/*! jQuery v3.7.1 | (c) OpenJS Foundation and other contributors | jquery.org/license */
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(ie,e){"use strict";var oe=[],r=Object.getPrototypeOf,ae=oe.slice,g=oe.flat?function(e){return oe.flat.call(e)}:function(e){return oe.concat.apply([],e)},s=oe.push,se=oe.indexOf,n={},i=n.toString,ue=n.hasOwnProperty,o=ue.toString,a=o.call(Object),le={},v=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType&&"function"!=typeof e.item},y=function(e){return null!=e&&e===e.window},C=ie.document,u={type:!0,src:!0,nonce:!0,noModule:!0};function m(e,t,n){var r,i,o=(n=n||C).createElement("script");if(o.text=e,t)for(r in u)(i=t[r]||t.getAttribute&&t.getAttribute(r))&&o.setAttribute(r,i);n.head.appendChild(o).parentNode.removeChild(o)}function x(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?n[i.call(e)]||"object":typeof e}var t="3.7.1",l=/HTML$/i,ce=function(e,t){return new ce.fn.init(e,t)};function c(e){var t=!!e&&"length"in e&&e.length,n=x(e);return!v(e)&&!y(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}function fe(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}ce.fn=ce.prototype={jquery:t,constructor:ce,length:0,toArray:function(){return ae.call(this)},get:function(e){return null==e?ae.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=ce.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return ce.each(this,e)},map:function(n){return this.pushStack(ce.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack(ae.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(ce.grep(this,function(e,t){return(t+1)%2}))},odd:function(){return this.pushStack(ce.grep(this,function(e,t){return t%2}))},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:s,sort:oe.sort,splice:oe.splice},ce.extend=ce.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||v(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(l&&r&&(ce.isPlainObject(r)||(i=Array.isArray(r)))?(n=a[t],o=i&&!Array.isArray(n)?[]:i||ce.isPlainObject(n)?n:{},i=!1,a[t]=ce.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},ce.extend({expando:"jQuery"+(t+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==i.call(e))&&(!(t=r(e))||"function"==typeof(n=ue.call(t,"constructor")&&t.constructor)&&o.call(n)===a)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t,n){m(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,r=0;if(c(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},text:function(e){var t,n="",r=0,i=e.nodeType;if(!i)while(t=e[r++])n+=ce.text(t);return 1===i||11===i?e.textContent:9===i?e.documentElement.textContent:3===i||4===i?e.nodeValue:n},makeArray:function(e,t){var n=t||[];return null!=e&&(c(Object(e))?ce.merge(n,"string"==typeof e?[e]:e):s.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:se.call(t,e,n)},isXMLDoc:function(e){var t=e&&e.namespaceURI,n=e&&(e.ownerDocument||e).documentElement;return!l.test(t||n&&n.nodeName||"HTML")},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,o=0,a=[];if(c(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&a.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&a.push(i);return g(a)},guid:1,support:le}),"function"==typeof Symbol&&(ce.fn[Symbol.iterator]=oe[Symbol.iterator]),ce.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){n["[object "+t+"]"]=t.toLowerCase()});var pe=oe.pop,de=oe.sort,he=oe.splice,ge="[\\x20\\t\\r\\n\\f]",ve=new RegExp("^"+ge+"+|((?:^|[^\\\\])(?:\\\\.)*)"+ge+"+$","g");ce.contains=function(e,t){var n=t&&t.parentNode;return e===n||!(!n||1!==n.nodeType||!(e.contains?e.contains(n):e.compareDocumentPosition&&16&e.compareDocumentPosition(n)))};var f=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;function p(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e}ce.escapeSelector=function(e){return(e+"").replace(f,p)};var ye=C,me=s;!function(){var e,b,w,o,a,T,r,C,d,i,k=me,S=ce.expando,E=0,n=0,s=W(),c=W(),u=W(),h=W(),l=function(e,t){return e===t&&(a=!0),0},f="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",t="(?:\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",p="\\["+ge+"*("+t+")(?:"+ge+"*([*^$|!~]?=)"+ge+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+t+"))|)"+ge+"*\\]",g=":("+t+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+p+")*)|.*)\\)|)",v=new RegExp(ge+"+","g"),y=new RegExp("^"+ge+"*,"+ge+"*"),m=new RegExp("^"+ge+"*([>+~]|"+ge+")"+ge+"*"),x=new RegExp(ge+"|>"),j=new RegExp(g),A=new RegExp("^"+t+"$"),D={ID:new RegExp("^#("+t+")"),CLASS:new RegExp("^\\.("+t+")"),TAG:new RegExp("^("+t+"|[*])"),ATTR:new RegExp("^"+p),PSEUDO:new RegExp("^"+g),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+ge+"*(even|odd|(([+-]|)(\\d*)n|)"+ge+"*(?:([+-]|)"+ge+"*(\\d+)|))"+ge+"*\\)|)","i"),bool:new RegExp("^(?:"+f+")$","i"),needsContext:new RegExp("^"+ge+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+ge+"*((?:-\\d)?\\d*)"+ge+"*\\)|)(?=[^-]|$)","i")},N=/^(?:input|select|textarea|button)$/i,q=/^h\d$/i,L=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,H=/[+~]/,O=new RegExp("\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\([^\\r\\n\\f])","g"),P=function(e,t){var n="0x"+e.slice(1)-65536;return t||(n<0?String.fromCharCode(n+65536):String.fromCharCode(n>>10|55296,1023&n|56320))},M=function(){V()},R=J(function(e){return!0===e.disabled&&fe(e,"fieldset")},{dir:"parentNode",next:"legend"});try{k.apply(oe=ae.call(ye.childNodes),ye.childNodes),oe[ye.childNodes.length].nodeType}catch(e){k={apply:function(e,t){me.apply(e,ae.call(t))},call:function(e){me.apply(e,ae.call(arguments,1))}}}function I(t,e,n,r){var i,o,a,s,u,l,c,f=e&&e.ownerDocument,p=e?e.nodeType:9;if(n=n||[],"string"!=typeof t||!t||1!==p&&9!==p&&11!==p)return n;if(!r&&(V(e),e=e||T,C)){if(11!==p&&(u=L.exec(t)))if(i=u[1]){if(9===p){if(!(a=e.getElementById(i)))return n;if(a.id===i)return k.call(n,a),n}else if(f&&(a=f.getElementById(i))&&I.contains(e,a)&&a.id===i)return k.call(n,a),n}else{if(u[2])return k.apply(n,e.getElementsByTagName(t)),n;if((i=u[3])&&e.getElementsByClassName)return k.apply(n,e.getElementsByClassName(i)),n}if(!(h[t+" "]||d&&d.test(t))){if(c=t,f=e,1===p&&(x.test(t)||m.test(t))){(f=H.test(t)&&U(e.parentNode)||e)==e&&le.scope||((s=e.getAttribute("id"))?s=ce.escapeSelector(s):e.setAttribute("id",s=S)),o=(l=Y(t)).length;while(o--)l[o]=(s?"#"+s:":scope")+" "+Q(l[o]);c=l.join(",")}try{return k.apply(n,f.querySelectorAll(c)),n}catch(e){h(t,!0)}finally{s===S&&e.removeAttribute("id")}}}return re(t.replace(ve,"$1"),e,n,r)}function W(){var r=[];return function e(t,n){return r.push(t+" ")>b.cacheLength&&delete e[r.shift()],e[t+" "]=n}}function F(e){return e[S]=!0,e}function $(e){var t=T.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function B(t){return function(e){return fe(e,"input")&&e.type===t}}function _(t){return function(e){return(fe(e,"input")||fe(e,"button"))&&e.type===t}}function z(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&R(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function X(a){return F(function(o){return o=+o,F(function(e,t){var n,r=a([],e.length,o),i=r.length;while(i--)e[n=r[i]]&&(e[n]=!(t[n]=e[n]))})})}function U(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}function V(e){var t,n=e?e.ownerDocument||e:ye;return n!=T&&9===n.nodeType&&n.documentElement&&(r=(T=n).documentElement,C=!ce.isXMLDoc(T),i=r.matches||r.webkitMatchesSelector||r.msMatchesSelector,r.msMatchesSelector&&ye!=T&&(t=T.defaultView)&&t.top!==t&&t.addEventListener("unload",M),le.getById=$(function(e){return r.appendChild(e).id=ce.expando,!T.getElementsByName||!T.getElementsByName(ce.expando).length}),le.disconnectedMatch=$(function(e){return i.call(e,"*")}),le.scope=$(function(){return T.querySelectorAll(":scope")}),le.cssHas=$(function(){try{return T.querySelector(":has(*,:jqfake)"),!1}catch(e){return!0}}),le.getById?(b.filter.ID=function(e){var t=e.replace(O,P);return function(e){return e.getAttribute("id")===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n=t.getElementById(e);return n?[n]:[]}}):(b.filter.ID=function(e){var n=e.replace(O,P);return function(e){var t="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return t&&t.value===n}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),b.find.TAG=function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):t.querySelectorAll(e)},b.find.CLASS=function(e,t){if("undefined"!=typeof t.getElementsByClassName&&C)return t.getElementsByClassName(e)},d=[],$(function(e){var t;r.appendChild(e).innerHTML="<a id='"+S+"' href='' disabled='disabled'></a><select id='"+S+"-\r\\' disabled='disabled'><option selected=''></option></select>",e.querySelectorAll("[selected]").length||d.push("\\["+ge+"*(?:value|"+f+")"),e.querySelectorAll("[id~="+S+"-]").length||d.push("~="),e.querySelectorAll("a#"+S+"+*").length||d.push(".#.+[+~]"),e.querySelectorAll(":checked").length||d.push(":checked"),(t=T.createElement("input")).setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),r.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&d.push(":enabled",":disabled"),(t=T.createElement("input")).setAttribute("name",""),e.appendChild(t),e.querySelectorAll("[name='']").length||d.push("\\["+ge+"*name"+ge+"*="+ge+"*(?:''|\"\")")}),le.cssHas||d.push(":has"),d=d.length&&new RegExp(d.join("|")),l=function(e,t){if(e===t)return a=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(1&(n=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!le.sortDetached&&t.compareDocumentPosition(e)===n?e===T||e.ownerDocument==ye&&I.contains(ye,e)?-1:t===T||t.ownerDocument==ye&&I.contains(ye,t)?1:o?se.call(o,e)-se.call(o,t):0:4&n?-1:1)}),T}for(e in I.matches=function(e,t){return I(e,null,null,t)},I.matchesSelector=function(e,t){if(V(e),C&&!h[t+" "]&&(!d||!d.test(t)))try{var n=i.call(e,t);if(n||le.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(e){h(t,!0)}return 0<I(t,T,null,[e]).length},I.contains=function(e,t){return(e.ownerDocument||e)!=T&&V(e),ce.contains(e,t)},I.attr=function(e,t){(e.ownerDocument||e)!=T&&V(e);var n=b.attrHandle[t.toLowerCase()],r=n&&ue.call(b.attrHandle,t.toLowerCase())?n(e,t,!C):void 0;return void 0!==r?r:e.getAttribute(t)},I.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},ce.uniqueSort=function(e){var t,n=[],r=0,i=0;if(a=!le.sortStable,o=!le.sortStable&&ae.call(e,0),de.call(e,l),a){while(t=e[i++])t===e[i]&&(r=n.push(i));while(r--)he.call(e,n[r],1)}return o=null,e},ce.fn.uniqueSort=function(){return this.pushStack(ce.uniqueSort(ae.apply(this)))},(b=ce.expr={cacheLength:50,createPseudo:F,match:D,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(O,P),e[3]=(e[3]||e[4]||e[5]||"").replace(O,P),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||I.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&I.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return D.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&j.test(n)&&(t=Y(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(O,P).toLowerCase();return"*"===e?function(){return!0}:function(e){return fe(e,t)}},CLASS:function(e){var t=s[e+" "];return t||(t=new RegExp("(^|"+ge+")"+e+"("+ge+"|$)"))&&s(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(n,r,i){return function(e){var t=I.attr(e,n);return null==t?"!="===r:!r||(t+="","="===r?t===i:"!="===r?t!==i:"^="===r?i&&0===t.indexOf(i):"*="===r?i&&-1<t.indexOf(i):"$="===r?i&&t.slice(-i.length)===i:"~="===r?-1<(" "+t.replace(v," ")+" ").indexOf(i):"|="===r&&(t===i||t.slice(0,i.length+1)===i+"-"))}},CHILD:function(d,e,t,h,g){var v="nth"!==d.slice(0,3),y="last"!==d.slice(-4),m="of-type"===e;return 1===h&&0===g?function(e){return!!e.parentNode}:function(e,t,n){var r,i,o,a,s,u=v!==y?"nextSibling":"previousSibling",l=e.parentNode,c=m&&e.nodeName.toLowerCase(),f=!n&&!m,p=!1;if(l){if(v){while(u){o=e;while(o=o[u])if(m?fe(o,c):1===o.nodeType)return!1;s=u="only"===d&&!s&&"nextSibling"}return!0}if(s=[y?l.firstChild:l.lastChild],y&&f){p=(a=(r=(i=l[S]||(l[S]={}))[d]||[])[0]===E&&r[1])&&r[2],o=a&&l.childNodes[a];while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if(1===o.nodeType&&++p&&o===e){i[d]=[E,a,p];break}}else if(f&&(p=a=(r=(i=e[S]||(e[S]={}))[d]||[])[0]===E&&r[1]),!1===p)while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if((m?fe(o,c):1===o.nodeType)&&++p&&(f&&((i=o[S]||(o[S]={}))[d]=[E,p]),o===e))break;return(p-=g)===h||p%h==0&&0<=p/h}}},PSEUDO:function(e,o){var t,a=b.pseudos[e]||b.setFilters[e.toLowerCase()]||I.error("unsupported pseudo: "+e);return a[S]?a(o):1<a.length?(t=[e,e,"",o],b.setFilters.hasOwnProperty(e.toLowerCase())?F(function(e,t){var n,r=a(e,o),i=r.length;while(i--)e[n=se.call(e,r[i])]=!(t[n]=r[i])}):function(e){return a(e,0,t)}):a}},pseudos:{not:F(function(e){var r=[],i=[],s=ne(e.replace(ve,"$1"));return s[S]?F(function(e,t,n,r){var i,o=s(e,null,r,[]),a=e.length;while(a--)(i=o[a])&&(e[a]=!(t[a]=i))}):function(e,t,n){return r[0]=e,s(r,null,n,i),r[0]=null,!i.pop()}}),has:F(function(t){return function(e){return 0<I(t,e).length}}),contains:F(function(t){return t=t.replace(O,P),function(e){return-1<(e.textContent||ce.text(e)).indexOf(t)}}),lang:F(function(n){return A.test(n||"")||I.error("unsupported lang: "+n),n=n.replace(O,P).toLowerCase(),function(e){var t;do{if(t=C?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===n||0===t.indexOf(n+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=ie.location&&ie.location.hash;return t&&t.slice(1)===e.id},root:function(e){return e===r},focus:function(e){return e===function(){try{return T.activeElement}catch(e){}}()&&T.hasFocus()&&!!(e.type||e.href||~e.tabIndex)},enabled:z(!1),disabled:z(!0),checked:function(e){return fe(e,"input")&&!!e.checked||fe(e,"option")&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!b.pseudos.empty(e)},header:function(e){return q.test(e.nodeName)},input:function(e){return N.test(e.nodeName)},button:function(e){return fe(e,"input")&&"button"===e.type||fe(e,"button")},text:function(e){var t;return fe(e,"input")&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:X(function(){return[0]}),last:X(function(e,t){return[t-1]}),eq:X(function(e,t,n){return[n<0?n+t:n]}),even:X(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:X(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:X(function(e,t,n){var r;for(r=n<0?n+t:t<n?t:n;0<=--r;)e.push(r);return e}),gt:X(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=b.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[e]=B(e);for(e in{submit:!0,reset:!0})b.pseudos[e]=_(e);function G(){}function Y(e,t){var n,r,i,o,a,s,u,l=c[e+" "];if(l)return t?0:l.slice(0);a=e,s=[],u=b.preFilter;while(a){for(o in n&&!(r=y.exec(a))||(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=m.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace(ve," ")}),a=a.slice(n.length)),b.filter)!(r=D[o].exec(a))||u[o]&&!(r=u[o](r))||(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?I.error(e):c(e,s).slice(0)}function Q(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function J(a,e,t){var s=e.dir,u=e.next,l=u||s,c=t&&"parentNode"===l,f=n++;return e.first?function(e,t,n){while(e=e[s])if(1===e.nodeType||c)return a(e,t,n);return!1}:function(e,t,n){var r,i,o=[E,f];if(n){while(e=e[s])if((1===e.nodeType||c)&&a(e,t,n))return!0}else while(e=e[s])if(1===e.nodeType||c)if(i=e[S]||(e[S]={}),u&&fe(e,u))e=e[s]||e;else{if((r=i[l])&&r[0]===E&&r[1]===f)return o[2]=r[2];if((i[l]=o)[2]=a(e,t,n))return!0}return!1}}function K(i){return 1<i.length?function(e,t,n){var r=i.length;while(r--)if(!i[r](e,t,n))return!1;return!0}:i[0]}function Z(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function ee(d,h,g,v,y,e){return v&&!v[S]&&(v=ee(v)),y&&!y[S]&&(y=ee(y,e)),F(function(e,t,n,r){var i,o,a,s,u=[],l=[],c=t.length,f=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)I(e,t[r],n);return n}(h||"*",n.nodeType?[n]:n,[]),p=!d||!e&&h?f:Z(f,u,d,n,r);if(g?g(p,s=y||(e?d:c||v)?[]:t,n,r):s=p,v){i=Z(s,l),v(i,[],n,r),o=i.length;while(o--)(a=i[o])&&(s[l[o]]=!(p[l[o]]=a))}if(e){if(y||d){if(y){i=[],o=s.length;while(o--)(a=s[o])&&i.push(p[o]=a);y(null,s=[],i,r)}o=s.length;while(o--)(a=s[o])&&-1<(i=y?se.call(e,a):u[o])&&(e[i]=!(t[i]=a))}}else s=Z(s===t?s.splice(c,s.length):s),y?y(null,t,s,r):k.apply(t,s)})}function te(e){for(var i,t,n,r=e.length,o=b.relative[e[0].type],a=o||b.relative[" "],s=o?1:0,u=J(function(e){return e===i},a,!0),l=J(function(e){return-1<se.call(i,e)},a,!0),c=[function(e,t,n){var r=!o&&(n||t!=w)||((i=t).nodeType?u(e,t,n):l(e,t,n));return i=null,r}];s<r;s++)if(t=b.relative[e[s].type])c=[J(K(c),t)];else{if((t=b.filter[e[s].type].apply(null,e[s].matches))[S]){for(n=++s;n<r;n++)if(b.relative[e[n].type])break;return ee(1<s&&K(c),1<s&&Q(e.slice(0,s-1).concat({value:" "===e[s-2].type?"*":""})).replace(ve,"$1"),t,s<n&&te(e.slice(s,n)),n<r&&te(e=e.slice(n)),n<r&&Q(e))}c.push(t)}return K(c)}function ne(e,t){var n,v,y,m,x,r,i=[],o=[],a=u[e+" "];if(!a){t||(t=Y(e)),n=t.length;while(n--)(a=te(t[n]))[S]?i.push(a):o.push(a);(a=u(e,(v=o,m=0<(y=i).length,x=0<v.length,r=function(e,t,n,r,i){var o,a,s,u=0,l="0",c=e&&[],f=[],p=w,d=e||x&&b.find.TAG("*",i),h=E+=null==p?1:Math.random()||.1,g=d.length;for(i&&(w=t==T||t||i);l!==g&&null!=(o=d[l]);l++){if(x&&o){a=0,t||o.ownerDocument==T||(V(o),n=!C);while(s=v[a++])if(s(o,t||T,n)){k.call(r,o);break}i&&(E=h)}m&&((o=!s&&o)&&u--,e&&c.push(o))}if(u+=l,m&&l!==u){a=0;while(s=y[a++])s(c,f,t,n);if(e){if(0<u)while(l--)c[l]||f[l]||(f[l]=pe.call(r));f=Z(f)}k.apply(r,f),i&&!e&&0<f.length&&1<u+y.length&&ce.uniqueSort(r)}return i&&(E=h,w=p),c},m?F(r):r))).selector=e}return a}function re(e,t,n,r){var i,o,a,s,u,l="function"==typeof e&&e,c=!r&&Y(e=l.selector||e);if(n=n||[],1===c.length){if(2<(o=c[0]=c[0].slice(0)).length&&"ID"===(a=o[0]).type&&9===t.nodeType&&C&&b.relative[o[1].type]){if(!(t=(b.find.ID(a.matches[0].replace(O,P),t)||[])[0]))return n;l&&(t=t.parentNode),e=e.slice(o.shift().value.length)}i=D.needsContext.test(e)?0:o.length;while(i--){if(a=o[i],b.relative[s=a.type])break;if((u=b.find[s])&&(r=u(a.matches[0].replace(O,P),H.test(o[0].type)&&U(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&Q(o)))return k.apply(n,r),n;break}}}return(l||ne(e,c))(r,t,!C,n,!t||H.test(e)&&U(t.parentNode)||t),n}G.prototype=b.filters=b.pseudos,b.setFilters=new G,le.sortStable=S.split("").sort(l).join("")===S,V(),le.sortDetached=$(function(e){return 1&e.compareDocumentPosition(T.createElement("fieldset"))}),ce.find=I,ce.expr[":"]=ce.expr.pseudos,ce.unique=ce.uniqueSort,I.compile=ne,I.select=re,I.setDocument=V,I.tokenize=Y,I.escape=ce.escapeSelector,I.getText=ce.text,I.isXML=ce.isXMLDoc,I.selectors=ce.expr,I.support=ce.support,I.uniqueSort=ce.uniqueSort}();var d=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&ce(e).is(n))break;r.push(e)}return r},h=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},b=ce.expr.match.needsContext,w=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function T(e,n,r){return v(n)?ce.grep(e,function(e,t){return!!n.call(e,t,e)!==r}):n.nodeType?ce.grep(e,function(e){return e===n!==r}):"string"!=typeof n?ce.grep(e,function(e){return-1<se.call(n,e)!==r}):ce.filter(n,e,r)}ce.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?ce.find.matchesSelector(r,e)?[r]:[]:ce.find.matches(e,ce.grep(t,function(e){return 1===e.nodeType}))},ce.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(ce(e).filter(function(){for(t=0;t<r;t++)if(ce.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)ce.find(e,i[t],n);return 1<r?ce.uniqueSort(n):n},filter:function(e){return this.pushStack(T(this,e||[],!1))},not:function(e){return this.pushStack(T(this,e||[],!0))},is:function(e){return!!T(this,"string"==typeof e&&b.test(e)?ce(e):e||[],!1).length}});var k,S=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(ce.fn.init=function(e,t,n){var r,i;if(!e)return this;if(n=n||k,"string"==typeof e){if(!(r="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:S.exec(e))||!r[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(r[1]){if(t=t instanceof ce?t[0]:t,ce.merge(this,ce.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:C,!0)),w.test(r[1])&&ce.isPlainObject(t))for(r in t)v(this[r])?this[r](t[r]):this.attr(r,t[r]);return this}return(i=C.getElementById(r[2]))&&(this[0]=i,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):v(e)?void 0!==n.ready?n.ready(e):e(ce):ce.makeArray(e,this)}).prototype=ce.fn,k=ce(C);var E=/^(?:parents|prev(?:Until|All))/,j={children:!0,contents:!0,next:!0,prev:!0};function A(e,t){while((e=e[t])&&1!==e.nodeType);return e}ce.fn.extend({has:function(e){var t=ce(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(ce.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&ce(e);if(!b.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?-1<a.index(n):1===n.nodeType&&ce.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?ce.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?se.call(ce(e),this[0]):se.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(ce.uniqueSort(ce.merge(this.get(),ce(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),ce.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return d(e,"parentNode")},parentsUntil:function(e,t,n){return d(e,"parentNode",n)},next:function(e){return A(e,"nextSibling")},prev:function(e){return A(e,"previousSibling")},nextAll:function(e){return d(e,"nextSibling")},prevAll:function(e){return d(e,"previousSibling")},nextUntil:function(e,t,n){return d(e,"nextSibling",n)},prevUntil:function(e,t,n){return d(e,"previousSibling",n)},siblings:function(e){return h((e.parentNode||{}).firstChild,e)},children:function(e){return h(e.firstChild)},contents:function(e){return null!=e.contentDocument&&r(e.contentDocument)?e.contentDocument:(fe(e,"template")&&(e=e.content||e),ce.merge([],e.childNodes))}},function(r,i){ce.fn[r]=function(e,t){var n=ce.map(this,i,e);return"Until"!==r.slice(-5)&&(t=e),t&&"string"==typeof t&&(n=ce.filter(t,n)),1<this.length&&(j[r]||ce.uniqueSort(n),E.test(r)&&n.reverse()),this.pushStack(n)}});var D=/[^\x20\t\r\n\f]+/g;function N(e){return e}function q(e){throw e}function L(e,t,n,r){var i;try{e&&v(i=e.promise)?i.call(e).done(t).fail(n):e&&v(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}ce.Callbacks=function(r){var e,n;r="string"==typeof r?(e=r,n={},ce.each(e.match(D)||[],function(e,t){n[t]=!0}),n):ce.extend({},r);var i,t,o,a,s=[],u=[],l=-1,c=function(){for(a=a||r.once,o=i=!0;u.length;l=-1){t=u.shift();while(++l<s.length)!1===s[l].apply(t[0],t[1])&&r.stopOnFalse&&(l=s.length,t=!1)}r.memory||(t=!1),i=!1,a&&(s=t?[]:"")},f={add:function(){return s&&(t&&!i&&(l=s.length-1,u.push(t)),function n(e){ce.each(e,function(e,t){v(t)?r.unique&&f.has(t)||s.push(t):t&&t.length&&"string"!==x(t)&&n(t)})}(arguments),t&&!i&&c()),this},remove:function(){return ce.each(arguments,function(e,t){var n;while(-1<(n=ce.inArray(t,s,n)))s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?-1<ce.inArray(e,s):0<s.length},empty:function(){return s&&(s=[]),this},disable:function(){return a=u=[],s=t="",this},disabled:function(){return!s},lock:function(){return a=u=[],t||i||(s=t=""),this},locked:function(){return!!a},fireWith:function(e,t){return a||(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),i||c()),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},ce.extend({Deferred:function(e){var o=[["notify","progress",ce.Callbacks("memory"),ce.Callbacks("memory"),2],["resolve","done",ce.Callbacks("once memory"),ce.Callbacks("once memory"),0,"resolved"],["reject","fail",ce.Callbacks("once memory"),ce.Callbacks("once memory"),1,"rejected"]],i="pending",a={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},"catch":function(e){return a.then(null,e)},pipe:function(){var i=arguments;return ce.Deferred(function(r){ce.each(o,function(e,t){var n=v(i[t[4]])&&i[t[4]];s[t[1]](function(){var e=n&&n.apply(this,arguments);e&&v(e.promise)?e.promise().progress(r.notify).done(r.resolve).fail(r.reject):r[t[0]+"With"](this,n?[e]:arguments)})}),i=null}).promise()},then:function(t,n,r){var u=0;function l(i,o,a,s){return function(){var n=this,r=arguments,e=function(){var e,t;if(!(i<u)){if((e=a.apply(n,r))===o.promise())throw new TypeError("Thenable self-resolution");t=e&&("object"==typeof e||"function"==typeof e)&&e.then,v(t)?s?t.call(e,l(u,o,N,s),l(u,o,q,s)):(u++,t.call(e,l(u,o,N,s),l(u,o,q,s),l(u,o,N,o.notifyWith))):(a!==N&&(n=void 0,r=[e]),(s||o.resolveWith)(n,r))}},t=s?e:function(){try{e()}catch(e){ce.Deferred.exceptionHook&&ce.Deferred.exceptionHook(e,t.error),u<=i+1&&(a!==q&&(n=void 0,r=[e]),o.rejectWith(n,r))}};i?t():(ce.Deferred.getErrorHook?t.error=ce.Deferred.getErrorHook():ce.Deferred.getStackHook&&(t.error=ce.Deferred.getStackHook()),ie.setTimeout(t))}}return ce.Deferred(function(e){o[0][3].add(l(0,e,v(r)?r:N,e.notifyWith)),o[1][3].add(l(0,e,v(t)?t:N)),o[2][3].add(l(0,e,v(n)?n:q))}).promise()},promise:function(e){return null!=e?ce.extend(e,a):a}},s={};return ce.each(o,function(e,t){var n=t[2],r=t[5];a[t[1]]=n.add,r&&n.add(function(){i=r},o[3-e][2].disable,o[3-e][3].disable,o[0][2].lock,o[0][3].lock),n.add(t[3].fire),s[t[0]]=function(){return s[t[0]+"With"](this===s?void 0:this,arguments),this},s[t[0]+"With"]=n.fireWith}),a.promise(s),e&&e.call(s,s),s},when:function(e){var n=arguments.length,t=n,r=Array(t),i=ae.call(arguments),o=ce.Deferred(),a=function(t){return function(e){r[t]=this,i[t]=1<arguments.length?ae.call(arguments):e,--n||o.resolveWith(r,i)}};if(n<=1&&(L(e,o.done(a(t)).resolve,o.reject,!n),"pending"===o.state()||v(i[t]&&i[t].then)))return o.then();while(t--)L(i[t],a(t),o.reject);return o.promise()}});var H=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;ce.Deferred.exceptionHook=function(e,t){ie.console&&ie.console.warn&&e&&H.test(e.name)&&ie.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},ce.readyException=function(e){ie.setTimeout(function(){throw e})};var O=ce.Deferred();function P(){C.removeEventListener("DOMContentLoaded",P),ie.removeEventListener("load",P),ce.ready()}ce.fn.ready=function(e){return O.then(e)["catch"](function(e){ce.readyException(e)}),this},ce.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--ce.readyWait:ce.isReady)||(ce.isReady=!0)!==e&&0<--ce.readyWait||O.resolveWith(C,[ce])}}),ce.ready.then=O.then,"complete"===C.readyState||"loading"!==C.readyState&&!C.documentElement.doScroll?ie.setTimeout(ce.ready):(C.addEventListener("DOMContentLoaded",P),ie.addEventListener("load",P));var M=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===x(n))for(s in i=!0,n)M(e,t,s,n[s],!0,o,a);else if(void 0!==r&&(i=!0,v(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(ce(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},R=/^-ms-/,I=/-([a-z])/g;function W(e,t){return t.toUpperCase()}function F(e){return e.replace(R,"ms-").replace(I,W)}var $=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function B(){this.expando=ce.expando+B.uid++}B.uid=1,B.prototype={cache:function(e){var t=e[this.expando];return t||(t={},$(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[F(t)]=n;else for(r in t)i[F(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][F(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(F):(t=F(t))in r?[t]:t.match(D)||[]).length;while(n--)delete r[t[n]]}(void 0===t||ce.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!ce.isEmptyObject(t)}};var _=new B,z=new B,X=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,U=/[A-Z]/g;function V(e,t,n){var r,i;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(U,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n="true"===(i=n)||"false"!==i&&("null"===i?null:i===+i+""?+i:X.test(i)?JSON.parse(i):i)}catch(e){}z.set(e,t,n)}else n=void 0;return n}ce.extend({hasData:function(e){return z.hasData(e)||_.hasData(e)},data:function(e,t,n){return z.access(e,t,n)},removeData:function(e,t){z.remove(e,t)},_data:function(e,t,n){return _.access(e,t,n)},_removeData:function(e,t){_.remove(e,t)}}),ce.fn.extend({data:function(n,e){var t,r,i,o=this[0],a=o&&o.attributes;if(void 0===n){if(this.length&&(i=z.get(o),1===o.nodeType&&!_.get(o,"hasDataAttrs"))){t=a.length;while(t--)a[t]&&0===(r=a[t].name).indexOf("data-")&&(r=F(r.slice(5)),V(o,r,i[r]));_.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof n?this.each(function(){z.set(this,n)}):M(this,function(e){var t;if(o&&void 0===e)return void 0!==(t=z.get(o,n))?t:void 0!==(t=V(o,n))?t:void 0;this.each(function(){z.set(this,n,e)})},null,e,1<arguments.length,null,!0)},removeData:function(e){return this.each(function(){z.remove(this,e)})}}),ce.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=_.get(e,t),n&&(!r||Array.isArray(n)?r=_.access(e,t,ce.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=ce.queue(e,t),r=n.length,i=n.shift(),o=ce._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){ce.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return _.get(e,n)||_.access(e,n,{empty:ce.Callbacks("once memory").add(function(){_.remove(e,[t+"queue",n])})})}}),ce.fn.extend({queue:function(t,n){var e=2;return"string"!=typeof t&&(n=t,t="fx",e--),arguments.length<e?ce.queue(this[0],t):void 0===n?this:this.each(function(){var e=ce.queue(this,t,n);ce._queueHooks(this,t),"fx"===t&&"inprogress"!==e[0]&&ce.dequeue(this,t)})},dequeue:function(e){return this.each(function(){ce.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=ce.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=_.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var G=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,Y=new RegExp("^(?:([+-])=|)("+G+")([a-z%]*)$","i"),Q=["Top","Right","Bottom","Left"],J=C.documentElement,K=function(e){return ce.contains(e.ownerDocument,e)},Z={composed:!0};J.getRootNode&&(K=function(e){return ce.contains(e.ownerDocument,e)||e.getRootNode(Z)===e.ownerDocument});var ee=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&K(e)&&"none"===ce.css(e,"display")};function te(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return ce.css(e,t,"")},u=s(),l=n&&n[3]||(ce.cssNumber[t]?"":"px"),c=e.nodeType&&(ce.cssNumber[t]||"px"!==l&&+u)&&Y.exec(ce.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)ce.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,ce.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var ne={};function re(e,t){for(var n,r,i,o,a,s,u,l=[],c=0,f=e.length;c<f;c++)(r=e[c]).style&&(n=r.style.display,t?("none"===n&&(l[c]=_.get(r,"display")||null,l[c]||(r.style.display="")),""===r.style.display&&ee(r)&&(l[c]=(u=a=o=void 0,a=(i=r).ownerDocument,s=i.nodeName,(u=ne[s])||(o=a.body.appendChild(a.createElement(s)),u=ce.css(o,"display"),o.parentNode.removeChild(o),"none"===u&&(u="block"),ne[s]=u)))):"none"!==n&&(l[c]="none",_.set(r,"display",n)));for(c=0;c<f;c++)null!=l[c]&&(e[c].style.display=l[c]);return e}ce.fn.extend({show:function(){return re(this,!0)},hide:function(){return re(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){ee(this)?ce(this).show():ce(this).hide()})}});var xe,be,we=/^(?:checkbox|radio)$/i,Te=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,Ce=/^$|^module$|\/(?:java|ecma)script/i;xe=C.createDocumentFragment().appendChild(C.createElement("div")),(be=C.createElement("input")).setAttribute("type","radio"),be.setAttribute("checked","checked"),be.setAttribute("name","t"),xe.appendChild(be),le.checkClone=xe.cloneNode(!0).cloneNode(!0).lastChild.checked,xe.innerHTML="<textarea>x</textarea>",le.noCloneChecked=!!xe.cloneNode(!0).lastChild.defaultValue,xe.innerHTML="<option></option>",le.option=!!xe.lastChild;var ke={thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function Se(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&fe(e,t)?ce.merge([e],n):n}function Ee(e,t){for(var n=0,r=e.length;n<r;n++)_.set(e[n],"globalEval",!t||_.get(t[n],"globalEval"))}ke.tbody=ke.tfoot=ke.colgroup=ke.caption=ke.thead,ke.th=ke.td,le.option||(ke.optgroup=ke.option=[1,"<select multiple='multiple'>","</select>"]);var je=/<|&#?\w+;/;function Ae(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===x(o))ce.merge(p,o.nodeType?[o]:o);else if(je.test(o)){a=a||f.appendChild(t.createElement("div")),s=(Te.exec(o)||["",""])[1].toLowerCase(),u=ke[s]||ke._default,a.innerHTML=u[1]+ce.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;ce.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&-1<ce.inArray(o,r))i&&i.push(o);else if(l=K(o),a=Se(f.appendChild(o),"script"),l&&Ee(a),n){c=0;while(o=a[c++])Ce.test(o.type||"")&&n.push(o)}return f}var De=/^([^.]*)(?:\.(.+)|)/;function Ne(){return!0}function qe(){return!1}function Le(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)Le(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=qe;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return ce().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=ce.guid++)),e.each(function(){ce.event.add(this,t,i,r,n)})}function He(e,r,t){t?(_.set(e,r,!1),ce.event.add(e,r,{namespace:!1,handler:function(e){var t,n=_.get(this,r);if(1&e.isTrigger&&this[r]){if(n)(ce.event.special[r]||{}).delegateType&&e.stopPropagation();else if(n=ae.call(arguments),_.set(this,r,n),this[r](),t=_.get(this,r),_.set(this,r,!1),n!==t)return e.stopImmediatePropagation(),e.preventDefault(),t}else n&&(_.set(this,r,ce.event.trigger(n[0],n.slice(1),this)),e.stopPropagation(),e.isImmediatePropagationStopped=Ne)}})):void 0===_.get(e,r)&&ce.event.add(e,r,Ne)}ce.event={global:{},add:function(t,e,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.get(t);if($(t)){n.handler&&(n=(o=n).handler,i=o.selector),i&&ce.find.matchesSelector(J,i),n.guid||(n.guid=ce.guid++),(u=v.events)||(u=v.events=Object.create(null)),(a=v.handle)||(a=v.handle=function(e){return"undefined"!=typeof ce&&ce.event.triggered!==e.type?ce.event.dispatch.apply(t,arguments):void 0}),l=(e=(e||"").match(D)||[""]).length;while(l--)d=g=(s=De.exec(e[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=ce.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=ce.event.special[d]||{},c=ce.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&ce.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(t,r,h,a)||t.addEventListener&&t.addEventListener(d,a)),f.add&&(f.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),ce.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.hasData(e)&&_.get(e);if(v&&(u=v.events)){l=(t=(t||"").match(D)||[""]).length;while(l--)if(d=g=(s=De.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d){f=ce.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,v.handle)||ce.removeEvent(e,d,v.handle),delete u[d])}else for(d in u)ce.event.remove(e,d+t[l],n,r,!0);ce.isEmptyObject(u)&&_.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a,s=new Array(arguments.length),u=ce.event.fix(e),l=(_.get(this,"events")||Object.create(null))[u.type]||[],c=ce.event.special[u.type]||{};for(s[0]=u,t=1;t<arguments.length;t++)s[t]=arguments[t];if(u.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,u)){a=ce.event.handlers.call(this,u,l),t=0;while((i=a[t++])&&!u.isPropagationStopped()){u.currentTarget=i.elem,n=0;while((o=i.handlers[n++])&&!u.isImmediatePropagationStopped())u.rnamespace&&!1!==o.namespace&&!u.rnamespace.test(o.namespace)||(u.handleObj=o,u.data=o.data,void 0!==(r=((ce.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,s))&&!1===(u.result=r)&&(u.preventDefault(),u.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,u),u.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&1<=e.button))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?-1<ce(i,this).index(l):ce.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(t,e){Object.defineProperty(ce.Event.prototype,t,{enumerable:!0,configurable:!0,get:v(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(e){return e[ce.expando]?e:new ce.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click",!0),!1},trigger:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click"),!0},_default:function(e){var t=e.target;return we.test(t.type)&&t.click&&fe(t,"input")&&_.get(t,"click")||fe(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},ce.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},ce.Event=function(e,t){if(!(this instanceof ce.Event))return new ce.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?Ne:qe,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&ce.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[ce.expando]=!0},ce.Event.prototype={constructor:ce.Event,isDefaultPrevented:qe,isPropagationStopped:qe,isImmediatePropagationStopped:qe,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=Ne,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=Ne,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=Ne,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},ce.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},ce.event.addProp),ce.each({focus:"focusin",blur:"focusout"},function(r,i){function o(e){if(C.documentMode){var t=_.get(this,"handle"),n=ce.event.fix(e);n.type="focusin"===e.type?"focus":"blur",n.isSimulated=!0,t(e),n.target===n.currentTarget&&t(n)}else ce.event.simulate(i,e.target,ce.event.fix(e))}ce.event.special[r]={setup:function(){var e;if(He(this,r,!0),!C.documentMode)return!1;(e=_.get(this,i))||this.addEventListener(i,o),_.set(this,i,(e||0)+1)},trigger:function(){return He(this,r),!0},teardown:function(){var e;if(!C.documentMode)return!1;(e=_.get(this,i)-1)?_.set(this,i,e):(this.removeEventListener(i,o),_.remove(this,i))},_default:function(e){return _.get(e.target,r)},delegateType:i},ce.event.special[i]={setup:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i);n||(C.documentMode?this.addEventListener(i,o):e.addEventListener(r,o,!0)),_.set(t,i,(n||0)+1)},teardown:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i)-1;n?_.set(t,i,n):(C.documentMode?this.removeEventListener(i,o):e.removeEventListener(r,o,!0),_.remove(t,i))}}}),ce.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,i){ce.event.special[e]={delegateType:i,bindType:i,handle:function(e){var t,n=e.relatedTarget,r=e.handleObj;return n&&(n===this||ce.contains(this,n))||(e.type=r.origType,t=r.handler.apply(this,arguments),e.type=i),t}}}),ce.fn.extend({on:function(e,t,n,r){return Le(this,e,t,n,r)},one:function(e,t,n,r){return Le(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,ce(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=qe),this.each(function(){ce.event.remove(this,e,n,t)})}});var Oe=/<script|<style|<link/i,Pe=/checked\s*(?:[^=]|=\s*.checked.)/i,Me=/^\s*<!\[CDATA\[|\]\]>\s*$/g;function Re(e,t){return fe(e,"table")&&fe(11!==t.nodeType?t:t.firstChild,"tr")&&ce(e).children("tbody")[0]||e}function Ie(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function We(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Fe(e,t){var n,r,i,o,a,s;if(1===t.nodeType){if(_.hasData(e)&&(s=_.get(e).events))for(i in _.remove(t,"handle events"),s)for(n=0,r=s[i].length;n<r;n++)ce.event.add(t,i,s[i][n]);z.hasData(e)&&(o=z.access(e),a=ce.extend({},o),z.set(t,a))}}function $e(n,r,i,o){r=g(r);var e,t,a,s,u,l,c=0,f=n.length,p=f-1,d=r[0],h=v(d);if(h||1<f&&"string"==typeof d&&!le.checkClone&&Pe.test(d))return n.each(function(e){var t=n.eq(e);h&&(r[0]=d.call(this,e,t.html())),$e(t,r,i,o)});if(f&&(t=(e=Ae(r,n[0].ownerDocument,!1,n,o)).firstChild,1===e.childNodes.length&&(e=t),t||o)){for(s=(a=ce.map(Se(e,"script"),Ie)).length;c<f;c++)u=e,c!==p&&(u=ce.clone(u,!0,!0),s&&ce.merge(a,Se(u,"script"))),i.call(n[c],u,c);if(s)for(l=a[a.length-1].ownerDocument,ce.map(a,We),c=0;c<s;c++)u=a[c],Ce.test(u.type||"")&&!_.access(u,"globalEval")&&ce.contains(l,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?ce._evalUrl&&!u.noModule&&ce._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")},l):m(u.textContent.replace(Me,""),u,l))}return n}function Be(e,t,n){for(var r,i=t?ce.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||ce.cleanData(Se(r)),r.parentNode&&(n&&K(r)&&Ee(Se(r,"script")),r.parentNode.removeChild(r));return e}ce.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var r,i,o,a,s,u,l,c=e.cloneNode(!0),f=K(e);if(!(le.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||ce.isXMLDoc(e)))for(a=Se(c),r=0,i=(o=Se(e)).length;r<i;r++)s=o[r],u=a[r],void 0,"input"===(l=u.nodeName.toLowerCase())&&we.test(s.type)?u.checked=s.checked:"input"!==l&&"textarea"!==l||(u.defaultValue=s.defaultValue);if(t)if(n)for(o=o||Se(e),a=a||Se(c),r=0,i=o.length;r<i;r++)Fe(o[r],a[r]);else Fe(e,c);return 0<(a=Se(c,"script")).length&&Ee(a,!f&&Se(e,"script")),c},cleanData:function(e){for(var t,n,r,i=ce.event.special,o=0;void 0!==(n=e[o]);o++)if($(n)){if(t=n[_.expando]){if(t.events)for(r in t.events)i[r]?ce.event.remove(n,r):ce.removeEvent(n,r,t.handle);n[_.expando]=void 0}n[z.expando]&&(n[z.expando]=void 0)}}}),ce.fn.extend({detach:function(e){return Be(this,e,!0)},remove:function(e){return Be(this,e)},text:function(e){return M(this,function(e){return void 0===e?ce.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return $e(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||Re(this,e).appendChild(e)})},prepend:function(){return $e(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=Re(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(ce.cleanData(Se(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return ce.clone(this,e,t)})},html:function(e){return M(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!Oe.test(e)&&!ke[(Te.exec(e)||["",""])[1].toLowerCase()]){e=ce.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(ce.cleanData(Se(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var n=[];return $e(this,arguments,function(e){var t=this.parentNode;ce.inArray(this,n)<0&&(ce.cleanData(Se(this)),t&&t.replaceChild(e,this))},n)}}),ce.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,a){ce.fn[e]=function(e){for(var t,n=[],r=ce(e),i=r.length-1,o=0;o<=i;o++)t=o===i?this:this.clone(!0),ce(r[o])[a](t),s.apply(n,t.get());return this.pushStack(n)}});var _e=new RegExp("^("+G+")(?!px)[a-z%]+$","i"),ze=/^--/,Xe=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=ie),t.getComputedStyle(e)},Ue=function(e,t,n){var r,i,o={};for(i in t)o[i]=e.style[i],e.style[i]=t[i];for(i in r=n.call(e),t)e.style[i]=o[i];return r},Ve=new RegExp(Q.join("|"),"i");function Ge(e,t,n){var r,i,o,a,s=ze.test(t),u=e.style;return(n=n||Xe(e))&&(a=n.getPropertyValue(t)||n[t],s&&a&&(a=a.replace(ve,"$1")||void 0),""!==a||K(e)||(a=ce.style(e,t)),!le.pixelBoxStyles()&&_e.test(a)&&Ve.test(t)&&(r=u.width,i=u.minWidth,o=u.maxWidth,u.minWidth=u.maxWidth=u.width=a,a=n.width,u.width=r,u.minWidth=i,u.maxWidth=o)),void 0!==a?a+"":a}function Ye(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(l){u.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",l.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",J.appendChild(u).appendChild(l);var e=ie.getComputedStyle(l);n="1%"!==e.top,s=12===t(e.marginLeft),l.style.right="60%",o=36===t(e.right),r=36===t(e.width),l.style.position="absolute",i=12===t(l.offsetWidth/3),J.removeChild(u),l=null}}function t(e){return Math.round(parseFloat(e))}var n,r,i,o,a,s,u=C.createElement("div"),l=C.createElement("div");l.style&&(l.style.backgroundClip="content-box",l.cloneNode(!0).style.backgroundClip="",le.clearCloneStyle="content-box"===l.style.backgroundClip,ce.extend(le,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),o},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),s},scrollboxSize:function(){return e(),i},reliableTrDimensions:function(){var e,t,n,r;return null==a&&(e=C.createElement("table"),t=C.createElement("tr"),n=C.createElement("div"),e.style.cssText="position:absolute;left:-11111px;border-collapse:separate",t.style.cssText="box-sizing:content-box;border:1px solid",t.style.height="1px",n.style.height="9px",n.style.display="block",J.appendChild(e).appendChild(t).appendChild(n),r=ie.getComputedStyle(t),a=parseInt(r.height,10)+parseInt(r.borderTopWidth,10)+parseInt(r.borderBottomWidth,10)===t.offsetHeight,J.removeChild(e)),a}}))}();var Qe=["Webkit","Moz","ms"],Je=C.createElement("div").style,Ke={};function Ze(e){var t=ce.cssProps[e]||Ke[e];return t||(e in Je?e:Ke[e]=function(e){var t=e[0].toUpperCase()+e.slice(1),n=Qe.length;while(n--)if((e=Qe[n]+t)in Je)return e}(e)||e)}var et=/^(none|table(?!-c[ea]).+)/,tt={position:"absolute",visibility:"hidden",display:"block"},nt={letterSpacing:"0",fontWeight:"400"};function rt(e,t,n){var r=Y.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function it(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0,l=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(l+=ce.css(e,n+Q[a],!0,i)),r?("content"===n&&(u-=ce.css(e,"padding"+Q[a],!0,i)),"margin"!==n&&(u-=ce.css(e,"border"+Q[a]+"Width",!0,i))):(u+=ce.css(e,"padding"+Q[a],!0,i),"padding"!==n?u+=ce.css(e,"border"+Q[a]+"Width",!0,i):s+=ce.css(e,"border"+Q[a]+"Width",!0,i));return!r&&0<=o&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u+l}function ot(e,t,n){var r=Xe(e),i=(!le.boxSizingReliable()||n)&&"border-box"===ce.css(e,"boxSizing",!1,r),o=i,a=Ge(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if(_e.test(a)){if(!n)return a;a="auto"}return(!le.boxSizingReliable()&&i||!le.reliableTrDimensions()&&fe(e,"tr")||"auto"===a||!parseFloat(a)&&"inline"===ce.css(e,"display",!1,r))&&e.getClientRects().length&&(i="border-box"===ce.css(e,"boxSizing",!1,r),(o=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+it(e,t,n||(i?"border":"content"),o,r,a)+"px"}function at(e,t,n,r,i){return new at.prototype.init(e,t,n,r,i)}ce.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Ge(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,aspectRatio:!0,borderImageSlice:!0,columnCount:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,scale:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeMiterlimit:!0,strokeOpacity:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=F(t),u=ze.test(t),l=e.style;if(u||(t=Ze(s)),a=ce.cssHooks[t]||ce.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"===(o=typeof n)&&(i=Y.exec(n))&&i[1]&&(n=te(e,t,i),o="number"),null!=n&&n==n&&("number"!==o||u||(n+=i&&i[3]||(ce.cssNumber[s]?"":"px")),le.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=F(t);return ze.test(t)||(t=Ze(s)),(a=ce.cssHooks[t]||ce.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=Ge(e,t,r)),"normal"===i&&t in nt&&(i=nt[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),ce.each(["height","width"],function(e,u){ce.cssHooks[u]={get:function(e,t,n){if(t)return!et.test(ce.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?ot(e,u,n):Ue(e,tt,function(){return ot(e,u,n)})},set:function(e,t,n){var r,i=Xe(e),o=!le.scrollboxSize()&&"absolute"===i.position,a=(o||n)&&"border-box"===ce.css(e,"boxSizing",!1,i),s=n?it(e,u,n,a,i):0;return a&&o&&(s-=Math.ceil(e["offset"+u[0].toUpperCase()+u.slice(1)]-parseFloat(i[u])-it(e,u,"border",!1,i)-.5)),s&&(r=Y.exec(t))&&"px"!==(r[3]||"px")&&(e.style[u]=t,t=ce.css(e,u)),rt(0,t,s)}}}),ce.cssHooks.marginLeft=Ye(le.reliableMarginLeft,function(e,t){if(t)return(parseFloat(Ge(e,"marginLeft"))||e.getBoundingClientRect().left-Ue(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),ce.each({margin:"",padding:"",border:"Width"},function(i,o){ce.cssHooks[i+o]={expand:function(e){for(var t=0,n={},r="string"==typeof e?e.split(" "):[e];t<4;t++)n[i+Q[t]+o]=r[t]||r[t-2]||r[0];return n}},"margin"!==i&&(ce.cssHooks[i+o].set=rt)}),ce.fn.extend({css:function(e,t){return M(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=Xe(e),i=t.length;a<i;a++)o[t[a]]=ce.css(e,t[a],!1,r);return o}return void 0!==n?ce.style(e,t,n):ce.css(e,t)},e,t,1<arguments.length)}}),((ce.Tween=at).prototype={constructor:at,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||ce.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(ce.cssNumber[n]?"":"px")},cur:function(){var e=at.propHooks[this.prop];return e&&e.get?e.get(this):at.propHooks._default.get(this)},run:function(e){var t,n=at.propHooks[this.prop];return this.options.duration?this.pos=t=ce.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):at.propHooks._default.set(this),this}}).init.prototype=at.prototype,(at.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=ce.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){ce.fx.step[e.prop]?ce.fx.step[e.prop](e):1!==e.elem.nodeType||!ce.cssHooks[e.prop]&&null==e.elem.style[Ze(e.prop)]?e.elem[e.prop]=e.now:ce.style(e.elem,e.prop,e.now+e.unit)}}}).scrollTop=at.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},ce.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},ce.fx=at.prototype.init,ce.fx.step={};var st,ut,lt,ct,ft=/^(?:toggle|show|hide)$/,pt=/queueHooks$/;function dt(){ut&&(!1===C.hidden&&ie.requestAnimationFrame?ie.requestAnimationFrame(dt):ie.setTimeout(dt,ce.fx.interval),ce.fx.tick())}function ht(){return ie.setTimeout(function(){st=void 0}),st=Date.now()}function gt(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=Q[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function vt(e,t,n){for(var r,i=(yt.tweeners[t]||[]).concat(yt.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function yt(o,e,t){var n,a,r=0,i=yt.prefilters.length,s=ce.Deferred().always(function(){delete u.elem}),u=function(){if(a)return!1;for(var e=st||ht(),t=Math.max(0,l.startTime+l.duration-e),n=1-(t/l.duration||0),r=0,i=l.tweens.length;r<i;r++)l.tweens[r].run(n);return s.notifyWith(o,[l,n,t]),n<1&&i?t:(i||s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l]),!1)},l=s.promise({elem:o,props:ce.extend({},e),opts:ce.extend(!0,{specialEasing:{},easing:ce.easing._default},t),originalProperties:e,originalOptions:t,startTime:st||ht(),duration:t.duration,tweens:[],createTween:function(e,t){var n=ce.Tween(o,l.opts,e,t,l.opts.specialEasing[e]||l.opts.easing);return l.tweens.push(n),n},stop:function(e){var t=0,n=e?l.tweens.length:0;if(a)return this;for(a=!0;t<n;t++)l.tweens[t].run(1);return e?(s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l,e])):s.rejectWith(o,[l,e]),this}}),c=l.props;for(!function(e,t){var n,r,i,o,a;for(n in e)if(i=t[r=F(n)],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=ce.cssHooks[r])&&"expand"in a)for(n in o=a.expand(o),delete e[r],o)n in e||(e[n]=o[n],t[n]=i);else t[r]=i}(c,l.opts.specialEasing);r<i;r++)if(n=yt.prefilters[r].call(l,o,c,l.opts))return v(n.stop)&&(ce._queueHooks(l.elem,l.opts.queue).stop=n.stop.bind(n)),n;return ce.map(c,vt,l),v(l.opts.start)&&l.opts.start.call(o,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),ce.fx.timer(ce.extend(u,{elem:o,anim:l,queue:l.opts.queue})),l}ce.Animation=ce.extend(yt,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return te(n.elem,e,Y.exec(t),n),n}]},tweener:function(e,t){v(e)?(t=e,e=["*"]):e=e.match(D);for(var n,r=0,i=e.length;r<i;r++)n=e[r],yt.tweeners[n]=yt.tweeners[n]||[],yt.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&ee(e),v=_.get(e,"fxshow");for(r in n.queue||(null==(a=ce._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,ce.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],ft.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!v||void 0===v[r])continue;g=!0}d[r]=v&&v[r]||ce.style(e,r)}if((u=!ce.isEmptyObject(t))||!ce.isEmptyObject(d))for(r in f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=v&&v.display)&&(l=_.get(e,"display")),"none"===(c=ce.css(e,"display"))&&(l?c=l:(re([e],!0),l=e.style.display||l,c=ce.css(e,"display"),re([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===ce.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1,d)u||(v?"hidden"in v&&(g=v.hidden):v=_.access(e,"fxshow",{display:l}),o&&(v.hidden=!g),g&&re([e],!0),p.done(function(){for(r in g||re([e]),_.remove(e,"fxshow"),d)ce.style(e,r,d[r])})),u=vt(g?v[r]:0,r,p),r in v||(v[r]=u.start,g&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?yt.prefilters.unshift(e):yt.prefilters.push(e)}}),ce.speed=function(e,t,n){var r=e&&"object"==typeof e?ce.extend({},e):{complete:n||!n&&t||v(e)&&e,duration:e,easing:n&&t||t&&!v(t)&&t};return ce.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in ce.fx.speeds?r.duration=ce.fx.speeds[r.duration]:r.duration=ce.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){v(r.old)&&r.old.call(this),r.queue&&ce.dequeue(this,r.queue)},r},ce.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ee).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(t,e,n,r){var i=ce.isEmptyObject(t),o=ce.speed(e,n,r),a=function(){var e=yt(this,ce.extend({},t),o);(i||_.get(this,"finish"))&&e.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(i,e,o){var a=function(e){var t=e.stop;delete e.stop,t(o)};return"string"!=typeof i&&(o=e,e=i,i=void 0),e&&this.queue(i||"fx",[]),this.each(function(){var e=!0,t=null!=i&&i+"queueHooks",n=ce.timers,r=_.get(this);if(t)r[t]&&r[t].stop&&a(r[t]);else for(t in r)r[t]&&r[t].stop&&pt.test(t)&&a(r[t]);for(t=n.length;t--;)n[t].elem!==this||null!=i&&n[t].queue!==i||(n[t].anim.stop(o),e=!1,n.splice(t,1));!e&&o||ce.dequeue(this,i)})},finish:function(a){return!1!==a&&(a=a||"fx"),this.each(function(){var e,t=_.get(this),n=t[a+"queue"],r=t[a+"queueHooks"],i=ce.timers,o=n?n.length:0;for(t.finish=!0,ce.queue(this,a,[]),r&&r.stop&&r.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===a&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<o;e++)n[e]&&n[e].finish&&n[e].finish.call(this);delete t.finish})}}),ce.each(["toggle","show","hide"],function(e,r){var i=ce.fn[r];ce.fn[r]=function(e,t,n){return null==e||"boolean"==typeof e?i.apply(this,arguments):this.animate(gt(r,!0),e,t,n)}}),ce.each({slideDown:gt("show"),slideUp:gt("hide"),slideToggle:gt("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,r){ce.fn[e]=function(e,t,n){return this.animate(r,e,t,n)}}),ce.timers=[],ce.fx.tick=function(){var e,t=0,n=ce.timers;for(st=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||ce.fx.stop(),st=void 0},ce.fx.timer=function(e){ce.timers.push(e),ce.fx.start()},ce.fx.interval=13,ce.fx.start=function(){ut||(ut=!0,dt())},ce.fx.stop=function(){ut=null},ce.fx.speeds={slow:600,fast:200,_default:400},ce.fn.delay=function(r,e){return r=ce.fx&&ce.fx.speeds[r]||r,e=e||"fx",this.queue(e,function(e,t){var n=ie.setTimeout(e,r);t.stop=function(){ie.clearTimeout(n)}})},lt=C.createElement("input"),ct=C.createElement("select").appendChild(C.createElement("option")),lt.type="checkbox",le.checkOn=""!==lt.value,le.optSelected=ct.selected,(lt=C.createElement("input")).value="t",lt.type="radio",le.radioValue="t"===lt.value;var mt,xt=ce.expr.attrHandle;ce.fn.extend({attr:function(e,t){return M(this,ce.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each(function(){ce.removeAttr(this,e)})}}),ce.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?ce.prop(e,t,n):(1===o&&ce.isXMLDoc(e)||(i=ce.attrHooks[t.toLowerCase()]||(ce.expr.match.bool.test(t)?mt:void 0)),void 0!==n?null===n?void ce.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=ce.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!le.radioValue&&"radio"===t&&fe(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(D);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),mt={set:function(e,t,n){return!1===t?ce.removeAttr(e,n):e.setAttribute(n,n),n}},ce.each(ce.expr.match.bool.source.match(/\w+/g),function(e,t){var a=xt[t]||ce.find.attr;xt[t]=function(e,t,n){var r,i,o=t.toLowerCase();return n||(i=xt[o],xt[o]=r,r=null!=a(e,t,n)?o:null,xt[o]=i),r}});var bt=/^(?:input|select|textarea|button)$/i,wt=/^(?:a|area)$/i;function Tt(e){return(e.match(D)||[]).join(" ")}function Ct(e){return e.getAttribute&&e.getAttribute("class")||""}function kt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(D)||[]}ce.fn.extend({prop:function(e,t){return M(this,ce.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each(function(){delete this[ce.propFix[e]||e]})}}),ce.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&ce.isXMLDoc(e)||(t=ce.propFix[t]||t,i=ce.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=ce.find.attr(e,"tabindex");return t?parseInt(t,10):bt.test(e.nodeName)||wt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),le.optSelected||(ce.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),ce.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){ce.propFix[this.toLowerCase()]=this}),ce.fn.extend({addClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).addClass(t.call(this,e,Ct(this)))}):(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++)i=e[o],n.indexOf(" "+i+" ")<0&&(n+=i+" ");a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this},removeClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).removeClass(t.call(this,e,Ct(this)))}):arguments.length?(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++){i=e[o];while(-1<n.indexOf(" "+i+" "))n=n.replace(" "+i+" "," ")}a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this:this.attr("class","")},toggleClass:function(t,n){var e,r,i,o,a=typeof t,s="string"===a||Array.isArray(t);return v(t)?this.each(function(e){ce(this).toggleClass(t.call(this,e,Ct(this),n),n)}):"boolean"==typeof n&&s?n?this.addClass(t):this.removeClass(t):(e=kt(t),this.each(function(){if(s)for(o=ce(this),i=0;i<e.length;i++)r=e[i],o.hasClass(r)?o.removeClass(r):o.addClass(r);else void 0!==t&&"boolean"!==a||((r=Ct(this))&&_.set(this,"__className__",r),this.setAttribute&&this.setAttribute("class",r||!1===t?"":_.get(this,"__className__")||""))}))},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&-1<(" "+Tt(Ct(n))+" ").indexOf(t))return!0;return!1}});var St=/\r/g;ce.fn.extend({val:function(n){var r,e,i,t=this[0];return arguments.length?(i=v(n),this.each(function(e){var t;1===this.nodeType&&(null==(t=i?n.call(this,e,ce(this).val()):n)?t="":"number"==typeof t?t+="":Array.isArray(t)&&(t=ce.map(t,function(e){return null==e?"":e+""})),(r=ce.valHooks[this.type]||ce.valHooks[this.nodeName.toLowerCase()])&&"set"in r&&void 0!==r.set(this,t,"value")||(this.value=t))})):t?(r=ce.valHooks[t.type]||ce.valHooks[t.nodeName.toLowerCase()])&&"get"in r&&void 0!==(e=r.get(t,"value"))?e:"string"==typeof(e=t.value)?e.replace(St,""):null==e?"":e:void 0}}),ce.extend({valHooks:{option:{get:function(e){var t=ce.find.attr(e,"value");return null!=t?t:Tt(ce.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!fe(n.parentNode,"optgroup"))){if(t=ce(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=ce.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=-1<ce.inArray(ce.valHooks.option.get(r),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),ce.each(["radio","checkbox"],function(){ce.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<ce.inArray(ce(e).val(),t)}},le.checkOn||(ce.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})});var Et=ie.location,jt={guid:Date.now()},At=/\?/;ce.parseXML=function(e){var t,n;if(!e||"string"!=typeof e)return null;try{t=(new ie.DOMParser).parseFromString(e,"text/xml")}catch(e){}return n=t&&t.getElementsByTagName("parsererror")[0],t&&!n||ce.error("Invalid XML: "+(n?ce.map(n.childNodes,function(e){return e.textContent}).join("\n"):e)),t};var Dt=/^(?:focusinfocus|focusoutblur)$/,Nt=function(e){e.stopPropagation()};ce.extend(ce.event,{trigger:function(e,t,n,r){var i,o,a,s,u,l,c,f,p=[n||C],d=ue.call(e,"type")?e.type:e,h=ue.call(e,"namespace")?e.namespace.split("."):[];if(o=f=a=n=n||C,3!==n.nodeType&&8!==n.nodeType&&!Dt.test(d+ce.event.triggered)&&(-1<d.indexOf(".")&&(d=(h=d.split(".")).shift(),h.sort()),u=d.indexOf(":")<0&&"on"+d,(e=e[ce.expando]?e:new ce.Event(d,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=h.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:ce.makeArray(t,[e]),c=ce.event.special[d]||{},r||!c.trigger||!1!==c.trigger.apply(n,t))){if(!r&&!c.noBubble&&!y(n)){for(s=c.delegateType||d,Dt.test(s+d)||(o=o.parentNode);o;o=o.parentNode)p.push(o),a=o;a===(n.ownerDocument||C)&&p.push(a.defaultView||a.parentWindow||ie)}i=0;while((o=p[i++])&&!e.isPropagationStopped())f=o,e.type=1<i?s:c.bindType||d,(l=(_.get(o,"events")||Object.create(null))[e.type]&&_.get(o,"handle"))&&l.apply(o,t),(l=u&&o[u])&&l.apply&&$(o)&&(e.result=l.apply(o,t),!1===e.result&&e.preventDefault());return e.type=d,r||e.isDefaultPrevented()||c._default&&!1!==c._default.apply(p.pop(),t)||!$(n)||u&&v(n[d])&&!y(n)&&((a=n[u])&&(n[u]=null),ce.event.triggered=d,e.isPropagationStopped()&&f.addEventListener(d,Nt),n[d](),e.isPropagationStopped()&&f.removeEventListener(d,Nt),ce.event.triggered=void 0,a&&(n[u]=a)),e.result}},simulate:function(e,t,n){var r=ce.extend(new ce.Event,n,{type:e,isSimulated:!0});ce.event.trigger(r,null,t)}}),ce.fn.extend({trigger:function(e,t){return this.each(function(){ce.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return ce.event.trigger(e,t,n,!0)}});var qt=/\[\]$/,Lt=/\r?\n/g,Ht=/^(?:submit|button|image|reset|file)$/i,Ot=/^(?:input|select|textarea|keygen)/i;function Pt(n,e,r,i){var t;if(Array.isArray(e))ce.each(e,function(e,t){r||qt.test(n)?i(n,t):Pt(n+"["+("object"==typeof t&&null!=t?e:"")+"]",t,r,i)});else if(r||"object"!==x(e))i(n,e);else for(t in e)Pt(n+"["+t+"]",e[t],r,i)}ce.param=function(e,t){var n,r=[],i=function(e,t){var n=v(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!ce.isPlainObject(e))ce.each(e,function(){i(this.name,this.value)});else for(n in e)Pt(n,e[n],t,i);return r.join("&")},ce.fn.extend({serialize:function(){return ce.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=ce.prop(this,"elements");return e?ce.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!ce(this).is(":disabled")&&Ot.test(this.nodeName)&&!Ht.test(e)&&(this.checked||!we.test(e))}).map(function(e,t){var n=ce(this).val();return null==n?null:Array.isArray(n)?ce.map(n,function(e){return{name:t.name,value:e.replace(Lt,"\r\n")}}):{name:t.name,value:n.replace(Lt,"\r\n")}}).get()}});var Mt=/%20/g,Rt=/#.*$/,It=/([?&])_=[^&]*/,Wt=/^(.*?):[ \t]*([^\r\n]*)$/gm,Ft=/^(?:GET|HEAD)$/,$t=/^\/\//,Bt={},_t={},zt="*/".concat("*"),Xt=C.createElement("a");function Ut(o){return function(e,t){"string"!=typeof e&&(t=e,e="*");var n,r=0,i=e.toLowerCase().match(D)||[];if(v(t))while(n=i[r++])"+"===n[0]?(n=n.slice(1)||"*",(o[n]=o[n]||[]).unshift(t)):(o[n]=o[n]||[]).push(t)}}function Vt(t,i,o,a){var s={},u=t===_t;function l(e){var r;return s[e]=!0,ce.each(t[e]||[],function(e,t){var n=t(i,o,a);return"string"!=typeof n||u||s[n]?u?!(r=n):void 0:(i.dataTypes.unshift(n),l(n),!1)}),r}return l(i.dataTypes[0])||!s["*"]&&l("*")}function Gt(e,t){var n,r,i=ce.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&ce.extend(!0,e,r),e}Xt.href=Et.href,ce.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Et.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Et.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":zt,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":ce.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?Gt(Gt(e,ce.ajaxSettings),t):Gt(ce.ajaxSettings,e)},ajaxPrefilter:Ut(Bt),ajaxTransport:Ut(_t),ajax:function(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var c,f,p,n,d,r,h,g,i,o,v=ce.ajaxSetup({},t),y=v.context||v,m=v.context&&(y.nodeType||y.jquery)?ce(y):ce.event,x=ce.Deferred(),b=ce.Callbacks("once memory"),w=v.statusCode||{},a={},s={},u="canceled",T={readyState:0,getResponseHeader:function(e){var t;if(h){if(!n){n={};while(t=Wt.exec(p))n[t[1].toLowerCase()+" "]=(n[t[1].toLowerCase()+" "]||[]).concat(t[2])}t=n[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return h?p:null},setRequestHeader:function(e,t){return null==h&&(e=s[e.toLowerCase()]=s[e.toLowerCase()]||e,a[e]=t),this},overrideMimeType:function(e){return null==h&&(v.mimeType=e),this},statusCode:function(e){var t;if(e)if(h)T.always(e[T.status]);else for(t in e)w[t]=[w[t],e[t]];return this},abort:function(e){var t=e||u;return c&&c.abort(t),l(0,t),this}};if(x.promise(T),v.url=((e||v.url||Et.href)+"").replace($t,Et.protocol+"//"),v.type=t.method||t.type||v.method||v.type,v.dataTypes=(v.dataType||"*").toLowerCase().match(D)||[""],null==v.crossDomain){r=C.createElement("a");try{r.href=v.url,r.href=r.href,v.crossDomain=Xt.protocol+"//"+Xt.host!=r.protocol+"//"+r.host}catch(e){v.crossDomain=!0}}if(v.data&&v.processData&&"string"!=typeof v.data&&(v.data=ce.param(v.data,v.traditional)),Vt(Bt,v,t,T),h)return T;for(i in(g=ce.event&&v.global)&&0==ce.active++&&ce.event.trigger("ajaxStart"),v.type=v.type.toUpperCase(),v.hasContent=!Ft.test(v.type),f=v.url.replace(Rt,""),v.hasContent?v.data&&v.processData&&0===(v.contentType||"").indexOf("application/x-www-form-urlencoded")&&(v.data=v.data.replace(Mt,"+")):(o=v.url.slice(f.length),v.data&&(v.processData||"string"==typeof v.data)&&(f+=(At.test(f)?"&":"?")+v.data,delete v.data),!1===v.cache&&(f=f.replace(It,"$1"),o=(At.test(f)?"&":"?")+"_="+jt.guid+++o),v.url=f+o),v.ifModified&&(ce.lastModified[f]&&T.setRequestHeader("If-Modified-Since",ce.lastModified[f]),ce.etag[f]&&T.setRequestHeader("If-None-Match",ce.etag[f])),(v.data&&v.hasContent&&!1!==v.contentType||t.contentType)&&T.setRequestHeader("Content-Type",v.contentType),T.setRequestHeader("Accept",v.dataTypes[0]&&v.accepts[v.dataTypes[0]]?v.accepts[v.dataTypes[0]]+("*"!==v.dataTypes[0]?", "+zt+"; q=0.01":""):v.accepts["*"]),v.headers)T.setRequestHeader(i,v.headers[i]);if(v.beforeSend&&(!1===v.beforeSend.call(y,T,v)||h))return T.abort();if(u="abort",b.add(v.complete),T.done(v.success),T.fail(v.error),c=Vt(_t,v,t,T)){if(T.readyState=1,g&&m.trigger("ajaxSend",[T,v]),h)return T;v.async&&0<v.timeout&&(d=ie.setTimeout(function(){T.abort("timeout")},v.timeout));try{h=!1,c.send(a,l)}catch(e){if(h)throw e;l(-1,e)}}else l(-1,"No Transport");function l(e,t,n,r){var i,o,a,s,u,l=t;h||(h=!0,d&&ie.clearTimeout(d),c=void 0,p=r||"",T.readyState=0<e?4:0,i=200<=e&&e<300||304===e,n&&(s=function(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(v,T,n)),!i&&-1<ce.inArray("script",v.dataTypes)&&ce.inArray("json",v.dataTypes)<0&&(v.converters["text script"]=function(){}),s=function(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}(v,s,T,i),i?(v.ifModified&&((u=T.getResponseHeader("Last-Modified"))&&(ce.lastModified[f]=u),(u=T.getResponseHeader("etag"))&&(ce.etag[f]=u)),204===e||"HEAD"===v.type?l="nocontent":304===e?l="notmodified":(l=s.state,o=s.data,i=!(a=s.error))):(a=l,!e&&l||(l="error",e<0&&(e=0))),T.status=e,T.statusText=(t||l)+"",i?x.resolveWith(y,[o,l,T]):x.rejectWith(y,[T,l,a]),T.statusCode(w),w=void 0,g&&m.trigger(i?"ajaxSuccess":"ajaxError",[T,v,i?o:a]),b.fireWith(y,[T,l]),g&&(m.trigger("ajaxComplete",[T,v]),--ce.active||ce.event.trigger("ajaxStop")))}return T},getJSON:function(e,t,n){return ce.get(e,t,n,"json")},getScript:function(e,t){return ce.get(e,void 0,t,"script")}}),ce.each(["get","post"],function(e,i){ce[i]=function(e,t,n,r){return v(t)&&(r=r||n,n=t,t=void 0),ce.ajax(ce.extend({url:e,type:i,dataType:r,data:t,success:n},ce.isPlainObject(e)&&e))}}),ce.ajaxPrefilter(function(e){var t;for(t in e.headers)"content-type"===t.toLowerCase()&&(e.contentType=e.headers[t]||"")}),ce._evalUrl=function(e,t,n){return ce.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){ce.globalEval(e,t,n)}})},ce.fn.extend({wrapAll:function(e){var t;return this[0]&&(v(e)&&(e=e.call(this[0])),t=ce(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(n){return v(n)?this.each(function(e){ce(this).wrapInner(n.call(this,e))}):this.each(function(){var e=ce(this),t=e.contents();t.length?t.wrapAll(n):e.append(n)})},wrap:function(t){var n=v(t);return this.each(function(e){ce(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(e){return this.parent(e).not("body").each(function(){ce(this).replaceWith(this.childNodes)}),this}}),ce.expr.pseudos.hidden=function(e){return!ce.expr.pseudos.visible(e)},ce.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},ce.ajaxSettings.xhr=function(){try{return new ie.XMLHttpRequest}catch(e){}};var Yt={0:200,1223:204},Qt=ce.ajaxSettings.xhr();le.cors=!!Qt&&"withCredentials"in Qt,le.ajax=Qt=!!Qt,ce.ajaxTransport(function(i){var o,a;if(le.cors||Qt&&!i.crossDomain)return{send:function(e,t){var n,r=i.xhr();if(r.open(i.type,i.url,i.async,i.username,i.password),i.xhrFields)for(n in i.xhrFields)r[n]=i.xhrFields[n];for(n in i.mimeType&&r.overrideMimeType&&r.overrideMimeType(i.mimeType),i.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest"),e)r.setRequestHeader(n,e[n]);o=function(e){return function(){o&&(o=a=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===e?r.abort():"error"===e?"number"!=typeof r.status?t(0,"error"):t(r.status,r.statusText):t(Yt[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!=typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=o(),a=r.onerror=r.ontimeout=o("error"),void 0!==r.onabort?r.onabort=a:r.onreadystatechange=function(){4===r.readyState&&ie.setTimeout(function(){o&&a()})},o=o("abort");try{r.send(i.hasContent&&i.data||null)}catch(e){if(o)throw e}},abort:function(){o&&o()}}}),ce.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),ce.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return ce.globalEval(e),e}}}),ce.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),ce.ajaxTransport("script",function(n){var r,i;if(n.crossDomain||n.scriptAttrs)return{send:function(e,t){r=ce("<script>").attr(n.scriptAttrs||{}).prop({charset:n.scriptCharset,src:n.url}).on("load error",i=function(e){r.remove(),i=null,e&&t("error"===e.type?404:200,e.type)}),C.head.appendChild(r[0])},abort:function(){i&&i()}}});var Jt,Kt=[],Zt=/(=)\?(?=&|$)|\?\?/;ce.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Kt.pop()||ce.expando+"_"+jt.guid++;return this[e]=!0,e}}),ce.ajaxPrefilter("json jsonp",function(e,t,n){var r,i,o,a=!1!==e.jsonp&&(Zt.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Zt.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return r=e.jsonpCallback=v(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Zt,"$1"+r):!1!==e.jsonp&&(e.url+=(At.test(e.url)?"&":"?")+e.jsonp+"="+r),e.converters["script json"]=function(){return o||ce.error(r+" was not called"),o[0]},e.dataTypes[0]="json",i=ie[r],ie[r]=function(){o=arguments},n.always(function(){void 0===i?ce(ie).removeProp(r):ie[r]=i,e[r]&&(e.jsonpCallback=t.jsonpCallback,Kt.push(r)),o&&v(i)&&i(o[0]),o=i=void 0}),"script"}),le.createHTMLDocument=((Jt=C.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===Jt.childNodes.length),ce.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(le.createHTMLDocument?((r=(t=C.implementation.createHTMLDocument("")).createElement("base")).href=C.location.href,t.head.appendChild(r)):t=C),o=!n&&[],(i=w.exec(e))?[t.createElement(i[1])]:(i=Ae([e],t,o),o&&o.length&&ce(o).remove(),ce.merge([],i.childNodes)));var r,i,o},ce.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return-1<s&&(r=Tt(e.slice(s)),e=e.slice(0,s)),v(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),0<a.length&&ce.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?ce("<div>").append(ce.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},ce.expr.pseudos.animated=function(t){return ce.grep(ce.timers,function(e){return t===e.elem}).length},ce.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l=ce.css(e,"position"),c=ce(e),f={};"static"===l&&(e.style.position="relative"),s=c.offset(),o=ce.css(e,"top"),u=ce.css(e,"left"),("absolute"===l||"fixed"===l)&&-1<(o+u).indexOf("auto")?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),v(t)&&(t=t.call(e,n,ce.extend({},s))),null!=t.top&&(f.top=t.top-s.top+a),null!=t.left&&(f.left=t.left-s.left+i),"using"in t?t.using.call(e,f):c.css(f)}},ce.fn.extend({offset:function(t){if(arguments.length)return void 0===t?this:this.each(function(e){ce.offset.setOffset(this,t,e)});var e,n,r=this[0];return r?r.getClientRects().length?(e=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===ce.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===ce.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=ce(e).offset()).top+=ce.css(e,"borderTopWidth",!0),i.left+=ce.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-ce.css(r,"marginTop",!0),left:t.left-i.left-ce.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===ce.css(e,"position"))e=e.offsetParent;return e||J})}}),ce.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,i){var o="pageYOffset"===i;ce.fn[t]=function(e){return M(this,function(e,t,n){var r;if(y(e)?r=e:9===e.nodeType&&(r=e.defaultView),void 0===n)return r?r[i]:e[t];r?r.scrollTo(o?r.pageXOffset:n,o?n:r.pageYOffset):e[t]=n},t,e,arguments.length)}}),ce.each(["top","left"],function(e,n){ce.cssHooks[n]=Ye(le.pixelPosition,function(e,t){if(t)return t=Ge(e,n),_e.test(t)?ce(e).position()[n]+"px":t})}),ce.each({Height:"height",Width:"width"},function(a,s){ce.each({padding:"inner"+a,content:s,"":"outer"+a},function(r,o){ce.fn[o]=function(e,t){var n=arguments.length&&(r||"boolean"!=typeof e),i=r||(!0===e||!0===t?"margin":"border");return M(this,function(e,t,n){var r;return y(e)?0===o.indexOf("outer")?e["inner"+a]:e.document.documentElement["client"+a]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+a],r["scroll"+a],e.body["offset"+a],r["offset"+a],r["client"+a])):void 0===n?ce.css(e,t,i):ce.style(e,t,n,i)},s,n?e:void 0,n)}})}),ce.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){ce.fn[t]=function(e){return this.on(t,e)}}),ce.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.on("mouseenter",e).on("mouseleave",t||e)}}),ce.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,n){ce.fn[n]=function(e,t){return 0<arguments.length?this.on(n,null,e,t):this.trigger(n)}});var en=/^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;ce.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),v(e))return r=ae.call(arguments,2),(i=function(){return e.apply(t||this,r.concat(ae.call(arguments)))}).guid=e.guid=e.guid||ce.guid++,i},ce.holdReady=function(e){e?ce.readyWait++:ce.ready(!0)},ce.isArray=Array.isArray,ce.parseJSON=JSON.parse,ce.nodeName=fe,ce.isFunction=v,ce.isWindow=y,ce.camelCase=F,ce.type=x,ce.now=Date.now,ce.isNumeric=function(e){var t=ce.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},ce.trim=function(e){return null==e?"":(e+"").replace(en,"$1")},"function"==typeof define&&define.amd&&define("jquery",[],function(){return ce});var tn=ie.jQuery,nn=ie.$;return ce.noConflict=function(e){return ie.$===ce&&(ie.$=nn),e&&ie.jQuery===ce&&(ie.jQuery=tn),ce},"undefined"==typeof e&&(ie.jQuery=ie.$=ce),ce});

/*
 Copyright (C) Federico Zivolo 2020
 Distributed under the MIT License (license terms are at http://opensource.org/licenses/MIT).
 */(function(e,t){'object'==typeof exports&&'undefined'!=typeof module?module.exports=t():'function'==typeof define&&define.amd?define(t):e.Popper=t()})(this,function(){'use strict';function e(e){return e&&'[object Function]'==={}.toString.call(e)}function t(e,t){if(1!==e.nodeType)return[];var o=e.ownerDocument.defaultView,n=o.getComputedStyle(e,null);return t?n[t]:n}function o(e){return'HTML'===e.nodeName?e:e.parentNode||e.host}function n(e){if(!e)return document.body;switch(e.nodeName){case'HTML':case'BODY':return e.ownerDocument.body;case'#document':return e.body;}var i=t(e),r=i.overflow,p=i.overflowX,s=i.overflowY;return /(auto|scroll|overlay)/.test(r+s+p)?e:n(o(e))}function i(e){return e&&e.referenceNode?e.referenceNode:e}function r(e){return 11===e?re:10===e?pe:re||pe}function p(e){if(!e)return document.documentElement;for(var o=r(10)?document.body:null,n=e.offsetParent||null;n===o&&e.nextElementSibling;)n=(e=e.nextElementSibling).offsetParent;var i=n&&n.nodeName;return i&&'BODY'!==i&&'HTML'!==i?-1!==['TH','TD','TABLE'].indexOf(n.nodeName)&&'static'===t(n,'position')?p(n):n:e?e.ownerDocument.documentElement:document.documentElement}function s(e){var t=e.nodeName;return'BODY'!==t&&('HTML'===t||p(e.firstElementChild)===e)}function d(e){return null===e.parentNode?e:d(e.parentNode)}function a(e,t){if(!e||!e.nodeType||!t||!t.nodeType)return document.documentElement;var o=e.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_FOLLOWING,n=o?e:t,i=o?t:e,r=document.createRange();r.setStart(n,0),r.setEnd(i,0);var l=r.commonAncestorContainer;if(e!==l&&t!==l||n.contains(i))return s(l)?l:p(l);var f=d(e);return f.host?a(f.host,t):a(e,d(t).host)}function l(e){var t=1<arguments.length&&void 0!==arguments[1]?arguments[1]:'top',o='top'===t?'scrollTop':'scrollLeft',n=e.nodeName;if('BODY'===n||'HTML'===n){var i=e.ownerDocument.documentElement,r=e.ownerDocument.scrollingElement||i;return r[o]}return e[o]}function f(e,t){var o=2<arguments.length&&void 0!==arguments[2]&&arguments[2],n=l(t,'top'),i=l(t,'left'),r=o?-1:1;return e.top+=n*r,e.bottom+=n*r,e.left+=i*r,e.right+=i*r,e}function m(e,t){var o='x'===t?'Left':'Top',n='Left'==o?'Right':'Bottom';return parseFloat(e['border'+o+'Width'])+parseFloat(e['border'+n+'Width'])}function h(e,t,o,n){return ee(t['offset'+e],t['scroll'+e],o['client'+e],o['offset'+e],o['scroll'+e],r(10)?parseInt(o['offset'+e])+parseInt(n['margin'+('Height'===e?'Top':'Left')])+parseInt(n['margin'+('Height'===e?'Bottom':'Right')]):0)}function c(e){var t=e.body,o=e.documentElement,n=r(10)&&getComputedStyle(o);return{height:h('Height',t,o,n),width:h('Width',t,o,n)}}function g(e){return le({},e,{right:e.left+e.width,bottom:e.top+e.height})}function u(e){var o={};try{if(r(10)){o=e.getBoundingClientRect();var n=l(e,'top'),i=l(e,'left');o.top+=n,o.left+=i,o.bottom+=n,o.right+=i}else o=e.getBoundingClientRect()}catch(t){}var p={left:o.left,top:o.top,width:o.right-o.left,height:o.bottom-o.top},s='HTML'===e.nodeName?c(e.ownerDocument):{},d=s.width||e.clientWidth||p.width,a=s.height||e.clientHeight||p.height,f=e.offsetWidth-d,h=e.offsetHeight-a;if(f||h){var u=t(e);f-=m(u,'x'),h-=m(u,'y'),p.width-=f,p.height-=h}return g(p)}function b(e,o){var i=2<arguments.length&&void 0!==arguments[2]&&arguments[2],p=r(10),s='HTML'===o.nodeName,d=u(e),a=u(o),l=n(e),m=t(o),h=parseFloat(m.borderTopWidth),c=parseFloat(m.borderLeftWidth);i&&s&&(a.top=ee(a.top,0),a.left=ee(a.left,0));var b=g({top:d.top-a.top-h,left:d.left-a.left-c,width:d.width,height:d.height});if(b.marginTop=0,b.marginLeft=0,!p&&s){var w=parseFloat(m.marginTop),y=parseFloat(m.marginLeft);b.top-=h-w,b.bottom-=h-w,b.left-=c-y,b.right-=c-y,b.marginTop=w,b.marginLeft=y}return(p&&!i?o.contains(l):o===l&&'BODY'!==l.nodeName)&&(b=f(b,o)),b}function w(e){var t=1<arguments.length&&void 0!==arguments[1]&&arguments[1],o=e.ownerDocument.documentElement,n=b(e,o),i=ee(o.clientWidth,window.innerWidth||0),r=ee(o.clientHeight,window.innerHeight||0),p=t?0:l(o),s=t?0:l(o,'left'),d={top:p-n.top+n.marginTop,left:s-n.left+n.marginLeft,width:i,height:r};return g(d)}function y(e){var n=e.nodeName;if('BODY'===n||'HTML'===n)return!1;if('fixed'===t(e,'position'))return!0;var i=o(e);return!!i&&y(i)}function E(e){if(!e||!e.parentElement||r())return document.documentElement;for(var o=e.parentElement;o&&'none'===t(o,'transform');)o=o.parentElement;return o||document.documentElement}function v(e,t,r,p){var s=4<arguments.length&&void 0!==arguments[4]&&arguments[4],d={top:0,left:0},l=s?E(e):a(e,i(t));if('viewport'===p)d=w(l,s);else{var f;'scrollParent'===p?(f=n(o(t)),'BODY'===f.nodeName&&(f=e.ownerDocument.documentElement)):'window'===p?f=e.ownerDocument.documentElement:f=p;var m=b(f,l,s);if('HTML'===f.nodeName&&!y(l)){var h=c(e.ownerDocument),g=h.height,u=h.width;d.top+=m.top-m.marginTop,d.bottom=g+m.top,d.left+=m.left-m.marginLeft,d.right=u+m.left}else d=m}r=r||0;var v='number'==typeof r;return d.left+=v?r:r.left||0,d.top+=v?r:r.top||0,d.right-=v?r:r.right||0,d.bottom-=v?r:r.bottom||0,d}function x(e){var t=e.width,o=e.height;return t*o}function O(e,t,o,n,i){var r=5<arguments.length&&void 0!==arguments[5]?arguments[5]:0;if(-1===e.indexOf('auto'))return e;var p=v(o,n,r,i),s={top:{width:p.width,height:t.top-p.top},right:{width:p.right-t.right,height:p.height},bottom:{width:p.width,height:p.bottom-t.bottom},left:{width:t.left-p.left,height:p.height}},d=Object.keys(s).map(function(e){return le({key:e},s[e],{area:x(s[e])})}).sort(function(e,t){return t.area-e.area}),a=d.filter(function(e){var t=e.width,n=e.height;return t>=o.clientWidth&&n>=o.clientHeight}),l=0<a.length?a[0].key:d[0].key,f=e.split('-')[1];return l+(f?'-'+f:'')}function L(e,t,o){var n=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null,r=n?E(t):a(t,i(o));return b(o,r,n)}function S(e){var t=e.ownerDocument.defaultView,o=t.getComputedStyle(e),n=parseFloat(o.marginTop||0)+parseFloat(o.marginBottom||0),i=parseFloat(o.marginLeft||0)+parseFloat(o.marginRight||0),r={width:e.offsetWidth+i,height:e.offsetHeight+n};return r}function T(e){var t={left:'right',right:'left',bottom:'top',top:'bottom'};return e.replace(/left|right|bottom|top/g,function(e){return t[e]})}function C(e,t,o){o=o.split('-')[0];var n=S(e),i={width:n.width,height:n.height},r=-1!==['right','left'].indexOf(o),p=r?'top':'left',s=r?'left':'top',d=r?'height':'width',a=r?'width':'height';return i[p]=t[p]+t[d]/2-n[d]/2,i[s]=o===s?t[s]-n[a]:t[T(s)],i}function D(e,t){return Array.prototype.find?e.find(t):e.filter(t)[0]}function N(e,t,o){if(Array.prototype.findIndex)return e.findIndex(function(e){return e[t]===o});var n=D(e,function(e){return e[t]===o});return e.indexOf(n)}function P(t,o,n){var i=void 0===n?t:t.slice(0,N(t,'name',n));return i.forEach(function(t){t['function']&&console.warn('`modifier.function` is deprecated, use `modifier.fn`!');var n=t['function']||t.fn;t.enabled&&e(n)&&(o.offsets.popper=g(o.offsets.popper),o.offsets.reference=g(o.offsets.reference),o=n(o,t))}),o}function k(){if(!this.state.isDestroyed){var e={instance:this,styles:{},arrowStyles:{},attributes:{},flipped:!1,offsets:{}};e.offsets.reference=L(this.state,this.popper,this.reference,this.options.positionFixed),e.placement=O(this.options.placement,e.offsets.reference,this.popper,this.reference,this.options.modifiers.flip.boundariesElement,this.options.modifiers.flip.padding),e.originalPlacement=e.placement,e.positionFixed=this.options.positionFixed,e.offsets.popper=C(this.popper,e.offsets.reference,e.placement),e.offsets.popper.position=this.options.positionFixed?'fixed':'absolute',e=P(this.modifiers,e),this.state.isCreated?this.options.onUpdate(e):(this.state.isCreated=!0,this.options.onCreate(e))}}function W(e,t){return e.some(function(e){var o=e.name,n=e.enabled;return n&&o===t})}function B(e){for(var t=[!1,'ms','Webkit','Moz','O'],o=e.charAt(0).toUpperCase()+e.slice(1),n=0;n<t.length;n++){var i=t[n],r=i?''+i+o:e;if('undefined'!=typeof document.body.style[r])return r}return null}function H(){return this.state.isDestroyed=!0,W(this.modifiers,'applyStyle')&&(this.popper.removeAttribute('x-placement'),this.popper.style.position='',this.popper.style.top='',this.popper.style.left='',this.popper.style.right='',this.popper.style.bottom='',this.popper.style.willChange='',this.popper.style[B('transform')]=''),this.disableEventListeners(),this.options.removeOnDestroy&&this.popper.parentNode.removeChild(this.popper),this}function A(e){var t=e.ownerDocument;return t?t.defaultView:window}function M(e,t,o,i){var r='BODY'===e.nodeName,p=r?e.ownerDocument.defaultView:e;p.addEventListener(t,o,{passive:!0}),r||M(n(p.parentNode),t,o,i),i.push(p)}function F(e,t,o,i){o.updateBound=i,A(e).addEventListener('resize',o.updateBound,{passive:!0});var r=n(e);return M(r,'scroll',o.updateBound,o.scrollParents),o.scrollElement=r,o.eventsEnabled=!0,o}function I(){this.state.eventsEnabled||(this.state=F(this.reference,this.options,this.state,this.scheduleUpdate))}function R(e,t){return A(e).removeEventListener('resize',t.updateBound),t.scrollParents.forEach(function(e){e.removeEventListener('scroll',t.updateBound)}),t.updateBound=null,t.scrollParents=[],t.scrollElement=null,t.eventsEnabled=!1,t}function U(){this.state.eventsEnabled&&(cancelAnimationFrame(this.scheduleUpdate),this.state=R(this.reference,this.state))}function Y(e){return''!==e&&!isNaN(parseFloat(e))&&isFinite(e)}function V(e,t){Object.keys(t).forEach(function(o){var n='';-1!==['width','height','top','right','bottom','left'].indexOf(o)&&Y(t[o])&&(n='px'),e.style[o]=t[o]+n})}function j(e,t){Object.keys(t).forEach(function(o){var n=t[o];!1===n?e.removeAttribute(o):e.setAttribute(o,t[o])})}function q(e,t){var o=e.offsets,n=o.popper,i=o.reference,r=$,p=function(e){return e},s=r(i.width),d=r(n.width),a=-1!==['left','right'].indexOf(e.placement),l=-1!==e.placement.indexOf('-'),f=t?a||l||s%2==d%2?r:Z:p,m=t?r:p;return{left:f(1==s%2&&1==d%2&&!l&&t?n.left-1:n.left),top:m(n.top),bottom:m(n.bottom),right:f(n.right)}}function K(e,t,o){var n=D(e,function(e){var o=e.name;return o===t}),i=!!n&&e.some(function(e){return e.name===o&&e.enabled&&e.order<n.order});if(!i){var r='`'+t+'`';console.warn('`'+o+'`'+' modifier is required by '+r+' modifier in order to work, be sure to include it before '+r+'!')}return i}function z(e){return'end'===e?'start':'start'===e?'end':e}function G(e){var t=1<arguments.length&&void 0!==arguments[1]&&arguments[1],o=he.indexOf(e),n=he.slice(o+1).concat(he.slice(0,o));return t?n.reverse():n}function _(e,t,o,n){var i=e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),r=+i[1],p=i[2];if(!r)return e;if(0===p.indexOf('%')){var s;switch(p){case'%p':s=o;break;case'%':case'%r':default:s=n;}var d=g(s);return d[t]/100*r}if('vh'===p||'vw'===p){var a;return a='vh'===p?ee(document.documentElement.clientHeight,window.innerHeight||0):ee(document.documentElement.clientWidth,window.innerWidth||0),a/100*r}return r}function X(e,t,o,n){var i=[0,0],r=-1!==['right','left'].indexOf(n),p=e.split(/(\+|\-)/).map(function(e){return e.trim()}),s=p.indexOf(D(p,function(e){return-1!==e.search(/,|\s/)}));p[s]&&-1===p[s].indexOf(',')&&console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');var d=/\s*,\s*|\s+/,a=-1===s?[p]:[p.slice(0,s).concat([p[s].split(d)[0]]),[p[s].split(d)[1]].concat(p.slice(s+1))];return a=a.map(function(e,n){var i=(1===n?!r:r)?'height':'width',p=!1;return e.reduce(function(e,t){return''===e[e.length-1]&&-1!==['+','-'].indexOf(t)?(e[e.length-1]=t,p=!0,e):p?(e[e.length-1]+=t,p=!1,e):e.concat(t)},[]).map(function(e){return _(e,i,t,o)})}),a.forEach(function(e,t){e.forEach(function(o,n){Y(o)&&(i[t]+=o*('-'===e[n-1]?-1:1))})}),i}function J(e,t){var o,n=t.offset,i=e.placement,r=e.offsets,p=r.popper,s=r.reference,d=i.split('-')[0];return o=Y(+n)?[+n,0]:X(n,p,s,d),'left'===d?(p.top+=o[0],p.left-=o[1]):'right'===d?(p.top+=o[0],p.left+=o[1]):'top'===d?(p.left+=o[0],p.top-=o[1]):'bottom'===d&&(p.left+=o[0],p.top+=o[1]),e.popper=p,e}var Q=Math.min,Z=Math.floor,$=Math.round,ee=Math.max,te='undefined'!=typeof window&&'undefined'!=typeof document&&'undefined'!=typeof navigator,oe=function(){for(var e=['Edge','Trident','Firefox'],t=0;t<e.length;t+=1)if(te&&0<=navigator.userAgent.indexOf(e[t]))return 1;return 0}(),ne=te&&window.Promise,ie=ne?function(e){var t=!1;return function(){t||(t=!0,window.Promise.resolve().then(function(){t=!1,e()}))}}:function(e){var t=!1;return function(){t||(t=!0,setTimeout(function(){t=!1,e()},oe))}},re=te&&!!(window.MSInputMethodContext&&document.documentMode),pe=te&&/MSIE 10/.test(navigator.userAgent),se=function(e,t){if(!(e instanceof t))throw new TypeError('Cannot call a class as a function')},de=function(){function e(e,t){for(var o,n=0;n<t.length;n++)o=t[n],o.enumerable=o.enumerable||!1,o.configurable=!0,'value'in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}return function(t,o,n){return o&&e(t.prototype,o),n&&e(t,n),t}}(),ae=function(e,t,o){return t in e?Object.defineProperty(e,t,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[t]=o,e},le=Object.assign||function(e){for(var t,o=1;o<arguments.length;o++)for(var n in t=arguments[o],t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e},fe=te&&/Firefox/i.test(navigator.userAgent),me=['auto-start','auto','auto-end','top-start','top','top-end','right-start','right','right-end','bottom-end','bottom','bottom-start','left-end','left','left-start'],he=me.slice(3),ce={FLIP:'flip',CLOCKWISE:'clockwise',COUNTERCLOCKWISE:'counterclockwise'},ge=function(){function t(o,n){var i=this,r=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{};se(this,t),this.scheduleUpdate=function(){return requestAnimationFrame(i.update)},this.update=ie(this.update.bind(this)),this.options=le({},t.Defaults,r),this.state={isDestroyed:!1,isCreated:!1,scrollParents:[]},this.reference=o&&o.jquery?o[0]:o,this.popper=n&&n.jquery?n[0]:n,this.options.modifiers={},Object.keys(le({},t.Defaults.modifiers,r.modifiers)).forEach(function(e){i.options.modifiers[e]=le({},t.Defaults.modifiers[e]||{},r.modifiers?r.modifiers[e]:{})}),this.modifiers=Object.keys(this.options.modifiers).map(function(e){return le({name:e},i.options.modifiers[e])}).sort(function(e,t){return e.order-t.order}),this.modifiers.forEach(function(t){t.enabled&&e(t.onLoad)&&t.onLoad(i.reference,i.popper,i.options,t,i.state)}),this.update();var p=this.options.eventsEnabled;p&&this.enableEventListeners(),this.state.eventsEnabled=p}return de(t,[{key:'update',value:function(){return k.call(this)}},{key:'destroy',value:function(){return H.call(this)}},{key:'enableEventListeners',value:function(){return I.call(this)}},{key:'disableEventListeners',value:function(){return U.call(this)}}]),t}();return ge.Utils=('undefined'==typeof window?global:window).PopperUtils,ge.placements=me,ge.Defaults={placement:'bottom',positionFixed:!1,eventsEnabled:!0,removeOnDestroy:!1,onCreate:function(){},onUpdate:function(){},modifiers:{shift:{order:100,enabled:!0,fn:function(e){var t=e.placement,o=t.split('-')[0],n=t.split('-')[1];if(n){var i=e.offsets,r=i.reference,p=i.popper,s=-1!==['bottom','top'].indexOf(o),d=s?'left':'top',a=s?'width':'height',l={start:ae({},d,r[d]),end:ae({},d,r[d]+r[a]-p[a])};e.offsets.popper=le({},p,l[n])}return e}},offset:{order:200,enabled:!0,fn:J,offset:0},preventOverflow:{order:300,enabled:!0,fn:function(e,t){var o=t.boundariesElement||p(e.instance.popper);e.instance.reference===o&&(o=p(o));var n=B('transform'),i=e.instance.popper.style,r=i.top,s=i.left,d=i[n];i.top='',i.left='',i[n]='';var a=v(e.instance.popper,e.instance.reference,t.padding,o,e.positionFixed);i.top=r,i.left=s,i[n]=d,t.boundaries=a;var l=t.priority,f=e.offsets.popper,m={primary:function(e){var o=f[e];return f[e]<a[e]&&!t.escapeWithReference&&(o=ee(f[e],a[e])),ae({},e,o)},secondary:function(e){var o='right'===e?'left':'top',n=f[o];return f[e]>a[e]&&!t.escapeWithReference&&(n=Q(f[o],a[e]-('right'===e?f.width:f.height))),ae({},o,n)}};return l.forEach(function(e){var t=-1===['left','top'].indexOf(e)?'secondary':'primary';f=le({},f,m[t](e))}),e.offsets.popper=f,e},priority:['left','right','top','bottom'],padding:5,boundariesElement:'scrollParent'},keepTogether:{order:400,enabled:!0,fn:function(e){var t=e.offsets,o=t.popper,n=t.reference,i=e.placement.split('-')[0],r=Z,p=-1!==['top','bottom'].indexOf(i),s=p?'right':'bottom',d=p?'left':'top',a=p?'width':'height';return o[s]<r(n[d])&&(e.offsets.popper[d]=r(n[d])-o[a]),o[d]>r(n[s])&&(e.offsets.popper[d]=r(n[s])),e}},arrow:{order:500,enabled:!0,fn:function(e,o){var n;if(!K(e.instance.modifiers,'arrow','keepTogether'))return e;var i=o.element;if('string'==typeof i){if(i=e.instance.popper.querySelector(i),!i)return e;}else if(!e.instance.popper.contains(i))return console.warn('WARNING: `arrow.element` must be child of its popper element!'),e;var r=e.placement.split('-')[0],p=e.offsets,s=p.popper,d=p.reference,a=-1!==['left','right'].indexOf(r),l=a?'height':'width',f=a?'Top':'Left',m=f.toLowerCase(),h=a?'left':'top',c=a?'bottom':'right',u=S(i)[l];d[c]-u<s[m]&&(e.offsets.popper[m]-=s[m]-(d[c]-u)),d[m]+u>s[c]&&(e.offsets.popper[m]+=d[m]+u-s[c]),e.offsets.popper=g(e.offsets.popper);var b=d[m]+d[l]/2-u/2,w=t(e.instance.popper),y=parseFloat(w['margin'+f]),E=parseFloat(w['border'+f+'Width']),v=b-e.offsets.popper[m]-y-E;return v=ee(Q(s[l]-u,v),0),e.arrowElement=i,e.offsets.arrow=(n={},ae(n,m,$(v)),ae(n,h,''),n),e},element:'[x-arrow]'},flip:{order:600,enabled:!0,fn:function(e,t){if(W(e.instance.modifiers,'inner'))return e;if(e.flipped&&e.placement===e.originalPlacement)return e;var o=v(e.instance.popper,e.instance.reference,t.padding,t.boundariesElement,e.positionFixed),n=e.placement.split('-')[0],i=T(n),r=e.placement.split('-')[1]||'',p=[];switch(t.behavior){case ce.FLIP:p=[n,i];break;case ce.CLOCKWISE:p=G(n);break;case ce.COUNTERCLOCKWISE:p=G(n,!0);break;default:p=t.behavior;}return p.forEach(function(s,d){if(n!==s||p.length===d+1)return e;n=e.placement.split('-')[0],i=T(n);var a=e.offsets.popper,l=e.offsets.reference,f=Z,m='left'===n&&f(a.right)>f(l.left)||'right'===n&&f(a.left)<f(l.right)||'top'===n&&f(a.bottom)>f(l.top)||'bottom'===n&&f(a.top)<f(l.bottom),h=f(a.left)<f(o.left),c=f(a.right)>f(o.right),g=f(a.top)<f(o.top),u=f(a.bottom)>f(o.bottom),b='left'===n&&h||'right'===n&&c||'top'===n&&g||'bottom'===n&&u,w=-1!==['top','bottom'].indexOf(n),y=!!t.flipVariations&&(w&&'start'===r&&h||w&&'end'===r&&c||!w&&'start'===r&&g||!w&&'end'===r&&u),E=!!t.flipVariationsByContent&&(w&&'start'===r&&c||w&&'end'===r&&h||!w&&'start'===r&&u||!w&&'end'===r&&g),v=y||E;(m||b||v)&&(e.flipped=!0,(m||b)&&(n=p[d+1]),v&&(r=z(r)),e.placement=n+(r?'-'+r:''),e.offsets.popper=le({},e.offsets.popper,C(e.instance.popper,e.offsets.reference,e.placement)),e=P(e.instance.modifiers,e,'flip'))}),e},behavior:'flip',padding:5,boundariesElement:'viewport',flipVariations:!1,flipVariationsByContent:!1},inner:{order:700,enabled:!1,fn:function(e){var t=e.placement,o=t.split('-')[0],n=e.offsets,i=n.popper,r=n.reference,p=-1!==['left','right'].indexOf(o),s=-1===['top','left'].indexOf(o);return i[p?'left':'top']=r[o]-(s?i[p?'width':'height']:0),e.placement=T(t),e.offsets.popper=g(i),e}},hide:{order:800,enabled:!0,fn:function(e){if(!K(e.instance.modifiers,'hide','preventOverflow'))return e;var t=e.offsets.reference,o=D(e.instance.modifiers,function(e){return'preventOverflow'===e.name}).boundaries;if(t.bottom<o.top||t.left>o.right||t.top>o.bottom||t.right<o.left){if(!0===e.hide)return e;e.hide=!0,e.attributes['x-out-of-boundaries']=''}else{if(!1===e.hide)return e;e.hide=!1,e.attributes['x-out-of-boundaries']=!1}return e}},computeStyle:{order:850,enabled:!0,fn:function(e,t){var o=t.x,n=t.y,i=e.offsets.popper,r=D(e.instance.modifiers,function(e){return'applyStyle'===e.name}).gpuAcceleration;void 0!==r&&console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');var s,d,a=void 0===r?t.gpuAcceleration:r,l=p(e.instance.popper),f=u(l),m={position:i.position},h=q(e,2>window.devicePixelRatio||!fe),c='bottom'===o?'top':'bottom',g='right'===n?'left':'right',b=B('transform');if(d='bottom'==c?'HTML'===l.nodeName?-l.clientHeight+h.bottom:-f.height+h.bottom:h.top,s='right'==g?'HTML'===l.nodeName?-l.clientWidth+h.right:-f.width+h.right:h.left,a&&b)m[b]='translate3d('+s+'px, '+d+'px, 0)',m[c]=0,m[g]=0,m.willChange='transform';else{var w='bottom'==c?-1:1,y='right'==g?-1:1;m[c]=d*w,m[g]=s*y,m.willChange=c+', '+g}var E={"x-placement":e.placement};return e.attributes=le({},E,e.attributes),e.styles=le({},m,e.styles),e.arrowStyles=le({},e.offsets.arrow,e.arrowStyles),e},gpuAcceleration:!0,x:'bottom',y:'right'},applyStyle:{order:900,enabled:!0,fn:function(e){return V(e.instance.popper,e.styles),j(e.instance.popper,e.attributes),e.arrowElement&&Object.keys(e.arrowStyles).length&&V(e.arrowElement,e.arrowStyles),e},onLoad:function(e,t,o,n,i){var r=L(i,t,e,o.positionFixed),p=O(o.placement,r,t,e,o.modifiers.flip.boundariesElement,o.modifiers.flip.padding);return t.setAttribute('x-placement',p),V(t,{position:o.positionFixed?'fixed':'absolute'}),o},gpuAcceleration:void 0}}},ge});
//# sourceMappingURL=popper.min.js.map

/*!
  * Bootstrap v4.6.2 (https://getbootstrap.com/)
  * Copyright 2011-2022 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports,require("jquery"),require("popper.js")):"function"==typeof define&&define.amd?define(["exports","jquery","popper.js"],e):e((t="undefined"!=typeof globalThis?globalThis:t||self).bootstrap={},t.jQuery,t.Popper)}(this,(function(t,e,n){"use strict";function i(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}var o=i(e),a=i(n);function s(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function l(t,e,n){return e&&s(t.prototype,e),n&&s(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}function r(){return r=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(t[i]=n[i])}return t},r.apply(this,arguments)}function u(t,e){return u=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t},u(t,e)}var f="transitionend";var d={TRANSITION_END:"bsTransitionEnd",getUID:function(t){do{t+=~~(1e6*Math.random())}while(document.getElementById(t));return t},getSelectorFromElement:function(t){var e=t.getAttribute("data-target");if(!e||"#"===e){var n=t.getAttribute("href");e=n&&"#"!==n?n.trim():""}try{return document.querySelector(e)?e:null}catch(t){return null}},getTransitionDurationFromElement:function(t){if(!t)return 0;var e=o.default(t).css("transition-duration"),n=o.default(t).css("transition-delay"),i=parseFloat(e),a=parseFloat(n);return i||a?(e=e.split(",")[0],n=n.split(",")[0],1e3*(parseFloat(e)+parseFloat(n))):0},reflow:function(t){return t.offsetHeight},triggerTransitionEnd:function(t){o.default(t).trigger(f)},supportsTransitionEnd:function(){return Boolean(f)},isElement:function(t){return(t[0]||t).nodeType},typeCheckConfig:function(t,e,n){for(var i in n)if(Object.prototype.hasOwnProperty.call(n,i)){var o=n[i],a=e[i],s=a&&d.isElement(a)?"element":null===(l=a)||"undefined"==typeof l?""+l:{}.toString.call(l).match(/\s([a-z]+)/i)[1].toLowerCase();if(!new RegExp(o).test(s))throw new Error(t.toUpperCase()+': Option "'+i+'" provided type "'+s+'" but expected type "'+o+'".')}var l},findShadowRoot:function(t){if(!document.documentElement.attachShadow)return null;if("function"==typeof t.getRootNode){var e=t.getRootNode();return e instanceof ShadowRoot?e:null}return t instanceof ShadowRoot?t:t.parentNode?d.findShadowRoot(t.parentNode):null},jQueryDetection:function(){if("undefined"==typeof o.default)throw new TypeError("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");var t=o.default.fn.jquery.split(" ")[0].split(".");if(t[0]<2&&t[1]<9||1===t[0]&&9===t[1]&&t[2]<1||t[0]>=4)throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0")}};d.jQueryDetection(),o.default.fn.emulateTransitionEnd=function(t){var e=this,n=!1;return o.default(this).one(d.TRANSITION_END,(function(){n=!0})),setTimeout((function(){n||d.triggerTransitionEnd(e)}),t),this},o.default.event.special[d.TRANSITION_END]={bindType:f,delegateType:f,handle:function(t){if(o.default(t.target).is(this))return t.handleObj.handler.apply(this,arguments)}};var c="bs.alert",h=o.default.fn.alert,g=function(){function t(t){this._element=t}var e=t.prototype;return e.close=function(t){var e=this._element;t&&(e=this._getRootElement(t)),this._triggerCloseEvent(e).isDefaultPrevented()||this._removeElement(e)},e.dispose=function(){o.default.removeData(this._element,c),this._element=null},e._getRootElement=function(t){var e=d.getSelectorFromElement(t),n=!1;return e&&(n=document.querySelector(e)),n||(n=o.default(t).closest(".alert")[0]),n},e._triggerCloseEvent=function(t){var e=o.default.Event("close.bs.alert");return o.default(t).trigger(e),e},e._removeElement=function(t){var e=this;if(o.default(t).removeClass("show"),o.default(t).hasClass("fade")){var n=d.getTransitionDurationFromElement(t);o.default(t).one(d.TRANSITION_END,(function(n){return e._destroyElement(t,n)})).emulateTransitionEnd(n)}else this._destroyElement(t)},e._destroyElement=function(t){o.default(t).detach().trigger("closed.bs.alert").remove()},t._jQueryInterface=function(e){return this.each((function(){var n=o.default(this),i=n.data(c);i||(i=new t(this),n.data(c,i)),"close"===e&&i[e](this)}))},t._handleDismiss=function(t){return function(e){e&&e.preventDefault(),t.close(this)}},l(t,null,[{key:"VERSION",get:function(){return"4.6.2"}}]),t}();o.default(document).on("click.bs.alert.data-api",'[data-dismiss="alert"]',g._handleDismiss(new g)),o.default.fn.alert=g._jQueryInterface,o.default.fn.alert.Constructor=g,o.default.fn.alert.noConflict=function(){return o.default.fn.alert=h,g._jQueryInterface};var m="bs.button",p=o.default.fn.button,_="active",v='[data-toggle^="button"]',y='input:not([type="hidden"])',b=".btn",E=function(){function t(t){this._element=t,this.shouldAvoidTriggerChange=!1}var e=t.prototype;return e.toggle=function(){var t=!0,e=!0,n=o.default(this._element).closest('[data-toggle="buttons"]')[0];if(n){var i=this._element.querySelector(y);if(i){if("radio"===i.type)if(i.checked&&this._element.classList.contains(_))t=!1;else{var a=n.querySelector(".active");a&&o.default(a).removeClass(_)}t&&("checkbox"!==i.type&&"radio"!==i.type||(i.checked=!this._element.classList.contains(_)),this.shouldAvoidTriggerChange||o.default(i).trigger("change")),i.focus(),e=!1}}this._element.hasAttribute("disabled")||this._element.classList.contains("disabled")||(e&&this._element.setAttribute("aria-pressed",!this._element.classList.contains(_)),t&&o.default(this._element).toggleClass(_))},e.dispose=function(){o.default.removeData(this._element,m),this._element=null},t._jQueryInterface=function(e,n){return this.each((function(){var i=o.default(this),a=i.data(m);a||(a=new t(this),i.data(m,a)),a.shouldAvoidTriggerChange=n,"toggle"===e&&a[e]()}))},l(t,null,[{key:"VERSION",get:function(){return"4.6.2"}}]),t}();o.default(document).on("click.bs.button.data-api",v,(function(t){var e=t.target,n=e;if(o.default(e).hasClass("btn")||(e=o.default(e).closest(b)[0]),!e||e.hasAttribute("disabled")||e.classList.contains("disabled"))t.preventDefault();else{var i=e.querySelector(y);if(i&&(i.hasAttribute("disabled")||i.classList.contains("disabled")))return void t.preventDefault();"INPUT"!==n.tagName&&"LABEL"===e.tagName||E._jQueryInterface.call(o.default(e),"toggle","INPUT"===n.tagName)}})).on("focus.bs.button.data-api blur.bs.button.data-api",v,(function(t){var e=o.default(t.target).closest(b)[0];o.default(e).toggleClass("focus",/^focus(in)?$/.test(t.type))})),o.default(window).on("load.bs.button.data-api",(function(){for(var t=[].slice.call(document.querySelectorAll('[data-toggle="buttons"] .btn')),e=0,n=t.length;e<n;e++){var i=t[e],o=i.querySelector(y);o.checked||o.hasAttribute("checked")?i.classList.add(_):i.classList.remove(_)}for(var a=0,s=(t=[].slice.call(document.querySelectorAll('[data-toggle="button"]'))).length;a<s;a++){var l=t[a];"true"===l.getAttribute("aria-pressed")?l.classList.add(_):l.classList.remove(_)}})),o.default.fn.button=E._jQueryInterface,o.default.fn.button.Constructor=E,o.default.fn.button.noConflict=function(){return o.default.fn.button=p,E._jQueryInterface};var T="carousel",w="bs.carousel",C=o.default.fn[T],S="active",N="next",D="prev",A="slid.bs.carousel",I=".active.carousel-item",k={interval:5e3,keyboard:!0,slide:!1,pause:"hover",wrap:!0,touch:!0},O={interval:"(number|boolean)",keyboard:"boolean",slide:"(boolean|string)",pause:"(string|boolean)",wrap:"boolean",touch:"boolean"},j={TOUCH:"touch",PEN:"pen"},P=function(){function t(t,e){this._items=null,this._interval=null,this._activeElement=null,this._isPaused=!1,this._isSliding=!1,this.touchTimeout=null,this.touchStartX=0,this.touchDeltaX=0,this._config=this._getConfig(e),this._element=t,this._indicatorsElement=this._element.querySelector(".carousel-indicators"),this._touchSupported="ontouchstart"in document.documentElement||navigator.maxTouchPoints>0,this._pointerEvent=Boolean(window.PointerEvent||window.MSPointerEvent),this._addEventListeners()}var e=t.prototype;return e.next=function(){this._isSliding||this._slide(N)},e.nextWhenVisible=function(){var t=o.default(this._element);!document.hidden&&t.is(":visible")&&"hidden"!==t.css("visibility")&&this.next()},e.prev=function(){this._isSliding||this._slide(D)},e.pause=function(t){t||(this._isPaused=!0),this._element.querySelector(".carousel-item-next, .carousel-item-prev")&&(d.triggerTransitionEnd(this._element),this.cycle(!0)),clearInterval(this._interval),this._interval=null},e.cycle=function(t){t||(this._isPaused=!1),this._interval&&(clearInterval(this._interval),this._interval=null),this._config.interval&&!this._isPaused&&(this._updateInterval(),this._interval=setInterval((document.visibilityState?this.nextWhenVisible:this.next).bind(this),this._config.interval))},e.to=function(t){var e=this;this._activeElement=this._element.querySelector(I);var n=this._getItemIndex(this._activeElement);if(!(t>this._items.length-1||t<0))if(this._isSliding)o.default(this._element).one(A,(function(){return e.to(t)}));else{if(n===t)return this.pause(),void this.cycle();var i=t>n?N:D;this._slide(i,this._items[t])}},e.dispose=function(){o.default(this._element).off(".bs.carousel"),o.default.removeData(this._element,w),this._items=null,this._config=null,this._element=null,this._interval=null,this._isPaused=null,this._isSliding=null,this._activeElement=null,this._indicatorsElement=null},e._getConfig=function(t){return t=r({},k,t),d.typeCheckConfig(T,t,O),t},e._handleSwipe=function(){var t=Math.abs(this.touchDeltaX);if(!(t<=40)){var e=t/this.touchDeltaX;this.touchDeltaX=0,e>0&&this.prev(),e<0&&this.next()}},e._addEventListeners=function(){var t=this;this._config.keyboard&&o.default(this._element).on("keydown.bs.carousel",(function(e){return t._keydown(e)})),"hover"===this._config.pause&&o.default(this._element).on("mouseenter.bs.carousel",(function(e){return t.pause(e)})).on("mouseleave.bs.carousel",(function(e){return t.cycle(e)})),this._config.touch&&this._addTouchEventListeners()},e._addTouchEventListeners=function(){var t=this;if(this._touchSupported){var e=function(e){t._pointerEvent&&j[e.originalEvent.pointerType.toUpperCase()]?t.touchStartX=e.originalEvent.clientX:t._pointerEvent||(t.touchStartX=e.originalEvent.touches[0].clientX)},n=function(e){t._pointerEvent&&j[e.originalEvent.pointerType.toUpperCase()]&&(t.touchDeltaX=e.originalEvent.clientX-t.touchStartX),t._handleSwipe(),"hover"===t._config.pause&&(t.pause(),t.touchTimeout&&clearTimeout(t.touchTimeout),t.touchTimeout=setTimeout((function(e){return t.cycle(e)}),500+t._config.interval))};o.default(this._element.querySelectorAll(".carousel-item img")).on("dragstart.bs.carousel",(function(t){return t.preventDefault()})),this._pointerEvent?(o.default(this._element).on("pointerdown.bs.carousel",(function(t){return e(t)})),o.default(this._element).on("pointerup.bs.carousel",(function(t){return n(t)})),this._element.classList.add("pointer-event")):(o.default(this._element).on("touchstart.bs.carousel",(function(t){return e(t)})),o.default(this._element).on("touchmove.bs.carousel",(function(e){return function(e){t.touchDeltaX=e.originalEvent.touches&&e.originalEvent.touches.length>1?0:e.originalEvent.touches[0].clientX-t.touchStartX}(e)})),o.default(this._element).on("touchend.bs.carousel",(function(t){return n(t)})))}},e._keydown=function(t){if(!/input|textarea/i.test(t.target.tagName))switch(t.which){case 37:t.preventDefault(),this.prev();break;case 39:t.preventDefault(),this.next()}},e._getItemIndex=function(t){return this._items=t&&t.parentNode?[].slice.call(t.parentNode.querySelectorAll(".carousel-item")):[],this._items.indexOf(t)},e._getItemByDirection=function(t,e){var n=t===N,i=t===D,o=this._getItemIndex(e),a=this._items.length-1;if((i&&0===o||n&&o===a)&&!this._config.wrap)return e;var s=(o+(t===D?-1:1))%this._items.length;return-1===s?this._items[this._items.length-1]:this._items[s]},e._triggerSlideEvent=function(t,e){var n=this._getItemIndex(t),i=this._getItemIndex(this._element.querySelector(I)),a=o.default.Event("slide.bs.carousel",{relatedTarget:t,direction:e,from:i,to:n});return o.default(this._element).trigger(a),a},e._setActiveIndicatorElement=function(t){if(this._indicatorsElement){var e=[].slice.call(this._indicatorsElement.querySelectorAll(".active"));o.default(e).removeClass(S);var n=this._indicatorsElement.children[this._getItemIndex(t)];n&&o.default(n).addClass(S)}},e._updateInterval=function(){var t=this._activeElement||this._element.querySelector(I);if(t){var e=parseInt(t.getAttribute("data-interval"),10);e?(this._config.defaultInterval=this._config.defaultInterval||this._config.interval,this._config.interval=e):this._config.interval=this._config.defaultInterval||this._config.interval}},e._slide=function(t,e){var n,i,a,s=this,l=this._element.querySelector(I),r=this._getItemIndex(l),u=e||l&&this._getItemByDirection(t,l),f=this._getItemIndex(u),c=Boolean(this._interval);if(t===N?(n="carousel-item-left",i="carousel-item-next",a="left"):(n="carousel-item-right",i="carousel-item-prev",a="right"),u&&o.default(u).hasClass(S))this._isSliding=!1;else if(!this._triggerSlideEvent(u,a).isDefaultPrevented()&&l&&u){this._isSliding=!0,c&&this.pause(),this._setActiveIndicatorElement(u),this._activeElement=u;var h=o.default.Event(A,{relatedTarget:u,direction:a,from:r,to:f});if(o.default(this._element).hasClass("slide")){o.default(u).addClass(i),d.reflow(u),o.default(l).addClass(n),o.default(u).addClass(n);var g=d.getTransitionDurationFromElement(l);o.default(l).one(d.TRANSITION_END,(function(){o.default(u).removeClass(n+" "+i).addClass(S),o.default(l).removeClass("active "+i+" "+n),s._isSliding=!1,setTimeout((function(){return o.default(s._element).trigger(h)}),0)})).emulateTransitionEnd(g)}else o.default(l).removeClass(S),o.default(u).addClass(S),this._isSliding=!1,o.default(this._element).trigger(h);c&&this.cycle()}},t._jQueryInterface=function(e){return this.each((function(){var n=o.default(this).data(w),i=r({},k,o.default(this).data());"object"==typeof e&&(i=r({},i,e));var a="string"==typeof e?e:i.slide;if(n||(n=new t(this,i),o.default(this).data(w,n)),"number"==typeof e)n.to(e);else if("string"==typeof a){if("undefined"==typeof n[a])throw new TypeError('No method named "'+a+'"');n[a]()}else i.interval&&i.ride&&(n.pause(),n.cycle())}))},t._dataApiClickHandler=function(e){var n=d.getSelectorFromElement(this);if(n){var i=o.default(n)[0];if(i&&o.default(i).hasClass("carousel")){var a=r({},o.default(i).data(),o.default(this).data()),s=this.getAttribute("data-slide-to");s&&(a.interval=!1),t._jQueryInterface.call(o.default(i),a),s&&o.default(i).data(w).to(s),e.preventDefault()}}},l(t,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"Default",get:function(){return k}}]),t}();o.default(document).on("click.bs.carousel.data-api","[data-slide], [data-slide-to]",P._dataApiClickHandler),o.default(window).on("load.bs.carousel.data-api",(function(){for(var t=[].slice.call(document.querySelectorAll('[data-ride="carousel"]')),e=0,n=t.length;e<n;e++){var i=o.default(t[e]);P._jQueryInterface.call(i,i.data())}})),o.default.fn[T]=P._jQueryInterface,o.default.fn[T].Constructor=P,o.default.fn[T].noConflict=function(){return o.default.fn[T]=C,P._jQueryInterface};var L="collapse",R="bs.collapse",x=o.default.fn[L],q="show",F="collapse",Q="collapsing",B="collapsed",H="width",U='[data-toggle="collapse"]',M={toggle:!0,parent:""},W={toggle:"boolean",parent:"(string|element)"},V=function(){function t(t,e){this._isTransitioning=!1,this._element=t,this._config=this._getConfig(e),this._triggerArray=[].slice.call(document.querySelectorAll('[data-toggle="collapse"][href="#'+t.id+'"],[data-toggle="collapse"][data-target="#'+t.id+'"]'));for(var n=[].slice.call(document.querySelectorAll(U)),i=0,o=n.length;i<o;i++){var a=n[i],s=d.getSelectorFromElement(a),l=[].slice.call(document.querySelectorAll(s)).filter((function(e){return e===t}));null!==s&&l.length>0&&(this._selector=s,this._triggerArray.push(a))}this._parent=this._config.parent?this._getParent():null,this._config.parent||this._addAriaAndCollapsedClass(this._element,this._triggerArray),this._config.toggle&&this.toggle()}var e=t.prototype;return e.toggle=function(){o.default(this._element).hasClass(q)?this.hide():this.show()},e.show=function(){var e,n,i=this;if(!(this._isTransitioning||o.default(this._element).hasClass(q)||(this._parent&&0===(e=[].slice.call(this._parent.querySelectorAll(".show, .collapsing")).filter((function(t){return"string"==typeof i._config.parent?t.getAttribute("data-parent")===i._config.parent:t.classList.contains(F)}))).length&&(e=null),e&&(n=o.default(e).not(this._selector).data(R))&&n._isTransitioning))){var a=o.default.Event("show.bs.collapse");if(o.default(this._element).trigger(a),!a.isDefaultPrevented()){e&&(t._jQueryInterface.call(o.default(e).not(this._selector),"hide"),n||o.default(e).data(R,null));var s=this._getDimension();o.default(this._element).removeClass(F).addClass(Q),this._element.style[s]=0,this._triggerArray.length&&o.default(this._triggerArray).removeClass(B).attr("aria-expanded",!0),this.setTransitioning(!0);var l="scroll"+(s[0].toUpperCase()+s.slice(1)),r=d.getTransitionDurationFromElement(this._element);o.default(this._element).one(d.TRANSITION_END,(function(){o.default(i._element).removeClass(Q).addClass("collapse show"),i._element.style[s]="",i.setTransitioning(!1),o.default(i._element).trigger("shown.bs.collapse")})).emulateTransitionEnd(r),this._element.style[s]=this._element[l]+"px"}}},e.hide=function(){var t=this;if(!this._isTransitioning&&o.default(this._element).hasClass(q)){var e=o.default.Event("hide.bs.collapse");if(o.default(this._element).trigger(e),!e.isDefaultPrevented()){var n=this._getDimension();this._element.style[n]=this._element.getBoundingClientRect()[n]+"px",d.reflow(this._element),o.default(this._element).addClass(Q).removeClass("collapse show");var i=this._triggerArray.length;if(i>0)for(var a=0;a<i;a++){var s=this._triggerArray[a],l=d.getSelectorFromElement(s);null!==l&&(o.default([].slice.call(document.querySelectorAll(l))).hasClass(q)||o.default(s).addClass(B).attr("aria-expanded",!1))}this.setTransitioning(!0),this._element.style[n]="";var r=d.getTransitionDurationFromElement(this._element);o.default(this._element).one(d.TRANSITION_END,(function(){t.setTransitioning(!1),o.default(t._element).removeClass(Q).addClass(F).trigger("hidden.bs.collapse")})).emulateTransitionEnd(r)}}},e.setTransitioning=function(t){this._isTransitioning=t},e.dispose=function(){o.default.removeData(this._element,R),this._config=null,this._parent=null,this._element=null,this._triggerArray=null,this._isTransitioning=null},e._getConfig=function(t){return(t=r({},M,t)).toggle=Boolean(t.toggle),d.typeCheckConfig(L,t,W),t},e._getDimension=function(){return o.default(this._element).hasClass(H)?H:"height"},e._getParent=function(){var e,n=this;d.isElement(this._config.parent)?(e=this._config.parent,"undefined"!=typeof this._config.parent.jquery&&(e=this._config.parent[0])):e=document.querySelector(this._config.parent);var i='[data-toggle="collapse"][data-parent="'+this._config.parent+'"]',a=[].slice.call(e.querySelectorAll(i));return o.default(a).each((function(e,i){n._addAriaAndCollapsedClass(t._getTargetFromElement(i),[i])})),e},e._addAriaAndCollapsedClass=function(t,e){var n=o.default(t).hasClass(q);e.length&&o.default(e).toggleClass(B,!n).attr("aria-expanded",n)},t._getTargetFromElement=function(t){var e=d.getSelectorFromElement(t);return e?document.querySelector(e):null},t._jQueryInterface=function(e){return this.each((function(){var n=o.default(this),i=n.data(R),a=r({},M,n.data(),"object"==typeof e&&e?e:{});if(!i&&a.toggle&&"string"==typeof e&&/show|hide/.test(e)&&(a.toggle=!1),i||(i=new t(this,a),n.data(R,i)),"string"==typeof e){if("undefined"==typeof i[e])throw new TypeError('No method named "'+e+'"');i[e]()}}))},l(t,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"Default",get:function(){return M}}]),t}();o.default(document).on("click.bs.collapse.data-api",U,(function(t){"A"===t.currentTarget.tagName&&t.preventDefault();var e=o.default(this),n=d.getSelectorFromElement(this),i=[].slice.call(document.querySelectorAll(n));o.default(i).each((function(){var t=o.default(this),n=t.data(R)?"toggle":e.data();V._jQueryInterface.call(t,n)}))})),o.default.fn[L]=V._jQueryInterface,o.default.fn[L].Constructor=V,o.default.fn[L].noConflict=function(){return o.default.fn[L]=x,V._jQueryInterface};var z="dropdown",K="bs.dropdown",X=o.default.fn[z],Y=new RegExp("38|40|27"),$="disabled",J="show",G="dropdown-menu-right",Z="hide.bs.dropdown",tt="hidden.bs.dropdown",et="click.bs.dropdown.data-api",nt="keydown.bs.dropdown.data-api",it='[data-toggle="dropdown"]',ot=".dropdown-menu",at={offset:0,flip:!0,boundary:"scrollParent",reference:"toggle",display:"dynamic",popperConfig:null},st={offset:"(number|string|function)",flip:"boolean",boundary:"(string|element)",reference:"(string|element)",display:"string",popperConfig:"(null|object)"},lt=function(){function t(t,e){this._element=t,this._popper=null,this._config=this._getConfig(e),this._menu=this._getMenuElement(),this._inNavbar=this._detectNavbar(),this._addEventListeners()}var e=t.prototype;return e.toggle=function(){if(!this._element.disabled&&!o.default(this._element).hasClass($)){var e=o.default(this._menu).hasClass(J);t._clearMenus(),e||this.show(!0)}},e.show=function(e){if(void 0===e&&(e=!1),!(this._element.disabled||o.default(this._element).hasClass($)||o.default(this._menu).hasClass(J))){var n={relatedTarget:this._element},i=o.default.Event("show.bs.dropdown",n),s=t._getParentFromElement(this._element);if(o.default(s).trigger(i),!i.isDefaultPrevented()){if(!this._inNavbar&&e){if("undefined"==typeof a.default)throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");var l=this._element;"parent"===this._config.reference?l=s:d.isElement(this._config.reference)&&(l=this._config.reference,"undefined"!=typeof this._config.reference.jquery&&(l=this._config.reference[0])),"scrollParent"!==this._config.boundary&&o.default(s).addClass("position-static"),this._popper=new a.default(l,this._menu,this._getPopperConfig())}"ontouchstart"in document.documentElement&&0===o.default(s).closest(".navbar-nav").length&&o.default(document.body).children().on("mouseover",null,o.default.noop),this._element.focus(),this._element.setAttribute("aria-expanded",!0),o.default(this._menu).toggleClass(J),o.default(s).toggleClass(J).trigger(o.default.Event("shown.bs.dropdown",n))}}},e.hide=function(){if(!this._element.disabled&&!o.default(this._element).hasClass($)&&o.default(this._menu).hasClass(J)){var e={relatedTarget:this._element},n=o.default.Event(Z,e),i=t._getParentFromElement(this._element);o.default(i).trigger(n),n.isDefaultPrevented()||(this._popper&&this._popper.destroy(),o.default(this._menu).toggleClass(J),o.default(i).toggleClass(J).trigger(o.default.Event(tt,e)))}},e.dispose=function(){o.default.removeData(this._element,K),o.default(this._element).off(".bs.dropdown"),this._element=null,this._menu=null,null!==this._popper&&(this._popper.destroy(),this._popper=null)},e.update=function(){this._inNavbar=this._detectNavbar(),null!==this._popper&&this._popper.scheduleUpdate()},e._addEventListeners=function(){var t=this;o.default(this._element).on("click.bs.dropdown",(function(e){e.preventDefault(),e.stopPropagation(),t.toggle()}))},e._getConfig=function(t){return t=r({},this.constructor.Default,o.default(this._element).data(),t),d.typeCheckConfig(z,t,this.constructor.DefaultType),t},e._getMenuElement=function(){if(!this._menu){var e=t._getParentFromElement(this._element);e&&(this._menu=e.querySelector(ot))}return this._menu},e._getPlacement=function(){var t=o.default(this._element.parentNode),e="bottom-start";return t.hasClass("dropup")?e=o.default(this._menu).hasClass(G)?"top-end":"top-start":t.hasClass("dropright")?e="right-start":t.hasClass("dropleft")?e="left-start":o.default(this._menu).hasClass(G)&&(e="bottom-end"),e},e._detectNavbar=function(){return o.default(this._element).closest(".navbar").length>0},e._getOffset=function(){var t=this,e={};return"function"==typeof this._config.offset?e.fn=function(e){return e.offsets=r({},e.offsets,t._config.offset(e.offsets,t._element)),e}:e.offset=this._config.offset,e},e._getPopperConfig=function(){var t={placement:this._getPlacement(),modifiers:{offset:this._getOffset(),flip:{enabled:this._config.flip},preventOverflow:{boundariesElement:this._config.boundary}}};return"static"===this._config.display&&(t.modifiers.applyStyle={enabled:!1}),r({},t,this._config.popperConfig)},t._jQueryInterface=function(e){return this.each((function(){var n=o.default(this).data(K);if(n||(n=new t(this,"object"==typeof e?e:null),o.default(this).data(K,n)),"string"==typeof e){if("undefined"==typeof n[e])throw new TypeError('No method named "'+e+'"');n[e]()}}))},t._clearMenus=function(e){if(!e||3!==e.which&&("keyup"!==e.type||9===e.which))for(var n=[].slice.call(document.querySelectorAll(it)),i=0,a=n.length;i<a;i++){var s=t._getParentFromElement(n[i]),l=o.default(n[i]).data(K),r={relatedTarget:n[i]};if(e&&"click"===e.type&&(r.clickEvent=e),l){var u=l._menu;if(o.default(s).hasClass(J)&&!(e&&("click"===e.type&&/input|textarea/i.test(e.target.tagName)||"keyup"===e.type&&9===e.which)&&o.default.contains(s,e.target))){var f=o.default.Event(Z,r);o.default(s).trigger(f),f.isDefaultPrevented()||("ontouchstart"in document.documentElement&&o.default(document.body).children().off("mouseover",null,o.default.noop),n[i].setAttribute("aria-expanded","false"),l._popper&&l._popper.destroy(),o.default(u).removeClass(J),o.default(s).removeClass(J).trigger(o.default.Event(tt,r)))}}}},t._getParentFromElement=function(t){var e,n=d.getSelectorFromElement(t);return n&&(e=document.querySelector(n)),e||t.parentNode},t._dataApiKeydownHandler=function(e){if(!(/input|textarea/i.test(e.target.tagName)?32===e.which||27!==e.which&&(40!==e.which&&38!==e.which||o.default(e.target).closest(ot).length):!Y.test(e.which))&&!this.disabled&&!o.default(this).hasClass($)){var n=t._getParentFromElement(this),i=o.default(n).hasClass(J);if(i||27!==e.which){if(e.preventDefault(),e.stopPropagation(),!i||27===e.which||32===e.which)return 27===e.which&&o.default(n.querySelector(it)).trigger("focus"),void o.default(this).trigger("click");var a=[].slice.call(n.querySelectorAll(".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)")).filter((function(t){return o.default(t).is(":visible")}));if(0!==a.length){var s=a.indexOf(e.target);38===e.which&&s>0&&s--,40===e.which&&s<a.length-1&&s++,s<0&&(s=0),a[s].focus()}}}},l(t,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"Default",get:function(){return at}},{key:"DefaultType",get:function(){return st}}]),t}();o.default(document).on(nt,it,lt._dataApiKeydownHandler).on(nt,ot,lt._dataApiKeydownHandler).on(et+" keyup.bs.dropdown.data-api",lt._clearMenus).on(et,it,(function(t){t.preventDefault(),t.stopPropagation(),lt._jQueryInterface.call(o.default(this),"toggle")})).on(et,".dropdown form",(function(t){t.stopPropagation()})),o.default.fn[z]=lt._jQueryInterface,o.default.fn[z].Constructor=lt,o.default.fn[z].noConflict=function(){return o.default.fn[z]=X,lt._jQueryInterface};var rt="bs.modal",ut=o.default.fn.modal,ft="modal-open",dt="fade",ct="show",ht="modal-static",gt="hidden.bs.modal",mt="show.bs.modal",pt="focusin.bs.modal",_t="resize.bs.modal",vt="click.dismiss.bs.modal",yt="keydown.dismiss.bs.modal",bt="mousedown.dismiss.bs.modal",Et=".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",Tt={backdrop:!0,keyboard:!0,focus:!0,show:!0},wt={backdrop:"(boolean|string)",keyboard:"boolean",focus:"boolean",show:"boolean"},Ct=function(){function t(t,e){this._config=this._getConfig(e),this._element=t,this._dialog=t.querySelector(".modal-dialog"),this._backdrop=null,this._isShown=!1,this._isBodyOverflowing=!1,this._ignoreBackdropClick=!1,this._isTransitioning=!1,this._scrollbarWidth=0}var e=t.prototype;return e.toggle=function(t){return this._isShown?this.hide():this.show(t)},e.show=function(t){var e=this;if(!this._isShown&&!this._isTransitioning){var n=o.default.Event(mt,{relatedTarget:t});o.default(this._element).trigger(n),n.isDefaultPrevented()||(this._isShown=!0,o.default(this._element).hasClass(dt)&&(this._isTransitioning=!0),this._checkScrollbar(),this._setScrollbar(),this._adjustDialog(),this._setEscapeEvent(),this._setResizeEvent(),o.default(this._element).on(vt,'[data-dismiss="modal"]',(function(t){return e.hide(t)})),o.default(this._dialog).on(bt,(function(){o.default(e._element).one("mouseup.dismiss.bs.modal",(function(t){o.default(t.target).is(e._element)&&(e._ignoreBackdropClick=!0)}))})),this._showBackdrop((function(){return e._showElement(t)})))}},e.hide=function(t){var e=this;if(t&&t.preventDefault(),this._isShown&&!this._isTransitioning){var n=o.default.Event("hide.bs.modal");if(o.default(this._element).trigger(n),this._isShown&&!n.isDefaultPrevented()){this._isShown=!1;var i=o.default(this._element).hasClass(dt);if(i&&(this._isTransitioning=!0),this._setEscapeEvent(),this._setResizeEvent(),o.default(document).off(pt),o.default(this._element).removeClass(ct),o.default(this._element).off(vt),o.default(this._dialog).off(bt),i){var a=d.getTransitionDurationFromElement(this._element);o.default(this._element).one(d.TRANSITION_END,(function(t){return e._hideModal(t)})).emulateTransitionEnd(a)}else this._hideModal()}}},e.dispose=function(){[window,this._element,this._dialog].forEach((function(t){return o.default(t).off(".bs.modal")})),o.default(document).off(pt),o.default.removeData(this._element,rt),this._config=null,this._element=null,this._dialog=null,this._backdrop=null,this._isShown=null,this._isBodyOverflowing=null,this._ignoreBackdropClick=null,this._isTransitioning=null,this._scrollbarWidth=null},e.handleUpdate=function(){this._adjustDialog()},e._getConfig=function(t){return t=r({},Tt,t),d.typeCheckConfig("modal",t,wt),t},e._triggerBackdropTransition=function(){var t=this,e=o.default.Event("hidePrevented.bs.modal");if(o.default(this._element).trigger(e),!e.isDefaultPrevented()){var n=this._element.scrollHeight>document.documentElement.clientHeight;n||(this._element.style.overflowY="hidden"),this._element.classList.add(ht);var i=d.getTransitionDurationFromElement(this._dialog);o.default(this._element).off(d.TRANSITION_END),o.default(this._element).one(d.TRANSITION_END,(function(){t._element.classList.remove(ht),n||o.default(t._element).one(d.TRANSITION_END,(function(){t._element.style.overflowY=""})).emulateTransitionEnd(t._element,i)})).emulateTransitionEnd(i),this._element.focus()}},e._showElement=function(t){var e=this,n=o.default(this._element).hasClass(dt),i=this._dialog?this._dialog.querySelector(".modal-body"):null;this._element.parentNode&&this._element.parentNode.nodeType===Node.ELEMENT_NODE||document.body.appendChild(this._element),this._element.style.display="block",this._element.removeAttribute("aria-hidden"),this._element.setAttribute("aria-modal",!0),this._element.setAttribute("role","dialog"),o.default(this._dialog).hasClass("modal-dialog-scrollable")&&i?i.scrollTop=0:this._element.scrollTop=0,n&&d.reflow(this._element),o.default(this._element).addClass(ct),this._config.focus&&this._enforceFocus();var a=o.default.Event("shown.bs.modal",{relatedTarget:t}),s=function(){e._config.focus&&e._element.focus(),e._isTransitioning=!1,o.default(e._element).trigger(a)};if(n){var l=d.getTransitionDurationFromElement(this._dialog);o.default(this._dialog).one(d.TRANSITION_END,s).emulateTransitionEnd(l)}else s()},e._enforceFocus=function(){var t=this;o.default(document).off(pt).on(pt,(function(e){document!==e.target&&t._element!==e.target&&0===o.default(t._element).has(e.target).length&&t._element.focus()}))},e._setEscapeEvent=function(){var t=this;this._isShown?o.default(this._element).on(yt,(function(e){t._config.keyboard&&27===e.which?(e.preventDefault(),t.hide()):t._config.keyboard||27!==e.which||t._triggerBackdropTransition()})):this._isShown||o.default(this._element).off(yt)},e._setResizeEvent=function(){var t=this;this._isShown?o.default(window).on(_t,(function(e){return t.handleUpdate(e)})):o.default(window).off(_t)},e._hideModal=function(){var t=this;this._element.style.display="none",this._element.setAttribute("aria-hidden",!0),this._element.removeAttribute("aria-modal"),this._element.removeAttribute("role"),this._isTransitioning=!1,this._showBackdrop((function(){o.default(document.body).removeClass(ft),t._resetAdjustments(),t._resetScrollbar(),o.default(t._element).trigger(gt)}))},e._removeBackdrop=function(){this._backdrop&&(o.default(this._backdrop).remove(),this._backdrop=null)},e._showBackdrop=function(t){var e=this,n=o.default(this._element).hasClass(dt)?dt:"";if(this._isShown&&this._config.backdrop){if(this._backdrop=document.createElement("div"),this._backdrop.className="modal-backdrop",n&&this._backdrop.classList.add(n),o.default(this._backdrop).appendTo(document.body),o.default(this._element).on(vt,(function(t){e._ignoreBackdropClick?e._ignoreBackdropClick=!1:t.target===t.currentTarget&&("static"===e._config.backdrop?e._triggerBackdropTransition():e.hide())})),n&&d.reflow(this._backdrop),o.default(this._backdrop).addClass(ct),!t)return;if(!n)return void t();var i=d.getTransitionDurationFromElement(this._backdrop);o.default(this._backdrop).one(d.TRANSITION_END,t).emulateTransitionEnd(i)}else if(!this._isShown&&this._backdrop){o.default(this._backdrop).removeClass(ct);var a=function(){e._removeBackdrop(),t&&t()};if(o.default(this._element).hasClass(dt)){var s=d.getTransitionDurationFromElement(this._backdrop);o.default(this._backdrop).one(d.TRANSITION_END,a).emulateTransitionEnd(s)}else a()}else t&&t()},e._adjustDialog=function(){var t=this._element.scrollHeight>document.documentElement.clientHeight;!this._isBodyOverflowing&&t&&(this._element.style.paddingLeft=this._scrollbarWidth+"px"),this._isBodyOverflowing&&!t&&(this._element.style.paddingRight=this._scrollbarWidth+"px")},e._resetAdjustments=function(){this._element.style.paddingLeft="",this._element.style.paddingRight=""},e._checkScrollbar=function(){var t=document.body.getBoundingClientRect();this._isBodyOverflowing=Math.round(t.left+t.right)<window.innerWidth,this._scrollbarWidth=this._getScrollbarWidth()},e._setScrollbar=function(){var t=this;if(this._isBodyOverflowing){var e=[].slice.call(document.querySelectorAll(Et)),n=[].slice.call(document.querySelectorAll(".sticky-top"));o.default(e).each((function(e,n){var i=n.style.paddingRight,a=o.default(n).css("padding-right");o.default(n).data("padding-right",i).css("padding-right",parseFloat(a)+t._scrollbarWidth+"px")})),o.default(n).each((function(e,n){var i=n.style.marginRight,a=o.default(n).css("margin-right");o.default(n).data("margin-right",i).css("margin-right",parseFloat(a)-t._scrollbarWidth+"px")}));var i=document.body.style.paddingRight,a=o.default(document.body).css("padding-right");o.default(document.body).data("padding-right",i).css("padding-right",parseFloat(a)+this._scrollbarWidth+"px")}o.default(document.body).addClass(ft)},e._resetScrollbar=function(){var t=[].slice.call(document.querySelectorAll(Et));o.default(t).each((function(t,e){var n=o.default(e).data("padding-right");o.default(e).removeData("padding-right"),e.style.paddingRight=n||""}));var e=[].slice.call(document.querySelectorAll(".sticky-top"));o.default(e).each((function(t,e){var n=o.default(e).data("margin-right");"undefined"!=typeof n&&o.default(e).css("margin-right",n).removeData("margin-right")}));var n=o.default(document.body).data("padding-right");o.default(document.body).removeData("padding-right"),document.body.style.paddingRight=n||""},e._getScrollbarWidth=function(){var t=document.createElement("div");t.className="modal-scrollbar-measure",document.body.appendChild(t);var e=t.getBoundingClientRect().width-t.clientWidth;return document.body.removeChild(t),e},t._jQueryInterface=function(e,n){return this.each((function(){var i=o.default(this).data(rt),a=r({},Tt,o.default(this).data(),"object"==typeof e&&e?e:{});if(i||(i=new t(this,a),o.default(this).data(rt,i)),"string"==typeof e){if("undefined"==typeof i[e])throw new TypeError('No method named "'+e+'"');i[e](n)}else a.show&&i.show(n)}))},l(t,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"Default",get:function(){return Tt}}]),t}();o.default(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',(function(t){var e,n=this,i=d.getSelectorFromElement(this);i&&(e=document.querySelector(i));var a=o.default(e).data(rt)?"toggle":r({},o.default(e).data(),o.default(this).data());"A"!==this.tagName&&"AREA"!==this.tagName||t.preventDefault();var s=o.default(e).one(mt,(function(t){t.isDefaultPrevented()||s.one(gt,(function(){o.default(n).is(":visible")&&n.focus()}))}));Ct._jQueryInterface.call(o.default(e),a,this)})),o.default.fn.modal=Ct._jQueryInterface,o.default.fn.modal.Constructor=Ct,o.default.fn.modal.noConflict=function(){return o.default.fn.modal=ut,Ct._jQueryInterface};var St=["background","cite","href","itemtype","longdesc","poster","src","xlink:href"],Nt=/^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i,Dt=/^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;function At(t,e,n){if(0===t.length)return t;if(n&&"function"==typeof n)return n(t);for(var i=(new window.DOMParser).parseFromString(t,"text/html"),o=Object.keys(e),a=[].slice.call(i.body.querySelectorAll("*")),s=function(t,n){var i=a[t],s=i.nodeName.toLowerCase();if(-1===o.indexOf(i.nodeName.toLowerCase()))return i.parentNode.removeChild(i),"continue";var l=[].slice.call(i.attributes),r=[].concat(e["*"]||[],e[s]||[]);l.forEach((function(t){(function(t,e){var n=t.nodeName.toLowerCase();if(-1!==e.indexOf(n))return-1===St.indexOf(n)||Boolean(Nt.test(t.nodeValue)||Dt.test(t.nodeValue));for(var i=e.filter((function(t){return t instanceof RegExp})),o=0,a=i.length;o<a;o++)if(i[o].test(n))return!0;return!1})(t,r)||i.removeAttribute(t.nodeName)}))},l=0,r=a.length;l<r;l++)s(l);return i.body.innerHTML}var It="tooltip",kt="bs.tooltip",Ot=o.default.fn.tooltip,jt=new RegExp("(^|\\s)bs-tooltip\\S+","g"),Pt=["sanitize","whiteList","sanitizeFn"],Lt="fade",Rt="show",xt="show",qt="out",Ft="hover",Qt="focus",Bt={AUTO:"auto",TOP:"top",RIGHT:"right",BOTTOM:"bottom",LEFT:"left"},Ht={animation:!0,template:'<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,selector:!1,placement:"top",offset:0,container:!1,fallbackPlacement:"flip",boundary:"scrollParent",customClass:"",sanitize:!0,sanitizeFn:null,whiteList:{"*":["class","dir","id","lang","role",/^aria-[\w-]*$/i],a:["target","href","title","rel"],area:[],b:[],br:[],col:[],code:[],div:[],em:[],hr:[],h1:[],h2:[],h3:[],h4:[],h5:[],h6:[],i:[],img:["src","srcset","alt","title","width","height"],li:[],ol:[],p:[],pre:[],s:[],small:[],span:[],sub:[],sup:[],strong:[],u:[],ul:[]},popperConfig:null},Ut={animation:"boolean",template:"string",title:"(string|element|function)",trigger:"string",delay:"(number|object)",html:"boolean",selector:"(string|boolean)",placement:"(string|function)",offset:"(number|string|function)",container:"(string|element|boolean)",fallbackPlacement:"(string|array)",boundary:"(string|element)",customClass:"(string|function)",sanitize:"boolean",sanitizeFn:"(null|function)",whiteList:"object",popperConfig:"(null|object)"},Mt={HIDE:"hide.bs.tooltip",HIDDEN:"hidden.bs.tooltip",SHOW:"show.bs.tooltip",SHOWN:"shown.bs.tooltip",INSERTED:"inserted.bs.tooltip",CLICK:"click.bs.tooltip",FOCUSIN:"focusin.bs.tooltip",FOCUSOUT:"focusout.bs.tooltip",MOUSEENTER:"mouseenter.bs.tooltip",MOUSELEAVE:"mouseleave.bs.tooltip"},Wt=function(){function t(t,e){if("undefined"==typeof a.default)throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");this._isEnabled=!0,this._timeout=0,this._hoverState="",this._activeTrigger={},this._popper=null,this.element=t,this.config=this._getConfig(e),this.tip=null,this._setListeners()}var e=t.prototype;return e.enable=function(){this._isEnabled=!0},e.disable=function(){this._isEnabled=!1},e.toggleEnabled=function(){this._isEnabled=!this._isEnabled},e.toggle=function(t){if(this._isEnabled)if(t){var e=this.constructor.DATA_KEY,n=o.default(t.currentTarget).data(e);n||(n=new this.constructor(t.currentTarget,this._getDelegateConfig()),o.default(t.currentTarget).data(e,n)),n._activeTrigger.click=!n._activeTrigger.click,n._isWithActiveTrigger()?n._enter(null,n):n._leave(null,n)}else{if(o.default(this.getTipElement()).hasClass(Rt))return void this._leave(null,this);this._enter(null,this)}},e.dispose=function(){clearTimeout(this._timeout),o.default.removeData(this.element,this.constructor.DATA_KEY),o.default(this.element).off(this.constructor.EVENT_KEY),o.default(this.element).closest(".modal").off("hide.bs.modal",this._hideModalHandler),this.tip&&o.default(this.tip).remove(),this._isEnabled=null,this._timeout=null,this._hoverState=null,this._activeTrigger=null,this._popper&&this._popper.destroy(),this._popper=null,this.element=null,this.config=null,this.tip=null},e.show=function(){var t=this;if("none"===o.default(this.element).css("display"))throw new Error("Please use show on visible elements");var e=o.default.Event(this.constructor.Event.SHOW);if(this.isWithContent()&&this._isEnabled){o.default(this.element).trigger(e);var n=d.findShadowRoot(this.element),i=o.default.contains(null!==n?n:this.element.ownerDocument.documentElement,this.element);if(e.isDefaultPrevented()||!i)return;var s=this.getTipElement(),l=d.getUID(this.constructor.NAME);s.setAttribute("id",l),this.element.setAttribute("aria-describedby",l),this.setContent(),this.config.animation&&o.default(s).addClass(Lt);var r="function"==typeof this.config.placement?this.config.placement.call(this,s,this.element):this.config.placement,u=this._getAttachment(r);this.addAttachmentClass(u);var f=this._getContainer();o.default(s).data(this.constructor.DATA_KEY,this),o.default.contains(this.element.ownerDocument.documentElement,this.tip)||o.default(s).appendTo(f),o.default(this.element).trigger(this.constructor.Event.INSERTED),this._popper=new a.default(this.element,s,this._getPopperConfig(u)),o.default(s).addClass(Rt),o.default(s).addClass(this.config.customClass),"ontouchstart"in document.documentElement&&o.default(document.body).children().on("mouseover",null,o.default.noop);var c=function(){t.config.animation&&t._fixTransition();var e=t._hoverState;t._hoverState=null,o.default(t.element).trigger(t.constructor.Event.SHOWN),e===qt&&t._leave(null,t)};if(o.default(this.tip).hasClass(Lt)){var h=d.getTransitionDurationFromElement(this.tip);o.default(this.tip).one(d.TRANSITION_END,c).emulateTransitionEnd(h)}else c()}},e.hide=function(t){var e=this,n=this.getTipElement(),i=o.default.Event(this.constructor.Event.HIDE),a=function(){e._hoverState!==xt&&n.parentNode&&n.parentNode.removeChild(n),e._cleanTipClass(),e.element.removeAttribute("aria-describedby"),o.default(e.element).trigger(e.constructor.Event.HIDDEN),null!==e._popper&&e._popper.destroy(),t&&t()};if(o.default(this.element).trigger(i),!i.isDefaultPrevented()){if(o.default(n).removeClass(Rt),"ontouchstart"in document.documentElement&&o.default(document.body).children().off("mouseover",null,o.default.noop),this._activeTrigger.click=!1,this._activeTrigger.focus=!1,this._activeTrigger.hover=!1,o.default(this.tip).hasClass(Lt)){var s=d.getTransitionDurationFromElement(n);o.default(n).one(d.TRANSITION_END,a).emulateTransitionEnd(s)}else a();this._hoverState=""}},e.update=function(){null!==this._popper&&this._popper.scheduleUpdate()},e.isWithContent=function(){return Boolean(this.getTitle())},e.addAttachmentClass=function(t){o.default(this.getTipElement()).addClass("bs-tooltip-"+t)},e.getTipElement=function(){return this.tip=this.tip||o.default(this.config.template)[0],this.tip},e.setContent=function(){var t=this.getTipElement();this.setElementContent(o.default(t.querySelectorAll(".tooltip-inner")),this.getTitle()),o.default(t).removeClass("fade show")},e.setElementContent=function(t,e){"object"!=typeof e||!e.nodeType&&!e.jquery?this.config.html?(this.config.sanitize&&(e=At(e,this.config.whiteList,this.config.sanitizeFn)),t.html(e)):t.text(e):this.config.html?o.default(e).parent().is(t)||t.empty().append(e):t.text(o.default(e).text())},e.getTitle=function(){var t=this.element.getAttribute("data-original-title");return t||(t="function"==typeof this.config.title?this.config.title.call(this.element):this.config.title),t},e._getPopperConfig=function(t){var e=this;return r({},{placement:t,modifiers:{offset:this._getOffset(),flip:{behavior:this.config.fallbackPlacement},arrow:{element:".arrow"},preventOverflow:{boundariesElement:this.config.boundary}},onCreate:function(t){t.originalPlacement!==t.placement&&e._handlePopperPlacementChange(t)},onUpdate:function(t){return e._handlePopperPlacementChange(t)}},this.config.popperConfig)},e._getOffset=function(){var t=this,e={};return"function"==typeof this.config.offset?e.fn=function(e){return e.offsets=r({},e.offsets,t.config.offset(e.offsets,t.element)),e}:e.offset=this.config.offset,e},e._getContainer=function(){return!1===this.config.container?document.body:d.isElement(this.config.container)?o.default(this.config.container):o.default(document).find(this.config.container)},e._getAttachment=function(t){return Bt[t.toUpperCase()]},e._setListeners=function(){var t=this;this.config.trigger.split(" ").forEach((function(e){if("click"===e)o.default(t.element).on(t.constructor.Event.CLICK,t.config.selector,(function(e){return t.toggle(e)}));else if("manual"!==e){var n=e===Ft?t.constructor.Event.MOUSEENTER:t.constructor.Event.FOCUSIN,i=e===Ft?t.constructor.Event.MOUSELEAVE:t.constructor.Event.FOCUSOUT;o.default(t.element).on(n,t.config.selector,(function(e){return t._enter(e)})).on(i,t.config.selector,(function(e){return t._leave(e)}))}})),this._hideModalHandler=function(){t.element&&t.hide()},o.default(this.element).closest(".modal").on("hide.bs.modal",this._hideModalHandler),this.config.selector?this.config=r({},this.config,{trigger:"manual",selector:""}):this._fixTitle()},e._fixTitle=function(){var t=typeof this.element.getAttribute("data-original-title");(this.element.getAttribute("title")||"string"!==t)&&(this.element.setAttribute("data-original-title",this.element.getAttribute("title")||""),this.element.setAttribute("title",""))},e._enter=function(t,e){var n=this.constructor.DATA_KEY;(e=e||o.default(t.currentTarget).data(n))||(e=new this.constructor(t.currentTarget,this._getDelegateConfig()),o.default(t.currentTarget).data(n,e)),t&&(e._activeTrigger["focusin"===t.type?Qt:Ft]=!0),o.default(e.getTipElement()).hasClass(Rt)||e._hoverState===xt?e._hoverState=xt:(clearTimeout(e._timeout),e._hoverState=xt,e.config.delay&&e.config.delay.show?e._timeout=setTimeout((function(){e._hoverState===xt&&e.show()}),e.config.delay.show):e.show())},e._leave=function(t,e){var n=this.constructor.DATA_KEY;(e=e||o.default(t.currentTarget).data(n))||(e=new this.constructor(t.currentTarget,this._getDelegateConfig()),o.default(t.currentTarget).data(n,e)),t&&(e._activeTrigger["focusout"===t.type?Qt:Ft]=!1),e._isWithActiveTrigger()||(clearTimeout(e._timeout),e._hoverState=qt,e.config.delay&&e.config.delay.hide?e._timeout=setTimeout((function(){e._hoverState===qt&&e.hide()}),e.config.delay.hide):e.hide())},e._isWithActiveTrigger=function(){for(var t in this._activeTrigger)if(this._activeTrigger[t])return!0;return!1},e._getConfig=function(t){var e=o.default(this.element).data();return Object.keys(e).forEach((function(t){-1!==Pt.indexOf(t)&&delete e[t]})),"number"==typeof(t=r({},this.constructor.Default,e,"object"==typeof t&&t?t:{})).delay&&(t.delay={show:t.delay,hide:t.delay}),"number"==typeof t.title&&(t.title=t.title.toString()),"number"==typeof t.content&&(t.content=t.content.toString()),d.typeCheckConfig(It,t,this.constructor.DefaultType),t.sanitize&&(t.template=At(t.template,t.whiteList,t.sanitizeFn)),t},e._getDelegateConfig=function(){var t={};if(this.config)for(var e in this.config)this.constructor.Default[e]!==this.config[e]&&(t[e]=this.config[e]);return t},e._cleanTipClass=function(){var t=o.default(this.getTipElement()),e=t.attr("class").match(jt);null!==e&&e.length&&t.removeClass(e.join(""))},e._handlePopperPlacementChange=function(t){this.tip=t.instance.popper,this._cleanTipClass(),this.addAttachmentClass(this._getAttachment(t.placement))},e._fixTransition=function(){var t=this.getTipElement(),e=this.config.animation;null===t.getAttribute("x-placement")&&(o.default(t).removeClass(Lt),this.config.animation=!1,this.hide(),this.show(),this.config.animation=e)},t._jQueryInterface=function(e){return this.each((function(){var n=o.default(this),i=n.data(kt),a="object"==typeof e&&e;if((i||!/dispose|hide/.test(e))&&(i||(i=new t(this,a),n.data(kt,i)),"string"==typeof e)){if("undefined"==typeof i[e])throw new TypeError('No method named "'+e+'"');i[e]()}}))},l(t,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"Default",get:function(){return Ht}},{key:"NAME",get:function(){return It}},{key:"DATA_KEY",get:function(){return kt}},{key:"Event",get:function(){return Mt}},{key:"EVENT_KEY",get:function(){return".bs.tooltip"}},{key:"DefaultType",get:function(){return Ut}}]),t}();o.default.fn.tooltip=Wt._jQueryInterface,o.default.fn.tooltip.Constructor=Wt,o.default.fn.tooltip.noConflict=function(){return o.default.fn.tooltip=Ot,Wt._jQueryInterface};var Vt="bs.popover",zt=o.default.fn.popover,Kt=new RegExp("(^|\\s)bs-popover\\S+","g"),Xt=r({},Wt.Default,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'}),Yt=r({},Wt.DefaultType,{content:"(string|element|function)"}),$t={HIDE:"hide.bs.popover",HIDDEN:"hidden.bs.popover",SHOW:"show.bs.popover",SHOWN:"shown.bs.popover",INSERTED:"inserted.bs.popover",CLICK:"click.bs.popover",FOCUSIN:"focusin.bs.popover",FOCUSOUT:"focusout.bs.popover",MOUSEENTER:"mouseenter.bs.popover",MOUSELEAVE:"mouseleave.bs.popover"},Jt=function(t){var e,n;function i(){return t.apply(this,arguments)||this}n=t,(e=i).prototype=Object.create(n.prototype),e.prototype.constructor=e,u(e,n);var a=i.prototype;return a.isWithContent=function(){return this.getTitle()||this._getContent()},a.addAttachmentClass=function(t){o.default(this.getTipElement()).addClass("bs-popover-"+t)},a.getTipElement=function(){return this.tip=this.tip||o.default(this.config.template)[0],this.tip},a.setContent=function(){var t=o.default(this.getTipElement());this.setElementContent(t.find(".popover-header"),this.getTitle());var e=this._getContent();"function"==typeof e&&(e=e.call(this.element)),this.setElementContent(t.find(".popover-body"),e),t.removeClass("fade show")},a._getContent=function(){return this.element.getAttribute("data-content")||this.config.content},a._cleanTipClass=function(){var t=o.default(this.getTipElement()),e=t.attr("class").match(Kt);null!==e&&e.length>0&&t.removeClass(e.join(""))},i._jQueryInterface=function(t){return this.each((function(){var e=o.default(this).data(Vt),n="object"==typeof t?t:null;if((e||!/dispose|hide/.test(t))&&(e||(e=new i(this,n),o.default(this).data(Vt,e)),"string"==typeof t)){if("undefined"==typeof e[t])throw new TypeError('No method named "'+t+'"');e[t]()}}))},l(i,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"Default",get:function(){return Xt}},{key:"NAME",get:function(){return"popover"}},{key:"DATA_KEY",get:function(){return Vt}},{key:"Event",get:function(){return $t}},{key:"EVENT_KEY",get:function(){return".bs.popover"}},{key:"DefaultType",get:function(){return Yt}}]),i}(Wt);o.default.fn.popover=Jt._jQueryInterface,o.default.fn.popover.Constructor=Jt,o.default.fn.popover.noConflict=function(){return o.default.fn.popover=zt,Jt._jQueryInterface};var Gt="scrollspy",Zt="bs.scrollspy",te=o.default.fn[Gt],ee="active",ne="position",ie=".nav, .list-group",oe={offset:10,method:"auto",target:""},ae={offset:"number",method:"string",target:"(string|element)"},se=function(){function t(t,e){var n=this;this._element=t,this._scrollElement="BODY"===t.tagName?window:t,this._config=this._getConfig(e),this._selector=this._config.target+" .nav-link,"+this._config.target+" .list-group-item,"+this._config.target+" .dropdown-item",this._offsets=[],this._targets=[],this._activeTarget=null,this._scrollHeight=0,o.default(this._scrollElement).on("scroll.bs.scrollspy",(function(t){return n._process(t)})),this.refresh(),this._process()}var e=t.prototype;return e.refresh=function(){var t=this,e=this._scrollElement===this._scrollElement.window?"offset":ne,n="auto"===this._config.method?e:this._config.method,i=n===ne?this._getScrollTop():0;this._offsets=[],this._targets=[],this._scrollHeight=this._getScrollHeight(),[].slice.call(document.querySelectorAll(this._selector)).map((function(t){var e,a=d.getSelectorFromElement(t);if(a&&(e=document.querySelector(a)),e){var s=e.getBoundingClientRect();if(s.width||s.height)return[o.default(e)[n]().top+i,a]}return null})).filter(Boolean).sort((function(t,e){return t[0]-e[0]})).forEach((function(e){t._offsets.push(e[0]),t._targets.push(e[1])}))},e.dispose=function(){o.default.removeData(this._element,Zt),o.default(this._scrollElement).off(".bs.scrollspy"),this._element=null,this._scrollElement=null,this._config=null,this._selector=null,this._offsets=null,this._targets=null,this._activeTarget=null,this._scrollHeight=null},e._getConfig=function(t){if("string"!=typeof(t=r({},oe,"object"==typeof t&&t?t:{})).target&&d.isElement(t.target)){var e=o.default(t.target).attr("id");e||(e=d.getUID(Gt),o.default(t.target).attr("id",e)),t.target="#"+e}return d.typeCheckConfig(Gt,t,ae),t},e._getScrollTop=function(){return this._scrollElement===window?this._scrollElement.pageYOffset:this._scrollElement.scrollTop},e._getScrollHeight=function(){return this._scrollElement.scrollHeight||Math.max(document.body.scrollHeight,document.documentElement.scrollHeight)},e._getOffsetHeight=function(){return this._scrollElement===window?window.innerHeight:this._scrollElement.getBoundingClientRect().height},e._process=function(){var t=this._getScrollTop()+this._config.offset,e=this._getScrollHeight(),n=this._config.offset+e-this._getOffsetHeight();if(this._scrollHeight!==e&&this.refresh(),t>=n){var i=this._targets[this._targets.length-1];this._activeTarget!==i&&this._activate(i)}else{if(this._activeTarget&&t<this._offsets[0]&&this._offsets[0]>0)return this._activeTarget=null,void this._clear();for(var o=this._offsets.length;o--;)this._activeTarget!==this._targets[o]&&t>=this._offsets[o]&&("undefined"==typeof this._offsets[o+1]||t<this._offsets[o+1])&&this._activate(this._targets[o])}},e._activate=function(t){this._activeTarget=t,this._clear();var e=this._selector.split(",").map((function(e){return e+'[data-target="'+t+'"],'+e+'[href="'+t+'"]'})),n=o.default([].slice.call(document.querySelectorAll(e.join(","))));n.hasClass("dropdown-item")?(n.closest(".dropdown").find(".dropdown-toggle").addClass(ee),n.addClass(ee)):(n.addClass(ee),n.parents(ie).prev(".nav-link, .list-group-item").addClass(ee),n.parents(ie).prev(".nav-item").children(".nav-link").addClass(ee)),o.default(this._scrollElement).trigger("activate.bs.scrollspy",{relatedTarget:t})},e._clear=function(){[].slice.call(document.querySelectorAll(this._selector)).filter((function(t){return t.classList.contains(ee)})).forEach((function(t){return t.classList.remove(ee)}))},t._jQueryInterface=function(e){return this.each((function(){var n=o.default(this).data(Zt);if(n||(n=new t(this,"object"==typeof e&&e),o.default(this).data(Zt,n)),"string"==typeof e){if("undefined"==typeof n[e])throw new TypeError('No method named "'+e+'"');n[e]()}}))},l(t,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"Default",get:function(){return oe}}]),t}();o.default(window).on("load.bs.scrollspy.data-api",(function(){for(var t=[].slice.call(document.querySelectorAll('[data-spy="scroll"]')),e=t.length;e--;){var n=o.default(t[e]);se._jQueryInterface.call(n,n.data())}})),o.default.fn[Gt]=se._jQueryInterface,o.default.fn[Gt].Constructor=se,o.default.fn[Gt].noConflict=function(){return o.default.fn[Gt]=te,se._jQueryInterface};var le="bs.tab",re=o.default.fn.tab,ue="active",fe="fade",de="show",ce=".active",he="> li > .active",ge=function(){function t(t){this._element=t}var e=t.prototype;return e.show=function(){var t=this;if(!(this._element.parentNode&&this._element.parentNode.nodeType===Node.ELEMENT_NODE&&o.default(this._element).hasClass(ue)||o.default(this._element).hasClass("disabled")||this._element.hasAttribute("disabled"))){var e,n,i=o.default(this._element).closest(".nav, .list-group")[0],a=d.getSelectorFromElement(this._element);if(i){var s="UL"===i.nodeName||"OL"===i.nodeName?he:ce;n=(n=o.default.makeArray(o.default(i).find(s)))[n.length-1]}var l=o.default.Event("hide.bs.tab",{relatedTarget:this._element}),r=o.default.Event("show.bs.tab",{relatedTarget:n});if(n&&o.default(n).trigger(l),o.default(this._element).trigger(r),!r.isDefaultPrevented()&&!l.isDefaultPrevented()){a&&(e=document.querySelector(a)),this._activate(this._element,i);var u=function(){var e=o.default.Event("hidden.bs.tab",{relatedTarget:t._element}),i=o.default.Event("shown.bs.tab",{relatedTarget:n});o.default(n).trigger(e),o.default(t._element).trigger(i)};e?this._activate(e,e.parentNode,u):u()}}},e.dispose=function(){o.default.removeData(this._element,le),this._element=null},e._activate=function(t,e,n){var i=this,a=(!e||"UL"!==e.nodeName&&"OL"!==e.nodeName?o.default(e).children(ce):o.default(e).find(he))[0],s=n&&a&&o.default(a).hasClass(fe),l=function(){return i._transitionComplete(t,a,n)};if(a&&s){var r=d.getTransitionDurationFromElement(a);o.default(a).removeClass(de).one(d.TRANSITION_END,l).emulateTransitionEnd(r)}else l()},e._transitionComplete=function(t,e,n){if(e){o.default(e).removeClass(ue);var i=o.default(e.parentNode).find("> .dropdown-menu .active")[0];i&&o.default(i).removeClass(ue),"tab"===e.getAttribute("role")&&e.setAttribute("aria-selected",!1)}o.default(t).addClass(ue),"tab"===t.getAttribute("role")&&t.setAttribute("aria-selected",!0),d.reflow(t),t.classList.contains(fe)&&t.classList.add(de);var a=t.parentNode;if(a&&"LI"===a.nodeName&&(a=a.parentNode),a&&o.default(a).hasClass("dropdown-menu")){var s=o.default(t).closest(".dropdown")[0];if(s){var l=[].slice.call(s.querySelectorAll(".dropdown-toggle"));o.default(l).addClass(ue)}t.setAttribute("aria-expanded",!0)}n&&n()},t._jQueryInterface=function(e){return this.each((function(){var n=o.default(this),i=n.data(le);if(i||(i=new t(this),n.data(le,i)),"string"==typeof e){if("undefined"==typeof i[e])throw new TypeError('No method named "'+e+'"');i[e]()}}))},l(t,null,[{key:"VERSION",get:function(){return"4.6.2"}}]),t}();o.default(document).on("click.bs.tab.data-api",'[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',(function(t){t.preventDefault(),ge._jQueryInterface.call(o.default(this),"show")})),o.default.fn.tab=ge._jQueryInterface,o.default.fn.tab.Constructor=ge,o.default.fn.tab.noConflict=function(){return o.default.fn.tab=re,ge._jQueryInterface};var me="bs.toast",pe=o.default.fn.toast,_e="hide",ve="show",ye="showing",be="click.dismiss.bs.toast",Ee={animation:!0,autohide:!0,delay:500},Te={animation:"boolean",autohide:"boolean",delay:"number"},we=function(){function t(t,e){this._element=t,this._config=this._getConfig(e),this._timeout=null,this._setListeners()}var e=t.prototype;return e.show=function(){var t=this,e=o.default.Event("show.bs.toast");if(o.default(this._element).trigger(e),!e.isDefaultPrevented()){this._clearTimeout(),this._config.animation&&this._element.classList.add("fade");var n=function(){t._element.classList.remove(ye),t._element.classList.add(ve),o.default(t._element).trigger("shown.bs.toast"),t._config.autohide&&(t._timeout=setTimeout((function(){t.hide()}),t._config.delay))};if(this._element.classList.remove(_e),d.reflow(this._element),this._element.classList.add(ye),this._config.animation){var i=d.getTransitionDurationFromElement(this._element);o.default(this._element).one(d.TRANSITION_END,n).emulateTransitionEnd(i)}else n()}},e.hide=function(){if(this._element.classList.contains(ve)){var t=o.default.Event("hide.bs.toast");o.default(this._element).trigger(t),t.isDefaultPrevented()||this._close()}},e.dispose=function(){this._clearTimeout(),this._element.classList.contains(ve)&&this._element.classList.remove(ve),o.default(this._element).off(be),o.default.removeData(this._element,me),this._element=null,this._config=null},e._getConfig=function(t){return t=r({},Ee,o.default(this._element).data(),"object"==typeof t&&t?t:{}),d.typeCheckConfig("toast",t,this.constructor.DefaultType),t},e._setListeners=function(){var t=this;o.default(this._element).on(be,'[data-dismiss="toast"]',(function(){return t.hide()}))},e._close=function(){var t=this,e=function(){t._element.classList.add(_e),o.default(t._element).trigger("hidden.bs.toast")};if(this._element.classList.remove(ve),this._config.animation){var n=d.getTransitionDurationFromElement(this._element);o.default(this._element).one(d.TRANSITION_END,e).emulateTransitionEnd(n)}else e()},e._clearTimeout=function(){clearTimeout(this._timeout),this._timeout=null},t._jQueryInterface=function(e){return this.each((function(){var n=o.default(this),i=n.data(me);if(i||(i=new t(this,"object"==typeof e&&e),n.data(me,i)),"string"==typeof e){if("undefined"==typeof i[e])throw new TypeError('No method named "'+e+'"');i[e](this)}}))},l(t,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"DefaultType",get:function(){return Te}},{key:"Default",get:function(){return Ee}}]),t}();o.default.fn.toast=we._jQueryInterface,o.default.fn.toast.Constructor=we,o.default.fn.toast.noConflict=function(){return o.default.fn.toast=pe,we._jQueryInterface},t.Alert=g,t.Button=E,t.Carousel=P,t.Collapse=V,t.Dropdown=lt,t.Modal=Ct,t.Popover=Jt,t.Scrollspy=se,t.Tab=ge,t.Toast=we,t.Tooltip=Wt,t.Util=d,Object.defineProperty(t,"__esModule",{value:!0})}));
//# sourceMappingURL=bootstrap.min.js.map
/*! DataTables 1.13.11
 * ©2008-2024 SpryMedia Ltd - datatables.net/license
 */

/**
 * @summary     DataTables
 * @description Paginate, search and order HTML tables
 * @version     1.13.11
 * @author      SpryMedia Ltd
 * @contact     www.datatables.net
 * @copyright   SpryMedia Ltd.
 *
 * This source file is free software, available under the following license:
 *   MIT license - https://datatables.net/license
 *
 * This source file is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
 *
 * For details please refer to: https://www.datatables.net
 */

/*jslint evil: true, undef: true, browser: true */
/*globals $,require,jQuery,define,_selector_run,_selector_opts,_selector_first,_selector_row_indexes,_ext,_Api,_api_register,_api_registerPlural,_re_new_lines,_re_html,_re_formatted_numeric,_re_escape_regex,_empty,_intVal,_numToDecimal,_isNumber,_isHtml,_htmlNumeric,_pluck,_pluck_order,_range,_stripHtml,_unique,_fnBuildAjax,_fnAjaxUpdate,_fnAjaxParameters,_fnAjaxUpdateDraw,_fnAjaxDataSrc,_fnAddColumn,_fnColumnOptions,_fnAdjustColumnSizing,_fnVisibleToColumnIndex,_fnColumnIndexToVisible,_fnVisbleColumns,_fnGetColumns,_fnColumnTypes,_fnApplyColumnDefs,_fnHungarianMap,_fnCamelToHungarian,_fnLanguageCompat,_fnBrowserDetect,_fnAddData,_fnAddTr,_fnNodeToDataIndex,_fnNodeToColumnIndex,_fnGetCellData,_fnSetCellData,_fnSplitObjNotation,_fnGetObjectDataFn,_fnSetObjectDataFn,_fnGetDataMaster,_fnClearTable,_fnDeleteIndex,_fnInvalidate,_fnGetRowElements,_fnCreateTr,_fnBuildHead,_fnDrawHead,_fnDraw,_fnReDraw,_fnAddOptionsHtml,_fnDetectHeader,_fnGetUniqueThs,_fnFeatureHtmlFilter,_fnFilterComplete,_fnFilterCustom,_fnFilterColumn,_fnFilter,_fnFilterCreateSearch,_fnEscapeRegex,_fnFilterData,_fnFeatureHtmlInfo,_fnUpdateInfo,_fnInfoMacros,_fnInitialise,_fnInitComplete,_fnLengthChange,_fnFeatureHtmlLength,_fnFeatureHtmlPaginate,_fnPageChange,_fnFeatureHtmlProcessing,_fnProcessingDisplay,_fnFeatureHtmlTable,_fnScrollDraw,_fnApplyToChildren,_fnCalculateColumnWidths,_fnThrottle,_fnConvertToWidth,_fnGetWidestNode,_fnGetMaxLenString,_fnStringToCss,_fnSortFlatten,_fnSort,_fnSortAria,_fnSortListener,_fnSortAttachListener,_fnSortingClasses,_fnSortData,_fnSaveState,_fnLoadState,_fnSettingsFromNode,_fnLog,_fnMap,_fnBindAction,_fnCallbackReg,_fnCallbackFire,_fnLengthOverflow,_fnRenderer,_fnDataSource,_fnRowAttributes*/

(function( factory ) {
	"use strict";

	if ( typeof define === 'function' && define.amd ) {
		// AMD
		define( ['jquery'], function ( $ ) {
			return factory( $, window, document );
		} );
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		// jQuery's factory checks for a global window - if it isn't present then it
		// returns a factory function that expects the window object
		var jq = require('jquery');

		if (typeof window === 'undefined') {
			module.exports = function (root, $) {
				if ( ! root ) {
					// CommonJS environments without a window global must pass a
					// root. This will give an error otherwise
					root = window;
				}

				if ( ! $ ) {
					$ = jq( root );
				}

				return factory( $, root, root.document );
			};
		}
		else {
			module.exports = factory( jq, window, window.document );
		}
	}
	else {
		// Browser
		window.DataTable = factory( jQuery, window, document );
	}
}
(function( $, window, document, undefined ) {
	"use strict";

	
	var DataTable = function ( selector, options )
	{
		// Check if called with a window or jQuery object for DOM less applications
		// This is for backwards compatibility
		if (DataTable.factory(selector, options)) {
			return DataTable;
		}
	
		// When creating with `new`, create a new DataTable, returning the API instance
		if (this instanceof DataTable) {
			return $(selector).DataTable(options);
		}
		else {
			// Argument switching
			options = selector;
		}
	
		/**
		 * Perform a jQuery selector action on the table's TR elements (from the tbody) and
		 * return the resulting jQuery object.
		 *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
		 *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
		 *  @param {string} [oOpts.filter=none] Select TR elements that meet the current filter
		 *    criterion ("applied") or all TR elements (i.e. no filter).
		 *  @param {string} [oOpts.order=current] Order of the TR elements in the processed array.
		 *    Can be either 'current', whereby the current sorting of the table is used, or
		 *    'original' whereby the original order the data was read into the table is used.
		 *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
		 *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
		 *    'current' and filter is 'applied', regardless of what they might be given as.
		 *  @returns {object} jQuery object, filtered by the given selector.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Highlight every second row
		 *      oTable.$('tr:odd').css('backgroundColor', 'blue');
		 *    } );
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Filter to rows with 'Webkit' in them, add a background colour and then
		 *      // remove the filter, thus highlighting the 'Webkit' rows only.
		 *      oTable.fnFilter('Webkit');
		 *      oTable.$('tr', {"search": "applied"}).css('backgroundColor', 'blue');
		 *      oTable.fnFilter('');
		 *    } );
		 */
		this.$ = function ( sSelector, oOpts )
		{
			return this.api(true).$( sSelector, oOpts );
		};
		
		
		/**
		 * Almost identical to $ in operation, but in this case returns the data for the matched
		 * rows - as such, the jQuery selector used should match TR row nodes or TD/TH cell nodes
		 * rather than any descendants, so the data can be obtained for the row/cell. If matching
		 * rows are found, the data returned is the original data array/object that was used to
		 * create the row (or a generated array if from a DOM source).
		 *
		 * This method is often useful in-combination with $ where both functions are given the
		 * same parameters and the array indexes will match identically.
		 *  @param {string|node|jQuery} sSelector jQuery selector or node collection to act on
		 *  @param {object} [oOpts] Optional parameters for modifying the rows to be included
		 *  @param {string} [oOpts.filter=none] Select elements that meet the current filter
		 *    criterion ("applied") or all elements (i.e. no filter).
		 *  @param {string} [oOpts.order=current] Order of the data in the processed array.
		 *    Can be either 'current', whereby the current sorting of the table is used, or
		 *    'original' whereby the original order the data was read into the table is used.
		 *  @param {string} [oOpts.page=all] Limit the selection to the currently displayed page
		 *    ("current") or not ("all"). If 'current' is given, then order is assumed to be
		 *    'current' and filter is 'applied', regardless of what they might be given as.
		 *  @returns {array} Data for the matched elements. If any elements, as a result of the
		 *    selector, were not TR, TD or TH elements in the DataTable, they will have a null
		 *    entry in the array.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Get the data from the first row in the table
		 *      var data = oTable._('tr:first');
		 *
		 *      // Do something useful with the data
		 *      alert( "First cell is: "+data[0] );
		 *    } );
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Filter to 'Webkit' and get all data for
		 *      oTable.fnFilter('Webkit');
		 *      var data = oTable._('tr', {"search": "applied"});
		 *
		 *      // Do something with the data
		 *      alert( data.length+" rows matched the search" );
		 *    } );
		 */
		this._ = function ( sSelector, oOpts )
		{
			return this.api(true).rows( sSelector, oOpts ).data();
		};
		
		
		/**
		 * Create a DataTables Api instance, with the currently selected tables for
		 * the Api's context.
		 * @param {boolean} [traditional=false] Set the API instance's context to be
		 *   only the table referred to by the `DataTable.ext.iApiIndex` option, as was
		 *   used in the API presented by DataTables 1.9- (i.e. the traditional mode),
		 *   or if all tables captured in the jQuery object should be used.
		 * @return {DataTables.Api}
		 */
		this.api = function ( traditional )
		{
			return traditional ?
				new _Api(
					_fnSettingsFromNode( this[ _ext.iApiIndex ] )
				) :
				new _Api( this );
		};
		
		
		/**
		 * Add a single new row or multiple rows of data to the table. Please note
		 * that this is suitable for client-side processing only - if you are using
		 * server-side processing (i.e. "bServerSide": true), then to add data, you
		 * must add it to the data source, i.e. the server-side, through an Ajax call.
		 *  @param {array|object} data The data to be added to the table. This can be:
		 *    <ul>
		 *      <li>1D array of data - add a single row with the data provided</li>
		 *      <li>2D array of arrays - add multiple rows in a single call</li>
		 *      <li>object - data object when using <i>mData</i></li>
		 *      <li>array of objects - multiple data objects when using <i>mData</i></li>
		 *    </ul>
		 *  @param {bool} [redraw=true] redraw the table or not
		 *  @returns {array} An array of integers, representing the list of indexes in
		 *    <i>aoData</i> ({@link DataTable.models.oSettings}) that have been added to
		 *    the table.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    // Global var for counter
		 *    var giCount = 2;
		 *
		 *    $(document).ready(function() {
		 *      $('#example').dataTable();
		 *    } );
		 *
		 *    function fnClickAddRow() {
		 *      $('#example').dataTable().fnAddData( [
		 *        giCount+".1",
		 *        giCount+".2",
		 *        giCount+".3",
		 *        giCount+".4" ]
		 *      );
		 *
		 *      giCount++;
		 *    }
		 */
		this.fnAddData = function( data, redraw )
		{
			var api = this.api( true );
		
			/* Check if we want to add multiple rows or not */
			var rows = Array.isArray(data) && ( Array.isArray(data[0]) || $.isPlainObject(data[0]) ) ?
				api.rows.add( data ) :
				api.row.add( data );
		
			if ( redraw === undefined || redraw ) {
				api.draw();
			}
		
			return rows.flatten().toArray();
		};
		
		
		/**
		 * This function will make DataTables recalculate the column sizes, based on the data
		 * contained in the table and the sizes applied to the columns (in the DOM, CSS or
		 * through the sWidth parameter). This can be useful when the width of the table's
		 * parent element changes (for example a window resize).
		 *  @param {boolean} [bRedraw=true] Redraw the table or not, you will typically want to
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable( {
		 *        "sScrollY": "200px",
		 *        "bPaginate": false
		 *      } );
		 *
		 *      $(window).on('resize', function () {
		 *        oTable.fnAdjustColumnSizing();
		 *      } );
		 *    } );
		 */
		this.fnAdjustColumnSizing = function ( bRedraw )
		{
			var api = this.api( true ).columns.adjust();
			var settings = api.settings()[0];
			var scroll = settings.oScroll;
		
			if ( bRedraw === undefined || bRedraw ) {
				api.draw( false );
			}
			else if ( scroll.sX !== "" || scroll.sY !== "" ) {
				/* If not redrawing, but scrolling, we want to apply the new column sizes anyway */
				_fnScrollDraw( settings );
			}
		};
		
		
		/**
		 * Quickly and simply clear a table
		 *  @param {bool} [bRedraw=true] redraw the table or not
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Immediately 'nuke' the current rows (perhaps waiting for an Ajax callback...)
		 *      oTable.fnClearTable();
		 *    } );
		 */
		this.fnClearTable = function( bRedraw )
		{
			var api = this.api( true ).clear();
		
			if ( bRedraw === undefined || bRedraw ) {
				api.draw();
			}
		};
		
		
		/**
		 * The exact opposite of 'opening' a row, this function will close any rows which
		 * are currently 'open'.
		 *  @param {node} nTr the table row to 'close'
		 *  @returns {int} 0 on success, or 1 if failed (can't find the row)
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable;
		 *
		 *      // 'open' an information row when a row is clicked on
		 *      $('#example tbody tr').click( function () {
		 *        if ( oTable.fnIsOpen(this) ) {
		 *          oTable.fnClose( this );
		 *        } else {
		 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
		 *        }
		 *      } );
		 *
		 *      oTable = $('#example').dataTable();
		 *    } );
		 */
		this.fnClose = function( nTr )
		{
			this.api( true ).row( nTr ).child.hide();
		};
		
		
		/**
		 * Remove a row for the table
		 *  @param {mixed} target The index of the row from aoData to be deleted, or
		 *    the TR element you want to delete
		 *  @param {function|null} [callBack] Callback function
		 *  @param {bool} [redraw=true] Redraw the table or not
		 *  @returns {array} The row that was deleted
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Immediately remove the first row
		 *      oTable.fnDeleteRow( 0 );
		 *    } );
		 */
		this.fnDeleteRow = function( target, callback, redraw )
		{
			var api = this.api( true );
			var rows = api.rows( target );
			var settings = rows.settings()[0];
			var data = settings.aoData[ rows[0][0] ];
		
			rows.remove();
		
			if ( callback ) {
				callback.call( this, settings, data );
			}
		
			if ( redraw === undefined || redraw ) {
				api.draw();
			}
		
			return data;
		};
		
		
		/**
		 * Restore the table to it's original state in the DOM by removing all of DataTables
		 * enhancements, alterations to the DOM structure of the table and event listeners.
		 *  @param {boolean} [remove=false] Completely remove the table from the DOM
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      // This example is fairly pointless in reality, but shows how fnDestroy can be used
		 *      var oTable = $('#example').dataTable();
		 *      oTable.fnDestroy();
		 *    } );
		 */
		this.fnDestroy = function ( remove )
		{
			this.api( true ).destroy( remove );
		};
		
		
		/**
		 * Redraw the table
		 *  @param {bool} [complete=true] Re-filter and resort (if enabled) the table before the draw.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Re-draw the table - you wouldn't want to do it here, but it's an example :-)
		 *      oTable.fnDraw();
		 *    } );
		 */
		this.fnDraw = function( complete )
		{
			// Note that this isn't an exact match to the old call to _fnDraw - it takes
			// into account the new data, but can hold position.
			this.api( true ).draw( complete );
		};
		
		
		/**
		 * Filter the input based on data
		 *  @param {string} sInput String to filter the table on
		 *  @param {int|null} [iColumn] Column to limit filtering to
		 *  @param {bool} [bRegex=false] Treat as regular expression or not
		 *  @param {bool} [bSmart=true] Perform smart filtering or not
		 *  @param {bool} [bShowGlobal=true] Show the input global filter in it's input box(es)
		 *  @param {bool} [bCaseInsensitive=true] Do case-insensitive matching (true) or not (false)
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Sometime later - filter...
		 *      oTable.fnFilter( 'test string' );
		 *    } );
		 */
		this.fnFilter = function( sInput, iColumn, bRegex, bSmart, bShowGlobal, bCaseInsensitive )
		{
			var api = this.api( true );
		
			if ( iColumn === null || iColumn === undefined ) {
				api.search( sInput, bRegex, bSmart, bCaseInsensitive );
			}
			else {
				api.column( iColumn ).search( sInput, bRegex, bSmart, bCaseInsensitive );
			}
		
			api.draw();
		};
		
		
		/**
		 * Get the data for the whole table, an individual row or an individual cell based on the
		 * provided parameters.
		 *  @param {int|node} [src] A TR row node, TD/TH cell node or an integer. If given as
		 *    a TR node then the data source for the whole row will be returned. If given as a
		 *    TD/TH cell node then iCol will be automatically calculated and the data for the
		 *    cell returned. If given as an integer, then this is treated as the aoData internal
		 *    data index for the row (see fnGetPosition) and the data for that row used.
		 *  @param {int} [col] Optional column index that you want the data of.
		 *  @returns {array|object|string} If mRow is undefined, then the data for all rows is
		 *    returned. If mRow is defined, just data for that row, and is iCol is
		 *    defined, only data for the designated cell is returned.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    // Row data
		 *    $(document).ready(function() {
		 *      oTable = $('#example').dataTable();
		 *
		 *      oTable.$('tr').click( function () {
		 *        var data = oTable.fnGetData( this );
		 *        // ... do something with the array / object of data for the row
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Individual cell data
		 *    $(document).ready(function() {
		 *      oTable = $('#example').dataTable();
		 *
		 *      oTable.$('td').click( function () {
		 *        var sData = oTable.fnGetData( this );
		 *        alert( 'The cell clicked on had the value of '+sData );
		 *      } );
		 *    } );
		 */
		this.fnGetData = function( src, col )
		{
			var api = this.api( true );
		
			if ( src !== undefined ) {
				var type = src.nodeName ? src.nodeName.toLowerCase() : '';
		
				return col !== undefined || type == 'td' || type == 'th' ?
					api.cell( src, col ).data() :
					api.row( src ).data() || null;
			}
		
			return api.data().toArray();
		};
		
		
		/**
		 * Get an array of the TR nodes that are used in the table's body. Note that you will
		 * typically want to use the '$' API method in preference to this as it is more
		 * flexible.
		 *  @param {int} [iRow] Optional row index for the TR element you want
		 *  @returns {array|node} If iRow is undefined, returns an array of all TR elements
		 *    in the table's body, or iRow is defined, just the TR element requested.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Get the nodes from the table
		 *      var nNodes = oTable.fnGetNodes( );
		 *    } );
		 */
		this.fnGetNodes = function( iRow )
		{
			var api = this.api( true );
		
			return iRow !== undefined ?
				api.row( iRow ).node() :
				api.rows().nodes().flatten().toArray();
		};
		
		
		/**
		 * Get the array indexes of a particular cell from it's DOM element
		 * and column index including hidden columns
		 *  @param {node} node this can either be a TR, TD or TH in the table's body
		 *  @returns {int} If nNode is given as a TR, then a single index is returned, or
		 *    if given as a cell, an array of [row index, column index (visible),
		 *    column index (all)] is given.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      $('#example tbody td').click( function () {
		 *        // Get the position of the current data from the node
		 *        var aPos = oTable.fnGetPosition( this );
		 *
		 *        // Get the data array for this row
		 *        var aData = oTable.fnGetData( aPos[0] );
		 *
		 *        // Update the data array and return the value
		 *        aData[ aPos[1] ] = 'clicked';
		 *        this.innerHTML = 'clicked';
		 *      } );
		 *
		 *      // Init DataTables
		 *      oTable = $('#example').dataTable();
		 *    } );
		 */
		this.fnGetPosition = function( node )
		{
			var api = this.api( true );
			var nodeName = node.nodeName.toUpperCase();
		
			if ( nodeName == 'TR' ) {
				return api.row( node ).index();
			}
			else if ( nodeName == 'TD' || nodeName == 'TH' ) {
				var cell = api.cell( node ).index();
		
				return [
					cell.row,
					cell.columnVisible,
					cell.column
				];
			}
			return null;
		};
		
		
		/**
		 * Check to see if a row is 'open' or not.
		 *  @param {node} nTr the table row to check
		 *  @returns {boolean} true if the row is currently open, false otherwise
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable;
		 *
		 *      // 'open' an information row when a row is clicked on
		 *      $('#example tbody tr').click( function () {
		 *        if ( oTable.fnIsOpen(this) ) {
		 *          oTable.fnClose( this );
		 *        } else {
		 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
		 *        }
		 *      } );
		 *
		 *      oTable = $('#example').dataTable();
		 *    } );
		 */
		this.fnIsOpen = function( nTr )
		{
			return this.api( true ).row( nTr ).child.isShown();
		};
		
		
		/**
		 * This function will place a new row directly after a row which is currently
		 * on display on the page, with the HTML contents that is passed into the
		 * function. This can be used, for example, to ask for confirmation that a
		 * particular record should be deleted.
		 *  @param {node} nTr The table row to 'open'
		 *  @param {string|node|jQuery} mHtml The HTML to put into the row
		 *  @param {string} sClass Class to give the new TD cell
		 *  @returns {node} The row opened. Note that if the table row passed in as the
		 *    first parameter, is not found in the table, this method will silently
		 *    return.
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable;
		 *
		 *      // 'open' an information row when a row is clicked on
		 *      $('#example tbody tr').click( function () {
		 *        if ( oTable.fnIsOpen(this) ) {
		 *          oTable.fnClose( this );
		 *        } else {
		 *          oTable.fnOpen( this, "Temporary row opened", "info_row" );
		 *        }
		 *      } );
		 *
		 *      oTable = $('#example').dataTable();
		 *    } );
		 */
		this.fnOpen = function( nTr, mHtml, sClass )
		{
			return this.api( true )
				.row( nTr )
				.child( mHtml, sClass )
				.show()
				.child()[0];
		};
		
		
		/**
		 * Change the pagination - provides the internal logic for pagination in a simple API
		 * function. With this function you can have a DataTables table go to the next,
		 * previous, first or last pages.
		 *  @param {string|int} mAction Paging action to take: "first", "previous", "next" or "last"
		 *    or page number to jump to (integer), note that page 0 is the first page.
		 *  @param {bool} [bRedraw=true] Redraw the table or not
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *      oTable.fnPageChange( 'next' );
		 *    } );
		 */
		this.fnPageChange = function ( mAction, bRedraw )
		{
			var api = this.api( true ).page( mAction );
		
			if ( bRedraw === undefined || bRedraw ) {
				api.draw(false);
			}
		};
		
		
		/**
		 * Show a particular column
		 *  @param {int} iCol The column whose display should be changed
		 *  @param {bool} bShow Show (true) or hide (false) the column
		 *  @param {bool} [bRedraw=true] Redraw the table or not
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Hide the second column after initialisation
		 *      oTable.fnSetColumnVis( 1, false );
		 *    } );
		 */
		this.fnSetColumnVis = function ( iCol, bShow, bRedraw )
		{
			var api = this.api( true ).column( iCol ).visible( bShow );
		
			if ( bRedraw === undefined || bRedraw ) {
				api.columns.adjust().draw();
			}
		};
		
		
		/**
		 * Get the settings for a particular table for external manipulation
		 *  @returns {object} DataTables settings object. See
		 *    {@link DataTable.models.oSettings}
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *      var oSettings = oTable.fnSettings();
		 *
		 *      // Show an example parameter from the settings
		 *      alert( oSettings._iDisplayStart );
		 *    } );
		 */
		this.fnSettings = function()
		{
			return _fnSettingsFromNode( this[_ext.iApiIndex] );
		};
		
		
		/**
		 * Sort the table by a particular column
		 *  @param {int} iCol the data index to sort on. Note that this will not match the
		 *    'display index' if you have hidden data entries
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Sort immediately with columns 0 and 1
		 *      oTable.fnSort( [ [0,'asc'], [1,'asc'] ] );
		 *    } );
		 */
		this.fnSort = function( aaSort )
		{
			this.api( true ).order( aaSort ).draw();
		};
		
		
		/**
		 * Attach a sort listener to an element for a given column
		 *  @param {node} nNode the element to attach the sort listener to
		 *  @param {int} iColumn the column that a click on this node will sort on
		 *  @param {function} [fnCallback] callback function when sort is run
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *
		 *      // Sort on column 1, when 'sorter' is clicked on
		 *      oTable.fnSortListener( document.getElementById('sorter'), 1 );
		 *    } );
		 */
		this.fnSortListener = function( nNode, iColumn, fnCallback )
		{
			this.api( true ).order.listener( nNode, iColumn, fnCallback );
		};
		
		
		/**
		 * Update a table cell or row - this method will accept either a single value to
		 * update the cell with, an array of values with one element for each column or
		 * an object in the same format as the original data source. The function is
		 * self-referencing in order to make the multi column updates easier.
		 *  @param {object|array|string} mData Data to update the cell/row with
		 *  @param {node|int} mRow TR element you want to update or the aoData index
		 *  @param {int} [iColumn] The column to update, give as null or undefined to
		 *    update a whole row.
		 *  @param {bool} [bRedraw=true] Redraw the table or not
		 *  @param {bool} [bAction=true] Perform pre-draw actions or not
		 *  @returns {int} 0 on success, 1 on error
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *      oTable.fnUpdate( 'Example update', 0, 0 ); // Single cell
		 *      oTable.fnUpdate( ['a', 'b', 'c', 'd', 'e'], $('tbody tr')[0] ); // Row
		 *    } );
		 */
		this.fnUpdate = function( mData, mRow, iColumn, bRedraw, bAction )
		{
			var api = this.api( true );
		
			if ( iColumn === undefined || iColumn === null ) {
				api.row( mRow ).data( mData );
			}
			else {
				api.cell( mRow, iColumn ).data( mData );
			}
		
			if ( bAction === undefined || bAction ) {
				api.columns.adjust();
			}
		
			if ( bRedraw === undefined || bRedraw ) {
				api.draw();
			}
			return 0;
		};
		
		
		/**
		 * Provide a common method for plug-ins to check the version of DataTables being used, in order
		 * to ensure compatibility.
		 *  @param {string} sVersion Version string to check for, in the format "X.Y.Z". Note that the
		 *    formats "X" and "X.Y" are also acceptable.
		 *  @returns {boolean} true if this version of DataTables is greater or equal to the required
		 *    version, or false if this version of DataTales is not suitable
		 *  @method
		 *  @dtopt API
		 *  @deprecated Since v1.10
		 *
		 *  @example
		 *    $(document).ready(function() {
		 *      var oTable = $('#example').dataTable();
		 *      alert( oTable.fnVersionCheck( '1.9.0' ) );
		 *    } );
		 */
		this.fnVersionCheck = _ext.fnVersionCheck;
		
	
		var _that = this;
		var emptyInit = options === undefined;
		var len = this.length;
	
		if ( emptyInit ) {
			options = {};
		}
	
		this.oApi = this.internal = _ext.internal;
	
		// Extend with old style plug-in API methods
		for ( var fn in DataTable.ext.internal ) {
			if ( fn ) {
				this[fn] = _fnExternApiFunc(fn);
			}
		}
	
		this.each(function() {
			// For each initialisation we want to give it a clean initialisation
			// object that can be bashed around
			var o = {};
			var oInit = len > 1 ? // optimisation for single table case
				_fnExtend( o, options, true ) :
				options;
	
			/*global oInit,_that,emptyInit*/
			var i=0, iLen, j, jLen, k, kLen;
			var sId = this.getAttribute( 'id' );
			var bInitHandedOff = false;
			var defaults = DataTable.defaults;
			var $this = $(this);
			
			
			/* Sanity check */
			if ( this.nodeName.toLowerCase() != 'table' )
			{
				_fnLog( null, 0, 'Non-table node initialisation ('+this.nodeName+')', 2 );
				return;
			}
			
			/* Backwards compatibility for the defaults */
			_fnCompatOpts( defaults );
			_fnCompatCols( defaults.column );
			
			/* Convert the camel-case defaults to Hungarian */
			_fnCamelToHungarian( defaults, defaults, true );
			_fnCamelToHungarian( defaults.column, defaults.column, true );
			
			/* Setting up the initialisation object */
			_fnCamelToHungarian( defaults, $.extend( oInit, $this.data() ), true );
			
			
			
			/* Check to see if we are re-initialising a table */
			var allSettings = DataTable.settings;
			for ( i=0, iLen=allSettings.length ; i<iLen ; i++ )
			{
				var s = allSettings[i];
			
				/* Base check on table node */
				if (
					s.nTable == this ||
					(s.nTHead && s.nTHead.parentNode == this) ||
					(s.nTFoot && s.nTFoot.parentNode == this)
				) {
					var bRetrieve = oInit.bRetrieve !== undefined ? oInit.bRetrieve : defaults.bRetrieve;
					var bDestroy = oInit.bDestroy !== undefined ? oInit.bDestroy : defaults.bDestroy;
			
					if ( emptyInit || bRetrieve )
					{
						return s.oInstance;
					}
					else if ( bDestroy )
					{
						s.oInstance.fnDestroy();
						break;
					}
					else
					{
						_fnLog( s, 0, 'Cannot reinitialise DataTable', 3 );
						return;
					}
				}
			
				/* If the element we are initialising has the same ID as a table which was previously
				 * initialised, but the table nodes don't match (from before) then we destroy the old
				 * instance by simply deleting it. This is under the assumption that the table has been
				 * destroyed by other methods. Anyone using non-id selectors will need to do this manually
				 */
				if ( s.sTableId == this.id )
				{
					allSettings.splice( i, 1 );
					break;
				}
			}
			
			/* Ensure the table has an ID - required for accessibility */
			if ( sId === null || sId === "" )
			{
				sId = "DataTables_Table_"+(DataTable.ext._unique++);
				this.id = sId;
			}
			
			/* Create the settings object for this table and set some of the default parameters */
			var oSettings = $.extend( true, {}, DataTable.models.oSettings, {
				"sDestroyWidth": $this[0].style.width,
				"sInstance":     sId,
				"sTableId":      sId
			} );
			oSettings.nTable = this;
			oSettings.oApi   = _that.internal;
			oSettings.oInit  = oInit;
			
			allSettings.push( oSettings );
			
			// Need to add the instance after the instance after the settings object has been added
			// to the settings array, so we can self reference the table instance if more than one
			oSettings.oInstance = (_that.length===1) ? _that : $this.dataTable();
			
			// Backwards compatibility, before we apply all the defaults
			_fnCompatOpts( oInit );
			_fnLanguageCompat( oInit.oLanguage );
			
			// If the length menu is given, but the init display length is not, use the length menu
			if ( oInit.aLengthMenu && ! oInit.iDisplayLength )
			{
				oInit.iDisplayLength = Array.isArray( oInit.aLengthMenu[0] ) ?
					oInit.aLengthMenu[0][0] : oInit.aLengthMenu[0];
			}
			
			// Apply the defaults and init options to make a single init object will all
			// options defined from defaults and instance options.
			oInit = _fnExtend( $.extend( true, {}, defaults ), oInit );
			
			
			// Map the initialisation options onto the settings object
			_fnMap( oSettings.oFeatures, oInit, [
				"bPaginate",
				"bLengthChange",
				"bFilter",
				"bSort",
				"bSortMulti",
				"bInfo",
				"bProcessing",
				"bAutoWidth",
				"bSortClasses",
				"bServerSide",
				"bDeferRender"
			] );
			_fnMap( oSettings, oInit, [
				"asStripeClasses",
				"ajax",
				"fnServerData",
				"fnFormatNumber",
				"sServerMethod",
				"aaSorting",
				"aaSortingFixed",
				"aLengthMenu",
				"sPaginationType",
				"sAjaxSource",
				"sAjaxDataProp",
				"iStateDuration",
				"sDom",
				"bSortCellsTop",
				"iTabIndex",
				"fnStateLoadCallback",
				"fnStateSaveCallback",
				"renderer",
				"searchDelay",
				"rowId",
				[ "iCookieDuration", "iStateDuration" ], // backwards compat
				[ "oSearch", "oPreviousSearch" ],
				[ "aoSearchCols", "aoPreSearchCols" ],
				[ "iDisplayLength", "_iDisplayLength" ]
			] );
			_fnMap( oSettings.oScroll, oInit, [
				[ "sScrollX", "sX" ],
				[ "sScrollXInner", "sXInner" ],
				[ "sScrollY", "sY" ],
				[ "bScrollCollapse", "bCollapse" ]
			] );
			_fnMap( oSettings.oLanguage, oInit, "fnInfoCallback" );
			
			/* Callback functions which are array driven */
			_fnCallbackReg( oSettings, 'aoDrawCallback',       oInit.fnDrawCallback,      'user' );
			_fnCallbackReg( oSettings, 'aoServerParams',       oInit.fnServerParams,      'user' );
			_fnCallbackReg( oSettings, 'aoStateSaveParams',    oInit.fnStateSaveParams,   'user' );
			_fnCallbackReg( oSettings, 'aoStateLoadParams',    oInit.fnStateLoadParams,   'user' );
			_fnCallbackReg( oSettings, 'aoStateLoaded',        oInit.fnStateLoaded,       'user' );
			_fnCallbackReg( oSettings, 'aoRowCallback',        oInit.fnRowCallback,       'user' );
			_fnCallbackReg( oSettings, 'aoRowCreatedCallback', oInit.fnCreatedRow,        'user' );
			_fnCallbackReg( oSettings, 'aoHeaderCallback',     oInit.fnHeaderCallback,    'user' );
			_fnCallbackReg( oSettings, 'aoFooterCallback',     oInit.fnFooterCallback,    'user' );
			_fnCallbackReg( oSettings, 'aoInitComplete',       oInit.fnInitComplete,      'user' );
			_fnCallbackReg( oSettings, 'aoPreDrawCallback',    oInit.fnPreDrawCallback,   'user' );
			
			oSettings.rowIdFn = _fnGetObjectDataFn( oInit.rowId );
			
			/* Browser support detection */
			_fnBrowserDetect( oSettings );
			
			var oClasses = oSettings.oClasses;
			
			$.extend( oClasses, DataTable.ext.classes, oInit.oClasses );
			$this.addClass( oClasses.sTable );
			
			
			if ( oSettings.iInitDisplayStart === undefined )
			{
				/* Display start point, taking into account the save saving */
				oSettings.iInitDisplayStart = oInit.iDisplayStart;
				oSettings._iDisplayStart = oInit.iDisplayStart;
			}
			
			if ( oInit.iDeferLoading !== null )
			{
				oSettings.bDeferLoading = true;
				var tmp = Array.isArray( oInit.iDeferLoading );
				oSettings._iRecordsDisplay = tmp ? oInit.iDeferLoading[0] : oInit.iDeferLoading;
				oSettings._iRecordsTotal = tmp ? oInit.iDeferLoading[1] : oInit.iDeferLoading;
			}
			
			/* Language definitions */
			var oLanguage = oSettings.oLanguage;
			$.extend( true, oLanguage, oInit.oLanguage );
			
			if ( oLanguage.sUrl )
			{
				/* Get the language definitions from a file - because this Ajax call makes the language
				 * get async to the remainder of this function we use bInitHandedOff to indicate that
				 * _fnInitialise will be fired by the returned Ajax handler, rather than the constructor
				 */
				$.ajax( {
					dataType: 'json',
					url: oLanguage.sUrl,
					success: function ( json ) {
						_fnCamelToHungarian( defaults.oLanguage, json );
						_fnLanguageCompat( json );
						$.extend( true, oLanguage, json, oSettings.oInit.oLanguage );
			
						_fnCallbackFire( oSettings, null, 'i18n', [oSettings]);
						_fnInitialise( oSettings );
					},
					error: function () {
						// Error occurred loading language file, continue on as best we can
						_fnInitialise( oSettings );
					}
				} );
				bInitHandedOff = true;
			}
			else {
				_fnCallbackFire( oSettings, null, 'i18n', [oSettings]);
			}
			
			/*
			 * Stripes
			 */
			if ( oInit.asStripeClasses === null )
			{
				oSettings.asStripeClasses =[
					oClasses.sStripeOdd,
					oClasses.sStripeEven
				];
			}
			
			/* Remove row stripe classes if they are already on the table row */
			var stripeClasses = oSettings.asStripeClasses;
			var rowOne = $this.children('tbody').find('tr').eq(0);
			if ( $.inArray( true, $.map( stripeClasses, function(el, i) {
				return rowOne.hasClass(el);
			} ) ) !== -1 ) {
				$('tbody tr', this).removeClass( stripeClasses.join(' ') );
				oSettings.asDestroyStripes = stripeClasses.slice();
			}
			
			/*
			 * Columns
			 * See if we should load columns automatically or use defined ones
			 */
			var anThs = [];
			var aoColumnsInit;
			var nThead = this.getElementsByTagName('thead');
			if ( nThead.length !== 0 )
			{
				_fnDetectHeader( oSettings.aoHeader, nThead[0] );
				anThs = _fnGetUniqueThs( oSettings );
			}
			
			/* If not given a column array, generate one with nulls */
			if ( oInit.aoColumns === null )
			{
				aoColumnsInit = [];
				for ( i=0, iLen=anThs.length ; i<iLen ; i++ )
				{
					aoColumnsInit.push( null );
				}
			}
			else
			{
				aoColumnsInit = oInit.aoColumns;
			}
			
			/* Add the columns */
			for ( i=0, iLen=aoColumnsInit.length ; i<iLen ; i++ )
			{
				_fnAddColumn( oSettings, anThs ? anThs[i] : null );
			}
			
			/* Apply the column definitions */
			_fnApplyColumnDefs( oSettings, oInit.aoColumnDefs, aoColumnsInit, function (iCol, oDef) {
				_fnColumnOptions( oSettings, iCol, oDef );
			} );
			
			/* HTML5 attribute detection - build an mData object automatically if the
			 * attributes are found
			 */
			if ( rowOne.length ) {
				var a = function ( cell, name ) {
					return cell.getAttribute( 'data-'+name ) !== null ? name : null;
				};
			
				$( rowOne[0] ).children('th, td').each( function (i, cell) {
					var col = oSettings.aoColumns[i];
			
					if (! col) {
						_fnLog( oSettings, 0, 'Incorrect column count', 18 );
					}
			
					if ( col.mData === i ) {
						var sort = a( cell, 'sort' ) || a( cell, 'order' );
						var filter = a( cell, 'filter' ) || a( cell, 'search' );
			
						if ( sort !== null || filter !== null ) {
							col.mData = {
								_:      i+'.display',
								sort:   sort !== null   ? i+'.@data-'+sort   : undefined,
								type:   sort !== null   ? i+'.@data-'+sort   : undefined,
								filter: filter !== null ? i+'.@data-'+filter : undefined
							};
							col._isArrayHost = true;
			
							_fnColumnOptions( oSettings, i );
						}
					}
				} );
			}
			
			var features = oSettings.oFeatures;
			var loadedInit = function () {
				/*
				 * Sorting
				 * @todo For modularisation (1.11) this needs to do into a sort start up handler
				 */
			
				// If aaSorting is not defined, then we use the first indicator in asSorting
				// in case that has been altered, so the default sort reflects that option
				if ( oInit.aaSorting === undefined ) {
					var sorting = oSettings.aaSorting;
					for ( i=0, iLen=sorting.length ; i<iLen ; i++ ) {
						sorting[i][1] = oSettings.aoColumns[ i ].asSorting[0];
					}
				}
			
				/* Do a first pass on the sorting classes (allows any size changes to be taken into
				 * account, and also will apply sorting disabled classes if disabled
				 */
				_fnSortingClasses( oSettings );
			
				if ( features.bSort ) {
					_fnCallbackReg( oSettings, 'aoDrawCallback', function () {
						if ( oSettings.bSorted ) {
							var aSort = _fnSortFlatten( oSettings );
							var sortedColumns = {};
			
							$.each( aSort, function (i, val) {
								sortedColumns[ val.src ] = val.dir;
							} );
			
							_fnCallbackFire( oSettings, null, 'order', [oSettings, aSort, sortedColumns] );
							_fnSortAria( oSettings );
						}
					} );
				}
			
				_fnCallbackReg( oSettings, 'aoDrawCallback', function () {
					if ( oSettings.bSorted || _fnDataSource( oSettings ) === 'ssp' || features.bDeferRender ) {
						_fnSortingClasses( oSettings );
					}
				}, 'sc' );
			
			
				/*
				 * Final init
				 * Cache the header, body and footer as required, creating them if needed
				 */
			
				// Work around for Webkit bug 83867 - store the caption-side before removing from doc
				var captions = $this.children('caption').each( function () {
					this._captionSide = $(this).css('caption-side');
				} );
			
				var thead = $this.children('thead');
				if ( thead.length === 0 ) {
					thead = $('<thead/>').appendTo($this);
				}
				oSettings.nTHead = thead[0];
			
				var tbody = $this.children('tbody');
				if ( tbody.length === 0 ) {
					tbody = $('<tbody/>').insertAfter(thead);
				}
				oSettings.nTBody = tbody[0];
			
				var tfoot = $this.children('tfoot');
				if ( tfoot.length === 0 && captions.length > 0 && (oSettings.oScroll.sX !== "" || oSettings.oScroll.sY !== "") ) {
					// If we are a scrolling table, and no footer has been given, then we need to create
					// a tfoot element for the caption element to be appended to
					tfoot = $('<tfoot/>').appendTo($this);
				}
			
				if ( tfoot.length === 0 || tfoot.children().length === 0 ) {
					$this.addClass( oClasses.sNoFooter );
				}
				else if ( tfoot.length > 0 ) {
					oSettings.nTFoot = tfoot[0];
					_fnDetectHeader( oSettings.aoFooter, oSettings.nTFoot );
				}
			
				/* Check if there is data passing into the constructor */
				if ( oInit.aaData ) {
					for ( i=0 ; i<oInit.aaData.length ; i++ ) {
						_fnAddData( oSettings, oInit.aaData[ i ] );
					}
				}
				else if ( oSettings.bDeferLoading || _fnDataSource( oSettings ) == 'dom' ) {
					/* Grab the data from the page - only do this when deferred loading or no Ajax
					 * source since there is no point in reading the DOM data if we are then going
					 * to replace it with Ajax data
					 */
					_fnAddTr( oSettings, $(oSettings.nTBody).children('tr') );
				}
			
				/* Copy the data index array */
				oSettings.aiDisplay = oSettings.aiDisplayMaster.slice();
			
				/* Initialisation complete - table can be drawn */
				oSettings.bInitialised = true;
			
				/* Check if we need to initialise the table (it might not have been handed off to the
				 * language processor)
				 */
				if ( bInitHandedOff === false ) {
					_fnInitialise( oSettings );
				}
			};
			
			/* Must be done after everything which can be overridden by the state saving! */
			_fnCallbackReg( oSettings, 'aoDrawCallback', _fnSaveState, 'state_save' );
			
			if ( oInit.bStateSave )
			{
				features.bStateSave = true;
				_fnLoadState( oSettings, oInit, loadedInit );
			}
			else {
				loadedInit();
			}
			
		} );
		_that = null;
		return this;
	};
	
	
	/*
	 * It is useful to have variables which are scoped locally so only the
	 * DataTables functions can access them and they don't leak into global space.
	 * At the same time these functions are often useful over multiple files in the
	 * core and API, so we list, or at least document, all variables which are used
	 * by DataTables as private variables here. This also ensures that there is no
	 * clashing of variable names and that they can easily referenced for reuse.
	 */
	
	
	// Defined else where
	//  _selector_run
	//  _selector_opts
	//  _selector_first
	//  _selector_row_indexes
	
	var _ext; // DataTable.ext
	var _Api; // DataTable.Api
	var _api_register; // DataTable.Api.register
	var _api_registerPlural; // DataTable.Api.registerPlural
	
	var _re_dic = {};
	var _re_new_lines = /[\r\n\u2028]/g;
	var _re_html = /<.*?>/g;
	
	// This is not strict ISO8601 - Date.parse() is quite lax, although
	// implementations differ between browsers.
	var _re_date = /^\d{2,4}[\.\/\-]\d{1,2}[\.\/\-]\d{1,2}([T ]{1}\d{1,2}[:\.]\d{2}([\.:]\d{2})?)?$/;
	
	// Escape regular expression special characters
	var _re_escape_regex = new RegExp( '(\\' + [ '/', '.', '*', '+', '?', '|', '(', ')', '[', ']', '{', '}', '\\', '$', '^', '-' ].join('|\\') + ')', 'g' );
	
	// https://en.wikipedia.org/wiki/Foreign_exchange_market
	// - \u20BD - Russian ruble.
	// - \u20a9 - South Korean Won
	// - \u20BA - Turkish Lira
	// - \u20B9 - Indian Rupee
	// - R - Brazil (R$) and South Africa
	// - fr - Swiss Franc
	// - kr - Swedish krona, Norwegian krone and Danish krone
	// - \u2009 is thin space and \u202F is narrow no-break space, both used in many
	// - Ƀ - Bitcoin
	// - Ξ - Ethereum
	//   standards as thousands separators.
	var _re_formatted_numeric = /['\u00A0,$£€¥%\u2009\u202F\u20BD\u20a9\u20BArfkɃΞ]/gi;
	
	
	var _empty = function ( d ) {
		return !d || d === true || d === '-' ? true : false;
	};
	
	
	var _intVal = function ( s ) {
		var integer = parseInt( s, 10 );
		return !isNaN(integer) && isFinite(s) ? integer : null;
	};
	
	// Convert from a formatted number with characters other than `.` as the
	// decimal place, to a Javascript number
	var _numToDecimal = function ( num, decimalPoint ) {
		// Cache created regular expressions for speed as this function is called often
		if ( ! _re_dic[ decimalPoint ] ) {
			_re_dic[ decimalPoint ] = new RegExp( _fnEscapeRegex( decimalPoint ), 'g' );
		}
		return typeof num === 'string' && decimalPoint !== '.' ?
			num.replace( /\./g, '' ).replace( _re_dic[ decimalPoint ], '.' ) :
			num;
	};
	
	
	var _isNumber = function ( d, decimalPoint, formatted ) {
		var type = typeof d;
		var strType = type === 'string';
	
		if ( type === 'number' || type === 'bigint') {
			return true;
		}
	
		// If empty return immediately so there must be a number if it is a
		// formatted string (this stops the string "k", or "kr", etc being detected
		// as a formatted number for currency
		if ( _empty( d ) ) {
			return true;
		}
	
		if ( decimalPoint && strType ) {
			d = _numToDecimal( d, decimalPoint );
		}
	
		if ( formatted && strType ) {
			d = d.replace( _re_formatted_numeric, '' );
		}
	
		return !isNaN( parseFloat(d) ) && isFinite( d );
	};
	
	
	// A string without HTML in it can be considered to be HTML still
	var _isHtml = function ( d ) {
		return _empty( d ) || typeof d === 'string';
	};
	
	
	var _htmlNumeric = function ( d, decimalPoint, formatted ) {
		if ( _empty( d ) ) {
			return true;
		}
	
		var html = _isHtml( d );
		return ! html ?
			null :
			_isNumber( _stripHtml( d ), decimalPoint, formatted ) ?
				true :
				null;
	};
	
	
	var _pluck = function ( a, prop, prop2 ) {
		var out = [];
		var i=0, ien=a.length;
	
		// Could have the test in the loop for slightly smaller code, but speed
		// is essential here
		if ( prop2 !== undefined ) {
			for ( ; i<ien ; i++ ) {
				if ( a[i] && a[i][ prop ] ) {
					out.push( a[i][ prop ][ prop2 ] );
				}
			}
		}
		else {
			for ( ; i<ien ; i++ ) {
				if ( a[i] ) {
					out.push( a[i][ prop ] );
				}
			}
		}
	
		return out;
	};
	
	
	// Basically the same as _pluck, but rather than looping over `a` we use `order`
	// as the indexes to pick from `a`
	var _pluck_order = function ( a, order, prop, prop2 )
	{
		var out = [];
		var i=0, ien=order.length;
	
		// Could have the test in the loop for slightly smaller code, but speed
		// is essential here
		if ( prop2 !== undefined ) {
			for ( ; i<ien ; i++ ) {
				if ( a[ order[i] ][ prop ] ) {
					out.push( a[ order[i] ][ prop ][ prop2 ] );
				}
			}
		}
		else {
			for ( ; i<ien ; i++ ) {
				out.push( a[ order[i] ][ prop ] );
			}
		}
	
		return out;
	};
	
	
	var _range = function ( len, start )
	{
		var out = [];
		var end;
	
		if ( start === undefined ) {
			start = 0;
			end = len;
		}
		else {
			end = start;
			start = len;
		}
	
		for ( var i=start ; i<end ; i++ ) {
			out.push( i );
		}
	
		return out;
	};
	
	
	var _removeEmpty = function ( a )
	{
		var out = [];
	
		for ( var i=0, ien=a.length ; i<ien ; i++ ) {
			if ( a[i] ) { // careful - will remove all falsy values!
				out.push( a[i] );
			}
		}
	
		return out;
	};
	
	
	var _stripHtml = function ( d ) {
		return d
			.replace( _re_html, '' ) // Complete tags
			.replace(/<script/i, ''); // Safety for incomplete script tag
	};
	
	
	/**
	 * Determine if all values in the array are unique. This means we can short
	 * cut the _unique method at the cost of a single loop. A sorted array is used
	 * to easily check the values.
	 *
	 * @param  {array} src Source array
	 * @return {boolean} true if all unique, false otherwise
	 * @ignore
	 */
	var _areAllUnique = function ( src ) {
		if ( src.length < 2 ) {
			return true;
		}
	
		var sorted = src.slice().sort();
		var last = sorted[0];
	
		for ( var i=1, ien=sorted.length ; i<ien ; i++ ) {
			if ( sorted[i] === last ) {
				return false;
			}
	
			last = sorted[i];
		}
	
		return true;
	};
	
	
	/**
	 * Find the unique elements in a source array.
	 *
	 * @param  {array} src Source array
	 * @return {array} Array of unique items
	 * @ignore
	 */
	var _unique = function ( src )
	{
		if ( _areAllUnique( src ) ) {
			return src.slice();
		}
	
		// A faster unique method is to use object keys to identify used values,
		// but this doesn't work with arrays or objects, which we must also
		// consider. See jsperf.com/compare-array-unique-versions/4 for more
		// information.
		var
			out = [],
			val,
			i, ien=src.length,
			j, k=0;
	
		again: for ( i=0 ; i<ien ; i++ ) {
			val = src[i];
	
			for ( j=0 ; j<k ; j++ ) {
				if ( out[j] === val ) {
					continue again;
				}
			}
	
			out.push( val );
			k++;
		}
	
		return out;
	};
	
	// Surprisingly this is faster than [].concat.apply
	// https://jsperf.com/flatten-an-array-loop-vs-reduce/2
	var _flatten = function (out, val) {
		if (Array.isArray(val)) {
			for (var i=0 ; i<val.length ; i++) {
				_flatten(out, val[i]);
			}
		}
		else {
			out.push(val);
		}
	  
		return out;
	}
	
	var _includes = function (search, start) {
		if (start === undefined) {
			start = 0;
		}
	
		return this.indexOf(search, start) !== -1;	
	};
	
	// Array.isArray polyfill.
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray
	if (! Array.isArray) {
	    Array.isArray = function(arg) {
	        return Object.prototype.toString.call(arg) === '[object Array]';
	    };
	}
	
	if (! Array.prototype.includes) {
		Array.prototype.includes = _includes;
	}
	
	// .trim() polyfill
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/trim
	if (!String.prototype.trim) {
	  String.prototype.trim = function () {
	    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	  };
	}
	
	if (! String.prototype.includes) {
		String.prototype.includes = _includes;
	}
	
	/**
	 * DataTables utility methods
	 * 
	 * This namespace provides helper methods that DataTables uses internally to
	 * create a DataTable, but which are not exclusively used only for DataTables.
	 * These methods can be used by extension authors to save the duplication of
	 * code.
	 *
	 *  @namespace
	 */
	DataTable.util = {
		/**
		 * Throttle the calls to a function. Arguments and context are maintained
		 * for the throttled function.
		 *
		 * @param {function} fn Function to be called
		 * @param {integer} freq Call frequency in mS
		 * @return {function} Wrapped function
		 */
		throttle: function ( fn, freq ) {
			var
				frequency = freq !== undefined ? freq : 200,
				last,
				timer;
	
			return function () {
				var
					that = this,
					now  = +new Date(),
					args = arguments;
	
				if ( last && now < last + frequency ) {
					clearTimeout( timer );
	
					timer = setTimeout( function () {
						last = undefined;
						fn.apply( that, args );
					}, frequency );
				}
				else {
					last = now;
					fn.apply( that, args );
				}
			};
		},
	
	
		/**
		 * Escape a string such that it can be used in a regular expression
		 *
		 *  @param {string} val string to escape
		 *  @returns {string} escaped string
		 */
		escapeRegex: function ( val ) {
			return val.replace( _re_escape_regex, '\\$1' );
		},
	
		/**
		 * Create a function that will write to a nested object or array
		 * @param {*} source JSON notation string
		 * @returns Write function
		 */
		set: function ( source ) {
			if ( $.isPlainObject( source ) ) {
				/* Unlike get, only the underscore (global) option is used for for
				 * setting data since we don't know the type here. This is why an object
				 * option is not documented for `mData` (which is read/write), but it is
				 * for `mRender` which is read only.
				 */
				return DataTable.util.set( source._ );
			}
			else if ( source === null ) {
				// Nothing to do when the data source is null
				return function () {};
			}
			else if ( typeof source === 'function' ) {
				return function (data, val, meta) {
					source( data, 'set', val, meta );
				};
			}
			else if ( typeof source === 'string' && (source.indexOf('.') !== -1 ||
					  source.indexOf('[') !== -1 || source.indexOf('(') !== -1) )
			{
				// Like the get, we need to get data from a nested object
				var setData = function (data, val, src) {
					var a = _fnSplitObjNotation( src ), b;
					var aLast = a[a.length-1];
					var arrayNotation, funcNotation, o, innerSrc;
		
					for ( var i=0, iLen=a.length-1 ; i<iLen ; i++ ) {
						// Protect against prototype pollution
						if (a[i] === '__proto__' || a[i] === 'constructor') {
							throw new Error('Cannot set prototype values');
						}
		
						// Check if we are dealing with an array notation request
						arrayNotation = a[i].match(__reArray);
						funcNotation = a[i].match(__reFn);
		
						if ( arrayNotation ) {
							a[i] = a[i].replace(__reArray, '');
							data[ a[i] ] = [];
		
							// Get the remainder of the nested object to set so we can recurse
							b = a.slice();
							b.splice( 0, i+1 );
							innerSrc = b.join('.');
		
							// Traverse each entry in the array setting the properties requested
							if ( Array.isArray( val ) ) {
								for ( var j=0, jLen=val.length ; j<jLen ; j++ ) {
									o = {};
									setData( o, val[j], innerSrc );
									data[ a[i] ].push( o );
								}
							}
							else {
								// We've been asked to save data to an array, but it
								// isn't array data to be saved. Best that can be done
								// is to just save the value.
								data[ a[i] ] = val;
							}
		
							// The inner call to setData has already traversed through the remainder
							// of the source and has set the data, thus we can exit here
							return;
						}
						else if ( funcNotation ) {
							// Function call
							a[i] = a[i].replace(__reFn, '');
							data = data[ a[i] ]( val );
						}
		
						// If the nested object doesn't currently exist - since we are
						// trying to set the value - create it
						if ( data[ a[i] ] === null || data[ a[i] ] === undefined ) {
							data[ a[i] ] = {};
						}
						data = data[ a[i] ];
					}
		
					// Last item in the input - i.e, the actual set
					if ( aLast.match(__reFn ) ) {
						// Function call
						data = data[ aLast.replace(__reFn, '') ]( val );
					}
					else {
						// If array notation is used, we just want to strip it and use the property name
						// and assign the value. If it isn't used, then we get the result we want anyway
						data[ aLast.replace(__reArray, '') ] = val;
					}
				};
		
				return function (data, val) { // meta is also passed in, but not used
					return setData( data, val, source );
				};
			}
			else {
				// Array or flat object mapping
				return function (data, val) { // meta is also passed in, but not used
					data[source] = val;
				};
			}
		},
	
		/**
		 * Create a function that will read nested objects from arrays, based on JSON notation
		 * @param {*} source JSON notation string
		 * @returns Value read
		 */
		get: function ( source ) {
			if ( $.isPlainObject( source ) ) {
				// Build an object of get functions, and wrap them in a single call
				var o = {};
				$.each( source, function (key, val) {
					if ( val ) {
						o[key] = DataTable.util.get( val );
					}
				} );
		
				return function (data, type, row, meta) {
					var t = o[type] || o._;
					return t !== undefined ?
						t(data, type, row, meta) :
						data;
				};
			}
			else if ( source === null ) {
				// Give an empty string for rendering / sorting etc
				return function (data) { // type, row and meta also passed, but not used
					return data;
				};
			}
			else if ( typeof source === 'function' ) {
				return function (data, type, row, meta) {
					return source( data, type, row, meta );
				};
			}
			else if ( typeof source === 'string' && (source.indexOf('.') !== -1 ||
					  source.indexOf('[') !== -1 || source.indexOf('(') !== -1) )
			{
				/* If there is a . in the source string then the data source is in a
				 * nested object so we loop over the data for each level to get the next
				 * level down. On each loop we test for undefined, and if found immediately
				 * return. This allows entire objects to be missing and sDefaultContent to
				 * be used if defined, rather than throwing an error
				 */
				var fetchData = function (data, type, src) {
					var arrayNotation, funcNotation, out, innerSrc;
		
					if ( src !== "" ) {
						var a = _fnSplitObjNotation( src );
		
						for ( var i=0, iLen=a.length ; i<iLen ; i++ ) {
							// Check if we are dealing with special notation
							arrayNotation = a[i].match(__reArray);
							funcNotation = a[i].match(__reFn);
		
							if ( arrayNotation ) {
								// Array notation
								a[i] = a[i].replace(__reArray, '');
		
								// Condition allows simply [] to be passed in
								if ( a[i] !== "" ) {
									data = data[ a[i] ];
								}
								out = [];
		
								// Get the remainder of the nested object to get
								a.splice( 0, i+1 );
								innerSrc = a.join('.');
		
								// Traverse each entry in the array getting the properties requested
								if ( Array.isArray( data ) ) {
									for ( var j=0, jLen=data.length ; j<jLen ; j++ ) {
										out.push( fetchData( data[j], type, innerSrc ) );
									}
								}
		
								// If a string is given in between the array notation indicators, that
								// is used to join the strings together, otherwise an array is returned
								var join = arrayNotation[0].substring(1, arrayNotation[0].length-1);
								data = (join==="") ? out : out.join(join);
		
								// The inner call to fetchData has already traversed through the remainder
								// of the source requested, so we exit from the loop
								break;
							}
							else if ( funcNotation ) {
								// Function call
								a[i] = a[i].replace(__reFn, '');
								data = data[ a[i] ]();
								continue;
							}
		
							if (data === null || data[ a[i] ] === null) {
								return null;
							}
							else if ( data === undefined || data[ a[i] ] === undefined ) {
								return undefined;
							}
	
							data = data[ a[i] ];
						}
					}
		
					return data;
				};
		
				return function (data, type) { // row and meta also passed, but not used
					return fetchData( data, type, source );
				};
			}
			else {
				// Array or flat object mapping
				return function (data, type) { // row and meta also passed, but not used
					return data[source];
				};
			}
		}
	};
	
	
	
	/**
	 * Create a mapping object that allows camel case parameters to be looked up
	 * for their Hungarian counterparts. The mapping is stored in a private
	 * parameter called `_hungarianMap` which can be accessed on the source object.
	 *  @param {object} o
	 *  @memberof DataTable#oApi
	 */
	function _fnHungarianMap ( o )
	{
		var
			hungarian = 'a aa ai ao as b fn i m o s ',
			match,
			newKey,
			map = {};
	
		$.each( o, function (key, val) {
			match = key.match(/^([^A-Z]+?)([A-Z])/);
	
			if ( match && hungarian.indexOf(match[1]+' ') !== -1 )
			{
				newKey = key.replace( match[0], match[2].toLowerCase() );
				map[ newKey ] = key;
	
				if ( match[1] === 'o' )
				{
					_fnHungarianMap( o[key] );
				}
			}
		} );
	
		o._hungarianMap = map;
	}
	
	
	/**
	 * Convert from camel case parameters to Hungarian, based on a Hungarian map
	 * created by _fnHungarianMap.
	 *  @param {object} src The model object which holds all parameters that can be
	 *    mapped.
	 *  @param {object} user The object to convert from camel case to Hungarian.
	 *  @param {boolean} force When set to `true`, properties which already have a
	 *    Hungarian value in the `user` object will be overwritten. Otherwise they
	 *    won't be.
	 *  @memberof DataTable#oApi
	 */
	function _fnCamelToHungarian ( src, user, force )
	{
		if ( ! src._hungarianMap ) {
			_fnHungarianMap( src );
		}
	
		var hungarianKey;
	
		$.each( user, function (key, val) {
			hungarianKey = src._hungarianMap[ key ];
	
			if ( hungarianKey !== undefined && (force || user[hungarianKey] === undefined) )
			{
				// For objects, we need to buzz down into the object to copy parameters
				if ( hungarianKey.charAt(0) === 'o' )
				{
					// Copy the camelCase options over to the hungarian
					if ( ! user[ hungarianKey ] ) {
						user[ hungarianKey ] = {};
					}
					$.extend( true, user[hungarianKey], user[key] );
	
					_fnCamelToHungarian( src[hungarianKey], user[hungarianKey], force );
				}
				else {
					user[hungarianKey] = user[ key ];
				}
			}
		} );
	}
	
	
	/**
	 * Language compatibility - when certain options are given, and others aren't, we
	 * need to duplicate the values over, in order to provide backwards compatibility
	 * with older language files.
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnLanguageCompat( lang )
	{
		// Note the use of the Hungarian notation for the parameters in this method as
		// this is called after the mapping of camelCase to Hungarian
		var defaults = DataTable.defaults.oLanguage;
	
		// Default mapping
		var defaultDecimal = defaults.sDecimal;
		if ( defaultDecimal ) {
			_addNumericSort( defaultDecimal );
		}
	
		if ( lang ) {
			var zeroRecords = lang.sZeroRecords;
	
			// Backwards compatibility - if there is no sEmptyTable given, then use the same as
			// sZeroRecords - assuming that is given.
			if ( ! lang.sEmptyTable && zeroRecords &&
				defaults.sEmptyTable === "No data available in table" )
			{
				_fnMap( lang, lang, 'sZeroRecords', 'sEmptyTable' );
			}
	
			// Likewise with loading records
			if ( ! lang.sLoadingRecords && zeroRecords &&
				defaults.sLoadingRecords === "Loading..." )
			{
				_fnMap( lang, lang, 'sZeroRecords', 'sLoadingRecords' );
			}
	
			// Old parameter name of the thousands separator mapped onto the new
			if ( lang.sInfoThousands ) {
				lang.sThousands = lang.sInfoThousands;
			}
	
			var decimal = lang.sDecimal;
			if ( decimal && defaultDecimal !== decimal ) {
				_addNumericSort( decimal );
			}
		}
	}
	
	
	/**
	 * Map one parameter onto another
	 *  @param {object} o Object to map
	 *  @param {*} knew The new parameter name
	 *  @param {*} old The old parameter name
	 */
	var _fnCompatMap = function ( o, knew, old ) {
		if ( o[ knew ] !== undefined ) {
			o[ old ] = o[ knew ];
		}
	};
	
	
	/**
	 * Provide backwards compatibility for the main DT options. Note that the new
	 * options are mapped onto the old parameters, so this is an external interface
	 * change only.
	 *  @param {object} init Object to map
	 */
	function _fnCompatOpts ( init )
	{
		_fnCompatMap( init, 'ordering',      'bSort' );
		_fnCompatMap( init, 'orderMulti',    'bSortMulti' );
		_fnCompatMap( init, 'orderClasses',  'bSortClasses' );
		_fnCompatMap( init, 'orderCellsTop', 'bSortCellsTop' );
		_fnCompatMap( init, 'order',         'aaSorting' );
		_fnCompatMap( init, 'orderFixed',    'aaSortingFixed' );
		_fnCompatMap( init, 'paging',        'bPaginate' );
		_fnCompatMap( init, 'pagingType',    'sPaginationType' );
		_fnCompatMap( init, 'pageLength',    'iDisplayLength' );
		_fnCompatMap( init, 'searching',     'bFilter' );
	
		// Boolean initialisation of x-scrolling
		if ( typeof init.sScrollX === 'boolean' ) {
			init.sScrollX = init.sScrollX ? '100%' : '';
		}
		if ( typeof init.scrollX === 'boolean' ) {
			init.scrollX = init.scrollX ? '100%' : '';
		}
	
		// Column search objects are in an array, so it needs to be converted
		// element by element
		var searchCols = init.aoSearchCols;
	
		if ( searchCols ) {
			for ( var i=0, ien=searchCols.length ; i<ien ; i++ ) {
				if ( searchCols[i] ) {
					_fnCamelToHungarian( DataTable.models.oSearch, searchCols[i] );
				}
			}
		}
	}
	
	
	/**
	 * Provide backwards compatibility for column options. Note that the new options
	 * are mapped onto the old parameters, so this is an external interface change
	 * only.
	 *  @param {object} init Object to map
	 */
	function _fnCompatCols ( init )
	{
		_fnCompatMap( init, 'orderable',     'bSortable' );
		_fnCompatMap( init, 'orderData',     'aDataSort' );
		_fnCompatMap( init, 'orderSequence', 'asSorting' );
		_fnCompatMap( init, 'orderDataType', 'sortDataType' );
	
		// orderData can be given as an integer
		var dataSort = init.aDataSort;
		if ( typeof dataSort === 'number' && ! Array.isArray( dataSort ) ) {
			init.aDataSort = [ dataSort ];
		}
	}
	
	
	/**
	 * Browser feature detection for capabilities, quirks
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnBrowserDetect( settings )
	{
		// We don't need to do this every time DataTables is constructed, the values
		// calculated are specific to the browser and OS configuration which we
		// don't expect to change between initialisations
		if ( ! DataTable.__browser ) {
			var browser = {};
			DataTable.__browser = browser;
	
			// Scrolling feature / quirks detection
			var n = $('<div/>')
				.css( {
					position: 'fixed',
					top: 0,
					left: $(window).scrollLeft()*-1, // allow for scrolling
					height: 1,
					width: 1,
					overflow: 'hidden'
				} )
				.append(
					$('<div/>')
						.css( {
							position: 'absolute',
							top: 1,
							left: 1,
							width: 100,
							overflow: 'scroll'
						} )
						.append(
							$('<div/>')
								.css( {
									width: '100%',
									height: 10
								} )
						)
				)
				.appendTo( 'body' );
	
			var outer = n.children();
			var inner = outer.children();
	
			// Numbers below, in order, are:
			// inner.offsetWidth, inner.clientWidth, outer.offsetWidth, outer.clientWidth
			//
			// IE6 XP:                           100 100 100  83
			// IE7 Vista:                        100 100 100  83
			// IE 8+ Windows:                     83  83 100  83
			// Evergreen Windows:                 83  83 100  83
			// Evergreen Mac with scrollbars:     85  85 100  85
			// Evergreen Mac without scrollbars: 100 100 100 100
	
			// Get scrollbar width
			browser.barWidth = outer[0].offsetWidth - outer[0].clientWidth;
	
			// IE6/7 will oversize a width 100% element inside a scrolling element, to
			// include the width of the scrollbar, while other browsers ensure the inner
			// element is contained without forcing scrolling
			browser.bScrollOversize = inner[0].offsetWidth === 100 && outer[0].clientWidth !== 100;
	
			// In rtl text layout, some browsers (most, but not all) will place the
			// scrollbar on the left, rather than the right.
			browser.bScrollbarLeft = Math.round( inner.offset().left ) !== 1;
	
			// IE8- don't provide height and width for getBoundingClientRect
			browser.bBounding = n[0].getBoundingClientRect().width ? true : false;
	
			n.remove();
		}
	
		$.extend( settings.oBrowser, DataTable.__browser );
		settings.oScroll.iBarWidth = DataTable.__browser.barWidth;
	}
	
	
	/**
	 * Array.prototype reduce[Right] method, used for browsers which don't support
	 * JS 1.6. Done this way to reduce code size, since we iterate either way
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnReduce ( that, fn, init, start, end, inc )
	{
		var
			i = start,
			value,
			isSet = false;
	
		if ( init !== undefined ) {
			value = init;
			isSet = true;
		}
	
		while ( i !== end ) {
			if ( ! that.hasOwnProperty(i) ) {
				continue;
			}
	
			value = isSet ?
				fn( value, that[i], i, that ) :
				that[i];
	
			isSet = true;
			i += inc;
		}
	
		return value;
	}
	
	/**
	 * Add a column to the list used for the table with default values
	 *  @param {object} oSettings dataTables settings object
	 *  @param {node} nTh The th element for this column
	 *  @memberof DataTable#oApi
	 */
	function _fnAddColumn( oSettings, nTh )
	{
		// Add column to aoColumns array
		var oDefaults = DataTable.defaults.column;
		var iCol = oSettings.aoColumns.length;
		var oCol = $.extend( {}, DataTable.models.oColumn, oDefaults, {
			"nTh": nTh ? nTh : document.createElement('th'),
			"sTitle":    oDefaults.sTitle    ? oDefaults.sTitle    : nTh ? nTh.innerHTML : '',
			"aDataSort": oDefaults.aDataSort ? oDefaults.aDataSort : [iCol],
			"mData": oDefaults.mData ? oDefaults.mData : iCol,
			idx: iCol
		} );
		oSettings.aoColumns.push( oCol );
	
		// Add search object for column specific search. Note that the `searchCols[ iCol ]`
		// passed into extend can be undefined. This allows the user to give a default
		// with only some of the parameters defined, and also not give a default
		var searchCols = oSettings.aoPreSearchCols;
		searchCols[ iCol ] = $.extend( {}, DataTable.models.oSearch, searchCols[ iCol ] );
	
		// Use the default column options function to initialise classes etc
		_fnColumnOptions( oSettings, iCol, $(nTh).data() );
	}
	
	
	/**
	 * Apply options for a column
	 *  @param {object} oSettings dataTables settings object
	 *  @param {int} iCol column index to consider
	 *  @param {object} oOptions object with sType, bVisible and bSearchable etc
	 *  @memberof DataTable#oApi
	 */
	function _fnColumnOptions( oSettings, iCol, oOptions )
	{
		var oCol = oSettings.aoColumns[ iCol ];
		var oClasses = oSettings.oClasses;
		var th = $(oCol.nTh);
	
		// Try to get width information from the DOM. We can't get it from CSS
		// as we'd need to parse the CSS stylesheet. `width` option can override
		if ( ! oCol.sWidthOrig ) {
			// Width attribute
			oCol.sWidthOrig = th.attr('width') || null;
	
			// Style attribute
			var t = (th.attr('style') || '').match(/width:\s*(\d+[pxem%]+)/);
			if ( t ) {
				oCol.sWidthOrig = t[1];
			}
		}
	
		/* User specified column options */
		if ( oOptions !== undefined && oOptions !== null )
		{
			// Backwards compatibility
			_fnCompatCols( oOptions );
	
			// Map camel case parameters to their Hungarian counterparts
			_fnCamelToHungarian( DataTable.defaults.column, oOptions, true );
	
			/* Backwards compatibility for mDataProp */
			if ( oOptions.mDataProp !== undefined && !oOptions.mData )
			{
				oOptions.mData = oOptions.mDataProp;
			}
	
			if ( oOptions.sType )
			{
				oCol._sManualType = oOptions.sType;
			}
	
			// `class` is a reserved word in Javascript, so we need to provide
			// the ability to use a valid name for the camel case input
			if ( oOptions.className && ! oOptions.sClass )
			{
				oOptions.sClass = oOptions.className;
			}
			if ( oOptions.sClass ) {
				th.addClass( oOptions.sClass );
			}
	
			var origClass = oCol.sClass;
	
			$.extend( oCol, oOptions );
			_fnMap( oCol, oOptions, "sWidth", "sWidthOrig" );
	
			// Merge class from previously defined classes with this one, rather than just
			// overwriting it in the extend above
			if (origClass !== oCol.sClass) {
				oCol.sClass = origClass + ' ' + oCol.sClass;
			}
	
			/* iDataSort to be applied (backwards compatibility), but aDataSort will take
			 * priority if defined
			 */
			if ( oOptions.iDataSort !== undefined )
			{
				oCol.aDataSort = [ oOptions.iDataSort ];
			}
			_fnMap( oCol, oOptions, "aDataSort" );
	
			// Fall back to the aria-label attribute on the table header if no ariaTitle is
			// provided.
			if (! oCol.ariaTitle) {
				oCol.ariaTitle = th.attr("aria-label");
			}
		}
	
		/* Cache the data get and set functions for speed */
		var mDataSrc = oCol.mData;
		var mData = _fnGetObjectDataFn( mDataSrc );
		var mRender = oCol.mRender ? _fnGetObjectDataFn( oCol.mRender ) : null;
	
		var attrTest = function( src ) {
			return typeof src === 'string' && src.indexOf('@') !== -1;
		};
		oCol._bAttrSrc = $.isPlainObject( mDataSrc ) && (
			attrTest(mDataSrc.sort) || attrTest(mDataSrc.type) || attrTest(mDataSrc.filter)
		);
		oCol._setter = null;
	
		oCol.fnGetData = function (rowData, type, meta) {
			var innerData = mData( rowData, type, undefined, meta );
	
			return mRender && type ?
				mRender( innerData, type, rowData, meta ) :
				innerData;
		};
		oCol.fnSetData = function ( rowData, val, meta ) {
			return _fnSetObjectDataFn( mDataSrc )( rowData, val, meta );
		};
	
		// Indicate if DataTables should read DOM data as an object or array
		// Used in _fnGetRowElements
		if ( typeof mDataSrc !== 'number' && ! oCol._isArrayHost ) {
			oSettings._rowReadObject = true;
		}
	
		/* Feature sorting overrides column specific when off */
		if ( !oSettings.oFeatures.bSort )
		{
			oCol.bSortable = false;
			th.addClass( oClasses.sSortableNone ); // Have to add class here as order event isn't called
		}
	
		/* Check that the class assignment is correct for sorting */
		var bAsc = $.inArray('asc', oCol.asSorting) !== -1;
		var bDesc = $.inArray('desc', oCol.asSorting) !== -1;
		if ( !oCol.bSortable || (!bAsc && !bDesc) )
		{
			oCol.sSortingClass = oClasses.sSortableNone;
			oCol.sSortingClassJUI = "";
		}
		else if ( bAsc && !bDesc )
		{
			oCol.sSortingClass = oClasses.sSortableAsc;
			oCol.sSortingClassJUI = oClasses.sSortJUIAscAllowed;
		}
		else if ( !bAsc && bDesc )
		{
			oCol.sSortingClass = oClasses.sSortableDesc;
			oCol.sSortingClassJUI = oClasses.sSortJUIDescAllowed;
		}
		else
		{
			oCol.sSortingClass = oClasses.sSortable;
			oCol.sSortingClassJUI = oClasses.sSortJUI;
		}
	}
	
	
	/**
	 * Adjust the table column widths for new data. Note: you would probably want to
	 * do a redraw after calling this function!
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnAdjustColumnSizing ( settings )
	{
		/* Not interested in doing column width calculation if auto-width is disabled */
		if ( settings.oFeatures.bAutoWidth !== false )
		{
			var columns = settings.aoColumns;
	
			_fnCalculateColumnWidths( settings );
			for ( var i=0 , iLen=columns.length ; i<iLen ; i++ )
			{
				columns[i].nTh.style.width = columns[i].sWidth;
			}
		}
	
		var scroll = settings.oScroll;
		if ( scroll.sY !== '' || scroll.sX !== '')
		{
			_fnScrollDraw( settings );
		}
	
		_fnCallbackFire( settings, null, 'column-sizing', [settings] );
	}
	
	
	/**
	 * Convert the index of a visible column to the index in the data array (take account
	 * of hidden columns)
	 *  @param {object} oSettings dataTables settings object
	 *  @param {int} iMatch Visible column index to lookup
	 *  @returns {int} i the data index
	 *  @memberof DataTable#oApi
	 */
	function _fnVisibleToColumnIndex( oSettings, iMatch )
	{
		var aiVis = _fnGetColumns( oSettings, 'bVisible' );
	
		return typeof aiVis[iMatch] === 'number' ?
			aiVis[iMatch] :
			null;
	}
	
	
	/**
	 * Convert the index of an index in the data array and convert it to the visible
	 *   column index (take account of hidden columns)
	 *  @param {int} iMatch Column index to lookup
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {int} i the data index
	 *  @memberof DataTable#oApi
	 */
	function _fnColumnIndexToVisible( oSettings, iMatch )
	{
		var aiVis = _fnGetColumns( oSettings, 'bVisible' );
		var iPos = $.inArray( iMatch, aiVis );
	
		return iPos !== -1 ? iPos : null;
	}
	
	
	/**
	 * Get the number of visible columns
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {int} i the number of visible columns
	 *  @memberof DataTable#oApi
	 */
	function _fnVisbleColumns( oSettings )
	{
		var vis = 0;
	
		// No reduce in IE8, use a loop for now
		$.each( oSettings.aoColumns, function ( i, col ) {
			if ( col.bVisible && $(col.nTh).css('display') !== 'none' ) {
				vis++;
			}
		} );
	
		return vis;
	}
	
	
	/**
	 * Get an array of column indexes that match a given property
	 *  @param {object} oSettings dataTables settings object
	 *  @param {string} sParam Parameter in aoColumns to look for - typically
	 *    bVisible or bSearchable
	 *  @returns {array} Array of indexes with matched properties
	 *  @memberof DataTable#oApi
	 */
	function _fnGetColumns( oSettings, sParam )
	{
		var a = [];
	
		$.map( oSettings.aoColumns, function(val, i) {
			if ( val[sParam] ) {
				a.push( i );
			}
		} );
	
		return a;
	}
	
	
	/**
	 * Calculate the 'type' of a column
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnColumnTypes ( settings )
	{
		var columns = settings.aoColumns;
		var data = settings.aoData;
		var types = DataTable.ext.type.detect;
		var i, ien, j, jen, k, ken;
		var col, cell, detectedType, cache;
	
		// For each column, spin over the 
		for ( i=0, ien=columns.length ; i<ien ; i++ ) {
			col = columns[i];
			cache = [];
	
			if ( ! col.sType && col._sManualType ) {
				col.sType = col._sManualType;
			}
			else if ( ! col.sType ) {
				for ( j=0, jen=types.length ; j<jen ; j++ ) {
					for ( k=0, ken=data.length ; k<ken ; k++ ) {
						// Use a cache array so we only need to get the type data
						// from the formatter once (when using multiple detectors)
						if ( cache[k] === undefined ) {
							cache[k] = _fnGetCellData( settings, k, i, 'type' );
						}
	
						detectedType = types[j]( cache[k], settings );
	
						// If null, then this type can't apply to this column, so
						// rather than testing all cells, break out. There is an
						// exception for the last type which is `html`. We need to
						// scan all rows since it is possible to mix string and HTML
						// types
						if ( ! detectedType && j !== types.length-1 ) {
							break;
						}
	
						// Only a single match is needed for html type since it is
						// bottom of the pile and very similar to string - but it
						// must not be empty
						if ( detectedType === 'html' && ! _empty(cache[k]) ) {
							break;
						}
					}
	
					// Type is valid for all data points in the column - use this
					// type
					if ( detectedType ) {
						col.sType = detectedType;
						break;
					}
				}
	
				// Fall back - if no type was detected, always use string
				if ( ! col.sType ) {
					col.sType = 'string';
				}
			}
		}
	}
	
	
	/**
	 * Take the column definitions and static columns arrays and calculate how
	 * they relate to column indexes. The callback function will then apply the
	 * definition found for a column to a suitable configuration object.
	 *  @param {object} oSettings dataTables settings object
	 *  @param {array} aoColDefs The aoColumnDefs array that is to be applied
	 *  @param {array} aoCols The aoColumns array that defines columns individually
	 *  @param {function} fn Callback function - takes two parameters, the calculated
	 *    column index and the definition for that column.
	 *  @memberof DataTable#oApi
	 */
	function _fnApplyColumnDefs( oSettings, aoColDefs, aoCols, fn )
	{
		var i, iLen, j, jLen, k, kLen, def;
		var columns = oSettings.aoColumns;
	
		// Column definitions with aTargets
		if ( aoColDefs )
		{
			/* Loop over the definitions array - loop in reverse so first instance has priority */
			for ( i=aoColDefs.length-1 ; i>=0 ; i-- )
			{
				def = aoColDefs[i];
	
				/* Each definition can target multiple columns, as it is an array */
				var aTargets = def.target !== undefined
					? def.target
					: def.targets !== undefined
						? def.targets
						: def.aTargets;
	
				if ( ! Array.isArray( aTargets ) )
				{
					aTargets = [ aTargets ];
				}
	
				for ( j=0, jLen=aTargets.length ; j<jLen ; j++ )
				{
					if ( typeof aTargets[j] === 'number' && aTargets[j] >= 0 )
					{
						/* Add columns that we don't yet know about */
						while( columns.length <= aTargets[j] )
						{
							_fnAddColumn( oSettings );
						}
	
						/* Integer, basic index */
						fn( aTargets[j], def );
					}
					else if ( typeof aTargets[j] === 'number' && aTargets[j] < 0 )
					{
						/* Negative integer, right to left column counting */
						fn( columns.length+aTargets[j], def );
					}
					else if ( typeof aTargets[j] === 'string' )
					{
						/* Class name matching on TH element */
						for ( k=0, kLen=columns.length ; k<kLen ; k++ )
						{
							if ( aTargets[j] == "_all" ||
							     $(columns[k].nTh).hasClass( aTargets[j] ) )
							{
								fn( k, def );
							}
						}
					}
				}
			}
		}
	
		// Statically defined columns array
		if ( aoCols )
		{
			for ( i=0, iLen=aoCols.length ; i<iLen ; i++ )
			{
				fn( i, aoCols[i] );
			}
		}
	}
	
	/**
	 * Add a data array to the table, creating DOM node etc. This is the parallel to
	 * _fnGatherData, but for adding rows from a Javascript source, rather than a
	 * DOM source.
	 *  @param {object} oSettings dataTables settings object
	 *  @param {array} aData data array to be added
	 *  @param {node} [nTr] TR element to add to the table - optional. If not given,
	 *    DataTables will create a row automatically
	 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
	 *    if nTr is.
	 *  @returns {int} >=0 if successful (index of new aoData entry), -1 if failed
	 *  @memberof DataTable#oApi
	 */
	function _fnAddData ( oSettings, aDataIn, nTr, anTds )
	{
		/* Create the object for storing information about this new row */
		var iRow = oSettings.aoData.length;
		var oData = $.extend( true, {}, DataTable.models.oRow, {
			src: nTr ? 'dom' : 'data',
			idx: iRow
		} );
	
		oData._aData = aDataIn;
		oSettings.aoData.push( oData );
	
		/* Create the cells */
		var nTd, sThisType;
		var columns = oSettings.aoColumns;
	
		// Invalidate the column types as the new data needs to be revalidated
		for ( var i=0, iLen=columns.length ; i<iLen ; i++ )
		{
			columns[i].sType = null;
		}
	
		/* Add to the display array */
		oSettings.aiDisplayMaster.push( iRow );
	
		var id = oSettings.rowIdFn( aDataIn );
		if ( id !== undefined ) {
			oSettings.aIds[ id ] = oData;
		}
	
		/* Create the DOM information, or register it if already present */
		if ( nTr || ! oSettings.oFeatures.bDeferRender )
		{
			_fnCreateTr( oSettings, iRow, nTr, anTds );
		}
	
		return iRow;
	}
	
	
	/**
	 * Add one or more TR elements to the table. Generally we'd expect to
	 * use this for reading data from a DOM sourced table, but it could be
	 * used for an TR element. Note that if a TR is given, it is used (i.e.
	 * it is not cloned).
	 *  @param {object} settings dataTables settings object
	 *  @param {array|node|jQuery} trs The TR element(s) to add to the table
	 *  @returns {array} Array of indexes for the added rows
	 *  @memberof DataTable#oApi
	 */
	function _fnAddTr( settings, trs )
	{
		var row;
	
		// Allow an individual node to be passed in
		if ( ! (trs instanceof $) ) {
			trs = $(trs);
		}
	
		return trs.map( function (i, el) {
			row = _fnGetRowElements( settings, el );
			return _fnAddData( settings, row.data, el, row.cells );
		} );
	}
	
	
	/**
	 * Take a TR element and convert it to an index in aoData
	 *  @param {object} oSettings dataTables settings object
	 *  @param {node} n the TR element to find
	 *  @returns {int} index if the node is found, null if not
	 *  @memberof DataTable#oApi
	 */
	function _fnNodeToDataIndex( oSettings, n )
	{
		return (n._DT_RowIndex!==undefined) ? n._DT_RowIndex : null;
	}
	
	
	/**
	 * Take a TD element and convert it into a column data index (not the visible index)
	 *  @param {object} oSettings dataTables settings object
	 *  @param {int} iRow The row number the TD/TH can be found in
	 *  @param {node} n The TD/TH element to find
	 *  @returns {int} index if the node is found, -1 if not
	 *  @memberof DataTable#oApi
	 */
	function _fnNodeToColumnIndex( oSettings, iRow, n )
	{
		return $.inArray( n, oSettings.aoData[ iRow ].anCells );
	}
	
	
	/**
	 * Get the data for a given cell from the internal cache, taking into account data mapping
	 *  @param {object} settings dataTables settings object
	 *  @param {int} rowIdx aoData row id
	 *  @param {int} colIdx Column index
	 *  @param {string} type data get type ('display', 'type' 'filter|search' 'sort|order')
	 *  @returns {*} Cell data
	 *  @memberof DataTable#oApi
	 */
	function _fnGetCellData( settings, rowIdx, colIdx, type )
	{
		if (type === 'search') {
			type = 'filter';
		}
		else if (type === 'order') {
			type = 'sort';
		}
	
		var draw           = settings.iDraw;
		var col            = settings.aoColumns[colIdx];
		var rowData        = settings.aoData[rowIdx]._aData;
		var defaultContent = col.sDefaultContent;
		var cellData       = col.fnGetData( rowData, type, {
			settings: settings,
			row:      rowIdx,
			col:      colIdx
		} );
	
		if ( cellData === undefined ) {
			if ( settings.iDrawError != draw && defaultContent === null ) {
				_fnLog( settings, 0, "Requested unknown parameter "+
					(typeof col.mData=='function' ? '{function}' : "'"+col.mData+"'")+
					" for row "+rowIdx+", column "+colIdx, 4 );
				settings.iDrawError = draw;
			}
			return defaultContent;
		}
	
		// When the data source is null and a specific data type is requested (i.e.
		// not the original data), we can use default column data
		if ( (cellData === rowData || cellData === null) && defaultContent !== null && type !== undefined ) {
			cellData = defaultContent;
		}
		else if ( typeof cellData === 'function' ) {
			// If the data source is a function, then we run it and use the return,
			// executing in the scope of the data object (for instances)
			return cellData.call( rowData );
		}
	
		if ( cellData === null && type === 'display' ) {
			return '';
		}
	
		if ( type === 'filter' ) {
			var fomatters = DataTable.ext.type.search;
	
			if ( fomatters[ col.sType ] ) {
				cellData = fomatters[ col.sType ]( cellData );
			}
		}
	
		return cellData;
	}
	
	
	/**
	 * Set the value for a specific cell, into the internal data cache
	 *  @param {object} settings dataTables settings object
	 *  @param {int} rowIdx aoData row id
	 *  @param {int} colIdx Column index
	 *  @param {*} val Value to set
	 *  @memberof DataTable#oApi
	 */
	function _fnSetCellData( settings, rowIdx, colIdx, val )
	{
		var col     = settings.aoColumns[colIdx];
		var rowData = settings.aoData[rowIdx]._aData;
	
		col.fnSetData( rowData, val, {
			settings: settings,
			row:      rowIdx,
			col:      colIdx
		}  );
	}
	
	
	// Private variable that is used to match action syntax in the data property object
	var __reArray = /\[.*?\]$/;
	var __reFn = /\(\)$/;
	
	/**
	 * Split string on periods, taking into account escaped periods
	 * @param  {string} str String to split
	 * @return {array} Split string
	 */
	function _fnSplitObjNotation( str )
	{
		return $.map( str.match(/(\\.|[^\.])+/g) || [''], function ( s ) {
			return s.replace(/\\\./g, '.');
		} );
	}
	
	
	/**
	 * Return a function that can be used to get data from a source object, taking
	 * into account the ability to use nested objects as a source
	 *  @param {string|int|function} mSource The data source for the object
	 *  @returns {function} Data get function
	 *  @memberof DataTable#oApi
	 */
	var _fnGetObjectDataFn = DataTable.util.get;
	
	
	/**
	 * Return a function that can be used to set data from a source object, taking
	 * into account the ability to use nested objects as a source
	 *  @param {string|int|function} mSource The data source for the object
	 *  @returns {function} Data set function
	 *  @memberof DataTable#oApi
	 */
	var _fnSetObjectDataFn = DataTable.util.set;
	
	
	/**
	 * Return an array with the full table data
	 *  @param {object} oSettings dataTables settings object
	 *  @returns array {array} aData Master data array
	 *  @memberof DataTable#oApi
	 */
	function _fnGetDataMaster ( settings )
	{
		return _pluck( settings.aoData, '_aData' );
	}
	
	
	/**
	 * Nuke the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnClearTable( settings )
	{
		settings.aoData.length = 0;
		settings.aiDisplayMaster.length = 0;
		settings.aiDisplay.length = 0;
		settings.aIds = {};
	}
	
	
	 /**
	 * Take an array of integers (index array) and remove a target integer (value - not
	 * the key!)
	 *  @param {array} a Index array to target
	 *  @param {int} iTarget value to find
	 *  @memberof DataTable#oApi
	 */
	function _fnDeleteIndex( a, iTarget, splice )
	{
		var iTargetIndex = -1;
	
		for ( var i=0, iLen=a.length ; i<iLen ; i++ )
		{
			if ( a[i] == iTarget )
			{
				iTargetIndex = i;
			}
			else if ( a[i] > iTarget )
			{
				a[i]--;
			}
		}
	
		if ( iTargetIndex != -1 && splice === undefined )
		{
			a.splice( iTargetIndex, 1 );
		}
	}
	
	
	/**
	 * Mark cached data as invalid such that a re-read of the data will occur when
	 * the cached data is next requested. Also update from the data source object.
	 *
	 * @param {object} settings DataTables settings object
	 * @param {int}    rowIdx   Row index to invalidate
	 * @param {string} [src]    Source to invalidate from: undefined, 'auto', 'dom'
	 *     or 'data'
	 * @param {int}    [colIdx] Column index to invalidate. If undefined the whole
	 *     row will be invalidated
	 * @memberof DataTable#oApi
	 *
	 * @todo For the modularisation of v1.11 this will need to become a callback, so
	 *   the sort and filter methods can subscribe to it. That will required
	 *   initialisation options for sorting, which is why it is not already baked in
	 */
	function _fnInvalidate( settings, rowIdx, src, colIdx )
	{
		var row = settings.aoData[ rowIdx ];
		var i, ien;
		var cellWrite = function ( cell, col ) {
			// This is very frustrating, but in IE if you just write directly
			// to innerHTML, and elements that are overwritten are GC'ed,
			// even if there is a reference to them elsewhere
			while ( cell.childNodes.length ) {
				cell.removeChild( cell.firstChild );
			}
	
			cell.innerHTML = _fnGetCellData( settings, rowIdx, col, 'display' );
		};
	
		// Are we reading last data from DOM or the data object?
		if ( src === 'dom' || ((! src || src === 'auto') && row.src === 'dom') ) {
			// Read the data from the DOM
			row._aData = _fnGetRowElements(
					settings, row, colIdx, colIdx === undefined ? undefined : row._aData
				)
				.data;
		}
		else {
			// Reading from data object, update the DOM
			var cells = row.anCells;
	
			if ( cells ) {
				if ( colIdx !== undefined ) {
					cellWrite( cells[colIdx], colIdx );
				}
				else {
					for ( i=0, ien=cells.length ; i<ien ; i++ ) {
						cellWrite( cells[i], i );
					}
				}
			}
		}
	
		// For both row and cell invalidation, the cached data for sorting and
		// filtering is nulled out
		row._aSortData = null;
		row._aFilterData = null;
	
		// Invalidate the type for a specific column (if given) or all columns since
		// the data might have changed
		var cols = settings.aoColumns;
		if ( colIdx !== undefined ) {
			cols[ colIdx ].sType = null;
		}
		else {
			for ( i=0, ien=cols.length ; i<ien ; i++ ) {
				cols[i].sType = null;
			}
	
			// Update DataTables special `DT_*` attributes for the row
			_fnRowAttributes( settings, row );
		}
	}
	
	
	/**
	 * Build a data source object from an HTML row, reading the contents of the
	 * cells that are in the row.
	 *
	 * @param {object} settings DataTables settings object
	 * @param {node|object} TR element from which to read data or existing row
	 *   object from which to re-read the data from the cells
	 * @param {int} [colIdx] Optional column index
	 * @param {array|object} [d] Data source object. If `colIdx` is given then this
	 *   parameter should also be given and will be used to write the data into.
	 *   Only the column in question will be written
	 * @returns {object} Object with two parameters: `data` the data read, in
	 *   document order, and `cells` and array of nodes (they can be useful to the
	 *   caller, so rather than needing a second traversal to get them, just return
	 *   them from here).
	 * @memberof DataTable#oApi
	 */
	function _fnGetRowElements( settings, row, colIdx, d )
	{
		var
			tds = [],
			td = row.firstChild,
			name, col, o, i=0, contents,
			columns = settings.aoColumns,
			objectRead = settings._rowReadObject;
	
		// Allow the data object to be passed in, or construct
		d = d !== undefined ?
			d :
			objectRead ?
				{} :
				[];
	
		var attr = function ( str, td  ) {
			if ( typeof str === 'string' ) {
				var idx = str.indexOf('@');
	
				if ( idx !== -1 ) {
					var attr = str.substring( idx+1 );
					var setter = _fnSetObjectDataFn( str );
					setter( d, td.getAttribute( attr ) );
				}
			}
		};
	
		// Read data from a cell and store into the data object
		var cellProcess = function ( cell ) {
			if ( colIdx === undefined || colIdx === i ) {
				col = columns[i];
				contents = (cell.innerHTML).trim();
	
				if ( col && col._bAttrSrc ) {
					var setter = _fnSetObjectDataFn( col.mData._ );
					setter( d, contents );
	
					attr( col.mData.sort, cell );
					attr( col.mData.type, cell );
					attr( col.mData.filter, cell );
				}
				else {
					// Depending on the `data` option for the columns the data can
					// be read to either an object or an array.
					if ( objectRead ) {
						if ( ! col._setter ) {
							// Cache the setter function
							col._setter = _fnSetObjectDataFn( col.mData );
						}
						col._setter( d, contents );
					}
					else {
						d[i] = contents;
					}
				}
			}
	
			i++;
		};
	
		if ( td ) {
			// `tr` element was passed in
			while ( td ) {
				name = td.nodeName.toUpperCase();
	
				if ( name == "TD" || name == "TH" ) {
					cellProcess( td );
					tds.push( td );
				}
	
				td = td.nextSibling;
			}
		}
		else {
			// Existing row object passed in
			tds = row.anCells;
	
			for ( var j=0, jen=tds.length ; j<jen ; j++ ) {
				cellProcess( tds[j] );
			}
		}
	
		// Read the ID from the DOM if present
		var rowNode = row.firstChild ? row : row.nTr;
	
		if ( rowNode ) {
			var id = rowNode.getAttribute( 'id' );
	
			if ( id ) {
				_fnSetObjectDataFn( settings.rowId )( d, id );
			}
		}
	
		return {
			data: d,
			cells: tds
		};
	}
	/**
	 * Create a new TR element (and it's TD children) for a row
	 *  @param {object} oSettings dataTables settings object
	 *  @param {int} iRow Row to consider
	 *  @param {node} [nTrIn] TR element to add to the table - optional. If not given,
	 *    DataTables will create a row automatically
	 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
	 *    if nTr is.
	 *  @memberof DataTable#oApi
	 */
	function _fnCreateTr ( oSettings, iRow, nTrIn, anTds )
	{
		var
			row = oSettings.aoData[iRow],
			rowData = row._aData,
			cells = [],
			nTr, nTd, oCol,
			i, iLen, create;
	
		if ( row.nTr === null )
		{
			nTr = nTrIn || document.createElement('tr');
	
			row.nTr = nTr;
			row.anCells = cells;
	
			/* Use a private property on the node to allow reserve mapping from the node
			 * to the aoData array for fast look up
			 */
			nTr._DT_RowIndex = iRow;
	
			/* Special parameters can be given by the data source to be used on the row */
			_fnRowAttributes( oSettings, row );
	
			/* Process each column */
			for ( i=0, iLen=oSettings.aoColumns.length ; i<iLen ; i++ )
			{
				oCol = oSettings.aoColumns[i];
				create = nTrIn ? false : true;
	
				nTd = create ? document.createElement( oCol.sCellType ) : anTds[i];
	
				if (! nTd) {
					_fnLog( oSettings, 0, 'Incorrect column count', 18 );
				}
	
				nTd._DT_CellIndex = {
					row: iRow,
					column: i
				};
				
				cells.push( nTd );
	
				// Need to create the HTML if new, or if a rendering function is defined
				if ( create || ((oCol.mRender || oCol.mData !== i) &&
					 (!$.isPlainObject(oCol.mData) || oCol.mData._ !== i+'.display')
				)) {
					nTd.innerHTML = _fnGetCellData( oSettings, iRow, i, 'display' );
				}
	
				/* Add user defined class */
				if ( oCol.sClass )
				{
					nTd.className += ' '+oCol.sClass;
				}
	
				// Visibility - add or remove as required
				if ( oCol.bVisible && ! nTrIn )
				{
					nTr.appendChild( nTd );
				}
				else if ( ! oCol.bVisible && nTrIn )
				{
					nTd.parentNode.removeChild( nTd );
				}
	
				if ( oCol.fnCreatedCell )
				{
					oCol.fnCreatedCell.call( oSettings.oInstance,
						nTd, _fnGetCellData( oSettings, iRow, i ), rowData, iRow, i
					);
				}
			}
	
			_fnCallbackFire( oSettings, 'aoRowCreatedCallback', null, [nTr, rowData, iRow, cells] );
		}
	}
	
	
	/**
	 * Add attributes to a row based on the special `DT_*` parameters in a data
	 * source object.
	 *  @param {object} settings DataTables settings object
	 *  @param {object} DataTables row object for the row to be modified
	 *  @memberof DataTable#oApi
	 */
	function _fnRowAttributes( settings, row )
	{
		var tr = row.nTr;
		var data = row._aData;
	
		if ( tr ) {
			var id = settings.rowIdFn( data );
	
			if ( id ) {
				tr.id = id;
			}
	
			if ( data.DT_RowClass ) {
				// Remove any classes added by DT_RowClass before
				var a = data.DT_RowClass.split(' ');
				row.__rowc = row.__rowc ?
					_unique( row.__rowc.concat( a ) ) :
					a;
	
				$(tr)
					.removeClass( row.__rowc.join(' ') )
					.addClass( data.DT_RowClass );
			}
	
			if ( data.DT_RowAttr ) {
				$(tr).attr( data.DT_RowAttr );
			}
	
			if ( data.DT_RowData ) {
				$(tr).data( data.DT_RowData );
			}
		}
	}
	
	
	/**
	 * Create the HTML header for the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnBuildHead( oSettings )
	{
		var i, ien, cell, row, column;
		var thead = oSettings.nTHead;
		var tfoot = oSettings.nTFoot;
		var createHeader = $('th, td', thead).length === 0;
		var classes = oSettings.oClasses;
		var columns = oSettings.aoColumns;
	
		if ( createHeader ) {
			row = $('<tr/>').appendTo( thead );
		}
	
		for ( i=0, ien=columns.length ; i<ien ; i++ ) {
			column = columns[i];
			cell = $( column.nTh ).addClass( column.sClass );
	
			if ( createHeader ) {
				cell.appendTo( row );
			}
	
			// 1.11 move into sorting
			if ( oSettings.oFeatures.bSort ) {
				cell.addClass( column.sSortingClass );
	
				if ( column.bSortable !== false ) {
					cell
						.attr( 'tabindex', oSettings.iTabIndex )
						.attr( 'aria-controls', oSettings.sTableId );
	
					_fnSortAttachListener( oSettings, column.nTh, i );
				}
			}
	
			if ( column.sTitle != cell[0].innerHTML ) {
				cell.html( column.sTitle );
			}
	
			_fnRenderer( oSettings, 'header' )(
				oSettings, cell, column, classes
			);
		}
	
		if ( createHeader ) {
			_fnDetectHeader( oSettings.aoHeader, thead );
		}
	
		/* Deal with the footer - add classes if required */
		$(thead).children('tr').children('th, td').addClass( classes.sHeaderTH );
		$(tfoot).children('tr').children('th, td').addClass( classes.sFooterTH );
	
		// Cache the footer cells. Note that we only take the cells from the first
		// row in the footer. If there is more than one row the user wants to
		// interact with, they need to use the table().foot() method. Note also this
		// allows cells to be used for multiple columns using colspan
		if ( tfoot !== null ) {
			var cells = oSettings.aoFooter[0];
	
			for ( i=0, ien=cells.length ; i<ien ; i++ ) {
				column = columns[i];
	
				if (column) {
					column.nTf = cells[i].cell;
		
					if ( column.sClass ) {
						$(column.nTf).addClass( column.sClass );
					}
				}
				else {
					_fnLog( oSettings, 0, 'Incorrect column count', 18 );
				}
			}
		}
	}
	
	
	/**
	 * Draw the header (or footer) element based on the column visibility states. The
	 * methodology here is to use the layout array from _fnDetectHeader, modified for
	 * the instantaneous column visibility, to construct the new layout. The grid is
	 * traversed over cell at a time in a rows x columns grid fashion, although each
	 * cell insert can cover multiple elements in the grid - which is tracks using the
	 * aApplied array. Cell inserts in the grid will only occur where there isn't
	 * already a cell in that position.
	 *  @param {object} oSettings dataTables settings object
	 *  @param array {objects} aoSource Layout array from _fnDetectHeader
	 *  @param {boolean} [bIncludeHidden=false] If true then include the hidden columns in the calc,
	 *  @memberof DataTable#oApi
	 */
	function _fnDrawHead( oSettings, aoSource, bIncludeHidden )
	{
		var i, iLen, j, jLen, k, kLen, n, nLocalTr;
		var aoLocal = [];
		var aApplied = [];
		var iColumns = oSettings.aoColumns.length;
		var iRowspan, iColspan;
	
		if ( ! aoSource )
		{
			return;
		}
	
		if (  bIncludeHidden === undefined )
		{
			bIncludeHidden = false;
		}
	
		/* Make a copy of the master layout array, but without the visible columns in it */
		for ( i=0, iLen=aoSource.length ; i<iLen ; i++ )
		{
			aoLocal[i] = aoSource[i].slice();
			aoLocal[i].nTr = aoSource[i].nTr;
	
			/* Remove any columns which are currently hidden */
			for ( j=iColumns-1 ; j>=0 ; j-- )
			{
				if ( !oSettings.aoColumns[j].bVisible && !bIncludeHidden )
				{
					aoLocal[i].splice( j, 1 );
				}
			}
	
			/* Prep the applied array - it needs an element for each row */
			aApplied.push( [] );
		}
	
		for ( i=0, iLen=aoLocal.length ; i<iLen ; i++ )
		{
			nLocalTr = aoLocal[i].nTr;
	
			/* All cells are going to be replaced, so empty out the row */
			if ( nLocalTr )
			{
				while( (n = nLocalTr.firstChild) )
				{
					nLocalTr.removeChild( n );
				}
			}
	
			for ( j=0, jLen=aoLocal[i].length ; j<jLen ; j++ )
			{
				iRowspan = 1;
				iColspan = 1;
	
				/* Check to see if there is already a cell (row/colspan) covering our target
				 * insert point. If there is, then there is nothing to do.
				 */
				if ( aApplied[i][j] === undefined )
				{
					nLocalTr.appendChild( aoLocal[i][j].cell );
					aApplied[i][j] = 1;
	
					/* Expand the cell to cover as many rows as needed */
					while ( aoLocal[i+iRowspan] !== undefined &&
					        aoLocal[i][j].cell == aoLocal[i+iRowspan][j].cell )
					{
						aApplied[i+iRowspan][j] = 1;
						iRowspan++;
					}
	
					/* Expand the cell to cover as many columns as needed */
					while ( aoLocal[i][j+iColspan] !== undefined &&
					        aoLocal[i][j].cell == aoLocal[i][j+iColspan].cell )
					{
						/* Must update the applied array over the rows for the columns */
						for ( k=0 ; k<iRowspan ; k++ )
						{
							aApplied[i+k][j+iColspan] = 1;
						}
						iColspan++;
					}
	
					/* Do the actual expansion in the DOM */
					$(aoLocal[i][j].cell)
						.attr('rowspan', iRowspan)
						.attr('colspan', iColspan);
				}
			}
		}
	}
	
	
	/**
	 * Insert the required TR nodes into the table for display
	 *  @param {object} oSettings dataTables settings object
	 *  @param ajaxComplete true after ajax call to complete rendering
	 *  @memberof DataTable#oApi
	 */
	function _fnDraw( oSettings, ajaxComplete )
	{
		// Allow for state saving and a custom start position
		_fnStart( oSettings );
	
		/* Provide a pre-callback function which can be used to cancel the draw is false is returned */
		var aPreDraw = _fnCallbackFire( oSettings, 'aoPreDrawCallback', 'preDraw', [oSettings] );
		if ( $.inArray( false, aPreDraw ) !== -1 )
		{
			_fnProcessingDisplay( oSettings, false );
			return;
		}
	
		var anRows = [];
		var iRowCount = 0;
		var asStripeClasses = oSettings.asStripeClasses;
		var iStripes = asStripeClasses.length;
		var oLang = oSettings.oLanguage;
		var bServerSide = _fnDataSource( oSettings ) == 'ssp';
		var aiDisplay = oSettings.aiDisplay;
		var iDisplayStart = oSettings._iDisplayStart;
		var iDisplayEnd = oSettings.fnDisplayEnd();
	
		oSettings.bDrawing = true;
	
		/* Server-side processing draw intercept */
		if ( oSettings.bDeferLoading )
		{
			oSettings.bDeferLoading = false;
			oSettings.iDraw++;
			_fnProcessingDisplay( oSettings, false );
		}
		else if ( !bServerSide )
		{
			oSettings.iDraw++;
		}
		else if ( !oSettings.bDestroying && !ajaxComplete)
		{
			_fnAjaxUpdate( oSettings );
			return;
		}
	
		if ( aiDisplay.length !== 0 )
		{
			var iStart = bServerSide ? 0 : iDisplayStart;
			var iEnd = bServerSide ? oSettings.aoData.length : iDisplayEnd;
	
			for ( var j=iStart ; j<iEnd ; j++ )
			{
				var iDataIndex = aiDisplay[j];
				var aoData = oSettings.aoData[ iDataIndex ];
				if ( aoData.nTr === null )
				{
					_fnCreateTr( oSettings, iDataIndex );
				}
	
				var nRow = aoData.nTr;
	
				/* Remove the old striping classes and then add the new one */
				if ( iStripes !== 0 )
				{
					var sStripe = asStripeClasses[ iRowCount % iStripes ];
					if ( aoData._sRowStripe != sStripe )
					{
						$(nRow).removeClass( aoData._sRowStripe ).addClass( sStripe );
						aoData._sRowStripe = sStripe;
					}
				}
	
				// Row callback functions - might want to manipulate the row
				// iRowCount and j are not currently documented. Are they at all
				// useful?
				_fnCallbackFire( oSettings, 'aoRowCallback', null,
					[nRow, aoData._aData, iRowCount, j, iDataIndex] );
	
				anRows.push( nRow );
				iRowCount++;
			}
		}
		else
		{
			/* Table is empty - create a row with an empty message in it */
			var sZero = oLang.sZeroRecords;
			if ( oSettings.iDraw == 1 &&  _fnDataSource( oSettings ) == 'ajax' )
			{
				sZero = oLang.sLoadingRecords;
			}
			else if ( oLang.sEmptyTable && oSettings.fnRecordsTotal() === 0 )
			{
				sZero = oLang.sEmptyTable;
			}
	
			anRows[ 0 ] = $( '<tr/>', { 'class': iStripes ? asStripeClasses[0] : '' } )
				.append( $('<td />', {
					'valign':  'top',
					'colSpan': _fnVisbleColumns( oSettings ),
					'class':   oSettings.oClasses.sRowEmpty
				} ).html( sZero ) )[0];
		}
	
		/* Header and footer callbacks */
		_fnCallbackFire( oSettings, 'aoHeaderCallback', 'header', [ $(oSettings.nTHead).children('tr')[0],
			_fnGetDataMaster( oSettings ), iDisplayStart, iDisplayEnd, aiDisplay ] );
	
		_fnCallbackFire( oSettings, 'aoFooterCallback', 'footer', [ $(oSettings.nTFoot).children('tr')[0],
			_fnGetDataMaster( oSettings ), iDisplayStart, iDisplayEnd, aiDisplay ] );
	
		var body = $(oSettings.nTBody);
	
		body.children().detach();
		body.append( $(anRows) );
	
		/* Call all required callback functions for the end of a draw */
		_fnCallbackFire( oSettings, 'aoDrawCallback', 'draw', [oSettings] );
	
		/* Draw is complete, sorting and filtering must be as well */
		oSettings.bSorted = false;
		oSettings.bFiltered = false;
		oSettings.bDrawing = false;
	}
	
	
	/**
	 * Redraw the table - taking account of the various features which are enabled
	 *  @param {object} oSettings dataTables settings object
	 *  @param {boolean} [holdPosition] Keep the current paging position. By default
	 *    the paging is reset to the first page
	 *  @memberof DataTable#oApi
	 */
	function _fnReDraw( settings, holdPosition )
	{
		var
			features = settings.oFeatures,
			sort     = features.bSort,
			filter   = features.bFilter;
	
		if ( sort ) {
			_fnSort( settings );
		}
	
		if ( filter ) {
			_fnFilterComplete( settings, settings.oPreviousSearch );
		}
		else {
			// No filtering, so we want to just use the display master
			settings.aiDisplay = settings.aiDisplayMaster.slice();
		}
	
		if ( holdPosition !== true ) {
			settings._iDisplayStart = 0;
		}
	
		// Let any modules know about the draw hold position state (used by
		// scrolling internally)
		settings._drawHold = holdPosition;
	
		_fnDraw( settings );
	
		settings._drawHold = false;
	}
	
	
	/**
	 * Add the options to the page HTML for the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnAddOptionsHtml ( oSettings )
	{
		var classes = oSettings.oClasses;
		var table = $(oSettings.nTable);
		var holding = $('<div/>').insertBefore( table ); // Holding element for speed
		var features = oSettings.oFeatures;
	
		// All DataTables are wrapped in a div
		var insert = $('<div/>', {
			id:      oSettings.sTableId+'_wrapper',
			'class': classes.sWrapper + (oSettings.nTFoot ? '' : ' '+classes.sNoFooter)
		} );
	
		oSettings.nHolding = holding[0];
		oSettings.nTableWrapper = insert[0];
		oSettings.nTableReinsertBefore = oSettings.nTable.nextSibling;
	
		/* Loop over the user set positioning and place the elements as needed */
		var aDom = oSettings.sDom.split('');
		var featureNode, cOption, nNewNode, cNext, sAttr, j;
		for ( var i=0 ; i<aDom.length ; i++ )
		{
			featureNode = null;
			cOption = aDom[i];
	
			if ( cOption == '<' )
			{
				/* New container div */
				nNewNode = $('<div/>')[0];
	
				/* Check to see if we should append an id and/or a class name to the container */
				cNext = aDom[i+1];
				if ( cNext == "'" || cNext == '"' )
				{
					sAttr = "";
					j = 2;
					while ( aDom[i+j] != cNext )
					{
						sAttr += aDom[i+j];
						j++;
					}
	
					/* Replace jQuery UI constants @todo depreciated */
					if ( sAttr == "H" )
					{
						sAttr = classes.sJUIHeader;
					}
					else if ( sAttr == "F" )
					{
						sAttr = classes.sJUIFooter;
					}
	
					/* The attribute can be in the format of "#id.class", "#id" or "class" This logic
					 * breaks the string into parts and applies them as needed
					 */
					if ( sAttr.indexOf('.') != -1 )
					{
						var aSplit = sAttr.split('.');
						nNewNode.id = aSplit[0].substr(1, aSplit[0].length-1);
						nNewNode.className = aSplit[1];
					}
					else if ( sAttr.charAt(0) == "#" )
					{
						nNewNode.id = sAttr.substr(1, sAttr.length-1);
					}
					else
					{
						nNewNode.className = sAttr;
					}
	
					i += j; /* Move along the position array */
				}
	
				insert.append( nNewNode );
				insert = $(nNewNode);
			}
			else if ( cOption == '>' )
			{
				/* End container div */
				insert = insert.parent();
			}
			// @todo Move options into their own plugins?
			else if ( cOption == 'l' && features.bPaginate && features.bLengthChange )
			{
				/* Length */
				featureNode = _fnFeatureHtmlLength( oSettings );
			}
			else if ( cOption == 'f' && features.bFilter )
			{
				/* Filter */
				featureNode = _fnFeatureHtmlFilter( oSettings );
			}
			else if ( cOption == 'r' && features.bProcessing )
			{
				/* pRocessing */
				featureNode = _fnFeatureHtmlProcessing( oSettings );
			}
			else if ( cOption == 't' )
			{
				/* Table */
				featureNode = _fnFeatureHtmlTable( oSettings );
			}
			else if ( cOption ==  'i' && features.bInfo )
			{
				/* Info */
				featureNode = _fnFeatureHtmlInfo( oSettings );
			}
			else if ( cOption == 'p' && features.bPaginate )
			{
				/* Pagination */
				featureNode = _fnFeatureHtmlPaginate( oSettings );
			}
			else if ( DataTable.ext.feature.length !== 0 )
			{
				/* Plug-in features */
				var aoFeatures = DataTable.ext.feature;
				for ( var k=0, kLen=aoFeatures.length ; k<kLen ; k++ )
				{
					if ( cOption == aoFeatures[k].cFeature )
					{
						featureNode = aoFeatures[k].fnInit( oSettings );
						break;
					}
				}
			}
	
			/* Add to the 2D features array */
			if ( featureNode )
			{
				var aanFeatures = oSettings.aanFeatures;
	
				if ( ! aanFeatures[cOption] )
				{
					aanFeatures[cOption] = [];
				}
	
				aanFeatures[cOption].push( featureNode );
				insert.append( featureNode );
			}
		}
	
		/* Built our DOM structure - replace the holding div with what we want */
		holding.replaceWith( insert );
		oSettings.nHolding = null;
	}
	
	
	/**
	 * Use the DOM source to create up an array of header cells. The idea here is to
	 * create a layout grid (array) of rows x columns, which contains a reference
	 * to the cell that that point in the grid (regardless of col/rowspan), such that
	 * any column / row could be removed and the new grid constructed
	 *  @param array {object} aLayout Array to store the calculated layout in
	 *  @param {node} nThead The header/footer element for the table
	 *  @memberof DataTable#oApi
	 */
	function _fnDetectHeader ( aLayout, nThead )
	{
		var nTrs = $(nThead).children('tr');
		var nTr, nCell;
		var i, k, l, iLen, jLen, iColShifted, iColumn, iColspan, iRowspan;
		var bUnique;
		var fnShiftCol = function ( a, i, j ) {
			var k = a[i];
	                while ( k[j] ) {
				j++;
			}
			return j;
		};
	
		aLayout.splice( 0, aLayout.length );
	
		/* We know how many rows there are in the layout - so prep it */
		for ( i=0, iLen=nTrs.length ; i<iLen ; i++ )
		{
			aLayout.push( [] );
		}
	
		/* Calculate a layout array */
		for ( i=0, iLen=nTrs.length ; i<iLen ; i++ )
		{
			nTr = nTrs[i];
			iColumn = 0;
	
			/* For every cell in the row... */
			nCell = nTr.firstChild;
			while ( nCell ) {
				if ( nCell.nodeName.toUpperCase() == "TD" ||
				     nCell.nodeName.toUpperCase() == "TH" )
				{
					/* Get the col and rowspan attributes from the DOM and sanitise them */
					iColspan = nCell.getAttribute('colspan') * 1;
					iRowspan = nCell.getAttribute('rowspan') * 1;
					iColspan = (!iColspan || iColspan===0 || iColspan===1) ? 1 : iColspan;
					iRowspan = (!iRowspan || iRowspan===0 || iRowspan===1) ? 1 : iRowspan;
	
					/* There might be colspan cells already in this row, so shift our target
					 * accordingly
					 */
					iColShifted = fnShiftCol( aLayout, i, iColumn );
	
					/* Cache calculation for unique columns */
					bUnique = iColspan === 1 ? true : false;
	
					/* If there is col / rowspan, copy the information into the layout grid */
					for ( l=0 ; l<iColspan ; l++ )
					{
						for ( k=0 ; k<iRowspan ; k++ )
						{
							aLayout[i+k][iColShifted+l] = {
								"cell": nCell,
								"unique": bUnique
							};
							aLayout[i+k].nTr = nTr;
						}
					}
				}
				nCell = nCell.nextSibling;
			}
		}
	}
	
	
	/**
	 * Get an array of unique th elements, one for each column
	 *  @param {object} oSettings dataTables settings object
	 *  @param {node} nHeader automatically detect the layout from this node - optional
	 *  @param {array} aLayout thead/tfoot layout from _fnDetectHeader - optional
	 *  @returns array {node} aReturn list of unique th's
	 *  @memberof DataTable#oApi
	 */
	function _fnGetUniqueThs ( oSettings, nHeader, aLayout )
	{
		var aReturn = [];
		if ( !aLayout )
		{
			aLayout = oSettings.aoHeader;
			if ( nHeader )
			{
				aLayout = [];
				_fnDetectHeader( aLayout, nHeader );
			}
		}
	
		for ( var i=0, iLen=aLayout.length ; i<iLen ; i++ )
		{
			for ( var j=0, jLen=aLayout[i].length ; j<jLen ; j++ )
			{
				if ( aLayout[i][j].unique &&
					 (!aReturn[j] || !oSettings.bSortCellsTop) )
				{
					aReturn[j] = aLayout[i][j].cell;
				}
			}
		}
	
		return aReturn;
	}
	
	/**
	 * Set the start position for draw
	 *  @param {object} oSettings dataTables settings object
	 */
	function _fnStart( oSettings )
	{
		var bServerSide = _fnDataSource( oSettings ) == 'ssp';
		var iInitDisplayStart = oSettings.iInitDisplayStart;
	
		// Check and see if we have an initial draw position from state saving
		if ( iInitDisplayStart !== undefined && iInitDisplayStart !== -1 )
		{
			oSettings._iDisplayStart = bServerSide ?
				iInitDisplayStart :
				iInitDisplayStart >= oSettings.fnRecordsDisplay() ?
					0 :
					iInitDisplayStart;
	
			oSettings.iInitDisplayStart = -1;
		}
	}
	
	/**
	 * Create an Ajax call based on the table's settings, taking into account that
	 * parameters can have multiple forms, and backwards compatibility.
	 *
	 * @param {object} oSettings dataTables settings object
	 * @param {array} data Data to send to the server, required by
	 *     DataTables - may be augmented by developer callbacks
	 * @param {function} fn Callback function to run when data is obtained
	 */
	function _fnBuildAjax( oSettings, data, fn )
	{
		// Compatibility with 1.9-, allow fnServerData and event to manipulate
		_fnCallbackFire( oSettings, 'aoServerParams', 'serverParams', [data] );
	
		// Convert to object based for 1.10+ if using the old array scheme which can
		// come from server-side processing or serverParams
		if ( data && Array.isArray(data) ) {
			var tmp = {};
			var rbracket = /(.*?)\[\]$/;
	
			$.each( data, function (key, val) {
				var match = val.name.match(rbracket);
	
				if ( match ) {
					// Support for arrays
					var name = match[0];
	
					if ( ! tmp[ name ] ) {
						tmp[ name ] = [];
					}
					tmp[ name ].push( val.value );
				}
				else {
					tmp[val.name] = val.value;
				}
			} );
			data = tmp;
		}
	
		var ajaxData;
		var ajax = oSettings.ajax;
		var instance = oSettings.oInstance;
		var callback = function ( json ) {
			var status = oSettings.jqXHR
				? oSettings.jqXHR.status
				: null;
	
			if ( json === null || (typeof status === 'number' && status == 204 ) ) {
				json = {};
				_fnAjaxDataSrc( oSettings, json, [] );
			}
	
			var error = json.error || json.sError;
			if ( error ) {
				_fnLog( oSettings, 0, error );
			}
	
			oSettings.json = json;
	
			_fnCallbackFire( oSettings, null, 'xhr', [oSettings, json, oSettings.jqXHR] );
			fn( json );
		};
	
		if ( $.isPlainObject( ajax ) && ajax.data )
		{
			ajaxData = ajax.data;
	
			var newData = typeof ajaxData === 'function' ?
				ajaxData( data, oSettings ) :  // fn can manipulate data or return
				ajaxData;                      // an object object or array to merge
	
			// If the function returned something, use that alone
			data = typeof ajaxData === 'function' && newData ?
				newData :
				$.extend( true, data, newData );
	
			// Remove the data property as we've resolved it already and don't want
			// jQuery to do it again (it is restored at the end of the function)
			delete ajax.data;
		}
	
		var baseAjax = {
			"data": data,
			"success": callback,
			"dataType": "json",
			"cache": false,
			"type": oSettings.sServerMethod,
			"error": function (xhr, error, thrown) {
				var ret = _fnCallbackFire( oSettings, null, 'xhr', [oSettings, null, oSettings.jqXHR] );
	
				if ( $.inArray( true, ret ) === -1 ) {
					if ( error == "parsererror" ) {
						_fnLog( oSettings, 0, 'Invalid JSON response', 1 );
					}
					else if ( xhr.readyState === 4 ) {
						_fnLog( oSettings, 0, 'Ajax error', 7 );
					}
				}
	
				_fnProcessingDisplay( oSettings, false );
			}
		};
	
		// Store the data submitted for the API
		oSettings.oAjaxData = data;
	
		// Allow plug-ins and external processes to modify the data
		_fnCallbackFire( oSettings, null, 'preXhr', [oSettings, data] );
	
		if ( oSettings.fnServerData )
		{
			// DataTables 1.9- compatibility
			oSettings.fnServerData.call( instance,
				oSettings.sAjaxSource,
				$.map( data, function (val, key) { // Need to convert back to 1.9 trad format
					return { name: key, value: val };
				} ),
				callback,
				oSettings
			);
		}
		else if ( oSettings.sAjaxSource || typeof ajax === 'string' )
		{
			// DataTables 1.9- compatibility
			oSettings.jqXHR = $.ajax( $.extend( baseAjax, {
				url: ajax || oSettings.sAjaxSource
			} ) );
		}
		else if ( typeof ajax === 'function' )
		{
			// Is a function - let the caller define what needs to be done
			oSettings.jqXHR = ajax.call( instance, data, callback, oSettings );
		}
		else
		{
			// Object to extend the base settings
			oSettings.jqXHR = $.ajax( $.extend( baseAjax, ajax ) );
	
			// Restore for next time around
			ajax.data = ajaxData;
		}
	}
	
	
	/**
	 * Update the table using an Ajax call
	 *  @param {object} settings dataTables settings object
	 *  @returns {boolean} Block the table drawing or not
	 *  @memberof DataTable#oApi
	 */
	function _fnAjaxUpdate( settings )
	{
		settings.iDraw++;
		_fnProcessingDisplay( settings, true );
	
		// Keep track of drawHold state to handle scrolling after the Ajax call
		var drawHold = settings._drawHold;
	
		_fnBuildAjax(
			settings,
			_fnAjaxParameters( settings ),
			function(json) {
				settings._drawHold = drawHold;
				_fnAjaxUpdateDraw( settings, json );
				settings._drawHold = false;
			}
		);
	}
	
	
	/**
	 * Build up the parameters in an object needed for a server-side processing
	 * request. Note that this is basically done twice, is different ways - a modern
	 * method which is used by default in DataTables 1.10 which uses objects and
	 * arrays, or the 1.9- method with is name / value pairs. 1.9 method is used if
	 * the sAjaxSource option is used in the initialisation, or the legacyAjax
	 * option is set.
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {bool} block the table drawing or not
	 *  @memberof DataTable#oApi
	 */
	function _fnAjaxParameters( settings )
	{
		var
			columns = settings.aoColumns,
			columnCount = columns.length,
			features = settings.oFeatures,
			preSearch = settings.oPreviousSearch,
			preColSearch = settings.aoPreSearchCols,
			i, data = [], dataProp, column, columnSearch,
			sort = _fnSortFlatten( settings ),
			displayStart = settings._iDisplayStart,
			displayLength = features.bPaginate !== false ?
				settings._iDisplayLength :
				-1;
	
		var param = function ( name, value ) {
			data.push( { 'name': name, 'value': value } );
		};
	
		// DataTables 1.9- compatible method
		param( 'sEcho',          settings.iDraw );
		param( 'iColumns',       columnCount );
		param( 'sColumns',       _pluck( columns, 'sName' ).join(',') );
		param( 'iDisplayStart',  displayStart );
		param( 'iDisplayLength', displayLength );
	
		// DataTables 1.10+ method
		var d = {
			draw:    settings.iDraw,
			columns: [],
			order:   [],
			start:   displayStart,
			length:  displayLength,
			search:  {
				value: preSearch.sSearch,
				regex: preSearch.bRegex
			}
		};
	
		for ( i=0 ; i<columnCount ; i++ ) {
			column = columns[i];
			columnSearch = preColSearch[i];
			dataProp = typeof column.mData=="function" ? 'function' : column.mData ;
	
			d.columns.push( {
				data:       dataProp,
				name:       column.sName,
				searchable: column.bSearchable,
				orderable:  column.bSortable,
				search:     {
					value: columnSearch.sSearch,
					regex: columnSearch.bRegex
				}
			} );
	
			param( "mDataProp_"+i, dataProp );
	
			if ( features.bFilter ) {
				param( 'sSearch_'+i,     columnSearch.sSearch );
				param( 'bRegex_'+i,      columnSearch.bRegex );
				param( 'bSearchable_'+i, column.bSearchable );
			}
	
			if ( features.bSort ) {
				param( 'bSortable_'+i, column.bSortable );
			}
		}
	
		if ( features.bFilter ) {
			param( 'sSearch', preSearch.sSearch );
			param( 'bRegex', preSearch.bRegex );
		}
	
		if ( features.bSort ) {
			$.each( sort, function ( i, val ) {
				d.order.push( { column: val.col, dir: val.dir } );
	
				param( 'iSortCol_'+i, val.col );
				param( 'sSortDir_'+i, val.dir );
			} );
	
			param( 'iSortingCols', sort.length );
		}
	
		// If the legacy.ajax parameter is null, then we automatically decide which
		// form to use, based on sAjaxSource
		var legacy = DataTable.ext.legacy.ajax;
		if ( legacy === null ) {
			return settings.sAjaxSource ? data : d;
		}
	
		// Otherwise, if legacy has been specified then we use that to decide on the
		// form
		return legacy ? data : d;
	}
	
	
	/**
	 * Data the data from the server (nuking the old) and redraw the table
	 *  @param {object} oSettings dataTables settings object
	 *  @param {object} json json data return from the server.
	 *  @param {string} json.sEcho Tracking flag for DataTables to match requests
	 *  @param {int} json.iTotalRecords Number of records in the data set, not accounting for filtering
	 *  @param {int} json.iTotalDisplayRecords Number of records in the data set, accounting for filtering
	 *  @param {array} json.aaData The data to display on this page
	 *  @param {string} [json.sColumns] Column ordering (sName, comma separated)
	 *  @memberof DataTable#oApi
	 */
	function _fnAjaxUpdateDraw ( settings, json )
	{
		// v1.10 uses camelCase variables, while 1.9 uses Hungarian notation.
		// Support both
		var compat = function ( old, modern ) {
			return json[old] !== undefined ? json[old] : json[modern];
		};
	
		var data = _fnAjaxDataSrc( settings, json );
		var draw            = compat( 'sEcho',                'draw' );
		var recordsTotal    = compat( 'iTotalRecords',        'recordsTotal' );
		var recordsFiltered = compat( 'iTotalDisplayRecords', 'recordsFiltered' );
	
		if ( draw !== undefined ) {
			// Protect against out of sequence returns
			if ( draw*1 < settings.iDraw ) {
				return;
			}
			settings.iDraw = draw * 1;
		}
	
		// No data in returned object, so rather than an array, we show an empty table
		if ( ! data ) {
			data = [];
		}
	
		_fnClearTable( settings );
		settings._iRecordsTotal   = parseInt(recordsTotal, 10);
		settings._iRecordsDisplay = parseInt(recordsFiltered, 10);
	
		for ( var i=0, ien=data.length ; i<ien ; i++ ) {
			_fnAddData( settings, data[i] );
		}
		settings.aiDisplay = settings.aiDisplayMaster.slice();
	
		_fnDraw( settings, true );
	
		if ( ! settings._bInitComplete ) {
			_fnInitComplete( settings, json );
		}
	
		_fnProcessingDisplay( settings, false );
	}
	
	
	/**
	 * Get the data from the JSON data source to use for drawing a table. Using
	 * `_fnGetObjectDataFn` allows the data to be sourced from a property of the
	 * source object, or from a processing function.
	 *  @param {object} oSettings dataTables settings object
	 *  @param  {object} json Data source object / array from the server
	 *  @return {array} Array of data to use
	 */
	 function _fnAjaxDataSrc ( oSettings, json, write )
	 {
		var dataSrc = $.isPlainObject( oSettings.ajax ) && oSettings.ajax.dataSrc !== undefined ?
			oSettings.ajax.dataSrc :
			oSettings.sAjaxDataProp; // Compatibility with 1.9-.
	
		if ( ! write ) {
			if ( dataSrc === 'data' ) {
				// If the default, then we still want to support the old style, and safely ignore
				// it if possible
				return json.aaData || json[dataSrc];
			}
	
			return dataSrc !== "" ?
				_fnGetObjectDataFn( dataSrc )( json ) :
				json;
		}
	
		// set
		_fnSetObjectDataFn( dataSrc )( json, write );
	}
	
	/**
	 * Generate the node required for filtering text
	 *  @returns {node} Filter control element
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnFeatureHtmlFilter ( settings )
	{
		var classes = settings.oClasses;
		var tableId = settings.sTableId;
		var language = settings.oLanguage;
		var previousSearch = settings.oPreviousSearch;
		var features = settings.aanFeatures;
		var input = '<input type="search" class="'+classes.sFilterInput+'"/>';
	
		var str = language.sSearch;
		str = str.match(/_INPUT_/) ?
			str.replace('_INPUT_', input) :
			str+input;
	
		var filter = $('<div/>', {
				'id': ! features.f ? tableId+'_filter' : null,
				'class': classes.sFilter
			} )
			.append( $('<label/>' ).append( str ) );
	
		var searchFn = function(event) {
			/* Update all other filter input elements for the new display */
			var n = features.f;
			var val = !this.value ? "" : this.value; // mental IE8 fix :-(
			if(previousSearch['return'] && event.key !== "Enter") {
				return;
			}
			/* Now do the filter */
			if ( val != previousSearch.sSearch ) {
				_fnFilterComplete( settings, {
					"sSearch": val,
					"bRegex": previousSearch.bRegex,
					"bSmart": previousSearch.bSmart ,
					"bCaseInsensitive": previousSearch.bCaseInsensitive,
					"return": previousSearch['return']
				} );
	
				// Need to redraw, without resorting
				settings._iDisplayStart = 0;
				_fnDraw( settings );
			}
		};
	
		var searchDelay = settings.searchDelay !== null ?
			settings.searchDelay :
			_fnDataSource( settings ) === 'ssp' ?
				400 :
				0;
	
		var jqFilter = $('input', filter)
			.val( previousSearch.sSearch )
			.attr( 'placeholder', language.sSearchPlaceholder )
			.on(
				'keyup.DT search.DT input.DT paste.DT cut.DT',
				searchDelay ?
					_fnThrottle( searchFn, searchDelay ) :
					searchFn
			)
			.on( 'mouseup.DT', function(e) {
				// Edge fix! Edge 17 does not trigger anything other than mouse events when clicking
				// on the clear icon (Edge bug 17584515). This is safe in other browsers as `searchFn`
				// checks the value to see if it has changed. In other browsers it won't have.
				setTimeout( function () {
					searchFn.call(jqFilter[0], e);
				}, 10);
			} )
			.on( 'keypress.DT', function(e) {
				/* Prevent form submission */
				if ( e.keyCode == 13 ) {
					return false;
				}
			} )
			.attr('aria-controls', tableId);
	
		// Update the input elements whenever the table is filtered
		$(settings.nTable).on( 'search.dt.DT', function ( ev, s ) {
			if ( settings === s ) {
				// IE9 throws an 'unknown error' if document.activeElement is used
				// inside an iframe or frame...
				try {
					if ( jqFilter[0] !== document.activeElement ) {
						jqFilter.val( previousSearch.sSearch );
					}
				}
				catch ( e ) {}
			}
		} );
	
		return filter[0];
	}
	
	
	/**
	 * Filter the table using both the global filter and column based filtering
	 *  @param {object} oSettings dataTables settings object
	 *  @param {object} oSearch search information
	 *  @param {int} [iForce] force a research of the master array (1) or not (undefined or 0)
	 *  @memberof DataTable#oApi
	 */
	function _fnFilterComplete ( oSettings, oInput, iForce )
	{
		var oPrevSearch = oSettings.oPreviousSearch;
		var aoPrevSearch = oSettings.aoPreSearchCols;
		var fnSaveFilter = function ( oFilter ) {
			/* Save the filtering values */
			oPrevSearch.sSearch = oFilter.sSearch;
			oPrevSearch.bRegex = oFilter.bRegex;
			oPrevSearch.bSmart = oFilter.bSmart;
			oPrevSearch.bCaseInsensitive = oFilter.bCaseInsensitive;
			oPrevSearch['return'] = oFilter['return'];
		};
		var fnRegex = function ( o ) {
			// Backwards compatibility with the bEscapeRegex option
			return o.bEscapeRegex !== undefined ? !o.bEscapeRegex : o.bRegex;
		};
	
		// Resolve any column types that are unknown due to addition or invalidation
		// @todo As per sort - can this be moved into an event handler?
		_fnColumnTypes( oSettings );
	
		/* In server-side processing all filtering is done by the server, so no point hanging around here */
		if ( _fnDataSource( oSettings ) != 'ssp' )
		{
			/* Global filter */
			_fnFilter( oSettings, oInput.sSearch, iForce, fnRegex(oInput), oInput.bSmart, oInput.bCaseInsensitive );
			fnSaveFilter( oInput );
	
			/* Now do the individual column filter */
			for ( var i=0 ; i<aoPrevSearch.length ; i++ )
			{
				_fnFilterColumn( oSettings, aoPrevSearch[i].sSearch, i, fnRegex(aoPrevSearch[i]),
					aoPrevSearch[i].bSmart, aoPrevSearch[i].bCaseInsensitive );
			}
	
			/* Custom filtering */
			_fnFilterCustom( oSettings );
		}
		else
		{
			fnSaveFilter( oInput );
		}
	
		/* Tell the draw function we have been filtering */
		oSettings.bFiltered = true;
		_fnCallbackFire( oSettings, null, 'search', [oSettings] );
	}
	
	
	/**
	 * Apply custom filtering functions
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnFilterCustom( settings )
	{
		var filters = DataTable.ext.search;
		var displayRows = settings.aiDisplay;
		var row, rowIdx;
	
		for ( var i=0, ien=filters.length ; i<ien ; i++ ) {
			var rows = [];
	
			// Loop over each row and see if it should be included
			for ( var j=0, jen=displayRows.length ; j<jen ; j++ ) {
				rowIdx = displayRows[ j ];
				row = settings.aoData[ rowIdx ];
	
				if ( filters[i]( settings, row._aFilterData, rowIdx, row._aData, j ) ) {
					rows.push( rowIdx );
				}
			}
	
			// So the array reference doesn't break set the results into the
			// existing array
			displayRows.length = 0;
			$.merge( displayRows, rows );
		}
	}
	
	
	/**
	 * Filter the table on a per-column basis
	 *  @param {object} oSettings dataTables settings object
	 *  @param {string} sInput string to filter on
	 *  @param {int} iColumn column to filter
	 *  @param {bool} bRegex treat search string as a regular expression or not
	 *  @param {bool} bSmart use smart filtering or not
	 *  @param {bool} bCaseInsensitive Do case insensitive matching or not
	 *  @memberof DataTable#oApi
	 */
	function _fnFilterColumn ( settings, searchStr, colIdx, regex, smart, caseInsensitive )
	{
		if ( searchStr === '' ) {
			return;
		}
	
		var data;
		var out = [];
		var display = settings.aiDisplay;
		var rpSearch = _fnFilterCreateSearch( searchStr, regex, smart, caseInsensitive );
	
		for ( var i=0 ; i<display.length ; i++ ) {
			data = settings.aoData[ display[i] ]._aFilterData[ colIdx ];
	
			if ( rpSearch.test( data ) ) {
				out.push( display[i] );
			}
		}
	
		settings.aiDisplay = out;
	}
	
	
	/**
	 * Filter the data table based on user input and draw the table
	 *  @param {object} settings dataTables settings object
	 *  @param {string} input string to filter on
	 *  @param {int} force optional - force a research of the master array (1) or not (undefined or 0)
	 *  @param {bool} regex treat as a regular expression or not
	 *  @param {bool} smart perform smart filtering or not
	 *  @param {bool} caseInsensitive Do case insensitive matching or not
	 *  @memberof DataTable#oApi
	 */
	function _fnFilter( settings, input, force, regex, smart, caseInsensitive )
	{
		var rpSearch = _fnFilterCreateSearch( input, regex, smart, caseInsensitive );
		var prevSearch = settings.oPreviousSearch.sSearch;
		var displayMaster = settings.aiDisplayMaster;
		var display, invalidated, i;
		var filtered = [];
	
		// Need to take account of custom filtering functions - always filter
		if ( DataTable.ext.search.length !== 0 ) {
			force = true;
		}
	
		// Check if any of the rows were invalidated
		invalidated = _fnFilterData( settings );
	
		// If the input is blank - we just want the full data set
		if ( input.length <= 0 ) {
			settings.aiDisplay = displayMaster.slice();
		}
		else {
			// New search - start from the master array
			if ( invalidated ||
				 force ||
				 regex ||
				 prevSearch.length > input.length ||
				 input.indexOf(prevSearch) !== 0 ||
				 settings.bSorted // On resort, the display master needs to be
				                  // re-filtered since indexes will have changed
			) {
				settings.aiDisplay = displayMaster.slice();
			}
	
			// Search the display array
			display = settings.aiDisplay;
	
			for ( i=0 ; i<display.length ; i++ ) {
				if ( rpSearch.test( settings.aoData[ display[i] ]._sFilterRow ) ) {
					filtered.push( display[i] );
				}
			}
	
			settings.aiDisplay = filtered;
		}
	}
	
	
	/**
	 * Build a regular expression object suitable for searching a table
	 *  @param {string} sSearch string to search for
	 *  @param {bool} bRegex treat as a regular expression or not
	 *  @param {bool} bSmart perform smart filtering or not
	 *  @param {bool} bCaseInsensitive Do case insensitive matching or not
	 *  @returns {RegExp} constructed object
	 *  @memberof DataTable#oApi
	 */
	function _fnFilterCreateSearch( search, regex, smart, caseInsensitive )
	{
		search = regex ?
			search :
			_fnEscapeRegex( search );
		
		if ( smart ) {
			/* For smart filtering we want to allow the search to work regardless of
			 * word order. We also want double quoted text to be preserved, so word
			 * order is important - a la google. So this is what we want to
			 * generate:
			 * 
			 * ^(?=.*?\bone\b)(?=.*?\btwo three\b)(?=.*?\bfour\b).*$
			 */
			var a = $.map( search.match( /["\u201C][^"\u201D]+["\u201D]|[^ ]+/g ) || [''], function ( word ) {
				if ( word.charAt(0) === '"' ) {
					var m = word.match( /^"(.*)"$/ );
					word = m ? m[1] : word;
				}
				else if ( word.charAt(0) === '\u201C' ) {
					var m = word.match( /^\u201C(.*)\u201D$/ );
					word = m ? m[1] : word;
				}
	
				return word.replace('"', '');
			} );
	
			search = '^(?=.*?'+a.join( ')(?=.*?' )+').*$';
		}
	
		return new RegExp( search, caseInsensitive ? 'i' : '' );
	}
	
	
	/**
	 * Escape a string such that it can be used in a regular expression
	 *  @param {string} sVal string to escape
	 *  @returns {string} escaped string
	 *  @memberof DataTable#oApi
	 */
	var _fnEscapeRegex = DataTable.util.escapeRegex;
	
	var __filter_div = $('<div>')[0];
	var __filter_div_textContent = __filter_div.textContent !== undefined;
	
	// Update the filtering data for each row if needed (by invalidation or first run)
	function _fnFilterData ( settings )
	{
		var columns = settings.aoColumns;
		var column;
		var i, j, ien, jen, filterData, cellData, row;
		var wasInvalidated = false;
	
		for ( i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
			row = settings.aoData[i];
	
			if ( ! row._aFilterData ) {
				filterData = [];
	
				for ( j=0, jen=columns.length ; j<jen ; j++ ) {
					column = columns[j];
	
					if ( column.bSearchable ) {
						cellData = _fnGetCellData( settings, i, j, 'filter' );
	
						// Search in DataTables 1.10 is string based. In 1.11 this
						// should be altered to also allow strict type checking.
						if ( cellData === null ) {
							cellData = '';
						}
	
						if ( typeof cellData !== 'string' && cellData.toString ) {
							cellData = cellData.toString();
						}
					}
					else {
						cellData = '';
					}
	
					// If it looks like there is an HTML entity in the string,
					// attempt to decode it so sorting works as expected. Note that
					// we could use a single line of jQuery to do this, but the DOM
					// method used here is much faster https://jsperf.com/html-decode
					if ( cellData.indexOf && cellData.indexOf('&') !== -1 ) {
						__filter_div.innerHTML = cellData;
						cellData = __filter_div_textContent ?
							__filter_div.textContent :
							__filter_div.innerText;
					}
	
					if ( cellData.replace ) {
						cellData = cellData.replace(/[\r\n\u2028]/g, '');
					}
	
					filterData.push( cellData );
				}
	
				row._aFilterData = filterData;
				row._sFilterRow = filterData.join('  ');
				wasInvalidated = true;
			}
		}
	
		return wasInvalidated;
	}
	
	
	/**
	 * Convert from the internal Hungarian notation to camelCase for external
	 * interaction
	 *  @param {object} obj Object to convert
	 *  @returns {object} Inverted object
	 *  @memberof DataTable#oApi
	 */
	function _fnSearchToCamel ( obj )
	{
		return {
			search:          obj.sSearch,
			smart:           obj.bSmart,
			regex:           obj.bRegex,
			caseInsensitive: obj.bCaseInsensitive
		};
	}
	
	
	
	/**
	 * Convert from camelCase notation to the internal Hungarian. We could use the
	 * Hungarian convert function here, but this is cleaner
	 *  @param {object} obj Object to convert
	 *  @returns {object} Inverted object
	 *  @memberof DataTable#oApi
	 */
	function _fnSearchToHung ( obj )
	{
		return {
			sSearch:          obj.search,
			bSmart:           obj.smart,
			bRegex:           obj.regex,
			bCaseInsensitive: obj.caseInsensitive
		};
	}
	
	/**
	 * Generate the node required for the info display
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {node} Information element
	 *  @memberof DataTable#oApi
	 */
	function _fnFeatureHtmlInfo ( settings )
	{
		var
			tid = settings.sTableId,
			nodes = settings.aanFeatures.i,
			n = $('<div/>', {
				'class': settings.oClasses.sInfo,
				'id': ! nodes ? tid+'_info' : null
			} );
	
		if ( ! nodes ) {
			// Update display on each draw
			settings.aoDrawCallback.push( {
				"fn": _fnUpdateInfo,
				"sName": "information"
			} );
	
			n
				.attr( 'role', 'status' )
				.attr( 'aria-live', 'polite' );
	
			// Table is described by our info div
			$(settings.nTable).attr( 'aria-describedby', tid+'_info' );
		}
	
		return n[0];
	}
	
	
	/**
	 * Update the information elements in the display
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnUpdateInfo ( settings )
	{
		/* Show information about the table */
		var nodes = settings.aanFeatures.i;
		if ( nodes.length === 0 ) {
			return;
		}
	
		var
			lang  = settings.oLanguage,
			start = settings._iDisplayStart+1,
			end   = settings.fnDisplayEnd(),
			max   = settings.fnRecordsTotal(),
			total = settings.fnRecordsDisplay(),
			out   = total ?
				lang.sInfo :
				lang.sInfoEmpty;
	
		if ( total !== max ) {
			/* Record set after filtering */
			out += ' ' + lang.sInfoFiltered;
		}
	
		// Convert the macros
		out += lang.sInfoPostFix;
		out = _fnInfoMacros( settings, out );
	
		var callback = lang.fnInfoCallback;
		if ( callback !== null ) {
			out = callback.call( settings.oInstance,
				settings, start, end, max, total, out
			);
		}
	
		$(nodes).html( out );
	}
	
	
	function _fnInfoMacros ( settings, str )
	{
		// When infinite scrolling, we are always starting at 1. _iDisplayStart is used only
		// internally
		var
			formatter  = settings.fnFormatNumber,
			start      = settings._iDisplayStart+1,
			len        = settings._iDisplayLength,
			vis        = settings.fnRecordsDisplay(),
			all        = len === -1;
	
		return str.
			replace(/_START_/g, formatter.call( settings, start ) ).
			replace(/_END_/g,   formatter.call( settings, settings.fnDisplayEnd() ) ).
			replace(/_MAX_/g,   formatter.call( settings, settings.fnRecordsTotal() ) ).
			replace(/_TOTAL_/g, formatter.call( settings, vis ) ).
			replace(/_PAGE_/g,  formatter.call( settings, all ? 1 : Math.ceil( start / len ) ) ).
			replace(/_PAGES_/g, formatter.call( settings, all ? 1 : Math.ceil( vis / len ) ) );
	}
	
	
	
	/**
	 * Draw the table for the first time, adding all required features
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnInitialise ( settings )
	{
		var i, iLen, iAjaxStart=settings.iInitDisplayStart;
		var columns = settings.aoColumns, column;
		var features = settings.oFeatures;
		var deferLoading = settings.bDeferLoading; // value modified by the draw
	
		/* Ensure that the table data is fully initialised */
		if ( ! settings.bInitialised ) {
			setTimeout( function(){ _fnInitialise( settings ); }, 200 );
			return;
		}
	
		/* Show the display HTML options */
		_fnAddOptionsHtml( settings );
	
		/* Build and draw the header / footer for the table */
		_fnBuildHead( settings );
		_fnDrawHead( settings, settings.aoHeader );
		_fnDrawHead( settings, settings.aoFooter );
	
		/* Okay to show that something is going on now */
		_fnProcessingDisplay( settings, true );
	
		/* Calculate sizes for columns */
		if ( features.bAutoWidth ) {
			_fnCalculateColumnWidths( settings );
		}
	
		for ( i=0, iLen=columns.length ; i<iLen ; i++ ) {
			column = columns[i];
	
			if ( column.sWidth ) {
				column.nTh.style.width = _fnStringToCss( column.sWidth );
			}
		}
	
		_fnCallbackFire( settings, null, 'preInit', [settings] );
	
		// If there is default sorting required - let's do it. The sort function
		// will do the drawing for us. Otherwise we draw the table regardless of the
		// Ajax source - this allows the table to look initialised for Ajax sourcing
		// data (show 'loading' message possibly)
		_fnReDraw( settings );
	
		// Server-side processing init complete is done by _fnAjaxUpdateDraw
		var dataSrc = _fnDataSource( settings );
		if ( dataSrc != 'ssp' || deferLoading ) {
			// if there is an ajax source load the data
			if ( dataSrc == 'ajax' ) {
				_fnBuildAjax( settings, [], function(json) {
					var aData = _fnAjaxDataSrc( settings, json );
	
					// Got the data - add it to the table
					for ( i=0 ; i<aData.length ; i++ ) {
						_fnAddData( settings, aData[i] );
					}
	
					// Reset the init display for cookie saving. We've already done
					// a filter, and therefore cleared it before. So we need to make
					// it appear 'fresh'
					settings.iInitDisplayStart = iAjaxStart;
	
					_fnReDraw( settings );
	
					_fnProcessingDisplay( settings, false );
					_fnInitComplete( settings, json );
				}, settings );
			}
			else {
				_fnProcessingDisplay( settings, false );
				_fnInitComplete( settings );
			}
		}
	}
	
	
	/**
	 * Draw the table for the first time, adding all required features
	 *  @param {object} oSettings dataTables settings object
	 *  @param {object} [json] JSON from the server that completed the table, if using Ajax source
	 *    with client-side processing (optional)
	 *  @memberof DataTable#oApi
	 */
	function _fnInitComplete ( settings, json )
	{
		settings._bInitComplete = true;
	
		// When data was added after the initialisation (data or Ajax) we need to
		// calculate the column sizing
		if ( json || settings.oInit.aaData ) {
			_fnAdjustColumnSizing( settings );
		}
	
		_fnCallbackFire( settings, null, 'plugin-init', [settings, json] );
		_fnCallbackFire( settings, 'aoInitComplete', 'init', [settings, json] );
	}
	
	
	function _fnLengthChange ( settings, val )
	{
		var len = parseInt( val, 10 );
		settings._iDisplayLength = len;
	
		_fnLengthOverflow( settings );
	
		// Fire length change event
		_fnCallbackFire( settings, null, 'length', [settings, len] );
	}
	
	
	/**
	 * Generate the node required for user display length changing
	 *  @param {object} settings dataTables settings object
	 *  @returns {node} Display length feature node
	 *  @memberof DataTable#oApi
	 */
	function _fnFeatureHtmlLength ( settings )
	{
		var
			classes  = settings.oClasses,
			tableId  = settings.sTableId,
			menu     = settings.aLengthMenu,
			d2       = Array.isArray( menu[0] ),
			lengths  = d2 ? menu[0] : menu,
			language = d2 ? menu[1] : menu;
	
		var select = $('<select/>', {
			'name':          tableId+'_length',
			'aria-controls': tableId,
			'class':         classes.sLengthSelect
		} );
	
		for ( var i=0, ien=lengths.length ; i<ien ; i++ ) {
			select[0][ i ] = new Option(
				typeof language[i] === 'number' ?
					settings.fnFormatNumber( language[i] ) :
					language[i],
				lengths[i]
			);
		}
	
		var div = $('<div><label/></div>').addClass( classes.sLength );
		if ( ! settings.aanFeatures.l ) {
			div[0].id = tableId+'_length';
		}
	
		div.children().append(
			settings.oLanguage.sLengthMenu.replace( '_MENU_', select[0].outerHTML )
		);
	
		// Can't use `select` variable as user might provide their own and the
		// reference is broken by the use of outerHTML
		$('select', div)
			.val( settings._iDisplayLength )
			.on( 'change.DT', function(e) {
				_fnLengthChange( settings, $(this).val() );
				_fnDraw( settings );
			} );
	
		// Update node value whenever anything changes the table's length
		$(settings.nTable).on( 'length.dt.DT', function (e, s, len) {
			if ( settings === s ) {
				$('select', div).val( len );
			}
		} );
	
		return div[0];
	}
	
	
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Note that most of the paging logic is done in
	 * DataTable.ext.pager
	 */
	
	/**
	 * Generate the node required for default pagination
	 *  @param {object} oSettings dataTables settings object
	 *  @returns {node} Pagination feature node
	 *  @memberof DataTable#oApi
	 */
	function _fnFeatureHtmlPaginate ( settings )
	{
		var
			type   = settings.sPaginationType,
			plugin = DataTable.ext.pager[ type ],
			modern = typeof plugin === 'function',
			redraw = function( settings ) {
				_fnDraw( settings );
			},
			node = $('<div/>').addClass( settings.oClasses.sPaging + type )[0],
			features = settings.aanFeatures;
	
		if ( ! modern ) {
			plugin.fnInit( settings, node, redraw );
		}
	
		/* Add a draw callback for the pagination on first instance, to update the paging display */
		if ( ! features.p )
		{
			node.id = settings.sTableId+'_paginate';
	
			settings.aoDrawCallback.push( {
				"fn": function( settings ) {
					if ( modern ) {
						var
							start      = settings._iDisplayStart,
							len        = settings._iDisplayLength,
							visRecords = settings.fnRecordsDisplay(),
							all        = len === -1,
							page = all ? 0 : Math.ceil( start / len ),
							pages = all ? 1 : Math.ceil( visRecords / len ),
							buttons = plugin(page, pages),
							i, ien;
	
						for ( i=0, ien=features.p.length ; i<ien ; i++ ) {
							_fnRenderer( settings, 'pageButton' )(
								settings, features.p[i], i, buttons, page, pages
							);
						}
					}
					else {
						plugin.fnUpdate( settings, redraw );
					}
				},
				"sName": "pagination"
			} );
		}
	
		return node;
	}
	
	
	/**
	 * Alter the display settings to change the page
	 *  @param {object} settings DataTables settings object
	 *  @param {string|int} action Paging action to take: "first", "previous",
	 *    "next" or "last" or page number to jump to (integer)
	 *  @param [bool] redraw Automatically draw the update or not
	 *  @returns {bool} true page has changed, false - no change
	 *  @memberof DataTable#oApi
	 */
	function _fnPageChange ( settings, action, redraw )
	{
		var
			start     = settings._iDisplayStart,
			len       = settings._iDisplayLength,
			records   = settings.fnRecordsDisplay();
	
		if ( records === 0 || len === -1 )
		{
			start = 0;
		}
		else if ( typeof action === "number" )
		{
			start = action * len;
	
			if ( start > records )
			{
				start = 0;
			}
		}
		else if ( action == "first" )
		{
			start = 0;
		}
		else if ( action == "previous" )
		{
			start = len >= 0 ?
				start - len :
				0;
	
			if ( start < 0 )
			{
			  start = 0;
			}
		}
		else if ( action == "next" )
		{
			if ( start + len < records )
			{
				start += len;
			}
		}
		else if ( action == "last" )
		{
			start = Math.floor( (records-1) / len) * len;
		}
		else
		{
			_fnLog( settings, 0, "Unknown paging action: "+action, 5 );
		}
	
		var changed = settings._iDisplayStart !== start;
		settings._iDisplayStart = start;
	
		if ( changed ) {
			_fnCallbackFire( settings, null, 'page', [settings] );
	
			if ( redraw ) {
				_fnDraw( settings );
			}
		}
		else {
			// No change event - paging was called, but no change
			_fnCallbackFire( settings, null, 'page-nc', [settings] );
		}
	
		return changed;
	}
	
	
	
	/**
	 * Generate the node required for the processing node
	 *  @param {object} settings dataTables settings object
	 *  @returns {node} Processing element
	 *  @memberof DataTable#oApi
	 */
	function _fnFeatureHtmlProcessing ( settings )
	{
		return $('<div/>', {
				'id': ! settings.aanFeatures.r ? settings.sTableId+'_processing' : null,
				'class': settings.oClasses.sProcessing,
				'role': 'status'
			} )
			.html( settings.oLanguage.sProcessing )
			.append('<div><div></div><div></div><div></div><div></div></div>')
			.insertBefore( settings.nTable )[0];
	}
	
	
	/**
	 * Display or hide the processing indicator
	 *  @param {object} settings dataTables settings object
	 *  @param {bool} show Show the processing indicator (true) or not (false)
	 *  @memberof DataTable#oApi
	 */
	function _fnProcessingDisplay ( settings, show )
	{
		if ( settings.oFeatures.bProcessing ) {
			$(settings.aanFeatures.r).css( 'display', show ? 'block' : 'none' );
		}
	
		_fnCallbackFire( settings, null, 'processing', [settings, show] );
	}
	
	/**
	 * Add any control elements for the table - specifically scrolling
	 *  @param {object} settings dataTables settings object
	 *  @returns {node} Node to add to the DOM
	 *  @memberof DataTable#oApi
	 */
	function _fnFeatureHtmlTable ( settings )
	{
		var table = $(settings.nTable);
	
		// Scrolling from here on in
		var scroll = settings.oScroll;
	
		if ( scroll.sX === '' && scroll.sY === '' ) {
			return settings.nTable;
		}
	
		var scrollX = scroll.sX;
		var scrollY = scroll.sY;
		var classes = settings.oClasses;
		var caption = table.children('caption');
		var captionSide = caption.length ? caption[0]._captionSide : null;
		var headerClone = $( table[0].cloneNode(false) );
		var footerClone = $( table[0].cloneNode(false) );
		var footer = table.children('tfoot');
		var _div = '<div/>';
		var size = function ( s ) {
			return !s ? null : _fnStringToCss( s );
		};
	
		if ( ! footer.length ) {
			footer = null;
		}
	
		/*
		 * The HTML structure that we want to generate in this function is:
		 *  div - scroller
		 *    div - scroll head
		 *      div - scroll head inner
		 *        table - scroll head table
		 *          thead - thead
		 *    div - scroll body
		 *      table - table (master table)
		 *        thead - thead clone for sizing
		 *        tbody - tbody
		 *    div - scroll foot
		 *      div - scroll foot inner
		 *        table - scroll foot table
		 *          tfoot - tfoot
		 */
		var scroller = $( _div, { 'class': classes.sScrollWrapper } )
			.append(
				$(_div, { 'class': classes.sScrollHead } )
					.css( {
						overflow: 'hidden',
						position: 'relative',
						border: 0,
						width: scrollX ? size(scrollX) : '100%'
					} )
					.append(
						$(_div, { 'class': classes.sScrollHeadInner } )
							.css( {
								'box-sizing': 'content-box',
								width: scroll.sXInner || '100%'
							} )
							.append(
								headerClone
									.removeAttr('id')
									.css( 'margin-left', 0 )
									.append( captionSide === 'top' ? caption : null )
									.append(
										table.children('thead')
									)
							)
					)
			)
			.append(
				$(_div, { 'class': classes.sScrollBody } )
					.css( {
						position: 'relative',
						overflow: 'auto',
						width: size( scrollX )
					} )
					.append( table )
			);
	
		if ( footer ) {
			scroller.append(
				$(_div, { 'class': classes.sScrollFoot } )
					.css( {
						overflow: 'hidden',
						border: 0,
						width: scrollX ? size(scrollX) : '100%'
					} )
					.append(
						$(_div, { 'class': classes.sScrollFootInner } )
							.append(
								footerClone
									.removeAttr('id')
									.css( 'margin-left', 0 )
									.append( captionSide === 'bottom' ? caption : null )
									.append(
										table.children('tfoot')
									)
							)
					)
			);
		}
	
		var children = scroller.children();
		var scrollHead = children[0];
		var scrollBody = children[1];
		var scrollFoot = footer ? children[2] : null;
	
		// When the body is scrolled, then we also want to scroll the headers
		if ( scrollX ) {
			$(scrollBody).on( 'scroll.DT', function (e) {
				var scrollLeft = this.scrollLeft;
	
				scrollHead.scrollLeft = scrollLeft;
	
				if ( footer ) {
					scrollFoot.scrollLeft = scrollLeft;
				}
			} );
		}
	
		$(scrollBody).css('max-height', scrollY);
		if (! scroll.bCollapse) {
			$(scrollBody).css('height', scrollY);
		}
	
		settings.nScrollHead = scrollHead;
		settings.nScrollBody = scrollBody;
		settings.nScrollFoot = scrollFoot;
	
		// On redraw - align columns
		settings.aoDrawCallback.push( {
			"fn": _fnScrollDraw,
			"sName": "scrolling"
		} );
	
		return scroller[0];
	}
	
	
	
	/**
	 * Update the header, footer and body tables for resizing - i.e. column
	 * alignment.
	 *
	 * Welcome to the most horrible function DataTables. The process that this
	 * function follows is basically:
	 *   1. Re-create the table inside the scrolling div
	 *   2. Take live measurements from the DOM
	 *   3. Apply the measurements to align the columns
	 *   4. Clean up
	 *
	 *  @param {object} settings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnScrollDraw ( settings )
	{
		// Given that this is such a monster function, a lot of variables are use
		// to try and keep the minimised size as small as possible
		var
			scroll         = settings.oScroll,
			scrollX        = scroll.sX,
			scrollXInner   = scroll.sXInner,
			scrollY        = scroll.sY,
			barWidth       = scroll.iBarWidth,
			divHeader      = $(settings.nScrollHead),
			divHeaderStyle = divHeader[0].style,
			divHeaderInner = divHeader.children('div'),
			divHeaderInnerStyle = divHeaderInner[0].style,
			divHeaderTable = divHeaderInner.children('table'),
			divBodyEl      = settings.nScrollBody,
			divBody        = $(divBodyEl),
			divBodyStyle   = divBodyEl.style,
			divFooter      = $(settings.nScrollFoot),
			divFooterInner = divFooter.children('div'),
			divFooterTable = divFooterInner.children('table'),
			header         = $(settings.nTHead),
			table          = $(settings.nTable),
			tableEl        = table[0],
			tableStyle     = tableEl.style,
			footer         = settings.nTFoot ? $(settings.nTFoot) : null,
			browser        = settings.oBrowser,
			ie67           = browser.bScrollOversize,
			dtHeaderCells  = _pluck( settings.aoColumns, 'nTh' ),
			headerTrgEls, footerTrgEls,
			headerSrcEls, footerSrcEls,
			headerCopy, footerCopy,
			headerWidths=[], footerWidths=[],
			headerContent=[], footerContent=[],
			idx, correction, sanityWidth,
			zeroOut = function(nSizer) {
				var style = nSizer.style;
				style.paddingTop = "0";
				style.paddingBottom = "0";
				style.borderTopWidth = "0";
				style.borderBottomWidth = "0";
				style.height = 0;
			};
	
		// If the scrollbar visibility has changed from the last draw, we need to
		// adjust the column sizes as the table width will have changed to account
		// for the scrollbar
		var scrollBarVis = divBodyEl.scrollHeight > divBodyEl.clientHeight;
		
		if ( settings.scrollBarVis !== scrollBarVis && settings.scrollBarVis !== undefined ) {
			settings.scrollBarVis = scrollBarVis;
			_fnAdjustColumnSizing( settings );
			return; // adjust column sizing will call this function again
		}
		else {
			settings.scrollBarVis = scrollBarVis;
		}
	
		/*
		 * 1. Re-create the table inside the scrolling div
		 */
	
		// Remove the old minimised thead and tfoot elements in the inner table
		table.children('thead, tfoot').remove();
	
		if ( footer ) {
			footerCopy = footer.clone().prependTo( table );
			footerTrgEls = footer.find('tr'); // the original tfoot is in its own table and must be sized
			footerSrcEls = footerCopy.find('tr');
			footerCopy.find('[id]').removeAttr('id');
		}
	
		// Clone the current header and footer elements and then place it into the inner table
		headerCopy = header.clone().prependTo( table );
		headerTrgEls = header.find('tr'); // original header is in its own table
		headerSrcEls = headerCopy.find('tr');
		headerCopy.find('th, td').removeAttr('tabindex');
		headerCopy.find('[id]').removeAttr('id');
	
	
		/*
		 * 2. Take live measurements from the DOM - do not alter the DOM itself!
		 */
	
		// Remove old sizing and apply the calculated column widths
		// Get the unique column headers in the newly created (cloned) header. We want to apply the
		// calculated sizes to this header
		if ( ! scrollX )
		{
			divBodyStyle.width = '100%';
			divHeader[0].style.width = '100%';
		}
	
		$.each( _fnGetUniqueThs( settings, headerCopy ), function ( i, el ) {
			idx = _fnVisibleToColumnIndex( settings, i );
			el.style.width = settings.aoColumns[idx].sWidth;
		} );
	
		if ( footer ) {
			_fnApplyToChildren( function(n) {
				n.style.width = "";
			}, footerSrcEls );
		}
	
		// Size the table as a whole
		sanityWidth = table.outerWidth();
		if ( scrollX === "" ) {
			// No x scrolling
			tableStyle.width = "100%";
	
			// IE7 will make the width of the table when 100% include the scrollbar
			// - which is shouldn't. When there is a scrollbar we need to take this
			// into account.
			if ( ie67 && (table.find('tbody').height() > divBodyEl.offsetHeight ||
				divBody.css('overflow-y') == "scroll")
			) {
				tableStyle.width = _fnStringToCss( table.outerWidth() - barWidth);
			}
	
			// Recalculate the sanity width
			sanityWidth = table.outerWidth();
		}
		else if ( scrollXInner !== "" ) {
			// legacy x scroll inner has been given - use it
			tableStyle.width = _fnStringToCss(scrollXInner);
	
			// Recalculate the sanity width
			sanityWidth = table.outerWidth();
		}
	
		// Hidden header should have zero height, so remove padding and borders. Then
		// set the width based on the real headers
	
		// Apply all styles in one pass
		_fnApplyToChildren( zeroOut, headerSrcEls );
	
		// Read all widths in next pass
		_fnApplyToChildren( function(nSizer) {
			var style = window.getComputedStyle ?
				window.getComputedStyle(nSizer).width :
				_fnStringToCss( $(nSizer).width() );
	
			headerContent.push( nSizer.innerHTML );
			headerWidths.push( style );
		}, headerSrcEls );
	
		// Apply all widths in final pass
		_fnApplyToChildren( function(nToSize, i) {
			nToSize.style.width = headerWidths[i];
		}, headerTrgEls );
	
		$(headerSrcEls).css('height', 0);
	
		/* Same again with the footer if we have one */
		if ( footer )
		{
			_fnApplyToChildren( zeroOut, footerSrcEls );
	
			_fnApplyToChildren( function(nSizer) {
				footerContent.push( nSizer.innerHTML );
				footerWidths.push( _fnStringToCss( $(nSizer).css('width') ) );
			}, footerSrcEls );
	
			_fnApplyToChildren( function(nToSize, i) {
				nToSize.style.width = footerWidths[i];
			}, footerTrgEls );
	
			$(footerSrcEls).height(0);
		}
	
	
		/*
		 * 3. Apply the measurements
		 */
	
		// "Hide" the header and footer that we used for the sizing. We need to keep
		// the content of the cell so that the width applied to the header and body
		// both match, but we want to hide it completely. We want to also fix their
		// width to what they currently are
		_fnApplyToChildren( function(nSizer, i) {
			nSizer.innerHTML = '<div class="dataTables_sizing">'+headerContent[i]+'</div>';
			nSizer.childNodes[0].style.height = "0";
			nSizer.childNodes[0].style.overflow = "hidden";
			nSizer.style.width = headerWidths[i];
		}, headerSrcEls );
	
		if ( footer )
		{
			_fnApplyToChildren( function(nSizer, i) {
				nSizer.innerHTML = '<div class="dataTables_sizing">'+footerContent[i]+'</div>';
				nSizer.childNodes[0].style.height = "0";
				nSizer.childNodes[0].style.overflow = "hidden";
				nSizer.style.width = footerWidths[i];
			}, footerSrcEls );
		}
	
		// Sanity check that the table is of a sensible width. If not then we are going to get
		// misalignment - try to prevent this by not allowing the table to shrink below its min width
		if ( Math.round(table.outerWidth()) < Math.round(sanityWidth) )
		{
			// The min width depends upon if we have a vertical scrollbar visible or not */
			correction = ((divBodyEl.scrollHeight > divBodyEl.offsetHeight ||
				divBody.css('overflow-y') == "scroll")) ?
					sanityWidth+barWidth :
					sanityWidth;
	
			// IE6/7 are a law unto themselves...
			if ( ie67 && (divBodyEl.scrollHeight >
				divBodyEl.offsetHeight || divBody.css('overflow-y') == "scroll")
			) {
				tableStyle.width = _fnStringToCss( correction-barWidth );
			}
	
			// And give the user a warning that we've stopped the table getting too small
			if ( scrollX === "" || scrollXInner !== "" ) {
				_fnLog( settings, 1, 'Possible column misalignment', 6 );
			}
		}
		else
		{
			correction = '100%';
		}
	
		// Apply to the container elements
		divBodyStyle.width = _fnStringToCss( correction );
		divHeaderStyle.width = _fnStringToCss( correction );
	
		if ( footer ) {
			settings.nScrollFoot.style.width = _fnStringToCss( correction );
		}
	
	
		/*
		 * 4. Clean up
		 */
		if ( ! scrollY ) {
			/* IE7< puts a vertical scrollbar in place (when it shouldn't be) due to subtracting
			 * the scrollbar height from the visible display, rather than adding it on. We need to
			 * set the height in order to sort this. Don't want to do it in any other browsers.
			 */
			if ( ie67 ) {
				divBodyStyle.height = _fnStringToCss( tableEl.offsetHeight+barWidth );
			}
		}
	
		/* Finally set the width's of the header and footer tables */
		var iOuterWidth = table.outerWidth();
		divHeaderTable[0].style.width = _fnStringToCss( iOuterWidth );
		divHeaderInnerStyle.width = _fnStringToCss( iOuterWidth );
	
		// Figure out if there are scrollbar present - if so then we need a the header and footer to
		// provide a bit more space to allow "overflow" scrolling (i.e. past the scrollbar)
		var bScrolling = table.height() > divBodyEl.clientHeight || divBody.css('overflow-y') == "scroll";
		var padding = 'padding' + (browser.bScrollbarLeft ? 'Left' : 'Right' );
		divHeaderInnerStyle[ padding ] = bScrolling ? barWidth+"px" : "0px";
	
		if ( footer ) {
			divFooterTable[0].style.width = _fnStringToCss( iOuterWidth );
			divFooterInner[0].style.width = _fnStringToCss( iOuterWidth );
			divFooterInner[0].style[padding] = bScrolling ? barWidth+"px" : "0px";
		}
	
		// Correct DOM ordering for colgroup - comes before the thead
		table.children('colgroup').insertBefore( table.children('thead') );
	
		/* Adjust the position of the header in case we loose the y-scrollbar */
		divBody.trigger('scroll');
	
		// If sorting or filtering has occurred, jump the scrolling back to the top
		// only if we aren't holding the position
		if ( (settings.bSorted || settings.bFiltered) && ! settings._drawHold ) {
			divBodyEl.scrollTop = 0;
		}
	}
	
	
	
	/**
	 * Apply a given function to the display child nodes of an element array (typically
	 * TD children of TR rows
	 *  @param {function} fn Method to apply to the objects
	 *  @param array {nodes} an1 List of elements to look through for display children
	 *  @param array {nodes} an2 Another list (identical structure to the first) - optional
	 *  @memberof DataTable#oApi
	 */
	function _fnApplyToChildren( fn, an1, an2 )
	{
		var index=0, i=0, iLen=an1.length;
		var nNode1, nNode2;
	
		while ( i < iLen ) {
			nNode1 = an1[i].firstChild;
			nNode2 = an2 ? an2[i].firstChild : null;
	
			while ( nNode1 ) {
				if ( nNode1.nodeType === 1 ) {
					if ( an2 ) {
						fn( nNode1, nNode2, index );
					}
					else {
						fn( nNode1, index );
					}
	
					index++;
				}
	
				nNode1 = nNode1.nextSibling;
				nNode2 = an2 ? nNode2.nextSibling : null;
			}
	
			i++;
		}
	}
	
	
	
	var __re_html_remove = /<.*?>/g;
	
	
	/**
	 * Calculate the width of columns for the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnCalculateColumnWidths ( oSettings )
	{
		var
			table = oSettings.nTable,
			columns = oSettings.aoColumns,
			scroll = oSettings.oScroll,
			scrollY = scroll.sY,
			scrollX = scroll.sX,
			scrollXInner = scroll.sXInner,
			columnCount = columns.length,
			visibleColumns = _fnGetColumns( oSettings, 'bVisible' ),
			headerCells = $('th', oSettings.nTHead),
			tableWidthAttr = table.getAttribute('width'), // from DOM element
			tableContainer = table.parentNode,
			userInputs = false,
			i, column, columnIdx, width, outerWidth,
			browser = oSettings.oBrowser,
			ie67 = browser.bScrollOversize;
	
		var styleWidth = table.style.width;
		if ( styleWidth && styleWidth.indexOf('%') !== -1 ) {
			tableWidthAttr = styleWidth;
		}
	
		/* Convert any user input sizes into pixel sizes */
		var sizes = _fnConvertToWidth(_pluck(columns, 'sWidthOrig'), tableContainer);
	
		for ( i=0 ; i<visibleColumns.length ; i++ ) {
			column = columns[ visibleColumns[i] ];
	
			if ( column.sWidth !== null ) {
				column.sWidth = sizes[i];
	
				userInputs = true;
			}
		}
	
		/* If the number of columns in the DOM equals the number that we have to
		 * process in DataTables, then we can use the offsets that are created by
		 * the web- browser. No custom sizes can be set in order for this to happen,
		 * nor scrolling used
		 */
		if ( ie67 || ! userInputs && ! scrollX && ! scrollY &&
		     columnCount == _fnVisbleColumns( oSettings ) &&
		     columnCount == headerCells.length
		) {
			for ( i=0 ; i<columnCount ; i++ ) {
				var colIdx = _fnVisibleToColumnIndex( oSettings, i );
	
				if ( colIdx !== null ) {
					columns[ colIdx ].sWidth = _fnStringToCss( headerCells.eq(i).width() );
				}
			}
		}
		else
		{
			// Otherwise construct a single row, worst case, table with the widest
			// node in the data, assign any user defined widths, then insert it into
			// the DOM and allow the browser to do all the hard work of calculating
			// table widths
			var tmpTable = $(table).clone() // don't use cloneNode - IE8 will remove events on the main table
				.css( 'visibility', 'hidden' )
				.removeAttr( 'id' );
	
			// Clean up the table body
			tmpTable.find('tbody tr').remove();
			var tr = $('<tr/>').appendTo( tmpTable.find('tbody') );
	
			// Clone the table header and footer - we can't use the header / footer
			// from the cloned table, since if scrolling is active, the table's
			// real header and footer are contained in different table tags
			tmpTable.find('thead, tfoot').remove();
			tmpTable
				.append( $(oSettings.nTHead).clone() )
				.append( $(oSettings.nTFoot).clone() );
	
			// Remove any assigned widths from the footer (from scrolling)
			tmpTable.find('tfoot th, tfoot td').css('width', '');
	
			// Apply custom sizing to the cloned header
			headerCells = _fnGetUniqueThs( oSettings, tmpTable.find('thead')[0] );
	
			for ( i=0 ; i<visibleColumns.length ; i++ ) {
				column = columns[ visibleColumns[i] ];
	
				headerCells[i].style.width = column.sWidthOrig !== null && column.sWidthOrig !== '' ?
					_fnStringToCss( column.sWidthOrig ) :
					'';
	
				// For scrollX we need to force the column width otherwise the
				// browser will collapse it. If this width is smaller than the
				// width the column requires, then it will have no effect
				if ( column.sWidthOrig && scrollX ) {
					$( headerCells[i] ).append( $('<div/>').css( {
						width: column.sWidthOrig,
						margin: 0,
						padding: 0,
						border: 0,
						height: 1
					} ) );
				}
			}
	
			// Find the widest cell for each column and put it into the table
			if ( oSettings.aoData.length ) {
				for ( i=0 ; i<visibleColumns.length ; i++ ) {
					columnIdx = visibleColumns[i];
					column = columns[ columnIdx ];
	
					$( _fnGetWidestNode( oSettings, columnIdx ) )
						.clone( false )
						.append( column.sContentPadding )
						.appendTo( tr );
				}
			}
	
			// Tidy the temporary table - remove name attributes so there aren't
			// duplicated in the dom (radio elements for example)
			$('[name]', tmpTable).removeAttr('name');
	
			// Table has been built, attach to the document so we can work with it.
			// A holding element is used, positioned at the top of the container
			// with minimal height, so it has no effect on if the container scrolls
			// or not. Otherwise it might trigger scrolling when it actually isn't
			// needed
			var holder = $('<div/>').css( scrollX || scrollY ?
					{
						position: 'absolute',
						top: 0,
						left: 0,
						height: 1,
						right: 0,
						overflow: 'hidden'
					} :
					{}
				)
				.append( tmpTable )
				.appendTo( tableContainer );
	
			// When scrolling (X or Y) we want to set the width of the table as 
			// appropriate. However, when not scrolling leave the table width as it
			// is. This results in slightly different, but I think correct behaviour
			if ( scrollX && scrollXInner ) {
				tmpTable.width( scrollXInner );
			}
			else if ( scrollX ) {
				tmpTable.css( 'width', 'auto' );
				tmpTable.removeAttr('width');
	
				// If there is no width attribute or style, then allow the table to
				// collapse
				if ( tmpTable.width() < tableContainer.clientWidth && tableWidthAttr ) {
					tmpTable.width( tableContainer.clientWidth );
				}
			}
			else if ( scrollY ) {
				tmpTable.width( tableContainer.clientWidth );
			}
			else if ( tableWidthAttr ) {
				tmpTable.width( tableWidthAttr );
			}
	
			// Get the width of each column in the constructed table - we need to
			// know the inner width (so it can be assigned to the other table's
			// cells) and the outer width so we can calculate the full width of the
			// table. This is safe since DataTables requires a unique cell for each
			// column, but if ever a header can span multiple columns, this will
			// need to be modified.
			var total = 0;
			for ( i=0 ; i<visibleColumns.length ; i++ ) {
				var cell = $(headerCells[i]);
				var border = cell.outerWidth() - cell.width();
	
				// Use getBounding... where possible (not IE8-) because it can give
				// sub-pixel accuracy, which we then want to round up!
				var bounding = browser.bBounding ?
					Math.ceil( headerCells[i].getBoundingClientRect().width ) :
					cell.outerWidth();
	
				// Total is tracked to remove any sub-pixel errors as the outerWidth
				// of the table might not equal the total given here (IE!).
				total += bounding;
	
				// Width for each column to use
				columns[ visibleColumns[i] ].sWidth = _fnStringToCss( bounding - border );
			}
	
			table.style.width = _fnStringToCss( total );
	
			// Finished with the table - ditch it
			holder.remove();
		}
	
		// If there is a width attr, we want to attach an event listener which
		// allows the table sizing to automatically adjust when the window is
		// resized. Use the width attr rather than CSS, since we can't know if the
		// CSS is a relative value or absolute - DOM read is always px.
		if ( tableWidthAttr ) {
			table.style.width = _fnStringToCss( tableWidthAttr );
		}
	
		if ( (tableWidthAttr || scrollX) && ! oSettings._reszEvt ) {
			var bindResize = function () {
				$(window).on('resize.DT-'+oSettings.sInstance, _fnThrottle( function () {
					_fnAdjustColumnSizing( oSettings );
				} ) );
			};
	
			// IE6/7 will crash if we bind a resize event handler on page load.
			// To be removed in 1.11 which drops IE6/7 support
			if ( ie67 ) {
				setTimeout( bindResize, 1000 );
			}
			else {
				bindResize();
			}
	
			oSettings._reszEvt = true;
		}
	}
	
	
	/**
	 * Throttle the calls to a function. Arguments and context are maintained for
	 * the throttled function
	 *  @param {function} fn Function to be called
	 *  @param {int} [freq=200] call frequency in mS
	 *  @returns {function} wrapped function
	 *  @memberof DataTable#oApi
	 */
	var _fnThrottle = DataTable.util.throttle;
	
	
	/**
	 * Convert a set of CSS units width to pixels (e.g. 2em)
	 *  @param {string[]} widths widths to be converted
	 *  @param {node} parent parent to get the with for (required for relative widths) - optional
	 *  @returns {int[]} widths in pixels
	 *  @memberof DataTable#oApi
	 */
	function _fnConvertToWidth ( widths, parent )
	{
		var els = [];
		var results = [];
	
		// Add the elements in a single loop so we only need to reflow once
		for (var i=0 ; i<widths.length ; i++) {
			if (widths[i]) {
				els.push(
					$('<div/>')
						.css( 'width', _fnStringToCss( widths[i] ) )
						.appendTo( parent || document.body )
				)
			}
			else {
				els.push(null);
			}
		}
	
		// Get the sizes (will reflow once)
		for (var i=0 ; i<widths.length ; i++) {
			results.push(els[i] ? els[i][0].offsetWidth : null);
		}
	
		// Tidy
		$(els).remove();
	
		return results;
	}
	
	
	/**
	 * Get the widest node
	 *  @param {object} settings dataTables settings object
	 *  @param {int} colIdx column of interest
	 *  @returns {node} widest table node
	 *  @memberof DataTable#oApi
	 */
	function _fnGetWidestNode( settings, colIdx )
	{
		var idx = _fnGetMaxLenString( settings, colIdx );
		if ( idx < 0 ) {
			return null;
		}
	
		var data = settings.aoData[ idx ];
		return ! data.nTr ? // Might not have been created when deferred rendering
			$('<td/>').html( _fnGetCellData( settings, idx, colIdx, 'display' ) )[0] :
			data.anCells[ colIdx ];
	}
	
	
	/**
	 * Get the maximum strlen for each data column
	 *  @param {object} settings dataTables settings object
	 *  @param {int} colIdx column of interest
	 *  @returns {string} max string length for each column
	 *  @memberof DataTable#oApi
	 */
	function _fnGetMaxLenString( settings, colIdx )
	{
		var s, max=-1, maxIdx = -1;
	
		for ( var i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
			s = _fnGetCellData( settings, i, colIdx, 'display' )+'';
			s = s.replace( __re_html_remove, '' );
			s = s.replace( /&nbsp;/g, ' ' );
	
			if ( s.length > max ) {
				max = s.length;
				maxIdx = i;
			}
		}
	
		return maxIdx;
	}
	
	
	/**
	 * Append a CSS unit (only if required) to a string
	 *  @param {string} value to css-ify
	 *  @returns {string} value with css unit
	 *  @memberof DataTable#oApi
	 */
	function _fnStringToCss( s )
	{
		if ( s === null ) {
			return '0px';
		}
	
		if ( typeof s == 'number' ) {
			return s < 0 ?
				'0px' :
				s+'px';
		}
	
		// Check it has a unit character already
		return s.match(/\d$/) ?
			s+'px' :
			s;
	}
	
	
	
	function _fnSortFlatten ( settings )
	{
		var
			i, iLen, k, kLen,
			aSort = [],
			aiOrig = [],
			aoColumns = settings.aoColumns,
			aDataSort, iCol, sType, srcCol,
			fixed = settings.aaSortingFixed,
			fixedObj = $.isPlainObject( fixed ),
			nestedSort = [],
			add = function ( a ) {
				if ( a.length && ! Array.isArray( a[0] ) ) {
					// 1D array
					nestedSort.push( a );
				}
				else {
					// 2D array
					$.merge( nestedSort, a );
				}
			};
	
		// Build the sort array, with pre-fix and post-fix options if they have been
		// specified
		if ( Array.isArray( fixed ) ) {
			add( fixed );
		}
	
		if ( fixedObj && fixed.pre ) {
			add( fixed.pre );
		}
	
		add( settings.aaSorting );
	
		if (fixedObj && fixed.post ) {
			add( fixed.post );
		}
	
		for ( i=0 ; i<nestedSort.length ; i++ )
		{
			srcCol = nestedSort[i][0];
			aDataSort = aoColumns[ srcCol ].aDataSort;
	
			for ( k=0, kLen=aDataSort.length ; k<kLen ; k++ )
			{
				iCol = aDataSort[k];
				sType = aoColumns[ iCol ].sType || 'string';
	
				if ( nestedSort[i]._idx === undefined ) {
					nestedSort[i]._idx = $.inArray( nestedSort[i][1], aoColumns[iCol].asSorting );
				}
	
				aSort.push( {
					src:       srcCol,
					col:       iCol,
					dir:       nestedSort[i][1],
					index:     nestedSort[i]._idx,
					type:      sType,
					formatter: DataTable.ext.type.order[ sType+"-pre" ]
				} );
			}
		}
	
		return aSort;
	}
	
	/**
	 * Change the order of the table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 *  @todo This really needs split up!
	 */
	function _fnSort ( oSettings )
	{
		var
			i, ien, iLen, j, jLen, k, kLen,
			sDataType, nTh,
			aiOrig = [],
			oExtSort = DataTable.ext.type.order,
			aoData = oSettings.aoData,
			aoColumns = oSettings.aoColumns,
			aDataSort, data, iCol, sType, oSort,
			formatters = 0,
			sortCol,
			displayMaster = oSettings.aiDisplayMaster,
			aSort;
	
		// Resolve any column types that are unknown due to addition or invalidation
		// @todo Can this be moved into a 'data-ready' handler which is called when
		//   data is going to be used in the table?
		_fnColumnTypes( oSettings );
	
		aSort = _fnSortFlatten( oSettings );
	
		for ( i=0, ien=aSort.length ; i<ien ; i++ ) {
			sortCol = aSort[i];
	
			// Track if we can use the fast sort algorithm
			if ( sortCol.formatter ) {
				formatters++;
			}
	
			// Load the data needed for the sort, for each cell
			_fnSortData( oSettings, sortCol.col );
		}
	
		/* No sorting required if server-side or no sorting array */
		if ( _fnDataSource( oSettings ) != 'ssp' && aSort.length !== 0 )
		{
			// Create a value - key array of the current row positions such that we can use their
			// current position during the sort, if values match, in order to perform stable sorting
			for ( i=0, iLen=displayMaster.length ; i<iLen ; i++ ) {
				aiOrig[ displayMaster[i] ] = i;
			}
	
			/* Do the sort - here we want multi-column sorting based on a given data source (column)
			 * and sorting function (from oSort) in a certain direction. It's reasonably complex to
			 * follow on it's own, but this is what we want (example two column sorting):
			 *  fnLocalSorting = function(a,b){
			 *    var iTest;
			 *    iTest = oSort['string-asc']('data11', 'data12');
			 *      if (iTest !== 0)
			 *        return iTest;
			 *    iTest = oSort['numeric-desc']('data21', 'data22');
			 *    if (iTest !== 0)
			 *      return iTest;
			 *    return oSort['numeric-asc']( aiOrig[a], aiOrig[b] );
			 *  }
			 * Basically we have a test for each sorting column, if the data in that column is equal,
			 * test the next column. If all columns match, then we use a numeric sort on the row
			 * positions in the original data array to provide a stable sort.
			 *
			 * Note - I know it seems excessive to have two sorting methods, but the first is around
			 * 15% faster, so the second is only maintained for backwards compatibility with sorting
			 * methods which do not have a pre-sort formatting function.
			 */
			if ( formatters === aSort.length ) {
				// All sort types have formatting functions
				displayMaster.sort( function ( a, b ) {
					var
						x, y, k, test, sort,
						len=aSort.length,
						dataA = aoData[a]._aSortData,
						dataB = aoData[b]._aSortData;
	
					for ( k=0 ; k<len ; k++ ) {
						sort = aSort[k];
	
						x = dataA[ sort.col ];
						y = dataB[ sort.col ];
	
						test = x<y ? -1 : x>y ? 1 : 0;
						if ( test !== 0 ) {
							return sort.dir === 'asc' ? test : -test;
						}
					}
	
					x = aiOrig[a];
					y = aiOrig[b];
					return x<y ? -1 : x>y ? 1 : 0;
				} );
			}
			else {
				// Depreciated - remove in 1.11 (providing a plug-in option)
				// Not all sort types have formatting methods, so we have to call their sorting
				// methods.
				displayMaster.sort( function ( a, b ) {
					var
						x, y, k, l, test, sort, fn,
						len=aSort.length,
						dataA = aoData[a]._aSortData,
						dataB = aoData[b]._aSortData;
	
					for ( k=0 ; k<len ; k++ ) {
						sort = aSort[k];
	
						x = dataA[ sort.col ];
						y = dataB[ sort.col ];
	
						fn = oExtSort[ sort.type+"-"+sort.dir ] || oExtSort[ "string-"+sort.dir ];
						test = fn( x, y );
						if ( test !== 0 ) {
							return test;
						}
					}
	
					x = aiOrig[a];
					y = aiOrig[b];
					return x<y ? -1 : x>y ? 1 : 0;
				} );
			}
		}
	
		/* Tell the draw function that we have sorted the data */
		oSettings.bSorted = true;
	}
	
	
	function _fnSortAria ( settings )
	{
		var label;
		var nextSort;
		var columns = settings.aoColumns;
		var aSort = _fnSortFlatten( settings );
		var oAria = settings.oLanguage.oAria;
	
		// ARIA attributes - need to loop all columns, to update all (removing old
		// attributes as needed)
		for ( var i=0, iLen=columns.length ; i<iLen ; i++ )
		{
			var col = columns[i];
			var asSorting = col.asSorting;
			var sTitle = col.ariaTitle || col.sTitle.replace( /<.*?>/g, "" );
			var th = col.nTh;
	
			// IE7 is throwing an error when setting these properties with jQuery's
			// attr() and removeAttr() methods...
			th.removeAttribute('aria-sort');
	
			/* In ARIA only the first sorting column can be marked as sorting - no multi-sort option */
			if ( col.bSortable ) {
				if ( aSort.length > 0 && aSort[0].col == i ) {
					th.setAttribute('aria-sort', aSort[0].dir=="asc" ? "ascending" : "descending" );
					nextSort = asSorting[ aSort[0].index+1 ] || asSorting[0];
				}
				else {
					nextSort = asSorting[0];
				}
	
				label = sTitle + ( nextSort === "asc" ?
					oAria.sSortAscending :
					oAria.sSortDescending
				);
			}
			else {
				label = sTitle;
			}
	
			th.setAttribute('aria-label', label);
		}
	}
	
	
	/**
	 * Function to run on user sort request
	 *  @param {object} settings dataTables settings object
	 *  @param {node} attachTo node to attach the handler to
	 *  @param {int} colIdx column sorting index
	 *  @param {boolean} [append=false] Append the requested sort to the existing
	 *    sort if true (i.e. multi-column sort)
	 *  @param {function} [callback] callback function
	 *  @memberof DataTable#oApi
	 */
	function _fnSortListener ( settings, colIdx, append, callback )
	{
		var col = settings.aoColumns[ colIdx ];
		var sorting = settings.aaSorting;
		var asSorting = col.asSorting;
		var nextSortIdx;
		var next = function ( a, overflow ) {
			var idx = a._idx;
			if ( idx === undefined ) {
				idx = $.inArray( a[1], asSorting );
			}
	
			return idx+1 < asSorting.length ?
				idx+1 :
				overflow ?
					null :
					0;
		};
	
		// Convert to 2D array if needed
		if ( typeof sorting[0] === 'number' ) {
			sorting = settings.aaSorting = [ sorting ];
		}
	
		// If appending the sort then we are multi-column sorting
		if ( append && settings.oFeatures.bSortMulti ) {
			// Are we already doing some kind of sort on this column?
			var sortIdx = $.inArray( colIdx, _pluck(sorting, '0') );
	
			if ( sortIdx !== -1 ) {
				// Yes, modify the sort
				nextSortIdx = next( sorting[sortIdx], true );
	
				if ( nextSortIdx === null && sorting.length === 1 ) {
					nextSortIdx = 0; // can't remove sorting completely
				}
	
				if ( nextSortIdx === null ) {
					sorting.splice( sortIdx, 1 );
				}
				else {
					sorting[sortIdx][1] = asSorting[ nextSortIdx ];
					sorting[sortIdx]._idx = nextSortIdx;
				}
			}
			else {
				// No sort on this column yet
				sorting.push( [ colIdx, asSorting[0], 0 ] );
				sorting[sorting.length-1]._idx = 0;
			}
		}
		else if ( sorting.length && sorting[0][0] == colIdx ) {
			// Single column - already sorting on this column, modify the sort
			nextSortIdx = next( sorting[0] );
	
			sorting.length = 1;
			sorting[0][1] = asSorting[ nextSortIdx ];
			sorting[0]._idx = nextSortIdx;
		}
		else {
			// Single column - sort only on this column
			sorting.length = 0;
			sorting.push( [ colIdx, asSorting[0] ] );
			sorting[0]._idx = 0;
		}
	
		// Run the sort by calling a full redraw
		_fnReDraw( settings );
	
		// callback used for async user interaction
		if ( typeof callback == 'function' ) {
			callback( settings );
		}
	}
	
	
	/**
	 * Attach a sort handler (click) to a node
	 *  @param {object} settings dataTables settings object
	 *  @param {node} attachTo node to attach the handler to
	 *  @param {int} colIdx column sorting index
	 *  @param {function} [callback] callback function
	 *  @memberof DataTable#oApi
	 */
	function _fnSortAttachListener ( settings, attachTo, colIdx, callback )
	{
		var col = settings.aoColumns[ colIdx ];
	
		_fnBindAction( attachTo, {}, function (e) {
			/* If the column is not sortable - don't to anything */
			if ( col.bSortable === false ) {
				return;
			}
	
			// If processing is enabled use a timeout to allow the processing
			// display to be shown - otherwise to it synchronously
			if ( settings.oFeatures.bProcessing ) {
				_fnProcessingDisplay( settings, true );
	
				setTimeout( function() {
					_fnSortListener( settings, colIdx, e.shiftKey, callback );
	
					// In server-side processing, the draw callback will remove the
					// processing display
					if ( _fnDataSource( settings ) !== 'ssp' ) {
						_fnProcessingDisplay( settings, false );
					}
				}, 0 );
			}
			else {
				_fnSortListener( settings, colIdx, e.shiftKey, callback );
			}
		} );
	}
	
	
	/**
	 * Set the sorting classes on table's body, Note: it is safe to call this function
	 * when bSort and bSortClasses are false
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnSortingClasses( settings )
	{
		var oldSort = settings.aLastSort;
		var sortClass = settings.oClasses.sSortColumn;
		var sort = _fnSortFlatten( settings );
		var features = settings.oFeatures;
		var i, ien, colIdx;
	
		if ( features.bSort && features.bSortClasses ) {
			// Remove old sorting classes
			for ( i=0, ien=oldSort.length ; i<ien ; i++ ) {
				colIdx = oldSort[i].src;
	
				// Remove column sorting
				$( _pluck( settings.aoData, 'anCells', colIdx ) )
					.removeClass( sortClass + (i<2 ? i+1 : 3) );
			}
	
			// Add new column sorting
			for ( i=0, ien=sort.length ; i<ien ; i++ ) {
				colIdx = sort[i].src;
	
				$( _pluck( settings.aoData, 'anCells', colIdx ) )
					.addClass( sortClass + (i<2 ? i+1 : 3) );
			}
		}
	
		settings.aLastSort = sort;
	}
	
	
	// Get the data to sort a column, be it from cache, fresh (populating the
	// cache), or from a sort formatter
	function _fnSortData( settings, idx )
	{
		// Custom sorting function - provided by the sort data type
		var column = settings.aoColumns[ idx ];
		var customSort = DataTable.ext.order[ column.sSortDataType ];
		var customData;
	
		if ( customSort ) {
			customData = customSort.call( settings.oInstance, settings, idx,
				_fnColumnIndexToVisible( settings, idx )
			);
		}
	
		// Use / populate cache
		var row, cellData;
		var formatter = DataTable.ext.type.order[ column.sType+"-pre" ];
	
		for ( var i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
			row = settings.aoData[i];
	
			if ( ! row._aSortData ) {
				row._aSortData = [];
			}
	
			if ( ! row._aSortData[idx] || customSort ) {
				cellData = customSort ?
					customData[i] : // If there was a custom sort function, use data from there
					_fnGetCellData( settings, i, idx, 'sort' );
	
				row._aSortData[ idx ] = formatter ?
					formatter( cellData ) :
					cellData;
			}
		}
	}
	
	
	
	/**
	 * Save the state of a table
	 *  @param {object} oSettings dataTables settings object
	 *  @memberof DataTable#oApi
	 */
	function _fnSaveState ( settings )
	{
		if (settings._bLoadingState) {
			return;
		}
	
		/* Store the interesting variables */
		var state = {
			time:    +new Date(),
			start:   settings._iDisplayStart,
			length:  settings._iDisplayLength,
			order:   $.extend( true, [], settings.aaSorting ),
			search:  _fnSearchToCamel( settings.oPreviousSearch ),
			columns: $.map( settings.aoColumns, function ( col, i ) {
				return {
					visible: col.bVisible,
					search: _fnSearchToCamel( settings.aoPreSearchCols[i] )
				};
			} )
		};
	
		settings.oSavedState = state;
		_fnCallbackFire( settings, "aoStateSaveParams", 'stateSaveParams', [settings, state] );
		
		if ( settings.oFeatures.bStateSave && !settings.bDestroying )
		{
			settings.fnStateSaveCallback.call( settings.oInstance, settings, state );
		}	
	}
	
	
	/**
	 * Attempt to load a saved table state
	 *  @param {object} oSettings dataTables settings object
	 *  @param {object} oInit DataTables init object so we can override settings
	 *  @param {function} callback Callback to execute when the state has been loaded
	 *  @memberof DataTable#oApi
	 */
	function _fnLoadState ( settings, oInit, callback )
	{
		if ( ! settings.oFeatures.bStateSave ) {
			callback();
			return;
		}
	
		var loaded = function(state) {
			_fnImplementState(settings, state, callback);
		}
	
		var state = settings.fnStateLoadCallback.call( settings.oInstance, settings, loaded );
	
		if ( state !== undefined ) {
			_fnImplementState( settings, state, callback );
		}
		// otherwise, wait for the loaded callback to be executed
	
		return true;
	}
	
	function _fnImplementState ( settings, s, callback) {
		var i, ien;
		var columns = settings.aoColumns;
		settings._bLoadingState = true;
	
		// When StateRestore was introduced the state could now be implemented at any time
		// Not just initialisation. To do this an api instance is required in some places
		var api = settings._bInitComplete ? new DataTable.Api(settings) : null;
	
		if ( ! s || ! s.time ) {
			settings._bLoadingState = false;
			callback();
			return;
		}
	
		// Allow custom and plug-in manipulation functions to alter the saved data set and
		// cancelling of loading by returning false
		var abStateLoad = _fnCallbackFire( settings, 'aoStateLoadParams', 'stateLoadParams', [settings, s] );
		if ( $.inArray( false, abStateLoad ) !== -1 ) {
			settings._bLoadingState = false;
			callback();
			return;
		}
	
		// Reject old data
		var duration = settings.iStateDuration;
		if ( duration > 0 && s.time < +new Date() - (duration*1000) ) {
			settings._bLoadingState = false;
			callback();
			return;
		}
	
		// Number of columns have changed - all bets are off, no restore of settings
		if ( s.columns && columns.length !== s.columns.length ) {
			settings._bLoadingState = false;
			callback();
			return;
		}
	
		// Store the saved state so it might be accessed at any time
		settings.oLoadedState = $.extend( true, {}, s );
	
		// Page Length
		if ( s.length !== undefined ) {
			// If already initialised just set the value directly so that the select element is also updated
			if (api) {
				api.page.len(s.length)
			}
			else {
				settings._iDisplayLength   = s.length;
			}
		}
	
		// Restore key features - todo - for 1.11 this needs to be done by
		// subscribed events
		if ( s.start !== undefined ) {
			if(api === null) {
				settings._iDisplayStart    = s.start;
				settings.iInitDisplayStart = s.start;
			}
			else {
				_fnPageChange(settings, s.start/settings._iDisplayLength);
			}
		}
	
		// Order
		if ( s.order !== undefined ) {
			settings.aaSorting = [];
			$.each( s.order, function ( i, col ) {
				settings.aaSorting.push( col[0] >= columns.length ?
					[ 0, col[1] ] :
					col
				);
			} );
		}
	
		// Search
		if ( s.search !== undefined ) {
			$.extend( settings.oPreviousSearch, _fnSearchToHung( s.search ) );
		}
	
		// Columns
		if ( s.columns ) {
			for ( i=0, ien=s.columns.length ; i<ien ; i++ ) {
				var col = s.columns[i];
	
				// Visibility
				if ( col.visible !== undefined ) {
					// If the api is defined, the table has been initialised so we need to use it rather than internal settings
					if (api) {
						// Don't redraw the columns on every iteration of this loop, we will do this at the end instead
						api.column(i).visible(col.visible, false);
					}
					else {
						columns[i].bVisible = col.visible;
					}
				}
	
				// Search
				if ( col.search !== undefined ) {
					$.extend( settings.aoPreSearchCols[i], _fnSearchToHung( col.search ) );
				}
			}
			
			// If the api is defined then we need to adjust the columns once the visibility has been changed
			if (api) {
				api.columns.adjust();
			}
		}
	
		settings._bLoadingState = false;
		_fnCallbackFire( settings, 'aoStateLoaded', 'stateLoaded', [settings, s] );
		callback();
	};
	
	
	/**
	 * Return the settings object for a particular table
	 *  @param {node} table table we are using as a dataTable
	 *  @returns {object} Settings object - or null if not found
	 *  @memberof DataTable#oApi
	 */
	function _fnSettingsFromNode ( table )
	{
		var settings = DataTable.settings;
		var idx = $.inArray( table, _pluck( settings, 'nTable' ) );
	
		return idx !== -1 ?
			settings[ idx ] :
			null;
	}
	
	
	/**
	 * Log an error message
	 *  @param {object} settings dataTables settings object
	 *  @param {int} level log error messages, or display them to the user
	 *  @param {string} msg error message
	 *  @param {int} tn Technical note id to get more information about the error.
	 *  @memberof DataTable#oApi
	 */
	function _fnLog( settings, level, msg, tn )
	{
		msg = 'DataTables warning: '+
			(settings ? 'table id='+settings.sTableId+' - ' : '')+msg;
	
		if ( tn ) {
			msg += '. For more information about this error, please see '+
			'https://datatables.net/tn/'+tn;
		}
	
		if ( ! level  ) {
			// Backwards compatibility pre 1.10
			var ext = DataTable.ext;
			var type = ext.sErrMode || ext.errMode;
	
			if ( settings ) {
				_fnCallbackFire( settings, null, 'error', [ settings, tn, msg ] );
			}
	
			if ( type == 'alert' ) {
				alert( msg );
			}
			else if ( type == 'throw' ) {
				throw new Error(msg);
			}
			else if ( typeof type == 'function' ) {
				type( settings, tn, msg );
			}
		}
		else if ( window.console && console.log ) {
			console.log( msg );
		}
	}
	
	
	/**
	 * See if a property is defined on one object, if so assign it to the other object
	 *  @param {object} ret target object
	 *  @param {object} src source object
	 *  @param {string} name property
	 *  @param {string} [mappedName] name to map too - optional, name used if not given
	 *  @memberof DataTable#oApi
	 */
	function _fnMap( ret, src, name, mappedName )
	{
		if ( Array.isArray( name ) ) {
			$.each( name, function (i, val) {
				if ( Array.isArray( val ) ) {
					_fnMap( ret, src, val[0], val[1] );
				}
				else {
					_fnMap( ret, src, val );
				}
			} );
	
			return;
		}
	
		if ( mappedName === undefined ) {
			mappedName = name;
		}
	
		if ( src[name] !== undefined ) {
			ret[mappedName] = src[name];
		}
	}
	
	
	/**
	 * Extend objects - very similar to jQuery.extend, but deep copy objects, and
	 * shallow copy arrays. The reason we need to do this, is that we don't want to
	 * deep copy array init values (such as aaSorting) since the dev wouldn't be
	 * able to override them, but we do want to deep copy arrays.
	 *  @param {object} out Object to extend
	 *  @param {object} extender Object from which the properties will be applied to
	 *      out
	 *  @param {boolean} breakRefs If true, then arrays will be sliced to take an
	 *      independent copy with the exception of the `data` or `aaData` parameters
	 *      if they are present. This is so you can pass in a collection to
	 *      DataTables and have that used as your data source without breaking the
	 *      references
	 *  @returns {object} out Reference, just for convenience - out === the return.
	 *  @memberof DataTable#oApi
	 *  @todo This doesn't take account of arrays inside the deep copied objects.
	 */
	function _fnExtend( out, extender, breakRefs )
	{
		var val;
	
		for ( var prop in extender ) {
			if ( extender.hasOwnProperty(prop) ) {
				val = extender[prop];
	
				if ( $.isPlainObject( val ) ) {
					if ( ! $.isPlainObject( out[prop] ) ) {
						out[prop] = {};
					}
					$.extend( true, out[prop], val );
				}
				else if ( breakRefs && prop !== 'data' && prop !== 'aaData' && Array.isArray(val) ) {
					out[prop] = val.slice();
				}
				else {
					out[prop] = val;
				}
			}
		}
	
		return out;
	}
	
	
	/**
	 * Bind an event handers to allow a click or return key to activate the callback.
	 * This is good for accessibility since a return on the keyboard will have the
	 * same effect as a click, if the element has focus.
	 *  @param {element} n Element to bind the action to
	 *  @param {object} oData Data object to pass to the triggered function
	 *  @param {function} fn Callback function for when the event is triggered
	 *  @memberof DataTable#oApi
	 */
	function _fnBindAction( n, oData, fn )
	{
		$(n)
			.on( 'click.DT', oData, function (e) {
					$(n).trigger('blur'); // Remove focus outline for mouse users
					fn(e);
				} )
			.on( 'keypress.DT', oData, function (e){
					if ( e.which === 13 ) {
						e.preventDefault();
						fn(e);
					}
				} )
			.on( 'selectstart.DT', function () {
					/* Take the brutal approach to cancelling text selection */
					return false;
				} );
	}
	
	
	/**
	 * Register a callback function. Easily allows a callback function to be added to
	 * an array store of callback functions that can then all be called together.
	 *  @param {object} oSettings dataTables settings object
	 *  @param {string} sStore Name of the array storage for the callbacks in oSettings
	 *  @param {function} fn Function to be called back
	 *  @param {string} sName Identifying name for the callback (i.e. a label)
	 *  @memberof DataTable#oApi
	 */
	function _fnCallbackReg( oSettings, sStore, fn, sName )
	{
		if ( fn )
		{
			oSettings[sStore].push( {
				"fn": fn,
				"sName": sName
			} );
		}
	}
	
	
	/**
	 * Fire callback functions and trigger events. Note that the loop over the
	 * callback array store is done backwards! Further note that you do not want to
	 * fire off triggers in time sensitive applications (for example cell creation)
	 * as its slow.
	 *  @param {object} settings dataTables settings object
	 *  @param {string} callbackArr Name of the array storage for the callbacks in
	 *      oSettings
	 *  @param {string} eventName Name of the jQuery custom event to trigger. If
	 *      null no trigger is fired
	 *  @param {array} args Array of arguments to pass to the callback function /
	 *      trigger
	 *  @memberof DataTable#oApi
	 */
	function _fnCallbackFire( settings, callbackArr, eventName, args )
	{
		var ret = [];
	
		if ( callbackArr ) {
			ret = $.map( settings[callbackArr].slice().reverse(), function (val, i) {
				return val.fn.apply( settings.oInstance, args );
			} );
		}
	
		if ( eventName !== null ) {
			var e = $.Event( eventName+'.dt' );
			var table = $(settings.nTable);
	
			table.trigger( e, args );
	
			// If not yet attached to the document, trigger the event
			// on the body directly to sort of simulate the bubble
			if (table.parents('body').length === 0) {
				$('body').trigger( e, args );
			}
	
			ret.push( e.result );
		}
	
		return ret;
	}
	
	
	function _fnLengthOverflow ( settings )
	{
		var
			start = settings._iDisplayStart,
			end = settings.fnDisplayEnd(),
			len = settings._iDisplayLength;
	
		/* If we have space to show extra rows (backing up from the end point - then do so */
		if ( start >= end )
		{
			start = end - len;
		}
	
		// Keep the start record on the current page
		start -= (start % len);
	
		if ( len === -1 || start < 0 )
		{
			start = 0;
		}
	
		settings._iDisplayStart = start;
	}
	
	
	function _fnRenderer( settings, type )
	{
		var renderer = settings.renderer;
		var host = DataTable.ext.renderer[type];
	
		if ( $.isPlainObject( renderer ) && renderer[type] ) {
			// Specific renderer for this type. If available use it, otherwise use
			// the default.
			return host[renderer[type]] || host._;
		}
		else if ( typeof renderer === 'string' ) {
			// Common renderer - if there is one available for this type use it,
			// otherwise use the default
			return host[renderer] || host._;
		}
	
		// Use the default
		return host._;
	}
	
	
	/**
	 * Detect the data source being used for the table. Used to simplify the code
	 * a little (ajax) and to make it compress a little smaller.
	 *
	 *  @param {object} settings dataTables settings object
	 *  @returns {string} Data source
	 *  @memberof DataTable#oApi
	 */
	function _fnDataSource ( settings )
	{
		if ( settings.oFeatures.bServerSide ) {
			return 'ssp';
		}
		else if ( settings.ajax || settings.sAjaxSource ) {
			return 'ajax';
		}
		return 'dom';
	}
	
	
	
	
	/**
	 * Computed structure of the DataTables API, defined by the options passed to
	 * `DataTable.Api.register()` when building the API.
	 *
	 * The structure is built in order to speed creation and extension of the Api
	 * objects since the extensions are effectively pre-parsed.
	 *
	 * The array is an array of objects with the following structure, where this
	 * base array represents the Api prototype base:
	 *
	 *     [
	 *       {
	 *         name:      'data'                -- string   - Property name
	 *         val:       function () {},       -- function - Api method (or undefined if just an object
	 *         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
	 *         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
	 *       },
	 *       {
	 *         name:     'row'
	 *         val:       {},
	 *         methodExt: [ ... ],
	 *         propExt:   [
	 *           {
	 *             name:      'data'
	 *             val:       function () {},
	 *             methodExt: [ ... ],
	 *             propExt:   [ ... ]
	 *           },
	 *           ...
	 *         ]
	 *       }
	 *     ]
	 *
	 * @type {Array}
	 * @ignore
	 */
	var __apiStruct = [];
	
	
	/**
	 * `Array.prototype` reference.
	 *
	 * @type object
	 * @ignore
	 */
	var __arrayProto = Array.prototype;
	
	
	/**
	 * Abstraction for `context` parameter of the `Api` constructor to allow it to
	 * take several different forms for ease of use.
	 *
	 * Each of the input parameter types will be converted to a DataTables settings
	 * object where possible.
	 *
	 * @param  {string|node|jQuery|object} mixed DataTable identifier. Can be one
	 *   of:
	 *
	 *   * `string` - jQuery selector. Any DataTables' matching the given selector
	 *     with be found and used.
	 *   * `node` - `TABLE` node which has already been formed into a DataTable.
	 *   * `jQuery` - A jQuery object of `TABLE` nodes.
	 *   * `object` - DataTables settings object
	 *   * `DataTables.Api` - API instance
	 * @return {array|null} Matching DataTables settings objects. `null` or
	 *   `undefined` is returned if no matching DataTable is found.
	 * @ignore
	 */
	var _toSettings = function ( mixed )
	{
		var idx, jq;
		var settings = DataTable.settings;
		var tables = $.map( settings, function (el, i) {
			return el.nTable;
		} );
	
		if ( ! mixed ) {
			return [];
		}
		else if ( mixed.nTable && mixed.oApi ) {
			// DataTables settings object
			return [ mixed ];
		}
		else if ( mixed.nodeName && mixed.nodeName.toLowerCase() === 'table' ) {
			// Table node
			idx = $.inArray( mixed, tables );
			return idx !== -1 ? [ settings[idx] ] : null;
		}
		else if ( mixed && typeof mixed.settings === 'function' ) {
			return mixed.settings().toArray();
		}
		else if ( typeof mixed === 'string' ) {
			// jQuery selector
			jq = $(mixed);
		}
		else if ( mixed instanceof $ ) {
			// jQuery object (also DataTables instance)
			jq = mixed;
		}
	
		if ( jq ) {
			return jq.map( function(i) {
				idx = $.inArray( this, tables );
				return idx !== -1 ? settings[idx] : null;
			} ).toArray();
		}
	};
	
	
	/**
	 * DataTables API class - used to control and interface with  one or more
	 * DataTables enhanced tables.
	 *
	 * The API class is heavily based on jQuery, presenting a chainable interface
	 * that you can use to interact with tables. Each instance of the API class has
	 * a "context" - i.e. the tables that it will operate on. This could be a single
	 * table, all tables on a page or a sub-set thereof.
	 *
	 * Additionally the API is designed to allow you to easily work with the data in
	 * the tables, retrieving and manipulating it as required. This is done by
	 * presenting the API class as an array like interface. The contents of the
	 * array depend upon the actions requested by each method (for example
	 * `rows().nodes()` will return an array of nodes, while `rows().data()` will
	 * return an array of objects or arrays depending upon your table's
	 * configuration). The API object has a number of array like methods (`push`,
	 * `pop`, `reverse` etc) as well as additional helper methods (`each`, `pluck`,
	 * `unique` etc) to assist your working with the data held in a table.
	 *
	 * Most methods (those which return an Api instance) are chainable, which means
	 * the return from a method call also has all of the methods available that the
	 * top level object had. For example, these two calls are equivalent:
	 *
	 *     // Not chained
	 *     api.row.add( {...} );
	 *     api.draw();
	 *
	 *     // Chained
	 *     api.row.add( {...} ).draw();
	 *
	 * @class DataTable.Api
	 * @param {array|object|string|jQuery} context DataTable identifier. This is
	 *   used to define which DataTables enhanced tables this API will operate on.
	 *   Can be one of:
	 *
	 *   * `string` - jQuery selector. Any DataTables' matching the given selector
	 *     with be found and used.
	 *   * `node` - `TABLE` node which has already been formed into a DataTable.
	 *   * `jQuery` - A jQuery object of `TABLE` nodes.
	 *   * `object` - DataTables settings object
	 * @param {array} [data] Data to initialise the Api instance with.
	 *
	 * @example
	 *   // Direct initialisation during DataTables construction
	 *   var api = $('#example').DataTable();
	 *
	 * @example
	 *   // Initialisation using a DataTables jQuery object
	 *   var api = $('#example').dataTable().api();
	 *
	 * @example
	 *   // Initialisation as a constructor
	 *   var api = new $.fn.DataTable.Api( 'table.dataTable' );
	 */
	_Api = function ( context, data )
	{
		if ( ! (this instanceof _Api) ) {
			return new _Api( context, data );
		}
	
		var settings = [];
		var ctxSettings = function ( o ) {
			var a = _toSettings( o );
			if ( a ) {
				settings.push.apply( settings, a );
			}
		};
	
		if ( Array.isArray( context ) ) {
			for ( var i=0, ien=context.length ; i<ien ; i++ ) {
				ctxSettings( context[i] );
			}
		}
		else {
			ctxSettings( context );
		}
	
		// Remove duplicates
		this.context = _unique( settings );
	
		// Initial data
		if ( data ) {
			$.merge( this, data );
		}
	
		// selector
		this.selector = {
			rows: null,
			cols: null,
			opts: null
		};
	
		_Api.extend( this, this, __apiStruct );
	};
	
	DataTable.Api = _Api;
	
	// Don't destroy the existing prototype, just extend it. Required for jQuery 2's
	// isPlainObject.
	$.extend( _Api.prototype, {
		any: function ()
		{
			return this.count() !== 0;
		},
	
	
		concat:  __arrayProto.concat,
	
	
		context: [], // array of table settings objects
	
	
		count: function ()
		{
			return this.flatten().length;
		},
	
	
		each: function ( fn )
		{
			for ( var i=0, ien=this.length ; i<ien; i++ ) {
				fn.call( this, this[i], i, this );
			}
	
			return this;
		},
	
	
		eq: function ( idx )
		{
			var ctx = this.context;
	
			return ctx.length > idx ?
				new _Api( ctx[idx], this[idx] ) :
				null;
		},
	
	
		filter: function ( fn )
		{
			var a = [];
	
			if ( __arrayProto.filter ) {
				a = __arrayProto.filter.call( this, fn, this );
			}
			else {
				// Compatibility for browsers without EMCA-252-5 (JS 1.6)
				for ( var i=0, ien=this.length ; i<ien ; i++ ) {
					if ( fn.call( this, this[i], i, this ) ) {
						a.push( this[i] );
					}
				}
			}
	
			return new _Api( this.context, a );
		},
	
	
		flatten: function ()
		{
			var a = [];
			return new _Api( this.context, a.concat.apply( a, this.toArray() ) );
		},
	
	
		join:    __arrayProto.join,
	
	
		indexOf: __arrayProto.indexOf || function (obj, start)
		{
			for ( var i=(start || 0), ien=this.length ; i<ien ; i++ ) {
				if ( this[i] === obj ) {
					return i;
				}
			}
			return -1;
		},
	
		iterator: function ( flatten, type, fn, alwaysNew ) {
			var
				a = [], ret,
				i, ien, j, jen,
				context = this.context,
				rows, items, item,
				selector = this.selector;
	
			// Argument shifting
			if ( typeof flatten === 'string' ) {
				alwaysNew = fn;
				fn = type;
				type = flatten;
				flatten = false;
			}
	
			for ( i=0, ien=context.length ; i<ien ; i++ ) {
				var apiInst = new _Api( context[i] );
	
				if ( type === 'table' ) {
					ret = fn.call( apiInst, context[i], i );
	
					if ( ret !== undefined ) {
						a.push( ret );
					}
				}
				else if ( type === 'columns' || type === 'rows' ) {
					// this has same length as context - one entry for each table
					ret = fn.call( apiInst, context[i], this[i], i );
	
					if ( ret !== undefined ) {
						a.push( ret );
					}
				}
				else if ( type === 'column' || type === 'column-rows' || type === 'row' || type === 'cell' ) {
					// columns and rows share the same structure.
					// 'this' is an array of column indexes for each context
					items = this[i];
	
					if ( type === 'column-rows' ) {
						rows = _selector_row_indexes( context[i], selector.opts );
					}
	
					for ( j=0, jen=items.length ; j<jen ; j++ ) {
						item = items[j];
	
						if ( type === 'cell' ) {
							ret = fn.call( apiInst, context[i], item.row, item.column, i, j );
						}
						else {
							ret = fn.call( apiInst, context[i], item, i, j, rows );
						}
	
						if ( ret !== undefined ) {
							a.push( ret );
						}
					}
				}
			}
	
			if ( a.length || alwaysNew ) {
				var api = new _Api( context, flatten ? a.concat.apply( [], a ) : a );
				var apiSelector = api.selector;
				apiSelector.rows = selector.rows;
				apiSelector.cols = selector.cols;
				apiSelector.opts = selector.opts;
				return api;
			}
			return this;
		},
	
	
		lastIndexOf: __arrayProto.lastIndexOf || function (obj, start)
		{
			// Bit cheeky...
			return this.indexOf.apply( this.toArray.reverse(), arguments );
		},
	
	
		length:  0,
	
	
		map: function ( fn )
		{
			var a = [];
	
			if ( __arrayProto.map ) {
				a = __arrayProto.map.call( this, fn, this );
			}
			else {
				// Compatibility for browsers without EMCA-252-5 (JS 1.6)
				for ( var i=0, ien=this.length ; i<ien ; i++ ) {
					a.push( fn.call( this, this[i], i ) );
				}
			}
	
			return new _Api( this.context, a );
		},
	
	
		pluck: function ( prop )
		{
			var fn = DataTable.util.get(prop);
	
			return this.map( function ( el ) {
				return fn(el);
			} );
		},
	
		pop:     __arrayProto.pop,
	
	
		push:    __arrayProto.push,
	
	
		// Does not return an API instance
		reduce: __arrayProto.reduce || function ( fn, init )
		{
			return _fnReduce( this, fn, init, 0, this.length, 1 );
		},
	
	
		reduceRight: __arrayProto.reduceRight || function ( fn, init )
		{
			return _fnReduce( this, fn, init, this.length-1, -1, -1 );
		},
	
	
		reverse: __arrayProto.reverse,
	
	
		// Object with rows, columns and opts
		selector: null,
	
	
		shift:   __arrayProto.shift,
	
	
		slice: function () {
			return new _Api( this.context, this );
		},
	
	
		sort:    __arrayProto.sort, // ? name - order?
	
	
		splice:  __arrayProto.splice,
	
	
		toArray: function ()
		{
			return __arrayProto.slice.call( this );
		},
	
	
		to$: function ()
		{
			return $( this );
		},
	
	
		toJQuery: function ()
		{
			return $( this );
		},
	
	
		unique: function ()
		{
			return new _Api( this.context, _unique(this) );
		},
	
	
		unshift: __arrayProto.unshift
	} );
	
	
	_Api.extend = function ( scope, obj, ext )
	{
		// Only extend API instances and static properties of the API
		if ( ! ext.length || ! obj || ( ! (obj instanceof _Api) && ! obj.__dt_wrapper ) ) {
			return;
		}
	
		var
			i, ien,
			struct,
			methodScoping = function ( scope, fn, struc ) {
				return function () {
					var ret = fn.apply( scope, arguments );
	
					// Method extension
					_Api.extend( ret, ret, struc.methodExt );
					return ret;
				};
			};
	
		for ( i=0, ien=ext.length ; i<ien ; i++ ) {
			struct = ext[i];
	
			// Value
			obj[ struct.name ] = struct.type === 'function' ?
				methodScoping( scope, struct.val, struct ) :
				struct.type === 'object' ?
					{} :
					struct.val;
	
			obj[ struct.name ].__dt_wrapper = true;
	
			// Property extension
			_Api.extend( scope, obj[ struct.name ], struct.propExt );
		}
	};
	
	
	// @todo - Is there need for an augment function?
	// _Api.augment = function ( inst, name )
	// {
	// 	// Find src object in the structure from the name
	// 	var parts = name.split('.');
	
	// 	_Api.extend( inst, obj );
	// };
	
	
	//     [
	//       {
	//         name:      'data'                -- string   - Property name
	//         val:       function () {},       -- function - Api method (or undefined if just an object
	//         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
	//         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
	//       },
	//       {
	//         name:     'row'
	//         val:       {},
	//         methodExt: [ ... ],
	//         propExt:   [
	//           {
	//             name:      'data'
	//             val:       function () {},
	//             methodExt: [ ... ],
	//             propExt:   [ ... ]
	//           },
	//           ...
	//         ]
	//       }
	//     ]
	
	_Api.register = _api_register = function ( name, val )
	{
		if ( Array.isArray( name ) ) {
			for ( var j=0, jen=name.length ; j<jen ; j++ ) {
				_Api.register( name[j], val );
			}
			return;
		}
	
		var
			i, ien,
			heir = name.split('.'),
			struct = __apiStruct,
			key, method;
	
		var find = function ( src, name ) {
			for ( var i=0, ien=src.length ; i<ien ; i++ ) {
				if ( src[i].name === name ) {
					return src[i];
				}
			}
			return null;
		};
	
		for ( i=0, ien=heir.length ; i<ien ; i++ ) {
			method = heir[i].indexOf('()') !== -1;
			key = method ?
				heir[i].replace('()', '') :
				heir[i];
	
			var src = find( struct, key );
			if ( ! src ) {
				src = {
					name:      key,
					val:       {},
					methodExt: [],
					propExt:   [],
					type:      'object'
				};
				struct.push( src );
			}
	
			if ( i === ien-1 ) {
				src.val = val;
				src.type = typeof val === 'function' ?
					'function' :
					$.isPlainObject( val ) ?
						'object' :
						'other';
			}
			else {
				struct = method ?
					src.methodExt :
					src.propExt;
			}
		}
	};
	
	_Api.registerPlural = _api_registerPlural = function ( pluralName, singularName, val ) {
		_Api.register( pluralName, val );
	
		_Api.register( singularName, function () {
			var ret = val.apply( this, arguments );
	
			if ( ret === this ) {
				// Returned item is the API instance that was passed in, return it
				return this;
			}
			else if ( ret instanceof _Api ) {
				// New API instance returned, want the value from the first item
				// in the returned array for the singular result.
				return ret.length ?
					Array.isArray( ret[0] ) ?
						new _Api( ret.context, ret[0] ) : // Array results are 'enhanced'
						ret[0] :
					undefined;
			}
	
			// Non-API return - just fire it back
			return ret;
		} );
	};
	
	
	/**
	 * Selector for HTML tables. Apply the given selector to the give array of
	 * DataTables settings objects.
	 *
	 * @param {string|integer} [selector] jQuery selector string or integer
	 * @param  {array} Array of DataTables settings objects to be filtered
	 * @return {array}
	 * @ignore
	 */
	var __table_selector = function ( selector, a )
	{
		if ( Array.isArray(selector) ) {
			return $.map( selector, function (item) {
				return __table_selector(item, a);
			} );
		}
	
		// Integer is used to pick out a table by index
		if ( typeof selector === 'number' ) {
			return [ a[ selector ] ];
		}
	
		// Perform a jQuery selector on the table nodes
		var nodes = $.map( a, function (el, i) {
			return el.nTable;
		} );
	
		return $(nodes)
			.filter( selector )
			.map( function (i) {
				// Need to translate back from the table node to the settings
				var idx = $.inArray( this, nodes );
				return a[ idx ];
			} )
			.toArray();
	};
	
	
	
	/**
	 * Context selector for the API's context (i.e. the tables the API instance
	 * refers to.
	 *
	 * @name    DataTable.Api#tables
	 * @param {string|integer} [selector] Selector to pick which tables the iterator
	 *   should operate on. If not given, all tables in the current context are
	 *   used. This can be given as a jQuery selector (for example `':gt(0)'`) to
	 *   select multiple tables or as an integer to select a single table.
	 * @returns {DataTable.Api} Returns a new API instance if a selector is given.
	 */
	_api_register( 'tables()', function ( selector ) {
		// A new instance is created if there was a selector specified
		return selector !== undefined && selector !== null ?
			new _Api( __table_selector( selector, this.context ) ) :
			this;
	} );
	
	
	_api_register( 'table()', function ( selector ) {
		var tables = this.tables( selector );
		var ctx = tables.context;
	
		// Truncate to the first matched table
		return ctx.length ?
			new _Api( ctx[0] ) :
			tables;
	} );
	
	
	_api_registerPlural( 'tables().nodes()', 'table().node()' , function () {
		return this.iterator( 'table', function ( ctx ) {
			return ctx.nTable;
		}, 1 );
	} );
	
	
	_api_registerPlural( 'tables().body()', 'table().body()' , function () {
		return this.iterator( 'table', function ( ctx ) {
			return ctx.nTBody;
		}, 1 );
	} );
	
	
	_api_registerPlural( 'tables().header()', 'table().header()' , function () {
		return this.iterator( 'table', function ( ctx ) {
			return ctx.nTHead;
		}, 1 );
	} );
	
	
	_api_registerPlural( 'tables().footer()', 'table().footer()' , function () {
		return this.iterator( 'table', function ( ctx ) {
			return ctx.nTFoot;
		}, 1 );
	} );
	
	
	_api_registerPlural( 'tables().containers()', 'table().container()' , function () {
		return this.iterator( 'table', function ( ctx ) {
			return ctx.nTableWrapper;
		}, 1 );
	} );
	
	
	
	/**
	 * Redraw the tables in the current context.
	 */
	_api_register( 'draw()', function ( paging ) {
		return this.iterator( 'table', function ( settings ) {
			if ( paging === 'page' ) {
				_fnDraw( settings );
			}
			else {
				if ( typeof paging === 'string' ) {
					paging = paging === 'full-hold' ?
						false :
						true;
				}
	
				_fnReDraw( settings, paging===false );
			}
		} );
	} );
	
	
	
	/**
	 * Get the current page index.
	 *
	 * @return {integer} Current page index (zero based)
	 *//**
	 * Set the current page.
	 *
	 * Note that if you attempt to show a page which does not exist, DataTables will
	 * not throw an error, but rather reset the paging.
	 *
	 * @param {integer|string} action The paging action to take. This can be one of:
	 *  * `integer` - The page index to jump to
	 *  * `string` - An action to take:
	 *    * `first` - Jump to first page.
	 *    * `next` - Jump to the next page
	 *    * `previous` - Jump to previous page
	 *    * `last` - Jump to the last page.
	 * @returns {DataTables.Api} this
	 */
	_api_register( 'page()', function ( action ) {
		if ( action === undefined ) {
			return this.page.info().page; // not an expensive call
		}
	
		// else, have an action to take on all tables
		return this.iterator( 'table', function ( settings ) {
			_fnPageChange( settings, action );
		} );
	} );
	
	
	/**
	 * Paging information for the first table in the current context.
	 *
	 * If you require paging information for another table, use the `table()` method
	 * with a suitable selector.
	 *
	 * @return {object} Object with the following properties set:
	 *  * `page` - Current page index (zero based - i.e. the first page is `0`)
	 *  * `pages` - Total number of pages
	 *  * `start` - Display index for the first record shown on the current page
	 *  * `end` - Display index for the last record shown on the current page
	 *  * `length` - Display length (number of records). Note that generally `start
	 *    + length = end`, but this is not always true, for example if there are
	 *    only 2 records to show on the final page, with a length of 10.
	 *  * `recordsTotal` - Full data set length
	 *  * `recordsDisplay` - Data set length once the current filtering criterion
	 *    are applied.
	 */
	_api_register( 'page.info()', function ( action ) {
		if ( this.context.length === 0 ) {
			return undefined;
		}
	
		var
			settings   = this.context[0],
			start      = settings._iDisplayStart,
			len        = settings.oFeatures.bPaginate ? settings._iDisplayLength : -1,
			visRecords = settings.fnRecordsDisplay(),
			all        = len === -1;
	
		return {
			"page":           all ? 0 : Math.floor( start / len ),
			"pages":          all ? 1 : Math.ceil( visRecords / len ),
			"start":          start,
			"end":            settings.fnDisplayEnd(),
			"length":         len,
			"recordsTotal":   settings.fnRecordsTotal(),
			"recordsDisplay": visRecords,
			"serverSide":     _fnDataSource( settings ) === 'ssp'
		};
	} );
	
	
	/**
	 * Get the current page length.
	 *
	 * @return {integer} Current page length. Note `-1` indicates that all records
	 *   are to be shown.
	 *//**
	 * Set the current page length.
	 *
	 * @param {integer} Page length to set. Use `-1` to show all records.
	 * @returns {DataTables.Api} this
	 */
	_api_register( 'page.len()', function ( len ) {
		// Note that we can't call this function 'length()' because `length`
		// is a Javascript property of functions which defines how many arguments
		// the function expects.
		if ( len === undefined ) {
			return this.context.length !== 0 ?
				this.context[0]._iDisplayLength :
				undefined;
		}
	
		// else, set the page length
		return this.iterator( 'table', function ( settings ) {
			_fnLengthChange( settings, len );
		} );
	} );
	
	
	
	var __reload = function ( settings, holdPosition, callback ) {
		// Use the draw event to trigger a callback
		if ( callback ) {
			var api = new _Api( settings );
	
			api.one( 'draw', function () {
				callback( api.ajax.json() );
			} );
		}
	
		if ( _fnDataSource( settings ) == 'ssp' ) {
			_fnReDraw( settings, holdPosition );
		}
		else {
			_fnProcessingDisplay( settings, true );
	
			// Cancel an existing request
			var xhr = settings.jqXHR;
			if ( xhr && xhr.readyState !== 4 ) {
				xhr.abort();
			}
	
			// Trigger xhr
			_fnBuildAjax( settings, [], function( json ) {
				_fnClearTable( settings );
	
				var data = _fnAjaxDataSrc( settings, json );
				for ( var i=0, ien=data.length ; i<ien ; i++ ) {
					_fnAddData( settings, data[i] );
				}
	
				_fnReDraw( settings, holdPosition );
				_fnProcessingDisplay( settings, false );
			} );
		}
	};
	
	
	/**
	 * Get the JSON response from the last Ajax request that DataTables made to the
	 * server. Note that this returns the JSON from the first table in the current
	 * context.
	 *
	 * @return {object} JSON received from the server.
	 */
	_api_register( 'ajax.json()', function () {
		var ctx = this.context;
	
		if ( ctx.length > 0 ) {
			return ctx[0].json;
		}
	
		// else return undefined;
	} );
	
	
	/**
	 * Get the data submitted in the last Ajax request
	 */
	_api_register( 'ajax.params()', function () {
		var ctx = this.context;
	
		if ( ctx.length > 0 ) {
			return ctx[0].oAjaxData;
		}
	
		// else return undefined;
	} );
	
	
	/**
	 * Reload tables from the Ajax data source. Note that this function will
	 * automatically re-draw the table when the remote data has been loaded.
	 *
	 * @param {boolean} [reset=true] Reset (default) or hold the current paging
	 *   position. A full re-sort and re-filter is performed when this method is
	 *   called, which is why the pagination reset is the default action.
	 * @returns {DataTables.Api} this
	 */
	_api_register( 'ajax.reload()', function ( callback, resetPaging ) {
		return this.iterator( 'table', function (settings) {
			__reload( settings, resetPaging===false, callback );
		} );
	} );
	
	
	/**
	 * Get the current Ajax URL. Note that this returns the URL from the first
	 * table in the current context.
	 *
	 * @return {string} Current Ajax source URL
	 *//**
	 * Set the Ajax URL. Note that this will set the URL for all tables in the
	 * current context.
	 *
	 * @param {string} url URL to set.
	 * @returns {DataTables.Api} this
	 */
	_api_register( 'ajax.url()', function ( url ) {
		var ctx = this.context;
	
		if ( url === undefined ) {
			// get
			if ( ctx.length === 0 ) {
				return undefined;
			}
			ctx = ctx[0];
	
			return ctx.ajax ?
				$.isPlainObject( ctx.ajax ) ?
					ctx.ajax.url :
					ctx.ajax :
				ctx.sAjaxSource;
		}
	
		// set
		return this.iterator( 'table', function ( settings ) {
			if ( $.isPlainObject( settings.ajax ) ) {
				settings.ajax.url = url;
			}
			else {
				settings.ajax = url;
			}
			// No need to consider sAjaxSource here since DataTables gives priority
			// to `ajax` over `sAjaxSource`. So setting `ajax` here, renders any
			// value of `sAjaxSource` redundant.
		} );
	} );
	
	
	/**
	 * Load data from the newly set Ajax URL. Note that this method is only
	 * available when `ajax.url()` is used to set a URL. Additionally, this method
	 * has the same effect as calling `ajax.reload()` but is provided for
	 * convenience when setting a new URL. Like `ajax.reload()` it will
	 * automatically redraw the table once the remote data has been loaded.
	 *
	 * @returns {DataTables.Api} this
	 */
	_api_register( 'ajax.url().load()', function ( callback, resetPaging ) {
		// Same as a reload, but makes sense to present it for easy access after a
		// url change
		return this.iterator( 'table', function ( ctx ) {
			__reload( ctx, resetPaging===false, callback );
		} );
	} );
	
	
	
	
	var _selector_run = function ( type, selector, selectFn, settings, opts )
	{
		var
			out = [], res,
			a, i, ien, j, jen,
			selectorType = typeof selector;
	
		// Can't just check for isArray here, as an API or jQuery instance might be
		// given with their array like look
		if ( ! selector || selectorType === 'string' || selectorType === 'function' || selector.length === undefined ) {
			selector = [ selector ];
		}
	
		for ( i=0, ien=selector.length ; i<ien ; i++ ) {
			// Only split on simple strings - complex expressions will be jQuery selectors
			a = selector[i] && selector[i].split && ! selector[i].match(/[\[\(:]/) ?
				selector[i].split(',') :
				[ selector[i] ];
	
			for ( j=0, jen=a.length ; j<jen ; j++ ) {
				res = selectFn( typeof a[j] === 'string' ? (a[j]).trim() : a[j] );
	
				if ( res && res.length ) {
					out = out.concat( res );
				}
			}
		}
	
		// selector extensions
		var ext = _ext.selector[ type ];
		if ( ext.length ) {
			for ( i=0, ien=ext.length ; i<ien ; i++ ) {
				out = ext[i]( settings, opts, out );
			}
		}
	
		return _unique( out );
	};
	
	
	var _selector_opts = function ( opts )
	{
		if ( ! opts ) {
			opts = {};
		}
	
		// Backwards compatibility for 1.9- which used the terminology filter rather
		// than search
		if ( opts.filter && opts.search === undefined ) {
			opts.search = opts.filter;
		}
	
		return $.extend( {
			search: 'none',
			order: 'current',
			page: 'all'
		}, opts );
	};
	
	
	var _selector_first = function ( inst )
	{
		// Reduce the API instance to the first item found
		for ( var i=0, ien=inst.length ; i<ien ; i++ ) {
			if ( inst[i].length > 0 ) {
				// Assign the first element to the first item in the instance
				// and truncate the instance and context
				inst[0] = inst[i];
				inst[0].length = 1;
				inst.length = 1;
				inst.context = [ inst.context[i] ];
	
				return inst;
			}
		}
	
		// Not found - return an empty instance
		inst.length = 0;
		return inst;
	};
	
	
	var _selector_row_indexes = function ( settings, opts )
	{
		var
			i, ien, tmp, a=[],
			displayFiltered = settings.aiDisplay,
			displayMaster = settings.aiDisplayMaster;
	
		var
			search = opts.search,  // none, applied, removed
			order  = opts.order,   // applied, current, index (original - compatibility with 1.9)
			page   = opts.page;    // all, current
	
		if ( _fnDataSource( settings ) == 'ssp' ) {
			// In server-side processing mode, most options are irrelevant since
			// rows not shown don't exist and the index order is the applied order
			// Removed is a special case - for consistency just return an empty
			// array
			return search === 'removed' ?
				[] :
				_range( 0, displayMaster.length );
		}
		else if ( page == 'current' ) {
			// Current page implies that order=current and filter=applied, since it is
			// fairly senseless otherwise, regardless of what order and search actually
			// are
			for ( i=settings._iDisplayStart, ien=settings.fnDisplayEnd() ; i<ien ; i++ ) {
				a.push( displayFiltered[i] );
			}
		}
		else if ( order == 'current' || order == 'applied' ) {
			if ( search == 'none') {
				a = displayMaster.slice();
			}
			else if ( search == 'applied' ) {
				a = displayFiltered.slice();
			}
			else if ( search == 'removed' ) {
				// O(n+m) solution by creating a hash map
				var displayFilteredMap = {};
	
				for ( var i=0, ien=displayFiltered.length ; i<ien ; i++ ) {
					displayFilteredMap[displayFiltered[i]] = null;
				}
	
				a = $.map( displayMaster, function (el) {
					return ! displayFilteredMap.hasOwnProperty(el) ?
						el :
						null;
				} );
			}
		}
		else if ( order == 'index' || order == 'original' ) {
			for ( i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
				if ( search == 'none' ) {
					a.push( i );
				}
				else { // applied | removed
					tmp = $.inArray( i, displayFiltered );
	
					if ((tmp === -1 && search == 'removed') ||
						(tmp >= 0   && search == 'applied') )
					{
						a.push( i );
					}
				}
			}
		}
	
		return a;
	};
	
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Rows
	 *
	 * {}          - no selector - use all available rows
	 * {integer}   - row aoData index
	 * {node}      - TR node
	 * {string}    - jQuery selector to apply to the TR elements
	 * {array}     - jQuery array of nodes, or simply an array of TR nodes
	 *
	 */
	var __row_selector = function ( settings, selector, opts )
	{
		var rows;
		var run = function ( sel ) {
			var selInt = _intVal( sel );
			var i, ien;
			var aoData = settings.aoData;
	
			// Short cut - selector is a number and no options provided (default is
			// all records, so no need to check if the index is in there, since it
			// must be - dev error if the index doesn't exist).
			if ( selInt !== null && ! opts ) {
				return [ selInt ];
			}
	
			if ( ! rows ) {
				rows = _selector_row_indexes( settings, opts );
			}
	
			if ( selInt !== null && $.inArray( selInt, rows ) !== -1 ) {
				// Selector - integer
				return [ selInt ];
			}
			else if ( sel === null || sel === undefined || sel === '' ) {
				// Selector - none
				return rows;
			}
	
			// Selector - function
			if ( typeof sel === 'function' ) {
				return $.map( rows, function (idx) {
					var row = aoData[ idx ];
					return sel( idx, row._aData, row.nTr ) ? idx : null;
				} );
			}
	
			// Selector - node
			if ( sel.nodeName ) {
				var rowIdx = sel._DT_RowIndex;  // Property added by DT for fast lookup
				var cellIdx = sel._DT_CellIndex;
	
				if ( rowIdx !== undefined ) {
					// Make sure that the row is actually still present in the table
					return aoData[ rowIdx ] && aoData[ rowIdx ].nTr === sel ?
						[ rowIdx ] :
						[];
				}
				else if ( cellIdx ) {
					return aoData[ cellIdx.row ] && aoData[ cellIdx.row ].nTr === sel.parentNode ?
						[ cellIdx.row ] :
						[];
				}
				else {
					var host = $(sel).closest('*[data-dt-row]');
					return host.length ?
						[ host.data('dt-row') ] :
						[];
				}
			}
	
			// ID selector. Want to always be able to select rows by id, regardless
			// of if the tr element has been created or not, so can't rely upon
			// jQuery here - hence a custom implementation. This does not match
			// Sizzle's fast selector or HTML4 - in HTML5 the ID can be anything,
			// but to select it using a CSS selector engine (like Sizzle or
			// querySelect) it would need to need to be escaped for some characters.
			// DataTables simplifies this for row selectors since you can select
			// only a row. A # indicates an id any anything that follows is the id -
			// unescaped.
			if ( typeof sel === 'string' && sel.charAt(0) === '#' ) {
				// get row index from id
				var rowObj = settings.aIds[ sel.replace( /^#/, '' ) ];
				if ( rowObj !== undefined ) {
					return [ rowObj.idx ];
				}
	
				// need to fall through to jQuery in case there is DOM id that
				// matches
			}
			
			// Get nodes in the order from the `rows` array with null values removed
			var nodes = _removeEmpty(
				_pluck_order( settings.aoData, rows, 'nTr' )
			);
	
			// Selector - jQuery selector string, array of nodes or jQuery object/
			// As jQuery's .filter() allows jQuery objects to be passed in filter,
			// it also allows arrays, so this will cope with all three options
			return $(nodes)
				.filter( sel )
				.map( function () {
					return this._DT_RowIndex;
				} )
				.toArray();
		};
	
		return _selector_run( 'row', selector, run, settings, opts );
	};
	
	
	_api_register( 'rows()', function ( selector, opts ) {
		// argument shifting
		if ( selector === undefined ) {
			selector = '';
		}
		else if ( $.isPlainObject( selector ) ) {
			opts = selector;
			selector = '';
		}
	
		opts = _selector_opts( opts );
	
		var inst = this.iterator( 'table', function ( settings ) {
			return __row_selector( settings, selector, opts );
		}, 1 );
	
		// Want argument shifting here and in __row_selector?
		inst.selector.rows = selector;
		inst.selector.opts = opts;
	
		return inst;
	} );
	
	_api_register( 'rows().nodes()', function () {
		return this.iterator( 'row', function ( settings, row ) {
			return settings.aoData[ row ].nTr || undefined;
		}, 1 );
	} );
	
	_api_register( 'rows().data()', function () {
		return this.iterator( true, 'rows', function ( settings, rows ) {
			return _pluck_order( settings.aoData, rows, '_aData' );
		}, 1 );
	} );
	
	_api_registerPlural( 'rows().cache()', 'row().cache()', function ( type ) {
		return this.iterator( 'row', function ( settings, row ) {
			var r = settings.aoData[ row ];
			return type === 'search' ? r._aFilterData : r._aSortData;
		}, 1 );
	} );
	
	_api_registerPlural( 'rows().invalidate()', 'row().invalidate()', function ( src ) {
		return this.iterator( 'row', function ( settings, row ) {
			_fnInvalidate( settings, row, src );
		} );
	} );
	
	_api_registerPlural( 'rows().indexes()', 'row().index()', function () {
		return this.iterator( 'row', function ( settings, row ) {
			return row;
		}, 1 );
	} );
	
	_api_registerPlural( 'rows().ids()', 'row().id()', function ( hash ) {
		var a = [];
		var context = this.context;
	
		// `iterator` will drop undefined values, but in this case we want them
		for ( var i=0, ien=context.length ; i<ien ; i++ ) {
			for ( var j=0, jen=this[i].length ; j<jen ; j++ ) {
				var id = context[i].rowIdFn( context[i].aoData[ this[i][j] ]._aData );
				a.push( (hash === true ? '#' : '' )+ id );
			}
		}
	
		return new _Api( context, a );
	} );
	
	_api_registerPlural( 'rows().remove()', 'row().remove()', function () {
		var that = this;
	
		this.iterator( 'row', function ( settings, row, thatIdx ) {
			var data = settings.aoData;
			var rowData = data[ row ];
			var i, ien, j, jen;
			var loopRow, loopCells;
	
			data.splice( row, 1 );
	
			// Update the cached indexes
			for ( i=0, ien=data.length ; i<ien ; i++ ) {
				loopRow = data[i];
				loopCells = loopRow.anCells;
	
				// Rows
				if ( loopRow.nTr !== null ) {
					loopRow.nTr._DT_RowIndex = i;
				}
	
				// Cells
				if ( loopCells !== null ) {
					for ( j=0, jen=loopCells.length ; j<jen ; j++ ) {
						loopCells[j]._DT_CellIndex.row = i;
					}
				}
			}
	
			// Delete from the display arrays
			_fnDeleteIndex( settings.aiDisplayMaster, row );
			_fnDeleteIndex( settings.aiDisplay, row );
			_fnDeleteIndex( that[ thatIdx ], row, false ); // maintain local indexes
	
			// For server-side processing tables - subtract the deleted row from the count
			if ( settings._iRecordsDisplay > 0 ) {
				settings._iRecordsDisplay--;
			}
	
			// Check for an 'overflow' they case for displaying the table
			_fnLengthOverflow( settings );
	
			// Remove the row's ID reference if there is one
			var id = settings.rowIdFn( rowData._aData );
			if ( id !== undefined ) {
				delete settings.aIds[ id ];
			}
		} );
	
		this.iterator( 'table', function ( settings ) {
			for ( var i=0, ien=settings.aoData.length ; i<ien ; i++ ) {
				settings.aoData[i].idx = i;
			}
		} );
	
		return this;
	} );
	
	
	_api_register( 'rows.add()', function ( rows ) {
		var newRows = this.iterator( 'table', function ( settings ) {
				var row, i, ien;
				var out = [];
	
				for ( i=0, ien=rows.length ; i<ien ; i++ ) {
					row = rows[i];
	
					if ( row.nodeName && row.nodeName.toUpperCase() === 'TR' ) {
						out.push( _fnAddTr( settings, row )[0] );
					}
					else {
						out.push( _fnAddData( settings, row ) );
					}
				}
	
				return out;
			}, 1 );
	
		// Return an Api.rows() extended instance, so rows().nodes() etc can be used
		var modRows = this.rows( -1 );
		modRows.pop();
		$.merge( modRows, newRows );
	
		return modRows;
	} );
	
	
	
	
	
	/**
	 *
	 */
	_api_register( 'row()', function ( selector, opts ) {
		return _selector_first( this.rows( selector, opts ) );
	} );
	
	
	_api_register( 'row().data()', function ( data ) {
		var ctx = this.context;
	
		if ( data === undefined ) {
			// Get
			return ctx.length && this.length ?
				ctx[0].aoData[ this[0] ]._aData :
				undefined;
		}
	
		// Set
		var row = ctx[0].aoData[ this[0] ];
		row._aData = data;
	
		// If the DOM has an id, and the data source is an array
		if ( Array.isArray( data ) && row.nTr && row.nTr.id ) {
			_fnSetObjectDataFn( ctx[0].rowId )( data, row.nTr.id );
		}
	
		// Automatically invalidate
		_fnInvalidate( ctx[0], this[0], 'data' );
	
		return this;
	} );
	
	
	_api_register( 'row().node()', function () {
		var ctx = this.context;
	
		return ctx.length && this.length ?
			ctx[0].aoData[ this[0] ].nTr || null :
			null;
	} );
	
	
	_api_register( 'row.add()', function ( row ) {
		// Allow a jQuery object to be passed in - only a single row is added from
		// it though - the first element in the set
		if ( row instanceof $ && row.length ) {
			row = row[0];
		}
	
		var rows = this.iterator( 'table', function ( settings ) {
			if ( row.nodeName && row.nodeName.toUpperCase() === 'TR' ) {
				return _fnAddTr( settings, row )[0];
			}
			return _fnAddData( settings, row );
		} );
	
		// Return an Api.rows() extended instance, with the newly added row selected
		return this.row( rows[0] );
	} );
	
	
	$(document).on('plugin-init.dt', function (e, context) {
		var api = new _Api( context );
		var namespace = 'on-plugin-init';
		var stateSaveParamsEvent = 'stateSaveParams.' + namespace;
		var destroyEvent = 'destroy. ' + namespace;
	
		api.on( stateSaveParamsEvent, function ( e, settings, d ) {
			// This could be more compact with the API, but it is a lot faster as a simple
			// internal loop
			var idFn = settings.rowIdFn;
			var data = settings.aoData;
			var ids = [];
	
			for (var i=0 ; i<data.length ; i++) {
				if (data[i]._detailsShow) {
					ids.push( '#' + idFn(data[i]._aData) );
				}
			}
	
			d.childRows = ids;
		});
	
		api.on( destroyEvent, function () {
			api.off(stateSaveParamsEvent + ' ' + destroyEvent);
		});
	
		var loaded = api.state.loaded();
	
		if ( loaded && loaded.childRows ) {
			api
				.rows( $.map(loaded.childRows, function (id){
					return id.replace(/:/g, '\\:')
				}) )
				.every( function () {
					_fnCallbackFire( context, null, 'requestChild', [ this ] )
				});
		}
	});
	
	var __details_add = function ( ctx, row, data, klass )
	{
		// Convert to array of TR elements
		var rows = [];
		var addRow = function ( r, k ) {
			// Recursion to allow for arrays of jQuery objects
			if ( Array.isArray( r ) || r instanceof $ ) {
				for ( var i=0, ien=r.length ; i<ien ; i++ ) {
					addRow( r[i], k );
				}
				return;
			}
	
			// If we get a TR element, then just add it directly - up to the dev
			// to add the correct number of columns etc
			if ( r.nodeName && r.nodeName.toLowerCase() === 'tr' ) {
				rows.push( r );
			}
			else {
				// Otherwise create a row with a wrapper
				var created = $('<tr><td></td></tr>').addClass( k );
				$('td', created)
					.addClass( k )
					.html( r )
					[0].colSpan = _fnVisbleColumns( ctx );
	
				rows.push( created[0] );
			}
		};
	
		addRow( data, klass );
	
		if ( row._details ) {
			row._details.detach();
		}
	
		row._details = $(rows);
	
		// If the children were already shown, that state should be retained
		if ( row._detailsShow ) {
			row._details.insertAfter( row.nTr );
		}
	};
	
	
	// Make state saving of child row details async to allow them to be batch processed
	var __details_state = DataTable.util.throttle(
		function (ctx) {
			_fnSaveState( ctx[0] )
		},
		500
	);
	
	
	var __details_remove = function ( api, idx )
	{
		var ctx = api.context;
	
		if ( ctx.length ) {
			var row = ctx[0].aoData[ idx !== undefined ? idx : api[0] ];
	
			if ( row && row._details ) {
				row._details.remove();
	
				row._detailsShow = undefined;
				row._details = undefined;
				$( row.nTr ).removeClass( 'dt-hasChild' );
				__details_state( ctx );
			}
		}
	};
	
	
	var __details_display = function ( api, show ) {
		var ctx = api.context;
	
		if ( ctx.length && api.length ) {
			var row = ctx[0].aoData[ api[0] ];
	
			if ( row._details ) {
				row._detailsShow = show;
	
				if ( show ) {
					row._details.insertAfter( row.nTr );
					$( row.nTr ).addClass( 'dt-hasChild' );
				}
				else {
					row._details.detach();
					$( row.nTr ).removeClass( 'dt-hasChild' );
				}
	
				_fnCallbackFire( ctx[0], null, 'childRow', [ show, api.row( api[0] ) ] )
	
				__details_events( ctx[0] );
				__details_state( ctx );
			}
		}
	};
	
	
	var __details_events = function ( settings )
	{
		var api = new _Api( settings );
		var namespace = '.dt.DT_details';
		var drawEvent = 'draw'+namespace;
		var colvisEvent = 'column-sizing'+namespace;
		var destroyEvent = 'destroy'+namespace;
		var data = settings.aoData;
	
		api.off( drawEvent +' '+ colvisEvent +' '+ destroyEvent );
	
		if ( _pluck( data, '_details' ).length > 0 ) {
			// On each draw, insert the required elements into the document
			api.on( drawEvent, function ( e, ctx ) {
				if ( settings !== ctx ) {
					return;
				}
	
				api.rows( {page:'current'} ).eq(0).each( function (idx) {
					// Internal data grab
					var row = data[ idx ];
	
					if ( row._detailsShow ) {
						row._details.insertAfter( row.nTr );
					}
				} );
			} );
	
			// Column visibility change - update the colspan
			api.on( colvisEvent, function ( e, ctx, idx, vis ) {
				if ( settings !== ctx ) {
					return;
				}
	
				// Update the colspan for the details rows (note, only if it already has
				// a colspan)
				var row, visible = _fnVisbleColumns( ctx );
	
				for ( var i=0, ien=data.length ; i<ien ; i++ ) {
					row = data[i];
	
					if ( row._details ) {
						row._details.each(function () {
							var el = $(this).children('td');
	
							if (el.length == 1) {
								el.attr('colspan', visible);
							}
						});
					}
				}
			} );
	
			// Table destroyed - nuke any child rows
			api.on( destroyEvent, function ( e, ctx ) {
				if ( settings !== ctx ) {
					return;
				}
	
				for ( var i=0, ien=data.length ; i<ien ; i++ ) {
					if ( data[i]._details ) {
						__details_remove( api, i );
					}
				}
			} );
		}
	};
	
	// Strings for the method names to help minification
	var _emp = '';
	var _child_obj = _emp+'row().child';
	var _child_mth = _child_obj+'()';
	
	// data can be:
	//  tr
	//  string
	//  jQuery or array of any of the above
	_api_register( _child_mth, function ( data, klass ) {
		var ctx = this.context;
	
		if ( data === undefined ) {
			// get
			return ctx.length && this.length ?
				ctx[0].aoData[ this[0] ]._details :
				undefined;
		}
		else if ( data === true ) {
			// show
			this.child.show();
		}
		else if ( data === false ) {
			// remove
			__details_remove( this );
		}
		else if ( ctx.length && this.length ) {
			// set
			__details_add( ctx[0], ctx[0].aoData[ this[0] ], data, klass );
		}
	
		return this;
	} );
	
	
	_api_register( [
		_child_obj+'.show()',
		_child_mth+'.show()' // only when `child()` was called with parameters (without
	], function ( show ) {   // it returns an object and this method is not executed)
		__details_display( this, true );
		return this;
	} );
	
	
	_api_register( [
		_child_obj+'.hide()',
		_child_mth+'.hide()' // only when `child()` was called with parameters (without
	], function () {         // it returns an object and this method is not executed)
		__details_display( this, false );
		return this;
	} );
	
	
	_api_register( [
		_child_obj+'.remove()',
		_child_mth+'.remove()' // only when `child()` was called with parameters (without
	], function () {           // it returns an object and this method is not executed)
		__details_remove( this );
		return this;
	} );
	
	
	_api_register( _child_obj+'.isShown()', function () {
		var ctx = this.context;
	
		if ( ctx.length && this.length ) {
			// _detailsShown as false or undefined will fall through to return false
			return ctx[0].aoData[ this[0] ]._detailsShow || false;
		}
		return false;
	} );
	
	
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Columns
	 *
	 * {integer}           - column index (>=0 count from left, <0 count from right)
	 * "{integer}:visIdx"  - visible column index (i.e. translate to column index)  (>=0 count from left, <0 count from right)
	 * "{integer}:visible" - alias for {integer}:visIdx  (>=0 count from left, <0 count from right)
	 * "{string}:name"     - column name
	 * "{string}"          - jQuery selector on column header nodes
	 *
	 */
	
	// can be an array of these items, comma separated list, or an array of comma
	// separated lists
	
	var __re_column_selector = /^([^:]+):(name|visIdx|visible)$/;
	
	
	// r1 and r2 are redundant - but it means that the parameters match for the
	// iterator callback in columns().data()
	var __columnData = function ( settings, column, r1, r2, rows ) {
		var a = [];
		for ( var row=0, ien=rows.length ; row<ien ; row++ ) {
			a.push( _fnGetCellData( settings, rows[row], column ) );
		}
		return a;
	};
	
	
	var __column_selector = function ( settings, selector, opts )
	{
		var
			columns = settings.aoColumns,
			names = _pluck( columns, 'sName' ),
			nodes = _pluck( columns, 'nTh' );
	
		var run = function ( s ) {
			var selInt = _intVal( s );
	
			// Selector - all
			if ( s === '' ) {
				return _range( columns.length );
			}
	
			// Selector - index
			if ( selInt !== null ) {
				return [ selInt >= 0 ?
					selInt : // Count from left
					columns.length + selInt // Count from right (+ because its a negative value)
				];
			}
	
			// Selector = function
			if ( typeof s === 'function' ) {
				var rows = _selector_row_indexes( settings, opts );
	
				return $.map( columns, function (col, idx) {
					return s(
							idx,
							__columnData( settings, idx, 0, 0, rows ),
							nodes[ idx ]
						) ? idx : null;
				} );
			}
	
			// jQuery or string selector
			var match = typeof s === 'string' ?
				s.match( __re_column_selector ) :
				'';
	
			if ( match ) {
				switch( match[2] ) {
					case 'visIdx':
					case 'visible':
						var idx = parseInt( match[1], 10 );
						// Visible index given, convert to column index
						if ( idx < 0 ) {
							// Counting from the right
							var visColumns = $.map( columns, function (col,i) {
								return col.bVisible ? i : null;
							} );
							return [ visColumns[ visColumns.length + idx ] ];
						}
						// Counting from the left
						return [ _fnVisibleToColumnIndex( settings, idx ) ];
	
					case 'name':
						// match by name. `names` is column index complete and in order
						return $.map( names, function (name, i) {
							return name === match[1] ? i : null;
						} );
	
					default:
						return [];
				}
			}
	
			// Cell in the table body
			if ( s.nodeName && s._DT_CellIndex ) {
				return [ s._DT_CellIndex.column ];
			}
	
			// jQuery selector on the TH elements for the columns
			var jqResult = $( nodes )
				.filter( s )
				.map( function () {
					return $.inArray( this, nodes ); // `nodes` is column index complete and in order
				} )
				.toArray();
	
			if ( jqResult.length || ! s.nodeName ) {
				return jqResult;
			}
	
			// Otherwise a node which might have a `dt-column` data attribute, or be
			// a child or such an element
			var host = $(s).closest('*[data-dt-column]');
			return host.length ?
				[ host.data('dt-column') ] :
				[];
		};
	
		return _selector_run( 'column', selector, run, settings, opts );
	};
	
	
	var __setColumnVis = function ( settings, column, vis ) {
		var
			cols = settings.aoColumns,
			col  = cols[ column ],
			data = settings.aoData,
			row, cells, i, ien, tr;
	
		// Get
		if ( vis === undefined ) {
			return col.bVisible;
		}
	
		// Set
		// No change
		if ( col.bVisible === vis ) {
			return;
		}
	
		if ( vis ) {
			// Insert column
			// Need to decide if we should use appendChild or insertBefore
			var insertBefore = $.inArray( true, _pluck(cols, 'bVisible'), column+1 );
	
			for ( i=0, ien=data.length ; i<ien ; i++ ) {
				tr = data[i].nTr;
				cells = data[i].anCells;
	
				if ( tr ) {
					// insertBefore can act like appendChild if 2nd arg is null
					tr.insertBefore( cells[ column ], cells[ insertBefore ] || null );
				}
			}
		}
		else {
			// Remove column
			$( _pluck( settings.aoData, 'anCells', column ) ).detach();
		}
	
		// Common actions
		col.bVisible = vis;
	};
	
	
	_api_register( 'columns()', function ( selector, opts ) {
		// argument shifting
		if ( selector === undefined ) {
			selector = '';
		}
		else if ( $.isPlainObject( selector ) ) {
			opts = selector;
			selector = '';
		}
	
		opts = _selector_opts( opts );
	
		var inst = this.iterator( 'table', function ( settings ) {
			return __column_selector( settings, selector, opts );
		}, 1 );
	
		// Want argument shifting here and in _row_selector?
		inst.selector.cols = selector;
		inst.selector.opts = opts;
	
		return inst;
	} );
	
	_api_registerPlural( 'columns().header()', 'column().header()', function ( selector, opts ) {
		return this.iterator( 'column', function ( settings, column ) {
			return settings.aoColumns[column].nTh;
		}, 1 );
	} );
	
	_api_registerPlural( 'columns().footer()', 'column().footer()', function ( selector, opts ) {
		return this.iterator( 'column', function ( settings, column ) {
			return settings.aoColumns[column].nTf;
		}, 1 );
	} );
	
	_api_registerPlural( 'columns().data()', 'column().data()', function () {
		return this.iterator( 'column-rows', __columnData, 1 );
	} );
	
	_api_registerPlural( 'columns().dataSrc()', 'column().dataSrc()', function () {
		return this.iterator( 'column', function ( settings, column ) {
			return settings.aoColumns[column].mData;
		}, 1 );
	} );
	
	_api_registerPlural( 'columns().cache()', 'column().cache()', function ( type ) {
		return this.iterator( 'column-rows', function ( settings, column, i, j, rows ) {
			return _pluck_order( settings.aoData, rows,
				type === 'search' ? '_aFilterData' : '_aSortData', column
			);
		}, 1 );
	} );
	
	_api_registerPlural( 'columns().nodes()', 'column().nodes()', function () {
		return this.iterator( 'column-rows', function ( settings, column, i, j, rows ) {
			return _pluck_order( settings.aoData, rows, 'anCells', column ) ;
		}, 1 );
	} );
	
	_api_registerPlural( 'columns().visible()', 'column().visible()', function ( vis, calc ) {
		var that = this;
		var ret = this.iterator( 'column', function ( settings, column ) {
			if ( vis === undefined ) {
				return settings.aoColumns[ column ].bVisible;
			} // else
			__setColumnVis( settings, column, vis );
		} );
	
		// Group the column visibility changes
		if ( vis !== undefined ) {
			this.iterator( 'table', function ( settings ) {
				// Redraw the header after changes
				_fnDrawHead( settings, settings.aoHeader );
				_fnDrawHead( settings, settings.aoFooter );
		
				// Update colspan for no records display. Child rows and extensions will use their own
				// listeners to do this - only need to update the empty table item here
				if ( ! settings.aiDisplay.length ) {
					$(settings.nTBody).find('td[colspan]').attr('colspan', _fnVisbleColumns(settings));
				}
		
				_fnSaveState( settings );
	
				// Second loop once the first is done for events
				that.iterator( 'column', function ( settings, column ) {
					_fnCallbackFire( settings, null, 'column-visibility', [settings, column, vis, calc] );
				} );
	
				if ( calc === undefined || calc ) {
					that.columns.adjust();
				}
			});
		}
	
		return ret;
	} );
	
	_api_registerPlural( 'columns().indexes()', 'column().index()', function ( type ) {
		return this.iterator( 'column', function ( settings, column ) {
			return type === 'visible' ?
				_fnColumnIndexToVisible( settings, column ) :
				column;
		}, 1 );
	} );
	
	_api_register( 'columns.adjust()', function () {
		return this.iterator( 'table', function ( settings ) {
			_fnAdjustColumnSizing( settings );
		}, 1 );
	} );
	
	_api_register( 'column.index()', function ( type, idx ) {
		if ( this.context.length !== 0 ) {
			var ctx = this.context[0];
	
			if ( type === 'fromVisible' || type === 'toData' ) {
				return _fnVisibleToColumnIndex( ctx, idx );
			}
			else if ( type === 'fromData' || type === 'toVisible' ) {
				return _fnColumnIndexToVisible( ctx, idx );
			}
		}
	} );
	
	_api_register( 'column()', function ( selector, opts ) {
		return _selector_first( this.columns( selector, opts ) );
	} );
	
	var __cell_selector = function ( settings, selector, opts )
	{
		var data = settings.aoData;
		var rows = _selector_row_indexes( settings, opts );
		var cells = _removeEmpty( _pluck_order( data, rows, 'anCells' ) );
		var allCells = $(_flatten( [], cells ));
		var row;
		var columns = settings.aoColumns.length;
		var a, i, ien, j, o, host;
	
		var run = function ( s ) {
			var fnSelector = typeof s === 'function';
	
			if ( s === null || s === undefined || fnSelector ) {
				// All cells and function selectors
				a = [];
	
				for ( i=0, ien=rows.length ; i<ien ; i++ ) {
					row = rows[i];
	
					for ( j=0 ; j<columns ; j++ ) {
						o = {
							row: row,
							column: j
						};
	
						if ( fnSelector ) {
							// Selector - function
							host = data[ row ];
	
							if ( s( o, _fnGetCellData(settings, row, j), host.anCells ? host.anCells[j] : null ) ) {
								a.push( o );
							}
						}
						else {
							// Selector - all
							a.push( o );
						}
					}
				}
	
				return a;
			}
			
			// Selector - index
			if ( $.isPlainObject( s ) ) {
				// Valid cell index and its in the array of selectable rows
				return s.column !== undefined && s.row !== undefined && $.inArray( s.row, rows ) !== -1 ?
					[s] :
					[];
			}
	
			// Selector - jQuery filtered cells
			var jqResult = allCells
				.filter( s )
				.map( function (i, el) {
					return { // use a new object, in case someone changes the values
						row:    el._DT_CellIndex.row,
						column: el._DT_CellIndex.column
	 				};
				} )
				.toArray();
	
			if ( jqResult.length || ! s.nodeName ) {
				return jqResult;
			}
	
			// Otherwise the selector is a node, and there is one last option - the
			// element might be a child of an element which has dt-row and dt-column
			// data attributes
			host = $(s).closest('*[data-dt-row]');
			return host.length ?
				[ {
					row: host.data('dt-row'),
					column: host.data('dt-column')
				} ] :
				[];
		};
	
		return _selector_run( 'cell', selector, run, settings, opts );
	};
	
	
	
	
	_api_register( 'cells()', function ( rowSelector, columnSelector, opts ) {
		// Argument shifting
		if ( $.isPlainObject( rowSelector ) ) {
			// Indexes
			if ( rowSelector.row === undefined ) {
				// Selector options in first parameter
				opts = rowSelector;
				rowSelector = null;
			}
			else {
				// Cell index objects in first parameter
				opts = columnSelector;
				columnSelector = null;
			}
		}
		if ( $.isPlainObject( columnSelector ) ) {
			opts = columnSelector;
			columnSelector = null;
		}
	
		// Cell selector
		if ( columnSelector === null || columnSelector === undefined ) {
			return this.iterator( 'table', function ( settings ) {
				return __cell_selector( settings, rowSelector, _selector_opts( opts ) );
			} );
		}
	
		// The default built in options need to apply to row and columns
		var internalOpts = opts ? {
			page: opts.page,
			order: opts.order,
			search: opts.search
		} : {};
	
		// Row + column selector
		var columns = this.columns( columnSelector, internalOpts );
		var rows = this.rows( rowSelector, internalOpts );
		var i, ien, j, jen;
	
		var cellsNoOpts = this.iterator( 'table', function ( settings, idx ) {
			var a = [];
	
			for ( i=0, ien=rows[idx].length ; i<ien ; i++ ) {
				for ( j=0, jen=columns[idx].length ; j<jen ; j++ ) {
					a.push( {
						row:    rows[idx][i],
						column: columns[idx][j]
					} );
				}
			}
	
			return a;
		}, 1 );
	
		// There is currently only one extension which uses a cell selector extension
		// It is a _major_ performance drag to run this if it isn't needed, so this is
		// an extension specific check at the moment
		var cells = opts && opts.selected ?
			this.cells( cellsNoOpts, opts ) :
			cellsNoOpts;
	
		$.extend( cells.selector, {
			cols: columnSelector,
			rows: rowSelector,
			opts: opts
		} );
	
		return cells;
	} );
	
	
	_api_registerPlural( 'cells().nodes()', 'cell().node()', function () {
		return this.iterator( 'cell', function ( settings, row, column ) {
			var data = settings.aoData[ row ];
	
			return data && data.anCells ?
				data.anCells[ column ] :
				undefined;
		}, 1 );
	} );
	
	
	_api_register( 'cells().data()', function () {
		return this.iterator( 'cell', function ( settings, row, column ) {
			return _fnGetCellData( settings, row, column );
		}, 1 );
	} );
	
	
	_api_registerPlural( 'cells().cache()', 'cell().cache()', function ( type ) {
		type = type === 'search' ? '_aFilterData' : '_aSortData';
	
		return this.iterator( 'cell', function ( settings, row, column ) {
			return settings.aoData[ row ][ type ][ column ];
		}, 1 );
	} );
	
	
	_api_registerPlural( 'cells().render()', 'cell().render()', function ( type ) {
		return this.iterator( 'cell', function ( settings, row, column ) {
			return _fnGetCellData( settings, row, column, type );
		}, 1 );
	} );
	
	
	_api_registerPlural( 'cells().indexes()', 'cell().index()', function () {
		return this.iterator( 'cell', function ( settings, row, column ) {
			return {
				row: row,
				column: column,
				columnVisible: _fnColumnIndexToVisible( settings, column )
			};
		}, 1 );
	} );
	
	
	_api_registerPlural( 'cells().invalidate()', 'cell().invalidate()', function ( src ) {
		return this.iterator( 'cell', function ( settings, row, column ) {
			_fnInvalidate( settings, row, src, column );
		} );
	} );
	
	
	
	_api_register( 'cell()', function ( rowSelector, columnSelector, opts ) {
		return _selector_first( this.cells( rowSelector, columnSelector, opts ) );
	} );
	
	
	_api_register( 'cell().data()', function ( data ) {
		var ctx = this.context;
		var cell = this[0];
	
		if ( data === undefined ) {
			// Get
			return ctx.length && cell.length ?
				_fnGetCellData( ctx[0], cell[0].row, cell[0].column ) :
				undefined;
		}
	
		// Set
		_fnSetCellData( ctx[0], cell[0].row, cell[0].column, data );
		_fnInvalidate( ctx[0], cell[0].row, 'data', cell[0].column );
	
		return this;
	} );
	
	
	
	/**
	 * Get current ordering (sorting) that has been applied to the table.
	 *
	 * @returns {array} 2D array containing the sorting information for the first
	 *   table in the current context. Each element in the parent array represents
	 *   a column being sorted upon (i.e. multi-sorting with two columns would have
	 *   2 inner arrays). The inner arrays may have 2 or 3 elements. The first is
	 *   the column index that the sorting condition applies to, the second is the
	 *   direction of the sort (`desc` or `asc`) and, optionally, the third is the
	 *   index of the sorting order from the `column.sorting` initialisation array.
	 *//**
	 * Set the ordering for the table.
	 *
	 * @param {integer} order Column index to sort upon.
	 * @param {string} direction Direction of the sort to be applied (`asc` or `desc`)
	 * @returns {DataTables.Api} this
	 *//**
	 * Set the ordering for the table.
	 *
	 * @param {array} order 1D array of sorting information to be applied.
	 * @param {array} [...] Optional additional sorting conditions
	 * @returns {DataTables.Api} this
	 *//**
	 * Set the ordering for the table.
	 *
	 * @param {array} order 2D array of sorting information to be applied.
	 * @returns {DataTables.Api} this
	 */
	_api_register( 'order()', function ( order, dir ) {
		var ctx = this.context;
	
		if ( order === undefined ) {
			// get
			return ctx.length !== 0 ?
				ctx[0].aaSorting :
				undefined;
		}
	
		// set
		if ( typeof order === 'number' ) {
			// Simple column / direction passed in
			order = [ [ order, dir ] ];
		}
		else if ( order.length && ! Array.isArray( order[0] ) ) {
			// Arguments passed in (list of 1D arrays)
			order = Array.prototype.slice.call( arguments );
		}
		// otherwise a 2D array was passed in
	
		return this.iterator( 'table', function ( settings ) {
			settings.aaSorting = order.slice();
		} );
	} );
	
	
	/**
	 * Attach a sort listener to an element for a given column
	 *
	 * @param {node|jQuery|string} node Identifier for the element(s) to attach the
	 *   listener to. This can take the form of a single DOM node, a jQuery
	 *   collection of nodes or a jQuery selector which will identify the node(s).
	 * @param {integer} column the column that a click on this node will sort on
	 * @param {function} [callback] callback function when sort is run
	 * @returns {DataTables.Api} this
	 */
	_api_register( 'order.listener()', function ( node, column, callback ) {
		return this.iterator( 'table', function ( settings ) {
			_fnSortAttachListener( settings, node, column, callback );
		} );
	} );
	
	
	_api_register( 'order.fixed()', function ( set ) {
		if ( ! set ) {
			var ctx = this.context;
			var fixed = ctx.length ?
				ctx[0].aaSortingFixed :
				undefined;
	
			return Array.isArray( fixed ) ?
				{ pre: fixed } :
				fixed;
		}
	
		return this.iterator( 'table', function ( settings ) {
			settings.aaSortingFixed = $.extend( true, {}, set );
		} );
	} );
	
	
	// Order by the selected column(s)
	_api_register( [
		'columns().order()',
		'column().order()'
	], function ( dir ) {
		var that = this;
	
		return this.iterator( 'table', function ( settings, i ) {
			var sort = [];
	
			$.each( that[i], function (j, col) {
				sort.push( [ col, dir ] );
			} );
	
			settings.aaSorting = sort;
		} );
	} );
	
	
	
	_api_register( 'search()', function ( input, regex, smart, caseInsen ) {
		var ctx = this.context;
	
		if ( input === undefined ) {
			// get
			return ctx.length !== 0 ?
				ctx[0].oPreviousSearch.sSearch :
				undefined;
		}
	
		// set
		return this.iterator( 'table', function ( settings ) {
			if ( ! settings.oFeatures.bFilter ) {
				return;
			}
	
			_fnFilterComplete( settings, $.extend( {}, settings.oPreviousSearch, {
				"sSearch": input+"",
				"bRegex":  regex === null ? false : regex,
				"bSmart":  smart === null ? true  : smart,
				"bCaseInsensitive": caseInsen === null ? true : caseInsen
			} ), 1 );
		} );
	} );
	
	
	_api_registerPlural(
		'columns().search()',
		'column().search()',
		function ( input, regex, smart, caseInsen ) {
			return this.iterator( 'column', function ( settings, column ) {
				var preSearch = settings.aoPreSearchCols;
	
				if ( input === undefined ) {
					// get
					return preSearch[ column ].sSearch;
				}
	
				// set
				if ( ! settings.oFeatures.bFilter ) {
					return;
				}
	
				$.extend( preSearch[ column ], {
					"sSearch": input+"",
					"bRegex":  regex === null ? false : regex,
					"bSmart":  smart === null ? true  : smart,
					"bCaseInsensitive": caseInsen === null ? true : caseInsen
				} );
	
				_fnFilterComplete( settings, settings.oPreviousSearch, 1 );
			} );
		}
	);
	
	/*
	 * State API methods
	 */
	
	_api_register( 'state()', function () {
		return this.context.length ?
			this.context[0].oSavedState :
			null;
	} );
	
	
	_api_register( 'state.clear()', function () {
		return this.iterator( 'table', function ( settings ) {
			// Save an empty object
			settings.fnStateSaveCallback.call( settings.oInstance, settings, {} );
		} );
	} );
	
	
	_api_register( 'state.loaded()', function () {
		return this.context.length ?
			this.context[0].oLoadedState :
			null;
	} );
	
	
	_api_register( 'state.save()', function () {
		return this.iterator( 'table', function ( settings ) {
			_fnSaveState( settings );
		} );
	} );
	
	
	
	/**
	 * Set the jQuery or window object to be used by DataTables
	 *
	 * @param {*} module Library / container object
	 * @param {string} [type] Library or container type `lib`, `win` or `datetime`.
	 *   If not provided, automatic detection is attempted.
	 */
	DataTable.use = function (module, type) {
		if (type === 'lib' || module.fn) {
			$ = module;
		}
		else if (type == 'win' || module.document) {
			window = module;
			document = module.document;
		}
		else if (type === 'datetime' || module.type === 'DateTime') {
			DataTable.DateTime = module;
		}
	}
	
	/**
	 * CommonJS factory function pass through. This will check if the arguments
	 * given are a window object or a jQuery object. If so they are set
	 * accordingly.
	 * @param {*} root Window
	 * @param {*} jq jQUery
	 * @returns {boolean} Indicator
	 */
	DataTable.factory = function (root, jq) {
		var is = false;
	
		// Test if the first parameter is a window object
		if (root && root.document) {
			window = root;
			document = root.document;
		}
	
		// Test if the second parameter is a jQuery object
		if (jq && jq.fn && jq.fn.jquery) {
			$ = jq;
			is = true;
		}
	
		return is;
	}
	
	/**
	 * Provide a common method for plug-ins to check the version of DataTables being
	 * used, in order to ensure compatibility.
	 *
	 *  @param {string} version Version string to check for, in the format "X.Y.Z".
	 *    Note that the formats "X" and "X.Y" are also acceptable.
	 *  @returns {boolean} true if this version of DataTables is greater or equal to
	 *    the required version, or false if this version of DataTales is not
	 *    suitable
	 *  @static
	 *  @dtopt API-Static
	 *
	 *  @example
	 *    alert( $.fn.dataTable.versionCheck( '1.9.0' ) );
	 */
	DataTable.versionCheck = DataTable.fnVersionCheck = function( version )
	{
		var aThis = DataTable.version.split('.');
		var aThat = version.split('.');
		var iThis, iThat;
	
		for ( var i=0, iLen=aThat.length ; i<iLen ; i++ ) {
			iThis = parseInt( aThis[i], 10 ) || 0;
			iThat = parseInt( aThat[i], 10 ) || 0;
	
			// Parts are the same, keep comparing
			if (iThis === iThat) {
				continue;
			}
	
			// Parts are different, return immediately
			return iThis > iThat;
		}
	
		return true;
	};
	
	
	/**
	 * Check if a `<table>` node is a DataTable table already or not.
	 *
	 *  @param {node|jquery|string} table Table node, jQuery object or jQuery
	 *      selector for the table to test. Note that if more than more than one
	 *      table is passed on, only the first will be checked
	 *  @returns {boolean} true the table given is a DataTable, or false otherwise
	 *  @static
	 *  @dtopt API-Static
	 *
	 *  @example
	 *    if ( ! $.fn.DataTable.isDataTable( '#example' ) ) {
	 *      $('#example').dataTable();
	 *    }
	 */
	DataTable.isDataTable = DataTable.fnIsDataTable = function ( table )
	{
		var t = $(table).get(0);
		var is = false;
	
		if ( table instanceof DataTable.Api ) {
			return true;
		}
	
		$.each( DataTable.settings, function (i, o) {
			var head = o.nScrollHead ? $('table', o.nScrollHead)[0] : null;
			var foot = o.nScrollFoot ? $('table', o.nScrollFoot)[0] : null;
	
			if ( o.nTable === t || head === t || foot === t ) {
				is = true;
			}
		} );
	
		return is;
	};
	
	
	/**
	 * Get all DataTable tables that have been initialised - optionally you can
	 * select to get only currently visible tables.
	 *
	 *  @param {boolean} [visible=false] Flag to indicate if you want all (default)
	 *    or visible tables only.
	 *  @returns {array} Array of `table` nodes (not DataTable instances) which are
	 *    DataTables
	 *  @static
	 *  @dtopt API-Static
	 *
	 *  @example
	 *    $.each( $.fn.dataTable.tables(true), function () {
	 *      $(table).DataTable().columns.adjust();
	 *    } );
	 */
	DataTable.tables = DataTable.fnTables = function ( visible )
	{
		var api = false;
	
		if ( $.isPlainObject( visible ) ) {
			api = visible.api;
			visible = visible.visible;
		}
	
		var a = $.map( DataTable.settings, function (o) {
			if ( !visible || (visible && $(o.nTable).is(':visible')) ) {
				return o.nTable;
			}
		} );
	
		return api ?
			new _Api( a ) :
			a;
	};
	
	
	/**
	 * Convert from camel case parameters to Hungarian notation. This is made public
	 * for the extensions to provide the same ability as DataTables core to accept
	 * either the 1.9 style Hungarian notation, or the 1.10+ style camelCase
	 * parameters.
	 *
	 *  @param {object} src The model object which holds all parameters that can be
	 *    mapped.
	 *  @param {object} user The object to convert from camel case to Hungarian.
	 *  @param {boolean} force When set to `true`, properties which already have a
	 *    Hungarian value in the `user` object will be overwritten. Otherwise they
	 *    won't be.
	 */
	DataTable.camelToHungarian = _fnCamelToHungarian;
	
	
	
	/**
	 *
	 */
	_api_register( '$()', function ( selector, opts ) {
		var
			rows   = this.rows( opts ).nodes(), // Get all rows
			jqRows = $(rows);
	
		return $( [].concat(
			jqRows.filter( selector ).toArray(),
			jqRows.find( selector ).toArray()
		) );
	} );
	
	
	// jQuery functions to operate on the tables
	$.each( [ 'on', 'one', 'off' ], function (i, key) {
		_api_register( key+'()', function ( /* event, handler */ ) {
			var args = Array.prototype.slice.call(arguments);
	
			// Add the `dt` namespace automatically if it isn't already present
			args[0] = $.map( args[0].split( /\s/ ), function ( e ) {
				return ! e.match(/\.dt\b/) ?
					e+'.dt' :
					e;
				} ).join( ' ' );
	
			var inst = $( this.tables().nodes() );
			inst[key].apply( inst, args );
			return this;
		} );
	} );
	
	
	_api_register( 'clear()', function () {
		return this.iterator( 'table', function ( settings ) {
			_fnClearTable( settings );
		} );
	} );
	
	
	_api_register( 'settings()', function () {
		return new _Api( this.context, this.context );
	} );
	
	
	_api_register( 'init()', function () {
		var ctx = this.context;
		return ctx.length ? ctx[0].oInit : null;
	} );
	
	
	_api_register( 'data()', function () {
		return this.iterator( 'table', function ( settings ) {
			return _pluck( settings.aoData, '_aData' );
		} ).flatten();
	} );
	
	
	_api_register( 'destroy()', function ( remove ) {
		remove = remove || false;
	
		return this.iterator( 'table', function ( settings ) {
			var classes   = settings.oClasses;
			var table     = settings.nTable;
			var tbody     = settings.nTBody;
			var thead     = settings.nTHead;
			var tfoot     = settings.nTFoot;
			var jqTable   = $(table);
			var jqTbody   = $(tbody);
			var jqWrapper = $(settings.nTableWrapper);
			var rows      = $.map( settings.aoData, function (r) { return r.nTr; } );
			var i, ien;
	
			// Flag to note that the table is currently being destroyed - no action
			// should be taken
			settings.bDestroying = true;
	
			// Fire off the destroy callbacks for plug-ins etc
			_fnCallbackFire( settings, "aoDestroyCallback", "destroy", [settings] );
	
			// If not being removed from the document, make all columns visible
			if ( ! remove ) {
				new _Api( settings ).columns().visible( true );
			}
	
			// Blitz all `DT` namespaced events (these are internal events, the
			// lowercase, `dt` events are user subscribed and they are responsible
			// for removing them
			jqWrapper.off('.DT').find(':not(tbody *)').off('.DT');
			$(window).off('.DT-'+settings.sInstance);
	
			// When scrolling we had to break the table up - restore it
			if ( table != thead.parentNode ) {
				jqTable.children('thead').detach();
				jqTable.append( thead );
			}
	
			if ( tfoot && table != tfoot.parentNode ) {
				jqTable.children('tfoot').detach();
				jqTable.append( tfoot );
			}
	
			settings.aaSorting = [];
			settings.aaSortingFixed = [];
			_fnSortingClasses( settings );
	
			$( rows ).removeClass( settings.asStripeClasses.join(' ') );
	
			$('th, td', thead).removeClass( classes.sSortable+' '+
				classes.sSortableAsc+' '+classes.sSortableDesc+' '+classes.sSortableNone
			);
	
			// Add the TR elements back into the table in their original order
			jqTbody.children().detach();
			jqTbody.append( rows );
	
			var orig = settings.nTableWrapper.parentNode;
	
			// Remove the DataTables generated nodes, events and classes
			var removedMethod = remove ? 'remove' : 'detach';
			jqTable[ removedMethod ]();
			jqWrapper[ removedMethod ]();
	
			// If we need to reattach the table to the document
			if ( ! remove && orig ) {
				// insertBefore acts like appendChild if !arg[1]
				orig.insertBefore( table, settings.nTableReinsertBefore );
	
				// Restore the width of the original table - was read from the style property,
				// so we can restore directly to that
				jqTable
					.css( 'width', settings.sDestroyWidth )
					.removeClass( classes.sTable );
	
				// If the were originally stripe classes - then we add them back here.
				// Note this is not fool proof (for example if not all rows had stripe
				// classes - but it's a good effort without getting carried away
				ien = settings.asDestroyStripes.length;
	
				if ( ien ) {
					jqTbody.children().each( function (i) {
						$(this).addClass( settings.asDestroyStripes[i % ien] );
					} );
				}
			}
	
			/* Remove the settings object from the settings array */
			var idx = $.inArray( settings, DataTable.settings );
			if ( idx !== -1 ) {
				DataTable.settings.splice( idx, 1 );
			}
		} );
	} );
	
	
	// Add the `every()` method for rows, columns and cells in a compact form
	$.each( [ 'column', 'row', 'cell' ], function ( i, type ) {
		_api_register( type+'s().every()', function ( fn ) {
			var opts = this.selector.opts;
			var api = this;
	
			return this.iterator( type, function ( settings, arg1, arg2, arg3, arg4 ) {
				// Rows and columns:
				//  arg1 - index
				//  arg2 - table counter
				//  arg3 - loop counter
				//  arg4 - undefined
				// Cells:
				//  arg1 - row index
				//  arg2 - column index
				//  arg3 - table counter
				//  arg4 - loop counter
				fn.call(
					api[ type ](
						arg1,
						type==='cell' ? arg2 : opts,
						type==='cell' ? opts : undefined
					),
					arg1, arg2, arg3, arg4
				);
			} );
		} );
	} );
	
	
	// i18n method for extensions to be able to use the language object from the
	// DataTable
	_api_register( 'i18n()', function ( token, def, plural ) {
		var ctx = this.context[0];
		var resolved = _fnGetObjectDataFn( token )( ctx.oLanguage );
	
		if ( resolved === undefined ) {
			resolved = def;
		}
	
		if ( plural !== undefined && $.isPlainObject( resolved ) ) {
			resolved = resolved[ plural ] !== undefined ?
				resolved[ plural ] :
				resolved._;
		}
	
		return typeof resolved === 'string'
			? resolved.replace( '%d', plural ) // nb: plural might be undefined,
			: resolved;
	} );	
	/**
	 * Version string for plug-ins to check compatibility. Allowed format is
	 * `a.b.c-d` where: a:int, b:int, c:int, d:string(dev|beta|alpha). `d` is used
	 * only for non-release builds. See https://semver.org/ for more information.
	 *  @member
	 *  @type string
	 *  @default Version number
	 */
	DataTable.version = "1.13.11";
	
	/**
	 * Private data store, containing all of the settings objects that are
	 * created for the tables on a given page.
	 *
	 * Note that the `DataTable.settings` object is aliased to
	 * `jQuery.fn.dataTableExt` through which it may be accessed and
	 * manipulated, or `jQuery.fn.dataTable.settings`.
	 *  @member
	 *  @type array
	 *  @default []
	 *  @private
	 */
	DataTable.settings = [];
	
	/**
	 * Object models container, for the various models that DataTables has
	 * available to it. These models define the objects that are used to hold
	 * the active state and configuration of the table.
	 *  @namespace
	 */
	DataTable.models = {};
	
	
	
	/**
	 * Template object for the way in which DataTables holds information about
	 * search information for the global filter and individual column filters.
	 *  @namespace
	 */
	DataTable.models.oSearch = {
		/**
		 * Flag to indicate if the filtering should be case insensitive or not
		 *  @type boolean
		 *  @default true
		 */
		"bCaseInsensitive": true,
	
		/**
		 * Applied search term
		 *  @type string
		 *  @default <i>Empty string</i>
		 */
		"sSearch": "",
	
		/**
		 * Flag to indicate if the search term should be interpreted as a
		 * regular expression (true) or not (false) and therefore and special
		 * regex characters escaped.
		 *  @type boolean
		 *  @default false
		 */
		"bRegex": false,
	
		/**
		 * Flag to indicate if DataTables is to use its smart filtering or not.
		 *  @type boolean
		 *  @default true
		 */
		"bSmart": true,
	
		/**
		 * Flag to indicate if DataTables should only trigger a search when
		 * the return key is pressed.
		 *  @type boolean
		 *  @default false
		 */
		"return": false
	};
	
	
	
	
	/**
	 * Template object for the way in which DataTables holds information about
	 * each individual row. This is the object format used for the settings
	 * aoData array.
	 *  @namespace
	 */
	DataTable.models.oRow = {
		/**
		 * TR element for the row
		 *  @type node
		 *  @default null
		 */
		"nTr": null,
	
		/**
		 * Array of TD elements for each row. This is null until the row has been
		 * created.
		 *  @type array nodes
		 *  @default []
		 */
		"anCells": null,
	
		/**
		 * Data object from the original data source for the row. This is either
		 * an array if using the traditional form of DataTables, or an object if
		 * using mData options. The exact type will depend on the passed in
		 * data from the data source, or will be an array if using DOM a data
		 * source.
		 *  @type array|object
		 *  @default []
		 */
		"_aData": [],
	
		/**
		 * Sorting data cache - this array is ostensibly the same length as the
		 * number of columns (although each index is generated only as it is
		 * needed), and holds the data that is used for sorting each column in the
		 * row. We do this cache generation at the start of the sort in order that
		 * the formatting of the sort data need be done only once for each cell
		 * per sort. This array should not be read from or written to by anything
		 * other than the master sorting methods.
		 *  @type array
		 *  @default null
		 *  @private
		 */
		"_aSortData": null,
	
		/**
		 * Per cell filtering data cache. As per the sort data cache, used to
		 * increase the performance of the filtering in DataTables
		 *  @type array
		 *  @default null
		 *  @private
		 */
		"_aFilterData": null,
	
		/**
		 * Filtering data cache. This is the same as the cell filtering cache, but
		 * in this case a string rather than an array. This is easily computed with
		 * a join on `_aFilterData`, but is provided as a cache so the join isn't
		 * needed on every search (memory traded for performance)
		 *  @type array
		 *  @default null
		 *  @private
		 */
		"_sFilterRow": null,
	
		/**
		 * Cache of the class name that DataTables has applied to the row, so we
		 * can quickly look at this variable rather than needing to do a DOM check
		 * on className for the nTr property.
		 *  @type string
		 *  @default <i>Empty string</i>
		 *  @private
		 */
		"_sRowStripe": "",
	
		/**
		 * Denote if the original data source was from the DOM, or the data source
		 * object. This is used for invalidating data, so DataTables can
		 * automatically read data from the original source, unless uninstructed
		 * otherwise.
		 *  @type string
		 *  @default null
		 *  @private
		 */
		"src": null,
	
		/**
		 * Index in the aoData array. This saves an indexOf lookup when we have the
		 * object, but want to know the index
		 *  @type integer
		 *  @default -1
		 *  @private
		 */
		"idx": -1
	};
	
	
	/**
	 * Template object for the column information object in DataTables. This object
	 * is held in the settings aoColumns array and contains all the information that
	 * DataTables needs about each individual column.
	 *
	 * Note that this object is related to {@link DataTable.defaults.column}
	 * but this one is the internal data store for DataTables's cache of columns.
	 * It should NOT be manipulated outside of DataTables. Any configuration should
	 * be done through the initialisation options.
	 *  @namespace
	 */
	DataTable.models.oColumn = {
		/**
		 * Column index. This could be worked out on-the-fly with $.inArray, but it
		 * is faster to just hold it as a variable
		 *  @type integer
		 *  @default null
		 */
		"idx": null,
	
		/**
		 * A list of the columns that sorting should occur on when this column
		 * is sorted. That this property is an array allows multi-column sorting
		 * to be defined for a column (for example first name / last name columns
		 * would benefit from this). The values are integers pointing to the
		 * columns to be sorted on (typically it will be a single integer pointing
		 * at itself, but that doesn't need to be the case).
		 *  @type array
		 */
		"aDataSort": null,
	
		/**
		 * Define the sorting directions that are applied to the column, in sequence
		 * as the column is repeatedly sorted upon - i.e. the first value is used
		 * as the sorting direction when the column if first sorted (clicked on).
		 * Sort it again (click again) and it will move on to the next index.
		 * Repeat until loop.
		 *  @type array
		 */
		"asSorting": null,
	
		/**
		 * Flag to indicate if the column is searchable, and thus should be included
		 * in the filtering or not.
		 *  @type boolean
		 */
		"bSearchable": null,
	
		/**
		 * Flag to indicate if the column is sortable or not.
		 *  @type boolean
		 */
		"bSortable": null,
	
		/**
		 * Flag to indicate if the column is currently visible in the table or not
		 *  @type boolean
		 */
		"bVisible": null,
	
		/**
		 * Store for manual type assignment using the `column.type` option. This
		 * is held in store so we can manipulate the column's `sType` property.
		 *  @type string
		 *  @default null
		 *  @private
		 */
		"_sManualType": null,
	
		/**
		 * Flag to indicate if HTML5 data attributes should be used as the data
		 * source for filtering or sorting. True is either are.
		 *  @type boolean
		 *  @default false
		 *  @private
		 */
		"_bAttrSrc": false,
	
		/**
		 * Developer definable function that is called whenever a cell is created (Ajax source,
		 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
		 * allowing you to modify the DOM element (add background colour for example) when the
		 * element is available.
		 *  @type function
		 *  @param {element} nTd The TD node that has been created
		 *  @param {*} sData The Data for the cell
		 *  @param {array|object} oData The data for the whole row
		 *  @param {int} iRow The row index for the aoData data store
		 *  @default null
		 */
		"fnCreatedCell": null,
	
		/**
		 * Function to get data from a cell in a column. You should <b>never</b>
		 * access data directly through _aData internally in DataTables - always use
		 * the method attached to this property. It allows mData to function as
		 * required. This function is automatically assigned by the column
		 * initialisation method
		 *  @type function
		 *  @param {array|object} oData The data array/object for the array
		 *    (i.e. aoData[]._aData)
		 *  @param {string} sSpecific The specific data type you want to get -
		 *    'display', 'type' 'filter' 'sort'
		 *  @returns {*} The data for the cell from the given row's data
		 *  @default null
		 */
		"fnGetData": null,
	
		/**
		 * Function to set data for a cell in the column. You should <b>never</b>
		 * set the data directly to _aData internally in DataTables - always use
		 * this method. It allows mData to function as required. This function
		 * is automatically assigned by the column initialisation method
		 *  @type function
		 *  @param {array|object} oData The data array/object for the array
		 *    (i.e. aoData[]._aData)
		 *  @param {*} sValue Value to set
		 *  @default null
		 */
		"fnSetData": null,
	
		/**
		 * Property to read the value for the cells in the column from the data
		 * source array / object. If null, then the default content is used, if a
		 * function is given then the return from the function is used.
		 *  @type function|int|string|null
		 *  @default null
		 */
		"mData": null,
	
		/**
		 * Partner property to mData which is used (only when defined) to get
		 * the data - i.e. it is basically the same as mData, but without the
		 * 'set' option, and also the data fed to it is the result from mData.
		 * This is the rendering method to match the data method of mData.
		 *  @type function|int|string|null
		 *  @default null
		 */
		"mRender": null,
	
		/**
		 * Unique header TH/TD element for this column - this is what the sorting
		 * listener is attached to (if sorting is enabled.)
		 *  @type node
		 *  @default null
		 */
		"nTh": null,
	
		/**
		 * Unique footer TH/TD element for this column (if there is one). Not used
		 * in DataTables as such, but can be used for plug-ins to reference the
		 * footer for each column.
		 *  @type node
		 *  @default null
		 */
		"nTf": null,
	
		/**
		 * The class to apply to all TD elements in the table's TBODY for the column
		 *  @type string
		 *  @default null
		 */
		"sClass": null,
	
		/**
		 * When DataTables calculates the column widths to assign to each column,
		 * it finds the longest string in each column and then constructs a
		 * temporary table and reads the widths from that. The problem with this
		 * is that "mmm" is much wider then "iiii", but the latter is a longer
		 * string - thus the calculation can go wrong (doing it properly and putting
		 * it into an DOM object and measuring that is horribly(!) slow). Thus as
		 * a "work around" we provide this option. It will append its value to the
		 * text that is found to be the longest string for the column - i.e. padding.
		 *  @type string
		 */
		"sContentPadding": null,
	
		/**
		 * Allows a default value to be given for a column's data, and will be used
		 * whenever a null data source is encountered (this can be because mData
		 * is set to null, or because the data source itself is null).
		 *  @type string
		 *  @default null
		 */
		"sDefaultContent": null,
	
		/**
		 * Name for the column, allowing reference to the column by name as well as
		 * by index (needs a lookup to work by name).
		 *  @type string
		 */
		"sName": null,
	
		/**
		 * Custom sorting data type - defines which of the available plug-ins in
		 * afnSortData the custom sorting will use - if any is defined.
		 *  @type string
		 *  @default std
		 */
		"sSortDataType": 'std',
	
		/**
		 * Class to be applied to the header element when sorting on this column
		 *  @type string
		 *  @default null
		 */
		"sSortingClass": null,
	
		/**
		 * Class to be applied to the header element when sorting on this column -
		 * when jQuery UI theming is used.
		 *  @type string
		 *  @default null
		 */
		"sSortingClassJUI": null,
	
		/**
		 * Title of the column - what is seen in the TH element (nTh).
		 *  @type string
		 */
		"sTitle": null,
	
		/**
		 * Column sorting and filtering type
		 *  @type string
		 *  @default null
		 */
		"sType": null,
	
		/**
		 * Width of the column
		 *  @type string
		 *  @default null
		 */
		"sWidth": null,
	
		/**
		 * Width of the column when it was first "encountered"
		 *  @type string
		 *  @default null
		 */
		"sWidthOrig": null
	};
	
	
	/*
	 * Developer note: The properties of the object below are given in Hungarian
	 * notation, that was used as the interface for DataTables prior to v1.10, however
	 * from v1.10 onwards the primary interface is camel case. In order to avoid
	 * breaking backwards compatibility utterly with this change, the Hungarian
	 * version is still, internally the primary interface, but is is not documented
	 * - hence the @name tags in each doc comment. This allows a Javascript function
	 * to create a map from Hungarian notation to camel case (going the other direction
	 * would require each property to be listed, which would add around 3K to the size
	 * of DataTables, while this method is about a 0.5K hit).
	 *
	 * Ultimately this does pave the way for Hungarian notation to be dropped
	 * completely, but that is a massive amount of work and will break current
	 * installs (therefore is on-hold until v2).
	 */
	
	/**
	 * Initialisation options that can be given to DataTables at initialisation
	 * time.
	 *  @namespace
	 */
	DataTable.defaults = {
		/**
		 * An array of data to use for the table, passed in at initialisation which
		 * will be used in preference to any data which is already in the DOM. This is
		 * particularly useful for constructing tables purely in Javascript, for
		 * example with a custom Ajax call.
		 *  @type array
		 *  @default null
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.data
		 *
		 *  @example
		 *    // Using a 2D array data source
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "data": [
		 *          ['Trident', 'Internet Explorer 4.0', 'Win 95+', 4, 'X'],
		 *          ['Trident', 'Internet Explorer 5.0', 'Win 95+', 5, 'C'],
		 *        ],
		 *        "columns": [
		 *          { "title": "Engine" },
		 *          { "title": "Browser" },
		 *          { "title": "Platform" },
		 *          { "title": "Version" },
		 *          { "title": "Grade" }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using an array of objects as a data source (`data`)
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "data": [
		 *          {
		 *            "engine":   "Trident",
		 *            "browser":  "Internet Explorer 4.0",
		 *            "platform": "Win 95+",
		 *            "version":  4,
		 *            "grade":    "X"
		 *          },
		 *          {
		 *            "engine":   "Trident",
		 *            "browser":  "Internet Explorer 5.0",
		 *            "platform": "Win 95+",
		 *            "version":  5,
		 *            "grade":    "C"
		 *          }
		 *        ],
		 *        "columns": [
		 *          { "title": "Engine",   "data": "engine" },
		 *          { "title": "Browser",  "data": "browser" },
		 *          { "title": "Platform", "data": "platform" },
		 *          { "title": "Version",  "data": "version" },
		 *          { "title": "Grade",    "data": "grade" }
		 *        ]
		 *      } );
		 *    } );
		 */
		"aaData": null,
	
	
		/**
		 * If ordering is enabled, then DataTables will perform a first pass sort on
		 * initialisation. You can define which column(s) the sort is performed
		 * upon, and the sorting direction, with this variable. The `sorting` array
		 * should contain an array for each column to be sorted initially containing
		 * the column's index and a direction string ('asc' or 'desc').
		 *  @type array
		 *  @default [[0,'asc']]
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.order
		 *
		 *  @example
		 *    // Sort by 3rd column first, and then 4th column
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "order": [[2,'asc'], [3,'desc']]
		 *      } );
		 *    } );
		 *
		 *    // No initial sorting
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "order": []
		 *      } );
		 *    } );
		 */
		"aaSorting": [[0,'asc']],
	
	
		/**
		 * This parameter is basically identical to the `sorting` parameter, but
		 * cannot be overridden by user interaction with the table. What this means
		 * is that you could have a column (visible or hidden) which the sorting
		 * will always be forced on first - any sorting after that (from the user)
		 * will then be performed as required. This can be useful for grouping rows
		 * together.
		 *  @type array
		 *  @default null
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.orderFixed
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "orderFixed": [[0,'asc']]
		 *      } );
		 *    } )
		 */
		"aaSortingFixed": [],
	
	
		/**
		 * DataTables can be instructed to load data to display in the table from a
		 * Ajax source. This option defines how that Ajax call is made and where to.
		 *
		 * The `ajax` property has three different modes of operation, depending on
		 * how it is defined. These are:
		 *
		 * * `string` - Set the URL from where the data should be loaded from.
		 * * `object` - Define properties for `jQuery.ajax`.
		 * * `function` - Custom data get function
		 *
		 * `string`
		 * --------
		 *
		 * As a string, the `ajax` property simply defines the URL from which
		 * DataTables will load data.
		 *
		 * `object`
		 * --------
		 *
		 * As an object, the parameters in the object are passed to
		 * [jQuery.ajax](https://api.jquery.com/jQuery.ajax/) allowing fine control
		 * of the Ajax request. DataTables has a number of default parameters which
		 * you can override using this option. Please refer to the jQuery
		 * documentation for a full description of the options available, although
		 * the following parameters provide additional options in DataTables or
		 * require special consideration:
		 *
		 * * `data` - As with jQuery, `data` can be provided as an object, but it
		 *   can also be used as a function to manipulate the data DataTables sends
		 *   to the server. The function takes a single parameter, an object of
		 *   parameters with the values that DataTables has readied for sending. An
		 *   object may be returned which will be merged into the DataTables
		 *   defaults, or you can add the items to the object that was passed in and
		 *   not return anything from the function. This supersedes `fnServerParams`
		 *   from DataTables 1.9-.
		 *
		 * * `dataSrc` - By default DataTables will look for the property `data` (or
		 *   `aaData` for compatibility with DataTables 1.9-) when obtaining data
		 *   from an Ajax source or for server-side processing - this parameter
		 *   allows that property to be changed. You can use Javascript dotted
		 *   object notation to get a data source for multiple levels of nesting, or
		 *   it my be used as a function. As a function it takes a single parameter,
		 *   the JSON returned from the server, which can be manipulated as
		 *   required, with the returned value being that used by DataTables as the
		 *   data source for the table. This supersedes `sAjaxDataProp` from
		 *   DataTables 1.9-.
		 *
		 * * `success` - Should not be overridden it is used internally in
		 *   DataTables. To manipulate / transform the data returned by the server
		 *   use `ajax.dataSrc`, or use `ajax` as a function (see below).
		 *
		 * `function`
		 * ----------
		 *
		 * As a function, making the Ajax call is left up to yourself allowing
		 * complete control of the Ajax request. Indeed, if desired, a method other
		 * than Ajax could be used to obtain the required data, such as Web storage
		 * or an AIR database.
		 *
		 * The function is given four parameters and no return is required. The
		 * parameters are:
		 *
		 * 1. _object_ - Data to send to the server
		 * 2. _function_ - Callback function that must be executed when the required
		 *    data has been obtained. That data should be passed into the callback
		 *    as the only parameter
		 * 3. _object_ - DataTables settings object for the table
		 *
		 * Note that this supersedes `fnServerData` from DataTables 1.9-.
		 *
		 *  @type string|object|function
		 *  @default null
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.ajax
		 *  @since 1.10.0
		 *
		 * @example
		 *   // Get JSON data from a file via Ajax.
		 *   // Note DataTables expects data in the form `{ data: [ ...data... ] }` by default).
		 *   $('#example').dataTable( {
		 *     "ajax": "data.json"
		 *   } );
		 *
		 * @example
		 *   // Get JSON data from a file via Ajax, using `dataSrc` to change
		 *   // `data` to `tableData` (i.e. `{ tableData: [ ...data... ] }`)
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "dataSrc": "tableData"
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Get JSON data from a file via Ajax, using `dataSrc` to read data
		 *   // from a plain array rather than an array in an object
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "dataSrc": ""
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Manipulate the data returned from the server - add a link to data
		 *   // (note this can, should, be done using `render` for the column - this
		 *   // is just a simple example of how the data can be manipulated).
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "dataSrc": function ( json ) {
		 *         for ( var i=0, ien=json.length ; i<ien ; i++ ) {
		 *           json[i][0] = '<a href="/message/'+json[i][0]+'>View message</a>';
		 *         }
		 *         return json;
		 *       }
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Add data to the request
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "data": function ( d ) {
		 *         return {
		 *           "extra_search": $('#extra').val()
		 *         };
		 *       }
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Send request as POST
		 *   $('#example').dataTable( {
		 *     "ajax": {
		 *       "url": "data.json",
		 *       "type": "POST"
		 *     }
		 *   } );
		 *
		 * @example
		 *   // Get the data from localStorage (could interface with a form for
		 *   // adding, editing and removing rows).
		 *   $('#example').dataTable( {
		 *     "ajax": function (data, callback, settings) {
		 *       callback(
		 *         JSON.parse( localStorage.getItem('dataTablesData') )
		 *       );
		 *     }
		 *   } );
		 */
		"ajax": null,
	
	
		/**
		 * This parameter allows you to readily specify the entries in the length drop
		 * down menu that DataTables shows when pagination is enabled. It can be
		 * either a 1D array of options which will be used for both the displayed
		 * option and the value, or a 2D array which will use the array in the first
		 * position as the value, and the array in the second position as the
		 * displayed options (useful for language strings such as 'All').
		 *
		 * Note that the `pageLength` property will be automatically set to the
		 * first value given in this array, unless `pageLength` is also provided.
		 *  @type array
		 *  @default [ 10, 25, 50, 100 ]
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.lengthMenu
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]]
		 *      } );
		 *    } );
		 */
		"aLengthMenu": [ 10, 25, 50, 100 ],
	
	
		/**
		 * The `columns` option in the initialisation parameter allows you to define
		 * details about the way individual columns behave. For a full list of
		 * column options that can be set, please see
		 * {@link DataTable.defaults.column}. Note that if you use `columns` to
		 * define your columns, you must have an entry in the array for every single
		 * column that you have in your table (these can be null if you don't which
		 * to specify any options).
		 *  @member
		 *
		 *  @name DataTable.defaults.column
		 */
		"aoColumns": null,
	
		/**
		 * Very similar to `columns`, `columnDefs` allows you to target a specific
		 * column, multiple columns, or all columns, using the `targets` property of
		 * each object in the array. This allows great flexibility when creating
		 * tables, as the `columnDefs` arrays can be of any length, targeting the
		 * columns you specifically want. `columnDefs` may use any of the column
		 * options available: {@link DataTable.defaults.column}, but it _must_
		 * have `targets` defined in each object in the array. Values in the `targets`
		 * array may be:
		 *   <ul>
		 *     <li>a string - class name will be matched on the TH for the column</li>
		 *     <li>0 or a positive integer - column index counting from the left</li>
		 *     <li>a negative integer - column index counting from the right</li>
		 *     <li>the string "_all" - all columns (i.e. assign a default)</li>
		 *   </ul>
		 *  @member
		 *
		 *  @name DataTable.defaults.columnDefs
		 */
		"aoColumnDefs": null,
	
	
		/**
		 * Basically the same as `search`, this parameter defines the individual column
		 * filtering state at initialisation time. The array must be of the same size
		 * as the number of columns, and each element be an object with the parameters
		 * `search` and `escapeRegex` (the latter is optional). 'null' is also
		 * accepted and the default will be used.
		 *  @type array
		 *  @default []
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.searchCols
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "searchCols": [
		 *          null,
		 *          { "search": "My filter" },
		 *          null,
		 *          { "search": "^[0-9]", "escapeRegex": false }
		 *        ]
		 *      } );
		 *    } )
		 */
		"aoSearchCols": [],
	
	
		/**
		 * An array of CSS classes that should be applied to displayed rows. This
		 * array may be of any length, and DataTables will apply each class
		 * sequentially, looping when required.
		 *  @type array
		 *  @default null <i>Will take the values determined by the `oClasses.stripe*`
		 *    options</i>
		 *
		 *  @dtopt Option
		 *  @name DataTable.defaults.stripeClasses
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stripeClasses": [ 'strip1', 'strip2', 'strip3' ]
		 *      } );
		 *    } )
		 */
		"asStripeClasses": null,
	
	
		/**
		 * Enable or disable automatic column width calculation. This can be disabled
		 * as an optimisation (it takes some time to calculate the widths) if the
		 * tables widths are passed in using `columns`.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.autoWidth
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "autoWidth": false
		 *      } );
		 *    } );
		 */
		"bAutoWidth": true,
	
	
		/**
		 * Deferred rendering can provide DataTables with a huge speed boost when you
		 * are using an Ajax or JS data source for the table. This option, when set to
		 * true, will cause DataTables to defer the creation of the table elements for
		 * each row until they are needed for a draw - saving a significant amount of
		 * time.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.deferRender
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "ajax": "sources/arrays.txt",
		 *        "deferRender": true
		 *      } );
		 *    } );
		 */
		"bDeferRender": false,
	
	
		/**
		 * Replace a DataTable which matches the given selector and replace it with
		 * one which has the properties of the new initialisation object passed. If no
		 * table matches the selector, then the new DataTable will be constructed as
		 * per normal.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.destroy
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "srollY": "200px",
		 *        "paginate": false
		 *      } );
		 *
		 *      // Some time later....
		 *      $('#example').dataTable( {
		 *        "filter": false,
		 *        "destroy": true
		 *      } );
		 *    } );
		 */
		"bDestroy": false,
	
	
		/**
		 * Enable or disable filtering of data. Filtering in DataTables is "smart" in
		 * that it allows the end user to input multiple words (space separated) and
		 * will match a row containing those words, even if not in the order that was
		 * specified (this allow matching across multiple columns). Note that if you
		 * wish to use filtering in DataTables this must remain 'true' - to remove the
		 * default filtering input box and retain filtering abilities, please use
		 * {@link DataTable.defaults.dom}.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.searching
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "searching": false
		 *      } );
		 *    } );
		 */
		"bFilter": true,
	
	
		/**
		 * Enable or disable the table information display. This shows information
		 * about the data that is currently visible on the page, including information
		 * about filtered data if that action is being performed.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.info
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "info": false
		 *      } );
		 *    } );
		 */
		"bInfo": true,
	
	
		/**
		 * Allows the end user to select the size of a formatted page from a select
		 * menu (sizes are 10, 25, 50 and 100). Requires pagination (`paginate`).
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.lengthChange
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "lengthChange": false
		 *      } );
		 *    } );
		 */
		"bLengthChange": true,
	
	
		/**
		 * Enable or disable pagination.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.paging
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "paging": false
		 *      } );
		 *    } );
		 */
		"bPaginate": true,
	
	
		/**
		 * Enable or disable the display of a 'processing' indicator when the table is
		 * being processed (e.g. a sort). This is particularly useful for tables with
		 * large amounts of data where it can take a noticeable amount of time to sort
		 * the entries.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.processing
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "processing": true
		 *      } );
		 *    } );
		 */
		"bProcessing": false,
	
	
		/**
		 * Retrieve the DataTables object for the given selector. Note that if the
		 * table has already been initialised, this parameter will cause DataTables
		 * to simply return the object that has already been set up - it will not take
		 * account of any changes you might have made to the initialisation object
		 * passed to DataTables (setting this parameter to true is an acknowledgement
		 * that you understand this). `destroy` can be used to reinitialise a table if
		 * you need.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.retrieve
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      initTable();
		 *      tableActions();
		 *    } );
		 *
		 *    function initTable ()
		 *    {
		 *      return $('#example').dataTable( {
		 *        "scrollY": "200px",
		 *        "paginate": false,
		 *        "retrieve": true
		 *      } );
		 *    }
		 *
		 *    function tableActions ()
		 *    {
		 *      var table = initTable();
		 *      // perform API operations with oTable
		 *    }
		 */
		"bRetrieve": false,
	
	
		/**
		 * When vertical (y) scrolling is enabled, DataTables will force the height of
		 * the table's viewport to the given height at all times (useful for layout).
		 * However, this can look odd when filtering data down to a small data set,
		 * and the footer is left "floating" further down. This parameter (when
		 * enabled) will cause DataTables to collapse the table's viewport down when
		 * the result set will fit within the given Y height.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.scrollCollapse
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "scrollY": "200",
		 *        "scrollCollapse": true
		 *      } );
		 *    } );
		 */
		"bScrollCollapse": false,
	
	
		/**
		 * Configure DataTables to use server-side processing. Note that the
		 * `ajax` parameter must also be given in order to give DataTables a
		 * source to obtain the required data for each draw.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Features
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.serverSide
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "serverSide": true,
		 *        "ajax": "xhr.php"
		 *      } );
		 *    } );
		 */
		"bServerSide": false,
	
	
		/**
		 * Enable or disable sorting of columns. Sorting of individual columns can be
		 * disabled by the `sortable` option for each column.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.ordering
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "ordering": false
		 *      } );
		 *    } );
		 */
		"bSort": true,
	
	
		/**
		 * Enable or display DataTables' ability to sort multiple columns at the
		 * same time (activated by shift-click by the user).
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.orderMulti
		 *
		 *  @example
		 *    // Disable multiple column sorting ability
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "orderMulti": false
		 *      } );
		 *    } );
		 */
		"bSortMulti": true,
	
	
		/**
		 * Allows control over whether DataTables should use the top (true) unique
		 * cell that is found for a single column, or the bottom (false - default).
		 * This is useful when using complex headers.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.orderCellsTop
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "orderCellsTop": true
		 *      } );
		 *    } );
		 */
		"bSortCellsTop": false,
	
	
		/**
		 * Enable or disable the addition of the classes `sorting\_1`, `sorting\_2` and
		 * `sorting\_3` to the columns which are currently being sorted on. This is
		 * presented as a feature switch as it can increase processing time (while
		 * classes are removed and added) so for large data sets you might want to
		 * turn this off.
		 *  @type boolean
		 *  @default true
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.orderClasses
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "orderClasses": false
		 *      } );
		 *    } );
		 */
		"bSortClasses": true,
	
	
		/**
		 * Enable or disable state saving. When enabled HTML5 `localStorage` will be
		 * used to save table display information such as pagination information,
		 * display length, filtering and sorting. As such when the end user reloads
		 * the page the display display will match what thy had previously set up.
		 *
		 * Due to the use of `localStorage` the default state saving is not supported
		 * in IE6 or 7. If state saving is required in those browsers, use
		 * `stateSaveCallback` to provide a storage solution such as cookies.
		 *  @type boolean
		 *  @default false
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.stateSave
		 *
		 *  @example
		 *    $(document).ready( function () {
		 *      $('#example').dataTable( {
		 *        "stateSave": true
		 *      } );
		 *    } );
		 */
		"bStateSave": false,
	
	
		/**
		 * This function is called when a TR element is created (and all TD child
		 * elements have been inserted), or registered if using a DOM source, allowing
		 * manipulation of the TR element (adding classes etc).
		 *  @type function
		 *  @param {node} row "TR" element for the current row
		 *  @param {array} data Raw data array for this row
		 *  @param {int} dataIndex The index of this row in the internal aoData array
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.createdRow
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "createdRow": function( row, data, dataIndex ) {
		 *          // Bold the grade for all 'A' grade browsers
		 *          if ( data[4] == "A" )
		 *          {
		 *            $('td:eq(4)', row).html( '<b>A</b>' );
		 *          }
		 *        }
		 *      } );
		 *    } );
		 */
		"fnCreatedRow": null,
	
	
		/**
		 * This function is called on every 'draw' event, and allows you to
		 * dynamically modify any aspect you want about the created DOM.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.drawCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "drawCallback": function( settings ) {
		 *          alert( 'DataTables has redrawn the table' );
		 *        }
		 *      } );
		 *    } );
		 */
		"fnDrawCallback": null,
	
	
		/**
		 * Identical to fnHeaderCallback() but for the table footer this function
		 * allows you to modify the table footer on every 'draw' event.
		 *  @type function
		 *  @param {node} foot "TR" element for the footer
		 *  @param {array} data Full table data (as derived from the original HTML)
		 *  @param {int} start Index for the current display starting point in the
		 *    display array
		 *  @param {int} end Index for the current display ending point in the
		 *    display array
		 *  @param {array int} display Index array to translate the visual position
		 *    to the full data array
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.footerCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "footerCallback": function( tfoot, data, start, end, display ) {
		 *          tfoot.getElementsByTagName('th')[0].innerHTML = "Starting index is "+start;
		 *        }
		 *      } );
		 *    } )
		 */
		"fnFooterCallback": null,
	
	
		/**
		 * When rendering large numbers in the information element for the table
		 * (i.e. "Showing 1 to 10 of 57 entries") DataTables will render large numbers
		 * to have a comma separator for the 'thousands' units (e.g. 1 million is
		 * rendered as "1,000,000") to help readability for the end user. This
		 * function will override the default method DataTables uses.
		 *  @type function
		 *  @member
		 *  @param {int} toFormat number to be formatted
		 *  @returns {string} formatted string for DataTables to show the number
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.formatNumber
		 *
		 *  @example
		 *    // Format a number using a single quote for the separator (note that
		 *    // this can also be done with the language.thousands option)
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "formatNumber": function ( toFormat ) {
		 *          return toFormat.toString().replace(
		 *            /\B(?=(\d{3})+(?!\d))/g, "'"
		 *          );
		 *        };
		 *      } );
		 *    } );
		 */
		"fnFormatNumber": function ( toFormat ) {
			return toFormat.toString().replace(
				/\B(?=(\d{3})+(?!\d))/g,
				this.oLanguage.sThousands
			);
		},
	
	
		/**
		 * This function is called on every 'draw' event, and allows you to
		 * dynamically modify the header row. This can be used to calculate and
		 * display useful information about the table.
		 *  @type function
		 *  @param {node} head "TR" element for the header
		 *  @param {array} data Full table data (as derived from the original HTML)
		 *  @param {int} start Index for the current display starting point in the
		 *    display array
		 *  @param {int} end Index for the current display ending point in the
		 *    display array
		 *  @param {array int} display Index array to translate the visual position
		 *    to the full data array
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.headerCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "fheaderCallback": function( head, data, start, end, display ) {
		 *          head.getElementsByTagName('th')[0].innerHTML = "Displaying "+(end-start)+" records";
		 *        }
		 *      } );
		 *    } )
		 */
		"fnHeaderCallback": null,
	
	
		/**
		 * The information element can be used to convey information about the current
		 * state of the table. Although the internationalisation options presented by
		 * DataTables are quite capable of dealing with most customisations, there may
		 * be times where you wish to customise the string further. This callback
		 * allows you to do exactly that.
		 *  @type function
		 *  @param {object} oSettings DataTables settings object
		 *  @param {int} start Starting position in data for the draw
		 *  @param {int} end End position in data for the draw
		 *  @param {int} max Total number of rows in the table (regardless of
		 *    filtering)
		 *  @param {int} total Total number of rows in the data set, after filtering
		 *  @param {string} pre The string that DataTables has formatted using it's
		 *    own rules
		 *  @returns {string} The string to be displayed in the information element.
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.infoCallback
		 *
		 *  @example
		 *    $('#example').dataTable( {
		 *      "infoCallback": function( settings, start, end, max, total, pre ) {
		 *        return start +" to "+ end;
		 *      }
		 *    } );
		 */
		"fnInfoCallback": null,
	
	
		/**
		 * Called when the table has been initialised. Normally DataTables will
		 * initialise sequentially and there will be no need for this function,
		 * however, this does not hold true when using external language information
		 * since that is obtained using an async XHR call.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @param {object} json The JSON object request from the server - only
		 *    present if client-side Ajax sourced data is used
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.initComplete
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "initComplete": function(settings, json) {
		 *          alert( 'DataTables has finished its initialisation.' );
		 *        }
		 *      } );
		 *    } )
		 */
		"fnInitComplete": null,
	
	
		/**
		 * Called at the very start of each table draw and can be used to cancel the
		 * draw by returning false, any other return (including undefined) results in
		 * the full draw occurring).
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @returns {boolean} False will cancel the draw, anything else (including no
		 *    return) will allow it to complete.
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.preDrawCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "preDrawCallback": function( settings ) {
		 *          if ( $('#test').val() == 1 ) {
		 *            return false;
		 *          }
		 *        }
		 *      } );
		 *    } );
		 */
		"fnPreDrawCallback": null,
	
	
		/**
		 * This function allows you to 'post process' each row after it have been
		 * generated for each table draw, but before it is rendered on screen. This
		 * function might be used for setting the row class name etc.
		 *  @type function
		 *  @param {node} row "TR" element for the current row
		 *  @param {array} data Raw data array for this row
		 *  @param {int} displayIndex The display index for the current table draw
		 *  @param {int} displayIndexFull The index of the data in the full list of
		 *    rows (after filtering)
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.rowCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "rowCallback": function( row, data, displayIndex, displayIndexFull ) {
		 *          // Bold the grade for all 'A' grade browsers
		 *          if ( data[4] == "A" ) {
		 *            $('td:eq(4)', row).html( '<b>A</b>' );
		 *          }
		 *        }
		 *      } );
		 *    } );
		 */
		"fnRowCallback": null,
	
	
		/**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 * This parameter allows you to override the default function which obtains
		 * the data from the server so something more suitable for your application.
		 * For example you could use POST data, or pull information from a Gears or
		 * AIR database.
		 *  @type function
		 *  @member
		 *  @param {string} source HTTP source to obtain the data from (`ajax`)
		 *  @param {array} data A key/value pair object containing the data to send
		 *    to the server
		 *  @param {function} callback to be called on completion of the data get
		 *    process that will draw the data on the page.
		 *  @param {object} settings DataTables settings object
		 *
		 *  @dtopt Callbacks
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.serverData
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */
		"fnServerData": null,
	
	
		/**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 *  It is often useful to send extra data to the server when making an Ajax
		 * request - for example custom filtering information, and this callback
		 * function makes it trivial to send extra information to the server. The
		 * passed in parameter is the data set that has been constructed by
		 * DataTables, and you can add to this or modify it as you require.
		 *  @type function
		 *  @param {array} data Data array (array of objects which are name/value
		 *    pairs) that has been constructed by DataTables and will be sent to the
		 *    server. In the case of Ajax sourced data with server-side processing
		 *    this will be an empty array, for server-side processing there will be a
		 *    significant number of parameters!
		 *  @returns {undefined} Ensure that you modify the data array passed in,
		 *    as this is passed by reference.
		 *
		 *  @dtopt Callbacks
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.serverParams
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */
		"fnServerParams": null,
	
	
		/**
		 * Load the table state. With this function you can define from where, and how, the
		 * state of a table is loaded. By default DataTables will load from `localStorage`
		 * but you might wish to use a server-side database or cookies.
		 *  @type function
		 *  @member
		 *  @param {object} settings DataTables settings object
		 *  @param {object} callback Callback that can be executed when done. It
		 *    should be passed the loaded state object.
		 *  @return {object} The DataTables state object to be loaded
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateLoadCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateLoadCallback": function (settings, callback) {
		 *          $.ajax( {
		 *            "url": "/state_load",
		 *            "dataType": "json",
		 *            "success": function (json) {
		 *              callback( json );
		 *            }
		 *          } );
		 *        }
		 *      } );
		 *    } );
		 */
		"fnStateLoadCallback": function ( settings ) {
			try {
				return JSON.parse(
					(settings.iStateDuration === -1 ? sessionStorage : localStorage).getItem(
						'DataTables_'+settings.sInstance+'_'+location.pathname
					)
				);
			} catch (e) {
				return {};
			}
		},
	
	
		/**
		 * Callback which allows modification of the saved state prior to loading that state.
		 * This callback is called when the table is loading state from the stored data, but
		 * prior to the settings object being modified by the saved state. Note that for
		 * plug-in authors, you should use the `stateLoadParams` event to load parameters for
		 * a plug-in.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @param {object} data The state object that is to be loaded
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateLoadParams
		 *
		 *  @example
		 *    // Remove a saved filter, so filtering is never loaded
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateLoadParams": function (settings, data) {
		 *          data.oSearch.sSearch = "";
		 *        }
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Disallow state loading by returning false
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateLoadParams": function (settings, data) {
		 *          return false;
		 *        }
		 *      } );
		 *    } );
		 */
		"fnStateLoadParams": null,
	
	
		/**
		 * Callback that is called when the state has been loaded from the state saving method
		 * and the DataTables settings object has been modified as a result of the loaded state.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @param {object} data The state object that was loaded
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateLoaded
		 *
		 *  @example
		 *    // Show an alert with the filtering value that was saved
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateLoaded": function (settings, data) {
		 *          alert( 'Saved filter was: '+data.oSearch.sSearch );
		 *        }
		 *      } );
		 *    } );
		 */
		"fnStateLoaded": null,
	
	
		/**
		 * Save the table state. This function allows you to define where and how the state
		 * information for the table is stored By default DataTables will use `localStorage`
		 * but you might wish to use a server-side database or cookies.
		 *  @type function
		 *  @member
		 *  @param {object} settings DataTables settings object
		 *  @param {object} data The state object to be saved
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateSaveCallback
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateSaveCallback": function (settings, data) {
		 *          // Send an Ajax request to the server with the state object
		 *          $.ajax( {
		 *            "url": "/state_save",
		 *            "data": data,
		 *            "dataType": "json",
		 *            "method": "POST"
		 *            "success": function () {}
		 *          } );
		 *        }
		 *      } );
		 *    } );
		 */
		"fnStateSaveCallback": function ( settings, data ) {
			try {
				(settings.iStateDuration === -1 ? sessionStorage : localStorage).setItem(
					'DataTables_'+settings.sInstance+'_'+location.pathname,
					JSON.stringify( data )
				);
			} catch (e) {}
		},
	
	
		/**
		 * Callback which allows modification of the state to be saved. Called when the table
		 * has changed state a new state save is required. This method allows modification of
		 * the state saving object prior to actually doing the save, including addition or
		 * other state properties or modification. Note that for plug-in authors, you should
		 * use the `stateSaveParams` event to save parameters for a plug-in.
		 *  @type function
		 *  @param {object} settings DataTables settings object
		 *  @param {object} data The state object to be saved
		 *
		 *  @dtopt Callbacks
		 *  @name DataTable.defaults.stateSaveParams
		 *
		 *  @example
		 *    // Remove a saved filter, so filtering is never saved
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateSave": true,
		 *        "stateSaveParams": function (settings, data) {
		 *          data.oSearch.sSearch = "";
		 *        }
		 *      } );
		 *    } );
		 */
		"fnStateSaveParams": null,
	
	
		/**
		 * Duration for which the saved state information is considered valid. After this period
		 * has elapsed the state will be returned to the default.
		 * Value is given in seconds.
		 *  @type int
		 *  @default 7200 <i>(2 hours)</i>
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.stateDuration
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "stateDuration": 60*60*24; // 1 day
		 *      } );
		 *    } )
		 */
		"iStateDuration": 7200,
	
	
		/**
		 * When enabled DataTables will not make a request to the server for the first
		 * page draw - rather it will use the data already on the page (no sorting etc
		 * will be applied to it), thus saving on an XHR at load time. `deferLoading`
		 * is used to indicate that deferred loading is required, but it is also used
		 * to tell DataTables how many records there are in the full table (allowing
		 * the information element and pagination to be displayed correctly). In the case
		 * where a filtering is applied to the table on initial load, this can be
		 * indicated by giving the parameter as an array, where the first element is
		 * the number of records available after filtering and the second element is the
		 * number of records without filtering (allowing the table information element
		 * to be shown correctly).
		 *  @type int | array
		 *  @default null
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.deferLoading
		 *
		 *  @example
		 *    // 57 records available in the table, no filtering applied
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "serverSide": true,
		 *        "ajax": "scripts/server_processing.php",
		 *        "deferLoading": 57
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // 57 records after filtering, 100 without filtering (an initial filter applied)
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "serverSide": true,
		 *        "ajax": "scripts/server_processing.php",
		 *        "deferLoading": [ 57, 100 ],
		 *        "search": {
		 *          "search": "my_filter"
		 *        }
		 *      } );
		 *    } );
		 */
		"iDeferLoading": null,
	
	
		/**
		 * Number of rows to display on a single page when using pagination. If
		 * feature enabled (`lengthChange`) then the end user will be able to override
		 * this to a custom setting using a pop-up menu.
		 *  @type int
		 *  @default 10
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.pageLength
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "pageLength": 50
		 *      } );
		 *    } )
		 */
		"iDisplayLength": 10,
	
	
		/**
		 * Define the starting point for data display when using DataTables with
		 * pagination. Note that this parameter is the number of records, rather than
		 * the page number, so if you have 10 records per page and want to start on
		 * the third page, it should be "20".
		 *  @type int
		 *  @default 0
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.displayStart
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "displayStart": 20
		 *      } );
		 *    } )
		 */
		"iDisplayStart": 0,
	
	
		/**
		 * By default DataTables allows keyboard navigation of the table (sorting, paging,
		 * and filtering) by adding a `tabindex` attribute to the required elements. This
		 * allows you to tab through the controls and press the enter key to activate them.
		 * The tabindex is default 0, meaning that the tab follows the flow of the document.
		 * You can overrule this using this parameter if you wish. Use a value of -1 to
		 * disable built-in keyboard navigation.
		 *  @type int
		 *  @default 0
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.tabIndex
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "tabIndex": 1
		 *      } );
		 *    } );
		 */
		"iTabIndex": 0,
	
	
		/**
		 * Classes that DataTables assigns to the various components and features
		 * that it adds to the HTML table. This allows classes to be configured
		 * during initialisation in addition to through the static
		 * {@link DataTable.ext.oStdClasses} object).
		 *  @namespace
		 *  @name DataTable.defaults.classes
		 */
		"oClasses": {},
	
	
		/**
		 * All strings that DataTables uses in the user interface that it creates
		 * are defined in this object, allowing you to modified them individually or
		 * completely replace them all as required.
		 *  @namespace
		 *  @name DataTable.defaults.language
		 */
		"oLanguage": {
			/**
			 * Strings that are used for WAI-ARIA labels and controls only (these are not
			 * actually visible on the page, but will be read by screenreaders, and thus
			 * must be internationalised as well).
			 *  @namespace
			 *  @name DataTable.defaults.language.aria
			 */
			"oAria": {
				/**
				 * ARIA label that is added to the table headers when the column may be
				 * sorted ascending by activing the column (click or return when focused).
				 * Note that the column header is prefixed to this string.
				 *  @type string
				 *  @default : activate to sort column ascending
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.aria.sortAscending
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "aria": {
				 *            "sortAscending": " - click/return to sort ascending"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
				"sSortAscending": ": activate to sort column ascending",
	
				/**
				 * ARIA label that is added to the table headers when the column may be
				 * sorted descending by activing the column (click or return when focused).
				 * Note that the column header is prefixed to this string.
				 *  @type string
				 *  @default : activate to sort column ascending
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.aria.sortDescending
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "aria": {
				 *            "sortDescending": " - click/return to sort descending"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
				"sSortDescending": ": activate to sort column descending"
			},
	
			/**
			 * Pagination string used by DataTables for the built-in pagination
			 * control types.
			 *  @namespace
			 *  @name DataTable.defaults.language.paginate
			 */
			"oPaginate": {
				/**
				 * Text to use when using the 'full_numbers' type of pagination for the
				 * button to take the user to the first page.
				 *  @type string
				 *  @default First
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.paginate.first
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "paginate": {
				 *            "first": "First page"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
				"sFirst": "First",
	
	
				/**
				 * Text to use when using the 'full_numbers' type of pagination for the
				 * button to take the user to the last page.
				 *  @type string
				 *  @default Last
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.paginate.last
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "paginate": {
				 *            "last": "Last page"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
				"sLast": "Last",
	
	
				/**
				 * Text to use for the 'next' pagination button (to take the user to the
				 * next page).
				 *  @type string
				 *  @default Next
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.paginate.next
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "paginate": {
				 *            "next": "Next page"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
				"sNext": "Next",
	
	
				/**
				 * Text to use for the 'previous' pagination button (to take the user to
				 * the previous page).
				 *  @type string
				 *  @default Previous
				 *
				 *  @dtopt Language
				 *  @name DataTable.defaults.language.paginate.previous
				 *
				 *  @example
				 *    $(document).ready( function() {
				 *      $('#example').dataTable( {
				 *        "language": {
				 *          "paginate": {
				 *            "previous": "Previous page"
				 *          }
				 *        }
				 *      } );
				 *    } );
				 */
				"sPrevious": "Previous"
			},
	
			/**
			 * This string is shown in preference to `zeroRecords` when the table is
			 * empty of data (regardless of filtering). Note that this is an optional
			 * parameter - if it is not given, the value of `zeroRecords` will be used
			 * instead (either the default or given value).
			 *  @type string
			 *  @default No data available in table
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.emptyTable
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "emptyTable": "No data available in table"
			 *        }
			 *      } );
			 *    } );
			 */
			"sEmptyTable": "No data available in table",
	
	
			/**
			 * This string gives information to the end user about the information
			 * that is current on display on the page. The following tokens can be
			 * used in the string and will be dynamically replaced as the table
			 * display updates. This tokens can be placed anywhere in the string, or
			 * removed as needed by the language requires:
			 *
			 * * `\_START\_` - Display index of the first record on the current page
			 * * `\_END\_` - Display index of the last record on the current page
			 * * `\_TOTAL\_` - Number of records in the table after filtering
			 * * `\_MAX\_` - Number of records in the table without filtering
			 * * `\_PAGE\_` - Current page number
			 * * `\_PAGES\_` - Total number of pages of data in the table
			 *
			 *  @type string
			 *  @default Showing _START_ to _END_ of _TOTAL_ entries
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.info
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "info": "Showing page _PAGE_ of _PAGES_"
			 *        }
			 *      } );
			 *    } );
			 */
			"sInfo": "Showing _START_ to _END_ of _TOTAL_ entries",
	
	
			/**
			 * Display information string for when the table is empty. Typically the
			 * format of this string should match `info`.
			 *  @type string
			 *  @default Showing 0 to 0 of 0 entries
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.infoEmpty
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "infoEmpty": "No entries to show"
			 *        }
			 *      } );
			 *    } );
			 */
			"sInfoEmpty": "Showing 0 to 0 of 0 entries",
	
	
			/**
			 * When a user filters the information in a table, this string is appended
			 * to the information (`info`) to give an idea of how strong the filtering
			 * is. The variable _MAX_ is dynamically updated.
			 *  @type string
			 *  @default (filtered from _MAX_ total entries)
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.infoFiltered
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "infoFiltered": " - filtering from _MAX_ records"
			 *        }
			 *      } );
			 *    } );
			 */
			"sInfoFiltered": "(filtered from _MAX_ total entries)",
	
	
			/**
			 * If can be useful to append extra information to the info string at times,
			 * and this variable does exactly that. This information will be appended to
			 * the `info` (`infoEmpty` and `infoFiltered` in whatever combination they are
			 * being used) at all times.
			 *  @type string
			 *  @default <i>Empty string</i>
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.infoPostFix
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "infoPostFix": "All records shown are derived from real information."
			 *        }
			 *      } );
			 *    } );
			 */
			"sInfoPostFix": "",
	
	
			/**
			 * This decimal place operator is a little different from the other
			 * language options since DataTables doesn't output floating point
			 * numbers, so it won't ever use this for display of a number. Rather,
			 * what this parameter does is modify the sort methods of the table so
			 * that numbers which are in a format which has a character other than
			 * a period (`.`) as a decimal place will be sorted numerically.
			 *
			 * Note that numbers with different decimal places cannot be shown in
			 * the same table and still be sortable, the table must be consistent.
			 * However, multiple different tables on the page can use different
			 * decimal place characters.
			 *  @type string
			 *  @default 
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.decimal
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "decimal": ","
			 *          "thousands": "."
			 *        }
			 *      } );
			 *    } );
			 */
			"sDecimal": "",
	
	
			/**
			 * DataTables has a build in number formatter (`formatNumber`) which is
			 * used to format large numbers that are used in the table information.
			 * By default a comma is used, but this can be trivially changed to any
			 * character you wish with this parameter.
			 *  @type string
			 *  @default ,
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.thousands
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "thousands": "'"
			 *        }
			 *      } );
			 *    } );
			 */
			"sThousands": ",",
	
	
			/**
			 * Detail the action that will be taken when the drop down menu for the
			 * pagination length option is changed. The '_MENU_' variable is replaced
			 * with a default select list of 10, 25, 50 and 100, and can be replaced
			 * with a custom select box if required.
			 *  @type string
			 *  @default Show _MENU_ entries
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.lengthMenu
			 *
			 *  @example
			 *    // Language change only
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "lengthMenu": "Display _MENU_ records"
			 *        }
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Language and options change
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "lengthMenu": 'Display <select>'+
			 *            '<option value="10">10</option>'+
			 *            '<option value="20">20</option>'+
			 *            '<option value="30">30</option>'+
			 *            '<option value="40">40</option>'+
			 *            '<option value="50">50</option>'+
			 *            '<option value="-1">All</option>'+
			 *            '</select> records'
			 *        }
			 *      } );
			 *    } );
			 */
			"sLengthMenu": "Show _MENU_ entries",
	
	
			/**
			 * When using Ajax sourced data and during the first draw when DataTables is
			 * gathering the data, this message is shown in an empty row in the table to
			 * indicate to the end user the the data is being loaded. Note that this
			 * parameter is not used when loading data by server-side processing, just
			 * Ajax sourced data with client-side processing.
			 *  @type string
			 *  @default Loading...
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.loadingRecords
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "loadingRecords": "Please wait - loading..."
			 *        }
			 *      } );
			 *    } );
			 */
			"sLoadingRecords": "Loading...",
	
	
			/**
			 * Text which is displayed when the table is processing a user action
			 * (usually a sort command or similar).
			 *  @type string
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.processing
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "processing": "DataTables is currently busy"
			 *        }
			 *      } );
			 *    } );
			 */
			"sProcessing": "",
	
	
			/**
			 * Details the actions that will be taken when the user types into the
			 * filtering input text box. The variable "_INPUT_", if used in the string,
			 * is replaced with the HTML text box for the filtering input allowing
			 * control over where it appears in the string. If "_INPUT_" is not given
			 * then the input box is appended to the string automatically.
			 *  @type string
			 *  @default Search:
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.search
			 *
			 *  @example
			 *    // Input text box will be appended at the end automatically
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "search": "Filter records:"
			 *        }
			 *      } );
			 *    } );
			 *
			 *  @example
			 *    // Specify where the filter should appear
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "search": "Apply filter _INPUT_ to table"
			 *        }
			 *      } );
			 *    } );
			 */
			"sSearch": "Search:",
	
	
			/**
			 * Assign a `placeholder` attribute to the search `input` element
			 *  @type string
			 *  @default 
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.searchPlaceholder
			 */
			"sSearchPlaceholder": "",
	
	
			/**
			 * All of the language information can be stored in a file on the
			 * server-side, which DataTables will look up if this parameter is passed.
			 * It must store the URL of the language file, which is in a JSON format,
			 * and the object has the same properties as the oLanguage object in the
			 * initialiser object (i.e. the above parameters). Please refer to one of
			 * the example language files to see how this works in action.
			 *  @type string
			 *  @default <i>Empty string - i.e. disabled</i>
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.url
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "url": "https://www.sprymedia.co.uk/dataTables/lang.txt"
			 *        }
			 *      } );
			 *    } );
			 */
			"sUrl": "",
	
	
			/**
			 * Text shown inside the table records when the is no information to be
			 * displayed after filtering. `emptyTable` is shown when there is simply no
			 * information in the table at all (regardless of filtering).
			 *  @type string
			 *  @default No matching records found
			 *
			 *  @dtopt Language
			 *  @name DataTable.defaults.language.zeroRecords
			 *
			 *  @example
			 *    $(document).ready( function() {
			 *      $('#example').dataTable( {
			 *        "language": {
			 *          "zeroRecords": "No records to display"
			 *        }
			 *      } );
			 *    } );
			 */
			"sZeroRecords": "No matching records found"
		},
	
	
		/**
		 * This parameter allows you to have define the global filtering state at
		 * initialisation time. As an object the `search` parameter must be
		 * defined, but all other parameters are optional. When `regex` is true,
		 * the search string will be treated as a regular expression, when false
		 * (default) it will be treated as a straight string. When `smart`
		 * DataTables will use it's smart filtering methods (to word match at
		 * any point in the data), when false this will not be done.
		 *  @namespace
		 *  @extends DataTable.models.oSearch
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.search
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "search": {"search": "Initial search"}
		 *      } );
		 *    } )
		 */
		"oSearch": $.extend( {}, DataTable.models.oSearch ),
	
	
		/**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 * By default DataTables will look for the property `data` (or `aaData` for
		 * compatibility with DataTables 1.9-) when obtaining data from an Ajax
		 * source or for server-side processing - this parameter allows that
		 * property to be changed. You can use Javascript dotted object notation to
		 * get a data source for multiple levels of nesting.
		 *  @type string
		 *  @default data
		 *
		 *  @dtopt Options
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.ajaxDataProp
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */
		"sAjaxDataProp": "data",
	
	
		/**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 * You can instruct DataTables to load data from an external
		 * source using this parameter (use aData if you want to pass data in you
		 * already have). Simply provide a url a JSON object can be obtained from.
		 *  @type string
		 *  @default null
		 *
		 *  @dtopt Options
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.ajaxSource
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */
		"sAjaxSource": null,
	
	
		/**
		 * This initialisation variable allows you to specify exactly where in the
		 * DOM you want DataTables to inject the various controls it adds to the page
		 * (for example you might want the pagination controls at the top of the
		 * table). DIV elements (with or without a custom class) can also be added to
		 * aid styling. The follow syntax is used:
		 *   <ul>
		 *     <li>The following options are allowed:
		 *       <ul>
		 *         <li>'l' - Length changing</li>
		 *         <li>'f' - Filtering input</li>
		 *         <li>'t' - The table!</li>
		 *         <li>'i' - Information</li>
		 *         <li>'p' - Pagination</li>
		 *         <li>'r' - pRocessing</li>
		 *       </ul>
		 *     </li>
		 *     <li>The following constants are allowed:
		 *       <ul>
		 *         <li>'H' - jQueryUI theme "header" classes ('fg-toolbar ui-widget-header ui-corner-tl ui-corner-tr ui-helper-clearfix')</li>
		 *         <li>'F' - jQueryUI theme "footer" classes ('fg-toolbar ui-widget-header ui-corner-bl ui-corner-br ui-helper-clearfix')</li>
		 *       </ul>
		 *     </li>
		 *     <li>The following syntax is expected:
		 *       <ul>
		 *         <li>'&lt;' and '&gt;' - div elements</li>
		 *         <li>'&lt;"class" and '&gt;' - div with a class</li>
		 *         <li>'&lt;"#id" and '&gt;' - div with an ID</li>
		 *       </ul>
		 *     </li>
		 *     <li>Examples:
		 *       <ul>
		 *         <li>'&lt;"wrapper"flipt&gt;'</li>
		 *         <li>'&lt;lf&lt;t&gt;ip&gt;'</li>
		 *       </ul>
		 *     </li>
		 *   </ul>
		 *  @type string
		 *  @default lfrtip <i>(when `jQueryUI` is false)</i> <b>or</b>
		 *    <"H"lfr>t<"F"ip> <i>(when `jQueryUI` is true)</i>
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.dom
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "dom": '&lt;"top"i&gt;rt&lt;"bottom"flp&gt;&lt;"clear"&gt;'
		 *      } );
		 *    } );
		 */
		"sDom": "lfrtip",
	
	
		/**
		 * Search delay option. This will throttle full table searches that use the
		 * DataTables provided search input element (it does not effect calls to
		 * `dt-api search()`, providing a delay before the search is made.
		 *  @type integer
		 *  @default 0
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.searchDelay
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "searchDelay": 200
		 *      } );
		 *    } )
		 */
		"searchDelay": null,
	
	
		/**
		 * DataTables features six different built-in options for the buttons to
		 * display for pagination control:
		 *
		 * * `numbers` - Page number buttons only
		 * * `simple` - 'Previous' and 'Next' buttons only
		 * * 'simple_numbers` - 'Previous' and 'Next' buttons, plus page numbers
		 * * `full` - 'First', 'Previous', 'Next' and 'Last' buttons
		 * * `full_numbers` - 'First', 'Previous', 'Next' and 'Last' buttons, plus page numbers
		 * * `first_last_numbers` - 'First' and 'Last' buttons, plus page numbers
		 *  
		 * Further methods can be added using {@link DataTable.ext.oPagination}.
		 *  @type string
		 *  @default simple_numbers
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.pagingType
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "pagingType": "full_numbers"
		 *      } );
		 *    } )
		 */
		"sPaginationType": "simple_numbers",
	
	
		/**
		 * Enable horizontal scrolling. When a table is too wide to fit into a
		 * certain layout, or you have a large number of columns in the table, you
		 * can enable x-scrolling to show the table in a viewport, which can be
		 * scrolled. This property can be `true` which will allow the table to
		 * scroll horizontally when needed, or any CSS unit, or a number (in which
		 * case it will be treated as a pixel measurement). Setting as simply `true`
		 * is recommended.
		 *  @type boolean|string
		 *  @default <i>blank string - i.e. disabled</i>
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.scrollX
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "scrollX": true,
		 *        "scrollCollapse": true
		 *      } );
		 *    } );
		 */
		"sScrollX": "",
	
	
		/**
		 * This property can be used to force a DataTable to use more width than it
		 * might otherwise do when x-scrolling is enabled. For example if you have a
		 * table which requires to be well spaced, this parameter is useful for
		 * "over-sizing" the table, and thus forcing scrolling. This property can by
		 * any CSS unit, or a number (in which case it will be treated as a pixel
		 * measurement).
		 *  @type string
		 *  @default <i>blank string - i.e. disabled</i>
		 *
		 *  @dtopt Options
		 *  @name DataTable.defaults.scrollXInner
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "scrollX": "100%",
		 *        "scrollXInner": "110%"
		 *      } );
		 *    } );
		 */
		"sScrollXInner": "",
	
	
		/**
		 * Enable vertical scrolling. Vertical scrolling will constrain the DataTable
		 * to the given height, and enable scrolling for any data which overflows the
		 * current viewport. This can be used as an alternative to paging to display
		 * a lot of data in a small area (although paging and scrolling can both be
		 * enabled at the same time). This property can be any CSS unit, or a number
		 * (in which case it will be treated as a pixel measurement).
		 *  @type string
		 *  @default <i>blank string - i.e. disabled</i>
		 *
		 *  @dtopt Features
		 *  @name DataTable.defaults.scrollY
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "scrollY": "200px",
		 *        "paginate": false
		 *      } );
		 *    } );
		 */
		"sScrollY": "",
	
	
		/**
		 * __Deprecated__ The functionality provided by this parameter has now been
		 * superseded by that provided through `ajax`, which should be used instead.
		 *
		 * Set the HTTP method that is used to make the Ajax call for server-side
		 * processing or Ajax sourced data.
		 *  @type string
		 *  @default GET
		 *
		 *  @dtopt Options
		 *  @dtopt Server-side
		 *  @name DataTable.defaults.serverMethod
		 *
		 *  @deprecated 1.10. Please use `ajax` for this functionality now.
		 */
		"sServerMethod": "GET",
	
	
		/**
		 * DataTables makes use of renderers when displaying HTML elements for
		 * a table. These renderers can be added or modified by plug-ins to
		 * generate suitable mark-up for a site. For example the Bootstrap
		 * integration plug-in for DataTables uses a paging button renderer to
		 * display pagination buttons in the mark-up required by Bootstrap.
		 *
		 * For further information about the renderers available see
		 * DataTable.ext.renderer
		 *  @type string|object
		 *  @default null
		 *
		 *  @name DataTable.defaults.renderer
		 *
		 */
		"renderer": null,
	
	
		/**
		 * Set the data property name that DataTables should use to get a row's id
		 * to set as the `id` property in the node.
		 *  @type string
		 *  @default DT_RowId
		 *
		 *  @name DataTable.defaults.rowId
		 */
		"rowId": "DT_RowId"
	};
	
	_fnHungarianMap( DataTable.defaults );
	
	
	
	/*
	 * Developer note - See note in model.defaults.js about the use of Hungarian
	 * notation and camel case.
	 */
	
	/**
	 * Column options that can be given to DataTables at initialisation time.
	 *  @namespace
	 */
	DataTable.defaults.column = {
		/**
		 * Define which column(s) an order will occur on for this column. This
		 * allows a column's ordering to take multiple columns into account when
		 * doing a sort or use the data from a different column. For example first
		 * name / last name columns make sense to do a multi-column sort over the
		 * two columns.
		 *  @type array|int
		 *  @default null <i>Takes the value of the column index automatically</i>
		 *
		 *  @name DataTable.defaults.column.orderData
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "orderData": [ 0, 1 ], "targets": [ 0 ] },
		 *          { "orderData": [ 1, 0 ], "targets": [ 1 ] },
		 *          { "orderData": 2, "targets": [ 2 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "orderData": [ 0, 1 ] },
		 *          { "orderData": [ 1, 0 ] },
		 *          { "orderData": 2 },
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
		"aDataSort": null,
		"iDataSort": -1,
	
	
		/**
		 * You can control the default ordering direction, and even alter the
		 * behaviour of the sort handler (i.e. only allow ascending ordering etc)
		 * using this parameter.
		 *  @type array
		 *  @default [ 'asc', 'desc' ]
		 *
		 *  @name DataTable.defaults.column.orderSequence
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "orderSequence": [ "asc" ], "targets": [ 1 ] },
		 *          { "orderSequence": [ "desc", "asc", "asc" ], "targets": [ 2 ] },
		 *          { "orderSequence": [ "desc" ], "targets": [ 3 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          null,
		 *          { "orderSequence": [ "asc" ] },
		 *          { "orderSequence": [ "desc", "asc", "asc" ] },
		 *          { "orderSequence": [ "desc" ] },
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
		"asSorting": [ 'asc', 'desc' ],
	
	
		/**
		 * Enable or disable filtering on the data in this column.
		 *  @type boolean
		 *  @default true
		 *
		 *  @name DataTable.defaults.column.searchable
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "searchable": false, "targets": [ 0 ] }
		 *        ] } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "searchable": false },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ] } );
		 *    } );
		 */
		"bSearchable": true,
	
	
		/**
		 * Enable or disable ordering on this column.
		 *  @type boolean
		 *  @default true
		 *
		 *  @name DataTable.defaults.column.orderable
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "orderable": false, "targets": [ 0 ] }
		 *        ] } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "orderable": false },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ] } );
		 *    } );
		 */
		"bSortable": true,
	
	
		/**
		 * Enable or disable the display of this column.
		 *  @type boolean
		 *  @default true
		 *
		 *  @name DataTable.defaults.column.visible
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "visible": false, "targets": [ 0 ] }
		 *        ] } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "visible": false },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ] } );
		 *    } );
		 */
		"bVisible": true,
	
	
		/**
		 * Developer definable function that is called whenever a cell is created (Ajax source,
		 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
		 * allowing you to modify the DOM element (add background colour for example) when the
		 * element is available.
		 *  @type function
		 *  @param {element} td The TD node that has been created
		 *  @param {*} cellData The Data for the cell
		 *  @param {array|object} rowData The data for the whole row
		 *  @param {int} row The row index for the aoData data store
		 *  @param {int} col The column index for aoColumns
		 *
		 *  @name DataTable.defaults.column.createdCell
		 *  @dtopt Columns
		 *
		 *  @example
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [3],
		 *          "createdCell": function (td, cellData, rowData, row, col) {
		 *            if ( cellData == "1.7" ) {
		 *              $(td).css('color', 'blue')
		 *            }
		 *          }
		 *        } ]
		 *      });
		 *    } );
		 */
		"fnCreatedCell": null,
	
	
		/**
		 * This parameter has been replaced by `data` in DataTables to ensure naming
		 * consistency. `dataProp` can still be used, as there is backwards
		 * compatibility in DataTables for this option, but it is strongly
		 * recommended that you use `data` in preference to `dataProp`.
		 *  @name DataTable.defaults.column.dataProp
		 */
	
	
		/**
		 * This property can be used to read data from any data source property,
		 * including deeply nested objects / properties. `data` can be given in a
		 * number of different ways which effect its behaviour:
		 *
		 * * `integer` - treated as an array index for the data source. This is the
		 *   default that DataTables uses (incrementally increased for each column).
		 * * `string` - read an object property from the data source. There are
		 *   three 'special' options that can be used in the string to alter how
		 *   DataTables reads the data from the source object:
		 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
		 *      Javascript to read from nested objects, so to can the options
		 *      specified in `data`. For example: `browser.version` or
		 *      `browser.name`. If your object parameter name contains a period, use
		 *      `\\` to escape it - i.e. `first\\.name`.
		 *    * `[]` - Array notation. DataTables can automatically combine data
		 *      from and array source, joining the data with the characters provided
		 *      between the two brackets. For example: `name[, ]` would provide a
		 *      comma-space separated list from the source array. If no characters
		 *      are provided between the brackets, the original array source is
		 *      returned.
		 *    * `()` - Function notation. Adding `()` to the end of a parameter will
		 *      execute a function of the name given. For example: `browser()` for a
		 *      simple function on the data source, `browser.version()` for a
		 *      function in a nested property or even `browser().version` to get an
		 *      object property if the function called returns an object. Note that
		 *      function notation is recommended for use in `render` rather than
		 *      `data` as it is much simpler to use as a renderer.
		 * * `null` - use the original data source for the row rather than plucking
		 *   data directly from it. This action has effects on two other
		 *   initialisation options:
		 *    * `defaultContent` - When null is given as the `data` option and
		 *      `defaultContent` is specified for the column, the value defined by
		 *      `defaultContent` will be used for the cell.
		 *    * `render` - When null is used for the `data` option and the `render`
		 *      option is specified for the column, the whole data source for the
		 *      row is used for the renderer.
		 * * `function` - the function given will be executed whenever DataTables
		 *   needs to set or get the data for a cell in the column. The function
		 *   takes three parameters:
		 *    * Parameters:
		 *      * `{array|object}` The data source for the row
		 *      * `{string}` The type call data requested - this will be 'set' when
		 *        setting data or 'filter', 'display', 'type', 'sort' or undefined
		 *        when gathering data. Note that when `undefined` is given for the
		 *        type DataTables expects to get the raw data for the object back<
		 *      * `{*}` Data to set when the second parameter is 'set'.
		 *    * Return:
		 *      * The return value from the function is not required when 'set' is
		 *        the type of call, but otherwise the return is what will be used
		 *        for the data requested.
		 *
		 * Note that `data` is a getter and setter option. If you just require
		 * formatting of data for output, you will likely want to use `render` which
		 * is simply a getter and thus simpler to use.
		 *
		 * Note that prior to DataTables 1.9.2 `data` was called `mDataProp`. The
		 * name change reflects the flexibility of this property and is consistent
		 * with the naming of mRender. If 'mDataProp' is given, then it will still
		 * be used by DataTables, as it automatically maps the old name to the new
		 * if required.
		 *
		 *  @type string|int|function|null
		 *  @default null <i>Use automatically calculated column index</i>
		 *
		 *  @name DataTable.defaults.column.data
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Read table data from objects
		 *    // JSON structure for each row:
		 *    //   {
		 *    //      "engine": {value},
		 *    //      "browser": {value},
		 *    //      "platform": {value},
		 *    //      "version": {value},
		 *    //      "grade": {value}
		 *    //   }
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "ajaxSource": "sources/objects.txt",
		 *        "columns": [
		 *          { "data": "engine" },
		 *          { "data": "browser" },
		 *          { "data": "platform" },
		 *          { "data": "version" },
		 *          { "data": "grade" }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Read information from deeply nested objects
		 *    // JSON structure for each row:
		 *    //   {
		 *    //      "engine": {value},
		 *    //      "browser": {value},
		 *    //      "platform": {
		 *    //         "inner": {value}
		 *    //      },
		 *    //      "details": [
		 *    //         {value}, {value}
		 *    //      ]
		 *    //   }
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "ajaxSource": "sources/deep.txt",
		 *        "columns": [
		 *          { "data": "engine" },
		 *          { "data": "browser" },
		 *          { "data": "platform.inner" },
		 *          { "data": "details.0" },
		 *          { "data": "details.1" }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `data` as a function to provide different information for
		 *    // sorting, filtering and display. In this case, currency (price)
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": function ( source, type, val ) {
		 *            if (type === 'set') {
		 *              source.price = val;
		 *              // Store the computed display and filter values for efficiency
		 *              source.price_display = val=="" ? "" : "$"+numberFormat(val);
		 *              source.price_filter  = val=="" ? "" : "$"+numberFormat(val)+" "+val;
		 *              return;
		 *            }
		 *            else if (type === 'display') {
		 *              return source.price_display;
		 *            }
		 *            else if (type === 'filter') {
		 *              return source.price_filter;
		 *            }
		 *            // 'sort', 'type' and undefined all just use the integer
		 *            return source.price;
		 *          }
		 *        } ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using default content
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": null,
		 *          "defaultContent": "Click to edit"
		 *        } ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using array notation - outputting a list from an array
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": "name[, ]"
		 *        } ]
		 *      } );
		 *    } );
		 *
		 */
		"mData": null,
	
	
		/**
		 * This property is the rendering partner to `data` and it is suggested that
		 * when you want to manipulate data for display (including filtering,
		 * sorting etc) without altering the underlying data for the table, use this
		 * property. `render` can be considered to be the the read only companion to
		 * `data` which is read / write (then as such more complex). Like `data`
		 * this option can be given in a number of different ways to effect its
		 * behaviour:
		 *
		 * * `integer` - treated as an array index for the data source. This is the
		 *   default that DataTables uses (incrementally increased for each column).
		 * * `string` - read an object property from the data source. There are
		 *   three 'special' options that can be used in the string to alter how
		 *   DataTables reads the data from the source object:
		 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
		 *      Javascript to read from nested objects, so to can the options
		 *      specified in `data`. For example: `browser.version` or
		 *      `browser.name`. If your object parameter name contains a period, use
		 *      `\\` to escape it - i.e. `first\\.name`.
		 *    * `[]` - Array notation. DataTables can automatically combine data
		 *      from and array source, joining the data with the characters provided
		 *      between the two brackets. For example: `name[, ]` would provide a
		 *      comma-space separated list from the source array. If no characters
		 *      are provided between the brackets, the original array source is
		 *      returned.
		 *    * `()` - Function notation. Adding `()` to the end of a parameter will
		 *      execute a function of the name given. For example: `browser()` for a
		 *      simple function on the data source, `browser.version()` for a
		 *      function in a nested property or even `browser().version` to get an
		 *      object property if the function called returns an object.
		 * * `object` - use different data for the different data types requested by
		 *   DataTables ('filter', 'display', 'type' or 'sort'). The property names
		 *   of the object is the data type the property refers to and the value can
		 *   defined using an integer, string or function using the same rules as
		 *   `render` normally does. Note that an `_` option _must_ be specified.
		 *   This is the default value to use if you haven't specified a value for
		 *   the data type requested by DataTables.
		 * * `function` - the function given will be executed whenever DataTables
		 *   needs to set or get the data for a cell in the column. The function
		 *   takes three parameters:
		 *    * Parameters:
		 *      * {array|object} The data source for the row (based on `data`)
		 *      * {string} The type call data requested - this will be 'filter',
		 *        'display', 'type' or 'sort'.
		 *      * {array|object} The full data source for the row (not based on
		 *        `data`)
		 *    * Return:
		 *      * The return value from the function is what will be used for the
		 *        data requested.
		 *
		 *  @type string|int|function|object|null
		 *  @default null Use the data source value.
		 *
		 *  @name DataTable.defaults.column.render
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Create a comma separated list from an array of objects
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "ajaxSource": "sources/deep.txt",
		 *        "columns": [
		 *          { "data": "engine" },
		 *          { "data": "browser" },
		 *          {
		 *            "data": "platform",
		 *            "render": "[, ].name"
		 *          }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Execute a function to obtain data
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": null, // Use the full data source object for the renderer's source
		 *          "render": "browserName()"
		 *        } ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // As an object, extracting different data for the different types
		 *    // This would be used with a data source such as:
		 *    //   { "phone": 5552368, "phone_filter": "5552368 555-2368", "phone_display": "555-2368" }
		 *    // Here the `phone` integer is used for sorting and type detection, while `phone_filter`
		 *    // (which has both forms) is used for filtering for if a user inputs either format, while
		 *    // the formatted phone number is the one that is shown in the table.
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": null, // Use the full data source object for the renderer's source
		 *          "render": {
		 *            "_": "phone",
		 *            "filter": "phone_filter",
		 *            "display": "phone_display"
		 *          }
		 *        } ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Use as a function to create a link from the data source
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "data": "download_link",
		 *          "render": function ( data, type, full ) {
		 *            return '<a href="'+data+'">Download</a>';
		 *          }
		 *        } ]
		 *      } );
		 *    } );
		 */
		"mRender": null,
	
	
		/**
		 * Change the cell type created for the column - either TD cells or TH cells. This
		 * can be useful as TH cells have semantic meaning in the table body, allowing them
		 * to act as a header for a row (you may wish to add scope='row' to the TH elements).
		 *  @type string
		 *  @default td
		 *
		 *  @name DataTable.defaults.column.cellType
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Make the first column use TH cells
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [ {
		 *          "targets": [ 0 ],
		 *          "cellType": "th"
		 *        } ]
		 *      } );
		 *    } );
		 */
		"sCellType": "td",
	
	
		/**
		 * Class to give to each cell in this column.
		 *  @type string
		 *  @default <i>Empty string</i>
		 *
		 *  @name DataTable.defaults.column.class
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "class": "my_class", "targets": [ 0 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "class": "my_class" },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
		"sClass": "",
	
		/**
		 * When DataTables calculates the column widths to assign to each column,
		 * it finds the longest string in each column and then constructs a
		 * temporary table and reads the widths from that. The problem with this
		 * is that "mmm" is much wider then "iiii", but the latter is a longer
		 * string - thus the calculation can go wrong (doing it properly and putting
		 * it into an DOM object and measuring that is horribly(!) slow). Thus as
		 * a "work around" we provide this option. It will append its value to the
		 * text that is found to be the longest string for the column - i.e. padding.
		 * Generally you shouldn't need this!
		 *  @type string
		 *  @default <i>Empty string<i>
		 *
		 *  @name DataTable.defaults.column.contentPadding
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          null,
		 *          null,
		 *          null,
		 *          {
		 *            "contentPadding": "mmm"
		 *          }
		 *        ]
		 *      } );
		 *    } );
		 */
		"sContentPadding": "",
	
	
		/**
		 * Allows a default value to be given for a column's data, and will be used
		 * whenever a null data source is encountered (this can be because `data`
		 * is set to null, or because the data source itself is null).
		 *  @type string
		 *  @default null
		 *
		 *  @name DataTable.defaults.column.defaultContent
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          {
		 *            "data": null,
		 *            "defaultContent": "Edit",
		 *            "targets": [ -1 ]
		 *          }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          null,
		 *          null,
		 *          null,
		 *          {
		 *            "data": null,
		 *            "defaultContent": "Edit"
		 *          }
		 *        ]
		 *      } );
		 *    } );
		 */
		"sDefaultContent": null,
	
	
		/**
		 * This parameter is only used in DataTables' server-side processing. It can
		 * be exceptionally useful to know what columns are being displayed on the
		 * client side, and to map these to database fields. When defined, the names
		 * also allow DataTables to reorder information from the server if it comes
		 * back in an unexpected order (i.e. if you switch your columns around on the
		 * client-side, your server-side code does not also need updating).
		 *  @type string
		 *  @default <i>Empty string</i>
		 *
		 *  @name DataTable.defaults.column.name
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "name": "engine", "targets": [ 0 ] },
		 *          { "name": "browser", "targets": [ 1 ] },
		 *          { "name": "platform", "targets": [ 2 ] },
		 *          { "name": "version", "targets": [ 3 ] },
		 *          { "name": "grade", "targets": [ 4 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "name": "engine" },
		 *          { "name": "browser" },
		 *          { "name": "platform" },
		 *          { "name": "version" },
		 *          { "name": "grade" }
		 *        ]
		 *      } );
		 *    } );
		 */
		"sName": "",
	
	
		/**
		 * Defines a data source type for the ordering which can be used to read
		 * real-time information from the table (updating the internally cached
		 * version) prior to ordering. This allows ordering to occur on user
		 * editable elements such as form inputs.
		 *  @type string
		 *  @default std
		 *
		 *  @name DataTable.defaults.column.orderDataType
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "orderDataType": "dom-text", "targets": [ 2, 3 ] },
		 *          { "type": "numeric", "targets": [ 3 ] },
		 *          { "orderDataType": "dom-select", "targets": [ 4 ] },
		 *          { "orderDataType": "dom-checkbox", "targets": [ 5 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          null,
		 *          null,
		 *          { "orderDataType": "dom-text" },
		 *          { "orderDataType": "dom-text", "type": "numeric" },
		 *          { "orderDataType": "dom-select" },
		 *          { "orderDataType": "dom-checkbox" }
		 *        ]
		 *      } );
		 *    } );
		 */
		"sSortDataType": "std",
	
	
		/**
		 * The title of this column.
		 *  @type string
		 *  @default null <i>Derived from the 'TH' value for this column in the
		 *    original HTML table.</i>
		 *
		 *  @name DataTable.defaults.column.title
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "title": "My column title", "targets": [ 0 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "title": "My column title" },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
		"sTitle": null,
	
	
		/**
		 * The type allows you to specify how the data for this column will be
		 * ordered. Four types (string, numeric, date and html (which will strip
		 * HTML tags before ordering)) are currently available. Note that only date
		 * formats understood by Javascript's Date() object will be accepted as type
		 * date. For example: "Mar 26, 2008 5:03 PM". May take the values: 'string',
		 * 'numeric', 'date' or 'html' (by default). Further types can be adding
		 * through plug-ins.
		 *  @type string
		 *  @default null <i>Auto-detected from raw data</i>
		 *
		 *  @name DataTable.defaults.column.type
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "type": "html", "targets": [ 0 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "type": "html" },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
		"sType": null,
	
	
		/**
		 * Defining the width of the column, this parameter may take any CSS value
		 * (3em, 20px etc). DataTables applies 'smart' widths to columns which have not
		 * been given a specific width through this interface ensuring that the table
		 * remains readable.
		 *  @type string
		 *  @default null <i>Automatic</i>
		 *
		 *  @name DataTable.defaults.column.width
		 *  @dtopt Columns
		 *
		 *  @example
		 *    // Using `columnDefs`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columnDefs": [
		 *          { "width": "20%", "targets": [ 0 ] }
		 *        ]
		 *      } );
		 *    } );
		 *
		 *  @example
		 *    // Using `columns`
		 *    $(document).ready( function() {
		 *      $('#example').dataTable( {
		 *        "columns": [
		 *          { "width": "20%" },
		 *          null,
		 *          null,
		 *          null,
		 *          null
		 *        ]
		 *      } );
		 *    } );
		 */
		"sWidth": null
	};
	
	_fnHungarianMap( DataTable.defaults.column );
	
	
	
	/**
	 * DataTables settings object - this holds all the information needed for a
	 * given table, including configuration, data and current application of the
	 * table options. DataTables does not have a single instance for each DataTable
	 * with the settings attached to that instance, but rather instances of the
	 * DataTable "class" are created on-the-fly as needed (typically by a
	 * $().dataTable() call) and the settings object is then applied to that
	 * instance.
	 *
	 * Note that this object is related to {@link DataTable.defaults} but this
	 * one is the internal data store for DataTables's cache of columns. It should
	 * NOT be manipulated outside of DataTables. Any configuration should be done
	 * through the initialisation options.
	 *  @namespace
	 *  @todo Really should attach the settings object to individual instances so we
	 *    don't need to create new instances on each $().dataTable() call (if the
	 *    table already exists). It would also save passing oSettings around and
	 *    into every single function. However, this is a very significant
	 *    architecture change for DataTables and will almost certainly break
	 *    backwards compatibility with older installations. This is something that
	 *    will be done in 2.0.
	 */
	DataTable.models.oSettings = {
		/**
		 * Primary features of DataTables and their enablement state.
		 *  @namespace
		 */
		"oFeatures": {
	
			/**
			 * Flag to say if DataTables should automatically try to calculate the
			 * optimum table and columns widths (true) or not (false).
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bAutoWidth": null,
	
			/**
			 * Delay the creation of TR and TD elements until they are actually
			 * needed by a driven page draw. This can give a significant speed
			 * increase for Ajax source and Javascript source data, but makes no
			 * difference at all for DOM and server-side processing tables.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bDeferRender": null,
	
			/**
			 * Enable filtering on the table or not. Note that if this is disabled
			 * then there is no filtering at all on the table, including fnFilter.
			 * To just remove the filtering input use sDom and remove the 'f' option.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bFilter": null,
	
			/**
			 * Table information element (the 'Showing x of y records' div) enable
			 * flag.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bInfo": null,
	
			/**
			 * Present a user control allowing the end user to change the page size
			 * when pagination is enabled.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bLengthChange": null,
	
			/**
			 * Pagination enabled or not. Note that if this is disabled then length
			 * changing must also be disabled.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bPaginate": null,
	
			/**
			 * Processing indicator enable flag whenever DataTables is enacting a
			 * user request - typically an Ajax request for server-side processing.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bProcessing": null,
	
			/**
			 * Server-side processing enabled flag - when enabled DataTables will
			 * get all data from the server for every draw - there is no filtering,
			 * sorting or paging done on the client-side.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bServerSide": null,
	
			/**
			 * Sorting enablement flag.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bSort": null,
	
			/**
			 * Multi-column sorting
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bSortMulti": null,
	
			/**
			 * Apply a class to the columns which are being sorted to provide a
			 * visual highlight or not. This can slow things down when enabled since
			 * there is a lot of DOM interaction.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bSortClasses": null,
	
			/**
			 * State saving enablement flag.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bStateSave": null
		},
	
	
		/**
		 * Scrolling settings for a table.
		 *  @namespace
		 */
		"oScroll": {
			/**
			 * When the table is shorter in height than sScrollY, collapse the
			 * table container down to the height of the table (when true).
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type boolean
			 */
			"bCollapse": null,
	
			/**
			 * Width of the scrollbar for the web-browser's platform. Calculated
			 * during table initialisation.
			 *  @type int
			 *  @default 0
			 */
			"iBarWidth": 0,
	
			/**
			 * Viewport width for horizontal scrolling. Horizontal scrolling is
			 * disabled if an empty string.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 */
			"sX": null,
	
			/**
			 * Width to expand the table to when using x-scrolling. Typically you
			 * should not need to use this.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 *  @deprecated
			 */
			"sXInner": null,
	
			/**
			 * Viewport height for vertical scrolling. Vertical scrolling is disabled
			 * if an empty string.
			 * Note that this parameter will be set by the initialisation routine. To
			 * set a default use {@link DataTable.defaults}.
			 *  @type string
			 */
			"sY": null
		},
	
		/**
		 * Language information for the table.
		 *  @namespace
		 *  @extends DataTable.defaults.oLanguage
		 */
		"oLanguage": {
			/**
			 * Information callback function. See
			 * {@link DataTable.defaults.fnInfoCallback}
			 *  @type function
			 *  @default null
			 */
			"fnInfoCallback": null
		},
	
		/**
		 * Browser support parameters
		 *  @namespace
		 */
		"oBrowser": {
			/**
			 * Indicate if the browser incorrectly calculates width:100% inside a
			 * scrolling element (IE6/7)
			 *  @type boolean
			 *  @default false
			 */
			"bScrollOversize": false,
	
			/**
			 * Determine if the vertical scrollbar is on the right or left of the
			 * scrolling container - needed for rtl language layout, although not
			 * all browsers move the scrollbar (Safari).
			 *  @type boolean
			 *  @default false
			 */
			"bScrollbarLeft": false,
	
			/**
			 * Flag for if `getBoundingClientRect` is fully supported or not
			 *  @type boolean
			 *  @default false
			 */
			"bBounding": false,
	
			/**
			 * Browser scrollbar width
			 *  @type integer
			 *  @default 0
			 */
			"barWidth": 0
		},
	
	
		"ajax": null,
	
	
		/**
		 * Array referencing the nodes which are used for the features. The
		 * parameters of this object match what is allowed by sDom - i.e.
		 *   <ul>
		 *     <li>'l' - Length changing</li>
		 *     <li>'f' - Filtering input</li>
		 *     <li>'t' - The table!</li>
		 *     <li>'i' - Information</li>
		 *     <li>'p' - Pagination</li>
		 *     <li>'r' - pRocessing</li>
		 *   </ul>
		 *  @type array
		 *  @default []
		 */
		"aanFeatures": [],
	
		/**
		 * Store data information - see {@link DataTable.models.oRow} for detailed
		 * information.
		 *  @type array
		 *  @default []
		 */
		"aoData": [],
	
		/**
		 * Array of indexes which are in the current display (after filtering etc)
		 *  @type array
		 *  @default []
		 */
		"aiDisplay": [],
	
		/**
		 * Array of indexes for display - no filtering
		 *  @type array
		 *  @default []
		 */
		"aiDisplayMaster": [],
	
		/**
		 * Map of row ids to data indexes
		 *  @type object
		 *  @default {}
		 */
		"aIds": {},
	
		/**
		 * Store information about each column that is in use
		 *  @type array
		 *  @default []
		 */
		"aoColumns": [],
	
		/**
		 * Store information about the table's header
		 *  @type array
		 *  @default []
		 */
		"aoHeader": [],
	
		/**
		 * Store information about the table's footer
		 *  @type array
		 *  @default []
		 */
		"aoFooter": [],
	
		/**
		 * Store the applied global search information in case we want to force a
		 * research or compare the old search to a new one.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @namespace
		 *  @extends DataTable.models.oSearch
		 */
		"oPreviousSearch": {},
	
		/**
		 * Store the applied search for each column - see
		 * {@link DataTable.models.oSearch} for the format that is used for the
		 * filtering information for each column.
		 *  @type array
		 *  @default []
		 */
		"aoPreSearchCols": [],
	
		/**
		 * Sorting that is applied to the table. Note that the inner arrays are
		 * used in the following manner:
		 * <ul>
		 *   <li>Index 0 - column number</li>
		 *   <li>Index 1 - current sorting direction</li>
		 * </ul>
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type array
		 *  @todo These inner arrays should really be objects
		 */
		"aaSorting": null,
	
		/**
		 * Sorting that is always applied to the table (i.e. prefixed in front of
		 * aaSorting).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type array
		 *  @default []
		 */
		"aaSortingFixed": [],
	
		/**
		 * Classes to use for the striping of a table.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type array
		 *  @default []
		 */
		"asStripeClasses": null,
	
		/**
		 * If restoring a table - we should restore its striping classes as well
		 *  @type array
		 *  @default []
		 */
		"asDestroyStripes": [],
	
		/**
		 * If restoring a table - we should restore its width
		 *  @type int
		 *  @default 0
		 */
		"sDestroyWidth": 0,
	
		/**
		 * Callback functions array for every time a row is inserted (i.e. on a draw).
		 *  @type array
		 *  @default []
		 */
		"aoRowCallback": [],
	
		/**
		 * Callback functions for the header on each draw.
		 *  @type array
		 *  @default []
		 */
		"aoHeaderCallback": [],
	
		/**
		 * Callback function for the footer on each draw.
		 *  @type array
		 *  @default []
		 */
		"aoFooterCallback": [],
	
		/**
		 * Array of callback functions for draw callback functions
		 *  @type array
		 *  @default []
		 */
		"aoDrawCallback": [],
	
		/**
		 * Array of callback functions for row created function
		 *  @type array
		 *  @default []
		 */
		"aoRowCreatedCallback": [],
	
		/**
		 * Callback functions for just before the table is redrawn. A return of
		 * false will be used to cancel the draw.
		 *  @type array
		 *  @default []
		 */
		"aoPreDrawCallback": [],
	
		/**
		 * Callback functions for when the table has been initialised.
		 *  @type array
		 *  @default []
		 */
		"aoInitComplete": [],
	
	
		/**
		 * Callbacks for modifying the settings to be stored for state saving, prior to
		 * saving state.
		 *  @type array
		 *  @default []
		 */
		"aoStateSaveParams": [],
	
		/**
		 * Callbacks for modifying the settings that have been stored for state saving
		 * prior to using the stored values to restore the state.
		 *  @type array
		 *  @default []
		 */
		"aoStateLoadParams": [],
	
		/**
		 * Callbacks for operating on the settings object once the saved state has been
		 * loaded
		 *  @type array
		 *  @default []
		 */
		"aoStateLoaded": [],
	
		/**
		 * Cache the table ID for quick access
		 *  @type string
		 *  @default <i>Empty string</i>
		 */
		"sTableId": "",
	
		/**
		 * The TABLE node for the main table
		 *  @type node
		 *  @default null
		 */
		"nTable": null,
	
		/**
		 * Permanent ref to the thead element
		 *  @type node
		 *  @default null
		 */
		"nTHead": null,
	
		/**
		 * Permanent ref to the tfoot element - if it exists
		 *  @type node
		 *  @default null
		 */
		"nTFoot": null,
	
		/**
		 * Permanent ref to the tbody element
		 *  @type node
		 *  @default null
		 */
		"nTBody": null,
	
		/**
		 * Cache the wrapper node (contains all DataTables controlled elements)
		 *  @type node
		 *  @default null
		 */
		"nTableWrapper": null,
	
		/**
		 * Indicate if when using server-side processing the loading of data
		 * should be deferred until the second draw.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 *  @default false
		 */
		"bDeferLoading": false,
	
		/**
		 * Indicate if all required information has been read in
		 *  @type boolean
		 *  @default false
		 */
		"bInitialised": false,
	
		/**
		 * Information about open rows. Each object in the array has the parameters
		 * 'nTr' and 'nParent'
		 *  @type array
		 *  @default []
		 */
		"aoOpenRows": [],
	
		/**
		 * Dictate the positioning of DataTables' control elements - see
		 * {@link DataTable.model.oInit.sDom}.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 *  @default null
		 */
		"sDom": null,
	
		/**
		 * Search delay (in mS)
		 *  @type integer
		 *  @default null
		 */
		"searchDelay": null,
	
		/**
		 * Which type of pagination should be used.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 *  @default two_button
		 */
		"sPaginationType": "two_button",
	
		/**
		 * The state duration (for `stateSave`) in seconds.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type int
		 *  @default 0
		 */
		"iStateDuration": 0,
	
		/**
		 * Array of callback functions for state saving. Each array element is an
		 * object with the following parameters:
		 *   <ul>
		 *     <li>function:fn - function to call. Takes two parameters, oSettings
		 *       and the JSON string to save that has been thus far created. Returns
		 *       a JSON string to be inserted into a json object
		 *       (i.e. '"param": [ 0, 1, 2]')</li>
		 *     <li>string:sName - name of callback</li>
		 *   </ul>
		 *  @type array
		 *  @default []
		 */
		"aoStateSave": [],
	
		/**
		 * Array of callback functions for state loading. Each array element is an
		 * object with the following parameters:
		 *   <ul>
		 *     <li>function:fn - function to call. Takes two parameters, oSettings
		 *       and the object stored. May return false to cancel state loading</li>
		 *     <li>string:sName - name of callback</li>
		 *   </ul>
		 *  @type array
		 *  @default []
		 */
		"aoStateLoad": [],
	
		/**
		 * State that was saved. Useful for back reference
		 *  @type object
		 *  @default null
		 */
		"oSavedState": null,
	
		/**
		 * State that was loaded. Useful for back reference
		 *  @type object
		 *  @default null
		 */
		"oLoadedState": null,
	
		/**
		 * Source url for AJAX data for the table.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 *  @default null
		 */
		"sAjaxSource": null,
	
		/**
		 * Property from a given object from which to read the table data from. This
		 * can be an empty string (when not server-side processing), in which case
		 * it is  assumed an an array is given directly.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 */
		"sAjaxDataProp": null,
	
		/**
		 * The last jQuery XHR object that was used for server-side data gathering.
		 * This can be used for working with the XHR information in one of the
		 * callbacks
		 *  @type object
		 *  @default null
		 */
		"jqXHR": null,
	
		/**
		 * JSON returned from the server in the last Ajax request
		 *  @type object
		 *  @default undefined
		 */
		"json": undefined,
	
		/**
		 * Data submitted as part of the last Ajax request
		 *  @type object
		 *  @default undefined
		 */
		"oAjaxData": undefined,
	
		/**
		 * Function to get the server-side data.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type function
		 */
		"fnServerData": null,
	
		/**
		 * Functions which are called prior to sending an Ajax request so extra
		 * parameters can easily be sent to the server
		 *  @type array
		 *  @default []
		 */
		"aoServerParams": [],
	
		/**
		 * Send the XHR HTTP method - GET or POST (could be PUT or DELETE if
		 * required).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type string
		 */
		"sServerMethod": null,
	
		/**
		 * Format numbers for display.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type function
		 */
		"fnFormatNumber": null,
	
		/**
		 * List of options that can be used for the user selectable length menu.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type array
		 *  @default []
		 */
		"aLengthMenu": null,
	
		/**
		 * Counter for the draws that the table does. Also used as a tracker for
		 * server-side processing
		 *  @type int
		 *  @default 0
		 */
		"iDraw": 0,
	
		/**
		 * Indicate if a redraw is being done - useful for Ajax
		 *  @type boolean
		 *  @default false
		 */
		"bDrawing": false,
	
		/**
		 * Draw index (iDraw) of the last error when parsing the returned data
		 *  @type int
		 *  @default -1
		 */
		"iDrawError": -1,
	
		/**
		 * Paging display length
		 *  @type int
		 *  @default 10
		 */
		"_iDisplayLength": 10,
	
		/**
		 * Paging start point - aiDisplay index
		 *  @type int
		 *  @default 0
		 */
		"_iDisplayStart": 0,
	
		/**
		 * Server-side processing - number of records in the result set
		 * (i.e. before filtering), Use fnRecordsTotal rather than
		 * this property to get the value of the number of records, regardless of
		 * the server-side processing setting.
		 *  @type int
		 *  @default 0
		 *  @private
		 */
		"_iRecordsTotal": 0,
	
		/**
		 * Server-side processing - number of records in the current display set
		 * (i.e. after filtering). Use fnRecordsDisplay rather than
		 * this property to get the value of the number of records, regardless of
		 * the server-side processing setting.
		 *  @type boolean
		 *  @default 0
		 *  @private
		 */
		"_iRecordsDisplay": 0,
	
		/**
		 * The classes to use for the table
		 *  @type object
		 *  @default {}
		 */
		"oClasses": {},
	
		/**
		 * Flag attached to the settings object so you can check in the draw
		 * callback if filtering has been done in the draw. Deprecated in favour of
		 * events.
		 *  @type boolean
		 *  @default false
		 *  @deprecated
		 */
		"bFiltered": false,
	
		/**
		 * Flag attached to the settings object so you can check in the draw
		 * callback if sorting has been done in the draw. Deprecated in favour of
		 * events.
		 *  @type boolean
		 *  @default false
		 *  @deprecated
		 */
		"bSorted": false,
	
		/**
		 * Indicate that if multiple rows are in the header and there is more than
		 * one unique cell per column, if the top one (true) or bottom one (false)
		 * should be used for sorting / title by DataTables.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @type boolean
		 */
		"bSortCellsTop": null,
	
		/**
		 * Initialisation object that is used for the table
		 *  @type object
		 *  @default null
		 */
		"oInit": null,
	
		/**
		 * Destroy callback functions - for plug-ins to attach themselves to the
		 * destroy so they can clean up markup and events.
		 *  @type array
		 *  @default []
		 */
		"aoDestroyCallback": [],
	
	
		/**
		 * Get the number of records in the current record set, before filtering
		 *  @type function
		 */
		"fnRecordsTotal": function ()
		{
			return _fnDataSource( this ) == 'ssp' ?
				this._iRecordsTotal * 1 :
				this.aiDisplayMaster.length;
		},
	
		/**
		 * Get the number of records in the current record set, after filtering
		 *  @type function
		 */
		"fnRecordsDisplay": function ()
		{
			return _fnDataSource( this ) == 'ssp' ?
				this._iRecordsDisplay * 1 :
				this.aiDisplay.length;
		},
	
		/**
		 * Get the display end point - aiDisplay index
		 *  @type function
		 */
		"fnDisplayEnd": function ()
		{
			var
				len      = this._iDisplayLength,
				start    = this._iDisplayStart,
				calc     = start + len,
				records  = this.aiDisplay.length,
				features = this.oFeatures,
				paginate = features.bPaginate;
	
			if ( features.bServerSide ) {
				return paginate === false || len === -1 ?
					start + records :
					Math.min( start+len, this._iRecordsDisplay );
			}
			else {
				return ! paginate || calc>records || len===-1 ?
					records :
					calc;
			}
		},
	
		/**
		 * The DataTables object for this table
		 *  @type object
		 *  @default null
		 */
		"oInstance": null,
	
		/**
		 * Unique identifier for each instance of the DataTables object. If there
		 * is an ID on the table node, then it takes that value, otherwise an
		 * incrementing internal counter is used.
		 *  @type string
		 *  @default null
		 */
		"sInstance": null,
	
		/**
		 * tabindex attribute value that is added to DataTables control elements, allowing
		 * keyboard navigation of the table and its controls.
		 */
		"iTabIndex": 0,
	
		/**
		 * DIV container for the footer scrolling table if scrolling
		 */
		"nScrollHead": null,
	
		/**
		 * DIV container for the footer scrolling table if scrolling
		 */
		"nScrollFoot": null,
	
		/**
		 * Last applied sort
		 *  @type array
		 *  @default []
		 */
		"aLastSort": [],
	
		/**
		 * Stored plug-in instances
		 *  @type object
		 *  @default {}
		 */
		"oPlugins": {},
	
		/**
		 * Function used to get a row's id from the row's data
		 *  @type function
		 *  @default null
		 */
		"rowIdFn": null,
	
		/**
		 * Data location where to store a row's id
		 *  @type string
		 *  @default null
		 */
		"rowId": null
	};
	
	/**
	 * Extension object for DataTables that is used to provide all extension
	 * options.
	 *
	 * Note that the `DataTable.ext` object is available through
	 * `jQuery.fn.dataTable.ext` where it may be accessed and manipulated. It is
	 * also aliased to `jQuery.fn.dataTableExt` for historic reasons.
	 *  @namespace
	 *  @extends DataTable.models.ext
	 */
	
	
	/**
	 * DataTables extensions
	 * 
	 * This namespace acts as a collection area for plug-ins that can be used to
	 * extend DataTables capabilities. Indeed many of the build in methods
	 * use this method to provide their own capabilities (sorting methods for
	 * example).
	 *
	 * Note that this namespace is aliased to `jQuery.fn.dataTableExt` for legacy
	 * reasons
	 *
	 *  @namespace
	 */
	DataTable.ext = _ext = {
		/**
		 * Buttons. For use with the Buttons extension for DataTables. This is
		 * defined here so other extensions can define buttons regardless of load
		 * order. It is _not_ used by DataTables core.
		 *
		 *  @type object
		 *  @default {}
		 */
		buttons: {},
	
	
		/**
		 * Element class names
		 *
		 *  @type object
		 *  @default {}
		 */
		classes: {},
	
	
		/**
		 * DataTables build type (expanded by the download builder)
		 *
		 *  @type string
		 */
		builder: "-source-",
	
	
		/**
		 * Error reporting.
		 * 
		 * How should DataTables report an error. Can take the value 'alert',
		 * 'throw', 'none' or a function.
		 *
		 *  @type string|function
		 *  @default alert
		 */
		errMode: "alert",
	
	
		/**
		 * Feature plug-ins.
		 * 
		 * This is an array of objects which describe the feature plug-ins that are
		 * available to DataTables. These feature plug-ins are then available for
		 * use through the `dom` initialisation option.
		 * 
		 * Each feature plug-in is described by an object which must have the
		 * following properties:
		 * 
		 * * `fnInit` - function that is used to initialise the plug-in,
		 * * `cFeature` - a character so the feature can be enabled by the `dom`
		 *   instillation option. This is case sensitive.
		 *
		 * The `fnInit` function has the following input parameters:
		 *
		 * 1. `{object}` DataTables settings object: see
		 *    {@link DataTable.models.oSettings}
		 *
		 * And the following return is expected:
		 * 
		 * * {node|null} The element which contains your feature. Note that the
		 *   return may also be void if your plug-in does not require to inject any
		 *   DOM elements into DataTables control (`dom`) - for example this might
		 *   be useful when developing a plug-in which allows table control via
		 *   keyboard entry
		 *
		 *  @type array
		 *
		 *  @example
		 *    $.fn.dataTable.ext.features.push( {
		 *      "fnInit": function( oSettings ) {
		 *        return new TableTools( { "oDTSettings": oSettings } );
		 *      },
		 *      "cFeature": "T"
		 *    } );
		 */
		feature: [],
	
	
		/**
		 * Row searching.
		 * 
		 * This method of searching is complimentary to the default type based
		 * searching, and a lot more comprehensive as it allows you complete control
		 * over the searching logic. Each element in this array is a function
		 * (parameters described below) that is called for every row in the table,
		 * and your logic decides if it should be included in the searching data set
		 * or not.
		 *
		 * Searching functions have the following input parameters:
		 *
		 * 1. `{object}` DataTables settings object: see
		 *    {@link DataTable.models.oSettings}
		 * 2. `{array|object}` Data for the row to be processed (same as the
		 *    original format that was passed in as the data source, or an array
		 *    from a DOM data source
		 * 3. `{int}` Row index ({@link DataTable.models.oSettings.aoData}), which
		 *    can be useful to retrieve the `TR` element if you need DOM interaction.
		 *
		 * And the following return is expected:
		 *
		 * * {boolean} Include the row in the searched result set (true) or not
		 *   (false)
		 *
		 * Note that as with the main search ability in DataTables, technically this
		 * is "filtering", since it is subtractive. However, for consistency in
		 * naming we call it searching here.
		 *
		 *  @type array
		 *  @default []
		 *
		 *  @example
		 *    // The following example shows custom search being applied to the
		 *    // fourth column (i.e. the data[3] index) based on two input values
		 *    // from the end-user, matching the data in a certain range.
		 *    $.fn.dataTable.ext.search.push(
		 *      function( settings, data, dataIndex ) {
		 *        var min = document.getElementById('min').value * 1;
		 *        var max = document.getElementById('max').value * 1;
		 *        var version = data[3] == "-" ? 0 : data[3]*1;
		 *
		 *        if ( min == "" && max == "" ) {
		 *          return true;
		 *        }
		 *        else if ( min == "" && version < max ) {
		 *          return true;
		 *        }
		 *        else if ( min < version && "" == max ) {
		 *          return true;
		 *        }
		 *        else if ( min < version && version < max ) {
		 *          return true;
		 *        }
		 *        return false;
		 *      }
		 *    );
		 */
		search: [],
	
	
		/**
		 * Selector extensions
		 *
		 * The `selector` option can be used to extend the options available for the
		 * selector modifier options (`selector-modifier` object data type) that
		 * each of the three built in selector types offer (row, column and cell +
		 * their plural counterparts). For example the Select extension uses this
		 * mechanism to provide an option to select only rows, columns and cells
		 * that have been marked as selected by the end user (`{selected: true}`),
		 * which can be used in conjunction with the existing built in selector
		 * options.
		 *
		 * Each property is an array to which functions can be pushed. The functions
		 * take three attributes:
		 *
		 * * Settings object for the host table
		 * * Options object (`selector-modifier` object type)
		 * * Array of selected item indexes
		 *
		 * The return is an array of the resulting item indexes after the custom
		 * selector has been applied.
		 *
		 *  @type object
		 */
		selector: {
			cell: [],
			column: [],
			row: []
		},
	
	
		/**
		 * Internal functions, exposed for used in plug-ins.
		 * 
		 * Please note that you should not need to use the internal methods for
		 * anything other than a plug-in (and even then, try to avoid if possible).
		 * The internal function may change between releases.
		 *
		 *  @type object
		 *  @default {}
		 */
		internal: {},
	
	
		/**
		 * Legacy configuration options. Enable and disable legacy options that
		 * are available in DataTables.
		 *
		 *  @type object
		 */
		legacy: {
			/**
			 * Enable / disable DataTables 1.9 compatible server-side processing
			 * requests
			 *
			 *  @type boolean
			 *  @default null
			 */
			ajax: null
		},
	
	
		/**
		 * Pagination plug-in methods.
		 * 
		 * Each entry in this object is a function and defines which buttons should
		 * be shown by the pagination rendering method that is used for the table:
		 * {@link DataTable.ext.renderer.pageButton}. The renderer addresses how the
		 * buttons are displayed in the document, while the functions here tell it
		 * what buttons to display. This is done by returning an array of button
		 * descriptions (what each button will do).
		 *
		 * Pagination types (the four built in options and any additional plug-in
		 * options defined here) can be used through the `paginationType`
		 * initialisation parameter.
		 *
		 * The functions defined take two parameters:
		 *
		 * 1. `{int} page` The current page index
		 * 2. `{int} pages` The number of pages in the table
		 *
		 * Each function is expected to return an array where each element of the
		 * array can be one of:
		 *
		 * * `first` - Jump to first page when activated
		 * * `last` - Jump to last page when activated
		 * * `previous` - Show previous page when activated
		 * * `next` - Show next page when activated
		 * * `{int}` - Show page of the index given
		 * * `{array}` - A nested array containing the above elements to add a
		 *   containing 'DIV' element (might be useful for styling).
		 *
		 * Note that DataTables v1.9- used this object slightly differently whereby
		 * an object with two functions would be defined for each plug-in. That
		 * ability is still supported by DataTables 1.10+ to provide backwards
		 * compatibility, but this option of use is now decremented and no longer
		 * documented in DataTables 1.10+.
		 *
		 *  @type object
		 *  @default {}
		 *
		 *  @example
		 *    // Show previous, next and current page buttons only
		 *    $.fn.dataTableExt.oPagination.current = function ( page, pages ) {
		 *      return [ 'previous', page, 'next' ];
		 *    };
		 */
		pager: {},
	
	
		renderer: {
			pageButton: {},
			header: {}
		},
	
	
		/**
		 * Ordering plug-ins - custom data source
		 * 
		 * The extension options for ordering of data available here is complimentary
		 * to the default type based ordering that DataTables typically uses. It
		 * allows much greater control over the the data that is being used to
		 * order a column, but is necessarily therefore more complex.
		 * 
		 * This type of ordering is useful if you want to do ordering based on data
		 * live from the DOM (for example the contents of an 'input' element) rather
		 * than just the static string that DataTables knows of.
		 * 
		 * The way these plug-ins work is that you create an array of the values you
		 * wish to be ordering for the column in question and then return that
		 * array. The data in the array much be in the index order of the rows in
		 * the table (not the currently ordering order!). Which order data gathering
		 * function is run here depends on the `dt-init columns.orderDataType`
		 * parameter that is used for the column (if any).
		 *
		 * The functions defined take two parameters:
		 *
		 * 1. `{object}` DataTables settings object: see
		 *    {@link DataTable.models.oSettings}
		 * 2. `{int}` Target column index
		 *
		 * Each function is expected to return an array:
		 *
		 * * `{array}` Data for the column to be ordering upon
		 *
		 *  @type array
		 *
		 *  @example
		 *    // Ordering using `input` node values
		 *    $.fn.dataTable.ext.order['dom-text'] = function  ( settings, col )
		 *    {
		 *      return this.api().column( col, {order:'index'} ).nodes().map( function ( td, i ) {
		 *        return $('input', td).val();
		 *      } );
		 *    }
		 */
		order: {},
	
	
		/**
		 * Type based plug-ins.
		 *
		 * Each column in DataTables has a type assigned to it, either by automatic
		 * detection or by direct assignment using the `type` option for the column.
		 * The type of a column will effect how it is ordering and search (plug-ins
		 * can also make use of the column type if required).
		 *
		 * @namespace
		 */
		type: {
			/**
			 * Type detection functions.
			 *
			 * The functions defined in this object are used to automatically detect
			 * a column's type, making initialisation of DataTables super easy, even
			 * when complex data is in the table.
			 *
			 * The functions defined take two parameters:
			 *
		     *  1. `{*}` Data from the column cell to be analysed
		     *  2. `{settings}` DataTables settings object. This can be used to
		     *     perform context specific type detection - for example detection
		     *     based on language settings such as using a comma for a decimal
		     *     place. Generally speaking the options from the settings will not
		     *     be required
			 *
			 * Each function is expected to return:
			 *
			 * * `{string|null}` Data type detected, or null if unknown (and thus
			 *   pass it on to the other type detection functions.
			 *
			 *  @type array
			 *
			 *  @example
			 *    // Currency type detection plug-in:
			 *    $.fn.dataTable.ext.type.detect.push(
			 *      function ( data, settings ) {
			 *        // Check the numeric part
			 *        if ( ! data.substring(1).match(/[0-9]/) ) {
			 *          return null;
			 *        }
			 *
			 *        // Check prefixed by currency
			 *        if ( data.charAt(0) == '$' || data.charAt(0) == '&pound;' ) {
			 *          return 'currency';
			 *        }
			 *        return null;
			 *      }
			 *    );
			 */
			detect: [],
	
	
			/**
			 * Type based search formatting.
			 *
			 * The type based searching functions can be used to pre-format the
			 * data to be search on. For example, it can be used to strip HTML
			 * tags or to de-format telephone numbers for numeric only searching.
			 *
			 * Note that is a search is not defined for a column of a given type,
			 * no search formatting will be performed.
			 * 
			 * Pre-processing of searching data plug-ins - When you assign the sType
			 * for a column (or have it automatically detected for you by DataTables
			 * or a type detection plug-in), you will typically be using this for
			 * custom sorting, but it can also be used to provide custom searching
			 * by allowing you to pre-processing the data and returning the data in
			 * the format that should be searched upon. This is done by adding
			 * functions this object with a parameter name which matches the sType
			 * for that target column. This is the corollary of <i>afnSortData</i>
			 * for searching data.
			 *
			 * The functions defined take a single parameter:
			 *
		     *  1. `{*}` Data from the column cell to be prepared for searching
			 *
			 * Each function is expected to return:
			 *
			 * * `{string|null}` Formatted string that will be used for the searching.
			 *
			 *  @type object
			 *  @default {}
			 *
			 *  @example
			 *    $.fn.dataTable.ext.type.search['title-numeric'] = function ( d ) {
			 *      return d.replace(/\n/g," ").replace( /<.*?>/g, "" );
			 *    }
			 */
			search: {},
	
	
			/**
			 * Type based ordering.
			 *
			 * The column type tells DataTables what ordering to apply to the table
			 * when a column is sorted upon. The order for each type that is defined,
			 * is defined by the functions available in this object.
			 *
			 * Each ordering option can be described by three properties added to
			 * this object:
			 *
			 * * `{type}-pre` - Pre-formatting function
			 * * `{type}-asc` - Ascending order function
			 * * `{type}-desc` - Descending order function
			 *
			 * All three can be used together, only `{type}-pre` or only
			 * `{type}-asc` and `{type}-desc` together. It is generally recommended
			 * that only `{type}-pre` is used, as this provides the optimal
			 * implementation in terms of speed, although the others are provided
			 * for compatibility with existing Javascript sort functions.
			 *
			 * `{type}-pre`: Functions defined take a single parameter:
			 *
		     *  1. `{*}` Data from the column cell to be prepared for ordering
			 *
			 * And return:
			 *
			 * * `{*}` Data to be sorted upon
			 *
			 * `{type}-asc` and `{type}-desc`: Functions are typical Javascript sort
			 * functions, taking two parameters:
			 *
		     *  1. `{*}` Data to compare to the second parameter
		     *  2. `{*}` Data to compare to the first parameter
			 *
			 * And returning:
			 *
			 * * `{*}` Ordering match: <0 if first parameter should be sorted lower
			 *   than the second parameter, ===0 if the two parameters are equal and
			 *   >0 if the first parameter should be sorted height than the second
			 *   parameter.
			 * 
			 *  @type object
			 *  @default {}
			 *
			 *  @example
			 *    // Numeric ordering of formatted numbers with a pre-formatter
			 *    $.extend( $.fn.dataTable.ext.type.order, {
			 *      "string-pre": function(x) {
			 *        a = (a === "-" || a === "") ? 0 : a.replace( /[^\d\-\.]/g, "" );
			 *        return parseFloat( a );
			 *      }
			 *    } );
			 *
			 *  @example
			 *    // Case-sensitive string ordering, with no pre-formatting method
			 *    $.extend( $.fn.dataTable.ext.order, {
			 *      "string-case-asc": function(x,y) {
			 *        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
			 *      },
			 *      "string-case-desc": function(x,y) {
			 *        return ((x < y) ? 1 : ((x > y) ? -1 : 0));
			 *      }
			 *    } );
			 */
			order: {}
		},
	
		/**
		 * Unique DataTables instance counter
		 *
		 * @type int
		 * @private
		 */
		_unique: 0,
	
	
		//
		// Depreciated
		// The following properties are retained for backwards compatibility only.
		// The should not be used in new projects and will be removed in a future
		// version
		//
	
		/**
		 * Version check function.
		 *  @type function
		 *  @depreciated Since 1.10
		 */
		fnVersionCheck: DataTable.fnVersionCheck,
	
	
		/**
		 * Index for what 'this' index API functions should use
		 *  @type int
		 *  @deprecated Since v1.10
		 */
		iApiIndex: 0,
	
	
		/**
		 * jQuery UI class container
		 *  @type object
		 *  @deprecated Since v1.10
		 */
		oJUIClasses: {},
	
	
		/**
		 * Software version
		 *  @type string
		 *  @deprecated Since v1.10
		 */
		sVersion: DataTable.version
	};
	
	
	//
	// Backwards compatibility. Alias to pre 1.10 Hungarian notation counter parts
	//
	$.extend( _ext, {
		afnFiltering: _ext.search,
		aTypes:       _ext.type.detect,
		ofnSearch:    _ext.type.search,
		oSort:        _ext.type.order,
		afnSortData:  _ext.order,
		aoFeatures:   _ext.feature,
		oApi:         _ext.internal,
		oStdClasses:  _ext.classes,
		oPagination:  _ext.pager
	} );
	
	
	$.extend( DataTable.ext.classes, {
		"sTable": "dataTable",
		"sNoFooter": "no-footer",
	
		/* Paging buttons */
		"sPageButton": "paginate_button",
		"sPageButtonActive": "current",
		"sPageButtonDisabled": "disabled",
	
		/* Striping classes */
		"sStripeOdd": "odd",
		"sStripeEven": "even",
	
		/* Empty row */
		"sRowEmpty": "dataTables_empty",
	
		/* Features */
		"sWrapper": "dataTables_wrapper",
		"sFilter": "dataTables_filter",
		"sInfo": "dataTables_info",
		"sPaging": "dataTables_paginate paging_", /* Note that the type is postfixed */
		"sLength": "dataTables_length",
		"sProcessing": "dataTables_processing",
	
		/* Sorting */
		"sSortAsc": "sorting_asc",
		"sSortDesc": "sorting_desc",
		"sSortable": "sorting", /* Sortable in both directions */
		"sSortableAsc": "sorting_desc_disabled",
		"sSortableDesc": "sorting_asc_disabled",
		"sSortableNone": "sorting_disabled",
		"sSortColumn": "sorting_", /* Note that an int is postfixed for the sorting order */
	
		/* Filtering */
		"sFilterInput": "",
	
		/* Page length */
		"sLengthSelect": "",
	
		/* Scrolling */
		"sScrollWrapper": "dataTables_scroll",
		"sScrollHead": "dataTables_scrollHead",
		"sScrollHeadInner": "dataTables_scrollHeadInner",
		"sScrollBody": "dataTables_scrollBody",
		"sScrollFoot": "dataTables_scrollFoot",
		"sScrollFootInner": "dataTables_scrollFootInner",
	
		/* Misc */
		"sHeaderTH": "",
		"sFooterTH": "",
	
		// Deprecated
		"sSortJUIAsc": "",
		"sSortJUIDesc": "",
		"sSortJUI": "",
		"sSortJUIAscAllowed": "",
		"sSortJUIDescAllowed": "",
		"sSortJUIWrapper": "",
		"sSortIcon": "",
		"sJUIHeader": "",
		"sJUIFooter": ""
	} );
	
	
	var extPagination = DataTable.ext.pager;
	
	function _numbers ( page, pages ) {
		var
			numbers = [],
			buttons = extPagination.numbers_length,
			half = Math.floor( buttons / 2 ),
			i = 1;
	
		if ( pages <= buttons ) {
			numbers = _range( 0, pages );
		}
		else if ( page <= half ) {
			numbers = _range( 0, buttons-2 );
			numbers.push( 'ellipsis' );
			numbers.push( pages-1 );
		}
		else if ( page >= pages - 1 - half ) {
			numbers = _range( pages-(buttons-2), pages );
			numbers.splice( 0, 0, 'ellipsis' ); // no unshift in ie6
			numbers.splice( 0, 0, 0 );
		}
		else {
			numbers = _range( page-half+2, page+half-1 );
			numbers.push( 'ellipsis' );
			numbers.push( pages-1 );
			numbers.splice( 0, 0, 'ellipsis' );
			numbers.splice( 0, 0, 0 );
		}
	
		numbers.DT_el = 'span';
		return numbers;
	}
	
	
	$.extend( extPagination, {
		simple: function ( page, pages ) {
			return [ 'previous', 'next' ];
		},
	
		full: function ( page, pages ) {
			return [  'first', 'previous', 'next', 'last' ];
		},
	
		numbers: function ( page, pages ) {
			return [ _numbers(page, pages) ];
		},
	
		simple_numbers: function ( page, pages ) {
			return [ 'previous', _numbers(page, pages), 'next' ];
		},
	
		full_numbers: function ( page, pages ) {
			return [ 'first', 'previous', _numbers(page, pages), 'next', 'last' ];
		},
		
		first_last_numbers: function (page, pages) {
	 		return ['first', _numbers(page, pages), 'last'];
	 	},
	
		// For testing and plug-ins to use
		_numbers: _numbers,
	
		// Number of number buttons (including ellipsis) to show. _Must be odd!_
		numbers_length: 7
	} );
	
	
	$.extend( true, DataTable.ext.renderer, {
		pageButton: {
			_: function ( settings, host, idx, buttons, page, pages ) {
				var classes = settings.oClasses;
				var lang = settings.oLanguage.oPaginate;
				var aria = settings.oLanguage.oAria.paginate || {};
				var btnDisplay, btnClass;
	
				var attach = function( container, buttons ) {
					var i, ien, node, button;
					var disabledClass = classes.sPageButtonDisabled;
					var clickHandler = function ( e ) {
						_fnPageChange( settings, e.data.action, true );
					};
	
					for ( i=0, ien=buttons.length ; i<ien ; i++ ) {
						button = buttons[i];
	
						if ( Array.isArray( button ) ) {
							var inner = $( '<'+(button.DT_el || 'div')+'/>' )
								.appendTo( container );
							attach( inner, button );
						}
						else {
							var disabled = false;
	
							btnDisplay = null;
							btnClass = button;
	
							switch ( button ) {
								case 'ellipsis':
									container.append('<span class="ellipsis">&#x2026;</span>');
									break;
	
								case 'first':
									btnDisplay = lang.sFirst;
	
									if ( page === 0 ) {
										disabled = true;
									}
									break;
	
								case 'previous':
									btnDisplay = lang.sPrevious;
	
									if ( page === 0 ) {
										disabled = true;
									}
									break;
	
								case 'next':
									btnDisplay = lang.sNext;
	
									if ( pages === 0 || page === pages-1 ) {
										disabled = true;
									}
									break;
	
								case 'last':
									btnDisplay = lang.sLast;
	
									if ( pages === 0 || page === pages-1 ) {
										disabled = true;
									}
									break;
	
								default:
									btnDisplay = settings.fnFormatNumber( button + 1 );
									btnClass = page === button ?
										classes.sPageButtonActive : '';
									break;
							}
	
							if ( btnDisplay !== null ) {
								var tag = settings.oInit.pagingTag || 'a';
	
								if (disabled) {
									btnClass += ' ' + disabledClass;
								}
	
								node = $('<'+tag+'>', {
										'class': classes.sPageButton+' '+btnClass,
										'aria-controls': settings.sTableId,
										'aria-disabled': disabled ? 'true' : null,
										'aria-label': aria[ button ],
										'role': 'link',
										'aria-current': btnClass === classes.sPageButtonActive ? 'page' : null,
										'data-dt-idx': button,
										'tabindex': disabled ? -1 : settings.iTabIndex,
										'id': idx === 0 && typeof button === 'string' ?
											settings.sTableId +'_'+ button :
											null
									} )
									.html( btnDisplay )
									.appendTo( container );
	
								_fnBindAction(
									node, {action: button}, clickHandler
								);
							}
						}
					}
				};
	
				// IE9 throws an 'unknown error' if document.activeElement is used
				// inside an iframe or frame. Try / catch the error. Not good for
				// accessibility, but neither are frames.
				var activeEl;
	
				try {
					// Because this approach is destroying and recreating the paging
					// elements, focus is lost on the select button which is bad for
					// accessibility. So we want to restore focus once the draw has
					// completed
					activeEl = $(host).find(document.activeElement).data('dt-idx');
				}
				catch (e) {}
	
				attach( $(host).empty(), buttons );
	
				if ( activeEl !== undefined ) {
					$(host).find( '[data-dt-idx='+activeEl+']' ).trigger('focus');
				}
			}
		}
	} );
	
	
	
	// Built in type detection. See model.ext.aTypes for information about
	// what is required from this methods.
	$.extend( DataTable.ext.type.detect, [
		// Plain numbers - first since V8 detects some plain numbers as dates
		// e.g. Date.parse('55') (but not all, e.g. Date.parse('22')...).
		function ( d, settings )
		{
			var decimal = settings.oLanguage.sDecimal;
			return _isNumber( d, decimal ) ? 'num'+decimal : null;
		},
	
		// Dates (only those recognised by the browser's Date.parse)
		function ( d, settings )
		{
			// V8 tries _very_ hard to make a string passed into `Date.parse()`
			// valid, so we need to use a regex to restrict date formats. Use a
			// plug-in for anything other than ISO8601 style strings
			if ( d && !(d instanceof Date) && ! _re_date.test(d) ) {
				return null;
			}
			var parsed = Date.parse(d);
			return (parsed !== null && !isNaN(parsed)) || _empty(d) ? 'date' : null;
		},
	
		// Formatted numbers
		function ( d, settings )
		{
			var decimal = settings.oLanguage.sDecimal;
			return _isNumber( d, decimal, true ) ? 'num-fmt'+decimal : null;
		},
	
		// HTML numeric
		function ( d, settings )
		{
			var decimal = settings.oLanguage.sDecimal;
			return _htmlNumeric( d, decimal ) ? 'html-num'+decimal : null;
		},
	
		// HTML numeric, formatted
		function ( d, settings )
		{
			var decimal = settings.oLanguage.sDecimal;
			return _htmlNumeric( d, decimal, true ) ? 'html-num-fmt'+decimal : null;
		},
	
		// HTML (this is strict checking - there must be html)
		function ( d, settings )
		{
			return _empty( d ) || (typeof d === 'string' && d.indexOf('<') !== -1) ?
				'html' : null;
		}
	] );
	
	
	
	// Filter formatting functions. See model.ext.ofnSearch for information about
	// what is required from these methods.
	// 
	// Note that additional search methods are added for the html numbers and
	// html formatted numbers by `_addNumericSort()` when we know what the decimal
	// place is
	
	
	$.extend( DataTable.ext.type.search, {
		html: function ( data ) {
			return _empty(data) ?
				data :
				typeof data === 'string' ?
					data
						.replace( _re_new_lines, " " )
						.replace( _re_html, "" ) :
					'';
		},
	
		string: function ( data ) {
			return _empty(data) ?
				data :
				typeof data === 'string' ?
					data.replace( _re_new_lines, " " ) :
					data;
		}
	} );
	
	
	
	var __numericReplace = function ( d, decimalPlace, re1, re2 ) {
		if ( d !== 0 && (!d || d === '-') ) {
			return -Infinity;
		}
		
		var type = typeof d;
	
		if (type === 'number' || type === 'bigint') {
			return d;
		}
	
		// If a decimal place other than `.` is used, it needs to be given to the
		// function so we can detect it and replace with a `.` which is the only
		// decimal place Javascript recognises - it is not locale aware.
		if ( decimalPlace ) {
			d = _numToDecimal( d, decimalPlace );
		}
	
		if ( d.replace ) {
			if ( re1 ) {
				d = d.replace( re1, '' );
			}
	
			if ( re2 ) {
				d = d.replace( re2, '' );
			}
		}
	
		return d * 1;
	};
	
	
	// Add the numeric 'deformatting' functions for sorting and search. This is done
	// in a function to provide an easy ability for the language options to add
	// additional methods if a non-period decimal place is used.
	function _addNumericSort ( decimalPlace ) {
		$.each(
			{
				// Plain numbers
				"num": function ( d ) {
					return __numericReplace( d, decimalPlace );
				},
	
				// Formatted numbers
				"num-fmt": function ( d ) {
					return __numericReplace( d, decimalPlace, _re_formatted_numeric );
				},
	
				// HTML numeric
				"html-num": function ( d ) {
					return __numericReplace( d, decimalPlace, _re_html );
				},
	
				// HTML numeric, formatted
				"html-num-fmt": function ( d ) {
					return __numericReplace( d, decimalPlace, _re_html, _re_formatted_numeric );
				}
			},
			function ( key, fn ) {
				// Add the ordering method
				_ext.type.order[ key+decimalPlace+'-pre' ] = fn;
	
				// For HTML types add a search formatter that will strip the HTML
				if ( key.match(/^html\-/) ) {
					_ext.type.search[ key+decimalPlace ] = _ext.type.search.html;
				}
			}
		);
	}
	
	
	// Default sort methods
	$.extend( _ext.type.order, {
		// Dates
		"date-pre": function ( d ) {
			var ts = Date.parse( d );
			return isNaN(ts) ? -Infinity : ts;
		},
	
		// html
		"html-pre": function ( a ) {
			return _empty(a) ?
				'' :
				a.replace ?
					a.replace( /<.*?>/g, "" ).toLowerCase() :
					a+'';
		},
	
		// string
		"string-pre": function ( a ) {
			// This is a little complex, but faster than always calling toString,
			// https://jsperf.com/tostring-v-check
			return _empty(a) ?
				'' :
				typeof a === 'string' ?
					a.toLowerCase() :
					! a.toString ?
						'' :
						a.toString();
		},
	
		// string-asc and -desc are retained only for compatibility with the old
		// sort methods
		"string-asc": function ( x, y ) {
			return ((x < y) ? -1 : ((x > y) ? 1 : 0));
		},
	
		"string-desc": function ( x, y ) {
			return ((x < y) ? 1 : ((x > y) ? -1 : 0));
		}
	} );
	
	
	// Numeric sorting types - order doesn't matter here
	_addNumericSort( '' );
	
	
	$.extend( true, DataTable.ext.renderer, {
		header: {
			_: function ( settings, cell, column, classes ) {
				// No additional mark-up required
				// Attach a sort listener to update on sort - note that using the
				// `DT` namespace will allow the event to be removed automatically
				// on destroy, while the `dt` namespaced event is the one we are
				// listening for
				$(settings.nTable).on( 'order.dt.DT', function ( e, ctx, sorting, columns ) {
					if ( settings !== ctx ) { // need to check this this is the host
						return;               // table, not a nested one
					}
	
					var colIdx = column.idx;
	
					cell
						.removeClass(
							classes.sSortAsc +' '+
							classes.sSortDesc
						)
						.addClass( columns[ colIdx ] == 'asc' ?
							classes.sSortAsc : columns[ colIdx ] == 'desc' ?
								classes.sSortDesc :
								column.sSortingClass
						);
				} );
			},
	
			jqueryui: function ( settings, cell, column, classes ) {
				$('<div/>')
					.addClass( classes.sSortJUIWrapper )
					.append( cell.contents() )
					.append( $('<span/>')
						.addClass( classes.sSortIcon+' '+column.sSortingClassJUI )
					)
					.appendTo( cell );
	
				// Attach a sort listener to update on sort
				$(settings.nTable).on( 'order.dt.DT', function ( e, ctx, sorting, columns ) {
					if ( settings !== ctx ) {
						return;
					}
	
					var colIdx = column.idx;
	
					cell
						.removeClass( classes.sSortAsc +" "+classes.sSortDesc )
						.addClass( columns[ colIdx ] == 'asc' ?
							classes.sSortAsc : columns[ colIdx ] == 'desc' ?
								classes.sSortDesc :
								column.sSortingClass
						);
	
					cell
						.find( 'span.'+classes.sSortIcon )
						.removeClass(
							classes.sSortJUIAsc +" "+
							classes.sSortJUIDesc +" "+
							classes.sSortJUI +" "+
							classes.sSortJUIAscAllowed +" "+
							classes.sSortJUIDescAllowed
						)
						.addClass( columns[ colIdx ] == 'asc' ?
							classes.sSortJUIAsc : columns[ colIdx ] == 'desc' ?
								classes.sSortJUIDesc :
								column.sSortingClassJUI
						);
				} );
			}
		}
	} );
	
	/*
	 * Public helper functions. These aren't used internally by DataTables, or
	 * called by any of the options passed into DataTables, but they can be used
	 * externally by developers working with DataTables. They are helper functions
	 * to make working with DataTables a little bit easier.
	 */
	
	var __htmlEscapeEntities = function ( d ) {
		if (Array.isArray(d)) {
			d = d.join(',');
		}
	
		return typeof d === 'string' ?
			d
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;') :
			d;
	};
	
	// Common logic for moment, luxon or a date action
	function __mld( dt, momentFn, luxonFn, dateFn, arg1 ) {
		if (window.moment) {
			return dt[momentFn]( arg1 );
		}
		else if (window.luxon) {
			return dt[luxonFn]( arg1 );
		}
		
		return dateFn ? dt[dateFn]( arg1 ) : dt;
	}
	
	
	var __mlWarning = false;
	function __mldObj (d, format, locale) {
		var dt;
	
		if (window.moment) {
			dt = window.moment.utc( d, format, locale, true );
	
			if (! dt.isValid()) {
				return null;
			}
		}
		else if (window.luxon) {
			dt = format && typeof d === 'string'
				? window.luxon.DateTime.fromFormat( d, format )
				: window.luxon.DateTime.fromISO( d );
	
			if (! dt.isValid) {
				return null;
			}
	
			dt.setLocale(locale);
		}
		else if (! format) {
			// No format given, must be ISO
			dt = new Date(d);
		}
		else {
			if (! __mlWarning) {
				alert('DataTables warning: Formatted date without Moment.js or Luxon - https://datatables.net/tn/17');
			}
	
			__mlWarning = true;
		}
	
		return dt;
	}
	
	// Wrapper for date, datetime and time which all operate the same way with the exception of
	// the output string for auto locale support
	function __mlHelper (localeString) {
		return function ( from, to, locale, def ) {
			// Luxon and Moment support
			// Argument shifting
			if ( arguments.length === 0 ) {
				locale = 'en';
				to = null; // means toLocaleString
				from = null; // means iso8601
			}
			else if ( arguments.length === 1 ) {
				locale = 'en';
				to = from;
				from = null;
			}
			else if ( arguments.length === 2 ) {
				locale = to;
				to = from;
				from = null;
			}
	
			var typeName = 'datetime-' + to;
	
			// Add type detection and sorting specific to this date format - we need to be able to identify
			// date type columns as such, rather than as numbers in extensions. Hence the need for this.
			if (! DataTable.ext.type.order[typeName]) {
				// The renderer will give the value to type detect as the type!
				DataTable.ext.type.detect.unshift(function (d) {
					return d === typeName ? typeName : false;
				});
	
				// The renderer gives us Moment, Luxon or Date obects for the sorting, all of which have a
				// `valueOf` which gives milliseconds epoch
				DataTable.ext.type.order[typeName + '-asc'] = function (a, b) {
					var x = a.valueOf();
					var y = b.valueOf();
	
					return x === y
						? 0
						: x < y
							? -1
							: 1;
				}
	
				DataTable.ext.type.order[typeName + '-desc'] = function (a, b) {
					var x = a.valueOf();
					var y = b.valueOf();
	
					return x === y
						? 0
						: x > y
							? -1
							: 1;
				}
			}
		
			return function ( d, type ) {
				// Allow for a default value
				if (d === null || d === undefined) {
					if (def === '--now') {
						// We treat everything as UTC further down, so no changes are
						// made, as such need to get the local date / time as if it were
						// UTC
						var local = new Date();
						d = new Date( Date.UTC(
							local.getFullYear(), local.getMonth(), local.getDate(),
							local.getHours(), local.getMinutes(), local.getSeconds()
						) );
					}
					else {
						d = '';
					}
				}
	
				if (type === 'type') {
					// Typing uses the type name for fast matching
					return typeName;
				}
	
				if (d === '') {
					return type !== 'sort'
						? ''
						: __mldObj('0000-01-01 00:00:00', null, locale);
				}
	
				// Shortcut. If `from` and `to` are the same, we are using the renderer to
				// format for ordering, not display - its already in the display format.
				if ( to !== null && from === to && type !== 'sort' && type !== 'type' && ! (d instanceof Date) ) {
					return d;
				}
	
				var dt = __mldObj(d, from, locale);
	
				if (dt === null) {
					return d;
				}
	
				if (type === 'sort') {
					return dt;
				}
				
				var formatted = to === null
					? __mld(dt, 'toDate', 'toJSDate', '')[localeString]()
					: __mld(dt, 'format', 'toFormat', 'toISOString', to);
	
				// XSS protection
				return type === 'display' ?
					__htmlEscapeEntities( formatted ) :
					formatted;
			};
		}
	}
	
	// Based on locale, determine standard number formatting
	// Fallback for legacy browsers is US English
	var __thousands = ',';
	var __decimal = '.';
	
	if (window.Intl !== undefined) {
		try {
			var num = new Intl.NumberFormat().formatToParts(100000.1);
		
			for (var i=0 ; i<num.length ; i++) {
				if (num[i].type === 'group') {
					__thousands = num[i].value;
				}
				else if (num[i].type === 'decimal') {
					__decimal = num[i].value;
				}
			}
		}
		catch (e) {
			// noop
		}
	}
	
	// Formatted date time detection - use by declaring the formats you are going to use
	DataTable.datetime = function ( format, locale ) {
		var typeName = 'datetime-detect-' + format;
	
		if (! locale) {
			locale = 'en';
		}
	
		if (! DataTable.ext.type.order[typeName]) {
			DataTable.ext.type.detect.unshift(function (d) {
				var dt = __mldObj(d, format, locale);
				return d === '' || dt ? typeName : false;
			});
	
			DataTable.ext.type.order[typeName + '-pre'] = function (d) {
				return __mldObj(d, format, locale) || 0;
			}
		}
	}
	
	/**
	 * Helpers for `columns.render`.
	 *
	 * The options defined here can be used with the `columns.render` initialisation
	 * option to provide a display renderer. The following functions are defined:
	 *
	 * * `number` - Will format numeric data (defined by `columns.data`) for
	 *   display, retaining the original unformatted data for sorting and filtering.
	 *   It takes 5 parameters:
	 *   * `string` - Thousands grouping separator
	 *   * `string` - Decimal point indicator
	 *   * `integer` - Number of decimal points to show
	 *   * `string` (optional) - Prefix.
	 *   * `string` (optional) - Postfix (/suffix).
	 * * `text` - Escape HTML to help prevent XSS attacks. It has no optional
	 *   parameters.
	 *
	 * @example
	 *   // Column definition using the number renderer
	 *   {
	 *     data: "salary",
	 *     render: $.fn.dataTable.render.number( '\'', '.', 0, '$' )
	 *   }
	 *
	 * @namespace
	 */
	DataTable.render = {
		date: __mlHelper('toLocaleDateString'),
		datetime: __mlHelper('toLocaleString'),
		time: __mlHelper('toLocaleTimeString'),
		number: function ( thousands, decimal, precision, prefix, postfix ) {
			// Auto locale detection
			if (thousands === null || thousands === undefined) {
				thousands = __thousands;
			}
	
			if (decimal === null || decimal === undefined) {
				decimal = __decimal;
			}
	
			return {
				display: function ( d ) {
					if ( typeof d !== 'number' && typeof d !== 'string' ) {
						return d;
					}
	
					if (d === '' || d === null) {
						return d;
					}
	
					var negative = d < 0 ? '-' : '';
					var flo = parseFloat( d );
	
					// If NaN then there isn't much formatting that we can do - just
					// return immediately, escaping any HTML (this was supposed to
					// be a number after all)
					if ( isNaN( flo ) ) {
						return __htmlEscapeEntities( d );
					}
	
					flo = flo.toFixed( precision );
					d = Math.abs( flo );
	
					var intPart = parseInt( d, 10 );
					var floatPart = precision ?
						decimal+(d - intPart).toFixed( precision ).substring( 2 ):
						'';
	
					// If zero, then can't have a negative prefix
					if (intPart === 0 && parseFloat(floatPart) === 0) {
						negative = '';
					}
	
					return negative + (prefix||'') +
						intPart.toString().replace(
							/\B(?=(\d{3})+(?!\d))/g, thousands
						) +
						floatPart +
						(postfix||'');
				}
			};
		},
	
		text: function () {
			return {
				display: __htmlEscapeEntities,
				filter: __htmlEscapeEntities
			};
		}
	};
	
	
	/*
	 * This is really a good bit rubbish this method of exposing the internal methods
	 * publicly... - To be fixed in 2.0 using methods on the prototype
	 */
	
	
	/**
	 * Create a wrapper function for exporting an internal functions to an external API.
	 *  @param {string} fn API function name
	 *  @returns {function} wrapped function
	 *  @memberof DataTable#internal
	 */
	function _fnExternApiFunc (fn)
	{
		return function() {
			var args = [_fnSettingsFromNode( this[DataTable.ext.iApiIndex] )].concat(
				Array.prototype.slice.call(arguments)
			);
			return DataTable.ext.internal[fn].apply( this, args );
		};
	}
	
	
	/**
	 * Reference to internal functions for use by plug-in developers. Note that
	 * these methods are references to internal functions and are considered to be
	 * private. If you use these methods, be aware that they are liable to change
	 * between versions.
	 *  @namespace
	 */
	$.extend( DataTable.ext.internal, {
		_fnExternApiFunc: _fnExternApiFunc,
		_fnBuildAjax: _fnBuildAjax,
		_fnAjaxUpdate: _fnAjaxUpdate,
		_fnAjaxParameters: _fnAjaxParameters,
		_fnAjaxUpdateDraw: _fnAjaxUpdateDraw,
		_fnAjaxDataSrc: _fnAjaxDataSrc,
		_fnAddColumn: _fnAddColumn,
		_fnColumnOptions: _fnColumnOptions,
		_fnAdjustColumnSizing: _fnAdjustColumnSizing,
		_fnVisibleToColumnIndex: _fnVisibleToColumnIndex,
		_fnColumnIndexToVisible: _fnColumnIndexToVisible,
		_fnVisbleColumns: _fnVisbleColumns,
		_fnGetColumns: _fnGetColumns,
		_fnColumnTypes: _fnColumnTypes,
		_fnApplyColumnDefs: _fnApplyColumnDefs,
		_fnHungarianMap: _fnHungarianMap,
		_fnCamelToHungarian: _fnCamelToHungarian,
		_fnLanguageCompat: _fnLanguageCompat,
		_fnBrowserDetect: _fnBrowserDetect,
		_fnAddData: _fnAddData,
		_fnAddTr: _fnAddTr,
		_fnNodeToDataIndex: _fnNodeToDataIndex,
		_fnNodeToColumnIndex: _fnNodeToColumnIndex,
		_fnGetCellData: _fnGetCellData,
		_fnSetCellData: _fnSetCellData,
		_fnSplitObjNotation: _fnSplitObjNotation,
		_fnGetObjectDataFn: _fnGetObjectDataFn,
		_fnSetObjectDataFn: _fnSetObjectDataFn,
		_fnGetDataMaster: _fnGetDataMaster,
		_fnClearTable: _fnClearTable,
		_fnDeleteIndex: _fnDeleteIndex,
		_fnInvalidate: _fnInvalidate,
		_fnGetRowElements: _fnGetRowElements,
		_fnCreateTr: _fnCreateTr,
		_fnBuildHead: _fnBuildHead,
		_fnDrawHead: _fnDrawHead,
		_fnDraw: _fnDraw,
		_fnReDraw: _fnReDraw,
		_fnAddOptionsHtml: _fnAddOptionsHtml,
		_fnDetectHeader: _fnDetectHeader,
		_fnGetUniqueThs: _fnGetUniqueThs,
		_fnFeatureHtmlFilter: _fnFeatureHtmlFilter,
		_fnFilterComplete: _fnFilterComplete,
		_fnFilterCustom: _fnFilterCustom,
		_fnFilterColumn: _fnFilterColumn,
		_fnFilter: _fnFilter,
		_fnFilterCreateSearch: _fnFilterCreateSearch,
		_fnEscapeRegex: _fnEscapeRegex,
		_fnFilterData: _fnFilterData,
		_fnFeatureHtmlInfo: _fnFeatureHtmlInfo,
		_fnUpdateInfo: _fnUpdateInfo,
		_fnInfoMacros: _fnInfoMacros,
		_fnInitialise: _fnInitialise,
		_fnInitComplete: _fnInitComplete,
		_fnLengthChange: _fnLengthChange,
		_fnFeatureHtmlLength: _fnFeatureHtmlLength,
		_fnFeatureHtmlPaginate: _fnFeatureHtmlPaginate,
		_fnPageChange: _fnPageChange,
		_fnFeatureHtmlProcessing: _fnFeatureHtmlProcessing,
		_fnProcessingDisplay: _fnProcessingDisplay,
		_fnFeatureHtmlTable: _fnFeatureHtmlTable,
		_fnScrollDraw: _fnScrollDraw,
		_fnApplyToChildren: _fnApplyToChildren,
		_fnCalculateColumnWidths: _fnCalculateColumnWidths,
		_fnThrottle: _fnThrottle,
		_fnConvertToWidth: _fnConvertToWidth,
		_fnGetWidestNode: _fnGetWidestNode,
		_fnGetMaxLenString: _fnGetMaxLenString,
		_fnStringToCss: _fnStringToCss,
		_fnSortFlatten: _fnSortFlatten,
		_fnSort: _fnSort,
		_fnSortAria: _fnSortAria,
		_fnSortListener: _fnSortListener,
		_fnSortAttachListener: _fnSortAttachListener,
		_fnSortingClasses: _fnSortingClasses,
		_fnSortData: _fnSortData,
		_fnSaveState: _fnSaveState,
		_fnLoadState: _fnLoadState,
		_fnImplementState: _fnImplementState,
		_fnSettingsFromNode: _fnSettingsFromNode,
		_fnLog: _fnLog,
		_fnMap: _fnMap,
		_fnBindAction: _fnBindAction,
		_fnCallbackReg: _fnCallbackReg,
		_fnCallbackFire: _fnCallbackFire,
		_fnLengthOverflow: _fnLengthOverflow,
		_fnRenderer: _fnRenderer,
		_fnDataSource: _fnDataSource,
		_fnRowAttributes: _fnRowAttributes,
		_fnExtend: _fnExtend,
		_fnCalculateEnd: function () {} // Used by a lot of plug-ins, but redundant
		                                // in 1.10, so this dead-end function is
		                                // added to prevent errors
	} );
	
	
	// jQuery access
	$.fn.dataTable = DataTable;
	
	// Provide access to the host jQuery object (circular reference)
	DataTable.$ = $;
	
	// Legacy aliases
	$.fn.dataTableSettings = DataTable.settings;
	$.fn.dataTableExt = DataTable.ext;
	
	// With a capital `D` we return a DataTables API instance rather than a
	// jQuery object
	$.fn.DataTable = function ( opts ) {
		return $(this).dataTable( opts ).api();
	};
	
	// All properties that are available to $.fn.dataTable should also be
	// available on $.fn.DataTable
	$.each( DataTable, function ( prop, val ) {
		$.fn.DataTable[ prop ] = val;
	} );

	return DataTable;
}));

/*! DataTables Bootstrap 4 integration
 * ©2011-2017 SpryMedia Ltd - datatables.net/license
 */

(function( factory ){
	if ( typeof define === 'function' && define.amd ) {
		// AMD
		define( ['jquery', 'datatables.net'], function ( $ ) {
			return factory( $, window, document );
		} );
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		var jq = require('jquery');
		var cjsRequires = function (root, $) {
			if ( ! $.fn.dataTable ) {
				require('datatables.net')(root, $);
			}
		};

		if (typeof window === 'undefined') {
			module.exports = function (root, $) {
				if ( ! root ) {
					// CommonJS environments without a window global must pass a
					// root. This will give an error otherwise
					root = window;
				}

				if ( ! $ ) {
					$ = jq( root );
				}

				cjsRequires( root, $ );
				return factory( $, root, root.document );
			};
		}
		else {
			cjsRequires( window, jq );
			module.exports = factory( jq, window, window.document );
		}
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;



/**
 * DataTables integration for Bootstrap 4. This requires Bootstrap 4 and
 * DataTables 1.10 or newer.
 *
 * This file sets the defaults and adds options to DataTables to style its
 * controls using Bootstrap. See https://datatables.net/manual/styling/bootstrap
 * for further information.
 */

/* Set the defaults for DataTables initialisation */
$.extend( true, DataTable.defaults, {
	dom:
		"<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>>" +
		"<'row'<'col-sm-12'tr>>" +
		"<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
	renderer: 'bootstrap'
} );


/* Default class modification */
$.extend( DataTable.ext.classes, {
	sWrapper:      "dataTables_wrapper dt-bootstrap4",
	sFilterInput:  "form-control form-control-sm",
	sLengthSelect: "custom-select custom-select-sm form-control form-control-sm",
	sProcessing:   "dataTables_processing card",
	sPageButton:   "paginate_button page-item"
} );


/* Bootstrap paging button renderer */
DataTable.ext.renderer.pageButton.bootstrap = function ( settings, host, idx, buttons, page, pages ) {
	var api     = new DataTable.Api( settings );
	var classes = settings.oClasses;
	var lang    = settings.oLanguage.oPaginate;
	var aria = settings.oLanguage.oAria.paginate || {};
	var btnDisplay, btnClass;

	var attach = function( container, buttons ) {
		var i, ien, node, button;
		var clickHandler = function ( e ) {
			e.preventDefault();
			if ( !$(e.currentTarget).hasClass('disabled') && api.page() != e.data.action ) {
				api.page( e.data.action ).draw( 'page' );
			}
		};

		for ( i=0, ien=buttons.length ; i<ien ; i++ ) {
			button = buttons[i];

			if ( Array.isArray( button ) ) {
				attach( container, button );
			}
			else {
				btnDisplay = '';
				btnClass = '';

				switch ( button ) {
					case 'ellipsis':
						btnDisplay = '&#x2026;';
						btnClass = 'disabled';
						break;

					case 'first':
						btnDisplay = lang.sFirst;
						btnClass = button + (page > 0 ?
							'' : ' disabled');
						break;

					case 'previous':
						btnDisplay = lang.sPrevious;
						btnClass = button + (page > 0 ?
							'' : ' disabled');
						break;

					case 'next':
						btnDisplay = lang.sNext;
						btnClass = button + (page < pages-1 ?
							'' : ' disabled');
						break;

					case 'last':
						btnDisplay = lang.sLast;
						btnClass = button + (page < pages-1 ?
							'' : ' disabled');
						break;

					default:
						btnDisplay = button + 1;
						btnClass = page === button ?
							'active' : '';
						break;
				}

				if ( btnDisplay ) {
					var disabled = btnClass.indexOf('disabled') !== -1;

					node = $('<li>', {
							'class': classes.sPageButton+' '+btnClass,
							'id': idx === 0 && typeof button === 'string' ?
								settings.sTableId +'_'+ button :
								null
						} )
						.append( $('<a>', {
								'href': disabled ? null : '#',
								'aria-controls': settings.sTableId,
								'aria-disabled': disabled ? 'true' : null,
								'aria-label': aria[ button ],
								'role': 'link',
								'aria-current': btnClass === 'active' ? 'page' : null,
								'data-dt-idx': button,
								'tabindex': disabled ? -1 : settings.iTabIndex,
								'class': 'page-link'
							} )
							.html( btnDisplay )
						)
						.appendTo( container );

					settings.oApi._fnBindAction(
						node, {action: button}, clickHandler
					);
				}
			}
		}
	};

	// IE9 throws an 'unknown error' if document.activeElement is used
	// inside an iframe or frame. 
	var activeEl;

	try {
		// Because this approach is destroying and recreating the paging
		// elements, focus is lost on the select button which is bad for
		// accessibility. So we want to restore focus once the draw has
		// completed
		activeEl = $(host).find(document.activeElement).data('dt-idx');
	}
	catch (e) {}

	attach(
		$(host).empty().html('<ul class="pagination"/>').children('ul'),
		buttons
	);

	if ( activeEl !== undefined ) {
		$(host).find( '[data-dt-idx='+activeEl+']' ).trigger('focus');
	}
};


return DataTable;
}));

/*! Responsive 2.5.0
 * © SpryMedia Ltd - datatables.net/license
 */
!function(n){var i,r;"function"==typeof define&&define.amd?define(["jquery","datatables.net"],function(e){return n(e,window,document)}):"object"==typeof exports?(i=require("jquery"),r=function(e,t){t.fn.dataTable||require("datatables.net")(e,t)},"undefined"==typeof window?module.exports=function(e,t){return e=e||window,t=t||i(e),r(e,t),n(t,e,e.document)}:(r(window,i),module.exports=n(i,window,window.document))):n(jQuery,window,document)}(function(f,m,d,h){"use strict";function a(e,t){if(!r.versionCheck||!r.versionCheck("1.10.10"))throw"DataTables Responsive requires DataTables 1.10.10 or newer";this.s={childNodeStore:{},columns:[],current:[],dt:new r.Api(e)},this.s.dt.settings()[0].responsive||(t&&"string"==typeof t.details?t.details={type:t.details}:t&&!1===t.details?t.details={type:!1}:t&&!0===t.details&&(t.details={type:"inline"}),this.c=f.extend(!0,{},a.defaults,r.defaults.responsive,t),(e.responsive=this)._constructor())}var r=f.fn.dataTable,e=(f.extend(a.prototype,{_constructor:function(){var s=this,i=this.s.dt,e=i.settings()[0],t=f(m).innerWidth(),e=(i.settings()[0]._responsive=this,f(m).on("resize.dtr orientationchange.dtr",r.util.throttle(function(){var e=f(m).innerWidth();e!==t&&(s._resize(),t=e)})),e.oApi._fnCallbackReg(e,"aoRowCreatedCallback",function(e,t,n){-1!==f.inArray(!1,s.s.current)&&f(">td, >th",e).each(function(e){e=i.column.index("toData",e);!1===s.s.current[e]&&f(this).css("display","none")})}),i.on("destroy.dtr",function(){i.off(".dtr"),f(i.table().body()).off(".dtr"),f(m).off("resize.dtr orientationchange.dtr"),i.cells(".dtr-control").nodes().to$().removeClass("dtr-control"),f.each(s.s.current,function(e,t){!1===t&&s._setColumnVis(e,!0)})}),this.c.breakpoints.sort(function(e,t){return e.width<t.width?1:e.width>t.width?-1:0}),this._classLogic(),this._resizeAuto(),this.c.details);!1!==e.type&&(s._detailsInit(),i.on("column-visibility.dtr",function(){s._timer&&clearTimeout(s._timer),s._timer=setTimeout(function(){s._timer=null,s._classLogic(),s._resizeAuto(),s._resize(!0),s._redrawChildren()},100)}),i.on("draw.dtr",function(){s._redrawChildren()}),f(i.table().node()).addClass("dtr-"+e.type)),i.on("column-reorder.dtr",function(e,t,n){s._classLogic(),s._resizeAuto(),s._resize(!0)}),i.on("column-sizing.dtr",function(){s._resizeAuto(),s._resize()}),i.on("column-calc.dt",function(e,t){for(var n=s.s.current,i=0;i<n.length;i++){var r=t.visible.indexOf(i);!1===n[i]&&0<=r&&t.visible.splice(r,1)}}),i.on("preXhr.dtr",function(){var e=[];i.rows().every(function(){this.child.isShown()&&e.push(this.id(!0))}),i.one("draw.dtr",function(){s._resizeAuto(),s._resize(),i.rows(e).every(function(){s._detailsDisplay(this,!1)})})}),i.on("draw.dtr",function(){s._controlClass()}).on("init.dtr",function(e,t,n){"dt"===e.namespace&&(s._resizeAuto(),s._resize(),f.inArray(!1,s.s.current)&&i.columns.adjust())}),this._resize()},_childNodes:function(e,t,n){var i=t+"-"+n;if(this.s.childNodeStore[i])return this.s.childNodeStore[i];for(var r=[],s=e.cell(t,n).node().childNodes,o=0,d=s.length;o<d;o++)r.push(s[o]);return this.s.childNodeStore[i]=r},_childNodesRestore:function(e,t,n){var i=t+"-"+n;if(this.s.childNodeStore[i]){for(var r=e.cell(t,n).node(),s=this.s.childNodeStore[i][0].parentNode.childNodes,o=[],d=0,a=s.length;d<a;d++)o.push(s[d]);for(var l=0,c=o.length;l<c;l++)r.appendChild(o[l]);this.s.childNodeStore[i]=h}},_columnsVisiblity:function(n){for(var i=this.s.dt,e=this.s.columns,t=e.map(function(e,t){return{columnIdx:t,priority:e.priority}}).sort(function(e,t){return e.priority!==t.priority?e.priority-t.priority:e.columnIdx-t.columnIdx}),r=f.map(e,function(e,t){return!1===i.column(t).visible()?"not-visible":(!e.auto||null!==e.minWidth)&&(!0===e.auto?"-":-1!==f.inArray(n,e.includeIn))}),s=0,o=0,d=r.length;o<d;o++)!0===r[o]&&(s+=e[o].minWidth);var a=i.settings()[0].oScroll,a=a.sY||a.sX?a.iBarWidth:0,l=i.table().container().offsetWidth-a-s;for(o=0,d=r.length;o<d;o++)e[o].control&&(l-=e[o].minWidth);var c=!1;for(o=0,d=t.length;o<d;o++){var u=t[o].columnIdx;"-"===r[u]&&!e[u].control&&e[u].minWidth&&(c||l-e[u].minWidth<0?r[u]=!(c=!0):r[u]=!0,l-=e[u].minWidth)}var h=!1;for(o=0,d=e.length;o<d;o++)if(!e[o].control&&!e[o].never&&!1===r[o]){h=!0;break}for(o=0,d=e.length;o<d;o++)e[o].control&&(r[o]=h),"not-visible"===r[o]&&(r[o]=!1);return-1===f.inArray(!0,r)&&(r[0]=!0),r},_classLogic:function(){function d(e,t,n,i){var r,s,o;if(n){if("max-"===n)for(r=a._find(t).width,s=0,o=l.length;s<o;s++)l[s].width<=r&&u(e,l[s].name);else if("min-"===n)for(r=a._find(t).width,s=0,o=l.length;s<o;s++)l[s].width>=r&&u(e,l[s].name);else if("not-"===n)for(s=0,o=l.length;s<o;s++)-1===l[s].name.indexOf(i)&&u(e,l[s].name)}else c[e].includeIn.push(t)}var a=this,l=this.c.breakpoints,i=this.s.dt,c=i.columns().eq(0).map(function(e){var t=this.column(e),n=t.header().className,e=i.settings()[0].aoColumns[e].responsivePriority,t=t.header().getAttribute("data-priority");return e===h&&(e=t===h||null===t?1e4:+t),{className:n,includeIn:[],auto:!1,control:!1,never:!!n.match(/\b(dtr\-)?never\b/),priority:e}}),u=function(e,t){e=c[e].includeIn;-1===f.inArray(t,e)&&e.push(t)};c.each(function(e,r){for(var t=e.className.split(" "),s=!1,n=0,i=t.length;n<i;n++){var o=t[n].trim();if("all"===o||"dtr-all"===o)return s=!0,void(e.includeIn=f.map(l,function(e){return e.name}));if("none"===o||"dtr-none"===o||e.never)return void(s=!0);if("control"===o||"dtr-control"===o)return s=!0,void(e.control=!0);f.each(l,function(e,t){var n=t.name.split("-"),i=new RegExp("(min\\-|max\\-|not\\-)?("+n[0]+")(\\-[_a-zA-Z0-9])?"),i=o.match(i);i&&(s=!0,i[2]===n[0]&&i[3]==="-"+n[1]?d(r,t.name,i[1],i[2]+i[3]):i[2]!==n[0]||i[3]||d(r,t.name,i[1],i[2]))})}s||(e.auto=!0)}),this.s.columns=c},_controlClass:function(){var e,t,n;"inline"===this.c.details.type&&(e=this.s.dt,t=this.s.current,n=f.inArray(!0,t),e.cells(null,function(e){return e!==n},{page:"current"}).nodes().to$().filter(".dtr-control").removeClass("dtr-control"),e.cells(null,n,{page:"current"}).nodes().to$().addClass("dtr-control"))},_detailsDisplay:function(t,n){function e(e){f(t.node()).toggleClass("parent",!1!==e),f(s.table().node()).triggerHandler("responsive-display.dt",[s,t,e,n])}var i,r=this,s=this.s.dt,o=this.c.details;o&&!1!==o.type&&(i="string"==typeof o.renderer?a.renderer[o.renderer]():o.renderer,"boolean"==typeof(o=o.display(t,n,function(){return i.call(r,s,t[0],r._detailsObj(t[0]))},function(){e(!1)}))&&e(o))},_detailsInit:function(){var n=this,i=this.s.dt,e=this.c.details,r=("inline"===e.type&&(e.target="td.dtr-control, th.dtr-control"),i.on("draw.dtr",function(){n._tabIndexes()}),n._tabIndexes(),f(i.table().body()).on("keyup.dtr","td, th",function(e){13===e.keyCode&&f(this).data("dtr-keyboard")&&f(this).click()}),e.target),e="string"==typeof r?r:"td, th";r===h&&null===r||f(i.table().body()).on("click.dtr mousedown.dtr mouseup.dtr",e,function(e){if(f(i.table().node()).hasClass("collapsed")&&-1!==f.inArray(f(this).closest("tr").get(0),i.rows().nodes().toArray())){if("number"==typeof r){var t=r<0?i.columns().eq(0).length+r:r;if(i.cell(this).index().column!==t)return}t=i.row(f(this).closest("tr"));"click"===e.type?n._detailsDisplay(t,!1):"mousedown"===e.type?f(this).css("outline","none"):"mouseup"===e.type&&f(this).trigger("blur").css("outline","")}})},_detailsObj:function(n){var i=this,r=this.s.dt;return f.map(this.s.columns,function(e,t){if(!e.never&&!e.control)return{className:(e=r.settings()[0].aoColumns[t]).sClass,columnIndex:t,data:r.cell(n,t).render(i.c.orthogonal),hidden:r.column(t).visible()&&!i.s.current[t],rowIndex:n,title:null!==e.sTitle?e.sTitle:f(r.column(t).header()).text()}})},_find:function(e){for(var t=this.c.breakpoints,n=0,i=t.length;n<i;n++)if(t[n].name===e)return t[n]},_redrawChildren:function(){var n=this,i=this.s.dt;i.rows({page:"current"}).iterator("row",function(e,t){n._detailsDisplay(i.row(t),!0)})},_resize:function(n){for(var e,i=this,t=this.s.dt,r=f(m).innerWidth(),s=this.c.breakpoints,o=s[0].name,d=this.s.columns,a=this.s.current.slice(),l=s.length-1;0<=l;l--)if(r<=s[l].width){o=s[l].name;break}var c=this._columnsVisiblity(o),u=(this.s.current=c,!1);for(l=0,e=d.length;l<e;l++)if(!1===c[l]&&!d[l].never&&!d[l].control&&!1==!t.column(l).visible()){u=!0;break}f(t.table().node()).toggleClass("collapsed",u);var h=!1,p=0;t.columns().eq(0).each(function(e,t){!0===c[t]&&p++,!n&&c[t]===a[t]||(h=!0,i._setColumnVis(e,c[t]))}),this._redrawChildren(),h&&(f(t.table().node()).trigger("responsive-resize.dt",[t,this.s.current]),0===t.page.info().recordsDisplay&&f("td",t.table().body()).eq(0).attr("colspan",p)),i._controlClass()},_resizeAuto:function(){var e,t,n,i,r,s=this.s.dt,o=this.s.columns,d=this;this.c.auto&&-1!==f.inArray(!0,f.map(o,function(e){return e.auto}))&&(f.isEmptyObject(this.s.childNodeStore)||f.each(this.s.childNodeStore,function(e){e=e.split("-");d._childNodesRestore(s,+e[0],+e[1])}),s.table().node().offsetWidth,s.columns,e=s.table().node().cloneNode(!1),t=f(s.table().header().cloneNode(!1)).appendTo(e),i=f(s.table().body()).clone(!1,!1).empty().appendTo(e),e.style.width="auto",n=s.columns().header().filter(function(e){return s.column(e).visible()}).to$().clone(!1).css("display","table-cell").css("width","auto").css("min-width",0),f(i).append(f(s.rows({page:"current"}).nodes()).clone(!1)).find("th, td").css("display",""),(i=s.table().footer())&&(i=f(i.cloneNode(!1)).appendTo(e),r=s.columns().footer().filter(function(e){return s.column(e).visible()}).to$().clone(!1).css("display","table-cell"),f("<tr/>").append(r).appendTo(i)),f("<tr/>").append(n).appendTo(t),"inline"===this.c.details.type&&f(e).addClass("dtr-inline collapsed"),f(e).find("[name]").removeAttr("name"),f(e).css("position","relative"),(r=f("<div/>").css({width:1,height:1,overflow:"hidden",clear:"both"}).append(e)).insertBefore(s.table().node()),n.each(function(e){e=s.column.index("fromVisible",e);o[e].minWidth=this.offsetWidth||0}),r.remove())},_responsiveOnlyHidden:function(){var n=this.s.dt;return f.map(this.s.current,function(e,t){return!1===n.column(t).visible()||e})},_setColumnVis:function(e,t){var n=this,i=this.s.dt,r=t?"":"none";f(i.column(e).header()).css("display",r).toggleClass("dtr-hidden",!t),f(i.column(e).footer()).css("display",r).toggleClass("dtr-hidden",!t),i.column(e).nodes().to$().css("display",r).toggleClass("dtr-hidden",!t),f.isEmptyObject(this.s.childNodeStore)||i.cells(null,e).indexes().each(function(e){n._childNodesRestore(i,e.row,e.column)})},_tabIndexes:function(){var e=this.s.dt,t=e.cells({page:"current"}).nodes().to$(),n=e.settings()[0],i=this.c.details.target;t.filter("[data-dtr-keyboard]").removeData("[data-dtr-keyboard]"),("number"==typeof i?e.cells(null,i,{page:"current"}).nodes().to$():f(i="td:first-child, th:first-child"===i?">td:first-child, >th:first-child":i,e.rows({page:"current"}).nodes())).attr("tabIndex",n.iTabIndex).data("dtr-keyboard",1)}}),a.defaults={breakpoints:a.breakpoints=[{name:"desktop",width:1/0},{name:"tablet-l",width:1024},{name:"tablet-p",width:768},{name:"mobile-l",width:480},{name:"mobile-p",width:320}],auto:!0,details:{display:(a.display={childRow:function(e,t,n){return t?f(e.node()).hasClass("parent")?(e.child(n(),"child").show(),!0):void 0:e.child.isShown()?(e.child(!1),!1):(e.child(n(),"child").show(),!0)},childRowImmediate:function(e,t,n){return!t&&e.child.isShown()||!e.responsive.hasHidden()?(e.child(!1),!1):(e.child(n(),"child").show(),!0)},modal:function(o){return function(e,t,n,i){if(t){if(!(s=f("div.dtr-modal-content")).length||e.index()!==s.data("dtr-row-idx"))return null;s.empty().append(n())}else{var r=function(){s.remove(),f(d).off("keypress.dtr"),f(e.node()).removeClass("parent"),i()},s=f('<div class="dtr-modal"/>').append(f('<div class="dtr-modal-display"/>').append(f('<div class="dtr-modal-content"/>').data("dtr-row-idx",e.index()).append(n())).append(f('<div class="dtr-modal-close">&times;</div>').click(function(){r()}))).append(f('<div class="dtr-modal-background"/>').click(function(){r()})).appendTo("body");f(e.node()).addClass("parent"),f(d).on("keyup.dtr",function(e){27===e.keyCode&&(e.stopPropagation(),r())})}return o&&o.header&&f("div.dtr-modal-content").prepend("<h2>"+o.header(e)+"</h2>"),!0}}}).childRow,renderer:(a.renderer={listHiddenNodes:function(){return function(i,e,t){var r=this,s=f('<ul data-dtr-index="'+e+'" class="dtr-details"/>'),o=!1;f.each(t,function(e,t){var n;t.hidden&&(n=t.className?'class="'+t.className+'"':"",f("<li "+n+' data-dtr-index="'+t.columnIndex+'" data-dt-row="'+t.rowIndex+'" data-dt-column="'+t.columnIndex+'"><span class="dtr-title">'+t.title+"</span> </li>").append(f('<span class="dtr-data"/>').append(r._childNodes(i,t.rowIndex,t.columnIndex))).appendTo(s),o=!0)});return!!o&&s}},listHidden:function(){return function(e,t,n){n=f.map(n,function(e){var t=e.className?'class="'+e.className+'"':"";return e.hidden?"<li "+t+' data-dtr-index="'+e.columnIndex+'" data-dt-row="'+e.rowIndex+'" data-dt-column="'+e.columnIndex+'"><span class="dtr-title">'+e.title+'</span> <span class="dtr-data">'+e.data+"</span></li>":""}).join("");return!!n&&f('<ul data-dtr-index="'+t+'" class="dtr-details"/>').append(n)}},tableAll:function(i){return i=f.extend({tableClass:""},i),function(e,t,n){n=f.map(n,function(e){return"<tr "+(e.className?'class="'+e.className+'"':"")+' data-dt-row="'+e.rowIndex+'" data-dt-column="'+e.columnIndex+'"><td>'+e.title+":</td> <td>"+e.data+"</td></tr>"}).join("");return f('<table class="'+i.tableClass+' dtr-details" width="100%"/>').append(n)}}}).listHidden(),target:0,type:"inline"},orthogonal:"display"},f.fn.dataTable.Api);return e.register("responsive()",function(){return this}),e.register("responsive.index()",function(e){return{column:(e=f(e)).data("dtr-index"),row:e.parent().data("dtr-index")}}),e.register("responsive.rebuild()",function(){return this.iterator("table",function(e){e._responsive&&e._responsive._classLogic()})}),e.register("responsive.recalc()",function(){return this.iterator("table",function(e){e._responsive&&(e._responsive._resizeAuto(),e._responsive._resize())})}),e.register("responsive.hasHidden()",function(){var e=this.context[0];return!!e._responsive&&-1!==f.inArray(!1,e._responsive._responsiveOnlyHidden())}),e.registerPlural("columns().responsiveHidden()","column().responsiveHidden()",function(){return this.iterator("column",function(e,t){return!!e._responsive&&e._responsive._responsiveOnlyHidden()[t]},1)}),a.version="2.5.0",f.fn.dataTable.Responsive=a,f.fn.DataTable.Responsive=a,f(d).on("preInit.dt.dtr",function(e,t,n){"dt"===e.namespace&&(f(t.nTable).hasClass("responsive")||f(t.nTable).hasClass("dt-responsive")||t.oInit.responsive||r.defaults.responsive)&&!1!==(e=t.oInit.responsive)&&new a(t,f.isPlainObject(e)?e:{})}),r});
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/

(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.JSZip = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";
var utils = require("./utils");
var support = require("./support");
// private property
var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";


// public method for encoding
exports.encode = function(input) {
    var output = [];
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0, len = input.length, remainingBytes = len;

    var isArray = utils.getTypeOf(input) !== "string";
    while (i < input.length) {
        remainingBytes = len - i;

        if (!isArray) {
            chr1 = input.charCodeAt(i++);
            chr2 = i < len ? input.charCodeAt(i++) : 0;
            chr3 = i < len ? input.charCodeAt(i++) : 0;
        } else {
            chr1 = input[i++];
            chr2 = i < len ? input[i++] : 0;
            chr3 = i < len ? input[i++] : 0;
        }

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = remainingBytes > 1 ? (((chr2 & 15) << 2) | (chr3 >> 6)) : 64;
        enc4 = remainingBytes > 2 ? (chr3 & 63) : 64;

        output.push(_keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4));

    }

    return output.join("");
};

// public method for decoding
exports.decode = function(input) {
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0, resultIndex = 0;

    var dataUrlPrefix = "data:";

    if (input.substr(0, dataUrlPrefix.length) === dataUrlPrefix) {
        // This is a common error: people give a data url
        // (data:image/png;base64,iVBOR...) with a {base64: true} and
        // wonders why things don't work.
        // We can detect that the string input looks like a data url but we
        // *can't* be sure it is one: removing everything up to the comma would
        // be too dangerous.
        throw new Error("Invalid base64 input, it looks like a data url.");
    }

    input = input.replace(/[^A-Za-z0-9+/=]/g, "");

    var totalLength = input.length * 3 / 4;
    if(input.charAt(input.length - 1) === _keyStr.charAt(64)) {
        totalLength--;
    }
    if(input.charAt(input.length - 2) === _keyStr.charAt(64)) {
        totalLength--;
    }
    if (totalLength % 1 !== 0) {
        // totalLength is not an integer, the length does not match a valid
        // base64 content. That can happen if:
        // - the input is not a base64 content
        // - the input is *almost* a base64 content, with a extra chars at the
        //   beginning or at the end
        // - the input uses a base64 variant (base64url for example)
        throw new Error("Invalid base64 input, bad content length.");
    }
    var output;
    if (support.uint8array) {
        output = new Uint8Array(totalLength|0);
    } else {
        output = new Array(totalLength|0);
    }

    while (i < input.length) {

        enc1 = _keyStr.indexOf(input.charAt(i++));
        enc2 = _keyStr.indexOf(input.charAt(i++));
        enc3 = _keyStr.indexOf(input.charAt(i++));
        enc4 = _keyStr.indexOf(input.charAt(i++));

        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;

        output[resultIndex++] = chr1;

        if (enc3 !== 64) {
            output[resultIndex++] = chr2;
        }
        if (enc4 !== 64) {
            output[resultIndex++] = chr3;
        }

    }

    return output;
};

},{"./support":30,"./utils":32}],2:[function(require,module,exports){
"use strict";

var external = require("./external");
var DataWorker = require("./stream/DataWorker");
var Crc32Probe = require("./stream/Crc32Probe");
var DataLengthProbe = require("./stream/DataLengthProbe");

/**
 * Represent a compressed object, with everything needed to decompress it.
 * @constructor
 * @param {number} compressedSize the size of the data compressed.
 * @param {number} uncompressedSize the size of the data after decompression.
 * @param {number} crc32 the crc32 of the decompressed file.
 * @param {object} compression the type of compression, see lib/compressions.js.
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the compressed data.
 */
function CompressedObject(compressedSize, uncompressedSize, crc32, compression, data) {
    this.compressedSize = compressedSize;
    this.uncompressedSize = uncompressedSize;
    this.crc32 = crc32;
    this.compression = compression;
    this.compressedContent = data;
}

CompressedObject.prototype = {
    /**
     * Create a worker to get the uncompressed content.
     * @return {GenericWorker} the worker.
     */
    getContentWorker: function () {
        var worker = new DataWorker(external.Promise.resolve(this.compressedContent))
            .pipe(this.compression.uncompressWorker())
            .pipe(new DataLengthProbe("data_length"));

        var that = this;
        worker.on("end", function () {
            if (this.streamInfo["data_length"] !== that.uncompressedSize) {
                throw new Error("Bug : uncompressed data size mismatch");
            }
        });
        return worker;
    },
    /**
     * Create a worker to get the compressed content.
     * @return {GenericWorker} the worker.
     */
    getCompressedWorker: function () {
        return new DataWorker(external.Promise.resolve(this.compressedContent))
            .withStreamInfo("compressedSize", this.compressedSize)
            .withStreamInfo("uncompressedSize", this.uncompressedSize)
            .withStreamInfo("crc32", this.crc32)
            .withStreamInfo("compression", this.compression)
        ;
    }
};

/**
 * Chain the given worker with other workers to compress the content with the
 * given compression.
 * @param {GenericWorker} uncompressedWorker the worker to pipe.
 * @param {Object} compression the compression object.
 * @param {Object} compressionOptions the options to use when compressing.
 * @return {GenericWorker} the new worker compressing the content.
 */
CompressedObject.createWorkerFrom = function (uncompressedWorker, compression, compressionOptions) {
    return uncompressedWorker
        .pipe(new Crc32Probe())
        .pipe(new DataLengthProbe("uncompressedSize"))
        .pipe(compression.compressWorker(compressionOptions))
        .pipe(new DataLengthProbe("compressedSize"))
        .withStreamInfo("compression", compression);
};

module.exports = CompressedObject;

},{"./external":6,"./stream/Crc32Probe":25,"./stream/DataLengthProbe":26,"./stream/DataWorker":27}],3:[function(require,module,exports){
"use strict";

var GenericWorker = require("./stream/GenericWorker");

exports.STORE = {
    magic: "\x00\x00",
    compressWorker : function () {
        return new GenericWorker("STORE compression");
    },
    uncompressWorker : function () {
        return new GenericWorker("STORE decompression");
    }
};
exports.DEFLATE = require("./flate");

},{"./flate":7,"./stream/GenericWorker":28}],4:[function(require,module,exports){
"use strict";

var utils = require("./utils");

/**
 * The following functions come from pako, from pako/lib/zlib/crc32.js
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */

// Use ordinary array, since untyped makes no boost here
function makeTable() {
    var c, table = [];

    for(var n =0; n < 256; n++){
        c = n;
        for(var k =0; k < 8; k++){
            c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
        }
        table[n] = c;
    }

    return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
    var t = crcTable, end = pos + len;

    crc = crc ^ (-1);

    for (var i = pos; i < end; i++ ) {
        crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
    }

    return (crc ^ (-1)); // >>> 0;
}

// That's all for the pako functions.

/**
 * Compute the crc32 of a string.
 * This is almost the same as the function crc32, but for strings. Using the
 * same function for the two use cases leads to horrible performances.
 * @param {Number} crc the starting value of the crc.
 * @param {String} str the string to use.
 * @param {Number} len the length of the string.
 * @param {Number} pos the starting position for the crc32 computation.
 * @return {Number} the computed crc32.
 */
function crc32str(crc, str, len, pos) {
    var t = crcTable, end = pos + len;

    crc = crc ^ (-1);

    for (var i = pos; i < end; i++ ) {
        crc = (crc >>> 8) ^ t[(crc ^ str.charCodeAt(i)) & 0xFF];
    }

    return (crc ^ (-1)); // >>> 0;
}

module.exports = function crc32wrapper(input, crc) {
    if (typeof input === "undefined" || !input.length) {
        return 0;
    }

    var isArray = utils.getTypeOf(input) !== "string";

    if(isArray) {
        return crc32(crc|0, input, input.length, 0);
    } else {
        return crc32str(crc|0, input, input.length, 0);
    }
};

},{"./utils":32}],5:[function(require,module,exports){
"use strict";
exports.base64 = false;
exports.binary = false;
exports.dir = false;
exports.createFolders = true;
exports.date = null;
exports.compression = null;
exports.compressionOptions = null;
exports.comment = null;
exports.unixPermissions = null;
exports.dosPermissions = null;

},{}],6:[function(require,module,exports){
"use strict";

// load the global object first:
// - it should be better integrated in the system (unhandledRejection in node)
// - the environment may have a custom Promise implementation (see zone.js)
var ES6Promise = null;
if (typeof Promise !== "undefined") {
    ES6Promise = Promise;
} else {
    ES6Promise = require("lie");
}

/**
 * Let the user use/change some implementations.
 */
module.exports = {
    Promise: ES6Promise
};

},{"lie":37}],7:[function(require,module,exports){
"use strict";
var USE_TYPEDARRAY = (typeof Uint8Array !== "undefined") && (typeof Uint16Array !== "undefined") && (typeof Uint32Array !== "undefined");

var pako = require("pako");
var utils = require("./utils");
var GenericWorker = require("./stream/GenericWorker");

var ARRAY_TYPE = USE_TYPEDARRAY ? "uint8array" : "array";

exports.magic = "\x08\x00";

/**
 * Create a worker that uses pako to inflate/deflate.
 * @constructor
 * @param {String} action the name of the pako function to call : either "Deflate" or "Inflate".
 * @param {Object} options the options to use when (de)compressing.
 */
function FlateWorker(action, options) {
    GenericWorker.call(this, "FlateWorker/" + action);

    this._pako = null;
    this._pakoAction = action;
    this._pakoOptions = options;
    // the `meta` object from the last chunk received
    // this allow this worker to pass around metadata
    this.meta = {};
}

utils.inherits(FlateWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
FlateWorker.prototype.processChunk = function (chunk) {
    this.meta = chunk.meta;
    if (this._pako === null) {
        this._createPako();
    }
    this._pako.push(utils.transformTo(ARRAY_TYPE, chunk.data), false);
};

/**
 * @see GenericWorker.flush
 */
FlateWorker.prototype.flush = function () {
    GenericWorker.prototype.flush.call(this);
    if (this._pako === null) {
        this._createPako();
    }
    this._pako.push([], true);
};
/**
 * @see GenericWorker.cleanUp
 */
FlateWorker.prototype.cleanUp = function () {
    GenericWorker.prototype.cleanUp.call(this);
    this._pako = null;
};

/**
 * Create the _pako object.
 * TODO: lazy-loading this object isn't the best solution but it's the
 * quickest. The best solution is to lazy-load the worker list. See also the
 * issue #446.
 */
FlateWorker.prototype._createPako = function () {
    this._pako = new pako[this._pakoAction]({
        raw: true,
        level: this._pakoOptions.level || -1 // default compression
    });
    var self = this;
    this._pako.onData = function(data) {
        self.push({
            data : data,
            meta : self.meta
        });
    };
};

exports.compressWorker = function (compressionOptions) {
    return new FlateWorker("Deflate", compressionOptions);
};
exports.uncompressWorker = function () {
    return new FlateWorker("Inflate", {});
};

},{"./stream/GenericWorker":28,"./utils":32,"pako":38}],8:[function(require,module,exports){
"use strict";

var utils = require("../utils");
var GenericWorker = require("../stream/GenericWorker");
var utf8 = require("../utf8");
var crc32 = require("../crc32");
var signature = require("../signature");

/**
 * Transform an integer into a string in hexadecimal.
 * @private
 * @param {number} dec the number to convert.
 * @param {number} bytes the number of bytes to generate.
 * @returns {string} the result.
 */
var decToHex = function(dec, bytes) {
    var hex = "", i;
    for (i = 0; i < bytes; i++) {
        hex += String.fromCharCode(dec & 0xff);
        dec = dec >>> 8;
    }
    return hex;
};

/**
 * Generate the UNIX part of the external file attributes.
 * @param {Object} unixPermissions the unix permissions or null.
 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
 * @return {Number} a 32 bit integer.
 *
 * adapted from http://unix.stackexchange.com/questions/14705/the-zip-formats-external-file-attribute :
 *
 * TTTTsstrwxrwxrwx0000000000ADVSHR
 * ^^^^____________________________ file type, see zipinfo.c (UNX_*)
 *     ^^^_________________________ setuid, setgid, sticky
 *        ^^^^^^^^^________________ permissions
 *                 ^^^^^^^^^^______ not used ?
 *                           ^^^^^^ DOS attribute bits : Archive, Directory, Volume label, System file, Hidden, Read only
 */
var generateUnixExternalFileAttr = function (unixPermissions, isDir) {

    var result = unixPermissions;
    if (!unixPermissions) {
        // I can't use octal values in strict mode, hence the hexa.
        //  040775 => 0x41fd
        // 0100664 => 0x81b4
        result = isDir ? 0x41fd : 0x81b4;
    }
    return (result & 0xFFFF) << 16;
};

/**
 * Generate the DOS part of the external file attributes.
 * @param {Object} dosPermissions the dos permissions or null.
 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
 * @return {Number} a 32 bit integer.
 *
 * Bit 0     Read-Only
 * Bit 1     Hidden
 * Bit 2     System
 * Bit 3     Volume Label
 * Bit 4     Directory
 * Bit 5     Archive
 */
var generateDosExternalFileAttr = function (dosPermissions) {
    // the dir flag is already set for compatibility
    return (dosPermissions || 0)  & 0x3F;
};

/**
 * Generate the various parts used in the construction of the final zip file.
 * @param {Object} streamInfo the hash with information about the compressed file.
 * @param {Boolean} streamedContent is the content streamed ?
 * @param {Boolean} streamingEnded is the stream finished ?
 * @param {number} offset the current offset from the start of the zip file.
 * @param {String} platform let's pretend we are this platform (change platform dependents fields)
 * @param {Function} encodeFileName the function to encode the file name / comment.
 * @return {Object} the zip parts.
 */
var generateZipParts = function(streamInfo, streamedContent, streamingEnded, offset, platform, encodeFileName) {
    var file = streamInfo["file"],
        compression = streamInfo["compression"],
        useCustomEncoding = encodeFileName !== utf8.utf8encode,
        encodedFileName = utils.transformTo("string", encodeFileName(file.name)),
        utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
        comment = file.comment,
        encodedComment = utils.transformTo("string", encodeFileName(comment)),
        utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
        useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
        useUTF8ForComment = utfEncodedComment.length !== comment.length,
        dosTime,
        dosDate,
        extraFields = "",
        unicodePathExtraField = "",
        unicodeCommentExtraField = "",
        dir = file.dir,
        date = file.date;


    var dataInfo = {
        crc32 : 0,
        compressedSize : 0,
        uncompressedSize : 0
    };

    // if the content is streamed, the sizes/crc32 are only available AFTER
    // the end of the stream.
    if (!streamedContent || streamingEnded) {
        dataInfo.crc32 = streamInfo["crc32"];
        dataInfo.compressedSize = streamInfo["compressedSize"];
        dataInfo.uncompressedSize = streamInfo["uncompressedSize"];
    }

    var bitflag = 0;
    if (streamedContent) {
        // Bit 3: the sizes/crc32 are set to zero in the local header.
        // The correct values are put in the data descriptor immediately
        // following the compressed data.
        bitflag |= 0x0008;
    }
    if (!useCustomEncoding && (useUTF8ForFileName || useUTF8ForComment)) {
        // Bit 11: Language encoding flag (EFS).
        bitflag |= 0x0800;
    }


    var extFileAttr = 0;
    var versionMadeBy = 0;
    if (dir) {
        // dos or unix, we set the dos dir flag
        extFileAttr |= 0x00010;
    }
    if(platform === "UNIX") {
        versionMadeBy = 0x031E; // UNIX, version 3.0
        extFileAttr |= generateUnixExternalFileAttr(file.unixPermissions, dir);
    } else { // DOS or other, fallback to DOS
        versionMadeBy = 0x0014; // DOS, version 2.0
        extFileAttr |= generateDosExternalFileAttr(file.dosPermissions, dir);
    }

    // date
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html

    dosTime = date.getUTCHours();
    dosTime = dosTime << 6;
    dosTime = dosTime | date.getUTCMinutes();
    dosTime = dosTime << 5;
    dosTime = dosTime | date.getUTCSeconds() / 2;

    dosDate = date.getUTCFullYear() - 1980;
    dosDate = dosDate << 4;
    dosDate = dosDate | (date.getUTCMonth() + 1);
    dosDate = dosDate << 5;
    dosDate = dosDate | date.getUTCDate();

    if (useUTF8ForFileName) {
        // set the unicode path extra field. unzip needs at least one extra
        // field to correctly handle unicode path, so using the path is as good
        // as any other information. This could improve the situation with
        // other archive managers too.
        // This field is usually used without the utf8 flag, with a non
        // unicode path in the header (winrar, winzip). This helps (a bit)
        // with the messy Windows' default compressed folders feature but
        // breaks on p7zip which doesn't seek the unicode path extra field.
        // So for now, UTF-8 everywhere !
        unicodePathExtraField =
            // Version
            decToHex(1, 1) +
            // NameCRC32
            decToHex(crc32(encodedFileName), 4) +
            // UnicodeName
            utfEncodedFileName;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x70" +
            // size
            decToHex(unicodePathExtraField.length, 2) +
            // content
            unicodePathExtraField;
    }

    if(useUTF8ForComment) {

        unicodeCommentExtraField =
            // Version
            decToHex(1, 1) +
            // CommentCRC32
            decToHex(crc32(encodedComment), 4) +
            // UnicodeName
            utfEncodedComment;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x63" +
            // size
            decToHex(unicodeCommentExtraField.length, 2) +
            // content
            unicodeCommentExtraField;
    }

    var header = "";

    // version needed to extract
    header += "\x0A\x00";
    // general purpose bit flag
    header += decToHex(bitflag, 2);
    // compression method
    header += compression.magic;
    // last mod file time
    header += decToHex(dosTime, 2);
    // last mod file date
    header += decToHex(dosDate, 2);
    // crc-32
    header += decToHex(dataInfo.crc32, 4);
    // compressed size
    header += decToHex(dataInfo.compressedSize, 4);
    // uncompressed size
    header += decToHex(dataInfo.uncompressedSize, 4);
    // file name length
    header += decToHex(encodedFileName.length, 2);
    // extra field length
    header += decToHex(extraFields.length, 2);


    var fileRecord = signature.LOCAL_FILE_HEADER + header + encodedFileName + extraFields;

    var dirRecord = signature.CENTRAL_FILE_HEADER +
        // version made by (00: DOS)
        decToHex(versionMadeBy, 2) +
        // file header (common to file and central directory)
        header +
        // file comment length
        decToHex(encodedComment.length, 2) +
        // disk number start
        "\x00\x00" +
        // internal file attributes TODO
        "\x00\x00" +
        // external file attributes
        decToHex(extFileAttr, 4) +
        // relative offset of local header
        decToHex(offset, 4) +
        // file name
        encodedFileName +
        // extra field
        extraFields +
        // file comment
        encodedComment;

    return {
        fileRecord: fileRecord,
        dirRecord: dirRecord
    };
};

/**
 * Generate the EOCD record.
 * @param {Number} entriesCount the number of entries in the zip file.
 * @param {Number} centralDirLength the length (in bytes) of the central dir.
 * @param {Number} localDirLength the length (in bytes) of the local dir.
 * @param {String} comment the zip file comment as a binary string.
 * @param {Function} encodeFileName the function to encode the comment.
 * @return {String} the EOCD record.
 */
var generateCentralDirectoryEnd = function (entriesCount, centralDirLength, localDirLength, comment, encodeFileName) {
    var dirEnd = "";
    var encodedComment = utils.transformTo("string", encodeFileName(comment));

    // end of central dir signature
    dirEnd = signature.CENTRAL_DIRECTORY_END +
        // number of this disk
        "\x00\x00" +
        // number of the disk with the start of the central directory
        "\x00\x00" +
        // total number of entries in the central directory on this disk
        decToHex(entriesCount, 2) +
        // total number of entries in the central directory
        decToHex(entriesCount, 2) +
        // size of the central directory   4 bytes
        decToHex(centralDirLength, 4) +
        // offset of start of central directory with respect to the starting disk number
        decToHex(localDirLength, 4) +
        // .ZIP file comment length
        decToHex(encodedComment.length, 2) +
        // .ZIP file comment
        encodedComment;

    return dirEnd;
};

/**
 * Generate data descriptors for a file entry.
 * @param {Object} streamInfo the hash generated by a worker, containing information
 * on the file entry.
 * @return {String} the data descriptors.
 */
var generateDataDescriptors = function (streamInfo) {
    var descriptor = "";
    descriptor = signature.DATA_DESCRIPTOR +
        // crc-32                          4 bytes
        decToHex(streamInfo["crc32"], 4) +
        // compressed size                 4 bytes
        decToHex(streamInfo["compressedSize"], 4) +
        // uncompressed size               4 bytes
        decToHex(streamInfo["uncompressedSize"], 4);

    return descriptor;
};


/**
 * A worker to concatenate other workers to create a zip file.
 * @param {Boolean} streamFiles `true` to stream the content of the files,
 * `false` to accumulate it.
 * @param {String} comment the comment to use.
 * @param {String} platform the platform to use, "UNIX" or "DOS".
 * @param {Function} encodeFileName the function to encode file names and comments.
 */
function ZipFileWorker(streamFiles, comment, platform, encodeFileName) {
    GenericWorker.call(this, "ZipFileWorker");
    // The number of bytes written so far. This doesn't count accumulated chunks.
    this.bytesWritten = 0;
    // The comment of the zip file
    this.zipComment = comment;
    // The platform "generating" the zip file.
    this.zipPlatform = platform;
    // the function to encode file names and comments.
    this.encodeFileName = encodeFileName;
    // Should we stream the content of the files ?
    this.streamFiles = streamFiles;
    // If `streamFiles` is false, we will need to accumulate the content of the
    // files to calculate sizes / crc32 (and write them *before* the content).
    // This boolean indicates if we are accumulating chunks (it will change a lot
    // during the lifetime of this worker).
    this.accumulate = false;
    // The buffer receiving chunks when accumulating content.
    this.contentBuffer = [];
    // The list of generated directory records.
    this.dirRecords = [];
    // The offset (in bytes) from the beginning of the zip file for the current source.
    this.currentSourceOffset = 0;
    // The total number of entries in this zip file.
    this.entriesCount = 0;
    // the name of the file currently being added, null when handling the end of the zip file.
    // Used for the emitted metadata.
    this.currentFile = null;



    this._sources = [];
}
utils.inherits(ZipFileWorker, GenericWorker);

/**
 * @see GenericWorker.push
 */
ZipFileWorker.prototype.push = function (chunk) {

    var currentFilePercent = chunk.meta.percent || 0;
    var entriesCount = this.entriesCount;
    var remainingFiles = this._sources.length;

    if(this.accumulate) {
        this.contentBuffer.push(chunk);
    } else {
        this.bytesWritten += chunk.data.length;

        GenericWorker.prototype.push.call(this, {
            data : chunk.data,
            meta : {
                currentFile : this.currentFile,
                percent : entriesCount ? (currentFilePercent + 100 * (entriesCount - remainingFiles - 1)) / entriesCount : 100
            }
        });
    }
};

/**
 * The worker started a new source (an other worker).
 * @param {Object} streamInfo the streamInfo object from the new source.
 */
ZipFileWorker.prototype.openedSource = function (streamInfo) {
    this.currentSourceOffset = this.bytesWritten;
    this.currentFile = streamInfo["file"].name;

    var streamedContent = this.streamFiles && !streamInfo["file"].dir;

    // don't stream folders (because they don't have any content)
    if(streamedContent) {
        var record = generateZipParts(streamInfo, streamedContent, false, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        this.push({
            data : record.fileRecord,
            meta : {percent:0}
        });
    } else {
        // we need to wait for the whole file before pushing anything
        this.accumulate = true;
    }
};

/**
 * The worker finished a source (an other worker).
 * @param {Object} streamInfo the streamInfo object from the finished source.
 */
ZipFileWorker.prototype.closedSource = function (streamInfo) {
    this.accumulate = false;
    var streamedContent = this.streamFiles && !streamInfo["file"].dir;
    var record = generateZipParts(streamInfo, streamedContent, true, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);

    this.dirRecords.push(record.dirRecord);
    if(streamedContent) {
        // after the streamed file, we put data descriptors
        this.push({
            data : generateDataDescriptors(streamInfo),
            meta : {percent:100}
        });
    } else {
        // the content wasn't streamed, we need to push everything now
        // first the file record, then the content
        this.push({
            data : record.fileRecord,
            meta : {percent:0}
        });
        while(this.contentBuffer.length) {
            this.push(this.contentBuffer.shift());
        }
    }
    this.currentFile = null;
};

/**
 * @see GenericWorker.flush
 */
ZipFileWorker.prototype.flush = function () {

    var localDirLength = this.bytesWritten;
    for(var i = 0; i < this.dirRecords.length; i++) {
        this.push({
            data : this.dirRecords[i],
            meta : {percent:100}
        });
    }
    var centralDirLength = this.bytesWritten - localDirLength;

    var dirEnd = generateCentralDirectoryEnd(this.dirRecords.length, centralDirLength, localDirLength, this.zipComment, this.encodeFileName);

    this.push({
        data : dirEnd,
        meta : {percent:100}
    });
};

/**
 * Prepare the next source to be read.
 */
ZipFileWorker.prototype.prepareNextSource = function () {
    this.previous = this._sources.shift();
    this.openedSource(this.previous.streamInfo);
    if (this.isPaused) {
        this.previous.pause();
    } else {
        this.previous.resume();
    }
};

/**
 * @see GenericWorker.registerPrevious
 */
ZipFileWorker.prototype.registerPrevious = function (previous) {
    this._sources.push(previous);
    var self = this;

    previous.on("data", function (chunk) {
        self.processChunk(chunk);
    });
    previous.on("end", function () {
        self.closedSource(self.previous.streamInfo);
        if(self._sources.length) {
            self.prepareNextSource();
        } else {
            self.end();
        }
    });
    previous.on("error", function (e) {
        self.error(e);
    });
    return this;
};

/**
 * @see GenericWorker.resume
 */
ZipFileWorker.prototype.resume = function () {
    if(!GenericWorker.prototype.resume.call(this)) {
        return false;
    }

    if (!this.previous && this._sources.length) {
        this.prepareNextSource();
        return true;
    }
    if (!this.previous && !this._sources.length && !this.generatedError) {
        this.end();
        return true;
    }
};

/**
 * @see GenericWorker.error
 */
ZipFileWorker.prototype.error = function (e) {
    var sources = this._sources;
    if(!GenericWorker.prototype.error.call(this, e)) {
        return false;
    }
    for(var i = 0; i < sources.length; i++) {
        try {
            sources[i].error(e);
        } catch(e) {
            // the `error` exploded, nothing to do
        }
    }
    return true;
};

/**
 * @see GenericWorker.lock
 */
ZipFileWorker.prototype.lock = function () {
    GenericWorker.prototype.lock.call(this);
    var sources = this._sources;
    for(var i = 0; i < sources.length; i++) {
        sources[i].lock();
    }
};

module.exports = ZipFileWorker;

},{"../crc32":4,"../signature":23,"../stream/GenericWorker":28,"../utf8":31,"../utils":32}],9:[function(require,module,exports){
"use strict";

var compressions = require("../compressions");
var ZipFileWorker = require("./ZipFileWorker");

/**
 * Find the compression to use.
 * @param {String} fileCompression the compression defined at the file level, if any.
 * @param {String} zipCompression the compression defined at the load() level.
 * @return {Object} the compression object to use.
 */
var getCompression = function (fileCompression, zipCompression) {

    var compressionName = fileCompression || zipCompression;
    var compression = compressions[compressionName];
    if (!compression) {
        throw new Error(compressionName + " is not a valid compression method !");
    }
    return compression;
};

/**
 * Create a worker to generate a zip file.
 * @param {JSZip} zip the JSZip instance at the right root level.
 * @param {Object} options to generate the zip file.
 * @param {String} comment the comment to use.
 */
exports.generateWorker = function (zip, options, comment) {

    var zipFileWorker = new ZipFileWorker(options.streamFiles, comment, options.platform, options.encodeFileName);
    var entriesCount = 0;
    try {

        zip.forEach(function (relativePath, file) {
            entriesCount++;
            var compression = getCompression(file.options.compression, options.compression);
            var compressionOptions = file.options.compressionOptions || options.compressionOptions || {};
            var dir = file.dir, date = file.date;

            file._compressWorker(compression, compressionOptions)
                .withStreamInfo("file", {
                    name : relativePath,
                    dir : dir,
                    date : date,
                    comment : file.comment || "",
                    unixPermissions : file.unixPermissions,
                    dosPermissions : file.dosPermissions
                })
                .pipe(zipFileWorker);
        });
        zipFileWorker.entriesCount = entriesCount;
    } catch (e) {
        zipFileWorker.error(e);
    }

    return zipFileWorker;
};

},{"../compressions":3,"./ZipFileWorker":8}],10:[function(require,module,exports){
"use strict";

/**
 * Representation a of zip file in js
 * @constructor
 */
function JSZip() {
    // if this constructor is used without `new`, it adds `new` before itself:
    if(!(this instanceof JSZip)) {
        return new JSZip();
    }

    if(arguments.length) {
        throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
    }

    // object containing the files :
    // {
    //   "folder/" : {...},
    //   "folder/data.txt" : {...}
    // }
    // NOTE: we use a null prototype because we do not
    // want filenames like "toString" coming from a zip file
    // to overwrite methods and attributes in a normal Object.
    this.files = Object.create(null);

    this.comment = null;

    // Where we are in the hierarchy
    this.root = "";
    this.clone = function() {
        var newObj = new JSZip();
        for (var i in this) {
            if (typeof this[i] !== "function") {
                newObj[i] = this[i];
            }
        }
        return newObj;
    };
}
JSZip.prototype = require("./object");
JSZip.prototype.loadAsync = require("./load");
JSZip.support = require("./support");
JSZip.defaults = require("./defaults");

// TODO find a better way to handle this version,
// a require('package.json').version doesn't work with webpack, see #327
JSZip.version = "3.10.1";

JSZip.loadAsync = function (content, options) {
    return new JSZip().loadAsync(content, options);
};

JSZip.external = require("./external");
module.exports = JSZip;

},{"./defaults":5,"./external":6,"./load":11,"./object":15,"./support":30}],11:[function(require,module,exports){
"use strict";
var utils = require("./utils");
var external = require("./external");
var utf8 = require("./utf8");
var ZipEntries = require("./zipEntries");
var Crc32Probe = require("./stream/Crc32Probe");
var nodejsUtils = require("./nodejsUtils");

/**
 * Check the CRC32 of an entry.
 * @param {ZipEntry} zipEntry the zip entry to check.
 * @return {Promise} the result.
 */
function checkEntryCRC32(zipEntry) {
    return new external.Promise(function (resolve, reject) {
        var worker = zipEntry.decompressed.getContentWorker().pipe(new Crc32Probe());
        worker.on("error", function (e) {
            reject(e);
        })
            .on("end", function () {
                if (worker.streamInfo.crc32 !== zipEntry.decompressed.crc32) {
                    reject(new Error("Corrupted zip : CRC32 mismatch"));
                } else {
                    resolve();
                }
            })
            .resume();
    });
}

module.exports = function (data, options) {
    var zip = this;
    options = utils.extend(options || {}, {
        base64: false,
        checkCRC32: false,
        optimizedBinaryString: false,
        createFolders: false,
        decodeFileName: utf8.utf8decode
    });

    if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
        return external.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file."));
    }

    return utils.prepareContent("the loaded zip file", data, true, options.optimizedBinaryString, options.base64)
        .then(function (data) {
            var zipEntries = new ZipEntries(options);
            zipEntries.load(data);
            return zipEntries;
        }).then(function checkCRC32(zipEntries) {
            var promises = [external.Promise.resolve(zipEntries)];
            var files = zipEntries.files;
            if (options.checkCRC32) {
                for (var i = 0; i < files.length; i++) {
                    promises.push(checkEntryCRC32(files[i]));
                }
            }
            return external.Promise.all(promises);
        }).then(function addFiles(results) {
            var zipEntries = results.shift();
            var files = zipEntries.files;
            for (var i = 0; i < files.length; i++) {
                var input = files[i];

                var unsafeName = input.fileNameStr;
                var safeName = utils.resolve(input.fileNameStr);

                zip.file(safeName, input.decompressed, {
                    binary: true,
                    optimizedBinaryString: true,
                    date: input.date,
                    dir: input.dir,
                    comment: input.fileCommentStr.length ? input.fileCommentStr : null,
                    unixPermissions: input.unixPermissions,
                    dosPermissions: input.dosPermissions,
                    createFolders: options.createFolders
                });
                if (!input.dir) {
                    zip.file(safeName).unsafeOriginalName = unsafeName;
                }
            }
            if (zipEntries.zipComment.length) {
                zip.comment = zipEntries.zipComment;
            }

            return zip;
        });
};

},{"./external":6,"./nodejsUtils":14,"./stream/Crc32Probe":25,"./utf8":31,"./utils":32,"./zipEntries":33}],12:[function(require,module,exports){
"use strict";

var utils = require("../utils");
var GenericWorker = require("../stream/GenericWorker");

/**
 * A worker that use a nodejs stream as source.
 * @constructor
 * @param {String} filename the name of the file entry for this stream.
 * @param {Readable} stream the nodejs stream.
 */
function NodejsStreamInputAdapter(filename, stream) {
    GenericWorker.call(this, "Nodejs stream input adapter for " + filename);
    this._upstreamEnded = false;
    this._bindStream(stream);
}

utils.inherits(NodejsStreamInputAdapter, GenericWorker);

/**
 * Prepare the stream and bind the callbacks on it.
 * Do this ASAP on node 0.10 ! A lazy binding doesn't always work.
 * @param {Stream} stream the nodejs stream to use.
 */
NodejsStreamInputAdapter.prototype._bindStream = function (stream) {
    var self = this;
    this._stream = stream;
    stream.pause();
    stream
        .on("data", function (chunk) {
            self.push({
                data: chunk,
                meta : {
                    percent : 0
                }
            });
        })
        .on("error", function (e) {
            if(self.isPaused) {
                this.generatedError = e;
            } else {
                self.error(e);
            }
        })
        .on("end", function () {
            if(self.isPaused) {
                self._upstreamEnded = true;
            } else {
                self.end();
            }
        });
};
NodejsStreamInputAdapter.prototype.pause = function () {
    if(!GenericWorker.prototype.pause.call(this)) {
        return false;
    }
    this._stream.pause();
    return true;
};
NodejsStreamInputAdapter.prototype.resume = function () {
    if(!GenericWorker.prototype.resume.call(this)) {
        return false;
    }

    if(this._upstreamEnded) {
        this.end();
    } else {
        this._stream.resume();
    }

    return true;
};

module.exports = NodejsStreamInputAdapter;

},{"../stream/GenericWorker":28,"../utils":32}],13:[function(require,module,exports){
"use strict";

var Readable = require("readable-stream").Readable;

var utils = require("../utils");
utils.inherits(NodejsStreamOutputAdapter, Readable);

/**
* A nodejs stream using a worker as source.
* @see the SourceWrapper in http://nodejs.org/api/stream.html
* @constructor
* @param {StreamHelper} helper the helper wrapping the worker
* @param {Object} options the nodejs stream options
* @param {Function} updateCb the update callback.
*/
function NodejsStreamOutputAdapter(helper, options, updateCb) {
    Readable.call(this, options);
    this._helper = helper;

    var self = this;
    helper.on("data", function (data, meta) {
        if (!self.push(data)) {
            self._helper.pause();
        }
        if(updateCb) {
            updateCb(meta);
        }
    })
        .on("error", function(e) {
            self.emit("error", e);
        })
        .on("end", function () {
            self.push(null);
        });
}


NodejsStreamOutputAdapter.prototype._read = function() {
    this._helper.resume();
};

module.exports = NodejsStreamOutputAdapter;

},{"../utils":32,"readable-stream":16}],14:[function(require,module,exports){
"use strict";

module.exports = {
    /**
     * True if this is running in Nodejs, will be undefined in a browser.
     * In a browser, browserify won't include this file and the whole module
     * will be resolved an empty object.
     */
    isNode : typeof Buffer !== "undefined",
    /**
     * Create a new nodejs Buffer from an existing content.
     * @param {Object} data the data to pass to the constructor.
     * @param {String} encoding the encoding to use.
     * @return {Buffer} a new Buffer.
     */
    newBufferFrom: function(data, encoding) {
        if (Buffer.from && Buffer.from !== Uint8Array.from) {
            return Buffer.from(data, encoding);
        } else {
            if (typeof data === "number") {
                // Safeguard for old Node.js versions. On newer versions,
                // Buffer.from(number) / Buffer(number, encoding) already throw.
                throw new Error("The \"data\" argument must not be a number");
            }
            return new Buffer(data, encoding);
        }
    },
    /**
     * Create a new nodejs Buffer with the specified size.
     * @param {Integer} size the size of the buffer.
     * @return {Buffer} a new Buffer.
     */
    allocBuffer: function (size) {
        if (Buffer.alloc) {
            return Buffer.alloc(size);
        } else {
            var buf = new Buffer(size);
            buf.fill(0);
            return buf;
        }
    },
    /**
     * Find out if an object is a Buffer.
     * @param {Object} b the object to test.
     * @return {Boolean} true if the object is a Buffer, false otherwise.
     */
    isBuffer : function(b){
        return Buffer.isBuffer(b);
    },

    isStream : function (obj) {
        return obj &&
            typeof obj.on === "function" &&
            typeof obj.pause === "function" &&
            typeof obj.resume === "function";
    }
};

},{}],15:[function(require,module,exports){
"use strict";
var utf8 = require("./utf8");
var utils = require("./utils");
var GenericWorker = require("./stream/GenericWorker");
var StreamHelper = require("./stream/StreamHelper");
var defaults = require("./defaults");
var CompressedObject = require("./compressedObject");
var ZipObject = require("./zipObject");
var generate = require("./generate");
var nodejsUtils = require("./nodejsUtils");
var NodejsStreamInputAdapter = require("./nodejs/NodejsStreamInputAdapter");


/**
 * Add a file in the current folder.
 * @private
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
 * @param {Object} originalOptions the options of the file
 * @return {Object} the new file.
 */
var fileAdd = function(name, data, originalOptions) {
    // be sure sub folders exist
    var dataType = utils.getTypeOf(data),
        parent;


    /*
     * Correct options.
     */

    var o = utils.extend(originalOptions || {}, defaults);
    o.date = o.date || new Date();
    if (o.compression !== null) {
        o.compression = o.compression.toUpperCase();
    }

    if (typeof o.unixPermissions === "string") {
        o.unixPermissions = parseInt(o.unixPermissions, 8);
    }

    // UNX_IFDIR  0040000 see zipinfo.c
    if (o.unixPermissions && (o.unixPermissions & 0x4000)) {
        o.dir = true;
    }
    // Bit 4    Directory
    if (o.dosPermissions && (o.dosPermissions & 0x0010)) {
        o.dir = true;
    }

    if (o.dir) {
        name = forceTrailingSlash(name);
    }
    if (o.createFolders && (parent = parentFolder(name))) {
        folderAdd.call(this, parent, true);
    }

    var isUnicodeString = dataType === "string" && o.binary === false && o.base64 === false;
    if (!originalOptions || typeof originalOptions.binary === "undefined") {
        o.binary = !isUnicodeString;
    }


    var isCompressedEmpty = (data instanceof CompressedObject) && data.uncompressedSize === 0;

    if (isCompressedEmpty || o.dir || !data || data.length === 0) {
        o.base64 = false;
        o.binary = true;
        data = "";
        o.compression = "STORE";
        dataType = "string";
    }

    /*
     * Convert content to fit.
     */

    var zipObjectContent = null;
    if (data instanceof CompressedObject || data instanceof GenericWorker) {
        zipObjectContent = data;
    } else if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
        zipObjectContent = new NodejsStreamInputAdapter(name, data);
    } else {
        zipObjectContent = utils.prepareContent(name, data, o.binary, o.optimizedBinaryString, o.base64);
    }

    var object = new ZipObject(name, zipObjectContent, o);
    this.files[name] = object;
    /*
    TODO: we can't throw an exception because we have async promises
    (we can have a promise of a Date() for example) but returning a
    promise is useless because file(name, data) returns the JSZip
    object for chaining. Should we break that to allow the user
    to catch the error ?

    return external.Promise.resolve(zipObjectContent)
    .then(function () {
        return object;
    });
    */
};

/**
 * Find the parent folder of the path.
 * @private
 * @param {string} path the path to use
 * @return {string} the parent folder, or ""
 */
var parentFolder = function (path) {
    if (path.slice(-1) === "/") {
        path = path.substring(0, path.length - 1);
    }
    var lastSlash = path.lastIndexOf("/");
    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
};

/**
 * Returns the path with a slash at the end.
 * @private
 * @param {String} path the path to check.
 * @return {String} the path with a trailing slash.
 */
var forceTrailingSlash = function(path) {
    // Check the name ends with a /
    if (path.slice(-1) !== "/") {
        path += "/"; // IE doesn't like substr(-1)
    }
    return path;
};

/**
 * Add a (sub) folder in the current folder.
 * @private
 * @param {string} name the folder's name
 * @param {boolean=} [createFolders] If true, automatically create sub
 *  folders. Defaults to false.
 * @return {Object} the new folder.
 */
var folderAdd = function(name, createFolders) {
    createFolders = (typeof createFolders !== "undefined") ? createFolders : defaults.createFolders;

    name = forceTrailingSlash(name);

    // Does this folder already exist?
    if (!this.files[name]) {
        fileAdd.call(this, name, null, {
            dir: true,
            createFolders: createFolders
        });
    }
    return this.files[name];
};

/**
* Cross-window, cross-Node-context regular expression detection
* @param  {Object}  object Anything
* @return {Boolean}        true if the object is a regular expression,
* false otherwise
*/
function isRegExp(object) {
    return Object.prototype.toString.call(object) === "[object RegExp]";
}

// return the actual prototype of JSZip
var out = {
    /**
     * @see loadAsync
     */
    load: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
    },


    /**
     * Call a callback function for each entry at this folder level.
     * @param {Function} cb the callback function:
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     */
    forEach: function(cb) {
        var filename, relativePath, file;
        // ignore warning about unwanted properties because this.files is a null prototype object
        /* eslint-disable-next-line guard-for-in */
        for (filename in this.files) {
            file = this.files[filename];
            relativePath = filename.slice(this.root.length, filename.length);
            if (relativePath && filename.slice(0, this.root.length) === this.root) { // the file is in the current root
                cb(relativePath, file); // TODO reverse the parameters ? need to be clean AND consistent with the filter search fn...
            }
        }
    },

    /**
     * Filter nested files/folders with the specified function.
     * @param {Function} search the predicate to use :
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     * @return {Array} An array of matching elements.
     */
    filter: function(search) {
        var result = [];
        this.forEach(function (relativePath, entry) {
            if (search(relativePath, entry)) { // the file matches the function
                result.push(entry);
            }

        });
        return result;
    },

    /**
     * Add a file to the zip file, or search a file.
     * @param   {string|RegExp} name The name of the file to add (if data is defined),
     * the name of the file to find (if no data) or a regex to match files.
     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
     * @param   {Object} o     File options
     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
     * a file (when searching by string) or an array of files (when searching by regex).
     */
    file: function(name, data, o) {
        if (arguments.length === 1) {
            if (isRegExp(name)) {
                var regexp = name;
                return this.filter(function(relativePath, file) {
                    return !file.dir && regexp.test(relativePath);
                });
            }
            else { // text
                var obj = this.files[this.root + name];
                if (obj && !obj.dir) {
                    return obj;
                } else {
                    return null;
                }
            }
        }
        else { // more than one argument : we have data !
            name = this.root + name;
            fileAdd.call(this, name, data, o);
        }
        return this;
    },

    /**
     * Add a directory to the zip file, or search.
     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
     */
    folder: function(arg) {
        if (!arg) {
            return this;
        }

        if (isRegExp(arg)) {
            return this.filter(function(relativePath, file) {
                return file.dir && arg.test(relativePath);
            });
        }

        // else, name is a new folder
        var name = this.root + arg;
        var newFolder = folderAdd.call(this, name);

        // Allow chaining by returning a new object with this folder as the root
        var ret = this.clone();
        ret.root = newFolder.name;
        return ret;
    },

    /**
     * Delete a file, or a directory and all sub-files, from the zip
     * @param {string} name the name of the file to delete
     * @return {JSZip} this JSZip object
     */
    remove: function(name) {
        name = this.root + name;
        var file = this.files[name];
        if (!file) {
            // Look for any folders
            if (name.slice(-1) !== "/") {
                name += "/";
            }
            file = this.files[name];
        }

        if (file && !file.dir) {
            // file
            delete this.files[name];
        } else {
            // maybe a folder, delete recursively
            var kids = this.filter(function(relativePath, file) {
                return file.name.slice(0, name.length) === name;
            });
            for (var i = 0; i < kids.length; i++) {
                delete this.files[kids[i].name];
            }
        }

        return this;
    },

    /**
     * @deprecated This method has been removed in JSZip 3.0, please check the upgrade guide.
     */
    generate: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
    },

    /**
     * Generate the complete zip file as an internal stream.
     * @param {Object} options the options to generate the zip file :
     * - compression, "STORE" by default.
     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
     * @return {StreamHelper} the streamed zip file.
     */
    generateInternalStream: function(options) {
        var worker, opts = {};
        try {
            opts = utils.extend(options || {}, {
                streamFiles: false,
                compression: "STORE",
                compressionOptions : null,
                type: "",
                platform: "DOS",
                comment: null,
                mimeType: "application/zip",
                encodeFileName: utf8.utf8encode
            });

            opts.type = opts.type.toLowerCase();
            opts.compression = opts.compression.toUpperCase();

            // "binarystring" is preferred but the internals use "string".
            if(opts.type === "binarystring") {
                opts.type = "string";
            }

            if (!opts.type) {
                throw new Error("No output type specified.");
            }

            utils.checkSupport(opts.type);

            // accept nodejs `process.platform`
            if(
                opts.platform === "darwin" ||
                opts.platform === "freebsd" ||
                opts.platform === "linux" ||
                opts.platform === "sunos"
            ) {
                opts.platform = "UNIX";
            }
            if (opts.platform === "win32") {
                opts.platform = "DOS";
            }

            var comment = opts.comment || this.comment || "";
            worker = generate.generateWorker(this, opts, comment);
        } catch (e) {
            worker = new GenericWorker("error");
            worker.error(e);
        }
        return new StreamHelper(worker, opts.type || "string", opts.mimeType);
    },
    /**
     * Generate the complete zip file asynchronously.
     * @see generateInternalStream
     */
    generateAsync: function(options, onUpdate) {
        return this.generateInternalStream(options).accumulate(onUpdate);
    },
    /**
     * Generate the complete zip file asynchronously.
     * @see generateInternalStream
     */
    generateNodeStream: function(options, onUpdate) {
        options = options || {};
        if (!options.type) {
            options.type = "nodebuffer";
        }
        return this.generateInternalStream(options).toNodejsStream(onUpdate);
    }
};
module.exports = out;

},{"./compressedObject":2,"./defaults":5,"./generate":9,"./nodejs/NodejsStreamInputAdapter":12,"./nodejsUtils":14,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31,"./utils":32,"./zipObject":35}],16:[function(require,module,exports){
"use strict";
/*
 * This file is used by module bundlers (browserify/webpack/etc) when
 * including a stream implementation. We use "readable-stream" to get a
 * consistent behavior between nodejs versions but bundlers often have a shim
 * for "stream". Using this shim greatly improve the compatibility and greatly
 * reduce the final size of the bundle (only one stream implementation, not
 * two).
 */
module.exports = require("stream");

},{"stream":undefined}],17:[function(require,module,exports){
"use strict";
var DataReader = require("./DataReader");
var utils = require("../utils");

function ArrayReader(data) {
    DataReader.call(this, data);
    for(var i = 0; i < this.data.length; i++) {
        data[i] = data[i] & 0xFF;
    }
}
utils.inherits(ArrayReader, DataReader);
/**
 * @see DataReader.byteAt
 */
ArrayReader.prototype.byteAt = function(i) {
    return this.data[this.zero + i];
};
/**
 * @see DataReader.lastIndexOfSignature
 */
ArrayReader.prototype.lastIndexOfSignature = function(sig) {
    var sig0 = sig.charCodeAt(0),
        sig1 = sig.charCodeAt(1),
        sig2 = sig.charCodeAt(2),
        sig3 = sig.charCodeAt(3);
    for (var i = this.length - 4; i >= 0; --i) {
        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
            return i - this.zero;
        }
    }

    return -1;
};
/**
 * @see DataReader.readAndCheckSignature
 */
ArrayReader.prototype.readAndCheckSignature = function (sig) {
    var sig0 = sig.charCodeAt(0),
        sig1 = sig.charCodeAt(1),
        sig2 = sig.charCodeAt(2),
        sig3 = sig.charCodeAt(3),
        data = this.readData(4);
    return sig0 === data[0] && sig1 === data[1] && sig2 === data[2] && sig3 === data[3];
};
/**
 * @see DataReader.readData
 */
ArrayReader.prototype.readData = function(size) {
    this.checkOffset(size);
    if(size === 0) {
        return [];
    }
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = ArrayReader;

},{"../utils":32,"./DataReader":18}],18:[function(require,module,exports){
"use strict";
var utils = require("../utils");

function DataReader(data) {
    this.data = data; // type : see implementation
    this.length = data.length;
    this.index = 0;
    this.zero = 0;
}
DataReader.prototype = {
    /**
     * Check that the offset will not go too far.
     * @param {string} offset the additional offset to check.
     * @throws {Error} an Error if the offset is out of bounds.
     */
    checkOffset: function(offset) {
        this.checkIndex(this.index + offset);
    },
    /**
     * Check that the specified index will not be too far.
     * @param {string} newIndex the index to check.
     * @throws {Error} an Error if the index is out of bounds.
     */
    checkIndex: function(newIndex) {
        if (this.length < this.zero + newIndex || newIndex < 0) {
            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
        }
    },
    /**
     * Change the index.
     * @param {number} newIndex The new index.
     * @throws {Error} if the new index is out of the data.
     */
    setIndex: function(newIndex) {
        this.checkIndex(newIndex);
        this.index = newIndex;
    },
    /**
     * Skip the next n bytes.
     * @param {number} n the number of bytes to skip.
     * @throws {Error} if the new index is out of the data.
     */
    skip: function(n) {
        this.setIndex(this.index + n);
    },
    /**
     * Get the byte at the specified index.
     * @param {number} i the index to use.
     * @return {number} a byte.
     */
    byteAt: function() {
        // see implementations
    },
    /**
     * Get the next number with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {number} the corresponding number.
     */
    readInt: function(size) {
        var result = 0,
            i;
        this.checkOffset(size);
        for (i = this.index + size - 1; i >= this.index; i--) {
            result = (result << 8) + this.byteAt(i);
        }
        this.index += size;
        return result;
    },
    /**
     * Get the next string with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {string} the corresponding string.
     */
    readString: function(size) {
        return utils.transformTo("string", this.readData(size));
    },
    /**
     * Get raw data without conversion, <size> bytes.
     * @param {number} size the number of bytes to read.
     * @return {Object} the raw data, implementation specific.
     */
    readData: function() {
        // see implementations
    },
    /**
     * Find the last occurrence of a zip signature (4 bytes).
     * @param {string} sig the signature to find.
     * @return {number} the index of the last occurrence, -1 if not found.
     */
    lastIndexOfSignature: function() {
        // see implementations
    },
    /**
     * Read the signature (4 bytes) at the current position and compare it with sig.
     * @param {string} sig the expected signature
     * @return {boolean} true if the signature matches, false otherwise.
     */
    readAndCheckSignature: function() {
        // see implementations
    },
    /**
     * Get the next date.
     * @return {Date} the date.
     */
    readDate: function() {
        var dostime = this.readInt(4);
        return new Date(Date.UTC(
            ((dostime >> 25) & 0x7f) + 1980, // year
            ((dostime >> 21) & 0x0f) - 1, // month
            (dostime >> 16) & 0x1f, // day
            (dostime >> 11) & 0x1f, // hour
            (dostime >> 5) & 0x3f, // minute
            (dostime & 0x1f) << 1)); // second
    }
};
module.exports = DataReader;

},{"../utils":32}],19:[function(require,module,exports){
"use strict";
var Uint8ArrayReader = require("./Uint8ArrayReader");
var utils = require("../utils");

function NodeBufferReader(data) {
    Uint8ArrayReader.call(this, data);
}
utils.inherits(NodeBufferReader, Uint8ArrayReader);

/**
 * @see DataReader.readData
 */
NodeBufferReader.prototype.readData = function(size) {
    this.checkOffset(size);
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = NodeBufferReader;

},{"../utils":32,"./Uint8ArrayReader":21}],20:[function(require,module,exports){
"use strict";
var DataReader = require("./DataReader");
var utils = require("../utils");

function StringReader(data) {
    DataReader.call(this, data);
}
utils.inherits(StringReader, DataReader);
/**
 * @see DataReader.byteAt
 */
StringReader.prototype.byteAt = function(i) {
    return this.data.charCodeAt(this.zero + i);
};
/**
 * @see DataReader.lastIndexOfSignature
 */
StringReader.prototype.lastIndexOfSignature = function(sig) {
    return this.data.lastIndexOf(sig) - this.zero;
};
/**
 * @see DataReader.readAndCheckSignature
 */
StringReader.prototype.readAndCheckSignature = function (sig) {
    var data = this.readData(4);
    return sig === data;
};
/**
 * @see DataReader.readData
 */
StringReader.prototype.readData = function(size) {
    this.checkOffset(size);
    // this will work because the constructor applied the "& 0xff" mask.
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = StringReader;

},{"../utils":32,"./DataReader":18}],21:[function(require,module,exports){
"use strict";
var ArrayReader = require("./ArrayReader");
var utils = require("../utils");

function Uint8ArrayReader(data) {
    ArrayReader.call(this, data);
}
utils.inherits(Uint8ArrayReader, ArrayReader);
/**
 * @see DataReader.readData
 */
Uint8ArrayReader.prototype.readData = function(size) {
    this.checkOffset(size);
    if(size === 0) {
        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
        return new Uint8Array(0);
    }
    var result = this.data.subarray(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = Uint8ArrayReader;

},{"../utils":32,"./ArrayReader":17}],22:[function(require,module,exports){
"use strict";

var utils = require("../utils");
var support = require("../support");
var ArrayReader = require("./ArrayReader");
var StringReader = require("./StringReader");
var NodeBufferReader = require("./NodeBufferReader");
var Uint8ArrayReader = require("./Uint8ArrayReader");

/**
 * Create a reader adapted to the data.
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data to read.
 * @return {DataReader} the data reader.
 */
module.exports = function (data) {
    var type = utils.getTypeOf(data);
    utils.checkSupport(type);
    if (type === "string" && !support.uint8array) {
        return new StringReader(data);
    }
    if (type === "nodebuffer") {
        return new NodeBufferReader(data);
    }
    if (support.uint8array) {
        return new Uint8ArrayReader(utils.transformTo("uint8array", data));
    }
    return new ArrayReader(utils.transformTo("array", data));
};

},{"../support":30,"../utils":32,"./ArrayReader":17,"./NodeBufferReader":19,"./StringReader":20,"./Uint8ArrayReader":21}],23:[function(require,module,exports){
"use strict";
exports.LOCAL_FILE_HEADER = "PK\x03\x04";
exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
exports.DATA_DESCRIPTOR = "PK\x07\x08";

},{}],24:[function(require,module,exports){
"use strict";

var GenericWorker = require("./GenericWorker");
var utils = require("../utils");

/**
 * A worker which convert chunks to a specified type.
 * @constructor
 * @param {String} destType the destination type.
 */
function ConvertWorker(destType) {
    GenericWorker.call(this, "ConvertWorker to " + destType);
    this.destType = destType;
}
utils.inherits(ConvertWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
ConvertWorker.prototype.processChunk = function (chunk) {
    this.push({
        data : utils.transformTo(this.destType, chunk.data),
        meta : chunk.meta
    });
};
module.exports = ConvertWorker;

},{"../utils":32,"./GenericWorker":28}],25:[function(require,module,exports){
"use strict";

var GenericWorker = require("./GenericWorker");
var crc32 = require("../crc32");
var utils = require("../utils");

/**
 * A worker which calculate the crc32 of the data flowing through.
 * @constructor
 */
function Crc32Probe() {
    GenericWorker.call(this, "Crc32Probe");
    this.withStreamInfo("crc32", 0);
}
utils.inherits(Crc32Probe, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Crc32Probe.prototype.processChunk = function (chunk) {
    this.streamInfo.crc32 = crc32(chunk.data, this.streamInfo.crc32 || 0);
    this.push(chunk);
};
module.exports = Crc32Probe;

},{"../crc32":4,"../utils":32,"./GenericWorker":28}],26:[function(require,module,exports){
"use strict";

var utils = require("../utils");
var GenericWorker = require("./GenericWorker");

/**
 * A worker which calculate the total length of the data flowing through.
 * @constructor
 * @param {String} propName the name used to expose the length
 */
function DataLengthProbe(propName) {
    GenericWorker.call(this, "DataLengthProbe for " + propName);
    this.propName = propName;
    this.withStreamInfo(propName, 0);
}
utils.inherits(DataLengthProbe, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
DataLengthProbe.prototype.processChunk = function (chunk) {
    if(chunk) {
        var length = this.streamInfo[this.propName] || 0;
        this.streamInfo[this.propName] = length + chunk.data.length;
    }
    GenericWorker.prototype.processChunk.call(this, chunk);
};
module.exports = DataLengthProbe;


},{"../utils":32,"./GenericWorker":28}],27:[function(require,module,exports){
"use strict";

var utils = require("../utils");
var GenericWorker = require("./GenericWorker");

// the size of the generated chunks
// TODO expose this as a public variable
var DEFAULT_BLOCK_SIZE = 16 * 1024;

/**
 * A worker that reads a content and emits chunks.
 * @constructor
 * @param {Promise} dataP the promise of the data to split
 */
function DataWorker(dataP) {
    GenericWorker.call(this, "DataWorker");
    var self = this;
    this.dataIsReady = false;
    this.index = 0;
    this.max = 0;
    this.data = null;
    this.type = "";

    this._tickScheduled = false;

    dataP.then(function (data) {
        self.dataIsReady = true;
        self.data = data;
        self.max = data && data.length || 0;
        self.type = utils.getTypeOf(data);
        if(!self.isPaused) {
            self._tickAndRepeat();
        }
    }, function (e) {
        self.error(e);
    });
}

utils.inherits(DataWorker, GenericWorker);

/**
 * @see GenericWorker.cleanUp
 */
DataWorker.prototype.cleanUp = function () {
    GenericWorker.prototype.cleanUp.call(this);
    this.data = null;
};

/**
 * @see GenericWorker.resume
 */
DataWorker.prototype.resume = function () {
    if(!GenericWorker.prototype.resume.call(this)) {
        return false;
    }

    if (!this._tickScheduled && this.dataIsReady) {
        this._tickScheduled = true;
        utils.delay(this._tickAndRepeat, [], this);
    }
    return true;
};

/**
 * Trigger a tick a schedule an other call to this function.
 */
DataWorker.prototype._tickAndRepeat = function() {
    this._tickScheduled = false;
    if(this.isPaused || this.isFinished) {
        return;
    }
    this._tick();
    if(!this.isFinished) {
        utils.delay(this._tickAndRepeat, [], this);
        this._tickScheduled = true;
    }
};

/**
 * Read and push a chunk.
 */
DataWorker.prototype._tick = function() {

    if(this.isPaused || this.isFinished) {
        return false;
    }

    var size = DEFAULT_BLOCK_SIZE;
    var data = null, nextIndex = Math.min(this.max, this.index + size);
    if (this.index >= this.max) {
        // EOF
        return this.end();
    } else {
        switch(this.type) {
        case "string":
            data = this.data.substring(this.index, nextIndex);
            break;
        case "uint8array":
            data = this.data.subarray(this.index, nextIndex);
            break;
        case "array":
        case "nodebuffer":
            data = this.data.slice(this.index, nextIndex);
            break;
        }
        this.index = nextIndex;
        return this.push({
            data : data,
            meta : {
                percent : this.max ? this.index / this.max * 100 : 0
            }
        });
    }
};

module.exports = DataWorker;

},{"../utils":32,"./GenericWorker":28}],28:[function(require,module,exports){
"use strict";

/**
 * A worker that does nothing but passing chunks to the next one. This is like
 * a nodejs stream but with some differences. On the good side :
 * - it works on IE 6-9 without any issue / polyfill
 * - it weights less than the full dependencies bundled with browserify
 * - it forwards errors (no need to declare an error handler EVERYWHERE)
 *
 * A chunk is an object with 2 attributes : `meta` and `data`. The former is an
 * object containing anything (`percent` for example), see each worker for more
 * details. The latter is the real data (String, Uint8Array, etc).
 *
 * @constructor
 * @param {String} name the name of the stream (mainly used for debugging purposes)
 */
function GenericWorker(name) {
    // the name of the worker
    this.name = name || "default";
    // an object containing metadata about the workers chain
    this.streamInfo = {};
    // an error which happened when the worker was paused
    this.generatedError = null;
    // an object containing metadata to be merged by this worker into the general metadata
    this.extraStreamInfo = {};
    // true if the stream is paused (and should not do anything), false otherwise
    this.isPaused = true;
    // true if the stream is finished (and should not do anything), false otherwise
    this.isFinished = false;
    // true if the stream is locked to prevent further structure updates (pipe), false otherwise
    this.isLocked = false;
    // the event listeners
    this._listeners = {
        "data":[],
        "end":[],
        "error":[]
    };
    // the previous worker, if any
    this.previous = null;
}

GenericWorker.prototype = {
    /**
     * Push a chunk to the next workers.
     * @param {Object} chunk the chunk to push
     */
    push : function (chunk) {
        this.emit("data", chunk);
    },
    /**
     * End the stream.
     * @return {Boolean} true if this call ended the worker, false otherwise.
     */
    end : function () {
        if (this.isFinished) {
            return false;
        }

        this.flush();
        try {
            this.emit("end");
            this.cleanUp();
            this.isFinished = true;
        } catch (e) {
            this.emit("error", e);
        }
        return true;
    },
    /**
     * End the stream with an error.
     * @param {Error} e the error which caused the premature end.
     * @return {Boolean} true if this call ended the worker with an error, false otherwise.
     */
    error : function (e) {
        if (this.isFinished) {
            return false;
        }

        if(this.isPaused) {
            this.generatedError = e;
        } else {
            this.isFinished = true;

            this.emit("error", e);

            // in the workers chain exploded in the middle of the chain,
            // the error event will go downward but we also need to notify
            // workers upward that there has been an error.
            if(this.previous) {
                this.previous.error(e);
            }

            this.cleanUp();
        }
        return true;
    },
    /**
     * Add a callback on an event.
     * @param {String} name the name of the event (data, end, error)
     * @param {Function} listener the function to call when the event is triggered
     * @return {GenericWorker} the current object for chainability
     */
    on : function (name, listener) {
        this._listeners[name].push(listener);
        return this;
    },
    /**
     * Clean any references when a worker is ending.
     */
    cleanUp : function () {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null;
        this._listeners = [];
    },
    /**
     * Trigger an event. This will call registered callback with the provided arg.
     * @param {String} name the name of the event (data, end, error)
     * @param {Object} arg the argument to call the callback with.
     */
    emit : function (name, arg) {
        if (this._listeners[name]) {
            for(var i = 0; i < this._listeners[name].length; i++) {
                this._listeners[name][i].call(this, arg);
            }
        }
    },
    /**
     * Chain a worker with an other.
     * @param {Worker} next the worker receiving events from the current one.
     * @return {worker} the next worker for chainability
     */
    pipe : function (next) {
        return next.registerPrevious(this);
    },
    /**
     * Same as `pipe` in the other direction.
     * Using an API with `pipe(next)` is very easy.
     * Implementing the API with the point of view of the next one registering
     * a source is easier, see the ZipFileWorker.
     * @param {Worker} previous the previous worker, sending events to this one
     * @return {Worker} the current worker for chainability
     */
    registerPrevious : function (previous) {
        if (this.isLocked) {
            throw new Error("The stream '" + this + "' has already been used.");
        }

        // sharing the streamInfo...
        this.streamInfo = previous.streamInfo;
        // ... and adding our own bits
        this.mergeStreamInfo();
        this.previous =  previous;
        var self = this;
        previous.on("data", function (chunk) {
            self.processChunk(chunk);
        });
        previous.on("end", function () {
            self.end();
        });
        previous.on("error", function (e) {
            self.error(e);
        });
        return this;
    },
    /**
     * Pause the stream so it doesn't send events anymore.
     * @return {Boolean} true if this call paused the worker, false otherwise.
     */
    pause : function () {
        if(this.isPaused || this.isFinished) {
            return false;
        }
        this.isPaused = true;

        if(this.previous) {
            this.previous.pause();
        }
        return true;
    },
    /**
     * Resume a paused stream.
     * @return {Boolean} true if this call resumed the worker, false otherwise.
     */
    resume : function () {
        if(!this.isPaused || this.isFinished) {
            return false;
        }
        this.isPaused = false;

        // if true, the worker tried to resume but failed
        var withError = false;
        if(this.generatedError) {
            this.error(this.generatedError);
            withError = true;
        }
        if(this.previous) {
            this.previous.resume();
        }

        return !withError;
    },
    /**
     * Flush any remaining bytes as the stream is ending.
     */
    flush : function () {},
    /**
     * Process a chunk. This is usually the method overridden.
     * @param {Object} chunk the chunk to process.
     */
    processChunk : function(chunk) {
        this.push(chunk);
    },
    /**
     * Add a key/value to be added in the workers chain streamInfo once activated.
     * @param {String} key the key to use
     * @param {Object} value the associated value
     * @return {Worker} the current worker for chainability
     */
    withStreamInfo : function (key, value) {
        this.extraStreamInfo[key] = value;
        this.mergeStreamInfo();
        return this;
    },
    /**
     * Merge this worker's streamInfo into the chain's streamInfo.
     */
    mergeStreamInfo : function () {
        for(var key in this.extraStreamInfo) {
            if (!Object.prototype.hasOwnProperty.call(this.extraStreamInfo, key)) {
                continue;
            }
            this.streamInfo[key] = this.extraStreamInfo[key];
        }
    },

    /**
     * Lock the stream to prevent further updates on the workers chain.
     * After calling this method, all calls to pipe will fail.
     */
    lock: function () {
        if (this.isLocked) {
            throw new Error("The stream '" + this + "' has already been used.");
        }
        this.isLocked = true;
        if (this.previous) {
            this.previous.lock();
        }
    },

    /**
     *
     * Pretty print the workers chain.
     */
    toString : function () {
        var me = "Worker " + this.name;
        if (this.previous) {
            return this.previous + " -> " + me;
        } else {
            return me;
        }
    }
};

module.exports = GenericWorker;

},{}],29:[function(require,module,exports){
"use strict";

var utils = require("../utils");
var ConvertWorker = require("./ConvertWorker");
var GenericWorker = require("./GenericWorker");
var base64 = require("../base64");
var support = require("../support");
var external = require("../external");

var NodejsStreamOutputAdapter = null;
if (support.nodestream) {
    try {
        NodejsStreamOutputAdapter = require("../nodejs/NodejsStreamOutputAdapter");
    } catch(e) {
        // ignore
    }
}

/**
 * Apply the final transformation of the data. If the user wants a Blob for
 * example, it's easier to work with an U8intArray and finally do the
 * ArrayBuffer/Blob conversion.
 * @param {String} type the name of the final type
 * @param {String|Uint8Array|Buffer} content the content to transform
 * @param {String} mimeType the mime type of the content, if applicable.
 * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the content in the right format.
 */
function transformZipOutput(type, content, mimeType) {
    switch(type) {
    case "blob" :
        return utils.newBlob(utils.transformTo("arraybuffer", content), mimeType);
    case "base64" :
        return base64.encode(content);
    default :
        return utils.transformTo(type, content);
    }
}

/**
 * Concatenate an array of data of the given type.
 * @param {String} type the type of the data in the given array.
 * @param {Array} dataArray the array containing the data chunks to concatenate
 * @return {String|Uint8Array|Buffer} the concatenated data
 * @throws Error if the asked type is unsupported
 */
function concat (type, dataArray) {
    var i, index = 0, res = null, totalLength = 0;
    for(i = 0; i < dataArray.length; i++) {
        totalLength += dataArray[i].length;
    }
    switch(type) {
    case "string":
        return dataArray.join("");
    case "array":
        return Array.prototype.concat.apply([], dataArray);
    case "uint8array":
        res = new Uint8Array(totalLength);
        for(i = 0; i < dataArray.length; i++) {
            res.set(dataArray[i], index);
            index += dataArray[i].length;
        }
        return res;
    case "nodebuffer":
        return Buffer.concat(dataArray);
    default:
        throw new Error("concat : unsupported type '"  + type + "'");
    }
}

/**
 * Listen a StreamHelper, accumulate its content and concatenate it into a
 * complete block.
 * @param {StreamHelper} helper the helper to use.
 * @param {Function} updateCallback a callback called on each update. Called
 * with one arg :
 * - the metadata linked to the update received.
 * @return Promise the promise for the accumulation.
 */
function accumulate(helper, updateCallback) {
    return new external.Promise(function (resolve, reject){
        var dataArray = [];
        var chunkType = helper._internalType,
            resultType = helper._outputType,
            mimeType = helper._mimeType;
        helper
            .on("data", function (data, meta) {
                dataArray.push(data);
                if(updateCallback) {
                    updateCallback(meta);
                }
            })
            .on("error", function(err) {
                dataArray = [];
                reject(err);
            })
            .on("end", function (){
                try {
                    var result = transformZipOutput(resultType, concat(chunkType, dataArray), mimeType);
                    resolve(result);
                } catch (e) {
                    reject(e);
                }
                dataArray = [];
            })
            .resume();
    });
}

/**
 * An helper to easily use workers outside of JSZip.
 * @constructor
 * @param {Worker} worker the worker to wrap
 * @param {String} outputType the type of data expected by the use
 * @param {String} mimeType the mime type of the content, if applicable.
 */
function StreamHelper(worker, outputType, mimeType) {
    var internalType = outputType;
    switch(outputType) {
    case "blob":
    case "arraybuffer":
        internalType = "uint8array";
        break;
    case "base64":
        internalType = "string";
        break;
    }

    try {
        // the type used internally
        this._internalType = internalType;
        // the type used to output results
        this._outputType = outputType;
        // the mime type
        this._mimeType = mimeType;
        utils.checkSupport(internalType);
        this._worker = worker.pipe(new ConvertWorker(internalType));
        // the last workers can be rewired without issues but we need to
        // prevent any updates on previous workers.
        worker.lock();
    } catch(e) {
        this._worker = new GenericWorker("error");
        this._worker.error(e);
    }
}

StreamHelper.prototype = {
    /**
     * Listen a StreamHelper, accumulate its content and concatenate it into a
     * complete block.
     * @param {Function} updateCb the update callback.
     * @return Promise the promise for the accumulation.
     */
    accumulate : function (updateCb) {
        return accumulate(this, updateCb);
    },
    /**
     * Add a listener on an event triggered on a stream.
     * @param {String} evt the name of the event
     * @param {Function} fn the listener
     * @return {StreamHelper} the current helper.
     */
    on : function (evt, fn) {
        var self = this;

        if(evt === "data") {
            this._worker.on(evt, function (chunk) {
                fn.call(self, chunk.data, chunk.meta);
            });
        } else {
            this._worker.on(evt, function () {
                utils.delay(fn, arguments, self);
            });
        }
        return this;
    },
    /**
     * Resume the flow of chunks.
     * @return {StreamHelper} the current helper.
     */
    resume : function () {
        utils.delay(this._worker.resume, [], this._worker);
        return this;
    },
    /**
     * Pause the flow of chunks.
     * @return {StreamHelper} the current helper.
     */
    pause : function () {
        this._worker.pause();
        return this;
    },
    /**
     * Return a nodejs stream for this helper.
     * @param {Function} updateCb the update callback.
     * @return {NodejsStreamOutputAdapter} the nodejs stream.
     */
    toNodejsStream : function (updateCb) {
        utils.checkSupport("nodestream");
        if (this._outputType !== "nodebuffer") {
            // an object stream containing blob/arraybuffer/uint8array/string
            // is strange and I don't know if it would be useful.
            // I you find this comment and have a good usecase, please open a
            // bug report !
            throw new Error(this._outputType + " is not supported by this method");
        }

        return new NodejsStreamOutputAdapter(this, {
            objectMode : this._outputType !== "nodebuffer"
        }, updateCb);
    }
};


module.exports = StreamHelper;

},{"../base64":1,"../external":6,"../nodejs/NodejsStreamOutputAdapter":13,"../support":30,"../utils":32,"./ConvertWorker":24,"./GenericWorker":28}],30:[function(require,module,exports){
"use strict";

exports.base64 = true;
exports.array = true;
exports.string = true;
exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
exports.nodebuffer = typeof Buffer !== "undefined";
// contains true if JSZip can read/generate Uint8Array, false otherwise.
exports.uint8array = typeof Uint8Array !== "undefined";

if (typeof ArrayBuffer === "undefined") {
    exports.blob = false;
}
else {
    var buffer = new ArrayBuffer(0);
    try {
        exports.blob = new Blob([buffer], {
            type: "application/zip"
        }).size === 0;
    }
    catch (e) {
        try {
            var Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
            var builder = new Builder();
            builder.append(buffer);
            exports.blob = builder.getBlob("application/zip").size === 0;
        }
        catch (e) {
            exports.blob = false;
        }
    }
}

try {
    exports.nodestream = !!require("readable-stream").Readable;
} catch(e) {
    exports.nodestream = false;
}

},{"readable-stream":16}],31:[function(require,module,exports){
"use strict";

var utils = require("./utils");
var support = require("./support");
var nodejsUtils = require("./nodejsUtils");
var GenericWorker = require("./stream/GenericWorker");

/**
 * The following functions come from pako, from pako/lib/utils/strings
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */

// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new Array(256);
for (var i=0; i<256; i++) {
    _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
}
_utf8len[254]=_utf8len[254]=1; // Invalid sequence start

// convert string to array (typed, when possible)
var string2buf = function (str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

    // count binary size
    for (m_pos = 0; m_pos < str_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }

    // allocate buffer
    if (support.uint8array) {
        buf = new Uint8Array(buf_len);
    } else {
        buf = new Array(buf_len);
    }

    // convert
    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) {
            /* one byte */
            buf[i++] = c;
        } else if (c < 0x800) {
            /* two bytes */
            buf[i++] = 0xC0 | (c >>> 6);
            buf[i++] = 0x80 | (c & 0x3f);
        } else if (c < 0x10000) {
            /* three bytes */
            buf[i++] = 0xE0 | (c >>> 12);
            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        } else {
            /* four bytes */
            buf[i++] = 0xf0 | (c >>> 18);
            buf[i++] = 0x80 | (c >>> 12 & 0x3f);
            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        }
    }

    return buf;
};

// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var utf8border = function(buf, max) {
    var pos;

    max = max || buf.length;
    if (max > buf.length) { max = buf.length; }

    // go back from last position, until start of sequence found
    pos = max-1;
    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

    // Fuckup - very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) { return max; }

    // If we came to start of buffer - that means vuffer is too small,
    // return max too.
    if (pos === 0) { return max; }

    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

// convert array to string
var buf2string = function (buf) {
    var i, out, c, c_len;
    var len = buf.length;

    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len*2);

    for (out=0, i=0; i<len;) {
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) { utf16buf[out++] = c; continue; }

        c_len = _utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }

        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while (c_len > 1 && i < len) {
            c = (c << 6) | (buf[i++] & 0x3f);
            c_len--;
        }

        // terminated by end of string?
        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

        if (c < 0x10000) {
            utf16buf[out++] = c;
        } else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
        }
    }

    // shrinkBuf(utf16buf, out)
    if (utf16buf.length !== out) {
        if(utf16buf.subarray) {
            utf16buf = utf16buf.subarray(0, out);
        } else {
            utf16buf.length = out;
        }
    }

    // return String.fromCharCode.apply(null, utf16buf);
    return utils.applyFromCharCode(utf16buf);
};


// That's all for the pako functions.


/**
 * Transform a javascript string into an array (typed if possible) of bytes,
 * UTF-8 encoded.
 * @param {String} str the string to encode
 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
 */
exports.utf8encode = function utf8encode(str) {
    if (support.nodebuffer) {
        return nodejsUtils.newBufferFrom(str, "utf-8");
    }

    return string2buf(str);
};


/**
 * Transform a bytes array (or a representation) representing an UTF-8 encoded
 * string into a javascript string.
 * @param {Array|Uint8Array|Buffer} buf the data de decode
 * @return {String} the decoded string.
 */
exports.utf8decode = function utf8decode(buf) {
    if (support.nodebuffer) {
        return utils.transformTo("nodebuffer", buf).toString("utf-8");
    }

    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);

    return buf2string(buf);
};

/**
 * A worker to decode utf8 encoded binary chunks into string chunks.
 * @constructor
 */
function Utf8DecodeWorker() {
    GenericWorker.call(this, "utf-8 decode");
    // the last bytes if a chunk didn't end with a complete codepoint.
    this.leftOver = null;
}
utils.inherits(Utf8DecodeWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Utf8DecodeWorker.prototype.processChunk = function (chunk) {

    var data = utils.transformTo(support.uint8array ? "uint8array" : "array", chunk.data);

    // 1st step, re-use what's left of the previous chunk
    if (this.leftOver && this.leftOver.length) {
        if(support.uint8array) {
            var previousData = data;
            data = new Uint8Array(previousData.length + this.leftOver.length);
            data.set(this.leftOver, 0);
            data.set(previousData, this.leftOver.length);
        } else {
            data = this.leftOver.concat(data);
        }
        this.leftOver = null;
    }

    var nextBoundary = utf8border(data);
    var usableData = data;
    if (nextBoundary !== data.length) {
        if (support.uint8array) {
            usableData = data.subarray(0, nextBoundary);
            this.leftOver = data.subarray(nextBoundary, data.length);
        } else {
            usableData = data.slice(0, nextBoundary);
            this.leftOver = data.slice(nextBoundary, data.length);
        }
    }

    this.push({
        data : exports.utf8decode(usableData),
        meta : chunk.meta
    });
};

/**
 * @see GenericWorker.flush
 */
Utf8DecodeWorker.prototype.flush = function () {
    if(this.leftOver && this.leftOver.length) {
        this.push({
            data : exports.utf8decode(this.leftOver),
            meta : {}
        });
        this.leftOver = null;
    }
};
exports.Utf8DecodeWorker = Utf8DecodeWorker;

/**
 * A worker to endcode string chunks into utf8 encoded binary chunks.
 * @constructor
 */
function Utf8EncodeWorker() {
    GenericWorker.call(this, "utf-8 encode");
}
utils.inherits(Utf8EncodeWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Utf8EncodeWorker.prototype.processChunk = function (chunk) {
    this.push({
        data : exports.utf8encode(chunk.data),
        meta : chunk.meta
    });
};
exports.Utf8EncodeWorker = Utf8EncodeWorker;

},{"./nodejsUtils":14,"./stream/GenericWorker":28,"./support":30,"./utils":32}],32:[function(require,module,exports){
"use strict";

var support = require("./support");
var base64 = require("./base64");
var nodejsUtils = require("./nodejsUtils");
var external = require("./external");
require("setimmediate");


/**
 * Convert a string that pass as a "binary string": it should represent a byte
 * array but may have > 255 char codes. Be sure to take only the first byte
 * and returns the byte array.
 * @param {String} str the string to transform.
 * @return {Array|Uint8Array} the string in a binary format.
 */
function string2binary(str) {
    var result = null;
    if (support.uint8array) {
        result = new Uint8Array(str.length);
    } else {
        result = new Array(str.length);
    }
    return stringToArrayLike(str, result);
}

/**
 * Create a new blob with the given content and the given type.
 * @param {String|ArrayBuffer} part the content to put in the blob. DO NOT use
 * an Uint8Array because the stock browser of android 4 won't accept it (it
 * will be silently converted to a string, "[object Uint8Array]").
 *
 * Use only ONE part to build the blob to avoid a memory leak in IE11 / Edge:
 * when a large amount of Array is used to create the Blob, the amount of
 * memory consumed is nearly 100 times the original data amount.
 *
 * @param {String} type the mime type of the blob.
 * @return {Blob} the created blob.
 */
exports.newBlob = function(part, type) {
    exports.checkSupport("blob");

    try {
        // Blob constructor
        return new Blob([part], {
            type: type
        });
    }
    catch (e) {

        try {
            // deprecated, browser only, old way
            var Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
            var builder = new Builder();
            builder.append(part);
            return builder.getBlob(type);
        }
        catch (e) {

            // well, fuck ?!
            throw new Error("Bug : can't construct the Blob.");
        }
    }


};
/**
 * The identity function.
 * @param {Object} input the input.
 * @return {Object} the same input.
 */
function identity(input) {
    return input;
}

/**
 * Fill in an array with a string.
 * @param {String} str the string to use.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
 */
function stringToArrayLike(str, array) {
    for (var i = 0; i < str.length; ++i) {
        array[i] = str.charCodeAt(i) & 0xFF;
    }
    return array;
}

/**
 * An helper for the function arrayLikeToString.
 * This contains static information and functions that
 * can be optimized by the browser JIT compiler.
 */
var arrayToStringHelper = {
    /**
     * Transform an array of int into a string, chunk by chunk.
     * See the performances notes on arrayLikeToString.
     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
     * @param {String} type the type of the array.
     * @param {Integer} chunk the chunk size.
     * @return {String} the resulting string.
     * @throws Error if the chunk is too big for the stack.
     */
    stringifyByChunk: function(array, type, chunk) {
        var result = [], k = 0, len = array.length;
        // shortcut
        if (len <= chunk) {
            return String.fromCharCode.apply(null, array);
        }
        while (k < len) {
            if (type === "array" || type === "nodebuffer") {
                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
            }
            else {
                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
            }
            k += chunk;
        }
        return result.join("");
    },
    /**
     * Call String.fromCharCode on every item in the array.
     * This is the naive implementation, which generate A LOT of intermediate string.
     * This should be used when everything else fail.
     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
     * @return {String} the result.
     */
    stringifyByChar: function(array){
        var resultStr = "";
        for(var i = 0; i < array.length; i++) {
            resultStr += String.fromCharCode(array[i]);
        }
        return resultStr;
    },
    applyCanBeUsed : {
        /**
         * true if the browser accepts to use String.fromCharCode on Uint8Array
         */
        uint8array : (function () {
            try {
                return support.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
            } catch (e) {
                return false;
            }
        })(),
        /**
         * true if the browser accepts to use String.fromCharCode on nodejs Buffer.
         */
        nodebuffer : (function () {
            try {
                return support.nodebuffer && String.fromCharCode.apply(null, nodejsUtils.allocBuffer(1)).length === 1;
            } catch (e) {
                return false;
            }
        })()
    }
};

/**
 * Transform an array-like object to a string.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
 * @return {String} the result.
 */
function arrayLikeToString(array) {
    // Performances notes :
    // --------------------
    // String.fromCharCode.apply(null, array) is the fastest, see
    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
    // but the stack is limited (and we can get huge arrays !).
    //
    // result += String.fromCharCode(array[i]); generate too many strings !
    //
    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
    // TODO : we now have workers that split the work. Do we still need that ?
    var chunk = 65536,
        type = exports.getTypeOf(array),
        canUseApply = true;
    if (type === "uint8array") {
        canUseApply = arrayToStringHelper.applyCanBeUsed.uint8array;
    } else if (type === "nodebuffer") {
        canUseApply = arrayToStringHelper.applyCanBeUsed.nodebuffer;
    }

    if (canUseApply) {
        while (chunk > 1) {
            try {
                return arrayToStringHelper.stringifyByChunk(array, type, chunk);
            } catch (e) {
                chunk = Math.floor(chunk / 2);
            }
        }
    }

    // no apply or chunk error : slow and painful algorithm
    // default browser on android 4.*
    return arrayToStringHelper.stringifyByChar(array);
}

exports.applyFromCharCode = arrayLikeToString;


/**
 * Copy the data from an array-like to an other array-like.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
 */
function arrayLikeToArrayLike(arrayFrom, arrayTo) {
    for (var i = 0; i < arrayFrom.length; i++) {
        arrayTo[i] = arrayFrom[i];
    }
    return arrayTo;
}

// a matrix containing functions to transform everything into everything.
var transform = {};

// string to ?
transform["string"] = {
    "string": identity,
    "array": function(input) {
        return stringToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["string"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return stringToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": function(input) {
        return stringToArrayLike(input, nodejsUtils.allocBuffer(input.length));
    }
};

// array to ?
transform["array"] = {
    "string": arrayLikeToString,
    "array": identity,
    "arraybuffer": function(input) {
        return (new Uint8Array(input)).buffer;
    },
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodejsUtils.newBufferFrom(input);
    }
};

// arraybuffer to ?
transform["arraybuffer"] = {
    "string": function(input) {
        return arrayLikeToString(new Uint8Array(input));
    },
    "array": function(input) {
        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
    },
    "arraybuffer": identity,
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodejsUtils.newBufferFrom(new Uint8Array(input));
    }
};

// uint8array to ?
transform["uint8array"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return input.buffer;
    },
    "uint8array": identity,
    "nodebuffer": function(input) {
        return nodejsUtils.newBufferFrom(input);
    }
};

// nodebuffer to ?
transform["nodebuffer"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["nodebuffer"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": identity
};

/**
 * Transform an input into any type.
 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
 * If no output type is specified, the unmodified input will be returned.
 * @param {String} outputType the output type.
 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
 * @throws {Error} an Error if the browser doesn't support the requested output type.
 */
exports.transformTo = function(outputType, input) {
    if (!input) {
        // undefined, null, etc
        // an empty string won't harm.
        input = "";
    }
    if (!outputType) {
        return input;
    }
    exports.checkSupport(outputType);
    var inputType = exports.getTypeOf(input);
    var result = transform[inputType][outputType](input);
    return result;
};

/**
 * Resolve all relative path components, "." and "..", in a path. If these relative components
 * traverse above the root then the resulting path will only contain the final path component.
 *
 * All empty components, e.g. "//", are removed.
 * @param {string} path A path with / or \ separators
 * @returns {string} The path with all relative path components resolved.
 */
exports.resolve = function(path) {
    var parts = path.split("/");
    var result = [];
    for (var index = 0; index < parts.length; index++) {
        var part = parts[index];
        // Allow the first and last component to be empty for trailing slashes.
        if (part === "." || (part === "" && index !== 0 && index !== parts.length - 1)) {
            continue;
        } else if (part === "..") {
            result.pop();
        } else {
            result.push(part);
        }
    }
    return result.join("/");
};

/**
 * Return the type of the input.
 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
 * @param {Object} input the input to identify.
 * @return {String} the (lowercase) type of the input.
 */
exports.getTypeOf = function(input) {
    if (typeof input === "string") {
        return "string";
    }
    if (Object.prototype.toString.call(input) === "[object Array]") {
        return "array";
    }
    if (support.nodebuffer && nodejsUtils.isBuffer(input)) {
        return "nodebuffer";
    }
    if (support.uint8array && input instanceof Uint8Array) {
        return "uint8array";
    }
    if (support.arraybuffer && input instanceof ArrayBuffer) {
        return "arraybuffer";
    }
};

/**
 * Throw an exception if the type is not supported.
 * @param {String} type the type to check.
 * @throws {Error} an Error if the browser doesn't support the requested type.
 */
exports.checkSupport = function(type) {
    var supported = support[type.toLowerCase()];
    if (!supported) {
        throw new Error(type + " is not supported by this platform");
    }
};

exports.MAX_VALUE_16BITS = 65535;
exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1

/**
 * Prettify a string read as binary.
 * @param {string} str the string to prettify.
 * @return {string} a pretty string.
 */
exports.pretty = function(str) {
    var res = "",
        code, i;
    for (i = 0; i < (str || "").length; i++) {
        code = str.charCodeAt(i);
        res += "\\x" + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
    }
    return res;
};

/**
 * Defer the call of a function.
 * @param {Function} callback the function to call asynchronously.
 * @param {Array} args the arguments to give to the callback.
 */
exports.delay = function(callback, args, self) {
    setImmediate(function () {
        callback.apply(self || null, args || []);
    });
};

/**
 * Extends a prototype with an other, without calling a constructor with
 * side effects. Inspired by nodejs' `utils.inherits`
 * @param {Function} ctor the constructor to augment
 * @param {Function} superCtor the parent constructor to use
 */
exports.inherits = function (ctor, superCtor) {
    var Obj = function() {};
    Obj.prototype = superCtor.prototype;
    ctor.prototype = new Obj();
};

/**
 * Merge the objects passed as parameters into a new one.
 * @private
 * @param {...Object} var_args All objects to merge.
 * @return {Object} a new object with the data of the others.
 */
exports.extend = function() {
    var result = {}, i, attr;
    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
        for (attr in arguments[i]) {
            if (Object.prototype.hasOwnProperty.call(arguments[i], attr) && typeof result[attr] === "undefined") {
                result[attr] = arguments[i][attr];
            }
        }
    }
    return result;
};

/**
 * Transform arbitrary content into a Promise.
 * @param {String} name a name for the content being processed.
 * @param {Object} inputData the content to process.
 * @param {Boolean} isBinary true if the content is not an unicode string
 * @param {Boolean} isOptimizedBinaryString true if the string content only has one byte per character.
 * @param {Boolean} isBase64 true if the string content is encoded with base64.
 * @return {Promise} a promise in a format usable by JSZip.
 */
exports.prepareContent = function(name, inputData, isBinary, isOptimizedBinaryString, isBase64) {

    // if inputData is already a promise, this flatten it.
    var promise = external.Promise.resolve(inputData).then(function(data) {


        var isBlob = support.blob && (data instanceof Blob || ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(data)) !== -1);

        if (isBlob && typeof FileReader !== "undefined") {
            return new external.Promise(function (resolve, reject) {
                var reader = new FileReader();

                reader.onload = function(e) {
                    resolve(e.target.result);
                };
                reader.onerror = function(e) {
                    reject(e.target.error);
                };
                reader.readAsArrayBuffer(data);
            });
        } else {
            return data;
        }
    });

    return promise.then(function(data) {
        var dataType = exports.getTypeOf(data);

        if (!dataType) {
            return external.Promise.reject(
                new Error("Can't read the data of '" + name + "'. Is it " +
                          "in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?")
            );
        }
        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
        if (dataType === "arraybuffer") {
            data = exports.transformTo("uint8array", data);
        } else if (dataType === "string") {
            if (isBase64) {
                data = base64.decode(data);
            }
            else if (isBinary) {
                // optimizedBinaryString === true means that the file has already been filtered with a 0xFF mask
                if (isOptimizedBinaryString !== true) {
                    // this is a string, not in a base64 format.
                    // Be sure that this is a correct "binary string"
                    data = string2binary(data);
                }
            }
        }
        return data;
    });
};

},{"./base64":1,"./external":6,"./nodejsUtils":14,"./support":30,"setimmediate":54}],33:[function(require,module,exports){
"use strict";
var readerFor = require("./reader/readerFor");
var utils = require("./utils");
var sig = require("./signature");
var ZipEntry = require("./zipEntry");
var support = require("./support");
//  class ZipEntries {{{
/**
 * All the entries in the zip file.
 * @constructor
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntries(loadOptions) {
    this.files = [];
    this.loadOptions = loadOptions;
}
ZipEntries.prototype = {
    /**
     * Check that the reader is on the specified signature.
     * @param {string} expectedSignature the expected signature.
     * @throws {Error} if it is an other signature.
     */
    checkSignature: function(expectedSignature) {
        if (!this.reader.readAndCheckSignature(expectedSignature)) {
            this.reader.index -= 4;
            var signature = this.reader.readString(4);
            throw new Error("Corrupted zip or bug: unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
        }
    },
    /**
     * Check if the given signature is at the given index.
     * @param {number} askedIndex the index to check.
     * @param {string} expectedSignature the signature to expect.
     * @return {boolean} true if the signature is here, false otherwise.
     */
    isSignature: function(askedIndex, expectedSignature) {
        var currentIndex = this.reader.index;
        this.reader.setIndex(askedIndex);
        var signature = this.reader.readString(4);
        var result = signature === expectedSignature;
        this.reader.setIndex(currentIndex);
        return result;
    },
    /**
     * Read the end of the central directory.
     */
    readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2);
        this.diskWithCentralDirStart = this.reader.readInt(2);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
        this.centralDirRecords = this.reader.readInt(2);
        this.centralDirSize = this.reader.readInt(4);
        this.centralDirOffset = this.reader.readInt(4);

        this.zipCommentLength = this.reader.readInt(2);
        // warning : the encoding depends of the system locale
        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
        // On a windows machine, this field is encoded with the localized windows code page.
        var zipComment = this.reader.readData(this.zipCommentLength);
        var decodeParamType = support.uint8array ? "uint8array" : "array";
        // To get consistent behavior with the generation part, we will assume that
        // this is utf8 encoded unless specified otherwise.
        var decodeContent = utils.transformTo(decodeParamType, zipComment);
        this.zipComment = this.loadOptions.decodeFileName(decodeContent);
    },
    /**
     * Read the end of the Zip 64 central directory.
     * Not merged with the method readEndOfCentral :
     * The end of central can coexist with its Zip64 brother,
     * I don't want to read the wrong number of bytes !
     */
    readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8);
        this.reader.skip(4);
        // this.versionMadeBy = this.reader.readString(2);
        // this.versionNeeded = this.reader.readInt(2);
        this.diskNumber = this.reader.readInt(4);
        this.diskWithCentralDirStart = this.reader.readInt(4);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
        this.centralDirRecords = this.reader.readInt(8);
        this.centralDirSize = this.reader.readInt(8);
        this.centralDirOffset = this.reader.readInt(8);

        this.zip64ExtensibleData = {};
        var extraDataSize = this.zip64EndOfCentralSize - 44,
            index = 0,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;
        while (index < extraDataSize) {
            extraFieldId = this.reader.readInt(2);
            extraFieldLength = this.reader.readInt(4);
            extraFieldValue = this.reader.readData(extraFieldLength);
            this.zip64ExtensibleData[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Read the end of the Zip 64 central directory locator.
     */
    readBlockZip64EndOfCentralLocator: function() {
        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
        this.disksCount = this.reader.readInt(4);
        if (this.disksCount > 1) {
            throw new Error("Multi-volumes zip are not supported");
        }
    },
    /**
     * Read the local files, based on the offset read in the central part.
     */
    readLocalFiles: function() {
        var i, file;
        for (i = 0; i < this.files.length; i++) {
            file = this.files[i];
            this.reader.setIndex(file.localHeaderOffset);
            this.checkSignature(sig.LOCAL_FILE_HEADER);
            file.readLocalPart(this.reader);
            file.handleUTF8();
            file.processAttributes();
        }
    },
    /**
     * Read the central directory.
     */
    readCentralDir: function() {
        var file;

        this.reader.setIndex(this.centralDirOffset);
        while (this.reader.readAndCheckSignature(sig.CENTRAL_FILE_HEADER)) {
            file = new ZipEntry({
                zip64: this.zip64
            }, this.loadOptions);
            file.readCentralPart(this.reader);
            this.files.push(file);
        }

        if (this.centralDirRecords !== this.files.length) {
            if (this.centralDirRecords !== 0 && this.files.length === 0) {
                // We expected some records but couldn't find ANY.
                // This is really suspicious, as if something went wrong.
                throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
            } else {
                // We found some records but not all.
                // Something is wrong but we got something for the user: no error here.
                // console.warn("expected", this.centralDirRecords, "records in central dir, got", this.files.length);
            }
        }
    },
    /**
     * Read the end of central directory.
     */
    readEndOfCentral: function() {
        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
        if (offset < 0) {
            // Check if the content is a truncated zip or complete garbage.
            // A "LOCAL_FILE_HEADER" is not required at the beginning (auto
            // extractible zip for example) but it can give a good hint.
            // If an ajax request was used without responseType, we will also
            // get unreadable data.
            var isGarbage = !this.isSignature(0, sig.LOCAL_FILE_HEADER);

            if (isGarbage) {
                throw new Error("Can't find end of central directory : is this a zip file ? " +
                                "If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
            } else {
                throw new Error("Corrupted zip: can't find end of central directory");
            }

        }
        this.reader.setIndex(offset);
        var endOfCentralDirOffset = offset;
        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
        this.readBlockEndOfCentral();


        /* extract from the zip spec :
            4)  If one of the fields in the end of central directory
                record is too small to hold required data, the field
                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
                ZIP64 format record should be created.
            5)  The end of central directory record and the
                Zip64 end of central directory locator record must
                reside on the same disk when splitting or spanning
                an archive.
         */
        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
            this.zip64 = true;

            /*
            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
            the zip file can fit into a 32bits integer. This cannot be solved : JavaScript represents
            all numbers as 64-bit double precision IEEE 754 floating point numbers.
            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
            */

            // should look for a zip64 EOCD locator
            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            if (offset < 0) {
                throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
            }
            this.reader.setIndex(offset);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            this.readBlockZip64EndOfCentralLocator();

            // now the zip64 EOCD record
            if (!this.isSignature(this.relativeOffsetEndOfZip64CentralDir, sig.ZIP64_CENTRAL_DIRECTORY_END)) {
                // console.warn("ZIP64 end of central directory not where expected.");
                this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
                if (this.relativeOffsetEndOfZip64CentralDir < 0) {
                    throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                }
            }
            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
            this.readBlockZip64EndOfCentral();
        }

        var expectedEndOfCentralDirOffset = this.centralDirOffset + this.centralDirSize;
        if (this.zip64) {
            expectedEndOfCentralDirOffset += 20; // end of central dir 64 locator
            expectedEndOfCentralDirOffset += 12 /* should not include the leading 12 bytes */ + this.zip64EndOfCentralSize;
        }

        var extraBytes = endOfCentralDirOffset - expectedEndOfCentralDirOffset;

        if (extraBytes > 0) {
            // console.warn(extraBytes, "extra bytes at beginning or within zipfile");
            if (this.isSignature(endOfCentralDirOffset, sig.CENTRAL_FILE_HEADER)) {
                // The offsets seem wrong, but we have something at the specified offset.
                // So… we keep it.
            } else {
                // the offset is wrong, update the "zero" of the reader
                // this happens if data has been prepended (crx files for example)
                this.reader.zero = extraBytes;
            }
        } else if (extraBytes < 0) {
            throw new Error("Corrupted zip: missing " + Math.abs(extraBytes) + " bytes.");
        }
    },
    prepareReader: function(data) {
        this.reader = readerFor(data);
    },
    /**
     * Read a zip file and create ZipEntries.
     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
     */
    load: function(data) {
        this.prepareReader(data);
        this.readEndOfCentral();
        this.readCentralDir();
        this.readLocalFiles();
    }
};
// }}} end of ZipEntries
module.exports = ZipEntries;

},{"./reader/readerFor":22,"./signature":23,"./support":30,"./utils":32,"./zipEntry":34}],34:[function(require,module,exports){
"use strict";
var readerFor = require("./reader/readerFor");
var utils = require("./utils");
var CompressedObject = require("./compressedObject");
var crc32fn = require("./crc32");
var utf8 = require("./utf8");
var compressions = require("./compressions");
var support = require("./support");

var MADE_BY_DOS = 0x00;
var MADE_BY_UNIX = 0x03;

/**
 * Find a compression registered in JSZip.
 * @param {string} compressionMethod the method magic to find.
 * @return {Object|null} the JSZip compression object, null if none found.
 */
var findCompression = function(compressionMethod) {
    for (var method in compressions) {
        if (!Object.prototype.hasOwnProperty.call(compressions, method)) {
            continue;
        }
        if (compressions[method].magic === compressionMethod) {
            return compressions[method];
        }
    }
    return null;
};

// class ZipEntry {{{
/**
 * An entry in the zip file.
 * @constructor
 * @param {Object} options Options of the current file.
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntry(options, loadOptions) {
    this.options = options;
    this.loadOptions = loadOptions;
}
ZipEntry.prototype = {
    /**
     * say if the file is encrypted.
     * @return {boolean} true if the file is encrypted, false otherwise.
     */
    isEncrypted: function() {
        // bit 1 is set
        return (this.bitFlag & 0x0001) === 0x0001;
    },
    /**
     * say if the file has utf-8 filename/comment.
     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
     */
    useUTF8: function() {
        // bit 11 is set
        return (this.bitFlag & 0x0800) === 0x0800;
    },
    /**
     * Read the local part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readLocalPart: function(reader) {
        var compression, localExtraFieldsLength;

        // we already know everything from the central dir !
        // If the central dir data are false, we are doomed.
        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
        // The less data we get here, the more reliable this should be.
        // Let's skip the whole header and dash to the data !
        reader.skip(22);
        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
        // Strangely, the filename here is OK.
        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
        // the internet.
        //
        // I think I see the logic here : the central directory is used to display
        // content and the local directory is used to extract the files. Mixing / and \
        // may be used to display \ to windows users and use / when extracting the files.
        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
        this.fileNameLength = reader.readInt(2);
        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
        // the fileName is stored as binary data, the handleUTF8 method will take care of the encoding.
        this.fileName = reader.readData(this.fileNameLength);
        reader.skip(localExtraFieldsLength);

        if (this.compressedSize === -1 || this.uncompressedSize === -1) {
            throw new Error("Bug or corrupted zip : didn't get enough information from the central directory " + "(compressedSize === -1 || uncompressedSize === -1)");
        }

        compression = findCompression(this.compressionMethod);
        if (compression === null) { // no compression found
            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + utils.transformTo("string", this.fileName) + ")");
        }
        this.decompressed = new CompressedObject(this.compressedSize, this.uncompressedSize, this.crc32, compression, reader.readData(this.compressedSize));
    },

    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readCentralPart: function(reader) {
        this.versionMadeBy = reader.readInt(2);
        reader.skip(2);
        // this.versionNeeded = reader.readInt(2);
        this.bitFlag = reader.readInt(2);
        this.compressionMethod = reader.readString(2);
        this.date = reader.readDate();
        this.crc32 = reader.readInt(4);
        this.compressedSize = reader.readInt(4);
        this.uncompressedSize = reader.readInt(4);
        var fileNameLength = reader.readInt(2);
        this.extraFieldsLength = reader.readInt(2);
        this.fileCommentLength = reader.readInt(2);
        this.diskNumberStart = reader.readInt(2);
        this.internalFileAttributes = reader.readInt(2);
        this.externalFileAttributes = reader.readInt(4);
        this.localHeaderOffset = reader.readInt(4);

        if (this.isEncrypted()) {
            throw new Error("Encrypted zip are not supported");
        }

        // will be read in the local part, see the comments there
        reader.skip(fileNameLength);
        this.readExtraFields(reader);
        this.parseZIP64ExtraField(reader);
        this.fileComment = reader.readData(this.fileCommentLength);
    },

    /**
     * Parse the external file attributes and get the unix/dos permissions.
     */
    processAttributes: function () {
        this.unixPermissions = null;
        this.dosPermissions = null;
        var madeBy = this.versionMadeBy >> 8;

        // Check if we have the DOS directory flag set.
        // We look for it in the DOS and UNIX permissions
        // but some unknown platform could set it as a compatibility flag.
        this.dir = this.externalFileAttributes & 0x0010 ? true : false;

        if(madeBy === MADE_BY_DOS) {
            // first 6 bits (0 to 5)
            this.dosPermissions = this.externalFileAttributes & 0x3F;
        }

        if(madeBy === MADE_BY_UNIX) {
            this.unixPermissions = (this.externalFileAttributes >> 16) & 0xFFFF;
            // the octal permissions are in (this.unixPermissions & 0x01FF).toString(8);
        }

        // fail safe : if the name ends with a / it probably means a folder
        if (!this.dir && this.fileNameStr.slice(-1) === "/") {
            this.dir = true;
        }
    },

    /**
     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
     * @param {DataReader} reader the reader to use.
     */
    parseZIP64ExtraField: function() {
        if (!this.extraFields[0x0001]) {
            return;
        }

        // should be something, preparing the extra reader
        var extraReader = readerFor(this.extraFields[0x0001].value);

        // I really hope that these 64bits integer can fit in 32 bits integer, because js
        // won't let us have more.
        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
            this.uncompressedSize = extraReader.readInt(8);
        }
        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
            this.compressedSize = extraReader.readInt(8);
        }
        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
            this.localHeaderOffset = extraReader.readInt(8);
        }
        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
            this.diskNumberStart = extraReader.readInt(4);
        }
    },
    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readExtraFields: function(reader) {
        var end = reader.index + this.extraFieldsLength,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;

        if (!this.extraFields) {
            this.extraFields = {};
        }

        while (reader.index + 4 < end) {
            extraFieldId = reader.readInt(2);
            extraFieldLength = reader.readInt(2);
            extraFieldValue = reader.readData(extraFieldLength);

            this.extraFields[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }

        reader.setIndex(end);
    },
    /**
     * Apply an UTF8 transformation if needed.
     */
    handleUTF8: function() {
        var decodeParamType = support.uint8array ? "uint8array" : "array";
        if (this.useUTF8()) {
            this.fileNameStr = utf8.utf8decode(this.fileName);
            this.fileCommentStr = utf8.utf8decode(this.fileComment);
        } else {
            var upath = this.findExtraFieldUnicodePath();
            if (upath !== null) {
                this.fileNameStr = upath;
            } else {
                // ASCII text or unsupported code page
                var fileNameByteArray =  utils.transformTo(decodeParamType, this.fileName);
                this.fileNameStr = this.loadOptions.decodeFileName(fileNameByteArray);
            }

            var ucomment = this.findExtraFieldUnicodeComment();
            if (ucomment !== null) {
                this.fileCommentStr = ucomment;
            } else {
                // ASCII text or unsupported code page
                var commentByteArray =  utils.transformTo(decodeParamType, this.fileComment);
                this.fileCommentStr = this.loadOptions.decodeFileName(commentByteArray);
            }
        }
    },

    /**
     * Find the unicode path declared in the extra field, if any.
     * @return {String} the unicode path, null otherwise.
     */
    findExtraFieldUnicodePath: function() {
        var upathField = this.extraFields[0x7075];
        if (upathField) {
            var extraReader = readerFor(upathField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the filename changed, this field is out of date.
            if (crc32fn(this.fileName) !== extraReader.readInt(4)) {
                return null;
            }

            return utf8.utf8decode(extraReader.readData(upathField.length - 5));
        }
        return null;
    },

    /**
     * Find the unicode comment declared in the extra field, if any.
     * @return {String} the unicode comment, null otherwise.
     */
    findExtraFieldUnicodeComment: function() {
        var ucommentField = this.extraFields[0x6375];
        if (ucommentField) {
            var extraReader = readerFor(ucommentField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the comment changed, this field is out of date.
            if (crc32fn(this.fileComment) !== extraReader.readInt(4)) {
                return null;
            }

            return utf8.utf8decode(extraReader.readData(ucommentField.length - 5));
        }
        return null;
    }
};
module.exports = ZipEntry;

},{"./compressedObject":2,"./compressions":3,"./crc32":4,"./reader/readerFor":22,"./support":30,"./utf8":31,"./utils":32}],35:[function(require,module,exports){
"use strict";

var StreamHelper = require("./stream/StreamHelper");
var DataWorker = require("./stream/DataWorker");
var utf8 = require("./utf8");
var CompressedObject = require("./compressedObject");
var GenericWorker = require("./stream/GenericWorker");

/**
 * A simple object representing a file in the zip file.
 * @constructor
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
 * @param {Object} options the options of the file
 */
var ZipObject = function(name, data, options) {
    this.name = name;
    this.dir = options.dir;
    this.date = options.date;
    this.comment = options.comment;
    this.unixPermissions = options.unixPermissions;
    this.dosPermissions = options.dosPermissions;

    this._data = data;
    this._dataBinary = options.binary;
    // keep only the compression
    this.options = {
        compression : options.compression,
        compressionOptions : options.compressionOptions
    };
};

ZipObject.prototype = {
    /**
     * Create an internal stream for the content of this object.
     * @param {String} type the type of each chunk.
     * @return StreamHelper the stream.
     */
    internalStream: function (type) {
        var result = null, outputType = "string";
        try {
            if (!type) {
                throw new Error("No output type specified.");
            }
            outputType = type.toLowerCase();
            var askUnicodeString = outputType === "string" || outputType === "text";
            if (outputType === "binarystring" || outputType === "text") {
                outputType = "string";
            }
            result = this._decompressWorker();

            var isUnicodeString = !this._dataBinary;

            if (isUnicodeString && !askUnicodeString) {
                result = result.pipe(new utf8.Utf8EncodeWorker());
            }
            if (!isUnicodeString && askUnicodeString) {
                result = result.pipe(new utf8.Utf8DecodeWorker());
            }
        } catch (e) {
            result = new GenericWorker("error");
            result.error(e);
        }

        return new StreamHelper(result, outputType, "");
    },

    /**
     * Prepare the content in the asked type.
     * @param {String} type the type of the result.
     * @param {Function} onUpdate a function to call on each internal update.
     * @return Promise the promise of the result.
     */
    async: function (type, onUpdate) {
        return this.internalStream(type).accumulate(onUpdate);
    },

    /**
     * Prepare the content as a nodejs stream.
     * @param {String} type the type of each chunk.
     * @param {Function} onUpdate a function to call on each internal update.
     * @return Stream the stream.
     */
    nodeStream: function (type, onUpdate) {
        return this.internalStream(type || "nodebuffer").toNodejsStream(onUpdate);
    },

    /**
     * Return a worker for the compressed content.
     * @private
     * @param {Object} compression the compression object to use.
     * @param {Object} compressionOptions the options to use when compressing.
     * @return Worker the worker.
     */
    _compressWorker: function (compression, compressionOptions) {
        if (
            this._data instanceof CompressedObject &&
            this._data.compression.magic === compression.magic
        ) {
            return this._data.getCompressedWorker();
        } else {
            var result = this._decompressWorker();
            if(!this._dataBinary) {
                result = result.pipe(new utf8.Utf8EncodeWorker());
            }
            return CompressedObject.createWorkerFrom(result, compression, compressionOptions);
        }
    },
    /**
     * Return a worker for the decompressed content.
     * @private
     * @return Worker the worker.
     */
    _decompressWorker : function () {
        if (this._data instanceof CompressedObject) {
            return this._data.getContentWorker();
        } else if (this._data instanceof GenericWorker) {
            return this._data;
        } else {
            return new DataWorker(this._data);
        }
    }
};

var removedMethods = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"];
var removedFn = function () {
    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
};

for(var i = 0; i < removedMethods.length; i++) {
    ZipObject.prototype[removedMethods[i]] = removedFn;
}
module.exports = ZipObject;

},{"./compressedObject":2,"./stream/DataWorker":27,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31}],36:[function(require,module,exports){
(function (global){
'use strict';
var Mutation = global.MutationObserver || global.WebKitMutationObserver;

var scheduleDrain;

{
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = global.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
    var channel = new global.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = global.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      global.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

module.exports = immediate;
function immediate(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],37:[function(require,module,exports){
'use strict';
var immediate = require('immediate');

/* istanbul ignore next */
function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];

module.exports = Promise;

function Promise(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise.prototype["finally"] = function (callback) {
  if (typeof callback !== 'function') {
    return this;
  }
  var p = this.constructor;
  return this.then(resolve, reject);

  function resolve(value) {
    function yes () {
      return value;
    }
    return p.resolve(callback()).then(yes);
  }
  function reject(reason) {
    function no () {
      throw reason;
    }
    return p.resolve(callback()).then(no);
  }
};
Promise.prototype["catch"] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

Promise.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

Promise.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

Promise.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

Promise.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}

},{"immediate":36}],38:[function(require,module,exports){
// Top level file is just a mixin of submodules & constants
'use strict';

var assign    = require('./lib/utils/common').assign;

var deflate   = require('./lib/deflate');
var inflate   = require('./lib/inflate');
var constants = require('./lib/zlib/constants');

var pako = {};

assign(pako, deflate, inflate, constants);

module.exports = pako;

},{"./lib/deflate":39,"./lib/inflate":40,"./lib/utils/common":41,"./lib/zlib/constants":44}],39:[function(require,module,exports){
'use strict';


var zlib_deflate = require('./zlib/deflate');
var utils        = require('./utils/common');
var strings      = require('./utils/strings');
var msg          = require('./zlib/messages');
var ZStream      = require('./zlib/zstream');

var toString = Object.prototype.toString;

/* Public constants ==========================================================*/
/* ===========================================================================*/

var Z_NO_FLUSH      = 0;
var Z_FINISH        = 4;

var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_SYNC_FLUSH    = 2;

var Z_DEFAULT_COMPRESSION = -1;

var Z_DEFAULT_STRATEGY    = 0;

var Z_DEFLATED  = 8;

/* ===========================================================================*/


/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/

/* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overriden.
 **/

/**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/

/**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/


/**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/
function Deflate(options) {
  if (!(this instanceof Deflate)) return new Deflate(options);

  this.options = utils.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY,
    to: ''
  }, options || {});

  var opt = this.options;

  if (opt.raw && (opt.windowBits > 0)) {
    opt.windowBits = -opt.windowBits;
  }

  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
    opt.windowBits += 16;
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm = new ZStream();
  this.strm.avail_out = 0;

  var status = zlib_deflate.deflateInit2(
    this.strm,
    opt.level,
    opt.method,
    opt.windowBits,
    opt.memLevel,
    opt.strategy
  );

  if (status !== Z_OK) {
    throw new Error(msg[status]);
  }

  if (opt.header) {
    zlib_deflate.deflateSetHeader(this.strm, opt.header);
  }

  if (opt.dictionary) {
    var dict;
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      // If we need to compress text, change encoding to utf8.
      dict = strings.string2buf(opt.dictionary);
    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
      dict = new Uint8Array(opt.dictionary);
    } else {
      dict = opt.dictionary;
    }

    status = zlib_deflate.deflateSetDictionary(this.strm, dict);

    if (status !== Z_OK) {
      throw new Error(msg[status]);
    }

    this._dict_set = true;
  }
}

/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Deflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var status, _mode;

  if (this.ended) { return false; }

  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // If we need to compress text, change encoding to utf8.
    strm.input = strings.string2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }
    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */

    if (status !== Z_STREAM_END && status !== Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }
    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
      if (this.options.to === 'string') {
        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
      } else {
        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
      }
    }
  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);

  // Finalize on the last chunk.
  if (_mode === Z_FINISH) {
    status = zlib_deflate.deflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === Z_SYNC_FLUSH) {
    this.onEnd(Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Deflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Deflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === Z_OK) {
    if (this.options.to === 'string') {
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/
function deflate(input, options) {
  var deflator = new Deflate(options);

  deflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (deflator.err) { throw deflator.msg || msg[deflator.err]; }

  return deflator.result;
}


/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function deflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return deflate(input, options);
}


/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/
function gzip(input, options) {
  options = options || {};
  options.gzip = true;
  return deflate(input, options);
}


exports.Deflate = Deflate;
exports.deflate = deflate;
exports.deflateRaw = deflateRaw;
exports.gzip = gzip;

},{"./utils/common":41,"./utils/strings":42,"./zlib/deflate":46,"./zlib/messages":51,"./zlib/zstream":53}],40:[function(require,module,exports){
'use strict';


var zlib_inflate = require('./zlib/inflate');
var utils        = require('./utils/common');
var strings      = require('./utils/strings');
var c            = require('./zlib/constants');
var msg          = require('./zlib/messages');
var ZStream      = require('./zlib/zstream');
var GZheader     = require('./zlib/gzheader');

var toString = Object.prototype.toString;

/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/

/* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overriden.
 **/

/**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/

/**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/


/**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/
function Inflate(options) {
  if (!(this instanceof Inflate)) return new Inflate(options);

  this.options = utils.assign({
    chunkSize: 16384,
    windowBits: 0,
    to: ''
  }, options || {});

  var opt = this.options;

  // Force window size for `raw` data, if not set directly,
  // because we have no header for autodetect.
  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
    opt.windowBits = -opt.windowBits;
    if (opt.windowBits === 0) { opt.windowBits = -15; }
  }

  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
      !(options && options.windowBits)) {
    opt.windowBits += 32;
  }

  // Gzip header has no info about windows size, we can do autodetect only
  // for deflate. So, if window size not set, force it to max when gzip possible
  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
    // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    if ((opt.windowBits & 15) === 0) {
      opt.windowBits |= 15;
    }
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm   = new ZStream();
  this.strm.avail_out = 0;

  var status  = zlib_inflate.inflateInit2(
    this.strm,
    opt.windowBits
  );

  if (status !== c.Z_OK) {
    throw new Error(msg[status]);
  }

  this.header = new GZheader();

  zlib_inflate.inflateGetHeader(this.strm, this.header);
}

/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Inflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var dictionary = this.options.dictionary;
  var status, _mode;
  var next_out_utf8, tail, utf8str;
  var dict;

  // Flag to properly process Z_BUF_ERROR on testing inflate call
  // when we check that all output data was flushed.
  var allowBufError = false;

  if (this.ended) { return false; }
  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // Only binary strings can be decompressed on practice
    strm.input = strings.binstring2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */

    if (status === c.Z_NEED_DICT && dictionary) {
      // Convert data if needed
      if (typeof dictionary === 'string') {
        dict = strings.string2buf(dictionary);
      } else if (toString.call(dictionary) === '[object ArrayBuffer]') {
        dict = new Uint8Array(dictionary);
      } else {
        dict = dictionary;
      }

      status = zlib_inflate.inflateSetDictionary(this.strm, dict);

    }

    if (status === c.Z_BUF_ERROR && allowBufError === true) {
      status = c.Z_OK;
      allowBufError = false;
    }

    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }

    if (strm.next_out) {
      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH))) {

        if (this.options.to === 'string') {

          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);

          tail = strm.next_out - next_out_utf8;
          utf8str = strings.buf2string(strm.output, next_out_utf8);

          // move tail
          strm.next_out = tail;
          strm.avail_out = chunkSize - tail;
          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }

          this.onData(utf8str);

        } else {
          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
        }
      }
    }

    // When no more input data, we should check that internal inflate buffers
    // are flushed. The only way to do it when avail_out = 0 - run one more
    // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
    // Here we set flag to process this error properly.
    //
    // NOTE. Deflate does not return error in this case and does not needs such
    // logic.
    if (strm.avail_in === 0 && strm.avail_out === 0) {
      allowBufError = true;
    }

  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);

  if (status === c.Z_STREAM_END) {
    _mode = c.Z_FINISH;
  }

  // Finalize on the last chunk.
  if (_mode === c.Z_FINISH) {
    status = zlib_inflate.inflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === c.Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === c.Z_SYNC_FLUSH) {
    this.onEnd(c.Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Inflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Inflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === c.Z_OK) {
    if (this.options.to === 'string') {
      // Glue & convert here, until we teach pako to send
      // utf8 alligned strings to onData
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/
function inflate(input, options) {
  var inflator = new Inflate(options);

  inflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (inflator.err) { throw inflator.msg || msg[inflator.err]; }

  return inflator.result;
}


/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function inflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return inflate(input, options);
}


/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/


exports.Inflate = Inflate;
exports.inflate = inflate;
exports.inflateRaw = inflateRaw;
exports.ungzip  = inflate;

},{"./utils/common":41,"./utils/strings":42,"./zlib/constants":44,"./zlib/gzheader":47,"./zlib/inflate":49,"./zlib/messages":51,"./zlib/zstream":53}],41:[function(require,module,exports){
'use strict';


var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
                (typeof Uint16Array !== 'undefined') &&
                (typeof Int32Array !== 'undefined');


exports.assign = function (obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    var source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (var p in source) {
      if (source.hasOwnProperty(p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function (buf, size) {
  if (buf.length === size) { return buf; }
  if (buf.subarray) { return buf.subarray(0, size); }
  buf.length = size;
  return buf;
};


var fnTyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
      return;
    }
    // Fallback to ordinary array
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    var i, l, len, pos, chunk, result;

    // calculate data length
    len = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      len += chunks[i].length;
    }

    // join chunks
    result = new Uint8Array(len);
    pos = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      chunk = chunks[i];
      result.set(chunk, pos);
      pos += chunk.length;
    }

    return result;
  }
};

var fnUntyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    return [].concat.apply([], chunks);
  }
};


// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function (on) {
  if (on) {
    exports.Buf8  = Uint8Array;
    exports.Buf16 = Uint16Array;
    exports.Buf32 = Int32Array;
    exports.assign(exports, fnTyped);
  } else {
    exports.Buf8  = Array;
    exports.Buf16 = Array;
    exports.Buf32 = Array;
    exports.assign(exports, fnUntyped);
  }
};

exports.setTyped(TYPED_OK);

},{}],42:[function(require,module,exports){
// String encode/decode helpers
'use strict';


var utils = require('./common');


// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safary
//
var STR_APPLY_OK = true;
var STR_APPLY_UIA_OK = true;

try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }


// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new utils.Buf8(256);
for (var q = 0; q < 256; q++) {
  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
}
_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start


// convert string to array (typed, when possible)
exports.string2buf = function (str) {
  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

  // count binary size
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }

  // allocate buffer
  buf = new utils.Buf8(buf_len);

  // convert
  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      /* one byte */
      buf[i++] = c;
    } else if (c < 0x800) {
      /* two bytes */
      buf[i++] = 0xC0 | (c >>> 6);
      buf[i++] = 0x80 | (c & 0x3f);
    } else if (c < 0x10000) {
      /* three bytes */
      buf[i++] = 0xE0 | (c >>> 12);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    } else {
      /* four bytes */
      buf[i++] = 0xf0 | (c >>> 18);
      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    }
  }

  return buf;
};

// Helper (used in 2 places)
function buf2binstring(buf, len) {
  // use fallback for big arrays to avoid stack overflow
  if (len < 65537) {
    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
    }
  }

  var result = '';
  for (var i = 0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
}


// Convert byte array to binary string
exports.buf2binstring = function (buf) {
  return buf2binstring(buf, buf.length);
};


// Convert binary string (typed, when possible)
exports.binstring2buf = function (str) {
  var buf = new utils.Buf8(str.length);
  for (var i = 0, len = buf.length; i < len; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
};


// convert array to string
exports.buf2string = function (buf, max) {
  var i, out, c, c_len;
  var len = max || buf.length;

  // Reserve max possible length (2 words per char)
  // NB: by unknown reasons, Array is significantly faster for
  //     String.fromCharCode.apply than Uint16Array.
  var utf16buf = new Array(len * 2);

  for (out = 0, i = 0; i < len;) {
    c = buf[i++];
    // quick process ascii
    if (c < 0x80) { utf16buf[out++] = c; continue; }

    c_len = _utf8len[c];
    // skip 5 & 6 byte codes
    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }

    // apply mask on first byte
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    // join the rest
    while (c_len > 1 && i < len) {
      c = (c << 6) | (buf[i++] & 0x3f);
      c_len--;
    }

    // terminated by end of string?
    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
    }
  }

  return buf2binstring(utf16buf, out);
};


// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
exports.utf8border = function (buf, max) {
  var pos;

  max = max || buf.length;
  if (max > buf.length) { max = buf.length; }

  // go back from last position, until start of sequence found
  pos = max - 1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

  // Fuckup - very small and broken sequence,
  // return max, because we should return something anyway.
  if (pos < 0) { return max; }

  // If we came to start of buffer - that means vuffer is too small,
  // return max too.
  if (pos === 0) { return max; }

  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

},{"./common":41}],43:[function(require,module,exports){
'use strict';

// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It doesn't worth to make additional optimizationa as in original.
// Small size is preferable.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function adler32(adler, buf, len, pos) {
  var s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
}


module.exports = adler32;

},{}],44:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};

},{}],45:[function(require,module,exports){
'use strict';

// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// Use ordinary array, since untyped makes no boost here
function makeTable() {
  var c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
  var t = crcTable,
      end = pos + len;

  crc ^= -1;

  for (var i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
}


module.exports = crc32;

},{}],46:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils   = require('../utils/common');
var trees   = require('./trees');
var adler32 = require('./adler32');
var crc32   = require('./crc32');
var msg     = require('./messages');

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
var Z_NO_FLUSH      = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
//var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;


/* compression levels */
//var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;


var Z_FILTERED            = 1;
var Z_HUFFMAN_ONLY        = 2;
var Z_RLE                 = 3;
var Z_FIXED               = 4;
var Z_DEFAULT_STRATEGY    = 0;

/* Possible values of the data_type field (though see inflate()) */
//var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;


/* The deflate compression method */
var Z_DEFLATED  = 8;

/*============================================================================*/


var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_MEM_LEVEL = 8;


var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
var LITERALS      = 256;
/* number of literal bytes 0..255 */
var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
var D_CODES       = 30;
/* number of distance codes */
var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
var MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

var PRESET_DICT = 0x20;

var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;

var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
var BS_BLOCK_DONE     = 2; /* block flush performed */
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

function err(strm, errorCode) {
  strm.msg = msg[errorCode];
  return errorCode;
}

function rank(f) {
  return ((f) << 1) - ((f) > 4 ? 9 : 0);
}

function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
function flush_pending(strm) {
  var s = strm.state;

  //_tr_flush_bits(s);
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}


function flush_block_only(s, last) {
  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}


function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
function putShortMSB(s, b) {
//  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
}


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
function read_buf(strm, buf, start, size) {
  var len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  utils.arraySet(buf, strm.input, strm.next_in, len, start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
}


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;      /* max hash chain length */
  var scan = s.strstart; /* current string */
  var match;                       /* matched string */
  var len;                           /* length of current match */
  var best_len = s.prev_length;              /* best match length so far */
  var nice_match = s.nice_match;             /* stop if match long enough */
  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  var _win = s.window; // shortcut

  var wmask = s.w_mask;
  var prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  var strend = s.strstart + MAX_MATCH;
  var scan_end1  = _win[scan + best_len - 1];
  var scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;

      /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = (m >= _w_size ? m - _w_size : 0);
      } while (--n);

      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);

      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
function deflate_stored(s, flush) {
  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
  var max_block_size = 0xffff;

  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }

  /* Copy as much as possible from input to output: */
  for (;;) {
    /* Fill the window as much as possible: */
    if (s.lookahead <= 1) {

      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
      //  s->block_start >= (long)s->w_size, "slide too late");
//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
//        s.block_start >= s.w_size)) {
//        throw  new Error("slide too late");
//      }

      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }

      if (s.lookahead === 0) {
        break;
      }
      /* flush the current block */
    }
    //Assert(s->block_start >= 0L, "block gone");
//    if (s.block_start < 0) throw new Error("block gone");

    s.strstart += s.lookahead;
    s.lookahead = 0;

    /* Emit a stored block if pending_buf will be full: */
    var max_start = s.block_start + max_block_size;

    if (s.strstart === 0 || s.strstart >= max_start) {
      /* strstart == 0 is possible when wraparound on 16-bit machine */
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/


    }
    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }

  s.insert = 0;

  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }

  if (s.strstart > s.block_start) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_NEED_MORE;
}

/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
function deflate_fast(s, flush) {
  var hash_head;        /* head of the hash chain */
  var bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
function deflate_slow(s, flush) {
  var hash_head;          /* head of hash chain */
  var bflush;              /* set if current block must be flushed */

  var max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
}


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
function deflate_rle(s, flush) {
  var bflush;            /* set if current block must be flushed */
  var prev;              /* byte at distance one to match */
  var scan, strend;      /* scan goes up to strend for length of run */

  var _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
function deflate_huff(s, flush) {
  var bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

var configuration_table;

configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
function lm_init(s) {
  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
}


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new utils.Buf16(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.l_buf = 0;          /* buffer index for literals or lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.last_lit = 0;      /* running index in l_buf */

  this.d_buf = 0;
  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


function deflateResetKeep(strm) {
  var s;

  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = Z_NO_FLUSH;
  trees._tr_init(s);
  return Z_OK;
}


function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK) {
    lm_init(strm.state);
  }
  return ret;
}


function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
  strm.state.gzhead = head;
  return Z_OK;
}


function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR;
  }
  var wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  var s = new DeflateState();

  strm.state = s;
  s.strm = strm;

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new utils.Buf8(s.w_size * 2);
  s.head = new utils.Buf16(s.hash_size);
  s.prev = new utils.Buf16(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  s.pending_buf_size = s.lit_bufsize * 4;

  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
  //s->pending_buf = (uchf *) overlay;
  s.pending_buf = new utils.Buf8(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
  s.d_buf = 1 * s.lit_bufsize;

  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
  s.l_buf = (1 + 2) * s.lit_bufsize;

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
}

function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}


function deflate(strm, flush) {
  var old_flush, s;
  var beg, val; // for gzip header write only

  if (!strm || !strm.state ||
    flush > Z_BLOCK || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
  }

  s = strm.state;

  if (!strm.output ||
      (!strm.input && strm.avail_in !== 0) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
  }

  s.strm = strm; /* just in case */
  old_flush = s.last_flush;
  s.last_flush = flush;

  /* Write the header */
  if (s.status === INIT_STATE) {

    if (s.wrap === 2) { // GZIP header
      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) { // s->gzhead == Z_NULL
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      }
      else {
        put_byte(s, (s.gzhead.text ? 1 : 0) +
                    (s.gzhead.hcrc ? 2 : 0) +
                    (!s.gzhead.extra ? 0 : 4) +
                    (!s.gzhead.name ? 0 : 8) +
                    (!s.gzhead.comment ? 0 : 16)
                );
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, (s.gzhead.time >> 8) & 0xff);
        put_byte(s, (s.gzhead.time >> 16) & 0xff);
        put_byte(s, (s.gzhead.time >> 24) & 0xff);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    }
    else // DEFLATE header
    {
      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
      var level_flags = -1;

      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= (level_flags << 6);
      if (s.strstart !== 0) { header |= PRESET_DICT; }
      header += 31 - (header % 31);

      s.status = BUSY_STATE;
      putShortMSB(s, header);

      /* Save the adler32 of the preset dictionary: */
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }
      strm.adler = 1; // adler32(0L, Z_NULL, 0);
    }
  }

//#ifdef GZIP
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */

      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    }
    else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    }
    else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    }
    else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        strm.adler = 0; //crc32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
      }
    }
    else {
      s.status = BUSY_STATE;
    }
  }
//#endif

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH) {
    return err(strm, Z_BUF_ERROR);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR);
  }

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
        configuration_table[s.level].func(s, flush));

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      }
      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

        trees._tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK;
      }
    }
  }
  //Assert(strm->avail_out > 0, "bug2");
  //if (strm.avail_out <= 0) { throw new Error("bug2");}

  if (flush !== Z_FINISH) { return Z_OK; }
  if (s.wrap <= 0) { return Z_STREAM_END; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}

function deflateEnd(strm) {
  var status;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  status = strm.state.status;
  if (status !== INIT_STATE &&
    status !== EXTRA_STATE &&
    status !== NAME_STATE &&
    status !== COMMENT_STATE &&
    status !== HCRC_STATE &&
    status !== BUSY_STATE &&
    status !== FINISH_STATE
  ) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
function deflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var s;
  var str, n;
  var wrap;
  var avail;
  var next;
  var input;
  var tmpDict;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  s = strm.state;
  wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    tmpDict = new utils.Buf8(s.w_size);
    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  avail = strm.avail_in;
  next = strm.next_in;
  input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    str = s.strstart;
    n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK;
}


exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/

},{"../utils/common":41,"./adler32":43,"./crc32":45,"./messages":51,"./trees":52}],47:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function GZheader() {
  /* true if compressed data believed to be text */
  this.text       = 0;
  /* modification time */
  this.time       = 0;
  /* extra flags (not used when writing a gzip file) */
  this.xflags     = 0;
  /* operating system */
  this.os         = 0;
  /* pointer to extra field or Z_NULL if none */
  this.extra      = null;
  /* extra field length (valid if extra != Z_NULL) */
  this.extra_len  = 0; // Actually, we don't need it in JS,
                       // but leave for few code modifications

  //
  // Setup limits is not necessary because in js we should not preallocate memory
  // for inflate use constant limit in 65536 bytes
  //

  /* space at extra (only when reading header) */
  // this.extra_max  = 0;
  /* pointer to zero-terminated file name or Z_NULL */
  this.name       = '';
  /* space at name (only when reading header) */
  // this.name_max   = 0;
  /* pointer to zero-terminated comment or Z_NULL */
  this.comment    = '';
  /* space at comment (only when reading header) */
  // this.comm_max   = 0;
  /* true if there was or will be a header crc */
  this.hcrc       = 0;
  /* true when done reading gzip header (not used when writing a gzip file) */
  this.done       = false;
}

module.exports = GZheader;

},{}],48:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// See state defs from inflate.js
var BAD = 30;       /* got a data error -- remain here until reset */
var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
module.exports = function inflate_fast(strm, start) {
  var state;
  var _in;                    /* local strm.input */
  var last;                   /* have enough input while in < last */
  var _out;                   /* local strm.output */
  var beg;                    /* inflate()'s initial strm.output */
  var end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  var dmax;                   /* maximum distance from zlib header */
//#endif
  var wsize;                  /* window size or zero if not using window */
  var whave;                  /* valid bytes in the window */
  var wnext;                  /* window write index */
  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
  var s_window;               /* allocated sliding window, if wsize != 0 */
  var hold;                   /* local strm.hold */
  var bits;                   /* local strm.bits */
  var lcode;                  /* local strm.lencode */
  var dcode;                  /* local strm.distcode */
  var lmask;                  /* mask for first level of length codes */
  var dmask;                  /* mask for first level of distance codes */
  var here;                   /* retrieved table entry */
  var op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  var len;                    /* match length, unused bytes */
  var dist;                   /* match distance */
  var from;                   /* where to copy match from */
  var from_source;


  var input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD;
                  break top;
                }

// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = s_window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};

},{}],49:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils         = require('../utils/common');
var adler32       = require('./adler32');
var crc32         = require('./crc32');
var inflate_fast  = require('./inffast');
var inflate_table = require('./inftrees');

var CODES = 0;
var LENS = 1;
var DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
//var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;

/* The deflate compression method */
var Z_DEFLATED  = 8;


/* STATES ====================================================================*/
/* ===========================================================================*/


var    HEAD = 1;       /* i: waiting for magic header */
var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
var    TIME = 3;       /* i: waiting for modification time (gzip) */
var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
var    NAME = 7;       /* i: waiting for end of file name (gzip) */
var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
var    HCRC = 9;       /* i: waiting for header crc (gzip) */
var    DICTID = 10;    /* i: waiting for dictionary check value */
var    DICT = 11;      /* waiting for inflateSetDictionary() call */
var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
var        STORED = 14;    /* i: waiting for stored size (length and complement) */
var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
var        LENLENS = 18;   /* i: waiting for code length code lengths */
var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
var            LEN = 21;       /* i: waiting for length/lit/eob code */
var            LENEXT = 22;    /* i: waiting for length extra bits */
var            DIST = 23;      /* i: waiting for distance code */
var            DISTEXT = 24;   /* i: waiting for distance extra bits */
var            MATCH = 25;     /* o: waiting for output space to copy string */
var            LIT = 26;       /* o: waiting for output space to write literal */
var    CHECK = 27;     /* i: waiting for 32-bit check value */
var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
var    DONE = 29;      /* finished check, done -- remain here until reset */
var    BAD = 30;       /* got a data error -- remain here until reset */
var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_WBITS = MAX_WBITS;


function zswap32(q) {
  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
}


function InflateState() {
  this.mode = 0;             /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
  this.work = new utils.Buf16(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}

function inflateResetKeep(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK;
}

function inflateReset(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

}

function inflateReset2(strm, windowBits) {
  var wrap;
  var state;

  /* get the state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
}

function inflateInit2(strm, windowBits) {
  var ret;
  var state;

  if (!strm) { return Z_STREAM_ERROR; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.window = null/*Z_NULL*/;
  ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
}

function inflateInit(strm) {
  return inflateInit2(strm, DEF_WBITS);
}


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
var virgin = true;

var lenfix, distfix; // We have no pointers in JS, so keep tables separate

function fixedtables(state) {
  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    var sym;

    lenfix = new utils.Buf32(512);
    distfix = new utils.Buf32(32);

    /* literal/length table */
    sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
}


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
function updatewindow(strm, src, end, copy) {
  var dist;
  var state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new utils.Buf8(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      utils.arraySet(state.window, src, end - copy, copy, 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
}

function inflate(strm, flush) {
  var state;
  var input, output;          // input/output buffers
  var next;                   /* next input INDEX */
  var put;                    /* next output INDEX */
  var have, left;             /* available input and output */
  var hold;                   /* bit buffer */
  var bits;                   /* bits in bit buffer */
  var _in, _out;              /* save starting available input and output */
  var copy;                   /* number of stored or match bytes to copy */
  var from;                   /* where to copy match bytes from */
  var from_source;
  var here = 0;               /* current decoding table entry */
  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //var last;                   /* parent table entry */
  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  var len;                    /* length to copy for repeats, bits to drop */
  var ret;                    /* return code */
  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
  var opts;

  var n; // temporary var for NEED_BITS

  var order = /* permutation of code lengths */
    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];


  if (!strm || !strm.state || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
    case HEAD:
      if (state.wrap === 0) {
        state.mode = TYPEDO;
        break;
      }
      //=== NEEDBITS(16);
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//

        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = FLAGS;
        break;
      }
      state.flags = 0;           /* expect zlib header */
      if (state.head) {
        state.head.done = false;
      }
      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
        strm.msg = 'incorrect header check';
        state.mode = BAD;
        break;
      }
      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
        strm.msg = 'unknown compression method';
        state.mode = BAD;
        break;
      }
      //--- DROPBITS(4) ---//
      hold >>>= 4;
      bits -= 4;
      //---//
      len = (hold & 0x0f)/*BITS(4)*/ + 8;
      if (state.wbits === 0) {
        state.wbits = len;
      }
      else if (len > state.wbits) {
        strm.msg = 'invalid window size';
        state.mode = BAD;
        break;
      }
      state.dmax = 1 << len;
      //Tracev((stderr, "inflate:   zlib header ok\n"));
      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
      state.mode = hold & 0x200 ? DICTID : TYPE;
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      break;
    case FLAGS:
      //=== NEEDBITS(16); */
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.flags = hold;
      if ((state.flags & 0xff) !== Z_DEFLATED) {
        strm.msg = 'unknown compression method';
        state.mode = BAD;
        break;
      }
      if (state.flags & 0xe000) {
        strm.msg = 'unknown header flags set';
        state.mode = BAD;
        break;
      }
      if (state.head) {
        state.head.text = ((hold >> 8) & 1);
      }
      if (state.flags & 0x0200) {
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = TIME;
      /* falls through */
    case TIME:
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if (state.head) {
        state.head.time = hold;
      }
      if (state.flags & 0x0200) {
        //=== CRC4(state.check, hold)
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        hbuf[2] = (hold >>> 16) & 0xff;
        hbuf[3] = (hold >>> 24) & 0xff;
        state.check = crc32(state.check, hbuf, 4, 0);
        //===
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = OS;
      /* falls through */
    case OS:
      //=== NEEDBITS(16); */
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if (state.head) {
        state.head.xflags = (hold & 0xff);
        state.head.os = (hold >> 8);
      }
      if (state.flags & 0x0200) {
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = EXLEN;
      /* falls through */
    case EXLEN:
      if (state.flags & 0x0400) {
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.length = hold;
        if (state.head) {
          state.head.extra_len = hold;
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
      }
      else if (state.head) {
        state.head.extra = null/*Z_NULL*/;
      }
      state.mode = EXTRA;
      /* falls through */
    case EXTRA:
      if (state.flags & 0x0400) {
        copy = state.length;
        if (copy > have) { copy = have; }
        if (copy) {
          if (state.head) {
            len = state.head.extra_len - state.length;
            if (!state.head.extra) {
              // Use untyped array for more conveniend processing later
              state.head.extra = new Array(state.head.extra_len);
            }
            utils.arraySet(
              state.head.extra,
              input,
              next,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              copy,
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              len
            );
            //zmemcpy(state.head.extra + len, next,
            //        len + copy > state.head.extra_max ?
            //        state.head.extra_max - len : copy);
          }
          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          state.length -= copy;
        }
        if (state.length) { break inf_leave; }
      }
      state.length = 0;
      state.mode = NAME;
      /* falls through */
    case NAME:
      if (state.flags & 0x0800) {
        if (have === 0) { break inf_leave; }
        copy = 0;
        do {
          // TODO: 2 or 1 bytes?
          len = input[next + copy++];
          /* use constant limit because in js we should not preallocate memory */
          if (state.head && len &&
              (state.length < 65536 /*state.head.name_max*/)) {
            state.head.name += String.fromCharCode(len);
          }
        } while (len && copy < have);

        if (state.flags & 0x0200) {
          state.check = crc32(state.check, input, copy, next);
        }
        have -= copy;
        next += copy;
        if (len) { break inf_leave; }
      }
      else if (state.head) {
        state.head.name = null;
      }
      state.length = 0;
      state.mode = COMMENT;
      /* falls through */
    case COMMENT:
      if (state.flags & 0x1000) {
        if (have === 0) { break inf_leave; }
        copy = 0;
        do {
          len = input[next + copy++];
          /* use constant limit because in js we should not preallocate memory */
          if (state.head && len &&
              (state.length < 65536 /*state.head.comm_max*/)) {
            state.head.comment += String.fromCharCode(len);
          }
        } while (len && copy < have);
        if (state.flags & 0x0200) {
          state.check = crc32(state.check, input, copy, next);
        }
        have -= copy;
        next += copy;
        if (len) { break inf_leave; }
      }
      else if (state.head) {
        state.head.comment = null;
      }
      state.mode = HCRC;
      /* falls through */
    case HCRC:
      if (state.flags & 0x0200) {
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (hold !== (state.check & 0xffff)) {
          strm.msg = 'header crc mismatch';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
      }
      if (state.head) {
        state.head.hcrc = ((state.flags >> 9) & 1);
        state.head.done = true;
      }
      strm.adler = state.check = 0;
      state.mode = TYPE;
      break;
    case DICTID:
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      strm.adler = state.check = zswap32(hold);
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = DICT;
      /* falls through */
    case DICT:
      if (state.havedict === 0) {
        //--- RESTORE() ---
        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits;
        //---
        return Z_NEED_DICT;
      }
      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
      state.mode = TYPE;
      /* falls through */
    case TYPE:
      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case TYPEDO:
      if (state.last) {
        //--- BYTEBITS() ---//
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        state.mode = CHECK;
        break;
      }
      //=== NEEDBITS(3); */
      while (bits < 3) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.last = (hold & 0x01)/*BITS(1)*/;
      //--- DROPBITS(1) ---//
      hold >>>= 1;
      bits -= 1;
      //---//

      switch ((hold & 0x03)/*BITS(2)*/) {
      case 0:                             /* stored block */
        //Tracev((stderr, "inflate:     stored block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = STORED;
        break;
      case 1:                             /* fixed block */
        fixedtables(state);
        //Tracev((stderr, "inflate:     fixed codes block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = LEN_;             /* decode codes */
        if (flush === Z_TREES) {
          //--- DROPBITS(2) ---//
          hold >>>= 2;
          bits -= 2;
          //---//
          break inf_leave;
        }
        break;
      case 2:                             /* dynamic block */
        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = TABLE;
        break;
      case 3:
        strm.msg = 'invalid block type';
        state.mode = BAD;
      }
      //--- DROPBITS(2) ---//
      hold >>>= 2;
      bits -= 2;
      //---//
      break;
    case STORED:
      //--- BYTEBITS() ---// /* go to byte boundary */
      hold >>>= bits & 7;
      bits -= bits & 7;
      //---//
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
        strm.msg = 'invalid stored block lengths';
        state.mode = BAD;
        break;
      }
      state.length = hold & 0xffff;
      //Tracev((stderr, "inflate:       stored length %u\n",
      //        state.length));
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = COPY_;
      if (flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case COPY_:
      state.mode = COPY;
      /* falls through */
    case COPY:
      copy = state.length;
      if (copy) {
        if (copy > have) { copy = have; }
        if (copy > left) { copy = left; }
        if (copy === 0) { break inf_leave; }
        //--- zmemcpy(put, next, copy); ---
        utils.arraySet(output, input, next, copy, put);
        //---//
        have -= copy;
        next += copy;
        left -= copy;
        put += copy;
        state.length -= copy;
        break;
      }
      //Tracev((stderr, "inflate:       stored end\n"));
      state.mode = TYPE;
      break;
    case TABLE:
      //=== NEEDBITS(14); */
      while (bits < 14) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
      //--- DROPBITS(5) ---//
      hold >>>= 5;
      bits -= 5;
      //---//
      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
      //--- DROPBITS(5) ---//
      hold >>>= 5;
      bits -= 5;
      //---//
      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
      //--- DROPBITS(4) ---//
      hold >>>= 4;
      bits -= 4;
      //---//
//#ifndef PKZIP_BUG_WORKAROUND
      if (state.nlen > 286 || state.ndist > 30) {
        strm.msg = 'too many length or distance symbols';
        state.mode = BAD;
        break;
      }
//#endif
      //Tracev((stderr, "inflate:       table sizes ok\n"));
      state.have = 0;
      state.mode = LENLENS;
      /* falls through */
    case LENLENS:
      while (state.have < state.ncode) {
        //=== NEEDBITS(3);
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
        //--- DROPBITS(3) ---//
        hold >>>= 3;
        bits -= 3;
        //---//
      }
      while (state.have < 19) {
        state.lens[order[state.have++]] = 0;
      }
      // We have separate tables & no pointers. 2 commented lines below not needed.
      //state.next = state.codes;
      //state.lencode = state.next;
      // Switch to use dynamic table
      state.lencode = state.lendyn;
      state.lenbits = 7;

      opts = { bits: state.lenbits };
      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
      state.lenbits = opts.bits;

      if (ret) {
        strm.msg = 'invalid code lengths set';
        state.mode = BAD;
        break;
      }
      //Tracev((stderr, "inflate:       code lengths ok\n"));
      state.have = 0;
      state.mode = CODELENS;
      /* falls through */
    case CODELENS:
      while (state.have < state.nlen + state.ndist) {
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_val < 16) {
          //--- DROPBITS(here.bits) ---//
          hold >>>= here_bits;
          bits -= here_bits;
          //---//
          state.lens[state.have++] = here_val;
        }
        else {
          if (here_val === 16) {
            //=== NEEDBITS(here.bits + 2);
            n = here_bits + 2;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            if (state.have === 0) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            len = state.lens[state.have - 1];
            copy = 3 + (hold & 0x03);//BITS(2);
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            //---//
          }
          else if (here_val === 17) {
            //=== NEEDBITS(here.bits + 3);
            n = here_bits + 3;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            len = 0;
            copy = 3 + (hold & 0x07);//BITS(3);
            //--- DROPBITS(3) ---//
            hold >>>= 3;
            bits -= 3;
            //---//
          }
          else {
            //=== NEEDBITS(here.bits + 7);
            n = here_bits + 7;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            len = 0;
            copy = 11 + (hold & 0x7f);//BITS(7);
            //--- DROPBITS(7) ---//
            hold >>>= 7;
            bits -= 7;
            //---//
          }
          if (state.have + copy > state.nlen + state.ndist) {
            strm.msg = 'invalid bit length repeat';
            state.mode = BAD;
            break;
          }
          while (copy--) {
            state.lens[state.have++] = len;
          }
        }
      }

      /* handle error breaks in while */
      if (state.mode === BAD) { break; }

      /* check for end-of-block code (better have one) */
      if (state.lens[256] === 0) {
        strm.msg = 'invalid code -- missing end-of-block';
        state.mode = BAD;
        break;
      }

      /* build code tables -- note: do not change the lenbits or distbits
         values here (9 and 6) without reading the comments in inftrees.h
         concerning the ENOUGH constants, which depend on those values */
      state.lenbits = 9;

      opts = { bits: state.lenbits };
      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
      // We have separate tables & no pointers. 2 commented lines below not needed.
      // state.next_index = opts.table_index;
      state.lenbits = opts.bits;
      // state.lencode = state.next;

      if (ret) {
        strm.msg = 'invalid literal/lengths set';
        state.mode = BAD;
        break;
      }

      state.distbits = 6;
      //state.distcode.copy(state.codes);
      // Switch to use dynamic table
      state.distcode = state.distdyn;
      opts = { bits: state.distbits };
      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
      // We have separate tables & no pointers. 2 commented lines below not needed.
      // state.next_index = opts.table_index;
      state.distbits = opts.bits;
      // state.distcode = state.next;

      if (ret) {
        strm.msg = 'invalid distances set';
        state.mode = BAD;
        break;
      }
      //Tracev((stderr, 'inflate:       codes ok\n'));
      state.mode = LEN_;
      if (flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case LEN_:
      state.mode = LEN;
      /* falls through */
    case LEN:
      if (have >= 6 && left >= 258) {
        //--- RESTORE() ---
        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits;
        //---
        inflate_fast(strm, _out);
        //--- LOAD() ---
        put = strm.next_out;
        output = strm.output;
        left = strm.avail_out;
        next = strm.next_in;
        input = strm.input;
        have = strm.avail_in;
        hold = state.hold;
        bits = state.bits;
        //---

        if (state.mode === TYPE) {
          state.back = -1;
        }
        break;
      }
      state.back = 0;
      for (;;) {
        here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
        here_bits = here >>> 24;
        here_op = (here >>> 16) & 0xff;
        here_val = here & 0xffff;

        if (here_bits <= bits) { break; }
        //--- PULLBYTE() ---//
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
        //---//
      }
      if (here_op && (here_op & 0xf0) === 0) {
        last_bits = here_bits;
        last_op = here_op;
        last_val = here_val;
        for (;;) {
          here = state.lencode[last_val +
                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((last_bits + here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        //--- DROPBITS(last.bits) ---//
        hold >>>= last_bits;
        bits -= last_bits;
        //---//
        state.back += last_bits;
      }
      //--- DROPBITS(here.bits) ---//
      hold >>>= here_bits;
      bits -= here_bits;
      //---//
      state.back += here_bits;
      state.length = here_val;
      if (here_op === 0) {
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        state.mode = LIT;
        break;
      }
      if (here_op & 32) {
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.back = -1;
        state.mode = TYPE;
        break;
      }
      if (here_op & 64) {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break;
      }
      state.extra = here_op & 15;
      state.mode = LENEXT;
      /* falls through */
    case LENEXT:
      if (state.extra) {
        //=== NEEDBITS(state.extra);
        n = state.extra;
        while (bits < n) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
        //--- DROPBITS(state.extra) ---//
        hold >>>= state.extra;
        bits -= state.extra;
        //---//
        state.back += state.extra;
      }
      //Tracevv((stderr, "inflate:         length %u\n", state.length));
      state.was = state.length;
      state.mode = DIST;
      /* falls through */
    case DIST:
      for (;;) {
        here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
        here_bits = here >>> 24;
        here_op = (here >>> 16) & 0xff;
        here_val = here & 0xffff;

        if ((here_bits) <= bits) { break; }
        //--- PULLBYTE() ---//
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
        //---//
      }
      if ((here_op & 0xf0) === 0) {
        last_bits = here_bits;
        last_op = here_op;
        last_val = here_val;
        for (;;) {
          here = state.distcode[last_val +
                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((last_bits + here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        //--- DROPBITS(last.bits) ---//
        hold >>>= last_bits;
        bits -= last_bits;
        //---//
        state.back += last_bits;
      }
      //--- DROPBITS(here.bits) ---//
      hold >>>= here_bits;
      bits -= here_bits;
      //---//
      state.back += here_bits;
      if (here_op & 64) {
        strm.msg = 'invalid distance code';
        state.mode = BAD;
        break;
      }
      state.offset = here_val;
      state.extra = (here_op) & 15;
      state.mode = DISTEXT;
      /* falls through */
    case DISTEXT:
      if (state.extra) {
        //=== NEEDBITS(state.extra);
        n = state.extra;
        while (bits < n) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
        //--- DROPBITS(state.extra) ---//
        hold >>>= state.extra;
        bits -= state.extra;
        //---//
        state.back += state.extra;
      }
//#ifdef INFLATE_STRICT
      if (state.offset > state.dmax) {
        strm.msg = 'invalid distance too far back';
        state.mode = BAD;
        break;
      }
//#endif
      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
      state.mode = MATCH;
      /* falls through */
    case MATCH:
      if (left === 0) { break inf_leave; }
      copy = _out - left;
      if (state.offset > copy) {         /* copy from window */
        copy = state.offset - copy;
        if (copy > state.whave) {
          if (state.sane) {
            strm.msg = 'invalid distance too far back';
            state.mode = BAD;
            break;
          }
// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
        }
        if (copy > state.wnext) {
          copy -= state.wnext;
          from = state.wsize - copy;
        }
        else {
          from = state.wnext - copy;
        }
        if (copy > state.length) { copy = state.length; }
        from_source = state.window;
      }
      else {                              /* copy from output */
        from_source = output;
        from = put - state.offset;
        copy = state.length;
      }
      if (copy > left) { copy = left; }
      left -= copy;
      state.length -= copy;
      do {
        output[put++] = from_source[from++];
      } while (--copy);
      if (state.length === 0) { state.mode = LEN; }
      break;
    case LIT:
      if (left === 0) { break inf_leave; }
      output[put++] = state.length;
      left--;
      state.mode = LEN;
      break;
    case CHECK:
      if (state.wrap) {
        //=== NEEDBITS(32);
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          // Use '|' insdead of '+' to make sure that result is signed
          hold |= input[next++] << bits;
          bits += 8;
        }
        //===//
        _out -= left;
        strm.total_out += _out;
        state.total += _out;
        if (_out) {
          strm.adler = state.check =
              /*UPDATE(state.check, put - _out, _out);*/
              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

        }
        _out = left;
        // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
        if ((state.flags ? hold : zswap32(hold)) !== state.check) {
          strm.msg = 'incorrect data check';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        //Tracev((stderr, "inflate:   check matches trailer\n"));
      }
      state.mode = LENGTH;
      /* falls through */
    case LENGTH:
      if (state.wrap && state.flags) {
        //=== NEEDBITS(32);
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (hold !== (state.total & 0xffffffff)) {
          strm.msg = 'incorrect length check';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        //Tracev((stderr, "inflate:   length matches trailer\n"));
      }
      state.mode = DONE;
      /* falls through */
    case DONE:
      ret = Z_STREAM_END;
      break inf_leave;
    case BAD:
      ret = Z_DATA_ERROR;
      break inf_leave;
    case MEM:
      return Z_MEM_ERROR;
    case SYNC:
      /* falls through */
    default:
      return Z_STREAM_ERROR;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
      state.mode = MEM;
      return Z_MEM_ERROR;
    }
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
    ret = Z_BUF_ERROR;
  }
  return ret;
}

function inflateEnd(strm) {

  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
    return Z_STREAM_ERROR;
  }

  var state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK;
}

function inflateGetHeader(strm, head) {
  var state;

  /* check state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK;
}

function inflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var state;
  var dictid;
  var ret;

  /* check state */
  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
  state = strm.state;

  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR;
  }

  /* check for correct dictionary identifier */
  if (state.mode === DICT) {
    dictid = 1; /* adler32(0, null, 0)*/
    /* dictid = adler32(dictid, dictionary, dictLength); */
    dictid = adler32(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR;
    }
  }
  /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR;
  }
  state.havedict = 1;
  // Tracev((stderr, "inflate:   dictionary set\n"));
  return Z_OK;
}

exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateInfo = 'pako inflate (from Nodeca project)';

/* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/

},{"../utils/common":41,"./adler32":43,"./crc32":45,"./inffast":48,"./inftrees":50}],50:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils = require('../utils/common');

var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

var lbase = [ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
];

var lext = [ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
];

var dbase = [ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
];

var dext = [ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
];

module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
{
  var bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  var len = 0;               /* a code's length in bits */
  var sym = 0;               /* index of code symbols */
  var min = 0, max = 0;          /* minimum and maximum code lengths */
  var root = 0;              /* number of index bits for root table */
  var curr = 0;              /* number of index bits for current table */
  var drop = 0;              /* code bits to drop for sub-table */
  var left = 0;                   /* number of prefix codes available */
  var used = 0;              /* code entries in table used */
  var huff = 0;              /* Huffman code */
  var incr;              /* for incrementing code, index */
  var fill;              /* index for replicating entries */
  var low;               /* low bits for current root entry */
  var mask;              /* mask for low root bits */
  var next;             /* next available space in table */
  var base = null;     /* base value table to use */
  var base_index = 0;
//  var shoextra;    /* extra bits table to use */
  var end;                    /* use base and extra for symbol > end */
  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
  var extra = null;
  var extra_index = 0;

  var here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES) {
    base = extra = work;    /* dummy value--not used */
    end = 19;

  } else if (type === LENS) {
    base = lbase;
    base_index -= 257;
    extra = lext;
    extra_index -= 257;
    end = 256;

  } else {                    /* DISTS */
    base = dbase;
    extra = dext;
    end = -1;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS && used > ENOUGH_LENS) ||
    (type === DISTS && used > ENOUGH_DISTS)) {
    return 1;
  }

  /* process all codes and make table entries */
  for (;;) {
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] < end) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] > end) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS && used > ENOUGH_LENS) ||
        (type === DISTS && used > ENOUGH_DISTS)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};

},{"../utils/common":41}],51:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};

},{}],52:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils = require('../utils/common');

/* Public constants ==========================================================*/
/* ===========================================================================*/


//var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED               = 4;
//var Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
var Z_BINARY              = 0;
var Z_TEXT                = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;

/*============================================================================*/


function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES    = 2;
/* The three kinds of block type */

var MIN_MATCH    = 3;
var MAX_MATCH    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */

var LITERALS      = 256;
/* number of literal bytes 0..255 */

var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */

var D_CODES       = 30;
/* number of distance codes */

var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */

var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */

var MAX_BITS      = 15;
/* All codes must not exceed MAX_BITS bits */

var Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

var END_BLOCK   = 256;
/* end of block literal code */

var REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

var REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
var extra_lbits =   /* extra bits for each length code */
  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

var extra_dbits =   /* extra bits for each distance code */
  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

var extra_blbits =  /* extra bits for each bit length code */
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

var bl_order =
  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
var static_ltree  = new Array((L_CODES + 2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

var static_dtree  = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

var _dist_code    = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

var base_length   = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

var base_dist     = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


var static_l_desc;
var static_d_desc;
var static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
function put_short(s, w) {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
}


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
function send_bits(s, value, length) {
  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
}


function send_code(s, c, tree) {
  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
}


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
function bi_reverse(code, len) {
  var res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
function gen_bitlen(s, desc)
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
  var tree            = desc.dyn_tree;
  var max_code        = desc.max_code;
  var stree           = desc.stat_desc.static_tree;
  var has_stree       = desc.stat_desc.has_stree;
  var extra           = desc.stat_desc.extra_bits;
  var base            = desc.stat_desc.extra_base;
  var max_length      = desc.stat_desc.max_length;
  var h;              /* heap index */
  var n, m;           /* iterate over the tree elements */
  var bits;           /* bit length */
  var xbits;          /* extra bits */
  var f;              /* frequency */
  var overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Trace((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
}


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
function gen_codes(tree, max_code, bl_count)
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
  var code = 0;              /* running code value */
  var bits;                  /* bit index */
  var n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS; bits++) {
    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    var len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
}


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
function tr_static_init() {
  var n;        /* iterates over tree elements */
  var bits;     /* bit counter */
  var length;   /* length value */
  var code;     /* code value */
  var dist;     /* distance index */
  var bl_count = new Array(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);

  //static_init_done = true;
}


/* ===========================================================================
 * Initialize a new block.
 */
function init_block(s) {
  var n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
function bi_windup(s)
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}

/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
function copy_block(s, buf, len, header)
//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
  bi_windup(s);        /* align on byte boundary */

  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
//  while (len--) {
//    put_byte(s, *buf++);
//  }
  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
function smaller(tree, n, m, depth) {
  var _n2 = n * 2;
  var _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
}

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
function pqdownheap(s, tree, k)
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
  var v = s.heap[k];
  var j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
}


// inlined manually
// var SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
function compress_block(s, ltree, dtree)
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
  var dist;           /* distance of matched string */
  var lc;             /* match length or unmatched char (if dist == 0) */
  var lx = 0;         /* running index in l_buf */
  var code;           /* the code to send */
  var extra;          /* number of extra bits to send */

  if (s.last_lit !== 0) {
    do {
      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
      lc = s.pending_buf[s.l_buf + lx];
      lx++;

      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
      //       "pendingBuf overflow");

    } while (lx < s.last_lit);
  }

  send_code(s, END_BLOCK, ltree);
}


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
function build_tree(s, desc)
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
  var tree     = desc.dyn_tree;
  var stree    = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems    = desc.stat_desc.elems;
  var n, m;          /* iterate over heap elements */
  var max_code = -1; /* largest code with non zero frequency */
  var node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
}


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
function scan_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
function send_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
function build_bl_tree(s) {
  var max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
}


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
function send_all_trees(s, lcodes, dcodes, blcodes)
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
  var rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
function detect_data_type(s) {
  /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  var black_mask = 0xf3ffc07f;
  var n;

  /* Check for non-textual ("black-listed") bytes. */
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("white-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
}


var static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
function _tr_init(s)
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
}


/* ===========================================================================
 * Send a stored block
 */
function _tr_stored_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  copy_block(s, buf, stored_len, true); /* with header */
}


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
function _tr_align(s) {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
function _tr_flush_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  var max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->last_lit));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
}

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
function _tr_tally(s, dist, lc)
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
  //var out_length, in_length, dcode;

  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;

  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility

//#ifdef TRUNCATE_BLOCK
//  /* Try to guess if it is profitable to stop the current block here */
//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
//    /* Compute an upper bound for the compressed length */
//    out_length = s.last_lit*8;
//    in_length = s.strstart - s.block_start;
//
//    for (dcode = 0; dcode < D_CODES; dcode++) {
//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
//    }
//    out_length >>>= 3;
//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
//    //       s->last_lit, in_length, out_length,
//    //       100L - out_length*100L/in_length));
//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
//      return true;
//    }
//  }
//#endif

  return (s.last_lit === s.lit_bufsize - 1);
  /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
}

exports._tr_init  = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block  = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;

},{"../utils/common":41}],53:[function(require,module,exports){
'use strict';

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

module.exports = ZStream;

},{}],54:[function(require,module,exports){
(function (global){
(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[10])(10)
});
/*! Buttons for DataTables 1.7.1
 * ©2016-2021 SpryMedia Ltd - datatables.net/license
 */

(function( factory ){
	if ( typeof define === 'function' && define.amd ) {
		// AMD
		define( ['jquery', 'datatables.net'], function ( $ ) {
			return factory( $, window, document );
		} );
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net')(root, $).$;
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;


// Used for namespacing events added to the document by each instance, so they
// can be removed on destroy
var _instCounter = 0;

// Button namespacing counter for namespacing events on individual buttons
var _buttonCounter = 0;

var _dtButtons = DataTable.ext.buttons;

// Allow for jQuery slim
function _fadeIn(el, duration, fn) {
	if ($.fn.animate) {
		el
			.stop()
			.fadeIn( duration, fn );
	}
	else {
		el.css('display', 'block');

		if (fn) {
			fn.call(el);
		}
	}
}

function _fadeOut(el, duration, fn) {
	if ($.fn.animate) {
		el
			.stop()
			.fadeOut( duration, fn );
	}
	else {
		el.css('display', 'none');
		
		if (fn) {
			fn.call(el);
		}
	}
}

/**
 * [Buttons description]
 * @param {[type]}
 * @param {[type]}
 */
var Buttons = function( dt, config )
{
	// If not created with a `new` keyword then we return a wrapper function that
	// will take the settings object for a DT. This allows easy use of new instances
	// with the `layout` option - e.g. `topLeft: $.fn.dataTable.Buttons( ... )`.
	if ( !(this instanceof Buttons) ) {
		return function (settings) {
			return new Buttons( settings, dt ).container();
		};
	}

	// If there is no config set it to an empty object
	if ( typeof( config ) === 'undefined' ) {
		config = {};	
	}
	
	// Allow a boolean true for defaults
	if ( config === true ) {
		config = {};
	}

	// For easy configuration of buttons an array can be given
	if ( Array.isArray( config ) ) {
		config = { buttons: config };
	}

	this.c = $.extend( true, {}, Buttons.defaults, config );

	// Don't want a deep copy for the buttons
	if ( config.buttons ) {
		this.c.buttons = config.buttons;
	}

	this.s = {
		dt: new DataTable.Api( dt ),
		buttons: [],
		listenKeys: '',
		namespace: 'dtb'+(_instCounter++)
	};

	this.dom = {
		container: $('<'+this.c.dom.container.tag+'/>')
			.addClass( this.c.dom.container.className )
	};

	this._constructor();
};


$.extend( Buttons.prototype, {
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Public methods
	 */

	/**
	 * Get the action of a button
	 * @param  {int|string} Button index
	 * @return {function}
	 *//**
	 * Set the action of a button
	 * @param  {node} node Button element
	 * @param  {function} action Function to set
	 * @return {Buttons} Self for chaining
	 */
	action: function ( node, action )
	{
		var button = this._nodeToButton( node );

		if ( action === undefined ) {
			return button.conf.action;
		}

		button.conf.action = action;

		return this;
	},

	/**
	 * Add an active class to the button to make to look active or get current
	 * active state.
	 * @param  {node} node Button element
	 * @param  {boolean} [flag] Enable / disable flag
	 * @return {Buttons} Self for chaining or boolean for getter
	 */
	active: function ( node, flag ) {
		var button = this._nodeToButton( node );
		var klass = this.c.dom.button.active;
		var jqNode = $(button.node);

		if ( flag === undefined ) {
			return jqNode.hasClass( klass );
		}

		jqNode.toggleClass( klass, flag === undefined ? true : flag );

		return this;
	},

	/**
	 * Add a new button
	 * @param {object} config Button configuration object, base string name or function
	 * @param {int|string} [idx] Button index for where to insert the button
	 * @return {Buttons} Self for chaining
	 */
	add: function ( config, idx )
	{
		var buttons = this.s.buttons;

		if ( typeof idx === 'string' ) {
			var split = idx.split('-');
			var base = this.s;

			for ( var i=0, ien=split.length-1 ; i<ien ; i++ ) {
				base = base.buttons[ split[i]*1 ];
			}

			buttons = base.buttons;
			idx = split[ split.length-1 ]*1;
		}

		this._expandButton( buttons, config, base !== undefined, idx );
		this._draw();

		return this;
	},

	/**
	 * Get the container node for the buttons
	 * @return {jQuery} Buttons node
	 */
	container: function ()
	{
		return this.dom.container;
	},

	/**
	 * Disable a button
	 * @param  {node} node Button node
	 * @return {Buttons} Self for chaining
	 */
	disable: function ( node ) {
		var button = this._nodeToButton( node );

		$(button.node)
			.addClass( this.c.dom.button.disabled )
			.attr('disabled', true);

		return this;
	},

	/**
	 * Destroy the instance, cleaning up event handlers and removing DOM
	 * elements
	 * @return {Buttons} Self for chaining
	 */
	destroy: function ()
	{
		// Key event listener
		$('body').off( 'keyup.'+this.s.namespace );

		// Individual button destroy (so they can remove their own events if
		// needed). Take a copy as the array is modified by `remove`
		var buttons = this.s.buttons.slice();
		var i, ien;
		
		for ( i=0, ien=buttons.length ; i<ien ; i++ ) {
			this.remove( buttons[i].node );
		}

		// Container
		this.dom.container.remove();

		// Remove from the settings object collection
		var buttonInsts = this.s.dt.settings()[0];

		for ( i=0, ien=buttonInsts.length ; i<ien ; i++ ) {
			if ( buttonInsts.inst === this ) {
				buttonInsts.splice( i, 1 );
				break;
			}
		}

		return this;
	},

	/**
	 * Enable / disable a button
	 * @param  {node} node Button node
	 * @param  {boolean} [flag=true] Enable / disable flag
	 * @return {Buttons} Self for chaining
	 */
	enable: function ( node, flag )
	{
		if ( flag === false ) {
			return this.disable( node );
		}

		var button = this._nodeToButton( node );
		$(button.node)
			.removeClass( this.c.dom.button.disabled )
			.removeAttr('disabled');

		return this;
	},

	/**
	 * Get the instance name for the button set selector
	 * @return {string} Instance name
	 */
	name: function ()
	{
		return this.c.name;
	},

	/**
	 * Get a button's node of the buttons container if no button is given
	 * @param  {node} [node] Button node
	 * @return {jQuery} Button element, or container
	 */
	node: function ( node )
	{
		if ( ! node ) {
			return this.dom.container;
		}

		var button = this._nodeToButton( node );
		return $(button.node);
	},

	/**
	 * Set / get a processing class on the selected button
	 * @param {element} node Triggering button node
	 * @param  {boolean} flag true to add, false to remove, undefined to get
	 * @return {boolean|Buttons} Getter value or this if a setter.
	 */
	processing: function ( node, flag )
	{
		var dt = this.s.dt;
		var button = this._nodeToButton( node );

		if ( flag === undefined ) {
			return $(button.node).hasClass( 'processing' );
		}

		$(button.node).toggleClass( 'processing', flag );

		$(dt.table().node()).triggerHandler( 'buttons-processing.dt', [
			flag, dt.button( node ), dt, $(node), button.conf
		] );

		return this;
	},

	/**
	 * Remove a button.
	 * @param  {node} node Button node
	 * @return {Buttons} Self for chaining
	 */
	remove: function ( node )
	{
		var button = this._nodeToButton( node );
		var host = this._nodeToHost( node );
		var dt = this.s.dt;

		// Remove any child buttons first
		if ( button.buttons.length ) {
			for ( var i=button.buttons.length-1 ; i>=0 ; i-- ) {
				this.remove( button.buttons[i].node );
			}
		}

		// Allow the button to remove event handlers, etc
		if ( button.conf.destroy ) {
			button.conf.destroy.call( dt.button(node), dt, $(node), button.conf );
		}

		this._removeKey( button.conf );

		$(button.node).remove();

		var idx = $.inArray( button, host );
		host.splice( idx, 1 );

		return this;
	},

	/**
	 * Get the text for a button
	 * @param  {int|string} node Button index
	 * @return {string} Button text
	 *//**
	 * Set the text for a button
	 * @param  {int|string|function} node Button index
	 * @param  {string} label Text
	 * @return {Buttons} Self for chaining
	 */
	text: function ( node, label )
	{
		var button = this._nodeToButton( node );
		var buttonLiner = this.c.dom.collection.buttonLiner;
		var linerTag = button.inCollection && buttonLiner && buttonLiner.tag ?
			buttonLiner.tag :
			this.c.dom.buttonLiner.tag;
		var dt = this.s.dt;
		var jqNode = $(button.node);
		var text = function ( opt ) {
			return typeof opt === 'function' ?
				opt( dt, jqNode, button.conf ) :
				opt;
		};

		if ( label === undefined ) {
			return text( button.conf.text );
		}

		button.conf.text = label;

		if ( linerTag ) {
			jqNode.children( linerTag ).html( text(label) );
		}
		else {
			jqNode.html( text(label) );
		}

		return this;
	},


	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Constructor
	 */

	/**
	 * Buttons constructor
	 * @private
	 */
	_constructor: function ()
	{
		var that = this;
		var dt = this.s.dt;
		var dtSettings = dt.settings()[0];
		var buttons =  this.c.buttons;

		if ( ! dtSettings._buttons ) {
			dtSettings._buttons = [];
		}

		dtSettings._buttons.push( {
			inst: this,
			name: this.c.name
		} );

		for ( var i=0, ien=buttons.length ; i<ien ; i++ ) {
			this.add( buttons[i] );
		}

		dt.on( 'destroy', function ( e, settings ) {
			if ( settings === dtSettings ) {
				that.destroy();
			}
		} );

		// Global key event binding to listen for button keys
		$('body').on( 'keyup.'+this.s.namespace, function ( e ) {
			if ( ! document.activeElement || document.activeElement === document.body ) {
				// SUse a string of characters for fast lookup of if we need to
				// handle this
				var character = String.fromCharCode(e.keyCode).toLowerCase();

				if ( that.s.listenKeys.toLowerCase().indexOf( character ) !== -1 ) {
					that._keypress( character, e );
				}
			}
		} );
	},


	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Private methods
	 */

	/**
	 * Add a new button to the key press listener
	 * @param {object} conf Resolved button configuration object
	 * @private
	 */
	_addKey: function ( conf )
	{
		if ( conf.key ) {
			this.s.listenKeys += $.isPlainObject( conf.key ) ?
				conf.key.key :
				conf.key;
		}
	},

	/**
	 * Insert the buttons into the container. Call without parameters!
	 * @param  {node} [container] Recursive only - Insert point
	 * @param  {array} [buttons] Recursive only - Buttons array
	 * @private
	 */
	_draw: function ( container, buttons )
	{
		if ( ! container ) {
			container = this.dom.container;
			buttons = this.s.buttons;
		}

		container.children().detach();

		for ( var i=0, ien=buttons.length ; i<ien ; i++ ) {
			container.append( buttons[i].inserter );
			container.append( ' ' );

			if ( buttons[i].buttons && buttons[i].buttons.length ) {
				this._draw( buttons[i].collection, buttons[i].buttons );
			}
		}
	},

	/**
	 * Create buttons from an array of buttons
	 * @param  {array} attachTo Buttons array to attach to
	 * @param  {object} button Button definition
	 * @param  {boolean} inCollection true if the button is in a collection
	 * @private
	 */
	_expandButton: function ( attachTo, button, inCollection, attachPoint )
	{
		var dt = this.s.dt;
		var buttonCounter = 0;
		var buttons = ! Array.isArray( button ) ?
			[ button ] :
			button;

		for ( var i=0, ien=buttons.length ; i<ien ; i++ ) {
			var conf = this._resolveExtends( buttons[i] );

			if ( ! conf ) {
				continue;
			}

			// If the configuration is an array, then expand the buttons at this
			// point
			if ( Array.isArray( conf ) ) {
				this._expandButton( attachTo, conf, inCollection, attachPoint );
				continue;
			}

			var built = this._buildButton( conf, inCollection );
			if ( ! built ) {
				continue;
			}

			if ( attachPoint !== undefined && attachPoint !== null ) {
				attachTo.splice( attachPoint, 0, built );
				attachPoint++;
			}
			else {
				attachTo.push( built );
			}

			if ( built.conf.buttons ) {
				built.collection = $('<'+this.c.dom.collection.tag+'/>');

				built.conf._collection = built.collection;

				this._expandButton( built.buttons, built.conf.buttons, true, attachPoint );
			}

			// init call is made here, rather than buildButton as it needs to
			// be selectable, and for that it needs to be in the buttons array
			if ( conf.init ) {
				conf.init.call( dt.button( built.node ), dt, $(built.node), conf );
			}

			buttonCounter++;
		}
	},

	/**
	 * Create an individual button
	 * @param  {object} config            Resolved button configuration
	 * @param  {boolean} inCollection `true` if a collection button
	 * @return {jQuery} Created button node (jQuery)
	 * @private
	 */
	_buildButton: function ( config, inCollection )
	{
		var buttonDom = this.c.dom.button;
		var linerDom = this.c.dom.buttonLiner;
		var collectionDom = this.c.dom.collection;
		var dt = this.s.dt;
		var text = function ( opt ) {
			return typeof opt === 'function' ?
				opt( dt, button, config ) :
				opt;
		};

		if ( inCollection && collectionDom.button ) {
			buttonDom = collectionDom.button;
		}

		if ( inCollection && collectionDom.buttonLiner ) {
			linerDom = collectionDom.buttonLiner;
		}

		// Make sure that the button is available based on whatever requirements
		// it has. For example, PDF button require pdfmake
		if ( config.available && ! config.available( dt, config ) ) {
			return false;
		}

		var action = function ( e, dt, button, config ) {
			config.action.call( dt.button( button ), e, dt, button, config );

			$(dt.table().node()).triggerHandler( 'buttons-action.dt', [
				dt.button( button ), dt, button, config 
			] );
		};

		var tag = config.tag || buttonDom.tag;
		var clickBlurs = config.clickBlurs === undefined ? true : config.clickBlurs
		var button = $('<'+tag+'/>')
			.addClass( buttonDom.className )
			.attr( 'tabindex', this.s.dt.settings()[0].iTabIndex )
			.attr( 'aria-controls', this.s.dt.table().node().id )
			.on( 'click.dtb', function (e) {
				e.preventDefault();

				if ( ! button.hasClass( buttonDom.disabled ) && config.action ) {
					action( e, dt, button, config );
				}
				if( clickBlurs ) {
					button.trigger('blur');
				}
			} )
			.on( 'keyup.dtb', function (e) {
				if ( e.keyCode === 13 ) {
					if ( ! button.hasClass( buttonDom.disabled ) && config.action ) {
						action( e, dt, button, config );
					}
				}
			} );

		// Make `a` tags act like a link
		if ( tag.toLowerCase() === 'a' ) {
			button.attr( 'href', '#' );
		}

		// Button tags should have `type=button` so they don't have any default behaviour
		if ( tag.toLowerCase() === 'button' ) {
			button.attr( 'type', 'button' );
		}

		if ( linerDom.tag ) {
			var liner = $('<'+linerDom.tag+'/>')
				.html( text( config.text ) )
				.addClass( linerDom.className );

			if ( linerDom.tag.toLowerCase() === 'a' ) {
				liner.attr( 'href', '#' );
			}

			button.append( liner );
		}
		else {
			button.html( text( config.text ) );
		}

		if ( config.enabled === false ) {
			button.addClass( buttonDom.disabled );
		}

		if ( config.className ) {
			button.addClass( config.className );
		}

		if ( config.titleAttr ) {
			button.attr( 'title', text( config.titleAttr ) );
		}

		if ( config.attr ) {
			button.attr( config.attr );
		}

		if ( ! config.namespace ) {
			config.namespace = '.dt-button-'+(_buttonCounter++);
		}

		var buttonContainer = this.c.dom.buttonContainer;
		var inserter;
		if ( buttonContainer && buttonContainer.tag ) {
			inserter = $('<'+buttonContainer.tag+'/>')
				.addClass( buttonContainer.className )
				.append( button );
		}
		else {
			inserter = button;
		}

		this._addKey( config );

		// Style integration callback for DOM manipulation
		// Note that this is _not_ documented. It is currently
		// for style integration only
		if( this.c.buttonCreated ) {
			inserter = this.c.buttonCreated( config, inserter );
		}

		return {
			conf:         config,
			node:         button.get(0),
			inserter:     inserter,
			buttons:      [],
			inCollection: inCollection,
			collection:   null
		};
	},

	/**
	 * Get the button object from a node (recursive)
	 * @param  {node} node Button node
	 * @param  {array} [buttons] Button array, uses base if not defined
	 * @return {object} Button object
	 * @private
	 */
	_nodeToButton: function ( node, buttons )
	{
		if ( ! buttons ) {
			buttons = this.s.buttons;
		}

		for ( var i=0, ien=buttons.length ; i<ien ; i++ ) {
			if ( buttons[i].node === node ) {
				return buttons[i];
			}

			if ( buttons[i].buttons.length ) {
				var ret = this._nodeToButton( node, buttons[i].buttons );

				if ( ret ) {
					return ret;
				}
			}
		}
	},

	/**
	 * Get container array for a button from a button node (recursive)
	 * @param  {node} node Button node
	 * @param  {array} [buttons] Button array, uses base if not defined
	 * @return {array} Button's host array
	 * @private
	 */
	_nodeToHost: function ( node, buttons )
	{
		if ( ! buttons ) {
			buttons = this.s.buttons;
		}

		for ( var i=0, ien=buttons.length ; i<ien ; i++ ) {
			if ( buttons[i].node === node ) {
				return buttons;
			}

			if ( buttons[i].buttons.length ) {
				var ret = this._nodeToHost( node, buttons[i].buttons );

				if ( ret ) {
					return ret;
				}
			}
		}
	},

	/**
	 * Handle a key press - determine if any button's key configured matches
	 * what was typed and trigger the action if so.
	 * @param  {string} character The character pressed
	 * @param  {object} e Key event that triggered this call
	 * @private
	 */
	_keypress: function ( character, e )
	{
		// Check if this button press already activated on another instance of Buttons
		if ( e._buttonsHandled ) {
			return;
		}

		var run = function ( conf, node ) {
			if ( ! conf.key ) {
				return;
			}

			if ( conf.key === character ) {
				e._buttonsHandled = true;
				$(node).click();
			}
			else if ( $.isPlainObject( conf.key ) ) {
				if ( conf.key.key !== character ) {
					return;
				}

				if ( conf.key.shiftKey && ! e.shiftKey ) {
					return;
				}

				if ( conf.key.altKey && ! e.altKey ) {
					return;
				}

				if ( conf.key.ctrlKey && ! e.ctrlKey ) {
					return;
				}

				if ( conf.key.metaKey && ! e.metaKey ) {
					return;
				}

				// Made it this far - it is good
				e._buttonsHandled = true;
				$(node).click();
			}
		};

		var recurse = function ( a ) {
			for ( var i=0, ien=a.length ; i<ien ; i++ ) {
				run( a[i].conf, a[i].node );

				if ( a[i].buttons.length ) {
					recurse( a[i].buttons );
				}
			}
		};

		recurse( this.s.buttons );
	},

	/**
	 * Remove a key from the key listener for this instance (to be used when a
	 * button is removed)
	 * @param  {object} conf Button configuration
	 * @private
	 */
	_removeKey: function ( conf )
	{
		if ( conf.key ) {
			var character = $.isPlainObject( conf.key ) ?
				conf.key.key :
				conf.key;

			// Remove only one character, as multiple buttons could have the
			// same listening key
			var a = this.s.listenKeys.split('');
			var idx = $.inArray( character, a );
			a.splice( idx, 1 );
			this.s.listenKeys = a.join('');
		}
	},

	/**
	 * Resolve a button configuration
	 * @param  {string|function|object} conf Button config to resolve
	 * @return {object} Button configuration
	 * @private
	 */
	_resolveExtends: function ( conf )
	{
		var dt = this.s.dt;
		var i, ien;
		var toConfObject = function ( base ) {
			var loop = 0;

			// Loop until we have resolved to a button configuration, or an
			// array of button configurations (which will be iterated
			// separately)
			while ( ! $.isPlainObject(base) && ! Array.isArray(base) ) {
				if ( base === undefined ) {
					return;
				}

				if ( typeof base === 'function' ) {
					base = base( dt, conf );

					if ( ! base ) {
						return false;
					}
				}
				else if ( typeof base === 'string' ) {
					if ( ! _dtButtons[ base ] ) {
						throw 'Unknown button type: '+base;
					}

					base = _dtButtons[ base ];
				}

				loop++;
				if ( loop > 30 ) {
					// Protect against misconfiguration killing the browser
					throw 'Buttons: Too many iterations';
				}
			}

			return Array.isArray( base ) ?
				base :
				$.extend( {}, base );
		};

		conf = toConfObject( conf );

		while ( conf && conf.extend ) {
			// Use `toConfObject` in case the button definition being extended
			// is itself a string or a function
			if ( ! _dtButtons[ conf.extend ] ) {
				throw 'Cannot extend unknown button type: '+conf.extend;
			}

			var objArray = toConfObject( _dtButtons[ conf.extend ] );
			if ( Array.isArray( objArray ) ) {
				return objArray;
			}
			else if ( ! objArray ) {
				// This is a little brutal as it might be possible to have a
				// valid button without the extend, but if there is no extend
				// then the host button would be acting in an undefined state
				return false;
			}

			// Stash the current class name
			var originalClassName = objArray.className;

			conf = $.extend( {}, objArray, conf );

			// The extend will have overwritten the original class name if the
			// `conf` object also assigned a class, but we want to concatenate
			// them so they are list that is combined from all extended buttons
			if ( originalClassName && conf.className !== originalClassName ) {
				conf.className = originalClassName+' '+conf.className;
			}

			// Buttons to be added to a collection  -gives the ability to define
			// if buttons should be added to the start or end of a collection
			var postfixButtons = conf.postfixButtons;
			if ( postfixButtons ) {
				if ( ! conf.buttons ) {
					conf.buttons = [];
				}

				for ( i=0, ien=postfixButtons.length ; i<ien ; i++ ) {
					conf.buttons.push( postfixButtons[i] );
				}

				conf.postfixButtons = null;
			}

			var prefixButtons = conf.prefixButtons;
			if ( prefixButtons ) {
				if ( ! conf.buttons ) {
					conf.buttons = [];
				}

				for ( i=0, ien=prefixButtons.length ; i<ien ; i++ ) {
					conf.buttons.splice( i, 0, prefixButtons[i] );
				}

				conf.prefixButtons = null;
			}

			// Although we want the `conf` object to overwrite almost all of
			// the properties of the object being extended, the `extend`
			// property should come from the object being extended
			conf.extend = objArray.extend;
		}

		return conf;
	},

	/**
	 * Display (and replace if there is an existing one) a popover attached to a button
	 * @param {string|node} content Content to show
	 * @param {DataTable.Api} hostButton DT API instance of the button
	 * @param {object} inOpts Options (see object below for all options)
	 */
	_popover: function ( content, hostButton, inOpts ) {
		var dt = hostButton;
		var buttonsSettings = this.c;
		var options = $.extend( {
			align: 'button-left', // button-right, dt-container
			autoClose: false,
			background: true,
			backgroundClassName: 'dt-button-background',
			contentClassName: buttonsSettings.dom.collection.className,
			collectionLayout: '',
			collectionTitle: '',
			dropup: false,
			fade: 400,
			rightAlignClassName: 'dt-button-right',
			tag: buttonsSettings.dom.collection.tag
		}, inOpts );
		var hostNode = hostButton.node();

		var close = function () {
			_fadeOut(
				$('.dt-button-collection'),
				options.fade,
				function () {
					$(this).detach();
				}
			);

			$(dt.buttons( '[aria-haspopup="true"][aria-expanded="true"]' ).nodes())
				.attr('aria-expanded', 'false');

			$('div.dt-button-background').off( 'click.dtb-collection' );
			Buttons.background( false, options.backgroundClassName, options.fade, hostNode );

			$('body').off( '.dtb-collection' );
			dt.off( 'buttons-action.b-internal' );
		};

		if (content === false) {
			close();
		}

		var existingExpanded = $(dt.buttons( '[aria-haspopup="true"][aria-expanded="true"]' ).nodes());
		if ( existingExpanded.length ) {
			hostNode = existingExpanded.eq(0);

			close();
		}

		var display = $('<div/>')
			.addClass('dt-button-collection')
			.addClass(options.collectionLayout)
			.css('display', 'none');

		content = $(content)
			.addClass(options.contentClassName)
			.attr('role', 'menu')
			.appendTo(display);

		hostNode.attr( 'aria-expanded', 'true' );

		if ( hostNode.parents('body')[0] !== document.body ) {
			hostNode = document.body.lastChild;
		}

		if ( options.collectionTitle ) {
			display.prepend('<div class="dt-button-collection-title">'+options.collectionTitle+'</div>');
		}

		_fadeIn( display.insertAfter( hostNode ), options.fade );

		var tableContainer = $( hostButton.table().container() );
		var position = display.css( 'position' );

		if ( options.align === 'dt-container' ) {
			hostNode = hostNode.parent();
			display.css('width', tableContainer.width());
		}

		// Align the popover relative to the DataTables container
		// Useful for wide popovers such as SearchPanes
		if (position === 'absolute') {
			// Align relative to the host button
			var hostPosition = hostNode.position();
			var buttonPosition = $(hostButton.node()).position();

			display.css( {
				top: buttonPosition.top + hostNode.outerHeight(),
				left: hostPosition.left
			} );

			// calculate overflow when positioned beneath
			var collectionHeight = display.outerHeight();
			var tableBottom = tableContainer.offset().top + tableContainer.height();
			var listBottom = buttonPosition.top + hostNode.outerHeight() + collectionHeight;
			var bottomOverflow = listBottom - tableBottom;

			// calculate overflow when positioned above
			var listTop = buttonPosition.top - collectionHeight;
			var tableTop = tableContainer.offset().top;
			var topOverflow = tableTop - listTop;

			// if bottom overflow is larger, move to the top because it fits better, or if dropup is requested
			var moveTop = buttonPosition.top - collectionHeight - 5;
			if ( (bottomOverflow > topOverflow || options.dropup) && -moveTop < tableTop ) {
				display.css( 'top', moveTop);
			}

			// Get the size of the container (left and width - and thus also right)
			var tableLeft = tableContainer.offset().left;
			var tableWidth = tableContainer.width();
			var tableRight = tableLeft + tableWidth;

			// Get the size of the popover (left and width - and ...)
			var popoverLeft = display.offset().left;
			var popoverWidth = display.width();
			var popoverRight = popoverLeft + popoverWidth;

			// Get the size of the host buttons (left and width - and ...)
			var buttonsLeft = hostNode.offset().left;
			var buttonsWidth = hostNode.outerWidth()
			var buttonsRight = buttonsLeft + buttonsWidth;

			if (
				display.hasClass( options.rightAlignClassName ) ||
				display.hasClass( options.leftAlignClassName ) ||
				options.align === 'dt-container'
			){
				// You've then got all the numbers you need to do some calculations and if statements,
				//  so we can do some quick JS maths and apply it only once
				// If it has the right align class OR the buttons are right aligned OR the button container is floated right,
				//  then calculate left position for the popover to align the popover to the right hand
				//  side of the button - check to see if the left of the popover is inside the table container.
				// If not, move the popover so it is, but not more than it means that the popover is to the right of the table container
				var popoverShuffle = 0;
				if ( display.hasClass( options.rightAlignClassName )) {
					popoverShuffle = buttonsRight - popoverRight;
					if(tableLeft > (popoverLeft + popoverShuffle)){
						var leftGap = tableLeft - (popoverLeft + popoverShuffle);
						var rightGap = tableRight - (popoverRight + popoverShuffle);
		
						if(leftGap > rightGap){
							popoverShuffle += rightGap; 
						}
						else {
							popoverShuffle += leftGap;
						}
					}
				}
				// else attempt to left align the popover to the button. Similar to above, if the popover's right goes past the table container's right,
				//  then move it back, but not so much that it goes past the left of the table container
				else {
					popoverShuffle = tableLeft - popoverLeft;
	
					if(tableRight < (popoverRight + popoverShuffle)){
						var leftGap = tableLeft - (popoverLeft + popoverShuffle);
						var rightGap = tableRight - (popoverRight + popoverShuffle);
	
						if(leftGap > rightGap ){
							popoverShuffle += rightGap;
						}
						else {
							popoverShuffle += leftGap;
						}
	
					}
				}
	
				display.css('left', display.position().left + popoverShuffle);
			}
			else {
				var top = hostNode.offset().top
				var popoverShuffle = 0;

				popoverShuffle = options.align === 'button-right'
					? buttonsRight - popoverRight
					: buttonsLeft - popoverLeft;

				display.css('left', display.position().left + popoverShuffle);
			}
			
			
		}
		else {
			// Fix position - centre on screen
			var top = display.height() / 2;
			if ( top > $(window).height() / 2 ) {
				top = $(window).height() / 2;
			}

			display.css( 'marginTop', top*-1 );
		}

		if ( options.background ) {
			Buttons.background( true, options.backgroundClassName, options.fade, hostNode );
		}

		// This is bonkers, but if we don't have a click listener on the
		// background element, iOS Safari will ignore the body click
		// listener below. An empty function here is all that is
		// required to make it work...
		$('div.dt-button-background').on( 'click.dtb-collection', function () {} );

		$('body')
			.on( 'click.dtb-collection', function (e) {
				// andSelf is deprecated in jQ1.8, but we want 1.7 compat
				var back = $.fn.addBack ? 'addBack' : 'andSelf';
				var parent = $(e.target).parent()[0];

				if (( ! $(e.target).parents()[back]().filter( content ).length  && !$(parent).hasClass('dt-buttons')) || $(e.target).hasClass('dt-button-background')) {
					close();
				}
			} )
			.on( 'keyup.dtb-collection', function (e) {
				if ( e.keyCode === 27 ) {
					close();
				}
			} );

		if ( options.autoClose ) {
			setTimeout( function () {
				dt.on( 'buttons-action.b-internal', function (e, btn, dt, node) {
					if ( node[0] === hostNode[0] ) {
						return;
					}
					close();
				} );
			}, 0);
		}

		$(display).trigger('buttons-popover.dt');
	}
} );



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Statics
 */

/**
 * Show / hide a background layer behind a collection
 * @param  {boolean} Flag to indicate if the background should be shown or
 *   hidden 
 * @param  {string} Class to assign to the background
 * @static
 */
Buttons.background = function ( show, className, fade, insertPoint ) {
	if ( fade === undefined ) {
		fade = 400;
	}
	if ( ! insertPoint ) {
		insertPoint = document.body;
	}

	if ( show ) {
		_fadeIn(
			$('<div/>')
				.addClass( className )
				.css( 'display', 'none' )
				.insertAfter( insertPoint ),
			fade
		);
	}
	else {
		_fadeOut(
			$('div.'+className),
			fade,
			function () {
				$(this)
					.removeClass( className )
					.remove();
			}
		);
	}
};

/**
 * Instance selector - select Buttons instances based on an instance selector
 * value from the buttons assigned to a DataTable. This is only useful if
 * multiple instances are attached to a DataTable.
 * @param  {string|int|array} Instance selector - see `instance-selector`
 *   documentation on the DataTables site
 * @param  {array} Button instance array that was attached to the DataTables
 *   settings object
 * @return {array} Buttons instances
 * @static
 */
Buttons.instanceSelector = function ( group, buttons )
{
	if ( group === undefined || group === null ) {
		return $.map( buttons, function ( v ) {
			return v.inst;
		} );
	}

	var ret = [];
	var names = $.map( buttons, function ( v ) {
		return v.name;
	} );

	// Flatten the group selector into an array of single options
	var process = function ( input ) {
		if ( Array.isArray( input ) ) {
			for ( var i=0, ien=input.length ; i<ien ; i++ ) {
				process( input[i] );
			}
			return;
		}

		if ( typeof input === 'string' ) {
			if ( input.indexOf( ',' ) !== -1 ) {
				// String selector, list of names
				process( input.split(',') );
			}
			else {
				// String selector individual name
				var idx = $.inArray( input.trim(), names );

				if ( idx !== -1 ) {
					ret.push( buttons[ idx ].inst );
				}
			}
		}
		else if ( typeof input === 'number' ) {
			// Index selector
			ret.push( buttons[ input ].inst );
		}
	};
	
	process( group );

	return ret;
};

/**
 * Button selector - select one or more buttons from a selector input so some
 * operation can be performed on them.
 * @param  {array} Button instances array that the selector should operate on
 * @param  {string|int|node|jQuery|array} Button selector - see
 *   `button-selector` documentation on the DataTables site
 * @return {array} Array of objects containing `inst` and `idx` properties of
 *   the selected buttons so you know which instance each button belongs to.
 * @static
 */
Buttons.buttonSelector = function ( insts, selector )
{
	var ret = [];
	var nodeBuilder = function ( a, buttons, baseIdx ) {
		var button;
		var idx;

		for ( var i=0, ien=buttons.length ; i<ien ; i++ ) {
			button = buttons[i];

			if ( button ) {
				idx = baseIdx !== undefined ?
					baseIdx+i :
					i+'';

				a.push( {
					node: button.node,
					name: button.conf.name,
					idx:  idx
				} );

				if ( button.buttons ) {
					nodeBuilder( a, button.buttons, idx+'-' );
				}
			}
		}
	};

	var run = function ( selector, inst ) {
		var i, ien;
		var buttons = [];
		nodeBuilder( buttons, inst.s.buttons );

		var nodes = $.map( buttons, function (v) {
			return v.node;
		} );

		if ( Array.isArray( selector ) || selector instanceof $ ) {
			for ( i=0, ien=selector.length ; i<ien ; i++ ) {
				run( selector[i], inst );
			}
			return;
		}

		if ( selector === null || selector === undefined || selector === '*' ) {
			// Select all
			for ( i=0, ien=buttons.length ; i<ien ; i++ ) {
				ret.push( {
					inst: inst,
					node: buttons[i].node
				} );
			}
		}
		else if ( typeof selector === 'number' ) {
			// Main button index selector
			ret.push( {
				inst: inst,
				node: inst.s.buttons[ selector ].node
			} );
		}
		else if ( typeof selector === 'string' ) {
			if ( selector.indexOf( ',' ) !== -1 ) {
				// Split
				var a = selector.split(',');

				for ( i=0, ien=a.length ; i<ien ; i++ ) {
					run( a[i].trim(), inst );
				}
			}
			else if ( selector.match( /^\d+(\-\d+)*$/ ) ) {
				// Sub-button index selector
				var indexes = $.map( buttons, function (v) {
					return v.idx;
				} );

				ret.push( {
					inst: inst,
					node: buttons[ $.inArray( selector, indexes ) ].node
				} );
			}
			else if ( selector.indexOf( ':name' ) !== -1 ) {
				// Button name selector
				var name = selector.replace( ':name', '' );

				for ( i=0, ien=buttons.length ; i<ien ; i++ ) {
					if ( buttons[i].name === name ) {
						ret.push( {
							inst: inst,
							node: buttons[i].node
						} );
					}
				}
			}
			else {
				// jQuery selector on the nodes
				$( nodes ).filter( selector ).each( function () {
					ret.push( {
						inst: inst,
						node: this
					} );
				} );
			}
		}
		else if ( typeof selector === 'object' && selector.nodeName ) {
			// Node selector
			var idx = $.inArray( selector, nodes );

			if ( idx !== -1 ) {
				ret.push( {
					inst: inst,
					node: nodes[ idx ]
				} );
			}
		}
	};


	for ( var i=0, ien=insts.length ; i<ien ; i++ ) {
		var inst = insts[i];

		run( selector, inst );
	}

	return ret;
};

/**
 * Default function used for formatting output data.
 * @param {*} str Data to strip
 */
Buttons.stripData = function ( str, config ) {
	if ( typeof str !== 'string' ) {
		return str;
	}

	// Always remove script tags
	str = str.replace( /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '' );

	// Always remove comments
	str = str.replace( /<!\-\-.*?\-\->/g, '' );

	if ( ! config || config.stripHtml ) {
		str = str.replace( /<[^>]*>/g, '' );
	}

	if ( ! config || config.trim ) {
		str = str.replace( /^\s+|\s+$/g, '' );
	}

	if ( ! config || config.stripNewlines ) {
		str = str.replace( /\n/g, ' ' );
	}

	if ( ! config || config.decodeEntities ) {
		_exportTextarea.innerHTML = str;
		str = _exportTextarea.value;
	}

	return str;
};


/**
 * Buttons defaults. For full documentation, please refer to the docs/option
 * directory or the DataTables site.
 * @type {Object}
 * @static
 */
Buttons.defaults = {
	buttons: [ 'copy', 'excel', 'csv', 'pdf', 'print' ],
	name: 'main',
	tabIndex: 0,
	dom: {
		container: {
			tag: 'div',
			className: 'dt-buttons'
		},
		collection: {
			tag: 'div',
			className: ''
		},
		button: {
			tag: 'button',
			className: 'dt-button',
			active: 'active',
			disabled: 'disabled'
		},
		buttonLiner: {
			tag: 'span',
			className: ''
		}
	}
};

/**
 * Version information
 * @type {string}
 * @static
 */
Buttons.version = '1.7.1';


$.extend( _dtButtons, {
	collection: {
		text: function ( dt ) {
			return dt.i18n( 'buttons.collection', 'Collection' );
		},
		className: 'buttons-collection',
		init: function ( dt, button, config ) {
			button.attr( 'aria-expanded', false );
		},
		action: function ( e, dt, button, config ) {
			e.stopPropagation();

			if ( config._collection.parents('body').length ) {
				this.popover(false, config);
			}
			else {
				this.popover(config._collection, config);
			}
		},
		attr: {
			'aria-haspopup': true
		}
		// Also the popover options, defined in Buttons.popover
	},
	copy: function ( dt, conf ) {
		if ( _dtButtons.copyHtml5 ) {
			return 'copyHtml5';
		}
	},
	csv: function ( dt, conf ) {
		if ( _dtButtons.csvHtml5 && _dtButtons.csvHtml5.available( dt, conf ) ) {
			return 'csvHtml5';
		}
	},
	excel: function ( dt, conf ) {
		if ( _dtButtons.excelHtml5 && _dtButtons.excelHtml5.available( dt, conf ) ) {
			return 'excelHtml5';
		}
	},
	pdf: function ( dt, conf ) {
		if ( _dtButtons.pdfHtml5 && _dtButtons.pdfHtml5.available( dt, conf ) ) {
			return 'pdfHtml5';
		}
	},
	pageLength: function ( dt ) {
		var lengthMenu = dt.settings()[0].aLengthMenu;
		var vals = [];
		var lang = [];
		var text = function ( dt ) {
			return dt.i18n( 'buttons.pageLength', {
				"-1": 'Show all rows',
				_:    'Show %d rows'
			}, dt.page.len() );
		};

		// Support for DataTables 1.x 2D array
		if (Array.isArray( lengthMenu[0] )) {
			vals = lengthMenu[0];
			lang = lengthMenu[1];
		}
		else {
			for (var i=0 ; i<lengthMenu.length ; i++) {
				var option = lengthMenu[i];

				// Support for DataTables 2 object in the array
				if ($.isPlainObject(option)) {
					vals.push(option.value);
					lang.push(option.label);
				}
				else {
					vals.push(option);
					lang.push(option);
				}
			}
		}

		return {
			extend: 'collection',
			text: text,
			className: 'buttons-page-length',
			autoClose: true,
			buttons: $.map( vals, function ( val, i ) {
				return {
					text: lang[i],
					className: 'button-page-length',
					action: function ( e, dt ) {
						dt.page.len( val ).draw();
					},
					init: function ( dt, node, conf ) {
						var that = this;
						var fn = function () {
							that.active( dt.page.len() === val );
						};

						dt.on( 'length.dt'+conf.namespace, fn );
						fn();
					},
					destroy: function ( dt, node, conf ) {
						dt.off( 'length.dt'+conf.namespace );
					}
				};
			} ),
			init: function ( dt, node, conf ) {
				var that = this;
				dt.on( 'length.dt'+conf.namespace, function () {
					that.text( conf.text );
				} );
			},
			destroy: function ( dt, node, conf ) {
				dt.off( 'length.dt'+conf.namespace );
			}
		};
	}
} );


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * DataTables API
 *
 * For complete documentation, please refer to the docs/api directory or the
 * DataTables site
 */

// Buttons group and individual button selector
DataTable.Api.register( 'buttons()', function ( group, selector ) {
	// Argument shifting
	if ( selector === undefined ) {
		selector = group;
		group = undefined;
	}

	this.selector.buttonGroup = group;

	var res = this.iterator( true, 'table', function ( ctx ) {
		if ( ctx._buttons ) {
			return Buttons.buttonSelector(
				Buttons.instanceSelector( group, ctx._buttons ),
				selector
			);
		}
	}, true );

	res._groupSelector = group;
	return res;
} );

// Individual button selector
DataTable.Api.register( 'button()', function ( group, selector ) {
	// just run buttons() and truncate
	var buttons = this.buttons( group, selector );

	if ( buttons.length > 1 ) {
		buttons.splice( 1, buttons.length );
	}

	return buttons;
} );

// Active buttons
DataTable.Api.registerPlural( 'buttons().active()', 'button().active()', function ( flag ) {
	if ( flag === undefined ) {
		return this.map( function ( set ) {
			return set.inst.active( set.node );
		} );
	}

	return this.each( function ( set ) {
		set.inst.active( set.node, flag );
	} );
} );

// Get / set button action
DataTable.Api.registerPlural( 'buttons().action()', 'button().action()', function ( action ) {
	if ( action === undefined ) {
		return this.map( function ( set ) {
			return set.inst.action( set.node );
		} );
	}

	return this.each( function ( set ) {
		set.inst.action( set.node, action );
	} );
} );

// Enable / disable buttons
DataTable.Api.register( ['buttons().enable()', 'button().enable()'], function ( flag ) {
	return this.each( function ( set ) {
		set.inst.enable( set.node, flag );
	} );
} );

// Disable buttons
DataTable.Api.register( ['buttons().disable()', 'button().disable()'], function () {
	return this.each( function ( set ) {
		set.inst.disable( set.node );
	} );
} );

// Get button nodes
DataTable.Api.registerPlural( 'buttons().nodes()', 'button().node()', function () {
	var jq = $();

	// jQuery will automatically reduce duplicates to a single entry
	$( this.each( function ( set ) {
		jq = jq.add( set.inst.node( set.node ) );
	} ) );

	return jq;
} );

// Get / set button processing state
DataTable.Api.registerPlural( 'buttons().processing()', 'button().processing()', function ( flag ) {
	if ( flag === undefined ) {
		return this.map( function ( set ) {
			return set.inst.processing( set.node );
		} );
	}

	return this.each( function ( set ) {
		set.inst.processing( set.node, flag );
	} );
} );

// Get / set button text (i.e. the button labels)
DataTable.Api.registerPlural( 'buttons().text()', 'button().text()', function ( label ) {
	if ( label === undefined ) {
		return this.map( function ( set ) {
			return set.inst.text( set.node );
		} );
	}

	return this.each( function ( set ) {
		set.inst.text( set.node, label );
	} );
} );

// Trigger a button's action
DataTable.Api.registerPlural( 'buttons().trigger()', 'button().trigger()', function () {
	return this.each( function ( set ) {
		set.inst.node( set.node ).trigger( 'click' );
	} );
} );

// Button resolver to the popover
DataTable.Api.register( 'button().popover()', function (content, options) {
	return this.map( function ( set ) {
		return set.inst._popover( content, this.button(this[0].node), options );
	} );
} );

// Get the container elements
DataTable.Api.register( 'buttons().containers()', function () {
	var jq = $();
	var groupSelector = this._groupSelector;

	// We need to use the group selector directly, since if there are no buttons
	// the result set will be empty
	this.iterator( true, 'table', function ( ctx ) {
		if ( ctx._buttons ) {
			var insts = Buttons.instanceSelector( groupSelector, ctx._buttons );

			for ( var i=0, ien=insts.length ; i<ien ; i++ ) {
				jq = jq.add( insts[i].container() );
			}
		}
	} );

	return jq;
} );

DataTable.Api.register( 'buttons().container()', function () {
	// API level of nesting is `buttons()` so we can zip into the containers method
	return this.containers().eq(0);
} );

// Add a new button
DataTable.Api.register( 'button().add()', function ( idx, conf ) {
	var ctx = this.context;

	// Don't use `this` as it could be empty - select the instances directly
	if ( ctx.length ) {
		var inst = Buttons.instanceSelector( this._groupSelector, ctx[0]._buttons );

		if ( inst.length ) {
			inst[0].add( conf, idx );
		}
	}

	return this.button( this._groupSelector, idx );
} );

// Destroy the button sets selected
DataTable.Api.register( 'buttons().destroy()', function () {
	this.pluck( 'inst' ).unique().each( function ( inst ) {
		inst.destroy();
	} );

	return this;
} );

// Remove a button
DataTable.Api.registerPlural( 'buttons().remove()', 'buttons().remove()', function () {
	this.each( function ( set ) {
		set.inst.remove( set.node );
	} );

	return this;
} );

// Information box that can be used by buttons
var _infoTimer;
DataTable.Api.register( 'buttons.info()', function ( title, message, time ) {
	var that = this;

	if ( title === false ) {
		this.off('destroy.btn-info');
		_fadeOut(
			$('#datatables_buttons_info'),
			400,
			function () {
				$(this).remove();
			}
		);
		clearTimeout( _infoTimer );
		_infoTimer = null;

		return this;
	}

	if ( _infoTimer ) {
		clearTimeout( _infoTimer );
	}

	if ( $('#datatables_buttons_info').length ) {
		$('#datatables_buttons_info').remove();
	}

	title = title ? '<h2>'+title+'</h2>' : '';

	_fadeIn(
		$('<div id="datatables_buttons_info" class="dt-button-info"/>')
			.html( title )
			.append( $('<div/>')[ typeof message === 'string' ? 'html' : 'append' ]( message ) )
			.css( 'display', 'none' )
			.appendTo( 'body' )
	);

	if ( time !== undefined && time !== 0 ) {
		_infoTimer = setTimeout( function () {
			that.buttons.info( false );
		}, time );
	}

	this.on('destroy.btn-info', function () {
		that.buttons.info(false);
	});

	return this;
} );

// Get data from the table for export - this is common to a number of plug-in
// buttons so it is included in the Buttons core library
DataTable.Api.register( 'buttons.exportData()', function ( options ) {
	if ( this.context.length ) {
		return _exportData( new DataTable.Api( this.context[0] ), options );
	}
} );

// Get information about the export that is common to many of the export data
// types (DRY)
DataTable.Api.register( 'buttons.exportInfo()', function ( conf ) {
	if ( ! conf ) {
		conf = {};
	}

	return {
		filename: _filename( conf ),
		title: _title( conf ),
		messageTop: _message(this, conf.message || conf.messageTop, 'top'),
		messageBottom: _message(this, conf.messageBottom, 'bottom')
	};
} );



/**
 * Get the file name for an exported file.
 *
 * @param {object}	config Button configuration
 * @param {boolean} incExtension Include the file name extension
 */
var _filename = function ( config )
{
	// Backwards compatibility
	var filename = config.filename === '*' && config.title !== '*' && config.title !== undefined && config.title !== null && config.title !== '' ?
		config.title :
		config.filename;

	if ( typeof filename === 'function' ) {
		filename = filename();
	}

	if ( filename === undefined || filename === null ) {
		return null;
	}

	if ( filename.indexOf( '*' ) !== -1 ) {
		filename = filename.replace( '*', $('head > title').text() ).trim();
	}

	// Strip characters which the OS will object to
	filename = filename.replace(/[^a-zA-Z0-9_\u00A1-\uFFFF\.,\-_ !\(\)]/g, "");

	var extension = _stringOrFunction( config.extension );
	if ( ! extension ) {
		extension = '';
	}

	return filename + extension;
};

/**
 * Simply utility method to allow parameters to be given as a function
 *
 * @param {undefined|string|function} option Option
 * @return {null|string} Resolved value
 */
var _stringOrFunction = function ( option )
{
	if ( option === null || option === undefined ) {
		return null;
	}
	else if ( typeof option === 'function' ) {
		return option();
	}
	return option;
};

/**
 * Get the title for an exported file.
 *
 * @param {object} config	Button configuration
 */
var _title = function ( config )
{
	var title = _stringOrFunction( config.title );

	return title === null ?
		null : title.indexOf( '*' ) !== -1 ?
			title.replace( '*', $('head > title').text() || 'Exported data' ) :
			title;
};

var _message = function ( dt, option, position )
{
	var message = _stringOrFunction( option );
	if ( message === null ) {
		return null;
	}

	var caption = $('caption', dt.table().container()).eq(0);
	if ( message === '*' ) {
		var side = caption.css( 'caption-side' );
		if ( side !== position ) {
			return null;
		}

		return caption.length ?
			caption.text() :
			'';
	}

	return message;
};




var _exportTextarea = $('<textarea/>')[0];
var _exportData = function ( dt, inOpts )
{
	var config = $.extend( true, {}, {
		rows:           null,
		columns:        '',
		modifier:       {
			search: 'applied',
			order:  'applied'
		},
		orthogonal:     'display',
		stripHtml:      true,
		stripNewlines:  true,
		decodeEntities: true,
		trim:           true,
		format:         {
			header: function ( d ) {
				return Buttons.stripData( d, config );
			},
			footer: function ( d ) {
				return Buttons.stripData( d, config );
			},
			body: function ( d ) {
				return Buttons.stripData( d, config );
			}
		},
		customizeData: null
	}, inOpts );

	var header = dt.columns( config.columns ).indexes().map( function (idx) {
		var el = dt.column( idx ).header();
		return config.format.header( el.innerHTML, idx, el );
	} ).toArray();

	var footer = dt.table().footer() ?
		dt.columns( config.columns ).indexes().map( function (idx) {
			var el = dt.column( idx ).footer();
			return config.format.footer( el ? el.innerHTML : '', idx, el );
		} ).toArray() :
		null;
	
	// If Select is available on this table, and any rows are selected, limit the export
	// to the selected rows. If no rows are selected, all rows will be exported. Specify
	// a `selected` modifier to control directly.
	var modifier = $.extend( {}, config.modifier );
	if ( dt.select && typeof dt.select.info === 'function' && modifier.selected === undefined ) {
		if ( dt.rows( config.rows, $.extend( { selected: true }, modifier ) ).any() ) {
			$.extend( modifier, { selected: true } )
		}
	}

	var rowIndexes = dt.rows( config.rows, modifier ).indexes().toArray();
	var selectedCells = dt.cells( rowIndexes, config.columns );
	var cells = selectedCells
		.render( config.orthogonal )
		.toArray();
	var cellNodes = selectedCells
		.nodes()
		.toArray();

	var columns = header.length;
	var rows = columns > 0 ? cells.length / columns : 0;
	var body = [];
	var cellCounter = 0;

	for ( var i=0, ien=rows ; i<ien ; i++ ) {
		var row = [ columns ];

		for ( var j=0 ; j<columns ; j++ ) {
			row[j] = config.format.body( cells[ cellCounter ], i, j, cellNodes[ cellCounter ] );
			cellCounter++;
		}

		body[i] = row;
	}

	var data = {
		header: header,
		footer: footer,
		body:   body
	};

	if ( config.customizeData ) {
		config.customizeData( data );
	}

	return data;
};


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * DataTables interface
 */

// Attach to DataTables objects for global access
$.fn.dataTable.Buttons = Buttons;
$.fn.DataTable.Buttons = Buttons;



// DataTables creation - check if the buttons have been defined for this table,
// they will have been if the `B` option was used in `dom`, otherwise we should
// create the buttons instance here so they can be inserted into the document
// using the API. Listen for `init` for compatibility with pre 1.10.10, but to
// be removed in future.
$(document).on( 'init.dt plugin-init.dt', function (e, settings) {
	if ( e.namespace !== 'dt' ) {
		return;
	}

	var opts = settings.oInit.buttons || DataTable.defaults.buttons;

	if ( opts && ! settings._buttons ) {
		new Buttons( settings, opts ).container();
	}
} );

function _init ( settings, options ) {
	var api = new DataTable.Api( settings );
	var opts = options
		? options
		: api.init().buttons || DataTable.defaults.buttons;

	return new Buttons( api, opts ).container();
}

// DataTables `dom` feature option
DataTable.ext.feature.push( {
	fnInit: _init,
	cFeature: "B"
} );

// DataTables 2 layout feature
if ( DataTable.ext.features ) {
	DataTable.ext.features.register( 'buttons', _init );
}


return Buttons;
}));

/*!
 * Column visibility buttons for Buttons and DataTables.
 * 2016 SpryMedia Ltd - datatables.net/license
 */

(function( factory ){
	if ( typeof define === 'function' && define.amd ) {
		// AMD
		define( ['jquery', 'datatables.net', 'datatables.net-buttons'], function ( $ ) {
			return factory( $, window, document );
		} );
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net')(root, $).$;
			}

			if ( ! $.fn.dataTable.Buttons ) {
				require('datatables.net-buttons')(root, $);
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;


$.extend( DataTable.ext.buttons, {
	// A collection of column visibility buttons
	colvis: function ( dt, conf ) {
		return {
			extend: 'collection',
			text: function ( dt ) {
				return dt.i18n( 'buttons.colvis', 'Column visibility' );
			},
			className: 'buttons-colvis',
			buttons: [ {
				extend: 'columnsToggle',
				columns: conf.columns,
				columnText: conf.columnText
			} ]
		};
	},

	// Selected columns with individual buttons - toggle column visibility
	columnsToggle: function ( dt, conf ) {
		var columns = dt.columns( conf.columns ).indexes().map( function ( idx ) {
			return {
				extend: 'columnToggle',
				columns: idx,
				columnText: conf.columnText
			};
		} ).toArray();

		return columns;
	},

	// Single button to toggle column visibility
	columnToggle: function ( dt, conf ) {
		return {
			extend: 'columnVisibility',
			columns: conf.columns,
			columnText: conf.columnText
		};
	},

	// Selected columns with individual buttons - set column visibility
	columnsVisibility: function ( dt, conf ) {
		var columns = dt.columns( conf.columns ).indexes().map( function ( idx ) {
			return {
				extend: 'columnVisibility',
				columns: idx,
				visibility: conf.visibility,
				columnText: conf.columnText
			};
		} ).toArray();

		return columns;
	},

	// Single button to set column visibility
	columnVisibility: {
		columns: undefined, // column selector
		text: function ( dt, button, conf ) {
			return conf._columnText( dt, conf );
		},
		className: 'buttons-columnVisibility',
		action: function ( e, dt, button, conf ) {
			var col = dt.columns( conf.columns );
			var curr = col.visible();

			col.visible( conf.visibility !== undefined ?
				conf.visibility :
				! (curr.length ? curr[0] : false )
			);
		},
		init: function ( dt, button, conf ) {
			var that = this;
			button.attr( 'data-cv-idx', conf.columns );

			dt
				.on( 'column-visibility.dt'+conf.namespace, function (e, settings) {
					if ( ! settings.bDestroying && settings.nTable == dt.settings()[0].nTable ) {
						that.active( dt.column( conf.columns ).visible() );
					}
				} )
				.on( 'column-reorder.dt'+conf.namespace, function (e, settings, details) {
					if ( dt.columns( conf.columns ).count() !== 1 ) {
						return;
					}

					// This button controls the same column index but the text for the column has
					// changed
					that.text( conf._columnText( dt, conf ) );

					// Since its a different column, we need to check its visibility
					that.active( dt.column( conf.columns ).visible() );
				} );

			this.active( dt.column( conf.columns ).visible() );
		},
		destroy: function ( dt, button, conf ) {
			dt
				.off( 'column-visibility.dt'+conf.namespace )
				.off( 'column-reorder.dt'+conf.namespace );
		},

		_columnText: function ( dt, conf ) {
			// Use DataTables' internal data structure until this is presented
			// is a public API. The other option is to use
			// `$( column(col).node() ).text()` but the node might not have been
			// populated when Buttons is constructed.
			var idx = dt.column( conf.columns ).index();
			var title = dt.settings()[0].aoColumns[ idx ].sTitle;

			if (! title) {
				title = dt.column(idx).header().innerHTML;
			}

			title = title
				.replace(/\n/g," ")        // remove new lines
				.replace(/<br\s*\/?>/gi, " ")  // replace line breaks with spaces
				.replace(/<select(.*?)<\/select>/g, "") // remove select tags, including options text
				.replace(/<!\-\-.*?\-\->/g, "") // strip HTML comments
				.replace(/<.*?>/g, "")   // strip HTML
				.replace(/^\s+|\s+$/g,""); // trim

			return conf.columnText ?
				conf.columnText( dt, idx, title ) :
				title;
		}
	},


	colvisRestore: {
		className: 'buttons-colvisRestore',

		text: function ( dt ) {
			return dt.i18n( 'buttons.colvisRestore', 'Restore visibility' );
		},

		init: function ( dt, button, conf ) {
			conf._visOriginal = dt.columns().indexes().map( function ( idx ) {
				return dt.column( idx ).visible();
			} ).toArray();
		},

		action: function ( e, dt, button, conf ) {
			dt.columns().every( function ( i ) {
				// Take into account that ColReorder might have disrupted our
				// indexes
				var idx = dt.colReorder && dt.colReorder.transpose ?
					dt.colReorder.transpose( i, 'toOriginal' ) :
					i;

				this.visible( conf._visOriginal[ idx ] );
			} );
		}
	},


	colvisGroup: {
		className: 'buttons-colvisGroup',

		action: function ( e, dt, button, conf ) {
			dt.columns( conf.show ).visible( true, false );
			dt.columns( conf.hide ).visible( false, false );

			dt.columns.adjust();
		},

		show: [],

		hide: []
	}
} );


return DataTable.Buttons;
}));

/*! Bootstrap 4 integration for DataTables' FixedColumns
 * © SpryMedia Ltd - datatables.net/license
 */

(function( factory ){
	if ( typeof define === 'function' && define.amd ) {
		// AMD
		define( ['jquery', 'datatables.net-bs4', 'datatables.net-fixedcolumns'], function ( $ ) {
			return factory( $, window, document );
		} );
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		var jq = require('jquery');
		var cjsRequires = function (root, $) {
			if ( ! $.fn.dataTable ) {
				require('datatables.net-bs4')(root, $);
			}

			if ( ! $.fn.dataTable.FixedColumns ) {
				require('datatables.net-fixedcolumns')(root, $);
			}
		};

		if (typeof window === 'undefined') {
			module.exports = function (root, $) {
				if ( ! root ) {
					// CommonJS environments without a window global must pass a
					// root. This will give an error otherwise
					root = window;
				}

				if ( ! $ ) {
					$ = jq( root );
				}

				cjsRequires( root, $ );
				return factory( $, root, root.document );
			};
		}
		else {
			cjsRequires( window, jq );
			module.exports = factory( jq, window, window.document );
		}
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;




return DataTable;
}));

/*! FixedColumns 4.3.0
 * © SpryMedia Ltd - datatables.net/license
 */

(function( factory ){
	if ( typeof define === 'function' && define.amd ) {
		// AMD
		define( ['jquery', 'datatables.net'], function ( $ ) {
			return factory( $, window, document );
		} );
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		var jq = require('jquery');
		var cjsRequires = function (root, $) {
			if ( ! $.fn.dataTable ) {
				require('datatables.net')(root, $);
			}
		};

		if (typeof window === 'undefined') {
			module.exports = function (root, $) {
				if ( ! root ) {
					// CommonJS environments without a window global must pass a
					// root. This will give an error otherwise
					root = window;
				}

				if ( ! $ ) {
					$ = jq( root );
				}

				cjsRequires( root, $ );
				return factory( $, root, root.document );
			};
		}
		else {
			cjsRequires( window, jq );
			module.exports = factory( jq, window, window.document );
		}
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;


(function () {
    'use strict';

    var $$1;
    var dataTable;
    function setJQuery(jq) {
        $$1 = jq;
        dataTable = $$1.fn.dataTable;
    }
    var FixedColumns = /** @class */ (function () {
        function FixedColumns(settings, opts) {
            var _this = this;
            // Check that the required version of DataTables is included
            if (!dataTable || !dataTable.versionCheck || !dataTable.versionCheck('1.10.0')) {
                throw new Error('FixedColumns requires DataTables 1.10 or newer');
            }
            var table = new dataTable.Api(settings);
            this.classes = $$1.extend(true, {}, FixedColumns.classes);
            // Get options from user
            this.c = $$1.extend(true, {}, FixedColumns.defaults, opts);
            // Backwards compatibility for deprecated leftColumns
            if ((!opts || opts.left === undefined) && this.c.leftColumns !== undefined) {
                this.c.left = this.c.leftColumns;
            }
            // Backwards compatibility for deprecated rightColumns
            if ((!opts || opts.right === undefined) && this.c.rightColumns !== undefined) {
                this.c.right = this.c.rightColumns;
            }
            this.s = {
                barWidth: 0,
                dt: table,
                rtl: $$1('body').css('direction') === 'rtl'
            };
            // Common CSS for all blockers
            var blockerCSS = {
                'bottom': '0px',
                'display': 'block',
                'position': 'absolute',
                'width': this.s.barWidth + 1 + 'px'
            };
            this.dom = {
                leftBottomBlocker: $$1('<div>')
                    .css(blockerCSS)
                    .css('left', 0)
                    .addClass(this.classes.leftBottomBlocker),
                leftTopBlocker: $$1('<div>')
                    .css(blockerCSS)
                    .css({
                    left: 0,
                    top: 0
                })
                    .addClass(this.classes.leftTopBlocker),
                rightBottomBlocker: $$1('<div>')
                    .css(blockerCSS)
                    .css('right', 0)
                    .addClass(this.classes.rightBottomBlocker),
                rightTopBlocker: $$1('<div>')
                    .css(blockerCSS)
                    .css({
                    right: 0,
                    top: 0
                })
                    .addClass(this.classes.rightTopBlocker)
            };
            if (this.s.dt.settings()[0]._bInitComplete) {
                // Fixed Columns Initialisation
                this._addStyles();
                this._setKeyTableListener();
            }
            else {
                table.one('init.dt.dtfc', function () {
                    // Fixed Columns Initialisation
                    _this._addStyles();
                    _this._setKeyTableListener();
                });
            }
            table.on('column-sizing.dt.dtfc', function () { return _this._addStyles(); });
            // Make class available through dt object
            table.settings()[0]._fixedColumns = this;
            table.on('destroy', function () { return _this._destroy(); });
            return this;
        }
        FixedColumns.prototype.left = function (newVal) {
            // If the value is to change
            if (newVal !== undefined) {
                if (newVal >= 0 && newVal <= this.s.dt.columns().count()) {
                    // Set the new values and redraw the columns
                    this.c.left = newVal;
                    this._addStyles();
                }
                return this;
            }
            return this.c.left;
        };
        FixedColumns.prototype.right = function (newVal) {
            // If the value is to change
            if (newVal !== undefined) {
                if (newVal >= 0 && newVal <= this.s.dt.columns().count()) {
                    // Set the new values and redraw the columns
                    this.c.right = newVal;
                    this._addStyles();
                }
                return this;
            }
            return this.c.right;
        };
        /**
         * Iterates over the columns, fixing the appropriate ones to the left and right
         */
        FixedColumns.prototype._addStyles = function () {
            // Set the bar width if vertical scrolling is enabled
            if (this.s.dt.settings()[0].oScroll.sY) {
                var scroll_1 = $$1(this.s.dt.table().node()).closest('div.dataTables_scrollBody')[0];
                var barWidth = this.s.dt.settings()[0].oBrowser.barWidth;
                if (scroll_1.offsetWidth - scroll_1.clientWidth >= barWidth) {
                    this.s.barWidth = barWidth;
                }
                else {
                    this.s.barWidth = 0;
                }
                this.dom.rightTopBlocker.css('width', this.s.barWidth + 1);
                this.dom.leftTopBlocker.css('width', this.s.barWidth + 1);
                this.dom.rightBottomBlocker.css('width', this.s.barWidth + 1);
                this.dom.leftBottomBlocker.css('width', this.s.barWidth + 1);
            }
            var parentDiv = null;
            // Get the header and it's height
            var header = this.s.dt.column(0).header();
            var headerHeight = null;
            if (header !== null) {
                header = $$1(header);
                headerHeight = header.outerHeight() + 1;
                parentDiv = $$1(header.closest('div.dataTables_scroll')).css('position', 'relative');
            }
            // Get the footer and it's height
            var footer = this.s.dt.column(0).footer();
            var footerHeight = null;
            if (footer !== null) {
                footer = $$1(footer);
                footerHeight = footer.outerHeight();
                // Only attempt to retrieve the parentDiv if it has not been retrieved already
                if (parentDiv === null) {
                    parentDiv = $$1(footer.closest('div.dataTables_scroll')).css('position', 'relative');
                }
            }
            // Get the number of columns in the table - this is used often so better to only make 1 api call
            var numCols = this.s.dt.columns().data().toArray().length;
            // Tracker for the number of pixels should be left to the left of the table
            var distLeft = 0;
            // Sometimes the headers have slightly different widths so need to track them individually
            var headLeft = 0;
            // Get all of the row elements in the table
            var rows = $$1(this.s.dt.table().node()).children('tbody').children('tr');
            var invisibles = 0;
            // When working from right to left we need to know how many are invisible before a point,
            // without including those that are invisible after
            var prevInvisible = new Map();
            // Iterate over all of the columns
            for (var i = 0; i < numCols; i++) {
                var column = this.s.dt.column(i);
                // Set the map for the previous column
                if (i > 0) {
                    prevInvisible.set(i - 1, invisibles);
                }
                if (!column.visible()) {
                    invisibles++;
                    continue;
                }
                // Get the columns header and footer element
                var colHeader = $$1(column.header());
                var colFooter = $$1(column.footer());
                // If i is less than the value of left then this column should be fixed left
                if (i - invisibles < this.c.left) {
                    $$1(this.s.dt.table().node()).addClass(this.classes.tableFixedLeft);
                    parentDiv.addClass(this.classes.tableFixedLeft);
                    // Add the width of the previous node - only if we are on atleast the second column
                    if (i - invisibles > 0) {
                        var prevIdx = i;
                        // Simply using the number of hidden columns doesn't work here,
                        // if the first is hidden then this would be thrown off
                        while (prevIdx + 1 < numCols) {
                            var prevCol = this.s.dt.column(prevIdx - 1, { page: 'current' });
                            if (prevCol.visible()) {
                                distLeft += $$1(prevCol.nodes()[0]).outerWidth();
                                headLeft += prevCol.header() ?
                                    $$1(prevCol.header()).outerWidth() :
                                    prevCol.footer() ?
                                        $$1(prevCol.header()).outerWidth() :
                                        0;
                                break;
                            }
                            prevIdx--;
                        }
                    }
                    // Iterate over all of the rows, fixing the cell to the left
                    for (var _i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
                        var row = rows_1[_i];
                        $$1($$1(row).children()[i - invisibles])
                            .css(this._getCellCSS(false, distLeft, 'left'))
                            .addClass(this.classes.fixedLeft);
                    }
                    // Add the css for the header and the footer
                    colHeader
                        .css(this._getCellCSS(true, headLeft, 'left'))
                        .addClass(this.classes.fixedLeft);
                    colFooter
                        .css(this._getCellCSS(true, headLeft, 'left'))
                        .addClass(this.classes.fixedLeft);
                }
                else {
                    // Iteriate through all of the rows, making sure they aren't currently trying to fix left
                    for (var _a = 0, rows_2 = rows; _a < rows_2.length; _a++) {
                        var row = rows_2[_a];
                        var cell = $$1($$1(row).children()[i - invisibles]);
                        // If the cell is trying to fix to the left, remove the class and the css
                        if (cell.hasClass(this.classes.fixedLeft)) {
                            cell
                                .css(this._clearCellCSS('left'))
                                .removeClass(this.classes.fixedLeft);
                        }
                    }
                    // Make sure the header for this column isn't fixed left
                    if (colHeader.hasClass(this.classes.fixedLeft)) {
                        colHeader
                            .css(this._clearCellCSS('left'))
                            .removeClass(this.classes.fixedLeft);
                    }
                    // Make sure the footer for this column isn't fixed left
                    if (colFooter.hasClass(this.classes.fixedLeft)) {
                        colFooter
                            .css(this._clearCellCSS('left'))
                            .removeClass(this.classes.fixedLeft);
                    }
                }
            }
            var distRight = 0;
            var headRight = 0;
            // Counter for the number of invisible columns so far
            var rightInvisibles = 0;
            for (var i = numCols - 1; i >= 0; i--) {
                var column = this.s.dt.column(i);
                // If a column is invisible just skip it
                if (!column.visible()) {
                    rightInvisibles++;
                    continue;
                }
                // Get the columns header and footer element
                var colHeader = $$1(column.header());
                var colFooter = $$1(column.footer());
                // Get the number of visible columns that came before this one
                var prev = prevInvisible.get(i);
                if (prev === undefined) {
                    // If it wasn't set then it was the last column so just use the final value
                    prev = invisibles;
                }
                if (i + rightInvisibles >= numCols - this.c.right) {
                    $$1(this.s.dt.table().node()).addClass(this.classes.tableFixedRight);
                    parentDiv.addClass(this.classes.tableFixedRight);
                    // Add the widht of the previous node, only if we are on atleast the second column
                    if (i + 1 + rightInvisibles < numCols) {
                        var prevIdx = i;
                        // Simply using the number of hidden columns doesn't work here,
                        // if the first is hidden then this would be thrown off
                        while (prevIdx + 1 < numCols) {
                            var prevCol = this.s.dt.column(prevIdx + 1, { page: 'current' });
                            if (prevCol.visible()) {
                                distRight += $$1(prevCol.nodes()[0]).outerWidth();
                                headRight += prevCol.header() ?
                                    $$1(prevCol.header()).outerWidth() :
                                    prevCol.footer() ?
                                        $$1(prevCol.header()).outerWidth() :
                                        0;
                                break;
                            }
                            prevIdx++;
                        }
                    }
                    // Iterate over all of the rows, fixing the cell to the right
                    for (var _b = 0, rows_3 = rows; _b < rows_3.length; _b++) {
                        var row = rows_3[_b];
                        $$1($$1(row).children()[i - prev])
                            .css(this._getCellCSS(false, distRight, 'right'))
                            .addClass(this.classes.fixedRight);
                    }
                    // Add the css for the header and the footer
                    colHeader
                        .css(this._getCellCSS(true, headRight, 'right'))
                        .addClass(this.classes.fixedRight);
                    colFooter
                        .css(this._getCellCSS(true, headRight, 'right'))
                        .addClass(this.classes.fixedRight);
                }
                else {
                    // Iteriate through all of the rows, making sure they aren't currently trying to fix right
                    for (var _c = 0, rows_4 = rows; _c < rows_4.length; _c++) {
                        var row = rows_4[_c];
                        var cell = $$1($$1(row).children()[i - prev]);
                        // If the cell is trying to fix to the right, remove the class and the css
                        if (cell.hasClass(this.classes.fixedRight)) {
                            cell
                                .css(this._clearCellCSS('right'))
                                .removeClass(this.classes.fixedRight);
                        }
                    }
                    // Make sure the header for this column isn't fixed right
                    if (colHeader.hasClass(this.classes.fixedRight)) {
                        colHeader
                            .css(this._clearCellCSS('right'))
                            .removeClass(this.classes.fixedRight);
                    }
                    // Make sure the footer for this column isn't fixed right
                    if (colFooter.hasClass(this.classes.fixedRight)) {
                        colFooter
                            .css(this._clearCellCSS('right'))
                            .removeClass(this.classes.fixedRight);
                    }
                }
            }
            // If there is a header with the index class and reading rtl then add right top blocker
            if (header) {
                if (!this.s.rtl) {
                    this.dom.rightTopBlocker.outerHeight(headerHeight);
                    parentDiv.append(this.dom.rightTopBlocker);
                }
                else {
                    this.dom.leftTopBlocker.outerHeight(headerHeight);
                    parentDiv.append(this.dom.leftTopBlocker);
                }
            }
            // If there is a footer with the index class and reading rtl then add right bottom blocker
            if (footer) {
                if (!this.s.rtl) {
                    this.dom.rightBottomBlocker.outerHeight(footerHeight);
                    parentDiv.append(this.dom.rightBottomBlocker);
                }
                else {
                    this.dom.leftBottomBlocker.outerHeight(footerHeight);
                    parentDiv.append(this.dom.leftBottomBlocker);
                }
            }
        };
        /**
         * Clean up
         */
        FixedColumns.prototype._destroy = function () {
            this.s.dt.off('.dtfc');
            this.dom.leftBottomBlocker.remove();
            this.dom.leftTopBlocker.remove();
            this.dom.rightBottomBlocker.remove();
            this.dom.rightTopBlocker.remove();
        };
        /**
         * Gets the correct CSS for the cell, header or footer based on options provided
         *
         * @param header Whether this cell is a header or a footer
         * @param dist The distance that the cell should be moved away from the edge
         * @param lr Indicator of fixing to the left or the right
         * @returns An object containing the correct css
         */
        FixedColumns.prototype._getCellCSS = function (header, dist, lr) {
            if (lr === 'left') {
                return this.s.rtl
                    ? {
                        position: 'sticky',
                        right: dist + 'px'
                    }
                    : {
                        left: dist + 'px',
                        position: 'sticky'
                    };
            }
            else {
                return this.s.rtl
                    ? {
                        left: dist + (header ? this.s.barWidth : 0) + 'px',
                        position: 'sticky'
                    }
                    : {
                        position: 'sticky',
                        right: dist + (header ? this.s.barWidth : 0) + 'px'
                    };
            }
        };
        /**
         * Gets the css that is required to clear the fixing to a side
         *
         * @param lr Indicator of fixing to the left or the right
         * @returns An object containing the correct css
         */
        FixedColumns.prototype._clearCellCSS = function (lr) {
            if (lr === 'left') {
                return !this.s.rtl ?
                    {
                        left: '',
                        position: ''
                    } :
                    {
                        position: '',
                        right: ''
                    };
            }
            else {
                return !this.s.rtl ?
                    {
                        position: '',
                        right: ''
                    } :
                    {
                        left: '',
                        position: ''
                    };
            }
        };
        FixedColumns.prototype._setKeyTableListener = function () {
            var _this = this;
            this.s.dt.on('key-focus.dt.dtfc', function (e, dt, cell) {
                var cellPos = $$1(cell.node()).offset();
                var scroll = $$1($$1(_this.s.dt.table().node()).closest('div.dataTables_scrollBody'));
                // If there are fixed columns to the left
                if (_this.c.left > 0) {
                    // Get the rightmost left fixed column header, it's position and it's width
                    var rightMost = $$1(_this.s.dt.column(_this.c.left - 1).header());
                    var rightMostPos = rightMost.offset();
                    var rightMostWidth = rightMost.outerWidth();
                    // If the current highlighted cell is left of the rightmost cell on the screen
                    if (cellPos.left < rightMostPos.left + rightMostWidth) {
                        // Scroll it into view
                        var currScroll = scroll.scrollLeft();
                        scroll.scrollLeft(currScroll - (rightMostPos.left + rightMostWidth - cellPos.left));
                    }
                }
                // If there are fixed columns to the right
                if (_this.c.right > 0) {
                    // Get the number of columns and the width of the cell as doing right side calc
                    var numCols = _this.s.dt.columns().data().toArray().length;
                    var cellWidth = $$1(cell.node()).outerWidth();
                    // Get the leftmost right fixed column header and it's position
                    var leftMost = $$1(_this.s.dt.column(numCols - _this.c.right).header());
                    var leftMostPos = leftMost.offset();
                    // If the current highlighted cell is right of the leftmost cell on the screen
                    if (cellPos.left + cellWidth > leftMostPos.left) {
                        // Scroll it into view
                        var currScroll = scroll.scrollLeft();
                        scroll.scrollLeft(currScroll - (leftMostPos.left - (cellPos.left + cellWidth)));
                    }
                }
            });
            // Whenever a draw occurs there is potential for the data to have changed and therefore also the column widths
            // Therefore it is necessary to recalculate the values for the fixed columns
            this.s.dt.on('draw.dt.dtfc', function () {
                _this._addStyles();
            });
            this.s.dt.on('column-reorder.dt.dtfc', function () {
                _this._addStyles();
            });
            this.s.dt.on('column-visibility.dt.dtfc', function (e, settings, column, state, recalc) {
                if (recalc && !settings.bDestroying) {
                    setTimeout(function () {
                        _this._addStyles();
                    }, 50);
                }
            });
        };
        FixedColumns.version = '4.3.0';
        FixedColumns.classes = {
            fixedLeft: 'dtfc-fixed-left',
            fixedRight: 'dtfc-fixed-right',
            leftBottomBlocker: 'dtfc-left-bottom-blocker',
            leftTopBlocker: 'dtfc-left-top-blocker',
            rightBottomBlocker: 'dtfc-right-bottom-blocker',
            rightTopBlocker: 'dtfc-right-top-blocker',
            tableFixedLeft: 'dtfc-has-left',
            tableFixedRight: 'dtfc-has-right'
        };
        FixedColumns.defaults = {
            i18n: {
                button: 'FixedColumns'
            },
            left: 1,
            right: 0
        };
        return FixedColumns;
    }());

    /*! FixedColumns 4.3.0
     * © SpryMedia Ltd - datatables.net/license
     */
    setJQuery($);
    $.fn.dataTable.FixedColumns = FixedColumns;
    $.fn.DataTable.FixedColumns = FixedColumns;
    var apiRegister = DataTable.Api.register;
    apiRegister('fixedColumns()', function () {
        return this;
    });
    apiRegister('fixedColumns().left()', function (newVal) {
        var ctx = this.context[0];
        if (newVal !== undefined) {
            ctx._fixedColumns.left(newVal);
            return this;
        }
        else {
            return ctx._fixedColumns.left();
        }
    });
    apiRegister('fixedColumns().right()', function (newVal) {
        var ctx = this.context[0];
        if (newVal !== undefined) {
            ctx._fixedColumns.right(newVal);
            return this;
        }
        else {
            return ctx._fixedColumns.right();
        }
    });
    DataTable.ext.buttons.fixedColumns = {
        action: function (e, dt, node, config) {
            if ($(node).attr('active')) {
                $(node).removeAttr('active').removeClass('active');
                dt.fixedColumns().left(0);
                dt.fixedColumns().right(0);
            }
            else {
                $(node).attr('active', 'true').addClass('active');
                dt.fixedColumns().left(config.config.left);
                dt.fixedColumns().right(config.config.right);
            }
        },
        config: {
            left: 1,
            right: 0
        },
        init: function (dt, node, config) {
            if (dt.settings()[0]._fixedColumns === undefined) {
                _init(dt.settings(), config);
            }
            $(node).attr('active', 'true').addClass('active');
            dt.button(node).text(config.text || dt.i18n('buttons.fixedColumns', dt.settings()[0]._fixedColumns.c.i18n.button));
        },
        text: null
    };
    function _init(settings, options) {
        if (options === void 0) { options = null; }
        var api = new DataTable.Api(settings);
        var opts = options
            ? options
            : api.init().fixedColumns || DataTable.defaults.fixedColumns;
        var fixedColumns = new FixedColumns(api, opts);
        return fixedColumns;
    }
    // Attach a listener to the document which listens for DataTables initialisation
    // events so we can automatically initialise
    $(document).on('plugin-init.dt', function (e, settings) {
        if (e.namespace !== 'dt') {
            return;
        }
        if (settings.oInit.fixedColumns ||
            DataTable.defaults.fixedColumns) {
            if (!settings._fixedColumns) {
                _init(settings, null);
            }
        }
    });

}());


return DataTable;
}));

/*! FixedHeader 3.4.0
 * © SpryMedia Ltd - datatables.net/license
 */

(function( factory ){
	if ( typeof define === 'function' && define.amd ) {
		// AMD
		define( ['jquery', 'datatables.net'], function ( $ ) {
			return factory( $, window, document );
		} );
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		var jq = require('jquery');
		var cjsRequires = function (root, $) {
			if ( ! $.fn.dataTable ) {
				require('datatables.net')(root, $);
			}
		};

		if (typeof window === 'undefined') {
			module.exports = function (root, $) {
				if ( ! root ) {
					// CommonJS environments without a window global must pass a
					// root. This will give an error otherwise
					root = window;
				}

				if ( ! $ ) {
					$ = jq( root );
				}

				cjsRequires( root, $ );
				return factory( $, root, root.document );
			};
		}
		else {
			cjsRequires( window, jq );
			module.exports = factory( jq, window, window.document );
		}
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;



/**
 * @summary     FixedHeader
 * @description Fix a table's header or footer, so it is always visible while
 *              scrolling
 * @version     3.4.0
 * @author      SpryMedia Ltd (www.sprymedia.co.uk)
 * @contact     www.sprymedia.co.uk
 * @copyright   SpryMedia Ltd.
 *
 * This source file is free software, available under the following license:
 *   MIT license - http://datatables.net/license/mit
 *
 * This source file is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
 *
 * For details please refer to: http://www.datatables.net
 */

var _instCounter = 0;

var FixedHeader = function (dt, config) {
	// Sanity check - you just know it will happen
	if (!(this instanceof FixedHeader)) {
		throw "FixedHeader must be initialised with the 'new' keyword.";
	}

	// Allow a boolean true for defaults
	if (config === true) {
		config = {};
	}

	dt = new DataTable.Api(dt);

	this.c = $.extend(true, {}, FixedHeader.defaults, config);

	this.s = {
		dt: dt,
		position: {
			theadTop: 0,
			tbodyTop: 0,
			tfootTop: 0,
			tfootBottom: 0,
			width: 0,
			left: 0,
			tfootHeight: 0,
			theadHeight: 0,
			windowHeight: $(window).height(),
			visible: true
		},
		headerMode: null,
		footerMode: null,
		autoWidth: dt.settings()[0].oFeatures.bAutoWidth,
		namespace: '.dtfc' + _instCounter++,
		scrollLeft: {
			header: -1,
			footer: -1
		},
		enable: true,
		autoDisable: false
	};

	this.dom = {
		floatingHeader: null,
		thead: $(dt.table().header()),
		tbody: $(dt.table().body()),
		tfoot: $(dt.table().footer()),
		header: {
			host: null,
			floating: null,
			floatingParent: $('<div class="dtfh-floatingparent">'),
			placeholder: null
		},
		footer: {
			host: null,
			floating: null,
			floatingParent: $('<div class="dtfh-floatingparent">'),
			placeholder: null
		}
	};

	this.dom.header.host = this.dom.thead.parent();
	this.dom.footer.host = this.dom.tfoot.parent();

	var dtSettings = dt.settings()[0];
	if (dtSettings._fixedHeader) {
		throw 'FixedHeader already initialised on table ' + dtSettings.nTable.id;
	}

	dtSettings._fixedHeader = this;

	this._constructor();
};

/*
 * Variable: FixedHeader
 * Purpose:  Prototype for FixedHeader
 * Scope:    global
 */
$.extend(FixedHeader.prototype, {
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * API methods
	 */

	/**
	 * Kill off FH and any events
	 */
	destroy: function () {
		var dom = this.dom;

		this.s.dt.off('.dtfc');
		$(window).off(this.s.namespace);

		// Remove clones of FC blockers
		if (dom.header.rightBlocker) {
			dom.header.rightBlocker.remove();
		}
		if (dom.header.leftBlocker) {
			dom.header.leftBlocker.remove();
		}
		if (dom.footer.rightBlocker) {
			dom.footer.rightBlocker.remove();
		}
		if (dom.footer.leftBlocker) {
			dom.footer.leftBlocker.remove();
		}

		if (this.c.header) {
			this._modeChange('in-place', 'header', true);
		}

		if (this.c.footer && dom.tfoot.length) {
			this._modeChange('in-place', 'footer', true);
		}
	},

	/**
	 * Enable / disable the fixed elements
	 *
	 * @param  {boolean} enable `true` to enable, `false` to disable
	 */
	enable: function (enable, update, type) {
		this.s.enable = enable;

		this.s.enableType = type;

		if (update || update === undefined) {
			this._positions();
			this._scroll(true);
		}
	},

	/**
	 * Get enabled status
	 */
	enabled: function () {
		return this.s.enable;
	},

	/**
	 * Set header offset
	 *
	 * @param  {int} new value for headerOffset
	 */
	headerOffset: function (offset) {
		if (offset !== undefined) {
			this.c.headerOffset = offset;
			this.update();
		}

		return this.c.headerOffset;
	},

	/**
	 * Set footer offset
	 *
	 * @param  {int} new value for footerOffset
	 */
	footerOffset: function (offset) {
		if (offset !== undefined) {
			this.c.footerOffset = offset;
			this.update();
		}

		return this.c.footerOffset;
	},

	/**
	 * Recalculate the position of the fixed elements and force them into place
	 */
	update: function (force) {
		var table = this.s.dt.table().node();

		// Update should only do something if enabled by the dev.
		if (!this.s.enable && !this.s.autoDisable) {
			return;
		}

		if ($(table).is(':visible')) {
			this.s.autoDisable = false;
			this.enable(true, false);
		}
		else {
			this.s.autoDisable = true;
			this.enable(false, false);
		}

		// Don't update if header is not in the document atm (due to
		// async events)
		if ($(table).children('thead').length === 0) {
			return;
		}

		this._positions();
		this._scroll(force !== undefined ? force : true);
	},

	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Constructor
	 */

	/**
	 * FixedHeader constructor - adding the required event listeners and
	 * simple initialisation
	 *
	 * @private
	 */
	_constructor: function () {
		var that = this;
		var dt = this.s.dt;

		$(window)
			.on('scroll' + this.s.namespace, function () {
				that._scroll();
			})
			.on(
				'resize' + this.s.namespace,
				DataTable.util.throttle(function () {
					that.s.position.windowHeight = $(window).height();
					that.update();
				}, 50)
			);

		var autoHeader = $('.fh-fixedHeader');
		if (!this.c.headerOffset && autoHeader.length) {
			this.c.headerOffset = autoHeader.outerHeight();
		}

		var autoFooter = $('.fh-fixedFooter');
		if (!this.c.footerOffset && autoFooter.length) {
			this.c.footerOffset = autoFooter.outerHeight();
		}

		dt.on(
			'column-reorder.dt.dtfc column-visibility.dt.dtfc column-sizing.dt.dtfc responsive-display.dt.dtfc',
			function (e, ctx) {
				that.update();
			}
		).on('draw.dt.dtfc', function (e, ctx) {
			// For updates from our own table, don't reclone, but for all others, do
			that.update(ctx === dt.settings()[0] ? false : true);
		});

		dt.on('destroy.dtfc', function () {
			that.destroy();
		});

		this._positions();
		this._scroll();
	},

	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 * Private methods
	 */

	/**
	 * Clone a fixed item to act as a place holder for the original element
	 * which is moved into a clone of the table element, and moved around the
	 * document to give the fixed effect.
	 *
	 * @param  {string}  item  'header' or 'footer'
	 * @param  {boolean} force Force the clone to happen, or allow automatic
	 *   decision (reuse existing if available)
	 * @private
	 */
	_clone: function (item, force) {
		var that = this;
		var dt = this.s.dt;
		var itemDom = this.dom[item];
		var itemElement = item === 'header' ? this.dom.thead : this.dom.tfoot;

		// If footer and scrolling is enabled then we don't clone
		// Instead the table's height is decreased accordingly - see `_scroll()`
		if (item === 'footer' && this._scrollEnabled()) {
			return;
		}

		if (!force && itemDom.floating) {
			// existing floating element - reuse it
			itemDom.floating.removeClass('fixedHeader-floating fixedHeader-locked');
		}
		else {
			if (itemDom.floating) {
				if (itemDom.placeholder !== null) {
					itemDom.placeholder.remove();
				}
				this._unsize(item);
				itemDom.floating.children().detach();
				itemDom.floating.remove();
			}

			var tableNode = $(dt.table().node());
			var scrollBody = $(tableNode.parent());
			var scrollEnabled = this._scrollEnabled();

			itemDom.floating = $(dt.table().node().cloneNode(false))
				.attr('aria-hidden', 'true')
				.css({
					'table-layout': 'fixed',
					top: 0,
					left: 0
				})
				.removeAttr('id')
				.append(itemElement);

			itemDom.floatingParent
				.css({
					width: scrollBody.width(),
					overflow: 'hidden',
					height: 'fit-content',
					position: 'fixed',
					left: scrollEnabled ? tableNode.offset().left + scrollBody.scrollLeft() : 0
				})
				.css(
					item === 'header'
						? {
								top: this.c.headerOffset,
								bottom: ''
						  }
						: {
								top: '',
								bottom: this.c.footerOffset
						  }
				)
				.addClass(item === 'footer' ? 'dtfh-floatingparentfoot' : 'dtfh-floatingparenthead')
				.append(itemDom.floating)
				.appendTo('body');

			this._stickyPosition(itemDom.floating, '-');

			var scrollLeftUpdate = function () {
				var scrollLeft = scrollBody.scrollLeft();
				that.s.scrollLeft = { footer: scrollLeft, header: scrollLeft };
				itemDom.floatingParent.scrollLeft(that.s.scrollLeft.header);
			};

			scrollLeftUpdate();
			scrollBody.off('scroll.dtfh').on('scroll.dtfh', scrollLeftUpdate);

			// Insert a fake thead/tfoot into the DataTable to stop it jumping around
			itemDom.placeholder = itemElement.clone(false);
			itemDom.placeholder.find('*[id]').removeAttr('id');

			itemDom.host.prepend(itemDom.placeholder);

			// Clone widths
			this._matchWidths(itemDom.placeholder, itemDom.floating);
		}
	},

	/**
	 * This method sets the sticky position of the header elements to match fixed columns
	 * @param {JQuery<HTMLElement>} el
	 * @param {string} sign
	 */
	_stickyPosition: function (el, sign) {
		if (this._scrollEnabled()) {
			var that = this;
			var rtl = $(that.s.dt.table().node()).css('direction') === 'rtl';

			el.find('th').each(function () {
				// Find out if fixed header has previously set this column
				if ($(this).css('position') === 'sticky') {
					var right = $(this).css('right');
					var left = $(this).css('left');
					if (right !== 'auto' && !rtl) {
						// New position either adds or dismisses the barWidth
						var potential =
							+right.replace(/px/g, '') +
							(sign === '-' ? -1 : 1) * that.s.dt.settings()[0].oBrowser.barWidth;
						$(this).css('right', potential > 0 ? potential : 0);
					}
					else if (left !== 'auto' && rtl) {
						var potential =
							+left.replace(/px/g, '') +
							(sign === '-' ? -1 : 1) * that.s.dt.settings()[0].oBrowser.barWidth;
						$(this).css('left', potential > 0 ? potential : 0);
					}
				}
			});
		}
	},

	/**
	 * Copy widths from the cells in one element to another. This is required
	 * for the footer as the footer in the main table takes its sizes from the
	 * header columns. That isn't present in the footer so to have it still
	 * align correctly, the sizes need to be copied over. It is also required
	 * for the header when auto width is not enabled
	 *
	 * @param  {jQuery} from Copy widths from
	 * @param  {jQuery} to   Copy widths to
	 * @private
	 */
	_matchWidths: function (from, to) {
		var get = function (name) {
			return $(name, from)
				.map(function () {
					return (
						$(this)
							.css('width')
							.replace(/[^\d\.]/g, '') * 1
					);
				})
				.toArray();
		};

		var set = function (name, toWidths) {
			$(name, to).each(function (i) {
				$(this).css({
					width: toWidths[i],
					minWidth: toWidths[i]
				});
			});
		};

		var thWidths = get('th');
		var tdWidths = get('td');

		set('th', thWidths);
		set('td', tdWidths);
	},

	/**
	 * Remove assigned widths from the cells in an element. This is required
	 * when inserting the footer back into the main table so the size is defined
	 * by the header columns and also when auto width is disabled in the
	 * DataTable.
	 *
	 * @param  {string} item The `header` or `footer`
	 * @private
	 */
	_unsize: function (item) {
		var el = this.dom[item].floating;

		if (el && (item === 'footer' || (item === 'header' && !this.s.autoWidth))) {
			$('th, td', el).css({
				width: '',
				minWidth: ''
			});
		}
		else if (el && item === 'header') {
			$('th, td', el).css('min-width', '');
		}
	},

	/**
	 * Reposition the floating elements to take account of horizontal page
	 * scroll
	 *
	 * @param  {string} item       The `header` or `footer`
	 * @param  {int}    scrollLeft Document scrollLeft
	 * @private
	 */
	_horizontal: function (item, scrollLeft) {
		var itemDom = this.dom[item];
		var position = this.s.position;
		var lastScrollLeft = this.s.scrollLeft;

		if (itemDom.floating && lastScrollLeft[item] !== scrollLeft) {
			// If scrolling is enabled we need to match the floating header to the body
			if (this._scrollEnabled()) {
				var newScrollLeft = $($(this.s.dt.table().node()).parent()).scrollLeft();
				itemDom.floating.scrollLeft(newScrollLeft);
				itemDom.floatingParent.scrollLeft(newScrollLeft);
			}

			lastScrollLeft[item] = scrollLeft;
		}
	},

	/**
	 * Change from one display mode to another. Each fixed item can be in one
	 * of:
	 *
	 * * `in-place` - In the main DataTable
	 * * `in` - Floating over the DataTable
	 * * `below` - (Header only) Fixed to the bottom of the table body
	 * * `above` - (Footer only) Fixed to the top of the table body
	 *
	 * @param  {string}  mode        Mode that the item should be shown in
	 * @param  {string}  item        'header' or 'footer'
	 * @param  {boolean} forceChange Force a redraw of the mode, even if already
	 *     in that mode.
	 * @private
	 */
	_modeChange: function (mode, item, forceChange) {
		var dt = this.s.dt;
		var itemDom = this.dom[item];
		var position = this.s.position;

		// Just determine if scroll is enabled once
		var scrollEnabled = this._scrollEnabled();

		// If footer and scrolling is enabled then we don't clone
		// Instead the table's height is decreased accordingly - see `_scroll()`
		if (item === 'footer' && scrollEnabled) {
			return;
		}

		// It isn't trivial to add a !important css attribute...
		var importantWidth = function (w) {
			itemDom.floating.attr('style', function (i, s) {
				return (s || '') + 'width: ' + w + 'px !important;';
			});

			// If not scrolling also have to update the floatingParent
			if (!scrollEnabled) {
				itemDom.floatingParent.attr('style', function (i, s) {
					return (s || '') + 'width: ' + w + 'px !important;';
				});
			}
		};

		// Record focus. Browser's will cause input elements to loose focus if
		// they are inserted else where in the doc
		var tablePart = this.dom[item === 'footer' ? 'tfoot' : 'thead'];
		var focus = $.contains(tablePart[0], document.activeElement)
			? document.activeElement
			: null;
		var scrollBody = $($(this.s.dt.table().node()).parent());

		if (mode === 'in-place') {
			// Insert the header back into the table's real header
			if (itemDom.placeholder) {
				itemDom.placeholder.remove();
				itemDom.placeholder = null;
			}

			this._unsize(item);

			if (item === 'header') {
				itemDom.host.prepend(tablePart);
			}
			else {
				itemDom.host.append(tablePart);
			}

			if (itemDom.floating) {
				itemDom.floating.remove();
				itemDom.floating = null;
				this._stickyPosition(itemDom.host, '+');
			}

			if (itemDom.floatingParent) {
				itemDom.floatingParent.remove();
			}

			$($(itemDom.host.parent()).parent()).scrollLeft(scrollBody.scrollLeft());
		}
		else if (mode === 'in') {
			// Remove the header from the read header and insert into a fixed
			// positioned floating table clone
			this._clone(item, forceChange);

			// Get useful position values
			var scrollOffset = scrollBody.offset();
			var windowTop = $(document).scrollTop();
			var windowHeight = $(window).height();
			var windowBottom = windowTop + windowHeight;
			var bodyTop = scrollEnabled ? scrollOffset.top : position.tbodyTop;
			var bodyBottom = scrollEnabled
				? scrollOffset.top + scrollBody.outerHeight()
				: position.tfootTop;

			// Calculate the amount that the footer or header needs to be shuffled
			var shuffle =
				item === 'footer'
					? // footer and top of body isn't on screen
					  bodyTop > windowBottom
						? // Yes - push the footer below
						  position.tfootHeight
						: // No - bottom set to the gap between the top of the body and the bottom of the window
						  bodyTop + position.tfootHeight - windowBottom
					: // Otherwise must be a header so get the difference from the bottom of the
					  //  desired floating header and the bottom of the table body
					  windowTop + this.c.headerOffset + position.theadHeight - bodyBottom;

			// Set the top or bottom based off of the offset and the shuffle value
			var prop = item === 'header' ? 'top' : 'bottom';
			var val = this.c[item + 'Offset'] - (shuffle > 0 ? shuffle : 0);

			itemDom.floating.addClass('fixedHeader-floating');
			itemDom.floatingParent
				.css(prop, val)
				.css({
					left: position.left,
					height: item === 'header' ? position.theadHeight : position.tfootHeight,
					'z-index': 2
				})
				.append(itemDom.floating);

			importantWidth(position.width);

			if (item === 'footer') {
				itemDom.floating.css('top', '');
			}
		}
		else if (mode === 'below') {
			// only used for the header
			// Fix the position of the floating header at base of the table body
			this._clone(item, forceChange);

			itemDom.floating.addClass('fixedHeader-locked');
			itemDom.floatingParent.css({
				position: 'absolute',
				top: position.tfootTop - position.theadHeight,
				left: position.left + 'px'
			});

			importantWidth(position.width);
		}
		else if (mode === 'above') {
			// only used for the footer
			// Fix the position of the floating footer at top of the table body
			this._clone(item, forceChange);

			itemDom.floating.addClass('fixedHeader-locked');
			itemDom.floatingParent.css({
				position: 'absolute',
				top: position.tbodyTop,
				left: position.left + 'px'
			});

			importantWidth(position.width);
		}

		// Restore focus if it was lost
		if (focus && focus !== document.activeElement) {
			setTimeout(function () {
				focus.focus();
			}, 10);
		}

		this.s.scrollLeft.header = -1;
		this.s.scrollLeft.footer = -1;
		this.s[item + 'Mode'] = mode;
	},

	/**
	 * Cache the positional information that is required for the mode
	 * calculations that FixedHeader performs.
	 *
	 * @private
	 */
	_positions: function () {
		var dt = this.s.dt;
		var table = dt.table();
		var position = this.s.position;
		var dom = this.dom;
		var tableNode = $(table.node());
		var scrollEnabled = this._scrollEnabled();

		// Need to use the header and footer that are in the main table,
		// regardless of if they are clones, since they hold the positions we
		// want to measure from
		var thead = $(dt.table().header());
		var tfoot = $(dt.table().footer());
		var tbody = dom.tbody;
		var scrollBody = tableNode.parent();

		position.visible = tableNode.is(':visible');
		position.width = tableNode.outerWidth();
		position.left = tableNode.offset().left;
		position.theadTop = thead.offset().top;
		position.tbodyTop = scrollEnabled ? scrollBody.offset().top : tbody.offset().top;
		position.tbodyHeight = scrollEnabled ? scrollBody.outerHeight() : tbody.outerHeight();
		position.theadHeight = thead.outerHeight();
		position.theadBottom = position.theadTop + position.theadHeight;

		if (tfoot.length) {
			position.tfootTop = position.tbodyTop + position.tbodyHeight; //tfoot.offset().top;
			position.tfootBottom = position.tfootTop + tfoot.outerHeight();
			position.tfootHeight = tfoot.outerHeight();
		}
		else {
			position.tfootTop = position.tbodyTop + tbody.outerHeight();
			position.tfootBottom = position.tfootTop;
			position.tfootHeight = position.tfootTop;
		}
	},

	/**
	 * Mode calculation - determine what mode the fixed items should be placed
	 * into.
	 *
	 * @param  {boolean} forceChange Force a redraw of the mode, even if already
	 *     in that mode.
	 * @private
	 */
	_scroll: function (forceChange) {
		if (this.s.dt.settings()[0].bDestroying) {
			return;
		}

		// ScrollBody details
		var scrollEnabled = this._scrollEnabled();
		var scrollBody = $(this.s.dt.table().node()).parent();
		var scrollOffset = scrollBody.offset();
		var scrollHeight = scrollBody.outerHeight();

		// Window details
		var windowLeft = $(document).scrollLeft();
		var windowTop = $(document).scrollTop();
		var windowHeight = $(window).height();
		var windowBottom = windowHeight + windowTop;

		var position = this.s.position;
		var headerMode, footerMode;

		// Body Details
		var bodyTop = scrollEnabled ? scrollOffset.top : position.tbodyTop;
		var bodyLeft = scrollEnabled ? scrollOffset.left : position.left;
		var bodyBottom = scrollEnabled ? scrollOffset.top + scrollHeight : position.tfootTop;
		var bodyWidth = scrollEnabled ? scrollBody.outerWidth() : position.tbodyWidth;

		var windowBottom = windowTop + windowHeight;

		if (this.c.header) {
			if (!this.s.enable) {
				headerMode = 'in-place';
			}
			// The header is in it's normal place if the body top is lower than
			//  the scroll of the window plus the headerOffset and the height of the header
			else if (
				!position.visible ||
				windowTop + this.c.headerOffset + position.theadHeight <= bodyTop
			) {
				headerMode = 'in-place';
			}
			// The header should be floated if
			else if (
				// The scrolling plus the header offset plus the height of the header is lower than the top of the body
				windowTop + this.c.headerOffset + position.theadHeight > bodyTop &&
				// And the scrolling at the top plus the header offset is above the bottom of the body
				windowTop + this.c.headerOffset + position.theadHeight < bodyBottom
			) {
				headerMode = 'in';
				var scrollBody = $($(this.s.dt.table().node()).parent());

				// Further to the above, If the scrolling plus the header offset plus the header height is lower
				// than the bottom of the table a shuffle is required so have to force the calculation
				if (
					windowTop + this.c.headerOffset + position.theadHeight > bodyBottom ||
					this.dom.header.floatingParent === undefined
				) {
					forceChange = true;
				}
				else {
					this.dom.header.floatingParent
						.css({
							top: this.c.headerOffset,
							position: 'fixed'
						})
						.append(this.dom.header.floating);
				}
			}
			// Anything else and the view is below the table
			else {
				headerMode = 'below';
			}

			if (forceChange || headerMode !== this.s.headerMode) {
				this._modeChange(headerMode, 'header', forceChange);
			}

			this._horizontal('header', windowLeft);
		}

		var header = {
			offset: { top: 0, left: 0 },
			height: 0
		};
		var footer = {
			offset: { top: 0, left: 0 },
			height: 0
		};

		if (this.c.footer && this.dom.tfoot.length) {
			if (!this.s.enable) {
				footerMode = 'in-place';
			}
			else if (
				!position.visible ||
				position.tfootBottom + this.c.footerOffset <= windowBottom
			) {
				footerMode = 'in-place';
			}
			else if (
				bodyBottom + position.tfootHeight + this.c.footerOffset > windowBottom &&
				bodyTop + this.c.footerOffset < windowBottom
			) {
				footerMode = 'in';
				forceChange = true;
			}
			else {
				footerMode = 'above';
			}

			if (forceChange || footerMode !== this.s.footerMode) {
				this._modeChange(footerMode, 'footer', forceChange);
			}

			this._horizontal('footer', windowLeft);

			var getOffsetHeight = function (el) {
				return {
					offset: el.offset(),
					height: el.outerHeight()
				};
			};

			header = this.dom.header.floating
				? getOffsetHeight(this.dom.header.floating)
				: getOffsetHeight(this.dom.thead);
			footer = this.dom.footer.floating
				? getOffsetHeight(this.dom.footer.floating)
				: getOffsetHeight(this.dom.tfoot);

			// If scrolling is enabled and the footer is off the screen
			if (scrollEnabled && footer.offset.top > windowTop) {
				// && footer.offset.top >= windowBottom) {
				// Calculate the gap between the top of the scrollBody and the top of the window
				var overlap = windowTop - scrollOffset.top;
				// The new height is the bottom of the window
				var newHeight =
					windowBottom +
					// If the gap between the top of the scrollbody and the window is more than
					//  the height of the header then the top of the table is still visible so add that gap
					// Doing this has effectively calculated the height from the top of the table to the bottom of the current page
					(overlap > -header.height ? overlap : 0) -
					// Take from that
					// The top of the header plus
					(header.offset.top +
						// The header height if the standard header is present
						(overlap < -header.height ? header.height : 0) +
						// And the height of the footer
						footer.height);

				// Don't want a negative height
				if (newHeight < 0) {
					newHeight = 0;
				}

				// At the end of the above calculation the space between the header (top of the page if floating)
				// and the point just above the footer should be the new value for the height of the table.
				scrollBody.outerHeight(newHeight);

				// Need some rounding here as sometimes very small decimal places are encountered
				// If the actual height is bigger or equal to the height we just applied then the footer is "Floating"
				if (Math.round(scrollBody.outerHeight()) >= Math.round(newHeight)) {
					$(this.dom.tfoot.parent()).addClass('fixedHeader-floating');
				}
				// Otherwise max-width has kicked in so it is not floating
				else {
					$(this.dom.tfoot.parent()).removeClass('fixedHeader-floating');
				}
			}
		}

		if (this.dom.header.floating) {
			this.dom.header.floatingParent.css('left', bodyLeft - windowLeft);
		}
		if (this.dom.footer.floating) {
			this.dom.footer.floatingParent.css('left', bodyLeft - windowLeft);
		}

		// If fixed columns is being used on this table then the blockers need to be copied across
		// Cloning these is cleaner than creating as our own as it will keep consistency with fixedColumns automatically
		// ASSUMING that the class remains the same
		if (this.s.dt.settings()[0]._fixedColumns !== undefined) {
			var adjustBlocker = function (side, end, el) {
				if (el === undefined) {
					var blocker = $('div.dtfc-' + side + '-' + end + '-blocker');

					el = blocker.length === 0 ? null : blocker.clone().css('z-index', 1);
				}

				if (el !== null) {
					if (headerMode === 'in' || headerMode === 'below') {
						el.appendTo('body').css({
							top: end === 'top' ? header.offset.top : footer.offset.top,
							left: side === 'right' ? bodyLeft + bodyWidth - el.width() : bodyLeft
						});
					}
					else {
						el.detach();
					}
				}

				return el;
			};

			// Adjust all blockers
			this.dom.header.rightBlocker = adjustBlocker(
				'right',
				'top',
				this.dom.header.rightBlocker
			);
			this.dom.header.leftBlocker = adjustBlocker('left', 'top', this.dom.header.leftBlocker);
			this.dom.footer.rightBlocker = adjustBlocker(
				'right',
				'bottom',
				this.dom.footer.rightBlocker
			);
			this.dom.footer.leftBlocker = adjustBlocker(
				'left',
				'bottom',
				this.dom.footer.leftBlocker
			);
		}
	},

	/**
	 * Function to check if scrolling is enabled on the table or not
	 * @returns Boolean value indicating if scrolling on the table is enabled or not
	 */
	_scrollEnabled: function () {
		var oScroll = this.s.dt.settings()[0].oScroll;
		if (oScroll.sY !== '' || oScroll.sX !== '') {
			return true;
		}
		return false;
	}
});

/**
 * Version
 * @type {String}
 * @static
 */
FixedHeader.version = '3.4.0';

/**
 * Defaults
 * @type {Object}
 * @static
 */
FixedHeader.defaults = {
	header: true,
	footer: false,
	headerOffset: 0,
	footerOffset: 0
};

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * DataTables interfaces
 */

// Attach for constructor access
$.fn.dataTable.FixedHeader = FixedHeader;
$.fn.DataTable.FixedHeader = FixedHeader;

// DataTables creation - check if the FixedHeader option has been defined on the
// table and if so, initialise
$(document).on('init.dt.dtfh', function (e, settings, json) {
	if (e.namespace !== 'dt') {
		return;
	}

	var init = settings.oInit.fixedHeader;
	var defaults = DataTable.defaults.fixedHeader;

	if ((init || defaults) && !settings._fixedHeader) {
		var opts = $.extend({}, defaults, init);

		if (init !== false) {
			new FixedHeader(settings, opts);
		}
	}
});

// DataTables API methods
DataTable.Api.register('fixedHeader()', function () {});

DataTable.Api.register('fixedHeader.adjust()', function () {
	return this.iterator('table', function (ctx) {
		var fh = ctx._fixedHeader;

		if (fh) {
			fh.update();
		}
	});
});

DataTable.Api.register('fixedHeader.enable()', function (flag) {
	return this.iterator('table', function (ctx) {
		var fh = ctx._fixedHeader;

		flag = flag !== undefined ? flag : true;
		if (fh && flag !== fh.enabled()) {
			fh.enable(flag);
		}
	});
});

DataTable.Api.register('fixedHeader.enabled()', function () {
	if (this.context.length) {
		var fh = this.context[0]._fixedHeader;

		if (fh) {
			return fh.enabled();
		}
	}

	return false;
});

DataTable.Api.register('fixedHeader.disable()', function () {
	return this.iterator('table', function (ctx) {
		var fh = ctx._fixedHeader;

		if (fh && fh.enabled()) {
			fh.enable(false);
		}
	});
});

$.each(['header', 'footer'], function (i, el) {
	DataTable.Api.register('fixedHeader.' + el + 'Offset()', function (offset) {
		var ctx = this.context;

		if (offset === undefined) {
			return ctx.length && ctx[0]._fixedHeader
				? ctx[0]._fixedHeader[el + 'Offset']()
				: undefined;
		}

		return this.iterator('table', function (ctx) {
			var fh = ctx._fixedHeader;

			if (fh) {
				fh[el + 'Offset'](offset);
			}
		});
	});
});


return DataTable;
}));

/*! Bootstrap 4 styling wrapper for FixedHeader
 * © SpryMedia Ltd - datatables.net/license
 */

(function( factory ){
	if ( typeof define === 'function' && define.amd ) {
		// AMD
		define( ['jquery', 'datatables.net-bs4', 'datatables.net-fixedheader'], function ( $ ) {
			return factory( $, window, document );
		} );
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		var jq = require('jquery');
		var cjsRequires = function (root, $) {
			if ( ! $.fn.dataTable ) {
				require('datatables.net-bs4')(root, $);
			}

			if ( ! $.fn.dataTable.FixedHeader ) {
				require('datatables.net-fixedheader')(root, $);
			}
		};

		if (typeof window === 'undefined') {
			module.exports = function (root, $) {
				if ( ! root ) {
					// CommonJS environments without a window global must pass a
					// root. This will give an error otherwise
					root = window;
				}

				if ( ! $ ) {
					$ = jq( root );
				}

				cjsRequires( root, $ );
				return factory( $, root, root.document );
			};
		}
		else {
			cjsRequires( window, jq );
			module.exports = factory( jq, window, window.document );
		}
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;




return DataTable;
}));

/*!
 * Flash export buttons for Buttons and DataTables.
 * 2015-2017 SpryMedia Ltd - datatables.net/license
 *
 * ZeroClipbaord - MIT license
 * Copyright (c) 2012 Joseph Huckaby
 */

(function( factory ){
	if ( typeof define === 'function' && define.amd ) {
		// AMD
		define( ['jquery', 'datatables.net', 'datatables.net-buttons'], function ( $ ) {
			return factory( $, window, document );
		} );
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net')(root, $).$;
			}

			if ( ! $.fn.dataTable.Buttons ) {
				require('datatables.net-buttons')(root, $);
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * ZeroClipboard dependency
 */

/*
 * ZeroClipboard 1.0.4 with modifications
 * Author: Joseph Huckaby
 * License: MIT
 *
 * Copyright (c) 2012 Joseph Huckaby
 */
var ZeroClipboard_TableTools = {
	version: "1.0.4-TableTools2",
	clients: {}, // registered upload clients on page, indexed by id
	moviePath: '', // URL to movie
	nextId: 1, // ID of next movie

	$: function(thingy) {
		// simple DOM lookup utility function
		if (typeof(thingy) == 'string') {
			thingy = document.getElementById(thingy);
		}
		if (!thingy.addClass) {
			// extend element with a few useful methods
			thingy.hide = function() { this.style.display = 'none'; };
			thingy.show = function() { this.style.display = ''; };
			thingy.addClass = function(name) { this.removeClass(name); this.className += ' ' + name; };
			thingy.removeClass = function(name) {
				this.className = this.className.replace( new RegExp("\\s*" + name + "\\s*"), " ").replace(/^\s+/, '').replace(/\s+$/, '');
			};
			thingy.hasClass = function(name) {
				return !!this.className.match( new RegExp("\\s*" + name + "\\s*") );
			};
		}
		return thingy;
	},

	setMoviePath: function(path) {
		// set path to ZeroClipboard.swf
		this.moviePath = path;
	},

	dispatch: function(id, eventName, args) {
		// receive event from flash movie, send to client
		var client = this.clients[id];
		if (client) {
			client.receiveEvent(eventName, args);
		}
	},

	log: function ( str ) {
		console.log( 'Flash: '+str );
	},

	register: function(id, client) {
		// register new client to receive events
		this.clients[id] = client;
	},

	getDOMObjectPosition: function(obj) {
		// get absolute coordinates for dom element
		var info = {
			left: 0,
			top: 0,
			width: obj.width ? obj.width : obj.offsetWidth,
			height: obj.height ? obj.height : obj.offsetHeight
		};

		if ( obj.style.width !== "" ) {
			info.width = obj.style.width.replace("px","");
		}

		if ( obj.style.height !== "" ) {
			info.height = obj.style.height.replace("px","");
		}

		while (obj) {
			info.left += obj.offsetLeft;
			info.top += obj.offsetTop;
			obj = obj.offsetParent;
		}

		return info;
	},

	Client: function(elem) {
		// constructor for new simple upload client
		this.handlers = {};

		// unique ID
		this.id = ZeroClipboard_TableTools.nextId++;
		this.movieId = 'ZeroClipboard_TableToolsMovie_' + this.id;

		// register client with singleton to receive flash events
		ZeroClipboard_TableTools.register(this.id, this);

		// create movie
		if (elem) {
			this.glue(elem);
		}
	}
};

ZeroClipboard_TableTools.Client.prototype = {

	id: 0, // unique ID for us
	ready: false, // whether movie is ready to receive events or not
	movie: null, // reference to movie object
	clipText: '', // text to copy to clipboard
	fileName: '', // default file save name
	action: 'copy', // action to perform
	handCursorEnabled: true, // whether to show hand cursor, or default pointer cursor
	cssEffects: true, // enable CSS mouse effects on dom container
	handlers: null, // user event handlers
	sized: false,
	sheetName: '', // default sheet name for excel export

	glue: function(elem, title) {
		// glue to DOM element
		// elem can be ID or actual DOM element object
		this.domElement = ZeroClipboard_TableTools.$(elem);

		// float just above object, or zIndex 99 if dom element isn't set
		var zIndex = 99;
		if (this.domElement.style.zIndex) {
			zIndex = parseInt(this.domElement.style.zIndex, 10) + 1;
		}

		// find X/Y position of domElement
		var box = ZeroClipboard_TableTools.getDOMObjectPosition(this.domElement);

		// create floating DIV above element
		this.div = document.createElement('div');
		var style = this.div.style;
		style.position = 'absolute';
		style.left = '0px';
		style.top = '0px';
		style.width = (box.width) + 'px';
		style.height = box.height + 'px';
		style.zIndex = zIndex;

		if ( typeof title != "undefined" && title !== "" ) {
			this.div.title = title;
		}
		if ( box.width !== 0 && box.height !== 0 ) {
			this.sized = true;
		}

		// style.backgroundColor = '#f00'; // debug
		if ( this.domElement ) {
			this.domElement.appendChild(this.div);
			this.div.innerHTML = this.getHTML( box.width, box.height ).replace(/&/g, '&amp;');
		}
	},

	positionElement: function() {
		var box = ZeroClipboard_TableTools.getDOMObjectPosition(this.domElement);
		var style = this.div.style;

		style.position = 'absolute';
		//style.left = (this.domElement.offsetLeft)+'px';
		//style.top = this.domElement.offsetTop+'px';
		style.width = box.width + 'px';
		style.height = box.height + 'px';

		if ( box.width !== 0 && box.height !== 0 ) {
			this.sized = true;
		} else {
			return;
		}

		var flash = this.div.childNodes[0];
		flash.width = box.width;
		flash.height = box.height;
	},

	getHTML: function(width, height) {
		// return HTML for movie
		var html = '';
		var flashvars = 'id=' + this.id +
			'&width=' + width +
			'&height=' + height;

		if (navigator.userAgent.match(/MSIE/)) {
			// IE gets an OBJECT tag
			var protocol = location.href.match(/^https/i) ? 'https://' : 'http://';
			html += '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" codebase="'+protocol+'download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=10,0,0,0" width="'+width+'" height="'+height+'" id="'+this.movieId+'" align="middle"><param name="allowScriptAccess" value="always" /><param name="allowFullScreen" value="false" /><param name="movie" value="'+ZeroClipboard_TableTools.moviePath+'" /><param name="loop" value="false" /><param name="menu" value="false" /><param name="quality" value="best" /><param name="bgcolor" value="#ffffff" /><param name="flashvars" value="'+flashvars+'"/><param name="wmode" value="transparent"/></object>';
		}
		else {
			// all other browsers get an EMBED tag
			html += '<embed id="'+this.movieId+'" src="'+ZeroClipboard_TableTools.moviePath+'" loop="false" menu="false" quality="best" bgcolor="#ffffff" width="'+width+'" height="'+height+'" name="'+this.movieId+'" align="middle" allowScriptAccess="always" allowFullScreen="false" type="application/x-shockwave-flash" pluginspage="http://www.macromedia.com/go/getflashplayer" flashvars="'+flashvars+'" wmode="transparent" />';
		}
		return html;
	},

	hide: function() {
		// temporarily hide floater offscreen
		if (this.div) {
			this.div.style.left = '-2000px';
		}
	},

	show: function() {
		// show ourselves after a call to hide()
		this.reposition();
	},

	destroy: function() {
		// destroy control and floater
		var that = this;

		if (this.domElement && this.div) {
			$(this.div).remove();

			this.domElement = null;
			this.div = null;

			$.each( ZeroClipboard_TableTools.clients, function ( id, client ) {
				if ( client === that ) {
					delete ZeroClipboard_TableTools.clients[ id ];
				}
			} );
		}
	},

	reposition: function(elem) {
		// reposition our floating div, optionally to new container
		// warning: container CANNOT change size, only position
		if (elem) {
			this.domElement = ZeroClipboard_TableTools.$(elem);
			if (!this.domElement) {
				this.hide();
			}
		}

		if (this.domElement && this.div) {
			var box = ZeroClipboard_TableTools.getDOMObjectPosition(this.domElement);
			var style = this.div.style;
			style.left = '' + box.left + 'px';
			style.top = '' + box.top + 'px';
		}
	},

	clearText: function() {
		// clear the text to be copy / saved
		this.clipText = '';
		if (this.ready) {
			this.movie.clearText();
		}
	},

	appendText: function(newText) {
		// append text to that which is to be copied / saved
		this.clipText += newText;
		if (this.ready) { this.movie.appendText(newText) ;}
	},

	setText: function(newText) {
		// set text to be copied to be copied / saved
		this.clipText = newText;
		if (this.ready) { this.movie.setText(newText) ;}
	},

	setFileName: function(newText) {
		// set the file name
		this.fileName = newText;
		if (this.ready) {
			this.movie.setFileName(newText);
		}
	},

	setSheetData: function(data) {
		// set the xlsx sheet data
		if (this.ready) {
			this.movie.setSheetData( JSON.stringify( data ) );
		}
	},

	setAction: function(newText) {
		// set action (save or copy)
		this.action = newText;
		if (this.ready) {
			this.movie.setAction(newText);
		}
	},

	addEventListener: function(eventName, func) {
		// add user event listener for event
		// event types: load, queueStart, fileStart, fileComplete, queueComplete, progress, error, cancel
		eventName = eventName.toString().toLowerCase().replace(/^on/, '');
		if (!this.handlers[eventName]) {
			this.handlers[eventName] = [];
		}
		this.handlers[eventName].push(func);
	},

	setHandCursor: function(enabled) {
		// enable hand cursor (true), or default arrow cursor (false)
		this.handCursorEnabled = enabled;
		if (this.ready) {
			this.movie.setHandCursor(enabled);
		}
	},

	setCSSEffects: function(enabled) {
		// enable or disable CSS effects on DOM container
		this.cssEffects = !!enabled;
	},

	receiveEvent: function(eventName, args) {
		var self;

		// receive event from flash
		eventName = eventName.toString().toLowerCase().replace(/^on/, '');

		// special behavior for certain events
		switch (eventName) {
			case 'load':
				// movie claims it is ready, but in IE this isn't always the case...
				// bug fix: Cannot extend EMBED DOM elements in Firefox, must use traditional function
				this.movie = document.getElementById(this.movieId);
				if (!this.movie) {
					self = this;
					setTimeout( function() { self.receiveEvent('load', null); }, 1 );
					return;
				}

				// firefox on pc needs a "kick" in order to set these in certain cases
				if (!this.ready && navigator.userAgent.match(/Firefox/) && navigator.userAgent.match(/Windows/)) {
					self = this;
					setTimeout( function() { self.receiveEvent('load', null); }, 100 );
					this.ready = true;
					return;
				}

				this.ready = true;
				this.movie.clearText();
				this.movie.appendText( this.clipText );
				this.movie.setFileName( this.fileName );
				this.movie.setAction( this.action );
				this.movie.setHandCursor( this.handCursorEnabled );
				break;

			case 'mouseover':
				if (this.domElement && this.cssEffects) {
					//this.domElement.addClass('hover');
					if (this.recoverActive) {
						this.domElement.addClass('active');
					}
				}
				break;

			case 'mouseout':
				if (this.domElement && this.cssEffects) {
					this.recoverActive = false;
					if (this.domElement.hasClass('active')) {
						this.domElement.removeClass('active');
						this.recoverActive = true;
					}
					//this.domElement.removeClass('hover');
				}
				break;

			case 'mousedown':
				if (this.domElement && this.cssEffects) {
					this.domElement.addClass('active');
				}
				break;

			case 'mouseup':
				if (this.domElement && this.cssEffects) {
					this.domElement.removeClass('active');
					this.recoverActive = false;
				}
				break;
		} // switch eventName

		if (this.handlers[eventName]) {
			for (var idx = 0, len = this.handlers[eventName].length; idx < len; idx++) {
				var func = this.handlers[eventName][idx];

				if (typeof(func) == 'function') {
					// actual function reference
					func(this, args);
				}
				else if ((typeof(func) == 'object') && (func.length == 2)) {
					// PHP style object + method, i.e. [myObject, 'myMethod']
					func[0][ func[1] ](this, args);
				}
				else if (typeof(func) == 'string') {
					// name of function
					window[func](this, args);
				}
			} // foreach event handler defined
		} // user defined handler for event
	}
};

ZeroClipboard_TableTools.hasFlash = function ()
{
	try {
		var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
		if (fo) {
			return true;
		}
	}
	catch (e) {
		if (
			navigator.mimeTypes &&
			navigator.mimeTypes['application/x-shockwave-flash'] !== undefined &&
			navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin
		) {
			return true;
		}
	}

	return false;
};

// For the Flash binding to work, ZeroClipboard_TableTools must be on the global
// object list
window.ZeroClipboard_TableTools = ZeroClipboard_TableTools;



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Local (private) functions
 */

/**
 * If a Buttons instance is initlaised before it is placed into the DOM, Flash
 * won't be able to bind to it, so we need to wait until it is available, this
 * method abstracts that out.
 *
 * @param {ZeroClipboard} flash ZeroClipboard instance
 * @param {jQuery} node  Button
 */
var _glue = function ( flash, node )
{
	var id = node.attr('id');

	if ( node.parents('html').length ) {
		flash.glue( node[0], '' );
	}
	else {
		setTimeout( function () {
			_glue( flash, node );
		}, 500 );
	}
};

/**
 * Get the sheet name for Excel exports.
 *
 * @param {object}  config       Button configuration
 */
var _sheetname = function ( config )
{
	var sheetName = 'Sheet1';

	if ( config.sheetName ) {
		sheetName = config.sheetName.replace(/[\[\]\*\/\\\?\:]/g, '');
	}

	return sheetName;
};

/**
 * Set the flash text. This has to be broken up into chunks as the Javascript /
 * Flash bridge has a size limit. There is no indication in the Flash
 * documentation what this is, and it probably depends upon the browser.
 * Experimentation shows that the point is around 50k when data starts to get
 * lost, so an 8K limit used here is safe.
 *
 * @param {ZeroClipboard} flash ZeroClipboard instance
 * @param {string}        data  Data to send to Flash
 */
var _setText = function ( flash, data )
{
	var parts = data.match(/[\s\S]{1,8192}/g) || [];

	flash.clearText();
	for ( var i=0, len=parts.length ; i<len ; i++ )
	{
		flash.appendText( parts[i] );
	}
};

/**
 * Get the newline character(s)
 *
 * @param {object}  config Button configuration
 * @return {string}        Newline character
 */
var _newLine = function ( config )
{
	return config.newline ?
		config.newline :
		navigator.userAgent.match(/Windows/) ?
			'\r\n' :
			'\n';
};

/**
 * Combine the data from the `buttons.exportData` method into a string that
 * will be used in the export file.
 *
 * @param  {DataTable.Api} dt     DataTables API instance
 * @param  {object}        config Button configuration
 * @return {object}               The data to export
 */
var _exportData = function ( dt, config )
{
	var newLine = _newLine( config );
	var data = dt.buttons.exportData( config.exportOptions );
	var boundary = config.fieldBoundary;
	var separator = config.fieldSeparator;
	var reBoundary = new RegExp( boundary, 'g' );
	var escapeChar = config.escapeChar !== undefined ?
		config.escapeChar :
		'\\';
	var join = function ( a ) {
		var s = '';

		// If there is a field boundary, then we might need to escape it in
		// the source data
		for ( var i=0, ien=a.length ; i<ien ; i++ ) {
			if ( i > 0 ) {
				s += separator;
			}

			s += boundary ?
				boundary + ('' + a[i]).replace( reBoundary, escapeChar+boundary ) + boundary :
				a[i];
		}

		return s;
	};

	var header = config.header ? join( data.header )+newLine : '';
	var footer = config.footer && data.footer ? newLine+join( data.footer ) : '';
	var body = [];

	for ( var i=0, ien=data.body.length ; i<ien ; i++ ) {
		body.push( join( data.body[i] ) );
	}

	return {
		str: header + body.join( newLine ) + footer,
		rows: body.length
	};
};


// Basic initialisation for the buttons is common between them
var flashButton = {
	available: function () {
		return ZeroClipboard_TableTools.hasFlash();
	},

	init: function ( dt, button, config ) {
		// Insert the Flash movie
		ZeroClipboard_TableTools.moviePath = DataTable.Buttons.swfPath;
		var flash = new ZeroClipboard_TableTools.Client();

		flash.setHandCursor( true );
		flash.addEventListener('mouseDown', function(client) {
			config._fromFlash = true;
			dt.button( button[0] ).trigger();
			config._fromFlash = false;
		} );

		_glue( flash, button );

		config._flash = flash;
	},

	destroy: function ( dt, button, config ) {
		config._flash.destroy();
	},

	fieldSeparator: ',',

	fieldBoundary: '"',

	exportOptions: {},

	title: '*',

	messageTop: '*',

	messageBottom: '*',

	filename: '*',

	extension: '.csv',

	header: true,

	footer: false
};


/**
 * Convert from numeric position to letter for column names in Excel
 * @param  {int} n Column number
 * @return {string} Column letter(s) name
 */
function createCellPos( n ){
	var ordA = 'A'.charCodeAt(0);
	var ordZ = 'Z'.charCodeAt(0);
	var len = ordZ - ordA + 1;
	var s = "";

	while( n >= 0 ) {
		s = String.fromCharCode(n % len + ordA) + s;
		n = Math.floor(n / len) - 1;
	}

	return s;
}

/**
 * Create an XML node and add any children, attributes, etc without needing to
 * be verbose in the DOM.
 *
 * @param  {object} doc      XML document
 * @param  {string} nodeName Node name
 * @param  {object} opts     Options - can be `attr` (attributes), `children`
 *   (child nodes) and `text` (text content)
 * @return {node}            Created node
 */
function _createNode( doc, nodeName, opts ){
	var tempNode = doc.createElement( nodeName );

	if ( opts ) {
		if ( opts.attr ) {
			$(tempNode).attr( opts.attr );
		}

		if ( opts.children ) {
			$.each( opts.children, function ( key, value ) {
				tempNode.appendChild( value );
			} );
		}

		if ( opts.text !== null && opts.text !== undefined ) {
			tempNode.appendChild( doc.createTextNode( opts.text ) );
		}
	}

	return tempNode;
}

/**
 * Get the width for an Excel column based on the contents of that column
 * @param  {object} data Data for export
 * @param  {int}    col  Column index
 * @return {int}         Column width
 */
function _excelColWidth( data, col ) {
	var max = data.header[col].length;
	var len, lineSplit, str;

	if ( data.footer && data.footer[col].length > max ) {
		max = data.footer[col].length;
	}

	for ( var i=0, ien=data.body.length ; i<ien ; i++ ) {
		var point = data.body[i][col];
		str = point !== null && point !== undefined ?
			point.toString() :
			'';

		// If there is a newline character, workout the width of the column
		// based on the longest line in the string
		if ( str.indexOf('\n') !== -1 ) {
			lineSplit = str.split('\n');
			lineSplit.sort( function (a, b) {
				return b.length - a.length;
			} );

			len = lineSplit[0].length;
		}
		else {
			len = str.length;
		}

		if ( len > max ) {
			max = len;
		}

		// Max width rather than having potentially massive column widths
		if ( max > 40 ) {
			return 52; // 40 * 1.3
		}
	}

	max *= 1.3;

	// And a min width
	return max > 6 ? max : 6;
}

  var _serialiser = "";
    if (typeof window.XMLSerializer === 'undefined') {
        _serialiser = new function () {
            this.serializeToString = function (input) {
                return input.xml
            }
        };
    } else {
        _serialiser =  new XMLSerializer();
    }

    var _ieExcel;


/**
 * Convert XML documents in an object to strings
 * @param  {object} obj XLSX document object
 */
function _xlsxToStrings( obj ) {
	if ( _ieExcel === undefined ) {
		// Detect if we are dealing with IE's _awful_ serialiser by seeing if it
		// drop attributes
		_ieExcel = _serialiser
			.serializeToString(
				$.parseXML( excelStrings['xl/worksheets/sheet1.xml'] )
			)
			.indexOf( 'xmlns:r' ) === -1;
	}

	$.each( obj, function ( name, val ) {
		if ( $.isPlainObject( val ) ) {
			_xlsxToStrings( val );
		}
		else {
			if ( _ieExcel ) {
				// IE's XML serialiser will drop some name space attributes from
				// from the root node, so we need to save them. Do this by
				// replacing the namespace nodes with a regular attribute that
				// we convert back when serialised. Edge does not have this
				// issue
				var worksheet = val.childNodes[0];
				var i, ien;
				var attrs = [];

				for ( i=worksheet.attributes.length-1 ; i>=0 ; i-- ) {
					var attrName = worksheet.attributes[i].nodeName;
					var attrValue = worksheet.attributes[i].nodeValue;

					if ( attrName.indexOf( ':' ) !== -1 ) {
						attrs.push( { name: attrName, value: attrValue } );

						worksheet.removeAttribute( attrName );
					}
				}

				for ( i=0, ien=attrs.length ; i<ien ; i++ ) {
					var attr = val.createAttribute( attrs[i].name.replace( ':', '_dt_b_namespace_token_' ) );
					attr.value = attrs[i].value;
					worksheet.setAttributeNode( attr );
				}
			}

			var str = _serialiser.serializeToString(val);

			// Fix IE's XML
			if ( _ieExcel ) {
				// IE doesn't include the XML declaration
				if ( str.indexOf( '<?xml' ) === -1 ) {
					str = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'+str;
				}

				// Return namespace attributes to being as such
				str = str.replace( /_dt_b_namespace_token_/g, ':' );
			}

			// Safari, IE and Edge will put empty name space attributes onto
			// various elements making them useless. This strips them out
			str = str.replace( /<([^<>]*?) xmlns=""([^<>]*?)>/g, '<$1 $2>' );

			obj[ name ] = str;
		}
	} );
}

// Excel - Pre-defined strings to build a basic XLSX file
var excelStrings = {
	"_rels/.rels":
		'<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'+
		'<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">'+
			'<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/>'+
		'</Relationships>',

	"xl/_rels/workbook.xml.rels":
		'<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'+
		'<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">'+
			'<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet1.xml"/>'+
			'<Relationship Id="rId2" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/>'+
		'</Relationships>',

	"[Content_Types].xml":
		'<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'+
		'<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">'+
			'<Default Extension="xml" ContentType="application/xml" />'+
			'<Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml" />'+
			'<Default Extension="jpeg" ContentType="image/jpeg" />'+
			'<Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml" />'+
			'<Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml" />'+
			'<Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml" />'+
		'</Types>',

	"xl/workbook.xml":
		'<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'+
		'<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">'+
			'<fileVersion appName="xl" lastEdited="5" lowestEdited="5" rupBuild="24816"/>'+
			'<workbookPr showInkAnnotation="0" autoCompressPictures="0"/>'+
			'<bookViews>'+
				'<workbookView xWindow="0" yWindow="0" windowWidth="25600" windowHeight="19020" tabRatio="500"/>'+
			'</bookViews>'+
			'<sheets>'+
				'<sheet name="" sheetId="1" r:id="rId1"/>'+
			'</sheets>'+
		'</workbook>',

	"xl/worksheets/sheet1.xml":
		'<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'+
		'<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac">'+
			'<sheetData/>'+
			'<mergeCells count="0"/>'+
		'</worksheet>',

	"xl/styles.xml":
		'<?xml version="1.0" encoding="UTF-8"?>'+
		'<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac">'+
			'<numFmts count="6">'+
				'<numFmt numFmtId="164" formatCode="#,##0.00_-\ [$$-45C]"/>'+
				'<numFmt numFmtId="165" formatCode="&quot;£&quot;#,##0.00"/>'+
				'<numFmt numFmtId="166" formatCode="[$€-2]\ #,##0.00"/>'+
				'<numFmt numFmtId="167" formatCode="0.0%"/>'+
				'<numFmt numFmtId="168" formatCode="#,##0;(#,##0)"/>'+
				'<numFmt numFmtId="169" formatCode="#,##0.00;(#,##0.00)"/>'+
			'</numFmts>'+
			'<fonts count="5" x14ac:knownFonts="1">'+
				'<font>'+
					'<sz val="11" />'+
					'<name val="Calibri" />'+
				'</font>'+
				'<font>'+
					'<sz val="11" />'+
					'<name val="Calibri" />'+
					'<color rgb="FFFFFFFF" />'+
				'</font>'+
				'<font>'+
					'<sz val="11" />'+
					'<name val="Calibri" />'+
					'<b />'+
				'</font>'+
				'<font>'+
					'<sz val="11" />'+
					'<name val="Calibri" />'+
					'<i />'+
				'</font>'+
				'<font>'+
					'<sz val="11" />'+
					'<name val="Calibri" />'+
					'<u />'+
				'</font>'+
			'</fonts>'+
			'<fills count="6">'+
				'<fill>'+
					'<patternFill patternType="none" />'+
				'</fill>'+
				'<fill>'+ // Excel appears to use this as a dotted background regardless of values but
					'<patternFill patternType="none" />'+ // to be valid to the schema, use a patternFill
				'</fill>'+
				'<fill>'+
					'<patternFill patternType="solid">'+
						'<fgColor rgb="FFD9D9D9" />'+
						'<bgColor indexed="64" />'+
					'</patternFill>'+
				'</fill>'+
				'<fill>'+
					'<patternFill patternType="solid">'+
						'<fgColor rgb="FFD99795" />'+
						'<bgColor indexed="64" />'+
					'</patternFill>'+
				'</fill>'+
				'<fill>'+
					'<patternFill patternType="solid">'+
						'<fgColor rgb="ffc6efce" />'+
						'<bgColor indexed="64" />'+
					'</patternFill>'+
				'</fill>'+
				'<fill>'+
					'<patternFill patternType="solid">'+
						'<fgColor rgb="ffc6cfef" />'+
						'<bgColor indexed="64" />'+
					'</patternFill>'+
				'</fill>'+
			'</fills>'+
			'<borders count="2">'+
				'<border>'+
					'<left />'+
					'<right />'+
					'<top />'+
					'<bottom />'+
					'<diagonal />'+
				'</border>'+
				'<border diagonalUp="false" diagonalDown="false">'+
					'<left style="thin">'+
						'<color auto="1" />'+
					'</left>'+
					'<right style="thin">'+
						'<color auto="1" />'+
					'</right>'+
					'<top style="thin">'+
						'<color auto="1" />'+
					'</top>'+
					'<bottom style="thin">'+
						'<color auto="1" />'+
					'</bottom>'+
					'<diagonal />'+
				'</border>'+
			'</borders>'+
			'<cellStyleXfs count="1">'+
				'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" />'+
			'</cellStyleXfs>'+
			'<cellXfs count="61">'+
				'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="1" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="2" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="3" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="4" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="0" fillId="2" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="1" fillId="2" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="2" fillId="2" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="3" fillId="2" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="4" fillId="2" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="0" fillId="3" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="1" fillId="3" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="2" fillId="3" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="3" fillId="3" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="4" fillId="3" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="0" fillId="4" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="1" fillId="4" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="2" fillId="4" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="3" fillId="4" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="4" fillId="4" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="0" fillId="5" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="1" fillId="5" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="2" fillId="5" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="3" fillId="5" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="4" fillId="5" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="0" fillId="0" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="1" fillId="0" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="2" fillId="0" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="3" fillId="0" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="4" fillId="0" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="0" fillId="2" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="1" fillId="2" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="2" fillId="2" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="3" fillId="2" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="4" fillId="2" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="0" fillId="3" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="1" fillId="3" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="2" fillId="3" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="3" fillId="3" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="4" fillId="3" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="0" fillId="4" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="1" fillId="4" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="2" fillId="4" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="3" fillId="4" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="4" fillId="4" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="0" fillId="5" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="1" fillId="5" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="2" fillId="5" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="3" fillId="5" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="4" fillId="5" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
					'<alignment horizontal="left"/>'+
				'</xf>'+
				'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
					'<alignment horizontal="center"/>'+
				'</xf>'+
				'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
					'<alignment horizontal="right"/>'+
				'</xf>'+
				'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
					'<alignment horizontal="fill"/>'+
				'</xf>'+
				'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
					'<alignment textRotation="90"/>'+
				'</xf>'+
				'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
					'<alignment wrapText="1"/>'+
				'</xf>'+
				'<xf numFmtId="9"   fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
				'<xf numFmtId="164" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
				'<xf numFmtId="165" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
				'<xf numFmtId="166" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
				'<xf numFmtId="167" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
				'<xf numFmtId="168" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
				'<xf numFmtId="169" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
				'<xf numFmtId="3" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
				'<xf numFmtId="4" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
			'</cellXfs>'+
			'<cellStyles count="1">'+
				'<cellStyle name="Normal" xfId="0" builtinId="0" />'+
			'</cellStyles>'+
			'<dxfs count="0" />'+
			'<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4" />'+
		'</styleSheet>'
};
// Note we could use 3 `for` loops for the styles, but when gzipped there is
// virtually no difference in size, since the above can be easily compressed

// Pattern matching for special number formats. Perhaps this should be exposed
// via an API in future?
var _excelSpecials = [
	{ match: /^\-?\d+\.\d%$/,       style: 60, fmt: function (d) { return d/100; } }, // Precent with d.p.
	{ match: /^\-?\d+\.?\d*%$/,     style: 56, fmt: function (d) { return d/100; } }, // Percent
	{ match: /^\-?\$[\d,]+.?\d*$/,  style: 57 }, // Dollars
	{ match: /^\-?£[\d,]+.?\d*$/,   style: 58 }, // Pounds
	{ match: /^\-?€[\d,]+.?\d*$/,   style: 59 }, // Euros
	{ match: /^\([\d,]+\)$/,        style: 61, fmt: function (d) { return -1 * d.replace(/[\(\)]/g, ''); } },  // Negative numbers indicated by brackets
	{ match: /^\([\d,]+\.\d{2}\)$/, style: 62, fmt: function (d) { return -1 * d.replace(/[\(\)]/g, ''); } },  // Negative numbers indicated by brackets - 2d.p.
	{ match: /^[\d,]+$/,            style: 63 }, // Numbers with thousand separators
	{ match: /^[\d,]+\.\d{2}$/,     style: 64 }  // Numbers with 2d.p. and thousands separators
];



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * DataTables options and methods
 */

// Set the default SWF path
DataTable.Buttons.swfPath = '//cdn.datatables.net/buttons/'+DataTable.Buttons.version+'/swf/flashExport.swf';

// Method to allow Flash buttons to be resized when made visible - as they are
// of zero height and width if initialised hidden
DataTable.Api.register( 'buttons.resize()', function () {
	$.each( ZeroClipboard_TableTools.clients, function ( i, client ) {
		if ( client.domElement !== undefined && client.domElement.parentNode ) {
			client.positionElement();
		}
	} );
} );


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Button definitions
 */

// Copy to clipboard
DataTable.ext.buttons.copyFlash = $.extend( {}, flashButton, {
	className: 'buttons-copy buttons-flash',

	text: function ( dt ) {
		return dt.i18n( 'buttons.copy', 'Copy' );
	},

	action: function ( e, dt, button, config ) {
		// Check that the trigger did actually occur due to a Flash activation
		if ( ! config._fromFlash ) {
			return;
		}

		this.processing( true );

		var flash = config._flash;
		var exportData = _exportData( dt, config );
		var info = dt.buttons.exportInfo( config );
		var newline = _newLine(config);
		var output = exportData.str;

		if ( info.title ) {
			output = info.title + newline + newline + output;
		}

		if ( info.messageTop ) {
			output = info.messageTop + newline + newline + output;
		}

		if ( info.messageBottom ) {
			output = output + newline + newline + info.messageBottom;
		}

		if ( config.customize ) {
			output = config.customize( output, config, dt );
		}

		flash.setAction( 'copy' );
		_setText( flash, output );

		this.processing( false );

		dt.buttons.info(
			dt.i18n( 'buttons.copyTitle', 'Copy to clipboard' ),
			dt.i18n( 'buttons.copySuccess', {
				_: 'Copied %d rows to clipboard',
				1: 'Copied 1 row to clipboard'
			}, data.rows ),
			3000
		);
	},

	fieldSeparator: '\t',

	fieldBoundary: ''
} );

// CSV save file
DataTable.ext.buttons.csvFlash = $.extend( {}, flashButton, {
	className: 'buttons-csv buttons-flash',

	text: function ( dt ) {
		return dt.i18n( 'buttons.csv', 'CSV' );
	},

	action: function ( e, dt, button, config ) {
		// Set the text
		var flash = config._flash;
		var data = _exportData( dt, config );
		var info = dt.buttons.exportInfo( config );
		var output = config.customize ?
			config.customize( data.str, config, dt ) :
			data.str;

		flash.setAction( 'csv' );
		flash.setFileName( info.filename );
		_setText( flash, output );
	},

	escapeChar: '"'
} );

// Excel save file - this is really a CSV file using UTF-8 that Excel can read
DataTable.ext.buttons.excelFlash = $.extend( {}, flashButton, {
	className: 'buttons-excel buttons-flash',

	text: function ( dt ) {
		return dt.i18n( 'buttons.excel', 'Excel' );
	},

	action: function ( e, dt, button, config ) {
		this.processing( true );

		var flash = config._flash;
		var rowPos = 0;
		var rels = $.parseXML( excelStrings['xl/worksheets/sheet1.xml'] ) ; //Parses xml
		var relsGet = rels.getElementsByTagName( "sheetData" )[0];

		var xlsx = {
			_rels: {
				".rels": $.parseXML( excelStrings['_rels/.rels'] )
			},
			xl: {
				_rels: {
					"workbook.xml.rels": $.parseXML( excelStrings['xl/_rels/workbook.xml.rels'] )
				},
				"workbook.xml": $.parseXML( excelStrings['xl/workbook.xml'] ),
				"styles.xml": $.parseXML( excelStrings['xl/styles.xml'] ),
				"worksheets": {
					"sheet1.xml": rels
				}

			},
			"[Content_Types].xml": $.parseXML( excelStrings['[Content_Types].xml'])
		};

		var data = dt.buttons.exportData( config.exportOptions );
		var currentRow, rowNode;
		var addRow = function ( row ) {
			currentRow = rowPos+1;
			rowNode = _createNode( rels, "row", { attr: {r:currentRow} } );

			for ( var i=0, ien=row.length ; i<ien ; i++ ) {
				// Concat both the Cell Columns as a letter and the Row of the cell.
				var cellId = createCellPos(i) + '' + currentRow;
				var cell = null;

				// For null, undefined of blank cell, continue so it doesn't create the _createNode
				if ( row[i] === null || row[i] === undefined || row[i] === '' ) {
					if ( config.createEmptyCells === true ) {
						row[i] = '';
					}
					else {
						continue;
					}
				}

				row[i] = typeof row[i].trim === 'function'
					? row[i].trim()
					: row[i];

				// Special number formatting options
				for ( var j=0, jen=_excelSpecials.length ; j<jen ; j++ ) {
					var special = _excelSpecials[j];

					// TODO Need to provide the ability for the specials to say
					// if they are returning a string, since at the moment it is
					// assumed to be a number
					if ( row[i].match && ! row[i].match(/^0\d+/) && row[i].match( special.match ) ) {
						var val = row[i].replace(/[^\d\.\-]/g, '');

						if ( special.fmt ) {
							val = special.fmt( val );
						}

						cell = _createNode( rels, 'c', {
							attr: {
								r: cellId,
								s: special.style
							},
							children: [
								_createNode( rels, 'v', { text: val } )
							]
						} );

						break;
					}
				}

				if ( ! cell ) {
					if ( typeof row[i] === 'number' || (
						row[i].match &&
						row[i].match(/^-?\d+(\.\d+)?$/) &&
						! row[i].match(/^0\d+/) )
					) {
						// Detect numbers - don't match numbers with leading zeros
						// or a negative anywhere but the start
						cell = _createNode( rels, 'c', {
							attr: {
								t: 'n',
								r: cellId
							},
							children: [
								_createNode( rels, 'v', { text: row[i] } )
							]
						} );
					}
					else {
						// String output - replace non standard characters for text output
						var text = ! row[i].replace ?
							row[i] :
							row[i].replace(/[\x00-\x09\x0B\x0C\x0E-\x1F\x7F-\x9F]/g, '');

						cell = _createNode( rels, 'c', {
							attr: {
								t: 'inlineStr',
								r: cellId
							},
							children:{
								row: _createNode( rels, 'is', {
									children: {
										row: _createNode( rels, 't', {
											text: text
										} )
									}
								} )
							}
						} );
					}
				}

				rowNode.appendChild( cell );
			}

			relsGet.appendChild(rowNode);
			rowPos++;
		};

		$( 'sheets sheet', xlsx.xl['workbook.xml'] ).attr( 'name', _sheetname( config ) );

		if ( config.customizeData ) {
			config.customizeData( data );
		}

		var mergeCells = function ( row, colspan ) {
			var mergeCells = $('mergeCells', rels);

			mergeCells[0].appendChild( _createNode( rels, 'mergeCell', {
				attr: {
					ref: 'A'+row+':'+createCellPos(colspan)+row
				}
			} ) );
			mergeCells.attr( 'count', mergeCells.attr( 'count' )+1 );
			$('row:eq('+(row-1)+') c', rels).attr( 's', '51' ); // centre
		};

		// Title and top messages
		var exportInfo = dt.buttons.exportInfo( config );
		if ( exportInfo.title ) {
			addRow( [exportInfo.title], rowPos );
			mergeCells( rowPos, data.header.length-1 );
		}

		if ( exportInfo.messageTop ) {
			addRow( [exportInfo.messageTop], rowPos );
			mergeCells( rowPos, data.header.length-1 );
		}

		// Table itself
		if ( config.header ) {
			addRow( data.header, rowPos );
			$('row:last c', rels).attr( 's', '2' ); // bold
		}

		for ( var n=0, ie=data.body.length ; n<ie ; n++ ) {
			addRow( data.body[n], rowPos );
		}

		if ( config.footer && data.footer ) {
			addRow( data.footer, rowPos);
			$('row:last c', rels).attr( 's', '2' ); // bold
		}

		// Below the table
		if ( exportInfo.messageBottom ) {
			addRow( [exportInfo.messageBottom], rowPos );
			mergeCells( rowPos, data.header.length-1 );
		}

		// Set column widths
		var cols = _createNode( rels, 'cols' );
		$('worksheet', rels).prepend( cols );

		for ( var i=0, ien=data.header.length ; i<ien ; i++ ) {
			cols.appendChild( _createNode( rels, 'col', {
				attr: {
					min: i+1,
					max: i+1,
					width: _excelColWidth( data, i ),
					customWidth: 1
				}
			} ) );
		}

		// Let the developer customise the document if they want to
		if ( config.customize ) {
			config.customize( xlsx, config, dt );
		}

		_xlsxToStrings( xlsx );

		flash.setAction( 'excel' );
		flash.setFileName( exportInfo.filename );
		flash.setSheetData( xlsx );
		_setText( flash, '' );

		this.processing( false );
	},

	extension: '.xlsx',
	
	createEmptyCells: false
} );



// PDF export
DataTable.ext.buttons.pdfFlash = $.extend( {}, flashButton, {
	className: 'buttons-pdf buttons-flash',

	text: function ( dt ) {
		return dt.i18n( 'buttons.pdf', 'PDF' );
	},

	action: function ( e, dt, button, config ) {
		this.processing( true );

		// Set the text
		var flash = config._flash;
		var data = dt.buttons.exportData( config.exportOptions );
		var info = dt.buttons.exportInfo( config );
		var totalWidth = dt.table().node().offsetWidth;

		// Calculate the column width ratios for layout of the table in the PDF
		var ratios = dt.columns( config.columns ).indexes().map( function ( idx ) {
			return dt.column( idx ).header().offsetWidth / totalWidth;
		} );

		flash.setAction( 'pdf' );
		flash.setFileName( info.filename );

		_setText( flash, JSON.stringify( {
			title:         info.title || '',
			messageTop:    info.messageTop || '',
			messageBottom: info.messageBottom || '',
			colWidth:      ratios.toArray(),
			orientation:   config.orientation,
			size:          config.pageSize,
			header:        config.header ? data.header : null,
			footer:        config.footer ? data.footer : null,
			body:          data.body
		} ) );

		this.processing( false );
	},

	extension: '.pdf',

	orientation: 'portrait',

	pageSize: 'A4',

	newline: '\n'
} );


return DataTable.Buttons;
}));

/*!
 * HTML5 export buttons for Buttons and DataTables.
 * 2016 SpryMedia Ltd - datatables.net/license
 *
 * FileSaver.js (1.3.3) - MIT license
 * Copyright © 2016 Eli Grey - http://eligrey.com
 */

(function( factory ){
	if ( typeof define === 'function' && define.amd ) {
		// AMD
		define( ['jquery', 'datatables.net', 'datatables.net-buttons'], function ( $ ) {
			return factory( $, window, document );
		} );
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $, jszip, pdfmake) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net')(root, $).$;
			}

			if ( ! $.fn.dataTable.Buttons ) {
				require('datatables.net-buttons')(root, $);
			}

			return factory( $, root, root.document, jszip, pdfmake );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, jszip, pdfmake, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;

// Allow the constructor to pass in JSZip and PDFMake from external requires.
// Otherwise, use globally defined variables, if they are available.
function _jsZip () {
	return jszip || window.JSZip;
}
function _pdfMake () {
	return pdfmake || window.pdfMake;
}

DataTable.Buttons.pdfMake = function (_) {
	if ( ! _ ) {
		return _pdfMake();
	}
	pdfmake = _;
}

DataTable.Buttons.jszip = function (_) {
	if ( ! _ ) {
		return _jsZip();
	}
	jszip = _;
}


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * FileSaver.js dependency
 */

/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

var _saveAs = (function(view) {
	"use strict";
	// IE <10 is explicitly unsupported
	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var
		  doc = view.document
		  // only get URL when necessary in case Blob.js hasn't overridden it yet
		, get_URL = function() {
			return view.URL || view.webkitURL || view;
		}
		, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
		, can_use_save_link = "download" in save_link
		, click = function(node) {
			var event = new MouseEvent("click");
			node.dispatchEvent(event);
		}
		, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
		, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
		, throw_outside = function(ex) {
			(view.setImmediate || view.setTimeout)(function() {
				throw ex;
			}, 0);
		}
		, force_saveable_type = "application/octet-stream"
		// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
		, arbitrary_revoke_timeout = 1000 * 40 // in ms
		, revoke = function(file) {
			var revoker = function() {
				if (typeof file === "string") { // file is an object URL
					get_URL().revokeObjectURL(file);
				} else { // file is a File
					file.remove();
				}
			};
			setTimeout(revoker, arbitrary_revoke_timeout);
		}
		, dispatch = function(filesaver, event_types, event) {
			event_types = [].concat(event_types);
			var i = event_types.length;
			while (i--) {
				var listener = filesaver["on" + event_types[i]];
				if (typeof listener === "function") {
					try {
						listener.call(filesaver, event || filesaver);
					} catch (ex) {
						throw_outside(ex);
					}
				}
			}
		}
		, auto_bom = function(blob) {
			// prepend BOM for UTF-8 XML and text/* types (including HTML)
			// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
			if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
				return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
			}
			return blob;
		}
		, FileSaver = function(blob, name, no_auto_bom) {
			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			// First try a.download, then web filesystem, then object URLs
			var
				  filesaver = this
				, type = blob.type
				, force = type === force_saveable_type
				, object_url
				, dispatch_all = function() {
					dispatch(filesaver, "writestart progress write writeend".split(" "));
				}
				// on any filesys errors revert to saving with object URLs
				, fs_error = function() {
					if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
						// Safari doesn't allow downloading of blob urls
						var reader = new FileReader();
						reader.onloadend = function() {
							var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
							var popup = view.open(url, '_blank');
							if(!popup) view.location.href = url;
							url=undefined; // release reference before dispatching
							filesaver.readyState = filesaver.DONE;
							dispatch_all();
						};
						reader.readAsDataURL(blob);
						filesaver.readyState = filesaver.INIT;
						return;
					}
					// don't create more object URLs than needed
					if (!object_url) {
						object_url = get_URL().createObjectURL(blob);
					}
					if (force) {
						view.location.href = object_url;
					} else {
						var opened = view.open(object_url, "_blank");
						if (!opened) {
							// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
							view.location.href = object_url;
						}
					}
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
					revoke(object_url);
				}
			;
			filesaver.readyState = filesaver.INIT;

			if (can_use_save_link) {
				object_url = get_URL().createObjectURL(blob);
				setTimeout(function() {
					save_link.href = object_url;
					save_link.download = name;
					click(save_link);
					dispatch_all();
					revoke(object_url);
					filesaver.readyState = filesaver.DONE;
				});
				return;
			}

			fs_error();
		}
		, FS_proto = FileSaver.prototype
		, saveAs = function(blob, name, no_auto_bom) {
			return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
		}
	;
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function(blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function(){};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error =
	FS_proto.onwritestart =
	FS_proto.onprogress =
	FS_proto.onwrite =
	FS_proto.onabort =
	FS_proto.onerror =
	FS_proto.onwriteend =
		null;

	return saveAs;
}(
	   typeof self !== "undefined" && self
	|| typeof window !== "undefined" && window
	|| this.content
));


// Expose file saver on the DataTables API. Can't attach to `DataTables.Buttons`
// since this file can be loaded before Button's core!
DataTable.fileSave = _saveAs;


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Local (private) functions
 */

/**
 * Get the sheet name for Excel exports.
 *
 * @param {object}	config Button configuration
 */
var _sheetname = function ( config )
{
	var sheetName = 'Sheet1';

	if ( config.sheetName ) {
		sheetName = config.sheetName.replace(/[\[\]\*\/\\\?\:]/g, '');
	}

	return sheetName;
};

/**
 * Get the newline character(s)
 *
 * @param {object}	config Button configuration
 * @return {string}				Newline character
 */
var _newLine = function ( config )
{
	return config.newline ?
		config.newline :
		navigator.userAgent.match(/Windows/) ?
			'\r\n' :
			'\n';
};

/**
 * Combine the data from the `buttons.exportData` method into a string that
 * will be used in the export file.
 *
 * @param	{DataTable.Api} dt		 DataTables API instance
 * @param	{object}				config Button configuration
 * @return {object}							 The data to export
 */
var _exportData = function ( dt, config )
{
	var newLine = _newLine( config );
	var data = dt.buttons.exportData( config.exportOptions );
	var boundary = config.fieldBoundary;
	var separator = config.fieldSeparator;
	var reBoundary = new RegExp( boundary, 'g' );
	var escapeChar = config.escapeChar !== undefined ?
		config.escapeChar :
		'\\';
	var join = function ( a ) {
		var s = '';

		// If there is a field boundary, then we might need to escape it in
		// the source data
		for ( var i=0, ien=a.length ; i<ien ; i++ ) {
			if ( i > 0 ) {
				s += separator;
			}

			s += boundary ?
				boundary + ('' + a[i]).replace( reBoundary, escapeChar+boundary ) + boundary :
				a[i];
		}

		return s;
	};

	var header = config.header ? join( data.header )+newLine : '';
	var footer = config.footer && data.footer ? newLine+join( data.footer ) : '';
	var body = [];

	for ( var i=0, ien=data.body.length ; i<ien ; i++ ) {
		body.push( join( data.body[i] ) );
	}

	return {
		str: header + body.join( newLine ) + footer,
		rows: body.length
	};
};

/**
 * Older versions of Safari (prior to tech preview 18) don't support the
 * download option required.
 *
 * @return {Boolean} `true` if old Safari
 */
var _isDuffSafari = function ()
{
	var safari = navigator.userAgent.indexOf('Safari') !== -1 &&
		navigator.userAgent.indexOf('Chrome') === -1 &&
		navigator.userAgent.indexOf('Opera') === -1;

	if ( ! safari ) {
		return false;
	}

	var version = navigator.userAgent.match( /AppleWebKit\/(\d+\.\d+)/ );
	if ( version && version.length > 1 && version[1]*1 < 603.1 ) {
		return true;
	}

	return false;
};

/**
 * Convert from numeric position to letter for column names in Excel
 * @param  {int} n Column number
 * @return {string} Column letter(s) name
 */
function createCellPos( n ){
	var ordA = 'A'.charCodeAt(0);
	var ordZ = 'Z'.charCodeAt(0);
	var len = ordZ - ordA + 1;
	var s = "";

	while( n >= 0 ) {
		s = String.fromCharCode(n % len + ordA) + s;
		n = Math.floor(n / len) - 1;
	}

	return s;
}

try {
	var _serialiser = new XMLSerializer();
	var _ieExcel;
}
catch (t) {}

/**
 * Recursively add XML files from an object's structure to a ZIP file. This
 * allows the XSLX file to be easily defined with an object's structure matching
 * the files structure.
 *
 * @param {JSZip} zip ZIP package
 * @param {object} obj Object to add (recursive)
 */
function _addToZip( zip, obj ) {
	if ( _ieExcel === undefined ) {
		// Detect if we are dealing with IE's _awful_ serialiser by seeing if it
		// drop attributes
		_ieExcel = _serialiser
			.serializeToString(
				( new window.DOMParser() ).parseFromString( excelStrings['xl/worksheets/sheet1.xml'], 'text/xml' )
			)
			.indexOf( 'xmlns:r' ) === -1;
	}

	$.each( obj, function ( name, val ) {
		if ( $.isPlainObject( val ) ) {
			var newDir = zip.folder( name );
			_addToZip( newDir, val );
		}
		else {
			if ( _ieExcel ) {
				// IE's XML serialiser will drop some name space attributes from
				// from the root node, so we need to save them. Do this by
				// replacing the namespace nodes with a regular attribute that
				// we convert back when serialised. Edge does not have this
				// issue
				var worksheet = val.childNodes[0];
				var i, ien;
				var attrs = [];

				for ( i=worksheet.attributes.length-1 ; i>=0 ; i-- ) {
					var attrName = worksheet.attributes[i].nodeName;
					var attrValue = worksheet.attributes[i].nodeValue;

					if ( attrName.indexOf( ':' ) !== -1 ) {
						attrs.push( { name: attrName, value: attrValue } );

						worksheet.removeAttribute( attrName );
					}
				}

				for ( i=0, ien=attrs.length ; i<ien ; i++ ) {
					var attr = val.createAttribute( attrs[i].name.replace( ':', '_dt_b_namespace_token_' ) );
					attr.value = attrs[i].value;
					worksheet.setAttributeNode( attr );
				}
			}

			var str = _serialiser.serializeToString(val);

			// Fix IE's XML
			if ( _ieExcel ) {
				// IE doesn't include the XML declaration
				if ( str.indexOf( '<?xml' ) === -1 ) {
					str = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'+str;
				}

				// Return namespace attributes to being as such
				str = str.replace( /_dt_b_namespace_token_/g, ':' );

				// Remove testing name space that IE puts into the space preserve attr
				str = str.replace( /xmlns:NS[\d]+="" NS[\d]+:/g, '' );
			}

			// Safari, IE and Edge will put empty name space attributes onto
			// various elements making them useless. This strips them out
			str = str.replace( /<([^<>]*?) xmlns=""([^<>]*?)>/g, '<$1 $2>' );

			zip.file( name, str );
		}
	} );
}

/**
 * Create an XML node and add any children, attributes, etc without needing to
 * be verbose in the DOM.
 *
 * @param  {object} doc      XML document
 * @param  {string} nodeName Node name
 * @param  {object} opts     Options - can be `attr` (attributes), `children`
 *   (child nodes) and `text` (text content)
 * @return {node}            Created node
 */
function _createNode( doc, nodeName, opts ) {
	var tempNode = doc.createElement( nodeName );

	if ( opts ) {
		if ( opts.attr ) {
			$(tempNode).attr( opts.attr );
		}

		if ( opts.children ) {
			$.each( opts.children, function ( key, value ) {
				tempNode.appendChild( value );
			} );
		}

		if ( opts.text !== null && opts.text !== undefined ) {
			tempNode.appendChild( doc.createTextNode( opts.text ) );
		}
	}

	return tempNode;
}

/**
 * Get the width for an Excel column based on the contents of that column
 * @param  {object} data Data for export
 * @param  {int}    col  Column index
 * @return {int}         Column width
 */
function _excelColWidth( data, col ) {
	var max = data.header[col].length;
	var len, lineSplit, str;

	if ( data.footer && data.footer[col].length > max ) {
		max = data.footer[col].length;
	}

	for ( var i=0, ien=data.body.length ; i<ien ; i++ ) {
		var point = data.body[i][col];
		str = point !== null && point !== undefined ?
			point.toString() :
			'';

		// If there is a newline character, workout the width of the column
		// based on the longest line in the string
		if ( str.indexOf('\n') !== -1 ) {
			lineSplit = str.split('\n');
			lineSplit.sort( function (a, b) {
				return b.length - a.length;
			} );

			len = lineSplit[0].length;
		}
		else {
			len = str.length;
		}

		if ( len > max ) {
			max = len;
		}

		// Max width rather than having potentially massive column widths
		if ( max > 40 ) {
			return 54; // 40 * 1.35
		}
	}

	max *= 1.35;

	// And a min width
	return max > 6 ? max : 6;
}

// Excel - Pre-defined strings to build a basic XLSX file
var excelStrings = {
	"_rels/.rels":
		'<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'+
		'<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">'+
			'<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/>'+
		'</Relationships>',

	"xl/_rels/workbook.xml.rels":
		'<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'+
		'<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">'+
			'<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet1.xml"/>'+
			'<Relationship Id="rId2" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/>'+
		'</Relationships>',

	"[Content_Types].xml":
		'<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'+
		'<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">'+
			'<Default Extension="xml" ContentType="application/xml" />'+
			'<Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml" />'+
			'<Default Extension="jpeg" ContentType="image/jpeg" />'+
			'<Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml" />'+
			'<Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml" />'+
			'<Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml" />'+
		'</Types>',

	"xl/workbook.xml":
		'<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'+
		'<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">'+
			'<fileVersion appName="xl" lastEdited="5" lowestEdited="5" rupBuild="24816"/>'+
			'<workbookPr showInkAnnotation="0" autoCompressPictures="0"/>'+
			'<bookViews>'+
				'<workbookView xWindow="0" yWindow="0" windowWidth="25600" windowHeight="19020" tabRatio="500"/>'+
			'</bookViews>'+
			'<sheets>'+
				'<sheet name="Sheet1" sheetId="1" r:id="rId1"/>'+
			'</sheets>'+
			'<definedNames/>'+
		'</workbook>',

	"xl/worksheets/sheet1.xml":
		'<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'+
		'<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac">'+
			'<sheetData/>'+
			'<mergeCells count="0"/>'+
		'</worksheet>',

	"xl/styles.xml":
		'<?xml version="1.0" encoding="UTF-8"?>'+
		'<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" mc:Ignorable="x14ac" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac">'+
			'<numFmts count="6">'+
				'<numFmt numFmtId="164" formatCode="#,##0.00_-\ [$$-45C]"/>'+
				'<numFmt numFmtId="165" formatCode="&quot;£&quot;#,##0.00"/>'+
				'<numFmt numFmtId="166" formatCode="[$€-2]\ #,##0.00"/>'+
				'<numFmt numFmtId="167" formatCode="0.0%"/>'+
				'<numFmt numFmtId="168" formatCode="#,##0;(#,##0)"/>'+
				'<numFmt numFmtId="169" formatCode="#,##0.00;(#,##0.00)"/>'+
			'</numFmts>'+
			'<fonts count="5" x14ac:knownFonts="1">'+
				'<font>'+
					'<sz val="11" />'+
					'<name val="Calibri" />'+
				'</font>'+
				'<font>'+
					'<sz val="11" />'+
					'<name val="Calibri" />'+
					'<color rgb="FFFFFFFF" />'+
				'</font>'+
				'<font>'+
					'<sz val="11" />'+
					'<name val="Calibri" />'+
					'<b />'+
				'</font>'+
				'<font>'+
					'<sz val="11" />'+
					'<name val="Calibri" />'+
					'<i />'+
				'</font>'+
				'<font>'+
					'<sz val="11" />'+
					'<name val="Calibri" />'+
					'<u />'+
				'</font>'+
			'</fonts>'+
			'<fills count="6">'+
				'<fill>'+
					'<patternFill patternType="none" />'+
				'</fill>'+
				'<fill>'+ // Excel appears to use this as a dotted background regardless of values but
					'<patternFill patternType="none" />'+ // to be valid to the schema, use a patternFill
				'</fill>'+
				'<fill>'+
					'<patternFill patternType="solid">'+
						'<fgColor rgb="FFD9D9D9" />'+
						'<bgColor indexed="64" />'+
					'</patternFill>'+
				'</fill>'+
				'<fill>'+
					'<patternFill patternType="solid">'+
						'<fgColor rgb="FFD99795" />'+
						'<bgColor indexed="64" />'+
					'</patternFill>'+
				'</fill>'+
				'<fill>'+
					'<patternFill patternType="solid">'+
						'<fgColor rgb="ffc6efce" />'+
						'<bgColor indexed="64" />'+
					'</patternFill>'+
				'</fill>'+
				'<fill>'+
					'<patternFill patternType="solid">'+
						'<fgColor rgb="ffc6cfef" />'+
						'<bgColor indexed="64" />'+
					'</patternFill>'+
				'</fill>'+
			'</fills>'+
			'<borders count="2">'+
				'<border>'+
					'<left />'+
					'<right />'+
					'<top />'+
					'<bottom />'+
					'<diagonal />'+
				'</border>'+
				'<border diagonalUp="false" diagonalDown="false">'+
					'<left style="thin">'+
						'<color auto="1" />'+
					'</left>'+
					'<right style="thin">'+
						'<color auto="1" />'+
					'</right>'+
					'<top style="thin">'+
						'<color auto="1" />'+
					'</top>'+
					'<bottom style="thin">'+
						'<color auto="1" />'+
					'</bottom>'+
					'<diagonal />'+
				'</border>'+
			'</borders>'+
			'<cellStyleXfs count="1">'+
				'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" />'+
			'</cellStyleXfs>'+
			'<cellXfs count="68">'+
				'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="1" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="2" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="3" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="4" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="0" fillId="2" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="1" fillId="2" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="2" fillId="2" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="3" fillId="2" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="4" fillId="2" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="0" fillId="3" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="1" fillId="3" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="2" fillId="3" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="3" fillId="3" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="4" fillId="3" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="0" fillId="4" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="1" fillId="4" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="2" fillId="4" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="3" fillId="4" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="4" fillId="4" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="0" fillId="5" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="1" fillId="5" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="2" fillId="5" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="3" fillId="5" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="4" fillId="5" borderId="0" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="0" fillId="0" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="1" fillId="0" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="2" fillId="0" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="3" fillId="0" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="4" fillId="0" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="0" fillId="2" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="1" fillId="2" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="2" fillId="2" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="3" fillId="2" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="4" fillId="2" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="0" fillId="3" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="1" fillId="3" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="2" fillId="3" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="3" fillId="3" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="4" fillId="3" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="0" fillId="4" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="1" fillId="4" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="2" fillId="4" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="3" fillId="4" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="4" fillId="4" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="0" fillId="5" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="1" fillId="5" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="2" fillId="5" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="3" fillId="5" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="4" fillId="5" borderId="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
				'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
					'<alignment horizontal="left"/>'+
				'</xf>'+
				'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
					'<alignment horizontal="center"/>'+
				'</xf>'+
				'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
					'<alignment horizontal="right"/>'+
				'</xf>'+
				'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
					'<alignment horizontal="fill"/>'+
				'</xf>'+
				'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
					'<alignment textRotation="90"/>'+
				'</xf>'+
				'<xf numFmtId="0" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyAlignment="1">'+
					'<alignment wrapText="1"/>'+
				'</xf>'+
				'<xf numFmtId="9"   fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
				'<xf numFmtId="164" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
				'<xf numFmtId="165" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
				'<xf numFmtId="166" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
				'<xf numFmtId="167" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
				'<xf numFmtId="168" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
				'<xf numFmtId="169" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
				'<xf numFmtId="3" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
				'<xf numFmtId="4" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
				'<xf numFmtId="1" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
				'<xf numFmtId="2" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
				'<xf numFmtId="14" fontId="0" fillId="0" borderId="0" applyFont="1" applyFill="1" applyBorder="1" xfId="0" applyNumberFormat="1"/>'+
			'</cellXfs>'+
			'<cellStyles count="1">'+
				'<cellStyle name="Normal" xfId="0" builtinId="0" />'+
			'</cellStyles>'+
			'<dxfs count="0" />'+
			'<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4" />'+
		'</styleSheet>'
};
// Note we could use 3 `for` loops for the styles, but when gzipped there is
// virtually no difference in size, since the above can be easily compressed

// Pattern matching for special number formats. Perhaps this should be exposed
// via an API in future?
// Ref: section 3.8.30 - built in formatters in open spreadsheet
//   https://www.ecma-international.org/news/TC45_current_work/Office%20Open%20XML%20Part%204%20-%20Markup%20Language%20Reference.pdf
var _excelSpecials = [
	{ match: /^\-?\d+\.\d%$/,               style: 60, fmt: function (d) { return d/100; } }, // Precent with d.p.
	{ match: /^\-?\d+\.?\d*%$/,             style: 56, fmt: function (d) { return d/100; } }, // Percent
	{ match: /^\-?\$[\d,]+.?\d*$/,          style: 57 }, // Dollars
	{ match: /^\-?£[\d,]+.?\d*$/,           style: 58 }, // Pounds
	{ match: /^\-?€[\d,]+.?\d*$/,           style: 59 }, // Euros
	{ match: /^\-?\d+$/,                    style: 65 }, // Numbers without thousand separators
	{ match: /^\-?\d+\.\d{2}$/,             style: 66 }, // Numbers 2 d.p. without thousands separators
	{ match: /^\([\d,]+\)$/,                style: 61, fmt: function (d) { return -1 * d.replace(/[\(\)]/g, ''); } },  // Negative numbers indicated by brackets
	{ match: /^\([\d,]+\.\d{2}\)$/,         style: 62, fmt: function (d) { return -1 * d.replace(/[\(\)]/g, ''); } },  // Negative numbers indicated by brackets - 2d.p.
	{ match: /^\-?[\d,]+$/,                 style: 63 }, // Numbers with thousand separators
	{ match: /^\-?[\d,]+\.\d{2}$/,          style: 64 },
	{ match: /^[\d]{4}\-[\d]{2}\-[\d]{2}$/, style: 67, fmt: function (d) {return Math.round(25569 + (Date.parse(d) / (86400 * 1000)));}} //Date yyyy-mm-dd
];



/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Buttons
 */

//
// Copy to clipboard
//
DataTable.ext.buttons.copyHtml5 = {
	className: 'buttons-copy buttons-html5',

	text: function ( dt ) {
		return dt.i18n( 'buttons.copy', 'Copy' );
	},

	action: function ( e, dt, button, config ) {
		this.processing( true );

		var that = this;
		var exportData = _exportData( dt, config );
		var info = dt.buttons.exportInfo( config );
		var newline = _newLine(config);
		var output = exportData.str;
		var hiddenDiv = $('<div/>')
			.css( {
				height: 1,
				width: 1,
				overflow: 'hidden',
				position: 'fixed',
				top: 0,
				left: 0
			} );

		if ( info.title ) {
			output = info.title + newline + newline + output;
		}

		if ( info.messageTop ) {
			output = info.messageTop + newline + newline + output;
		}

		if ( info.messageBottom ) {
			output = output + newline + newline + info.messageBottom;
		}

		if ( config.customize ) {
			output = config.customize( output, config, dt );
		}

		var textarea = $('<textarea readonly/>')
			.val( output )
			.appendTo( hiddenDiv );

		// For browsers that support the copy execCommand, try to use it
		if ( document.queryCommandSupported('copy') ) {
			hiddenDiv.appendTo( dt.table().container() );
			textarea[0].focus();
			textarea[0].select();

			try {
				var successful = document.execCommand( 'copy' );
				hiddenDiv.remove();

				if (successful) {
					dt.buttons.info(
						dt.i18n( 'buttons.copyTitle', 'Copy to clipboard' ),
						dt.i18n( 'buttons.copySuccess', {
							1: 'Copied one row to clipboard',
							_: 'Copied %d rows to clipboard'
						}, exportData.rows ),
						2000
					);

					this.processing( false );
					return;
				}
			}
			catch (t) {}
		}

		// Otherwise we show the text box and instruct the user to use it
		var message = $('<span>'+dt.i18n( 'buttons.copyKeys',
				'Press <i>ctrl</i> or <i>\u2318</i> + <i>C</i> to copy the table data<br>to your system clipboard.<br><br>'+
				'To cancel, click this message or press escape.' )+'</span>'
			)
			.append( hiddenDiv );

		dt.buttons.info( dt.i18n( 'buttons.copyTitle', 'Copy to clipboard' ), message, 0 );

		// Select the text so when the user activates their system clipboard
		// it will copy that text
		textarea[0].focus();
		textarea[0].select();

		// Event to hide the message when the user is done
		var container = $(message).closest('.dt-button-info');
		var close = function () {
			container.off( 'click.buttons-copy' );
			$(document).off( '.buttons-copy' );
			dt.buttons.info( false );
		};

		container.on( 'click.buttons-copy', close );
		$(document)
			.on( 'keydown.buttons-copy', function (e) {
				if ( e.keyCode === 27 ) { // esc
					close();
					that.processing( false );
				}
			} )
			.on( 'copy.buttons-copy cut.buttons-copy', function () {
				close();
				that.processing( false );
			} );
	},

	exportOptions: {},

	fieldSeparator: '\t',

	fieldBoundary: '',

	header: true,

	footer: false,

	title: '*',

	messageTop: '*',

	messageBottom: '*'
};

//
// CSV export
//
DataTable.ext.buttons.csvHtml5 = {
	bom: false,

	className: 'buttons-csv buttons-html5',

	available: function () {
		return window.FileReader !== undefined && window.Blob;
	},

	text: function ( dt ) {
		return dt.i18n( 'buttons.csv', 'CSV' );
	},

	action: function ( e, dt, button, config ) {
		this.processing( true );

		// Set the text
		var output = _exportData( dt, config ).str;
		var info = dt.buttons.exportInfo(config);
		var charset = config.charset;

		if ( config.customize ) {
			output = config.customize( output, config, dt );
		}

		if ( charset !== false ) {
			if ( ! charset ) {
				charset = document.characterSet || document.charset;
			}

			if ( charset ) {
				charset = ';charset='+charset;
			}
		}
		else {
			charset = '';
		}

		if ( config.bom ) {
			output = String.fromCharCode(0xFEFF) + output;
		}

		_saveAs(
			new Blob( [output], {type: 'text/csv'+charset} ),
			info.filename,
			true
		);

		this.processing( false );
	},

	filename: '*',

	extension: '.csv',

	exportOptions: {},

	fieldSeparator: ',',

	fieldBoundary: '"',

	escapeChar: '"',

	charset: null,

	header: true,

	footer: false
};

//
// Excel (xlsx) export
//
DataTable.ext.buttons.excelHtml5 = {
	className: 'buttons-excel buttons-html5',

	available: function () {
		return window.FileReader !== undefined && _jsZip() !== undefined && ! _isDuffSafari() && _serialiser;
	},

	text: function ( dt ) {
		return dt.i18n( 'buttons.excel', 'Excel' );
	},

	action: function ( e, dt, button, config ) {
		this.processing( true );

		var that = this;
		var rowPos = 0;
		var dataStartRow, dataEndRow;
		var getXml = function ( type ) {
			var str = excelStrings[ type ];

			//str = str.replace( /xmlns:/g, 'xmlns_' ).replace( /mc:/g, 'mc_' );

			return $.parseXML( str );
		};
		var rels = getXml('xl/worksheets/sheet1.xml');
		var relsGet = rels.getElementsByTagName( "sheetData" )[0];

		var xlsx = {
			_rels: {
				".rels": getXml('_rels/.rels')
			},
			xl: {
				_rels: {
					"workbook.xml.rels": getXml('xl/_rels/workbook.xml.rels')
				},
				"workbook.xml": getXml('xl/workbook.xml'),
				"styles.xml": getXml('xl/styles.xml'),
				"worksheets": {
					"sheet1.xml": rels
				}

			},
			"[Content_Types].xml": getXml('[Content_Types].xml')
		};

		var data = dt.buttons.exportData( config.exportOptions );
		var currentRow, rowNode;
		var addRow = function ( row ) {
			currentRow = rowPos+1;
			rowNode = _createNode( rels, "row", { attr: {r:currentRow} } );

			for ( var i=0, ien=row.length ; i<ien ; i++ ) {
				// Concat both the Cell Columns as a letter and the Row of the cell.
				var cellId = createCellPos(i) + '' + currentRow;
				var cell = null;

				// For null, undefined of blank cell, continue so it doesn't create the _createNode
				if ( row[i] === null || row[i] === undefined || row[i] === '' ) {
					if ( config.createEmptyCells === true ) {
						row[i] = '';
					}
					else {
						continue;
					}
				}

				var originalContent = row[i];
				row[i] = typeof row[i].trim === 'function'
					? row[i].trim()
					: row[i];

				// Special number formatting options
				for ( var j=0, jen=_excelSpecials.length ; j<jen ; j++ ) {
					var special = _excelSpecials[j];

					// TODO Need to provide the ability for the specials to say
					// if they are returning a string, since at the moment it is
					// assumed to be a number
					if ( row[i].match && ! row[i].match(/^0\d+/) && row[i].match( special.match ) ) {
						var val = row[i].replace(/[^\d\.\-]/g, '');

						if ( special.fmt ) {
							val = special.fmt( val );
						}

						cell = _createNode( rels, 'c', {
							attr: {
								r: cellId,
								s: special.style
							},
							children: [
								_createNode( rels, 'v', { text: val } )
							]
						} );

						break;
					}
				}

				if ( ! cell ) {
					if ( typeof row[i] === 'number' || (
						row[i].match &&
						row[i].match(/^-?\d+(\.\d+)?$/) &&
						! row[i].match(/^0\d+/) )
					) {
						// Detect numbers - don't match numbers with leading zeros
						// or a negative anywhere but the start
						cell = _createNode( rels, 'c', {
							attr: {
								t: 'n',
								r: cellId
							},
							children: [
								_createNode( rels, 'v', { text: row[i] } )
							]
						} );
					}
					else {
						// String output - replace non standard characters for text output
						var text = ! originalContent.replace ?
							originalContent :
							originalContent.replace(/[\x00-\x09\x0B\x0C\x0E-\x1F\x7F-\x9F]/g, '');

						cell = _createNode( rels, 'c', {
							attr: {
								t: 'inlineStr',
								r: cellId
							},
							children:{
								row: _createNode( rels, 'is', {
									children: {
										row: _createNode( rels, 't', {
											text: text,
											attr: {
												'xml:space': 'preserve'
											}
										} )
									}
								} )
							}
						} );
					}
				}

				rowNode.appendChild( cell );
			}

			relsGet.appendChild(rowNode);
			rowPos++;
		};

		if ( config.customizeData ) {
			config.customizeData( data );
		}

		var mergeCells = function ( row, colspan ) {
			var mergeCells = $('mergeCells', rels);

			mergeCells[0].appendChild( _createNode( rels, 'mergeCell', {
				attr: {
					ref: 'A'+row+':'+createCellPos(colspan)+row
				}
			} ) );
			mergeCells.attr( 'count', parseFloat(mergeCells.attr( 'count' ))+1 );
			$('row:eq('+(row-1)+') c', rels).attr( 's', '51' ); // centre
		};

		// Title and top messages
		var exportInfo = dt.buttons.exportInfo( config );
		if ( exportInfo.title ) {
			addRow( [exportInfo.title], rowPos );
			mergeCells( rowPos, data.header.length-1 );
		}

		if ( exportInfo.messageTop ) {
			addRow( [exportInfo.messageTop], rowPos );
			mergeCells( rowPos, data.header.length-1 );
		}


		// Table itself
		if ( config.header ) {
			addRow( data.header, rowPos );
			$('row:last c', rels).attr( 's', '2' ); // bold
		}
	
		dataStartRow = rowPos;

		for ( var n=0, ie=data.body.length ; n<ie ; n++ ) {
			addRow( data.body[n], rowPos );
		}
	
		dataEndRow = rowPos;

		if ( config.footer && data.footer ) {
			addRow( data.footer, rowPos);
			$('row:last c', rels).attr( 's', '2' ); // bold
		}

		// Below the table
		if ( exportInfo.messageBottom ) {
			addRow( [exportInfo.messageBottom], rowPos );
			mergeCells( rowPos, data.header.length-1 );
		}

		// Set column widths
		var cols = _createNode( rels, 'cols' );
		$('worksheet', rels).prepend( cols );

		for ( var i=0, ien=data.header.length ; i<ien ; i++ ) {
			cols.appendChild( _createNode( rels, 'col', {
				attr: {
					min: i+1,
					max: i+1,
					width: _excelColWidth( data, i ),
					customWidth: 1
				}
			} ) );
		}

		// Workbook modifications
		var workbook = xlsx.xl['workbook.xml'];

		$( 'sheets sheet', workbook ).attr( 'name', _sheetname( config ) );

		// Auto filter for columns
		if ( config.autoFilter ) {
			$('mergeCells', rels).before( _createNode( rels, 'autoFilter', {
				attr: {
					ref: 'A'+dataStartRow+':'+createCellPos(data.header.length-1)+dataEndRow
				}
			} ) );

			$('definedNames', workbook).append( _createNode( workbook, 'definedName', {
				attr: {
					name: '_xlnm._FilterDatabase',
					localSheetId: '0',
					hidden: 1
				},
				text: _sheetname(config)+'!$A$'+dataStartRow+':'+createCellPos(data.header.length-1)+dataEndRow
			} ) );
		}

		// Let the developer customise the document if they want to
		if ( config.customize ) {
			config.customize( xlsx, config, dt );
		}

		// Excel doesn't like an empty mergeCells tag
		if ( $('mergeCells', rels).children().length === 0 ) {
			$('mergeCells', rels).remove();
		}

		var jszip = _jsZip();
		var zip = new jszip();
		var zipConfig = {
			type: 'blob',
			mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
		};

		_addToZip( zip, xlsx );

		if ( zip.generateAsync ) {
			// JSZip 3+
			zip
				.generateAsync( zipConfig )
				.then( function ( blob ) {
					_saveAs( blob, exportInfo.filename );
					that.processing( false );
				} );
		}
		else {
			// JSZip 2.5
			_saveAs(
				zip.generate( zipConfig ),
				exportInfo.filename
			);
			this.processing( false );
		}
	},

	filename: '*',

	extension: '.xlsx',

	exportOptions: {},

	header: true,

	footer: false,

	title: '*',

	messageTop: '*',

	messageBottom: '*',

	createEmptyCells: false,

	autoFilter: false,

	sheetName: ''
};

//
// PDF export - using pdfMake - http://pdfmake.org
//
DataTable.ext.buttons.pdfHtml5 = {
	className: 'buttons-pdf buttons-html5',

	available: function () {
		return window.FileReader !== undefined && _pdfMake();
	},

	text: function ( dt ) {
		return dt.i18n( 'buttons.pdf', 'PDF' );
	},

	action: function ( e, dt, button, config ) {
		this.processing( true );

		var that = this;
		var data = dt.buttons.exportData( config.exportOptions );
		var info = dt.buttons.exportInfo( config );
		var rows = [];

		if ( config.header ) {
			rows.push( $.map( data.header, function ( d ) {
				return {
					text: typeof d === 'string' ? d : d+'',
					style: 'tableHeader'
				};
			} ) );
		}

		for ( var i=0, ien=data.body.length ; i<ien ; i++ ) {
			rows.push( $.map( data.body[i], function ( d ) {
				if ( d === null || d === undefined ) {
					d = '';
				}
				return {
					text: typeof d === 'string' ? d : d+'',
					style: i % 2 ? 'tableBodyEven' : 'tableBodyOdd'
				};
			} ) );
		}

		if ( config.footer && data.footer) {
			rows.push( $.map( data.footer, function ( d ) {
				return {
					text: typeof d === 'string' ? d : d+'',
					style: 'tableFooter'
				};
			} ) );
		}

		var doc = {
			pageSize: config.pageSize,
			pageOrientation: config.orientation,
			content: [
				{
					table: {
						headerRows: 1,
						body: rows
					},
					layout: 'noBorders'
				}
			],
			styles: {
				tableHeader: {
					bold: true,
					fontSize: 11,
					color: 'white',
					fillColor: '#2d4154',
					alignment: 'center'
				},
				tableBodyEven: {},
				tableBodyOdd: {
					fillColor: '#f3f3f3'
				},
				tableFooter: {
					bold: true,
					fontSize: 11,
					color: 'white',
					fillColor: '#2d4154'
				},
				title: {
					alignment: 'center',
					fontSize: 15
				},
				message: {}
			},
			defaultStyle: {
				fontSize: 10
			}
		};

		if ( info.messageTop ) {
			doc.content.unshift( {
				text: info.messageTop,
				style: 'message',
				margin: [ 0, 0, 0, 12 ]
			} );
		}

		if ( info.messageBottom ) {
			doc.content.push( {
				text: info.messageBottom,
				style: 'message',
				margin: [ 0, 0, 0, 12 ]
			} );
		}

		if ( info.title ) {
			doc.content.unshift( {
				text: info.title,
				style: 'title',
				margin: [ 0, 0, 0, 12 ]
			} );
		}

		if ( config.customize ) {
			config.customize( doc, config, dt );
		}

		var pdf = _pdfMake().createPdf( doc );

		if ( config.download === 'open' && ! _isDuffSafari() ) {
			pdf.open();
		}
		else {
			pdf.download( info.filename );
		}

		this.processing( false );
	},

	title: '*',

	filename: '*',

	extension: '.pdf',

	exportOptions: {},

	orientation: 'portrait',

	pageSize: 'A4',

	header: true,

	footer: false,

	messageTop: '*',

	messageBottom: '*',

	customize: null,

	download: 'download'
};


return DataTable.Buttons;
}));

/*!
 * Print button for Buttons and DataTables.
 * 2016 SpryMedia Ltd - datatables.net/license
 */

(function( factory ){
	if ( typeof define === 'function' && define.amd ) {
		// AMD
		define( ['jquery', 'datatables.net', 'datatables.net-buttons'], function ( $ ) {
			return factory( $, window, document );
		} );
	}
	else if ( typeof exports === 'object' ) {
		// CommonJS
		module.exports = function (root, $) {
			if ( ! root ) {
				root = window;
			}

			if ( ! $ || ! $.fn.dataTable ) {
				$ = require('datatables.net')(root, $).$;
			}

			if ( ! $.fn.dataTable.Buttons ) {
				require('datatables.net-buttons')(root, $);
			}

			return factory( $, root, root.document );
		};
	}
	else {
		// Browser
		factory( jQuery, window, document );
	}
}(function( $, window, document, undefined ) {
'use strict';
var DataTable = $.fn.dataTable;


var _link = document.createElement( 'a' );

/**
 * Clone link and style tags, taking into account the need to change the source
 * path.
 *
 * @param  {node}     el Element to convert
 */
var _styleToAbs = function( el ) {
	var url;
	var clone = $(el).clone()[0];
	var linkHost;

	if ( clone.nodeName.toLowerCase() === 'link' ) {
		clone.href = _relToAbs( clone.href );
	}

	return clone.outerHTML;
};

/**
 * Convert a URL from a relative to an absolute address so it will work
 * correctly in the popup window which has no base URL.
 *
 * @param  {string} href URL
 */
var _relToAbs = function( href ) {
	// Assign to a link on the original page so the browser will do all the
	// hard work of figuring out where the file actually is
	_link.href = href;
	var linkHost = _link.host;

	// IE doesn't have a trailing slash on the host
	// Chrome has it on the pathname
	if ( linkHost.indexOf('/') === -1 && _link.pathname.indexOf('/') !== 0) {
		linkHost += '/';
	}

	return _link.protocol+"//"+linkHost+_link.pathname+_link.search;
};


DataTable.ext.buttons.print = {
	className: 'buttons-print',

	text: function ( dt ) {
		return dt.i18n( 'buttons.print', 'Print' );
	},

	action: function ( e, dt, button, config ) {
		var data = dt.buttons.exportData(
			$.extend( {decodeEntities: false}, config.exportOptions ) // XSS protection
		);
		var exportInfo = dt.buttons.exportInfo( config );
		var columnClasses = dt
			.columns( config.exportOptions.columns )
			.flatten()
			.map( function (idx) {
				return dt.settings()[0].aoColumns[dt.column(idx).index()].sClass;
			} )
			.toArray();

		var addRow = function ( d, tag ) {
			var str = '<tr>';

			for ( var i=0, ien=d.length ; i<ien ; i++ ) {
				// null and undefined aren't useful in the print output
				var dataOut = d[i] === null || d[i] === undefined ?
					'' :
					d[i];
				var classAttr = columnClasses[i] ?
					'class="'+columnClasses[i]+'"' :
					'';

				str += '<'+tag+' '+classAttr+'>'+dataOut+'</'+tag+'>';
			}

			return str + '</tr>';
		};

		// Construct a table for printing
		var html = '<table class="'+dt.table().node().className+'">';

		if ( config.header ) {
			html += '<thead>'+ addRow( data.header, 'th' ) +'</thead>';
		}

		html += '<tbody>';
		for ( var i=0, ien=data.body.length ; i<ien ; i++ ) {
			html += addRow( data.body[i], 'td' );
		}
		html += '</tbody>';

		if ( config.footer && data.footer ) {
			html += '<tfoot>'+ addRow( data.footer, 'th' ) +'</tfoot>';
		}
		html += '</table>';

		// Open a new window for the printable table
		var win = window.open( '', '' );

		if (! win) {
			dt.buttons.info(
				dt.i18n( 'buttons.printErrorTitle', 'Unable to open print view' ),
				dt.i18n( 'buttons.printErrorMsg', 'Please allow popups in your browser for this site to be able to view the print view.' ),
				5000
			);

			return;
		}

		win.document.close();

		// Inject the title and also a copy of the style and link tags from this
		// document so the table can retain its base styling. Note that we have
		// to use string manipulation as IE won't allow elements to be created
		// in the host document and then appended to the new window.
		var head = '<title>'+exportInfo.title+'</title>';
		$('style, link').each( function () {
			head += _styleToAbs( this );
		} );

		try {
			win.document.head.innerHTML = head; // Work around for Edge
		}
		catch (e) {
			$(win.document.head).html( head ); // Old IE
		}

		// Inject the table and other surrounding information
		win.document.body.innerHTML =
			'<h1>'+exportInfo.title+'</h1>'+
			'<div>'+(exportInfo.messageTop || '')+'</div>'+
			html+
			'<div>'+(exportInfo.messageBottom || '')+'</div>';

		$(win.document.body).addClass('dt-print-view');

		$('img', win.document.body).each( function ( i, img ) {
			img.setAttribute( 'src', _relToAbs( img.getAttribute('src') ) );
		} );

		if ( config.customize ) {
			config.customize( win, config, dt );
		}

		// Allow stylesheets time to load
		var autoPrint = function () {
			if ( config.autoPrint ) {
				win.print(); // blocking - so close will not
				win.close(); // execute until this is done
			}
		};

		if ( navigator.userAgent.match(/Trident\/\d.\d/) ) { // IE needs to call this without a setTimeout
			autoPrint();
		}
		else {
			win.setTimeout( autoPrint, 1000 );
		}
	},

	title: '*',

	messageTop: '*',

	messageBottom: '*',

	exportOptions: {},

	header: true,

	footer: false,

	autoPrint: true,

	customize: null
};


return DataTable.Buttons;
}));

/*!
* sweetalert2 v11.26.25
* Released under the MIT License.
*/
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).Sweetalert2=t()}(this,function(){"use strict";function e(e,t,n){if("function"==typeof e?e===t:e.has(t))return arguments.length<3?t:n;throw new TypeError("Private element is not present on this object")}function t(t,n){return t.get(e(t,n))}function n(e,t,n){(function(e,t){if(t.has(e))throw new TypeError("Cannot initialize the same private elements twice on an object")})(e,t),t.set(e,n)}const o={},i=e=>new Promise(t=>{if(!e)return t();const n=window.scrollX,i=window.scrollY;o.restoreFocusTimeout=setTimeout(()=>{o.previousActiveElement instanceof HTMLElement?(o.previousActiveElement.focus(),o.previousActiveElement=null):document.body&&document.body.focus(),t()},100),window.scrollTo(n,i)}),s="swal2-",r=["container","shown","height-auto","iosfix","popup","modal","no-backdrop","no-transition","toast","toast-shown","show","hide","close","title","html-container","actions","confirm","deny","cancel","footer","icon","icon-content","image","input","file","range","select","radio","checkbox","label","textarea","inputerror","input-label","validation-message","progress-steps","active-progress-step","progress-step","progress-step-line","loader","loading","styled","top","top-start","top-end","top-left","top-right","center","center-start","center-end","center-left","center-right","bottom","bottom-start","bottom-end","bottom-left","bottom-right","grow-row","grow-column","grow-fullscreen","rtl","timer-progress-bar","timer-progress-bar-container","scrollbar-measure","icon-success","icon-warning","icon-info","icon-question","icon-error","draggable","dragging"].reduce((e,t)=>(e[t]=s+t,e),{}),a=["success","warning","info","question","error"].reduce((e,t)=>(e[t]=s+t,e),{}),l="SweetAlert2:",c=e=>e.charAt(0).toUpperCase()+e.slice(1),u=e=>{console.warn(`${l} ${"object"==typeof e?e.join(" "):e}`)},d=e=>{console.error(`${l} ${e}`)},p=[],m=(e,t=null)=>{var n;n=`"${e}" is deprecated and will be removed in the next major release.${t?` Use "${t}" instead.`:""}`,p.includes(n)||(p.push(n),u(n))},h=e=>"function"==typeof e?e():e,g=e=>e&&"function"==typeof e.toPromise,f=e=>g(e)?e.toPromise():Promise.resolve(e),b=e=>e&&Promise.resolve(e)===e,y=()=>document.body.querySelector(`.${r.container}`),v=e=>{const t=y();return t?t.querySelector(e):null},w=e=>v(`.${e}`),C=()=>w(r.popup),A=()=>w(r.icon),E=()=>w(r.title),k=()=>w(r["html-container"]),B=()=>w(r.image),$=()=>w(r["progress-steps"]),L=()=>w(r["validation-message"]),P=()=>v(`.${r.actions} .${r.confirm}`),x=()=>v(`.${r.actions} .${r.cancel}`),T=()=>v(`.${r.actions} .${r.deny}`),S=()=>v(`.${r.loader}`),O=()=>w(r.actions),M=()=>w(r.footer),H=()=>w(r["timer-progress-bar"]),j=()=>w(r.close),I=()=>{const e=C();if(!e)return[];const t=e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'),n=Array.from(t).sort((e,t)=>{const n=parseInt(e.getAttribute("tabindex")||"0"),o=parseInt(t.getAttribute("tabindex")||"0");return n>o?1:n<o?-1:0}),o=e.querySelectorAll('\n  a[href],\n  area[href],\n  input:not([disabled]),\n  select:not([disabled]),\n  textarea:not([disabled]),\n  button:not([disabled]),\n  iframe,\n  object,\n  embed,\n  [tabindex="0"],\n  [contenteditable],\n  audio[controls],\n  video[controls],\n  summary\n'),i=Array.from(o).filter(e=>"-1"!==e.getAttribute("tabindex"));return[...new Set(n.concat(i))].filter(e=>ee(e))},D=()=>N(document.body,r.shown)&&!N(document.body,r["toast-shown"])&&!N(document.body,r["no-backdrop"]),V=()=>{const e=C();return!!e&&N(e,r.toast)},q=(e,t)=>{if(e.textContent="",t){const n=(new DOMParser).parseFromString(t,"text/html"),o=n.querySelector("head");o&&Array.from(o.childNodes).forEach(t=>{e.appendChild(t)});const i=n.querySelector("body");i&&Array.from(i.childNodes).forEach(t=>{t instanceof HTMLVideoElement||t instanceof HTMLAudioElement?e.appendChild(t.cloneNode(!0)):e.appendChild(t)})}},N=(e,t)=>!!t&&t.split(/\s+/).every(t=>e.classList.contains(t)),_=(e,t,n)=>{if(((e,t)=>{Array.from(e.classList).forEach(n=>{Object.values(r).includes(n)||Object.values(a).includes(n)||Object.values(t.showClass||{}).includes(n)||e.classList.remove(n)})})(e,t),!t.customClass)return;const o=t.customClass[n];o&&("string"==typeof o||o.forEach?z(e,o):u(`Invalid type of customClass.${n}! Expected string or iterable object, got "${typeof o}"`))},F=(e,t)=>{if(!t)return null;switch(t){case"select":case"textarea":case"file":return e.querySelector(`.${r.popup} > .${r[t]}`);case"checkbox":return e.querySelector(`.${r.popup} > .${r.checkbox} input`);case"radio":return e.querySelector(`.${r.popup} > .${r.radio} input:checked`)||e.querySelector(`.${r.popup} > .${r.radio} input:first-child`);case"range":return e.querySelector(`.${r.popup} > .${r.range} input`);default:return e.querySelector(`.${r.popup} > .${r.input}`)}},R=e=>{if(e.focus(),"file"!==e.type){const t=e.value;e.value="",e.value=t}},U=(e,t,n)=>{if(!e||!t)return;const o="string"==typeof t?t.split(/\s+/).filter(Boolean):t;(Array.isArray(e)?e:[e]).forEach(e=>{o.forEach(t=>{n?e.classList.add(t):e.classList.remove(t)})})},z=(e,t)=>{U(e,t,!0)},W=(e,t)=>{U(e,t,!1)},K=(e,t)=>Array.from(e.children).find(e=>e instanceof HTMLElement&&N(e,t)),Y=(e,t,n)=>{n===`${parseInt(`${n}`)}`&&(n=parseInt(n)),n||0===n?e.style.setProperty(t,"number"==typeof n?`${n}px`:n):e.style.removeProperty(t)},X=(e,t="flex")=>{e&&(e.style.display=t)},Z=e=>{e&&(e.style.display="none")},J=(e,t="block")=>{e&&new MutationObserver(()=>{Q(e,e.innerHTML,t)}).observe(e,{childList:!0,subtree:!0})},G=(e,t,n,o)=>{const i=e.querySelector(t);i&&i.style.setProperty(n,o)},Q=(e,t,n="flex")=>{t?X(e,n):Z(e)},ee=e=>Boolean(e&&(e.offsetWidth||e.offsetHeight||e.getClientRects().length)),te=e=>Boolean(e.scrollHeight>e.clientHeight),ne=e=>{const t=window.getComputedStyle(e),n=parseFloat(t.getPropertyValue("animation-duration")||"0"),o=parseFloat(t.getPropertyValue("transition-duration")||"0");return n>0||o>0},oe=(e,t=!1)=>{const n=H();n&&ee(n)&&(t&&(n.style.transition="none",n.style.width="100%"),setTimeout(()=>{n.style.transition=`width ${e/1e3}s linear`,n.style.width="0%"},10))},ie=`\n <div aria-labelledby="${r.title}" aria-describedby="${r["html-container"]}" class="${r.popup}" tabindex="-1">\n   <button type="button" class="${r.close}"></button>\n   <ul class="${r["progress-steps"]}"></ul>\n   <div class="${r.icon}"></div>\n   <img class="${r.image}" />\n   <h2 class="${r.title}" id="${r.title}"></h2>\n   <div class="${r["html-container"]}" id="${r["html-container"]}"></div>\n   <input class="${r.input}" id="${r.input}" />\n   <input type="file" class="${r.file}" />\n   <div class="${r.range}">\n     <input type="range" />\n     <output></output>\n   </div>\n   <select class="${r.select}" id="${r.select}"></select>\n   <div class="${r.radio}"></div>\n   <label class="${r.checkbox}">\n     <input type="checkbox" id="${r.checkbox}" />\n     <span class="${r.label}"></span>\n   </label>\n   <textarea class="${r.textarea}" id="${r.textarea}"></textarea>\n   <div class="${r["validation-message"]}" id="${r["validation-message"]}"></div>\n   <div class="${r.actions}">\n     <div class="${r.loader}"></div>\n     <button type="button" class="${r.confirm}"></button>\n     <button type="button" class="${r.deny}"></button>\n     <button type="button" class="${r.cancel}"></button>\n   </div>\n   <div class="${r.footer}"></div>\n   <div class="${r["timer-progress-bar-container"]}">\n     <div class="${r["timer-progress-bar"]}"></div>\n   </div>\n </div>\n`.replace(/(^|\n)\s*/g,""),se=()=>{o.currentInstance&&o.currentInstance.resetValidationMessage()},re=e=>{const t=(()=>{const e=y();return!!e&&(e.remove(),W([document.documentElement,document.body],[r["no-backdrop"],r["toast-shown"],r["has-column"]]),!0)})();if("undefined"==typeof window||"undefined"==typeof document)return void d("SweetAlert2 requires document to initialize");const n=document.createElement("div");n.className=r.container,t&&z(n,r["no-transition"]),q(n,ie),n.dataset.swal2Theme=e.theme;const i=(e=>{if("string"==typeof e){const t=document.querySelector(e);if(!t)throw new Error(`Target element "${e}" not found`);return t}return e})(e.target||"body");i.appendChild(n),e.topLayer&&(n.setAttribute("popover",""),n.showPopover()),(e=>{const t=C();t&&(t.setAttribute("role",e.toast?"alert":"dialog"),t.setAttribute("aria-live",e.toast?"polite":"assertive"),e.toast||t.setAttribute("aria-modal","true"))})(e),(e=>{"rtl"===window.getComputedStyle(e).direction&&(z(y(),r.rtl),o.isRTL=!0)})(i),(()=>{const e=C();if(!e)return;const t=K(e,r.input),n=K(e,r.file),o=e.querySelector(`.${r.range} input`),i=e.querySelector(`.${r.range} output`),s=K(e,r.select),a=e.querySelector(`.${r.checkbox} input`),l=K(e,r.textarea);t&&(t.oninput=se),n&&(n.onchange=se),s&&(s.onchange=se),a&&(a.onchange=se),l&&(l.oninput=se),o&&i&&(o.oninput=()=>{se(),i.value=o.value},o.onchange=()=>{se(),i.value=o.value})})()},ae=(e,t)=>{e instanceof HTMLElement?t.appendChild(e):"object"==typeof e?le(e,t):e&&q(t,e)},le=(e,t)=>{"jquery"in e?ce(t,e):q(t,e.toString())},ce=(e,t)=>{if(e.textContent="",0 in t)for(let n=0;n in t;n++)e.appendChild(t[n].cloneNode(!0));else e.appendChild(t.cloneNode(!0))},ue=(e,t)=>{const n=O(),o=S();n&&o&&(t.showConfirmButton||t.showDenyButton||t.showCancelButton?X(n):Z(n),_(n,t,"actions"),function(e,t,n){const o=P(),i=T(),s=x();if(!o||!i||!s)return;de(o,"confirm",n),de(i,"deny",n),de(s,"cancel",n),function(e,t,n,o){if(!o.buttonsStyling)return void W([e,t,n],r.styled);z([e,t,n],r.styled);const i=[[e,"confirm",o.confirmButtonColor],[t,"deny",o.denyButtonColor],[n,"cancel",o.cancelButtonColor]];i.forEach(([e,t,n])=>{n&&e.style.setProperty(`--swal2-${t}-button-background-color`,n),function(e){const t=window.getComputedStyle(e);if(t.getPropertyValue("--swal2-action-button-focus-box-shadow"))return;const n=t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/,"rgba($1, $2, $3, 0.5)");e.style.setProperty("--swal2-action-button-focus-box-shadow",t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/,` ${n}`))}(e)})}(o,i,s,n),n.reverseButtons&&(n.toast?(e.insertBefore(s,o),e.insertBefore(i,o)):(e.insertBefore(s,t),e.insertBefore(i,t),e.insertBefore(o,t)))}(n,o,t),q(o,t.loaderHtml||""),_(o,t,"loader"))};function de(e,t,n){const o=c(t);Q(e,n[`show${o}Button`],"inline-block"),q(e,n[`${t}ButtonText`]||""),e.setAttribute("aria-label",n[`${t}ButtonAriaLabel`]||""),e.className=r[t],_(e,n,`${t}Button`)}const pe=(e,t)=>{const n=y();n&&(!function(e,t){"string"==typeof t?e.style.background=t:t||z([document.documentElement,document.body],r["no-backdrop"])}(n,t.backdrop),function(e,t){if(!t)return;t in r?z(e,r[t]):(u('The "position" parameter is not valid, defaulting to "center"'),z(e,r.center))}(n,t.position),function(e,t){if(!t)return;z(e,r[`grow-${t}`])}(n,t.grow),_(n,t,"container"))};var me={innerParams:new WeakMap,domCache:new WeakMap,focusedElement:new WeakMap};const he=["input","file","range","select","radio","checkbox","textarea"],ge=e=>{if(!e.input)return;if(!Ae[e.input])return void d(`Unexpected type of input! Expected ${Object.keys(Ae).join(" | ")}, got "${e.input}"`);const t=we(e.input);if(!t)return;const n=Ae[e.input](t,e);X(t),e.inputAutoFocus&&setTimeout(()=>{R(n)})},fe=(e,t)=>{const n=C();if(!n)return;const o=F(n,e);if(o){(e=>{for(const{name:t}of Array.from(e.attributes))["id","type","value","style"].includes(t)||e.removeAttribute(t)})(o);for(const e in t)o.setAttribute(e,t[e])}},be=e=>{if(!e.input)return;const t=we(e.input);t&&_(t,e,"input")},ye=(e,t)=>{!e.placeholder&&t.inputPlaceholder&&(e.placeholder=t.inputPlaceholder)},ve=(e,t,n)=>{if(n.inputLabel){const o=document.createElement("label"),i=r["input-label"];o.setAttribute("for",e.id),o.className=i,"object"==typeof n.customClass&&z(o,n.customClass.inputLabel),o.innerText=n.inputLabel,t.insertAdjacentElement("beforebegin",o)}},we=e=>{const t=C();if(t)return K(t,r[e]||r.input)},Ce=(e,t)=>{["string","number"].includes(typeof t)?e.value=`${t}`:b(t)||u(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`)},Ae={};Ae.text=Ae.email=Ae.password=Ae.number=Ae.tel=Ae.url=Ae.search=Ae.date=Ae["datetime-local"]=Ae.time=Ae.week=Ae.month=(e,t)=>{const n=e;return Ce(n,t.inputValue),ve(n,n,t),ye(n,t),n.type=t.input,n},Ae.file=(e,t)=>{const n=e;return ve(n,n,t),ye(n,t),n},Ae.range=(e,t)=>{const n=e,o=n.querySelector("input"),i=n.querySelector("output");return o&&(Ce(o,t.inputValue),o.type=t.input,ve(o,e,t)),i&&Ce(i,t.inputValue),e},Ae.select=(e,t)=>{const n=e;if(n.textContent="",t.inputPlaceholder){const e=document.createElement("option");q(e,t.inputPlaceholder),e.value="",e.disabled=!0,e.selected=!0,n.appendChild(e)}return ve(n,n,t),n},Ae.radio=e=>(e.textContent="",e),Ae.checkbox=(e,t)=>{const n=C();if(!n)throw new Error("Popup not found");const o=F(n,"checkbox");if(!o)throw new Error("Checkbox input not found");o.value="1",o.checked=Boolean(t.inputValue);const i=e.querySelector("span");if(i){const e=t.inputPlaceholder||t.inputLabel;e&&q(i,e)}return o},Ae.textarea=(e,t)=>{const n=e;Ce(n,t.inputValue),ye(n,t),ve(n,n,t);return setTimeout(()=>{if("MutationObserver"in window){const e=C();if(!e)return;const o=parseInt(window.getComputedStyle(e).width);new MutationObserver(()=>{if(!document.body.contains(n))return;const e=n.offsetWidth+(i=n,parseInt(window.getComputedStyle(i).marginLeft)+parseInt(window.getComputedStyle(i).marginRight));var i;const s=C();s&&(e>o?s.style.width=`${e}px`:Y(s,"width",t.width))}).observe(n,{attributes:!0,attributeFilter:["style"]})}}),n};const Ee=(e,t)=>{const n=k();n&&(J(n),_(n,t,"htmlContainer"),t.html?(ae(t.html,n),X(n,"block")):t.text?(n.textContent=t.text,X(n,"block")):Z(n),((e,t)=>{const n=C();if(!n)return;const o=me.innerParams.get(e),i=!o||t.input!==o.input;he.forEach(e=>{const o=K(n,r[e]);o&&(fe(e,t.inputAttributes),o.className=r[e],i&&Z(o))}),t.input&&(i&&ge(t),be(t))})(e,t))},ke=(e,t)=>{for(const[n,o]of Object.entries(a))t.icon!==n&&W(e,o);z(e,t.icon&&a[t.icon]),Le(e,t),Be(),_(e,t,"icon")},Be=()=>{const e=C();if(!e)return;const t=window.getComputedStyle(e).getPropertyValue("background-color");e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix").forEach(e=>{e.style.backgroundColor=t})},$e=(e,t)=>{if(!t.icon&&!t.iconHtml)return;let n=e.innerHTML,o="";if(t.iconHtml)o=Pe(t.iconHtml);else if("success"===t.icon)o=(e=>`\n  ${e.animation?'<div class="swal2-success-circular-line-left"></div>':""}\n  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>\n  <div class="swal2-success-ring"></div>\n  ${e.animation?'<div class="swal2-success-fix"></div>':""}\n  ${e.animation?'<div class="swal2-success-circular-line-right"></div>':""}\n`)(t),n=n.replace(/ style=".*?"/g,"");else if("error"===t.icon)o='\n  <span class="swal2-x-mark">\n    <span class="swal2-x-mark-line-left"></span>\n    <span class="swal2-x-mark-line-right"></span>\n  </span>\n';else if(t.icon){o=Pe({question:"?",warning:"!",info:"i"}[t.icon])}n.trim()!==o.trim()&&q(e,o)},Le=(e,t)=>{if(t.iconColor){e.style.color=t.iconColor,e.style.borderColor=t.iconColor;for(const n of[".swal2-success-line-tip",".swal2-success-line-long",".swal2-x-mark-line-left",".swal2-x-mark-line-right"])G(e,n,"background-color",t.iconColor);G(e,".swal2-success-ring","border-color",t.iconColor)}},Pe=e=>`<div class="${r["icon-content"]}">${e}</div>`;let xe=!1,Te=0,Se=0,Oe=0,Me=0;const He=e=>{const t=C();if(!t)return;const n=A();if(e.target===t||n&&n.contains(e.target)){xe=!0;const n=De(e);Te=n.clientX,Se=n.clientY,Oe=parseInt(t.style.insetInlineStart)||0,Me=parseInt(t.style.insetBlockStart)||0,z(t,"swal2-dragging")}},je=e=>{const t=C();if(t&&xe){let{clientX:n,clientY:i}=De(e);const s=n-Te;t.style.insetInlineStart=`${Oe+(o.isRTL?-s:s)}px`,t.style.insetBlockStart=`${Me+(i-Se)}px`}},Ie=()=>{const e=C();xe=!1,W(e,"swal2-dragging")},De=e=>{const t=e.type.startsWith("touch")?e.touches[0]:e;return{clientX:t.clientX,clientY:t.clientY}},Ve=(e,t)=>{const n=y(),o=C();if(n&&o){if(t.toast){Y(n,"width",t.width),o.style.width="100%";const e=S();e&&o.insertBefore(e,A())}else Y(o,"width",t.width);Y(o,"padding",t.padding),t.color&&(o.style.color=t.color),t.background&&(o.style.background=t.background),Z(L()),qe(o,t),t.draggable&&!t.toast?(z(o,r.draggable),(e=>{e.addEventListener("mousedown",He),document.body.addEventListener("mousemove",je),e.addEventListener("mouseup",Ie),e.addEventListener("touchstart",He),document.body.addEventListener("touchmove",je),e.addEventListener("touchend",Ie)})(o)):(W(o,r.draggable),(e=>{e.removeEventListener("mousedown",He),document.body.removeEventListener("mousemove",je),e.removeEventListener("mouseup",Ie),e.removeEventListener("touchstart",He),document.body.removeEventListener("touchmove",je),e.removeEventListener("touchend",Ie)})(o))}},qe=(e,t)=>{const n=t.showClass||{};e.className=`${r.popup} ${ee(e)?n.popup:""}`,t.toast?(z([document.documentElement,document.body],r["toast-shown"]),z(e,r.toast)):z(e,r.modal),_(e,t,"popup"),"string"==typeof t.customClass&&z(e,t.customClass),t.icon&&z(e,r[`icon-${t.icon}`])},Ne=e=>{const t=document.createElement("li");return z(t,r["progress-step"]),q(t,e),t},_e=e=>{const t=document.createElement("li");return z(t,r["progress-step-line"]),e.progressStepsDistance&&Y(t,"width",e.progressStepsDistance),t},Fe=(e,t)=>{var n;Ve(0,t),pe(0,t),((e,t)=>{const n=$();if(!n)return;const{progressSteps:o,currentProgressStep:i}=t;o&&0!==o.length&&void 0!==i?(X(n),n.textContent="",i>=o.length&&u("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"),o.forEach((e,s)=>{const a=Ne(e);if(n.appendChild(a),s===i&&z(a,r["active-progress-step"]),s!==o.length-1){const e=_e(t);n.appendChild(e)}})):Z(n)})(0,t),((e,t)=>{const n=me.innerParams.get(e),o=A();if(!o)return;if(n&&t.icon===n.icon)return $e(o,t),void ke(o,t);if(!t.icon&&!t.iconHtml)return void Z(o);if(t.icon&&-1===Object.keys(a).indexOf(t.icon))return d(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`),void Z(o);X(o),$e(o,t),ke(o,t),z(o,t.showClass&&t.showClass.icon),window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change",Be)})(e,t),((e,t)=>{const n=B();n&&(t.imageUrl?(X(n,""),n.setAttribute("src",t.imageUrl),n.setAttribute("alt",t.imageAlt||""),Y(n,"width",t.imageWidth),Y(n,"height",t.imageHeight),n.className=r.image,_(n,t,"image")):Z(n))})(0,t),((e,t)=>{const n=E();n&&(J(n),Q(n,Boolean(t.title||t.titleText),"block"),t.title&&ae(t.title,n),t.titleText&&(n.innerText=t.titleText),_(n,t,"title"))})(0,t),((e,t)=>{const n=j();n&&(q(n,t.closeButtonHtml||""),_(n,t,"closeButton"),Q(n,t.showCloseButton),n.setAttribute("aria-label",t.closeButtonAriaLabel||""))})(0,t),Ee(e,t),ue(0,t),((e,t)=>{const n=M();n&&(J(n),Q(n,Boolean(t.footer),"block"),t.footer&&ae(t.footer,n),_(n,t,"footer"))})(0,t);const i=C();"function"==typeof t.didRender&&i&&t.didRender(i),null===(n=o.eventEmitter)||void 0===n||n.emit("didRender",i)},Re=()=>{var e;return null===(e=P())||void 0===e?void 0:e.click()},Ue=Object.freeze({cancel:"cancel",backdrop:"backdrop",close:"close",esc:"esc",timer:"timer"}),ze=e=>{if(e.keydownTarget&&e.keydownHandlerAdded&&e.keydownHandler){const t=e.keydownHandler;e.keydownTarget.removeEventListener("keydown",t,{capture:e.keydownListenerCapture}),e.keydownHandlerAdded=!1}},We=(e,t)=>{var n;const o=I();return o.length?(-2===(e+=t)&&(e=o.length-1),e===o.length?e=0:-1===e&&(e=o.length-1),o[e].focus(),!(navigator.userAgent.includes("Firefox")&&o[e]instanceof HTMLIFrameElement)):(null===(n=C())||void 0===n||n.focus(),!0)},Ke=["ArrowRight","ArrowDown"],Ye=["ArrowLeft","ArrowUp"],Xe=(e,t,n)=>{e&&(t.isComposing||229===t.keyCode||(e.stopKeydownPropagation&&t.stopPropagation(),"Enter"===t.key?Ze(t,e):"Tab"===t.key?Je(t):[...Ke,...Ye].includes(t.key)?Ge(t.key):"Escape"===t.key&&Qe(t,e,n)))},Ze=(e,t)=>{if(!h(t.allowEnterKey))return;const n=C();if(!n||!t.input)return;const o=F(n,t.input);if(e.target&&o&&e.target instanceof HTMLElement&&e.target.outerHTML===o.outerHTML){if(["textarea","file"].includes(t.input))return;Re(),e.preventDefault()}},Je=e=>{const t=e.target,n=I().findIndex(e=>e===t);let o=!0;o=e.shiftKey?We(n,-1):We(n,1),e.stopPropagation(),o&&e.preventDefault()},Ge=e=>{const t=O(),n=P(),o=T(),i=x();if(!(t&&n&&o&&i))return;const s=[n,o,i];if(document.activeElement instanceof HTMLElement&&!s.includes(document.activeElement))return;const r=Ke.includes(e)?"nextElementSibling":"previousElementSibling";let a=document.activeElement;if(a){for(let e=0;e<t.children.length;e++){if(a=a[r],!a)return;if(a instanceof HTMLButtonElement&&ee(a))break}a instanceof HTMLButtonElement&&a.focus()}},Qe=(e,t,n)=>{e.preventDefault(),h(t.allowEscapeKey)&&n(Ue.esc)};var et={swalPromiseResolve:new WeakMap,swalPromiseReject:new WeakMap};const tt=()=>{Array.from(document.body.children).forEach(e=>{e.hasAttribute("data-previous-aria-hidden")?(e.setAttribute("aria-hidden",e.getAttribute("data-previous-aria-hidden")||""),e.removeAttribute("data-previous-aria-hidden")):e.removeAttribute("aria-hidden")})},nt="undefined"!=typeof window&&Boolean(window.GestureEvent),ot=nt&&/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,it=()=>{const e=y();if(!e)return;let t;e.ontouchstart=e=>{t=st(e)},e.ontouchmove=e=>{t&&(e.preventDefault(),e.stopPropagation())}},st=e=>{const t=e.target,n=y(),o=k();return!(!n||!o)&&(!rt(e)&&!at(e)&&(t===n||!(te(n)||!(t instanceof HTMLElement)||((e,t)=>{let n=e;for(;n&&n!==t;){if(te(n))return!0;n=n.parentElement}return!1})(t,o)||"INPUT"===t.tagName||"TEXTAREA"===t.tagName||te(o)&&o.contains(t))))},rt=e=>Boolean(e.touches&&e.touches.length&&"stylus"===e.touches[0].touchType),at=e=>e.touches&&e.touches.length>1;let lt=null;const ct=e=>{null===lt&&(document.body.scrollHeight>window.innerHeight||"scroll"===e)&&(lt=parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")),document.body.style.paddingRight=`${lt+(()=>{const e=document.createElement("div");e.className=r["scrollbar-measure"],document.body.appendChild(e);const t=e.getBoundingClientRect().width-e.clientWidth;return document.body.removeChild(e),t})()}px`)};function ut(e,t,n,s){V()?yt(e,s):(i(n).then(()=>yt(e,s)),ze(o)),nt?(t.setAttribute("style","display:none !important"),t.removeAttribute("class"),t.innerHTML=""):t.remove(),D()&&(null!==lt&&(document.body.style.paddingRight=`${lt}px`,lt=null),(()=>{if(N(document.body,r.iosfix)){const e=parseInt(document.body.style.top,10);W(document.body,r.iosfix),document.body.style.top="",document.body.scrollTop=-1*e}})(),tt()),W([document.documentElement,document.body],[r.shown,r["height-auto"],r["no-backdrop"],r["toast-shown"]])}function dt(e){e=gt(e);const t=et.swalPromiseResolve.get(this),n=pt(this);this.isAwaitingPromise?e.isDismissed||(ht(this),t(e)):n&&t(e)}const pt=e=>{const t=C();if(!t)return!1;const n=me.innerParams.get(e);if(!n||N(t,n.hideClass.popup))return!1;W(t,n.showClass.popup),z(t,n.hideClass.popup);const o=y();return W(o,n.showClass.backdrop),z(o,n.hideClass.backdrop),ft(e,t,n),!0};function mt(e){const t=et.swalPromiseReject.get(this);ht(this),t&&t(e)}const ht=e=>{e.isAwaitingPromise&&(delete e.isAwaitingPromise,me.innerParams.get(e)||e._destroy())},gt=e=>void 0===e?{isConfirmed:!1,isDenied:!1,isDismissed:!0}:Object.assign({isConfirmed:!1,isDenied:!1,isDismissed:!1},e),ft=(e,t,n)=>{var i;const s=y(),r=ne(t);"function"==typeof n.willClose&&n.willClose(t),null===(i=o.eventEmitter)||void 0===i||i.emit("willClose",t),r&&s?bt(e,t,s,Boolean(n.returnFocus),n.didClose):s&&ut(e,s,Boolean(n.returnFocus),n.didClose)},bt=(e,t,n,i,s)=>{o.swalCloseEventFinishedCallback=ut.bind(null,e,n,i,s);const r=function(e){var n;e.target===t&&(null===(n=o.swalCloseEventFinishedCallback)||void 0===n||n.call(o),delete o.swalCloseEventFinishedCallback,t.removeEventListener("animationend",r),t.removeEventListener("transitionend",r))};t.addEventListener("animationend",r),t.addEventListener("transitionend",r)},yt=(e,t)=>{setTimeout(()=>{var n;"function"==typeof t&&t.bind(e.params)(),null===(n=o.eventEmitter)||void 0===n||n.emit("didClose"),e._destroy&&e._destroy()})},vt=e=>{let t=C();if(t||new Gn,t=C(),!t)return;const n=S();V()?Z(A()):wt(t,e),X(n),t.setAttribute("data-loading","true"),t.setAttribute("aria-busy","true"),t.focus()},wt=(e,t)=>{const n=O(),o=S();n&&o&&(!t&&ee(P())&&(t=P()),X(n),t&&(Z(t),o.setAttribute("data-button-to-replace",t.className),n.insertBefore(o,t)),z([e,n],r.loading))},Ct=e=>e.checked?1:0,At=e=>e.checked?e.value:null,Et=e=>e.files&&e.files.length?null!==e.getAttribute("multiple")?e.files:e.files[0]:null,kt=(e,t)=>{const n=C();if(!n)return;const o=e=>{"select"===t.input?function(e,t,n){const o=K(e,r.select);if(!o)return;const i=(e,t,o)=>{const i=document.createElement("option");i.value=o,q(i,t),i.selected=Lt(o,n.inputValue),e.appendChild(i)};t.forEach(e=>{const t=e[0],n=e[1];if(Array.isArray(n)){const e=document.createElement("optgroup");e.label=t,e.disabled=!1,o.appendChild(e),n.forEach(t=>i(e,t[1],t[0]))}else i(o,n,t)}),o.focus()}(n,$t(e),t):"radio"===t.input&&function(e,t,n){const o=K(e,r.radio);if(!o)return;t.forEach(e=>{const t=e[0],i=e[1],s=document.createElement("input"),a=document.createElement("label");s.type="radio",s.name=r.radio,s.value=t,Lt(t,n.inputValue)&&(s.checked=!0);const l=document.createElement("span");q(l,i),l.className=r.label,a.appendChild(s),a.appendChild(l),o.appendChild(a)});const i=o.querySelectorAll("input");i.length&&i[0].focus()}(n,$t(e),t)};g(t.inputOptions)||b(t.inputOptions)?(vt(P()),f(t.inputOptions).then(t=>{e.hideLoading(),o(t)})):"object"==typeof t.inputOptions?o(t.inputOptions):d("Unexpected type of inputOptions! Expected object, Map or Promise, got "+typeof t.inputOptions)},Bt=(e,t)=>{const n=e.getInput();n&&(Z(n),f(t.inputValue).then(o=>{n.value="number"===t.input?`${parseFloat(o)||0}`:`${o}`,X(n),n.focus(),e.hideLoading()}).catch(t=>{d(`Error in inputValue promise: ${t}`),n.value="",X(n),n.focus(),e.hideLoading()}))};const $t=e=>(e instanceof Map?Array.from(e):Object.entries(e)).map(([e,t])=>[e,"object"==typeof t?$t(t):t]),Lt=(e,t)=>Boolean(t)&&null!=t&&t.toString()===e.toString(),Pt=(e,t)=>{const n=me.innerParams.get(e);if(!n.input)return void d(`The "input" parameter is needed to be set when using returnInputValueOn${c(t)}`);const o=e.getInput(),i=((e,t)=>{const n=e.getInput();if(!n)return null;switch(t.input){case"checkbox":return Ct(n);case"radio":return At(n);case"file":return Et(n);default:return t.inputAutoTrim?n.value.trim():n.value}})(e,n);n.inputValidator?xt(e,i,t):o&&!o.checkValidity()?(e.enableButtons(),e.showValidationMessage(n.validationMessage||o.validationMessage)):"deny"===t?Tt(e,i):Mt(e,i)},xt=(e,t,n)=>{const o=me.innerParams.get(e);e.disableInput();Promise.resolve().then(()=>f(o.inputValidator(t,o.validationMessage))).then(o=>{e.enableButtons(),e.enableInput(),o?e.showValidationMessage(o):"deny"===n?Tt(e,t):Mt(e,t)})},Tt=(e,t)=>{const n=me.innerParams.get(e);if(n.showLoaderOnDeny&&vt(T()),n.preDeny){e.isAwaitingPromise=!0;Promise.resolve().then(()=>f(n.preDeny(t,n.validationMessage))).then(n=>{!1===n?(e.hideLoading(),ht(e)):e.close({isDenied:!0,value:void 0===n?t:n})}).catch(t=>Ot(e,t))}else e.close({isDenied:!0,value:t})},St=(e,t)=>{e.close({isConfirmed:!0,value:t})},Ot=(e,t)=>{e.rejectPromise(t)},Mt=(e,t)=>{const n=me.innerParams.get(e);if(n.showLoaderOnConfirm&&vt(),n.preConfirm){e.resetValidationMessage(),e.isAwaitingPromise=!0;Promise.resolve().then(()=>f(n.preConfirm(t,n.validationMessage))).then(n=>{ee(L())||!1===n?(e.hideLoading(),ht(e)):St(e,void 0===n?t:n)}).catch(t=>Ot(e,t))}else St(e,t)};function Ht(){const e=me.innerParams.get(this);if(!e)return;const t=me.domCache.get(this);Z(t.loader),V()?e.icon&&X(A()):jt(t),W([t.popup,t.actions],r.loading),t.popup.removeAttribute("aria-busy"),t.popup.removeAttribute("data-loading"),this.enableButtons()}const jt=e=>{const t=e.loader.getAttribute("data-button-to-replace"),n=t?e.popup.getElementsByClassName(t):[];n.length?X(n[0],"inline-block"):ee(P())||ee(T())||ee(x())||Z(e.actions)};function It(){const e=me.innerParams.get(this),t=me.domCache.get(this);return t?F(t.popup,e.input):null}function Dt(e,t,n){const o=me.domCache.get(e);t.forEach(e=>{o[e].disabled=n})}function Vt(e,t){const n=C();if(n&&e)if("radio"===e.type){n.querySelectorAll(`[name="${r.radio}"]`).forEach(e=>{e.disabled=t})}else e.disabled=t}function qt(){Dt(this,["confirmButton","denyButton","cancelButton"],!1);const e=me.focusedElement.get(this);e instanceof HTMLElement&&document.activeElement===document.body&&e.focus(),me.focusedElement.delete(this)}function Nt(){me.focusedElement.set(this,document.activeElement),Dt(this,["confirmButton","denyButton","cancelButton"],!0)}function _t(){Vt(this.getInput(),!1)}function Ft(){Vt(this.getInput(),!0)}function Rt(e){const t=me.domCache.get(this),n=me.innerParams.get(this);q(t.validationMessage,e),t.validationMessage.className=r["validation-message"],n.customClass&&n.customClass.validationMessage&&z(t.validationMessage,n.customClass.validationMessage),X(t.validationMessage);const o=this.getInput();o&&(o.setAttribute("aria-invalid","true"),o.setAttribute("aria-describedby",r["validation-message"]),R(o),z(o,r.inputerror))}function Ut(){const e=me.domCache.get(this);e.validationMessage&&Z(e.validationMessage);const t=this.getInput();t&&(t.removeAttribute("aria-invalid"),t.removeAttribute("aria-describedby"),W(t,r.inputerror))}const zt={title:"",titleText:"",text:"",html:"",footer:"",icon:void 0,iconColor:void 0,iconHtml:void 0,template:void 0,toast:!1,draggable:!1,animation:!0,theme:"light",showClass:{popup:"swal2-show",backdrop:"swal2-backdrop-show",icon:"swal2-icon-show"},hideClass:{popup:"swal2-hide",backdrop:"swal2-backdrop-hide",icon:"swal2-icon-hide"},customClass:{},target:"body",color:void 0,backdrop:!0,heightAuto:!0,allowOutsideClick:!0,allowEscapeKey:!0,allowEnterKey:!0,stopKeydownPropagation:!0,keydownListenerCapture:!1,showConfirmButton:!0,showDenyButton:!1,showCancelButton:!1,preConfirm:void 0,preDeny:void 0,confirmButtonText:"OK",confirmButtonAriaLabel:"",confirmButtonColor:void 0,denyButtonText:"No",denyButtonAriaLabel:"",denyButtonColor:void 0,cancelButtonText:"Cancel",cancelButtonAriaLabel:"",cancelButtonColor:void 0,buttonsStyling:!0,reverseButtons:!1,focusConfirm:!0,focusDeny:!1,focusCancel:!1,returnFocus:!0,showCloseButton:!1,closeButtonHtml:"&times;",closeButtonAriaLabel:"Close this dialog",loaderHtml:"",showLoaderOnConfirm:!1,showLoaderOnDeny:!1,imageUrl:void 0,imageWidth:void 0,imageHeight:void 0,imageAlt:"",timer:void 0,timerProgressBar:!1,width:void 0,padding:void 0,background:void 0,input:void 0,inputPlaceholder:"",inputLabel:"",inputValue:"",inputOptions:{},inputAutoFocus:!0,inputAutoTrim:!0,inputAttributes:{},inputValidator:void 0,returnInputValueOnDeny:!1,validationMessage:void 0,grow:!1,position:"center",progressSteps:[],currentProgressStep:void 0,progressStepsDistance:void 0,willOpen:void 0,didOpen:void 0,didRender:void 0,willClose:void 0,didClose:void 0,didDestroy:void 0,scrollbarPadding:!0,topLayer:!1},Wt=["allowEscapeKey","allowOutsideClick","background","buttonsStyling","cancelButtonAriaLabel","cancelButtonColor","cancelButtonText","closeButtonAriaLabel","closeButtonHtml","color","confirmButtonAriaLabel","confirmButtonColor","confirmButtonText","currentProgressStep","customClass","denyButtonAriaLabel","denyButtonColor","denyButtonText","didClose","didDestroy","draggable","footer","hideClass","html","icon","iconColor","iconHtml","imageAlt","imageHeight","imageUrl","imageWidth","preConfirm","preDeny","progressSteps","returnFocus","reverseButtons","showCancelButton","showCloseButton","showConfirmButton","showDenyButton","text","title","titleText","theme","willClose"],Kt={allowEnterKey:void 0},Yt=["allowOutsideClick","allowEnterKey","backdrop","draggable","focusConfirm","focusDeny","focusCancel","returnFocus","heightAuto","keydownListenerCapture"],Xt=e=>Object.prototype.hasOwnProperty.call(zt,e),Zt=e=>-1!==Wt.indexOf(e),Jt=e=>Kt[e],Gt=e=>{Xt(e)||u(`Unknown parameter "${e}"`)},Qt=e=>{Yt.includes(e)&&u(`The parameter "${e}" is incompatible with toasts`)},en=e=>{const t=Jt(e);t&&m(e,t)},tn=e=>{!1===e.backdrop&&e.allowOutsideClick&&u('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'),e.theme&&!["light","dark","auto","minimal","borderless","bootstrap-4","bootstrap-4-light","bootstrap-4-dark","bootstrap-5","bootstrap-5-light","bootstrap-5-dark","material-ui","material-ui-light","material-ui-dark","embed-iframe","bulma","bulma-light","bulma-dark"].includes(e.theme)&&u(`Invalid theme "${e.theme}"`);for(const t in e)Gt(t),e.toast&&Qt(t),en(t)};function nn(e){const t=y(),n=C(),o=me.innerParams.get(this);if(!n||N(n,o.hideClass.popup))return void u("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");const i=on(e),s=Object.assign({},o,i);tn(s),t&&(t.dataset.swal2Theme=s.theme),Fe(this,s),me.innerParams.set(this,s),Object.defineProperties(this,{params:{value:Object.assign({},this.params,e),writable:!1,enumerable:!0}})}const on=e=>{const t={};return Object.keys(e).forEach(n=>{if(Zt(n)){const o=e;t[n]=o[n]}else u(`Invalid parameter to update: ${n}`)}),t};function sn(){var e;const t=me.domCache.get(this),n=me.innerParams.get(this);n?(t.popup&&o.swalCloseEventFinishedCallback&&(o.swalCloseEventFinishedCallback(),delete o.swalCloseEventFinishedCallback),"function"==typeof n.didDestroy&&n.didDestroy(),null===(e=o.eventEmitter)||void 0===e||e.emit("didDestroy"),rn(this)):an(this)}const rn=e=>{an(e),delete e.params,delete o.keydownHandler,delete o.keydownTarget,delete o.currentInstance},an=e=>{e.isAwaitingPromise?(ln(me,e),e.isAwaitingPromise=!0):(ln(et,e),ln(me,e),delete e.isAwaitingPromise,delete e.disableButtons,delete e.enableButtons,delete e.getInput,delete e.disableInput,delete e.enableInput,delete e.hideLoading,delete e.disableLoading,delete e.showValidationMessage,delete e.resetValidationMessage,delete e.close,delete e.closePopup,delete e.closeModal,delete e.closeToast,delete e.rejectPromise,delete e.update,delete e._destroy)},ln=(e,t)=>{for(const n in e)e[n].delete(t)};var cn=Object.freeze({__proto__:null,_destroy:sn,close:dt,closeModal:dt,closePopup:dt,closeToast:dt,disableButtons:Nt,disableInput:Ft,disableLoading:Ht,enableButtons:qt,enableInput:_t,getInput:It,handleAwaitingPromise:ht,hideLoading:Ht,rejectPromise:mt,resetValidationMessage:Ut,showValidationMessage:Rt,update:nn});const un=(e,t,n)=>{t.popup.onclick=()=>{e&&(dn(e)||e.timer||e.input)||n(Ue.close)}},dn=e=>Boolean(e.showConfirmButton||e.showDenyButton||e.showCancelButton||e.showCloseButton);let pn=!1;const mn=e=>{e.popup.onmousedown=()=>{e.container.onmouseup=function(t){e.container.onmouseup=()=>{},t.target===e.container&&(pn=!0)}}},hn=e=>{e.container.onmousedown=t=>{t.target===e.container&&t.preventDefault(),e.popup.onmouseup=function(t){e.popup.onmouseup=()=>{},(t.target===e.popup||t.target instanceof HTMLElement&&e.popup.contains(t.target))&&(pn=!0)}}},gn=(e,t,n)=>{t.container.onclick=o=>{pn?pn=!1:o.target===t.container&&h(e.allowOutsideClick)&&n(Ue.backdrop)}},fn=e=>e instanceof Element||(e=>"object"==typeof e&&null!==e&&"jquery"in e)(e);const bn=()=>{if(o.timeout)return(()=>{const e=H();if(!e)return;const t=parseInt(window.getComputedStyle(e).width);e.style.removeProperty("transition"),e.style.width="100%";const n=t/parseInt(window.getComputedStyle(e).width)*100;e.style.width=`${n}%`})(),o.timeout.stop()},yn=()=>{if(o.timeout){const e=o.timeout.start();return oe(e),e}};let vn=!1;const wn={};const Cn=e=>{for(let t=e.target;t&&t!==document;t=t.parentNode)for(const e in wn){const n=t.getAttribute&&t.getAttribute(e);if(n)return void wn[e].fire({template:n})}};o.eventEmitter=new class{constructor(){this.events={}}_getHandlersByEventName(e){return void 0===this.events[e]&&(this.events[e]=[]),this.events[e]}on(e,t){const n=this._getHandlersByEventName(e);n.includes(t)||n.push(t)}once(e,t){const n=(...o)=>{this.removeListener(e,n),t.apply(this,o)};this.on(e,n)}emit(e,...t){this._getHandlersByEventName(e).forEach(e=>{try{e.apply(this,t)}catch(e){console.error(e)}})}removeListener(e,t){const n=this._getHandlersByEventName(e),o=n.indexOf(t);o>-1&&n.splice(o,1)}removeAllListeners(e){void 0!==this.events[e]&&(this.events[e].length=0)}reset(){this.events={}}};var An=Object.freeze({__proto__:null,argsToParams:e=>{const t={};return"object"!=typeof e[0]||fn(e[0])?["title","html","icon"].forEach((n,o)=>{const i=e[o];"string"==typeof i||fn(i)?t[n]=i:void 0!==i&&d(`Unexpected type of ${n}! Expected "string" or "Element", got ${typeof i}`)}):Object.assign(t,e[0]),t},bindClickHandler:function(e="data-swal-template"){wn[e]=this,vn||(document.body.addEventListener("click",Cn),vn=!0)},clickCancel:()=>{var e;return null===(e=x())||void 0===e?void 0:e.click()},clickConfirm:Re,clickDeny:()=>{var e;return null===(e=T())||void 0===e?void 0:e.click()},enableLoading:vt,fire:function(...e){return new this(...e)},getActions:O,getCancelButton:x,getCloseButton:j,getConfirmButton:P,getContainer:y,getDenyButton:T,getFocusableElements:I,getFooter:M,getHtmlContainer:k,getIcon:A,getIconContent:()=>w(r["icon-content"]),getImage:B,getInputLabel:()=>w(r["input-label"]),getLoader:S,getPopup:C,getProgressSteps:$,getTimerLeft:()=>o.timeout&&o.timeout.getTimerLeft(),getTimerProgressBar:H,getTitle:E,getValidationMessage:L,increaseTimer:e=>{if(o.timeout){const t=o.timeout.increase(e);return oe(t,!0),t}},isDeprecatedParameter:Jt,isLoading:()=>{const e=C();return!!e&&e.hasAttribute("data-loading")},isTimerRunning:()=>Boolean(o.timeout&&o.timeout.isRunning()),isUpdatableParameter:Zt,isValidParameter:Xt,isVisible:()=>ee(C()),mixin:function(e){return class extends(this){_main(t,n){return super._main(t,Object.assign({},e,n))}}},off:(e,t)=>{o.eventEmitter&&(e?t?o.eventEmitter.removeListener(e,t):o.eventEmitter.removeAllListeners(e):o.eventEmitter.reset())},on:(e,t)=>{o.eventEmitter&&o.eventEmitter.on(e,t)},once:(e,t)=>{o.eventEmitter&&o.eventEmitter.once(e,t)},resumeTimer:yn,showLoading:vt,stopTimer:bn,toggleTimer:()=>{const e=o.timeout;return e&&(e.running?bn():yn())}});class En{constructor(e,t){this.callback=e,this.remaining=t,this.running=!1,this.start()}start(){return this.running||(this.running=!0,this.started=new Date,this.id=setTimeout(this.callback,this.remaining)),this.remaining}stop(){return this.started&&this.running&&(this.running=!1,clearTimeout(this.id),this.remaining-=(new Date).getTime()-this.started.getTime()),this.remaining}increase(e){const t=this.running;return t&&this.stop(),this.remaining+=e,t&&this.start(),this.remaining}getTimerLeft(){return this.running&&(this.stop(),this.start()),this.remaining}isRunning(){return this.running}}const kn=["swal-title","swal-html","swal-footer"],Bn=e=>{const t={};return Array.from(e.querySelectorAll("swal-param")).forEach(e=>{Mn(e,["name","value"]);const n=e.getAttribute("name"),o=e.getAttribute("value");n&&o&&(t[n]=n in zt&&"boolean"==typeof zt[n]?"false"!==o:n in zt&&"object"==typeof zt[n]?JSON.parse(o):o)}),t},$n=e=>{const t={};return Array.from(e.querySelectorAll("swal-function-param")).forEach(e=>{const n=e.getAttribute("name"),o=e.getAttribute("value");n&&o&&(t[n]=new Function(`return ${o}`)())}),t},Ln=e=>{const t={};return Array.from(e.querySelectorAll("swal-button")).forEach(e=>{Mn(e,["type","color","aria-label"]);const n=e.getAttribute("type");if(!n||!["confirm","cancel","deny"].includes(n))return;t[`${n}ButtonText`]=e.innerHTML,t[`show${c(n)}Button`]=!0;const o=e.getAttribute("color");null!==o&&(t[`${n}ButtonColor`]=o);const i=e.getAttribute("aria-label");null!==i&&(t[`${n}ButtonAriaLabel`]=i)}),t},Pn=e=>{const t={},n=e.querySelector("swal-image");if(n){Mn(n,["src","width","height","alt"]);const e=n.getAttribute("src");null!==e&&(t.imageUrl=e||void 0);const o=n.getAttribute("width");null!==o&&(t.imageWidth=o||void 0);const i=n.getAttribute("height");null!==i&&(t.imageHeight=i||void 0);const s=n.getAttribute("alt");null!==s&&(t.imageAlt=s||void 0)}return t},xn=e=>{const t={},n=e.querySelector("swal-icon");return n&&(Mn(n,["type","color"]),n.hasAttribute("type")&&(t.icon=n.getAttribute("type")),n.hasAttribute("color")&&(t.iconColor=n.getAttribute("color")),t.iconHtml=n.innerHTML),t},Tn=e=>{const t={},n=e.querySelector("swal-input");n&&(Mn(n,["type","label","placeholder","value"]),t.input=n.getAttribute("type")||"text",n.hasAttribute("label")&&(t.inputLabel=n.getAttribute("label")),n.hasAttribute("placeholder")&&(t.inputPlaceholder=n.getAttribute("placeholder")),n.hasAttribute("value")&&(t.inputValue=n.getAttribute("value")));const o=Array.from(e.querySelectorAll("swal-input-option"));return o.length&&(t.inputOptions={},o.forEach(e=>{Mn(e,["value"]);const n=e.getAttribute("value");if(!n)return;const o=e.innerHTML;t.inputOptions[n]=o})),t},Sn=(e,t)=>{const n={};for(const o in t){const i=t[o],s=e.querySelector(i);s&&(Mn(s,[]),n[i.replace(/^swal-/,"")]=s.innerHTML.trim())}return n},On=e=>{const t=kn.concat(["swal-param","swal-function-param","swal-button","swal-image","swal-icon","swal-input","swal-input-option"]);Array.from(e.children).forEach(e=>{const n=e.tagName.toLowerCase();t.includes(n)||u(`Unrecognized element <${n}>`)})},Mn=(e,t)=>{Array.from(e.attributes).forEach(n=>{-1===t.indexOf(n.name)&&u([`Unrecognized attribute "${n.name}" on <${e.tagName.toLowerCase()}>.`,""+(t.length?`Allowed attributes are: ${t.join(", ")}`:"To set the value, use HTML within the element.")])})},Hn=e=>{var t,n;const i=y(),s=C();if(!i||!s)return;"function"==typeof e.willOpen&&e.willOpen(s),null===(t=o.eventEmitter)||void 0===t||t.emit("willOpen",s);const r=window.getComputedStyle(document.body).overflowY;if(Vn(i,s,e),setTimeout(()=>{In(i,s)},10),D()&&(Dn(i,void 0!==e.scrollbarPadding&&e.scrollbarPadding,r),(()=>{const e=y();Array.from(document.body.children).forEach(t=>{t.contains(e)||(t.hasAttribute("aria-hidden")&&t.setAttribute("data-previous-aria-hidden",t.getAttribute("aria-hidden")||""),t.setAttribute("aria-hidden","true"))})})()),ot&&!1===e.backdrop&&s.scrollHeight>i.clientHeight&&(i.style.pointerEvents="auto"),V()||o.previousActiveElement||(o.previousActiveElement=document.activeElement),"function"==typeof e.didOpen){const t=e.didOpen;setTimeout(()=>t(s))}null===(n=o.eventEmitter)||void 0===n||n.emit("didOpen",s)},jn=e=>{const t=C();if(!t||e.target!==t)return;const n=y();n&&(t.removeEventListener("animationend",jn),t.removeEventListener("transitionend",jn),n.style.overflowY="auto",W(n,r["no-transition"]))},In=(e,t)=>{ne(t)?(e.style.overflowY="hidden",t.addEventListener("animationend",jn),t.addEventListener("transitionend",jn)):e.style.overflowY="auto"},Dn=(e,t,n)=>{(()=>{if(nt&&!N(document.body,r.iosfix)){const e=document.body.scrollTop;document.body.style.top=-1*e+"px",z(document.body,r.iosfix),it()}})(),t&&"hidden"!==n&&ct(n),setTimeout(()=>{e.scrollTop=0})},Vn=(e,t,n)=>{var o;null!==(o=n.showClass)&&void 0!==o&&o.backdrop&&z(e,n.showClass.backdrop),n.animation?(t.style.setProperty("opacity","0","important"),X(t,"grid"),setTimeout(()=>{var e;null!==(e=n.showClass)&&void 0!==e&&e.popup&&z(t,n.showClass.popup),t.style.removeProperty("opacity")},10)):X(t,"grid"),z([document.documentElement,document.body],r.shown),n.heightAuto&&n.backdrop&&!n.toast&&z([document.documentElement,document.body],r["height-auto"])};var qn=(e,t)=>/^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e)?Promise.resolve():Promise.resolve(t||"Invalid email address"),Nn=(e,t)=>/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e)?Promise.resolve():Promise.resolve(t||"Invalid URL");function _n(e){!function(e){e.inputValidator||("email"===e.input&&(e.inputValidator=qn),"url"===e.input&&(e.inputValidator=Nn))}(e),e.showLoaderOnConfirm&&!e.preConfirm&&u("showLoaderOnConfirm is set to true, but preConfirm is not defined.\nshowLoaderOnConfirm should be used together with preConfirm, see usage example:\nhttps://sweetalert2.github.io/#ajax-request"),function(e){(!e.target||"string"==typeof e.target&&!document.querySelector(e.target)||"string"!=typeof e.target&&!e.target.appendChild)&&(u('Target parameter is not valid, defaulting to "body"'),e.target="body")}(e),"string"==typeof e.title&&(e.title=e.title.split("\n").join("<br />")),re(e)}let Fn;var Rn=new WeakMap;class Un{constructor(...t){if(n(this,Rn,Promise.resolve({isConfirmed:!1,isDenied:!1,isDismissed:!0})),"undefined"==typeof window)return;Fn=this;const o=Object.freeze(this.constructor.argsToParams(t));var i,s,r;this.params=o,this.isAwaitingPromise=!1,i=Rn,s=this,r=this._main(Fn.params),i.set(e(i,s),r)}_main(e,t={}){if(tn(Object.assign({},t,e)),o.currentInstance){const e=et.swalPromiseResolve.get(o.currentInstance),{isAwaitingPromise:t}=o.currentInstance;o.currentInstance._destroy(),t||e({isDismissed:!0}),D()&&tt()}o.currentInstance=Fn;const n=Wn(e,t);_n(n),Object.freeze(n),o.timeout&&(o.timeout.stop(),delete o.timeout),clearTimeout(o.restoreFocusTimeout);const i=Kn(Fn);return Fe(Fn,n),me.innerParams.set(Fn,n),zn(Fn,i,n)}then(e){return t(Rn,this).then(e)}finally(e){return t(Rn,this).finally(e)}}const zn=(e,t,n)=>new Promise((i,s)=>{const r=t=>{e.close({isDismissed:!0,dismiss:t,isConfirmed:!1,isDenied:!1})};et.swalPromiseResolve.set(e,i),et.swalPromiseReject.set(e,s),t.confirmButton.onclick=()=>{(e=>{const t=me.innerParams.get(e);e.disableButtons(),t.input?Pt(e,"confirm"):Mt(e,!0)})(e)},t.denyButton.onclick=()=>{(e=>{const t=me.innerParams.get(e);e.disableButtons(),t.returnInputValueOnDeny?Pt(e,"deny"):Tt(e,!1)})(e)},t.cancelButton.onclick=()=>{((e,t)=>{e.disableButtons(),t(Ue.cancel)})(e,r)},t.closeButton.onclick=()=>{r(Ue.close)},((e,t,n)=>{e.toast?un(e,t,n):(mn(t),hn(t),gn(e,t,n))})(n,t,r),((e,t,n)=>{if(ze(e),!t.toast){const o=e=>Xe(t,e,n);e.keydownHandler=o;const i=t.keydownListenerCapture?window:C();if(i){e.keydownTarget=i,e.keydownListenerCapture=t.keydownListenerCapture;const n=o;e.keydownTarget.addEventListener("keydown",n,{capture:e.keydownListenerCapture}),e.keydownHandlerAdded=!0}}})(o,n,r),((e,t)=>{"select"===t.input||"radio"===t.input?kt(e,t):["text","email","number","tel","textarea"].some(e=>e===t.input)&&(g(t.inputValue)||b(t.inputValue))&&(vt(P()),Bt(e,t))})(e,n),Hn(n),Yn(o,n,r),Xn(t,n),setTimeout(()=>{t.container.scrollTop=0})}),Wn=(e,t)=>{const n=(e=>{const t="string"==typeof e.template?document.querySelector(e.template):e.template;if(!t)return{};const n=t.content;return On(n),Object.assign(Bn(n),$n(n),Ln(n),Pn(n),xn(n),Tn(n),Sn(n,kn))})(e),o=Object.assign({},zt,t,n,e);return o.showClass=Object.assign({},zt.showClass,o.showClass),o.hideClass=Object.assign({},zt.hideClass,o.hideClass),!1===o.animation&&(o.showClass={backdrop:"swal2-noanimation"},o.hideClass={}),o},Kn=e=>{const t={popup:C(),container:y(),actions:O(),confirmButton:P(),denyButton:T(),cancelButton:x(),loader:S(),closeButton:j(),validationMessage:L(),progressSteps:$()};return me.domCache.set(e,t),t},Yn=(e,t,n)=>{const o=H();Z(o),t.timer&&(e.timeout=new En(()=>{n("timer"),delete e.timeout},t.timer),t.timerProgressBar&&o&&(X(o),_(o,t,"timerProgressBar"),setTimeout(()=>{e.timeout&&e.timeout.running&&oe(t.timer)})))},Xn=(e,t)=>{if(!t.toast)return h(t.allowEnterKey)?void(Zn(e)||Jn(e,t)||We(-1,1)):(m("allowEnterKey","preConfirm: () => false"),void e.popup.focus())},Zn=e=>{const t=Array.from(e.popup.querySelectorAll("[autofocus]"));for(const e of t)if(e instanceof HTMLElement&&ee(e))return e.focus(),!0;return!1},Jn=(e,t)=>t.focusDeny&&ee(e.denyButton)?(e.denyButton.focus(),!0):t.focusCancel&&ee(e.cancelButton)?(e.cancelButton.focus(),!0):!(!t.focusConfirm||!ee(e.confirmButton))&&(e.confirmButton.focus(),!0);Un.prototype.disableButtons=Nt,Un.prototype.enableButtons=qt,Un.prototype.getInput=It,Un.prototype.disableInput=Ft,Un.prototype.enableInput=_t,Un.prototype.hideLoading=Ht,Un.prototype.disableLoading=Ht,Un.prototype.showValidationMessage=Rt,Un.prototype.resetValidationMessage=Ut,Un.prototype.close=dt,Un.prototype.closePopup=dt,Un.prototype.closeModal=dt,Un.prototype.closeToast=dt,Un.prototype.rejectPromise=mt,Un.prototype.update=nn,Un.prototype._destroy=sn,Object.assign(Un,An),Object.keys(cn).forEach(e=>{Un[e]=function(...t){if(Fn&&Fn[e])return Fn[e](...t)}}),Un.DismissReason=Ue,Un.version="11.26.25";const Gn=Un;return Gn.default=Gn,Gn}),void 0!==this&&this.Sweetalert2&&(this.swal=this.sweetAlert=this.Swal=this.SweetAlert=this.Sweetalert2);

!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});

/*!
 * 
 * Super simple WYSIWYG editor v0.9.0
 * https://summernote.org
 *
 * Copyright 2013~ Hackerwins and contributors
 * Summernote may be freely distributed under the MIT license.
 *
 * Date: 2024-09-28T13:18Z
 *
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"));
	else if(typeof define === 'function' && define.amd)
		define(["jquery"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("jquery")) : factory(root["jQuery"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, (__WEBPACK_EXTERNAL_MODULE__8938__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 7000:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8938);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);

(jquery__WEBPACK_IMPORTED_MODULE_0___default().summernote) = (jquery__WEBPACK_IMPORTED_MODULE_0___default().summernote) || {
  lang: {}
};
jquery__WEBPACK_IMPORTED_MODULE_0___default().extend(true, (jquery__WEBPACK_IMPORTED_MODULE_0___default().summernote).lang, {
  'en-US': {
    font: {
      bold: 'Bold',
      italic: 'Italic',
      underline: 'Underline',
      clear: 'Remove Font Style',
      height: 'Line Height',
      name: 'Font Family',
      strikethrough: 'Strikethrough',
      subscript: 'Subscript',
      superscript: 'Superscript',
      size: 'Font Size',
      sizeunit: 'Font Size Unit'
    },
    image: {
      image: 'Picture',
      insert: 'Insert Image',
      resizeFull: 'Resize full',
      resizeHalf: 'Resize half',
      resizeQuarter: 'Resize quarter',
      resizeNone: 'Original size',
      floatLeft: 'Float Left',
      floatRight: 'Float Right',
      floatNone: 'Remove float',
      shapeRounded: 'Shape: Rounded',
      shapeCircle: 'Shape: Circle',
      shapeThumbnail: 'Shape: Thumbnail',
      shapeNone: 'Shape: None',
      dragImageHere: 'Drag image or text here',
      dropImage: 'Drop image or Text',
      selectFromFiles: 'Select from files',
      maximumFileSize: 'Maximum file size',
      maximumFileSizeError: 'Maximum file size exceeded.',
      url: 'Image URL',
      remove: 'Remove Image',
      original: 'Original'
    },
    video: {
      video: 'Video',
      videoLink: 'Video Link',
      insert: 'Insert Video',
      url: 'Video URL',
      providers: '(YouTube, Google Drive, Vimeo, Vine, Instagram, DailyMotion, Youku, Peertube)'
    },
    link: {
      link: 'Link',
      insert: 'Insert Link',
      unlink: 'Unlink',
      edit: 'Edit',
      textToDisplay: 'Text to display',
      url: 'To what URL should this link go?',
      openInNewWindow: 'Open in new window'
    },
    table: {
      table: 'Table',
      addRowAbove: 'Add row above',
      addRowBelow: 'Add row below',
      addColLeft: 'Add column left',
      addColRight: 'Add column right',
      delRow: 'Delete row',
      delCol: 'Delete column',
      delTable: 'Delete table'
    },
    hr: {
      insert: 'Insert Horizontal Rule'
    },
    style: {
      style: 'Style',
      p: 'Normal',
      blockquote: 'Quote',
      pre: 'Code',
      h1: 'Header 1',
      h2: 'Header 2',
      h3: 'Header 3',
      h4: 'Header 4',
      h5: 'Header 5',
      h6: 'Header 6'
    },
    lists: {
      unordered: 'Unordered list',
      ordered: 'Ordered list'
    },
    options: {
      help: 'Help',
      fullscreen: 'Full Screen',
      codeview: 'Code View'
    },
    paragraph: {
      paragraph: 'Paragraph',
      outdent: 'Outdent',
      indent: 'Indent',
      left: 'Align left',
      center: 'Align center',
      right: 'Align right',
      justify: 'Justify full'
    },
    color: {
      recent: 'Recent Color',
      more: 'More Color',
      background: 'Background Color',
      foreground: 'Text Color',
      transparent: 'Transparent',
      setTransparent: 'Set transparent',
      reset: 'Reset',
      resetToDefault: 'Reset to default',
      cpSelect: 'Select'
    },
    shortcut: {
      shortcuts: 'Keyboard shortcuts',
      close: 'Close',
      textFormatting: 'Text formatting',
      action: 'Action',
      paragraphFormatting: 'Paragraph formatting',
      documentStyle: 'Document Style',
      extraKeys: 'Extra keys'
    },
    help: {
      'escape': 'Escape',
      'insertParagraph': 'Insert Paragraph',
      'undo': 'Undo the last command',
      'redo': 'Redo the last command',
      'tab': 'Tab',
      'untab': 'Untab',
      'bold': 'Set a bold style',
      'italic': 'Set a italic style',
      'underline': 'Set a underline style',
      'strikethrough': 'Set a strikethrough style',
      'removeFormat': 'Clean a style',
      'justifyLeft': 'Set left align',
      'justifyCenter': 'Set center align',
      'justifyRight': 'Set right align',
      'justifyFull': 'Set full align',
      'insertUnorderedList': 'Toggle unordered list',
      'insertOrderedList': 'Toggle ordered list',
      'outdent': 'Outdent on current paragraph',
      'indent': 'Indent on current paragraph',
      'formatPara': 'Change current block\'s format as a paragraph(P tag)',
      'formatH1': 'Change current block\'s format as H1',
      'formatH2': 'Change current block\'s format as H2',
      'formatH3': 'Change current block\'s format as H3',
      'formatH4': 'Change current block\'s format as H4',
      'formatH5': 'Change current block\'s format as H5',
      'formatH6': 'Change current block\'s format as H6',
      'insertHorizontalRule': 'Insert horizontal rule',
      'linkDialog.show': 'Show Link Dialog'
    },
    history: {
      undo: 'Undo',
      redo: 'Redo'
    },
    specialChar: {
      specialChar: 'SPECIAL CHARACTERS',
      select: 'Select Special characters'
    },
    output: {
      noSelection: 'No Selection Made!'
    }
  }
});

/***/ }),

/***/ 8938:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__8938__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};

// EXTERNAL MODULE: external {"root":"jQuery","commonjs":"jquery","commonjs2":"jquery","amd":"jquery"}
var external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_ = __webpack_require__(8938);
var external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default = /*#__PURE__*/__webpack_require__.n(external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_);
// EXTERNAL MODULE: ./src/lang/summernote-en-US.js
var summernote_en_US = __webpack_require__(7000);
;// CONCATENATED MODULE: ./src/js/core/env.js


/**
 * returns whether font is installed or not.
 *
 * @param {String} fontName
 * @return {Boolean}
 */
var genericFontFamilies = ['sans-serif', 'serif', 'monospace', 'cursive', 'fantasy'];
function validFontName(fontName) {
  return external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().inArray(fontName.toLowerCase(), genericFontFamilies) === -1 ? "'".concat(fontName, "'") : fontName;
}
function createIsFontInstalledFunc() {
  var testText = "mw";
  var fontSize = "20px";
  var canvasWidth = 40;
  var canvasHeight = 20;
  var canvas = document.createElement("canvas");
  var context = canvas.getContext("2d", {
    willReadFrequently: true
  });
  canvas.width = canvasWidth;
  canvas.height = canvasHeight;
  context.textAlign = "center";
  context.fillStyle = "black";
  context.textBaseline = "middle";
  function getPxInfo(font, testFontName) {
    context.clearRect(0, 0, canvasWidth, canvasHeight);
    context.font = fontSize + ' ' + validFontName(font) + ', "' + testFontName + '"';
    context.fillText(testText, canvasWidth / 2, canvasHeight / 2);
    // Get pixel information
    var pxInfo = context.getImageData(0, 0, canvasWidth, canvasHeight).data;
    return pxInfo.join("");
  }
  return function (fontName) {
    var testFontName = fontName === 'Comic Sans MS' ? 'Courier New' : 'Comic Sans MS';
    var testInfo = getPxInfo(testFontName, testFontName);
    var fontInfo = getPxInfo(fontName, testFontName);
    return testInfo !== fontInfo;
  };
}
var userAgent = navigator.userAgent;
var isMSIE = /MSIE|Trident/i.test(userAgent);
var browserVersion;
if (isMSIE) {
  var matches = /MSIE (\d+[.]\d+)/.exec(userAgent);
  if (matches) {
    browserVersion = parseFloat(matches[1]);
  }
  matches = /Trident\/.*rv:([0-9]{1,}[.0-9]{0,})/.exec(userAgent);
  if (matches) {
    browserVersion = parseFloat(matches[1]);
  }
}
var isEdge = /Edge\/\d+/.test(userAgent);
var isSupportTouch = 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

// [workaround] IE doesn't have input events for contentEditable
// - see: https://goo.gl/4bfIvA
var inputEventName = isMSIE ? 'DOMCharacterDataModified DOMSubtreeModified DOMNodeInserted' : 'input';

/**
 * @class core.env
 *
 * Object which check platform and agent
 *
 * @singleton
 * @alternateClassName env
 */
/* harmony default export */ const env = ({
  isMac: navigator.appVersion.indexOf('Mac') > -1,
  isMSIE: isMSIE,
  isEdge: isEdge,
  isFF: !isEdge && /firefox/i.test(userAgent),
  isPhantom: /PhantomJS/i.test(userAgent),
  isWebkit: !isEdge && /webkit/i.test(userAgent),
  isChrome: !isEdge && /chrome/i.test(userAgent),
  isSafari: !isEdge && /safari/i.test(userAgent) && !/chrome/i.test(userAgent),
  browserVersion: browserVersion,
  isSupportTouch: isSupportTouch,
  isFontInstalled: createIsFontInstalledFunc(),
  isW3CRangeSupport: !!document.createRange,
  inputEventName: inputEventName,
  genericFontFamilies: genericFontFamilies,
  validFontName: validFontName
});
;// CONCATENATED MODULE: ./src/js/core/func.js


/**
 * @class core.func
 *
 * func utils (for high-order func's arg)
 *
 * @singleton
 * @alternateClassName func
 */
function eq(itemA) {
  return function (itemB) {
    return itemA === itemB;
  };
}
function eq2(itemA, itemB) {
  return itemA === itemB;
}
function peq2(propName) {
  return function (itemA, itemB) {
    return itemA[propName] === itemB[propName];
  };
}
function ok() {
  return true;
}
function fail() {
  return false;
}
function not(f) {
  return function () {
    return !f.apply(f, arguments);
  };
}
function and(fA, fB) {
  return function (item) {
    return fA(item) && fB(item);
  };
}
function func_self(a) {
  return a;
}
function invoke(obj, method) {
  return function () {
    return obj[method].apply(obj, arguments);
  };
}
var idCounter = 0;

/**
 * reset globally-unique id
 *
 */
function resetUniqueId() {
  idCounter = 0;
}

/**
 * generate a globally-unique id
 *
 * @param {String} [prefix]
 */
function uniqueId(prefix) {
  var id = ++idCounter + '';
  return prefix ? prefix + id : id;
}

/**
 * returns bnd (bounds) from rect
 *
 * - IE Compatibility Issue: http://goo.gl/sRLOAo
 * - Scroll Issue: http://goo.gl/sNjUc
 *
 * @param {Rect} rect
 * @return {Object} bounds
 * @return {Number} bounds.top
 * @return {Number} bounds.left
 * @return {Number} bounds.width
 * @return {Number} bounds.height
 */
function rect2bnd(rect) {
  var $document = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(document);
  return {
    top: rect.top + $document.scrollTop(),
    left: rect.left + $document.scrollLeft(),
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };
}

/**
 * returns a copy of the object where the keys have become the values and the values the keys.
 * @param {Object} obj
 * @return {Object}
 */
function invertObject(obj) {
  var inverted = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      inverted[obj[key]] = key;
    }
  }
  return inverted;
}

/**
 * @param {String} namespace
 * @param {String} [prefix]
 * @return {String}
 */
function namespaceToCamel(namespace, prefix) {
  prefix = prefix || '';
  return prefix + namespace.split('.').map(function (name) {
    return name.substring(0, 1).toUpperCase() + name.substring(1);
  }).join('');
}

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 * @param {Function} func
 * @param {Number} wait
 * @param {Boolean} immediate
 * @return {Function}
 */
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this;
    var args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
}

/**
 *
 * @param {String} url
 * @return {Boolean}
 */
function isValidUrl(url) {
  var expression = /[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi;
  return expression.test(url);
}
/* harmony default export */ const func = ({
  eq: eq,
  eq2: eq2,
  peq2: peq2,
  ok: ok,
  fail: fail,
  self: func_self,
  not: not,
  and: and,
  invoke: invoke,
  resetUniqueId: resetUniqueId,
  uniqueId: uniqueId,
  rect2bnd: rect2bnd,
  invertObject: invertObject,
  namespaceToCamel: namespaceToCamel,
  debounce: debounce,
  isValidUrl: isValidUrl
});
;// CONCATENATED MODULE: ./src/js/core/lists.js


/**
 * returns the first item of an array.
 *
 * @param {Array} array
 */
function head(array) {
  return array[0];
}

/**
 * returns the last item of an array.
 *
 * @param {Array} array
 */
function last(array) {
  return array[array.length - 1];
}

/**
 * returns everything but the last entry of the array.
 *
 * @param {Array} array
 */
function initial(array) {
  return array.slice(0, array.length - 1);
}

/**
 * returns the rest of the items in an array.
 *
 * @param {Array} array
 */
function tail(array) {
  return array.slice(1);
}

/**
 * returns item of array
 */
function find(array, pred) {
  for (var idx = 0, len = array.length; idx < len; idx++) {
    var item = array[idx];
    if (pred(item)) {
      return item;
    }
  }
}

/**
 * returns true if all of the values in the array pass the predicate truth test.
 */
function lists_all(array, pred) {
  for (var idx = 0, len = array.length; idx < len; idx++) {
    if (!pred(array[idx])) {
      return false;
    }
  }
  return true;
}

/**
 * returns true if the value is present in the list.
 */
function contains(array, item) {
  if (array && array.length && item) {
    if (array.indexOf) {
      return array.indexOf(item) !== -1;
    } else if (array.contains) {
      // `DOMTokenList` doesn't implement `.indexOf`, but it implements `.contains`
      return array.contains(item);
    }
  }
  return false;
}

/**
 * get sum from a list
 *
 * @param {Array} array - array
 * @param {Function} fn - iterator
 */
function sum(array, fn) {
  fn = fn || func.self;
  return array.reduce(function (memo, v) {
    return memo + fn(v);
  }, 0);
}

/**
 * returns a copy of the collection with array type.
 * @param {Collection} collection - collection eg) node.childNodes, ...
 */
function from(collection) {
  var result = [];
  var length = collection.length;
  var idx = -1;
  while (++idx < length) {
    result[idx] = collection[idx];
  }
  return result;
}

/**
 * returns whether list is empty or not
 */
function isEmpty(array) {
  return !array || !array.length;
}

/**
 * cluster elements by predicate function.
 *
 * @param {Array} array - array
 * @param {Function} fn - predicate function for cluster rule
 * @param {Array[]}
 */
function clusterBy(array, fn) {
  if (!array.length) {
    return [];
  }
  var aTail = tail(array);
  return aTail.reduce(function (memo, v) {
    var aLast = last(memo);
    if (fn(last(aLast), v)) {
      aLast[aLast.length] = v;
    } else {
      memo[memo.length] = [v];
    }
    return memo;
  }, [[head(array)]]);
}

/**
 * returns a copy of the array with all false values removed
 *
 * @param {Array} array - array
 * @param {Function} fn - predicate function for cluster rule
 */
function compact(array) {
  var aResult = [];
  for (var idx = 0, len = array.length; idx < len; idx++) {
    if (array[idx]) {
      aResult.push(array[idx]);
    }
  }
  return aResult;
}

/**
 * produces a duplicate-free version of the array
 *
 * @param {Array} array
 */
function unique(array) {
  var results = [];
  for (var idx = 0, len = array.length; idx < len; idx++) {
    if (!contains(results, array[idx])) {
      results.push(array[idx]);
    }
  }
  return results;
}

/**
 * returns next item.
 * @param {Array} array
 */
function next(array, item) {
  if (array && array.length && item) {
    var idx = array.indexOf(item);
    return idx === -1 ? null : array[idx + 1];
  }
  return null;
}

/**
 * returns prev item.
 * @param {Array} array
 */
function prev(array, item) {
  if (array && array.length && item) {
    var idx = array.indexOf(item);
    return idx === -1 ? null : array[idx - 1];
  }
  return null;
}

/**
 * @class core.list
 *
 * list utils
 *
 * @singleton
 * @alternateClassName list
 */
/* harmony default export */ const lists = ({
  head: head,
  last: last,
  initial: initial,
  tail: tail,
  prev: prev,
  next: next,
  find: find,
  contains: contains,
  all: lists_all,
  sum: sum,
  from: from,
  isEmpty: isEmpty,
  clusterBy: clusterBy,
  compact: compact,
  unique: unique
});
;// CONCATENATED MODULE: ./src/js/core/dom.js




var NBSP_CHAR = String.fromCharCode(160);
var ZERO_WIDTH_NBSP_CHAR = "\uFEFF";

/**
 * @method isEditable
 *
 * returns whether node is `note-editable` or not.
 *
 * @param {Node} node
 * @return {Boolean}
 */
function isEditable(node) {
  return node && external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(node).hasClass('note-editable');
}

/**
 * @method isControlSizing
 *
 * returns whether node is `note-control-sizing` or not.
 *
 * @param {Node} node
 * @return {Boolean}
 */
function isControlSizing(node) {
  return node && external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(node).hasClass('note-control-sizing');
}

/**
 * @method makePredByNodeName
 *
 * returns predicate which judge whether nodeName is same
 *
 * @param {String} nodeName
 * @return {Function}
 */
function makePredByNodeName(nodeName) {
  nodeName = nodeName.toUpperCase();
  return function (node) {
    return node && node.nodeName.toUpperCase() === nodeName;
  };
}

/**
 * @method isText
 *
 *
 *
 * @param {Node} node
 * @return {Boolean} true if node's type is text(3)
 */
function isText(node) {
  return node && node.nodeType === 3;
}

/**
 * @method isElement
 *
 *
 *
 * @param {Node} node
 * @return {Boolean} true if node's type is element(1)
 */
function isElement(node) {
  return node && node.nodeType === 1;
}

/**
 * ex) br, col, embed, hr, img, input, ...
 * @see http://www.w3.org/html/wg/drafts/html/master/syntax.html#void-elements
 */
function isVoid(node) {
  return node && /^BR|^IMG|^HR|^IFRAME|^BUTTON|^INPUT|^AUDIO|^VIDEO|^EMBED/.test(node.nodeName.toUpperCase());
}
function isPara(node) {
  if (isEditable(node)) {
    return false;
  }

  // Chrome(v31.0), FF(v25.0.1) use DIV for paragraph
  return node && /^DIV|^P|^LI|^H[1-7]/.test(node.nodeName.toUpperCase());
}
function isHeading(node) {
  return node && /^H[1-7]/.test(node.nodeName.toUpperCase());
}
var isPre = makePredByNodeName('PRE');
var isLi = makePredByNodeName('LI');
function isPurePara(node) {
  return isPara(node) && !isLi(node);
}
var isTable = makePredByNodeName('TABLE');
var isData = makePredByNodeName('DATA');
function isInline(node) {
  return !isBodyContainer(node) && !isList(node) && !isHr(node) && !isPara(node) && !isTable(node) && !isBlockquote(node) && !isData(node);
}
function isList(node) {
  return node && /^UL|^OL/.test(node.nodeName.toUpperCase());
}
var isHr = makePredByNodeName('HR');
function isCell(node) {
  return node && /^TD|^TH/.test(node.nodeName.toUpperCase());
}
var isBlockquote = makePredByNodeName('BLOCKQUOTE');
function isBodyContainer(node) {
  return isCell(node) || isBlockquote(node) || isEditable(node);
}
var isAnchor = makePredByNodeName('A');
function isParaInline(node) {
  return isInline(node) && !!ancestor(node, isPara);
}
function isBodyInline(node) {
  return isInline(node) && !ancestor(node, isPara);
}
var isBody = makePredByNodeName('BODY');

/**
 * returns whether nodeB is closest sibling of nodeA
 *
 * @param {Node} nodeA
 * @param {Node} nodeB
 * @return {Boolean}
 */
function isClosestSibling(nodeA, nodeB) {
  return nodeA.nextSibling === nodeB || nodeA.previousSibling === nodeB;
}

/**
 * returns array of closest siblings with node
 *
 * @param {Node} node
 * @param {function} [pred] - predicate function
 * @return {Node[]}
 */
function withClosestSiblings(node, pred) {
  pred = pred || func.ok;
  var siblings = [];
  if (node.previousSibling && pred(node.previousSibling)) {
    siblings.push(node.previousSibling);
  }
  siblings.push(node);
  if (node.nextSibling && pred(node.nextSibling)) {
    siblings.push(node.nextSibling);
  }
  return siblings;
}

/**
 * blank HTML for cursor position
 * - [workaround] old IE only works with &nbsp;
 * - [workaround] IE11 and other browser works with bogus br
 */
var blankHTML = env.isMSIE && env.browserVersion < 11 ? '&nbsp;' : '<br>';

/**
 * @method nodeLength
 *
 * returns #text's text size or element's childNodes size
 *
 * @param {Node} node
 */
function nodeLength(node) {
  if (isText(node)) {
    return node.nodeValue.length;
  }
  if (node) {
    return node.childNodes.length;
  }
  return 0;
}

/**
 * returns whether deepest child node is empty or not.
 *
 * @param {Node} node
 * @return {Boolean}
 */
function deepestChildIsEmpty(node) {
  do {
    if (node.firstElementChild === null || node.firstElementChild.innerHTML === '') break;
  } while (node = node.firstElementChild);
  return dom_isEmpty(node);
}

/**
 * returns whether node is empty or not.
 *
 * @param {Node} node
 * @return {Boolean}
 */
function dom_isEmpty(node) {
  var len = nodeLength(node);
  if (len === 0) {
    return true;
  } else if (!isText(node) && len === 1 && node.innerHTML === blankHTML) {
    // ex) <p><br></p>, <span><br></span>
    return true;
  } else if (lists.all(node.childNodes, isText) && node.innerHTML === '') {
    // ex) <p></p>, <span></span>
    return true;
  }
  return false;
}

/**
 * padding blankHTML if node is empty (for cursor position)
 */
function paddingBlankHTML(node) {
  if (!isVoid(node) && !nodeLength(node)) {
    node.innerHTML = blankHTML;
  }
}

/**
 * find nearest ancestor predicate hit
 *
 * @param {Node} node
 * @param {Function} pred - predicate function
 */
function ancestor(node, pred) {
  while (node) {
    if (pred(node)) {
      return node;
    }
    if (isEditable(node)) {
      break;
    }
    node = node.parentNode;
  }
  return null;
}

/**
 * find nearest ancestor only single child blood line and predicate hit
 *
 * @param {Node} node
 * @param {Function} pred - predicate function
 */
function singleChildAncestor(node, pred) {
  node = node.parentNode;
  while (node) {
    if (nodeLength(node) !== 1) {
      break;
    }
    if (pred(node)) {
      return node;
    }
    if (isEditable(node)) {
      break;
    }
    node = node.parentNode;
  }
  return null;
}

/**
 * returns new array of ancestor nodes (until predicate hit).
 *
 * @param {Node} node
 * @param {Function} [optional] pred - predicate function
 */
function listAncestor(node, pred) {
  pred = pred || func.fail;
  var ancestors = [];
  ancestor(node, function (el) {
    if (!isEditable(el)) {
      ancestors.push(el);
    }
    return pred(el);
  });
  return ancestors;
}

/**
 * find farthest ancestor predicate hit
 */
function lastAncestor(node, pred) {
  var ancestors = listAncestor(node);
  return lists.last(ancestors.filter(pred));
}

/**
 * returns common ancestor node between two nodes.
 *
 * @param {Node} nodeA
 * @param {Node} nodeB
 */
function commonAncestor(nodeA, nodeB) {
  var ancestors = listAncestor(nodeA);
  for (var n = nodeB; n; n = n.parentNode) {
    if (ancestors.indexOf(n) > -1) return n;
  }
  return null; // difference document area
}

/**
 * listing all previous siblings (until predicate hit).
 *
 * @param {Node} node
 * @param {Function} [optional] pred - predicate function
 */
function listPrev(node, pred) {
  pred = pred || func.fail;
  var nodes = [];
  while (node) {
    if (pred(node)) {
      break;
    }
    nodes.push(node);
    node = node.previousSibling;
  }
  return nodes;
}

/**
 * listing next siblings (until predicate hit).
 *
 * @param {Node} node
 * @param {Function} [pred] - predicate function
 */
function listNext(node, pred) {
  pred = pred || func.fail;
  var nodes = [];
  while (node) {
    if (pred(node)) {
      break;
    }
    nodes.push(node);
    node = node.nextSibling;
  }
  return nodes;
}

/**
 * listing descendant nodes
 *
 * @param {Node} node
 * @param {Function} [pred] - predicate function
 */
function listDescendant(node, pred) {
  var descendants = [];
  pred = pred || func.ok;

  // start DFS(depth first search) with node
  (function fnWalk(current) {
    if (node !== current && pred(current)) {
      descendants.push(current);
    }
    for (var idx = 0, len = current.childNodes.length; idx < len; idx++) {
      fnWalk(current.childNodes[idx]);
    }
  })(node);
  return descendants;
}

/**
 * wrap node with new tag.
 *
 * @param {Node} node
 * @param {Node} tagName of wrapper
 * @return {Node} - wrapper
 */
function wrap(node, wrapperName) {
  var parent = node.parentNode;
  var wrapper = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<' + wrapperName + '>')[0];
  parent.insertBefore(wrapper, node);
  wrapper.appendChild(node);
  return wrapper;
}

/**
 * insert node after preceding
 *
 * @param {Node} node
 * @param {Node} preceding - predicate function
 */
function insertAfter(node, preceding) {
  var next = preceding.nextSibling;
  var parent = preceding.parentNode;
  if (next) {
    parent.insertBefore(node, next);
  } else {
    parent.appendChild(node);
  }
  return node;
}

/**
 * append elements.
 *
 * @param {Node} node
 * @param {Collection} aChild
 */
function appendChildNodes(node, aChild, isSkipPaddingBlankHTML) {
  external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(aChild, function (idx, child) {
    // special case: appending a pure UL/OL to a LI element creates inaccessible LI element
    // e.g. press enter in last LI which has UL/OL-subelements
    // Therefore, if current node is LI element with no child nodes (text-node) and appending a list, add a br before
    if (!isSkipPaddingBlankHTML && isLi(node) && node.firstChild === null && isList(child)) {
      node.appendChild(create("br"));
    }
    node.appendChild(child);
  });
  return node;
}

/**
 * returns whether boundaryPoint is left edge or not.
 *
 * @param {BoundaryPoint} point
 * @return {Boolean}
 */
function isLeftEdgePoint(point) {
  return point.offset === 0;
}

/**
 * returns whether boundaryPoint is right edge or not.
 *
 * @param {BoundaryPoint} point
 * @return {Boolean}
 */
function isRightEdgePoint(point) {
  return point.offset === nodeLength(point.node);
}

/**
 * returns whether boundaryPoint is edge or not.
 *
 * @param {BoundaryPoint} point
 * @return {Boolean}
 */
function isEdgePoint(point) {
  return isLeftEdgePoint(point) || isRightEdgePoint(point);
}

/**
 * returns whether node is left edge of ancestor or not.
 *
 * @param {Node} node
 * @param {Node} ancestor
 * @return {Boolean}
 */
function isLeftEdgeOf(node, ancestor) {
  while (node && node !== ancestor) {
    if (position(node) !== 0) {
      return false;
    }
    node = node.parentNode;
  }
  return true;
}

/**
 * returns whether node is right edge of ancestor or not.
 *
 * @param {Node} node
 * @param {Node} ancestor
 * @return {Boolean}
 */
function isRightEdgeOf(node, ancestor) {
  if (!ancestor) {
    return false;
  }
  while (node && node !== ancestor) {
    if (position(node) !== nodeLength(node.parentNode) - 1) {
      return false;
    }
    node = node.parentNode;
  }
  return true;
}

/**
 * returns whether point is left edge of ancestor or not.
 * @param {BoundaryPoint} point
 * @param {Node} ancestor
 * @return {Boolean}
 */
function isLeftEdgePointOf(point, ancestor) {
  return isLeftEdgePoint(point) && isLeftEdgeOf(point.node, ancestor);
}

/**
 * returns whether point is right edge of ancestor or not.
 * @param {BoundaryPoint} point
 * @param {Node} ancestor
 * @return {Boolean}
 */
function isRightEdgePointOf(point, ancestor) {
  return isRightEdgePoint(point) && isRightEdgeOf(point.node, ancestor);
}

/**
 * returns offset from parent.
 *
 * @param {Node} node
 */
function position(node) {
  var offset = 0;
  while (node = node.previousSibling) {
    offset += 1;
  }
  return offset;
}
function hasChildren(node) {
  return !!(node && node.childNodes && node.childNodes.length);
}

/**
 * returns previous boundaryPoint
 *
 * @param {BoundaryPoint} point
 * @param {Boolean} isSkipInnerOffset
 * @return {BoundaryPoint}
 */
function prevPoint(point, isSkipInnerOffset) {
  var node;
  var offset;
  if (point.offset === 0) {
    if (isEditable(point.node)) {
      return null;
    }
    node = point.node.parentNode;
    offset = position(point.node);
  } else if (hasChildren(point.node)) {
    node = point.node.childNodes[point.offset - 1];
    offset = nodeLength(node);
  } else {
    node = point.node;
    offset = isSkipInnerOffset ? 0 : point.offset - 1;
  }
  return {
    node: node,
    offset: offset
  };
}

/**
 * returns next boundaryPoint
 *
 * @param {BoundaryPoint} point
 * @param {Boolean} isSkipInnerOffset
 * @return {BoundaryPoint}
 */
function nextPoint(point, isSkipInnerOffset) {
  var node, offset;
  if (nodeLength(point.node) === point.offset) {
    if (isEditable(point.node)) {
      return null;
    }
    var nextTextNode = getNextTextNode(point.node);
    if (nextTextNode) {
      node = nextTextNode;
      offset = 0;
    } else {
      node = point.node.parentNode;
      offset = position(point.node) + 1;
    }
  } else if (hasChildren(point.node)) {
    node = point.node.childNodes[point.offset];
    offset = 0;
  } else {
    node = point.node;
    offset = isSkipInnerOffset ? nodeLength(point.node) : point.offset + 1;
  }
  return {
    node: node,
    offset: offset
  };
}

/**
 * Find next boundaryPoint for preorder / depth first traversal of the DOM
 * returns next boundaryPoint with empty node
 *
 * @param {BoundaryPoint} point
 * @param {Boolean} isSkipInnerOffset
 * @return {BoundaryPoint}
 */
function nextPointWithEmptyNode(point, isSkipInnerOffset) {
  var node,
    offset = 0;
  if (nodeLength(point.node) === point.offset) {
    if (isEditable(point.node)) {
      return null;
    }
    node = point.node.parentNode;
    offset = position(point.node) + 1;

    // if parent node is editable,  return current node's sibling node.
    if (isEditable(node)) {
      node = point.node.nextSibling;
      offset = 0;
    }
  } else if (hasChildren(point.node)) {
    node = point.node.childNodes[point.offset];
    offset = 0;
  } else {
    node = point.node;
    offset = isSkipInnerOffset ? nodeLength(point.node) : point.offset + 1;
  }
  return {
    node: node,
    offset: offset
  };
}

/*
* returns the next Text node index or 0 if not found.
*/
function getNextTextNode(actual) {
  if (!actual.nextSibling) return undefined;
  if (actual.parent !== actual.nextSibling.parent) return undefined;
  if (isText(actual.nextSibling)) return actual.nextSibling;else return getNextTextNode(actual.nextSibling);
}

/**
 * returns whether pointA and pointB is same or not.
 *
 * @param {BoundaryPoint} pointA
 * @param {BoundaryPoint} pointB
 * @return {Boolean}
 */
function isSamePoint(pointA, pointB) {
  return pointA.node === pointB.node && pointA.offset === pointB.offset;
}

/**
 * returns whether point is visible (can set cursor) or not.
 *
 * @param {BoundaryPoint} point
 * @return {Boolean}
 */
function isVisiblePoint(point) {
  if (isText(point.node) || !hasChildren(point.node) || dom_isEmpty(point.node)) {
    return true;
  }
  var leftNode = point.node.childNodes[point.offset - 1];
  var rightNode = point.node.childNodes[point.offset];
  if ((!leftNode || isVoid(leftNode)) && (!rightNode || isVoid(rightNode)) || isTable(rightNode)) {
    return true;
  }
  return false;
}

/**
 * @method prevPointUtil
 *
 * @param {BoundaryPoint} point
 * @param {Function} pred
 * @return {BoundaryPoint}
 */
function prevPointUntil(point, pred) {
  while (point) {
    if (pred(point)) {
      return point;
    }
    point = prevPoint(point);
  }
  return null;
}

/**
 * @method nextPointUntil
 *
 * @param {BoundaryPoint} point
 * @param {Function} pred
 * @return {BoundaryPoint}
 */
function nextPointUntil(point, pred) {
  while (point) {
    if (pred(point)) {
      return point;
    }
    point = nextPoint(point);
  }
  return null;
}

/**
 * returns whether point has character or not.
 *
 * @param {Point} point
 * @return {Boolean}
 */
function isCharPoint(point) {
  if (!isText(point.node)) {
    return false;
  }
  var ch = point.node.nodeValue.charAt(point.offset - 1);
  return ch && ch !== ' ' && ch !== NBSP_CHAR;
}

/**
 * returns whether point has space or not.
 *
 * @param {Point} point
 * @return {Boolean}
 */
function isSpacePoint(point) {
  if (!isText(point.node)) {
    return false;
  }
  var ch = point.node.nodeValue.charAt(point.offset - 1);
  return ch === ' ' || ch === NBSP_CHAR;
}

/**
 * @method walkPoint - preorder / depth first traversal of the DOM
 *
 * @param {BoundaryPoint} startPoint
 * @param {BoundaryPoint} endPoint
 * @param {Function} handler
 * @param {Boolean} isSkipInnerOffset
 */
function walkPoint(startPoint, endPoint, handler, isSkipInnerOffset) {
  var point = startPoint;
  while (point && point.node) {
    handler(point);
    if (isSamePoint(point, endPoint)) {
      break;
    }
    var isSkipOffset = isSkipInnerOffset && startPoint.node !== point.node && endPoint.node !== point.node;
    point = nextPointWithEmptyNode(point, isSkipOffset);
  }
}

/**
 * @method makeOffsetPath
 *
 * return offsetPath(array of offset) from ancestor
 *
 * @param {Node} ancestor - ancestor node
 * @param {Node} node
 */
function makeOffsetPath(ancestor, node) {
  var ancestors = listAncestor(node, func.eq(ancestor));
  return ancestors.map(position).reverse();
}

/**
 * @method fromOffsetPath
 *
 * return element from offsetPath(array of offset)
 *
 * @param {Node} ancestor - ancestor node
 * @param {array} offsets - offsetPath
 */
function fromOffsetPath(ancestor, offsets) {
  var current = ancestor;
  for (var i = 0, len = offsets.length; i < len; i++) {
    if (current.childNodes.length <= offsets[i]) {
      current = current.childNodes[current.childNodes.length - 1];
    } else {
      current = current.childNodes[offsets[i]];
    }
  }
  return current;
}

/**
 * @method splitNode
 *
 * split element or #text
 *
 * @param {BoundaryPoint} point
 * @param {Object} [options]
 * @param {Boolean} [options.isSkipPaddingBlankHTML] - default: false
 * @param {Boolean} [options.isNotSplitEdgePoint] - default: false
 * @param {Boolean} [options.isDiscardEmptySplits] - default: false
 * @return {Node} right node of boundaryPoint
 */
function splitNode(point, options) {
  var isSkipPaddingBlankHTML = options && options.isSkipPaddingBlankHTML;
  var isNotSplitEdgePoint = options && options.isNotSplitEdgePoint;
  var isDiscardEmptySplits = options && options.isDiscardEmptySplits;
  if (isDiscardEmptySplits) {
    isSkipPaddingBlankHTML = true;
  }

  // edge case
  if (isEdgePoint(point) && (isText(point.node) || isNotSplitEdgePoint)) {
    if (isLeftEdgePoint(point)) {
      return point.node;
    } else if (isRightEdgePoint(point)) {
      return point.node.nextSibling;
    }
  }

  // split #text
  if (isText(point.node)) {
    return point.node.splitText(point.offset);
  } else {
    var childNode = point.node.childNodes[point.offset];
    var childNodes = listNext(childNode);
    var clone = insertAfter(point.node.cloneNode(false), point.node);
    appendChildNodes(clone, childNodes);
    if (!isSkipPaddingBlankHTML) {
      paddingBlankHTML(point.node);
      paddingBlankHTML(clone);
    }
    if (isDiscardEmptySplits) {
      if (dom_isEmpty(point.node)) {
        remove(point.node);
      }
      if (dom_isEmpty(clone)) {
        remove(clone);
        return point.node.nextSibling;
      }
    }
    return clone;
  }
}

/**
 * @method splitTree
 *
 * split tree by point
 *
 * @param {Node} root - split root
 * @param {BoundaryPoint} point
 * @param {Object} [options]
 * @param {Boolean} [options.isSkipPaddingBlankHTML] - default: false
 * @param {Boolean} [options.isNotSplitEdgePoint] - default: false
 * @return {Node} right node of boundaryPoint
 */
function splitTree(root, point, options) {
  // ex) [#text, <span>, <p>]
  var ancestors = listAncestor(point.node, func.eq(root));
  if (!ancestors.length) {
    return null;
  } else if (ancestors.length === 1) {
    return splitNode(point, options);
  }
  // Filter elements with sibling elements
  if (ancestors.length > 2) {
    var domList = ancestors.slice(0, ancestors.length - 1);
    var ifHasNextSibling = domList.find(function (item) {
      return item.nextSibling;
    });
    if (ifHasNextSibling && point.offset != 0 && isRightEdgePoint(point)) {
      var nestSibling = ifHasNextSibling.nextSibling;
      var textNode;
      if (nestSibling.nodeType == 1) {
        textNode = nestSibling.childNodes[0];
        ancestors = listAncestor(textNode, func.eq(root));
        point = {
          node: textNode,
          offset: 0
        };
      } else if (nestSibling.nodeType == 3 && !nestSibling.data.match(/[\n\r]/g)) {
        textNode = nestSibling;
        ancestors = listAncestor(textNode, func.eq(root));
        point = {
          node: textNode,
          offset: 0
        };
      }
    }
  }
  return ancestors.reduce(function (node, parent) {
    if (node === point.node) {
      node = splitNode(point, options);
    }
    return splitNode({
      node: parent,
      offset: node ? position(node) : nodeLength(parent)
    }, options);
  });
}

/**
 * split point
 *
 * @param {Point} point
 * @param {Boolean} isInline
 * @return {Object}
 */
function splitPoint(point, isInline) {
  // find splitRoot, container
  //  - inline: splitRoot is a child of paragraph
  //  - block: splitRoot is a child of bodyContainer
  var pred = isInline ? isPara : isBodyContainer;
  var ancestors = listAncestor(point.node, pred);
  var topAncestor = lists.last(ancestors) || point.node;
  var splitRoot, container;
  if (pred(topAncestor)) {
    splitRoot = ancestors[ancestors.length - 2];
    container = topAncestor;
  } else {
    splitRoot = topAncestor;
    container = splitRoot.parentNode;
  }

  // if splitRoot is exists, split with splitTree
  var pivot = splitRoot && splitTree(splitRoot, point, {
    isSkipPaddingBlankHTML: isInline,
    isNotSplitEdgePoint: isInline
  });

  // if container is point.node, find pivot with point.offset
  if (!pivot && container === point.node) {
    pivot = point.node.childNodes[point.offset];
  }
  return {
    rightNode: pivot,
    container: container
  };
}
function create(nodeName) {
  return document.createElement(nodeName);
}
function createText(text) {
  return document.createTextNode(text);
}

/**
 * @method remove
 *
 * remove node, (isRemoveChild: remove child or not)
 *
 * @param {Node} node
 * @param {Boolean} isRemoveChild
 */
function remove(node, isRemoveChild) {
  if (!node || !node.parentNode) {
    return;
  }
  if (node.removeNode) {
    return node.removeNode(isRemoveChild);
  }
  var parent = node.parentNode;
  if (!isRemoveChild) {
    var nodes = [];
    for (var i = 0, len = node.childNodes.length; i < len; i++) {
      nodes.push(node.childNodes[i]);
    }
    for (var _i = 0, _len = nodes.length; _i < _len; _i++) {
      parent.insertBefore(nodes[_i], node);
    }
  }
  parent.removeChild(node);
}

/**
 * @method removeWhile
 *
 * @param {Node} node
 * @param {Function} pred
 */
function removeWhile(node, pred) {
  while (node) {
    if (isEditable(node) || !pred(node)) {
      break;
    }
    var parent = node.parentNode;
    remove(node);
    node = parent;
  }
}

/**
 * @method replace
 *
 * replace node with provided nodeName
 *
 * @param {Node} node
 * @param {String} nodeName
 * @return {Node} - new node
 */
function replace(node, nodeName) {
  if (node.nodeName.toUpperCase() === nodeName.toUpperCase()) {
    return node;
  }
  var newNode = create(nodeName);
  if (node.style.cssText) {
    newNode.style.cssText = node.style.cssText;
  }
  appendChildNodes(newNode, lists.from(node.childNodes));
  insertAfter(newNode, node);
  remove(node);
  return newNode;
}
var isTextarea = makePredByNodeName('TEXTAREA');

/**
 * @param {jQuery} $node
 * @param {Boolean} [stripLinebreaks] - default: false
 */
function value($node, stripLinebreaks) {
  var val = isTextarea($node[0]) ? $node.val() : $node.html();
  if (stripLinebreaks) {
    return val.replace(/[\n\r]/g, '');
  }
  return val;
}

/**
 * @method html
 *
 * get the HTML contents of node
 *
 * @param {jQuery} $node
 * @param {Boolean} [isNewlineOnBlock]
 */
function html($node, isNewlineOnBlock) {
  var markup = value($node);
  if (isNewlineOnBlock) {
    var regexTag = /<(\/?)(\b(?!!)[^>\s]*)(.*?)(\s*\/?>)/g;
    markup = markup.replace(regexTag, function (match, endSlash, name) {
      name = name.toUpperCase();
      var isEndOfInlineContainer = /^DIV|^TD|^TH|^P|^LI|^H[1-7]/.test(name) && !!endSlash;
      var isBlockNode = /^BLOCKQUOTE|^TABLE|^TBODY|^TR|^HR|^UL|^OL/.test(name);
      return match + (isEndOfInlineContainer || isBlockNode ? '\n' : '');
    });
    markup = markup.trim();
  }
  return markup;
}
function posFromPlaceholder(placeholder) {
  var $placeholder = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(placeholder);
  var pos = $placeholder.offset();
  var height = $placeholder.outerHeight(true); // include margin

  return {
    left: pos.left,
    top: pos.top + height
  };
}
function attachEvents($node, events) {
  Object.keys(events).forEach(function (key) {
    $node.on(key, events[key]);
  });
}
function detachEvents($node, events) {
  Object.keys(events).forEach(function (key) {
    $node.off(key, events[key]);
  });
}

/**
 * @method isCustomStyleTag
 *
 * assert if a node contains a "note-styletag" class,
 * which implies that's a custom-made style tag node
 *
 * @param {Node} an HTML DOM node
 */
function isCustomStyleTag(node) {
  return node && !isText(node) && lists.contains(node.classList, 'note-styletag');
}
/* harmony default export */ const dom = ({
  /** @property {String} NBSP_CHAR */
  NBSP_CHAR: NBSP_CHAR,
  /** @property {String} ZERO_WIDTH_NBSP_CHAR */
  ZERO_WIDTH_NBSP_CHAR: ZERO_WIDTH_NBSP_CHAR,
  /** @property {String} blank */
  blank: blankHTML,
  /** @property {String} emptyPara */
  emptyPara: "<p>".concat(blankHTML, "</p>"),
  makePredByNodeName: makePredByNodeName,
  isEditable: isEditable,
  isControlSizing: isControlSizing,
  isText: isText,
  isElement: isElement,
  isVoid: isVoid,
  isPara: isPara,
  isPurePara: isPurePara,
  isHeading: isHeading,
  isInline: isInline,
  isBlock: func.not(isInline),
  isBodyInline: isBodyInline,
  isBody: isBody,
  isParaInline: isParaInline,
  isPre: isPre,
  isList: isList,
  isTable: isTable,
  isData: isData,
  isCell: isCell,
  isBlockquote: isBlockquote,
  isBodyContainer: isBodyContainer,
  isAnchor: isAnchor,
  isDiv: makePredByNodeName('DIV'),
  isLi: isLi,
  isBR: makePredByNodeName('BR'),
  isSpan: makePredByNodeName('SPAN'),
  isB: makePredByNodeName('B'),
  isU: makePredByNodeName('U'),
  isS: makePredByNodeName('S'),
  isI: makePredByNodeName('I'),
  isImg: makePredByNodeName('IMG'),
  isTextarea: isTextarea,
  deepestChildIsEmpty: deepestChildIsEmpty,
  isEmpty: dom_isEmpty,
  isEmptyAnchor: func.and(isAnchor, dom_isEmpty),
  isClosestSibling: isClosestSibling,
  withClosestSiblings: withClosestSiblings,
  nodeLength: nodeLength,
  isLeftEdgePoint: isLeftEdgePoint,
  isRightEdgePoint: isRightEdgePoint,
  isEdgePoint: isEdgePoint,
  isLeftEdgeOf: isLeftEdgeOf,
  isRightEdgeOf: isRightEdgeOf,
  isLeftEdgePointOf: isLeftEdgePointOf,
  isRightEdgePointOf: isRightEdgePointOf,
  prevPoint: prevPoint,
  nextPoint: nextPoint,
  nextPointWithEmptyNode: nextPointWithEmptyNode,
  isSamePoint: isSamePoint,
  isVisiblePoint: isVisiblePoint,
  prevPointUntil: prevPointUntil,
  nextPointUntil: nextPointUntil,
  isCharPoint: isCharPoint,
  isSpacePoint: isSpacePoint,
  walkPoint: walkPoint,
  ancestor: ancestor,
  singleChildAncestor: singleChildAncestor,
  listAncestor: listAncestor,
  lastAncestor: lastAncestor,
  listNext: listNext,
  listPrev: listPrev,
  listDescendant: listDescendant,
  commonAncestor: commonAncestor,
  wrap: wrap,
  insertAfter: insertAfter,
  appendChildNodes: appendChildNodes,
  position: position,
  hasChildren: hasChildren,
  makeOffsetPath: makeOffsetPath,
  fromOffsetPath: fromOffsetPath,
  splitTree: splitTree,
  splitPoint: splitPoint,
  create: create,
  createText: createText,
  remove: remove,
  removeWhile: removeWhile,
  replace: replace,
  html: html,
  value: value,
  posFromPlaceholder: posFromPlaceholder,
  attachEvents: attachEvents,
  detachEvents: detachEvents,
  isCustomStyleTag: isCustomStyleTag
});
;// CONCATENATED MODULE: ./src/js/Context.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




var Context = /*#__PURE__*/function () {
  /**
   * @param {jQuery} $note
   * @param {Object} options
   */
  function Context($note, options) {
    _classCallCheck(this, Context);
    this.$note = $note;
    this.memos = {};
    this.modules = {};
    this.layoutInfo = {};
    this.options = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().extend(true, {}, options);

    // init ui with options
    (external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote.ui = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().summernote.ui_template(this.options);
    this.ui = (external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote.ui;
    this.initialize();
  }

  /**
   * create layout and initialize modules and other resources
   */
  return _createClass(Context, [{
    key: "initialize",
    value: function initialize() {
      this.layoutInfo = this.ui.createLayout(this.$note);
      this._initialize();
      this.$note.hide();
      return this;
    }

    /**
     * destroy modules and other resources and remove layout
     */
  }, {
    key: "destroy",
    value: function destroy() {
      this._destroy();
      this.$note.removeData('summernote');
      this.ui.removeLayout(this.$note, this.layoutInfo);
    }

    /**
     * destory modules and other resources and initialize it again
     */
  }, {
    key: "reset",
    value: function reset() {
      var disabled = this.isDisabled();
      this.code(dom.emptyPara);
      this._destroy();
      this._initialize();
      if (disabled) {
        this.disable();
      }
    }
  }, {
    key: "_initialize",
    value: function _initialize() {
      var _this = this;
      // set own id
      this.options.id = func.uniqueId(external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().now());
      // set default container for tooltips, popovers, and dialogs
      this.options.container = this.options.container || this.layoutInfo.editor;

      // add optional buttons
      var buttons = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().extend({}, this.options.buttons);
      Object.keys(buttons).forEach(function (key) {
        _this.memo('button.' + key, buttons[key]);
      });
      var modules = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().extend({}, this.options.modules, (external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote.plugins || {});

      // add and initialize modules
      Object.keys(modules).forEach(function (key) {
        _this.module(key, modules[key], true);
      });
      Object.keys(this.modules).forEach(function (key) {
        _this.initializeModule(key);
      });
    }
  }, {
    key: "_destroy",
    value: function _destroy() {
      var _this2 = this;
      // destroy modules with reversed order
      Object.keys(this.modules).reverse().forEach(function (key) {
        _this2.removeModule(key);
      });
      Object.keys(this.memos).forEach(function (key) {
        _this2.removeMemo(key);
      });
      // trigger custom onDestroy callback
      this.triggerEvent('destroy', this);
    }
  }, {
    key: "code",
    value: function code(html) {
      var isActivated = this.invoke('codeview.isActivated');
      if (html === undefined) {
        this.invoke('codeview.sync');
        return isActivated ? this.layoutInfo.codable.val() : this.layoutInfo.editable.html();
      } else {
        if (isActivated) {
          this.invoke('codeview.sync', html);
        } else {
          this.layoutInfo.editable.html(html);
        }
        this.$note.val(html);
        this.triggerEvent('change', html, this.layoutInfo.editable);
      }
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      return this.layoutInfo.editable.attr('contenteditable') === 'false';
    }
  }, {
    key: "enable",
    value: function enable() {
      this.layoutInfo.editable.attr('contenteditable', true);
      this.invoke('toolbar.activate', true);
      this.triggerEvent('disable', false);
      this.options.editing = true;
    }
  }, {
    key: "disable",
    value: function disable() {
      // close codeview if codeview is opend
      if (this.invoke('codeview.isActivated')) {
        this.invoke('codeview.deactivate');
      }
      this.layoutInfo.editable.attr('contenteditable', false);
      this.options.editing = false;
      this.invoke('toolbar.deactivate', true);
      this.triggerEvent('disable', true);
    }
  }, {
    key: "triggerEvent",
    value: function triggerEvent() {
      var namespace = lists.head(arguments);
      var args = lists.tail(lists.from(arguments));
      var callback = this.options.callbacks[func.namespaceToCamel(namespace, 'on')];
      if (callback) {
        callback.apply(this.$note[0], args);
      }
      this.$note.trigger('summernote.' + namespace, args);
    }
  }, {
    key: "initializeModule",
    value: function initializeModule(key) {
      var module = this.modules[key];
      module.shouldInitialize = module.shouldInitialize || func.ok;
      if (!module.shouldInitialize()) {
        return;
      }

      // initialize module
      if (module.initialize) {
        module.initialize();
      }

      // attach events
      if (module.events) {
        dom.attachEvents(this.$note, module.events);
      }
    }
  }, {
    key: "module",
    value: function module(key, ModuleClass, withoutIntialize) {
      if (arguments.length === 1) {
        return this.modules[key];
      }
      this.modules[key] = new ModuleClass(this);
      if (!withoutIntialize) {
        this.initializeModule(key);
      }
    }
  }, {
    key: "removeModule",
    value: function removeModule(key) {
      var module = this.modules[key];
      if (module.shouldInitialize()) {
        if (module.events) {
          dom.detachEvents(this.$note, module.events);
        }
        if (module.destroy) {
          module.destroy();
        }
      }
      delete this.modules[key];
    }
  }, {
    key: "memo",
    value: function memo(key, obj) {
      if (arguments.length === 1) {
        return this.memos[key];
      }
      this.memos[key] = obj;
    }
  }, {
    key: "removeMemo",
    value: function removeMemo(key) {
      if (this.memos[key] && this.memos[key].destroy) {
        this.memos[key].destroy();
      }
      delete this.memos[key];
    }

    /**
     * Some buttons need to change their visual style immediately once they get pressed
     */
  }, {
    key: "createInvokeHandlerAndUpdateState",
    value: function createInvokeHandlerAndUpdateState(namespace, value) {
      var _this3 = this;
      return function (event) {
        _this3.createInvokeHandler(namespace, value)(event);
        _this3.invoke('buttons.updateCurrentStyle');
      };
    }
  }, {
    key: "createInvokeHandler",
    value: function createInvokeHandler(namespace, value) {
      var _this4 = this;
      return function (event) {
        event.preventDefault();
        var $target = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(event.target);
        _this4.invoke(namespace, value || $target.closest('[data-value]').data('value'), $target);
      };
    }
  }, {
    key: "invoke",
    value: function invoke() {
      var namespace = lists.head(arguments);
      var args = lists.tail(lists.from(arguments));
      var splits = namespace.split('.');
      var hasSeparator = splits.length > 1;
      var moduleName = hasSeparator && lists.head(splits);
      var methodName = hasSeparator ? lists.last(splits) : lists.head(splits);
      var module = this.modules[moduleName || 'editor'];
      if (!moduleName && this[methodName]) {
        return this[methodName].apply(this, args);
      } else if (module && module[methodName] && module.shouldInitialize()) {
        return module[methodName].apply(module, args);
      }
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/summernote.js
function summernote_typeof(o) { "@babel/helpers - typeof"; return summernote_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, summernote_typeof(o); }




external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().fn.extend({
  /**
   * Summernote API
   *
   * @param {Object|String}
   * @return {this}
   */
  summernote: function summernote() {
    var type = summernote_typeof(lists.head(arguments));
    var isExternalAPICalled = type === 'string';
    var hasInitOptions = type === 'object';
    var options = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().extend({}, (external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote.options, hasInitOptions ? lists.head(arguments) : {});

    // Update options
    options.langInfo = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().extend(true, {}, (external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote.lang['en-US'], (external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote.lang[options.lang]);
    options.icons = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().extend(true, {}, (external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote.options.icons, options.icons);
    options.tooltip = options.tooltip === 'auto' ? !env.isSupportTouch : options.tooltip;
    this.each(function (idx, note) {
      var $note = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(note);
      if (!$note.data('summernote')) {
        var context = new Context($note, options);
        $note.data('summernote', context);
        $note.data('summernote').triggerEvent('init', context.layoutInfo);
      }
    });
    var $note = this.first();
    if ($note.length) {
      var context = $note.data('summernote');
      if (isExternalAPICalled) {
        return context.invoke.apply(context, lists.from(arguments));
      } else if (options.focus) {
        context.invoke('editor.focus');
      }
    }
    return this;
  }
});
;// CONCATENATED MODULE: ./src/js/core/range.js
function range_typeof(o) { "@babel/helpers - typeof"; return range_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, range_typeof(o); }
function range_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function range_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, range_toPropertyKey(o.key), o); } }
function range_createClass(e, r, t) { return r && range_defineProperties(e.prototype, r), t && range_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function range_toPropertyKey(t) { var i = range_toPrimitive(t, "string"); return "symbol" == range_typeof(i) ? i : i + ""; }
function range_toPrimitive(t, r) { if ("object" != range_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != range_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






/**
 * return boundaryPoint from TextRange, inspired by Andy Na's HuskyRange.js
 *
 * @param {TextRange} textRange
 * @param {Boolean} isStart
 * @return {BoundaryPoint}
 *
 * @see http://msdn.microsoft.com/en-us/library/ie/ms535872(v=vs.85).aspx
 */
function textRangeToPoint(textRange, isStart) {
  var container = textRange.parentElement();
  var offset;
  var tester = document.body.createTextRange();
  var prevContainer;
  var childNodes = lists.from(container.childNodes);
  for (offset = 0; offset < childNodes.length; offset++) {
    if (dom.isText(childNodes[offset])) {
      continue;
    }
    tester.moveToElementText(childNodes[offset]);
    if (tester.compareEndPoints('StartToStart', textRange) >= 0) {
      break;
    }
    prevContainer = childNodes[offset];
  }
  if (offset !== 0 && dom.isText(childNodes[offset - 1])) {
    var textRangeStart = document.body.createTextRange();
    var curTextNode = null;
    textRangeStart.moveToElementText(prevContainer || container);
    textRangeStart.collapse(!prevContainer);
    curTextNode = prevContainer ? prevContainer.nextSibling : container.firstChild;
    var pointTester = textRange.duplicate();
    pointTester.setEndPoint('StartToStart', textRangeStart);
    var textCount = pointTester.text.replace(/[\r\n]/g, '').length;
    while (textCount > curTextNode.nodeValue.length && curTextNode.nextSibling) {
      textCount -= curTextNode.nodeValue.length;
      curTextNode = curTextNode.nextSibling;
    }

    // [workaround] enforce IE to re-reference curTextNode, hack
    var dummy = curTextNode.nodeValue; // eslint-disable-line

    if (isStart && curTextNode.nextSibling && dom.isText(curTextNode.nextSibling) && textCount === curTextNode.nodeValue.length) {
      textCount -= curTextNode.nodeValue.length;
      curTextNode = curTextNode.nextSibling;
    }
    container = curTextNode;
    offset = textCount;
  }
  return {
    cont: container,
    offset: offset
  };
}

/**
 * return TextRange from boundary point (inspired by google closure-library)
 * @param {BoundaryPoint} point
 * @return {TextRange}
 */
function pointToTextRange(point) {
  var textRangeInfo = function textRangeInfo(container, offset) {
    var node, isCollapseToStart;
    if (dom.isText(container)) {
      var prevTextNodes = dom.listPrev(container, func.not(dom.isText));
      var prevContainer = lists.last(prevTextNodes).previousSibling;
      node = prevContainer || container.parentNode;
      offset += lists.sum(lists.tail(prevTextNodes), dom.nodeLength);
      isCollapseToStart = !prevContainer;
    } else {
      node = container.childNodes[offset] || container;
      if (dom.isText(node)) {
        return textRangeInfo(node, 0);
      }
      offset = 0;
      isCollapseToStart = false;
    }
    return {
      node: node,
      collapseToStart: isCollapseToStart,
      offset: offset
    };
  };
  var textRange = document.body.createTextRange();
  var info = textRangeInfo(point.node, point.offset);
  textRange.moveToElementText(info.node);
  textRange.collapse(info.collapseToStart);
  textRange.moveStart('character', info.offset);
  return textRange;
}

/**
   * Wrapped Range
   *
   * @constructor
   * @param {Node} sc - start container
   * @param {Number} so - start offset
   * @param {Node} ec - end container
   * @param {Number} eo - end offset
   */
var WrappedRange = /*#__PURE__*/function () {
  function WrappedRange(sc, so, ec, eo) {
    range_classCallCheck(this, WrappedRange);
    this.sc = sc;
    this.so = so;
    this.ec = ec;
    this.eo = eo;

    // isOnEditable: judge whether range is on editable or not
    this.isOnEditable = this.makeIsOn(dom.isEditable);
    // isOnList: judge whether range is on list node or not
    this.isOnList = this.makeIsOn(dom.isList);
    // isOnAnchor: judge whether range is on anchor node or not
    this.isOnAnchor = this.makeIsOn(dom.isAnchor);
    // isOnCell: judge whether range is on cell node or not
    this.isOnCell = this.makeIsOn(dom.isCell);
    // isOnData: judge whether range is on data node or not
    this.isOnData = this.makeIsOn(dom.isData);
  }

  // nativeRange: get nativeRange from sc, so, ec, eo
  return range_createClass(WrappedRange, [{
    key: "nativeRange",
    value: function nativeRange() {
      if (env.isW3CRangeSupport) {
        var w3cRange = document.createRange();
        w3cRange.setStart(this.sc, this.so);
        w3cRange.setEnd(this.ec, this.eo);
        return w3cRange;
      } else {
        var textRange = pointToTextRange({
          node: this.sc,
          offset: this.so
        });
        textRange.setEndPoint('EndToEnd', pointToTextRange({
          node: this.ec,
          offset: this.eo
        }));
        return textRange;
      }
    }
  }, {
    key: "getPoints",
    value: function getPoints() {
      return {
        sc: this.sc,
        so: this.so,
        ec: this.ec,
        eo: this.eo
      };
    }
  }, {
    key: "getStartPoint",
    value: function getStartPoint() {
      return {
        node: this.sc,
        offset: this.so
      };
    }
  }, {
    key: "getEndPoint",
    value: function getEndPoint() {
      return {
        node: this.ec,
        offset: this.eo
      };
    }

    /**
     * select update visible range
     */
  }, {
    key: "select",
    value: function select() {
      var nativeRng = this.nativeRange();
      if (env.isW3CRangeSupport) {
        var selection = document.getSelection();
        if (selection.rangeCount > 0) {
          selection.removeAllRanges();
        }
        selection.addRange(nativeRng);
      } else {
        nativeRng.select();
      }
      return this;
    }

    /**
     * Moves the scrollbar to start container(sc) of current range
     *
     * @return {WrappedRange}
     */
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView(container) {
      var height = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(container).height();
      if (container.scrollTop + height < this.sc.offsetTop) {
        container.scrollTop += Math.abs(container.scrollTop + height - this.sc.offsetTop);
      }
      return this;
    }

    /**
     * @return {WrappedRange}
     */
  }, {
    key: "normalize",
    value: function normalize() {
      /**
       * @param {BoundaryPoint} point
       * @param {Boolean} isLeftToRight - true: prefer to choose right node
       *                                - false: prefer to choose left node
       * @return {BoundaryPoint}
       */
      var getVisiblePoint = function getVisiblePoint(point, isLeftToRight) {
        if (!point) {
          return point;
        }

        // Just use the given point [XXX:Adhoc]
        //  - case 01. if the point is on the middle of the node
        //  - case 02. if the point is on the right edge and prefer to choose left node
        //  - case 03. if the point is on the left edge and prefer to choose right node
        //  - case 04. if the point is on the right edge and prefer to choose right node but the node is void
        //  - case 05. if the point is on the left edge and prefer to choose left node but the node is void
        //  - case 06. if the point is on the block node and there is no children
        if (dom.isVisiblePoint(point)) {
          if (!dom.isEdgePoint(point) || dom.isRightEdgePoint(point) && !isLeftToRight || dom.isLeftEdgePoint(point) && isLeftToRight || dom.isRightEdgePoint(point) && isLeftToRight && dom.isVoid(point.node.nextSibling) || dom.isLeftEdgePoint(point) && !isLeftToRight && dom.isVoid(point.node.previousSibling) || dom.isBlock(point.node) && dom.isEmpty(point.node)) {
            return point;
          }
        }

        // point on block's edge
        var block = dom.ancestor(point.node, dom.isBlock);
        var hasRightNode = false;
        if (!hasRightNode) {
          var prevPoint = dom.prevPoint(point) || {
            node: null
          };
          hasRightNode = (dom.isLeftEdgePointOf(point, block) || dom.isVoid(prevPoint.node)) && !isLeftToRight;
        }
        var hasLeftNode = false;
        if (!hasLeftNode) {
          var _nextPoint = dom.nextPoint(point) || {
            node: null
          };
          hasLeftNode = (dom.isRightEdgePointOf(point, block) || dom.isVoid(_nextPoint.node)) && isLeftToRight;
        }
        if (hasRightNode || hasLeftNode) {
          // returns point already on visible point
          if (dom.isVisiblePoint(point)) {
            return point;
          }
          // reverse direction
          isLeftToRight = !isLeftToRight;
        }
        var nextPoint = isLeftToRight ? dom.nextPointUntil(dom.nextPoint(point), dom.isVisiblePoint) : dom.prevPointUntil(dom.prevPoint(point), dom.isVisiblePoint);
        return nextPoint || point;
      };
      var endPoint = getVisiblePoint(this.getEndPoint(), false);
      var startPoint = this.isCollapsed() ? endPoint : getVisiblePoint(this.getStartPoint(), true);
      return new WrappedRange(startPoint.node, startPoint.offset, endPoint.node, endPoint.offset);
    }

    /**
     * returns matched nodes on range
     *
     * @param {Function} [pred] - predicate function
     * @param {Object} [options]
     * @param {Boolean} [options.includeAncestor]
     * @param {Boolean} [options.fullyContains]
     * @return {Node[]}
     */
  }, {
    key: "nodes",
    value: function nodes(pred, options) {
      pred = pred || func.ok;
      var includeAncestor = options && options.includeAncestor;
      var fullyContains = options && options.fullyContains;

      // TODO compare points and sort
      var startPoint = this.getStartPoint();
      var endPoint = this.getEndPoint();
      var nodes = [];
      var leftEdgeNodes = [];
      dom.walkPoint(startPoint, endPoint, function (point) {
        if (dom.isEditable(point.node)) {
          return;
        }
        var node;
        if (fullyContains) {
          if (dom.isLeftEdgePoint(point)) {
            leftEdgeNodes.push(point.node);
          }
          if (dom.isRightEdgePoint(point) && lists.contains(leftEdgeNodes, point.node)) {
            node = point.node;
          }
        } else if (includeAncestor) {
          node = dom.ancestor(point.node, pred);
        } else {
          node = point.node;
        }
        if (node && pred(node)) {
          nodes.push(node);
        }
      }, true);
      return lists.unique(nodes);
    }

    /**
     * returns commonAncestor of range
     * @return {Element} - commonAncestor
     */
  }, {
    key: "commonAncestor",
    value: function commonAncestor() {
      return dom.commonAncestor(this.sc, this.ec);
    }

    /**
     * returns expanded range by pred
     *
     * @param {Function} pred - predicate function
     * @return {WrappedRange}
     */
  }, {
    key: "expand",
    value: function expand(pred) {
      var startAncestor = dom.ancestor(this.sc, pred);
      var endAncestor = dom.ancestor(this.ec, pred);
      if (!startAncestor && !endAncestor) {
        return new WrappedRange(this.sc, this.so, this.ec, this.eo);
      }
      var boundaryPoints = this.getPoints();
      if (startAncestor) {
        boundaryPoints.sc = startAncestor;
        boundaryPoints.so = 0;
      }
      if (endAncestor) {
        boundaryPoints.ec = endAncestor;
        boundaryPoints.eo = dom.nodeLength(endAncestor);
      }
      return new WrappedRange(boundaryPoints.sc, boundaryPoints.so, boundaryPoints.ec, boundaryPoints.eo);
    }

    /**
     * @param {Boolean} isCollapseToStart
     * @return {WrappedRange}
     */
  }, {
    key: "collapse",
    value: function collapse(isCollapseToStart) {
      if (isCollapseToStart) {
        return new WrappedRange(this.sc, this.so, this.sc, this.so);
      } else {
        return new WrappedRange(this.ec, this.eo, this.ec, this.eo);
      }
    }

    /**
     * splitText on range
     */
  }, {
    key: "splitText",
    value: function splitText() {
      var isSameContainer = this.sc === this.ec;
      var boundaryPoints = this.getPoints();
      if (dom.isText(this.ec) && !dom.isEdgePoint(this.getEndPoint())) {
        this.ec.splitText(this.eo);
      }
      if (dom.isText(this.sc) && !dom.isEdgePoint(this.getStartPoint())) {
        boundaryPoints.sc = this.sc.splitText(this.so);
        boundaryPoints.so = 0;
        if (isSameContainer) {
          boundaryPoints.ec = boundaryPoints.sc;
          boundaryPoints.eo = this.eo - this.so;
        }
      }
      return new WrappedRange(boundaryPoints.sc, boundaryPoints.so, boundaryPoints.ec, boundaryPoints.eo);
    }

    /**
     * delete contents on range
     * @return {WrappedRange}
     */
  }, {
    key: "deleteContents",
    value: function deleteContents() {
      if (this.isCollapsed()) {
        return this;
      }
      var rng = this.splitText();
      var nodes = rng.nodes(null, {
        fullyContains: true
      });

      // find new cursor point
      var point = dom.prevPointUntil(rng.getStartPoint(), function (point) {
        return !lists.contains(nodes, point.node);
      });
      var emptyParents = [];
      external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(nodes, function (idx, node) {
        // find empty parents
        var parent = node.parentNode;
        if (point.node !== parent && dom.nodeLength(parent) === 1) {
          emptyParents.push(parent);
        }
        dom.remove(node, false);
      });

      // remove empty parents
      external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(emptyParents, function (idx, node) {
        dom.remove(node, false);
      });
      return new WrappedRange(point.node, point.offset, point.node, point.offset).normalize();
    }

    /**
     * makeIsOn: return isOn(pred) function
     */
  }, {
    key: "makeIsOn",
    value: function makeIsOn(pred) {
      return function () {
        var ancestor = dom.ancestor(this.sc, pred);
        return !!ancestor && ancestor === dom.ancestor(this.ec, pred);
      };
    }

    /**
     * @param {Function} pred
     * @return {Boolean}
     */
  }, {
    key: "isLeftEdgeOf",
    value: function isLeftEdgeOf(pred) {
      if (!dom.isLeftEdgePoint(this.getStartPoint())) {
        return false;
      }
      var node = dom.ancestor(this.sc, pred);
      return node && dom.isLeftEdgeOf(this.sc, node);
    }

    /**
     * returns whether range was collapsed or not
     */
  }, {
    key: "isCollapsed",
    value: function isCollapsed() {
      return this.sc === this.ec && this.so === this.eo;
    }

    /**
     * wrap inline nodes which children of body with paragraph
     *
     * @return {WrappedRange}
     */
  }, {
    key: "wrapBodyInlineWithPara",
    value: function wrapBodyInlineWithPara() {
      if (dom.isBodyContainer(this.sc) && dom.isEmpty(this.sc)) {
        this.sc.innerHTML = dom.emptyPara;
        return new WrappedRange(this.sc.firstChild, 0, this.sc.firstChild, 0);
      }

      /**
       * [workaround] firefox often create range on not visible point. so normalize here.
       *  - firefox: |<p>text</p>|
       *  - chrome: <p>|text|</p>
       */
      var rng = this.normalize();
      if (dom.isParaInline(this.sc) || dom.isPara(this.sc)) {
        return rng;
      }

      // find inline top ancestor
      var topAncestor;
      if (dom.isInline(rng.sc)) {
        var ancestors = dom.listAncestor(rng.sc, func.not(dom.isInline));
        topAncestor = lists.last(ancestors);
        if (!dom.isInline(topAncestor)) {
          topAncestor = ancestors[ancestors.length - 2] || rng.sc.childNodes[rng.so];
        }
      } else {
        topAncestor = rng.sc.childNodes[rng.so > 0 ? rng.so - 1 : 0];
      }
      if (topAncestor) {
        // siblings not in paragraph
        var inlineSiblings = dom.listPrev(topAncestor, dom.isParaInline).reverse();
        inlineSiblings = inlineSiblings.concat(dom.listNext(topAncestor.nextSibling, dom.isParaInline));

        // wrap with paragraph
        if (inlineSiblings.length) {
          var para = dom.wrap(lists.head(inlineSiblings), 'p');
          dom.appendChildNodes(para, lists.tail(inlineSiblings));
        }
      }
      return this.normalize();
    }

    /**
     * insert node at current cursor
     *
     * @param {Node} node
     * @param {Boolean} doNotInsertPara - default is false, removes added <p> that's added if true
     * @return {Node}
     */
  }, {
    key: "insertNode",
    value: function insertNode(node) {
      var doNotInsertPara = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var rng = this;
      if (dom.isText(node) || dom.isInline(node)) {
        rng = this.wrapBodyInlineWithPara().deleteContents();
      }
      var info = dom.splitPoint(rng.getStartPoint(), dom.isInline(node));
      if (info.rightNode) {
        info.rightNode.parentNode.insertBefore(node, info.rightNode);
        if (dom.isEmpty(info.rightNode) && (doNotInsertPara || dom.isPara(node))) {
          info.rightNode.parentNode.removeChild(info.rightNode);
        }
      } else {
        info.container.appendChild(node);
      }
      return node;
    }

    /**
     * insert html at current cursor
     */
  }, {
    key: "pasteHTML",
    value: function pasteHTML(markup) {
      markup = ((markup || '') + '').trim(markup);
      var contentsContainer = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<div></div>').html(markup)[0];
      var childNodes = lists.from(contentsContainer.childNodes);

      // const rng = this.wrapBodyInlineWithPara().deleteContents();
      var rng = this;
      var reversed = false;
      if (rng.so >= 0) {
        childNodes = childNodes.reverse();
        reversed = true;
      }
      childNodes = childNodes.map(function (childNode) {
        return rng.insertNode(childNode, !dom.isInline(childNode));
      });
      if (reversed) {
        childNodes = childNodes.reverse();
      }
      return childNodes;
    }

    /**
     * returns text in range
     *
     * @return {String}
     */
  }, {
    key: "toString",
    value: function toString() {
      var nativeRng = this.nativeRange();
      return env.isW3CRangeSupport ? nativeRng.toString() : nativeRng.text;
    }

    /**
     * returns range for word before cursor
     *
     * @param {Boolean} [findAfter] - find after cursor, default: false
     * @return {WrappedRange}
     */
  }, {
    key: "getWordRange",
    value: function getWordRange(findAfter) {
      var endPoint = this.getEndPoint();
      if (!dom.isCharPoint(endPoint)) {
        return this;
      }
      var startPoint = dom.prevPointUntil(endPoint, function (point) {
        return !dom.isCharPoint(point);
      });
      if (findAfter) {
        endPoint = dom.nextPointUntil(endPoint, function (point) {
          return !dom.isCharPoint(point);
        });
      }
      return new WrappedRange(startPoint.node, startPoint.offset, endPoint.node, endPoint.offset);
    }

    /**
     * returns range for words before cursor
     *
     * @param {Boolean} [findAfter] - find after cursor, default: false
     * @return {WrappedRange}
     */
  }, {
    key: "getWordsRange",
    value: function getWordsRange(findAfter) {
      var endPoint = this.getEndPoint();
      var isNotTextPoint = function isNotTextPoint(point) {
        return !dom.isCharPoint(point) && !dom.isSpacePoint(point);
      };
      if (isNotTextPoint(endPoint)) {
        return this;
      }
      var startPoint = dom.prevPointUntil(endPoint, isNotTextPoint);
      if (findAfter) {
        endPoint = dom.nextPointUntil(endPoint, isNotTextPoint);
      }
      return new WrappedRange(startPoint.node, startPoint.offset, endPoint.node, endPoint.offset);
    }

    /**
     * returns range for words before cursor that match with a Regex
     *
     * example:
     *  range: 'hi @Peter Pan'
     *  regex: '/@[a-z ]+/i'
     *  return range: '@Peter Pan'
     *
     * @param {RegExp} [regex]
     * @return {WrappedRange|null}
     */
  }, {
    key: "getWordsMatchRange",
    value: function getWordsMatchRange(regex) {
      var endPoint = this.getEndPoint();
      var startPoint = dom.prevPointUntil(endPoint, function (point) {
        if (!dom.isCharPoint(point) && !dom.isSpacePoint(point)) {
          return true;
        }
        var rng = new WrappedRange(point.node, point.offset, endPoint.node, endPoint.offset);
        var result = regex.exec(rng.toString());
        return result && result.index === 0;
      });
      var rng = new WrappedRange(startPoint.node, startPoint.offset, endPoint.node, endPoint.offset);
      var text = rng.toString();
      var result = regex.exec(text);
      if (result && result[0].length === text.length) {
        return rng;
      } else {
        return null;
      }
    }

    /**
     * create offsetPath bookmark
     *
     * @param {Node} editable
     */
  }, {
    key: "bookmark",
    value: function bookmark(editable) {
      return {
        s: {
          path: dom.makeOffsetPath(editable, this.sc),
          offset: this.so
        },
        e: {
          path: dom.makeOffsetPath(editable, this.ec),
          offset: this.eo
        }
      };
    }

    /**
     * create offsetPath bookmark base on paragraph
     *
     * @param {Node[]} paras
     */
  }, {
    key: "paraBookmark",
    value: function paraBookmark(paras) {
      return {
        s: {
          path: lists.tail(dom.makeOffsetPath(lists.head(paras), this.sc)),
          offset: this.so
        },
        e: {
          path: lists.tail(dom.makeOffsetPath(lists.last(paras), this.ec)),
          offset: this.eo
        }
      };
    }

    /**
     * getClientRects
     * @return {Rect[]}
     */
  }, {
    key: "getClientRects",
    value: function getClientRects() {
      var nativeRng = this.nativeRange();
      return nativeRng.getClientRects();
    }
  }]);
}();
/**
 * Data structure
 *  * BoundaryPoint: a point of dom tree
 *  * BoundaryPoints: two boundaryPoints corresponding to the start and the end of the Range
 *
 * See to http://www.w3.org/TR/DOM-Level-2-Traversal-Range/ranges.html#Level-2-Range-Position
 */
/* harmony default export */ const range = ({
  /**
   * create Range Object From arguments or Browser Selection
   *
   * @param {Node} sc - start container
   * @param {Number} so - start offset
   * @param {Node} ec - end container
   * @param {Number} eo - end offset
   * @return {WrappedRange}
   */
  create: function create(sc, so, ec, eo) {
    if (arguments.length === 4) {
      return new WrappedRange(sc, so, ec, eo);
    } else if (arguments.length === 2) {
      // collapsed
      ec = sc;
      eo = so;
      return new WrappedRange(sc, so, ec, eo);
    } else {
      var wrappedRange = this.createFromSelection();
      if (!wrappedRange && arguments.length === 1) {
        var bodyElement = arguments[0];
        if (dom.isEditable(bodyElement)) {
          bodyElement = bodyElement.lastChild;
        }
        return this.createFromBodyElement(bodyElement, dom.emptyPara === arguments[0].innerHTML);
      }
      return wrappedRange;
    }
  },
  createFromBodyElement: function createFromBodyElement(bodyElement) {
    var isCollapseToStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var wrappedRange = this.createFromNode(bodyElement);
    return wrappedRange.collapse(isCollapseToStart);
  },
  createFromSelection: function createFromSelection() {
    var sc, so, ec, eo;
    if (env.isW3CRangeSupport) {
      var selection = document.getSelection();
      if (!selection || selection.rangeCount === 0) {
        return null;
      } else if (dom.isBody(selection.anchorNode)) {
        // Firefox: returns entire body as range on initialization.
        // We won't never need it.
        return null;
      }
      var nativeRng = selection.getRangeAt(0);
      sc = nativeRng.startContainer;
      so = nativeRng.startOffset;
      ec = nativeRng.endContainer;
      eo = nativeRng.endOffset;
    } else {
      // IE8: TextRange
      var textRange = document.selection.createRange();
      var textRangeEnd = textRange.duplicate();
      textRangeEnd.collapse(false);
      var textRangeStart = textRange;
      textRangeStart.collapse(true);
      var startPoint = textRangeToPoint(textRangeStart, true);
      var endPoint = textRangeToPoint(textRangeEnd, false);

      // same visible point case: range was collapsed.
      if (dom.isText(startPoint.node) && dom.isLeftEdgePoint(startPoint) && dom.isTextNode(endPoint.node) && dom.isRightEdgePoint(endPoint) && endPoint.node.nextSibling === startPoint.node) {
        startPoint = endPoint;
      }
      sc = startPoint.cont;
      so = startPoint.offset;
      ec = endPoint.cont;
      eo = endPoint.offset;
    }
    return new WrappedRange(sc, so, ec, eo);
  },
  /**
   * @method
   *
   * create WrappedRange from node
   *
   * @param {Node} node
   * @return {WrappedRange}
   */
  createFromNode: function createFromNode(node) {
    var sc = node;
    var so = 0;
    var ec = node;
    var eo = dom.nodeLength(ec);

    // browsers can't target a picture or void node
    if (dom.isVoid(sc)) {
      so = dom.listPrev(sc).length - 1;
      sc = sc.parentNode;
    }
    if (dom.isBR(ec)) {
      eo = dom.listPrev(ec).length - 1;
      ec = ec.parentNode;
    } else if (dom.isVoid(ec)) {
      eo = dom.listPrev(ec).length;
      ec = ec.parentNode;
    }
    return this.create(sc, so, ec, eo);
  },
  /**
   * create WrappedRange from node after position
   *
   * @param {Node} node
   * @return {WrappedRange}
   */
  createFromNodeBefore: function createFromNodeBefore(node) {
    return this.createFromNode(node).collapse(true);
  },
  /**
   * create WrappedRange from node after position
   *
   * @param {Node} node
   * @return {WrappedRange}
   */
  createFromNodeAfter: function createFromNodeAfter(node) {
    return this.createFromNode(node).collapse();
  },
  /**
   * @method
   *
   * create WrappedRange from bookmark
   *
   * @param {Node} editable
   * @param {Object} bookmark
   * @return {WrappedRange}
   */
  createFromBookmark: function createFromBookmark(editable, bookmark) {
    var sc = dom.fromOffsetPath(editable, bookmark.s.path);
    var so = bookmark.s.offset;
    var ec = dom.fromOffsetPath(editable, bookmark.e.path);
    var eo = bookmark.e.offset;
    return new WrappedRange(sc, so, ec, eo);
  },
  /**
   * @method
   *
   * create WrappedRange from paraBookmark
   *
   * @param {Object} bookmark
   * @param {Node[]} paras
   * @return {WrappedRange}
   */
  createFromParaBookmark: function createFromParaBookmark(bookmark, paras) {
    var so = bookmark.s.offset;
    var eo = bookmark.e.offset;
    var sc = dom.fromOffsetPath(lists.head(paras), bookmark.s.path);
    var ec = dom.fromOffsetPath(lists.last(paras), bookmark.e.path);
    return new WrappedRange(sc, so, ec, eo);
  }
});
;// CONCATENATED MODULE: ./src/js/core/key.js


var KEY_MAP = {
  'BACKSPACE': 8,
  'TAB': 9,
  'ENTER': 13,
  'ESCAPE': 27,
  'SPACE': 32,
  'DELETE': 46,
  // Arrow
  'LEFT': 37,
  'UP': 38,
  'RIGHT': 39,
  'DOWN': 40,
  // Number: 0-9
  'NUM0': 48,
  'NUM1': 49,
  'NUM2': 50,
  'NUM3': 51,
  'NUM4': 52,
  'NUM5': 53,
  'NUM6': 54,
  'NUM7': 55,
  'NUM8': 56,
  // Alphabet: a-z
  'B': 66,
  'E': 69,
  'I': 73,
  'J': 74,
  'K': 75,
  'L': 76,
  'R': 82,
  'S': 83,
  'U': 85,
  'V': 86,
  'Y': 89,
  'Z': 90,
  'SLASH': 191,
  'LEFTBRACKET': 219,
  'BACKSLASH': 220,
  'RIGHTBRACKET': 221,
  // Navigation
  'HOME': 36,
  'END': 35,
  'PAGEUP': 33,
  'PAGEDOWN': 34
};

/**
 * @class core.key
 *
 * Object for keycodes.
 *
 * @singleton
 * @alternateClassName key
 */
/* harmony default export */ const key = ({
  /**
   * @method isEdit
   *
   * @param {Number} keyCode
   * @return {Boolean}
   */
  isEdit: function isEdit(keyCode) {
    return lists.contains([KEY_MAP.BACKSPACE, KEY_MAP.TAB, KEY_MAP.ENTER, KEY_MAP.SPACE, KEY_MAP.DELETE], keyCode);
  },
  /**
   * @method isRemove
   *
   * @param {Number} keyCode
   * @return {Boolean}
   */
  isRemove: function isRemove(keyCode) {
    // LB
    return lists.contains([KEY_MAP.BACKSPACE, KEY_MAP.DELETE], keyCode);
  },
  /**
   * @method isMove
   *
   * @param {Number} keyCode
   * @return {Boolean}
   */
  isMove: function isMove(keyCode) {
    return lists.contains([KEY_MAP.LEFT, KEY_MAP.UP, KEY_MAP.RIGHT, KEY_MAP.DOWN], keyCode);
  },
  /**
   * @method isNavigation
   *
   * @param {Number} keyCode
   * @return {Boolean}
   */
  isNavigation: function isNavigation(keyCode) {
    return lists.contains([KEY_MAP.HOME, KEY_MAP.END, KEY_MAP.PAGEUP, KEY_MAP.PAGEDOWN], keyCode);
  },
  /**
   * @property {Object} nameFromCode
   * @property {String} nameFromCode.8 "BACKSPACE"
   */
  nameFromCode: func.invertObject(KEY_MAP),
  code: KEY_MAP
});
;// CONCATENATED MODULE: ./src/js/core/async.js


/**
 * @method readFileAsDataURL
 *
 * read contents of file as representing URL
 *
 * @param {File} file
 * @return {Promise} - then: dataUrl
 */
function readFileAsDataURL(file) {
  return external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().Deferred(function (deferred) {
    external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().extend(new FileReader(), {
      onload: function onload(event) {
        var dataURL = event.target.result;
        deferred.resolve(dataURL);
      },
      onerror: function onerror(err) {
        deferred.reject(err);
      }
    }).readAsDataURL(file);
  }).promise();
}

/**
 * @method createImage
 *
 * create `<image>` from url string
 *
 * @param {String} url
 * @return {Promise} - then: $image
 */
function createImage(url) {
  return external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().Deferred(function (deferred) {
    var $img = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<img>');
    $img.one('load', function () {
      $img.off('error abort');
      deferred.resolve($img);
    }).one('error abort', function () {
      $img.off('load').detach();
      deferred.reject($img);
    }).css({
      display: 'none'
    }).appendTo(document.body).attr('src', url);
  }).promise();
}
;// CONCATENATED MODULE: ./src/js/editing/History.js
function History_typeof(o) { "@babel/helpers - typeof"; return History_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, History_typeof(o); }
function History_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function History_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, History_toPropertyKey(o.key), o); } }
function History_createClass(e, r, t) { return r && History_defineProperties(e.prototype, r), t && History_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function History_toPropertyKey(t) { var i = History_toPrimitive(t, "string"); return "symbol" == History_typeof(i) ? i : i + ""; }
function History_toPrimitive(t, r) { if ("object" != History_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != History_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var History = /*#__PURE__*/function () {
  function History(context) {
    History_classCallCheck(this, History);
    this.stack = [];
    this.stackOffset = -1;
    this.context = context;
    this.$editable = context.layoutInfo.editable;
    this.editable = this.$editable[0];
  }
  return History_createClass(History, [{
    key: "makeSnapshot",
    value: function makeSnapshot() {
      var rng = range.create(this.editable);
      var emptyBookmark = {
        s: {
          path: [],
          offset: 0
        },
        e: {
          path: [],
          offset: 0
        }
      };
      return {
        contents: this.$editable.html(),
        bookmark: rng && rng.isOnEditable() ? rng.bookmark(this.editable) : emptyBookmark
      };
    }
  }, {
    key: "applySnapshot",
    value: function applySnapshot(snapshot) {
      if (snapshot.contents !== null) {
        this.$editable.html(snapshot.contents);
      }
      if (snapshot.bookmark !== null) {
        range.createFromBookmark(this.editable, snapshot.bookmark).select();
      }
    }

    /**
    * @method rewind
    * Rewinds the history stack back to the first snapshot taken.
    * Leaves the stack intact, so that "Redo" can still be used.
    */
  }, {
    key: "rewind",
    value: function rewind() {
      // Create snap shot if not yet recorded
      if (this.$editable.html() !== this.stack[this.stackOffset].contents) {
        this.recordUndo();
      }

      // Return to the first available snapshot.
      this.stackOffset = 0;

      // Apply that snapshot.
      this.applySnapshot(this.stack[this.stackOffset]);
    }

    /**
    *  @method commit
    *  Resets history stack, but keeps current editor's content.
    */
  }, {
    key: "commit",
    value: function commit() {
      // Clear the stack.
      this.stack = [];

      // Restore stackOffset to its original value.
      this.stackOffset = -1;

      // Record our first snapshot (of nothing).
      this.recordUndo();
    }

    /**
    * @method reset
    * Resets the history stack completely; reverting to an empty editor.
    */
  }, {
    key: "reset",
    value: function reset() {
      // Clear the stack.
      this.stack = [];

      // Restore stackOffset to its original value.
      this.stackOffset = -1;

      // Clear the editable area.
      this.$editable.html('');

      // Record our first snapshot (of nothing).
      this.recordUndo();
    }

    /**
     * undo
     */
  }, {
    key: "undo",
    value: function undo() {
      // Create snap shot if not yet recorded
      if (this.$editable.html() !== this.stack[this.stackOffset].contents) {
        this.recordUndo();
      }
      if (this.stackOffset > 0) {
        this.stackOffset--;
        this.applySnapshot(this.stack[this.stackOffset]);
      }
    }

    /**
     * redo
     */
  }, {
    key: "redo",
    value: function redo() {
      if (this.stack.length - 1 > this.stackOffset) {
        this.stackOffset++;
        this.applySnapshot(this.stack[this.stackOffset]);
      }
    }

    /**
     * recorded undo
     */
  }, {
    key: "recordUndo",
    value: function recordUndo() {
      this.stackOffset++;

      // Wash out stack after stackOffset
      if (this.stack.length > this.stackOffset) {
        this.stack = this.stack.slice(0, this.stackOffset);
      }

      // Create new snapshot and push it to the end
      this.stack.push(this.makeSnapshot());

      // If the stack size reachs to the limit, then slice it
      if (this.stack.length > this.context.options.historyLimit) {
        this.stack.shift();
        this.stackOffset -= 1;
      }
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/editing/Style.js
function Style_typeof(o) { "@babel/helpers - typeof"; return Style_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Style_typeof(o); }
function Style_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Style_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Style_toPropertyKey(o.key), o); } }
function Style_createClass(e, r, t) { return r && Style_defineProperties(e.prototype, r), t && Style_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Style_toPropertyKey(t) { var i = Style_toPrimitive(t, "string"); return "symbol" == Style_typeof(i) ? i : i + ""; }
function Style_toPrimitive(t, r) { if ("object" != Style_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Style_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




var Style = /*#__PURE__*/function () {
  function Style() {
    Style_classCallCheck(this, Style);
  }
  return Style_createClass(Style, [{
    key: "jQueryCSS",
    value:
    /**
     * @method jQueryCSS
     *
     * [workaround] for old jQuery
     * passing an array of style properties to .css()
     * will result in an object of property-value pairs.
     * (compability with version < 1.9)
     *
     * @private
     * @param  {jQuery} $obj
     * @param  {Array} propertyNames - An array of one or more CSS properties.
     * @return {Object}
     */
    function jQueryCSS($obj, propertyNames) {
      var result = {};
      external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(propertyNames, function (idx, propertyName) {
        result[propertyName] = $obj.css(propertyName);
      });
      return result;
    }

    /**
     * returns style object from node
     *
     * @param {jQuery} $node
     * @return {Object}
     */
  }, {
    key: "fromNode",
    value: function fromNode($node) {
      var properties = ['font-family', 'font-size', 'text-align', 'list-style-type', 'line-height'];
      var styleInfo = this.jQueryCSS($node, properties) || {};
      var fontSize = $node[0].style.fontSize || styleInfo['font-size'];
      styleInfo['font-size'] = parseInt(fontSize, 10);
      styleInfo['font-size-unit'] = fontSize.match(/[a-z%]+$/);
      return styleInfo;
    }

    /**
     * paragraph level style
     *
     * @param {WrappedRange} rng
     * @param {Object} styleInfo
     */
  }, {
    key: "stylePara",
    value: function stylePara(rng, styleInfo) {
      external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(rng.nodes(dom.isPara, {
        includeAncestor: true
      }), function (idx, para) {
        external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(para).css(styleInfo);
      });
    }

    /**
     * insert and returns styleNodes on range.
     *
     * @param {WrappedRange} rng
     * @param {Object} [options] - options for styleNodes
     * @param {String} [options.nodeName] - default: `SPAN`
     * @param {Boolean} [options.expandClosestSibling] - default: `false`
     * @param {Boolean} [options.onlyPartialContains] - default: `false`
     * @return {Node[]}
     */
  }, {
    key: "styleNodes",
    value: function styleNodes(rng, options) {
      rng = rng.splitText();
      var nodeName = options && options.nodeName || 'SPAN';
      var expandClosestSibling = !!(options && options.expandClosestSibling);
      var onlyPartialContains = !!(options && options.onlyPartialContains);
      if (rng.isCollapsed()) {
        return [rng.insertNode(dom.create(nodeName))];
      }
      var pred = dom.makePredByNodeName(nodeName);
      var nodes = rng.nodes(dom.isText, {
        fullyContains: true
      }).map(function (text) {
        return dom.singleChildAncestor(text, pred) || dom.wrap(text, nodeName);
      });
      if (expandClosestSibling) {
        if (onlyPartialContains) {
          var nodesInRange = rng.nodes();
          // compose with partial contains predication
          pred = func.and(pred, function (node) {
            return lists.contains(nodesInRange, node);
          });
        }
        return nodes.map(function (node) {
          var siblings = dom.withClosestSiblings(node, pred);
          var head = lists.head(siblings);
          var tails = lists.tail(siblings);
          external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(tails, function (idx, elem) {
            dom.appendChildNodes(head, elem.childNodes);
            dom.remove(elem);
          });
          return lists.head(siblings);
        });
      } else {
        return nodes;
      }
    }

    /**
     * get current style on cursor
     *
     * @param {WrappedRange} rng
     * @return {Object} - object contains style properties.
     */
  }, {
    key: "current",
    value: function current(rng) {
      var $cont = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(!dom.isElement(rng.sc) ? rng.sc.parentNode : rng.sc);
      var styleInfo = this.fromNode($cont);

      // document.queryCommandState for toggle state
      // [workaround] prevent Firefox nsresult: "0x80004005 (NS_ERROR_FAILURE)"
      try {
        styleInfo = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().extend(styleInfo, {
          'font-bold': document.queryCommandState('bold') ? 'bold' : 'normal',
          'font-italic': document.queryCommandState('italic') ? 'italic' : 'normal',
          'font-underline': document.queryCommandState('underline') ? 'underline' : 'normal',
          'font-subscript': document.queryCommandState('subscript') ? 'subscript' : 'normal',
          'font-superscript': document.queryCommandState('superscript') ? 'superscript' : 'normal',
          'font-strikethrough': document.queryCommandState('strikethrough') ? 'strikethrough' : 'normal',
          'font-family': document.queryCommandValue('fontname') || styleInfo['font-family']
        });
      } catch (e) {
        // eslint-disable-next-line
      }

      // list-style-type to list-style(unordered, ordered)
      if (!rng.isOnList()) {
        styleInfo['list-style'] = 'none';
      } else {
        var orderedTypes = ['circle', 'disc', 'disc-leading-zero', 'square'];
        var isUnordered = orderedTypes.indexOf(styleInfo['list-style-type']) > -1;
        styleInfo['list-style'] = isUnordered ? 'unordered' : 'ordered';
      }
      var para = dom.ancestor(rng.sc, dom.isPara);
      if (para && para.style['line-height']) {
        styleInfo['line-height'] = para.style.lineHeight;
      } else {
        var lineHeight = parseInt(styleInfo['line-height'], 10) / parseInt(styleInfo['font-size'], 10);
        styleInfo['line-height'] = lineHeight.toFixed(1);
      }
      styleInfo.anchor = rng.isOnAnchor() && dom.ancestor(rng.sc, dom.isAnchor);
      styleInfo.ancestors = dom.listAncestor(rng.sc, dom.isEditable);
      styleInfo.range = rng;
      return styleInfo;
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/editing/Bullet.js
function Bullet_typeof(o) { "@babel/helpers - typeof"; return Bullet_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Bullet_typeof(o); }
function Bullet_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Bullet_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Bullet_toPropertyKey(o.key), o); } }
function Bullet_createClass(e, r, t) { return r && Bullet_defineProperties(e.prototype, r), t && Bullet_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Bullet_toPropertyKey(t) { var i = Bullet_toPrimitive(t, "string"); return "symbol" == Bullet_typeof(i) ? i : i + ""; }
function Bullet_toPrimitive(t, r) { if ("object" != Bullet_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Bullet_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





var Bullet = /*#__PURE__*/function () {
  function Bullet() {
    Bullet_classCallCheck(this, Bullet);
  }
  return Bullet_createClass(Bullet, [{
    key: "insertOrderedList",
    value:
    /**
     * toggle ordered list
     */
    function insertOrderedList(editable) {
      this.toggleList('OL', editable);
    }

    /**
     * toggle unordered list
     */
  }, {
    key: "insertUnorderedList",
    value: function insertUnorderedList(editable) {
      this.toggleList('UL', editable);
    }

    /**
     * indent
     */
  }, {
    key: "indent",
    value: function indent(editable) {
      var _this = this;
      var rng = range.create(editable).wrapBodyInlineWithPara();
      var paras = rng.nodes(dom.isPara, {
        includeAncestor: true
      });
      var clustereds = lists.clusterBy(paras, func.peq2('parentNode'));
      external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(clustereds, function (idx, paras) {
        var head = lists.head(paras);
        if (dom.isLi(head)) {
          var previousList = _this.findList(head.previousSibling);
          if (previousList) {
            paras.map(function (para) {
              return previousList.appendChild(para);
            });
          } else {
            _this.wrapList(paras, head.parentNode.nodeName);
            paras.map(function (para) {
              return para.parentNode;
            }).map(function (para) {
              return _this.appendToPrevious(para);
            });
          }
        } else {
          external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(paras, function (idx, para) {
            external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(para).css('marginLeft', function (idx, val) {
              return (parseInt(val, 10) || 0) + 25;
            });
          });
        }
      });
      rng.select();
    }

    /**
     * outdent
     */
  }, {
    key: "outdent",
    value: function outdent(editable) {
      var _this2 = this;
      var rng = range.create(editable).wrapBodyInlineWithPara();
      var paras = rng.nodes(dom.isPara, {
        includeAncestor: true
      });
      var clustereds = lists.clusterBy(paras, func.peq2('parentNode'));
      external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(clustereds, function (idx, paras) {
        var head = lists.head(paras);
        if (dom.isLi(head)) {
          _this2.releaseList([paras]);
        } else {
          external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(paras, function (idx, para) {
            external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(para).css('marginLeft', function (idx, val) {
              val = parseInt(val, 10) || 0;
              return val > 25 ? val - 25 : '';
            });
          });
        }
      });
      rng.select();
    }

    /**
     * toggle list
     *
     * @param {String} listName - OL or UL
     */
  }, {
    key: "toggleList",
    value: function toggleList(listName, editable) {
      var _this3 = this;
      var rng = range.create(editable).wrapBodyInlineWithPara();
      var paras = rng.nodes(dom.isPara, {
        includeAncestor: true
      });
      var bookmark = rng.paraBookmark(paras);
      var clustereds = lists.clusterBy(paras, func.peq2('parentNode'));

      // paragraph to list
      if (lists.find(paras, dom.isPurePara)) {
        var wrappedParas = [];
        external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(clustereds, function (idx, paras) {
          wrappedParas = wrappedParas.concat(_this3.wrapList(paras, listName));
        });
        paras = wrappedParas;
        // list to paragraph or change list style
      } else {
        var diffLists = rng.nodes(dom.isList, {
          includeAncestor: true
        }).filter(function (listNode) {
          return !external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().nodeName(listNode, listName);
        });
        if (diffLists.length) {
          external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(diffLists, function (idx, listNode) {
            dom.replace(listNode, listName);
          });
        } else {
          paras = this.releaseList(clustereds, true);
        }
      }
      range.createFromParaBookmark(bookmark, paras).select();
    }

    /**
     * @param {Node[]} paras
     * @param {String} listName
     * @return {Node[]}
     */
  }, {
    key: "wrapList",
    value: function wrapList(paras, listName) {
      var head = lists.head(paras);
      var last = lists.last(paras);
      var prevList = dom.isList(head.previousSibling) && head.previousSibling;
      var nextList = dom.isList(last.nextSibling) && last.nextSibling;
      var listNode = prevList || dom.insertAfter(dom.create(listName || 'UL'), last);

      // P to LI
      paras = paras.map(function (para) {
        return dom.isPurePara(para) ? dom.replace(para, 'LI') : para;
      });

      // append to list(<ul>, <ol>)
      dom.appendChildNodes(listNode, paras, true);
      if (nextList) {
        dom.appendChildNodes(listNode, lists.from(nextList.childNodes), true);
        dom.remove(nextList);
      }
      return paras;
    }

    /**
     * @method releaseList
     *
     * @param {Array[]} clustereds
     * @param {Boolean} isEscapseToBody
     * @return {Node[]}
     */
  }, {
    key: "releaseList",
    value: function releaseList(clustereds, isEscapseToBody) {
      var _this4 = this;
      var releasedParas = [];
      external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(clustereds, function (idx, paras) {
        var head = lists.head(paras);
        var last = lists.last(paras);
        var headList = isEscapseToBody ? dom.lastAncestor(head, dom.isList) : head.parentNode;
        var parentItem = headList.parentNode;
        if (headList.parentNode.nodeName === 'LI') {
          paras.map(function (para) {
            var newList = _this4.findNextSiblings(para);
            if (parentItem.nextSibling) {
              parentItem.parentNode.insertBefore(para, parentItem.nextSibling);
            } else {
              parentItem.parentNode.appendChild(para);
            }
            if (newList.length) {
              _this4.wrapList(newList, headList.nodeName);
              para.appendChild(newList[0].parentNode);
            }
          });
          if (headList.children.length === 0) {
            parentItem.removeChild(headList);
          }
          if (parentItem.childNodes.length === 0) {
            parentItem.parentNode.removeChild(parentItem);
          }
        } else {
          var lastList = headList.childNodes.length > 1 ? dom.splitTree(headList, {
            node: last.parentNode,
            offset: dom.position(last) + 1
          }, {
            isSkipPaddingBlankHTML: true
          }) : null;
          var middleList = dom.splitTree(headList, {
            node: head.parentNode,
            offset: dom.position(head)
          }, {
            isSkipPaddingBlankHTML: true
          });
          paras = isEscapseToBody ? dom.listDescendant(middleList, dom.isLi) : lists.from(middleList.childNodes).filter(dom.isLi);

          // LI to P
          if (isEscapseToBody || !dom.isList(headList.parentNode)) {
            paras = paras.map(function (para) {
              return dom.replace(para, 'P');
            });
          }
          external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(lists.from(paras).reverse(), function (idx, para) {
            dom.insertAfter(para, headList);
          });

          // remove empty lists
          var rootLists = lists.compact([headList, middleList, lastList]);
          external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(rootLists, function (idx, rootList) {
            var listNodes = [rootList].concat(dom.listDescendant(rootList, dom.isList));
            external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(listNodes.reverse(), function (idx, listNode) {
              if (!dom.nodeLength(listNode)) {
                dom.remove(listNode, true);
              }
            });
          });
        }
        releasedParas = releasedParas.concat(paras);
      });
      return releasedParas;
    }

    /**
     * @method appendToPrevious
     *
     * Appends list to previous list item, if
     * none exist it wraps the list in a new list item.
     *
     * @param {HTMLNode} ListItem
     * @return {HTMLNode}
     */
  }, {
    key: "appendToPrevious",
    value: function appendToPrevious(node) {
      return node.previousSibling ? dom.appendChildNodes(node.previousSibling, [node]) : this.wrapList([node], 'LI');
    }

    /**
     * @method findList
     *
     * Finds an existing list in list item
     *
     * @param {HTMLNode} ListItem
     * @return {Array[]}
     */
  }, {
    key: "findList",
    value: function findList(node) {
      return node ? lists.find(node.children, function (child) {
        return ['OL', 'UL'].indexOf(child.nodeName) > -1;
      }) : null;
    }

    /**
     * @method findNextSiblings
     *
     * Finds all list item siblings that follow it
     *
     * @param {HTMLNode} ListItem
     * @return {HTMLNode}
     */
  }, {
    key: "findNextSiblings",
    value: function findNextSiblings(node) {
      var siblings = [];
      while (node.nextSibling) {
        siblings.push(node.nextSibling);
        node = node.nextSibling;
      }
      return siblings;
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/editing/Typing.js
function Typing_typeof(o) { "@babel/helpers - typeof"; return Typing_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Typing_typeof(o); }
function Typing_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Typing_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Typing_toPropertyKey(o.key), o); } }
function Typing_createClass(e, r, t) { return r && Typing_defineProperties(e.prototype, r), t && Typing_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Typing_toPropertyKey(t) { var i = Typing_toPrimitive(t, "string"); return "symbol" == Typing_typeof(i) ? i : i + ""; }
function Typing_toPrimitive(t, r) { if ("object" != Typing_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Typing_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





/**
 * @class editing.Typing
 *
 * Typing
 *
 */
var Typing = /*#__PURE__*/function () {
  function Typing(context) {
    Typing_classCallCheck(this, Typing);
    // a Bullet instance to toggle lists off
    this.bullet = new Bullet();
    this.options = context.options;
  }

  /**
   * insert tab
   *
   * @param {WrappedRange} rng
   * @param {Number} tabsize
   */
  return Typing_createClass(Typing, [{
    key: "insertTab",
    value: function insertTab(rng, tabsize) {
      var tab = dom.createText(new Array(tabsize + 1).join(dom.NBSP_CHAR));
      rng = rng.deleteContents();
      rng.insertNode(tab, true);
      rng = range.create(tab, tabsize);
      rng.select();
    }

    /**
     * insert paragraph
     *
     * @param {jQuery} $editable
     * @param {WrappedRange} rng Can be used in unit tests to "mock" the range
     *
     * blockquoteBreakingLevel
     *   0 - No break, the new paragraph remains inside the quote
     *   1 - Break the first blockquote in the ancestors list
     *   2 - Break all blockquotes, so that the new paragraph is not quoted (this is the default)
     */
  }, {
    key: "insertParagraph",
    value: function insertParagraph(editable, rng) {
      rng = rng || range.create(editable);

      // deleteContents on range.
      rng = rng.deleteContents();

      // Wrap range if it needs to be wrapped by paragraph
      rng = rng.wrapBodyInlineWithPara();

      // finding paragraph
      var splitRoot = dom.ancestor(rng.sc, dom.isPara);
      var nextPara;
      // on paragraph: split paragraph
      if (splitRoot) {
        // if it is an empty line with li
        if (dom.isLi(splitRoot) && (dom.isEmpty(splitRoot) || dom.deepestChildIsEmpty(splitRoot))) {
          // toggle UL/OL and escape
          this.bullet.toggleList(splitRoot.parentNode.nodeName);
          return;
        } else {
          var blockquote = null;
          if (this.options.blockquoteBreakingLevel === 1) {
            blockquote = dom.ancestor(splitRoot, dom.isBlockquote);
          } else if (this.options.blockquoteBreakingLevel === 2) {
            blockquote = dom.lastAncestor(splitRoot, dom.isBlockquote);
          }
          if (blockquote) {
            // We're inside a blockquote and options ask us to break it
            nextPara = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(dom.emptyPara)[0];
            // If the split is right before a <br>, remove it so that there's no "empty line"
            // after the split in the new blockquote created
            if (dom.isRightEdgePoint(rng.getStartPoint()) && dom.isBR(rng.sc.nextSibling)) {
              external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(rng.sc.nextSibling).remove();
            }
            var split = dom.splitTree(blockquote, rng.getStartPoint(), {
              isDiscardEmptySplits: true
            });
            if (split) {
              split.parentNode.insertBefore(nextPara, split);
            } else {
              dom.insertAfter(nextPara, blockquote); // There's no split if we were at the end of the blockquote
            }
          } else {
            nextPara = dom.splitTree(splitRoot, rng.getStartPoint());

            // not a blockquote, just insert the paragraph
            var emptyAnchors = dom.listDescendant(splitRoot, dom.isEmptyAnchor);
            emptyAnchors = emptyAnchors.concat(dom.listDescendant(nextPara, dom.isEmptyAnchor));
            external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(emptyAnchors, function (idx, anchor) {
              dom.remove(anchor);
            });

            // replace empty heading, pre or custom-made styleTag with P tag
            if ((dom.isHeading(nextPara) || dom.isPre(nextPara) || dom.isCustomStyleTag(nextPara)) && dom.isEmpty(nextPara)) {
              nextPara = dom.replace(nextPara, 'p');
            }
          }
        }
        // no paragraph: insert empty paragraph
      } else {
        var next = rng.sc.childNodes[rng.so];
        nextPara = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(dom.emptyPara)[0];
        if (next) {
          rng.sc.insertBefore(nextPara, next);
        } else {
          rng.sc.appendChild(nextPara);
        }
      }
      range.create(nextPara, 0).normalize().select().scrollIntoView(editable);
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/editing/Table.js
function Table_typeof(o) { "@babel/helpers - typeof"; return Table_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Table_typeof(o); }
function Table_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Table_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Table_toPropertyKey(o.key), o); } }
function Table_createClass(e, r, t) { return r && Table_defineProperties(e.prototype, r), t && Table_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Table_toPropertyKey(t) { var i = Table_toPrimitive(t, "string"); return "symbol" == Table_typeof(i) ? i : i + ""; }
function Table_toPrimitive(t, r) { if ("object" != Table_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Table_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





/**
 * @class Create a virtual table to create what actions to do in change.
 * @param {object} startPoint Cell selected to apply change.
 * @param {enum} where  Where change will be applied Row or Col. Use enum: TableResultAction.where
 * @param {enum} action Action to be applied. Use enum: TableResultAction.requestAction
 * @param {object} domTable Dom element of table to make changes.
 */
var TableResultAction = function TableResultAction(startPoint, where, action, domTable) {
  var _startPoint = {
    'colPos': 0,
    'rowPos': 0
  };
  var _virtualTable = [];
  var _actionCellList = [];

  /// ///////////////////////////////////////////
  // Private functions
  /// ///////////////////////////////////////////

  /**
   * Set the startPoint of action.
   */
  function setStartPoint() {
    if (!startPoint || !startPoint.tagName || startPoint.tagName.toLowerCase() !== 'td' && startPoint.tagName.toLowerCase() !== 'th') {
      // Impossible to identify start Cell point
      return;
    }
    _startPoint.colPos = startPoint.cellIndex;
    if (!startPoint.parentElement || !startPoint.parentElement.tagName || startPoint.parentElement.tagName.toLowerCase() !== 'tr') {
      // Impossible to identify start Row point
      return;
    }
    _startPoint.rowPos = startPoint.parentElement.rowIndex;
  }

  /**
   * Define virtual table position info object.
   *
   * @param {int} rowIndex Index position in line of virtual table.
   * @param {int} cellIndex Index position in column of virtual table.
   * @param {object} baseRow Row affected by this position.
   * @param {object} baseCell Cell affected by this position.
   * @param {bool} isSpan Inform if it is an span cell/row.
   */
  function setVirtualTablePosition(rowIndex, cellIndex, baseRow, baseCell, isRowSpan, isColSpan, isVirtualCell) {
    var objPosition = {
      'baseRow': baseRow,
      'baseCell': baseCell,
      'isRowSpan': isRowSpan,
      'isColSpan': isColSpan,
      'isVirtual': isVirtualCell
    };
    if (!_virtualTable[rowIndex]) {
      _virtualTable[rowIndex] = [];
    }
    _virtualTable[rowIndex][cellIndex] = objPosition;
  }

  /**
   * Create action cell object.
   *
   * @param {object} virtualTableCellObj Object of specific position on virtual table.
   * @param {enum} resultAction Action to be applied in that item.
   */
  function getActionCell(virtualTableCellObj, resultAction, virtualRowPosition, virtualColPosition) {
    return {
      'baseCell': virtualTableCellObj.baseCell,
      'action': resultAction,
      'virtualTable': {
        'rowIndex': virtualRowPosition,
        'cellIndex': virtualColPosition
      }
    };
  }

  /**
   * Recover free index of row to append Cell.
   *
   * @param {int} rowIndex Index of row to find free space.
   * @param {int} cellIndex Index of cell to find free space in table.
   */
  function recoverCellIndex(rowIndex, cellIndex) {
    if (!_virtualTable[rowIndex]) {
      return cellIndex;
    }
    if (!_virtualTable[rowIndex][cellIndex]) {
      return cellIndex;
    }
    var newCellIndex = cellIndex;
    while (_virtualTable[rowIndex][newCellIndex]) {
      newCellIndex++;
      if (!_virtualTable[rowIndex][newCellIndex]) {
        return newCellIndex;
      }
    }
  }

  /**
   * Recover info about row and cell and add information to virtual table.
   *
   * @param {object} row Row to recover information.
   * @param {object} cell Cell to recover information.
   */
  function addCellInfoToVirtual(row, cell) {
    var cellIndex = recoverCellIndex(row.rowIndex, cell.cellIndex);
    var cellHasColspan = cell.colSpan > 1;
    var cellHasRowspan = cell.rowSpan > 1;
    var isThisSelectedCell = row.rowIndex === _startPoint.rowPos && cell.cellIndex === _startPoint.colPos;
    setVirtualTablePosition(row.rowIndex, cellIndex, row, cell, cellHasRowspan, cellHasColspan, false);

    // Add span rows to virtual Table.
    var rowspanNumber = cell.attributes.rowSpan ? parseInt(cell.attributes.rowSpan.value, 10) : 0;
    if (rowspanNumber > 1) {
      for (var rp = 1; rp < rowspanNumber; rp++) {
        var rowspanIndex = row.rowIndex + rp;
        adjustStartPoint(rowspanIndex, cellIndex, cell, isThisSelectedCell);
        setVirtualTablePosition(rowspanIndex, cellIndex, row, cell, true, cellHasColspan, true);
      }
    }

    // Add span cols to virtual table.
    var colspanNumber = cell.attributes.colSpan ? parseInt(cell.attributes.colSpan.value, 10) : 0;
    if (colspanNumber > 1) {
      for (var cp = 1; cp < colspanNumber; cp++) {
        var cellspanIndex = recoverCellIndex(row.rowIndex, cellIndex + cp);
        adjustStartPoint(row.rowIndex, cellspanIndex, cell, isThisSelectedCell);
        setVirtualTablePosition(row.rowIndex, cellspanIndex, row, cell, cellHasRowspan, true, true);
      }
    }
  }

  /**
   * Process validation and adjust of start point if needed
   *
   * @param {int} rowIndex
   * @param {int} cellIndex
   * @param {object} cell
   * @param {bool} isSelectedCell
   */
  function adjustStartPoint(rowIndex, cellIndex, cell, isSelectedCell) {
    if (rowIndex === _startPoint.rowPos && _startPoint.colPos >= cell.cellIndex && cell.cellIndex <= cellIndex && !isSelectedCell) {
      _startPoint.colPos++;
    }
  }

  /**
   * Create virtual table of cells with all cells, including span cells.
   */
  function createVirtualTable() {
    var rows = domTable.rows;
    for (var rowIndex = 0; rowIndex < rows.length; rowIndex++) {
      var cells = rows[rowIndex].cells;
      for (var cellIndex = 0; cellIndex < cells.length; cellIndex++) {
        addCellInfoToVirtual(rows[rowIndex], cells[cellIndex]);
      }
    }
  }

  /**
   * Get action to be applied on the cell.
   *
   * @param {object} cell virtual table cell to apply action
   */
  function getDeleteResultActionToCell(cell) {
    switch (where) {
      case TableResultAction.where.Column:
        if (cell.isColSpan) {
          return TableResultAction.resultAction.SubtractSpanCount;
        }
        break;
      case TableResultAction.where.Row:
        if (!cell.isVirtual && cell.isRowSpan) {
          return TableResultAction.resultAction.AddCell;
        } else if (cell.isRowSpan) {
          return TableResultAction.resultAction.SubtractSpanCount;
        }
        break;
    }
    return TableResultAction.resultAction.RemoveCell;
  }

  /**
   * Get action to be applied on the cell.
   *
   * @param {object} cell virtual table cell to apply action
   */
  function getAddResultActionToCell(cell) {
    switch (where) {
      case TableResultAction.where.Column:
        if (cell.isColSpan) {
          return TableResultAction.resultAction.SumSpanCount;
        } else if (cell.isRowSpan && cell.isVirtual) {
          return TableResultAction.resultAction.Ignore;
        }
        break;
      case TableResultAction.where.Row:
        if (cell.isRowSpan) {
          return TableResultAction.resultAction.SumSpanCount;
        } else if (cell.isColSpan && cell.isVirtual) {
          return TableResultAction.resultAction.Ignore;
        }
        break;
    }
    return TableResultAction.resultAction.AddCell;
  }
  function init() {
    setStartPoint();
    createVirtualTable();
  }

  /// ///////////////////////////////////////////
  // Public functions
  /// ///////////////////////////////////////////

  /**
   * Recover array os what to do in table.
   */
  this.getActionList = function () {
    var fixedRow = where === TableResultAction.where.Row ? _startPoint.rowPos : -1;
    var fixedCol = where === TableResultAction.where.Column ? _startPoint.colPos : -1;
    var actualPosition = 0;
    var canContinue = true;
    while (canContinue) {
      var rowPosition = fixedRow >= 0 ? fixedRow : actualPosition;
      var colPosition = fixedCol >= 0 ? fixedCol : actualPosition;
      var row = _virtualTable[rowPosition];
      if (!row) {
        canContinue = false;
        return _actionCellList;
      }
      var cell = row[colPosition];
      if (!cell) {
        canContinue = false;
        return _actionCellList;
      }

      // Define action to be applied in this cell
      var resultAction = TableResultAction.resultAction.Ignore;
      switch (action) {
        case TableResultAction.requestAction.Add:
          resultAction = getAddResultActionToCell(cell);
          break;
        case TableResultAction.requestAction.Delete:
          resultAction = getDeleteResultActionToCell(cell);
          break;
      }
      _actionCellList.push(getActionCell(cell, resultAction, rowPosition, colPosition));
      actualPosition++;
    }
    return _actionCellList;
  };
  init();
};
/**
*
* Where action occours enum.
*/
TableResultAction.where = {
  'Row': 0,
  'Column': 1
};
/**
*
* Requested action to apply enum.
*/
TableResultAction.requestAction = {
  'Add': 0,
  'Delete': 1
};
/**
*
* Result action to be executed enum.
*/
TableResultAction.resultAction = {
  'Ignore': 0,
  'SubtractSpanCount': 1,
  'RemoveCell': 2,
  'AddCell': 3,
  'SumSpanCount': 4
};

/**
 *
 * @class editing.Table
 *
 * Table
 *
 */
var Table = /*#__PURE__*/function () {
  function Table() {
    Table_classCallCheck(this, Table);
  }
  return Table_createClass(Table, [{
    key: "tab",
    value:
    /**
     * handle tab key
     *
     * @param {WrappedRange} rng
     * @param {Boolean} isShift
     */
    function tab(rng, isShift) {
      var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
      var table = dom.ancestor(cell, dom.isTable);
      var cells = dom.listDescendant(table, dom.isCell);
      var nextCell = lists[isShift ? 'prev' : 'next'](cells, cell);
      if (nextCell) {
        range.create(nextCell, 0).select();
      }
    }

    /**
     * Add a new row
     *
     * @param {WrappedRange} rng
     * @param {String} position (top/bottom)
     * @return {Node}
     */
  }, {
    key: "addRow",
    value: function addRow(rng, position) {
      var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
      var currentTr = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(cell).closest('tr');
      var trAttributes = this.recoverAttributes(currentTr);
      var html = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<tr' + trAttributes + '></tr>');
      var vTable = new TableResultAction(cell, TableResultAction.where.Row, TableResultAction.requestAction.Add, external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(currentTr).closest('table')[0]);
      var actions = vTable.getActionList();
      for (var idCell = 0; idCell < actions.length; idCell++) {
        var currentCell = actions[idCell];
        var tdAttributes = this.recoverAttributes(currentCell.baseCell);
        switch (currentCell.action) {
          case TableResultAction.resultAction.AddCell:
            html.append('<td' + tdAttributes + '>' + dom.blank + '</td>');
            break;
          case TableResultAction.resultAction.SumSpanCount:
            {
              if (position === 'top') {
                var baseCellTr = currentCell.baseCell.parent;
                var isTopFromRowSpan = (!baseCellTr ? 0 : currentCell.baseCell.closest('tr').rowIndex) <= currentTr[0].rowIndex;
                if (isTopFromRowSpan) {
                  var newTd = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<div></div>').append(external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<td' + tdAttributes + '>' + dom.blank + '</td>').removeAttr('rowspan')).html();
                  html.append(newTd);
                  break;
                }
              }
              var rowspanNumber = parseInt(currentCell.baseCell.rowSpan, 10);
              rowspanNumber++;
              currentCell.baseCell.setAttribute('rowSpan', rowspanNumber);
            }
            break;
        }
      }
      if (position === 'top') {
        currentTr.before(html);
      } else {
        var cellHasRowspan = cell.rowSpan > 1;
        if (cellHasRowspan) {
          var lastTrIndex = currentTr[0].rowIndex + (cell.rowSpan - 2);
          external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(currentTr).parent().find('tr')[lastTrIndex]).after(external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(html));
          return;
        }
        currentTr.after(html);
      }
    }

    /**
     * Add a new col
     *
     * @param {WrappedRange} rng
     * @param {String} position (left/right)
     * @return {Node}
     */
  }, {
    key: "addCol",
    value: function addCol(rng, position) {
      var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
      var row = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(cell).closest('tr');
      var rowsGroup = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(row).siblings();
      rowsGroup.push(row);
      var vTable = new TableResultAction(cell, TableResultAction.where.Column, TableResultAction.requestAction.Add, external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(row).closest('table')[0]);
      var actions = vTable.getActionList();
      for (var actionIndex = 0; actionIndex < actions.length; actionIndex++) {
        var currentCell = actions[actionIndex];
        var tdAttributes = this.recoverAttributes(currentCell.baseCell);
        switch (currentCell.action) {
          case TableResultAction.resultAction.AddCell:
            if (position === 'right') {
              external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(currentCell.baseCell).after('<td' + tdAttributes + '>' + dom.blank + '</td>');
            } else {
              external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(currentCell.baseCell).before('<td' + tdAttributes + '>' + dom.blank + '</td>');
            }
            break;
          case TableResultAction.resultAction.SumSpanCount:
            if (position === 'right') {
              var colspanNumber = parseInt(currentCell.baseCell.colSpan, 10);
              colspanNumber++;
              currentCell.baseCell.setAttribute('colSpan', colspanNumber);
            } else {
              external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(currentCell.baseCell).before('<td' + tdAttributes + '>' + dom.blank + '</td>');
            }
            break;
        }
      }
    }

    /*
    * Copy attributes from element.
    *
    * @param {object} Element to recover attributes.
    * @return {string} Copied string elements.
    */
  }, {
    key: "recoverAttributes",
    value: function recoverAttributes(el) {
      var resultStr = '';
      if (!el) {
        return resultStr;
      }
      var attrList = el.attributes || [];
      for (var i = 0; i < attrList.length; i++) {
        if (attrList[i].name.toLowerCase() === 'id') {
          continue;
        }
        if (attrList[i].specified) {
          resultStr += ' ' + attrList[i].name + '=\'' + attrList[i].value + '\'';
        }
      }
      return resultStr;
    }

    /**
     * Delete current row
     *
     * @param {WrappedRange} rng
     * @return {Node}
     */
  }, {
    key: "deleteRow",
    value: function deleteRow(rng) {
      var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
      var row = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(cell).closest('tr');
      var cellPos = row.children('td, th').index(external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(cell));
      var rowPos = row[0].rowIndex;
      var vTable = new TableResultAction(cell, TableResultAction.where.Row, TableResultAction.requestAction.Delete, external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(row).closest('table')[0]);
      var actions = vTable.getActionList();
      for (var actionIndex = 0; actionIndex < actions.length; actionIndex++) {
        if (!actions[actionIndex]) {
          continue;
        }
        var baseCell = actions[actionIndex].baseCell;
        var virtualPosition = actions[actionIndex].virtualTable;
        var hasRowspan = baseCell.rowSpan && baseCell.rowSpan > 1;
        var rowspanNumber = hasRowspan ? parseInt(baseCell.rowSpan, 10) : 0;
        switch (actions[actionIndex].action) {
          case TableResultAction.resultAction.Ignore:
            continue;
          case TableResultAction.resultAction.AddCell:
            {
              var nextRow = row.next('tr')[0];
              if (!nextRow) {
                continue;
              }
              var cloneRow = row[0].cells[cellPos];
              if (hasRowspan) {
                if (rowspanNumber > 2) {
                  rowspanNumber--;
                  nextRow.insertBefore(cloneRow, nextRow.cells[cellPos]);
                  nextRow.cells[cellPos].setAttribute('rowSpan', rowspanNumber);
                  nextRow.cells[cellPos].innerHTML = '';
                } else if (rowspanNumber === 2) {
                  nextRow.insertBefore(cloneRow, nextRow.cells[cellPos]);
                  nextRow.cells[cellPos].removeAttribute('rowSpan');
                  nextRow.cells[cellPos].innerHTML = '';
                }
              }
            }
            continue;
          case TableResultAction.resultAction.SubtractSpanCount:
            if (hasRowspan) {
              if (rowspanNumber > 2) {
                rowspanNumber--;
                baseCell.setAttribute('rowSpan', rowspanNumber);
                if (virtualPosition.rowIndex !== rowPos && baseCell.cellIndex === cellPos) {
                  baseCell.innerHTML = '';
                }
              } else if (rowspanNumber === 2) {
                baseCell.removeAttribute('rowSpan');
                if (virtualPosition.rowIndex !== rowPos && baseCell.cellIndex === cellPos) {
                  baseCell.innerHTML = '';
                }
              }
            }
            continue;
          case TableResultAction.resultAction.RemoveCell:
            // Do not need remove cell because row will be deleted.
            continue;
        }
      }
      row.remove();
    }

    /**
     * Delete current col
     *
     * @param {WrappedRange} rng
     * @return {Node}
     */
  }, {
    key: "deleteCol",
    value: function deleteCol(rng) {
      var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
      var row = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(cell).closest('tr');
      var cellPos = row.children('td, th').index(external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(cell));
      var vTable = new TableResultAction(cell, TableResultAction.where.Column, TableResultAction.requestAction.Delete, external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(row).closest('table')[0]);
      var actions = vTable.getActionList();
      for (var actionIndex = 0; actionIndex < actions.length; actionIndex++) {
        if (!actions[actionIndex]) {
          continue;
        }
        switch (actions[actionIndex].action) {
          case TableResultAction.resultAction.Ignore:
            continue;
          case TableResultAction.resultAction.SubtractSpanCount:
            {
              var baseCell = actions[actionIndex].baseCell;
              var hasColspan = baseCell.colSpan && baseCell.colSpan > 1;
              if (hasColspan) {
                var colspanNumber = baseCell.colSpan ? parseInt(baseCell.colSpan, 10) : 0;
                if (colspanNumber > 2) {
                  colspanNumber--;
                  baseCell.setAttribute('colSpan', colspanNumber);
                  if (baseCell.cellIndex === cellPos) {
                    baseCell.innerHTML = '';
                  }
                } else if (colspanNumber === 2) {
                  baseCell.removeAttribute('colSpan');
                  if (baseCell.cellIndex === cellPos) {
                    baseCell.innerHTML = '';
                  }
                }
              }
            }
            continue;
          case TableResultAction.resultAction.RemoveCell:
            dom.remove(actions[actionIndex].baseCell, true);
            continue;
        }
      }
    }

    /**
     * create empty table element
     *
     * @param {Number} rowCount
     * @param {Number} colCount
     * @return {Node}
     */
  }, {
    key: "createTable",
    value: function createTable(colCount, rowCount, options) {
      var tds = [];
      var tdHTML;
      for (var idxCol = 0; idxCol < colCount; idxCol++) {
        tds.push('<td>' + dom.blank + '</td>');
      }
      tdHTML = tds.join('');
      var trs = [];
      var trHTML;
      for (var idxRow = 0; idxRow < rowCount; idxRow++) {
        trs.push('<tr>' + tdHTML + '</tr>');
      }
      trHTML = trs.join('');
      var $table = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<table>' + trHTML + '</table>');
      if (options && options.tableClassName) {
        $table.addClass(options.tableClassName);
      }
      return $table[0];
    }

    /**
     * Delete current table
     *
     * @param {WrappedRange} rng
     * @return {Node}
     */
  }, {
    key: "deleteTable",
    value: function deleteTable(rng) {
      var cell = dom.ancestor(rng.commonAncestor(), dom.isCell);
      external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(cell).closest('table').remove();
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/Editor.js
function Editor_typeof(o) { "@babel/helpers - typeof"; return Editor_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Editor_typeof(o); }
function Editor_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Editor_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Editor_toPropertyKey(o.key), o); } }
function Editor_createClass(e, r, t) { return r && Editor_defineProperties(e.prototype, r), t && Editor_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Editor_toPropertyKey(t) { var i = Editor_toPrimitive(t, "string"); return "symbol" == Editor_typeof(i) ? i : i + ""; }
function Editor_toPrimitive(t, r) { if ("object" != Editor_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Editor_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }













var KEY_BOGUS = 'bogus';
var MAILTO_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
var TEL_PATTERN = /^(\+?\d{1,3}[\s-]?)?(\d{1,4})[\s-]?(\d{1,4})[\s-]?(\d{1,4})$/;
var URL_SCHEME_PATTERN = /^([A-Za-z][A-Za-z0-9+-.]*\:|#|\/)/;

/**
 * @class Editor
 */
var Editor = /*#__PURE__*/function () {
  function Editor(context) {
    var _this = this;
    Editor_classCallCheck(this, Editor);
    this.context = context;
    this.$note = context.layoutInfo.note;
    this.$editor = context.layoutInfo.editor;
    this.$editable = context.layoutInfo.editable;
    this.options = context.options;
    this.lang = this.options.langInfo;
    this.editable = this.$editable[0];
    this.lastRange = null;
    this.snapshot = null;
    this.style = new Style();
    this.table = new Table();
    this.typing = new Typing(context);
    this.bullet = new Bullet();
    this.history = new History(context);
    this.context.memo('help.escape', this.lang.help.escape);
    this.context.memo('help.undo', this.lang.help.undo);
    this.context.memo('help.redo', this.lang.help.redo);
    this.context.memo('help.tab', this.lang.help.tab);
    this.context.memo('help.untab', this.lang.help.untab);
    this.context.memo('help.insertParagraph', this.lang.help.insertParagraph);
    this.context.memo('help.insertOrderedList', this.lang.help.insertOrderedList);
    this.context.memo('help.insertUnorderedList', this.lang.help.insertUnorderedList);
    this.context.memo('help.indent', this.lang.help.indent);
    this.context.memo('help.outdent', this.lang.help.outdent);
    this.context.memo('help.formatPara', this.lang.help.formatPara);
    this.context.memo('help.insertHorizontalRule', this.lang.help.insertHorizontalRule);
    this.context.memo('help.fontName', this.lang.help.fontName);

    // native commands(with execCommand), generate function for execCommand
    var commands = ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'formatBlock', 'removeFormat', 'backColor'];
    for (var idx = 0, len = commands.length; idx < len; idx++) {
      this[commands[idx]] = function (sCmd) {
        return function (value) {
          _this.beforeCommand();
          document.execCommand(sCmd, false, value);
          _this.afterCommand(true);
        };
      }(commands[idx]);
      this.context.memo('help.' + commands[idx], this.lang.help[commands[idx]]);
    }
    this.fontName = this.wrapCommand(function (value) {
      return _this.fontStyling('font-family', env.validFontName(value));
    });
    this.fontSize = this.wrapCommand(function (value) {
      var unit = _this.currentStyle()['font-size-unit'];
      return _this.fontStyling('font-size', value + unit);
    });
    this.fontSizeUnit = this.wrapCommand(function (value) {
      var size = _this.currentStyle()['font-size'];
      return _this.fontStyling('font-size', size + value);
    });
    for (var _idx = 1; _idx <= 6; _idx++) {
      this['formatH' + _idx] = function (idx) {
        return function () {
          _this.formatBlock('H' + idx);
        };
      }(_idx);
      this.context.memo('help.formatH' + _idx, this.lang.help['formatH' + _idx]);
    }
    this.insertParagraph = this.wrapCommand(function () {
      _this.typing.insertParagraph(_this.editable);
    });
    this.insertOrderedList = this.wrapCommand(function () {
      _this.bullet.insertOrderedList(_this.editable);
    });
    this.insertUnorderedList = this.wrapCommand(function () {
      _this.bullet.insertUnorderedList(_this.editable);
    });
    this.indent = this.wrapCommand(function () {
      _this.bullet.indent(_this.editable);
    });
    this.outdent = this.wrapCommand(function () {
      _this.bullet.outdent(_this.editable);
    });

    /**
     * insertNode
     * insert node
     * @param {Node} node
     */
    this.insertNode = this.wrapCommand(function (node) {
      if (_this.isLimited(external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(node).text().length)) {
        return;
      }
      var rng = _this.getLastRange();
      rng.insertNode(node);
      _this.setLastRange(range.createFromNodeAfter(node).select());
    });

    /**
     * insert text
     * @param {String} text
     */
    this.insertText = this.wrapCommand(function (text) {
      if (_this.isLimited(text.length)) {
        return;
      }
      var rng = _this.getLastRange();
      var textNode = rng.insertNode(dom.createText(text));
      _this.setLastRange(range.create(textNode, dom.nodeLength(textNode)).select());
    });

    /**
     * paste HTML
     * @param {String} markup
     */
    this.pasteHTML = this.wrapCommand(function (markup) {
      if (_this.isLimited(markup.length)) {
        return;
      }
      markup = _this.context.invoke('codeview.purify', markup);
      var contents = _this.getLastRange().pasteHTML(markup);
      _this.setLastRange(range.createFromNodeAfter(lists.last(contents)).select());
    });

    /**
     * formatBlock
     *
     * @param {String} tagName
     */
    this.formatBlock = this.wrapCommand(function (tagName, $target) {
      var onApplyCustomStyle = _this.options.callbacks.onApplyCustomStyle;
      if (onApplyCustomStyle) {
        onApplyCustomStyle.call(_this, $target, _this.context, _this.onFormatBlock);
      } else {
        _this.onFormatBlock(tagName, $target);
      }
    });

    /**
     * insert horizontal rule
     */
    this.insertHorizontalRule = this.wrapCommand(function () {
      var hrNode = _this.getLastRange().insertNode(dom.create('HR'));
      if (hrNode.nextSibling) {
        _this.setLastRange(range.create(hrNode.nextSibling, 0).normalize().select());
      }
    });

    /**
     * lineHeight
     * @param {String} value
     */
    this.lineHeight = this.wrapCommand(function (value) {
      _this.style.stylePara(_this.getLastRange(), {
        lineHeight: value
      });
    });

    /**
     * create link (command)
     *
     * @param {Object} linkInfo
     */
    this.createLink = this.wrapCommand(function (linkInfo) {
      var rel = [];
      var linkUrl = linkInfo.url;
      var linkText = linkInfo.text;
      var isNewWindow = linkInfo.isNewWindow;
      var addNoReferrer = _this.options.linkAddNoReferrer;
      var addNoOpener = _this.options.linkAddNoOpener;
      var rng = linkInfo.range || _this.getLastRange();
      var additionalTextLength = linkText.length - rng.toString().length;
      if (additionalTextLength > 0 && _this.isLimited(additionalTextLength)) {
        return;
      }
      var isTextChanged = rng.toString() !== linkText;

      // handle spaced urls from input
      if (typeof linkUrl === 'string') {
        linkUrl = linkUrl.trim();
      }
      if (_this.options.onCreateLink) {
        linkUrl = _this.options.onCreateLink(linkUrl);
      } else {
        linkUrl = _this.checkLinkUrl(linkUrl);
      }
      var anchors = [];
      if (isTextChanged) {
        rng = rng.deleteContents();
        var anchor = rng.insertNode(external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<A></A>').text(linkText)[0]);
        anchors.push(anchor);
      } else {
        anchors = _this.style.styleNodes(rng, {
          nodeName: 'A',
          expandClosestSibling: true,
          onlyPartialContains: true
        });
      }
      external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(anchors, function (idx, anchor) {
        external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(anchor).attr('href', linkUrl);
        if (isNewWindow) {
          external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(anchor).attr('target', '_blank');
          if (addNoReferrer) {
            rel.push('noreferrer');
          }
          if (addNoOpener) {
            rel.push('noopener');
          }
          if (rel.length) {
            external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(anchor).attr('rel', rel.join(' '));
          }
        } else {
          external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(anchor).removeAttr('target');
        }
      });
      _this.setLastRange(_this.createRangeFromList(anchors).select());
    });

    /**
     * setting color
     *
     * @param {Object} sObjColor  color code
     * @param {String} sObjColor.foreColor foreground color
     * @param {String} sObjColor.backColor background color
     */
    this.color = this.wrapCommand(function (colorInfo) {
      var foreColor = colorInfo.foreColor;
      var backColor = colorInfo.backColor;
      if (foreColor) {
        document.execCommand('foreColor', false, foreColor);
      }
      if (backColor) {
        document.execCommand('backColor', false, backColor);
      }
    });

    /**
     * Set foreground color
     *
     * @param {String} colorCode foreground color code
     */
    this.foreColor = this.wrapCommand(function (colorInfo) {
      document.execCommand('foreColor', false, colorInfo);
    });

    /**
     * insert Table
     *
     * @param {String} dimension of table (ex : "5x5")
     */
    this.insertTable = this.wrapCommand(function (dim) {
      var dimension = dim.split('x');
      var rng = _this.getLastRange().deleteContents();
      rng.insertNode(_this.table.createTable(dimension[0], dimension[1], _this.options));
    });

    /**
     * remove media object and Figure Elements if media object is img with Figure.
     */
    this.removeMedia = this.wrapCommand(function () {
      var $target = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(_this.restoreTarget()).parent();
      if ($target.closest('figure').length) {
        $target.closest('figure').remove();
      } else {
        $target = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(_this.restoreTarget()).detach();
      }
      _this.setLastRange(range.createFromSelection($target).select());
      _this.context.triggerEvent('media.delete', $target, _this.$editable);
    });

    /**
     * float me
     *
     * @param {String} value
     */
    this.floatMe = this.wrapCommand(function (value) {
      var $target = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(_this.restoreTarget());
      $target.toggleClass('note-float-left', value === 'left');
      $target.toggleClass('note-float-right', value === 'right');
      $target.css('float', value === 'none' ? '' : value);
    });

    /**
     * resize overlay element
     * @param {String} value
     */
    this.resize = this.wrapCommand(function (value) {
      var $target = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(_this.restoreTarget());
      value = parseFloat(value);
      if (value === 0) {
        $target.css('width', '');
      } else {
        $target.css({
          width: value * 100 + '%',
          height: ''
        });
      }
    });
  }
  return Editor_createClass(Editor, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;
      // bind custom events
      this.$editable.on('keydown', function (event) {
        if (event.keyCode === key.code.ENTER) {
          _this2.context.triggerEvent('enter', event);
        }
        _this2.context.triggerEvent('keydown', event);

        // keep a snapshot to limit text on input event
        _this2.snapshot = _this2.history.makeSnapshot();
        _this2.hasKeyShortCut = false;
        if (!event.isDefaultPrevented()) {
          if (_this2.options.shortcuts) {
            _this2.hasKeyShortCut = _this2.handleKeyMap(event);
          } else {
            _this2.preventDefaultEditableShortCuts(event);
          }
        }
        if (_this2.isLimited(1, event)) {
          var lastRange = _this2.getLastRange();
          if (lastRange.eo - lastRange.so === 0) {
            return false;
          }
        }
        _this2.setLastRange();

        // record undo in the key event except keyMap.
        if (_this2.options.recordEveryKeystroke) {
          if (_this2.hasKeyShortCut === false) {
            _this2.history.recordUndo();
          }
        }
      }).on('keyup', function (event) {
        _this2.setLastRange();
        _this2.context.triggerEvent('keyup', event);
      }).on('focus', function (event) {
        _this2.setLastRange();
        _this2.context.triggerEvent('focus', event);
      }).on('blur', function (event) {
        _this2.context.triggerEvent('blur', event);
      }).on('mousedown', function (event) {
        _this2.context.triggerEvent('mousedown', event);
      }).on('mouseup', function (event) {
        _this2.setLastRange();
        _this2.history.recordUndo();
        _this2.context.triggerEvent('mouseup', event);
      }).on('scroll', function (event) {
        _this2.context.triggerEvent('scroll', event);
      }).on('paste', function (event) {
        _this2.setLastRange();
        _this2.context.triggerEvent('paste', event);
      }).on('copy', function (event) {
        _this2.context.triggerEvent('copy', event);
      }).on('input', function () {
        // To limit composition characters (e.g. Korean)
        if (_this2.isLimited(0) && _this2.snapshot) {
          _this2.history.applySnapshot(_this2.snapshot);
        }
      });
      this.$editable.attr('spellcheck', this.options.spellCheck);
      this.$editable.attr('autocorrect', this.options.spellCheck);
      if (this.options.disableGrammar) {
        this.$editable.attr('data-gramm', false);
      }

      // init content before set event
      this.$editable.html(dom.html(this.$note) || dom.emptyPara);
      this.$editable.on(env.inputEventName, func.debounce(function () {
        _this2.context.triggerEvent('change', _this2.$editable.html(), _this2.$editable);
      }, 10));
      this.$editable.on('focusin', function (event) {
        _this2.context.triggerEvent('focusin', event);
      }).on('focusout', function (event) {
        _this2.context.triggerEvent('focusout', event);
      });
      if (this.options.airMode) {
        if (this.options.overrideContextMenu) {
          this.$editor.on('contextmenu', function (event) {
            _this2.context.triggerEvent('contextmenu', event);
            return false;
          });
        }
      } else {
        if (this.options.width) {
          this.$editor.outerWidth(this.options.width);
        }
        if (this.options.height) {
          this.$editable.outerHeight(this.options.height);
        }
        if (this.options.maxHeight) {
          this.$editable.css('max-height', this.options.maxHeight);
        }
        if (this.options.minHeight) {
          this.$editable.css('min-height', this.options.minHeight);
        }
      }
      this.history.recordUndo();
      this.setLastRange();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.$editable.off();
    }
  }, {
    key: "handleKeyMap",
    value: function handleKeyMap(event) {
      var keyMap = this.options.keyMap[env.isMac ? 'mac' : 'pc'];
      var keys = [];
      if (event.metaKey) {
        keys.push('CMD');
      }
      if (event.ctrlKey && !event.altKey) {
        keys.push('CTRL');
      }
      if (event.shiftKey) {
        keys.push('SHIFT');
      }
      var keyName = key.nameFromCode[event.keyCode];
      if (keyName) {
        keys.push(keyName);
      }
      var eventName = keyMap[keys.join('+')];
      if (keyName === 'TAB' && !this.options.tabDisable) {
        this.afterCommand();
      } else if (eventName) {
        if (this.context.invoke(eventName) !== false) {
          event.preventDefault();
          return true;
        }
      } else if (key.isEdit(event.keyCode)) {
        if (key.isRemove(event.keyCode)) {
          this.context.invoke('removed');
        }
        this.afterCommand();
      }
      return false;
    }
  }, {
    key: "preventDefaultEditableShortCuts",
    value: function preventDefaultEditableShortCuts(event) {
      // B(Bold, 66) / I(Italic, 73) / U(Underline, 85)
      if ((event.ctrlKey || event.metaKey) && lists.contains([66, 73, 85], event.keyCode)) {
        event.preventDefault();
      }
    }
  }, {
    key: "isLimited",
    value: function isLimited(pad, event) {
      pad = pad || 0;
      if (typeof event !== 'undefined') {
        if (key.isMove(event.keyCode) || key.isNavigation(event.keyCode) || event.ctrlKey || event.metaKey || lists.contains([key.code.BACKSPACE, key.code.DELETE], event.keyCode)) {
          return false;
        }
      }
      if (this.options.maxTextLength > 0) {
        if (this.$editable.text().length + pad > this.options.maxTextLength) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "checkLinkUrl",
    value: function checkLinkUrl(linkUrl) {
      if (MAILTO_PATTERN.test(linkUrl)) {
        return 'mailto://' + linkUrl;
      } else if (TEL_PATTERN.test(linkUrl)) {
        return 'tel://' + linkUrl;
      } else if (!URL_SCHEME_PATTERN.test(linkUrl)) {
        return 'http://' + linkUrl;
      }
      return linkUrl;
    }

    /**
     * create range
     * @return {WrappedRange}
     */
  }, {
    key: "createRange",
    value: function createRange() {
      this.focus();
      this.setLastRange();
      return this.getLastRange();
    }

    /**
     * create a new range from the list of elements
     *
     * @param {list} dom element list
     * @return {WrappedRange}
     */
  }, {
    key: "createRangeFromList",
    value: function createRangeFromList(lst) {
      var startRange = range.createFromNodeBefore(lists.head(lst));
      var startPoint = startRange.getStartPoint();
      var endRange = range.createFromNodeAfter(lists.last(lst));
      var endPoint = endRange.getEndPoint();
      return range.create(startPoint.node, startPoint.offset, endPoint.node, endPoint.offset);
    }

    /**
     * set the last range
     *
     * if given rng is exist, set rng as the last range
     * or create a new range at the end of the document
     *
     * @param {WrappedRange} rng
     */
  }, {
    key: "setLastRange",
    value: function setLastRange(rng) {
      if (rng) {
        this.lastRange = rng;
      } else {
        this.lastRange = range.create(this.editable);
        if (external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(this.lastRange.sc).closest('.note-editable').length === 0) {
          this.lastRange = range.createFromBodyElement(this.editable);
        }
      }
    }

    /**
     * get the last range
     *
     * if there is a saved last range, return it
     * or create a new range and return it
     *
     * @return {WrappedRange}
     */
  }, {
    key: "getLastRange",
    value: function getLastRange() {
      if (!this.lastRange) {
        this.setLastRange();
      }
      return this.lastRange;
    }

    /**
     * saveRange
     *
     * save current range
     *
     * @param {Boolean} [thenCollapse=false]
     */
  }, {
    key: "saveRange",
    value: function saveRange(thenCollapse) {
      if (thenCollapse) {
        this.getLastRange().collapse().select();
      }
    }

    /**
     * restoreRange
     *
     * restore lately range
     */
  }, {
    key: "restoreRange",
    value: function restoreRange() {
      if (this.lastRange) {
        this.lastRange.select();
        this.focus();
      }
    }
  }, {
    key: "saveTarget",
    value: function saveTarget(node) {
      this.$editable.data('target', node);
    }
  }, {
    key: "clearTarget",
    value: function clearTarget() {
      this.$editable.removeData('target');
    }
  }, {
    key: "restoreTarget",
    value: function restoreTarget() {
      return this.$editable.data('target');
    }

    /**
     * currentStyle
     *
     * current style
     * @return {Object|Boolean} unfocus
     */
  }, {
    key: "currentStyle",
    value: function currentStyle() {
      var rng = range.create();
      if (rng) {
        rng = rng.normalize();
      }
      return rng ? this.style.current(rng) : this.style.fromNode(this.$editable);
    }

    /**
     * style from node
     *
     * @param {jQuery} $node
     * @return {Object}
     */
  }, {
    key: "styleFromNode",
    value: function styleFromNode($node) {
      return this.style.fromNode($node);
    }

    /**
     * undo
     */
  }, {
    key: "undo",
    value: function undo() {
      this.context.triggerEvent('before.command', this.$editable.html());
      this.history.undo();
      this.context.triggerEvent('change', this.$editable.html(), this.$editable);
    }

    /*
    * commit
    */
  }, {
    key: "commit",
    value: function commit() {
      this.context.triggerEvent('before.command', this.$editable.html());
      this.history.commit();
      this.context.triggerEvent('change', this.$editable.html(), this.$editable);
    }

    /**
     * redo
     */
  }, {
    key: "redo",
    value: function redo() {
      this.context.triggerEvent('before.command', this.$editable.html());
      this.history.redo();
      this.context.triggerEvent('change', this.$editable.html(), this.$editable);
    }

    /**
     * before command
     */
  }, {
    key: "beforeCommand",
    value: function beforeCommand() {
      this.context.triggerEvent('before.command', this.$editable.html());

      // Set styleWithCSS before run a command
      document.execCommand('styleWithCSS', false, this.options.styleWithCSS);

      // keep focus on editable before command execution
      this.focus();
    }

    /**
     * after command
     * @param {Boolean} isPreventTrigger
     */
  }, {
    key: "afterCommand",
    value: function afterCommand(isPreventTrigger) {
      this.normalizeContent();
      this.history.recordUndo();
      if (!isPreventTrigger) {
        this.context.triggerEvent('change', this.$editable.html(), this.$editable);
      }
    }

    /**
     * handle tab key
     */
  }, {
    key: "tab",
    value: function tab() {
      var rng = this.getLastRange();
      if (rng.isCollapsed() && rng.isOnCell()) {
        this.table.tab(rng);
      } else {
        if (this.options.tabSize === 0) {
          return false;
        }
        if (!this.isLimited(this.options.tabSize)) {
          this.beforeCommand();
          this.typing.insertTab(rng, this.options.tabSize);
          this.afterCommand();
        }
      }
    }

    /**
     * handle shift+tab key
     */
  }, {
    key: "untab",
    value: function untab() {
      var rng = this.getLastRange();
      if (rng.isCollapsed() && rng.isOnCell()) {
        this.table.tab(rng, true);
      } else {
        if (this.options.tabSize === 0) {
          return false;
        }
      }
    }

    /**
     * run given function between beforeCommand and afterCommand
     */
  }, {
    key: "wrapCommand",
    value: function wrapCommand(fn) {
      return function () {
        this.beforeCommand();
        fn.apply(this, arguments);
        this.afterCommand();
      };
    }
    /**
     * removed (function added by 1der1)
    */
  }, {
    key: "removed",
    value: function removed(rng, node, tagName) {
      // LB
      rng = range.create();
      if (rng.isCollapsed() && rng.isOnCell()) {
        node = rng.ec;
        if ((tagName = node.tagName) && node.childElementCount === 1 && node.childNodes[0].tagName === "BR") {
          if (tagName === "P") {
            node.remove();
          } else if (['TH', 'TD'].indexOf(tagName) >= 0) {
            node.firstChild.remove();
          }
        }
      }
    }
    /**
     * insert image
     *
     * @param {String} src
     * @param {String|Function} param
     * @return {Promise}
     */
  }, {
    key: "insertImage",
    value: function insertImage(src, param) {
      var _this3 = this;
      return createImage(src, param).then(function ($image) {
        _this3.beforeCommand();
        if (typeof param === 'function') {
          param($image);
        } else {
          if (typeof param === 'string') {
            $image.attr('data-filename', param);
          }
          $image.css('width', Math.min(_this3.$editable.width(), $image.width()));
        }
        $image.show();
        _this3.getLastRange().insertNode($image[0]);
        _this3.setLastRange(range.createFromNodeAfter($image[0]).select());
        _this3.afterCommand();
      }).fail(function (e) {
        _this3.context.triggerEvent('image.upload.error', e);
      });
    }

    /**
     * insertImages
     * @param {File[]} files
     */
  }, {
    key: "insertImagesAsDataURL",
    value: function insertImagesAsDataURL(files) {
      var _this4 = this;
      external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(files, function (idx, file) {
        var filename = file.name;
        if (_this4.options.maximumImageFileSize && _this4.options.maximumImageFileSize < file.size) {
          _this4.context.triggerEvent('image.upload.error', _this4.lang.image.maximumFileSizeError);
        } else {
          readFileAsDataURL(file).then(function (dataURL) {
            return _this4.insertImage(dataURL, filename);
          }).fail(function () {
            _this4.context.triggerEvent('image.upload.error');
          });
        }
      });
    }

    /**
     * insertImagesOrCallback
     * @param {File[]} files
     */
  }, {
    key: "insertImagesOrCallback",
    value: function insertImagesOrCallback(files) {
      var callbacks = this.options.callbacks;
      // If onImageUpload set,
      if (callbacks.onImageUpload) {
        this.context.triggerEvent('image.upload', files);
        // else insert Image as dataURL
      } else {
        this.insertImagesAsDataURL(files);
      }
    }

    /**
     * return selected plain text
     * @return {String} text
     */
  }, {
    key: "getSelectedText",
    value: function getSelectedText() {
      var rng = this.getLastRange();

      // if range on anchor, expand range with anchor
      if (rng.isOnAnchor()) {
        rng = range.createFromNode(dom.ancestor(rng.sc, dom.isAnchor));
      }
      return rng.toString();
    }
  }, {
    key: "onFormatBlock",
    value: function onFormatBlock(tagName, $target) {
      // [workaround] for MSIE, IE need `<`
      document.execCommand('FormatBlock', false, env.isMSIE ? '<' + tagName + '>' : tagName);

      // support custom class
      if ($target && $target.length) {
        // find the exact element has given tagName
        if ($target[0].tagName.toUpperCase() !== tagName.toUpperCase()) {
          $target = $target.find(tagName);
        }
        if ($target && $target.length) {
          var currentRange = this.createRange();
          var $parent = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()([currentRange.sc, currentRange.ec]).closest(tagName);
          // remove class added for current block
          $parent.removeClass();
          var className = $target[0].className || '';
          if (className) {
            $parent.addClass(className);
          }
        }
      }
    }
  }, {
    key: "formatPara",
    value: function formatPara() {
      this.formatBlock('P');
    }
  }, {
    key: "fontStyling",
    value: function fontStyling(target, value) {
      var rng = this.getLastRange();
      if (rng !== '') {
        var spans = this.style.styleNodes(rng);
        this.$editor.find('.note-status-output').html('');
        external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(spans).css(target, value);

        // [workaround] added styled bogus span for style
        //  - also bogus character needed for cursor position
        if (rng.isCollapsed()) {
          var firstSpan = lists.head(spans);
          if (firstSpan && !dom.nodeLength(firstSpan)) {
            firstSpan.innerHTML = dom.ZERO_WIDTH_NBSP_CHAR;
            range.createFromNode(firstSpan.firstChild).select();
            this.setLastRange();
            this.$editable.data(KEY_BOGUS, firstSpan);
          }
        } else {
          rng.select();
        }
      } else {
        var noteStatusOutput = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().now();
        this.$editor.find('.note-status-output').html('<div id="note-status-output-' + noteStatusOutput + '" class="alert alert-info">' + this.lang.output.noSelection + '</div>');
        setTimeout(function () {
          external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('#note-status-output-' + noteStatusOutput).remove();
        }, 5000);
      }
    }

    /**
     * unlink
     *
     * @type command
     */
  }, {
    key: "unlink",
    value: function unlink() {
      var rng = this.getLastRange();
      if (rng.isOnAnchor()) {
        var anchor = dom.ancestor(rng.sc, dom.isAnchor);
        rng = range.createFromNode(anchor);
        rng.select();
        this.setLastRange();
        this.beforeCommand();
        document.execCommand('unlink');
        this.afterCommand();
      }
    }

    /**
     * returns link info
     *
     * @return {Object}
     * @return {WrappedRange} return.range
     * @return {String} return.text
     * @return {Boolean} [return.isNewWindow=true]
     * @return {String} [return.url=""]
     */
  }, {
    key: "getLinkInfo",
    value: function getLinkInfo() {
      if (!this.hasFocus()) {
        this.focus();
      }
      var rng = this.getLastRange().expand(dom.isAnchor);
      // Get the first anchor on range(for edit).
      var $anchor = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(lists.head(rng.nodes(dom.isAnchor)));
      var linkInfo = {
        range: rng,
        text: rng.toString(),
        url: $anchor.length ? $anchor.attr('href') : ''
      };

      // When anchor exists,
      if ($anchor.length) {
        // Set isNewWindow by checking its target.
        linkInfo.isNewWindow = $anchor.attr('target') === '_blank';
      }
      return linkInfo;
    }
  }, {
    key: "addRow",
    value: function addRow(position) {
      var rng = this.getLastRange(this.$editable);
      if (rng.isCollapsed() && rng.isOnCell()) {
        this.beforeCommand();
        this.table.addRow(rng, position);
        this.afterCommand();
      }
    }
  }, {
    key: "addCol",
    value: function addCol(position) {
      var rng = this.getLastRange(this.$editable);
      if (rng.isCollapsed() && rng.isOnCell()) {
        this.beforeCommand();
        this.table.addCol(rng, position);
        this.afterCommand();
      }
    }
  }, {
    key: "deleteRow",
    value: function deleteRow() {
      var rng = this.getLastRange(this.$editable);
      if (rng.isCollapsed() && rng.isOnCell()) {
        this.beforeCommand();
        this.table.deleteRow(rng);
        this.afterCommand();
      }
    }
  }, {
    key: "deleteCol",
    value: function deleteCol() {
      var rng = this.getLastRange(this.$editable);
      if (rng.isCollapsed() && rng.isOnCell()) {
        this.beforeCommand();
        this.table.deleteCol(rng);
        this.afterCommand();
      }
    }
  }, {
    key: "deleteTable",
    value: function deleteTable() {
      var rng = this.getLastRange(this.$editable);
      if (rng.isCollapsed() && rng.isOnCell()) {
        this.beforeCommand();
        this.table.deleteTable(rng);
        this.afterCommand();
      }
    }

    /**
     * @param {Position} pos
     * @param {jQuery} $target - target element
     * @param {Boolean} [bKeepRatio] - keep ratio
     */
  }, {
    key: "resizeTo",
    value: function resizeTo(pos, $target, bKeepRatio) {
      var imageSize;
      if (bKeepRatio) {
        var newRatio = pos.y / pos.x;
        var ratio = $target.data('ratio');
        imageSize = {
          width: ratio > newRatio ? pos.x : pos.y / ratio,
          height: ratio > newRatio ? pos.x * ratio : pos.y
        };
      } else {
        imageSize = {
          width: pos.x,
          height: pos.y
        };
      }
      $target.css(imageSize);
    }

    /**
     * returns whether editable area has focus or not.
     */
  }, {
    key: "hasFocus",
    value: function hasFocus() {
      return this.$editable.is(':focus');
    }

    /**
     * set focus
     */
  }, {
    key: "focus",
    value: function focus() {
      // [workaround] Screen will move when page is scolled in IE.
      //  - do focus when not focused
      if (!this.hasFocus()) {
        this.$editable.trigger('focus');
      }
    }

    /**
     * returns whether contents is empty or not.
     * @return {Boolean}
     */
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return dom.isEmpty(this.$editable[0]) || dom.emptyPara === this.$editable.html();
    }

    /**
     * Removes all contents and restores the editable instance to an _emptyPara_.
     */
  }, {
    key: "empty",
    value: function empty() {
      this.context.invoke('code', dom.emptyPara);
    }

    /**
     * normalize content
     */
  }, {
    key: "normalizeContent",
    value: function normalizeContent() {
      this.$editable[0].normalize();
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/Clipboard.js
function Clipboard_typeof(o) { "@babel/helpers - typeof"; return Clipboard_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Clipboard_typeof(o); }
function Clipboard_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Clipboard_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Clipboard_toPropertyKey(o.key), o); } }
function Clipboard_createClass(e, r, t) { return r && Clipboard_defineProperties(e.prototype, r), t && Clipboard_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Clipboard_toPropertyKey(t) { var i = Clipboard_toPrimitive(t, "string"); return "symbol" == Clipboard_typeof(i) ? i : i + ""; }
function Clipboard_toPrimitive(t, r) { if ("object" != Clipboard_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Clipboard_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Clipboard = /*#__PURE__*/function () {
  function Clipboard(context) {
    Clipboard_classCallCheck(this, Clipboard);
    this.context = context;
    this.options = context.options;
    this.$editable = context.layoutInfo.editable;
  }
  return Clipboard_createClass(Clipboard, [{
    key: "initialize",
    value: function initialize() {
      this.$editable.on('paste', this.pasteByEvent.bind(this));
    }

    /**
     * paste by clipboard event
     *
     * @param {Event} event
     */
  }, {
    key: "pasteByEvent",
    value: function pasteByEvent(event) {
      var _this = this;
      if (this.context.isDisabled()) {
        return;
      }
      var clipboardData = event.originalEvent.clipboardData;
      if (clipboardData && clipboardData.items && clipboardData.items.length) {
        var clipboardFiles = clipboardData.files;
        var clipboardText = clipboardData.getData('Text');

        // paste img file
        if (clipboardFiles.length > 0 && this.options.allowClipboardImagePasting) {
          this.context.invoke('editor.insertImagesOrCallback', clipboardFiles);
          event.preventDefault();
        }

        // paste text with maxTextLength check
        if (clipboardText.length > 0 && this.context.invoke('editor.isLimited', clipboardText.length)) {
          event.preventDefault();
        }
      } else if (window.clipboardData) {
        // for IE
        var text = window.clipboardData.getData('text');
        if (this.context.invoke('editor.isLimited', text.length)) {
          event.preventDefault();
        }
      }

      // Call editor.afterCommand after proceeding default event handler
      setTimeout(function () {
        _this.context.invoke('editor.afterCommand');
      }, 10);
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/Dropzone.js
function Dropzone_typeof(o) { "@babel/helpers - typeof"; return Dropzone_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Dropzone_typeof(o); }
function Dropzone_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Dropzone_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Dropzone_toPropertyKey(o.key), o); } }
function Dropzone_createClass(e, r, t) { return r && Dropzone_defineProperties(e.prototype, r), t && Dropzone_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Dropzone_toPropertyKey(t) { var i = Dropzone_toPrimitive(t, "string"); return "symbol" == Dropzone_typeof(i) ? i : i + ""; }
function Dropzone_toPrimitive(t, r) { if ("object" != Dropzone_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Dropzone_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var Dropzone = /*#__PURE__*/function () {
  function Dropzone(context) {
    Dropzone_classCallCheck(this, Dropzone);
    this.context = context;
    this.$eventListener = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(document);
    this.$editor = context.layoutInfo.editor;
    this.$editable = context.layoutInfo.editable;
    this.options = context.options;
    this.lang = this.options.langInfo;
    this.documentEventHandlers = {};
    this.$dropzone = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(['<div class="note-dropzone">', '<div class="note-dropzone-message"></div>', '</div>'].join('')).prependTo(this.$editor);
  }

  /**
   * attach Drag and Drop Events
   */
  return Dropzone_createClass(Dropzone, [{
    key: "initialize",
    value: function initialize() {
      if (this.options.disableDragAndDrop) {
        // prevent default drop event
        this.documentEventHandlers.onDrop = function (e) {
          e.preventDefault();
        };
        // do not consider outside of dropzone
        this.$eventListener = this.$dropzone;
        this.$eventListener.on('drop', this.documentEventHandlers.onDrop);
      } else {
        this.attachDragAndDropEvent();
      }
    }

    /**
     * attach Drag and Drop Events
     */
  }, {
    key: "attachDragAndDropEvent",
    value: function attachDragAndDropEvent() {
      var _this = this;
      var collection = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()();
      var $dropzoneMessage = this.$dropzone.find('.note-dropzone-message');
      this.documentEventHandlers.onDragenter = function (e) {
        var isCodeview = _this.context.invoke('codeview.isActivated');
        var hasEditorSize = _this.$editor.width() > 0 && _this.$editor.height() > 0;
        if (!isCodeview && !collection.length && hasEditorSize) {
          _this.$editor.addClass('dragover');
          _this.$dropzone.width(_this.$editor.width());
          _this.$dropzone.height(_this.$editor.height());
          $dropzoneMessage.text(_this.lang.image.dragImageHere);
        }
        collection = collection.add(e.target);
      };
      this.documentEventHandlers.onDragleave = function (e) {
        collection = collection.not(e.target);

        // If nodeName is BODY, then just make it over (fix for IE)
        if (!collection.length || e.target.nodeName === 'BODY') {
          collection = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()();
          _this.$editor.removeClass('dragover');
        }
      };
      this.documentEventHandlers.onDrop = function () {
        collection = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()();
        _this.$editor.removeClass('dragover');
      };

      // show dropzone on dragenter when dragging a object to document
      // -but only if the editor is visible, i.e. has a positive width and height
      this.$eventListener.on('dragenter', this.documentEventHandlers.onDragenter).on('dragleave', this.documentEventHandlers.onDragleave).on('drop', this.documentEventHandlers.onDrop);

      // change dropzone's message on hover.
      this.$dropzone.on('dragenter', function () {
        _this.$dropzone.addClass('hover');
        $dropzoneMessage.text(_this.lang.image.dropImage);
      }).on('dragleave', function () {
        _this.$dropzone.removeClass('hover');
        $dropzoneMessage.text(_this.lang.image.dragImageHere);
      });

      // attach dropImage
      this.$dropzone.on('drop', function (event) {
        var dataTransfer = event.originalEvent.dataTransfer;

        // stop the browser from opening the dropped content
        event.preventDefault();
        if (dataTransfer && dataTransfer.files && dataTransfer.files.length) {
          _this.$editable.trigger('focus');
          _this.context.invoke('editor.insertImagesOrCallback', dataTransfer.files);
        } else {
          external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(dataTransfer.types, function (idx, type) {
            // skip moz-specific types
            if (type.toLowerCase().indexOf('_moz_') > -1) {
              return;
            }
            var content = dataTransfer.getData(type);
            if (type.toLowerCase().indexOf('text') > -1) {
              _this.context.invoke('editor.pasteHTML', content);
            } else {
              external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(content).each(function (idx, item) {
                _this.context.invoke('editor.insertNode', item);
              });
            }
          });
        }
      }).on('dragover', false); // prevent default dragover event
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this2 = this;
      Object.keys(this.documentEventHandlers).forEach(function (key) {
        _this2.$eventListener.off(key.slice(2).toLowerCase(), _this2.documentEventHandlers[key]);
      });
      this.documentEventHandlers = {};
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/Codeview.js
function Codeview_typeof(o) { "@babel/helpers - typeof"; return Codeview_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Codeview_typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function Codeview_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Codeview_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Codeview_toPropertyKey(o.key), o); } }
function Codeview_createClass(e, r, t) { return r && Codeview_defineProperties(e.prototype, r), t && Codeview_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Codeview_toPropertyKey(t) { var i = Codeview_toPrimitive(t, "string"); return "symbol" == Codeview_typeof(i) ? i : i + ""; }
function Codeview_toPrimitive(t, r) { if ("object" != Codeview_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Codeview_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



/**
 * @class Codeview
 */
var CodeView = /*#__PURE__*/function () {
  function CodeView(context) {
    Codeview_classCallCheck(this, CodeView);
    this.context = context;
    this.$editor = context.layoutInfo.editor;
    this.$editable = context.layoutInfo.editable;
    this.$codable = context.layoutInfo.codable;
    this.options = context.options;
    this.CodeMirrorConstructor = window.CodeMirror;
    if (this.options.codemirror.CodeMirrorConstructor) {
      this.CodeMirrorConstructor = this.options.codemirror.CodeMirrorConstructor;
    }
  }
  return Codeview_createClass(CodeView, [{
    key: "sync",
    value: function sync(html) {
      var isCodeview = this.isActivated();
      var CodeMirror = this.CodeMirrorConstructor;
      if (isCodeview) {
        if (html) {
          if (CodeMirror) {
            this.$codable.data('cmEditor').getDoc().setValue(html);
          } else {
            this.$codable.val(html);
          }
        } else {
          if (CodeMirror) {
            this.$codable.data('cmEditor').save();
          }
        }
      }
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this = this;
      this.$codable.on('keyup', function (event) {
        if (event.keyCode === key.code.ESCAPE) {
          _this.deactivate();
        }
      });
    }

    /**
     * @return {Boolean}
     */
  }, {
    key: "isActivated",
    value: function isActivated() {
      return this.$editor.hasClass('codeview');
    }

    /**
     * toggle codeview
     */
  }, {
    key: "toggle",
    value: function toggle() {
      if (this.isActivated()) {
        this.deactivate();
      } else {
        this.activate();
      }
      this.context.triggerEvent('codeview.toggled');
    }

    /**
     * purify input value
     * @param value
     * @returns {*}
     */
  }, {
    key: "purify",
    value: function purify(value) {
      if (this.options.codeviewFilter) {
        // filter code view regex
        value = value.replace(this.options.codeviewFilterRegex, '');
        // allow specific iframe tag
        if (this.options.codeviewIframeFilter) {
          var whitelist = this.options.codeviewIframeWhitelistSrc.concat(this.options.codeviewIframeWhitelistSrcBase);
          value = value.replace(/(<iframe.*?>.*?(?:<\/iframe>)?)/gi, function (tag) {
            // remove if src attribute is duplicated
            if (/<.+src(?==?('|"|\s)?)[\s\S]+src(?=('|"|\s)?)[^>]*?>/i.test(tag)) {
              return '';
            }
            var _iterator = _createForOfIteratorHelper(whitelist),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var src = _step.value;
                // pass if src is trusted
                if (new RegExp('src="(https?:)?\/\/' + src.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + '\/(.+)"').test(tag)) {
                  return tag;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            return '';
          });
        }
      }
      return value;
    }

    /**
     * activate code view
     */
  }, {
    key: "activate",
    value: function activate() {
      var _this2 = this;
      var CodeMirror = this.CodeMirrorConstructor;
      this.$codable.val(dom.html(this.$editable, this.options.prettifyHtml));
      this.$codable.height(this.$editable.height());
      this.context.invoke('toolbar.updateCodeview', true);
      this.context.invoke('airPopover.updateCodeview', true);
      this.$editor.addClass('codeview');
      this.$codable.trigger('focus');

      // activate CodeMirror as codable
      if (CodeMirror) {
        var cmEditor = CodeMirror.fromTextArea(this.$codable[0], this.options.codemirror);

        // CodeMirror TernServer
        if (this.options.codemirror.tern) {
          var server = new CodeMirror.TernServer(this.options.codemirror.tern);
          cmEditor.ternServer = server;
          cmEditor.on('cursorActivity', function (cm) {
            server.updateArgHints(cm);
          });
        }
        cmEditor.on('blur', function (event) {
          _this2.context.triggerEvent('blur.codeview', cmEditor.getValue(), event);
        });
        cmEditor.on('change', function () {
          _this2.context.triggerEvent('change.codeview', cmEditor.getValue(), cmEditor);
        });

        // CodeMirror hasn't Padding.
        cmEditor.setSize(null, this.$editable.outerHeight());
        this.$codable.data('cmEditor', cmEditor);
      } else {
        this.$codable.on('blur', function (event) {
          _this2.context.triggerEvent('blur.codeview', _this2.$codable.val(), event);
        });
        this.$codable.on('input', function () {
          _this2.context.triggerEvent('change.codeview', _this2.$codable.val(), _this2.$codable);
        });
      }
    }

    /**
     * deactivate code view
     */
  }, {
    key: "deactivate",
    value: function deactivate() {
      var CodeMirror = this.CodeMirrorConstructor;
      // deactivate CodeMirror as codable
      if (CodeMirror) {
        var cmEditor = this.$codable.data('cmEditor');
        this.$codable.val(cmEditor.getValue());
        cmEditor.toTextArea();
      }
      var value = this.purify(dom.value(this.$codable, this.options.prettifyHtml) || dom.emptyPara);
      var isChange = this.$editable.html() !== value;
      this.$editable.html(value);
      this.$editable.height(this.options.height ? this.$codable.height() : 'auto');
      this.$editor.removeClass('codeview');
      if (isChange) {
        this.context.triggerEvent('change', this.$editable.html(), this.$editable);
      }
      this.$editable.trigger('focus');
      this.context.invoke('toolbar.updateCodeview', false);
      this.context.invoke('airPopover.updateCodeview', false);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.isActivated()) {
        this.deactivate();
      }
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/Statusbar.js
function Statusbar_typeof(o) { "@babel/helpers - typeof"; return Statusbar_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Statusbar_typeof(o); }
function Statusbar_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Statusbar_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Statusbar_toPropertyKey(o.key), o); } }
function Statusbar_createClass(e, r, t) { return r && Statusbar_defineProperties(e.prototype, r), t && Statusbar_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Statusbar_toPropertyKey(t) { var i = Statusbar_toPrimitive(t, "string"); return "symbol" == Statusbar_typeof(i) ? i : i + ""; }
function Statusbar_toPrimitive(t, r) { if ("object" != Statusbar_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Statusbar_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var EDITABLE_PADDING = 24;
var Statusbar = /*#__PURE__*/function () {
  function Statusbar(context) {
    Statusbar_classCallCheck(this, Statusbar);
    this.$document = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(document);
    this.$statusbar = context.layoutInfo.statusbar;
    this.$editable = context.layoutInfo.editable;
    this.$codable = context.layoutInfo.codable;
    this.options = context.options;
  }
  return Statusbar_createClass(Statusbar, [{
    key: "initialize",
    value: function initialize() {
      var _this = this;
      if (this.options.airMode || this.options.disableResizeEditor) {
        this.destroy();
        return;
      }
      this.$statusbar.on('mousedown touchstart', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var editableTop = _this.$editable.offset().top - _this.$document.scrollTop();
        var editableCodeTop = _this.$codable.offset().top - _this.$document.scrollTop();
        var onStatusbarMove = function onStatusbarMove(event) {
          var originalEvent = event.type == 'mousemove' ? event : event.originalEvent.touches[0];
          var height = originalEvent.clientY - (editableTop + EDITABLE_PADDING);
          var heightCode = originalEvent.clientY - (editableCodeTop + EDITABLE_PADDING);
          height = _this.options.minheight > 0 ? Math.max(height, _this.options.minheight) : height;
          height = _this.options.maxHeight > 0 ? Math.min(height, _this.options.maxHeight) : height;
          heightCode = _this.options.minheight > 0 ? Math.max(heightCode, _this.options.minheight) : heightCode;
          heightCode = _this.options.maxHeight > 0 ? Math.min(heightCode, _this.options.maxHeight) : heightCode;
          _this.$editable.height(height);
          _this.$codable.height(heightCode);
        };
        _this.$document.on('mousemove touchmove', onStatusbarMove).one('mouseup touchend', function () {
          _this.$document.off('mousemove touchmove', onStatusbarMove);
        });
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.$statusbar.off();
      this.$statusbar.addClass('locked');
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/Fullscreen.js
function Fullscreen_typeof(o) { "@babel/helpers - typeof"; return Fullscreen_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Fullscreen_typeof(o); }
function Fullscreen_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Fullscreen_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Fullscreen_toPropertyKey(o.key), o); } }
function Fullscreen_createClass(e, r, t) { return r && Fullscreen_defineProperties(e.prototype, r), t && Fullscreen_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Fullscreen_toPropertyKey(t) { var i = Fullscreen_toPrimitive(t, "string"); return "symbol" == Fullscreen_typeof(i) ? i : i + ""; }
function Fullscreen_toPrimitive(t, r) { if ("object" != Fullscreen_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Fullscreen_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var Fullscreen = /*#__PURE__*/function () {
  function Fullscreen(context) {
    var _this = this;
    Fullscreen_classCallCheck(this, Fullscreen);
    this.context = context;
    this.$editor = context.layoutInfo.editor;
    this.$toolbar = context.layoutInfo.toolbar;
    this.$editable = context.layoutInfo.editable;
    this.$codable = context.layoutInfo.codable;
    this.$window = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(window);
    this.$scrollbar = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('html, body');
    this.scrollbarClassName = 'note-fullscreen-body';
    this.onResize = function () {
      _this.resizeTo({
        h: _this.$window.height() - _this.$toolbar.outerHeight()
      });
    };
  }
  return Fullscreen_createClass(Fullscreen, [{
    key: "resizeTo",
    value: function resizeTo(size) {
      this.$editable.css('height', size.h);
      this.$codable.css('height', size.h);
      if (this.$codable.data('cmeditor')) {
        this.$codable.data('cmeditor').setsize(null, size.h);
      }
    }

    /**
     * toggle fullscreen
     */
  }, {
    key: "toggle",
    value: function toggle() {
      this.$editor.toggleClass('fullscreen');
      var isFullscreen = this.isFullscreen();
      this.$scrollbar.toggleClass(this.scrollbarClassName, isFullscreen);
      if (isFullscreen) {
        this.$editable.data('orgHeight', this.$editable.css('height'));
        this.$editable.data('orgMaxHeight', this.$editable.css('maxHeight'));
        this.$editable.css('maxHeight', '');
        this.$window.on('resize', this.onResize).trigger('resize');
      } else {
        this.$window.off('resize', this.onResize);
        this.resizeTo({
          h: this.$editable.data('orgHeight')
        });
        this.$editable.css('maxHeight', this.$editable.css('orgMaxHeight'));
      }
      this.context.invoke('toolbar.updateFullscreen', isFullscreen);
    }
  }, {
    key: "isFullscreen",
    value: function isFullscreen() {
      return this.$editor.hasClass('fullscreen');
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.$scrollbar.removeClass(this.scrollbarClassName);
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/Handle.js
function Handle_typeof(o) { "@babel/helpers - typeof"; return Handle_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Handle_typeof(o); }
function Handle_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Handle_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Handle_toPropertyKey(o.key), o); } }
function Handle_createClass(e, r, t) { return r && Handle_defineProperties(e.prototype, r), t && Handle_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Handle_toPropertyKey(t) { var i = Handle_toPrimitive(t, "string"); return "symbol" == Handle_typeof(i) ? i : i + ""; }
function Handle_toPrimitive(t, r) { if ("object" != Handle_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Handle_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var Handle = /*#__PURE__*/function () {
  function Handle(context) {
    var _this = this;
    Handle_classCallCheck(this, Handle);
    this.context = context;
    this.$document = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(document);
    this.$editingArea = context.layoutInfo.editingArea;
    this.options = context.options;
    this.lang = this.options.langInfo;
    this.events = {
      'summernote.mousedown': function summernoteMousedown(we, e) {
        if (_this.update(e.target, e)) {
          e.preventDefault();
        }
      },
      'summernote.keyup summernote.scroll summernote.change summernote.dialog.shown': function summernoteKeyupSummernoteScrollSummernoteChangeSummernoteDialogShown() {
        _this.update();
      },
      'summernote.disable summernote.blur': function summernoteDisableSummernoteBlur() {
        _this.hide();
      },
      'summernote.codeview.toggled': function summernoteCodeviewToggled() {
        _this.update();
      }
    };
  }
  return Handle_createClass(Handle, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;
      this.$handle = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(['<div class="note-handle">', '<div class="note-control-selection">', '<div class="note-control-selection-bg"></div>', '<div class="note-control-holder note-control-nw"></div>', '<div class="note-control-holder note-control-ne"></div>', '<div class="note-control-holder note-control-sw"></div>', '<div class="', this.options.disableResizeImage ? 'note-control-holder' : 'note-control-sizing', ' note-control-se"></div>', this.options.disableResizeImage ? '' : '<div class="note-control-selection-info"></div>', '</div>', '</div>'].join('')).prependTo(this.$editingArea);
      this.$handle.on('mousedown', function (event) {
        if (dom.isControlSizing(event.target)) {
          event.preventDefault();
          event.stopPropagation();
          var $target = _this2.$handle.find('.note-control-selection').data('target');
          var posStart = $target.offset();
          var scrollTop = _this2.$document.scrollTop();
          var onMouseMove = function onMouseMove(event) {
            _this2.context.invoke('editor.resizeTo', {
              x: event.clientX - posStart.left,
              y: event.clientY - (posStart.top - scrollTop)
            }, $target, !event.shiftKey);
            _this2.update($target[0], event);
          };
          _this2.$document.on('mousemove', onMouseMove).one('mouseup', function (e) {
            e.preventDefault();
            _this2.$document.off('mousemove', onMouseMove);
            _this2.context.invoke('editor.afterCommand');
          });
          if (!$target.data('ratio')) {
            // original ratio.
            $target.data('ratio', $target.height() / $target.width());
          }
        }
      });

      // Listen for scrolling on the handle overlay.
      this.$handle.on('wheel', function (event) {
        event.preventDefault();
        _this2.update();
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.$handle.remove();
    }
  }, {
    key: "update",
    value: function update(target, event) {
      if (this.context.isDisabled()) {
        return false;
      }
      var isImage = dom.isImg(target);
      var $selection = this.$handle.find('.note-control-selection');
      this.context.invoke('imagePopover.update', target, event);
      if (isImage) {
        var $image = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(target);
        var areaRect = this.$editingArea[0].getBoundingClientRect();
        var imageRect = target.getBoundingClientRect();
        $selection.css({
          display: 'block',
          left: imageRect.left - areaRect.left,
          top: imageRect.top - areaRect.top,
          width: imageRect.width,
          height: imageRect.height
        }).data('target', $image); // save current image element.

        var origImageObj = new Image();
        origImageObj.src = $image.attr('src');
        var sizingText = imageRect.width + 'x' + imageRect.height + ' (' + this.lang.image.original + ': ' + origImageObj.width + 'x' + origImageObj.height + ')';
        $selection.find('.note-control-selection-info').text(sizingText);
        this.context.invoke('editor.saveTarget', target);
      } else {
        this.hide();
      }
      return isImage;
    }

    /**
     * hide
     *
     * @param {jQuery} $handle
     */
  }, {
    key: "hide",
    value: function hide() {
      this.context.invoke('editor.clearTarget');
      this.$handle.children().hide();
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/AutoLink.js
function AutoLink_typeof(o) { "@babel/helpers - typeof"; return AutoLink_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, AutoLink_typeof(o); }
function AutoLink_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function AutoLink_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, AutoLink_toPropertyKey(o.key), o); } }
function AutoLink_createClass(e, r, t) { return r && AutoLink_defineProperties(e.prototype, r), t && AutoLink_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function AutoLink_toPropertyKey(t) { var i = AutoLink_toPrimitive(t, "string"); return "symbol" == AutoLink_typeof(i) ? i : i + ""; }
function AutoLink_toPrimitive(t, r) { if ("object" != AutoLink_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != AutoLink_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var defaultScheme = 'http://';
var linkPattern = /^([A-Za-z][A-Za-z0-9+-.]*\:[\/]{2}|tel:|mailto:[A-Z0-9._%+-]+@|xmpp:[A-Z0-9._%+-]+@)?(www\.)?(.+)$/i;
var AutoLink = /*#__PURE__*/function () {
  function AutoLink(context) {
    var _this = this;
    AutoLink_classCallCheck(this, AutoLink);
    this.context = context;
    this.options = context.options;
    this.$editable = context.layoutInfo.editable;
    this.events = {
      'summernote.keyup': function summernoteKeyup(we, event) {
        if (!event.isDefaultPrevented()) {
          _this.handleKeyup(event);
        }
      },
      'summernote.keydown': function summernoteKeydown(we, event) {
        _this.handleKeydown(event);
      }
    };
  }
  return AutoLink_createClass(AutoLink, [{
    key: "initialize",
    value: function initialize() {
      this.lastWordRange = null;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.lastWordRange = null;
    }
  }, {
    key: "replace",
    value: function replace() {
      if (!this.lastWordRange) {
        return;
      }
      var keyword = this.lastWordRange.toString();
      var match = keyword.match(linkPattern);
      if (match && (match[1] || match[2])) {
        var link = match[1] ? keyword : defaultScheme + keyword;
        var urlText = this.options.showDomainOnlyForAutolink ? keyword.replace(/^(?:https?:\/\/)?(?:tel?:?)?(?:mailto?:?)?(?:xmpp?:?)?(?:www\.)?/i, '').split('/')[0] : keyword;
        var node = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<a></a>').html(urlText).attr('href', link)[0];
        if (this.context.options.linkTargetBlank) {
          external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(node).attr('target', '_blank');
        }
        this.lastWordRange.insertNode(node);
        this.lastWordRange = null;
        this.context.invoke('editor.focus');
        this.context.triggerEvent('change', this.$editable.html(), this.$editable);
      }
    }
  }, {
    key: "handleKeydown",
    value: function handleKeydown(event) {
      if (lists.contains([key.code.ENTER, key.code.SPACE], event.keyCode)) {
        var wordRange = this.context.invoke('editor.createRange').getWordRange();
        this.lastWordRange = wordRange;
      }
    }
  }, {
    key: "handleKeyup",
    value: function handleKeyup(event) {
      if (key.code.SPACE === event.keyCode || key.code.ENTER === event.keyCode && !event.shiftKey) {
        this.replace();
      }
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/AutoSync.js
function AutoSync_typeof(o) { "@babel/helpers - typeof"; return AutoSync_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, AutoSync_typeof(o); }
function AutoSync_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function AutoSync_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, AutoSync_toPropertyKey(o.key), o); } }
function AutoSync_createClass(e, r, t) { return r && AutoSync_defineProperties(e.prototype, r), t && AutoSync_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function AutoSync_toPropertyKey(t) { var i = AutoSync_toPrimitive(t, "string"); return "symbol" == AutoSync_typeof(i) ? i : i + ""; }
function AutoSync_toPrimitive(t, r) { if ("object" != AutoSync_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != AutoSync_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


/**
 * textarea auto sync.
 */
var AutoSync = /*#__PURE__*/function () {
  function AutoSync(context) {
    var _this = this;
    AutoSync_classCallCheck(this, AutoSync);
    this.$note = context.layoutInfo.note;
    this.events = {
      'summernote.change': function summernoteChange() {
        _this.$note.val(context.invoke('code'));
      }
    };
  }
  return AutoSync_createClass(AutoSync, [{
    key: "shouldInitialize",
    value: function shouldInitialize() {
      return dom.isTextarea(this.$note[0]);
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/AutoReplace.js
function AutoReplace_typeof(o) { "@babel/helpers - typeof"; return AutoReplace_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, AutoReplace_typeof(o); }
function AutoReplace_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function AutoReplace_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, AutoReplace_toPropertyKey(o.key), o); } }
function AutoReplace_createClass(e, r, t) { return r && AutoReplace_defineProperties(e.prototype, r), t && AutoReplace_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function AutoReplace_toPropertyKey(t) { var i = AutoReplace_toPrimitive(t, "string"); return "symbol" == AutoReplace_typeof(i) ? i : i + ""; }
function AutoReplace_toPrimitive(t, r) { if ("object" != AutoReplace_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != AutoReplace_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var AutoReplace = /*#__PURE__*/function () {
  function AutoReplace(context) {
    var _this = this;
    AutoReplace_classCallCheck(this, AutoReplace);
    this.context = context;
    this.options = context.options.replace || {};
    this.keys = [key.code.ENTER, key.code.SPACE, key.code.PERIOD, key.code.COMMA, key.code.SEMICOLON, key.code.SLASH];
    this.previousKeydownCode = null;
    this.events = {
      'summernote.keyup': function summernoteKeyup(we, event) {
        if (!event.isDefaultPrevented()) {
          _this.handleKeyup(event);
        }
      },
      'summernote.keydown': function summernoteKeydown(we, event) {
        _this.handleKeydown(event);
      }
    };
  }
  return AutoReplace_createClass(AutoReplace, [{
    key: "shouldInitialize",
    value: function shouldInitialize() {
      return !!this.options.match;
    }
  }, {
    key: "initialize",
    value: function initialize() {
      this.lastWord = null;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.lastWord = null;
    }
  }, {
    key: "replace",
    value: function replace() {
      if (!this.lastWord) {
        return;
      }
      var self = this;
      var keyword = this.lastWord.toString();
      this.options.match(keyword, function (match) {
        if (match) {
          var node = '';
          if (typeof match === 'string') {
            node = dom.createText(match);
          } else if (match instanceof jQuery) {
            node = match[0];
          } else if (match instanceof Node) {
            node = match;
          }
          if (!node) return;
          self.lastWord.insertNode(node);
          self.lastWord = null;
          self.context.invoke('editor.focus');
        }
      });
    }
  }, {
    key: "handleKeydown",
    value: function handleKeydown(event) {
      // this forces it to remember the last whole word, even if multiple termination keys are pressed
      // before the previous key is let go.
      if (this.previousKeydownCode && lists.contains(this.keys, this.previousKeydownCode)) {
        this.previousKeydownCode = event.keyCode;
        return;
      }
      if (lists.contains(this.keys, event.keyCode)) {
        var wordRange = this.context.invoke('editor.createRange').getWordRange();
        this.lastWord = wordRange;
      }
      this.previousKeydownCode = event.keyCode;
    }
  }, {
    key: "handleKeyup",
    value: function handleKeyup(event) {
      if (lists.contains(this.keys, event.keyCode)) {
        this.replace();
      }
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/Placeholder.js
function Placeholder_typeof(o) { "@babel/helpers - typeof"; return Placeholder_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Placeholder_typeof(o); }
function Placeholder_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Placeholder_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Placeholder_toPropertyKey(o.key), o); } }
function Placeholder_createClass(e, r, t) { return r && Placeholder_defineProperties(e.prototype, r), t && Placeholder_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Placeholder_toPropertyKey(t) { var i = Placeholder_toPrimitive(t, "string"); return "symbol" == Placeholder_typeof(i) ? i : i + ""; }
function Placeholder_toPrimitive(t, r) { if ("object" != Placeholder_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Placeholder_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var Placeholder = /*#__PURE__*/function () {
  function Placeholder(context) {
    var _this = this;
    Placeholder_classCallCheck(this, Placeholder);
    this.context = context;
    this.$editingArea = context.layoutInfo.editingArea;
    this.options = context.options;
    if (this.options.inheritPlaceholder === true) {
      // get placeholder value from the original element
      this.options.placeholder = this.context.$note.attr('placeholder') || this.options.placeholder;
    }
    this.events = {
      'summernote.init summernote.change': function summernoteInitSummernoteChange() {
        _this.update();
      },
      'summernote.codeview.toggled': function summernoteCodeviewToggled() {
        _this.update();
      }
    };
  }
  return Placeholder_createClass(Placeholder, [{
    key: "shouldInitialize",
    value: function shouldInitialize() {
      return !!this.options.placeholder;
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this2 = this;
      this.$placeholder = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<div class="note-placeholder"></div>');
      this.$placeholder.on('click', function () {
        _this2.context.invoke('focus');
      }).html(this.options.placeholder).prependTo(this.$editingArea);
      this.update();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.$placeholder.remove();
    }
  }, {
    key: "update",
    value: function update() {
      var isShow = !this.context.invoke('codeview.isActivated') && this.context.invoke('editor.isEmpty');
      this.$placeholder.toggle(isShow);
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/Buttons.js
function Buttons_typeof(o) { "@babel/helpers - typeof"; return Buttons_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Buttons_typeof(o); }
function Buttons_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Buttons_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Buttons_toPropertyKey(o.key), o); } }
function Buttons_createClass(e, r, t) { return r && Buttons_defineProperties(e.prototype, r), t && Buttons_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Buttons_toPropertyKey(t) { var i = Buttons_toPrimitive(t, "string"); return "symbol" == Buttons_typeof(i) ? i : i + ""; }
function Buttons_toPrimitive(t, r) { if ("object" != Buttons_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Buttons_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




var Buttons = /*#__PURE__*/function () {
  function Buttons(context) {
    Buttons_classCallCheck(this, Buttons);
    this.ui = (external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote.ui;
    this.context = context;
    this.$toolbar = context.layoutInfo.toolbar;
    this.options = context.options;
    this.lang = this.options.langInfo;
    this.invertedKeyMap = func.invertObject(this.options.keyMap[env.isMac ? 'mac' : 'pc']);
  }
  return Buttons_createClass(Buttons, [{
    key: "representShortcut",
    value: function representShortcut(editorMethod) {
      var shortcut = this.invertedKeyMap[editorMethod];
      if (!this.options.shortcuts || !shortcut) {
        return '';
      }
      if (env.isMac) {
        shortcut = shortcut.replace('CMD', '⌘').replace('SHIFT', '⇧');
      }
      shortcut = shortcut.replace('BACKSLASH', '\\').replace('SLASH', '/').replace('LEFTBRACKET', '[').replace('RIGHTBRACKET', ']');
      return ' (' + shortcut + ')';
    }
  }, {
    key: "button",
    value: function button(o) {
      if (!this.options.tooltip && o.tooltip) {
        delete o.tooltip;
      }
      o.container = this.options.container;
      return this.ui.button(o);
    }
  }, {
    key: "initialize",
    value: function initialize() {
      this.addToolbarButtons();
      this.addImagePopoverButtons();
      this.addLinkPopoverButtons();
      this.addTablePopoverButtons();
      this.fontInstalledMap = {};
    }
  }, {
    key: "destroy",
    value: function destroy() {
      delete this.fontInstalledMap;
    }
  }, {
    key: "isFontInstalled",
    value: function isFontInstalled(name) {
      if (!Object.prototype.hasOwnProperty.call(this.fontInstalledMap, name)) {
        this.fontInstalledMap[name] = env.isFontInstalled(name) || lists.contains(this.options.fontNamesIgnoreCheck, name);
      }
      return this.fontInstalledMap[name];
    }
  }, {
    key: "isFontDeservedToAdd",
    value: function isFontDeservedToAdd(name) {
      name = name.toLowerCase();
      return name !== '' && this.isFontInstalled(name) && env.genericFontFamilies.indexOf(name) === -1;
    }
  }, {
    key: "colorPalette",
    value: function colorPalette(className, tooltip, backColor, foreColor) {
      var _this = this;
      return this.ui.buttonGroup({
        className: 'note-color ' + className,
        children: [this.button({
          className: 'note-current-color-button',
          contents: this.ui.icon(this.options.icons.font + ' note-recent-color'),
          tooltip: tooltip,
          click: function click(event) {
            var $button = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(event.currentTarget);
            if (backColor && foreColor) {
              _this.context.invoke('editor.color', {
                backColor: $button.attr('data-backColor'),
                foreColor: $button.attr('data-foreColor')
              });
            } else if (backColor) {
              _this.context.invoke('editor.color', {
                backColor: $button.attr('data-backColor')
              });
            } else if (foreColor) {
              _this.context.invoke('editor.color', {
                foreColor: $button.attr('data-foreColor')
              });
            }
          },
          callback: function callback($button) {
            var $recentColor = $button.find('.note-recent-color');
            if (backColor) {
              $recentColor.css('background-color', _this.options.colorButton.backColor);
              $button.attr('data-backColor', _this.options.colorButton.backColor);
            }
            if (foreColor) {
              $recentColor.css('color', _this.options.colorButton.foreColor);
              $button.attr('data-foreColor', _this.options.colorButton.foreColor);
            } else {
              $recentColor.css('color', 'transparent');
            }
          }
        }), this.button({
          className: 'dropdown-toggle',
          contents: this.ui.dropdownButtonContents('', this.options),
          tooltip: this.lang.color.more,
          data: {
            toggle: 'dropdown'
          }
        }), this.ui.dropdown({
          items: (backColor ? ['<div class="note-palette">', '<div class="note-palette-title">' + this.lang.color.background + '</div>', '<div>', '<button type="button" class="note-color-reset btn btn-light btn-default" data-event="backColor" data-value="transparent">', this.lang.color.transparent, '</button>', '</div>', '<div class="note-holder" data-event="backColor"><!-- back colors --></div>', '<div>', '<button type="button" class="note-color-select btn btn-light btn-default" data-event="openPalette" data-value="backColorPicker-' + this.options.id + '">', this.lang.color.cpSelect, '</button>', '<input type="color" id="backColorPicker-' + this.options.id + '" class="note-btn note-color-select-btn" value="' + this.options.colorButton.backColor + '" data-event="backColorPalette-' + this.options.id + '">', '</div>', '<div class="note-holder-custom" id="backColorPalette-' + this.options.id + '" data-event="backColor"></div>', '</div>'].join('') : '') + (foreColor ? ['<div class="note-palette">', '<div class="note-palette-title">' + this.lang.color.foreground + '</div>', '<div>', '<button type="button" class="note-color-reset btn btn-light btn-default" data-event="removeFormat" data-value="foreColor">', this.lang.color.resetToDefault, '</button>', '</div>', '<div class="note-holder" data-event="foreColor"><!-- fore colors --></div>', '<div>', '<button type="button" class="note-color-select btn btn-light btn-default" data-event="openPalette" data-value="foreColorPicker-' + this.options.id + '">', this.lang.color.cpSelect, '</button>', '<input type="color" id="foreColorPicker-' + this.options.id + '" class="note-btn note-color-select-btn" value="' + this.options.colorButton.foreColor + '" data-event="foreColorPalette-' + this.options.id + '">', '</div>',
          // Fix missing Div, Commented to find easily if it's wrong
          '<div class="note-holder-custom" id="foreColorPalette-' + this.options.id + '" data-event="foreColor"></div>', '</div>'].join('') : ''),
          callback: function callback($dropdown) {
            $dropdown.find('.note-holder').each(function (idx, item) {
              var $holder = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(item);
              $holder.append(_this.ui.palette({
                colors: _this.options.colors,
                colorsName: _this.options.colorsName,
                eventName: $holder.data('event'),
                container: _this.options.container,
                tooltip: _this.options.tooltip
              }).render());
            });
            /* TODO: do we have to record recent custom colors within cookies? */
            var customColors = [['#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF']];
            $dropdown.find('.note-holder-custom').each(function (idx, item) {
              var $holder = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(item);
              $holder.append(_this.ui.palette({
                colors: customColors,
                colorsName: customColors,
                eventName: $holder.data('event'),
                container: _this.options.container,
                tooltip: _this.options.tooltip
              }).render());
            });
            $dropdown.find('input[type=color]').each(function (idx, item) {
              external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(item).on("change", function () {
                var $chip = $dropdown.find('#' + external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(this).data('event')).find('.note-color-btn').first();
                var color = this.value.toUpperCase();
                $chip.css('background-color', color).attr('aria-label', color).attr('data-value', color).attr('data-original-title', color);
                $chip.trigger('click');
              });
            });
          },
          click: function click(event) {
            event.stopPropagation();
            var $parent = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('.' + className).find('.note-dropdown-menu');
            var $button = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(event.target);
            var eventName = $button.data('event');
            var value = $button.attr('data-value');
            if (eventName === 'openPalette') {
              var $picker = $parent.find('#' + value);
              var $palette = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()($parent.find('#' + $picker.data('event')).find('.note-color-row')[0]);

              // Shift palette chips
              var $chip = $palette.find('.note-color-btn').last().detach();

              // Set chip attributes
              var color = $picker.val();
              $chip.css('background-color', color).attr('aria-label', color).attr('data-value', color).attr('data-original-title', color);
              $palette.prepend($chip);
              $picker.trigger('click');
            } else {
              if (lists.contains(['backColor', 'foreColor'], eventName)) {
                var key = eventName === 'backColor' ? 'background-color' : 'color';
                var $color = $button.closest('.note-color').find('.note-recent-color');
                var $currentButton = $button.closest('.note-color').find('.note-current-color-button');
                $color.css(key, value);
                $currentButton.attr('data-' + eventName, value);
              }
              _this.context.invoke('editor.' + eventName, value);
            }
          }
        })]
      }).render();
    }
  }, {
    key: "addToolbarButtons",
    value: function addToolbarButtons() {
      var _this2 = this;
      this.context.memo('button.style', function () {
        return _this2.ui.buttonGroup([_this2.button({
          className: 'dropdown-toggle',
          contents: _this2.ui.dropdownButtonContents(_this2.ui.icon(_this2.options.icons.magic), _this2.options),
          tooltip: _this2.lang.style.style,
          data: {
            toggle: 'dropdown'
          }
        }), _this2.ui.dropdown({
          className: 'dropdown-style',
          items: _this2.options.styleTags,
          title: _this2.lang.style.style,
          template: function template(item) {
            // TBD: need to be simplified
            if (typeof item === 'string') {
              item = {
                tag: item,
                title: Object.prototype.hasOwnProperty.call(_this2.lang.style, item) ? _this2.lang.style[item] : item
              };
            }
            var tag = item.tag;
            var title = item.title;
            var style = item.style ? ' style="' + item.style + '" ' : '';
            var className = item.className ? ' class="' + item.className + '"' : '';
            return '<' + tag + style + className + '>' + title + '</' + tag + '>';
          },
          click: _this2.context.createInvokeHandler('editor.formatBlock')
        })]).render();
      });
      var _loop = function _loop() {
        var item = _this2.options.styleTags[styleIdx];
        _this2.context.memo('button.style.' + item, function () {
          return _this2.button({
            className: 'note-btn-style-' + item,
            contents: '<div data-value="' + item + '">' + item.toUpperCase() + '</div>',
            tooltip: _this2.lang.style[item],
            click: _this2.context.createInvokeHandler('editor.formatBlock')
          }).render();
        });
      };
      for (var styleIdx = 0, styleLen = this.options.styleTags.length; styleIdx < styleLen; styleIdx++) {
        _loop();
      }
      this.context.memo('button.bold', function () {
        return _this2.button({
          className: 'note-btn-bold',
          contents: _this2.ui.icon(_this2.options.icons.bold),
          tooltip: _this2.lang.font.bold + _this2.representShortcut('bold'),
          click: _this2.context.createInvokeHandlerAndUpdateState('editor.bold')
        }).render();
      });
      this.context.memo('button.italic', function () {
        return _this2.button({
          className: 'note-btn-italic',
          contents: _this2.ui.icon(_this2.options.icons.italic),
          tooltip: _this2.lang.font.italic + _this2.representShortcut('italic'),
          click: _this2.context.createInvokeHandlerAndUpdateState('editor.italic')
        }).render();
      });
      this.context.memo('button.underline', function () {
        return _this2.button({
          className: 'note-btn-underline',
          contents: _this2.ui.icon(_this2.options.icons.underline),
          tooltip: _this2.lang.font.underline + _this2.representShortcut('underline'),
          click: _this2.context.createInvokeHandlerAndUpdateState('editor.underline')
        }).render();
      });
      this.context.memo('button.clear', function () {
        return _this2.button({
          contents: _this2.ui.icon(_this2.options.icons.eraser),
          tooltip: _this2.lang.font.clear + _this2.representShortcut('removeFormat'),
          click: _this2.context.createInvokeHandler('editor.removeFormat')
        }).render();
      });
      this.context.memo('button.strikethrough', function () {
        return _this2.button({
          className: 'note-btn-strikethrough',
          contents: _this2.ui.icon(_this2.options.icons.strikethrough),
          tooltip: _this2.lang.font.strikethrough + _this2.representShortcut('strikethrough'),
          click: _this2.context.createInvokeHandlerAndUpdateState('editor.strikethrough')
        }).render();
      });
      this.context.memo('button.superscript', function () {
        return _this2.button({
          className: 'note-btn-superscript',
          contents: _this2.ui.icon(_this2.options.icons.superscript),
          tooltip: _this2.lang.font.superscript,
          click: _this2.context.createInvokeHandlerAndUpdateState('editor.superscript')
        }).render();
      });
      this.context.memo('button.subscript', function () {
        return _this2.button({
          className: 'note-btn-subscript',
          contents: _this2.ui.icon(_this2.options.icons.subscript),
          tooltip: _this2.lang.font.subscript,
          click: _this2.context.createInvokeHandlerAndUpdateState('editor.subscript')
        }).render();
      });
      this.context.memo('button.fontname', function () {
        var styleInfo = _this2.context.invoke('editor.currentStyle');
        if (_this2.options.addDefaultFonts) {
          // Add 'default' fonts into the fontnames array if not exist
          external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(styleInfo['font-family'].split(','), function (idx, fontname) {
            fontname = fontname.trim().replace(/['"]+/g, '');
            if (_this2.isFontDeservedToAdd(fontname)) {
              if (_this2.options.fontNames.indexOf(fontname) === -1) {
                _this2.options.fontNames.push(fontname);
              }
            }
          });
        }
        return _this2.ui.buttonGroup([_this2.button({
          className: 'dropdown-toggle',
          contents: _this2.ui.dropdownButtonContents('<span class="note-current-fontname"></span>', _this2.options),
          tooltip: _this2.lang.font.name,
          data: {
            toggle: 'dropdown'
          }
        }), _this2.ui.dropdownCheck({
          className: 'dropdown-fontname',
          checkClassName: _this2.options.icons.menuCheck,
          items: _this2.options.fontNames.filter(_this2.isFontInstalled.bind(_this2)),
          title: _this2.lang.font.name,
          template: function template(item) {
            return '<span style="font-family: ' + env.validFontName(item) + '">' + item + '</span>';
          },
          click: _this2.context.createInvokeHandlerAndUpdateState('editor.fontName')
        })]).render();
      });
      this.context.memo('button.fontsize', function () {
        return _this2.ui.buttonGroup([_this2.button({
          className: 'dropdown-toggle',
          contents: _this2.ui.dropdownButtonContents('<span class="note-current-fontsize"></span>', _this2.options),
          tooltip: _this2.lang.font.size,
          data: {
            toggle: 'dropdown'
          }
        }), _this2.ui.dropdownCheck({
          className: 'dropdown-fontsize',
          checkClassName: _this2.options.icons.menuCheck,
          items: _this2.options.fontSizes,
          title: _this2.lang.font.size,
          click: _this2.context.createInvokeHandlerAndUpdateState('editor.fontSize')
        })]).render();
      });
      this.context.memo('button.fontsizeunit', function () {
        return _this2.ui.buttonGroup([_this2.button({
          className: 'dropdown-toggle',
          contents: _this2.ui.dropdownButtonContents('<span class="note-current-fontsizeunit"></span>', _this2.options),
          tooltip: _this2.lang.font.sizeunit,
          data: {
            toggle: 'dropdown'
          }
        }), _this2.ui.dropdownCheck({
          className: 'dropdown-fontsizeunit',
          checkClassName: _this2.options.icons.menuCheck,
          items: _this2.options.fontSizeUnits,
          title: _this2.lang.font.sizeunit,
          click: _this2.context.createInvokeHandlerAndUpdateState('editor.fontSizeUnit')
        })]).render();
      });
      this.context.memo('button.color', function () {
        return _this2.colorPalette('note-color-all', _this2.lang.color.recent, true, true);
      });
      this.context.memo('button.forecolor', function () {
        return _this2.colorPalette('note-color-fore', _this2.lang.color.foreground, false, true);
      });
      this.context.memo('button.backcolor', function () {
        return _this2.colorPalette('note-color-back', _this2.lang.color.background, true, false);
      });
      this.context.memo('button.ul', function () {
        return _this2.button({
          contents: _this2.ui.icon(_this2.options.icons.unorderedlist),
          tooltip: _this2.lang.lists.unordered + _this2.representShortcut('insertUnorderedList'),
          click: _this2.context.createInvokeHandler('editor.insertUnorderedList')
        }).render();
      });
      this.context.memo('button.ol', function () {
        return _this2.button({
          contents: _this2.ui.icon(_this2.options.icons.orderedlist),
          tooltip: _this2.lang.lists.ordered + _this2.representShortcut('insertOrderedList'),
          click: _this2.context.createInvokeHandler('editor.insertOrderedList')
        }).render();
      });
      var justifyLeft = this.button({
        contents: this.ui.icon(this.options.icons.alignLeft),
        tooltip: this.lang.paragraph.left + this.representShortcut('justifyLeft'),
        click: this.context.createInvokeHandler('editor.justifyLeft')
      });
      var justifyCenter = this.button({
        contents: this.ui.icon(this.options.icons.alignCenter),
        tooltip: this.lang.paragraph.center + this.representShortcut('justifyCenter'),
        click: this.context.createInvokeHandler('editor.justifyCenter')
      });
      var justifyRight = this.button({
        contents: this.ui.icon(this.options.icons.alignRight),
        tooltip: this.lang.paragraph.right + this.representShortcut('justifyRight'),
        click: this.context.createInvokeHandler('editor.justifyRight')
      });
      var justifyFull = this.button({
        contents: this.ui.icon(this.options.icons.alignJustify),
        tooltip: this.lang.paragraph.justify + this.representShortcut('justifyFull'),
        click: this.context.createInvokeHandler('editor.justifyFull')
      });
      var outdent = this.button({
        contents: this.ui.icon(this.options.icons.outdent),
        tooltip: this.lang.paragraph.outdent + this.representShortcut('outdent'),
        click: this.context.createInvokeHandler('editor.outdent')
      });
      var indent = this.button({
        contents: this.ui.icon(this.options.icons.indent),
        tooltip: this.lang.paragraph.indent + this.representShortcut('indent'),
        click: this.context.createInvokeHandler('editor.indent')
      });
      this.context.memo('button.justifyLeft', func.invoke(justifyLeft, 'render'));
      this.context.memo('button.justifyCenter', func.invoke(justifyCenter, 'render'));
      this.context.memo('button.justifyRight', func.invoke(justifyRight, 'render'));
      this.context.memo('button.justifyFull', func.invoke(justifyFull, 'render'));
      this.context.memo('button.outdent', func.invoke(outdent, 'render'));
      this.context.memo('button.indent', func.invoke(indent, 'render'));
      this.context.memo('button.paragraph', function () {
        return _this2.ui.buttonGroup([_this2.button({
          className: 'dropdown-toggle',
          contents: _this2.ui.dropdownButtonContents(_this2.ui.icon(_this2.options.icons.alignLeft), _this2.options),
          tooltip: _this2.lang.paragraph.paragraph,
          data: {
            toggle: 'dropdown'
          }
        }), _this2.ui.dropdown([_this2.ui.buttonGroup({
          className: 'note-align',
          children: [justifyLeft, justifyCenter, justifyRight, justifyFull]
        }), _this2.ui.buttonGroup({
          className: 'note-list',
          children: [outdent, indent]
        })])]).render();
      });
      this.context.memo('button.height', function () {
        return _this2.ui.buttonGroup([_this2.button({
          className: 'dropdown-toggle',
          contents: _this2.ui.dropdownButtonContents(_this2.ui.icon(_this2.options.icons.textHeight), _this2.options),
          tooltip: _this2.lang.font.height,
          data: {
            toggle: 'dropdown'
          }
        }), _this2.ui.dropdownCheck({
          items: _this2.options.lineHeights,
          checkClassName: _this2.options.icons.menuCheck,
          className: 'dropdown-line-height',
          title: _this2.lang.font.height,
          click: _this2.context.createInvokeHandler('editor.lineHeight')
        })]).render();
      });
      this.context.memo('button.table', function () {
        return _this2.ui.buttonGroup([_this2.button({
          className: 'dropdown-toggle',
          contents: _this2.ui.dropdownButtonContents(_this2.ui.icon(_this2.options.icons.table), _this2.options),
          tooltip: _this2.lang.table.table,
          data: {
            toggle: 'dropdown'
          }
        }), _this2.ui.dropdown({
          title: _this2.lang.table.table,
          className: 'note-table',
          items: ['<div class="note-dimension-picker">', '<div class="note-dimension-picker-mousecatcher" data-event="insertTable" data-value="1x1"></div>', '<div class="note-dimension-picker-highlighted"></div>', '<div class="note-dimension-picker-unhighlighted"></div>', '</div>', '<div class="note-dimension-display">1 x 1</div>'].join('')
        })], {
          callback: function callback($node) {
            var $catcher = $node.find('.note-dimension-picker-mousecatcher');
            $catcher.css({
              width: _this2.options.insertTableMaxSize.col + 'em',
              height: _this2.options.insertTableMaxSize.row + 'em'
            }).on('mousedown', _this2.context.createInvokeHandler('editor.insertTable')).on('mousemove', _this2.tableMoveHandler.bind(_this2));
          }
        }).render();
      });
      this.context.memo('button.link', function () {
        return _this2.button({
          contents: _this2.ui.icon(_this2.options.icons.link),
          tooltip: _this2.lang.link.link + _this2.representShortcut('linkDialog.show'),
          click: _this2.context.createInvokeHandler('linkDialog.show')
        }).render();
      });
      this.context.memo('button.picture', function () {
        return _this2.button({
          contents: _this2.ui.icon(_this2.options.icons.picture),
          tooltip: _this2.lang.image.image,
          click: _this2.context.createInvokeHandler('imageDialog.show')
        }).render();
      });
      this.context.memo('button.video', function () {
        return _this2.button({
          contents: _this2.ui.icon(_this2.options.icons.video),
          tooltip: _this2.lang.video.video,
          click: _this2.context.createInvokeHandler('videoDialog.show')
        }).render();
      });
      this.context.memo('button.hr', function () {
        return _this2.button({
          contents: _this2.ui.icon(_this2.options.icons.minus),
          tooltip: _this2.lang.hr.insert + _this2.representShortcut('insertHorizontalRule'),
          click: _this2.context.createInvokeHandler('editor.insertHorizontalRule')
        }).render();
      });
      this.context.memo('button.fullscreen', function () {
        return _this2.button({
          className: 'btn-fullscreen note-codeview-keep',
          contents: _this2.ui.icon(_this2.options.icons.arrowsAlt),
          tooltip: _this2.lang.options.fullscreen,
          click: _this2.context.createInvokeHandler('fullscreen.toggle')
        }).render();
      });
      this.context.memo('button.codeview', function () {
        return _this2.button({
          className: 'btn-codeview note-codeview-keep',
          contents: _this2.ui.icon(_this2.options.icons.code),
          tooltip: _this2.lang.options.codeview,
          click: _this2.context.createInvokeHandler('codeview.toggle')
        }).render();
      });
      this.context.memo('button.redo', function () {
        return _this2.button({
          contents: _this2.ui.icon(_this2.options.icons.redo),
          tooltip: _this2.lang.history.redo + _this2.representShortcut('redo'),
          click: _this2.context.createInvokeHandler('editor.redo')
        }).render();
      });
      this.context.memo('button.undo', function () {
        return _this2.button({
          contents: _this2.ui.icon(_this2.options.icons.undo),
          tooltip: _this2.lang.history.undo + _this2.representShortcut('undo'),
          click: _this2.context.createInvokeHandler('editor.undo')
        }).render();
      });
      this.context.memo('button.help', function () {
        return _this2.button({
          contents: _this2.ui.icon(_this2.options.icons.question),
          tooltip: _this2.lang.options.help,
          click: _this2.context.createInvokeHandler('helpDialog.show')
        }).render();
      });
    }

    /**
     * image: [
     *   ['imageResize', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']],
     *   ['float', ['floatLeft', 'floatRight', 'floatNone']],
     *   ['remove', ['removeMedia']],
     * ],
     */
  }, {
    key: "addImagePopoverButtons",
    value: function addImagePopoverButtons() {
      var _this3 = this;
      // Image Size Buttons
      this.context.memo('button.resizeFull', function () {
        return _this3.button({
          contents: '<span class="note-fontsize-10">100%</span>',
          tooltip: _this3.lang.image.resizeFull,
          click: _this3.context.createInvokeHandler('editor.resize', '1')
        }).render();
      });
      this.context.memo('button.resizeHalf', function () {
        return _this3.button({
          contents: '<span class="note-fontsize-10">50%</span>',
          tooltip: _this3.lang.image.resizeHalf,
          click: _this3.context.createInvokeHandler('editor.resize', '0.5')
        }).render();
      });
      this.context.memo('button.resizeQuarter', function () {
        return _this3.button({
          contents: '<span class="note-fontsize-10">25%</span>',
          tooltip: _this3.lang.image.resizeQuarter,
          click: _this3.context.createInvokeHandler('editor.resize', '0.25')
        }).render();
      });
      this.context.memo('button.resizeNone', function () {
        return _this3.button({
          contents: _this3.ui.icon(_this3.options.icons.rollback),
          tooltip: _this3.lang.image.resizeNone,
          click: _this3.context.createInvokeHandler('editor.resize', '0')
        }).render();
      });

      // Float Buttons
      this.context.memo('button.floatLeft', function () {
        return _this3.button({
          contents: _this3.ui.icon(_this3.options.icons.floatLeft),
          tooltip: _this3.lang.image.floatLeft,
          click: _this3.context.createInvokeHandler('editor.floatMe', 'left')
        }).render();
      });
      this.context.memo('button.floatRight', function () {
        return _this3.button({
          contents: _this3.ui.icon(_this3.options.icons.floatRight),
          tooltip: _this3.lang.image.floatRight,
          click: _this3.context.createInvokeHandler('editor.floatMe', 'right')
        }).render();
      });
      this.context.memo('button.floatNone', function () {
        return _this3.button({
          contents: _this3.ui.icon(_this3.options.icons.rollback),
          tooltip: _this3.lang.image.floatNone,
          click: _this3.context.createInvokeHandler('editor.floatMe', 'none')
        }).render();
      });

      // Remove Buttons
      this.context.memo('button.removeMedia', function () {
        return _this3.button({
          contents: _this3.ui.icon(_this3.options.icons.trash),
          tooltip: _this3.lang.image.remove,
          click: _this3.context.createInvokeHandler('editor.removeMedia')
        }).render();
      });
    }
  }, {
    key: "addLinkPopoverButtons",
    value: function addLinkPopoverButtons() {
      var _this4 = this;
      this.context.memo('button.linkDialogShow', function () {
        return _this4.button({
          contents: _this4.ui.icon(_this4.options.icons.link),
          tooltip: _this4.lang.link.edit,
          click: _this4.context.createInvokeHandler('linkDialog.show')
        }).render();
      });
      this.context.memo('button.unlink', function () {
        return _this4.button({
          contents: _this4.ui.icon(_this4.options.icons.unlink),
          tooltip: _this4.lang.link.unlink,
          click: _this4.context.createInvokeHandler('editor.unlink')
        }).render();
      });
    }

    /**
     * table : [
     *  ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
     *  ['delete', ['deleteRow', 'deleteCol', 'deleteTable']]
     * ],
     */
  }, {
    key: "addTablePopoverButtons",
    value: function addTablePopoverButtons() {
      var _this5 = this;
      this.context.memo('button.addRowUp', function () {
        return _this5.button({
          className: 'btn-md',
          contents: _this5.ui.icon(_this5.options.icons.rowAbove),
          tooltip: _this5.lang.table.addRowAbove,
          click: _this5.context.createInvokeHandler('editor.addRow', 'top')
        }).render();
      });
      this.context.memo('button.addRowDown', function () {
        return _this5.button({
          className: 'btn-md',
          contents: _this5.ui.icon(_this5.options.icons.rowBelow),
          tooltip: _this5.lang.table.addRowBelow,
          click: _this5.context.createInvokeHandler('editor.addRow', 'bottom')
        }).render();
      });
      this.context.memo('button.addColLeft', function () {
        return _this5.button({
          className: 'btn-md',
          contents: _this5.ui.icon(_this5.options.icons.colBefore),
          tooltip: _this5.lang.table.addColLeft,
          click: _this5.context.createInvokeHandler('editor.addCol', 'left')
        }).render();
      });
      this.context.memo('button.addColRight', function () {
        return _this5.button({
          className: 'btn-md',
          contents: _this5.ui.icon(_this5.options.icons.colAfter),
          tooltip: _this5.lang.table.addColRight,
          click: _this5.context.createInvokeHandler('editor.addCol', 'right')
        }).render();
      });
      this.context.memo('button.deleteRow', function () {
        return _this5.button({
          className: 'btn-md',
          contents: _this5.ui.icon(_this5.options.icons.rowRemove),
          tooltip: _this5.lang.table.delRow,
          click: _this5.context.createInvokeHandler('editor.deleteRow')
        }).render();
      });
      this.context.memo('button.deleteCol', function () {
        return _this5.button({
          className: 'btn-md',
          contents: _this5.ui.icon(_this5.options.icons.colRemove),
          tooltip: _this5.lang.table.delCol,
          click: _this5.context.createInvokeHandler('editor.deleteCol')
        }).render();
      });
      this.context.memo('button.deleteTable', function () {
        return _this5.button({
          className: 'btn-md',
          contents: _this5.ui.icon(_this5.options.icons.trash),
          tooltip: _this5.lang.table.delTable,
          click: _this5.context.createInvokeHandler('editor.deleteTable')
        }).render();
      });
    }
  }, {
    key: "build",
    value: function build($container, groups) {
      for (var groupIdx = 0, groupLen = groups.length; groupIdx < groupLen; groupIdx++) {
        var group = groups[groupIdx];
        var groupName = Array.isArray(group) ? group[0] : group;
        var buttons = Array.isArray(group) ? group.length === 1 ? [group[0]] : group[1] : [group];
        var $group = this.ui.buttonGroup({
          className: 'note-' + groupName
        }).render();
        for (var idx = 0, len = buttons.length; idx < len; idx++) {
          var btn = this.context.memo('button.' + buttons[idx]);
          if (btn) {
            $group.append(typeof btn === 'function' ? btn(this.context) : btn);
          }
        }
        $group.appendTo($container);
      }
    }

    /**
     * @param {jQuery} [$container]
     */
  }, {
    key: "updateCurrentStyle",
    value: function updateCurrentStyle($container) {
      var $cont = $container || this.$toolbar;
      var styleInfo = this.context.invoke('editor.currentStyle');
      this.updateBtnStates($cont, {
        '.note-btn-bold': function noteBtnBold() {
          return styleInfo['font-bold'] === 'bold';
        },
        '.note-btn-italic': function noteBtnItalic() {
          return styleInfo['font-italic'] === 'italic';
        },
        '.note-btn-underline': function noteBtnUnderline() {
          return styleInfo['font-underline'] === 'underline';
        },
        '.note-btn-subscript': function noteBtnSubscript() {
          return styleInfo['font-subscript'] === 'subscript';
        },
        '.note-btn-superscript': function noteBtnSuperscript() {
          return styleInfo['font-superscript'] === 'superscript';
        },
        '.note-btn-strikethrough': function noteBtnStrikethrough() {
          return styleInfo['font-strikethrough'] === 'strikethrough';
        }
      });
      if (styleInfo['font-family']) {
        var fontNames = styleInfo['font-family'].split(',').map(function (name) {
          return name.replace(/[\'\"]/g, '').replace(/\s+$/, '').replace(/^\s+/, '');
        });
        var fontName = lists.find(fontNames, this.isFontInstalled.bind(this));
        $cont.find('.dropdown-fontname a').each(function (idx, item) {
          var $item = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(item);
          // always compare string to avoid creating another func.
          var isChecked = $item.data('value') + '' === fontName + '';
          $item.toggleClass('checked', isChecked);
        });
        $cont.find('.note-current-fontname').text(fontName).css('font-family', fontName);
      }
      if (styleInfo['font-size']) {
        var fontSize = styleInfo['font-size'];
        $cont.find('.dropdown-fontsize a').each(function (idx, item) {
          var $item = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(item);
          // always compare with string to avoid creating another func.
          var isChecked = $item.data('value') + '' === fontSize + '';
          $item.toggleClass('checked', isChecked);
        });
        $cont.find('.note-current-fontsize').text(fontSize);
        var fontSizeUnit = styleInfo['font-size-unit'];
        $cont.find('.dropdown-fontsizeunit a').each(function (idx, item) {
          var $item = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(item);
          var isChecked = $item.data('value') + '' === fontSizeUnit + '';
          $item.toggleClass('checked', isChecked);
        });
        $cont.find('.note-current-fontsizeunit').text(fontSizeUnit);
      }
      if (styleInfo['line-height']) {
        var lineHeight = styleInfo['line-height'];
        $cont.find('.dropdown-line-height a').each(function (idx, item) {
          var $item = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(item);
          // always compare with string to avoid creating another func.
          var isChecked = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(item).data('value') + '' === lineHeight + '';
          $item.toggleClass('checked', isChecked);
        });
        $cont.find('.note-current-line-height').text(lineHeight);
      }
    }
  }, {
    key: "updateBtnStates",
    value: function updateBtnStates($container, infos) {
      var _this6 = this;
      external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(infos, function (selector, pred) {
        _this6.ui.toggleBtnActive($container.find(selector), pred());
      });
    }
  }, {
    key: "tableMoveHandler",
    value: function tableMoveHandler(event) {
      var PX_PER_EM = 18;
      var $picker = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(event.target.parentNode); // target is mousecatcher
      var $dimensionDisplay = $picker.next();
      var $catcher = $picker.find('.note-dimension-picker-mousecatcher');
      var $highlighted = $picker.find('.note-dimension-picker-highlighted');
      var $unhighlighted = $picker.find('.note-dimension-picker-unhighlighted');
      var posOffset;
      // HTML5 with jQuery - e.offsetX is undefined in Firefox
      if (event.offsetX === undefined) {
        var posCatcher = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(event.target).offset();
        posOffset = {
          x: event.pageX - posCatcher.left,
          y: event.pageY - posCatcher.top
        };
      } else {
        posOffset = {
          x: event.offsetX,
          y: event.offsetY
        };
      }
      var dim = {
        c: Math.ceil(posOffset.x / PX_PER_EM) || 1,
        r: Math.ceil(posOffset.y / PX_PER_EM) || 1
      };
      $highlighted.css({
        width: dim.c + 'em',
        height: dim.r + 'em'
      });
      $catcher.data('value', dim.c + 'x' + dim.r);
      if (dim.c > 3 && dim.c < this.options.insertTableMaxSize.col) {
        $unhighlighted.css({
          width: dim.c + 1 + 'em'
        });
      }
      if (dim.r > 3 && dim.r < this.options.insertTableMaxSize.row) {
        $unhighlighted.css({
          height: dim.r + 1 + 'em'
        });
      }
      $dimensionDisplay.html(dim.c + ' x ' + dim.r);
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/Toolbar.js
function Toolbar_typeof(o) { "@babel/helpers - typeof"; return Toolbar_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Toolbar_typeof(o); }
function Toolbar_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function Toolbar_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, Toolbar_toPropertyKey(o.key), o); } }
function Toolbar_createClass(e, r, t) { return r && Toolbar_defineProperties(e.prototype, r), t && Toolbar_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function Toolbar_toPropertyKey(t) { var i = Toolbar_toPrimitive(t, "string"); return "symbol" == Toolbar_typeof(i) ? i : i + ""; }
function Toolbar_toPrimitive(t, r) { if ("object" != Toolbar_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Toolbar_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var Toolbar = /*#__PURE__*/function () {
  function Toolbar(context) {
    Toolbar_classCallCheck(this, Toolbar);
    this.context = context;
    this.$window = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(window);
    this.$document = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(document);
    this.ui = (external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote.ui;
    this.$note = context.layoutInfo.note;
    this.$editor = context.layoutInfo.editor;
    this.$toolbar = context.layoutInfo.toolbar;
    this.$editable = context.layoutInfo.editable;
    this.$statusbar = context.layoutInfo.statusbar;
    this.options = context.options;
    this.isFollowing = false;
    this.followScroll = this.followScroll.bind(this);
  }
  return Toolbar_createClass(Toolbar, [{
    key: "shouldInitialize",
    value: function shouldInitialize() {
      return !this.options.airMode;
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this = this;
      this.options.toolbar = this.options.toolbar || [];
      if (!this.options.toolbar.length) {
        this.$toolbar.hide();
      } else {
        this.context.invoke('buttons.build', this.$toolbar, this.options.toolbar);
      }
      if (this.options.toolbarContainer) {
        this.$toolbar.appendTo(this.options.toolbarContainer);
      }
      this.changeContainer(false);
      this.$note.on('summernote.keyup summernote.mouseup summernote.change', function () {
        _this.context.invoke('buttons.updateCurrentStyle');
      });
      this.context.invoke('buttons.updateCurrentStyle');
      if (this.options.followingToolbar) {
        this.$window.on('scroll resize', this.followScroll);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.$toolbar.children().remove();
      if (this.options.followingToolbar) {
        this.$window.off('scroll resize', this.followScroll);
      }
    }
  }, {
    key: "followScroll",
    value: function followScroll() {
      if (this.$editor.hasClass('fullscreen')) {
        return false;
      }
      var editorHeight = this.$editor.outerHeight();
      var editorWidth = this.$editor.width();
      var toolbarHeight = this.$toolbar.height();
      var statusbarHeight = this.$statusbar.height();

      // check if the web app is currently using another static bar
      var otherBarHeight = 0;
      if (this.options.otherStaticBar) {
        otherBarHeight = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(this.options.otherStaticBar).outerHeight();
      }
      var currentOffset = this.$document.scrollTop();
      var editorOffsetTop = this.$editor.offset().top;
      var editorOffsetBottom = editorOffsetTop + editorHeight;
      var activateOffset = editorOffsetTop - otherBarHeight;
      var deactivateOffsetBottom = editorOffsetBottom - otherBarHeight - toolbarHeight - statusbarHeight;
      if (!this.isFollowing && currentOffset > activateOffset && currentOffset < deactivateOffsetBottom - toolbarHeight) {
        this.isFollowing = true;
        this.$editable.css({
          marginTop: this.$toolbar.outerHeight()
        });
        this.$toolbar.css({
          position: 'fixed',
          top: otherBarHeight,
          width: editorWidth,
          zIndex: 1000
        });
      } else if (this.isFollowing && (currentOffset < activateOffset || currentOffset > deactivateOffsetBottom)) {
        this.isFollowing = false;
        this.$toolbar.css({
          position: 'relative',
          top: 0,
          width: '100%',
          zIndex: 'auto'
        });
        this.$editable.css({
          marginTop: ''
        });
      }
    }
  }, {
    key: "changeContainer",
    value: function changeContainer(isFullscreen) {
      if (isFullscreen) {
        this.$toolbar.prependTo(this.$editor);
      } else {
        if (this.options.toolbarContainer) {
          this.$toolbar.appendTo(this.options.toolbarContainer);
        }
      }
      if (this.options.followingToolbar) {
        this.followScroll();
      }
    }
  }, {
    key: "updateFullscreen",
    value: function updateFullscreen(isFullscreen) {
      this.ui.toggleBtnActive(this.$toolbar.find('.btn-fullscreen'), isFullscreen);
      this.changeContainer(isFullscreen);
    }
  }, {
    key: "updateCodeview",
    value: function updateCodeview(isCodeview) {
      this.ui.toggleBtnActive(this.$toolbar.find('.btn-codeview'), isCodeview);
      if (isCodeview) {
        this.deactivate();
      } else {
        this.activate();
      }
    }
  }, {
    key: "activate",
    value: function activate(isIncludeCodeview) {
      var $btn = this.$toolbar.find('button');
      if (!isIncludeCodeview) {
        $btn = $btn.not('.note-codeview-keep');
      }
      this.ui.toggleBtn($btn, true);
    }
  }, {
    key: "deactivate",
    value: function deactivate(isIncludeCodeview) {
      var $btn = this.$toolbar.find('button');
      if (!isIncludeCodeview) {
        $btn = $btn.not('.note-codeview-keep');
      }
      this.ui.toggleBtn($btn, false);
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/LinkDialog.js
function LinkDialog_typeof(o) { "@babel/helpers - typeof"; return LinkDialog_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, LinkDialog_typeof(o); }
function LinkDialog_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function LinkDialog_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, LinkDialog_toPropertyKey(o.key), o); } }
function LinkDialog_createClass(e, r, t) { return r && LinkDialog_defineProperties(e.prototype, r), t && LinkDialog_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function LinkDialog_toPropertyKey(t) { var i = LinkDialog_toPrimitive(t, "string"); return "symbol" == LinkDialog_typeof(i) ? i : i + ""; }
function LinkDialog_toPrimitive(t, r) { if ("object" != LinkDialog_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != LinkDialog_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




var LinkDialog_MAILTO_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
var LinkDialog_TEL_PATTERN = /^(\+?\d{1,3}[\s-]?)?(\d{1,4})[\s-]?(\d{1,4})[\s-]?(\d{1,4})$/;
var LinkDialog_URL_SCHEME_PATTERN = /^([A-Za-z][A-Za-z0-9+-.]*\:|#|\/)/;
var LinkDialog = /*#__PURE__*/function () {
  function LinkDialog(context) {
    LinkDialog_classCallCheck(this, LinkDialog);
    this.context = context;
    this.ui = (external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote.ui;
    this.$body = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(document.body);
    this.$editor = context.layoutInfo.editor;
    this.options = context.options;
    this.lang = this.options.langInfo;
    context.memo('help.linkDialog.show', this.options.langInfo.help['linkDialog.show']);
  }
  return LinkDialog_createClass(LinkDialog, [{
    key: "initialize",
    value: function initialize() {
      var $container = this.options.dialogsInBody ? this.$body : this.options.container;
      var body = ['<div class="form-group note-form-group">', "<label for=\"note-dialog-link-txt-".concat(this.options.id, "\" class=\"note-form-label\">").concat(this.lang.link.textToDisplay, "</label>"), "<input id=\"note-dialog-link-txt-".concat(this.options.id, "\" class=\"note-link-text form-control note-form-control note-input\" type=\"text\"/>"), '</div>', '<div class="form-group note-form-group">', "<label for=\"note-dialog-link-url-".concat(this.options.id, "\" class=\"note-form-label\">").concat(this.lang.link.url, "</label>"), "<input id=\"note-dialog-link-url-".concat(this.options.id, "\" class=\"note-link-url form-control note-form-control note-input\" type=\"text\" value=\"http://\"/>"), '</div>', !this.options.disableLinkTarget ? external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<div></div>').append(this.ui.checkbox({
        className: 'sn-checkbox-open-in-new-window',
        text: this.lang.link.openInNewWindow,
        checked: true
      }).render()).html() : ''].join('');
      var buttonClass = 'btn btn-primary note-btn note-btn-primary note-link-btn';
      var footer = "<input type=\"button\" href=\"#\" class=\"".concat(buttonClass, "\" value=\"").concat(this.lang.link.insert, "\" disabled>");
      this.$dialog = this.ui.dialog({
        className: 'link-dialog',
        title: this.lang.link.insert,
        fade: this.options.dialogsFade,
        body: body,
        footer: footer
      }).render().appendTo($container);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.ui.hideDialog(this.$dialog);
      this.$dialog.remove();
    }
  }, {
    key: "bindEnterKey",
    value: function bindEnterKey($input, $btn) {
      $input.on('keypress', function (event) {
        if (event.keyCode === key.code.ENTER) {
          event.preventDefault();
          $btn.trigger('click');
        }
      });
    }
  }, {
    key: "checkLinkUrl",
    value: function checkLinkUrl(linkUrl) {
      if (LinkDialog_MAILTO_PATTERN.test(linkUrl)) {
        return 'mailto://' + linkUrl;
      } else if (LinkDialog_TEL_PATTERN.test(linkUrl)) {
        return 'tel://' + linkUrl;
      } else if (!LinkDialog_URL_SCHEME_PATTERN.test(linkUrl)) {
        return 'http://' + linkUrl;
      }
      return linkUrl;
    }
  }, {
    key: "onCheckLinkUrl",
    value: function onCheckLinkUrl($input) {
      var _this = this;
      $input.on('blur', function (event) {
        event.target.value = event.target.value == '' ? '' : _this.checkLinkUrl(event.target.value);
      });
    }

    /**
     * toggle update button
     */
  }, {
    key: "toggleLinkBtn",
    value: function toggleLinkBtn($linkBtn, $linkText, $linkUrl) {
      this.ui.toggleBtn($linkBtn, $linkText.val() && $linkUrl.val());
    }

    /**
     * Show link dialog and set event handlers on dialog controls.
     *
     * @param {Object} linkInfo
     * @return {Promise}
     */
  }, {
    key: "showLinkDialog",
    value: function showLinkDialog(linkInfo) {
      var _this2 = this;
      return external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().Deferred(function (deferred) {
        var $linkText = _this2.$dialog.find('.note-link-text');
        var $linkUrl = _this2.$dialog.find('.note-link-url');
        var $linkBtn = _this2.$dialog.find('.note-link-btn');
        var $openInNewWindow = _this2.$dialog.find('.sn-checkbox-open-in-new-window input[type=checkbox]');
        _this2.ui.onDialogShown(_this2.$dialog, function () {
          _this2.context.triggerEvent('dialog.shown');

          // If no url was given and given text is valid URL then copy that into URL Field
          if (!linkInfo.url && func.isValidUrl(linkInfo.text)) {
            linkInfo.url = _this2.checkLinkUrl(linkInfo.text);
          }
          $linkText.on('input paste propertychange', function () {
            // If linktext was modified by input events,
            // cloning text from linkUrl will be stopped.
            var text = $linkText.val();
            var div = document.createElement('div');
            div.innerText = text;
            text = div.innerHTML;
            linkInfo.text = text;
            _this2.toggleLinkBtn($linkBtn, $linkText, $linkUrl);
          }).val(linkInfo.text);
          $linkUrl.on('input paste propertychange', function () {
            // Display same text on `Text to display` as default
            // when linktext has no text
            if (!linkInfo.text) {
              $linkText.val($linkUrl.val());
            }
            _this2.toggleLinkBtn($linkBtn, $linkText, $linkUrl);
          }).val(linkInfo.url);
          if (!env.isSupportTouch) {
            $linkUrl.trigger('focus');
          }
          _this2.toggleLinkBtn($linkBtn, $linkText, $linkUrl);
          _this2.bindEnterKey($linkUrl, $linkBtn);
          _this2.bindEnterKey($linkText, $linkBtn);
          _this2.onCheckLinkUrl($linkUrl);
          var isNewWindowChecked = linkInfo.isNewWindow !== undefined ? linkInfo.isNewWindow : _this2.context.options.linkTargetBlank;
          $openInNewWindow.prop('checked', isNewWindowChecked);
          $linkBtn.one('click', function (event) {
            event.preventDefault();
            deferred.resolve({
              range: linkInfo.range,
              url: $linkUrl.val(),
              text: $linkText.val(),
              isNewWindow: $openInNewWindow.is(':checked')
            });
            _this2.ui.hideDialog(_this2.$dialog);
          });
        });
        _this2.ui.onDialogHidden(_this2.$dialog, function () {
          // detach events
          $linkText.off();
          $linkUrl.off();
          $linkBtn.off();
          if (deferred.state() === 'pending') {
            deferred.reject();
          }
        });
        _this2.ui.showDialog(_this2.$dialog);
      }).promise();
    }

    /**
     * @param {Object} layoutInfo
     */
  }, {
    key: "show",
    value: function show() {
      var _this3 = this;
      var linkInfo = this.context.invoke('editor.getLinkInfo');
      this.context.invoke('editor.saveRange');
      this.showLinkDialog(linkInfo).then(function (linkInfo) {
        _this3.context.invoke('editor.restoreRange');
        _this3.context.invoke('editor.createLink', linkInfo);
      }).fail(function () {
        _this3.context.invoke('editor.restoreRange');
      });
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/LinkPopover.js
function LinkPopover_typeof(o) { "@babel/helpers - typeof"; return LinkPopover_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, LinkPopover_typeof(o); }
function LinkPopover_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function LinkPopover_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, LinkPopover_toPropertyKey(o.key), o); } }
function LinkPopover_createClass(e, r, t) { return r && LinkPopover_defineProperties(e.prototype, r), t && LinkPopover_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function LinkPopover_toPropertyKey(t) { var i = LinkPopover_toPrimitive(t, "string"); return "symbol" == LinkPopover_typeof(i) ? i : i + ""; }
function LinkPopover_toPrimitive(t, r) { if ("object" != LinkPopover_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != LinkPopover_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var LinkPopover = /*#__PURE__*/function () {
  function LinkPopover(context) {
    var _this = this;
    LinkPopover_classCallCheck(this, LinkPopover);
    this.context = context;
    this.ui = (external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote.ui;
    this.options = context.options;
    this.events = {
      'summernote.keyup summernote.mouseup summernote.change summernote.scroll': function summernoteKeyupSummernoteMouseupSummernoteChangeSummernoteScroll() {
        _this.update();
      },
      'summernote.disable summernote.dialog.shown': function summernoteDisableSummernoteDialogShown() {
        _this.hide();
      },
      'summernote.blur': function summernoteBlur(we, event) {
        if (event.originalEvent && event.originalEvent.relatedTarget) {
          if (!_this.$popover[0].contains(event.originalEvent.relatedTarget)) {
            _this.hide();
          }
        } else {
          _this.hide();
        }
      }
    };
  }
  return LinkPopover_createClass(LinkPopover, [{
    key: "shouldInitialize",
    value: function shouldInitialize() {
      return !lists.isEmpty(this.options.popover.link);
    }
  }, {
    key: "initialize",
    value: function initialize() {
      this.$popover = this.ui.popover({
        className: 'note-link-popover',
        callback: function callback($node) {
          var $content = $node.find('.popover-content,.note-popover-content');
          $content.prepend('<span><a target="_blank"></a>&nbsp;</span>');
        }
      }).render().appendTo(this.options.container);
      var $content = this.$popover.find('.popover-content,.note-popover-content');
      this.context.invoke('buttons.build', $content, this.options.popover.link);
      this.$popover.on('mousedown', function (event) {
        event.preventDefault();
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.$popover.remove();
    }
  }, {
    key: "update",
    value: function update() {
      // Prevent focusing on editable when invoke('code') is executed
      if (!this.context.invoke('editor.hasFocus')) {
        this.hide();
        return;
      }
      var rng = this.context.invoke('editor.getLastRange');
      if (rng.isCollapsed() && rng.isOnAnchor()) {
        var anchor = dom.ancestor(rng.sc, dom.isAnchor);
        var href = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(anchor).attr('href');
        this.$popover.find('a').attr('href', href).text(href);
        var pos = dom.posFromPlaceholder(anchor);
        var containerOffset = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(this.options.container).offset();
        pos.top -= containerOffset.top;
        pos.left -= containerOffset.left;
        this.$popover.css({
          display: 'block',
          left: pos.left,
          top: pos.top
        });
      } else {
        this.hide();
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      this.$popover.hide();
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/ImageDialog.js
function ImageDialog_typeof(o) { "@babel/helpers - typeof"; return ImageDialog_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, ImageDialog_typeof(o); }
function ImageDialog_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function ImageDialog_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, ImageDialog_toPropertyKey(o.key), o); } }
function ImageDialog_createClass(e, r, t) { return r && ImageDialog_defineProperties(e.prototype, r), t && ImageDialog_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function ImageDialog_toPropertyKey(t) { var i = ImageDialog_toPrimitive(t, "string"); return "symbol" == ImageDialog_typeof(i) ? i : i + ""; }
function ImageDialog_toPrimitive(t, r) { if ("object" != ImageDialog_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != ImageDialog_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var ImageDialog = /*#__PURE__*/function () {
  function ImageDialog(context) {
    ImageDialog_classCallCheck(this, ImageDialog);
    this.context = context;
    this.ui = (external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote.ui;
    this.$body = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(document.body);
    this.$editor = context.layoutInfo.editor;
    this.options = context.options;
    this.lang = this.options.langInfo;
  }
  return ImageDialog_createClass(ImageDialog, [{
    key: "initialize",
    value: function initialize() {
      var imageLimitation = '';
      if (this.options.maximumImageFileSize) {
        var unit = Math.floor(Math.log(this.options.maximumImageFileSize) / Math.log(1024));
        var readableSize = (this.options.maximumImageFileSize / Math.pow(1024, unit)).toFixed(2) * 1 + ' ' + ' KMGTP'[unit] + 'B';
        imageLimitation = "<small>".concat(this.lang.image.maximumFileSize + ' : ' + readableSize, "</small>");
      }
      var $container = this.options.dialogsInBody ? this.$body : this.options.container;
      var body = ['<div class="form-group note-form-group note-group-select-from-files">', '<label for="note-dialog-image-file-' + this.options.id + '" class="note-form-label">' + this.lang.image.selectFromFiles + '</label>', '<input id="note-dialog-image-file-' + this.options.id + '" class="note-image-input form-control-file note-form-control note-input" ', ' type="file" name="files" accept="' + this.options.acceptImageFileTypes + '" multiple="multiple"/>', imageLimitation, '</div>', '<div class="form-group note-group-image-url">', '<label for="note-dialog-image-url-' + this.options.id + '" class="note-form-label">' + this.lang.image.url + '</label>', '<input id="note-dialog-image-url-' + this.options.id + '" class="note-image-url form-control note-form-control note-input" type="text"/>', '</div>'].join('');
      var buttonClass = 'btn btn-primary note-btn note-btn-primary note-image-btn';
      var footer = "<input type=\"button\" href=\"#\" class=\"".concat(buttonClass, "\" value=\"").concat(this.lang.image.insert, "\" disabled>");
      this.$dialog = this.ui.dialog({
        title: this.lang.image.insert,
        fade: this.options.dialogsFade,
        body: body,
        footer: footer
      }).render().appendTo($container);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.ui.hideDialog(this.$dialog);
      this.$dialog.remove();
    }
  }, {
    key: "bindEnterKey",
    value: function bindEnterKey($input, $btn) {
      $input.on('keypress', function (event) {
        if (event.keyCode === key.code.ENTER) {
          event.preventDefault();
          $btn.trigger('click');
        }
      });
    }
  }, {
    key: "show",
    value: function show() {
      var _this = this;
      this.context.invoke('editor.saveRange');
      this.showImageDialog().then(function (data) {
        // [workaround] hide dialog before restore range for IE range focus
        _this.ui.hideDialog(_this.$dialog);
        _this.context.invoke('editor.restoreRange');
        if (typeof data === 'string') {
          // image url
          // If onImageLinkInsert set,
          if (_this.options.callbacks.onImageLinkInsert) {
            _this.context.triggerEvent('image.link.insert', data);
          } else {
            _this.context.invoke('editor.insertImage', data);
          }
        } else {
          // array of files
          _this.context.invoke('editor.insertImagesOrCallback', data);
        }
      }).fail(function () {
        _this.context.invoke('editor.restoreRange');
      });
    }

    /**
     * show image dialog
     *
     * @param {jQuery} $dialog
     * @return {Promise}
     */
  }, {
    key: "showImageDialog",
    value: function showImageDialog() {
      var _this2 = this;
      return external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().Deferred(function (deferred) {
        var $imageInput = _this2.$dialog.find('.note-image-input');
        var $imageUrl = _this2.$dialog.find('.note-image-url');
        var $imageBtn = _this2.$dialog.find('.note-image-btn');
        _this2.ui.onDialogShown(_this2.$dialog, function () {
          _this2.context.triggerEvent('dialog.shown');

          // Cloning imageInput to clear element.
          $imageInput.replaceWith($imageInput.clone().on('change', function (event) {
            deferred.resolve(event.target.files || event.target.value);
          }).val(''));
          $imageUrl.on('input paste propertychange', function () {
            _this2.ui.toggleBtn($imageBtn, $imageUrl.val());
          }).val('');
          if (!env.isSupportTouch) {
            $imageUrl.trigger('focus');
          }
          $imageBtn.on('click', function (event) {
            event.preventDefault();
            deferred.resolve($imageUrl.val());
          });
          _this2.bindEnterKey($imageUrl, $imageBtn);
        });
        _this2.ui.onDialogHidden(_this2.$dialog, function () {
          $imageInput.off();
          $imageUrl.off();
          $imageBtn.off();
          if (deferred.state() === 'pending') {
            deferred.reject();
          }
        });
        _this2.ui.showDialog(_this2.$dialog);
      });
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/ImagePopover.js
function ImagePopover_typeof(o) { "@babel/helpers - typeof"; return ImagePopover_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, ImagePopover_typeof(o); }
function ImagePopover_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function ImagePopover_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, ImagePopover_toPropertyKey(o.key), o); } }
function ImagePopover_createClass(e, r, t) { return r && ImagePopover_defineProperties(e.prototype, r), t && ImagePopover_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function ImagePopover_toPropertyKey(t) { var i = ImagePopover_toPrimitive(t, "string"); return "symbol" == ImagePopover_typeof(i) ? i : i + ""; }
function ImagePopover_toPrimitive(t, r) { if ("object" != ImagePopover_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != ImagePopover_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




/**
 * Image popover module
 *  mouse events that show/hide popover will be handled by Handle.js.
 *  Handle.js will receive the events and invoke 'imagePopover.update'.
 */
var ImagePopover = /*#__PURE__*/function () {
  function ImagePopover(context) {
    var _this = this;
    ImagePopover_classCallCheck(this, ImagePopover);
    this.context = context;
    this.ui = (external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote.ui;
    this.editable = context.layoutInfo.editable[0];
    this.options = context.options;
    this.events = {
      'summernote.disable summernote.dialog.shown': function summernoteDisableSummernoteDialogShown() {
        _this.hide();
      },
      'summernote.blur': function summernoteBlur(we, event) {
        if (event.originalEvent && event.originalEvent.relatedTarget) {
          if (!_this.$popover[0].contains(event.originalEvent.relatedTarget)) {
            _this.hide();
          }
        } else {
          _this.hide();
        }
      }
    };
  }
  return ImagePopover_createClass(ImagePopover, [{
    key: "shouldInitialize",
    value: function shouldInitialize() {
      return !lists.isEmpty(this.options.popover.image);
    }
  }, {
    key: "initialize",
    value: function initialize() {
      this.$popover = this.ui.popover({
        className: 'note-image-popover'
      }).render().appendTo(this.options.container);
      var $content = this.$popover.find('.popover-content,.note-popover-content');
      this.context.invoke('buttons.build', $content, this.options.popover.image);
      this.$popover.on('mousedown', function (event) {
        event.preventDefault();
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.$popover.remove();
    }
  }, {
    key: "update",
    value: function update(target, event) {
      if (dom.isImg(target)) {
        var position = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(target).offset();
        var containerOffset = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(this.options.container).offset();
        var pos = {};
        if (this.options.popatmouse) {
          pos.left = event.pageX - 20;
          pos.top = event.pageY;
        } else {
          pos = position;
        }
        pos.top -= containerOffset.top;
        pos.left -= containerOffset.left;
        this.$popover.css({
          display: 'block',
          left: pos.left,
          top: pos.top
        });
      } else {
        this.hide();
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      this.$popover.hide();
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/TablePopover.js
function TablePopover_typeof(o) { "@babel/helpers - typeof"; return TablePopover_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, TablePopover_typeof(o); }
function TablePopover_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function TablePopover_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, TablePopover_toPropertyKey(o.key), o); } }
function TablePopover_createClass(e, r, t) { return r && TablePopover_defineProperties(e.prototype, r), t && TablePopover_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function TablePopover_toPropertyKey(t) { var i = TablePopover_toPrimitive(t, "string"); return "symbol" == TablePopover_typeof(i) ? i : i + ""; }
function TablePopover_toPrimitive(t, r) { if ("object" != TablePopover_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != TablePopover_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




var TablePopover = /*#__PURE__*/function () {
  function TablePopover(context) {
    var _this = this;
    TablePopover_classCallCheck(this, TablePopover);
    this.context = context;
    this.ui = (external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote.ui;
    this.options = context.options;
    this.events = {
      'summernote.mousedown': function summernoteMousedown(we, event) {
        _this.update(event.target);
      },
      'summernote.keyup summernote.scroll summernote.change': function summernoteKeyupSummernoteScrollSummernoteChange() {
        _this.update();
      },
      'summernote.disable summernote.dialog.shown': function summernoteDisableSummernoteDialogShown() {
        _this.hide();
      },
      'summernote.blur': function summernoteBlur(we, event) {
        if (event.originalEvent && event.originalEvent.relatedTarget) {
          if (!_this.$popover[0].contains(event.originalEvent.relatedTarget)) {
            _this.hide();
          }
        } else {
          _this.hide();
        }
      }
    };
  }
  return TablePopover_createClass(TablePopover, [{
    key: "shouldInitialize",
    value: function shouldInitialize() {
      return !lists.isEmpty(this.options.popover.table);
    }
  }, {
    key: "initialize",
    value: function initialize() {
      this.$popover = this.ui.popover({
        className: 'note-table-popover'
      }).render().appendTo(this.options.container);
      var $content = this.$popover.find('.popover-content,.note-popover-content');
      this.context.invoke('buttons.build', $content, this.options.popover.table);

      // [workaround] Disable Firefox's default table editor
      if (env.isFF) {
        document.execCommand('enableInlineTableEditing', false, false);
      }
      this.$popover.on('mousedown', function (event) {
        event.preventDefault();
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.$popover.remove();
    }
  }, {
    key: "update",
    value: function update(target) {
      if (this.context.isDisabled()) {
        return false;
      }
      var isCell = dom.isCell(target) || dom.isCell(target === null || target === void 0 ? void 0 : target.parentElement);
      if (isCell) {
        var pos = dom.posFromPlaceholder(target);
        var containerOffset = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(this.options.container).offset();
        pos.top -= containerOffset.top;
        pos.left -= containerOffset.left;
        this.$popover.css({
          display: 'block',
          left: pos.left,
          top: pos.top
        });
      } else {
        this.hide();
      }
      return isCell;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.$popover.hide();
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/VideoDialog.js
function VideoDialog_typeof(o) { "@babel/helpers - typeof"; return VideoDialog_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, VideoDialog_typeof(o); }
function VideoDialog_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function VideoDialog_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, VideoDialog_toPropertyKey(o.key), o); } }
function VideoDialog_createClass(e, r, t) { return r && VideoDialog_defineProperties(e.prototype, r), t && VideoDialog_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function VideoDialog_toPropertyKey(t) { var i = VideoDialog_toPrimitive(t, "string"); return "symbol" == VideoDialog_typeof(i) ? i : i + ""; }
function VideoDialog_toPrimitive(t, r) { if ("object" != VideoDialog_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != VideoDialog_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var VideoDialog = /*#__PURE__*/function () {
  function VideoDialog(context) {
    VideoDialog_classCallCheck(this, VideoDialog);
    this.context = context;
    this.ui = (external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote.ui;
    this.$body = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(document.body);
    this.$editor = context.layoutInfo.editor;
    this.options = context.options;
    this.lang = this.options.langInfo;
  }
  return VideoDialog_createClass(VideoDialog, [{
    key: "initialize",
    value: function initialize() {
      var $container = this.options.dialogsInBody ? this.$body : this.options.container;
      var body = ['<div class="form-group note-form-group row-fluid">', "<label for=\"note-dialog-video-url-".concat(this.options.id, "\" class=\"note-form-label\">").concat(this.lang.video.url, " <small class=\"text-muted\">").concat(this.lang.video.providers, "</small></label>"), "<input id=\"note-dialog-video-url-".concat(this.options.id, "\" class=\"note-video-url form-control note-form-control note-input\" type=\"text\"/>"), '</div>'].join('');
      var buttonClass = 'btn btn-primary note-btn note-btn-primary note-video-btn';
      var footer = "<input type=\"button\" href=\"#\" class=\"".concat(buttonClass, "\" value=\"").concat(this.lang.video.insert, "\" disabled>");
      this.$dialog = this.ui.dialog({
        title: this.lang.video.insert,
        fade: this.options.dialogsFade,
        body: body,
        footer: footer
      }).render().appendTo($container);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.ui.hideDialog(this.$dialog);
      this.$dialog.remove();
    }
  }, {
    key: "bindEnterKey",
    value: function bindEnterKey($input, $btn) {
      $input.on('keypress', function (event) {
        if (event.keyCode === key.code.ENTER) {
          event.preventDefault();
          $btn.trigger('click');
        }
      });
    }
  }, {
    key: "createVideoNode",
    value: function createVideoNode(url) {
      // video url patterns(youtube, instagram, vimeo, dailymotion, youku, peertube, mp4, ogg, webm)
      var ytRegExp = /(?:youtu\.be\/|youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=|shorts\/|live\/))([^&\n?]+)(?:.*[?&]t=([^&\n]+))?.*/;
      var ytRegExpForStart = /^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/;
      var ytMatch = url.match(ytRegExp);
      var gdRegExp = /(?:\.|\/\/)drive\.google\.com\/file\/d\/(.[a-zA-Z0-9_-]*)\/view/;
      var gdMatch = url.match(gdRegExp);
      var igRegExp = /(?:www\.|\/\/)instagram\.com\/(reel|p)\/(.[a-zA-Z0-9_-]*)/;
      var igMatch = url.match(igRegExp);
      var vRegExp = /\/\/vine\.co\/v\/([a-zA-Z0-9]+)/;
      var vMatch = url.match(vRegExp);
      var vimRegExp = /\/\/(player\.)?vimeo\.com\/([a-z]*\/)*(\d+)[?]?.*/;
      var vimMatch = url.match(vimRegExp);
      var dmRegExp = /.+dailymotion.com\/(video|hub)\/([^_]+)[^#]*(#video=([^_&]+))?/;
      var dmMatch = url.match(dmRegExp);
      var youkuRegExp = /\/\/v\.youku\.com\/v_show\/id_(\w+)=*\.html/;
      var youkuMatch = url.match(youkuRegExp);
      var peerTubeRegExp = /\/\/(.*)\/videos\/watch\/([^?]*)(?:\?(?:start=(\w*))?(?:&stop=(\w*))?(?:&loop=([10]))?(?:&autoplay=([10]))?(?:&muted=([10]))?)?/;
      var peerTubeMatch = url.match(peerTubeRegExp);
      var qqRegExp = /\/\/v\.qq\.com.*?vid=(.+)/;
      var qqMatch = url.match(qqRegExp);
      var qqRegExp2 = /\/\/v\.qq\.com\/x?\/?(page|cover).*?\/([^\/]+)\.html\??.*/;
      var qqMatch2 = url.match(qqRegExp2);
      var mp4RegExp = /^.+.(mp4|m4v)$/;
      var mp4Match = url.match(mp4RegExp);
      var oggRegExp = /^.+.(ogg|ogv)$/;
      var oggMatch = url.match(oggRegExp);
      var webmRegExp = /^.+.(webm)$/;
      var webmMatch = url.match(webmRegExp);
      var fbRegExp = /(?:www\.|\/\/)facebook\.com\/([^\/]+)\/videos\/([0-9]+)/;
      var fbMatch = url.match(fbRegExp);
      var $video;
      if (ytMatch && ytMatch[1].length === 11) {
        var youtubeId = ytMatch[1];
        var start = 0;
        if (typeof ytMatch[2] !== 'undefined') {
          var ytMatchForStart = ytMatch[2].match(ytRegExpForStart);
          if (ytMatchForStart) {
            for (var n = [3600, 60, 1], i = 0, r = n.length; i < r; i++) {
              start += typeof ytMatchForStart[i + 1] !== 'undefined' ? n[i] * parseInt(ytMatchForStart[i + 1], 10) : 0;
            }
          } else {
            start = parseInt(ytMatch[2], 10);
          }
        }
        $video = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<iframe>').attr('frameborder', 0).attr('src', '//www.youtube.com/embed/' + youtubeId + (start > 0 ? '?start=' + start : '')).attr('width', '640').attr('height', '360');
      } else if (gdMatch && gdMatch[0].length) {
        $video = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<iframe>').attr('frameborder', 0).attr('src', 'https://drive.google.com/file/d/' + gdMatch[1] + '/preview').attr('width', '640').attr('height', '480');
      } else if (igMatch && igMatch[0].length) {
        $video = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<iframe>').attr('frameborder', 0).attr('src', 'https://instagram.com/p/' + igMatch[2] + '/embed/').attr('width', '612').attr('height', '710').attr('scrolling', 'no').attr('allowtransparency', 'true');
      } else if (vMatch && vMatch[0].length) {
        $video = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<iframe>').attr('frameborder', 0).attr('src', vMatch[0] + '/embed/simple').attr('width', '600').attr('height', '600').attr('class', 'vine-embed');
      } else if (vimMatch && vimMatch[3].length) {
        $video = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<iframe webkitallowfullscreen mozallowfullscreen allowfullscreen>').attr('frameborder', 0).attr('src', '//player.vimeo.com/video/' + vimMatch[3]).attr('width', '640').attr('height', '360');
      } else if (dmMatch && dmMatch[2].length) {
        $video = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<iframe>').attr('frameborder', 0).attr('src', '//www.dailymotion.com/embed/video/' + dmMatch[2]).attr('width', '640').attr('height', '360');
      } else if (youkuMatch && youkuMatch[1].length) {
        $video = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<iframe webkitallowfullscreen mozallowfullscreen allowfullscreen>').attr('frameborder', 0).attr('height', '498').attr('width', '510').attr('src', '//player.youku.com/embed/' + youkuMatch[1]);
      } else if (peerTubeMatch && peerTubeMatch[0].length) {
        var begin = 0;
        if (peerTubeMatch[2] !== 'undefined') begin = peerTubeMatch[2];
        var end = 0;
        if (peerTubeMatch[3] !== 'undefined') end = peerTubeMatch[3];
        var loop = 0;
        if (peerTubeMatch[4] !== 'undefined') loop = peerTubeMatch[4];
        var autoplay = 0;
        if (peerTubeMatch[5] !== 'undefined') autoplay = peerTubeMatch[5];
        var muted = 0;
        if (peerTubeMatch[6] !== 'undefined') muted = peerTubeMatch[6];
        $video = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<iframe allowfullscreen sandbox="allow-same-origin allow-scripts allow-popups">').attr('frameborder', 0).attr('src', '//' + peerTubeMatch[1] + '/videos/embed/' + peerTubeMatch[2] + "?loop=" + loop + "&autoplay=" + autoplay + "&muted=" + muted + (begin > 0 ? '&start=' + begin : '') + (end > 0 ? '&end=' + start : '')).attr('width', '560').attr('height', '315');
      } else if (qqMatch && qqMatch[1].length || qqMatch2 && qqMatch2[2].length) {
        var vid = qqMatch && qqMatch[1].length ? qqMatch[1] : qqMatch2[2];
        $video = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<iframe webkitallowfullscreen mozallowfullscreen allowfullscreen>').attr('frameborder', 0).attr('height', '310').attr('width', '500').attr('src', 'https://v.qq.com/txp/iframe/player.html?vid=' + vid + '&amp;auto=0');
      } else if (mp4Match || oggMatch || webmMatch) {
        $video = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<video controls>').attr('src', url).attr('width', '640').attr('height', '360');
      } else if (fbMatch && fbMatch[0].length) {
        $video = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<iframe>').attr('frameborder', 0).attr('src', 'https://www.facebook.com/plugins/video.php?href=' + encodeURIComponent(fbMatch[0]) + '&show_text=0&width=560').attr('width', '560').attr('height', '301').attr('scrolling', 'no').attr('allowtransparency', 'true');
      } else {
        // this is not a known video link. Now what, Cat? Now what?
        return false;
      }
      $video.addClass('note-video-clip');
      return $video[0];
    }
  }, {
    key: "show",
    value: function show() {
      var _this = this;
      var text = this.context.invoke('editor.getSelectedText');
      this.context.invoke('editor.saveRange');
      this.showVideoDialog(text).then(function (url) {
        // [workaround] hide dialog before restore range for IE range focus
        _this.ui.hideDialog(_this.$dialog);
        _this.context.invoke('editor.restoreRange');

        // build node
        var $node = _this.createVideoNode(url);
        if ($node) {
          // insert video node
          _this.context.invoke('editor.insertNode', $node);
        }
      }).fail(function () {
        _this.context.invoke('editor.restoreRange');
      });
    }

    /**
     * show video dialog
     *
     * @param {jQuery} $dialog
     * @return {Promise}
     */
  }, {
    key: "showVideoDialog",
    value: function showVideoDialog( /* text */
    ) {
      var _this2 = this;
      return external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().Deferred(function (deferred) {
        var $videoUrl = _this2.$dialog.find('.note-video-url');
        var $videoBtn = _this2.$dialog.find('.note-video-btn');
        _this2.ui.onDialogShown(_this2.$dialog, function () {
          _this2.context.triggerEvent('dialog.shown');
          $videoUrl.on('input paste propertychange', function () {
            _this2.ui.toggleBtn($videoBtn, $videoUrl.val());
          });
          if (!env.isSupportTouch) {
            $videoUrl.trigger('focus');
          }
          $videoBtn.on('click', function (event) {
            event.preventDefault();
            deferred.resolve($videoUrl.val());
          });
          _this2.bindEnterKey($videoUrl, $videoBtn);
        });
        _this2.ui.onDialogHidden(_this2.$dialog, function () {
          $videoUrl.off();
          $videoBtn.off();
          if (deferred.state() === 'pending') {
            deferred.reject();
          }
        });
        _this2.ui.showDialog(_this2.$dialog);
      });
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/HelpDialog.js
function HelpDialog_typeof(o) { "@babel/helpers - typeof"; return HelpDialog_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, HelpDialog_typeof(o); }
function HelpDialog_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function HelpDialog_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, HelpDialog_toPropertyKey(o.key), o); } }
function HelpDialog_createClass(e, r, t) { return r && HelpDialog_defineProperties(e.prototype, r), t && HelpDialog_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function HelpDialog_toPropertyKey(t) { var i = HelpDialog_toPrimitive(t, "string"); return "symbol" == HelpDialog_typeof(i) ? i : i + ""; }
function HelpDialog_toPrimitive(t, r) { if ("object" != HelpDialog_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != HelpDialog_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var HelpDialog = /*#__PURE__*/function () {
  function HelpDialog(context) {
    HelpDialog_classCallCheck(this, HelpDialog);
    this.context = context;
    this.ui = (external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote.ui;
    this.$body = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(document.body);
    this.$editor = context.layoutInfo.editor;
    this.options = context.options;
    this.lang = this.options.langInfo;
  }
  return HelpDialog_createClass(HelpDialog, [{
    key: "initialize",
    value: function initialize() {
      var $container = this.options.dialogsInBody ? this.$body : this.options.container;
      var body = ['<p class="text-center">', '<a href="http://summernote.org/" target="_blank" rel="noopener noreferrer">Summernote 0.9.0</a> · ', '<a href="https://github.com/summernote/summernote" target="_blank" rel="noopener noreferrer">Project</a> · ', '<a href="https://github.com/summernote/summernote/issues" target="_blank" rel="noopener noreferrer">Issues</a>', '</p>'].join('');
      this.$dialog = this.ui.dialog({
        title: this.lang.options.help,
        fade: this.options.dialogsFade,
        body: this.createShortcutList(),
        footer: body,
        callback: function callback($node) {
          $node.find('.modal-body,.note-modal-body').css({
            'max-height': 300,
            'overflow': 'scroll'
          });
        }
      }).render().appendTo($container);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.ui.hideDialog(this.$dialog);
      this.$dialog.remove();
    }
  }, {
    key: "createShortcutList",
    value: function createShortcutList() {
      var _this = this;
      var keyMap = this.options.keyMap[env.isMac ? 'mac' : 'pc'];
      return Object.keys(keyMap).map(function (key) {
        var command = keyMap[key];
        var $row = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<div><div class="help-list-item"></div></div>');
        $row.append(external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<label><kbd>' + key + '</kdb></label>').css({
          'width': 180,
          'margin-right': 10
        })).append(external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<span></span>').html(_this.context.memo('help.' + command) || command));
        return $row.html();
      }).join('');
    }

    /**
     * show help dialog
     *
     * @return {Promise}
     */
  }, {
    key: "showHelpDialog",
    value: function showHelpDialog() {
      var _this2 = this;
      return external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().Deferred(function (deferred) {
        _this2.ui.onDialogShown(_this2.$dialog, function () {
          _this2.context.triggerEvent('dialog.shown');
          deferred.resolve();
        });
        _this2.ui.showDialog(_this2.$dialog);
      }).promise();
    }
  }, {
    key: "show",
    value: function show() {
      var _this3 = this;
      this.context.invoke('editor.saveRange');
      this.showHelpDialog().then(function () {
        _this3.context.invoke('editor.restoreRange');
      });
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/AirPopover.js
function AirPopover_typeof(o) { "@babel/helpers - typeof"; return AirPopover_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, AirPopover_typeof(o); }
function AirPopover_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function AirPopover_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, AirPopover_toPropertyKey(o.key), o); } }
function AirPopover_createClass(e, r, t) { return r && AirPopover_defineProperties(e.prototype, r), t && AirPopover_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function AirPopover_toPropertyKey(t) { var i = AirPopover_toPrimitive(t, "string"); return "symbol" == AirPopover_typeof(i) ? i : i + ""; }
function AirPopover_toPrimitive(t, r) { if ("object" != AirPopover_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != AirPopover_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var AIRMODE_POPOVER_X_OFFSET = -5;
var AIRMODE_POPOVER_Y_OFFSET = 5;
var AirPopover = /*#__PURE__*/function () {
  function AirPopover(context) {
    var _this = this;
    AirPopover_classCallCheck(this, AirPopover);
    this.context = context;
    this.ui = (external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote.ui;
    this.options = context.options;
    this.hidable = true;
    this.onContextmenu = false;
    this.pageX = null;
    this.pageY = null;
    this.events = {
      'summernote.contextmenu': function summernoteContextmenu(event) {
        if (_this.options.editing) {
          event.preventDefault();
          event.stopPropagation();
          _this.onContextmenu = true;
          _this.update(true);
        }
      },
      'summernote.mousedown': function summernoteMousedown(we, event) {
        _this.pageX = event.pageX;
        _this.pageY = event.pageY;
      },
      'summernote.keyup summernote.mouseup summernote.scroll': function summernoteKeyupSummernoteMouseupSummernoteScroll(we, event) {
        if (_this.options.editing && !_this.onContextmenu) {
          if (event.type == 'keyup') {
            var range = _this.context.invoke('editor.getLastRange');
            var wordRange = range.getWordRange();
            var bnd = func.rect2bnd(lists.last(wordRange.getClientRects()));
            _this.pageX = bnd.left;
            _this.pageY = bnd.top;
          } else {
            _this.pageX = event.pageX;
            _this.pageY = event.pageY;
          }
          _this.update();
        }
        _this.onContextmenu = false;
      },
      'summernote.disable summernote.change summernote.dialog.shown summernote.blur': function summernoteDisableSummernoteChangeSummernoteDialogShownSummernoteBlur() {
        _this.hide();
      },
      'summernote.focusout': function summernoteFocusout() {
        if (!_this.$popover.is(':active,:focus')) {
          _this.hide();
        }
      }
    };
  }
  return AirPopover_createClass(AirPopover, [{
    key: "shouldInitialize",
    value: function shouldInitialize() {
      return this.options.airMode && !lists.isEmpty(this.options.popover.air);
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this2 = this;
      this.$popover = this.ui.popover({
        className: 'note-air-popover'
      }).render().appendTo(this.options.container);
      var $content = this.$popover.find('.popover-content');
      this.context.invoke('buttons.build', $content, this.options.popover.air);

      // disable hiding this popover preemptively by 'summernote.blur' event.
      this.$popover.on('mousedown', function () {
        _this2.hidable = false;
      });
      // (re-)enable hiding after 'summernote.blur' has been handled (aka. ignored).
      this.$popover.on('mouseup', function () {
        _this2.hidable = true;
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.$popover.remove();
    }
  }, {
    key: "update",
    value: function update(forcelyOpen) {
      var styleInfo = this.context.invoke('editor.currentStyle');
      if (styleInfo.range && (!styleInfo.range.isCollapsed() || forcelyOpen)) {
        var rect = {
          left: this.pageX,
          top: this.pageY
        };
        var containerOffset = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(this.options.container).offset();
        rect.top -= containerOffset.top;
        rect.left -= containerOffset.left;
        this.$popover.css({
          display: 'block',
          left: Math.max(rect.left, 0) + AIRMODE_POPOVER_X_OFFSET,
          top: rect.top + AIRMODE_POPOVER_Y_OFFSET
        });
        this.context.invoke('buttons.updateCurrentStyle', this.$popover);
      } else {
        this.hide();
      }
    }
  }, {
    key: "updateCodeview",
    value: function updateCodeview(isCodeview) {
      this.ui.toggleBtnActive(this.$popover.find('.btn-codeview'), isCodeview);
      if (isCodeview) {
        this.hide();
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.hidable) {
        this.$popover.hide();
      }
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/module/HintPopover.js
function HintPopover_typeof(o) { "@babel/helpers - typeof"; return HintPopover_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, HintPopover_typeof(o); }
function HintPopover_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function HintPopover_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, HintPopover_toPropertyKey(o.key), o); } }
function HintPopover_createClass(e, r, t) { return r && HintPopover_defineProperties(e.prototype, r), t && HintPopover_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function HintPopover_toPropertyKey(t) { var i = HintPopover_toPrimitive(t, "string"); return "symbol" == HintPopover_typeof(i) ? i : i + ""; }
function HintPopover_toPrimitive(t, r) { if ("object" != HintPopover_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != HintPopover_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






var POPOVER_DIST = 5;
var HintPopover = /*#__PURE__*/function () {
  function HintPopover(context) {
    var _this = this;
    HintPopover_classCallCheck(this, HintPopover);
    this.context = context;
    this.ui = (external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote.ui;
    this.$editable = context.layoutInfo.editable;
    this.options = context.options;
    this.hint = this.options.hint || [];
    this.direction = this.options.hintDirection || 'bottom';
    this.hints = Array.isArray(this.hint) ? this.hint : [this.hint];
    this.events = {
      'summernote.keyup': function summernoteKeyup(we, event) {
        if (!event.isDefaultPrevented()) {
          _this.handleKeyup(event);
        }
      },
      'summernote.keydown': function summernoteKeydown(we, event) {
        _this.handleKeydown(event);
      },
      'summernote.disable summernote.dialog.shown summernote.blur': function summernoteDisableSummernoteDialogShownSummernoteBlur() {
        _this.hide();
      }
    };
  }
  return HintPopover_createClass(HintPopover, [{
    key: "shouldInitialize",
    value: function shouldInitialize() {
      return this.hints.length > 0;
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this2 = this;
      this.lastWordRange = null;
      this.matchingWord = null;
      this.$popover = this.ui.popover({
        className: 'note-hint-popover',
        hideArrow: true,
        direction: ''
      }).render().appendTo(this.options.container);
      this.$popover.hide();
      this.$content = this.$popover.find('.popover-content,.note-popover-content');
      this.$content.on('click', '.note-hint-item', function (event) {
        _this2.$content.find('.active').removeClass('active');
        external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(event.currentTarget).addClass('active');
        _this2.replace();
      });
      this.$popover.on('mousedown', function (event) {
        event.preventDefault();
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.$popover.remove();
    }
  }, {
    key: "selectItem",
    value: function selectItem($item) {
      this.$content.find('.active').removeClass('active');
      $item.addClass('active');
      this.$content[0].scrollTop = $item[0].offsetTop - this.$content.innerHeight() / 2;
    }
  }, {
    key: "moveDown",
    value: function moveDown() {
      var $current = this.$content.find('.note-hint-item.active');
      var $next = $current.next();
      if ($next.length) {
        this.selectItem($next);
      } else {
        var $nextGroup = $current.parent().next();
        if (!$nextGroup.length) {
          $nextGroup = this.$content.find('.note-hint-group').first();
        }
        this.selectItem($nextGroup.find('.note-hint-item').first());
      }
    }
  }, {
    key: "moveUp",
    value: function moveUp() {
      var $current = this.$content.find('.note-hint-item.active');
      var $prev = $current.prev();
      if ($prev.length) {
        this.selectItem($prev);
      } else {
        var $prevGroup = $current.parent().prev();
        if (!$prevGroup.length) {
          $prevGroup = this.$content.find('.note-hint-group').last();
        }
        this.selectItem($prevGroup.find('.note-hint-item').last());
      }
    }
  }, {
    key: "replace",
    value: function replace() {
      var $item = this.$content.find('.note-hint-item.active');
      if ($item.length) {
        var node = this.nodeFromItem($item);
        // If matchingWord length = 0 -> capture OK / open hint / but as mention capture "" (\w*)
        if (this.matchingWord !== null && this.matchingWord.length === 0) {
          this.lastWordRange.so = this.lastWordRange.eo;
          // Else si > 0 and normal case -> adjust range "before" for correct position of insertion
        } else if (this.matchingWord !== null && this.matchingWord.length > 0 && !this.lastWordRange.isCollapsed()) {
          var rangeCompute = this.lastWordRange.eo - this.lastWordRange.so - this.matchingWord.length;
          if (rangeCompute > 0) {
            this.lastWordRange.so += rangeCompute;
          }
        }
        this.lastWordRange.insertNode(node);
        if (this.options.hintSelect === 'next') {
          var blank = document.createTextNode('');
          external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(node).after(blank);
          range.createFromNodeBefore(blank).select();
        } else {
          range.createFromNodeAfter(node).select();
        }
        this.lastWordRange = null;
        this.hide();
        this.context.invoke('editor.focus');
        this.context.triggerEvent('change', this.$editable.html(), this.$editable);
      }
    }
  }, {
    key: "nodeFromItem",
    value: function nodeFromItem($item) {
      var hint = this.hints[$item.data('index')];
      var item = $item.data('item');
      var node = hint.content ? hint.content(item) : item;
      if (typeof node === 'string') {
        node = dom.createText(node);
      }
      return node;
    }
  }, {
    key: "createItemTemplates",
    value: function createItemTemplates(hintIdx, items) {
      var hint = this.hints[hintIdx];
      return items.map(function (item, idx) {
        var $item = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<div class="note-hint-item"></div>');
        $item.append(hint.template ? hint.template(item) : item + '');
        $item.data({
          'index': hintIdx,
          'item': item
        });
        if (hintIdx === 0 && idx === 0) {
          $item.addClass('active');
        }
        return $item;
      });
    }
  }, {
    key: "handleKeydown",
    value: function handleKeydown(event) {
      if (!this.$popover.is(':visible')) {
        return;
      }
      if (event.keyCode === key.code.ENTER) {
        event.preventDefault();
        this.replace();
      } else if (event.keyCode === key.code.UP) {
        event.preventDefault();
        this.moveUp();
      } else if (event.keyCode === key.code.DOWN) {
        event.preventDefault();
        this.moveDown();
      }
    }
  }, {
    key: "searchKeyword",
    value: function searchKeyword(index, keyword, callback) {
      var hint = this.hints[index];
      if (hint && hint.match.test(keyword) && hint.search) {
        var matches = hint.match.exec(keyword);
        this.matchingWord = matches[0];
        hint.search(matches[1], callback);
      } else {
        callback();
      }
    }
  }, {
    key: "createGroup",
    value: function createGroup(idx, keyword) {
      var _this3 = this;
      var $group = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<div class="note-hint-group note-hint-group-' + idx + '"></div>');
      this.searchKeyword(idx, keyword, function (items) {
        items = items || [];
        if (items.length) {
          $group.html(_this3.createItemTemplates(idx, items));
          _this3.show();
        }
      });
      return $group;
    }
  }, {
    key: "handleKeyup",
    value: function handleKeyup(event) {
      var _this4 = this;
      if (!lists.contains([key.code.ENTER, key.code.UP, key.code.DOWN], event.keyCode)) {
        var _range = this.context.invoke('editor.getLastRange');
        var wordRange, keyword;
        if (this.options.hintMode === 'words') {
          wordRange = _range.getWordsRange(_range);
          keyword = wordRange.toString();
          this.hints.forEach(function (hint) {
            if (hint.match.test(keyword)) {
              wordRange = _range.getWordsMatchRange(hint.match);
              return false;
            }
          });
          if (!wordRange) {
            this.hide();
            return;
          }
          keyword = wordRange.toString();
        } else {
          wordRange = _range.getWordRange();
          keyword = wordRange.toString();
        }
        if (this.hints.length && keyword) {
          this.$content.empty();
          var bnd = func.rect2bnd(lists.last(wordRange.getClientRects()));
          var containerOffset = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(this.options.container).offset();
          if (bnd) {
            bnd.top -= containerOffset.top;
            bnd.left -= containerOffset.left;
            this.$popover.hide();
            this.lastWordRange = wordRange;
            this.hints.forEach(function (hint, idx) {
              if (hint.match.test(keyword)) {
                _this4.createGroup(idx, keyword).appendTo(_this4.$content);
              }
            });
            // select first .note-hint-item
            this.$content.find('.note-hint-item').first().addClass('active');

            // set position for popover after group is created
            if (this.direction === 'top') {
              this.$popover.css({
                left: bnd.left,
                top: bnd.top - this.$popover.outerHeight() - POPOVER_DIST
              });
            } else {
              this.$popover.css({
                left: bnd.left,
                top: bnd.top + bnd.height + POPOVER_DIST
              });
            }
          }
        } else {
          this.hide();
        }
      }
    }
  }, {
    key: "show",
    value: function show() {
      this.$popover.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.$popover.hide();
    }
  }]);
}();

;// CONCATENATED MODULE: ./src/js/settings.js




























(external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().extend((external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote, {
  version: '0.9.0',
  plugins: {},
  dom: dom,
  range: range,
  lists: lists,
  options: {
    langInfo: (external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote.lang['en-US'],
    editing: true,
    modules: {
      'editor': Editor,
      'clipboard': Clipboard,
      'dropzone': Dropzone,
      'codeview': CodeView,
      'statusbar': Statusbar,
      'fullscreen': Fullscreen,
      'handle': Handle,
      // FIXME: HintPopover must be front of autolink
      //  - Script error about range when Enter key is pressed on hint popover
      'hintPopover': HintPopover,
      'autoLink': AutoLink,
      'autoSync': AutoSync,
      'autoReplace': AutoReplace,
      'placeholder': Placeholder,
      'buttons': Buttons,
      'toolbar': Toolbar,
      'linkDialog': LinkDialog,
      'linkPopover': LinkPopover,
      'imageDialog': ImageDialog,
      'imagePopover': ImagePopover,
      'tablePopover': TablePopover,
      'videoDialog': VideoDialog,
      'helpDialog': HelpDialog,
      'airPopover': AirPopover
    },
    buttons: {},
    lang: 'en-US',
    followingToolbar: false,
    toolbarPosition: 'top',
    otherStaticBar: '',
    // toolbar
    codeviewKeepButton: false,
    toolbar: [['style', ['style']], ['font', ['bold', 'underline', 'clear']], ['fontname', ['fontname']], ['color', ['color']], ['para', ['ul', 'ol', 'paragraph']], ['table', ['table']], ['insert', ['link', 'picture', 'video']], ['view', ['fullscreen', 'codeview', 'help']]],
    // popover
    popatmouse: true,
    popover: {
      image: [['resize', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']], ['float', ['floatLeft', 'floatRight', 'floatNone']], ['remove', ['removeMedia']]],
      link: [['link', ['linkDialogShow', 'unlink']]],
      table: [['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']], ['delete', ['deleteRow', 'deleteCol', 'deleteTable']]],
      air: [['color', ['color']], ['font', ['bold', 'underline', 'clear']], ['para', ['ul', 'paragraph']], ['table', ['table']], ['insert', ['link', 'picture']], ['view', ['fullscreen', 'codeview']]]
    },
    // link options
    linkAddNoReferrer: false,
    addLinkNoOpener: false,
    // air mode: inline editor
    airMode: false,
    overrideContextMenu: false,
    // TBD

    width: null,
    height: null,
    linkTargetBlank: true,
    focus: false,
    tabDisable: false,
    tabSize: 4,
    styleWithCSS: false,
    shortcuts: true,
    textareaAutoSync: true,
    tooltip: 'auto',
    container: null,
    maxTextLength: 0,
    blockquoteBreakingLevel: 2,
    spellCheck: true,
    disableGrammar: false,
    placeholder: null,
    inheritPlaceholder: false,
    // TODO: need to be documented
    recordEveryKeystroke: false,
    historyLimit: 200,
    // TODO: need to be documented
    showDomainOnlyForAutolink: false,
    // TODO: need to be documented
    hintMode: 'word',
    hintSelect: 'after',
    hintDirection: 'bottom',
    styleTags: ['p', 'blockquote', 'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
    fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Helvetica Neue', 'Helvetica', 'Impact', 'Lucida Grande', 'Tahoma', 'Times New Roman', 'Verdana'],
    fontNamesIgnoreCheck: [],
    addDefaultFonts: true,
    fontSizes: ['8', '9', '10', '11', '12', '14', '18', '24', '36'],
    fontSizeUnits: ['px', 'pt'],
    // pallete colors(n x n)
    colors: [['#000000', '#424242', '#636363', '#9C9C94', '#CEC6CE', '#EFEFEF', '#F7F7F7', '#FFFFFF'], ['#FF0000', '#FF9C00', '#FFFF00', '#00FF00', '#00FFFF', '#0000FF', '#9C00FF', '#FF00FF'], ['#F7C6CE', '#FFE7CE', '#FFEFC6', '#D6EFD6', '#CEDEE7', '#CEE7F7', '#D6D6E7', '#E7D6DE'], ['#E79C9C', '#FFC69C', '#FFE79C', '#B5D6A5', '#A5C6CE', '#9CC6EF', '#B5A5D6', '#D6A5BD'], ['#E76363', '#F7AD6B', '#FFD663', '#94BD7B', '#73A5AD', '#6BADDE', '#8C7BC6', '#C67BA5'], ['#CE0000', '#E79439', '#EFC631', '#6BA54A', '#4A7B8C', '#3984C6', '#634AA5', '#A54A7B'], ['#9C0000', '#B56308', '#BD9400', '#397B21', '#104A5A', '#085294', '#311873', '#731842'], ['#630000', '#7B3900', '#846300', '#295218', '#083139', '#003163', '#21104A', '#4A1031']],
    // http://chir.ag/projects/name-that-color/
    colorsName: [['Black', 'Tundora', 'Dove Gray', 'Star Dust', 'Pale Slate', 'Gallery', 'Alabaster', 'White'], ['Red', 'Orange Peel', 'Yellow', 'Green', 'Cyan', 'Blue', 'Electric Violet', 'Magenta'], ['Azalea', 'Karry', 'Egg White', 'Zanah', 'Botticelli', 'Tropical Blue', 'Mischka', 'Twilight'], ['Tonys Pink', 'Peach Orange', 'Cream Brulee', 'Sprout', 'Casper', 'Perano', 'Cold Purple', 'Careys Pink'], ['Mandy', 'Rajah', 'Dandelion', 'Olivine', 'Gulf Stream', 'Viking', 'Blue Marguerite', 'Puce'], ['Guardsman Red', 'Fire Bush', 'Golden Dream', 'Chelsea Cucumber', 'Smalt Blue', 'Boston Blue', 'Butterfly Bush', 'Cadillac'], ['Sangria', 'Mai Tai', 'Buddha Gold', 'Forest Green', 'Eden', 'Venice Blue', 'Meteorite', 'Claret'], ['Rosewood', 'Cinnamon', 'Olive', 'Parsley', 'Tiber', 'Midnight Blue', 'Valentino', 'Loulou']],
    colorButton: {
      foreColor: '#000000',
      backColor: '#FFFF00'
    },
    lineHeights: ['1.0', '1.2', '1.4', '1.5', '1.6', '1.8', '2.0', '3.0'],
    tableClassName: 'table table-bordered',
    insertTableMaxSize: {
      col: 10,
      row: 10
    },
    // By default, dialogs are attached in container.
    dialogsInBody: false,
    dialogsFade: false,
    maximumImageFileSize: null,
    acceptImageFileTypes: "image/*",
    allowClipboardImagePasting: true,
    callbacks: {
      onBeforeCommand: null,
      onBlur: null,
      onBlurCodeview: null,
      onChange: null,
      onChangeCodeview: null,
      onDialogShown: null,
      onEnter: null,
      onFocus: null,
      onImageLinkInsert: null,
      onImageUpload: null,
      onImageUploadError: null,
      onInit: null,
      onKeydown: null,
      onKeyup: null,
      onMousedown: null,
      onMouseup: null,
      onPaste: null,
      onScroll: null
    },
    codemirror: {
      mode: 'text/html',
      htmlMode: true,
      lineNumbers: true
    },
    codeviewFilter: true,
    codeviewFilterRegex: /<\/*(?:applet|b(?:ase|gsound|link)|embed|frame(?:set)?|ilayer|l(?:ayer|ink)|meta|object|s(?:cript|tyle)|t(?:itle|extarea)|xml)[^>]*?>/gi,
    codeviewIframeFilter: true,
    codeviewIframeWhitelistSrc: [],
    codeviewIframeWhitelistSrcBase: ['www.youtube.com', 'www.youtube-nocookie.com', 'www.facebook.com', 'vine.co', 'instagram.com', 'player.vimeo.com', 'www.dailymotion.com', 'player.youku.com', 'jumpingbean.tv', 'v.qq.com'],
    keyMap: {
      pc: {
        'ESC': 'escape',
        'ENTER': 'insertParagraph',
        'CTRL+Z': 'undo',
        'CTRL+Y': 'redo',
        'TAB': 'tab',
        'SHIFT+TAB': 'untab',
        'CTRL+B': 'bold',
        'CTRL+I': 'italic',
        'CTRL+U': 'underline',
        'CTRL+SHIFT+S': 'strikethrough',
        'CTRL+BACKSLASH': 'removeFormat',
        'CTRL+SHIFT+L': 'justifyLeft',
        'CTRL+SHIFT+E': 'justifyCenter',
        'CTRL+SHIFT+R': 'justifyRight',
        'CTRL+SHIFT+J': 'justifyFull',
        'CTRL+SHIFT+NUM7': 'insertUnorderedList',
        'CTRL+SHIFT+NUM8': 'insertOrderedList',
        'CTRL+LEFTBRACKET': 'outdent',
        'CTRL+RIGHTBRACKET': 'indent',
        'CTRL+NUM0': 'formatPara',
        'CTRL+NUM1': 'formatH1',
        'CTRL+NUM2': 'formatH2',
        'CTRL+NUM3': 'formatH3',
        'CTRL+NUM4': 'formatH4',
        'CTRL+NUM5': 'formatH5',
        'CTRL+NUM6': 'formatH6',
        'CTRL+ENTER': 'insertHorizontalRule',
        'CTRL+K': 'linkDialog.show'
      },
      mac: {
        'ESC': 'escape',
        'ENTER': 'insertParagraph',
        'CMD+Z': 'undo',
        'CMD+SHIFT+Z': 'redo',
        'TAB': 'tab',
        'SHIFT+TAB': 'untab',
        'CMD+B': 'bold',
        'CMD+I': 'italic',
        'CMD+U': 'underline',
        'CMD+SHIFT+S': 'strikethrough',
        'CMD+BACKSLASH': 'removeFormat',
        'CMD+SHIFT+L': 'justifyLeft',
        'CMD+SHIFT+E': 'justifyCenter',
        'CMD+SHIFT+R': 'justifyRight',
        'CMD+SHIFT+J': 'justifyFull',
        'CMD+SHIFT+NUM7': 'insertUnorderedList',
        'CMD+SHIFT+NUM8': 'insertOrderedList',
        'CMD+LEFTBRACKET': 'outdent',
        'CMD+RIGHTBRACKET': 'indent',
        'CMD+NUM0': 'formatPara',
        'CMD+NUM1': 'formatH1',
        'CMD+NUM2': 'formatH2',
        'CMD+NUM3': 'formatH3',
        'CMD+NUM4': 'formatH4',
        'CMD+NUM5': 'formatH5',
        'CMD+NUM6': 'formatH6',
        'CMD+ENTER': 'insertHorizontalRule',
        'CMD+K': 'linkDialog.show'
      }
    },
    icons: {
      'align': 'note-icon-align',
      'alignCenter': 'note-icon-align-center',
      'alignJustify': 'note-icon-align-justify',
      'alignLeft': 'note-icon-align-left',
      'alignRight': 'note-icon-align-right',
      'rowBelow': 'note-icon-row-below',
      'colBefore': 'note-icon-col-before',
      'colAfter': 'note-icon-col-after',
      'rowAbove': 'note-icon-row-above',
      'rowRemove': 'note-icon-row-remove',
      'colRemove': 'note-icon-col-remove',
      'indent': 'note-icon-align-indent',
      'outdent': 'note-icon-align-outdent',
      'arrowsAlt': 'note-icon-arrows-alt',
      'bold': 'note-icon-bold',
      'caret': 'note-icon-caret',
      'circle': 'note-icon-circle',
      'close': 'note-icon-close',
      'code': 'note-icon-code',
      'eraser': 'note-icon-eraser',
      'floatLeft': 'note-icon-float-left',
      'floatRight': 'note-icon-float-right',
      'font': 'note-icon-font',
      'frame': 'note-icon-frame',
      'italic': 'note-icon-italic',
      'link': 'note-icon-link',
      'unlink': 'note-icon-chain-broken',
      'magic': 'note-icon-magic',
      'menuCheck': 'note-icon-menu-check',
      'minus': 'note-icon-minus',
      'orderedlist': 'note-icon-orderedlist',
      'pencil': 'note-icon-pencil',
      'picture': 'note-icon-picture',
      'question': 'note-icon-question',
      'redo': 'note-icon-redo',
      'rollback': 'note-icon-rollback',
      'square': 'note-icon-square',
      'strikethrough': 'note-icon-strikethrough',
      'subscript': 'note-icon-subscript',
      'superscript': 'note-icon-superscript',
      'table': 'note-icon-table',
      'textHeight': 'note-icon-text-height',
      'trash': 'note-icon-trash',
      'underline': 'note-icon-underline',
      'undo': 'note-icon-undo',
      'unorderedlist': 'note-icon-unorderedlist',
      'video': 'note-icon-video'
    }
  }
});
;// CONCATENATED MODULE: ./src/js/renderer.js
function renderer_typeof(o) { "@babel/helpers - typeof"; return renderer_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, renderer_typeof(o); }
function renderer_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function renderer_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, renderer_toPropertyKey(o.key), o); } }
function renderer_createClass(e, r, t) { return r && renderer_defineProperties(e.prototype, r), t && renderer_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function renderer_toPropertyKey(t) { var i = renderer_toPrimitive(t, "string"); return "symbol" == renderer_typeof(i) ? i : i + ""; }
function renderer_toPrimitive(t, r) { if ("object" != renderer_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != renderer_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var Renderer = /*#__PURE__*/function () {
  function Renderer(markup, children, options, callback) {
    renderer_classCallCheck(this, Renderer);
    this.markup = markup;
    this.children = children;
    this.options = options;
    this.callback = callback;
  }
  return renderer_createClass(Renderer, [{
    key: "render",
    value: function render($parent) {
      var $node = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(this.markup);
      if (this.options && this.options.contents) {
        $node.html(this.options.contents);
      }
      if (this.options && this.options.className) {
        $node.addClass(this.options.className);
      }
      if (this.options && this.options.data) {
        external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().each(this.options.data, function (k, v) {
          $node.attr('data-' + k, v);
        });
      }
      if (this.options && this.options.click) {
        $node.on('click', this.options.click);
      }
      if (this.children) {
        var $container = $node.find('.note-children-container');
        this.children.forEach(function (child) {
          child.render($container.length ? $container : $node);
        });
      }
      if (this.callback) {
        this.callback($node, this.options);
      }
      if (this.options && this.options.callback) {
        this.options.callback($node);
      }
      if ($parent) {
        $parent.append($node);
      }
      return $node;
    }
  }]);
}();
/* harmony default export */ const renderer = ({
  create: function create(markup, callback) {
    return function () {
      var options = renderer_typeof(arguments[1]) === 'object' ? arguments[1] : arguments[0];
      var children = Array.isArray(arguments[0]) ? arguments[0] : [];
      if (options && options.children) {
        children = options.children;
      }
      return new Renderer(markup, children, options, callback);
    };
  }
});
;// CONCATENATED MODULE: ./src/styles/lite/js/TooltipUI.js
function TooltipUI_typeof(o) { "@babel/helpers - typeof"; return TooltipUI_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, TooltipUI_typeof(o); }
function TooltipUI_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function TooltipUI_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, TooltipUI_toPropertyKey(o.key), o); } }
function TooltipUI_createClass(e, r, t) { return r && TooltipUI_defineProperties(e.prototype, r), t && TooltipUI_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function TooltipUI_toPropertyKey(t) { var i = TooltipUI_toPrimitive(t, "string"); return "symbol" == TooltipUI_typeof(i) ? i : i + ""; }
function TooltipUI_toPrimitive(t, r) { if ("object" != TooltipUI_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != TooltipUI_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var TooltipUI = /*#__PURE__*/function () {
  function TooltipUI($node, options) {
    TooltipUI_classCallCheck(this, TooltipUI);
    this.$node = $node;
    this.options = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().extend({}, {
      title: '',
      target: options.container,
      trigger: 'hover focus',
      placement: 'bottom'
    }, options);

    // create tooltip node
    this.$tooltip = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(['<div class="note-tooltip">', '<div class="note-tooltip-arrow"></div>', '<div class="note-tooltip-content"></div>', '</div>'].join(''));

    // define event
    if (this.options.trigger !== 'manual') {
      var showCallback = this.show.bind(this);
      var hideCallback = this.hide.bind(this);
      var toggleCallback = this.toggle.bind(this);
      this.options.trigger.split(' ').forEach(function (eventName) {
        if (eventName === 'hover') {
          $node.off('mouseenter mouseleave');
          $node.on('mouseenter', showCallback).on('mouseleave', hideCallback);
        } else if (eventName === 'click') {
          $node.on('click', toggleCallback);
        } else if (eventName === 'focus') {
          $node.on('focus', showCallback).on('blur', hideCallback);
        }
      });
    }
  }
  return TooltipUI_createClass(TooltipUI, [{
    key: "show",
    value: function show() {
      var $node = this.$node;
      var offset = $node.offset();
      var targetOffset = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(this.options.target).offset();
      offset.top -= targetOffset.top;
      offset.left -= targetOffset.left;
      var $tooltip = this.$tooltip;
      var title = this.options.title || $node.attr('title') || $node.data('title');
      var placement = this.options.placement || $node.data('placement');
      $tooltip.addClass(placement);
      $tooltip.find('.note-tooltip-content').text(title);
      $tooltip.appendTo(this.options.target);
      var nodeWidth = $node.outerWidth();
      var nodeHeight = $node.outerHeight();
      var tooltipWidth = $tooltip.outerWidth();
      var tooltipHeight = $tooltip.outerHeight();
      if (placement === 'bottom') {
        $tooltip.css({
          top: offset.top + nodeHeight,
          left: offset.left + (nodeWidth / 2 - tooltipWidth / 2)
        });
      } else if (placement === 'top') {
        $tooltip.css({
          top: offset.top - tooltipHeight,
          left: offset.left + (nodeWidth / 2 - tooltipWidth / 2)
        });
      } else if (placement === 'left') {
        $tooltip.css({
          top: offset.top + (nodeHeight / 2 - tooltipHeight / 2),
          left: offset.left - tooltipWidth
        });
      } else if (placement === 'right') {
        $tooltip.css({
          top: offset.top + (nodeHeight / 2 - tooltipHeight / 2),
          left: offset.left + nodeWidth
        });
      }
      $tooltip.addClass('in');
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this = this;
      this.$tooltip.removeClass('in');
      setTimeout(function () {
        _this.$tooltip.remove();
      }, 200);
    }
  }, {
    key: "toggle",
    value: function toggle() {
      if (this.$tooltip.hasClass('in')) {
        this.hide();
      } else {
        this.show();
      }
    }
  }]);
}();
/* harmony default export */ const js_TooltipUI = (TooltipUI);
;// CONCATENATED MODULE: ./src/styles/lite/js/DropdownUI.js
function DropdownUI_typeof(o) { "@babel/helpers - typeof"; return DropdownUI_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, DropdownUI_typeof(o); }
function DropdownUI_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function DropdownUI_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, DropdownUI_toPropertyKey(o.key), o); } }
function DropdownUI_createClass(e, r, t) { return r && DropdownUI_defineProperties(e.prototype, r), t && DropdownUI_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function DropdownUI_toPropertyKey(t) { var i = DropdownUI_toPrimitive(t, "string"); return "symbol" == DropdownUI_typeof(i) ? i : i + ""; }
function DropdownUI_toPrimitive(t, r) { if ("object" != DropdownUI_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != DropdownUI_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var DropdownUI = /*#__PURE__*/function () {
  function DropdownUI($node, options) {
    DropdownUI_classCallCheck(this, DropdownUI);
    this.$button = $node;
    this.options = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().extend({}, {
      target: options.container
    }, options);
    this.setEvent();
  }
  return DropdownUI_createClass(DropdownUI, [{
    key: "setEvent",
    value: function setEvent() {
      var _this = this;
      this.$button.on('click', function (e) {
        _this.toggle();
        e.stopImmediatePropagation();
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      var $parent = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('.note-btn-group.open');
      $parent.find('.note-btn.active').removeClass('active');
      $parent.removeClass('open');
    }
  }, {
    key: "show",
    value: function show() {
      this.$button.addClass('active');
      this.$button.parent().addClass('open');
      var $dropdown = this.$button.next();
      var offset = $dropdown.offset();
      var width = $dropdown.outerWidth();
      var windowWidth = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(window).width();
      var targetMarginRight = parseFloat(external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(this.options.target).css('margin-right'));
      if (offset.left + width > windowWidth - targetMarginRight) {
        $dropdown.css('margin-left', windowWidth - targetMarginRight - (offset.left + width));
      } else {
        $dropdown.css('margin-left', '');
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      this.$button.removeClass('active');
      this.$button.parent().removeClass('open');
    }
  }, {
    key: "toggle",
    value: function toggle() {
      var isOpened = this.$button.parent().hasClass('open');
      this.clear();
      if (isOpened) {
        this.hide();
      } else {
        this.show();
      }
    }
  }]);
}();
external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(document).on('click.note-dropdown-menu', function (e) {
  if (!external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(e.target).closest('.note-btn-group').length) {
    external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('.note-btn-group.open .note-btn.active').removeClass('active');
    external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('.note-btn-group.open').removeClass('open');
  }
});
external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(document).on('click.note-dropdown-menu', function (e) {
  external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(e.target).closest('.note-dropdown-menu').parent().removeClass('open');
  external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(e.target).closest('.note-dropdown-menu').parent().find('.note-btn.active').removeClass('active');
});
/* harmony default export */ const js_DropdownUI = (DropdownUI);
;// CONCATENATED MODULE: ./src/styles/lite/js/ModalUI.js
function ModalUI_typeof(o) { "@babel/helpers - typeof"; return ModalUI_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, ModalUI_typeof(o); }
function ModalUI_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function ModalUI_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, ModalUI_toPropertyKey(o.key), o); } }
function ModalUI_createClass(e, r, t) { return r && ModalUI_defineProperties(e.prototype, r), t && ModalUI_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function ModalUI_toPropertyKey(t) { var i = ModalUI_toPrimitive(t, "string"); return "symbol" == ModalUI_typeof(i) ? i : i + ""; }
function ModalUI_toPrimitive(t, r) { if ("object" != ModalUI_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != ModalUI_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var ModalUI = /*#__PURE__*/function () {
  function ModalUI($node /*, options */) {
    ModalUI_classCallCheck(this, ModalUI);
    this.$modal = $node;
    this.$backdrop = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<div class="note-modal-backdrop"></div>');
  }
  return ModalUI_createClass(ModalUI, [{
    key: "show",
    value: function show() {
      var _this = this;
      this.$backdrop.appendTo(document.body).show();
      this.$modal.addClass('open').show();
      this.$modal.trigger('note.modal.show');
      this.$modal.off('click', '.close').on('click', '.close', this.hide.bind(this));
      this.$modal.on('keydown', function (event) {
        if (event.which === 27) {
          event.preventDefault();
          _this.hide();
        }
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      this.$modal.removeClass('open').hide();
      this.$backdrop.hide();
      this.$modal.trigger('note.modal.hide');
      this.$modal.off('keydown');
    }
  }]);
}();
/* harmony default export */ const js_ModalUI = (ModalUI);
;// CONCATENATED MODULE: ./src/styles/lite/summernote-lite.js







var editor = renderer.create('<div class="note-editor note-frame"></div>');
var toolbar = renderer.create('<div class="note-toolbar" role="toolbar"></div>');
var editingArea = renderer.create('<div class="note-editing-area"></div>');
var codable = renderer.create('<textarea class="note-codable" aria-multiline="true"></textarea>');
var editable = renderer.create('<div class="note-editable" contentEditable="true" role="textbox" aria-multiline="true"></div>');
var statusbar = renderer.create(['<output class="note-status-output" role="status" aria-live="polite"></output>', '<div class="note-statusbar" role="status">', '<div class="note-resizebar" aria-label="resize">', '<div class="note-icon-bar"></div>', '<div class="note-icon-bar"></div>', '<div class="note-icon-bar"></div>', '</div>', '</div>'].join(''));
var airEditor = renderer.create('<div class="note-editor note-airframe"></div>');
var airEditable = renderer.create(['<div class="note-editable" contentEditable="true" role="textbox" aria-multiline="true"></div>', '<output class="note-status-output" role="status" aria-live="polite"></output>'].join(''));
var buttonGroup = renderer.create('<div class="note-btn-group"></div>');
var summernote_lite_button = renderer.create('<button type="button" class="note-btn" tabindex="-1"></button>', function ($node, options) {
  // set button type
  if (options && options.tooltip) {
    $node.attr({
      'aria-label': options.tooltip
    });
    $node.data('_lite_tooltip', new js_TooltipUI($node, {
      title: options.tooltip,
      container: options.container
    })).on('click', function (e) {
      external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(e.currentTarget).data('_lite_tooltip').hide();
    });
  }
  if (options.contents) {
    $node.html(options.contents);
  }
  if (options && options.data && options.data.toggle === 'dropdown') {
    $node.data('_lite_dropdown', new js_DropdownUI($node, {
      container: options.container
    }));
  }
  if (options && options.codeviewKeepButton) {
    $node.addClass('note-codeview-keep');
  }
});
var dropdown = renderer.create('<div class="note-dropdown-menu" role="list"></div>', function ($node, options) {
  var markup = Array.isArray(options.items) ? options.items.map(function (item) {
    var value = typeof item === 'string' ? item : item.value || '';
    var content = options.template ? options.template(item) : item;
    var $temp = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<a class="note-dropdown-item" href="#" data-value="' + value + '" role="listitem" aria-label="' + value + '"></a>');
    $temp.html(content).data('item', item);
    return $temp;
  }) : options.items;
  $node.html(markup).attr({
    'aria-label': options.title
  });
  $node.on('click', '> .note-dropdown-item', function (e) {
    var $a = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(this);
    var item = $a.data('item');
    var value = $a.data('value');
    if (item.click) {
      item.click($a);
    } else if (options.itemClick) {
      options.itemClick(e, item, value);
    }
  });
  if (options && options.codeviewKeepButton) {
    $node.addClass('note-codeview-keep');
  }
});
var dropdownCheck = renderer.create('<div class="note-dropdown-menu note-check" role="list"></div>', function ($node, options) {
  var markup = Array.isArray(options.items) ? options.items.map(function (item) {
    var value = typeof item === 'string' ? item : item.value || '';
    var content = options.template ? options.template(item) : item;
    var $temp = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()('<a class="note-dropdown-item" href="#" data-value="' + value + '" role="listitem" aria-label="' + item + '"></a>');
    $temp.html([icon(options.checkClassName), ' ', content]).data('item', item);
    return $temp;
  }) : options.items;
  $node.html(markup).attr({
    'aria-label': options.title
  });
  $node.on('click', '> .note-dropdown-item', function (e) {
    var $a = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(this);
    var item = $a.data('item');
    var value = $a.data('value');
    if (item.click) {
      item.click($a);
    } else if (options.itemClick) {
      options.itemClick(e, item, value);
    }
  });
  if (options && options.codeviewKeepButton) {
    $node.addClass('note-codeview-keep');
  }
});
var dropdownButtonContents = function dropdownButtonContents(contents, options) {
  return contents + ' ' + icon(options.icons.caret, 'span');
};
var dropdownButton = function dropdownButton(opt, callback) {
  return buttonGroup([summernote_lite_button({
    className: 'dropdown-toggle',
    contents: opt.title + ' ' + icon('note-icon-caret'),
    tooltip: opt.tooltip,
    data: {
      toggle: 'dropdown'
    }
  }), dropdown({
    className: opt.className,
    items: opt.items,
    template: opt.template,
    itemClick: opt.itemClick
  })], {
    callback: callback
  }).render();
};
var dropdownCheckButton = function dropdownCheckButton(opt, callback) {
  return buttonGroup([summernote_lite_button({
    className: 'dropdown-toggle',
    contents: opt.title + ' ' + icon('note-icon-caret'),
    tooltip: opt.tooltip,
    data: {
      toggle: 'dropdown'
    }
  }), dropdownCheck({
    className: opt.className,
    checkClassName: opt.checkClassName,
    items: opt.items,
    template: opt.template,
    itemClick: opt.itemClick
  })], {
    callback: callback
  }).render();
};
var paragraphDropdownButton = function paragraphDropdownButton(opt) {
  return buttonGroup([summernote_lite_button({
    className: 'dropdown-toggle',
    contents: opt.title + ' ' + icon('note-icon-caret'),
    tooltip: opt.tooltip,
    data: {
      toggle: 'dropdown'
    }
  }), dropdown([buttonGroup({
    className: 'note-align',
    children: opt.items[0]
  }), buttonGroup({
    className: 'note-list',
    children: opt.items[1]
  })])]).render();
};
var tableMoveHandler = function tableMoveHandler(event, col, row) {
  var PX_PER_EM = 18;
  var $picker = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(event.target.parentNode); // target is mousecatcher
  var $dimensionDisplay = $picker.next();
  var $catcher = $picker.find('.note-dimension-picker-mousecatcher');
  var $highlighted = $picker.find('.note-dimension-picker-highlighted');
  var $unhighlighted = $picker.find('.note-dimension-picker-unhighlighted');
  var posOffset;
  // HTML5 with jQuery - e.offsetX is undefined in Firefox
  if (event.offsetX === undefined) {
    var posCatcher = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(event.target).offset();
    posOffset = {
      x: event.pageX - posCatcher.left,
      y: event.pageY - posCatcher.top
    };
  } else {
    posOffset = {
      x: event.offsetX,
      y: event.offsetY
    };
  }
  var dim = {
    c: Math.ceil(posOffset.x / PX_PER_EM) || 1,
    r: Math.ceil(posOffset.y / PX_PER_EM) || 1
  };
  $highlighted.css({
    width: dim.c + 'em',
    height: dim.r + 'em'
  });
  $catcher.data('value', dim.c + 'x' + dim.r);
  if (dim.c > 3 && dim.c < col) {
    $unhighlighted.css({
      width: dim.c + 1 + 'em'
    });
  }
  if (dim.r > 3 && dim.r < row) {
    $unhighlighted.css({
      height: dim.r + 1 + 'em'
    });
  }
  $dimensionDisplay.html(dim.c + ' x ' + dim.r);
};
var tableDropdownButton = function tableDropdownButton(opt) {
  return buttonGroup([summernote_lite_button({
    className: 'dropdown-toggle',
    contents: opt.title + ' ' + icon('note-icon-caret'),
    tooltip: opt.tooltip,
    data: {
      toggle: 'dropdown'
    }
  }), dropdown({
    className: 'note-table',
    items: ['<div class="note-dimension-picker">', '<div class="note-dimension-picker-mousecatcher" data-event="insertTable" data-value="1x1"></div>', '<div class="note-dimension-picker-highlighted"></div>', '<div class="note-dimension-picker-unhighlighted"></div>', '</div>', '<div class="note-dimension-display">1 x 1</div>'].join('')
  })], {
    callback: function callback($node) {
      var $catcher = $node.find('.note-dimension-picker-mousecatcher');
      $catcher.css({
        width: opt.col + 'em',
        height: opt.row + 'em'
      }).on('mouseup', opt.itemClick).on('mousemove', function (e) {
        tableMoveHandler(e, opt.col, opt.row);
      });
    }
  }).render();
};
var palette = renderer.create('<div class="note-color-palette"></div>', function ($node, options) {
  var contents = [];
  for (var row = 0, rowSize = options.colors.length; row < rowSize; row++) {
    var eventName = options.eventName;
    var colors = options.colors[row];
    var colorsName = options.colorsName[row];
    var buttons = [];
    for (var col = 0, colSize = colors.length; col < colSize; col++) {
      var color = colors[col];
      var colorName = colorsName[col];
      buttons.push(['<button type="button" class="note-btn note-color-btn"', 'style="background-color:', color, '" ', 'data-event="', eventName, '" ', 'data-value="', color, '" ', 'data-title="', colorName, '" ', 'aria-label="', colorName, '" ', 'data-toggle="button" tabindex="-1"></button>'].join(''));
    }
    contents.push('<div class="note-color-row">' + buttons.join('') + '</div>');
  }
  $node.html(contents.join(''));
  $node.find('.note-color-btn').each(function () {
    external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(this).data('_lite_tooltip', new js_TooltipUI(external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(this), {
      container: options.container
    }));
  });
});
var colorDropdownButton = function colorDropdownButton(opt, type) {
  return buttonGroup({
    className: 'note-color',
    children: [summernote_lite_button({
      className: 'note-current-color-button',
      contents: opt.title,
      tooltip: opt.lang.color.recent,
      click: opt.currentClick,
      callback: function callback($button) {
        var $recentColor = $button.find('.note-recent-color');
        if (type !== 'foreColor') {
          $recentColor.css('background-color', '#FFFF00');
          $button.attr('data-backColor', '#FFFF00');
        }
      }
    }), summernote_lite_button({
      className: 'dropdown-toggle',
      contents: icon('note-icon-caret'),
      tooltip: opt.lang.color.more,
      data: {
        toggle: 'dropdown'
      }
    }), dropdown({
      items: ['<div>', '<div class="note-btn-group btn-background-color">', '<div class="note-palette-title">' + opt.lang.color.background + '</div>', '<div>', '<button type="button" class="note-color-reset note-btn note-btn-block" data-event="backColor" data-value="transparent">', opt.lang.color.transparent, '</button>', '</div>', '<div class="note-holder" data-event="backColor"></div>', '<div class="btn-sm">', '<input type="color" id="html5bcp" class="note-btn btn-default" value="#21104A" style="width:100%;" data-value="cp">', '<button type="button" class="note-color-reset btn" data-event="backColor" data-value="cpbackColor">', opt.lang.color.cpSelect, '</button>', '</div>', '</div>', '<div class="note-btn-group btn-foreground-color">', '<div class="note-palette-title">' + opt.lang.color.foreground + '</div>', '<div>', '<button type="button" class="note-color-reset note-btn note-btn-block" data-event="removeFormat" data-value="foreColor">', opt.lang.color.resetToDefault, '</button>', '</div>', '<div class="note-holder" data-event="foreColor"></div>', '<div class="btn-sm">', '<input type="color" id="html5fcp" class="note-btn btn-default" value="#21104A" style="width:100%;" data-value="cp">', '<button type="button" class="note-color-reset btn" data-event="foreColor" data-value="cpforeColor">', opt.lang.color.cpSelect, '</button>', '</div>', '</div>', '</div>'].join(''),
      callback: function callback($dropdown) {
        $dropdown.find('.note-holder').each(function () {
          var $holder = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(this);
          $holder.append(palette({
            colors: opt.colors,
            eventName: $holder.data('event')
          }).render());
        });
        if (type === 'fore') {
          $dropdown.find('.btn-background-color').hide();
          $dropdown.css({
            'min-width': '210px'
          });
        } else if (type === 'back') {
          $dropdown.find('.btn-foreground-color').hide();
          $dropdown.css({
            'min-width': '210px'
          });
        }
      },
      click: function click(event) {
        var $button = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()(event.target);
        var eventName = $button.data('event');
        var value = $button.data('value');
        var foreinput = document.getElementById('html5fcp').value;
        var backinput = document.getElementById('html5bcp').value;
        if (value === 'cp') {
          event.stopPropagation();
        } else if (value === 'cpbackColor') {
          value = backinput;
        } else if (value === 'cpforeColor') {
          value = foreinput;
        }
        if (eventName && value) {
          var key = eventName === 'backColor' ? 'background-color' : 'color';
          var $color = $button.closest('.note-color').find('.note-recent-color');
          var $currentButton = $button.closest('.note-color').find('.note-current-color-button');
          $color.css(key, value);
          $currentButton.attr('data-' + eventName, value);
          if (type === 'fore') {
            opt.itemClick('foreColor', value);
          } else if (type === 'back') {
            opt.itemClick('backColor', value);
          } else {
            opt.itemClick(eventName, value);
          }
        }
      }
    })]
  }).render();
};
var dialog = renderer.create('<div class="note-modal" aria-hidden="false" tabindex="-1" role="dialog"></div>', function ($node, options) {
  if (options.fade) {
    $node.addClass('fade');
  }
  $node.attr({
    'aria-label': options.title
  });
  $node.html(['<div class="note-modal-content">', options.title ? '<div class="note-modal-header"><button type="button" class="close" aria-label="Close" aria-hidden="true"><i class="note-icon-close"></i></button><h4 class="note-modal-title">' + options.title + '</h4></div>' : '', '<div class="note-modal-body">' + options.body + '</div>', options.footer ? '<div class="note-modal-footer">' + options.footer + '</div>' : '', '</div>'].join(''));
  $node.data('modal', new js_ModalUI($node, options));
});
var videoDialog = function videoDialog(opt) {
  var body = '<div class="note-form-group">' + '<label for="note-dialog-video-url-' + opt.id + '" class="note-form-label">' + opt.lang.video.url + ' <small class="text-muted">' + opt.lang.video.providers + '</small></label>' + '<input id="note-dialog-video-url-' + opt.id + '" class="note-video-url note-input" type="text"/>' + '</div>';
  var footer = ['<button type="button" href="#" class="note-btn note-btn-primary note-video-btn disabled" disabled>', opt.lang.video.insert, '</button>'].join('');
  return dialog({
    title: opt.lang.video.insert,
    fade: opt.fade,
    body: body,
    footer: footer
  }).render();
};
var imageDialog = function imageDialog(opt) {
  var body = '<div class="note-form-group note-group-select-from-files">' + '<label for="note-dialog-image-file-' + opt.id + '" class="note-form-label">' + opt.lang.image.selectFromFiles + '</label>' + '<input id="note-dialog-image-file-' + opt.id + '" class="note-note-image-input note-input" type="file" name="files" accept="image/*" multiple="multiple"/>' + opt.imageLimitation + '</div>' + '<div class="note-form-group">' + '<label for="note-dialog-image-url-' + opt.id + '" class="note-form-label">' + opt.lang.image.url + '</label>' + '<input id="note-dialog-image-url-' + opt.id + '" class="note-image-url note-input" type="text"/>' + '</div>';
  var footer = ['<button href="#" type="button" class="note-btn note-btn-primary note-btn-large note-image-btn disabled" disabled>', opt.lang.image.insert, '</button>'].join('');
  return dialog({
    title: opt.lang.image.insert,
    fade: opt.fade,
    body: body,
    footer: footer
  }).render();
};
var linkDialog = function linkDialog(opt) {
  var body = '<div class="note-form-group">' + '<label for="note-dialog-link-txt-' + opt.id + '" class="note-form-label">' + opt.lang.link.textToDisplay + '</label>' + '<input id="note-dialog-link-txt-' + opt.id + '" class="note-link-text note-input" type="text"/>' + '</div>' + '<div class="note-form-group">' + '<label for="note-dialog-link-url-' + opt.id + '" class="note-form-label">' + opt.lang.link.url + '</label>' + '<input id="note-dialog-link-url-' + opt.id + '" class="note-link-url note-input" type="text" value="http://"/>' + '</div>' + (!opt.disableLinkTarget ? '<div class="checkbox"><label for="note-dialog-link-nw-' + opt.id + '"><input id="note-dialog-link-nw-' + opt.id + '" type="checkbox" checked> ' + opt.lang.link.openInNewWindow + '</label></div>' : '');
  var footer = ['<button href="#" type="button" class="note-btn note-btn-primary note-link-btn disabled" disabled>', opt.lang.link.insert, '</button>'].join('');
  return dialog({
    className: 'link-dialog',
    title: opt.lang.link.insert,
    fade: opt.fade,
    body: body,
    footer: footer
  }).render();
};
var popover = renderer.create(['<div class="note-popover bottom">', '<div class="note-popover-arrow"></div>', '<div class="popover-content note-children-container"></div>', '</div>'].join(''), function ($node, options) {
  var direction = typeof options.direction !== 'undefined' ? options.direction : 'bottom';
  $node.addClass(direction).hide();
  if (options.hideArrow) {
    $node.find('.note-popover-arrow').hide();
  }
});
var summernote_lite_checkbox = renderer.create('<div class="checkbox"></div>', function ($node, options) {
  $node.html(['<label' + (options.id ? ' for="note-' + options.id + '"' : '') + '>', '<input role="checkbox" type="checkbox"' + (options.id ? ' id="note-' + options.id + '"' : ''), options.checked ? ' checked' : '', ' aria-checked="' + (options.checked ? 'true' : 'false') + '"/>', options.text ? options.text : '', '</label>'].join(''));
});
var icon = function icon(iconClassName, tagName) {
  if (iconClassName.match(/^</)) {
    return iconClassName;
  }
  tagName = tagName || 'i';
  return '<' + tagName + ' class="' + iconClassName + '"></' + tagName + '>';
};
var ui = function ui(editorOptions) {
  return {
    editor: editor,
    toolbar: toolbar,
    editingArea: editingArea,
    codable: codable,
    editable: editable,
    statusbar: statusbar,
    airEditor: airEditor,
    airEditable: airEditable,
    buttonGroup: buttonGroup,
    button: summernote_lite_button,
    dropdown: dropdown,
    dropdownCheck: dropdownCheck,
    dropdownButton: dropdownButton,
    dropdownButtonContents: dropdownButtonContents,
    dropdownCheckButton: dropdownCheckButton,
    paragraphDropdownButton: paragraphDropdownButton,
    tableDropdownButton: tableDropdownButton,
    colorDropdownButton: colorDropdownButton,
    palette: palette,
    dialog: dialog,
    videoDialog: videoDialog,
    imageDialog: imageDialog,
    linkDialog: linkDialog,
    popover: popover,
    checkbox: summernote_lite_checkbox,
    icon: icon,
    options: editorOptions,
    toggleBtn: function toggleBtn($btn, isEnable) {
      $btn.toggleClass('disabled', !isEnable);
      $btn.attr('disabled', !isEnable);
    },
    toggleBtnActive: function toggleBtnActive($btn, isActive) {
      $btn.toggleClass('active', isActive);
    },
    check: function check($dom, value) {
      $dom.find('.checked').removeClass('checked');
      $dom.find('[data-value="' + value + '"]').addClass('checked');
    },
    onDialogShown: function onDialogShown($dialog, handler) {
      $dialog.one('note.modal.show', handler);
    },
    onDialogHidden: function onDialogHidden($dialog, handler) {
      $dialog.one('note.modal.hide', handler);
    },
    showDialog: function showDialog($dialog) {
      $dialog.data('modal').show();
    },
    hideDialog: function hideDialog($dialog) {
      $dialog.data('modal').hide();
    },
    /**
     * get popover content area
     *
     * @param $popover
     * @returns {*}
     */
    getPopoverContent: function getPopoverContent($popover) {
      return $popover.find('.note-popover-content');
    },
    /**
     * get dialog's body area
     *
     * @param $dialog
     * @returns {*}
     */
    getDialogBody: function getDialogBody($dialog) {
      return $dialog.find('.note-modal-body');
    },
    createLayout: function createLayout($note) {
      var $editor = (editorOptions.airMode ? airEditor([editingArea([codable(), airEditable()])]) : editorOptions.toolbarPosition === 'bottom' ? editor([editingArea([codable(), editable()]), toolbar(), statusbar()]) : editor([toolbar(), editingArea([codable(), editable()]), statusbar()])).render();
      $editor.insertAfter($note);
      return {
        note: $note,
        editor: $editor,
        toolbar: $editor.find('.note-toolbar'),
        editingArea: $editor.find('.note-editing-area'),
        editable: $editor.find('.note-editable'),
        codable: $editor.find('.note-codable'),
        statusbar: $editor.find('.note-statusbar')
      };
    },
    removeLayout: function removeLayout($note, layoutInfo) {
      $note.html(layoutInfo.editable.html());
      layoutInfo.editor.remove();
      $note.off('summernote'); // remove summernote custom event
      $note.show();
    }
  };
};
(external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote = external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default().extend((external_root_jQuery_commonjs_jquery_commonjs2_jquery_amd_jquery_default()).summernote, {
  ui_template: ui,
  "interface": 'lite'
});
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=summernote-lite.js.map
/*!
 * ApexCharts v3.54.1
 * (c) 2018-2024 ApexCharts
 * Released under the MIT License.
 */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).ApexCharts=e()}(this,(function(){"use strict";function t(t,e){(null==e||e>t.length)&&(e=t.length);for(var i=0,a=Array(e);i<e;i++)a[i]=t[i];return a}function e(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function a(t,e){for(var i=0;i<e.length;i++){var a=e[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(t,x(a.key),a)}}function s(t,e,i){return e&&a(t.prototype,e),i&&a(t,i),Object.defineProperty(t,"prototype",{writable:!1}),t}function r(t,e){var i="undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(!i){if(Array.isArray(t)||(i=v(t))||e&&t&&"number"==typeof t.length){i&&(t=i);var a=0,s=function(){};return{s:s,n:function(){return a>=t.length?{done:!0}:{done:!1,value:t[a++]}},e:function(t){throw t},f:s}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var r,o=!0,n=!1;return{s:function(){i=i.call(t)},n:function(){var t=i.next();return o=t.done,t},e:function(t){n=!0,r=t},f:function(){try{o||null==i.return||i.return()}finally{if(n)throw r}}}}function o(t){var i=c();return function(){var a,s=l(t);if(i){var r=l(this).constructor;a=Reflect.construct(s,arguments,r)}else a=s.apply(this,arguments);return function(t,i){if(i&&("object"==typeof i||"function"==typeof i))return i;if(void 0!==i)throw new TypeError("Derived constructors may only return object or undefined");return e(t)}(this,a)}}function n(t,e,i){return(e=x(e))in t?Object.defineProperty(t,e,{value:i,enumerable:!0,configurable:!0,writable:!0}):t[e]=i,t}function l(t){return l=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)},l(t)}function h(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&u(t,e)}function c(){try{var t=!Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){})))}catch(t){}return(c=function(){return!!t})()}function d(t,e){var i=Object.keys(t);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(t);e&&(a=a.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),i.push.apply(i,a)}return i}function g(t){for(var e=1;e<arguments.length;e++){var i=null!=arguments[e]?arguments[e]:{};e%2?d(Object(i),!0).forEach((function(e){n(t,e,i[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(i)):d(Object(i)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(i,e))}))}return t}function u(t,e){return u=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t},u(t,e)}function f(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var i=null==t?null:"undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(null!=i){var a,s,r,o,n=[],l=!0,h=!1;try{if(r=(i=i.call(t)).next,0===e){if(Object(i)!==i)return;l=!1}else for(;!(l=(a=r.call(i)).done)&&(n.push(a.value),n.length!==e);l=!0);}catch(t){h=!0,s=t}finally{try{if(!l&&null!=i.return&&(o=i.return(),Object(o)!==o))return}finally{if(h)throw s}}return n}}(t,e)||v(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function p(e){return function(e){if(Array.isArray(e))return t(e)}(e)||function(t){if("undefined"!=typeof Symbol&&null!=t[Symbol.iterator]||null!=t["@@iterator"])return Array.from(t)}(e)||v(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function x(t){var e=function(t,e){if("object"!=typeof t||!t)return t;var i=t[Symbol.toPrimitive];if(void 0!==i){var a=i.call(t,e||"default");if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===e?String:Number)(t)}(t,"string");return"symbol"==typeof e?e:e+""}function b(t){return b="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},b(t)}function v(e,i){if(e){if("string"==typeof e)return t(e,i);var a={}.toString.call(e).slice(8,-1);return"Object"===a&&e.constructor&&(a=e.constructor.name),"Map"===a||"Set"===a?Array.from(e):"Arguments"===a||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)?t(e,i):void 0}}var m=function(){function t(){i(this,t)}return s(t,[{key:"shadeRGBColor",value:function(t,e){var i=e.split(","),a=t<0?0:255,s=t<0?-1*t:t,r=parseInt(i[0].slice(4),10),o=parseInt(i[1],10),n=parseInt(i[2],10);return"rgb("+(Math.round((a-r)*s)+r)+","+(Math.round((a-o)*s)+o)+","+(Math.round((a-n)*s)+n)+")"}},{key:"shadeHexColor",value:function(t,e){var i=parseInt(e.slice(1),16),a=t<0?0:255,s=t<0?-1*t:t,r=i>>16,o=i>>8&255,n=255&i;return"#"+(16777216+65536*(Math.round((a-r)*s)+r)+256*(Math.round((a-o)*s)+o)+(Math.round((a-n)*s)+n)).toString(16).slice(1)}},{key:"shadeColor",value:function(e,i){return t.isColorHex(i)?this.shadeHexColor(e,i):this.shadeRGBColor(e,i)}}],[{key:"bind",value:function(t,e){return function(){return t.apply(e,arguments)}}},{key:"isObject",value:function(t){return t&&"object"===b(t)&&!Array.isArray(t)&&null!=t}},{key:"is",value:function(t,e){return Object.prototype.toString.call(e)==="[object "+t+"]"}},{key:"listToArray",value:function(t){var e,i=[];for(e=0;e<t.length;e++)i[e]=t[e];return i}},{key:"extend",value:function(t,e){var i=this;"function"!=typeof Object.assign&&(Object.assign=function(t){if(null==t)throw new TypeError("Cannot convert undefined or null to object");for(var e=Object(t),i=1;i<arguments.length;i++){var a=arguments[i];if(null!=a)for(var s in a)a.hasOwnProperty(s)&&(e[s]=a[s])}return e});var a=Object.assign({},t);return this.isObject(t)&&this.isObject(e)&&Object.keys(e).forEach((function(s){i.isObject(e[s])&&s in t?a[s]=i.extend(t[s],e[s]):Object.assign(a,n({},s,e[s]))})),a}},{key:"extendArray",value:function(e,i){var a=[];return e.map((function(e){a.push(t.extend(i,e))})),e=a}},{key:"monthMod",value:function(t){return t%12}},{key:"clone",value:function(e){if(t.is("Array",e)){for(var i=[],a=0;a<e.length;a++)i[a]=this.clone(e[a]);return i}if(t.is("Null",e))return null;if(t.is("Date",e))return e;if("object"===b(e)){var s={};for(var r in e)e.hasOwnProperty(r)&&(s[r]=this.clone(e[r]));return s}return e}},{key:"log10",value:function(t){return Math.log(t)/Math.LN10}},{key:"roundToBase10",value:function(t){return Math.pow(10,Math.floor(Math.log10(t)))}},{key:"roundToBase",value:function(t,e){return Math.pow(e,Math.floor(Math.log(t)/Math.log(e)))}},{key:"parseNumber",value:function(t){return null===t?t:parseFloat(t)}},{key:"stripNumber",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:2;return Number.isInteger(t)?t:parseFloat(t.toPrecision(e))}},{key:"randomId",value:function(){return(Math.random()+1).toString(36).substring(4)}},{key:"noExponents",value:function(t){var e=String(t).split(/[eE]/);if(1===e.length)return e[0];var i="",a=t<0?"-":"",s=e[0].replace(".",""),r=Number(e[1])+1;if(r<0){for(i=a+"0.";r++;)i+="0";return i+s.replace(/^-/,"")}for(r-=s.length;r--;)i+="0";return s+i}},{key:"getDimensions",value:function(t){var e=getComputedStyle(t,null),i=t.clientHeight,a=t.clientWidth;return i-=parseFloat(e.paddingTop)+parseFloat(e.paddingBottom),[a-=parseFloat(e.paddingLeft)+parseFloat(e.paddingRight),i]}},{key:"getBoundingClientRect",value:function(t){var e=t.getBoundingClientRect();return{top:e.top,right:e.right,bottom:e.bottom,left:e.left,width:t.clientWidth,height:t.clientHeight,x:e.left,y:e.top}}},{key:"getLargestStringFromArr",value:function(t){return t.reduce((function(t,e){return Array.isArray(e)&&(e=e.reduce((function(t,e){return t.length>e.length?t:e}))),t.length>e.length?t:e}),0)}},{key:"hexToRgba",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"#999999",e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:.6;"#"!==t.substring(0,1)&&(t="#999999");var i=t.replace("#","");i=i.match(new RegExp("(.{"+i.length/3+"})","g"));for(var a=0;a<i.length;a++)i[a]=parseInt(1===i[a].length?i[a]+i[a]:i[a],16);return void 0!==e&&i.push(e),"rgba("+i.join(",")+")"}},{key:"getOpacityFromRGBA",value:function(t){return parseFloat(t.replace(/^.*,(.+)\)/,"$1"))}},{key:"rgb2hex",value:function(t){return(t=t.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i))&&4===t.length?"#"+("0"+parseInt(t[1],10).toString(16)).slice(-2)+("0"+parseInt(t[2],10).toString(16)).slice(-2)+("0"+parseInt(t[3],10).toString(16)).slice(-2):""}},{key:"isColorHex",value:function(t){return/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)|(^#[0-9A-F]{8}$)/i.test(t)}},{key:"getPolygonPos",value:function(t,e){for(var i=[],a=2*Math.PI/e,s=0;s<e;s++){var r={};r.x=t*Math.sin(s*a),r.y=-t*Math.cos(s*a),i.push(r)}return i}},{key:"polarToCartesian",value:function(t,e,i,a){var s=(a-90)*Math.PI/180;return{x:t+i*Math.cos(s),y:e+i*Math.sin(s)}}},{key:"escapeString",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"x",i=t.toString().slice();return i=i.replace(/[` ~!@#$%^&*()|+\=?;:'",.<>{}[\]\\/]/gi,e)}},{key:"negToZero",value:function(t){return t<0?0:t}},{key:"moveIndexInArray",value:function(t,e,i){if(i>=t.length)for(var a=i-t.length+1;a--;)t.push(void 0);return t.splice(i,0,t.splice(e,1)[0]),t}},{key:"extractNumber",value:function(t){return parseFloat(t.replace(/[^\d.]*/g,""))}},{key:"findAncestor",value:function(t,e){for(;(t=t.parentElement)&&!t.classList.contains(e););return t}},{key:"setELstyles",value:function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t.style.key=e[i])}},{key:"preciseAddition",value:function(t,e){var i=(String(t).split(".")[1]||"").length,a=(String(e).split(".")[1]||"").length,s=Math.pow(10,Math.max(i,a));return(Math.round(t*s)+Math.round(e*s))/s}},{key:"isNumber",value:function(t){return!isNaN(t)&&parseFloat(Number(t))===t&&!isNaN(parseInt(t,10))}},{key:"isFloat",value:function(t){return Number(t)===t&&t%1!=0}},{key:"isSafari",value:function(){return/^((?!chrome|android).)*safari/i.test(navigator.userAgent)}},{key:"isFirefox",value:function(){return navigator.userAgent.toLowerCase().indexOf("firefox")>-1}},{key:"isMsEdge",value:function(){var t=window.navigator.userAgent,e=t.indexOf("Edge/");return e>0&&parseInt(t.substring(e+5,t.indexOf(".",e)),10)}},{key:"getGCD",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:7,a=Math.pow(10,i-Math.floor(Math.log10(Math.max(t,e))));for(t=Math.round(Math.abs(t)*a),e=Math.round(Math.abs(e)*a);e;){var s=e;e=t%e,t=s}return t/a}},{key:"getPrimeFactors",value:function(t){for(var e=[],i=2;t>=2;)t%i==0?(e.push(i),t/=i):i++;return e}},{key:"mod",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:7,a=Math.pow(10,i-Math.floor(Math.log10(Math.max(t,e))));return(t=Math.round(Math.abs(t)*a))%(e=Math.round(Math.abs(e)*a))/a}}]),t}(),y=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w,this.setEasingFunctions()}return s(t,[{key:"setEasingFunctions",value:function(){var t;if(!this.w.globals.easing){switch(this.w.config.chart.animations.easing){case"linear":t="-";break;case"easein":t="<";break;case"easeout":t=">";break;case"easeinout":default:t="<>";break;case"swing":t=function(t){var e=1.70158;return(t-=1)*t*((e+1)*t+e)+1};break;case"bounce":t=function(t){return t<1/2.75?7.5625*t*t:t<2/2.75?7.5625*(t-=1.5/2.75)*t+.75:t<2.5/2.75?7.5625*(t-=2.25/2.75)*t+.9375:7.5625*(t-=2.625/2.75)*t+.984375};break;case"elastic":t=function(t){return t===!!t?t:Math.pow(2,-10*t)*Math.sin((t-.075)*(2*Math.PI)/.3)+1}}this.w.globals.easing=t}}},{key:"animateLine",value:function(t,e,i,a){t.attr(e).animate(a).attr(i)}},{key:"animateMarker",value:function(t,e,i,a){t.attr({opacity:0}).animate(e,i).attr({opacity:1}).afterAll((function(){a()}))}},{key:"animateRect",value:function(t,e,i,a,s){t.attr(e).animate(a).attr(i).afterAll((function(){return s()}))}},{key:"animatePathsGradually",value:function(t){var e=t.el,i=t.realIndex,a=t.j,s=t.fill,r=t.pathFrom,o=t.pathTo,n=t.speed,l=t.delay,h=this.w,c=0;h.config.chart.animations.animateGradually.enabled&&(c=h.config.chart.animations.animateGradually.delay),h.config.chart.animations.dynamicAnimation.enabled&&h.globals.dataChanged&&"bar"!==h.config.chart.type&&(c=0),this.morphSVG(e,i,a,"line"!==h.config.chart.type||h.globals.comboCharts?s:"stroke",r,o,n,l*c)}},{key:"showDelayedElements",value:function(){this.w.globals.delayedElements.forEach((function(t){var e=t.el;e.classList.remove("apexcharts-element-hidden"),e.classList.add("apexcharts-hidden-element-shown")}))}},{key:"animationCompleted",value:function(t){var e=this.w;e.globals.animationEnded||(e.globals.animationEnded=!0,this.showDelayedElements(),"function"==typeof e.config.chart.events.animationEnd&&e.config.chart.events.animationEnd(this.ctx,{el:t,w:e}))}},{key:"morphSVG",value:function(t,e,i,a,s,r,o,n){var l=this,h=this.w;s||(s=t.attr("pathFrom")),r||(r=t.attr("pathTo"));var c=function(t){return"radar"===h.config.chart.type&&(o=1),"M 0 ".concat(h.globals.gridHeight)};(!s||s.indexOf("undefined")>-1||s.indexOf("NaN")>-1)&&(s=c()),(!r||r.indexOf("undefined")>-1||r.indexOf("NaN")>-1)&&(r=c()),h.globals.shouldAnimate||(o=1),t.plot(s).animate(1,h.globals.easing,n).plot(s).animate(o,h.globals.easing,n).plot(r).afterAll((function(){m.isNumber(i)?i===h.globals.series[h.globals.maxValsInArrayIndex].length-2&&h.globals.shouldAnimate&&l.animationCompleted(t):"none"!==a&&h.globals.shouldAnimate&&(!h.globals.comboCharts&&e===h.globals.series.length-1||h.globals.comboCharts)&&l.animationCompleted(t),l.showDelayedElements()}))}}]),t}(),w=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w}return s(t,[{key:"getDefaultFilter",value:function(t,e){var i=this.w;t.unfilter(!0),(new window.SVG.Filter).size("120%","180%","-5%","-40%"),"none"!==i.config.states.normal.filter?this.applyFilter(t,e,i.config.states.normal.filter.type,i.config.states.normal.filter.value):i.config.chart.dropShadow.enabled&&this.dropShadow(t,i.config.chart.dropShadow,e)}},{key:"addNormalFilter",value:function(t,e){var i=this.w;i.config.chart.dropShadow.enabled&&!t.node.classList.contains("apexcharts-marker")&&this.dropShadow(t,i.config.chart.dropShadow,e)}},{key:"addLightenFilter",value:function(t,e,i){var a=this,s=this.w,r=i.intensity;t.unfilter(!0);new window.SVG.Filter;t.filter((function(t){var i=s.config.chart.dropShadow;(i.enabled?a.addShadow(t,e,i):t).componentTransfer({rgb:{type:"linear",slope:1.5,intercept:r}})})),t.filterer.node.setAttribute("filterUnits","userSpaceOnUse"),this._scaleFilterSize(t.filterer.node)}},{key:"addDarkenFilter",value:function(t,e,i){var a=this,s=this.w,r=i.intensity;t.unfilter(!0);new window.SVG.Filter;t.filter((function(t){var i=s.config.chart.dropShadow;(i.enabled?a.addShadow(t,e,i):t).componentTransfer({rgb:{type:"linear",slope:r}})})),t.filterer.node.setAttribute("filterUnits","userSpaceOnUse"),this._scaleFilterSize(t.filterer.node)}},{key:"applyFilter",value:function(t,e,i){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:.5;switch(i){case"none":this.addNormalFilter(t,e);break;case"lighten":this.addLightenFilter(t,e,{intensity:a});break;case"darken":this.addDarkenFilter(t,e,{intensity:a})}}},{key:"addShadow",value:function(t,e,i){var a,s=this.w,r=i.blur,o=i.top,n=i.left,l=i.color,h=i.opacity;if((null===(a=s.config.chart.dropShadow.enabledOnSeries)||void 0===a?void 0:a.length)>0&&-1===s.config.chart.dropShadow.enabledOnSeries.indexOf(e))return t;var c=t.flood(Array.isArray(l)?l[e]:l,h).composite(t.sourceAlpha,"in").offset(n,o).gaussianBlur(r).merge(t.source);return t.blend(t.source,c)}},{key:"dropShadow",value:function(t,e){var i,a,s=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,r=e.top,o=e.left,n=e.blur,l=e.color,h=e.opacity,c=e.noUserSpaceOnUse,d=this.w;if(t.unfilter(!0),m.isMsEdge()&&"radialBar"===d.config.chart.type)return t;if((null===(i=d.config.chart.dropShadow.enabledOnSeries)||void 0===i?void 0:i.length)>0&&-1===(null===(a=d.config.chart.dropShadow.enabledOnSeries)||void 0===a?void 0:a.indexOf(s)))return t;return l=Array.isArray(l)?l[s]:l,t.filter((function(t){var e=null;e=m.isSafari()||m.isFirefox()||m.isMsEdge()?t.flood(l,h).composite(t.sourceAlpha,"in").offset(o,r).gaussianBlur(n):t.flood(l,h).composite(t.sourceAlpha,"in").offset(o,r).gaussianBlur(n).merge(t.source),t.blend(t.source,e)})),c||t.filterer.node.setAttribute("filterUnits","userSpaceOnUse"),this._scaleFilterSize(t.filterer.node),t}},{key:"setSelectionFilter",value:function(t,e,i){var a=this.w;if(void 0!==a.globals.selectedDataPoints[e]&&a.globals.selectedDataPoints[e].indexOf(i)>-1){t.node.setAttribute("selected",!0);var s=a.config.states.active.filter;"none"!==s&&this.applyFilter(t,e,s.type,s.value)}}},{key:"_scaleFilterSize",value:function(t){!function(e){for(var i in e)e.hasOwnProperty(i)&&t.setAttribute(i,e[i])}({width:"200%",height:"200%",x:"-50%",y:"-50%"})}}]),t}(),k=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w}return s(t,[{key:"roundPathCorners",value:function(t,e){function i(t,e,i){var s=e.x-t.x,r=e.y-t.y,o=Math.sqrt(s*s+r*r);return a(t,e,Math.min(1,i/o))}function a(t,e,i){return{x:t.x+(e.x-t.x)*i,y:t.y+(e.y-t.y)*i}}function s(t,e){t.length>2&&(t[t.length-2]=e.x,t[t.length-1]=e.y)}function r(t){return{x:parseFloat(t[t.length-2]),y:parseFloat(t[t.length-1])}}t.indexOf("NaN")>-1&&(t="");var o=t.split(/[,\s]/).reduce((function(t,e){var i=e.match("([a-zA-Z])(.+)");return i?(t.push(i[1]),t.push(i[2])):t.push(e),t}),[]).reduce((function(t,e){return parseFloat(e)==e&&t.length?t[t.length-1].push(e):t.push([e]),t}),[]),n=[];if(o.length>1){var l=r(o[0]),h=null;"Z"==o[o.length-1][0]&&o[0].length>2&&(h=["L",l.x,l.y],o[o.length-1]=h),n.push(o[0]);for(var c=1;c<o.length;c++){var d=n[n.length-1],g=o[c],u=g==h?o[1]:o[c+1];if(u&&d&&d.length>2&&"L"==g[0]&&u.length>2&&"L"==u[0]){var f,p,x=r(d),b=r(g),v=r(u);f=i(b,x,e),p=i(b,v,e),s(g,f),g.origPoint=b,n.push(g);var m=a(f,b,.5),y=a(b,p,.5),w=["C",m.x,m.y,y.x,y.y,p.x,p.y];w.origPoint=b,n.push(w)}else n.push(g)}if(h){var k=r(n[n.length-1]);n.push(["Z"]),s(n[0],k)}}else n=o;return n.reduce((function(t,e){return t+e.join(" ")+" "}),"")}},{key:"drawLine",value:function(t,e,i,a){var s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:"#a8a8a8",r=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0,o=arguments.length>6&&void 0!==arguments[6]?arguments[6]:null,n=arguments.length>7&&void 0!==arguments[7]?arguments[7]:"butt";return this.w.globals.dom.Paper.line().attr({x1:t,y1:e,x2:i,y2:a,stroke:s,"stroke-dasharray":r,"stroke-width":o,"stroke-linecap":n})}},{key:"drawRect",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,r=arguments.length>5&&void 0!==arguments[5]?arguments[5]:"#fefefe",o=arguments.length>6&&void 0!==arguments[6]?arguments[6]:1,n=arguments.length>7&&void 0!==arguments[7]?arguments[7]:null,l=arguments.length>8&&void 0!==arguments[8]?arguments[8]:null,h=arguments.length>9&&void 0!==arguments[9]?arguments[9]:0,c=this.w.globals.dom.Paper.rect();return c.attr({x:t,y:e,width:i>0?i:0,height:a>0?a:0,rx:s,ry:s,opacity:o,"stroke-width":null!==n?n:0,stroke:null!==l?l:"none","stroke-dasharray":h}),c.node.setAttribute("fill",r),c}},{key:"drawPolygon",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"#e1e1e1",i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"none";return this.w.globals.dom.Paper.polygon(t).attr({fill:a,stroke:e,"stroke-width":i})}},{key:"drawCircle",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;t<0&&(t=0);var i=this.w.globals.dom.Paper.circle(2*t);return null!==e&&i.attr(e),i}},{key:"drawPath",value:function(t){var e=t.d,i=void 0===e?"":e,a=t.stroke,s=void 0===a?"#a8a8a8":a,r=t.strokeWidth,o=void 0===r?1:r,n=t.fill,l=t.fillOpacity,h=void 0===l?1:l,c=t.strokeOpacity,d=void 0===c?1:c,g=t.classes,u=t.strokeLinecap,f=void 0===u?null:u,p=t.strokeDashArray,x=void 0===p?0:p,b=this.w;return null===f&&(f=b.config.stroke.lineCap),(i.indexOf("undefined")>-1||i.indexOf("NaN")>-1)&&(i="M 0 ".concat(b.globals.gridHeight)),b.globals.dom.Paper.path(i).attr({fill:n,"fill-opacity":h,stroke:s,"stroke-opacity":d,"stroke-linecap":f,"stroke-width":o,"stroke-dasharray":x,class:g})}},{key:"group",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,e=this.w.globals.dom.Paper.group();return null!==t&&e.attr(t),e}},{key:"move",value:function(t,e){var i=["M",t,e].join(" ");return i}},{key:"line",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,a=null;return null===i?a=[" L",t,e].join(" "):"H"===i?a=[" H",t].join(" "):"V"===i&&(a=[" V",e].join(" ")),a}},{key:"curve",value:function(t,e,i,a,s,r){var o=["C",t,e,i,a,s,r].join(" ");return o}},{key:"quadraticCurve",value:function(t,e,i,a){return["Q",t,e,i,a].join(" ")}},{key:"arc",value:function(t,e,i,a,s,r,o){var n="A";arguments.length>7&&void 0!==arguments[7]&&arguments[7]&&(n="a");var l=[n,t,e,i,a,s,r,o].join(" ");return l}},{key:"renderPaths",value:function(t){var e,i=t.j,a=t.realIndex,s=t.pathFrom,r=t.pathTo,o=t.stroke,n=t.strokeWidth,l=t.strokeLinecap,h=t.fill,c=t.animationDelay,d=t.initialSpeed,u=t.dataChangeSpeed,f=t.className,p=t.chartType,x=t.shouldClipToGrid,b=void 0===x||x,v=t.bindEventsOnPaths,m=void 0===v||v,k=t.drawShadow,A=void 0===k||k,S=this.w,C=new w(this.ctx),L=new y(this.ctx),P=this.w.config.chart.animations.enabled,M=P&&this.w.config.chart.animations.dynamicAnimation.enabled,I=!!(P&&!S.globals.resized||M&&S.globals.dataChanged&&S.globals.shouldAnimate);I?e=s:(e=r,S.globals.animationEnded=!0);var T=S.config.stroke.dashArray,z=0;z=Array.isArray(T)?T[a]:S.config.stroke.dashArray;var X=this.drawPath({d:e,stroke:o,strokeWidth:n,fill:h,fillOpacity:1,classes:f,strokeLinecap:l,strokeDashArray:z});if(X.attr("index",a),b&&("bar"===p&&!S.globals.isHorizontal||S.globals.comboCharts?X.attr({"clip-path":"url(#gridRectBarMask".concat(S.globals.cuid,")")}):X.attr({"clip-path":"url(#gridRectMask".concat(S.globals.cuid,")")})),"none"!==S.config.states.normal.filter.type)C.getDefaultFilter(X,a);else if(S.config.chart.dropShadow.enabled&&A){var E=S.config.chart.dropShadow;C.dropShadow(X,E,a)}m&&(X.node.addEventListener("mouseenter",this.pathMouseEnter.bind(this,X)),X.node.addEventListener("mouseleave",this.pathMouseLeave.bind(this,X)),X.node.addEventListener("mousedown",this.pathMouseDown.bind(this,X))),X.attr({pathTo:r,pathFrom:s});var Y={el:X,j:i,realIndex:a,pathFrom:s,pathTo:r,fill:h,strokeWidth:n,delay:c};return!P||S.globals.resized||S.globals.dataChanged?!S.globals.resized&&S.globals.dataChanged||L.showDelayedElements():L.animatePathsGradually(g(g({},Y),{},{speed:d})),S.globals.dataChanged&&M&&I&&L.animatePathsGradually(g(g({},Y),{},{speed:u})),X}},{key:"drawPattern",value:function(t,e,i){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"#a8a8a8",s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0;return this.w.globals.dom.Paper.pattern(e,i,(function(r){"horizontalLines"===t?r.line(0,0,i,0).stroke({color:a,width:s+1}):"verticalLines"===t?r.line(0,0,0,e).stroke({color:a,width:s+1}):"slantedLines"===t?r.line(0,0,e,i).stroke({color:a,width:s}):"squares"===t?r.rect(e,i).fill("none").stroke({color:a,width:s}):"circles"===t&&r.circle(e).fill("none").stroke({color:a,width:s})}))}},{key:"drawGradient",value:function(t,e,i,a,s){var r,o=arguments.length>5&&void 0!==arguments[5]?arguments[5]:null,n=arguments.length>6&&void 0!==arguments[6]?arguments[6]:null,l=arguments.length>7&&void 0!==arguments[7]?arguments[7]:null,h=arguments.length>8&&void 0!==arguments[8]?arguments[8]:0,c=this.w;e.length<9&&0===e.indexOf("#")&&(e=m.hexToRgba(e,a)),i.length<9&&0===i.indexOf("#")&&(i=m.hexToRgba(i,s));var d=0,g=1,u=1,f=null;null!==n&&(d=void 0!==n[0]?n[0]/100:0,g=void 0!==n[1]?n[1]/100:1,u=void 0!==n[2]?n[2]/100:1,f=void 0!==n[3]?n[3]/100:null);var p=!("donut"!==c.config.chart.type&&"pie"!==c.config.chart.type&&"polarArea"!==c.config.chart.type&&"bubble"!==c.config.chart.type);if(r=null===l||0===l.length?c.globals.dom.Paper.gradient(p?"radial":"linear",(function(t){t.at(d,e,a),t.at(g,i,s),t.at(u,i,s),null!==f&&t.at(f,e,a)})):c.globals.dom.Paper.gradient(p?"radial":"linear",(function(t){(Array.isArray(l[h])?l[h]:l).forEach((function(e){t.at(e.offset/100,e.color,e.opacity)}))})),p){var x=c.globals.gridWidth/2,b=c.globals.gridHeight/2;"bubble"!==c.config.chart.type?r.attr({gradientUnits:"userSpaceOnUse",cx:x,cy:b,r:o}):r.attr({cx:.5,cy:.5,r:.8,fx:.2,fy:.2})}else"vertical"===t?r.from(0,0).to(0,1):"diagonal"===t?r.from(0,0).to(1,1):"horizontal"===t?r.from(0,1).to(1,1):"diagonal2"===t&&r.from(1,0).to(0,1);return r}},{key:"getTextBasedOnMaxWidth",value:function(t){var e=t.text,i=t.maxWidth,a=t.fontSize,s=t.fontFamily,r=this.getTextRects(e,a,s),o=r.width/e.length,n=Math.floor(i/o);return i<r.width?e.slice(0,n-3)+"...":e}},{key:"drawText",value:function(t){var e=this,i=t.x,a=t.y,s=t.text,r=t.textAnchor,o=t.fontSize,n=t.fontFamily,l=t.fontWeight,h=t.foreColor,c=t.opacity,d=t.maxWidth,u=t.cssClass,f=void 0===u?"":u,p=t.isPlainText,x=void 0===p||p,b=t.dominantBaseline,v=void 0===b?"auto":b,m=this.w;void 0===s&&(s="");var y=s;r||(r="start"),h&&h.length||(h=m.config.chart.foreColor),n=n||m.config.chart.fontFamily,l=l||"regular";var w,k={maxWidth:d,fontSize:o=o||"11px",fontFamily:n};return Array.isArray(s)?w=m.globals.dom.Paper.text((function(t){for(var i=0;i<s.length;i++)y=s[i],d&&(y=e.getTextBasedOnMaxWidth(g({text:s[i]},k))),0===i?t.tspan(y):t.tspan(y).newLine()})):(d&&(y=this.getTextBasedOnMaxWidth(g({text:s},k))),w=x?m.globals.dom.Paper.plain(s):m.globals.dom.Paper.text((function(t){return t.tspan(y)}))),w.attr({x:i,y:a,"text-anchor":r,"dominant-baseline":v,"font-size":o,"font-family":n,"font-weight":l,fill:h,class:"apexcharts-text "+f}),w.node.style.fontFamily=n,w.node.style.opacity=c,w}},{key:"getMarkerPath",value:function(t,e,i,a){var s="";switch(i){case"cross":s="M ".concat(t-(a/=1.4)," ").concat(e-a," L ").concat(t+a," ").concat(e+a,"  M ").concat(t-a," ").concat(e+a," L ").concat(t+a," ").concat(e-a);break;case"plus":s="M ".concat(t-(a/=1.12)," ").concat(e," L ").concat(t+a," ").concat(e,"  M ").concat(t," ").concat(e-a," L ").concat(t," ").concat(e+a);break;case"star":case"sparkle":var r=5;a*=1.15,"sparkle"===i&&(a/=1.1,r=4);for(var o=Math.PI/r,n=0;n<=2*r;n++){var l=n*o,h=n%2==0?a:a/2;s+=(0===n?"M":"L")+(t+h*Math.sin(l))+","+(e-h*Math.cos(l))}s+="Z";break;case"triangle":s="M ".concat(t," ").concat(e-a," \n             L ").concat(t+a," ").concat(e+a," \n             L ").concat(t-a," ").concat(e+a," \n             Z");break;case"square":case"rect":s="M ".concat(t-(a/=1.125)," ").concat(e-a," \n           L ").concat(t+a," ").concat(e-a," \n           L ").concat(t+a," ").concat(e+a," \n           L ").concat(t-a," ").concat(e+a," \n           Z");break;case"diamond":a*=1.05,s="M ".concat(t," ").concat(e-a," \n             L ").concat(t+a," ").concat(e," \n             L ").concat(t," ").concat(e+a," \n             L ").concat(t-a," ").concat(e," \n            Z");break;case"line":s="M ".concat(t-(a/=1.1)," ").concat(e," \n           L ").concat(t+a," ").concat(e);break;default:a*=2,s="M ".concat(t,", ").concat(e," \n           m -").concat(a/2,", 0 \n           a ").concat(a/2,",").concat(a/2," 0 1,0 ").concat(a,",0 \n           a ").concat(a/2,",").concat(a/2," 0 1,0 -").concat(a,",0")}return s}},{key:"drawMarkerShape",value:function(t,e,i,a,s){var r=this.drawPath({d:this.getMarkerPath(t,e,i,a,s),stroke:s.pointStrokeColor,strokeDashArray:s.pointStrokeDashArray,strokeWidth:s.pointStrokeWidth,fill:s.pointFillColor,fillOpacity:s.pointFillOpacity,strokeOpacity:s.pointStrokeOpacity});return r.attr({cx:t,cy:e,shape:s.shape,class:s.class?s.class:""}),r}},{key:"drawMarker",value:function(t,e,i){t=t||0;var a=i.pSize||0;return m.isNumber(e)||(a=0,e=0),this.drawMarkerShape(t,e,null==i?void 0:i.shape,a,g(g({},i),"line"===i.shape||"plus"===i.shape||"cross"===i.shape?{pointStrokeColor:i.pointFillColor,pointStrokeOpacity:i.pointFillOpacity}:{}))}},{key:"pathMouseEnter",value:function(t,e){var i=this.w,a=new w(this.ctx),s=parseInt(t.node.getAttribute("index"),10),r=parseInt(t.node.getAttribute("j"),10);if("function"==typeof i.config.chart.events.dataPointMouseEnter&&i.config.chart.events.dataPointMouseEnter(e,this.ctx,{seriesIndex:s,dataPointIndex:r,w:i}),this.ctx.events.fireEvent("dataPointMouseEnter",[e,this.ctx,{seriesIndex:s,dataPointIndex:r,w:i}]),("none"===i.config.states.active.filter.type||"true"!==t.node.getAttribute("selected"))&&"none"!==i.config.states.hover.filter.type&&!i.globals.isTouchDevice){var o=i.config.states.hover.filter;a.applyFilter(t,s,o.type,o.value)}}},{key:"pathMouseLeave",value:function(t,e){var i=this.w,a=new w(this.ctx),s=parseInt(t.node.getAttribute("index"),10),r=parseInt(t.node.getAttribute("j"),10);"function"==typeof i.config.chart.events.dataPointMouseLeave&&i.config.chart.events.dataPointMouseLeave(e,this.ctx,{seriesIndex:s,dataPointIndex:r,w:i}),this.ctx.events.fireEvent("dataPointMouseLeave",[e,this.ctx,{seriesIndex:s,dataPointIndex:r,w:i}]),"none"!==i.config.states.active.filter.type&&"true"===t.node.getAttribute("selected")||"none"!==i.config.states.hover.filter.type&&a.getDefaultFilter(t,s)}},{key:"pathMouseDown",value:function(t,e){var i=this.w,a=new w(this.ctx),s=parseInt(t.node.getAttribute("index"),10),r=parseInt(t.node.getAttribute("j"),10),o="false";if("true"===t.node.getAttribute("selected")){if(t.node.setAttribute("selected","false"),i.globals.selectedDataPoints[s].indexOf(r)>-1){var n=i.globals.selectedDataPoints[s].indexOf(r);i.globals.selectedDataPoints[s].splice(n,1)}}else{if(!i.config.states.active.allowMultipleDataPointsSelection&&i.globals.selectedDataPoints.length>0){i.globals.selectedDataPoints=[];var l=i.globals.dom.Paper.select(".apexcharts-series path").members,h=i.globals.dom.Paper.select(".apexcharts-series circle, .apexcharts-series rect").members,c=function(t){Array.prototype.forEach.call(t,(function(t){t.node.setAttribute("selected","false"),a.getDefaultFilter(t,s)}))};c(l),c(h)}t.node.setAttribute("selected","true"),o="true",void 0===i.globals.selectedDataPoints[s]&&(i.globals.selectedDataPoints[s]=[]),i.globals.selectedDataPoints[s].push(r)}if("true"===o){var d=i.config.states.active.filter;if("none"!==d)a.applyFilter(t,s,d.type,d.value);else if("none"!==i.config.states.hover.filter&&!i.globals.isTouchDevice){var g=i.config.states.hover.filter;a.applyFilter(t,s,g.type,g.value)}}else if("none"!==i.config.states.active.filter.type)if("none"===i.config.states.hover.filter.type||i.globals.isTouchDevice)a.getDefaultFilter(t,s);else{g=i.config.states.hover.filter;a.applyFilter(t,s,g.type,g.value)}"function"==typeof i.config.chart.events.dataPointSelection&&i.config.chart.events.dataPointSelection(e,this.ctx,{selectedDataPoints:i.globals.selectedDataPoints,seriesIndex:s,dataPointIndex:r,w:i}),e&&this.ctx.events.fireEvent("dataPointSelection",[e,this.ctx,{selectedDataPoints:i.globals.selectedDataPoints,seriesIndex:s,dataPointIndex:r,w:i}])}},{key:"rotateAroundCenter",value:function(t){var e={};return t&&"function"==typeof t.getBBox&&(e=t.getBBox()),{x:e.x+e.width/2,y:e.y+e.height/2}}},{key:"getTextRects",value:function(t,e,i,a){var s=!(arguments.length>4&&void 0!==arguments[4])||arguments[4],r=this.w,o=this.drawText({x:-200,y:-200,text:t,textAnchor:"start",fontSize:e,fontFamily:i,foreColor:"#fff",opacity:0});a&&o.attr("transform",a),r.globals.dom.Paper.add(o);var n=o.bbox();return s||(n=o.node.getBoundingClientRect()),o.remove(),{width:n.width,height:n.height}}},{key:"placeTextWithEllipsis",value:function(t,e,i){if("function"==typeof t.getComputedTextLength&&(t.textContent=e,e.length>0&&t.getComputedTextLength()>=i/1.1)){for(var a=e.length-3;a>0;a-=3)if(t.getSubStringLength(0,a)<=i/1.1)return void(t.textContent=e.substring(0,a)+"...");t.textContent="."}}}],[{key:"setAttrs",value:function(t,e){for(var i in e)e.hasOwnProperty(i)&&t.setAttribute(i,e[i])}}]),t}(),A=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w}return s(t,[{key:"getStackedSeriesTotals",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],e=this.w,i=[];if(0===e.globals.series.length)return i;for(var a=0;a<e.globals.series[e.globals.maxValsInArrayIndex].length;a++){for(var s=0,r=0;r<e.globals.series.length;r++)void 0!==e.globals.series[r][a]&&-1===t.indexOf(r)&&(s+=e.globals.series[r][a]);i.push(s)}return i}},{key:"getSeriesTotalByIndex",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;return null===t?this.w.config.series.reduce((function(t,e){return t+e}),0):this.w.globals.series[t].reduce((function(t,e){return t+e}),0)}},{key:"getStackedSeriesTotalsByGroups",value:function(){var t=this,e=this.w,i=[];return e.globals.seriesGroups.forEach((function(a){var s=[];e.config.series.forEach((function(t,i){a.indexOf(e.globals.seriesNames[i])>-1&&s.push(i)}));var r=e.globals.series.map((function(t,e){return-1===s.indexOf(e)?e:-1})).filter((function(t){return-1!==t}));i.push(t.getStackedSeriesTotals(r))})),i}},{key:"setSeriesYAxisMappings",value:function(){var t=this.w.globals,e=this.w.config,i=[],a=[],s=[],r=t.series.length>e.yaxis.length||e.yaxis.some((function(t){return Array.isArray(t.seriesName)}));e.series.forEach((function(t,e){s.push(e),a.push(null)})),e.yaxis.forEach((function(t,e){i[e]=[]}));var o=[];e.yaxis.forEach((function(t,a){var n=!1;if(t.seriesName){var l=[];Array.isArray(t.seriesName)?l=t.seriesName:l.push(t.seriesName),l.forEach((function(t){e.series.forEach((function(e,o){if(e.name===t){var l=o;a===o||r?!r||s.indexOf(o)>-1?i[a].push([a,o]):console.warn("Series '"+e.name+"' referenced more than once in what looks like the new style. That is, when using either seriesName: [], or when there are more series than yaxes."):(i[o].push([o,a]),l=a),n=!0,-1!==(l=s.indexOf(l))&&s.splice(l,1)}}))}))}n||o.push(a)})),i=i.map((function(t,e){var i=[];return t.forEach((function(t){a[t[1]]=t[0],i.push(t[1])})),i}));for(var n=e.yaxis.length-1,l=0;l<o.length&&(n=o[l],i[n]=[],s);l++){var h=s[0];s.shift(),i[n].push(h),a[h]=n}s.forEach((function(t){i[n].push(t),a[t]=n})),t.seriesYAxisMap=i.map((function(t){return t})),t.seriesYAxisReverseMap=a.map((function(t){return t})),t.seriesYAxisMap.forEach((function(t,i){t.forEach((function(t){e.series[t]&&void 0===e.series[t].group&&(e.series[t].group="apexcharts-axis-".concat(i.toString()))}))}))}},{key:"isSeriesNull",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;return 0===(null===t?this.w.config.series.filter((function(t){return null!==t})):this.w.config.series[t].data.filter((function(t){return null!==t}))).length}},{key:"seriesHaveSameValues",value:function(t){return this.w.globals.series[t].every((function(t,e,i){return t===i[0]}))}},{key:"getCategoryLabels",value:function(t){var e=this.w,i=t.slice();return e.config.xaxis.convertedCatToNumeric&&(i=t.map((function(t,i){return e.config.xaxis.labels.formatter(t-e.globals.minX+1)}))),i}},{key:"getLargestSeries",value:function(){var t=this.w;t.globals.maxValsInArrayIndex=t.globals.series.map((function(t){return t.length})).indexOf(Math.max.apply(Math,t.globals.series.map((function(t){return t.length}))))}},{key:"getLargestMarkerSize",value:function(){var t=this.w,e=0;return t.globals.markers.size.forEach((function(t){e=Math.max(e,t)})),t.config.markers.discrete&&t.config.markers.discrete.length&&t.config.markers.discrete.forEach((function(t){e=Math.max(e,t.size)})),e>0&&(t.config.markers.hover.size>0?e=t.config.markers.hover.size:e+=t.config.markers.hover.sizeOffset),t.globals.markers.largestSize=e,e}},{key:"getSeriesTotals",value:function(){var t=this.w;t.globals.seriesTotals=t.globals.series.map((function(t,e){var i=0;if(Array.isArray(t))for(var a=0;a<t.length;a++)i+=t[a];else i+=t;return i}))}},{key:"getSeriesTotalsXRange",value:function(t,e){var i=this.w;return i.globals.series.map((function(a,s){for(var r=0,o=0;o<a.length;o++)i.globals.seriesX[s][o]>t&&i.globals.seriesX[s][o]<e&&(r+=a[o]);return r}))}},{key:"getPercentSeries",value:function(){var t=this.w;t.globals.seriesPercent=t.globals.series.map((function(e,i){var a=[];if(Array.isArray(e))for(var s=0;s<e.length;s++){var r=t.globals.stackedSeriesTotals[s],o=0;r&&(o=100*e[s]/r),a.push(o)}else{var n=100*e/t.globals.seriesTotals.reduce((function(t,e){return t+e}),0);a.push(n)}return a}))}},{key:"getCalculatedRatios",value:function(){var t,e,i,a=this,s=this.w,r=s.globals,o=[],n=0,l=[],h=.1,c=0;if(r.yRange=[],r.isMultipleYAxis)for(var d=0;d<r.minYArr.length;d++)r.yRange.push(Math.abs(r.minYArr[d]-r.maxYArr[d])),l.push(0);else r.yRange.push(Math.abs(r.minY-r.maxY));r.xRange=Math.abs(r.maxX-r.minX),r.zRange=Math.abs(r.maxZ-r.minZ);for(var g=0;g<r.yRange.length;g++)o.push(r.yRange[g]/r.gridHeight);if(e=r.xRange/r.gridWidth,t=r.yRange/r.gridWidth,i=r.xRange/r.gridHeight,(n=r.zRange/r.gridHeight*16)||(n=1),r.minY!==Number.MIN_VALUE&&0!==Math.abs(r.minY)&&(r.hasNegs=!0),s.globals.seriesYAxisReverseMap.length>0){var u=function(t,e){var i=s.config.yaxis[s.globals.seriesYAxisReverseMap[e]],r=t<0?-1:1;return t=Math.abs(t),i.logarithmic&&(t=a.getBaseLog(i.logBase,t)),-r*t/o[e]};if(r.isMultipleYAxis){l=[];for(var f=0;f<o.length;f++)l.push(u(r.minYArr[f],f))}else(l=[]).push(u(r.minY,0)),r.minY!==Number.MIN_VALUE&&0!==Math.abs(r.minY)&&(h=-r.minY/t,c=r.minX/e)}else(l=[]).push(0),h=0,c=0;return{yRatio:o,invertedYRatio:t,zRatio:n,xRatio:e,invertedXRatio:i,baseLineInvertedY:h,baseLineY:l,baseLineX:c}}},{key:"getLogSeries",value:function(t){var e=this,i=this.w;return i.globals.seriesLog=t.map((function(t,a){var s=i.globals.seriesYAxisReverseMap[a];return i.config.yaxis[s]&&i.config.yaxis[s].logarithmic?t.map((function(t){return null===t?null:e.getLogVal(i.config.yaxis[s].logBase,t,a)})):t})),i.globals.invalidLogScale?t:i.globals.seriesLog}},{key:"getBaseLog",value:function(t,e){return Math.log(e)/Math.log(t)}},{key:"getLogVal",value:function(t,e,i){if(e<=0)return 0;var a=this.w,s=0===a.globals.minYArr[i]?-1:this.getBaseLog(t,a.globals.minYArr[i]),r=(0===a.globals.maxYArr[i]?0:this.getBaseLog(t,a.globals.maxYArr[i]))-s;return e<1?e/r:(this.getBaseLog(t,e)-s)/r}},{key:"getLogYRatios",value:function(t){var e=this,i=this.w,a=this.w.globals;return a.yLogRatio=t.slice(),a.logYRange=a.yRange.map((function(t,s){var r=i.globals.seriesYAxisReverseMap[s];if(i.config.yaxis[r]&&e.w.config.yaxis[r].logarithmic){var o,n=-Number.MAX_VALUE,l=Number.MIN_VALUE;return a.seriesLog.forEach((function(t,e){t.forEach((function(t){i.config.yaxis[e]&&i.config.yaxis[e].logarithmic&&(n=Math.max(t,n),l=Math.min(t,l))}))})),o=Math.pow(a.yRange[s],Math.abs(l-n)/a.yRange[s]),a.yLogRatio[s]=o/a.gridHeight,o}})),a.invalidLogScale?t.slice():a.yLogRatio}},{key:"drawSeriesByGroup",value:function(t,e,i,a){var s=this.w,r=[];return t.series.length>0&&e.forEach((function(e){var o=[],n=[];t.i.forEach((function(i,a){s.config.series[i].group===e&&(o.push(t.series[a]),n.push(i))})),o.length>0&&r.push(a.draw(o,i,n))})),r}}],[{key:"checkComboSeries",value:function(t,e){var i=!1,a=0,s=0;return void 0===e&&(e="line"),t.length&&void 0!==t[0].type&&t.forEach((function(t){"bar"!==t.type&&"column"!==t.type&&"candlestick"!==t.type&&"boxPlot"!==t.type||a++,void 0!==t.type&&t.type!==e&&s++})),s>0&&(i=!0),{comboBarCount:a,comboCharts:i}}},{key:"extendArrayProps",value:function(t,e,i){var a,s,r,o,n,l;(null!==(a=e)&&void 0!==a&&a.yaxis&&(e=t.extendYAxis(e,i)),null!==(s=e)&&void 0!==s&&s.annotations)&&(e.annotations.yaxis&&(e=t.extendYAxisAnnotations(e)),null!==(r=e)&&void 0!==r&&null!==(o=r.annotations)&&void 0!==o&&o.xaxis&&(e=t.extendXAxisAnnotations(e)),null!==(n=e)&&void 0!==n&&null!==(l=n.annotations)&&void 0!==l&&l.points&&(e=t.extendPointAnnotations(e)));return e}}]),t}(),S=function(){function t(e){i(this,t),this.w=e.w,this.annoCtx=e}return s(t,[{key:"setOrientations",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,i=this.w;if("vertical"===t.label.orientation){var a=null!==e?e:0,s=i.globals.dom.baseEl.querySelector(".apexcharts-xaxis-annotations .apexcharts-xaxis-annotation-label[rel='".concat(a,"']"));if(null!==s){var r=s.getBoundingClientRect();s.setAttribute("x",parseFloat(s.getAttribute("x"))-r.height+4);var o="top"===t.label.position?r.width:-r.width;s.setAttribute("y",parseFloat(s.getAttribute("y"))+o);var n=this.annoCtx.graphics.rotateAroundCenter(s),l=n.x,h=n.y;s.setAttribute("transform","rotate(-90 ".concat(l," ").concat(h,")"))}}}},{key:"addBackgroundToAnno",value:function(t,e){var i=this.w;if(!t||!e.label.text||!String(e.label.text).trim())return null;var a=i.globals.dom.baseEl.querySelector(".apexcharts-grid").getBoundingClientRect(),s=t.getBoundingClientRect(),r=e.label.style.padding,o=r.left,n=r.right,l=r.top,h=r.bottom;if("vertical"===e.label.orientation){var c=[o,n,l,h];l=c[0],h=c[1],o=c[2],n=c[3]}var d=s.left-a.left-o,g=s.top-a.top-l,u=this.annoCtx.graphics.drawRect(d-i.globals.barPadForNumericAxis,g,s.width+o+n,s.height+l+h,e.label.borderRadius,e.label.style.background,1,e.label.borderWidth,e.label.borderColor,0);return e.id&&u.node.classList.add(e.id),u}},{key:"annotationsBackground",value:function(){var t=this,e=this.w,i=function(i,a,s){var r=e.globals.dom.baseEl.querySelector(".apexcharts-".concat(s,"-annotations .apexcharts-").concat(s,"-annotation-label[rel='").concat(a,"']"));if(r){var o=r.parentNode,n=t.addBackgroundToAnno(r,i);n&&(o.insertBefore(n.node,r),i.label.mouseEnter&&n.node.addEventListener("mouseenter",i.label.mouseEnter.bind(t,i)),i.label.mouseLeave&&n.node.addEventListener("mouseleave",i.label.mouseLeave.bind(t,i)),i.label.click&&n.node.addEventListener("click",i.label.click.bind(t,i)))}};e.config.annotations.xaxis.forEach((function(t,e){return i(t,e,"xaxis")})),e.config.annotations.yaxis.forEach((function(t,e){return i(t,e,"yaxis")})),e.config.annotations.points.forEach((function(t,e){return i(t,e,"point")}))}},{key:"getY1Y2",value:function(t,e){var i,a=this.w,s="y1"===t?e.y:e.y2,r=!1;if(this.annoCtx.invertAxis){var o=a.config.xaxis.convertedCatToNumeric?a.globals.categoryLabels:a.globals.labels,n=o.indexOf(s),l=a.globals.dom.baseEl.querySelector(".apexcharts-yaxis-texts-g text:nth-child(".concat(n+1,")"));i=l?parseFloat(l.getAttribute("y")):(a.globals.gridHeight/o.length-1)*(n+1)-a.globals.barHeight,void 0!==e.seriesIndex&&a.globals.barHeight&&(i-=a.globals.barHeight/2*(a.globals.series.length-1)-a.globals.barHeight*e.seriesIndex)}else{var h,c=a.globals.seriesYAxisMap[e.yAxisIndex][0],d=a.config.yaxis[e.yAxisIndex].logarithmic?new A(this.annoCtx.ctx).getLogVal(a.config.yaxis[e.yAxisIndex].logBase,s,c)/a.globals.yLogRatio[c]:(s-a.globals.minYArr[c])/(a.globals.yRange[c]/a.globals.gridHeight);i=a.globals.gridHeight-Math.min(Math.max(d,0),a.globals.gridHeight),r=d>a.globals.gridHeight||d<0,!e.marker||void 0!==e.y&&null!==e.y||(i=0),null!==(h=a.config.yaxis[e.yAxisIndex])&&void 0!==h&&h.reversed&&(i=d)}return"string"==typeof s&&s.includes("px")&&(i=parseFloat(s)),{yP:i,clipped:r}}},{key:"getX1X2",value:function(t,e){var i=this.w,a="x1"===t?e.x:e.x2,s=this.annoCtx.invertAxis?i.globals.minY:i.globals.minX,r=this.annoCtx.invertAxis?i.globals.maxY:i.globals.maxX,o=this.annoCtx.invertAxis?i.globals.yRange[0]:i.globals.xRange,n=!1,l=this.annoCtx.inversedReversedAxis?(r-a)/(o/i.globals.gridWidth):(a-s)/(o/i.globals.gridWidth);return"category"!==i.config.xaxis.type&&!i.config.xaxis.convertedCatToNumeric||this.annoCtx.invertAxis||i.globals.dataFormatXNumeric||i.config.chart.sparkline.enabled||(l=this.getStringX(a)),"string"==typeof a&&a.includes("px")&&(l=parseFloat(a)),null==a&&e.marker&&(l=i.globals.gridWidth),void 0!==e.seriesIndex&&i.globals.barWidth&&!this.annoCtx.invertAxis&&(l-=i.globals.barWidth/2*(i.globals.series.length-1)-i.globals.barWidth*e.seriesIndex),l>i.globals.gridWidth?(l=i.globals.gridWidth,n=!0):l<0&&(l=0,n=!0),{x:l,clipped:n}}},{key:"getStringX",value:function(t){var e=this.w,i=t;e.config.xaxis.convertedCatToNumeric&&e.globals.categoryLabels.length&&(t=e.globals.categoryLabels.indexOf(t)+1);var a=e.globals.labels.map((function(t){return Array.isArray(t)?t.join(" "):t})).indexOf(t),s=e.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g text:nth-child(".concat(a+1,")"));return s&&(i=parseFloat(s.getAttribute("x"))),i}}]),t}(),C=function(){function t(e){i(this,t),this.w=e.w,this.annoCtx=e,this.invertAxis=this.annoCtx.invertAxis,this.helpers=new S(this.annoCtx)}return s(t,[{key:"addXaxisAnnotation",value:function(t,e,i){var a,s=this.w,r=this.helpers.getX1X2("x1",t),o=r.x,n=r.clipped,l=!0,h=t.label.text,c=t.strokeDashArray;if(m.isNumber(o)){if(null===t.x2||void 0===t.x2){if(!n){var d=this.annoCtx.graphics.drawLine(o+t.offsetX,0+t.offsetY,o+t.offsetX,s.globals.gridHeight+t.offsetY,t.borderColor,c,t.borderWidth);e.appendChild(d.node),t.id&&d.node.classList.add(t.id)}}else{var g=this.helpers.getX1X2("x2",t);if(a=g.x,l=g.clipped,!n||!l){if(a<o){var u=o;o=a,a=u}var f=this.annoCtx.graphics.drawRect(o+t.offsetX,0+t.offsetY,a-o,s.globals.gridHeight+t.offsetY,0,t.fillColor,t.opacity,1,t.borderColor,c);f.node.classList.add("apexcharts-annotation-rect"),f.attr("clip-path","url(#gridRectMask".concat(s.globals.cuid,")")),e.appendChild(f.node),t.id&&f.node.classList.add(t.id)}}if(!n||!l){var p=this.annoCtx.graphics.getTextRects(h,parseFloat(t.label.style.fontSize)),x="top"===t.label.position?4:"center"===t.label.position?s.globals.gridHeight/2+("vertical"===t.label.orientation?p.width/2:0):s.globals.gridHeight,b=this.annoCtx.graphics.drawText({x:o+t.label.offsetX,y:x+t.label.offsetY-("vertical"===t.label.orientation?"top"===t.label.position?p.width/2-12:-p.width/2:0),text:h,textAnchor:t.label.textAnchor,fontSize:t.label.style.fontSize,fontFamily:t.label.style.fontFamily,fontWeight:t.label.style.fontWeight,foreColor:t.label.style.color,cssClass:"apexcharts-xaxis-annotation-label ".concat(t.label.style.cssClass," ").concat(t.id?t.id:"")});b.attr({rel:i}),e.appendChild(b.node),this.annoCtx.helpers.setOrientations(t,i)}}}},{key:"drawXAxisAnnotations",value:function(){var t=this,e=this.w,i=this.annoCtx.graphics.group({class:"apexcharts-xaxis-annotations"});return e.config.annotations.xaxis.map((function(e,a){t.addXaxisAnnotation(e,i.node,a)})),i}}]),t}(),L=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w,this.months31=[1,3,5,7,8,10,12],this.months30=[2,4,6,9,11],this.daysCntOfYear=[0,31,59,90,120,151,181,212,243,273,304,334]}return s(t,[{key:"isValidDate",value:function(t){return"number"!=typeof t&&!isNaN(this.parseDate(t))}},{key:"getTimeStamp",value:function(t){return Date.parse(t)?this.w.config.xaxis.labels.datetimeUTC?new Date(new Date(t).toISOString().substr(0,25)).getTime():new Date(t).getTime():t}},{key:"getDate",value:function(t){return this.w.config.xaxis.labels.datetimeUTC?new Date(new Date(t).toUTCString()):new Date(t)}},{key:"parseDate",value:function(t){var e=Date.parse(t);if(!isNaN(e))return this.getTimeStamp(t);var i=Date.parse(t.replace(/-/g,"/").replace(/[a-z]+/gi," "));return i=this.getTimeStamp(i)}},{key:"parseDateWithTimezone",value:function(t){return Date.parse(t.replace(/-/g,"/").replace(/[a-z]+/gi," "))}},{key:"formatDate",value:function(t,e){var i=this.w.globals.locale,a=this.w.config.xaxis.labels.datetimeUTC,s=["\0"].concat(p(i.months)),r=["\x01"].concat(p(i.shortMonths)),o=["\x02"].concat(p(i.days)),n=["\x03"].concat(p(i.shortDays));function l(t,e){var i=t+"";for(e=e||2;i.length<e;)i="0"+i;return i}var h=a?t.getUTCFullYear():t.getFullYear();e=(e=(e=e.replace(/(^|[^\\])yyyy+/g,"$1"+h)).replace(/(^|[^\\])yy/g,"$1"+h.toString().substr(2,2))).replace(/(^|[^\\])y/g,"$1"+h);var c=(a?t.getUTCMonth():t.getMonth())+1;e=(e=(e=(e=e.replace(/(^|[^\\])MMMM+/g,"$1"+s[0])).replace(/(^|[^\\])MMM/g,"$1"+r[0])).replace(/(^|[^\\])MM/g,"$1"+l(c))).replace(/(^|[^\\])M/g,"$1"+c);var d=a?t.getUTCDate():t.getDate();e=(e=(e=(e=e.replace(/(^|[^\\])dddd+/g,"$1"+o[0])).replace(/(^|[^\\])ddd/g,"$1"+n[0])).replace(/(^|[^\\])dd/g,"$1"+l(d))).replace(/(^|[^\\])d/g,"$1"+d);var g=a?t.getUTCHours():t.getHours(),u=g>12?g-12:0===g?12:g;e=(e=(e=(e=e.replace(/(^|[^\\])HH+/g,"$1"+l(g))).replace(/(^|[^\\])H/g,"$1"+g)).replace(/(^|[^\\])hh+/g,"$1"+l(u))).replace(/(^|[^\\])h/g,"$1"+u);var f=a?t.getUTCMinutes():t.getMinutes();e=(e=e.replace(/(^|[^\\])mm+/g,"$1"+l(f))).replace(/(^|[^\\])m/g,"$1"+f);var x=a?t.getUTCSeconds():t.getSeconds();e=(e=e.replace(/(^|[^\\])ss+/g,"$1"+l(x))).replace(/(^|[^\\])s/g,"$1"+x);var b=a?t.getUTCMilliseconds():t.getMilliseconds();e=e.replace(/(^|[^\\])fff+/g,"$1"+l(b,3)),b=Math.round(b/10),e=e.replace(/(^|[^\\])ff/g,"$1"+l(b)),b=Math.round(b/10);var v=g<12?"AM":"PM";e=(e=(e=e.replace(/(^|[^\\])f/g,"$1"+b)).replace(/(^|[^\\])TT+/g,"$1"+v)).replace(/(^|[^\\])T/g,"$1"+v.charAt(0));var m=v.toLowerCase();e=(e=e.replace(/(^|[^\\])tt+/g,"$1"+m)).replace(/(^|[^\\])t/g,"$1"+m.charAt(0));var y=-t.getTimezoneOffset(),w=a||!y?"Z":y>0?"+":"-";if(!a){var k=(y=Math.abs(y))%60;w+=l(Math.floor(y/60))+":"+l(k)}e=e.replace(/(^|[^\\])K/g,"$1"+w);var A=(a?t.getUTCDay():t.getDay())+1;return e=(e=(e=(e=(e=e.replace(new RegExp(o[0],"g"),o[A])).replace(new RegExp(n[0],"g"),n[A])).replace(new RegExp(s[0],"g"),s[c])).replace(new RegExp(r[0],"g"),r[c])).replace(/\\(.)/g,"$1")}},{key:"getTimeUnitsfromTimestamp",value:function(t,e,i){var a=this.w;void 0!==a.config.xaxis.min&&(t=a.config.xaxis.min),void 0!==a.config.xaxis.max&&(e=a.config.xaxis.max);var s=this.getDate(t),r=this.getDate(e),o=this.formatDate(s,"yyyy MM dd HH mm ss fff").split(" "),n=this.formatDate(r,"yyyy MM dd HH mm ss fff").split(" ");return{minMillisecond:parseInt(o[6],10),maxMillisecond:parseInt(n[6],10),minSecond:parseInt(o[5],10),maxSecond:parseInt(n[5],10),minMinute:parseInt(o[4],10),maxMinute:parseInt(n[4],10),minHour:parseInt(o[3],10),maxHour:parseInt(n[3],10),minDate:parseInt(o[2],10),maxDate:parseInt(n[2],10),minMonth:parseInt(o[1],10)-1,maxMonth:parseInt(n[1],10)-1,minYear:parseInt(o[0],10),maxYear:parseInt(n[0],10)}}},{key:"isLeapYear",value:function(t){return t%4==0&&t%100!=0||t%400==0}},{key:"calculcateLastDaysOfMonth",value:function(t,e,i){return this.determineDaysOfMonths(t,e)-i}},{key:"determineDaysOfYear",value:function(t){var e=365;return this.isLeapYear(t)&&(e=366),e}},{key:"determineRemainingDaysOfYear",value:function(t,e,i){var a=this.daysCntOfYear[e]+i;return e>1&&this.isLeapYear()&&a++,a}},{key:"determineDaysOfMonths",value:function(t,e){var i=30;switch(t=m.monthMod(t),!0){case this.months30.indexOf(t)>-1:2===t&&(i=this.isLeapYear(e)?29:28);break;case this.months31.indexOf(t)>-1:default:i=31}return i}}]),t}(),P=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w,this.tooltipKeyFormat="dd MMM"}return s(t,[{key:"xLabelFormat",value:function(t,e,i,a){var s=this.w;if("datetime"===s.config.xaxis.type&&void 0===s.config.xaxis.labels.formatter&&void 0===s.config.tooltip.x.formatter){var r=new L(this.ctx);return r.formatDate(r.getDate(e),s.config.tooltip.x.format)}return t(e,i,a)}},{key:"defaultGeneralFormatter",value:function(t){return Array.isArray(t)?t.map((function(t){return t})):t}},{key:"defaultYFormatter",value:function(t,e,i){var a=this.w;if(m.isNumber(t))if(0!==a.globals.yValueDecimal)t=t.toFixed(void 0!==e.decimalsInFloat?e.decimalsInFloat:a.globals.yValueDecimal);else{var s=t.toFixed(0);t=t==s?s:t.toFixed(1)}return t}},{key:"setLabelFormatters",value:function(){var t=this,e=this.w;return e.globals.xaxisTooltipFormatter=function(e){return t.defaultGeneralFormatter(e)},e.globals.ttKeyFormatter=function(e){return t.defaultGeneralFormatter(e)},e.globals.ttZFormatter=function(t){return t},e.globals.legendFormatter=function(e){return t.defaultGeneralFormatter(e)},void 0!==e.config.xaxis.labels.formatter?e.globals.xLabelFormatter=e.config.xaxis.labels.formatter:e.globals.xLabelFormatter=function(t){if(m.isNumber(t)){if(!e.config.xaxis.convertedCatToNumeric&&"numeric"===e.config.xaxis.type){if(m.isNumber(e.config.xaxis.decimalsInFloat))return t.toFixed(e.config.xaxis.decimalsInFloat);var i=e.globals.maxX-e.globals.minX;return i>0&&i<100?t.toFixed(1):t.toFixed(0)}if(e.globals.isBarHorizontal)if(e.globals.maxY-e.globals.minYArr<4)return t.toFixed(1);return t.toFixed(0)}return t},"function"==typeof e.config.tooltip.x.formatter?e.globals.ttKeyFormatter=e.config.tooltip.x.formatter:e.globals.ttKeyFormatter=e.globals.xLabelFormatter,"function"==typeof e.config.xaxis.tooltip.formatter&&(e.globals.xaxisTooltipFormatter=e.config.xaxis.tooltip.formatter),(Array.isArray(e.config.tooltip.y)||void 0!==e.config.tooltip.y.formatter)&&(e.globals.ttVal=e.config.tooltip.y),void 0!==e.config.tooltip.z.formatter&&(e.globals.ttZFormatter=e.config.tooltip.z.formatter),void 0!==e.config.legend.formatter&&(e.globals.legendFormatter=e.config.legend.formatter),e.config.yaxis.forEach((function(i,a){void 0!==i.labels.formatter?e.globals.yLabelFormatters[a]=i.labels.formatter:e.globals.yLabelFormatters[a]=function(s){return e.globals.xyCharts?Array.isArray(s)?s.map((function(e){return t.defaultYFormatter(e,i,a)})):t.defaultYFormatter(s,i,a):s}})),e.globals}},{key:"heatmapLabelFormatters",value:function(){var t=this.w;if("heatmap"===t.config.chart.type){t.globals.yAxisScale[0].result=t.globals.seriesNames.slice();var e=t.globals.seriesNames.reduce((function(t,e){return t.length>e.length?t:e}),0);t.globals.yAxisScale[0].niceMax=e,t.globals.yAxisScale[0].niceMin=e}}}]),t}(),M=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w}return s(t,[{key:"getLabel",value:function(t,e,i,a){var s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:[],r=arguments.length>5&&void 0!==arguments[5]?arguments[5]:"12px",o=!(arguments.length>6&&void 0!==arguments[6])||arguments[6],n=this.w,l=void 0===t[a]?"":t[a],h=l,c=n.globals.xLabelFormatter,d=n.config.xaxis.labels.formatter,g=!1,u=new P(this.ctx),f=l;o&&(h=u.xLabelFormat(c,l,f,{i:a,dateFormatter:new L(this.ctx).formatDate,w:n}),void 0!==d&&(h=d(l,t[a],{i:a,dateFormatter:new L(this.ctx).formatDate,w:n})));var p,x;e.length>0?(p=e[a].unit,x=null,e.forEach((function(t){"month"===t.unit?x="year":"day"===t.unit?x="month":"hour"===t.unit?x="day":"minute"===t.unit&&(x="hour")})),g=x===p,i=e[a].position,h=e[a].value):"datetime"===n.config.xaxis.type&&void 0===d&&(h=""),void 0===h&&(h=""),h=Array.isArray(h)?h:h.toString();var b=new k(this.ctx),v={};v=n.globals.rotateXLabels&&o?b.getTextRects(h,parseInt(r,10),null,"rotate(".concat(n.config.xaxis.labels.rotate," 0 0)"),!1):b.getTextRects(h,parseInt(r,10));var m=!n.config.xaxis.labels.showDuplicates&&this.ctx.timeScale;return!Array.isArray(h)&&("NaN"===String(h)||s.indexOf(h)>=0&&m)&&(h=""),{x:i,text:h,textRect:v,isBold:g}}},{key:"checkLabelBasedOnTickamount",value:function(t,e,i){var a=this.w,s=a.config.xaxis.tickAmount;return"dataPoints"===s&&(s=Math.round(a.globals.gridWidth/120)),s>i||t%Math.round(i/(s+1))==0||(e.text=""),e}},{key:"checkForOverflowingLabels",value:function(t,e,i,a,s){var r=this.w;if(0===t&&r.globals.skipFirstTimelinelabel&&(e.text=""),t===i-1&&r.globals.skipLastTimelinelabel&&(e.text=""),r.config.xaxis.labels.hideOverlappingLabels&&a.length>0){var o=s[s.length-1];e.x<o.textRect.width/(r.globals.rotateXLabels?Math.abs(r.config.xaxis.labels.rotate)/12:1.01)+o.x&&(e.text="")}return e}},{key:"checkForReversedLabels",value:function(t,e){var i=this.w;return i.config.yaxis[t]&&i.config.yaxis[t].reversed&&e.reverse(),e}},{key:"yAxisAllSeriesCollapsed",value:function(t){var e=this.w.globals;return!e.seriesYAxisMap[t].some((function(t){return-1===e.collapsedSeriesIndices.indexOf(t)}))}},{key:"translateYAxisIndex",value:function(t){var e=this.w,i=e.globals,a=e.config.yaxis;return i.series.length>a.length||a.some((function(t){return Array.isArray(t.seriesName)}))?t:i.seriesYAxisReverseMap[t]}},{key:"isYAxisHidden",value:function(t){var e=this.w,i=e.config.yaxis[t];if(!i.show||this.yAxisAllSeriesCollapsed(t))return!0;if(!i.showForNullSeries){var a=e.globals.seriesYAxisMap[t],s=new A(this.ctx);return a.every((function(t){return s.isSeriesNull(t)}))}return!1}},{key:"getYAxisForeColor",value:function(t,e){var i=this.w;return Array.isArray(t)&&i.globals.yAxisScale[e]&&this.ctx.theme.pushExtraColors(t,i.globals.yAxisScale[e].result.length,!1),t}},{key:"drawYAxisTicks",value:function(t,e,i,a,s,r,o){var n=this.w,l=new k(this.ctx),h=n.globals.translateY+n.config.yaxis[s].labels.offsetY;if(n.globals.isBarHorizontal?h=0:"heatmap"===n.config.chart.type&&(h+=r/2),a.show&&e>0){!0===n.config.yaxis[s].opposite&&(t+=a.width);for(var c=e;c>=0;c--){var d=l.drawLine(t+i.offsetX-a.width+a.offsetX,h+a.offsetY,t+i.offsetX+a.offsetX,h+a.offsetY,a.color);o.add(d),h+=r}}}}]),t}(),I=function(){function t(e){i(this,t),this.w=e.w,this.annoCtx=e,this.helpers=new S(this.annoCtx),this.axesUtils=new M(this.annoCtx)}return s(t,[{key:"addYaxisAnnotation",value:function(t,e,i){var a,s=this.w,r=t.strokeDashArray,o=this.helpers.getY1Y2("y1",t),n=o.yP,l=o.clipped,h=!0,c=!1,d=t.label.text;if(null===t.y2||void 0===t.y2){if(!l){c=!0;var g=this.annoCtx.graphics.drawLine(0+t.offsetX,n+t.offsetY,this._getYAxisAnnotationWidth(t),n+t.offsetY,t.borderColor,r,t.borderWidth);e.appendChild(g.node),t.id&&g.node.classList.add(t.id)}}else{if(a=(o=this.helpers.getY1Y2("y2",t)).yP,h=o.clipped,a>n){var u=n;n=a,a=u}if(!l||!h){c=!0;var f=this.annoCtx.graphics.drawRect(0+t.offsetX,a+t.offsetY,this._getYAxisAnnotationWidth(t),n-a,0,t.fillColor,t.opacity,1,t.borderColor,r);f.node.classList.add("apexcharts-annotation-rect"),f.attr("clip-path","url(#gridRectMask".concat(s.globals.cuid,")")),e.appendChild(f.node),t.id&&f.node.classList.add(t.id)}}if(c){var p="right"===t.label.position?s.globals.gridWidth:"center"===t.label.position?s.globals.gridWidth/2:0,x=this.annoCtx.graphics.drawText({x:p+t.label.offsetX,y:(null!=a?a:n)+t.label.offsetY-3,text:d,textAnchor:t.label.textAnchor,fontSize:t.label.style.fontSize,fontFamily:t.label.style.fontFamily,fontWeight:t.label.style.fontWeight,foreColor:t.label.style.color,cssClass:"apexcharts-yaxis-annotation-label ".concat(t.label.style.cssClass," ").concat(t.id?t.id:"")});x.attr({rel:i}),e.appendChild(x.node)}}},{key:"_getYAxisAnnotationWidth",value:function(t){var e=this.w;e.globals.gridWidth;return(t.width.indexOf("%")>-1?e.globals.gridWidth*parseInt(t.width,10)/100:parseInt(t.width,10))+t.offsetX}},{key:"drawYAxisAnnotations",value:function(){var t=this,e=this.w,i=this.annoCtx.graphics.group({class:"apexcharts-yaxis-annotations"});return e.config.annotations.yaxis.forEach((function(e,a){e.yAxisIndex=t.axesUtils.translateYAxisIndex(e.yAxisIndex),t.axesUtils.isYAxisHidden(e.yAxisIndex)&&t.axesUtils.yAxisAllSeriesCollapsed(e.yAxisIndex)||t.addYaxisAnnotation(e,i.node,a)})),i}}]),t}(),T=function(){function t(e){i(this,t),this.w=e.w,this.annoCtx=e,this.helpers=new S(this.annoCtx)}return s(t,[{key:"addPointAnnotation",value:function(t,e,i){if(!(this.w.globals.collapsedSeriesIndices.indexOf(t.seriesIndex)>-1)){var a=this.helpers.getX1X2("x1",t),s=a.x,r=a.clipped,o=(a=this.helpers.getY1Y2("y1",t)).yP,n=a.clipped;if(m.isNumber(s)&&!n&&!r){var l={pSize:t.marker.size,pointStrokeWidth:t.marker.strokeWidth,pointFillColor:t.marker.fillColor,pointStrokeColor:t.marker.strokeColor,shape:t.marker.shape,pRadius:t.marker.radius,class:"apexcharts-point-annotation-marker ".concat(t.marker.cssClass," ").concat(t.id?t.id:"")},h=this.annoCtx.graphics.drawMarker(s+t.marker.offsetX,o+t.marker.offsetY,l);e.appendChild(h.node);var c=t.label.text?t.label.text:"",d=this.annoCtx.graphics.drawText({x:s+t.label.offsetX,y:o+t.label.offsetY-t.marker.size-parseFloat(t.label.style.fontSize)/1.6,text:c,textAnchor:t.label.textAnchor,fontSize:t.label.style.fontSize,fontFamily:t.label.style.fontFamily,fontWeight:t.label.style.fontWeight,foreColor:t.label.style.color,cssClass:"apexcharts-point-annotation-label ".concat(t.label.style.cssClass," ").concat(t.id?t.id:"")});if(d.attr({rel:i}),e.appendChild(d.node),t.customSVG.SVG){var g=this.annoCtx.graphics.group({class:"apexcharts-point-annotations-custom-svg "+t.customSVG.cssClass});g.attr({transform:"translate(".concat(s+t.customSVG.offsetX,", ").concat(o+t.customSVG.offsetY,")")}),g.node.innerHTML=t.customSVG.SVG,e.appendChild(g.node)}if(t.image.path){var u=t.image.width?t.image.width:20,f=t.image.height?t.image.height:20;h=this.annoCtx.addImage({x:s+t.image.offsetX-u/2,y:o+t.image.offsetY-f/2,width:u,height:f,path:t.image.path,appendTo:".apexcharts-point-annotations"})}t.mouseEnter&&h.node.addEventListener("mouseenter",t.mouseEnter.bind(this,t)),t.mouseLeave&&h.node.addEventListener("mouseleave",t.mouseLeave.bind(this,t)),t.click&&h.node.addEventListener("click",t.click.bind(this,t))}}}},{key:"drawPointAnnotations",value:function(){var t=this,e=this.w,i=this.annoCtx.graphics.group({class:"apexcharts-point-annotations"});return e.config.annotations.points.map((function(e,a){t.addPointAnnotation(e,i.node,a)})),i}}]),t}();var z={name:"en",options:{months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],toolbar:{exportToSVG:"Download SVG",exportToPNG:"Download PNG",exportToCSV:"Download CSV",menu:"Menu",selection:"Selection",selectionZoom:"Selection Zoom",zoomIn:"Zoom In",zoomOut:"Zoom Out",pan:"Panning",reset:"Reset Zoom"}}},X=function(){function t(){i(this,t),this.yAxis={show:!0,showAlways:!1,showForNullSeries:!0,seriesName:void 0,opposite:!1,reversed:!1,logarithmic:!1,logBase:10,tickAmount:void 0,stepSize:void 0,forceNiceScale:!1,max:void 0,min:void 0,floating:!1,decimalsInFloat:void 0,labels:{show:!0,showDuplicates:!1,minWidth:0,maxWidth:160,offsetX:0,offsetY:0,align:void 0,rotate:0,padding:20,style:{colors:[],fontSize:"11px",fontWeight:400,fontFamily:void 0,cssClass:""},formatter:void 0},axisBorder:{show:!1,color:"#e0e0e0",width:1,offsetX:0,offsetY:0},axisTicks:{show:!1,color:"#e0e0e0",width:6,offsetX:0,offsetY:0},title:{text:void 0,rotate:-90,offsetY:0,offsetX:0,style:{color:void 0,fontSize:"11px",fontWeight:900,fontFamily:void 0,cssClass:""}},tooltip:{enabled:!1,offsetX:0},crosshairs:{show:!0,position:"front",stroke:{color:"#b6b6b6",width:1,dashArray:0}}},this.pointAnnotation={id:void 0,x:0,y:null,yAxisIndex:0,seriesIndex:void 0,mouseEnter:void 0,mouseLeave:void 0,click:void 0,marker:{size:4,fillColor:"#fff",strokeWidth:2,strokeColor:"#333",shape:"circle",offsetX:0,offsetY:0,cssClass:""},label:{borderColor:"#c2c2c2",borderWidth:1,borderRadius:2,text:void 0,textAnchor:"middle",offsetX:0,offsetY:0,mouseEnter:void 0,mouseLeave:void 0,click:void 0,style:{background:"#fff",color:void 0,fontSize:"11px",fontFamily:void 0,fontWeight:400,cssClass:"",padding:{left:5,right:5,top:2,bottom:2}}},customSVG:{SVG:void 0,cssClass:void 0,offsetX:0,offsetY:0},image:{path:void 0,width:20,height:20,offsetX:0,offsetY:0}},this.yAxisAnnotation={id:void 0,y:0,y2:null,strokeDashArray:1,fillColor:"#c2c2c2",borderColor:"#c2c2c2",borderWidth:1,opacity:.3,offsetX:0,offsetY:0,width:"100%",yAxisIndex:0,label:{borderColor:"#c2c2c2",borderWidth:1,borderRadius:2,text:void 0,textAnchor:"end",position:"right",offsetX:0,offsetY:-3,mouseEnter:void 0,mouseLeave:void 0,click:void 0,style:{background:"#fff",color:void 0,fontSize:"11px",fontFamily:void 0,fontWeight:400,cssClass:"",padding:{left:5,right:5,top:2,bottom:2}}}},this.xAxisAnnotation={id:void 0,x:0,x2:null,strokeDashArray:1,fillColor:"#c2c2c2",borderColor:"#c2c2c2",borderWidth:1,opacity:.3,offsetX:0,offsetY:0,label:{borderColor:"#c2c2c2",borderWidth:1,borderRadius:2,text:void 0,textAnchor:"middle",orientation:"vertical",position:"top",offsetX:0,offsetY:0,mouseEnter:void 0,mouseLeave:void 0,click:void 0,style:{background:"#fff",color:void 0,fontSize:"11px",fontFamily:void 0,fontWeight:400,cssClass:"",padding:{left:5,right:5,top:2,bottom:2}}}},this.text={x:0,y:0,text:"",textAnchor:"start",foreColor:void 0,fontSize:"13px",fontFamily:void 0,fontWeight:400,appendTo:".apexcharts-annotations",backgroundColor:"transparent",borderColor:"#c2c2c2",borderRadius:0,borderWidth:0,paddingLeft:4,paddingRight:4,paddingTop:2,paddingBottom:2}}return s(t,[{key:"init",value:function(){return{annotations:{yaxis:[this.yAxisAnnotation],xaxis:[this.xAxisAnnotation],points:[this.pointAnnotation],texts:[],images:[],shapes:[]},chart:{animations:{enabled:!0,easing:"easeinout",speed:800,animateGradually:{delay:150,enabled:!0},dynamicAnimation:{enabled:!0,speed:350}},background:"",locales:[z],defaultLocale:"en",dropShadow:{enabled:!1,enabledOnSeries:void 0,top:2,left:2,blur:4,color:"#000",opacity:.35},events:{animationEnd:void 0,beforeMount:void 0,mounted:void 0,updated:void 0,click:void 0,mouseMove:void 0,mouseLeave:void 0,xAxisLabelClick:void 0,legendClick:void 0,markerClick:void 0,selection:void 0,dataPointSelection:void 0,dataPointMouseEnter:void 0,dataPointMouseLeave:void 0,beforeZoom:void 0,beforeResetZoom:void 0,zoomed:void 0,scrolled:void 0,brushScrolled:void 0},foreColor:"#373d3f",fontFamily:"Helvetica, Arial, sans-serif",height:"auto",parentHeightOffset:15,redrawOnParentResize:!0,redrawOnWindowResize:!0,id:void 0,group:void 0,nonce:void 0,offsetX:0,offsetY:0,selection:{enabled:!1,type:"x",fill:{color:"#24292e",opacity:.1},stroke:{width:1,color:"#24292e",opacity:.4,dashArray:3},xaxis:{min:void 0,max:void 0},yaxis:{min:void 0,max:void 0}},sparkline:{enabled:!1},brush:{enabled:!1,autoScaleYaxis:!0,target:void 0,targets:void 0},stacked:!1,stackOnlyBar:!0,stackType:"normal",toolbar:{show:!0,offsetX:0,offsetY:0,tools:{download:!0,selection:!0,zoom:!0,zoomin:!0,zoomout:!0,pan:!0,reset:!0,customIcons:[]},export:{csv:{filename:void 0,columnDelimiter:",",headerCategory:"category",headerValue:"value",categoryFormatter:void 0,valueFormatter:void 0},png:{filename:void 0},svg:{filename:void 0},scale:void 0,width:void 0},autoSelected:"zoom"},type:"line",width:"100%",zoom:{enabled:!0,type:"x",autoScaleYaxis:!1,allowMouseWheelZoom:!0,zoomedArea:{fill:{color:"#90CAF9",opacity:.4},stroke:{color:"#0D47A1",opacity:.4,width:1}}}},plotOptions:{line:{isSlopeChart:!1},area:{fillTo:"origin"},bar:{horizontal:!1,columnWidth:"70%",barHeight:"70%",distributed:!1,borderRadius:0,borderRadiusApplication:"around",borderRadiusWhenStacked:"last",rangeBarOverlap:!0,rangeBarGroupRows:!1,hideZeroBarsWhenGrouped:!1,isDumbbell:!1,dumbbellColors:void 0,isFunnel:!1,isFunnel3d:!0,colors:{ranges:[],backgroundBarColors:[],backgroundBarOpacity:1,backgroundBarRadius:0},dataLabels:{position:"top",maxItems:100,hideOverflowingLabels:!0,orientation:"horizontal",total:{enabled:!1,formatter:void 0,offsetX:0,offsetY:0,style:{color:"#373d3f",fontSize:"12px",fontFamily:void 0,fontWeight:600}}}},bubble:{zScaling:!0,minBubbleRadius:void 0,maxBubbleRadius:void 0},candlestick:{colors:{upward:"#00B746",downward:"#EF403C"},wick:{useFillColor:!0}},boxPlot:{colors:{upper:"#00E396",lower:"#008FFB"}},heatmap:{radius:2,enableShades:!0,shadeIntensity:.5,reverseNegativeShade:!1,distributed:!1,useFillColorAsStroke:!1,colorScale:{inverse:!1,ranges:[],min:void 0,max:void 0}},treemap:{enableShades:!0,shadeIntensity:.5,distributed:!1,reverseNegativeShade:!1,useFillColorAsStroke:!1,borderRadius:4,dataLabels:{format:"scale"},colorScale:{inverse:!1,ranges:[],min:void 0,max:void 0}},radialBar:{inverseOrder:!1,startAngle:0,endAngle:360,offsetX:0,offsetY:0,hollow:{margin:5,size:"50%",background:"transparent",image:void 0,imageWidth:150,imageHeight:150,imageOffsetX:0,imageOffsetY:0,imageClipped:!0,position:"front",dropShadow:{enabled:!1,top:0,left:0,blur:3,color:"#000",opacity:.5}},track:{show:!0,startAngle:void 0,endAngle:void 0,background:"#f2f2f2",strokeWidth:"97%",opacity:1,margin:5,dropShadow:{enabled:!1,top:0,left:0,blur:3,color:"#000",opacity:.5}},dataLabels:{show:!0,name:{show:!0,fontSize:"16px",fontFamily:void 0,fontWeight:600,color:void 0,offsetY:0,formatter:function(t){return t}},value:{show:!0,fontSize:"14px",fontFamily:void 0,fontWeight:400,color:void 0,offsetY:16,formatter:function(t){return t+"%"}},total:{show:!1,label:"Total",fontSize:"16px",fontWeight:600,fontFamily:void 0,color:void 0,formatter:function(t){return t.globals.seriesTotals.reduce((function(t,e){return t+e}),0)/t.globals.series.length+"%"}}},barLabels:{enabled:!1,offsetX:0,offsetY:0,useSeriesColors:!0,fontFamily:void 0,fontWeight:600,fontSize:"16px",formatter:function(t){return t},onClick:void 0}},pie:{customScale:1,offsetX:0,offsetY:0,startAngle:0,endAngle:360,expandOnClick:!0,dataLabels:{offset:0,minAngleToShowLabel:10},donut:{size:"65%",background:"transparent",labels:{show:!1,name:{show:!0,fontSize:"16px",fontFamily:void 0,fontWeight:600,color:void 0,offsetY:-10,formatter:function(t){return t}},value:{show:!0,fontSize:"20px",fontFamily:void 0,fontWeight:400,color:void 0,offsetY:10,formatter:function(t){return t}},total:{show:!1,showAlways:!1,label:"Total",fontSize:"16px",fontWeight:400,fontFamily:void 0,color:void 0,formatter:function(t){return t.globals.seriesTotals.reduce((function(t,e){return t+e}),0)}}}}},polarArea:{rings:{strokeWidth:1,strokeColor:"#e8e8e8"},spokes:{strokeWidth:1,connectorColors:"#e8e8e8"}},radar:{size:void 0,offsetX:0,offsetY:0,polygons:{strokeWidth:1,strokeColors:"#e8e8e8",connectorColors:"#e8e8e8",fill:{colors:void 0}}}},colors:void 0,dataLabels:{enabled:!0,enabledOnSeries:void 0,formatter:function(t){return null!==t?t:""},textAnchor:"middle",distributed:!1,offsetX:0,offsetY:0,style:{fontSize:"12px",fontFamily:void 0,fontWeight:600,colors:void 0},background:{enabled:!0,foreColor:"#fff",borderRadius:2,padding:4,opacity:.9,borderWidth:1,borderColor:"#fff",dropShadow:{enabled:!1,top:1,left:1,blur:1,color:"#000",opacity:.45}},dropShadow:{enabled:!1,top:1,left:1,blur:1,color:"#000",opacity:.45}},fill:{type:"solid",colors:void 0,opacity:.85,gradient:{shade:"dark",type:"horizontal",shadeIntensity:.5,gradientToColors:void 0,inverseColors:!0,opacityFrom:1,opacityTo:1,stops:[0,50,100],colorStops:[]},image:{src:[],width:void 0,height:void 0},pattern:{style:"squares",width:6,height:6,strokeWidth:2}},forecastDataPoints:{count:0,fillOpacity:.5,strokeWidth:void 0,dashArray:4},grid:{show:!0,borderColor:"#e0e0e0",strokeDashArray:0,position:"back",xaxis:{lines:{show:!1}},yaxis:{lines:{show:!0}},row:{colors:void 0,opacity:.5},column:{colors:void 0,opacity:.5},padding:{top:0,right:10,bottom:0,left:12}},labels:[],legend:{show:!0,showForSingleSeries:!1,showForNullSeries:!0,showForZeroSeries:!0,floating:!1,position:"bottom",horizontalAlign:"center",inverseOrder:!1,fontSize:"12px",fontFamily:void 0,fontWeight:400,width:void 0,height:void 0,formatter:void 0,tooltipHoverFormatter:void 0,offsetX:-20,offsetY:4,customLegendItems:[],labels:{colors:void 0,useSeriesColors:!1},markers:{size:7,fillColors:void 0,strokeWidth:1,shape:void 0,offsetX:0,offsetY:0,customHTML:void 0,onClick:void 0},itemMargin:{horizontal:5,vertical:4},onItemClick:{toggleDataSeries:!0},onItemHover:{highlightDataSeries:!0}},markers:{discrete:[],size:0,colors:void 0,strokeColors:"#fff",strokeWidth:2,strokeOpacity:.9,strokeDashArray:0,fillOpacity:1,shape:"circle",offsetX:0,offsetY:0,showNullDataPoints:!0,onClick:void 0,onDblClick:void 0,hover:{size:void 0,sizeOffset:3}},noData:{text:void 0,align:"center",verticalAlign:"middle",offsetX:0,offsetY:0,style:{color:void 0,fontSize:"14px",fontFamily:void 0}},responsive:[],series:void 0,states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"lighten",value:.1}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"darken",value:.5}}},title:{text:void 0,align:"left",margin:5,offsetX:0,offsetY:0,floating:!1,style:{fontSize:"14px",fontWeight:900,fontFamily:void 0,color:void 0}},subtitle:{text:void 0,align:"left",margin:5,offsetX:0,offsetY:30,floating:!1,style:{fontSize:"12px",fontWeight:400,fontFamily:void 0,color:void 0}},stroke:{show:!0,curve:"smooth",lineCap:"butt",width:2,colors:void 0,dashArray:0,fill:{type:"solid",colors:void 0,opacity:.85,gradient:{shade:"dark",type:"horizontal",shadeIntensity:.5,gradientToColors:void 0,inverseColors:!0,opacityFrom:1,opacityTo:1,stops:[0,50,100],colorStops:[]}}},tooltip:{enabled:!0,enabledOnSeries:void 0,shared:!0,hideEmptySeries:!1,followCursor:!1,intersect:!1,inverseOrder:!1,custom:void 0,fillSeriesColor:!1,theme:"light",cssClass:"",style:{fontSize:"12px",fontFamily:void 0},onDatasetHover:{highlightDataSeries:!1},x:{show:!0,format:"dd MMM",formatter:void 0},y:{formatter:void 0,title:{formatter:function(t){return t?t+": ":""}}},z:{formatter:void 0,title:"Size: "},marker:{show:!0,fillColors:void 0},items:{display:"flex"},fixed:{enabled:!1,position:"topRight",offsetX:0,offsetY:0}},xaxis:{type:"category",categories:[],convertedCatToNumeric:!1,offsetX:0,offsetY:0,overwriteCategories:void 0,labels:{show:!0,rotate:-45,rotateAlways:!1,hideOverlappingLabels:!0,trim:!1,minHeight:void 0,maxHeight:120,showDuplicates:!0,style:{colors:[],fontSize:"12px",fontWeight:400,fontFamily:void 0,cssClass:""},offsetX:0,offsetY:0,format:void 0,formatter:void 0,datetimeUTC:!0,datetimeFormatter:{year:"yyyy",month:"MMM 'yy",day:"dd MMM",hour:"HH:mm",minute:"HH:mm:ss",second:"HH:mm:ss"}},group:{groups:[],style:{colors:[],fontSize:"12px",fontWeight:400,fontFamily:void 0,cssClass:""}},axisBorder:{show:!0,color:"#e0e0e0",width:"100%",height:1,offsetX:0,offsetY:0},axisTicks:{show:!0,color:"#e0e0e0",height:6,offsetX:0,offsetY:0},stepSize:void 0,tickAmount:void 0,tickPlacement:"on",min:void 0,max:void 0,range:void 0,floating:!1,decimalsInFloat:void 0,position:"bottom",title:{text:void 0,offsetX:0,offsetY:0,style:{color:void 0,fontSize:"12px",fontWeight:900,fontFamily:void 0,cssClass:""}},crosshairs:{show:!0,width:1,position:"back",opacity:.9,stroke:{color:"#b6b6b6",width:1,dashArray:3},fill:{type:"solid",color:"#B1B9C4",gradient:{colorFrom:"#D8E3F0",colorTo:"#BED1E6",stops:[0,100],opacityFrom:.4,opacityTo:.5}},dropShadow:{enabled:!1,left:0,top:0,blur:1,opacity:.4}},tooltip:{enabled:!0,offsetY:0,formatter:void 0,style:{fontSize:"12px",fontFamily:void 0}}},yaxis:this.yAxis,theme:{mode:"",palette:"palette1",monochrome:{enabled:!1,color:"#008FFB",shadeTo:"light",shadeIntensity:.65}}}}}]),t}(),E=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w,this.graphics=new k(this.ctx),this.w.globals.isBarHorizontal&&(this.invertAxis=!0),this.helpers=new S(this),this.xAxisAnnotations=new C(this),this.yAxisAnnotations=new I(this),this.pointsAnnotations=new T(this),this.w.globals.isBarHorizontal&&this.w.config.yaxis[0].reversed&&(this.inversedReversedAxis=!0),this.xDivision=this.w.globals.gridWidth/this.w.globals.dataPoints}return s(t,[{key:"drawAxesAnnotations",value:function(){var t=this.w;if(t.globals.axisCharts&&t.globals.dataPoints){for(var e=this.yAxisAnnotations.drawYAxisAnnotations(),i=this.xAxisAnnotations.drawXAxisAnnotations(),a=this.pointsAnnotations.drawPointAnnotations(),s=t.config.chart.animations.enabled,r=[e,i,a],o=[i.node,e.node,a.node],n=0;n<3;n++)t.globals.dom.elGraphical.add(r[n]),!s||t.globals.resized||t.globals.dataChanged||"scatter"!==t.config.chart.type&&"bubble"!==t.config.chart.type&&t.globals.dataPoints>1&&o[n].classList.add("apexcharts-element-hidden"),t.globals.delayedElements.push({el:o[n],index:0});this.helpers.annotationsBackground()}}},{key:"drawImageAnnos",value:function(){var t=this;this.w.config.annotations.images.map((function(e,i){t.addImage(e,i)}))}},{key:"drawTextAnnos",value:function(){var t=this;this.w.config.annotations.texts.map((function(e,i){t.addText(e,i)}))}},{key:"addXaxisAnnotation",value:function(t,e,i){this.xAxisAnnotations.addXaxisAnnotation(t,e,i)}},{key:"addYaxisAnnotation",value:function(t,e,i){this.yAxisAnnotations.addYaxisAnnotation(t,e,i)}},{key:"addPointAnnotation",value:function(t,e,i){this.pointsAnnotations.addPointAnnotation(t,e,i)}},{key:"addText",value:function(t,e){var i=t.x,a=t.y,s=t.text,r=t.textAnchor,o=t.foreColor,n=t.fontSize,l=t.fontFamily,h=t.fontWeight,c=t.cssClass,d=t.backgroundColor,g=t.borderWidth,u=t.strokeDashArray,f=t.borderRadius,p=t.borderColor,x=t.appendTo,b=void 0===x?".apexcharts-svg":x,v=t.paddingLeft,m=void 0===v?4:v,y=t.paddingRight,w=void 0===y?4:y,k=t.paddingBottom,A=void 0===k?2:k,S=t.paddingTop,C=void 0===S?2:S,L=this.w,P=this.graphics.drawText({x:i,y:a,text:s,textAnchor:r||"start",fontSize:n||"12px",fontWeight:h||"regular",fontFamily:l||L.config.chart.fontFamily,foreColor:o||L.config.chart.foreColor,cssClass:c}),M=L.globals.dom.baseEl.querySelector(b);M&&M.appendChild(P.node);var I=P.bbox();if(s){var T=this.graphics.drawRect(I.x-m,I.y-C,I.width+m+w,I.height+A+C,f,d||"transparent",1,g,p,u);M.insertBefore(T.node,P.node)}}},{key:"addImage",value:function(t,e){var i=this.w,a=t.path,s=t.x,r=void 0===s?0:s,o=t.y,n=void 0===o?0:o,l=t.width,h=void 0===l?20:l,c=t.height,d=void 0===c?20:c,g=t.appendTo,u=void 0===g?".apexcharts-svg":g,f=i.globals.dom.Paper.image(a);f.size(h,d).move(r,n);var p=i.globals.dom.baseEl.querySelector(u);return p&&p.appendChild(f.node),f}},{key:"addXaxisAnnotationExternal",value:function(t,e,i){return this.addAnnotationExternal({params:t,pushToMemory:e,context:i,type:"xaxis",contextMethod:i.addXaxisAnnotation}),i}},{key:"addYaxisAnnotationExternal",value:function(t,e,i){return this.addAnnotationExternal({params:t,pushToMemory:e,context:i,type:"yaxis",contextMethod:i.addYaxisAnnotation}),i}},{key:"addPointAnnotationExternal",value:function(t,e,i){return void 0===this.invertAxis&&(this.invertAxis=i.w.globals.isBarHorizontal),this.addAnnotationExternal({params:t,pushToMemory:e,context:i,type:"point",contextMethod:i.addPointAnnotation}),i}},{key:"addAnnotationExternal",value:function(t){var e=t.params,i=t.pushToMemory,a=t.context,s=t.type,r=t.contextMethod,o=a,n=o.w,l=n.globals.dom.baseEl.querySelector(".apexcharts-".concat(s,"-annotations")),h=l.childNodes.length+1,c=new X,d=Object.assign({},"xaxis"===s?c.xAxisAnnotation:"yaxis"===s?c.yAxisAnnotation:c.pointAnnotation),g=m.extend(d,e);switch(s){case"xaxis":this.addXaxisAnnotation(g,l,h);break;case"yaxis":this.addYaxisAnnotation(g,l,h);break;case"point":this.addPointAnnotation(g,l,h)}var u=n.globals.dom.baseEl.querySelector(".apexcharts-".concat(s,"-annotations .apexcharts-").concat(s,"-annotation-label[rel='").concat(h,"']")),f=this.helpers.addBackgroundToAnno(u,g);return f&&l.insertBefore(f.node,u),i&&n.globals.memory.methodsToExec.push({context:o,id:g.id?g.id:m.randomId(),method:r,label:"addAnnotation",params:e}),a}},{key:"clearAnnotations",value:function(t){for(var e=t.w,i=e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-annotations, .apexcharts-xaxis-annotations, .apexcharts-point-annotations"),a=e.globals.memory.methodsToExec.length-1;a>=0;a--)"addText"!==e.globals.memory.methodsToExec[a].label&&"addAnnotation"!==e.globals.memory.methodsToExec[a].label||e.globals.memory.methodsToExec.splice(a,1);i=m.listToArray(i),Array.prototype.forEach.call(i,(function(t){for(;t.firstChild;)t.removeChild(t.firstChild)}))}},{key:"removeAnnotation",value:function(t,e){var i=t.w,a=i.globals.dom.baseEl.querySelectorAll(".".concat(e));a&&(i.globals.memory.methodsToExec.map((function(t,a){t.id===e&&i.globals.memory.methodsToExec.splice(a,1)})),Array.prototype.forEach.call(a,(function(t){t.parentElement.removeChild(t)})))}}]),t}(),Y=function(t){var e,i=t.isTimeline,a=t.ctx,s=t.seriesIndex,r=t.dataPointIndex,o=t.y1,n=t.y2,l=t.w,h=l.globals.seriesRangeStart[s][r],c=l.globals.seriesRangeEnd[s][r],d=l.globals.labels[r],g=l.config.series[s].name?l.config.series[s].name:"",u=l.globals.ttKeyFormatter,f=l.config.tooltip.y.title.formatter,p={w:l,seriesIndex:s,dataPointIndex:r,start:h,end:c};("function"==typeof f&&(g=f(g,p)),null!==(e=l.config.series[s].data[r])&&void 0!==e&&e.x&&(d=l.config.series[s].data[r].x),i)||"datetime"===l.config.xaxis.type&&(d=new P(a).xLabelFormat(l.globals.ttKeyFormatter,d,d,{i:void 0,dateFormatter:new L(a).formatDate,w:l}));"function"==typeof u&&(d=u(d,p)),Number.isFinite(o)&&Number.isFinite(n)&&(h=o,c=n);var x="",b="",v=l.globals.colors[s];if(void 0===l.config.tooltip.x.formatter)if("datetime"===l.config.xaxis.type){var m=new L(a);x=m.formatDate(m.getDate(h),l.config.tooltip.x.format),b=m.formatDate(m.getDate(c),l.config.tooltip.x.format)}else x=h,b=c;else x=l.config.tooltip.x.formatter(h),b=l.config.tooltip.x.formatter(c);return{start:h,end:c,startVal:x,endVal:b,ylabel:d,color:v,seriesName:g}},R=function(t){var e=t.color,i=t.seriesName,a=t.ylabel,s=t.start,r=t.end,o=t.seriesIndex,n=t.dataPointIndex,l=t.ctx.tooltip.tooltipLabels.getFormatters(o);s=l.yLbFormatter(s),r=l.yLbFormatter(r);var h=l.yLbFormatter(t.w.globals.series[o][n]),c='<span class="value start-value">\n  '.concat(s,'\n  </span> <span class="separator">-</span> <span class="value end-value">\n  ').concat(r,"\n  </span>");return'<div class="apexcharts-tooltip-rangebar"><div> <span class="series-name" style="color: '+e+'">'+(i||"")+'</span></div><div> <span class="category">'+a+": </span> "+(t.w.globals.comboCharts?"rangeArea"===t.w.config.series[o].type||"rangeBar"===t.w.config.series[o].type?c:"<span>".concat(h,"</span>"):c)+" </div></div>"},F=function(){function t(e){i(this,t),this.opts=e}return s(t,[{key:"hideYAxis",value:function(){this.opts.yaxis[0].show=!1,this.opts.yaxis[0].title.text="",this.opts.yaxis[0].axisBorder.show=!1,this.opts.yaxis[0].axisTicks.show=!1,this.opts.yaxis[0].floating=!0}},{key:"line",value:function(){return{chart:{animations:{easing:"swing"}},dataLabels:{enabled:!1},stroke:{width:5,curve:"straight"},markers:{size:0,hover:{sizeOffset:6}},xaxis:{crosshairs:{width:1}}}}},{key:"sparkline",value:function(t){this.hideYAxis();return m.extend(t,{grid:{show:!1,padding:{left:0,right:0,top:0,bottom:0}},legend:{show:!1},xaxis:{labels:{show:!1},tooltip:{enabled:!1},axisBorder:{show:!1},axisTicks:{show:!1}},chart:{toolbar:{show:!1},zoom:{enabled:!1}},dataLabels:{enabled:!1}})}},{key:"slope",value:function(){return this.hideYAxis(),{chart:{toolbar:{show:!1},zoom:{enabled:!1}},dataLabels:{enabled:!0,formatter:function(t,e){var i=e.w.config.series[e.seriesIndex].name;return null!==t?i+": "+t:""},background:{enabled:!1},offsetX:-5},grid:{xaxis:{lines:{show:!0}},yaxis:{lines:{show:!1}}},xaxis:{position:"top",labels:{style:{fontSize:14,fontWeight:900}},tooltip:{enabled:!1},crosshairs:{show:!1}},markers:{size:8,hover:{sizeOffset:1}},legend:{show:!1},tooltip:{shared:!1,intersect:!0,followCursor:!0},stroke:{width:5,curve:"straight"}}}},{key:"bar",value:function(){return{chart:{stacked:!1,animations:{easing:"swing"}},plotOptions:{bar:{dataLabels:{position:"center"}}},dataLabels:{style:{colors:["#fff"]},background:{enabled:!1}},stroke:{width:0,lineCap:"round"},fill:{opacity:.85},legend:{markers:{shape:"square"}},tooltip:{shared:!1,intersect:!0},xaxis:{tooltip:{enabled:!1},tickPlacement:"between",crosshairs:{width:"barWidth",position:"back",fill:{type:"gradient"},dropShadow:{enabled:!1},stroke:{width:0}}}}}},{key:"funnel",value:function(){return this.hideYAxis(),g(g({},this.bar()),{},{chart:{animations:{easing:"linear",speed:800,animateGradually:{enabled:!1}}},plotOptions:{bar:{horizontal:!0,borderRadiusApplication:"around",borderRadius:0,dataLabels:{position:"center"}}},grid:{show:!1,padding:{left:0,right:0}},xaxis:{labels:{show:!1},tooltip:{enabled:!1},axisBorder:{show:!1},axisTicks:{show:!1}}})}},{key:"candlestick",value:function(){var t=this;return{stroke:{width:1,colors:["#333"]},fill:{opacity:1},dataLabels:{enabled:!1},tooltip:{shared:!0,custom:function(e){var i=e.seriesIndex,a=e.dataPointIndex,s=e.w;return t._getBoxTooltip(s,i,a,["Open","High","","Low","Close"],"candlestick")}},states:{active:{filter:{type:"none"}}},xaxis:{crosshairs:{width:1}}}}},{key:"boxPlot",value:function(){var t=this;return{chart:{animations:{dynamicAnimation:{enabled:!1}}},stroke:{width:1,colors:["#24292e"]},dataLabels:{enabled:!1},tooltip:{shared:!0,custom:function(e){var i=e.seriesIndex,a=e.dataPointIndex,s=e.w;return t._getBoxTooltip(s,i,a,["Minimum","Q1","Median","Q3","Maximum"],"boxPlot")}},markers:{size:7,strokeWidth:1,strokeColors:"#111"},xaxis:{crosshairs:{width:1}}}}},{key:"rangeBar",value:function(){return{chart:{animations:{animateGradually:!1}},stroke:{width:0,lineCap:"square"},plotOptions:{bar:{borderRadius:0,dataLabels:{position:"center"}}},dataLabels:{enabled:!1,formatter:function(t,e){e.ctx;var i=e.seriesIndex,a=e.dataPointIndex,s=e.w,r=function(){var t=s.globals.seriesRangeStart[i][a];return s.globals.seriesRangeEnd[i][a]-t};return s.globals.comboCharts?"rangeBar"===s.config.series[i].type||"rangeArea"===s.config.series[i].type?r():t:r()},background:{enabled:!1},style:{colors:["#fff"]}},markers:{size:10},tooltip:{shared:!1,followCursor:!0,custom:function(t){return t.w.config.plotOptions&&t.w.config.plotOptions.bar&&t.w.config.plotOptions.bar.horizontal?function(t){var e=Y(g(g({},t),{},{isTimeline:!0})),i=e.color,a=e.seriesName,s=e.ylabel,r=e.startVal,o=e.endVal;return R(g(g({},t),{},{color:i,seriesName:a,ylabel:s,start:r,end:o}))}(t):function(t){var e=Y(t),i=e.color,a=e.seriesName,s=e.ylabel,r=e.start,o=e.end;return R(g(g({},t),{},{color:i,seriesName:a,ylabel:s,start:r,end:o}))}(t)}},xaxis:{tickPlacement:"between",tooltip:{enabled:!1},crosshairs:{stroke:{width:0}}}}}},{key:"dumbbell",value:function(t){var e,i;return null!==(e=t.plotOptions.bar)&&void 0!==e&&e.barHeight||(t.plotOptions.bar.barHeight=2),null!==(i=t.plotOptions.bar)&&void 0!==i&&i.columnWidth||(t.plotOptions.bar.columnWidth=2),t}},{key:"area",value:function(){return{stroke:{width:4,fill:{type:"solid",gradient:{inverseColors:!1,shade:"light",type:"vertical",opacityFrom:.65,opacityTo:.5,stops:[0,100,100]}}},fill:{type:"gradient",gradient:{inverseColors:!1,shade:"light",type:"vertical",opacityFrom:.65,opacityTo:.5,stops:[0,100,100]}},markers:{size:0,hover:{sizeOffset:6}},tooltip:{followCursor:!1}}}},{key:"rangeArea",value:function(){return{stroke:{curve:"straight",width:0},fill:{type:"solid",opacity:.6},markers:{size:0},states:{hover:{filter:{type:"none"}},active:{filter:{type:"none"}}},tooltip:{intersect:!1,shared:!0,followCursor:!0,custom:function(t){return function(t){var e=Y(t),i=e.color,a=e.seriesName,s=e.ylabel,r=e.start,o=e.end;return R(g(g({},t),{},{color:i,seriesName:a,ylabel:s,start:r,end:o}))}(t)}}}}},{key:"brush",value:function(t){return m.extend(t,{chart:{toolbar:{autoSelected:"selection",show:!1},zoom:{enabled:!1}},dataLabels:{enabled:!1},stroke:{width:1},tooltip:{enabled:!1},xaxis:{tooltip:{enabled:!1}}})}},{key:"stacked100",value:function(t){t.dataLabels=t.dataLabels||{},t.dataLabels.formatter=t.dataLabels.formatter||void 0;var e=t.dataLabels.formatter;return t.yaxis.forEach((function(e,i){t.yaxis[i].min=0,t.yaxis[i].max=100})),"bar"===t.chart.type&&(t.dataLabels.formatter=e||function(t){return"number"==typeof t&&t?t.toFixed(0)+"%":t}),t}},{key:"stackedBars",value:function(){var t=this.bar();return g(g({},t),{},{plotOptions:g(g({},t.plotOptions),{},{bar:g(g({},t.plotOptions.bar),{},{borderRadiusApplication:"end",borderRadiusWhenStacked:"last"})})})}},{key:"convertCatToNumeric",value:function(t){return t.xaxis.convertedCatToNumeric=!0,t}},{key:"convertCatToNumericXaxis",value:function(t,e,i){t.xaxis.type="numeric",t.xaxis.labels=t.xaxis.labels||{},t.xaxis.labels.formatter=t.xaxis.labels.formatter||function(t){return m.isNumber(t)?Math.floor(t):t};var a=t.xaxis.labels.formatter,s=t.xaxis.categories&&t.xaxis.categories.length?t.xaxis.categories:t.labels;return i&&i.length&&(s=i.map((function(t){return Array.isArray(t)?t:String(t)}))),s&&s.length&&(t.xaxis.labels.formatter=function(t){return m.isNumber(t)?a(s[Math.floor(t)-1]):a(t)}),t.xaxis.categories=[],t.labels=[],t.xaxis.tickAmount=t.xaxis.tickAmount||"dataPoints",t}},{key:"bubble",value:function(){return{dataLabels:{style:{colors:["#fff"]}},tooltip:{shared:!1,intersect:!0},xaxis:{crosshairs:{width:0}},fill:{type:"solid",gradient:{shade:"light",inverse:!0,shadeIntensity:.55,opacityFrom:.4,opacityTo:.8}}}}},{key:"scatter",value:function(){return{dataLabels:{enabled:!1},tooltip:{shared:!1,intersect:!0},markers:{size:6,strokeWidth:1,hover:{sizeOffset:2}}}}},{key:"heatmap",value:function(){return{chart:{stacked:!1},fill:{opacity:1},dataLabels:{style:{colors:["#fff"]}},stroke:{colors:["#fff"]},tooltip:{followCursor:!0,marker:{show:!1},x:{show:!1}},legend:{position:"top",markers:{shape:"square"}},grid:{padding:{right:20}}}}},{key:"treemap",value:function(){return{chart:{zoom:{enabled:!1}},dataLabels:{style:{fontSize:14,fontWeight:600,colors:["#fff"]}},stroke:{show:!0,width:2,colors:["#fff"]},legend:{show:!1},fill:{opacity:1,gradient:{stops:[0,100]}},tooltip:{followCursor:!0,x:{show:!1}},grid:{padding:{left:0,right:0}},xaxis:{crosshairs:{show:!1},tooltip:{enabled:!1}}}}},{key:"pie",value:function(){return{chart:{toolbar:{show:!1}},plotOptions:{pie:{donut:{labels:{show:!1}}}},dataLabels:{formatter:function(t){return t.toFixed(1)+"%"},style:{colors:["#fff"]},background:{enabled:!1},dropShadow:{enabled:!0}},stroke:{colors:["#fff"]},fill:{opacity:1,gradient:{shade:"light",stops:[0,100]}},tooltip:{theme:"dark",fillSeriesColor:!0},legend:{position:"right"},grid:{padding:{left:0,right:0,top:0,bottom:0}}}}},{key:"donut",value:function(){return{chart:{toolbar:{show:!1}},dataLabels:{formatter:function(t){return t.toFixed(1)+"%"},style:{colors:["#fff"]},background:{enabled:!1},dropShadow:{enabled:!0}},stroke:{colors:["#fff"]},fill:{opacity:1,gradient:{shade:"light",shadeIntensity:.35,stops:[80,100],opacityFrom:1,opacityTo:1}},tooltip:{theme:"dark",fillSeriesColor:!0},legend:{position:"right"},grid:{padding:{left:0,right:0,top:0,bottom:0}}}}},{key:"polarArea",value:function(){return{chart:{toolbar:{show:!1}},dataLabels:{formatter:function(t){return t.toFixed(1)+"%"},enabled:!1},stroke:{show:!0,width:2},fill:{opacity:.7},tooltip:{theme:"dark",fillSeriesColor:!0},legend:{position:"right"},grid:{padding:{left:0,right:0,top:0,bottom:0}}}}},{key:"radar",value:function(){return this.opts.yaxis[0].labels.offsetY=this.opts.yaxis[0].labels.offsetY?this.opts.yaxis[0].labels.offsetY:6,{dataLabels:{enabled:!1,style:{fontSize:"11px"}},stroke:{width:2},markers:{size:5,strokeWidth:1,strokeOpacity:1},fill:{opacity:.2},tooltip:{shared:!1,intersect:!0,followCursor:!0},grid:{show:!1,padding:{left:0,right:0,top:0,bottom:0}},xaxis:{labels:{formatter:function(t){return t},style:{colors:["#a8a8a8"],fontSize:"11px"}},tooltip:{enabled:!1},crosshairs:{show:!1}}}}},{key:"radialBar",value:function(){return{chart:{animations:{dynamicAnimation:{enabled:!0,speed:800}},toolbar:{show:!1}},fill:{gradient:{shade:"dark",shadeIntensity:.4,inverseColors:!1,type:"diagonal2",opacityFrom:1,opacityTo:1,stops:[70,98,100]}},legend:{show:!1,position:"right"},tooltip:{enabled:!1,fillSeriesColor:!0},grid:{padding:{left:0,right:0,top:0,bottom:0}}}}},{key:"_getBoxTooltip",value:function(t,e,i,a,s){var r=t.globals.seriesCandleO[e][i],o=t.globals.seriesCandleH[e][i],n=t.globals.seriesCandleM[e][i],l=t.globals.seriesCandleL[e][i],h=t.globals.seriesCandleC[e][i];return t.config.series[e].type&&t.config.series[e].type!==s?'<div class="apexcharts-custom-tooltip">\n          '.concat(t.config.series[e].name?t.config.series[e].name:"series-"+(e+1),": <strong>").concat(t.globals.series[e][i],"</strong>\n        </div>"):'<div class="apexcharts-tooltip-box apexcharts-tooltip-'.concat(t.config.chart.type,'">')+"<div>".concat(a[0],': <span class="value">')+r+"</span></div>"+"<div>".concat(a[1],': <span class="value">')+o+"</span></div>"+(n?"<div>".concat(a[2],': <span class="value">')+n+"</span></div>":"")+"<div>".concat(a[3],': <span class="value">')+l+"</span></div>"+"<div>".concat(a[4],': <span class="value">')+h+"</span></div></div>"}}]),t}(),D=function(){function t(e){i(this,t),this.opts=e}return s(t,[{key:"init",value:function(t){var e=t.responsiveOverride,i=this.opts,a=new X,s=new F(i);this.chartType=i.chart.type,i=this.extendYAxis(i),i=this.extendAnnotations(i);var r=a.init(),o={};if(i&&"object"===b(i)){var n,l,h,c,d,g,u,f,p,x,v={};v=-1!==["line","area","bar","candlestick","boxPlot","rangeBar","rangeArea","bubble","scatter","heatmap","treemap","pie","polarArea","donut","radar","radialBar"].indexOf(i.chart.type)?s[i.chart.type]():s.line(),null!==(n=i.plotOptions)&&void 0!==n&&null!==(l=n.bar)&&void 0!==l&&l.isFunnel&&(v=s.funnel()),i.chart.stacked&&"bar"===i.chart.type&&(v=s.stackedBars()),null!==(h=i.chart.brush)&&void 0!==h&&h.enabled&&(v=s.brush(v)),null!==(c=i.plotOptions)&&void 0!==c&&null!==(d=c.line)&&void 0!==d&&d.isSlopeChart&&(v=s.slope()),i.chart.stacked&&"100%"===i.chart.stackType&&(i=s.stacked100(i)),null!==(g=i.plotOptions)&&void 0!==g&&null!==(u=g.bar)&&void 0!==u&&u.isDumbbell&&(i=s.dumbbell(i)),this.checkForDarkTheme(window.Apex),this.checkForDarkTheme(i),i.xaxis=i.xaxis||window.Apex.xaxis||{},e||(i.xaxis.convertedCatToNumeric=!1),(null!==(f=(i=this.checkForCatToNumericXAxis(this.chartType,v,i)).chart.sparkline)&&void 0!==f&&f.enabled||null!==(p=window.Apex.chart)&&void 0!==p&&null!==(x=p.sparkline)&&void 0!==x&&x.enabled)&&(v=s.sparkline(v)),o=m.extend(r,v)}var y=m.extend(o,window.Apex);return r=m.extend(y,i),r=this.handleUserInputErrors(r)}},{key:"checkForCatToNumericXAxis",value:function(t,e,i){var a,s,r=new F(i),o=("bar"===t||"boxPlot"===t)&&(null===(a=i.plotOptions)||void 0===a||null===(s=a.bar)||void 0===s?void 0:s.horizontal),n="pie"===t||"polarArea"===t||"donut"===t||"radar"===t||"radialBar"===t||"heatmap"===t,l="datetime"!==i.xaxis.type&&"numeric"!==i.xaxis.type,h=i.xaxis.tickPlacement?i.xaxis.tickPlacement:e.xaxis&&e.xaxis.tickPlacement;return o||n||!l||"between"===h||(i=r.convertCatToNumeric(i)),i}},{key:"extendYAxis",value:function(t,e){var i=new X;(void 0===t.yaxis||!t.yaxis||Array.isArray(t.yaxis)&&0===t.yaxis.length)&&(t.yaxis={}),t.yaxis.constructor!==Array&&window.Apex.yaxis&&window.Apex.yaxis.constructor!==Array&&(t.yaxis=m.extend(t.yaxis,window.Apex.yaxis)),t.yaxis.constructor!==Array?t.yaxis=[m.extend(i.yAxis,t.yaxis)]:t.yaxis=m.extendArray(t.yaxis,i.yAxis);var a=!1;t.yaxis.forEach((function(t){t.logarithmic&&(a=!0)}));var s=t.series;return e&&!s&&(s=e.config.series),a&&s.length!==t.yaxis.length&&s.length&&(t.yaxis=s.map((function(e,a){if(e.name||(s[a].name="series-".concat(a+1)),t.yaxis[a])return t.yaxis[a].seriesName=s[a].name,t.yaxis[a];var r=m.extend(i.yAxis,t.yaxis[0]);return r.show=!1,r}))),a&&s.length>1&&s.length!==t.yaxis.length&&console.warn("A multi-series logarithmic chart should have equal number of series and y-axes"),t}},{key:"extendAnnotations",value:function(t){return void 0===t.annotations&&(t.annotations={},t.annotations.yaxis=[],t.annotations.xaxis=[],t.annotations.points=[]),t=this.extendYAxisAnnotations(t),t=this.extendXAxisAnnotations(t),t=this.extendPointAnnotations(t)}},{key:"extendYAxisAnnotations",value:function(t){var e=new X;return t.annotations.yaxis=m.extendArray(void 0!==t.annotations.yaxis?t.annotations.yaxis:[],e.yAxisAnnotation),t}},{key:"extendXAxisAnnotations",value:function(t){var e=new X;return t.annotations.xaxis=m.extendArray(void 0!==t.annotations.xaxis?t.annotations.xaxis:[],e.xAxisAnnotation),t}},{key:"extendPointAnnotations",value:function(t){var e=new X;return t.annotations.points=m.extendArray(void 0!==t.annotations.points?t.annotations.points:[],e.pointAnnotation),t}},{key:"checkForDarkTheme",value:function(t){t.theme&&"dark"===t.theme.mode&&(t.tooltip||(t.tooltip={}),"light"!==t.tooltip.theme&&(t.tooltip.theme="dark"),t.chart.foreColor||(t.chart.foreColor="#f6f7f8"),t.theme.palette||(t.theme.palette="palette4"))}},{key:"handleUserInputErrors",value:function(t){var e=t;if(e.tooltip.shared&&e.tooltip.intersect)throw new Error("tooltip.shared cannot be enabled when tooltip.intersect is true. Turn off any other option by setting it to false.");if("bar"===e.chart.type&&e.plotOptions.bar.horizontal){if(e.yaxis.length>1)throw new Error("Multiple Y Axis for bars are not supported. Switch to column chart by setting plotOptions.bar.horizontal=false");e.yaxis[0].reversed&&(e.yaxis[0].opposite=!0),e.xaxis.tooltip.enabled=!1,e.yaxis[0].tooltip.enabled=!1,e.chart.zoom.enabled=!1}return"bar"!==e.chart.type&&"rangeBar"!==e.chart.type||e.tooltip.shared&&"barWidth"===e.xaxis.crosshairs.width&&e.series.length>1&&(e.xaxis.crosshairs.width="tickWidth"),"candlestick"!==e.chart.type&&"boxPlot"!==e.chart.type||e.yaxis[0].reversed&&(console.warn("Reversed y-axis in ".concat(e.chart.type," chart is not supported.")),e.yaxis[0].reversed=!1),e}}]),t}(),H=function(){function t(){i(this,t)}return s(t,[{key:"initGlobalVars",value:function(t){t.series=[],t.seriesCandleO=[],t.seriesCandleH=[],t.seriesCandleM=[],t.seriesCandleL=[],t.seriesCandleC=[],t.seriesRangeStart=[],t.seriesRangeEnd=[],t.seriesRange=[],t.seriesPercent=[],t.seriesGoals=[],t.seriesX=[],t.seriesZ=[],t.seriesNames=[],t.seriesTotals=[],t.seriesLog=[],t.seriesColors=[],t.stackedSeriesTotals=[],t.seriesXvalues=[],t.seriesYvalues=[],t.labels=[],t.hasXaxisGroups=!1,t.groups=[],t.barGroups=[],t.lineGroups=[],t.areaGroups=[],t.hasSeriesGroups=!1,t.seriesGroups=[],t.categoryLabels=[],t.timescaleLabels=[],t.noLabelsProvided=!1,t.resizeTimer=null,t.selectionResizeTimer=null,t.lastWheelExecution=0,t.delayedElements=[],t.pointsArray=[],t.dataLabelsRects=[],t.isXNumeric=!1,t.skipLastTimelinelabel=!1,t.skipFirstTimelinelabel=!1,t.isDataXYZ=!1,t.isMultiLineX=!1,t.isMultipleYAxis=!1,t.maxY=-Number.MAX_VALUE,t.minY=Number.MIN_VALUE,t.minYArr=[],t.maxYArr=[],t.maxX=-Number.MAX_VALUE,t.minX=Number.MAX_VALUE,t.initialMaxX=-Number.MAX_VALUE,t.initialMinX=Number.MAX_VALUE,t.maxDate=0,t.minDate=Number.MAX_VALUE,t.minZ=Number.MAX_VALUE,t.maxZ=-Number.MAX_VALUE,t.minXDiff=Number.MAX_VALUE,t.yAxisScale=[],t.xAxisScale=null,t.xAxisTicksPositions=[],t.yLabelsCoords=[],t.yTitleCoords=[],t.barPadForNumericAxis=0,t.padHorizontal=0,t.xRange=0,t.yRange=[],t.zRange=0,t.dataPoints=0,t.xTickAmount=0,t.multiAxisTickAmount=0}},{key:"globalVars",value:function(t){return{chartID:null,cuid:null,events:{beforeMount:[],mounted:[],updated:[],clicked:[],selection:[],dataPointSelection:[],zoomed:[],scrolled:[]},colors:[],clientX:null,clientY:null,fill:{colors:[]},stroke:{colors:[]},dataLabels:{style:{colors:[]}},radarPolygons:{fill:{colors:[]}},markers:{colors:[],size:t.markers.size,largestSize:0},animationEnded:!1,isTouchDevice:"ontouchstart"in window||navigator.msMaxTouchPoints,isDirty:!1,isExecCalled:!1,initialConfig:null,initialSeries:[],lastXAxis:[],lastYAxis:[],columnSeries:null,labels:[],timescaleLabels:[],noLabelsProvided:!1,allSeriesCollapsed:!1,collapsedSeries:[],collapsedSeriesIndices:[],ancillaryCollapsedSeries:[],ancillaryCollapsedSeriesIndices:[],risingSeries:[],dataFormatXNumeric:!1,capturedSeriesIndex:-1,capturedDataPointIndex:-1,selectedDataPoints:[],invalidLogScale:!1,ignoreYAxisIndexes:[],maxValsInArrayIndex:0,radialSize:0,selection:void 0,zoomEnabled:"zoom"===t.chart.toolbar.autoSelected&&t.chart.toolbar.tools.zoom&&t.chart.zoom.enabled,panEnabled:"pan"===t.chart.toolbar.autoSelected&&t.chart.toolbar.tools.pan,selectionEnabled:"selection"===t.chart.toolbar.autoSelected&&t.chart.toolbar.tools.selection,yaxis:null,mousedown:!1,lastClientPosition:{},visibleXRange:void 0,yValueDecimal:0,total:0,SVGNS:"http://www.w3.org/2000/svg",svgWidth:0,svgHeight:0,noData:!1,locale:{},dom:{},memory:{methodsToExec:[]},shouldAnimate:!0,skipLastTimelinelabel:!1,skipFirstTimelinelabel:!1,delayedElements:[],axisCharts:!0,isDataXYZ:!1,isSlopeChart:t.plotOptions.line.isSlopeChart,resized:!1,resizeTimer:null,comboCharts:!1,dataChanged:!1,previousPaths:[],allSeriesHasEqualX:!0,pointsArray:[],dataLabelsRects:[],lastDrawnDataLabelsIndexes:[],hasNullValues:!1,easing:null,zoomed:!1,gridWidth:0,gridHeight:0,rotateXLabels:!1,defaultLabels:!1,xLabelFormatter:void 0,yLabelFormatters:[],xaxisTooltipFormatter:void 0,ttKeyFormatter:void 0,ttVal:void 0,ttZFormatter:void 0,LINE_HEIGHT_RATIO:1.618,xAxisLabelsHeight:0,xAxisGroupLabelsHeight:0,xAxisLabelsWidth:0,yAxisLabelsWidth:0,scaleX:1,scaleY:1,translateX:0,translateY:0,translateYAxisX:[],yAxisWidths:[],translateXAxisY:0,translateXAxisX:0,tooltip:null,niceScaleAllowedMagMsd:[[1,1,2,5,5,5,10,10,10,10,10],[1,1,2,5,5,5,10,10,10,10,10]],niceScaleDefaultTicks:[1,2,4,4,6,6,6,6,6,6,6,6,6,6,6,6,6,6,12,12,12,12,12,12,12,12,12,24],seriesYAxisMap:[],seriesYAxisReverseMap:[]}}},{key:"init",value:function(t){var e=this.globalVars(t);return this.initGlobalVars(e),e.initialConfig=m.extend({},t),e.initialSeries=m.clone(t.series),e.lastXAxis=m.clone(e.initialConfig.xaxis),e.lastYAxis=m.clone(e.initialConfig.yaxis),e}}]),t}(),O=function(){function t(e){i(this,t),this.opts=e}return s(t,[{key:"init",value:function(){var t=new D(this.opts).init({responsiveOverride:!1});return{config:t,globals:(new H).init(t)}}}]),t}(),N=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w,this.opts=null,this.seriesIndex=0,this.patternIDs=[]}return s(t,[{key:"clippedImgArea",value:function(t){var e=this.w,i=e.config,a=parseInt(e.globals.gridWidth,10),s=parseInt(e.globals.gridHeight,10),r=a>s?a:s,o=t.image,n=0,l=0;void 0===t.width&&void 0===t.height?void 0!==i.fill.image.width&&void 0!==i.fill.image.height?(n=i.fill.image.width+1,l=i.fill.image.height):(n=r+1,l=r):(n=t.width,l=t.height);var h=document.createElementNS(e.globals.SVGNS,"pattern");k.setAttrs(h,{id:t.patternID,patternUnits:t.patternUnits?t.patternUnits:"userSpaceOnUse",width:n+"px",height:l+"px"});var c=document.createElementNS(e.globals.SVGNS,"image");h.appendChild(c),c.setAttributeNS(window.SVG.xlink,"href",o),k.setAttrs(c,{x:0,y:0,preserveAspectRatio:"none",width:n+"px",height:l+"px"}),c.style.opacity=t.opacity,e.globals.dom.elDefs.node.appendChild(h)}},{key:"getSeriesIndex",value:function(t){var e=this.w,i=e.config.chart.type;return("bar"===i||"rangeBar"===i)&&e.config.plotOptions.bar.distributed||"heatmap"===i||"treemap"===i?this.seriesIndex=t.seriesNumber:this.seriesIndex=t.seriesNumber%e.globals.series.length,this.seriesIndex}},{key:"fillPath",value:function(t){var e=this.w;this.opts=t;var i,a,s,r=this.w.config;this.seriesIndex=this.getSeriesIndex(t);var o=this.getFillColors()[this.seriesIndex];void 0!==e.globals.seriesColors[this.seriesIndex]&&(o=e.globals.seriesColors[this.seriesIndex]),"function"==typeof o&&(o=o({seriesIndex:this.seriesIndex,dataPointIndex:t.dataPointIndex,value:t.value,w:e}));var n=t.fillType?t.fillType:this.getFillType(this.seriesIndex),l=Array.isArray(r.fill.opacity)?r.fill.opacity[this.seriesIndex]:r.fill.opacity;t.color&&(o=t.color),o||(o="#fff",console.warn("undefined color - ApexCharts"));var h=o;if(-1===o.indexOf("rgb")?o.length<9&&(h=m.hexToRgba(o,l)):o.indexOf("rgba")>-1&&(l=m.getOpacityFromRGBA(o)),t.opacity&&(l=t.opacity),"pattern"===n&&(a=this.handlePatternFill({fillConfig:t.fillConfig,patternFill:a,fillColor:o,fillOpacity:l,defaultColor:h})),"gradient"===n&&(s=this.handleGradientFill({fillConfig:t.fillConfig,fillColor:o,fillOpacity:l,i:this.seriesIndex})),"image"===n){var c=r.fill.image.src,d=t.patternID?t.patternID:"",g="pattern".concat(e.globals.cuid).concat(t.seriesNumber+1).concat(d);-1===this.patternIDs.indexOf(g)&&(this.clippedImgArea({opacity:l,image:Array.isArray(c)?t.seriesNumber<c.length?c[t.seriesNumber]:c[0]:c,width:t.width?t.width:void 0,height:t.height?t.height:void 0,patternUnits:t.patternUnits,patternID:g}),this.patternIDs.push(g)),i="url(#".concat(g,")")}else i="gradient"===n?s:"pattern"===n?a:h;return t.solid&&(i=h),i}},{key:"getFillType",value:function(t){var e=this.w;return Array.isArray(e.config.fill.type)?e.config.fill.type[t]:e.config.fill.type}},{key:"getFillColors",value:function(){var t=this.w,e=t.config,i=this.opts,a=[];return t.globals.comboCharts?"line"===t.config.series[this.seriesIndex].type?Array.isArray(t.globals.stroke.colors)?a=t.globals.stroke.colors:a.push(t.globals.stroke.colors):Array.isArray(t.globals.fill.colors)?a=t.globals.fill.colors:a.push(t.globals.fill.colors):"line"===e.chart.type?Array.isArray(t.globals.stroke.colors)?a=t.globals.stroke.colors:a.push(t.globals.stroke.colors):Array.isArray(t.globals.fill.colors)?a=t.globals.fill.colors:a.push(t.globals.fill.colors),void 0!==i.fillColors&&(a=[],Array.isArray(i.fillColors)?a=i.fillColors.slice():a.push(i.fillColors)),a}},{key:"handlePatternFill",value:function(t){var e=t.fillConfig,i=t.patternFill,a=t.fillColor,s=t.fillOpacity,r=t.defaultColor,o=this.w.config.fill;e&&(o=e);var n=this.opts,l=new k(this.ctx),h=Array.isArray(o.pattern.strokeWidth)?o.pattern.strokeWidth[this.seriesIndex]:o.pattern.strokeWidth,c=a;Array.isArray(o.pattern.style)?i=void 0!==o.pattern.style[n.seriesNumber]?l.drawPattern(o.pattern.style[n.seriesNumber],o.pattern.width,o.pattern.height,c,h,s):r:i=l.drawPattern(o.pattern.style,o.pattern.width,o.pattern.height,c,h,s);return i}},{key:"handleGradientFill",value:function(t){var e=t.fillColor,i=t.fillOpacity,a=t.fillConfig,s=t.i,r=this.w.config.fill;a&&(r=g(g({},r),a));var o,n=this.opts,l=new k(this.ctx),h=new m,c=r.gradient.type,d=e,u=void 0===r.gradient.opacityFrom?i:Array.isArray(r.gradient.opacityFrom)?r.gradient.opacityFrom[s]:r.gradient.opacityFrom;d.indexOf("rgba")>-1&&(u=m.getOpacityFromRGBA(d));var f=void 0===r.gradient.opacityTo?i:Array.isArray(r.gradient.opacityTo)?r.gradient.opacityTo[s]:r.gradient.opacityTo;if(void 0===r.gradient.gradientToColors||0===r.gradient.gradientToColors.length)o="dark"===r.gradient.shade?h.shadeColor(-1*parseFloat(r.gradient.shadeIntensity),e.indexOf("rgb")>-1?m.rgb2hex(e):e):h.shadeColor(parseFloat(r.gradient.shadeIntensity),e.indexOf("rgb")>-1?m.rgb2hex(e):e);else if(r.gradient.gradientToColors[n.seriesNumber]){var p=r.gradient.gradientToColors[n.seriesNumber];o=p,p.indexOf("rgba")>-1&&(f=m.getOpacityFromRGBA(p))}else o=e;if(r.gradient.gradientFrom&&(d=r.gradient.gradientFrom),r.gradient.gradientTo&&(o=r.gradient.gradientTo),r.gradient.inverseColors){var x=d;d=o,o=x}return d.indexOf("rgb")>-1&&(d=m.rgb2hex(d)),o.indexOf("rgb")>-1&&(o=m.rgb2hex(o)),l.drawGradient(c,d,o,u,f,n.size,r.gradient.stops,r.gradient.colorStops,s)}}]),t}(),W=function(){function t(e,a){i(this,t),this.ctx=e,this.w=e.w}return s(t,[{key:"setGlobalMarkerSize",value:function(){var t=this.w;if(t.globals.markers.size=Array.isArray(t.config.markers.size)?t.config.markers.size:[t.config.markers.size],t.globals.markers.size.length>0){if(t.globals.markers.size.length<t.globals.series.length+1)for(var e=0;e<=t.globals.series.length;e++)void 0===t.globals.markers.size[e]&&t.globals.markers.size.push(t.globals.markers.size[0])}else t.globals.markers.size=t.config.series.map((function(e){return t.config.markers.size}))}},{key:"plotChartMarkers",value:function(t,e,i,a){var s,r=arguments.length>4&&void 0!==arguments[4]&&arguments[4],o=this.w,n=e,l=t,h=null,c=new k(this.ctx),d=o.config.markers.discrete&&o.config.markers.discrete.length;if((o.globals.markers.size[e]>0||r||d)&&(h=c.group({class:r||d?"":"apexcharts-series-markers"})).attr("clip-path","url(#gridRectMarkerMask".concat(o.globals.cuid,")")),Array.isArray(l.x))for(var g=0;g<l.x.length;g++){var u=i;1===i&&0===g&&(u=0),1===i&&1===g&&(u=1);var f="apexcharts-marker";if("line"!==o.config.chart.type&&"area"!==o.config.chart.type||o.globals.comboCharts||o.config.tooltip.intersect||(f+=" no-pointer-events"),(Array.isArray(o.config.markers.size)?o.globals.markers.size[e]>0:o.config.markers.size>0)||r||d){m.isNumber(l.y[g])?f+=" w".concat(m.randomId()):f="apexcharts-nullpoint";var p=this.getMarkerConfig({cssClass:f,seriesIndex:e,dataPointIndex:u});o.config.series[n].data[u]&&(o.config.series[n].data[u].fillColor&&(p.pointFillColor=o.config.series[n].data[u].fillColor),o.config.series[n].data[u].strokeColor&&(p.pointStrokeColor=o.config.series[n].data[u].strokeColor)),void 0!==a&&(p.pSize=a),(l.x[g]<-o.globals.markers.largestSize||l.x[g]>o.globals.gridWidth+o.globals.markers.largestSize||l.y[g]<-o.globals.markers.largestSize||l.y[g]>o.globals.gridHeight+o.globals.markers.largestSize)&&(p.pSize=0),(s=c.drawMarker(l.x[g],l.y[g],p)).attr("rel",u),s.attr("j",u),s.attr("index",e),s.node.setAttribute("default-marker-size",p.pSize),new w(this.ctx).setSelectionFilter(s,e,u),this.addEvents(s),h&&h.add(s)}else void 0===o.globals.pointsArray[e]&&(o.globals.pointsArray[e]=[]),o.globals.pointsArray[e].push([l.x[g],l.y[g]])}return h}},{key:"getMarkerConfig",value:function(t){var e=t.cssClass,i=t.seriesIndex,a=t.dataPointIndex,s=void 0===a?null:a,r=t.radius,o=void 0===r?null:r,n=t.size,l=void 0===n?null:n,h=t.strokeWidth,c=void 0===h?null:h,d=this.w,g=this.getMarkerStyle(i),u=null===l?d.globals.markers.size[i]:l,f=d.config.markers;return null!==s&&f.discrete.length&&f.discrete.map((function(t){t.seriesIndex===i&&t.dataPointIndex===s&&(g.pointStrokeColor=t.strokeColor,g.pointFillColor=t.fillColor,u=t.size,g.pointShape=t.shape)})),{pSize:null===o?u:o,pRadius:null!==o?o:f.radius,pointStrokeWidth:null!==c?c:Array.isArray(f.strokeWidth)?f.strokeWidth[i]:f.strokeWidth,pointStrokeColor:g.pointStrokeColor,pointFillColor:g.pointFillColor,shape:g.pointShape||(Array.isArray(f.shape)?f.shape[i]:f.shape),class:e,pointStrokeOpacity:Array.isArray(f.strokeOpacity)?f.strokeOpacity[i]:f.strokeOpacity,pointStrokeDashArray:Array.isArray(f.strokeDashArray)?f.strokeDashArray[i]:f.strokeDashArray,pointFillOpacity:Array.isArray(f.fillOpacity)?f.fillOpacity[i]:f.fillOpacity,seriesIndex:i}}},{key:"addEvents",value:function(t){var e=this.w,i=new k(this.ctx);t.node.addEventListener("mouseenter",i.pathMouseEnter.bind(this.ctx,t)),t.node.addEventListener("mouseleave",i.pathMouseLeave.bind(this.ctx,t)),t.node.addEventListener("mousedown",i.pathMouseDown.bind(this.ctx,t)),t.node.addEventListener("click",e.config.markers.onClick),t.node.addEventListener("dblclick",e.config.markers.onDblClick),t.node.addEventListener("touchstart",i.pathMouseDown.bind(this.ctx,t),{passive:!0})}},{key:"getMarkerStyle",value:function(t){var e=this.w,i=e.globals.markers.colors,a=e.config.markers.strokeColor||e.config.markers.strokeColors;return{pointStrokeColor:Array.isArray(a)?a[t]:a,pointFillColor:Array.isArray(i)?i[t]:i}}}]),t}(),B=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w,this.initialAnim=this.w.config.chart.animations.enabled}return s(t,[{key:"draw",value:function(t,e,i){var a=this.w,s=new k(this.ctx),r=i.realIndex,o=i.pointsPos,n=i.zRatio,l=i.elParent,h=s.group({class:"apexcharts-series-markers apexcharts-series-".concat(a.config.chart.type)});if(h.attr("clip-path","url(#gridRectMarkerMask".concat(a.globals.cuid,")")),Array.isArray(o.x))for(var c=0;c<o.x.length;c++){var d=e+1,g=!0;0===e&&0===c&&(d=0),0===e&&1===c&&(d=1);var u=a.globals.markers.size[r];if(n!==1/0){var f=a.config.plotOptions.bubble;u=a.globals.seriesZ[r][d],f.zScaling&&(u/=n),f.minBubbleRadius&&u<f.minBubbleRadius&&(u=f.minBubbleRadius),f.maxBubbleRadius&&u>f.maxBubbleRadius&&(u=f.maxBubbleRadius)}var p=o.x[c],x=o.y[c];if(u=u||0,null!==x&&void 0!==a.globals.series[r][d]||(g=!1),g){var b=this.drawPoint(p,x,u,r,d,e);h.add(b)}l.add(h)}}},{key:"drawPoint",value:function(t,e,i,a,s,r){var o=this.w,n=a,l=new y(this.ctx),h=new w(this.ctx),c=new N(this.ctx),d=new W(this.ctx),g=new k(this.ctx),u=d.getMarkerConfig({cssClass:"apexcharts-marker",seriesIndex:n,dataPointIndex:s,radius:"bubble"===o.config.chart.type||o.globals.comboCharts&&o.config.series[a]&&"bubble"===o.config.series[a].type?i:null}),f=c.fillPath({seriesNumber:a,dataPointIndex:s,color:u.pointFillColor,patternUnits:"objectBoundingBox",value:o.globals.series[a][r]}),p=g.drawMarker(t,e,u);if(o.config.series[n].data[s]&&o.config.series[n].data[s].fillColor&&(f=o.config.series[n].data[s].fillColor),p.attr({fill:f}),o.config.chart.dropShadow.enabled){var x=o.config.chart.dropShadow;h.dropShadow(p,x,a)}if(!this.initialAnim||o.globals.dataChanged||o.globals.resized)o.globals.animationEnded=!0;else{var b=o.config.chart.animations.speed;l.animateMarker(p,b,o.globals.easing,(function(){window.setTimeout((function(){l.animationCompleted(p)}),100)}))}return p.attr({rel:s,j:s,index:a,"default-marker-size":u.pSize}),h.setSelectionFilter(p,a,s),d.addEvents(p),p.node.classList.add("apexcharts-marker"),p}},{key:"centerTextInBubble",value:function(t){var e=this.w;return{y:t+=parseInt(e.config.dataLabels.style.fontSize,10)/4}}}]),t}(),G=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w}return s(t,[{key:"dataLabelsCorrection",value:function(t,e,i,a,s,r,o){var n=this.w,l=!1,h=new k(this.ctx).getTextRects(i,o),c=h.width,d=h.height;e<0&&(e=0),e>n.globals.gridHeight+d&&(e=n.globals.gridHeight+d/2),void 0===n.globals.dataLabelsRects[a]&&(n.globals.dataLabelsRects[a]=[]),n.globals.dataLabelsRects[a].push({x:t,y:e,width:c,height:d});var g=n.globals.dataLabelsRects[a].length-2,u=void 0!==n.globals.lastDrawnDataLabelsIndexes[a]?n.globals.lastDrawnDataLabelsIndexes[a][n.globals.lastDrawnDataLabelsIndexes[a].length-1]:0;if(void 0!==n.globals.dataLabelsRects[a][g]){var f=n.globals.dataLabelsRects[a][u];(t>f.x+f.width||e>f.y+f.height||e+d<f.y||t+c<f.x)&&(l=!0)}return(0===s||r)&&(l=!0),{x:t,y:e,textRects:h,drawnextLabel:l}}},{key:"drawDataLabel",value:function(t){var e=this,i=t.type,a=t.pos,s=t.i,r=t.j,o=t.isRangeStart,n=t.strokeWidth,l=void 0===n?2:n,h=this.w,c=new k(this.ctx),d=h.config.dataLabels,g=0,u=0,f=r,p=null;if(-1!==h.globals.collapsedSeriesIndices.indexOf(s)||!d.enabled||!Array.isArray(a.x))return p;p=c.group({class:"apexcharts-data-labels"});for(var x=0;x<a.x.length;x++)if(g=a.x[x]+d.offsetX,u=a.y[x]+d.offsetY+l,!isNaN(g)){1===r&&0===x&&(f=0),1===r&&1===x&&(f=1);var b=h.globals.series[s][f];"rangeArea"===i&&(b=o?h.globals.seriesRangeStart[s][f]:h.globals.seriesRangeEnd[s][f]);var v="",m=function(t){return h.config.dataLabels.formatter(t,{ctx:e.ctx,seriesIndex:s,dataPointIndex:f,w:h})};if("bubble"===h.config.chart.type)v=m(b=h.globals.seriesZ[s][f]),u=a.y[x],u=new B(this.ctx).centerTextInBubble(u,s,f).y;else void 0!==b&&(v=m(b));var y=h.config.dataLabels.textAnchor;h.globals.isSlopeChart&&(y=0===f?"end":f===h.config.series[s].data.length-1?"start":"middle"),this.plotDataLabelsText({x:g,y:u,text:v,i:s,j:f,parent:p,offsetCorrection:!0,dataLabelsConfig:h.config.dataLabels,textAnchor:y})}return p}},{key:"plotDataLabelsText",value:function(t){var e=this.w,i=new k(this.ctx),a=t.x,s=t.y,r=t.i,o=t.j,n=t.text,l=t.textAnchor,h=t.fontSize,c=t.parent,d=t.dataLabelsConfig,g=t.color,u=t.alwaysDrawDataLabel,f=t.offsetCorrection,p=t.className,x=null;if(Array.isArray(e.config.dataLabels.enabledOnSeries)&&e.config.dataLabels.enabledOnSeries.indexOf(r)<0)return x;var b={x:a,y:s,drawnextLabel:!0,textRects:null};f&&(b=this.dataLabelsCorrection(a,s,n,r,o,u,parseInt(d.style.fontSize,10))),e.globals.zoomed||(a=b.x,s=b.y),b.textRects&&(a<-20-b.textRects.width||a>e.globals.gridWidth+b.textRects.width+30)&&(n="");var v=e.globals.dataLabels.style.colors[r];(("bar"===e.config.chart.type||"rangeBar"===e.config.chart.type)&&e.config.plotOptions.bar.distributed||e.config.dataLabels.distributed)&&(v=e.globals.dataLabels.style.colors[o]),"function"==typeof v&&(v=v({series:e.globals.series,seriesIndex:r,dataPointIndex:o,w:e})),g&&(v=g);var m=d.offsetX,y=d.offsetY;if("bar"!==e.config.chart.type&&"rangeBar"!==e.config.chart.type||(m=0,y=0),e.globals.isSlopeChart&&(0!==o&&(m=-2*d.offsetX+5),0!==o&&o!==e.config.series[r].data.length-1&&(m=0)),b.drawnextLabel){if((x=i.drawText({width:100,height:parseInt(d.style.fontSize,10),x:a+m,y:s+y,foreColor:v,textAnchor:l||d.textAnchor,text:n,fontSize:h||d.style.fontSize,fontFamily:d.style.fontFamily,fontWeight:d.style.fontWeight||"normal"})).attr({class:p||"apexcharts-datalabel",cx:a,cy:s}),d.dropShadow.enabled){var A=d.dropShadow;new w(this.ctx).dropShadow(x,A)}c.add(x),void 0===e.globals.lastDrawnDataLabelsIndexes[r]&&(e.globals.lastDrawnDataLabelsIndexes[r]=[]),e.globals.lastDrawnDataLabelsIndexes[r].push(o)}return x}},{key:"addBackgroundToDataLabel",value:function(t,e){var i=this.w,a=i.config.dataLabels.background,s=a.padding,r=a.padding/2,o=e.width,n=e.height,l=new k(this.ctx).drawRect(e.x-s,e.y-r/2,o+2*s,n+r,a.borderRadius,"transparent"!==i.config.chart.background&&i.config.chart.background?i.config.chart.background:"#fff",a.opacity,a.borderWidth,a.borderColor);a.dropShadow.enabled&&new w(this.ctx).dropShadow(l,a.dropShadow);return l}},{key:"dataLabelsBackground",value:function(){var t=this.w;if("bubble"!==t.config.chart.type)for(var e=t.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels text"),i=0;i<e.length;i++){var a=e[i],s=a.getBBox(),r=null;if(s.width&&s.height&&(r=this.addBackgroundToDataLabel(a,s)),r){a.parentNode.insertBefore(r.node,a);var o=a.getAttribute("fill");t.config.chart.animations.enabled&&!t.globals.resized&&!t.globals.dataChanged?r.animate().attr({fill:o}):r.attr({fill:o}),a.setAttribute("fill",t.config.dataLabels.background.foreColor)}}}},{key:"bringForward",value:function(){for(var t=this.w,e=t.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels"),i=t.globals.dom.baseEl.querySelector(".apexcharts-plot-series:last-child"),a=0;a<e.length;a++)i&&i.insertBefore(e[a],i.nextSibling)}}]),t}(),V=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w,this.legendInactiveClass="legend-mouseover-inactive"}return s(t,[{key:"getAllSeriesEls",value:function(){return this.w.globals.dom.baseEl.getElementsByClassName("apexcharts-series")}},{key:"getSeriesByName",value:function(t){return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner .apexcharts-series[seriesName='".concat(m.escapeString(t),"']"))}},{key:"isSeriesHidden",value:function(t){var e=this.getSeriesByName(t),i=parseInt(e.getAttribute("data:realIndex"),10);return{isHidden:e.classList.contains("apexcharts-series-collapsed"),realIndex:i}}},{key:"addCollapsedClassToSeries",value:function(t,e){var i=this.w;function a(i){for(var a=0;a<i.length;a++)i[a].index===e&&t.node.classList.add("apexcharts-series-collapsed")}a(i.globals.collapsedSeries),a(i.globals.ancillaryCollapsedSeries)}},{key:"toggleSeries",value:function(t){var e=this.isSeriesHidden(t);return this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex,e.isHidden),e.isHidden}},{key:"showSeries",value:function(t){var e=this.isSeriesHidden(t);e.isHidden&&this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex,!0)}},{key:"hideSeries",value:function(t){var e=this.isSeriesHidden(t);e.isHidden||this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex,!1)}},{key:"resetSeries",value:function(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0],e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],a=this.w,s=m.clone(a.globals.initialSeries);a.globals.previousPaths=[],i?(a.globals.collapsedSeries=[],a.globals.ancillaryCollapsedSeries=[],a.globals.collapsedSeriesIndices=[],a.globals.ancillaryCollapsedSeriesIndices=[]):s=this.emptyCollapsedSeries(s),a.config.series=s,t&&(e&&(a.globals.zoomed=!1,this.ctx.updateHelpers.revertDefaultAxisMinMax()),this.ctx.updateHelpers._updateSeries(s,a.config.chart.animations.dynamicAnimation.enabled))}},{key:"emptyCollapsedSeries",value:function(t){for(var e=this.w,i=0;i<t.length;i++)e.globals.collapsedSeriesIndices.indexOf(i)>-1&&(t[i].data=[]);return t}},{key:"highlightSeries",value:function(t){var e=this.w,i=this.getSeriesByName(t),a=parseInt(null==i?void 0:i.getAttribute("data:realIndex"),10),s=e.globals.dom.baseEl.querySelectorAll(".apexcharts-series, .apexcharts-datalabels, .apexcharts-yaxis"),r=null,o=null,n=null;if(e.globals.axisCharts||"radialBar"===e.config.chart.type)if(e.globals.axisCharts){r=e.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(a,"']")),o=e.globals.dom.baseEl.querySelector(".apexcharts-datalabels[data\\:realIndex='".concat(a,"']"));var l=e.globals.seriesYAxisReverseMap[a];n=e.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(l,"']"))}else r=e.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(a+1,"']"));else r=e.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(a+1,"'] path"));for(var h=0;h<s.length;h++)s[h].classList.add(this.legendInactiveClass);if(r)e.globals.axisCharts||r.parentNode.classList.remove(this.legendInactiveClass),r.classList.remove(this.legendInactiveClass),null!==o&&o.classList.remove(this.legendInactiveClass),null!==n&&n.classList.remove(this.legendInactiveClass);else for(var c=0;c<s.length;c++)s[c].classList.remove(this.legendInactiveClass)}},{key:"toggleSeriesOnHover",value:function(t,e){var i=this.w;e||(e=t.target);var a=i.globals.dom.baseEl.querySelectorAll(".apexcharts-series, .apexcharts-datalabels, .apexcharts-yaxis");if("mousemove"===t.type){var s=parseInt(e.getAttribute("rel"),10)-1;this.highlightSeries(i.globals.seriesNames[s])}else if("mouseout"===t.type)for(var r=0;r<a.length;r++)a[r].classList.remove(this.legendInactiveClass)}},{key:"highlightRangeInSeries",value:function(t,e){var i=this,a=this.w,s=a.globals.dom.baseEl.getElementsByClassName("apexcharts-heatmap-rect"),r=function(t){for(var e=0;e<s.length;e++)s[e].classList[t](i.legendInactiveClass)};if("mousemove"===t.type){var o=parseInt(e.getAttribute("rel"),10)-1;r("add");var n=a.config.plotOptions.heatmap.colorScale.ranges;!function(t,e){for(var a=0;a<s.length;a++){var r=Number(s[a].getAttribute("val"));r>=t.from&&(r<t.to||t.to===e&&r===e)&&s[a].classList.remove(i.legendInactiveClass)}}(n[o],n.reduce((function(t,e){return Math.max(t,e.to)}),0))}else"mouseout"===t.type&&r("remove")}},{key:"getActiveConfigSeriesIndex",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"asc",e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],i=this.w,a=0;if(i.config.series.length>1)for(var s=i.config.series.map((function(t,a){return t.data&&t.data.length>0&&-1===i.globals.collapsedSeriesIndices.indexOf(a)&&(!i.globals.comboCharts||0===e.length||e.length&&e.indexOf(i.config.series[a].type)>-1)?a:-1})),r="asc"===t?0:s.length-1;"asc"===t?r<s.length:r>=0;"asc"===t?r++:r--)if(-1!==s[r]){a=s[r];break}return a}},{key:"getBarSeriesIndices",value:function(){return this.w.globals.comboCharts?this.w.config.series.map((function(t,e){return"bar"===t.type||"column"===t.type?e:-1})).filter((function(t){return-1!==t})):this.w.config.series.map((function(t,e){return e}))}},{key:"getPreviousPaths",value:function(){var t=this.w;function e(e,i,a){for(var s=e[i].childNodes,r={type:a,paths:[],realIndex:e[i].getAttribute("data:realIndex")},o=0;o<s.length;o++)if(s[o].hasAttribute("pathTo")){var n=s[o].getAttribute("pathTo");r.paths.push({d:n})}t.globals.previousPaths.push(r)}t.globals.previousPaths=[];["line","area","bar","rangebar","rangeArea","candlestick","radar"].forEach((function(i){for(var a,s=(a=i,t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(a,"-series .apexcharts-series"))),r=0;r<s.length;r++)e(s,r,i)})),this.handlePrevBubbleScatterPaths("bubble"),this.handlePrevBubbleScatterPaths("scatter");var i=t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t.config.chart.type," .apexcharts-series"));if(i.length>0)for(var a=function(e){for(var i=t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t.config.chart.type," .apexcharts-series[data\\:realIndex='").concat(e,"'] rect")),a=[],s=function(t){var e=function(e){return i[t].getAttribute(e)},s={x:parseFloat(e("x")),y:parseFloat(e("y")),width:parseFloat(e("width")),height:parseFloat(e("height"))};a.push({rect:s,color:i[t].getAttribute("color")})},r=0;r<i.length;r++)s(r);t.globals.previousPaths.push(a)},s=0;s<i.length;s++)a(s);t.globals.axisCharts||(t.globals.previousPaths=t.globals.series)}},{key:"handlePrevBubbleScatterPaths",value:function(t){var e=this.w,i=e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t,"-series .apexcharts-series"));if(i.length>0)for(var a=0;a<i.length;a++){for(var s=e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t,"-series .apexcharts-series[data\\:realIndex='").concat(a,"'] circle")),r=[],o=0;o<s.length;o++)r.push({x:s[o].getAttribute("cx"),y:s[o].getAttribute("cy"),r:s[o].getAttribute("r")});e.globals.previousPaths.push(r)}}},{key:"clearPreviousPaths",value:function(){var t=this.w;t.globals.previousPaths=[],t.globals.allSeriesCollapsed=!1}},{key:"handleNoData",value:function(){var t=this.w,e=t.config.noData,i=new k(this.ctx),a=t.globals.svgWidth/2,s=t.globals.svgHeight/2,r="middle";if(t.globals.noData=!0,t.globals.animationEnded=!0,"left"===e.align?(a=10,r="start"):"right"===e.align&&(a=t.globals.svgWidth-10,r="end"),"top"===e.verticalAlign?s=50:"bottom"===e.verticalAlign&&(s=t.globals.svgHeight-50),a+=e.offsetX,s=s+parseInt(e.style.fontSize,10)+2+e.offsetY,void 0!==e.text&&""!==e.text){var o=i.drawText({x:a,y:s,text:e.text,textAnchor:r,fontSize:e.style.fontSize,fontFamily:e.style.fontFamily,foreColor:e.style.color,opacity:1,class:"apexcharts-text-nodata"});t.globals.dom.Paper.add(o)}}},{key:"setNullSeriesToZeroValues",value:function(t){for(var e=this.w,i=0;i<t.length;i++)if(0===t[i].length)for(var a=0;a<t[e.globals.maxValsInArrayIndex].length;a++)t[i].push(0);return t}},{key:"hasAllSeriesEqualX",value:function(){for(var t=!0,e=this.w,i=this.filteredSeriesX(),a=0;a<i.length-1;a++)if(i[a][0]!==i[a+1][0]){t=!1;break}return e.globals.allSeriesHasEqualX=t,t}},{key:"filteredSeriesX",value:function(){var t=this.w.globals.seriesX.map((function(t){return t.length>0?t:[]}));return t}}]),t}(),_=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w,this.twoDSeries=[],this.threeDSeries=[],this.twoDSeriesX=[],this.seriesGoals=[],this.coreUtils=new A(this.ctx)}return s(t,[{key:"isMultiFormat",value:function(){return this.isFormatXY()||this.isFormat2DArray()}},{key:"isFormatXY",value:function(){var t=this.w.config.series.slice(),e=new V(this.ctx);if(this.activeSeriesIndex=e.getActiveConfigSeriesIndex(),void 0!==t[this.activeSeriesIndex].data&&t[this.activeSeriesIndex].data.length>0&&null!==t[this.activeSeriesIndex].data[0]&&void 0!==t[this.activeSeriesIndex].data[0].x&&null!==t[this.activeSeriesIndex].data[0])return!0}},{key:"isFormat2DArray",value:function(){var t=this.w.config.series.slice(),e=new V(this.ctx);if(this.activeSeriesIndex=e.getActiveConfigSeriesIndex(),void 0!==t[this.activeSeriesIndex].data&&t[this.activeSeriesIndex].data.length>0&&void 0!==t[this.activeSeriesIndex].data[0]&&null!==t[this.activeSeriesIndex].data[0]&&t[this.activeSeriesIndex].data[0].constructor===Array)return!0}},{key:"handleFormat2DArray",value:function(t,e){for(var i=this.w.config,a=this.w.globals,s="boxPlot"===i.chart.type||"boxPlot"===i.series[e].type,r=0;r<t[e].data.length;r++)if(void 0!==t[e].data[r][1]&&(Array.isArray(t[e].data[r][1])&&4===t[e].data[r][1].length&&!s?this.twoDSeries.push(m.parseNumber(t[e].data[r][1][3])):t[e].data[r].length>=5?this.twoDSeries.push(m.parseNumber(t[e].data[r][4])):this.twoDSeries.push(m.parseNumber(t[e].data[r][1])),a.dataFormatXNumeric=!0),"datetime"===i.xaxis.type){var o=new Date(t[e].data[r][0]);o=new Date(o).getTime(),this.twoDSeriesX.push(o)}else this.twoDSeriesX.push(t[e].data[r][0]);for(var n=0;n<t[e].data.length;n++)void 0!==t[e].data[n][2]&&(this.threeDSeries.push(t[e].data[n][2]),a.isDataXYZ=!0)}},{key:"handleFormatXY",value:function(t,e){var i=this.w.config,a=this.w.globals,s=new L(this.ctx),r=e;a.collapsedSeriesIndices.indexOf(e)>-1&&(r=this.activeSeriesIndex);for(var o=0;o<t[e].data.length;o++)void 0!==t[e].data[o].y&&(Array.isArray(t[e].data[o].y)?this.twoDSeries.push(m.parseNumber(t[e].data[o].y[t[e].data[o].y.length-1])):this.twoDSeries.push(m.parseNumber(t[e].data[o].y))),void 0!==t[e].data[o].goals&&Array.isArray(t[e].data[o].goals)?(void 0===this.seriesGoals[e]&&(this.seriesGoals[e]=[]),this.seriesGoals[e].push(t[e].data[o].goals)):(void 0===this.seriesGoals[e]&&(this.seriesGoals[e]=[]),this.seriesGoals[e].push(null));for(var n=0;n<t[r].data.length;n++){var l="string"==typeof t[r].data[n].x,h=Array.isArray(t[r].data[n].x),c=!h&&!!s.isValidDate(t[r].data[n].x);if(l||c)if(l||i.xaxis.convertedCatToNumeric){var d=a.isBarHorizontal&&a.isRangeData;"datetime"!==i.xaxis.type||d?(this.fallbackToCategory=!0,this.twoDSeriesX.push(t[r].data[n].x),isNaN(t[r].data[n].x)||"category"===this.w.config.xaxis.type||"string"==typeof t[r].data[n].x||(a.isXNumeric=!0)):this.twoDSeriesX.push(s.parseDate(t[r].data[n].x))}else"datetime"===i.xaxis.type?this.twoDSeriesX.push(s.parseDate(t[r].data[n].x.toString())):(a.dataFormatXNumeric=!0,a.isXNumeric=!0,this.twoDSeriesX.push(parseFloat(t[r].data[n].x)));else h?(this.fallbackToCategory=!0,this.twoDSeriesX.push(t[r].data[n].x)):(a.isXNumeric=!0,a.dataFormatXNumeric=!0,this.twoDSeriesX.push(t[r].data[n].x))}if(t[e].data[0]&&void 0!==t[e].data[0].z){for(var g=0;g<t[e].data.length;g++)this.threeDSeries.push(t[e].data[g].z);a.isDataXYZ=!0}}},{key:"handleRangeData",value:function(t,e){var i=this.w.globals,a={};return this.isFormat2DArray()?a=this.handleRangeDataFormat("array",t,e):this.isFormatXY()&&(a=this.handleRangeDataFormat("xy",t,e)),i.seriesRangeStart.push(void 0===a.start?[]:a.start),i.seriesRangeEnd.push(void 0===a.end?[]:a.end),i.seriesRange.push(a.rangeUniques),i.seriesRange.forEach((function(t,e){t&&t.forEach((function(t,e){t.y.forEach((function(e,i){for(var a=0;a<t.y.length;a++)if(i!==a){var s=e.y1,r=e.y2,o=t.y[a].y1;s<=t.y[a].y2&&o<=r&&(t.overlaps.indexOf(e.rangeName)<0&&t.overlaps.push(e.rangeName),t.overlaps.indexOf(t.y[a].rangeName)<0&&t.overlaps.push(t.y[a].rangeName))}}))}))})),a}},{key:"handleCandleStickBoxData",value:function(t,e){var i=this.w.globals,a={};return this.isFormat2DArray()?a=this.handleCandleStickBoxDataFormat("array",t,e):this.isFormatXY()&&(a=this.handleCandleStickBoxDataFormat("xy",t,e)),i.seriesCandleO[e]=a.o,i.seriesCandleH[e]=a.h,i.seriesCandleM[e]=a.m,i.seriesCandleL[e]=a.l,i.seriesCandleC[e]=a.c,a}},{key:"handleRangeDataFormat",value:function(t,e,i){var a=[],s=[],r=e[i].data.filter((function(t,e,i){return e===i.findIndex((function(e){return e.x===t.x}))})).map((function(t,e){return{x:t.x,overlaps:[],y:[]}}));if("array"===t)for(var o=0;o<e[i].data.length;o++)Array.isArray(e[i].data[o])?(a.push(e[i].data[o][1][0]),s.push(e[i].data[o][1][1])):(a.push(e[i].data[o]),s.push(e[i].data[o]));else if("xy"===t)for(var n=function(t){var o=Array.isArray(e[i].data[t].y),n=m.randomId(),l=e[i].data[t].x,h={y1:o?e[i].data[t].y[0]:e[i].data[t].y,y2:o?e[i].data[t].y[1]:e[i].data[t].y,rangeName:n};e[i].data[t].rangeName=n;var c=r.findIndex((function(t){return t.x===l}));r[c].y.push(h),a.push(h.y1),s.push(h.y2)},l=0;l<e[i].data.length;l++)n(l);return{start:a,end:s,rangeUniques:r}}},{key:"handleCandleStickBoxDataFormat",value:function(t,e,i){var a=this.w,s="boxPlot"===a.config.chart.type||"boxPlot"===a.config.series[i].type,r=[],o=[],n=[],l=[],h=[];if("array"===t)if(s&&6===e[i].data[0].length||!s&&5===e[i].data[0].length)for(var c=0;c<e[i].data.length;c++)r.push(e[i].data[c][1]),o.push(e[i].data[c][2]),s?(n.push(e[i].data[c][3]),l.push(e[i].data[c][4]),h.push(e[i].data[c][5])):(l.push(e[i].data[c][3]),h.push(e[i].data[c][4]));else for(var d=0;d<e[i].data.length;d++)Array.isArray(e[i].data[d][1])&&(r.push(e[i].data[d][1][0]),o.push(e[i].data[d][1][1]),s?(n.push(e[i].data[d][1][2]),l.push(e[i].data[d][1][3]),h.push(e[i].data[d][1][4])):(l.push(e[i].data[d][1][2]),h.push(e[i].data[d][1][3])));else if("xy"===t)for(var g=0;g<e[i].data.length;g++)Array.isArray(e[i].data[g].y)&&(r.push(e[i].data[g].y[0]),o.push(e[i].data[g].y[1]),s?(n.push(e[i].data[g].y[2]),l.push(e[i].data[g].y[3]),h.push(e[i].data[g].y[4])):(l.push(e[i].data[g].y[2]),h.push(e[i].data[g].y[3])));return{o:r,h:o,m:n,l:l,c:h}}},{key:"parseDataAxisCharts",value:function(t){var e=this,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.ctx,a=this.w.config,s=this.w.globals,r=new L(i),o=a.labels.length>0?a.labels.slice():a.xaxis.categories.slice();s.isRangeBar="rangeBar"===a.chart.type&&s.isBarHorizontal,s.hasXaxisGroups="category"===a.xaxis.type&&a.xaxis.group.groups.length>0,s.hasXaxisGroups&&(s.groups=a.xaxis.group.groups),t.forEach((function(t,e){void 0!==t.name?s.seriesNames.push(t.name):s.seriesNames.push("series-"+parseInt(e+1,10))})),this.coreUtils.setSeriesYAxisMappings();var n=[],l=p(new Set(a.series.map((function(t){return t.group}))));a.series.forEach((function(t,e){var i=l.indexOf(t.group);n[i]||(n[i]=[]),n[i].push(s.seriesNames[e])})),s.seriesGroups=n;for(var h=function(){for(var t=0;t<o.length;t++)if("string"==typeof o[t]){if(!r.isValidDate(o[t]))throw new Error("You have provided invalid Date format. Please provide a valid JavaScript Date");e.twoDSeriesX.push(r.parseDate(o[t]))}else e.twoDSeriesX.push(o[t])},c=0;c<t.length;c++){if(this.twoDSeries=[],this.twoDSeriesX=[],this.threeDSeries=[],void 0===t[c].data)return void console.error("It is a possibility that you may have not included 'data' property in series.");if("rangeBar"!==a.chart.type&&"rangeArea"!==a.chart.type&&"rangeBar"!==t[c].type&&"rangeArea"!==t[c].type||(s.isRangeData=!0,"rangeBar"!==a.chart.type&&"rangeArea"!==a.chart.type||this.handleRangeData(t,c)),this.isMultiFormat())this.isFormat2DArray()?this.handleFormat2DArray(t,c):this.isFormatXY()&&this.handleFormatXY(t,c),"candlestick"!==a.chart.type&&"candlestick"!==t[c].type&&"boxPlot"!==a.chart.type&&"boxPlot"!==t[c].type||this.handleCandleStickBoxData(t,c),s.series.push(this.twoDSeries),s.labels.push(this.twoDSeriesX),s.seriesX.push(this.twoDSeriesX),s.seriesGoals=this.seriesGoals,c!==this.activeSeriesIndex||this.fallbackToCategory||(s.isXNumeric=!0);else{"datetime"===a.xaxis.type?(s.isXNumeric=!0,h(),s.seriesX.push(this.twoDSeriesX)):"numeric"===a.xaxis.type&&(s.isXNumeric=!0,o.length>0&&(this.twoDSeriesX=o,s.seriesX.push(this.twoDSeriesX))),s.labels.push(this.twoDSeriesX);var d=t[c].data.map((function(t){return m.parseNumber(t)}));s.series.push(d)}s.seriesZ.push(this.threeDSeries),void 0!==t[c].color?s.seriesColors.push(t[c].color):s.seriesColors.push(void 0)}return this.w}},{key:"parseDataNonAxisCharts",value:function(t){var e=this.w.globals,i=this.w.config;e.series=t.slice(),e.seriesNames=i.labels.slice();for(var a=0;a<e.series.length;a++)void 0===e.seriesNames[a]&&e.seriesNames.push("series-"+(a+1));return this.w}},{key:"handleExternalLabelsData",value:function(t){var e=this.w.config,i=this.w.globals;if(e.xaxis.categories.length>0)i.labels=e.xaxis.categories;else if(e.labels.length>0)i.labels=e.labels.slice();else if(this.fallbackToCategory){if(i.labels=i.labels[0],i.seriesRange.length&&(i.seriesRange.map((function(t){t.forEach((function(t){i.labels.indexOf(t.x)<0&&t.x&&i.labels.push(t.x)}))})),i.labels=Array.from(new Set(i.labels.map(JSON.stringify)),JSON.parse)),e.xaxis.convertedCatToNumeric)new F(e).convertCatToNumericXaxis(e,this.ctx,i.seriesX[0]),this._generateExternalLabels(t)}else this._generateExternalLabels(t)}},{key:"_generateExternalLabels",value:function(t){var e=this.w.globals,i=this.w.config,a=[];if(e.axisCharts){if(e.series.length>0)if(this.isFormatXY())for(var s=i.series.map((function(t,e){return t.data.filter((function(t,e,i){return i.findIndex((function(e){return e.x===t.x}))===e}))})),r=s.reduce((function(t,e,i,a){return a[t].length>e.length?t:i}),0),o=0;o<s[r].length;o++)a.push(o+1);else for(var n=0;n<e.series[e.maxValsInArrayIndex].length;n++)a.push(n+1);e.seriesX=[];for(var l=0;l<t.length;l++)e.seriesX.push(a);this.w.globals.isBarHorizontal||(e.isXNumeric=!0)}if(0===a.length){a=e.axisCharts?[]:e.series.map((function(t,e){return e+1}));for(var h=0;h<t.length;h++)e.seriesX.push(a)}e.labels=a,i.xaxis.convertedCatToNumeric&&(e.categoryLabels=a.map((function(t){return i.xaxis.labels.formatter(t)}))),e.noLabelsProvided=!0}},{key:"parseData",value:function(t){var e=this.w,i=e.config,a=e.globals;if(this.excludeCollapsedSeriesInYAxis(),this.fallbackToCategory=!1,this.ctx.core.resetGlobals(),this.ctx.core.isMultipleY(),a.axisCharts?(this.parseDataAxisCharts(t),this.coreUtils.getLargestSeries()):this.parseDataNonAxisCharts(t),i.chart.stacked){var s=new V(this.ctx);a.series=s.setNullSeriesToZeroValues(a.series)}this.coreUtils.getSeriesTotals(),a.axisCharts&&(a.stackedSeriesTotals=this.coreUtils.getStackedSeriesTotals(),a.stackedSeriesTotalsByGroups=this.coreUtils.getStackedSeriesTotalsByGroups()),this.coreUtils.getPercentSeries(),a.dataFormatXNumeric||a.isXNumeric&&("numeric"!==i.xaxis.type||0!==i.labels.length||0!==i.xaxis.categories.length)||this.handleExternalLabelsData(t);for(var r=this.coreUtils.getCategoryLabels(a.labels),o=0;o<r.length;o++)if(Array.isArray(r[o])){a.isMultiLineX=!0;break}}},{key:"excludeCollapsedSeriesInYAxis",value:function(){var t=this.w,e=[];t.globals.seriesYAxisMap.forEach((function(i,a){var s=0;i.forEach((function(e){-1!==t.globals.collapsedSeriesIndices.indexOf(e)&&s++})),s>0&&s==i.length&&e.push(a)})),t.globals.ignoreYAxisIndexes=e.map((function(t){return t}))}}]),t}(),U=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w}return s(t,[{key:"scaleSvgNode",value:function(t,e){var i=parseFloat(t.getAttributeNS(null,"width")),a=parseFloat(t.getAttributeNS(null,"height"));t.setAttributeNS(null,"width",i*e),t.setAttributeNS(null,"height",a*e),t.setAttributeNS(null,"viewBox","0 0 "+i+" "+a)}},{key:"getSvgString",value:function(){var t=this;return new Promise((function(e){var i=t.w,a=i.config.chart.toolbar.export.width,s=i.config.chart.toolbar.export.scale||a/i.globals.svgWidth;s||(s=1);var r=t.w.globals.dom.Paper.svg(),o=t.w.globals.dom.Paper.node.cloneNode(!0);1!==s&&t.scaleSvgNode(o,s),t.convertImagesToBase64(o).then((function(){r=(new XMLSerializer).serializeToString(o),e(r.replace(/&nbsp;/g,"&#160;"))}))}))}},{key:"convertImagesToBase64",value:function(t){var e=this,i=t.getElementsByTagName("image"),a=Array.from(i).map((function(t){var i=t.getAttributeNS("http://www.w3.org/1999/xlink","href");return i&&!i.startsWith("data:")?e.getBase64FromUrl(i).then((function(e){t.setAttributeNS("http://www.w3.org/1999/xlink","href",e)})).catch((function(t){console.error("Error converting image to base64:",t)})):Promise.resolve()}));return Promise.all(a)}},{key:"getBase64FromUrl",value:function(t){return new Promise((function(e,i){var a=new Image;a.crossOrigin="Anonymous",a.onload=function(){var t=document.createElement("canvas");t.width=a.width,t.height=a.height,t.getContext("2d").drawImage(a,0,0),e(t.toDataURL())},a.onerror=i,a.src=t}))}},{key:"cleanup",value:function(){var t=this.w,e=t.globals.dom.baseEl.getElementsByClassName("apexcharts-xcrosshairs"),i=t.globals.dom.baseEl.getElementsByClassName("apexcharts-ycrosshairs"),a=t.globals.dom.baseEl.querySelectorAll(".apexcharts-zoom-rect, .apexcharts-selection-rect");Array.prototype.forEach.call(a,(function(t){t.setAttribute("width",0)})),e&&e[0]&&(e[0].setAttribute("x",-500),e[0].setAttribute("x1",-500),e[0].setAttribute("x2",-500)),i&&i[0]&&(i[0].setAttribute("y",-100),i[0].setAttribute("y1",-100),i[0].setAttribute("y2",-100))}},{key:"svgUrl",value:function(){var t=this;return new Promise((function(e){t.cleanup(),t.getSvgString().then((function(t){var i=new Blob([t],{type:"image/svg+xml;charset=utf-8"});e(URL.createObjectURL(i))}))}))}},{key:"dataURI",value:function(t){var e=this;return new Promise((function(i){var a=e.w,s=t?t.scale||t.width/a.globals.svgWidth:1;e.cleanup();var r=document.createElement("canvas");r.width=a.globals.svgWidth*s,r.height=parseInt(a.globals.dom.elWrap.style.height,10)*s;var o="transparent"!==a.config.chart.background&&a.config.chart.background?a.config.chart.background:"#fff",n=r.getContext("2d");n.fillStyle=o,n.fillRect(0,0,r.width*s,r.height*s),e.getSvgString().then((function(t){var e="data:image/svg+xml,"+encodeURIComponent(t),a=new Image;a.crossOrigin="anonymous",a.onload=function(){if(n.drawImage(a,0,0),r.msToBlob){var t=r.msToBlob();i({blob:t})}else{var e=r.toDataURL("image/png");i({imgURI:e})}},a.src=e}))}))}},{key:"exportToSVG",value:function(){var t=this;this.svgUrl().then((function(e){t.triggerDownload(e,t.w.config.chart.toolbar.export.svg.filename,".svg")}))}},{key:"exportToPng",value:function(){var t=this,e=this.w.config.chart.toolbar.export.scale,i=this.w.config.chart.toolbar.export.width,a=e?{scale:e}:i?{width:i}:void 0;this.dataURI(a).then((function(e){var i=e.imgURI,a=e.blob;a?navigator.msSaveOrOpenBlob(a,t.w.globals.chartID+".png"):t.triggerDownload(i,t.w.config.chart.toolbar.export.png.filename,".png")}))}},{key:"exportToCSV",value:function(t){var e=this,i=t.series,a=t.fileName,s=t.columnDelimiter,r=void 0===s?",":s,o=t.lineDelimiter,n=void 0===o?"\n":o,l=this.w;i||(i=l.config.series);var h,c,d=[],g=[],u="",f=l.globals.series.map((function(t,e){return-1===l.globals.collapsedSeriesIndices.indexOf(e)?t:[]})),x=function(t){return"function"==typeof l.config.chart.toolbar.export.csv.categoryFormatter?l.config.chart.toolbar.export.csv.categoryFormatter(t):"datetime"===l.config.xaxis.type&&String(t).length>=10?new Date(t).toDateString():m.isNumber(t)?t:t.split(r).join("")},b=function(t){return"function"==typeof l.config.chart.toolbar.export.csv.valueFormatter?l.config.chart.toolbar.export.csv.valueFormatter(t):t},v=Math.max.apply(Math,p(i.map((function(t){return t.data?t.data.length:0})))),y=new _(this.ctx),w=new M(this.ctx),k=function(t){var i="";if(l.globals.axisCharts){if("category"===l.config.xaxis.type||l.config.xaxis.convertedCatToNumeric)if(l.globals.isBarHorizontal){var a=l.globals.yLabelFormatters[0],s=new V(e.ctx).getActiveConfigSeriesIndex();i=a(l.globals.labels[t],{seriesIndex:s,dataPointIndex:t,w:l})}else i=w.getLabel(l.globals.labels,l.globals.timescaleLabels,0,t).text;"datetime"===l.config.xaxis.type&&(l.config.xaxis.categories.length?i=l.config.xaxis.categories[t]:l.config.labels.length&&(i=l.config.labels[t]))}else i=l.config.labels[t];return null===i?"nullvalue":(Array.isArray(i)&&(i=i.join(" ")),m.isNumber(i)?i:i.split(r).join(""))},A=function(t,e){if(d.length&&0===e&&g.push(d.join(r)),t.data){t.data=t.data.length&&t.data||p(Array(v)).map((function(){return""}));for(var a=0;a<t.data.length;a++){d=[];var s=k(a);if("nullvalue"!==s){if(s||(y.isFormatXY()?s=i[e].data[a].x:y.isFormat2DArray()&&(s=i[e].data[a]?i[e].data[a][0]:"")),0===e){d.push(x(s));for(var o=0;o<l.globals.series.length;o++){var n,h=y.isFormatXY()?null===(n=i[o].data[a])||void 0===n?void 0:n.y:f[o][a];d.push(b(h))}}("candlestick"===l.config.chart.type||t.type&&"candlestick"===t.type)&&(d.pop(),d.push(l.globals.seriesCandleO[e][a]),d.push(l.globals.seriesCandleH[e][a]),d.push(l.globals.seriesCandleL[e][a]),d.push(l.globals.seriesCandleC[e][a])),("boxPlot"===l.config.chart.type||t.type&&"boxPlot"===t.type)&&(d.pop(),d.push(l.globals.seriesCandleO[e][a]),d.push(l.globals.seriesCandleH[e][a]),d.push(l.globals.seriesCandleM[e][a]),d.push(l.globals.seriesCandleL[e][a]),d.push(l.globals.seriesCandleC[e][a])),"rangeBar"===l.config.chart.type&&(d.pop(),d.push(l.globals.seriesRangeStart[e][a]),d.push(l.globals.seriesRangeEnd[e][a])),d.length&&g.push(d.join(r))}}}};d.push(l.config.chart.toolbar.export.csv.headerCategory),"boxPlot"===l.config.chart.type?(d.push("minimum"),d.push("q1"),d.push("median"),d.push("q3"),d.push("maximum")):"candlestick"===l.config.chart.type?(d.push("open"),d.push("high"),d.push("low"),d.push("close")):"rangeBar"===l.config.chart.type?(d.push("minimum"),d.push("maximum")):i.map((function(t,e){var i=(t.name?t.name:"series-".concat(e))+"";l.globals.axisCharts&&d.push(i.split(r).join("")?i.split(r).join(""):"series-".concat(e))})),l.globals.axisCharts||(d.push(l.config.chart.toolbar.export.csv.headerValue),g.push(d.join(r))),l.globals.allSeriesHasEqualX||!l.globals.axisCharts||l.config.xaxis.categories.length||l.config.labels.length?i.map((function(t,e){l.globals.axisCharts?A(t,e):((d=[]).push(x(l.globals.labels[e])),d.push(b(f[e])),g.push(d.join(r)))})):(h=new Set,c={},i.forEach((function(t,e){null==t||t.data.forEach((function(t){var a,s;if(y.isFormatXY())a=t.x,s=t.y;else{if(!y.isFormat2DArray())return;a=t[0],s=t[1]}c[a]||(c[a]=Array(i.length).fill("")),c[a][e]=b(s),h.add(a)}))})),d.length&&g.push(d.join(r)),Array.from(h).sort().forEach((function(t){g.push([x(t),c[t].join(r)])}))),u+=g.join(n),this.triggerDownload("data:text/csv; charset=utf-8,"+encodeURIComponent("\ufeff"+u),a||l.config.chart.toolbar.export.csv.filename,".csv")}},{key:"triggerDownload",value:function(t,e,i){var a=document.createElement("a");a.href=t,a.download=(e||this.w.globals.chartID)+i,document.body.appendChild(a),a.click(),document.body.removeChild(a)}}]),t}(),q=function(){function t(e,a){i(this,t),this.ctx=e,this.elgrid=a,this.w=e.w;var s=this.w;this.axesUtils=new M(e),this.xaxisLabels=s.globals.labels.slice(),s.globals.timescaleLabels.length>0&&!s.globals.isBarHorizontal&&(this.xaxisLabels=s.globals.timescaleLabels.slice()),s.config.xaxis.overwriteCategories&&(this.xaxisLabels=s.config.xaxis.overwriteCategories),this.drawnLabels=[],this.drawnLabelsRects=[],"top"===s.config.xaxis.position?this.offY=0:this.offY=s.globals.gridHeight,this.offY=this.offY+s.config.xaxis.axisBorder.offsetY,this.isCategoryBarHorizontal="bar"===s.config.chart.type&&s.config.plotOptions.bar.horizontal,this.xaxisFontSize=s.config.xaxis.labels.style.fontSize,this.xaxisFontFamily=s.config.xaxis.labels.style.fontFamily,this.xaxisForeColors=s.config.xaxis.labels.style.colors,this.xaxisBorderWidth=s.config.xaxis.axisBorder.width,this.isCategoryBarHorizontal&&(this.xaxisBorderWidth=s.config.yaxis[0].axisBorder.width.toString()),this.xaxisBorderWidth.indexOf("%")>-1?this.xaxisBorderWidth=s.globals.gridWidth*parseInt(this.xaxisBorderWidth,10)/100:this.xaxisBorderWidth=parseInt(this.xaxisBorderWidth,10),this.xaxisBorderHeight=s.config.xaxis.axisBorder.height,this.yaxis=s.config.yaxis[0]}return s(t,[{key:"drawXaxis",value:function(){var t=this.w,e=new k(this.ctx),i=e.group({class:"apexcharts-xaxis",transform:"translate(".concat(t.config.xaxis.offsetX,", ").concat(t.config.xaxis.offsetY,")")}),a=e.group({class:"apexcharts-xaxis-texts-g",transform:"translate(".concat(t.globals.translateXAxisX,", ").concat(t.globals.translateXAxisY,")")});i.add(a);for(var s=[],r=0;r<this.xaxisLabels.length;r++)s.push(this.xaxisLabels[r]);if(this.drawXAxisLabelAndGroup(!0,e,a,s,t.globals.isXNumeric,(function(t,e){return e})),t.globals.hasXaxisGroups){var o=t.globals.groups;s=[];for(var n=0;n<o.length;n++)s.push(o[n].title);var l={};t.config.xaxis.group.style&&(l.xaxisFontSize=t.config.xaxis.group.style.fontSize,l.xaxisFontFamily=t.config.xaxis.group.style.fontFamily,l.xaxisForeColors=t.config.xaxis.group.style.colors,l.fontWeight=t.config.xaxis.group.style.fontWeight,l.cssClass=t.config.xaxis.group.style.cssClass),this.drawXAxisLabelAndGroup(!1,e,a,s,!1,(function(t,e){return o[t].cols*e}),l)}if(void 0!==t.config.xaxis.title.text){var h=e.group({class:"apexcharts-xaxis-title"}),c=e.drawText({x:t.globals.gridWidth/2+t.config.xaxis.title.offsetX,y:this.offY+parseFloat(this.xaxisFontSize)+("bottom"===t.config.xaxis.position?t.globals.xAxisLabelsHeight:-t.globals.xAxisLabelsHeight-10)+t.config.xaxis.title.offsetY,text:t.config.xaxis.title.text,textAnchor:"middle",fontSize:t.config.xaxis.title.style.fontSize,fontFamily:t.config.xaxis.title.style.fontFamily,fontWeight:t.config.xaxis.title.style.fontWeight,foreColor:t.config.xaxis.title.style.color,cssClass:"apexcharts-xaxis-title-text "+t.config.xaxis.title.style.cssClass});h.add(c),i.add(h)}if(t.config.xaxis.axisBorder.show){var d=t.globals.barPadForNumericAxis,g=e.drawLine(t.globals.padHorizontal+t.config.xaxis.axisBorder.offsetX-d,this.offY,this.xaxisBorderWidth+d,this.offY,t.config.xaxis.axisBorder.color,0,this.xaxisBorderHeight);this.elgrid&&this.elgrid.elGridBorders&&t.config.grid.show?this.elgrid.elGridBorders.add(g):i.add(g)}return i}},{key:"drawXAxisLabelAndGroup",value:function(t,e,i,a,s,r){var o,n=this,l=arguments.length>6&&void 0!==arguments[6]?arguments[6]:{},h=[],c=[],d=this.w,g=l.xaxisFontSize||this.xaxisFontSize,u=l.xaxisFontFamily||this.xaxisFontFamily,f=l.xaxisForeColors||this.xaxisForeColors,p=l.fontWeight||d.config.xaxis.labels.style.fontWeight,x=l.cssClass||d.config.xaxis.labels.style.cssClass,b=d.globals.padHorizontal,v=a.length,m="category"===d.config.xaxis.type?d.globals.dataPoints:v;if(0===m&&v>m&&(m=v),s){var y=m>1?m-1:m;o=d.globals.gridWidth/Math.min(y,v-1),b=b+r(0,o)/2+d.config.xaxis.labels.offsetX}else o=d.globals.gridWidth/m,b=b+r(0,o)+d.config.xaxis.labels.offsetX;for(var w=function(s){var l=b-r(s,o)/2+d.config.xaxis.labels.offsetX;0===s&&1===v&&o/2===b&&1===m&&(l=d.globals.gridWidth/2);var y=n.axesUtils.getLabel(a,d.globals.timescaleLabels,l,s,h,g,t),w=28;d.globals.rotateXLabels&&t&&(w=22),d.config.xaxis.title.text&&"top"===d.config.xaxis.position&&(w+=parseFloat(d.config.xaxis.title.style.fontSize)+2),t||(w=w+parseFloat(g)+(d.globals.xAxisLabelsHeight-d.globals.xAxisGroupLabelsHeight)+(d.globals.rotateXLabels?10:0)),y=void 0!==d.config.xaxis.tickAmount&&"dataPoints"!==d.config.xaxis.tickAmount&&"datetime"!==d.config.xaxis.type?n.axesUtils.checkLabelBasedOnTickamount(s,y,v):n.axesUtils.checkForOverflowingLabels(s,y,v,h,c);if(d.config.xaxis.labels.show){var k=e.drawText({x:y.x,y:n.offY+d.config.xaxis.labels.offsetY+w-("top"===d.config.xaxis.position?d.globals.xAxisHeight+d.config.xaxis.axisTicks.height-2:0),text:y.text,textAnchor:"middle",fontWeight:y.isBold?600:p,fontSize:g,fontFamily:u,foreColor:Array.isArray(f)?t&&d.config.xaxis.convertedCatToNumeric?f[d.globals.minX+s-1]:f[s]:f,isPlainText:!1,cssClass:(t?"apexcharts-xaxis-label ":"apexcharts-xaxis-group-label ")+x});if(i.add(k),k.on("click",(function(t){if("function"==typeof d.config.chart.events.xAxisLabelClick){var e=Object.assign({},d,{labelIndex:s});d.config.chart.events.xAxisLabelClick(t,n.ctx,e)}})),t){var A=document.createElementNS(d.globals.SVGNS,"title");A.textContent=Array.isArray(y.text)?y.text.join(" "):y.text,k.node.appendChild(A),""!==y.text&&(h.push(y.text),c.push(y))}}s<v-1&&(b+=r(s+1,o))},k=0;k<=v-1;k++)w(k)}},{key:"drawXaxisInversed",value:function(t){var e,i,a=this,s=this.w,r=new k(this.ctx),o=s.config.yaxis[0].opposite?s.globals.translateYAxisX[t]:0,n=r.group({class:"apexcharts-yaxis apexcharts-xaxis-inversed",rel:t}),l=r.group({class:"apexcharts-yaxis-texts-g apexcharts-xaxis-inversed-texts-g",transform:"translate("+o+", 0)"});n.add(l);var h=[];if(s.config.yaxis[t].show)for(var c=0;c<this.xaxisLabels.length;c++)h.push(this.xaxisLabels[c]);e=s.globals.gridHeight/h.length,i=-e/2.2;var d=s.globals.yLabelFormatters[0],g=s.config.yaxis[0].labels;if(g.show)for(var u=function(o){var n=void 0===h[o]?"":h[o];n=d(n,{seriesIndex:t,dataPointIndex:o,w:s});var c=a.axesUtils.getYAxisForeColor(g.style.colors,t),u=0;Array.isArray(n)&&(u=n.length/2*parseInt(g.style.fontSize,10));var f=g.offsetX-15,p="end";a.yaxis.opposite&&(p="start"),"left"===s.config.yaxis[0].labels.align?(f=g.offsetX,p="start"):"center"===s.config.yaxis[0].labels.align?(f=g.offsetX,p="middle"):"right"===s.config.yaxis[0].labels.align&&(p="end");var x=r.drawText({x:f,y:i+e+g.offsetY-u,text:n,textAnchor:p,foreColor:Array.isArray(c)?c[o]:c,fontSize:g.style.fontSize,fontFamily:g.style.fontFamily,fontWeight:g.style.fontWeight,isPlainText:!1,cssClass:"apexcharts-yaxis-label "+g.style.cssClass,maxWidth:g.maxWidth});l.add(x),x.on("click",(function(t){if("function"==typeof s.config.chart.events.xAxisLabelClick){var e=Object.assign({},s,{labelIndex:o});s.config.chart.events.xAxisLabelClick(t,a.ctx,e)}}));var b=document.createElementNS(s.globals.SVGNS,"title");if(b.textContent=Array.isArray(n)?n.join(" "):n,x.node.appendChild(b),0!==s.config.yaxis[t].labels.rotate){var v=r.rotateAroundCenter(x.node);x.node.setAttribute("transform","rotate(".concat(s.config.yaxis[t].labels.rotate," 0 ").concat(v.y,")"))}i+=e},f=0;f<=h.length-1;f++)u(f);if(void 0!==s.config.yaxis[0].title.text){var p=r.group({class:"apexcharts-yaxis-title apexcharts-xaxis-title-inversed",transform:"translate("+o+", 0)"}),x=r.drawText({x:s.config.yaxis[0].title.offsetX,y:s.globals.gridHeight/2+s.config.yaxis[0].title.offsetY,text:s.config.yaxis[0].title.text,textAnchor:"middle",foreColor:s.config.yaxis[0].title.style.color,fontSize:s.config.yaxis[0].title.style.fontSize,fontWeight:s.config.yaxis[0].title.style.fontWeight,fontFamily:s.config.yaxis[0].title.style.fontFamily,cssClass:"apexcharts-yaxis-title-text "+s.config.yaxis[0].title.style.cssClass});p.add(x),n.add(p)}var b=0;this.isCategoryBarHorizontal&&s.config.yaxis[0].opposite&&(b=s.globals.gridWidth);var v=s.config.xaxis.axisBorder;if(v.show){var m=r.drawLine(s.globals.padHorizontal+v.offsetX+b,1+v.offsetY,s.globals.padHorizontal+v.offsetX+b,s.globals.gridHeight+v.offsetY,v.color,0);this.elgrid&&this.elgrid.elGridBorders&&s.config.grid.show?this.elgrid.elGridBorders.add(m):n.add(m)}return s.config.yaxis[0].axisTicks.show&&this.axesUtils.drawYAxisTicks(b,h.length,s.config.yaxis[0].axisBorder,s.config.yaxis[0].axisTicks,0,e,n),n}},{key:"drawXaxisTicks",value:function(t,e,i){var a=this.w,s=t;if(!(t<0||t-2>a.globals.gridWidth)){var r=this.offY+a.config.xaxis.axisTicks.offsetY;if(e=e+r+a.config.xaxis.axisTicks.height,"top"===a.config.xaxis.position&&(e=r-a.config.xaxis.axisTicks.height),a.config.xaxis.axisTicks.show){var o=new k(this.ctx).drawLine(t+a.config.xaxis.axisTicks.offsetX,r+a.config.xaxis.offsetY,s+a.config.xaxis.axisTicks.offsetX,e+a.config.xaxis.offsetY,a.config.xaxis.axisTicks.color);i.add(o),o.node.classList.add("apexcharts-xaxis-tick")}}}},{key:"getXAxisTicksPositions",value:function(){var t=this.w,e=[],i=this.xaxisLabels.length,a=t.globals.padHorizontal;if(t.globals.timescaleLabels.length>0)for(var s=0;s<i;s++)a=this.xaxisLabels[s].position,e.push(a);else for(var r=i,o=0;o<r;o++){var n=r;t.globals.isXNumeric&&"bar"!==t.config.chart.type&&(n-=1),a+=t.globals.gridWidth/n,e.push(a)}return e}},{key:"xAxisLabelCorrections",value:function(){var t=this.w,e=new k(this.ctx),i=t.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g"),a=t.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-texts-g text:not(.apexcharts-xaxis-group-label)"),s=t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-inversed text"),r=t.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-inversed-texts-g text tspan");if(t.globals.rotateXLabels||t.config.xaxis.labels.rotateAlways)for(var o=0;o<a.length;o++){var n=e.rotateAroundCenter(a[o]);n.y=n.y-1,n.x=n.x+1,a[o].setAttribute("transform","rotate(".concat(t.config.xaxis.labels.rotate," ").concat(n.x," ").concat(n.y,")")),a[o].setAttribute("text-anchor","end");i.setAttribute("transform","translate(0, ".concat(-10,")"));var l=a[o].childNodes;t.config.xaxis.labels.trim&&Array.prototype.forEach.call(l,(function(i){e.placeTextWithEllipsis(i,i.textContent,t.globals.xAxisLabelsHeight-("bottom"===t.config.legend.position?20:10))}))}else!function(){for(var i=t.globals.gridWidth/(t.globals.labels.length+1),s=0;s<a.length;s++){var r=a[s].childNodes;t.config.xaxis.labels.trim&&"datetime"!==t.config.xaxis.type&&Array.prototype.forEach.call(r,(function(t){e.placeTextWithEllipsis(t,t.textContent,i)}))}}();if(s.length>0){var h=s[s.length-1].getBBox(),c=s[0].getBBox();h.x<-20&&s[s.length-1].parentNode.removeChild(s[s.length-1]),c.x+c.width>t.globals.gridWidth&&!t.globals.isBarHorizontal&&s[0].parentNode.removeChild(s[0]);for(var d=0;d<r.length;d++)e.placeTextWithEllipsis(r[d],r[d].textContent,t.config.yaxis[0].labels.maxWidth-(t.config.yaxis[0].title.text?2*parseFloat(t.config.yaxis[0].title.style.fontSize):0)-15)}}}]),t}(),Z=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w;var a=this.w;this.xaxisLabels=a.globals.labels.slice(),this.axesUtils=new M(e),this.isRangeBar=a.globals.seriesRange.length&&a.globals.isBarHorizontal,a.globals.timescaleLabels.length>0&&(this.xaxisLabels=a.globals.timescaleLabels.slice())}return s(t,[{key:"drawGridArea",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,e=this.w,i=new k(this.ctx);t||(t=i.group({class:"apexcharts-grid"}));var a=i.drawLine(e.globals.padHorizontal,1,e.globals.padHorizontal,e.globals.gridHeight,"transparent"),s=i.drawLine(e.globals.padHorizontal,e.globals.gridHeight,e.globals.gridWidth,e.globals.gridHeight,"transparent");return t.add(s),t.add(a),t}},{key:"drawGrid",value:function(){if(this.w.globals.axisCharts){var t=this.renderGrid();return this.drawGridArea(t.el),t}return null}},{key:"createGridMask",value:function(){var t=this.w,e=t.globals,i=new k(this.ctx),a=Array.isArray(t.config.stroke.width)?Math.max.apply(Math,p(t.config.stroke.width)):t.config.stroke.width,s=function(t){var i=document.createElementNS(e.SVGNS,"clipPath");return i.setAttribute("id",t),i};e.dom.elGridRectMask=s("gridRectMask".concat(e.cuid)),e.dom.elGridRectBarMask=s("gridRectBarMask".concat(e.cuid)),e.dom.elGridRectMarkerMask=s("gridRectMarkerMask".concat(e.cuid)),e.dom.elForecastMask=s("forecastMask".concat(e.cuid)),e.dom.elNonForecastMask=s("nonForecastMask".concat(e.cuid));var r=0,o=0;(["bar","rangeBar","candlestick","boxPlot"].includes(t.config.chart.type)||t.globals.comboBarCount>0)&&t.globals.isXNumeric&&!t.globals.isBarHorizontal&&(r=Math.max(t.config.grid.padding.left,e.barPadForNumericAxis),o=Math.max(t.config.grid.padding.right,e.barPadForNumericAxis)),e.dom.elGridRect=i.drawRect(0,0,e.gridWidth,e.gridHeight,0,"#fff"),e.dom.elGridRectBar=i.drawRect(-a/2-r-2,-a/2-2,e.gridWidth+a+o+r+4,e.gridHeight+a+4,0,"#fff");var n=t.globals.markers.largestSize;e.dom.elGridRectMarker=i.drawRect(-n,-n,e.gridWidth+2*n,e.gridHeight+2*n,0,"#fff"),e.dom.elGridRectMask.appendChild(e.dom.elGridRect.node),e.dom.elGridRectBarMask.appendChild(e.dom.elGridRectBar.node),e.dom.elGridRectMarkerMask.appendChild(e.dom.elGridRectMarker.node);var l=e.dom.baseEl.querySelector("defs");l.appendChild(e.dom.elGridRectMask),l.appendChild(e.dom.elGridRectBarMask),l.appendChild(e.dom.elGridRectMarkerMask),l.appendChild(e.dom.elForecastMask),l.appendChild(e.dom.elNonForecastMask)}},{key:"_drawGridLines",value:function(t){var e=t.i,i=t.x1,a=t.y1,s=t.x2,r=t.y2,o=t.xCount,n=t.parent,l=this.w;if(!(0===e&&l.globals.skipFirstTimelinelabel||e===o-1&&l.globals.skipLastTimelinelabel&&!l.config.xaxis.labels.formatter||"radar"===l.config.chart.type)){l.config.grid.xaxis.lines.show&&this._drawGridLine({i:e,x1:i,y1:a,x2:s,y2:r,xCount:o,parent:n});var h=0;if(l.globals.hasXaxisGroups&&"between"===l.config.xaxis.tickPlacement){var c=l.globals.groups;if(c){for(var d=0,g=0;d<e&&g<c.length;g++)d+=c[g].cols;d===e&&(h=.6*l.globals.xAxisLabelsHeight)}}new q(this.ctx).drawXaxisTicks(i,h,l.globals.dom.elGraphical)}}},{key:"_drawGridLine",value:function(t){var e=t.i,i=t.x1,a=t.y1,s=t.x2,r=t.y2,o=t.xCount,n=t.parent,l=this.w,h=n.node.classList.contains("apexcharts-gridlines-horizontal"),c=l.globals.barPadForNumericAxis,d=0===a&&0===r||0===i&&0===s||a===l.globals.gridHeight&&r===l.globals.gridHeight||l.globals.isBarHorizontal&&(0===e||e===o-1),g=new k(this).drawLine(i-(h?c:0),a,s+(h?c:0),r,l.config.grid.borderColor,l.config.grid.strokeDashArray);g.node.classList.add("apexcharts-gridline"),d&&l.config.grid.show?this.elGridBorders.add(g):n.add(g)}},{key:"_drawGridBandRect",value:function(t){var e=t.c,i=t.x1,a=t.y1,s=t.x2,r=t.y2,o=t.type,n=this.w,l=new k(this.ctx),h=n.globals.barPadForNumericAxis,c=n.config.grid[o].colors[e],d=l.drawRect(i-("row"===o?h:0),a,s+("row"===o?2*h:0),r,0,c,n.config.grid[o].opacity);this.elg.add(d),d.attr("clip-path","url(#gridRectMask".concat(n.globals.cuid,")")),d.node.classList.add("apexcharts-grid-".concat(o))}},{key:"_drawXYLines",value:function(t){var e=this,i=t.xCount,a=t.tickAmount,s=this.w;if(s.config.grid.xaxis.lines.show||s.config.xaxis.axisTicks.show){var r,o=s.globals.padHorizontal,n=s.globals.gridHeight;s.globals.timescaleLabels.length?function(t){for(var a=t.xC,s=t.x1,r=t.y1,o=t.x2,n=t.y2,l=0;l<a;l++)s=e.xaxisLabels[l].position,o=e.xaxisLabels[l].position,e._drawGridLines({i:l,x1:s,y1:r,x2:o,y2:n,xCount:i,parent:e.elgridLinesV})}({xC:i,x1:o,y1:0,x2:r,y2:n}):(s.globals.isXNumeric&&(i=s.globals.xAxisScale.result.length),function(t){for(var a=t.xC,r=t.x1,o=t.y1,n=t.x2,l=t.y2,h=0;h<a+(s.globals.isXNumeric?0:1);h++)0===h&&1===a&&1===s.globals.dataPoints&&(n=r=s.globals.gridWidth/2),e._drawGridLines({i:h,x1:r,y1:o,x2:n,y2:l,xCount:i,parent:e.elgridLinesV}),n=r+=s.globals.gridWidth/(s.globals.isXNumeric?a-1:a)}({xC:i,x1:o,y1:0,x2:r,y2:n}))}if(s.config.grid.yaxis.lines.show){var l=0,h=0,c=s.globals.gridWidth,d=a+1;this.isRangeBar&&(d=s.globals.labels.length);for(var g=0;g<d+(this.isRangeBar?1:0);g++)this._drawGridLine({i:g,xCount:d+(this.isRangeBar?1:0),x1:0,y1:l,x2:c,y2:h,parent:this.elgridLinesH}),h=l+=s.globals.gridHeight/(this.isRangeBar?d:a)}}},{key:"_drawInvertedXYLines",value:function(t){var e=t.xCount,i=this.w;if(i.config.grid.xaxis.lines.show||i.config.xaxis.axisTicks.show)for(var a,s=i.globals.padHorizontal,r=i.globals.gridHeight,o=0;o<e+1;o++){i.config.grid.xaxis.lines.show&&this._drawGridLine({i:o,xCount:e+1,x1:s,y1:0,x2:a,y2:r,parent:this.elgridLinesV}),new q(this.ctx).drawXaxisTicks(s,0,i.globals.dom.elGraphical),a=s+=i.globals.gridWidth/e}if(i.config.grid.yaxis.lines.show)for(var n=0,l=0,h=i.globals.gridWidth,c=0;c<i.globals.dataPoints+1;c++)this._drawGridLine({i:c,xCount:i.globals.dataPoints+1,x1:0,y1:n,x2:h,y2:l,parent:this.elgridLinesH}),l=n+=i.globals.gridHeight/i.globals.dataPoints}},{key:"renderGrid",value:function(){var t=this.w,e=t.globals,i=new k(this.ctx);this.elg=i.group({class:"apexcharts-grid"}),this.elgridLinesH=i.group({class:"apexcharts-gridlines-horizontal"}),this.elgridLinesV=i.group({class:"apexcharts-gridlines-vertical"}),this.elGridBorders=i.group({class:"apexcharts-grid-borders"}),this.elg.add(this.elgridLinesH),this.elg.add(this.elgridLinesV),t.config.grid.show||(this.elgridLinesV.hide(),this.elgridLinesH.hide(),this.elGridBorders.hide());for(var a=0;a<e.seriesYAxisMap.length&&e.ignoreYAxisIndexes.includes(a);)a++;a===e.seriesYAxisMap.length&&(a=0);var s,r=e.yAxisScale[a].result.length-1;if(!e.isBarHorizontal||this.isRangeBar){var o,n,l;if(s=this.xaxisLabels.length,this.isRangeBar)r=e.labels.length,t.config.xaxis.tickAmount&&t.config.xaxis.labels.formatter&&(s=t.config.xaxis.tickAmount),(null===(o=e.yAxisScale)||void 0===o||null===(n=o[a])||void 0===n||null===(l=n.result)||void 0===l?void 0:l.length)>0&&"datetime"!==t.config.xaxis.type&&(s=e.yAxisScale[a].result.length-1);this._drawXYLines({xCount:s,tickAmount:r})}else s=r,r=e.xTickAmount,this._drawInvertedXYLines({xCount:s,tickAmount:r});return this.drawGridBands(s,r),{el:this.elg,elGridBorders:this.elGridBorders,xAxisTickWidth:e.gridWidth/s}}},{key:"drawGridBands",value:function(t,e){var i,a,s=this,r=this.w;if((null===(i=r.config.grid.row.colors)||void 0===i?void 0:i.length)>0&&function(t,i,a,o,n,l){for(var h=0,c=0;h<i;h++,c++)c>=r.config.grid[t].colors.length&&(c=0),s._drawGridBandRect({c:c,x1:a,y1:o,x2:n,y2:l,type:t}),o+=r.globals.gridHeight/e}("row",e,0,0,r.globals.gridWidth,r.globals.gridHeight/e),(null===(a=r.config.grid.column.colors)||void 0===a?void 0:a.length)>0){var o=r.globals.isBarHorizontal||"on"!==r.config.xaxis.tickPlacement||"category"!==r.config.xaxis.type&&!r.config.xaxis.convertedCatToNumeric?t:t-1;r.globals.isXNumeric&&(o=r.globals.xAxisScale.result.length-1);for(var n=r.globals.padHorizontal,l=r.globals.padHorizontal+r.globals.gridWidth/o,h=r.globals.gridHeight,c=0,d=0;c<t;c++,d++){var g;if(d>=r.config.grid.column.colors.length&&(d=0),"datetime"===r.config.xaxis.type)n=this.xaxisLabels[c].position,l=((null===(g=this.xaxisLabels[c+1])||void 0===g?void 0:g.position)||r.globals.gridWidth)-this.xaxisLabels[c].position;this._drawGridBandRect({c:d,x1:n,y1:0,x2:l,y2:h,type:"column"}),n+=r.globals.gridWidth/o}}}}]),t}(),$=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w,this.coreUtils=new A(this.ctx)}return s(t,[{key:"niceScale",value:function(t,e){var i,a,s,r,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,n=1e-11,l=this.w,h=l.globals;h.isBarHorizontal?(i=l.config.xaxis,a=Math.max((h.svgWidth-100)/25,2)):(i=l.config.yaxis[o],a=Math.max((h.svgHeight-100)/15,2)),m.isNumber(a)||(a=10),s=void 0!==i.min&&null!==i.min,r=void 0!==i.max&&null!==i.min;var c=void 0!==i.stepSize&&null!==i.stepSize,d=void 0!==i.tickAmount&&null!==i.tickAmount,g=d?i.tickAmount:h.niceScaleDefaultTicks[Math.min(Math.round(a/2),h.niceScaleDefaultTicks.length-1)];if(h.isMultipleYAxis&&!d&&h.multiAxisTickAmount>0&&(g=h.multiAxisTickAmount,d=!0),g="dataPoints"===g?h.dataPoints-1:Math.abs(Math.round(g)),(t===Number.MIN_VALUE&&0===e||!m.isNumber(t)&&!m.isNumber(e)||t===Number.MIN_VALUE&&e===-Number.MAX_VALUE)&&(t=m.isNumber(i.min)?i.min:0,e=m.isNumber(i.max)?i.max:t+g,h.allSeriesCollapsed=!1),t>e){console.warn("axis.min cannot be greater than axis.max: swapping min and max");var u=e;e=t,t=u}else t===e&&(t=0===t?0:t-1,e=0===e?2:e+1);var f=[];g<1&&(g=1);var p=g,x=Math.abs(e-t);!s&&t>0&&t/x<.15&&(t=0,s=!0),!r&&e<0&&-e/x<.15&&(e=0,r=!0);var b=(x=Math.abs(e-t))/p,v=b,y=Math.floor(Math.log10(v)),w=Math.pow(10,y),k=Math.ceil(v/w);if(b=v=(k=h.niceScaleAllowedMagMsd[0===h.yValueDecimal?0:1][k])*w,h.isBarHorizontal&&i.stepSize&&"datetime"!==i.type?(b=i.stepSize,c=!0):c&&(b=i.stepSize),c&&i.forceNiceScale){var A=Math.floor(Math.log10(b));b*=Math.pow(10,y-A)}if(s&&r){var S=x/p;if(d)if(c)if(0!=m.mod(x,b)){var C=m.getGCD(b,S);b=S/C<10?C:S}else 0==m.mod(b,S)?b=S:(S=b,d=!1);else b=S;else if(c)0==m.mod(x,b)?S=b:b=S;else if(0==m.mod(x,b))S=b;else{S=x/(p=Math.ceil(x/b));var L=m.getGCD(x,b);x/L<a&&(S=L),b=S}p=Math.round(x/b)}else{if(s||r){if(r)if(d)t=e-b*p;else{var P=t;t=b*Math.floor(t/b),Math.abs(e-t)/m.getGCD(x,b)>a&&(t=e-b*g,t+=b*Math.floor((P-t)/b))}else if(s)if(d)e=t+b*p;else{var M=e;e=b*Math.ceil(e/b),Math.abs(e-t)/m.getGCD(x,b)>a&&(e=t+b*g,e+=b*Math.ceil((M-e)/b))}}else if(h.isMultipleYAxis&&d){var I=b*Math.floor(t/b),T=I+b*p;T<e&&(b*=2),T=e,e=(t=I)+b*p,x=Math.abs(e-t),t>0&&t<Math.abs(T-e)&&(t=0,e=b*p),e<0&&-e<Math.abs(I-t)&&(e=0,t=-b*p)}else t=b*Math.floor(t/b),e=b*Math.ceil(e/b);x=Math.abs(e-t),b=m.getGCD(x,b),p=Math.round(x/b)}if(d||s||r||(p=Math.ceil((x-n)/(b+n)))>16&&m.getPrimeFactors(p).length<2&&p++,!d&&i.forceNiceScale&&0===h.yValueDecimal&&p>x&&(p=x,b=Math.round(x/p)),p>a&&(!d&&!c||i.forceNiceScale)){var z=m.getPrimeFactors(p),X=z.length-1,E=p;t:for(var Y=0;Y<X;Y++)for(var R=0;R<=X-Y;R++){for(var F=Math.min(R+Y,X),D=E,H=1,O=R;O<=F;O++)H*=z[O];if((D/=H)<a){E=D;break t}}b=E===p?x:x/E,p=Math.round(x/b)}h.isMultipleYAxis&&0==h.multiAxisTickAmount&&h.ignoreYAxisIndexes.indexOf(o)<0&&(h.multiAxisTickAmount=p);var N=t-b,W=b*n;do{N+=b,f.push(m.stripNumber(N,7))}while(e-N>W);return{result:f,niceMin:f[0],niceMax:f[f.length-1]}}},{key:"linearScale",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:10,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:void 0,r=Math.abs(e-t),o=[];if(t===e)return{result:o=[t],niceMin:o[0],niceMax:o[o.length-1]};"dataPoints"===(i=this._adjustTicksForSmallRange(i,a,r))&&(i=this.w.globals.dataPoints-1),s||(s=r/i),s=Math.round(10*(s+Number.EPSILON))/10,i===Number.MAX_VALUE&&(i=5,s=1);for(var n=t;i>=0;)o.push(n),n=m.preciseAddition(n,s),i-=1;return{result:o,niceMin:o[0],niceMax:o[o.length-1]}}},{key:"logarithmicScaleNice",value:function(t,e,i){e<=0&&(e=Math.max(t,i)),t<=0&&(t=Math.min(e,i));for(var a=[],s=Math.ceil(Math.log(e)/Math.log(i)+1),r=Math.floor(Math.log(t)/Math.log(i));r<s;r++)a.push(Math.pow(i,r));return{result:a,niceMin:a[0],niceMax:a[a.length-1]}}},{key:"logarithmicScale",value:function(t,e,i){e<=0&&(e=Math.max(t,i)),t<=0&&(t=Math.min(e,i));for(var a=[],s=Math.log(e)/Math.log(i),r=Math.log(t)/Math.log(i),o=s-r,n=Math.round(o),l=o/n,h=0,c=r;h<n;h++,c+=l)a.push(Math.pow(i,c));return a.push(Math.pow(i,s)),{result:a,niceMin:t,niceMax:e}}},{key:"_adjustTicksForSmallRange",value:function(t,e,i){var a=t;if(void 0!==e&&this.w.config.yaxis[e].labels.formatter&&void 0===this.w.config.yaxis[e].tickAmount){var s=Number(this.w.config.yaxis[e].labels.formatter(1));m.isNumber(s)&&0===this.w.globals.yValueDecimal&&(a=Math.ceil(i))}return a<t?a:t}},{key:"setYScaleForIndex",value:function(t,e,i){var a=this.w.globals,s=this.w.config,r=a.isBarHorizontal?s.xaxis:s.yaxis[t];void 0===a.yAxisScale[t]&&(a.yAxisScale[t]=[]);var o=Math.abs(i-e);r.logarithmic&&o<=5&&(a.invalidLogScale=!0),r.logarithmic&&o>5?(a.allSeriesCollapsed=!1,a.yAxisScale[t]=r.forceNiceScale?this.logarithmicScaleNice(e,i,r.logBase):this.logarithmicScale(e,i,r.logBase)):i!==-Number.MAX_VALUE&&m.isNumber(i)&&e!==Number.MAX_VALUE&&m.isNumber(e)?(a.allSeriesCollapsed=!1,a.yAxisScale[t]=this.niceScale(e,i,t)):a.yAxisScale[t]=this.niceScale(Number.MIN_VALUE,0,t)}},{key:"setXScale",value:function(t,e){var i=this.w,a=i.globals,s=Math.abs(e-t);if(e!==-Number.MAX_VALUE&&m.isNumber(e)){var r=a.xTickAmount+1;s<10&&s>1&&(r=s),a.xAxisScale=this.linearScale(t,e,r,0,i.config.xaxis.stepSize)}else a.xAxisScale=this.linearScale(0,10,10);return a.xAxisScale}},{key:"scaleMultipleYAxes",value:function(){var t=this,e=this.w.config,i=this.w.globals;this.coreUtils.setSeriesYAxisMappings();var a=i.seriesYAxisMap,s=i.minYArr,r=i.maxYArr;i.allSeriesCollapsed=!0,i.barGroups=[],a.forEach((function(a,o){var n=[];a.forEach((function(t){var i=e.series[t].group;n.indexOf(i)<0&&n.push(i)})),a.length>0?function(){var l,h,c=Number.MAX_VALUE,d=-Number.MAX_VALUE,g=c,u=d;if(e.chart.stacked)!function(){var t=new Array(i.dataPoints).fill(0),s=[],r=[],f=[];n.forEach((function(){s.push(t.map((function(){return Number.MIN_VALUE}))),r.push(t.map((function(){return Number.MIN_VALUE}))),f.push(t.map((function(){return Number.MIN_VALUE})))}));for(var p=function(t){!l&&e.series[a[t]].type&&(l=e.series[a[t]].type);var c=a[t];h=e.series[c].group?e.series[c].group:"axis-".concat(o),!(i.collapsedSeriesIndices.indexOf(c)<0&&i.ancillaryCollapsedSeriesIndices.indexOf(c)<0)||(i.allSeriesCollapsed=!1,n.forEach((function(t,a){if(e.series[c].group===t)for(var o=0;o<i.series[c].length;o++){var n=i.series[c][o];n>=0?r[a][o]+=n:f[a][o]+=n,s[a][o]+=n,g=Math.min(g,n),u=Math.max(u,n)}}))),"bar"!==l&&"column"!==l||i.barGroups.push(h)},x=0;x<a.length;x++)p(x);l||(l=e.chart.type),"bar"===l||"column"===l?n.forEach((function(t,e){c=Math.min(c,Math.min.apply(null,f[e])),d=Math.max(d,Math.max.apply(null,r[e]))})):(n.forEach((function(t,e){g=Math.min(g,Math.min.apply(null,s[e])),u=Math.max(u,Math.max.apply(null,s[e]))})),c=g,d=u),c===Number.MIN_VALUE&&d===Number.MIN_VALUE&&(d=-Number.MAX_VALUE)}();else for(var f=0;f<a.length;f++){var p=a[f];c=Math.min(c,s[p]),d=Math.max(d,r[p]),!(i.collapsedSeriesIndices.indexOf(p)<0&&i.ancillaryCollapsedSeriesIndices.indexOf(p)<0)||(i.allSeriesCollapsed=!1)}void 0!==e.yaxis[o].min&&(c="function"==typeof e.yaxis[o].min?e.yaxis[o].min(c):e.yaxis[o].min),void 0!==e.yaxis[o].max&&(d="function"==typeof e.yaxis[o].max?e.yaxis[o].max(d):e.yaxis[o].max),i.barGroups=i.barGroups.filter((function(t,e,i){return i.indexOf(t)===e})),t.setYScaleForIndex(o,c,d),a.forEach((function(t){s[t]=i.yAxisScale[o].niceMin,r[t]=i.yAxisScale[o].niceMax}))}():t.setYScaleForIndex(o,0,-Number.MAX_VALUE)}))}}]),t}(),J=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w,this.scales=new $(e)}return s(t,[{key:"init",value:function(){this.setYRange(),this.setXRange(),this.setZRange()}},{key:"getMinYMaxY",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Number.MAX_VALUE,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:-Number.MAX_VALUE,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null,s=this.w.config,r=this.w.globals,o=-Number.MAX_VALUE,n=Number.MIN_VALUE;null===a&&(a=t+1);var l=r.series,h=l,c=l;"candlestick"===s.chart.type?(h=r.seriesCandleL,c=r.seriesCandleH):"boxPlot"===s.chart.type?(h=r.seriesCandleO,c=r.seriesCandleC):r.isRangeData&&(h=r.seriesRangeStart,c=r.seriesRangeEnd);var d=!1;if(r.seriesX.length>=a){var g,u=null===(g=r.brushSource)||void 0===g?void 0:g.w.config.chart.brush;(s.chart.zoom.enabled&&s.chart.zoom.autoScaleYaxis||null!=u&&u.enabled&&null!=u&&u.autoScaleYaxis)&&(d=!0)}for(var f=t;f<a;f++){r.dataPoints=Math.max(r.dataPoints,l[f].length);var p=s.series[f].type;r.categoryLabels.length&&(r.dataPoints=r.categoryLabels.filter((function(t){return void 0!==t})).length),r.labels.length&&"datetime"!==s.xaxis.type&&0!==r.series.reduce((function(t,e){return t+e.length}),0)&&(r.dataPoints=Math.max(r.dataPoints,r.labels.length));var x=0,b=l[f].length-1;if(d){if(s.xaxis.min)for(;x<b&&r.seriesX[f][x]<s.xaxis.min;x++);if(s.xaxis.max)for(;b>x&&r.seriesX[f][b]>s.xaxis.max;b--);}for(var v=x;v<=b&&v<r.series[f].length;v++){var y=l[f][v];if(null!==y&&m.isNumber(y)){switch(void 0!==c[f][v]&&(o=Math.max(o,c[f][v]),e=Math.min(e,c[f][v])),void 0!==h[f][v]&&(e=Math.min(e,h[f][v]),i=Math.max(i,h[f][v])),p){case"candlestick":void 0!==r.seriesCandleC[f][v]&&(o=Math.max(o,r.seriesCandleH[f][v]),e=Math.min(e,r.seriesCandleL[f][v]));break;case"boxPlot":void 0!==r.seriesCandleC[f][v]&&(o=Math.max(o,r.seriesCandleC[f][v]),e=Math.min(e,r.seriesCandleO[f][v]))}p&&"candlestick"!==p&&"boxPlot"!==p&&"rangeArea"!==p&&"rangeBar"!==p&&(o=Math.max(o,r.series[f][v]),e=Math.min(e,r.series[f][v])),i=o,r.seriesGoals[f]&&r.seriesGoals[f][v]&&Array.isArray(r.seriesGoals[f][v])&&r.seriesGoals[f][v].forEach((function(t){n!==Number.MIN_VALUE&&(n=Math.min(n,t.value),e=n),o=Math.max(o,t.value),i=o})),m.isFloat(y)&&(y=m.noExponents(y),r.yValueDecimal=Math.max(r.yValueDecimal,y.toString().split(".")[1].length)),n>h[f][v]&&h[f][v]<0&&(n=h[f][v])}else r.hasNullValues=!0}"bar"!==p&&"column"!==p||(n<0&&o<0&&(o=0,i=Math.max(i,0)),n===Number.MIN_VALUE&&(n=0,e=Math.min(e,0)))}return"rangeBar"===s.chart.type&&r.seriesRangeStart.length&&r.isBarHorizontal&&(n=e),"bar"===s.chart.type&&(n<0&&o<0&&(o=0),n===Number.MIN_VALUE&&(n=0)),{minY:n,maxY:o,lowestY:e,highestY:i}}},{key:"setYRange",value:function(){var t=this.w.globals,e=this.w.config;t.maxY=-Number.MAX_VALUE,t.minY=Number.MIN_VALUE;var i,a=Number.MAX_VALUE;if(t.isMultipleYAxis){a=Number.MAX_VALUE;for(var s=0;s<t.series.length;s++)i=this.getMinYMaxY(s),t.minYArr[s]=i.lowestY,t.maxYArr[s]=i.highestY,a=Math.min(a,i.lowestY)}if(i=this.getMinYMaxY(0,a,null,t.series.length),"bar"===e.chart.type?(t.minY=i.minY,t.maxY=i.maxY):(t.minY=i.lowestY,t.maxY=i.highestY),a=i.lowestY,e.chart.stacked&&this._setStackedMinMax(),"line"===e.chart.type||"area"===e.chart.type||"scatter"===e.chart.type||"candlestick"===e.chart.type||"boxPlot"===e.chart.type||"rangeBar"===e.chart.type&&!t.isBarHorizontal?t.minY===Number.MIN_VALUE&&a!==-Number.MAX_VALUE&&a!==t.maxY&&(t.minY=a):t.minY=t.minY!==Number.MIN_VALUE?Math.min(i.minY,t.minY):i.minY,e.yaxis.forEach((function(e,i){void 0!==e.max&&("number"==typeof e.max?t.maxYArr[i]=e.max:"function"==typeof e.max&&(t.maxYArr[i]=e.max(t.isMultipleYAxis?t.maxYArr[i]:t.maxY)),t.maxY=t.maxYArr[i]),void 0!==e.min&&("number"==typeof e.min?t.minYArr[i]=e.min:"function"==typeof e.min&&(t.minYArr[i]=e.min(t.isMultipleYAxis?t.minYArr[i]===Number.MIN_VALUE?0:t.minYArr[i]:t.minY)),t.minY=t.minYArr[i])})),t.isBarHorizontal){["min","max"].forEach((function(i){void 0!==e.xaxis[i]&&"number"==typeof e.xaxis[i]&&("min"===i?t.minY=e.xaxis[i]:t.maxY=e.xaxis[i])}))}return t.isMultipleYAxis?(this.scales.scaleMultipleYAxes(),t.minY=a):(this.scales.setYScaleForIndex(0,t.minY,t.maxY),t.minY=t.yAxisScale[0].niceMin,t.maxY=t.yAxisScale[0].niceMax,t.minYArr[0]=t.minY,t.maxYArr[0]=t.maxY),t.barGroups=[],t.lineGroups=[],t.areaGroups=[],e.series.forEach((function(i){switch(i.type||e.chart.type){case"bar":case"column":t.barGroups.push(i.group);break;case"line":t.lineGroups.push(i.group);break;case"area":t.areaGroups.push(i.group)}})),t.barGroups=t.barGroups.filter((function(t,e,i){return i.indexOf(t)===e})),t.lineGroups=t.lineGroups.filter((function(t,e,i){return i.indexOf(t)===e})),t.areaGroups=t.areaGroups.filter((function(t,e,i){return i.indexOf(t)===e})),{minY:t.minY,maxY:t.maxY,minYArr:t.minYArr,maxYArr:t.maxYArr,yAxisScale:t.yAxisScale}}},{key:"setXRange",value:function(){var t=this.w.globals,e=this.w.config,i="numeric"===e.xaxis.type||"datetime"===e.xaxis.type||"category"===e.xaxis.type&&!t.noLabelsProvided||t.noLabelsProvided||t.isXNumeric;if(t.isXNumeric&&function(){for(var e=0;e<t.series.length;e++)if(t.labels[e])for(var i=0;i<t.labels[e].length;i++)null!==t.labels[e][i]&&m.isNumber(t.labels[e][i])&&(t.maxX=Math.max(t.maxX,t.labels[e][i]),t.initialMaxX=Math.max(t.maxX,t.labels[e][i]),t.minX=Math.min(t.minX,t.labels[e][i]),t.initialMinX=Math.min(t.minX,t.labels[e][i]))}(),t.noLabelsProvided&&0===e.xaxis.categories.length&&(t.maxX=t.labels[t.labels.length-1],t.initialMaxX=t.labels[t.labels.length-1],t.minX=1,t.initialMinX=1),t.isXNumeric||t.noLabelsProvided||t.dataFormatXNumeric){var a=10;if(void 0===e.xaxis.tickAmount)a=Math.round(t.svgWidth/150),"numeric"===e.xaxis.type&&t.dataPoints<30&&(a=t.dataPoints-1),a>t.dataPoints&&0!==t.dataPoints&&(a=t.dataPoints-1);else if("dataPoints"===e.xaxis.tickAmount){if(t.series.length>1&&(a=t.series[t.maxValsInArrayIndex].length-1),t.isXNumeric){var s=t.maxX-t.minX;s<30&&(a=s-1)}}else a=e.xaxis.tickAmount;if(t.xTickAmount=a,void 0!==e.xaxis.max&&"number"==typeof e.xaxis.max&&(t.maxX=e.xaxis.max),void 0!==e.xaxis.min&&"number"==typeof e.xaxis.min&&(t.minX=e.xaxis.min),void 0!==e.xaxis.range&&(t.minX=t.maxX-e.xaxis.range),t.minX!==Number.MAX_VALUE&&t.maxX!==-Number.MAX_VALUE)if(e.xaxis.convertedCatToNumeric&&!t.dataFormatXNumeric){for(var r=[],o=t.minX-1;o<t.maxX;o++)r.push(o+1);t.xAxisScale={result:r,niceMin:r[0],niceMax:r[r.length-1]}}else t.xAxisScale=this.scales.setXScale(t.minX,t.maxX);else t.xAxisScale=this.scales.linearScale(0,a,a,0,e.xaxis.stepSize),t.noLabelsProvided&&t.labels.length>0&&(t.xAxisScale=this.scales.linearScale(1,t.labels.length,a-1,0,e.xaxis.stepSize),t.seriesX=t.labels.slice());i&&(t.labels=t.xAxisScale.result.slice())}return t.isBarHorizontal&&t.labels.length&&(t.xTickAmount=t.labels.length),this._handleSingleDataPoint(),this._getMinXDiff(),{minX:t.minX,maxX:t.maxX}}},{key:"setZRange",value:function(){var t=this.w.globals;if(t.isDataXYZ)for(var e=0;e<t.series.length;e++)if(void 0!==t.seriesZ[e])for(var i=0;i<t.seriesZ[e].length;i++)null!==t.seriesZ[e][i]&&m.isNumber(t.seriesZ[e][i])&&(t.maxZ=Math.max(t.maxZ,t.seriesZ[e][i]),t.minZ=Math.min(t.minZ,t.seriesZ[e][i]))}},{key:"_handleSingleDataPoint",value:function(){var t=this.w.globals,e=this.w.config;if(t.minX===t.maxX){var i=new L(this.ctx);if("datetime"===e.xaxis.type){var a=i.getDate(t.minX);e.xaxis.labels.datetimeUTC?a.setUTCDate(a.getUTCDate()-2):a.setDate(a.getDate()-2),t.minX=new Date(a).getTime();var s=i.getDate(t.maxX);e.xaxis.labels.datetimeUTC?s.setUTCDate(s.getUTCDate()+2):s.setDate(s.getDate()+2),t.maxX=new Date(s).getTime()}else("numeric"===e.xaxis.type||"category"===e.xaxis.type&&!t.noLabelsProvided)&&(t.minX=t.minX-2,t.initialMinX=t.minX,t.maxX=t.maxX+2,t.initialMaxX=t.maxX)}}},{key:"_getMinXDiff",value:function(){var t=this.w.globals;t.isXNumeric&&t.seriesX.forEach((function(e,i){1===e.length&&e.push(t.seriesX[t.maxValsInArrayIndex][t.seriesX[t.maxValsInArrayIndex].length-1]);var a=e.slice();a.sort((function(t,e){return t-e})),a.forEach((function(e,i){if(i>0){var s=e-a[i-1];s>0&&(t.minXDiff=Math.min(s,t.minXDiff))}})),1!==t.dataPoints&&t.minXDiff!==Number.MAX_VALUE||(t.minXDiff=.5)}))}},{key:"_setStackedMinMax",value:function(){var t=this,e=this.w.globals;if(e.series.length){var i=e.seriesGroups;i.length||(i=[this.w.globals.seriesNames.map((function(t){return t}))]);var a={},s={};i.forEach((function(i){a[i]=[],s[i]=[],t.w.config.series.map((function(t,a){return i.indexOf(e.seriesNames[a])>-1?a:null})).filter((function(t){return null!==t})).forEach((function(r){for(var o=0;o<e.series[e.maxValsInArrayIndex].length;o++){var n,l,h,c;void 0===a[i][o]&&(a[i][o]=0,s[i][o]=0),(t.w.config.chart.stacked&&!e.comboCharts||t.w.config.chart.stacked&&e.comboCharts&&(!t.w.config.chart.stackOnlyBar||"bar"===(null===(n=t.w.config.series)||void 0===n||null===(l=n[r])||void 0===l?void 0:l.type)||"column"===(null===(h=t.w.config.series)||void 0===h||null===(c=h[r])||void 0===c?void 0:c.type)))&&null!==e.series[r][o]&&m.isNumber(e.series[r][o])&&(e.series[r][o]>0?a[i][o]+=parseFloat(e.series[r][o])+1e-4:s[i][o]+=parseFloat(e.series[r][o]))}}))})),Object.entries(a).forEach((function(t){var i=f(t,1)[0];a[i].forEach((function(t,r){e.maxY=Math.max(e.maxY,a[i][r]),e.minY=Math.min(e.minY,s[i][r])}))}))}}}]),t}(),Q=function(){function t(e,a){i(this,t),this.ctx=e,this.elgrid=a,this.w=e.w;var s=this.w;this.xaxisFontSize=s.config.xaxis.labels.style.fontSize,this.axisFontFamily=s.config.xaxis.labels.style.fontFamily,this.xaxisForeColors=s.config.xaxis.labels.style.colors,this.isCategoryBarHorizontal="bar"===s.config.chart.type&&s.config.plotOptions.bar.horizontal,this.xAxisoffX="bottom"===s.config.xaxis.position?s.globals.gridHeight:0,this.drawnLabels=[],this.axesUtils=new M(e)}return s(t,[{key:"drawYaxis",value:function(t){var e=this.w,i=new k(this.ctx),a=e.config.yaxis[t].labels.style,s=a.fontSize,r=a.fontFamily,o=a.fontWeight,n=i.group({class:"apexcharts-yaxis",rel:t,transform:"translate(".concat(e.globals.translateYAxisX[t],", 0)")});if(this.axesUtils.isYAxisHidden(t))return n;var l=i.group({class:"apexcharts-yaxis-texts-g"});n.add(l);var h=e.globals.yAxisScale[t].result.length-1,c=e.globals.gridHeight/h,d=e.globals.yLabelFormatters[t],g=this.axesUtils.checkForReversedLabels(t,e.globals.yAxisScale[t].result.slice());if(e.config.yaxis[t].labels.show){var u=e.globals.translateY+e.config.yaxis[t].labels.offsetY;e.globals.isBarHorizontal?u=0:"heatmap"===e.config.chart.type&&(u-=c/2),u+=parseInt(s,10)/3;for(var f=h;f>=0;f--){var p=d(g[f],f,e),x=e.config.yaxis[t].labels.padding;e.config.yaxis[t].opposite&&0!==e.config.yaxis.length&&(x*=-1);var b=this.getTextAnchor(e.config.yaxis[t].labels.align,e.config.yaxis[t].opposite),v=this.axesUtils.getYAxisForeColor(a.colors,t),y=Array.isArray(v)?v[f]:v,w=m.listToArray(e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis[rel='".concat(t,"'] .apexcharts-yaxis-label tspan"))).map((function(t){return t.textContent})),A=i.drawText({x:x,y:u,text:w.includes(p)&&!e.config.yaxis[t].labels.showDuplicates?"":p,textAnchor:b,fontSize:s,fontFamily:r,fontWeight:o,maxWidth:e.config.yaxis[t].labels.maxWidth,foreColor:y,isPlainText:!1,cssClass:"apexcharts-yaxis-label ".concat(a.cssClass)});l.add(A),this.addTooltip(A,p),0!==e.config.yaxis[t].labels.rotate&&this.rotateLabel(i,A,firstLabel,e.config.yaxis[t].labels.rotate),u+=c}}return this.addYAxisTitle(i,n,t),this.addAxisBorder(i,n,t,h,c),n}},{key:"getTextAnchor",value:function(t,e){return"left"===t?"start":"center"===t?"middle":"right"===t?"end":e?"start":"end"}},{key:"addTooltip",value:function(t,e){var i=document.createElementNS(this.w.globals.SVGNS,"title");i.textContent=Array.isArray(e)?e.join(" "):e,t.node.appendChild(i)}},{key:"rotateLabel",value:function(t,e,i,a){var s=t.rotateAroundCenter(i.node),r=t.rotateAroundCenter(e.node);e.node.setAttribute("transform","rotate(".concat(a," ").concat(s.x," ").concat(r.y,")"))}},{key:"addYAxisTitle",value:function(t,e,i){var a=this.w;if(void 0!==a.config.yaxis[i].title.text){var s=t.group({class:"apexcharts-yaxis-title"}),r=a.config.yaxis[i].opposite?a.globals.translateYAxisX[i]:0,o=t.drawText({x:r,y:a.globals.gridHeight/2+a.globals.translateY+a.config.yaxis[i].title.offsetY,text:a.config.yaxis[i].title.text,textAnchor:"end",foreColor:a.config.yaxis[i].title.style.color,fontSize:a.config.yaxis[i].title.style.fontSize,fontWeight:a.config.yaxis[i].title.style.fontWeight,fontFamily:a.config.yaxis[i].title.style.fontFamily,cssClass:"apexcharts-yaxis-title-text ".concat(a.config.yaxis[i].title.style.cssClass)});s.add(o),e.add(s)}}},{key:"addAxisBorder",value:function(t,e,i,a,s){var r=this.w,o=r.config.yaxis[i].axisBorder,n=31+o.offsetX;if(r.config.yaxis[i].opposite&&(n=-31-o.offsetX),o.show){var l=t.drawLine(n,r.globals.translateY+o.offsetY-2,n,r.globals.gridHeight+r.globals.translateY+o.offsetY+2,o.color,0,o.width);e.add(l)}r.config.yaxis[i].axisTicks.show&&this.axesUtils.drawYAxisTicks(n,a,o,r.config.yaxis[i].axisTicks,i,s,e)}},{key:"drawYaxisInversed",value:function(t){var e=this.w,i=new k(this.ctx),a=i.group({class:"apexcharts-xaxis apexcharts-yaxis-inversed"}),s=i.group({class:"apexcharts-xaxis-texts-g",transform:"translate(".concat(e.globals.translateXAxisX,", ").concat(e.globals.translateXAxisY,")")});a.add(s);var r=e.globals.yAxisScale[t].result.length-1,o=e.globals.gridWidth/r+.1,n=o+e.config.xaxis.labels.offsetX,l=e.globals.xLabelFormatter,h=this.axesUtils.checkForReversedLabels(t,e.globals.yAxisScale[t].result.slice()),c=e.globals.timescaleLabels;if(c.length>0&&(this.xaxisLabels=c.slice(),r=(h=c.slice()).length),e.config.xaxis.labels.show)for(var d=c.length?0:r;c.length?d<c.length:d>=0;c.length?d++:d--){var g=l(h[d],d,e),u=e.globals.gridWidth+e.globals.padHorizontal-(n-o+e.config.xaxis.labels.offsetX);if(c.length){var f=this.axesUtils.getLabel(h,c,u,d,this.drawnLabels,this.xaxisFontSize);u=f.x,g=f.text,this.drawnLabels.push(f.text),0===d&&e.globals.skipFirstTimelinelabel&&(g=""),d===h.length-1&&e.globals.skipLastTimelinelabel&&(g="")}var p=i.drawText({x:u,y:this.xAxisoffX+e.config.xaxis.labels.offsetY+30-("top"===e.config.xaxis.position?e.globals.xAxisHeight+e.config.xaxis.axisTicks.height-2:0),text:g,textAnchor:"middle",foreColor:Array.isArray(this.xaxisForeColors)?this.xaxisForeColors[t]:this.xaxisForeColors,fontSize:this.xaxisFontSize,fontFamily:this.xaxisFontFamily,fontWeight:e.config.xaxis.labels.style.fontWeight,isPlainText:!1,cssClass:"apexcharts-xaxis-label ".concat(e.config.xaxis.labels.style.cssClass)});s.add(p),p.tspan(g),this.addTooltip(p,g),n+=o}return this.inversedYAxisTitleText(a),this.inversedYAxisBorder(a),a}},{key:"inversedYAxisBorder",value:function(t){var e=this.w,i=new k(this.ctx),a=e.config.xaxis.axisBorder;if(a.show){var s=0;"bar"===e.config.chart.type&&e.globals.isXNumeric&&(s-=15);var r=i.drawLine(e.globals.padHorizontal+s+a.offsetX,this.xAxisoffX,e.globals.gridWidth,this.xAxisoffX,a.color,0,a.height);this.elgrid&&this.elgrid.elGridBorders&&e.config.grid.show?this.elgrid.elGridBorders.add(r):t.add(r)}}},{key:"inversedYAxisTitleText",value:function(t){var e=this.w,i=new k(this.ctx);if(void 0!==e.config.xaxis.title.text){var a=i.group({class:"apexcharts-xaxis-title apexcharts-yaxis-title-inversed"}),s=i.drawText({x:e.globals.gridWidth/2+e.config.xaxis.title.offsetX,y:this.xAxisoffX+parseFloat(this.xaxisFontSize)+parseFloat(e.config.xaxis.title.style.fontSize)+e.config.xaxis.title.offsetY+20,text:e.config.xaxis.title.text,textAnchor:"middle",fontSize:e.config.xaxis.title.style.fontSize,fontFamily:e.config.xaxis.title.style.fontFamily,fontWeight:e.config.xaxis.title.style.fontWeight,foreColor:e.config.xaxis.title.style.color,cssClass:"apexcharts-xaxis-title-text ".concat(e.config.xaxis.title.style.cssClass)});a.add(s),t.add(a)}}},{key:"yAxisTitleRotate",value:function(t,e){var i=this.w,a=new k(this.ctx),s=i.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(t,"'] .apexcharts-yaxis-texts-g")),r=s?s.getBoundingClientRect():{width:0,height:0},o=i.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(t,"'] .apexcharts-yaxis-title text")),n=o?o.getBoundingClientRect():{width:0,height:0};if(o){var l=this.xPaddingForYAxisTitle(t,r,n,e);o.setAttribute("x",l.xPos-(e?10:0));var h=a.rotateAroundCenter(o);o.setAttribute("transform","rotate(".concat(e?-1*i.config.yaxis[t].title.rotate:i.config.yaxis[t].title.rotate," ").concat(h.x," ").concat(h.y,")"))}}},{key:"xPaddingForYAxisTitle",value:function(t,e,i,a){var s=this.w,r=0,o=10;return void 0===s.config.yaxis[t].title.text||t<0?{xPos:r,padd:0}:(a?r=e.width+s.config.yaxis[t].title.offsetX+i.width/2+o/2:(r=-1*e.width+s.config.yaxis[t].title.offsetX+o/2+i.width/2,s.globals.isBarHorizontal&&(o=25,r=-1*e.width-s.config.yaxis[t].title.offsetX-o)),{xPos:r,padd:o})}},{key:"setYAxisXPosition",value:function(t,e){var i=this.w,a=0,s=0,r=18,o=1;i.config.yaxis.length>1&&(this.multipleYs=!0),i.config.yaxis.forEach((function(n,l){var h=i.globals.ignoreYAxisIndexes.includes(l)||!n.show||n.floating||0===t[l].width,c=t[l].width+e[l].width;n.opposite?i.globals.isBarHorizontal?(s=i.globals.gridWidth+i.globals.translateX-1,i.globals.translateYAxisX[l]=s-n.labels.offsetX):(s=i.globals.gridWidth+i.globals.translateX+o,h||(o+=c+20),i.globals.translateYAxisX[l]=s-n.labels.offsetX+20):(a=i.globals.translateX-r,h||(r+=c+20),i.globals.translateYAxisX[l]=a+n.labels.offsetX)}))}},{key:"setYAxisTextAlignments",value:function(){var t=this.w;m.listToArray(t.globals.dom.baseEl.getElementsByClassName("apexcharts-yaxis")).forEach((function(e,i){var a=t.config.yaxis[i];if(a&&!a.floating&&void 0!==a.labels.align){var s=t.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(i,"'] .apexcharts-yaxis-texts-g")),r=m.listToArray(t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis[rel='".concat(i,"'] .apexcharts-yaxis-label"))),o=s.getBoundingClientRect();r.forEach((function(t){t.setAttribute("text-anchor",a.labels.align)})),"left"!==a.labels.align||a.opposite?"center"===a.labels.align?s.setAttribute("transform","translate(".concat(o.width/2*(a.opposite?1:-1),", 0)")):"right"===a.labels.align&&a.opposite&&s.setAttribute("transform","translate(".concat(o.width,", 0)")):s.setAttribute("transform","translate(-".concat(o.width,", 0)"))}}))}}]),t}(),K=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w,this.documentEvent=m.bind(this.documentEvent,this)}return s(t,[{key:"addEventListener",value:function(t,e){var i=this.w;i.globals.events.hasOwnProperty(t)?i.globals.events[t].push(e):i.globals.events[t]=[e]}},{key:"removeEventListener",value:function(t,e){var i=this.w;if(i.globals.events.hasOwnProperty(t)){var a=i.globals.events[t].indexOf(e);-1!==a&&i.globals.events[t].splice(a,1)}}},{key:"fireEvent",value:function(t,e){var i=this.w;if(i.globals.events.hasOwnProperty(t)){e&&e.length||(e=[]);for(var a=i.globals.events[t],s=a.length,r=0;r<s;r++)a[r].apply(null,e)}}},{key:"setupEventHandlers",value:function(){var t=this,e=this.w,i=this.ctx,a=e.globals.dom.baseEl.querySelector(e.globals.chartClass);this.ctx.eventList.forEach((function(t){a.addEventListener(t,(function(t){var a=Object.assign({},e,{seriesIndex:e.globals.axisCharts?e.globals.capturedSeriesIndex:0,dataPointIndex:e.globals.capturedDataPointIndex});"mousemove"===t.type||"touchmove"===t.type?"function"==typeof e.config.chart.events.mouseMove&&e.config.chart.events.mouseMove(t,i,a):"mouseleave"===t.type||"touchleave"===t.type?"function"==typeof e.config.chart.events.mouseLeave&&e.config.chart.events.mouseLeave(t,i,a):("mouseup"===t.type&&1===t.which||"touchend"===t.type)&&("function"==typeof e.config.chart.events.click&&e.config.chart.events.click(t,i,a),i.ctx.events.fireEvent("click",[t,i,a]))}),{capture:!1,passive:!0})})),this.ctx.eventList.forEach((function(i){e.globals.dom.baseEl.addEventListener(i,t.documentEvent,{passive:!0})})),this.ctx.core.setupBrushHandler()}},{key:"documentEvent",value:function(t){var e=this.w,i=t.target.className;if("click"===t.type){var a=e.globals.dom.baseEl.querySelector(".apexcharts-menu");a&&a.classList.contains("apexcharts-menu-open")&&"apexcharts-menu-icon"!==i&&a.classList.remove("apexcharts-menu-open")}e.globals.clientX="touchmove"===t.type?t.touches[0].clientX:t.clientX,e.globals.clientY="touchmove"===t.type?t.touches[0].clientY:t.clientY}}]),t}(),tt=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w}return s(t,[{key:"setCurrentLocaleValues",value:function(t){var e=this.w.config.chart.locales;window.Apex.chart&&window.Apex.chart.locales&&window.Apex.chart.locales.length>0&&(e=this.w.config.chart.locales.concat(window.Apex.chart.locales));var i=e.filter((function(e){return e.name===t}))[0];if(!i)throw new Error("Wrong locale name provided. Please make sure you set the correct locale name in options");var a=m.extend(z,i);this.w.globals.locale=a.options}}]),t}(),et=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w}return s(t,[{key:"drawAxis",value:function(t,e){var i,a,s=this,r=this.w.globals,o=this.w.config,n=new q(this.ctx,e),l=new Q(this.ctx,e);r.axisCharts&&"radar"!==t&&(r.isBarHorizontal?(a=l.drawYaxisInversed(0),i=n.drawXaxisInversed(0),r.dom.elGraphical.add(i),r.dom.elGraphical.add(a)):(i=n.drawXaxis(),r.dom.elGraphical.add(i),o.yaxis.map((function(t,e){if(-1===r.ignoreYAxisIndexes.indexOf(e)&&(a=l.drawYaxis(e),r.dom.Paper.add(a),"back"===s.w.config.grid.position)){var i=r.dom.Paper.children()[1];i.remove(),r.dom.Paper.add(i)}}))))}}]),t}(),it=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w}return s(t,[{key:"drawXCrosshairs",value:function(){var t=this.w,e=new k(this.ctx),i=new w(this.ctx),a=t.config.xaxis.crosshairs.fill.gradient,s=t.config.xaxis.crosshairs.dropShadow,r=t.config.xaxis.crosshairs.fill.type,o=a.colorFrom,n=a.colorTo,l=a.opacityFrom,h=a.opacityTo,c=a.stops,d=s.enabled,g=s.left,u=s.top,f=s.blur,p=s.color,x=s.opacity,b=t.config.xaxis.crosshairs.fill.color;if(t.config.xaxis.crosshairs.show){"gradient"===r&&(b=e.drawGradient("vertical",o,n,l,h,null,c,null));var v=e.drawRect();1===t.config.xaxis.crosshairs.width&&(v=e.drawLine());var y=t.globals.gridHeight;(!m.isNumber(y)||y<0)&&(y=0);var A=t.config.xaxis.crosshairs.width;(!m.isNumber(A)||A<0)&&(A=0),v.attr({class:"apexcharts-xcrosshairs",x:0,y:0,y2:y,width:A,height:y,fill:b,filter:"none","fill-opacity":t.config.xaxis.crosshairs.opacity,stroke:t.config.xaxis.crosshairs.stroke.color,"stroke-width":t.config.xaxis.crosshairs.stroke.width,"stroke-dasharray":t.config.xaxis.crosshairs.stroke.dashArray}),d&&(v=i.dropShadow(v,{left:g,top:u,blur:f,color:p,opacity:x})),t.globals.dom.elGraphical.add(v)}}},{key:"drawYCrosshairs",value:function(){var t=this.w,e=new k(this.ctx),i=t.config.yaxis[0].crosshairs,a=t.globals.barPadForNumericAxis;if(t.config.yaxis[0].crosshairs.show){var s=e.drawLine(-a,0,t.globals.gridWidth+a,0,i.stroke.color,i.stroke.dashArray,i.stroke.width);s.attr({class:"apexcharts-ycrosshairs"}),t.globals.dom.elGraphical.add(s)}var r=e.drawLine(-a,0,t.globals.gridWidth+a,0,i.stroke.color,0,0);r.attr({class:"apexcharts-ycrosshairs-hidden"}),t.globals.dom.elGraphical.add(r)}}]),t}(),at=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w}return s(t,[{key:"checkResponsiveConfig",value:function(t){var e=this,i=this.w,a=i.config;if(0!==a.responsive.length){var s=a.responsive.slice();s.sort((function(t,e){return t.breakpoint>e.breakpoint?1:e.breakpoint>t.breakpoint?-1:0})).reverse();var r=new D({}),o=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},a=s[0].breakpoint,o=window.innerWidth>0?window.innerWidth:screen.width;if(o>a){var n=m.clone(i.globals.initialConfig);n.series=m.clone(i.config.series);var l=A.extendArrayProps(r,n,i);t=m.extend(l,t),t=m.extend(i.config,t),e.overrideResponsiveOptions(t)}else for(var h=0;h<s.length;h++)o<s[h].breakpoint&&(t=A.extendArrayProps(r,s[h].options,i),t=m.extend(i.config,t),e.overrideResponsiveOptions(t))};if(t){var n=A.extendArrayProps(r,t,i);n=m.extend(i.config,n),o(n=m.extend(n,t))}else o({})}}},{key:"overrideResponsiveOptions",value:function(t){var e=new D(t).init({responsiveOverride:!0});this.w.config=e}}]),t}(),st=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w,this.colors=[],this.isColorFn=!1,this.isHeatmapDistributed=this.checkHeatmapDistributed(),this.isBarDistributed=this.checkBarDistributed()}return s(t,[{key:"checkHeatmapDistributed",value:function(){var t=this.w.config,e=t.chart,i=t.plotOptions;return"treemap"===e.type&&i.treemap&&i.treemap.distributed||"heatmap"===e.type&&i.heatmap&&i.heatmap.distributed}},{key:"checkBarDistributed",value:function(){var t=this.w.config,e=t.chart,i=t.plotOptions;return i.bar&&i.bar.distributed&&("bar"===e.type||"rangeBar"===e.type)}},{key:"init",value:function(){this.setDefaultColors()}},{key:"setDefaultColors",value:function(){var t=this.w,e=new m;t.globals.dom.elWrap.classList.add("apexcharts-theme-".concat(t.config.theme.mode));var i=p(t.config.colors||t.config.fill.colors||[]);t.globals.colors=this.getColors(i),this.applySeriesColors(t.globals.seriesColors,t.globals.colors),t.config.theme.monochrome.enabled&&(t.globals.colors=this.getMonochromeColors(t.config.theme.monochrome,t.globals.series,e));var a=t.globals.colors.slice();this.pushExtraColors(t.globals.colors),this.applyColorTypes(["fill","stroke"],a),this.applyDataLabelsColors(a),this.applyRadarPolygonsColors(),this.applyMarkersColors(a)}},{key:"getColors",value:function(t){var e=this,i=this.w;return t&&0!==t.length?Array.isArray(t)&&t.length>0&&"function"==typeof t[0]?(this.isColorFn=!0,i.config.series.map((function(a,s){var r=t[s]||t[0];return"function"==typeof r?r({value:i.globals.axisCharts?i.globals.series[s][0]||0:i.globals.series[s],seriesIndex:s,dataPointIndex:s,w:e.w}):r}))):t:this.predefined()}},{key:"applySeriesColors",value:function(t,e){t.forEach((function(t,i){t&&(e[i]=t)}))}},{key:"getMonochromeColors",value:function(t,e,i){var a=t.color,s=t.shadeIntensity,r=t.shadeTo,o=this.isBarDistributed||this.isHeatmapDistributed?e[0].length*e.length:e.length,n=1/(o/s),l=0;return Array.from({length:o},(function(){var t="dark"===r?i.shadeColor(-1*l,a):i.shadeColor(l,a);return l+=n,t}))}},{key:"applyColorTypes",value:function(t,e){var i=this,a=this.w;t.forEach((function(t){a.globals[t].colors=void 0===a.config[t].colors?i.isColorFn?a.config.colors:e:a.config[t].colors.slice(),i.pushExtraColors(a.globals[t].colors)}))}},{key:"applyDataLabelsColors",value:function(t){var e=this.w;e.globals.dataLabels.style.colors=void 0===e.config.dataLabels.style.colors?t:e.config.dataLabels.style.colors.slice(),this.pushExtraColors(e.globals.dataLabels.style.colors,50)}},{key:"applyRadarPolygonsColors",value:function(){var t=this.w;t.globals.radarPolygons.fill.colors=void 0===t.config.plotOptions.radar.polygons.fill.colors?["dark"===t.config.theme.mode?"#424242":"none"]:t.config.plotOptions.radar.polygons.fill.colors.slice(),this.pushExtraColors(t.globals.radarPolygons.fill.colors,20)}},{key:"applyMarkersColors",value:function(t){var e=this.w;e.globals.markers.colors=void 0===e.config.markers.colors?t:e.config.markers.colors.slice(),this.pushExtraColors(e.globals.markers.colors)}},{key:"pushExtraColors",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,a=this.w,s=e||a.globals.series.length;if(null===i&&(i=this.isBarDistributed||this.isHeatmapDistributed||"heatmap"===a.config.chart.type&&a.config.plotOptions.heatmap&&a.config.plotOptions.heatmap.colorScale.inverse),i&&a.globals.series.length&&(s=a.globals.series[a.globals.maxValsInArrayIndex].length*a.globals.series.length),t.length<s)for(var r=s-t.length,o=0;o<r;o++)t.push(t[o])}},{key:"updateThemeOptions",value:function(t){t.chart=t.chart||{},t.tooltip=t.tooltip||{};var e=t.theme.mode,i="dark"===e?"palette4":"light"===e?"palette1":t.theme.palette||"palette1",a="dark"===e?"#f6f7f8":"light"===e?"#373d3f":t.chart.foreColor||"#373d3f";return t.tooltip.theme=e||"light",t.chart.foreColor=a,t.theme.palette=i,t}},{key:"predefined",value:function(){var t={palette1:["#008FFB","#00E396","#FEB019","#FF4560","#775DD0"],palette2:["#3f51b5","#03a9f4","#4caf50","#f9ce1d","#FF9800"],palette3:["#33b2df","#546E7A","#d4526e","#13d8aa","#A5978B"],palette4:["#4ecdc4","#c7f464","#81D4FA","#fd6a6a","#546E7A"],palette5:["#2b908f","#f9a3a4","#90ee7e","#fa4443","#69d2e7"],palette6:["#449DD1","#F86624","#EA3546","#662E9B","#C5D86D"],palette7:["#D7263D","#1B998B","#2E294E","#F46036","#E2C044"],palette8:["#662E9B","#F86624","#F9C80E","#EA3546","#43BCCD"],palette9:["#5C4742","#A5978B","#8D5B4C","#5A2A27","#C4BBAF"],palette10:["#A300D6","#7D02EB","#5653FE","#2983FF","#00B1F2"],default:["#008FFB","#00E396","#FEB019","#FF4560","#775DD0"]};return t[this.w.config.theme.palette]||t.default}}]),t}(),rt=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w}return s(t,[{key:"draw",value:function(){this.drawTitleSubtitle("title"),this.drawTitleSubtitle("subtitle")}},{key:"drawTitleSubtitle",value:function(t){var e=this.w,i="title"===t?e.config.title:e.config.subtitle,a=e.globals.svgWidth/2,s=i.offsetY,r="middle";if("left"===i.align?(a=10,r="start"):"right"===i.align&&(a=e.globals.svgWidth-10,r="end"),a+=i.offsetX,s=s+parseInt(i.style.fontSize,10)+i.margin/2,void 0!==i.text){var o=new k(this.ctx).drawText({x:a,y:s,text:i.text,textAnchor:r,fontSize:i.style.fontSize,fontFamily:i.style.fontFamily,fontWeight:i.style.fontWeight,foreColor:i.style.color,opacity:1});o.node.setAttribute("class","apexcharts-".concat(t,"-text")),e.globals.dom.Paper.add(o)}}}]),t}(),ot=function(){function t(e){i(this,t),this.w=e.w,this.dCtx=e}return s(t,[{key:"getTitleSubtitleCoords",value:function(t){var e=this.w,i=0,a=0,s="title"===t?e.config.title.floating:e.config.subtitle.floating,r=e.globals.dom.baseEl.querySelector(".apexcharts-".concat(t,"-text"));if(null!==r&&!s){var o=r.getBoundingClientRect();i=o.width,a=e.globals.axisCharts?o.height+5:o.height}return{width:i,height:a}}},{key:"getLegendsRect",value:function(){var t=this.w,e=t.globals.dom.elLegendWrap;t.config.legend.height||"top"!==t.config.legend.position&&"bottom"!==t.config.legend.position||(e.style.maxHeight=t.globals.svgHeight/2+"px");var i=Object.assign({},m.getBoundingClientRect(e));return null!==e&&!t.config.legend.floating&&t.config.legend.show?this.dCtx.lgRect={x:i.x,y:i.y,height:i.height,width:0===i.height?0:i.width}:this.dCtx.lgRect={x:0,y:0,height:0,width:0},"left"!==t.config.legend.position&&"right"!==t.config.legend.position||1.5*this.dCtx.lgRect.width>t.globals.svgWidth&&(this.dCtx.lgRect.width=t.globals.svgWidth/1.5),this.dCtx.lgRect}},{key:"getDatalabelsRect",value:function(){var t=this,e=this.w,i=[];e.config.series.forEach((function(s,r){s.data.forEach((function(s,o){var n;n=e.globals.series[r][o],a=e.config.dataLabels.formatter(n,{ctx:t.dCtx.ctx,seriesIndex:r,dataPointIndex:o,w:e}),i.push(a)}))}));var a=m.getLargestStringFromArr(i),s=new k(this.dCtx.ctx),r=e.config.dataLabels.style,o=s.getTextRects(a,parseInt(r.fontSize),r.fontFamily);return{width:1.05*o.width,height:o.height}}},{key:"getLargestStringFromMultiArr",value:function(t,e){var i=t;if(this.w.globals.isMultiLineX){var a=e.map((function(t,e){return Array.isArray(t)?t.length:1})),s=Math.max.apply(Math,p(a));i=e[a.indexOf(s)]}return i}}]),t}(),nt=function(){function t(e){i(this,t),this.w=e.w,this.dCtx=e}return s(t,[{key:"getxAxisLabelsCoords",value:function(){var t,e=this.w,i=e.globals.labels.slice();if(e.config.xaxis.convertedCatToNumeric&&0===i.length&&(i=e.globals.categoryLabels),e.globals.timescaleLabels.length>0){var a=this.getxAxisTimeScaleLabelsCoords();t={width:a.width,height:a.height},e.globals.rotateXLabels=!1}else{this.dCtx.lgWidthForSideLegends="left"!==e.config.legend.position&&"right"!==e.config.legend.position||e.config.legend.floating?0:this.dCtx.lgRect.width;var s=e.globals.xLabelFormatter,r=m.getLargestStringFromArr(i),o=this.dCtx.dimHelpers.getLargestStringFromMultiArr(r,i);e.globals.isBarHorizontal&&(o=r=e.globals.yAxisScale[0].result.reduce((function(t,e){return t.length>e.length?t:e}),0));var n=new P(this.dCtx.ctx),l=r;r=n.xLabelFormat(s,r,l,{i:void 0,dateFormatter:new L(this.dCtx.ctx).formatDate,w:e}),o=n.xLabelFormat(s,o,l,{i:void 0,dateFormatter:new L(this.dCtx.ctx).formatDate,w:e}),(e.config.xaxis.convertedCatToNumeric&&void 0===r||""===String(r).trim())&&(o=r="1");var h=new k(this.dCtx.ctx),c=h.getTextRects(r,e.config.xaxis.labels.style.fontSize),d=c;if(r!==o&&(d=h.getTextRects(o,e.config.xaxis.labels.style.fontSize)),(t={width:c.width>=d.width?c.width:d.width,height:c.height>=d.height?c.height:d.height}).width*i.length>e.globals.svgWidth-this.dCtx.lgWidthForSideLegends-this.dCtx.yAxisWidth-this.dCtx.gridPad.left-this.dCtx.gridPad.right&&0!==e.config.xaxis.labels.rotate||e.config.xaxis.labels.rotateAlways){if(!e.globals.isBarHorizontal){e.globals.rotateXLabels=!0;var g=function(t){return h.getTextRects(t,e.config.xaxis.labels.style.fontSize,e.config.xaxis.labels.style.fontFamily,"rotate(".concat(e.config.xaxis.labels.rotate," 0 0)"),!1)};c=g(r),r!==o&&(d=g(o)),t.height=(c.height>d.height?c.height:d.height)/1.5,t.width=c.width>d.width?c.width:d.width}}else e.globals.rotateXLabels=!1}return e.config.xaxis.labels.show||(t={width:0,height:0}),{width:t.width,height:t.height}}},{key:"getxAxisGroupLabelsCoords",value:function(){var t,e=this.w;if(!e.globals.hasXaxisGroups)return{width:0,height:0};var i,a=(null===(t=e.config.xaxis.group.style)||void 0===t?void 0:t.fontSize)||e.config.xaxis.labels.style.fontSize,s=e.globals.groups.map((function(t){return t.title})),r=m.getLargestStringFromArr(s),o=this.dCtx.dimHelpers.getLargestStringFromMultiArr(r,s),n=new k(this.dCtx.ctx),l=n.getTextRects(r,a),h=l;return r!==o&&(h=n.getTextRects(o,a)),i={width:l.width>=h.width?l.width:h.width,height:l.height>=h.height?l.height:h.height},e.config.xaxis.labels.show||(i={width:0,height:0}),{width:i.width,height:i.height}}},{key:"getxAxisTitleCoords",value:function(){var t=this.w,e=0,i=0;if(void 0!==t.config.xaxis.title.text){var a=new k(this.dCtx.ctx).getTextRects(t.config.xaxis.title.text,t.config.xaxis.title.style.fontSize);e=a.width,i=a.height}return{width:e,height:i}}},{key:"getxAxisTimeScaleLabelsCoords",value:function(){var t,e=this.w;this.dCtx.timescaleLabels=e.globals.timescaleLabels.slice();var i=this.dCtx.timescaleLabels.map((function(t){return t.value})),a=i.reduce((function(t,e){return void 0===t?(console.error("You have possibly supplied invalid Date format. Please supply a valid JavaScript Date"),0):t.length>e.length?t:e}),0);return 1.05*(t=new k(this.dCtx.ctx).getTextRects(a,e.config.xaxis.labels.style.fontSize)).width*i.length>e.globals.gridWidth&&0!==e.config.xaxis.labels.rotate&&(e.globals.overlappingXLabels=!0),t}},{key:"additionalPaddingXLabels",value:function(t){var e=this,i=this.w,a=i.globals,s=i.config,r=s.xaxis.type,o=t.width;a.skipLastTimelinelabel=!1,a.skipFirstTimelinelabel=!1;var n=i.config.yaxis[0].opposite&&i.globals.isBarHorizontal,l=function(t,n){s.yaxis.length>1&&function(t){return-1!==a.collapsedSeriesIndices.indexOf(t)}(n)||function(t){if(e.dCtx.timescaleLabels&&e.dCtx.timescaleLabels.length){var n=e.dCtx.timescaleLabels[0],l=e.dCtx.timescaleLabels[e.dCtx.timescaleLabels.length-1].position+o/1.75-e.dCtx.yAxisWidthRight,h=n.position-o/1.75+e.dCtx.yAxisWidthLeft,c="right"===i.config.legend.position&&e.dCtx.lgRect.width>0?e.dCtx.lgRect.width:0;l>a.svgWidth-a.translateX-c&&(a.skipLastTimelinelabel=!0),h<-(t.show&&!t.floating||"bar"!==s.chart.type&&"candlestick"!==s.chart.type&&"rangeBar"!==s.chart.type&&"boxPlot"!==s.chart.type?10:o/1.75)&&(a.skipFirstTimelinelabel=!0)}else"datetime"===r?e.dCtx.gridPad.right<o&&!a.rotateXLabels&&(a.skipLastTimelinelabel=!0):"datetime"!==r&&e.dCtx.gridPad.right<o/2-e.dCtx.yAxisWidthRight&&!a.rotateXLabels&&!i.config.xaxis.labels.trim&&(e.dCtx.xPadRight=o/2+1)}(t)};s.yaxis.forEach((function(t,i){n?(e.dCtx.gridPad.left<o&&(e.dCtx.xPadLeft=o/2+1),e.dCtx.xPadRight=o/2+1):l(t,i)}))}}]),t}(),lt=function(){function t(e){i(this,t),this.w=e.w,this.dCtx=e}return s(t,[{key:"getyAxisLabelsCoords",value:function(){var t=this,e=this.w,i=[],a=10,s=new M(this.dCtx.ctx);return e.config.yaxis.map((function(r,o){var n={seriesIndex:o,dataPointIndex:-1,w:e},l=e.globals.yAxisScale[o],h=0;if(!s.isYAxisHidden(o)&&r.labels.show&&void 0!==r.labels.minWidth&&(h=r.labels.minWidth),!s.isYAxisHidden(o)&&r.labels.show&&l.result.length){var c=e.globals.yLabelFormatters[o],d=l.niceMin===Number.MIN_VALUE?0:l.niceMin,g=l.result.reduce((function(t,e){var i,a;return(null===(i=String(c(t,n)))||void 0===i?void 0:i.length)>(null===(a=String(c(e,n)))||void 0===a?void 0:a.length)?t:e}),d),u=g=c(g,n);if(void 0!==g&&0!==g.length||(g=l.niceMax),e.globals.isBarHorizontal){a=0;var f=e.globals.labels.slice();g=m.getLargestStringFromArr(f),g=c(g,{seriesIndex:o,dataPointIndex:-1,w:e}),u=t.dCtx.dimHelpers.getLargestStringFromMultiArr(g,f)}var p=new k(t.dCtx.ctx),x="rotate(".concat(r.labels.rotate," 0 0)"),b=p.getTextRects(g,r.labels.style.fontSize,r.labels.style.fontFamily,x,!1),v=b;g!==u&&(v=p.getTextRects(u,r.labels.style.fontSize,r.labels.style.fontFamily,x,!1)),i.push({width:(h>v.width||h>b.width?h:v.width>b.width?v.width:b.width)+a,height:v.height>b.height?v.height:b.height})}else i.push({width:0,height:0})})),i}},{key:"getyAxisTitleCoords",value:function(){var t=this,e=this.w,i=[];return e.config.yaxis.map((function(e,a){if(e.show&&void 0!==e.title.text){var s=new k(t.dCtx.ctx),r="rotate(".concat(e.title.rotate," 0 0)"),o=s.getTextRects(e.title.text,e.title.style.fontSize,e.title.style.fontFamily,r,!1);i.push({width:o.width,height:o.height})}else i.push({width:0,height:0})})),i}},{key:"getTotalYAxisWidth",value:function(){var t=this.w,e=0,i=0,a=0,s=t.globals.yAxisScale.length>1?10:0,r=new M(this.dCtx.ctx),o=function(o,n){var l=t.config.yaxis[n].floating,h=0;o.width>0&&!l?(h=o.width+s,function(e){return t.globals.ignoreYAxisIndexes.indexOf(e)>-1}(n)&&(h=h-o.width-s)):h=l||r.isYAxisHidden(n)?0:5,t.config.yaxis[n].opposite?a+=h:i+=h,e+=h};return t.globals.yLabelsCoords.map((function(t,e){o(t,e)})),t.globals.yTitleCoords.map((function(t,e){o(t,e)})),t.globals.isBarHorizontal&&!t.config.yaxis[0].floating&&(e=t.globals.yLabelsCoords[0].width+t.globals.yTitleCoords[0].width+15),this.dCtx.yAxisWidthLeft=i,this.dCtx.yAxisWidthRight=a,e}}]),t}(),ht=function(){function t(e){i(this,t),this.w=e.w,this.dCtx=e}return s(t,[{key:"gridPadForColumnsInNumericAxis",value:function(t){var e=this.w,i=e.config,a=e.globals;if(a.noData||a.collapsedSeries.length+a.ancillaryCollapsedSeries.length===i.series.length)return 0;var s=function(t){return["bar","rangeBar","candlestick","boxPlot"].includes(t)},r=i.chart.type,o=0,n=s(r)?i.series.length:1;a.comboBarCount>0&&(n=a.comboBarCount),a.collapsedSeries.forEach((function(t){s(t.type)&&(n-=1)})),i.chart.stacked&&(n=1);var l=s(r)||a.comboBarCount>0,h=Math.abs(a.initialMaxX-a.initialMinX);if(l&&a.isXNumeric&&!a.isBarHorizontal&&n>0&&0!==h){h<=3&&(h=a.dataPoints);var c=h/t,d=a.minXDiff&&a.minXDiff/c>0?a.minXDiff/c:0;d>t/2&&(d/=2),(o=d*parseInt(i.plotOptions.bar.columnWidth,10)/100)<1&&(o=1),a.barPadForNumericAxis=o}return o}},{key:"gridPadFortitleSubtitle",value:function(){var t=this,e=this.w,i=e.globals,a=this.dCtx.isSparkline||!i.axisCharts?0:10;["title","subtitle"].forEach((function(s){void 0!==e.config[s].text?a+=e.config[s].margin:a+=t.dCtx.isSparkline||!i.axisCharts?0:5})),!e.config.legend.show||"bottom"!==e.config.legend.position||e.config.legend.floating||i.axisCharts||(a+=10);var s=this.dCtx.dimHelpers.getTitleSubtitleCoords("title"),r=this.dCtx.dimHelpers.getTitleSubtitleCoords("subtitle");i.gridHeight-=s.height+r.height+a,i.translateY+=s.height+r.height+a}},{key:"setGridXPosForDualYAxis",value:function(t,e){var i=this.w,a=new M(this.dCtx.ctx);i.config.yaxis.forEach((function(s,r){-1!==i.globals.ignoreYAxisIndexes.indexOf(r)||s.floating||a.isYAxisHidden(r)||(s.opposite&&(i.globals.translateX-=e[r].width+t[r].width+parseInt(s.labels.style.fontSize,10)/1.2+12),i.globals.translateX<2&&(i.globals.translateX=2))}))}}]),t}(),ct=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w,this.lgRect={},this.yAxisWidth=0,this.yAxisWidthLeft=0,this.yAxisWidthRight=0,this.xAxisHeight=0,this.isSparkline=this.w.config.chart.sparkline.enabled,this.dimHelpers=new ot(this),this.dimYAxis=new lt(this),this.dimXAxis=new nt(this),this.dimGrid=new ht(this),this.lgWidthForSideLegends=0,this.gridPad=this.w.config.grid.padding,this.xPadRight=0,this.xPadLeft=0}return s(t,[{key:"plotCoords",value:function(){var t=this,e=this.w,i=e.globals;this.lgRect=this.dimHelpers.getLegendsRect(),this.datalabelsCoords={width:0,height:0};var a=Array.isArray(e.config.stroke.width)?Math.max.apply(Math,p(e.config.stroke.width)):e.config.stroke.width;this.isSparkline&&((e.config.markers.discrete.length>0||e.config.markers.size>0)&&Object.entries(this.gridPad).forEach((function(e){var i=f(e,2),a=i[0],s=i[1];t.gridPad[a]=Math.max(s,t.w.globals.markers.largestSize/1.5)})),this.gridPad.top=Math.max(a/2,this.gridPad.top),this.gridPad.bottom=Math.max(a/2,this.gridPad.bottom)),i.axisCharts?this.setDimensionsForAxisCharts():this.setDimensionsForNonAxisCharts(),this.dimGrid.gridPadFortitleSubtitle(),i.gridHeight=i.gridHeight-this.gridPad.top-this.gridPad.bottom,i.gridWidth=i.gridWidth-this.gridPad.left-this.gridPad.right-this.xPadRight-this.xPadLeft;var s=this.dimGrid.gridPadForColumnsInNumericAxis(i.gridWidth);i.gridWidth=i.gridWidth-2*s,i.translateX=i.translateX+this.gridPad.left+this.xPadLeft+(s>0?s:0),i.translateY=i.translateY+this.gridPad.top}},{key:"setDimensionsForAxisCharts",value:function(){var t=this,e=this.w,i=e.globals,a=this.dimYAxis.getyAxisLabelsCoords(),s=this.dimYAxis.getyAxisTitleCoords();i.isSlopeChart&&(this.datalabelsCoords=this.dimHelpers.getDatalabelsRect()),e.globals.yLabelsCoords=[],e.globals.yTitleCoords=[],e.config.yaxis.map((function(t,i){e.globals.yLabelsCoords.push({width:a[i].width,index:i}),e.globals.yTitleCoords.push({width:s[i].width,index:i})})),this.yAxisWidth=this.dimYAxis.getTotalYAxisWidth();var r=this.dimXAxis.getxAxisLabelsCoords(),o=this.dimXAxis.getxAxisGroupLabelsCoords(),n=this.dimXAxis.getxAxisTitleCoords();this.conditionalChecksForAxisCoords(r,n,o),i.translateXAxisY=e.globals.rotateXLabels?this.xAxisHeight/8:-4,i.translateXAxisX=e.globals.rotateXLabels&&e.globals.isXNumeric&&e.config.xaxis.labels.rotate<=-45?-this.xAxisWidth/4:0,e.globals.isBarHorizontal&&(i.rotateXLabels=!1,i.translateXAxisY=parseInt(e.config.xaxis.labels.style.fontSize,10)/1.5*-1),i.translateXAxisY=i.translateXAxisY+e.config.xaxis.labels.offsetY,i.translateXAxisX=i.translateXAxisX+e.config.xaxis.labels.offsetX;var l=this.yAxisWidth,h=this.xAxisHeight;i.xAxisLabelsHeight=this.xAxisHeight-n.height,i.xAxisGroupLabelsHeight=i.xAxisLabelsHeight-r.height,i.xAxisLabelsWidth=this.xAxisWidth,i.xAxisHeight=this.xAxisHeight;var c=10;("radar"===e.config.chart.type||this.isSparkline)&&(l=0,h=0),this.isSparkline&&(this.lgRect={height:0,width:0}),(this.isSparkline||"treemap"===e.config.chart.type)&&(l=0,h=0,c=0),this.isSparkline||"treemap"===e.config.chart.type||this.dimXAxis.additionalPaddingXLabels(r);var d=function(){i.translateX=l+t.datalabelsCoords.width,i.gridHeight=i.svgHeight-t.lgRect.height-h-(t.isSparkline||"treemap"===e.config.chart.type?0:e.globals.rotateXLabels?10:15),i.gridWidth=i.svgWidth-l-2*t.datalabelsCoords.width};switch("top"===e.config.xaxis.position&&(c=i.xAxisHeight-e.config.xaxis.axisTicks.height-5),e.config.legend.position){case"bottom":i.translateY=c,d();break;case"top":i.translateY=this.lgRect.height+c,d();break;case"left":i.translateY=c,i.translateX=this.lgRect.width+l+this.datalabelsCoords.width,i.gridHeight=i.svgHeight-h-12,i.gridWidth=i.svgWidth-this.lgRect.width-l-2*this.datalabelsCoords.width;break;case"right":i.translateY=c,i.translateX=l+this.datalabelsCoords.width,i.gridHeight=i.svgHeight-h-12,i.gridWidth=i.svgWidth-this.lgRect.width-l-2*this.datalabelsCoords.width-5;break;default:throw new Error("Legend position not supported")}this.dimGrid.setGridXPosForDualYAxis(s,a),new Q(this.ctx).setYAxisXPosition(a,s)}},{key:"setDimensionsForNonAxisCharts",value:function(){var t=this.w,e=t.globals,i=t.config,a=0;t.config.legend.show&&!t.config.legend.floating&&(a=20);var s="pie"===i.chart.type||"polarArea"===i.chart.type||"donut"===i.chart.type?"pie":"radialBar",r=i.plotOptions[s].offsetY,o=i.plotOptions[s].offsetX;if(!i.legend.show||i.legend.floating){e.gridHeight=e.svgHeight;var n=e.dom.elWrap.getBoundingClientRect().width;return e.gridWidth=Math.min(n,e.gridHeight),e.translateY=r,void(e.translateX=o+(e.svgWidth-e.gridWidth)/2)}switch(i.legend.position){case"bottom":e.gridHeight=e.svgHeight-this.lgRect.height,e.gridWidth=e.svgWidth,e.translateY=r-10,e.translateX=o+(e.svgWidth-e.gridWidth)/2;break;case"top":e.gridHeight=e.svgHeight-this.lgRect.height,e.gridWidth=e.svgWidth,e.translateY=this.lgRect.height+r+10,e.translateX=o+(e.svgWidth-e.gridWidth)/2;break;case"left":e.gridWidth=e.svgWidth-this.lgRect.width-a,e.gridHeight="auto"!==i.chart.height?e.svgHeight:e.gridWidth,e.translateY=r,e.translateX=o+this.lgRect.width+a;break;case"right":e.gridWidth=e.svgWidth-this.lgRect.width-a-5,e.gridHeight="auto"!==i.chart.height?e.svgHeight:e.gridWidth,e.translateY=r,e.translateX=o+10;break;default:throw new Error("Legend position not supported")}}},{key:"conditionalChecksForAxisCoords",value:function(t,e,i){var a=this.w,s=a.globals.hasXaxisGroups?2:1,r=i.height+t.height+e.height,o=a.globals.isMultiLineX?1.2:a.globals.LINE_HEIGHT_RATIO,n=a.globals.rotateXLabels?22:10,l=a.globals.rotateXLabels&&"bottom"===a.config.legend.position?10:0;this.xAxisHeight=r*o+s*n+l,this.xAxisWidth=t.width,this.xAxisHeight-e.height>a.config.xaxis.labels.maxHeight&&(this.xAxisHeight=a.config.xaxis.labels.maxHeight),a.config.xaxis.labels.minHeight&&this.xAxisHeight<a.config.xaxis.labels.minHeight&&(this.xAxisHeight=a.config.xaxis.labels.minHeight),a.config.xaxis.floating&&(this.xAxisHeight=0);var h=0,c=0;a.config.yaxis.forEach((function(t){h+=t.labels.minWidth,c+=t.labels.maxWidth})),this.yAxisWidth<h&&(this.yAxisWidth=h),this.yAxisWidth>c&&(this.yAxisWidth=c)}}]),t}(),dt=function(){function t(e){i(this,t),this.w=e.w,this.lgCtx=e}return s(t,[{key:"getLegendStyles",value:function(){var t,e,i,a=document.createElement("style");a.setAttribute("type","text/css");var s=(null===(t=this.lgCtx.ctx)||void 0===t||null===(e=t.opts)||void 0===e||null===(i=e.chart)||void 0===i?void 0:i.nonce)||this.w.config.chart.nonce;s&&a.setAttribute("nonce",s);var r=document.createTextNode("\n      .apexcharts-flip-y {\n        transform: scaleY(-1) translateY(-100%);\n        transform-origin: top;\n        transform-box: fill-box;\n      }\n      .apexcharts-flip-x {\n        transform: scaleX(-1);\n        transform-origin: center;\n        transform-box: fill-box;\n      }\n      .apexcharts-legend {\n        display: flex;\n        overflow: auto;\n        padding: 0 10px;\n      }\n      .apexcharts-legend.apx-legend-position-bottom, .apexcharts-legend.apx-legend-position-top {\n        flex-wrap: wrap\n      }\n      .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {\n        flex-direction: column;\n        bottom: 0;\n      }\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-left, .apexcharts-legend.apx-legend-position-top.apexcharts-align-left, .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {\n        justify-content: flex-start;\n      }\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center, .apexcharts-legend.apx-legend-position-top.apexcharts-align-center {\n        justify-content: center;\n      }\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-right, .apexcharts-legend.apx-legend-position-top.apexcharts-align-right {\n        justify-content: flex-end;\n      }\n      .apexcharts-legend-series {\n        cursor: pointer;\n        line-height: normal;\n        display: flex;\n        align-items: center;\n      }\n      .apexcharts-legend-text {\n        position: relative;\n        font-size: 14px;\n      }\n      .apexcharts-legend-text *, .apexcharts-legend-marker * {\n        pointer-events: none;\n      }\n      .apexcharts-legend-marker {\n        position: relative;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        margin-right: 1px;\n      }\n\n      .apexcharts-legend-series.apexcharts-no-click {\n        cursor: auto;\n      }\n      .apexcharts-legend .apexcharts-hidden-zero-series, .apexcharts-legend .apexcharts-hidden-null-series {\n        display: none !important;\n      }\n      .apexcharts-inactive-legend {\n        opacity: 0.45;\n      }");return a.appendChild(r),a}},{key:"getLegendDimensions",value:function(){var t=this.w.globals.dom.baseEl.querySelector(".apexcharts-legend").getBoundingClientRect(),e=t.width;return{clwh:t.height,clww:e}}},{key:"appendToForeignObject",value:function(){this.w.globals.dom.elLegendForeign.appendChild(this.getLegendStyles())}},{key:"toggleDataSeries",value:function(t,e){var i=this,a=this.w;if(a.globals.axisCharts||"radialBar"===a.config.chart.type){a.globals.resized=!0;var s=null,r=null;if(a.globals.risingSeries=[],a.globals.axisCharts?(s=a.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(t,"']")),r=parseInt(s.getAttribute("data:realIndex"),10)):(s=a.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(t+1,"']")),r=parseInt(s.getAttribute("rel"),10)-1),e)[{cs:a.globals.collapsedSeries,csi:a.globals.collapsedSeriesIndices},{cs:a.globals.ancillaryCollapsedSeries,csi:a.globals.ancillaryCollapsedSeriesIndices}].forEach((function(t){i.riseCollapsedSeries(t.cs,t.csi,r)}));else this.hideSeries({seriesEl:s,realIndex:r})}else{var o=a.globals.dom.Paper.select(" .apexcharts-series[rel='".concat(t+1,"'] path")),n=a.config.chart.type;if("pie"===n||"polarArea"===n||"donut"===n){var l=a.config.plotOptions.pie.donut.labels;new k(this.lgCtx.ctx).pathMouseDown(o.members[0],null),this.lgCtx.ctx.pie.printDataLabelsInner(o.members[0].node,l)}o.fire("click")}}},{key:"getSeriesAfterCollapsing",value:function(t){var e=t.realIndex,i=this.w,a=i.globals,s=m.clone(i.config.series);if(a.axisCharts){var r=i.config.yaxis[a.seriesYAxisReverseMap[e]],o={index:e,data:s[e].data.slice(),type:s[e].type||i.config.chart.type};if(r&&r.show&&r.showAlways)a.ancillaryCollapsedSeriesIndices.indexOf(e)<0&&(a.ancillaryCollapsedSeries.push(o),a.ancillaryCollapsedSeriesIndices.push(e));else if(a.collapsedSeriesIndices.indexOf(e)<0){a.collapsedSeries.push(o),a.collapsedSeriesIndices.push(e);var n=a.risingSeries.indexOf(e);a.risingSeries.splice(n,1)}}else a.collapsedSeries.push({index:e,data:s[e]}),a.collapsedSeriesIndices.push(e);return a.allSeriesCollapsed=a.collapsedSeries.length+a.ancillaryCollapsedSeries.length===i.config.series.length,this._getSeriesBasedOnCollapsedState(s)}},{key:"hideSeries",value:function(t){for(var e=t.seriesEl,i=t.realIndex,a=this.w,s=this.getSeriesAfterCollapsing({realIndex:i}),r=e.childNodes,o=0;o<r.length;o++)r[o].classList.contains("apexcharts-series-markers-wrap")&&(r[o].classList.contains("apexcharts-hide")?r[o].classList.remove("apexcharts-hide"):r[o].classList.add("apexcharts-hide"));this.lgCtx.ctx.updateHelpers._updateSeries(s,a.config.chart.animations.dynamicAnimation.enabled)}},{key:"riseCollapsedSeries",value:function(t,e,i){var a=this.w,s=m.clone(a.config.series);if(t.length>0){for(var r=0;r<t.length;r++)t[r].index===i&&(a.globals.axisCharts?s[i].data=t[r].data.slice():s[i]=t[r].data,s[i].hidden=!1,t.splice(r,1),e.splice(r,1),a.globals.risingSeries.push(i));s=this._getSeriesBasedOnCollapsedState(s),this.lgCtx.ctx.updateHelpers._updateSeries(s,a.config.chart.animations.dynamicAnimation.enabled)}}},{key:"_getSeriesBasedOnCollapsedState",value:function(t){var e=this.w,i=0;return e.globals.axisCharts?t.forEach((function(a,s){e.globals.collapsedSeriesIndices.indexOf(s)<0&&e.globals.ancillaryCollapsedSeriesIndices.indexOf(s)<0||(t[s].data=[],i++)})):t.forEach((function(a,s){!e.globals.collapsedSeriesIndices.indexOf(s)<0&&(t[s]=0,i++)})),e.globals.allSeriesCollapsed=i===t.length,t}}]),t}(),gt=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w,this.onLegendClick=this.onLegendClick.bind(this),this.onLegendHovered=this.onLegendHovered.bind(this),this.isBarsDistributed="bar"===this.w.config.chart.type&&this.w.config.plotOptions.bar.distributed&&1===this.w.config.series.length,this.legendHelpers=new dt(this)}return s(t,[{key:"init",value:function(){var t=this.w,e=t.globals,i=t.config,a=i.legend.showForSingleSeries&&1===e.series.length||this.isBarsDistributed||e.series.length>1;if(this.legendHelpers.appendToForeignObject(),(a||!e.axisCharts)&&i.legend.show){for(;e.dom.elLegendWrap.firstChild;)e.dom.elLegendWrap.removeChild(e.dom.elLegendWrap.firstChild);this.drawLegends(),"bottom"===i.legend.position||"top"===i.legend.position?this.legendAlignHorizontal():"right"!==i.legend.position&&"left"!==i.legend.position||this.legendAlignVertical()}}},{key:"createLegendMarker",value:function(t){var e=t.i,i=t.fillcolor,a=this.w,s=document.createElement("span");s.classList.add("apexcharts-legend-marker");var r=a.config.legend.markers.shape||a.config.markers.shape,o=r;Array.isArray(r)&&(o=r[e]);var n=Array.isArray(a.config.legend.markers.size)?parseFloat(a.config.legend.markers.size[e]):parseFloat(a.config.legend.markers.size),l=Array.isArray(a.config.legend.markers.offsetX)?parseFloat(a.config.legend.markers.offsetX[e]):parseFloat(a.config.legend.markers.offsetX),h=Array.isArray(a.config.legend.markers.offsetY)?parseFloat(a.config.legend.markers.offsetY[e]):parseFloat(a.config.legend.markers.offsetY),c=Array.isArray(a.config.legend.markers.strokeWidth)?parseFloat(a.config.legend.markers.strokeWidth[e]):parseFloat(a.config.legend.markers.strokeWidth),d=s.style;if(d.height=2*(n+c)+"px",d.width=2*(n+c)+"px",d.left=l+"px",d.top=h+"px",a.config.legend.markers.customHTML)d.background="transparent",d.color=i[e],Array.isArray(a.config.legend.markers.customHTML)?a.config.legend.markers.customHTML[e]&&(s.innerHTML=a.config.legend.markers.customHTML[e]()):s.innerHTML=a.config.legend.markers.customHTML();else{var u=new W(this.ctx).getMarkerConfig({cssClass:"apexcharts-legend-marker apexcharts-marker apexcharts-marker-".concat(o),seriesIndex:e,strokeWidth:c,size:n}),f=SVG(s).size("100%","100%"),p=new k(this.ctx).drawMarker(0,0,g(g({},u),{},{pointFillColor:Array.isArray(i)?i[e]:u.pointFillColor,shape:o}));SVG.select(".apexcharts-legend-marker.apexcharts-marker").members.forEach((function(t){t.node.classList.contains("apexcharts-marker-triangle")?t.node.style.transform="translate(50%, 45%)":t.node.style.transform="translate(50%, 50%)"})),f.add(p)}return s}},{key:"drawLegends",value:function(){var t=this,e=this.w,i=e.config.legend.fontFamily,a=e.globals.seriesNames,s=e.config.legend.markers.fillColors?e.config.legend.markers.fillColors.slice():e.globals.colors.slice();if("heatmap"===e.config.chart.type){var r=e.config.plotOptions.heatmap.colorScale.ranges;a=r.map((function(t){return t.name?t.name:t.from+" - "+t.to})),s=r.map((function(t){return t.color}))}else this.isBarsDistributed&&(a=e.globals.labels.slice());e.config.legend.customLegendItems.length&&(a=e.config.legend.customLegendItems);for(var o=e.globals.legendFormatter,n=e.config.legend.inverseOrder,l=n?a.length-1:0;n?l>=0:l<=a.length-1;n?l--:l++){var h,c=o(a[l],{seriesIndex:l,w:e}),d=!1,g=!1;if(e.globals.collapsedSeries.length>0)for(var u=0;u<e.globals.collapsedSeries.length;u++)e.globals.collapsedSeries[u].index===l&&(d=!0);if(e.globals.ancillaryCollapsedSeriesIndices.length>0)for(var f=0;f<e.globals.ancillaryCollapsedSeriesIndices.length;f++)e.globals.ancillaryCollapsedSeriesIndices[f]===l&&(g=!0);var p=this.createLegendMarker({i:l,fillcolor:s});k.setAttrs(p,{rel:l+1,"data:collapsed":d||g}),(d||g)&&p.classList.add("apexcharts-inactive-legend");var x=document.createElement("div"),b=document.createElement("span");b.classList.add("apexcharts-legend-text"),b.innerHTML=Array.isArray(c)?c.join(" "):c;var v=e.config.legend.labels.useSeriesColors?e.globals.colors[l]:Array.isArray(e.config.legend.labels.colors)?null===(h=e.config.legend.labels.colors)||void 0===h?void 0:h[l]:e.config.legend.labels.colors;v||(v=e.config.chart.foreColor),b.style.color=v,b.style.fontSize=parseFloat(e.config.legend.fontSize)+"px",b.style.fontWeight=e.config.legend.fontWeight,b.style.fontFamily=i||e.config.chart.fontFamily,k.setAttrs(b,{rel:l+1,i:l,"data:default-text":encodeURIComponent(c),"data:collapsed":d||g}),x.appendChild(p),x.appendChild(b);var y=new A(this.ctx);if(!e.config.legend.showForZeroSeries)0===y.getSeriesTotalByIndex(l)&&y.seriesHaveSameValues(l)&&!y.isSeriesNull(l)&&-1===e.globals.collapsedSeriesIndices.indexOf(l)&&-1===e.globals.ancillaryCollapsedSeriesIndices.indexOf(l)&&x.classList.add("apexcharts-hidden-zero-series");e.config.legend.showForNullSeries||y.isSeriesNull(l)&&-1===e.globals.collapsedSeriesIndices.indexOf(l)&&-1===e.globals.ancillaryCollapsedSeriesIndices.indexOf(l)&&x.classList.add("apexcharts-hidden-null-series"),e.globals.dom.elLegendWrap.appendChild(x),e.globals.dom.elLegendWrap.classList.add("apexcharts-align-".concat(e.config.legend.horizontalAlign)),e.globals.dom.elLegendWrap.classList.add("apx-legend-position-"+e.config.legend.position),x.classList.add("apexcharts-legend-series"),x.style.margin="".concat(e.config.legend.itemMargin.vertical,"px ").concat(e.config.legend.itemMargin.horizontal,"px"),e.globals.dom.elLegendWrap.style.width=e.config.legend.width?e.config.legend.width+"px":"",e.globals.dom.elLegendWrap.style.height=e.config.legend.height?e.config.legend.height+"px":"",k.setAttrs(x,{rel:l+1,seriesName:m.escapeString(a[l]),"data:collapsed":d||g}),(d||g)&&x.classList.add("apexcharts-inactive-legend"),e.config.legend.onItemClick.toggleDataSeries||x.classList.add("apexcharts-no-click")}e.globals.dom.elWrap.addEventListener("click",t.onLegendClick,!0),e.config.legend.onItemHover.highlightDataSeries&&0===e.config.legend.customLegendItems.length&&(e.globals.dom.elWrap.addEventListener("mousemove",t.onLegendHovered,!0),e.globals.dom.elWrap.addEventListener("mouseout",t.onLegendHovered,!0))}},{key:"setLegendWrapXY",value:function(t,e){var i=this.w,a=i.globals.dom.elLegendWrap,s=a.clientHeight,r=0,o=0;if("bottom"===i.config.legend.position)o=i.globals.svgHeight-Math.min(s,i.globals.svgHeight/2)-5;else if("top"===i.config.legend.position){var n=new ct(this.ctx),l=n.dimHelpers.getTitleSubtitleCoords("title").height,h=n.dimHelpers.getTitleSubtitleCoords("subtitle").height;o=(l>0?l-10:0)+(h>0?h-10:0)}a.style.position="absolute",r=r+t+i.config.legend.offsetX,o=o+e+i.config.legend.offsetY,a.style.left=r+"px",a.style.top=o+"px","right"===i.config.legend.position&&(a.style.left="auto",a.style.right=25+i.config.legend.offsetX+"px");["width","height"].forEach((function(t){a.style[t]&&(a.style[t]=parseInt(i.config.legend[t],10)+"px")}))}},{key:"legendAlignHorizontal",value:function(){var t=this.w;t.globals.dom.elLegendWrap.style.right=0;var e=new ct(this.ctx),i=e.dimHelpers.getTitleSubtitleCoords("title"),a=e.dimHelpers.getTitleSubtitleCoords("subtitle"),s=0;"top"===t.config.legend.position&&(s=i.height+a.height+t.config.title.margin+t.config.subtitle.margin-10),this.setLegendWrapXY(20,s)}},{key:"legendAlignVertical",value:function(){var t=this.w,e=this.legendHelpers.getLegendDimensions(),i=0;"left"===t.config.legend.position&&(i=20),"right"===t.config.legend.position&&(i=t.globals.svgWidth-e.clww-10),this.setLegendWrapXY(i,20)}},{key:"onLegendHovered",value:function(t){var e=this.w,i=t.target.classList.contains("apexcharts-legend-series")||t.target.classList.contains("apexcharts-legend-text")||t.target.classList.contains("apexcharts-legend-marker");if("heatmap"===e.config.chart.type||this.isBarsDistributed){if(i){var a=parseInt(t.target.getAttribute("rel"),10)-1;this.ctx.events.fireEvent("legendHover",[this.ctx,a,this.w]),new V(this.ctx).highlightRangeInSeries(t,t.target)}}else!t.target.classList.contains("apexcharts-inactive-legend")&&i&&new V(this.ctx).toggleSeriesOnHover(t,t.target)}},{key:"onLegendClick",value:function(t){var e=this.w;if(!e.config.legend.customLegendItems.length&&(t.target.classList.contains("apexcharts-legend-series")||t.target.classList.contains("apexcharts-legend-text")||t.target.classList.contains("apexcharts-legend-marker"))){var i=parseInt(t.target.getAttribute("rel"),10)-1,a="true"===t.target.getAttribute("data:collapsed"),s=this.w.config.chart.events.legendClick;"function"==typeof s&&s(this.ctx,i,this.w),this.ctx.events.fireEvent("legendClick",[this.ctx,i,this.w]);var r=this.w.config.legend.markers.onClick;"function"==typeof r&&t.target.classList.contains("apexcharts-legend-marker")&&(r(this.ctx,i,this.w),this.ctx.events.fireEvent("legendMarkerClick",[this.ctx,i,this.w])),"treemap"!==e.config.chart.type&&"heatmap"!==e.config.chart.type&&!this.isBarsDistributed&&e.config.legend.onItemClick.toggleDataSeries&&this.legendHelpers.toggleDataSeries(i,a)}}}]),t}(),ut=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w;var a=this.w;this.ev=this.w.config.chart.events,this.selectedClass="apexcharts-selected",this.localeValues=this.w.globals.locale.toolbar,this.minX=a.globals.minX,this.maxX=a.globals.maxX}return s(t,[{key:"createToolbar",value:function(){var t=this,e=this.w,i=function(){return document.createElement("div")},a=i();if(a.setAttribute("class","apexcharts-toolbar"),a.style.top=e.config.chart.toolbar.offsetY+"px",a.style.right=3-e.config.chart.toolbar.offsetX+"px",e.globals.dom.elWrap.appendChild(a),this.elZoom=i(),this.elZoomIn=i(),this.elZoomOut=i(),this.elPan=i(),this.elSelection=i(),this.elZoomReset=i(),this.elMenuIcon=i(),this.elMenu=i(),this.elCustomIcons=[],this.t=e.config.chart.toolbar.tools,Array.isArray(this.t.customIcons))for(var s=0;s<this.t.customIcons.length;s++)this.elCustomIcons.push(i());var r=[],o=function(i,a,s){var o=i.toLowerCase();t.t[o]&&e.config.chart.zoom.enabled&&r.push({el:a,icon:"string"==typeof t.t[o]?t.t[o]:s,title:t.localeValues[i],class:"apexcharts-".concat(o,"-icon")})};o("zoomIn",this.elZoomIn,'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>\n</svg>\n'),o("zoomOut",this.elZoomOut,'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>\n</svg>\n');var n=function(i){t.t[i]&&e.config.chart[i].enabled&&r.push({el:"zoom"===i?t.elZoom:t.elSelection,icon:"string"==typeof t.t[i]?t.t[i]:"zoom"===i?'<svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="24" viewBox="0 0 24 24" width="24">\n    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>\n    <path d="M0 0h24v24H0V0z" fill="none"/>\n    <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"/>\n</svg>':'<svg fill="#6E8192" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2z"/>\n</svg>',title:t.localeValues["zoom"===i?"selectionZoom":"selection"],class:e.globals.isTouchDevice?"apexcharts-element-hidden":"apexcharts-".concat(i,"-icon")})};n("zoom"),n("selection"),this.t.pan&&e.config.chart.zoom.enabled&&r.push({el:this.elPan,icon:"string"==typeof this.t.pan?this.t.pan:'<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="24" viewBox="0 0 24 24" width="24">\n    <defs>\n        <path d="M0 0h24v24H0z" id="a"/>\n    </defs>\n    <clipPath id="b">\n        <use overflow="visible" xlink:href="#a"/>\n    </clipPath>\n    <path clip-path="url(#b)" d="M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"/>\n</svg>',title:this.localeValues.pan,class:e.globals.isTouchDevice?"apexcharts-element-hidden":"apexcharts-pan-icon"}),o("reset",this.elZoomReset,'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'),this.t.download&&r.push({el:this.elMenuIcon,icon:"string"==typeof this.t.download?this.t.download:'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>',title:this.localeValues.menu,class:"apexcharts-menu-icon"});for(var l=0;l<this.elCustomIcons.length;l++)r.push({el:this.elCustomIcons[l],icon:this.t.customIcons[l].icon,title:this.t.customIcons[l].title,index:this.t.customIcons[l].index,class:"apexcharts-toolbar-custom-icon "+this.t.customIcons[l].class});r.forEach((function(t,e){t.index&&m.moveIndexInArray(r,e,t.index)}));for(var h=0;h<r.length;h++)k.setAttrs(r[h].el,{class:r[h].class,title:r[h].title}),r[h].el.innerHTML=r[h].icon,a.appendChild(r[h].el);this._createHamburgerMenu(a),e.globals.zoomEnabled?this.elZoom.classList.add(this.selectedClass):e.globals.panEnabled?this.elPan.classList.add(this.selectedClass):e.globals.selectionEnabled&&this.elSelection.classList.add(this.selectedClass),this.addToolbarEventListeners()}},{key:"_createHamburgerMenu",value:function(t){this.elMenuItems=[],t.appendChild(this.elMenu),k.setAttrs(this.elMenu,{class:"apexcharts-menu"});for(var e=[{name:"exportSVG",title:this.localeValues.exportToSVG},{name:"exportPNG",title:this.localeValues.exportToPNG},{name:"exportCSV",title:this.localeValues.exportToCSV}],i=0;i<e.length;i++)this.elMenuItems.push(document.createElement("div")),this.elMenuItems[i].innerHTML=e[i].title,k.setAttrs(this.elMenuItems[i],{class:"apexcharts-menu-item ".concat(e[i].name),title:e[i].title}),this.elMenu.appendChild(this.elMenuItems[i])}},{key:"addToolbarEventListeners",value:function(){var t=this;this.elZoomReset.addEventListener("click",this.handleZoomReset.bind(this)),this.elSelection.addEventListener("click",this.toggleZoomSelection.bind(this,"selection")),this.elZoom.addEventListener("click",this.toggleZoomSelection.bind(this,"zoom")),this.elZoomIn.addEventListener("click",this.handleZoomIn.bind(this)),this.elZoomOut.addEventListener("click",this.handleZoomOut.bind(this)),this.elPan.addEventListener("click",this.togglePanning.bind(this)),this.elMenuIcon.addEventListener("click",this.toggleMenu.bind(this)),this.elMenuItems.forEach((function(e){e.classList.contains("exportSVG")?e.addEventListener("click",t.handleDownload.bind(t,"svg")):e.classList.contains("exportPNG")?e.addEventListener("click",t.handleDownload.bind(t,"png")):e.classList.contains("exportCSV")&&e.addEventListener("click",t.handleDownload.bind(t,"csv"))}));for(var e=0;e<this.t.customIcons.length;e++)this.elCustomIcons[e].addEventListener("click",this.t.customIcons[e].click.bind(this,this.ctx,this.ctx.w))}},{key:"toggleZoomSelection",value:function(t){this.ctx.getSyncedCharts().forEach((function(e){e.ctx.toolbar.toggleOtherControls();var i="selection"===t?e.ctx.toolbar.elSelection:e.ctx.toolbar.elZoom,a="selection"===t?"selectionEnabled":"zoomEnabled";e.w.globals[a]=!e.w.globals[a],i.classList.contains(e.ctx.toolbar.selectedClass)?i.classList.remove(e.ctx.toolbar.selectedClass):i.classList.add(e.ctx.toolbar.selectedClass)}))}},{key:"getToolbarIconsReference",value:function(){var t=this.w;this.elZoom||(this.elZoom=t.globals.dom.baseEl.querySelector(".apexcharts-zoom-icon")),this.elPan||(this.elPan=t.globals.dom.baseEl.querySelector(".apexcharts-pan-icon")),this.elSelection||(this.elSelection=t.globals.dom.baseEl.querySelector(".apexcharts-selection-icon"))}},{key:"enableZoomPanFromToolbar",value:function(t){this.toggleOtherControls(),"pan"===t?this.w.globals.panEnabled=!0:this.w.globals.zoomEnabled=!0;var e="pan"===t?this.elPan:this.elZoom,i="pan"===t?this.elZoom:this.elPan;e&&e.classList.add(this.selectedClass),i&&i.classList.remove(this.selectedClass)}},{key:"togglePanning",value:function(){this.ctx.getSyncedCharts().forEach((function(t){t.ctx.toolbar.toggleOtherControls(),t.w.globals.panEnabled=!t.w.globals.panEnabled,t.ctx.toolbar.elPan.classList.contains(t.ctx.toolbar.selectedClass)?t.ctx.toolbar.elPan.classList.remove(t.ctx.toolbar.selectedClass):t.ctx.toolbar.elPan.classList.add(t.ctx.toolbar.selectedClass)}))}},{key:"toggleOtherControls",value:function(){var t=this,e=this.w;e.globals.panEnabled=!1,e.globals.zoomEnabled=!1,e.globals.selectionEnabled=!1,this.getToolbarIconsReference(),[this.elPan,this.elSelection,this.elZoom].forEach((function(e){e&&e.classList.remove(t.selectedClass)}))}},{key:"handleZoomIn",value:function(){var t=this.w;t.globals.isRangeBar&&(this.minX=t.globals.minY,this.maxX=t.globals.maxY);var e=(this.minX+this.maxX)/2,i=(this.minX+e)/2,a=(this.maxX+e)/2,s=this._getNewMinXMaxX(i,a);t.globals.disableZoomIn||this.zoomUpdateOptions(s.minX,s.maxX)}},{key:"handleZoomOut",value:function(){var t=this.w;if(t.globals.isRangeBar&&(this.minX=t.globals.minY,this.maxX=t.globals.maxY),!("datetime"===t.config.xaxis.type&&new Date(this.minX).getUTCFullYear()<1e3)){var e=(this.minX+this.maxX)/2,i=this.minX-(e-this.minX),a=this.maxX-(e-this.maxX),s=this._getNewMinXMaxX(i,a);t.globals.disableZoomOut||this.zoomUpdateOptions(s.minX,s.maxX)}}},{key:"_getNewMinXMaxX",value:function(t,e){var i=this.w.config.xaxis.convertedCatToNumeric;return{minX:i?Math.floor(t):t,maxX:i?Math.floor(e):e}}},{key:"zoomUpdateOptions",value:function(t,e){var i=this.w;if(void 0!==t||void 0!==e){if(!(i.config.xaxis.convertedCatToNumeric&&(t<1&&(t=1,e=i.globals.dataPoints),e-t<2))){var a={min:t,max:e},s=this.getBeforeZoomRange(a);s&&(a=s.xaxis);var r={xaxis:a},o=m.clone(i.globals.initialConfig.yaxis);i.config.chart.group||(r.yaxis=o),this.w.globals.zoomed=!0,this.ctx.updateHelpers._updateOptions(r,!1,this.w.config.chart.animations.dynamicAnimation.enabled),this.zoomCallback(a,o)}}else this.handleZoomReset()}},{key:"zoomCallback",value:function(t,e){"function"==typeof this.ev.zoomed&&this.ev.zoomed(this.ctx,{xaxis:t,yaxis:e})}},{key:"getBeforeZoomRange",value:function(t,e){var i=null;return"function"==typeof this.ev.beforeZoom&&(i=this.ev.beforeZoom(this,{xaxis:t,yaxis:e})),i}},{key:"toggleMenu",value:function(){var t=this;window.setTimeout((function(){t.elMenu.classList.contains("apexcharts-menu-open")?t.elMenu.classList.remove("apexcharts-menu-open"):t.elMenu.classList.add("apexcharts-menu-open")}),0)}},{key:"handleDownload",value:function(t){var e=this.w,i=new U(this.ctx);switch(t){case"svg":i.exportToSVG(this.ctx);break;case"png":i.exportToPng(this.ctx);break;case"csv":i.exportToCSV({series:e.config.series,columnDelimiter:e.config.chart.toolbar.export.csv.columnDelimiter})}}},{key:"handleZoomReset",value:function(t){this.ctx.getSyncedCharts().forEach((function(t){var e=t.w;if(e.globals.lastXAxis.min=e.globals.initialConfig.xaxis.min,e.globals.lastXAxis.max=e.globals.initialConfig.xaxis.max,t.updateHelpers.revertDefaultAxisMinMax(),"function"==typeof e.config.chart.events.beforeResetZoom){var i=e.config.chart.events.beforeResetZoom(t,e);i&&t.updateHelpers.revertDefaultAxisMinMax(i)}"function"==typeof e.config.chart.events.zoomed&&t.ctx.toolbar.zoomCallback({min:e.config.xaxis.min,max:e.config.xaxis.max}),e.globals.zoomed=!1;var a=t.ctx.series.emptyCollapsedSeries(m.clone(e.globals.initialSeries));t.updateHelpers._updateSeries(a,e.config.chart.animations.dynamicAnimation.enabled)}))}},{key:"destroy",value:function(){this.elZoom=null,this.elZoomIn=null,this.elZoomOut=null,this.elPan=null,this.elSelection=null,this.elZoomReset=null,this.elMenuIcon=null}}]),t}(),ft=function(t){h(a,t);var e=o(a);function a(t){var s;return i(this,a),(s=e.call(this,t)).ctx=t,s.w=t.w,s.dragged=!1,s.graphics=new k(s.ctx),s.eventList=["mousedown","mouseleave","mousemove","touchstart","touchmove","mouseup","touchend","wheel"],s.clientX=0,s.clientY=0,s.startX=0,s.endX=0,s.dragX=0,s.startY=0,s.endY=0,s.dragY=0,s.moveDirection="none",s.debounceTimer=null,s.debounceDelay=100,s.wheelDelay=400,s}return s(a,[{key:"init",value:function(t){var e=this,i=t.xyRatios,a=this.w,s=this;this.xyRatios=i,this.zoomRect=this.graphics.drawRect(0,0,0,0),this.selectionRect=this.graphics.drawRect(0,0,0,0),this.gridRect=a.globals.dom.baseEl.querySelector(".apexcharts-grid"),this.zoomRect.node.classList.add("apexcharts-zoom-rect"),this.selectionRect.node.classList.add("apexcharts-selection-rect"),a.globals.dom.elGraphical.add(this.zoomRect),a.globals.dom.elGraphical.add(this.selectionRect),"x"===a.config.chart.selection.type?this.slDraggableRect=this.selectionRect.draggable({minX:0,minY:0,maxX:a.globals.gridWidth,maxY:a.globals.gridHeight}).on("dragmove",this.selectionDragging.bind(this,"dragging")):"y"===a.config.chart.selection.type?this.slDraggableRect=this.selectionRect.draggable({minX:0,maxX:a.globals.gridWidth}).on("dragmove",this.selectionDragging.bind(this,"dragging")):this.slDraggableRect=this.selectionRect.draggable().on("dragmove",this.selectionDragging.bind(this,"dragging")),this.preselectedSelection(),this.hoverArea=a.globals.dom.baseEl.querySelector("".concat(a.globals.chartClass," .apexcharts-svg")),this.hoverArea.classList.add("apexcharts-zoomable"),this.eventList.forEach((function(t){e.hoverArea.addEventListener(t,s.svgMouseEvents.bind(s,i),{capture:!1,passive:!0})})),a.config.chart.zoom.allowMouseWheelZoom&&this.hoverArea.addEventListener("wheel",s.mouseWheelEvent.bind(s),{capture:!1,passive:!1})}},{key:"destroy",value:function(){this.slDraggableRect&&(this.slDraggableRect.draggable(!1),this.slDraggableRect.off(),this.selectionRect.off()),this.selectionRect=null,this.zoomRect=null,this.gridRect=null}},{key:"svgMouseEvents",value:function(t,e){var i=this.w,a=this,s=this.ctx.toolbar,r=i.globals.zoomEnabled?i.config.chart.zoom.type:i.config.chart.selection.type,o=i.config.chart.toolbar.autoSelected;if(e.shiftKey?(this.shiftWasPressed=!0,s.enableZoomPanFromToolbar("pan"===o?"zoom":"pan")):this.shiftWasPressed&&(s.enableZoomPanFromToolbar(o),this.shiftWasPressed=!1),e.target){var n,l=e.target.classList;if(e.target.parentNode&&null!==e.target.parentNode&&(n=e.target.parentNode.classList),!(l.contains("apexcharts-selection-rect")||l.contains("apexcharts-legend-marker")||l.contains("apexcharts-legend-text")||n&&n.contains("apexcharts-toolbar"))){if(a.clientX="touchmove"===e.type||"touchstart"===e.type?e.touches[0].clientX:"touchend"===e.type?e.changedTouches[0].clientX:e.clientX,a.clientY="touchmove"===e.type||"touchstart"===e.type?e.touches[0].clientY:"touchend"===e.type?e.changedTouches[0].clientY:e.clientY,"mousedown"===e.type&&1===e.which){var h=a.gridRect.getBoundingClientRect();a.startX=a.clientX-h.left,a.startY=a.clientY-h.top,a.dragged=!1,a.w.globals.mousedown=!0}if(("mousemove"===e.type&&1===e.which||"touchmove"===e.type)&&(a.dragged=!0,i.globals.panEnabled?(i.globals.selection=null,a.w.globals.mousedown&&a.panDragging({context:a,zoomtype:r,xyRatios:t})):(a.w.globals.mousedown&&i.globals.zoomEnabled||a.w.globals.mousedown&&i.globals.selectionEnabled)&&(a.selection=a.selectionDrawing({context:a,zoomtype:r}))),"mouseup"===e.type||"touchend"===e.type||"mouseleave"===e.type){var c,d=null===(c=a.gridRect)||void 0===c?void 0:c.getBoundingClientRect();d&&a.w.globals.mousedown&&(a.endX=a.clientX-d.left,a.endY=a.clientY-d.top,a.dragX=Math.abs(a.endX-a.startX),a.dragY=Math.abs(a.endY-a.startY),(i.globals.zoomEnabled||i.globals.selectionEnabled)&&a.selectionDrawn({context:a,zoomtype:r}),i.globals.panEnabled&&i.config.xaxis.convertedCatToNumeric&&a.delayedPanScrolled()),i.globals.zoomEnabled&&a.hideSelectionRect(this.selectionRect),a.dragged=!1,a.w.globals.mousedown=!1}this.makeSelectionRectDraggable()}}}},{key:"mouseWheelEvent",value:function(t){var e=this,i=this.w;t.preventDefault();var a=Date.now();a-i.globals.lastWheelExecution>this.wheelDelay&&(this.executeMouseWheelZoom(t),i.globals.lastWheelExecution=a),this.debounceTimer&&clearTimeout(this.debounceTimer),this.debounceTimer=setTimeout((function(){a-i.globals.lastWheelExecution>e.wheelDelay&&(e.executeMouseWheelZoom(t),i.globals.lastWheelExecution=a)}),this.debounceDelay)}},{key:"executeMouseWheelZoom",value:function(t){var e,i=this.w;this.minX=i.globals.isRangeBar?i.globals.minY:i.globals.minX,this.maxX=i.globals.isRangeBar?i.globals.maxY:i.globals.maxX;var a=null===(e=this.gridRect)||void 0===e?void 0:e.getBoundingClientRect();if(a){var s,r,o,n=(t.clientX-a.left)/a.width,l=this.minX,h=this.maxX,c=h-l;if(t.deltaY<0){var d=l+n*c;r=d-(s=.5*c)/2,o=d+s/2}else r=l-(s=1.5*c)/2,o=h+s/2;if(!i.globals.isRangeBar){r=Math.max(r,i.globals.initialMinX),o=Math.min(o,i.globals.initialMaxX);var g=.01*(i.globals.initialMaxX-i.globals.initialMinX);if(o-r<g){var u=(r+o)/2;r=u-g/2,o=u+g/2}}var f=this._getNewMinXMaxX(r,o);isNaN(f.minX)||isNaN(f.maxX)||this.zoomUpdateOptions(f.minX,f.maxX)}}},{key:"makeSelectionRectDraggable",value:function(){var t=this.w;if(this.selectionRect){var e=this.selectionRect.node.getBoundingClientRect();e.width>0&&e.height>0&&this.slDraggableRect.selectize({points:"l, r",pointSize:8,pointType:"rect"}).resize({constraint:{minX:0,minY:0,maxX:t.globals.gridWidth,maxY:t.globals.gridHeight}}).on("resizing",this.selectionDragging.bind(this,"resizing"))}}},{key:"preselectedSelection",value:function(){var t=this.w,e=this.xyRatios;if(!t.globals.zoomEnabled)if(void 0!==t.globals.selection&&null!==t.globals.selection)this.drawSelectionRect(t.globals.selection);else if(void 0!==t.config.chart.selection.xaxis.min&&void 0!==t.config.chart.selection.xaxis.max){var i=(t.config.chart.selection.xaxis.min-t.globals.minX)/e.xRatio,a=t.globals.gridWidth-(t.globals.maxX-t.config.chart.selection.xaxis.max)/e.xRatio-i;t.globals.isRangeBar&&(i=(t.config.chart.selection.xaxis.min-t.globals.yAxisScale[0].niceMin)/e.invertedYRatio,a=(t.config.chart.selection.xaxis.max-t.config.chart.selection.xaxis.min)/e.invertedYRatio);var s={x:i,y:0,width:a,height:t.globals.gridHeight,translateX:0,translateY:0,selectionEnabled:!0};this.drawSelectionRect(s),this.makeSelectionRectDraggable(),"function"==typeof t.config.chart.events.selection&&t.config.chart.events.selection(this.ctx,{xaxis:{min:t.config.chart.selection.xaxis.min,max:t.config.chart.selection.xaxis.max},yaxis:{}})}}},{key:"drawSelectionRect",value:function(t){var e=t.x,i=t.y,a=t.width,s=t.height,r=t.translateX,o=void 0===r?0:r,n=t.translateY,l=void 0===n?0:n,h=this.w,c=this.zoomRect,d=this.selectionRect;if(this.dragged||null!==h.globals.selection){var g={transform:"translate("+o+", "+l+")"};h.globals.zoomEnabled&&this.dragged&&(a<0&&(a=1),c.attr({x:e,y:i,width:a,height:s,fill:h.config.chart.zoom.zoomedArea.fill.color,"fill-opacity":h.config.chart.zoom.zoomedArea.fill.opacity,stroke:h.config.chart.zoom.zoomedArea.stroke.color,"stroke-width":h.config.chart.zoom.zoomedArea.stroke.width,"stroke-opacity":h.config.chart.zoom.zoomedArea.stroke.opacity}),k.setAttrs(c.node,g)),h.globals.selectionEnabled&&(d.attr({x:e,y:i,width:a>0?a:0,height:s>0?s:0,fill:h.config.chart.selection.fill.color,"fill-opacity":h.config.chart.selection.fill.opacity,stroke:h.config.chart.selection.stroke.color,"stroke-width":h.config.chart.selection.stroke.width,"stroke-dasharray":h.config.chart.selection.stroke.dashArray,"stroke-opacity":h.config.chart.selection.stroke.opacity}),k.setAttrs(d.node,g))}}},{key:"hideSelectionRect",value:function(t){t&&t.attr({x:0,y:0,width:0,height:0})}},{key:"selectionDrawing",value:function(t){var e=t.context,i=t.zoomtype,a=this.w,s=e,r=this.gridRect.getBoundingClientRect(),o=s.startX-1,n=s.startY,l=!1,h=!1,c=s.clientX-r.left-o,d=s.clientY-r.top-n,g={};return Math.abs(c+o)>a.globals.gridWidth?c=a.globals.gridWidth-o:s.clientX-r.left<0&&(c=o),o>s.clientX-r.left&&(l=!0,c=Math.abs(c)),n>s.clientY-r.top&&(h=!0,d=Math.abs(d)),g="x"===i?{x:l?o-c:o,y:0,width:c,height:a.globals.gridHeight}:"y"===i?{x:0,y:h?n-d:n,width:a.globals.gridWidth,height:d}:{x:l?o-c:o,y:h?n-d:n,width:c,height:d},s.drawSelectionRect(g),s.selectionDragging("resizing"),g}},{key:"selectionDragging",value:function(t,e){var i=this,a=this.w,s=this.xyRatios,r=this.selectionRect,o=0;"resizing"===t&&(o=30);var n=function(t){return parseFloat(r.node.getAttribute(t))},l={x:n("x"),y:n("y"),width:n("width"),height:n("height")};a.globals.selection=l,"function"==typeof a.config.chart.events.selection&&a.globals.selectionEnabled&&(clearTimeout(this.w.globals.selectionResizeTimer),this.w.globals.selectionResizeTimer=window.setTimeout((function(){var t,e,o,n,l=i.gridRect.getBoundingClientRect(),h=r.node.getBoundingClientRect();a.globals.isRangeBar?(t=a.globals.yAxisScale[0].niceMin+(h.left-l.left)*s.invertedYRatio,e=a.globals.yAxisScale[0].niceMin+(h.right-l.left)*s.invertedYRatio,o=0,n=1):(t=a.globals.xAxisScale.niceMin+(h.left-l.left)*s.xRatio,e=a.globals.xAxisScale.niceMin+(h.right-l.left)*s.xRatio,o=a.globals.yAxisScale[0].niceMin+(l.bottom-h.bottom)*s.yRatio[0],n=a.globals.yAxisScale[0].niceMax-(h.top-l.top)*s.yRatio[0]);var c={xaxis:{min:t,max:e},yaxis:{min:o,max:n}};a.config.chart.events.selection(i.ctx,c),a.config.chart.brush.enabled&&void 0!==a.config.chart.events.brushScrolled&&a.config.chart.events.brushScrolled(i.ctx,c)}),o))}},{key:"selectionDrawn",value:function(t){var e=t.context,i=t.zoomtype,a=this.w,s=e,r=this.xyRatios,o=this.ctx.toolbar;if(s.startX>s.endX){var n=s.startX;s.startX=s.endX,s.endX=n}if(s.startY>s.endY){var l=s.startY;s.startY=s.endY,s.endY=l}var h=void 0,c=void 0;a.globals.isRangeBar?(h=a.globals.yAxisScale[0].niceMin+s.startX*r.invertedYRatio,c=a.globals.yAxisScale[0].niceMin+s.endX*r.invertedYRatio):(h=a.globals.xAxisScale.niceMin+s.startX*r.xRatio,c=a.globals.xAxisScale.niceMin+s.endX*r.xRatio);var d=[],g=[];if(a.config.yaxis.forEach((function(t,e){var i=a.globals.seriesYAxisMap[e][0];d.push(a.globals.yAxisScale[e].niceMax-r.yRatio[i]*s.startY),g.push(a.globals.yAxisScale[e].niceMax-r.yRatio[i]*s.endY)})),s.dragged&&(s.dragX>10||s.dragY>10)&&h!==c)if(a.globals.zoomEnabled){var u=m.clone(a.globals.initialConfig.yaxis),f=m.clone(a.globals.initialConfig.xaxis);if(a.globals.zoomed=!0,a.config.xaxis.convertedCatToNumeric&&(h=Math.floor(h),c=Math.floor(c),h<1&&(h=1,c=a.globals.dataPoints),c-h<2&&(c=h+1)),"xy"!==i&&"x"!==i||(f={min:h,max:c}),"xy"!==i&&"y"!==i||u.forEach((function(t,e){u[e].min=g[e],u[e].max=d[e]})),o){var p=o.getBeforeZoomRange(f,u);p&&(f=p.xaxis?p.xaxis:f,u=p.yaxis?p.yaxis:u)}var x={xaxis:f};a.config.chart.group||(x.yaxis=u),s.ctx.updateHelpers._updateOptions(x,!1,s.w.config.chart.animations.dynamicAnimation.enabled),"function"==typeof a.config.chart.events.zoomed&&o.zoomCallback(f,u)}else if(a.globals.selectionEnabled){var b,v=null;b={min:h,max:c},"xy"!==i&&"y"!==i||(v=m.clone(a.config.yaxis)).forEach((function(t,e){v[e].min=g[e],v[e].max=d[e]})),a.globals.selection=s.selection,"function"==typeof a.config.chart.events.selection&&a.config.chart.events.selection(s.ctx,{xaxis:b,yaxis:v})}}},{key:"panDragging",value:function(t){var e=t.context,i=this.w,a=e;if(void 0!==i.globals.lastClientPosition.x){var s=i.globals.lastClientPosition.x-a.clientX,r=i.globals.lastClientPosition.y-a.clientY;Math.abs(s)>Math.abs(r)&&s>0?this.moveDirection="left":Math.abs(s)>Math.abs(r)&&s<0?this.moveDirection="right":Math.abs(r)>Math.abs(s)&&r>0?this.moveDirection="up":Math.abs(r)>Math.abs(s)&&r<0&&(this.moveDirection="down")}i.globals.lastClientPosition={x:a.clientX,y:a.clientY};var o=i.globals.isRangeBar?i.globals.minY:i.globals.minX,n=i.globals.isRangeBar?i.globals.maxY:i.globals.maxX;i.config.xaxis.convertedCatToNumeric||a.panScrolled(o,n)}},{key:"delayedPanScrolled",value:function(){var t=this.w,e=t.globals.minX,i=t.globals.maxX,a=(t.globals.maxX-t.globals.minX)/2;"left"===this.moveDirection?(e=t.globals.minX+a,i=t.globals.maxX+a):"right"===this.moveDirection&&(e=t.globals.minX-a,i=t.globals.maxX-a),e=Math.floor(e),i=Math.floor(i),this.updateScrolledChart({xaxis:{min:e,max:i}},e,i)}},{key:"panScrolled",value:function(t,e){var i=this.w,a=this.xyRatios,s=m.clone(i.globals.initialConfig.yaxis),r=a.xRatio,o=i.globals.minX,n=i.globals.maxX;i.globals.isRangeBar&&(r=a.invertedYRatio,o=i.globals.minY,n=i.globals.maxY),"left"===this.moveDirection?(t=o+i.globals.gridWidth/15*r,e=n+i.globals.gridWidth/15*r):"right"===this.moveDirection&&(t=o-i.globals.gridWidth/15*r,e=n-i.globals.gridWidth/15*r),i.globals.isRangeBar||(t<i.globals.initialMinX||e>i.globals.initialMaxX)&&(t=o,e=n);var l={xaxis:{min:t,max:e}};i.config.chart.group||(l.yaxis=s),this.updateScrolledChart(l,t,e)}},{key:"updateScrolledChart",value:function(t,e,i){var a=this.w;this.ctx.updateHelpers._updateOptions(t,!1,!1),"function"==typeof a.config.chart.events.scrolled&&a.config.chart.events.scrolled(this.ctx,{xaxis:{min:e,max:i}})}}]),a}(ut),pt=function(){function t(e){i(this,t),this.w=e.w,this.ttCtx=e,this.ctx=e.ctx}return s(t,[{key:"getNearestValues",value:function(t){var e=t.hoverArea,i=t.elGrid,a=t.clientX,s=t.clientY,r=this.w,o=i.getBoundingClientRect(),n=o.width,l=o.height,h=n/(r.globals.dataPoints-1),c=l/r.globals.dataPoints,d=this.hasBars();!r.globals.comboCharts&&!d||r.config.xaxis.convertedCatToNumeric||(h=n/r.globals.dataPoints);var g=a-o.left-r.globals.barPadForNumericAxis,u=s-o.top;g<0||u<0||g>n||u>l?(e.classList.remove("hovering-zoom"),e.classList.remove("hovering-pan")):r.globals.zoomEnabled?(e.classList.remove("hovering-pan"),e.classList.add("hovering-zoom")):r.globals.panEnabled&&(e.classList.remove("hovering-zoom"),e.classList.add("hovering-pan"));var f=Math.round(g/h),p=Math.floor(u/c);d&&!r.config.xaxis.convertedCatToNumeric&&(f=Math.ceil(g/h),f-=1);var x=null,b=null,v=r.globals.seriesXvalues.map((function(t){return t.filter((function(t){return m.isNumber(t)}))})),y=r.globals.seriesYvalues.map((function(t){return t.filter((function(t){return m.isNumber(t)}))}));if(r.globals.isXNumeric){var w=this.ttCtx.getElGrid().getBoundingClientRect(),k=g*(w.width/n),A=u*(w.height/l);x=(b=this.closestInMultiArray(k,A,v,y)).index,f=b.j,null!==x&&(v=r.globals.seriesXvalues[x],f=(b=this.closestInArray(k,v)).index)}return r.globals.capturedSeriesIndex=null===x?-1:x,(!f||f<1)&&(f=0),r.globals.isBarHorizontal?r.globals.capturedDataPointIndex=p:r.globals.capturedDataPointIndex=f,{capturedSeries:x,j:r.globals.isBarHorizontal?p:f,hoverX:g,hoverY:u}}},{key:"closestInMultiArray",value:function(t,e,i,a){var s=this.w,r=0,o=null,n=-1;s.globals.series.length>1?r=this.getFirstActiveXArray(i):o=0;var l=i[r][0],h=Math.abs(t-l);if(i.forEach((function(e){e.forEach((function(e,i){var a=Math.abs(t-e);a<=h&&(h=a,n=i)}))})),-1!==n){var c=a[r][n],d=Math.abs(e-c);o=r,a.forEach((function(t,i){var a=Math.abs(e-t[n]);a<=d&&(d=a,o=i)}))}return{index:o,j:n}}},{key:"getFirstActiveXArray",value:function(t){for(var e=this.w,i=0,a=t.map((function(t,e){return t.length>0?e:-1})),s=0;s<a.length;s++)if(-1!==a[s]&&-1===e.globals.collapsedSeriesIndices.indexOf(s)&&-1===e.globals.ancillaryCollapsedSeriesIndices.indexOf(s)){i=a[s];break}return i}},{key:"closestInArray",value:function(t,e){for(var i=e[0],a=null,s=Math.abs(t-i),r=0;r<e.length;r++){var o=Math.abs(t-e[r]);o<s&&(s=o,a=r)}return{index:a}}},{key:"isXoverlap",value:function(t){var e=[],i=this.w.globals.seriesX.filter((function(t){return void 0!==t[0]}));if(i.length>0)for(var a=0;a<i.length-1;a++)void 0!==i[a][t]&&void 0!==i[a+1][t]&&i[a][t]!==i[a+1][t]&&e.push("unEqual");return 0===e.length}},{key:"isInitialSeriesSameLen",value:function(){for(var t=!0,e=this.w.globals.initialSeries,i=0;i<e.length-1;i++)if(e[i].data.length!==e[i+1].data.length){t=!1;break}return t}},{key:"getBarsHeight",value:function(t){return p(t).reduce((function(t,e){return t+e.getBBox().height}),0)}},{key:"getElMarkers",value:function(t){return"number"==typeof t?this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:realIndex='".concat(t,"'] .apexcharts-series-markers-wrap > *")):this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap > *")}},{key:"getAllMarkers",value:function(){var t=this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap");(t=p(t)).sort((function(t,e){var i=Number(t.getAttribute("data:realIndex")),a=Number(e.getAttribute("data:realIndex"));return a<i?1:a>i?-1:0}));var e=[];return t.forEach((function(t){e.push(t.querySelector(".apexcharts-marker"))})),e}},{key:"hasMarkers",value:function(t){return this.getElMarkers(t).length>0}},{key:"getPathFromPoint",value:function(t,e){var i=Number(t.getAttribute("cx")),a=Number(t.getAttribute("cy")),s=t.getAttribute("shape");return new k(this.ctx).getMarkerPath(i,a,s,e)}},{key:"getElBars",value:function(){return this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-bar-series,  .apexcharts-candlestick-series, .apexcharts-boxPlot-series, .apexcharts-rangebar-series")}},{key:"hasBars",value:function(){return this.getElBars().length>0}},{key:"getHoverMarkerSize",value:function(t){var e=this.w,i=e.config.markers.hover.size;return void 0===i&&(i=e.globals.markers.size[t]+e.config.markers.hover.sizeOffset),i}},{key:"toggleAllTooltipSeriesGroups",value:function(t){var e=this.w,i=this.ttCtx;0===i.allTooltipSeriesGroups.length&&(i.allTooltipSeriesGroups=e.globals.dom.baseEl.querySelectorAll(".apexcharts-tooltip-series-group"));for(var a=i.allTooltipSeriesGroups,s=0;s<a.length;s++)"enable"===t?(a[s].classList.add("apexcharts-active"),a[s].style.display=e.config.tooltip.items.display):(a[s].classList.remove("apexcharts-active"),a[s].style.display="none")}}]),t}(),xt=function(){function t(e){i(this,t),this.w=e.w,this.ctx=e.ctx,this.ttCtx=e,this.tooltipUtil=new pt(e)}return s(t,[{key:"drawSeriesTexts",value:function(t){var e=t.shared,i=void 0===e||e,a=t.ttItems,s=t.i,r=void 0===s?0:s,o=t.j,n=void 0===o?null:o,l=t.y1,h=t.y2,c=t.e,d=this.w;void 0!==d.config.tooltip.custom?this.handleCustomTooltip({i:r,j:n,y1:l,y2:h,w:d}):this.toggleActiveInactiveSeries(i,r);var g=this.getValuesToPrint({i:r,j:n});this.printLabels({i:r,j:n,values:g,ttItems:a,shared:i,e:c});var u=this.ttCtx.getElTooltip();this.ttCtx.tooltipRect.ttWidth=u.getBoundingClientRect().width,this.ttCtx.tooltipRect.ttHeight=u.getBoundingClientRect().height}},{key:"printLabels",value:function(t){var e,i=this,a=t.i,s=t.j,r=t.values,o=t.ttItems,n=t.shared,l=t.e,h=this.w,c=[],d=function(t){return h.globals.seriesGoals[t]&&h.globals.seriesGoals[t][s]&&Array.isArray(h.globals.seriesGoals[t][s])},u=r.xVal,f=r.zVal,p=r.xAxisTTVal,x="",b=h.globals.colors[a];null!==s&&h.config.plotOptions.bar.distributed&&(b=h.globals.colors[s]);for(var v=function(t,r){var v=i.getFormatters(a);x=i.getSeriesName({fn:v.yLbTitleFormatter,index:a,seriesIndex:a,j:s}),"treemap"===h.config.chart.type&&(x=v.yLbTitleFormatter(String(h.config.series[a].data[s].x),{series:h.globals.series,seriesIndex:a,dataPointIndex:s,w:h}));var m=h.config.tooltip.inverseOrder?r:t;if(h.globals.axisCharts){var y=function(t){var e,i,a,r;return h.globals.isRangeData?v.yLbFormatter(null===(e=h.globals.seriesRangeStart)||void 0===e||null===(i=e[t])||void 0===i?void 0:i[s],{series:h.globals.seriesRangeStart,seriesIndex:t,dataPointIndex:s,w:h})+" - "+v.yLbFormatter(null===(a=h.globals.seriesRangeEnd)||void 0===a||null===(r=a[t])||void 0===r?void 0:r[s],{series:h.globals.seriesRangeEnd,seriesIndex:t,dataPointIndex:s,w:h}):v.yLbFormatter(h.globals.series[t][s],{series:h.globals.series,seriesIndex:t,dataPointIndex:s,w:h})};if(n)v=i.getFormatters(m),x=i.getSeriesName({fn:v.yLbTitleFormatter,index:m,seriesIndex:a,j:s}),b=h.globals.colors[m],e=y(m),d(m)&&(c=h.globals.seriesGoals[m][s].map((function(t){return{attrs:t,val:v.yLbFormatter(t.value,{seriesIndex:m,dataPointIndex:s,w:h})}})));else{var w,k=null==l||null===(w=l.target)||void 0===w?void 0:w.getAttribute("fill");k&&(-1!==k.indexOf("url")?-1!==k.indexOf("Pattern")&&(b=h.globals.dom.baseEl.querySelector(k.substr(4).slice(0,-1)).childNodes[0].getAttribute("stroke")):b=k),e=y(a),d(a)&&Array.isArray(h.globals.seriesGoals[a][s])&&(c=h.globals.seriesGoals[a][s].map((function(t){return{attrs:t,val:v.yLbFormatter(t.value,{seriesIndex:a,dataPointIndex:s,w:h})}})))}}null===s&&(e=v.yLbFormatter(h.globals.series[a],g(g({},h),{},{seriesIndex:a,dataPointIndex:a}))),i.DOMHandling({i:a,t:m,j:s,ttItems:o,values:{val:e,goalVals:c,xVal:u,xAxisTTVal:p,zVal:f},seriesName:x,shared:n,pColor:b})},m=0,y=h.globals.series.length-1;m<h.globals.series.length;m++,y--)v(m,y)}},{key:"getFormatters",value:function(t){var e,i=this.w,a=i.globals.yLabelFormatters[t];return void 0!==i.globals.ttVal?Array.isArray(i.globals.ttVal)?(a=i.globals.ttVal[t]&&i.globals.ttVal[t].formatter,e=i.globals.ttVal[t]&&i.globals.ttVal[t].title&&i.globals.ttVal[t].title.formatter):(a=i.globals.ttVal.formatter,"function"==typeof i.globals.ttVal.title.formatter&&(e=i.globals.ttVal.title.formatter)):e=i.config.tooltip.y.title.formatter,"function"!=typeof a&&(a=i.globals.yLabelFormatters[0]?i.globals.yLabelFormatters[0]:function(t){return t}),"function"!=typeof e&&(e=function(t){return t}),{yLbFormatter:a,yLbTitleFormatter:e}}},{key:"getSeriesName",value:function(t){var e=t.fn,i=t.index,a=t.seriesIndex,s=t.j,r=this.w;return e(String(r.globals.seriesNames[i]),{series:r.globals.series,seriesIndex:a,dataPointIndex:s,w:r})}},{key:"DOMHandling",value:function(t){t.i;var e=t.t,i=t.j,a=t.ttItems,s=t.values,r=t.seriesName,o=t.shared,n=t.pColor,l=this.w,h=this.ttCtx,c=s.val,d=s.goalVals,g=s.xVal,u=s.xAxisTTVal,f=s.zVal,p=null;p=a[e].children,l.config.tooltip.fillSeriesColor&&(a[e].style.backgroundColor=n,p[0].style.display="none"),h.showTooltipTitle&&(null===h.tooltipTitle&&(h.tooltipTitle=l.globals.dom.baseEl.querySelector(".apexcharts-tooltip-title")),h.tooltipTitle.innerHTML=g),h.isXAxisTooltipEnabled&&(h.xaxisTooltipText.innerHTML=""!==u?u:g);var x=a[e].querySelector(".apexcharts-tooltip-text-y-label");x&&(x.innerHTML=r||"");var b=a[e].querySelector(".apexcharts-tooltip-text-y-value");b&&(b.innerHTML=void 0!==c?c:""),p[0]&&p[0].classList.contains("apexcharts-tooltip-marker")&&(l.config.tooltip.marker.fillColors&&Array.isArray(l.config.tooltip.marker.fillColors)&&(n=l.config.tooltip.marker.fillColors[e]),p[0].style.backgroundColor=n),l.config.tooltip.marker.show||(p[0].style.display="none");var v=a[e].querySelector(".apexcharts-tooltip-text-goals-label"),m=a[e].querySelector(".apexcharts-tooltip-text-goals-value");if(d.length&&l.globals.seriesGoals[e]){var y=function(){var t="<div >",e="<div>";d.forEach((function(i,a){t+=' <div style="display: flex"><span class="apexcharts-tooltip-marker" style="background-color: '.concat(i.attrs.strokeColor,'; height: 3px; border-radius: 0; top: 5px;"></span> ').concat(i.attrs.name,"</div>"),e+="<div>".concat(i.val,"</div>")})),v.innerHTML=t+"</div>",m.innerHTML=e+"</div>"};o?l.globals.seriesGoals[e][i]&&Array.isArray(l.globals.seriesGoals[e][i])?y():(v.innerHTML="",m.innerHTML=""):y()}else v.innerHTML="",m.innerHTML="";null!==f&&(a[e].querySelector(".apexcharts-tooltip-text-z-label").innerHTML=l.config.tooltip.z.title,a[e].querySelector(".apexcharts-tooltip-text-z-value").innerHTML=void 0!==f?f:"");if(o&&p[0]){if(l.config.tooltip.hideEmptySeries){var w=a[e].querySelector(".apexcharts-tooltip-marker"),k=a[e].querySelector(".apexcharts-tooltip-text");0==parseFloat(c)?(w.style.display="none",k.style.display="none"):(w.style.display="block",k.style.display="block")}null==c||l.globals.ancillaryCollapsedSeriesIndices.indexOf(e)>-1||l.globals.collapsedSeriesIndices.indexOf(e)>-1||Array.isArray(h.tConfig.enabledOnSeries)&&-1===h.tConfig.enabledOnSeries.indexOf(e)?p[0].parentNode.style.display="none":p[0].parentNode.style.display=l.config.tooltip.items.display}else Array.isArray(h.tConfig.enabledOnSeries)&&-1===h.tConfig.enabledOnSeries.indexOf(e)&&(p[0].parentNode.style.display="none")}},{key:"toggleActiveInactiveSeries",value:function(t,e){var i=this.w;if(t)this.tooltipUtil.toggleAllTooltipSeriesGroups("enable");else{this.tooltipUtil.toggleAllTooltipSeriesGroups("disable");var a=i.globals.dom.baseEl.querySelector(".apexcharts-tooltip-series-group-".concat(e));a&&(a.classList.add("apexcharts-active"),a.style.display=i.config.tooltip.items.display)}}},{key:"getValuesToPrint",value:function(t){var e=t.i,i=t.j,a=this.w,s=this.ctx.series.filteredSeriesX(),r="",o="",n=null,l=null,h={series:a.globals.series,seriesIndex:e,dataPointIndex:i,w:a},c=a.globals.ttZFormatter;null===i?l=a.globals.series[e]:a.globals.isXNumeric&&"treemap"!==a.config.chart.type?(r=s[e][i],0===s[e].length&&(r=s[this.tooltipUtil.getFirstActiveXArray(s)][i])):r=new _(this.ctx).isFormatXY()?void 0!==a.config.series[e].data[i]?a.config.series[e].data[i].x:"":void 0!==a.globals.labels[i]?a.globals.labels[i]:"";var d=r;a.globals.isXNumeric&&"datetime"===a.config.xaxis.type?r=new P(this.ctx).xLabelFormat(a.globals.ttKeyFormatter,d,d,{i:void 0,dateFormatter:new L(this.ctx).formatDate,w:this.w}):r=a.globals.isBarHorizontal?a.globals.yLabelFormatters[0](d,h):a.globals.xLabelFormatter(d,h);return void 0!==a.config.tooltip.x.formatter&&(r=a.globals.ttKeyFormatter(d,h)),a.globals.seriesZ.length>0&&a.globals.seriesZ[e].length>0&&(n=c(a.globals.seriesZ[e][i],a)),o="function"==typeof a.config.xaxis.tooltip.formatter?a.globals.xaxisTooltipFormatter(d,h):r,{val:Array.isArray(l)?l.join(" "):l,xVal:Array.isArray(r)?r.join(" "):r,xAxisTTVal:Array.isArray(o)?o.join(" "):o,zVal:n}}},{key:"handleCustomTooltip",value:function(t){var e=t.i,i=t.j,a=t.y1,s=t.y2,r=t.w,o=this.ttCtx.getElTooltip(),n=r.config.tooltip.custom;Array.isArray(n)&&n[e]&&(n=n[e]),o.innerHTML=n({ctx:this.ctx,series:r.globals.series,seriesIndex:e,dataPointIndex:i,y1:a,y2:s,w:r})}}]),t}(),bt=function(){function t(e){i(this,t),this.ttCtx=e,this.ctx=e.ctx,this.w=e.w}return s(t,[{key:"moveXCrosshairs",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,i=this.ttCtx,a=this.w,s=i.getElXCrosshairs(),r=t-i.xcrosshairsWidth/2,o=a.globals.labels.slice().length;if(null!==e&&(r=a.globals.gridWidth/o*e),null===s||a.globals.isBarHorizontal||(s.setAttribute("x",r),s.setAttribute("x1",r),s.setAttribute("x2",r),s.setAttribute("y2",a.globals.gridHeight),s.classList.add("apexcharts-active")),r<0&&(r=0),r>a.globals.gridWidth&&(r=a.globals.gridWidth),i.isXAxisTooltipEnabled){var n=r;"tickWidth"!==a.config.xaxis.crosshairs.width&&"barWidth"!==a.config.xaxis.crosshairs.width||(n=r+i.xcrosshairsWidth/2),this.moveXAxisTooltip(n)}}},{key:"moveYCrosshairs",value:function(t){var e=this.ttCtx;null!==e.ycrosshairs&&k.setAttrs(e.ycrosshairs,{y1:t,y2:t}),null!==e.ycrosshairsHidden&&k.setAttrs(e.ycrosshairsHidden,{y1:t,y2:t})}},{key:"moveXAxisTooltip",value:function(t){var e=this.w,i=this.ttCtx;if(null!==i.xaxisTooltip&&0!==i.xcrosshairsWidth){i.xaxisTooltip.classList.add("apexcharts-active");var a=i.xaxisOffY+e.config.xaxis.tooltip.offsetY+e.globals.translateY+1+e.config.xaxis.offsetY;if(t-=i.xaxisTooltip.getBoundingClientRect().width/2,!isNaN(t)){t+=e.globals.translateX;var s;s=new k(this.ctx).getTextRects(i.xaxisTooltipText.innerHTML),i.xaxisTooltipText.style.minWidth=s.width+"px",i.xaxisTooltip.style.left=t+"px",i.xaxisTooltip.style.top=a+"px"}}}},{key:"moveYAxisTooltip",value:function(t){var e=this.w,i=this.ttCtx;null===i.yaxisTTEls&&(i.yaxisTTEls=e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));var a=parseInt(i.ycrosshairsHidden.getAttribute("y1"),10),s=e.globals.translateY+a,r=i.yaxisTTEls[t].getBoundingClientRect().height,o=e.globals.translateYAxisX[t]-2;e.config.yaxis[t].opposite&&(o-=26),s-=r/2,-1===e.globals.ignoreYAxisIndexes.indexOf(t)?(i.yaxisTTEls[t].classList.add("apexcharts-active"),i.yaxisTTEls[t].style.top=s+"px",i.yaxisTTEls[t].style.left=o+e.config.yaxis[t].tooltip.offsetX+"px"):i.yaxisTTEls[t].classList.remove("apexcharts-active")}},{key:"moveTooltip",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,a=this.w,s=this.ttCtx,r=s.getElTooltip(),o=s.tooltipRect,n=null!==i?parseFloat(i):1,l=parseFloat(t)+n+5,h=parseFloat(e)+n/2;if(l>a.globals.gridWidth/2&&(l=l-o.ttWidth-n-10),l>a.globals.gridWidth-o.ttWidth-10&&(l=a.globals.gridWidth-o.ttWidth),l<-20&&(l=-20),a.config.tooltip.followCursor){var c=s.getElGrid().getBoundingClientRect();(l=s.e.clientX-c.left)>a.globals.gridWidth/2&&(l-=s.tooltipRect.ttWidth),(h=s.e.clientY+a.globals.translateY-c.top)>a.globals.gridHeight/2&&(h-=s.tooltipRect.ttHeight)}else a.globals.isBarHorizontal||o.ttHeight/2+h>a.globals.gridHeight&&(h=a.globals.gridHeight-o.ttHeight+a.globals.translateY);isNaN(l)||(l+=a.globals.translateX,r.style.left=l+"px",r.style.top=h+"px")}},{key:"moveMarkers",value:function(t,e){var i=this.w,a=this.ttCtx;if(i.globals.markers.size[t]>0)for(var s=i.globals.dom.baseEl.querySelectorAll(" .apexcharts-series[data\\:realIndex='".concat(t,"'] .apexcharts-marker")),r=0;r<s.length;r++)parseInt(s[r].getAttribute("rel"),10)===e&&(a.marker.resetPointsSize(),a.marker.enlargeCurrentPoint(e,s[r]));else a.marker.resetPointsSize(),this.moveDynamicPointOnHover(e,t)}},{key:"moveDynamicPointOnHover",value:function(t,e){var i,a,s,r,o=this.w,n=this.ttCtx,l=new k(this.ctx),h=o.globals.pointsArray,c=n.tooltipUtil.getHoverMarkerSize(e),d=o.config.series[e].type;if(!d||"column"!==d&&"candlestick"!==d&&"boxPlot"!==d){s=null===(i=h[e][t])||void 0===i?void 0:i[0],r=(null===(a=h[e][t])||void 0===a?void 0:a[1])||0;var g=o.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(e,"'] .apexcharts-series-markers path"));if(g&&r<o.globals.gridHeight&&r>0){var u=g.getAttribute("shape"),f=l.getMarkerPath(s,r,u,1.5*c);g.setAttribute("d",f)}this.moveXCrosshairs(s),n.fixedTooltip||this.moveTooltip(s,r,c)}}},{key:"moveDynamicPointsOnHover",value:function(t){var e,i=this.ttCtx,a=i.w,s=0,r=0,o=a.globals.pointsArray,n=new V(this.ctx),l=new k(this.ctx);e=n.getActiveConfigSeriesIndex("asc",["line","area","scatter","bubble"]);var h=i.tooltipUtil.getHoverMarkerSize(e);o[e]&&(s=o[e][t][0],r=o[e][t][1]);var c=i.tooltipUtil.getAllMarkers();if(null!==c)for(var d=0;d<a.globals.series.length;d++){var g=o[d];if(a.globals.comboCharts&&void 0===g&&c.splice(d,0,null),g&&g.length){var u=o[d][t][1],f=void 0;c[d].setAttribute("cx",s);var p=c[d].getAttribute("shape");if("rangeArea"===a.config.chart.type&&!a.globals.comboCharts){var x=t+a.globals.series[d].length;f=o[d][x][1],u-=Math.abs(u-f)/2}if(null!==u&&!isNaN(u)&&u<a.globals.gridHeight+h&&u+h>0){var b=l.getMarkerPath(s,u,p,h);c[d].setAttribute("d",b)}else c[d].setAttribute("d","")}}this.moveXCrosshairs(s),i.fixedTooltip||this.moveTooltip(s,r||a.globals.gridHeight,h)}},{key:"moveStickyTooltipOverBars",value:function(t,e){var i=this.w,a=this.ttCtx,s=i.globals.columnSeries?i.globals.columnSeries.length:i.globals.series.length,r=s>=2&&s%2==0?Math.floor(s/2):Math.floor(s/2)+1;i.globals.isBarHorizontal&&(r=new V(this.ctx).getActiveConfigSeriesIndex("desc")+1);var o=i.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[rel='".concat(r,"'] path[j='").concat(t,"'], .apexcharts-candlestick-series .apexcharts-series[rel='").concat(r,"'] path[j='").concat(t,"'], .apexcharts-boxPlot-series .apexcharts-series[rel='").concat(r,"'] path[j='").concat(t,"'], .apexcharts-rangebar-series .apexcharts-series[rel='").concat(r,"'] path[j='").concat(t,"']"));o||"number"!=typeof e||(o=i.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[data\\:realIndex='".concat(e,"'] path[j='").concat(t,"'],\n        .apexcharts-candlestick-series .apexcharts-series[data\\:realIndex='").concat(e,"'] path[j='").concat(t,"'],\n        .apexcharts-boxPlot-series .apexcharts-series[data\\:realIndex='").concat(e,"'] path[j='").concat(t,"'],\n        .apexcharts-rangebar-series .apexcharts-series[data\\:realIndex='").concat(e,"'] path[j='").concat(t,"']")));var n=o?parseFloat(o.getAttribute("cx")):0,l=o?parseFloat(o.getAttribute("cy")):0,h=o?parseFloat(o.getAttribute("barWidth")):0,c=a.getElGrid().getBoundingClientRect(),d=o&&(o.classList.contains("apexcharts-candlestick-area")||o.classList.contains("apexcharts-boxPlot-area"));i.globals.isXNumeric?(o&&!d&&(n-=s%2!=0?h/2:0),o&&d&&i.globals.comboCharts&&(n-=h/2)):i.globals.isBarHorizontal||(n=a.xAxisTicksPositions[t-1]+a.dataPointsDividedWidth/2,isNaN(n)&&(n=a.xAxisTicksPositions[t]-a.dataPointsDividedWidth/2)),i.globals.isBarHorizontal?l-=a.tooltipRect.ttHeight:i.config.tooltip.followCursor?l=a.e.clientY-c.top-a.tooltipRect.ttHeight/2:l+a.tooltipRect.ttHeight+15>i.globals.gridHeight&&(l=i.globals.gridHeight),i.globals.isBarHorizontal||this.moveXCrosshairs(n),a.fixedTooltip||this.moveTooltip(n,l||i.globals.gridHeight)}}]),t}(),vt=function(){function t(e){i(this,t),this.w=e.w,this.ttCtx=e,this.ctx=e.ctx,this.tooltipPosition=new bt(e)}return s(t,[{key:"drawDynamicPoints",value:function(){var t=this.w,e=new k(this.ctx),i=new W(this.ctx),a=t.globals.dom.baseEl.querySelectorAll(".apexcharts-series");a=p(a),t.config.chart.stacked&&a.sort((function(t,e){return parseFloat(t.getAttribute("data:realIndex"))-parseFloat(e.getAttribute("data:realIndex"))}));for(var s=0;s<a.length;s++){var r=a[s].querySelector(".apexcharts-series-markers-wrap");if(null!==r){var o=void 0,n="apexcharts-marker w".concat((Math.random()+1).toString(36).substring(4));"line"!==t.config.chart.type&&"area"!==t.config.chart.type||t.globals.comboCharts||t.config.tooltip.intersect||(n+=" no-pointer-events");var l=i.getMarkerConfig({cssClass:n,seriesIndex:Number(r.getAttribute("data:realIndex"))});(o=e.drawMarker(0,0,l)).node.setAttribute("default-marker-size",0);var h=document.createElementNS(t.globals.SVGNS,"g");h.classList.add("apexcharts-series-markers"),h.appendChild(o.node),r.appendChild(h)}}}},{key:"enlargeCurrentPoint",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null,s=this.w;"bubble"!==s.config.chart.type&&this.newPointSize(t,e);var r=e.getAttribute("cx"),o=e.getAttribute("cy");if(null!==i&&null!==a&&(r=i,o=a),this.tooltipPosition.moveXCrosshairs(r),!this.fixedTooltip){if("radar"===s.config.chart.type){var n=this.ttCtx.getElGrid().getBoundingClientRect();r=this.ttCtx.e.clientX-n.left}this.tooltipPosition.moveTooltip(r,o,s.config.markers.hover.size)}}},{key:"enlargePoints",value:function(t){for(var e=this.w,i=this,a=this.ttCtx,s=t,r=e.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"),o=e.config.markers.hover.size,n=0;n<r.length;n++){var l=r[n].getAttribute("rel"),h=r[n].getAttribute("index");if(void 0===o&&(o=e.globals.markers.size[h]+e.config.markers.hover.sizeOffset),s===parseInt(l,10)){i.newPointSize(s,r[n]);var c=r[n].getAttribute("cx"),d=r[n].getAttribute("cy");i.tooltipPosition.moveXCrosshairs(c),a.fixedTooltip||i.tooltipPosition.moveTooltip(c,d,o)}else i.oldPointSize(r[n])}}},{key:"newPointSize",value:function(t,e){var i=this.w,a=i.config.markers.hover.size,s=0===t?e.parentNode.firstChild:e.parentNode.lastChild;if("0"!==s.getAttribute("default-marker-size")){var r=parseInt(s.getAttribute("index"),10);void 0===a&&(a=i.globals.markers.size[r]+i.config.markers.hover.sizeOffset),a<0&&(a=0);var o=this.ttCtx.tooltipUtil.getPathFromPoint(e,a);e.setAttribute("d",o)}}},{key:"oldPointSize",value:function(t){var e=parseFloat(t.getAttribute("default-marker-size")),i=this.ttCtx.tooltipUtil.getPathFromPoint(t,e);t.setAttribute("d",i)}},{key:"resetPointsSize",value:function(){for(var t=this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"),e=0;e<t.length;e++){var i=parseFloat(t[e].getAttribute("default-marker-size"));if(m.isNumber(i)&&i>=0){var a=this.ttCtx.tooltipUtil.getPathFromPoint(t[e],i);t[e].setAttribute("d",a)}else t[e].setAttribute("d","M0,0")}}}]),t}(),mt=function(){function t(e){i(this,t),this.w=e.w;var a=this.w;this.ttCtx=e,this.isVerticalGroupedRangeBar=!a.globals.isBarHorizontal&&"rangeBar"===a.config.chart.type&&a.config.plotOptions.bar.rangeBarGroupRows}return s(t,[{key:"getAttr",value:function(t,e){return parseFloat(t.target.getAttribute(e))}},{key:"handleHeatTreeTooltip",value:function(t){var e=t.e,i=t.opt,a=t.x,s=t.y,r=t.type,o=this.ttCtx,n=this.w;if(e.target.classList.contains("apexcharts-".concat(r,"-rect"))){var l=this.getAttr(e,"i"),h=this.getAttr(e,"j"),c=this.getAttr(e,"cx"),d=this.getAttr(e,"cy"),g=this.getAttr(e,"width"),u=this.getAttr(e,"height");if(o.tooltipLabels.drawSeriesTexts({ttItems:i.ttItems,i:l,j:h,shared:!1,e:e}),n.globals.capturedSeriesIndex=l,n.globals.capturedDataPointIndex=h,a=c+o.tooltipRect.ttWidth/2+g,s=d+o.tooltipRect.ttHeight/2-u/2,o.tooltipPosition.moveXCrosshairs(c+g/2),a>n.globals.gridWidth/2&&(a=c-o.tooltipRect.ttWidth/2+g),o.w.config.tooltip.followCursor){var f=n.globals.dom.elWrap.getBoundingClientRect();a=n.globals.clientX-f.left-(a>n.globals.gridWidth/2?o.tooltipRect.ttWidth:0),s=n.globals.clientY-f.top-(s>n.globals.gridHeight/2?o.tooltipRect.ttHeight:0)}}return{x:a,y:s}}},{key:"handleMarkerTooltip",value:function(t){var e,i,a=t.e,s=t.opt,r=t.x,o=t.y,n=this.w,l=this.ttCtx;if(a.target.classList.contains("apexcharts-marker")){var h=parseInt(s.paths.getAttribute("cx"),10),c=parseInt(s.paths.getAttribute("cy"),10),d=parseFloat(s.paths.getAttribute("val"));if(i=parseInt(s.paths.getAttribute("rel"),10),e=parseInt(s.paths.parentNode.parentNode.parentNode.getAttribute("rel"),10)-1,l.intersect){var g=m.findAncestor(s.paths,"apexcharts-series");g&&(e=parseInt(g.getAttribute("data:realIndex"),10))}if(l.tooltipLabels.drawSeriesTexts({ttItems:s.ttItems,i:e,j:i,shared:!l.showOnIntersect&&n.config.tooltip.shared,e:a}),"mouseup"===a.type&&l.markerClick(a,e,i),n.globals.capturedSeriesIndex=e,n.globals.capturedDataPointIndex=i,r=h,o=c+n.globals.translateY-1.4*l.tooltipRect.ttHeight,l.w.config.tooltip.followCursor){var u=l.getElGrid().getBoundingClientRect();o=l.e.clientY+n.globals.translateY-u.top}d<0&&(o=c),l.marker.enlargeCurrentPoint(i,s.paths,r,o)}return{x:r,y:o}}},{key:"handleBarTooltip",value:function(t){var e,i,a=t.e,s=t.opt,r=this.w,o=this.ttCtx,n=o.getElTooltip(),l=0,h=0,c=0,d=this.getBarTooltipXY({e:a,opt:s});e=d.i;var g=d.j;r.globals.capturedSeriesIndex=e,r.globals.capturedDataPointIndex=g,r.globals.isBarHorizontal&&o.tooltipUtil.hasBars()||!r.config.tooltip.shared?(h=d.x,c=d.y,i=Array.isArray(r.config.stroke.width)?r.config.stroke.width[e]:r.config.stroke.width,l=h):r.globals.comboCharts||r.config.tooltip.shared||(l/=2),isNaN(c)&&(c=r.globals.svgHeight-o.tooltipRect.ttHeight);var u=parseInt(s.paths.parentNode.getAttribute("data:realIndex"),10);if(r.globals.isMultipleYAxis?r.config.yaxis[u]&&r.config.yaxis[u].reversed:r.config.yaxis[0].reversed,h+o.tooltipRect.ttWidth>r.globals.gridWidth?h-=o.tooltipRect.ttWidth:h<0&&(h=0),o.w.config.tooltip.followCursor){var f=o.getElGrid().getBoundingClientRect();c=o.e.clientY-f.top}null===o.tooltip&&(o.tooltip=r.globals.dom.baseEl.querySelector(".apexcharts-tooltip")),r.config.tooltip.shared||(r.globals.comboBarCount>0?o.tooltipPosition.moveXCrosshairs(l+i/2):o.tooltipPosition.moveXCrosshairs(l)),!o.fixedTooltip&&(!r.config.tooltip.shared||r.globals.isBarHorizontal&&o.tooltipUtil.hasBars())&&(c=c+r.globals.translateY-o.tooltipRect.ttHeight/2,n.style.left=h+r.globals.translateX+"px",n.style.top=c+"px")}},{key:"getBarTooltipXY",value:function(t){var e=this,i=t.e,a=t.opt,s=this.w,r=null,o=this.ttCtx,n=0,l=0,h=0,c=0,d=0,g=i.target.classList;if(g.contains("apexcharts-bar-area")||g.contains("apexcharts-candlestick-area")||g.contains("apexcharts-boxPlot-area")||g.contains("apexcharts-rangebar-area")){var u=i.target,f=u.getBoundingClientRect(),p=a.elGrid.getBoundingClientRect(),x=f.height;d=f.height;var b=f.width,v=parseInt(u.getAttribute("cx"),10),m=parseInt(u.getAttribute("cy"),10);c=parseFloat(u.getAttribute("barWidth"));var y="touchmove"===i.type?i.touches[0].clientX:i.clientX;r=parseInt(u.getAttribute("j"),10),n=parseInt(u.parentNode.getAttribute("rel"),10)-1;var w=u.getAttribute("data-range-y1"),k=u.getAttribute("data-range-y2");s.globals.comboCharts&&(n=parseInt(u.parentNode.getAttribute("data:realIndex"),10));var A=function(t){return s.globals.isXNumeric?v-b/2:e.isVerticalGroupedRangeBar?v+b/2:v-o.dataPointsDividedWidth+b/2},S=function(){return m-o.dataPointsDividedHeight+x/2-o.tooltipRect.ttHeight/2};o.tooltipLabels.drawSeriesTexts({ttItems:a.ttItems,i:n,j:r,y1:w?parseInt(w,10):null,y2:k?parseInt(k,10):null,shared:!o.showOnIntersect&&s.config.tooltip.shared,e:i}),s.config.tooltip.followCursor?s.globals.isBarHorizontal?(l=y-p.left+15,h=S()):(l=A(),h=i.clientY-p.top-o.tooltipRect.ttHeight/2-15):s.globals.isBarHorizontal?((l=v)<o.xyRatios.baseLineInvertedY&&(l=v-o.tooltipRect.ttWidth),h=S()):(l=A(),h=m)}return{x:l,y:h,barHeight:d,barWidth:c,i:n,j:r}}}]),t}(),yt=function(){function t(e){i(this,t),this.w=e.w,this.ttCtx=e}return s(t,[{key:"drawXaxisTooltip",value:function(){var t=this.w,e=this.ttCtx,i="bottom"===t.config.xaxis.position;e.xaxisOffY=i?t.globals.gridHeight+1:-t.globals.xAxisHeight-t.config.xaxis.axisTicks.height+3;var a=i?"apexcharts-xaxistooltip apexcharts-xaxistooltip-bottom":"apexcharts-xaxistooltip apexcharts-xaxistooltip-top",s=t.globals.dom.elWrap;e.isXAxisTooltipEnabled&&(null===t.globals.dom.baseEl.querySelector(".apexcharts-xaxistooltip")&&(e.xaxisTooltip=document.createElement("div"),e.xaxisTooltip.setAttribute("class",a+" apexcharts-theme-"+t.config.tooltip.theme),s.appendChild(e.xaxisTooltip),e.xaxisTooltipText=document.createElement("div"),e.xaxisTooltipText.classList.add("apexcharts-xaxistooltip-text"),e.xaxisTooltipText.style.fontFamily=t.config.xaxis.tooltip.style.fontFamily||t.config.chart.fontFamily,e.xaxisTooltipText.style.fontSize=t.config.xaxis.tooltip.style.fontSize,e.xaxisTooltip.appendChild(e.xaxisTooltipText)))}},{key:"drawYaxisTooltip",value:function(){for(var t=this.w,e=this.ttCtx,i=0;i<t.config.yaxis.length;i++){var a=t.config.yaxis[i].opposite||t.config.yaxis[i].crosshairs.opposite;e.yaxisOffX=a?t.globals.gridWidth+1:1;var s="apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(i,a?" apexcharts-yaxistooltip-right":" apexcharts-yaxistooltip-left"),r=t.globals.dom.elWrap;null===t.globals.dom.baseEl.querySelector(".apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(i))&&(e.yaxisTooltip=document.createElement("div"),e.yaxisTooltip.setAttribute("class",s+" apexcharts-theme-"+t.config.tooltip.theme),r.appendChild(e.yaxisTooltip),0===i&&(e.yaxisTooltipText=[]),e.yaxisTooltipText[i]=document.createElement("div"),e.yaxisTooltipText[i].classList.add("apexcharts-yaxistooltip-text"),e.yaxisTooltip.appendChild(e.yaxisTooltipText[i]))}}},{key:"setXCrosshairWidth",value:function(){var t=this.w,e=this.ttCtx,i=e.getElXCrosshairs();if(e.xcrosshairsWidth=parseInt(t.config.xaxis.crosshairs.width,10),t.globals.comboCharts){var a=t.globals.dom.baseEl.querySelector(".apexcharts-bar-area");if(null!==a&&"barWidth"===t.config.xaxis.crosshairs.width){var s=parseFloat(a.getAttribute("barWidth"));e.xcrosshairsWidth=s}else if("tickWidth"===t.config.xaxis.crosshairs.width){var r=t.globals.labels.length;e.xcrosshairsWidth=t.globals.gridWidth/r}}else if("tickWidth"===t.config.xaxis.crosshairs.width){var o=t.globals.labels.length;e.xcrosshairsWidth=t.globals.gridWidth/o}else if("barWidth"===t.config.xaxis.crosshairs.width){var n=t.globals.dom.baseEl.querySelector(".apexcharts-bar-area");if(null!==n){var l=parseFloat(n.getAttribute("barWidth"));e.xcrosshairsWidth=l}else e.xcrosshairsWidth=1}t.globals.isBarHorizontal&&(e.xcrosshairsWidth=0),null!==i&&e.xcrosshairsWidth>0&&i.setAttribute("width",e.xcrosshairsWidth)}},{key:"handleYCrosshair",value:function(){var t=this.w,e=this.ttCtx;e.ycrosshairs=t.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs"),e.ycrosshairsHidden=t.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs-hidden")}},{key:"drawYaxisTooltipText",value:function(t,e,i){var a=this.ttCtx,s=this.w,r=s.globals,o=r.seriesYAxisMap[t];if(a.yaxisTooltips[t]&&o.length>0){var n=r.yLabelFormatters[t],l=a.getElGrid().getBoundingClientRect(),h=o[0],c=0;i.yRatio.length>1&&(c=h);var d=(e-l.top)*i.yRatio[c],g=r.maxYArr[h]-r.minYArr[h],u=r.minYArr[h]+(g-d);s.config.yaxis[t].reversed&&(u=r.maxYArr[h]-(g-d)),a.tooltipPosition.moveYCrosshairs(e-l.top),a.yaxisTooltipText[t].innerHTML=n(u),a.tooltipPosition.moveYAxisTooltip(t)}}}]),t}(),wt=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w;var a=this.w;this.tConfig=a.config.tooltip,this.tooltipUtil=new pt(this),this.tooltipLabels=new xt(this),this.tooltipPosition=new bt(this),this.marker=new vt(this),this.intersect=new mt(this),this.axesTooltip=new yt(this),this.showOnIntersect=this.tConfig.intersect,this.showTooltipTitle=this.tConfig.x.show,this.fixedTooltip=this.tConfig.fixed.enabled,this.xaxisTooltip=null,this.yaxisTTEls=null,this.isBarShared=!a.globals.isBarHorizontal&&this.tConfig.shared,this.lastHoverTime=Date.now()}return s(t,[{key:"getElTooltip",value:function(t){return t||(t=this),t.w.globals.dom.baseEl?t.w.globals.dom.baseEl.querySelector(".apexcharts-tooltip"):null}},{key:"getElXCrosshairs",value:function(){return this.w.globals.dom.baseEl.querySelector(".apexcharts-xcrosshairs")}},{key:"getElGrid",value:function(){return this.w.globals.dom.baseEl.querySelector(".apexcharts-grid")}},{key:"drawTooltip",value:function(t){var e=this.w;this.xyRatios=t,this.isXAxisTooltipEnabled=e.config.xaxis.tooltip.enabled&&e.globals.axisCharts,this.yaxisTooltips=e.config.yaxis.map((function(t,i){return!!(t.show&&t.tooltip.enabled&&e.globals.axisCharts)})),this.allTooltipSeriesGroups=[],e.globals.axisCharts||(this.showTooltipTitle=!1);var i=document.createElement("div");if(i.classList.add("apexcharts-tooltip"),e.config.tooltip.cssClass&&i.classList.add(e.config.tooltip.cssClass),i.classList.add("apexcharts-theme-".concat(this.tConfig.theme)),e.globals.dom.elWrap.appendChild(i),e.globals.axisCharts){this.axesTooltip.drawXaxisTooltip(),this.axesTooltip.drawYaxisTooltip(),this.axesTooltip.setXCrosshairWidth(),this.axesTooltip.handleYCrosshair();var a=new q(this.ctx);this.xAxisTicksPositions=a.getXAxisTicksPositions()}if(!e.globals.comboCharts&&!this.tConfig.intersect&&"rangeBar"!==e.config.chart.type||this.tConfig.shared||(this.showOnIntersect=!0),0!==e.config.markers.size&&0!==e.globals.markers.largestSize||this.marker.drawDynamicPoints(this),e.globals.collapsedSeries.length!==e.globals.series.length){this.dataPointsDividedHeight=e.globals.gridHeight/e.globals.dataPoints,this.dataPointsDividedWidth=e.globals.gridWidth/e.globals.dataPoints,this.showTooltipTitle&&(this.tooltipTitle=document.createElement("div"),this.tooltipTitle.classList.add("apexcharts-tooltip-title"),this.tooltipTitle.style.fontFamily=this.tConfig.style.fontFamily||e.config.chart.fontFamily,this.tooltipTitle.style.fontSize=this.tConfig.style.fontSize,i.appendChild(this.tooltipTitle));var s=e.globals.series.length;(e.globals.xyCharts||e.globals.comboCharts)&&this.tConfig.shared&&(s=this.showOnIntersect?1:e.globals.series.length),this.legendLabels=e.globals.dom.baseEl.querySelectorAll(".apexcharts-legend-text"),this.ttItems=this.createTTElements(s),this.addSVGEvents()}}},{key:"createTTElements",value:function(t){for(var e=this,i=this.w,a=[],s=this.getElTooltip(),r=function(r){var o=document.createElement("div");o.classList.add("apexcharts-tooltip-series-group","apexcharts-tooltip-series-group-".concat(r)),o.style.order=i.config.tooltip.inverseOrder?t-r:r+1;var n=document.createElement("span");n.classList.add("apexcharts-tooltip-marker"),n.style.backgroundColor=i.globals.colors[r],o.appendChild(n);var l=document.createElement("div");l.classList.add("apexcharts-tooltip-text"),l.style.fontFamily=e.tConfig.style.fontFamily||i.config.chart.fontFamily,l.style.fontSize=e.tConfig.style.fontSize,["y","goals","z"].forEach((function(t){var e=document.createElement("div");e.classList.add("apexcharts-tooltip-".concat(t,"-group"));var i=document.createElement("span");i.classList.add("apexcharts-tooltip-text-".concat(t,"-label")),e.appendChild(i);var a=document.createElement("span");a.classList.add("apexcharts-tooltip-text-".concat(t,"-value")),e.appendChild(a),l.appendChild(e)})),o.appendChild(l),s.appendChild(o),a.push(o)},o=0;o<t;o++)r(o);return a}},{key:"addSVGEvents",value:function(){var t=this.w,e=t.config.chart.type,i=this.getElTooltip(),a=!("bar"!==e&&"candlestick"!==e&&"boxPlot"!==e&&"rangeBar"!==e),s="area"===e||"line"===e||"scatter"===e||"bubble"===e||"radar"===e,r=t.globals.dom.Paper.node,o=this.getElGrid();o&&(this.seriesBound=o.getBoundingClientRect());var n,l=[],h=[],c={hoverArea:r,elGrid:o,tooltipEl:i,tooltipY:l,tooltipX:h,ttItems:this.ttItems};if(t.globals.axisCharts&&(s?n=t.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:longestSeries='true'] .apexcharts-marker"):a?n=t.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-bar-area, .apexcharts-series .apexcharts-candlestick-area, .apexcharts-series .apexcharts-boxPlot-area, .apexcharts-series .apexcharts-rangebar-area"):"heatmap"!==e&&"treemap"!==e||(n=t.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-heatmap, .apexcharts-series .apexcharts-treemap")),n&&n.length))for(var d=0;d<n.length;d++)l.push(n[d].getAttribute("cy")),h.push(n[d].getAttribute("cx"));if(t.globals.xyCharts&&!this.showOnIntersect||t.globals.comboCharts&&!this.showOnIntersect||a&&this.tooltipUtil.hasBars()&&this.tConfig.shared)this.addPathsEventListeners([r],c);else if(a&&!t.globals.comboCharts||s&&this.showOnIntersect)this.addDatapointEventsListeners(c);else if(!t.globals.axisCharts||"heatmap"===e||"treemap"===e){var g=t.globals.dom.baseEl.querySelectorAll(".apexcharts-series");this.addPathsEventListeners(g,c)}if(this.showOnIntersect){var u=t.globals.dom.baseEl.querySelectorAll(".apexcharts-line-series .apexcharts-marker, .apexcharts-area-series .apexcharts-marker");u.length>0&&this.addPathsEventListeners(u,c),this.tooltipUtil.hasBars()&&!this.tConfig.shared&&this.addDatapointEventsListeners(c)}}},{key:"drawFixedTooltipRect",value:function(){var t=this.w,e=this.getElTooltip(),i=e.getBoundingClientRect(),a=i.width+10,s=i.height+10,r=this.tConfig.fixed.offsetX,o=this.tConfig.fixed.offsetY,n=this.tConfig.fixed.position.toLowerCase();return n.indexOf("right")>-1&&(r=r+t.globals.svgWidth-a+10),n.indexOf("bottom")>-1&&(o=o+t.globals.svgHeight-s-10),e.style.left=r+"px",e.style.top=o+"px",{x:r,y:o,ttWidth:a,ttHeight:s}}},{key:"addDatapointEventsListeners",value:function(t){var e=this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers .apexcharts-marker, .apexcharts-bar-area, .apexcharts-candlestick-area, .apexcharts-boxPlot-area, .apexcharts-rangebar-area");this.addPathsEventListeners(e,t)}},{key:"addPathsEventListeners",value:function(t,e){for(var i=this,a=function(a){var s={paths:t[a],tooltipEl:e.tooltipEl,tooltipY:e.tooltipY,tooltipX:e.tooltipX,elGrid:e.elGrid,hoverArea:e.hoverArea,ttItems:e.ttItems};["mousemove","mouseup","touchmove","mouseout","touchend"].map((function(e){return t[a].addEventListener(e,i.onSeriesHover.bind(i,s),{capture:!1,passive:!0})}))},s=0;s<t.length;s++)a(s)}},{key:"onSeriesHover",value:function(t,e){var i=this,a=Date.now()-this.lastHoverTime;a>=100?this.seriesHover(t,e):(clearTimeout(this.seriesHoverTimeout),this.seriesHoverTimeout=setTimeout((function(){i.seriesHover(t,e)}),100-a))}},{key:"seriesHover",value:function(t,e){var i=this;this.lastHoverTime=Date.now();var a=[],s=this.w;s.config.chart.group&&(a=this.ctx.getGroupedCharts()),s.globals.axisCharts&&(s.globals.minX===-1/0&&s.globals.maxX===1/0||0===s.globals.dataPoints)||(a.length?a.forEach((function(a){var s=i.getElTooltip(a),r={paths:t.paths,tooltipEl:s,tooltipY:t.tooltipY,tooltipX:t.tooltipX,elGrid:t.elGrid,hoverArea:t.hoverArea,ttItems:a.w.globals.tooltip.ttItems};a.w.globals.minX===i.w.globals.minX&&a.w.globals.maxX===i.w.globals.maxX&&a.w.globals.tooltip.seriesHoverByContext({chartCtx:a,ttCtx:a.w.globals.tooltip,opt:r,e:e})})):this.seriesHoverByContext({chartCtx:this.ctx,ttCtx:this.w.globals.tooltip,opt:t,e:e}))}},{key:"seriesHoverByContext",value:function(t){var e=t.chartCtx,i=t.ttCtx,a=t.opt,s=t.e,r=e.w,o=this.getElTooltip(e);if(o){if(i.tooltipRect={x:0,y:0,ttWidth:o.getBoundingClientRect().width,ttHeight:o.getBoundingClientRect().height},i.e=s,i.tooltipUtil.hasBars()&&!r.globals.comboCharts&&!i.isBarShared)if(this.tConfig.onDatasetHover.highlightDataSeries)new V(e).toggleSeriesOnHover(s,s.target.parentNode);i.fixedTooltip&&i.drawFixedTooltipRect(),r.globals.axisCharts?i.axisChartsTooltips({e:s,opt:a,tooltipRect:i.tooltipRect}):i.nonAxisChartsTooltips({e:s,opt:a,tooltipRect:i.tooltipRect})}}},{key:"axisChartsTooltips",value:function(t){var e,i,a=t.e,s=t.opt,r=this.w,o=s.elGrid.getBoundingClientRect(),n="touchmove"===a.type?a.touches[0].clientX:a.clientX,l="touchmove"===a.type?a.touches[0].clientY:a.clientY;if(this.clientY=l,this.clientX=n,r.globals.capturedSeriesIndex=-1,r.globals.capturedDataPointIndex=-1,l<o.top||l>o.top+o.height)this.handleMouseOut(s);else{if(Array.isArray(this.tConfig.enabledOnSeries)&&!r.config.tooltip.shared){var h=parseInt(s.paths.getAttribute("index"),10);if(this.tConfig.enabledOnSeries.indexOf(h)<0)return void this.handleMouseOut(s)}var c=this.getElTooltip(),d=this.getElXCrosshairs(),g=[];r.config.chart.group&&(g=this.ctx.getSyncedCharts());var u=r.globals.xyCharts||"bar"===r.config.chart.type&&!r.globals.isBarHorizontal&&this.tooltipUtil.hasBars()&&this.tConfig.shared||r.globals.comboCharts&&this.tooltipUtil.hasBars();if("mousemove"===a.type||"touchmove"===a.type||"mouseup"===a.type){if(r.globals.collapsedSeries.length+r.globals.ancillaryCollapsedSeries.length===r.globals.series.length)return;null!==d&&d.classList.add("apexcharts-active");var f=this.yaxisTooltips.filter((function(t){return!0===t}));if(null!==this.ycrosshairs&&f.length&&this.ycrosshairs.classList.add("apexcharts-active"),u&&!this.showOnIntersect||g.length>1)this.handleStickyTooltip(a,n,l,s);else if("heatmap"===r.config.chart.type||"treemap"===r.config.chart.type){var p=this.intersect.handleHeatTreeTooltip({e:a,opt:s,x:e,y:i,type:r.config.chart.type});e=p.x,i=p.y,c.style.left=e+"px",c.style.top=i+"px"}else this.tooltipUtil.hasBars()&&this.intersect.handleBarTooltip({e:a,opt:s}),this.tooltipUtil.hasMarkers()&&this.intersect.handleMarkerTooltip({e:a,opt:s,x:e,y:i});if(this.yaxisTooltips.length)for(var x=0;x<r.config.yaxis.length;x++)this.axesTooltip.drawYaxisTooltipText(x,l,this.xyRatios);r.globals.dom.baseEl.classList.add("apexcharts-tooltip-active"),s.tooltipEl.classList.add("apexcharts-active")}else"mouseout"!==a.type&&"touchend"!==a.type||this.handleMouseOut(s)}}},{key:"nonAxisChartsTooltips",value:function(t){var e=t.e,i=t.opt,a=t.tooltipRect,s=this.w,r=i.paths.getAttribute("rel"),o=this.getElTooltip(),n=s.globals.dom.elWrap.getBoundingClientRect();if("mousemove"===e.type||"touchmove"===e.type){s.globals.dom.baseEl.classList.add("apexcharts-tooltip-active"),o.classList.add("apexcharts-active"),this.tooltipLabels.drawSeriesTexts({ttItems:i.ttItems,i:parseInt(r,10)-1,shared:!1});var l=s.globals.clientX-n.left-a.ttWidth/2,h=s.globals.clientY-n.top-a.ttHeight-10;if(o.style.left=l+"px",o.style.top=h+"px",s.config.legend.tooltipHoverFormatter){var c=r-1,d=(0,s.config.legend.tooltipHoverFormatter)(this.legendLabels[c].getAttribute("data:default-text"),{seriesIndex:c,dataPointIndex:c,w:s});this.legendLabels[c].innerHTML=d}}else"mouseout"!==e.type&&"touchend"!==e.type||(o.classList.remove("apexcharts-active"),s.globals.dom.baseEl.classList.remove("apexcharts-tooltip-active"),s.config.legend.tooltipHoverFormatter&&this.legendLabels.forEach((function(t){var e=t.getAttribute("data:default-text");t.innerHTML=decodeURIComponent(e)})))}},{key:"handleStickyTooltip",value:function(t,e,i,a){var s=this.w,r=this.tooltipUtil.getNearestValues({context:this,hoverArea:a.hoverArea,elGrid:a.elGrid,clientX:e,clientY:i}),o=r.j,n=r.capturedSeries;s.globals.collapsedSeriesIndices.includes(n)&&(n=null);var l=a.elGrid.getBoundingClientRect();if(r.hoverX<0||r.hoverX>l.width)this.handleMouseOut(a);else if(null!==n)this.handleStickyCapturedSeries(t,n,a,o);else if(this.tooltipUtil.isXoverlap(o)||s.globals.isBarHorizontal){var h=s.globals.series.findIndex((function(t,e){return!s.globals.collapsedSeriesIndices.includes(e)}));this.create(t,this,h,o,a.ttItems)}}},{key:"handleStickyCapturedSeries",value:function(t,e,i,a){var s=this.w;if(!this.tConfig.shared&&null===s.globals.series[e][a])return void this.handleMouseOut(i);if(void 0!==s.globals.series[e][a])this.tConfig.shared&&this.tooltipUtil.isXoverlap(a)&&this.tooltipUtil.isInitialSeriesSameLen()?this.create(t,this,e,a,i.ttItems):this.create(t,this,e,a,i.ttItems,!1);else if(this.tooltipUtil.isXoverlap(a)){var r=s.globals.series.findIndex((function(t,e){return!s.globals.collapsedSeriesIndices.includes(e)}));this.create(t,this,r,a,i.ttItems)}}},{key:"deactivateHoverFilter",value:function(){for(var t=this.w,e=new k(this.ctx),i=t.globals.dom.Paper.select(".apexcharts-bar-area"),a=0;a<i.length;a++)e.pathMouseLeave(i[a])}},{key:"handleMouseOut",value:function(t){var e=this.w,i=this.getElXCrosshairs();if(e.globals.dom.baseEl.classList.remove("apexcharts-tooltip-active"),t.tooltipEl.classList.remove("apexcharts-active"),this.deactivateHoverFilter(),"bubble"!==e.config.chart.type&&this.marker.resetPointsSize(),null!==i&&i.classList.remove("apexcharts-active"),null!==this.ycrosshairs&&this.ycrosshairs.classList.remove("apexcharts-active"),this.isXAxisTooltipEnabled&&this.xaxisTooltip.classList.remove("apexcharts-active"),this.yaxisTooltips.length){null===this.yaxisTTEls&&(this.yaxisTTEls=e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));for(var a=0;a<this.yaxisTTEls.length;a++)this.yaxisTTEls[a].classList.remove("apexcharts-active")}e.config.legend.tooltipHoverFormatter&&this.legendLabels.forEach((function(t){var e=t.getAttribute("data:default-text");t.innerHTML=decodeURIComponent(e)}))}},{key:"markerClick",value:function(t,e,i){var a=this.w;"function"==typeof a.config.chart.events.markerClick&&a.config.chart.events.markerClick(t,this.ctx,{seriesIndex:e,dataPointIndex:i,w:a}),this.ctx.events.fireEvent("markerClick",[t,this.ctx,{seriesIndex:e,dataPointIndex:i,w:a}])}},{key:"create",value:function(t,e,i,a,s){var r,o,n,l,h,c,d,u,f,p,x,b,v,m,y,w,A=arguments.length>5&&void 0!==arguments[5]?arguments[5]:null,S=this.w,C=e;"mouseup"===t.type&&this.markerClick(t,i,a),null===A&&(A=this.tConfig.shared);var L=this.tooltipUtil.hasMarkers(i),P=this.tooltipUtil.getElBars();if(S.config.legend.tooltipHoverFormatter){var M=S.config.legend.tooltipHoverFormatter,I=Array.from(this.legendLabels);I.forEach((function(t){var e=t.getAttribute("data:default-text");t.innerHTML=decodeURIComponent(e)}));for(var T=0;T<I.length;T++){var z=I[T],X=parseInt(z.getAttribute("i"),10),E=decodeURIComponent(z.getAttribute("data:default-text")),Y=M(E,{seriesIndex:A?X:i,dataPointIndex:a,w:S});if(A)z.innerHTML=S.globals.collapsedSeriesIndices.indexOf(X)<0?Y:E;else if(z.innerHTML=X===i?Y:E,i===X)break}}var R=g(g({ttItems:s,i:i,j:a},void 0!==(null===(r=S.globals.seriesRange)||void 0===r||null===(o=r[i])||void 0===o||null===(n=o[a])||void 0===n||null===(l=n.y[0])||void 0===l?void 0:l.y1)&&{y1:null===(h=S.globals.seriesRange)||void 0===h||null===(c=h[i])||void 0===c||null===(d=c[a])||void 0===d||null===(u=d.y[0])||void 0===u?void 0:u.y1}),void 0!==(null===(f=S.globals.seriesRange)||void 0===f||null===(p=f[i])||void 0===p||null===(x=p[a])||void 0===x||null===(b=x.y[0])||void 0===b?void 0:b.y2)&&{y2:null===(v=S.globals.seriesRange)||void 0===v||null===(m=v[i])||void 0===m||null===(y=m[a])||void 0===y||null===(w=y.y[0])||void 0===w?void 0:w.y2});if(A){if(C.tooltipLabels.drawSeriesTexts(g(g({},R),{},{shared:!this.showOnIntersect&&this.tConfig.shared})),L)S.globals.markers.largestSize>0?C.marker.enlargePoints(a):C.tooltipPosition.moveDynamicPointsOnHover(a);else if(this.tooltipUtil.hasBars()&&(this.barSeriesHeight=this.tooltipUtil.getBarsHeight(P),this.barSeriesHeight>0)){var F=new k(this.ctx),D=S.globals.dom.Paper.select(".apexcharts-bar-area[j='".concat(a,"']"));this.deactivateHoverFilter(),this.tooltipPosition.moveStickyTooltipOverBars(a,i);for(var H=0;H<D.length;H++)F.pathMouseEnter(D[H])}}else C.tooltipLabels.drawSeriesTexts(g({shared:!1},R)),this.tooltipUtil.hasBars()&&C.tooltipPosition.moveStickyTooltipOverBars(a,i),L&&C.tooltipPosition.moveMarkers(i,a)}}]),t}(),kt=function(){function t(e){i(this,t),this.w=e.w,this.barCtx=e,this.totalFormatter=this.w.config.plotOptions.bar.dataLabels.total.formatter,this.totalFormatter||(this.totalFormatter=this.w.config.dataLabels.formatter)}return s(t,[{key:"handleBarDataLabels",value:function(t){var e,i,a=t.x,s=t.y,r=t.y1,o=t.y2,n=t.i,l=t.j,h=t.realIndex,c=t.columnGroupIndex,d=t.series,u=t.barHeight,f=t.barWidth,p=t.barXPosition,x=t.barYPosition,b=t.visibleSeries,v=t.renderedPath,m=this.w,y=new k(this.barCtx.ctx),w=Array.isArray(this.barCtx.strokeWidth)?this.barCtx.strokeWidth[h]:this.barCtx.strokeWidth;m.globals.isXNumeric&&!m.globals.isBarHorizontal?(e=a+parseFloat(f*(b+1)),i=s+parseFloat(u*(b+1))-w):(e=a+parseFloat(f*b),i=s+parseFloat(u*b));var A,S=null,C=a,L=s,P={},M=m.config.dataLabels,I=this.barCtx.barOptions.dataLabels,T=this.barCtx.barOptions.dataLabels.total;void 0!==x&&this.barCtx.isRangeBar&&(i=x,L=x),void 0!==p&&this.barCtx.isVerticalGroupedRangeBar&&(e=p,C=p);var z=M.offsetX,X=M.offsetY,E={width:0,height:0};if(m.config.dataLabels.enabled){var Y=m.globals.series[n][l];E=y.getTextRects(m.config.dataLabels.formatter?m.config.dataLabels.formatter(Y,g(g({},m),{},{seriesIndex:n,dataPointIndex:l,w:m})):m.globals.yLabelFormatters[0](Y),parseFloat(M.style.fontSize))}var R={x:a,y:s,i:n,j:l,realIndex:h,columnGroupIndex:c,renderedPath:v,bcx:e,bcy:i,barHeight:u,barWidth:f,textRects:E,strokeWidth:w,dataLabelsX:C,dataLabelsY:L,dataLabelsConfig:M,barDataLabelsConfig:I,barTotalDataLabelsConfig:T,offX:z,offY:X};return P=this.barCtx.isHorizontal?this.calculateBarsDataLabelsPosition(R):this.calculateColumnsDataLabelsPosition(R),v.attr({cy:P.bcy,cx:P.bcx,j:l,val:m.globals.series[n][l],barHeight:u,barWidth:f}),A=this.drawCalculatedDataLabels({x:P.dataLabelsX,y:P.dataLabelsY,val:this.barCtx.isRangeBar?[r,o]:"100%"===m.config.chart.stackType?d[h][l]:m.globals.series[h][l],i:h,j:l,barWidth:f,barHeight:u,textRects:E,dataLabelsConfig:M}),m.config.chart.stacked&&T.enabled&&(S=this.drawTotalDataLabels({x:P.totalDataLabelsX,y:P.totalDataLabelsY,barWidth:f,barHeight:u,realIndex:h,textAnchor:P.totalDataLabelsAnchor,val:this.getStackedTotalDataLabel({realIndex:h,j:l}),dataLabelsConfig:M,barTotalDataLabelsConfig:T})),{dataLabels:A,totalDataLabels:S}}},{key:"getStackedTotalDataLabel",value:function(t){var e=t.realIndex,i=t.j,a=this.w,s=this.barCtx.stackedSeriesTotals[i];return this.totalFormatter&&(s=this.totalFormatter(s,g(g({},a),{},{seriesIndex:e,dataPointIndex:i,w:a}))),s}},{key:"calculateColumnsDataLabelsPosition",value:function(t){var e=this.w,i=t.i,a=t.j,s=t.realIndex;t.columnGroupIndex;var r,o,n=t.y,l=t.bcx,h=t.barWidth,c=t.barHeight,d=t.textRects,g=t.dataLabelsX,u=t.dataLabelsY,f=t.dataLabelsConfig,p=t.barDataLabelsConfig,x=t.barTotalDataLabelsConfig,b=t.strokeWidth,v=t.offX,m=t.offY,y=l;c=Math.abs(c);var w="vertical"===e.config.plotOptions.bar.dataLabels.orientation,A=this.barCtx.barHelpers.getZeroValueEncounters({i:i,j:a}).zeroEncounters;l-=b/2;var S=e.globals.gridWidth/e.globals.dataPoints;if(this.barCtx.isVerticalGroupedRangeBar?g+=h/2:(g=e.globals.isXNumeric?l-h/2+v:l-S+h/2+v,A>0&&e.config.plotOptions.bar.hideZeroBarsWhenGrouped&&(g-=h*A)),w){g=g+d.height/2-b/2-2}var C=e.globals.series[i][a]<0,L=n;switch(this.barCtx.isReversed&&(L=n+(C?c:-c)),p.position){case"center":u=w?C?L-c/2+m:L+c/2-m:C?L-c/2+d.height/2+m:L+c/2+d.height/2-m;break;case"bottom":u=w?C?L-c+m:L+c-m:C?L-c+d.height+b+m:L+c-d.height/2+b-m;break;case"top":u=w?C?L+m:L-m:C?L-d.height/2-m:L+d.height+m}if(this.barCtx.lastActiveBarSerieIndex===s&&x.enabled){var P=new k(this.barCtx.ctx).getTextRects(this.getStackedTotalDataLabel({realIndex:s,j:a}),f.fontSize);r=C?L-P.height/2-m-x.offsetY+18:L+P.height+m+x.offsetY-18;var M=S;o=y+(e.globals.isXNumeric?-h*e.globals.barGroups.length/2:e.globals.barGroups.length*h/2-(e.globals.barGroups.length-1)*h-M)+x.offsetX}return e.config.chart.stacked||(u<0?u=0+b:u+d.height/3>e.globals.gridHeight&&(u=e.globals.gridHeight-b)),{bcx:l,bcy:n,dataLabelsX:g,dataLabelsY:u,totalDataLabelsX:o,totalDataLabelsY:r,totalDataLabelsAnchor:"middle"}}},{key:"calculateBarsDataLabelsPosition",value:function(t){var e=this.w,i=t.x,a=t.i,s=t.j,r=t.realIndex,o=t.bcy,n=t.barHeight,l=t.barWidth,h=t.textRects,c=t.dataLabelsX,d=t.strokeWidth,g=t.dataLabelsConfig,u=t.barDataLabelsConfig,f=t.barTotalDataLabelsConfig,p=t.offX,x=t.offY,b=e.globals.gridHeight/e.globals.dataPoints;l=Math.abs(l);var v,m,y=o-(this.barCtx.isRangeBar?0:b)+n/2+h.height/2+x-3,w="start",A=e.globals.series[a][s]<0,S=i;switch(this.barCtx.isReversed&&(S=i+(A?-l:l),w=A?"start":"end"),u.position){case"center":c=A?S+l/2-p:Math.max(h.width/2,S-l/2)+p;break;case"bottom":c=A?S+l-d-p:S-l+d+p;break;case"top":c=A?S-d-p:S-d+p}if(this.barCtx.lastActiveBarSerieIndex===r&&f.enabled){var C=new k(this.barCtx.ctx).getTextRects(this.getStackedTotalDataLabel({realIndex:r,j:s}),g.fontSize);A?(v=S-d-p-f.offsetX,w="end"):v=S+p+f.offsetX+(this.barCtx.isReversed?-(l+d):d),m=y-h.height/2+C.height/2+f.offsetY+d}return e.config.chart.stacked||("start"===g.textAnchor?c-h.width<0?c=A?h.width+d:d:c+h.width>e.globals.gridWidth&&(c=A?e.globals.gridWidth-d:e.globals.gridWidth-h.width-d):"middle"===g.textAnchor?c-h.width/2<0?c=h.width/2+d:c+h.width/2>e.globals.gridWidth&&(c=e.globals.gridWidth-h.width/2-d):"end"===g.textAnchor&&(c<1?c=h.width+d:c+1>e.globals.gridWidth&&(c=e.globals.gridWidth-h.width-d))),{bcx:i,bcy:o,dataLabelsX:c,dataLabelsY:y,totalDataLabelsX:v,totalDataLabelsY:m,totalDataLabelsAnchor:w}}},{key:"drawCalculatedDataLabels",value:function(t){var e=t.x,i=t.y,a=t.val,s=t.i,r=t.j,o=t.textRects,n=t.barHeight,l=t.barWidth,h=t.dataLabelsConfig,c=this.w,d="rotate(0)";"vertical"===c.config.plotOptions.bar.dataLabels.orientation&&(d="rotate(-90, ".concat(e,", ").concat(i,")"));var u=new G(this.barCtx.ctx),f=new k(this.barCtx.ctx),p=h.formatter,x=null,b=c.globals.collapsedSeriesIndices.indexOf(s)>-1;if(h.enabled&&!b){x=f.group({class:"apexcharts-data-labels",transform:d});var v="";void 0!==a&&(v=p(a,g(g({},c),{},{seriesIndex:s,dataPointIndex:r,w:c}))),!a&&c.config.plotOptions.bar.hideZeroBarsWhenGrouped&&(v="");var m=c.globals.series[s][r]<0,y=c.config.plotOptions.bar.dataLabels.position;if("vertical"===c.config.plotOptions.bar.dataLabels.orientation&&("top"===y&&(h.textAnchor=m?"end":"start"),"center"===y&&(h.textAnchor="middle"),"bottom"===y&&(h.textAnchor=m?"end":"start")),this.barCtx.isRangeBar&&this.barCtx.barOptions.dataLabels.hideOverflowingLabels)l<f.getTextRects(v,parseFloat(h.style.fontSize)).width&&(v="");c.config.chart.stacked&&this.barCtx.barOptions.dataLabels.hideOverflowingLabels&&(this.barCtx.isHorizontal?o.width/1.6>Math.abs(l)&&(v=""):o.height/1.6>Math.abs(n)&&(v=""));var w=g({},h);this.barCtx.isHorizontal&&a<0&&("start"===h.textAnchor?w.textAnchor="end":"end"===h.textAnchor&&(w.textAnchor="start")),u.plotDataLabelsText({x:e,y:i,text:v,i:s,j:r,parent:x,dataLabelsConfig:w,alwaysDrawDataLabel:!0,offsetCorrection:!0})}return x}},{key:"drawTotalDataLabels",value:function(t){var e=t.x,i=t.y,a=t.val,s=t.realIndex,r=t.textAnchor,o=t.barTotalDataLabelsConfig;this.w;var n,l=new k(this.barCtx.ctx);return o.enabled&&void 0!==e&&void 0!==i&&this.barCtx.lastActiveBarSerieIndex===s&&(n=l.drawText({x:e,y:i,foreColor:o.style.color,text:a,textAnchor:r,fontFamily:o.style.fontFamily,fontSize:o.style.fontSize,fontWeight:o.style.fontWeight})),n}}]),t}(),At=function(){function t(e){i(this,t),this.w=e.w,this.barCtx=e}return s(t,[{key:"initVariables",value:function(t){var e=this.w;this.barCtx.series=t,this.barCtx.totalItems=0,this.barCtx.seriesLen=0,this.barCtx.visibleI=-1,this.barCtx.visibleItems=1;for(var i=0;i<t.length;i++)if(t[i].length>0&&(this.barCtx.seriesLen=this.barCtx.seriesLen+1,this.barCtx.totalItems+=t[i].length),e.globals.isXNumeric)for(var a=0;a<t[i].length;a++)e.globals.seriesX[i][a]>e.globals.minX&&e.globals.seriesX[i][a]<e.globals.maxX&&this.barCtx.visibleItems++;else this.barCtx.visibleItems=e.globals.dataPoints;this.arrBorderRadius=this.createBorderRadiusArr(e.globals.series),0===this.barCtx.seriesLen&&(this.barCtx.seriesLen=1),this.barCtx.zeroSerieses=[],e.globals.comboCharts||this.checkZeroSeries({series:t})}},{key:"initialPositions",value:function(){var t,e,i,a,s,r,o,n,l=this.w,h=l.globals.dataPoints;this.barCtx.isRangeBar&&(h=l.globals.labels.length);var c=this.barCtx.seriesLen;if(l.config.plotOptions.bar.rangeBarGroupRows&&(c=1),this.barCtx.isHorizontal)s=(i=l.globals.gridHeight/h)/c,l.globals.isXNumeric&&(s=(i=l.globals.gridHeight/this.barCtx.totalItems)/this.barCtx.seriesLen),s=s*parseInt(this.barCtx.barOptions.barHeight,10)/100,-1===String(this.barCtx.barOptions.barHeight).indexOf("%")&&(s=parseInt(this.barCtx.barOptions.barHeight,10)),n=this.barCtx.baseLineInvertedY+l.globals.padHorizontal+(this.barCtx.isReversed?l.globals.gridWidth:0)-(this.barCtx.isReversed?2*this.barCtx.baseLineInvertedY:0),this.barCtx.isFunnel&&(n=l.globals.gridWidth/2),e=(i-s*this.barCtx.seriesLen)/2;else{if(a=l.globals.gridWidth/this.barCtx.visibleItems,l.config.xaxis.convertedCatToNumeric&&(a=l.globals.gridWidth/l.globals.dataPoints),r=a/c*parseInt(this.barCtx.barOptions.columnWidth,10)/100,l.globals.isXNumeric){var d=this.barCtx.xRatio;l.globals.minXDiff&&.5!==l.globals.minXDiff&&l.globals.minXDiff/d>0&&(a=l.globals.minXDiff/d),(r=a/c*parseInt(this.barCtx.barOptions.columnWidth,10)/100)<1&&(r=1)}-1===String(this.barCtx.barOptions.columnWidth).indexOf("%")&&(r=parseInt(this.barCtx.barOptions.columnWidth,10)),o=l.globals.gridHeight-this.barCtx.baseLineY[this.barCtx.translationsIndex]-(this.barCtx.isReversed?l.globals.gridHeight:0)+(this.barCtx.isReversed?2*this.barCtx.baseLineY[this.barCtx.translationsIndex]:0),t=l.globals.padHorizontal+(a-r*this.barCtx.seriesLen)/2}return l.globals.barHeight=s,l.globals.barWidth=r,{x:t,y:e,yDivision:i,xDivision:a,barHeight:s,barWidth:r,zeroH:o,zeroW:n}}},{key:"initializeStackedPrevVars",value:function(t){t.w.globals.seriesGroups.forEach((function(e){t[e]||(t[e]={}),t[e].prevY=[],t[e].prevX=[],t[e].prevYF=[],t[e].prevXF=[],t[e].prevYVal=[],t[e].prevXVal=[]}))}},{key:"initializeStackedXYVars",value:function(t){t.w.globals.seriesGroups.forEach((function(e){t[e]||(t[e]={}),t[e].xArrj=[],t[e].xArrjF=[],t[e].xArrjVal=[],t[e].yArrj=[],t[e].yArrjF=[],t[e].yArrjVal=[]}))}},{key:"getPathFillColor",value:function(t,e,i,a){var s,r,o,n,l,h=this.w,c=this.barCtx.ctx.fill,d=null,g=this.barCtx.barOptions.distributed?i:e;this.barCtx.barOptions.colors.ranges.length>0&&this.barCtx.barOptions.colors.ranges.map((function(a){t[e][i]>=a.from&&t[e][i]<=a.to&&(d=a.color)}));return null!==(s=h.config.series[e].data[i])&&void 0!==s&&s.fillColor&&(d=h.config.series[e].data[i].fillColor),c.fillPath({seriesNumber:this.barCtx.barOptions.distributed?g:a,dataPointIndex:i,color:d,value:t[e][i],fillConfig:null===(r=h.config.series[e].data[i])||void 0===r?void 0:r.fill,fillType:null!==(o=h.config.series[e].data[i])&&void 0!==o&&null!==(n=o.fill)&&void 0!==n&&n.type?null===(l=h.config.series[e].data[i])||void 0===l?void 0:l.fill.type:Array.isArray(h.config.fill.type)?h.config.fill.type[a]:h.config.fill.type})}},{key:"getStrokeWidth",value:function(t,e,i){var a=0,s=this.w;return this.barCtx.series[t][e]?this.barCtx.isNullValue=!1:this.barCtx.isNullValue=!0,s.config.stroke.show&&(this.barCtx.isNullValue||(a=Array.isArray(this.barCtx.strokeWidth)?this.barCtx.strokeWidth[i]:this.barCtx.strokeWidth)),a}},{key:"createBorderRadiusArr",value:function(t){var e=this.w,i=!this.w.config.chart.stacked||"last"!==e.config.plotOptions.bar.borderRadiusWhenStacked||e.config.plotOptions.bar.borderRadius<=0,a=t.length,s=t[0].length,o=Array.from({length:a},(function(){return Array(s).fill(i?"top":"none")}));if(i)return o;for(var n=0;n<s;n++){for(var l=[],h=[],c=0,d=0;d<a;d++){var g=t[d][n];g>0?(l.push(d),c++):g<0&&(h.push(d),c++)}if(l.length>0&&0===h.length)if(1===l.length)o[l[0]][n]="both";else{var u,f=l[0],p=l[l.length-1],x=r(l);try{for(x.s();!(u=x.n()).done;){var b=u.value;o[b][n]=b===f?"bottom":b===p?"top":"none"}}catch(t){x.e(t)}finally{x.f()}}else if(h.length>0&&0===l.length)if(1===h.length)o[h[0]][n]="both";else{var v,m=h[0],y=h[h.length-1],w=r(h);try{for(w.s();!(v=w.n()).done;){var k=v.value;o[k][n]=k===m?"bottom":k===y?"top":"none"}}catch(t){w.e(t)}finally{w.f()}}else if(l.length>0&&h.length>0){var A,S=l[l.length-1],C=r(l);try{for(C.s();!(A=C.n()).done;){var L=A.value;o[L][n]=L===S?"top":"none"}}catch(t){C.e(t)}finally{C.f()}var P,M=h[h.length-1],I=r(h);try{for(I.s();!(P=I.n()).done;){var T=P.value;o[T][n]=T===M?"bottom":"none"}}catch(t){I.e(t)}finally{I.f()}}else if(1===c){o[l[0]||h[0]][n]="both"}}return o}},{key:"barBackground",value:function(t){var e=t.j,i=t.i,a=t.x1,s=t.x2,r=t.y1,o=t.y2,n=t.elSeries,l=this.w,h=new k(this.barCtx.ctx),c=new V(this.barCtx.ctx).getActiveConfigSeriesIndex();if(this.barCtx.barOptions.colors.backgroundBarColors.length>0&&c===i){e>=this.barCtx.barOptions.colors.backgroundBarColors.length&&(e%=this.barCtx.barOptions.colors.backgroundBarColors.length);var d=this.barCtx.barOptions.colors.backgroundBarColors[e],g=h.drawRect(void 0!==a?a:0,void 0!==r?r:0,void 0!==s?s:l.globals.gridWidth,void 0!==o?o:l.globals.gridHeight,this.barCtx.barOptions.colors.backgroundBarRadius,d,this.barCtx.barOptions.colors.backgroundBarOpacity);n.add(g),g.node.classList.add("apexcharts-backgroundBar")}}},{key:"getColumnPaths",value:function(t){var e,i=t.barWidth,a=t.barXPosition,s=t.y1,r=t.y2,o=t.strokeWidth,n=t.isReversed,l=t.series,h=t.seriesGroup,c=t.realIndex,d=t.i,g=t.j,u=t.w,f=new k(this.barCtx.ctx);(o=Array.isArray(o)?o[c]:o)||(o=0);var p=i,x=a;null!==(e=u.config.series[c].data[g])&&void 0!==e&&e.columnWidthOffset&&(x=a-u.config.series[c].data[g].columnWidthOffset/2,p=i+u.config.series[c].data[g].columnWidthOffset);var b=o/2,v=x+b,m=x+p-b,y=(l[d][g]>=0?1:-1)*(n?-1:1);s+=.001-b*y,r+=.001+b*y;var w=f.move(v,s),A=f.move(v,s),S=f.line(m,s);if(u.globals.previousPaths.length>0&&(A=this.barCtx.getPreviousPath(c,g,!1)),w=w+f.line(v,r)+f.line(m,r)+S+("around"===u.config.plotOptions.bar.borderRadiusApplication||"both"===this.arrBorderRadius[c][g]?" Z":" z"),A=A+f.line(v,s)+S+S+S+S+S+f.line(v,s)+("around"===u.config.plotOptions.bar.borderRadiusApplication||"both"===this.arrBorderRadius[c][g]?" Z":" z"),"none"!==this.arrBorderRadius[c][g]&&(w=f.roundPathCorners(w,u.config.plotOptions.bar.borderRadius)),u.config.chart.stacked){var C=this.barCtx;(C=this.barCtx[h]).yArrj.push(r-b*y),C.yArrjF.push(Math.abs(s-r+o*y)),C.yArrjVal.push(this.barCtx.series[d][g])}return{pathTo:w,pathFrom:A}}},{key:"getBarpaths",value:function(t){var e,i=t.barYPosition,a=t.barHeight,s=t.x1,r=t.x2,o=t.strokeWidth,n=t.isReversed,l=t.series,h=t.seriesGroup,c=t.realIndex,d=t.i,g=t.j,u=t.w,f=new k(this.barCtx.ctx);(o=Array.isArray(o)?o[c]:o)||(o=0);var p=i,x=a;null!==(e=u.config.series[c].data[g])&&void 0!==e&&e.barHeightOffset&&(p=i-u.config.series[c].data[g].barHeightOffset/2,x=a+u.config.series[c].data[g].barHeightOffset);var b=o/2,v=p+b,m=p+x-b,y=(l[d][g]>=0?1:-1)*(n?-1:1);s+=.001+b*y,r+=.001-b*y;var w=f.move(s,v),A=f.move(s,v);u.globals.previousPaths.length>0&&(A=this.barCtx.getPreviousPath(c,g,!1));var S=f.line(s,m);if(w=w+f.line(r,v)+f.line(r,m)+S+("around"===u.config.plotOptions.bar.borderRadiusApplication||"both"===this.arrBorderRadius[c][g]?" Z":" z"),A=A+f.line(s,v)+S+S+S+S+S+f.line(s,v)+("around"===u.config.plotOptions.bar.borderRadiusApplication||"both"===this.arrBorderRadius[c][g]?" Z":" z"),"none"!==this.arrBorderRadius[c][g]&&(w=f.roundPathCorners(w,u.config.plotOptions.bar.borderRadius)),u.config.chart.stacked){var C=this.barCtx;(C=this.barCtx[h]).xArrj.push(r+b*y),C.xArrjF.push(Math.abs(s-r-o*y)),C.xArrjVal.push(this.barCtx.series[d][g])}return{pathTo:w,pathFrom:A}}},{key:"checkZeroSeries",value:function(t){for(var e=t.series,i=this.w,a=0;a<e.length;a++){for(var s=0,r=0;r<e[i.globals.maxValsInArrayIndex].length;r++)s+=e[a][r];0===s&&this.barCtx.zeroSerieses.push(a)}}},{key:"getXForValue",value:function(t,e){var i=!(arguments.length>2&&void 0!==arguments[2])||arguments[2]?e:null;return null!=t&&(i=e+t/this.barCtx.invertedYRatio-2*(this.barCtx.isReversed?t/this.barCtx.invertedYRatio:0)),i}},{key:"getYForValue",value:function(t,e,i){var a=!(arguments.length>3&&void 0!==arguments[3])||arguments[3]?e:null;return null!=t&&(a=e-t/this.barCtx.yRatio[i]+2*(this.barCtx.isReversed?t/this.barCtx.yRatio[i]:0)),a}},{key:"getGoalValues",value:function(t,e,i,a,s,r){var o=this,l=this.w,h=[],c=function(a,s){var l;h.push((n(l={},t,"x"===t?o.getXForValue(a,e,!1):o.getYForValue(a,i,r,!1)),n(l,"attrs",s),l))};if(l.globals.seriesGoals[a]&&l.globals.seriesGoals[a][s]&&Array.isArray(l.globals.seriesGoals[a][s])&&l.globals.seriesGoals[a][s].forEach((function(t){c(t.value,t)})),this.barCtx.barOptions.isDumbbell&&l.globals.seriesRange.length){var d=this.barCtx.barOptions.dumbbellColors?this.barCtx.barOptions.dumbbellColors:l.globals.colors,u={strokeHeight:"x"===t?0:l.globals.markers.size[a],strokeWidth:"x"===t?l.globals.markers.size[a]:0,strokeDashArray:0,strokeLineCap:"round",strokeColor:Array.isArray(d[a])?d[a][0]:d[a]};c(l.globals.seriesRangeStart[a][s],u),c(l.globals.seriesRangeEnd[a][s],g(g({},u),{},{strokeColor:Array.isArray(d[a])?d[a][1]:d[a]}))}return h}},{key:"drawGoalLine",value:function(t){var e=t.barXPosition,i=t.barYPosition,a=t.goalX,s=t.goalY,r=t.barWidth,o=t.barHeight,n=new k(this.barCtx.ctx),l=n.group({className:"apexcharts-bar-goals-groups"});l.node.classList.add("apexcharts-element-hidden"),this.barCtx.w.globals.delayedElements.push({el:l.node}),l.attr("clip-path","url(#gridRectMarkerMask".concat(this.barCtx.w.globals.cuid,")"));var h=null;return this.barCtx.isHorizontal?Array.isArray(a)&&a.forEach((function(t){if(t.x>=-1&&t.x<=n.w.globals.gridWidth+1){var e=void 0!==t.attrs.strokeHeight?t.attrs.strokeHeight:o/2,a=i+e+o/2;h=n.drawLine(t.x,a-2*e,t.x,a,t.attrs.strokeColor?t.attrs.strokeColor:void 0,t.attrs.strokeDashArray,t.attrs.strokeWidth?t.attrs.strokeWidth:2,t.attrs.strokeLineCap),l.add(h)}})):Array.isArray(s)&&s.forEach((function(t){if(t.y>=-1&&t.y<=n.w.globals.gridHeight+1){var i=void 0!==t.attrs.strokeWidth?t.attrs.strokeWidth:r/2,a=e+i+r/2;h=n.drawLine(a-2*i,t.y,a,t.y,t.attrs.strokeColor?t.attrs.strokeColor:void 0,t.attrs.strokeDashArray,t.attrs.strokeHeight?t.attrs.strokeHeight:2,t.attrs.strokeLineCap),l.add(h)}})),l}},{key:"drawBarShadow",value:function(t){var e=t.prevPaths,i=t.currPaths,a=t.color,s=this.w,r=e.x,o=e.x1,n=e.barYPosition,l=i.x,h=i.x1,c=i.barYPosition,d=n+i.barHeight,g=new k(this.barCtx.ctx),u=new m,f=g.move(o,d)+g.line(r,d)+g.line(l,c)+g.line(h,c)+g.line(o,d)+("around"===s.config.plotOptions.bar.borderRadiusApplication||"both"===this.arrBorderRadius[realIndex][j]?" Z":" z");return g.drawPath({d:f,fill:u.shadeColor(.5,m.rgb2hex(a)),stroke:"none",strokeWidth:0,fillOpacity:1,classes:"apexcharts-bar-shadows"})}},{key:"getZeroValueEncounters",value:function(t){var e,i=t.i,a=t.j,s=this.w,r=0,o=0;return(s.config.plotOptions.bar.horizontal?s.globals.series.map((function(t,e){return e})):(null===(e=s.globals.columnSeries)||void 0===e?void 0:e.i.map((function(t){return t})))||[]).forEach((function(t){var e=s.globals.seriesPercent[t][a];e&&r++,t<i&&0===e&&o++})),{nonZeroColumns:r,zeroEncounters:o}}},{key:"getGroupIndex",value:function(t){var e=this.w,i=e.globals.seriesGroups.findIndex((function(i){return i.indexOf(e.globals.seriesNames[t])>-1})),a=this.barCtx.columnGroupIndices,s=a.indexOf(i);return s<0&&(a.push(i),s=a.length-1),{groupIndex:i,columnGroupIndex:s}}}]),t}(),St=function(){function t(e,a){i(this,t),this.ctx=e,this.w=e.w;var s=this.w;this.barOptions=s.config.plotOptions.bar,this.isHorizontal=this.barOptions.horizontal,this.strokeWidth=s.config.stroke.width,this.isNullValue=!1,this.isRangeBar=s.globals.seriesRange.length&&this.isHorizontal,this.isVerticalGroupedRangeBar=!s.globals.isBarHorizontal&&s.globals.seriesRange.length&&s.config.plotOptions.bar.rangeBarGroupRows,this.isFunnel=this.barOptions.isFunnel,this.xyRatios=a,null!==this.xyRatios&&(this.xRatio=a.xRatio,this.yRatio=a.yRatio,this.invertedXRatio=a.invertedXRatio,this.invertedYRatio=a.invertedYRatio,this.baseLineY=a.baseLineY,this.baseLineInvertedY=a.baseLineInvertedY),this.yaxisIndex=0,this.translationsIndex=0,this.seriesLen=0,this.pathArr=[];var r=new V(this.ctx);this.lastActiveBarSerieIndex=r.getActiveConfigSeriesIndex("desc",["bar","column"]),this.columnGroupIndices=[];var o=r.getBarSeriesIndices(),n=new A(this.ctx);this.stackedSeriesTotals=n.getStackedSeriesTotals(this.w.config.series.map((function(t,e){return-1===o.indexOf(e)?e:-1})).filter((function(t){return-1!==t}))),this.barHelpers=new At(this)}return s(t,[{key:"draw",value:function(t,e){var i=this.w,a=new k(this.ctx),s=new A(this.ctx,i);t=s.getLogSeries(t),this.series=t,this.yRatio=s.getLogYRatios(this.yRatio),this.barHelpers.initVariables(t);var r=a.group({class:"apexcharts-bar-series apexcharts-plot-series"});i.config.dataLabels.enabled&&this.totalItems>this.barOptions.dataLabels.maxItems&&console.warn("WARNING: DataLabels are enabled but there are too many to display. This may cause performance issue when rendering - ApexCharts");for(var o=0,n=0;o<t.length;o++,n++){var l,h,c,d,u=void 0,f=void 0,p=[],x=[],b=i.globals.comboCharts?e[o]:o,v=this.barHelpers.getGroupIndex(b).columnGroupIndex,y=a.group({class:"apexcharts-series",rel:o+1,seriesName:m.escapeString(i.globals.seriesNames[b]),"data:realIndex":b});this.ctx.series.addCollapsedClassToSeries(y,b),t[o].length>0&&(this.visibleI=this.visibleI+1);var w=0,S=0;this.yRatio.length>1&&(this.yaxisIndex=i.globals.seriesYAxisReverseMap[b],this.translationsIndex=b);var C=this.translationsIndex;this.isReversed=i.config.yaxis[this.yaxisIndex]&&i.config.yaxis[this.yaxisIndex].reversed;var L=this.barHelpers.initialPositions();f=L.y,w=L.barHeight,h=L.yDivision,d=L.zeroW,u=L.x,S=L.barWidth,l=L.xDivision,c=L.zeroH,this.horizontal||x.push(u+S/2);var P=a.group({class:"apexcharts-datalabels","data:realIndex":b});i.globals.delayedElements.push({el:P.node}),P.node.classList.add("apexcharts-element-hidden");var M=a.group({class:"apexcharts-bar-goals-markers"}),I=a.group({class:"apexcharts-bar-shadows"});i.globals.delayedElements.push({el:I.node}),I.node.classList.add("apexcharts-element-hidden");for(var T=0;T<t[o].length;T++){var z=this.barHelpers.getStrokeWidth(o,T,b),X=null,E={indexes:{i:o,j:T,realIndex:b,translationsIndex:C,bc:n},x:u,y:f,strokeWidth:z,elSeries:y};this.isHorizontal?(X=this.drawBarPaths(g(g({},E),{},{barHeight:w,zeroW:d,yDivision:h})),S=this.series[o][T]/this.invertedYRatio):(X=this.drawColumnPaths(g(g({},E),{},{xDivision:l,barWidth:S,zeroH:c})),w=this.series[o][T]/this.yRatio[C]);var Y=this.barHelpers.getPathFillColor(t,o,T,b);if(this.isFunnel&&this.barOptions.isFunnel3d&&this.pathArr.length&&T>0){var R=this.barHelpers.drawBarShadow({color:"string"==typeof Y&&-1===(null==Y?void 0:Y.indexOf("url"))?Y:m.hexToRgba(i.globals.colors[o]),prevPaths:this.pathArr[this.pathArr.length-1],currPaths:X});R&&I.add(R)}this.pathArr.push(X);var F=this.barHelpers.drawGoalLine({barXPosition:X.barXPosition,barYPosition:X.barYPosition,goalX:X.goalX,goalY:X.goalY,barHeight:w,barWidth:S});F&&M.add(F),f=X.y,u=X.x,T>0&&x.push(u+S/2),p.push(f),this.renderSeries({realIndex:b,pathFill:Y,j:T,i:o,columnGroupIndex:v,pathFrom:X.pathFrom,pathTo:X.pathTo,strokeWidth:z,elSeries:y,x:u,y:f,series:t,barHeight:Math.abs(X.barHeight?X.barHeight:w),barWidth:Math.abs(X.barWidth?X.barWidth:S),elDataLabelsWrap:P,elGoalsMarkers:M,elBarShadows:I,visibleSeries:this.visibleI,type:"bar"})}i.globals.seriesXvalues[b]=x,i.globals.seriesYvalues[b]=p,r.add(y)}return r}},{key:"renderSeries",value:function(t){var e=t.realIndex,i=t.pathFill,a=t.lineFill,s=t.j,r=t.i,o=t.columnGroupIndex,n=t.pathFrom,l=t.pathTo,h=t.strokeWidth,c=t.elSeries,d=t.x,g=t.y,u=t.y1,f=t.y2,p=t.series,x=t.barHeight,b=t.barWidth,v=t.barXPosition,m=t.barYPosition,y=t.elDataLabelsWrap,A=t.elGoalsMarkers,S=t.elBarShadows,C=t.visibleSeries,L=t.type,P=t.classes,M=this.w,I=new k(this.ctx);if(!a){var T="function"==typeof M.globals.stroke.colors[e]?function(t){var e,i=M.config.stroke.colors;return Array.isArray(i)&&i.length>0&&((e=i[t])||(e=""),"function"==typeof e)?e({value:M.globals.series[t][s],dataPointIndex:s,w:M}):e}(e):M.globals.stroke.colors[e];a=this.barOptions.distributed?M.globals.stroke.colors[s]:T}M.config.series[r].data[s]&&M.config.series[r].data[s].strokeColor&&(a=M.config.series[r].data[s].strokeColor),this.isNullValue&&(i="none");var z=s/M.config.chart.animations.animateGradually.delay*(M.config.chart.animations.speed/M.globals.dataPoints)/2.4,X=I.renderPaths({i:r,j:s,realIndex:e,pathFrom:n,pathTo:l,stroke:a,strokeWidth:h,strokeLineCap:M.config.stroke.lineCap,fill:i,animationDelay:z,initialSpeed:M.config.chart.animations.speed,dataChangeSpeed:M.config.chart.animations.dynamicAnimation.speed,className:"apexcharts-".concat(L,"-area ").concat(P),chartType:L});X.attr("clip-path","url(#gridRectBarMask".concat(M.globals.cuid,")"));var E=M.config.forecastDataPoints;E.count>0&&s>=M.globals.dataPoints-E.count&&(X.node.setAttribute("stroke-dasharray",E.dashArray),X.node.setAttribute("stroke-width",E.strokeWidth),X.node.setAttribute("fill-opacity",E.fillOpacity)),void 0!==u&&void 0!==f&&(X.attr("data-range-y1",u),X.attr("data-range-y2",f)),new w(this.ctx).setSelectionFilter(X,e,s),c.add(X);var Y=new kt(this).handleBarDataLabels({x:d,y:g,y1:u,y2:f,i:r,j:s,series:p,realIndex:e,columnGroupIndex:o,barHeight:x,barWidth:b,barXPosition:v,barYPosition:m,renderedPath:X,visibleSeries:C});return null!==Y.dataLabels&&y.add(Y.dataLabels),Y.totalDataLabels&&y.add(Y.totalDataLabels),c.add(y),A&&c.add(A),S&&c.add(S),c}},{key:"drawBarPaths",value:function(t){var e,i=t.indexes,a=t.barHeight,s=t.strokeWidth,r=t.zeroW,o=t.x,n=t.y,l=t.yDivision,h=t.elSeries,c=this.w,d=i.i,g=i.j;if(c.globals.isXNumeric)e=(n=(c.globals.seriesX[d][g]-c.globals.minX)/this.invertedXRatio-a)+a*this.visibleI;else if(c.config.plotOptions.bar.hideZeroBarsWhenGrouped){var u=0,f=0;c.globals.seriesPercent.forEach((function(t,e){t[g]&&u++,e<d&&0===t[g]&&f++})),u>0&&(a=this.seriesLen*a/u),e=n+a*this.visibleI,e-=a*f}else e=n+a*this.visibleI;this.isFunnel&&(r-=(this.barHelpers.getXForValue(this.series[d][g],r)-r)/2),o=this.barHelpers.getXForValue(this.series[d][g],r);var p=this.barHelpers.getBarpaths({barYPosition:e,barHeight:a,x1:r,x2:o,strokeWidth:s,isReversed:this.isReversed,series:this.series,realIndex:i.realIndex,i:d,j:g,w:c});return c.globals.isXNumeric||(n+=l),this.barHelpers.barBackground({j:g,i:d,y1:e-a*this.visibleI,y2:a*this.seriesLen,elSeries:h}),{pathTo:p.pathTo,pathFrom:p.pathFrom,x1:r,x:o,y:n,goalX:this.barHelpers.getGoalValues("x",r,null,d,g),barYPosition:e,barHeight:a}}},{key:"drawColumnPaths",value:function(t){var e,i=t.indexes,a=t.x,s=t.y,r=t.xDivision,o=t.barWidth,n=t.zeroH,l=t.strokeWidth,h=t.elSeries,c=this.w,d=i.realIndex,g=i.translationsIndex,u=i.i,f=i.j,p=i.bc;if(c.globals.isXNumeric){var x=this.getBarXForNumericXAxis({x:a,j:f,realIndex:d,barWidth:o});a=x.x,e=x.barXPosition}else if(c.config.plotOptions.bar.hideZeroBarsWhenGrouped){var b=this.barHelpers.getZeroValueEncounters({i:u,j:f}),v=b.nonZeroColumns,m=b.zeroEncounters;v>0&&(o=this.seriesLen*o/v),e=a+o*this.visibleI,e-=o*m}else e=a+o*this.visibleI;s=this.barHelpers.getYForValue(this.series[u][f],n,g);var y=this.barHelpers.getColumnPaths({barXPosition:e,barWidth:o,y1:n,y2:s,strokeWidth:l,isReversed:this.isReversed,series:this.series,realIndex:d,i:u,j:f,w:c});return c.globals.isXNumeric||(a+=r),this.barHelpers.barBackground({bc:p,j:f,i:u,x1:e-l/2-o*this.visibleI,x2:o*this.seriesLen+l/2,elSeries:h}),{pathTo:y.pathTo,pathFrom:y.pathFrom,x:a,y:s,goalY:this.barHelpers.getGoalValues("y",null,n,u,f,g),barXPosition:e,barWidth:o}}},{key:"getBarXForNumericXAxis",value:function(t){var e=t.x,i=t.barWidth,a=t.realIndex,s=t.j,r=this.w,o=a;return r.globals.seriesX[a].length||(o=r.globals.maxValsInArrayIndex),r.globals.seriesX[o][s]&&(e=(r.globals.seriesX[o][s]-r.globals.minX)/this.xRatio-i*this.seriesLen/2),{barXPosition:e+i*this.visibleI,x:e}}},{key:"getPreviousPath",value:function(t,e){for(var i,a=this.w,s=0;s<a.globals.previousPaths.length;s++){var r=a.globals.previousPaths[s];r.paths&&r.paths.length>0&&parseInt(r.realIndex,10)===parseInt(t,10)&&void 0!==a.globals.previousPaths[s].paths[e]&&(i=a.globals.previousPaths[s].paths[e].d)}return i}}]),t}(),Ct=function(t){h(a,t);var e=o(a);function a(){return i(this,a),e.apply(this,arguments)}return s(a,[{key:"draw",value:function(t,e){var i=this,a=this.w;this.graphics=new k(this.ctx),this.bar=new St(this.ctx,this.xyRatios);var s=new A(this.ctx,a);t=s.getLogSeries(t),this.yRatio=s.getLogYRatios(this.yRatio),this.barHelpers.initVariables(t),"100%"===a.config.chart.stackType&&(t=a.globals.comboCharts?e.map((function(t){return a.globals.seriesPercent[t]})):a.globals.seriesPercent.slice()),this.series=t,this.barHelpers.initializeStackedPrevVars(this);for(var r=this.graphics.group({class:"apexcharts-bar-series apexcharts-plot-series"}),o=0,n=0,l=function(s,l){var h=void 0,c=void 0,d=void 0,u=void 0,f=a.globals.comboCharts?e[s]:s,p=i.barHelpers.getGroupIndex(f),x=p.groupIndex,b=p.columnGroupIndex;i.groupCtx=i[a.globals.seriesGroups[x]];var v=[],y=[],w=0;i.yRatio.length>1&&(i.yaxisIndex=a.globals.seriesYAxisReverseMap[f][0],w=f),i.isReversed=a.config.yaxis[i.yaxisIndex]&&a.config.yaxis[i.yaxisIndex].reversed;var k=i.graphics.group({class:"apexcharts-series",seriesName:m.escapeString(a.globals.seriesNames[f]),rel:s+1,"data:realIndex":f});i.ctx.series.addCollapsedClassToSeries(k,f);var A=i.graphics.group({class:"apexcharts-datalabels","data:realIndex":f}),S=i.graphics.group({class:"apexcharts-bar-goals-markers"}),C=0,L=0,P=i.initialPositions(o,n,h,c,d,u,w);n=P.y,C=P.barHeight,c=P.yDivision,u=P.zeroW,o=P.x,L=P.barWidth,h=P.xDivision,d=P.zeroH,a.globals.barHeight=C,a.globals.barWidth=L,i.barHelpers.initializeStackedXYVars(i),1===i.groupCtx.prevY.length&&i.groupCtx.prevY[0].every((function(t){return isNaN(t)}))&&(i.groupCtx.prevY[0]=i.groupCtx.prevY[0].map((function(){return d})),i.groupCtx.prevYF[0]=i.groupCtx.prevYF[0].map((function(){return 0})));for(var M=0;M<a.globals.dataPoints;M++){var I=i.barHelpers.getStrokeWidth(s,M,f),T={indexes:{i:s,j:M,realIndex:f,translationsIndex:w,bc:l},strokeWidth:I,x:o,y:n,elSeries:k,columnGroupIndex:b,seriesGroup:a.globals.seriesGroups[x]},z=null;i.isHorizontal?(z=i.drawStackedBarPaths(g(g({},T),{},{zeroW:u,barHeight:C,yDivision:c})),L=i.series[s][M]/i.invertedYRatio):(z=i.drawStackedColumnPaths(g(g({},T),{},{xDivision:h,barWidth:L,zeroH:d})),C=i.series[s][M]/i.yRatio[w]);var X=i.barHelpers.drawGoalLine({barXPosition:z.barXPosition,barYPosition:z.barYPosition,goalX:z.goalX,goalY:z.goalY,barHeight:C,barWidth:L});X&&S.add(X),n=z.y,o=z.x,v.push(o),y.push(n);var E=i.barHelpers.getPathFillColor(t,s,M,f),Y="";a.globals.isBarHorizontal?"bottom"===i.barHelpers.arrBorderRadius[f][M]&&a.globals.series[f][M]>0&&(Y="apexcharts-flip-x"):"bottom"===i.barHelpers.arrBorderRadius[f][M]&&a.globals.series[f][M]>0&&(Y="apexcharts-flip-y"),k=i.renderSeries({realIndex:f,pathFill:E,j:M,i:s,columnGroupIndex:b,pathFrom:z.pathFrom,pathTo:z.pathTo,strokeWidth:I,elSeries:k,x:o,y:n,series:t,barHeight:C,barWidth:L,elDataLabelsWrap:A,elGoalsMarkers:S,type:"bar",visibleSeries:b,classes:Y})}a.globals.seriesXvalues[f]=v,a.globals.seriesYvalues[f]=y,i.groupCtx.prevY.push(i.groupCtx.yArrj),i.groupCtx.prevYF.push(i.groupCtx.yArrjF),i.groupCtx.prevYVal.push(i.groupCtx.yArrjVal),i.groupCtx.prevX.push(i.groupCtx.xArrj),i.groupCtx.prevXF.push(i.groupCtx.xArrjF),i.groupCtx.prevXVal.push(i.groupCtx.xArrjVal),r.add(k)},h=0,c=0;h<t.length;h++,c++)l(h,c);return r}},{key:"initialPositions",value:function(t,e,i,a,s,r,o){var n,l,h=this.w;if(this.isHorizontal){a=h.globals.gridHeight/h.globals.dataPoints;var c=h.config.plotOptions.bar.barHeight;n=-1===String(c).indexOf("%")?parseInt(c,10):a*parseInt(c,10)/100,r=h.globals.padHorizontal+(this.isReversed?h.globals.gridWidth-this.baseLineInvertedY:this.baseLineInvertedY),e=(a-n)/2}else{l=i=h.globals.gridWidth/h.globals.dataPoints;var d=h.config.plotOptions.bar.columnWidth;h.globals.isXNumeric&&h.globals.dataPoints>1?l=(i=h.globals.minXDiff/this.xRatio)*parseInt(this.barOptions.columnWidth,10)/100:-1===String(d).indexOf("%")?l=parseInt(d,10):l*=parseInt(d,10)/100,s=this.isReversed?this.baseLineY[o]:h.globals.gridHeight-this.baseLineY[o],t=h.globals.padHorizontal+(i-l)/2}var g=h.globals.barGroups.length||1;return{x:t,y:e,yDivision:a,xDivision:i,barHeight:n/g,barWidth:l/g,zeroH:s,zeroW:r}}},{key:"drawStackedBarPaths",value:function(t){for(var e,i=t.indexes,a=t.barHeight,s=t.strokeWidth,r=t.zeroW,o=t.x,n=t.y,l=t.columnGroupIndex,h=t.seriesGroup,c=t.yDivision,d=t.elSeries,g=this.w,u=n+l*a,f=i.i,p=i.j,x=i.realIndex,b=i.translationsIndex,v=0,m=0;m<this.groupCtx.prevXF.length;m++)v+=this.groupCtx.prevXF[m][p];var y;if((y=h.indexOf(g.config.series[x].name))>0){var w=r;this.groupCtx.prevXVal[y-1][p]<0?w=this.series[f][p]>=0?this.groupCtx.prevX[y-1][p]+v-2*(this.isReversed?v:0):this.groupCtx.prevX[y-1][p]:this.groupCtx.prevXVal[y-1][p]>=0&&(w=this.series[f][p]>=0?this.groupCtx.prevX[y-1][p]:this.groupCtx.prevX[y-1][p]-v+2*(this.isReversed?v:0)),e=w}else e=r;o=null===this.series[f][p]?e:e+this.series[f][p]/this.invertedYRatio-2*(this.isReversed?this.series[f][p]/this.invertedYRatio:0);var k=this.barHelpers.getBarpaths({barYPosition:u,barHeight:a,x1:e,x2:o,strokeWidth:s,isReversed:this.isReversed,series:this.series,realIndex:i.realIndex,seriesGroup:h,i:f,j:p,w:g});return this.barHelpers.barBackground({j:p,i:f,y1:u,y2:a,elSeries:d}),n+=c,{pathTo:k.pathTo,pathFrom:k.pathFrom,goalX:this.barHelpers.getGoalValues("x",r,null,f,p,b),barXPosition:e,barYPosition:u,x:o,y:n}}},{key:"drawStackedColumnPaths",value:function(t){var e=t.indexes,i=t.x,a=t.y,s=t.xDivision,r=t.barWidth,o=t.zeroH,n=t.columnGroupIndex,l=t.seriesGroup,h=t.elSeries,c=this.w,d=e.i,g=e.j,u=e.bc,f=e.realIndex,p=e.translationsIndex;if(c.globals.isXNumeric){var x=c.globals.seriesX[f][g];x||(x=0),i=(x-c.globals.minX)/this.xRatio-r/2*c.globals.barGroups.length}for(var b,v=i+n*r,m=0,y=0;y<this.groupCtx.prevYF.length;y++)m+=isNaN(this.groupCtx.prevYF[y][g])?0:this.groupCtx.prevYF[y][g];var w=d;if(l&&(w=l.indexOf(c.globals.seriesNames[f])),w>0&&!c.globals.isXNumeric||w>0&&c.globals.isXNumeric&&c.globals.seriesX[f-1][g]===c.globals.seriesX[f][g]){var k,A,S,C=Math.min(this.yRatio.length+1,f+1);if(void 0!==this.groupCtx.prevY[w-1]&&this.groupCtx.prevY[w-1].length)for(var L=1;L<C;L++){var P;if(!isNaN(null===(P=this.groupCtx.prevY[w-L])||void 0===P?void 0:P[g])){S=this.groupCtx.prevY[w-L][g];break}}for(var M=1;M<C;M++){var I,T;if((null===(I=this.groupCtx.prevYVal[w-M])||void 0===I?void 0:I[g])<0){A=this.series[d][g]>=0?S-m+2*(this.isReversed?m:0):S;break}if((null===(T=this.groupCtx.prevYVal[w-M])||void 0===T?void 0:T[g])>=0){A=this.series[d][g]>=0?S:S+m-2*(this.isReversed?m:0);break}}void 0===A&&(A=c.globals.gridHeight),b=null!==(k=this.groupCtx.prevYF[0])&&void 0!==k&&k.every((function(t){return 0===t}))&&this.groupCtx.prevYF.slice(1,w).every((function(t){return t.every((function(t){return isNaN(t)}))}))?o:A}else b=o;a=this.series[d][g]?b-this.series[d][g]/this.yRatio[p]+2*(this.isReversed?this.series[d][g]/this.yRatio[p]:0):b;var z=this.barHelpers.getColumnPaths({barXPosition:v,barWidth:r,y1:b,y2:a,yRatio:this.yRatio[p],strokeWidth:this.strokeWidth,isReversed:this.isReversed,series:this.series,seriesGroup:l,realIndex:e.realIndex,i:d,j:g,w:c});return this.barHelpers.barBackground({bc:u,j:g,i:d,x1:v,x2:r,elSeries:h}),{pathTo:z.pathTo,pathFrom:z.pathFrom,goalY:this.barHelpers.getGoalValues("y",null,o,d,g),barXPosition:v,x:c.globals.isXNumeric?i:i+s,y:a}}}]),a}(St),Lt=function(t){h(a,t);var e=o(a);function a(){return i(this,a),e.apply(this,arguments)}return s(a,[{key:"draw",value:function(t,e,i){var a=this,s=this.w,r=new k(this.ctx),o=s.globals.comboCharts?e:s.config.chart.type,n=new N(this.ctx);this.candlestickOptions=this.w.config.plotOptions.candlestick,this.boxOptions=this.w.config.plotOptions.boxPlot,this.isHorizontal=s.config.plotOptions.bar.horizontal;var l=new A(this.ctx,s);t=l.getLogSeries(t),this.series=t,this.yRatio=l.getLogYRatios(this.yRatio),this.barHelpers.initVariables(t);for(var h=r.group({class:"apexcharts-".concat(o,"-series apexcharts-plot-series")}),c=function(e){a.isBoxPlot="boxPlot"===s.config.chart.type||"boxPlot"===s.config.series[e].type;var o,l,c,d,u=void 0,f=void 0,p=[],x=[],b=s.globals.comboCharts?i[e]:e,v=a.barHelpers.getGroupIndex(b).columnGroupIndex,y=r.group({class:"apexcharts-series",seriesName:m.escapeString(s.globals.seriesNames[b]),rel:e+1,"data:realIndex":b});a.ctx.series.addCollapsedClassToSeries(y,b),t[e].length>0&&(a.visibleI=a.visibleI+1);var w,k,A=0;a.yRatio.length>1&&(a.yaxisIndex=s.globals.seriesYAxisReverseMap[b][0],A=b);var S=a.barHelpers.initialPositions();f=S.y,w=S.barHeight,l=S.yDivision,d=S.zeroW,u=S.x,k=S.barWidth,o=S.xDivision,c=S.zeroH,x.push(u+k/2);for(var C=r.group({class:"apexcharts-datalabels","data:realIndex":b}),L=function(i){var r=a.barHelpers.getStrokeWidth(e,i,b),h=null,m={indexes:{i:e,j:i,realIndex:b,translationsIndex:A},x:u,y:f,strokeWidth:r,elSeries:y};h=a.isHorizontal?a.drawHorizontalBoxPaths(g(g({},m),{},{yDivision:l,barHeight:w,zeroW:d})):a.drawVerticalBoxPaths(g(g({},m),{},{xDivision:o,barWidth:k,zeroH:c})),f=h.y,u=h.x,i>0&&x.push(u+k/2),p.push(f),h.pathTo.forEach((function(o,l){var c=!a.isBoxPlot&&a.candlestickOptions.wick.useFillColor?h.color[l]:s.globals.stroke.colors[e],d=n.fillPath({seriesNumber:b,dataPointIndex:i,color:h.color[l],value:t[e][i]});a.renderSeries({realIndex:b,pathFill:d,lineFill:c,j:i,i:e,pathFrom:h.pathFrom,pathTo:o,strokeWidth:r,elSeries:y,x:u,y:f,series:t,columnGroupIndex:v,barHeight:w,barWidth:k,elDataLabelsWrap:C,visibleSeries:a.visibleI,type:s.config.chart.type})}))},P=0;P<s.globals.dataPoints;P++)L(P);s.globals.seriesXvalues[b]=x,s.globals.seriesYvalues[b]=p,h.add(y)},d=0;d<t.length;d++)c(d);return h}},{key:"drawVerticalBoxPaths",value:function(t){var e=t.indexes,i=t.x;t.y;var a=t.xDivision,s=t.barWidth,r=t.zeroH,o=t.strokeWidth,n=this.w,l=new k(this.ctx),h=e.i,c=e.j,d=!0,g=n.config.plotOptions.candlestick.colors.upward,u=n.config.plotOptions.candlestick.colors.downward,f="";this.isBoxPlot&&(f=[this.boxOptions.colors.lower,this.boxOptions.colors.upper]);var p=this.yRatio[e.translationsIndex],x=e.realIndex,b=this.getOHLCValue(x,c),v=r,m=r;b.o>b.c&&(d=!1);var y=Math.min(b.o,b.c),w=Math.max(b.o,b.c),A=b.m;n.globals.isXNumeric&&(i=(n.globals.seriesX[x][c]-n.globals.minX)/this.xRatio-s/2);var S=i+s*this.visibleI;void 0===this.series[h][c]||null===this.series[h][c]?(y=r,w=r):(y=r-y/p,w=r-w/p,v=r-b.h/p,m=r-b.l/p,A=r-b.m/p);var C=l.move(S,r),L=l.move(S+s/2,y);return n.globals.previousPaths.length>0&&(L=this.getPreviousPath(x,c,!0)),C=this.isBoxPlot?[l.move(S,y)+l.line(S+s/2,y)+l.line(S+s/2,v)+l.line(S+s/4,v)+l.line(S+s-s/4,v)+l.line(S+s/2,v)+l.line(S+s/2,y)+l.line(S+s,y)+l.line(S+s,A)+l.line(S,A)+l.line(S,y+o/2),l.move(S,A)+l.line(S+s,A)+l.line(S+s,w)+l.line(S+s/2,w)+l.line(S+s/2,m)+l.line(S+s-s/4,m)+l.line(S+s/4,m)+l.line(S+s/2,m)+l.line(S+s/2,w)+l.line(S,w)+l.line(S,A)+"z"]:[l.move(S,w)+l.line(S+s/2,w)+l.line(S+s/2,v)+l.line(S+s/2,w)+l.line(S+s,w)+l.line(S+s,y)+l.line(S+s/2,y)+l.line(S+s/2,m)+l.line(S+s/2,y)+l.line(S,y)+l.line(S,w-o/2)],L+=l.move(S,y),n.globals.isXNumeric||(i+=a),{pathTo:C,pathFrom:L,x:i,y:w,barXPosition:S,color:this.isBoxPlot?f:d?[g]:[u]}}},{key:"drawHorizontalBoxPaths",value:function(t){var e=t.indexes;t.x;var i=t.y,a=t.yDivision,s=t.barHeight,r=t.zeroW,o=t.strokeWidth,n=this.w,l=new k(this.ctx),h=e.i,c=e.j,d=this.boxOptions.colors.lower;this.isBoxPlot&&(d=[this.boxOptions.colors.lower,this.boxOptions.colors.upper]);var g=this.invertedYRatio,u=e.realIndex,f=this.getOHLCValue(u,c),p=r,x=r,b=Math.min(f.o,f.c),v=Math.max(f.o,f.c),m=f.m;n.globals.isXNumeric&&(i=(n.globals.seriesX[u][c]-n.globals.minX)/this.invertedXRatio-s/2);var y=i+s*this.visibleI;void 0===this.series[h][c]||null===this.series[h][c]?(b=r,v=r):(b=r+b/g,v=r+v/g,p=r+f.h/g,x=r+f.l/g,m=r+f.m/g);var w=l.move(r,y),A=l.move(b,y+s/2);return n.globals.previousPaths.length>0&&(A=this.getPreviousPath(u,c,!0)),w=[l.move(b,y)+l.line(b,y+s/2)+l.line(p,y+s/2)+l.line(p,y+s/2-s/4)+l.line(p,y+s/2+s/4)+l.line(p,y+s/2)+l.line(b,y+s/2)+l.line(b,y+s)+l.line(m,y+s)+l.line(m,y)+l.line(b+o/2,y),l.move(m,y)+l.line(m,y+s)+l.line(v,y+s)+l.line(v,y+s/2)+l.line(x,y+s/2)+l.line(x,y+s-s/4)+l.line(x,y+s/4)+l.line(x,y+s/2)+l.line(v,y+s/2)+l.line(v,y)+l.line(m,y)+"z"],A+=l.move(b,y),n.globals.isXNumeric||(i+=a),{pathTo:w,pathFrom:A,x:v,y:i,barYPosition:y,color:d}}},{key:"getOHLCValue",value:function(t,e){var i=this.w;return{o:this.isBoxPlot?i.globals.seriesCandleH[t][e]:i.globals.seriesCandleO[t][e],h:this.isBoxPlot?i.globals.seriesCandleO[t][e]:i.globals.seriesCandleH[t][e],m:i.globals.seriesCandleM[t][e],l:this.isBoxPlot?i.globals.seriesCandleC[t][e]:i.globals.seriesCandleL[t][e],c:this.isBoxPlot?i.globals.seriesCandleL[t][e]:i.globals.seriesCandleC[t][e]}}}]),a}(St),Pt=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w}return s(t,[{key:"checkColorRange",value:function(){var t=this.w,e=!1,i=t.config.plotOptions[t.config.chart.type];return i.colorScale.ranges.length>0&&i.colorScale.ranges.map((function(t,i){t.from<=0&&(e=!0)})),e}},{key:"getShadeColor",value:function(t,e,i,a){var s=this.w,r=1,o=s.config.plotOptions[t].shadeIntensity,n=this.determineColor(t,e,i);s.globals.hasNegs||a?r=s.config.plotOptions[t].reverseNegativeShade?n.percent<0?n.percent/100*(1.25*o):(1-n.percent/100)*(1.25*o):n.percent<=0?1-(1+n.percent/100)*o:(1-n.percent/100)*o:(r=1-n.percent/100,"treemap"===t&&(r=(1-n.percent/100)*(1.25*o)));var l=n.color,h=new m;if(s.config.plotOptions[t].enableShades)if("dark"===this.w.config.theme.mode){var c=h.shadeColor(-1*r,n.color);l=m.hexToRgba(m.isColorHex(c)?c:m.rgb2hex(c),s.config.fill.opacity)}else{var d=h.shadeColor(r,n.color);l=m.hexToRgba(m.isColorHex(d)?d:m.rgb2hex(d),s.config.fill.opacity)}return{color:l,colorProps:n}}},{key:"determineColor",value:function(t,e,i){var a=this.w,s=a.globals.series[e][i],r=a.config.plotOptions[t],o=r.colorScale.inverse?i:e;r.distributed&&"treemap"===a.config.chart.type&&(o=i);var n=a.globals.colors[o],l=null,h=Math.min.apply(Math,p(a.globals.series[e])),c=Math.max.apply(Math,p(a.globals.series[e]));r.distributed||"heatmap"!==t||(h=a.globals.minY,c=a.globals.maxY),void 0!==r.colorScale.min&&(h=r.colorScale.min<a.globals.minY?r.colorScale.min:a.globals.minY,c=r.colorScale.max>a.globals.maxY?r.colorScale.max:a.globals.maxY);var d=Math.abs(c)+Math.abs(h),g=100*s/(0===d?d-1e-6:d);r.colorScale.ranges.length>0&&r.colorScale.ranges.map((function(t,e){if(s>=t.from&&s<=t.to){n=t.color,l=t.foreColor?t.foreColor:null,h=t.from,c=t.to;var i=Math.abs(c)+Math.abs(h);g=100*s/(0===i?i-1e-6:i)}}));return{color:n,foreColor:l,percent:g}}},{key:"calculateDataLabels",value:function(t){var e=t.text,i=t.x,a=t.y,s=t.i,r=t.j,o=t.colorProps,n=t.fontSize,l=this.w.config.dataLabels,h=new k(this.ctx),c=new G(this.ctx),d=null;if(l.enabled){d=h.group({class:"apexcharts-data-labels"});var g=l.offsetX,u=l.offsetY,f=i+g,p=a+parseFloat(l.style.fontSize)/3+u;c.plotDataLabelsText({x:f,y:p,text:e,i:s,j:r,color:o.foreColor,parent:d,fontSize:n,dataLabelsConfig:l})}return d}},{key:"addListeners",value:function(t){var e=new k(this.ctx);t.node.addEventListener("mouseenter",e.pathMouseEnter.bind(this,t)),t.node.addEventListener("mouseleave",e.pathMouseLeave.bind(this,t)),t.node.addEventListener("mousedown",e.pathMouseDown.bind(this,t))}}]),t}(),Mt=function(){function t(e,a){i(this,t),this.ctx=e,this.w=e.w,this.xRatio=a.xRatio,this.yRatio=a.yRatio,this.dynamicAnim=this.w.config.chart.animations.dynamicAnimation,this.helpers=new Pt(e),this.rectRadius=this.w.config.plotOptions.heatmap.radius,this.strokeWidth=this.w.config.stroke.show?this.w.config.stroke.width:0}return s(t,[{key:"draw",value:function(t){var e=this.w,i=new k(this.ctx),a=i.group({class:"apexcharts-heatmap"});a.attr("clip-path","url(#gridRectMask".concat(e.globals.cuid,")"));var s=e.globals.gridWidth/e.globals.dataPoints,r=e.globals.gridHeight/e.globals.series.length,o=0,n=!1;this.negRange=this.helpers.checkColorRange();var l=t.slice();e.config.yaxis[0].reversed&&(n=!0,l.reverse());for(var h=n?0:l.length-1;n?h<l.length:h>=0;n?h++:h--){var c=i.group({class:"apexcharts-series apexcharts-heatmap-series",seriesName:m.escapeString(e.globals.seriesNames[h]),rel:h+1,"data:realIndex":h});if(this.ctx.series.addCollapsedClassToSeries(c,h),e.config.chart.dropShadow.enabled){var d=e.config.chart.dropShadow;new w(this.ctx).dropShadow(c,d,h)}for(var g=0,u=e.config.plotOptions.heatmap.shadeIntensity,f=0;f<l[h].length;f++){var p=this.helpers.getShadeColor(e.config.chart.type,h,f,this.negRange),x=p.color,b=p.colorProps;if("image"===e.config.fill.type)x=new N(this.ctx).fillPath({seriesNumber:h,dataPointIndex:f,opacity:e.globals.hasNegs?b.percent<0?1-(1+b.percent/100):u+b.percent/100:b.percent/100,patternID:m.randomId(),width:e.config.fill.image.width?e.config.fill.image.width:s,height:e.config.fill.image.height?e.config.fill.image.height:r});var v=this.rectRadius,y=i.drawRect(g,o,s,r,v);if(y.attr({cx:g,cy:o}),y.node.classList.add("apexcharts-heatmap-rect"),c.add(y),y.attr({fill:x,i:h,index:h,j:f,val:t[h][f],"stroke-width":this.strokeWidth,stroke:e.config.plotOptions.heatmap.useFillColorAsStroke?x:e.globals.stroke.colors[0],color:x}),this.helpers.addListeners(y),e.config.chart.animations.enabled&&!e.globals.dataChanged){var A=1;e.globals.resized||(A=e.config.chart.animations.speed),this.animateHeatMap(y,g,o,s,r,A)}if(e.globals.dataChanged){var S=1;if(this.dynamicAnim.enabled&&e.globals.shouldAnimate){S=this.dynamicAnim.speed;var C=e.globals.previousPaths[h]&&e.globals.previousPaths[h][f]&&e.globals.previousPaths[h][f].color;C||(C="rgba(255, 255, 255, 0)"),this.animateHeatColor(y,m.isColorHex(C)?C:m.rgb2hex(C),m.isColorHex(x)?x:m.rgb2hex(x),S)}}var L=(0,e.config.dataLabels.formatter)(e.globals.series[h][f],{value:e.globals.series[h][f],seriesIndex:h,dataPointIndex:f,w:e}),P=this.helpers.calculateDataLabels({text:L,x:g+s/2,y:o+r/2,i:h,j:f,colorProps:b,series:l});null!==P&&c.add(P),g+=s}o+=r,a.add(c)}var M=e.globals.yAxisScale[0].result.slice();return e.config.yaxis[0].reversed?M.unshift(""):M.push(""),e.globals.yAxisScale[0].result=M,a}},{key:"animateHeatMap",value:function(t,e,i,a,s,r){var o=new y(this.ctx);o.animateRect(t,{x:e+a/2,y:i+s/2,width:0,height:0},{x:e,y:i,width:a,height:s},r,(function(){o.animationCompleted(t)}))}},{key:"animateHeatColor",value:function(t,e,i,a){t.attr({fill:e}).animate(a).attr({fill:i})}}]),t}(),It=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w}return s(t,[{key:"drawYAxisTexts",value:function(t,e,i,a){var s=this.w,r=s.config.yaxis[0],o=s.globals.yLabelFormatters[0];return new k(this.ctx).drawText({x:t+r.labels.offsetX,y:e+r.labels.offsetY,text:o(a,i),textAnchor:"middle",fontSize:r.labels.style.fontSize,fontFamily:r.labels.style.fontFamily,foreColor:Array.isArray(r.labels.style.colors)?r.labels.style.colors[i]:r.labels.style.colors})}}]),t}(),Tt=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w;var a=this.w;this.chartType=this.w.config.chart.type,this.initialAnim=this.w.config.chart.animations.enabled,this.dynamicAnim=this.initialAnim&&this.w.config.chart.animations.dynamicAnimation.enabled,this.animBeginArr=[0],this.animDur=0,this.donutDataLabels=this.w.config.plotOptions.pie.donut.labels,this.lineColorArr=void 0!==a.globals.stroke.colors?a.globals.stroke.colors:a.globals.colors,this.defaultSize=Math.min(a.globals.gridWidth,a.globals.gridHeight),this.centerY=this.defaultSize/2,this.centerX=a.globals.gridWidth/2,"radialBar"===a.config.chart.type?this.fullAngle=360:this.fullAngle=Math.abs(a.config.plotOptions.pie.endAngle-a.config.plotOptions.pie.startAngle),this.initialAngle=a.config.plotOptions.pie.startAngle%this.fullAngle,a.globals.radialSize=this.defaultSize/2.05-a.config.stroke.width-(a.config.chart.sparkline.enabled?0:a.config.chart.dropShadow.blur),this.donutSize=a.globals.radialSize*parseInt(a.config.plotOptions.pie.donut.size,10)/100;var s=a.config.plotOptions.pie.customScale,r=a.globals.gridWidth/2,o=a.globals.gridHeight/2;this.translateX=r-r*s,this.translateY=o-o*s,this.dataLabelsGroup=new k(this.ctx).group({class:"apexcharts-datalabels-group",transform:"translate(".concat(this.translateX,", ").concat(this.translateY,") scale(").concat(s,")")}),this.maxY=0,this.sliceLabels=[],this.sliceSizes=[],this.prevSectorAngleArr=[]}return s(t,[{key:"draw",value:function(t){var e=this,i=this.w,a=new k(this.ctx),s=a.group({class:"apexcharts-pie"});if(i.globals.noData)return s;for(var r=0,o=0;o<t.length;o++)r+=m.negToZero(t[o]);var n=[],l=a.group();0===r&&(r=1e-5),t.forEach((function(t){e.maxY=Math.max(e.maxY,t)})),i.config.yaxis[0].max&&(this.maxY=i.config.yaxis[0].max),"back"===i.config.grid.position&&"polarArea"===this.chartType&&this.drawPolarElements(s);for(var h=0;h<t.length;h++){var c=this.fullAngle*m.negToZero(t[h])/r;n.push(c),"polarArea"===this.chartType?(n[h]=this.fullAngle/t.length,this.sliceSizes.push(i.globals.radialSize*t[h]/this.maxY)):this.sliceSizes.push(i.globals.radialSize)}if(i.globals.dataChanged){for(var d,g=0,u=0;u<i.globals.previousPaths.length;u++)g+=m.negToZero(i.globals.previousPaths[u]);for(var f=0;f<i.globals.previousPaths.length;f++)d=this.fullAngle*m.negToZero(i.globals.previousPaths[f])/g,this.prevSectorAngleArr.push(d)}if(this.donutSize<0&&(this.donutSize=0),"donut"===this.chartType){var p=a.drawCircle(this.donutSize);p.attr({cx:this.centerX,cy:this.centerY,fill:i.config.plotOptions.pie.donut.background?i.config.plotOptions.pie.donut.background:"transparent"}),l.add(p)}var x=this.drawArcs(n,t);if(this.sliceLabels.forEach((function(t){x.add(t)})),l.attr({transform:"translate(".concat(this.translateX,", ").concat(this.translateY,") scale(").concat(i.config.plotOptions.pie.customScale,")")}),l.add(x),s.add(l),this.donutDataLabels.show){var b=this.renderInnerDataLabels(this.dataLabelsGroup,this.donutDataLabels,{hollowSize:this.donutSize,centerX:this.centerX,centerY:this.centerY,opacity:this.donutDataLabels.show});s.add(b)}return"front"===i.config.grid.position&&"polarArea"===this.chartType&&this.drawPolarElements(s),s}},{key:"drawArcs",value:function(t,e){var i=this.w,a=new w(this.ctx),s=new k(this.ctx),r=new N(this.ctx),o=s.group({class:"apexcharts-slices"}),n=this.initialAngle,l=this.initialAngle,h=this.initialAngle,c=this.initialAngle;this.strokeWidth=i.config.stroke.show?i.config.stroke.width:0;for(var d=0;d<t.length;d++){var g=s.group({class:"apexcharts-series apexcharts-pie-series",seriesName:m.escapeString(i.globals.seriesNames[d]),rel:d+1,"data:realIndex":d});o.add(g),l=c,h=(n=h)+t[d],c=l+this.prevSectorAngleArr[d];var u=h<n?this.fullAngle+h-n:h-n,f=r.fillPath({seriesNumber:d,size:this.sliceSizes[d],value:e[d]}),p=this.getChangedPath(l,c),x=s.drawPath({d:p,stroke:Array.isArray(this.lineColorArr)?this.lineColorArr[d]:this.lineColorArr,strokeWidth:0,fill:f,fillOpacity:i.config.fill.opacity,classes:"apexcharts-pie-area apexcharts-".concat(this.chartType.toLowerCase(),"-slice-").concat(d)});if(x.attr({index:0,j:d}),a.setSelectionFilter(x,0,d),i.config.chart.dropShadow.enabled){var b=i.config.chart.dropShadow;a.dropShadow(x,b,d)}this.addListeners(x,this.donutDataLabels),k.setAttrs(x.node,{"data:angle":u,"data:startAngle":n,"data:strokeWidth":this.strokeWidth,"data:value":e[d]});var v={x:0,y:0};"pie"===this.chartType||"polarArea"===this.chartType?v=m.polarToCartesian(this.centerX,this.centerY,i.globals.radialSize/1.25+i.config.plotOptions.pie.dataLabels.offset,(n+u/2)%this.fullAngle):"donut"===this.chartType&&(v=m.polarToCartesian(this.centerX,this.centerY,(i.globals.radialSize+this.donutSize)/2+i.config.plotOptions.pie.dataLabels.offset,(n+u/2)%this.fullAngle)),g.add(x);var y=0;if(!this.initialAnim||i.globals.resized||i.globals.dataChanged?this.animBeginArr.push(0):(0===(y=u/this.fullAngle*i.config.chart.animations.speed)&&(y=1),this.animDur=y+this.animDur,this.animBeginArr.push(this.animDur)),this.dynamicAnim&&i.globals.dataChanged?this.animatePaths(x,{size:this.sliceSizes[d],endAngle:h,startAngle:n,prevStartAngle:l,prevEndAngle:c,animateStartingPos:!0,i:d,animBeginArr:this.animBeginArr,shouldSetPrevPaths:!0,dur:i.config.chart.animations.dynamicAnimation.speed}):this.animatePaths(x,{size:this.sliceSizes[d],endAngle:h,startAngle:n,i:d,totalItems:t.length-1,animBeginArr:this.animBeginArr,dur:y}),i.config.plotOptions.pie.expandOnClick&&"polarArea"!==this.chartType&&x.node.addEventListener("mouseup",this.pieClicked.bind(this,d)),void 0!==i.globals.selectedDataPoints[0]&&i.globals.selectedDataPoints[0].indexOf(d)>-1&&this.pieClicked(d),i.config.dataLabels.enabled){var A=v.x,S=v.y,C=100*u/this.fullAngle+"%";if(0!==u&&i.config.plotOptions.pie.dataLabels.minAngleToShowLabel<t[d]){var L=i.config.dataLabels.formatter;void 0!==L&&(C=L(i.globals.seriesPercent[d][0],{seriesIndex:d,w:i}));var P=i.globals.dataLabels.style.colors[d],M=s.group({class:"apexcharts-datalabels"}),I=s.drawText({x:A,y:S,text:C,textAnchor:"middle",fontSize:i.config.dataLabels.style.fontSize,fontFamily:i.config.dataLabels.style.fontFamily,fontWeight:i.config.dataLabels.style.fontWeight,foreColor:P});if(M.add(I),i.config.dataLabels.dropShadow.enabled){var T=i.config.dataLabels.dropShadow;a.dropShadow(I,T)}I.node.classList.add("apexcharts-pie-label"),i.config.chart.animations.animate&&!1===i.globals.resized&&(I.node.classList.add("apexcharts-pie-label-delay"),I.node.style.animationDelay=i.config.chart.animations.speed/940+"s"),this.sliceLabels.push(M)}}}return o}},{key:"addListeners",value:function(t,e){var i=new k(this.ctx);t.node.addEventListener("mouseenter",i.pathMouseEnter.bind(this,t)),t.node.addEventListener("mouseleave",i.pathMouseLeave.bind(this,t)),t.node.addEventListener("mouseleave",this.revertDataLabelsInner.bind(this,t.node,e)),t.node.addEventListener("mousedown",i.pathMouseDown.bind(this,t)),this.donutDataLabels.total.showAlways||(t.node.addEventListener("mouseenter",this.printDataLabelsInner.bind(this,t.node,e)),t.node.addEventListener("mousedown",this.printDataLabelsInner.bind(this,t.node,e)))}},{key:"animatePaths",value:function(t,e){var i=this.w,a=e.endAngle<e.startAngle?this.fullAngle+e.endAngle-e.startAngle:e.endAngle-e.startAngle,s=a,r=e.startAngle,o=e.startAngle;void 0!==e.prevStartAngle&&void 0!==e.prevEndAngle&&(r=e.prevEndAngle,s=e.prevEndAngle<e.prevStartAngle?this.fullAngle+e.prevEndAngle-e.prevStartAngle:e.prevEndAngle-e.prevStartAngle),e.i===i.config.series.length-1&&(a+o>this.fullAngle?e.endAngle=e.endAngle-(a+o):a+o<this.fullAngle&&(e.endAngle=e.endAngle+(this.fullAngle-(a+o)))),a===this.fullAngle&&(a=this.fullAngle-.01),this.animateArc(t,r,o,a,s,e)}},{key:"animateArc",value:function(t,e,i,a,s,r){var o,n=this,l=this.w,h=new y(this.ctx),c=r.size;(isNaN(e)||isNaN(s))&&(e=i,s=a,r.dur=0);var d=a,g=i,u=e<i?this.fullAngle+e-i:e-i;l.globals.dataChanged&&r.shouldSetPrevPaths&&r.prevEndAngle&&(o=n.getPiePath({me:n,startAngle:r.prevStartAngle,angle:r.prevEndAngle<r.prevStartAngle?this.fullAngle+r.prevEndAngle-r.prevStartAngle:r.prevEndAngle-r.prevStartAngle,size:c}),t.attr({d:o})),0!==r.dur?t.animate(r.dur,l.globals.easing,r.animBeginArr[r.i]).afterAll((function(){"pie"!==n.chartType&&"donut"!==n.chartType&&"polarArea"!==n.chartType||this.animate(l.config.chart.animations.dynamicAnimation.speed).attr({"stroke-width":n.strokeWidth}),r.i===l.config.series.length-1&&h.animationCompleted(t)})).during((function(l){d=u+(a-u)*l,r.animateStartingPos&&(d=s+(a-s)*l,g=e-s+(i-(e-s))*l),o=n.getPiePath({me:n,startAngle:g,angle:d,size:c}),t.node.setAttribute("data:pathOrig",o),t.attr({d:o})})):(o=n.getPiePath({me:n,startAngle:g,angle:a,size:c}),r.isTrack||(l.globals.animationEnded=!0),t.node.setAttribute("data:pathOrig",o),t.attr({d:o,"stroke-width":n.strokeWidth}))}},{key:"pieClicked",value:function(t){var e,i=this.w,a=this,s=a.sliceSizes[t]+(i.config.plotOptions.pie.expandOnClick?4:0),r=i.globals.dom.Paper.select(".apexcharts-".concat(a.chartType.toLowerCase(),"-slice-").concat(t)).members[0];if("true"!==r.attr("data:pieClicked")){var o=i.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area");Array.prototype.forEach.call(o,(function(t){t.setAttribute("data:pieClicked","false");var e=t.getAttribute("data:pathOrig");e&&t.setAttribute("d",e)})),i.globals.capturedDataPointIndex=t,r.attr("data:pieClicked","true");var n=parseInt(r.attr("data:startAngle"),10),l=parseInt(r.attr("data:angle"),10);e=a.getPiePath({me:a,startAngle:n,angle:l,size:s}),360!==l&&r.plot(e)}else{r.attr({"data:pieClicked":"false"}),this.revertDataLabelsInner(r.node,this.donutDataLabels);var h=r.attr("data:pathOrig");r.attr({d:h})}}},{key:"getChangedPath",value:function(t,e){var i="";return this.dynamicAnim&&this.w.globals.dataChanged&&(i=this.getPiePath({me:this,startAngle:t,angle:e-t,size:this.size})),i}},{key:"getPiePath",value:function(t){var e,i=t.me,a=t.startAngle,s=t.angle,r=t.size,o=new k(this.ctx),n=a,l=Math.PI*(n-90)/180,h=s+a;Math.ceil(h)>=this.fullAngle+this.w.config.plotOptions.pie.startAngle%this.fullAngle&&(h=this.fullAngle+this.w.config.plotOptions.pie.startAngle%this.fullAngle-.01),Math.ceil(h)>this.fullAngle&&(h-=this.fullAngle);var c=Math.PI*(h-90)/180,d=i.centerX+r*Math.cos(l),g=i.centerY+r*Math.sin(l),u=i.centerX+r*Math.cos(c),f=i.centerY+r*Math.sin(c),p=m.polarToCartesian(i.centerX,i.centerY,i.donutSize,h),x=m.polarToCartesian(i.centerX,i.centerY,i.donutSize,n),b=s>180?1:0,v=["M",d,g,"A",r,r,0,b,1,u,f];return e="donut"===i.chartType?[].concat(v,["L",p.x,p.y,"A",i.donutSize,i.donutSize,0,b,0,x.x,x.y,"L",d,g,"z"]).join(" "):"pie"===i.chartType||"polarArea"===i.chartType?[].concat(v,["L",i.centerX,i.centerY,"L",d,g]).join(" "):[].concat(v).join(" "),o.roundPathCorners(e,2*this.strokeWidth)}},{key:"drawPolarElements",value:function(t){var e=this.w,i=new $(this.ctx),a=new k(this.ctx),s=new It(this.ctx),r=a.group(),o=a.group(),n=i.niceScale(0,Math.ceil(this.maxY),0),l=n.result.reverse(),h=n.result.length;this.maxY=n.niceMax;for(var c=e.globals.radialSize,d=c/(h-1),g=0;g<h-1;g++){var u=a.drawCircle(c);if(u.attr({cx:this.centerX,cy:this.centerY,fill:"none","stroke-width":e.config.plotOptions.polarArea.rings.strokeWidth,stroke:e.config.plotOptions.polarArea.rings.strokeColor}),e.config.yaxis[0].show){var f=s.drawYAxisTexts(this.centerX,this.centerY-c+parseInt(e.config.yaxis[0].labels.style.fontSize,10)/2,g,l[g]);o.add(f)}r.add(u),c-=d}this.drawSpokes(t),t.add(r),t.add(o)}},{key:"renderInnerDataLabels",value:function(t,e,i){var a=this.w,s=new k(this.ctx),r=e.total.show;t.node.innerHTML="",t.node.style.opacity=i.opacity;var o,n,l=i.centerX,h=this.donutDataLabels.total.label?i.centerY:i.centerY-i.centerY/6;o=void 0===e.name.color?a.globals.colors[0]:e.name.color;var c=e.name.fontSize,d=e.name.fontFamily,g=e.name.fontWeight;n=void 0===e.value.color?a.config.chart.foreColor:e.value.color;var u=e.value.formatter,f="",p="";if(r?(o=e.total.color,c=e.total.fontSize,d=e.total.fontFamily,g=e.total.fontWeight,p=this.donutDataLabels.total.label?e.total.label:"",f=e.total.formatter(a)):1===a.globals.series.length&&(f=u(a.globals.series[0],a),p=a.globals.seriesNames[0]),p&&(p=e.name.formatter(p,e.total.show,a)),e.name.show){var x=s.drawText({x:l,y:h+parseFloat(e.name.offsetY),text:p,textAnchor:"middle",foreColor:o,fontSize:c,fontWeight:g,fontFamily:d});x.node.classList.add("apexcharts-datalabel-label"),t.add(x)}if(e.value.show){var b=e.name.show?parseFloat(e.value.offsetY)+16:e.value.offsetY,v=s.drawText({x:l,y:h+b,text:f,textAnchor:"middle",foreColor:n,fontWeight:e.value.fontWeight,fontSize:e.value.fontSize,fontFamily:e.value.fontFamily});v.node.classList.add("apexcharts-datalabel-value"),t.add(v)}return t}},{key:"printInnerLabels",value:function(t,e,i,a){var s,r=this.w;a?s=void 0===t.name.color?r.globals.colors[parseInt(a.parentNode.getAttribute("rel"),10)-1]:t.name.color:r.globals.series.length>1&&t.total.show&&(s=t.total.color);var o=r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-label"),n=r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-value");i=(0,t.value.formatter)(i,r),a||"function"!=typeof t.total.formatter||(i=t.total.formatter(r));var l=e===t.total.label;e=this.donutDataLabels.total.label?t.name.formatter(e,l,r):"",null!==o&&(o.textContent=e),null!==n&&(n.textContent=i),null!==o&&(o.style.fill=s)}},{key:"printDataLabelsInner",value:function(t,e){var i=this.w,a=t.getAttribute("data:value"),s=i.globals.seriesNames[parseInt(t.parentNode.getAttribute("rel"),10)-1];i.globals.series.length>1&&this.printInnerLabels(e,s,a,t);var r=i.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group");null!==r&&(r.style.opacity=1)}},{key:"drawSpokes",value:function(t){var e=this,i=this.w,a=new k(this.ctx),s=i.config.plotOptions.polarArea.spokes;if(0!==s.strokeWidth){for(var r=[],o=360/i.globals.series.length,n=0;n<i.globals.series.length;n++)r.push(m.polarToCartesian(this.centerX,this.centerY,i.globals.radialSize,i.config.plotOptions.pie.startAngle+o*n));r.forEach((function(i,r){var o=a.drawLine(i.x,i.y,e.centerX,e.centerY,Array.isArray(s.connectorColors)?s.connectorColors[r]:s.connectorColors);t.add(o)}))}}},{key:"revertDataLabelsInner",value:function(){var t=this.w;if(this.donutDataLabels.show){var e=t.globals.dom.Paper.select(".apexcharts-datalabels-group").members[0],i=this.renderInnerDataLabels(e,this.donutDataLabels,{hollowSize:this.donutSize,centerX:this.centerX,centerY:this.centerY,opacity:this.donutDataLabels.show});t.globals.dom.Paper.select(".apexcharts-radialbar, .apexcharts-pie").members[0].add(i)}}}]),t}(),zt=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w,this.chartType=this.w.config.chart.type,this.initialAnim=this.w.config.chart.animations.enabled,this.dynamicAnim=this.initialAnim&&this.w.config.chart.animations.dynamicAnimation.enabled,this.animDur=0;var a=this.w;this.graphics=new k(this.ctx),this.lineColorArr=void 0!==a.globals.stroke.colors?a.globals.stroke.colors:a.globals.colors,this.defaultSize=a.globals.svgHeight<a.globals.svgWidth?a.globals.gridHeight:a.globals.gridWidth,this.isLog=a.config.yaxis[0].logarithmic,this.logBase=a.config.yaxis[0].logBase,this.coreUtils=new A(this.ctx),this.maxValue=this.isLog?this.coreUtils.getLogVal(this.logBase,a.globals.maxY,0):a.globals.maxY,this.minValue=this.isLog?this.coreUtils.getLogVal(this.logBase,this.w.globals.minY,0):a.globals.minY,this.polygons=a.config.plotOptions.radar.polygons,this.strokeWidth=a.config.stroke.show?a.config.stroke.width:0,this.size=this.defaultSize/2.1-this.strokeWidth-a.config.chart.dropShadow.blur,a.config.xaxis.labels.show&&(this.size=this.size-a.globals.xAxisLabelsWidth/1.75),void 0!==a.config.plotOptions.radar.size&&(this.size=a.config.plotOptions.radar.size),this.dataRadiusOfPercent=[],this.dataRadius=[],this.angleArr=[],this.yaxisLabelsTextsPos=[]}return s(t,[{key:"draw",value:function(t){var e=this,i=this.w,a=new N(this.ctx),s=[],r=new G(this.ctx);t.length&&(this.dataPointsLen=t[i.globals.maxValsInArrayIndex].length),this.disAngle=2*Math.PI/this.dataPointsLen;var o=i.globals.gridWidth/2,n=i.globals.gridHeight/2,l=o+i.config.plotOptions.radar.offsetX,h=n+i.config.plotOptions.radar.offsetY,c=this.graphics.group({class:"apexcharts-radar-series apexcharts-plot-series",transform:"translate(".concat(l||0,", ").concat(h||0,")")}),d=[],u=null,f=null;if(this.yaxisLabels=this.graphics.group({class:"apexcharts-yaxis"}),t.forEach((function(t,o){var n=t.length===i.globals.dataPoints,l=e.graphics.group().attr({class:"apexcharts-series","data:longestSeries":n,seriesName:m.escapeString(i.globals.seriesNames[o]),rel:o+1,"data:realIndex":o});e.dataRadiusOfPercent[o]=[],e.dataRadius[o]=[],e.angleArr[o]=[],t.forEach((function(t,i){var a=Math.abs(e.maxValue-e.minValue);t-=e.minValue,e.isLog&&(t=e.coreUtils.getLogVal(e.logBase,t,0)),e.dataRadiusOfPercent[o][i]=t/a,e.dataRadius[o][i]=e.dataRadiusOfPercent[o][i]*e.size,e.angleArr[o][i]=i*e.disAngle})),d=e.getDataPointsPos(e.dataRadius[o],e.angleArr[o]);var h=e.createPaths(d,{x:0,y:0});u=e.graphics.group({class:"apexcharts-series-markers-wrap apexcharts-element-hidden"}),f=e.graphics.group({class:"apexcharts-datalabels","data:realIndex":o}),i.globals.delayedElements.push({el:u.node,index:o});var c={i:o,realIndex:o,animationDelay:o,initialSpeed:i.config.chart.animations.speed,dataChangeSpeed:i.config.chart.animations.dynamicAnimation.speed,className:"apexcharts-radar",shouldClipToGrid:!1,bindEventsOnPaths:!1,stroke:i.globals.stroke.colors[o],strokeLineCap:i.config.stroke.lineCap},p=null;i.globals.previousPaths.length>0&&(p=e.getPreviousPath(o));for(var x=0;x<h.linePathsTo.length;x++){var b=e.graphics.renderPaths(g(g({},c),{},{pathFrom:null===p?h.linePathsFrom[x]:p,pathTo:h.linePathsTo[x],strokeWidth:Array.isArray(e.strokeWidth)?e.strokeWidth[o]:e.strokeWidth,fill:"none",drawShadow:!1}));l.add(b);var v=a.fillPath({seriesNumber:o}),y=e.graphics.renderPaths(g(g({},c),{},{pathFrom:null===p?h.areaPathsFrom[x]:p,pathTo:h.areaPathsTo[x],strokeWidth:0,fill:v,drawShadow:!1}));if(i.config.chart.dropShadow.enabled){var k=new w(e.ctx),A=i.config.chart.dropShadow;k.dropShadow(y,Object.assign({},A,{noUserSpaceOnUse:!0}),o)}l.add(y)}t.forEach((function(t,a){var s=new W(e.ctx).getMarkerConfig({cssClass:"apexcharts-marker",seriesIndex:o,dataPointIndex:a}),n=e.graphics.drawMarker(d[a].x,d[a].y,s);n.attr("rel",a),n.attr("j",a),n.attr("index",o),n.node.setAttribute("default-marker-size",s.pSize);var h=e.graphics.group({class:"apexcharts-series-markers"});h&&h.add(n),u.add(h),l.add(u);var c=i.config.dataLabels;if(c.enabled){var p=c.formatter(i.globals.series[o][a],{seriesIndex:o,dataPointIndex:a,w:i});r.plotDataLabelsText({x:d[a].x,y:d[a].y,text:p,textAnchor:"middle",i:o,j:o,parent:f,offsetCorrection:!1,dataLabelsConfig:g({},c)})}l.add(f)})),s.push(l)})),this.drawPolygons({parent:c}),i.config.xaxis.labels.show){var p=this.drawXAxisTexts();c.add(p)}return s.forEach((function(t){c.add(t)})),c.add(this.yaxisLabels),c}},{key:"drawPolygons",value:function(t){for(var e=this,i=this.w,a=t.parent,s=new It(this.ctx),r=i.globals.yAxisScale[0].result.reverse(),o=r.length,n=[],l=this.size/(o-1),h=0;h<o;h++)n[h]=l*h;n.reverse();var c=[],d=[];n.forEach((function(t,i){var a=m.getPolygonPos(t,e.dataPointsLen),s="";a.forEach((function(t,a){if(0===i){var r=e.graphics.drawLine(t.x,t.y,0,0,Array.isArray(e.polygons.connectorColors)?e.polygons.connectorColors[a]:e.polygons.connectorColors);d.push(r)}0===a&&e.yaxisLabelsTextsPos.push({x:t.x,y:t.y}),s+=t.x+","+t.y+" "})),c.push(s)})),c.forEach((function(t,s){var r=e.polygons.strokeColors,o=e.polygons.strokeWidth,n=e.graphics.drawPolygon(t,Array.isArray(r)?r[s]:r,Array.isArray(o)?o[s]:o,i.globals.radarPolygons.fill.colors[s]);a.add(n)})),d.forEach((function(t){a.add(t)})),i.config.yaxis[0].show&&this.yaxisLabelsTextsPos.forEach((function(t,i){var a=s.drawYAxisTexts(t.x,t.y,i,r[i]);e.yaxisLabels.add(a)}))}},{key:"drawXAxisTexts",value:function(){var t=this,e=this.w,i=e.config.xaxis.labels,a=this.graphics.group({class:"apexcharts-xaxis"}),s=m.getPolygonPos(this.size,this.dataPointsLen);return e.globals.labels.forEach((function(r,o){var n=e.config.xaxis.labels.formatter,l=new G(t.ctx);if(s[o]){var h=t.getTextPos(s[o],t.size),c=n(r,{seriesIndex:-1,dataPointIndex:o,w:e});l.plotDataLabelsText({x:h.newX,y:h.newY,text:c,textAnchor:h.textAnchor,i:o,j:o,parent:a,className:"apexcharts-xaxis-label",color:Array.isArray(i.style.colors)&&i.style.colors[o]?i.style.colors[o]:"#a8a8a8",dataLabelsConfig:g({textAnchor:h.textAnchor,dropShadow:{enabled:!1}},i),offsetCorrection:!1}).on("click",(function(i){if("function"==typeof e.config.chart.events.xAxisLabelClick){var a=Object.assign({},e,{labelIndex:o});e.config.chart.events.xAxisLabelClick(i,t.ctx,a)}}))}})),a}},{key:"createPaths",value:function(t,e){var i=this,a=[],s=[],r=[],o=[];if(t.length){s=[this.graphics.move(e.x,e.y)],o=[this.graphics.move(e.x,e.y)];var n=this.graphics.move(t[0].x,t[0].y),l=this.graphics.move(t[0].x,t[0].y);t.forEach((function(e,a){n+=i.graphics.line(e.x,e.y),l+=i.graphics.line(e.x,e.y),a===t.length-1&&(n+="Z",l+="Z")})),a.push(n),r.push(l)}return{linePathsFrom:s,linePathsTo:a,areaPathsFrom:o,areaPathsTo:r}}},{key:"getTextPos",value:function(t,e){var i="middle",a=t.x,s=t.y;return Math.abs(t.x)>=10?t.x>0?(i="start",a+=10):t.x<0&&(i="end",a-=10):i="middle",Math.abs(t.y)>=e-10&&(t.y<0?s-=10:t.y>0&&(s+=10)),{textAnchor:i,newX:a,newY:s}}},{key:"getPreviousPath",value:function(t){for(var e=this.w,i=null,a=0;a<e.globals.previousPaths.length;a++){var s=e.globals.previousPaths[a];s.paths.length>0&&parseInt(s.realIndex,10)===parseInt(t,10)&&void 0!==e.globals.previousPaths[a].paths[0]&&(i=e.globals.previousPaths[a].paths[0].d)}return i}},{key:"getDataPointsPos",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.dataPointsLen;t=t||[],e=e||[];for(var a=[],s=0;s<i;s++){var r={};r.x=t[s]*Math.sin(e[s]),r.y=-t[s]*Math.cos(e[s]),a.push(r)}return a}}]),t}(),Xt=function(t){h(r,t);var a=o(r);function r(t){var s;i(this,r),(s=a.call(this,t)).ctx=t,s.w=t.w,s.animBeginArr=[0],s.animDur=0;var o=s.w;return s.startAngle=o.config.plotOptions.radialBar.startAngle,s.endAngle=o.config.plotOptions.radialBar.endAngle,s.totalAngle=Math.abs(o.config.plotOptions.radialBar.endAngle-o.config.plotOptions.radialBar.startAngle),s.trackStartAngle=o.config.plotOptions.radialBar.track.startAngle,s.trackEndAngle=o.config.plotOptions.radialBar.track.endAngle,s.barLabels=s.w.config.plotOptions.radialBar.barLabels,s.donutDataLabels=s.w.config.plotOptions.radialBar.dataLabels,s.radialDataLabels=s.donutDataLabels,s.trackStartAngle||(s.trackStartAngle=s.startAngle),s.trackEndAngle||(s.trackEndAngle=s.endAngle),360===s.endAngle&&(s.endAngle=359.99),s.margin=parseInt(o.config.plotOptions.radialBar.track.margin,10),s.onBarLabelClick=s.onBarLabelClick.bind(e(s)),s}return s(r,[{key:"draw",value:function(t){var e=this.w,i=new k(this.ctx),a=i.group({class:"apexcharts-radialbar"});if(e.globals.noData)return a;var s=i.group(),r=this.defaultSize/2,o=e.globals.gridWidth/2,n=this.defaultSize/2.05;e.config.chart.sparkline.enabled||(n=n-e.config.stroke.width-e.config.chart.dropShadow.blur);var l=e.globals.fill.colors;if(e.config.plotOptions.radialBar.track.show){var h=this.drawTracks({size:n,centerX:o,centerY:r,colorArr:l,series:t});s.add(h)}var c=this.drawArcs({size:n,centerX:o,centerY:r,colorArr:l,series:t}),d=360;e.config.plotOptions.radialBar.startAngle<0&&(d=this.totalAngle);var g=(360-d)/360;if(e.globals.radialSize=n-n*g,this.radialDataLabels.value.show){var u=Math.max(this.radialDataLabels.value.offsetY,this.radialDataLabels.name.offsetY);e.globals.radialSize+=u*g}return s.add(c.g),"front"===e.config.plotOptions.radialBar.hollow.position&&(c.g.add(c.elHollow),c.dataLabels&&c.g.add(c.dataLabels)),a.add(s),a}},{key:"drawTracks",value:function(t){var e=this.w,i=new k(this.ctx),a=i.group({class:"apexcharts-tracks"}),s=new w(this.ctx),r=new N(this.ctx),o=this.getStrokeWidth(t);t.size=t.size-o/2;for(var n=0;n<t.series.length;n++){var l=i.group({class:"apexcharts-radialbar-track apexcharts-track"});a.add(l),l.attr({rel:n+1}),t.size=t.size-o-this.margin;var h=e.config.plotOptions.radialBar.track,c=r.fillPath({seriesNumber:0,size:t.size,fillColors:Array.isArray(h.background)?h.background[n]:h.background,solid:!0}),d=this.trackStartAngle,g=this.trackEndAngle;Math.abs(g)+Math.abs(d)>=360&&(g=360-Math.abs(this.startAngle)-.1);var u=i.drawPath({d:"",stroke:c,strokeWidth:o*parseInt(h.strokeWidth,10)/100,fill:"none",strokeOpacity:h.opacity,classes:"apexcharts-radialbar-area"});if(h.dropShadow.enabled){var f=h.dropShadow;s.dropShadow(u,f)}l.add(u),u.attr("id","apexcharts-radialbarTrack-"+n),this.animatePaths(u,{centerX:t.centerX,centerY:t.centerY,endAngle:g,startAngle:d,size:t.size,i:n,totalItems:2,animBeginArr:0,dur:0,isTrack:!0,easing:e.globals.easing})}return a}},{key:"drawArcs",value:function(t){var e=this.w,i=new k(this.ctx),a=new N(this.ctx),s=new w(this.ctx),r=i.group(),o=this.getStrokeWidth(t);t.size=t.size-o/2;var n=e.config.plotOptions.radialBar.hollow.background,l=t.size-o*t.series.length-this.margin*t.series.length-o*parseInt(e.config.plotOptions.radialBar.track.strokeWidth,10)/100/2,h=l-e.config.plotOptions.radialBar.hollow.margin;void 0!==e.config.plotOptions.radialBar.hollow.image&&(n=this.drawHollowImage(t,r,l,n));var c=this.drawHollow({size:h,centerX:t.centerX,centerY:t.centerY,fill:n||"transparent"});if(e.config.plotOptions.radialBar.hollow.dropShadow.enabled){var d=e.config.plotOptions.radialBar.hollow.dropShadow;s.dropShadow(c,d)}var g=1;!this.radialDataLabels.total.show&&e.globals.series.length>1&&(g=0);var u=null;if(this.radialDataLabels.show){var f=e.globals.dom.Paper.select(".apexcharts-datalabels-group").members[0];u=this.renderInnerDataLabels(f,this.radialDataLabels,{hollowSize:l,centerX:t.centerX,centerY:t.centerY,opacity:g})}"back"===e.config.plotOptions.radialBar.hollow.position&&(r.add(c),u&&r.add(u));var p=!1;e.config.plotOptions.radialBar.inverseOrder&&(p=!0);for(var x=p?t.series.length-1:0;p?x>=0:x<t.series.length;p?x--:x++){var b=i.group({class:"apexcharts-series apexcharts-radial-series",seriesName:m.escapeString(e.globals.seriesNames[x])});r.add(b),b.attr({rel:x+1,"data:realIndex":x}),this.ctx.series.addCollapsedClassToSeries(b,x),t.size=t.size-o-this.margin;var v=a.fillPath({seriesNumber:x,size:t.size,value:t.series[x]}),y=this.startAngle,A=void 0,S=m.negToZero(t.series[x]>100?100:t.series[x])/100,C=Math.round(this.totalAngle*S)+this.startAngle,L=void 0;e.globals.dataChanged&&(A=this.startAngle,L=Math.round(this.totalAngle*m.negToZero(e.globals.previousPaths[x])/100)+A),Math.abs(C)+Math.abs(y)>360&&(C-=.01),Math.abs(L)+Math.abs(A)>360&&(L-=.01);var P=C-y,M=Array.isArray(e.config.stroke.dashArray)?e.config.stroke.dashArray[x]:e.config.stroke.dashArray,I=i.drawPath({d:"",stroke:v,strokeWidth:o,fill:"none",fillOpacity:e.config.fill.opacity,classes:"apexcharts-radialbar-area apexcharts-radialbar-slice-"+x,strokeDashArray:M});if(k.setAttrs(I.node,{"data:angle":P,"data:value":t.series[x]}),e.config.chart.dropShadow.enabled){var T=e.config.chart.dropShadow;s.dropShadow(I,T,x)}if(s.setSelectionFilter(I,0,x),this.addListeners(I,this.radialDataLabels),b.add(I),I.attr({index:0,j:x}),this.barLabels.enabled){var z=m.polarToCartesian(t.centerX,t.centerY,t.size,y),X=this.barLabels.formatter(e.globals.seriesNames[x],{seriesIndex:x,w:e}),E=["apexcharts-radialbar-label"];this.barLabels.onClick||E.push("apexcharts-no-click");var Y=this.barLabels.useSeriesColors?e.globals.colors[x]:e.config.chart.foreColor;Y||(Y=e.config.chart.foreColor);var R=z.x+this.barLabels.offsetX,F=z.y+this.barLabels.offsetY,D=i.drawText({x:R,y:F,text:X,textAnchor:"end",dominantBaseline:"middle",fontFamily:this.barLabels.fontFamily,fontWeight:this.barLabels.fontWeight,fontSize:this.barLabels.fontSize,foreColor:Y,cssClass:E.join(" ")});D.on("click",this.onBarLabelClick),D.attr({rel:x+1}),0!==y&&D.attr({"transform-origin":"".concat(R," ").concat(F),transform:"rotate(".concat(y," 0 0)")}),b.add(D)}var H=0;!this.initialAnim||e.globals.resized||e.globals.dataChanged||(H=e.config.chart.animations.speed),e.globals.dataChanged&&(H=e.config.chart.animations.dynamicAnimation.speed),this.animDur=H/(1.2*t.series.length)+this.animDur,this.animBeginArr.push(this.animDur),this.animatePaths(I,{centerX:t.centerX,centerY:t.centerY,endAngle:C,startAngle:y,prevEndAngle:L,prevStartAngle:A,size:t.size,i:x,totalItems:2,animBeginArr:this.animBeginArr,dur:H,shouldSetPrevPaths:!0,easing:e.globals.easing})}return{g:r,elHollow:c,dataLabels:u}}},{key:"drawHollow",value:function(t){var e=new k(this.ctx).drawCircle(2*t.size);return e.attr({class:"apexcharts-radialbar-hollow",cx:t.centerX,cy:t.centerY,r:t.size,fill:t.fill}),e}},{key:"drawHollowImage",value:function(t,e,i,a){var s=this.w,r=new N(this.ctx),o=m.randomId(),n=s.config.plotOptions.radialBar.hollow.image;if(s.config.plotOptions.radialBar.hollow.imageClipped)r.clippedImgArea({width:i,height:i,image:n,patternID:"pattern".concat(s.globals.cuid).concat(o)}),a="url(#pattern".concat(s.globals.cuid).concat(o,")");else{var l=s.config.plotOptions.radialBar.hollow.imageWidth,h=s.config.plotOptions.radialBar.hollow.imageHeight;if(void 0===l&&void 0===h){var c=s.globals.dom.Paper.image(n).loaded((function(e){this.move(t.centerX-e.width/2+s.config.plotOptions.radialBar.hollow.imageOffsetX,t.centerY-e.height/2+s.config.plotOptions.radialBar.hollow.imageOffsetY)}));e.add(c)}else{var d=s.globals.dom.Paper.image(n).loaded((function(e){this.move(t.centerX-l/2+s.config.plotOptions.radialBar.hollow.imageOffsetX,t.centerY-h/2+s.config.plotOptions.radialBar.hollow.imageOffsetY),this.size(l,h)}));e.add(d)}}return a}},{key:"getStrokeWidth",value:function(t){var e=this.w;return t.size*(100-parseInt(e.config.plotOptions.radialBar.hollow.size,10))/100/(t.series.length+1)-this.margin}},{key:"onBarLabelClick",value:function(t){var e=parseInt(t.target.getAttribute("rel"),10)-1,i=this.barLabels.onClick,a=this.w;i&&i(a.globals.seriesNames[e],{w:a,seriesIndex:e})}}]),r}(Tt),Et=function(t){h(a,t);var e=o(a);function a(){return i(this,a),e.apply(this,arguments)}return s(a,[{key:"draw",value:function(t,e){var i=this.w,a=new k(this.ctx);this.rangeBarOptions=this.w.config.plotOptions.rangeBar,this.series=t,this.seriesRangeStart=i.globals.seriesRangeStart,this.seriesRangeEnd=i.globals.seriesRangeEnd,this.barHelpers.initVariables(t);for(var s=a.group({class:"apexcharts-rangebar-series apexcharts-plot-series"}),r=0;r<t.length;r++){var o,n,l,h,c=void 0,d=void 0,u=i.globals.comboCharts?e[r]:r,f=this.barHelpers.getGroupIndex(u).columnGroupIndex,p=a.group({class:"apexcharts-series",seriesName:m.escapeString(i.globals.seriesNames[u]),rel:r+1,"data:realIndex":u});this.ctx.series.addCollapsedClassToSeries(p,u),t[r].length>0&&(this.visibleI=this.visibleI+1);var x=0,b=0,v=0;this.yRatio.length>1&&(this.yaxisIndex=i.globals.seriesYAxisReverseMap[u][0],v=u);var y=this.barHelpers.initialPositions();d=y.y,h=y.zeroW,c=y.x,b=y.barWidth,x=y.barHeight,o=y.xDivision,n=y.yDivision,l=y.zeroH;for(var w=a.group({class:"apexcharts-datalabels","data:realIndex":u}),A=a.group({class:"apexcharts-rangebar-goals-markers"}),S=0;S<i.globals.dataPoints;S++){var C=this.barHelpers.getStrokeWidth(r,S,u),L=this.seriesRangeStart[r][S],P=this.seriesRangeEnd[r][S],M=null,I=null,T=null,z={x:c,y:d,strokeWidth:C,elSeries:p},X=this.seriesLen;if(i.config.plotOptions.bar.rangeBarGroupRows&&(X=1),void 0===i.config.series[r].data[S])break;if(this.isHorizontal){T=d+x*this.visibleI;var E=(n-x*X)/2;if(i.config.series[r].data[S].x){var Y=this.detectOverlappingBars({i:r,j:S,barYPosition:T,srty:E,barHeight:x,yDivision:n,initPositions:y});x=Y.barHeight,T=Y.barYPosition}b=(M=this.drawRangeBarPaths(g({indexes:{i:r,j:S,realIndex:u},barHeight:x,barYPosition:T,zeroW:h,yDivision:n,y1:L,y2:P},z))).barWidth}else{i.globals.isXNumeric&&(c=(i.globals.seriesX[r][S]-i.globals.minX)/this.xRatio-b/2),I=c+b*this.visibleI;var R=(o-b*X)/2;if(i.config.series[r].data[S].x){var F=this.detectOverlappingBars({i:r,j:S,barXPosition:I,srtx:R,barWidth:b,xDivision:o,initPositions:y});b=F.barWidth,I=F.barXPosition}x=(M=this.drawRangeColumnPaths(g({indexes:{i:r,j:S,realIndex:u,translationsIndex:v},barWidth:b,barXPosition:I,zeroH:l,xDivision:o},z))).barHeight}var D=this.barHelpers.drawGoalLine({barXPosition:M.barXPosition,barYPosition:T,goalX:M.goalX,goalY:M.goalY,barHeight:x,barWidth:b});D&&A.add(D),d=M.y,c=M.x;var H=this.barHelpers.getPathFillColor(t,r,S,u),O=i.globals.stroke.colors[u];this.renderSeries({realIndex:u,pathFill:H,lineFill:O,j:S,i:r,x:c,y:d,y1:L,y2:P,pathFrom:M.pathFrom,pathTo:M.pathTo,strokeWidth:C,elSeries:p,series:t,barHeight:x,barWidth:b,barXPosition:I,barYPosition:T,columnGroupIndex:f,elDataLabelsWrap:w,elGoalsMarkers:A,visibleSeries:this.visibleI,type:"rangebar"})}s.add(p)}return s}},{key:"detectOverlappingBars",value:function(t){var e=t.i,i=t.j,a=t.barYPosition,s=t.barXPosition,r=t.srty,o=t.srtx,n=t.barHeight,l=t.barWidth,h=t.yDivision,c=t.xDivision,d=t.initPositions,g=this.w,u=[],f=g.config.series[e].data[i].rangeName,p=g.config.series[e].data[i].x,x=Array.isArray(p)?p.join(" "):p,b=g.globals.labels.map((function(t){return Array.isArray(t)?t.join(" "):t})).indexOf(x),v=g.globals.seriesRange[e].findIndex((function(t){return t.x===x&&t.overlaps.length>0}));return this.isHorizontal?(a=g.config.plotOptions.bar.rangeBarGroupRows?r+h*b:r+n*this.visibleI+h*b,v>-1&&!g.config.plotOptions.bar.rangeBarOverlap&&(u=g.globals.seriesRange[e][v].overlaps).indexOf(f)>-1&&(a=(n=d.barHeight/u.length)*this.visibleI+h*(100-parseInt(this.barOptions.barHeight,10))/100/2+n*(this.visibleI+u.indexOf(f))+h*b)):(b>-1&&!g.globals.timescaleLabels.length&&(s=g.config.plotOptions.bar.rangeBarGroupRows?o+c*b:o+l*this.visibleI+c*b),v>-1&&!g.config.plotOptions.bar.rangeBarOverlap&&(u=g.globals.seriesRange[e][v].overlaps).indexOf(f)>-1&&(s=(l=d.barWidth/u.length)*this.visibleI+c*(100-parseInt(this.barOptions.barWidth,10))/100/2+l*(this.visibleI+u.indexOf(f))+c*b)),{barYPosition:a,barXPosition:s,barHeight:n,barWidth:l}}},{key:"drawRangeColumnPaths",value:function(t){var e=t.indexes,i=t.x,a=t.xDivision,s=t.barWidth,r=t.barXPosition,o=t.zeroH,n=this.w,l=e.i,h=e.j,c=e.realIndex,d=e.translationsIndex,g=this.yRatio[d],u=this.getRangeValue(c,h),f=Math.min(u.start,u.end),p=Math.max(u.start,u.end);void 0===this.series[l][h]||null===this.series[l][h]?f=o:(f=o-f/g,p=o-p/g);var x=Math.abs(p-f),b=this.barHelpers.getColumnPaths({barXPosition:r,barWidth:s,y1:f,y2:p,strokeWidth:this.strokeWidth,series:this.seriesRangeEnd,realIndex:c,i:c,j:h,w:n});if(n.globals.isXNumeric){var v=this.getBarXForNumericXAxis({x:i,j:h,realIndex:c,barWidth:s});i=v.x,r=v.barXPosition}else i+=a;return{pathTo:b.pathTo,pathFrom:b.pathFrom,barHeight:x,x:i,y:u.start<0&&u.end<0?f:p,goalY:this.barHelpers.getGoalValues("y",null,o,l,h,d),barXPosition:r}}},{key:"preventBarOverflow",value:function(t){var e=this.w;return t<0&&(t=0),t>e.globals.gridWidth&&(t=e.globals.gridWidth),t}},{key:"drawRangeBarPaths",value:function(t){var e=t.indexes,i=t.y,a=t.y1,s=t.y2,r=t.yDivision,o=t.barHeight,n=t.barYPosition,l=t.zeroW,h=this.w,c=e.realIndex,d=e.j,g=this.preventBarOverflow(l+a/this.invertedYRatio),u=this.preventBarOverflow(l+s/this.invertedYRatio),f=this.getRangeValue(c,d),p=Math.abs(u-g),x=this.barHelpers.getBarpaths({barYPosition:n,barHeight:o,x1:g,x2:u,strokeWidth:this.strokeWidth,series:this.seriesRangeEnd,i:c,realIndex:c,j:d,w:h});return h.globals.isXNumeric||(i+=r),{pathTo:x.pathTo,pathFrom:x.pathFrom,barWidth:p,x:f.start<0&&f.end<0?g:u,goalX:this.barHelpers.getGoalValues("x",l,null,c,d),y:i}}},{key:"getRangeValue",value:function(t,e){var i=this.w;return{start:i.globals.seriesRangeStart[t][e],end:i.globals.seriesRangeEnd[t][e]}}}]),a}(St),Yt=function(){function t(e){i(this,t),this.w=e.w,this.lineCtx=e}return s(t,[{key:"sameValueSeriesFix",value:function(t,e){var i=this.w;if(("gradient"===i.config.fill.type||"gradient"===i.config.fill.type[t])&&new A(this.lineCtx.ctx,i).seriesHaveSameValues(t)){var a=e[t].slice();a[a.length-1]=a[a.length-1]+1e-6,e[t]=a}return e}},{key:"calculatePoints",value:function(t){var e=t.series,i=t.realIndex,a=t.x,s=t.y,r=t.i,o=t.j,n=t.prevY,l=this.w,h=[],c=[];if(0===o){var d=this.lineCtx.categoryAxisCorrection+l.config.markers.offsetX;l.globals.isXNumeric&&(d=(l.globals.seriesX[i][0]-l.globals.minX)/this.lineCtx.xRatio+l.config.markers.offsetX),h.push(d),c.push(m.isNumber(e[r][0])?n+l.config.markers.offsetY:null),h.push(a+l.config.markers.offsetX),c.push(m.isNumber(e[r][o+1])?s+l.config.markers.offsetY:null)}else h.push(a+l.config.markers.offsetX),c.push(m.isNumber(e[r][o+1])?s+l.config.markers.offsetY:null);return{x:h,y:c}}},{key:"checkPreviousPaths",value:function(t){for(var e=t.pathFromLine,i=t.pathFromArea,a=t.realIndex,s=this.w,r=0;r<s.globals.previousPaths.length;r++){var o=s.globals.previousPaths[r];("line"===o.type||"area"===o.type)&&o.paths.length>0&&parseInt(o.realIndex,10)===parseInt(a,10)&&("line"===o.type?(this.lineCtx.appendPathFrom=!1,e=s.globals.previousPaths[r].paths[0].d):"area"===o.type&&(this.lineCtx.appendPathFrom=!1,i=s.globals.previousPaths[r].paths[0].d,s.config.stroke.show&&s.globals.previousPaths[r].paths[1]&&(e=s.globals.previousPaths[r].paths[1].d)))}return{pathFromLine:e,pathFromArea:i}}},{key:"determineFirstPrevY",value:function(t){var e,i,a,s=t.i,r=t.realIndex,o=t.series,n=t.prevY,l=t.lineYPosition,h=t.translationsIndex,c=this.w,d=c.config.chart.stacked&&!c.globals.comboCharts||c.config.chart.stacked&&c.globals.comboCharts&&(!this.w.config.chart.stackOnlyBar||"bar"===(null===(e=this.w.config.series[r])||void 0===e?void 0:e.type)||"column"===(null===(i=this.w.config.series[r])||void 0===i?void 0:i.type));if(void 0!==(null===(a=o[s])||void 0===a?void 0:a[0]))n=(l=d&&s>0?this.lineCtx.prevSeriesY[s-1][0]:this.lineCtx.zeroY)-o[s][0]/this.lineCtx.yRatio[h]+2*(this.lineCtx.isReversed?o[s][0]/this.lineCtx.yRatio[h]:0);else if(d&&s>0&&void 0===o[s][0])for(var g=s-1;g>=0;g--)if(null!==o[g][0]&&void 0!==o[g][0]){n=l=this.lineCtx.prevSeriesY[g][0];break}return{prevY:n,lineYPosition:l}}}]),t}(),Rt=function(t){for(var e,i,a,s,r=function(t){for(var e=[],i=t[0],a=t[1],s=e[0]=Ht(i,a),r=1,o=t.length-1;r<o;r++)i=a,a=t[r+1],e[r]=.5*(s+(s=Ht(i,a)));return e[r]=s,e}(t),o=t.length-1,n=[],l=0;l<o;l++)a=Ht(t[l],t[l+1]),Math.abs(a)<1e-6?r[l]=r[l+1]=0:(s=(e=r[l]/a)*e+(i=r[l+1]/a)*i)>9&&(s=3*a/Math.sqrt(s),r[l]=s*e,r[l+1]=s*i);for(var h=0;h<=o;h++)s=(t[Math.min(o,h+1)][0]-t[Math.max(0,h-1)][0])/(6*(1+r[h]*r[h])),n.push([s||0,r[h]*s||0]);return n},Ft=function(t){var e=Rt(t),i=t[1],a=t[0],s=[],r=e[1],o=e[0];s.push(a,[a[0]+o[0],a[1]+o[1],i[0]-r[0],i[1]-r[1],i[0],i[1]]);for(var n=2,l=e.length;n<l;n++){var h=t[n],c=e[n];s.push([h[0]-c[0],h[1]-c[1],h[0],h[1]])}return s},Dt=function(t,e,i){var a=t.slice(e,i);if(e){if(i-e>1&&a[1].length<6){var s=a[0].length;a[1]=[2*a[0][s-2]-a[0][s-4],2*a[0][s-1]-a[0][s-3]].concat(a[1])}a[0]=a[0].slice(-2)}return a};function Ht(t,e){return(e[1]-t[1])/(e[0]-t[0])}var Ot=function(){function t(e,a,s){i(this,t),this.ctx=e,this.w=e.w,this.xyRatios=a,this.pointsChart=!("bubble"!==this.w.config.chart.type&&"scatter"!==this.w.config.chart.type)||s,this.scatter=new B(this.ctx),this.noNegatives=this.w.globals.minX===Number.MAX_VALUE,this.lineHelpers=new Yt(this),this.markers=new W(this.ctx),this.prevSeriesY=[],this.categoryAxisCorrection=0,this.yaxisIndex=0}return s(t,[{key:"draw",value:function(t,e,i,a){var s,r=this.w,o=new k(this.ctx),n=r.globals.comboCharts?e:r.config.chart.type,l=o.group({class:"apexcharts-".concat(n,"-series apexcharts-plot-series")}),h=new A(this.ctx,r);this.yRatio=this.xyRatios.yRatio,this.zRatio=this.xyRatios.zRatio,this.xRatio=this.xyRatios.xRatio,this.baseLineY=this.xyRatios.baseLineY,t=h.getLogSeries(t),this.yRatio=h.getLogYRatios(this.yRatio),this.prevSeriesY=[];for(var c=[],d=0;d<t.length;d++){t=this.lineHelpers.sameValueSeriesFix(d,t);var u=r.globals.comboCharts?i[d]:d,f=this.yRatio.length>1?u:0;this._initSerieVariables(t,d,u);var p=[],x=[],b=[],v=r.globals.padHorizontal+this.categoryAxisCorrection;this.ctx.series.addCollapsedClassToSeries(this.elSeries,u),r.globals.isXNumeric&&r.globals.seriesX.length>0&&(v=(r.globals.seriesX[u][0]-r.globals.minX)/this.xRatio),b.push(v);var m,y=v,w=void 0,S=y,C=this.zeroY,L=this.zeroY;C=this.lineHelpers.determineFirstPrevY({i:d,realIndex:u,series:t,prevY:C,lineYPosition:0,translationsIndex:f}).prevY,"monotoneCubic"===r.config.stroke.curve&&null===t[d][0]?p.push(null):p.push(C),m=C;"rangeArea"===n&&(w=L=this.lineHelpers.determineFirstPrevY({i:d,realIndex:u,series:a,prevY:L,lineYPosition:0,translationsIndex:f}).prevY,x.push(null!==p[0]?L:null));var P=this._calculatePathsFrom({type:n,series:t,i:d,realIndex:u,translationsIndex:f,prevX:S,prevY:C,prevY2:L}),M=[p[0]],I=[x[0]],T={type:n,series:t,realIndex:u,translationsIndex:f,i:d,x:v,y:1,pX:y,pY:m,pathsFrom:P,linePaths:[],areaPaths:[],seriesIndex:i,lineYPosition:0,xArrj:b,yArrj:p,y2Arrj:x,seriesRangeEnd:a},z=this._iterateOverDataPoints(g(g({},T),{},{iterations:"rangeArea"===n?t[d].length-1:void 0,isRangeStart:!0}));if("rangeArea"===n){for(var X=this._calculatePathsFrom({series:a,i:d,realIndex:u,prevX:S,prevY:L}),E=this._iterateOverDataPoints(g(g({},T),{},{series:a,xArrj:[v],yArrj:M,y2Arrj:I,pY:w,areaPaths:z.areaPaths,pathsFrom:X,iterations:a[d].length-1,isRangeStart:!1})),Y=z.linePaths.length/2,R=0;R<Y;R++)z.linePaths[R]=E.linePaths[R+Y]+z.linePaths[R];z.linePaths.splice(Y),z.pathFromLine=E.pathFromLine+z.pathFromLine}else z.pathFromArea+="z";this._handlePaths({type:n,realIndex:u,i:d,paths:z}),this.elSeries.add(this.elPointsMain),this.elSeries.add(this.elDataLabelsWrap),c.push(this.elSeries)}if(void 0!==(null===(s=r.config.series[0])||void 0===s?void 0:s.zIndex)&&c.sort((function(t,e){return Number(t.node.getAttribute("zIndex"))-Number(e.node.getAttribute("zIndex"))})),r.config.chart.stacked)for(var F=c.length-1;F>=0;F--)l.add(c[F]);else for(var D=0;D<c.length;D++)l.add(c[D]);return l}},{key:"_initSerieVariables",value:function(t,e,i){var a=this.w,s=new k(this.ctx);this.xDivision=a.globals.gridWidth/(a.globals.dataPoints-("on"===a.config.xaxis.tickPlacement?1:0)),this.strokeWidth=Array.isArray(a.config.stroke.width)?a.config.stroke.width[i]:a.config.stroke.width;var r=0;this.yRatio.length>1&&(this.yaxisIndex=a.globals.seriesYAxisReverseMap[i],r=i),this.isReversed=a.config.yaxis[this.yaxisIndex]&&a.config.yaxis[this.yaxisIndex].reversed,this.zeroY=a.globals.gridHeight-this.baseLineY[r]-(this.isReversed?a.globals.gridHeight:0)+(this.isReversed?2*this.baseLineY[r]:0),this.areaBottomY=this.zeroY,(this.zeroY>a.globals.gridHeight||"end"===a.config.plotOptions.area.fillTo)&&(this.areaBottomY=a.globals.gridHeight),this.categoryAxisCorrection=this.xDivision/2,this.elSeries=s.group({class:"apexcharts-series",zIndex:void 0!==a.config.series[i].zIndex?a.config.series[i].zIndex:i,seriesName:m.escapeString(a.globals.seriesNames[i])}),this.elPointsMain=s.group({class:"apexcharts-series-markers-wrap","data:realIndex":i}),this.elDataLabelsWrap=s.group({class:"apexcharts-datalabels","data:realIndex":i});var o=t[e].length===a.globals.dataPoints;this.elSeries.attr({"data:longestSeries":o,rel:e+1,"data:realIndex":i}),this.appendPathFrom=!0}},{key:"_calculatePathsFrom",value:function(t){var e,i,a,s,r=t.type,o=t.series,n=t.i,l=t.realIndex,h=t.translationsIndex,c=t.prevX,d=t.prevY,g=t.prevY2,u=this.w,f=new k(this.ctx);if(null===o[n][0]){for(var p=0;p<o[n].length;p++)if(null!==o[n][p]){c=this.xDivision*p,d=this.zeroY-o[n][p]/this.yRatio[h],e=f.move(c,d),i=f.move(c,this.areaBottomY);break}}else e=f.move(c,d),"rangeArea"===r&&(e=f.move(c,g)+f.line(c,d)),i=f.move(c,this.areaBottomY)+f.line(c,d);if(a=f.move(0,this.zeroY)+f.line(0,this.zeroY),s=f.move(0,this.zeroY)+f.line(0,this.zeroY),u.globals.previousPaths.length>0){var x=this.lineHelpers.checkPreviousPaths({pathFromLine:a,pathFromArea:s,realIndex:l});a=x.pathFromLine,s=x.pathFromArea}return{prevX:c,prevY:d,linePath:e,areaPath:i,pathFromLine:a,pathFromArea:s}}},{key:"_handlePaths",value:function(t){var e=t.type,i=t.realIndex,a=t.i,s=t.paths,r=this.w,o=new k(this.ctx),n=new N(this.ctx);this.prevSeriesY.push(s.yArrj),r.globals.seriesXvalues[i]=s.xArrj,r.globals.seriesYvalues[i]=s.yArrj;var l=r.config.forecastDataPoints;if(l.count>0&&"rangeArea"!==e){var h=r.globals.seriesXvalues[i][r.globals.seriesXvalues[i].length-l.count-1],c=o.drawRect(h,0,r.globals.gridWidth,r.globals.gridHeight,0);r.globals.dom.elForecastMask.appendChild(c.node);var d=o.drawRect(0,0,h,r.globals.gridHeight,0);r.globals.dom.elNonForecastMask.appendChild(d.node)}this.pointsChart||r.globals.delayedElements.push({el:this.elPointsMain.node,index:i});var u={i:a,realIndex:i,animationDelay:a,initialSpeed:r.config.chart.animations.speed,dataChangeSpeed:r.config.chart.animations.dynamicAnimation.speed,className:"apexcharts-".concat(e)};if("area"===e)for(var f=n.fillPath({seriesNumber:i}),p=0;p<s.areaPaths.length;p++){var x=o.renderPaths(g(g({},u),{},{pathFrom:s.pathFromArea,pathTo:s.areaPaths[p],stroke:"none",strokeWidth:0,strokeLineCap:null,fill:f}));this.elSeries.add(x)}if(r.config.stroke.show&&!this.pointsChart){var b=null;if("line"===e)b=n.fillPath({seriesNumber:i,i:a});else if("solid"===r.config.stroke.fill.type)b=r.globals.stroke.colors[i];else{var v=r.config.fill;r.config.fill=r.config.stroke.fill,b=n.fillPath({seriesNumber:i,i:a}),r.config.fill=v}for(var m=0;m<s.linePaths.length;m++){var y=b;"rangeArea"===e&&(y=n.fillPath({seriesNumber:i}));var w=g(g({},u),{},{pathFrom:s.pathFromLine,pathTo:s.linePaths[m],stroke:b,strokeWidth:this.strokeWidth,strokeLineCap:r.config.stroke.lineCap,fill:"rangeArea"===e?y:"none"}),A=o.renderPaths(w);if(this.elSeries.add(A),A.attr("fill-rule","evenodd"),l.count>0&&"rangeArea"!==e){var S=o.renderPaths(w);S.node.setAttribute("stroke-dasharray",l.dashArray),l.strokeWidth&&S.node.setAttribute("stroke-width",l.strokeWidth),this.elSeries.add(S),S.attr("clip-path","url(#forecastMask".concat(r.globals.cuid,")")),A.attr("clip-path","url(#nonForecastMask".concat(r.globals.cuid,")"))}}}}},{key:"_iterateOverDataPoints",value:function(t){var e,i,a=this,s=t.type,r=t.series,o=t.iterations,n=t.realIndex,l=t.translationsIndex,h=t.i,c=t.x,d=t.y,g=t.pX,u=t.pY,f=t.pathsFrom,p=t.linePaths,x=t.areaPaths,b=t.seriesIndex,v=t.lineYPosition,y=t.xArrj,w=t.yArrj,A=t.y2Arrj,S=t.isRangeStart,C=t.seriesRangeEnd,L=this.w,P=new k(this.ctx),M=this.yRatio,I=f.prevY,T=f.linePath,z=f.areaPath,X=f.pathFromLine,E=f.pathFromArea,Y=m.isNumber(L.globals.minYArr[n])?L.globals.minYArr[n]:L.globals.minY;o||(o=L.globals.dataPoints>1?L.globals.dataPoints-1:L.globals.dataPoints);var R=function(t,e){return e-t/M[l]+2*(a.isReversed?t/M[l]:0)},F=d,D=L.config.chart.stacked&&!L.globals.comboCharts||L.config.chart.stacked&&L.globals.comboCharts&&(!this.w.config.chart.stackOnlyBar||"bar"===(null===(e=this.w.config.series[n])||void 0===e?void 0:e.type)||"column"===(null===(i=this.w.config.series[n])||void 0===i?void 0:i.type)),H=L.config.stroke.curve;Array.isArray(H)&&(H=Array.isArray(b)?H[b[h]]:H[h]);for(var O,N=0,W=0;W<o;W++){var B=void 0===r[h][W+1]||null===r[h][W+1];if(L.globals.isXNumeric){var G=L.globals.seriesX[n][W+1];void 0===L.globals.seriesX[n][W+1]&&(G=L.globals.seriesX[n][o-1]),c=(G-L.globals.minX)/this.xRatio}else c+=this.xDivision;if(D)if(h>0&&L.globals.collapsedSeries.length<L.config.series.length-1){v=this.prevSeriesY[function(t){for(var e=t;e>0;e--){if(!(L.globals.collapsedSeriesIndices.indexOf((null==b?void 0:b[e])||e)>-1))return e;e--}return 0}(h-1)][W+1]}else v=this.zeroY;else v=this.zeroY;B?d=R(Y,v):(d=R(r[h][W+1],v),"rangeArea"===s&&(F=R(C[h][W+1],v))),y.push(c),!B||"smooth"!==L.config.stroke.curve&&"monotoneCubic"!==L.config.stroke.curve?(w.push(d),A.push(F)):(w.push(null),A.push(null));var V=this.lineHelpers.calculatePoints({series:r,x:c,y:d,realIndex:n,i:h,j:W,prevY:I}),j=this._createPaths({type:s,series:r,i:h,realIndex:n,j:W,x:c,y:d,y2:F,xArrj:y,yArrj:w,y2Arrj:A,pX:g,pY:u,pathState:N,segmentStartX:O,linePath:T,areaPath:z,linePaths:p,areaPaths:x,curve:H,isRangeStart:S});x=j.areaPaths,p=j.linePaths,g=j.pX,u=j.pY,N=j.pathState,O=j.segmentStartX,z=j.areaPath,T=j.linePath,!this.appendPathFrom||"monotoneCubic"===H&&"rangeArea"===s||(X+=P.line(c,this.zeroY),E+=P.line(c,this.zeroY)),this.handleNullDataPoints(r,V,h,W,n),this._handleMarkersAndLabels({type:s,pointsPos:V,i:h,j:W,realIndex:n,isRangeStart:S})}return{yArrj:w,xArrj:y,pathFromArea:E,areaPaths:x,pathFromLine:X,linePaths:p,linePath:T,areaPath:z}}},{key:"_handleMarkersAndLabels",value:function(t){var e=t.type,i=t.pointsPos,a=t.isRangeStart,s=t.i,r=t.j,o=t.realIndex,n=this.w,l=new G(this.ctx);if(this.pointsChart)this.scatter.draw(this.elSeries,r,{realIndex:o,pointsPos:i,zRatio:this.zRatio,elParent:this.elPointsMain});else{n.globals.series[s].length>1&&this.elPointsMain.node.classList.add("apexcharts-element-hidden");var h=this.markers.plotChartMarkers(i,o,r+1);null!==h&&this.elPointsMain.add(h)}var c=l.drawDataLabel({type:e,isRangeStart:a,pos:i,i:o,j:r+1});null!==c&&this.elDataLabelsWrap.add(c)}},{key:"_createPaths",value:function(t){var e=t.type,i=t.series,a=t.i;t.realIndex;var s,r=t.j,o=t.x,n=t.y,l=t.xArrj,h=t.yArrj,c=t.y2,d=t.y2Arrj,g=t.pX,u=t.pY,f=t.pathState,p=t.segmentStartX,x=t.linePath,b=t.areaPath,v=t.linePaths,m=t.areaPaths,y=t.curve,w=t.isRangeStart,A=new k(this.ctx),S=this.areaBottomY,C="rangeArea"===e,L="rangeArea"===e&&w;switch(y){case"monotoneCubic":var P=w?h:d;switch(f){case 0:if(null===P[r+1])break;f=1;case 1:if(!(C?l.length===i[a].length:r===i[a].length-2))break;case 2:var M=w?l:l.slice().reverse(),I=w?P:P.slice().reverse(),T=(s=I,M.map((function(t,e){return[t,s[e]]})).filter((function(t){return null!==t[1]}))),z=T.length>1?Ft(T):T,X=[];C&&(L?m=T:X=m.reverse());var E=0,Y=0;if(function(t,e){for(var i=function(t){var e=[],i=0;return t.forEach((function(t){null!==t?i++:i>0&&(e.push(i),i=0)})),i>0&&e.push(i),e}(t),a=[],s=0,r=0;s<i.length;r+=i[s++])a[s]=Dt(e,r,r+i[s]);return a}(I,z).forEach((function(t){E++;var e=function(t){for(var e="",i=0;i<t.length;i++){var a=t[i],s=a.length;s>4?(e+="C".concat(a[0],", ").concat(a[1]),e+=", ".concat(a[2],", ").concat(a[3]),e+=", ".concat(a[4],", ").concat(a[5])):s>2&&(e+="S".concat(a[0],", ").concat(a[1]),e+=", ".concat(a[2],", ").concat(a[3]))}return e}(t),i=Y,a=(Y+=t.length)-1;L?x=A.move(T[i][0],T[i][1])+e:C?x=A.move(X[i][0],X[i][1])+A.line(T[i][0],T[i][1])+e+A.line(X[a][0],X[a][1]):(x=A.move(T[i][0],T[i][1])+e,b=x+A.line(T[a][0],S)+A.line(T[i][0],S)+"z",m.push(b)),v.push(x)})),C&&E>1&&!L){var R=v.slice(E).reverse();v.splice(E),R.forEach((function(t){return v.push(t)}))}f=0}break;case"smooth":var F=.35*(o-g);if(null===i[a][r])f=0;else switch(f){case 0:if(p=g,x=L?A.move(g,d[r])+A.line(g,u):A.move(g,u),b=A.move(g,u),null===i[a][r+1]){v.push(x),m.push(b);break}if(f=1,r<i[a].length-2){var D=A.curve(g+F,u,o-F,n,o,n);x+=D,b+=D;break}case 1:if(null===i[a][r+1])x+=L?A.line(g,c):A.move(g,u),b+=A.line(g,S)+A.line(p,S)+"z",v.push(x),m.push(b),f=-1;else{var H=A.curve(g+F,u,o-F,n,o,n);x+=H,b+=H,r>=i[a].length-2&&(L&&(x+=A.curve(o,n,o,n,o,c)+A.move(o,c)),b+=A.curve(o,n,o,n,o,S)+A.line(p,S)+"z",v.push(x),m.push(b),f=-1)}}g=o,u=n;break;default:var O=function(t,e,i){var a=[];switch(t){case"stepline":a=A.line(e,null,"H")+A.line(null,i,"V");break;case"linestep":a=A.line(null,i,"V")+A.line(e,null,"H");break;case"straight":a=A.line(e,i)}return a};if(null===i[a][r])f=0;else switch(f){case 0:if(p=g,x=L?A.move(g,d[r])+A.line(g,u):A.move(g,u),b=A.move(g,u),null===i[a][r+1]){v.push(x),m.push(b);break}if(f=1,r<i[a].length-2){var N=O(y,o,n);x+=N,b+=N;break}case 1:if(null===i[a][r+1])x+=L?A.line(g,c):A.move(g,u),b+=A.line(g,S)+A.line(p,S)+"z",v.push(x),m.push(b),f=-1;else{var W=O(y,o,n);x+=W,b+=W,r>=i[a].length-2&&(L&&(x+=A.line(o,c)),b+=A.line(o,S)+A.line(p,S)+"z",v.push(x),m.push(b),f=-1)}}g=o,u=n}return{linePaths:v,areaPaths:m,pX:g,pY:u,pathState:f,segmentStartX:p,linePath:x,areaPath:b}}},{key:"handleNullDataPoints",value:function(t,e,i,a,s){var r=this.w;if(null===t[i][a]&&r.config.markers.showNullDataPoints||1===t[i].length){var o=this.strokeWidth-r.config.markers.strokeWidth/2;o>0||(o=0);var n=this.markers.plotChartMarkers(e,s,a+1,o,!0);null!==n&&this.elPointsMain.add(n)}}}]),t}();window.TreemapSquared={},window.TreemapSquared.generate=function(){function t(e,i,a,s){this.xoffset=e,this.yoffset=i,this.height=s,this.width=a,this.shortestEdge=function(){return Math.min(this.height,this.width)},this.getCoordinates=function(t){var e,i=[],a=this.xoffset,s=this.yoffset,o=r(t)/this.height,n=r(t)/this.width;if(this.width>=this.height)for(e=0;e<t.length;e++)i.push([a,s,a+o,s+t[e]/o]),s+=t[e]/o;else for(e=0;e<t.length;e++)i.push([a,s,a+t[e]/n,s+n]),a+=t[e]/n;return i},this.cutArea=function(e){var i;if(this.width>=this.height){var a=e/this.height,s=this.width-a;i=new t(this.xoffset+a,this.yoffset,s,this.height)}else{var r=e/this.width,o=this.height-r;i=new t(this.xoffset,this.yoffset+r,this.width,o)}return i}}function e(e,a,s,o,n){o=void 0===o?0:o,n=void 0===n?0:n;var l=i(function(t,e){var i,a=[],s=e/r(t);for(i=0;i<t.length;i++)a[i]=t[i]*s;return a}(e,a*s),[],new t(o,n,a,s),[]);return function(t){var e,i,a=[];for(e=0;e<t.length;e++)for(i=0;i<t[e].length;i++)a.push(t[e][i]);return a}(l)}function i(t,e,s,o){var n,l,h;if(0!==t.length)return n=s.shortestEdge(),function(t,e,i){var s;if(0===t.length)return!0;(s=t.slice()).push(e);var r=a(t,i),o=a(s,i);return r>=o}(e,l=t[0],n)?(e.push(l),i(t.slice(1),e,s,o)):(h=s.cutArea(r(e),o),o.push(s.getCoordinates(e)),i(t,[],h,o)),o;o.push(s.getCoordinates(e))}function a(t,e){var i=Math.min.apply(Math,t),a=Math.max.apply(Math,t),s=r(t);return Math.max(Math.pow(e,2)*a/Math.pow(s,2),Math.pow(s,2)/(Math.pow(e,2)*i))}function s(t){return t&&t.constructor===Array}function r(t){var e,i=0;for(e=0;e<t.length;e++)i+=t[e];return i}function o(t){var e,i=0;if(s(t[0]))for(e=0;e<t.length;e++)i+=o(t[e]);else i=r(t);return i}return function t(i,a,r,n,l){n=void 0===n?0:n,l=void 0===l?0:l;var h,c,d=[],g=[];if(s(i[0])){for(c=0;c<i.length;c++)d[c]=o(i[c]);for(h=e(d,a,r,n,l),c=0;c<i.length;c++)g.push(t(i[c],h[c][2]-h[c][0],h[c][3]-h[c][1],h[c][0],h[c][1]))}else g=e(i,a,r,n,l);return g}}();var Nt,Wt,Bt=function(){function t(e,a){i(this,t),this.ctx=e,this.w=e.w,this.strokeWidth=this.w.config.stroke.width,this.helpers=new Pt(e),this.dynamicAnim=this.w.config.chart.animations.dynamicAnimation,this.labels=[]}return s(t,[{key:"draw",value:function(t){var e=this,i=this.w,a=new k(this.ctx),s=new N(this.ctx),r=a.group({class:"apexcharts-treemap"});if(i.globals.noData)return r;var o=[];return t.forEach((function(t){var e=t.map((function(t){return Math.abs(t)}));o.push(e)})),this.negRange=this.helpers.checkColorRange(),i.config.series.forEach((function(t,i){t.data.forEach((function(t){Array.isArray(e.labels[i])||(e.labels[i]=[]),e.labels[i].push(t.x)}))})),window.TreemapSquared.generate(o,i.globals.gridWidth,i.globals.gridHeight).forEach((function(o,n){var l=a.group({class:"apexcharts-series apexcharts-treemap-series",seriesName:m.escapeString(i.globals.seriesNames[n]),rel:n+1,"data:realIndex":n});if(i.config.chart.dropShadow.enabled){var h=i.config.chart.dropShadow;new w(e.ctx).dropShadow(r,h,n)}var c=a.group({class:"apexcharts-data-labels"});o.forEach((function(r,o){var h=r[0],c=r[1],d=r[2],g=r[3],u=a.drawRect(h,c,d-h,g-c,i.config.plotOptions.treemap.borderRadius,"#fff",1,e.strokeWidth,i.config.plotOptions.treemap.useFillColorAsStroke?p:i.globals.stroke.colors[n]);u.attr({cx:h,cy:c,index:n,i:n,j:o,width:d-h,height:g-c});var f=e.helpers.getShadeColor(i.config.chart.type,n,o,e.negRange),p=f.color;void 0!==i.config.series[n].data[o]&&i.config.series[n].data[o].fillColor&&(p=i.config.series[n].data[o].fillColor);var x=s.fillPath({color:p,seriesNumber:n,dataPointIndex:o});u.node.classList.add("apexcharts-treemap-rect"),u.attr({fill:x}),e.helpers.addListeners(u);var b={x:h+(d-h)/2,y:c+(g-c)/2,width:0,height:0},v={x:h,y:c,width:d-h,height:g-c};if(i.config.chart.animations.enabled&&!i.globals.dataChanged){var m=1;i.globals.resized||(m=i.config.chart.animations.speed),e.animateTreemap(u,b,v,m)}if(i.globals.dataChanged){var y=1;e.dynamicAnim.enabled&&i.globals.shouldAnimate&&(y=e.dynamicAnim.speed,i.globals.previousPaths[n]&&i.globals.previousPaths[n][o]&&i.globals.previousPaths[n][o].rect&&(b=i.globals.previousPaths[n][o].rect),e.animateTreemap(u,b,v,y))}var w=e.getFontSize(r),k=i.config.dataLabels.formatter(e.labels[n][o],{value:i.globals.series[n][o],seriesIndex:n,dataPointIndex:o,w:i});"truncate"===i.config.plotOptions.treemap.dataLabels.format&&(w=parseInt(i.config.dataLabels.style.fontSize,10),k=e.truncateLabels(k,w,h,c,d,g));var A=null;i.globals.series[n][o]&&(A=e.helpers.calculateDataLabels({text:k,x:(h+d)/2,y:(c+g)/2+e.strokeWidth/2+w/3,i:n,j:o,colorProps:f,fontSize:w,series:t})),i.config.dataLabels.enabled&&A&&e.rotateToFitLabel(A,w,k,h,c,d,g),l.add(u),null!==A&&l.add(A)})),l.add(c),r.add(l)})),r}},{key:"getFontSize",value:function(t){var e=this.w;var i,a,s,r,o=function t(e){var i,a=0;if(Array.isArray(e[0]))for(i=0;i<e.length;i++)a+=t(e[i]);else for(i=0;i<e.length;i++)a+=e[i].length;return a}(this.labels)/function t(e){var i,a=0;if(Array.isArray(e[0]))for(i=0;i<e.length;i++)a+=t(e[i]);else for(i=0;i<e.length;i++)a+=1;return a}(this.labels);return i=t[2]-t[0],a=t[3]-t[1],s=i*a,r=Math.pow(s,.5),Math.min(r/o,parseInt(e.config.dataLabels.style.fontSize,10))}},{key:"rotateToFitLabel",value:function(t,e,i,a,s,r,o){var n=new k(this.ctx),l=n.getTextRects(i,e);if(l.width+this.w.config.stroke.width+5>r-a&&l.width<=o-s){var h=n.rotateAroundCenter(t.node);t.node.setAttribute("transform","rotate(-90 ".concat(h.x," ").concat(h.y,") translate(").concat(l.height/3,")"))}}},{key:"truncateLabels",value:function(t,e,i,a,s,r){var o=new k(this.ctx),n=o.getTextRects(t,e).width+this.w.config.stroke.width+5>s-i&&r-a>s-i?r-a:s-i,l=o.getTextBasedOnMaxWidth({text:t,maxWidth:n,fontSize:e});return t.length!==l.length&&n/e<5?"":l}},{key:"animateTreemap",value:function(t,e,i,a){var s=new y(this.ctx);s.animateRect(t,{x:e.x,y:e.y,width:e.width,height:e.height},{x:i.x,y:i.y,width:i.width,height:i.height},a,(function(){s.animationCompleted(t)}))}}]),t}(),Gt=86400,Vt=10/Gt,jt=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w,this.timeScaleArray=[],this.utc=this.w.config.xaxis.labels.datetimeUTC}return s(t,[{key:"calculateTimeScaleTicks",value:function(t,e){var i=this,a=this.w;if(a.globals.allSeriesCollapsed)return a.globals.labels=[],a.globals.timescaleLabels=[],[];var s=new L(this.ctx),r=(e-t)/864e5;this.determineInterval(r),a.globals.disableZoomIn=!1,a.globals.disableZoomOut=!1,r<Vt?a.globals.disableZoomIn=!0:r>5e4&&(a.globals.disableZoomOut=!0);var o=s.getTimeUnitsfromTimestamp(t,e,this.utc),n=a.globals.gridWidth/r,l=n/24,h=l/60,c=h/60,d=Math.floor(24*r),u=Math.floor(1440*r),f=Math.floor(r*Gt),p=Math.floor(r),x=Math.floor(r/30),b=Math.floor(r/365),v={minMillisecond:o.minMillisecond,minSecond:o.minSecond,minMinute:o.minMinute,minHour:o.minHour,minDate:o.minDate,minMonth:o.minMonth,minYear:o.minYear},m={firstVal:v,currentMillisecond:v.minMillisecond,currentSecond:v.minSecond,currentMinute:v.minMinute,currentHour:v.minHour,currentMonthDate:v.minDate,currentDate:v.minDate,currentMonth:v.minMonth,currentYear:v.minYear,daysWidthOnXAxis:n,hoursWidthOnXAxis:l,minutesWidthOnXAxis:h,secondsWidthOnXAxis:c,numberOfSeconds:f,numberOfMinutes:u,numberOfHours:d,numberOfDays:p,numberOfMonths:x,numberOfYears:b};switch(this.tickInterval){case"years":this.generateYearScale(m);break;case"months":case"half_year":this.generateMonthScale(m);break;case"months_days":case"months_fortnight":case"days":case"week_days":this.generateDayScale(m);break;case"hours":this.generateHourScale(m);break;case"minutes_fives":case"minutes":this.generateMinuteScale(m);break;case"seconds_tens":case"seconds_fives":case"seconds":this.generateSecondScale(m)}var y=this.timeScaleArray.map((function(t){var e={position:t.position,unit:t.unit,year:t.year,day:t.day?t.day:1,hour:t.hour?t.hour:0,month:t.month+1};return"month"===t.unit?g(g({},e),{},{day:1,value:t.value+1}):"day"===t.unit||"hour"===t.unit?g(g({},e),{},{value:t.value}):"minute"===t.unit?g(g({},e),{},{value:t.value,minute:t.value}):"second"===t.unit?g(g({},e),{},{value:t.value,minute:t.minute,second:t.second}):t}));return y.filter((function(t){var e=1,s=Math.ceil(a.globals.gridWidth/120),r=t.value;void 0!==a.config.xaxis.tickAmount&&(s=a.config.xaxis.tickAmount),y.length>s&&(e=Math.floor(y.length/s));var o=!1,n=!1;switch(i.tickInterval){case"years":"year"===t.unit&&(o=!0);break;case"half_year":e=7,"year"===t.unit&&(o=!0);break;case"months":e=1,"year"===t.unit&&(o=!0);break;case"months_fortnight":e=15,"year"!==t.unit&&"month"!==t.unit||(o=!0),30===r&&(n=!0);break;case"months_days":e=10,"month"===t.unit&&(o=!0),30===r&&(n=!0);break;case"week_days":e=8,"month"===t.unit&&(o=!0);break;case"days":e=1,"month"===t.unit&&(o=!0);break;case"hours":"day"===t.unit&&(o=!0);break;case"minutes_fives":case"seconds_fives":r%5!=0&&(n=!0);break;case"seconds_tens":r%10!=0&&(n=!0)}if("hours"===i.tickInterval||"minutes_fives"===i.tickInterval||"seconds_tens"===i.tickInterval||"seconds_fives"===i.tickInterval){if(!n)return!0}else if((r%e==0||o)&&!n)return!0}))}},{key:"recalcDimensionsBasedOnFormat",value:function(t,e){var i=this.w,a=this.formatDates(t),s=this.removeOverlappingTS(a);i.globals.timescaleLabels=s.slice(),new ct(this.ctx).plotCoords()}},{key:"determineInterval",value:function(t){var e=24*t,i=60*e;switch(!0){case t/365>5:this.tickInterval="years";break;case t>800:this.tickInterval="half_year";break;case t>180:this.tickInterval="months";break;case t>90:this.tickInterval="months_fortnight";break;case t>60:this.tickInterval="months_days";break;case t>30:this.tickInterval="week_days";break;case t>2:this.tickInterval="days";break;case e>2.4:this.tickInterval="hours";break;case i>15:this.tickInterval="minutes_fives";break;case i>5:this.tickInterval="minutes";break;case i>1:this.tickInterval="seconds_tens";break;case 60*i>20:this.tickInterval="seconds_fives";break;default:this.tickInterval="seconds"}}},{key:"generateYearScale",value:function(t){var e=t.firstVal,i=t.currentMonth,a=t.currentYear,s=t.daysWidthOnXAxis,r=t.numberOfYears,o=e.minYear,n=0,l=new L(this.ctx),h="year";if(e.minDate>1||e.minMonth>0){var c=l.determineRemainingDaysOfYear(e.minYear,e.minMonth,e.minDate);n=(l.determineDaysOfYear(e.minYear)-c+1)*s,o=e.minYear+1,this.timeScaleArray.push({position:n,value:o,unit:h,year:o,month:m.monthMod(i+1)})}else 1===e.minDate&&0===e.minMonth&&this.timeScaleArray.push({position:n,value:o,unit:h,year:a,month:m.monthMod(i+1)});for(var d=o,g=n,u=0;u<r;u++)d++,g=l.determineDaysOfYear(d-1)*s+g,this.timeScaleArray.push({position:g,value:d,unit:h,year:d,month:1})}},{key:"generateMonthScale",value:function(t){var e=t.firstVal,i=t.currentMonthDate,a=t.currentMonth,s=t.currentYear,r=t.daysWidthOnXAxis,o=t.numberOfMonths,n=a,l=0,h=new L(this.ctx),c="month",d=0;if(e.minDate>1){l=(h.determineDaysOfMonths(a+1,e.minYear)-i+1)*r,n=m.monthMod(a+1);var g=s+d,u=m.monthMod(n),f=n;0===n&&(c="year",f=g,u=1,g+=d+=1),this.timeScaleArray.push({position:l,value:f,unit:c,year:g,month:u})}else this.timeScaleArray.push({position:l,value:n,unit:c,year:s,month:m.monthMod(a)});for(var p=n+1,x=l,b=0,v=1;b<o;b++,v++){0===(p=m.monthMod(p))?(c="year",d+=1):c="month";var y=this._getYear(s,p,d);x=h.determineDaysOfMonths(p,y)*r+x;var w=0===p?y:p;this.timeScaleArray.push({position:x,value:w,unit:c,year:y,month:0===p?1:p}),p++}}},{key:"generateDayScale",value:function(t){var e=t.firstVal,i=t.currentMonth,a=t.currentYear,s=t.hoursWidthOnXAxis,r=t.numberOfDays,o=new L(this.ctx),n="day",l=e.minDate+1,h=l,c=function(t,e,i){return t>o.determineDaysOfMonths(e+1,i)?(h=1,n="month",g=e+=1,e):e},d=(24-e.minHour)*s,g=l,u=c(h,i,a);0===e.minHour&&1===e.minDate?(d=0,g=m.monthMod(e.minMonth),n="month",h=e.minDate):1!==e.minDate&&0===e.minHour&&0===e.minMinute&&(d=0,l=e.minDate,g=l,u=c(h=l,i,a)),this.timeScaleArray.push({position:d,value:g,unit:n,year:this._getYear(a,u,0),month:m.monthMod(u),day:h});for(var f=d,p=0;p<r;p++){n="day",u=c(h+=1,u,this._getYear(a,u,0));var x=this._getYear(a,u,0);f=24*s+f;var b=1===h?m.monthMod(u):h;this.timeScaleArray.push({position:f,value:b,unit:n,year:x,month:m.monthMod(u),day:b})}}},{key:"generateHourScale",value:function(t){var e=t.firstVal,i=t.currentDate,a=t.currentMonth,s=t.currentYear,r=t.minutesWidthOnXAxis,o=t.numberOfHours,n=new L(this.ctx),l="hour",h=function(t,e){return t>n.determineDaysOfMonths(e+1,s)&&(p=1,e+=1),{month:e,date:p}},c=function(t,e){return t>n.determineDaysOfMonths(e+1,s)?e+=1:e},d=60-(e.minMinute+e.minSecond/60),g=d*r,u=e.minHour+1,f=u;60===d&&(g=0,f=u=e.minHour);var p=i;f>=24&&(f=0,p+=1,l="day");var x=h(p,a).month;x=c(p,x),this.timeScaleArray.push({position:g,value:u,unit:l,day:p,hour:f,year:s,month:m.monthMod(x)}),f++;for(var b=g,v=0;v<o;v++){if(l="hour",f>=24)f=0,l="day",x=h(p+=1,x).month,x=c(p,x);var y=this._getYear(s,x,0);b=60*r+b;var w=0===f?p:f;this.timeScaleArray.push({position:b,value:w,unit:l,hour:f,day:p,year:y,month:m.monthMod(x)}),f++}}},{key:"generateMinuteScale",value:function(t){for(var e=t.currentMillisecond,i=t.currentSecond,a=t.currentMinute,s=t.currentHour,r=t.currentDate,o=t.currentMonth,n=t.currentYear,l=t.minutesWidthOnXAxis,h=t.secondsWidthOnXAxis,c=t.numberOfMinutes,d=a+1,g=r,u=o,f=n,p=s,x=(60-i-e/1e3)*h,b=0;b<c;b++)d>=60&&(d=0,24===(p+=1)&&(p=0)),this.timeScaleArray.push({position:x,value:d,unit:"minute",hour:p,minute:d,day:g,year:this._getYear(f,u,0),month:m.monthMod(u)}),x+=l,d++}},{key:"generateSecondScale",value:function(t){for(var e=t.currentMillisecond,i=t.currentSecond,a=t.currentMinute,s=t.currentHour,r=t.currentDate,o=t.currentMonth,n=t.currentYear,l=t.secondsWidthOnXAxis,h=t.numberOfSeconds,c=i+1,d=a,g=r,u=o,f=n,p=s,x=(1e3-e)/1e3*l,b=0;b<h;b++)c>=60&&(c=0,++d>=60&&(d=0,24===++p&&(p=0))),this.timeScaleArray.push({position:x,value:c,unit:"second",hour:p,minute:d,second:c,day:g,year:this._getYear(f,u,0),month:m.monthMod(u)}),x+=l,c++}},{key:"createRawDateString",value:function(t,e){var i=t.year;return 0===t.month&&(t.month=1),i+="-"+("0"+t.month.toString()).slice(-2),"day"===t.unit?i+="day"===t.unit?"-"+("0"+e).slice(-2):"-01":i+="-"+("0"+(t.day?t.day:"1")).slice(-2),"hour"===t.unit?i+="hour"===t.unit?"T"+("0"+e).slice(-2):"T00":i+="T"+("0"+(t.hour?t.hour:"0")).slice(-2),"minute"===t.unit?i+=":"+("0"+e).slice(-2):i+=":"+(t.minute?("0"+t.minute).slice(-2):"00"),"second"===t.unit?i+=":"+("0"+e).slice(-2):i+=":00",this.utc&&(i+=".000Z"),i}},{key:"formatDates",value:function(t){var e=this,i=this.w;return t.map((function(t){var a=t.value.toString(),s=new L(e.ctx),r=e.createRawDateString(t,a),o=s.getDate(s.parseDate(r));if(e.utc||(o=s.getDate(s.parseDateWithTimezone(r))),void 0===i.config.xaxis.labels.format){var n="dd MMM",l=i.config.xaxis.labels.datetimeFormatter;"year"===t.unit&&(n=l.year),"month"===t.unit&&(n=l.month),"day"===t.unit&&(n=l.day),"hour"===t.unit&&(n=l.hour),"minute"===t.unit&&(n=l.minute),"second"===t.unit&&(n=l.second),a=s.formatDate(o,n)}else a=s.formatDate(o,i.config.xaxis.labels.format);return{dateString:r,position:t.position,value:a,unit:t.unit,year:t.year,month:t.month}}))}},{key:"removeOverlappingTS",value:function(t){var e,i=this,a=new k(this.ctx),s=!1;t.length>0&&t[0].value&&t.every((function(e){return e.value.length===t[0].value.length}))&&(s=!0,e=a.getTextRects(t[0].value).width);var r=0,o=t.map((function(o,n){if(n>0&&i.w.config.xaxis.labels.hideOverlappingLabels){var l=s?e:a.getTextRects(t[r].value).width,h=t[r].position;return o.position>h+l+10?(r=n,o):null}return o}));return o=o.filter((function(t){return null!==t}))}},{key:"_getYear",value:function(t,e,i){return t+Math.floor(e/12)+i}}]),t}(),_t=function(){function t(e,a){i(this,t),this.ctx=a,this.w=a.w,this.el=e}return s(t,[{key:"setupElements",value:function(){var t=this.w,e=t.globals,i=t.config,a=i.chart.type;e.axisCharts=["line","area","bar","rangeBar","rangeArea","candlestick","boxPlot","scatter","bubble","radar","heatmap","treemap"].includes(a),e.xyCharts=["line","area","bar","rangeBar","rangeArea","candlestick","boxPlot","scatter","bubble"].includes(a),e.isBarHorizontal=["bar","rangeBar","boxPlot"].includes(a)&&i.plotOptions.bar.horizontal,e.chartClass=".apexcharts".concat(e.chartID),e.dom.baseEl=this.el,e.dom.elWrap=document.createElement("div"),k.setAttrs(e.dom.elWrap,{id:e.chartClass.substring(1),class:"apexcharts-canvas ".concat(e.chartClass.substring(1))}),this.el.appendChild(e.dom.elWrap),e.dom.Paper=new window.SVG.Doc(e.dom.elWrap),e.dom.Paper.attr({class:"apexcharts-svg","xmlns:data":"ApexChartsNS",transform:"translate(".concat(i.chart.offsetX,", ").concat(i.chart.offsetY,")")}),e.dom.Paper.node.style.background="dark"!==i.theme.mode||i.chart.background?"light"!==i.theme.mode||i.chart.background?i.chart.background:"#fff":"#424242",this.setSVGDimensions(),e.dom.elLegendForeign=document.createElementNS(e.SVGNS,"foreignObject"),k.setAttrs(e.dom.elLegendForeign,{x:0,y:0,width:e.svgWidth,height:e.svgHeight}),e.dom.elLegendWrap=document.createElement("div"),e.dom.elLegendWrap.classList.add("apexcharts-legend"),e.dom.elLegendWrap.setAttribute("xmlns","http://www.w3.org/1999/xhtml"),e.dom.elLegendForeign.appendChild(e.dom.elLegendWrap),e.dom.Paper.node.appendChild(e.dom.elLegendForeign),e.dom.elGraphical=e.dom.Paper.group().attr({class:"apexcharts-inner apexcharts-graphical"}),e.dom.elDefs=e.dom.Paper.defs(),e.dom.Paper.add(e.dom.elGraphical),e.dom.elGraphical.add(e.dom.elDefs)}},{key:"plotChartType",value:function(t,e){var i=this.w,a=this.ctx,s=i.config,r=i.globals,o={line:{series:[],i:[]},area:{series:[],i:[]},scatter:{series:[],i:[]},bubble:{series:[],i:[]},column:{series:[],i:[]},candlestick:{series:[],i:[]},boxPlot:{series:[],i:[]},rangeBar:{series:[],i:[]},rangeArea:{series:[],seriesRangeEnd:[],i:[]}},n=s.chart.type||"line",l=null,h=0;r.series.forEach((function(e,a){var s=t[a].type||n;o[s]?("rangeArea"===s?(o[s].series.push(r.seriesRangeStart[a]),o[s].seriesRangeEnd.push(r.seriesRangeEnd[a])):o[s].series.push(e),o[s].i.push(a),"column"!==s&&"bar"!==s||(i.globals.columnSeries=o.column)):["heatmap","treemap","pie","donut","polarArea","radialBar","radar"].includes(s)?l=s:"bar"===s?(o.column.series.push(e),o.column.i.push(a)):console.warn("You have specified an unrecognized series type (".concat(s,").")),n!==s&&"scatter"!==s&&h++})),h>0&&(l&&console.warn("Chart or series type ".concat(l," cannot appear with other chart or series types.")),o.column.series.length>0&&s.plotOptions.bar.horizontal&&(h-=o.column.series.length,o.column={series:[],i:[]},i.globals.columnSeries={series:[],i:[]},console.warn("Horizontal bars are not supported in a mixed/combo chart. Please turn off `plotOptions.bar.horizontal`"))),r.comboCharts||(r.comboCharts=h>0);var c=new Ot(a,e),d=new Lt(a,e);a.pie=new Tt(a);var g=new Xt(a);a.rangeBar=new Et(a,e);var u=new zt(a),f=[];if(r.comboCharts){var x,b,v=new A(a);if(o.area.series.length>0)(x=f).push.apply(x,p(v.drawSeriesByGroup(o.area,r.areaGroups,"area",c)));if(o.column.series.length>0)if(s.chart.stacked){var m=new Ct(a,e);f.push(m.draw(o.column.series,o.column.i))}else a.bar=new St(a,e),f.push(a.bar.draw(o.column.series,o.column.i));if(o.rangeArea.series.length>0&&f.push(c.draw(o.rangeArea.series,"rangeArea",o.rangeArea.i,o.rangeArea.seriesRangeEnd)),o.line.series.length>0)(b=f).push.apply(b,p(v.drawSeriesByGroup(o.line,r.lineGroups,"line",c)));if(o.candlestick.series.length>0&&f.push(d.draw(o.candlestick.series,"candlestick",o.candlestick.i)),o.boxPlot.series.length>0&&f.push(d.draw(o.boxPlot.series,"boxPlot",o.boxPlot.i)),o.rangeBar.series.length>0&&f.push(a.rangeBar.draw(o.rangeBar.series,o.rangeBar.i)),o.scatter.series.length>0){var y=new Ot(a,e,!0);f.push(y.draw(o.scatter.series,"scatter",o.scatter.i))}if(o.bubble.series.length>0){var w=new Ot(a,e,!0);f.push(w.draw(o.bubble.series,"bubble",o.bubble.i))}}else switch(s.chart.type){case"line":f=c.draw(r.series,"line");break;case"area":f=c.draw(r.series,"area");break;case"bar":if(s.chart.stacked)f=new Ct(a,e).draw(r.series);else a.bar=new St(a,e),f=a.bar.draw(r.series);break;case"candlestick":f=new Lt(a,e).draw(r.series,"candlestick");break;case"boxPlot":f=new Lt(a,e).draw(r.series,s.chart.type);break;case"rangeBar":f=a.rangeBar.draw(r.series);break;case"rangeArea":f=c.draw(r.seriesRangeStart,"rangeArea",void 0,r.seriesRangeEnd);break;case"heatmap":f=new Mt(a,e).draw(r.series);break;case"treemap":f=new Bt(a,e).draw(r.series);break;case"pie":case"donut":case"polarArea":f=a.pie.draw(r.series);break;case"radialBar":f=g.draw(r.series);break;case"radar":f=u.draw(r.series);break;default:f=c.draw(r.series)}return f}},{key:"setSVGDimensions",value:function(){var t=this.w,e=t.globals,i=t.config;i.chart.width=i.chart.width||"100%",i.chart.height=i.chart.height||"auto",e.svgWidth=i.chart.width,e.svgHeight=i.chart.height;var a=m.getDimensions(this.el),s=i.chart.width.toString().split(/[0-9]+/g).pop();"%"===s?m.isNumber(a[0])&&(0===a[0].width&&(a=m.getDimensions(this.el.parentNode)),e.svgWidth=a[0]*parseInt(i.chart.width,10)/100):"px"!==s&&""!==s||(e.svgWidth=parseInt(i.chart.width,10));var r=String(i.chart.height).toString().split(/[0-9]+/g).pop();if("auto"!==e.svgHeight&&""!==e.svgHeight)if("%"===r){var o=m.getDimensions(this.el.parentNode);e.svgHeight=o[1]*parseInt(i.chart.height,10)/100}else e.svgHeight=parseInt(i.chart.height,10);else e.svgHeight=e.axisCharts?e.svgWidth/1.61:e.svgWidth/1.2;if(e.svgWidth=Math.max(e.svgWidth,0),e.svgHeight=Math.max(e.svgHeight,0),k.setAttrs(e.dom.Paper.node,{width:e.svgWidth,height:e.svgHeight}),"%"!==r){var n=i.chart.sparkline.enabled?0:e.axisCharts?i.chart.parentHeightOffset:0;e.dom.Paper.node.parentNode.parentNode.style.minHeight="".concat(e.svgHeight+n,"px")}e.dom.elWrap.style.width="".concat(e.svgWidth,"px"),e.dom.elWrap.style.height="".concat(e.svgHeight,"px")}},{key:"shiftGraphPosition",value:function(){var t=this.w.globals,e=t.translateY,i=t.translateX;k.setAttrs(t.dom.elGraphical.node,{transform:"translate(".concat(i,", ").concat(e,")")})}},{key:"resizeNonAxisCharts",value:function(){var t=this.w,e=t.globals,i=0,a=t.config.chart.sparkline.enabled?1:15;a+=t.config.grid.padding.bottom,["top","bottom"].includes(t.config.legend.position)&&t.config.legend.show&&!t.config.legend.floating&&(i=new gt(this.ctx).legendHelpers.getLegendDimensions().clwh+7);var s=t.globals.dom.baseEl.querySelector(".apexcharts-radialbar, .apexcharts-pie"),r=2.05*t.globals.radialSize;if(s&&!t.config.chart.sparkline.enabled&&0!==t.config.plotOptions.radialBar.startAngle){var o=m.getBoundingClientRect(s);r=o.bottom;var n=o.bottom-o.top;r=Math.max(2.05*t.globals.radialSize,n)}var l=Math.ceil(r+e.translateY+i+a);e.dom.elLegendForeign&&e.dom.elLegendForeign.setAttribute("height",l),t.config.chart.height&&String(t.config.chart.height).includes("%")||(e.dom.elWrap.style.height="".concat(l,"px"),k.setAttrs(e.dom.Paper.node,{height:l}),e.dom.Paper.node.parentNode.parentNode.style.minHeight="".concat(l,"px"))}},{key:"coreCalculations",value:function(){new J(this.ctx).init()}},{key:"resetGlobals",value:function(){var t=this,e=function(){return t.w.config.series.map((function(){return[]}))},i=new H,a=this.w.globals;i.initGlobalVars(a),a.seriesXvalues=e(),a.seriesYvalues=e()}},{key:"isMultipleY",value:function(){return!!(Array.isArray(this.w.config.yaxis)&&this.w.config.yaxis.length>1)&&(this.w.globals.isMultipleYAxis=!0,!0)}},{key:"xySettings",value:function(){var t=this.w,e=null;if(t.globals.axisCharts){if("back"===t.config.xaxis.crosshairs.position&&new it(this.ctx).drawXCrosshairs(),"back"===t.config.yaxis[0].crosshairs.position&&new it(this.ctx).drawYCrosshairs(),"datetime"===t.config.xaxis.type&&void 0===t.config.xaxis.labels.formatter){this.ctx.timeScale=new jt(this.ctx);var i=[];isFinite(t.globals.minX)&&isFinite(t.globals.maxX)&&!t.globals.isBarHorizontal?i=this.ctx.timeScale.calculateTimeScaleTicks(t.globals.minX,t.globals.maxX):t.globals.isBarHorizontal&&(i=this.ctx.timeScale.calculateTimeScaleTicks(t.globals.minY,t.globals.maxY)),this.ctx.timeScale.recalcDimensionsBasedOnFormat(i)}e=new A(this.ctx).getCalculatedRatios()}return e}},{key:"updateSourceChart",value:function(t){this.ctx.w.globals.selection=void 0,this.ctx.updateHelpers._updateOptions({chart:{selection:{xaxis:{min:t.w.globals.minX,max:t.w.globals.maxX}}}},!1,!1)}},{key:"setupBrushHandler",value:function(){var t=this,e=this.w;if(e.config.chart.brush.enabled&&"function"!=typeof e.config.chart.events.selection){var i=Array.isArray(e.config.chart.brush.targets)?e.config.chart.brush.targets:[e.config.chart.brush.target];i.forEach((function(e){var i=ApexCharts.getChartByID(e);i.w.globals.brushSource=t.ctx,"function"!=typeof i.w.config.chart.events.zoomed&&(i.w.config.chart.events.zoomed=function(){return t.updateSourceChart(i)}),"function"!=typeof i.w.config.chart.events.scrolled&&(i.w.config.chart.events.scrolled=function(){return t.updateSourceChart(i)})})),e.config.chart.events.selection=function(t,e){i.forEach((function(t){ApexCharts.getChartByID(t).ctx.updateHelpers._updateOptions({xaxis:{min:e.xaxis.min,max:e.xaxis.max}},!1,!1,!1,!1)}))}}}}]),t}(),Ut=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w}return s(t,[{key:"_updateOptions",value:function(t){var e=this,i=arguments.length>1&&void 0!==arguments[1]&&arguments[1],a=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],s=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],r=arguments.length>4&&void 0!==arguments[4]&&arguments[4];return new Promise((function(o){var n=[e.ctx];s&&(n=e.ctx.getSyncedCharts()),e.ctx.w.globals.isExecCalled&&(n=[e.ctx],e.ctx.w.globals.isExecCalled=!1),n.forEach((function(s,l){var h=s.w;if(h.globals.shouldAnimate=a,i||(h.globals.resized=!0,h.globals.dataChanged=!0,a&&s.series.getPreviousPaths()),t&&"object"===b(t)&&(s.config=new D(t),t=A.extendArrayProps(s.config,t,h),s.w.globals.chartID!==e.ctx.w.globals.chartID&&delete t.series,h.config=m.extend(h.config,t),r&&(h.globals.lastXAxis=t.xaxis?m.clone(t.xaxis):[],h.globals.lastYAxis=t.yaxis?m.clone(t.yaxis):[],h.globals.initialConfig=m.extend({},h.config),h.globals.initialSeries=m.clone(h.config.series),t.series))){for(var c=0;c<h.globals.collapsedSeriesIndices.length;c++){var d=h.config.series[h.globals.collapsedSeriesIndices[c]];h.globals.collapsedSeries[c].data=h.globals.axisCharts?d.data.slice():d}for(var g=0;g<h.globals.ancillaryCollapsedSeriesIndices.length;g++){var u=h.config.series[h.globals.ancillaryCollapsedSeriesIndices[g]];h.globals.ancillaryCollapsedSeries[g].data=h.globals.axisCharts?u.data.slice():u}s.series.emptyCollapsedSeries(h.config.series)}return s.update(t).then((function(){l===n.length-1&&o(s)}))}))}))}},{key:"_updateSeries",value:function(t,e){var i=this,a=arguments.length>2&&void 0!==arguments[2]&&arguments[2];return new Promise((function(s){var r,o=i.w;return o.globals.shouldAnimate=e,o.globals.dataChanged=!0,e&&i.ctx.series.getPreviousPaths(),o.globals.axisCharts?(0===(r=t.map((function(t,e){return i._extendSeries(t,e)}))).length&&(r=[{data:[]}]),o.config.series=r):o.config.series=t.slice(),a&&(o.globals.initialConfig.series=m.clone(o.config.series),o.globals.initialSeries=m.clone(o.config.series)),i.ctx.update().then((function(){s(i.ctx)}))}))}},{key:"_extendSeries",value:function(t,e){var i=this.w,a=i.config.series[e];return g(g({},i.config.series[e]),{},{name:t.name?t.name:null==a?void 0:a.name,color:t.color?t.color:null==a?void 0:a.color,type:t.type?t.type:null==a?void 0:a.type,group:t.group?t.group:null==a?void 0:a.group,hidden:void 0!==t.hidden?t.hidden:null==a?void 0:a.hidden,data:t.data?t.data:null==a?void 0:a.data,zIndex:void 0!==t.zIndex?t.zIndex:e})}},{key:"toggleDataPointSelection",value:function(t,e){var i=this.w,a=null,s=".apexcharts-series[data\\:realIndex='".concat(t,"']");return i.globals.axisCharts?a=i.globals.dom.Paper.select("".concat(s," path[j='").concat(e,"'], ").concat(s," circle[j='").concat(e,"'], ").concat(s," rect[j='").concat(e,"']")).members[0]:void 0===e&&(a=i.globals.dom.Paper.select("".concat(s," path[j='").concat(t,"']")).members[0],"pie"!==i.config.chart.type&&"polarArea"!==i.config.chart.type&&"donut"!==i.config.chart.type||this.ctx.pie.pieClicked(t)),a?(new k(this.ctx).pathMouseDown(a,null),a.node?a.node:null):(console.warn("toggleDataPointSelection: Element not found"),null)}},{key:"forceXAxisUpdate",value:function(t){var e=this.w;if(["min","max"].forEach((function(i){void 0!==t.xaxis[i]&&(e.config.xaxis[i]=t.xaxis[i],e.globals.lastXAxis[i]=t.xaxis[i])})),t.xaxis.categories&&t.xaxis.categories.length&&(e.config.xaxis.categories=t.xaxis.categories),e.config.xaxis.convertedCatToNumeric){var i=new F(t);t=i.convertCatToNumericXaxis(t,this.ctx)}return t}},{key:"forceYAxisUpdate",value:function(t){return t.chart&&t.chart.stacked&&"100%"===t.chart.stackType&&(Array.isArray(t.yaxis)?t.yaxis.forEach((function(e,i){t.yaxis[i].min=0,t.yaxis[i].max=100})):(t.yaxis.min=0,t.yaxis.max=100)),t}},{key:"revertDefaultAxisMinMax",value:function(t){var e=this,i=this.w,a=i.globals.lastXAxis,s=i.globals.lastYAxis;t&&t.xaxis&&(a=t.xaxis),t&&t.yaxis&&(s=t.yaxis),i.config.xaxis.min=a.min,i.config.xaxis.max=a.max;var r=function(t){void 0!==s[t]&&(i.config.yaxis[t].min=s[t].min,i.config.yaxis[t].max=s[t].max)};i.config.yaxis.map((function(t,a){i.globals.zoomed||void 0!==s[a]?r(a):void 0!==e.ctx.opts.yaxis[a]&&(t.min=e.ctx.opts.yaxis[a].min,t.max=e.ctx.opts.yaxis[a].max)}))}}]),t}();Nt="undefined"!=typeof window?window:void 0,Wt=function(t,e){var i=(void 0!==this?this:t).SVG=function(t){if(i.supported)return t=new i.Doc(t),i.parser.draw||i.prepare(),t};if(i.ns="http://www.w3.org/2000/svg",i.xmlns="http://www.w3.org/2000/xmlns/",i.xlink="http://www.w3.org/1999/xlink",i.svgjs="http://svgjs.dev",i.supported=!0,!i.supported)return!1;i.did=1e3,i.eid=function(t){return"Svgjs"+c(t)+i.did++},i.create=function(t){var i=e.createElementNS(this.ns,t);return i.setAttribute("id",this.eid(t)),i},i.extend=function(){var t,e;e=(t=[].slice.call(arguments)).pop();for(var a=t.length-1;a>=0;a--)if(t[a])for(var s in e)t[a].prototype[s]=e[s];i.Set&&i.Set.inherit&&i.Set.inherit()},i.invent=function(t){var e="function"==typeof t.create?t.create:function(){this.constructor.call(this,i.create(t.create))};return t.inherit&&(e.prototype=new t.inherit),t.extend&&i.extend(e,t.extend),t.construct&&i.extend(t.parent||i.Container,t.construct),e},i.adopt=function(e){return e?e.instance?e.instance:((a="svg"==e.nodeName?e.parentNode instanceof t.SVGElement?new i.Nested:new i.Doc:"linearGradient"==e.nodeName?new i.Gradient("linear"):"radialGradient"==e.nodeName?new i.Gradient("radial"):i[c(e.nodeName)]?new(i[c(e.nodeName)]):new i.Element(e)).type=e.nodeName,a.node=e,e.instance=a,a instanceof i.Doc&&a.namespace().defs(),a.setData(JSON.parse(e.getAttribute("svgjs:data"))||{}),a):null;var a},i.prepare=function(){var t=e.getElementsByTagName("body")[0],a=(t?new i.Doc(t):i.adopt(e.documentElement).nested()).size(2,0);i.parser={body:t||e.documentElement,draw:a.style("opacity:0;position:absolute;left:-100%;top:-100%;overflow:hidden").node,poly:a.polyline().node,path:a.path().node,native:i.create("svg")}},i.parser={native:i.create("svg")},e.addEventListener("DOMContentLoaded",(function(){i.parser.draw||i.prepare()}),!1),i.regex={numberAndUnit:/^([+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?)([a-z%]*)$/i,hex:/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,rgb:/rgb\((\d+),(\d+),(\d+)\)/,reference:/#([a-z0-9\-_]+)/i,transforms:/\)\s*,?\s*/,whitespace:/\s/g,isHex:/^#[a-f0-9]{3,6}$/i,isRgb:/^rgb\(/,isCss:/[^:]+:[^;]+;?/,isBlank:/^(\s+)?$/,isNumber:/^[+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,isPercent:/^-?[\d\.]+%$/,isImage:/\.(jpg|jpeg|png|gif|svg)(\?[^=]+.*)?/i,delimiter:/[\s,]+/,hyphen:/([^e])\-/gi,pathLetters:/[MLHVCSQTAZ]/gi,isPathLetter:/[MLHVCSQTAZ]/i,numbersWithDots:/((\d?\.\d+(?:e[+-]?\d+)?)((?:\.\d+(?:e[+-]?\d+)?)+))+/gi,dots:/\./g},i.utils={map:function(t,e){for(var i=t.length,a=[],s=0;s<i;s++)a.push(e(t[s]));return a},filter:function(t,e){for(var i=t.length,a=[],s=0;s<i;s++)e(t[s])&&a.push(t[s]);return a},filterSVGElements:function(e){return this.filter(e,(function(e){return e instanceof t.SVGElement}))}},i.defaults={attrs:{"fill-opacity":1,"stroke-opacity":1,"stroke-width":0,"stroke-linejoin":"miter","stroke-linecap":"butt",fill:"#000000",stroke:"#000000",opacity:1,x:0,y:0,cx:0,cy:0,width:0,height:0,r:0,rx:0,ry:0,offset:0,"stop-opacity":1,"stop-color":"#000000","font-size":16,"font-family":"Helvetica, Arial, sans-serif","text-anchor":"start"}},i.Color=function(t){var e,a;this.r=0,this.g=0,this.b=0,t&&("string"==typeof t?i.regex.isRgb.test(t)?(e=i.regex.rgb.exec(t.replace(i.regex.whitespace,"")),this.r=parseInt(e[1]),this.g=parseInt(e[2]),this.b=parseInt(e[3])):i.regex.isHex.test(t)&&(e=i.regex.hex.exec(4==(a=t).length?["#",a.substring(1,2),a.substring(1,2),a.substring(2,3),a.substring(2,3),a.substring(3,4),a.substring(3,4)].join(""):a),this.r=parseInt(e[1],16),this.g=parseInt(e[2],16),this.b=parseInt(e[3],16)):"object"===b(t)&&(this.r=t.r,this.g=t.g,this.b=t.b))},i.extend(i.Color,{toString:function(){return this.toHex()},toHex:function(){return"#"+d(this.r)+d(this.g)+d(this.b)},toRgb:function(){return"rgb("+[this.r,this.g,this.b].join()+")"},brightness:function(){return this.r/255*.3+this.g/255*.59+this.b/255*.11},morph:function(t){return this.destination=new i.Color(t),this},at:function(t){return this.destination?(t=t<0?0:t>1?1:t,new i.Color({r:~~(this.r+(this.destination.r-this.r)*t),g:~~(this.g+(this.destination.g-this.g)*t),b:~~(this.b+(this.destination.b-this.b)*t)})):this}}),i.Color.test=function(t){return t+="",i.regex.isHex.test(t)||i.regex.isRgb.test(t)},i.Color.isRgb=function(t){return t&&"number"==typeof t.r&&"number"==typeof t.g&&"number"==typeof t.b},i.Color.isColor=function(t){return i.Color.isRgb(t)||i.Color.test(t)},i.Array=function(t,e){0==(t=(t||[]).valueOf()).length&&e&&(t=e.valueOf()),this.value=this.parse(t)},i.extend(i.Array,{toString:function(){return this.value.join(" ")},valueOf:function(){return this.value},parse:function(t){return t=t.valueOf(),Array.isArray(t)?t:this.split(t)}}),i.PointArray=function(t,e){i.Array.call(this,t,e||[[0,0]])},i.PointArray.prototype=new i.Array,i.PointArray.prototype.constructor=i.PointArray;for(var a={M:function(t,e,i){return e.x=i.x=t[0],e.y=i.y=t[1],["M",e.x,e.y]},L:function(t,e){return e.x=t[0],e.y=t[1],["L",t[0],t[1]]},H:function(t,e){return e.x=t[0],["H",t[0]]},V:function(t,e){return e.y=t[0],["V",t[0]]},C:function(t,e){return e.x=t[4],e.y=t[5],["C",t[0],t[1],t[2],t[3],t[4],t[5]]},Q:function(t,e){return e.x=t[2],e.y=t[3],["Q",t[0],t[1],t[2],t[3]]},S:function(t,e){return e.x=t[2],e.y=t[3],["S",t[0],t[1],t[2],t[3]]},Z:function(t,e,i){return e.x=i.x,e.y=i.y,["Z"]}},s="mlhvqtcsaz".split(""),r=0,o=s.length;r<o;++r)a[s[r]]=function(t){return function(e,i,s){if("H"==t)e[0]=e[0]+i.x;else if("V"==t)e[0]=e[0]+i.y;else if("A"==t)e[5]=e[5]+i.x,e[6]=e[6]+i.y;else for(var r=0,o=e.length;r<o;++r)e[r]=e[r]+(r%2?i.y:i.x);if(a&&"function"==typeof a[t])return a[t](e,i,s)}}(s[r].toUpperCase());i.PathArray=function(t,e){i.Array.call(this,t,e||[["M",0,0]])},i.PathArray.prototype=new i.Array,i.PathArray.prototype.constructor=i.PathArray,i.extend(i.PathArray,{toString:function(){return function(t){for(var e=0,i=t.length,a="";e<i;e++)a+=t[e][0],null!=t[e][1]&&(a+=t[e][1],null!=t[e][2]&&(a+=" ",a+=t[e][2],null!=t[e][3]&&(a+=" ",a+=t[e][3],a+=" ",a+=t[e][4],null!=t[e][5]&&(a+=" ",a+=t[e][5],a+=" ",a+=t[e][6],null!=t[e][7]&&(a+=" ",a+=t[e][7])))));return a+" "}(this.value)},move:function(t,e){var i=this.bbox();return i.x,i.y,this},at:function(t){if(!this.destination)return this;for(var e=this.value,a=this.destination.value,s=[],r=new i.PathArray,o=0,n=e.length;o<n;o++){s[o]=[e[o][0]];for(var l=1,h=e[o].length;l<h;l++)s[o][l]=e[o][l]+(a[o][l]-e[o][l])*t;"A"===s[o][0]&&(s[o][4]=+(0!=s[o][4]),s[o][5]=+(0!=s[o][5]))}return r.value=s,r},parse:function(t){if(t instanceof i.PathArray)return t.valueOf();var e,s={M:2,L:2,H:1,V:1,C:6,S:4,Q:4,T:2,A:7,Z:0};t="string"==typeof t?t.replace(i.regex.numbersWithDots,l).replace(i.regex.pathLetters," $& ").replace(i.regex.hyphen,"$1 -").trim().split(i.regex.delimiter):t.reduce((function(t,e){return[].concat.call(t,e)}),[]);var r=[],o=new i.Point,n=new i.Point,h=0,c=t.length;do{i.regex.isPathLetter.test(t[h])?(e=t[h],++h):"M"==e?e="L":"m"==e&&(e="l"),r.push(a[e].call(null,t.slice(h,h+=s[e.toUpperCase()]).map(parseFloat),o,n))}while(c>h);return r},bbox:function(){return i.parser.draw||i.prepare(),i.parser.path.setAttribute("d",this.toString()),i.parser.path.getBBox()}}),i.Number=i.invent({create:function(t,e){this.value=0,this.unit=e||"","number"==typeof t?this.value=isNaN(t)?0:isFinite(t)?t:t<0?-34e37:34e37:"string"==typeof t?(e=t.match(i.regex.numberAndUnit))&&(this.value=parseFloat(e[1]),"%"==e[5]?this.value/=100:"s"==e[5]&&(this.value*=1e3),this.unit=e[5]):t instanceof i.Number&&(this.value=t.valueOf(),this.unit=t.unit)},extend:{toString:function(){return("%"==this.unit?~~(1e8*this.value)/1e6:"s"==this.unit?this.value/1e3:this.value)+this.unit},toJSON:function(){return this.toString()},valueOf:function(){return this.value},plus:function(t){return t=new i.Number(t),new i.Number(this+t,this.unit||t.unit)},minus:function(t){return t=new i.Number(t),new i.Number(this-t,this.unit||t.unit)},times:function(t){return t=new i.Number(t),new i.Number(this*t,this.unit||t.unit)},divide:function(t){return t=new i.Number(t),new i.Number(this/t,this.unit||t.unit)},to:function(t){var e=new i.Number(this);return"string"==typeof t&&(e.unit=t),e},morph:function(t){return this.destination=new i.Number(t),t.relative&&(this.destination.value+=this.value),this},at:function(t){return this.destination?new i.Number(this.destination).minus(this).times(t).plus(this):this}}}),i.Element=i.invent({create:function(t){this._stroke=i.defaults.attrs.stroke,this._event=null,this.dom={},(this.node=t)&&(this.type=t.nodeName,this.node.instance=this,this._stroke=t.getAttribute("stroke")||this._stroke)},extend:{x:function(t){return this.attr("x",t)},y:function(t){return this.attr("y",t)},cx:function(t){return null==t?this.x()+this.width()/2:this.x(t-this.width()/2)},cy:function(t){return null==t?this.y()+this.height()/2:this.y(t-this.height()/2)},move:function(t,e){return this.x(t).y(e)},center:function(t,e){return this.cx(t).cy(e)},width:function(t){return this.attr("width",t)},height:function(t){return this.attr("height",t)},size:function(t,e){var a=g(this,t,e);return this.width(new i.Number(a.width)).height(new i.Number(a.height))},clone:function(t){this.writeDataToDom();var e=p(this.node.cloneNode(!0));return t?t.add(e):this.after(e),e},remove:function(){return this.parent()&&this.parent().removeElement(this),this},replace:function(t){return this.after(t).remove(),t},addTo:function(t){return t.put(this)},putIn:function(t){return t.add(this)},id:function(t){return this.attr("id",t)},show:function(){return this.style("display","")},hide:function(){return this.style("display","none")},visible:function(){return"none"!=this.style("display")},toString:function(){return this.attr("id")},classes:function(){var t=this.attr("class");return null==t?[]:t.trim().split(i.regex.delimiter)},hasClass:function(t){return-1!=this.classes().indexOf(t)},addClass:function(t){if(!this.hasClass(t)){var e=this.classes();e.push(t),this.attr("class",e.join(" "))}return this},removeClass:function(t){return this.hasClass(t)&&this.attr("class",this.classes().filter((function(e){return e!=t})).join(" ")),this},toggleClass:function(t){return this.hasClass(t)?this.removeClass(t):this.addClass(t)},reference:function(t){return i.get(this.attr(t))},parent:function(e){var a=this;if(!a.node.parentNode)return null;if(a=i.adopt(a.node.parentNode),!e)return a;for(;a&&a.node instanceof t.SVGElement;){if("string"==typeof e?a.matches(e):a instanceof e)return a;if(!a.node.parentNode||"#document"==a.node.parentNode.nodeName)return null;a=i.adopt(a.node.parentNode)}},doc:function(){return this instanceof i.Doc?this:this.parent(i.Doc)},parents:function(t){var e=[],i=this;do{if(!(i=i.parent(t))||!i.node)break;e.push(i)}while(i.parent);return e},matches:function(t){return function(t,e){return(t.matches||t.matchesSelector||t.msMatchesSelector||t.mozMatchesSelector||t.webkitMatchesSelector||t.oMatchesSelector).call(t,e)}(this.node,t)},native:function(){return this.node},svg:function(t){var a=e.createElementNS("http://www.w3.org/2000/svg","svg");if(!(t&&this instanceof i.Parent))return a.appendChild(t=e.createElementNS("http://www.w3.org/2000/svg","svg")),this.writeDataToDom(),t.appendChild(this.node.cloneNode(!0)),a.innerHTML.replace(/^<svg>/,"").replace(/<\/svg>$/,"");a.innerHTML="<svg>"+t.replace(/\n/,"").replace(/<([\w:-]+)([^<]+?)\/>/g,"<$1$2></$1>")+"</svg>";for(var s=0,r=a.firstChild.childNodes.length;s<r;s++)this.node.appendChild(a.firstChild.firstChild);return this},writeDataToDom:function(){return(this.each||this.lines)&&(this.each?this:this.lines()).each((function(){this.writeDataToDom()})),this.node.removeAttribute("svgjs:data"),Object.keys(this.dom).length&&this.node.setAttribute("svgjs:data",JSON.stringify(this.dom)),this},setData:function(t){return this.dom=t,this},is:function(t){return function(t,e){return t instanceof e}(this,t)}}}),i.easing={"-":function(t){return t},"<>":function(t){return-Math.cos(t*Math.PI)/2+.5},">":function(t){return Math.sin(t*Math.PI/2)},"<":function(t){return 1-Math.cos(t*Math.PI/2)}},i.morph=function(t){return function(e,a){return new i.MorphObj(e,a).at(t)}},i.Situation=i.invent({create:function(t){this.init=!1,this.reversed=!1,this.reversing=!1,this.duration=new i.Number(t.duration).valueOf(),this.delay=new i.Number(t.delay).valueOf(),this.start=+new Date+this.delay,this.finish=this.start+this.duration,this.ease=t.ease,this.loop=0,this.loops=!1,this.animations={},this.attrs={},this.styles={},this.transforms=[],this.once={}}}),i.FX=i.invent({create:function(t){this._target=t,this.situations=[],this.active=!1,this.situation=null,this.paused=!1,this.lastPos=0,this.pos=0,this.absPos=0,this._speed=1},extend:{animate:function(t,e,a){"object"===b(t)&&(e=t.ease,a=t.delay,t=t.duration);var s=new i.Situation({duration:t||1e3,delay:a||0,ease:i.easing[e||"-"]||e});return this.queue(s),this},target:function(t){return t&&t instanceof i.Element?(this._target=t,this):this._target},timeToAbsPos:function(t){return(t-this.situation.start)/(this.situation.duration/this._speed)},absPosToTime:function(t){return this.situation.duration/this._speed*t+this.situation.start},startAnimFrame:function(){this.stopAnimFrame(),this.animationFrame=t.requestAnimationFrame(function(){this.step()}.bind(this))},stopAnimFrame:function(){t.cancelAnimationFrame(this.animationFrame)},start:function(){return!this.active&&this.situation&&(this.active=!0,this.startCurrent()),this},startCurrent:function(){return this.situation.start=+new Date+this.situation.delay/this._speed,this.situation.finish=this.situation.start+this.situation.duration/this._speed,this.initAnimations().step()},queue:function(t){return("function"==typeof t||t instanceof i.Situation)&&this.situations.push(t),this.situation||(this.situation=this.situations.shift()),this},dequeue:function(){return this.stop(),this.situation=this.situations.shift(),this.situation&&(this.situation instanceof i.Situation?this.start():this.situation.call(this)),this},initAnimations:function(){var t,e=this.situation;if(e.init)return this;for(var a in e.animations){t=this.target()[a](),Array.isArray(t)||(t=[t]),Array.isArray(e.animations[a])||(e.animations[a]=[e.animations[a]]);for(var s=t.length;s--;)e.animations[a][s]instanceof i.Number&&(t[s]=new i.Number(t[s])),e.animations[a][s]=t[s].morph(e.animations[a][s])}for(var a in e.attrs)e.attrs[a]=new i.MorphObj(this.target().attr(a),e.attrs[a]);for(var a in e.styles)e.styles[a]=new i.MorphObj(this.target().style(a),e.styles[a]);return e.initialTransformation=this.target().matrixify(),e.init=!0,this},clearQueue:function(){return this.situations=[],this},clearCurrent:function(){return this.situation=null,this},stop:function(t,e){var i=this.active;return this.active=!1,e&&this.clearQueue(),t&&this.situation&&(!i&&this.startCurrent(),this.atEnd()),this.stopAnimFrame(),this.clearCurrent()},after:function(t){var e=this.last();return this.target().on("finished.fx",(function i(a){a.detail.situation==e&&(t.call(this,e),this.off("finished.fx",i))})),this._callStart()},during:function(t){var e=this.last(),a=function(a){a.detail.situation==e&&t.call(this,a.detail.pos,i.morph(a.detail.pos),a.detail.eased,e)};return this.target().off("during.fx",a).on("during.fx",a),this.after((function(){this.off("during.fx",a)})),this._callStart()},afterAll:function(t){var e=function e(i){t.call(this),this.off("allfinished.fx",e)};return this.target().off("allfinished.fx",e).on("allfinished.fx",e),this._callStart()},last:function(){return this.situations.length?this.situations[this.situations.length-1]:this.situation},add:function(t,e,i){return this.last()[i||"animations"][t]=e,this._callStart()},step:function(t){var e,i,a;t||(this.absPos=this.timeToAbsPos(+new Date)),!1!==this.situation.loops?(e=Math.max(this.absPos,0),i=Math.floor(e),!0===this.situation.loops||i<this.situation.loops?(this.pos=e-i,a=this.situation.loop,this.situation.loop=i):(this.absPos=this.situation.loops,this.pos=1,a=this.situation.loop-1,this.situation.loop=this.situation.loops),this.situation.reversing&&(this.situation.reversed=this.situation.reversed!=Boolean((this.situation.loop-a)%2))):(this.absPos=Math.min(this.absPos,1),this.pos=this.absPos),this.pos<0&&(this.pos=0),this.situation.reversed&&(this.pos=1-this.pos);var s=this.situation.ease(this.pos);for(var r in this.situation.once)r>this.lastPos&&r<=s&&(this.situation.once[r].call(this.target(),this.pos,s),delete this.situation.once[r]);return this.active&&this.target().fire("during",{pos:this.pos,eased:s,fx:this,situation:this.situation}),this.situation?(this.eachAt(),1==this.pos&&!this.situation.reversed||this.situation.reversed&&0==this.pos?(this.stopAnimFrame(),this.target().fire("finished",{fx:this,situation:this.situation}),this.situations.length||(this.target().fire("allfinished"),this.situations.length||(this.target().off(".fx"),this.active=!1)),this.active?this.dequeue():this.clearCurrent()):!this.paused&&this.active&&this.startAnimFrame(),this.lastPos=s,this):this},eachAt:function(){var t,e=this,a=this.target(),s=this.situation;for(var r in s.animations)t=[].concat(s.animations[r]).map((function(t){return"string"!=typeof t&&t.at?t.at(s.ease(e.pos),e.pos):t})),a[r].apply(a,t);for(var r in s.attrs)t=[r].concat(s.attrs[r]).map((function(t){return"string"!=typeof t&&t.at?t.at(s.ease(e.pos),e.pos):t})),a.attr.apply(a,t);for(var r in s.styles)t=[r].concat(s.styles[r]).map((function(t){return"string"!=typeof t&&t.at?t.at(s.ease(e.pos),e.pos):t})),a.style.apply(a,t);if(s.transforms.length){t=s.initialTransformation,r=0;for(var o=s.transforms.length;r<o;r++){var n=s.transforms[r];n instanceof i.Matrix?t=n.relative?t.multiply((new i.Matrix).morph(n).at(s.ease(this.pos))):t.morph(n).at(s.ease(this.pos)):(n.relative||n.undo(t.extract()),t=t.multiply(n.at(s.ease(this.pos))))}a.matrix(t)}return this},once:function(t,e,i){var a=this.last();return i||(t=a.ease(t)),a.once[t]=e,this},_callStart:function(){return setTimeout(function(){this.start()}.bind(this),0),this}},parent:i.Element,construct:{animate:function(t,e,a){return(this.fx||(this.fx=new i.FX(this))).animate(t,e,a)},delay:function(t){return(this.fx||(this.fx=new i.FX(this))).delay(t)},stop:function(t,e){return this.fx&&this.fx.stop(t,e),this},finish:function(){return this.fx&&this.fx.finish(),this}}}),i.MorphObj=i.invent({create:function(t,e){return i.Color.isColor(e)?new i.Color(t).morph(e):i.regex.delimiter.test(t)?i.regex.pathLetters.test(t)?new i.PathArray(t).morph(e):new i.Array(t).morph(e):i.regex.numberAndUnit.test(e)?new i.Number(t).morph(e):(this.value=t,void(this.destination=e))},extend:{at:function(t,e){return e<1?this.value:this.destination},valueOf:function(){return this.value}}}),i.extend(i.FX,{attr:function(t,e,i){if("object"===b(t))for(var a in t)this.attr(a,t[a]);else this.add(t,e,"attrs");return this},plot:function(t,e,i,a){return 4==arguments.length?this.plot([t,e,i,a]):this.add("plot",new(this.target().morphArray)(t))}}),i.Box=i.invent({create:function(t,e,a,s){if(!("object"!==b(t)||t instanceof i.Element))return i.Box.call(this,null!=t.left?t.left:t.x,null!=t.top?t.top:t.y,t.width,t.height);var r;4==arguments.length&&(this.x=t,this.y=e,this.width=a,this.height=s),null==(r=this).x&&(r.x=0,r.y=0,r.width=0,r.height=0),r.w=r.width,r.h=r.height,r.x2=r.x+r.width,r.y2=r.y+r.height,r.cx=r.x+r.width/2,r.cy=r.y+r.height/2}}),i.BBox=i.invent({create:function(t){if(i.Box.apply(this,[].slice.call(arguments)),t instanceof i.Element){var a;try{if(!e.documentElement.contains){for(var s=t.node;s.parentNode;)s=s.parentNode;if(s!=e)throw new Error("Element not in the dom")}a=t.node.getBBox()}catch(e){if(t instanceof i.Shape){i.parser.draw||i.prepare();var r=t.clone(i.parser.draw.instance).show();r&&r.node&&"function"==typeof r.node.getBBox&&(a=r.node.getBBox()),r&&"function"==typeof r.remove&&r.remove()}else a={x:t.node.clientLeft,y:t.node.clientTop,width:t.node.clientWidth,height:t.node.clientHeight}}i.Box.call(this,a)}},inherit:i.Box,parent:i.Element,construct:{bbox:function(){return new i.BBox(this)}}}),i.BBox.prototype.constructor=i.BBox,i.Matrix=i.invent({create:function(t){var e=f([1,0,0,1,0,0]);t=null===t?e:t instanceof i.Element?t.matrixify():"string"==typeof t?f(t.split(i.regex.delimiter).map(parseFloat)):6==arguments.length?f([].slice.call(arguments)):Array.isArray(t)?f(t):t&&"object"===b(t)?t:e;for(var a=v.length-1;a>=0;--a)this[v[a]]=null!=t[v[a]]?t[v[a]]:e[v[a]]},extend:{extract:function(){var t=u(this,0,1);u(this,1,0);var e=180/Math.PI*Math.atan2(t.y,t.x)-90;return{x:this.e,y:this.f,transformedX:(this.e*Math.cos(e*Math.PI/180)+this.f*Math.sin(e*Math.PI/180))/Math.sqrt(this.a*this.a+this.b*this.b),transformedY:(this.f*Math.cos(e*Math.PI/180)+this.e*Math.sin(-e*Math.PI/180))/Math.sqrt(this.c*this.c+this.d*this.d),rotation:e,a:this.a,b:this.b,c:this.c,d:this.d,e:this.e,f:this.f,matrix:new i.Matrix(this)}},clone:function(){return new i.Matrix(this)},morph:function(t){return this.destination=new i.Matrix(t),this},multiply:function(t){return new i.Matrix(this.native().multiply(function(t){return t instanceof i.Matrix||(t=new i.Matrix(t)),t}(t).native()))},inverse:function(){return new i.Matrix(this.native().inverse())},translate:function(t,e){return new i.Matrix(this.native().translate(t||0,e||0))},native:function(){for(var t=i.parser.native.createSVGMatrix(),e=v.length-1;e>=0;e--)t[v[e]]=this[v[e]];return t},toString:function(){return"matrix("+x(this.a)+","+x(this.b)+","+x(this.c)+","+x(this.d)+","+x(this.e)+","+x(this.f)+")"}},parent:i.Element,construct:{ctm:function(){return new i.Matrix(this.node.getCTM())},screenCTM:function(){if(this instanceof i.Nested){var t=this.rect(1,1),e=t.node.getScreenCTM();return t.remove(),new i.Matrix(e)}return new i.Matrix(this.node.getScreenCTM())}}}),i.Point=i.invent({create:function(t,e){var i;i=Array.isArray(t)?{x:t[0],y:t[1]}:"object"===b(t)?{x:t.x,y:t.y}:null!=t?{x:t,y:null!=e?e:t}:{x:0,y:0},this.x=i.x,this.y=i.y},extend:{clone:function(){return new i.Point(this)},morph:function(t,e){return this.destination=new i.Point(t,e),this}}}),i.extend(i.Element,{point:function(t,e){return new i.Point(t,e).transform(this.screenCTM().inverse())}}),i.extend(i.Element,{attr:function(t,e,a){if(null==t){for(t={},a=(e=this.node.attributes).length-1;a>=0;a--)t[e[a].nodeName]=i.regex.isNumber.test(e[a].nodeValue)?parseFloat(e[a].nodeValue):e[a].nodeValue;return t}if("object"===b(t))for(var s in t)this.attr(s,t[s]);else if(null===e)this.node.removeAttribute(t);else{if(null==e)return null==(e=this.node.getAttribute(t))?i.defaults.attrs[t]:i.regex.isNumber.test(e)?parseFloat(e):e;"stroke-width"==t?this.attr("stroke",parseFloat(e)>0?this._stroke:null):"stroke"==t&&(this._stroke=e),"fill"!=t&&"stroke"!=t||(i.regex.isImage.test(e)&&(e=this.doc().defs().image(e,0,0)),e instanceof i.Image&&(e=this.doc().defs().pattern(0,0,(function(){this.add(e)})))),"number"==typeof e?e=new i.Number(e):i.Color.isColor(e)?e=new i.Color(e):Array.isArray(e)&&(e=new i.Array(e)),"leading"==t?this.leading&&this.leading(e):"string"==typeof a?this.node.setAttributeNS(a,t,e.toString()):this.node.setAttribute(t,e.toString()),!this.rebuild||"font-size"!=t&&"x"!=t||this.rebuild(t,e)}return this}}),i.extend(i.Element,{transform:function(t,e){var a;return"object"!==b(t)?(a=new i.Matrix(this).extract(),"string"==typeof t?a[t]:a):(a=new i.Matrix(this),e=!!e||!!t.relative,null!=t.a&&(a=e?a.multiply(new i.Matrix(t)):new i.Matrix(t)),this.attr("transform",a))}}),i.extend(i.Element,{untransform:function(){return this.attr("transform",null)},matrixify:function(){return(this.attr("transform")||"").split(i.regex.transforms).slice(0,-1).map((function(t){var e=t.trim().split("(");return[e[0],e[1].split(i.regex.delimiter).map((function(t){return parseFloat(t)}))]})).reduce((function(t,e){return"matrix"==e[0]?t.multiply(f(e[1])):t[e[0]].apply(t,e[1])}),new i.Matrix)},toParent:function(t){if(this==t)return this;var e=this.screenCTM(),i=t.screenCTM().inverse();return this.addTo(t).untransform().transform(i.multiply(e)),this},toDoc:function(){return this.toParent(this.doc())}}),i.Transformation=i.invent({create:function(t,e){if(arguments.length>1&&"boolean"!=typeof e)return this.constructor.call(this,[].slice.call(arguments));if(Array.isArray(t))for(var i=0,a=this.arguments.length;i<a;++i)this[this.arguments[i]]=t[i];else if(t&&"object"===b(t))for(i=0,a=this.arguments.length;i<a;++i)this[this.arguments[i]]=t[this.arguments[i]];this.inversed=!1,!0===e&&(this.inversed=!0)}}),i.Translate=i.invent({parent:i.Matrix,inherit:i.Transformation,create:function(t,e){this.constructor.apply(this,[].slice.call(arguments))},extend:{arguments:["transformedX","transformedY"],method:"translate"}}),i.extend(i.Element,{style:function(t,e){if(0==arguments.length)return this.node.style.cssText||"";if(arguments.length<2)if("object"===b(t))for(var a in t)this.style(a,t[a]);else{if(!i.regex.isCss.test(t))return this.node.style[h(t)];for(t=t.split(/\s*;\s*/).filter((function(t){return!!t})).map((function(t){return t.split(/\s*:\s*/)}));e=t.pop();)this.style(e[0],e[1])}else this.node.style[h(t)]=null===e||i.regex.isBlank.test(e)?"":e;return this}}),i.Parent=i.invent({create:function(t){this.constructor.call(this,t)},inherit:i.Element,extend:{children:function(){return i.utils.map(i.utils.filterSVGElements(this.node.childNodes),(function(t){return i.adopt(t)}))},add:function(t,e){return null==e?this.node.appendChild(t.node):t.node!=this.node.childNodes[e]&&this.node.insertBefore(t.node,this.node.childNodes[e]),this},put:function(t,e){return this.add(t,e),t},has:function(t){return this.index(t)>=0},index:function(t){return[].slice.call(this.node.childNodes).indexOf(t.node)},get:function(t){return i.adopt(this.node.childNodes[t])},first:function(){return this.get(0)},last:function(){return this.get(this.node.childNodes.length-1)},each:function(t,e){for(var a=this.children(),s=0,r=a.length;s<r;s++)a[s]instanceof i.Element&&t.apply(a[s],[s,a]),e&&a[s]instanceof i.Container&&a[s].each(t,e);return this},removeElement:function(t){return this.node.removeChild(t.node),this},clear:function(){for(;this.node.hasChildNodes();)this.node.removeChild(this.node.lastChild);return delete this._defs,this},defs:function(){return this.doc().defs()}}}),i.extend(i.Parent,{ungroup:function(t,e){return 0===e||this instanceof i.Defs||this.node==i.parser.draw||(t=t||(this instanceof i.Doc?this:this.parent(i.Parent)),e=e||1/0,this.each((function(){return this instanceof i.Defs?this:this instanceof i.Parent?this.ungroup(t,e-1):this.toParent(t)})),this.node.firstChild||this.remove()),this},flatten:function(t,e){return this.ungroup(t,e)}}),i.Container=i.invent({create:function(t){this.constructor.call(this,t)},inherit:i.Parent}),i.ViewBox=i.invent({parent:i.Container,construct:{}}),["click","dblclick","mousedown","mouseup","mouseover","mouseout","mousemove","touchstart","touchmove","touchleave","touchend","touchcancel"].forEach((function(t){i.Element.prototype[t]=function(e){return i.on(this.node,t,e),this}})),i.listeners=[],i.handlerMap=[],i.listenerId=0,i.on=function(t,e,a,s,r){var o=a.bind(s||t.instance||t),n=(i.handlerMap.indexOf(t)+1||i.handlerMap.push(t))-1,l=e.split(".")[0],h=e.split(".")[1]||"*";i.listeners[n]=i.listeners[n]||{},i.listeners[n][l]=i.listeners[n][l]||{},i.listeners[n][l][h]=i.listeners[n][l][h]||{},a._svgjsListenerId||(a._svgjsListenerId=++i.listenerId),i.listeners[n][l][h][a._svgjsListenerId]=o,t.addEventListener(l,o,r||{passive:!1})},i.off=function(t,e,a){var s=i.handlerMap.indexOf(t),r=e&&e.split(".")[0],o=e&&e.split(".")[1],n="";if(-1!=s)if(a){if("function"==typeof a&&(a=a._svgjsListenerId),!a)return;i.listeners[s][r]&&i.listeners[s][r][o||"*"]&&(t.removeEventListener(r,i.listeners[s][r][o||"*"][a],!1),delete i.listeners[s][r][o||"*"][a])}else if(o&&r){if(i.listeners[s][r]&&i.listeners[s][r][o]){for(var l in i.listeners[s][r][o])i.off(t,[r,o].join("."),l);delete i.listeners[s][r][o]}}else if(o)for(var h in i.listeners[s])for(var n in i.listeners[s][h])o===n&&i.off(t,[h,o].join("."));else if(r){if(i.listeners[s][r]){for(var n in i.listeners[s][r])i.off(t,[r,n].join("."));delete i.listeners[s][r]}}else{for(var h in i.listeners[s])i.off(t,h);delete i.listeners[s],delete i.handlerMap[s]}},i.extend(i.Element,{on:function(t,e,a,s){return i.on(this.node,t,e,a,s),this},off:function(t,e){return i.off(this.node,t,e),this},fire:function(e,a){return e instanceof t.Event?this.node.dispatchEvent(e):this.node.dispatchEvent(e=new i.CustomEvent(e,{detail:a,cancelable:!0})),this._event=e,this},event:function(){return this._event}}),i.Defs=i.invent({create:"defs",inherit:i.Container}),i.G=i.invent({create:"g",inherit:i.Container,extend:{x:function(t){return null==t?this.transform("x"):this.transform({x:t-this.x()},!0)}},construct:{group:function(){return this.put(new i.G)}}}),i.Doc=i.invent({create:function(t){t&&("svg"==(t="string"==typeof t?e.getElementById(t):t).nodeName?this.constructor.call(this,t):(this.constructor.call(this,i.create("svg")),t.appendChild(this.node),this.size("100%","100%")),this.namespace().defs())},inherit:i.Container,extend:{namespace:function(){return this.attr({xmlns:i.ns,version:"1.1"}).attr("xmlns:xlink",i.xlink,i.xmlns).attr("xmlns:svgjs",i.svgjs,i.xmlns)},defs:function(){var t;return this._defs||((t=this.node.getElementsByTagName("defs")[0])?this._defs=i.adopt(t):this._defs=new i.Defs,this.node.appendChild(this._defs.node)),this._defs},parent:function(){return this.node.parentNode&&"#document"!=this.node.parentNode.nodeName?this.node.parentNode:null},remove:function(){return this.parent()&&this.parent().removeChild(this.node),this},clear:function(){for(;this.node.hasChildNodes();)this.node.removeChild(this.node.lastChild);return delete this._defs,i.parser.draw&&!i.parser.draw.parentNode&&this.node.appendChild(i.parser.draw),this},clone:function(t){this.writeDataToDom();var e=this.node,i=p(e.cloneNode(!0));return t?(t.node||t).appendChild(i.node):e.parentNode.insertBefore(i.node,e.nextSibling),i}}}),i.extend(i.Element,{}),i.Gradient=i.invent({create:function(t){this.constructor.call(this,i.create(t+"Gradient")),this.type=t},inherit:i.Container,extend:{at:function(t,e,a){return this.put(new i.Stop).update(t,e,a)},update:function(t){return this.clear(),"function"==typeof t&&t.call(this,this),this},fill:function(){return"url(#"+this.id()+")"},toString:function(){return this.fill()},attr:function(t,e,a){return"transform"==t&&(t="gradientTransform"),i.Container.prototype.attr.call(this,t,e,a)}},construct:{gradient:function(t,e){return this.defs().gradient(t,e)}}}),i.extend(i.Gradient,i.FX,{from:function(t,e){return"radial"==(this._target||this).type?this.attr({fx:new i.Number(t),fy:new i.Number(e)}):this.attr({x1:new i.Number(t),y1:new i.Number(e)})},to:function(t,e){return"radial"==(this._target||this).type?this.attr({cx:new i.Number(t),cy:new i.Number(e)}):this.attr({x2:new i.Number(t),y2:new i.Number(e)})}}),i.extend(i.Defs,{gradient:function(t,e){return this.put(new i.Gradient(t)).update(e)}}),i.Stop=i.invent({create:"stop",inherit:i.Element,extend:{update:function(t){return("number"==typeof t||t instanceof i.Number)&&(t={offset:arguments[0],color:arguments[1],opacity:arguments[2]}),null!=t.opacity&&this.attr("stop-opacity",t.opacity),null!=t.color&&this.attr("stop-color",t.color),null!=t.offset&&this.attr("offset",new i.Number(t.offset)),this}}}),i.Pattern=i.invent({create:"pattern",inherit:i.Container,extend:{fill:function(){return"url(#"+this.id()+")"},update:function(t){return this.clear(),"function"==typeof t&&t.call(this,this),this},toString:function(){return this.fill()},attr:function(t,e,a){return"transform"==t&&(t="patternTransform"),i.Container.prototype.attr.call(this,t,e,a)}},construct:{pattern:function(t,e,i){return this.defs().pattern(t,e,i)}}}),i.extend(i.Defs,{pattern:function(t,e,a){return this.put(new i.Pattern).update(a).attr({x:0,y:0,width:t,height:e,patternUnits:"userSpaceOnUse"})}}),i.Shape=i.invent({create:function(t){this.constructor.call(this,t)},inherit:i.Element}),i.Symbol=i.invent({create:"symbol",inherit:i.Container,construct:{symbol:function(){return this.put(new i.Symbol)}}}),i.Use=i.invent({create:"use",inherit:i.Shape,extend:{element:function(t,e){return this.attr("href",(e||"")+"#"+t,i.xlink)}},construct:{use:function(t,e){return this.put(new i.Use).element(t,e)}}}),i.Rect=i.invent({create:"rect",inherit:i.Shape,construct:{rect:function(t,e){return this.put(new i.Rect).size(t,e)}}}),i.Circle=i.invent({create:"circle",inherit:i.Shape,construct:{circle:function(t){return this.put(new i.Circle).rx(new i.Number(t).divide(2)).move(0,0)}}}),i.extend(i.Circle,i.FX,{rx:function(t){return this.attr("r",t)},ry:function(t){return this.rx(t)}}),i.Ellipse=i.invent({create:"ellipse",inherit:i.Shape,construct:{ellipse:function(t,e){return this.put(new i.Ellipse).size(t,e).move(0,0)}}}),i.extend(i.Ellipse,i.Rect,i.FX,{rx:function(t){return this.attr("rx",t)},ry:function(t){return this.attr("ry",t)}}),i.extend(i.Circle,i.Ellipse,{x:function(t){return null==t?this.cx()-this.rx():this.cx(t+this.rx())},y:function(t){return null==t?this.cy()-this.ry():this.cy(t+this.ry())},cx:function(t){return null==t?this.attr("cx"):this.attr("cx",t)},cy:function(t){return null==t?this.attr("cy"):this.attr("cy",t)},width:function(t){return null==t?2*this.rx():this.rx(new i.Number(t).divide(2))},height:function(t){return null==t?2*this.ry():this.ry(new i.Number(t).divide(2))},size:function(t,e){var a=g(this,t,e);return this.rx(new i.Number(a.width).divide(2)).ry(new i.Number(a.height).divide(2))}}),i.Line=i.invent({create:"line",inherit:i.Shape,extend:{array:function(){return new i.PointArray([[this.attr("x1"),this.attr("y1")],[this.attr("x2"),this.attr("y2")]])},plot:function(t,e,a,s){return null==t?this.array():(t=void 0!==e?{x1:t,y1:e,x2:a,y2:s}:new i.PointArray(t).toLine(),this.attr(t))},move:function(t,e){return this.attr(this.array().move(t,e).toLine())},size:function(t,e){var i=g(this,t,e);return this.attr(this.array().size(i.width,i.height).toLine())}},construct:{line:function(t,e,a,s){return i.Line.prototype.plot.apply(this.put(new i.Line),null!=t?[t,e,a,s]:[0,0,0,0])}}}),i.Polyline=i.invent({create:"polyline",inherit:i.Shape,construct:{polyline:function(t){return this.put(new i.Polyline).plot(t||new i.PointArray)}}}),i.Polygon=i.invent({create:"polygon",inherit:i.Shape,construct:{polygon:function(t){return this.put(new i.Polygon).plot(t||new i.PointArray)}}}),i.extend(i.Polyline,i.Polygon,{array:function(){return this._array||(this._array=new i.PointArray(this.attr("points")))},plot:function(t){return null==t?this.array():this.clear().attr("points","string"==typeof t?t:this._array=new i.PointArray(t))},clear:function(){return delete this._array,this},move:function(t,e){return this.attr("points",this.array().move(t,e))},size:function(t,e){var i=g(this,t,e);return this.attr("points",this.array().size(i.width,i.height))}}),i.extend(i.Line,i.Polyline,i.Polygon,{morphArray:i.PointArray,x:function(t){return null==t?this.bbox().x:this.move(t,this.bbox().y)},y:function(t){return null==t?this.bbox().y:this.move(this.bbox().x,t)},width:function(t){var e=this.bbox();return null==t?e.width:this.size(t,e.height)},height:function(t){var e=this.bbox();return null==t?e.height:this.size(e.width,t)}}),i.Path=i.invent({create:"path",inherit:i.Shape,extend:{morphArray:i.PathArray,array:function(){return this._array||(this._array=new i.PathArray(this.attr("d")))},plot:function(t){return null==t?this.array():this.clear().attr("d","string"==typeof t?t:this._array=new i.PathArray(t))},clear:function(){return delete this._array,this}},construct:{path:function(t){return this.put(new i.Path).plot(t||new i.PathArray)}}}),i.Image=i.invent({create:"image",inherit:i.Shape,extend:{load:function(e){if(!e)return this;var a=this,s=new t.Image;return i.on(s,"load",(function(){i.off(s);var t=a.parent(i.Pattern);null!==t&&(0==a.width()&&0==a.height()&&a.size(s.width,s.height),t&&0==t.width()&&0==t.height()&&t.size(a.width(),a.height()),"function"==typeof a._loaded&&a._loaded.call(a,{width:s.width,height:s.height,ratio:s.width/s.height,url:e}))})),i.on(s,"error",(function(t){i.off(s),"function"==typeof a._error&&a._error.call(a,t)})),this.attr("href",s.src=this.src=e,i.xlink)},loaded:function(t){return this._loaded=t,this},error:function(t){return this._error=t,this}},construct:{image:function(t,e,a){return this.put(new i.Image).load(t).size(e||0,a||e||0)}}}),i.Text=i.invent({create:function(){this.constructor.call(this,i.create("text")),this.dom.leading=new i.Number(1.3),this._rebuild=!0,this._build=!1,this.attr("font-family",i.defaults.attrs["font-family"])},inherit:i.Shape,extend:{x:function(t){return null==t?this.attr("x"):this.attr("x",t)},text:function(t){if(void 0===t){t="";for(var e=this.node.childNodes,a=0,s=e.length;a<s;++a)0!=a&&3!=e[a].nodeType&&1==i.adopt(e[a]).dom.newLined&&(t+="\n"),t+=e[a].textContent;return t}if(this.clear().build(!0),"function"==typeof t)t.call(this,this);else{a=0;for(var r=(t=t.split("\n")).length;a<r;a++)this.tspan(t[a]).newLine()}return this.build(!1).rebuild()},size:function(t){return this.attr("font-size",t).rebuild()},leading:function(t){return null==t?this.dom.leading:(this.dom.leading=new i.Number(t),this.rebuild())},lines:function(){var t=(this.textPath&&this.textPath()||this).node,e=i.utils.map(i.utils.filterSVGElements(t.childNodes),(function(t){return i.adopt(t)}));return new i.Set(e)},rebuild:function(t){if("boolean"==typeof t&&(this._rebuild=t),this._rebuild){var e=this,a=0,s=this.dom.leading*new i.Number(this.attr("font-size"));this.lines().each((function(){this.dom.newLined&&(e.textPath()||this.attr("x",e.attr("x")),"\n"==this.text()?a+=s:(this.attr("dy",s+a),a=0))})),this.fire("rebuild")}return this},build:function(t){return this._build=!!t,this},setData:function(t){return this.dom=t,this.dom.leading=new i.Number(t.leading||1.3),this}},construct:{text:function(t){return this.put(new i.Text).text(t)},plain:function(t){return this.put(new i.Text).plain(t)}}}),i.Tspan=i.invent({create:"tspan",inherit:i.Shape,extend:{text:function(t){return null==t?this.node.textContent+(this.dom.newLined?"\n":""):("function"==typeof t?t.call(this,this):this.plain(t),this)},dx:function(t){return this.attr("dx",t)},dy:function(t){return this.attr("dy",t)},newLine:function(){var t=this.parent(i.Text);return this.dom.newLined=!0,this.dy(t.dom.leading*t.attr("font-size")).attr("x",t.x())}}}),i.extend(i.Text,i.Tspan,{plain:function(t){return!1===this._build&&this.clear(),this.node.appendChild(e.createTextNode(t)),this},tspan:function(t){var e=(this.textPath&&this.textPath()||this).node,a=new i.Tspan;return!1===this._build&&this.clear(),e.appendChild(a.node),a.text(t)},clear:function(){for(var t=(this.textPath&&this.textPath()||this).node;t.hasChildNodes();)t.removeChild(t.lastChild);return this},length:function(){return this.node.getComputedTextLength()}}),i.TextPath=i.invent({create:"textPath",inherit:i.Parent,parent:i.Text,construct:{morphArray:i.PathArray,array:function(){var t=this.track();return t?t.array():null},plot:function(t){var e=this.track(),i=null;return e&&(i=e.plot(t)),null==t?i:this},track:function(){var t=this.textPath();if(t)return t.reference("href")},textPath:function(){if(this.node.firstChild&&"textPath"==this.node.firstChild.nodeName)return i.adopt(this.node.firstChild)}}}),i.Nested=i.invent({create:function(){this.constructor.call(this,i.create("svg")),this.style("overflow","visible")},inherit:i.Container,construct:{nested:function(){return this.put(new i.Nested)}}});var n={stroke:["color","width","opacity","linecap","linejoin","miterlimit","dasharray","dashoffset"],fill:["color","opacity","rule"],prefix:function(t,e){return"color"==e?t:t+"-"+e}};function l(t,e,a,s){return a+s.replace(i.regex.dots," .")}function h(t){return t.toLowerCase().replace(/-(.)/g,(function(t,e){return e.toUpperCase()}))}function c(t){return t.charAt(0).toUpperCase()+t.slice(1)}function d(t){var e=t.toString(16);return 1==e.length?"0"+e:e}function g(t,e,i){if(null==e||null==i){var a=t.bbox();null==e?e=a.width/a.height*i:null==i&&(i=a.height/a.width*e)}return{width:e,height:i}}function u(t,e,i){return{x:e*t.a+i*t.c+0,y:e*t.b+i*t.d+0}}function f(t){return{a:t[0],b:t[1],c:t[2],d:t[3],e:t[4],f:t[5]}}function p(e){for(var a=e.childNodes.length-1;a>=0;a--)e.childNodes[a]instanceof t.SVGElement&&p(e.childNodes[a]);return i.adopt(e).id(i.eid(e.nodeName))}function x(t){return Math.abs(t)>1e-37?t:0}["fill","stroke"].forEach((function(t){var e={};e[t]=function(e){if(void 0===e)return this;if("string"==typeof e||i.Color.isRgb(e)||e&&"function"==typeof e.fill)this.attr(t,e);else for(var a=n[t].length-1;a>=0;a--)null!=e[n[t][a]]&&this.attr(n.prefix(t,n[t][a]),e[n[t][a]]);return this},i.extend(i.Element,i.FX,e)})),i.extend(i.Element,i.FX,{translate:function(t,e){return this.transform({x:t,y:e})},matrix:function(t){return this.attr("transform",new i.Matrix(6==arguments.length?[].slice.call(arguments):t))},opacity:function(t){return this.attr("opacity",t)},dx:function(t){return this.x(new i.Number(t).plus(this instanceof i.FX?0:this.x()),!0)},dy:function(t){return this.y(new i.Number(t).plus(this instanceof i.FX?0:this.y()),!0)}}),i.extend(i.Path,{length:function(){return this.node.getTotalLength()},pointAt:function(t){return this.node.getPointAtLength(t)}}),i.Set=i.invent({create:function(t){Array.isArray(t)?this.members=t:this.clear()},extend:{add:function(){for(var t=[].slice.call(arguments),e=0,i=t.length;e<i;e++)this.members.push(t[e]);return this},remove:function(t){var e=this.index(t);return e>-1&&this.members.splice(e,1),this},each:function(t){for(var e=0,i=this.members.length;e<i;e++)t.apply(this.members[e],[e,this.members]);return this},clear:function(){return this.members=[],this},length:function(){return this.members.length},has:function(t){return this.index(t)>=0},index:function(t){return this.members.indexOf(t)},get:function(t){return this.members[t]},first:function(){return this.get(0)},last:function(){return this.get(this.members.length-1)},valueOf:function(){return this.members}},construct:{set:function(t){return new i.Set(t)}}}),i.FX.Set=i.invent({create:function(t){this.set=t}}),i.Set.inherit=function(){var t=[];for(var e in i.Shape.prototype)"function"==typeof i.Shape.prototype[e]&&"function"!=typeof i.Set.prototype[e]&&t.push(e);for(var e in t.forEach((function(t){i.Set.prototype[t]=function(){for(var e=0,a=this.members.length;e<a;e++)this.members[e]&&"function"==typeof this.members[e][t]&&this.members[e][t].apply(this.members[e],arguments);return"animate"==t?this.fx||(this.fx=new i.FX.Set(this)):this}})),t=[],i.FX.prototype)"function"==typeof i.FX.prototype[e]&&"function"!=typeof i.FX.Set.prototype[e]&&t.push(e);t.forEach((function(t){i.FX.Set.prototype[t]=function(){for(var e=0,i=this.set.members.length;e<i;e++)this.set.members[e].fx[t].apply(this.set.members[e].fx,arguments);return this}}))},i.extend(i.Element,{}),i.extend(i.Element,{remember:function(t,e){if("object"===b(arguments[0]))for(var i in t)this.remember(i,t[i]);else{if(1==arguments.length)return this.memory()[t];this.memory()[t]=e}return this},forget:function(){if(0==arguments.length)this._memory={};else for(var t=arguments.length-1;t>=0;t--)delete this.memory()[arguments[t]];return this},memory:function(){return this._memory||(this._memory={})}}),i.get=function(t){var a=e.getElementById(function(t){var e=(t||"").toString().match(i.regex.reference);if(e)return e[1]}(t)||t);return i.adopt(a)},i.select=function(t,a){return new i.Set(i.utils.map((a||e).querySelectorAll(t),(function(t){return i.adopt(t)})))},i.extend(i.Parent,{select:function(t){return i.select(t,this.node)}});var v="abcdef".split("");if("function"!=typeof t.CustomEvent){var m=function(t,i){i=i||{bubbles:!1,cancelable:!1,detail:void 0};var a=e.createEvent("CustomEvent");return a.initCustomEvent(t,i.bubbles,i.cancelable,i.detail),a};m.prototype=t.Event.prototype,i.CustomEvent=m}else i.CustomEvent=t.CustomEvent;return i},"function"==typeof define&&define.amd?define((function(){return Wt(Nt,Nt.document)})):"object"===("undefined"==typeof exports?"undefined":b(exports))&&"undefined"!=typeof module?module.exports=Nt.document?Wt(Nt,Nt.document):function(t){return Wt(t,t.document)}:Nt.SVG=Wt(Nt,Nt.document),
/*! svg.filter.js - v2.0.2 - 2016-02-24
  * https://github.com/wout/svg.filter.js
  * Copyright (c) 2016 Wout Fierens; Licensed MIT */
function(){SVG.Filter=SVG.invent({create:"filter",inherit:SVG.Parent,extend:{source:"SourceGraphic",sourceAlpha:"SourceAlpha",background:"BackgroundImage",backgroundAlpha:"BackgroundAlpha",fill:"FillPaint",stroke:"StrokePaint",autoSetIn:!0,put:function(t,e){return this.add(t,e),!t.attr("in")&&this.autoSetIn&&t.attr("in",this.source),t.attr("result")||t.attr("result",t),t},blend:function(t,e,i){return this.put(new SVG.BlendEffect(t,e,i))},colorMatrix:function(t,e){return this.put(new SVG.ColorMatrixEffect(t,e))},convolveMatrix:function(t){return this.put(new SVG.ConvolveMatrixEffect(t))},componentTransfer:function(t){return this.put(new SVG.ComponentTransferEffect(t))},composite:function(t,e,i){return this.put(new SVG.CompositeEffect(t,e,i))},flood:function(t,e){return this.put(new SVG.FloodEffect(t,e))},offset:function(t,e){return this.put(new SVG.OffsetEffect(t,e))},image:function(t){return this.put(new SVG.ImageEffect(t))},merge:function(){var t=[void 0];for(var e in arguments)t.push(arguments[e]);return this.put(new(SVG.MergeEffect.bind.apply(SVG.MergeEffect,t)))},gaussianBlur:function(t,e){return this.put(new SVG.GaussianBlurEffect(t,e))},morphology:function(t,e){return this.put(new SVG.MorphologyEffect(t,e))},diffuseLighting:function(t,e,i){return this.put(new SVG.DiffuseLightingEffect(t,e,i))},displacementMap:function(t,e,i,a,s){return this.put(new SVG.DisplacementMapEffect(t,e,i,a,s))},specularLighting:function(t,e,i,a){return this.put(new SVG.SpecularLightingEffect(t,e,i,a))},tile:function(){return this.put(new SVG.TileEffect)},turbulence:function(t,e,i,a,s){return this.put(new SVG.TurbulenceEffect(t,e,i,a,s))},toString:function(){return"url(#"+this.attr("id")+")"}}}),SVG.extend(SVG.Defs,{filter:function(t){var e=this.put(new SVG.Filter);return"function"==typeof t&&t.call(e,e),e}}),SVG.extend(SVG.Container,{filter:function(t){return this.defs().filter(t)}}),SVG.extend(SVG.Element,SVG.G,SVG.Nested,{filter:function(t){return this.filterer=t instanceof SVG.Element?t:this.doc().filter(t),this.doc()&&this.filterer.doc()!==this.doc()&&this.doc().defs().add(this.filterer),this.attr("filter",this.filterer),this.filterer},unfilter:function(t){return this.filterer&&!0===t&&this.filterer.remove(),delete this.filterer,this.attr("filter",null)}}),SVG.Effect=SVG.invent({create:function(){this.constructor.call(this)},inherit:SVG.Element,extend:{in:function(t){return null==t?this.parent()&&this.parent().select('[result="'+this.attr("in")+'"]').get(0)||this.attr("in"):this.attr("in",t)},result:function(t){return null==t?this.attr("result"):this.attr("result",t)},toString:function(){return this.result()}}}),SVG.ParentEffect=SVG.invent({create:function(){this.constructor.call(this)},inherit:SVG.Parent,extend:{in:function(t){return null==t?this.parent()&&this.parent().select('[result="'+this.attr("in")+'"]').get(0)||this.attr("in"):this.attr("in",t)},result:function(t){return null==t?this.attr("result"):this.attr("result",t)},toString:function(){return this.result()}}});var t={blend:function(t,e){return this.parent()&&this.parent().blend(this,t,e)},colorMatrix:function(t,e){return this.parent()&&this.parent().colorMatrix(t,e).in(this)},convolveMatrix:function(t){return this.parent()&&this.parent().convolveMatrix(t).in(this)},componentTransfer:function(t){return this.parent()&&this.parent().componentTransfer(t).in(this)},composite:function(t,e){return this.parent()&&this.parent().composite(this,t,e)},flood:function(t,e){return this.parent()&&this.parent().flood(t,e)},offset:function(t,e){return this.parent()&&this.parent().offset(t,e).in(this)},image:function(t){return this.parent()&&this.parent().image(t)},merge:function(){return this.parent()&&this.parent().merge.apply(this.parent(),[this].concat(arguments))},gaussianBlur:function(t,e){return this.parent()&&this.parent().gaussianBlur(t,e).in(this)},morphology:function(t,e){return this.parent()&&this.parent().morphology(t,e).in(this)},diffuseLighting:function(t,e,i){return this.parent()&&this.parent().diffuseLighting(t,e,i).in(this)},displacementMap:function(t,e,i,a){return this.parent()&&this.parent().displacementMap(this,t,e,i,a)},specularLighting:function(t,e,i,a){return this.parent()&&this.parent().specularLighting(t,e,i,a).in(this)},tile:function(){return this.parent()&&this.parent().tile().in(this)},turbulence:function(t,e,i,a,s){return this.parent()&&this.parent().turbulence(t,e,i,a,s).in(this)}};SVG.extend(SVG.Effect,t),SVG.extend(SVG.ParentEffect,t),SVG.ChildEffect=SVG.invent({create:function(){this.constructor.call(this)},inherit:SVG.Element,extend:{in:function(t){this.attr("in",t)}}});var e={blend:function(t,e,i){this.attr({in:t,in2:e,mode:i||"normal"})},colorMatrix:function(t,e){"matrix"==t&&(e=s(e)),this.attr({type:t,values:void 0===e?null:e})},convolveMatrix:function(t){t=s(t),this.attr({order:Math.sqrt(t.split(" ").length),kernelMatrix:t})},composite:function(t,e,i){this.attr({in:t,in2:e,operator:i})},flood:function(t,e){this.attr("flood-color",t),null!=e&&this.attr("flood-opacity",e)},offset:function(t,e){this.attr({dx:t,dy:e})},image:function(t){this.attr("href",t,SVG.xlink)},displacementMap:function(t,e,i,a,s){this.attr({in:t,in2:e,scale:i,xChannelSelector:a,yChannelSelector:s})},gaussianBlur:function(t,e){null!=t||null!=e?this.attr("stdDeviation",function(t){if(!Array.isArray(t))return t;for(var e=0,i=t.length,a=[];e<i;e++)a.push(t[e]);return a.join(" ")}(Array.prototype.slice.call(arguments))):this.attr("stdDeviation","0 0")},morphology:function(t,e){this.attr({operator:t,radius:e})},tile:function(){},turbulence:function(t,e,i,a,s){this.attr({numOctaves:e,seed:i,stitchTiles:a,baseFrequency:t,type:s})}},i={merge:function(){var t;if(arguments[0]instanceof SVG.Set){var e=this;arguments[0].each((function(t){this instanceof SVG.MergeNode?e.put(this):(this instanceof SVG.Effect||this instanceof SVG.ParentEffect)&&e.put(new SVG.MergeNode(this))}))}else{t=Array.isArray(arguments[0])?arguments[0]:arguments;for(var i=0;i<t.length;i++)t[i]instanceof SVG.MergeNode?this.put(t[i]):this.put(new SVG.MergeNode(t[i]))}},componentTransfer:function(t){if(this.rgb=new SVG.Set,["r","g","b","a"].forEach(function(t){this[t]=new(SVG["Func"+t.toUpperCase()])("identity"),this.rgb.add(this[t]),this.node.appendChild(this[t].node)}.bind(this)),t)for(var e in t.rgb&&(["r","g","b"].forEach(function(e){this[e].attr(t.rgb)}.bind(this)),delete t.rgb),t)this[e].attr(t[e])},diffuseLighting:function(t,e,i){this.attr({surfaceScale:t,diffuseConstant:e,kernelUnitLength:i})},specularLighting:function(t,e,i,a){this.attr({surfaceScale:t,diffuseConstant:e,specularExponent:i,kernelUnitLength:a})}},a={distantLight:function(t,e){this.attr({azimuth:t,elevation:e})},pointLight:function(t,e,i){this.attr({x:t,y:e,z:i})},spotLight:function(t,e,i,a,s,r){this.attr({x:t,y:e,z:i,pointsAtX:a,pointsAtY:s,pointsAtZ:r})},mergeNode:function(t){this.attr("in",t)}};function s(t){return Array.isArray(t)&&(t=new SVG.Array(t)),t.toString().replace(/^\s+/,"").replace(/\s+$/,"").replace(/\s+/g," ")}function r(){var t=function(){};for(var e in"function"==typeof arguments[arguments.length-1]&&(t=arguments[arguments.length-1],Array.prototype.splice.call(arguments,arguments.length-1,1)),arguments)for(var i in arguments[e])t(arguments[e][i],i,arguments[e])}["r","g","b","a"].forEach((function(t){a["Func"+t.toUpperCase()]=function(t){switch(this.attr("type",t),t){case"table":this.attr("tableValues",arguments[1]);break;case"linear":this.attr("slope",arguments[1]),this.attr("intercept",arguments[2]);break;case"gamma":this.attr("amplitude",arguments[1]),this.attr("exponent",arguments[2]),this.attr("offset",arguments[2])}}})),r(e,(function(t,e){var i=e.charAt(0).toUpperCase()+e.slice(1);SVG[i+"Effect"]=SVG.invent({create:function(){this.constructor.call(this,SVG.create("fe"+i)),t.apply(this,arguments),this.result(this.attr("id")+"Out")},inherit:SVG.Effect,extend:{}})})),r(i,(function(t,e){var i=e.charAt(0).toUpperCase()+e.slice(1);SVG[i+"Effect"]=SVG.invent({create:function(){this.constructor.call(this,SVG.create("fe"+i)),t.apply(this,arguments),this.result(this.attr("id")+"Out")},inherit:SVG.ParentEffect,extend:{}})})),r(a,(function(t,e){var i=e.charAt(0).toUpperCase()+e.slice(1);SVG[i]=SVG.invent({create:function(){this.constructor.call(this,SVG.create("fe"+i)),t.apply(this,arguments)},inherit:SVG.ChildEffect,extend:{}})})),SVG.extend(SVG.MergeEffect,{in:function(t){return t instanceof SVG.MergeNode?this.add(t,0):this.add(new SVG.MergeNode(t),0),this}}),SVG.extend(SVG.CompositeEffect,SVG.BlendEffect,SVG.DisplacementMapEffect,{in2:function(t){return null==t?this.parent()&&this.parent().select('[result="'+this.attr("in2")+'"]').get(0)||this.attr("in2"):this.attr("in2",t)}}),SVG.filter={sepiatone:[.343,.669,.119,0,0,.249,.626,.13,0,0,.172,.334,.111,0,0,0,0,0,1,0]}}.call(void 0),function(){function t(t,s,r,o,n,l,h){for(var c=t.slice(s,r||h),d=o.slice(n,l||h),g=0,u={pos:[0,0],start:[0,0]},f={pos:[0,0],start:[0,0]};;){if(c[g]=e.call(u,c[g]),d[g]=e.call(f,d[g]),c[g][0]!=d[g][0]||"M"==c[g][0]||"A"==c[g][0]&&(c[g][4]!=d[g][4]||c[g][5]!=d[g][5])?(Array.prototype.splice.apply(c,[g,1].concat(a.call(u,c[g]))),Array.prototype.splice.apply(d,[g,1].concat(a.call(f,d[g])))):(c[g]=i.call(u,c[g]),d[g]=i.call(f,d[g])),++g==c.length&&g==d.length)break;g==c.length&&c.push(["C",u.pos[0],u.pos[1],u.pos[0],u.pos[1],u.pos[0],u.pos[1]]),g==d.length&&d.push(["C",f.pos[0],f.pos[1],f.pos[0],f.pos[1],f.pos[0],f.pos[1]])}return{start:c,dest:d}}function e(t){switch(t[0]){case"z":case"Z":t[0]="L",t[1]=this.start[0],t[2]=this.start[1];break;case"H":t[0]="L",t[2]=this.pos[1];break;case"V":t[0]="L",t[2]=t[1],t[1]=this.pos[0];break;case"T":t[0]="Q",t[3]=t[1],t[4]=t[2],t[1]=this.reflection[1],t[2]=this.reflection[0];break;case"S":t[0]="C",t[6]=t[4],t[5]=t[3],t[4]=t[2],t[3]=t[1],t[2]=this.reflection[1],t[1]=this.reflection[0]}return t}function i(t){var e=t.length;return this.pos=[t[e-2],t[e-1]],-1!="SCQT".indexOf(t[0])&&(this.reflection=[2*this.pos[0]-t[e-4],2*this.pos[1]-t[e-3]]),t}function a(t){var e=[t];switch(t[0]){case"M":return this.pos=this.start=[t[1],t[2]],e;case"L":t[5]=t[3]=t[1],t[6]=t[4]=t[2],t[1]=this.pos[0],t[2]=this.pos[1];break;case"Q":t[6]=t[4],t[5]=t[3],t[4]=1*t[4]/3+2*t[2]/3,t[3]=1*t[3]/3+2*t[1]/3,t[2]=1*this.pos[1]/3+2*t[2]/3,t[1]=1*this.pos[0]/3+2*t[1]/3;break;case"A":e=function(t,e){var i,a,s,r,o,n,l,h,c,d,g,u,f,p,x,b,v,m,y,w,k,A,S,C,L,P,M=Math.abs(e[1]),I=Math.abs(e[2]),T=e[3]%360,z=e[4],X=e[5],E=e[6],Y=e[7],R=new SVG.Point(t),F=new SVG.Point(E,Y),D=[];if(0===M||0===I||R.x===F.x&&R.y===F.y)return[["C",R.x,R.y,F.x,F.y,F.x,F.y]];i=new SVG.Point((R.x-F.x)/2,(R.y-F.y)/2).transform((new SVG.Matrix).rotate(T)),(a=i.x*i.x/(M*M)+i.y*i.y/(I*I))>1&&(M*=a=Math.sqrt(a),I*=a);s=(new SVG.Matrix).rotate(T).scale(1/M,1/I).rotate(-T),R=R.transform(s),F=F.transform(s),r=[F.x-R.x,F.y-R.y],n=r[0]*r[0]+r[1]*r[1],o=Math.sqrt(n),r[0]/=o,r[1]/=o,l=n<4?Math.sqrt(1-n/4):0,z===X&&(l*=-1);h=new SVG.Point((F.x+R.x)/2+l*-r[1],(F.y+R.y)/2+l*r[0]),c=new SVG.Point(R.x-h.x,R.y-h.y),d=new SVG.Point(F.x-h.x,F.y-h.y),g=Math.acos(c.x/Math.sqrt(c.x*c.x+c.y*c.y)),c.y<0&&(g*=-1);u=Math.acos(d.x/Math.sqrt(d.x*d.x+d.y*d.y)),d.y<0&&(u*=-1);X&&g>u&&(u+=2*Math.PI);!X&&g<u&&(u-=2*Math.PI);for(p=Math.ceil(2*Math.abs(g-u)/Math.PI),b=[],v=g,f=(u-g)/p,x=4*Math.tan(f/4)/3,k=0;k<=p;k++)y=Math.cos(v),m=Math.sin(v),w=new SVG.Point(h.x+y,h.y+m),b[k]=[new SVG.Point(w.x+x*m,w.y-x*y),w,new SVG.Point(w.x-x*m,w.y+x*y)],v+=f;for(b[0][0]=b[0][1].clone(),b[b.length-1][2]=b[b.length-1][1].clone(),s=(new SVG.Matrix).rotate(T).scale(M,I).rotate(-T),k=0,A=b.length;k<A;k++)b[k][0]=b[k][0].transform(s),b[k][1]=b[k][1].transform(s),b[k][2]=b[k][2].transform(s);for(k=1,A=b.length;k<A;k++)S=(w=b[k-1][2]).x,C=w.y,L=(w=b[k][0]).x,P=w.y,E=(w=b[k][1]).x,Y=w.y,D.push(["C",S,C,L,P,E,Y]);return D}(this.pos,t),t=e[0]}return t[0]="C",this.pos=[t[5],t[6]],this.reflection=[2*t[5]-t[3],2*t[6]-t[4]],e}function s(t,e){if(!1===e)return!1;for(var i=e,a=t.length;i<a;++i)if("M"==t[i][0])return i;return!1}SVG.extend(SVG.PathArray,{morph:function(e){for(var i=this.value,a=this.parse(e),r=0,o=0,n=!1,l=!1;!1!==r||!1!==o;){var h;n=s(i,!1!==r&&r+1),l=s(a,!1!==o&&o+1),!1===r&&(r=0==(h=new SVG.PathArray(c.start).bbox()).height||0==h.width?i.push(i[0])-1:i.push(["M",h.x+h.width/2,h.y+h.height/2])-1),!1===o&&(o=0==(h=new SVG.PathArray(c.dest).bbox()).height||0==h.width?a.push(a[0])-1:a.push(["M",h.x+h.width/2,h.y+h.height/2])-1);var c=t(i,r,n,a,o,l);i=i.slice(0,r).concat(c.start,!1===n?[]:i.slice(n)),a=a.slice(0,o).concat(c.dest,!1===l?[]:a.slice(l)),r=!1!==n&&r+c.start.length,o=!1!==l&&o+c.dest.length}return this.value=i,this.destination=new SVG.PathArray,this.destination.value=a,this}})}(),
/*! svg.draggable.js - v2.2.2 - 2019-01-08
  * https://github.com/svgdotjs/svg.draggable.js
  * Copyright (c) 2019 Wout Fierens; Licensed MIT */
function(){function t(t){t.remember("_draggable",this),this.el=t}t.prototype.init=function(t,e){var i=this;this.constraint=t,this.value=e,this.el.on("mousedown.drag",(function(t){i.start(t)})),this.el.on("touchstart.drag",(function(t){i.start(t)}))},t.prototype.transformPoint=function(t,e){var i=(t=t||window.event).changedTouches&&t.changedTouches[0]||t;return this.p.x=i.clientX-(e||0),this.p.y=i.clientY,this.p.matrixTransform(this.m)},t.prototype.getBBox=function(){var t=this.el.bbox();return this.el instanceof SVG.Nested&&(t=this.el.rbox()),(this.el instanceof SVG.G||this.el instanceof SVG.Use||this.el instanceof SVG.Nested)&&(t.x=this.el.x(),t.y=this.el.y()),t},t.prototype.start=function(t){if("click"!=t.type&&"mousedown"!=t.type&&"mousemove"!=t.type||1==(t.which||t.buttons)){var e=this;if(this.el.fire("beforedrag",{event:t,handler:this}),!this.el.event().defaultPrevented){t.preventDefault(),t.stopPropagation(),this.parent=this.parent||this.el.parent(SVG.Nested)||this.el.parent(SVG.Doc),this.p=this.parent.node.createSVGPoint(),this.m=this.el.node.getScreenCTM().inverse();var i,a=this.getBBox();if(this.el instanceof SVG.Text)switch(i=this.el.node.getComputedTextLength(),this.el.attr("text-anchor")){case"middle":i/=2;break;case"start":i=0}this.startPoints={point:this.transformPoint(t,i),box:a,transform:this.el.transform()},SVG.on(window,"mousemove.drag",(function(t){e.drag(t)})),SVG.on(window,"touchmove.drag",(function(t){e.drag(t)})),SVG.on(window,"mouseup.drag",(function(t){e.end(t)})),SVG.on(window,"touchend.drag",(function(t){e.end(t)})),this.el.fire("dragstart",{event:t,p:this.startPoints.point,m:this.m,handler:this})}}},t.prototype.drag=function(t){var e=this.getBBox(),i=this.transformPoint(t),a=this.startPoints.box.x+i.x-this.startPoints.point.x,s=this.startPoints.box.y+i.y-this.startPoints.point.y,r=this.constraint,o=i.x-this.startPoints.point.x,n=i.y-this.startPoints.point.y;if(this.el.fire("dragmove",{event:t,p:i,m:this.m,handler:this}),this.el.event().defaultPrevented)return i;if("function"==typeof r){var l=r.call(this.el,a,s,this.m);"boolean"==typeof l&&(l={x:l,y:l}),!0===l.x?this.el.x(a):!1!==l.x&&this.el.x(l.x),!0===l.y?this.el.y(s):!1!==l.y&&this.el.y(l.y)}else"object"==typeof r&&(null!=r.minX&&a<r.minX?o=(a=r.minX)-this.startPoints.box.x:null!=r.maxX&&a>r.maxX-e.width&&(o=(a=r.maxX-e.width)-this.startPoints.box.x),null!=r.minY&&s<r.minY?n=(s=r.minY)-this.startPoints.box.y:null!=r.maxY&&s>r.maxY-e.height&&(n=(s=r.maxY-e.height)-this.startPoints.box.y),null!=r.snapToGrid&&(a-=a%r.snapToGrid,s-=s%r.snapToGrid,o-=o%r.snapToGrid,n-=n%r.snapToGrid),this.el instanceof SVG.G?this.el.matrix(this.startPoints.transform).transform({x:o,y:n},!0):this.el.move(a,s));return i},t.prototype.end=function(t){var e=this.drag(t);this.el.fire("dragend",{event:t,p:e,m:this.m,handler:this}),SVG.off(window,"mousemove.drag"),SVG.off(window,"touchmove.drag"),SVG.off(window,"mouseup.drag"),SVG.off(window,"touchend.drag")},SVG.extend(SVG.Element,{draggable:function(e,i){"function"!=typeof e&&"object"!=typeof e||(i=e,e=!0);var a=this.remember("_draggable")||new t(this);return(e=void 0===e||e)?a.init(i||{},e):(this.off("mousedown.drag"),this.off("touchstart.drag")),this}})}.call(void 0),function(){function t(t){this.el=t,t.remember("_selectHandler",this),this.pointSelection={isSelected:!1},this.rectSelection={isSelected:!1},this.pointsList={lt:[0,0],rt:["width",0],rb:["width","height"],lb:[0,"height"],t:["width",0],r:["width","height"],b:["width","height"],l:[0,"height"]},this.pointCoord=function(t,e,i){var a="string"!=typeof t?t:e[t];return i?a/2:a},this.pointCoords=function(t,e){var i=this.pointsList[t];return{x:this.pointCoord(i[0],e,"t"===t||"b"===t),y:this.pointCoord(i[1],e,"r"===t||"l"===t)}}}t.prototype.init=function(t,e){var i=this.el.bbox();this.options={};var a=this.el.selectize.defaults.points;for(var s in this.el.selectize.defaults)this.options[s]=this.el.selectize.defaults[s],void 0!==e[s]&&(this.options[s]=e[s]);var r=["points","pointsExclude"];for(var s in r){var o=this.options[r[s]];"string"==typeof o?o=o.length>0?o.split(/\s*,\s*/i):[]:"boolean"==typeof o&&"points"===r[s]&&(o=o?a:[]),this.options[r[s]]=o}this.options.points=[a,this.options.points].reduce((function(t,e){return t.filter((function(t){return e.indexOf(t)>-1}))})),this.options.points=[this.options.points,this.options.pointsExclude].reduce((function(t,e){return t.filter((function(t){return e.indexOf(t)<0}))})),this.parent=this.el.parent(),this.nested=this.nested||this.parent.group(),this.nested.matrix(new SVG.Matrix(this.el).translate(i.x,i.y)),this.options.deepSelect&&-1!==["line","polyline","polygon"].indexOf(this.el.type)?this.selectPoints(t):this.selectRect(t),this.observe(),this.cleanup()},t.prototype.selectPoints=function(t){return this.pointSelection.isSelected=t,this.pointSelection.set||(this.pointSelection.set=this.parent.set(),this.drawPoints()),this},t.prototype.getPointArray=function(){var t=this.el.bbox();return this.el.array().valueOf().map((function(e){return[e[0]-t.x,e[1]-t.y]}))},t.prototype.drawPoints=function(){for(var t=this,e=this.getPointArray(),i=0,a=e.length;i<a;++i){var s=function(e){return function(i){(i=i||window.event).preventDefault?i.preventDefault():i.returnValue=!1,i.stopPropagation();var a=i.pageX||i.touches[0].pageX,s=i.pageY||i.touches[0].pageY;t.el.fire("point",{x:a,y:s,i:e,event:i})}}(i),r=this.drawPoint(e[i][0],e[i][1]).addClass(this.options.classPoints).addClass(this.options.classPoints+"_point").on("touchstart",s).on("mousedown",s);this.pointSelection.set.add(r)}},t.prototype.drawPoint=function(t,e){var i=this.options.pointType;switch(i){case"circle":return this.drawCircle(t,e);case"rect":return this.drawRect(t,e);default:if("function"==typeof i)return i.call(this,t,e);throw new Error("Unknown "+i+" point type!")}},t.prototype.drawCircle=function(t,e){return this.nested.circle(this.options.pointSize).center(t,e)},t.prototype.drawRect=function(t,e){return this.nested.rect(this.options.pointSize,this.options.pointSize).center(t,e)},t.prototype.updatePointSelection=function(){var t=this.getPointArray();this.pointSelection.set.each((function(e){this.cx()===t[e][0]&&this.cy()===t[e][1]||this.center(t[e][0],t[e][1])}))},t.prototype.updateRectSelection=function(){var t=this,e=this.el.bbox();if(this.rectSelection.set.get(0).attr({width:e.width,height:e.height}),this.options.points.length&&this.options.points.map((function(i,a){var s=t.pointCoords(i,e);t.rectSelection.set.get(a+1).center(s.x,s.y)})),this.options.rotationPoint){var i=this.rectSelection.set.length();this.rectSelection.set.get(i-1).center(e.width/2,20)}},t.prototype.selectRect=function(t){var e=this,i=this.el.bbox();function a(t){return function(i){(i=i||window.event).preventDefault?i.preventDefault():i.returnValue=!1,i.stopPropagation();var a=i.pageX||i.touches[0].pageX,s=i.pageY||i.touches[0].pageY;e.el.fire(t,{x:a,y:s,event:i})}}if(this.rectSelection.isSelected=t,this.rectSelection.set=this.rectSelection.set||this.parent.set(),this.rectSelection.set.get(0)||this.rectSelection.set.add(this.nested.rect(i.width,i.height).addClass(this.options.classRect)),this.options.points.length&&this.rectSelection.set.length()<2){this.options.points.map((function(t,s){var r=e.pointCoords(t,i),o=e.drawPoint(r.x,r.y).attr("class",e.options.classPoints+"_"+t).on("mousedown",a(t)).on("touchstart",a(t));e.rectSelection.set.add(o)})),this.rectSelection.set.each((function(){this.addClass(e.options.classPoints)}))}if(this.options.rotationPoint&&(this.options.points&&!this.rectSelection.set.get(9)||!this.options.points&&!this.rectSelection.set.get(1))){var s=function(t){(t=t||window.event).preventDefault?t.preventDefault():t.returnValue=!1,t.stopPropagation();var i=t.pageX||t.touches[0].pageX,a=t.pageY||t.touches[0].pageY;e.el.fire("rot",{x:i,y:a,event:t})},r=this.drawPoint(i.width/2,20).attr("class",this.options.classPoints+"_rot").on("touchstart",s).on("mousedown",s);this.rectSelection.set.add(r)}},t.prototype.handler=function(){var t=this.el.bbox();this.nested.matrix(new SVG.Matrix(this.el).translate(t.x,t.y)),this.rectSelection.isSelected&&this.updateRectSelection(),this.pointSelection.isSelected&&this.updatePointSelection()},t.prototype.observe=function(){var t=this;if(MutationObserver)if(this.rectSelection.isSelected||this.pointSelection.isSelected)this.observerInst=this.observerInst||new MutationObserver((function(){t.handler()})),this.observerInst.observe(this.el.node,{attributes:!0});else try{this.observerInst.disconnect(),delete this.observerInst}catch(t){}else this.el.off("DOMAttrModified.select"),(this.rectSelection.isSelected||this.pointSelection.isSelected)&&this.el.on("DOMAttrModified.select",(function(){t.handler()}))},t.prototype.cleanup=function(){!this.rectSelection.isSelected&&this.rectSelection.set&&(this.rectSelection.set.each((function(){this.remove()})),this.rectSelection.set.clear(),delete this.rectSelection.set),!this.pointSelection.isSelected&&this.pointSelection.set&&(this.pointSelection.set.each((function(){this.remove()})),this.pointSelection.set.clear(),delete this.pointSelection.set),this.pointSelection.isSelected||this.rectSelection.isSelected||(this.nested.remove(),delete this.nested)},SVG.extend(SVG.Element,{selectize:function(e,i){return"object"==typeof e&&(i=e,e=!0),(this.remember("_selectHandler")||new t(this)).init(void 0===e||e,i||{}),this}}),SVG.Element.prototype.selectize.defaults={points:["lt","rt","rb","lb","t","r","b","l"],pointsExclude:[],classRect:"svg_select_boundingRect",classPoints:"svg_select_points",pointSize:7,rotationPoint:!0,deepSelect:!1,pointType:"circle"}}(),function(){(function(){function t(t){t.remember("_resizeHandler",this),this.el=t,this.parameters={},this.lastUpdateCall=null,this.p=t.doc().node.createSVGPoint()}t.prototype.transformPoint=function(t,e,i){return this.p.x=t-(this.offset.x-window.pageXOffset),this.p.y=e-(this.offset.y-window.pageYOffset),this.p.matrixTransform(i||this.m)},t.prototype._extractPosition=function(t){return{x:null!=t.clientX?t.clientX:t.touches[0].clientX,y:null!=t.clientY?t.clientY:t.touches[0].clientY}},t.prototype.init=function(t){var e=this;if(this.stop(),"stop"!==t){for(var i in this.options={},this.el.resize.defaults)this.options[i]=this.el.resize.defaults[i],void 0!==t[i]&&(this.options[i]=t[i]);this.el.on("lt.resize",(function(t){e.resize(t||window.event)})),this.el.on("rt.resize",(function(t){e.resize(t||window.event)})),this.el.on("rb.resize",(function(t){e.resize(t||window.event)})),this.el.on("lb.resize",(function(t){e.resize(t||window.event)})),this.el.on("t.resize",(function(t){e.resize(t||window.event)})),this.el.on("r.resize",(function(t){e.resize(t||window.event)})),this.el.on("b.resize",(function(t){e.resize(t||window.event)})),this.el.on("l.resize",(function(t){e.resize(t||window.event)})),this.el.on("rot.resize",(function(t){e.resize(t||window.event)})),this.el.on("point.resize",(function(t){e.resize(t||window.event)})),this.update()}},t.prototype.stop=function(){return this.el.off("lt.resize"),this.el.off("rt.resize"),this.el.off("rb.resize"),this.el.off("lb.resize"),this.el.off("t.resize"),this.el.off("r.resize"),this.el.off("b.resize"),this.el.off("l.resize"),this.el.off("rot.resize"),this.el.off("point.resize"),this},t.prototype.resize=function(t){var e=this;this.m=this.el.node.getScreenCTM().inverse(),this.offset={x:window.pageXOffset,y:window.pageYOffset};var i=this._extractPosition(t.detail.event);if(this.parameters={type:this.el.type,p:this.transformPoint(i.x,i.y),x:t.detail.x,y:t.detail.y,box:this.el.bbox(),rotation:this.el.transform().rotation},"text"===this.el.type&&(this.parameters.fontSize=this.el.attr()["font-size"]),void 0!==t.detail.i){var a=this.el.array().valueOf();this.parameters.i=t.detail.i,this.parameters.pointCoords=[a[t.detail.i][0],a[t.detail.i][1]]}switch(t.type){case"lt":this.calc=function(t,e){var i=this.snapToGrid(t,e);if(this.parameters.box.width-i[0]>0&&this.parameters.box.height-i[1]>0){if("text"===this.parameters.type)return this.el.move(this.parameters.box.x+i[0],this.parameters.box.y),void this.el.attr("font-size",this.parameters.fontSize-i[0]);i=this.checkAspectRatio(i),this.el.move(this.parameters.box.x+i[0],this.parameters.box.y+i[1]).size(this.parameters.box.width-i[0],this.parameters.box.height-i[1])}};break;case"rt":this.calc=function(t,e){var i=this.snapToGrid(t,e,2);if(this.parameters.box.width+i[0]>0&&this.parameters.box.height-i[1]>0){if("text"===this.parameters.type)return this.el.move(this.parameters.box.x-i[0],this.parameters.box.y),void this.el.attr("font-size",this.parameters.fontSize+i[0]);i=this.checkAspectRatio(i,!0),this.el.move(this.parameters.box.x,this.parameters.box.y+i[1]).size(this.parameters.box.width+i[0],this.parameters.box.height-i[1])}};break;case"rb":this.calc=function(t,e){var i=this.snapToGrid(t,e,0);if(this.parameters.box.width+i[0]>0&&this.parameters.box.height+i[1]>0){if("text"===this.parameters.type)return this.el.move(this.parameters.box.x-i[0],this.parameters.box.y),void this.el.attr("font-size",this.parameters.fontSize+i[0]);i=this.checkAspectRatio(i),this.el.move(this.parameters.box.x,this.parameters.box.y).size(this.parameters.box.width+i[0],this.parameters.box.height+i[1])}};break;case"lb":this.calc=function(t,e){var i=this.snapToGrid(t,e,1);if(this.parameters.box.width-i[0]>0&&this.parameters.box.height+i[1]>0){if("text"===this.parameters.type)return this.el.move(this.parameters.box.x+i[0],this.parameters.box.y),void this.el.attr("font-size",this.parameters.fontSize-i[0]);i=this.checkAspectRatio(i,!0),this.el.move(this.parameters.box.x+i[0],this.parameters.box.y).size(this.parameters.box.width-i[0],this.parameters.box.height+i[1])}};break;case"t":this.calc=function(t,e){var i=this.snapToGrid(t,e,2);if(this.parameters.box.height-i[1]>0){if("text"===this.parameters.type)return;this.el.move(this.parameters.box.x,this.parameters.box.y+i[1]).height(this.parameters.box.height-i[1])}};break;case"r":this.calc=function(t,e){var i=this.snapToGrid(t,e,0);if(this.parameters.box.width+i[0]>0){if("text"===this.parameters.type)return;this.el.move(this.parameters.box.x,this.parameters.box.y).width(this.parameters.box.width+i[0])}};break;case"b":this.calc=function(t,e){var i=this.snapToGrid(t,e,0);if(this.parameters.box.height+i[1]>0){if("text"===this.parameters.type)return;this.el.move(this.parameters.box.x,this.parameters.box.y).height(this.parameters.box.height+i[1])}};break;case"l":this.calc=function(t,e){var i=this.snapToGrid(t,e,1);if(this.parameters.box.width-i[0]>0){if("text"===this.parameters.type)return;this.el.move(this.parameters.box.x+i[0],this.parameters.box.y).width(this.parameters.box.width-i[0])}};break;case"rot":this.calc=function(t,e){var i=t+this.parameters.p.x,a=e+this.parameters.p.y,s=Math.atan2(this.parameters.p.y-this.parameters.box.y-this.parameters.box.height/2,this.parameters.p.x-this.parameters.box.x-this.parameters.box.width/2),r=Math.atan2(a-this.parameters.box.y-this.parameters.box.height/2,i-this.parameters.box.x-this.parameters.box.width/2),o=this.parameters.rotation+180*(r-s)/Math.PI+this.options.snapToAngle/2;this.el.center(this.parameters.box.cx,this.parameters.box.cy).rotate(o-o%this.options.snapToAngle,this.parameters.box.cx,this.parameters.box.cy)};break;case"point":this.calc=function(t,e){var i=this.snapToGrid(t,e,this.parameters.pointCoords[0],this.parameters.pointCoords[1]),a=this.el.array().valueOf();a[this.parameters.i][0]=this.parameters.pointCoords[0]+i[0],a[this.parameters.i][1]=this.parameters.pointCoords[1]+i[1],this.el.plot(a)}}this.el.fire("resizestart",{dx:this.parameters.x,dy:this.parameters.y,event:t}),SVG.on(window,"touchmove.resize",(function(t){e.update(t||window.event)})),SVG.on(window,"touchend.resize",(function(){e.done()})),SVG.on(window,"mousemove.resize",(function(t){e.update(t||window.event)})),SVG.on(window,"mouseup.resize",(function(){e.done()}))},t.prototype.update=function(t){if(t){var e=this._extractPosition(t),i=this.transformPoint(e.x,e.y),a=i.x-this.parameters.p.x,s=i.y-this.parameters.p.y;this.lastUpdateCall=[a,s],this.calc(a,s),this.el.fire("resizing",{dx:a,dy:s,event:t})}else this.lastUpdateCall&&this.calc(this.lastUpdateCall[0],this.lastUpdateCall[1])},t.prototype.done=function(){this.lastUpdateCall=null,SVG.off(window,"mousemove.resize"),SVG.off(window,"mouseup.resize"),SVG.off(window,"touchmove.resize"),SVG.off(window,"touchend.resize"),this.el.fire("resizedone")},t.prototype.snapToGrid=function(t,e,i,a){var s;return void 0!==a?s=[(i+t)%this.options.snapToGrid,(a+e)%this.options.snapToGrid]:(i=null==i?3:i,s=[(this.parameters.box.x+t+(1&i?0:this.parameters.box.width))%this.options.snapToGrid,(this.parameters.box.y+e+(2&i?0:this.parameters.box.height))%this.options.snapToGrid]),t<0&&(s[0]-=this.options.snapToGrid),e<0&&(s[1]-=this.options.snapToGrid),t-=Math.abs(s[0])<this.options.snapToGrid/2?s[0]:s[0]-(t<0?-this.options.snapToGrid:this.options.snapToGrid),e-=Math.abs(s[1])<this.options.snapToGrid/2?s[1]:s[1]-(e<0?-this.options.snapToGrid:this.options.snapToGrid),this.constraintToBox(t,e,i,a)},t.prototype.constraintToBox=function(t,e,i,a){var s,r,o=this.options.constraint||{};return void 0!==a?(s=i,r=a):(s=this.parameters.box.x+(1&i?0:this.parameters.box.width),r=this.parameters.box.y+(2&i?0:this.parameters.box.height)),void 0!==o.minX&&s+t<o.minX&&(t=o.minX-s),void 0!==o.maxX&&s+t>o.maxX&&(t=o.maxX-s),void 0!==o.minY&&r+e<o.minY&&(e=o.minY-r),void 0!==o.maxY&&r+e>o.maxY&&(e=o.maxY-r),[t,e]},t.prototype.checkAspectRatio=function(t,e){if(!this.options.saveAspectRatio)return t;var i=t.slice(),a=this.parameters.box.width/this.parameters.box.height,s=this.parameters.box.width+t[0],r=this.parameters.box.height-t[1],o=s/r;return o<a?(i[1]=s/a-this.parameters.box.height,e&&(i[1]=-i[1])):o>a&&(i[0]=this.parameters.box.width-r*a,e&&(i[0]=-i[0])),i},SVG.extend(SVG.Element,{resize:function(e){return(this.remember("_resizeHandler")||new t(this)).init(e||{}),this}}),SVG.Element.prototype.resize.defaults={snapToAngle:.1,snapToGrid:1,constraint:{},saveAspectRatio:!1}}).call(this)}(),void 0===window.Apex&&(window.Apex={});var qt=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w}return s(t,[{key:"initModules",value:function(){this.ctx.publicMethods=["updateOptions","updateSeries","appendData","appendSeries","isSeriesHidden","highlightSeries","toggleSeries","showSeries","hideSeries","setLocale","resetSeries","zoomX","toggleDataPointSelection","dataURI","exportToCSV","addXaxisAnnotation","addYaxisAnnotation","addPointAnnotation","clearAnnotations","removeAnnotation","paper","destroy"],this.ctx.eventList=["click","mousedown","mousemove","mouseleave","touchstart","touchmove","touchleave","mouseup","touchend"],this.ctx.animations=new y(this.ctx),this.ctx.axes=new et(this.ctx),this.ctx.core=new _t(this.ctx.el,this.ctx),this.ctx.config=new D({}),this.ctx.data=new _(this.ctx),this.ctx.grid=new Z(this.ctx),this.ctx.graphics=new k(this.ctx),this.ctx.coreUtils=new A(this.ctx),this.ctx.crosshairs=new it(this.ctx),this.ctx.events=new K(this.ctx),this.ctx.exports=new U(this.ctx),this.ctx.fill=new N(this.ctx),this.ctx.localization=new tt(this.ctx),this.ctx.options=new X,this.ctx.responsive=new at(this.ctx),this.ctx.series=new V(this.ctx),this.ctx.theme=new st(this.ctx),this.ctx.formatters=new P(this.ctx),this.ctx.titleSubtitle=new rt(this.ctx),this.ctx.legend=new gt(this.ctx),this.ctx.toolbar=new ut(this.ctx),this.ctx.tooltip=new wt(this.ctx),this.ctx.dimensions=new ct(this.ctx),this.ctx.updateHelpers=new Ut(this.ctx),this.ctx.zoomPanSelection=new ft(this.ctx),this.ctx.w.globals.tooltip=new wt(this.ctx)}}]),t}(),Zt=function(){function t(e){i(this,t),this.ctx=e,this.w=e.w}return s(t,[{key:"clear",value:function(t){var e=t.isUpdating;this.ctx.zoomPanSelection&&this.ctx.zoomPanSelection.destroy(),this.ctx.toolbar&&this.ctx.toolbar.destroy(),this.ctx.animations=null,this.ctx.axes=null,this.ctx.annotations=null,this.ctx.core=null,this.ctx.data=null,this.ctx.grid=null,this.ctx.series=null,this.ctx.responsive=null,this.ctx.theme=null,this.ctx.formatters=null,this.ctx.titleSubtitle=null,this.ctx.legend=null,this.ctx.dimensions=null,this.ctx.options=null,this.ctx.crosshairs=null,this.ctx.zoomPanSelection=null,this.ctx.updateHelpers=null,this.ctx.toolbar=null,this.ctx.localization=null,this.ctx.w.globals.tooltip=null,this.clearDomElements({isUpdating:e})}},{key:"killSVG",value:function(t){t.each((function(){this.removeClass("*"),this.off(),this.stop()}),!0),t.ungroup(),t.clear()}},{key:"clearDomElements",value:function(t){var e=this,i=t.isUpdating,a=this.w.globals.dom.Paper.node;a.parentNode&&a.parentNode.parentNode&&!i&&(a.parentNode.parentNode.style.minHeight="unset");var s=this.w.globals.dom.baseEl;s&&this.ctx.eventList.forEach((function(t){s.removeEventListener(t,e.ctx.events.documentEvent)}));var r=this.w.globals.dom;if(null!==this.ctx.el)for(;this.ctx.el.firstChild;)this.ctx.el.removeChild(this.ctx.el.firstChild);this.killSVG(r.Paper),r.Paper.remove(),r.elWrap=null,r.elGraphical=null,r.elLegendWrap=null,r.elLegendForeign=null,r.baseEl=null,r.elGridRect=null,r.elGridRectMask=null,r.elGridRectBarMask=null,r.elGridRectMarkerMask=null,r.elForecastMask=null,r.elNonForecastMask=null,r.elDefs=null}}]),t}(),$t=new WeakMap;var Jt=function(){function t(e,a){i(this,t),this.opts=a,this.ctx=this,this.w=new O(a).init(),this.el=e,this.w.globals.cuid=m.randomId(),this.w.globals.chartID=this.w.config.chart.id?m.escapeString(this.w.config.chart.id):this.w.globals.cuid,new qt(this).initModules(),this.create=m.bind(this.create,this),this.windowResizeHandler=this._windowResizeHandler.bind(this),this.parentResizeHandler=this._parentResizeCallback.bind(this)}return s(t,[{key:"render",value:function(){var t=this;return new Promise((function(e,i){if(null!==t.el){void 0===Apex._chartInstances&&(Apex._chartInstances=[]),t.w.config.chart.id&&Apex._chartInstances.push({id:t.w.globals.chartID,group:t.w.config.chart.group,chart:t}),t.setLocale(t.w.config.chart.defaultLocale);var a=t.w.config.chart.events.beforeMount;"function"==typeof a&&a(t,t.w),t.events.fireEvent("beforeMount",[t,t.w]),window.addEventListener("resize",t.windowResizeHandler),function(t,e){var i=!1;if(t.nodeType!==Node.DOCUMENT_FRAGMENT_NODE){var a=t.getBoundingClientRect();"none"!==t.style.display&&0!==a.width||(i=!0)}var s=new ResizeObserver((function(a){i&&e.call(t,a),i=!0}));t.nodeType===Node.DOCUMENT_FRAGMENT_NODE?Array.from(t.children).forEach((function(t){return s.observe(t)})):s.observe(t),$t.set(e,s)}(t.el.parentNode,t.parentResizeHandler);var s=t.el.getRootNode&&t.el.getRootNode(),r=m.is("ShadowRoot",s),o=t.el.ownerDocument,n=r?s.getElementById("apexcharts-css"):o.getElementById("apexcharts-css");if(!n){var l;(n=document.createElement("style")).id="apexcharts-css",n.textContent='@keyframes opaque {\n  0% {\n    opacity: 0\n  }\n\n  to {\n    opacity: 1\n  }\n}\n\n@keyframes resizeanim {\n\n  0%,\n  to {\n    opacity: 0\n  }\n}\n\n.apexcharts-canvas {\n  position: relative;\n  direction: ltr !important;\n  user-select: none\n}\n\n.apexcharts-canvas ::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 6px\n}\n\n.apexcharts-canvas ::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, .5);\n  box-shadow: 0 0 1px rgba(255, 255, 255, .5);\n  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, .5)\n}\n\n.apexcharts-inner {\n  position: relative\n}\n\n.apexcharts-text tspan {\n  font-family: inherit\n}\n\nrect.legend-mouseover-inactive,\n.legend-mouseover-inactive rect,\n.legend-mouseover-inactive path,\n.legend-mouseover-inactive circle,\n.legend-mouseover-inactive line,\n.legend-mouseover-inactive text.apexcharts-yaxis-title-text,\n.legend-mouseover-inactive text.apexcharts-yaxis-label {\n  transition: .15s ease all;\n  opacity: .2\n}\n\n.apexcharts-legend-text {\n  padding-left: 15px;\n  margin-left: -15px;\n}\n\n.apexcharts-series-collapsed {\n  opacity: 0\n}\n\n.apexcharts-tooltip {\n  border-radius: 5px;\n  box-shadow: 2px 2px 6px -4px #999;\n  cursor: default;\n  font-size: 14px;\n  left: 62px;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 20px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  white-space: nowrap;\n  z-index: 12;\n  transition: .15s ease all\n}\n\n.apexcharts-tooltip.apexcharts-active {\n  opacity: 1;\n  transition: .15s ease all\n}\n\n.apexcharts-tooltip.apexcharts-theme-light {\n  border: 1px solid #e3e3e3;\n  background: rgba(255, 255, 255, .96)\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark {\n  color: #fff;\n  background: rgba(30, 30, 30, .8)\n}\n\n.apexcharts-tooltip * {\n  font-family: inherit\n}\n\n.apexcharts-tooltip-title {\n  padding: 6px;\n  font-size: 15px;\n  margin-bottom: 4px\n}\n\n.apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {\n  background: #eceff1;\n  border-bottom: 1px solid #ddd\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark .apexcharts-tooltip-title {\n  background: rgba(0, 0, 0, .7);\n  border-bottom: 1px solid #333\n}\n\n.apexcharts-tooltip-text-goals-value,\n.apexcharts-tooltip-text-y-value,\n.apexcharts-tooltip-text-z-value {\n  display: inline-block;\n  margin-left: 5px;\n  font-weight: 600\n}\n\n.apexcharts-tooltip-text-goals-label:empty,\n.apexcharts-tooltip-text-goals-value:empty,\n.apexcharts-tooltip-text-y-label:empty,\n.apexcharts-tooltip-text-y-value:empty,\n.apexcharts-tooltip-text-z-value:empty,\n.apexcharts-tooltip-title:empty {\n  display: none\n}\n\n.apexcharts-tooltip-text-goals-label,\n.apexcharts-tooltip-text-goals-value {\n  padding: 6px 0 5px\n}\n\n.apexcharts-tooltip-goals-group,\n.apexcharts-tooltip-text-goals-label,\n.apexcharts-tooltip-text-goals-value {\n  display: flex\n}\n\n.apexcharts-tooltip-text-goals-label:not(:empty),\n.apexcharts-tooltip-text-goals-value:not(:empty) {\n  margin-top: -6px\n}\n\n.apexcharts-tooltip-marker {\n  width: 12px;\n  height: 12px;\n  position: relative;\n  top: 0;\n  margin-right: 10px;\n  border-radius: 50%\n}\n\n.apexcharts-tooltip-series-group {\n  padding: 0 10px;\n  display: none;\n  text-align: left;\n  justify-content: left;\n  align-items: center\n}\n\n.apexcharts-tooltip-series-group.apexcharts-active .apexcharts-tooltip-marker {\n  opacity: 1\n}\n\n.apexcharts-tooltip-series-group.apexcharts-active,\n.apexcharts-tooltip-series-group:last-child {\n  padding-bottom: 4px\n}\n\n.apexcharts-tooltip-y-group {\n  padding: 6px 0 5px\n}\n\n.apexcharts-custom-tooltip,\n.apexcharts-tooltip-box {\n  padding: 4px 8px\n}\n\n.apexcharts-tooltip-boxPlot {\n  display: flex;\n  flex-direction: column-reverse\n}\n\n.apexcharts-tooltip-box>div {\n  margin: 4px 0\n}\n\n.apexcharts-tooltip-box span.value {\n  font-weight: 700\n}\n\n.apexcharts-tooltip-rangebar {\n  padding: 5px 8px\n}\n\n.apexcharts-tooltip-rangebar .category {\n  font-weight: 600;\n  color: #777\n}\n\n.apexcharts-tooltip-rangebar .series-name {\n  font-weight: 700;\n  display: block;\n  margin-bottom: 5px\n}\n\n.apexcharts-xaxistooltip,\n.apexcharts-yaxistooltip {\n  opacity: 0;\n  pointer-events: none;\n  color: #373d3f;\n  font-size: 13px;\n  text-align: center;\n  border-radius: 2px;\n  position: absolute;\n  z-index: 10;\n  background: #eceff1;\n  border: 1px solid #90a4ae\n}\n\n.apexcharts-xaxistooltip {\n  padding: 9px 10px;\n  transition: .15s ease all\n}\n\n.apexcharts-xaxistooltip.apexcharts-theme-dark {\n  background: rgba(0, 0, 0, .7);\n  border: 1px solid rgba(0, 0, 0, .5);\n  color: #fff\n}\n\n.apexcharts-xaxistooltip:after,\n.apexcharts-xaxistooltip:before {\n  left: 50%;\n  border: solid transparent;\n  content: " ";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none\n}\n\n.apexcharts-xaxistooltip:after {\n  border-color: transparent;\n  border-width: 6px;\n  margin-left: -6px\n}\n\n.apexcharts-xaxistooltip:before {\n  border-color: transparent;\n  border-width: 7px;\n  margin-left: -7px\n}\n\n.apexcharts-xaxistooltip-bottom:after,\n.apexcharts-xaxistooltip-bottom:before {\n  bottom: 100%\n}\n\n.apexcharts-xaxistooltip-top:after,\n.apexcharts-xaxistooltip-top:before {\n  top: 100%\n}\n\n.apexcharts-xaxistooltip-bottom:after {\n  border-bottom-color: #eceff1\n}\n\n.apexcharts-xaxistooltip-bottom:before {\n  border-bottom-color: #90a4ae\n}\n\n.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:after,\n.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:before {\n  border-bottom-color: rgba(0, 0, 0, .5)\n}\n\n.apexcharts-xaxistooltip-top:after {\n  border-top-color: #eceff1\n}\n\n.apexcharts-xaxistooltip-top:before {\n  border-top-color: #90a4ae\n}\n\n.apexcharts-xaxistooltip-top.apexcharts-theme-dark:after,\n.apexcharts-xaxistooltip-top.apexcharts-theme-dark:before {\n  border-top-color: rgba(0, 0, 0, .5)\n}\n\n.apexcharts-xaxistooltip.apexcharts-active {\n  opacity: 1;\n  transition: .15s ease all\n}\n\n.apexcharts-yaxistooltip {\n  padding: 4px 10px\n}\n\n.apexcharts-yaxistooltip.apexcharts-theme-dark {\n  background: rgba(0, 0, 0, .7);\n  border: 1px solid rgba(0, 0, 0, .5);\n  color: #fff\n}\n\n.apexcharts-yaxistooltip:after,\n.apexcharts-yaxistooltip:before {\n  top: 50%;\n  border: solid transparent;\n  content: " ";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none\n}\n\n.apexcharts-yaxistooltip:after {\n  border-color: transparent;\n  border-width: 6px;\n  margin-top: -6px\n}\n\n.apexcharts-yaxistooltip:before {\n  border-color: transparent;\n  border-width: 7px;\n  margin-top: -7px\n}\n\n.apexcharts-yaxistooltip-left:after,\n.apexcharts-yaxistooltip-left:before {\n  left: 100%\n}\n\n.apexcharts-yaxistooltip-right:after,\n.apexcharts-yaxistooltip-right:before {\n  right: 100%\n}\n\n.apexcharts-yaxistooltip-left:after {\n  border-left-color: #eceff1\n}\n\n.apexcharts-yaxistooltip-left:before {\n  border-left-color: #90a4ae\n}\n\n.apexcharts-yaxistooltip-left.apexcharts-theme-dark:after,\n.apexcharts-yaxistooltip-left.apexcharts-theme-dark:before {\n  border-left-color: rgba(0, 0, 0, .5)\n}\n\n.apexcharts-yaxistooltip-right:after {\n  border-right-color: #eceff1\n}\n\n.apexcharts-yaxistooltip-right:before {\n  border-right-color: #90a4ae\n}\n\n.apexcharts-yaxistooltip-right.apexcharts-theme-dark:after,\n.apexcharts-yaxistooltip-right.apexcharts-theme-dark:before {\n  border-right-color: rgba(0, 0, 0, .5)\n}\n\n.apexcharts-yaxistooltip.apexcharts-active {\n  opacity: 1\n}\n\n.apexcharts-yaxistooltip-hidden {\n  display: none\n}\n\n.apexcharts-xcrosshairs,\n.apexcharts-ycrosshairs {\n  pointer-events: none;\n  opacity: 0;\n  transition: .15s ease all\n}\n\n.apexcharts-xcrosshairs.apexcharts-active,\n.apexcharts-ycrosshairs.apexcharts-active {\n  opacity: 1;\n  transition: .15s ease all\n}\n\n.apexcharts-ycrosshairs-hidden {\n  opacity: 0\n}\n\n.apexcharts-selection-rect {\n  cursor: move\n}\n\n.svg_select_boundingRect,\n.svg_select_points_rot {\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden\n}\n\n.apexcharts-selection-rect+g .svg_select_boundingRect,\n.apexcharts-selection-rect+g .svg_select_points_rot {\n  opacity: 0;\n  visibility: hidden\n}\n\n.apexcharts-selection-rect+g .svg_select_points_l,\n.apexcharts-selection-rect+g .svg_select_points_r {\n  cursor: ew-resize;\n  opacity: 1;\n  visibility: visible\n}\n\n.svg_select_points {\n  fill: #efefef;\n  stroke: #333;\n  rx: 2\n}\n\n.apexcharts-svg.apexcharts-zoomable.hovering-zoom {\n  cursor: crosshair\n}\n\n.apexcharts-svg.apexcharts-zoomable.hovering-pan {\n  cursor: move\n}\n\n.apexcharts-menu-icon,\n.apexcharts-pan-icon,\n.apexcharts-reset-icon,\n.apexcharts-selection-icon,\n.apexcharts-toolbar-custom-icon,\n.apexcharts-zoom-icon,\n.apexcharts-zoomin-icon,\n.apexcharts-zoomout-icon {\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  line-height: 24px;\n  color: #6e8192;\n  text-align: center\n}\n\n.apexcharts-menu-icon svg,\n.apexcharts-reset-icon svg,\n.apexcharts-zoom-icon svg,\n.apexcharts-zoomin-icon svg,\n.apexcharts-zoomout-icon svg {\n  fill: #6e8192\n}\n\n.apexcharts-selection-icon svg {\n  fill: #444;\n  transform: scale(.76)\n}\n\n.apexcharts-theme-dark .apexcharts-menu-icon svg,\n.apexcharts-theme-dark .apexcharts-pan-icon svg,\n.apexcharts-theme-dark .apexcharts-reset-icon svg,\n.apexcharts-theme-dark .apexcharts-selection-icon svg,\n.apexcharts-theme-dark .apexcharts-toolbar-custom-icon svg,\n.apexcharts-theme-dark .apexcharts-zoom-icon svg,\n.apexcharts-theme-dark .apexcharts-zoomin-icon svg,\n.apexcharts-theme-dark .apexcharts-zoomout-icon svg {\n  fill: #f3f4f5\n}\n\n.apexcharts-canvas .apexcharts-reset-zoom-icon.apexcharts-selected svg,\n.apexcharts-canvas .apexcharts-selection-icon.apexcharts-selected svg,\n.apexcharts-canvas .apexcharts-zoom-icon.apexcharts-selected svg {\n  fill: #008ffb\n}\n\n.apexcharts-theme-light .apexcharts-menu-icon:hover svg,\n.apexcharts-theme-light .apexcharts-reset-icon:hover svg,\n.apexcharts-theme-light .apexcharts-selection-icon:not(.apexcharts-selected):hover svg,\n.apexcharts-theme-light .apexcharts-zoom-icon:not(.apexcharts-selected):hover svg,\n.apexcharts-theme-light .apexcharts-zoomin-icon:hover svg,\n.apexcharts-theme-light .apexcharts-zoomout-icon:hover svg {\n  fill: #333\n}\n\n.apexcharts-menu-icon,\n.apexcharts-selection-icon {\n  position: relative\n}\n\n.apexcharts-reset-icon {\n  margin-left: 5px\n}\n\n.apexcharts-menu-icon,\n.apexcharts-reset-icon,\n.apexcharts-zoom-icon {\n  transform: scale(.85)\n}\n\n.apexcharts-zoomin-icon,\n.apexcharts-zoomout-icon {\n  transform: scale(.7)\n}\n\n.apexcharts-zoomout-icon {\n  margin-right: 3px\n}\n\n.apexcharts-pan-icon {\n  transform: scale(.62);\n  position: relative;\n  left: 1px;\n  top: 0\n}\n\n.apexcharts-pan-icon svg {\n  fill: #fff;\n  stroke: #6e8192;\n  stroke-width: 2\n}\n\n.apexcharts-pan-icon.apexcharts-selected svg {\n  stroke: #008ffb\n}\n\n.apexcharts-pan-icon:not(.apexcharts-selected):hover svg {\n  stroke: #333\n}\n\n.apexcharts-toolbar {\n  position: absolute;\n  z-index: 11;\n  max-width: 176px;\n  text-align: right;\n  border-radius: 3px;\n  padding: 0 6px 2px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center\n}\n\n.apexcharts-menu {\n  background: #fff;\n  position: absolute;\n  top: 100%;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 3px;\n  right: 10px;\n  opacity: 0;\n  min-width: 110px;\n  transition: .15s ease all;\n  pointer-events: none\n}\n\n.apexcharts-menu.apexcharts-menu-open {\n  opacity: 1;\n  pointer-events: all;\n  transition: .15s ease all\n}\n\n.apexcharts-menu-item {\n  padding: 6px 7px;\n  font-size: 12px;\n  cursor: pointer\n}\n\n.apexcharts-theme-light .apexcharts-menu-item:hover {\n  background: #eee\n}\n\n.apexcharts-theme-dark .apexcharts-menu {\n  background: rgba(0, 0, 0, .7);\n  color: #fff\n}\n\n@media screen and (min-width:768px) {\n  .apexcharts-canvas:hover .apexcharts-toolbar {\n    opacity: 1\n  }\n}\n\n.apexcharts-canvas .apexcharts-element-hidden,\n.apexcharts-datalabel.apexcharts-element-hidden,\n.apexcharts-hide .apexcharts-series-points {\n  opacity: 0;\n}\n\n.apexcharts-hidden-element-shown {\n  opacity: 1;\n  transition: 0.25s ease all;\n}\n\n.apexcharts-datalabel,\n.apexcharts-datalabel-label,\n.apexcharts-datalabel-value,\n.apexcharts-datalabels,\n.apexcharts-pie-label {\n  cursor: default;\n  pointer-events: none\n}\n\n.apexcharts-pie-label-delay {\n  opacity: 0;\n  animation-name: opaque;\n  animation-duration: .3s;\n  animation-fill-mode: forwards;\n  animation-timing-function: ease\n}\n\n.apexcharts-radialbar-label {\n  cursor: pointer;\n}\n\n.apexcharts-annotation-rect,\n.apexcharts-area-series .apexcharts-area,\n.apexcharts-area-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,\n.apexcharts-gridline,\n.apexcharts-line,\n.apexcharts-line-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,\n.apexcharts-point-annotation-label,\n.apexcharts-radar-series path:not(.apexcharts-marker),\n.apexcharts-radar-series polygon,\n.apexcharts-toolbar svg,\n.apexcharts-tooltip .apexcharts-marker,\n.apexcharts-xaxis-annotation-label,\n.apexcharts-yaxis-annotation-label,\n.apexcharts-zoom-rect {\n  pointer-events: none\n}\n\n.apexcharts-tooltip-active .apexcharts-marker {\n  transition: .15s ease all\n}\n\n.resize-triggers {\n  animation: 1ms resizeanim;\n  visibility: hidden;\n  opacity: 0;\n  height: 100%;\n  width: 100%;\n  overflow: hidden\n}\n\n.contract-trigger:before,\n.resize-triggers,\n.resize-triggers>div {\n  content: " ";\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0\n}\n\n.resize-triggers>div {\n  height: 100%;\n  width: 100%;\n  background: #eee;\n  overflow: auto\n}\n\n.contract-trigger:before {\n  overflow: hidden;\n  width: 200%;\n  height: 200%\n}\n\n.apexcharts-bar-goals-markers {\n  pointer-events: none\n}\n\n.apexcharts-bar-shadows {\n  pointer-events: none\n}\n\n.apexcharts-rangebar-goals-markers {\n  pointer-events: none\n}\n';var h=(null===(l=t.opts.chart)||void 0===l?void 0:l.nonce)||t.w.config.chart.nonce;h&&n.setAttribute("nonce",h),r?s.prepend(n):o.head.appendChild(n)}var c=t.create(t.w.config.series,{});if(!c)return e(t);t.mount(c).then((function(){"function"==typeof t.w.config.chart.events.mounted&&t.w.config.chart.events.mounted(t,t.w),t.events.fireEvent("mounted",[t,t.w]),e(c)})).catch((function(t){i(t)}))}else i(new Error("Element not found"))}))}},{key:"create",value:function(t,e){var i=this,a=this.w;new qt(this).initModules();var s=this.w.globals;(s.noData=!1,s.animationEnded=!1,this.responsive.checkResponsiveConfig(e),a.config.xaxis.convertedCatToNumeric)&&new F(a.config).convertCatToNumericXaxis(a.config,this.ctx);if(null===this.el)return s.animationEnded=!0,null;if(this.core.setupElements(),"treemap"===a.config.chart.type&&(a.config.grid.show=!1,a.config.yaxis[0].show=!1),0===s.svgWidth)return s.animationEnded=!0,null;var r=t;t.forEach((function(t,e){t.hidden&&(r=i.legend.legendHelpers.getSeriesAfterCollapsing({realIndex:e}))}));var o=A.checkComboSeries(r,a.config.chart.type);s.comboCharts=o.comboCharts,s.comboBarCount=o.comboBarCount;var n=r.every((function(t){return t.data&&0===t.data.length}));(0===r.length||n&&s.collapsedSeries.length<1)&&this.series.handleNoData(),this.events.setupEventHandlers(),this.data.parseData(r),this.theme.init(),new W(this).setGlobalMarkerSize(),this.formatters.setLabelFormatters(),this.titleSubtitle.draw(),s.noData&&s.collapsedSeries.length!==s.series.length&&!a.config.legend.showForSingleSeries||this.legend.init(),this.series.hasAllSeriesEqualX(),s.axisCharts&&(this.core.coreCalculations(),"category"!==a.config.xaxis.type&&this.formatters.setLabelFormatters(),this.ctx.toolbar.minX=a.globals.minX,this.ctx.toolbar.maxX=a.globals.maxX),this.formatters.heatmapLabelFormatters(),new A(this).getLargestMarkerSize(),this.dimensions.plotCoords();var l=this.core.xySettings();this.grid.createGridMask();var h=this.core.plotChartType(r,l),c=new G(this);return c.bringForward(),a.config.dataLabels.background.enabled&&c.dataLabelsBackground(),this.core.shiftGraphPosition(),{elGraph:h,xyRatios:l,dimensions:{plot:{left:a.globals.translateX,top:a.globals.translateY,width:a.globals.gridWidth,height:a.globals.gridHeight}}}}},{key:"mount",value:function(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,i=this,a=i.w;return new Promise((function(s,r){if(null===i.el)return r(new Error("Not enough data to display or target element not found"));(null===e||a.globals.allSeriesCollapsed)&&i.series.handleNoData(),i.grid=new Z(i);var o,n,l=i.grid.drawGrid();(i.annotations=new E(i),i.annotations.drawImageAnnos(),i.annotations.drawTextAnnos(),"back"===a.config.grid.position)&&(l&&a.globals.dom.elGraphical.add(l.el),null!=l&&null!==(o=l.elGridBorders)&&void 0!==o&&o.node&&a.globals.dom.elGraphical.add(l.elGridBorders));if(Array.isArray(e.elGraph))for(var h=0;h<e.elGraph.length;h++)a.globals.dom.elGraphical.add(e.elGraph[h]);else a.globals.dom.elGraphical.add(e.elGraph);"front"===a.config.grid.position&&(l&&a.globals.dom.elGraphical.add(l.el),null!=l&&null!==(n=l.elGridBorders)&&void 0!==n&&n.node&&a.globals.dom.elGraphical.add(l.elGridBorders));"front"===a.config.xaxis.crosshairs.position&&i.crosshairs.drawXCrosshairs(),"front"===a.config.yaxis[0].crosshairs.position&&i.crosshairs.drawYCrosshairs(),"treemap"!==a.config.chart.type&&i.axes.drawAxis(a.config.chart.type,l);var c=new q(t.ctx,l),d=new Q(t.ctx,l);if(null!==l&&(c.xAxisLabelCorrections(l.xAxisTickWidth),d.setYAxisTextAlignments(),a.config.yaxis.map((function(t,e){-1===a.globals.ignoreYAxisIndexes.indexOf(e)&&d.yAxisTitleRotate(e,t.opposite)}))),i.annotations.drawAxesAnnotations(),!a.globals.noData){if(a.config.tooltip.enabled&&!a.globals.noData&&i.w.globals.tooltip.drawTooltip(e.xyRatios),a.globals.axisCharts&&(a.globals.isXNumeric||a.config.xaxis.convertedCatToNumeric||a.globals.isRangeBar))(a.config.chart.zoom.enabled||a.config.chart.selection&&a.config.chart.selection.enabled||a.config.chart.pan&&a.config.chart.pan.enabled)&&i.zoomPanSelection.init({xyRatios:e.xyRatios});else{var g=a.config.chart.toolbar.tools;["zoom","zoomin","zoomout","selection","pan","reset"].forEach((function(t){g[t]=!1}))}a.config.chart.toolbar.show&&!a.globals.allSeriesCollapsed&&i.toolbar.createToolbar()}a.globals.memory.methodsToExec.length>0&&a.globals.memory.methodsToExec.forEach((function(t){t.method(t.params,!1,t.context)})),a.globals.axisCharts||a.globals.noData||i.core.resizeNonAxisCharts(),s(i)}))}},{key:"destroy",value:function(){var t,e;window.removeEventListener("resize",this.windowResizeHandler),this.el.parentNode,t=this.parentResizeHandler,(e=$t.get(t))&&(e.disconnect(),$t.delete(t));var i=this.w.config.chart.id;i&&Apex._chartInstances.forEach((function(t,e){t.id===m.escapeString(i)&&Apex._chartInstances.splice(e,1)})),new Zt(this.ctx).clear({isUpdating:!1})}},{key:"updateOptions",value:function(t){var e=this,i=arguments.length>1&&void 0!==arguments[1]&&arguments[1],a=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],s=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],r=!(arguments.length>4&&void 0!==arguments[4])||arguments[4],o=this.w;return o.globals.selection=void 0,t.series&&(this.series.resetSeries(!1,!0,!1),t.series.length&&t.series[0].data&&(t.series=t.series.map((function(t,i){return e.updateHelpers._extendSeries(t,i)}))),this.updateHelpers.revertDefaultAxisMinMax()),t.xaxis&&(t=this.updateHelpers.forceXAxisUpdate(t)),t.yaxis&&(t=this.updateHelpers.forceYAxisUpdate(t)),o.globals.collapsedSeriesIndices.length>0&&this.series.clearPreviousPaths(),t.theme&&(t=this.theme.updateThemeOptions(t)),this.updateHelpers._updateOptions(t,i,a,s,r)}},{key:"updateSeries",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=!(arguments.length>2&&void 0!==arguments[2])||arguments[2];return this.series.resetSeries(!1),this.updateHelpers.revertDefaultAxisMinMax(),this.updateHelpers._updateSeries(t,e,i)}},{key:"appendSeries",value:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],a=this.w.config.series.slice();return a.push(t),this.series.resetSeries(!1),this.updateHelpers.revertDefaultAxisMinMax(),this.updateHelpers._updateSeries(a,e,i)}},{key:"appendData",value:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=this;i.w.globals.dataChanged=!0,i.series.getPreviousPaths();for(var a=i.w.config.series.slice(),s=0;s<a.length;s++)if(null!==t[s]&&void 0!==t[s])for(var r=0;r<t[s].data.length;r++)a[s].data.push(t[s].data[r]);return i.w.config.series=a,e&&(i.w.globals.initialSeries=m.clone(i.w.config.series)),this.update()}},{key:"update",value:function(t){var e=this;return new Promise((function(i,a){new Zt(e.ctx).clear({isUpdating:!0});var s=e.create(e.w.config.series,t);if(!s)return i(e);e.mount(s).then((function(){"function"==typeof e.w.config.chart.events.updated&&e.w.config.chart.events.updated(e,e.w),e.events.fireEvent("updated",[e,e.w]),e.w.globals.isDirty=!0,i(e)})).catch((function(t){a(t)}))}))}},{key:"getSyncedCharts",value:function(){var t=this.getGroupedCharts(),e=[this];return t.length&&(e=[],t.forEach((function(t){e.push(t)}))),e}},{key:"getGroupedCharts",value:function(){var t=this;return Apex._chartInstances.filter((function(t){if(t.group)return!0})).map((function(e){return t.w.config.chart.group===e.group?e.chart:t}))}},{key:"toggleSeries",value:function(t){return this.series.toggleSeries(t)}},{key:"highlightSeriesOnLegendHover",value:function(t,e){return this.series.toggleSeriesOnHover(t,e)}},{key:"showSeries",value:function(t){this.series.showSeries(t)}},{key:"hideSeries",value:function(t){this.series.hideSeries(t)}},{key:"highlightSeries",value:function(t){this.series.highlightSeries(t)}},{key:"isSeriesHidden",value:function(t){this.series.isSeriesHidden(t)}},{key:"resetSeries",value:function(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0],e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];this.series.resetSeries(t,e)}},{key:"addEventListener",value:function(t,e){this.events.addEventListener(t,e)}},{key:"removeEventListener",value:function(t,e){this.events.removeEventListener(t,e)}},{key:"addXaxisAnnotation",value:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0,a=this;i&&(a=i),a.annotations.addXaxisAnnotationExternal(t,e,a)}},{key:"addYaxisAnnotation",value:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0,a=this;i&&(a=i),a.annotations.addYaxisAnnotationExternal(t,e,a)}},{key:"addPointAnnotation",value:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0,a=this;i&&(a=i),a.annotations.addPointAnnotationExternal(t,e,a)}},{key:"clearAnnotations",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:void 0,e=this;t&&(e=t),e.annotations.clearAnnotations(e)}},{key:"removeAnnotation",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:void 0,i=this;e&&(i=e),i.annotations.removeAnnotation(i,t)}},{key:"getChartArea",value:function(){return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner")}},{key:"getSeriesTotalXRange",value:function(t,e){return this.coreUtils.getSeriesTotalsXRange(t,e)}},{key:"getHighestValueInSeries",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;return new J(this.ctx).getMinYMaxY(t).highestY}},{key:"getLowestValueInSeries",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;return new J(this.ctx).getMinYMaxY(t).lowestY}},{key:"getSeriesTotal",value:function(){return this.w.globals.seriesTotals}},{key:"toggleDataPointSelection",value:function(t,e){return this.updateHelpers.toggleDataPointSelection(t,e)}},{key:"zoomX",value:function(t,e){this.ctx.toolbar.zoomUpdateOptions(t,e)}},{key:"setLocale",value:function(t){this.localization.setCurrentLocaleValues(t)}},{key:"dataURI",value:function(t){return new U(this.ctx).dataURI(t)}},{key:"exportToCSV",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return new U(this.ctx).exportToCSV(t)}},{key:"paper",value:function(){return this.w.globals.dom.Paper}},{key:"_parentResizeCallback",value:function(){this.w.globals.animationEnded&&this.w.config.chart.redrawOnParentResize&&this._windowResize()}},{key:"_windowResize",value:function(){var t=this;clearTimeout(this.w.globals.resizeTimer),this.w.globals.resizeTimer=window.setTimeout((function(){t.w.globals.resized=!0,t.w.globals.dataChanged=!1,t.ctx.update()}),150)}},{key:"_windowResizeHandler",value:function(){var t=this.w.config.chart.redrawOnWindowResize;"function"==typeof t&&(t=t()),t&&this._windowResize()}}],[{key:"getChartByID",value:function(t){var e=m.escapeString(t);if(Apex._chartInstances){var i=Apex._chartInstances.filter((function(t){return t.id===e}))[0];return i&&i.chart}}},{key:"initOnLoad",value:function(){for(var e=document.querySelectorAll("[data-apexcharts]"),i=0;i<e.length;i++){new t(e[i],JSON.parse(e[i].getAttribute("data-options"))).render()}}},{key:"exec",value:function(t,e){var i=this.getChartByID(t);if(i){i.w.globals.isExecCalled=!0;var a=null;if(-1!==i.publicMethods.indexOf(e)){for(var s=arguments.length,r=new Array(s>2?s-2:0),o=2;o<s;o++)r[o-2]=arguments[o];a=i[e].apply(i,r)}return a}}},{key:"merge",value:function(t,e){return m.extend(t,e)}}]),t}();return Jt}));

/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.html2canvas = factory());
}(this, (function () { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }

    var Bounds = /** @class */ (function () {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function (x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function (context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function (context, domRectList) {
            var domRect = Array.from(domRectList).find(function (rect) { return rect.width !== 0; });
            return domRect
                ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height)
                : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }());
    var parseBounds = function (context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function (document) {
        var body = document.body;
        var documentElement = document.documentElement;
        if (!body || !documentElement) {
            throw new Error("Unable to get document size");
        }
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };

    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var toCodePoints$1 = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint$1 = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$2 = 0; i$2 < chars$2.length; i$2++) {
        lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    }

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++) {
        lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    }
    var decode$1 = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1$1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function (base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16$1(view16, (headerLength + view32[4]) / 2)
            : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2$1) & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$3 = 0; i$3 < chars$3.length; i$3++) {
        lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    }

    var base64$1 = 'KwAAAAAAAAAACA4AUD0AADAgAAACAAAAAAAIABAAGABAAEgAUABYAGAAaABgAGgAYgBqAF8AZwBgAGgAcQB5AHUAfQCFAI0AlQCdAKIAqgCyALoAYABoAGAAaABgAGgAwgDKAGAAaADGAM4A0wDbAOEA6QDxAPkAAQEJAQ8BFwF1AH0AHAEkASwBNAE6AUIBQQFJAVEBWQFhAWgBcAF4ATAAgAGGAY4BlQGXAZ8BpwGvAbUBvQHFAc0B0wHbAeMB6wHxAfkBAQIJAvEBEQIZAiECKQIxAjgCQAJGAk4CVgJeAmQCbAJ0AnwCgQKJApECmQKgAqgCsAK4ArwCxAIwAMwC0wLbAjAA4wLrAvMC+AIAAwcDDwMwABcDHQMlAy0DNQN1AD0DQQNJA0kDSQNRA1EDVwNZA1kDdQB1AGEDdQBpA20DdQN1AHsDdQCBA4kDkQN1AHUAmQOhA3UAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AKYDrgN1AHUAtgO+A8YDzgPWAxcD3gPjA+sD8wN1AHUA+wMDBAkEdQANBBUEHQQlBCoEFwMyBDgEYABABBcDSARQBFgEYARoBDAAcAQzAXgEgASIBJAEdQCXBHUAnwSnBK4EtgS6BMIEyAR1AHUAdQB1AHUAdQCVANAEYABgAGAAYABgAGAAYABgANgEYADcBOQEYADsBPQE/AQEBQwFFAUcBSQFLAU0BWQEPAVEBUsFUwVbBWAAYgVgAGoFcgV6BYIFigWRBWAAmQWfBaYFYABgAGAAYABgAKoFYACxBbAFuQW6BcEFwQXHBcEFwQXPBdMF2wXjBeoF8gX6BQIGCgYSBhoGIgYqBjIGOgZgAD4GRgZMBmAAUwZaBmAAYABgAGAAYABgAGAAYABgAGAAYABgAGIGYABpBnAGYABgAGAAYABgAGAAYABgAGAAYAB4Bn8GhQZgAGAAYAB1AHcDFQSLBmAAYABgAJMGdQA9A3UAmwajBqsGqwaVALMGuwbDBjAAywbSBtIG1QbSBtIG0gbSBtIG0gbdBuMG6wbzBvsGAwcLBxMHAwcbByMHJwcsBywHMQcsB9IGOAdAB0gHTgfSBkgHVgfSBtIG0gbSBtIG0gbSBtIG0gbSBiwHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAdgAGAALAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAdbB2MHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsB2kH0gZwB64EdQB1AHUAdQB1AHUAdQB1AHUHfQdgAIUHjQd1AHUAlQedB2AAYAClB6sHYACzB7YHvgfGB3UAzgfWBzMB3gfmB1EB7gf1B/0HlQENAQUIDQh1ABUIHQglCBcDLQg1CD0IRQhNCEEDUwh1AHUAdQBbCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIaQhjCGQIZQhmCGcIaAhpCGMIZAhlCGYIZwhoCGkIYwhkCGUIZghnCGgIcAh3CHoIMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIgggwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAALAcsBywHLAcsBywHLAcsBywHLAcsB4oILAcsB44I0gaWCJ4Ipgh1AHUAqgiyCHUAdQB1AHUAdQB1AHUAdQB1AHUAtwh8AXUAvwh1AMUIyQjRCNkI4AjoCHUAdQB1AO4I9gj+CAYJDgkTCS0HGwkjCYIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiCCIIIggiAAIAAAAFAAYABgAGIAXwBgAHEAdQBFAJUAogCyAKAAYABgAEIA4ABGANMA4QDxAMEBDwE1AFwBLAE6AQEBUQF4QkhCmEKoQrhCgAHIQsAB0MLAAcABwAHAAeDC6ABoAHDCwMMAAcABwAHAAdDDGMMAAcAB6MM4wwjDWMNow3jDaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAEjDqABWw6bDqABpg6gAaABoAHcDvwOPA+gAaABfA/8DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DvwO/A78DpcPAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcAB9cPKwkyCToJMAB1AHUAdQBCCUoJTQl1AFUJXAljCWcJawkwADAAMAAwAHMJdQB2CX4JdQCECYoJjgmWCXUAngkwAGAAYABxAHUApgn3A64JtAl1ALkJdQDACTAAMAAwADAAdQB1AHUAdQB1AHUAdQB1AHUAowYNBMUIMAAwADAAMADICcsJ0wnZCRUE4QkwAOkJ8An4CTAAMAB1AAAKvwh1AAgKDwoXCh8KdQAwACcKLgp1ADYKqAmICT4KRgowADAAdQB1AE4KMAB1AFYKdQBeCnUAZQowADAAMAAwADAAMAAwADAAMAAVBHUAbQowADAAdQC5CXUKMAAwAHwBxAijBogEMgF9CoQKiASMCpQKmgqIBKIKqgquCogEDQG2Cr4KxgrLCjAAMADTCtsKCgHjCusK8Qr5CgELMAAwADAAMAB1AIsECQsRC3UANAEZCzAAMAAwADAAMAB1ACELKQswAHUANAExCzkLdQBBC0kLMABRC1kLMAAwADAAMAAwADAAdQBhCzAAMAAwAGAAYABpC3ELdwt/CzAAMACHC4sLkwubC58Lpwt1AK4Ltgt1APsDMAAwADAAMAAwADAAMAAwAL4LwwvLC9IL1wvdCzAAMADlC+kL8Qv5C/8LSQswADAAMAAwADAAMAAwADAAMAAHDDAAMAAwADAAMAAODBYMHgx1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1ACYMMAAwADAAdQB1AHUALgx1AHUAdQB1AHUAdQA2DDAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AD4MdQBGDHUAdQB1AHUAdQB1AEkMdQB1AHUAdQB1AFAMMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQBYDHUAdQB1AF8MMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUA+wMVBGcMMAAwAHwBbwx1AHcMfwyHDI8MMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAYABgAJcMMAAwADAAdQB1AJ8MlQClDDAAMACtDCwHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsB7UMLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHdQB1AHUAdQB1AHUAdQB1AHUAdQB1AHUAdQB1AA0EMAC9DDAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAsBywHLAcsBywHLAcsBywHLQcwAMEMyAwsBywHLAcsBywHLAcsBywHLAcsBywHzAwwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAHUAdQB1ANQM2QzhDDAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMABgAGAAYABgAGAAYABgAOkMYADxDGAA+AwADQYNYABhCWAAYAAODTAAMAAwADAAFg1gAGAAHg37AzAAMAAwADAAYABgACYNYAAsDTQNPA1gAEMNPg1LDWAAYABgAGAAYABgAGAAYABgAGAAUg1aDYsGVglhDV0NcQBnDW0NdQ15DWAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAlQCBDZUAiA2PDZcNMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAnw2nDTAAMAAwADAAMAAwAHUArw23DTAAMAAwADAAMAAwADAAMAAwADAAMAB1AL8NMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAB1AHUAdQB1AHUAdQDHDTAAYABgAM8NMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAA1w11ANwNMAAwAD0B5A0wADAAMAAwADAAMADsDfQN/A0EDgwOFA4wABsOMAAwADAAMAAwADAAMAAwANIG0gbSBtIG0gbSBtIG0gYjDigOwQUuDsEFMw7SBjoO0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGQg5KDlIOVg7SBtIGXg5lDm0OdQ7SBtIGfQ6EDooOjQ6UDtIGmg6hDtIG0gaoDqwO0ga0DrwO0gZgAGAAYADEDmAAYAAkBtIGzA5gANIOYADaDokO0gbSBt8O5w7SBu8O0gb1DvwO0gZgAGAAxA7SBtIG0gbSBtIGYABgAGAAYAAED2AAsAUMD9IG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGFA8sBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAccD9IGLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHJA8sBywHLAcsBywHLAccDywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywPLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAc0D9IG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAccD9IG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIGFA8sBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHLAcsBywHPA/SBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gbSBtIG0gYUD0QPlQCVAJUAMAAwADAAMACVAJUAlQCVAJUAlQCVAEwPMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAA//8EAAQABAAEAAQABAAEAAQABAANAAMAAQABAAIABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQACgATABcAHgAbABoAHgAXABYAEgAeABsAGAAPABgAHABLAEsASwBLAEsASwBLAEsASwBLABgAGAAeAB4AHgATAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQABYAGwASAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAWAA0AEQAeAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAFAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAJABYAGgAbABsAGwAeAB0AHQAeAE8AFwAeAA0AHgAeABoAGwBPAE8ADgBQAB0AHQAdAE8ATwAXAE8ATwBPABYAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAFAAUABQAFAAUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AHgAeAFAATwBAAE8ATwBPAEAATwBQAFAATwBQAB4AHgAeAB4AHgAeAB0AHQAdAB0AHgAdAB4ADgBQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgBQAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAJAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAkACQAJAAkACQAJAAkABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgAeAFAAHgAeAB4AKwArAFAAUABQAFAAGABQACsAKwArACsAHgAeAFAAHgBQAFAAUAArAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAUAAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAYAA0AKwArAB4AHgAbACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQADQAEAB4ABAAEAB4ABAAEABMABAArACsAKwArACsAKwArACsAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAKwArACsAKwBWAFYAVgBWAB4AHgArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AGgAaABoAGAAYAB4AHgAEAAQABAAEAAQABAAEAAQABAAEAAQAEwAEACsAEwATAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABLAEsASwBLAEsASwBLAEsASwBLABoAGQAZAB4AUABQAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQABMAUAAEAAQABAAEAAQABAAEAB4AHgAEAAQABAAEAAQABABQAFAABAAEAB4ABAAEAAQABABQAFAASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUAAeAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAFAABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQAUABQAB4AHgAYABMAUAArACsABAAbABsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAFAABAAEAAQABAAEAFAABAAEAAQAUAAEAAQABAAEAAQAKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAArACsAHgArAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAUAAEAAQABAAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAABAAEAA0ADQBLAEsASwBLAEsASwBLAEsASwBLAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAArAFAAUABQAFAAUABQAFAAUAArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUAArACsAKwBQAFAAUABQACsAKwAEAFAABAAEAAQABAAEAAQABAArACsABAAEACsAKwAEAAQABABQACsAKwArACsAKwArACsAKwAEACsAKwArACsAUABQACsAUABQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAFAAUAAaABoAUABQAFAAUABQAEwAHgAbAFAAHgAEACsAKwAEAAQABAArAFAAUABQAFAAUABQACsAKwArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQACsAUABQACsAKwAEACsABAAEAAQABAAEACsAKwArACsABAAEACsAKwAEAAQABAArACsAKwAEACsAKwArACsAKwArACsAUABQAFAAUAArAFAAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLAAQABABQAFAAUAAEAB4AKwArACsAKwArACsAKwArACsAKwAEAAQABAArAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQAFAAUABQACsAKwAEAFAABAAEAAQABAAEAAQABAAEACsABAAEAAQAKwAEAAQABAArACsAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAB4AGwArACsAKwArACsAKwArAFAABAAEAAQABAAEAAQAKwAEAAQABAArAFAAUABQAFAAUABQAFAAUAArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAArACsABAAEACsAKwAEAAQABAArACsAKwArACsAKwArAAQABAAEACsAKwArACsAUABQACsAUABQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAB4AUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArAAQAUAArAFAAUABQAFAAUABQACsAKwArAFAAUABQACsAUABQAFAAUAArACsAKwBQAFAAKwBQACsAUABQACsAKwArAFAAUAArACsAKwBQAFAAUAArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArAAQABAAEAAQABAArACsAKwAEAAQABAArAAQABAAEAAQAKwArAFAAKwArACsAKwArACsABAArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAHgAeAB4AHgAeAB4AGwAeACsAKwArACsAKwAEAAQABAAEAAQAUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAUAAEAAQABAAEAAQABAAEACsABAAEAAQAKwAEAAQABAAEACsAKwArACsAKwArACsABAAEACsAUABQAFAAKwArACsAKwArAFAAUAAEAAQAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAKwAOAFAAUABQAFAAUABQAFAAHgBQAAQABAAEAA4AUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAKwArAAQAUAAEAAQABAAEAAQABAAEACsABAAEAAQAKwAEAAQABAAEACsAKwArACsAKwArACsABAAEACsAKwArACsAKwArACsAUAArAFAAUAAEAAQAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwBQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAFAABAAEAAQABAAEAAQABAArAAQABAAEACsABAAEAAQABABQAB4AKwArACsAKwBQAFAAUAAEAFAAUABQAFAAUABQAFAAUABQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAFAAUABQAFAAUABQAFAAUABQABoAUABQAFAAUABQAFAAKwAEAAQABAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQACsAUAArACsAUABQAFAAUABQAFAAUAArACsAKwAEACsAKwArACsABAAEAAQABAAEAAQAKwAEACsABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArAAQABAAeACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAAqAFwAXAAqACoAKgAqACoAKgAqACsAKwArACsAGwBcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAeAEsASwBLAEsASwBLAEsASwBLAEsADQANACsAKwArACsAKwBcAFwAKwBcACsAXABcAFwAXABcACsAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACsAXAArAFwAXABcAFwAXABcAFwAXABcAFwAKgBcAFwAKgAqACoAKgAqACoAKgAqACoAXAArACsAXABcAFwAXABcACsAXAArACoAKgAqACoAKgAqACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwBcAFwAXABcAFAADgAOAA4ADgAeAA4ADgAJAA4ADgANAAkAEwATABMAEwATAAkAHgATAB4AHgAeAAQABAAeAB4AHgAeAB4AHgBLAEsASwBLAEsASwBLAEsASwBLAFAAUABQAFAAUABQAFAAUABQAFAADQAEAB4ABAAeAAQAFgARABYAEQAEAAQAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQADQAEAAQABAAEAAQADQAEAAQAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArAA0ADQAeAB4AHgAeAB4AHgAEAB4AHgAeAB4AHgAeACsAHgAeAA4ADgANAA4AHgAeAB4AHgAeAAkACQArACsAKwArACsAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgBcAEsASwBLAEsASwBLAEsASwBLAEsADQANAB4AHgAeAB4AXABcAFwAXABcAFwAKgAqACoAKgBcAFwAXABcACoAKgAqAFwAKgAqACoAXABcACoAKgAqACoAKgAqACoAXABcAFwAKgAqACoAKgBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAqACoAKgAqAFwAKgBLAEsASwBLAEsASwBLAEsASwBLACoAKgAqACoAKgAqAFAAUABQAFAAUABQACsAUAArACsAKwArACsAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgBQAFAAUABQAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUAArACsAUABQAFAAUABQAFAAUAArAFAAKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAKwBQACsAUABQAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsABAAEAAQAHgANAB4AHgAeAB4AHgAeAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUAArACsADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAANAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAWABEAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAA0ADQANAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAANAA0AKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUAArAAQABAArACsAKwArACsAKwArACsAKwArACsAKwBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqAA0ADQAVAFwADQAeAA0AGwBcACoAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwAeAB4AEwATAA0ADQAOAB4AEwATAB4ABAAEAAQACQArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUAAEAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAHgArACsAKwATABMASwBLAEsASwBLAEsASwBLAEsASwBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAArACsAXABcAFwAXABcACsAKwArACsAKwArACsAKwArACsAKwBcAFwAXABcAFwAXABcAFwAXABcAFwAXAArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAXAArACsAKwAqACoAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAArACsAHgAeAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAqACoAKwAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKwArAAQASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArACoAKgAqACoAKgAqACoAXAAqACoAKgAqACoAKgArACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABABQAFAAUABQAFAAUABQACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwANAA0AHgANAA0ADQANAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAEAAQAHgAeAB4AHgAeAB4AHgAeAB4AKwArACsABAAEAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwAeAB4AHgAeAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArAA0ADQANAA0ADQBLAEsASwBLAEsASwBLAEsASwBLACsAKwArAFAAUABQAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAA0ADQBQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUAAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArAAQABAAEAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAAQAUABQAFAAUABQAFAABABQAFAABAAEAAQAUAArACsAKwArACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsABAAEAAQABAAEAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAKwBQACsAUAArAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAB4AHgAeAB4AHgAeAB4AHgBQAB4AHgAeAFAAUABQACsAHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQACsAKwAeAB4AHgAeAB4AHgArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAFAAUABQACsAHgAeAB4AHgAeAB4AHgAOAB4AKwANAA0ADQANAA0ADQANAAkADQANAA0ACAAEAAsABAAEAA0ACQANAA0ADAAdAB0AHgAXABcAFgAXABcAFwAWABcAHQAdAB4AHgAUABQAFAANAAEAAQAEAAQABAAEAAQACQAaABoAGgAaABoAGgAaABoAHgAXABcAHQAVABUAHgAeAB4AHgAeAB4AGAAWABEAFQAVABUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ADQAeAA0ADQANAA0AHgANAA0ADQAHAB4AHgAeAB4AKwAEAAQABAAEAAQABAAEAAQABAAEAFAAUAArACsATwBQAFAAUABQAFAAHgAeAB4AFgARAE8AUABPAE8ATwBPAFAAUABQAFAAUAAeAB4AHgAWABEAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArABsAGwAbABsAGwAbABsAGgAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGgAbABsAGwAbABoAGwAbABoAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAHgAeAFAAGgAeAB0AHgBQAB4AGgAeAB4AHgAeAB4AHgAeAB4AHgBPAB4AUAAbAB4AHgBQAFAAUABQAFAAHgAeAB4AHQAdAB4AUAAeAFAAHgBQAB4AUABPAFAAUAAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAHgBQAFAAUABQAE8ATwBQAFAAUABQAFAATwBQAFAATwBQAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAFAAUABQAFAATwBPAE8ATwBPAE8ATwBPAE8ATwBQAFAAUABQAFAAUABQAFAAUAAeAB4AUABQAFAAUABPAB4AHgArACsAKwArAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHQAdAB4AHgAeAB0AHQAeAB4AHQAeAB4AHgAdAB4AHQAbABsAHgAdAB4AHgAeAB4AHQAeAB4AHQAdAB0AHQAeAB4AHQAeAB0AHgAdAB0AHQAdAB0AHQAeAB0AHgAeAB4AHgAeAB0AHQAdAB0AHgAeAB4AHgAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHgAeAB0AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHgAeAB0AHQAdAB0AHgAeAB0AHQAeAB4AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHQAeAB4AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAeAB4AHgAdAB4AHgAeAB4AHgAeAB4AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABYAEQAWABEAHgAeAB4AHgAeAB4AHQAeAB4AHgAeAB4AHgAeACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAWABEAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAFAAHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB4AHgAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAeAB4AHQAdAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHQAeAB0AHQAdAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB0AHQAeAB4AHQAdAB4AHgAeAB4AHQAdAB4AHgAeAB4AHQAdAB0AHgAeAB0AHgAeAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlAB4AHQAdAB4AHgAdAB4AHgAeAB4AHQAdAB4AHgAeAB4AJQAlAB0AHQAlAB4AJQAlACUAIAAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAeAB4AHgAeAB0AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHgAdAB0AHQAeAB0AJQAdAB0AHgAdAB0AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAdAB0AHQAdACUAHgAlACUAJQAdACUAJQAdAB0AHQAlACUAHQAdACUAHQAdACUAJQAlAB4AHQAeAB4AHgAeAB0AHQAlAB0AHQAdAB0AHQAdACUAJQAlACUAJQAdACUAJQAgACUAHQAdACUAJQAlACUAJQAlACUAJQAeAB4AHgAlACUAIAAgACAAIAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AFwAXABcAFwAXABcAHgATABMAJQAeAB4AHgAWABEAFgARABYAEQAWABEAFgARABYAEQAWABEATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABYAEQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAWABEAFgARABYAEQAWABEAFgARAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFgARABYAEQAWABEAFgARABYAEQAWABEAFgARABYAEQAWABEAFgARABYAEQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAWABEAFgARAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFgARAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAEAAQABAAeAB4AKwArACsAKwArABMADQANAA0AUAATAA0AUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAUAANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAA0ADQANAA0ADQANAA0ADQAeAA0AFgANAB4AHgAXABcAHgAeABcAFwAWABEAFgARABYAEQAWABEADQANAA0ADQATAFAADQANAB4ADQANAB4AHgAeAB4AHgAMAAwADQANAA0AHgANAA0AFgANAA0ADQANAA0ADQANAA0AHgANAB4ADQANAB4AHgAeACsAKwArACsAKwArACsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAKwArACsAKwArACsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArAA0AEQARACUAJQBHAFcAVwAWABEAFgARABYAEQAWABEAFgARACUAJQAWABEAFgARABYAEQAWABEAFQAWABEAEQAlAFcAVwBXAFcAVwBXAFcAVwBXAAQABAAEAAQABAAEACUAVwBXAFcAVwA2ACUAJQBXAFcAVwBHAEcAJQAlACUAKwBRAFcAUQBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFEAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBRAFcAUQBXAFEAVwBXAFcAVwBXAFcAUQBXAFcAVwBXAFcAVwBRAFEAKwArAAQABAAVABUARwBHAFcAFQBRAFcAUQBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBRAFcAVwBXAFcAVwBXAFEAUQBXAFcAVwBXABUAUQBHAEcAVwArACsAKwArACsAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwAlACUAVwBXAFcAVwAlACUAJQAlACUAJQAlACUAJQAlACsAKwArACsAKwArACsAKwArACsAKwArAFEAUQBRAFEAUQBRAFEAUQBRAFEAUQBRAFEAUQBRAFEAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBPAE8ATwBPAE8ATwBPAE8AJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAEcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAADQATAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABLAEsASwBLAEsASwBLAEsASwBLAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAABAAEAAQABAAeAAQABAAEAAQABAAEAAQABAAEAAQAHgBQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUABQAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAeAA0ADQANAA0ADQArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAB4AHgAeAB4AHgAeAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AUABQAFAAUABQAFAAUABQAFAAUABQAAQAUABQAFAABABQAFAAUABQAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAeAB4AHgAeAAQAKwArACsAUABQAFAAUABQAFAAHgAeABoAHgArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAADgAOABMAEwArACsAKwArACsAKwArACsABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwANAA0ASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAFAAUAAeAB4AHgBQAA4AUABQAAQAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAA0ADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArAB4AWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYACsAKwArAAQAHgAeAB4AHgAeAB4ADQANAA0AHgAeAB4AHgArAFAASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArAB4AHgBcAFwAXABcAFwAKgBcAFwAXABcAFwAXABcAFwAXABcAEsASwBLAEsASwBLAEsASwBLAEsAXABcAFwAXABcACsAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArAFAAUABQAAQAUABQAFAAUABQAFAAUABQAAQABAArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAHgANAA0ADQBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAXAAqACoAKgBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAAqAFwAKgAqACoAXABcACoAKgBcAFwAXABcAFwAKgAqAFwAKgBcACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcACoAKgBQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAA0ADQBQAFAAUAAEAAQAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUAArACsAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQADQAEAAQAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAVABVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBUAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVACsAKwArACsAKwArACsAKwArACsAKwArAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAKwArACsAKwBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAKwArACsAKwAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAKwArACsAKwArAFYABABWAFYAVgBWAFYAVgBWAFYAVgBWAB4AVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgArAFYAVgBWAFYAVgArAFYAKwBWAFYAKwBWAFYAKwBWAFYAVgBWAFYAVgBWAFYAVgBWAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAEQAWAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUAAaAB4AKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAGAARABEAGAAYABMAEwAWABEAFAArACsAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACUAJQAlACUAJQAWABEAFgARABYAEQAWABEAFgARABYAEQAlACUAFgARACUAJQAlACUAJQAlACUAEQAlABEAKwAVABUAEwATACUAFgARABYAEQAWABEAJQAlACUAJQAlACUAJQAlACsAJQAbABoAJQArACsAKwArAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAcAKwATACUAJQAbABoAJQAlABYAEQAlACUAEQAlABEAJQBXAFcAVwBXAFcAVwBXAFcAVwBXABUAFQAlACUAJQATACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXABYAJQARACUAJQAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwAWACUAEQAlABYAEQARABYAEQARABUAVwBRAFEAUQBRAFEAUQBRAFEAUQBRAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAEcARwArACsAVwBXAFcAVwBXAFcAKwArAFcAVwBXAFcAVwBXACsAKwBXAFcAVwBXAFcAVwArACsAVwBXAFcAKwArACsAGgAbACUAJQAlABsAGwArAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwAEAAQABAAQAB0AKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsADQANAA0AKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAAQAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAA0AUABQAFAAUAArACsAKwArAFAAUABQAFAAUABQAFAAUAANAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwAeACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAKwArAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUAArACsAKwBQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwANAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAUABQAFAAUABQAAQABAAEACsABAAEACsAKwArACsAKwAEAAQABAAEAFAAUABQAFAAKwBQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEACsAKwArACsABABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAA0ADQANAA0ADQANAA0ADQAeACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAArACsAKwArAFAAUABQAFAAUAANAA0ADQANAA0ADQAUACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsADQANAA0ADQANAA0ADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAAQABAAEAAQAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUAArAAQABAANACsAKwBQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAB4AHgAeAB4AHgArACsAKwArACsAKwAEAAQABAAEAAQABAAEAA0ADQAeAB4AHgAeAB4AKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwAeACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsASwBLAEsASwBLAEsASwBLAEsASwANAA0ADQANAFAABAAEAFAAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAeAA4AUAArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAADQANAB4ADQAEAAQABAAEAB4ABAAEAEsASwBLAEsASwBLAEsASwBLAEsAUAAOAFAADQANAA0AKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAANAA0AHgANAA0AHgAEACsAUABQAFAAUABQAFAAUAArAFAAKwBQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAA0AKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsABAAEAAQABAArAFAAUABQAFAAUABQAFAAUAArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQAFAAUABQACsABAAEAFAABAAEAAQABAAEAAQABAArACsABAAEACsAKwAEAAQABAArACsAUAArACsAKwArACsAKwAEACsAKwArACsAKwBQAFAAUABQAFAABAAEACsAKwAEAAQABAAEAAQABAAEACsAKwArAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAAQABABQAFAAUABQAA0ADQANAA0AHgBLAEsASwBLAEsASwBLAEsASwBLAA0ADQArAB4ABABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAAQABAAEAFAAUAAeAFAAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAArACsABAAEAAQABAAEAAQABAAEAAQADgANAA0AEwATAB4AHgAeAA0ADQANAA0ADQANAA0ADQANAA0ADQANAA0ADQANAFAAUABQAFAABAAEACsAKwAEAA0ADQAeAFAAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAFAAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKwArACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBcAFwADQANAA0AKgBQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAKwArAFAAKwArAFAAUABQAFAAUABQAFAAUAArAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQAKwAEAAQAKwArAAQABAAEAAQAUAAEAFAABAAEAA0ADQANACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAArACsABAAEAAQABAAEAAQABABQAA4AUAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAFAABAAEAAQABAAOAB4ADQANAA0ADQAOAB4ABAArACsAKwArACsAKwArACsAUAAEAAQABAAEAAQABAAEAAQABAAEAAQAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAA0ADQANAFAADgAOAA4ADQANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEACsABAAEAAQABAAEAAQABAAEAFAADQANAA0ADQANACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwAOABMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAArACsAKwAEACsABAAEACsABAAEAAQABAAEAAQABABQAAQAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAKwBQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQAKwAEAAQAKwAEAAQABAAEAAQAUAArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAaABoAGgAaAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsADQANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAASABIAEgAQwBDAEMAUABQAFAAUABDAFAAUABQAEgAQwBIAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAASABDAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwAJAAkACQAJAAkACQAJABYAEQArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABIAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwANAA0AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEAAQABAANACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAA0ADQANAB4AHgAeAB4AHgAeAFAAUABQAFAADQAeACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAANAA0AHgAeACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwAEAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwAEAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAARwBHABUARwAJACsAKwArACsAKwArACsAKwArACsAKwAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACsAKwArACsAKwArACsAKwBXAFcAVwBXAFcAVwBXAFcAVwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUQBRAFEAKwArACsAKwArACsAKwArACsAKwArACsAKwBRAFEAUQBRACsAKwArACsAKwArACsAKwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUAArACsAHgAEAAQADQAEAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArAB4AHgAeAB4AHgAeAB4AKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAAQABAAEAAQABAAeAB4AHgAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAB4AHgAEAAQABAAEAAQABAAEAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQAHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwBQAFAAKwArAFAAKwArAFAAUAArACsAUABQAFAAUAArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAUAArAFAAUABQAFAAUABQAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAHgAeAFAAUABQAFAAUAArAFAAKwArACsAUABQAFAAUABQAFAAUAArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeACsAKwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgAeAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgAeAB4AHgAeAB4ABAAeAB4AHgAeAB4AHgAeAB4AHgAeAAQAHgAeAA0ADQANAA0AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAAQABAAEAAQAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAEAAQAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArAAQABAAEAAQABAAEAAQAKwAEAAQAKwAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwAEAAQABAAEAAQABAAEAFAAUABQAFAAUABQAFAAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwBQAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArABsAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArAB4AHgAeAB4ABAAEAAQABAAEAAQABABQACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArABYAFgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAGgBQAFAAUAAaAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAKwBQACsAKwBQACsAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAKwBQACsAUAArACsAKwArACsAKwBQACsAKwArACsAUAArAFAAKwBQACsAUABQAFAAKwBQAFAAKwBQACsAKwBQACsAUAArAFAAKwBQACsAUAArAFAAUAArAFAAKwArAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUAArAFAAUABQAFAAKwBQACsAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAUABQAFAAKwBQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8AJQAlACUAHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB4AHgAeACUAJQAlAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAJQAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAlACUAJQAlACUAHgAlACUAJQAlACUAIAAgACAAJQAlACAAJQAlACAAIAAgACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACEAIQAhACEAIQAlACUAIAAgACUAJQAgACAAIAAgACAAIAAgACAAIAAgACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAJQAlACUAIAAlACUAJQAlACAAIAAgACUAIAAgACAAJQAlACUAJQAlACUAJQAgACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAlAB4AJQAeACUAJQAlACUAJQAgACUAJQAlACUAHgAlAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAJQAlACUAJQAgACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACAAIAAgACUAJQAlACAAIAAgACAAIAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABcAFwAXABUAFQAVAB4AHgAeAB4AJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAgACUAJQAlACUAJQAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAgACUAJQAgACUAJQAlACUAJQAlACUAJQAgACAAIAAgACAAIAAgACAAJQAlACUAJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAgACAAIAAgACAAIAAgACAAIAAgACUAJQAgACAAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAgACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAlACAAIAAlACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAgACAAIAAlACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAJQAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAKwArAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwAlACUAJQAlACUAJQAlACUAJQAlACUAVwBXACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAKwAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAA==';

    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [0x2329, 0xff08];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = '×';
    var BREAK_ALLOWED$1 = '÷';
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [AL, HL];
    var HARD_LINE_BREAKS = [BK, CR$1, LF$1, NL];
    var SPACE$1 = [SP, ZW];
    var PREFIX_POSTFIX = [PR, PO];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
    var HYPHEN = [HY, BA];
    var codePointsToCharacterClasses = function (codePoints, lineBreak) {
        if (lineBreak === void 0) { lineBreak = 'strict'; }
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function (codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            }
            else {
                categories.push(false);
            }
            if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
                // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
                if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) {
                return types.push(lineBreak === 'strict' ? NS : ID);
            }
            if (classType === SA) {
                return types.push(AL);
            }
            if (classType === AI) {
                return types.push(AL);
            }
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if ((codePoint >= 0x20000 && codePoint <= 0x2fffd) || (codePoint >= 0x30000 && codePoint <= 0x3fffd)) {
                    return types.push(ID);
                }
                else {
                    return types.push(AL);
                }
            }
            types.push(classType);
        });
        return [indices, types, categories];
    };
    var isAdjacentWithSpaceIgnored = function (a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while (i <= classTypes.length) {
                i++;
                var next = classTypes[i];
                if (next === b) {
                    return true;
                }
                if (next !== SP) {
                    break;
                }
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while (i > 0) {
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while (n <= classTypes.length) {
                        n++;
                        var next = classTypes[n];
                        if (next === b) {
                            return true;
                        }
                        if (next !== SP) {
                            break;
                        }
                    }
                }
                if (prev !== SP) {
                    break;
                }
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function (currentIndex, classTypes) {
        var i = currentIndex;
        while (i >= 0) {
            var type = classTypes[i];
            if (type === SP) {
                i--;
            }
            else {
                return type;
            }
        }
        return 0;
    };
    var _lineBreakAtIndex = function (codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) {
            return BREAK_NOT_ALLOWED$1;
        }
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
            return BREAK_NOT_ALLOWED$1;
        }
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
            return BREAK_MANDATORY;
        }
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
            return BREAK_ALLOWED$1;
        }
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB18 Break after spaces.
        if (current === SP) {
            return BREAK_ALLOWED$1;
        }
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) {
            return BREAK_ALLOWED$1;
        }
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB22 Do not break before ellipsis.
        if (next === IN) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23 Do not break between digits and letters.
        if ((ALPHABETICS.indexOf(next) !== -1 && current === NU) || (ALPHABETICS.indexOf(current) !== -1 && next === NU)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if ((current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
            ([ID, EB, EM].indexOf(current) !== -1 && next === PO)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if ((ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1) ||
            (PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (
        // (PR | PO) × ( OP | HY )? NU
        ([PR, PO].indexOf(current) !== -1 &&
            (next === NU || ([OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU))) ||
            // ( OP | HY ) × NU
            ([OP, HY].indexOf(current) !== -1 && next === NU) ||
            // NU ×	(NU | SY | IS)
            (current === NU && [NU, SY, IS].indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([PR, PO].indexOf(next) !== -1) {
            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // LB26 Do not break a Korean syllable.
        if ((JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
            ([JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1) ||
            ([JT, H3].indexOf(current) !== -1 && next === JT)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB27 Treat a Korean Syllable Block the same as ID.
        if ((KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1) ||
            (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if ((ALPHABETICS.concat(NU).indexOf(current) !== -1 &&
            next === OP &&
            ea_OP.indexOf(codePoints[afterIndex]) === -1) ||
            (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while (i > 0) {
                i--;
                if (classTypes[i] === RI$1) {
                    count++;
                }
                else {
                    break;
                }
            }
            if (count % 2 !== 0) {
                return BREAK_NOT_ALLOWED$1;
            }
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) {
            return BREAK_NOT_ALLOWED$1;
        }
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function (codePoints, options) {
        if (!options) {
            options = { lineBreak: 'normal', wordBreak: 'normal' };
        }
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
            classTypes = classTypes.map(function (type) { return ([NU, AL, SA].indexOf(type) !== -1 ? ID : type); });
        }
        var forbiddenBreakpoints = options.wordBreak === 'keep-all'
            ? isLetterNumber.map(function (letterNumber, i) {
                return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
            })
            : undefined;
        return [indicies, classTypes, forbiddenBreakpoints];
    };
    var Break = /** @class */ (function () {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function () {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }());
    var LineBreaker = function (str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function () {
                if (nextIndex >= length) {
                    return { done: true, value: null };
                }
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while (nextIndex < length &&
                    (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) ===
                        BREAK_NOT_ALLOWED$1) { }
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };

    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1 << 0;
    var FLAG_ID = 1 << 1;
    var FLAG_INTEGER = 1 << 2;
    var FLAG_NUMBER = 1 << 3;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function (codePoint) { return codePoint >= ZERO && codePoint <= 0x0039; };
    var isSurrogateCodePoint = function (codePoint) { return codePoint >= 0xd800 && codePoint <= 0xdfff; };
    var isHex = function (codePoint) {
        return isDigit(codePoint) || (codePoint >= A && codePoint <= F) || (codePoint >= a && codePoint <= f);
    };
    var isLowerCaseLetter = function (codePoint) { return codePoint >= a && codePoint <= z; };
    var isUpperCaseLetter = function (codePoint) { return codePoint >= A && codePoint <= Z; };
    var isLetter = function (codePoint) { return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint); };
    var isNonASCIICodePoint = function (codePoint) { return codePoint >= CONTROL; };
    var isWhiteSpace = function (codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function (codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function (codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function (codePoint) {
        return ((codePoint >= NULL && codePoint <= BACKSPACE) ||
            codePoint === LINE_TABULATION ||
            (codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE) ||
            codePoint === DELETE);
    };
    var isValidEscape = function (c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) {
            return false;
        }
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function (c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) {
            return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        }
        else if (isNameStartCodePoint(c1)) {
            return true;
        }
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
            return true;
        }
        return false;
    };
    var isNumberStart = function (c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) {
                return true;
            }
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) {
            return isDigit(c2);
        }
        return isDigit(c1);
    };
    var stringToNumber = function (codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                sign = -1;
            }
            c++;
        }
        var integers = [];
        while (isDigit(codePoints[c])) {
            integers.push(codePoints[c++]);
        }
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) {
            c++;
        }
        var fraction = [];
        while (isDigit(codePoints[c])) {
            fraction.push(codePoints[c++]);
        }
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) {
            c++;
        }
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                expsign = -1;
            }
            c++;
        }
        var exponent = [];
        while (isDigit(codePoints[c])) {
            exponent.push(codePoints[c++]);
        }
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */
    };
    var COMMA_TOKEN = { type: 4 /* COMMA_TOKEN */ };
    var SUFFIX_MATCH_TOKEN = { type: 13 /* SUFFIX_MATCH_TOKEN */ };
    var PREFIX_MATCH_TOKEN = { type: 8 /* PREFIX_MATCH_TOKEN */ };
    var COLUMN_TOKEN = { type: 21 /* COLUMN_TOKEN */ };
    var DASH_MATCH_TOKEN = { type: 9 /* DASH_MATCH_TOKEN */ };
    var INCLUDE_MATCH_TOKEN = { type: 10 /* INCLUDE_MATCH_TOKEN */ };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */
    };
    var SUBSTRING_MATCH_TOKEN = { type: 14 /* SUBSTRING_MATCH_TOKEN */ };
    var BAD_URL_TOKEN = { type: 23 /* BAD_URL_TOKEN */ };
    var BAD_STRING_TOKEN = { type: 1 /* BAD_STRING_TOKEN */ };
    var CDO_TOKEN = { type: 25 /* CDO_TOKEN */ };
    var CDC_TOKEN = { type: 24 /* CDC_TOKEN */ };
    var COLON_TOKEN = { type: 26 /* COLON_TOKEN */ };
    var SEMICOLON_TOKEN = { type: 27 /* SEMICOLON_TOKEN */ };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */
    };
    var WHITESPACE_TOKEN = { type: 31 /* WHITESPACE_TOKEN */ };
    var EOF_TOKEN = { type: 32 /* EOF_TOKEN */ };
    var Tokenizer = /** @class */ (function () {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function (chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function () {
            var tokens = [];
            var token = this.consumeToken();
            while (token !== EOF_TOKEN) {
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function () {
            var codePoint = this.consumeCodePoint();
            switch (codePoint) {
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return { type: 5 /* HASH_TOKEN */, value: value, flags: flags };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while (true) {
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) {
                                    return this.consumeToken();
                                }
                            }
                            if (c === EOF) {
                                return this.consumeToken();
                            }
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK &&
                        this.peekCodePoint(1) === HYPHEN_MINUS &&
                        this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return { type: 7 /* AT_KEYWORD_TOKEN */, value: value };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return { type: 6 /* DELIM_TOKEN */, value: fromCodePoint$1(codePoint) };
        };
        Tokenizer.prototype.consumeCodePoint = function () {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function (delta) {
            if (delta >= this._value.length) {
                return -1;
            }
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function () {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while (isHex(codePoint) && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while (codePoint === QUESTION_MARK && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? ZERO : digit); })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? F : digit); })), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start_1, end: end };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while (isHex(codePoint) && endDigits.length < 6) {
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: end };
            }
            else {
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: start };
            }
        };
        Tokenizer.prototype.consumeIdentLikeToken = function () {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            }
            else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return { type: 19 /* FUNCTION_TOKEN */, value: value };
            }
            return { type: 20 /* IDENT_TOKEN */, value: value };
        };
        Tokenizer.prototype.consumeUrlToken = function () {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) {
                return { type: 22 /* URL_TOKEN */, value: '' };
            }
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: stringToken.value };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                    return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                }
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === QUOTATION_MARK ||
                    codePoint === APOSTROPHE ||
                    codePoint === LEFT_PARENTHESIS ||
                    isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        value.push(this.consumeEscapedCodePoint());
                    }
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                }
                else {
                    value.push(codePoint);
                }
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function () {
            while (isWhiteSpace(this.peekCodePoint(0))) {
                this.consumeCodePoint();
            }
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function () {
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                    return;
                }
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    this.consumeEscapedCodePoint();
                }
            }
        };
        Tokenizer.prototype.consumeStringSlice = function (count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while (count > 0) {
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function (endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return { type: 0 /* STRING_TOKEN */, value: value };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        }
                        else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            } while (true);
        };
        Tokenizer.prototype.consumeNumber = function () {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
                repr.push(this.consumeCodePoint());
            }
            while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3)) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            return [stringToNumber(repr), type];
        };
        Tokenizer.prototype.consumeNumericToken = function () {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return { type: 15 /* DIMENSION_TOKEN */, number: number, flags: flags, unit: unit };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return { type: 16 /* PERCENTAGE_TOKEN */, number: number, flags: flags };
            }
            return { type: 17 /* NUMBER_TOKEN */, number: number, flags: flags };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function () {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
                    hex += fromCodePoint$1(this.consumeCodePoint());
                }
                if (isWhiteSpace(this.peekCodePoint(0))) {
                    this.consumeCodePoint();
                }
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
                    return REPLACEMENT_CHARACTER;
                }
                return hexCodePoint;
            }
            if (codePoint === EOF) {
                return REPLACEMENT_CHARACTER;
            }
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function () {
            var result = '';
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) {
                    result += fromCodePoint$1(codePoint);
                }
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    result += fromCodePoint$1(this.consumeEscapedCodePoint());
                }
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }());

    var Parser = /** @class */ (function () {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function (value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function (value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function (value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function () {
            var token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */) {
                token = this.consumeToken();
            }
            if (token.type === 32 /* EOF_TOKEN */) {
                throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            }
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do {
                token = this.consumeToken();
            } while (token.type === 31 /* WHITESPACE_TOKEN */);
            if (token.type === 32 /* EOF_TOKEN */) {
                return value;
            }
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function () {
            var values = [];
            while (true) {
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */) {
                    return values;
                }
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function () {
            var token = this.consumeToken();
            switch (token.type) {
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */:
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */:
                case 2 /* LEFT_PARENTHESIS_TOKEN */:
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */:
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function (type) {
            var block = { type: type, values: [] };
            var token = this.consumeToken();
            while (true) {
                if (token.type === 32 /* EOF_TOKEN */ || isEndingTokenFor(token, type)) {
                    return block;
                }
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function (functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */
            };
            while (true) {
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */ || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */) {
                    return cssFunction;
                }
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function () {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function (token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }());
    var isDimensionToken = function (token) { return token.type === 15 /* DIMENSION_TOKEN */; };
    var isNumberToken = function (token) { return token.type === 17 /* NUMBER_TOKEN */; };
    var isIdentToken = function (token) { return token.type === 20 /* IDENT_TOKEN */; };
    var isStringToken = function (token) { return token.type === 0 /* STRING_TOKEN */; };
    var isIdentWithValue = function (token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function (token) { return token.type !== 31 /* WHITESPACE_TOKEN */; };
    var nonFunctionArgSeparator = function (token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ && token.type !== 4 /* COMMA_TOKEN */;
    };
    var parseFunctionArgs = function (tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function (token) {
            if (token.type === 4 /* COMMA_TOKEN */) {
                if (arg.length === 0) {
                    throw new Error("Error parsing function args, zero tokens for arg");
                }
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */) {
                arg.push(token);
            }
        });
        if (arg.length) {
            args.push(arg);
        }
        return args;
    };
    var isEndingTokenFor = function (token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */ && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */) {
            return true;
        }
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */ && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */) {
            return true;
        }
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */ && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */;
    };

    var isLength = function (token) {
        return token.type === 17 /* NUMBER_TOKEN */ || token.type === 15 /* DIMENSION_TOKEN */;
    };

    var isLengthPercentage = function (token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */ || isLength(token);
    };
    var parseLengthPercentageTuple = function (tokens) {
        return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function (tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)];
    };
    var getAbsoluteValue = function (token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            return (token.number / 100) * parent;
        }
        if (isDimensionToken(token)) {
            switch (token.unit) {
                case 'rem':
                case 'em':
                    return 16 * token.number; // TODO use correct font-size
                case 'px':
                default:
                    return token.number;
            }
        }
        return token.number;
    };

    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit) {
                    case DEG:
                        return (Math.PI * value.number) / 180;
                    case GRAD:
                        return (Math.PI / 200) * value.number;
                    case RAD:
                        return value.number;
                    case TURN:
                        return Math.PI * 2 * value.number;
                }
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function (value) {
        if (value.type === 15 /* DIMENSION_TOKEN */) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
                return true;
            }
        }
        return false;
    };
    var parseNamedSide = function (tokens) {
        var sideOrCorner = tokens
            .filter(isIdentToken)
            .map(function (ident) { return ident.value; })
            .join(' ');
        switch (sideOrCorner) {
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [ZERO_LENGTH, ZERO_LENGTH];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [ZERO_LENGTH, HUNDRED_PERCENT];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [HUNDRED_PERCENT, HUNDRED_PERCENT];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [HUNDRED_PERCENT, ZERO_LENGTH];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function (deg) { return (Math.PI * deg) / 180; };

    var color$1 = {
        name: 'color',
        parse: function (context, value) {
            if (value.type === 18 /* FUNCTION */) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                }
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') {
                    return namedColor;
                }
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function (color) { return (0xff & color) === 0; };
    var asString = function (color) {
        var alpha = 0xff & color;
        var blue = 0xff & (color >> 8);
        var green = 0xff & (color >> 16);
        var red = 0xff & (color >> 24);
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function (r, g, b, a) {
        return ((r << 24) | (g << 16) | (b << 8) | (Math.round(a * 255) << 0)) >>> 0;
    };
    var getTokenColorValue = function (token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */) {
            return token.number;
        }
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? (token.number / 100) * max : Math.round((token.number / 100) * max);
        }
        return 0;
    };
    var rgb = function (_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) {
            hue += 1;
        }
        if (hue >= 1) {
            hue -= 1;
        }
        if (hue < 1 / 6) {
            return (t2 - t1) * hue * 6 + t1;
        }
        else if (hue < 1 / 2) {
            return t2;
        }
        else if (hue < 2 / 3) {
            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        }
        else {
            return t1;
        }
    }
    var hsl = function (context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */ ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) {
            return pack(l * 255, l * 255, l * 255, 1);
        }
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function (context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };

    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var parseColorStop = function (context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? { color: color, stop: stop } : { color: color, stop: null };
    };
    var processColorStops = function (stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) {
            first.stop = ZERO_LENGTH;
        }
        if (last.stop === null) {
            last.stop = HUNDRED_PERCENT;
        }
        var processStops = [];
        var previous = 0;
        for (var i = 0; i < stops.length; i++) {
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) {
                    processStops.push(absoluteValue);
                }
                else {
                    processStops.push(previous);
                }
                previous = absoluteValue;
            }
            else {
                processStops.push(null);
            }
        }
        var gapBegin = null;
        for (var i = 0; i < processStops.length; i++) {
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) {
                    gapBegin = i;
                }
            }
            else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for (var g = 1; g <= gapLength; g++) {
                    processStops[gapBegin + g - 1] = gapValue * g;
                }
                gapBegin = null;
            }
        }
        return stops.map(function (_a, i) {
            var color = _a.color;
            return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) };
        });
    };
    var getAngleFromCorner = function (corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function (angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
    };
    var distance = function (a, b) { return Math.sqrt(a * a + b * b); };
    var findCorner = function (width, height, x, y, closest) {
        var corners = [
            [0, 0],
            [0, height],
            [width, 0],
            [width, height]
        ];
        return corners.reduce(function (stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
                return {
                    optimumCorner: corner,
                    optimumDistance: d
                };
            }
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function (gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch (gradient.size) {
            case 0 /* CLOSEST_SIDE */:
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */:
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */:
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */:
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [rx, ry];
    };

    var linearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return { angle: angle$1, stops: stops, type: 1 /* LINEAR_GRADIENT */ };
    };

    var prefixLinearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ &&
                    ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */
        };
    };

    var webkitGradient = function (context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */;
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */;
                    return;
                }
                else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: ZERO_LENGTH, color: color });
                }
                else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: HUNDRED_PERCENT, color: color });
                }
                else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) {
                            stops.push({
                                stop: { type: 16 /* PERCENTAGE_TOKEN */, number: stop_1.number * 100, flags: stop_1.flags },
                                color: color
                            });
                        }
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */
            ? {
                angle: (angle + deg(180)) % deg(360),
                stops: stops,
                type: type
            }
            : { size: size, shape: shape, stops: stops, position: position, type: type };
    };

    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function (acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) {
                            switch (token.value) {
                                case 'center':
                                    position.push(FIFTY_PERCENT);
                                    return acc;
                                case 'top':
                                case 'left':
                                    position.push(ZERO_LENGTH);
                                    return acc;
                                case 'right':
                                case 'bottom':
                                    position.push(HUNDRED_PERCENT);
                                    return acc;
                            }
                        }
                        else if (isLengthPercentage(token) || isLength(token)) {
                            position.push(token);
                        }
                    }
                    else if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case 'at':
                                isAtPosition_1 = true;
                                return false;
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case COVER:
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var prefixRadialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return false;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return false;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return false;
                        }
                    }
                    else if (isLengthPercentage(token) || isLength(token)) {
                        position.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            else if (i === 1) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case COVER:
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var isLinearGradient = function (background) {
        return background.type === 1 /* LINEAR_GRADIENT */;
    };
    var isRadialGradient = function (background) {
        return background.type === 2 /* RADIAL_GRADIENT */;
    };
    var image = {
        name: 'image',
        parse: function (context, value) {
            if (value.type === 22 /* URL_TOKEN */) {
                var image_1 = { url: value.value, type: 0 /* URL */ };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                }
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return (!(value.type === 20 /* IDENT_TOKEN */ && value.value === 'none') &&
            (value.type !== 18 /* FUNCTION */ || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]));
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };

    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens
                .filter(function (value) { return nonFunctionArgSeparator(value) && isSupportedImage(value); })
                .map(function (value) { return image.parse(context, value); });
        }
    };

    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) { return values.filter(isLengthPercentage); })
                .map(parseLengthPercentageTuple);
        }
    };

    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) {
                return values
                    .filter(isIdentToken)
                    .map(function (token) { return token.value; })
                    .join(' ');
            })
                .map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function (value) {
        switch (value) {
            case 'no-repeat':
                return 1 /* NO_REPEAT */;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */;
            case 'repeat':
            default:
                return 0 /* REPEAT */;
        }
    };

    var BACKGROUND_SIZE;
    (function (BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens).map(function (values) { return values.filter(isBackgroundSizeInfoToken); });
        }
    };
    var isBackgroundSizeInfoToken = function (value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };

    var borderColorForSide = function (side) { return ({
        name: "border-" + side + "-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    }); };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');

    var borderRadiusForSide = function (side) { return ({
        name: "border-radius-" + side,
        initialValue: '0 0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
        }
    }); };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');

    var borderStyleForSide = function (side) { return ({
        name: "border-" + side + "-style",
        initialValue: 'solid',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, style) {
            switch (style) {
                case 'none':
                    return 0 /* NONE */;
                case 'dashed':
                    return 2 /* DASHED */;
                case 'dotted':
                    return 3 /* DOTTED */;
                case 'double':
                    return 4 /* DOUBLE */;
            }
            return 1 /* SOLID */;
        }
    }); };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');

    var borderWidthForSide = function (side) { return ({
        name: "border-" + side + "-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    }); };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');

    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, direction) {
            switch (direction) {
                case 'rtl':
                    return 1 /* RTL */;
                case 'ltr':
                default:
                    return 0 /* LTR */;
            }
        }
    };

    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function (bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */);
        }
    };
    var parseDisplayValue = function (display) {
        switch (display) {
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */;
            case 'inline':
                return 4 /* INLINE */;
            case 'run-in':
                return 8 /* RUN_IN */;
            case 'flow':
                return 16 /* FLOW */;
            case 'flow-root':
                return 32 /* FLOW_ROOT */;
            case 'table':
                return 64 /* TABLE */;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */;
            case 'ruby':
                return 512 /* RUBY */;
            case 'subgrid':
                return 1024 /* SUBGRID */;
            case 'list-item':
                return 2048 /* LIST_ITEM */;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */;
            case 'table-row':
                return 32768 /* TABLE_ROW */;
            case 'table-cell':
                return 65536 /* TABLE_CELL */;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */;
            case 'contents':
                return 16777216 /* CONTENTS */;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */;
        }
        return 0 /* NONE */;
    };

    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, float) {
            switch (float) {
                case 'left':
                    return 1 /* LEFT */;
                case 'right':
                    return 2 /* RIGHT */;
                case 'inline-start':
                    return 3 /* INLINE_START */;
                case 'inline-end':
                    return 4 /* INLINE_END */;
            }
            return 0 /* NONE */;
        }
    };

    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'normal') {
                return 0;
            }
            if (token.type === 17 /* NUMBER_TOKEN */) {
                return token.number;
            }
            if (token.type === 15 /* DIMENSION_TOKEN */) {
                return token.number;
            }
            return 0;
        }
    };

    var LINE_BREAK;
    (function (LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, lineBreak) {
            switch (lineBreak) {
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };

    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    };
    var computeLineHeight = function (token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') {
            return 1.2 * fontSize;
        }
        else if (token.type === 17 /* NUMBER_TOKEN */) {
            return fontSize * token.number;
        }
        else if (isLengthPercentage(token)) {
            return getAbsoluteValue(token, fontSize);
        }
        return fontSize;
    };

    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            return image.parse(context, token);
        }
    };

    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'inside':
                    return 0 /* INSIDE */;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */;
            }
        }
    };

    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, type) {
            switch (type) {
                case 'disc':
                    return 0 /* DISC */;
                case 'circle':
                    return 1 /* CIRCLE */;
                case 'square':
                    return 2 /* SQUARE */;
                case 'decimal':
                    return 3 /* DECIMAL */;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */;
                case 'armenian':
                    return 12 /* ARMENIAN */;
                case 'bengali':
                    return 13 /* BENGALI */;
                case 'cambodian':
                    return 14 /* CAMBODIAN */;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */;
                case 'devanagari':
                    return 18 /* DEVANAGARI */;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */;
                case 'georgian':
                    return 20 /* GEORGIAN */;
                case 'gujarati':
                    return 21 /* GUJARATI */;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */;
                case 'hebrew':
                    return 22 /* HEBREW */;
                case 'hiragana':
                    return 23 /* HIRAGANA */;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */;
                case 'kannada':
                    return 27 /* KANNADA */;
                case 'katakana':
                    return 28 /* KATAKANA */;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */;
                case 'khmer':
                    return 30 /* KHMER */;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */;
                case 'lao':
                    return 34 /* LAO */;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */;
                case 'malayalam':
                    return 36 /* MALAYALAM */;
                case 'mongolian':
                    return 37 /* MONGOLIAN */;
                case 'myanmar':
                    return 38 /* MYANMAR */;
                case 'oriya':
                    return 39 /* ORIYA */;
                case 'persian':
                    return 40 /* PERSIAN */;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */;
                case 'tamil':
                    return 43 /* TAMIL */;
                case 'telugu':
                    return 44 /* TELUGU */;
                case 'thai':
                    return 45 /* THAI */;
                case 'tibetan':
                    return 46 /* TIBETAN */;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */;
                case 'none':
                default:
                    return -1 /* NONE */;
            }
        }
    };

    var marginForSide = function (side) { return ({
        name: "margin-" + side,
        initialValue: '0',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    }); };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');

    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (overflow) {
                switch (overflow.value) {
                    case 'hidden':
                        return 1 /* HIDDEN */;
                    case 'scroll':
                        return 2 /* SCROLL */;
                    case 'clip':
                        return 3 /* CLIP */;
                    case 'auto':
                        return 4 /* AUTO */;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */;
                }
            });
        }
    };

    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'break-word':
                    return "break-word" /* BREAK_WORD */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var paddingForSide = function (side) { return ({
        name: "padding-" + side,
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length-percentage'
    }); };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');

    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textAlign) {
            switch (textAlign) {
                case 'right':
                    return 2 /* RIGHT */;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */;
                case 'left':
                default:
                    return 0 /* LEFT */;
            }
        }
    };

    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'relative':
                    return 1 /* RELATIVE */;
                case 'absolute':
                    return 2 /* ABSOLUTE */;
                case 'fixed':
                    return 3 /* FIXED */;
                case 'sticky':
                    return 4 /* STICKY */;
            }
            return 0 /* STATIC */;
        }
    };

    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else {
                            shadow.blur = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textTransform) {
            switch (textTransform) {
                case 'uppercase':
                    return 2 /* UPPERCASE */;
                case 'lowercase':
                    return 1 /* LOWERCASE */;
                case 'capitalize':
                    return 3 /* CAPITALIZE */;
            }
            return 0 /* NONE */;
        }
    };

    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            if (token.type === 18 /* FUNCTION */) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                }
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        var a1 = values[0], b1 = values[1]; values[2]; values[3]; var a2 = values[4], b2 = values[5]; values[6]; values[7]; values[8]; values[9]; values[10]; values[11]; var a4 = values[12], b4 = values[13]; values[14]; values[15];
        return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };

    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) {
                return DEFAULT;
            }
            return [origins[0], origins[1]];
        }
    };

    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, visibility) {
            switch (visibility) {
                case 'hidden':
                    return 1 /* HIDDEN */;
                case 'collapse':
                    return 2 /* COLLAPSE */;
                case 'visible':
                default:
                    return 0 /* VISIBLE */;
            }
        }
    };

    var WORD_BREAK;
    (function (WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, wordBreak) {
            switch (wordBreak) {
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };

    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */) {
                return { auto: true, order: 0 };
            }
            if (isNumberToken(token)) {
                return { auto: false, order: token.number };
            }
            throw new Error("Invalid z-index number parsed");
        }
    };

    var time = {
        name: 'time',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit.toLowerCase()) {
                    case 's':
                        return 1000 * value.number;
                    case 'ms':
                        return value.number;
                }
            }
            throw new Error("Unsupported time type");
        }
    };

    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            return 1;
        }
    };

    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens
                .filter(isIdentToken)
                .map(function (token) {
                switch (token.value) {
                    case 'underline':
                        return 1 /* UNDERLINE */;
                    case 'overline':
                        return 2 /* OVERLINE */;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */;
                    case 'none':
                        return 4 /* BLINK */;
                }
                return 0 /* NONE */;
            })
                .filter(function (line) { return line !== 0 /* NONE */; });
        }
    };

    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function (token) {
                switch (token.type) {
                    case 20 /* IDENT_TOKEN */:
                    case 0 /* STRING_TOKEN */:
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */:
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */:
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) {
                results.push(accumulator.join(' '));
            }
            return results.map(function (result) { return (result.indexOf(' ') === -1 ? result : "'" + result + "'"); });
        }
    };

    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length'
    };

    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            if (isIdentToken(token)) {
                switch (token.value) {
                    case 'bold':
                        return 700;
                    case 'normal':
                    default:
                        return 400;
                }
            }
            return 400;
        }
    };

    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (token) { return token.value; });
        }
    };

    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'oblique':
                    return "oblique" /* OBLIQUE */;
                case 'italic':
                    return "italic" /* ITALIC */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var contains = function (bit, value) { return (bit & value) !== 0; };

    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens;
        }
    };

    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({ counter: counter.value, increment: increment });
                }
            }
            return increments;
        }
    };

    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({ counter: counter.value, reset: reset });
                }
            }
            return resets;
        }
    };

    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (context, tokens) {
            return tokens.filter(isDimensionToken).map(function (token) { return time.parse(context, token); });
        }
    };

    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) {
                return null;
            }
            for (var i = 0; i < filtered.length; i += 2) {
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({ open: open_1, close: close_1 });
            }
            return quotes;
        }
    };
    var getQuote = function (quotes, depth, open) {
        if (!quotes) {
            return '';
        }
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) {
            return '';
        }
        return open ? quote.open : quote.close;
    };

    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) {
                        shadow.inset = true;
                    }
                    else if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else if (c === 2) {
                            shadow.blur = token;
                        }
                        else {
                            shadow.spread = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var DEFAULT_VALUE = [0 /* FILL */, 1 /* STROKE */, 2 /* MARKERS */];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function (token) {
                switch (token.value) {
                    case 'stroke':
                        layers.push(1 /* STROKE */);
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */);
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */);
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function (value) {
                if (layers.indexOf(value) === -1) {
                    layers.push(value);
                }
            });
            return layers;
        }
    };

    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    };

    var CSSParsedDeclaration = /** @class */ (function () {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function () {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */;
        };
        CSSParsedDeclaration.prototype.isTransparent = function () {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function () {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function () {
            return this.position !== 0 /* STATIC */;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function () {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function () {
            return this.float !== 0 /* NONE */;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function () {
            return (contains(this.display, 4 /* INLINE */) ||
                contains(this.display, 33554432 /* INLINE_BLOCK */) ||
                contains(this.display, 268435456 /* INLINE_FLEX */) ||
                contains(this.display, 536870912 /* INLINE_GRID */) ||
                contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
                contains(this.display, 134217728 /* INLINE_TABLE */));
        };
        return CSSParsedDeclaration;
    }());
    var CSSParsedPseudoDeclaration = /** @class */ (function () {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }());
    var CSSParsedCounterDeclaration = /** @class */ (function () {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function (context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch (descriptor.type) {
            case 2 /* IDENT_VALUE */:
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */:
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */:
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */:
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */:
                switch (descriptor.format) {
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };

    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function (element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch (attribute) {
            case 'all':
                return 1 /* ALL */;
            case 'clone':
                return 2 /* CLONE */;
            case 'parse':
                return 3 /* PARSE */;
            case 'render':
                return 4 /* RENDER */;
            default:
                return 0 /* NONE */;
        }
    };
    var isDebugging = function (element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */ || type === elementType;
    };

    var ElementContainer = /** @class */ (function () {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */)) {
                debugger;
            }
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function (duration) { return duration > 0; })) {
                    element.style.animationDuration = '0s';
                }
                if (this.styles.transform !== null) {
                    // getBoundingClientRect takes transforms into account
                    element.style.transform = 'none';
                }
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */)) {
                this.flags |= 16 /* DEBUG_RENDER */;
            }
        }
        return ElementContainer;
    }());

    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var base64 = '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';

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1 = 0; i$1 < chars$1.length; i$1++) {
        lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    }
    var decode = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function (base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16(view16, (headerLength + view32[4]) / 2)
            : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i = 0; i < chars.length; i++) {
        lookup[chars.charCodeAt(i)] = i;
    }

    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = '×';
    var BREAK_ALLOWED = '÷';
    var codePointToClass = function (codePoint) { return UnicodeTrie.get(codePoint); };
    var _graphemeBreakAtIndex = function (_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) {
            return BREAK_NOT_ALLOWED;
        }
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) {
            return BREAK_ALLOWED;
        }
        // GB5
        if (next === CR || next === LF || next === Control) {
            return BREAK_ALLOWED;
        }
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [L, V, LV, LVT].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) {
            return BREAK_NOT_ALLOWED;
        }
        // GB8
        if ((current === LVT || current === T) && next === T) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) {
            return BREAK_NOT_ALLOWED;
        }
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9a
        if (current === Prepend) {
            return BREAK_NOT_ALLOWED;
        }
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while (prev === Extend) {
                prev = classTypes[--prevIndex];
            }
            if (prev === Extended_Pictographic) {
                return BREAK_NOT_ALLOWED;
            }
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while (prev === RI) {
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) {
                return BREAK_NOT_ALLOWED;
            }
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function (str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function () {
                if (index >= length) {
                    return { done: true, value: null };
                }
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while (index < length &&
                    (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED) { }
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };
    var splitGraphemes = function (str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while (!(bk = breaker.next()).done) {
            if (bk.value) {
                graphemes.push(bk.value.slice());
            }
        }
        return graphemes;
    };

    var testRangeBounds = function (document) {
        var TEST_HEIGHT = 123;
        if (document.createRange) {
            var range = document.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) {
                    return true;
                }
            }
        }
        return false;
    };
    var testIOSLineBreak = function (document) {
        var testElement = document.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document.body.appendChild(testElement);
        var range = document.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function (i) { return fromCodePoint$1(i); });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function (text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) {
                return true;
            }
            return boundAhead;
        });
        document.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function () { return typeof new Image().crossOrigin !== 'undefined'; };
    var testResponseType = function () { return typeof new XMLHttpRequest().responseType === 'string'; };
    var testSVG = function (document) {
        var img = new Image();
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return false;
        }
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        }
        catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function (data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function (document) {
        var canvas = document.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return Promise.reject(false);
        }
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg)
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data)
                ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node))
                : Promise.reject(false);
        })
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        })
            .catch(function () { return false; });
    };
    var createForeignObjectSVG = function (width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () { return resolve(img); };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS() {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
            return value;
        },
        get SUPPORT_WORD_BREAKING() {
            var value = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', { value: value });
            return value;
        },
        get SUPPORT_SVG_DRAWING() {
            var value = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING() {
            var value = typeof Array.from === 'function' && typeof window.fetch === 'function'
                ? testForeignObject(document)
                : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_CORS_IMAGES() {
            var value = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
            return value;
        },
        get SUPPORT_RESPONSE_TYPE() {
            var value = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
            return value;
        },
        get SUPPORT_CORS_XHR() {
            var value = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
            return value;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', { value: value });
            return value;
        }
    };

    var TextBounds = /** @class */ (function () {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }());
    var parseTextBounds = function (context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function (text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function (subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    }
                    else {
                        textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                    }
                }
                else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            }
            else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
                node = node.splitText(text.length);
            }
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function (context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) {
                    parentNode.replaceChild(wrapper.firstChild, wrapper);
                }
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function (node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) {
            throw new Error('Node has no owner document');
        }
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function (value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, { granularity: 'grapheme' });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function (value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return breakWords(value, styles);
    };
    var breakText = function (value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [0x0020, 0x00a0, 0x1361, 0x10100, 0x10101, 0x1039, 0x1091];
    var breakWords = function (str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */ ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function () {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function (codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) {
                        word_1 += fromCodePoint$1(codePoint);
                    }
                    else {
                        if (word_1.length) {
                            words.push(word_1);
                        }
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) {
                    words.push(word_1);
                }
            }
        };
        while (!(bk = breaker.next()).done) {
            _loop_1();
        }
        return words;
    };

    var TextContainer = /** @class */ (function () {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }());
    var transform = function (text, transform) {
        switch (transform) {
            case 1 /* LOWERCASE */:
                return text.toLowerCase();
            case 3 /* CAPITALIZE */:
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */:
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function (m, p1, p2) {
        if (m.length > 0) {
            return p1 + p2.toUpperCase();
        }
        return m;
    };

    var ImageElementContainer = /** @class */ (function (_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer));

    var CanvasElementContainer = /** @class */ (function (_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer));

    var SVGElementContainer = /** @class */ (function (_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer));

    var LIElementContainer = /** @class */ (function (_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer));

    var OLElementContainer = /** @class */ (function (_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer));

    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function (bounds) {
        if (bounds.width > bounds.height) {
            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        }
        else if (bounds.width < bounds.height) {
            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        }
        return bounds;
    };
    var getInputValue = function (node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ (function (_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor =
                    _this.styles.borderRightColor =
                        _this.styles.borderBottomColor =
                            _this.styles.borderLeftColor =
                                0xa5a5a5ff;
                _this.styles.borderTopWidth =
                    _this.styles.borderRightWidth =
                        _this.styles.borderBottomWidth =
                            _this.styles.borderLeftWidth =
                                1;
                _this.styles.borderTopStyle =
                    _this.styles.borderRightStyle =
                        _this.styles.borderBottomStyle =
                            _this.styles.borderLeftStyle =
                                1 /* SOLID */;
                _this.styles.backgroundClip = [0 /* BORDER_BOX */];
                _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch (_this.type) {
                case CHECKBOX:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer));

    var SelectElementContainer = /** @class */ (function (_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer));

    var TextareaElementContainer = /** @class */ (function (_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer));

    var IFrameElementContainer = /** @class */ (function (_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow &&
                    iframe.contentWindow.document &&
                    iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor)
                        : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor)
                        ? isTransparent(bodyBackgroundColor)
                            ? _this.styles.backgroundColor
                            : bodyBackgroundColor
                        : documentBackgroundColor;
                }
            }
            catch (e) { }
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer));

    var LIST_OWNERS = ['OL', 'UL', 'MENU'];
    var parseNodeTree = function (context, node, parent, root) {
        for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
                parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            }
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) {
                    childNode.assignedNodes().forEach(function (childNode) { return parseNodeTree(context, childNode, parent, root); });
                }
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) {
                            container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
                        }
                        else if (createsStackingContext(container.styles)) {
                            container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
                        }
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                            container.flags |= 8 /* IS_LIST_OWNER */;
                        }
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) {
                            parseNodeTree(context, childNode.shadowRoot, container, root);
                        }
                        else if (!isTextareaElement(childNode) &&
                            !isSVGElement(childNode) &&
                            !isSelectElement(childNode)) {
                            parseNodeTree(context, childNode, container, root);
                        }
                    }
                }
            }
        }
    };
    var createContainer = function (context, element) {
        if (isImageElement(element)) {
            return new ImageElementContainer(context, element);
        }
        if (isCanvasElement(element)) {
            return new CanvasElementContainer(context, element);
        }
        if (isSVGElement(element)) {
            return new SVGElementContainer(context, element);
        }
        if (isLIElement(element)) {
            return new LIElementContainer(context, element);
        }
        if (isOLElement(element)) {
            return new OLElementContainer(context, element);
        }
        if (isInputElement(element)) {
            return new InputElementContainer(context, element);
        }
        if (isSelectElement(element)) {
            return new SelectElementContainer(context, element);
        }
        if (isTextareaElement(element)) {
            return new TextareaElementContainer(context, element);
        }
        if (isIFrameElement(element)) {
            return new IFrameElementContainer(context, element);
        }
        return new ElementContainer(context, element);
    };
    var parseTree = function (context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function (node, container, root) {
        return (container.styles.isPositionedWithZIndex() ||
            container.styles.opacity < 1 ||
            container.styles.isTransformed() ||
            (isBodyElement(node) && root.styles.isTransparent()));
    };
    var createsStackingContext = function (styles) { return styles.isPositioned() || styles.isFloating(); };
    var isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
    var isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    var isHTMLElementNode = function (node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function (element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function (node) { return node.tagName === 'LI'; };
    var isOLElement = function (node) { return node.tagName === 'OL'; };
    var isInputElement = function (node) { return node.tagName === 'INPUT'; };
    var isHTMLElement = function (node) { return node.tagName === 'HTML'; };
    var isSVGElement = function (node) { return node.tagName === 'svg'; };
    var isBodyElement = function (node) { return node.tagName === 'BODY'; };
    var isCanvasElement = function (node) { return node.tagName === 'CANVAS'; };
    var isVideoElement = function (node) { return node.tagName === 'VIDEO'; };
    var isImageElement = function (node) { return node.tagName === 'IMG'; };
    var isIFrameElement = function (node) { return node.tagName === 'IFRAME'; };
    var isStyleElement = function (node) { return node.tagName === 'STYLE'; };
    var isScriptElement = function (node) { return node.tagName === 'SCRIPT'; };
    var isTextareaElement = function (node) { return node.tagName === 'TEXTAREA'; };
    var isSelectElement = function (node) { return node.tagName === 'SELECT'; };
    var isSlotElement = function (node) { return node.tagName === 'SLOT'; };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function (node) { return node.tagName.indexOf('-') > 0; };

    var CounterState = /** @class */ (function () {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function (name) {
            var counter = this.counters[name];
            if (counter && counter.length) {
                return counter[counter.length - 1];
            }
            return 1;
        };
        CounterState.prototype.getCounterValues = function (name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function (counters) {
            var _this = this;
            counters.forEach(function (counter) { return _this.counters[counter].pop(); });
        };
        CounterState.prototype.parse = function (style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) {
                counterIncrement.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    if (counter && entry.increment !== 0) {
                        canReset = false;
                        if (!counter.length) {
                            counter.push(1);
                        }
                        counter[Math.max(0, counter.length - 1)] += entry.increment;
                    }
                });
            }
            var counterNames = [];
            if (canReset) {
                counterReset.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    counterNames.push(entry.counter);
                    if (!counter) {
                        counter = _this.counters[entry.counter] = [];
                    }
                    counter.push(entry.reset);
                });
            }
            return counterNames;
        };
        return CounterState;
    }());
    var ROMAN_UPPER = {
        integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
        values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
    };
    var ARMENIAN = {
        integers: [
            9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70,
            60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'Ք',
            'Փ',
            'Ւ',
            'Ց',
            'Ր',
            'Տ',
            'Վ',
            'Ս',
            'Ռ',
            'Ջ',
            'Պ',
            'Չ',
            'Ո',
            'Շ',
            'Ն',
            'Յ',
            'Մ',
            'Ճ',
            'Ղ',
            'Ձ',
            'Հ',
            'Կ',
            'Ծ',
            'Խ',
            'Լ',
            'Ի',
            'Ժ',
            'Թ',
            'Ը',
            'Է',
            'Զ',
            'Ե',
            'Դ',
            'Գ',
            'Բ',
            'Ա'
        ]
    };
    var HEBREW = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20,
            19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'י׳',
            'ט׳',
            'ח׳',
            'ז׳',
            'ו׳',
            'ה׳',
            'ד׳',
            'ג׳',
            'ב׳',
            'א׳',
            'ת',
            'ש',
            'ר',
            'ק',
            'צ',
            'פ',
            'ע',
            'ס',
            'נ',
            'מ',
            'ל',
            'כ',
            'יט',
            'יח',
            'יז',
            'טז',
            'טו',
            'י',
            'ט',
            'ח',
            'ז',
            'ו',
            'ה',
            'ד',
            'ג',
            'ב',
            'א'
        ]
    };
    var GEORGIAN = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90,
            80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'ჵ',
            'ჰ',
            'ჯ',
            'ჴ',
            'ხ',
            'ჭ',
            'წ',
            'ძ',
            'ც',
            'ჩ',
            'შ',
            'ყ',
            'ღ',
            'ქ',
            'ფ',
            'ჳ',
            'ტ',
            'ს',
            'რ',
            'ჟ',
            'პ',
            'ო',
            'ჲ',
            'ნ',
            'მ',
            'ლ',
            'კ',
            'ი',
            'თ',
            'ჱ',
            'ზ',
            'ვ',
            'ე',
            'დ',
            'გ',
            'ბ',
            'ა'
        ]
    };
    var createAdditiveCounter = function (value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) {
            return createCounterText(value, fallback, suffix.length > 0);
        }
        return (symbols.integers.reduce(function (string, integer, index) {
            while (value >= integer) {
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix);
    };
    var createCounterStyleWithSymbolResolver = function (value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) {
                value--;
            }
            string = resolver(value) + string;
            value /= codePointRangeLength;
        } while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function (value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return ((value < 0 ? '-' : '') +
            (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
                return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
            }) +
                suffix));
    };
    var createCounterStyleFromSymbols = function (value, symbols, suffix) {
        if (suffix === void 0) { suffix = '. '; }
        var codePointRangeLength = symbols.length;
        return (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) { return symbols[Math.floor(codePoint % codePointRangeLength)]; }) + suffix);
    };
    var CJK_ZEROS = 1 << 0;
    var CJK_TEN_COEFFICIENTS = 1 << 1;
    var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
    var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
    var createCJKCounter = function (value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) {
            return createCounterText(value, 4 /* CJK_DECIMAL */, suffix.length > 0);
        }
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) {
            return numbers[0] + string;
        }
        for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
                string = numbers[coefficient] + string;
            }
            else if (coefficient > 1 ||
                (coefficient === 1 && digit === 0) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS)) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100) ||
                (coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS))) {
                string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            }
            else if (coefficient === 1 && digit > 0) {
                string = multipliers[digit - 1] + string;
            }
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
    var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
    var JAPANESE_NEGATIVE = 'マイナス';
    var KOREAN_NEGATIVE = '마이너스';
    var createCounterText = function (value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? '、' : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch (type) {
            case 0 /* DISC */:
                return '•' + spaceSuffix;
            case 1 /* CIRCLE */:
                return '◦' + spaceSuffix;
            case 2 /* SQUARE */:
                return '◾' + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */:
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */:
                return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
            case 6 /* LOWER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix);
            case 8 /* LOWER_GREEK */:
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */:
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */:
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */:
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */:
            case 49 /* UPPER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix);
            case 35 /* LOWER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 13 /* BENGALI */:
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */:
            case 30 /* KHMER */:
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */:
                return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */:
                return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */:
            case 48 /* TRAD_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */:
                return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */:
                return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */:
                return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */:
                return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */:
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */:
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */, defaultSuffix);
            case 21 /* GUJARATI */:
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */:
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */:
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */, defaultSuffix);
            case 23 /* HIRAGANA */:
                return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
            case 24 /* HIRAGANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
            case 27 /* KANNADA */:
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */:
                return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
            case 29 /* KATAKANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
            case 34 /* LAO */:
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */:
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */:
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */:
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */:
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */:
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */:
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */:
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */:
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */:
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };

    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ (function () {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) {
                throw new Error('Cloned element does not have an owner document');
            }
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function (ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) {
                return Promise.reject("Unable to find iframe window");
            }
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */
            var iframeLoad = iframeLoader(iframe).then(function () { return __awaiter(_this, void 0, void 0, function () {
                var onclone, referenceElement;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.scrolledElements.forEach(restoreNodeScroll);
                            if (cloneWindow) {
                                cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) &&
                                    (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                    this.context.logger.warn('Unable to restore scroll position for cloned document');
                                    this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                }
                            }
                            onclone = this.options.onclone;
                            referenceElement = this.clonedReferenceElement;
                            if (typeof referenceElement === 'undefined') {
                                return [2 /*return*/, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                            }
                            if (!(documentClone.fonts && documentClone.fonts.ready)) return [3 /*break*/, 2];
                            return [4 /*yield*/, documentClone.fonts.ready];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [3 /*break*/, 4];
                            return [4 /*yield*/, imagesReady(documentClone)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            if (typeof onclone === 'function') {
                                return [2 /*return*/, Promise.resolve()
                                        .then(function () { return onclone(documentClone, referenceElement); })
                                        .then(function () { return iframe; })];
                            }
                            return [2 /*return*/, iframe];
                    }
                });
            }); });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function (node) {
            if (isDebugging(node, 2 /* CLONE */)) {
                debugger;
            }
            if (isCanvasElement(node)) {
                return this.createCanvasClone(node);
            }
            if (isVideoElement(node)) {
                return this.createVideoClone(node);
            }
            if (isStyleElement(node)) {
                return this.createStyleClone(node);
            }
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') {
                    clone.loading = 'eager';
                }
            }
            if (isCustomElement(clone)) {
                return this.createCustomElementClone(clone);
            }
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function (node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function (node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function (css, rule) {
                        if (rule && typeof rule.cssText === 'string') {
                            return css + rule.cssText;
                        }
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            }
            catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') {
                    throw e;
                }
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function (canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                }
                catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) {
                        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    }
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) {
                                this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                            }
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function (video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) {
                        ctx.getImageData(0, 0, canvas.width, canvas.height);
                    }
                }
                return canvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function (clone, child, copyStyles) {
            if (!isElementNode(child) ||
                (!isScriptElement(child) &&
                    !child.hasAttribute(IGNORE_ATTRIBUTE) &&
                    (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child)))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
                    clone.appendChild(this.cloneNode(child, copyStyles));
                }
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function (node, clone, copyStyles) {
            var _this = this;
            for (var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling) {
                if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                    var assignedNodes = child.assignedNodes();
                    if (assignedNodes.length) {
                        assignedNodes.forEach(function (assignedNode) { return _this.appendChildNode(clone, assignedNode, copyStyles); });
                    }
                }
                else {
                    this.appendChildNode(clone, child, copyStyles);
                }
            }
        };
        DocumentCloner.prototype.cloneNode = function (node, copyStyles) {
            if (isTextNode(node)) {
                return document.createTextNode(node.data);
            }
            if (!node.ownerDocument) {
                return node.cloneNode(false);
            }
            var window = node.ownerDocument.defaultView;
            if (window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window.getComputedStyle(node);
                var styleBefore = window.getComputedStyle(node, ':before');
                var styleAfter = window.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) {
                    this.clonedReferenceElement = clone;
                }
                if (isBodyElement(clone)) {
                    createPseudoHideStyles(clone);
                }
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) {
                    copyStyles = true;
                }
                if (!isVideoElement(node)) {
                    this.cloneChildNodes(node, clone, copyStyles);
                }
                if (before) {
                    clone.insertBefore(before, clone.firstChild);
                }
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) {
                    clone.appendChild(after);
                }
                this.counters.pop(counters);
                if ((style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node)) ||
                    copyStyles) {
                    copyCSSStyles(style, clone);
                }
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                if ((isTextareaElement(node) || isSelectElement(node)) &&
                    (isTextareaElement(clone) || isSelectElement(clone))) {
                    clone.value = node.value;
                }
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function (node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) {
                return;
            }
            var value = style.content;
            var document = clone.ownerDocument;
            if (!document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') {
                return;
            }
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function (token) {
                if (token.type === 0 /* STRING_TOKEN */) {
                    anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                }
                else if (token.type === 22 /* URL_TOKEN */) {
                    var img = document.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                }
                else if (token.type === 18 /* FUNCTION */) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) {
                            anonymousReplacedElement.appendChild(document.createTextNode(node.getAttribute(attr[0].value) || ''));
                        }
                    }
                    else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            anonymousReplacedElement.appendChild(document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    }
                    else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */ ? delim.value : '';
                            var text = counterStates
                                .map(function (value) { return createCounterText(value, counterType_1, false); })
                                .join(separator);
                            anonymousReplacedElement.appendChild(document.createTextNode(text));
                        }
                    }
                    else ;
                }
                else if (token.type === 20 /* IDENT_TOKEN */) {
                    switch (token.value) {
                        case 'open-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                            break;
                        case 'close-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                            break;
                        default:
                            // safari doesn't parse string tokens correctly because of lack of quotes
                            anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                    }
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE
                ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
                : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) {
                clone.className.baseValue += newClassName;
            }
            else {
                clone.className += newClassName;
            }
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function (container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }());
    var PseudoElementType;
    (function (PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function (ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function (img) {
        return new Promise(function (resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function (document) {
        return Promise.all([].slice.call(document.images, 0).map(imageReady));
    };
    var iframeLoader = function (iframe) {
        return new Promise(function (resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) {
                return reject("No window assigned for iframe");
            }
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function () {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function () {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function (style, target) {
        // Edge does not provide value for cssText
        for (var i = style.length - 1; i >= 0; i--) {
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) {
                target.style.setProperty(property, style.getPropertyValue(property));
            }
        }
        return target;
    };
    var serializeDoctype = function (doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) {
                str += doctype.name;
            }
            if (doctype.internalSubset) {
                str += doctype.internalSubset;
            }
            if (doctype.publicId) {
                str += "\"" + doctype.publicId + "\"";
            }
            if (doctype.systemId) {
                str += "\"" + doctype.systemId + "\"";
            }
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function (ownerDocument, x, y) {
        if (ownerDocument &&
            ownerDocument.defaultView &&
            (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x, y);
        }
    };
    var restoreNodeScroll = function (_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function (body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function (body, styles) {
        var document = body.ownerDocument;
        if (document) {
            var style = document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };

    var CacheStorage = /** @class */ (function () {
        function CacheStorage() {
        }
        CacheStorage.getOrigin = function (url) {
            var link = CacheStorage._link;
            if (!link) {
                return 'about:blank';
            }
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function (src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function (window) {
            CacheStorage._link = window.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }());
    var Cache = /** @class */ (function () {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function (src) {
            var result = Promise.resolve();
            if (this.has(src)) {
                return result;
            }
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function () {
                    // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function (src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) &&
                                !isSameOrigin &&
                                !isBlobImage(key) &&
                                typeof this._options.proxy === 'string' &&
                                FEATURES.SUPPORT_CORS_XHR &&
                                !useCORS;
                            if (!isSameOrigin &&
                                this._options.allowTaint === false &&
                                !isInlineImage(key) &&
                                !isBlobImage(key) &&
                                !useProxy &&
                                !useCORS) {
                                return [2 /*return*/];
                            }
                            src = key;
                            if (!useProxy) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.proxy(src)];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    var img = new Image();
                                    img.onload = function () { return resolve(img); };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) {
                                        img.crossOrigin = 'anonymous';
                                    }
                                    img.src = src;
                                    if (img.complete === true) {
                                        // Inline XML images may fail to parse, throwing an Error later on
                                        setTimeout(function () { return resolve(img); }, 500);
                                    }
                                    if (_this._options.imageTimeout > 0) {
                                        setTimeout(function () { return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image"); }, _this._options.imageTimeout);
                                    }
                                })];
                        case 3: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        Cache.prototype.has = function (key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function () {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function (src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) {
                throw new Error('No proxy defined');
            }
            var key = src.substring(0, 256);
            return new Promise(function (resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        if (responseType === 'text') {
                            resolve(xhr.response);
                        }
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function () { return resolve(reader_1.result); }, false);
                            reader_1.addEventListener('error', function (e) { return reject(e); }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    }
                    else {
                        reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                    }
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
                    xhr.responseType = responseType;
                }
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function () { return reject("Timed out (" + timeout_1 + "ms) proxying " + key); };
                }
                xhr.send();
            });
        };
        return Cache;
    }());
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function (src) { return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src); };
    var isInlineImage = function (src) { return INLINE_IMG.test(src); };
    var isInlineBase64Image = function (src) { return INLINE_BASE64.test(src); };
    var isBlobImage = function (src) { return src.substr(0, 4) === 'blob'; };
    var isSVG = function (src) { return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src); };

    var Vector = /** @class */ (function () {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function (deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }());

    var lerp = function (a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ (function () {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function (t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function (deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function () {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }());
    var isBezierCurve = function (path) { return path.type === 1 /* BEZIER_CURVE */; };

    var BoundCurves = /** @class */ (function () {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3, tlh - (borderLeftWidth * 2) / 3, tlv - (borderTopWidth * 2) / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.topRightBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + (borderTopWidth * 2) / 3, trh - (borderRightWidth * 2) / 3, trv - (borderTopWidth * 2) / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.bottomRightBorderDoubleInnerBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - (borderRightWidth * 2) / 3, brv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.bottomLeftBorderDoubleInnerBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + leftHeight, blh - (borderLeftWidth * 2) / 3, blv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.topLeftBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT)
                    : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }());
    var CORNER;
    (function (CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function (x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch (position) {
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function (curves) {
        return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
    };
    var calculateContentBoxPath = function (curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function (curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };

    var TransformEffect = /** @class */ (function () {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return TransformEffect;
    }());
    var ClipEffect = /** @class */ (function () {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */;
        }
        return ClipEffect;
    }());
    var OpacityEffect = /** @class */ (function () {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return OpacityEffect;
    }());
    var isTransformEffect = function (effect) {
        return effect.type === 0 /* TRANSFORM */;
    };
    var isClipEffect = function (effect) { return effect.type === 1 /* CLIP */; };
    var isOpacityEffect = function (effect) { return effect.type === 2 /* OPACITY */; };

    var equalPath = function (a, b) {
        if (a.length === b.length) {
            return a.some(function (v, i) { return v === b[i]; });
        }
        return false;
    };
    var transformPath = function (path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function (point, index) {
            switch (index) {
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };

    var StackingContext = /** @class */ (function () {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }());
    var ElementPaint = /** @class */ (function () {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) {
                this.effects.push(new OpacityEffect(this.container.styles.opacity));
            }
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */));
                }
            }
        }
        ElementPaint.prototype.getEffects = function (target) {
            var inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while (parent) {
                var croplessEffects = parent.effects.filter(function (effect) { return !isClipEffect(effect); });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */ || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) {
                            effects.unshift(new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                        }
                    }
                }
                else {
                    effects.unshift.apply(effects, croplessEffects);
                }
                parent = parent.parent;
            }
            return effects.filter(function (effect) { return contains(effect.target, target); });
        };
        return ElementPaint;
    }());
    var parseStackTree = function (parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function (child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */);
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */);
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
                listItems.push(paintContainer);
            }
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function (current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            }
                            else if (index_1 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    }
                    else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function (current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            }
                            else if (index_2 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    }
                    else {
                        parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                    }
                }
                else {
                    if (child.styles.isFloating()) {
                        parentStack.nonPositionedFloats.push(stack);
                    }
                    else {
                        parentStack.nonPositionedInlineLevel.push(stack);
                    }
                }
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            }
            else {
                if (child.styles.isInlineLevel()) {
                    stackingContext.inlineLevel.push(paintContainer);
                }
                else {
                    stackingContext.nonInlineLevel.push(paintContainer);
                }
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
                processListItems(child, listOwnerItems);
            }
        });
    };
    var processListItems = function (owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for (var i = 0; i < elements.length; i++) {
            var item = elements[i];
            if (item.container instanceof LIElementContainer &&
                typeof item.container.value === 'number' &&
                item.container.value !== 0) {
                numbering = item.container.value;
            }
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function (container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };

    var parsePathForBorder = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function (outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        return path;
    };
    var createPathFromCurves = function (outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        if (isBezierCurve(inner2)) {
            path.push(inner2.subdivide(0.5, true).reverse());
        }
        else {
            path.push(inner2);
        }
        if (isBezierCurve(inner1)) {
            path.push(inner1.subdivide(0.5, false).reverse());
        }
        else {
            path.push(inner1);
        }
        return path;
    };

    var paddingBox = function (element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function (element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };

    var calculateBackgroundPositioningArea = function (backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundOrigin === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function (backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundClip === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function (container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [path, offsetX, offsetY, sizeWidth, sizeHeight];
    };
    var isAuto = function (token) { return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO; };
    var hasIntrinsicValue = function (value) { return typeof value === 'number'; };
    var calculateBackgroundSize = function (size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) {
            return [0, 0];
        }
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
        }
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER)
                    ? [bounds.width, bounds.width / intrinsicProportion]
                    : [bounds.height * intrinsicProportion, bounds.height];
            }
            return [bounds.width, bounds.height];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) {
                return [intrinsicWidth, intrinsicHeight];
            }
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
                return [bounds.width, bounds.height];
            }
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth
                    ? intrinsicWidth
                    : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight
                    ? intrinsicHeight
                    : intrinsicWidth / intrinsicProportion;
                return [width_1, height_1];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [width_2, height_2];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) {
                width_3 = getAbsoluteValue(first, bounds.width);
            }
            else if (isLengthPercentage(second)) {
                height_3 = getAbsoluteValue(second, bounds.height);
            }
            if (isAuto(first)) {
                width_3 = height_3 * intrinsicProportion;
            }
            else if (!second || isAuto(second)) {
                height_3 = width_3 / intrinsicProportion;
            }
            return [width_3, height_3];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) {
            width = getAbsoluteValue(first, bounds.width);
        }
        else if (second && isLengthPercentage(second)) {
            height = getAbsoluteValue(second, bounds.height);
        }
        if (width !== null && (!second || isAuto(second))) {
            height =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (width / intrinsicWidth) * intrinsicHeight
                    : bounds.height;
        }
        if (height !== null && isAuto(first)) {
            width =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (height / intrinsicHeight) * intrinsicWidth
                    : bounds.width;
        }
        if (width !== null && height !== null) {
            return [width, height];
        }
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function (values, index) {
        var value = values[index];
        if (typeof value === 'undefined') {
            return values[0];
        }
        return value;
    };
    var calculateBackgroundRepeatPath = function (repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch (repeat) {
            case 2 /* REPEAT_X */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };

    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ (function () {
        function FontMetrics(document) {
            this._data = {};
            this._document = document;
        }
        FontMetrics.prototype.parseMetrics = function (fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return { baseline: baseline, middle: middle };
        };
        FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') {
                this._data[key] = this.parseMetrics(fontFamily, fontSize);
            }
            return this._data[key];
        };
        return FontMetrics;
    }());

    var Renderer = /** @class */ (function () {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }());

    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ (function (_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function (effects) {
            var _this = this;
            while (this._activeEffects.length) {
                this.popEffect();
            }
            effects.forEach(function (effect) { return _this.applyEffect(effect); });
        };
        CanvasRenderer.prototype.applyEffect = function (effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) {
                this.ctx.globalAlpha = effect.opacity;
            }
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function () {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var styles;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderStackContent(stack)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            if (!paint.container.styles.isVisible()) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.renderNodeContent(paint)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function (text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) {
                this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            }
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function (left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function (styles) {
            var fontVariant = styles.fontVariant
                .filter(function (variant) { return variant === 'normal' || variant === 'small-caps'; })
                .join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize)
                ? "" + styles.fontSize.number + styles.fontSize.unit
                : styles.fontSize.number + "px";
            return [
                [styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function (text, styles) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function (_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */ ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function (text) {
                        paintOrder.forEach(function (paintOrderLayer) {
                            switch (paintOrderLayer) {
                                case 0 /* FILL */:
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows
                                            .slice(0)
                                            .reverse()
                                            .forEach(function (textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function (textDecorationLine) {
                                            switch (textDecorationLine) {
                                                case 1 /* UNDERLINE */:
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */:
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */:
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */:
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function (container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderTextNode(child, styles)];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, this.context.cache.match(container.src)];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 8];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [3 /*break*/, 8];
                        case 8:
                            if (container instanceof CanvasElementContainer) {
                                this.renderReplacedElement(container, curves, container.canvas);
                            }
                            if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([9, 11, , 12]);
                            return [4 /*yield*/, this.context.cache.match(container.svg)];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 12];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [3 /*break*/, 12];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [3 /*break*/, 14];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [4 /*yield*/, iframeRenderer.render(container.tree)];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) {
                                this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            }
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                                else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch (container.styles.textAlign) {
                                    case 1 /* CENTER */:
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */:
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */)) return [3 /*break*/, 20];
                            if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */)) return [3 /*break*/, 18];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([15, 17, , 18]);
                            return [4 /*yield*/, this.context.cache.match(url)];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [3 /*break*/, 18];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [3 /*break*/, 18];
                        case 18: return [3 /*break*/, 20];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function (_p) {
                    switch (_p.label) {
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element)];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3 /*break*/, 5];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [3 /*break*/, 2];
                        case 5: 
                        // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                        return [4 /*yield*/, this.renderNodeContent(stack.element)];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [3 /*break*/, 10];
                            child = _c[_b];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [3 /*break*/, 7];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [3 /*break*/, 14];
                            child = _e[_d];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [3 /*break*/, 11];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [3 /*break*/, 18];
                            child = _g[_f];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [3 /*break*/, 15];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [3 /*break*/, 22];
                            child = _j[_h];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [3 /*break*/, 19];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [3 /*break*/, 26];
                            child = _l[_k];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [3 /*break*/, 23];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [3 /*break*/, 30];
                            child = _o[_m];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [3 /*break*/, 27];
                        case 30: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function (paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function (paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function (paths) {
            var _this = this;
            paths.forEach(function (point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) {
                    _this.ctx.moveTo(start.x, start.y);
                }
                else {
                    _this.ctx.lineTo(start.x, start.y);
                }
                if (isBezierCurve(point)) {
                    _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                }
            });
        };
        CanvasRenderer.prototype.renderRepeat = function (path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function (image, width, height) {
            var _a;
            if (image.width === width && image.height === height) {
                return image;
            }
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function (container) {
            return __awaiter(this, void 0, void 0, function () {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function (backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function (_h) {
                                    switch (_h.label) {
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */)) return [3 /*break*/, 5];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this_1.context.cache.match(url)];
                                        case 2:
                                            image = _h.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [3 /*break*/, 4];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [3 /*break*/, 6];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [null, null, null]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function (colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            }
                                            else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function (colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    }
                                                    else {
                                                        this_1.ctx.fill();
                                                    }
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            backgroundImage = _a[_i];
                            return [5 /*yield**/, _loop_1(backgroundImage)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function (color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function (color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                var outerPaths, innerPaths;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(width < 3)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderSolidBorder(color, side, curvePoints)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                { style: styles.borderTopStyle, color: styles.borderTopColor, width: styles.borderTopWidth },
                                { style: styles.borderRightStyle, color: styles.borderRightColor, width: styles.borderRightWidth },
                                { style: styles.borderBottomStyle, color: styles.borderBottomColor, width: styles.borderBottomWidth },
                                { style: styles.borderLeftStyle, color: styles.borderLeftColor, width: styles.borderLeftWidth }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [4 /*yield*/, this.renderBackgroundImage(paint.container)];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow
                                .slice(0)
                                .reverse()
                                .forEach(function (shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                }
                                else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [3 /*break*/, 13];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */ && !isTransparent(border.color) && border.width > 0)) return [3 /*break*/, 11];
                            if (!(border.style === 2 /* DASHED */)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */)];
                        case 4:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */)) return [3 /*break*/, 7];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */)];
                        case 6:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */)) return [3 /*break*/, 9];
                            return [4 /*yield*/, this.renderDoubleBorder(border.color, border.width, side, paint.curves)];
                        case 8:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 9: return [4 /*yield*/, this.renderSolidBorder(border.color, side, paint.curves)];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [3 /*break*/, 3];
                        case 13: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function (color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function () {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function (_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    }
                    else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    }
                    else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) {
                        length = Math.abs(startX - endX);
                    }
                    else {
                        length = Math.abs(startY - endY);
                    }
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */) {
                        this.formatPath(strokePaths);
                    }
                    else {
                        this.formatPath(boxPaths.slice(0, 2));
                    }
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) {
                        useLineDash = false;
                    }
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    }
                    else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength =
                            maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace)
                                ? minSpace
                                : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */) {
                            this.ctx.setLineDash([0, dashLength + spaceLength]);
                        }
                        else {
                            this.ctx.setLineDash([dashLength, spaceLength]);
                        }
                    }
                    if (style === 3 /* DOTTED */) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    }
                    else {
                        this.ctx.lineWidth = width * 2 + 1.1;
                    }
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var stack;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [4 /*yield*/, this.renderStack(stack)];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer));
    var isTextInputElement = function (container) {
        if (container instanceof TextareaElementContainer) {
            return true;
        }
        else if (container instanceof SelectElementContainer) {
            return true;
        }
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
            return true;
        }
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function (clip, curves) {
        switch (clip) {
            case 0 /* BORDER_BOX */:
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */:
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */:
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function (textAlign) {
        switch (textAlign) {
            case 1 /* CENTER */:
                return 'center';
            case 2 /* RIGHT */:
                return 'right';
            case 0 /* LEFT */:
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = ['-apple-system', 'system-ui'];
    var fixIOSSystemFonts = function (fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent)
            ? fontFamilies.filter(function (fontFamily) { return iOSBrokenFonts.indexOf(fontFamily) === -1; })
            : fontFamilies;
    };

    var ForeignObjectRenderer = /** @class */ (function (_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var svg, img;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [4 /*yield*/, loadSerializedSVG(svg)];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer));
    var loadSerializedSVG = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };

    var Logger = /** @class */ (function () {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') {
                    // eslint-disable-next-line no-console
                    console.debug.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.prototype.getTime = function () {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
                    // eslint-disable-next-line no-console
                    console.info.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') {
                    // eslint-disable-next-line no-console
                    console.warn.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') {
                    // eslint-disable-next-line no-console
                    console.error.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.instances = {};
        return Logger;
    }());

    var Context = /** @class */ (function () {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({ id: this.instanceName, enabled: options.logging });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }());

    var html2canvas = function (element, options) {
        if (options === void 0) { options = {}; }
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') {
        CacheStorage.setContext(window);
    }
    var renderElement = function (element, opts) { return __awaiter(void 0, void 0, void 0, function () {
        var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        return __generator(this, function (_u) {
            switch (_u.label) {
                case 0:
                    if (!element || typeof element !== 'object') {
                        return [2 /*return*/, Promise.reject('Invalid element provided as first argument')];
                    }
                    ownerDocument = element.ownerDocument;
                    if (!ownerDocument) {
                        throw new Error("Element is not attached to a Document");
                    }
                    defaultView = ownerDocument.defaultView;
                    if (!defaultView) {
                        throw new Error("Document is not attached to a Window");
                    }
                    resourceOptions = {
                        allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                        imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                        proxy: opts.proxy,
                        useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                    };
                    contextOptions = __assign({ logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true, cache: opts.cache }, resourceOptions);
                    windowOptions = {
                        windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                        windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                        scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                        scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                    };
                    windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                    context = new Context(contextOptions, windowBounds);
                    foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                    cloneOptions = {
                        allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                        onclone: opts.onclone,
                        ignoreElements: opts.ignoreElements,
                        inlineImages: foreignObjectRendering,
                        copyStyles: foreignObjectRendering
                    };
                    context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                    documentCloner = new DocumentCloner(context, element, cloneOptions);
                    clonedElement = documentCloner.clonedReferenceElement;
                    if (!clonedElement) {
                        return [2 /*return*/, Promise.reject("Unable to find element in cloned iframe")];
                    }
                    return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)];
                case 1:
                    container = _u.sent();
                    _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement)
                        ? parseDocumentSize(clonedElement.ownerDocument)
                        : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                    backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                    renderOptions = {
                        canvas: opts.canvas,
                        backgroundColor: backgroundColor,
                        scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                        x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                        y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                        width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                        height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                    };
                    if (!foreignObjectRendering) return [3 /*break*/, 3];
                    context.logger.debug("Document cloned, using foreign object rendering");
                    renderer = new ForeignObjectRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(clonedElement)];
                case 2:
                    canvas = _u.sent();
                    return [3 /*break*/, 5];
                case 3:
                    context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                    context.logger.debug("Starting DOM parsing");
                    root = parseTree(context, clonedElement);
                    if (backgroundColor === root.styles.backgroundColor) {
                        root.styles.backgroundColor = COLORS.TRANSPARENT;
                    }
                    context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                    renderer = new CanvasRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(root)];
                case 4:
                    canvas = _u.sent();
                    _u.label = 5;
                case 5:
                    if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                        if (!DocumentCloner.destroy(container)) {
                            context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                    }
                    context.logger.debug("Finished rendering");
                    return [2 /*return*/, canvas];
            }
        });
    }); };
    var parseBackgroundColor = function (context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement
            ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor)
            : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body
            ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor)
            : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string'
            ? parseColor(context, backgroundColorOverride)
            : backgroundColorOverride === null
                ? COLORS.TRANSPARENT
                : 0xffffffff;
        return element === ownerDocument.documentElement
            ? isTransparent(documentBackgroundColor)
                ? isTransparent(bodyBackgroundColor)
                    ? defaultBackgroundColor
                    : bodyBackgroundColor
                : documentBackgroundColor
            : defaultBackgroundColor;
    };

    return html2canvas;

})));
//# sourceMappingURL=html2canvas.js.map

/**
 * textFit v2.3.1
 * Previously known as jQuery.textFit
 * 11/2014 by STRML (strml.github.com)
 * MIT License
 *
 * To use: textFit(document.getElementById('target-div'), options);
 *
 * Will make the *text* content inside a container scale to fit the container
 * The container is required to have a set width and height
 * Uses binary search to fit text with minimal layout calls.
 * Version 2.0 does not use jQuery.
 */
/*global define:true, document:true, window:true, HTMLElement:true*/

(function(root, factory) {
  "use strict";

  // UMD shim
  if (typeof define === "function" && define.amd) {
    // AMD
    define([], factory);
  } else if (typeof exports === "object") {
    // Node/CommonJS
    module.exports = factory();
  } else {
    // Browser
    root.textFit = factory();
  }

}(typeof global === "object" ? global : this, function () {
  "use strict";

  var defaultSettings = {
    alignVert: false, // if true, textFit will align vertically using css tables
    alignHoriz: false, // if true, textFit will set text-align: center
    multiLine: false, // if true, textFit will not set white-space: no-wrap
    detectMultiLine: true, // disable to turn off automatic multi-line sensing
    minFontSize: 6,
    maxFontSize: 80,
    reProcess: true, // if true, textFit will re-process already-fit nodes. Set to 'false' for better performance
    widthOnly: false, // if true, textFit will fit text to element width, regardless of text height
    alignVertWithFlexbox: false, // if true, textFit will use flexbox for vertical alignment
  };

  return function textFit(els, options) {

    if (!options) options = {};

    // Extend options.
    var settings = {};
    for(var key in defaultSettings){
      if(options.hasOwnProperty(key)){
        settings[key] = options[key];
      } else {
        settings[key] = defaultSettings[key];
      }
    }

    // Convert jQuery objects into arrays
    if (typeof els.toArray === "function") {
      els = els.toArray();
    }

    // Support passing a single el
    var elType = Object.prototype.toString.call(els);
    if (elType !== '[object Array]' && elType !== '[object NodeList]' &&
            elType !== '[object HTMLCollection]'){
      els = [els];
    }

    // Process each el we've passed.
    for(var i = 0; i < els.length; i++){
      processItem(els[i], settings);
    }
  };

  /**
   * The meat. Given an el, make the text inside it fit its parent.
   * @param  {DOMElement} el       Child el.
   * @param  {Object} settings     Options for fit.
   */
  function processItem(el, settings){
    if (!isElement(el) || (!settings.reProcess && el.getAttribute('textFitted'))) {
      return false;
    }

    // Set textFitted attribute so we know this was processed.
    if(!settings.reProcess){
      el.setAttribute('textFitted', 1);
    }

    var innerSpan, originalHeight, originalHTML, originalWidth;
    var low, mid, high;

    // Get element data.
    originalHTML = el.innerHTML;
    originalWidth = innerWidth(el);
    originalHeight = innerHeight(el);

    // Don't process if we can't find box dimensions
    if (!originalWidth || (!settings.widthOnly && !originalHeight)) {
      if(!settings.widthOnly)
        throw new Error('Set a static height and width on the target element ' + el.outerHTML +
          ' before using textFit!');
      else
        throw new Error('Set a static width on the target element ' + el.outerHTML +
          ' before using textFit!');
    }

    // Add textFitted span inside this container.
    if (originalHTML.indexOf('textFitted') === -1) {
      innerSpan = document.createElement('span');
      innerSpan.className = 'textFitted';
      // Inline block ensure it takes on the size of its contents, even if they are enclosed
      // in other tags like <p>
      innerSpan.style['display'] = 'inline-block';
      innerSpan.innerHTML = originalHTML;
      el.innerHTML = '';
      el.appendChild(innerSpan);
    } else {
      // Reprocessing.
      innerSpan = el.querySelector('span.textFitted');
      // Remove vertical align if we're reprocessing.
      if (hasClass(innerSpan, 'textFitAlignVert')){
        innerSpan.className = innerSpan.className.replace('textFitAlignVert', '');
        innerSpan.style['height'] = '';
        el.className.replace('textFitAlignVertFlex', '');
      }
    }

    // Prepare & set alignment
    if (settings.alignHoriz) {
      el.style['text-align'] = 'center';
      innerSpan.style['text-align'] = 'center';
    }

    // Check if this string is multiple lines
    // Not guaranteed to always work if you use wonky line-heights
    var multiLine = settings.multiLine;
    if (settings.detectMultiLine && !multiLine &&
        innerSpan.scrollHeight >= parseInt(window.getComputedStyle(innerSpan)['font-size'], 10) * 2){
      multiLine = true;
    }

    // If we're not treating this as a multiline string, don't let it wrap.
    if (!multiLine) {
      el.style['white-space'] = 'nowrap';
    }

    low = settings.minFontSize;
    high = settings.maxFontSize;

    // Binary search for highest best fit
    var size = low;
    while (low <= high) {
      mid = (high + low) >> 1;
      innerSpan.style.fontSize = mid + 'px';
      if(innerSpan.scrollWidth <= originalWidth && (settings.widthOnly || innerSpan.scrollHeight <= originalHeight)){
        size = mid;
        low = mid + 1;
      } else {
        high = mid - 1;
      }
      // await injection point
    }
    // found, updating font if differs:
    if( innerSpan.style.fontSize != size + 'px' ) innerSpan.style.fontSize = size + 'px';

    // Our height is finalized. If we are aligning vertically, set that up.
    if (settings.alignVert) {
      addStyleSheet();
      var height = innerSpan.scrollHeight;
      if (window.getComputedStyle(el)['position'] === "static"){
        el.style['position'] = 'relative';
      }
      if (!hasClass(innerSpan, "textFitAlignVert")){
        innerSpan.className = innerSpan.className + " textFitAlignVert";
      }
      innerSpan.style['height'] = height + "px";
      if (settings.alignVertWithFlexbox && !hasClass(el, "textFitAlignVertFlex")) {
        el.className = el.className + " textFitAlignVertFlex";
      }
    }
  }

  // Calculate height without padding.
  function innerHeight(el){
    var style = window.getComputedStyle(el, null);
    return el.clientHeight -
      parseInt(style.getPropertyValue('padding-top'), 10) -
      parseInt(style.getPropertyValue('padding-bottom'), 10);
  }

  // Calculate width without padding.
  function innerWidth(el){
    var style = window.getComputedStyle(el, null);
    return el.clientWidth -
      parseInt(style.getPropertyValue('padding-left'), 10) -
      parseInt(style.getPropertyValue('padding-right'), 10);
  }

  //Returns true if it is a DOM element
  function isElement(o){
    return (
      typeof HTMLElement === "object" ? o instanceof HTMLElement : //DOM2
      o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName==="string"
    );
  }

  function hasClass(element, cls) {
    return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }

  // Better than a stylesheet dependency
  function addStyleSheet() {
    if (document.getElementById("textFitStyleSheet")) return;
    var style = [
      ".textFitAlignVert{",
        "position: absolute;",
        "top: 0; right: 0; bottom: 0; left: 0;",
        "margin: auto;",
        "display: flex;",
        "justify-content: center;",
        "flex-direction: column;",
      "}",
      ".textFitAlignVertFlex{",
        "display: flex;",
      "}",
      ".textFitAlignVertFlex .textFitAlignVert{",
        "position: static;",
      "}",].join("");

    var css = document.createElement("style");
    css.type = "text/css";
    css.id = "textFitStyleSheet";
    css.innerHTML = style;
    document.body.appendChild(css);
  }
}));

$(document).ready(function () {
	var viewport_width = $(window).width();
	if (viewport_width <= 900) {
		$('#menuBtn').click(function () {
			$('.leftAsideBar').removeClass("closebtn");
			$('.leftAsideBar').addClass("toggled mobile_nav");

		});
		$('#closebtn').click(function () {
			$('.leftAsideBar').addClass("closebtn");
			$('.leftAsideBar').removeClass("toggled mobile_nav");

		});
	}
	else {
		$('.leftAsideBar').removeClass("closebtn");
		$('.leftAsideBar').removeClass("toggled mobile_nav");
	}
});

$(window).resize(function () {
	var viewport_width = $(window).width();
	if (viewport_width <= 900) {
		$('#menuBtn').click(function () {
			$('.leftAsideBar').removeClass("closebtn");
			$('.leftAsideBar').addClass("toggled mobile_nav");
		});

		$('#closebtn').click(function () {
			$('.leftAsideBar').addClass("closebtn");
			$('.leftAsideBar').removeClass("toggled mobile_nav");

		});

		$('.rotationArrow ').click(function () {
			$('.collapse').addClass("show");

		});
	}
	else {
		$('.leftAsideBar').removeClass("closebtn");
		$('.leftAsideBar').removeClass("toggled mobile_nav");
	}
});


function hoverButtons(event, state, edit = true, copy = true, remove = true) {
	if (state) {
		var div = document.createElement("div");
		const editHtml = edit ? `<a><span class="icon-edit1"></span></a>` : ``;
		const copyHtml = copy ? `<a><span class="icon-copy"></span></a>` : ``;
		const removeHtml = remove ? `<a><span class="icon-delete"></span></a>` : ``;
		div.innerHTML = `
    <div class="topBar">
        <div class="right-ic">` +
			editHtml +
			copyHtml +
			removeHtml + `
        </div>
    </div>`;

		div.id = "headerLogo";
		div.classList.add("headerLogo");
		event.appendChild(div);
	}
	else {
		var elem = document.querySelector('#headerLogo');
		elem.parentNode.removeChild(elem);
	}
}

$(document).click(function (event) {
	const timeout = 100;
	let isEditorOpen;

	if (event.target.closest('.rightSidetabs')) {
		isEditorOpen = event.target.closest('.rightSidetabs').classList.contains('rightSidetabs');
	}

	setTimeout(() => {
		if (event.target.classList.contains('leftslider-arrow') ||
			event.target.classList.contains('stopclick') ||
			event.target.classList.contains('fa-angle-right')
		) {
			$('.rightBody').addClass('removeleftSlider');
			$('.leftslider-arrow').css('visibility', 'hidden');
		}
		else {
			$('.rightBody').removeClass('removeleftSlider');
			$('.leftslider-arrow').css('visibility', 'visible');
		}

		if (event.target.classList.contains('icon-edit1') ||
			event.target.classList.contains('icon-edit') ||
			event.target.classList.contains('fa-angle-left') ||
			isEditorOpen
		) {
			$('.rightSlider').addClass('addrightSlider');
		}
		else {
		}

	}, timeout);
});

CKEDITOR_BASEPATH = '/assets/js/ckeditor/';

/**
 * @license MIT
 * topbar 1.0.0, 2021-01-06
 * http://buunguyen.github.io/topbar
 * Copyright (c) 2021 Buu Nguyen
 */
(function (window, document) {
  "use strict";

  // https://gist.github.com/paulirish/1579671
  (function () {
    var lastTime = 0;
    var vendors = ["ms", "moz", "webkit", "o"];
    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
      window.requestAnimationFrame =
        window[vendors[x] + "RequestAnimationFrame"];
      window.cancelAnimationFrame =
        window[vendors[x] + "CancelAnimationFrame"] ||
        window[vendors[x] + "CancelRequestAnimationFrame"];
    }
    if (!window.requestAnimationFrame)
      window.requestAnimationFrame = function (callback, element) {
        var currTime = new Date().getTime();
        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
        var id = window.setTimeout(function () {
          callback(currTime + timeToCall);
        }, timeToCall);
        lastTime = currTime + timeToCall;
        return id;
      };
    if (!window.cancelAnimationFrame)
      window.cancelAnimationFrame = function (id) {
        clearTimeout(id);
      };
  })();

  var canvas,
    progressTimerId,
    fadeTimerId,
    currentProgress,
    showing,
    addEvent = function (elem, type, handler) {
      if (elem.addEventListener) elem.addEventListener(type, handler, false);
      else if (elem.attachEvent) elem.attachEvent("on" + type, handler);
      else elem["on" + type] = handler;
    },
    options = {
      autoRun: true,
      barThickness: 3,
      barColors: {
        0: "rgba(26,  188, 156, .9)",
        ".25": "rgba(52,  152, 219, .9)",
        ".50": "rgba(241, 196, 15,  .9)",
        ".75": "rgba(230, 126, 34,  .9)",
        "1.0": "rgba(211, 84,  0,   .9)",
      },
      shadowBlur: 10,
      shadowColor: "rgba(0,   0,   0,   .6)",
      className: null,
    },
    repaint = function () {
      canvas.width = window.innerWidth;
      canvas.height = options.barThickness * 5; // need space for shadow

      var ctx = canvas.getContext("2d");
      ctx.shadowBlur = options.shadowBlur;
      ctx.shadowColor = options.shadowColor;

      var lineGradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
      for (var stop in options.barColors)
        lineGradient.addColorStop(stop, options.barColors[stop]);
      ctx.lineWidth = options.barThickness;
      ctx.beginPath();
      ctx.moveTo(0, options.barThickness / 2);
      ctx.lineTo(
        Math.ceil(currentProgress * canvas.width),
        options.barThickness / 2
      );
      ctx.strokeStyle = lineGradient;
      ctx.stroke();
    },
    createCanvas = function () {
      canvas = document.createElement("canvas");
      var style = canvas.style;
      style.position = "fixed";
      style.top = style.left = style.right = style.margin = style.padding = 0;
      style.zIndex = 100001;
      style.display = "none";
      if (options.className) canvas.classList.add(options.className);
      document.body.appendChild(canvas);
      addEvent(window, "resize", repaint);
    },
    topbar = {
      config: function (opts) {
        for (var key in opts)
          if (options.hasOwnProperty(key)) options[key] = opts[key];
      },
      show: function () {
        if (showing) return;
        showing = true;
        if (fadeTimerId !== null) window.cancelAnimationFrame(fadeTimerId);
        if (!canvas) createCanvas();
        canvas.style.opacity = 1;
        canvas.style.display = "block";
        topbar.progress(0);
        if (options.autoRun) {
          (function loop() {
            progressTimerId = window.requestAnimationFrame(loop);
            topbar.progress(
              "+" + 0.05 * Math.pow(1 - Math.sqrt(currentProgress), 2)
            );
          })();
        }
      },
      progress: function (to) {
        if (typeof to === "undefined") return currentProgress;
        if (typeof to === "string") {
          to =
            (to.indexOf("+") >= 0 || to.indexOf("-") >= 0
              ? currentProgress
              : 0) + parseFloat(to);
        }
        currentProgress = to > 1 ? 1 : to;
        repaint();
        return currentProgress;
      },
      hide: function () {
        if (!showing) return;
        showing = false;
        if (progressTimerId != null) {
          window.cancelAnimationFrame(progressTimerId);
          progressTimerId = null;
        }
        (function loop() {
          if (topbar.progress("+.1") >= 1) {
            canvas.style.opacity -= 0.05;
            if (canvas.style.opacity <= 0.05) {
              canvas.style.display = "none";
              fadeTimerId = null;
              return;
            }
          }
          fadeTimerId = window.requestAnimationFrame(loop);
        })();
      },
    };

  if (typeof module === "object" && typeof module.exports === "object") {
    module.exports = topbar;
  } else if (typeof define === "function" && define.amd) {
    define(function () {
      return topbar;
    });
  } else {
    this.topbar = topbar;
  }
}.call(this, window, document));

/**
 * vis-network
 * https://visjs.github.io/vis-network/
 *
 * A dynamic, browser-based visualization library.
 *
 * @version 9.0.3
 * @date    2021-03-06T12:02:16.846Z
 *
 * @copyright (c) 2011-2017 Almende B.V, http://almende.com
 * @copyright (c) 2017-2019 visjs contributors, https://github.com/visjs
 *
 * @license
 * vis.js is dual licensed under both
 *
 *   1. The Apache 2.0 License
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *   and
 *
 *   2. The MIT License
 *      http://opensource.org/licenses/MIT
 *
 * vis.js may be distributed under either license.
 */

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
        typeof define === 'function' && define.amd ? define(['exports'], factory) :
            (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.vis = global.vis || {}));
}(this, (function (exports) {
    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

    function createCommonjsModule(fn) {
        var module = { exports: {} };
        return fn(module, module.exports), module.exports;
    }

    var check = function (it) {
        return it && it.Math == Math && it;
    }; // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028


    var global$1 =
        /* global globalThis -- safe */
        check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
        function () {
            return this;
        }() || Function('return this')();

    var fails = function (exec) {
        try {
            return !!exec();
        } catch (error) {
            return true;
        }
    };

    var descriptors = !fails(function () {
        return Object.defineProperty({}, 1, {
            get: function () {
                return 7;
            }
        })[1] != 7;
    });

    var nativePropertyIsEnumerable$1 = {}.propertyIsEnumerable;
    var getOwnPropertyDescriptor$5 = Object.getOwnPropertyDescriptor; // Nashorn ~ JDK8 bug

    var NASHORN_BUG = getOwnPropertyDescriptor$5 && !nativePropertyIsEnumerable$1.call({
        1: 2
    }, 1); // `Object.prototype.propertyIsEnumerable` method implementation
    // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable

    var f$6 = NASHORN_BUG ? function propertyIsEnumerable(V) {
        var descriptor = getOwnPropertyDescriptor$5(this, V);
        return !!descriptor && descriptor.enumerable;
    } : nativePropertyIsEnumerable$1;
    var objectPropertyIsEnumerable = {
        f: f$6
    };

    var createPropertyDescriptor = function (bitmap, value) {
        return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value
        };
    };

    var toString$1 = {}.toString;

    var classofRaw = function (it) {
        return toString$1.call(it).slice(8, -1);
    };

    var split = ''.split; // fallback for non-array-like ES3 and non-enumerable old V8 strings

    var indexedObject = fails(function () {
        // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
        // eslint-disable-next-line no-prototype-builtins -- safe
        return !Object('z').propertyIsEnumerable(0);
    }) ? function (it) {
        return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
    } : Object;

    // `RequireObjectCoercible` abstract operation
    // https://tc39.es/ecma262/#sec-requireobjectcoercible
    var requireObjectCoercible = function (it) {
        if (it == undefined) throw TypeError("Can't call method on " + it);
        return it;
    };

    var toIndexedObject = function (it) {
        return indexedObject(requireObjectCoercible(it));
    };

    var isObject$1 = function (it) {
        return typeof it === 'object' ? it !== null : typeof it === 'function';
    };

    // https://tc39.es/ecma262/#sec-toprimitive
    // instead of the ES6 spec version, we didn't implement @@toPrimitive case
    // and the second argument - flag - preferred type is a string

    var toPrimitive = function (input, PREFERRED_STRING) {
        if (!isObject$1(input)) return input;
        var fn, val;
        if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$1(val = fn.call(input))) return val;
        if (typeof (fn = input.valueOf) == 'function' && !isObject$1(val = fn.call(input))) return val;
        if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$1(val = fn.call(input))) return val;
        throw TypeError("Can't convert object to primitive value");
    };

    var hasOwnProperty = {}.hasOwnProperty;

    var has$1 = function (it, key) {
        return hasOwnProperty.call(it, key);
    };

    var document$1 = global$1.document; // typeof document.createElement is 'object' in old IE

    var EXISTS = isObject$1(document$1) && isObject$1(document$1.createElement);

    var documentCreateElement = function (it) {
        return EXISTS ? document$1.createElement(it) : {};
    };

    var ie8DomDefine = !descriptors && !fails(function () {
        return Object.defineProperty(documentCreateElement('div'), 'a', {
            get: function () {
                return 7;
            }
        }).a != 7;
    });

    var nativeGetOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor; // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

    var f$5 = descriptors ? nativeGetOwnPropertyDescriptor$2 : function getOwnPropertyDescriptor(O, P) {
        O = toIndexedObject(O);
        P = toPrimitive(P, true);
        if (ie8DomDefine) try {
            return nativeGetOwnPropertyDescriptor$2(O, P);
        } catch (error) {
            /* empty */
        }
        if (has$1(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
    };
    var objectGetOwnPropertyDescriptor = {
        f: f$5
    };

    var replacement = /#|\.prototype\./;

    var isForced = function (feature, detection) {
        var value = data[normalize(feature)];
        return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == 'function' ? fails(detection) : !!detection;
    };

    var normalize = isForced.normalize = function (string) {
        return String(string).replace(replacement, '.').toLowerCase();
    };

    var data = isForced.data = {};
    var NATIVE = isForced.NATIVE = 'N';
    var POLYFILL = isForced.POLYFILL = 'P';
    var isForced_1 = isForced;

    var path = {};

    var aFunction$1 = function (it) {
        if (typeof it != 'function') {
            throw TypeError(String(it) + ' is not a function');
        }

        return it;
    };

    var functionBindContext = function (fn, that, length) {
        aFunction$1(fn);
        if (that === undefined) return fn;

        switch (length) {
            case 0:
                return function () {
                    return fn.call(that);
                };

            case 1:
                return function (a) {
                    return fn.call(that, a);
                };

            case 2:
                return function (a, b) {
                    return fn.call(that, a, b);
                };

            case 3:
                return function (a, b, c) {
                    return fn.call(that, a, b, c);
                };
        }

        return function ()
            /* ...args */
        {
            return fn.apply(that, arguments);
        };
    };

    var anObject = function (it) {
        if (!isObject$1(it)) {
            throw TypeError(String(it) + ' is not an object');
        }

        return it;
    };

    var nativeDefineProperty$1 = Object.defineProperty; // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty

    var f$4 = descriptors ? nativeDefineProperty$1 : function defineProperty(O, P, Attributes) {
        anObject(O);
        P = toPrimitive(P, true);
        anObject(Attributes);
        if (ie8DomDefine) try {
            return nativeDefineProperty$1(O, P, Attributes);
        } catch (error) {
            /* empty */
        }
        if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
        if ('value' in Attributes) O[P] = Attributes.value;
        return O;
    };
    var objectDefineProperty = {
        f: f$4
    };

    var createNonEnumerableProperty = descriptors ? function (object, key, value) {
        return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
    } : function (object, key, value) {
        object[key] = value;
        return object;
    };

    var getOwnPropertyDescriptor$4 = objectGetOwnPropertyDescriptor.f;

    var wrapConstructor = function (NativeConstructor) {
        var Wrapper = function (a, b, c) {
            if (this instanceof NativeConstructor) {
                switch (arguments.length) {
                    case 0:
                        return new NativeConstructor();

                    case 1:
                        return new NativeConstructor(a);

                    case 2:
                        return new NativeConstructor(a, b);
                }

                return new NativeConstructor(a, b, c);
            }

            return NativeConstructor.apply(this, arguments);
        };

        Wrapper.prototype = NativeConstructor.prototype;
        return Wrapper;
    };
    /*
	  options.target      - name of the target object
	  options.global      - target is the global object
	  options.stat        - export as static methods of target
	  options.proto       - export as prototype methods of target
	  options.real        - real prototype method for the `pure` version
	  options.forced      - export even if the native feature is available
	  options.bind        - bind methods to the target, required for the `pure` version
	  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
	  options.sham        - add a flag to not completely full polyfills
	  options.enumerable  - export as enumerable property
	  options.noTargetGet - prevent calling a getter on target
	*/


    var _export = function (options, source) {
        var TARGET = options.target;
        var GLOBAL = options.global;
        var STATIC = options.stat;
        var PROTO = options.proto;
        var nativeSource = GLOBAL ? global$1 : STATIC ? global$1[TARGET] : (global$1[TARGET] || {}).prototype;
        var target = GLOBAL ? path : path[TARGET] || (path[TARGET] = {});
        var targetPrototype = target.prototype;
        var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
        var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;

        for (key in source) {
            FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced); // contains in native

            USE_NATIVE = !FORCED && nativeSource && has$1(nativeSource, key);
            targetProperty = target[key];
            if (USE_NATIVE) if (options.noTargetGet) {
                descriptor = getOwnPropertyDescriptor$4(nativeSource, key);
                nativeProperty = descriptor && descriptor.value;
            } else nativeProperty = nativeSource[key]; // export native or implementation

            sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];
            if (USE_NATIVE && typeof targetProperty === typeof sourceProperty) continue; // bind timers to global for call from export context

            if (options.bind && USE_NATIVE) resultProperty = functionBindContext(sourceProperty, global$1); // wrap global constructors for prevent changs in this version
            else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty); // make static versions for prototype methods
            else if (PROTO && typeof sourceProperty == 'function') resultProperty = functionBindContext(Function.call, sourceProperty); // default case
            else resultProperty = sourceProperty; // add a flag to not completely full polyfills

            if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) {
                createNonEnumerableProperty(resultProperty, 'sham', true);
            }

            target[key] = resultProperty;

            if (PROTO) {
                VIRTUAL_PROTOTYPE = TARGET + 'Prototype';

                if (!has$1(path, VIRTUAL_PROTOTYPE)) {
                    createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {});
                } // export virtual prototype methods


                path[VIRTUAL_PROTOTYPE][key] = sourceProperty; // export real prototype methods

                if (options.real && targetPrototype && !targetPrototype[key]) {
                    createNonEnumerableProperty(targetPrototype, key, sourceProperty);
                }
            }
        }
    };

    var ceil = Math.ceil;
    var floor = Math.floor; // `ToInteger` abstract operation
    // https://tc39.es/ecma262/#sec-tointeger

    var toInteger = function (argument) {
        return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
    };

    var min$2 = Math.min; // `ToLength` abstract operation
    // https://tc39.es/ecma262/#sec-tolength

    var toLength = function (argument) {
        return argument > 0 ? min$2(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
    };

    var max$2 = Math.max;
    var min$1 = Math.min; // Helper for a popular repeating case of the spec:
    // Let integer be ? ToInteger(index).
    // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).

    var toAbsoluteIndex = function (index, length) {
        var integer = toInteger(index);
        return integer < 0 ? max$2(integer + length, 0) : min$1(integer, length);
    };

    var createMethod$5 = function (IS_INCLUDES) {
        return function ($this, el, fromIndex) {
            var O = toIndexedObject($this);
            var length = toLength(O.length);
            var index = toAbsoluteIndex(fromIndex, length);
            var value; // Array#includes uses SameValueZero equality algorithm
            // eslint-disable-next-line no-self-compare -- NaN check

            if (IS_INCLUDES && el != el) while (length > index) {
                value = O[index++]; // eslint-disable-next-line no-self-compare -- NaN check

                if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
            } else for (; length > index; index++) {
                if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
            }
            return !IS_INCLUDES && -1;
        };
    };

    var arrayIncludes = {
        // `Array.prototype.includes` method
        // https://tc39.es/ecma262/#sec-array.prototype.includes
        includes: createMethod$5(true),
        // `Array.prototype.indexOf` method
        // https://tc39.es/ecma262/#sec-array.prototype.indexof
        indexOf: createMethod$5(false)
    };

    var hiddenKeys$1 = {};

    var indexOf$3 = arrayIncludes.indexOf;

    var objectKeysInternal = function (object, names) {
        var O = toIndexedObject(object);
        var i = 0;
        var result = [];
        var key;

        for (key in O) !has$1(hiddenKeys$1, key) && has$1(O, key) && result.push(key); // Don't enum bug & hidden keys


        while (names.length > i) if (has$1(O, key = names[i++])) {
            ~indexOf$3(result, key) || result.push(key);
        }

        return result;
    };

    // IE8- don't enum bug keys
    var enumBugKeys = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];

    // https://tc39.es/ecma262/#sec-object.keys

    var objectKeys = Object.keys || function keys(O) {
        return objectKeysInternal(O, enumBugKeys);
    };

    var f$3 = Object.getOwnPropertySymbols;
    var objectGetOwnPropertySymbols = {
        f: f$3
    };

    // https://tc39.es/ecma262/#sec-toobject

    var toObject = function (argument) {
        return Object(requireObjectCoercible(argument));
    };

    var nativeAssign = Object.assign;
    var defineProperty$8 = Object.defineProperty; // `Object.assign` method
    // https://tc39.es/ecma262/#sec-object.assign

    var objectAssign = !nativeAssign || fails(function () {
        // should have correct order of operations (Edge bug)
        if (descriptors && nativeAssign({
            b: 1
        }, nativeAssign(defineProperty$8({}, 'a', {
            enumerable: true,
            get: function () {
                defineProperty$8(this, 'b', {
                    value: 3,
                    enumerable: false
                });
            }
        }), {
            b: 2
        })).b !== 1) return true; // should work with symbols and should have deterministic property order (V8 bug)

        var A = {};
        var B = {};
        /* global Symbol -- required for testing */

        var symbol = Symbol();
        var alphabet = 'abcdefghijklmnopqrst';
        A[symbol] = 7;
        alphabet.split('').forEach(function (chr) {
            B[chr] = chr;
        });
        return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
    }) ? function assign(target, source) {
        // eslint-disable-line no-unused-vars -- required for `.length`
        var T = toObject(target);
        var argumentsLength = arguments.length;
        var index = 1;
        var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
        var propertyIsEnumerable = objectPropertyIsEnumerable.f;

        while (argumentsLength > index) {
            var S = indexedObject(arguments[index++]);
            var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
            var length = keys.length;
            var j = 0;
            var key;

            while (length > j) {
                key = keys[j++];
                if (!descriptors || propertyIsEnumerable.call(S, key)) T[key] = S[key];
            }
        }

        return T;
    } : nativeAssign;

    // https://tc39.es/ecma262/#sec-object.assign

    _export({
        target: 'Object',
        stat: true,
        forced: Object.assign !== objectAssign
    }, {
        assign: objectAssign
    });

    var assign$4 = path.Object.assign;

    var assign$3 = assign$4;

    var assign$2 = assign$3;

    var slice$6 = [].slice;
    var factories = {};

    var construct$3 = function (C, argsLength, args) {
        if (!(argsLength in factories)) {
            for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']'; // eslint-disable-next-line no-new-func -- we have no proper alternatives, IE8- only


            factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
        }

        return factories[argsLength](C, args);
    }; // `Function.prototype.bind` method implementation
    // https://tc39.es/ecma262/#sec-function.prototype.bind


    var functionBind = Function.bind || function bind(that
                                                      /* , ...args */
    ) {
        var fn = aFunction$1(this);
        var partArgs = slice$6.call(arguments, 1);

        var boundFunction = function bound()
            /* args... */
        {
            var args = partArgs.concat(slice$6.call(arguments));
            return this instanceof boundFunction ? construct$3(fn, args.length, args) : fn.apply(that, args);
        };

        if (isObject$1(fn.prototype)) boundFunction.prototype = fn.prototype;
        return boundFunction;
    };

    // https://tc39.es/ecma262/#sec-function.prototype.bind

    _export({
        target: 'Function',
        proto: true
    }, {
        bind: functionBind
    });

    var entryVirtual = function (CONSTRUCTOR) {
        return path[CONSTRUCTOR + 'Prototype'];
    };

    var bind$2 = entryVirtual('Function').bind;

    var FunctionPrototype = Function.prototype;

    var bind_1 = function (it) {
        var own = it.bind;
        return it === FunctionPrototype || it instanceof Function && own === FunctionPrototype.bind ? bind$2 : own;
    };

    var bind$1 = bind_1;

    var bind = bind$1;

    /**
     * Draw a circle.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The position of the center on the x axis.
     * @param y - The position of the center on the y axis.
     * @param r - The radius of the circle.
     */
    function drawCircle(ctx, x, y, r) {
        ctx.beginPath();
        ctx.arc(x, y, r, 0, 2 * Math.PI, false);
        ctx.closePath();
    }
    /**
     * Draw a square.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The position of the center on the x axis.
     * @param y - The position of the center on the y axis.
     * @param r - Half of the width and height of the square.
     */

    function drawSquare(ctx, x, y, r) {
        ctx.beginPath();
        ctx.rect(x - r, y - r, r * 2, r * 2);
        ctx.closePath();
    }
    /**
     * Draw an equilateral triangle standing on a side.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The position of the center on the x axis.
     * @param y - The position of the center on the y axis.
     * @param r - Half of the length of the sides.
     *
     * @remarks
     * http://en.wikipedia.org/wiki/Equilateral_triangle
     */

    function drawTriangle(ctx, x, y, r) {
        ctx.beginPath(); // the change in radius and the offset is here to center the shape

        r *= 1.15;
        y += 0.275 * r;
        var s = r * 2;
        var s2 = s / 2;
        var ir = Math.sqrt(3) / 6 * s; // radius of inner circle

        var h = Math.sqrt(s * s - s2 * s2); // height

        ctx.moveTo(x, y - (h - ir));
        ctx.lineTo(x + s2, y + ir);
        ctx.lineTo(x - s2, y + ir);
        ctx.lineTo(x, y - (h - ir));
        ctx.closePath();
    }
    /**
     * Draw an equilateral triangle standing on a vertex.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The position of the center on the x axis.
     * @param y - The position of the center on the y axis.
     * @param r - Half of the length of the sides.
     *
     * @remarks
     * http://en.wikipedia.org/wiki/Equilateral_triangle
     */

    function drawTriangleDown(ctx, x, y, r) {
        ctx.beginPath(); // the change in radius and the offset is here to center the shape

        r *= 1.15;
        y -= 0.275 * r;
        var s = r * 2;
        var s2 = s / 2;
        var ir = Math.sqrt(3) / 6 * s; // radius of inner circle

        var h = Math.sqrt(s * s - s2 * s2); // height

        ctx.moveTo(x, y + (h - ir));
        ctx.lineTo(x + s2, y - ir);
        ctx.lineTo(x - s2, y - ir);
        ctx.lineTo(x, y + (h - ir));
        ctx.closePath();
    }
    /**
     * Draw a star.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The position of the center on the x axis.
     * @param y - The position of the center on the y axis.
     * @param r - The outer radius of the star.
     */

    function drawStar(ctx, x, y, r) {
        // http://www.html5canvastutorials.com/labs/html5-canvas-star-spinner/
        ctx.beginPath(); // the change in radius and the offset is here to center the shape

        r *= 0.82;
        y += 0.1 * r;

        for (var n = 0; n < 10; n++) {
            var radius = n % 2 === 0 ? r * 1.3 : r * 0.5;
            ctx.lineTo(x + radius * Math.sin(n * 2 * Math.PI / 10), y - radius * Math.cos(n * 2 * Math.PI / 10));
        }

        ctx.closePath();
    }
    /**
     * Draw a diamond.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The position of the center on the x axis.
     * @param y - The position of the center on the y axis.
     * @param r - Half of the width and height of the diamond.
     *
     * @remarks
     * http://www.html5canvastutorials.com/labs/html5-canvas-star-spinner/
     */

    function drawDiamond(ctx, x, y, r) {
        ctx.beginPath();
        ctx.lineTo(x, y + r);
        ctx.lineTo(x + r, y);
        ctx.lineTo(x, y - r);
        ctx.lineTo(x - r, y);
        ctx.closePath();
    }
    /**
     * Draw a rectangle with rounded corners.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The position of the center on the x axis.
     * @param y - The position of the center on the y axis.
     * @param w - The width of the rectangle.
     * @param h - The height of the rectangle.
     * @param r - The radius of the corners.
     *
     * @remarks
     * http://stackoverflow.com/questions/1255512/how-to-draw-a-rounded-rectangle-on-html-canvas
     */

    function drawRoundRect(ctx, x, y, w, h, r) {
        var r2d = Math.PI / 180;

        if (w - 2 * r < 0) {
            r = w / 2;
        } //ensure that the radius isn't too large for x


        if (h - 2 * r < 0) {
            r = h / 2;
        } //ensure that the radius isn't too large for y


        ctx.beginPath();
        ctx.moveTo(x + r, y);
        ctx.lineTo(x + w - r, y);
        ctx.arc(x + w - r, y + r, r, r2d * 270, r2d * 360, false);
        ctx.lineTo(x + w, y + h - r);
        ctx.arc(x + w - r, y + h - r, r, 0, r2d * 90, false);
        ctx.lineTo(x + r, y + h);
        ctx.arc(x + r, y + h - r, r, r2d * 90, r2d * 180, false);
        ctx.lineTo(x, y + r);
        ctx.arc(x + r, y + r, r, r2d * 180, r2d * 270, false);
        ctx.closePath();
    }
    /**
     * Draw an ellipse.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The position of the center on the x axis.
     * @param y - The position of the center on the y axis.
     * @param w - The width of the ellipse.
     * @param h - The height of the ellipse.
     *
     * @remarks
     * http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas
     *
     * Postfix '_vis' added to discern it from standard method ellipse().
     */

    function drawEllipse(ctx, x, y, w, h) {
        var kappa = 0.5522848,
            ox = w / 2 * kappa,
            // control point offset horizontal
            oy = h / 2 * kappa,
            // control point offset vertical
            xe = x + w,
            // x-end
            ye = y + h,
            // y-end
            xm = x + w / 2,
            // x-middle
            ym = y + h / 2; // y-middle

        ctx.beginPath();
        ctx.moveTo(x, ym);
        ctx.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
        ctx.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
        ctx.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
        ctx.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
        ctx.closePath();
    }
    /**
     * Draw an isometric cylinder.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The position of the center on the x axis.
     * @param y - The position of the center on the y axis.
     * @param w - The width of the database.
     * @param h - The height of the database.
     *
     * @remarks
     * http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas
     */

    function drawDatabase(ctx, x, y, w, h) {
        var f = 1 / 3;
        var wEllipse = w;
        var hEllipse = h * f;
        var kappa = 0.5522848,
            ox = wEllipse / 2 * kappa,
            // control point offset horizontal
            oy = hEllipse / 2 * kappa,
            // control point offset vertical
            xe = x + wEllipse,
            // x-end
            ye = y + hEllipse,
            // y-end
            xm = x + wEllipse / 2,
            // x-middle
            ym = y + hEllipse / 2,
            // y-middle
            ymb = y + (h - hEllipse / 2),
            // y-midlle, bottom ellipse
            yeb = y + h; // y-end, bottom ellipse

        ctx.beginPath();
        ctx.moveTo(xe, ym);
        ctx.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
        ctx.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
        ctx.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
        ctx.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
        ctx.lineTo(xe, ymb);
        ctx.bezierCurveTo(xe, ymb + oy, xm + ox, yeb, xm, yeb);
        ctx.bezierCurveTo(xm - ox, yeb, x, ymb + oy, x, ymb);
        ctx.lineTo(x, ym);
    }
    /**
     * Draw a dashed line.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The start position on the x axis.
     * @param y - The start position on the y axis.
     * @param x2 - The end position on the x axis.
     * @param y2 - The end position on the y axis.
     * @param pattern - List of lengths starting with line and then alternating between space and line.
     *
     * @author David Jordan
     * @remarks
     * date 2012-08-08
     * http://stackoverflow.com/questions/4576724/dotted-stroke-in-canvas
     */

    function drawDashedLine(ctx, x, y, x2, y2, pattern) {
        ctx.beginPath();
        ctx.moveTo(x, y);
        var patternLength = pattern.length;
        var dx = x2 - x;
        var dy = y2 - y;
        var slope = dy / dx;
        var distRemaining = Math.sqrt(dx * dx + dy * dy);
        var patternIndex = 0;
        var draw = true;
        var xStep = 0;
        var dashLength = +pattern[0];

        while (distRemaining >= 0.1) {
            dashLength = +pattern[patternIndex++ % patternLength];

            if (dashLength > distRemaining) {
                dashLength = distRemaining;
            }

            xStep = Math.sqrt(dashLength * dashLength / (1 + slope * slope));
            xStep = dx < 0 ? -xStep : xStep;
            x += xStep;
            y += slope * xStep;

            if (draw === true) {
                ctx.lineTo(x, y);
            } else {
                ctx.moveTo(x, y);
            }

            distRemaining -= dashLength;
            draw = !draw;
        }
    }
    /**
     * Draw a hexagon.
     *
     * @param ctx - The context this shape will be rendered to.
     * @param x - The position of the center on the x axis.
     * @param y - The position of the center on the y axis.
     * @param r - The radius of the hexagon.
     */

    function drawHexagon(ctx, x, y, r) {
        ctx.beginPath();
        var sides = 6;
        var a = Math.PI * 2 / sides;
        ctx.moveTo(x + r, y);

        for (var i = 1; i < sides; i++) {
            ctx.lineTo(x + r * Math.cos(a * i), y + r * Math.sin(a * i));
        }

        ctx.closePath();
    }
    var shapeMap = {
        circle: drawCircle,
        dashedLine: drawDashedLine,
        database: drawDatabase,
        diamond: drawDiamond,
        ellipse: drawEllipse,
        ellipse_vis: drawEllipse,
        hexagon: drawHexagon,
        roundRect: drawRoundRect,
        square: drawSquare,
        star: drawStar,
        triangle: drawTriangle,
        triangleDown: drawTriangleDown
    };
    /**
     * Returns either custom or native drawing function base on supplied name.
     *
     * @param name - The name of the function. Either the name of a
     * CanvasRenderingContext2D property or an export from shapes.ts without the
     * draw prefix.
     *
     * @returns The function that can be used for rendering. In case of native
     * CanvasRenderingContext2D function the API is normalized to
     * `(ctx: CanvasRenderingContext2D, ...originalArgs) => void`.
     */

    function getShape(name) {
        if (Object.prototype.hasOwnProperty.call(shapeMap, name)) {
            return shapeMap[name];
        } else {
            return function (ctx) {
                for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = arguments[_key];
                }

                CanvasRenderingContext2D.prototype[name].call(ctx, args);
            };
        }
    }

    function styleInject(css, ref) {
        if (ref === void 0) ref = {};
        var insertAt = ref.insertAt;

        if (!css || typeof document === 'undefined') {
            return;
        }

        var head = document.head || document.getElementsByTagName('head')[0];
        var style = document.createElement('style');
        style.type = 'text/css';

        if (insertAt === 'top') {
            if (head.firstChild) {
                head.insertBefore(style, head.firstChild);
            } else {
                head.appendChild(style);
            }
        } else {
            head.appendChild(style);
        }

        if (style.styleSheet) {
            style.styleSheet.cssText = css;
        } else {
            style.appendChild(document.createTextNode(css));
        }
    }

    var css_248z$6 = ".vis-overlay {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n\n  /* Must be displayed above for example selected Timeline items */\n  z-index: 10;\n}\n\n.vis-active {\n  box-shadow: 0 0 10px #86d5f8;\n}\n";
    styleInject(css_248z$6);

    var css_248z$5 = "/* override some bootstrap styles screwing up the timelines css */\n\n.vis [class*=\"span\"] {\n  min-height: 0;\n  width: auto;\n}\n";
    styleInject(css_248z$5);

    var css_248z$4 = "div.vis-color-picker {\n  position: absolute;\n  top: 0px;\n  left: 30px;\n  margin-top: -140px;\n  margin-left: 30px;\n  width: 310px;\n  height: 444px;\n  z-index: 1;\n  padding: 10px;\n  border-radius: 15px;\n  background-color: #ffffff;\n  display: none;\n  box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 10px 0px;\n}\n\ndiv.vis-color-picker div.vis-arrow {\n  position: absolute;\n  top: 147px;\n  left: 5px;\n}\n\ndiv.vis-color-picker div.vis-arrow::after,\ndiv.vis-color-picker div.vis-arrow::before {\n  right: 100%;\n  top: 50%;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n\ndiv.vis-color-picker div.vis-arrow:after {\n  border-color: rgba(255, 255, 255, 0);\n  border-right-color: #ffffff;\n  border-width: 30px;\n  margin-top: -30px;\n}\n\ndiv.vis-color-picker div.vis-color {\n  position: absolute;\n  width: 289px;\n  height: 289px;\n  cursor: pointer;\n}\n\ndiv.vis-color-picker div.vis-brightness {\n  position: absolute;\n  top: 313px;\n}\n\ndiv.vis-color-picker div.vis-opacity {\n  position: absolute;\n  top: 350px;\n}\n\ndiv.vis-color-picker div.vis-selector {\n  position: absolute;\n  top: 137px;\n  left: 137px;\n  width: 15px;\n  height: 15px;\n  border-radius: 15px;\n  border: 1px solid #ffffff;\n  background: #4c4c4c; /* Old browsers */\n  background: -moz-linear-gradient(\n    top,\n    #4c4c4c 0%,\n    #595959 12%,\n    #666666 25%,\n    #474747 39%,\n    #2c2c2c 50%,\n    #000000 51%,\n    #111111 60%,\n    #2b2b2b 76%,\n    #1c1c1c 91%,\n    #131313 100%\n  ); /* FF3.6+ */\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0%, #4c4c4c),\n    color-stop(12%, #595959),\n    color-stop(25%, #666666),\n    color-stop(39%, #474747),\n    color-stop(50%, #2c2c2c),\n    color-stop(51%, #000000),\n    color-stop(60%, #111111),\n    color-stop(76%, #2b2b2b),\n    color-stop(91%, #1c1c1c),\n    color-stop(100%, #131313)\n  ); /* Chrome,Safari4+ */\n  background: -webkit-linear-gradient(\n    top,\n    #4c4c4c 0%,\n    #595959 12%,\n    #666666 25%,\n    #474747 39%,\n    #2c2c2c 50%,\n    #000000 51%,\n    #111111 60%,\n    #2b2b2b 76%,\n    #1c1c1c 91%,\n    #131313 100%\n  ); /* Chrome10+,Safari5.1+ */\n  background: -o-linear-gradient(\n    top,\n    #4c4c4c 0%,\n    #595959 12%,\n    #666666 25%,\n    #474747 39%,\n    #2c2c2c 50%,\n    #000000 51%,\n    #111111 60%,\n    #2b2b2b 76%,\n    #1c1c1c 91%,\n    #131313 100%\n  ); /* Opera 11.10+ */\n  background: -ms-linear-gradient(\n    top,\n    #4c4c4c 0%,\n    #595959 12%,\n    #666666 25%,\n    #474747 39%,\n    #2c2c2c 50%,\n    #000000 51%,\n    #111111 60%,\n    #2b2b2b 76%,\n    #1c1c1c 91%,\n    #131313 100%\n  ); /* IE10+ */\n  background: linear-gradient(\n    to bottom,\n    #4c4c4c 0%,\n    #595959 12%,\n    #666666 25%,\n    #474747 39%,\n    #2c2c2c 50%,\n    #000000 51%,\n    #111111 60%,\n    #2b2b2b 76%,\n    #1c1c1c 91%,\n    #131313 100%\n  ); /* W3C */\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4c4c4c', endColorstr='#131313',GradientType=0 ); /* IE6-9 */\n}\n\ndiv.vis-color-picker div.vis-new-color {\n  position: absolute;\n  width: 140px;\n  height: 20px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 5px;\n  top: 380px;\n  left: 159px;\n  text-align: right;\n  padding-right: 2px;\n  font-size: 10px;\n  color: rgba(0, 0, 0, 0.4);\n  vertical-align: middle;\n  line-height: 20px;\n}\n\ndiv.vis-color-picker div.vis-initial-color {\n  position: absolute;\n  width: 140px;\n  height: 20px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 5px;\n  top: 380px;\n  left: 10px;\n  text-align: left;\n  padding-left: 2px;\n  font-size: 10px;\n  color: rgba(0, 0, 0, 0.4);\n  vertical-align: middle;\n  line-height: 20px;\n}\n\ndiv.vis-color-picker div.vis-label {\n  position: absolute;\n  width: 300px;\n  left: 10px;\n}\n\ndiv.vis-color-picker div.vis-label.vis-brightness {\n  top: 300px;\n}\n\ndiv.vis-color-picker div.vis-label.vis-opacity {\n  top: 338px;\n}\n\ndiv.vis-color-picker div.vis-button {\n  position: absolute;\n  width: 68px;\n  height: 25px;\n  border-radius: 10px;\n  vertical-align: middle;\n  text-align: center;\n  line-height: 25px;\n  top: 410px;\n  border: 2px solid #d9d9d9;\n  background-color: #f7f7f7;\n  cursor: pointer;\n}\n\ndiv.vis-color-picker div.vis-button.vis-cancel {\n  /*border:2px solid #ff4e33;*/\n  /*background-color: #ff7761;*/\n  left: 5px;\n}\ndiv.vis-color-picker div.vis-button.vis-load {\n  /*border:2px solid #a153e6;*/\n  /*background-color: #cb8dff;*/\n  left: 82px;\n}\ndiv.vis-color-picker div.vis-button.vis-apply {\n  /*border:2px solid #4588e6;*/\n  /*background-color: #82b6ff;*/\n  left: 159px;\n}\ndiv.vis-color-picker div.vis-button.vis-save {\n  /*border:2px solid #45e655;*/\n  /*background-color: #6dff7c;*/\n  left: 236px;\n}\n\ndiv.vis-color-picker input.vis-range {\n  width: 290px;\n  height: 20px;\n}\n\n/* TODO: is this redundant?\ndiv.vis-color-picker input.vis-range-brightness {\n  width: 289px !important;\n}\n\n\ndiv.vis-color-picker input.vis-saturation-range {\n  width: 289px !important;\n}*/\n";
    styleInject(css_248z$4);

    var css_248z$3 = "div.vis-configuration {\n  position: relative;\n  display: block;\n  float: left;\n  font-size: 12px;\n}\n\ndiv.vis-configuration-wrapper {\n  display: block;\n  width: 700px;\n}\n\ndiv.vis-configuration-wrapper::after {\n  clear: both;\n  content: \"\";\n  display: block;\n}\n\ndiv.vis-configuration.vis-config-option-container {\n  display: block;\n  width: 495px;\n  background-color: #ffffff;\n  border: 2px solid #f7f8fa;\n  border-radius: 4px;\n  margin-top: 20px;\n  left: 10px;\n  padding-left: 5px;\n}\n\ndiv.vis-configuration.vis-config-button {\n  display: block;\n  width: 495px;\n  height: 25px;\n  vertical-align: middle;\n  line-height: 25px;\n  background-color: #f7f8fa;\n  border: 2px solid #ceced0;\n  border-radius: 4px;\n  margin-top: 20px;\n  left: 10px;\n  padding-left: 5px;\n  cursor: pointer;\n  margin-bottom: 30px;\n}\n\ndiv.vis-configuration.vis-config-button.hover {\n  background-color: #4588e6;\n  border: 2px solid #214373;\n  color: #ffffff;\n}\n\ndiv.vis-configuration.vis-config-item {\n  display: block;\n  float: left;\n  width: 495px;\n  height: 25px;\n  vertical-align: middle;\n  line-height: 25px;\n}\n\ndiv.vis-configuration.vis-config-item.vis-config-s2 {\n  left: 10px;\n  background-color: #f7f8fa;\n  padding-left: 5px;\n  border-radius: 3px;\n}\ndiv.vis-configuration.vis-config-item.vis-config-s3 {\n  left: 20px;\n  background-color: #e4e9f0;\n  padding-left: 5px;\n  border-radius: 3px;\n}\ndiv.vis-configuration.vis-config-item.vis-config-s4 {\n  left: 30px;\n  background-color: #cfd8e6;\n  padding-left: 5px;\n  border-radius: 3px;\n}\n\ndiv.vis-configuration.vis-config-header {\n  font-size: 18px;\n  font-weight: bold;\n}\n\ndiv.vis-configuration.vis-config-label {\n  width: 120px;\n  height: 25px;\n  line-height: 25px;\n}\n\ndiv.vis-configuration.vis-config-label.vis-config-s3 {\n  width: 110px;\n}\ndiv.vis-configuration.vis-config-label.vis-config-s4 {\n  width: 100px;\n}\n\ndiv.vis-configuration.vis-config-colorBlock {\n  top: 1px;\n  width: 30px;\n  height: 19px;\n  border: 1px solid #444444;\n  border-radius: 2px;\n  padding: 0px;\n  margin: 0px;\n  cursor: pointer;\n}\n\ninput.vis-configuration.vis-config-checkbox {\n  left: -5px;\n}\n\ninput.vis-configuration.vis-config-rangeinput {\n  position: relative;\n  top: -5px;\n  width: 60px;\n  /*height:13px;*/\n  padding: 1px;\n  margin: 0;\n  pointer-events: none;\n}\n\ninput.vis-configuration.vis-config-range {\n  /*removes default webkit styles*/\n  -webkit-appearance: none;\n\n  /*fix for FF unable to apply focus style bug */\n  border: 0px solid white;\n  background-color: rgba(0, 0, 0, 0);\n\n  /*required for proper track sizing in FF*/\n  width: 300px;\n  height: 20px;\n}\ninput.vis-configuration.vis-config-range::-webkit-slider-runnable-track {\n  width: 300px;\n  height: 5px;\n  background: #dedede; /* Old browsers */\n  background: -moz-linear-gradient(top, #dedede 0%, #c8c8c8 99%); /* FF3.6+ */\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0%, #dedede),\n    color-stop(99%, #c8c8c8)\n  ); /* Chrome,Safari4+ */\n  background: -webkit-linear-gradient(\n    top,\n    #dedede 0%,\n    #c8c8c8 99%\n  ); /* Chrome10+,Safari5.1+ */\n  background: -o-linear-gradient(\n    top,\n    #dedede 0%,\n    #c8c8c8 99%\n  ); /* Opera 11.10+ */\n  background: -ms-linear-gradient(top, #dedede 0%, #c8c8c8 99%); /* IE10+ */\n  background: linear-gradient(to bottom, #dedede 0%, #c8c8c8 99%); /* W3C */\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#dedede', endColorstr='#c8c8c8',GradientType=0 ); /* IE6-9 */\n\n  border: 1px solid #999999;\n  box-shadow: #aaaaaa 0px 0px 3px 0px;\n  border-radius: 3px;\n}\ninput.vis-configuration.vis-config-range::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  border: 1px solid #14334b;\n  height: 17px;\n  width: 17px;\n  border-radius: 50%;\n  background: #3876c2; /* Old browsers */\n  background: -moz-linear-gradient(top, #3876c2 0%, #385380 100%); /* FF3.6+ */\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0%, #3876c2),\n    color-stop(100%, #385380)\n  ); /* Chrome,Safari4+ */\n  background: -webkit-linear-gradient(\n    top,\n    #3876c2 0%,\n    #385380 100%\n  ); /* Chrome10+,Safari5.1+ */\n  background: -o-linear-gradient(\n    top,\n    #3876c2 0%,\n    #385380 100%\n  ); /* Opera 11.10+ */\n  background: -ms-linear-gradient(top, #3876c2 0%, #385380 100%); /* IE10+ */\n  background: linear-gradient(to bottom, #3876c2 0%, #385380 100%); /* W3C */\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#3876c2', endColorstr='#385380',GradientType=0 ); /* IE6-9 */\n  box-shadow: #111927 0px 0px 1px 0px;\n  margin-top: -7px;\n}\ninput.vis-configuration.vis-config-range:focus {\n  outline: none;\n}\ninput.vis-configuration.vis-config-range:focus::-webkit-slider-runnable-track {\n  background: #9d9d9d; /* Old browsers */\n  background: -moz-linear-gradient(top, #9d9d9d 0%, #c8c8c8 99%); /* FF3.6+ */\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0%, #9d9d9d),\n    color-stop(99%, #c8c8c8)\n  ); /* Chrome,Safari4+ */\n  background: -webkit-linear-gradient(\n    top,\n    #9d9d9d 0%,\n    #c8c8c8 99%\n  ); /* Chrome10+,Safari5.1+ */\n  background: -o-linear-gradient(\n    top,\n    #9d9d9d 0%,\n    #c8c8c8 99%\n  ); /* Opera 11.10+ */\n  background: -ms-linear-gradient(top, #9d9d9d 0%, #c8c8c8 99%); /* IE10+ */\n  background: linear-gradient(to bottom, #9d9d9d 0%, #c8c8c8 99%); /* W3C */\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#9d9d9d', endColorstr='#c8c8c8',GradientType=0 ); /* IE6-9 */\n}\n\ninput.vis-configuration.vis-config-range::-moz-range-track {\n  width: 300px;\n  height: 10px;\n  background: #dedede; /* Old browsers */\n  background: -moz-linear-gradient(top, #dedede 0%, #c8c8c8 99%); /* FF3.6+ */\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0%, #dedede),\n    color-stop(99%, #c8c8c8)\n  ); /* Chrome,Safari4+ */\n  background: -webkit-linear-gradient(\n    top,\n    #dedede 0%,\n    #c8c8c8 99%\n  ); /* Chrome10+,Safari5.1+ */\n  background: -o-linear-gradient(\n    top,\n    #dedede 0%,\n    #c8c8c8 99%\n  ); /* Opera 11.10+ */\n  background: -ms-linear-gradient(top, #dedede 0%, #c8c8c8 99%); /* IE10+ */\n  background: linear-gradient(to bottom, #dedede 0%, #c8c8c8 99%); /* W3C */\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#dedede', endColorstr='#c8c8c8',GradientType=0 ); /* IE6-9 */\n\n  border: 1px solid #999999;\n  box-shadow: #aaaaaa 0px 0px 3px 0px;\n  border-radius: 3px;\n}\ninput.vis-configuration.vis-config-range::-moz-range-thumb {\n  border: none;\n  height: 16px;\n  width: 16px;\n\n  border-radius: 50%;\n  background: #385380;\n}\n\n/*hide the outline behind the border*/\ninput.vis-configuration.vis-config-range:-moz-focusring {\n  outline: 1px solid white;\n  outline-offset: -1px;\n}\n\ninput.vis-configuration.vis-config-range::-ms-track {\n  width: 300px;\n  height: 5px;\n\n  /*remove bg colour from the track, we'll use ms-fill-lower and ms-fill-upper instead */\n  background: transparent;\n\n  /*leave room for the larger thumb to overflow with a transparent border */\n  border-color: transparent;\n  border-width: 6px 0;\n\n  /*remove default tick marks*/\n  color: transparent;\n}\ninput.vis-configuration.vis-config-range::-ms-fill-lower {\n  background: #777;\n  border-radius: 10px;\n}\ninput.vis-configuration.vis-config-range::-ms-fill-upper {\n  background: #ddd;\n  border-radius: 10px;\n}\ninput.vis-configuration.vis-config-range::-ms-thumb {\n  border: none;\n  height: 16px;\n  width: 16px;\n  border-radius: 50%;\n  background: #385380;\n}\ninput.vis-configuration.vis-config-range:focus::-ms-fill-lower {\n  background: #888;\n}\ninput.vis-configuration.vis-config-range:focus::-ms-fill-upper {\n  background: #ccc;\n}\n\n.vis-configuration-popup {\n  position: absolute;\n  background: rgba(57, 76, 89, 0.85);\n  border: 2px solid #f2faff;\n  line-height: 30px;\n  height: 30px;\n  width: 150px;\n  text-align: center;\n  color: #ffffff;\n  font-size: 14px;\n  border-radius: 4px;\n  -webkit-transition: opacity 0.3s ease-in-out;\n  -moz-transition: opacity 0.3s ease-in-out;\n  transition: opacity 0.3s ease-in-out;\n}\n.vis-configuration-popup:after,\n.vis-configuration-popup:before {\n  left: 100%;\n  top: 50%;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n\n.vis-configuration-popup:after {\n  border-color: rgba(136, 183, 213, 0);\n  border-left-color: rgba(57, 76, 89, 0.85);\n  border-width: 8px;\n  margin-top: -8px;\n}\n.vis-configuration-popup:before {\n  border-color: rgba(194, 225, 245, 0);\n  border-left-color: #f2faff;\n  border-width: 12px;\n  margin-top: -12px;\n}\n";
    styleInject(css_248z$3);

    var css_248z$2 = "div.vis-tooltip {\n  position: absolute;\n  visibility: hidden;\n  padding: 5px;\n  white-space: nowrap;\n\n  font-family: verdana;\n  font-size: 14px;\n  color: #000000;\n  background-color: #f5f4ed;\n\n  -moz-border-radius: 3px;\n  -webkit-border-radius: 3px;\n  border-radius: 3px;\n  border: 1px solid #808074;\n\n  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.2);\n  pointer-events: none;\n\n  z-index: 5;\n}\n";
    styleInject(css_248z$2);

    var componentEmitter = createCommonjsModule(function (module) {
        /**
         * Expose `Emitter`.
         */
        {
            module.exports = Emitter;
        }
        /**
         * Initialize a new `Emitter`.
         *
         * @api public
         */


        function Emitter(obj) {
            if (obj) return mixin(obj);
        }
        /**
         * Mixin the emitter properties.
         *
         * @param {Object} obj
         * @return {Object}
         * @api private
         */

        function mixin(obj) {
            for (var key in Emitter.prototype) {
                obj[key] = Emitter.prototype[key];
            }

            return obj;
        }
        /**
         * Listen on the given `event` with `fn`.
         *
         * @param {String} event
         * @param {Function} fn
         * @return {Emitter}
         * @api public
         */


        Emitter.prototype.on = Emitter.prototype.addEventListener = function (event, fn) {
            this._callbacks = this._callbacks || {};
            (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
            return this;
        };
        /**
         * Adds an `event` listener that will be invoked a single
         * time then automatically removed.
         *
         * @param {String} event
         * @param {Function} fn
         * @return {Emitter}
         * @api public
         */


        Emitter.prototype.once = function (event, fn) {
            function on() {
                this.off(event, on);
                fn.apply(this, arguments);
            }

            on.fn = fn;
            this.on(event, on);
            return this;
        };
        /**
         * Remove the given callback for `event` or all
         * registered callbacks.
         *
         * @param {String} event
         * @param {Function} fn
         * @return {Emitter}
         * @api public
         */


        Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function (event, fn) {
            this._callbacks = this._callbacks || {}; // all

            if (0 == arguments.length) {
                this._callbacks = {};
                return this;
            } // specific event


            var callbacks = this._callbacks['$' + event];
            if (!callbacks) return this; // remove all handlers

            if (1 == arguments.length) {
                delete this._callbacks['$' + event];
                return this;
            } // remove specific handler


            var cb;

            for (var i = 0; i < callbacks.length; i++) {
                cb = callbacks[i];

                if (cb === fn || cb.fn === fn) {
                    callbacks.splice(i, 1);
                    break;
                }
            } // Remove event specific arrays for event types that no
            // one is subscribed for to avoid memory leak.


            if (callbacks.length === 0) {
                delete this._callbacks['$' + event];
            }

            return this;
        };
        /**
         * Emit `event` with the given args.
         *
         * @param {String} event
         * @param {Mixed} ...
         * @return {Emitter}
         */


        Emitter.prototype.emit = function (event) {
            this._callbacks = this._callbacks || {};
            var args = new Array(arguments.length - 1),
                callbacks = this._callbacks['$' + event];

            for (var i = 1; i < arguments.length; i++) {
                args[i - 1] = arguments[i];
            }

            if (callbacks) {
                callbacks = callbacks.slice(0);

                for (var i = 0, len = callbacks.length; i < len; ++i) {
                    callbacks[i].apply(this, args);
                }
            }

            return this;
        };
        /**
         * Return array of callbacks for `event`.
         *
         * @param {String} event
         * @return {Array}
         * @api public
         */


        Emitter.prototype.listeners = function (event) {
            this._callbacks = this._callbacks || {};
            return this._callbacks['$' + event] || [];
        };
        /**
         * Check if this emitter has `event` handlers.
         *
         * @param {String} event
         * @return {Boolean}
         * @api public
         */


        Emitter.prototype.hasListeners = function (event) {
            return !!this.listeners(event).length;
        };
    });

    var createMethod$4 = function (CONVERT_TO_STRING) {
        return function ($this, pos) {
            var S = String(requireObjectCoercible($this));
            var position = toInteger(pos);
            var size = S.length;
            var first, second;
            if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
            first = S.charCodeAt(position);
            return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
        };
    };

    var stringMultibyte = {
        // `String.prototype.codePointAt` method
        // https://tc39.es/ecma262/#sec-string.prototype.codepointat
        codeAt: createMethod$4(false),
        // `String.prototype.at` method
        // https://github.com/mathiasbynens/String.prototype.at
        charAt: createMethod$4(true)
    };

    var setGlobal = function (key, value) {
        try {
            createNonEnumerableProperty(global$1, key, value);
        } catch (error) {
            global$1[key] = value;
        }

        return value;
    };

    var SHARED = '__core-js_shared__';
    var store$1 = global$1[SHARED] || setGlobal(SHARED, {});
    var sharedStore = store$1;

    var functionToString = Function.toString; // this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper

    if (typeof sharedStore.inspectSource != 'function') {
        sharedStore.inspectSource = function (it) {
            return functionToString.call(it);
        };
    }

    var inspectSource = sharedStore.inspectSource;

    var WeakMap$1 = global$1.WeakMap;
    var nativeWeakMap = typeof WeakMap$1 === 'function' && /native code/.test(inspectSource(WeakMap$1));

    var shared = createCommonjsModule(function (module) {
        (module.exports = function (key, value) {
            return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
        })('versions', []).push({
            version: '3.9.1',
            mode: 'pure' ,
            copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
        });
    });

    var id$1 = 0;
    var postfix = Math.random();

    var uid = function (key) {
        return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id$1 + postfix).toString(36);
    };

    var keys$6 = shared('keys');

    var sharedKey = function (key) {
        return keys$6[key] || (keys$6[key] = uid(key));
    };

    var WeakMap = global$1.WeakMap;
    var set$3, get$4, has;

    var enforce = function (it) {
        return has(it) ? get$4(it) : set$3(it, {});
    };

    var getterFor = function (TYPE) {
        return function (it) {
            var state;

            if (!isObject$1(it) || (state = get$4(it)).type !== TYPE) {
                throw TypeError('Incompatible receiver, ' + TYPE + ' required');
            }

            return state;
        };
    };

    if (nativeWeakMap) {
        var store = sharedStore.state || (sharedStore.state = new WeakMap());
        var wmget = store.get;
        var wmhas = store.has;
        var wmset = store.set;

        set$3 = function (it, metadata) {
            metadata.facade = it;
            wmset.call(store, it, metadata);
            return metadata;
        };

        get$4 = function (it) {
            return wmget.call(store, it) || {};
        };

        has = function (it) {
            return wmhas.call(store, it);
        };
    } else {
        var STATE = sharedKey('state');
        hiddenKeys$1[STATE] = true;

        set$3 = function (it, metadata) {
            metadata.facade = it;
            createNonEnumerableProperty(it, STATE, metadata);
            return metadata;
        };

        get$4 = function (it) {
            return has$1(it, STATE) ? it[STATE] : {};
        };

        has = function (it) {
            return has$1(it, STATE);
        };
    }

    var internalState = {
        set: set$3,
        get: get$4,
        has: has,
        enforce: enforce,
        getterFor: getterFor
    };

    var correctPrototypeGetter = !fails(function () {
        function F() {
            /* empty */
        }

        F.prototype.constructor = null;
        return Object.getPrototypeOf(new F()) !== F.prototype;
    });

    var IE_PROTO$1 = sharedKey('IE_PROTO');
    var ObjectPrototype$1 = Object.prototype; // `Object.getPrototypeOf` method
    // https://tc39.es/ecma262/#sec-object.getprototypeof

    var objectGetPrototypeOf = correctPrototypeGetter ? Object.getPrototypeOf : function (O) {
        O = toObject(O);
        if (has$1(O, IE_PROTO$1)) return O[IE_PROTO$1];

        if (typeof O.constructor == 'function' && O instanceof O.constructor) {
            return O.constructor.prototype;
        }

        return O instanceof Object ? ObjectPrototype$1 : null;
    };

    var engineIsNode = classofRaw(global$1.process) == 'process';

    var aFunction = function (variable) {
        return typeof variable == 'function' ? variable : undefined;
    };

    var getBuiltIn = function (namespace, method) {
        return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global$1[namespace]) : path[namespace] && path[namespace][method] || global$1[namespace] && global$1[namespace][method];
    };

    var engineUserAgent = getBuiltIn('navigator', 'userAgent') || '';

    var process = global$1.process;
    var versions = process && process.versions;
    var v8 = versions && versions.v8;
    var match, version;

    if (v8) {
        match = v8.split('.');
        version = match[0] + match[1];
    } else if (engineUserAgent) {
        match = engineUserAgent.match(/Edge\/(\d+)/);

        if (!match || match[1] >= 74) {
            match = engineUserAgent.match(/Chrome\/(\d+)/);
            if (match) version = match[1];
        }
    }

    var engineV8Version = version && +version;

    var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function () {
        /* global Symbol -- required for testing */
        return !Symbol.sham && ( // Chrome 38 Symbol has incorrect toString conversion
            // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
            engineIsNode ? engineV8Version === 38 : engineV8Version > 37 && engineV8Version < 41);
    });

    var useSymbolAsUid = nativeSymbol
        /* global Symbol -- safe */
        && !Symbol.sham && typeof Symbol.iterator == 'symbol';

    var WellKnownSymbolsStore$1 = shared('wks');
    var Symbol$1 = global$1.Symbol;
    var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

    var wellKnownSymbol = function (name) {
        if (!has$1(WellKnownSymbolsStore$1, name) || !(nativeSymbol || typeof WellKnownSymbolsStore$1[name] == 'string')) {
            if (nativeSymbol && has$1(Symbol$1, name)) {
                WellKnownSymbolsStore$1[name] = Symbol$1[name];
            } else {
                WellKnownSymbolsStore$1[name] = createWellKnownSymbol('Symbol.' + name);
            }
        }

        return WellKnownSymbolsStore$1[name];
    };

    var ITERATOR$5 = wellKnownSymbol('iterator');
    var BUGGY_SAFARI_ITERATORS$1 = false;

    var returnThis$2 = function () {
        return this;
    }; // `%IteratorPrototype%` object
    // https://tc39.es/ecma262/#sec-%iteratorprototype%-object


    var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

    if ([].keys) {
        arrayIterator = [].keys(); // Safari 8 has buggy iterators w/o `next`

        if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;else {
            PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
            if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
        }
    }

    var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == undefined || fails(function () {
        var test = {}; // FF44- legacy iterators case

        return IteratorPrototype$2[ITERATOR$5].call(test) !== test;
    });
    if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {}; // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()

    if ((NEW_ITERATOR_PROTOTYPE) && !has$1(IteratorPrototype$2, ITERATOR$5)) {
        createNonEnumerableProperty(IteratorPrototype$2, ITERATOR$5, returnThis$2);
    }

    var iteratorsCore = {
        IteratorPrototype: IteratorPrototype$2,
        BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
    };

    // https://tc39.es/ecma262/#sec-object.defineproperties

    var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
        anObject(O);
        var keys = objectKeys(Properties);
        var length = keys.length;
        var index = 0;
        var key;

        while (length > index) objectDefineProperty.f(O, key = keys[index++], Properties[key]);

        return O;
    };

    var html = getBuiltIn('document', 'documentElement');

    var GT = '>';
    var LT = '<';
    var PROTOTYPE$1 = 'prototype';
    var SCRIPT = 'script';
    var IE_PROTO = sharedKey('IE_PROTO');

    var EmptyConstructor = function () {
        /* empty */
    };

    var scriptTag = function (content) {
        return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
    }; // Create object with fake `null` prototype: use ActiveX Object with cleared prototype


    var NullProtoObjectViaActiveX = function (activeXDocument) {
        activeXDocument.write(scriptTag(''));
        activeXDocument.close();
        var temp = activeXDocument.parentWindow.Object;
        activeXDocument = null; // avoid memory leak

        return temp;
    }; // Create object with fake `null` prototype: use iframe Object with cleared prototype


    var NullProtoObjectViaIFrame = function () {
        // Thrash, waste and sodomy: IE GC bug
        var iframe = documentCreateElement('iframe');
        var JS = 'java' + SCRIPT + ':';
        var iframeDocument;
        iframe.style.display = 'none';
        html.appendChild(iframe); // https://github.com/zloirock/core-js/issues/475

        iframe.src = String(JS);
        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(scriptTag('document.F=Object'));
        iframeDocument.close();
        return iframeDocument.F;
    }; // Check for document.domain and active x support
    // No need to use active x approach when document.domain is not set
    // see https://github.com/es-shims/es5-shim/issues/150
    // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
    // avoid IE GC bug


    var activeXDocument;

    var NullProtoObject = function () {
        try {
            /* global ActiveXObject -- old IE */
            activeXDocument = document.domain && new ActiveXObject('htmlfile');
        } catch (error) {
            /* ignore */
        }

        NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
        var length = enumBugKeys.length;

        while (length--) delete NullProtoObject[PROTOTYPE$1][enumBugKeys[length]];

        return NullProtoObject();
    };

    hiddenKeys$1[IE_PROTO] = true; // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create

    var objectCreate = Object.create || function create(O, Properties) {
        var result;

        if (O !== null) {
            EmptyConstructor[PROTOTYPE$1] = anObject(O);
            result = new EmptyConstructor();
            EmptyConstructor[PROTOTYPE$1] = null; // add "__proto__" for Object.getPrototypeOf polyfill

            result[IE_PROTO] = O;
        } else result = NullProtoObject();

        return Properties === undefined ? result : objectDefineProperties(result, Properties);
    };

    var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');
    var test$2 = {};
    test$2[TO_STRING_TAG$3] = 'z';
    var toStringTagSupport = String(test$2) === '[object z]';

    var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag'); // ES3 wrong here

    var CORRECT_ARGUMENTS = classofRaw(function () {
        return arguments;
    }()) == 'Arguments'; // fallback for IE11 Script Access Denied error

    var tryGet = function (it, key) {
        try {
            return it[key];
        } catch (error) {
            /* empty */
        }
    }; // getting tag from ES6+ `Object.prototype.toString`


    var classof = toStringTagSupport ? classofRaw : function (it) {
        var O, tag, result;
        return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
            : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$2)) == 'string' ? tag // builtinTag case
                : CORRECT_ARGUMENTS ? classofRaw(O) // ES3 arguments fallback
                    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
    };

    // https://tc39.es/ecma262/#sec-object.prototype.tostring


    var objectToString = toStringTagSupport ? {}.toString : function toString() {
        return '[object ' + classof(this) + ']';
    };

    var defineProperty$7 = objectDefineProperty.f;
    var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');

    var setToStringTag = function (it, TAG, STATIC, SET_METHOD) {
        if (it) {
            var target = STATIC ? it : it.prototype;

            if (!has$1(target, TO_STRING_TAG$1)) {
                defineProperty$7(target, TO_STRING_TAG$1, {
                    configurable: true,
                    value: TAG
                });
            }

            if (SET_METHOD && !toStringTagSupport) {
                createNonEnumerableProperty(target, 'toString', objectToString);
            }
        }
    };

    var iterators = {};

    var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;

    var returnThis$1 = function () {
        return this;
    };

    var createIteratorConstructor = function (IteratorConstructor, NAME, next) {
        var TO_STRING_TAG = NAME + ' Iterator';
        IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, {
            next: createPropertyDescriptor(1, next)
        });
        setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
        iterators[TO_STRING_TAG] = returnThis$1;
        return IteratorConstructor;
    };

    var aPossiblePrototype = function (it) {
        if (!isObject$1(it) && it !== null) {
            throw TypeError("Can't set " + String(it) + ' as a prototype');
        }

        return it;
    };

    /* eslint-disable no-proto -- safe */
    // https://tc39.es/ecma262/#sec-object.setprototypeof
    // Works with __proto__ only. Old v8 can't work with null proto objects.

    var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
        var CORRECT_SETTER = false;
        var test = {};
        var setter;

        try {
            setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
            setter.call(test, []);
            CORRECT_SETTER = test instanceof Array;
        } catch (error) {
            /* empty */
        }

        return function setPrototypeOf(O, proto) {
            anObject(O);
            aPossiblePrototype(proto);
            if (CORRECT_SETTER) setter.call(O, proto);else O.__proto__ = proto;
            return O;
        };
    }() : undefined);

    var redefine = function (target, key, value, options) {
        if (options && options.enumerable) target[key] = value;else createNonEnumerableProperty(target, key, value);
    };

    var IteratorPrototype = iteratorsCore.IteratorPrototype;
    var BUGGY_SAFARI_ITERATORS = iteratorsCore.BUGGY_SAFARI_ITERATORS;
    var ITERATOR$4 = wellKnownSymbol('iterator');
    var KEYS = 'keys';
    var VALUES = 'values';
    var ENTRIES = 'entries';

    var returnThis = function () {
        return this;
    };

    var defineIterator = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
        createIteratorConstructor(IteratorConstructor, NAME, next);

        var getIterationMethod = function (KIND) {
            if (KIND === DEFAULT && defaultIterator) return defaultIterator;
            if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];

            switch (KIND) {
                case KEYS:
                    return function keys() {
                        return new IteratorConstructor(this, KIND);
                    };

                case VALUES:
                    return function values() {
                        return new IteratorConstructor(this, KIND);
                    };

                case ENTRIES:
                    return function entries() {
                        return new IteratorConstructor(this, KIND);
                    };
            }

            return function () {
                return new IteratorConstructor(this);
            };
        };

        var TO_STRING_TAG = NAME + ' Iterator';
        var INCORRECT_VALUES_NAME = false;
        var IterablePrototype = Iterable.prototype;
        var nativeIterator = IterablePrototype[ITERATOR$4] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
        var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
        var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
        var CurrentIteratorPrototype, methods, KEY; // fix native

        if (anyNativeIterator) {
            CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));

            if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {


                setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
                iterators[TO_STRING_TAG] = returnThis;
            }
        } // fix Array#{values, @@iterator}.name in V8 / FF


        if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
            INCORRECT_VALUES_NAME = true;

            defaultIterator = function values() {
                return nativeIterator.call(this);
            };
        } // define iterator


        if ((FORCED) && IterablePrototype[ITERATOR$4] !== defaultIterator) {
            createNonEnumerableProperty(IterablePrototype, ITERATOR$4, defaultIterator);
        }

        iterators[NAME] = defaultIterator; // export additional methods

        if (DEFAULT) {
            methods = {
                values: getIterationMethod(VALUES),
                keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
                entries: getIterationMethod(ENTRIES)
            };
            if (FORCED) for (KEY in methods) {
                if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
                    redefine(IterablePrototype, KEY, methods[KEY]);
                }
            } else _export({
                target: NAME,
                proto: true,
                forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
            }, methods);
        }

        return methods;
    };

    var charAt = stringMultibyte.charAt;
    var STRING_ITERATOR = 'String Iterator';
    var setInternalState$5 = internalState.set;
    var getInternalState$2 = internalState.getterFor(STRING_ITERATOR); // `String.prototype[@@iterator]` method
    // https://tc39.es/ecma262/#sec-string.prototype-@@iterator

    defineIterator(String, 'String', function (iterated) {
        setInternalState$5(this, {
            type: STRING_ITERATOR,
            string: String(iterated),
            index: 0
        }); // `%StringIteratorPrototype%.next` method
        // https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
    }, function next() {
        var state = getInternalState$2(this);
        var string = state.string;
        var index = state.index;
        var point;
        if (index >= string.length) return {
            value: undefined,
            done: true
        };
        point = charAt(string, index);
        state.index += point.length;
        return {
            value: point,
            done: false
        };
    });

    var iteratorClose = function (iterator) {
        var returnMethod = iterator['return'];

        if (returnMethod !== undefined) {
            return anObject(returnMethod.call(iterator)).value;
        }
    };

    var callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
        try {
            return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value); // 7.4.6 IteratorClose(iterator, completion)
        } catch (error) {
            iteratorClose(iterator);
            throw error;
        }
    };

    var ITERATOR$3 = wellKnownSymbol('iterator');
    var ArrayPrototype$i = Array.prototype; // check on default Array iterator

    var isArrayIteratorMethod = function (it) {
        return it !== undefined && (iterators.Array === it || ArrayPrototype$i[ITERATOR$3] === it);
    };

    var createProperty = function (object, key, value) {
        var propertyKey = toPrimitive(key);
        if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));else object[propertyKey] = value;
    };

    var ITERATOR$2 = wellKnownSymbol('iterator');

    var getIteratorMethod$1 = function (it) {
        if (it != undefined) return it[ITERATOR$2] || it['@@iterator'] || iterators[classof(it)];
    };

    // https://tc39.es/ecma262/#sec-array.from


    var arrayFrom = function from(arrayLike
                                  /* , mapfn = undefined, thisArg = undefined */
    ) {
        var O = toObject(arrayLike);
        var C = typeof this == 'function' ? this : Array;
        var argumentsLength = arguments.length;
        var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        var iteratorMethod = getIteratorMethod$1(O);
        var index = 0;
        var length, result, step, iterator, next, value;
        if (mapping) mapfn = functionBindContext(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2); // if the target is not iterable or it's an array with the default iterator - use a simple case

        if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
            iterator = iteratorMethod.call(O);
            next = iterator.next;
            result = new C();

            for (; !(step = next.call(iterator)).done; index++) {
                value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
                createProperty(result, index, value);
            }
        } else {
            length = toLength(O.length);
            result = new C(length);

            for (; length > index; index++) {
                value = mapping ? mapfn(O[index], index) : O[index];
                createProperty(result, index, value);
            }
        }

        result.length = index;
        return result;
    };

    var ITERATOR$1 = wellKnownSymbol('iterator');
    var SAFE_CLOSING = false;

    try {
        var called = 0;
        var iteratorWithReturn = {
            next: function () {
                return {
                    done: !!called++
                };
            },
            'return': function () {
                SAFE_CLOSING = true;
            }
        };

        iteratorWithReturn[ITERATOR$1] = function () {
            return this;
        }; // eslint-disable-next-line no-throw-literal -- required for testing


        Array.from(iteratorWithReturn, function () {
            throw 2;
        });
    } catch (error) {
        /* empty */
    }

    var checkCorrectnessOfIteration = function (exec, SKIP_CLOSING) {
        if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
        var ITERATION_SUPPORT = false;

        try {
            var object = {};

            object[ITERATOR$1] = function () {
                return {
                    next: function () {
                        return {
                            done: ITERATION_SUPPORT = true
                        };
                    }
                };
            };

            exec(object);
        } catch (error) {
            /* empty */
        }

        return ITERATION_SUPPORT;
    };

    var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
        Array.from(iterable);
    }); // `Array.from` method
    // https://tc39.es/ecma262/#sec-array.from

    _export({
        target: 'Array',
        stat: true,
        forced: INCORRECT_ITERATION
    }, {
        from: arrayFrom
    });

    var from$4 = path.Array.from;

    var from$3 = from$4;

    var from$2 = from$3;

    var ARRAY_ITERATOR = 'Array Iterator';
    var setInternalState$4 = internalState.set;
    var getInternalState$1 = internalState.getterFor(ARRAY_ITERATOR); // `Array.prototype.entries` method
    // https://tc39.es/ecma262/#sec-array.prototype.entries
    // `Array.prototype.keys` method
    // https://tc39.es/ecma262/#sec-array.prototype.keys
    // `Array.prototype.values` method
    // https://tc39.es/ecma262/#sec-array.prototype.values
    // `Array.prototype[@@iterator]` method
    // https://tc39.es/ecma262/#sec-array.prototype-@@iterator
    // `CreateArrayIterator` internal method
    // https://tc39.es/ecma262/#sec-createarrayiterator

    defineIterator(Array, 'Array', function (iterated, kind) {
        setInternalState$4(this, {
            type: ARRAY_ITERATOR,
            target: toIndexedObject(iterated),
            // target
            index: 0,
            // next index
            kind: kind // kind

        }); // `%ArrayIteratorPrototype%.next` method
        // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
    }, function () {
        var state = getInternalState$1(this);
        var target = state.target;
        var kind = state.kind;
        var index = state.index++;

        if (!target || index >= target.length) {
            state.target = undefined;
            return {
                value: undefined,
                done: true
            };
        }

        if (kind == 'keys') return {
            value: index,
            done: false
        };
        if (kind == 'values') return {
            value: target[index],
            done: false
        };
        return {
            value: [index, target[index]],
            done: false
        };
    }, 'values'); // argumentsList[@@iterator] is %ArrayProto_values%
    // https://tc39.es/ecma262/#sec-createunmappedargumentsobject
    // https://tc39.es/ecma262/#sec-createmappedargumentsobject

    iterators.Arguments = iterators.Array; // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

    // iterable DOM collections
    // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
    var domIterables = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0
    };

    var TO_STRING_TAG = wellKnownSymbol('toStringTag');

    for (var COLLECTION_NAME in domIterables) {
        var Collection = global$1[COLLECTION_NAME];
        var CollectionPrototype = Collection && Collection.prototype;

        if (CollectionPrototype && classof(CollectionPrototype) !== TO_STRING_TAG) {
            createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
        }

        iterators[COLLECTION_NAME] = iterators.Array;
    }

    var getIteratorMethod_1 = getIteratorMethod$1;

    var getIteratorMethod = getIteratorMethod_1;

    var getIterator$1 = function (it) {
        var iteratorMethod = getIteratorMethod$1(it);

        if (typeof iteratorMethod != 'function') {
            throw TypeError(String(it) + ' is not iterable');
        }

        return anObject(iteratorMethod.call(it));
    };

    var getIterator_1 = getIterator$1;

    var getIterator = getIterator_1;

    // https://tc39.es/ecma262/#sec-isarray

    var isArray$5 = Array.isArray || function isArray(arg) {
        return classofRaw(arg) == 'Array';
    };

    var hiddenKeys = enumBugKeys.concat('length', 'prototype'); // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames

    var f$2 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
        return objectKeysInternal(O, hiddenKeys);
    };

    var objectGetOwnPropertyNames = {
        f: f$2
    };

    var nativeGetOwnPropertyNames$2 = objectGetOwnPropertyNames.f;
    var toString = {}.toString;
    var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

    var getWindowNames = function (it) {
        try {
            return nativeGetOwnPropertyNames$2(it);
        } catch (error) {
            return windowNames.slice();
        }
    }; // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window


    var f$1 = function getOwnPropertyNames(it) {
        return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : nativeGetOwnPropertyNames$2(toIndexedObject(it));
    };

    var objectGetOwnPropertyNamesExternal = {
        f: f$1
    };

    var f = wellKnownSymbol;
    var wellKnownSymbolWrapped = {
        f: f
    };

    var defineProperty$6 = objectDefineProperty.f;

    var defineWellKnownSymbol = function (NAME) {
        var Symbol = path.Symbol || (path.Symbol = {});
        if (!has$1(Symbol, NAME)) defineProperty$6(Symbol, NAME, {
            value: wellKnownSymbolWrapped.f(NAME)
        });
    };

    var SPECIES$3 = wellKnownSymbol('species'); // `ArraySpeciesCreate` abstract operation
    // https://tc39.es/ecma262/#sec-arrayspeciescreate

    var arraySpeciesCreate = function (originalArray, length) {
        var C;

        if (isArray$5(originalArray)) {
            C = originalArray.constructor; // cross-realm fallback

            if (typeof C == 'function' && (C === Array || isArray$5(C.prototype))) C = undefined;else if (isObject$1(C)) {
                C = C[SPECIES$3];
                if (C === null) C = undefined;
            }
        }

        return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
    };

    var push = [].push; // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation

    var createMethod$3 = function (TYPE) {
        var IS_MAP = TYPE == 1;
        var IS_FILTER = TYPE == 2;
        var IS_SOME = TYPE == 3;
        var IS_EVERY = TYPE == 4;
        var IS_FIND_INDEX = TYPE == 6;
        var IS_FILTER_OUT = TYPE == 7;
        var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
        return function ($this, callbackfn, that, specificCreate) {
            var O = toObject($this);
            var self = indexedObject(O);
            var boundFunction = functionBindContext(callbackfn, that, 3);
            var length = toLength(self.length);
            var index = 0;
            var create = specificCreate || arraySpeciesCreate;
            var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
            var value, result;

            for (; length > index; index++) if (NO_HOLES || index in self) {
                value = self[index];
                result = boundFunction(value, index, O);

                if (TYPE) {
                    if (IS_MAP) target[index] = result; // map
                    else if (result) switch (TYPE) {
                        case 3:
                            return true;
                        // some

                        case 5:
                            return value;
                        // find

                        case 6:
                            return index;
                        // findIndex

                        case 2:
                            push.call(target, value);
                        // filter
                    } else switch (TYPE) {
                        case 4:
                            return false;
                        // every

                        case 7:
                            push.call(target, value);
                        // filterOut
                    }
                }
            }

            return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
        };
    };

    var arrayIteration = {
        // `Array.prototype.forEach` method
        // https://tc39.es/ecma262/#sec-array.prototype.foreach
        forEach: createMethod$3(0),
        // `Array.prototype.map` method
        // https://tc39.es/ecma262/#sec-array.prototype.map
        map: createMethod$3(1),
        // `Array.prototype.filter` method
        // https://tc39.es/ecma262/#sec-array.prototype.filter
        filter: createMethod$3(2),
        // `Array.prototype.some` method
        // https://tc39.es/ecma262/#sec-array.prototype.some
        some: createMethod$3(3),
        // `Array.prototype.every` method
        // https://tc39.es/ecma262/#sec-array.prototype.every
        every: createMethod$3(4),
        // `Array.prototype.find` method
        // https://tc39.es/ecma262/#sec-array.prototype.find
        find: createMethod$3(5),
        // `Array.prototype.findIndex` method
        // https://tc39.es/ecma262/#sec-array.prototype.findIndex
        findIndex: createMethod$3(6),
        // `Array.prototype.filterOut` method
        // https://github.com/tc39/proposal-array-filtering
        filterOut: createMethod$3(7)
    };

    var $forEach$1 = arrayIteration.forEach;
    var HIDDEN = sharedKey('hidden');
    var SYMBOL = 'Symbol';
    var PROTOTYPE = 'prototype';
    var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
    var setInternalState$3 = internalState.set;
    var getInternalState = internalState.getterFor(SYMBOL);
    var ObjectPrototype = Object[PROTOTYPE];
    var $Symbol = global$1.Symbol;
    var $stringify$1 = getBuiltIn('JSON', 'stringify');
    var nativeGetOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
    var nativeDefineProperty = objectDefineProperty.f;
    var nativeGetOwnPropertyNames$1 = objectGetOwnPropertyNamesExternal.f;
    var nativePropertyIsEnumerable = objectPropertyIsEnumerable.f;
    var AllSymbols = shared('symbols');
    var ObjectPrototypeSymbols = shared('op-symbols');
    var StringToSymbolRegistry = shared('string-to-symbol-registry');
    var SymbolToStringRegistry = shared('symbol-to-string-registry');
    var WellKnownSymbolsStore = shared('wks');
    var QObject = global$1.QObject; // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

    var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

    var setSymbolDescriptor = descriptors && fails(function () {
        return objectCreate(nativeDefineProperty({}, 'a', {
            get: function () {
                return nativeDefineProperty(this, 'a', {
                    value: 7
                }).a;
            }
        })).a != 7;
    }) ? function (O, P, Attributes) {
        var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor$1(ObjectPrototype, P);
        if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
        nativeDefineProperty(O, P, Attributes);

        if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
            nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
        }
    } : nativeDefineProperty;

    var wrap$1 = function (tag, description) {
        var symbol = AllSymbols[tag] = objectCreate($Symbol[PROTOTYPE]);
        setInternalState$3(symbol, {
            type: SYMBOL,
            tag: tag,
            description: description
        });
        if (!descriptors) symbol.description = description;
        return symbol;
    };

    var isSymbol = useSymbolAsUid ? function (it) {
        return typeof it == 'symbol';
    } : function (it) {
        return Object(it) instanceof $Symbol;
    };

    var $defineProperty = function defineProperty(O, P, Attributes) {
        if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
        anObject(O);
        var key = toPrimitive(P, true);
        anObject(Attributes);

        if (has$1(AllSymbols, key)) {
            if (!Attributes.enumerable) {
                if (!has$1(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
                O[HIDDEN][key] = true;
            } else {
                if (has$1(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
                Attributes = objectCreate(Attributes, {
                    enumerable: createPropertyDescriptor(0, false)
                });
            }

            return setSymbolDescriptor(O, key, Attributes);
        }

        return nativeDefineProperty(O, key, Attributes);
    };

    var $defineProperties = function defineProperties(O, Properties) {
        anObject(O);
        var properties = toIndexedObject(Properties);
        var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
        $forEach$1(keys, function (key) {
            if (!descriptors || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
        });
        return O;
    };

    var $create = function create(O, Properties) {
        return Properties === undefined ? objectCreate(O) : $defineProperties(objectCreate(O), Properties);
    };

    var $propertyIsEnumerable = function propertyIsEnumerable(V) {
        var P = toPrimitive(V, true);
        var enumerable = nativePropertyIsEnumerable.call(this, P);
        if (this === ObjectPrototype && has$1(AllSymbols, P) && !has$1(ObjectPrototypeSymbols, P)) return false;
        return enumerable || !has$1(this, P) || !has$1(AllSymbols, P) || has$1(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
    };

    var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
        var it = toIndexedObject(O);
        var key = toPrimitive(P, true);
        if (it === ObjectPrototype && has$1(AllSymbols, key) && !has$1(ObjectPrototypeSymbols, key)) return;
        var descriptor = nativeGetOwnPropertyDescriptor$1(it, key);

        if (descriptor && has$1(AllSymbols, key) && !(has$1(it, HIDDEN) && it[HIDDEN][key])) {
            descriptor.enumerable = true;
        }

        return descriptor;
    };

    var $getOwnPropertyNames = function getOwnPropertyNames(O) {
        var names = nativeGetOwnPropertyNames$1(toIndexedObject(O));
        var result = [];
        $forEach$1(names, function (key) {
            if (!has$1(AllSymbols, key) && !has$1(hiddenKeys$1, key)) result.push(key);
        });
        return result;
    };

    var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
        var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
        var names = nativeGetOwnPropertyNames$1(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
        var result = [];
        $forEach$1(names, function (key) {
            if (has$1(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has$1(ObjectPrototype, key))) {
                result.push(AllSymbols[key]);
            }
        });
        return result;
    }; // `Symbol` constructor
    // https://tc39.es/ecma262/#sec-symbol-constructor


    if (!nativeSymbol) {
        $Symbol = function Symbol() {
            if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
            var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
            var tag = uid(description);

            var setter = function (value) {
                if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
                if (has$1(this, HIDDEN) && has$1(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
                setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
            };

            if (descriptors && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, {
                configurable: true,
                set: setter
            });
            return wrap$1(tag, description);
        };

        redefine($Symbol[PROTOTYPE], 'toString', function toString() {
            return getInternalState(this).tag;
        });
        redefine($Symbol, 'withoutSetter', function (description) {
            return wrap$1(uid(description), description);
        });
        objectPropertyIsEnumerable.f = $propertyIsEnumerable;
        objectDefineProperty.f = $defineProperty;
        objectGetOwnPropertyDescriptor.f = $getOwnPropertyDescriptor;
        objectGetOwnPropertyNames.f = objectGetOwnPropertyNamesExternal.f = $getOwnPropertyNames;
        objectGetOwnPropertySymbols.f = $getOwnPropertySymbols;

        wellKnownSymbolWrapped.f = function (name) {
            return wrap$1(wellKnownSymbol(name), name);
        };

        if (descriptors) {
            // https://github.com/tc39/proposal-Symbol-description
            nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
                configurable: true,
                get: function description() {
                    return getInternalState(this).description;
                }
            });
        }
    }

    _export({
        global: true,
        wrap: true,
        forced: !nativeSymbol,
        sham: !nativeSymbol
    }, {
        Symbol: $Symbol
    });
    $forEach$1(objectKeys(WellKnownSymbolsStore), function (name) {
        defineWellKnownSymbol(name);
    });
    _export({
        target: SYMBOL,
        stat: true,
        forced: !nativeSymbol
    }, {
        // `Symbol.for` method
        // https://tc39.es/ecma262/#sec-symbol.for
        'for': function (key) {
            var string = String(key);
            if (has$1(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
            var symbol = $Symbol(string);
            StringToSymbolRegistry[string] = symbol;
            SymbolToStringRegistry[symbol] = string;
            return symbol;
        },
        // `Symbol.keyFor` method
        // https://tc39.es/ecma262/#sec-symbol.keyfor
        keyFor: function keyFor(sym) {
            if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
            if (has$1(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
        },
        useSetter: function () {
            USE_SETTER = true;
        },
        useSimple: function () {
            USE_SETTER = false;
        }
    });
    _export({
        target: 'Object',
        stat: true,
        forced: !nativeSymbol,
        sham: !descriptors
    }, {
        // `Object.create` method
        // https://tc39.es/ecma262/#sec-object.create
        create: $create,
        // `Object.defineProperty` method
        // https://tc39.es/ecma262/#sec-object.defineproperty
        defineProperty: $defineProperty,
        // `Object.defineProperties` method
        // https://tc39.es/ecma262/#sec-object.defineproperties
        defineProperties: $defineProperties,
        // `Object.getOwnPropertyDescriptor` method
        // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
        getOwnPropertyDescriptor: $getOwnPropertyDescriptor
    });
    _export({
        target: 'Object',
        stat: true,
        forced: !nativeSymbol
    }, {
        // `Object.getOwnPropertyNames` method
        // https://tc39.es/ecma262/#sec-object.getownpropertynames
        getOwnPropertyNames: $getOwnPropertyNames,
        // `Object.getOwnPropertySymbols` method
        // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
        getOwnPropertySymbols: $getOwnPropertySymbols
    }); // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
    // https://bugs.chromium.org/p/v8/issues/detail?id=3443

    _export({
        target: 'Object',
        stat: true,
        forced: fails(function () {
            objectGetOwnPropertySymbols.f(1);
        })
    }, {
        getOwnPropertySymbols: function getOwnPropertySymbols(it) {
            return objectGetOwnPropertySymbols.f(toObject(it));
        }
    }); // `JSON.stringify` method behavior with symbols
    // https://tc39.es/ecma262/#sec-json.stringify

    if ($stringify$1) {
        var FORCED_JSON_STRINGIFY = !nativeSymbol || fails(function () {
            var symbol = $Symbol(); // MS Edge converts symbol values to JSON as {}

            return $stringify$1([symbol]) != '[null]' // WebKit converts symbol values to JSON as null
                || $stringify$1({
                    a: symbol
                }) != '{}' // V8 throws on boxed symbols
                || $stringify$1(Object(symbol)) != '{}';
        });
        _export({
            target: 'JSON',
            stat: true,
            forced: FORCED_JSON_STRINGIFY
        }, {
            // eslint-disable-next-line no-unused-vars -- required for `.length`
            stringify: function stringify(it, replacer, space) {
                var args = [it];
                var index = 1;
                var $replacer;

                while (arguments.length > index) args.push(arguments[index++]);

                $replacer = replacer;
                if (!isObject$1(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined

                if (!isArray$5(replacer)) replacer = function (key, value) {
                    if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
                    if (!isSymbol(value)) return value;
                };
                args[1] = replacer;
                return $stringify$1.apply(null, args);
            }
        });
    } // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive


    if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
        createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
    } // `Symbol.prototype[@@toStringTag]` property
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag


    setToStringTag($Symbol, SYMBOL);
    hiddenKeys$1[HIDDEN] = true;

    var getOwnPropertySymbols$2 = path.Object.getOwnPropertySymbols;

    var getOwnPropertySymbols$1 = getOwnPropertySymbols$2;

    var getOwnPropertySymbols = getOwnPropertySymbols$1;

    var nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
    var FAILS_ON_PRIMITIVES$3 = fails(function () {
        nativeGetOwnPropertyDescriptor(1);
    });
    var FORCED$6 = !descriptors || FAILS_ON_PRIMITIVES$3; // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor

    _export({
        target: 'Object',
        stat: true,
        forced: FORCED$6,
        sham: !descriptors
    }, {
        getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
            return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
        }
    });

    var getOwnPropertyDescriptor_1 = createCommonjsModule(function (module) {
        var Object = path.Object;

        var getOwnPropertyDescriptor = module.exports = function getOwnPropertyDescriptor(it, key) {
            return Object.getOwnPropertyDescriptor(it, key);
        };

        if (Object.getOwnPropertyDescriptor.sham) getOwnPropertyDescriptor.sham = true;
    });

    var getOwnPropertyDescriptor$3 = getOwnPropertyDescriptor_1;

    var getOwnPropertyDescriptor$2 = getOwnPropertyDescriptor$3;

    var ownKeys$8 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
        var keys = objectGetOwnPropertyNames.f(anObject(it));
        var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
        return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
    };

    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors

    _export({
        target: 'Object',
        stat: true,
        sham: !descriptors
    }, {
        getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
            var O = toIndexedObject(object);
            var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
            var keys = ownKeys$8(O);
            var result = {};
            var index = 0;
            var key, descriptor;

            while (keys.length > index) {
                descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
                if (descriptor !== undefined) createProperty(result, key, descriptor);
            }

            return result;
        }
    });

    var getOwnPropertyDescriptors$2 = path.Object.getOwnPropertyDescriptors;

    var getOwnPropertyDescriptors$1 = getOwnPropertyDescriptors$2;

    var getOwnPropertyDescriptors = getOwnPropertyDescriptors$1;

    // https://tc39.es/ecma262/#sec-object.defineproperties

    _export({
        target: 'Object',
        stat: true,
        forced: !descriptors,
        sham: !descriptors
    }, {
        defineProperties: objectDefineProperties
    });

    var defineProperties_1 = createCommonjsModule(function (module) {
        var Object = path.Object;

        var defineProperties = module.exports = function defineProperties(T, D) {
            return Object.defineProperties(T, D);
        };

        if (Object.defineProperties.sham) defineProperties.sham = true;
    });

    var defineProperties$1 = defineProperties_1;

    var defineProperties = defineProperties$1;

    // https://tc39.es/ecma262/#sec-object.defineproperty

    _export({
        target: 'Object',
        stat: true,
        forced: !descriptors,
        sham: !descriptors
    }, {
        defineProperty: objectDefineProperty.f
    });

    var defineProperty_1 = createCommonjsModule(function (module) {
        var Object = path.Object;

        var defineProperty = module.exports = function defineProperty(it, key, desc) {
            return Object.defineProperty(it, key, desc);
        };

        if (Object.defineProperty.sham) defineProperty.sham = true;
    });

    var defineProperty$5 = defineProperty_1;

    var defineProperty$4 = defineProperty$5;

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var defineProperty$3 = defineProperty_1;

    var defineProperty$2 = defineProperty$3;

    function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;

            defineProperty$2(target, descriptor.key, descriptor);
        }
    }

    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }

    function _defineProperty(obj, key, value) {
        if (key in obj) {
            defineProperty$2(obj, key, {
                value: value,
                enumerable: true,
                configurable: true,
                writable: true
            });
        } else {
            obj[key] = value;
        }

        return obj;
    }

    // https://tc39.es/ecma262/#sec-array.isarray

    _export({
        target: 'Array',
        stat: true
    }, {
        isArray: isArray$5
    });

    var isArray$4 = path.Array.isArray;

    var isArray$3 = isArray$4;

    var isArray$2 = isArray$3;

    function _arrayWithHoles(arr) {
        if (isArray$2(arr)) return arr;
    }

    var SPECIES$2 = wellKnownSymbol('species');

    var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
        // We can't use this feature detection in V8 since it causes
        // deoptimization and serious performance degradation
        // https://github.com/zloirock/core-js/issues/677
        return engineV8Version >= 51 || !fails(function () {
            var array = [];
            var constructor = array.constructor = {};

            constructor[SPECIES$2] = function () {
                return {
                    foo: 1
                };
            };

            return array[METHOD_NAME](Boolean).foo !== 1;
        });
    };

    var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
    var MAX_SAFE_INTEGER$1 = 0x1FFFFFFFFFFFFF;
    var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded'; // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/679

    var IS_CONCAT_SPREADABLE_SUPPORT = engineV8Version >= 51 || !fails(function () {
        var array = [];
        array[IS_CONCAT_SPREADABLE] = false;
        return array.concat()[0] !== array;
    });
    var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

    var isConcatSpreadable = function (O) {
        if (!isObject$1(O)) return false;
        var spreadable = O[IS_CONCAT_SPREADABLE];
        return spreadable !== undefined ? !!spreadable : isArray$5(O);
    };

    var FORCED$5 = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT; // `Array.prototype.concat` method
    // https://tc39.es/ecma262/#sec-array.prototype.concat
    // with adding support of @@isConcatSpreadable and @@species

    _export({
        target: 'Array',
        proto: true,
        forced: FORCED$5
    }, {
        // eslint-disable-next-line no-unused-vars -- required for `.length`
        concat: function concat(arg) {
            var O = toObject(this);
            var A = arraySpeciesCreate(O, 0);
            var n = 0;
            var i, k, length, len, E;

            for (i = -1, length = arguments.length; i < length; i++) {
                E = i === -1 ? O : arguments[i];

                if (isConcatSpreadable(E)) {
                    len = toLength(E.length);
                    if (n + len > MAX_SAFE_INTEGER$1) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);

                    for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
                } else {
                    if (n >= MAX_SAFE_INTEGER$1) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
                    createProperty(A, n++, E);
                }
            }

            A.length = n;
            return A;
        }
    });

    // https://tc39.es/ecma262/#sec-symbol.asynciterator

    defineWellKnownSymbol('asyncIterator');

    // https://tc39.es/ecma262/#sec-symbol.hasinstance

    defineWellKnownSymbol('hasInstance');

    // https://tc39.es/ecma262/#sec-symbol.isconcatspreadable

    defineWellKnownSymbol('isConcatSpreadable');

    // https://tc39.es/ecma262/#sec-symbol.iterator

    defineWellKnownSymbol('iterator');

    // https://tc39.es/ecma262/#sec-symbol.match

    defineWellKnownSymbol('match');

    // https://tc39.es/ecma262/#sec-symbol.matchall

    defineWellKnownSymbol('matchAll');

    // https://tc39.es/ecma262/#sec-symbol.replace

    defineWellKnownSymbol('replace');

    // https://tc39.es/ecma262/#sec-symbol.search

    defineWellKnownSymbol('search');

    // https://tc39.es/ecma262/#sec-symbol.species

    defineWellKnownSymbol('species');

    // https://tc39.es/ecma262/#sec-symbol.split

    defineWellKnownSymbol('split');

    // https://tc39.es/ecma262/#sec-symbol.toprimitive

    defineWellKnownSymbol('toPrimitive');

    // https://tc39.es/ecma262/#sec-symbol.tostringtag

    defineWellKnownSymbol('toStringTag');

    // https://tc39.es/ecma262/#sec-symbol.unscopables

    defineWellKnownSymbol('unscopables');

    // https://tc39.es/ecma262/#sec-json-@@tostringtag

    setToStringTag(global$1.JSON, 'JSON', true);

    var symbol$4 = path.Symbol;

    // https://github.com/tc39/proposal-using-statement

    defineWellKnownSymbol('asyncDispose');

    // https://github.com/tc39/proposal-using-statement

    defineWellKnownSymbol('dispose');

    // https://github.com/tc39/proposal-observable

    defineWellKnownSymbol('observable');

    // https://github.com/tc39/proposal-pattern-matching

    defineWellKnownSymbol('patternMatch');

    defineWellKnownSymbol('replaceAll');

    var symbol$3 = symbol$4;

    var symbol$2 = symbol$3;

    var ITERATOR = wellKnownSymbol('iterator');

    var isIterable$1 = function (it) {
        var O = Object(it);
        return O[ITERATOR] !== undefined || '@@iterator' in O // eslint-disable-next-line no-prototype-builtins -- safe
            || iterators.hasOwnProperty(classof(O));
    };

    var isIterable_1 = isIterable$1;

    var isIterable = isIterable_1;

    function _iterableToArrayLimit(arr, i) {
        if (typeof symbol$2 === "undefined" || !isIterable(Object(arr))) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;

        try {
            for (var _i = getIterator(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);

                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally {
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }

        return _arr;
    }

    var HAS_SPECIES_SUPPORT$3 = arrayMethodHasSpeciesSupport('slice');
    var SPECIES$1 = wellKnownSymbol('species');
    var nativeSlice = [].slice;
    var max$1 = Math.max; // `Array.prototype.slice` method
    // https://tc39.es/ecma262/#sec-array.prototype.slice
    // fallback for not array-like ES3 strings and DOM objects

    _export({
        target: 'Array',
        proto: true,
        forced: !HAS_SPECIES_SUPPORT$3
    }, {
        slice: function slice(start, end) {
            var O = toIndexedObject(this);
            var length = toLength(O.length);
            var k = toAbsoluteIndex(start, length);
            var fin = toAbsoluteIndex(end === undefined ? length : end, length); // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible

            var Constructor, result, n;

            if (isArray$5(O)) {
                Constructor = O.constructor; // cross-realm fallback

                if (typeof Constructor == 'function' && (Constructor === Array || isArray$5(Constructor.prototype))) {
                    Constructor = undefined;
                } else if (isObject$1(Constructor)) {
                    Constructor = Constructor[SPECIES$1];
                    if (Constructor === null) Constructor = undefined;
                }

                if (Constructor === Array || Constructor === undefined) {
                    return nativeSlice.call(O, k, fin);
                }
            }

            result = new (Constructor === undefined ? Array : Constructor)(max$1(fin - k, 0));

            for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);

            result.length = n;
            return result;
        }
    });

    var slice$5 = entryVirtual('Array').slice;

    var ArrayPrototype$h = Array.prototype;

    var slice_1 = function (it) {
        var own = it.slice;
        return it === ArrayPrototype$h || it instanceof Array && own === ArrayPrototype$h.slice ? slice$5 : own;
    };

    var slice$4 = slice_1;

    var slice$3 = slice$4;

    var from$1 = from$4;

    var from = from$1;

    function _arrayLikeToArray$9(arr, len) {
        if (len == null || len > arr.length) len = arr.length;

        for (var i = 0, arr2 = new Array(len); i < len; i++) {
            arr2[i] = arr[i];
        }

        return arr2;
    }

    function _unsupportedIterableToArray$9(o, minLen) {
        var _context;

        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray$9(o, minLen);

        var n = slice$3(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);

        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$9(o, minLen);
    }

    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$9(arr, i) || _nonIterableRest();
    }

    var iterator$4 = wellKnownSymbolWrapped.f('iterator');

    var iterator$3 = iterator$4;

    var iterator$2 = iterator$3;

    function _typeof(obj) {
        "@babel/helpers - typeof";

        if (typeof symbol$2 === "function" && typeof iterator$2 === "symbol") {
            _typeof = function _typeof(obj) {
                return typeof obj;
            };
        } else {
            _typeof = function _typeof(obj) {
                return obj && typeof symbol$2 === "function" && obj.constructor === symbol$2 && obj !== symbol$2.prototype ? "symbol" : typeof obj;
            };
        }

        return _typeof(obj);
    }

    function _arrayWithoutHoles(arr) {
        if (isArray$2(arr)) return _arrayLikeToArray$9(arr);
    }

    function _iterableToArray(iter) {
        if (typeof symbol$2 !== "undefined" && isIterable(Object(iter))) return from(iter);
    }

    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$9(arr) || _nonIterableSpread();
    }

    var symbol$1 = symbol$4;

    var symbol = symbol$1;

    var concat$2 = entryVirtual('Array').concat;

    var ArrayPrototype$g = Array.prototype;

    var concat_1 = function (it) {
        var own = it.concat;
        return it === ArrayPrototype$g || it instanceof Array && own === ArrayPrototype$g.concat ? concat$2 : own;
    };

    var concat$1 = concat_1;

    var concat = concat$1;

    var slice$2 = slice_1;

    var slice$1 = slice$2;

    // https://tc39.es/ecma262/#sec-reflect.ownkeys

    _export({
        target: 'Reflect',
        stat: true
    }, {
        ownKeys: ownKeys$8
    });

    var ownKeys$7 = path.Reflect.ownKeys;

    var ownKeys$6 = ownKeys$7;

    var ownKeys$5 = ownKeys$6;

    var isArray$1 = isArray$4;

    var isArray = isArray$1;

    var $map = arrayIteration.map;
    var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport('map'); // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    // with adding support of @@species

    _export({
        target: 'Array',
        proto: true,
        forced: !HAS_SPECIES_SUPPORT$2
    }, {
        map: function map(callbackfn
                          /* , thisArg */
        ) {
            return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        }
    });

    var map$5 = entryVirtual('Array').map;

    var ArrayPrototype$f = Array.prototype;

    var map_1 = function (it) {
        var own = it.map;
        return it === ArrayPrototype$f || it instanceof Array && own === ArrayPrototype$f.map ? map$5 : own;
    };

    var map$4 = map_1;

    var map$3 = map$4;

    var FAILS_ON_PRIMITIVES$2 = fails(function () {
        objectKeys(1);
    }); // `Object.keys` method
    // https://tc39.es/ecma262/#sec-object.keys

    _export({
        target: 'Object',
        stat: true,
        forced: FAILS_ON_PRIMITIVES$2
    }, {
        keys: function keys(it) {
            return objectKeys(toObject(it));
        }
    });

    var keys$5 = path.Object.keys;

    var keys$4 = keys$5;

    var keys$3 = keys$4;

    // https://tc39.es/ecma262/#sec-date.now

    _export({
        target: 'Date',
        stat: true
    }, {
        now: function now() {
            return new Date().getTime();
        }
    });

    var now$3 = path.Date.now;

    var now$2 = now$3;

    var now$1 = now$2;

    var arrayMethodIsStrict = function (METHOD_NAME, argument) {
        var method = [][METHOD_NAME];
        return !!method && fails(function () {
            // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
            method.call(null, argument || function () {
                throw 1;
            }, 1);
        });
    };

    var $forEach = arrayIteration.forEach;
    var STRICT_METHOD$5 = arrayMethodIsStrict('forEach'); // `Array.prototype.forEach` method implementation
    // https://tc39.es/ecma262/#sec-array.prototype.foreach

    var arrayForEach = !STRICT_METHOD$5 ? function forEach(callbackfn
                                                           /* , thisArg */
    ) {
        return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    } : [].forEach;

    // https://tc39.es/ecma262/#sec-array.prototype.foreach


    _export({
        target: 'Array',
        proto: true,
        forced: [].forEach != arrayForEach
    }, {
        forEach: arrayForEach
    });

    var forEach$4 = entryVirtual('Array').forEach;

    var forEach$3 = forEach$4;

    var ArrayPrototype$e = Array.prototype;
    var DOMIterables$3 = {
        DOMTokenList: true,
        NodeList: true
    };

    var forEach_1 = function (it) {
        var own = it.forEach;
        return it === ArrayPrototype$e || it instanceof Array && own === ArrayPrototype$e.forEach // eslint-disable-next-line no-prototype-builtins -- safe
        || DOMIterables$3.hasOwnProperty(classof(it)) ? forEach$3 : own;
    };

    var forEach$2 = forEach_1;

    var nativeReverse = [].reverse;
    var test$1 = [1, 2]; // `Array.prototype.reverse` method
    // https://tc39.es/ecma262/#sec-array.prototype.reverse
    // fix for Safari 12.0 bug
    // https://bugs.webkit.org/show_bug.cgi?id=188794

    _export({
        target: 'Array',
        proto: true,
        forced: String(test$1) === String(test$1.reverse())
    }, {
        reverse: function reverse() {
            // eslint-disable-next-line no-self-assign -- dirty hack
            if (isArray$5(this)) this.length = this.length;
            return nativeReverse.call(this);
        }
    });

    var reverse$2 = entryVirtual('Array').reverse;

    var ArrayPrototype$d = Array.prototype;

    var reverse_1 = function (it) {
        var own = it.reverse;
        return it === ArrayPrototype$d || it instanceof Array && own === ArrayPrototype$d.reverse ? reverse$2 : own;
    };

    var reverse$1 = reverse_1;

    var reverse = reverse$1;

    var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport('splice');
    var max = Math.max;
    var min = Math.min;
    var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
    var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded'; // `Array.prototype.splice` method
    // https://tc39.es/ecma262/#sec-array.prototype.splice
    // with adding support of @@species

    _export({
        target: 'Array',
        proto: true,
        forced: !HAS_SPECIES_SUPPORT$1
    }, {
        splice: function splice(start, deleteCount
                                /* , ...items */
        ) {
            var O = toObject(this);
            var len = toLength(O.length);
            var actualStart = toAbsoluteIndex(start, len);
            var argumentsLength = arguments.length;
            var insertCount, actualDeleteCount, A, k, from, to;

            if (argumentsLength === 0) {
                insertCount = actualDeleteCount = 0;
            } else if (argumentsLength === 1) {
                insertCount = 0;
                actualDeleteCount = len - actualStart;
            } else {
                insertCount = argumentsLength - 2;
                actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
            }

            if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
                throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
            }

            A = arraySpeciesCreate(O, actualDeleteCount);

            for (k = 0; k < actualDeleteCount; k++) {
                from = actualStart + k;
                if (from in O) createProperty(A, k, O[from]);
            }

            A.length = actualDeleteCount;

            if (insertCount < actualDeleteCount) {
                for (k = actualStart; k < len - actualDeleteCount; k++) {
                    from = k + actualDeleteCount;
                    to = k + insertCount;
                    if (from in O) O[to] = O[from];else delete O[to];
                }

                for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
            } else if (insertCount > actualDeleteCount) {
                for (k = len - actualDeleteCount; k > actualStart; k--) {
                    from = k + actualDeleteCount - 1;
                    to = k + insertCount - 1;
                    if (from in O) O[to] = O[from];else delete O[to];
                }
            }

            for (k = 0; k < insertCount; k++) {
                O[k + actualStart] = arguments[k + 2];
            }

            O.length = len - actualDeleteCount + insertCount;
            return A;
        }
    });

    var splice$2 = entryVirtual('Array').splice;

    var ArrayPrototype$c = Array.prototype;

    var splice_1 = function (it) {
        var own = it.splice;
        return it === ArrayPrototype$c || it instanceof Array && own === ArrayPrototype$c.splice ? splice$2 : own;
    };

    var splice$1 = splice_1;

    var splice = splice$1;

    var $includes = arrayIncludes.includes; // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes

    _export({
        target: 'Array',
        proto: true
    }, {
        includes: function includes(el
                                    /* , fromIndex = 0 */
        ) {
            return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
        }
    }); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

    var includes$4 = entryVirtual('Array').includes;

    var MATCH$1 = wellKnownSymbol('match'); // `IsRegExp` abstract operation
    // https://tc39.es/ecma262/#sec-isregexp

    var isRegexp = function (it) {
        var isRegExp;
        return isObject$1(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
    };

    var notARegexp = function (it) {
        if (isRegexp(it)) {
            throw TypeError("The method doesn't accept regular expressions");
        }

        return it;
    };

    var MATCH = wellKnownSymbol('match');

    var correctIsRegexpLogic = function (METHOD_NAME) {
        var regexp = /./;

        try {
            '/./'[METHOD_NAME](regexp);
        } catch (error1) {
            try {
                regexp[MATCH] = false;
                return '/./'[METHOD_NAME](regexp);
            } catch (error2) {
                /* empty */
            }
        }

        return false;
    };

    // https://tc39.es/ecma262/#sec-string.prototype.includes


    _export({
        target: 'String',
        proto: true,
        forced: !correctIsRegexpLogic('includes')
    }, {
        includes: function includes(searchString
                                    /* , position = 0 */
        ) {
            return !!~String(requireObjectCoercible(this)).indexOf(notARegexp(searchString), arguments.length > 1 ? arguments[1] : undefined);
        }
    });

    var includes$3 = entryVirtual('String').includes;

    var ArrayPrototype$b = Array.prototype;
    var StringPrototype = String.prototype;

    var includes$2 = function (it) {
        var own = it.includes;
        if (it === ArrayPrototype$b || it instanceof Array && own === ArrayPrototype$b.includes) return includes$4;

        if (typeof it === 'string' || it === StringPrototype || it instanceof String && own === StringPrototype.includes) {
            return includes$3;
        }

        return own;
    };

    var includes$1 = includes$2;

    var includes = includes$1;

    var FAILS_ON_PRIMITIVES$1 = fails(function () {
        objectGetPrototypeOf(1);
    }); // `Object.getPrototypeOf` method
    // https://tc39.es/ecma262/#sec-object.getprototypeof

    _export({
        target: 'Object',
        stat: true,
        forced: FAILS_ON_PRIMITIVES$1,
        sham: !correctPrototypeGetter
    }, {
        getPrototypeOf: function getPrototypeOf(it) {
            return objectGetPrototypeOf(toObject(it));
        }
    });

    var getPrototypeOf$4 = path.Object.getPrototypeOf;

    var getPrototypeOf$3 = getPrototypeOf$4;

    var getPrototypeOf$2 = getPrototypeOf$3;

    var $filter = arrayIteration.filter;
    var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter'); // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    // with adding support of @@species

    _export({
        target: 'Array',
        proto: true,
        forced: !HAS_SPECIES_SUPPORT
    }, {
        filter: function filter(callbackfn
                                /* , thisArg */
        ) {
            return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        }
    });

    var filter$2 = entryVirtual('Array').filter;

    var ArrayPrototype$a = Array.prototype;

    var filter_1 = function (it) {
        var own = it.filter;
        return it === ArrayPrototype$a || it instanceof Array && own === ArrayPrototype$a.filter ? filter$2 : own;
    };

    var filter$1 = filter_1;

    var filter = filter$1;

    var propertyIsEnumerable = objectPropertyIsEnumerable.f; // `Object.{ entries, values }` methods implementation

    var createMethod$2 = function (TO_ENTRIES) {
        return function (it) {
            var O = toIndexedObject(it);
            var keys = objectKeys(O);
            var length = keys.length;
            var i = 0;
            var result = [];
            var key;

            while (length > i) {
                key = keys[i++];

                if (!descriptors || propertyIsEnumerable.call(O, key)) {
                    result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
                }
            }

            return result;
        };
    };

    var objectToArray = {
        // `Object.entries` method
        // https://tc39.es/ecma262/#sec-object.entries
        entries: createMethod$2(true),
        // `Object.values` method
        // https://tc39.es/ecma262/#sec-object.values
        values: createMethod$2(false)
    };

    var $values = objectToArray.values; // `Object.values` method
    // https://tc39.es/ecma262/#sec-object.values

    _export({
        target: 'Object',
        stat: true
    }, {
        values: function values(O) {
            return $values(O);
        }
    });

    path.Object.values;

    // a string of all valid unicode whitespaces
    var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' + '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

    var whitespace = '[' + whitespaces + ']';
    var ltrim = RegExp('^' + whitespace + whitespace + '*');
    var rtrim = RegExp(whitespace + whitespace + '*$'); // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation

    var createMethod$1 = function (TYPE) {
        return function ($this) {
            var string = String(requireObjectCoercible($this));
            if (TYPE & 1) string = string.replace(ltrim, '');
            if (TYPE & 2) string = string.replace(rtrim, '');
            return string;
        };
    };

    var stringTrim = {
        // `String.prototype.{ trimLeft, trimStart }` methods
        // https://tc39.es/ecma262/#sec-string.prototype.trimstart
        start: createMethod$1(1),
        // `String.prototype.{ trimRight, trimEnd }` methods
        // https://tc39.es/ecma262/#sec-string.prototype.trimend
        end: createMethod$1(2),
        // `String.prototype.trim` method
        // https://tc39.es/ecma262/#sec-string.prototype.trim
        trim: createMethod$1(3)
    };

    var trim$1 = stringTrim.trim;
    var $parseInt = global$1.parseInt;
    var hex = /^[+-]?0[Xx]/;
    var FORCED$4 = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22; // `parseInt` method
    // https://tc39.es/ecma262/#sec-parseint-string-radix

    var numberParseInt = FORCED$4 ? function parseInt(string, radix) {
        var S = trim$1(String(string));
        return $parseInt(S, radix >>> 0 || (hex.test(S) ? 16 : 10));
    } : $parseInt;

    // https://tc39.es/ecma262/#sec-parseint-string-radix

    _export({
        global: true,
        forced: parseInt != numberParseInt
    }, {
        parseInt: numberParseInt
    });

    var _parseInt$2 = path.parseInt;

    var _parseInt$1 = _parseInt$2;

    var _parseInt = _parseInt$1;

    var $indexOf = arrayIncludes.indexOf;
    var nativeIndexOf = [].indexOf;
    var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
    var STRICT_METHOD$4 = arrayMethodIsStrict('indexOf'); // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof

    _export({
        target: 'Array',
        proto: true,
        forced: NEGATIVE_ZERO || !STRICT_METHOD$4
    }, {
        indexOf: function indexOf(searchElement
                                  /* , fromIndex = 0 */
        ) {
            return NEGATIVE_ZERO // convert -0 to +0
                ? nativeIndexOf.apply(this, arguments) || 0 : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
        }
    });

    var indexOf$2 = entryVirtual('Array').indexOf;

    var ArrayPrototype$9 = Array.prototype;

    var indexOf_1 = function (it) {
        var own = it.indexOf;
        return it === ArrayPrototype$9 || it instanceof Array && own === ArrayPrototype$9.indexOf ? indexOf$2 : own;
    };

    var indexOf$1 = indexOf_1;

    var indexOf = indexOf$1;

    var non = '\u200B\u0085\u180E'; // check that a method works with the correct list
    // of whitespaces and has a correct name

    var stringTrimForced = function (METHOD_NAME) {
        return fails(function () {
            return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
        });
    };

    var $trim = stringTrim.trim; // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim

    _export({
        target: 'String',
        proto: true,
        forced: stringTrimForced('trim')
    }, {
        trim: function trim() {
            return $trim(this);
        }
    });

    entryVirtual('String').trim;

    // https://tc39.es/ecma262/#sec-object.create

    _export({
        target: 'Object',
        stat: true,
        sham: !descriptors
    }, {
        create: objectCreate
    });

    var Object$2 = path.Object;

    var create$4 = function create(P, D) {
        return Object$2.create(P, D);
    };

    var create$3 = create$4;

    var create$2 = create$3;

    var $stringify = getBuiltIn('JSON', 'stringify');
    var re = /[\uD800-\uDFFF]/g;
    var low = /^[\uD800-\uDBFF]$/;
    var hi = /^[\uDC00-\uDFFF]$/;

    var fix = function (match, offset, string) {
        var prev = string.charAt(offset - 1);
        var next = string.charAt(offset + 1);

        if (low.test(match) && !hi.test(next) || hi.test(match) && !low.test(prev)) {
            return '\\u' + match.charCodeAt(0).toString(16);
        }

        return match;
    };

    var FORCED$3 = fails(function () {
        return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"' || $stringify('\uDEAD') !== '"\\udead"';
    });

    if ($stringify) {
        // `JSON.stringify` method
        // https://tc39.es/ecma262/#sec-json.stringify
        // https://github.com/tc39/proposal-well-formed-stringify
        _export({
            target: 'JSON',
            stat: true,
            forced: FORCED$3
        }, {
            // eslint-disable-next-line no-unused-vars -- required for `.length`
            stringify: function stringify(it, replacer, space) {
                var result = $stringify.apply(null, arguments);
                return typeof result == 'string' ? result.replace(re, fix) : result;
            }
        });
    }

    if (!path.JSON) path.JSON = {
        stringify: JSON.stringify
    }; // eslint-disable-next-line no-unused-vars -- required for `.length`

    var stringify$3 = function stringify(it, replacer, space) {
        return path.JSON.stringify.apply(null, arguments);
    };

    var stringify$2 = stringify$3;

    var stringify$1 = stringify$2;

    var slice = [].slice;
    var MSIE = /MSIE .\./.test(engineUserAgent); // <- dirty ie9- check

    var wrap = function (scheduler) {
        return function (handler, timeout
                         /* , ...arguments */
        ) {
            var boundArgs = arguments.length > 2;
            var args = boundArgs ? slice.call(arguments, 2) : undefined;
            return scheduler(boundArgs ? function () {
                // eslint-disable-next-line no-new-func -- spec requirement
                (typeof handler == 'function' ? handler : Function(handler)).apply(this, args);
            } : handler, timeout);
        };
    }; // ie9- setTimeout & setInterval additional parameters fix
    // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers


    _export({
        global: true,
        bind: true,
        forced: MSIE
    }, {
        // `setTimeout` method
        // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
        setTimeout: wrap(global$1.setTimeout),
        // `setInterval` method
        // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
        setInterval: wrap(global$1.setInterval)
    });

    var setTimeout$2 = path.setTimeout;

    var setTimeout$1 = setTimeout$2;

    // https://tc39.es/ecma262/#sec-array.prototype.fill


    var arrayFill = function fill(value
                                  /* , start = 0, end = @length */
    ) {
        var O = toObject(this);
        var length = toLength(O.length);
        var argumentsLength = arguments.length;
        var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
        var end = argumentsLength > 2 ? arguments[2] : undefined;
        var endPos = end === undefined ? length : toAbsoluteIndex(end, length);

        while (endPos > index) O[index++] = value;

        return O;
    };

    // https://tc39.es/ecma262/#sec-array.prototype.fill

    _export({
        target: 'Array',
        proto: true
    }, {
        fill: arrayFill
    }); // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables

    var fill$2 = entryVirtual('Array').fill;

    var ArrayPrototype$8 = Array.prototype;

    var fill_1 = function (it) {
        var own = it.fill;
        return it === ArrayPrototype$8 || it instanceof Array && own === ArrayPrototype$8.fill ? fill$2 : own;
    };

    var fill$1 = fill_1;

    var fill = fill$1;

    /*! Hammer.JS - v2.0.17-rc - 2019-12-16
	 * http://naver.github.io/egjs
	 *
	 * Forked By Naver egjs
	 * Copyright (c) hammerjs
	 * Licensed under the MIT license */
    function _extends() {
        _extends = Object.assign || function (target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i];

                for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }

            return target;
        };

        return _extends.apply(this, arguments);
    }

    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        subClass.__proto__ = superClass;
    }

    function _assertThisInitialized$1(self) {
        if (self === void 0) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return self;
    }
    /**
     * @private
     * extend object.
     * means that properties in dest will be overwritten by the ones in src.
     * @param {Object} target
     * @param {...Object} objects_to_assign
     * @returns {Object} target
     */


    var assign;

    if (typeof Object.assign !== 'function') {
        assign = function assign(target) {
            if (target === undefined || target === null) {
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var output = Object(target);

            for (var index = 1; index < arguments.length; index++) {
                var source = arguments[index];

                if (source !== undefined && source !== null) {
                    for (var nextKey in source) {
                        if (source.hasOwnProperty(nextKey)) {
                            output[nextKey] = source[nextKey];
                        }
                    }
                }
            }

            return output;
        };
    } else {
        assign = Object.assign;
    }

    var assign$1 = assign;
    var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
    var TEST_ELEMENT = typeof document === "undefined" ? {
        style: {}
    } : document.createElement('div');
    var TYPE_FUNCTION = 'function';
    var round = Math.round,
        abs$1 = Math.abs;
    var now = Date.now;
    /**
     * @private
     * get the prefixed property
     * @param {Object} obj
     * @param {String} property
     * @returns {String|Undefined} prefixed
     */

    function prefixed(obj, property) {
        var prefix;
        var prop;
        var camelProp = property[0].toUpperCase() + property.slice(1);
        var i = 0;

        while (i < VENDOR_PREFIXES.length) {
            prefix = VENDOR_PREFIXES[i];
            prop = prefix ? prefix + camelProp : property;

            if (prop in obj) {
                return prop;
            }

            i++;
        }

        return undefined;
    }
    /* eslint-disable no-new-func, no-nested-ternary */


    var win;

    if (typeof window === "undefined") {
        // window is undefined in node.js
        win = {};
    } else {
        win = window;
    }

    var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
    var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

    function getTouchActionProps() {
        if (!NATIVE_TOUCH_ACTION) {
            return false;
        }

        var touchMap = {};
        var cssSupports = win.CSS && win.CSS.supports;
        ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function (val) {
            // If css.supports is not supported but there is native touch-action assume it supports
            // all values. This is the case for IE 10 and 11.
            return touchMap[val] = cssSupports ? win.CSS.supports('touch-action', val) : true;
        });
        return touchMap;
    }

    var TOUCH_ACTION_COMPUTE = 'compute';
    var TOUCH_ACTION_AUTO = 'auto';
    var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented

    var TOUCH_ACTION_NONE = 'none';
    var TOUCH_ACTION_PAN_X = 'pan-x';
    var TOUCH_ACTION_PAN_Y = 'pan-y';
    var TOUCH_ACTION_MAP = getTouchActionProps();
    var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
    var SUPPORT_TOUCH = ('ontouchstart' in win);
    var SUPPORT_POINTER_EVENTS = prefixed(win, 'PointerEvent') !== undefined;
    var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
    var INPUT_TYPE_TOUCH = 'touch';
    var INPUT_TYPE_PEN = 'pen';
    var INPUT_TYPE_MOUSE = 'mouse';
    var INPUT_TYPE_KINECT = 'kinect';
    var COMPUTE_INTERVAL = 25;
    var INPUT_START = 1;
    var INPUT_MOVE = 2;
    var INPUT_END = 4;
    var INPUT_CANCEL = 8;
    var DIRECTION_NONE = 1;
    var DIRECTION_LEFT = 2;
    var DIRECTION_RIGHT = 4;
    var DIRECTION_UP = 8;
    var DIRECTION_DOWN = 16;
    var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
    var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
    var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
    var PROPS_XY = ['x', 'y'];
    var PROPS_CLIENT_XY = ['clientX', 'clientY'];
    /**
     * @private
     * walk objects and arrays
     * @param {Object} obj
     * @param {Function} iterator
     * @param {Object} context
     */

    function each(obj, iterator, context) {
        var i;

        if (!obj) {
            return;
        }

        if (obj.forEach) {
            obj.forEach(iterator, context);
        } else if (obj.length !== undefined) {
            i = 0;

            while (i < obj.length) {
                iterator.call(context, obj[i], i, obj);
                i++;
            }
        } else {
            for (i in obj) {
                obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
            }
        }
    }
    /**
     * @private
     * let a boolean value also be a function that must return a boolean
     * this first item in args will be used as the context
     * @param {Boolean|Function} val
     * @param {Array} [args]
     * @returns {Boolean}
     */


    function boolOrFn(val, args) {
        if (typeof val === TYPE_FUNCTION) {
            return val.apply(args ? args[0] || undefined : undefined, args);
        }

        return val;
    }
    /**
     * @private
     * small indexOf wrapper
     * @param {String} str
     * @param {String} find
     * @returns {Boolean} found
     */


    function inStr(str, find) {
        return str.indexOf(find) > -1;
    }
    /**
     * @private
     * when the touchActions are collected they are not a valid value, so we need to clean things up. *
     * @param {String} actions
     * @returns {*}
     */


    function cleanTouchActions(actions) {
        // none
        if (inStr(actions, TOUCH_ACTION_NONE)) {
            return TOUCH_ACTION_NONE;
        }

        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y); // if both pan-x and pan-y are set (different recognizers
        // for different directions, e.g. horizontal pan but vertical swipe?)
        // we need none (as otherwise with pan-x pan-y combined none of these
        // recognizers will work, since the browser would handle all panning

        if (hasPanX && hasPanY) {
            return TOUCH_ACTION_NONE;
        } // pan-x OR pan-y


        if (hasPanX || hasPanY) {
            return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
        } // manipulation


        if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
            return TOUCH_ACTION_MANIPULATION;
        }

        return TOUCH_ACTION_AUTO;
    }
    /**
     * @private
     * Touch Action
     * sets the touchAction property or uses the js alternative
     * @param {Manager} manager
     * @param {String} value
     * @constructor
     */


    var TouchAction = /*#__PURE__*/function () {
        function TouchAction(manager, value) {
            this.manager = manager;
            this.set(value);
        }
        /**
         * @private
         * set the touchAction value on the element or enable the polyfill
         * @param {String} value
         */


        var _proto = TouchAction.prototype;

        _proto.set = function set(value) {
            // find out the touch-action by the event handlers
            if (value === TOUCH_ACTION_COMPUTE) {
                value = this.compute();
            }

            if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
                this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
            }

            this.actions = value.toLowerCase().trim();
        };
        /**
         * @private
         * just re-set the touchAction value
         */


        _proto.update = function update() {
            this.set(this.manager.options.touchAction);
        };
        /**
         * @private
         * compute the value for the touchAction property based on the recognizer's settings
         * @returns {String} value
         */


        _proto.compute = function compute() {
            var actions = [];
            each(this.manager.recognizers, function (recognizer) {
                if (boolOrFn(recognizer.options.enable, [recognizer])) {
                    actions = actions.concat(recognizer.getTouchAction());
                }
            });
            return cleanTouchActions(actions.join(' '));
        };
        /**
         * @private
         * this method is called on each input cycle and provides the preventing of the browser behavior
         * @param {Object} input
         */


        _proto.preventDefaults = function preventDefaults(input) {
            var srcEvent = input.srcEvent;
            var direction = input.offsetDirection; // if the touch action did prevented once this session

            if (this.manager.session.prevented) {
                srcEvent.preventDefault();
                return;
            }

            var actions = this.actions;
            var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
            var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
            var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

            if (hasNone) {
                // do not prevent defaults if this is a tap gesture
                var isTapPointer = input.pointers.length === 1;
                var isTapMovement = input.distance < 2;
                var isTapTouchTime = input.deltaTime < 250;

                if (isTapPointer && isTapMovement && isTapTouchTime) {
                    return;
                }
            }

            if (hasPanX && hasPanY) {
                // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
                return;
            }

            if (hasNone || hasPanY && direction & DIRECTION_HORIZONTAL || hasPanX && direction & DIRECTION_VERTICAL) {
                return this.preventSrc(srcEvent);
            }
        };
        /**
         * @private
         * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
         * @param {Object} srcEvent
         */


        _proto.preventSrc = function preventSrc(srcEvent) {
            this.manager.session.prevented = true;
            srcEvent.preventDefault();
        };

        return TouchAction;
    }();
    /**
     * @private
     * find if a node is in the given parent
     * @method hasParent
     * @param {HTMLElement} node
     * @param {HTMLElement} parent
     * @return {Boolean} found
     */


    function hasParent(node, parent) {
        while (node) {
            if (node === parent) {
                return true;
            }

            node = node.parentNode;
        }

        return false;
    }
    /**
     * @private
     * get the center of all the pointers
     * @param {Array} pointers
     * @return {Object} center contains `x` and `y` properties
     */


    function getCenter(pointers) {
        var pointersLength = pointers.length; // no need to loop when only one touch

        if (pointersLength === 1) {
            return {
                x: round(pointers[0].clientX),
                y: round(pointers[0].clientY)
            };
        }

        var x = 0;
        var y = 0;
        var i = 0;

        while (i < pointersLength) {
            x += pointers[i].clientX;
            y += pointers[i].clientY;
            i++;
        }

        return {
            x: round(x / pointersLength),
            y: round(y / pointersLength)
        };
    }
    /**
     * @private
     * create a simple clone from the input used for storage of firstInput and firstMultiple
     * @param {Object} input
     * @returns {Object} clonedInputData
     */


    function simpleCloneInputData(input) {
        // make a simple copy of the pointers because we will get a reference if we don't
        // we only need clientXY for the calculations
        var pointers = [];
        var i = 0;

        while (i < input.pointers.length) {
            pointers[i] = {
                clientX: round(input.pointers[i].clientX),
                clientY: round(input.pointers[i].clientY)
            };
            i++;
        }

        return {
            timeStamp: now(),
            pointers: pointers,
            center: getCenter(pointers),
            deltaX: input.deltaX,
            deltaY: input.deltaY
        };
    }
    /**
     * @private
     * calculate the absolute distance between two points
     * @param {Object} p1 {x, y}
     * @param {Object} p2 {x, y}
     * @param {Array} [props] containing x and y keys
     * @return {Number} distance
     */


    function getDistance(p1, p2, props) {
        if (!props) {
            props = PROPS_XY;
        }

        var x = p2[props[0]] - p1[props[0]];
        var y = p2[props[1]] - p1[props[1]];
        return Math.sqrt(x * x + y * y);
    }
    /**
     * @private
     * calculate the angle between two coordinates
     * @param {Object} p1
     * @param {Object} p2
     * @param {Array} [props] containing x and y keys
     * @return {Number} angle
     */


    function getAngle(p1, p2, props) {
        if (!props) {
            props = PROPS_XY;
        }

        var x = p2[props[0]] - p1[props[0]];
        var y = p2[props[1]] - p1[props[1]];
        return Math.atan2(y, x) * 180 / Math.PI;
    }
    /**
     * @private
     * get the direction between two points
     * @param {Number} x
     * @param {Number} y
     * @return {Number} direction
     */


    function getDirection(x, y) {
        if (x === y) {
            return DIRECTION_NONE;
        }

        if (abs$1(x) >= abs$1(y)) {
            return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
        }

        return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
    }

    function computeDeltaXY(session, input) {
        var center = input.center; // let { offsetDelta:offset = {}, prevDelta = {}, prevInput = {} } = session;
        // jscs throwing error on defalut destructured values and without defaults tests fail

        var offset = session.offsetDelta || {};
        var prevDelta = session.prevDelta || {};
        var prevInput = session.prevInput || {};

        if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
            prevDelta = session.prevDelta = {
                x: prevInput.deltaX || 0,
                y: prevInput.deltaY || 0
            };
            offset = session.offsetDelta = {
                x: center.x,
                y: center.y
            };
        }

        input.deltaX = prevDelta.x + (center.x - offset.x);
        input.deltaY = prevDelta.y + (center.y - offset.y);
    }
    /**
     * @private
     * calculate the velocity between two points. unit is in px per ms.
     * @param {Number} deltaTime
     * @param {Number} x
     * @param {Number} y
     * @return {Object} velocity `x` and `y`
     */


    function getVelocity(deltaTime, x, y) {
        return {
            x: x / deltaTime || 0,
            y: y / deltaTime || 0
        };
    }
    /**
     * @private
     * calculate the scale factor between two pointersets
     * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
     * @param {Array} start array of pointers
     * @param {Array} end array of pointers
     * @return {Number} scale
     */


    function getScale(start, end) {
        return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
    }
    /**
     * @private
     * calculate the rotation degrees between two pointersets
     * @param {Array} start array of pointers
     * @param {Array} end array of pointers
     * @return {Number} rotation
     */


    function getRotation(start, end) {
        return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
    }
    /**
     * @private
     * velocity is calculated every x ms
     * @param {Object} session
     * @param {Object} input
     */


    function computeIntervalInputData(session, input) {
        var last = session.lastInterval || input;
        var deltaTime = input.timeStamp - last.timeStamp;
        var velocity;
        var velocityX;
        var velocityY;
        var direction;

        if (input.eventType !== INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
            var deltaX = input.deltaX - last.deltaX;
            var deltaY = input.deltaY - last.deltaY;
            var v = getVelocity(deltaTime, deltaX, deltaY);
            velocityX = v.x;
            velocityY = v.y;
            velocity = abs$1(v.x) > abs$1(v.y) ? v.x : v.y;
            direction = getDirection(deltaX, deltaY);
            session.lastInterval = input;
        } else {
            // use latest velocity info if it doesn't overtake a minimum period
            velocity = last.velocity;
            velocityX = last.velocityX;
            velocityY = last.velocityY;
            direction = last.direction;
        }

        input.velocity = velocity;
        input.velocityX = velocityX;
        input.velocityY = velocityY;
        input.direction = direction;
    }
    /**
     * @private
     * extend the data with some usable properties like scale, rotate, velocity etc
     * @param {Object} manager
     * @param {Object} input
     */


    function computeInputData(manager, input) {
        var session = manager.session;
        var pointers = input.pointers;
        var pointersLength = pointers.length; // store the first input to calculate the distance and direction

        if (!session.firstInput) {
            session.firstInput = simpleCloneInputData(input);
        } // to compute scale and rotation we need to store the multiple touches


        if (pointersLength > 1 && !session.firstMultiple) {
            session.firstMultiple = simpleCloneInputData(input);
        } else if (pointersLength === 1) {
            session.firstMultiple = false;
        }

        var firstInput = session.firstInput,
            firstMultiple = session.firstMultiple;
        var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
        var center = input.center = getCenter(pointers);
        input.timeStamp = now();
        input.deltaTime = input.timeStamp - firstInput.timeStamp;
        input.angle = getAngle(offsetCenter, center);
        input.distance = getDistance(offsetCenter, center);
        computeDeltaXY(session, input);
        input.offsetDirection = getDirection(input.deltaX, input.deltaY);
        var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
        input.overallVelocityX = overallVelocity.x;
        input.overallVelocityY = overallVelocity.y;
        input.overallVelocity = abs$1(overallVelocity.x) > abs$1(overallVelocity.y) ? overallVelocity.x : overallVelocity.y;
        input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
        input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
        input.maxPointers = !session.prevInput ? input.pointers.length : input.pointers.length > session.prevInput.maxPointers ? input.pointers.length : session.prevInput.maxPointers;
        computeIntervalInputData(session, input); // find the correct target

        var target = manager.element;
        var srcEvent = input.srcEvent;
        var srcEventTarget;

        if (srcEvent.composedPath) {
            srcEventTarget = srcEvent.composedPath()[0];
        } else if (srcEvent.path) {
            srcEventTarget = srcEvent.path[0];
        } else {
            srcEventTarget = srcEvent.target;
        }

        if (hasParent(srcEventTarget, target)) {
            target = srcEventTarget;
        }

        input.target = target;
    }
    /**
     * @private
     * handle input events
     * @param {Manager} manager
     * @param {String} eventType
     * @param {Object} input
     */


    function inputHandler(manager, eventType, input) {
        var pointersLen = input.pointers.length;
        var changedPointersLen = input.changedPointers.length;
        var isFirst = eventType & INPUT_START && pointersLen - changedPointersLen === 0;
        var isFinal = eventType & (INPUT_END | INPUT_CANCEL) && pointersLen - changedPointersLen === 0;
        input.isFirst = !!isFirst;
        input.isFinal = !!isFinal;

        if (isFirst) {
            manager.session = {};
        } // source event is the normalized value of the domEvents
        // like 'touchstart, mouseup, pointerdown'


        input.eventType = eventType; // compute scale, rotation etc

        computeInputData(manager, input); // emit secret event

        manager.emit('hammer.input', input);
        manager.recognize(input);
        manager.session.prevInput = input;
    }
    /**
     * @private
     * split string on whitespace
     * @param {String} str
     * @returns {Array} words
     */


    function splitStr(str) {
        return str.trim().split(/\s+/g);
    }
    /**
     * @private
     * addEventListener with multiple events at once
     * @param {EventTarget} target
     * @param {String} types
     * @param {Function} handler
     */


    function addEventListeners(target, types, handler) {
        each(splitStr(types), function (type) {
            target.addEventListener(type, handler, false);
        });
    }
    /**
     * @private
     * removeEventListener with multiple events at once
     * @param {EventTarget} target
     * @param {String} types
     * @param {Function} handler
     */


    function removeEventListeners(target, types, handler) {
        each(splitStr(types), function (type) {
            target.removeEventListener(type, handler, false);
        });
    }
    /**
     * @private
     * get the window object of an element
     * @param {HTMLElement} element
     * @returns {DocumentView|Window}
     */


    function getWindowForElement(element) {
        var doc = element.ownerDocument || element;
        return doc.defaultView || doc.parentWindow || window;
    }
    /**
     * @private
     * create new input type manager
     * @param {Manager} manager
     * @param {Function} callback
     * @returns {Input}
     * @constructor
     */


    var Input = /*#__PURE__*/function () {
        function Input(manager, callback) {
            var self = this;
            this.manager = manager;
            this.callback = callback;
            this.element = manager.element;
            this.target = manager.options.inputTarget; // smaller wrapper around the handler, for the scope and the enabled state of the manager,
            // so when disabled the input events are completely bypassed.

            this.domHandler = function (ev) {
                if (boolOrFn(manager.options.enable, [manager])) {
                    self.handler(ev);
                }
            };

            this.init();
        }
        /**
         * @private
         * should handle the inputEvent data and trigger the callback
         * @virtual
         */


        var _proto = Input.prototype;

        _proto.handler = function handler() {};
        /**
         * @private
         * bind the events
         */


        _proto.init = function init() {
            this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        };
        /**
         * @private
         * unbind the events
         */


        _proto.destroy = function destroy() {
            this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        };

        return Input;
    }();
    /**
     * @private
     * find if a array contains the object using indexOf or a simple polyFill
     * @param {Array} src
     * @param {String} find
     * @param {String} [findByKey]
     * @return {Boolean|Number} false when not found, or the index
     */


    function inArray(src, find, findByKey) {
        if (src.indexOf && !findByKey) {
            return src.indexOf(find);
        } else {
            var i = 0;

            while (i < src.length) {
                if (findByKey && src[i][findByKey] == find || !findByKey && src[i] === find) {
                    // do not use === here, test fails
                    return i;
                }

                i++;
            }

            return -1;
        }
    }

    var POINTER_INPUT_MAP = {
        pointerdown: INPUT_START,
        pointermove: INPUT_MOVE,
        pointerup: INPUT_END,
        pointercancel: INPUT_CANCEL,
        pointerout: INPUT_CANCEL
    }; // in IE10 the pointer types is defined as an enum

    var IE10_POINTER_TYPE_ENUM = {
        2: INPUT_TYPE_TOUCH,
        3: INPUT_TYPE_PEN,
        4: INPUT_TYPE_MOUSE,
        5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816

    };
    var POINTER_ELEMENT_EVENTS = 'pointerdown';
    var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel'; // IE10 has prefixed support, and case-sensitive

    if (win.MSPointerEvent && !win.PointerEvent) {
        POINTER_ELEMENT_EVENTS = 'MSPointerDown';
        POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
    }
    /**
     * @private
     * Pointer events input
     * @constructor
     * @extends Input
     */


    var PointerEventInput = /*#__PURE__*/function (_Input) {
        _inheritsLoose(PointerEventInput, _Input);

        function PointerEventInput() {
            var _this;

            var proto = PointerEventInput.prototype;
            proto.evEl = POINTER_ELEMENT_EVENTS;
            proto.evWin = POINTER_WINDOW_EVENTS;
            _this = _Input.apply(this, arguments) || this;
            _this.store = _this.manager.session.pointerEvents = [];
            return _this;
        }
        /**
         * @private
         * handle mouse events
         * @param {Object} ev
         */


        var _proto = PointerEventInput.prototype;

        _proto.handler = function handler(ev) {
            var store = this.store;
            var removePointer = false;
            var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
            var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
            var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
            var isTouch = pointerType === INPUT_TYPE_TOUCH; // get index of the event in the store

            var storeIndex = inArray(store, ev.pointerId, 'pointerId'); // start and mouse must be down

            if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
                if (storeIndex < 0) {
                    store.push(ev);
                    storeIndex = store.length - 1;
                }
            } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
                removePointer = true;
            } // it not found, so the pointer hasn't been down (so it's probably a hover)


            if (storeIndex < 0) {
                return;
            } // update the event in the store


            store[storeIndex] = ev;
            this.callback(this.manager, eventType, {
                pointers: store,
                changedPointers: [ev],
                pointerType: pointerType,
                srcEvent: ev
            });

            if (removePointer) {
                // remove from the store
                store.splice(storeIndex, 1);
            }
        };

        return PointerEventInput;
    }(Input);
    /**
     * @private
     * convert array-like objects to real arrays
     * @param {Object} obj
     * @returns {Array}
     */


    function toArray(obj) {
        return Array.prototype.slice.call(obj, 0);
    }
    /**
     * @private
     * unique array with objects based on a key (like 'id') or just by the array's value
     * @param {Array} src [{id:1},{id:2},{id:1}]
     * @param {String} [key]
     * @param {Boolean} [sort=False]
     * @returns {Array} [{id:1},{id:2}]
     */


    function uniqueArray(src, key, sort) {
        var results = [];
        var values = [];
        var i = 0;

        while (i < src.length) {
            var val = key ? src[i][key] : src[i];

            if (inArray(values, val) < 0) {
                results.push(src[i]);
            }

            values[i] = val;
            i++;
        }

        if (sort) {
            if (!key) {
                results = results.sort();
            } else {
                results = results.sort(function (a, b) {
                    return a[key] > b[key];
                });
            }
        }

        return results;
    }

    var TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
    /**
     * @private
     * Multi-user touch events input
     * @constructor
     * @extends Input
     */

    var TouchInput = /*#__PURE__*/function (_Input) {
        _inheritsLoose(TouchInput, _Input);

        function TouchInput() {
            var _this;

            TouchInput.prototype.evTarget = TOUCH_TARGET_EVENTS;
            _this = _Input.apply(this, arguments) || this;
            _this.targetIds = {}; // this.evTarget = TOUCH_TARGET_EVENTS;

            return _this;
        }

        var _proto = TouchInput.prototype;

        _proto.handler = function handler(ev) {
            var type = TOUCH_INPUT_MAP[ev.type];
            var touches = getTouches.call(this, ev, type);

            if (!touches) {
                return;
            }

            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        };

        return TouchInput;
    }(Input);

    function getTouches(ev, type) {
        var allTouches = toArray(ev.touches);
        var targetIds = this.targetIds; // when there is only one touch, the process can be simplified

        if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
            targetIds[allTouches[0].identifier] = true;
            return [allTouches, allTouches];
        }

        var i;
        var targetTouches;
        var changedTouches = toArray(ev.changedTouches);
        var changedTargetTouches = [];
        var target = this.target; // get target touches from touches

        targetTouches = allTouches.filter(function (touch) {
            return hasParent(touch.target, target);
        }); // collect touches

        if (type === INPUT_START) {
            i = 0;

            while (i < targetTouches.length) {
                targetIds[targetTouches[i].identifier] = true;
                i++;
            }
        } // filter changed touches to only contain touches that exist in the collected target ids


        i = 0;

        while (i < changedTouches.length) {
            if (targetIds[changedTouches[i].identifier]) {
                changedTargetTouches.push(changedTouches[i]);
            } // cleanup removed touches


            if (type & (INPUT_END | INPUT_CANCEL)) {
                delete targetIds[changedTouches[i].identifier];
            }

            i++;
        }

        if (!changedTargetTouches.length) {
            return;
        }

        return [// merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
            uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true), changedTargetTouches];
    }

    var MOUSE_INPUT_MAP = {
        mousedown: INPUT_START,
        mousemove: INPUT_MOVE,
        mouseup: INPUT_END
    };
    var MOUSE_ELEMENT_EVENTS = 'mousedown';
    var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
    /**
     * @private
     * Mouse events input
     * @constructor
     * @extends Input
     */

    var MouseInput = /*#__PURE__*/function (_Input) {
        _inheritsLoose(MouseInput, _Input);

        function MouseInput() {
            var _this;

            var proto = MouseInput.prototype;
            proto.evEl = MOUSE_ELEMENT_EVENTS;
            proto.evWin = MOUSE_WINDOW_EVENTS;
            _this = _Input.apply(this, arguments) || this;
            _this.pressed = false; // mousedown state

            return _this;
        }
        /**
         * @private
         * handle mouse events
         * @param {Object} ev
         */


        var _proto = MouseInput.prototype;

        _proto.handler = function handler(ev) {
            var eventType = MOUSE_INPUT_MAP[ev.type]; // on start we want to have the left mouse button down

            if (eventType & INPUT_START && ev.button === 0) {
                this.pressed = true;
            }

            if (eventType & INPUT_MOVE && ev.which !== 1) {
                eventType = INPUT_END;
            } // mouse must be down


            if (!this.pressed) {
                return;
            }

            if (eventType & INPUT_END) {
                this.pressed = false;
            }

            this.callback(this.manager, eventType, {
                pointers: [ev],
                changedPointers: [ev],
                pointerType: INPUT_TYPE_MOUSE,
                srcEvent: ev
            });
        };

        return MouseInput;
    }(Input);
    /**
     * @private
     * Combined touch and mouse input
     *
     * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
     * This because touch devices also emit mouse events while doing a touch.
     *
     * @constructor
     * @extends Input
     */


    var DEDUP_TIMEOUT = 2500;
    var DEDUP_DISTANCE = 25;

    function setLastTouch(eventData) {
        var _eventData$changedPoi = eventData.changedPointers,
            touch = _eventData$changedPoi[0];

        if (touch.identifier === this.primaryTouch) {
            var lastTouch = {
                x: touch.clientX,
                y: touch.clientY
            };
            var lts = this.lastTouches;
            this.lastTouches.push(lastTouch);

            var removeLastTouch = function removeLastTouch() {
                var i = lts.indexOf(lastTouch);

                if (i > -1) {
                    lts.splice(i, 1);
                }
            };

            setTimeout(removeLastTouch, DEDUP_TIMEOUT);
        }
    }

    function recordTouches(eventType, eventData) {
        if (eventType & INPUT_START) {
            this.primaryTouch = eventData.changedPointers[0].identifier;
            setLastTouch.call(this, eventData);
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            setLastTouch.call(this, eventData);
        }
    }

    function isSyntheticEvent(eventData) {
        var x = eventData.srcEvent.clientX;
        var y = eventData.srcEvent.clientY;

        for (var i = 0; i < this.lastTouches.length; i++) {
            var t = this.lastTouches[i];
            var dx = Math.abs(x - t.x);
            var dy = Math.abs(y - t.y);

            if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
                return true;
            }
        }

        return false;
    }

    var TouchMouseInput = /*#__PURE__*/function () {
        var TouchMouseInput = /*#__PURE__*/function (_Input) {
            _inheritsLoose(TouchMouseInput, _Input);

            function TouchMouseInput(_manager, callback) {
                var _this;

                _this = _Input.call(this, _manager, callback) || this;

                _this.handler = function (manager, inputEvent, inputData) {
                    var isTouch = inputData.pointerType === INPUT_TYPE_TOUCH;
                    var isMouse = inputData.pointerType === INPUT_TYPE_MOUSE;

                    if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
                        return;
                    } // when we're in a touch event, record touches to  de-dupe synthetic mouse event


                    if (isTouch) {
                        recordTouches.call(_assertThisInitialized$1(_assertThisInitialized$1(_this)), inputEvent, inputData);
                    } else if (isMouse && isSyntheticEvent.call(_assertThisInitialized$1(_assertThisInitialized$1(_this)), inputData)) {
                        return;
                    }

                    _this.callback(manager, inputEvent, inputData);
                };

                _this.touch = new TouchInput(_this.manager, _this.handler);
                _this.mouse = new MouseInput(_this.manager, _this.handler);
                _this.primaryTouch = null;
                _this.lastTouches = [];
                return _this;
            }
            /**
             * @private
             * handle mouse and touch events
             * @param {Hammer} manager
             * @param {String} inputEvent
             * @param {Object} inputData
             */


            var _proto = TouchMouseInput.prototype;
            /**
             * @private
             * remove the event listeners
             */

            _proto.destroy = function destroy() {
                this.touch.destroy();
                this.mouse.destroy();
            };

            return TouchMouseInput;
        }(Input);

        return TouchMouseInput;
    }();
    /**
     * @private
     * create new input type manager
     * called by the Manager constructor
     * @param {Hammer} manager
     * @returns {Input}
     */


    function createInputInstance(manager) {
        var Type; // let inputClass = manager.options.inputClass;

        var inputClass = manager.options.inputClass;

        if (inputClass) {
            Type = inputClass;
        } else if (SUPPORT_POINTER_EVENTS) {
            Type = PointerEventInput;
        } else if (SUPPORT_ONLY_TOUCH) {
            Type = TouchInput;
        } else if (!SUPPORT_TOUCH) {
            Type = MouseInput;
        } else {
            Type = TouchMouseInput;
        }

        return new Type(manager, inputHandler);
    }
    /**
     * @private
     * if the argument is an array, we want to execute the fn on each entry
     * if it aint an array we don't want to do a thing.
     * this is used by all the methods that accept a single and array argument.
     * @param {*|Array} arg
     * @param {String} fn
     * @param {Object} [context]
     * @returns {Boolean}
     */


    function invokeArrayArg(arg, fn, context) {
        if (Array.isArray(arg)) {
            each(arg, context[fn], context);
            return true;
        }

        return false;
    }

    var STATE_POSSIBLE = 1;
    var STATE_BEGAN = 2;
    var STATE_CHANGED = 4;
    var STATE_ENDED = 8;
    var STATE_RECOGNIZED = STATE_ENDED;
    var STATE_CANCELLED = 16;
    var STATE_FAILED = 32;
    /**
     * @private
     * get a unique id
     * @returns {number} uniqueId
     */

    var _uniqueId = 1;

    function uniqueId() {
        return _uniqueId++;
    }
    /**
     * @private
     * get a recognizer by name if it is bound to a manager
     * @param {Recognizer|String} otherRecognizer
     * @param {Recognizer} recognizer
     * @returns {Recognizer}
     */


    function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
        var manager = recognizer.manager;

        if (manager) {
            return manager.get(otherRecognizer);
        }

        return otherRecognizer;
    }
    /**
     * @private
     * get a usable string, used as event postfix
     * @param {constant} state
     * @returns {String} state
     */


    function stateStr(state) {
        if (state & STATE_CANCELLED) {
            return 'cancel';
        } else if (state & STATE_ENDED) {
            return 'end';
        } else if (state & STATE_CHANGED) {
            return 'move';
        } else if (state & STATE_BEGAN) {
            return 'start';
        }

        return '';
    }
    /**
     * @private
     * Recognizer flow explained; *
     * All recognizers have the initial state of POSSIBLE when a input session starts.
     * The definition of a input session is from the first input until the last input, with all it's movement in it. *
     * Example session for mouse-input: mousedown -> mousemove -> mouseup
     *
     * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
     * which determines with state it should be.
     *
     * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
     * POSSIBLE to give it another change on the next cycle.
     *
     *               Possible
     *                  |
     *            +-----+---------------+
     *            |                     |
     *      +-----+-----+               |
     *      |           |               |
     *   Failed      Cancelled          |
     *                          +-------+------+
     *                          |              |
     *                      Recognized       Began
     *                                         |
     *                                      Changed
     *                                         |
     *                                  Ended/Recognized
     */

    /**
     * @private
     * Recognizer
     * Every recognizer needs to extend from this class.
     * @constructor
     * @param {Object} options
     */


    var Recognizer = /*#__PURE__*/function () {
        function Recognizer(options) {
            if (options === void 0) {
                options = {};
            }

            this.options = _extends({
                enable: true
            }, options);
            this.id = uniqueId();
            this.manager = null; // default is enable true

            this.state = STATE_POSSIBLE;
            this.simultaneous = {};
            this.requireFail = [];
        }
        /**
         * @private
         * set options
         * @param {Object} options
         * @return {Recognizer}
         */


        var _proto = Recognizer.prototype;

        _proto.set = function set(options) {
            assign$1(this.options, options); // also update the touchAction, in case something changed about the directions/enabled state

            this.manager && this.manager.touchAction.update();
            return this;
        };
        /**
         * @private
         * recognize simultaneous with an other recognizer.
         * @param {Recognizer} otherRecognizer
         * @returns {Recognizer} this
         */


        _proto.recognizeWith = function recognizeWith(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
                return this;
            }

            var simultaneous = this.simultaneous;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);

            if (!simultaneous[otherRecognizer.id]) {
                simultaneous[otherRecognizer.id] = otherRecognizer;
                otherRecognizer.recognizeWith(this);
            }

            return this;
        };
        /**
         * @private
         * drop the simultaneous link. it doesnt remove the link on the other recognizer.
         * @param {Recognizer} otherRecognizer
         * @returns {Recognizer} this
         */


        _proto.dropRecognizeWith = function dropRecognizeWith(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
                return this;
            }

            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            delete this.simultaneous[otherRecognizer.id];
            return this;
        };
        /**
         * @private
         * recognizer can only run when an other is failing
         * @param {Recognizer} otherRecognizer
         * @returns {Recognizer} this
         */


        _proto.requireFailure = function requireFailure(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
                return this;
            }

            var requireFail = this.requireFail;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);

            if (inArray(requireFail, otherRecognizer) === -1) {
                requireFail.push(otherRecognizer);
                otherRecognizer.requireFailure(this);
            }

            return this;
        };
        /**
         * @private
         * drop the requireFailure link. it does not remove the link on the other recognizer.
         * @param {Recognizer} otherRecognizer
         * @returns {Recognizer} this
         */


        _proto.dropRequireFailure = function dropRequireFailure(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
                return this;
            }

            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            var index = inArray(this.requireFail, otherRecognizer);

            if (index > -1) {
                this.requireFail.splice(index, 1);
            }

            return this;
        };
        /**
         * @private
         * has require failures boolean
         * @returns {boolean}
         */


        _proto.hasRequireFailures = function hasRequireFailures() {
            return this.requireFail.length > 0;
        };
        /**
         * @private
         * if the recognizer can recognize simultaneous with an other recognizer
         * @param {Recognizer} otherRecognizer
         * @returns {Boolean}
         */


        _proto.canRecognizeWith = function canRecognizeWith(otherRecognizer) {
            return !!this.simultaneous[otherRecognizer.id];
        };
        /**
         * @private
         * You should use `tryEmit` instead of `emit` directly to check
         * that all the needed recognizers has failed before emitting.
         * @param {Object} input
         */


        _proto.emit = function emit(input) {
            var self = this;
            var state = this.state;

            function emit(event) {
                self.manager.emit(event, input);
            } // 'panstart' and 'panmove'


            if (state < STATE_ENDED) {
                emit(self.options.event + stateStr(state));
            }

            emit(self.options.event); // simple 'eventName' events

            if (input.additionalEvent) {
                // additional event(panleft, panright, pinchin, pinchout...)
                emit(input.additionalEvent);
            } // panend and pancancel


            if (state >= STATE_ENDED) {
                emit(self.options.event + stateStr(state));
            }
        };
        /**
         * @private
         * Check that all the require failure recognizers has failed,
         * if true, it emits a gesture event,
         * otherwise, setup the state to FAILED.
         * @param {Object} input
         */


        _proto.tryEmit = function tryEmit(input) {
            if (this.canEmit()) {
                return this.emit(input);
            } // it's failing anyway


            this.state = STATE_FAILED;
        };
        /**
         * @private
         * can we emit?
         * @returns {boolean}
         */


        _proto.canEmit = function canEmit() {
            var i = 0;

            while (i < this.requireFail.length) {
                if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                    return false;
                }

                i++;
            }

            return true;
        };
        /**
         * @private
         * update the recognizer
         * @param {Object} inputData
         */


        _proto.recognize = function recognize(inputData) {
            // make a new copy of the inputData
            // so we can change the inputData without messing up the other recognizers
            var inputDataClone = assign$1({}, inputData); // is is enabled and allow recognizing?

            if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
                this.reset();
                this.state = STATE_FAILED;
                return;
            } // reset when we've reached the end


            if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
                this.state = STATE_POSSIBLE;
            }

            this.state = this.process(inputDataClone); // the recognizer has recognized a gesture
            // so trigger an event

            if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
                this.tryEmit(inputDataClone);
            }
        };
        /**
         * @private
         * return the state of the recognizer
         * the actual recognizing happens in this method
         * @virtual
         * @param {Object} inputData
         * @returns {constant} STATE
         */

        /* jshint ignore:start */


        _proto.process = function process(inputData) {};
        /* jshint ignore:end */

        /**
         * @private
         * return the preferred touch-action
         * @virtual
         * @returns {Array}
         */


        _proto.getTouchAction = function getTouchAction() {};
        /**
         * @private
         * called when the gesture isn't allowed to recognize
         * like when another is being recognized or it is disabled
         * @virtual
         */


        _proto.reset = function reset() {};

        return Recognizer;
    }();
    /**
     * @private
     * A tap is recognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
     * between the given interval and position. The delay option can be used to recognize multi-taps without firing
     * a single tap.
     *
     * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
     * multi-taps being recognized.
     * @constructor
     * @extends Recognizer
     */


    var TapRecognizer = /*#__PURE__*/function (_Recognizer) {
        _inheritsLoose(TapRecognizer, _Recognizer);

        function TapRecognizer(options) {
            var _this;

            if (options === void 0) {
                options = {};
            }

            _this = _Recognizer.call(this, _extends({
                event: 'tap',
                pointers: 1,
                taps: 1,
                interval: 300,
                // max time between the multi-tap taps
                time: 250,
                // max time of the pointer to be down (like finger on the screen)
                threshold: 9,
                // a minimal movement is ok, but keep it low
                posThreshold: 10
            }, options)) || this; // previous time and center,
            // used for tap counting

            _this.pTime = false;
            _this.pCenter = false;
            _this._timer = null;
            _this._input = null;
            _this.count = 0;
            return _this;
        }

        var _proto = TapRecognizer.prototype;

        _proto.getTouchAction = function getTouchAction() {
            return [TOUCH_ACTION_MANIPULATION];
        };

        _proto.process = function process(input) {
            var _this2 = this;

            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTouchTime = input.deltaTime < options.time;
            this.reset();

            if (input.eventType & INPUT_START && this.count === 0) {
                return this.failTimeout();
            } // we only allow little movement
            // and we've reached an end event, so a tap is possible


            if (validMovement && validTouchTime && validPointers) {
                if (input.eventType !== INPUT_END) {
                    return this.failTimeout();
                }

                var validInterval = this.pTime ? input.timeStamp - this.pTime < options.interval : true;
                var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
                this.pTime = input.timeStamp;
                this.pCenter = input.center;

                if (!validMultiTap || !validInterval) {
                    this.count = 1;
                } else {
                    this.count += 1;
                }

                this._input = input; // if tap count matches we have recognized it,
                // else it has began recognizing...

                var tapCount = this.count % options.taps;

                if (tapCount === 0) {
                    // no failing requirements, immediately trigger the tap event
                    // or wait as long as the multitap interval to trigger
                    if (!this.hasRequireFailures()) {
                        return STATE_RECOGNIZED;
                    } else {
                        this._timer = setTimeout(function () {
                            _this2.state = STATE_RECOGNIZED;

                            _this2.tryEmit();
                        }, options.interval);
                        return STATE_BEGAN;
                    }
                }
            }

            return STATE_FAILED;
        };

        _proto.failTimeout = function failTimeout() {
            var _this3 = this;

            this._timer = setTimeout(function () {
                _this3.state = STATE_FAILED;
            }, this.options.interval);
            return STATE_FAILED;
        };

        _proto.reset = function reset() {
            clearTimeout(this._timer);
        };

        _proto.emit = function emit() {
            if (this.state === STATE_RECOGNIZED) {
                this._input.tapCount = this.count;
                this.manager.emit(this.options.event, this._input);
            }
        };

        return TapRecognizer;
    }(Recognizer);
    /**
     * @private
     * This recognizer is just used as a base for the simple attribute recognizers.
     * @constructor
     * @extends Recognizer
     */


    var AttrRecognizer = /*#__PURE__*/function (_Recognizer) {
        _inheritsLoose(AttrRecognizer, _Recognizer);

        function AttrRecognizer(options) {
            if (options === void 0) {
                options = {};
            }

            return _Recognizer.call(this, _extends({
                pointers: 1
            }, options)) || this;
        }
        /**
         * @private
         * Used to check if it the recognizer receives valid input, like input.distance > 10.
         * @memberof AttrRecognizer
         * @param {Object} input
         * @returns {Boolean} recognized
         */


        var _proto = AttrRecognizer.prototype;

        _proto.attrTest = function attrTest(input) {
            var optionPointers = this.options.pointers;
            return optionPointers === 0 || input.pointers.length === optionPointers;
        };
        /**
         * @private
         * Process the input and return the state for the recognizer
         * @memberof AttrRecognizer
         * @param {Object} input
         * @returns {*} State
         */


        _proto.process = function process(input) {
            var state = this.state;
            var eventType = input.eventType;
            var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
            var isValid = this.attrTest(input); // on cancel input and we've recognized before, return STATE_CANCELLED

            if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
                return state | STATE_CANCELLED;
            } else if (isRecognized || isValid) {
                if (eventType & INPUT_END) {
                    return state | STATE_ENDED;
                } else if (!(state & STATE_BEGAN)) {
                    return STATE_BEGAN;
                }

                return state | STATE_CHANGED;
            }

            return STATE_FAILED;
        };

        return AttrRecognizer;
    }(Recognizer);
    /**
     * @private
     * direction cons to string
     * @param {constant} direction
     * @returns {String}
     */


    function directionStr(direction) {
        if (direction === DIRECTION_DOWN) {
            return 'down';
        } else if (direction === DIRECTION_UP) {
            return 'up';
        } else if (direction === DIRECTION_LEFT) {
            return 'left';
        } else if (direction === DIRECTION_RIGHT) {
            return 'right';
        }

        return '';
    }
    /**
     * @private
     * Pan
     * Recognized when the pointer is down and moved in the allowed direction.
     * @constructor
     * @extends AttrRecognizer
     */


    var PanRecognizer = /*#__PURE__*/function (_AttrRecognizer) {
        _inheritsLoose(PanRecognizer, _AttrRecognizer);

        function PanRecognizer(options) {
            var _this;

            if (options === void 0) {
                options = {};
            }

            _this = _AttrRecognizer.call(this, _extends({
                event: 'pan',
                threshold: 10,
                pointers: 1,
                direction: DIRECTION_ALL
            }, options)) || this;
            _this.pX = null;
            _this.pY = null;
            return _this;
        }

        var _proto = PanRecognizer.prototype;

        _proto.getTouchAction = function getTouchAction() {
            var direction = this.options.direction;
            var actions = [];

            if (direction & DIRECTION_HORIZONTAL) {
                actions.push(TOUCH_ACTION_PAN_Y);
            }

            if (direction & DIRECTION_VERTICAL) {
                actions.push(TOUCH_ACTION_PAN_X);
            }

            return actions;
        };

        _proto.directionTest = function directionTest(input) {
            var options = this.options;
            var hasMoved = true;
            var distance = input.distance;
            var direction = input.direction;
            var x = input.deltaX;
            var y = input.deltaY; // lock to axis?

            if (!(direction & options.direction)) {
                if (options.direction & DIRECTION_HORIZONTAL) {
                    direction = x === 0 ? DIRECTION_NONE : x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
                    hasMoved = x !== this.pX;
                    distance = Math.abs(input.deltaX);
                } else {
                    direction = y === 0 ? DIRECTION_NONE : y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
                    hasMoved = y !== this.pY;
                    distance = Math.abs(input.deltaY);
                }
            }

            input.direction = direction;
            return hasMoved && distance > options.threshold && direction & options.direction;
        };

        _proto.attrTest = function attrTest(input) {
            return AttrRecognizer.prototype.attrTest.call(this, input) && ( // replace with a super call
                this.state & STATE_BEGAN || !(this.state & STATE_BEGAN) && this.directionTest(input));
        };

        _proto.emit = function emit(input) {
            this.pX = input.deltaX;
            this.pY = input.deltaY;
            var direction = directionStr(input.direction);

            if (direction) {
                input.additionalEvent = this.options.event + direction;
            }

            _AttrRecognizer.prototype.emit.call(this, input);
        };

        return PanRecognizer;
    }(AttrRecognizer);
    /**
     * @private
     * Swipe
     * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
     * @constructor
     * @extends AttrRecognizer
     */


    var SwipeRecognizer = /*#__PURE__*/function (_AttrRecognizer) {
        _inheritsLoose(SwipeRecognizer, _AttrRecognizer);

        function SwipeRecognizer(options) {
            if (options === void 0) {
                options = {};
            }

            return _AttrRecognizer.call(this, _extends({
                event: 'swipe',
                threshold: 10,
                velocity: 0.3,
                direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
                pointers: 1
            }, options)) || this;
        }

        var _proto = SwipeRecognizer.prototype;

        _proto.getTouchAction = function getTouchAction() {
            return PanRecognizer.prototype.getTouchAction.call(this);
        };

        _proto.attrTest = function attrTest(input) {
            var direction = this.options.direction;
            var velocity;

            if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
                velocity = input.overallVelocity;
            } else if (direction & DIRECTION_HORIZONTAL) {
                velocity = input.overallVelocityX;
            } else if (direction & DIRECTION_VERTICAL) {
                velocity = input.overallVelocityY;
            }

            return _AttrRecognizer.prototype.attrTest.call(this, input) && direction & input.offsetDirection && input.distance > this.options.threshold && input.maxPointers === this.options.pointers && abs$1(velocity) > this.options.velocity && input.eventType & INPUT_END;
        };

        _proto.emit = function emit(input) {
            var direction = directionStr(input.offsetDirection);

            if (direction) {
                this.manager.emit(this.options.event + direction, input);
            }

            this.manager.emit(this.options.event, input);
        };

        return SwipeRecognizer;
    }(AttrRecognizer);
    /**
     * @private
     * Pinch
     * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
     * @constructor
     * @extends AttrRecognizer
     */


    var PinchRecognizer = /*#__PURE__*/function (_AttrRecognizer) {
        _inheritsLoose(PinchRecognizer, _AttrRecognizer);

        function PinchRecognizer(options) {
            if (options === void 0) {
                options = {};
            }

            return _AttrRecognizer.call(this, _extends({
                event: 'pinch',
                threshold: 0,
                pointers: 2
            }, options)) || this;
        }

        var _proto = PinchRecognizer.prototype;

        _proto.getTouchAction = function getTouchAction() {
            return [TOUCH_ACTION_NONE];
        };

        _proto.attrTest = function attrTest(input) {
            return _AttrRecognizer.prototype.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
        };

        _proto.emit = function emit(input) {
            if (input.scale !== 1) {
                var inOut = input.scale < 1 ? 'in' : 'out';
                input.additionalEvent = this.options.event + inOut;
            }

            _AttrRecognizer.prototype.emit.call(this, input);
        };

        return PinchRecognizer;
    }(AttrRecognizer);
    /**
     * @private
     * Rotate
     * Recognized when two or more pointer are moving in a circular motion.
     * @constructor
     * @extends AttrRecognizer
     */


    var RotateRecognizer = /*#__PURE__*/function (_AttrRecognizer) {
        _inheritsLoose(RotateRecognizer, _AttrRecognizer);

        function RotateRecognizer(options) {
            if (options === void 0) {
                options = {};
            }

            return _AttrRecognizer.call(this, _extends({
                event: 'rotate',
                threshold: 0,
                pointers: 2
            }, options)) || this;
        }

        var _proto = RotateRecognizer.prototype;

        _proto.getTouchAction = function getTouchAction() {
            return [TOUCH_ACTION_NONE];
        };

        _proto.attrTest = function attrTest(input) {
            return _AttrRecognizer.prototype.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
        };

        return RotateRecognizer;
    }(AttrRecognizer);
    /**
     * @private
     * Press
     * Recognized when the pointer is down for x ms without any movement.
     * @constructor
     * @extends Recognizer
     */


    var PressRecognizer = /*#__PURE__*/function (_Recognizer) {
        _inheritsLoose(PressRecognizer, _Recognizer);

        function PressRecognizer(options) {
            var _this;

            if (options === void 0) {
                options = {};
            }

            _this = _Recognizer.call(this, _extends({
                event: 'press',
                pointers: 1,
                time: 251,
                // minimal time of the pointer to be pressed
                threshold: 9
            }, options)) || this;
            _this._timer = null;
            _this._input = null;
            return _this;
        }

        var _proto = PressRecognizer.prototype;

        _proto.getTouchAction = function getTouchAction() {
            return [TOUCH_ACTION_AUTO];
        };

        _proto.process = function process(input) {
            var _this2 = this;

            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTime = input.deltaTime > options.time;
            this._input = input; // we only allow little movement
            // and we've reached an end event, so a tap is possible

            if (!validMovement || !validPointers || input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime) {
                this.reset();
            } else if (input.eventType & INPUT_START) {
                this.reset();
                this._timer = setTimeout(function () {
                    _this2.state = STATE_RECOGNIZED;

                    _this2.tryEmit();
                }, options.time);
            } else if (input.eventType & INPUT_END) {
                return STATE_RECOGNIZED;
            }

            return STATE_FAILED;
        };

        _proto.reset = function reset() {
            clearTimeout(this._timer);
        };

        _proto.emit = function emit(input) {
            if (this.state !== STATE_RECOGNIZED) {
                return;
            }

            if (input && input.eventType & INPUT_END) {
                this.manager.emit(this.options.event + "up", input);
            } else {
                this._input.timeStamp = now();
                this.manager.emit(this.options.event, this._input);
            }
        };

        return PressRecognizer;
    }(Recognizer);

    var defaults = {
        /**
         * @private
         * set if DOM events are being triggered.
         * But this is slower and unused by simple implementations, so disabled by default.
         * @type {Boolean}
         * @default false
         */
        domEvents: false,

        /**
         * @private
         * The value for the touchAction property/fallback.
         * When set to `compute` it will magically set the correct value based on the added recognizers.
         * @type {String}
         * @default compute
         */
        touchAction: TOUCH_ACTION_COMPUTE,

        /**
         * @private
         * @type {Boolean}
         * @default true
         */
        enable: true,

        /**
         * @private
         * EXPERIMENTAL FEATURE -- can be removed/changed
         * Change the parent input target element.
         * If Null, then it is being set the to main element.
         * @type {Null|EventTarget}
         * @default null
         */
        inputTarget: null,

        /**
         * @private
         * force an input class
         * @type {Null|Function}
         * @default null
         */
        inputClass: null,

        /**
         * @private
         * Some CSS properties can be used to improve the working of Hammer.
         * Add them to this method and they will be set when creating a new Manager.
         * @namespace
         */
        cssProps: {
            /**
             * @private
             * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
             * @type {String}
             * @default 'none'
             */
            userSelect: "none",

            /**
             * @private
             * Disable the Windows Phone grippers when pressing an element.
             * @type {String}
             * @default 'none'
             */
            touchSelect: "none",

            /**
             * @private
             * Disables the default callout shown when you touch and hold a touch target.
             * On iOS, when you touch and hold a touch target such as a link, Safari displays
             * a callout containing information about the link. This property allows you to disable that callout.
             * @type {String}
             * @default 'none'
             */
            touchCallout: "none",

            /**
             * @private
             * Specifies whether zooming is enabled. Used by IE10>
             * @type {String}
             * @default 'none'
             */
            contentZooming: "none",

            /**
             * @private
             * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
             * @type {String}
             * @default 'none'
             */
            userDrag: "none",

            /**
             * @private
             * Overrides the highlight color shown when the user taps a link or a JavaScript
             * clickable element in iOS. This property obeys the alpha value, if specified.
             * @type {String}
             * @default 'rgba(0,0,0,0)'
             */
            tapHighlightColor: "rgba(0,0,0,0)"
        }
    };
    /**
     * @private
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * This is separated with other defaults because of tree-shaking.
     * @type {Array}
     */

    var preset = [[RotateRecognizer, {
        enable: false
    }], [PinchRecognizer, {
        enable: false
    }, ['rotate']], [SwipeRecognizer, {
        direction: DIRECTION_HORIZONTAL
    }], [PanRecognizer, {
        direction: DIRECTION_HORIZONTAL
    }, ['swipe']], [TapRecognizer], [TapRecognizer, {
        event: 'doubletap',
        taps: 2
    }, ['tap']], [PressRecognizer]];
    var STOP = 1;
    var FORCED_STOP = 2;
    /**
     * @private
     * add/remove the css properties as defined in manager.options.cssProps
     * @param {Manager} manager
     * @param {Boolean} add
     */

    function toggleCssProps(manager, add) {
        var element = manager.element;

        if (!element.style) {
            return;
        }

        var prop;
        each(manager.options.cssProps, function (value, name) {
            prop = prefixed(element.style, name);

            if (add) {
                manager.oldCssProps[prop] = element.style[prop];
                element.style[prop] = value;
            } else {
                element.style[prop] = manager.oldCssProps[prop] || "";
            }
        });

        if (!add) {
            manager.oldCssProps = {};
        }
    }
    /**
     * @private
     * trigger dom event
     * @param {String} event
     * @param {Object} data
     */


    function triggerDomEvent(event, data) {
        var gestureEvent = document.createEvent("Event");
        gestureEvent.initEvent(event, true, true);
        gestureEvent.gesture = data;
        data.target.dispatchEvent(gestureEvent);
    }
    /**
     * @private
     * Manager
     * @param {HTMLElement} element
     * @param {Object} [options]
     * @constructor
     */


    var Manager = /*#__PURE__*/function () {
        function Manager(element, options) {
            var _this = this;

            this.options = assign$1({}, defaults, options || {});
            this.options.inputTarget = this.options.inputTarget || element;
            this.handlers = {};
            this.session = {};
            this.recognizers = [];
            this.oldCssProps = {};
            this.element = element;
            this.input = createInputInstance(this);
            this.touchAction = new TouchAction(this, this.options.touchAction);
            toggleCssProps(this, true);
            each(this.options.recognizers, function (item) {
                var recognizer = _this.add(new item[0](item[1]));

                item[2] && recognizer.recognizeWith(item[2]);
                item[3] && recognizer.requireFailure(item[3]);
            }, this);
        }
        /**
         * @private
         * set options
         * @param {Object} options
         * @returns {Manager}
         */


        var _proto = Manager.prototype;

        _proto.set = function set(options) {
            assign$1(this.options, options); // Options that need a little more setup

            if (options.touchAction) {
                this.touchAction.update();
            }

            if (options.inputTarget) {
                // Clean up existing event listeners and reinitialize
                this.input.destroy();
                this.input.target = options.inputTarget;
                this.input.init();
            }

            return this;
        };
        /**
         * @private
         * stop recognizing for this session.
         * This session will be discarded, when a new [input]start event is fired.
         * When forced, the recognizer cycle is stopped immediately.
         * @param {Boolean} [force]
         */


        _proto.stop = function stop(force) {
            this.session.stopped = force ? FORCED_STOP : STOP;
        };
        /**
         * @private
         * run the recognizers!
         * called by the inputHandler function on every movement of the pointers (touches)
         * it walks through all the recognizers and tries to detect the gesture that is being made
         * @param {Object} inputData
         */


        _proto.recognize = function recognize(inputData) {
            var session = this.session;

            if (session.stopped) {
                return;
            } // run the touch-action polyfill


            this.touchAction.preventDefaults(inputData);
            var recognizer;
            var recognizers = this.recognizers; // this holds the recognizer that is being recognized.
            // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
            // if no recognizer is detecting a thing, it is set to `null`

            var curRecognizer = session.curRecognizer; // reset when the last recognizer is recognized
            // or when we're in a new session

            if (!curRecognizer || curRecognizer && curRecognizer.state & STATE_RECOGNIZED) {
                session.curRecognizer = null;
                curRecognizer = null;
            }

            var i = 0;

            while (i < recognizers.length) {
                recognizer = recognizers[i]; // find out if we are allowed try to recognize the input for this one.
                // 1.   allow if the session is NOT forced stopped (see the .stop() method)
                // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
                //      that is being recognized.
                // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
                //      this can be setup with the `recognizeWith()` method on the recognizer.

                if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer === curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) {
                    // 3
                    recognizer.recognize(inputData);
                } else {
                    recognizer.reset();
                } // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
                // current active recognizer. but only if we don't already have an active recognizer


                if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                    session.curRecognizer = recognizer;
                    curRecognizer = recognizer;
                }

                i++;
            }
        };
        /**
         * @private
         * get a recognizer by its event name.
         * @param {Recognizer|String} recognizer
         * @returns {Recognizer|Null}
         */


        _proto.get = function get(recognizer) {
            if (recognizer instanceof Recognizer) {
                return recognizer;
            }

            var recognizers = this.recognizers;

            for (var i = 0; i < recognizers.length; i++) {
                if (recognizers[i].options.event === recognizer) {
                    return recognizers[i];
                }
            }

            return null;
        };
        /**
         * @private add a recognizer to the manager
         * existing recognizers with the same event name will be removed
         * @param {Recognizer} recognizer
         * @returns {Recognizer|Manager}
         */


        _proto.add = function add(recognizer) {
            if (invokeArrayArg(recognizer, "add", this)) {
                return this;
            } // remove existing


            var existing = this.get(recognizer.options.event);

            if (existing) {
                this.remove(existing);
            }

            this.recognizers.push(recognizer);
            recognizer.manager = this;
            this.touchAction.update();
            return recognizer;
        };
        /**
         * @private
         * remove a recognizer by name or instance
         * @param {Recognizer|String} recognizer
         * @returns {Manager}
         */


        _proto.remove = function remove(recognizer) {
            if (invokeArrayArg(recognizer, "remove", this)) {
                return this;
            }

            var targetRecognizer = this.get(recognizer); // let's make sure this recognizer exists

            if (recognizer) {
                var recognizers = this.recognizers;
                var index = inArray(recognizers, targetRecognizer);

                if (index !== -1) {
                    recognizers.splice(index, 1);
                    this.touchAction.update();
                }
            }

            return this;
        };
        /**
         * @private
         * bind event
         * @param {String} events
         * @param {Function} handler
         * @returns {EventEmitter} this
         */


        _proto.on = function on(events, handler) {
            if (events === undefined || handler === undefined) {
                return this;
            }

            var handlers = this.handlers;
            each(splitStr(events), function (event) {
                handlers[event] = handlers[event] || [];
                handlers[event].push(handler);
            });
            return this;
        };
        /**
         * @private unbind event, leave emit blank to remove all handlers
         * @param {String} events
         * @param {Function} [handler]
         * @returns {EventEmitter} this
         */


        _proto.off = function off(events, handler) {
            if (events === undefined) {
                return this;
            }

            var handlers = this.handlers;
            each(splitStr(events), function (event) {
                if (!handler) {
                    delete handlers[event];
                } else {
                    handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
                }
            });
            return this;
        };
        /**
         * @private emit event to the listeners
         * @param {String} event
         * @param {Object} data
         */


        _proto.emit = function emit(event, data) {
            // we also want to trigger dom events
            if (this.options.domEvents) {
                triggerDomEvent(event, data);
            } // no handlers, so skip it all


            var handlers = this.handlers[event] && this.handlers[event].slice();

            if (!handlers || !handlers.length) {
                return;
            }

            data.type = event;

            data.preventDefault = function () {
                data.srcEvent.preventDefault();
            };

            var i = 0;

            while (i < handlers.length) {
                handlers[i](data);
                i++;
            }
        };
        /**
         * @private
         * destroy the manager and unbinds all events
         * it doesn't unbind dom events, that is the user own responsibility
         */


        _proto.destroy = function destroy() {
            this.element && toggleCssProps(this, false);
            this.handlers = {};
            this.session = {};
            this.input.destroy();
            this.element = null;
        };

        return Manager;
    }();

    var SINGLE_TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
    var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
    /**
     * @private
     * Touch events input
     * @constructor
     * @extends Input
     */

    var SingleTouchInput = /*#__PURE__*/function (_Input) {
        _inheritsLoose(SingleTouchInput, _Input);

        function SingleTouchInput() {
            var _this;

            var proto = SingleTouchInput.prototype;
            proto.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
            proto.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
            _this = _Input.apply(this, arguments) || this;
            _this.started = false;
            return _this;
        }

        var _proto = SingleTouchInput.prototype;

        _proto.handler = function handler(ev) {
            var type = SINGLE_TOUCH_INPUT_MAP[ev.type]; // should we handle the touch events?

            if (type === INPUT_START) {
                this.started = true;
            }

            if (!this.started) {
                return;
            }

            var touches = normalizeSingleTouches.call(this, ev, type); // when done, reset the started state

            if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
                this.started = false;
            }

            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        };

        return SingleTouchInput;
    }(Input);

    function normalizeSingleTouches(ev, type) {
        var all = toArray(ev.touches);
        var changed = toArray(ev.changedTouches);

        if (type & (INPUT_END | INPUT_CANCEL)) {
            all = uniqueArray(all.concat(changed), 'identifier', true);
        }

        return [all, changed];
    }
    /**
     * @private
     * wrap a method with a deprecation warning and stack trace
     * @param {Function} method
     * @param {String} name
     * @param {String} message
     * @returns {Function} A new function wrapping the supplied method.
     */


    function deprecate(method, name, message) {
        var deprecationMessage = "DEPRECATED METHOD: " + name + "\n" + message + " AT \n";
        return function () {
            var e = new Error('get-stack-trace');
            var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '').replace(/^\s+at\s+/gm, '').replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
            var log = window.console && (window.console.warn || window.console.log);

            if (log) {
                log.call(window.console, deprecationMessage, stack);
            }

            return method.apply(this, arguments);
        };
    }
    /**
     * @private
     * extend object.
     * means that properties in dest will be overwritten by the ones in src.
     * @param {Object} dest
     * @param {Object} src
     * @param {Boolean} [merge=false]
     * @returns {Object} dest
     */


    var extend = deprecate(function (dest, src, merge) {
        var keys = Object.keys(src);
        var i = 0;

        while (i < keys.length) {
            if (!merge || merge && dest[keys[i]] === undefined) {
                dest[keys[i]] = src[keys[i]];
            }

            i++;
        }

        return dest;
    }, 'extend', 'Use `assign`.');
    /**
     * @private
     * merge the values from src in the dest.
     * means that properties that exist in dest will not be overwritten by src
     * @param {Object} dest
     * @param {Object} src
     * @returns {Object} dest
     */

    var merge$1 = deprecate(function (dest, src) {
        return extend(dest, src, true);
    }, 'merge', 'Use `assign`.');
    /**
     * @private
     * simple class inheritance
     * @param {Function} child
     * @param {Function} base
     * @param {Object} [properties]
     */

    function inherit(child, base, properties) {
        var baseP = base.prototype;
        var childP;
        childP = child.prototype = Object.create(baseP);
        childP.constructor = child;
        childP._super = baseP;

        if (properties) {
            assign$1(childP, properties);
        }
    }
    /**
     * @private
     * simple function bind
     * @param {Function} fn
     * @param {Object} context
     * @returns {Function}
     */


    function bindFn(fn, context) {
        return function boundFn() {
            return fn.apply(context, arguments);
        };
    }
    /**
     * @private
     * Simple way to create a manager with a default set of recognizers.
     * @param {HTMLElement} element
     * @param {Object} [options]
     * @constructor
     */


    var Hammer$2 = /*#__PURE__*/function () {
        var Hammer =
            /**
             * @private
             * @const {string}
             */
            function Hammer(element, options) {
                if (options === void 0) {
                    options = {};
                }

                return new Manager(element, _extends({
                    recognizers: preset.concat()
                }, options));
            };

        Hammer.VERSION = "2.0.17-rc";
        Hammer.DIRECTION_ALL = DIRECTION_ALL;
        Hammer.DIRECTION_DOWN = DIRECTION_DOWN;
        Hammer.DIRECTION_LEFT = DIRECTION_LEFT;
        Hammer.DIRECTION_RIGHT = DIRECTION_RIGHT;
        Hammer.DIRECTION_UP = DIRECTION_UP;
        Hammer.DIRECTION_HORIZONTAL = DIRECTION_HORIZONTAL;
        Hammer.DIRECTION_VERTICAL = DIRECTION_VERTICAL;
        Hammer.DIRECTION_NONE = DIRECTION_NONE;
        Hammer.DIRECTION_DOWN = DIRECTION_DOWN;
        Hammer.INPUT_START = INPUT_START;
        Hammer.INPUT_MOVE = INPUT_MOVE;
        Hammer.INPUT_END = INPUT_END;
        Hammer.INPUT_CANCEL = INPUT_CANCEL;
        Hammer.STATE_POSSIBLE = STATE_POSSIBLE;
        Hammer.STATE_BEGAN = STATE_BEGAN;
        Hammer.STATE_CHANGED = STATE_CHANGED;
        Hammer.STATE_ENDED = STATE_ENDED;
        Hammer.STATE_RECOGNIZED = STATE_RECOGNIZED;
        Hammer.STATE_CANCELLED = STATE_CANCELLED;
        Hammer.STATE_FAILED = STATE_FAILED;
        Hammer.Manager = Manager;
        Hammer.Input = Input;
        Hammer.TouchAction = TouchAction;
        Hammer.TouchInput = TouchInput;
        Hammer.MouseInput = MouseInput;
        Hammer.PointerEventInput = PointerEventInput;
        Hammer.TouchMouseInput = TouchMouseInput;
        Hammer.SingleTouchInput = SingleTouchInput;
        Hammer.Recognizer = Recognizer;
        Hammer.AttrRecognizer = AttrRecognizer;
        Hammer.Tap = TapRecognizer;
        Hammer.Pan = PanRecognizer;
        Hammer.Swipe = SwipeRecognizer;
        Hammer.Pinch = PinchRecognizer;
        Hammer.Rotate = RotateRecognizer;
        Hammer.Press = PressRecognizer;
        Hammer.on = addEventListeners;
        Hammer.off = removeEventListeners;
        Hammer.each = each;
        Hammer.merge = merge$1;
        Hammer.extend = extend;
        Hammer.bindFn = bindFn;
        Hammer.assign = assign$1;
        Hammer.inherit = inherit;
        Hammer.bindFn = bindFn;
        Hammer.prefixed = prefixed;
        Hammer.toArray = toArray;
        Hammer.inArray = inArray;
        Hammer.uniqueArray = uniqueArray;
        Hammer.splitStr = splitStr;
        Hammer.boolOrFn = boolOrFn;
        Hammer.hasParent = hasParent;
        Hammer.addEventListeners = addEventListeners;
        Hammer.removeEventListeners = removeEventListeners;
        Hammer.defaults = assign$1({}, defaults, {
            preset: preset
        });
        return Hammer;
    }(); //  style loader but by script tag, not by the loader.

    function _createForOfIteratorHelper$8(o, allowArrayLike) { var it; if (typeof symbol === "undefined" || getIteratorMethod(o) == null) { if (isArray(o) || (it = _unsupportedIterableToArray$8(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

    function _unsupportedIterableToArray$8(o, minLen) { var _context21; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$8(o, minLen); var n = slice$1(_context21 = Object.prototype.toString.call(o)).call(_context21, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return from$2(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$8(o, minLen); }

    function _arrayLikeToArray$8(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
    /**
     * Use this symbol to delete properies in deepObjectAssign.
     */

    var DELETE = symbol("DELETE");
    /**
     * Pure version of deepObjectAssign, it doesn't modify any of it's arguments.
     *
     * @param base - The base object that fullfils the whole interface T.
     * @param updates - Updates that may change or delete props.
     *
     * @returns A brand new instance with all the supplied objects deeply merged.
     */


    function pureDeepObjectAssign(base) {
        var _context;

        for (var _len = arguments.length, updates = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            updates[_key - 1] = arguments[_key];
        }

        return deepObjectAssign.apply(void 0, concat(_context = [{}, base]).call(_context, updates));
    }
    /**
     * Deep version of object assign with additional deleting by the DELETE symbol.
     *
     * @param values - Objects to be deeply merged.
     *
     * @returns The first object from values.
     */


    function deepObjectAssign() {
        var merged = deepObjectAssignNonentry.apply(void 0, arguments);
        stripDelete(merged);
        return merged;
    }
    /**
     * Deep version of object assign with additional deleting by the DELETE symbol.
     *
     * @remarks
     * This doesn't strip the DELETE symbols so they may end up in the final object.
     *
     * @param values - Objects to be deeply merged.
     *
     * @returns The first object from values.
     */


    function deepObjectAssignNonentry() {
        for (var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            values[_key2] = arguments[_key2];
        }

        if (values.length < 2) {
            return values[0];
        } else if (values.length > 2) {
            var _context2;

            return deepObjectAssignNonentry.apply(void 0, concat(_context2 = [deepObjectAssign(values[0], values[1])]).call(_context2, _toConsumableArray(slice$1(values).call(values, 2))));
        }

        var a = values[0];
        var b = values[1];

        var _iterator = _createForOfIteratorHelper$8(ownKeys$5(b)),
            _step;

        try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var prop = _step.value;
                if (!Object.prototype.propertyIsEnumerable.call(b, prop)) ;else if (b[prop] === DELETE) {
                    delete a[prop];
                } else if (a[prop] !== null && b[prop] !== null && _typeof(a[prop]) === "object" && _typeof(b[prop]) === "object" && !isArray(a[prop]) && !isArray(b[prop])) {
                    a[prop] = deepObjectAssignNonentry(a[prop], b[prop]);
                } else {
                    a[prop] = clone(b[prop]);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally {
            _iterator.f();
        }

        return a;
    }
    /**
     * Deep clone given object or array. In case of primitive simply return.
     *
     * @param a - Anything.
     *
     * @returns Deep cloned object/array or unchanged a.
     */


    function clone(a) {
        if (isArray(a)) {
            return map$3(a).call(a, function (value) {
                return clone(value);
            });
        } else if (_typeof(a) === "object" && a !== null) {
            return deepObjectAssignNonentry({}, a);
        } else {
            return a;
        }
    }
    /**
     * Strip DELETE from given object.
     *
     * @param a - Object which may contain DELETE but won't after this is executed.
     */


    function stripDelete(a) {
        for (var _i = 0, _Object$keys = keys$3(a); _i < _Object$keys.length; _i++) {
            var prop = _Object$keys[_i];

            if (a[prop] === DELETE) {
                delete a[prop];
            } else if (_typeof(a[prop]) === "object" && a[prop] !== null) {
                stripDelete(a[prop]);
            }
        }
    }
    /**
     * Seedable, fast and reasonably good (not crypto but more than okay for our
     * needs) random number generator.
     *
     * @remarks
     * Adapted from {@link https://web.archive.org/web/20110429100736/http://baagoe.com:80/en/RandomMusings/javascript}.
     * Original algorithm created by Johannes Baagøe \<baagoe\@baagoe.com\> in 2010.
     */

    /**
     * Create a seeded pseudo random generator based on Alea by Johannes Baagøe.
     *
     * @param seed - All supplied arguments will be used as a seed. In case nothing
     * is supplied the current time will be used to seed the generator.
     *
     * @returns A ready to use seeded generator.
     */


    function Alea() {
        for (var _len3 = arguments.length, seed = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            seed[_key3] = arguments[_key3];
        }

        return AleaImplementation(seed.length ? seed : [now$1()]);
    }
    /**
     * An implementation of [[Alea]] without user input validation.
     *
     * @param seed - The data that will be used to seed the generator.
     *
     * @returns A ready to use seeded generator.
     */


    function AleaImplementation(seed) {
        var _mashSeed = mashSeed(seed),
            _mashSeed2 = _slicedToArray(_mashSeed, 3),
            s0 = _mashSeed2[0],
            s1 = _mashSeed2[1],
            s2 = _mashSeed2[2];

        var c = 1;

        var random = function random() {
            var t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32

            s0 = s1;
            s1 = s2;
            return s2 = t - (c = t | 0);
        };

        random.uint32 = function () {
            return random() * 0x100000000;
        }; // 2^32


        random.fract53 = function () {
            return random() + (random() * 0x200000 | 0) * 1.1102230246251565e-16;
        }; // 2^-53


        random.algorithm = "Alea";
        random.seed = seed;
        random.version = "0.9";
        return random;
    }
    /**
     * Turn arbitrary data into values [[AleaImplementation]] can use to generate
     * random numbers.
     *
     * @param seed - Arbitrary data that will be used as the seed.
     *
     * @returns Three numbers to use as initial values for [[AleaImplementation]].
     */


    function mashSeed() {
        var mash = Mash();
        var s0 = mash(" ");
        var s1 = mash(" ");
        var s2 = mash(" ");

        for (var i = 0; i < arguments.length; i++) {
            s0 -= mash(i < 0 || arguments.length <= i ? undefined : arguments[i]);

            if (s0 < 0) {
                s0 += 1;
            }

            s1 -= mash(i < 0 || arguments.length <= i ? undefined : arguments[i]);

            if (s1 < 0) {
                s1 += 1;
            }

            s2 -= mash(i < 0 || arguments.length <= i ? undefined : arguments[i]);

            if (s2 < 0) {
                s2 += 1;
            }
        }

        return [s0, s1, s2];
    }
    /**
     * Create a new mash function.
     *
     * @returns A nonpure function that takes arbitrary [[Mashable]] data and turns
     * them into numbers.
     */


    function Mash() {
        var n = 0xefc8249d;
        return function (data) {
            var string = data.toString();

            for (var i = 0; i < string.length; i++) {
                n += string.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }

            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
    }
    /**
     * Setup a mock hammer.js object, for unit testing.
     *
     * Inspiration: https://github.com/uber/deck.gl/pull/658
     *
     * @returns {{on: noop, off: noop, destroy: noop, emit: noop, get: get}}
     */


    function hammerMock() {
        var noop = function noop() {};

        return {
            on: noop,
            off: noop,
            destroy: noop,
            emit: noop,
            get: function get() {
                return {
                    set: noop
                };
            }
        };
    }

    var Hammer = typeof window !== "undefined" ? window.Hammer || Hammer$2 : function () {
        // hammer.js is only available in a browser, not in node.js. Replacing it with a mock object.
        return hammerMock();
    };
    /**
     * Turn an element into an clickToUse element.
     * When not active, the element has a transparent overlay. When the overlay is
     * clicked, the mode is changed to active.
     * When active, the element is displayed with a blue border around it, and
     * the interactive contents of the element can be used. When clicked outside
     * the element, the elements mode is changed to inactive.
     *
     * @param {Element} container
     * @class Activator
     */

    function Activator(container) {
        var _this = this,
            _context3;

        this._cleanupQueue = [];
        this.active = false;
        this._dom = {
            container: container,
            overlay: document.createElement("div")
        };

        this._dom.overlay.classList.add("vis-overlay");

        this._dom.container.appendChild(this._dom.overlay);

        this._cleanupQueue.push(function () {
            _this._dom.overlay.parentNode.removeChild(_this._dom.overlay);
        });

        var hammer = Hammer(this._dom.overlay);
        hammer.on("tap", bind(_context3 = this._onTapOverlay).call(_context3, this));

        this._cleanupQueue.push(function () {
            hammer.destroy(); // FIXME: cleaning up hammer instances doesn't work (Timeline not removed
            // from memory)
        }); // block all touch events (except tap)


        var events = ["tap", "doubletap", "press", "pinch", "pan", "panstart", "panmove", "panend"];

        forEach$2(events).call(events, function (event) {
            hammer.on(event, function (event) {
                event.srcEvent.stopPropagation();
            });
        }); // attach a click event to the window, in order to deactivate when clicking outside the timeline


        if (document && document.body) {
            this._onClick = function (event) {
                if (!_hasParent(event.target, container)) {
                    _this.deactivate();
                }
            };

            document.body.addEventListener("click", this._onClick);

            this._cleanupQueue.push(function () {
                document.body.removeEventListener("click", _this._onClick);
            });
        } // prepare escape key listener for deactivating when active


        this._escListener = function (event) {
            if ("key" in event ? event.key === "Escape" : event.keyCode === 27
                /* the keyCode is for IE11 */
            ) {
                _this.deactivate();
            }
        };
    } // turn into an event emitter


    componentEmitter(Activator.prototype); // The currently active activator

    Activator.current = null;
    /**
     * Destroy the activator. Cleans up all created DOM and event listeners
     */

    Activator.prototype.destroy = function () {
        var _context4, _context5;

        this.deactivate();

        var _iterator2 = _createForOfIteratorHelper$8(reverse(_context4 = splice(_context5 = this._cleanupQueue).call(_context5, 0)).call(_context4)),
            _step2;

        try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var callback = _step2.value;
                callback();
            }
        } catch (err) {
            _iterator2.e(err);
        } finally {
            _iterator2.f();
        }
    };
    /**
     * Activate the element
     * Overlay is hidden, element is decorated with a blue shadow border
     */


    Activator.prototype.activate = function () {
        // we allow only one active activator at a time
        if (Activator.current) {
            Activator.current.deactivate();
        }

        Activator.current = this;
        this.active = true;
        this._dom.overlay.style.display = "none";

        this._dom.container.classList.add("vis-active");

        this.emit("change");
        this.emit("activate"); // ugly hack: bind ESC after emitting the events, as the Network rebinds all
        // keyboard events on a 'change' event

        document.body.addEventListener("keydown", this._escListener);
    };
    /**
     * Deactivate the element
     * Overlay is displayed on top of the element
     */


    Activator.prototype.deactivate = function () {
        this.active = false;
        this._dom.overlay.style.display = "block";

        this._dom.container.classList.remove("vis-active");

        document.body.removeEventListener("keydown", this._escListener);
        this.emit("change");
        this.emit("deactivate");
    };
    /**
     * Handle a tap event: activate the container
     *
     * @param {Event}  event   The event
     * @private
     */


    Activator.prototype._onTapOverlay = function (event) {
        // activate the container
        this.activate();
        event.srcEvent.stopPropagation();
    };
    /**
     * Test whether the element has the requested parent element somewhere in
     * its chain of parent nodes.
     *
     * @param {HTMLElement} element
     * @param {HTMLElement} parent
     * @returns {boolean} Returns true when the parent is found somewhere in the
     *                    chain of parent nodes.
     * @private
     */


    function _hasParent(element, parent) {
        while (element) {
            if (element === parent) {
                return true;
            }

            element = element.parentNode;
        }

        return false;
    } // utility functions

    var fullHexRE = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
    var shortHexRE = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    var rgbRE = /^rgb\( *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *\)$/i;
    var rgbaRE = /^rgba\( *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *(1?\d{1,2}|2[0-4]\d|25[0-5]) *, *([01]|0?\.\d+) *\)$/i;
    /**
     * Remove everything in the DOM object.
     *
     * @param DOMobject - Node whose child nodes will be recursively deleted.
     */


    function recursiveDOMDelete(DOMobject) {
        if (DOMobject) {
            while (DOMobject.hasChildNodes() === true) {
                var child = DOMobject.firstChild;

                if (child) {
                    recursiveDOMDelete(child);
                    DOMobject.removeChild(child);
                }
            }
        }
    }
    /**
     * Test whether given object is a string.
     *
     * @param value - Input value of unknown type.
     *
     * @returns True if string, false otherwise.
     */


    function isString(value) {
        return value instanceof String || typeof value === "string";
    }
    /**
     * Test whether given object is a object (not primitive or null).
     *
     * @param value - Input value of unknown type.
     *
     * @returns True if not null object, false otherwise.
     */


    function isObject(value) {
        return _typeof(value) === "object" && value !== null;
    }
    /**
     * Copy property from b to a if property present in a.
     * If property in b explicitly set to null, delete it if `allowDeletion` set.
     *
     * Internal helper routine, should not be exported. Not added to `exports` for that reason.
     *
     * @param a - Target object.
     * @param b - Source object.
     * @param prop - Name of property to copy from b to a.
     * @param allowDeletion - If true, delete property in a if explicitly set to null in b.
     */


    function copyOrDelete(a, b, prop, allowDeletion) {
        var doDeletion = false;

        if (allowDeletion === true) {
            doDeletion = b[prop] === null && a[prop] !== undefined;
        }

        if (doDeletion) {
            delete a[prop];
        } else {
            a[prop] = b[prop]; // Remember, this is a reference copy!
        }
    }
    /**
     * Fill an object with a possibly partially defined other object.
     *
     * Only copies values for the properties already present in a.
     * That means an object is not created on a property if only the b object has it.
     *
     * @param a - The object that will have it's properties updated.
     * @param b - The object with property updates.
     * @param allowDeletion - If true, delete properties in a that are explicitly set to null in b.
     */


    function fillIfDefined(a, b) {
        var allowDeletion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        // NOTE: iteration of properties of a
        // NOTE: prototype properties iterated over as well
        for (var prop in a) {
            if (b[prop] !== undefined) {
                if (b[prop] === null || _typeof(b[prop]) !== "object") {
                    // Note: typeof null === 'object'
                    copyOrDelete(a, b, prop, allowDeletion);
                } else {
                    var aProp = a[prop];
                    var bProp = b[prop];

                    if (isObject(aProp) && isObject(bProp)) {
                        fillIfDefined(aProp, bProp, allowDeletion);
                    }
                }
            }
        }
    }
    /**
     * Extend object a with selected properties of object b.
     * Only properties with defined values are copied.
     *
     * @remarks
     * Previous version of this routine implied that multiple source objects could
     * be used; however, the implementation was **wrong**. Since multiple (\>1)
     * sources weren't used anywhere in the `vis.js` code, this has been removed
     *
     * @param props - Names of first-level properties to copy over.
     * @param a - Target object.
     * @param b - Source object.
     * @param allowDeletion - If true, delete property in a if explicitly set to null in b.
     *
     * @returns Argument a.
     */


    function selectiveDeepExtend(props, a, b) {
        var allowDeletion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        // TODO: add support for Arrays to deepExtend
        if (isArray(b)) {
            throw new TypeError("Arrays are not supported by deepExtend");
        }

        for (var p = 0; p < props.length; p++) {
            var prop = props[p];

            if (Object.prototype.hasOwnProperty.call(b, prop)) {
                if (b[prop] && b[prop].constructor === Object) {
                    if (a[prop] === undefined) {
                        a[prop] = {};
                    }

                    if (a[prop].constructor === Object) {
                        deepExtend(a[prop], b[prop], false, allowDeletion);
                    } else {
                        copyOrDelete(a, b, prop, allowDeletion);
                    }
                } else if (isArray(b[prop])) {
                    throw new TypeError("Arrays are not supported by deepExtend");
                } else {
                    copyOrDelete(a, b, prop, allowDeletion);
                }
            }
        }

        return a;
    }
    /**
     * Extend object `a` with properties of object `b`, ignoring properties which
     * are explicitly specified to be excluded.
     *
     * @remarks
     * The properties of `b` are considered for copying. Properties which are
     * themselves objects are are also extended. Only properties with defined
     * values are copied.
     *
     * @param propsToExclude - Names of properties which should *not* be copied.
     * @param a - Object to extend.
     * @param b - Object to take properties from for extension.
     * @param allowDeletion - If true, delete properties in a that are explicitly
     * set to null in b.
     *
     * @returns Argument a.
     */


    function selectiveNotDeepExtend(propsToExclude, a, b) {
        var allowDeletion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        // TODO: add support for Arrays to deepExtend
        // NOTE: array properties have an else-below; apparently, there is a problem here.
        if (isArray(b)) {
            throw new TypeError("Arrays are not supported by deepExtend");
        }

        for (var prop in b) {
            if (!Object.prototype.hasOwnProperty.call(b, prop)) {
                continue;
            } // Handle local properties only


            if (includes(propsToExclude).call(propsToExclude, prop)) {
                continue;
            } // In exclusion list, skip


            if (b[prop] && b[prop].constructor === Object) {
                if (a[prop] === undefined) {
                    a[prop] = {};
                }

                if (a[prop].constructor === Object) {
                    deepExtend(a[prop], b[prop]); // NOTE: allowDeletion not propagated!
                } else {
                    copyOrDelete(a, b, prop, allowDeletion);
                }
            } else if (isArray(b[prop])) {
                a[prop] = [];

                for (var i = 0; i < b[prop].length; i++) {
                    a[prop].push(b[prop][i]);
                }
            } else {
                copyOrDelete(a, b, prop, allowDeletion);
            }
        }

        return a;
    }
    /**
     * Deep extend an object a with the properties of object b.
     *
     * @param a - Target object.
     * @param b - Source object.
     * @param protoExtend - If true, the prototype values will also be extended.
     * (That is the options objects that inherit from others will also get the
     * inherited options).
     * @param allowDeletion - If true, the values of fields that are null will be deleted.
     *
     * @returns Argument a.
     */


    function deepExtend(a, b) {
        var protoExtend = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var allowDeletion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        for (var prop in b) {
            if (Object.prototype.hasOwnProperty.call(b, prop) || protoExtend === true) {
                if (_typeof(b[prop]) === "object" && b[prop] !== null && getPrototypeOf$2(b[prop]) === Object.prototype) {
                    if (a[prop] === undefined) {
                        a[prop] = deepExtend({}, b[prop], protoExtend); // NOTE: allowDeletion not propagated!
                    } else if (_typeof(a[prop]) === "object" && a[prop] !== null && getPrototypeOf$2(a[prop]) === Object.prototype) {
                        deepExtend(a[prop], b[prop], protoExtend); // NOTE: allowDeletion not propagated!
                    } else {
                        copyOrDelete(a, b, prop, allowDeletion);
                    }
                } else if (isArray(b[prop])) {
                    var _context6;

                    a[prop] = slice$1(_context6 = b[prop]).call(_context6);
                } else {
                    copyOrDelete(a, b, prop, allowDeletion);
                }
            }
        }

        return a;
    }
    /**
     * Used to extend an array and copy it. This is used to propagate paths recursively.
     *
     * @param arr - First part.
     * @param newValue - The value to be aadded into the array.
     *
     * @returns A new array with all items from arr and newValue (which is last).
     */


    function copyAndExtendArray(arr, newValue) {
        var _context7;

        return concat(_context7 = []).call(_context7, _toConsumableArray(arr), [newValue]);
    }
    /**
     * Used to extend an array and copy it. This is used to propagate paths recursively.
     *
     * @param arr - The array to be copied.
     *
     * @returns Shallow copy of arr.
     */


    function copyArray(arr) {
        return slice$1(arr).call(arr);
    }
    /**
     * Retrieve the absolute left value of a DOM element.
     *
     * @param elem - A dom element, for example a div.
     *
     * @returns The absolute left position of this element in the browser page.
     */


    function getAbsoluteLeft(elem) {
        return elem.getBoundingClientRect().left;
    }
    /**
     * Retrieve the absolute top value of a DOM element.
     *
     * @param elem - A dom element, for example a div.
     *
     * @returns The absolute top position of this element in the browser page.
     */


    function getAbsoluteTop(elem) {
        return elem.getBoundingClientRect().top;
    }
    /**
     * For each method for both arrays and objects.
     * In case of an array, the built-in Array.forEach() is applied (**No, it's not!**).
     * In case of an Object, the method loops over all properties of the object.
     *
     * @param object - An Object or Array to be iterated over.
     * @param callback - Array.forEach-like callback.
     */


    function forEach$1(object, callback) {
        if (isArray(object)) {
            // array
            var len = object.length;

            for (var i = 0; i < len; i++) {
                callback(object[i], i, object);
            }
        } else {
            // object
            for (var key in object) {
                if (Object.prototype.hasOwnProperty.call(object, key)) {
                    callback(object[key], key, object);
                }
            }
        }
    }
    /**
     * Add and event listener. Works for all browsers.
     *
     * @param element - The element to bind the event listener to.
     * @param action - Same as Element.addEventListener(action, —, —).
     * @param listener - Same as Element.addEventListener(—, listener, —).
     * @param useCapture - Same as Element.addEventListener(—, —, useCapture).
     */


    function addEventListener(element, action, listener, useCapture) {
        if (element.addEventListener) {
            var _context8;

            if (useCapture === undefined) {
                useCapture = false;
            }

            if (action === "mousewheel" && includes(_context8 = navigator.userAgent).call(_context8, "Firefox")) {
                action = "DOMMouseScroll"; // For Firefox
            }

            element.addEventListener(action, listener, useCapture);
        } else {
            // @TODO: IE types? Does anyone care?
            element.attachEvent("on" + action, listener); // IE browsers
        }
    }
    /**
     * Remove an event listener from an element.
     *
     * @param element - The element to bind the event listener to.
     * @param action - Same as Element.removeEventListener(action, —, —).
     * @param listener - Same as Element.removeEventListener(—, listener, —).
     * @param useCapture - Same as Element.removeEventListener(—, —, useCapture).
     */


    function removeEventListener(element, action, listener, useCapture) {
        if (element.removeEventListener) {
            var _context9;

            // non-IE browsers
            if (useCapture === undefined) {
                useCapture = false;
            }

            if (action === "mousewheel" && includes(_context9 = navigator.userAgent).call(_context9, "Firefox")) {
                action = "DOMMouseScroll"; // For Firefox
            }

            element.removeEventListener(action, listener, useCapture);
        } else {
            // @TODO: IE types? Does anyone care?
            element.detachEvent("on" + action, listener); // IE browsers
        }
    }
    /**
     * Convert hex color string into RGB color object.
     *
     * @remarks
     * {@link http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb}
     *
     * @param hex - Hex color string (3 or 6 digits, with or without #).
     *
     * @returns RGB color object.
     */

    function hexToRGB(hex) {
        var result;

        switch (hex.length) {
            case 3:
            case 4:
                result = shortHexRE.exec(hex);
                return result ? {
                    r: _parseInt(result[1] + result[1], 16),
                    g: _parseInt(result[2] + result[2], 16),
                    b: _parseInt(result[3] + result[3], 16)
                } : null;

            case 6:
            case 7:
                result = fullHexRE.exec(hex);
                return result ? {
                    r: _parseInt(result[1], 16),
                    g: _parseInt(result[2], 16),
                    b: _parseInt(result[3], 16)
                } : null;

            default:
                return null;
        }
    }
    /**
     * This function takes string color in hex or RGB format and adds the opacity, RGBA is passed through unchanged.
     *
     * @param color - The color string (hex, RGB, RGBA).
     * @param opacity - The new opacity.
     *
     * @returns RGBA string, for example 'rgba(255, 0, 127, 0.3)'.
     */


    function overrideOpacity(color, opacity) {
        if (includes(color).call(color, "rgba")) {
            return color;
        } else if (includes(color).call(color, "rgb")) {
            var rgb = color.substr(indexOf(color).call(color, "(") + 1).replace(")", "").split(",");
            return "rgba(" + rgb[0] + "," + rgb[1] + "," + rgb[2] + "," + opacity + ")";
        } else {
            var _rgb = hexToRGB(color);

            if (_rgb == null) {
                return color;
            } else {
                return "rgba(" + _rgb.r + "," + _rgb.g + "," + _rgb.b + "," + opacity + ")";
            }
        }
    }
    /**
     * Convert RGB \<0, 255\> into hex color string.
     *
     * @param red - Red channel.
     * @param green - Green channel.
     * @param blue - Blue channel.
     *
     * @returns Hex color string (for example: '#0acdc0').
     */


    function RGBToHex(red, green, blue) {
        var _context10;

        return "#" + slice$1(_context10 = ((1 << 24) + (red << 16) + (green << 8) + blue).toString(16)).call(_context10, 1);
    }
    /**
     * Parse a color property into an object with border, background, and highlight colors.
     *
     * @param inputColor - Shorthand color string or input color object.
     * @param defaultColor - Full color object to fill in missing values in inputColor.
     *
     * @returns Color object.
     */


    function parseColor(inputColor, defaultColor) {
        if (isString(inputColor)) {
            var colorStr = inputColor;

            if (isValidRGB(colorStr)) {
                var _context11;

                var rgb = map$3(_context11 = colorStr.substr(4).substr(0, colorStr.length - 5).split(",")).call(_context11, function (value) {
                    return _parseInt(value);
                });

                colorStr = RGBToHex(rgb[0], rgb[1], rgb[2]);
            }

            if (isValidHex(colorStr) === true) {
                var hsv = hexToHSV(colorStr);
                var lighterColorHSV = {
                    h: hsv.h,
                    s: hsv.s * 0.8,
                    v: Math.min(1, hsv.v * 1.02)
                };
                var darkerColorHSV = {
                    h: hsv.h,
                    s: Math.min(1, hsv.s * 1.25),
                    v: hsv.v * 0.8
                };
                var darkerColorHex = HSVToHex(darkerColorHSV.h, darkerColorHSV.s, darkerColorHSV.v);
                var lighterColorHex = HSVToHex(lighterColorHSV.h, lighterColorHSV.s, lighterColorHSV.v);
                return {
                    background: colorStr,
                    border: darkerColorHex,
                    highlight: {
                        background: lighterColorHex,
                        border: darkerColorHex
                    },
                    hover: {
                        background: lighterColorHex,
                        border: darkerColorHex
                    }
                };
            } else {
                return {
                    background: colorStr,
                    border: colorStr,
                    highlight: {
                        background: colorStr,
                        border: colorStr
                    },
                    hover: {
                        background: colorStr,
                        border: colorStr
                    }
                };
            }
        } else {
            if (defaultColor) {
                var color = {
                    background: inputColor.background || defaultColor.background,
                    border: inputColor.border || defaultColor.border,
                    highlight: isString(inputColor.highlight) ? {
                        border: inputColor.highlight,
                        background: inputColor.highlight
                    } : {
                        background: inputColor.highlight && inputColor.highlight.background || defaultColor.highlight.background,
                        border: inputColor.highlight && inputColor.highlight.border || defaultColor.highlight.border
                    },
                    hover: isString(inputColor.hover) ? {
                        border: inputColor.hover,
                        background: inputColor.hover
                    } : {
                        border: inputColor.hover && inputColor.hover.border || defaultColor.hover.border,
                        background: inputColor.hover && inputColor.hover.background || defaultColor.hover.background
                    }
                };
                return color;
            } else {
                var _color = {
                    background: inputColor.background || undefined,
                    border: inputColor.border || undefined,
                    highlight: isString(inputColor.highlight) ? {
                        border: inputColor.highlight,
                        background: inputColor.highlight
                    } : {
                        background: inputColor.highlight && inputColor.highlight.background || undefined,
                        border: inputColor.highlight && inputColor.highlight.border || undefined
                    },
                    hover: isString(inputColor.hover) ? {
                        border: inputColor.hover,
                        background: inputColor.hover
                    } : {
                        border: inputColor.hover && inputColor.hover.border || undefined,
                        background: inputColor.hover && inputColor.hover.background || undefined
                    }
                };
                return _color;
            }
        }
    }
    /**
     * Convert RGB \<0, 255\> into HSV object.
     *
     * @remarks
     * {@link http://www.javascripter.net/faq/rgb2hsv.htm}
     *
     * @param red - Red channel.
     * @param green - Green channel.
     * @param blue - Blue channel.
     *
     * @returns HSV color object.
     */


    function RGBToHSV(red, green, blue) {
        red = red / 255;
        green = green / 255;
        blue = blue / 255;
        var minRGB = Math.min(red, Math.min(green, blue));
        var maxRGB = Math.max(red, Math.max(green, blue)); // Black-gray-white

        if (minRGB === maxRGB) {
            return {
                h: 0,
                s: 0,
                v: minRGB
            };
        } // Colors other than black-gray-white:


        var d = red === minRGB ? green - blue : blue === minRGB ? red - green : blue - red;
        var h = red === minRGB ? 3 : blue === minRGB ? 1 : 5;
        var hue = 60 * (h - d / (maxRGB - minRGB)) / 360;
        var saturation = (maxRGB - minRGB) / maxRGB;
        var value = maxRGB;
        return {
            h: hue,
            s: saturation,
            v: value
        };
    }
    /**
     * Convert HSV \<0, 1\> into RGB color object.
     *
     * @remarks
     * {@link https://gist.github.com/mjijackson/5311256}
     *
     * @param h - Hue.
     * @param s - Saturation.
     * @param v - Value.
     *
     * @returns RGB color object.
     */


    function HSVToRGB(h, s, v) {
        var r;
        var g;
        var b;
        var i = Math.floor(h * 6);
        var f = h * 6 - i;
        var p = v * (1 - s);
        var q = v * (1 - f * s);
        var t = v * (1 - (1 - f) * s);

        switch (i % 6) {
            case 0:
                r = v, g = t, b = p;
                break;

            case 1:
                r = q, g = v, b = p;
                break;

            case 2:
                r = p, g = v, b = t;
                break;

            case 3:
                r = p, g = q, b = v;
                break;

            case 4:
                r = t, g = p, b = v;
                break;

            case 5:
                r = v, g = p, b = q;
                break;
        }

        return {
            r: Math.floor(r * 255),
            g: Math.floor(g * 255),
            b: Math.floor(b * 255)
        };
    }
    /**
     * Convert HSV \<0, 1\> into hex color string.
     *
     * @param h - Hue.
     * @param s - Saturation.
     * @param v - Value.
     *
     * @returns Hex color string.
     */


    function HSVToHex(h, s, v) {
        var rgb = HSVToRGB(h, s, v);
        return RGBToHex(rgb.r, rgb.g, rgb.b);
    }
    /**
     * Convert hex color string into HSV \<0, 1\>.
     *
     * @param hex - Hex color string.
     *
     * @returns HSV color object.
     */


    function hexToHSV(hex) {
        var rgb = hexToRGB(hex);

        if (!rgb) {
            throw new TypeError("'".concat(hex, "' is not a valid color."));
        }

        return RGBToHSV(rgb.r, rgb.g, rgb.b);
    }
    /**
     * Validate hex color string.
     *
     * @param hex - Unknown string that may contain a color.
     *
     * @returns True if the string is valid, false otherwise.
     */


    function isValidHex(hex) {
        var isOk = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(hex);
        return isOk;
    }
    /**
     * Validate RGB color string.
     *
     * @param rgb - Unknown string that may contain a color.
     *
     * @returns True if the string is valid, false otherwise.
     */


    function isValidRGB(rgb) {
        return rgbRE.test(rgb);
    }
    /**
     * Validate RGBA color string.
     *
     * @param rgba - Unknown string that may contain a color.
     *
     * @returns True if the string is valid, false otherwise.
     */


    function isValidRGBA(rgba) {
        return rgbaRE.test(rgba);
    }
    /**
     * This recursively redirects the prototype of JSON objects to the referenceObject.
     * This is used for default options.
     *
     * @param referenceObject - The original object.
     *
     * @returns The Element if the referenceObject is an Element, or a new object inheriting from the referenceObject.
     */


    function bridgeObject(referenceObject) {
        if (referenceObject === null || _typeof(referenceObject) !== "object") {
            return null;
        }

        if (referenceObject instanceof Element) {
            // Avoid bridging DOM objects
            return referenceObject;
        }

        var objectTo = create$2(referenceObject);

        for (var i in referenceObject) {
            if (Object.prototype.hasOwnProperty.call(referenceObject, i)) {
                if (_typeof(referenceObject[i]) == "object") {
                    objectTo[i] = bridgeObject(referenceObject[i]);
                }
            }
        }

        return objectTo;
    }
    /**
     * This is used to set the options of subobjects in the options object.
     *
     * A requirement of these subobjects is that they have an 'enabled' element
     * which is optional for the user but mandatory for the program.
     *
     * The added value here of the merge is that option 'enabled' is set as required.
     *
     * @param mergeTarget - Either this.options or the options used for the groups.
     * @param options - Options.
     * @param option - Option key in the options argument.
     * @param globalOptions - Global options, passed in to determine value of option 'enabled'.
     */


    function mergeOptions(mergeTarget, options, option) {
        var globalOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

        // Local helpers
        var isPresent = function isPresent(obj) {
            return obj !== null && obj !== undefined;
        };

        var isObject = function isObject(obj) {
            return obj !== null && _typeof(obj) === "object";
        }; // https://stackoverflow.com/a/34491287/1223531


        var isEmpty = function isEmpty(obj) {
            for (var x in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, x)) {
                    return false;
                }
            }

            return true;
        }; // Guards


        if (!isObject(mergeTarget)) {
            throw new Error("Parameter mergeTarget must be an object");
        }

        if (!isObject(options)) {
            throw new Error("Parameter options must be an object");
        }

        if (!isPresent(option)) {
            throw new Error("Parameter option must have a value");
        }

        if (!isObject(globalOptions)) {
            throw new Error("Parameter globalOptions must be an object");
        } //
        // Actual merge routine, separated from main logic
        // Only a single level of options is merged. Deeper levels are ref'd. This may actually be an issue.
        //


        var doMerge = function doMerge(target, options, option) {
            if (!isObject(target[option])) {
                target[option] = {};
            }

            var src = options[option];
            var dst = target[option];

            for (var prop in src) {
                if (Object.prototype.hasOwnProperty.call(src, prop)) {
                    dst[prop] = src[prop];
                }
            }
        }; // Local initialization


        var srcOption = options[option];
        var globalPassed = isObject(globalOptions) && !isEmpty(globalOptions);
        var globalOption = globalPassed ? globalOptions[option] : undefined;
        var globalEnabled = globalOption ? globalOption.enabled : undefined; /////////////////////////////////////////
        // Main routine
        /////////////////////////////////////////

        if (srcOption === undefined) {
            return; // Nothing to do
        }

        if (typeof srcOption === "boolean") {
            if (!isObject(mergeTarget[option])) {
                mergeTarget[option] = {};
            }

            mergeTarget[option].enabled = srcOption;
            return;
        }

        if (srcOption === null && !isObject(mergeTarget[option])) {
            // If possible, explicit copy from globals
            if (isPresent(globalOption)) {
                mergeTarget[option] = create$2(globalOption);
            } else {
                return; // Nothing to do
            }
        }

        if (!isObject(srcOption)) {
            return;
        } //
        // Ensure that 'enabled' is properly set. It is required internally
        // Note that the value from options will always overwrite the existing value
        //


        var enabled = true; // default value

        if (srcOption.enabled !== undefined) {
            enabled = srcOption.enabled;
        } else {
            // Take from globals, if present
            if (globalEnabled !== undefined) {
                enabled = globalOption.enabled;
            }
        }

        doMerge(mergeTarget, options, option);
        mergeTarget[option].enabled = enabled;
    }
    /*
	 * Easing Functions.
	 * Only considering the t value for the range [0, 1] => [0, 1].
	 *
	 * Inspiration: from http://gizma.com/easing/
	 * https://gist.github.com/gre/1650294
	 */


    var easingFunctions = {
        /**
         * Provides no easing and no acceleration.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        linear: function linear(t) {
            return t;
        },

        /**
         * Accelerate from zero velocity.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeInQuad: function easeInQuad(t) {
            return t * t;
        },

        /**
         * Decelerate to zero velocity.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeOutQuad: function easeOutQuad(t) {
            return t * (2 - t);
        },

        /**
         * Accelerate until halfway, then decelerate.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeInOutQuad: function easeInOutQuad(t) {
            return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },

        /**
         * Accelerate from zero velocity.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeInCubic: function easeInCubic(t) {
            return t * t * t;
        },

        /**
         * Decelerate to zero velocity.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeOutCubic: function easeOutCubic(t) {
            return --t * t * t + 1;
        },

        /**
         * Accelerate until halfway, then decelerate.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeInOutCubic: function easeInOutCubic(t) {
            return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },

        /**
         * Accelerate from zero velocity.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeInQuart: function easeInQuart(t) {
            return t * t * t * t;
        },

        /**
         * Decelerate to zero velocity.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeOutQuart: function easeOutQuart(t) {
            return 1 - --t * t * t * t;
        },

        /**
         * Accelerate until halfway, then decelerate.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeInOutQuart: function easeInOutQuart(t) {
            return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },

        /**
         * Accelerate from zero velocity.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeInQuint: function easeInQuint(t) {
            return t * t * t * t * t;
        },

        /**
         * Decelerate to zero velocity.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeOutQuint: function easeOutQuint(t) {
            return 1 + --t * t * t * t * t;
        },

        /**
         * Accelerate until halfway, then decelerate.
         *
         * @param t - Time.
         *
         * @returns Value at time t.
         */
        easeInOutQuint: function easeInOutQuint(t) {
            return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
    };
    // It works only for single property objects,
    // otherwise it combines all of the types in a union.
    // export function topMost<K1 extends string, V1> (
    //   pile: Record<K1, undefined | V1>[],
    //   accessors: K1 | [K1]
    // ): undefined | V1
    // export function topMost<K1 extends string, K2 extends string, V1, V2> (
    //   pile: Record<K1, undefined | V1 | Record<K2, undefined | V2>>[],
    //   accessors: [K1, K2]
    // ): undefined | V1 | V2
    // export function topMost<K1 extends string, K2 extends string, K3 extends string, V1, V2, V3> (
    //   pile: Record<K1, undefined | V1 | Record<K2, undefined | V2 | Record<K3, undefined | V3>>>[],
    //   accessors: [K1, K2, K3]
    // ): undefined | V1 | V2 | V3

    /**
     * Get the top most property value from a pile of objects.
     *
     * @param pile - Array of objects, no required format.
     * @param accessors - Array of property names.
     * For example `object['foo']['bar']` → `['foo', 'bar']`.
     *
     * @returns Value of the property with given accessors path from the first pile item where it's not undefined.
     */


    function topMost(pile, accessors) {
        var candidate;

        if (!isArray(accessors)) {
            accessors = [accessors];
        }

        var _iterator3 = _createForOfIteratorHelper$8(pile),
            _step3;

        try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var member = _step3.value;

                if (member) {
                    candidate = member[accessors[0]];

                    for (var i = 1; i < accessors.length; i++) {
                        if (candidate) {
                            candidate = candidate[accessors[i]];
                        }
                    }

                    if (typeof candidate !== "undefined") {
                        break;
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally {
            _iterator3.f();
        }

        return candidate;
    }

    var htmlColors = {
        black: "#000000",
        navy: "#000080",
        darkblue: "#00008B",
        mediumblue: "#0000CD",
        blue: "#0000FF",
        darkgreen: "#006400",
        green: "#008000",
        teal: "#008080",
        darkcyan: "#008B8B",
        deepskyblue: "#00BFFF",
        darkturquoise: "#00CED1",
        mediumspringgreen: "#00FA9A",
        lime: "#00FF00",
        springgreen: "#00FF7F",
        aqua: "#00FFFF",
        cyan: "#00FFFF",
        midnightblue: "#191970",
        dodgerblue: "#1E90FF",
        lightseagreen: "#20B2AA",
        forestgreen: "#228B22",
        seagreen: "#2E8B57",
        darkslategray: "#2F4F4F",
        limegreen: "#32CD32",
        mediumseagreen: "#3CB371",
        turquoise: "#40E0D0",
        royalblue: "#4169E1",
        steelblue: "#4682B4",
        darkslateblue: "#483D8B",
        mediumturquoise: "#48D1CC",
        indigo: "#4B0082",
        darkolivegreen: "#556B2F",
        cadetblue: "#5F9EA0",
        cornflowerblue: "#6495ED",
        mediumaquamarine: "#66CDAA",
        dimgray: "#696969",
        slateblue: "#6A5ACD",
        olivedrab: "#6B8E23",
        slategray: "#708090",
        lightslategray: "#778899",
        mediumslateblue: "#7B68EE",
        lawngreen: "#7CFC00",
        chartreuse: "#7FFF00",
        aquamarine: "#7FFFD4",
        maroon: "#800000",
        purple: "#800080",
        olive: "#808000",
        gray: "#808080",
        skyblue: "#87CEEB",
        lightskyblue: "#87CEFA",
        blueviolet: "#8A2BE2",
        darkred: "#8B0000",
        darkmagenta: "#8B008B",
        saddlebrown: "#8B4513",
        darkseagreen: "#8FBC8F",
        lightgreen: "#90EE90",
        mediumpurple: "#9370D8",
        darkviolet: "#9400D3",
        palegreen: "#98FB98",
        darkorchid: "#9932CC",
        yellowgreen: "#9ACD32",
        sienna: "#A0522D",
        brown: "#A52A2A",
        darkgray: "#A9A9A9",
        lightblue: "#ADD8E6",
        greenyellow: "#ADFF2F",
        paleturquoise: "#AFEEEE",
        lightsteelblue: "#B0C4DE",
        powderblue: "#B0E0E6",
        firebrick: "#B22222",
        darkgoldenrod: "#B8860B",
        mediumorchid: "#BA55D3",
        rosybrown: "#BC8F8F",
        darkkhaki: "#BDB76B",
        silver: "#C0C0C0",
        mediumvioletred: "#C71585",
        indianred: "#CD5C5C",
        peru: "#CD853F",
        chocolate: "#D2691E",
        tan: "#D2B48C",
        lightgrey: "#D3D3D3",
        palevioletred: "#D87093",
        thistle: "#D8BFD8",
        orchid: "#DA70D6",
        goldenrod: "#DAA520",
        crimson: "#DC143C",
        gainsboro: "#DCDCDC",
        plum: "#DDA0DD",
        burlywood: "#DEB887",
        lightcyan: "#E0FFFF",
        lavender: "#E6E6FA",
        darksalmon: "#E9967A",
        violet: "#EE82EE",
        palegoldenrod: "#EEE8AA",
        lightcoral: "#F08080",
        khaki: "#F0E68C",
        aliceblue: "#F0F8FF",
        honeydew: "#F0FFF0",
        azure: "#F0FFFF",
        sandybrown: "#F4A460",
        wheat: "#F5DEB3",
        beige: "#F5F5DC",
        whitesmoke: "#F5F5F5",
        mintcream: "#F5FFFA",
        ghostwhite: "#F8F8FF",
        salmon: "#FA8072",
        antiquewhite: "#FAEBD7",
        linen: "#FAF0E6",
        lightgoldenrodyellow: "#FAFAD2",
        oldlace: "#FDF5E6",
        red: "#FF0000",
        fuchsia: "#FF00FF",
        magenta: "#FF00FF",
        deeppink: "#FF1493",
        orangered: "#FF4500",
        tomato: "#FF6347",
        hotpink: "#FF69B4",
        coral: "#FF7F50",
        darkorange: "#FF8C00",
        lightsalmon: "#FFA07A",
        orange: "#FFA500",
        lightpink: "#FFB6C1",
        pink: "#FFC0CB",
        gold: "#FFD700",
        peachpuff: "#FFDAB9",
        navajowhite: "#FFDEAD",
        moccasin: "#FFE4B5",
        bisque: "#FFE4C4",
        mistyrose: "#FFE4E1",
        blanchedalmond: "#FFEBCD",
        papayawhip: "#FFEFD5",
        lavenderblush: "#FFF0F5",
        seashell: "#FFF5EE",
        cornsilk: "#FFF8DC",
        lemonchiffon: "#FFFACD",
        floralwhite: "#FFFAF0",
        snow: "#FFFAFA",
        yellow: "#FFFF00",
        lightyellow: "#FFFFE0",
        ivory: "#FFFFF0",
        white: "#FFFFFF"
    };
    /**
     * @param {number} [pixelRatio=1]
     */

    var ColorPicker = /*#__PURE__*/function () {
        /**
         * @param {number} [pixelRatio=1]
         */
        function ColorPicker() {
            var pixelRatio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            _classCallCheck(this, ColorPicker);

            this.pixelRatio = pixelRatio;
            this.generated = false;
            this.centerCoordinates = {
                x: 289 / 2,
                y: 289 / 2
            };
            this.r = 289 * 0.49;
            this.color = {
                r: 255,
                g: 255,
                b: 255,
                a: 1.0
            };
            this.hueCircle = undefined;
            this.initialColor = {
                r: 255,
                g: 255,
                b: 255,
                a: 1.0
            };
            this.previousColor = undefined;
            this.applied = false; // bound by

            this.updateCallback = function () {};

            this.closeCallback = function () {}; // create all DOM elements


            this._create();
        }
        /**
         * this inserts the colorPicker into a div from the DOM
         *
         * @param {Element} container
         */


        _createClass(ColorPicker, [{
            key: "insertTo",
            value: function insertTo(container) {
                if (this.hammer !== undefined) {
                    this.hammer.destroy();
                    this.hammer = undefined;
                }

                this.container = container;
                this.container.appendChild(this.frame);

                this._bindHammer();

                this._setSize();
            }
            /**
             * the callback is executed on apply and save. Bind it to the application
             *
             * @param {Function} callback
             */

        }, {
            key: "setUpdateCallback",
            value: function setUpdateCallback(callback) {
                if (typeof callback === "function") {
                    this.updateCallback = callback;
                } else {
                    throw new Error("Function attempted to set as colorPicker update callback is not a function.");
                }
            }
            /**
             * the callback is executed on apply and save. Bind it to the application
             *
             * @param {Function} callback
             */

        }, {
            key: "setCloseCallback",
            value: function setCloseCallback(callback) {
                if (typeof callback === "function") {
                    this.closeCallback = callback;
                } else {
                    throw new Error("Function attempted to set as colorPicker closing callback is not a function.");
                }
            }
            /**
             *
             * @param {string} color
             * @returns {string}
             * @private
             */

        }, {
            key: "_isColorString",
            value: function _isColorString(color) {
                if (typeof color === "string") {
                    return htmlColors[color];
                }
            }
            /**
             * Set the color of the colorPicker
             * Supported formats:
             * 'red'                   --> HTML color string
             * '#ffffff'               --> hex string
             * 'rgb(255,255,255)'      --> rgb string
             * 'rgba(255,255,255,1.0)' --> rgba string
             * {r:255,g:255,b:255}     --> rgb object
             * {r:255,g:255,b:255,a:1.0} --> rgba object
             *
             * @param {string | object} color
             * @param {boolean} [setInitial=true]
             */

        }, {
            key: "setColor",
            value: function setColor(color) {
                var setInitial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                if (color === "none") {
                    return;
                }

                var rgba; // if a html color shorthand is used, convert to hex

                var htmlColor = this._isColorString(color);

                if (htmlColor !== undefined) {
                    color = htmlColor;
                } // check format


                if (isString(color) === true) {
                    if (isValidRGB(color) === true) {
                        var rgbaArray = color.substr(4).substr(0, color.length - 5).split(",");
                        rgba = {
                            r: rgbaArray[0],
                            g: rgbaArray[1],
                            b: rgbaArray[2],
                            a: 1.0
                        };
                    } else if (isValidRGBA(color) === true) {
                        var _rgbaArray = color.substr(5).substr(0, color.length - 6).split(",");

                        rgba = {
                            r: _rgbaArray[0],
                            g: _rgbaArray[1],
                            b: _rgbaArray[2],
                            a: _rgbaArray[3]
                        };
                    } else if (isValidHex(color) === true) {
                        var rgbObj = hexToRGB(color);
                        rgba = {
                            r: rgbObj.r,
                            g: rgbObj.g,
                            b: rgbObj.b,
                            a: 1.0
                        };
                    }
                } else {
                    if (color instanceof Object) {
                        if (color.r !== undefined && color.g !== undefined && color.b !== undefined) {
                            var alpha = color.a !== undefined ? color.a : "1.0";
                            rgba = {
                                r: color.r,
                                g: color.g,
                                b: color.b,
                                a: alpha
                            };
                        }
                    }
                } // set color


                if (rgba === undefined) {
                    throw new Error("Unknown color passed to the colorPicker. Supported are strings: rgb, hex, rgba. Object: rgb ({r:r,g:g,b:b,[a:a]}). Supplied: " + stringify$1(color));
                } else {
                    this._setColor(rgba, setInitial);
                }
            }
            /**
             * this shows the color picker.
             * The hue circle is constructed once and stored.
             */

        }, {
            key: "show",
            value: function show() {
                if (this.closeCallback !== undefined) {
                    this.closeCallback();
                    this.closeCallback = undefined;
                }

                this.applied = false;
                this.frame.style.display = "block";

                this._generateHueCircle();
            } // ------------------------------------------ PRIVATE ----------------------------- //

            /**
             * Hide the picker. Is called by the cancel button.
             * Optional boolean to store the previous color for easy access later on.
             *
             * @param {boolean} [storePrevious=true]
             * @private
             */

        }, {
            key: "_hide",
            value: function _hide() {
                var _this2 = this;

                var storePrevious = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                // store the previous color for next time;
                if (storePrevious === true) {
                    this.previousColor = assign$2({}, this.color);
                }

                if (this.applied === true) {
                    this.updateCallback(this.initialColor);
                }

                this.frame.style.display = "none"; // call the closing callback, restoring the onclick method.
                // this is in a setTimeout because it will trigger the show again before the click is done.

                setTimeout$1(function () {
                    if (_this2.closeCallback !== undefined) {
                        _this2.closeCallback();

                        _this2.closeCallback = undefined;
                    }
                }, 0);
            }
            /**
             * bound to the save button. Saves and hides.
             *
             * @private
             */

        }, {
            key: "_save",
            value: function _save() {
                this.updateCallback(this.color);
                this.applied = false;

                this._hide();
            }
            /**
             * Bound to apply button. Saves but does not close. Is undone by the cancel button.
             *
             * @private
             */

        }, {
            key: "_apply",
            value: function _apply() {
                this.applied = true;
                this.updateCallback(this.color);

                this._updatePicker(this.color);
            }
            /**
             * load the color from the previous session.
             *
             * @private
             */

        }, {
            key: "_loadLast",
            value: function _loadLast() {
                if (this.previousColor !== undefined) {
                    this.setColor(this.previousColor, false);
                } else {
                    alert("There is no last color to load...");
                }
            }
            /**
             * set the color, place the picker
             *
             * @param {object} rgba
             * @param {boolean} [setInitial=true]
             * @private
             */

        }, {
            key: "_setColor",
            value: function _setColor(rgba) {
                var setInitial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                // store the initial color
                if (setInitial === true) {
                    this.initialColor = assign$2({}, rgba);
                }

                this.color = rgba;
                var hsv = RGBToHSV(rgba.r, rgba.g, rgba.b);
                var angleConvert = 2 * Math.PI;
                var radius = this.r * hsv.s;
                var x = this.centerCoordinates.x + radius * Math.sin(angleConvert * hsv.h);
                var y = this.centerCoordinates.y + radius * Math.cos(angleConvert * hsv.h);
                this.colorPickerSelector.style.left = x - 0.5 * this.colorPickerSelector.clientWidth + "px";
                this.colorPickerSelector.style.top = y - 0.5 * this.colorPickerSelector.clientHeight + "px";

                this._updatePicker(rgba);
            }
            /**
             * bound to opacity control
             *
             * @param {number} value
             * @private
             */

        }, {
            key: "_setOpacity",
            value: function _setOpacity(value) {
                this.color.a = value / 100;

                this._updatePicker(this.color);
            }
            /**
             * bound to brightness control
             *
             * @param {number} value
             * @private
             */

        }, {
            key: "_setBrightness",
            value: function _setBrightness(value) {
                var hsv = RGBToHSV(this.color.r, this.color.g, this.color.b);
                hsv.v = value / 100;
                var rgba = HSVToRGB(hsv.h, hsv.s, hsv.v);
                rgba["a"] = this.color.a;
                this.color = rgba;

                this._updatePicker();
            }
            /**
             * update the color picker. A black circle overlays the hue circle to mimic the brightness decreasing.
             *
             * @param {object} rgba
             * @private
             */

        }, {
            key: "_updatePicker",
            value: function _updatePicker() {
                var rgba = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.color;
                var hsv = RGBToHSV(rgba.r, rgba.g, rgba.b);
                var ctx = this.colorPickerCanvas.getContext("2d");

                if (this.pixelRation === undefined) {
                    this.pixelRatio = (window.devicePixelRatio || 1) / (ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1);
                }

                ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0); // clear the canvas

                var w = this.colorPickerCanvas.clientWidth;
                var h = this.colorPickerCanvas.clientHeight;
                ctx.clearRect(0, 0, w, h);
                ctx.putImageData(this.hueCircle, 0, 0);
                ctx.fillStyle = "rgba(0,0,0," + (1 - hsv.v) + ")";
                ctx.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r);

                fill(ctx).call(ctx);

                this.brightnessRange.value = 100 * hsv.v;
                this.opacityRange.value = 100 * rgba.a;
                this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")";
                this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
            }
            /**
             * used by create to set the size of the canvas.
             *
             * @private
             */

        }, {
            key: "_setSize",
            value: function _setSize() {
                this.colorPickerCanvas.style.width = "100%";
                this.colorPickerCanvas.style.height = "100%";
                this.colorPickerCanvas.width = 289 * this.pixelRatio;
                this.colorPickerCanvas.height = 289 * this.pixelRatio;
            }
            /**
             * create all dom elements
             * TODO: cleanup, lots of similar dom elements
             *
             * @private
             */

        }, {
            key: "_create",
            value: function _create() {
                var _context16, _context17, _context18, _context19;

                this.frame = document.createElement("div");
                this.frame.className = "vis-color-picker";
                this.colorPickerDiv = document.createElement("div");
                this.colorPickerSelector = document.createElement("div");
                this.colorPickerSelector.className = "vis-selector";
                this.colorPickerDiv.appendChild(this.colorPickerSelector);
                this.colorPickerCanvas = document.createElement("canvas");
                this.colorPickerDiv.appendChild(this.colorPickerCanvas);

                if (!this.colorPickerCanvas.getContext) {
                    var noCanvas = document.createElement("DIV");
                    noCanvas.style.color = "red";
                    noCanvas.style.fontWeight = "bold";
                    noCanvas.style.padding = "10px";
                    noCanvas.innerText = "Error: your browser does not support HTML canvas";
                    this.colorPickerCanvas.appendChild(noCanvas);
                } else {
                    var ctx = this.colorPickerCanvas.getContext("2d");
                    this.pixelRatio = (window.devicePixelRatio || 1) / (ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1);
                    this.colorPickerCanvas.getContext("2d").setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
                }

                this.colorPickerDiv.className = "vis-color";
                this.opacityDiv = document.createElement("div");
                this.opacityDiv.className = "vis-opacity";
                this.brightnessDiv = document.createElement("div");
                this.brightnessDiv.className = "vis-brightness";
                this.arrowDiv = document.createElement("div");
                this.arrowDiv.className = "vis-arrow";
                this.opacityRange = document.createElement("input");

                try {
                    this.opacityRange.type = "range"; // Not supported on IE9

                    this.opacityRange.min = "0";
                    this.opacityRange.max = "100";
                } catch (err) {// TODO: Add some error handling.
                }

                this.opacityRange.value = "100";
                this.opacityRange.className = "vis-range";
                this.brightnessRange = document.createElement("input");

                try {
                    this.brightnessRange.type = "range"; // Not supported on IE9

                    this.brightnessRange.min = "0";
                    this.brightnessRange.max = "100";
                } catch (err) {// TODO: Add some error handling.
                }

                this.brightnessRange.value = "100";
                this.brightnessRange.className = "vis-range";
                this.opacityDiv.appendChild(this.opacityRange);
                this.brightnessDiv.appendChild(this.brightnessRange);
                var me = this;

                this.opacityRange.onchange = function () {
                    me._setOpacity(this.value);
                };

                this.opacityRange.oninput = function () {
                    me._setOpacity(this.value);
                };

                this.brightnessRange.onchange = function () {
                    me._setBrightness(this.value);
                };

                this.brightnessRange.oninput = function () {
                    me._setBrightness(this.value);
                };

                this.brightnessLabel = document.createElement("div");
                this.brightnessLabel.className = "vis-label vis-brightness";
                this.brightnessLabel.innerText = "brightness:";
                this.opacityLabel = document.createElement("div");
                this.opacityLabel.className = "vis-label vis-opacity";
                this.opacityLabel.innerText = "opacity:";
                this.newColorDiv = document.createElement("div");
                this.newColorDiv.className = "vis-new-color";
                this.newColorDiv.innerText = "new";
                this.initialColorDiv = document.createElement("div");
                this.initialColorDiv.className = "vis-initial-color";
                this.initialColorDiv.innerText = "initial";
                this.cancelButton = document.createElement("div");
                this.cancelButton.className = "vis-button vis-cancel";
                this.cancelButton.innerText = "cancel";
                this.cancelButton.onclick = bind(_context16 = this._hide).call(_context16, this, false);
                this.applyButton = document.createElement("div");
                this.applyButton.className = "vis-button vis-apply";
                this.applyButton.innerText = "apply";
                this.applyButton.onclick = bind(_context17 = this._apply).call(_context17, this);
                this.saveButton = document.createElement("div");
                this.saveButton.className = "vis-button vis-save";
                this.saveButton.innerText = "save";
                this.saveButton.onclick = bind(_context18 = this._save).call(_context18, this);
                this.loadButton = document.createElement("div");
                this.loadButton.className = "vis-button vis-load";
                this.loadButton.innerText = "load last";
                this.loadButton.onclick = bind(_context19 = this._loadLast).call(_context19, this);
                this.frame.appendChild(this.colorPickerDiv);
                this.frame.appendChild(this.arrowDiv);
                this.frame.appendChild(this.brightnessLabel);
                this.frame.appendChild(this.brightnessDiv);
                this.frame.appendChild(this.opacityLabel);
                this.frame.appendChild(this.opacityDiv);
                this.frame.appendChild(this.newColorDiv);
                this.frame.appendChild(this.initialColorDiv);
                this.frame.appendChild(this.cancelButton);
                this.frame.appendChild(this.applyButton);
                this.frame.appendChild(this.saveButton);
                this.frame.appendChild(this.loadButton);
            }
            /**
             * bind hammer to the color picker
             *
             * @private
             */

        }, {
            key: "_bindHammer",
            value: function _bindHammer() {
                var _this3 = this;

                this.drag = {};
                this.pinch = {};
                this.hammer = new Hammer(this.colorPickerCanvas);
                this.hammer.get("pinch").set({
                    enable: true
                });
                this.hammer.on("hammer.input", function (event) {
                    if (event.isFirst) {
                        _this3._moveSelector(event);
                    }
                });
                this.hammer.on("tap", function (event) {
                    _this3._moveSelector(event);
                });
                this.hammer.on("panstart", function (event) {
                    _this3._moveSelector(event);
                });
                this.hammer.on("panmove", function (event) {
                    _this3._moveSelector(event);
                });
                this.hammer.on("panend", function (event) {
                    _this3._moveSelector(event);
                });
            }
            /**
             * generate the hue circle. This is relatively heavy (200ms) and is done only once on the first time it is shown.
             *
             * @private
             */

        }, {
            key: "_generateHueCircle",
            value: function _generateHueCircle() {
                if (this.generated === false) {
                    var ctx = this.colorPickerCanvas.getContext("2d");

                    if (this.pixelRation === undefined) {
                        this.pixelRatio = (window.devicePixelRatio || 1) / (ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1);
                    }

                    ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0); // clear the canvas

                    var w = this.colorPickerCanvas.clientWidth;
                    var h = this.colorPickerCanvas.clientHeight;
                    ctx.clearRect(0, 0, w, h); // draw hue circle

                    var x, y, hue, sat;
                    this.centerCoordinates = {
                        x: w * 0.5,
                        y: h * 0.5
                    };
                    this.r = 0.49 * w;
                    var angleConvert = 2 * Math.PI / 360;
                    var hfac = 1 / 360;
                    var sfac = 1 / this.r;
                    var rgb;

                    for (hue = 0; hue < 360; hue++) {
                        for (sat = 0; sat < this.r; sat++) {
                            x = this.centerCoordinates.x + sat * Math.sin(angleConvert * hue);
                            y = this.centerCoordinates.y + sat * Math.cos(angleConvert * hue);
                            rgb = HSVToRGB(hue * hfac, sat * sfac, 1);
                            ctx.fillStyle = "rgb(" + rgb.r + "," + rgb.g + "," + rgb.b + ")";
                            ctx.fillRect(x - 0.5, y - 0.5, 2, 2);
                        }
                    }

                    ctx.strokeStyle = "rgba(0,0,0,1)";
                    ctx.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r);
                    ctx.stroke();
                    this.hueCircle = ctx.getImageData(0, 0, w, h);
                }

                this.generated = true;
            }
            /**
             * move the selector. This is called by hammer functions.
             *
             * @param {Event}  event   The event
             * @private
             */

        }, {
            key: "_moveSelector",
            value: function _moveSelector(event) {
                var rect = this.colorPickerDiv.getBoundingClientRect();
                var left = event.center.x - rect.left;
                var top = event.center.y - rect.top;
                var centerY = 0.5 * this.colorPickerDiv.clientHeight;
                var centerX = 0.5 * this.colorPickerDiv.clientWidth;
                var x = left - centerX;
                var y = top - centerY;
                var angle = Math.atan2(x, y);
                var radius = 0.98 * Math.min(Math.sqrt(x * x + y * y), centerX);
                var newTop = Math.cos(angle) * radius + centerY;
                var newLeft = Math.sin(angle) * radius + centerX;
                this.colorPickerSelector.style.top = newTop - 0.5 * this.colorPickerSelector.clientHeight + "px";
                this.colorPickerSelector.style.left = newLeft - 0.5 * this.colorPickerSelector.clientWidth + "px"; // set color

                var h = angle / (2 * Math.PI);
                h = h < 0 ? h + 1 : h;
                var s = radius / this.r;
                var hsv = RGBToHSV(this.color.r, this.color.g, this.color.b);
                hsv.h = h;
                hsv.s = s;
                var rgba = HSVToRGB(hsv.h, hsv.s, hsv.v);
                rgba["a"] = this.color.a;
                this.color = rgba; // update previews

                this.initialColorDiv.style.backgroundColor = "rgba(" + this.initialColor.r + "," + this.initialColor.g + "," + this.initialColor.b + "," + this.initialColor.a + ")";
                this.newColorDiv.style.backgroundColor = "rgba(" + this.color.r + "," + this.color.g + "," + this.color.b + "," + this.color.a + ")";
            }
        }]);

        return ColorPicker;
    }();
    /**
     * Wrap given text (last argument) in HTML elements (all preceding arguments).
     *
     * @param {...any} rest - List of tag names followed by inner text.
     *
     * @returns An element or a text node.
     */


    function wrapInTag() {
        for (var _len5 = arguments.length, rest = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            rest[_key5] = arguments[_key5];
        }

        if (rest.length < 1) {
            throw new TypeError("Invalid arguments.");
        } else if (rest.length === 1) {
            return document.createTextNode(rest[0]);
        } else {
            var element = document.createElement(rest[0]);
            element.appendChild(wrapInTag.apply(void 0, _toConsumableArray(slice$1(rest).call(rest, 1))));
            return element;
        }
    }
    /**
     * The way this works is for all properties of this.possible options, you can supply the property name in any form to list the options.
     * Boolean options are recognised as Boolean
     * Number options should be written as array: [default value, min value, max value, stepsize]
     * Colors should be written as array: ['color', '#ffffff']
     * Strings with should be written as array: [option1, option2, option3, ..]
     *
     * The options are matched with their counterparts in each of the modules and the values used in the configuration are
     */


    var Configurator = /*#__PURE__*/function () {
        /**
         * @param {object} parentModule        | the location where parentModule.setOptions() can be called
         * @param {object} defaultContainer    | the default container of the module
         * @param {object} configureOptions    | the fully configured and predefined options set found in allOptions.js
         * @param {number} pixelRatio          | canvas pixel ratio
         * @param {Function} hideOption        | custom logic to dynamically hide options
         */
        function Configurator(parentModule, defaultContainer, configureOptions) {
            var pixelRatio = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
            var hideOption = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {
                return false;
            };

            _classCallCheck(this, Configurator);

            this.parent = parentModule;
            this.changedOptions = [];
            this.container = defaultContainer;
            this.allowCreation = false;
            this.hideOption = hideOption;
            this.options = {};
            this.initialized = false;
            this.popupCounter = 0;
            this.defaultOptions = {
                enabled: false,
                filter: true,
                container: undefined,
                showButton: true
            };

            assign$2(this.options, this.defaultOptions);

            this.configureOptions = configureOptions;
            this.moduleOptions = {};
            this.domElements = [];
            this.popupDiv = {};
            this.popupLimit = 5;
            this.popupHistory = {};
            this.colorPicker = new ColorPicker(pixelRatio);
            this.wrapper = undefined;
        }
        /**
         * refresh all options.
         * Because all modules parse their options by themselves, we just use their options. We copy them here.
         *
         * @param {object} options
         */


        _createClass(Configurator, [{
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    // reset the popup history because the indices may have been changed.
                    this.popupHistory = {};

                    this._removePopup();

                    var enabled = true;

                    if (typeof options === "string") {
                        this.options.filter = options;
                    } else if (isArray(options)) {
                        this.options.filter = options.join();
                    } else if (_typeof(options) === "object") {
                        if (options == null) {
                            throw new TypeError("options cannot be null");
                        }

                        if (options.container !== undefined) {
                            this.options.container = options.container;
                        }

                        if (filter(options) !== undefined) {
                            this.options.filter = filter(options);
                        }

                        if (options.showButton !== undefined) {
                            this.options.showButton = options.showButton;
                        }

                        if (options.enabled !== undefined) {
                            enabled = options.enabled;
                        }
                    } else if (typeof options === "boolean") {
                        this.options.filter = true;
                        enabled = options;
                    } else if (typeof options === "function") {
                        this.options.filter = options;
                        enabled = true;
                    }

                    if (filter(this.options) === false) {
                        enabled = false;
                    }

                    this.options.enabled = enabled;
                }

                this._clean();
            }
            /**
             *
             * @param {object} moduleOptions
             */

        }, {
            key: "setModuleOptions",
            value: function setModuleOptions(moduleOptions) {
                this.moduleOptions = moduleOptions;

                if (this.options.enabled === true) {
                    this._clean();

                    if (this.options.container !== undefined) {
                        this.container = this.options.container;
                    }

                    this._create();
                }
            }
            /**
             * Create all DOM elements
             *
             * @private
             */

        }, {
            key: "_create",
            value: function _create() {
                this._clean();

                this.changedOptions = [];

                var filter$1 = filter(this.options);

                var counter = 0;
                var show = false;

                for (var _option in this.configureOptions) {
                    if (Object.prototype.hasOwnProperty.call(this.configureOptions, _option)) {
                        this.allowCreation = false;
                        show = false;

                        if (typeof filter$1 === "function") {
                            show = filter$1(_option, []);
                            show = show || this._handleObject(this.configureOptions[_option], [_option], true);
                        } else if (filter$1 === true || indexOf(filter$1).call(filter$1, _option) !== -1) {
                            show = true;
                        }

                        if (show !== false) {
                            this.allowCreation = true; // linebreak between categories

                            if (counter > 0) {
                                this._makeItem([]);
                            } // a header for the category


                            this._makeHeader(_option); // get the sub options


                            this._handleObject(this.configureOptions[_option], [_option]);
                        }

                        counter++;
                    }
                }

                this._makeButton();

                this._push(); //~ this.colorPicker.insertTo(this.container);

            }
            /**
             * draw all DOM elements on the screen
             *
             * @private
             */

        }, {
            key: "_push",
            value: function _push() {
                this.wrapper = document.createElement("div");
                this.wrapper.className = "vis-configuration-wrapper";
                this.container.appendChild(this.wrapper);

                for (var i = 0; i < this.domElements.length; i++) {
                    this.wrapper.appendChild(this.domElements[i]);
                }

                this._showPopupIfNeeded();
            }
            /**
             * delete all DOM elements
             *
             * @private
             */

        }, {
            key: "_clean",
            value: function _clean() {
                for (var i = 0; i < this.domElements.length; i++) {
                    this.wrapper.removeChild(this.domElements[i]);
                }

                if (this.wrapper !== undefined) {
                    this.container.removeChild(this.wrapper);
                    this.wrapper = undefined;
                }

                this.domElements = [];

                this._removePopup();
            }
            /**
             * get the value from the actualOptions if it exists
             *
             * @param {Array} path    | where to look for the actual option
             * @returns {*}
             * @private
             */

        }, {
            key: "_getValue",
            value: function _getValue(path) {
                var base = this.moduleOptions;

                for (var i = 0; i < path.length; i++) {
                    if (base[path[i]] !== undefined) {
                        base = base[path[i]];
                    } else {
                        base = undefined;
                        break;
                    }
                }

                return base;
            }
            /**
             * all option elements are wrapped in an item
             *
             * @param {Array} path    | where to look for the actual option
             * @param {Array.<Element>} domElements
             * @returns {number}
             * @private
             */

        }, {
            key: "_makeItem",
            value: function _makeItem(path) {
                if (this.allowCreation === true) {
                    var item = document.createElement("div");
                    item.className = "vis-configuration vis-config-item vis-config-s" + path.length;

                    for (var _len6 = arguments.length, domElements = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
                        domElements[_key6 - 1] = arguments[_key6];
                    }

                    forEach$2(domElements).call(domElements, function (element) {
                        item.appendChild(element);
                    });

                    this.domElements.push(item);
                    return this.domElements.length;
                }

                return 0;
            }
            /**
             * header for major subjects
             *
             * @param {string} name
             * @private
             */

        }, {
            key: "_makeHeader",
            value: function _makeHeader(name) {
                var div = document.createElement("div");
                div.className = "vis-configuration vis-config-header";
                div.innerText = name;

                this._makeItem([], div);
            }
            /**
             * make a label, if it is an object label, it gets different styling.
             *
             * @param {string} name
             * @param {Array} path    | where to look for the actual option
             * @param {string} objectLabel
             * @returns {HTMLElement}
             * @private
             */

        }, {
            key: "_makeLabel",
            value: function _makeLabel(name, path) {
                var objectLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var div = document.createElement("div");
                div.className = "vis-configuration vis-config-label vis-config-s" + path.length;

                if (objectLabel === true) {
                    while (div.firstChild) {
                        div.removeChild(div.firstChild);
                    }

                    div.appendChild(wrapInTag("i", "b", name));
                } else {
                    div.innerText = name + ":";
                }

                return div;
            }
            /**
             * make a dropdown list for multiple possible string optoins
             *
             * @param {Array.<number>} arr
             * @param {number} value
             * @param {Array} path    | where to look for the actual option
             * @private
             */

        }, {
            key: "_makeDropdown",
            value: function _makeDropdown(arr, value, path) {
                var select = document.createElement("select");
                select.className = "vis-configuration vis-config-select";
                var selectedValue = 0;

                if (value !== undefined) {
                    if (indexOf(arr).call(arr, value) !== -1) {
                        selectedValue = indexOf(arr).call(arr, value);
                    }
                }

                for (var i = 0; i < arr.length; i++) {
                    var _option2 = document.createElement("option");

                    _option2.value = arr[i];

                    if (i === selectedValue) {
                        _option2.selected = "selected";
                    }

                    _option2.innerText = arr[i];
                    select.appendChild(_option2);
                }

                var me = this;

                select.onchange = function () {
                    me._update(this.value, path);
                };

                var label = this._makeLabel(path[path.length - 1], path);

                this._makeItem(path, label, select);
            }
            /**
             * make a range object for numeric options
             *
             * @param {Array.<number>} arr
             * @param {number} value
             * @param {Array} path    | where to look for the actual option
             * @private
             */

        }, {
            key: "_makeRange",
            value: function _makeRange(arr, value, path) {
                var defaultValue = arr[0];
                var min = arr[1];
                var max = arr[2];
                var step = arr[3];
                var range = document.createElement("input");
                range.className = "vis-configuration vis-config-range";

                try {
                    range.type = "range"; // not supported on IE9

                    range.min = min;
                    range.max = max;
                } catch (err) {// TODO: Add some error handling.
                }

                range.step = step; // set up the popup settings in case they are needed.

                var popupString = "";
                var popupValue = 0;

                if (value !== undefined) {
                    var factor = 1.2;

                    if (value < 0 && value * factor < min) {
                        range.min = Math.ceil(value * factor);
                        popupValue = range.min;
                        popupString = "range increased";
                    } else if (value / factor < min) {
                        range.min = Math.ceil(value / factor);
                        popupValue = range.min;
                        popupString = "range increased";
                    }

                    if (value * factor > max && max !== 1) {
                        range.max = Math.ceil(value * factor);
                        popupValue = range.max;
                        popupString = "range increased";
                    }

                    range.value = value;
                } else {
                    range.value = defaultValue;
                }

                var input = document.createElement("input");
                input.className = "vis-configuration vis-config-rangeinput";
                input.value = range.value;
                var me = this;

                range.onchange = function () {
                    input.value = this.value;

                    me._update(Number(this.value), path);
                };

                range.oninput = function () {
                    input.value = this.value;
                };

                var label = this._makeLabel(path[path.length - 1], path);

                var itemIndex = this._makeItem(path, label, range, input); // if a popup is needed AND it has not been shown for this value, show it.


                if (popupString !== "" && this.popupHistory[itemIndex] !== popupValue) {
                    this.popupHistory[itemIndex] = popupValue;

                    this._setupPopup(popupString, itemIndex);
                }
            }
            /**
             * make a button object
             *
             * @private
             */

        }, {
            key: "_makeButton",
            value: function _makeButton() {
                var _this4 = this;

                if (this.options.showButton === true) {
                    var generateButton = document.createElement("div");
                    generateButton.className = "vis-configuration vis-config-button";
                    generateButton.innerText = "generate options";

                    generateButton.onclick = function () {
                        _this4._printOptions();
                    };

                    generateButton.onmouseover = function () {
                        generateButton.className = "vis-configuration vis-config-button hover";
                    };

                    generateButton.onmouseout = function () {
                        generateButton.className = "vis-configuration vis-config-button";
                    };

                    this.optionsContainer = document.createElement("div");
                    this.optionsContainer.className = "vis-configuration vis-config-option-container";
                    this.domElements.push(this.optionsContainer);
                    this.domElements.push(generateButton);
                }
            }
            /**
             * prepare the popup
             *
             * @param {string} string
             * @param {number} index
             * @private
             */

        }, {
            key: "_setupPopup",
            value: function _setupPopup(string, index) {
                var _this5 = this;

                if (this.initialized === true && this.allowCreation === true && this.popupCounter < this.popupLimit) {
                    var div = document.createElement("div");
                    div.id = "vis-configuration-popup";
                    div.className = "vis-configuration-popup";
                    div.innerText = string;

                    div.onclick = function () {
                        _this5._removePopup();
                    };

                    this.popupCounter += 1;
                    this.popupDiv = {
                        html: div,
                        index: index
                    };
                }
            }
            /**
             * remove the popup from the dom
             *
             * @private
             */

        }, {
            key: "_removePopup",
            value: function _removePopup() {
                if (this.popupDiv.html !== undefined) {
                    this.popupDiv.html.parentNode.removeChild(this.popupDiv.html);
                    clearTimeout(this.popupDiv.hideTimeout);
                    clearTimeout(this.popupDiv.deleteTimeout);
                    this.popupDiv = {};
                }
            }
            /**
             * Show the popup if it is needed.
             *
             * @private
             */

        }, {
            key: "_showPopupIfNeeded",
            value: function _showPopupIfNeeded() {
                var _this6 = this;

                if (this.popupDiv.html !== undefined) {
                    var correspondingElement = this.domElements[this.popupDiv.index];
                    var rect = correspondingElement.getBoundingClientRect();
                    this.popupDiv.html.style.left = rect.left + "px";
                    this.popupDiv.html.style.top = rect.top - 30 + "px"; // 30 is the height;

                    document.body.appendChild(this.popupDiv.html);
                    this.popupDiv.hideTimeout = setTimeout$1(function () {
                        _this6.popupDiv.html.style.opacity = 0;
                    }, 1500);
                    this.popupDiv.deleteTimeout = setTimeout$1(function () {
                        _this6._removePopup();
                    }, 1800);
                }
            }
            /**
             * make a checkbox for boolean options.
             *
             * @param {number} defaultValue
             * @param {number} value
             * @param {Array} path    | where to look for the actual option
             * @private
             */

        }, {
            key: "_makeCheckbox",
            value: function _makeCheckbox(defaultValue, value, path) {
                var checkbox = document.createElement("input");
                checkbox.type = "checkbox";
                checkbox.className = "vis-configuration vis-config-checkbox";
                checkbox.checked = defaultValue;

                if (value !== undefined) {
                    checkbox.checked = value;

                    if (value !== defaultValue) {
                        if (_typeof(defaultValue) === "object") {
                            if (value !== defaultValue.enabled) {
                                this.changedOptions.push({
                                    path: path,
                                    value: value
                                });
                            }
                        } else {
                            this.changedOptions.push({
                                path: path,
                                value: value
                            });
                        }
                    }
                }

                var me = this;

                checkbox.onchange = function () {
                    me._update(this.checked, path);
                };

                var label = this._makeLabel(path[path.length - 1], path);

                this._makeItem(path, label, checkbox);
            }
            /**
             * make a text input field for string options.
             *
             * @param {number} defaultValue
             * @param {number} value
             * @param {Array} path    | where to look for the actual option
             * @private
             */

        }, {
            key: "_makeTextInput",
            value: function _makeTextInput(defaultValue, value, path) {
                var checkbox = document.createElement("input");
                checkbox.type = "text";
                checkbox.className = "vis-configuration vis-config-text";
                checkbox.value = value;

                if (value !== defaultValue) {
                    this.changedOptions.push({
                        path: path,
                        value: value
                    });
                }

                var me = this;

                checkbox.onchange = function () {
                    me._update(this.value, path);
                };

                var label = this._makeLabel(path[path.length - 1], path);

                this._makeItem(path, label, checkbox);
            }
            /**
             * make a color field with a color picker for color fields
             *
             * @param {Array.<number>} arr
             * @param {number} value
             * @param {Array} path    | where to look for the actual option
             * @private
             */

        }, {
            key: "_makeColorField",
            value: function _makeColorField(arr, value, path) {
                var _this7 = this;

                var defaultColor = arr[1];
                var div = document.createElement("div");
                value = value === undefined ? defaultColor : value;

                if (value !== "none") {
                    div.className = "vis-configuration vis-config-colorBlock";
                    div.style.backgroundColor = value;
                } else {
                    div.className = "vis-configuration vis-config-colorBlock none";
                }

                value = value === undefined ? defaultColor : value;

                div.onclick = function () {
                    _this7._showColorPicker(value, div, path);
                };

                var label = this._makeLabel(path[path.length - 1], path);

                this._makeItem(path, label, div);
            }
            /**
             * used by the color buttons to call the color picker.
             *
             * @param {number} value
             * @param {HTMLElement} div
             * @param {Array} path    | where to look for the actual option
             * @private
             */

        }, {
            key: "_showColorPicker",
            value: function _showColorPicker(value, div, path) {
                var _this8 = this;

                // clear the callback from this div
                div.onclick = function () {};

                this.colorPicker.insertTo(div);
                this.colorPicker.show();
                this.colorPicker.setColor(value);
                this.colorPicker.setUpdateCallback(function (color) {
                    var colorString = "rgba(" + color.r + "," + color.g + "," + color.b + "," + color.a + ")";
                    div.style.backgroundColor = colorString;

                    _this8._update(colorString, path);
                }); // on close of the colorpicker, restore the callback.

                this.colorPicker.setCloseCallback(function () {
                    div.onclick = function () {
                        _this8._showColorPicker(value, div, path);
                    };
                });
            }
            /**
             * parse an object and draw the correct items
             *
             * @param {object} obj
             * @param {Array} [path=[]]    | where to look for the actual option
             * @param {boolean} [checkOnly=false]
             * @returns {boolean}
             * @private
             */

        }, {
            key: "_handleObject",
            value: function _handleObject(obj) {
                var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var checkOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var show = false;

                var filter$1 = filter(this.options);

                var visibleInSet = false;

                for (var subObj in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, subObj)) {
                        show = true;
                        var item = obj[subObj];
                        var newPath = copyAndExtendArray(path, subObj);

                        if (typeof filter$1 === "function") {
                            show = filter$1(subObj, path); // if needed we must go deeper into the object.

                            if (show === false) {
                                if (!isArray(item) && typeof item !== "string" && typeof item !== "boolean" && item instanceof Object) {
                                    this.allowCreation = false;
                                    show = this._handleObject(item, newPath, true);
                                    this.allowCreation = checkOnly === false;
                                }
                            }
                        }

                        if (show !== false) {
                            visibleInSet = true;

                            var value = this._getValue(newPath);

                            if (isArray(item)) {
                                this._handleArray(item, value, newPath);
                            } else if (typeof item === "string") {
                                this._makeTextInput(item, value, newPath);
                            } else if (typeof item === "boolean") {
                                this._makeCheckbox(item, value, newPath);
                            } else if (item instanceof Object) {
                                // skip the options that are not enabled
                                if (!this.hideOption(path, subObj, this.moduleOptions)) {
                                    // initially collapse options with an disabled enabled option.
                                    if (item.enabled !== undefined) {
                                        var enabledPath = copyAndExtendArray(newPath, "enabled");

                                        var enabledValue = this._getValue(enabledPath);

                                        if (enabledValue === true) {
                                            var label = this._makeLabel(subObj, newPath, true);

                                            this._makeItem(newPath, label);

                                            visibleInSet = this._handleObject(item, newPath) || visibleInSet;
                                        } else {
                                            this._makeCheckbox(item, enabledValue, newPath);
                                        }
                                    } else {
                                        var _label = this._makeLabel(subObj, newPath, true);

                                        this._makeItem(newPath, _label);

                                        visibleInSet = this._handleObject(item, newPath) || visibleInSet;
                                    }
                                }
                            } else {
                                console.error("dont know how to handle", item, subObj, newPath);
                            }
                        }
                    }
                }

                return visibleInSet;
            }
            /**
             * handle the array type of option
             *
             * @param {Array.<number>} arr
             * @param {number} value
             * @param {Array} path    | where to look for the actual option
             * @private
             */

        }, {
            key: "_handleArray",
            value: function _handleArray(arr, value, path) {
                if (typeof arr[0] === "string" && arr[0] === "color") {
                    this._makeColorField(arr, value, path);

                    if (arr[1] !== value) {
                        this.changedOptions.push({
                            path: path,
                            value: value
                        });
                    }
                } else if (typeof arr[0] === "string") {
                    this._makeDropdown(arr, value, path);

                    if (arr[0] !== value) {
                        this.changedOptions.push({
                            path: path,
                            value: value
                        });
                    }
                } else if (typeof arr[0] === "number") {
                    this._makeRange(arr, value, path);

                    if (arr[0] !== value) {
                        this.changedOptions.push({
                            path: path,
                            value: Number(value)
                        });
                    }
                }
            }
            /**
             * called to update the network with the new settings.
             *
             * @param {number} value
             * @param {Array} path    | where to look for the actual option
             * @private
             */

        }, {
            key: "_update",
            value: function _update(value, path) {
                var options = this._constructOptions(value, path);

                if (this.parent.body && this.parent.body.emitter && this.parent.body.emitter.emit) {
                    this.parent.body.emitter.emit("configChange", options);
                }

                this.initialized = true;
                this.parent.setOptions(options);
            }
            /**
             *
             * @param {string | boolean} value
             * @param {Array.<string>} path
             * @param {{}} optionsObj
             * @returns {{}}
             * @private
             */

        }, {
            key: "_constructOptions",
            value: function _constructOptions(value, path) {
                var optionsObj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var pointer = optionsObj; // when dropdown boxes can be string or boolean, we typecast it into correct types

                value = value === "true" ? true : value;
                value = value === "false" ? false : value;

                for (var i = 0; i < path.length; i++) {
                    if (path[i] !== "global") {
                        if (pointer[path[i]] === undefined) {
                            pointer[path[i]] = {};
                        }

                        if (i !== path.length - 1) {
                            pointer = pointer[path[i]];
                        } else {
                            pointer[path[i]] = value;
                        }
                    }
                }

                return optionsObj;
            }
            /**
             * @private
             */

        }, {
            key: "_printOptions",
            value: function _printOptions() {
                var options = this.getOptions();

                while (this.optionsContainer.firstChild) {
                    this.optionsContainer.removeChild(this.optionsContainer.firstChild);
                }

                this.optionsContainer.appendChild(wrapInTag("pre", "const options = " + stringify$1(options, null, 2)));
            }
            /**
             *
             * @returns {{}} options
             */

        }, {
            key: "getOptions",
            value: function getOptions() {
                var options = {};

                for (var i = 0; i < this.changedOptions.length; i++) {
                    this._constructOptions(this.changedOptions[i].value, this.changedOptions[i].path, options);
                }

                return options;
            }
        }]);

        return Configurator;
    }();
    /**
     * Popup is a class to create a popup window with some text
     */


    var Popup = /*#__PURE__*/function () {
        /**
         * @param {Element} container       The container object.
         * @param {string}  overflowMethod  How the popup should act to overflowing ('flip' or 'cap')
         */
        function Popup(container, overflowMethod) {
            _classCallCheck(this, Popup);

            this.container = container;
            this.overflowMethod = overflowMethod || "cap";
            this.x = 0;
            this.y = 0;
            this.padding = 5;
            this.hidden = false; // create the frame

            this.frame = document.createElement("div");
            this.frame.className = "vis-tooltip";
            this.container.appendChild(this.frame);
        }
        /**
         * @param {number} x   Horizontal position of the popup window
         * @param {number} y   Vertical position of the popup window
         */


        _createClass(Popup, [{
            key: "setPosition",
            value: function setPosition(x, y) {
                this.x = _parseInt(x);
                this.y = _parseInt(y);
            }
            /**
             * Set the content for the popup window. This can be HTML code or text.
             *
             * @param {string | Element} content
             */

        }, {
            key: "setText",
            value: function setText(content) {
                if (content instanceof Element) {
                    while (this.frame.firstChild) {
                        this.frame.removeChild(this.frame.firstChild);
                    }

                    this.frame.appendChild(content);
                } else {
                    // String containing literal text, element has to be used for HTML due to
                    // XSS risks associated with innerHTML (i.e. prevent XSS by accident).
                    this.frame.innerText = content;
                }
            }
            /**
             * Show the popup window
             *
             * @param {boolean} [doShow]    Show or hide the window
             */

        }, {
            key: "show",
            value: function show(doShow) {
                if (doShow === undefined) {
                    doShow = true;
                }

                if (doShow === true) {
                    var height = this.frame.clientHeight;
                    var width = this.frame.clientWidth;
                    var maxHeight = this.frame.parentNode.clientHeight;
                    var maxWidth = this.frame.parentNode.clientWidth;
                    var left = 0,
                        top = 0;

                    if (this.overflowMethod == "flip") {
                        var isLeft = false,
                            isTop = true; // Where around the position it's located

                        if (this.y - height < this.padding) {
                            isTop = false;
                        }

                        if (this.x + width > maxWidth - this.padding) {
                            isLeft = true;
                        }

                        if (isLeft) {
                            left = this.x - width;
                        } else {
                            left = this.x;
                        }

                        if (isTop) {
                            top = this.y - height;
                        } else {
                            top = this.y;
                        }
                    } else {
                        top = this.y - height;

                        if (top + height + this.padding > maxHeight) {
                            top = maxHeight - height - this.padding;
                        }

                        if (top < this.padding) {
                            top = this.padding;
                        }

                        left = this.x;

                        if (left + width + this.padding > maxWidth) {
                            left = maxWidth - width - this.padding;
                        }

                        if (left < this.padding) {
                            left = this.padding;
                        }
                    }

                    this.frame.style.left = left + "px";
                    this.frame.style.top = top + "px";
                    this.frame.style.visibility = "visible";
                    this.hidden = false;
                } else {
                    this.hide();
                }
            }
            /**
             * Hide the popup window
             */

        }, {
            key: "hide",
            value: function hide() {
                this.hidden = true;
                this.frame.style.left = "0";
                this.frame.style.top = "0";
                this.frame.style.visibility = "hidden";
            }
            /**
             * Remove the popup window
             */

        }, {
            key: "destroy",
            value: function destroy() {
                this.frame.parentNode.removeChild(this.frame); // Remove element from DOM
            }
        }]);

        return Popup;
    }();

    var errorFound = false;
    var allOptions$1;
    var VALIDATOR_PRINT_STYLE = "background: #FFeeee; color: #dd0000";
    /**
     *  Used to validate options.
     */

    var Validator = /*#__PURE__*/function () {
        function Validator() {
            _classCallCheck(this, Validator);
        }

        _createClass(Validator, null, [{
            key: "validate",
            value:
                /**
                 * Main function to be called
                 *
                 * @param {object} options
                 * @param {object} referenceOptions
                 * @param {object} subObject
                 * @returns {boolean}
                 * @static
                 */
                function validate(options, referenceOptions, subObject) {
                    errorFound = false;
                    allOptions$1 = referenceOptions;
                    var usedOptions = referenceOptions;

                    if (subObject !== undefined) {
                        usedOptions = referenceOptions[subObject];
                    }

                    Validator.parse(options, usedOptions, []);
                    return errorFound;
                }
            /**
             * Will traverse an object recursively and check every value
             *
             * @param {object} options
             * @param {object} referenceOptions
             * @param {Array} path    | where to look for the actual option
             * @static
             */

        }, {
            key: "parse",
            value: function parse(options, referenceOptions, path) {
                for (var _option3 in options) {
                    if (Object.prototype.hasOwnProperty.call(options, _option3)) {
                        Validator.check(_option3, options, referenceOptions, path);
                    }
                }
            }
            /**
             * Check every value. If the value is an object, call the parse function on that object.
             *
             * @param {string} option
             * @param {object} options
             * @param {object} referenceOptions
             * @param {Array} path    | where to look for the actual option
             * @static
             */

        }, {
            key: "check",
            value: function check(option, options, referenceOptions, path) {
                if (referenceOptions[option] === undefined && referenceOptions.__any__ === undefined) {
                    Validator.getSuggestion(option, referenceOptions, path);
                    return;
                }

                var referenceOption = option;
                var is_object = true;

                if (referenceOptions[option] === undefined && referenceOptions.__any__ !== undefined) {
                    // NOTE: This only triggers if the __any__ is in the top level of the options object.
                    //       THAT'S A REALLY BAD PLACE TO ALLOW IT!!!!
                    // TODO: Examine if needed, remove if possible
                    // __any__ is a wildcard. Any value is accepted and will be further analysed by reference.
                    referenceOption = "__any__"; // if the any-subgroup is not a predefined object in the configurator,
                    // we do not look deeper into the object.

                    is_object = Validator.getType(options[option]) === "object";
                }

                var refOptionObj = referenceOptions[referenceOption];

                if (is_object && refOptionObj.__type__ !== undefined) {
                    refOptionObj = refOptionObj.__type__;
                }

                Validator.checkFields(option, options, referenceOptions, referenceOption, refOptionObj, path);
            }
            /**
             *
             * @param {string}  option           | the option property
             * @param {object}  options          | The supplied options object
             * @param {object}  referenceOptions | The reference options containing all options and their allowed formats
             * @param {string}  referenceOption  | Usually this is the same as option, except when handling an __any__ tag.
             * @param {string}  refOptionObj     | This is the type object from the reference options
             * @param {Array}   path             | where in the object is the option
             * @static
             */

        }, {
            key: "checkFields",
            value: function checkFields(option, options, referenceOptions, referenceOption, refOptionObj, path) {
                var log = function log(message) {
                    console.error("%c" + message + Validator.printLocation(path, option), VALIDATOR_PRINT_STYLE);
                };

                var optionType = Validator.getType(options[option]);
                var refOptionType = refOptionObj[optionType];

                if (refOptionType !== undefined) {
                    // if the type is correct, we check if it is supposed to be one of a few select values
                    if (Validator.getType(refOptionType) === "array" && indexOf(refOptionType).call(refOptionType, options[option]) === -1) {
                        log('Invalid option detected in "' + option + '".' + " Allowed values are:" + Validator.print(refOptionType) + ' not "' + options[option] + '". ');
                        errorFound = true;
                    } else if (optionType === "object" && referenceOption !== "__any__") {
                        path = copyAndExtendArray(path, option);
                        Validator.parse(options[option], referenceOptions[referenceOption], path);
                    }
                } else if (refOptionObj["any"] === undefined) {
                    // type of the field is incorrect and the field cannot be any
                    log('Invalid type received for "' + option + '". Expected: ' + Validator.print(keys$3(refOptionObj)) + ". Received [" + optionType + '] "' + options[option] + '"');
                    errorFound = true;
                }
            }
            /**
             *
             * @param {object | boolean | number | string | Array.<number> | Date | Node | Moment | undefined | null} object
             * @returns {string}
             * @static
             */

        }, {
            key: "getType",
            value: function getType(object) {
                var type = _typeof(object);

                if (type === "object") {
                    if (object === null) {
                        return "null";
                    }

                    if (object instanceof Boolean) {
                        return "boolean";
                    }

                    if (object instanceof Number) {
                        return "number";
                    }

                    if (object instanceof String) {
                        return "string";
                    }

                    if (isArray(object)) {
                        return "array";
                    }

                    if (object instanceof Date) {
                        return "date";
                    }

                    if (object.nodeType !== undefined) {
                        return "dom";
                    }

                    if (object._isAMomentObject === true) {
                        return "moment";
                    }

                    return "object";
                } else if (type === "number") {
                    return "number";
                } else if (type === "boolean") {
                    return "boolean";
                } else if (type === "string") {
                    return "string";
                } else if (type === undefined) {
                    return "undefined";
                }

                return type;
            }
            /**
             * @param {string} option
             * @param {object} options
             * @param {Array.<string>} path
             * @static
             */

        }, {
            key: "getSuggestion",
            value: function getSuggestion(option, options, path) {
                var localSearch = Validator.findInOptions(option, options, path, false);
                var globalSearch = Validator.findInOptions(option, allOptions$1, [], true);
                var localSearchThreshold = 8;
                var globalSearchThreshold = 4;
                var msg;

                if (localSearch.indexMatch !== undefined) {
                    msg = " in " + Validator.printLocation(localSearch.path, option, "") + 'Perhaps it was incomplete? Did you mean: "' + localSearch.indexMatch + '"?\n\n';
                } else if (globalSearch.distance <= globalSearchThreshold && localSearch.distance > globalSearch.distance) {
                    msg = " in " + Validator.printLocation(localSearch.path, option, "") + "Perhaps it was misplaced? Matching option found at: " + Validator.printLocation(globalSearch.path, globalSearch.closestMatch, "");
                } else if (localSearch.distance <= localSearchThreshold) {
                    msg = '. Did you mean "' + localSearch.closestMatch + '"?' + Validator.printLocation(localSearch.path, option);
                } else {
                    msg = ". Did you mean one of these: " + Validator.print(keys$3(options)) + Validator.printLocation(path, option);
                }

                console.error('%cUnknown option detected: "' + option + '"' + msg, VALIDATOR_PRINT_STYLE);
                errorFound = true;
            }
            /**
             * traverse the options in search for a match.
             *
             * @param {string} option
             * @param {object} options
             * @param {Array} path    | where to look for the actual option
             * @param {boolean} [recursive=false]
             * @returns {{closestMatch: string, path: Array, distance: number}}
             * @static
             */

        }, {
            key: "findInOptions",
            value: function findInOptions(option, options, path) {
                var recursive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                var min = 1e9;
                var closestMatch = "";
                var closestMatchPath = [];
                var lowerCaseOption = option.toLowerCase();
                var indexMatch = undefined;

                for (var op in options) {
                    var distance = void 0;

                    if (options[op].__type__ !== undefined && recursive === true) {
                        var result = Validator.findInOptions(option, options[op], copyAndExtendArray(path, op));

                        if (min > result.distance) {
                            closestMatch = result.closestMatch;
                            closestMatchPath = result.path;
                            min = result.distance;
                            indexMatch = result.indexMatch;
                        }
                    } else {
                        var _context20;

                        if (indexOf(_context20 = op.toLowerCase()).call(_context20, lowerCaseOption) !== -1) {
                            indexMatch = op;
                        }

                        distance = Validator.levenshteinDistance(option, op);

                        if (min > distance) {
                            closestMatch = op;
                            closestMatchPath = copyArray(path);
                            min = distance;
                        }
                    }
                }

                return {
                    closestMatch: closestMatch,
                    path: closestMatchPath,
                    distance: min,
                    indexMatch: indexMatch
                };
            }
            /**
             * @param {Array.<string>} path
             * @param {object} option
             * @param {string} prefix
             * @returns {string}
             * @static
             */

        }, {
            key: "printLocation",
            value: function printLocation(path, option) {
                var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Problem value found at: \n";
                var str = "\n\n" + prefix + "options = {\n";

                for (var i = 0; i < path.length; i++) {
                    for (var j = 0; j < i + 1; j++) {
                        str += "  ";
                    }

                    str += path[i] + ": {\n";
                }

                for (var _j = 0; _j < path.length + 1; _j++) {
                    str += "  ";
                }

                str += option + "\n";

                for (var _i3 = 0; _i3 < path.length + 1; _i3++) {
                    for (var _j2 = 0; _j2 < path.length - _i3; _j2++) {
                        str += "  ";
                    }

                    str += "}\n";
                }

                return str + "\n\n";
            }
            /**
             * @param {object} options
             * @returns {string}
             * @static
             */

        }, {
            key: "print",
            value: function print(options) {
                return stringify$1(options).replace(/(")|(\[)|(\])|(,"__type__")/g, "").replace(/(,)/g, ", ");
            }
            /**
             *  Compute the edit distance between the two given strings
             * http://en.wikibooks.org/wiki/Algorithm_Implementation/Strings/Levenshtein_distance#JavaScript
             *
             * Copyright (c) 2011 Andrei Mackenzie
             *
             * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
             *
             * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
             *
             * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
             *
             * @param {string} a
             * @param {string} b
             * @returns {Array.<Array.<number>>}}
             * @static
             */

        }, {
            key: "levenshteinDistance",
            value: function levenshteinDistance(a, b) {
                if (a.length === 0) return b.length;
                if (b.length === 0) return a.length;
                var matrix = []; // increment along the first column of each row

                var i;

                for (i = 0; i <= b.length; i++) {
                    matrix[i] = [i];
                } // increment each column in the first row


                var j;

                for (j = 0; j <= a.length; j++) {
                    matrix[0][j] = j;
                } // Fill in the rest of the matrix


                for (i = 1; i <= b.length; i++) {
                    for (j = 1; j <= a.length; j++) {
                        if (b.charAt(i - 1) == a.charAt(j - 1)) {
                            matrix[i][j] = matrix[i - 1][j - 1];
                        } else {
                            matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, // substitution
                                Math.min(matrix[i][j - 1] + 1, // insertion
                                    matrix[i - 1][j] + 1)); // deletion
                        }
                    }
                }

                return matrix[b.length][a.length];
            }
        }]);

        return Validator;
    }();

    var Activator$1 = Activator;
    var Configurator$1 = Configurator;
    var Hammer$1 = Hammer;
    var Popup$1 = Popup;
    var VALIDATOR_PRINT_STYLE$1 = VALIDATOR_PRINT_STYLE;
    var Validator$1 = Validator;

    /* eslint-disable no-prototype-builtins */

    /* eslint-disable no-unused-vars */

    /* eslint-disable no-var */

    /**
     * Parse a text source containing data in DOT language into a JSON object.
     * The object contains two lists: one with nodes and one with edges.
     *
     * DOT language reference: http://www.graphviz.org/doc/info/lang.html
     *
     * DOT language attributes: http://graphviz.org/content/attrs
     *
     * @param {string} data     Text containing a graph in DOT-notation
     * @returns {object} graph   An object containing two parameters:
     *                          {Object[]} nodes
     *                          {Object[]} edges
     *
     * -------------------------------------------
     * TODO
     * ====
     *
     * For label handling, this is an incomplete implementation. From docs (quote #3015):
     *
     * > the escape sequences "\n", "\l" and "\r" divide the label into lines, centered,
     * > left-justified, and right-justified, respectively.
     *
     * Source: http://www.graphviz.org/content/attrs#kescString
     *
     * > As another aid for readability, dot allows double-quoted strings to span multiple physical
     * > lines using the standard C convention of a backslash immediately preceding a newline
     * > character
     * > In addition, double-quoted strings can be concatenated using a '+' operator.
     * > As HTML strings can contain newline characters, which are used solely for formatting,
     * > the language does not allow escaped newlines or concatenation operators to be used
     * > within them.
     *
     * - Currently, only '\\n' is handled
     * - Note that text explicitly says 'labels'; the dot parser currently handles escape
     *   sequences in **all** strings.
     */
    function parseDOT(data) {
        dot = data;
        return parseGraph();
    } // mapping of attributes from DOT (the keys) to vis.js (the values)

    var NODE_ATTR_MAPPING = {
        fontsize: "font.size",
        fontcolor: "font.color",
        labelfontcolor: "font.color",
        fontname: "font.face",
        color: ["color.border", "color.background"],
        fillcolor: "color.background",
        tooltip: "title",
        labeltooltip: "title"
    };

    var EDGE_ATTR_MAPPING = create$2(NODE_ATTR_MAPPING);

    EDGE_ATTR_MAPPING.color = "color.color";
    EDGE_ATTR_MAPPING.style = "dashes"; // token types enumeration

    var TOKENTYPE = {
        NULL: 0,
        DELIMITER: 1,
        IDENTIFIER: 2,
        UNKNOWN: 3
    }; // map with all delimiters

    var DELIMITERS = {
        "{": true,
        "}": true,
        "[": true,
        "]": true,
        ";": true,
        "=": true,
        ",": true,
        "->": true,
        "--": true
    };
    var dot = ""; // current dot file

    var index$1 = 0; // current index in dot file

    var c = ""; // current token character in expr

    var token = ""; // current token

    var tokenType = TOKENTYPE.NULL; // type of the token

    /**
     * Get the first character from the dot file.
     * The character is stored into the char c. If the end of the dot file is
     * reached, the function puts an empty string in c.
     */

    function first() {
        index$1 = 0;
        c = dot.charAt(0);
    }
    /**
     * Get the next character from the dot file.
     * The character is stored into the char c. If the end of the dot file is
     * reached, the function puts an empty string in c.
     */


    function next() {
        index$1++;
        c = dot.charAt(index$1);
    }
    /**
     * Preview the next character from the dot file.
     *
     * @returns {string} cNext
     */


    function nextPreview() {
        return dot.charAt(index$1 + 1);
    }
    /**
     * Test whether given character is alphabetic or numeric ( a-zA-Z_0-9.:# )
     *
     * @param {string} c
     * @returns {boolean} isAlphaNumeric
     */


    function isAlphaNumeric(c) {
        var charCode = c.charCodeAt(0);

        if (charCode < 47) {
            // #.
            return charCode === 35 || charCode === 46;
        }

        if (charCode < 59) {
            // 0-9 and :
            return charCode > 47;
        }

        if (charCode < 91) {
            // A-Z
            return charCode > 64;
        }

        if (charCode < 96) {
            // _
            return charCode === 95;
        }

        if (charCode < 123) {
            // a-z
            return charCode > 96;
        }

        return false;
    }
    /**
     * Merge all options of object b into object b
     *
     * @param {object} a
     * @param {object} b
     * @returns {object} a
     */


    function merge(a, b) {
        if (!a) {
            a = {};
        }

        if (b) {
            for (var name in b) {
                if (b.hasOwnProperty(name)) {
                    a[name] = b[name];
                }
            }
        }

        return a;
    }
    /**
     * Set a value in an object, where the provided parameter name can be a
     * path with nested parameters. For example:
     *
     *     var obj = {a: 2};
     *     setValue(obj, 'b.c', 3);     // obj = {a: 2, b: {c: 3}}
     *
     * @param {object} obj
     * @param {string} path  A parameter name or dot-separated parameter path,
     *                      like "color.highlight.border".
     * @param {*} value
     */


    function setValue(obj, path, value) {
        var keys = path.split(".");
        var o = obj;

        while (keys.length) {
            var key = keys.shift();

            if (keys.length) {
                // this isn't the end point
                if (!o[key]) {
                    o[key] = {};
                }

                o = o[key];
            } else {
                // this is the end point
                o[key] = value;
            }
        }
    }
    /**
     * Add a node to a graph object. If there is already a node with
     * the same id, their attributes will be merged.
     *
     * @param {object} graph
     * @param {object} node
     */


    function addNode(graph, node) {
        var i, len;
        var current = null; // find root graph (in case of subgraph)

        var graphs = [graph]; // list with all graphs from current graph to root graph

        var root = graph;

        while (root.parent) {
            graphs.push(root.parent);
            root = root.parent;
        } // find existing node (at root level) by its id


        if (root.nodes) {
            for (i = 0, len = root.nodes.length; i < len; i++) {
                if (node.id === root.nodes[i].id) {
                    current = root.nodes[i];
                    break;
                }
            }
        }

        if (!current) {
            // this is a new node
            current = {
                id: node.id
            };

            if (graph.node) {
                // clone default attributes
                current.attr = merge(current.attr, graph.node);
            }
        } // add node to this (sub)graph and all its parent graphs


        for (i = graphs.length - 1; i >= 0; i--) {
            var _context;

            var g = graphs[i];

            if (!g.nodes) {
                g.nodes = [];
            }

            if (indexOf(_context = g.nodes).call(_context, current) === -1) {
                g.nodes.push(current);
            }
        } // merge attributes


        if (node.attr) {
            current.attr = merge(current.attr, node.attr);
        }
    }
    /**
     * Add an edge to a graph object
     *
     * @param {object} graph
     * @param {object} edge
     */


    function addEdge(graph, edge) {
        if (!graph.edges) {
            graph.edges = [];
        }

        graph.edges.push(edge);

        if (graph.edge) {
            var attr = merge({}, graph.edge); // clone default attributes

            edge.attr = merge(attr, edge.attr); // merge attributes
        }
    }
    /**
     * Create an edge to a graph object
     *
     * @param {object} graph
     * @param {string | number | object} from
     * @param {string | number | object} to
     * @param {string} type
     * @param {object | null} attr
     * @returns {object} edge
     */


    function createEdge(graph, from, to, type, attr) {
        var edge = {
            from: from,
            to: to,
            type: type
        };

        if (graph.edge) {
            edge.attr = merge({}, graph.edge); // clone default attributes
        }

        edge.attr = merge(edge.attr || {}, attr); // merge attributes
        // Move arrows attribute from attr to edge temporally created in
        // parseAttributeList().

        if (attr != null) {
            if (attr.hasOwnProperty("arrows") && attr["arrows"] != null) {
                edge["arrows"] = {
                    to: {
                        enabled: true,
                        type: attr.arrows.type
                    }
                };
                attr["arrows"] = null;
            }
        }

        return edge;
    }
    /**
     * Get next token in the current dot file.
     * The token and token type are available as token and tokenType
     */


    function getToken() {
        tokenType = TOKENTYPE.NULL;
        token = ""; // skip over whitespaces

        while (c === " " || c === "\t" || c === "\n" || c === "\r") {
            // space, tab, enter
            next();
        }

        do {
            var isComment = false; // skip comment

            if (c === "#") {
                // find the previous non-space character
                var i = index$1 - 1;

                while (dot.charAt(i) === " " || dot.charAt(i) === "\t") {
                    i--;
                }

                if (dot.charAt(i) === "\n" || dot.charAt(i) === "") {
                    // the # is at the start of a line, this is indeed a line comment
                    while (c != "" && c != "\n") {
                        next();
                    }

                    isComment = true;
                }
            }

            if (c === "/" && nextPreview() === "/") {
                // skip line comment
                while (c != "" && c != "\n") {
                    next();
                }

                isComment = true;
            }

            if (c === "/" && nextPreview() === "*") {
                // skip block comment
                while (c != "") {
                    if (c === "*" && nextPreview() === "/") {
                        // end of block comment found. skip these last two characters
                        next();
                        next();
                        break;
                    } else {
                        next();
                    }
                }

                isComment = true;
            } // skip over whitespaces


            while (c === " " || c === "\t" || c === "\n" || c === "\r") {
                // space, tab, enter
                next();
            }
        } while (isComment); // check for end of dot file


        if (c === "") {
            // token is still empty
            tokenType = TOKENTYPE.DELIMITER;
            return;
        } // check for delimiters consisting of 2 characters


        var c2 = c + nextPreview();

        if (DELIMITERS[c2]) {
            tokenType = TOKENTYPE.DELIMITER;
            token = c2;
            next();
            next();
            return;
        } // check for delimiters consisting of 1 character


        if (DELIMITERS[c]) {
            tokenType = TOKENTYPE.DELIMITER;
            token = c;
            next();
            return;
        } // check for an identifier (number or string)
        // TODO: more precise parsing of numbers/strings (and the port separator ':')


        if (isAlphaNumeric(c) || c === "-") {
            token += c;
            next();

            while (isAlphaNumeric(c)) {
                token += c;
                next();
            }

            if (token === "false") {
                token = false; // convert to boolean
            } else if (token === "true") {
                token = true; // convert to boolean
            } else if (!isNaN(Number(token))) {
                token = Number(token); // convert to number
            }

            tokenType = TOKENTYPE.IDENTIFIER;
            return;
        } // check for a string enclosed by double quotes


        if (c === '"') {
            next();

            while (c != "" && (c != '"' || c === '"' && nextPreview() === '"')) {
                if (c === '"') {
                    // skip the escape character
                    token += c;
                    next();
                } else if (c === "\\" && nextPreview() === "n") {
                    // Honor a newline escape sequence
                    token += "\n";
                    next();
                } else {
                    token += c;
                }

                next();
            }

            if (c != '"') {
                throw newSyntaxError('End of string " expected');
            }

            next();
            tokenType = TOKENTYPE.IDENTIFIER;
            return;
        } // something unknown is found, wrong characters, a syntax error


        tokenType = TOKENTYPE.UNKNOWN;

        while (c != "") {
            token += c;
            next();
        }

        throw new SyntaxError('Syntax error in part "' + chop(token, 30) + '"');
    }
    /**
     * Parse a graph.
     *
     * @returns {object} graph
     */


    function parseGraph() {
        var graph = {};
        first();
        getToken(); // optional strict keyword

        if (token === "strict") {
            graph.strict = true;
            getToken();
        } // graph or digraph keyword


        if (token === "graph" || token === "digraph") {
            graph.type = token;
            getToken();
        } // optional graph id


        if (tokenType === TOKENTYPE.IDENTIFIER) {
            graph.id = token;
            getToken();
        } // open angle bracket


        if (token != "{") {
            throw newSyntaxError("Angle bracket { expected");
        }

        getToken(); // statements

        parseStatements(graph); // close angle bracket

        if (token != "}") {
            throw newSyntaxError("Angle bracket } expected");
        }

        getToken(); // end of file

        if (token !== "") {
            throw newSyntaxError("End of file expected");
        }

        getToken(); // remove temporary default options

        delete graph.node;
        delete graph.edge;
        delete graph.graph;
        return graph;
    }
    /**
     * Parse a list with statements.
     *
     * @param {object} graph
     */


    function parseStatements(graph) {
        while (token !== "" && token != "}") {
            parseStatement(graph);

            if (token === ";") {
                getToken();
            }
        }
    }
    /**
     * Parse a single statement. Can be a an attribute statement, node
     * statement, a series of node statements and edge statements, or a
     * parameter.
     *
     * @param {object} graph
     */


    function parseStatement(graph) {
        // parse subgraph
        var subgraph = parseSubgraph(graph);

        if (subgraph) {
            // edge statements
            parseEdge(graph, subgraph);
            return;
        } // parse an attribute statement


        var attr = parseAttributeStatement(graph);

        if (attr) {
            return;
        } // parse node


        if (tokenType != TOKENTYPE.IDENTIFIER) {
            throw newSyntaxError("Identifier expected");
        }

        var id = token; // id can be a string or a number

        getToken();

        if (token === "=") {
            // id statement
            getToken();

            if (tokenType != TOKENTYPE.IDENTIFIER) {
                throw newSyntaxError("Identifier expected");
            }

            graph[id] = token;
            getToken(); // TODO: implement comma separated list with "a_list: ID=ID [','] [a_list] "
        } else {
            parseNodeStatement(graph, id);
        }
    }
    /**
     * Parse a subgraph
     *
     * @param {object} graph    parent graph object
     * @returns {object | null} subgraph
     */


    function parseSubgraph(graph) {
        var subgraph = null; // optional subgraph keyword

        if (token === "subgraph") {
            subgraph = {};
            subgraph.type = "subgraph";
            getToken(); // optional graph id

            if (tokenType === TOKENTYPE.IDENTIFIER) {
                subgraph.id = token;
                getToken();
            }
        } // open angle bracket


        if (token === "{") {
            getToken();

            if (!subgraph) {
                subgraph = {};
            }

            subgraph.parent = graph;
            subgraph.node = graph.node;
            subgraph.edge = graph.edge;
            subgraph.graph = graph.graph; // statements

            parseStatements(subgraph); // close angle bracket

            if (token != "}") {
                throw newSyntaxError("Angle bracket } expected");
            }

            getToken(); // remove temporary default options

            delete subgraph.node;
            delete subgraph.edge;
            delete subgraph.graph;
            delete subgraph.parent; // register at the parent graph

            if (!graph.subgraphs) {
                graph.subgraphs = [];
            }

            graph.subgraphs.push(subgraph);
        }

        return subgraph;
    }
    /**
     * parse an attribute statement like "node [shape=circle fontSize=16]".
     * Available keywords are 'node', 'edge', 'graph'.
     * The previous list with default attributes will be replaced
     *
     * @param {object} graph
     * @returns {string | null} keyword Returns the name of the parsed attribute
     *                                  (node, edge, graph), or null if nothing
     *                                  is parsed.
     */


    function parseAttributeStatement(graph) {
        // attribute statements
        if (token === "node") {
            getToken(); // node attributes

            graph.node = parseAttributeList();
            return "node";
        } else if (token === "edge") {
            getToken(); // edge attributes

            graph.edge = parseAttributeList();
            return "edge";
        } else if (token === "graph") {
            getToken(); // graph attributes

            graph.graph = parseAttributeList();
            return "graph";
        }

        return null;
    }
    /**
     * parse a node statement
     *
     * @param {object} graph
     * @param {string | number} id
     */


    function parseNodeStatement(graph, id) {
        // node statement
        var node = {
            id: id
        };
        var attr = parseAttributeList();

        if (attr) {
            node.attr = attr;
        }

        addNode(graph, node); // edge statements

        parseEdge(graph, id);
    }
    /**
     * Parse an edge or a series of edges
     *
     * @param {object} graph
     * @param {string | number} from        Id of the from node
     */


    function parseEdge(graph, from) {
        while (token === "->" || token === "--") {
            var to;
            var type = token;
            getToken();
            var subgraph = parseSubgraph(graph);

            if (subgraph) {
                to = subgraph;
            } else {
                if (tokenType != TOKENTYPE.IDENTIFIER) {
                    throw newSyntaxError("Identifier or subgraph expected");
                }

                to = token;
                addNode(graph, {
                    id: to
                });
                getToken();
            } // parse edge attributes


            var attr = parseAttributeList(); // create edge

            var edge = createEdge(graph, from, to, type, attr);
            addEdge(graph, edge);
            from = to;
        }
    }
    /**
     * Parse a set with attributes,
     * for example [label="1.000", shape=solid]
     *
     * @returns {object | null} attr
     */


    function parseAttributeList() {
        var i;
        var attr = null; // edge styles of dot and vis

        var edgeStyles = {
            dashed: true,
            solid: false,
            dotted: [1, 5]
        };
        /**
         * Define arrow types.
         * vis currently supports types defined in 'arrowTypes'.
         * Details of arrow shapes are described in
         * http://www.graphviz.org/content/arrow-shapes
         */

        var arrowTypes = {
            dot: "circle",
            box: "box",
            crow: "crow",
            curve: "curve",
            icurve: "inv_curve",
            normal: "triangle",
            inv: "inv_triangle",
            diamond: "diamond",
            tee: "bar",
            vee: "vee"
        };
        /**
         * 'attr_list' contains attributes for checking if some of them are affected
         * later. For instance, both of 'arrowhead' and 'dir' (edge style defined
         * in DOT) make changes to 'arrows' attribute in vis.
         */

        var attr_list = new Array();
        var attr_names = new Array(); // used for checking the case.
        // parse attributes

        while (token === "[") {
            getToken();
            attr = {};

            while (token !== "" && token != "]") {
                if (tokenType != TOKENTYPE.IDENTIFIER) {
                    throw newSyntaxError("Attribute name expected");
                }

                var name = token;
                getToken();

                if (token != "=") {
                    throw newSyntaxError("Equal sign = expected");
                }

                getToken();

                if (tokenType != TOKENTYPE.IDENTIFIER) {
                    throw newSyntaxError("Attribute value expected");
                }

                var value = token; // convert from dot style to vis

                if (name === "style") {
                    value = edgeStyles[value];
                }

                var arrowType;

                if (name === "arrowhead") {
                    arrowType = arrowTypes[value];
                    name = "arrows";
                    value = {
                        to: {
                            enabled: true,
                            type: arrowType
                        }
                    };
                }

                if (name === "arrowtail") {
                    arrowType = arrowTypes[value];
                    name = "arrows";
                    value = {
                        from: {
                            enabled: true,
                            type: arrowType
                        }
                    };
                }

                attr_list.push({
                    attr: attr,
                    name: name,
                    value: value
                });
                attr_names.push(name);
                getToken();

                if (token == ",") {
                    getToken();
                }
            }

            if (token != "]") {
                throw newSyntaxError("Bracket ] expected");
            }

            getToken();
        }
        /**
         * As explained in [1], graphviz has limitations for combination of
         * arrow[head|tail] and dir. If attribute list includes 'dir',
         * following cases just be supported.
         *   1. both or none + arrowhead, arrowtail
         *   2. forward + arrowhead (arrowtail is not affedted)
         *   3. back + arrowtail (arrowhead is not affected)
         * [1] https://www.graphviz.org/doc/info/attrs.html#h:undir_note
         */


        if (includes(attr_names).call(attr_names, "dir")) {
            var idx = {}; // get index of 'arrows' and 'dir'

            idx.arrows = {};

            for (i = 0; i < attr_list.length; i++) {
                if (attr_list[i].name === "arrows") {
                    if (attr_list[i].value.to != null) {
                        idx.arrows.to = i;
                    } else if (attr_list[i].value.from != null) {
                        idx.arrows.from = i;
                    } else {
                        throw newSyntaxError("Invalid value of arrows");
                    }
                } else if (attr_list[i].name === "dir") {
                    idx.dir = i;
                }
            } // first, add default arrow shape if it is not assigned to avoid error


            var dir_type = attr_list[idx.dir].value;

            if (!includes(attr_names).call(attr_names, "arrows")) {
                if (dir_type === "both") {
                    attr_list.push({
                        attr: attr_list[idx.dir].attr,
                        name: "arrows",
                        value: {
                            to: {
                                enabled: true
                            }
                        }
                    });
                    idx.arrows.to = attr_list.length - 1;
                    attr_list.push({
                        attr: attr_list[idx.dir].attr,
                        name: "arrows",
                        value: {
                            from: {
                                enabled: true
                            }
                        }
                    });
                    idx.arrows.from = attr_list.length - 1;
                } else if (dir_type === "forward") {
                    attr_list.push({
                        attr: attr_list[idx.dir].attr,
                        name: "arrows",
                        value: {
                            to: {
                                enabled: true
                            }
                        }
                    });
                    idx.arrows.to = attr_list.length - 1;
                } else if (dir_type === "back") {
                    attr_list.push({
                        attr: attr_list[idx.dir].attr,
                        name: "arrows",
                        value: {
                            from: {
                                enabled: true
                            }
                        }
                    });
                    idx.arrows.from = attr_list.length - 1;
                } else if (dir_type === "none") {
                    attr_list.push({
                        attr: attr_list[idx.dir].attr,
                        name: "arrows",
                        value: ""
                    });
                    idx.arrows.to = attr_list.length - 1;
                } else {
                    throw newSyntaxError('Invalid dir type "' + dir_type + '"');
                }
            }

            var from_type;
            var to_type; // update 'arrows' attribute from 'dir'.

            if (dir_type === "both") {
                // both of shapes of 'from' and 'to' are given
                if (idx.arrows.to && idx.arrows.from) {
                    to_type = attr_list[idx.arrows.to].value.to.type;
                    from_type = attr_list[idx.arrows.from].value.from.type;
                    attr_list[idx.arrows.to] = {
                        attr: attr_list[idx.arrows.to].attr,
                        name: attr_list[idx.arrows.to].name,
                        value: {
                            to: {
                                enabled: true,
                                type: to_type
                            },
                            from: {
                                enabled: true,
                                type: from_type
                            }
                        }
                    };

                    splice(attr_list).call(attr_list, idx.arrows.from, 1); // shape of 'to' is assigned and use default to 'from'

                } else if (idx.arrows.to) {
                    to_type = attr_list[idx.arrows.to].value.to.type;
                    from_type = "arrow";
                    attr_list[idx.arrows.to] = {
                        attr: attr_list[idx.arrows.to].attr,
                        name: attr_list[idx.arrows.to].name,
                        value: {
                            to: {
                                enabled: true,
                                type: to_type
                            },
                            from: {
                                enabled: true,
                                type: from_type
                            }
                        }
                    }; // only shape of 'from' is assigned and use default for 'to'
                } else if (idx.arrows.from) {
                    to_type = "arrow";
                    from_type = attr_list[idx.arrows.from].value.from.type;
                    attr_list[idx.arrows.from] = {
                        attr: attr_list[idx.arrows.from].attr,
                        name: attr_list[idx.arrows.from].name,
                        value: {
                            to: {
                                enabled: true,
                                type: to_type
                            },
                            from: {
                                enabled: true,
                                type: from_type
                            }
                        }
                    };
                }
            } else if (dir_type === "back") {
                // given both of shapes, but use only 'from'
                if (idx.arrows.to && idx.arrows.from) {
                    to_type = "";
                    from_type = attr_list[idx.arrows.from].value.from.type;
                    attr_list[idx.arrows.from] = {
                        attr: attr_list[idx.arrows.from].attr,
                        name: attr_list[idx.arrows.from].name,
                        value: {
                            to: {
                                enabled: true,
                                type: to_type
                            },
                            from: {
                                enabled: true,
                                type: from_type
                            }
                        }
                    }; // given shape of 'to', but does not use it
                } else if (idx.arrows.to) {
                    to_type = "";
                    from_type = "arrow";
                    idx.arrows.from = idx.arrows.to;
                    attr_list[idx.arrows.from] = {
                        attr: attr_list[idx.arrows.from].attr,
                        name: attr_list[idx.arrows.from].name,
                        value: {
                            to: {
                                enabled: true,
                                type: to_type
                            },
                            from: {
                                enabled: true,
                                type: from_type
                            }
                        }
                    }; // assign given 'from' shape
                } else if (idx.arrows.from) {
                    to_type = "";
                    from_type = attr_list[idx.arrows.from].value.from.type;
                    attr_list[idx.arrows.to] = {
                        attr: attr_list[idx.arrows.from].attr,
                        name: attr_list[idx.arrows.from].name,
                        value: {
                            to: {
                                enabled: true,
                                type: to_type
                            },
                            from: {
                                enabled: true,
                                type: from_type
                            }
                        }
                    };
                }

                attr_list[idx.arrows.from] = {
                    attr: attr_list[idx.arrows.from].attr,
                    name: attr_list[idx.arrows.from].name,
                    value: {
                        from: {
                            enabled: true,
                            type: attr_list[idx.arrows.from].value.from.type
                        }
                    }
                };
            } else if (dir_type === "none") {
                var idx_arrow;

                if (idx.arrows.to) {
                    idx_arrow = idx.arrows.to;
                } else {
                    idx_arrow = idx.arrows.from;
                }

                attr_list[idx_arrow] = {
                    attr: attr_list[idx_arrow].attr,
                    name: attr_list[idx_arrow].name,
                    value: ""
                };
            } else if (dir_type === "forward") {
                // given both of shapes, but use only 'to'
                if (idx.arrows.to && idx.arrows.from) {
                    to_type = attr_list[idx.arrows.to].value.to.type;
                    from_type = "";
                    attr_list[idx.arrows.to] = {
                        attr: attr_list[idx.arrows.to].attr,
                        name: attr_list[idx.arrows.to].name,
                        value: {
                            to: {
                                enabled: true,
                                type: to_type
                            },
                            from: {
                                enabled: true,
                                type: from_type
                            }
                        }
                    }; // assign given 'to' shape
                } else if (idx.arrows.to) {
                    to_type = attr_list[idx.arrows.to].value.to.type;
                    from_type = "";
                    attr_list[idx.arrows.to] = {
                        attr: attr_list[idx.arrows.to].attr,
                        name: attr_list[idx.arrows.to].name,
                        value: {
                            to: {
                                enabled: true,
                                type: to_type
                            },
                            from: {
                                enabled: true,
                                type: from_type
                            }
                        }
                    }; // given shape of 'from', but does not use it
                } else if (idx.arrows.from) {
                    to_type = "arrow";
                    from_type = "";
                    idx.arrows.to = idx.arrows.from;
                    attr_list[idx.arrows.to] = {
                        attr: attr_list[idx.arrows.to].attr,
                        name: attr_list[idx.arrows.to].name,
                        value: {
                            to: {
                                enabled: true,
                                type: to_type
                            },
                            from: {
                                enabled: true,
                                type: from_type
                            }
                        }
                    };
                }

                attr_list[idx.arrows.to] = {
                    attr: attr_list[idx.arrows.to].attr,
                    name: attr_list[idx.arrows.to].name,
                    value: {
                        to: {
                            enabled: true,
                            type: attr_list[idx.arrows.to].value.to.type
                        }
                    }
                };
            } else {
                throw newSyntaxError('Invalid dir type "' + dir_type + '"');
            } // remove 'dir' attribute no need anymore


            splice(attr_list).call(attr_list, idx.dir, 1);
        } // parse 'penwidth'


        var nof_attr_list;

        if (includes(attr_names).call(attr_names, "penwidth")) {
            var tmp_attr_list = [];
            nof_attr_list = attr_list.length;

            for (i = 0; i < nof_attr_list; i++) {
                // exclude 'width' from attr_list if 'penwidth' exists
                if (attr_list[i].name !== "width") {
                    if (attr_list[i].name === "penwidth") {
                        attr_list[i].name = "width";
                    }

                    tmp_attr_list.push(attr_list[i]);
                }
            }

            attr_list = tmp_attr_list;
        }

        nof_attr_list = attr_list.length;

        for (i = 0; i < nof_attr_list; i++) {
            setValue(attr_list[i].attr, attr_list[i].name, attr_list[i].value);
        }

        return attr;
    }
    /**
     * Create a syntax error with extra information on current token and index.
     *
     * @param {string} message
     * @returns {SyntaxError} err
     */


    function newSyntaxError(message) {
        return new SyntaxError(message + ', got "' + chop(token, 30) + '" (char ' + index$1 + ")");
    }
    /**
     * Chop off text after a maximum length
     *
     * @param {string} text
     * @param {number} maxLength
     * @returns {string}
     */


    function chop(text, maxLength) {
        return text.length <= maxLength ? text : text.substr(0, 27) + "...";
    }
    /**
     * Execute a function fn for each pair of elements in two arrays
     *
     * @param {Array | *} array1
     * @param {Array | *} array2
     * @param {Function} fn
     */


    function forEach2(array1, array2, fn) {
        if (isArray(array1)) {
            forEach$2(array1).call(array1, function (elem1) {
                if (isArray(array2)) {
                    forEach$2(array2).call(array2, function (elem2) {
                        fn(elem1, elem2);
                    });
                } else {
                    fn(elem1, array2);
                }
            });
        } else {
            if (isArray(array2)) {
                forEach$2(array2).call(array2, function (elem2) {
                    fn(array1, elem2);
                });
            } else {
                fn(array1, array2);
            }
        }
    }
    /**
     * Set a nested property on an object
     * When nested objects are missing, they will be created.
     * For example setProp({}, 'font.color', 'red') will return {font: {color: 'red'}}
     *
     * @param {object} object
     * @param {string} path   A dot separated string like 'font.color'
     * @param {*} value       Value for the property
     * @returns {object} Returns the original object, allows for chaining.
     */


    function setProp(object, path, value) {
        var names = path.split(".");
        var prop = names.pop(); // traverse over the nested objects

        var obj = object;

        for (var i = 0; i < names.length; i++) {
            var name = names[i];

            if (!(name in obj)) {
                obj[name] = {};
            }

            obj = obj[name];
        } // set the property value


        obj[prop] = value;
        return object;
    }
    /**
     * Convert an object with DOT attributes to their vis.js equivalents.
     *
     * @param {object} attr     Object with DOT attributes
     * @param {object} mapping
     * @returns {object}         Returns an object with vis.js attributes
     */


    function convertAttr(attr, mapping) {
        var converted = {};

        for (var prop in attr) {
            if (attr.hasOwnProperty(prop)) {
                var visProp = mapping[prop];

                if (isArray(visProp)) {
                    forEach$2(visProp).call(visProp, function (visPropI) {
                        setProp(converted, visPropI, attr[prop]);
                    });
                } else if (typeof visProp === "string") {
                    setProp(converted, visProp, attr[prop]);
                } else {
                    setProp(converted, prop, attr[prop]);
                }
            }
        }

        return converted;
    }
    /**
     * Convert a string containing a graph in DOT language into a map containing
     * with nodes and edges in the format of graph.
     *
     * @param {string} data         Text containing a graph in DOT-notation
     * @returns {object} graphData
     */


    function DOTToGraph(data) {
        // parse the DOT file
        var dotData = parseDOT(data);
        var graphData = {
            nodes: [],
            edges: [],
            options: {}
        }; // copy the nodes

        if (dotData.nodes) {
            var _context2;

            forEach$2(_context2 = dotData.nodes).call(_context2, function (dotNode) {
                var graphNode = {
                    id: dotNode.id,
                    label: String(dotNode.label || dotNode.id)
                };
                merge(graphNode, convertAttr(dotNode.attr, NODE_ATTR_MAPPING));

                if (graphNode.image) {
                    graphNode.shape = "image";
                }

                graphData.nodes.push(graphNode);
            });
        } // copy the edges


        if (dotData.edges) {
            var _context3;

            /**
             * Convert an edge in DOT format to an edge with VisGraph format
             *
             * @param {object} dotEdge
             * @returns {object} graphEdge
             */
            var convertEdge = function convertEdge(dotEdge) {
                var graphEdge = {
                    from: dotEdge.from,
                    to: dotEdge.to
                };
                merge(graphEdge, convertAttr(dotEdge.attr, EDGE_ATTR_MAPPING)); // Add arrows attribute to default styled arrow.
                // The reason why default style is not added in parseAttributeList() is
                // because only default is cleared before here.

                if (graphEdge.arrows == null && dotEdge.type === "->") {
                    graphEdge.arrows = "to";
                }

                return graphEdge;
            };

            forEach$2(_context3 = dotData.edges).call(_context3, function (dotEdge) {
                var from, to;

                if (dotEdge.from instanceof Object) {
                    from = dotEdge.from.nodes;
                } else {
                    from = {
                        id: dotEdge.from
                    };
                }

                if (dotEdge.to instanceof Object) {
                    to = dotEdge.to.nodes;
                } else {
                    to = {
                        id: dotEdge.to
                    };
                }

                if (dotEdge.from instanceof Object && dotEdge.from.edges) {
                    var _context4;

                    forEach$2(_context4 = dotEdge.from.edges).call(_context4, function (subEdge) {
                        var graphEdge = convertEdge(subEdge);
                        graphData.edges.push(graphEdge);
                    });
                }

                forEach2(from, to, function (from, to) {
                    var subEdge = createEdge(graphData, from.id, to.id, dotEdge.type, dotEdge.attr);
                    var graphEdge = convertEdge(subEdge);
                    graphData.edges.push(graphEdge);
                });

                if (dotEdge.to instanceof Object && dotEdge.to.edges) {
                    var _context5;

                    forEach$2(_context5 = dotEdge.to.edges).call(_context5, function (subEdge) {
                        var graphEdge = convertEdge(subEdge);
                        graphData.edges.push(graphEdge);
                    });
                }
            });
        } // copy the options


        if (dotData.attr) {
            graphData.options = dotData.attr;
        }

        return graphData;
    }
    /* eslint-enable no-var */

    /* eslint-enable no-unused-vars */

    /* eslint-enable no-prototype-builtins */

    var dotparser = /*#__PURE__*/Object.freeze({
        __proto__: null,
        parseDOT: parseDOT,
        DOTToGraph: DOTToGraph
    });

    /**
     * Convert Gephi to Vis.
     *
     * @param gephiJSON - The parsed JSON data in Gephi format.
     * @param optionsObj - Additional options.
     *
     * @returns The converted data ready to be used in Vis.
     */
    function parseGephi(gephiJSON, optionsObj) {
        var _context;

        var options = {
            edges: {
                inheritColor: false
            },
            nodes: {
                fixed: false,
                parseColor: false
            }
        };

        if (optionsObj != null) {
            if (optionsObj.fixed != null) {
                options.nodes.fixed = optionsObj.fixed;
            }

            if (optionsObj.parseColor != null) {
                options.nodes.parseColor = optionsObj.parseColor;
            }

            if (optionsObj.inheritColor != null) {
                options.edges.inheritColor = optionsObj.inheritColor;
            }
        }

        var gEdges = gephiJSON.edges;

        var vEdges = map$3(gEdges).call(gEdges, function (gEdge) {
            var vEdge = {
                from: gEdge.source,
                id: gEdge.id,
                to: gEdge.target
            };

            if (gEdge.attributes != null) {
                vEdge.attributes = gEdge.attributes;
            }

            if (gEdge.label != null) {
                vEdge.label = gEdge.label;
            }

            if (gEdge.attributes != null && gEdge.attributes.title != null) {
                vEdge.title = gEdge.attributes.title;
            }

            if (gEdge.type === "Directed") {
                vEdge.arrows = "to";
            } // edge['value'] = gEdge.attributes != null ? gEdge.attributes.Weight : undefined;
            // edge['width'] = edge['value'] != null ? undefined : edgegEdge.size;


            if (gEdge.color && options.edges.inheritColor === false) {
                vEdge.color = gEdge.color;
            }

            return vEdge;
        });

        var vNodes = map$3(_context = gephiJSON.nodes).call(_context, function (gNode) {
            var vNode = {
                id: gNode.id,
                fixed: options.nodes.fixed && gNode.x != null && gNode.y != null
            };

            if (gNode.attributes != null) {
                vNode.attributes = gNode.attributes;
            }

            if (gNode.label != null) {
                vNode.label = gNode.label;
            }

            if (gNode.size != null) {
                vNode.size = gNode.size;
            }

            if (gNode.attributes != null && gNode.attributes.title != null) {
                vNode.title = gNode.attributes.title;
            }

            if (gNode.title != null) {
                vNode.title = gNode.title;
            }

            if (gNode.x != null) {
                vNode.x = gNode.x;
            }

            if (gNode.y != null) {
                vNode.y = gNode.y;
            }

            if (gNode.color != null) {
                if (options.nodes.parseColor === true) {
                    vNode.color = gNode.color;
                } else {
                    vNode.color = {
                        background: gNode.color,
                        border: gNode.color,
                        highlight: {
                            background: gNode.color,
                            border: gNode.color
                        },
                        hover: {
                            background: gNode.color,
                            border: gNode.color
                        }
                    };
                }
            }

            return vNode;
        });

        return {
            nodes: vNodes,
            edges: vEdges
        };
    }

    var gephiParser = /*#__PURE__*/Object.freeze({
        __proto__: null,
        parseGephi: parseGephi
    });

    // English
    var en = {
        addDescription: "Click in an empty space to place a new node.",
        addEdge: "Add Edge",
        addNode: "Add Node",
        back: "Back",
        close: "Close",
        createEdgeError: "Cannot link edges to a cluster.",
        del: "Delete selected",
        deleteClusterError: "Clusters cannot be deleted.",
        edgeDescription: "Click on a node and drag the edge to another node to connect them.",
        edit: "Edit",
        editClusterError: "Clusters cannot be edited.",
        editEdge: "Edit Edge",
        editEdgeDescription: "Click on the control points and drag them to a node to connect to it.",
        editNode: "Edit Node"
    }; // German

    var de = {
        addDescription: "Klicke auf eine freie Stelle, um einen neuen Knoten zu plazieren.",
        addEdge: "Kante hinzuf\xFCgen",
        addNode: "Knoten hinzuf\xFCgen",
        back: "Zur\xFCck",
        close: "Schließen",
        createEdgeError: "Es ist nicht m\xF6glich, Kanten mit Clustern zu verbinden.",
        del: "L\xF6sche Auswahl",
        deleteClusterError: "Cluster k\xF6nnen nicht gel\xF6scht werden.",
        edgeDescription: "Klicke auf einen Knoten und ziehe die Kante zu einem anderen Knoten, um diese zu verbinden.",
        edit: "Editieren",
        editClusterError: "Cluster k\xF6nnen nicht editiert werden.",
        editEdge: "Kante editieren",
        editEdgeDescription: "Klicke auf die Verbindungspunkte und ziehe diese auf einen Knoten, um sie zu verbinden.",
        editNode: "Knoten editieren"
    }; // Spanish

    var es = {
        addDescription: "Haga clic en un lugar vac\xEDo para colocar un nuevo nodo.",
        addEdge: "A\xF1adir arista",
        addNode: "A\xF1adir nodo",
        back: "Atr\xE1s",
        close: "Cerrar",
        createEdgeError: "No se puede conectar una arista a un grupo.",
        del: "Eliminar selecci\xF3n",
        deleteClusterError: "No es posible eliminar grupos.",
        edgeDescription: "Haga clic en un nodo y arrastre la arista hacia otro nodo para conectarlos.",
        edit: "Editar",
        editClusterError: "No es posible editar grupos.",
        editEdge: "Editar arista",
        editEdgeDescription: "Haga clic en un punto de control y arrastrelo a un nodo para conectarlo.",
        editNode: "Editar nodo"
    }; //Italiano

    var it = {
        addDescription: "Clicca per aggiungere un nuovo nodo",
        addEdge: "Aggiungi un vertice",
        addNode: "Aggiungi un nodo",
        back: "Indietro",
        close: "Chiudere",
        createEdgeError: "Non si possono collegare vertici ad un cluster",
        del: "Cancella la selezione",
        deleteClusterError: "I cluster non possono essere cancellati",
        edgeDescription: "Clicca su un nodo e trascinalo ad un altro nodo per connetterli.",
        edit: "Modifica",
        editClusterError: "I clusters non possono essere modificati.",
        editEdge: "Modifica il vertice",
        editEdgeDescription: "Clicca sui Punti di controllo e trascinali ad un nodo per connetterli.",
        editNode: "Modifica il nodo"
    }; // Dutch

    var nl = {
        addDescription: "Klik op een leeg gebied om een nieuwe node te maken.",
        addEdge: "Link toevoegen",
        addNode: "Node toevoegen",
        back: "Terug",
        close: "Sluiten",
        createEdgeError: "Kan geen link maken naar een cluster.",
        del: "Selectie verwijderen",
        deleteClusterError: "Clusters kunnen niet worden verwijderd.",
        edgeDescription: "Klik op een node en sleep de link naar een andere node om ze te verbinden.",
        edit: "Wijzigen",
        editClusterError: "Clusters kunnen niet worden aangepast.",
        editEdge: "Link wijzigen",
        editEdgeDescription: "Klik op de verbindingspunten en sleep ze naar een node om daarmee te verbinden.",
        editNode: "Node wijzigen"
    }; // Portuguese Brazil

    var pt = {
        addDescription: "Clique em um espaço em branco para adicionar um novo nó",
        addEdge: "Adicionar aresta",
        addNode: "Adicionar nó",
        back: "Voltar",
        close: "Fechar",
        createEdgeError: "Não foi possível linkar arestas a um cluster.",
        del: "Remover selecionado",
        deleteClusterError: "Clusters não puderam ser removidos.",
        edgeDescription: "Clique em um nó e arraste a aresta até outro nó para conectá-los",
        edit: "Editar",
        editClusterError: "Clusters não puderam ser editados.",
        editEdge: "Editar aresta",
        editEdgeDescription: "Clique nos pontos de controle e os arraste para um nó para conectá-los",
        editNode: "Editar nó"
    }; // Russian

    var ru = {
        addDescription: "Кликните в свободное место, чтобы добавить новый узел.",
        addEdge: "Добавить ребро",
        addNode: "Добавить узел",
        back: "Назад",
        close: "Закрывать",
        createEdgeError: "Невозможно соединить ребра в кластер.",
        del: "Удалить выбранное",
        deleteClusterError: "Кластеры не могут быть удалены",
        edgeDescription: "Кликните на узел и протяните ребро к другому узлу, чтобы соединить их.",
        edit: "Редактировать",
        editClusterError: "Кластеры недоступны для редактирования.",
        editEdge: "Редактировать ребро",
        editEdgeDescription: "Кликните на контрольные точки и перетащите их в узел, чтобы подключиться к нему.",
        editNode: "Редактировать узел"
    }; // Chinese

    var cn = {
        addDescription: "单击空白处放置新节点。",
        addEdge: "添加连接线",
        addNode: "添加节点",
        back: "返回",
        close: "關閉",
        createEdgeError: "无法将连接线连接到群集。",
        del: "删除选定",
        deleteClusterError: "无法删除群集。",
        edgeDescription: "单击某个节点并将该连接线拖动到另一个节点以连接它们。",
        edit: "编辑",
        editClusterError: "无法编辑群集。",
        editEdge: "编辑连接线",
        editEdgeDescription: "单击控制节点并将它们拖到节点上连接。",
        editNode: "编辑节点"
    }; // Ukrainian

    var uk = {
        addDescription: "Kлікніть на вільне місце, щоб додати новий вузол.",
        addEdge: "Додати край",
        addNode: "Додати вузол",
        back: "Назад",
        close: "Закрити",
        createEdgeError: "Не можливо об'єднати краї в групу.",
        del: "Видалити обране",
        deleteClusterError: "Групи не можуть бути видалені.",
        edgeDescription: "Клікніть на вузол і перетягніть край до іншого вузла, щоб їх з'єднати.",
        edit: "Редагувати",
        editClusterError: "Групи недоступні для редагування.",
        editEdge: "Редагувати край",
        editEdgeDescription: "Клікніть на контрольні точки і перетягніть їх у вузол, щоб підключитися до нього.",
        editNode: "Редагувати вузол"
    }; // French

    var fr = {
        addDescription: "Cliquez dans un endroit vide pour placer un nœud.",
        addEdge: "Ajouter un lien",
        addNode: "Ajouter un nœud",
        back: "Retour",
        close: "Fermer",
        createEdgeError: "Impossible de créer un lien vers un cluster.",
        del: "Effacer la sélection",
        deleteClusterError: "Les clusters ne peuvent pas être effacés.",
        edgeDescription: "Cliquez sur un nœud et glissez le lien vers un autre nœud pour les connecter.",
        edit: "Éditer",
        editClusterError: "Les clusters ne peuvent pas être édités.",
        editEdge: "Éditer le lien",
        editEdgeDescription: "Cliquez sur les points de contrôle et glissez-les pour connecter un nœud.",
        editNode: "Éditer le nœud"
    }; // Czech

    var cs = {
        addDescription: "Kluknutím do prázdného prostoru můžete přidat nový vrchol.",
        addEdge: "Přidat hranu",
        addNode: "Přidat vrchol",
        back: "Zpět",
        close: "Zavřít",
        createEdgeError: "Nelze připojit hranu ke shluku.",
        del: "Smazat výběr",
        deleteClusterError: "Nelze mazat shluky.",
        edgeDescription: "Přetažením z jednoho vrcholu do druhého můžete spojit tyto vrcholy novou hranou.",
        edit: "Upravit",
        editClusterError: "Nelze upravovat shluky.",
        editEdge: "Upravit hranu",
        editEdgeDescription: "Přetažením kontrolního vrcholu hrany ji můžete připojit k jinému vrcholu.",
        editNode: "Upravit vrchol"
    };

    var locales = /*#__PURE__*/Object.freeze({
        __proto__: null,
        en: en,
        de: de,
        es: es,
        it: it,
        nl: nl,
        pt: pt,
        ru: ru,
        cn: cn,
        uk: uk,
        fr: fr,
        cs: cs
    });

    /**
     * Normalizes language code into the format used internally.
     *
     * @param locales - All the available locales.
     * @param rawCode - The original code as supplied by the user.
     *
     * @returns Language code in the format language-COUNTRY or language, eventually
     * fallbacks to en.
     */
    function normalizeLanguageCode(locales, rawCode) {
        try {
            var _rawCode$split = rawCode.split(/[-_ /]/, 2),
                _rawCode$split2 = _slicedToArray(_rawCode$split, 2),
                rawLanguage = _rawCode$split2[0],
                rawCountry = _rawCode$split2[1];

            var language = rawLanguage != null ? rawLanguage.toLowerCase() : null;
            var country = rawCountry != null ? rawCountry.toUpperCase() : null;

            if (language && country) {
                var code = language + "-" + country;

                if (Object.prototype.hasOwnProperty.call(locales, code)) {
                    return code;
                } else {
                    var _context;

                    console.warn(concat(_context = "Unknown variant ".concat(country, " of language ")).call(_context, language, "."));
                }
            }

            if (language) {
                var _code = language;

                if (Object.prototype.hasOwnProperty.call(locales, _code)) {
                    return _code;
                } else {
                    console.warn("Unknown language ".concat(language));
                }
            }

            console.warn("Unknown locale ".concat(rawCode, ", falling back to English."));
            return "en";
        } catch (error) {
            console.error(error);
            console.warn("Unexpected error while normalizing locale ".concat(rawCode, ", falling back to English."));
            return "en";
        }
    }

    /**
     * Associates a canvas to a given image, containing a number of renderings
     * of the image at various sizes.
     *
     * This technique is known as 'mipmapping'.
     *
     * NOTE: Images can also be of type 'data:svg+xml`. This code also works
     *       for svg, but the mipmapping may not be necessary.
     *
     * @param {Image} image
     */
    var CachedImage = /*#__PURE__*/function () {
        /**
         * @ignore
         */
        function CachedImage() {
            _classCallCheck(this, CachedImage);

            this.NUM_ITERATIONS = 4; // Number of items in the coordinates array

            this.image = new Image();
            this.canvas = document.createElement("canvas");
        }
        /**
         * Called when the image has been successfully loaded.
         */


        _createClass(CachedImage, [{
            key: "init",
            value: function init() {
                if (this.initialized()) return;
                this.src = this.image.src; // For same interface with Image

                var w = this.image.width;
                var h = this.image.height; // Ease external access

                this.width = w;
                this.height = h;
                var h2 = Math.floor(h / 2);
                var h4 = Math.floor(h / 4);
                var h8 = Math.floor(h / 8);
                var h16 = Math.floor(h / 16);
                var w2 = Math.floor(w / 2);
                var w4 = Math.floor(w / 4);
                var w8 = Math.floor(w / 8);
                var w16 = Math.floor(w / 16); // Make canvas as small as possible

                this.canvas.width = 3 * w4;
                this.canvas.height = h2; // Coordinates and sizes of images contained in the canvas
                // Values per row:  [top x, left y, width, height]

                this.coordinates = [[0, 0, w2, h2], [w2, 0, w4, h4], [w2, h4, w8, h8], [5 * w8, h4, w16, h16]];

                this._fillMipMap();
            }
            /**
             * @returns {boolean} true if init() has been called, false otherwise.
             */

        }, {
            key: "initialized",
            value: function initialized() {
                return this.coordinates !== undefined;
            }
            /**
             * Redraw main image in various sizes to the context.
             *
             * The rationale behind this is to reduce artefacts due to interpolation
             * at differing zoom levels.
             *
             * Source: http://stackoverflow.com/q/18761404/1223531
             *
             * This methods takes the resizing out of the drawing loop, in order to
             * reduce performance overhead.
             *
             * TODO: The code assumes that a 2D context can always be gotten. This is
             *       not necessarily true! OTOH, if not true then usage of this class
             *       is senseless.
             *
             * @private
             */

        }, {
            key: "_fillMipMap",
            value: function _fillMipMap() {
                var ctx = this.canvas.getContext("2d"); // First zoom-level comes from the image

                var to = this.coordinates[0];
                ctx.drawImage(this.image, to[0], to[1], to[2], to[3]); // The rest are copy actions internal to the canvas/context

                for (var iterations = 1; iterations < this.NUM_ITERATIONS; iterations++) {
                    var from = this.coordinates[iterations - 1];
                    var _to = this.coordinates[iterations];
                    ctx.drawImage(this.canvas, from[0], from[1], from[2], from[3], _to[0], _to[1], _to[2], _to[3]);
                }
            }
            /**
             * Draw the image, using the mipmap if necessary.
             *
             * MipMap is only used if param factor > 2; otherwise, original bitmap
             * is resized. This is also used to skip mipmap usage, e.g. by setting factor = 1
             *
             * Credits to 'Alex de Mulder' for original implementation.
             *
             * @param {CanvasRenderingContext2D} ctx  context on which to draw zoomed image
             * @param {Float} factor scale factor at which to draw
             * @param {number} left
             * @param {number} top
             * @param {number} width
             * @param {number} height
             */

        }, {
            key: "drawImageAtPosition",
            value: function drawImageAtPosition(ctx, factor, left, top, width, height) {
                if (!this.initialized()) return; //can't draw image yet not intialized

                if (factor > 2) {
                    // Determine which zoomed image to use
                    factor *= 0.5;
                    var iterations = 0;

                    while (factor > 2 && iterations < this.NUM_ITERATIONS) {
                        factor *= 0.5;
                        iterations += 1;
                    }

                    if (iterations >= this.NUM_ITERATIONS) {
                        iterations = this.NUM_ITERATIONS - 1;
                    } //console.log("iterations: " + iterations);


                    var from = this.coordinates[iterations];
                    ctx.drawImage(this.canvas, from[0], from[1], from[2], from[3], left, top, width, height);
                } else {
                    // Draw image directly
                    ctx.drawImage(this.image, left, top, width, height);
                }
            }
        }]);

        return CachedImage;
    }();

    /**
     * This callback is a callback that accepts an Image.
     *
     * @callback ImageCallback
     * @param {Image} image
     */

    /**
     * This class loads images and keeps them stored.
     *
     * @param {ImageCallback} callback
     */

    var Images = /*#__PURE__*/function () {
        /**
         * @param {ImageCallback} callback
         */
        function Images(callback) {
            _classCallCheck(this, Images);

            this.images = {};
            this.imageBroken = {};
            this.callback = callback;
        }
        /**
         * @param {string} url                      The original Url that failed to load, if the broken image is successfully loaded it will be added to the cache using this Url as the key so that subsequent requests for this Url will return the broken image
         * @param {string} brokenUrl                Url the broken image to try and load
         * @param {Image} imageToLoadBrokenUrlOn   The image object
         */


        _createClass(Images, [{
            key: "_tryloadBrokenUrl",
            value: function _tryloadBrokenUrl(url, brokenUrl, imageToLoadBrokenUrlOn) {
                //If these parameters aren't specified then exit the function because nothing constructive can be done
                if (url === undefined || imageToLoadBrokenUrlOn === undefined) return;

                if (brokenUrl === undefined) {
                    console.warn("No broken url image defined");
                    return;
                } //Clear the old subscription to the error event and put a new in place that only handle errors in loading the brokenImageUrl


                imageToLoadBrokenUrlOn.image.onerror = function () {
                    console.error("Could not load brokenImage:", brokenUrl); // cache item will contain empty image, this should be OK for default
                }; //Set the source of the image to the brokenUrl, this is actually what kicks off the loading of the broken image


                imageToLoadBrokenUrlOn.image.src = brokenUrl;
            }
            /**
             *
             * @param {vis.Image} imageToRedrawWith
             * @private
             */

        }, {
            key: "_redrawWithImage",
            value: function _redrawWithImage(imageToRedrawWith) {
                if (this.callback) {
                    this.callback(imageToRedrawWith);
                }
            }
            /**
             * @param {string} url          Url of the image
             * @param {string} brokenUrl    Url of an image to use if the url image is not found
             * @returns {Image} img          The image object
             */

        }, {
            key: "load",
            value: function load(url, brokenUrl) {
                var _this = this;

                //Try and get the image from the cache, if successful then return the cached image
                var cachedImage = this.images[url];
                if (cachedImage) return cachedImage; //Create a new image

                var img = new CachedImage(); // Need to add to cache here, otherwise final return will spawn different copies of the same image,
                // Also, there will be multiple loads of the same image.

                this.images[url] = img; //Subscribe to the event that is raised if the image loads successfully

                img.image.onload = function () {
                    // Properly init the cached item and then request a redraw
                    _this._fixImageCoordinates(img.image);

                    img.init();

                    _this._redrawWithImage(img);
                }; //Subscribe to the event that is raised if the image fails to load


                img.image.onerror = function () {
                    console.error("Could not load image:", url); //Try and load the image specified by the brokenUrl using

                    _this._tryloadBrokenUrl(url, brokenUrl, img);
                }; //Set the source of the image to the url, this is what actually kicks off the loading of the image


                img.image.src = url; //Return the new image

                return img;
            }
            /**
             * IE11 fix -- thanks dponch!
             *
             * Local helper function
             *
             * @param {vis.Image} imageToCache
             * @private
             */

        }, {
            key: "_fixImageCoordinates",
            value: function _fixImageCoordinates(imageToCache) {
                if (imageToCache.width === 0) {
                    document.body.appendChild(imageToCache);
                    imageToCache.width = imageToCache.offsetWidth;
                    imageToCache.height = imageToCache.offsetHeight;
                    document.body.removeChild(imageToCache);
                }
            }
        }]);

        return Images;
    }();

    var freezing = !fails(function () {
        return Object.isExtensible(Object.preventExtensions({}));
    });

    var internalMetadata = createCommonjsModule(function (module) {
        var defineProperty = objectDefineProperty.f;
        var METADATA = uid('meta');
        var id = 0;

        var isExtensible = Object.isExtensible || function () {
            return true;
        };

        var setMetadata = function (it) {
            defineProperty(it, METADATA, {
                value: {
                    objectID: 'O' + ++id,
                    // object ID
                    weakData: {} // weak collections IDs

                }
            });
        };

        var fastKey = function (it, create) {
            // return a primitive with prefix
            if (!isObject$1(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

            if (!has$1(it, METADATA)) {
                // can't set metadata to uncaught frozen object
                if (!isExtensible(it)) return 'F'; // not necessary to add metadata

                if (!create) return 'E'; // add missing metadata

                setMetadata(it); // return object ID
            }

            return it[METADATA].objectID;
        };

        var getWeakData = function (it, create) {
            if (!has$1(it, METADATA)) {
                // can't set metadata to uncaught frozen object
                if (!isExtensible(it)) return true; // not necessary to add metadata

                if (!create) return false; // add missing metadata

                setMetadata(it); // return the store of weak collections IDs
            }

            return it[METADATA].weakData;
        }; // add metadata on freeze-family methods calling


        var onFreeze = function (it) {
            if (freezing && meta.REQUIRED && isExtensible(it) && !has$1(it, METADATA)) setMetadata(it);
            return it;
        };

        var meta = module.exports = {
            REQUIRED: false,
            fastKey: fastKey,
            getWeakData: getWeakData,
            onFreeze: onFreeze
        };
        hiddenKeys$1[METADATA] = true;
    });

    var Result = function (stopped, result) {
        this.stopped = stopped;
        this.result = result;
    };

    var iterate = function (iterable, unboundFunction, options) {
        var that = options && options.that;
        var AS_ENTRIES = !!(options && options.AS_ENTRIES);
        var IS_ITERATOR = !!(options && options.IS_ITERATOR);
        var INTERRUPTED = !!(options && options.INTERRUPTED);
        var fn = functionBindContext(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
        var iterator, iterFn, index, length, result, next, step;

        var stop = function (condition) {
            if (iterator) iteratorClose(iterator);
            return new Result(true, condition);
        };

        var callFn = function (value) {
            if (AS_ENTRIES) {
                anObject(value);
                return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
            }

            return INTERRUPTED ? fn(value, stop) : fn(value);
        };

        if (IS_ITERATOR) {
            iterator = iterable;
        } else {
            iterFn = getIteratorMethod$1(iterable);
            if (typeof iterFn != 'function') throw TypeError('Target is not iterable'); // optimisation for array iterators

            if (isArrayIteratorMethod(iterFn)) {
                for (index = 0, length = toLength(iterable.length); length > index; index++) {
                    result = callFn(iterable[index]);
                    if (result && result instanceof Result) return result;
                }

                return new Result(false);
            }

            iterator = iterFn.call(iterable);
        }

        next = iterator.next;

        while (!(step = next.call(iterator)).done) {
            try {
                result = callFn(step.value);
            } catch (error) {
                iteratorClose(iterator);
                throw error;
            }

            if (typeof result == 'object' && result && result instanceof Result) return result;
        }

        return new Result(false);
    };

    var anInstance = function (it, Constructor, name) {
        if (!(it instanceof Constructor)) {
            throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
        }

        return it;
    };

    var defineProperty$1 = objectDefineProperty.f;
    var forEach = arrayIteration.forEach;
    var setInternalState$2 = internalState.set;
    var internalStateGetterFor$2 = internalState.getterFor;

    var collection = function (CONSTRUCTOR_NAME, wrapper, common) {
        var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
        var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
        var ADDER = IS_MAP ? 'set' : 'add';
        var NativeConstructor = global$1[CONSTRUCTOR_NAME];
        var NativePrototype = NativeConstructor && NativeConstructor.prototype;
        var exported = {};
        var Constructor;

        if (!descriptors || typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
            new NativeConstructor().entries().next();
        }))) {
            // create collection constructor
            Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
            internalMetadata.REQUIRED = true;
        } else {
            Constructor = wrapper(function (target, iterable) {
                setInternalState$2(anInstance(target, Constructor, CONSTRUCTOR_NAME), {
                    type: CONSTRUCTOR_NAME,
                    collection: new NativeConstructor()
                });
                if (iterable != undefined) iterate(iterable, target[ADDER], {
                    that: target,
                    AS_ENTRIES: IS_MAP
                });
            });
            var getInternalState = internalStateGetterFor$2(CONSTRUCTOR_NAME);
            forEach(['add', 'clear', 'delete', 'forEach', 'get', 'has', 'set', 'keys', 'values', 'entries'], function (KEY) {
                var IS_ADDER = KEY == 'add' || KEY == 'set';

                if (KEY in NativePrototype && !(IS_WEAK && KEY == 'clear')) {
                    createNonEnumerableProperty(Constructor.prototype, KEY, function (a, b) {
                        var collection = getInternalState(this).collection;
                        if (!IS_ADDER && IS_WEAK && !isObject$1(a)) return KEY == 'get' ? undefined : false;
                        var result = collection[KEY](a === 0 ? 0 : a, b);
                        return IS_ADDER ? this : result;
                    });
                }
            });
            IS_WEAK || defineProperty$1(Constructor.prototype, 'size', {
                configurable: true,
                get: function () {
                    return getInternalState(this).collection.size;
                }
            });
        }

        setToStringTag(Constructor, CONSTRUCTOR_NAME, false, true);
        exported[CONSTRUCTOR_NAME] = Constructor;
        _export({
            global: true,
            forced: true
        }, exported);
        if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
        return Constructor;
    };

    var redefineAll = function (target, src, options) {
        for (var key in src) {
            if (options && options.unsafe && target[key]) target[key] = src[key];else redefine(target, key, src[key], options);
        }

        return target;
    };

    var SPECIES = wellKnownSymbol('species');

    var setSpecies = function (CONSTRUCTOR_NAME) {
        var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
        var defineProperty = objectDefineProperty.f;

        if (descriptors && Constructor && !Constructor[SPECIES]) {
            defineProperty(Constructor, SPECIES, {
                configurable: true,
                get: function () {
                    return this;
                }
            });
        }
    };

    var defineProperty = objectDefineProperty.f;
    var fastKey = internalMetadata.fastKey;
    var setInternalState$1 = internalState.set;
    var internalStateGetterFor$1 = internalState.getterFor;
    var collectionStrong = {
        getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
            var C = wrapper(function (that, iterable) {
                anInstance(that, C, CONSTRUCTOR_NAME);
                setInternalState$1(that, {
                    type: CONSTRUCTOR_NAME,
                    index: objectCreate(null),
                    first: undefined,
                    last: undefined,
                    size: 0
                });
                if (!descriptors) that.size = 0;
                if (iterable != undefined) iterate(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
            });
            var getInternalState = internalStateGetterFor$1(CONSTRUCTOR_NAME);

            var define = function (that, key, value) {
                var state = getInternalState(that);
                var entry = getEntry(that, key);
                var previous, index; // change existing entry

                if (entry) {
                    entry.value = value; // create new entry
                } else {
                    state.last = entry = {
                        index: index = fastKey(key, true),
                        key: key,
                        value: value,
                        previous: previous = state.last,
                        next: undefined,
                        removed: false
                    };
                    if (!state.first) state.first = entry;
                    if (previous) previous.next = entry;
                    if (descriptors) state.size++;else that.size++; // add to index

                    if (index !== 'F') state.index[index] = entry;
                }

                return that;
            };

            var getEntry = function (that, key) {
                var state = getInternalState(that); // fast case

                var index = fastKey(key);
                var entry;
                if (index !== 'F') return state.index[index]; // frozen object case

                for (entry = state.first; entry; entry = entry.next) {
                    if (entry.key == key) return entry;
                }
            };

            redefineAll(C.prototype, {
                // 23.1.3.1 Map.prototype.clear()
                // 23.2.3.2 Set.prototype.clear()
                clear: function clear() {
                    var that = this;
                    var state = getInternalState(that);
                    var data = state.index;
                    var entry = state.first;

                    while (entry) {
                        entry.removed = true;
                        if (entry.previous) entry.previous = entry.previous.next = undefined;
                        delete data[entry.index];
                        entry = entry.next;
                    }

                    state.first = state.last = undefined;
                    if (descriptors) state.size = 0;else that.size = 0;
                },
                // 23.1.3.3 Map.prototype.delete(key)
                // 23.2.3.4 Set.prototype.delete(value)
                'delete': function (key) {
                    var that = this;
                    var state = getInternalState(that);
                    var entry = getEntry(that, key);

                    if (entry) {
                        var next = entry.next;
                        var prev = entry.previous;
                        delete state.index[entry.index];
                        entry.removed = true;
                        if (prev) prev.next = next;
                        if (next) next.previous = prev;
                        if (state.first == entry) state.first = next;
                        if (state.last == entry) state.last = prev;
                        if (descriptors) state.size--;else that.size--;
                    }

                    return !!entry;
                },
                // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
                // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
                forEach: function forEach(callbackfn
                                          /* , that = undefined */
                ) {
                    var state = getInternalState(this);
                    var boundFunction = functionBindContext(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
                    var entry;

                    while (entry = entry ? entry.next : state.first) {
                        boundFunction(entry.value, entry.key, this); // revert to the last existing entry

                        while (entry && entry.removed) entry = entry.previous;
                    }
                },
                // 23.1.3.7 Map.prototype.has(key)
                // 23.2.3.7 Set.prototype.has(value)
                has: function has(key) {
                    return !!getEntry(this, key);
                }
            });
            redefineAll(C.prototype, IS_MAP ? {
                // 23.1.3.6 Map.prototype.get(key)
                get: function get(key) {
                    var entry = getEntry(this, key);
                    return entry && entry.value;
                },
                // 23.1.3.9 Map.prototype.set(key, value)
                set: function set(key, value) {
                    return define(this, key === 0 ? 0 : key, value);
                }
            } : {
                // 23.2.3.1 Set.prototype.add(value)
                add: function add(value) {
                    return define(this, value = value === 0 ? 0 : value, value);
                }
            });
            if (descriptors) defineProperty(C.prototype, 'size', {
                get: function () {
                    return getInternalState(this).size;
                }
            });
            return C;
        },
        setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
            var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
            var getInternalCollectionState = internalStateGetterFor$1(CONSTRUCTOR_NAME);
            var getInternalIteratorState = internalStateGetterFor$1(ITERATOR_NAME); // add .keys, .values, .entries, [@@iterator]
            // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11

            defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
                setInternalState$1(this, {
                    type: ITERATOR_NAME,
                    target: iterated,
                    state: getInternalCollectionState(iterated),
                    kind: kind,
                    last: undefined
                });
            }, function () {
                var state = getInternalIteratorState(this);
                var kind = state.kind;
                var entry = state.last; // revert to the last existing entry

                while (entry && entry.removed) entry = entry.previous; // get next entry


                if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
                    // or finish the iteration
                    state.target = undefined;
                    return {
                        value: undefined,
                        done: true
                    };
                } // return step by kind


                if (kind == 'keys') return {
                    value: entry.key,
                    done: false
                };
                if (kind == 'values') return {
                    value: entry.value,
                    done: false
                };
                return {
                    value: [entry.key, entry.value],
                    done: false
                };
            }, IS_MAP ? 'entries' : 'values', !IS_MAP, true); // add [@@species], 23.1.2.2, 23.2.2.2

            setSpecies(CONSTRUCTOR_NAME);
        }
    };

    // https://tc39.es/ecma262/#sec-map-objects


    collection('Map', function (init) {
        return function Map() {
            return init(this, arguments.length ? arguments[0] : undefined);
        };
    }, collectionStrong);

    var map$2 = path.Map;

    var map$1 = map$2;

    var map = map$1;

    /**
     * This class can store groups and options specific for groups.
     */
    var Groups = /*#__PURE__*/function () {
        /**
         * @ignore
         */
        function Groups() {
            _classCallCheck(this, Groups);

            this.clear();
            this._defaultIndex = 0;
            this._groupIndex = 0;
            this._defaultGroups = [{
                border: "#2B7CE9",
                background: "#97C2FC",
                highlight: {
                    border: "#2B7CE9",
                    background: "#D2E5FF"
                },
                hover: {
                    border: "#2B7CE9",
                    background: "#D2E5FF"
                }
            }, // 0: blue
                {
                    border: "#FFA500",
                    background: "#FFFF00",
                    highlight: {
                        border: "#FFA500",
                        background: "#FFFFA3"
                    },
                    hover: {
                        border: "#FFA500",
                        background: "#FFFFA3"
                    }
                }, // 1: yellow
                {
                    border: "#FA0A10",
                    background: "#FB7E81",
                    highlight: {
                        border: "#FA0A10",
                        background: "#FFAFB1"
                    },
                    hover: {
                        border: "#FA0A10",
                        background: "#FFAFB1"
                    }
                }, // 2: red
                {
                    border: "#41A906",
                    background: "#7BE141",
                    highlight: {
                        border: "#41A906",
                        background: "#A1EC76"
                    },
                    hover: {
                        border: "#41A906",
                        background: "#A1EC76"
                    }
                }, // 3: green
                {
                    border: "#E129F0",
                    background: "#EB7DF4",
                    highlight: {
                        border: "#E129F0",
                        background: "#F0B3F5"
                    },
                    hover: {
                        border: "#E129F0",
                        background: "#F0B3F5"
                    }
                }, // 4: magenta
                {
                    border: "#7C29F0",
                    background: "#AD85E4",
                    highlight: {
                        border: "#7C29F0",
                        background: "#D3BDF0"
                    },
                    hover: {
                        border: "#7C29F0",
                        background: "#D3BDF0"
                    }
                }, // 5: purple
                {
                    border: "#C37F00",
                    background: "#FFA807",
                    highlight: {
                        border: "#C37F00",
                        background: "#FFCA66"
                    },
                    hover: {
                        border: "#C37F00",
                        background: "#FFCA66"
                    }
                }, // 6: orange
                {
                    border: "#4220FB",
                    background: "#6E6EFD",
                    highlight: {
                        border: "#4220FB",
                        background: "#9B9BFD"
                    },
                    hover: {
                        border: "#4220FB",
                        background: "#9B9BFD"
                    }
                }, // 7: darkblue
                {
                    border: "#FD5A77",
                    background: "#FFC0CB",
                    highlight: {
                        border: "#FD5A77",
                        background: "#FFD1D9"
                    },
                    hover: {
                        border: "#FD5A77",
                        background: "#FFD1D9"
                    }
                }, // 8: pink
                {
                    border: "#4AD63A",
                    background: "#C2FABC",
                    highlight: {
                        border: "#4AD63A",
                        background: "#E6FFE3"
                    },
                    hover: {
                        border: "#4AD63A",
                        background: "#E6FFE3"
                    }
                }, // 9: mint
                {
                    border: "#990000",
                    background: "#EE0000",
                    highlight: {
                        border: "#BB0000",
                        background: "#FF3333"
                    },
                    hover: {
                        border: "#BB0000",
                        background: "#FF3333"
                    }
                }, // 10:bright red
                {
                    border: "#FF6000",
                    background: "#FF6000",
                    highlight: {
                        border: "#FF6000",
                        background: "#FF6000"
                    },
                    hover: {
                        border: "#FF6000",
                        background: "#FF6000"
                    }
                }, // 12: real orange
                {
                    border: "#97C2FC",
                    background: "#2B7CE9",
                    highlight: {
                        border: "#D2E5FF",
                        background: "#2B7CE9"
                    },
                    hover: {
                        border: "#D2E5FF",
                        background: "#2B7CE9"
                    }
                }, // 13: blue
                {
                    border: "#399605",
                    background: "#255C03",
                    highlight: {
                        border: "#399605",
                        background: "#255C03"
                    },
                    hover: {
                        border: "#399605",
                        background: "#255C03"
                    }
                }, // 14: green
                {
                    border: "#B70054",
                    background: "#FF007E",
                    highlight: {
                        border: "#B70054",
                        background: "#FF007E"
                    },
                    hover: {
                        border: "#B70054",
                        background: "#FF007E"
                    }
                }, // 15: magenta
                {
                    border: "#AD85E4",
                    background: "#7C29F0",
                    highlight: {
                        border: "#D3BDF0",
                        background: "#7C29F0"
                    },
                    hover: {
                        border: "#D3BDF0",
                        background: "#7C29F0"
                    }
                }, // 16: purple
                {
                    border: "#4557FA",
                    background: "#000EA1",
                    highlight: {
                        border: "#6E6EFD",
                        background: "#000EA1"
                    },
                    hover: {
                        border: "#6E6EFD",
                        background: "#000EA1"
                    }
                }, // 17: darkblue
                {
                    border: "#FFC0CB",
                    background: "#FD5A77",
                    highlight: {
                        border: "#FFD1D9",
                        background: "#FD5A77"
                    },
                    hover: {
                        border: "#FFD1D9",
                        background: "#FD5A77"
                    }
                }, // 18: pink
                {
                    border: "#C2FABC",
                    background: "#74D66A",
                    highlight: {
                        border: "#E6FFE3",
                        background: "#74D66A"
                    },
                    hover: {
                        border: "#E6FFE3",
                        background: "#74D66A"
                    }
                }, // 19: mint
                {
                    border: "#EE0000",
                    background: "#990000",
                    highlight: {
                        border: "#FF3333",
                        background: "#BB0000"
                    },
                    hover: {
                        border: "#FF3333",
                        background: "#BB0000"
                    }
                } // 20:bright red
            ];
            this.options = {};
            this.defaultOptions = {
                useDefaultGroups: true
            };

            assign$2(this.options, this.defaultOptions);
        }
        /**
         *
         * @param {object} options
         */


        _createClass(Groups, [{
            key: "setOptions",
            value: function setOptions(options) {
                var optionFields = ["useDefaultGroups"];

                if (options !== undefined) {
                    for (var groupName in options) {
                        if (Object.prototype.hasOwnProperty.call(options, groupName)) {
                            if (indexOf(optionFields).call(optionFields, groupName) === -1) {
                                var group = options[groupName];
                                this.add(groupName, group);
                            }
                        }
                    }
                }
            }
            /**
             * Clear all groups
             */

        }, {
            key: "clear",
            value: function clear() {
                this._groups = new map();
                this._groupNames = [];
            }
            /**
             * Get group options of a groupname.
             * If groupname is not found, a new group may be created.
             *
             * @param {*}       groupname     Can be a number, string, Date, etc.
             * @param {boolean} [shouldCreate=true] If true, create a new group
             * @returns {object} The found or created group
             */

        }, {
            key: "get",
            value: function get(groupname) {
                var shouldCreate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                var group = this._groups.get(groupname);

                if (group === undefined && shouldCreate) {
                    if (this.options.useDefaultGroups === false && this._groupNames.length > 0) {
                        // create new group
                        var index = this._groupIndex % this._groupNames.length;
                        ++this._groupIndex;
                        group = {};
                        group.color = this._groups.get(this._groupNames[index]);

                        this._groups.set(groupname, group);
                    } else {
                        // create new group
                        var _index = this._defaultIndex % this._defaultGroups.length;

                        this._defaultIndex++;
                        group = {};
                        group.color = this._defaultGroups[_index];

                        this._groups.set(groupname, group);
                    }
                }

                return group;
            }
            /**
             * Add custom group style.
             *
             * @param {string} groupName - The name of the group, a new group will be
             * created if a group with the same name doesn't exist, otherwise the old
             * groups style will be overwritten.
             * @param {object} style - An object containing borderColor, backgroundColor,
             * etc.
             * @returns {object} The created group object.
             */

        }, {
            key: "add",
            value: function add(groupName, style) {
                // Only push group name once to prevent duplicates which would consume more
                // RAM and also skew the distribution towards more often updated groups,
                // neither of which is desirable.
                if (!this._groups.has(groupName)) {
                    this._groupNames.push(groupName);
                }

                this._groups.set(groupName, style);

                return style;
            }
        }]);

        return Groups;
    }();

    // https://tc39.es/ecma262/#sec-number.isnan

    _export({
        target: 'Number',
        stat: true
    }, {
        isNaN: function isNaN(number) {
            // eslint-disable-next-line no-self-compare -- NaN check
            return number != number;
        }
    });

    var isNan$2 = path.Number.isNaN;

    var isNan$1 = isNan$2;

    var isNan = isNan$1;

    var globalIsFinite = global$1.isFinite; // `Number.isFinite` method
    // https://tc39.es/ecma262/#sec-number.isfinite

    var numberIsFinite = Number.isFinite || function isFinite(it) {
        return typeof it == 'number' && globalIsFinite(it);
    };

    // https://tc39.es/ecma262/#sec-number.isfinite

    _export({
        target: 'Number',
        stat: true
    }, {
        isFinite: numberIsFinite
    });

    var _isFinite$2 = path.Number.isFinite;

    var _isFinite$1 = _isFinite$2;

    var _isFinite = _isFinite$1;

    var $some = arrayIteration.some;
    var STRICT_METHOD$3 = arrayMethodIsStrict('some'); // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some

    _export({
        target: 'Array',
        proto: true,
        forced: !STRICT_METHOD$3
    }, {
        some: function some(callbackfn
                            /* , thisArg */
        ) {
            return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        }
    });

    var some$2 = entryVirtual('Array').some;

    var ArrayPrototype$7 = Array.prototype;

    var some_1 = function (it) {
        var own = it.some;
        return it === ArrayPrototype$7 || it instanceof Array && own === ArrayPrototype$7.some ? some$2 : own;
    };

    var some$1 = some_1;

    var some = some$1;

    var nativeConstruct = getBuiltIn('Reflect', 'construct'); // `Reflect.construct` method
    // https://tc39.es/ecma262/#sec-reflect.construct
    // MS Edge supports only 2 arguments and argumentsList argument is optional
    // FF Nightly sets third argument as `new.target`, but does not create `this` from it

    var NEW_TARGET_BUG = fails(function () {
        function F() {
            /* empty */
        }

        return !(nativeConstruct(function () {
            /* empty */
        }, [], F) instanceof F);
    });
    var ARGS_BUG = !fails(function () {
        nativeConstruct(function () {
            /* empty */
        });
    });
    var FORCED$2 = NEW_TARGET_BUG || ARGS_BUG;
    _export({
        target: 'Reflect',
        stat: true,
        forced: FORCED$2,
        sham: FORCED$2
    }, {
        construct: function construct(Target, args
                                      /* , newTarget */
        ) {
            aFunction$1(Target);
            anObject(args);
            var newTarget = arguments.length < 3 ? Target : aFunction$1(arguments[2]);
            if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);

            if (Target == newTarget) {
                // w/o altered newTarget, optimization for 0-4 arguments
                switch (args.length) {
                    case 0:
                        return new Target();

                    case 1:
                        return new Target(args[0]);

                    case 2:
                        return new Target(args[0], args[1]);

                    case 3:
                        return new Target(args[0], args[1], args[2]);

                    case 4:
                        return new Target(args[0], args[1], args[2], args[3]);
                } // w/o altered newTarget, lot of arguments case


                var $args = [null];
                $args.push.apply($args, args);
                return new (functionBind.apply(Target, $args))();
            } // with altered newTarget, not support built-in constructors


            var proto = newTarget.prototype;
            var instance = objectCreate(isObject$1(proto) ? proto : Object.prototype);
            var result = Function.apply.call(Target, instance, args);
            return isObject$1(result) ? result : instance;
        }
    });

    var construct$2 = path.Reflect.construct;

    var construct$1 = construct$2;

    var construct = construct$1;

    function _assertThisInitialized(self) {
        if (self === void 0) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return self;
    }

    var create$1 = create$4;

    var create = create$1;

    // https://tc39.es/ecma262/#sec-object.setprototypeof

    _export({
        target: 'Object',
        stat: true
    }, {
        setPrototypeOf: objectSetPrototypeOf
    });

    var setPrototypeOf$2 = path.Object.setPrototypeOf;

    var setPrototypeOf$1 = setPrototypeOf$2;

    var setPrototypeOf = setPrototypeOf$1;

    function _setPrototypeOf(o, p) {
        _setPrototypeOf = setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };

        return _setPrototypeOf(o, p);
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function");
        }

        subClass.prototype = create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }

    function _possibleConstructorReturn(self, call) {
        if (call && (_typeof(call) === "object" || typeof call === "function")) {
            return call;
        }

        return _assertThisInitialized(self);
    }

    var getPrototypeOf$1 = getPrototypeOf$4;

    var getPrototypeOf = getPrototypeOf$1;

    function _getPrototypeOf(o) {
        _getPrototypeOf = setPrototypeOf ? getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }

    /**
     * Copyright (c) 2014-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var runtime_1 = createCommonjsModule(function (module) {
        var runtime = function (exports) {

            var Op = Object.prototype;
            var hasOwn = Op.hasOwnProperty;
            var undefined$1; // More compressible than void 0.

            var $Symbol = typeof Symbol === "function" ? Symbol : {};
            var iteratorSymbol = $Symbol.iterator || "@@iterator";
            var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
            var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

            function define(obj, key, value) {
                Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                return obj[key];
            }

            try {
                // IE 8 has a broken Object.defineProperty that only works on DOM objects.
                define({}, "");
            } catch (err) {
                define = function (obj, key, value) {
                    return obj[key] = value;
                };
            }

            function wrap(innerFn, outerFn, self, tryLocsList) {
                // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
                var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
                var generator = Object.create(protoGenerator.prototype);
                var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
                // .throw, and .return methods.

                generator._invoke = makeInvokeMethod(innerFn, self, context);
                return generator;
            }

            exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
            // record like context.tryEntries[i].completion. This interface could
            // have been (and was previously) designed to take a closure to be
            // invoked without arguments, but in all the cases we care about we
            // already have an existing method we want to call, so there's no need
            // to create a new function object. We can even get away with assuming
            // the method takes exactly one argument, since that happens to be true
            // in every case, so we don't have to touch the arguments object. The
            // only additional allocation required is the completion record, which
            // has a stable shape and so hopefully should be cheap to allocate.

            function tryCatch(fn, obj, arg) {
                try {
                    return {
                        type: "normal",
                        arg: fn.call(obj, arg)
                    };
                } catch (err) {
                    return {
                        type: "throw",
                        arg: err
                    };
                }
            }

            var GenStateSuspendedStart = "suspendedStart";
            var GenStateSuspendedYield = "suspendedYield";
            var GenStateExecuting = "executing";
            var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
            // breaking out of the dispatch switch statement.

            var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
            // .constructor.prototype properties for functions that return Generator
            // objects. For full spec compliance, you may wish to configure your
            // minifier not to mangle the names of these two functions.

            function Generator() {}

            function GeneratorFunction() {}

            function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
            // don't natively support it.


            var IteratorPrototype = {};

            IteratorPrototype[iteratorSymbol] = function () {
                return this;
            };

            var getProto = Object.getPrototypeOf;
            var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

            if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
                // This environment has a native %IteratorPrototype%; use it instead
                // of the polyfill.
                IteratorPrototype = NativeIteratorPrototype;
            }

            var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
            GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
            GeneratorFunctionPrototype.constructor = GeneratorFunction;
            GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
            // Iterator interface in terms of a single ._invoke method.

            function defineIteratorMethods(prototype) {
                ["next", "throw", "return"].forEach(function (method) {
                    define(prototype, method, function (arg) {
                        return this._invoke(method, arg);
                    });
                });
            }

            exports.isGeneratorFunction = function (genFun) {
                var ctor = typeof genFun === "function" && genFun.constructor;
                return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
                    // do is to check its .name property.
                    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
            };

            exports.mark = function (genFun) {
                if (Object.setPrototypeOf) {
                    Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
                } else {
                    genFun.__proto__ = GeneratorFunctionPrototype;
                    define(genFun, toStringTagSymbol, "GeneratorFunction");
                }

                genFun.prototype = Object.create(Gp);
                return genFun;
            }; // Within the body of any async function, `await x` is transformed to
            // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
            // `hasOwn.call(value, "__await")` to determine if the yielded value is
            // meant to be awaited.


            exports.awrap = function (arg) {
                return {
                    __await: arg
                };
            };

            function AsyncIterator(generator, PromiseImpl) {
                function invoke(method, arg, resolve, reject) {
                    var record = tryCatch(generator[method], generator, arg);

                    if (record.type === "throw") {
                        reject(record.arg);
                    } else {
                        var result = record.arg;
                        var value = result.value;

                        if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
                            return PromiseImpl.resolve(value.__await).then(function (value) {
                                invoke("next", value, resolve, reject);
                            }, function (err) {
                                invoke("throw", err, resolve, reject);
                            });
                        }

                        return PromiseImpl.resolve(value).then(function (unwrapped) {
                            // When a yielded Promise is resolved, its final value becomes
                            // the .value of the Promise<{value,done}> result for the
                            // current iteration.
                            result.value = unwrapped;
                            resolve(result);
                        }, function (error) {
                            // If a rejected Promise was yielded, throw the rejection back
                            // into the async generator function so it can be handled there.
                            return invoke("throw", error, resolve, reject);
                        });
                    }
                }

                var previousPromise;

                function enqueue(method, arg) {
                    function callInvokeWithMethodAndArg() {
                        return new PromiseImpl(function (resolve, reject) {
                            invoke(method, arg, resolve, reject);
                        });
                    }

                    return previousPromise = // If enqueue has been called before, then we want to wait until
                        // all previous Promises have been resolved before calling invoke,
                        // so that results are always delivered in the correct order. If
                        // enqueue has not been called before, then it is important to
                        // call invoke immediately, without waiting on a callback to fire,
                        // so that the async generator function has the opportunity to do
                        // any necessary setup in a predictable way. This predictability
                        // is why the Promise constructor synchronously invokes its
                        // executor callback, and why async functions synchronously
                        // execute code before the first await. Since we implement simple
                        // async functions in terms of async generators, it is especially
                        // important to get this right, even though it requires care.
                        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
                            // invocations of the iterator.
                            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
                } // Define the unified helper method that is used to implement .next,
                // .throw, and .return (see defineIteratorMethods).


                this._invoke = enqueue;
            }

            defineIteratorMethods(AsyncIterator.prototype);

            AsyncIterator.prototype[asyncIteratorSymbol] = function () {
                return this;
            };

            exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
            // AsyncIterator objects; they just return a Promise for the value of
            // the final result produced by the iterator.

            exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
                if (PromiseImpl === void 0) PromiseImpl = Promise;
                var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
                return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
                    : iter.next().then(function (result) {
                        return result.done ? result.value : iter.next();
                    });
            };

            function makeInvokeMethod(innerFn, self, context) {
                var state = GenStateSuspendedStart;
                return function invoke(method, arg) {
                    if (state === GenStateExecuting) {
                        throw new Error("Generator is already running");
                    }

                    if (state === GenStateCompleted) {
                        if (method === "throw") {
                            throw arg;
                        } // Be forgiving, per 25.3.3.3.3 of the spec:
                        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


                        return doneResult();
                    }

                    context.method = method;
                    context.arg = arg;

                    while (true) {
                        var delegate = context.delegate;

                        if (delegate) {
                            var delegateResult = maybeInvokeDelegate(delegate, context);

                            if (delegateResult) {
                                if (delegateResult === ContinueSentinel) continue;
                                return delegateResult;
                            }
                        }

                        if (context.method === "next") {
                            // Setting context._sent for legacy support of Babel's
                            // function.sent implementation.
                            context.sent = context._sent = context.arg;
                        } else if (context.method === "throw") {
                            if (state === GenStateSuspendedStart) {
                                state = GenStateCompleted;
                                throw context.arg;
                            }

                            context.dispatchException(context.arg);
                        } else if (context.method === "return") {
                            context.abrupt("return", context.arg);
                        }

                        state = GenStateExecuting;
                        var record = tryCatch(innerFn, self, context);

                        if (record.type === "normal") {
                            // If an exception is thrown from innerFn, we leave state ===
                            // GenStateExecuting and loop back for another invocation.
                            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

                            if (record.arg === ContinueSentinel) {
                                continue;
                            }

                            return {
                                value: record.arg,
                                done: context.done
                            };
                        } else if (record.type === "throw") {
                            state = GenStateCompleted; // Dispatch the exception by looping back around to the
                            // context.dispatchException(context.arg) call above.

                            context.method = "throw";
                            context.arg = record.arg;
                        }
                    }
                };
            } // Call delegate.iterator[context.method](context.arg) and handle the
            // result, either by returning a { value, done } result from the
            // delegate iterator, or by modifying context.method and context.arg,
            // setting context.delegate to null, and returning the ContinueSentinel.


            function maybeInvokeDelegate(delegate, context) {
                var method = delegate.iterator[context.method];

                if (method === undefined$1) {
                    // A .throw or .return when the delegate iterator has no .throw
                    // method always terminates the yield* loop.
                    context.delegate = null;

                    if (context.method === "throw") {
                        // Note: ["return"] must be used for ES3 parsing compatibility.
                        if (delegate.iterator["return"]) {
                            // If the delegate iterator has a return method, give it a
                            // chance to clean up.
                            context.method = "return";
                            context.arg = undefined$1;
                            maybeInvokeDelegate(delegate, context);

                            if (context.method === "throw") {
                                // If maybeInvokeDelegate(context) changed context.method from
                                // "return" to "throw", let that override the TypeError below.
                                return ContinueSentinel;
                            }
                        }

                        context.method = "throw";
                        context.arg = new TypeError("The iterator does not provide a 'throw' method");
                    }

                    return ContinueSentinel;
                }

                var record = tryCatch(method, delegate.iterator, context.arg);

                if (record.type === "throw") {
                    context.method = "throw";
                    context.arg = record.arg;
                    context.delegate = null;
                    return ContinueSentinel;
                }

                var info = record.arg;

                if (!info) {
                    context.method = "throw";
                    context.arg = new TypeError("iterator result is not an object");
                    context.delegate = null;
                    return ContinueSentinel;
                }

                if (info.done) {
                    // Assign the result of the finished delegate to the temporary
                    // variable specified by delegate.resultName (see delegateYield).
                    context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

                    context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
                    // exception, let the outer generator proceed normally. If
                    // context.method was "next", forget context.arg since it has been
                    // "consumed" by the delegate iterator. If context.method was
                    // "return", allow the original .return call to continue in the
                    // outer generator.

                    if (context.method !== "return") {
                        context.method = "next";
                        context.arg = undefined$1;
                    }
                } else {
                    // Re-yield the result returned by the delegate method.
                    return info;
                } // The delegate iterator is finished, so forget it and continue with
                // the outer generator.


                context.delegate = null;
                return ContinueSentinel;
            } // Define Generator.prototype.{next,throw,return} in terms of the
            // unified ._invoke helper method.


            defineIteratorMethods(Gp);
            define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
            // @@iterator function is called on it. Some browsers' implementations of the
            // iterator prototype chain incorrectly implement this, causing the Generator
            // object to not be returned from this call. This ensures that doesn't happen.
            // See https://github.com/facebook/regenerator/issues/274 for more details.

            Gp[iteratorSymbol] = function () {
                return this;
            };

            Gp.toString = function () {
                return "[object Generator]";
            };

            function pushTryEntry(locs) {
                var entry = {
                    tryLoc: locs[0]
                };

                if (1 in locs) {
                    entry.catchLoc = locs[1];
                }

                if (2 in locs) {
                    entry.finallyLoc = locs[2];
                    entry.afterLoc = locs[3];
                }

                this.tryEntries.push(entry);
            }

            function resetTryEntry(entry) {
                var record = entry.completion || {};
                record.type = "normal";
                delete record.arg;
                entry.completion = record;
            }

            function Context(tryLocsList) {
                // The root entry object (effectively a try statement without a catch
                // or a finally block) gives us a place to store values thrown from
                // locations where there is no enclosing try statement.
                this.tryEntries = [{
                    tryLoc: "root"
                }];
                tryLocsList.forEach(pushTryEntry, this);
                this.reset(true);
            }

            exports.keys = function (object) {
                var keys = [];

                for (var key in object) {
                    keys.push(key);
                }

                keys.reverse(); // Rather than returning an object with a next method, we keep
                // things simple and return the next function itself.

                return function next() {
                    while (keys.length) {
                        var key = keys.pop();

                        if (key in object) {
                            next.value = key;
                            next.done = false;
                            return next;
                        }
                    } // To avoid creating an additional object, we just hang the .value
                    // and .done properties off the next function object itself. This
                    // also ensures that the minifier will not anonymize the function.


                    next.done = true;
                    return next;
                };
            };

            function values(iterable) {
                if (iterable) {
                    var iteratorMethod = iterable[iteratorSymbol];

                    if (iteratorMethod) {
                        return iteratorMethod.call(iterable);
                    }

                    if (typeof iterable.next === "function") {
                        return iterable;
                    }

                    if (!isNaN(iterable.length)) {
                        var i = -1,
                            next = function next() {
                                while (++i < iterable.length) {
                                    if (hasOwn.call(iterable, i)) {
                                        next.value = iterable[i];
                                        next.done = false;
                                        return next;
                                    }
                                }

                                next.value = undefined$1;
                                next.done = true;
                                return next;
                            };

                        return next.next = next;
                    }
                } // Return an iterator with no values.


                return {
                    next: doneResult
                };
            }

            exports.values = values;

            function doneResult() {
                return {
                    value: undefined$1,
                    done: true
                };
            }

            Context.prototype = {
                constructor: Context,
                reset: function (skipTempReset) {
                    this.prev = 0;
                    this.next = 0; // Resetting context._sent for legacy support of Babel's
                    // function.sent implementation.

                    this.sent = this._sent = undefined$1;
                    this.done = false;
                    this.delegate = null;
                    this.method = "next";
                    this.arg = undefined$1;
                    this.tryEntries.forEach(resetTryEntry);

                    if (!skipTempReset) {
                        for (var name in this) {
                            // Not sure about the optimal order of these conditions:
                            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                                this[name] = undefined$1;
                            }
                        }
                    }
                },
                stop: function () {
                    this.done = true;
                    var rootEntry = this.tryEntries[0];
                    var rootRecord = rootEntry.completion;

                    if (rootRecord.type === "throw") {
                        throw rootRecord.arg;
                    }

                    return this.rval;
                },
                dispatchException: function (exception) {
                    if (this.done) {
                        throw exception;
                    }

                    var context = this;

                    function handle(loc, caught) {
                        record.type = "throw";
                        record.arg = exception;
                        context.next = loc;

                        if (caught) {
                            // If the dispatched exception was caught by a catch block,
                            // then let that catch block handle the exception normally.
                            context.method = "next";
                            context.arg = undefined$1;
                        }

                        return !!caught;
                    }

                    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                        var entry = this.tryEntries[i];
                        var record = entry.completion;

                        if (entry.tryLoc === "root") {
                            // Exception thrown outside of any try block that could handle
                            // it, so set the completion value of the entire function to
                            // throw the exception.
                            return handle("end");
                        }

                        if (entry.tryLoc <= this.prev) {
                            var hasCatch = hasOwn.call(entry, "catchLoc");
                            var hasFinally = hasOwn.call(entry, "finallyLoc");

                            if (hasCatch && hasFinally) {
                                if (this.prev < entry.catchLoc) {
                                    return handle(entry.catchLoc, true);
                                } else if (this.prev < entry.finallyLoc) {
                                    return handle(entry.finallyLoc);
                                }
                            } else if (hasCatch) {
                                if (this.prev < entry.catchLoc) {
                                    return handle(entry.catchLoc, true);
                                }
                            } else if (hasFinally) {
                                if (this.prev < entry.finallyLoc) {
                                    return handle(entry.finallyLoc);
                                }
                            } else {
                                throw new Error("try statement without catch or finally");
                            }
                        }
                    }
                },
                abrupt: function (type, arg) {
                    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                        var entry = this.tryEntries[i];

                        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                            var finallyEntry = entry;
                            break;
                        }
                    }

                    if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
                        // Ignore the finally entry if control is not jumping to a
                        // location outside the try/catch block.
                        finallyEntry = null;
                    }

                    var record = finallyEntry ? finallyEntry.completion : {};
                    record.type = type;
                    record.arg = arg;

                    if (finallyEntry) {
                        this.method = "next";
                        this.next = finallyEntry.finallyLoc;
                        return ContinueSentinel;
                    }

                    return this.complete(record);
                },
                complete: function (record, afterLoc) {
                    if (record.type === "throw") {
                        throw record.arg;
                    }

                    if (record.type === "break" || record.type === "continue") {
                        this.next = record.arg;
                    } else if (record.type === "return") {
                        this.rval = this.arg = record.arg;
                        this.method = "return";
                        this.next = "end";
                    } else if (record.type === "normal" && afterLoc) {
                        this.next = afterLoc;
                    }

                    return ContinueSentinel;
                },
                finish: function (finallyLoc) {
                    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                        var entry = this.tryEntries[i];

                        if (entry.finallyLoc === finallyLoc) {
                            this.complete(entry.completion, entry.afterLoc);
                            resetTryEntry(entry);
                            return ContinueSentinel;
                        }
                    }
                },
                "catch": function (tryLoc) {
                    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                        var entry = this.tryEntries[i];

                        if (entry.tryLoc === tryLoc) {
                            var record = entry.completion;

                            if (record.type === "throw") {
                                var thrown = record.arg;
                                resetTryEntry(entry);
                            }

                            return thrown;
                        }
                    } // The context.catch method must only be called with a location
                    // argument that corresponds to a known catch block.


                    throw new Error("illegal catch attempt");
                },
                delegateYield: function (iterable, resultName, nextLoc) {
                    this.delegate = {
                        iterator: values(iterable),
                        resultName: resultName,
                        nextLoc: nextLoc
                    };

                    if (this.method === "next") {
                        // Deliberately forget the last sent value so that we don't
                        // accidentally pass it on to the delegate.
                        this.arg = undefined$1;
                    }

                    return ContinueSentinel;
                }
            }; // Regardless of whether this script is executing as a CommonJS module
            // or not, return the runtime object so that we can declare the variable
            // regeneratorRuntime in the outer scope, which allows this module to be
            // injected easily by `bin/regenerator --include-runtime script.js`.

            return exports;
        }( // If this script is executing as a CommonJS module, use module.exports
            // as the regeneratorRuntime namespace. Otherwise create a new empty
            // object. Either way, the resulting object will be used to initialize
            // the regeneratorRuntime variable at the top of this file.
            module.exports );

        try {
            regeneratorRuntime = runtime;
        } catch (accidentalStrictMode) {
            // This module should not be running in strict mode, so the above
            // assignment should always work unless something is misconfigured. Just
            // in case runtime.js accidentally runs in strict mode, we can escape
            // strict mode using a global Function call. This could conceivably fail
            // if a Content Security Policy forbids using Function, but in that case
            // the proper solution is to fix the accidental strict mode problem. If
            // you've misconfigured your bundler to force strict mode and applied a
            // CSP to forbid Function, and you're not willing to fix either of those
            // problems, please detail your unique predicament in a GitHub issue.
            Function("r", "regeneratorRuntime = r")(runtime);
        }
    });

    var regenerator = runtime_1;

    var createMethod = function (IS_RIGHT) {
        return function (that, callbackfn, argumentsLength, memo) {
            aFunction$1(callbackfn);
            var O = toObject(that);
            var self = indexedObject(O);
            var length = toLength(O.length);
            var index = IS_RIGHT ? length - 1 : 0;
            var i = IS_RIGHT ? -1 : 1;
            if (argumentsLength < 2) while (true) {
                if (index in self) {
                    memo = self[index];
                    index += i;
                    break;
                }

                index += i;

                if (IS_RIGHT ? index < 0 : length <= index) {
                    throw TypeError('Reduce of empty array with no initial value');
                }
            }

            for (; IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
                memo = callbackfn(memo, self[index], index, O);
            }

            return memo;
        };
    };

    var arrayReduce = {
        // `Array.prototype.reduce` method
        // https://tc39.es/ecma262/#sec-array.prototype.reduce
        left: createMethod(false),
        // `Array.prototype.reduceRight` method
        // https://tc39.es/ecma262/#sec-array.prototype.reduceright
        right: createMethod(true)
    };

    var $reduce = arrayReduce.left;
    var STRICT_METHOD$2 = arrayMethodIsStrict('reduce'); // Chrome 80-82 has a critical bug
    // https://bugs.chromium.org/p/chromium/issues/detail?id=1049982

    var CHROME_BUG = !engineIsNode && engineV8Version > 79 && engineV8Version < 83; // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce

    _export({
        target: 'Array',
        proto: true,
        forced: !STRICT_METHOD$2 || CHROME_BUG
    }, {
        reduce: function reduce(callbackfn
                                /* , initialValue */
        ) {
            return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
        }
    });

    var reduce$2 = entryVirtual('Array').reduce;

    var ArrayPrototype$6 = Array.prototype;

    var reduce_1 = function (it) {
        var own = it.reduce;
        return it === ArrayPrototype$6 || it instanceof Array && own === ArrayPrototype$6.reduce ? reduce$2 : own;
    };

    var reduce$1 = reduce_1;

    var reduce = reduce$1;

    // https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray


    var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
        var targetIndex = start;
        var sourceIndex = 0;
        var mapFn = mapper ? functionBindContext(mapper, thisArg, 3) : false;
        var element;

        while (sourceIndex < sourceLen) {
            if (sourceIndex in source) {
                element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

                if (depth > 0 && isArray$5(element)) {
                    targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
                } else {
                    if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError('Exceed the acceptable array length');
                    target[targetIndex] = element;
                }

                targetIndex++;
            }

            sourceIndex++;
        }

        return targetIndex;
    };

    var flattenIntoArray_1 = flattenIntoArray;

    // https://tc39.es/ecma262/#sec-array.prototype.flatmap


    _export({
        target: 'Array',
        proto: true
    }, {
        flatMap: function flatMap(callbackfn
                                  /* , thisArg */
        ) {
            var O = toObject(this);
            var sourceLen = toLength(O.length);
            var A;
            aFunction$1(callbackfn);
            A = arraySpeciesCreate(O, 0);
            A.length = flattenIntoArray_1(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
            return A;
        }
    });

    var flatMap$2 = entryVirtual('Array').flatMap;

    var ArrayPrototype$5 = Array.prototype;

    var flatMap_1 = function (it) {
        var own = it.flatMap;
        return it === ArrayPrototype$5 || it instanceof Array && own === ArrayPrototype$5.flatMap ? flatMap$2 : own;
    };

    var flatMap$1 = flatMap_1;

    var flatMap = flatMap$1;

    var iterator$1 = iterator$4;

    var iterator = iterator$1;

    // https://tc39.es/ecma262/#sec-set-objects


    collection('Set', function (init) {
        return function Set() {
            return init(this, arguments.length ? arguments[0] : undefined);
        };
    }, collectionStrong);

    var set$2 = path.Set;

    var set$1 = set$2;

    var set = set$1;

    var test = [];
    var nativeSort = test.sort; // IE8-

    var FAILS_ON_UNDEFINED = fails(function () {
        test.sort(undefined);
    }); // V8 bug

    var FAILS_ON_NULL = fails(function () {
        test.sort(null);
    }); // Old WebKit

    var STRICT_METHOD$1 = arrayMethodIsStrict('sort');
    var FORCED$1 = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD$1; // `Array.prototype.sort` method
    // https://tc39.es/ecma262/#sec-array.prototype.sort

    _export({
        target: 'Array',
        proto: true,
        forced: FORCED$1
    }, {
        sort: function sort(comparefn) {
            return comparefn === undefined ? nativeSort.call(toObject(this)) : nativeSort.call(toObject(this), aFunction$1(comparefn));
        }
    });

    var sort$2 = entryVirtual('Array').sort;

    var ArrayPrototype$4 = Array.prototype;

    var sort_1 = function (it) {
        var own = it.sort;
        return it === ArrayPrototype$4 || it instanceof Array && own === ArrayPrototype$4.sort ? sort$2 : own;
    };

    var sort$1 = sort_1;

    var sort = sort$1;

    var keys$2 = entryVirtual('Array').keys;

    var keys$1 = keys$2;

    var ArrayPrototype$3 = Array.prototype;
    var DOMIterables$2 = {
        DOMTokenList: true,
        NodeList: true
    };

    var keys_1 = function (it) {
        var own = it.keys;
        return it === ArrayPrototype$3 || it instanceof Array && own === ArrayPrototype$3.keys // eslint-disable-next-line no-prototype-builtins -- safe
        || DOMIterables$2.hasOwnProperty(classof(it)) ? keys$1 : own;
    };

    var keys = keys_1;

    var values$2 = entryVirtual('Array').values;

    var values$1 = values$2;

    var ArrayPrototype$2 = Array.prototype;
    var DOMIterables$1 = {
        DOMTokenList: true,
        NodeList: true
    };

    var values_1 = function (it) {
        var own = it.values;
        return it === ArrayPrototype$2 || it instanceof Array && own === ArrayPrototype$2.values // eslint-disable-next-line no-prototype-builtins -- safe
        || DOMIterables$1.hasOwnProperty(classof(it)) ? values$1 : own;
    };

    var values = values_1;

    var entries$2 = entryVirtual('Array').entries;

    var entries$1 = entries$2;

    var ArrayPrototype$1 = Array.prototype;
    var DOMIterables = {
        DOMTokenList: true,
        NodeList: true
    };

    var entries_1 = function (it) {
        var own = it.entries;
        return it === ArrayPrototype$1 || it instanceof Array && own === ArrayPrototype$1.entries // eslint-disable-next-line no-prototype-builtins -- safe
        || DOMIterables.hasOwnProperty(classof(it)) ? entries$1 : own;
    };

    var entries = entries_1;

    // Unique ID creation requires a high quality random # generator. In the browser we therefore
    // require the crypto API and do not support built-in fallback to lower quality random number
    // generators (like Math.random()).
    var getRandomValues;
    var rnds8 = new Uint8Array(16);
    function rng() {
        // lazy load so that environments that need to polyfill have a chance to do so
        if (!getRandomValues) {
            // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
            // find the complete implementation of crypto (msCrypto) on IE11.
            getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

            if (!getRandomValues) {
                throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
            }
        }

        return getRandomValues(rnds8);
    }

    var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

    function validate(uuid) {
        return typeof uuid === 'string' && REGEX.test(uuid);
    }

    /**
     * Convert array of 16 byte values to UUID string format of the form:
     * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
     */

    var byteToHex = [];

    for (var i = 0; i < 256; ++i) {
        byteToHex.push((i + 0x100).toString(16).substr(1));
    }

    function stringify(arr) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0; // Note: Be careful editing this code!  It's been tuned for performance
        // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434

        var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
        // of the following:
        // - One or more input array values don't map to a hex octet (leading to
        // "undefined" in the uuid)
        // - Invalid input values for the RFC `version` or `variant` fields

        if (!validate(uuid)) {
            throw TypeError('Stringified UUID is invalid');
        }

        return uuid;
    }

    function v4(options, buf, offset) {
        options = options || {};
        var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

        rnds[6] = rnds[6] & 0x0f | 0x40;
        rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

        if (buf) {
            offset = offset || 0;

            for (var i = 0; i < 16; ++i) {
                buf[offset + i] = rnds[i];
            }

            return buf;
        }

        return stringify(rnds);
    }

    function ownKeys$4(object, enumerableOnly) { var keys = keys$3(object); if (getOwnPropertySymbols) { var symbols = getOwnPropertySymbols(object); if (enumerableOnly) symbols = filter(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$2(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

    function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context32; forEach$2(_context32 = ownKeys$4(Object(source), true)).call(_context32, function (key) { _defineProperty(target, key, source[key]); }); } else if (getOwnPropertyDescriptors) { defineProperties(target, getOwnPropertyDescriptors(source)); } else { var _context33; forEach$2(_context33 = ownKeys$4(Object(source))).call(_context33, function (key) { defineProperty$4(target, key, getOwnPropertyDescriptor$2(source, key)); }); } } return target; }

    function _createSuper$t(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$t(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$t() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

    function _createForOfIteratorHelper$7(o, allowArrayLike) { var it; if (typeof symbol === "undefined" || getIteratorMethod(o) == null) { if (isArray(o) || (it = _unsupportedIterableToArray$7(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

    function _unsupportedIterableToArray$7(o, minLen) { var _context31; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$7(o, minLen); var n = slice$1(_context31 = Object.prototype.toString.call(o)).call(_context31, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return from$2(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen); }

    function _arrayLikeToArray$7(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
    /**
     * Create new data pipe.
     *
     * @param from - The source data set or data view.
     *
     * @remarks
     * Example usage:
     * ```typescript
     * interface AppItem {
     *   whoami: string;
     *   appData: unknown;
     *   visData: VisItem;
     * }
     * interface VisItem {
     *   id: number;
     *   label: string;
     *   color: string;
     *   x: number;
     *   y: number;
     * }
     *
     * const ds1 = new DataSet<AppItem, "whoami">([], { fieldId: "whoami" });
     * const ds2 = new DataSet<VisItem, "id">();
     *
     * const pipe = createNewDataPipeFrom(ds1)
     *   .filter((item): boolean => item.enabled === true)
     *   .map<VisItem, "id">((item): VisItem => item.visData)
     *   .to(ds2);
     *
     * pipe.start();
     * ```
     *
     * @returns A factory whose methods can be used to configure the pipe.
     */

    function createNewDataPipeFrom(from) {
        return new DataPipeUnderConstruction(from);
    }
    /**
     * Internal implementation of the pipe. This should be accessible only through
     * `createNewDataPipeFrom` from the outside.
     *
     * @typeParam SI - Source item type.
     * @typeParam SP - Source item type's id property name.
     * @typeParam TI - Target item type.
     * @typeParam TP - Target item type's id property name.
     */


    var SimpleDataPipe = /*#__PURE__*/function () {
        /**
         * Create a new data pipe.
         *
         * @param _source - The data set or data view that will be observed.
         * @param _transformers - An array of transforming functions to be used to
         * filter or transform the items in the pipe.
         * @param _target - The data set or data view that will receive the items.
         */
        function SimpleDataPipe(_source, _transformers, _target) {
            var _context, _context2, _context3;

            _classCallCheck(this, SimpleDataPipe);

            this._source = _source;
            this._transformers = _transformers;
            this._target = _target;
            /**
             * Bound listeners for use with `DataInterface['on' | 'off']`.
             */

            this._listeners = {
                add: bind(_context = this._add).call(_context, this),
                remove: bind(_context2 = this._remove).call(_context2, this),
                update: bind(_context3 = this._update).call(_context3, this)
            };
        }
        /** @inheritDoc */


        _createClass(SimpleDataPipe, [{
            key: "all",
            value: function all() {
                this._target.update(this._transformItems(this._source.get()));

                return this;
            }
            /** @inheritDoc */

        }, {
            key: "start",
            value: function start() {
                this._source.on("add", this._listeners.add);

                this._source.on("remove", this._listeners.remove);

                this._source.on("update", this._listeners.update);

                return this;
            }
            /** @inheritDoc */

        }, {
            key: "stop",
            value: function stop() {
                this._source.off("add", this._listeners.add);

                this._source.off("remove", this._listeners.remove);

                this._source.off("update", this._listeners.update);

                return this;
            }
            /**
             * Apply the transformers to the items.
             *
             * @param items - The items to be transformed.
             *
             * @returns The transformed items.
             */

        }, {
            key: "_transformItems",
            value: function _transformItems(items) {
                var _context4;

                return reduce(_context4 = this._transformers).call(_context4, function (items, transform) {
                    return transform(items);
                }, items);
            }
            /**
             * Handle an add event.
             *
             * @param _name - Ignored.
             * @param payload - The payload containing the ids of the added items.
             */

        }, {
            key: "_add",
            value: function _add(_name, payload) {
                if (payload == null) {
                    return;
                }

                this._target.add(this._transformItems(this._source.get(payload.items)));
            }
            /**
             * Handle an update event.
             *
             * @param _name - Ignored.
             * @param payload - The payload containing the ids of the updated items.
             */

        }, {
            key: "_update",
            value: function _update(_name, payload) {
                if (payload == null) {
                    return;
                }

                this._target.update(this._transformItems(this._source.get(payload.items)));
            }
            /**
             * Handle a remove event.
             *
             * @param _name - Ignored.
             * @param payload - The payload containing the data of the removed items.
             */

        }, {
            key: "_remove",
            value: function _remove(_name, payload) {
                if (payload == null) {
                    return;
                }

                this._target.remove(this._transformItems(payload.oldData));
            }
        }]);

        return SimpleDataPipe;
    }();
    /**
     * Internal implementation of the pipe factory. This should be accessible
     * only through `createNewDataPipeFrom` from the outside.
     *
     * @typeParam TI - Target item type.
     * @typeParam TP - Target item type's id property name.
     */


    var DataPipeUnderConstruction = /*#__PURE__*/function () {
        /**
         * Create a new data pipe factory. This is an internal constructor that
         * should never be called from outside of this file.
         *
         * @param _source - The source data set or data view for this pipe.
         */
        function DataPipeUnderConstruction(_source) {
            _classCallCheck(this, DataPipeUnderConstruction);

            this._source = _source;
            /**
             * Array transformers used to transform items within the pipe. This is typed
             * as any for the sake of simplicity.
             */

            this._transformers = [];
        }
        /**
         * Filter the items.
         *
         * @param callback - A filtering function that returns true if given item
         * should be piped and false if not.
         *
         * @returns This factory for further configuration.
         */


        _createClass(DataPipeUnderConstruction, [{
            key: "filter",
            value: function filter$1(callback) {
                this._transformers.push(function (input) {
                    return filter(input).call(input, callback);
                });

                return this;
            }
            /**
             * Map each source item to a new type.
             *
             * @param callback - A mapping function that takes a source item and returns
             * corresponding mapped item.
             *
             * @typeParam TI - Target item type.
             * @typeParam TP - Target item type's id property name.
             *
             * @returns This factory for further configuration.
             */

        }, {
            key: "map",
            value: function map(callback) {
                this._transformers.push(function (input) {
                    return map$3(input).call(input, callback);
                });

                return this;
            }
            /**
             * Map each source item to zero or more items of a new type.
             *
             * @param callback - A mapping function that takes a source item and returns
             * an array of corresponding mapped items.
             *
             * @typeParam TI - Target item type.
             * @typeParam TP - Target item type's id property name.
             *
             * @returns This factory for further configuration.
             */

        }, {
            key: "flatMap",
            value: function flatMap$1(callback) {
                this._transformers.push(function (input) {
                    return flatMap(input).call(input, callback);
                });

                return this;
            }
            /**
             * Connect this pipe to given data set.
             *
             * @param target - The data set that will receive the items from this pipe.
             *
             * @returns The pipe connected between given data sets and performing
             * configured transformation on the processed items.
             */

        }, {
            key: "to",
            value: function to(target) {
                return new SimpleDataPipe(this._source, this._transformers, target);
            }
        }]);

        return DataPipeUnderConstruction;
    }();
    /**
     * Determine whether a value can be used as an id.
     *
     * @param value - Input value of unknown type.
     *
     * @returns True if the value is valid id, false otherwise.
     */


    function isId(value) {
        return typeof value === "string" || typeof value === "number";
    }
    /**
     * A queue.
     *
     * @typeParam T - The type of method names to be replaced by queued versions.
     */


    var Queue = /*#__PURE__*/function () {
        /**
         * Construct a new Queue.
         *
         * @param options - Queue configuration.
         */
        function Queue(options) {
            _classCallCheck(this, Queue);

            this._queue = [];
            this._timeout = null;
            this._extended = null; // options

            this.delay = null;
            this.max = Infinity;
            this.setOptions(options);
        }
        /**
         * Update the configuration of the queue.
         *
         * @param options - Queue configuration.
         */


        _createClass(Queue, [{
            key: "setOptions",
            value: function setOptions(options) {
                if (options && typeof options.delay !== "undefined") {
                    this.delay = options.delay;
                }

                if (options && typeof options.max !== "undefined") {
                    this.max = options.max;
                }

                this._flushIfNeeded();
            }
            /**
             * Extend an object with queuing functionality.
             * The object will be extended with a function flush, and the methods provided in options.replace will be replaced with queued ones.
             *
             * @param object - The object to be extended.
             * @param options - Additional options.
             *
             * @returns The created queue.
             */

        }, {
            key: "destroy",
            value:
                /**
                 * Destroy the queue. The queue will first flush all queued actions, and in case it has extended an object, will restore the original object.
                 */
                function destroy() {
                    this.flush();

                    if (this._extended) {
                        var object = this._extended.object;
                        var methods = this._extended.methods;

                        for (var i = 0; i < methods.length; i++) {
                            var method = methods[i];

                            if (method.original) {
                                // @TODO: better solution?
                                object[method.name] = method.original;
                            } else {
                                // @TODO: better solution?
                                delete object[method.name];
                            }
                        }

                        this._extended = null;
                    }
                }
            /**
             * Replace a method on an object with a queued version.
             *
             * @param object - Object having the method.
             * @param method - The method name.
             */

        }, {
            key: "replace",
            value: function replace(object, method) {
                /* eslint-disable-next-line @typescript-eslint/no-this-alias -- Function this is necessary in the function bellow, so class this has to be saved into a variable here. */
                var me = this;
                var original = object[method];

                if (!original) {
                    throw new Error("Method " + method + " undefined");
                }

                object[method] = function () {
                    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    // add this call to the queue
                    me.queue({
                        args: args,
                        fn: original,
                        context: this
                    });
                };
            }
            /**
             * Queue a call.
             *
             * @param entry - The function or entry to be queued.
             */

        }, {
            key: "queue",
            value: function queue(entry) {
                if (typeof entry === "function") {
                    this._queue.push({
                        fn: entry
                    });
                } else {
                    this._queue.push(entry);
                }

                this._flushIfNeeded();
            }
            /**
             * Check whether the queue needs to be flushed.
             */

        }, {
            key: "_flushIfNeeded",
            value: function _flushIfNeeded() {
                var _this = this;

                // flush when the maximum is exceeded.
                if (this._queue.length > this.max) {
                    this.flush();
                } // flush after a period of inactivity when a delay is configured


                if (this._timeout != null) {
                    clearTimeout(this._timeout);
                    this._timeout = null;
                }

                if (this.queue.length > 0 && typeof this.delay === "number") {
                    this._timeout = setTimeout$1(function () {
                        _this.flush();
                    }, this.delay);
                }
            }
            /**
             * Flush all queued calls
             */

        }, {
            key: "flush",
            value: function flush() {
                var _context5, _context6;

                forEach$2(_context5 = splice(_context6 = this._queue).call(_context6, 0)).call(_context5, function (entry) {
                    entry.fn.apply(entry.context || entry.fn, entry.args || []);
                });
            }
        }], [{
            key: "extend",
            value: function extend(object, options) {
                var queue = new Queue(options);

                if (object.flush !== undefined) {
                    throw new Error("Target object already has a property flush");
                }

                object.flush = function () {
                    queue.flush();
                };

                var methods = [{
                    name: "flush",
                    original: undefined
                }];

                if (options && options.replace) {
                    for (var i = 0; i < options.replace.length; i++) {
                        var name = options.replace[i];
                        methods.push({
                            name: name,
                            // @TODO: better solution?
                            original: object[name]
                        }); // @TODO: better solution?

                        queue.replace(object, name);
                    }
                }

                queue._extended = {
                    object: object,
                    methods: methods
                };
                return queue;
            }
        }]);

        return Queue;
    }();
    /**
     * [[DataSet]] code that can be reused in [[DataView]] or other similar implementations of [[DataInterface]].
     *
     * @typeParam Item - Item type that may or may not have an id.
     * @typeParam IdProp - Name of the property that contains the id.
     */


    var DataSetPart = /*#__PURE__*/function () {
        function DataSetPart() {
            _classCallCheck(this, DataSetPart);

            this._subscribers = {
                "*": [],
                add: [],
                remove: [],
                update: []
            };
            /**
             * @deprecated Use on instead (PS: DataView.subscribe === DataView.on).
             */

            this.subscribe = DataSetPart.prototype.on;
            /**
             * @deprecated Use off instead (PS: DataView.unsubscribe === DataView.off).
             */

            this.unsubscribe = DataSetPart.prototype.off;
        }
        /**
         * Trigger an event
         *
         * @param event - Event name.
         * @param payload - Event payload.
         * @param senderId - Id of the sender.
         */


        _createClass(DataSetPart, [{
            key: "_trigger",
            value: function _trigger(event, payload, senderId) {
                var _context7, _context8;

                if (event === "*") {
                    throw new Error("Cannot trigger event *");
                }

                forEach$2(_context7 = concat(_context8 = []).call(_context8, _toConsumableArray(this._subscribers[event]), _toConsumableArray(this._subscribers["*"]))).call(_context7, function (subscriber) {
                    subscriber(event, payload, senderId != null ? senderId : null);
                });
            }
            /**
             * Subscribe to an event, add an event listener.
             *
             * @remarks Non-function callbacks are ignored.
             *
             * @param event - Event name.
             * @param callback - Callback method.
             */

        }, {
            key: "on",
            value: function on(event, callback) {
                if (typeof callback === "function") {
                    this._subscribers[event].push(callback);
                } // @TODO: Maybe throw for invalid callbacks?

            }
            /**
             * Unsubscribe from an event, remove an event listener.
             *
             * @remarks If the same callback was subscribed more than once **all** occurences will be removed.
             *
             * @param event - Event name.
             * @param callback - Callback method.
             */

        }, {
            key: "off",
            value: function off(event, callback) {
                var _context9;

                this._subscribers[event] = filter(_context9 = this._subscribers[event]).call(_context9, function (subscriber) {
                    return subscriber !== callback;
                });
            }
        }]);

        return DataSetPart;
    }();
    /**
     * Data stream
     *
     * @remarks
     * [[DataStream]] offers an always up to date stream of items from a [[DataSet]] or [[DataView]].
     * That means that the stream is evaluated at the time of iteration, conversion to another data type or when [[cache]] is called, not when the [[DataStream]] was created.
     * Multiple invocations of for example [[toItemArray]] may yield different results (if the data source like for example [[DataSet]] gets modified).
     *
     * @typeParam Item - The item type this stream is going to work with.
     */


    var DataStream = /*#__PURE__*/function () {
        /**
         * Create a new data stream.
         *
         * @param pairs - The id, item pairs.
         */
        function DataStream(pairs) {
            _classCallCheck(this, DataStream);

            this._pairs = pairs;
        }
        /**
         * Return an iterable of key, value pairs for every entry in the stream.
         */


        _createClass(DataStream, [{
            key: iterator,
            value:
            /*#__PURE__*/
                regenerator.mark(function value() {
                    var _iterator, _step, _step$value, id, item;

                    return regenerator.wrap(function value$(_context10) {
                        while (1) {
                            switch (_context10.prev = _context10.next) {
                                case 0:
                                    _iterator = _createForOfIteratorHelper$7(this._pairs);
                                    _context10.prev = 1;

                                    _iterator.s();

                                case 3:
                                    if ((_step = _iterator.n()).done) {
                                        _context10.next = 9;
                                        break;
                                    }

                                    _step$value = _slicedToArray(_step.value, 2), id = _step$value[0], item = _step$value[1];
                                    _context10.next = 7;
                                    return [id, item];

                                case 7:
                                    _context10.next = 3;
                                    break;

                                case 9:
                                    _context10.next = 14;
                                    break;

                                case 11:
                                    _context10.prev = 11;
                                    _context10.t0 = _context10["catch"](1);

                                    _iterator.e(_context10.t0);

                                case 14:
                                    _context10.prev = 14;

                                    _iterator.f();

                                    return _context10.finish(14);

                                case 17:
                                case "end":
                                    return _context10.stop();
                            }
                        }
                    }, value, this, [[1, 11, 14, 17]]);
                })
            /**
             * Return an iterable of key, value pairs for every entry in the stream.
             */

        }, {
            key: "entries",
            value:
            /*#__PURE__*/
                regenerator.mark(function entries() {
                    var _iterator2, _step2, _step2$value, id, item;

                    return regenerator.wrap(function entries$(_context11) {
                        while (1) {
                            switch (_context11.prev = _context11.next) {
                                case 0:
                                    _iterator2 = _createForOfIteratorHelper$7(this._pairs);
                                    _context11.prev = 1;

                                    _iterator2.s();

                                case 3:
                                    if ((_step2 = _iterator2.n()).done) {
                                        _context11.next = 9;
                                        break;
                                    }

                                    _step2$value = _slicedToArray(_step2.value, 2), id = _step2$value[0], item = _step2$value[1];
                                    _context11.next = 7;
                                    return [id, item];

                                case 7:
                                    _context11.next = 3;
                                    break;

                                case 9:
                                    _context11.next = 14;
                                    break;

                                case 11:
                                    _context11.prev = 11;
                                    _context11.t0 = _context11["catch"](1);

                                    _iterator2.e(_context11.t0);

                                case 14:
                                    _context11.prev = 14;

                                    _iterator2.f();

                                    return _context11.finish(14);

                                case 17:
                                case "end":
                                    return _context11.stop();
                            }
                        }
                    }, entries, this, [[1, 11, 14, 17]]);
                })
            /**
             * Return an iterable of keys in the stream.
             */

        }, {
            key: "keys",
            value:
            /*#__PURE__*/
                regenerator.mark(function keys() {
                    var _iterator3, _step3, _step3$value, id;

                    return regenerator.wrap(function keys$(_context12) {
                        while (1) {
                            switch (_context12.prev = _context12.next) {
                                case 0:
                                    _iterator3 = _createForOfIteratorHelper$7(this._pairs);
                                    _context12.prev = 1;

                                    _iterator3.s();

                                case 3:
                                    if ((_step3 = _iterator3.n()).done) {
                                        _context12.next = 9;
                                        break;
                                    }

                                    _step3$value = _slicedToArray(_step3.value, 1), id = _step3$value[0];
                                    _context12.next = 7;
                                    return id;

                                case 7:
                                    _context12.next = 3;
                                    break;

                                case 9:
                                    _context12.next = 14;
                                    break;

                                case 11:
                                    _context12.prev = 11;
                                    _context12.t0 = _context12["catch"](1);

                                    _iterator3.e(_context12.t0);

                                case 14:
                                    _context12.prev = 14;

                                    _iterator3.f();

                                    return _context12.finish(14);

                                case 17:
                                case "end":
                                    return _context12.stop();
                            }
                        }
                    }, keys, this, [[1, 11, 14, 17]]);
                })
            /**
             * Return an iterable of values in the stream.
             */

        }, {
            key: "values",
            value:
            /*#__PURE__*/
                regenerator.mark(function values() {
                    var _iterator4, _step4, _step4$value, item;

                    return regenerator.wrap(function values$(_context13) {
                        while (1) {
                            switch (_context13.prev = _context13.next) {
                                case 0:
                                    _iterator4 = _createForOfIteratorHelper$7(this._pairs);
                                    _context13.prev = 1;

                                    _iterator4.s();

                                case 3:
                                    if ((_step4 = _iterator4.n()).done) {
                                        _context13.next = 9;
                                        break;
                                    }

                                    _step4$value = _slicedToArray(_step4.value, 2), item = _step4$value[1];
                                    _context13.next = 7;
                                    return item;

                                case 7:
                                    _context13.next = 3;
                                    break;

                                case 9:
                                    _context13.next = 14;
                                    break;

                                case 11:
                                    _context13.prev = 11;
                                    _context13.t0 = _context13["catch"](1);

                                    _iterator4.e(_context13.t0);

                                case 14:
                                    _context13.prev = 14;

                                    _iterator4.f();

                                    return _context13.finish(14);

                                case 17:
                                case "end":
                                    return _context13.stop();
                            }
                        }
                    }, values, this, [[1, 11, 14, 17]]);
                })
            /**
             * Return an array containing all the ids in this stream.
             *
             * @remarks
             * The array may contain duplicities.
             *
             * @returns The array with all ids from this stream.
             */

        }, {
            key: "toIdArray",
            value: function toIdArray() {
                var _context14;

                return map$3(_context14 = _toConsumableArray(this._pairs)).call(_context14, function (pair) {
                    return pair[0];
                });
            }
            /**
             * Return an array containing all the items in this stream.
             *
             * @remarks
             * The array may contain duplicities.
             *
             * @returns The array with all items from this stream.
             */

        }, {
            key: "toItemArray",
            value: function toItemArray() {
                var _context15;

                return map$3(_context15 = _toConsumableArray(this._pairs)).call(_context15, function (pair) {
                    return pair[1];
                });
            }
            /**
             * Return an array containing all the entries in this stream.
             *
             * @remarks
             * The array may contain duplicities.
             *
             * @returns The array with all entries from this stream.
             */

        }, {
            key: "toEntryArray",
            value: function toEntryArray() {
                return _toConsumableArray(this._pairs);
            }
            /**
             * Return an object map containing all the items in this stream accessible by ids.
             *
             * @remarks
             * In case of duplicate ids (coerced to string so `7 == '7'`) the last encoutered appears in the returned object.
             *
             * @returns The object map of all id → item pairs from this stream.
             */

        }, {
            key: "toObjectMap",
            value: function toObjectMap() {
                var map = create$2(null);

                var _iterator5 = _createForOfIteratorHelper$7(this._pairs),
                    _step5;

                try {
                    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                        var _step5$value = _slicedToArray(_step5.value, 2),
                            id = _step5$value[0],
                            item = _step5$value[1];

                        map[id] = item;
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally {
                    _iterator5.f();
                }

                return map;
            }
            /**
             * Return a map containing all the items in this stream accessible by ids.
             *
             * @returns The map of all id → item pairs from this stream.
             */

        }, {
            key: "toMap",
            value: function toMap() {
                return new map(this._pairs);
            }
            /**
             * Return a set containing all the (unique) ids in this stream.
             *
             * @returns The set of all ids from this stream.
             */

        }, {
            key: "toIdSet",
            value: function toIdSet() {
                return new set(this.toIdArray());
            }
            /**
             * Return a set containing all the (unique) items in this stream.
             *
             * @returns The set of all items from this stream.
             */

        }, {
            key: "toItemSet",
            value: function toItemSet() {
                return new set(this.toItemArray());
            }
            /**
             * Cache the items from this stream.
             *
             * @remarks
             * This method allows for items to be fetched immediatelly and used (possibly multiple times) later.
             * It can also be used to optimize performance as [[DataStream]] would otherwise reevaluate everything upon each iteration.
             *
             * ## Example
             * ```javascript
             * const ds = new DataSet([…])
             *
             * const cachedStream = ds.stream()
             *   .filter(…)
             *   .sort(…)
             *   .map(…)
             *   .cached(…) // Data are fetched, processed and cached here.
             *
             * ds.clear()
             * chachedStream // Still has all the items.
             * ```
             *
             * @returns A new [[DataStream]] with cached items (detached from the original [[DataSet]]).
             */

        }, {
            key: "cache",
            value: function cache() {
                return new DataStream(_toConsumableArray(this._pairs));
            }
            /**
             * Get the distinct values of given property.
             *
             * @param callback - The function that picks and possibly converts the property.
             *
             * @typeParam T - The type of the distinct value.
             *
             * @returns A set of all distinct properties.
             */

        }, {
            key: "distinct",
            value: function distinct(callback) {
                var set$1 = new set();

                var _iterator6 = _createForOfIteratorHelper$7(this._pairs),
                    _step6;

                try {
                    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                        var _step6$value = _slicedToArray(_step6.value, 2),
                            id = _step6$value[0],
                            item = _step6$value[1];

                        set$1.add(callback(item, id));
                    }
                } catch (err) {
                    _iterator6.e(err);
                } finally {
                    _iterator6.f();
                }

                return set$1;
            }
            /**
             * Filter the items of the stream.
             *
             * @param callback - The function that decides whether an item will be included.
             *
             * @returns A new data stream with the filtered items.
             */

        }, {
            key: "filter",
            value: function filter(callback) {
                var pairs = this._pairs;
                return new DataStream(_defineProperty({}, iterator, /*#__PURE__*/regenerator.mark(function _callee() {
                    var _iterator7, _step7, _step7$value, id, item;

                    return regenerator.wrap(function _callee$(_context16) {
                        while (1) {
                            switch (_context16.prev = _context16.next) {
                                case 0:
                                    _iterator7 = _createForOfIteratorHelper$7(pairs);
                                    _context16.prev = 1;

                                    _iterator7.s();

                                case 3:
                                    if ((_step7 = _iterator7.n()).done) {
                                        _context16.next = 10;
                                        break;
                                    }

                                    _step7$value = _slicedToArray(_step7.value, 2), id = _step7$value[0], item = _step7$value[1];

                                    if (!callback(item, id)) {
                                        _context16.next = 8;
                                        break;
                                    }

                                    _context16.next = 8;
                                    return [id, item];

                                case 8:
                                    _context16.next = 3;
                                    break;

                                case 10:
                                    _context16.next = 15;
                                    break;

                                case 12:
                                    _context16.prev = 12;
                                    _context16.t0 = _context16["catch"](1);

                                    _iterator7.e(_context16.t0);

                                case 15:
                                    _context16.prev = 15;

                                    _iterator7.f();

                                    return _context16.finish(15);

                                case 18:
                                case "end":
                                    return _context16.stop();
                            }
                        }
                    }, _callee, null, [[1, 12, 15, 18]]);
                })));
            }
            /**
             * Execute a callback for each item of the stream.
             *
             * @param callback - The function that will be invoked for each item.
             */

        }, {
            key: "forEach",
            value: function forEach(callback) {
                var _iterator8 = _createForOfIteratorHelper$7(this._pairs),
                    _step8;

                try {
                    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                        var _step8$value = _slicedToArray(_step8.value, 2),
                            id = _step8$value[0],
                            item = _step8$value[1];

                        callback(item, id);
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally {
                    _iterator8.f();
                }
            }
            /**
             * Map the items into a different type.
             *
             * @param callback - The function that does the conversion.
             *
             * @typeParam Mapped - The type of the item after mapping.
             *
             * @returns A new data stream with the mapped items.
             */

        }, {
            key: "map",
            value: function map(callback) {
                var pairs = this._pairs;
                return new DataStream(_defineProperty({}, iterator, /*#__PURE__*/regenerator.mark(function _callee2() {
                    var _iterator9, _step9, _step9$value, id, item;

                    return regenerator.wrap(function _callee2$(_context17) {
                        while (1) {
                            switch (_context17.prev = _context17.next) {
                                case 0:
                                    _iterator9 = _createForOfIteratorHelper$7(pairs);
                                    _context17.prev = 1;

                                    _iterator9.s();

                                case 3:
                                    if ((_step9 = _iterator9.n()).done) {
                                        _context17.next = 9;
                                        break;
                                    }

                                    _step9$value = _slicedToArray(_step9.value, 2), id = _step9$value[0], item = _step9$value[1];
                                    _context17.next = 7;
                                    return [id, callback(item, id)];

                                case 7:
                                    _context17.next = 3;
                                    break;

                                case 9:
                                    _context17.next = 14;
                                    break;

                                case 11:
                                    _context17.prev = 11;
                                    _context17.t0 = _context17["catch"](1);

                                    _iterator9.e(_context17.t0);

                                case 14:
                                    _context17.prev = 14;

                                    _iterator9.f();

                                    return _context17.finish(14);

                                case 17:
                                case "end":
                                    return _context17.stop();
                            }
                        }
                    }, _callee2, null, [[1, 11, 14, 17]]);
                })));
            }
            /**
             * Get the item with the maximum value of given property.
             *
             * @param callback - The function that picks and possibly converts the property.
             *
             * @returns The item with the maximum if found otherwise null.
             */

        }, {
            key: "max",
            value: function max(callback) {
                var iter = getIterator(this._pairs);

                var curr = iter.next();

                if (curr.done) {
                    return null;
                }

                var maxItem = curr.value[1];
                var maxValue = callback(curr.value[1], curr.value[0]);

                while (!(curr = iter.next()).done) {
                    var _curr$value = _slicedToArray(curr.value, 2),
                        id = _curr$value[0],
                        item = _curr$value[1];

                    var _value = callback(item, id);

                    if (_value > maxValue) {
                        maxValue = _value;
                        maxItem = item;
                    }
                }

                return maxItem;
            }
            /**
             * Get the item with the minimum value of given property.
             *
             * @param callback - The function that picks and possibly converts the property.
             *
             * @returns The item with the minimum if found otherwise null.
             */

        }, {
            key: "min",
            value: function min(callback) {
                var iter = getIterator(this._pairs);

                var curr = iter.next();

                if (curr.done) {
                    return null;
                }

                var minItem = curr.value[1];
                var minValue = callback(curr.value[1], curr.value[0]);

                while (!(curr = iter.next()).done) {
                    var _curr$value2 = _slicedToArray(curr.value, 2),
                        id = _curr$value2[0],
                        item = _curr$value2[1];

                    var _value2 = callback(item, id);

                    if (_value2 < minValue) {
                        minValue = _value2;
                        minItem = item;
                    }
                }

                return minItem;
            }
            /**
             * Reduce the items into a single value.
             *
             * @param callback - The function that does the reduction.
             * @param accumulator - The initial value of the accumulator.
             *
             * @typeParam T - The type of the accumulated value.
             *
             * @returns The reduced value.
             */

        }, {
            key: "reduce",
            value: function reduce(callback, accumulator) {
                var _iterator10 = _createForOfIteratorHelper$7(this._pairs),
                    _step10;

                try {
                    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                        var _step10$value = _slicedToArray(_step10.value, 2),
                            id = _step10$value[0],
                            item = _step10$value[1];

                        accumulator = callback(accumulator, item, id);
                    }
                } catch (err) {
                    _iterator10.e(err);
                } finally {
                    _iterator10.f();
                }

                return accumulator;
            }
            /**
             * Sort the items.
             *
             * @param callback - Item comparator.
             *
             * @returns A new stream with sorted items.
             */

        }, {
            key: "sort",
            value: function sort$1(callback) {
                var _this2 = this;

                return new DataStream(_defineProperty({}, iterator, function () {
                    var _context18;

                    return getIterator(sort(_context18 = _toConsumableArray(_this2._pairs)).call(_context18, function (_ref, _ref2) {
                        var _ref3 = _slicedToArray(_ref, 2),
                            idA = _ref3[0],
                            itemA = _ref3[1];

                        var _ref4 = _slicedToArray(_ref2, 2),
                            idB = _ref4[0],
                            itemB = _ref4[1];

                        return callback(itemA, itemB, idA, idB);
                    }));
                }));
            }
        }]);

        return DataStream;
    }();
    /**
     * Add an id to given item if it doesn't have one already.
     *
     * @remarks
     * The item will be modified.
     *
     * @param item - The item that will have an id after a call to this function.
     * @param idProp - The key of the id property.
     *
     * @typeParam Item - Item type that may or may not have an id.
     * @typeParam IdProp - Name of the property that contains the id.
     *
     * @returns true
     */


    function ensureFullItem(item, idProp) {
        if (item[idProp] == null) {
            // generate an id
            item[idProp] = v4();
        }

        return item;
    }
    /**
     * # DataSet
     *
     * Vis.js comes with a flexible DataSet, which can be used to hold and
     * manipulate unstructured data and listen for changes in the data. The DataSet
     * is key/value based. Data items can be added, updated and removed from the
     * DataSet, and one can subscribe to changes in the DataSet. The data in the
     * DataSet can be filtered and ordered. Data can be normalized when appending it
     * to the DataSet as well.
     *
     * ## Example
     *
     * The following example shows how to use a DataSet.
     *
     * ```javascript
     * // create a DataSet
     * var options = {};
     * var data = new vis.DataSet(options);
     *
     * // add items
     * // note that the data items can contain different properties and data formats
     * data.add([
     *   {id: 1, text: 'item 1', date: new Date(2013, 6, 20), group: 1, first: true},
     *   {id: 2, text: 'item 2', date: '2013-06-23', group: 2},
     *   {id: 3, text: 'item 3', date: '2013-06-25', group: 2},
     *   {id: 4, text: 'item 4'}
     * ]);
     *
     * // subscribe to any change in the DataSet
     * data.on('*', function (event, properties, senderId) {
     *   console.log('event', event, properties);
     * });
     *
     * // update an existing item
     * data.update({id: 2, group: 1});
     *
     * // remove an item
     * data.remove(4);
     *
     * // get all ids
     * var ids = data.getIds();
     * console.log('ids', ids);
     *
     * // get a specific item
     * var item1 = data.get(1);
     * console.log('item1', item1);
     *
     * // retrieve a filtered subset of the data
     * var items = data.get({
     *   filter: function (item) {
     *     return item.group == 1;
     *   }
     * });
     * console.log('filtered items', items);
     * ```
     *
     * @typeParam Item - Item type that may or may not have an id.
     * @typeParam IdProp - Name of the property that contains the id.
     */


    var DataSet = /*#__PURE__*/function (_DataSetPart) {
        _inherits(DataSet, _DataSetPart);

        var _super = _createSuper$t(DataSet);

        /**
         * Construct a new DataSet.
         *
         * @param data - Initial data or options.
         * @param options - Options (type error if data is also options).
         */
        function DataSet(data, options) {
            var _this3;

            _classCallCheck(this, DataSet);

            _this3 = _super.call(this);
            _this3._queue = null; // correctly read optional arguments

            if (data && !isArray(data)) {
                options = data;
                data = [];
            }

            _this3._options = options || {};
            _this3._data = new map(); // map with data indexed by id

            _this3.length = 0; // number of items in the DataSet

            _this3._idProp = _this3._options.fieldId || "id"; // name of the field containing id
            // add initial data when provided

            if (data && data.length) {
                _this3.add(data);
            }

            _this3.setOptions(options);

            return _this3;
        }
        /** @inheritDoc */


        _createClass(DataSet, [{
            key: "idProp",
            get: function get() {
                return this._idProp;
            }
            /**
             * Set new options.
             *
             * @param options - The new options.
             */

        }, {
            key: "setOptions",
            value: function setOptions(options) {
                if (options && options.queue !== undefined) {
                    if (options.queue === false) {
                        // delete queue if loaded
                        if (this._queue) {
                            this._queue.destroy();

                            this._queue = null;
                        }
                    } else {
                        // create queue and update its options
                        if (!this._queue) {
                            this._queue = Queue.extend(this, {
                                replace: ["add", "update", "remove"]
                            });
                        }

                        if (options.queue && _typeof(options.queue) === "object") {
                            this._queue.setOptions(options.queue);
                        }
                    }
                }
            }
            /**
             * Add a data item or an array with items.
             *
             * After the items are added to the DataSet, the DataSet will trigger an event `add`. When a `senderId` is provided, this id will be passed with the triggered event to all subscribers.
             *
             * ## Example
             *
             * ```javascript
             * // create a DataSet
             * const data = new vis.DataSet()
             *
             * // add items
             * const ids = data.add([
             *   { id: 1, text: 'item 1' },
             *   { id: 2, text: 'item 2' },
             *   { text: 'item without an id' }
             * ])
             *
             * console.log(ids) // [1, 2, '<UUIDv4>']
             * ```
             *
             * @param data - Items to be added (ids will be generated if missing).
             * @param senderId - Sender id.
             *
             * @returns addedIds - Array with the ids (generated if not present) of the added items.
             *
             * @throws When an item with the same id as any of the added items already exists.
             */

        }, {
            key: "add",
            value: function add(data, senderId) {
                var _this4 = this;

                var addedIds = [];
                var id;

                if (isArray(data)) {
                    // Array
                    var idsToAdd = map$3(data).call(data, function (d) {
                        return d[_this4._idProp];
                    });

                    if (some(idsToAdd).call(idsToAdd, function (id) {
                        return _this4._data.has(id);
                    })) {
                        throw new Error("A duplicate id was found in the parameter array.");
                    }

                    for (var i = 0, len = data.length; i < len; i++) {
                        id = this._addItem(data[i]);
                        addedIds.push(id);
                    }
                } else if (data && _typeof(data) === "object") {
                    // Single item
                    id = this._addItem(data);
                    addedIds.push(id);
                } else {
                    throw new Error("Unknown dataType");
                }

                if (addedIds.length) {
                    this._trigger("add", {
                        items: addedIds
                    }, senderId);
                }

                return addedIds;
            }
            /**
             * Update existing items. When an item does not exist, it will be created.
             *
             * @remarks
             * The provided properties will be merged in the existing item. When an item does not exist, it will be created.
             *
             * After the items are updated, the DataSet will trigger an event `add` for the added items, and an event `update`. When a `senderId` is provided, this id will be passed with the triggered event to all subscribers.
             *
             * ## Example
             *
             * ```javascript
             * // create a DataSet
             * const data = new vis.DataSet([
             *   { id: 1, text: 'item 1' },
             *   { id: 2, text: 'item 2' },
             *   { id: 3, text: 'item 3' }
             * ])
             *
             * // update items
             * const ids = data.update([
             *   { id: 2, text: 'item 2 (updated)' },
             *   { id: 4, text: 'item 4 (new)' }
             * ])
             *
             * console.log(ids) // [2, 4]
             * ```
             *
             * ## Warning for TypeScript users
             * This method may introduce partial items into the data set. Use add or updateOnly instead for better type safety.
             *
             * @param data - Items to be updated (if the id is already present) or added (if the id is missing).
             * @param senderId - Sender id.
             *
             * @returns updatedIds - The ids of the added (these may be newly generated if there was no id in the item from the data) or updated items.
             *
             * @throws When the supplied data is neither an item nor an array of items.
             */

        }, {
            key: "update",
            value: function update(data, senderId) {
                var _this5 = this;

                var addedIds = [];
                var updatedIds = [];
                var oldData = [];
                var updatedData = [];
                var idProp = this._idProp;

                var addOrUpdate = function addOrUpdate(item) {
                    var origId = item[idProp];

                    if (origId != null && _this5._data.has(origId)) {
                        var fullItem = item; // it has an id, therefore it is a fullitem

                        var oldItem = assign$2({}, _this5._data.get(origId)); // update item


                        var id = _this5._updateItem(fullItem);

                        updatedIds.push(id);
                        updatedData.push(fullItem);
                        oldData.push(oldItem);
                    } else {
                        // add new item
                        var _id = _this5._addItem(item);

                        addedIds.push(_id);
                    }
                };

                if (isArray(data)) {
                    // Array
                    for (var i = 0, len = data.length; i < len; i++) {
                        if (data[i] && _typeof(data[i]) === "object") {
                            addOrUpdate(data[i]);
                        } else {
                            console.warn("Ignoring input item, which is not an object at index " + i);
                        }
                    }
                } else if (data && _typeof(data) === "object") {
                    // Single item
                    addOrUpdate(data);
                } else {
                    throw new Error("Unknown dataType");
                }

                if (addedIds.length) {
                    this._trigger("add", {
                        items: addedIds
                    }, senderId);
                }

                if (updatedIds.length) {
                    var props = {
                        items: updatedIds,
                        oldData: oldData,
                        data: updatedData
                    }; // TODO: remove deprecated property 'data' some day
                    //Object.defineProperty(props, 'data', {
                    //  'get': (function() {
                    //    console.warn('Property data is deprecated. Use DataSet.get(ids) to retrieve the new data, use the oldData property on this object to get the old data');
                    //    return updatedData;
                    //  }).bind(this)
                    //});

                    this._trigger("update", props, senderId);
                }

                return concat(addedIds).call(addedIds, updatedIds);
            }
            /**
             * Update existing items. When an item does not exist, an error will be thrown.
             *
             * @remarks
             * The provided properties will be deeply merged into the existing item.
             * When an item does not exist (id not present in the data set or absent), an error will be thrown and nothing will be changed.
             *
             * After the items are updated, the DataSet will trigger an event `update`.
             * When a `senderId` is provided, this id will be passed with the triggered event to all subscribers.
             *
             * ## Example
             *
             * ```javascript
             * // create a DataSet
             * const data = new vis.DataSet([
             *   { id: 1, text: 'item 1' },
             *   { id: 2, text: 'item 2' },
             *   { id: 3, text: 'item 3' },
             * ])
             *
             * // update items
             * const ids = data.update([
             *   { id: 2, text: 'item 2 (updated)' }, // works
             *   // { id: 4, text: 'item 4 (new)' }, // would throw
             *   // { text: 'item 4 (new)' }, // would also throw
             * ])
             *
             * console.log(ids) // [2]
             * ```
             *
             * @param data - Updates (the id and optionally other props) to the items in this data set.
             * @param senderId - Sender id.
             *
             * @returns updatedIds - The ids of the updated items.
             *
             * @throws When the supplied data is neither an item nor an array of items, when the ids are missing.
             */

        }, {
            key: "updateOnly",
            value: function updateOnly(data, senderId) {
                var _context19,
                    _this6 = this;

                if (!isArray(data)) {
                    data = [data];
                }

                var updateEventData = map$3(_context19 = map$3(data).call(data, function (update) {
                    var oldData = _this6._data.get(update[_this6._idProp]);

                    if (oldData == null) {
                        throw new Error("Updating non-existent items is not allowed.");
                    }

                    return {
                        oldData: oldData,
                        update: update
                    };
                })).call(_context19, function (_ref5) {
                    var oldData = _ref5.oldData,
                        update = _ref5.update;
                    var id = oldData[_this6._idProp];
                    var updatedData = pureDeepObjectAssign(oldData, update);

                    _this6._data.set(id, updatedData);

                    return {
                        id: id,
                        oldData: oldData,
                        updatedData: updatedData
                    };
                });

                if (updateEventData.length) {
                    var props = {
                        items: map$3(updateEventData).call(updateEventData, function (value) {
                            return value.id;
                        }),
                        oldData: map$3(updateEventData).call(updateEventData, function (value) {
                            return value.oldData;
                        }),
                        data: map$3(updateEventData).call(updateEventData, function (value) {
                            return value.updatedData;
                        })
                    }; // TODO: remove deprecated property 'data' some day
                    //Object.defineProperty(props, 'data', {
                    //  'get': (function() {
                    //    console.warn('Property data is deprecated. Use DataSet.get(ids) to retrieve the new data, use the oldData property on this object to get the old data');
                    //    return updatedData;
                    //  }).bind(this)
                    //});

                    this._trigger("update", props, senderId);

                    return props.items;
                } else {
                    return [];
                }
            }
            /** @inheritDoc */

        }, {
            key: "get",
            value: function get(first, second) {
                // @TODO: Woudn't it be better to split this into multiple methods?
                // parse the arguments
                var id = undefined;
                var ids = undefined;
                var options = undefined;

                if (isId(first)) {
                    // get(id [, options])
                    id = first;
                    options = second;
                } else if (isArray(first)) {
                    // get(ids [, options])
                    ids = first;
                    options = second;
                } else {
                    // get([, options])
                    options = first;
                } // determine the return type


                var returnType = options && options.returnType === "Object" ? "Object" : "Array"; // @TODO: WTF is this? Or am I missing something?
                // var returnType
                // if (options && options.returnType) {
                //   var allowedValues = ['Array', 'Object']
                //   returnType =
                //     allowedValues.indexOf(options.returnType) == -1
                //       ? 'Array'
                //       : options.returnType
                // } else {
                //   returnType = 'Array'
                // }
                // build options

                var filter$1 = options && filter(options);

                var items = [];
                var item = undefined;
                var itemIds = undefined;
                var itemId = undefined; // convert items

                if (id != null) {
                    // return a single item
                    item = this._data.get(id);

                    if (item && filter$1 && !filter$1(item)) {
                        item = undefined;
                    }
                } else if (ids != null) {
                    // return a subset of items
                    for (var i = 0, len = ids.length; i < len; i++) {
                        item = this._data.get(ids[i]);

                        if (item != null && (!filter$1 || filter$1(item))) {
                            items.push(item);
                        }
                    }
                } else {
                    var _context20;

                    // return all items
                    itemIds = _toConsumableArray(keys(_context20 = this._data).call(_context20));

                    for (var _i = 0, _len2 = itemIds.length; _i < _len2; _i++) {
                        itemId = itemIds[_i];
                        item = this._data.get(itemId);

                        if (item != null && (!filter$1 || filter$1(item))) {
                            items.push(item);
                        }
                    }
                } // order the results


                if (options && options.order && id == undefined) {
                    this._sort(items, options.order);
                } // filter fields of the items


                if (options && options.fields) {
                    var fields = options.fields;

                    if (id != undefined && item != null) {
                        item = this._filterFields(item, fields);
                    } else {
                        for (var _i2 = 0, _len3 = items.length; _i2 < _len3; _i2++) {
                            items[_i2] = this._filterFields(items[_i2], fields);
                        }
                    }
                } // return the results


                if (returnType == "Object") {
                    var result = {};

                    for (var _i3 = 0, _len4 = items.length; _i3 < _len4; _i3++) {
                        var resultant = items[_i3]; // @TODO: Shoudn't this be this._fieldId?
                        // result[resultant.id] = resultant

                        var _id2 = resultant[this._idProp];
                        result[_id2] = resultant;
                    }

                    return result;
                } else {
                    if (id != null) {
                        var _item;

                        // a single item
                        return (_item = item) !== null && _item !== void 0 ? _item : null;
                    } else {
                        // just return our array
                        return items;
                    }
                }
            }
            /** @inheritDoc */

        }, {
            key: "getIds",
            value: function getIds(options) {
                var data = this._data;

                var filter$1 = options && filter(options);

                var order = options && options.order;

                var itemIds = _toConsumableArray(keys(data).call(data));

                var ids = [];

                if (filter$1) {
                    // get filtered items
                    if (order) {
                        // create ordered list
                        var items = [];

                        for (var i = 0, len = itemIds.length; i < len; i++) {
                            var id = itemIds[i];

                            var item = this._data.get(id);

                            if (item != null && filter$1(item)) {
                                items.push(item);
                            }
                        }

                        this._sort(items, order);

                        for (var _i4 = 0, _len5 = items.length; _i4 < _len5; _i4++) {
                            ids.push(items[_i4][this._idProp]);
                        }
                    } else {
                        // create unordered list
                        for (var _i5 = 0, _len6 = itemIds.length; _i5 < _len6; _i5++) {
                            var _id3 = itemIds[_i5];

                            var _item2 = this._data.get(_id3);

                            if (_item2 != null && filter$1(_item2)) {
                                ids.push(_item2[this._idProp]);
                            }
                        }
                    }
                } else {
                    // get all items
                    if (order) {
                        // create an ordered list
                        var _items = [];

                        for (var _i6 = 0, _len7 = itemIds.length; _i6 < _len7; _i6++) {
                            var _id4 = itemIds[_i6];

                            _items.push(data.get(_id4));
                        }

                        this._sort(_items, order);

                        for (var _i7 = 0, _len8 = _items.length; _i7 < _len8; _i7++) {
                            ids.push(_items[_i7][this._idProp]);
                        }
                    } else {
                        // create unordered list
                        for (var _i8 = 0, _len9 = itemIds.length; _i8 < _len9; _i8++) {
                            var _id5 = itemIds[_i8];

                            var _item3 = data.get(_id5);

                            if (_item3 != null) {
                                ids.push(_item3[this._idProp]);
                            }
                        }
                    }
                }

                return ids;
            }
            /** @inheritDoc */

        }, {
            key: "getDataSet",
            value: function getDataSet() {
                return this;
            }
            /** @inheritDoc */

        }, {
            key: "forEach",
            value: function forEach(callback, options) {
                var filter$1 = options && filter(options);

                var data = this._data;

                var itemIds = _toConsumableArray(keys(data).call(data));

                if (options && options.order) {
                    // execute forEach on ordered list
                    var items = this.get(options);

                    for (var i = 0, len = items.length; i < len; i++) {
                        var item = items[i];
                        var id = item[this._idProp];
                        callback(item, id);
                    }
                } else {
                    // unordered
                    for (var _i9 = 0, _len10 = itemIds.length; _i9 < _len10; _i9++) {
                        var _id6 = itemIds[_i9];

                        var _item4 = this._data.get(_id6);

                        if (_item4 != null && (!filter$1 || filter$1(_item4))) {
                            callback(_item4, _id6);
                        }
                    }
                }
            }
            /** @inheritDoc */

        }, {
            key: "map",
            value: function map(callback, options) {
                var filter$1 = options && filter(options);

                var mappedItems = [];
                var data = this._data;

                var itemIds = _toConsumableArray(keys(data).call(data)); // convert and filter items


                for (var i = 0, len = itemIds.length; i < len; i++) {
                    var id = itemIds[i];

                    var item = this._data.get(id);

                    if (item != null && (!filter$1 || filter$1(item))) {
                        mappedItems.push(callback(item, id));
                    }
                } // order items


                if (options && options.order) {
                    this._sort(mappedItems, options.order);
                }

                return mappedItems;
            }
            /**
             * Filter the fields of an item.
             *
             * @param item - The item whose fields should be filtered.
             * @param fields - The names of the fields that will be kept.
             *
             * @typeParam K - Field name type.
             *
             * @returns The item without any additional fields.
             */

        }, {
            key: "_filterFields",
            value: function _filterFields(item, fields) {
                var _context21;

                if (!item) {
                    // item is null
                    return item;
                }

                return reduce(_context21 = isArray(fields) ? // Use the supplied array
                    fields : // Use the keys of the supplied object
                    keys$3(fields)).call(_context21, function (filteredItem, field) {
                    filteredItem[field] = item[field];
                    return filteredItem;
                }, {});
            }
            /**
             * Sort the provided array with items.
             *
             * @param items - Items to be sorted in place.
             * @param order - A field name or custom sort function.
             *
             * @typeParam T - The type of the items in the items array.
             */

        }, {
            key: "_sort",
            value: function _sort(items, order) {
                if (typeof order === "string") {
                    // order by provided field name
                    var name = order; // field name

                    sort(items).call(items, function (a, b) {
                        // @TODO: How to treat missing properties?
                        var av = a[name];
                        var bv = b[name];
                        return av > bv ? 1 : av < bv ? -1 : 0;
                    });
                } else if (typeof order === "function") {
                    // order by sort function
                    sort(items).call(items, order);
                } else {
                    // TODO: extend order by an Object {field:string, direction:string}
                    //       where direction can be 'asc' or 'desc'
                    throw new TypeError("Order must be a function or a string");
                }
            }
            /**
             * Remove an item or multiple items by “reference” (only the id is used) or by id.
             *
             * The method ignores removal of non-existing items, and returns an array containing the ids of the items which are actually removed from the DataSet.
             *
             * After the items are removed, the DataSet will trigger an event `remove` for the removed items. When a `senderId` is provided, this id will be passed with the triggered event to all subscribers.
             *
             * ## Example
             * ```javascript
             * // create a DataSet
             * const data = new vis.DataSet([
             *   { id: 1, text: 'item 1' },
             *   { id: 2, text: 'item 2' },
             *   { id: 3, text: 'item 3' }
             * ])
             *
             * // remove items
             * const ids = data.remove([2, { id: 3 }, 4])
             *
             * console.log(ids) // [2, 3]
             * ```
             *
             * @param id - One or more items or ids of items to be removed.
             * @param senderId - Sender id.
             *
             * @returns The ids of the removed items.
             */

        }, {
            key: "remove",
            value: function remove(id, senderId) {
                var removedIds = [];
                var removedItems = []; // force everything to be an array for simplicity

                var ids = isArray(id) ? id : [id];

                for (var i = 0, len = ids.length; i < len; i++) {
                    var item = this._remove(ids[i]);

                    if (item) {
                        var itemId = item[this._idProp];

                        if (itemId != null) {
                            removedIds.push(itemId);
                            removedItems.push(item);
                        }
                    }
                }

                if (removedIds.length) {
                    this._trigger("remove", {
                        items: removedIds,
                        oldData: removedItems
                    }, senderId);
                }

                return removedIds;
            }
            /**
             * Remove an item by its id or reference.
             *
             * @param id - Id of an item or the item itself.
             *
             * @returns The removed item if removed, null otherwise.
             */

        }, {
            key: "_remove",
            value: function _remove(id) {
                // @TODO: It origianlly returned the item although the docs say id.
                // The code expects the item, so probably an error in the docs.
                var ident; // confirm the id to use based on the args type

                if (isId(id)) {
                    ident = id;
                } else if (id && _typeof(id) === "object") {
                    ident = id[this._idProp]; // look for the identifier field using ._idProp
                } // do the removing if the item is found


                if (ident != null && this._data.has(ident)) {
                    var item = this._data.get(ident) || null;

                    this._data.delete(ident);

                    --this.length;
                    return item;
                }

                return null;
            }
            /**
             * Clear the entire data set.
             *
             * After the items are removed, the [[DataSet]] will trigger an event `remove` for all removed items. When a `senderId` is provided, this id will be passed with the triggered event to all subscribers.
             *
             * @param senderId - Sender id.
             *
             * @returns removedIds - The ids of all removed items.
             */

        }, {
            key: "clear",
            value: function clear(senderId) {
                var _context22;

                var ids = _toConsumableArray(keys(_context22 = this._data).call(_context22));

                var items = [];

                for (var i = 0, len = ids.length; i < len; i++) {
                    items.push(this._data.get(ids[i]));
                }

                this._data.clear();

                this.length = 0;

                this._trigger("remove", {
                    items: ids,
                    oldData: items
                }, senderId);

                return ids;
            }
            /**
             * Find the item with maximum value of a specified field.
             *
             * @param field - Name of the property that should be searched for max value.
             *
             * @returns Item containing max value, or null if no items.
             */

        }, {
            key: "max",
            value: function max(field) {
                var _context23;

                var max = null;
                var maxField = null;

                var _iterator11 = _createForOfIteratorHelper$7(values(_context23 = this._data).call(_context23)),
                    _step11;

                try {
                    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                        var item = _step11.value;
                        var itemField = item[field];

                        if (typeof itemField === "number" && (maxField == null || itemField > maxField)) {
                            max = item;
                            maxField = itemField;
                        }
                    }
                } catch (err) {
                    _iterator11.e(err);
                } finally {
                    _iterator11.f();
                }

                return max || null;
            }
            /**
             * Find the item with minimum value of a specified field.
             *
             * @param field - Name of the property that should be searched for min value.
             *
             * @returns Item containing min value, or null if no items.
             */

        }, {
            key: "min",
            value: function min(field) {
                var _context24;

                var min = null;
                var minField = null;

                var _iterator12 = _createForOfIteratorHelper$7(values(_context24 = this._data).call(_context24)),
                    _step12;

                try {
                    for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                        var item = _step12.value;
                        var itemField = item[field];

                        if (typeof itemField === "number" && (minField == null || itemField < minField)) {
                            min = item;
                            minField = itemField;
                        }
                    }
                } catch (err) {
                    _iterator12.e(err);
                } finally {
                    _iterator12.f();
                }

                return min || null;
            }
            /**
             * Find all distinct values of a specified field
             *
             * @param prop - The property name whose distinct values should be returned.
             *
             * @returns Unordered array containing all distinct values. Items without specified property are ignored.
             */

        }, {
            key: "distinct",
            value: function distinct(prop) {
                var data = this._data;

                var itemIds = _toConsumableArray(keys(data).call(data));

                var values = [];
                var count = 0;

                for (var i = 0, len = itemIds.length; i < len; i++) {
                    var id = itemIds[i];
                    var item = data.get(id);
                    var _value3 = item[prop];
                    var exists = false;

                    for (var j = 0; j < count; j++) {
                        if (values[j] == _value3) {
                            exists = true;
                            break;
                        }
                    }

                    if (!exists && _value3 !== undefined) {
                        values[count] = _value3;
                        count++;
                    }
                }

                return values;
            }
            /**
             * Add a single item. Will fail when an item with the same id already exists.
             *
             * @param item - A new item to be added.
             *
             * @returns Added item's id. An id is generated when it is not present in the item.
             */

        }, {
            key: "_addItem",
            value: function _addItem(item) {
                var fullItem = ensureFullItem(item, this._idProp);
                var id = fullItem[this._idProp]; // check whether this id is already taken

                if (this._data.has(id)) {
                    // item already exists
                    throw new Error("Cannot add item: item with id " + id + " already exists");
                }

                this._data.set(id, fullItem);

                ++this.length;
                return id;
            }
            /**
             * Update a single item: merge with existing item.
             * Will fail when the item has no id, or when there does not exist an item with the same id.
             *
             * @param update - The new item
             *
             * @returns The id of the updated item.
             */

        }, {
            key: "_updateItem",
            value: function _updateItem(update) {
                var id = update[this._idProp];

                if (id == null) {
                    throw new Error("Cannot update item: item has no id (item: " + stringify$1(update) + ")");
                }

                var item = this._data.get(id);

                if (!item) {
                    // item doesn't exist
                    throw new Error("Cannot update item: no item with id " + id + " found");
                }

                this._data.set(id, _objectSpread$4(_objectSpread$4({}, item), update));

                return id;
            }
            /** @inheritDoc */

        }, {
            key: "stream",
            value: function stream(ids) {
                if (ids) {
                    var data = this._data;
                    return new DataStream(_defineProperty({}, iterator, /*#__PURE__*/regenerator.mark(function _callee3() {
                        var _iterator13, _step13, id, item;

                        return regenerator.wrap(function _callee3$(_context25) {
                            while (1) {
                                switch (_context25.prev = _context25.next) {
                                    case 0:
                                        _iterator13 = _createForOfIteratorHelper$7(ids);
                                        _context25.prev = 1;

                                        _iterator13.s();

                                    case 3:
                                        if ((_step13 = _iterator13.n()).done) {
                                            _context25.next = 11;
                                            break;
                                        }

                                        id = _step13.value;
                                        item = data.get(id);

                                        if (!(item != null)) {
                                            _context25.next = 9;
                                            break;
                                        }

                                        _context25.next = 9;
                                        return [id, item];

                                    case 9:
                                        _context25.next = 3;
                                        break;

                                    case 11:
                                        _context25.next = 16;
                                        break;

                                    case 13:
                                        _context25.prev = 13;
                                        _context25.t0 = _context25["catch"](1);

                                        _iterator13.e(_context25.t0);

                                    case 16:
                                        _context25.prev = 16;

                                        _iterator13.f();

                                        return _context25.finish(16);

                                    case 19:
                                    case "end":
                                        return _context25.stop();
                                }
                            }
                        }, _callee3, null, [[1, 13, 16, 19]]);
                    })));
                } else {
                    var _context26;

                    return new DataStream(_defineProperty({}, iterator, bind(_context26 = entries(this._data)).call(_context26, this._data)));
                }
            }
        }]);

        return DataSet;
    }(DataSetPart);
    /**
     * DataView
     *
     * A DataView offers a filtered and/or formatted view on a DataSet. One can subscribe to changes in a DataView, and easily get filtered or formatted data without having to specify filters and field types all the time.
     *
     * ## Example
     * ```javascript
     * // create a DataSet
     * var data = new vis.DataSet();
     * data.add([
     *   {id: 1, text: 'item 1', date: new Date(2013, 6, 20), group: 1, first: true},
     *   {id: 2, text: 'item 2', date: '2013-06-23', group: 2},
     *   {id: 3, text: 'item 3', date: '2013-06-25', group: 2},
     *   {id: 4, text: 'item 4'}
     * ]);
     *
     * // create a DataView
     * // the view will only contain items having a property group with value 1,
     * // and will only output fields id, text, and date.
     * var view = new vis.DataView(data, {
     *   filter: function (item) {
     *     return (item.group == 1);
     *   },
     *   fields: ['id', 'text', 'date']
     * });
     *
     * // subscribe to any change in the DataView
     * view.on('*', function (event, properties, senderId) {
     *   console.log('event', event, properties);
     * });
     *
     * // update an item in the data set
     * data.update({id: 2, group: 1});
     *
     * // get all ids in the view
     * var ids = view.getIds();
     * console.log('ids', ids); // will output [1, 2]
     *
     * // get all items in the view
     * var items = view.get();
     * ```
     *
     * @typeParam Item - Item type that may or may not have an id.
     * @typeParam IdProp - Name of the property that contains the id.
     */


    var DataView = /*#__PURE__*/function (_DataSetPart2) {
        _inherits(DataView, _DataSetPart2);

        var _super2 = _createSuper$t(DataView);

        /**
         * Create a DataView.
         *
         * @param data - The instance containing data (directly or indirectly).
         * @param options - Options to configure this data view.
         */
        function DataView(data, options) {
            var _context27;

            var _this7;

            _classCallCheck(this, DataView);

            _this7 = _super2.call(this);
            /** @inheritDoc */

            _this7.length = 0;
            _this7._ids = new set(); // ids of the items currently in memory (just contains a boolean true)

            _this7._options = options || {};
            _this7._listener = bind(_context27 = _this7._onEvent).call(_context27, _assertThisInitialized(_this7));

            _this7.setData(data);

            return _this7;
        }
        /** @inheritDoc */


        _createClass(DataView, [{
            key: "idProp",
            get: function get() {
                return this.getDataSet().idProp;
            } // TODO: implement a function .config() to dynamically update things like configured filter
            // and trigger changes accordingly

            /**
             * Set a data source for the view.
             *
             * @param data - The instance containing data (directly or indirectly).
             *
             * @remarks
             * Note that when the data view is bound to a data set it won't be garbage
             * collected unless the data set is too. Use `dataView.setData(null)` or
             * `dataView.dispose()` to enable garbage collection before you lose the last
             * reference.
             */

        }, {
            key: "setData",
            value: function setData(data) {
                if (this._data) {
                    // unsubscribe from current dataset
                    if (this._data.off) {
                        this._data.off("*", this._listener);
                    } // trigger a remove of all items in memory


                    var ids = this._data.getIds({
                        filter: filter(this._options)
                    });

                    var items = this._data.get(ids);

                    this._ids.clear();

                    this.length = 0;

                    this._trigger("remove", {
                        items: ids,
                        oldData: items
                    });
                }

                if (data != null) {
                    this._data = data; // trigger an add of all added items

                    var _ids = this._data.getIds({
                        filter: filter(this._options)
                    });

                    for (var i = 0, len = _ids.length; i < len; i++) {
                        var id = _ids[i];

                        this._ids.add(id);
                    }

                    this.length = _ids.length;

                    this._trigger("add", {
                        items: _ids
                    });
                } else {
                    this._data = new DataSet();
                } // subscribe to new dataset


                if (this._data.on) {
                    this._data.on("*", this._listener);
                }
            }
            /**
             * Refresh the DataView.
             * Useful when the DataView has a filter function containing a variable parameter.
             */

        }, {
            key: "refresh",
            value: function refresh() {
                var ids = this._data.getIds({
                    filter: filter(this._options)
                });

                var oldIds = _toConsumableArray(this._ids);

                var newIds = {};
                var addedIds = [];
                var removedIds = [];
                var removedItems = []; // check for additions

                for (var i = 0, len = ids.length; i < len; i++) {
                    var id = ids[i];
                    newIds[id] = true;

                    if (!this._ids.has(id)) {
                        addedIds.push(id);

                        this._ids.add(id);
                    }
                } // check for removals


                for (var _i10 = 0, _len11 = oldIds.length; _i10 < _len11; _i10++) {
                    var _id7 = oldIds[_i10];

                    var item = this._data.get(_id7);

                    if (item == null) {
                        // @TODO: Investigate.
                        // Doesn't happen during tests or examples.
                        // Is it really impossible or could it eventually happen?
                        // How to handle it if it does? The types guarantee non-nullable items.
                        console.error("If you see this, report it please.");
                    } else if (!newIds[_id7]) {
                        removedIds.push(_id7);
                        removedItems.push(item);

                        this._ids.delete(_id7);
                    }
                }

                this.length += addedIds.length - removedIds.length; // trigger events

                if (addedIds.length) {
                    this._trigger("add", {
                        items: addedIds
                    });
                }

                if (removedIds.length) {
                    this._trigger("remove", {
                        items: removedIds,
                        oldData: removedItems
                    });
                }
            }
            /** @inheritDoc */

        }, {
            key: "get",
            value: function get(first, second) {
                if (this._data == null) {
                    return null;
                } // parse the arguments


                var ids = null;
                var options;

                if (isId(first) || isArray(first)) {
                    ids = first;
                    options = second;
                } else {
                    options = first;
                } // extend the options with the default options and provided options


                var viewOptions = assign$2({}, this._options, options); // create a combined filter method when needed


                var thisFilter = filter(this._options);

                var optionsFilter = options && filter(options);

                if (thisFilter && optionsFilter) {
                    viewOptions.filter = function (item) {
                        return thisFilter(item) && optionsFilter(item);
                    };
                }

                if (ids == null) {
                    return this._data.get(viewOptions);
                } else {
                    return this._data.get(ids, viewOptions);
                }
            }
            /** @inheritDoc */

        }, {
            key: "getIds",
            value: function getIds(options) {
                if (this._data.length) {
                    var defaultFilter = filter(this._options);

                    var optionsFilter = options != null ? filter(options) : null;
                    var filter$1;

                    if (optionsFilter) {
                        if (defaultFilter) {
                            filter$1 = function filter(item) {
                                return defaultFilter(item) && optionsFilter(item);
                            };
                        } else {
                            filter$1 = optionsFilter;
                        }
                    } else {
                        filter$1 = defaultFilter;
                    }

                    return this._data.getIds({
                        filter: filter$1,
                        order: options && options.order
                    });
                } else {
                    return [];
                }
            }
            /** @inheritDoc */

        }, {
            key: "forEach",
            value: function forEach(callback, options) {
                if (this._data) {
                    var _context28;

                    var defaultFilter = filter(this._options);

                    var optionsFilter = options && filter(options);

                    var filter$1;

                    if (optionsFilter) {
                        if (defaultFilter) {
                            filter$1 = function filter(item) {
                                return defaultFilter(item) && optionsFilter(item);
                            };
                        } else {
                            filter$1 = optionsFilter;
                        }
                    } else {
                        filter$1 = defaultFilter;
                    }

                    forEach$2(_context28 = this._data).call(_context28, callback, {
                        filter: filter$1,
                        order: options && options.order
                    });
                }
            }
            /** @inheritDoc */

        }, {
            key: "map",
            value: function map(callback, options) {
                if (this._data) {
                    var _context29;

                    var defaultFilter = filter(this._options);

                    var optionsFilter = options && filter(options);

                    var filter$1;

                    if (optionsFilter) {
                        if (defaultFilter) {
                            filter$1 = function filter(item) {
                                return defaultFilter(item) && optionsFilter(item);
                            };
                        } else {
                            filter$1 = optionsFilter;
                        }
                    } else {
                        filter$1 = defaultFilter;
                    }

                    return map$3(_context29 = this._data).call(_context29, callback, {
                        filter: filter$1,
                        order: options && options.order
                    });
                } else {
                    return [];
                }
            }
            /** @inheritDoc */

        }, {
            key: "getDataSet",
            value: function getDataSet() {
                return this._data.getDataSet();
            }
            /** @inheritDoc */

        }, {
            key: "stream",
            value: function stream(ids) {
                var _context30;

                return this._data.stream(ids || _defineProperty({}, iterator, bind(_context30 = keys(this._ids)).call(_context30, this._ids)));
            }
            /**
             * Render the instance unusable prior to garbage collection.
             *
             * @remarks
             * The intention of this method is to help discover scenarios where the data
             * view is being used when the programmer thinks it has been garbage collected
             * already. It's stricter version of `dataView.setData(null)`.
             */

        }, {
            key: "dispose",
            value: function dispose() {
                var _this$_data;

                if ((_this$_data = this._data) !== null && _this$_data !== void 0 && _this$_data.off) {
                    this._data.off("*", this._listener);
                }

                var message = "This data view has already been disposed of.";
                var replacement = {
                    get: function get() {
                        throw new Error(message);
                    },
                    set: function set() {
                        throw new Error(message);
                    },
                    configurable: false
                };

                var _iterator14 = _createForOfIteratorHelper$7(ownKeys$5(DataView.prototype)),
                    _step14;

                try {
                    for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                        var key = _step14.value;

                        defineProperty$4(this, key, replacement);
                    }
                } catch (err) {
                    _iterator14.e(err);
                } finally {
                    _iterator14.f();
                }
            }
            /**
             * Event listener. Will propagate all events from the connected data set to the subscribers of the DataView, but will filter the items and only trigger when there are changes in the filtered data set.
             *
             * @param event - The name of the event.
             * @param params - Parameters of the event.
             * @param senderId - Id supplied by the sender.
             */

        }, {
            key: "_onEvent",
            value: function _onEvent(event, params, senderId) {
                if (!params || !params.items || !this._data) {
                    return;
                }

                var ids = params.items;
                var addedIds = [];
                var updatedIds = [];
                var removedIds = [];
                var oldItems = [];
                var updatedItems = [];
                var removedItems = [];

                switch (event) {
                    case "add":
                        // filter the ids of the added items
                        for (var i = 0, len = ids.length; i < len; i++) {
                            var id = ids[i];
                            var item = this.get(id);

                            if (item) {
                                this._ids.add(id);

                                addedIds.push(id);
                            }
                        }

                        break;

                    case "update":
                        // determine the event from the views viewpoint: an updated
                        // item can be added, updated, or removed from this view.
                        for (var _i11 = 0, _len12 = ids.length; _i11 < _len12; _i11++) {
                            var _id8 = ids[_i11];

                            var _item5 = this.get(_id8);

                            if (_item5) {
                                if (this._ids.has(_id8)) {
                                    updatedIds.push(_id8);
                                    updatedItems.push(params.data[_i11]);
                                    oldItems.push(params.oldData[_i11]);
                                } else {
                                    this._ids.add(_id8);

                                    addedIds.push(_id8);
                                }
                            } else {
                                if (this._ids.has(_id8)) {
                                    this._ids.delete(_id8);

                                    removedIds.push(_id8);
                                    removedItems.push(params.oldData[_i11]);
                                }
                            }
                        }

                        break;

                    case "remove":
                        // filter the ids of the removed items
                        for (var _i12 = 0, _len13 = ids.length; _i12 < _len13; _i12++) {
                            var _id9 = ids[_i12];

                            if (this._ids.has(_id9)) {
                                this._ids.delete(_id9);

                                removedIds.push(_id9);
                                removedItems.push(params.oldData[_i12]);
                            }
                        }

                        break;
                }

                this.length += addedIds.length - removedIds.length;

                if (addedIds.length) {
                    this._trigger("add", {
                        items: addedIds
                    }, senderId);
                }

                if (updatedIds.length) {
                    this._trigger("update", {
                        items: updatedIds,
                        oldData: oldItems,
                        data: updatedItems
                    }, senderId);
                }

                if (removedIds.length) {
                    this._trigger("remove", {
                        items: removedIds,
                        oldData: removedItems
                    }, senderId);
                }
            }
        }]);

        return DataView;
    }(DataSetPart);
    /**
     * Check that given value is compatible with Vis Data Set interface.
     *
     * @param idProp - The expected property to contain item id.
     * @param v - The value to be tested.
     *
     * @returns True if all expected values and methods match, false otherwise.
     */


    function isDataSetLike(idProp, v) {
        return _typeof(v) === "object" && v !== null && idProp === v.idProp && typeof v.add === "function" && typeof v.clear === "function" && typeof v.distinct === "function" && typeof forEach$2(v) === "function" && typeof v.get === "function" && typeof v.getDataSet === "function" && typeof v.getIds === "function" && typeof v.length === "number" && typeof map$3(v) === "function" && typeof v.max === "function" && typeof v.min === "function" && typeof v.off === "function" && typeof v.on === "function" && typeof v.remove === "function" && typeof v.setOptions === "function" && typeof v.stream === "function" && typeof v.update === "function" && typeof v.updateOnly === "function";
    }
    /**
     * Check that given value is compatible with Vis Data View interface.
     *
     * @param idProp - The expected property to contain item id.
     * @param v - The value to be tested.
     *
     * @returns True if all expected values and methods match, false otherwise.
     */


    function isDataViewLike(idProp, v) {
        return _typeof(v) === "object" && v !== null && idProp === v.idProp && typeof forEach$2(v) === "function" && typeof v.get === "function" && typeof v.getDataSet === "function" && typeof v.getIds === "function" && typeof v.length === "number" && typeof map$3(v) === "function" && typeof v.off === "function" && typeof v.on === "function" && typeof v.stream === "function" && isDataSetLike(idProp, v.getDataSet());
    }

    var index = /*#__PURE__*/Object.freeze({
        __proto__: null,
        DELETE: DELETE,
        DataSet: DataSet,
        DataStream: DataStream,
        DataView: DataView,
        Queue: Queue,
        createNewDataPipeFrom: createNewDataPipeFrom,
        isDataSetLike: isDataSetLike,
        isDataViewLike: isDataViewLike
    });

    var trim = stringTrim.trim;
    var $parseFloat = global$1.parseFloat;
    var FORCED = 1 / $parseFloat(whitespaces + '-0') !== -Infinity; // `parseFloat` method
    // https://tc39.es/ecma262/#sec-parsefloat-string

    var numberParseFloat = FORCED ? function parseFloat(string) {
        var trimmedString = trim(String(string));
        var result = $parseFloat(trimmedString);
        return result === 0 && trimmedString.charAt(0) == '-' ? -0 : result;
    } : $parseFloat;

    // https://tc39.es/ecma262/#sec-parsefloat-string

    _export({
        global: true,
        forced: parseFloat != numberParseFloat
    }, {
        parseFloat: numberParseFloat
    });

    var _parseFloat$2 = path.parseFloat;

    var _parseFloat$1 = _parseFloat$2;

    var _parseFloat = _parseFloat$1;

    var nativeGetOwnPropertyNames = objectGetOwnPropertyNamesExternal.f;
    var FAILS_ON_PRIMITIVES = fails(function () {
        return !Object.getOwnPropertyNames(1);
    }); // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames

    _export({
        target: 'Object',
        stat: true,
        forced: FAILS_ON_PRIMITIVES
    }, {
        getOwnPropertyNames: nativeGetOwnPropertyNames
    });

    var Object$1 = path.Object;

    var getOwnPropertyNames$2 = function getOwnPropertyNames(it) {
        return Object$1.getOwnPropertyNames(it);
    };

    var getOwnPropertyNames$1 = getOwnPropertyNames$2;

    var getOwnPropertyNames = getOwnPropertyNames$1;

    /**
     * Helper functions for components
     */

    /**
     * Determine values to use for (sub)options of 'chosen'.
     *
     * This option is either a boolean or an object whose values should be examined further.
     * The relevant structures are:
     *
     * - chosen: <boolean value>
     * - chosen: { subOption: <boolean or function> }
     *
     * Where subOption is 'node', 'edge' or 'label'.
     *
     * The intention of this method appears to be to set a specific priority to the options;
     * Since most properties are either bridged or merged into the local options objects, there
     * is not much point in handling them separately.
     * TODO: examine if 'most' in previous sentence can be replaced with 'all'. In that case, we
     *       should be able to get rid of this method.
     *
     * @param {string}  subOption  option within object 'chosen' to consider; either 'node', 'edge' or 'label'
     * @param {object}  pile       array of options objects to consider
     *
     * @returns {boolean | Function}  value for passed subOption of 'chosen' to use
     */

    function choosify(subOption, pile) {
        // allowed values for subOption
        var allowed = ["node", "edge", "label"];
        var value = true;
        var chosen = topMost(pile, "chosen");

        if (typeof chosen === "boolean") {
            value = chosen;
        } else if (_typeof(chosen) === "object") {
            if (indexOf(allowed).call(allowed, subOption) === -1) {
                throw new Error("choosify: subOption '" + subOption + "' should be one of " + "'" + allowed.join("', '") + "'");
            }

            var chosenEdge = topMost(pile, ["chosen", subOption]);

            if (typeof chosenEdge === "boolean" || typeof chosenEdge === "function") {
                value = chosenEdge;
            }
        }

        return value;
    }
    /**
     * Check if the point falls within the given rectangle.
     *
     * @param {rect} rect
     * @param {point} point
     * @param {rotationPoint} [rotationPoint] if specified, the rotation that applies to the rectangle.
     * @returns {boolean}  true if point within rectangle, false otherwise
     */

    function pointInRect(rect, point, rotationPoint) {
        if (rect.width <= 0 || rect.height <= 0) {
            return false; // early out
        }

        if (rotationPoint !== undefined) {
            // Rotate the point the same amount as the rectangle
            var tmp = {
                x: point.x - rotationPoint.x,
                y: point.y - rotationPoint.y
            };

            if (rotationPoint.angle !== 0) {
                // In order to get the coordinates the same, you need to
                // rotate in the reverse direction
                var angle = -rotationPoint.angle;
                var tmp2 = {
                    x: Math.cos(angle) * tmp.x - Math.sin(angle) * tmp.y,
                    y: Math.sin(angle) * tmp.x + Math.cos(angle) * tmp.y
                };
                point = tmp2;
            } else {
                point = tmp;
            } // Note that if a rotation is specified, the rectangle coordinates
            // are **not* the full canvas coordinates. They are relative to the
            // rotationPoint. Hence, the point coordinates need not be translated
            // back in this case.

        }

        var right = rect.x + rect.width;
        var bottom = rect.y + rect.width;
        return rect.left < point.x && right > point.x && rect.top < point.y && bottom > point.y;
    }
    /**
     * Check if given value is acceptable as a label text.
     *
     * @param {*} text value to check; can be anything at this point
     * @returns {boolean} true if valid label value, false otherwise
     */

    function isValidLabel(text) {
        // Note that this is quite strict: types that *might* be converted to string are disallowed
        return typeof text === "string" && text !== "";
    }
    /**
     * Returns x, y of self reference circle based on provided angle
     *
     * @param {object} ctx
     * @param {number} angle
     * @param {number} radius
     * @param {VisNode} node
     *
     * @returns {object} x and y coordinates
     */

    function getSelfRefCoordinates(ctx, angle, radius, node) {
        var x = node.x;
        var y = node.y;

        if (typeof node.distanceToBorder === "function") {
            //calculating opposite and adjacent
            //distaneToBorder becomes Hypotenuse.
            //Formulas sin(a) = Opposite / Hypotenuse and cos(a) = Adjacent / Hypotenuse
            var toBorderDist = node.distanceToBorder(ctx, angle);
            var yFromNodeCenter = Math.sin(angle) * toBorderDist;
            var xFromNodeCenter = Math.cos(angle) * toBorderDist; //xFromNodeCenter is basically x and if xFromNodeCenter equals to the distance to border then it means
            //that y does not need calculation because it is equal node.height / 2 or node.y
            //same thing with yFromNodeCenter and if yFromNodeCenter equals to the distance to border then it means
            //that x is equal node.width / 2 or node.x

            if (xFromNodeCenter === toBorderDist) {
                x += toBorderDist;
                y = node.y;
            } else if (yFromNodeCenter === toBorderDist) {
                x = node.x;
                y -= toBorderDist;
            } else {
                x += xFromNodeCenter;
                y -= yFromNodeCenter;
            }
        } else if (node.shape.width > node.shape.height) {
            x = node.x + node.shape.width * 0.5;
            y = node.y - radius;
        } else {
            x = node.x + radius;
            y = node.y - node.shape.height * 0.5;
        }

        return {
            x: x,
            y: y
        };
    }

    /**
     * Callback to determine text dimensions, using the parent label settings.
     *
     * @callback MeasureText
     * @param {text} text
     * @param {text} mod
     * @returns {object} { width, values} width in pixels and font attributes
     */

    /**
     * Helper class for Label which collects results of splitting labels into lines and blocks.
     *
     * @private
     */
    var LabelAccumulator = /*#__PURE__*/function () {
        /**
         * @param {MeasureText} measureText
         */
        function LabelAccumulator(measureText) {
            _classCallCheck(this, LabelAccumulator);

            this.measureText = measureText;
            this.current = 0;
            this.width = 0;
            this.height = 0;
            this.lines = [];
        }
        /**
         * Append given text to the given line.
         *
         * @param {number}  l    index of line to add to
         * @param {string}  text string to append to line
         * @param {'bold'|'ital'|'boldital'|'mono'|'normal'} [mod='normal']
         * @private
         */


        _createClass(LabelAccumulator, [{
            key: "_add",
            value: function _add(l, text) {
                var mod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "normal";

                if (this.lines[l] === undefined) {
                    this.lines[l] = {
                        width: 0,
                        height: 0,
                        blocks: []
                    };
                } // We still need to set a block for undefined and empty texts, hence return at this point
                // This is necessary because we don't know at this point if we're at the
                // start of an empty line or not.
                // To compensate, empty blocks are removed in `finalize()`.
                //
                // Empty strings should still have a height


                var tmpText = text;
                if (text === undefined || text === "") tmpText = " "; // Determine width and get the font properties

                var result = this.measureText(tmpText, mod);

                var block = assign$2({}, values(result));

                block.text = text;
                block.width = result.width;
                block.mod = mod;

                if (text === undefined || text === "") {
                    block.width = 0;
                }

                this.lines[l].blocks.push(block); // Update the line width. We need this for determining if a string goes over max width

                this.lines[l].width += block.width;
            }
            /**
             * Returns the width in pixels of the current line.
             *
             * @returns {number}
             */

        }, {
            key: "curWidth",
            value: function curWidth() {
                var line = this.lines[this.current];
                if (line === undefined) return 0;
                return line.width;
            }
            /**
             * Add text in block to current line
             *
             * @param {string} text
             * @param {'bold'|'ital'|'boldital'|'mono'|'normal'} [mod='normal']
             */

        }, {
            key: "append",
            value: function append(text) {
                var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "normal";

                this._add(this.current, text, mod);
            }
            /**
             * Add text in block to current line and start a new line
             *
             * @param {string} text
             * @param {'bold'|'ital'|'boldital'|'mono'|'normal'} [mod='normal']
             */

        }, {
            key: "newLine",
            value: function newLine(text) {
                var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "normal";

                this._add(this.current, text, mod);

                this.current++;
            }
            /**
             * Determine and set the heights of all the lines currently contained in this instance
             *
             * Note that width has already been set.
             *
             * @private
             */

        }, {
            key: "determineLineHeights",
            value: function determineLineHeights() {
                for (var k = 0; k < this.lines.length; k++) {
                    var line = this.lines[k]; // Looking for max height of blocks in line

                    var height = 0;

                    if (line.blocks !== undefined) {
                        // Can happen if text contains e.g. '\n '
                        for (var l = 0; l < line.blocks.length; l++) {
                            var block = line.blocks[l];

                            if (height < block.height) {
                                height = block.height;
                            }
                        }
                    }

                    line.height = height;
                }
            }
            /**
             * Determine the full size of the label text, as determined by current lines and blocks
             *
             * @private
             */

        }, {
            key: "determineLabelSize",
            value: function determineLabelSize() {
                var width = 0;
                var height = 0;

                for (var k = 0; k < this.lines.length; k++) {
                    var line = this.lines[k];

                    if (line.width > width) {
                        width = line.width;
                    }

                    height += line.height;
                }

                this.width = width;
                this.height = height;
            }
            /**
             * Remove all empty blocks and empty lines we don't need
             *
             * This must be done after the width/height determination,
             * so that these are set properly for processing here.
             *
             * @returns {Array<Line>} Lines with empty blocks (and some empty lines) removed
             * @private
             */

        }, {
            key: "removeEmptyBlocks",
            value: function removeEmptyBlocks() {
                var tmpLines = [];

                for (var k = 0; k < this.lines.length; k++) {
                    var line = this.lines[k]; // Note: an empty line in between text has width zero but is still relevant to layout.
                    // So we can't use width for testing empty line here

                    if (line.blocks.length === 0) continue; // Discard final empty line always

                    if (k === this.lines.length - 1) {
                        if (line.width === 0) continue;
                    }

                    var tmpLine = {};

                    assign$2(tmpLine, line);

                    tmpLine.blocks = [];
                    var firstEmptyBlock = void 0;
                    var tmpBlocks = [];

                    for (var l = 0; l < line.blocks.length; l++) {
                        var block = line.blocks[l];

                        if (block.width !== 0) {
                            tmpBlocks.push(block);
                        } else {
                            if (firstEmptyBlock === undefined) {
                                firstEmptyBlock = block;
                            }
                        }
                    } // Ensure that there is *some* text present


                    if (tmpBlocks.length === 0 && firstEmptyBlock !== undefined) {
                        tmpBlocks.push(firstEmptyBlock);
                    }

                    tmpLine.blocks = tmpBlocks;
                    tmpLines.push(tmpLine);
                }

                return tmpLines;
            }
            /**
             * Set the sizes for all lines and the whole thing.
             *
             * @returns {{width: (number|*), height: (number|*), lines: Array}}
             */

        }, {
            key: "finalize",
            value: function finalize() {
                //console.log(JSON.stringify(this.lines, null, 2));
                this.determineLineHeights();
                this.determineLabelSize();
                var tmpLines = this.removeEmptyBlocks(); // Return a simple hash object for further processing.

                return {
                    width: this.width,
                    height: this.height,
                    lines: tmpLines
                };
            }
        }]);

        return LabelAccumulator;
    }();

    var tagPattern = {
        // HTML
        "<b>": /<b>/,
        "<i>": /<i>/,
        "<code>": /<code>/,
        "</b>": /<\/b>/,
        "</i>": /<\/i>/,
        "</code>": /<\/code>/,
        // Markdown
        "*": /\*/,
        // bold
        _: /_/,
        // ital
        "`": /`/,
        // mono
        afterBold: /[^*]/,
        afterItal: /[^_]/,
        afterMono: /[^`]/
    };
    /**
     * Internal helper class for parsing the markup tags for HTML and Markdown.
     *
     * NOTE: Sequences of tabs and spaces are reduced to single space.
     *       Scan usage of `this.spacing` within method
     */

    var MarkupAccumulator = /*#__PURE__*/function () {
        /**
         * Create an instance
         *
         * @param {string} text  text to parse for markup
         */
        function MarkupAccumulator(text) {
            _classCallCheck(this, MarkupAccumulator);

            this.text = text;
            this.bold = false;
            this.ital = false;
            this.mono = false;
            this.spacing = false;
            this.position = 0;
            this.buffer = "";
            this.modStack = [];
            this.blocks = [];
        }
        /**
         * Return the mod label currently on the top of the stack
         *
         * @returns {string}  label of topmost mod
         * @private
         */


        _createClass(MarkupAccumulator, [{
            key: "mod",
            value: function mod() {
                return this.modStack.length === 0 ? "normal" : this.modStack[0];
            }
            /**
             * Return the mod label currently active
             *
             * @returns {string}  label of active mod
             * @private
             */

        }, {
            key: "modName",
            value: function modName() {
                if (this.modStack.length === 0) return "normal";else if (this.modStack[0] === "mono") return "mono";else {
                    if (this.bold && this.ital) {
                        return "boldital";
                    } else if (this.bold) {
                        return "bold";
                    } else if (this.ital) {
                        return "ital";
                    }
                }
            }
            /**
             * @private
             */

        }, {
            key: "emitBlock",
            value: function emitBlock() {
                if (this.spacing) {
                    this.add(" ");
                    this.spacing = false;
                }

                if (this.buffer.length > 0) {
                    this.blocks.push({
                        text: this.buffer,
                        mod: this.modName()
                    });
                    this.buffer = "";
                }
            }
            /**
             * Output text to buffer
             *
             * @param {string} text  text to add
             * @private
             */

        }, {
            key: "add",
            value: function add(text) {
                if (text === " ") {
                    this.spacing = true;
                }

                if (this.spacing) {
                    this.buffer += " ";
                    this.spacing = false;
                }

                if (text != " ") {
                    this.buffer += text;
                }
            }
            /**
             * Handle parsing of whitespace
             *
             * @param {string} ch  the character to check
             * @returns {boolean} true if the character was processed as whitespace, false otherwise
             */

        }, {
            key: "parseWS",
            value: function parseWS(ch) {
                if (/[ \t]/.test(ch)) {
                    if (!this.mono) {
                        this.spacing = true;
                    } else {
                        this.add(ch);
                    }

                    return true;
                }

                return false;
            }
            /**
             * @param {string} tagName  label for block type to set
             * @private
             */

        }, {
            key: "setTag",
            value: function setTag(tagName) {
                this.emitBlock();
                this[tagName] = true;
                this.modStack.unshift(tagName);
            }
            /**
             * @param {string} tagName  label for block type to unset
             * @private
             */

        }, {
            key: "unsetTag",
            value: function unsetTag(tagName) {
                this.emitBlock();
                this[tagName] = false;
                this.modStack.shift();
            }
            /**
             * @param {string} tagName label for block type we are currently processing
             * @param {string|RegExp} tag string to match in text
             * @returns {boolean} true if the tag was processed, false otherwise
             */

        }, {
            key: "parseStartTag",
            value: function parseStartTag(tagName, tag) {
                // Note: if 'mono' passed as tagName, there is a double check here. This is OK
                if (!this.mono && !this[tagName] && this.match(tag)) {
                    this.setTag(tagName);
                    return true;
                }

                return false;
            }
            /**
             * @param {string|RegExp} tag
             * @param {number} [advance=true] if set, advance current position in text
             * @returns {boolean} true if match at given position, false otherwise
             * @private
             */

        }, {
            key: "match",
            value: function match(tag) {
                var advance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                var _this$prepareRegExp = this.prepareRegExp(tag),
                    _this$prepareRegExp2 = _slicedToArray(_this$prepareRegExp, 2),
                    regExp = _this$prepareRegExp2[0],
                    length = _this$prepareRegExp2[1];

                var matched = regExp.test(this.text.substr(this.position, length));

                if (matched && advance) {
                    this.position += length - 1;
                }

                return matched;
            }
            /**
             * @param {string} tagName label for block type we are currently processing
             * @param {string|RegExp} tag string to match in text
             * @param {RegExp} [nextTag] regular expression to match for characters *following* the current tag
             * @returns {boolean} true if the tag was processed, false otherwise
             */

        }, {
            key: "parseEndTag",
            value: function parseEndTag(tagName, tag, nextTag) {
                var checkTag = this.mod() === tagName;

                if (tagName === "mono") {
                    // special handling for 'mono'
                    checkTag = checkTag && this.mono;
                } else {
                    checkTag = checkTag && !this.mono;
                }

                if (checkTag && this.match(tag)) {
                    if (nextTag !== undefined) {
                        // Purpose of the following match is to prevent a direct unset/set of a given tag
                        // E.g. '*bold **still bold*' => '*bold still bold*'
                        if (this.position === this.text.length - 1 || this.match(nextTag, false)) {
                            this.unsetTag(tagName);
                        }
                    } else {
                        this.unsetTag(tagName);
                    }

                    return true;
                }

                return false;
            }
            /**
             * @param {string|RegExp} tag  string to match in text
             * @param {value} value  string to replace tag with, if found at current position
             * @returns {boolean} true if the tag was processed, false otherwise
             */

        }, {
            key: "replace",
            value: function replace(tag, value) {
                if (this.match(tag)) {
                    this.add(value);
                    this.position += length - 1;
                    return true;
                }

                return false;
            }
            /**
             * Create a regular expression for the tag if it isn't already one.
             *
             * The return value is an array `[RegExp, number]`, with exactly two value, where:
             *  - RegExp is the regular expression to use
             *  - number is the lenth of the input string to match
             *
             * @param {string|RegExp} tag  string to match in text
             * @returns {Array}  regular expression to use and length of input string to match
             * @private
             */

        }, {
            key: "prepareRegExp",
            value: function prepareRegExp(tag) {
                var length;
                var regExp;

                if (tag instanceof RegExp) {
                    regExp = tag;
                    length = 1; // ASSUMPTION: regexp only tests one character
                } else {
                    // use prepared regexp if present
                    var prepared = tagPattern[tag];

                    if (prepared !== undefined) {
                        regExp = prepared;
                    } else {
                        regExp = new RegExp(tag);
                    }

                    length = tag.length;
                }

                return [regExp, length];
            }
        }]);

        return MarkupAccumulator;
    }();
    /**
     * Helper class for Label which explodes the label text into lines and blocks within lines
     *
     * @private
     */


    var LabelSplitter = /*#__PURE__*/function () {
        /**
         * @param {CanvasRenderingContext2D} ctx Canvas rendering context
         * @param {Label} parent reference to the Label instance using current instance
         * @param {boolean} selected
         * @param {boolean} hover
         */
        function LabelSplitter(ctx, parent, selected, hover) {
            var _this = this;

            _classCallCheck(this, LabelSplitter);

            this.ctx = ctx;
            this.parent = parent;
            this.selected = selected;
            this.hover = hover;
            /**
             * Callback to determine text width; passed to LabelAccumulator instance
             *
             * @param  {string} text string to determine width of
             * @param  {string} mod  font type to use for this text
             * @returns {object} { width, values} width in pixels and font attributes
             */

            var textWidth = function textWidth(text, mod) {
                if (text === undefined) return 0; // TODO: This can be done more efficiently with caching
                // This will set the ctx.font correctly, depending on selected/hover and mod - so that ctx.measureText() will be accurate.

                var values = _this.parent.getFormattingValues(ctx, selected, hover, mod);

                var width = 0;

                if (text !== "") {
                    var measure = _this.ctx.measureText(text);

                    width = measure.width;
                }

                return {
                    width: width,
                    values: values
                };
            };

            this.lines = new LabelAccumulator(textWidth);
        }
        /**
         * Split passed text of a label into lines and blocks.
         *
         * # NOTE
         *
         * The handling of spacing is option dependent:
         *
         * - if `font.multi : false`, all spaces are retained
         * - if `font.multi : true`, every sequence of spaces is compressed to a single space
         *
         * This might not be the best way to do it, but this is as it has been working till now.
         * In order not to break existing functionality, for the time being this behaviour will
         * be retained in any code changes.
         *
         * @param {string} text  text to split
         * @returns {Array<line>}
         */


        _createClass(LabelSplitter, [{
            key: "process",
            value: function process(text) {
                if (!isValidLabel(text)) {
                    return this.lines.finalize();
                }

                var font = this.parent.fontOptions; // Normalize the end-of-line's to a single representation - order important

                text = text.replace(/\r\n/g, "\n"); // Dos EOL's

                text = text.replace(/\r/g, "\n"); // Mac EOL's
                // Note that at this point, there can be no \r's in the text.
                // This is used later on splitStringIntoLines() to split multifont texts.

                var nlLines = String(text).split("\n");
                var lineCount = nlLines.length;

                if (font.multi) {
                    // Multi-font case: styling tags active
                    for (var i = 0; i < lineCount; i++) {
                        var blocks = this.splitBlocks(nlLines[i], font.multi); // Post: Sequences of tabs and spaces are reduced to single space

                        if (blocks === undefined) continue;

                        if (blocks.length === 0) {
                            this.lines.newLine("");
                            continue;
                        }

                        if (font.maxWdt > 0) {
                            // widthConstraint.maximum defined
                            //console.log('Running widthConstraint multi, max: ' + this.fontOptions.maxWdt);
                            for (var j = 0; j < blocks.length; j++) {
                                var mod = blocks[j].mod;
                                var _text = blocks[j].text;
                                this.splitStringIntoLines(_text, mod, true);
                            }
                        } else {
                            // widthConstraint.maximum NOT defined
                            for (var _j = 0; _j < blocks.length; _j++) {
                                var _mod = blocks[_j].mod;
                                var _text2 = blocks[_j].text;
                                this.lines.append(_text2, _mod);
                            }
                        }

                        this.lines.newLine();
                    }
                } else {
                    // Single-font case
                    if (font.maxWdt > 0) {
                        // widthConstraint.maximum defined
                        // console.log('Running widthConstraint normal, max: ' + this.fontOptions.maxWdt);
                        for (var _i = 0; _i < lineCount; _i++) {
                            this.splitStringIntoLines(nlLines[_i]);
                        }
                    } else {
                        // widthConstraint.maximum NOT defined
                        for (var _i2 = 0; _i2 < lineCount; _i2++) {
                            this.lines.newLine(nlLines[_i2]);
                        }
                    }
                }

                return this.lines.finalize();
            }
            /**
             * normalize the markup system
             *
             * @param {boolean|'md'|'markdown'|'html'} markupSystem
             * @returns {string}
             */

        }, {
            key: "decodeMarkupSystem",
            value: function decodeMarkupSystem(markupSystem) {
                var system = "none";

                if (markupSystem === "markdown" || markupSystem === "md") {
                    system = "markdown";
                } else if (markupSystem === true || markupSystem === "html") {
                    system = "html";
                }

                return system;
            }
            /**
             *
             * @param {string} text
             * @returns {Array}
             */

        }, {
            key: "splitHtmlBlocks",
            value: function splitHtmlBlocks(text) {
                var s = new MarkupAccumulator(text);

                var parseEntities = function parseEntities(ch) {
                    if (/&/.test(ch)) {
                        var parsed = s.replace(s.text, "&lt;", "<") || s.replace(s.text, "&amp;", "&");

                        if (!parsed) {
                            s.add("&");
                        }

                        return true;
                    }

                    return false;
                };

                while (s.position < s.text.length) {
                    var ch = s.text.charAt(s.position);
                    var parsed = s.parseWS(ch) || /</.test(ch) && (s.parseStartTag("bold", "<b>") || s.parseStartTag("ital", "<i>") || s.parseStartTag("mono", "<code>") || s.parseEndTag("bold", "</b>") || s.parseEndTag("ital", "</i>") || s.parseEndTag("mono", "</code>")) || parseEntities(ch);

                    if (!parsed) {
                        s.add(ch);
                    }

                    s.position++;
                }

                s.emitBlock();
                return s.blocks;
            }
            /**
             *
             * @param {string} text
             * @returns {Array}
             */

        }, {
            key: "splitMarkdownBlocks",
            value: function splitMarkdownBlocks(text) {
                var _this2 = this;

                var s = new MarkupAccumulator(text);
                var beginable = true;

                var parseOverride = function parseOverride(ch) {
                    if (/\\/.test(ch)) {
                        if (s.position < _this2.text.length + 1) {
                            s.position++;
                            ch = _this2.text.charAt(s.position);

                            if (/ \t/.test(ch)) {
                                s.spacing = true;
                            } else {
                                s.add(ch);
                                beginable = false;
                            }
                        }

                        return true;
                    }

                    return false;
                };

                while (s.position < s.text.length) {
                    var ch = s.text.charAt(s.position);
                    var parsed = s.parseWS(ch) || parseOverride(ch) || (beginable || s.spacing) && (s.parseStartTag("bold", "*") || s.parseStartTag("ital", "_") || s.parseStartTag("mono", "`")) || s.parseEndTag("bold", "*", "afterBold") || s.parseEndTag("ital", "_", "afterItal") || s.parseEndTag("mono", "`", "afterMono");

                    if (!parsed) {
                        s.add(ch);
                        beginable = false;
                    }

                    s.position++;
                }

                s.emitBlock();
                return s.blocks;
            }
            /**
             * Explodes a piece of text into single-font blocks using a given markup
             *
             * @param {string} text
             * @param {boolean|'md'|'markdown'|'html'} markupSystem
             * @returns {Array.<{text: string, mod: string}>}
             * @private
             */

        }, {
            key: "splitBlocks",
            value: function splitBlocks(text, markupSystem) {
                var system = this.decodeMarkupSystem(markupSystem);

                if (system === "none") {
                    return [{
                        text: text,
                        mod: "normal"
                    }];
                } else if (system === "markdown") {
                    return this.splitMarkdownBlocks(text);
                } else if (system === "html") {
                    return this.splitHtmlBlocks(text);
                }
            }
            /**
             * @param {string} text
             * @returns {boolean} true if text length over the current max with
             * @private
             */

        }, {
            key: "overMaxWidth",
            value: function overMaxWidth(text) {
                var width = this.ctx.measureText(text).width;
                return this.lines.curWidth() + width > this.parent.fontOptions.maxWdt;
            }
            /**
             * Determine the longest part of the sentence which still fits in the
             * current max width.
             *
             * @param {Array} words  Array of strings signifying a text lines
             * @returns {number}      index of first item in string making string go over max
             * @private
             */

        }, {
            key: "getLongestFit",
            value: function getLongestFit(words) {
                var text = "";
                var w = 0;

                while (w < words.length) {
                    var pre = text === "" ? "" : " ";
                    var newText = text + pre + words[w];
                    if (this.overMaxWidth(newText)) break;
                    text = newText;
                    w++;
                }

                return w;
            }
            /**
             * Determine the longest part of the string which still fits in the
             * current max width.
             *
             * @param {Array} words Array of strings signifying a text lines
             * @returns {number} index of first item in string making string go over max
             */

        }, {
            key: "getLongestFitWord",
            value: function getLongestFitWord(words) {
                var w = 0;

                while (w < words.length) {
                    if (this.overMaxWidth(slice$1(words).call(words, 0, w))) break;
                    w++;
                }

                return w;
            }
            /**
             * Split the passed text into lines, according to width constraint (if any).
             *
             * The method assumes that the input string is a single line, i.e. without lines break.
             *
             * This method retains spaces, if still present (case `font.multi: false`).
             * A space which falls on an internal line break, will be replaced by a newline.
             * There is no special handling of tabs; these go along with the flow.
             *
             * @param {string} str
             * @param {string} [mod='normal']
             * @param {boolean} [appendLast=false]
             * @private
             */

        }, {
            key: "splitStringIntoLines",
            value: function splitStringIntoLines(str) {
                var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "normal";
                var appendLast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                // Set the canvas context font, based upon the current selected/hover state
                // and the provided mod, so the text measurement performed by getLongestFit
                // will be accurate - and not just use the font of whoever last used the canvas.
                this.parent.getFormattingValues(this.ctx, this.selected, this.hover, mod); // Still-present spaces are relevant, retain them

                str = str.replace(/^( +)/g, "$1\r");
                str = str.replace(/([^\r][^ ]*)( +)/g, "$1\r$2\r");
                var words = str.split("\r");

                while (words.length > 0) {
                    var w = this.getLongestFit(words);

                    if (w === 0) {
                        // Special case: the first word is already larger than the max width.
                        var word = words[0]; // Break the word to the largest part that fits the line

                        var x = this.getLongestFitWord(word);
                        this.lines.newLine(slice$1(word).call(word, 0, x), mod); // Adjust the word, so that the rest will be done next iteration

                        words[0] = slice$1(word).call(word, x);
                    } else {
                        // skip any space that is replaced by a newline
                        var newW = w;

                        if (words[w - 1] === " ") {
                            w--;
                        } else if (words[newW] === " ") {
                            newW++;
                        }

                        var text = slice$1(words).call(words, 0, w).join("");

                        if (w == words.length && appendLast) {
                            this.lines.append(text, mod);
                        } else {
                            this.lines.newLine(text, mod);
                        } // Adjust the word, so that the rest will be done next iteration


                        words = slice$1(words).call(words, newW);
                    }
                }
            }
        }]);

        return LabelSplitter;
    }();

    /**
     * List of special styles for multi-fonts
     *
     * @private
     */

    var multiFontStyle = ["bold", "ital", "boldital", "mono"];
    /**
     * A Label to be used for Nodes or Edges.
     */

    var Label = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {object} options
         * @param {boolean} [edgelabel=false]
         */
        function Label(body, options) {
            var edgelabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            _classCallCheck(this, Label);

            this.body = body;
            this.pointToSelf = false;
            this.baseSize = undefined;
            this.fontOptions = {}; // instance variable containing the *instance-local* font options

            this.setOptions(options);
            this.size = {
                top: 0,
                left: 0,
                width: 0,
                height: 0,
                yLine: 0
            };
            this.isEdgeLabel = edgelabel;
        }
        /**
         * @param {object} options the options of the parent Node-instance
         */


        _createClass(Label, [{
            key: "setOptions",
            value: function setOptions(options) {
                this.elementOptions = options; // Reference to the options of the parent Node-instance

                this.initFontOptions(options.font);

                if (isValidLabel(options.label)) {
                    this.labelDirty = true;
                } else {
                    // Bad label! Change the option value to prevent bad stuff happening
                    options.label = undefined;
                }

                if (options.font !== undefined && options.font !== null) {
                    // font options can be deleted at various levels
                    if (typeof options.font === "string") {
                        this.baseSize = this.fontOptions.size;
                    } else if (_typeof(options.font) === "object") {
                        var size = options.font.size;

                        if (size !== undefined) {
                            this.baseSize = size;
                        }
                    }
                }
            }
            /**
             * Init the font Options structure.
             *
             * Member fontOptions serves as an accumulator for the current font options.
             * As such, it needs to be completely separated from the node options.
             *
             * @param {object} newFontOptions the new font options to process
             * @private
             */

        }, {
            key: "initFontOptions",
            value: function initFontOptions(newFontOptions) {
                var _this = this;

                // Prepare the multi-font option objects.
                // These will be filled in propagateFonts(), if required
                forEach$1(multiFontStyle, function (style) {
                    _this.fontOptions[style] = {};
                }); // Handle shorthand option, if present

                if (Label.parseFontString(this.fontOptions, newFontOptions)) {
                    this.fontOptions.vadjust = 0;
                    return;
                } // Copy over the non-multifont options, if specified


                forEach$1(newFontOptions, function (prop, n) {
                    if (prop !== undefined && prop !== null && _typeof(prop) !== "object") {
                        _this.fontOptions[n] = prop;
                    }
                });
            }
            /**
             * If in-variable is a string, parse it as a font specifier.
             *
             * Note that following is not done here and have to be done after the call:
             * - Not all font options are set (vadjust, mod)
             *
             * @param {object} outOptions  out-parameter, object in which to store the parse results (if any)
             * @param {object} inOptions  font options to parse
             * @returns {boolean} true if font parsed as string, false otherwise
             * @static
             */

        }, {
            key: "constrain",
            value:
                /**
                 * Set the width and height constraints based on 'nearest' value
                 *
                 * @param {Array} pile array of option objects to consider
                 * @returns {object} the actual constraint values to use
                 * @private
                 */
                function constrain(pile) {
                    // NOTE: constrainWidth and  constrainHeight never set!
                    // NOTE: for edge labels, only 'maxWdt' set
                    // Node labels can set all the fields
                    var fontOptions = {
                        constrainWidth: false,
                        maxWdt: -1,
                        minWdt: -1,
                        constrainHeight: false,
                        minHgt: -1,
                        valign: "middle"
                    };
                    var widthConstraint = topMost(pile, "widthConstraint");

                    if (typeof widthConstraint === "number") {
                        fontOptions.maxWdt = Number(widthConstraint);
                        fontOptions.minWdt = Number(widthConstraint);
                    } else if (_typeof(widthConstraint) === "object") {
                        var widthConstraintMaximum = topMost(pile, ["widthConstraint", "maximum"]);

                        if (typeof widthConstraintMaximum === "number") {
                            fontOptions.maxWdt = Number(widthConstraintMaximum);
                        }

                        var widthConstraintMinimum = topMost(pile, ["widthConstraint", "minimum"]);

                        if (typeof widthConstraintMinimum === "number") {
                            fontOptions.minWdt = Number(widthConstraintMinimum);
                        }
                    }

                    var heightConstraint = topMost(pile, "heightConstraint");

                    if (typeof heightConstraint === "number") {
                        fontOptions.minHgt = Number(heightConstraint);
                    } else if (_typeof(heightConstraint) === "object") {
                        var heightConstraintMinimum = topMost(pile, ["heightConstraint", "minimum"]);

                        if (typeof heightConstraintMinimum === "number") {
                            fontOptions.minHgt = Number(heightConstraintMinimum);
                        }

                        var heightConstraintValign = topMost(pile, ["heightConstraint", "valign"]);

                        if (typeof heightConstraintValign === "string") {
                            if (heightConstraintValign === "top" || heightConstraintValign === "bottom") {
                                fontOptions.valign = heightConstraintValign;
                            }
                        }
                    }

                    return fontOptions;
                }
            /**
             * Set options and update internal state
             *
             * @param {object} options  options to set
             * @param {Array}  pile     array of option objects to consider for option 'chosen'
             */

        }, {
            key: "update",
            value: function update(options, pile) {
                this.setOptions(options, true);
                this.propagateFonts(pile);
                deepExtend(this.fontOptions, this.constrain(pile));
                this.fontOptions.chooser = choosify("label", pile);
            }
            /**
             * When margins are set in an element, adjust sizes is called to remove them
             * from the width/height constraints. This must be done prior to label sizing.
             *
             * @param {{top: number, right: number, bottom: number, left: number}} margins
             */

        }, {
            key: "adjustSizes",
            value: function adjustSizes(margins) {
                var widthBias = margins ? margins.right + margins.left : 0;

                if (this.fontOptions.constrainWidth) {
                    this.fontOptions.maxWdt -= widthBias;
                    this.fontOptions.minWdt -= widthBias;
                }

                var heightBias = margins ? margins.top + margins.bottom : 0;

                if (this.fontOptions.constrainHeight) {
                    this.fontOptions.minHgt -= heightBias;
                }
            } /////////////////////////////////////////////////////////
            // Methods for handling options piles
            // Eventually, these will be moved to a separate class
            /////////////////////////////////////////////////////////

            /**
             * Add the font members of the passed list of option objects to the pile.
             *
             * @param {Pile} dstPile  pile of option objects add to
             * @param {Pile} srcPile  pile of option objects to take font options from
             * @private
             */

        }, {
            key: "addFontOptionsToPile",
            value: function addFontOptionsToPile(dstPile, srcPile) {
                for (var i = 0; i < srcPile.length; ++i) {
                    this.addFontToPile(dstPile, srcPile[i]);
                }
            }
            /**
             * Add given font option object to the list of objects (the 'pile') to consider for determining
             * multi-font option values.
             *
             * @param {Pile} pile  pile of option objects to use
             * @param {object} options  instance to add to pile
             * @private
             */

        }, {
            key: "addFontToPile",
            value: function addFontToPile(pile, options) {
                if (options === undefined) return;
                if (options.font === undefined || options.font === null) return;
                var item = options.font;
                pile.push(item);
            }
            /**
             * Collect all own-property values from the font pile that aren't multi-font option objectss.
             *
             * @param {Pile} pile  pile of option objects to use
             * @returns {object} object with all current own basic font properties
             * @private
             */

        }, {
            key: "getBasicOptions",
            value: function getBasicOptions(pile) {
                var ret = {}; // Scans the whole pile to get all options present

                for (var n = 0; n < pile.length; ++n) {
                    var fontOptions = pile[n]; // Convert shorthand if necessary

                    var tmpShorthand = {};

                    if (Label.parseFontString(tmpShorthand, fontOptions)) {
                        fontOptions = tmpShorthand;
                    }

                    forEach$1(fontOptions, function (opt, name) {
                        if (opt === undefined) return; // multi-font option need not be present

                        if (Object.prototype.hasOwnProperty.call(ret, name)) return; // Keep first value we encounter

                        if (indexOf(multiFontStyle).call(multiFontStyle, name) !== -1) {
                            // Skip multi-font properties but we do need the structure
                            ret[name] = {};
                        } else {
                            ret[name] = opt;
                        }
                    });
                }

                return ret;
            }
            /**
             * Return the value for given option for the given multi-font.
             *
             * All available option objects are trawled in the set order to construct the option values.
             *
             * ---------------------------------------------------------------------
             * ## Traversal of pile for multi-fonts
             *
             * The determination of multi-font option values is a special case, because any values not
             * present in the multi-font options should by definition be taken from the main font options,
             * i.e. from the current 'parent' object of the multi-font option.
             *
             * ### Search order for multi-fonts
             *
             * 'bold' used as example:
             *
             *   - search in option group 'bold' in local properties
             *   - search in main font option group in local properties
             *
             * ---------------------------------------------------------------------
             *
             * @param {Pile} pile  pile of option objects to use
             * @param {MultiFontStyle} multiName sub path for the multi-font
             * @param {string} option  the option to search for, for the given multi-font
             * @returns {string|number} the value for the given option
             * @private
             */

        }, {
            key: "getFontOption",
            value: function getFontOption(pile, multiName, option) {
                var multiFont; // Search multi font in local properties

                for (var n = 0; n < pile.length; ++n) {
                    var fontOptions = pile[n];

                    if (Object.prototype.hasOwnProperty.call(fontOptions, multiName)) {
                        multiFont = fontOptions[multiName];
                        if (multiFont === undefined || multiFont === null) continue; // Convert shorthand if necessary
                        // TODO: inefficient to do this conversion every time; find a better way.

                        var tmpShorthand = {};

                        if (Label.parseFontString(tmpShorthand, multiFont)) {
                            multiFont = tmpShorthand;
                        }

                        if (Object.prototype.hasOwnProperty.call(multiFont, option)) {
                            return multiFont[option];
                        }
                    }
                } // Option is not mentioned in the multi font options; take it from the parent font options.
                // These have already been converted with getBasicOptions(), so use the converted values.


                if (Object.prototype.hasOwnProperty.call(this.fontOptions, option)) {
                    return this.fontOptions[option];
                } // A value **must** be found; you should never get here.


                throw new Error("Did not find value for multi-font for property: '" + option + "'");
            }
            /**
             * Return all options values for the given multi-font.
             *
             * All available option objects are trawled in the set order to construct the option values.
             *
             * @param {Pile} pile  pile of option objects to use
             * @param {MultiFontStyle} multiName sub path for the mod-font
             * @returns {MultiFontOptions}
             * @private
             */

        }, {
            key: "getFontOptions",
            value: function getFontOptions(pile, multiName) {
                var result = {};
                var optionNames = ["color", "size", "face", "mod", "vadjust"]; // List of allowed options per multi-font

                for (var i = 0; i < optionNames.length; ++i) {
                    var mod = optionNames[i];
                    result[mod] = this.getFontOption(pile, multiName, mod);
                }

                return result;
            } /////////////////////////////////////////////////////////
            // End methods for handling options piles
            /////////////////////////////////////////////////////////

            /**
             * Collapse the font options for the multi-font to single objects, from
             * the chain of option objects passed (the 'pile').
             *
             * @param {Pile} pile  sequence of option objects to consider.
             *                     First item in list assumed to be the newly set options.
             */

        }, {
            key: "propagateFonts",
            value: function propagateFonts(pile) {
                var _this2 = this;

                var fontPile = []; // sequence of font objects to consider, order important
                // Note that this.elementOptions is not used here.

                this.addFontOptionsToPile(fontPile, pile);
                this.fontOptions = this.getBasicOptions(fontPile); // We set multifont values even if multi === false, for consistency (things break otherwise)

                var _loop = function _loop(i) {
                    var mod = multiFontStyle[i];
                    var modOptions = _this2.fontOptions[mod];

                    var tmpMultiFontOptions = _this2.getFontOptions(fontPile, mod); // Copy over found values


                    forEach$1(tmpMultiFontOptions, function (option, n) {
                        modOptions[n] = option;
                    });
                    modOptions.size = Number(modOptions.size);
                    modOptions.vadjust = Number(modOptions.vadjust);
                };

                for (var i = 0; i < multiFontStyle.length; ++i) {
                    _loop(i);
                }
            }
            /**
             * Main function. This is called from anything that wants to draw a label.
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x
             * @param {number} y
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {string} [baseline='middle']
             */

        }, {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover) {
                var baseline = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "middle";
                // if no label, return
                if (this.elementOptions.label === undefined) return; // check if we have to render the label

                var viewFontSize = this.fontOptions.size * this.body.view.scale;
                if (this.elementOptions.label && viewFontSize < this.elementOptions.scaling.label.drawThreshold - 1) return; // This ensures that there will not be HUGE letters on screen
                // by setting an upper limit on the visible text size (regardless of zoomLevel)

                if (viewFontSize >= this.elementOptions.scaling.label.maxVisible) {
                    viewFontSize = Number(this.elementOptions.scaling.label.maxVisible) / this.body.view.scale;
                } // update the size cache if required


                this.calculateLabelSize(ctx, selected, hover, x, y, baseline);

                this._drawBackground(ctx);

                this._drawText(ctx, x, this.size.yLine, baseline, viewFontSize);
            }
            /**
             * Draws the label background
             *
             * @param {CanvasRenderingContext2D} ctx
             * @private
             */

        }, {
            key: "_drawBackground",
            value: function _drawBackground(ctx) {
                if (this.fontOptions.background !== undefined && this.fontOptions.background !== "none") {
                    ctx.fillStyle = this.fontOptions.background;
                    var size = this.getSize();
                    ctx.fillRect(size.left, size.top, size.width, size.height);
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x
             * @param {number} y
             * @param {string} [baseline='middle']
             * @param {number} viewFontSize
             * @private
             */

        }, {
            key: "_drawText",
            value: function _drawText(ctx, x, y) {
                var baseline = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "middle";
                var viewFontSize = arguments.length > 4 ? arguments[4] : undefined;

                var _this$_setAlignment = this._setAlignment(ctx, x, y, baseline);

                var _this$_setAlignment2 = _slicedToArray(_this$_setAlignment, 2);

                x = _this$_setAlignment2[0];
                y = _this$_setAlignment2[1];
                ctx.textAlign = "left";
                x = x - this.size.width / 2; // Shift label 1/2-distance to the left

                if (this.fontOptions.valign && this.size.height > this.size.labelHeight) {
                    if (this.fontOptions.valign === "top") {
                        y -= (this.size.height - this.size.labelHeight) / 2;
                    }

                    if (this.fontOptions.valign === "bottom") {
                        y += (this.size.height - this.size.labelHeight) / 2;
                    }
                } // draw the text


                for (var i = 0; i < this.lineCount; i++) {
                    var line = this.lines[i];

                    if (line && line.blocks) {
                        var width = 0;

                        if (this.isEdgeLabel || this.fontOptions.align === "center") {
                            width += (this.size.width - line.width) / 2;
                        } else if (this.fontOptions.align === "right") {
                            width += this.size.width - line.width;
                        }

                        for (var j = 0; j < line.blocks.length; j++) {
                            var block = line.blocks[j];
                            ctx.font = block.font;

                            var _this$_getColor = this._getColor(block.color, viewFontSize, block.strokeColor),
                                _this$_getColor2 = _slicedToArray(_this$_getColor, 2),
                                fontColor = _this$_getColor2[0],
                                strokeColor = _this$_getColor2[1];

                            if (block.strokeWidth > 0) {
                                ctx.lineWidth = block.strokeWidth;
                                ctx.strokeStyle = strokeColor;
                                ctx.lineJoin = "round";
                            }

                            ctx.fillStyle = fontColor;

                            if (block.strokeWidth > 0) {
                                ctx.strokeText(block.text, x + width, y + block.vadjust);
                            }

                            ctx.fillText(block.text, x + width, y + block.vadjust);
                            width += block.width;
                        }

                        y += line.height;
                    }
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x
             * @param {number} y
             * @param {string} baseline
             * @returns {Array.<number>}
             * @private
             */

        }, {
            key: "_setAlignment",
            value: function _setAlignment(ctx, x, y, baseline) {
                // check for label alignment (for edges)
                // TODO: make alignment for nodes
                if (this.isEdgeLabel && this.fontOptions.align !== "horizontal" && this.pointToSelf === false) {
                    x = 0;
                    y = 0;
                    var lineMargin = 2;

                    if (this.fontOptions.align === "top") {
                        ctx.textBaseline = "alphabetic";
                        y -= 2 * lineMargin; // distance from edge, required because we use alphabetic. Alphabetic has less difference between browsers
                    } else if (this.fontOptions.align === "bottom") {
                        ctx.textBaseline = "hanging";
                        y += 2 * lineMargin; // distance from edge, required because we use hanging. Hanging has less difference between browsers
                    } else {
                        ctx.textBaseline = "middle";
                    }
                } else {
                    ctx.textBaseline = baseline;
                }

                return [x, y];
            }
            /**
             * fade in when relative scale is between threshold and threshold - 1.
             * If the relative scale would be smaller than threshold -1 the draw function would have returned before coming here.
             *
             * @param {string} color  The font color to use
             * @param {number} viewFontSize
             * @param {string} initialStrokeColor
             * @returns {Array.<string>} An array containing the font color and stroke color
             * @private
             */

        }, {
            key: "_getColor",
            value: function _getColor(color, viewFontSize, initialStrokeColor) {
                var fontColor = color || "#000000";
                var strokeColor = initialStrokeColor || "#ffffff";

                if (viewFontSize <= this.elementOptions.scaling.label.drawThreshold) {
                    var opacity = Math.max(0, Math.min(1, 1 - (this.elementOptions.scaling.label.drawThreshold - viewFontSize)));
                    fontColor = overrideOpacity(fontColor, opacity);
                    strokeColor = overrideOpacity(strokeColor, opacity);
                }

                return [fontColor, strokeColor];
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {boolean} selected
             * @param {boolean} hover
             * @returns {{width: number, height: number}}
             */

        }, {
            key: "getTextSize",
            value: function getTextSize(ctx) {
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                this._processLabel(ctx, selected, hover);

                return {
                    width: this.size.width,
                    height: this.size.height,
                    lineCount: this.lineCount
                };
            }
            /**
             * Get the current dimensions of the label
             *
             * @returns {rect}
             */

        }, {
            key: "getSize",
            value: function getSize() {
                var lineMargin = 2;
                var x = this.size.left; // default values which might be overridden below

                var y = this.size.top - 0.5 * lineMargin; // idem

                if (this.isEdgeLabel) {
                    var x2 = -this.size.width * 0.5;

                    switch (this.fontOptions.align) {
                        case "middle":
                            x = x2;
                            y = -this.size.height * 0.5;
                            break;

                        case "top":
                            x = x2;
                            y = -(this.size.height + lineMargin);
                            break;

                        case "bottom":
                            x = x2;
                            y = lineMargin;
                            break;
                    }
                }

                var ret = {
                    left: x,
                    top: y,
                    width: this.size.width,
                    height: this.size.height
                };
                return ret;
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {number} [x=0]
             * @param {number} [y=0]
             * @param {'middle'|'hanging'} [baseline='middle']
             */

        }, {
            key: "calculateLabelSize",
            value: function calculateLabelSize(ctx, selected, hover) {
                var x = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var y = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
                var baseline = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "middle";

                this._processLabel(ctx, selected, hover);

                this.size.left = x - this.size.width * 0.5;
                this.size.top = y - this.size.height * 0.5;
                this.size.yLine = y + (1 - this.lineCount) * 0.5 * this.fontOptions.size;

                if (baseline === "hanging") {
                    this.size.top += 0.5 * this.fontOptions.size;
                    this.size.top += 4; // distance from node, required because we use hanging. Hanging has less difference between browsers

                    this.size.yLine += 4; // distance from node
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {string} mod
             * @returns {{color, size, face, mod, vadjust, strokeWidth: *, strokeColor: (*|string|allOptions.edges.font.strokeColor|{string}|allOptions.nodes.font.strokeColor|Array)}}
             */

        }, {
            key: "getFormattingValues",
            value: function getFormattingValues(ctx, selected, hover, mod) {
                var getValue = function getValue(fontOptions, mod, option) {
                    if (mod === "normal") {
                        if (option === "mod") return "";
                        return fontOptions[option];
                    }

                    if (fontOptions[mod][option] !== undefined) {
                        // Grumbl leaving out test on undefined equals false for ""
                        return fontOptions[mod][option];
                    } else {
                        // Take from parent font option
                        return fontOptions[option];
                    }
                };

                var values = {
                    color: getValue(this.fontOptions, mod, "color"),
                    size: getValue(this.fontOptions, mod, "size"),
                    face: getValue(this.fontOptions, mod, "face"),
                    mod: getValue(this.fontOptions, mod, "mod"),
                    vadjust: getValue(this.fontOptions, mod, "vadjust"),
                    strokeWidth: this.fontOptions.strokeWidth,
                    strokeColor: this.fontOptions.strokeColor
                };

                if (selected || hover) {
                    if (mod === "normal" && this.fontOptions.chooser === true && this.elementOptions.labelHighlightBold) {
                        values.mod = "bold";
                    } else {
                        if (typeof this.fontOptions.chooser === "function") {
                            this.fontOptions.chooser(values, this.elementOptions.id, selected, hover);
                        }
                    }
                }

                var fontString = "";

                if (values.mod !== undefined && values.mod !== "") {
                    // safeguard for undefined - this happened
                    fontString += values.mod + " ";
                }

                fontString += values.size + "px " + values.face;
                ctx.font = fontString.replace(/"/g, "");
                values.font = ctx.font;
                values.height = values.size;
                return values;
            }
            /**
             *
             * @param {boolean} selected
             * @param {boolean} hover
             * @returns {boolean}
             */

        }, {
            key: "differentState",
            value: function differentState(selected, hover) {
                return selected !== this.selectedState || hover !== this.hoverState;
            }
            /**
             * This explodes the passed text into lines and determines the width, height and number of lines.
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {string} inText  the text to explode
             * @returns {{width, height, lines}|*}
             * @private
             */

        }, {
            key: "_processLabelText",
            value: function _processLabelText(ctx, selected, hover, inText) {
                var splitter = new LabelSplitter(ctx, this, selected, hover);
                return splitter.process(inText);
            }
            /**
             * This explodes the label string into lines and sets the width, height and number of lines.
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {boolean} selected
             * @param {boolean} hover
             * @private
             */

        }, {
            key: "_processLabel",
            value: function _processLabel(ctx, selected, hover) {
                if (this.labelDirty === false && !this.differentState(selected, hover)) return;

                var state = this._processLabelText(ctx, selected, hover, this.elementOptions.label);

                if (this.fontOptions.minWdt > 0 && state.width < this.fontOptions.minWdt) {
                    state.width = this.fontOptions.minWdt;
                }

                this.size.labelHeight = state.height;

                if (this.fontOptions.minHgt > 0 && state.height < this.fontOptions.minHgt) {
                    state.height = this.fontOptions.minHgt;
                }

                this.lines = state.lines;
                this.lineCount = state.lines.length;
                this.size.width = state.width;
                this.size.height = state.height;
                this.selectedState = selected;
                this.hoverState = hover;
                this.labelDirty = false;
            }
            /**
             * Check if this label is visible
             *
             * @returns {boolean} true if this label will be show, false otherwise
             */

        }, {
            key: "visible",
            value: function visible() {
                if (this.size.width === 0 || this.size.height === 0 || this.elementOptions.label === undefined) {
                    return false; // nothing to display
                }

                var viewFontSize = this.fontOptions.size * this.body.view.scale;

                if (viewFontSize < this.elementOptions.scaling.label.drawThreshold - 1) {
                    return false; // Too small or too far away to show
                }

                return true;
            }
        }], [{
            key: "parseFontString",
            value: function parseFontString(outOptions, inOptions) {
                if (!inOptions || typeof inOptions !== "string") return false;
                var newOptionsArray = inOptions.split(" ");
                outOptions.size = +newOptionsArray[0].replace("px", "");
                outOptions.face = newOptionsArray[1];
                outOptions.color = newOptionsArray[2];
                return true;
            }
        }]);

        return Label;
    }();

    /**
     * The Base class for all Nodes.
     */
    var NodeBase = /*#__PURE__*/function () {
        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function NodeBase(options, body, labelModule) {
            _classCallCheck(this, NodeBase);

            this.body = body;
            this.labelModule = labelModule;
            this.setOptions(options);
            this.top = undefined;
            this.left = undefined;
            this.height = undefined;
            this.width = undefined;
            this.radius = undefined;
            this.margin = undefined;
            this.refreshNeeded = true;
            this.boundingBox = {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
            };
        }
        /**
         *
         * @param {object} options
         */


        _createClass(NodeBase, [{
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
            }
            /**
             *
             * @param {Label} labelModule
             * @private
             */

        }, {
            key: "_setMargins",
            value: function _setMargins(labelModule) {
                this.margin = {};

                if (this.options.margin) {
                    if (_typeof(this.options.margin) == "object") {
                        this.margin.top = this.options.margin.top;
                        this.margin.right = this.options.margin.right;
                        this.margin.bottom = this.options.margin.bottom;
                        this.margin.left = this.options.margin.left;
                    } else {
                        this.margin.top = this.options.margin;
                        this.margin.right = this.options.margin;
                        this.margin.bottom = this.options.margin;
                        this.margin.left = this.options.margin;
                    }
                }

                labelModule.adjustSizes(this.margin);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             * @private
             */

        }, {
            key: "_distanceToBorder",
            value: function _distanceToBorder(ctx, angle) {
                var borderWidth = this.options.borderWidth;

                if (ctx) {
                    this.resize(ctx);
                }

                return Math.min(Math.abs(this.width / 2 / Math.cos(angle)), Math.abs(this.height / 2 / Math.sin(angle))) + borderWidth;
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {ArrowOptions} values
             */

        }, {
            key: "enableShadow",
            value: function enableShadow(ctx, values) {
                if (values.shadow) {
                    ctx.shadowColor = values.shadowColor;
                    ctx.shadowBlur = values.shadowSize;
                    ctx.shadowOffsetX = values.shadowX;
                    ctx.shadowOffsetY = values.shadowY;
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {ArrowOptions} values
             */

        }, {
            key: "disableShadow",
            value: function disableShadow(ctx, values) {
                if (values.shadow) {
                    ctx.shadowColor = "rgba(0,0,0,0)";
                    ctx.shadowBlur = 0;
                    ctx.shadowOffsetX = 0;
                    ctx.shadowOffsetY = 0;
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {ArrowOptions} values
             */

        }, {
            key: "enableBorderDashes",
            value: function enableBorderDashes(ctx, values) {
                if (values.borderDashes !== false) {
                    if (ctx.setLineDash !== undefined) {
                        var dashes = values.borderDashes;

                        if (dashes === true) {
                            dashes = [5, 15];
                        }

                        ctx.setLineDash(dashes);
                    } else {
                        console.warn("setLineDash is not supported in this browser. The dashed borders cannot be used.");
                        this.options.shapeProperties.borderDashes = false;
                        values.borderDashes = false;
                    }
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {ArrowOptions} values
             */

        }, {
            key: "disableBorderDashes",
            value: function disableBorderDashes(ctx, values) {
                if (values.borderDashes !== false) {
                    if (ctx.setLineDash !== undefined) {
                        ctx.setLineDash([0]);
                    } else {
                        console.warn("setLineDash is not supported in this browser. The dashed borders cannot be used.");
                        this.options.shapeProperties.borderDashes = false;
                        values.borderDashes = false;
                    }
                }
            }
            /**
             * Determine if the shape of a node needs to be recalculated.
             *
             * @param {boolean} selected
             * @param {boolean} hover
             * @returns {boolean}
             * @protected
             */

        }, {
            key: "needsRefresh",
            value: function needsRefresh(selected, hover) {
                if (this.refreshNeeded === true) {
                    // This is probably not the best location to reset this member.
                    // However, in the current logic, it is the most convenient one.
                    this.refreshNeeded = false;
                    return true;
                }

                return this.width === undefined || this.labelModule.differentState(selected, hover);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {ArrowOptions} values
             */

        }, {
            key: "initContextForDraw",
            value: function initContextForDraw(ctx, values) {
                var borderWidth = values.borderWidth / this.body.view.scale;
                ctx.lineWidth = Math.min(this.width, borderWidth);
                ctx.strokeStyle = values.borderColor;
                ctx.fillStyle = values.color;
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {ArrowOptions} values
             */

        }, {
            key: "performStroke",
            value: function performStroke(ctx, values) {
                var borderWidth = values.borderWidth / this.body.view.scale; //draw dashed border if enabled, save and restore is required for firefox not to crash on unix.

                ctx.save(); // if borders are zero width, they will be drawn with width 1 by default. This prevents that

                if (borderWidth > 0) {
                    this.enableBorderDashes(ctx, values); //draw the border

                    ctx.stroke(); //disable dashed border for other elements

                    this.disableBorderDashes(ctx, values);
                }

                ctx.restore();
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {ArrowOptions} values
             */

        }, {
            key: "performFill",
            value: function performFill(ctx, values) {
                ctx.save();
                ctx.fillStyle = values.color; // draw shadow if enabled

                this.enableShadow(ctx, values); // draw the background

                fill(ctx).call(ctx); // disable shadows for other elements.


                this.disableShadow(ctx, values);
                ctx.restore();
                this.performStroke(ctx, values);
            }
            /**
             *
             * @param {number} margin
             * @private
             */

        }, {
            key: "_addBoundingBoxMargin",
            value: function _addBoundingBoxMargin(margin) {
                this.boundingBox.left -= margin;
                this.boundingBox.top -= margin;
                this.boundingBox.bottom += margin;
                this.boundingBox.right += margin;
            }
            /**
             * Actual implementation of this method call.
             *
             * Doing it like this makes it easier to override
             * in the child classes.
             *
             * @param {number} x width
             * @param {number} y height
             * @param {CanvasRenderingContext2D} ctx
             * @param {boolean} selected
             * @param {boolean} hover
             * @private
             */

        }, {
            key: "_updateBoundingBox",
            value: function _updateBoundingBox(x, y, ctx, selected, hover) {
                if (ctx !== undefined) {
                    this.resize(ctx, selected, hover);
                }

                this.left = x - this.width / 2;
                this.top = y - this.height / 2;
                this.boundingBox.left = this.left;
                this.boundingBox.top = this.top;
                this.boundingBox.bottom = this.top + this.height;
                this.boundingBox.right = this.left + this.width;
            }
            /**
             * Default implementation of this method call.
             * This acts as a stub which can be overridden.
             *
             * @param {number} x width
             * @param {number} y height
             * @param {CanvasRenderingContext2D} ctx
             * @param {boolean} selected
             * @param {boolean} hover
             */

        }, {
            key: "updateBoundingBox",
            value: function updateBoundingBox(x, y, ctx, selected, hover) {
                this._updateBoundingBox(x, y, ctx, selected, hover);
            }
            /**
             * Determine the dimensions to use for nodes with an internal label
             *
             * Currently, these are: Circle, Ellipse, Database, Box
             * The other nodes have external labels, and will not call this method
             *
             * If there is no label, decent default values are supplied.
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {boolean} [selected]
             * @param {boolean} [hover]
             * @returns {{width:number, height:number}}
             */

        }, {
            key: "getDimensionsFromLabel",
            value: function getDimensionsFromLabel(ctx, selected, hover) {
                // NOTE: previously 'textSize' was not put in 'this' for Ellipse
                // TODO: examine the consequences.
                this.textSize = this.labelModule.getTextSize(ctx, selected, hover);
                var width = this.textSize.width;
                var height = this.textSize.height;
                var DEFAULT_SIZE = 14;

                if (width === 0) {
                    // This happens when there is no label text set
                    width = DEFAULT_SIZE; // use a decent default

                    height = DEFAULT_SIZE; // if width zero, then height also always zero
                }

                return {
                    width: width,
                    height: height
                };
            }
        }]);

        return NodeBase;
    }();

    function _createSuper$s(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$s(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$s() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Box Node/Cluster shape.
     *
     * @augments NodeBase
     */

    var Box$1 = /*#__PURE__*/function (_NodeBase) {
        _inherits(Box, _NodeBase);

        var _super = _createSuper$s(Box);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Box(options, body, labelModule) {
            var _this;

            _classCallCheck(this, Box);

            _this = _super.call(this, options, body, labelModule);

            _this._setMargins(labelModule);

            return _this;
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {boolean} [selected]
         * @param {boolean} [hover]
         */


        _createClass(Box, [{
            key: "resize",
            value: function resize(ctx) {
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
                var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;

                if (this.needsRefresh(selected, hover)) {
                    var dimensions = this.getDimensionsFromLabel(ctx, selected, hover);
                    this.width = dimensions.width + this.margin.right + this.margin.left;
                    this.height = dimensions.height + this.margin.top + this.margin.bottom;
                    this.radius = this.width / 2;
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {ArrowOptions} values
             */

        }, {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                this.resize(ctx, selected, hover);
                this.left = x - this.width / 2;
                this.top = y - this.height / 2;
                this.initContextForDraw(ctx, values);
                drawRoundRect(ctx, this.left, this.top, this.width, this.height, values.borderRadius);
                this.performFill(ctx, values);
                this.updateBoundingBox(x, y, ctx, selected, hover);
                this.labelModule.draw(ctx, this.left + this.textSize.width / 2 + this.margin.left, this.top + this.textSize.height / 2 + this.margin.top, selected, hover);
            }
            /**
             *
             * @param {number} x width
             * @param {number} y height
             * @param {CanvasRenderingContext2D} ctx
             * @param {boolean} selected
             * @param {boolean} hover
             */

        }, {
            key: "updateBoundingBox",
            value: function updateBoundingBox(x, y, ctx, selected, hover) {
                this._updateBoundingBox(x, y, ctx, selected, hover);

                var borderRadius = this.options.shapeProperties.borderRadius; // only effective for box

                this._addBoundingBoxMargin(borderRadius);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                if (ctx) {
                    this.resize(ctx);
                }

                var borderWidth = this.options.borderWidth;
                return Math.min(Math.abs(this.width / 2 / Math.cos(angle)), Math.abs(this.height / 2 / Math.sin(angle))) + borderWidth;
            }
        }]);

        return Box;
    }(NodeBase);

    function _createSuper$r(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$r(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$r() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * NOTE: This is a bad base class
     *
     * Child classes are:
     *
     *   Image       - uses *only* image methods
     *   Circle      - uses *only* _drawRawCircle
     *   CircleImage - uses all
     *
     * TODO: Refactor, move _drawRawCircle to different module, derive Circle from NodeBase
     *       Rename this to ImageBase
     *       Consolidate common code in Image and CircleImage to base class
     *
     * @augments NodeBase
     */

    var CircleImageBase = /*#__PURE__*/function (_NodeBase) {
        _inherits(CircleImageBase, _NodeBase);

        var _super = _createSuper$r(CircleImageBase);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function CircleImageBase(options, body, labelModule) {
            var _this;

            _classCallCheck(this, CircleImageBase);

            _this = _super.call(this, options, body, labelModule);
            _this.labelOffset = 0;
            _this.selected = false;
            return _this;
        }
        /**
         *
         * @param {object} options
         * @param {object} [imageObj]
         * @param {object} [imageObjAlt]
         */


        _createClass(CircleImageBase, [{
            key: "setOptions",
            value: function setOptions(options, imageObj, imageObjAlt) {
                this.options = options;

                if (!(imageObj === undefined && imageObjAlt === undefined)) {
                    this.setImages(imageObj, imageObjAlt);
                }
            }
            /**
             * Set the images for this node.
             *
             * The images can be updated after the initial setting of options;
             * therefore, this method needs to be reentrant.
             *
             * For correct working in error cases, it is necessary to properly set
             * field 'nodes.brokenImage' in the options.
             *
             * @param {Image} imageObj  required; main image to show for this node
             * @param {Image|undefined} imageObjAlt optional; image to show when node is selected
             */

        }, {
            key: "setImages",
            value: function setImages(imageObj, imageObjAlt) {
                if (imageObjAlt && this.selected) {
                    this.imageObj = imageObjAlt;
                    this.imageObjAlt = imageObj;
                } else {
                    this.imageObj = imageObj;
                    this.imageObjAlt = imageObjAlt;
                }
            }
            /**
             * Set selection and switch between the base and the selected image.
             *
             * Do the switch only if imageObjAlt exists.
             *
             * @param {boolean} selected value of new selected state for current node
             */

        }, {
            key: "switchImages",
            value: function switchImages(selected) {
                var selection_changed = selected && !this.selected || !selected && this.selected;
                this.selected = selected; // Remember new selection

                if (this.imageObjAlt !== undefined && selection_changed) {
                    var imageTmp = this.imageObj;
                    this.imageObj = this.imageObjAlt;
                    this.imageObjAlt = imageTmp;
                }
            }
            /**
             * Returns Image Padding from node options
             *
             * @returns {{top: number,left: number,bottom: number,right: number}} image padding inside this shape
             * @private
             */

        }, {
            key: "_getImagePadding",
            value: function _getImagePadding() {
                var imgPadding = {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                };

                if (this.options.imagePadding) {
                    var optImgPadding = this.options.imagePadding;

                    if (_typeof(optImgPadding) == "object") {
                        imgPadding.top = optImgPadding.top;
                        imgPadding.right = optImgPadding.right;
                        imgPadding.bottom = optImgPadding.bottom;
                        imgPadding.left = optImgPadding.left;
                    } else {
                        imgPadding.top = optImgPadding;
                        imgPadding.right = optImgPadding;
                        imgPadding.bottom = optImgPadding;
                        imgPadding.left = optImgPadding;
                    }
                }

                return imgPadding;
            }
            /**
             * Adjust the node dimensions for a loaded image.
             *
             * Pre: this.imageObj is valid
             */

        }, {
            key: "_resizeImage",
            value: function _resizeImage() {
                var width, height;

                if (this.options.shapeProperties.useImageSize === false) {
                    // Use the size property
                    var ratio_width = 1;
                    var ratio_height = 1; // Only calculate the proper ratio if both width and height not zero

                    if (this.imageObj.width && this.imageObj.height) {
                        if (this.imageObj.width > this.imageObj.height) {
                            ratio_width = this.imageObj.width / this.imageObj.height;
                        } else {
                            ratio_height = this.imageObj.height / this.imageObj.width;
                        }
                    }

                    width = this.options.size * 2 * ratio_width;
                    height = this.options.size * 2 * ratio_height;
                } else {
                    // Use the image size with image padding
                    var imgPadding = this._getImagePadding();

                    width = this.imageObj.width + imgPadding.left + imgPadding.right;
                    height = this.imageObj.height + imgPadding.top + imgPadding.bottom;
                }

                this.width = width;
                this.height = height;
                this.radius = 0.5 * this.width;
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {ArrowOptions} values
             * @private
             */

        }, {
            key: "_drawRawCircle",
            value: function _drawRawCircle(ctx, x, y, values) {
                this.initContextForDraw(ctx, values);
                drawCircle(ctx, x, y, values.size);
                this.performFill(ctx, values);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {ArrowOptions} values
             * @private
             */

        }, {
            key: "_drawImageAtPosition",
            value: function _drawImageAtPosition(ctx, values) {
                if (this.imageObj.width != 0) {
                    // draw the image
                    ctx.globalAlpha = values.opacity !== undefined ? values.opacity : 1; // draw shadow if enabled

                    this.enableShadow(ctx, values);
                    var factor = 1;

                    if (this.options.shapeProperties.interpolation === true) {
                        factor = this.imageObj.width / this.width / this.body.view.scale;
                    }

                    var imgPadding = this._getImagePadding();

                    var imgPosLeft = this.left + imgPadding.left;
                    var imgPosTop = this.top + imgPadding.top;
                    var imgWidth = this.width - imgPadding.left - imgPadding.right;
                    var imgHeight = this.height - imgPadding.top - imgPadding.bottom;
                    this.imageObj.drawImageAtPosition(ctx, factor, imgPosLeft, imgPosTop, imgWidth, imgHeight); // disable shadows for other elements.

                    this.disableShadow(ctx, values);
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {boolean} selected
             * @param {boolean} hover
             * @private
             */

        }, {
            key: "_drawImageLabel",
            value: function _drawImageLabel(ctx, x, y, selected, hover) {
                var offset = 0;

                if (this.height !== undefined) {
                    offset = this.height * 0.5;
                    var labelDimensions = this.labelModule.getTextSize(ctx, selected, hover);

                    if (labelDimensions.lineCount >= 1) {
                        offset += labelDimensions.height / 2;
                    }
                }

                var yLabel = y + offset;

                if (this.options.label) {
                    this.labelOffset = offset;
                }

                this.labelModule.draw(ctx, x, yLabel, selected, hover, "hanging");
            }
        }]);

        return CircleImageBase;
    }(NodeBase);

    function _createSuper$q(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$q(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$q() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Circle Node/Cluster shape.
     *
     * @augments CircleImageBase
     */

    var Circle$1 = /*#__PURE__*/function (_CircleImageBase) {
        _inherits(Circle, _CircleImageBase);

        var _super = _createSuper$q(Circle);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Circle(options, body, labelModule) {
            var _this;

            _classCallCheck(this, Circle);

            _this = _super.call(this, options, body, labelModule);

            _this._setMargins(labelModule);

            return _this;
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {boolean} [selected]
         * @param {boolean} [hover]
         */


        _createClass(Circle, [{
            key: "resize",
            value: function resize(ctx) {
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
                var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;

                if (this.needsRefresh(selected, hover)) {
                    var dimensions = this.getDimensionsFromLabel(ctx, selected, hover);
                    var diameter = Math.max(dimensions.width + this.margin.right + this.margin.left, dimensions.height + this.margin.top + this.margin.bottom);
                    this.options.size = diameter / 2; // NOTE: this size field only set here, not in Ellipse, Database, Box

                    this.width = diameter;
                    this.height = diameter;
                    this.radius = this.width / 2;
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {ArrowOptions} values
             */

        }, {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                this.resize(ctx, selected, hover);
                this.left = x - this.width / 2;
                this.top = y - this.height / 2;

                this._drawRawCircle(ctx, x, y, values);

                this.updateBoundingBox(x, y);
                this.labelModule.draw(ctx, this.left + this.textSize.width / 2 + this.margin.left, y, selected, hover);
            }
            /**
             *
             * @param {number} x width
             * @param {number} y height
             */

        }, {
            key: "updateBoundingBox",
            value: function updateBoundingBox(x, y) {
                this.boundingBox.top = y - this.options.size;
                this.boundingBox.left = x - this.options.size;
                this.boundingBox.right = x + this.options.size;
                this.boundingBox.bottom = y + this.options.size;
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx) {
                if (ctx) {
                    this.resize(ctx);
                }

                return this.width * 0.5;
            }
        }]);

        return Circle;
    }(CircleImageBase);

    function _createSuper$p(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$p(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$p() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A CircularImage Node/Cluster shape.
     *
     * @augments CircleImageBase
     */

    var CircularImage = /*#__PURE__*/function (_CircleImageBase) {
        _inherits(CircularImage, _CircleImageBase);

        var _super = _createSuper$p(CircularImage);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         * @param {Image} imageObj
         * @param {Image} imageObjAlt
         */
        function CircularImage(options, body, labelModule, imageObj, imageObjAlt) {
            var _this;

            _classCallCheck(this, CircularImage);

            _this = _super.call(this, options, body, labelModule);

            _this.setImages(imageObj, imageObjAlt);

            return _this;
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {boolean} [selected]
         * @param {boolean} [hover]
         */


        _createClass(CircularImage, [{
            key: "resize",
            value: function resize(ctx) {
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
                var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;
                var imageAbsent = this.imageObj.src === undefined || this.imageObj.width === undefined || this.imageObj.height === undefined;

                if (imageAbsent) {
                    var diameter = this.options.size * 2;
                    this.width = diameter;
                    this.height = diameter;
                    this.radius = 0.5 * this.width;
                    return;
                } // At this point, an image is present, i.e. this.imageObj is valid.


                if (this.needsRefresh(selected, hover)) {
                    this._resizeImage();
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {ArrowOptions} values
             */

        }, {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                this.switchImages(selected);
                this.resize();
                var labelX = x,
                    labelY = y;

                if (this.options.shapeProperties.coordinateOrigin === "top-left") {
                    this.left = x;
                    this.top = y;
                    labelX += this.width / 2;
                    labelY += this.height / 2;
                } else {
                    this.left = x - this.width / 2;
                    this.top = y - this.height / 2;
                } // draw the background circle. IMPORTANT: the stroke in this method is used by the clip method below.


                this._drawRawCircle(ctx, labelX, labelY, values); // now we draw in the circle, we save so we can revert the clip operation after drawing.


                ctx.save(); // clip is used to use the stroke in drawRawCircle as an area that we can draw in.

                ctx.clip(); // draw the image

                this._drawImageAtPosition(ctx, values); // restore so we can again draw on the full canvas


                ctx.restore();

                this._drawImageLabel(ctx, labelX, labelY, selected, hover);

                this.updateBoundingBox(x, y);
            } // TODO: compare with Circle.updateBoundingBox(), consolidate? More stuff is happening here

            /**
             *
             * @param {number} x width
             * @param {number} y height
             */

        }, {
            key: "updateBoundingBox",
            value: function updateBoundingBox(x, y) {
                if (this.options.shapeProperties.coordinateOrigin === "top-left") {
                    this.boundingBox.top = y;
                    this.boundingBox.left = x;
                    this.boundingBox.right = x + this.options.size * 2;
                    this.boundingBox.bottom = y + this.options.size * 2;
                } else {
                    this.boundingBox.top = y - this.options.size;
                    this.boundingBox.left = x - this.options.size;
                    this.boundingBox.right = x + this.options.size;
                    this.boundingBox.bottom = y + this.options.size;
                } // TODO: compare with Image.updateBoundingBox(), consolidate?


                this.boundingBox.left = Math.min(this.boundingBox.left, this.labelModule.size.left);
                this.boundingBox.right = Math.max(this.boundingBox.right, this.labelModule.size.left + this.labelModule.size.width);
                this.boundingBox.bottom = Math.max(this.boundingBox.bottom, this.boundingBox.bottom + this.labelOffset);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx) {
                if (ctx) {
                    this.resize(ctx);
                }

                return this.width * 0.5;
            }
        }]);

        return CircularImage;
    }(CircleImageBase);

    function _createSuper$o(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$o(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$o() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * Base class for constructing Node/Cluster Shapes.
     *
     * @augments NodeBase
     */

    var ShapeBase = /*#__PURE__*/function (_NodeBase) {
        _inherits(ShapeBase, _NodeBase);

        var _super = _createSuper$o(ShapeBase);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function ShapeBase(options, body, labelModule) {
            _classCallCheck(this, ShapeBase);

            return _super.call(this, options, body, labelModule);
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {boolean} [selected]
         * @param {boolean} [hover]
         * @param {object} [values={size: this.options.size}]
         */


        _createClass(ShapeBase, [{
            key: "resize",
            value: function resize(ctx) {
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
                var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;
                var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    size: this.options.size
                };

                if (this.needsRefresh(selected, hover)) {
                    var _this$customSizeWidth, _this$customSizeHeigh;

                    this.labelModule.getTextSize(ctx, selected, hover);
                    var size = 2 * values.size;
                    this.width = (_this$customSizeWidth = this.customSizeWidth) !== null && _this$customSizeWidth !== void 0 ? _this$customSizeWidth : size;
                    this.height = (_this$customSizeHeigh = this.customSizeHeight) !== null && _this$customSizeHeigh !== void 0 ? _this$customSizeHeigh : size;
                    this.radius = 0.5 * this.width;
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {string} shape
             * @param {number} sizeMultiplier - Unused! TODO: Remove next major release
             * @param {number} x
             * @param {number} y
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {ArrowOptions} values
             * @private
             *
             * @returns {object} Callbacks to draw later on higher layers.
             */

        }, {
            key: "_drawShape",
            value: function _drawShape(ctx, shape, sizeMultiplier, x, y, selected, hover, values) {
                var _this = this;

                this.resize(ctx, selected, hover, values);
                this.left = x - this.width / 2;
                this.top = y - this.height / 2;
                this.initContextForDraw(ctx, values);
                getShape(shape)(ctx, x, y, values.size);
                this.performFill(ctx, values);

                if (this.options.icon !== undefined) {
                    if (this.options.icon.code !== undefined) {
                        ctx.font = (selected ? "bold " : "") + this.height / 2 + "px " + (this.options.icon.face || "FontAwesome");
                        ctx.fillStyle = this.options.icon.color || "black";
                        ctx.textAlign = "center";
                        ctx.textBaseline = "middle";
                        ctx.fillText(this.options.icon.code, x, y);
                    }
                }

                return {
                    drawExternalLabel: function drawExternalLabel() {
                        if (_this.options.label !== undefined) {
                            // Need to call following here in order to ensure value for
                            // `this.labelModule.size.height`.
                            _this.labelModule.calculateLabelSize(ctx, selected, hover, x, y, "hanging");

                            var yLabel = y + 0.5 * _this.height + 0.5 * _this.labelModule.size.height;

                            _this.labelModule.draw(ctx, x, yLabel, selected, hover, "hanging");
                        }

                        _this.updateBoundingBox(x, y);
                    }
                };
            }
            /**
             *
             * @param {number} x
             * @param {number} y
             */

        }, {
            key: "updateBoundingBox",
            value: function updateBoundingBox(x, y) {
                this.boundingBox.top = y - this.options.size;
                this.boundingBox.left = x - this.options.size;
                this.boundingBox.right = x + this.options.size;
                this.boundingBox.bottom = y + this.options.size;

                if (this.options.label !== undefined && this.labelModule.size.width > 0) {
                    this.boundingBox.left = Math.min(this.boundingBox.left, this.labelModule.size.left);
                    this.boundingBox.right = Math.max(this.boundingBox.right, this.labelModule.size.left + this.labelModule.size.width);
                    this.boundingBox.bottom = Math.max(this.boundingBox.bottom, this.boundingBox.bottom + this.labelModule.size.height);
                }
            }
        }]);

        return ShapeBase;
    }(NodeBase);

    function ownKeys$3(object, enumerableOnly) { var keys = keys$3(object); if (getOwnPropertySymbols) { var symbols = getOwnPropertySymbols(object); if (enumerableOnly) symbols = filter(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$2(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

    function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; forEach$2(_context = ownKeys$3(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (getOwnPropertyDescriptors) { defineProperties(target, getOwnPropertyDescriptors(source)); } else { var _context2; forEach$2(_context2 = ownKeys$3(Object(source))).call(_context2, function (key) { defineProperty$4(target, key, getOwnPropertyDescriptor$2(source, key)); }); } } return target; }

    function _createSuper$n(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$n(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$n() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A CustomShape Node/Cluster shape.
     *
     * @augments ShapeBase
     */

    var CustomShape = /*#__PURE__*/function (_ShapeBase) {
        _inherits(CustomShape, _ShapeBase);

        var _super = _createSuper$n(CustomShape);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         * @param {Function} ctxRenderer

         */
        function CustomShape(options, body, labelModule, ctxRenderer) {
            var _this;

            _classCallCheck(this, CustomShape);

            _this = _super.call(this, options, body, labelModule, ctxRenderer);
            _this.ctxRenderer = ctxRenderer;
            return _this;
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {number} x width
         * @param {number} y height
         * @param {boolean} selected
         * @param {boolean} hover
         * @param {ArrowOptions} values
         *
         * @returns {object} Callbacks to draw later on different layers.
         */


        _createClass(CustomShape, [{
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                this.resize(ctx, selected, hover, values);
                this.left = x - this.width / 2;
                this.top = y - this.height / 2; // Guard right away because someone may just draw in the function itself.

                ctx.save();
                var drawLater = this.ctxRenderer({
                    ctx: ctx,
                    id: this.options.id,
                    x: x,
                    y: y,
                    state: {
                        selected: selected,
                        hover: hover
                    },
                    style: _objectSpread$3({}, values),
                    label: this.options.label
                }); // Render the node shape bellow arrows.

                if (drawLater.drawNode != null) {
                    drawLater.drawNode();
                }

                ctx.restore();

                if (drawLater.drawExternalLabel) {
                    // Guard the external label (above arrows) drawing function.
                    var drawExternalLabel = drawLater.drawExternalLabel;

                    drawLater.drawExternalLabel = function () {
                        ctx.save();
                        drawExternalLabel();
                        ctx.restore();
                    };
                }

                if (drawLater.nodeDimensions) {
                    this.customSizeWidth = drawLater.nodeDimensions.width;
                    this.customSizeHeight = drawLater.nodeDimensions.height;
                }

                return drawLater;
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return CustomShape;
    }(ShapeBase);

    function _createSuper$m(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$m(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$m() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Database Node/Cluster shape.
     *
     * @augments NodeBase
     */

    var Database = /*#__PURE__*/function (_NodeBase) {
        _inherits(Database, _NodeBase);

        var _super = _createSuper$m(Database);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Database(options, body, labelModule) {
            var _this;

            _classCallCheck(this, Database);

            _this = _super.call(this, options, body, labelModule);

            _this._setMargins(labelModule);

            return _this;
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {boolean} selected
         * @param {boolean} hover
         */


        _createClass(Database, [{
            key: "resize",
            value: function resize(ctx, selected, hover) {
                if (this.needsRefresh(selected, hover)) {
                    var dimensions = this.getDimensionsFromLabel(ctx, selected, hover);
                    var size = dimensions.width + this.margin.right + this.margin.left;
                    this.width = size;
                    this.height = size;
                    this.radius = this.width / 2;
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {ArrowOptions} values
             */

        }, {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                this.resize(ctx, selected, hover);
                this.left = x - this.width / 2;
                this.top = y - this.height / 2;
                this.initContextForDraw(ctx, values);
                drawDatabase(ctx, x - this.width / 2, y - this.height / 2, this.width, this.height);
                this.performFill(ctx, values);
                this.updateBoundingBox(x, y, ctx, selected, hover);
                this.labelModule.draw(ctx, this.left + this.textSize.width / 2 + this.margin.left, this.top + this.textSize.height / 2 + this.margin.top, selected, hover);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return Database;
    }(NodeBase);

    function _createSuper$l(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$l(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$l() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Diamond Node/Cluster shape.
     *
     * @augments ShapeBase
     */

    var Diamond$1 = /*#__PURE__*/function (_ShapeBase) {
        _inherits(Diamond, _ShapeBase);

        var _super = _createSuper$l(Diamond);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Diamond(options, body, labelModule) {
            _classCallCheck(this, Diamond);

            return _super.call(this, options, body, labelModule);
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {number} x width
         * @param {number} y height
         * @param {boolean} selected
         * @param {boolean} hover
         * @param {ArrowOptions} values
         *
         * @returns {object} Callbacks to draw later on higher layers.
         */


        _createClass(Diamond, [{
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                return this._drawShape(ctx, "diamond", 4, x, y, selected, hover, values);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return Diamond;
    }(ShapeBase);

    function _createSuper$k(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$k(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$k() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Dot Node/Cluster shape.
     *
     * @augments ShapeBase
     */

    var Dot = /*#__PURE__*/function (_ShapeBase) {
        _inherits(Dot, _ShapeBase);

        var _super = _createSuper$k(Dot);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Dot(options, body, labelModule) {
            _classCallCheck(this, Dot);

            return _super.call(this, options, body, labelModule);
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {number} x width
         * @param {number} y height
         * @param {boolean} selected
         * @param {boolean} hover
         * @param {ArrowOptions} values
         *
         * @returns {object} Callbacks to draw later on higher layers.
         */


        _createClass(Dot, [{
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                return this._drawShape(ctx, "circle", 2, x, y, selected, hover, values);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx) {
                if (ctx) {
                    this.resize(ctx);
                }

                return this.options.size;
            }
        }]);

        return Dot;
    }(ShapeBase);

    function _createSuper$j(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$j(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$j() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * Am Ellipse Node/Cluster shape.
     *
     * @augments NodeBase
     */

    var Ellipse = /*#__PURE__*/function (_NodeBase) {
        _inherits(Ellipse, _NodeBase);

        var _super = _createSuper$j(Ellipse);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Ellipse(options, body, labelModule) {
            _classCallCheck(this, Ellipse);

            return _super.call(this, options, body, labelModule);
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {boolean} [selected]
         * @param {boolean} [hover]
         */


        _createClass(Ellipse, [{
            key: "resize",
            value: function resize(ctx) {
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
                var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;

                if (this.needsRefresh(selected, hover)) {
                    var dimensions = this.getDimensionsFromLabel(ctx, selected, hover);
                    this.height = dimensions.height * 2;
                    this.width = dimensions.width + dimensions.height;
                    this.radius = 0.5 * this.width;
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {ArrowOptions} values
             */

        }, {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                this.resize(ctx, selected, hover);
                this.left = x - this.width * 0.5;
                this.top = y - this.height * 0.5;
                this.initContextForDraw(ctx, values);
                drawEllipse(ctx, this.left, this.top, this.width, this.height);
                this.performFill(ctx, values);
                this.updateBoundingBox(x, y, ctx, selected, hover);
                this.labelModule.draw(ctx, x, y, selected, hover);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                if (ctx) {
                    this.resize(ctx);
                }

                var a = this.width * 0.5;
                var b = this.height * 0.5;
                var w = Math.sin(angle) * a;
                var h = Math.cos(angle) * b;
                return a * b / Math.sqrt(w * w + h * h);
            }
        }]);

        return Ellipse;
    }(NodeBase);

    function _createSuper$i(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$i(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$i() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * An icon replacement for the default Node shape.
     *
     * @augments NodeBase
     */

    var Icon = /*#__PURE__*/function (_NodeBase) {
        _inherits(Icon, _NodeBase);

        var _super = _createSuper$i(Icon);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Icon(options, body, labelModule) {
            var _this;

            _classCallCheck(this, Icon);

            _this = _super.call(this, options, body, labelModule);

            _this._setMargins(labelModule);

            return _this;
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx - Unused.
         * @param {boolean} [selected]
         * @param {boolean} [hover]
         */


        _createClass(Icon, [{
            key: "resize",
            value: function resize(ctx, selected, hover) {
                if (this.needsRefresh(selected, hover)) {
                    this.iconSize = {
                        width: Number(this.options.icon.size),
                        height: Number(this.options.icon.size)
                    };
                    this.width = this.iconSize.width + this.margin.right + this.margin.left;
                    this.height = this.iconSize.height + this.margin.top + this.margin.bottom;
                    this.radius = 0.5 * this.width;
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {ArrowOptions} values
             *
             * @returns {object} Callbacks to draw later on higher layers.
             */

        }, {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                var _this2 = this;

                this.resize(ctx, selected, hover);
                this.options.icon.size = this.options.icon.size || 50;
                this.left = x - this.width / 2;
                this.top = y - this.height / 2;

                this._icon(ctx, x, y, selected, hover, values);

                return {
                    drawExternalLabel: function drawExternalLabel() {
                        if (_this2.options.label !== undefined) {
                            var iconTextSpacing = 5;

                            _this2.labelModule.draw(ctx, _this2.left + _this2.iconSize.width / 2 + _this2.margin.left, y + _this2.height / 2 + iconTextSpacing, selected);
                        }

                        _this2.updateBoundingBox(x, y);
                    }
                };
            }
            /**
             *
             * @param {number} x
             * @param {number} y
             */

        }, {
            key: "updateBoundingBox",
            value: function updateBoundingBox(x, y) {
                this.boundingBox.top = y - this.options.icon.size * 0.5;
                this.boundingBox.left = x - this.options.icon.size * 0.5;
                this.boundingBox.right = x + this.options.icon.size * 0.5;
                this.boundingBox.bottom = y + this.options.icon.size * 0.5;

                if (this.options.label !== undefined && this.labelModule.size.width > 0) {
                    var iconTextSpacing = 5;
                    this.boundingBox.left = Math.min(this.boundingBox.left, this.labelModule.size.left);
                    this.boundingBox.right = Math.max(this.boundingBox.right, this.labelModule.size.left + this.labelModule.size.width);
                    this.boundingBox.bottom = Math.max(this.boundingBox.bottom, this.boundingBox.bottom + this.labelModule.size.height + iconTextSpacing);
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {boolean} selected
             * @param {boolean} hover - Unused
             * @param {ArrowOptions} values
             */

        }, {
            key: "_icon",
            value: function _icon(ctx, x, y, selected, hover, values) {
                var iconSize = Number(this.options.icon.size);

                if (this.options.icon.code !== undefined) {
                    ctx.font = [this.options.icon.weight != null ? this.options.icon.weight : selected ? "bold" : "", // If the weight is forced (for example to make Font Awesome 5 work
                        // properly) substitute slightly bigger size for bold font face.
                        (this.options.icon.weight != null && selected ? 5 : 0) + iconSize + "px", this.options.icon.face].join(" "); // draw icon

                    ctx.fillStyle = this.options.icon.color || "black";
                    ctx.textAlign = "center";
                    ctx.textBaseline = "middle"; // draw shadow if enabled

                    this.enableShadow(ctx, values);
                    ctx.fillText(this.options.icon.code, x, y); // disable shadows for other elements.

                    this.disableShadow(ctx, values);
                } else {
                    console.error("When using the icon shape, you need to define the code in the icon options object. This can be done per node or globally.");
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return Icon;
    }(NodeBase);

    function _createSuper$h(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$h(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$h() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * An image-based replacement for the default Node shape.
     *
     * @augments CircleImageBase
     */

    var Image$2 = /*#__PURE__*/function (_CircleImageBase) {
        _inherits(Image, _CircleImageBase);

        var _super = _createSuper$h(Image);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         * @param {Image} imageObj
         * @param {Image} imageObjAlt
         */
        function Image(options, body, labelModule, imageObj, imageObjAlt) {
            var _this;

            _classCallCheck(this, Image);

            _this = _super.call(this, options, body, labelModule);

            _this.setImages(imageObj, imageObjAlt);

            return _this;
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx - Unused.
         * @param {boolean} [selected]
         * @param {boolean} [hover]
         */


        _createClass(Image, [{
            key: "resize",
            value: function resize(ctx) {
                var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
                var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;
                var imageAbsent = this.imageObj.src === undefined || this.imageObj.width === undefined || this.imageObj.height === undefined;

                if (imageAbsent) {
                    var side = this.options.size * 2;
                    this.width = side;
                    this.height = side;
                    return;
                }

                if (this.needsRefresh(selected, hover)) {
                    this._resizeImage();
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {ArrowOptions} values
             */

        }, {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                ctx.save();
                this.switchImages(selected);
                this.resize();
                var labelX = x,
                    labelY = y;

                if (this.options.shapeProperties.coordinateOrigin === "top-left") {
                    this.left = x;
                    this.top = y;
                    labelX += this.width / 2;
                    labelY += this.height / 2;
                } else {
                    this.left = x - this.width / 2;
                    this.top = y - this.height / 2;
                }

                if (this.options.shapeProperties.useBorderWithImage === true) {
                    var neutralborderWidth = this.options.borderWidth;
                    var selectionLineWidth = this.options.borderWidthSelected || 2 * this.options.borderWidth;
                    var borderWidth = (selected ? selectionLineWidth : neutralborderWidth) / this.body.view.scale;
                    ctx.lineWidth = Math.min(this.width, borderWidth);
                    ctx.beginPath();
                    var strokeStyle = selected ? this.options.color.highlight.border : hover ? this.options.color.hover.border : this.options.color.border;
                    var fillStyle = selected ? this.options.color.highlight.background : hover ? this.options.color.hover.background : this.options.color.background;

                    if (values.opacity !== undefined) {
                        strokeStyle = overrideOpacity(strokeStyle, values.opacity);
                        fillStyle = overrideOpacity(fillStyle, values.opacity);
                    } // setup the line properties.


                    ctx.strokeStyle = strokeStyle; // set a fillstyle

                    ctx.fillStyle = fillStyle; // draw a rectangle to form the border around. This rectangle is filled so the opacity of a picture (in future vis releases?) can be used to tint the image

                    ctx.rect(this.left - 0.5 * ctx.lineWidth, this.top - 0.5 * ctx.lineWidth, this.width + ctx.lineWidth, this.height + ctx.lineWidth);

                    fill(ctx).call(ctx);

                    this.performStroke(ctx, values);
                    ctx.closePath();
                }

                this._drawImageAtPosition(ctx, values);

                this._drawImageLabel(ctx, labelX, labelY, selected, hover);

                this.updateBoundingBox(x, y);
                ctx.restore();
            }
            /**
             *
             * @param {number} x
             * @param {number} y
             */

        }, {
            key: "updateBoundingBox",
            value: function updateBoundingBox(x, y) {
                this.resize();

                if (this.options.shapeProperties.coordinateOrigin === "top-left") {
                    this.left = x;
                    this.top = y;
                } else {
                    this.left = x - this.width / 2;
                    this.top = y - this.height / 2;
                }

                this.boundingBox.left = this.left;
                this.boundingBox.top = this.top;
                this.boundingBox.bottom = this.top + this.height;
                this.boundingBox.right = this.left + this.width;

                if (this.options.label !== undefined && this.labelModule.size.width > 0) {
                    this.boundingBox.left = Math.min(this.boundingBox.left, this.labelModule.size.left);
                    this.boundingBox.right = Math.max(this.boundingBox.right, this.labelModule.size.left + this.labelModule.size.width);
                    this.boundingBox.bottom = Math.max(this.boundingBox.bottom, this.boundingBox.bottom + this.labelOffset);
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return Image;
    }(CircleImageBase);

    function _createSuper$g(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$g(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$g() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Square Node/Cluster shape.
     *
     * @augments ShapeBase
     */

    var Square = /*#__PURE__*/function (_ShapeBase) {
        _inherits(Square, _ShapeBase);

        var _super = _createSuper$g(Square);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Square(options, body, labelModule) {
            _classCallCheck(this, Square);

            return _super.call(this, options, body, labelModule);
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {number} x width
         * @param {number} y height
         * @param {boolean} selected
         * @param {boolean} hover
         * @param {ArrowOptions} values
         *
         * @returns {object} Callbacks to draw later on higher layers.
         */


        _createClass(Square, [{
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                return this._drawShape(ctx, "square", 2, x, y, selected, hover, values);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return Square;
    }(ShapeBase);

    function _createSuper$f(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$f(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$f() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Hexagon Node/Cluster shape.
     *
     * @augments ShapeBase
     */

    var Hexagon = /*#__PURE__*/function (_ShapeBase) {
        _inherits(Hexagon, _ShapeBase);

        var _super = _createSuper$f(Hexagon);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Hexagon(options, body, labelModule) {
            _classCallCheck(this, Hexagon);

            return _super.call(this, options, body, labelModule);
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {number} x width
         * @param {number} y height
         * @param {boolean} selected
         * @param {boolean} hover
         * @param {ArrowOptions} values
         *
         * @returns {object} Callbacks to draw later on higher layers.
         */


        _createClass(Hexagon, [{
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                return this._drawShape(ctx, "hexagon", 4, x, y, selected, hover, values);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return Hexagon;
    }(ShapeBase);

    function _createSuper$e(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$e(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$e() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Star Node/Cluster shape.
     *
     * @augments ShapeBase
     */

    var Star = /*#__PURE__*/function (_ShapeBase) {
        _inherits(Star, _ShapeBase);

        var _super = _createSuper$e(Star);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Star(options, body, labelModule) {
            _classCallCheck(this, Star);

            return _super.call(this, options, body, labelModule);
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {number} x width
         * @param {number} y height
         * @param {boolean} selected
         * @param {boolean} hover
         * @param {ArrowOptions} values
         *
         * @returns {object} Callbacks to draw later on higher layers.
         */


        _createClass(Star, [{
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                return this._drawShape(ctx, "star", 4, x, y, selected, hover, values);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return Star;
    }(ShapeBase);

    function _createSuper$d(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$d(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$d() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A text-based replacement for the default Node shape.
     *
     * @augments NodeBase
     */

    var Text = /*#__PURE__*/function (_NodeBase) {
        _inherits(Text, _NodeBase);

        var _super = _createSuper$d(Text);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Text(options, body, labelModule) {
            var _this;

            _classCallCheck(this, Text);

            _this = _super.call(this, options, body, labelModule);

            _this._setMargins(labelModule);

            return _this;
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {boolean} selected
         * @param {boolean} hover
         */


        _createClass(Text, [{
            key: "resize",
            value: function resize(ctx, selected, hover) {
                if (this.needsRefresh(selected, hover)) {
                    this.textSize = this.labelModule.getTextSize(ctx, selected, hover);
                    this.width = this.textSize.width + this.margin.right + this.margin.left;
                    this.height = this.textSize.height + this.margin.top + this.margin.bottom;
                    this.radius = 0.5 * this.width;
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} x width
             * @param {number} y height
             * @param {boolean} selected
             * @param {boolean} hover
             * @param {ArrowOptions} values
             */

        }, {
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                this.resize(ctx, selected, hover);
                this.left = x - this.width / 2;
                this.top = y - this.height / 2; // draw shadow if enabled

                this.enableShadow(ctx, values);
                this.labelModule.draw(ctx, this.left + this.textSize.width / 2 + this.margin.left, this.top + this.textSize.height / 2 + this.margin.top, selected, hover); // disable shadows for other elements.

                this.disableShadow(ctx, values);
                this.updateBoundingBox(x, y, ctx, selected, hover);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return Text;
    }(NodeBase);

    function _createSuper$c(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$c(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$c() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Triangle Node/Cluster shape.
     *
     * @augments ShapeBase
     */

    var Triangle$1 = /*#__PURE__*/function (_ShapeBase) {
        _inherits(Triangle, _ShapeBase);

        var _super = _createSuper$c(Triangle);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function Triangle(options, body, labelModule) {
            _classCallCheck(this, Triangle);

            return _super.call(this, options, body, labelModule);
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {number} x
         * @param {number} y
         * @param {boolean} selected
         * @param {boolean} hover
         * @param {ArrowOptions} values
         *
         * @returns {object} Callbacks to draw later on higher layers.
         */


        _createClass(Triangle, [{
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                return this._drawShape(ctx, "triangle", 3, x, y, selected, hover, values);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return Triangle;
    }(ShapeBase);

    function _createSuper$b(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$b(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$b() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A downward facing Triangle Node/Cluster shape.
     *
     * @augments ShapeBase
     */

    var TriangleDown = /*#__PURE__*/function (_ShapeBase) {
        _inherits(TriangleDown, _ShapeBase);

        var _super = _createSuper$b(TriangleDown);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Label} labelModule
         */
        function TriangleDown(options, body, labelModule) {
            _classCallCheck(this, TriangleDown);

            return _super.call(this, options, body, labelModule);
        }
        /**
         *
         * @param {CanvasRenderingContext2D} ctx
         * @param {number} x
         * @param {number} y
         * @param {boolean} selected
         * @param {boolean} hover
         * @param {ArrowOptions} values
         *
         * @returns {object} Callbacks to draw later on higher layers.
         */


        _createClass(TriangleDown, [{
            key: "draw",
            value: function draw(ctx, x, y, selected, hover, values) {
                return this._drawShape(ctx, "triangleDown", 3, x, y, selected, hover, values);
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {number} angle
             * @returns {number}
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this._distanceToBorder(ctx, angle);
            }
        }]);

        return TriangleDown;
    }(ShapeBase);

    function ownKeys$2(object, enumerableOnly) { var keys = keys$3(object); if (getOwnPropertySymbols) { var symbols = getOwnPropertySymbols(object); if (enumerableOnly) symbols = filter(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$2(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

    function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context5; forEach$2(_context5 = ownKeys$2(Object(source), true)).call(_context5, function (key) { _defineProperty(target, key, source[key]); }); } else if (getOwnPropertyDescriptors) { defineProperties(target, getOwnPropertyDescriptors(source)); } else { var _context6; forEach$2(_context6 = ownKeys$2(Object(source))).call(_context6, function (key) { defineProperty$4(target, key, getOwnPropertyDescriptor$2(source, key)); }); } } return target; }
    /**
     * A node. A node can be connected to other nodes via one or multiple edges.
     */

    var Node = /*#__PURE__*/function () {
        /**
         *
         * @param {object} options An object containing options for the node. All
         *                            options are optional, except for the id.
         *                              {number} id     Id of the node. Required
         *                              {string} label  Text label for the node
         *                              {number} x      Horizontal position of the node
         *                              {number} y      Vertical position of the node
         *                              {string} shape  Node shape
         *                              {string} image  An image url
         *                              {string} title  A title text, can be HTML
         *                              {anytype} group A group name or number
         *
         * @param {object} body               Shared state of current network instance
         * @param {Network.Images} imagelist  A list with images. Only needed when the node has an image
         * @param {Groups} grouplist          A list with groups. Needed for retrieving group options
         * @param {object} globalOptions      Current global node options; these serve as defaults for the node instance
         * @param {object} defaultOptions     Global default options for nodes; note that this is also the prototype
         *                                    for parameter `globalOptions`.
         */
        function Node(options, body, imagelist, grouplist, globalOptions, defaultOptions) {
            _classCallCheck(this, Node);

            this.options = bridgeObject(globalOptions);
            this.globalOptions = globalOptions;
            this.defaultOptions = defaultOptions;
            this.body = body;
            this.edges = []; // all edges connected to this node
            // set defaults for the options

            this.id = undefined;
            this.imagelist = imagelist;
            this.grouplist = grouplist; // state options

            this.x = undefined;
            this.y = undefined;
            this.baseSize = this.options.size;
            this.baseFontSize = this.options.font.size;
            this.predefinedPosition = false; // used to check if initial fit should just take the range or approximate

            this.selected = false;
            this.hover = false;
            this.labelModule = new Label(this.body, this.options, false
                /* Not edge label */
            );
            this.setOptions(options);
        }
        /**
         * Attach a edge to the node
         *
         * @param {Edge} edge
         */


        _createClass(Node, [{
            key: "attachEdge",
            value: function attachEdge(edge) {
                var _context;

                if (indexOf(_context = this.edges).call(_context, edge) === -1) {
                    this.edges.push(edge);
                }
            }
            /**
             * Detach a edge from the node
             *
             * @param {Edge} edge
             */

        }, {
            key: "detachEdge",
            value: function detachEdge(edge) {
                var _context2;

                var index = indexOf(_context2 = this.edges).call(_context2, edge);

                if (index != -1) {
                    var _context3;

                    splice(_context3 = this.edges).call(_context3, index, 1);
                }
            }
            /**
             * Set or overwrite options for the node
             *
             * @param {object} options an object with options
             * @returns {null|boolean}
             */

        }, {
            key: "setOptions",
            value: function setOptions(options) {
                var currentShape = this.options.shape;

                if (!options) {
                    return; // Note that the return value will be 'undefined'! This is OK.
                } // Save the color for later.
                // This is necessary in order to prevent local color from being overwritten by group color.
                // TODO: To prevent such workarounds the way options are handled should be rewritten from scratch.
                // This is not the only problem with current options handling.


                if (typeof options.color !== "undefined") {
                    this._localColor = options.color;
                } // basic options


                if (options.id !== undefined) {
                    this.id = options.id;
                }

                if (this.id === undefined) {
                    throw new Error("Node must have an id");
                }

                Node.checkMass(options, this.id); // set these options locally
                // clear x and y positions

                if (options.x !== undefined) {
                    if (options.x === null) {
                        this.x = undefined;
                        this.predefinedPosition = false;
                    } else {
                        this.x = _parseInt(options.x);
                        this.predefinedPosition = true;
                    }
                }

                if (options.y !== undefined) {
                    if (options.y === null) {
                        this.y = undefined;
                        this.predefinedPosition = false;
                    } else {
                        this.y = _parseInt(options.y);
                        this.predefinedPosition = true;
                    }
                }

                if (options.size !== undefined) {
                    this.baseSize = options.size;
                }

                if (options.value !== undefined) {
                    options.value = _parseFloat(options.value);
                } // this transforms all shorthands into fully defined options


                Node.parseOptions(this.options, options, true, this.globalOptions, this.grouplist);
                var pile = [options, this.options, this.defaultOptions];
                this.chooser = choosify("node", pile);

                this._load_images();

                this.updateLabelModule(options); // Need to set local opacity after `this.updateLabelModule(options);` because `this.updateLabelModule(options);` overrites local opacity with group opacity

                if (options.opacity !== undefined && Node.checkOpacity(options.opacity)) {
                    this.options.opacity = options.opacity;
                }

                this.updateShape(currentShape);
                return options.hidden !== undefined || options.physics !== undefined;
            }
            /**
             * Load the images from the options, for the nodes that need them.
             *
             * Images are always loaded, even if they are not used in the current shape.
             * The user may switch to an image shape later on.
             *
             * @private
             */

        }, {
            key: "_load_images",
            value: function _load_images() {
                if (this.options.shape === "circularImage" || this.options.shape === "image") {
                    if (this.options.image === undefined) {
                        throw new Error("Option image must be defined for node type '" + this.options.shape + "'");
                    }
                }

                if (this.options.image === undefined) {
                    return;
                }

                if (this.imagelist === undefined) {
                    throw new Error("Internal Error: No images provided");
                }

                if (typeof this.options.image === "string") {
                    this.imageObj = this.imagelist.load(this.options.image, this.options.brokenImage, this.id);
                } else {
                    if (this.options.image.unselected === undefined) {
                        throw new Error("No unselected image provided");
                    }

                    this.imageObj = this.imagelist.load(this.options.image.unselected, this.options.brokenImage, this.id);

                    if (this.options.image.selected !== undefined) {
                        this.imageObjAlt = this.imagelist.load(this.options.image.selected, this.options.brokenImage, this.id);
                    } else {
                        this.imageObjAlt = undefined;
                    }
                }
            }
            /**
             * Check that opacity is only between 0 and 1
             *
             * @param {number} opacity
             * @returns {boolean}
             */

        }, {
            key: "getFormattingValues",
            value:
                /**
                 *
                 * @returns {{color: *, borderWidth: *, borderColor: *, size: *, borderDashes: (boolean|Array|allOptions.nodes.shapeProperties.borderDashes|{boolean, array}), borderRadius: (number|allOptions.nodes.shapeProperties.borderRadius|{number}|Array), shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *}}
                 */
                function getFormattingValues() {
                    var values = {
                        color: this.options.color.background,
                        opacity: this.options.opacity,
                        borderWidth: this.options.borderWidth,
                        borderColor: this.options.color.border,
                        size: this.options.size,
                        borderDashes: this.options.shapeProperties.borderDashes,
                        borderRadius: this.options.shapeProperties.borderRadius,
                        shadow: this.options.shadow.enabled,
                        shadowColor: this.options.shadow.color,
                        shadowSize: this.options.shadow.size,
                        shadowX: this.options.shadow.x,
                        shadowY: this.options.shadow.y
                    };

                    if (this.selected || this.hover) {
                        if (this.chooser === true) {
                            if (this.selected) {
                                if (this.options.borderWidthSelected != null) {
                                    values.borderWidth = this.options.borderWidthSelected;
                                } else {
                                    values.borderWidth *= 2;
                                }

                                values.color = this.options.color.highlight.background;
                                values.borderColor = this.options.color.highlight.border;
                                values.shadow = this.options.shadow.enabled;
                            } else if (this.hover) {
                                values.color = this.options.color.hover.background;
                                values.borderColor = this.options.color.hover.border;
                                values.shadow = this.options.shadow.enabled;
                            }
                        } else if (typeof this.chooser === "function") {
                            this.chooser(values, this.options.id, this.selected, this.hover);

                            if (values.shadow === false) {
                                if (values.shadowColor !== this.options.shadow.color || values.shadowSize !== this.options.shadow.size || values.shadowX !== this.options.shadow.x || values.shadowY !== this.options.shadow.y) {
                                    values.shadow = true;
                                }
                            }
                        }
                    } else {
                        values.shadow = this.options.shadow.enabled;
                    }

                    if (this.options.opacity !== undefined) {
                        var opacity = this.options.opacity;
                        values.borderColor = overrideOpacity(values.borderColor, opacity);
                        values.color = overrideOpacity(values.color, opacity);
                        values.shadowColor = overrideOpacity(values.shadowColor, opacity);
                    }

                    return values;
                }
            /**
             *
             * @param {object} options
             */

        }, {
            key: "updateLabelModule",
            value: function updateLabelModule(options) {
                if (this.options.label === undefined || this.options.label === null) {
                    this.options.label = "";
                }

                Node.updateGroupOptions(this.options, _objectSpread$2(_objectSpread$2({}, options), {}, {
                    color: options && options.color || this._localColor || undefined
                }), this.grouplist); //
                // Note:The prototype chain for this.options is:
                //
                // this.options ->    NodesHandler.options    -> NodesHandler.defaultOptions
                //                 (also: this.globalOptions)
                //
                // Note that the prototypes are mentioned explicitly in the pile list below;
                // WE DON'T WANT THE ORDER OF THE PROTOTYPES!!!! At least, not for font handling of labels.
                // This is a good indication that the prototype usage of options is deficient.
                //

                var currentGroup = this.grouplist.get(this.options.group, false);
                var pile = [options, // new options
                    this.options, // current node options, see comment above for prototype
                    currentGroup, // group options, if any
                    this.globalOptions, // Currently set global node options
                    this.defaultOptions // Default global node options
                ];
                this.labelModule.update(this.options, pile);

                if (this.labelModule.baseSize !== undefined) {
                    this.baseFontSize = this.labelModule.baseSize;
                }
            }
            /**
             *
             * @param {string} currentShape
             */

        }, {
            key: "updateShape",
            value: function updateShape(currentShape) {
                if (currentShape === this.options.shape && this.shape) {
                    this.shape.setOptions(this.options, this.imageObj, this.imageObjAlt);
                } else {
                    // choose draw method depending on the shape
                    switch (this.options.shape) {
                        case "box":
                            this.shape = new Box$1(this.options, this.body, this.labelModule);
                            break;

                        case "circle":
                            this.shape = new Circle$1(this.options, this.body, this.labelModule);
                            break;

                        case "circularImage":
                            this.shape = new CircularImage(this.options, this.body, this.labelModule, this.imageObj, this.imageObjAlt);
                            break;

                        case "custom":
                            this.shape = new CustomShape(this.options, this.body, this.labelModule, this.options.ctxRenderer);
                            break;

                        case "database":
                            this.shape = new Database(this.options, this.body, this.labelModule);
                            break;

                        case "diamond":
                            this.shape = new Diamond$1(this.options, this.body, this.labelModule);
                            break;

                        case "dot":
                            this.shape = new Dot(this.options, this.body, this.labelModule);
                            break;

                        case "ellipse":
                            this.shape = new Ellipse(this.options, this.body, this.labelModule);
                            break;

                        case "icon":
                            this.shape = new Icon(this.options, this.body, this.labelModule);
                            break;

                        case "image":
                            this.shape = new Image$2(this.options, this.body, this.labelModule, this.imageObj, this.imageObjAlt);
                            break;

                        case "square":
                            this.shape = new Square(this.options, this.body, this.labelModule);
                            break;

                        case "hexagon":
                            this.shape = new Hexagon(this.options, this.body, this.labelModule);
                            break;

                        case "star":
                            this.shape = new Star(this.options, this.body, this.labelModule);
                            break;

                        case "text":
                            this.shape = new Text(this.options, this.body, this.labelModule);
                            break;

                        case "triangle":
                            this.shape = new Triangle$1(this.options, this.body, this.labelModule);
                            break;

                        case "triangleDown":
                            this.shape = new TriangleDown(this.options, this.body, this.labelModule);
                            break;

                        default:
                            this.shape = new Ellipse(this.options, this.body, this.labelModule);
                            break;
                    }
                }

                this.needsRefresh();
            }
            /**
             * select this node
             */

        }, {
            key: "select",
            value: function select() {
                this.selected = true;
                this.needsRefresh();
            }
            /**
             * unselect this node
             */

        }, {
            key: "unselect",
            value: function unselect() {
                this.selected = false;
                this.needsRefresh();
            }
            /**
             * Reset the calculated size of the node, forces it to recalculate its size
             */

        }, {
            key: "needsRefresh",
            value: function needsRefresh() {
                this.shape.refreshNeeded = true;
            }
            /**
             * get the title of this node.
             *
             * @returns {string} title    The title of the node, or undefined when no title
             *                           has been set.
             */

        }, {
            key: "getTitle",
            value: function getTitle() {
                return this.options.title;
            }
            /**
             * Calculate the distance to the border of the Node
             *
             * @param {CanvasRenderingContext2D}   ctx
             * @param {number} angle        Angle in radians
             * @returns {number} distance   Distance to the border in pixels
             */

        }, {
            key: "distanceToBorder",
            value: function distanceToBorder(ctx, angle) {
                return this.shape.distanceToBorder(ctx, angle);
            }
            /**
             * Check if this node has a fixed x and y position
             *
             * @returns {boolean}      true if fixed, false if not
             */

        }, {
            key: "isFixed",
            value: function isFixed() {
                return this.options.fixed.x && this.options.fixed.y;
            }
            /**
             * check if this node is selecte
             *
             * @returns {boolean} selected   True if node is selected, else false
             */

        }, {
            key: "isSelected",
            value: function isSelected() {
                return this.selected;
            }
            /**
             * Retrieve the value of the node. Can be undefined
             *
             * @returns {number} value
             */

        }, {
            key: "getValue",
            value: function getValue() {
                return this.options.value;
            }
            /**
             * Get the current dimensions of the label
             *
             * @returns {rect}
             */

        }, {
            key: "getLabelSize",
            value: function getLabelSize() {
                return this.labelModule.size();
            }
            /**
             * Adjust the value range of the node. The node will adjust it's size
             * based on its value.
             *
             * @param {number} min
             * @param {number} max
             * @param {number} total
             */

        }, {
            key: "setValueRange",
            value: function setValueRange(min, max, total) {
                if (this.options.value !== undefined) {
                    var scale = this.options.scaling.customScalingFunction(min, max, total, this.options.value);
                    var sizeDiff = this.options.scaling.max - this.options.scaling.min;

                    if (this.options.scaling.label.enabled === true) {
                        var fontDiff = this.options.scaling.label.max - this.options.scaling.label.min;
                        this.options.font.size = this.options.scaling.label.min + scale * fontDiff;
                    }

                    this.options.size = this.options.scaling.min + scale * sizeDiff;
                } else {
                    this.options.size = this.baseSize;
                    this.options.font.size = this.baseFontSize;
                }

                this.updateLabelModule();
            }
            /**
             * Draw this node in the given canvas
             * The 2d context of a HTML canvas can be retrieved by canvas.getContext("2d");
             *
             * @param {CanvasRenderingContext2D}   ctx
             *
             * @returns {object} Callbacks to draw later on higher layers.
             */

        }, {
            key: "draw",
            value: function draw(ctx) {
                var values = this.getFormattingValues();
                return this.shape.draw(ctx, this.x, this.y, this.selected, this.hover, values) || {};
            }
            /**
             * Update the bounding box of the shape
             *
             * @param {CanvasRenderingContext2D}   ctx
             */

        }, {
            key: "updateBoundingBox",
            value: function updateBoundingBox(ctx) {
                this.shape.updateBoundingBox(this.x, this.y, ctx);
            }
            /**
             * Recalculate the size of this node in the given canvas
             * The 2d context of a HTML canvas can be retrieved by canvas.getContext("2d");
             *
             * @param {CanvasRenderingContext2D}   ctx
             */

        }, {
            key: "resize",
            value: function resize(ctx) {
                var values = this.getFormattingValues();
                this.shape.resize(ctx, this.selected, this.hover, values);
            }
            /**
             * Determine all visual elements of this node instance, in which the given
             * point falls within the bounding shape.
             *
             * @param {point} point
             * @returns {Array.<nodeClickItem|nodeLabelClickItem>} list with the items which are on the point
             */

        }, {
            key: "getItemsOnPoint",
            value: function getItemsOnPoint(point) {
                var ret = [];

                if (this.labelModule.visible()) {
                    if (pointInRect(this.labelModule.getSize(), point)) {
                        ret.push({
                            nodeId: this.id,
                            labelId: 0
                        });
                    }
                }

                if (pointInRect(this.shape.boundingBox, point)) {
                    ret.push({
                        nodeId: this.id
                    });
                }

                return ret;
            }
            /**
             * Check if this object is overlapping with the provided object
             *
             * @param {object} obj   an object with parameters left, top, right, bottom
             * @returns {boolean}     True if location is located on node
             */

        }, {
            key: "isOverlappingWith",
            value: function isOverlappingWith(obj) {
                return this.shape.left < obj.right && this.shape.left + this.shape.width > obj.left && this.shape.top < obj.bottom && this.shape.top + this.shape.height > obj.top;
            }
            /**
             * Check if this object is overlapping with the provided object
             *
             * @param {object} obj   an object with parameters left, top, right, bottom
             * @returns {boolean}     True if location is located on node
             */

        }, {
            key: "isBoundingBoxOverlappingWith",
            value: function isBoundingBoxOverlappingWith(obj) {
                return this.shape.boundingBox.left < obj.right && this.shape.boundingBox.right > obj.left && this.shape.boundingBox.top < obj.bottom && this.shape.boundingBox.bottom > obj.top;
            }
            /**
             * Check valid values for mass
             *
             * The mass may not be negative or zero. If it is, reset to 1
             *
             * @param {object} options
             * @param {Node.id} id
             * @static
             */

        }], [{
            key: "checkOpacity",
            value: function checkOpacity(opacity) {
                return 0 <= opacity && opacity <= 1;
            }
            /**
             * Check that origin is 'center' or 'top-left'
             *
             * @param {string} origin
             * @returns {boolean}
             */

        }, {
            key: "checkCoordinateOrigin",
            value: function checkCoordinateOrigin(origin) {
                return origin === undefined || origin === "center" || origin === "top-left";
            }
            /**
             * Copy group option values into the node options.
             *
             * The group options override the global node options, so the copy of group options
             *  must happen *after* the global node options have been set.
             *
             * This method must also be called also if the global node options have changed and the group options did not.
             *
             * @param {object} parentOptions
             * @param {object} newOptions  new values for the options, currently only passed in for check
             * @param {object} groupList
             */

        }, {
            key: "updateGroupOptions",
            value: function updateGroupOptions(parentOptions, newOptions, groupList) {
                var _context4;

                if (groupList === undefined) return; // No groups, nothing to do

                var group = parentOptions.group; // paranoia: the selected group is already merged into node options, check.

                if (newOptions !== undefined && newOptions.group !== undefined && group !== newOptions.group) {
                    throw new Error("updateGroupOptions: group values in options don't match.");
                }

                var hasGroup = typeof group === "number" || typeof group === "string" && group != "";
                if (!hasGroup) return; // current node has no group, no need to merge

                var groupObj = groupList.get(group);

                if (groupObj.opacity !== undefined && newOptions.opacity === undefined) {
                    if (!Node.checkOpacity(groupObj.opacity)) {
                        console.error("Invalid option for node opacity. Value must be between 0 and 1, found: " + groupObj.opacity);
                        groupObj.opacity = undefined;
                    }
                } // Skip any new option to avoid them being overridden by the group options.


                var skipProperties = filter(_context4 = getOwnPropertyNames(newOptions)).call(_context4, function (p) {
                    return newOptions[p] != null;
                }); // Always skip merging group font options into parent; these are required to be distinct for labels


                skipProperties.push("font");
                selectiveNotDeepExtend(skipProperties, parentOptions, groupObj); // the color object needs to be completely defined.
                // Since groups can partially overwrite the colors, we parse it again, just in case.

                parentOptions.color = parseColor(parentOptions.color);
            }
            /**
             * This process all possible shorthands in the new options and makes sure that the parentOptions are fully defined.
             * Static so it can also be used by the handler.
             *
             * @param {object} parentOptions
             * @param {object} newOptions
             * @param {boolean} [allowDeletion=false]
             * @param {object} [globalOptions={}]
             * @param {object} [groupList]
             * @static
             */

        }, {
            key: "parseOptions",
            value: function parseOptions(parentOptions, newOptions) {
                var allowDeletion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var globalOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var groupList = arguments.length > 4 ? arguments[4] : undefined;
                var fields = ["color", "fixed", "shadow"];
                selectiveNotDeepExtend(fields, parentOptions, newOptions, allowDeletion);
                Node.checkMass(newOptions);

                if (parentOptions.opacity !== undefined) {
                    if (!Node.checkOpacity(parentOptions.opacity)) {
                        console.error("Invalid option for node opacity. Value must be between 0 and 1, found: " + parentOptions.opacity);
                        parentOptions.opacity = undefined;
                    }
                }

                if (newOptions.opacity !== undefined) {
                    if (!Node.checkOpacity(newOptions.opacity)) {
                        console.error("Invalid option for node opacity. Value must be between 0 and 1, found: " + newOptions.opacity);
                        newOptions.opacity = undefined;
                    }
                }

                if (newOptions.shapeProperties && !Node.checkCoordinateOrigin(newOptions.shapeProperties.coordinateOrigin)) {
                    console.error("Invalid option for node coordinateOrigin, found: " + newOptions.shapeProperties.coordinateOrigin);
                } // merge the shadow options into the parent.


                mergeOptions(parentOptions, newOptions, "shadow", globalOptions); // individual shape newOptions

                if (newOptions.color !== undefined && newOptions.color !== null) {
                    var parsedColor = parseColor(newOptions.color);
                    fillIfDefined(parentOptions.color, parsedColor);
                } else if (allowDeletion === true && newOptions.color === null) {
                    parentOptions.color = bridgeObject(globalOptions.color); // set the object back to the global options
                } // handle the fixed options


                if (newOptions.fixed !== undefined && newOptions.fixed !== null) {
                    if (typeof newOptions.fixed === "boolean") {
                        parentOptions.fixed.x = newOptions.fixed;
                        parentOptions.fixed.y = newOptions.fixed;
                    } else {
                        if (newOptions.fixed.x !== undefined && typeof newOptions.fixed.x === "boolean") {
                            parentOptions.fixed.x = newOptions.fixed.x;
                        }

                        if (newOptions.fixed.y !== undefined && typeof newOptions.fixed.y === "boolean") {
                            parentOptions.fixed.y = newOptions.fixed.y;
                        }
                    }
                }

                if (allowDeletion === true && newOptions.font === null) {
                    parentOptions.font = bridgeObject(globalOptions.font); // set the object back to the global options
                }

                Node.updateGroupOptions(parentOptions, newOptions, groupList); // handle the scaling options, specifically the label part

                if (newOptions.scaling !== undefined) {
                    mergeOptions(parentOptions.scaling, newOptions.scaling, "label", globalOptions.scaling);
                }
            }
        }, {
            key: "checkMass",
            value: function checkMass(options, id) {
                if (options.mass !== undefined && options.mass <= 0) {
                    var strId = "";

                    if (id !== undefined) {
                        strId = " in node id: " + id;
                    }

                    console.error("%cNegative or zero mass disallowed" + strId + ", setting mass to 1.", VALIDATOR_PRINT_STYLE$1);
                    options.mass = 1;
                }
            }
        }]);

        return Node;
    }();

    function _createForOfIteratorHelper$6(o, allowArrayLike) { var it; if (typeof symbol === "undefined" || getIteratorMethod(o) == null) { if (isArray(o) || (it = _unsupportedIterableToArray$6(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

    function _unsupportedIterableToArray$6(o, minLen) { var _context4; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$6(o, minLen); var n = slice$1(_context4 = Object.prototype.toString.call(o)).call(_context4, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return from$2(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen); }

    function _arrayLikeToArray$6(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
    /**
     * Handler for Nodes
     */

    var NodesHandler = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {Images} images
         * @param {Array.<Group>} groups
         * @param {LayoutEngine} layoutEngine
         */
        function NodesHandler(body, images, groups, layoutEngine) {
            var _context,
                _this = this;

            _classCallCheck(this, NodesHandler);

            this.body = body;
            this.images = images;
            this.groups = groups;
            this.layoutEngine = layoutEngine; // create the node API in the body container

            this.body.functions.createNode = bind(_context = this.create).call(_context, this);
            this.nodesListeners = {
                add: function add(event, params) {
                    _this.add(params.items);
                },
                update: function update(event, params) {
                    _this.update(params.items, params.data, params.oldData);
                },
                remove: function remove(event, params) {
                    _this.remove(params.items);
                }
            };
            this.defaultOptions = {
                borderWidth: 1,
                borderWidthSelected: undefined,
                brokenImage: undefined,
                color: {
                    border: "#2B7CE9",
                    background: "#97C2FC",
                    highlight: {
                        border: "#2B7CE9",
                        background: "#D2E5FF"
                    },
                    hover: {
                        border: "#2B7CE9",
                        background: "#D2E5FF"
                    }
                },
                opacity: undefined,
                // number between 0 and 1
                fixed: {
                    x: false,
                    y: false
                },
                font: {
                    color: "#343434",
                    size: 14,
                    // px
                    face: "arial",
                    background: "none",
                    strokeWidth: 0,
                    // px
                    strokeColor: "#ffffff",
                    align: "center",
                    vadjust: 0,
                    multi: false,
                    bold: {
                        mod: "bold"
                    },
                    boldital: {
                        mod: "bold italic"
                    },
                    ital: {
                        mod: "italic"
                    },
                    mono: {
                        mod: "",
                        size: 15,
                        // px
                        face: "monospace",
                        vadjust: 2
                    }
                },
                group: undefined,
                hidden: false,
                icon: {
                    face: "FontAwesome",
                    //'FontAwesome',
                    code: undefined,
                    //'\uf007',
                    size: 50,
                    //50,
                    color: "#2B7CE9" //'#aa00ff'

                },
                image: undefined,
                // --> URL
                imagePadding: {
                    // only for image shape
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                },
                label: undefined,
                labelHighlightBold: true,
                level: undefined,
                margin: {
                    top: 5,
                    right: 5,
                    bottom: 5,
                    left: 5
                },
                mass: 1,
                physics: true,
                scaling: {
                    min: 10,
                    max: 30,
                    label: {
                        enabled: false,
                        min: 14,
                        max: 30,
                        maxVisible: 30,
                        drawThreshold: 5
                    },
                    customScalingFunction: function customScalingFunction(min, max, total, value) {
                        if (max === min) {
                            return 0.5;
                        } else {
                            var scale = 1 / (max - min);
                            return Math.max(0, (value - min) * scale);
                        }
                    }
                },
                shadow: {
                    enabled: false,
                    color: "rgba(0,0,0,0.5)",
                    size: 10,
                    x: 5,
                    y: 5
                },
                shape: "ellipse",
                shapeProperties: {
                    borderDashes: false,
                    // only for borders
                    borderRadius: 6,
                    // only for box shape
                    interpolation: true,
                    // only for image and circularImage shapes
                    useImageSize: false,
                    // only for image and circularImage shapes
                    useBorderWithImage: false,
                    // only for image shape
                    coordinateOrigin: "center" // only for image and circularImage shapes

                },
                size: 25,
                title: undefined,
                value: undefined,
                x: undefined,
                y: undefined
            }; // Protect from idiocy

            if (this.defaultOptions.mass <= 0) {
                throw "Internal error: mass in defaultOptions of NodesHandler may not be zero or negative";
            }

            this.options = bridgeObject(this.defaultOptions);
            this.bindEventListeners();
        }
        /**
         * Binds event listeners
         */


        _createClass(NodesHandler, [{
            key: "bindEventListeners",
            value: function bindEventListeners() {
                var _context2,
                    _context3,
                    _this2 = this;

                // refresh the nodes. Used when reverting from hierarchical layout
                this.body.emitter.on("refreshNodes", bind(_context2 = this.refresh).call(_context2, this));
                this.body.emitter.on("refresh", bind(_context3 = this.refresh).call(_context3, this));
                this.body.emitter.on("destroy", function () {
                    forEach$1(_this2.nodesListeners, function (callback, event) {
                        if (_this2.body.data.nodes) _this2.body.data.nodes.off(event, callback);
                    });
                    delete _this2.body.functions.createNode;
                    delete _this2.nodesListeners.add;
                    delete _this2.nodesListeners.update;
                    delete _this2.nodesListeners.remove;
                    delete _this2.nodesListeners;
                });
            }
            /**
             *
             * @param {object} options
             */

        }, {
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    Node.parseOptions(this.options, options); // Need to set opacity here because Node.parseOptions is also used for groups,
                    // if you set opacity in Node.parseOptions it overwrites group opacity.

                    if (options.opacity !== undefined) {
                        if (isNan(options.opacity) || !_isFinite(options.opacity) || options.opacity < 0 || options.opacity > 1) {
                            console.error("Invalid option for node opacity. Value must be between 0 and 1, found: " + options.opacity);
                        } else {
                            this.options.opacity = options.opacity;
                        }
                    } // update the shape in all nodes


                    if (options.shape !== undefined) {
                        for (var nodeId in this.body.nodes) {
                            if (Object.prototype.hasOwnProperty.call(this.body.nodes, nodeId)) {
                                this.body.nodes[nodeId].updateShape();
                            }
                        }
                    } // Update the labels of nodes if any relevant options changed.


                    if (typeof options.font !== "undefined" || typeof options.widthConstraint !== "undefined" || typeof options.heightConstraint !== "undefined") {
                        for (var _i = 0, _Object$keys = keys$3(this.body.nodes); _i < _Object$keys.length; _i++) {
                            var _nodeId = _Object$keys[_i];

                            this.body.nodes[_nodeId].updateLabelModule();

                            this.body.nodes[_nodeId].needsRefresh();
                        }
                    } // update the shape size in all nodes


                    if (options.size !== undefined) {
                        for (var _nodeId2 in this.body.nodes) {
                            if (Object.prototype.hasOwnProperty.call(this.body.nodes, _nodeId2)) {
                                this.body.nodes[_nodeId2].needsRefresh();
                            }
                        }
                    } // update the state of the variables if needed


                    if (options.hidden !== undefined || options.physics !== undefined) {
                        this.body.emitter.emit("_dataChanged");
                    }
                }
            }
            /**
             * Set a data set with nodes for the network
             *
             * @param {Array | DataSet | DataView} nodes         The data containing the nodes.
             * @param {boolean} [doNotEmit=false] - Suppress data changed event.
             * @private
             */

        }, {
            key: "setData",
            value: function setData(nodes) {
                var doNotEmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var oldNodesData = this.body.data.nodes;

                if (isDataViewLike("id", nodes)) {
                    this.body.data.nodes = nodes;
                } else if (isArray(nodes)) {
                    this.body.data.nodes = new DataSet();
                    this.body.data.nodes.add(nodes);
                } else if (!nodes) {
                    this.body.data.nodes = new DataSet();
                } else {
                    throw new TypeError("Array or DataSet expected");
                }

                if (oldNodesData) {
                    // unsubscribe from old dataset
                    forEach$1(this.nodesListeners, function (callback, event) {
                        oldNodesData.off(event, callback);
                    });
                } // remove drawn nodes


                this.body.nodes = {};

                if (this.body.data.nodes) {
                    // subscribe to new dataset
                    var me = this;
                    forEach$1(this.nodesListeners, function (callback, event) {
                        me.body.data.nodes.on(event, callback);
                    }); // draw all new nodes

                    var ids = this.body.data.nodes.getIds();
                    this.add(ids, true);
                }

                if (doNotEmit === false) {
                    this.body.emitter.emit("_dataChanged");
                }
            }
            /**
             * Add nodes
             *
             * @param {number[] | string[]} ids
             * @param {boolean} [doNotEmit=false]
             * @private
             */

        }, {
            key: "add",
            value: function add(ids) {
                var doNotEmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var id;
                var newNodes = [];

                for (var i = 0; i < ids.length; i++) {
                    id = ids[i];
                    var properties = this.body.data.nodes.get(id);
                    var node = this.create(properties);
                    newNodes.push(node);
                    this.body.nodes[id] = node; // note: this may replace an existing node
                }

                this.layoutEngine.positionInitially(newNodes);

                if (doNotEmit === false) {
                    this.body.emitter.emit("_dataChanged");
                }
            }
            /**
             * Update existing nodes, or create them when not yet existing
             *
             * @param {number[] | string[]} ids id's of changed nodes
             * @param {Array} changedData array with changed data
             * @param {Array|undefined} oldData optional; array with previous data
             * @private
             */

        }, {
            key: "update",
            value: function update(ids, changedData, oldData) {
                var nodes = this.body.nodes;
                var dataChanged = false;

                for (var i = 0; i < ids.length; i++) {
                    var id = ids[i];
                    var node = nodes[id];
                    var data = changedData[i];

                    if (node !== undefined) {
                        // update node
                        if (node.setOptions(data)) {
                            dataChanged = true;
                        }
                    } else {
                        dataChanged = true; // create node

                        node = this.create(data);
                        nodes[id] = node;
                    }
                }

                if (!dataChanged && oldData !== undefined) {
                    // Check for any changes which should trigger a layout recalculation
                    // For now, this is just 'level' for hierarchical layout
                    // Assumption: old and new data arranged in same order; at time of writing, this holds.
                    dataChanged = some(changedData).call(changedData, function (newValue, index) {
                        var oldValue = oldData[index];
                        return oldValue && oldValue.level !== newValue.level;
                    });
                }

                if (dataChanged === true) {
                    this.body.emitter.emit("_dataChanged");
                } else {
                    this.body.emitter.emit("_dataUpdated");
                }
            }
            /**
             * Remove existing nodes. If nodes do not exist, the method will just ignore it.
             *
             * @param {number[] | string[]} ids
             * @private
             */

        }, {
            key: "remove",
            value: function remove(ids) {
                var nodes = this.body.nodes;

                for (var i = 0; i < ids.length; i++) {
                    var id = ids[i];
                    delete nodes[id];
                }

                this.body.emitter.emit("_dataChanged");
            }
            /**
             * create a node
             *
             * @param {object} properties
             * @param {class} [constructorClass=Node.default]
             * @returns {*}
             */

        }, {
            key: "create",
            value: function create(properties) {
                var constructorClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Node;
                return new constructorClass(properties, this.body, this.images, this.groups, this.options, this.defaultOptions);
            }
            /**
             *
             * @param {boolean} [clearPositions=false]
             */

        }, {
            key: "refresh",
            value: function refresh() {
                var _this3 = this;

                var clearPositions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                forEach$1(this.body.nodes, function (node, nodeId) {
                    var data = _this3.body.data.nodes.get(nodeId);

                    if (data !== undefined) {
                        if (clearPositions === true) {
                            node.setOptions({
                                x: null,
                                y: null
                            });
                        }

                        node.setOptions({
                            fixed: false
                        });
                        node.setOptions(data);
                    }
                });
            }
            /**
             * Returns the positions of the nodes.
             *
             * @param {Array.<Node.id> | string} [ids]  --> optional, can be array of nodeIds, can be string
             * @returns {{}}
             */

        }, {
            key: "getPositions",
            value: function getPositions(ids) {
                var dataArray = {};

                if (ids !== undefined) {
                    if (isArray(ids) === true) {
                        for (var i = 0; i < ids.length; i++) {
                            if (this.body.nodes[ids[i]] !== undefined) {
                                var node = this.body.nodes[ids[i]];
                                dataArray[ids[i]] = {
                                    x: Math.round(node.x),
                                    y: Math.round(node.y)
                                };
                            }
                        }
                    } else {
                        if (this.body.nodes[ids] !== undefined) {
                            var _node = this.body.nodes[ids];
                            dataArray[ids] = {
                                x: Math.round(_node.x),
                                y: Math.round(_node.y)
                            };
                        }
                    }
                } else {
                    for (var _i2 = 0; _i2 < this.body.nodeIndices.length; _i2++) {
                        var _node2 = this.body.nodes[this.body.nodeIndices[_i2]];
                        dataArray[this.body.nodeIndices[_i2]] = {
                            x: Math.round(_node2.x),
                            y: Math.round(_node2.y)
                        };
                    }
                }

                return dataArray;
            }
            /**
             * Retrieves the x y position of a specific id.
             *
             * @param {string} id The id to retrieve.
             *
             * @throws {TypeError} If no id is included.
             * @throws {ReferenceError} If an invalid id is provided.
             *
             * @returns {{ x: number, y: number }} Returns X, Y canvas position of the node with given id.
             */

        }, {
            key: "getPosition",
            value: function getPosition(id) {
                if (id == undefined) {
                    throw new TypeError("No id was specified for getPosition method.");
                } else if (this.body.nodes[id] == undefined) {
                    throw new ReferenceError("NodeId provided for getPosition does not exist. Provided: ".concat(id));
                } else {
                    return {
                        x: Math.round(this.body.nodes[id].x),
                        y: Math.round(this.body.nodes[id].y)
                    };
                }
            }
            /**
             * Load the XY positions of the nodes into the dataset.
             */

        }, {
            key: "storePositions",
            value: function storePositions() {
                // todo: add support for clusters and hierarchical.
                var dataArray = [];
                var dataset = this.body.data.nodes.getDataSet();

                var _iterator = _createForOfIteratorHelper$6(dataset.get()),
                    _step;

                try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        var dsNode = _step.value;
                        var id = dsNode.id;
                        var bodyNode = this.body.nodes[id];
                        var x = Math.round(bodyNode.x);
                        var y = Math.round(bodyNode.y);

                        if (dsNode.x !== x || dsNode.y !== y) {
                            dataArray.push({
                                id: id,
                                x: x,
                                y: y
                            });
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally {
                    _iterator.f();
                }

                dataset.update(dataArray);
            }
            /**
             * get the bounding box of a node.
             *
             * @param {Node.id} nodeId
             * @returns {j|*}
             */

        }, {
            key: "getBoundingBox",
            value: function getBoundingBox(nodeId) {
                if (this.body.nodes[nodeId] !== undefined) {
                    return this.body.nodes[nodeId].shape.boundingBox;
                }
            }
            /**
             * Get the Ids of nodes connected to this node.
             *
             * @param {Node.id} nodeId
             * @param {'to'|'from'|undefined} direction values 'from' and 'to' select respectively parent and child nodes only.
             *                                          Any other value returns both parent and child nodes.
             * @returns {Array}
             */

        }, {
            key: "getConnectedNodes",
            value: function getConnectedNodes(nodeId, direction) {
                var nodeList = [];

                if (this.body.nodes[nodeId] !== undefined) {
                    var node = this.body.nodes[nodeId];
                    var nodeObj = {}; // used to quickly check if node already exists

                    for (var i = 0; i < node.edges.length; i++) {
                        var edge = node.edges[i];

                        if (direction !== "to" && edge.toId == node.id) {
                            // these are double equals since ids can be numeric or string
                            if (nodeObj[edge.fromId] === undefined) {
                                nodeList.push(edge.fromId);
                                nodeObj[edge.fromId] = true;
                            }
                        } else if (direction !== "from" && edge.fromId == node.id) {
                            // these are double equals since ids can be numeric or string
                            if (nodeObj[edge.toId] === undefined) {
                                nodeList.push(edge.toId);
                                nodeObj[edge.toId] = true;
                            }
                        }
                    }
                }

                return nodeList;
            }
            /**
             * Get the ids of the edges connected to this node.
             *
             * @param {Node.id} nodeId
             * @returns {*}
             */

        }, {
            key: "getConnectedEdges",
            value: function getConnectedEdges(nodeId) {
                var edgeList = [];

                if (this.body.nodes[nodeId] !== undefined) {
                    var node = this.body.nodes[nodeId];

                    for (var i = 0; i < node.edges.length; i++) {
                        edgeList.push(node.edges[i].id);
                    }
                } else {
                    console.error("NodeId provided for getConnectedEdges does not exist. Provided: ", nodeId);
                }

                return edgeList;
            }
            /**
             * Move a node.
             *
             * @param {Node.id} nodeId
             * @param {number} x
             * @param {number} y
             */

        }, {
            key: "moveNode",
            value: function moveNode(nodeId, x, y) {
                var _this4 = this;

                if (this.body.nodes[nodeId] !== undefined) {
                    this.body.nodes[nodeId].x = Number(x);
                    this.body.nodes[nodeId].y = Number(y);

                    setTimeout$1(function () {
                        _this4.body.emitter.emit("startSimulation");
                    }, 0);
                } else {
                    console.error("Node id supplied to moveNode does not exist. Provided: ", nodeId);
                }
            }
        }]);

        return NodesHandler;
    }();

    // https://tc39.es/ecma262/#sec-reflect.get

    function get$3(target, propertyKey
                   /* , receiver */
    ) {
        var receiver = arguments.length < 3 ? target : arguments[2];
        var descriptor, prototype;
        if (anObject(target) === receiver) return target[propertyKey];
        if (descriptor = objectGetOwnPropertyDescriptor.f(target, propertyKey)) return has$1(descriptor, 'value') ? descriptor.value : descriptor.get === undefined ? undefined : descriptor.get.call(receiver);
        if (isObject$1(prototype = objectGetPrototypeOf(target))) return get$3(prototype, propertyKey, receiver);
    }

    _export({
        target: 'Reflect',
        stat: true
    }, {
        get: get$3
    });

    var get$2 = path.Reflect.get;

    var get$1 = get$2;

    var get = get$1;

    var getOwnPropertyDescriptor$1 = getOwnPropertyDescriptor_1;

    var getOwnPropertyDescriptor = getOwnPropertyDescriptor$1;

    function _superPropBase(object, property) {
        while (!Object.prototype.hasOwnProperty.call(object, property)) {
            object = _getPrototypeOf(object);
            if (object === null) break;
        }

        return object;
    }

    function _get(target, property, receiver) {
        if (typeof Reflect !== "undefined" && get) {
            _get = get;
        } else {
            _get = function _get(target, property, receiver) {
                var base = _superPropBase(target, property);
                if (!base) return;

                var desc = getOwnPropertyDescriptor(base, property);

                if (desc.get) {
                    return desc.get.call(receiver);
                }

                return desc.value;
            };
        }

        return _get(target, property, receiver || target);
    }

    var $hypot = Math.hypot;
    var abs = Math.abs;
    var sqrt = Math.sqrt; // Chrome 77 bug
    // https://bugs.chromium.org/p/v8/issues/detail?id=9546

    var BUGGY = !!$hypot && $hypot(Infinity, NaN) !== Infinity; // `Math.hypot` method
    // https://tc39.es/ecma262/#sec-math.hypot

    _export({
        target: 'Math',
        stat: true,
        forced: BUGGY
    }, {
        // eslint-disable-next-line no-unused-vars -- required for `.length`
        hypot: function hypot(value1, value2) {
            var sum = 0;
            var i = 0;
            var aLen = arguments.length;
            var larg = 0;
            var arg, div;

            while (i < aLen) {
                arg = abs(arguments[i++]);

                if (larg < arg) {
                    div = larg / arg;
                    sum = sum * div * div + 1;
                    larg = arg;
                } else if (arg > 0) {
                    div = arg / larg;
                    sum += div * div;
                } else sum += arg;
            }

            return larg === Infinity ? Infinity : larg * sqrt(sum);
        }
    });

    var hypot$2 = path.Math.hypot;

    var hypot$1 = hypot$2;

    var hypot = hypot$1;

    function _createSuper$a(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$a(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$a() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * Common methods for endpoints
     *
     * @class
     */

    var EndPoint = /*#__PURE__*/function () {
        function EndPoint() {
            _classCallCheck(this, EndPoint);
        }

        _createClass(EndPoint, null, [{
            key: "transform",
            value:
                /**
                 * Apply transformation on points for display.
                 *
                 * The following is done:
                 * - rotate by the specified angle
                 * - multiply the (normalized) coordinates by the passed length
                 * - offset by the target coordinates
                 *
                 * @param points - The point(s) to be transformed.
                 * @param arrowData - The data determining the result of the transformation.
                 */
                function transform(points, arrowData) {
                    if (!isArray(points)) {
                        points = [points];
                    }

                    var x = arrowData.point.x;
                    var y = arrowData.point.y;
                    var angle = arrowData.angle;
                    var length = arrowData.length;

                    for (var i = 0; i < points.length; ++i) {
                        var p = points[i];
                        var xt = p.x * Math.cos(angle) - p.y * Math.sin(angle);
                        var yt = p.x * Math.sin(angle) + p.y * Math.cos(angle);
                        p.x = x + length * xt;
                        p.y = y + length * yt;
                    }
                }
            /**
             * Draw a closed path using the given real coordinates.
             *
             * @param ctx - The path will be rendered into this context.
             * @param points - The points of the path.
             */

        }, {
            key: "drawPath",
            value: function drawPath(ctx, points) {
                ctx.beginPath();
                ctx.moveTo(points[0].x, points[0].y);

                for (var i = 1; i < points.length; ++i) {
                    ctx.lineTo(points[i].x, points[i].y);
                }

                ctx.closePath();
            }
        }]);

        return EndPoint;
    }();
    /**
     * Drawing methods for the arrow endpoint.
     */


    var Image$1 = /*#__PURE__*/function (_EndPoint) {
        _inherits(Image, _EndPoint);

        var _super = _createSuper$a(Image);

        function Image() {
            _classCallCheck(this, Image);

            return _super.apply(this, arguments);
        }

        _createClass(Image, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns False as there is no way to fill an image.
                 */
                function draw(ctx, arrowData) {
                    if (arrowData.image) {
                        ctx.save();
                        ctx.translate(arrowData.point.x, arrowData.point.y);
                        ctx.rotate(Math.PI / 2 + arrowData.angle);
                        var width = arrowData.imageWidth != null ? arrowData.imageWidth : arrowData.image.width;
                        var height = arrowData.imageHeight != null ? arrowData.imageHeight : arrowData.image.height;
                        arrowData.image.drawImageAtPosition(ctx, 1, // scale
                            -width / 2, // x
                            0, // y
                            width, height);
                        ctx.restore();
                    }

                    return false;
                }
        }]);

        return Image;
    }(EndPoint);
    /**
     * Drawing methods for the arrow endpoint.
     */


    var Arrow = /*#__PURE__*/function (_EndPoint2) {
        _inherits(Arrow, _EndPoint2);

        var _super2 = _createSuper$a(Arrow);

        function Arrow() {
            _classCallCheck(this, Arrow);

            return _super2.apply(this, arguments);
        }

        _createClass(Arrow, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    // Normalized points of closed path, in the order that they should be drawn.
                    // (0, 0) is the attachment point, and the point around which should be rotated
                    var points = [{
                        x: 0,
                        y: 0
                    }, {
                        x: -1,
                        y: 0.3
                    }, {
                        x: -0.9,
                        y: 0
                    }, {
                        x: -1,
                        y: -0.3
                    }];
                    EndPoint.transform(points, arrowData);
                    EndPoint.drawPath(ctx, points);
                    return true;
                }
        }]);

        return Arrow;
    }(EndPoint);
    /**
     * Drawing methods for the crow endpoint.
     */


    var Crow = /*#__PURE__*/function () {
        function Crow() {
            _classCallCheck(this, Crow);
        }

        _createClass(Crow, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    // Normalized points of closed path, in the order that they should be drawn.
                    // (0, 0) is the attachment point, and the point around which should be rotated
                    var points = [{
                        x: -1,
                        y: 0
                    }, {
                        x: 0,
                        y: 0.3
                    }, {
                        x: -0.4,
                        y: 0
                    }, {
                        x: 0,
                        y: -0.3
                    }];
                    EndPoint.transform(points, arrowData);
                    EndPoint.drawPath(ctx, points);
                    return true;
                }
        }]);

        return Crow;
    }();
    /**
     * Drawing methods for the curve endpoint.
     */


    var Curve = /*#__PURE__*/function () {
        function Curve() {
            _classCallCheck(this, Curve);
        }

        _createClass(Curve, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    // Normalized points of closed path, in the order that they should be drawn.
                    // (0, 0) is the attachment point, and the point around which should be rotated
                    var point = {
                        x: -0.4,
                        y: 0
                    };
                    EndPoint.transform(point, arrowData); // Update endpoint style for drawing transparent arc.

                    ctx.strokeStyle = ctx.fillStyle;
                    ctx.fillStyle = "rgba(0, 0, 0, 0)"; // Define curve endpoint as semicircle.

                    var pi = Math.PI;
                    var startAngle = arrowData.angle - pi / 2;
                    var endAngle = arrowData.angle + pi / 2;
                    ctx.beginPath();
                    ctx.arc(point.x, point.y, arrowData.length * 0.4, startAngle, endAngle, false);
                    ctx.stroke();
                    return true;
                }
        }]);

        return Curve;
    }();
    /**
     * Drawing methods for the inverted curve endpoint.
     */


    var InvertedCurve = /*#__PURE__*/function () {
        function InvertedCurve() {
            _classCallCheck(this, InvertedCurve);
        }

        _createClass(InvertedCurve, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    // Normalized points of closed path, in the order that they should be drawn.
                    // (0, 0) is the attachment point, and the point around which should be rotated
                    var point = {
                        x: -0.3,
                        y: 0
                    };
                    EndPoint.transform(point, arrowData); // Update endpoint style for drawing transparent arc.

                    ctx.strokeStyle = ctx.fillStyle;
                    ctx.fillStyle = "rgba(0, 0, 0, 0)"; // Define inverted curve endpoint as semicircle.

                    var pi = Math.PI;
                    var startAngle = arrowData.angle + pi / 2;
                    var endAngle = arrowData.angle + 3 * pi / 2;
                    ctx.beginPath();
                    ctx.arc(point.x, point.y, arrowData.length * 0.4, startAngle, endAngle, false);
                    ctx.stroke();
                    return true;
                }
        }]);

        return InvertedCurve;
    }();
    /**
     * Drawing methods for the trinagle endpoint.
     */


    var Triangle = /*#__PURE__*/function () {
        function Triangle() {
            _classCallCheck(this, Triangle);
        }

        _createClass(Triangle, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    // Normalized points of closed path, in the order that they should be drawn.
                    // (0, 0) is the attachment point, and the point around which should be rotated
                    var points = [{
                        x: 0.02,
                        y: 0
                    }, {
                        x: -1,
                        y: 0.3
                    }, {
                        x: -1,
                        y: -0.3
                    }];
                    EndPoint.transform(points, arrowData);
                    EndPoint.drawPath(ctx, points);
                    return true;
                }
        }]);

        return Triangle;
    }();
    /**
     * Drawing methods for the inverted trinagle endpoint.
     */


    var InvertedTriangle = /*#__PURE__*/function () {
        function InvertedTriangle() {
            _classCallCheck(this, InvertedTriangle);
        }

        _createClass(InvertedTriangle, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    // Normalized points of closed path, in the order that they should be drawn.
                    // (0, 0) is the attachment point, and the point around which should be rotated
                    var points = [{
                        x: 0,
                        y: 0.3
                    }, {
                        x: 0,
                        y: -0.3
                    }, {
                        x: -1,
                        y: 0
                    }];
                    EndPoint.transform(points, arrowData);
                    EndPoint.drawPath(ctx, points);
                    return true;
                }
        }]);

        return InvertedTriangle;
    }();
    /**
     * Drawing methods for the circle endpoint.
     */


    var Circle = /*#__PURE__*/function () {
        function Circle() {
            _classCallCheck(this, Circle);
        }

        _createClass(Circle, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    var point = {
                        x: -0.4,
                        y: 0
                    };
                    EndPoint.transform(point, arrowData);
                    drawCircle(ctx, point.x, point.y, arrowData.length * 0.4);
                    return true;
                }
        }]);

        return Circle;
    }();
    /**
     * Drawing methods for the bar endpoint.
     */


    var Bar = /*#__PURE__*/function () {
        function Bar() {
            _classCallCheck(this, Bar);
        }

        _createClass(Bar, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    /*
	      var points = [
	        {x:0, y:0.5},
	        {x:0, y:-0.5}
	      ];
	           EndPoint.transform(points, arrowData);
	      ctx.beginPath();
	      ctx.moveTo(points[0].x, points[0].y);
	      ctx.lineTo(points[1].x, points[1].y);
	      ctx.stroke();
	      */
                    var points = [{
                        x: 0,
                        y: 0.5
                    }, {
                        x: 0,
                        y: -0.5
                    }, {
                        x: -0.15,
                        y: -0.5
                    }, {
                        x: -0.15,
                        y: 0.5
                    }];
                    EndPoint.transform(points, arrowData);
                    EndPoint.drawPath(ctx, points);
                    return true;
                }
        }]);

        return Bar;
    }();
    /**
     * Drawing methods for the box endpoint.
     */


    var Box = /*#__PURE__*/function () {
        function Box() {
            _classCallCheck(this, Box);
        }

        _createClass(Box, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    var points = [{
                        x: 0,
                        y: 0.3
                    }, {
                        x: 0,
                        y: -0.3
                    }, {
                        x: -0.6,
                        y: -0.3
                    }, {
                        x: -0.6,
                        y: 0.3
                    }];
                    EndPoint.transform(points, arrowData);
                    EndPoint.drawPath(ctx, points);
                    return true;
                }
        }]);

        return Box;
    }();
    /**
     * Drawing methods for the diamond endpoint.
     */


    var Diamond = /*#__PURE__*/function () {
        function Diamond() {
            _classCallCheck(this, Diamond);
        }

        _createClass(Diamond, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    var points = [{
                        x: 0,
                        y: 0
                    }, {
                        x: -0.5,
                        y: -0.3
                    }, {
                        x: -1,
                        y: 0
                    }, {
                        x: -0.5,
                        y: 0.3
                    }];
                    EndPoint.transform(points, arrowData);
                    EndPoint.drawPath(ctx, points);
                    return true;
                }
        }]);

        return Diamond;
    }();
    /**
     * Drawing methods for the vee endpoint.
     */


    var Vee = /*#__PURE__*/function () {
        function Vee() {
            _classCallCheck(this, Vee);
        }

        _createClass(Vee, null, [{
            key: "draw",
            value:
                /**
                 * Draw this shape at the end of a line.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True because ctx.fill() can be used to fill the arrow.
                 */
                function draw(ctx, arrowData) {
                    // Normalized points of closed path, in the order that they should be drawn.
                    // (0, 0) is the attachment point, and the point around which should be rotated
                    var points = [{
                        x: -1,
                        y: 0.3
                    }, {
                        x: -0.5,
                        y: 0
                    }, {
                        x: -1,
                        y: -0.3
                    }, {
                        x: 0,
                        y: 0
                    }];
                    EndPoint.transform(points, arrowData);
                    EndPoint.drawPath(ctx, points);
                    return true;
                }
        }]);

        return Vee;
    }();
    /**
     * Drawing methods for the endpoints.
     */


    var EndPoints = /*#__PURE__*/function () {
        function EndPoints() {
            _classCallCheck(this, EndPoints);
        }

        _createClass(EndPoints, null, [{
            key: "draw",
            value:
                /**
                 * Draw an endpoint.
                 *
                 * @param ctx - The shape will be rendered into this context.
                 * @param arrowData - The data determining the shape.
                 *
                 * @returns True if ctx.fill() can be used to fill the arrow, false otherwise.
                 */
                function draw(ctx, arrowData) {
                    var type;

                    if (arrowData.type) {
                        type = arrowData.type.toLowerCase();
                    }

                    switch (type) {
                        case "image":
                            return Image$1.draw(ctx, arrowData);

                        case "circle":
                            return Circle.draw(ctx, arrowData);

                        case "box":
                            return Box.draw(ctx, arrowData);

                        case "crow":
                            return Crow.draw(ctx, arrowData);

                        case "curve":
                            return Curve.draw(ctx, arrowData);

                        case "diamond":
                            return Diamond.draw(ctx, arrowData);

                        case "inv_curve":
                            return InvertedCurve.draw(ctx, arrowData);

                        case "triangle":
                            return Triangle.draw(ctx, arrowData);

                        case "inv_triangle":
                            return InvertedTriangle.draw(ctx, arrowData);

                        case "bar":
                            return Bar.draw(ctx, arrowData);

                        case "vee":
                            return Vee.draw(ctx, arrowData);

                        case "arrow": // fall-through

                        default:
                            return Arrow.draw(ctx, arrowData);
                    }
                }
        }]);

        return EndPoints;
    }();

    function ownKeys$1(object, enumerableOnly) { var keys = keys$3(object); if (getOwnPropertySymbols) { var symbols = getOwnPropertySymbols(object); if (enumerableOnly) symbols = filter(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$2(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

    function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context2; forEach$2(_context2 = ownKeys$1(Object(source), true)).call(_context2, function (key) { _defineProperty(target, key, source[key]); }); } else if (getOwnPropertyDescriptors) { defineProperties(target, getOwnPropertyDescriptors(source)); } else { var _context3; forEach$2(_context3 = ownKeys$1(Object(source))).call(_context3, function (key) { defineProperty$4(target, key, getOwnPropertyDescriptor$2(source, key)); }); } } return target; }
    /**
     * The Base Class for all edges.
     */

    var EdgeBase = /*#__PURE__*/function () {
        /**
         * Create a new instance.
         *
         * @param options - The options object of given edge.
         * @param _body - The body of the network.
         * @param _labelModule - Label module.
         */
        function EdgeBase(options, _body, _labelModule) {
            _classCallCheck(this, EdgeBase);

            this._body = _body;
            this._labelModule = _labelModule;
            this.color = {};
            this.colorDirty = true;
            this.hoverWidth = 1.5;
            this.selectionWidth = 2;
            this.setOptions(options);
            this.fromPoint = this.from;
            this.toPoint = this.to;
        }
        /** @inheritDoc */


        _createClass(EdgeBase, [{
            key: "connect",
            value: function connect() {
                this.from = this._body.nodes[this.options.from];
                this.to = this._body.nodes[this.options.to];
            }
            /** @inheritDoc */

        }, {
            key: "cleanup",
            value: function cleanup() {
                return false;
            }
            /**
             * Set new edge options.
             *
             * @param options - The new edge options object.
             */

        }, {
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
                this.from = this._body.nodes[this.options.from];
                this.to = this._body.nodes[this.options.to];
                this.id = this.options.id;
            }
            /** @inheritDoc */

        }, {
            key: "drawLine",
            value: function drawLine(ctx, values, _selected, _hover) {
                var viaNode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.getViaNode();
                // set style
                ctx.strokeStyle = this.getColor(ctx, values);
                ctx.lineWidth = values.width;

                if (values.dashes !== false) {
                    this._drawDashedLine(ctx, values, viaNode);
                } else {
                    this._drawLine(ctx, values, viaNode);
                }
            }
            /**
             * Draw a line with given style between two nodes through supplied node(s).
             *
             * @param ctx - The context that will be used for rendering.
             * @param values - Formatting values like color, opacity or shadow.
             * @param viaNode - Additional control point(s) for the edge.
             * @param fromPoint - TODO: Seems ignored, remove?
             * @param toPoint - TODO: Seems ignored, remove?
             */

        }, {
            key: "_drawLine",
            value: function _drawLine(ctx, values, viaNode, fromPoint, toPoint) {
                if (this.from != this.to) {
                    // draw line
                    this._line(ctx, values, viaNode, fromPoint, toPoint);
                } else {
                    var _this$_getCircleData = this._getCircleData(ctx),
                        _this$_getCircleData2 = _slicedToArray(_this$_getCircleData, 3),
                        x = _this$_getCircleData2[0],
                        y = _this$_getCircleData2[1],
                        radius = _this$_getCircleData2[2];

                    this._circle(ctx, values, x, y, radius);
                }
            }
            /**
             * Draw a dashed line with given style between two nodes through supplied node(s).
             *
             * @param ctx - The context that will be used for rendering.
             * @param values - Formatting values like color, opacity or shadow.
             * @param viaNode - Additional control point(s) for the edge.
             * @param _fromPoint - Ignored (TODO: remove in the future).
             * @param _toPoint - Ignored (TODO: remove in the future).
             */

        }, {
            key: "_drawDashedLine",
            value: function _drawDashedLine(ctx, values, viaNode, _fromPoint, _toPoint) {
                ctx.lineCap = "round";
                var pattern = isArray(values.dashes) ? values.dashes : [5, 5]; // only firefox and chrome support this method, else we use the legacy one.

                if (ctx.setLineDash !== undefined) {
                    ctx.save(); // set dash settings for chrome or firefox

                    ctx.setLineDash(pattern);
                    ctx.lineDashOffset = 0; // draw the line

                    if (this.from != this.to) {
                        // draw line
                        this._line(ctx, values, viaNode);
                    } else {
                        var _this$_getCircleData3 = this._getCircleData(ctx),
                            _this$_getCircleData4 = _slicedToArray(_this$_getCircleData3, 3),
                            x = _this$_getCircleData4[0],
                            y = _this$_getCircleData4[1],
                            radius = _this$_getCircleData4[2];

                        this._circle(ctx, values, x, y, radius);
                    } // restore the dash settings.


                    ctx.setLineDash([0]);
                    ctx.lineDashOffset = 0;
                    ctx.restore();
                } else {
                    // unsupporting smooth lines
                    if (this.from != this.to) {
                        // draw line
                        drawDashedLine(ctx, this.from.x, this.from.y, this.to.x, this.to.y, pattern);
                    } else {
                        var _this$_getCircleData5 = this._getCircleData(ctx),
                            _this$_getCircleData6 = _slicedToArray(_this$_getCircleData5, 3),
                            _x = _this$_getCircleData6[0],
                            _y = _this$_getCircleData6[1],
                            _radius = _this$_getCircleData6[2];

                        this._circle(ctx, values, _x, _y, _radius);
                    } // draw shadow if enabled


                    this.enableShadow(ctx, values);
                    ctx.stroke(); // disable shadows for other elements.

                    this.disableShadow(ctx, values);
                }
            }
            /**
             * Find the intersection between the border of the node and the edge.
             *
             * @param node - The node (either from or to node of the edge).
             * @param ctx - The context that will be used for rendering.
             * @param options - Additional options.
             *
             * @returns Cartesian coordinates of the intersection between the border of the node and the edge.
             */

        }, {
            key: "findBorderPosition",
            value: function findBorderPosition(node, ctx, options) {
                if (this.from != this.to) {
                    return this._findBorderPosition(node, ctx, options);
                } else {
                    return this._findBorderPositionCircle(node, ctx, options);
                }
            }
            /** @inheritDoc */

        }, {
            key: "findBorderPositions",
            value: function findBorderPositions(ctx) {
                if (this.from != this.to) {
                    return {
                        from: this._findBorderPosition(this.from, ctx),
                        to: this._findBorderPosition(this.to, ctx)
                    };
                } else {
                    var _context;

                    var _this$_getCircleData$ = slice$1(_context = this._getCircleData(ctx)).call(_context, 0, 2),
                        _this$_getCircleData$2 = _slicedToArray(_this$_getCircleData$, 2),
                        x = _this$_getCircleData$2[0],
                        y = _this$_getCircleData$2[1];

                    return {
                        from: this._findBorderPositionCircle(this.from, ctx, {
                            x: x,
                            y: y,
                            low: 0.25,
                            high: 0.6,
                            direction: -1
                        }),
                        to: this._findBorderPositionCircle(this.from, ctx, {
                            x: x,
                            y: y,
                            low: 0.6,
                            high: 0.8,
                            direction: 1
                        })
                    };
                }
            }
            /**
             * Compute the center point and radius of an edge connected to the same node at both ends.
             *
             * @param ctx - The context that will be used for rendering.
             *
             * @returns `[x, y, radius]`
             */

        }, {
            key: "_getCircleData",
            value: function _getCircleData(ctx) {
                var radius = this.options.selfReference.size;

                if (ctx !== undefined) {
                    if (this.from.shape.width === undefined) {
                        this.from.shape.resize(ctx);
                    }
                } // get circle coordinates


                var coordinates = getSelfRefCoordinates(ctx, this.options.selfReference.angle, radius, this.from);
                return [coordinates.x, coordinates.y, radius];
            }
            /**
             * Get a point on a circle.
             *
             * @param x - Center of the circle on the x axis.
             * @param y - Center of the circle on the y axis.
             * @param radius - Radius of the circle.
             * @param position - Value between 0 (line start) and 1 (line end).
             *
             * @returns Cartesian coordinates of requested point on the circle.
             */

        }, {
            key: "_pointOnCircle",
            value: function _pointOnCircle(x, y, radius, position) {
                var angle = position * 2 * Math.PI;
                return {
                    x: x + radius * Math.cos(angle),
                    y: y - radius * Math.sin(angle)
                };
            }
            /**
             * Find the intersection between the border of the node and the edge.
             *
             * @remarks
             * This function uses binary search to look for the point where the circle crosses the border of the node.
             *
             * @param nearNode - The node (either from or to node of the edge).
             * @param ctx - The context that will be used for rendering.
             * @param options - Additional options.
             *
             * @returns Cartesian coordinates of the intersection between the border of the node and the edge.
             */

        }, {
            key: "_findBorderPositionCircle",
            value: function _findBorderPositionCircle(nearNode, ctx, options) {
                var x = options.x;
                var y = options.y;
                var low = options.low;
                var high = options.high;
                var direction = options.direction;
                var maxIterations = 10;
                var radius = this.options.selfReference.size;
                var threshold = 0.05;
                var pos;
                var middle = (low + high) * 0.5;
                var endPointOffset = 0;

                if (this.options.arrowStrikethrough === true) {
                    if (direction === -1) {
                        endPointOffset = this.options.endPointOffset.from;
                    } else if (direction === 1) {
                        endPointOffset = this.options.endPointOffset.to;
                    }
                }

                var iteration = 0;

                do {
                    middle = (low + high) * 0.5;
                    pos = this._pointOnCircle(x, y, radius, middle);
                    var angle = Math.atan2(nearNode.y - pos.y, nearNode.x - pos.x);
                    var distanceToBorder = nearNode.distanceToBorder(ctx, angle) + endPointOffset;
                    var distanceToPoint = Math.sqrt(Math.pow(pos.x - nearNode.x, 2) + Math.pow(pos.y - nearNode.y, 2));
                    var difference = distanceToBorder - distanceToPoint;

                    if (Math.abs(difference) < threshold) {
                        break; // found
                    } else if (difference > 0) {
                        // distance to nodes is larger than distance to border --> t needs to be bigger if we're looking at the to node.
                        if (direction > 0) {
                            low = middle;
                        } else {
                            high = middle;
                        }
                    } else {
                        if (direction > 0) {
                            high = middle;
                        } else {
                            low = middle;
                        }
                    }

                    ++iteration;
                } while (low <= high && iteration < maxIterations);

                return _objectSpread$1(_objectSpread$1({}, pos), {}, {
                    t: middle
                });
            }
            /**
             * Get the line width of the edge. Depends on width and whether one of the connected nodes is selected.
             *
             * @param selected - Determines wheter the line is selected.
             * @param hover - Determines wheter the line is being hovered, only applies if selected is false.
             *
             * @returns The width of the line.
             */

        }, {
            key: "getLineWidth",
            value: function getLineWidth(selected, hover) {
                if (selected === true) {
                    return Math.max(this.selectionWidth, 0.3 / this._body.view.scale);
                } else if (hover === true) {
                    return Math.max(this.hoverWidth, 0.3 / this._body.view.scale);
                } else {
                    return Math.max(this.options.width, 0.3 / this._body.view.scale);
                }
            }
            /**
             * Compute the color or gradient for given edge.
             *
             * @param ctx - The context that will be used for rendering.
             * @param values - Formatting values like color, opacity or shadow.
             * @param _selected - Ignored (TODO: remove in the future).
             * @param _hover - Ignored (TODO: remove in the future).
             *
             * @returns Color string if single color is inherited or gradient if two.
             */

        }, {
            key: "getColor",
            value: function getColor(ctx, values) {
                if (values.inheritsColor !== false) {
                    // when this is a loop edge, just use the 'from' method
                    if (values.inheritsColor === "both" && this.from.id !== this.to.id) {
                        var grd = ctx.createLinearGradient(this.from.x, this.from.y, this.to.x, this.to.y);
                        var fromColor = this.from.options.color.highlight.border;
                        var toColor = this.to.options.color.highlight.border;

                        if (this.from.selected === false && this.to.selected === false) {
                            fromColor = overrideOpacity(this.from.options.color.border, values.opacity);
                            toColor = overrideOpacity(this.to.options.color.border, values.opacity);
                        } else if (this.from.selected === true && this.to.selected === false) {
                            toColor = this.to.options.color.border;
                        } else if (this.from.selected === false && this.to.selected === true) {
                            fromColor = this.from.options.color.border;
                        }

                        grd.addColorStop(0, fromColor);
                        grd.addColorStop(1, toColor); // -------------------- this returns -------------------- //

                        return grd;
                    }

                    if (values.inheritsColor === "to") {
                        return overrideOpacity(this.to.options.color.border, values.opacity);
                    } else {
                        // "from"
                        return overrideOpacity(this.from.options.color.border, values.opacity);
                    }
                } else {
                    return overrideOpacity(values.color, values.opacity);
                }
            }
            /**
             * Draw a line from a node to itself, a circle.
             *
             * @param ctx - The context that will be used for rendering.
             * @param values - Formatting values like color, opacity or shadow.
             * @param x - Center of the circle on the x axis.
             * @param y - Center of the circle on the y axis.
             * @param radius - Radius of the circle.
             */

        }, {
            key: "_circle",
            value: function _circle(ctx, values, x, y, radius) {
                // draw shadow if enabled
                this.enableShadow(ctx, values); //full circle

                var angleFrom = 0;
                var angleTo = Math.PI * 2;

                if (!this.options.selfReference.renderBehindTheNode) {
                    //render only parts which are not overlaping with parent node
                    //need to find x,y of from point and x,y to point
                    //calculating radians
                    var low = this.options.selfReference.angle;
                    var high = this.options.selfReference.angle + Math.PI;

                    var pointTFrom = this._findBorderPositionCircle(this.from, ctx, {
                        x: x,
                        y: y,
                        low: low,
                        high: high,
                        direction: -1
                    });

                    var pointTTo = this._findBorderPositionCircle(this.from, ctx, {
                        x: x,
                        y: y,
                        low: low,
                        high: high,
                        direction: 1
                    });

                    angleFrom = Math.atan2(pointTFrom.y - y, pointTFrom.x - x);
                    angleTo = Math.atan2(pointTTo.y - y, pointTTo.x - x);
                } // draw a circle


                ctx.beginPath();
                ctx.arc(x, y, radius, angleFrom, angleTo, false);
                ctx.stroke(); // disable shadows for other elements.

                this.disableShadow(ctx, values);
            }
            /**
             * @inheritDoc
             *
             * @remarks
             * http://stackoverflow.com/questions/849211/shortest-distancae-between-a-point-and-a-line-segment
             */

        }, {
            key: "getDistanceToEdge",
            value: function getDistanceToEdge(x1, y1, x2, y2, x3, y3) {
                if (this.from != this.to) {
                    return this._getDistanceToEdge(x1, y1, x2, y2, x3, y3);
                } else {
                    var _this$_getCircleData7 = this._getCircleData(undefined),
                        _this$_getCircleData8 = _slicedToArray(_this$_getCircleData7, 3),
                        x = _this$_getCircleData8[0],
                        y = _this$_getCircleData8[1],
                        radius = _this$_getCircleData8[2];

                    var dx = x - x3;
                    var dy = y - y3;
                    return Math.abs(Math.sqrt(dx * dx + dy * dy) - radius);
                }
            }
            /**
             * Calculate the distance between a point (x3, y3) and a line segment from (x1, y1) to (x2, y2).
             *
             * @param x1 - First end of the line segment on the x axis.
             * @param y1 - First end of the line segment on the y axis.
             * @param x2 - Second end of the line segment on the x axis.
             * @param y2 - Second end of the line segment on the y axis.
             * @param x3 - Position of the point on the x axis.
             * @param y3 - Position of the point on the y axis.
             *
             * @returns The distance between the line segment and the point.
             */

        }, {
            key: "_getDistanceToLine",
            value: function _getDistanceToLine(x1, y1, x2, y2, x3, y3) {
                var px = x2 - x1;
                var py = y2 - y1;
                var something = px * px + py * py;
                var u = ((x3 - x1) * px + (y3 - y1) * py) / something;

                if (u > 1) {
                    u = 1;
                } else if (u < 0) {
                    u = 0;
                }

                var x = x1 + u * px;
                var y = y1 + u * py;
                var dx = x - x3;
                var dy = y - y3; //# Note: If the actual distance does not matter,
                //# if you only want to compare what this function
                //# returns to other results of this function, you
                //# can just return the squared distance instead
                //# (i.e. remove the sqrt) to gain a little performance

                return Math.sqrt(dx * dx + dy * dy);
            }
            /** @inheritDoc */

        }, {
            key: "getArrowData",
            value: function getArrowData(ctx, position, viaNode, _selected, _hover, values) {
                // set lets
                var angle;
                var arrowPoint;
                var node1;
                var node2;
                var reversed;
                var scaleFactor;
                var type;
                var lineWidth = values.width;

                if (position === "from") {
                    node1 = this.from;
                    node2 = this.to;
                    reversed = values.fromArrowScale < 0;
                    scaleFactor = Math.abs(values.fromArrowScale);
                    type = values.fromArrowType;
                } else if (position === "to") {
                    node1 = this.to;
                    node2 = this.from;
                    reversed = values.toArrowScale < 0;
                    scaleFactor = Math.abs(values.toArrowScale);
                    type = values.toArrowType;
                } else {
                    node1 = this.to;
                    node2 = this.from;
                    reversed = values.middleArrowScale < 0;
                    scaleFactor = Math.abs(values.middleArrowScale);
                    type = values.middleArrowType;
                }

                var length = 15 * scaleFactor + 3 * lineWidth; // 3* lineWidth is the width of the edge.
                // if not connected to itself

                if (node1 != node2) {
                    var approximateEdgeLength = hypot(node1.x - node2.x, node1.y - node2.y);

                    var relativeLength = length / approximateEdgeLength;

                    if (position !== "middle") {
                        // draw arrow head
                        if (this.options.smooth.enabled === true) {
                            var pointT = this._findBorderPosition(node1, ctx, {
                                via: viaNode
                            });

                            var guidePos = this.getPoint(pointT.t + relativeLength * (position === "from" ? 1 : -1), viaNode);
                            angle = Math.atan2(pointT.y - guidePos.y, pointT.x - guidePos.x);
                            arrowPoint = pointT;
                        } else {
                            angle = Math.atan2(node1.y - node2.y, node1.x - node2.x);
                            arrowPoint = this._findBorderPosition(node1, ctx);
                        }
                    } else {
                        // Negative half length reverses arrow direction.
                        var halfLength = (reversed ? -relativeLength : relativeLength) / 2;
                        var guidePos1 = this.getPoint(0.5 + halfLength, viaNode);
                        var guidePos2 = this.getPoint(0.5 - halfLength, viaNode);
                        angle = Math.atan2(guidePos1.y - guidePos2.y, guidePos1.x - guidePos2.x);
                        arrowPoint = this.getPoint(0.5, viaNode);
                    }
                } else {
                    // draw circle
                    var _this$_getCircleData9 = this._getCircleData(ctx),
                        _this$_getCircleData10 = _slicedToArray(_this$_getCircleData9, 3),
                        x = _this$_getCircleData10[0],
                        y = _this$_getCircleData10[1],
                        radius = _this$_getCircleData10[2];

                    if (position === "from") {
                        var low = this.options.selfReference.angle;
                        var high = this.options.selfReference.angle + Math.PI;

                        var _pointT = this._findBorderPositionCircle(this.from, ctx, {
                            x: x,
                            y: y,
                            low: low,
                            high: high,
                            direction: -1
                        });

                        angle = _pointT.t * -2 * Math.PI + 1.5 * Math.PI + 0.1 * Math.PI;
                        arrowPoint = _pointT;
                    } else if (position === "to") {
                        var _low = this.options.selfReference.angle;

                        var _high = this.options.selfReference.angle + Math.PI;

                        var _pointT2 = this._findBorderPositionCircle(this.from, ctx, {
                            x: x,
                            y: y,
                            low: _low,
                            high: _high,
                            direction: 1
                        });

                        angle = _pointT2.t * -2 * Math.PI + 1.5 * Math.PI - 1.1 * Math.PI;
                        arrowPoint = _pointT2;
                    } else {
                        var pos = this.options.selfReference.angle / (2 * Math.PI);
                        arrowPoint = this._pointOnCircle(x, y, radius, pos);
                        angle = pos * -2 * Math.PI + 1.5 * Math.PI + 0.1 * Math.PI;
                    }
                }

                var xi = arrowPoint.x - length * 0.9 * Math.cos(angle);
                var yi = arrowPoint.y - length * 0.9 * Math.sin(angle);
                var arrowCore = {
                    x: xi,
                    y: yi
                };
                return {
                    point: arrowPoint,
                    core: arrowCore,
                    angle: angle,
                    length: length,
                    type: type
                };
            }
            /** @inheritDoc */

        }, {
            key: "drawArrowHead",
            value: function drawArrowHead(ctx, values, _selected, _hover, arrowData) {
                // set style
                ctx.strokeStyle = this.getColor(ctx, values);
                ctx.fillStyle = ctx.strokeStyle;
                ctx.lineWidth = values.width;
                var canFill = EndPoints.draw(ctx, arrowData);

                if (canFill) {
                    // draw shadow if enabled
                    this.enableShadow(ctx, values);

                    fill(ctx).call(ctx); // disable shadows for other elements.


                    this.disableShadow(ctx, values);
                }
            }
            /**
             * Set the shadow formatting values in the context if enabled, do nothing otherwise.
             *
             * @param ctx - The context that will be used for rendering.
             * @param values - Formatting values for the shadow.
             */

        }, {
            key: "enableShadow",
            value: function enableShadow(ctx, values) {
                if (values.shadow === true) {
                    ctx.shadowColor = values.shadowColor;
                    ctx.shadowBlur = values.shadowSize;
                    ctx.shadowOffsetX = values.shadowX;
                    ctx.shadowOffsetY = values.shadowY;
                }
            }
            /**
             * Reset the shadow formatting values in the context if enabled, do nothing otherwise.
             *
             * @param ctx - The context that will be used for rendering.
             * @param values - Formatting values for the shadow.
             */

        }, {
            key: "disableShadow",
            value: function disableShadow(ctx, values) {
                if (values.shadow === true) {
                    ctx.shadowColor = "rgba(0,0,0,0)";
                    ctx.shadowBlur = 0;
                    ctx.shadowOffsetX = 0;
                    ctx.shadowOffsetY = 0;
                }
            }
            /**
             * Render the background according to the formatting values.
             *
             * @param ctx - The context that will be used for rendering.
             * @param values - Formatting values for the background.
             */

        }, {
            key: "drawBackground",
            value: function drawBackground(ctx, values) {
                if (values.background !== false) {
                    // save original line attrs
                    var origCtxAttr = {
                        strokeStyle: ctx.strokeStyle,
                        lineWidth: ctx.lineWidth,
                        dashes: ctx.dashes
                    };
                    ctx.strokeStyle = values.backgroundColor;
                    ctx.lineWidth = values.backgroundSize;
                    this.setStrokeDashed(ctx, values.backgroundDashes);
                    ctx.stroke(); // restore original line attrs

                    ctx.strokeStyle = origCtxAttr.strokeStyle;
                    ctx.lineWidth = origCtxAttr.lineWidth;
                    ctx.dashes = origCtxAttr.dashes;
                    this.setStrokeDashed(ctx, values.dashes);
                }
            }
            /**
             * Set the line dash pattern if supported. Logs a warning to the console if it isn't supported.
             *
             * @param ctx - The context that will be used for rendering.
             * @param dashes - The pattern [line, space, line…], true for default dashed line or false for normal line.
             */

        }, {
            key: "setStrokeDashed",
            value: function setStrokeDashed(ctx, dashes) {
                if (dashes !== false) {
                    if (ctx.setLineDash !== undefined) {
                        var pattern = isArray(dashes) ? dashes : [5, 5];
                        ctx.setLineDash(pattern);
                    } else {
                        console.warn("setLineDash is not supported in this browser. The dashed stroke cannot be used.");
                    }
                } else {
                    if (ctx.setLineDash !== undefined) {
                        ctx.setLineDash([]);
                    } else {
                        console.warn("setLineDash is not supported in this browser. The dashed stroke cannot be used.");
                    }
                }
            }
        }]);

        return EdgeBase;
    }();

    function ownKeys(object, enumerableOnly) { var keys = keys$3(object); if (getOwnPropertySymbols) { var symbols = getOwnPropertySymbols(object); if (enumerableOnly) symbols = filter(symbols).call(symbols, function (sym) { return getOwnPropertyDescriptor$2(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

    function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; forEach$2(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (getOwnPropertyDescriptors) { defineProperties(target, getOwnPropertyDescriptors(source)); } else { var _context2; forEach$2(_context2 = ownKeys(Object(source))).call(_context2, function (key) { defineProperty$4(target, key, getOwnPropertyDescriptor$2(source, key)); }); } } return target; }

    function _createSuper$9(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$9(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * The Base Class for all Bezier edges.
     * Bezier curves are used to model smooth gradual curves in paths between nodes.
     */

    var BezierEdgeBase = /*#__PURE__*/function (_EdgeBase) {
        _inherits(BezierEdgeBase, _EdgeBase);

        var _super = _createSuper$9(BezierEdgeBase);

        /**
         * Create a new instance.
         *
         * @param options - The options object of given edge.
         * @param body - The body of the network.
         * @param labelModule - Label module.
         */
        function BezierEdgeBase(options, body, labelModule) {
            _classCallCheck(this, BezierEdgeBase);

            return _super.call(this, options, body, labelModule);
        }
        /**
         * Find the intersection between the border of the node and the edge.
         *
         * @remarks
         * This function uses binary search to look for the point where the bezier curve crosses the border of the node.
         *
         * @param nearNode - The node (either from or to node of the edge).
         * @param ctx - The context that will be used for rendering.
         * @param viaNode - Additional node(s) the edge passes through.
         *
         * @returns Cartesian coordinates of the intersection between the border of the node and the edge.
         */


        _createClass(BezierEdgeBase, [{
            key: "_findBorderPositionBezier",
            value: function _findBorderPositionBezier(nearNode, ctx) {
                var viaNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this._getViaCoordinates();
                var maxIterations = 10;
                var threshold = 0.2;
                var from = false;
                var high = 1;
                var low = 0;
                var node = this.to;
                var pos;
                var middle;
                var endPointOffset = this.options.endPointOffset ? this.options.endPointOffset.to : 0;

                if (nearNode.id === this.from.id) {
                    node = this.from;
                    from = true;
                    endPointOffset = this.options.endPointOffset ? this.options.endPointOffset.from : 0;
                }

                if (this.options.arrowStrikethrough === false) {
                    endPointOffset = 0;
                }

                var iteration = 0;

                do {
                    middle = (low + high) * 0.5;
                    pos = this.getPoint(middle, viaNode);
                    var angle = Math.atan2(node.y - pos.y, node.x - pos.x);
                    var distanceToBorder = node.distanceToBorder(ctx, angle) + endPointOffset;
                    var distanceToPoint = Math.sqrt(Math.pow(pos.x - node.x, 2) + Math.pow(pos.y - node.y, 2));
                    var difference = distanceToBorder - distanceToPoint;

                    if (Math.abs(difference) < threshold) {
                        break; // found
                    } else if (difference < 0) {
                        // distance to nodes is larger than distance to border --> t needs to be bigger if we're looking at the to node.
                        if (from === false) {
                            low = middle;
                        } else {
                            high = middle;
                        }
                    } else {
                        if (from === false) {
                            high = middle;
                        } else {
                            low = middle;
                        }
                    }

                    ++iteration;
                } while (low <= high && iteration < maxIterations);

                return _objectSpread(_objectSpread({}, pos), {}, {
                    t: middle
                });
            }
            /**
             * Calculate the distance between a point (x3,y3) and a line segment from (x1,y1) to (x2,y2).
             *
             * @remarks
             * http://stackoverflow.com/questions/849211/shortest-distancae-between-a-point-and-a-line-segment
             *
             * @param x1 - First end of the line segment on the x axis.
             * @param y1 - First end of the line segment on the y axis.
             * @param x2 - Second end of the line segment on the x axis.
             * @param y2 - Second end of the line segment on the y axis.
             * @param x3 - Position of the point on the x axis.
             * @param y3 - Position of the point on the y axis.
             * @param via - The control point for the edge.
             *
             * @returns The distance between the line segment and the point.
             */

        }, {
            key: "_getDistanceToBezierEdge",
            value: function _getDistanceToBezierEdge(x1, y1, x2, y2, x3, y3, via) {
                // x3,y3 is the point
                var minDistance = 1e9;
                var distance;
                var i, t, x, y;
                var lastX = x1;
                var lastY = y1;

                for (i = 1; i < 10; i++) {
                    t = 0.1 * i;
                    x = Math.pow(1 - t, 2) * x1 + 2 * t * (1 - t) * via.x + Math.pow(t, 2) * x2;
                    y = Math.pow(1 - t, 2) * y1 + 2 * t * (1 - t) * via.y + Math.pow(t, 2) * y2;

                    if (i > 0) {
                        distance = this._getDistanceToLine(lastX, lastY, x, y, x3, y3);
                        minDistance = distance < minDistance ? distance : minDistance;
                    }

                    lastX = x;
                    lastY = y;
                }

                return minDistance;
            }
            /**
             * Render a bezier curve between two nodes.
             *
             * @remarks
             * The method accepts zero, one or two control points.
             * Passing zero control points just draws a straight line.
             *
             * @param ctx - The context that will be used for rendering.
             * @param values - Style options for edge drawing.
             * @param viaNode1 - First control point for curve drawing.
             * @param viaNode2 - Second control point for curve drawing.
             */

        }, {
            key: "_bezierCurve",
            value: function _bezierCurve(ctx, values, viaNode1, viaNode2) {
                ctx.beginPath();
                ctx.moveTo(this.fromPoint.x, this.fromPoint.y);

                if (viaNode1 != null && viaNode1.x != null) {
                    if (viaNode2 != null && viaNode2.x != null) {
                        ctx.bezierCurveTo(viaNode1.x, viaNode1.y, viaNode2.x, viaNode2.y, this.toPoint.x, this.toPoint.y);
                    } else {
                        ctx.quadraticCurveTo(viaNode1.x, viaNode1.y, this.toPoint.x, this.toPoint.y);
                    }
                } else {
                    // fallback to normal straight edge
                    ctx.lineTo(this.toPoint.x, this.toPoint.y);
                } // draw a background


                this.drawBackground(ctx, values); // draw shadow if enabled

                this.enableShadow(ctx, values);
                ctx.stroke();
                this.disableShadow(ctx, values);
            }
            /** @inheritDoc */

        }, {
            key: "getViaNode",
            value: function getViaNode() {
                return this._getViaCoordinates();
            }
        }]);

        return BezierEdgeBase;
    }(EdgeBase);

    function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Dynamic Bezier Edge. Bezier curves are used to model smooth gradual
     * curves in paths between nodes. The Dynamic piece refers to how the curve
     * reacts to physics changes.
     *
     * @augments BezierEdgeBase
     */

    var BezierEdgeDynamic = /*#__PURE__*/function (_BezierEdgeBase) {
        _inherits(BezierEdgeDynamic, _BezierEdgeBase);

        var _super = _createSuper$8(BezierEdgeDynamic);

        /**
         * Create a new instance.
         *
         * @param options - The options object of given edge.
         * @param body - The body of the network.
         * @param labelModule - Label module.
         */
        function BezierEdgeDynamic(options, body, labelModule) {
            var _this;

            _classCallCheck(this, BezierEdgeDynamic);

            //this.via = undefined; // Here for completeness but not allowed to defined before super() is invoked.
            _this = _super.call(this, options, body, labelModule); // --> this calls the setOptions below

            _this.via = _this.via; // constructor → super → super → setOptions → setupSupportNode

            _this._boundFunction = function () {
                _this.positionBezierNode();
            };

            _this._body.emitter.on("_repositionBezierNodes", _this._boundFunction);

            return _this;
        }
        /** @inheritDoc */


        _createClass(BezierEdgeDynamic, [{
            key: "setOptions",
            value: function setOptions(options) {
                _get(_getPrototypeOf(BezierEdgeDynamic.prototype), "setOptions", this).call(this, options); // check if the physics has changed.


                var physicsChange = false;

                if (this.options.physics !== options.physics) {
                    physicsChange = true;
                } // set the options and the to and from nodes


                this.options = options;
                this.id = this.options.id;
                this.from = this._body.nodes[this.options.from];
                this.to = this._body.nodes[this.options.to]; // setup the support node and connect

                this.setupSupportNode();
                this.connect(); // when we change the physics state of the edge, we reposition the support node.

                if (physicsChange === true) {
                    this.via.setOptions({
                        physics: this.options.physics
                    });
                    this.positionBezierNode();
                }
            }
            /** @inheritDoc */

        }, {
            key: "connect",
            value: function connect() {
                this.from = this._body.nodes[this.options.from];
                this.to = this._body.nodes[this.options.to];

                if (this.from === undefined || this.to === undefined || this.options.physics === false) {
                    this.via.setOptions({
                        physics: false
                    });
                } else {
                    // fix weird behaviour where a self referencing node has physics enabled
                    if (this.from.id === this.to.id) {
                        this.via.setOptions({
                            physics: false
                        });
                    } else {
                        this.via.setOptions({
                            physics: true
                        });
                    }
                }
            }
            /** @inheritDoc */

        }, {
            key: "cleanup",
            value: function cleanup() {
                this._body.emitter.off("_repositionBezierNodes", this._boundFunction);

                if (this.via !== undefined) {
                    delete this._body.nodes[this.via.id];
                    this.via = undefined;
                    return true;
                }

                return false;
            }
            /**
             * Create and add a support node if not already present.
             *
             * @remarks
             * Bezier curves require an anchor point to calculate the smooth flow.
             * These points are nodes.
             * These nodes are invisible but are used for the force calculation.
             *
             * The changed data is not called, if needed, it is returned by the main edge constructor.
             */

        }, {
            key: "setupSupportNode",
            value: function setupSupportNode() {
                if (this.via === undefined) {
                    var nodeId = "edgeId:" + this.id;

                    var node = this._body.functions.createNode({
                        id: nodeId,
                        shape: "circle",
                        physics: true,
                        hidden: true
                    });

                    this._body.nodes[nodeId] = node;
                    this.via = node;
                    this.via.parentEdgeId = this.id;
                    this.positionBezierNode();
                }
            }
            /**
             * Position bezier node.
             */

        }, {
            key: "positionBezierNode",
            value: function positionBezierNode() {
                if (this.via !== undefined && this.from !== undefined && this.to !== undefined) {
                    this.via.x = 0.5 * (this.from.x + this.to.x);
                    this.via.y = 0.5 * (this.from.y + this.to.y);
                } else if (this.via !== undefined) {
                    this.via.x = 0;
                    this.via.y = 0;
                }
            }
            /** @inheritDoc */

        }, {
            key: "_line",
            value: function _line(ctx, values, viaNode) {
                this._bezierCurve(ctx, values, viaNode);
            }
            /** @inheritDoc */

        }, {
            key: "_getViaCoordinates",
            value: function _getViaCoordinates() {
                return this.via;
            }
            /** @inheritDoc */

        }, {
            key: "getViaNode",
            value: function getViaNode() {
                return this.via;
            }
            /** @inheritDoc */

        }, {
            key: "getPoint",
            value: function getPoint(position) {
                var viaNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.via;

                if (this.from === this.to) {
                    var _this$_getCircleData = this._getCircleData(),
                        _this$_getCircleData2 = _slicedToArray(_this$_getCircleData, 3),
                        cx = _this$_getCircleData2[0],
                        cy = _this$_getCircleData2[1],
                        cr = _this$_getCircleData2[2];

                    var a = 2 * Math.PI * (1 - position);
                    return {
                        x: cx + cr * Math.sin(a),
                        y: cy + cr - cr * (1 - Math.cos(a))
                    };
                } else {
                    return {
                        x: Math.pow(1 - position, 2) * this.fromPoint.x + 2 * position * (1 - position) * viaNode.x + Math.pow(position, 2) * this.toPoint.x,
                        y: Math.pow(1 - position, 2) * this.fromPoint.y + 2 * position * (1 - position) * viaNode.y + Math.pow(position, 2) * this.toPoint.y
                    };
                }
            }
            /** @inheritDoc */

        }, {
            key: "_findBorderPosition",
            value: function _findBorderPosition(nearNode, ctx) {
                return this._findBorderPositionBezier(nearNode, ctx, this.via);
            }
            /** @inheritDoc */

        }, {
            key: "_getDistanceToEdge",
            value: function _getDistanceToEdge(x1, y1, x2, y2, x3, y3) {
                // x3,y3 is the point
                return this._getDistanceToBezierEdge(x1, y1, x2, y2, x3, y3, this.via);
            }
        }]);

        return BezierEdgeDynamic;
    }(BezierEdgeBase);

    function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Static Bezier Edge. Bezier curves are used to model smooth gradual curves in paths between nodes.
     */

    var BezierEdgeStatic = /*#__PURE__*/function (_BezierEdgeBase) {
        _inherits(BezierEdgeStatic, _BezierEdgeBase);

        var _super = _createSuper$7(BezierEdgeStatic);

        /**
         * Create a new instance.
         *
         * @param options - The options object of given edge.
         * @param body - The body of the network.
         * @param labelModule - Label module.
         */
        function BezierEdgeStatic(options, body, labelModule) {
            _classCallCheck(this, BezierEdgeStatic);

            return _super.call(this, options, body, labelModule);
        }
        /** @inheritDoc */


        _createClass(BezierEdgeStatic, [{
            key: "_line",
            value: function _line(ctx, values, viaNode) {
                this._bezierCurve(ctx, values, viaNode);
            }
            /** @inheritDoc */

        }, {
            key: "getViaNode",
            value: function getViaNode() {
                return this._getViaCoordinates();
            }
            /**
             * Compute the coordinates of the via node.
             *
             * @remarks
             * We do not use the to and fromPoints here to make the via nodes the same as edges without arrows.
             *
             * @returns Cartesian coordinates of the via node.
             */

        }, {
            key: "_getViaCoordinates",
            value: function _getViaCoordinates() {
                // Assumption: x/y coordinates in from/to always defined
                var factor = this.options.smooth.roundness;
                var type = this.options.smooth.type;
                var dx = Math.abs(this.from.x - this.to.x);
                var dy = Math.abs(this.from.y - this.to.y);

                if (type === "discrete" || type === "diagonalCross") {
                    var stepX;
                    var stepY;

                    if (dx <= dy) {
                        stepX = stepY = factor * dy;
                    } else {
                        stepX = stepY = factor * dx;
                    }

                    if (this.from.x > this.to.x) {
                        stepX = -stepX;
                    }

                    if (this.from.y >= this.to.y) {
                        stepY = -stepY;
                    }

                    var xVia = this.from.x + stepX;
                    var yVia = this.from.y + stepY;

                    if (type === "discrete") {
                        if (dx <= dy) {
                            xVia = dx < factor * dy ? this.from.x : xVia;
                        } else {
                            yVia = dy < factor * dx ? this.from.y : yVia;
                        }
                    }

                    return {
                        x: xVia,
                        y: yVia
                    };
                } else if (type === "straightCross") {
                    var _stepX = (1 - factor) * dx;

                    var _stepY = (1 - factor) * dy;

                    if (dx <= dy) {
                        // up - down
                        _stepX = 0;

                        if (this.from.y < this.to.y) {
                            _stepY = -_stepY;
                        }
                    } else {
                        // left - right
                        if (this.from.x < this.to.x) {
                            _stepX = -_stepX;
                        }

                        _stepY = 0;
                    }

                    return {
                        x: this.to.x + _stepX,
                        y: this.to.y + _stepY
                    };
                } else if (type === "horizontal") {
                    var _stepX2 = (1 - factor) * dx;

                    if (this.from.x < this.to.x) {
                        _stepX2 = -_stepX2;
                    }

                    return {
                        x: this.to.x + _stepX2,
                        y: this.from.y
                    };
                } else if (type === "vertical") {
                    var _stepY2 = (1 - factor) * dy;

                    if (this.from.y < this.to.y) {
                        _stepY2 = -_stepY2;
                    }

                    return {
                        x: this.from.x,
                        y: this.to.y + _stepY2
                    };
                } else if (type === "curvedCW") {
                    dx = this.to.x - this.from.x;
                    dy = this.from.y - this.to.y;
                    var radius = Math.sqrt(dx * dx + dy * dy);
                    var pi = Math.PI;
                    var originalAngle = Math.atan2(dy, dx);
                    var myAngle = (originalAngle + (factor * 0.5 + 0.5) * pi) % (2 * pi);
                    return {
                        x: this.from.x + (factor * 0.5 + 0.5) * radius * Math.sin(myAngle),
                        y: this.from.y + (factor * 0.5 + 0.5) * radius * Math.cos(myAngle)
                    };
                } else if (type === "curvedCCW") {
                    dx = this.to.x - this.from.x;
                    dy = this.from.y - this.to.y;

                    var _radius = Math.sqrt(dx * dx + dy * dy);

                    var _pi = Math.PI;

                    var _originalAngle = Math.atan2(dy, dx);

                    var _myAngle = (_originalAngle + (-factor * 0.5 + 0.5) * _pi) % (2 * _pi);

                    return {
                        x: this.from.x + (factor * 0.5 + 0.5) * _radius * Math.sin(_myAngle),
                        y: this.from.y + (factor * 0.5 + 0.5) * _radius * Math.cos(_myAngle)
                    };
                } else {
                    // continuous
                    var _stepX3;

                    var _stepY3;

                    if (dx <= dy) {
                        _stepX3 = _stepY3 = factor * dy;
                    } else {
                        _stepX3 = _stepY3 = factor * dx;
                    }

                    if (this.from.x > this.to.x) {
                        _stepX3 = -_stepX3;
                    }

                    if (this.from.y >= this.to.y) {
                        _stepY3 = -_stepY3;
                    }

                    var _xVia = this.from.x + _stepX3;

                    var _yVia = this.from.y + _stepY3;

                    if (dx <= dy) {
                        if (this.from.x <= this.to.x) {
                            _xVia = this.to.x < _xVia ? this.to.x : _xVia;
                        } else {
                            _xVia = this.to.x > _xVia ? this.to.x : _xVia;
                        }
                    } else {
                        if (this.from.y >= this.to.y) {
                            _yVia = this.to.y > _yVia ? this.to.y : _yVia;
                        } else {
                            _yVia = this.to.y < _yVia ? this.to.y : _yVia;
                        }
                    }

                    return {
                        x: _xVia,
                        y: _yVia
                    };
                }
            }
            /** @inheritDoc */

        }, {
            key: "_findBorderPosition",
            value: function _findBorderPosition(nearNode, ctx) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this._findBorderPositionBezier(nearNode, ctx, options.via);
            }
            /** @inheritDoc */

        }, {
            key: "_getDistanceToEdge",
            value: function _getDistanceToEdge(x1, y1, x2, y2, x3, y3) {
                var viaNode = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : this._getViaCoordinates();
                // x3,y3 is the point
                return this._getDistanceToBezierEdge(x1, y1, x2, y2, x3, y3, viaNode);
            }
            /** @inheritDoc */

        }, {
            key: "getPoint",
            value: function getPoint(position) {
                var viaNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._getViaCoordinates();
                var t = position;
                var x = Math.pow(1 - t, 2) * this.fromPoint.x + 2 * t * (1 - t) * viaNode.x + Math.pow(t, 2) * this.toPoint.x;
                var y = Math.pow(1 - t, 2) * this.fromPoint.y + 2 * t * (1 - t) * viaNode.y + Math.pow(t, 2) * this.toPoint.y;
                return {
                    x: x,
                    y: y
                };
            }
        }]);

        return BezierEdgeStatic;
    }(BezierEdgeBase);

    function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Base Class for all Cubic Bezier Edges. Bezier curves are used to model
     * smooth gradual curves in paths between nodes.
     *
     * @augments BezierEdgeBase
     */

    var CubicBezierEdgeBase = /*#__PURE__*/function (_BezierEdgeBase) {
        _inherits(CubicBezierEdgeBase, _BezierEdgeBase);

        var _super = _createSuper$6(CubicBezierEdgeBase);

        /**
         * Create a new instance.
         *
         * @param options - The options object of given edge.
         * @param body - The body of the network.
         * @param labelModule - Label module.
         */
        function CubicBezierEdgeBase(options, body, labelModule) {
            _classCallCheck(this, CubicBezierEdgeBase);

            return _super.call(this, options, body, labelModule);
        }
        /**
         * Calculate the distance between a point (x3,y3) and a line segment from (x1,y1) to (x2,y2).
         *
         * @remarks
         * http://stackoverflow.com/questions/849211/shortest-distancae-between-a-point-and-a-line-segment
         * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
         *
         * @param x1 - First end of the line segment on the x axis.
         * @param y1 - First end of the line segment on the y axis.
         * @param x2 - Second end of the line segment on the x axis.
         * @param y2 - Second end of the line segment on the y axis.
         * @param x3 - Position of the point on the x axis.
         * @param y3 - Position of the point on the y axis.
         * @param via1 - The first point this edge passes through.
         * @param via2 - The second point this edge passes through.
         *
         * @returns The distance between the line segment and the point.
         */


        _createClass(CubicBezierEdgeBase, [{
            key: "_getDistanceToBezierEdge2",
            value: function _getDistanceToBezierEdge2(x1, y1, x2, y2, x3, y3, via1, via2) {
                // x3,y3 is the point
                var minDistance = 1e9;
                var lastX = x1;
                var lastY = y1;
                var vec = [0, 0, 0, 0];

                for (var i = 1; i < 10; i++) {
                    var t = 0.1 * i;
                    vec[0] = Math.pow(1 - t, 3);
                    vec[1] = 3 * t * Math.pow(1 - t, 2);
                    vec[2] = 3 * Math.pow(t, 2) * (1 - t);
                    vec[3] = Math.pow(t, 3);
                    var x = vec[0] * x1 + vec[1] * via1.x + vec[2] * via2.x + vec[3] * x2;
                    var y = vec[0] * y1 + vec[1] * via1.y + vec[2] * via2.y + vec[3] * y2;

                    if (i > 0) {
                        var distance = this._getDistanceToLine(lastX, lastY, x, y, x3, y3);

                        minDistance = distance < minDistance ? distance : minDistance;
                    }

                    lastX = x;
                    lastY = y;
                }

                return minDistance;
            }
        }]);

        return CubicBezierEdgeBase;
    }(BezierEdgeBase);

    function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Cubic Bezier Edge. Bezier curves are used to model smooth gradual curves in paths between nodes.
     */

    var CubicBezierEdge = /*#__PURE__*/function (_CubicBezierEdgeBase) {
        _inherits(CubicBezierEdge, _CubicBezierEdgeBase);

        var _super = _createSuper$5(CubicBezierEdge);

        /**
         * Create a new instance.
         *
         * @param options - The options object of given edge.
         * @param body - The body of the network.
         * @param labelModule - Label module.
         */
        function CubicBezierEdge(options, body, labelModule) {
            _classCallCheck(this, CubicBezierEdge);

            return _super.call(this, options, body, labelModule);
        }
        /** @inheritDoc */


        _createClass(CubicBezierEdge, [{
            key: "_line",
            value: function _line(ctx, values, viaNodes) {
                // get the coordinates of the support points.
                var via1 = viaNodes[0];
                var via2 = viaNodes[1];

                this._bezierCurve(ctx, values, via1, via2);
            }
            /**
             * Compute the additional points the edge passes through.
             *
             * @returns Cartesian coordinates of the points the edge passes through.
             */

        }, {
            key: "_getViaCoordinates",
            value: function _getViaCoordinates() {
                var dx = this.from.x - this.to.x;
                var dy = this.from.y - this.to.y;
                var x1;
                var y1;
                var x2;
                var y2;
                var roundness = this.options.smooth.roundness; // horizontal if x > y or if direction is forced or if direction is horizontal

                if ((Math.abs(dx) > Math.abs(dy) || this.options.smooth.forceDirection === true || this.options.smooth.forceDirection === "horizontal") && this.options.smooth.forceDirection !== "vertical") {
                    y1 = this.from.y;
                    y2 = this.to.y;
                    x1 = this.from.x - roundness * dx;
                    x2 = this.to.x + roundness * dx;
                } else {
                    y1 = this.from.y - roundness * dy;
                    y2 = this.to.y + roundness * dy;
                    x1 = this.from.x;
                    x2 = this.to.x;
                }

                return [{
                    x: x1,
                    y: y1
                }, {
                    x: x2,
                    y: y2
                }];
            }
            /** @inheritDoc */

        }, {
            key: "getViaNode",
            value: function getViaNode() {
                return this._getViaCoordinates();
            }
            /** @inheritDoc */

        }, {
            key: "_findBorderPosition",
            value: function _findBorderPosition(nearNode, ctx) {
                return this._findBorderPositionBezier(nearNode, ctx);
            }
            /** @inheritDoc */

        }, {
            key: "_getDistanceToEdge",
            value: function _getDistanceToEdge(x1, y1, x2, y2, x3, y3) {
                var _ref = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : this._getViaCoordinates(),
                    _ref2 = _slicedToArray(_ref, 2),
                    via1 = _ref2[0],
                    via2 = _ref2[1];

                // x3,y3 is the point
                return this._getDistanceToBezierEdge2(x1, y1, x2, y2, x3, y3, via1, via2);
            }
            /** @inheritDoc */

        }, {
            key: "getPoint",
            value: function getPoint(position) {
                var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._getViaCoordinates(),
                    _ref4 = _slicedToArray(_ref3, 2),
                    via1 = _ref4[0],
                    via2 = _ref4[1];

                var t = position;
                var vec = [Math.pow(1 - t, 3), 3 * t * Math.pow(1 - t, 2), 3 * Math.pow(t, 2) * (1 - t), Math.pow(t, 3)];
                var x = vec[0] * this.fromPoint.x + vec[1] * via1.x + vec[2] * via2.x + vec[3] * this.toPoint.x;
                var y = vec[0] * this.fromPoint.y + vec[1] * via1.y + vec[2] * via2.y + vec[3] * this.toPoint.y;
                return {
                    x: x,
                    y: y
                };
            }
        }]);

        return CubicBezierEdge;
    }(CubicBezierEdgeBase);

    function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Straight Edge.
     */

    var StraightEdge = /*#__PURE__*/function (_EdgeBase) {
        _inherits(StraightEdge, _EdgeBase);

        var _super = _createSuper$4(StraightEdge);

        /**
         * Create a new instance.
         *
         * @param options - The options object of given edge.
         * @param body - The body of the network.
         * @param labelModule - Label module.
         */
        function StraightEdge(options, body, labelModule) {
            _classCallCheck(this, StraightEdge);

            return _super.call(this, options, body, labelModule);
        }
        /** @inheritDoc */


        _createClass(StraightEdge, [{
            key: "_line",
            value: function _line(ctx, values) {
                // draw a straight line
                ctx.beginPath();
                ctx.moveTo(this.fromPoint.x, this.fromPoint.y);
                ctx.lineTo(this.toPoint.x, this.toPoint.y); // draw shadow if enabled

                this.enableShadow(ctx, values);
                ctx.stroke();
                this.disableShadow(ctx, values);
            }
            /** @inheritDoc */

        }, {
            key: "getViaNode",
            value: function getViaNode() {
                return undefined;
            }
            /** @inheritDoc */

        }, {
            key: "getPoint",
            value: function getPoint(position) {
                return {
                    x: (1 - position) * this.fromPoint.x + position * this.toPoint.x,
                    y: (1 - position) * this.fromPoint.y + position * this.toPoint.y
                };
            }
            /** @inheritDoc */

        }, {
            key: "_findBorderPosition",
            value: function _findBorderPosition(nearNode, ctx) {
                var node1 = this.to;
                var node2 = this.from;

                if (nearNode.id === this.from.id) {
                    node1 = this.from;
                    node2 = this.to;
                }

                var angle = Math.atan2(node1.y - node2.y, node1.x - node2.x);
                var dx = node1.x - node2.x;
                var dy = node1.y - node2.y;
                var edgeSegmentLength = Math.sqrt(dx * dx + dy * dy);
                var toBorderDist = nearNode.distanceToBorder(ctx, angle);
                var toBorderPoint = (edgeSegmentLength - toBorderDist) / edgeSegmentLength;
                return {
                    x: (1 - toBorderPoint) * node2.x + toBorderPoint * node1.x,
                    y: (1 - toBorderPoint) * node2.y + toBorderPoint * node1.y,
                    t: 0
                };
            }
            /** @inheritDoc */

        }, {
            key: "_getDistanceToEdge",
            value: function _getDistanceToEdge(x1, y1, x2, y2, x3, y3) {
                // x3,y3 is the point
                return this._getDistanceToLine(x1, y1, x2, y2, x3, y3);
            }
        }]);

        return StraightEdge;
    }(EdgeBase);

    /**
     * An edge connects two nodes and has a specific direction.
     */

    var Edge = /*#__PURE__*/function () {
        /**
         * @param {object} options        values specific to this edge, must contain at least 'from' and 'to'
         * @param {object} body           shared state from Network instance
         * @param {Network.Images} imagelist  A list with images. Only needed when the edge has image arrows.
         * @param {object} globalOptions  options from the EdgesHandler instance
         * @param {object} defaultOptions default options from the EdgeHandler instance. Value and reference are constant
         */
        function Edge(options, body, imagelist, globalOptions, defaultOptions) {
            _classCallCheck(this, Edge);

            if (body === undefined) {
                throw new Error("No body provided");
            } // Since globalOptions is constant in values as well as reference,
            // Following needs to be done only once.


            this.options = bridgeObject(globalOptions);
            this.globalOptions = globalOptions;
            this.defaultOptions = defaultOptions;
            this.body = body;
            this.imagelist = imagelist; // initialize variables

            this.id = undefined;
            this.fromId = undefined;
            this.toId = undefined;
            this.selected = false;
            this.hover = false;
            this.labelDirty = true;
            this.baseWidth = this.options.width;
            this.baseFontSize = this.options.font.size;
            this.from = undefined; // a node

            this.to = undefined; // a node

            this.edgeType = undefined;
            this.connected = false;
            this.labelModule = new Label(this.body, this.options, true
                /* It's an edge label */
            );
            this.setOptions(options);
        }
        /**
         * Set or overwrite options for the edge
         *
         * @param {object} options  an object with options
         * @returns {undefined|boolean} undefined if no options, true if layout affecting data changed, false otherwise.
         */


        _createClass(Edge, [{
            key: "setOptions",
            value: function setOptions(options) {
                if (!options) {
                    return;
                } // Following options if changed affect the layout.


                var affectsLayout = typeof options.physics !== "undefined" && this.options.physics !== options.physics || typeof options.hidden !== "undefined" && (this.options.hidden || false) !== (options.hidden || false) || typeof options.from !== "undefined" && this.options.from !== options.from || typeof options.to !== "undefined" && this.options.to !== options.to;
                Edge.parseOptions(this.options, options, true, this.globalOptions);

                if (options.id !== undefined) {
                    this.id = options.id;
                }

                if (options.from !== undefined) {
                    this.fromId = options.from;
                }

                if (options.to !== undefined) {
                    this.toId = options.to;
                }

                if (options.title !== undefined) {
                    this.title = options.title;
                }

                if (options.value !== undefined) {
                    options.value = _parseFloat(options.value);
                }

                var pile = [options, this.options, this.defaultOptions];
                this.chooser = choosify("edge", pile); // update label Module

                this.updateLabelModule(options); // Update edge type, this if changed affects the layout.

                affectsLayout = this.updateEdgeType() || affectsLayout; // if anything has been updates, reset the selection width and the hover width

                this._setInteractionWidths(); // A node is connected when it has a from and to node that both exist in the network.body.nodes.


                this.connect();
                return affectsLayout;
            }
            /**
             *
             * @param {object} parentOptions
             * @param {object} newOptions
             * @param {boolean} [allowDeletion=false]
             * @param {object} [globalOptions={}]
             * @param {boolean} [copyFromGlobals=false]
             */

        }, {
            key: "getFormattingValues",
            value:
                /**
                 *
                 * @returns {ArrowOptions}
                 */
                function getFormattingValues() {
                    var toArrow = this.options.arrows.to === true || this.options.arrows.to.enabled === true;
                    var fromArrow = this.options.arrows.from === true || this.options.arrows.from.enabled === true;
                    var middleArrow = this.options.arrows.middle === true || this.options.arrows.middle.enabled === true;
                    var inheritsColor = this.options.color.inherit;
                    var values = {
                        toArrow: toArrow,
                        toArrowScale: this.options.arrows.to.scaleFactor,
                        toArrowType: this.options.arrows.to.type,
                        toArrowSrc: this.options.arrows.to.src,
                        toArrowImageWidth: this.options.arrows.to.imageWidth,
                        toArrowImageHeight: this.options.arrows.to.imageHeight,
                        middleArrow: middleArrow,
                        middleArrowScale: this.options.arrows.middle.scaleFactor,
                        middleArrowType: this.options.arrows.middle.type,
                        middleArrowSrc: this.options.arrows.middle.src,
                        middleArrowImageWidth: this.options.arrows.middle.imageWidth,
                        middleArrowImageHeight: this.options.arrows.middle.imageHeight,
                        fromArrow: fromArrow,
                        fromArrowScale: this.options.arrows.from.scaleFactor,
                        fromArrowType: this.options.arrows.from.type,
                        fromArrowSrc: this.options.arrows.from.src,
                        fromArrowImageWidth: this.options.arrows.from.imageWidth,
                        fromArrowImageHeight: this.options.arrows.from.imageHeight,
                        arrowStrikethrough: this.options.arrowStrikethrough,
                        color: inheritsColor ? undefined : this.options.color.color,
                        inheritsColor: inheritsColor,
                        opacity: this.options.color.opacity,
                        hidden: this.options.hidden,
                        length: this.options.length,
                        shadow: this.options.shadow.enabled,
                        shadowColor: this.options.shadow.color,
                        shadowSize: this.options.shadow.size,
                        shadowX: this.options.shadow.x,
                        shadowY: this.options.shadow.y,
                        dashes: this.options.dashes,
                        width: this.options.width,
                        background: this.options.background.enabled,
                        backgroundColor: this.options.background.color,
                        backgroundSize: this.options.background.size,
                        backgroundDashes: this.options.background.dashes
                    };

                    if (this.selected || this.hover) {
                        if (this.chooser === true) {
                            if (this.selected) {
                                var selectedWidth = this.options.selectionWidth;

                                if (typeof selectedWidth === "function") {
                                    values.width = selectedWidth(values.width);
                                } else if (typeof selectedWidth === "number") {
                                    values.width += selectedWidth;
                                }

                                values.width = Math.max(values.width, 0.3 / this.body.view.scale);
                                values.color = this.options.color.highlight;
                                values.shadow = this.options.shadow.enabled;
                            } else if (this.hover) {
                                var hoverWidth = this.options.hoverWidth;

                                if (typeof hoverWidth === "function") {
                                    values.width = hoverWidth(values.width);
                                } else if (typeof hoverWidth === "number") {
                                    values.width += hoverWidth;
                                }

                                values.width = Math.max(values.width, 0.3 / this.body.view.scale);
                                values.color = this.options.color.hover;
                                values.shadow = this.options.shadow.enabled;
                            }
                        } else if (typeof this.chooser === "function") {
                            this.chooser(values, this.options.id, this.selected, this.hover);

                            if (values.color !== undefined) {
                                values.inheritsColor = false;
                            }

                            if (values.shadow === false) {
                                if (values.shadowColor !== this.options.shadow.color || values.shadowSize !== this.options.shadow.size || values.shadowX !== this.options.shadow.x || values.shadowY !== this.options.shadow.y) {
                                    values.shadow = true;
                                }
                            }
                        }
                    } else {
                        values.shadow = this.options.shadow.enabled;
                        values.width = Math.max(values.width, 0.3 / this.body.view.scale);
                    }

                    return values;
                }
            /**
             * update the options in the label module
             *
             * @param {object} options
             */

        }, {
            key: "updateLabelModule",
            value: function updateLabelModule(options) {
                var pile = [options, this.options, this.globalOptions, // Currently set global edge options
                    this.defaultOptions];
                this.labelModule.update(this.options, pile);

                if (this.labelModule.baseSize !== undefined) {
                    this.baseFontSize = this.labelModule.baseSize;
                }
            }
            /**
             * update the edge type, set the options
             *
             * @returns {boolean}
             */

        }, {
            key: "updateEdgeType",
            value: function updateEdgeType() {
                var smooth = this.options.smooth;
                var dataChanged = false;
                var changeInType = true;

                if (this.edgeType !== undefined) {
                    if (this.edgeType instanceof BezierEdgeDynamic && smooth.enabled === true && smooth.type === "dynamic" || this.edgeType instanceof CubicBezierEdge && smooth.enabled === true && smooth.type === "cubicBezier" || this.edgeType instanceof BezierEdgeStatic && smooth.enabled === true && smooth.type !== "dynamic" && smooth.type !== "cubicBezier" || this.edgeType instanceof StraightEdge && smooth.type.enabled === false) {
                        changeInType = false;
                    }

                    if (changeInType === true) {
                        dataChanged = this.cleanup();
                    }
                }

                if (changeInType === true) {
                    if (smooth.enabled === true) {
                        if (smooth.type === "dynamic") {
                            dataChanged = true;
                            this.edgeType = new BezierEdgeDynamic(this.options, this.body, this.labelModule);
                        } else if (smooth.type === "cubicBezier") {
                            this.edgeType = new CubicBezierEdge(this.options, this.body, this.labelModule);
                        } else {
                            this.edgeType = new BezierEdgeStatic(this.options, this.body, this.labelModule);
                        }
                    } else {
                        this.edgeType = new StraightEdge(this.options, this.body, this.labelModule);
                    }
                } else {
                    // if nothing changes, we just set the options.
                    this.edgeType.setOptions(this.options);
                }

                return dataChanged;
            }
            /**
             * Connect an edge to its nodes
             */

        }, {
            key: "connect",
            value: function connect() {
                this.disconnect();
                this.from = this.body.nodes[this.fromId] || undefined;
                this.to = this.body.nodes[this.toId] || undefined;
                this.connected = this.from !== undefined && this.to !== undefined;

                if (this.connected === true) {
                    this.from.attachEdge(this);
                    this.to.attachEdge(this);
                } else {
                    if (this.from) {
                        this.from.detachEdge(this);
                    }

                    if (this.to) {
                        this.to.detachEdge(this);
                    }
                }

                this.edgeType.connect();
            }
            /**
             * Disconnect an edge from its nodes
             */

        }, {
            key: "disconnect",
            value: function disconnect() {
                if (this.from) {
                    this.from.detachEdge(this);
                    this.from = undefined;
                }

                if (this.to) {
                    this.to.detachEdge(this);
                    this.to = undefined;
                }

                this.connected = false;
            }
            /**
             * get the title of this edge.
             *
             * @returns {string} title    The title of the edge, or undefined when no title
             *                           has been set.
             */

        }, {
            key: "getTitle",
            value: function getTitle() {
                return this.title;
            }
            /**
             * check if this node is selecte
             *
             * @returns {boolean} selected   True if node is selected, else false
             */

        }, {
            key: "isSelected",
            value: function isSelected() {
                return this.selected;
            }
            /**
             * Retrieve the value of the edge. Can be undefined
             *
             * @returns {number} value
             */

        }, {
            key: "getValue",
            value: function getValue() {
                return this.options.value;
            }
            /**
             * Adjust the value range of the edge. The edge will adjust it's width
             * based on its value.
             *
             * @param {number} min
             * @param {number} max
             * @param {number} total
             */

        }, {
            key: "setValueRange",
            value: function setValueRange(min, max, total) {
                if (this.options.value !== undefined) {
                    var scale = this.options.scaling.customScalingFunction(min, max, total, this.options.value);
                    var widthDiff = this.options.scaling.max - this.options.scaling.min;

                    if (this.options.scaling.label.enabled === true) {
                        var fontDiff = this.options.scaling.label.max - this.options.scaling.label.min;
                        this.options.font.size = this.options.scaling.label.min + scale * fontDiff;
                    }

                    this.options.width = this.options.scaling.min + scale * widthDiff;
                } else {
                    this.options.width = this.baseWidth;
                    this.options.font.size = this.baseFontSize;
                }

                this._setInteractionWidths();

                this.updateLabelModule();
            }
            /**
             *
             * @private
             */

        }, {
            key: "_setInteractionWidths",
            value: function _setInteractionWidths() {
                if (typeof this.options.hoverWidth === "function") {
                    this.edgeType.hoverWidth = this.options.hoverWidth(this.options.width);
                } else {
                    this.edgeType.hoverWidth = this.options.hoverWidth + this.options.width;
                }

                if (typeof this.options.selectionWidth === "function") {
                    this.edgeType.selectionWidth = this.options.selectionWidth(this.options.width);
                } else {
                    this.edgeType.selectionWidth = this.options.selectionWidth + this.options.width;
                }
            }
            /**
             * Redraw a edge
             * Draw this edge in the given canvas
             * The 2d context of a HTML canvas can be retrieved by canvas.getContext("2d");
             *
             * @param {CanvasRenderingContext2D}   ctx
             */

        }, {
            key: "draw",
            value: function draw(ctx) {
                var values = this.getFormattingValues();

                if (values.hidden) {
                    return;
                } // get the via node from the edge type


                var viaNode = this.edgeType.getViaNode(); // draw line and label

                this.edgeType.drawLine(ctx, values, this.selected, this.hover, viaNode);
                this.drawLabel(ctx, viaNode);
            }
            /**
             * Redraw arrows
             * Draw this arrows in the given canvas
             * The 2d context of a HTML canvas can be retrieved by canvas.getContext("2d");
             *
             * @param {CanvasRenderingContext2D}   ctx
             */

        }, {
            key: "drawArrows",
            value: function drawArrows(ctx) {
                var values = this.getFormattingValues();

                if (values.hidden) {
                    return;
                } // get the via node from the edge type


                var viaNode = this.edgeType.getViaNode();
                var arrowData = {}; // restore edge targets to defaults

                this.edgeType.fromPoint = this.edgeType.from;
                this.edgeType.toPoint = this.edgeType.to; // from and to arrows give a different end point for edges. we set them here

                if (values.fromArrow) {
                    arrowData.from = this.edgeType.getArrowData(ctx, "from", viaNode, this.selected, this.hover, values);
                    if (values.arrowStrikethrough === false) this.edgeType.fromPoint = arrowData.from.core;

                    if (values.fromArrowSrc) {
                        arrowData.from.image = this.imagelist.load(values.fromArrowSrc);
                    }

                    if (values.fromArrowImageWidth) {
                        arrowData.from.imageWidth = values.fromArrowImageWidth;
                    }

                    if (values.fromArrowImageHeight) {
                        arrowData.from.imageHeight = values.fromArrowImageHeight;
                    }
                }

                if (values.toArrow) {
                    arrowData.to = this.edgeType.getArrowData(ctx, "to", viaNode, this.selected, this.hover, values);
                    if (values.arrowStrikethrough === false) this.edgeType.toPoint = arrowData.to.core;

                    if (values.toArrowSrc) {
                        arrowData.to.image = this.imagelist.load(values.toArrowSrc);
                    }

                    if (values.toArrowImageWidth) {
                        arrowData.to.imageWidth = values.toArrowImageWidth;
                    }

                    if (values.toArrowImageHeight) {
                        arrowData.to.imageHeight = values.toArrowImageHeight;
                    }
                } // the middle arrow depends on the line, which can depend on the to and from arrows so we do this one lastly.


                if (values.middleArrow) {
                    arrowData.middle = this.edgeType.getArrowData(ctx, "middle", viaNode, this.selected, this.hover, values);

                    if (values.middleArrowSrc) {
                        arrowData.middle.image = this.imagelist.load(values.middleArrowSrc);
                    }

                    if (values.middleArrowImageWidth) {
                        arrowData.middle.imageWidth = values.middleArrowImageWidth;
                    }

                    if (values.middleArrowImageHeight) {
                        arrowData.middle.imageHeight = values.middleArrowImageHeight;
                    }
                }

                if (values.fromArrow) {
                    this.edgeType.drawArrowHead(ctx, values, this.selected, this.hover, arrowData.from);
                }

                if (values.middleArrow) {
                    this.edgeType.drawArrowHead(ctx, values, this.selected, this.hover, arrowData.middle);
                }

                if (values.toArrow) {
                    this.edgeType.drawArrowHead(ctx, values, this.selected, this.hover, arrowData.to);
                }
            }
            /**
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {Node} viaNode
             */

        }, {
            key: "drawLabel",
            value: function drawLabel(ctx, viaNode) {
                if (this.options.label !== undefined) {
                    // set style
                    var node1 = this.from;
                    var node2 = this.to;

                    if (this.labelModule.differentState(this.selected, this.hover)) {
                        this.labelModule.getTextSize(ctx, this.selected, this.hover);
                    }

                    var point;

                    if (node1.id != node2.id) {
                        this.labelModule.pointToSelf = false;
                        point = this.edgeType.getPoint(0.5, viaNode);
                        ctx.save();

                        var rotationPoint = this._getRotation(ctx);

                        if (rotationPoint.angle != 0) {
                            ctx.translate(rotationPoint.x, rotationPoint.y);
                            ctx.rotate(rotationPoint.angle);
                        } // draw the label


                        this.labelModule.draw(ctx, point.x, point.y, this.selected, this.hover);
                        /*
	          // Useful debug code: draw a border around the label
	          // This should **not** be enabled in production!
	          var size = this.labelModule.getSize();; // ;; intentional so lint catches it
	          ctx.strokeStyle = "#ff0000";
	          ctx.strokeRect(size.left, size.top, size.width, size.height);
	          // End  debug code
	          */

                        ctx.restore();
                    } else {
                        // Ignore the orientations.
                        this.labelModule.pointToSelf = true; // get circle coordinates

                        var coordinates = getSelfRefCoordinates(ctx, this.options.selfReference.angle, this.options.selfReference.size, node1);
                        point = this._pointOnCircle(coordinates.x, coordinates.y, this.options.selfReference.size, this.options.selfReference.angle);
                        this.labelModule.draw(ctx, point.x, point.y, this.selected, this.hover);
                    }
                }
            }
            /**
             * Determine all visual elements of this edge instance, in which the given
             * point falls within the bounding shape.
             *
             * @param {point} point
             * @returns {Array.<edgeClickItem|edgeLabelClickItem>} list with the items which are on the point
             */

        }, {
            key: "getItemsOnPoint",
            value: function getItemsOnPoint(point) {
                var ret = [];

                if (this.labelModule.visible()) {
                    var rotationPoint = this._getRotation();

                    if (pointInRect(this.labelModule.getSize(), point, rotationPoint)) {
                        ret.push({
                            edgeId: this.id,
                            labelId: 0
                        });
                    }
                }

                var obj = {
                    left: point.x,
                    top: point.y
                };

                if (this.isOverlappingWith(obj)) {
                    ret.push({
                        edgeId: this.id
                    });
                }

                return ret;
            }
            /**
             * Check if this object is overlapping with the provided object
             *
             * @param {object} obj   an object with parameters left, top
             * @returns {boolean}     True if location is located on the edge
             */

        }, {
            key: "isOverlappingWith",
            value: function isOverlappingWith(obj) {
                if (this.connected) {
                    var distMax = 10;
                    var xFrom = this.from.x;
                    var yFrom = this.from.y;
                    var xTo = this.to.x;
                    var yTo = this.to.y;
                    var xObj = obj.left;
                    var yObj = obj.top;
                    var dist = this.edgeType.getDistanceToEdge(xFrom, yFrom, xTo, yTo, xObj, yObj);
                    return dist < distMax;
                } else {
                    return false;
                }
            }
            /**
             * Determine the rotation point, if any.
             *
             * @param {CanvasRenderingContext2D} [ctx] if passed, do a recalculation of the label size
             * @returns {rotationPoint} the point to rotate around and the angle in radians to rotate
             * @private
             */

        }, {
            key: "_getRotation",
            value: function _getRotation(ctx) {
                var viaNode = this.edgeType.getViaNode();
                var point = this.edgeType.getPoint(0.5, viaNode);

                if (ctx !== undefined) {
                    this.labelModule.calculateLabelSize(ctx, this.selected, this.hover, point.x, point.y);
                }

                var ret = {
                    x: point.x,
                    y: this.labelModule.size.yLine,
                    angle: 0
                };

                if (!this.labelModule.visible()) {
                    return ret; // Don't even bother doing the atan2, there's nothing to draw
                }

                if (this.options.font.align === "horizontal") {
                    return ret; // No need to calculate angle
                }

                var dy = this.from.y - this.to.y;
                var dx = this.from.x - this.to.x;
                var angle = Math.atan2(dy, dx); // radians
                // rotate so that label is readable

                if (angle < -1 && dx < 0 || angle > 0 && dx < 0) {
                    angle += Math.PI;
                }

                ret.angle = angle;
                return ret;
            }
            /**
             * Get a point on a circle
             *
             * @param {number} x
             * @param {number} y
             * @param {number} radius
             * @param {number} angle
             * @returns {object} point
             * @private
             */

        }, {
            key: "_pointOnCircle",
            value: function _pointOnCircle(x, y, radius, angle) {
                return {
                    x: x + radius * Math.cos(angle),
                    y: y - radius * Math.sin(angle)
                };
            }
            /**
             * Sets selected state to true
             */

        }, {
            key: "select",
            value: function select() {
                this.selected = true;
            }
            /**
             * Sets selected state to false
             */

        }, {
            key: "unselect",
            value: function unselect() {
                this.selected = false;
            }
            /**
             * cleans all required things on delete
             *
             * @returns {*}
             */

        }, {
            key: "cleanup",
            value: function cleanup() {
                return this.edgeType.cleanup();
            }
            /**
             * Remove edge from the list and perform necessary cleanup.
             */

        }, {
            key: "remove",
            value: function remove() {
                this.cleanup();
                this.disconnect();
                delete this.body.edges[this.id];
            }
            /**
             * Check if both connecting nodes exist
             *
             * @returns {boolean}
             */

        }, {
            key: "endPointsValid",
            value: function endPointsValid() {
                return this.body.nodes[this.fromId] !== undefined && this.body.nodes[this.toId] !== undefined;
            }
        }], [{
            key: "parseOptions",
            value: function parseOptions(parentOptions, newOptions) {
                var allowDeletion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var globalOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var copyFromGlobals = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                var fields = ["endPointOffset", "arrowStrikethrough", "id", "from", "hidden", "hoverWidth", "labelHighlightBold", "length", "line", "opacity", "physics", "scaling", "selectionWidth", "selfReferenceSize", "selfReference", "to", "title", "value", "width", "font", "chosen", "widthConstraint"]; // only deep extend the items in the field array. These do not have shorthand.

                selectiveDeepExtend(fields, parentOptions, newOptions, allowDeletion); // Only use endPointOffset values (from and to) if it's valid values

                if (newOptions.endPointOffset !== undefined && newOptions.endPointOffset.from !== undefined) {
                    if (_isFinite(newOptions.endPointOffset.from)) {
                        parentOptions.endPointOffset.from = newOptions.endPointOffset.from;
                    } else {
                        parentOptions.endPointOffset.from = globalOptions.endPointOffset.from !== undefined ? globalOptions.endPointOffset.from : 0;
                        console.error("endPointOffset.from is not a valid number");
                    }
                }

                if (newOptions.endPointOffset !== undefined && newOptions.endPointOffset.to !== undefined) {
                    if (_isFinite(newOptions.endPointOffset.to)) {
                        parentOptions.endPointOffset.to = newOptions.endPointOffset.to;
                    } else {
                        parentOptions.endPointOffset.to = globalOptions.endPointOffset.to !== undefined ? globalOptions.endPointOffset.to : 0;
                        console.error("endPointOffset.to is not a valid number");
                    }
                } // Only copy label if it's a legal value.


                if (isValidLabel(newOptions.label)) {
                    parentOptions.label = newOptions.label;
                } else if (!isValidLabel(parentOptions.label)) {
                    parentOptions.label = undefined;
                }

                mergeOptions(parentOptions, newOptions, "smooth", globalOptions);
                mergeOptions(parentOptions, newOptions, "shadow", globalOptions);
                mergeOptions(parentOptions, newOptions, "background", globalOptions);

                if (newOptions.dashes !== undefined && newOptions.dashes !== null) {
                    parentOptions.dashes = newOptions.dashes;
                } else if (allowDeletion === true && newOptions.dashes === null) {
                    parentOptions.dashes = create$2(globalOptions.dashes); // this sets the pointer of the option back to the global option.
                } // set the scaling newOptions


                if (newOptions.scaling !== undefined && newOptions.scaling !== null) {
                    if (newOptions.scaling.min !== undefined) {
                        parentOptions.scaling.min = newOptions.scaling.min;
                    }

                    if (newOptions.scaling.max !== undefined) {
                        parentOptions.scaling.max = newOptions.scaling.max;
                    }

                    mergeOptions(parentOptions.scaling, newOptions.scaling, "label", globalOptions.scaling);
                } else if (allowDeletion === true && newOptions.scaling === null) {
                    parentOptions.scaling = create$2(globalOptions.scaling); // this sets the pointer of the option back to the global option.
                } // handle multiple input cases for arrows


                if (newOptions.arrows !== undefined && newOptions.arrows !== null) {
                    if (typeof newOptions.arrows === "string") {
                        var arrows = newOptions.arrows.toLowerCase();
                        parentOptions.arrows.to.enabled = indexOf(arrows).call(arrows, "to") != -1;
                        parentOptions.arrows.middle.enabled = indexOf(arrows).call(arrows, "middle") != -1;
                        parentOptions.arrows.from.enabled = indexOf(arrows).call(arrows, "from") != -1;
                    } else if (_typeof(newOptions.arrows) === "object") {
                        mergeOptions(parentOptions.arrows, newOptions.arrows, "to", globalOptions.arrows);
                        mergeOptions(parentOptions.arrows, newOptions.arrows, "middle", globalOptions.arrows);
                        mergeOptions(parentOptions.arrows, newOptions.arrows, "from", globalOptions.arrows);
                    } else {
                        throw new Error("The arrow newOptions can only be an object or a string. Refer to the documentation. You used:" + stringify$1(newOptions.arrows));
                    }
                } else if (allowDeletion === true && newOptions.arrows === null) {
                    parentOptions.arrows = create$2(globalOptions.arrows); // this sets the pointer of the option back to the global option.
                } // handle multiple input cases for color


                if (newOptions.color !== undefined && newOptions.color !== null) {
                    var fromColor = isString(newOptions.color) ? {
                        color: newOptions.color,
                        highlight: newOptions.color,
                        hover: newOptions.color,
                        inherit: false,
                        opacity: 1
                    } : newOptions.color;
                    var toColor = parentOptions.color; // If passed, fill in values from default options - required in the case of no prototype bridging

                    if (copyFromGlobals) {
                        deepExtend(toColor, globalOptions.color, false, allowDeletion);
                    } else {
                        // Clear local properties - need to do it like this in order to retain prototype bridges
                        for (var i in toColor) {
                            if (Object.prototype.hasOwnProperty.call(toColor, i)) {
                                delete toColor[i];
                            }
                        }
                    }

                    if (isString(toColor)) {
                        toColor.color = toColor;
                        toColor.highlight = toColor;
                        toColor.hover = toColor;
                        toColor.inherit = false;

                        if (fromColor.opacity === undefined) {
                            toColor.opacity = 1.0; // set default
                        }
                    } else {
                        var colorsDefined = false;

                        if (fromColor.color !== undefined) {
                            toColor.color = fromColor.color;
                            colorsDefined = true;
                        }

                        if (fromColor.highlight !== undefined) {
                            toColor.highlight = fromColor.highlight;
                            colorsDefined = true;
                        }

                        if (fromColor.hover !== undefined) {
                            toColor.hover = fromColor.hover;
                            colorsDefined = true;
                        }

                        if (fromColor.inherit !== undefined) {
                            toColor.inherit = fromColor.inherit;
                        }

                        if (fromColor.opacity !== undefined) {
                            toColor.opacity = Math.min(1, Math.max(0, fromColor.opacity));
                        }

                        if (colorsDefined === true) {
                            toColor.inherit = false;
                        } else {
                            if (toColor.inherit === undefined) {
                                toColor.inherit = "from"; // Set default
                            }
                        }
                    }
                } else if (allowDeletion === true && newOptions.color === null) {
                    parentOptions.color = bridgeObject(globalOptions.color); // set the object back to the global options
                }

                if (allowDeletion === true && newOptions.font === null) {
                    parentOptions.font = bridgeObject(globalOptions.font); // set the object back to the global options
                }

                if (Object.prototype.hasOwnProperty.call(newOptions, "selfReferenceSize")) {
                    console.warn("The selfReferenceSize property has been deprecated. Please use selfReference property instead. The selfReference can be set like thise selfReference:{size:30, angle:Math.PI / 4}");
                    parentOptions.selfReference.size = newOptions.selfReferenceSize;
                }
            }
        }]);

        return Edge;
    }();

    /**
     * Handler for Edges
     */

    var EdgesHandler = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {Array.<Image>} images
         * @param {Array.<Group>} groups
         */
        function EdgesHandler(body, images, groups) {
            var _context,
                _this = this;

            _classCallCheck(this, EdgesHandler);

            this.body = body;
            this.images = images;
            this.groups = groups; // create the edge API in the body container

            this.body.functions.createEdge = bind(_context = this.create).call(_context, this);
            this.edgesListeners = {
                add: function add(event, params) {
                    _this.add(params.items);
                },
                update: function update(event, params) {
                    _this.update(params.items);
                },
                remove: function remove(event, params) {
                    _this.remove(params.items);
                }
            };
            this.options = {};
            this.defaultOptions = {
                arrows: {
                    to: {
                        enabled: false,
                        scaleFactor: 1,
                        type: "arrow"
                    },
                    // boolean / {arrowScaleFactor:1} / {enabled: false, arrowScaleFactor:1}
                    middle: {
                        enabled: false,
                        scaleFactor: 1,
                        type: "arrow"
                    },
                    from: {
                        enabled: false,
                        scaleFactor: 1,
                        type: "arrow"
                    }
                },
                endPointOffset: {
                    from: 0,
                    to: 0
                },
                arrowStrikethrough: true,
                color: {
                    color: "#848484",
                    highlight: "#848484",
                    hover: "#848484",
                    inherit: "from",
                    opacity: 1.0
                },
                dashes: false,
                font: {
                    color: "#343434",
                    size: 14,
                    // px
                    face: "arial",
                    background: "none",
                    strokeWidth: 2,
                    // px
                    strokeColor: "#ffffff",
                    align: "horizontal",
                    multi: false,
                    vadjust: 0,
                    bold: {
                        mod: "bold"
                    },
                    boldital: {
                        mod: "bold italic"
                    },
                    ital: {
                        mod: "italic"
                    },
                    mono: {
                        mod: "",
                        size: 15,
                        // px
                        face: "courier new",
                        vadjust: 2
                    }
                },
                hidden: false,
                hoverWidth: 1.5,
                label: undefined,
                labelHighlightBold: true,
                length: undefined,
                physics: true,
                scaling: {
                    min: 1,
                    max: 15,
                    label: {
                        enabled: true,
                        min: 14,
                        max: 30,
                        maxVisible: 30,
                        drawThreshold: 5
                    },
                    customScalingFunction: function customScalingFunction(min, max, total, value) {
                        if (max === min) {
                            return 0.5;
                        } else {
                            var scale = 1 / (max - min);
                            return Math.max(0, (value - min) * scale);
                        }
                    }
                },
                selectionWidth: 1.5,
                selfReference: {
                    size: 20,
                    angle: Math.PI / 4,
                    renderBehindTheNode: true
                },
                shadow: {
                    enabled: false,
                    color: "rgba(0,0,0,0.5)",
                    size: 10,
                    x: 5,
                    y: 5
                },
                background: {
                    enabled: false,
                    color: "rgba(111,111,111,1)",
                    size: 10,
                    dashes: false
                },
                smooth: {
                    enabled: true,
                    type: "dynamic",
                    forceDirection: "none",
                    roundness: 0.5
                },
                title: undefined,
                width: 1,
                value: undefined
            };
            deepExtend(this.options, this.defaultOptions);
            this.bindEventListeners();
        }
        /**
         * Binds event listeners
         */


        _createClass(EdgesHandler, [{
            key: "bindEventListeners",
            value: function bindEventListeners() {
                var _this2 = this,
                    _context2,
                    _context3;

                // this allows external modules to force all dynamic curves to turn static.
                this.body.emitter.on("_forceDisableDynamicCurves", function (type) {
                    var emit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                    if (type === "dynamic") {
                        type = "continuous";
                    }

                    var dataChanged = false;

                    for (var edgeId in _this2.body.edges) {
                        if (Object.prototype.hasOwnProperty.call(_this2.body.edges, edgeId)) {
                            var edge = _this2.body.edges[edgeId];

                            var edgeData = _this2.body.data.edges.get(edgeId); // only forcibly remove the smooth curve if the data has been set of the edge has the smooth curves defined.
                            // this is because a change in the global would not affect these curves.


                            if (edgeData != null) {
                                var smoothOptions = edgeData.smooth;

                                if (smoothOptions !== undefined) {
                                    if (smoothOptions.enabled === true && smoothOptions.type === "dynamic") {
                                        if (type === undefined) {
                                            edge.setOptions({
                                                smooth: false
                                            });
                                        } else {
                                            edge.setOptions({
                                                smooth: {
                                                    type: type
                                                }
                                            });
                                        }

                                        dataChanged = true;
                                    }
                                }
                            }
                        }
                    }

                    if (emit === true && dataChanged === true) {
                        _this2.body.emitter.emit("_dataChanged");
                    }
                }); // this is called when options of EXISTING nodes or edges have changed.
                //
                // NOTE: Not true, called when options have NOT changed, for both existing as well as new nodes.
                //       See update() for logic.
                // TODO: Verify and examine the consequences of this. It might still trigger when
                //       non-option fields have changed, but then reconnecting edges is still useless.
                //       Alternatively, it might also be called when edges are removed.
                //

                this.body.emitter.on("_dataUpdated", function () {
                    _this2.reconnectEdges();
                }); // refresh the edges. Used when reverting from hierarchical layout

                this.body.emitter.on("refreshEdges", bind(_context2 = this.refresh).call(_context2, this));
                this.body.emitter.on("refresh", bind(_context3 = this.refresh).call(_context3, this));
                this.body.emitter.on("destroy", function () {
                    forEach$1(_this2.edgesListeners, function (callback, event) {
                        if (_this2.body.data.edges) _this2.body.data.edges.off(event, callback);
                    });
                    delete _this2.body.functions.createEdge;
                    delete _this2.edgesListeners.add;
                    delete _this2.edgesListeners.update;
                    delete _this2.edgesListeners.remove;
                    delete _this2.edgesListeners;
                });
            }
            /**
             *
             * @param {object} options
             */

        }, {
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    // use the parser from the Edge class to fill in all shorthand notations
                    Edge.parseOptions(this.options, options, true, this.defaultOptions, true); // update smooth settings in all edges

                    var dataChanged = false;

                    if (options.smooth !== undefined) {
                        for (var edgeId in this.body.edges) {
                            if (Object.prototype.hasOwnProperty.call(this.body.edges, edgeId)) {
                                dataChanged = this.body.edges[edgeId].updateEdgeType() || dataChanged;
                            }
                        }
                    } // update fonts in all edges


                    if (options.font !== undefined) {
                        for (var _edgeId in this.body.edges) {
                            if (Object.prototype.hasOwnProperty.call(this.body.edges, _edgeId)) {
                                this.body.edges[_edgeId].updateLabelModule();
                            }
                        }
                    } // update the state of the variables if needed


                    if (options.hidden !== undefined || options.physics !== undefined || dataChanged === true) {
                        this.body.emitter.emit("_dataChanged");
                    }
                }
            }
            /**
             * Load edges by reading the data table
             *
             * @param {Array | DataSet | DataView} edges    The data containing the edges.
             * @param {boolean} [doNotEmit=false] - Suppress data changed event.
             * @private
             */

        }, {
            key: "setData",
            value: function setData(edges) {
                var _this3 = this;

                var doNotEmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var oldEdgesData = this.body.data.edges;

                if (isDataViewLike("id", edges)) {
                    this.body.data.edges = edges;
                } else if (isArray(edges)) {
                    this.body.data.edges = new DataSet();
                    this.body.data.edges.add(edges);
                } else if (!edges) {
                    this.body.data.edges = new DataSet();
                } else {
                    throw new TypeError("Array or DataSet expected");
                } // TODO: is this null or undefined or false?


                if (oldEdgesData) {
                    // unsubscribe from old dataset
                    forEach$1(this.edgesListeners, function (callback, event) {
                        oldEdgesData.off(event, callback);
                    });
                } // remove drawn edges


                this.body.edges = {}; // TODO: is this null or undefined or false?

                if (this.body.data.edges) {
                    // subscribe to new dataset
                    forEach$1(this.edgesListeners, function (callback, event) {
                        _this3.body.data.edges.on(event, callback);
                    }); // draw all new nodes

                    var ids = this.body.data.edges.getIds();
                    this.add(ids, true);
                }

                this.body.emitter.emit("_adjustEdgesForHierarchicalLayout");

                if (doNotEmit === false) {
                    this.body.emitter.emit("_dataChanged");
                }
            }
            /**
             * Add edges
             *
             * @param {number[] | string[]} ids
             * @param {boolean} [doNotEmit=false]
             * @private
             */

        }, {
            key: "add",
            value: function add(ids) {
                var doNotEmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var edges = this.body.edges;
                var edgesData = this.body.data.edges;

                for (var i = 0; i < ids.length; i++) {
                    var id = ids[i];
                    var oldEdge = edges[id];

                    if (oldEdge) {
                        oldEdge.disconnect();
                    }

                    var data = edgesData.get(id, {
                        showInternalIds: true
                    });
                    edges[id] = this.create(data);
                }

                this.body.emitter.emit("_adjustEdgesForHierarchicalLayout");

                if (doNotEmit === false) {
                    this.body.emitter.emit("_dataChanged");
                }
            }
            /**
             * Update existing edges, or create them when not yet existing
             *
             * @param {number[] | string[]} ids
             * @private
             */

        }, {
            key: "update",
            value: function update(ids) {
                var edges = this.body.edges;
                var edgesData = this.body.data.edges;
                var dataChanged = false;

                for (var i = 0; i < ids.length; i++) {
                    var id = ids[i];
                    var data = edgesData.get(id);
                    var edge = edges[id];

                    if (edge !== undefined) {
                        // update edge
                        edge.disconnect();
                        dataChanged = edge.setOptions(data) || dataChanged; // if a support node is added, data can be changed.

                        edge.connect();
                    } else {
                        // create edge
                        this.body.edges[id] = this.create(data);
                        dataChanged = true;
                    }
                }

                if (dataChanged === true) {
                    this.body.emitter.emit("_adjustEdgesForHierarchicalLayout");
                    this.body.emitter.emit("_dataChanged");
                } else {
                    this.body.emitter.emit("_dataUpdated");
                }
            }
            /**
             * Remove existing edges. Non existing ids will be ignored
             *
             * @param {number[] | string[]} ids
             * @param {boolean} [emit=true]
             * @private
             */

        }, {
            key: "remove",
            value: function remove(ids) {
                var emit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (ids.length === 0) return; // early out

                var edges = this.body.edges;
                forEach$1(ids, function (id) {
                    var edge = edges[id];

                    if (edge !== undefined) {
                        edge.remove();
                    }
                });

                if (emit) {
                    this.body.emitter.emit("_dataChanged");
                }
            }
            /**
             * Refreshes Edge Handler
             */

        }, {
            key: "refresh",
            value: function refresh() {
                var _this4 = this;

                forEach$1(this.body.edges, function (edge, edgeId) {
                    var data = _this4.body.data.edges.get(edgeId);

                    if (data !== undefined) {
                        edge.setOptions(data);
                    }
                });
            }
            /**
             *
             * @param {object} properties
             * @returns {Edge}
             */

        }, {
            key: "create",
            value: function create(properties) {
                return new Edge(properties, this.body, this.images, this.options, this.defaultOptions);
            }
            /**
             * Reconnect all edges
             *
             * @private
             */

        }, {
            key: "reconnectEdges",
            value: function reconnectEdges() {
                var id;
                var nodes = this.body.nodes;
                var edges = this.body.edges;

                for (id in nodes) {
                    if (Object.prototype.hasOwnProperty.call(nodes, id)) {
                        nodes[id].edges = [];
                    }
                }

                for (id in edges) {
                    if (Object.prototype.hasOwnProperty.call(edges, id)) {
                        var edge = edges[id];
                        edge.from = null;
                        edge.to = null;
                        edge.connect();
                    }
                }
            }
            /**
             *
             * @param {Edge.id} edgeId
             * @returns {Array}
             */

        }, {
            key: "getConnectedNodes",
            value: function getConnectedNodes(edgeId) {
                var nodeList = [];

                if (this.body.edges[edgeId] !== undefined) {
                    var edge = this.body.edges[edgeId];

                    if (edge.fromId !== undefined) {
                        nodeList.push(edge.fromId);
                    }

                    if (edge.toId !== undefined) {
                        nodeList.push(edge.toId);
                    }
                }

                return nodeList;
            }
            /**
             * There is no direct relation between the nodes and the edges DataSet,
             * so the right place to do call this is in the handler for event `_dataUpdated`.
             */

        }, {
            key: "_updateState",
            value: function _updateState() {
                this._addMissingEdges();

                this._removeInvalidEdges();
            }
            /**
             * Scan for missing nodes and remove corresponding edges, if any.
             *
             * @private
             */

        }, {
            key: "_removeInvalidEdges",
            value: function _removeInvalidEdges() {
                var _this5 = this;

                var edgesToDelete = [];
                forEach$1(this.body.edges, function (edge, id) {
                    var toNode = _this5.body.nodes[edge.toId];
                    var fromNode = _this5.body.nodes[edge.fromId]; // Skip clustering edges here, let the Clustering module handle those

                    if (toNode !== undefined && toNode.isCluster === true || fromNode !== undefined && fromNode.isCluster === true) {
                        return;
                    }

                    if (toNode === undefined || fromNode === undefined) {
                        edgesToDelete.push(id);
                    }
                });
                this.remove(edgesToDelete, false);
            }
            /**
             * add all edges from dataset that are not in the cached state
             *
             * @private
             */

        }, {
            key: "_addMissingEdges",
            value: function _addMissingEdges() {
                var edgesData = this.body.data.edges;

                if (edgesData === undefined || edgesData === null) {
                    return; // No edges DataSet yet; can happen on startup
                }

                var edges = this.body.edges;
                var addIds = [];

                forEach$2(edgesData).call(edgesData, function (edgeData, edgeId) {
                    var edge = edges[edgeId];

                    if (edge === undefined) {
                        addIds.push(edgeId);
                    }
                });

                this.add(addIds, true);
            }
        }]);

        return EdgesHandler;
    }();

    /**
     * Barnes Hut Solver
     */

    var BarnesHutSolver = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
         * @param {object} options
         */
        function BarnesHutSolver(body, physicsBody, options) {
            _classCallCheck(this, BarnesHutSolver);

            this.body = body;
            this.physicsBody = physicsBody;
            this.barnesHutTree;
            this.setOptions(options);
            this._rng = Alea("BARNES HUT SOLVER"); // debug: show grid
            // this.body.emitter.on("afterDrawing", (ctx) => {this._debug(ctx,'#ff0000')})
        }
        /**
         *
         * @param {object} options
         */


        _createClass(BarnesHutSolver, [{
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
                this.thetaInversed = 1 / this.options.theta; // if 1 then min distance = 0.5, if 0.5 then min distance = 0.5 + 0.5*node.shape.radius

                this.overlapAvoidanceFactor = 1 - Math.max(0, Math.min(1, this.options.avoidOverlap));
            }
            /**
             * This function calculates the forces the nodes apply on each other based on a gravitational model.
             * The Barnes Hut method is used to speed up this N-body simulation.
             *
             * @private
             */

        }, {
            key: "solve",
            value: function solve() {
                if (this.options.gravitationalConstant !== 0 && this.physicsBody.physicsNodeIndices.length > 0) {
                    var node;
                    var nodes = this.body.nodes;
                    var nodeIndices = this.physicsBody.physicsNodeIndices;
                    var nodeCount = nodeIndices.length; // create the tree

                    var barnesHutTree = this._formBarnesHutTree(nodes, nodeIndices); // for debugging


                    this.barnesHutTree = barnesHutTree; // place the nodes one by one recursively

                    for (var i = 0; i < nodeCount; i++) {
                        node = nodes[nodeIndices[i]];

                        if (node.options.mass > 0) {
                            // starting with root is irrelevant, it never passes the BarnesHutSolver condition
                            this._getForceContributions(barnesHutTree.root, node);
                        }
                    }
                }
            }
            /**
             * @param {object} parentBranch
             * @param {Node} node
             * @private
             */

        }, {
            key: "_getForceContributions",
            value: function _getForceContributions(parentBranch, node) {
                this._getForceContribution(parentBranch.children.NW, node);

                this._getForceContribution(parentBranch.children.NE, node);

                this._getForceContribution(parentBranch.children.SW, node);

                this._getForceContribution(parentBranch.children.SE, node);
            }
            /**
             * This function traverses the barnesHutTree. It checks when it can approximate distant nodes with their center of mass.
             * If a region contains a single node, we check if it is not itself, then we apply the force.
             *
             * @param {object} parentBranch
             * @param {Node} node
             * @private
             */

        }, {
            key: "_getForceContribution",
            value: function _getForceContribution(parentBranch, node) {
                // we get no force contribution from an empty region
                if (parentBranch.childrenCount > 0) {
                    // get the distance from the center of mass to the node.
                    var dx = parentBranch.centerOfMass.x - node.x;
                    var dy = parentBranch.centerOfMass.y - node.y;
                    var distance = Math.sqrt(dx * dx + dy * dy); // BarnesHutSolver condition
                    // original condition : s/d < theta = passed  ===  d/s > 1/theta = passed
                    // calcSize = 1/s --> d * 1/s > 1/theta = passed

                    if (distance * parentBranch.calcSize > this.thetaInversed) {
                        this._calculateForces(distance, dx, dy, node, parentBranch);
                    } else {
                        // Did not pass the condition, go into children if available
                        if (parentBranch.childrenCount === 4) {
                            this._getForceContributions(parentBranch, node);
                        } else {
                            // parentBranch must have only one node, if it was empty we wouldnt be here
                            if (parentBranch.children.data.id != node.id) {
                                // if it is not self
                                this._calculateForces(distance, dx, dy, node, parentBranch);
                            }
                        }
                    }
                }
            }
            /**
             * Calculate the forces based on the distance.
             *
             * @param {number} distance
             * @param {number} dx
             * @param {number} dy
             * @param {Node} node
             * @param {object} parentBranch
             * @private
             */

        }, {
            key: "_calculateForces",
            value: function _calculateForces(distance, dx, dy, node, parentBranch) {
                if (distance === 0) {
                    distance = 0.1;
                    dx = distance;
                }

                if (this.overlapAvoidanceFactor < 1 && node.shape.radius) {
                    distance = Math.max(0.1 + this.overlapAvoidanceFactor * node.shape.radius, distance - node.shape.radius);
                } // the dividing by the distance cubed instead of squared allows us to get the fx and fy components without sines and cosines
                // it is shorthand for gravityforce with distance squared and fx = dx/distance * gravityForce


                var gravityForce = this.options.gravitationalConstant * parentBranch.mass * node.options.mass / Math.pow(distance, 3);
                var fx = dx * gravityForce;
                var fy = dy * gravityForce;
                this.physicsBody.forces[node.id].x += fx;
                this.physicsBody.forces[node.id].y += fy;
            }
            /**
             * This function constructs the barnesHut tree recursively. It creates the root, splits it and starts placing the nodes.
             *
             * @param {Array.<Node>} nodes
             * @param {Array.<number>} nodeIndices
             * @returns {{root: {centerOfMass: {x: number, y: number}, mass: number, range: {minX: number, maxX: number, minY: number, maxY: number}, size: number, calcSize: number, children: {data: null}, maxWidth: number, level: number, childrenCount: number}}} BarnesHutTree
             * @private
             */

        }, {
            key: "_formBarnesHutTree",
            value: function _formBarnesHutTree(nodes, nodeIndices) {
                var node;
                var nodeCount = nodeIndices.length;
                var minX = nodes[nodeIndices[0]].x;
                var minY = nodes[nodeIndices[0]].y;
                var maxX = nodes[nodeIndices[0]].x;
                var maxY = nodes[nodeIndices[0]].y; // get the range of the nodes

                for (var i = 1; i < nodeCount; i++) {
                    var _node = nodes[nodeIndices[i]];
                    var x = _node.x;
                    var y = _node.y;

                    if (_node.options.mass > 0) {
                        if (x < minX) {
                            minX = x;
                        }

                        if (x > maxX) {
                            maxX = x;
                        }

                        if (y < minY) {
                            minY = y;
                        }

                        if (y > maxY) {
                            maxY = y;
                        }
                    }
                } // make the range a square


                var sizeDiff = Math.abs(maxX - minX) - Math.abs(maxY - minY); // difference between X and Y

                if (sizeDiff > 0) {
                    minY -= 0.5 * sizeDiff;
                    maxY += 0.5 * sizeDiff;
                } // xSize > ySize
                else {
                    minX += 0.5 * sizeDiff;
                    maxX -= 0.5 * sizeDiff;
                } // xSize < ySize


                var minimumTreeSize = 1e-5;
                var rootSize = Math.max(minimumTreeSize, Math.abs(maxX - minX));
                var halfRootSize = 0.5 * rootSize;
                var centerX = 0.5 * (minX + maxX),
                    centerY = 0.5 * (minY + maxY); // construct the barnesHutTree

                var barnesHutTree = {
                    root: {
                        centerOfMass: {
                            x: 0,
                            y: 0
                        },
                        mass: 0,
                        range: {
                            minX: centerX - halfRootSize,
                            maxX: centerX + halfRootSize,
                            minY: centerY - halfRootSize,
                            maxY: centerY + halfRootSize
                        },
                        size: rootSize,
                        calcSize: 1 / rootSize,
                        children: {
                            data: null
                        },
                        maxWidth: 0,
                        level: 0,
                        childrenCount: 4
                    }
                };

                this._splitBranch(barnesHutTree.root); // place the nodes one by one recursively


                for (var _i = 0; _i < nodeCount; _i++) {
                    node = nodes[nodeIndices[_i]];

                    if (node.options.mass > 0) {
                        this._placeInTree(barnesHutTree.root, node);
                    }
                } // make global


                return barnesHutTree;
            }
            /**
             * this updates the mass of a branch. this is increased by adding a node.
             *
             * @param {object} parentBranch
             * @param {Node} node
             * @private
             */

        }, {
            key: "_updateBranchMass",
            value: function _updateBranchMass(parentBranch, node) {
                var centerOfMass = parentBranch.centerOfMass;
                var totalMass = parentBranch.mass + node.options.mass;
                var totalMassInv = 1 / totalMass;
                centerOfMass.x = centerOfMass.x * parentBranch.mass + node.x * node.options.mass;
                centerOfMass.x *= totalMassInv;
                centerOfMass.y = centerOfMass.y * parentBranch.mass + node.y * node.options.mass;
                centerOfMass.y *= totalMassInv;
                parentBranch.mass = totalMass;
                var biggestSize = Math.max(Math.max(node.height, node.radius), node.width);
                parentBranch.maxWidth = parentBranch.maxWidth < biggestSize ? biggestSize : parentBranch.maxWidth;
            }
            /**
             * determine in which branch the node will be placed.
             *
             * @param {object} parentBranch
             * @param {Node} node
             * @param {boolean} skipMassUpdate
             * @private
             */

        }, {
            key: "_placeInTree",
            value: function _placeInTree(parentBranch, node, skipMassUpdate) {
                if (skipMassUpdate != true || skipMassUpdate === undefined) {
                    // update the mass of the branch.
                    this._updateBranchMass(parentBranch, node);
                }

                var range = parentBranch.children.NW.range;
                var region;

                if (range.maxX > node.x) {
                    // in NW or SW
                    if (range.maxY > node.y) {
                        region = "NW";
                    } else {
                        region = "SW";
                    }
                } else {
                    // in NE or SE
                    if (range.maxY > node.y) {
                        region = "NE";
                    } else {
                        region = "SE";
                    }
                }

                this._placeInRegion(parentBranch, node, region);
            }
            /**
             * actually place the node in a region (or branch)
             *
             * @param {object} parentBranch
             * @param {Node} node
             * @param {'NW'| 'NE' | 'SW' | 'SE'} region
             * @private
             */

        }, {
            key: "_placeInRegion",
            value: function _placeInRegion(parentBranch, node, region) {
                var children = parentBranch.children[region];

                switch (children.childrenCount) {
                    case 0:
                        // place node here
                        children.children.data = node;
                        children.childrenCount = 1;

                        this._updateBranchMass(children, node);

                        break;

                    case 1:
                        // convert into children
                        // if there are two nodes exactly overlapping (on init, on opening of cluster etc.)
                        // we move one node a little bit and we do not put it in the tree.
                        if (children.children.data.x === node.x && children.children.data.y === node.y) {
                            node.x += this._rng();
                            node.y += this._rng();
                        } else {
                            this._splitBranch(children);

                            this._placeInTree(children, node);
                        }

                        break;

                    case 4:
                        // place in branch
                        this._placeInTree(children, node);

                        break;
                }
            }
            /**
             * this function splits a branch into 4 sub branches. If the branch contained a node, we place it in the subbranch
             * after the split is complete.
             *
             * @param {object} parentBranch
             * @private
             */

        }, {
            key: "_splitBranch",
            value: function _splitBranch(parentBranch) {
                // if the branch is shaded with a node, replace the node in the new subset.
                var containedNode = null;

                if (parentBranch.childrenCount === 1) {
                    containedNode = parentBranch.children.data;
                    parentBranch.mass = 0;
                    parentBranch.centerOfMass.x = 0;
                    parentBranch.centerOfMass.y = 0;
                }

                parentBranch.childrenCount = 4;
                parentBranch.children.data = null;

                this._insertRegion(parentBranch, "NW");

                this._insertRegion(parentBranch, "NE");

                this._insertRegion(parentBranch, "SW");

                this._insertRegion(parentBranch, "SE");

                if (containedNode != null) {
                    this._placeInTree(parentBranch, containedNode);
                }
            }
            /**
             * This function subdivides the region into four new segments.
             * Specifically, this inserts a single new segment.
             * It fills the children section of the parentBranch
             *
             * @param {object} parentBranch
             * @param {'NW'| 'NE' | 'SW' | 'SE'} region
             * @private
             */

        }, {
            key: "_insertRegion",
            value: function _insertRegion(parentBranch, region) {
                var minX, maxX, minY, maxY;
                var childSize = 0.5 * parentBranch.size;

                switch (region) {
                    case "NW":
                        minX = parentBranch.range.minX;
                        maxX = parentBranch.range.minX + childSize;
                        minY = parentBranch.range.minY;
                        maxY = parentBranch.range.minY + childSize;
                        break;

                    case "NE":
                        minX = parentBranch.range.minX + childSize;
                        maxX = parentBranch.range.maxX;
                        minY = parentBranch.range.minY;
                        maxY = parentBranch.range.minY + childSize;
                        break;

                    case "SW":
                        minX = parentBranch.range.minX;
                        maxX = parentBranch.range.minX + childSize;
                        minY = parentBranch.range.minY + childSize;
                        maxY = parentBranch.range.maxY;
                        break;

                    case "SE":
                        minX = parentBranch.range.minX + childSize;
                        maxX = parentBranch.range.maxX;
                        minY = parentBranch.range.minY + childSize;
                        maxY = parentBranch.range.maxY;
                        break;
                }

                parentBranch.children[region] = {
                    centerOfMass: {
                        x: 0,
                        y: 0
                    },
                    mass: 0,
                    range: {
                        minX: minX,
                        maxX: maxX,
                        minY: minY,
                        maxY: maxY
                    },
                    size: 0.5 * parentBranch.size,
                    calcSize: 2 * parentBranch.calcSize,
                    children: {
                        data: null
                    },
                    maxWidth: 0,
                    level: parentBranch.level + 1,
                    childrenCount: 0
                };
            } //---------------------------  DEBUGGING BELOW  ---------------------------//

            /**
             * This function is for debugging purposed, it draws the tree.
             *
             * @param {CanvasRenderingContext2D} ctx
             * @param {string} color
             * @private
             */

        }, {
            key: "_debug",
            value: function _debug(ctx, color) {
                if (this.barnesHutTree !== undefined) {
                    ctx.lineWidth = 1;

                    this._drawBranch(this.barnesHutTree.root, ctx, color);
                }
            }
            /**
             * This function is for debugging purposes. It draws the branches recursively.
             *
             * @param {object} branch
             * @param {CanvasRenderingContext2D} ctx
             * @param {string} color
             * @private
             */

        }, {
            key: "_drawBranch",
            value: function _drawBranch(branch, ctx, color) {
                if (color === undefined) {
                    color = "#FF0000";
                }

                if (branch.childrenCount === 4) {
                    this._drawBranch(branch.children.NW, ctx);

                    this._drawBranch(branch.children.NE, ctx);

                    this._drawBranch(branch.children.SE, ctx);

                    this._drawBranch(branch.children.SW, ctx);
                }

                ctx.strokeStyle = color;
                ctx.beginPath();
                ctx.moveTo(branch.range.minX, branch.range.minY);
                ctx.lineTo(branch.range.maxX, branch.range.minY);
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(branch.range.maxX, branch.range.minY);
                ctx.lineTo(branch.range.maxX, branch.range.maxY);
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(branch.range.maxX, branch.range.maxY);
                ctx.lineTo(branch.range.minX, branch.range.maxY);
                ctx.stroke();
                ctx.beginPath();
                ctx.moveTo(branch.range.minX, branch.range.maxY);
                ctx.lineTo(branch.range.minX, branch.range.minY);
                ctx.stroke();
                /*
	       if (branch.mass > 0) {
	       ctx.circle(branch.centerOfMass.x, branch.centerOfMass.y, 3*branch.mass);
	       ctx.stroke();
	       }
	       */
            }
        }]);

        return BarnesHutSolver;
    }();

    /**
     * Repulsion Solver
     */

    var RepulsionSolver = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
         * @param {object} options
         */
        function RepulsionSolver(body, physicsBody, options) {
            _classCallCheck(this, RepulsionSolver);

            this._rng = Alea("REPULSION SOLVER");
            this.body = body;
            this.physicsBody = physicsBody;
            this.setOptions(options);
        }
        /**
         *
         * @param {object} options
         */


        _createClass(RepulsionSolver, [{
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
            }
            /**
             * Calculate the forces the nodes apply on each other based on a repulsion field.
             * This field is linearly approximated.
             *
             * @private
             */

        }, {
            key: "solve",
            value: function solve() {
                var dx, dy, distance, fx, fy, repulsingForce, node1, node2;
                var nodes = this.body.nodes;
                var nodeIndices = this.physicsBody.physicsNodeIndices;
                var forces = this.physicsBody.forces; // repulsing forces between nodes

                var nodeDistance = this.options.nodeDistance; // approximation constants

                var a = -2 / 3 / nodeDistance;
                var b = 4 / 3; // we loop from i over all but the last entree in the array
                // j loops from i+1 to the last. This way we do not double count any of the indices, nor i === j

                for (var i = 0; i < nodeIndices.length - 1; i++) {
                    node1 = nodes[nodeIndices[i]];

                    for (var j = i + 1; j < nodeIndices.length; j++) {
                        node2 = nodes[nodeIndices[j]];
                        dx = node2.x - node1.x;
                        dy = node2.y - node1.y;
                        distance = Math.sqrt(dx * dx + dy * dy); // same condition as BarnesHutSolver, making sure nodes are never 100% overlapping.

                        if (distance === 0) {
                            distance = 0.1 * this._rng();
                            dx = distance;
                        }

                        if (distance < 2 * nodeDistance) {
                            if (distance < 0.5 * nodeDistance) {
                                repulsingForce = 1.0;
                            } else {
                                repulsingForce = a * distance + b; // linear approx of  1 / (1 + Math.exp((distance / nodeDistance - 1) * steepness))
                            }

                            repulsingForce = repulsingForce / distance;
                            fx = dx * repulsingForce;
                            fy = dy * repulsingForce;
                            forces[node1.id].x -= fx;
                            forces[node1.id].y -= fy;
                            forces[node2.id].x += fx;
                            forces[node2.id].y += fy;
                        }
                    }
                }
            }
        }]);

        return RepulsionSolver;
    }();

    /**
     * Hierarchical Repulsion Solver
     */
    var HierarchicalRepulsionSolver = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
         * @param {object} options
         */
        function HierarchicalRepulsionSolver(body, physicsBody, options) {
            _classCallCheck(this, HierarchicalRepulsionSolver);

            this.body = body;
            this.physicsBody = physicsBody;
            this.setOptions(options);
        }
        /**
         *
         * @param {object} options
         */


        _createClass(HierarchicalRepulsionSolver, [{
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
                this.overlapAvoidanceFactor = Math.max(0, Math.min(1, this.options.avoidOverlap || 0));
            }
            /**
             * Calculate the forces the nodes apply on each other based on a repulsion field.
             * This field is linearly approximated.
             *
             * @private
             */

        }, {
            key: "solve",
            value: function solve() {
                var nodes = this.body.nodes;
                var nodeIndices = this.physicsBody.physicsNodeIndices;
                var forces = this.physicsBody.forces; // repulsing forces between nodes

                var nodeDistance = this.options.nodeDistance; // we loop from i over all but the last entree in the array
                // j loops from i+1 to the last. This way we do not double count any of the indices, nor i === j

                for (var i = 0; i < nodeIndices.length - 1; i++) {
                    var node1 = nodes[nodeIndices[i]];

                    for (var j = i + 1; j < nodeIndices.length; j++) {
                        var node2 = nodes[nodeIndices[j]]; // nodes only affect nodes on their level

                        if (node1.level === node2.level) {
                            var theseNodesDistance = nodeDistance + this.overlapAvoidanceFactor * ((node1.shape.radius || 0) / 2 + (node2.shape.radius || 0) / 2);
                            var dx = node2.x - node1.x;
                            var dy = node2.y - node1.y;
                            var distance = Math.sqrt(dx * dx + dy * dy);
                            var steepness = 0.05;
                            var repulsingForce = void 0;

                            if (distance < theseNodesDistance) {
                                repulsingForce = -Math.pow(steepness * distance, 2) + Math.pow(steepness * theseNodesDistance, 2);
                            } else {
                                repulsingForce = 0;
                            } // normalize force with


                            if (distance !== 0) {
                                repulsingForce = repulsingForce / distance;
                            }

                            var fx = dx * repulsingForce;
                            var fy = dy * repulsingForce;
                            forces[node1.id].x -= fx;
                            forces[node1.id].y -= fy;
                            forces[node2.id].x += fx;
                            forces[node2.id].y += fy;
                        }
                    }
                }
            }
        }]);

        return HierarchicalRepulsionSolver;
    }();

    /**
     * Spring Solver
     */
    var SpringSolver = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
         * @param {object} options
         */
        function SpringSolver(body, physicsBody, options) {
            _classCallCheck(this, SpringSolver);

            this.body = body;
            this.physicsBody = physicsBody;
            this.setOptions(options);
        }
        /**
         *
         * @param {object} options
         */


        _createClass(SpringSolver, [{
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
            }
            /**
             * This function calculates the springforces on the nodes, accounting for the support nodes.
             *
             * @private
             */

        }, {
            key: "solve",
            value: function solve() {
                var edgeLength, edge;
                var edgeIndices = this.physicsBody.physicsEdgeIndices;
                var edges = this.body.edges;
                var node1, node2, node3; // forces caused by the edges, modelled as springs

                for (var i = 0; i < edgeIndices.length; i++) {
                    edge = edges[edgeIndices[i]];

                    if (edge.connected === true && edge.toId !== edge.fromId) {
                        // only calculate forces if nodes are in the same sector
                        if (this.body.nodes[edge.toId] !== undefined && this.body.nodes[edge.fromId] !== undefined) {
                            if (edge.edgeType.via !== undefined) {
                                edgeLength = edge.options.length === undefined ? this.options.springLength : edge.options.length;
                                node1 = edge.to;
                                node2 = edge.edgeType.via;
                                node3 = edge.from;

                                this._calculateSpringForce(node1, node2, 0.5 * edgeLength);

                                this._calculateSpringForce(node2, node3, 0.5 * edgeLength);
                            } else {
                                // the * 1.5 is here so the edge looks as large as a smooth edge. It does not initially because the smooth edges use
                                // the support nodes which exert a repulsive force on the to and from nodes, making the edge appear larger.
                                edgeLength = edge.options.length === undefined ? this.options.springLength * 1.5 : edge.options.length;

                                this._calculateSpringForce(edge.from, edge.to, edgeLength);
                            }
                        }
                    }
                }
            }
            /**
             * This is the code actually performing the calculation for the function above.
             *
             * @param {Node} node1
             * @param {Node} node2
             * @param {number} edgeLength
             * @private
             */

        }, {
            key: "_calculateSpringForce",
            value: function _calculateSpringForce(node1, node2, edgeLength) {
                var dx = node1.x - node2.x;
                var dy = node1.y - node2.y;
                var distance = Math.max(Math.sqrt(dx * dx + dy * dy), 0.01); // the 1/distance is so the fx and fy can be calculated without sine or cosine.

                var springForce = this.options.springConstant * (edgeLength - distance) / distance;
                var fx = dx * springForce;
                var fy = dy * springForce; // handle the case where one node is not part of the physcis

                if (this.physicsBody.forces[node1.id] !== undefined) {
                    this.physicsBody.forces[node1.id].x += fx;
                    this.physicsBody.forces[node1.id].y += fy;
                }

                if (this.physicsBody.forces[node2.id] !== undefined) {
                    this.physicsBody.forces[node2.id].x -= fx;
                    this.physicsBody.forces[node2.id].y -= fy;
                }
            }
        }]);

        return SpringSolver;
    }();

    /**
     * Hierarchical Spring Solver
     */
    var HierarchicalSpringSolver = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
         * @param {object} options
         */
        function HierarchicalSpringSolver(body, physicsBody, options) {
            _classCallCheck(this, HierarchicalSpringSolver);

            this.body = body;
            this.physicsBody = physicsBody;
            this.setOptions(options);
        }
        /**
         *
         * @param {object} options
         */


        _createClass(HierarchicalSpringSolver, [{
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
            }
            /**
             * This function calculates the springforces on the nodes, accounting for the support nodes.
             *
             * @private
             */

        }, {
            key: "solve",
            value: function solve() {
                var edgeLength, edge;
                var dx, dy, fx, fy, springForce, distance;
                var edges = this.body.edges;
                var factor = 0.5;
                var edgeIndices = this.physicsBody.physicsEdgeIndices;
                var nodeIndices = this.physicsBody.physicsNodeIndices;
                var forces = this.physicsBody.forces; // initialize the spring force counters

                for (var i = 0; i < nodeIndices.length; i++) {
                    var nodeId = nodeIndices[i];
                    forces[nodeId].springFx = 0;
                    forces[nodeId].springFy = 0;
                } // forces caused by the edges, modelled as springs


                for (var _i = 0; _i < edgeIndices.length; _i++) {
                    edge = edges[edgeIndices[_i]];

                    if (edge.connected === true) {
                        edgeLength = edge.options.length === undefined ? this.options.springLength : edge.options.length;
                        dx = edge.from.x - edge.to.x;
                        dy = edge.from.y - edge.to.y;
                        distance = Math.sqrt(dx * dx + dy * dy);
                        distance = distance === 0 ? 0.01 : distance; // the 1/distance is so the fx and fy can be calculated without sine or cosine.

                        springForce = this.options.springConstant * (edgeLength - distance) / distance;
                        fx = dx * springForce;
                        fy = dy * springForce;

                        if (edge.to.level != edge.from.level) {
                            if (forces[edge.toId] !== undefined) {
                                forces[edge.toId].springFx -= fx;
                                forces[edge.toId].springFy -= fy;
                            }

                            if (forces[edge.fromId] !== undefined) {
                                forces[edge.fromId].springFx += fx;
                                forces[edge.fromId].springFy += fy;
                            }
                        } else {
                            if (forces[edge.toId] !== undefined) {
                                forces[edge.toId].x -= factor * fx;
                                forces[edge.toId].y -= factor * fy;
                            }

                            if (forces[edge.fromId] !== undefined) {
                                forces[edge.fromId].x += factor * fx;
                                forces[edge.fromId].y += factor * fy;
                            }
                        }
                    }
                } // normalize spring forces


                springForce = 1;
                var springFx, springFy;

                for (var _i2 = 0; _i2 < nodeIndices.length; _i2++) {
                    var _nodeId = nodeIndices[_i2];
                    springFx = Math.min(springForce, Math.max(-springForce, forces[_nodeId].springFx));
                    springFy = Math.min(springForce, Math.max(-springForce, forces[_nodeId].springFy));
                    forces[_nodeId].x += springFx;
                    forces[_nodeId].y += springFy;
                } // retain energy balance


                var totalFx = 0;
                var totalFy = 0;

                for (var _i3 = 0; _i3 < nodeIndices.length; _i3++) {
                    var _nodeId2 = nodeIndices[_i3];
                    totalFx += forces[_nodeId2].x;
                    totalFy += forces[_nodeId2].y;
                }

                var correctionFx = totalFx / nodeIndices.length;
                var correctionFy = totalFy / nodeIndices.length;

                for (var _i4 = 0; _i4 < nodeIndices.length; _i4++) {
                    var _nodeId3 = nodeIndices[_i4];
                    forces[_nodeId3].x -= correctionFx;
                    forces[_nodeId3].y -= correctionFy;
                }
            }
        }]);

        return HierarchicalSpringSolver;
    }();

    /**
     * Central Gravity Solver
     */
    var CentralGravitySolver = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
         * @param {object} options
         */
        function CentralGravitySolver(body, physicsBody, options) {
            _classCallCheck(this, CentralGravitySolver);

            this.body = body;
            this.physicsBody = physicsBody;
            this.setOptions(options);
        }
        /**
         *
         * @param {object} options
         */


        _createClass(CentralGravitySolver, [{
            key: "setOptions",
            value: function setOptions(options) {
                this.options = options;
            }
            /**
             * Calculates forces for each node
             */

        }, {
            key: "solve",
            value: function solve() {
                var dx, dy, distance, node;
                var nodes = this.body.nodes;
                var nodeIndices = this.physicsBody.physicsNodeIndices;
                var forces = this.physicsBody.forces;

                for (var i = 0; i < nodeIndices.length; i++) {
                    var nodeId = nodeIndices[i];
                    node = nodes[nodeId];
                    dx = -node.x;
                    dy = -node.y;
                    distance = Math.sqrt(dx * dx + dy * dy);

                    this._calculateForces(distance, dx, dy, forces, node);
                }
            }
            /**
             * Calculate the forces based on the distance.
             *
             * @param {number} distance
             * @param {number} dx
             * @param {number} dy
             * @param {object<Node.id, vis.Node>} forces
             * @param {Node} node
             * @private
             */

        }, {
            key: "_calculateForces",
            value: function _calculateForces(distance, dx, dy, forces, node) {
                var gravityForce = distance === 0 ? 0 : this.options.centralGravity / distance;
                forces[node.id].x = dx * gravityForce;
                forces[node.id].y = dy * gravityForce;
            }
        }]);

        return CentralGravitySolver;
    }();

    function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * @augments BarnesHutSolver
     */

    var ForceAtlas2BasedRepulsionSolver = /*#__PURE__*/function (_BarnesHutSolver) {
        _inherits(ForceAtlas2BasedRepulsionSolver, _BarnesHutSolver);

        var _super = _createSuper$3(ForceAtlas2BasedRepulsionSolver);

        /**
         * @param {object} body
         * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
         * @param {object} options
         */
        function ForceAtlas2BasedRepulsionSolver(body, physicsBody, options) {
            var _this;

            _classCallCheck(this, ForceAtlas2BasedRepulsionSolver);

            _this = _super.call(this, body, physicsBody, options);
            _this._rng = Alea("FORCE ATLAS 2 BASED REPULSION SOLVER");
            return _this;
        }
        /**
         * Calculate the forces based on the distance.
         *
         * @param {number} distance
         * @param {number} dx
         * @param {number} dy
         * @param {Node} node
         * @param {object} parentBranch
         * @private
         */


        _createClass(ForceAtlas2BasedRepulsionSolver, [{
            key: "_calculateForces",
            value: function _calculateForces(distance, dx, dy, node, parentBranch) {
                if (distance === 0) {
                    distance = 0.1 * this._rng();
                    dx = distance;
                }

                if (this.overlapAvoidanceFactor < 1 && node.shape.radius) {
                    distance = Math.max(0.1 + this.overlapAvoidanceFactor * node.shape.radius, distance - node.shape.radius);
                }

                var degree = node.edges.length + 1; // the dividing by the distance cubed instead of squared allows us to get the fx and fy components without sines and cosines
                // it is shorthand for gravityforce with distance squared and fx = dx/distance * gravityForce

                var gravityForce = this.options.gravitationalConstant * parentBranch.mass * node.options.mass * degree / Math.pow(distance, 2);
                var fx = dx * gravityForce;
                var fy = dy * gravityForce;
                this.physicsBody.forces[node.id].x += fx;
                this.physicsBody.forces[node.id].y += fy;
            }
        }]);

        return ForceAtlas2BasedRepulsionSolver;
    }(BarnesHutSolver);

    function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * @augments CentralGravitySolver
     */

    var ForceAtlas2BasedCentralGravitySolver = /*#__PURE__*/function (_CentralGravitySolver) {
        _inherits(ForceAtlas2BasedCentralGravitySolver, _CentralGravitySolver);

        var _super = _createSuper$2(ForceAtlas2BasedCentralGravitySolver);

        /**
         * @param {object} body
         * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
         * @param {object} options
         */
        function ForceAtlas2BasedCentralGravitySolver(body, physicsBody, options) {
            _classCallCheck(this, ForceAtlas2BasedCentralGravitySolver);

            return _super.call(this, body, physicsBody, options);
        }
        /**
         * Calculate the forces based on the distance.
         *
         * @param {number} distance
         * @param {number} dx
         * @param {number} dy
         * @param {object<Node.id, Node>} forces
         * @param {Node} node
         * @private
         */


        _createClass(ForceAtlas2BasedCentralGravitySolver, [{
            key: "_calculateForces",
            value: function _calculateForces(distance, dx, dy, forces, node) {
                if (distance > 0) {
                    var degree = node.edges.length + 1;
                    var gravityForce = this.options.centralGravity * degree * node.options.mass;
                    forces[node.id].x = dx * gravityForce;
                    forces[node.id].y = dy * gravityForce;
                }
            }
        }]);

        return ForceAtlas2BasedCentralGravitySolver;
    }(CentralGravitySolver);

    /**
     * The physics engine
     */

    var PhysicsEngine = /*#__PURE__*/function () {
        /**
         * @param {object} body
         */
        function PhysicsEngine(body) {
            _classCallCheck(this, PhysicsEngine);

            this.body = body;
            this.physicsBody = {
                physicsNodeIndices: [],
                physicsEdgeIndices: [],
                forces: {},
                velocities: {}
            };
            this.physicsEnabled = true;
            this.simulationInterval = 1000 / 60;
            this.requiresTimeout = true;
            this.previousStates = {};
            this.referenceState = {};
            this.freezeCache = {};
            this.renderTimer = undefined; // parameters for the adaptive timestep

            this.adaptiveTimestep = false;
            this.adaptiveTimestepEnabled = false;
            this.adaptiveCounter = 0;
            this.adaptiveInterval = 3;
            this.stabilized = false;
            this.startedStabilization = false;
            this.stabilizationIterations = 0;
            this.ready = false; // will be set to true if the stabilize
            // default options

            this.options = {};
            this.defaultOptions = {
                enabled: true,
                barnesHut: {
                    theta: 0.5,
                    gravitationalConstant: -2000,
                    centralGravity: 0.3,
                    springLength: 95,
                    springConstant: 0.04,
                    damping: 0.09,
                    avoidOverlap: 0
                },
                forceAtlas2Based: {
                    theta: 0.5,
                    gravitationalConstant: -50,
                    centralGravity: 0.01,
                    springConstant: 0.08,
                    springLength: 100,
                    damping: 0.4,
                    avoidOverlap: 0
                },
                repulsion: {
                    centralGravity: 0.2,
                    springLength: 200,
                    springConstant: 0.05,
                    nodeDistance: 100,
                    damping: 0.09,
                    avoidOverlap: 0
                },
                hierarchicalRepulsion: {
                    centralGravity: 0.0,
                    springLength: 100,
                    springConstant: 0.01,
                    nodeDistance: 120,
                    damping: 0.09
                },
                maxVelocity: 50,
                minVelocity: 0.75,
                // px/s
                solver: "barnesHut",
                stabilization: {
                    enabled: true,
                    iterations: 1000,
                    // maximum number of iteration to stabilize
                    updateInterval: 50,
                    onlyDynamicEdges: false,
                    fit: true
                },
                timestep: 0.5,
                adaptiveTimestep: true,
                wind: {
                    x: 0,
                    y: 0
                }
            };

            assign$2(this.options, this.defaultOptions);

            this.timestep = 0.5;
            this.layoutFailed = false;
            this.bindEventListeners();
        }
        /**
         * Binds event listeners
         */


        _createClass(PhysicsEngine, [{
            key: "bindEventListeners",
            value: function bindEventListeners() {
                var _this = this;

                this.body.emitter.on("initPhysics", function () {
                    _this.initPhysics();
                });
                this.body.emitter.on("_layoutFailed", function () {
                    _this.layoutFailed = true;
                });
                this.body.emitter.on("resetPhysics", function () {
                    _this.stopSimulation();

                    _this.ready = false;
                });
                this.body.emitter.on("disablePhysics", function () {
                    _this.physicsEnabled = false;

                    _this.stopSimulation();
                });
                this.body.emitter.on("restorePhysics", function () {
                    _this.setOptions(_this.options);

                    if (_this.ready === true) {
                        _this.startSimulation();
                    }
                });
                this.body.emitter.on("startSimulation", function () {
                    if (_this.ready === true) {
                        _this.startSimulation();
                    }
                });
                this.body.emitter.on("stopSimulation", function () {
                    _this.stopSimulation();
                });
                this.body.emitter.on("destroy", function () {
                    _this.stopSimulation(false);

                    _this.body.emitter.off();
                });
                this.body.emitter.on("_dataChanged", function () {
                    // Nodes and/or edges have been added or removed, update shortcut lists.
                    _this.updatePhysicsData();
                }); // debug: show forces
                // this.body.emitter.on("afterDrawing", (ctx) => {this._drawForces(ctx);});
            }
            /**
             * set the physics options
             *
             * @param {object} options
             */

        }, {
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    if (options === false) {
                        this.options.enabled = false;
                        this.physicsEnabled = false;
                        this.stopSimulation();
                    } else if (options === true) {
                        this.options.enabled = true;
                        this.physicsEnabled = true;
                        this.startSimulation();
                    } else {
                        this.physicsEnabled = true;
                        selectiveNotDeepExtend(["stabilization"], this.options, options);
                        mergeOptions(this.options, options, "stabilization");

                        if (options.enabled === undefined) {
                            this.options.enabled = true;
                        }

                        if (this.options.enabled === false) {
                            this.physicsEnabled = false;
                            this.stopSimulation();
                        }

                        var wind = this.options.wind;

                        if (wind) {
                            if (typeof wind.x !== "number" || isNan(wind.x)) {
                                wind.x = 0;
                            }

                            if (typeof wind.y !== "number" || isNan(wind.y)) {
                                wind.y = 0;
                            }
                        } // set the timestep


                        this.timestep = this.options.timestep;
                    }
                }

                this.init();
            }
            /**
             * configure the engine.
             */

        }, {
            key: "init",
            value: function init() {
                var options;

                if (this.options.solver === "forceAtlas2Based") {
                    options = this.options.forceAtlas2Based;
                    this.nodesSolver = new ForceAtlas2BasedRepulsionSolver(this.body, this.physicsBody, options);
                    this.edgesSolver = new SpringSolver(this.body, this.physicsBody, options);
                    this.gravitySolver = new ForceAtlas2BasedCentralGravitySolver(this.body, this.physicsBody, options);
                } else if (this.options.solver === "repulsion") {
                    options = this.options.repulsion;
                    this.nodesSolver = new RepulsionSolver(this.body, this.physicsBody, options);
                    this.edgesSolver = new SpringSolver(this.body, this.physicsBody, options);
                    this.gravitySolver = new CentralGravitySolver(this.body, this.physicsBody, options);
                } else if (this.options.solver === "hierarchicalRepulsion") {
                    options = this.options.hierarchicalRepulsion;
                    this.nodesSolver = new HierarchicalRepulsionSolver(this.body, this.physicsBody, options);
                    this.edgesSolver = new HierarchicalSpringSolver(this.body, this.physicsBody, options);
                    this.gravitySolver = new CentralGravitySolver(this.body, this.physicsBody, options);
                } else {
                    // barnesHut
                    options = this.options.barnesHut;
                    this.nodesSolver = new BarnesHutSolver(this.body, this.physicsBody, options);
                    this.edgesSolver = new SpringSolver(this.body, this.physicsBody, options);
                    this.gravitySolver = new CentralGravitySolver(this.body, this.physicsBody, options);
                }

                this.modelOptions = options;
            }
            /**
             * initialize the engine
             */

        }, {
            key: "initPhysics",
            value: function initPhysics() {
                if (this.physicsEnabled === true && this.options.enabled === true) {
                    if (this.options.stabilization.enabled === true) {
                        this.stabilize();
                    } else {
                        this.stabilized = false;
                        this.ready = true;
                        this.body.emitter.emit("fit", {}, this.layoutFailed); // if the layout failed, we use the approximation for the zoom

                        this.startSimulation();
                    }
                } else {
                    this.ready = true;
                    this.body.emitter.emit("fit");
                }
            }
            /**
             * Start the simulation
             */

        }, {
            key: "startSimulation",
            value: function startSimulation() {
                if (this.physicsEnabled === true && this.options.enabled === true) {
                    this.stabilized = false; // when visible, adaptivity is disabled.

                    this.adaptiveTimestep = false; // this sets the width of all nodes initially which could be required for the avoidOverlap

                    this.body.emitter.emit("_resizeNodes");

                    if (this.viewFunction === undefined) {
                        var _context;

                        this.viewFunction = bind(_context = this.simulationStep).call(_context, this);
                        this.body.emitter.on("initRedraw", this.viewFunction);
                        this.body.emitter.emit("_startRendering");
                    }
                } else {
                    this.body.emitter.emit("_redraw");
                }
            }
            /**
             * Stop the simulation, force stabilization.
             *
             * @param {boolean} [emit=true]
             */

        }, {
            key: "stopSimulation",
            value: function stopSimulation() {
                var emit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                this.stabilized = true;

                if (emit === true) {
                    this._emitStabilized();
                }

                if (this.viewFunction !== undefined) {
                    this.body.emitter.off("initRedraw", this.viewFunction);
                    this.viewFunction = undefined;

                    if (emit === true) {
                        this.body.emitter.emit("_stopRendering");
                    }
                }
            }
            /**
             * The viewFunction inserts this step into each render loop. It calls the physics tick and handles the cleanup at stabilized.
             *
             */

        }, {
            key: "simulationStep",
            value: function simulationStep() {
                // check if the physics have settled
                var startTime = now$1();

                this.physicsTick();
                var physicsTime = now$1() - startTime; // run double speed if it is a little graph

                if ((physicsTime < 0.4 * this.simulationInterval || this.runDoubleSpeed === true) && this.stabilized === false) {
                    this.physicsTick(); // this makes sure there is no jitter. The decision is taken once to run it at double speed.

                    this.runDoubleSpeed = true;
                }

                if (this.stabilized === true) {
                    this.stopSimulation();
                }
            }
            /**
             * trigger the stabilized event.
             *
             * @param {number} [amountOfIterations=this.stabilizationIterations]
             * @private
             */

        }, {
            key: "_emitStabilized",
            value: function _emitStabilized() {
                var _this2 = this;

                var amountOfIterations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.stabilizationIterations;

                if (this.stabilizationIterations > 1 || this.startedStabilization === true) {
                    setTimeout$1(function () {
                        _this2.body.emitter.emit("stabilized", {
                            iterations: amountOfIterations
                        });

                        _this2.startedStabilization = false;
                        _this2.stabilizationIterations = 0;
                    }, 0);
                }
            }
            /**
             * Calculate the forces for one physics iteration and move the nodes.
             *
             * @private
             */

        }, {
            key: "physicsStep",
            value: function physicsStep() {
                this.gravitySolver.solve();
                this.nodesSolver.solve();
                this.edgesSolver.solve();
                this.moveNodes();
            }
            /**
             * Make dynamic adjustments to the timestep, based on current state.
             *
             * Helper function for physicsTick().
             *
             * @private
             */

        }, {
            key: "adjustTimeStep",
            value: function adjustTimeStep() {
                var factor = 1.2; // Factor for increasing the timestep on success.
                // we compare the two steps. if it is acceptable we double the step.

                if (this._evaluateStepQuality() === true) {
                    this.timestep = factor * this.timestep;
                } else {
                    // if not, we decrease the step to a minimum of the options timestep.
                    // if the decreased timestep is smaller than the options step, we do not reset the counter
                    // we assume that the options timestep is stable enough.
                    if (this.timestep / factor < this.options.timestep) {
                        this.timestep = this.options.timestep;
                    } else {
                        // if the timestep was larger than 2 times the option one we check the adaptivity again to ensure
                        // that large instabilities do not form.
                        this.adaptiveCounter = -1; // check again next iteration

                        this.timestep = Math.max(this.options.timestep, this.timestep / factor);
                    }
                }
            }
            /**
             * A single simulation step (or 'tick') in the physics simulation
             *
             * @private
             */

        }, {
            key: "physicsTick",
            value: function physicsTick() {
                this._startStabilizing(); // this ensures that there is no start event when the network is already stable.


                if (this.stabilized === true) return; // adaptivity means the timestep adapts to the situation, only applicable for stabilization

                if (this.adaptiveTimestep === true && this.adaptiveTimestepEnabled === true) {
                    // timestep remains stable for "interval" iterations.
                    var doAdaptive = this.adaptiveCounter % this.adaptiveInterval === 0;

                    if (doAdaptive) {
                        // first the big step and revert.
                        this.timestep = 2 * this.timestep;
                        this.physicsStep();
                        this.revert(); // saves the reference state
                        // now the normal step. Since this is the last step, it is the more stable one and we will take this.

                        this.timestep = 0.5 * this.timestep; // since it's half the step, we do it twice.

                        this.physicsStep();
                        this.physicsStep();
                        this.adjustTimeStep();
                    } else {
                        this.physicsStep(); // normal step, keeping timestep constant
                    }

                    this.adaptiveCounter += 1;
                } else {
                    // case for the static timestep, we reset it to the one in options and take a normal step.
                    this.timestep = this.options.timestep;
                    this.physicsStep();
                }

                if (this.stabilized === true) this.revert();
                this.stabilizationIterations++;
            }
            /**
             * Nodes and edges can have the physics toggles on or off. A collection of indices is created here so we can skip the check all the time.
             *
             * @private
             */

        }, {
            key: "updatePhysicsData",
            value: function updatePhysicsData() {
                this.physicsBody.forces = {};
                this.physicsBody.physicsNodeIndices = [];
                this.physicsBody.physicsEdgeIndices = [];
                var nodes = this.body.nodes;
                var edges = this.body.edges; // get node indices for physics

                for (var nodeId in nodes) {
                    if (Object.prototype.hasOwnProperty.call(nodes, nodeId)) {
                        if (nodes[nodeId].options.physics === true) {
                            this.physicsBody.physicsNodeIndices.push(nodes[nodeId].id);
                        }
                    }
                } // get edge indices for physics


                for (var edgeId in edges) {
                    if (Object.prototype.hasOwnProperty.call(edges, edgeId)) {
                        if (edges[edgeId].options.physics === true) {
                            this.physicsBody.physicsEdgeIndices.push(edges[edgeId].id);
                        }
                    }
                } // get the velocity and the forces vector


                for (var i = 0; i < this.physicsBody.physicsNodeIndices.length; i++) {
                    var _nodeId = this.physicsBody.physicsNodeIndices[i];
                    this.physicsBody.forces[_nodeId] = {
                        x: 0,
                        y: 0
                    }; // forces can be reset because they are recalculated. Velocities have to persist.

                    if (this.physicsBody.velocities[_nodeId] === undefined) {
                        this.physicsBody.velocities[_nodeId] = {
                            x: 0,
                            y: 0
                        };
                    }
                } // clean deleted nodes from the velocity vector


                for (var _nodeId2 in this.physicsBody.velocities) {
                    if (nodes[_nodeId2] === undefined) {
                        delete this.physicsBody.velocities[_nodeId2];
                    }
                }
            }
            /**
             * Revert the simulation one step. This is done so after stabilization, every new start of the simulation will also say stabilized.
             */

        }, {
            key: "revert",
            value: function revert() {
                var nodeIds = keys$3(this.previousStates);

                var nodes = this.body.nodes;
                var velocities = this.physicsBody.velocities;
                this.referenceState = {};

                for (var i = 0; i < nodeIds.length; i++) {
                    var nodeId = nodeIds[i];

                    if (nodes[nodeId] !== undefined) {
                        if (nodes[nodeId].options.physics === true) {
                            this.referenceState[nodeId] = {
                                positions: {
                                    x: nodes[nodeId].x,
                                    y: nodes[nodeId].y
                                }
                            };
                            velocities[nodeId].x = this.previousStates[nodeId].vx;
                            velocities[nodeId].y = this.previousStates[nodeId].vy;
                            nodes[nodeId].x = this.previousStates[nodeId].x;
                            nodes[nodeId].y = this.previousStates[nodeId].y;
                        }
                    } else {
                        delete this.previousStates[nodeId];
                    }
                }
            }
            /**
             * This compares the reference state to the current state
             *
             * @returns {boolean}
             * @private
             */

        }, {
            key: "_evaluateStepQuality",
            value: function _evaluateStepQuality() {
                var dx, dy, dpos;
                var nodes = this.body.nodes;
                var reference = this.referenceState;
                var posThreshold = 0.3;

                for (var nodeId in this.referenceState) {
                    if (Object.prototype.hasOwnProperty.call(this.referenceState, nodeId) && nodes[nodeId] !== undefined) {
                        dx = nodes[nodeId].x - reference[nodeId].positions.x;
                        dy = nodes[nodeId].y - reference[nodeId].positions.y;
                        dpos = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));

                        if (dpos > posThreshold) {
                            return false;
                        }
                    }
                }

                return true;
            }
            /**
             * move the nodes one timestep and check if they are stabilized
             */

        }, {
            key: "moveNodes",
            value: function moveNodes() {
                var nodeIndices = this.physicsBody.physicsNodeIndices;
                var maxNodeVelocity = 0;
                var averageNodeVelocity = 0; // the velocity threshold (energy in the system) for the adaptivity toggle

                var velocityAdaptiveThreshold = 5;

                for (var i = 0; i < nodeIndices.length; i++) {
                    var nodeId = nodeIndices[i];

                    var nodeVelocity = this._performStep(nodeId); // stabilized is true if stabilized is true and velocity is smaller than vmin --> all nodes must be stabilized


                    maxNodeVelocity = Math.max(maxNodeVelocity, nodeVelocity);
                    averageNodeVelocity += nodeVelocity;
                } // evaluating the stabilized and adaptiveTimestepEnabled conditions


                this.adaptiveTimestepEnabled = averageNodeVelocity / nodeIndices.length < velocityAdaptiveThreshold;
                this.stabilized = maxNodeVelocity < this.options.minVelocity;
            }
            /**
             * Calculate new velocity for a coordinate direction
             *
             * @param {number} v  velocity for current coordinate
             * @param {number} f  regular force for current coordinate
             * @param {number} m  mass of current node
             * @returns {number} new velocity for current coordinate
             * @private
             */

        }, {
            key: "calculateComponentVelocity",
            value: function calculateComponentVelocity(v, f, m) {
                var df = this.modelOptions.damping * v; // damping force

                var a = (f - df) / m; // acceleration

                v += a * this.timestep; // Put a limit on the velocities if it is really high

                var maxV = this.options.maxVelocity || 1e9;

                if (Math.abs(v) > maxV) {
                    v = v > 0 ? maxV : -maxV;
                }

                return v;
            }
            /**
             * Perform the actual step
             *
             * @param {Node.id} nodeId
             * @returns {number} the new velocity of given node
             * @private
             */

        }, {
            key: "_performStep",
            value: function _performStep(nodeId) {
                var node = this.body.nodes[nodeId];
                var force = this.physicsBody.forces[nodeId];

                if (this.options.wind) {
                    force.x += this.options.wind.x;
                    force.y += this.options.wind.y;
                }

                var velocity = this.physicsBody.velocities[nodeId]; // store the state so we can revert

                this.previousStates[nodeId] = {
                    x: node.x,
                    y: node.y,
                    vx: velocity.x,
                    vy: velocity.y
                };

                if (node.options.fixed.x === false) {
                    velocity.x = this.calculateComponentVelocity(velocity.x, force.x, node.options.mass);
                    node.x += velocity.x * this.timestep;
                } else {
                    force.x = 0;
                    velocity.x = 0;
                }

                if (node.options.fixed.y === false) {
                    velocity.y = this.calculateComponentVelocity(velocity.y, force.y, node.options.mass);
                    node.y += velocity.y * this.timestep;
                } else {
                    force.y = 0;
                    velocity.y = 0;
                }

                var totalVelocity = Math.sqrt(Math.pow(velocity.x, 2) + Math.pow(velocity.y, 2));
                return totalVelocity;
            }
            /**
             * When initializing and stabilizing, we can freeze nodes with a predefined position.
             * This greatly speeds up stabilization because only the supportnodes for the smoothCurves have to settle.
             *
             * @private
             */

        }, {
            key: "_freezeNodes",
            value: function _freezeNodes() {
                var nodes = this.body.nodes;

                for (var id in nodes) {
                    if (Object.prototype.hasOwnProperty.call(nodes, id)) {
                        if (nodes[id].x && nodes[id].y) {
                            var fixed = nodes[id].options.fixed;
                            this.freezeCache[id] = {
                                x: fixed.x,
                                y: fixed.y
                            };
                            fixed.x = true;
                            fixed.y = true;
                        }
                    }
                }
            }
            /**
             * Unfreezes the nodes that have been frozen by _freezeDefinedNodes.
             *
             * @private
             */

        }, {
            key: "_restoreFrozenNodes",
            value: function _restoreFrozenNodes() {
                var nodes = this.body.nodes;

                for (var id in nodes) {
                    if (Object.prototype.hasOwnProperty.call(nodes, id)) {
                        if (this.freezeCache[id] !== undefined) {
                            nodes[id].options.fixed.x = this.freezeCache[id].x;
                            nodes[id].options.fixed.y = this.freezeCache[id].y;
                        }
                    }
                }

                this.freezeCache = {};
            }
            /**
             * Find a stable position for all nodes
             *
             * @param {number} [iterations=this.options.stabilization.iterations]
             */

        }, {
            key: "stabilize",
            value: function stabilize() {
                var _this3 = this;

                var iterations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.stabilization.iterations;

                if (typeof iterations !== "number") {
                    iterations = this.options.stabilization.iterations;
                    console.error("The stabilize method needs a numeric amount of iterations. Switching to default: ", iterations);
                }

                if (this.physicsBody.physicsNodeIndices.length === 0) {
                    this.ready = true;
                    return;
                } // enable adaptive timesteps


                this.adaptiveTimestep = this.options.adaptiveTimestep; // this sets the width of all nodes initially which could be required for the avoidOverlap

                this.body.emitter.emit("_resizeNodes");
                this.stopSimulation(); // stop the render loop

                this.stabilized = false; // block redraw requests

                this.body.emitter.emit("_blockRedraw");
                this.targetIterations = iterations; // start the stabilization

                if (this.options.stabilization.onlyDynamicEdges === true) {
                    this._freezeNodes();
                }

                this.stabilizationIterations = 0;

                setTimeout$1(function () {
                    return _this3._stabilizationBatch();
                }, 0);
            }
            /**
             * If not already stabilizing, start it and emit a start event.
             *
             * @returns {boolean} true if stabilization started with this call
             * @private
             */

        }, {
            key: "_startStabilizing",
            value: function _startStabilizing() {
                if (this.startedStabilization === true) return false;
                this.body.emitter.emit("startStabilizing");
                this.startedStabilization = true;
                return true;
            }
            /**
             * One batch of stabilization
             *
             * @private
             */

        }, {
            key: "_stabilizationBatch",
            value: function _stabilizationBatch() {
                var _this4 = this;

                var running = function running() {
                    return _this4.stabilized === false && _this4.stabilizationIterations < _this4.targetIterations;
                };

                var sendProgress = function sendProgress() {
                    _this4.body.emitter.emit("stabilizationProgress", {
                        iterations: _this4.stabilizationIterations,
                        total: _this4.targetIterations
                    });
                };

                if (this._startStabilizing()) {
                    sendProgress(); // Ensure that there is at least one start event.
                }

                var count = 0;

                while (running() && count < this.options.stabilization.updateInterval) {
                    this.physicsTick();
                    count++;
                }

                sendProgress();

                if (running()) {
                    var _context2;

                    setTimeout$1(bind(_context2 = this._stabilizationBatch).call(_context2, this), 0);
                } else {
                    this._finalizeStabilization();
                }
            }
            /**
             * Wrap up the stabilization, fit and emit the events.
             *
             * @private
             */

        }, {
            key: "_finalizeStabilization",
            value: function _finalizeStabilization() {
                this.body.emitter.emit("_allowRedraw");

                if (this.options.stabilization.fit === true) {
                    this.body.emitter.emit("fit");
                }

                if (this.options.stabilization.onlyDynamicEdges === true) {
                    this._restoreFrozenNodes();
                }

                this.body.emitter.emit("stabilizationIterationsDone");
                this.body.emitter.emit("_requestRedraw");

                if (this.stabilized === true) {
                    this._emitStabilized();
                } else {
                    this.startSimulation();
                }

                this.ready = true;
            } //---------------------------  DEBUGGING BELOW  ---------------------------//

            /**
             * Debug function that display arrows for the forces currently active in the network.
             *
             * Use this when debugging only.
             *
             * @param {CanvasRenderingContext2D} ctx
             * @private
             */

        }, {
            key: "_drawForces",
            value: function _drawForces(ctx) {
                for (var i = 0; i < this.physicsBody.physicsNodeIndices.length; i++) {
                    var index = this.physicsBody.physicsNodeIndices[i];
                    var node = this.body.nodes[index];
                    var force = this.physicsBody.forces[index];
                    var factor = 20;
                    var colorFactor = 0.03;
                    var forceSize = Math.sqrt(Math.pow(force.x, 2) + Math.pow(force.x, 2));
                    var size = Math.min(Math.max(5, forceSize), 15);
                    var arrowSize = 3 * size;
                    var color = HSVToHex((180 - Math.min(1, Math.max(0, colorFactor * forceSize)) * 180) / 360, 1, 1);
                    var point = {
                        x: node.x + factor * force.x,
                        y: node.y + factor * force.y
                    };
                    ctx.lineWidth = size;
                    ctx.strokeStyle = color;
                    ctx.beginPath();
                    ctx.moveTo(node.x, node.y);
                    ctx.lineTo(point.x, point.y);
                    ctx.stroke();
                    var angle = Math.atan2(force.y, force.x);
                    ctx.fillStyle = color;
                    EndPoints.draw(ctx, {
                        type: "arrow",
                        point: point,
                        angle: angle,
                        length: arrowSize
                    });

                    fill(ctx).call(ctx);
                }
            }
        }]);

        return PhysicsEngine;
    }();

    /**
     * Utility Class
     */

    var NetworkUtil = /*#__PURE__*/function () {
        /**
         * @ignore
         */
        function NetworkUtil() {
            _classCallCheck(this, NetworkUtil);
        }
        /**
         * Find the center position of the network considering the bounding boxes
         *
         * @param {Array.<Node>} allNodes
         * @param {Array.<Node>} [specificNodes=[]]
         * @returns {{minX: number, maxX: number, minY: number, maxY: number}}
         * @static
         */


        _createClass(NetworkUtil, null, [{
            key: "getRange",
            value: function getRange(allNodes) {
                var specificNodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var minY = 1e9,
                    maxY = -1e9,
                    minX = 1e9,
                    maxX = -1e9,
                    node;

                if (specificNodes.length > 0) {
                    for (var i = 0; i < specificNodes.length; i++) {
                        node = allNodes[specificNodes[i]];

                        if (minX > node.shape.boundingBox.left) {
                            minX = node.shape.boundingBox.left;
                        }

                        if (maxX < node.shape.boundingBox.right) {
                            maxX = node.shape.boundingBox.right;
                        }

                        if (minY > node.shape.boundingBox.top) {
                            minY = node.shape.boundingBox.top;
                        } // top is negative, bottom is positive


                        if (maxY < node.shape.boundingBox.bottom) {
                            maxY = node.shape.boundingBox.bottom;
                        } // top is negative, bottom is positive

                    }
                }

                if (minX === 1e9 && maxX === -1e9 && minY === 1e9 && maxY === -1e9) {
                    minY = 0, maxY = 0, minX = 0, maxX = 0;
                }

                return {
                    minX: minX,
                    maxX: maxX,
                    minY: minY,
                    maxY: maxY
                };
            }
            /**
             * Find the center position of the network
             *
             * @param {Array.<Node>} allNodes
             * @param {Array.<Node>} [specificNodes=[]]
             * @returns {{minX: number, maxX: number, minY: number, maxY: number}}
             * @static
             */

        }, {
            key: "getRangeCore",
            value: function getRangeCore(allNodes) {
                var specificNodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var minY = 1e9,
                    maxY = -1e9,
                    minX = 1e9,
                    maxX = -1e9,
                    node;

                if (specificNodes.length > 0) {
                    for (var i = 0; i < specificNodes.length; i++) {
                        node = allNodes[specificNodes[i]];

                        if (minX > node.x) {
                            minX = node.x;
                        }

                        if (maxX < node.x) {
                            maxX = node.x;
                        }

                        if (minY > node.y) {
                            minY = node.y;
                        } // top is negative, bottom is positive


                        if (maxY < node.y) {
                            maxY = node.y;
                        } // top is negative, bottom is positive

                    }
                }

                if (minX === 1e9 && maxX === -1e9 && minY === 1e9 && maxY === -1e9) {
                    minY = 0, maxY = 0, minX = 0, maxX = 0;
                }

                return {
                    minX: minX,
                    maxX: maxX,
                    minY: minY,
                    maxY: maxY
                };
            }
            /**
             * @param {object} range = {minX: minX, maxX: maxX, minY: minY, maxY: maxY};
             * @returns {{x: number, y: number}}
             * @static
             */

        }, {
            key: "findCenter",
            value: function findCenter(range) {
                return {
                    x: 0.5 * (range.maxX + range.minX),
                    y: 0.5 * (range.maxY + range.minY)
                };
            }
            /**
             * This returns a clone of the options or options of the edge or node to be used for construction of new edges or check functions for new nodes.
             *
             * @param {vis.Item} item
             * @param {'node'|undefined} type
             * @returns {{}}
             * @static
             */

        }, {
            key: "cloneOptions",
            value: function cloneOptions(item, type) {
                var clonedOptions = {};

                if (type === undefined || type === "node") {
                    deepExtend(clonedOptions, item.options, true);
                    clonedOptions.x = item.x;
                    clonedOptions.y = item.y;
                    clonedOptions.amountOfConnections = item.edges.length;
                } else {
                    deepExtend(clonedOptions, item.options, true);
                }

                return clonedOptions;
            }
        }]);

        return NetworkUtil;
    }();

    function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * A Cluster is a special Node that allows a group of Nodes positioned closely together
     * to be represented by a single Cluster Node.
     *
     * @augments Node
     */

    var Cluster = /*#__PURE__*/function (_Node) {
        _inherits(Cluster, _Node);

        var _super = _createSuper$1(Cluster);

        /**
         * @param {object} options
         * @param {object} body
         * @param {Array.<HTMLImageElement>}imagelist
         * @param {Array} grouplist
         * @param {object} globalOptions
         * @param {object} defaultOptions     Global default options for nodes
         */
        function Cluster(options, body, imagelist, grouplist, globalOptions, defaultOptions) {
            var _this;

            _classCallCheck(this, Cluster);

            _this = _super.call(this, options, body, imagelist, grouplist, globalOptions, defaultOptions);
            _this.isCluster = true;
            _this.containedNodes = {};
            _this.containedEdges = {};
            return _this;
        }
        /**
         * Transfer child cluster data to current and disconnect the child cluster.
         *
         * Please consult the header comment in 'Clustering.js' for the fields set here.
         *
         * @param {string|number} childClusterId  id of child cluster to open
         */


        _createClass(Cluster, [{
            key: "_openChildCluster",
            value: function _openChildCluster(childClusterId) {
                var _this2 = this;

                var childCluster = this.body.nodes[childClusterId];

                if (this.containedNodes[childClusterId] === undefined) {
                    throw new Error("node with id: " + childClusterId + " not in current cluster");
                }

                if (!childCluster.isCluster) {
                    throw new Error("node with id: " + childClusterId + " is not a cluster");
                } // Disconnect child cluster from current cluster


                delete this.containedNodes[childClusterId];
                forEach$1(childCluster.edges, function (edge) {
                    delete _this2.containedEdges[edge.id];
                }); // Transfer nodes and edges

                forEach$1(childCluster.containedNodes, function (node, nodeId) {
                    _this2.containedNodes[nodeId] = node;
                });
                childCluster.containedNodes = {};
                forEach$1(childCluster.containedEdges, function (edge, edgeId) {
                    _this2.containedEdges[edgeId] = edge;
                });
                childCluster.containedEdges = {}; // Transfer edges within cluster edges which are clustered

                forEach$1(childCluster.edges, function (clusterEdge) {
                    forEach$1(_this2.edges, function (parentClusterEdge) {
                        var _context, _context2;

                        // Assumption: a clustered edge can only be present in a single clustering edge
                        // Not tested here
                        var index = indexOf(_context = parentClusterEdge.clusteringEdgeReplacingIds).call(_context, clusterEdge.id);

                        if (index === -1) return;
                        forEach$1(clusterEdge.clusteringEdgeReplacingIds, function (srcId) {
                            parentClusterEdge.clusteringEdgeReplacingIds.push(srcId); // Maintain correct bookkeeping for transferred edge

                            _this2.body.edges[srcId].edgeReplacedById = parentClusterEdge.id;
                        }); // Remove cluster edge from parent cluster edge

                        splice(_context2 = parentClusterEdge.clusteringEdgeReplacingIds).call(_context2, index, 1);
                    });
                });
                childCluster.edges = [];
            }
        }]);

        return Cluster;
    }(Node);

    /**
     * The clustering engine
     */

    var ClusterEngine = /*#__PURE__*/function () {
        /**
         * @param {object} body
         */
        function ClusterEngine(body) {
            var _this = this;

            _classCallCheck(this, ClusterEngine);

            this.body = body;
            this.clusteredNodes = {}; // key: node id, value: { clusterId: <id of cluster>, node: <node instance>}

            this.clusteredEdges = {}; // key: edge id, value: restore information for given edge

            this.options = {};
            this.defaultOptions = {};

            assign$2(this.options, this.defaultOptions);

            this.body.emitter.on("_resetData", function () {
                _this.clusteredNodes = {};
                _this.clusteredEdges = {};
            });
        }
        /**
         *
         * @param {number} hubsize
         * @param {object} options
         */


        _createClass(ClusterEngine, [{
            key: "clusterByHubsize",
            value: function clusterByHubsize(hubsize, options) {
                if (hubsize === undefined) {
                    hubsize = this._getHubSize();
                } else if (_typeof(hubsize) === "object") {
                    options = this._checkOptions(hubsize);
                    hubsize = this._getHubSize();
                }

                var nodesToCluster = [];

                for (var i = 0; i < this.body.nodeIndices.length; i++) {
                    var node = this.body.nodes[this.body.nodeIndices[i]];

                    if (node.edges.length >= hubsize) {
                        nodesToCluster.push(node.id);
                    }
                }

                for (var _i = 0; _i < nodesToCluster.length; _i++) {
                    this.clusterByConnection(nodesToCluster[_i], options, true);
                }

                this.body.emitter.emit("_dataChanged");
            }
            /**
             * loop over all nodes, check if they adhere to the condition and cluster if needed.
             *
             * @param {object} options
             * @param {boolean} [refreshData=true]
             */

        }, {
            key: "cluster",
            value: function cluster() {
                var _this2 = this;

                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var refreshData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                if (options.joinCondition === undefined) {
                    throw new Error("Cannot call clusterByNodeData without a joinCondition function in the options.");
                } // check if the options object is fine, append if needed


                options = this._checkOptions(options);
                var childNodesObj = {};
                var childEdgesObj = {}; // collect the nodes that will be in the cluster

                forEach$1(this.body.nodes, function (node, nodeId) {
                    if (node.options && options.joinCondition(node.options) === true) {
                        childNodesObj[nodeId] = node; // collect the edges that will be in the cluster

                        forEach$1(node.edges, function (edge) {
                            if (_this2.clusteredEdges[edge.id] === undefined) {
                                childEdgesObj[edge.id] = edge;
                            }
                        });
                    }
                });

                this._cluster(childNodesObj, childEdgesObj, options, refreshData);
            }
            /**
             * Cluster all nodes in the network that have only X edges
             *
             * @param {number} edgeCount
             * @param {object} options
             * @param {boolean} [refreshData=true]
             */

        }, {
            key: "clusterByEdgeCount",
            value: function clusterByEdgeCount(edgeCount, options) {
                var _this3 = this;

                var refreshData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                options = this._checkOptions(options);
                var clusters = [];
                var usedNodes = {};
                var edge, edges, relevantEdgeCount; // collect the nodes that will be in the cluster

                var _loop = function _loop(i) {
                    var childNodesObj = {};
                    var childEdgesObj = {};
                    var nodeId = _this3.body.nodeIndices[i];
                    var node = _this3.body.nodes[nodeId]; // if this node is already used in another cluster this session, we do not have to re-evaluate it.

                    if (usedNodes[nodeId] === undefined) {
                        relevantEdgeCount = 0;
                        edges = [];

                        for (var j = 0; j < node.edges.length; j++) {
                            edge = node.edges[j];

                            if (_this3.clusteredEdges[edge.id] === undefined) {
                                if (edge.toId !== edge.fromId) {
                                    relevantEdgeCount++;
                                }

                                edges.push(edge);
                            }
                        } // this node qualifies, we collect its neighbours to start the clustering process.


                        if (relevantEdgeCount === edgeCount) {
                            var checkJoinCondition = function checkJoinCondition(node) {
                                if (options.joinCondition === undefined || options.joinCondition === null) {
                                    return true;
                                }

                                var clonedOptions = NetworkUtil.cloneOptions(node);
                                return options.joinCondition(clonedOptions);
                            };

                            var gatheringSuccessful = true;

                            for (var _j = 0; _j < edges.length; _j++) {
                                edge = edges[_j];

                                var childNodeId = _this3._getConnectedId(edge, nodeId); // add the nodes to the list by the join condition.


                                if (checkJoinCondition(node)) {
                                    childEdgesObj[edge.id] = edge;
                                    childNodesObj[nodeId] = node;
                                    childNodesObj[childNodeId] = _this3.body.nodes[childNodeId];
                                    usedNodes[nodeId] = true;
                                } else {
                                    // this node does not qualify after all.
                                    gatheringSuccessful = false;
                                    break;
                                }
                            } // add to the cluster queue


                            if (keys$3(childNodesObj).length > 0 && keys$3(childEdgesObj).length > 0 && gatheringSuccessful === true) {
                                /**
                                 * Search for cluster data that contains any of the node id's
                                 *
                                 * @returns {boolean} true if no joinCondition, otherwise return value of joinCondition
                                 */
                                var findClusterData = function findClusterData() {
                                    for (var n = 0; n < clusters.length; ++n) {
                                        // Search for a cluster containing any of the node id's
                                        for (var m in childNodesObj) {
                                            if (clusters[n].nodes[m] !== undefined) {
                                                return clusters[n];
                                            }
                                        }
                                    }

                                    return undefined;
                                }; // If any of the found nodes is part of a cluster found in this method,
                                // add the current values to that cluster


                                var foundCluster = findClusterData();

                                if (foundCluster !== undefined) {
                                    // Add nodes to found cluster if not present
                                    for (var m in childNodesObj) {
                                        if (foundCluster.nodes[m] === undefined) {
                                            foundCluster.nodes[m] = childNodesObj[m];
                                        }
                                    } // Add edges to found cluster, if not present


                                    for (var _m in childEdgesObj) {
                                        if (foundCluster.edges[_m] === undefined) {
                                            foundCluster.edges[_m] = childEdgesObj[_m];
                                        }
                                    }
                                } else {
                                    // Create a new cluster group
                                    clusters.push({
                                        nodes: childNodesObj,
                                        edges: childEdgesObj
                                    });
                                }
                            }
                        }
                    }
                };

                for (var i = 0; i < this.body.nodeIndices.length; i++) {
                    _loop(i);
                }

                for (var _i2 = 0; _i2 < clusters.length; _i2++) {
                    this._cluster(clusters[_i2].nodes, clusters[_i2].edges, options, false);
                }

                if (refreshData === true) {
                    this.body.emitter.emit("_dataChanged");
                }
            }
            /**
             * Cluster all nodes in the network that have only 1 edge
             *
             * @param {object} options
             * @param {boolean} [refreshData=true]
             */

        }, {
            key: "clusterOutliers",
            value: function clusterOutliers(options) {
                var refreshData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                this.clusterByEdgeCount(1, options, refreshData);
            }
            /**
             * Cluster all nodes in the network that have only 2 edge
             *
             * @param {object} options
             * @param {boolean} [refreshData=true]
             */

        }, {
            key: "clusterBridges",
            value: function clusterBridges(options) {
                var refreshData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                this.clusterByEdgeCount(2, options, refreshData);
            }
            /**
             * suck all connected nodes of a node into the node.
             *
             * @param {Node.id} nodeId
             * @param {object} options
             * @param {boolean} [refreshData=true]
             */

        }, {
            key: "clusterByConnection",
            value: function clusterByConnection(nodeId, options) {
                var _context;

                var refreshData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

                // kill conditions
                if (nodeId === undefined) {
                    throw new Error("No nodeId supplied to clusterByConnection!");
                }

                if (this.body.nodes[nodeId] === undefined) {
                    throw new Error("The nodeId given to clusterByConnection does not exist!");
                }

                var node = this.body.nodes[nodeId];
                options = this._checkOptions(options, node);

                if (options.clusterNodeProperties.x === undefined) {
                    options.clusterNodeProperties.x = node.x;
                }

                if (options.clusterNodeProperties.y === undefined) {
                    options.clusterNodeProperties.y = node.y;
                }

                if (options.clusterNodeProperties.fixed === undefined) {
                    options.clusterNodeProperties.fixed = {};
                    options.clusterNodeProperties.fixed.x = node.options.fixed.x;
                    options.clusterNodeProperties.fixed.y = node.options.fixed.y;
                }

                var childNodesObj = {};
                var childEdgesObj = {};
                var parentNodeId = node.id;
                var parentClonedOptions = NetworkUtil.cloneOptions(node);
                childNodesObj[parentNodeId] = node; // collect the nodes that will be in the cluster

                for (var i = 0; i < node.edges.length; i++) {
                    var edge = node.edges[i];

                    if (this.clusteredEdges[edge.id] === undefined) {
                        var childNodeId = this._getConnectedId(edge, parentNodeId); // if the child node is not in a cluster


                        if (this.clusteredNodes[childNodeId] === undefined) {
                            if (childNodeId !== parentNodeId) {
                                if (options.joinCondition === undefined) {
                                    childEdgesObj[edge.id] = edge;
                                    childNodesObj[childNodeId] = this.body.nodes[childNodeId];
                                } else {
                                    // clone the options and insert some additional parameters that could be interesting.
                                    var childClonedOptions = NetworkUtil.cloneOptions(this.body.nodes[childNodeId]);

                                    if (options.joinCondition(parentClonedOptions, childClonedOptions) === true) {
                                        childEdgesObj[edge.id] = edge;
                                        childNodesObj[childNodeId] = this.body.nodes[childNodeId];
                                    }
                                }
                            } else {
                                // swallow the edge if it is self-referencing.
                                childEdgesObj[edge.id] = edge;
                            }
                        }
                    }
                }

                var childNodeIDs = map$3(_context = keys$3(childNodesObj)).call(_context, function (childNode) {
                    return childNodesObj[childNode].id;
                });

                for (var childNodeKey in childNodesObj) {
                    if (!Object.prototype.hasOwnProperty.call(childNodesObj, childNodeKey)) continue;
                    var childNode = childNodesObj[childNodeKey];

                    for (var y = 0; y < childNode.edges.length; y++) {
                        var childEdge = childNode.edges[y];

                        if (indexOf(childNodeIDs).call(childNodeIDs, this._getConnectedId(childEdge, childNode.id)) > -1) {
                            childEdgesObj[childEdge.id] = childEdge;
                        }
                    }
                }

                this._cluster(childNodesObj, childEdgesObj, options, refreshData);
            }
            /**
             * This function creates the edges that will be attached to the cluster
             * It looks for edges that are connected to the nodes from the "outside' of the cluster.
             *
             * @param {{Node.id: vis.Node}} childNodesObj
             * @param {{vis.Edge.id: vis.Edge}} childEdgesObj
             * @param {object} clusterNodeProperties
             * @param {object} clusterEdgeProperties
             * @private
             */

        }, {
            key: "_createClusterEdges",
            value: function _createClusterEdges(childNodesObj, childEdgesObj, clusterNodeProperties, clusterEdgeProperties) {
                var edge, childNodeId, childNode, toId, fromId, otherNodeId; // loop over all child nodes and their edges to find edges going out of the cluster
                // these edges will be replaced by clusterEdges.

                var childKeys = keys$3(childNodesObj);

                var createEdges = [];

                for (var i = 0; i < childKeys.length; i++) {
                    childNodeId = childKeys[i];
                    childNode = childNodesObj[childNodeId]; // construct new edges from the cluster to others

                    for (var j = 0; j < childNode.edges.length; j++) {
                        edge = childNode.edges[j]; // we only handle edges that are visible to the system, not the disabled ones from the clustering process.

                        if (this.clusteredEdges[edge.id] === undefined) {
                            // self-referencing edges will be added to the "hidden" list
                            if (edge.toId == edge.fromId) {
                                childEdgesObj[edge.id] = edge;
                            } else {
                                // set up the from and to.
                                if (edge.toId == childNodeId) {
                                    // this is a double equals because ints and strings can be interchanged here.
                                    toId = clusterNodeProperties.id;
                                    fromId = edge.fromId;
                                    otherNodeId = fromId;
                                } else {
                                    toId = edge.toId;
                                    fromId = clusterNodeProperties.id;
                                    otherNodeId = toId;
                                }
                            } // Only edges from the cluster outwards are being replaced.


                            if (childNodesObj[otherNodeId] === undefined) {
                                createEdges.push({
                                    edge: edge,
                                    fromId: fromId,
                                    toId: toId
                                });
                            }
                        }
                    }
                } //
                // Here we actually create the replacement edges.
                //
                // We could not do this in the loop above as the creation process
                // would add an edge to the edges array we are iterating over.
                //
                // NOTE: a clustered edge can have multiple base edges!
                //


                var newEdges = [];
                /**
                 * Find a cluster edge which matches the given created edge.
                 *
                 * @param {vis.Edge} createdEdge
                 * @returns {vis.Edge}
                 */

                var getNewEdge = function getNewEdge(createdEdge) {
                    for (var _j2 = 0; _j2 < newEdges.length; _j2++) {
                        var newEdge = newEdges[_j2]; // We replace both to and from edges with a single cluster edge

                        var matchToDirection = createdEdge.fromId === newEdge.fromId && createdEdge.toId === newEdge.toId;
                        var matchFromDirection = createdEdge.fromId === newEdge.toId && createdEdge.toId === newEdge.fromId;

                        if (matchToDirection || matchFromDirection) {
                            return newEdge;
                        }
                    }

                    return null;
                };

                for (var _j3 = 0; _j3 < createEdges.length; _j3++) {
                    var createdEdge = createEdges[_j3];
                    var _edge = createdEdge.edge;
                    var newEdge = getNewEdge(createdEdge);

                    if (newEdge === null) {
                        // Create a clustered edge for this connection
                        newEdge = this._createClusteredEdge(createdEdge.fromId, createdEdge.toId, _edge, clusterEdgeProperties);
                        newEdges.push(newEdge);
                    } else {
                        newEdge.clusteringEdgeReplacingIds.push(_edge.id);
                    } // also reference the new edge in the old edge


                    this.body.edges[_edge.id].edgeReplacedById = newEdge.id; // hide the replaced edge

                    this._backupEdgeOptions(_edge);

                    _edge.setOptions({
                        physics: false
                    });
                }
            }
            /**
             * This function checks the options that can be supplied to the different cluster functions
             * for certain fields and inserts defaults if needed
             *
             * @param {object} options
             * @returns {*}
             * @private
             */

        }, {
            key: "_checkOptions",
            value: function _checkOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                if (options.clusterEdgeProperties === undefined) {
                    options.clusterEdgeProperties = {};
                }

                if (options.clusterNodeProperties === undefined) {
                    options.clusterNodeProperties = {};
                }

                return options;
            }
            /**
             *
             * @param {object}    childNodesObj         | object with node objects, id as keys, same as childNodes except it also contains a source node
             * @param {object}    childEdgesObj         | object with edge objects, id as keys
             * @param {Array}     options               | object with {clusterNodeProperties, clusterEdgeProperties, processProperties}
             * @param {boolean}   refreshData | when true, do not wrap up
             * @private
             */

        }, {
            key: "_cluster",
            value: function _cluster(childNodesObj, childEdgesObj, options) {
                var refreshData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
                // Remove nodes which are already clustered
                var tmpNodesToRemove = [];

                for (var nodeId in childNodesObj) {
                    if (Object.prototype.hasOwnProperty.call(childNodesObj, nodeId)) {
                        if (this.clusteredNodes[nodeId] !== undefined) {
                            tmpNodesToRemove.push(nodeId);
                        }
                    }
                }

                for (var n = 0; n < tmpNodesToRemove.length; ++n) {
                    delete childNodesObj[tmpNodesToRemove[n]];
                } // kill condition: no nodes don't bother


                if (keys$3(childNodesObj).length == 0) {
                    return;
                } // allow clusters of 1 if options allow


                if (keys$3(childNodesObj).length == 1 && options.clusterNodeProperties.allowSingleNodeCluster != true) {
                    return;
                }

                var clusterNodeProperties = deepExtend({}, options.clusterNodeProperties); // construct the clusterNodeProperties

                if (options.processProperties !== undefined) {
                    // get the childNode options
                    var childNodesOptions = [];

                    for (var _nodeId in childNodesObj) {
                        if (Object.prototype.hasOwnProperty.call(childNodesObj, _nodeId)) {
                            var clonedOptions = NetworkUtil.cloneOptions(childNodesObj[_nodeId]);
                            childNodesOptions.push(clonedOptions);
                        }
                    } // get cluster properties based on childNodes


                    var childEdgesOptions = [];

                    for (var edgeId in childEdgesObj) {
                        if (Object.prototype.hasOwnProperty.call(childEdgesObj, edgeId)) {
                            // these cluster edges will be removed on creation of the cluster.
                            if (edgeId.substr(0, 12) !== "clusterEdge:") {
                                var _clonedOptions = NetworkUtil.cloneOptions(childEdgesObj[edgeId], "edge");

                                childEdgesOptions.push(_clonedOptions);
                            }
                        }
                    }

                    clusterNodeProperties = options.processProperties(clusterNodeProperties, childNodesOptions, childEdgesOptions);

                    if (!clusterNodeProperties) {
                        throw new Error("The processProperties function does not return properties!");
                    }
                } // check if we have an unique id;


                if (clusterNodeProperties.id === undefined) {
                    clusterNodeProperties.id = "cluster:" + v4();
                }

                var clusterId = clusterNodeProperties.id;

                if (clusterNodeProperties.label === undefined) {
                    clusterNodeProperties.label = "cluster";
                } // give the clusterNode a position if it does not have one.


                var pos = undefined;

                if (clusterNodeProperties.x === undefined) {
                    pos = this._getClusterPosition(childNodesObj);
                    clusterNodeProperties.x = pos.x;
                }

                if (clusterNodeProperties.y === undefined) {
                    if (pos === undefined) {
                        pos = this._getClusterPosition(childNodesObj);
                    }

                    clusterNodeProperties.y = pos.y;
                } // force the ID to remain the same


                clusterNodeProperties.id = clusterId; // create the cluster Node
                // Note that allowSingleNodeCluster, if present, is stored in the options as well

                var clusterNode = this.body.functions.createNode(clusterNodeProperties, Cluster);
                clusterNode.containedNodes = childNodesObj;
                clusterNode.containedEdges = childEdgesObj; // cache a copy from the cluster edge properties if we have to reconnect others later on

                clusterNode.clusterEdgeProperties = options.clusterEdgeProperties; // finally put the cluster node into global

                this.body.nodes[clusterNodeProperties.id] = clusterNode;

                this._clusterEdges(childNodesObj, childEdgesObj, clusterNodeProperties, options.clusterEdgeProperties); // set ID to undefined so no duplicates arise


                clusterNodeProperties.id = undefined; // wrap up

                if (refreshData === true) {
                    this.body.emitter.emit("_dataChanged");
                }
            }
            /**
             *
             * @param {Edge} edge
             * @private
             */

        }, {
            key: "_backupEdgeOptions",
            value: function _backupEdgeOptions(edge) {
                if (this.clusteredEdges[edge.id] === undefined) {
                    this.clusteredEdges[edge.id] = {
                        physics: edge.options.physics
                    };
                }
            }
            /**
             *
             * @param {Edge} edge
             * @private
             */

        }, {
            key: "_restoreEdge",
            value: function _restoreEdge(edge) {
                var originalOptions = this.clusteredEdges[edge.id];

                if (originalOptions !== undefined) {
                    edge.setOptions({
                        physics: originalOptions.physics
                    });
                    delete this.clusteredEdges[edge.id];
                }
            }
            /**
             * Check if a node is a cluster.
             *
             * @param {Node.id} nodeId
             * @returns {*}
             */

        }, {
            key: "isCluster",
            value: function isCluster(nodeId) {
                if (this.body.nodes[nodeId] !== undefined) {
                    return this.body.nodes[nodeId].isCluster === true;
                } else {
                    console.error("Node does not exist.");
                    return false;
                }
            }
            /**
             * get the position of the cluster node based on what's inside
             *
             * @param {object} childNodesObj    | object with node objects, id as keys
             * @returns {{x: number, y: number}}
             * @private
             */

        }, {
            key: "_getClusterPosition",
            value: function _getClusterPosition(childNodesObj) {
                var childKeys = keys$3(childNodesObj);

                var minX = childNodesObj[childKeys[0]].x;
                var maxX = childNodesObj[childKeys[0]].x;
                var minY = childNodesObj[childKeys[0]].y;
                var maxY = childNodesObj[childKeys[0]].y;
                var node;

                for (var i = 1; i < childKeys.length; i++) {
                    node = childNodesObj[childKeys[i]];
                    minX = node.x < minX ? node.x : minX;
                    maxX = node.x > maxX ? node.x : maxX;
                    minY = node.y < minY ? node.y : minY;
                    maxY = node.y > maxY ? node.y : maxY;
                }

                return {
                    x: 0.5 * (minX + maxX),
                    y: 0.5 * (minY + maxY)
                };
            }
            /**
             * Open a cluster by calling this function.
             *
             * @param {vis.Edge.id}  clusterNodeId | the ID of the cluster node
             * @param {object} options
             * @param {boolean} refreshData | wrap up afterwards if not true
             */

        }, {
            key: "openCluster",
            value: function openCluster(clusterNodeId, options) {
                var refreshData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

                // kill conditions
                if (clusterNodeId === undefined) {
                    throw new Error("No clusterNodeId supplied to openCluster.");
                }

                var clusterNode = this.body.nodes[clusterNodeId];

                if (clusterNode === undefined) {
                    throw new Error("The clusterNodeId supplied to openCluster does not exist.");
                }

                if (clusterNode.isCluster !== true || clusterNode.containedNodes === undefined || clusterNode.containedEdges === undefined) {
                    throw new Error("The node:" + clusterNodeId + " is not a valid cluster.");
                } // Check if current cluster is clustered itself


                var stack = this.findNode(clusterNodeId);
                var parentIndex = indexOf(stack).call(stack, clusterNodeId) - 1;

                if (parentIndex >= 0) {
                    // Current cluster is clustered; transfer contained nodes and edges to parent
                    var parentClusterNodeId = stack[parentIndex];
                    var parentClusterNode = this.body.nodes[parentClusterNodeId]; // clustering.clusteredNodes and clustering.clusteredEdges remain unchanged

                    parentClusterNode._openChildCluster(clusterNodeId); // All components of child cluster node have been transferred. It can die now.


                    delete this.body.nodes[clusterNodeId];

                    if (refreshData === true) {
                        this.body.emitter.emit("_dataChanged");
                    }

                    return;
                } // main body


                var containedNodes = clusterNode.containedNodes;
                var containedEdges = clusterNode.containedEdges; // allow the user to position the nodes after release.

                if (options !== undefined && options.releaseFunction !== undefined && typeof options.releaseFunction === "function") {
                    var positions = {};
                    var clusterPosition = {
                        x: clusterNode.x,
                        y: clusterNode.y
                    };

                    for (var nodeId in containedNodes) {
                        if (Object.prototype.hasOwnProperty.call(containedNodes, nodeId)) {
                            var containedNode = this.body.nodes[nodeId];
                            positions[nodeId] = {
                                x: containedNode.x,
                                y: containedNode.y
                            };
                        }
                    }

                    var newPositions = options.releaseFunction(clusterPosition, positions);

                    for (var _nodeId2 in containedNodes) {
                        if (Object.prototype.hasOwnProperty.call(containedNodes, _nodeId2)) {
                            var _containedNode = this.body.nodes[_nodeId2];

                            if (newPositions[_nodeId2] !== undefined) {
                                _containedNode.x = newPositions[_nodeId2].x === undefined ? clusterNode.x : newPositions[_nodeId2].x;
                                _containedNode.y = newPositions[_nodeId2].y === undefined ? clusterNode.y : newPositions[_nodeId2].y;
                            }
                        }
                    }
                } else {
                    // copy the position from the cluster
                    forEach$1(containedNodes, function (containedNode) {
                        // inherit position
                        if (containedNode.options.fixed.x === false) {
                            containedNode.x = clusterNode.x;
                        }

                        if (containedNode.options.fixed.y === false) {
                            containedNode.y = clusterNode.y;
                        }
                    });
                } // release nodes


                for (var _nodeId3 in containedNodes) {
                    if (Object.prototype.hasOwnProperty.call(containedNodes, _nodeId3)) {
                        var _containedNode2 = this.body.nodes[_nodeId3]; // inherit speed

                        _containedNode2.vx = clusterNode.vx;
                        _containedNode2.vy = clusterNode.vy;

                        _containedNode2.setOptions({
                            physics: true
                        });

                        delete this.clusteredNodes[_nodeId3];
                    }
                } // copy the clusterNode edges because we cannot iterate over an object that we add or remove from.


                var edgesToBeDeleted = [];

                for (var i = 0; i < clusterNode.edges.length; i++) {
                    edgesToBeDeleted.push(clusterNode.edges[i]);
                } // actually handling the deleting.


                for (var _i3 = 0; _i3 < edgesToBeDeleted.length; _i3++) {
                    var edge = edgesToBeDeleted[_i3];

                    var otherNodeId = this._getConnectedId(edge, clusterNodeId);

                    var otherNode = this.clusteredNodes[otherNodeId];

                    for (var j = 0; j < edge.clusteringEdgeReplacingIds.length; j++) {
                        var transferId = edge.clusteringEdgeReplacingIds[j];
                        var transferEdge = this.body.edges[transferId];
                        if (transferEdge === undefined) continue; // if the other node is in another cluster, we transfer ownership of this edge to the other cluster

                        if (otherNode !== undefined) {
                            // transfer ownership:
                            var otherCluster = this.body.nodes[otherNode.clusterId];
                            otherCluster.containedEdges[transferEdge.id] = transferEdge; // delete local reference

                            delete containedEdges[transferEdge.id]; // get to and from

                            var fromId = transferEdge.fromId;
                            var toId = transferEdge.toId;

                            if (transferEdge.toId == otherNodeId) {
                                toId = otherNode.clusterId;
                            } else {
                                fromId = otherNode.clusterId;
                            } // create new cluster edge from the otherCluster


                            this._createClusteredEdge(fromId, toId, transferEdge, otherCluster.clusterEdgeProperties, {
                                hidden: false,
                                physics: true
                            });
                        } else {
                            this._restoreEdge(transferEdge);
                        }
                    }

                    edge.remove();
                } // handle the releasing of the edges


                for (var edgeId in containedEdges) {
                    if (Object.prototype.hasOwnProperty.call(containedEdges, edgeId)) {
                        this._restoreEdge(containedEdges[edgeId]);
                    }
                } // remove clusterNode


                delete this.body.nodes[clusterNodeId];

                if (refreshData === true) {
                    this.body.emitter.emit("_dataChanged");
                }
            }
            /**
             *
             * @param {Cluster.id} clusterId
             * @returns {Array.<Node.id>}
             */

        }, {
            key: "getNodesInCluster",
            value: function getNodesInCluster(clusterId) {
                var nodesArray = [];

                if (this.isCluster(clusterId) === true) {
                    var containedNodes = this.body.nodes[clusterId].containedNodes;

                    for (var nodeId in containedNodes) {
                        if (Object.prototype.hasOwnProperty.call(containedNodes, nodeId)) {
                            nodesArray.push(this.body.nodes[nodeId].id);
                        }
                    }
                }

                return nodesArray;
            }
            /**
             * Get the stack clusterId's that a certain node resides in. cluster A -> cluster B -> cluster C -> node
             *
             * If a node can't be found in the chain, return an empty array.
             *
             * @param {string|number} nodeId
             * @returns {Array}
             */

        }, {
            key: "findNode",
            value: function findNode(nodeId) {
                var stack = [];
                var max = 100;
                var counter = 0;
                var node;

                while (this.clusteredNodes[nodeId] !== undefined && counter < max) {
                    node = this.body.nodes[nodeId];
                    if (node === undefined) return [];
                    stack.push(node.id);
                    nodeId = this.clusteredNodes[nodeId].clusterId;
                    counter++;
                }

                node = this.body.nodes[nodeId];
                if (node === undefined) return [];
                stack.push(node.id);

                reverse(stack).call(stack);

                return stack;
            }
            /**
             * Using a clustered nodeId, update with the new options
             *
             * @param {Node.id} clusteredNodeId
             * @param {object} newOptions
             */

        }, {
            key: "updateClusteredNode",
            value: function updateClusteredNode(clusteredNodeId, newOptions) {
                if (clusteredNodeId === undefined) {
                    throw new Error("No clusteredNodeId supplied to updateClusteredNode.");
                }

                if (newOptions === undefined) {
                    throw new Error("No newOptions supplied to updateClusteredNode.");
                }

                if (this.body.nodes[clusteredNodeId] === undefined) {
                    throw new Error("The clusteredNodeId supplied to updateClusteredNode does not exist.");
                }

                this.body.nodes[clusteredNodeId].setOptions(newOptions);
                this.body.emitter.emit("_dataChanged");
            }
            /**
             * Using a base edgeId, update all related clustered edges with the new options
             *
             * @param {vis.Edge.id} startEdgeId
             * @param {object} newOptions
             */

        }, {
            key: "updateEdge",
            value: function updateEdge(startEdgeId, newOptions) {
                if (startEdgeId === undefined) {
                    throw new Error("No startEdgeId supplied to updateEdge.");
                }

                if (newOptions === undefined) {
                    throw new Error("No newOptions supplied to updateEdge.");
                }

                if (this.body.edges[startEdgeId] === undefined) {
                    throw new Error("The startEdgeId supplied to updateEdge does not exist.");
                }

                var allEdgeIds = this.getClusteredEdges(startEdgeId);

                for (var i = 0; i < allEdgeIds.length; i++) {
                    var edge = this.body.edges[allEdgeIds[i]];
                    edge.setOptions(newOptions);
                }

                this.body.emitter.emit("_dataChanged");
            }
            /**
             * Get a stack of clusterEdgeId's (+base edgeid) that a base edge is the same as. cluster edge C -> cluster edge B -> cluster edge A -> base edge(edgeId)
             *
             * @param {vis.Edge.id} edgeId
             * @returns {Array.<vis.Edge.id>}
             */

        }, {
            key: "getClusteredEdges",
            value: function getClusteredEdges(edgeId) {
                var stack = [];
                var max = 100;
                var counter = 0;

                while (edgeId !== undefined && this.body.edges[edgeId] !== undefined && counter < max) {
                    stack.push(this.body.edges[edgeId].id);
                    edgeId = this.body.edges[edgeId].edgeReplacedById;
                    counter++;
                }

                reverse(stack).call(stack);

                return stack;
            }
            /**
             * Get the base edge id of clusterEdgeId. cluster edge (clusteredEdgeId) -> cluster edge B -> cluster edge C -> base edge
             *
             * @param {vis.Edge.id} clusteredEdgeId
             * @returns {vis.Edge.id} baseEdgeId
             *
             * TODO: deprecate in 5.0.0. Method getBaseEdges() is the correct one to use.
             */

        }, {
            key: "getBaseEdge",
            value: function getBaseEdge(clusteredEdgeId) {
                // Just kludge this by returning the first base edge id found
                return this.getBaseEdges(clusteredEdgeId)[0];
            }
            /**
             * Get all regular edges for this clustered edge id.
             *
             * @param {vis.Edge.id} clusteredEdgeId
             * @returns {Array.<vis.Edge.id>} all baseEdgeId's under this clustered edge
             */

        }, {
            key: "getBaseEdges",
            value: function getBaseEdges(clusteredEdgeId) {
                var IdsToHandle = [clusteredEdgeId];
                var doneIds = [];
                var foundIds = [];
                var max = 100;
                var counter = 0;

                while (IdsToHandle.length > 0 && counter < max) {
                    var nextId = IdsToHandle.pop();
                    if (nextId === undefined) continue; // Paranoia here and onwards

                    var nextEdge = this.body.edges[nextId];
                    if (nextEdge === undefined) continue;
                    counter++;
                    var replacingIds = nextEdge.clusteringEdgeReplacingIds;

                    if (replacingIds === undefined) {
                        // nextId is a base id
                        foundIds.push(nextId);
                    } else {
                        // Another cluster edge, unravel this one as well
                        for (var i = 0; i < replacingIds.length; ++i) {
                            var replacingId = replacingIds[i]; // Don't add if already handled
                            // TODO: never triggers; find a test-case which does

                            if (indexOf(IdsToHandle).call(IdsToHandle, replacingIds) !== -1 || indexOf(doneIds).call(doneIds, replacingIds) !== -1) {
                                continue;
                            }

                            IdsToHandle.push(replacingId);
                        }
                    }

                    doneIds.push(nextId);
                }

                return foundIds;
            }
            /**
             * Get the Id the node is connected to
             *
             * @param {vis.Edge} edge
             * @param {Node.id} nodeId
             * @returns {*}
             * @private
             */

        }, {
            key: "_getConnectedId",
            value: function _getConnectedId(edge, nodeId) {
                if (edge.toId != nodeId) {
                    return edge.toId;
                } else if (edge.fromId != nodeId) {
                    return edge.fromId;
                } else {
                    return edge.fromId;
                }
            }
            /**
             * We determine how many connections denote an important hub.
             * We take the mean + 2*std as the important hub size. (Assuming a normal distribution of data, ~2.2%)
             *
             * @returns {number}
             * @private
             */

        }, {
            key: "_getHubSize",
            value: function _getHubSize() {
                var average = 0;
                var averageSquared = 0;
                var hubCounter = 0;
                var largestHub = 0;

                for (var i = 0; i < this.body.nodeIndices.length; i++) {
                    var node = this.body.nodes[this.body.nodeIndices[i]];

                    if (node.edges.length > largestHub) {
                        largestHub = node.edges.length;
                    }

                    average += node.edges.length;
                    averageSquared += Math.pow(node.edges.length, 2);
                    hubCounter += 1;
                }

                average = average / hubCounter;
                averageSquared = averageSquared / hubCounter;
                var variance = averageSquared - Math.pow(average, 2);
                var standardDeviation = Math.sqrt(variance);
                var hubThreshold = Math.floor(average + 2 * standardDeviation); // always have at least one to cluster

                if (hubThreshold > largestHub) {
                    hubThreshold = largestHub;
                }

                return hubThreshold;
            }
            /**
             * Create an edge for the cluster representation.
             *
             * @param {Node.id} fromId
             * @param {Node.id} toId
             * @param {vis.Edge} baseEdge
             * @param {object} clusterEdgeProperties
             * @param {object} extraOptions
             * @returns {Edge} newly created clustered edge
             * @private
             */

        }, {
            key: "_createClusteredEdge",
            value: function _createClusteredEdge(fromId, toId, baseEdge, clusterEdgeProperties, extraOptions) {
                // copy the options of the edge we will replace
                var clonedOptions = NetworkUtil.cloneOptions(baseEdge, "edge"); // make sure the properties of clusterEdges are superimposed on it

                deepExtend(clonedOptions, clusterEdgeProperties); // set up the edge

                clonedOptions.from = fromId;
                clonedOptions.to = toId;
                clonedOptions.id = "clusterEdge:" + v4(); // apply the edge specific options to it if specified

                if (extraOptions !== undefined) {
                    deepExtend(clonedOptions, extraOptions);
                }

                var newEdge = this.body.functions.createEdge(clonedOptions);
                newEdge.clusteringEdgeReplacingIds = [baseEdge.id];
                newEdge.connect(); // Register the new edge

                this.body.edges[newEdge.id] = newEdge;
                return newEdge;
            }
            /**
             * Add the passed child nodes and edges to the given cluster node.
             *
             * @param {object | Node} childNodes  hash of nodes or single node to add in cluster
             * @param {object | Edge} childEdges  hash of edges or single edge to take into account when clustering
             * @param {Node} clusterNode  cluster node to add nodes and edges to
             * @param {object} [clusterEdgeProperties]
             * @private
             */

        }, {
            key: "_clusterEdges",
            value: function _clusterEdges(childNodes, childEdges, clusterNode, clusterEdgeProperties) {
                if (childEdges instanceof Edge) {
                    var edge = childEdges;
                    var obj = {};
                    obj[edge.id] = edge;
                    childEdges = obj;
                }

                if (childNodes instanceof Node) {
                    var node = childNodes;
                    var _obj = {};
                    _obj[node.id] = node;
                    childNodes = _obj;
                }

                if (clusterNode === undefined || clusterNode === null) {
                    throw new Error("_clusterEdges: parameter clusterNode required");
                }

                if (clusterEdgeProperties === undefined) {
                    // Take the required properties from the cluster node
                    clusterEdgeProperties = clusterNode.clusterEdgeProperties;
                } // create the new edges that will connect to the cluster.
                // All self-referencing edges will be added to childEdges here.


                this._createClusterEdges(childNodes, childEdges, clusterNode, clusterEdgeProperties); // disable the childEdges


                for (var edgeId in childEdges) {
                    if (Object.prototype.hasOwnProperty.call(childEdges, edgeId)) {
                        if (this.body.edges[edgeId] !== undefined) {
                            var _edge2 = this.body.edges[edgeId]; // cache the options before changing

                            this._backupEdgeOptions(_edge2); // disable physics and hide the edge


                            _edge2.setOptions({
                                physics: false
                            });
                        }
                    }
                } // disable the childNodes


                for (var nodeId in childNodes) {
                    if (Object.prototype.hasOwnProperty.call(childNodes, nodeId)) {
                        this.clusteredNodes[nodeId] = {
                            clusterId: clusterNode.id,
                            node: this.body.nodes[nodeId]
                        };
                        this.body.nodes[nodeId].setOptions({
                            physics: false
                        });
                    }
                }
            }
            /**
             * Determine in which cluster given nodeId resides.
             *
             * If not in cluster, return undefined.
             *
             * NOTE: If you know a cleaner way to do this, please enlighten me (wimrijnders).
             *
             * @param {Node.id} nodeId
             * @returns {Node|undefined} Node instance for cluster, if present
             * @private
             */

        }, {
            key: "_getClusterNodeForNode",
            value: function _getClusterNodeForNode(nodeId) {
                if (nodeId === undefined) return undefined;
                var clusteredNode = this.clusteredNodes[nodeId]; // NOTE: If no cluster info found, it should actually be an error

                if (clusteredNode === undefined) return undefined;
                var clusterId = clusteredNode.clusterId;
                if (clusterId === undefined) return undefined;
                return this.body.nodes[clusterId];
            }
            /**
             * Internal helper function for conditionally removing items in array
             *
             * Done like this because Array.filter() is not fully supported by all IE's.
             *
             * @param {Array} arr
             * @param {Function} callback
             * @returns {Array}
             * @private
             */

        }, {
            key: "_filter",
            value: function _filter(arr, callback) {
                var ret = [];
                forEach$1(arr, function (item) {
                    if (callback(item)) {
                        ret.push(item);
                    }
                });
                return ret;
            }
            /**
             * Scan all edges for changes in clustering and adjust this if necessary.
             *
             * Call this (internally) after there has been a change in node or edge data.
             *
             * Pre: States of this.body.nodes and this.body.edges consistent
             * Pre: this.clusteredNodes and this.clusteredEdge consistent with containedNodes and containedEdges
             *      of cluster nodes.
             */

        }, {
            key: "_updateState",
            value: function _updateState() {
                var _this4 = this;

                var nodeId;
                var deletedNodeIds = [];
                var deletedEdgeIds = {};
                /**
                 * Utility function to iterate over clustering nodes only
                 *
                 * @param {Function} callback  function to call for each cluster node
                 */

                var eachClusterNode = function eachClusterNode(callback) {
                    forEach$1(_this4.body.nodes, function (node) {
                        if (node.isCluster === true) {
                            callback(node);
                        }
                    });
                }; //
                // Remove deleted regular nodes from clustering
                //
                // Determine the deleted nodes


                for (nodeId in this.clusteredNodes) {
                    if (!Object.prototype.hasOwnProperty.call(this.clusteredNodes, nodeId)) continue;
                    var node = this.body.nodes[nodeId];

                    if (node === undefined) {
                        deletedNodeIds.push(nodeId);
                    }
                } // Remove nodes from cluster nodes


                eachClusterNode(function (clusterNode) {
                    for (var n = 0; n < deletedNodeIds.length; n++) {
                        delete clusterNode.containedNodes[deletedNodeIds[n]];
                    }
                }); // Remove nodes from cluster list

                for (var n = 0; n < deletedNodeIds.length; n++) {
                    delete this.clusteredNodes[deletedNodeIds[n]];
                } //
                // Remove deleted edges from clustering
                //
                // Add the deleted clustered edges to the list


                forEach$1(this.clusteredEdges, function (edgeId) {
                    var edge = _this4.body.edges[edgeId];

                    if (edge === undefined || !edge.endPointsValid()) {
                        deletedEdgeIds[edgeId] = edgeId;
                    }
                }); // Cluster nodes can also contain edges which are not clustered,
                // i.e. nodes 1-2 within cluster with an edge in between.
                // So the cluster nodes also need to be scanned for invalid edges

                eachClusterNode(function (clusterNode) {
                    forEach$1(clusterNode.containedEdges, function (edge, edgeId) {
                        if (!edge.endPointsValid() && !deletedEdgeIds[edgeId]) {
                            deletedEdgeIds[edgeId] = edgeId;
                        }
                    });
                }); // Also scan for cluster edges which need to be removed in the active list.
                // Regular edges have been removed beforehand, so this only picks up the cluster edges.

                forEach$1(this.body.edges, function (edge, edgeId) {
                    // Explicitly scan the contained edges for validity
                    var isValid = true;
                    var replacedIds = edge.clusteringEdgeReplacingIds;

                    if (replacedIds !== undefined) {
                        var numValid = 0;
                        forEach$1(replacedIds, function (containedEdgeId) {
                            var containedEdge = _this4.body.edges[containedEdgeId];

                            if (containedEdge !== undefined && containedEdge.endPointsValid()) {
                                numValid += 1;
                            }
                        });
                        isValid = numValid > 0;
                    }

                    if (!edge.endPointsValid() || !isValid) {
                        deletedEdgeIds[edgeId] = edgeId;
                    }
                }); // Remove edges from cluster nodes

                eachClusterNode(function (clusterNode) {
                    forEach$1(deletedEdgeIds, function (deletedEdgeId) {
                        delete clusterNode.containedEdges[deletedEdgeId];
                        forEach$1(clusterNode.edges, function (edge, m) {
                            if (edge.id === deletedEdgeId) {
                                clusterNode.edges[m] = null; // Don't want to directly delete here, because in the loop

                                return;
                            }

                            edge.clusteringEdgeReplacingIds = _this4._filter(edge.clusteringEdgeReplacingIds, function (id) {
                                return !deletedEdgeIds[id];
                            });
                        }); // Clean up the nulls

                        clusterNode.edges = _this4._filter(clusterNode.edges, function (item) {
                            return item !== null;
                        });
                    });
                }); // Remove from cluster list

                forEach$1(deletedEdgeIds, function (edgeId) {
                    delete _this4.clusteredEdges[edgeId];
                }); // Remove cluster edges from active list (this.body.edges).
                // deletedEdgeIds still contains id of regular edges, but these should all
                // be gone when you reach here.

                forEach$1(deletedEdgeIds, function (edgeId) {
                    delete _this4.body.edges[edgeId];
                }); //
                // Check changed cluster state of edges
                //
                // Iterating over keys here, because edges may be removed in the loop

                var ids = keys$3(this.body.edges);

                forEach$1(ids, function (edgeId) {
                    var edge = _this4.body.edges[edgeId];

                    var shouldBeClustered = _this4._isClusteredNode(edge.fromId) || _this4._isClusteredNode(edge.toId);

                    if (shouldBeClustered === _this4._isClusteredEdge(edge.id)) {
                        return; // all is well
                    }

                    if (shouldBeClustered) {
                        // add edge to clustering
                        var clusterFrom = _this4._getClusterNodeForNode(edge.fromId);

                        if (clusterFrom !== undefined) {
                            _this4._clusterEdges(_this4.body.nodes[edge.fromId], edge, clusterFrom);
                        }

                        var clusterTo = _this4._getClusterNodeForNode(edge.toId);

                        if (clusterTo !== undefined) {
                            _this4._clusterEdges(_this4.body.nodes[edge.toId], edge, clusterTo);
                        } // TODO: check that it works for both edges clustered
                        //       (This might be paranoia)

                    } else {
                        delete _this4._clusterEdges[edgeId];

                        _this4._restoreEdge(edge); // This should not be happening, the state should
                        // be properly updated at this point.
                        //
                        // If it *is* reached during normal operation, then we have to implement
                        // undo clustering for this edge here.
                        // throw new Error('remove edge from clustering not implemented!')

                    }
                }); // Clusters may be nested to any level. Keep on opening until nothing to open

                var changed = false;
                var continueLoop = true;

                var _loop2 = function _loop2() {
                    var clustersToOpen = []; // Determine the id's of clusters that need opening

                    eachClusterNode(function (clusterNode) {
                        var numNodes = keys$3(clusterNode.containedNodes).length;

                        var allowSingle = clusterNode.options.allowSingleNodeCluster === true;

                        if (allowSingle && numNodes < 1 || !allowSingle && numNodes < 2) {
                            clustersToOpen.push(clusterNode.id);
                        }
                    }); // Open them

                    for (var _n = 0; _n < clustersToOpen.length; ++_n) {
                        _this4.openCluster(clustersToOpen[_n], {}, false
                            /* Don't refresh, we're in an refresh/update already */
                        );
                    }

                    continueLoop = clustersToOpen.length > 0;
                    changed = changed || continueLoop;
                };

                while (continueLoop) {
                    _loop2();
                }

                if (changed) {
                    this._updateState(); // Redo this method (recursion possible! should be safe)

                }
            }
            /**
             * Determine if node with given id is part of a cluster.
             *
             * @param {Node.id} nodeId
             * @returns {boolean} true if part of a cluster.
             */

        }, {
            key: "_isClusteredNode",
            value: function _isClusteredNode(nodeId) {
                return this.clusteredNodes[nodeId] !== undefined;
            }
            /**
             * Determine if edge with given id is not visible due to clustering.
             *
             * An edge is considered clustered if:
             * - it is directly replaced by a clustering edge
             * - any of its connecting nodes is in a cluster
             *
             * @param {vis.Edge.id} edgeId
             * @returns {boolean} true if part of a cluster.
             */

        }, {
            key: "_isClusteredEdge",
            value: function _isClusteredEdge(edgeId) {
                return this.clusteredEdges[edgeId] !== undefined;
            }
        }]);

        return ClusterEngine;
    }();

    function _createForOfIteratorHelper$5(o, allowArrayLike) { var it; if (typeof symbol === "undefined" || getIteratorMethod(o) == null) { if (isArray(o) || (it = _unsupportedIterableToArray$5(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

    function _unsupportedIterableToArray$5(o, minLen) { var _context4; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$5(o, minLen); var n = slice$1(_context4 = Object.prototype.toString.call(o)).call(_context4, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return from$2(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen); }

    function _arrayLikeToArray$5(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
    /**
     * Initializes window.requestAnimationFrame() to a usable form.
     *
     * Specifically, set up this method for the case of running on node.js with jsdom enabled.
     *
     * NOTES:
     *
     * * On node.js, when calling this directly outside of this class, `window` is not defined.
     *   This happens even if jsdom is used.
     * * For node.js + jsdom, `window` is available at the moment the constructor is called.
     *   For this reason, the called is placed within the constructor.
     * * Even then, `window.requestAnimationFrame()` is not defined, so it still needs to be added.
     * * During unit testing, it happens that the window object is reset during execution, causing
     *   a runtime error due to missing `requestAnimationFrame()`. This needs to be compensated for,
     *   see `_requestNextFrame()`.
     * * Since this is a global object, it may affect other modules besides `Network`. With normal
     *   usage, this does not cause any problems. During unit testing, errors may occur. These have
     *   been compensated for, see comment block in _requestNextFrame().
     *
     * @private
     */

    function _initRequestAnimationFrame() {
        var func;

        if (window !== undefined) {
            func = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
        }

        if (func === undefined) {
            // window or method not present, setting mock requestAnimationFrame
            window.requestAnimationFrame = function (callback) {
                //console.log("Called mock requestAnimationFrame");
                callback();
            };
        } else {
            window.requestAnimationFrame = func;
        }
    }
    /**
     * The canvas renderer
     */


    var CanvasRenderer = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {Canvas} canvas
         */
        function CanvasRenderer(body, canvas) {
            _classCallCheck(this, CanvasRenderer);

            _initRequestAnimationFrame();

            this.body = body;
            this.canvas = canvas;
            this.redrawRequested = false;
            this.renderTimer = undefined;
            this.requiresTimeout = true;
            this.renderingActive = false;
            this.renderRequests = 0;
            this.allowRedraw = true;
            this.dragging = false;
            this.zooming = false;
            this.options = {};
            this.defaultOptions = {
                hideEdgesOnDrag: false,
                hideEdgesOnZoom: false,
                hideNodesOnDrag: false
            };

            assign$2(this.options, this.defaultOptions);

            this._determineBrowserMethod();

            this.bindEventListeners();
        }
        /**
         * Binds event listeners
         */


        _createClass(CanvasRenderer, [{
            key: "bindEventListeners",
            value: function bindEventListeners() {
                var _this = this,
                    _context2;

                this.body.emitter.on("dragStart", function () {
                    _this.dragging = true;
                });
                this.body.emitter.on("dragEnd", function () {
                    _this.dragging = false;
                });
                this.body.emitter.on("zoom", function () {
                    _this.zooming = true;
                    window.clearTimeout(_this.zoomTimeoutId);
                    _this.zoomTimeoutId = setTimeout$1(function () {
                        var _context;

                        _this.zooming = false;

                        bind(_context = _this._requestRedraw).call(_context, _this)();
                    }, 250);
                });
                this.body.emitter.on("_resizeNodes", function () {
                    _this._resizeNodes();
                });
                this.body.emitter.on("_redraw", function () {
                    if (_this.renderingActive === false) {
                        _this._redraw();
                    }
                });
                this.body.emitter.on("_blockRedraw", function () {
                    _this.allowRedraw = false;
                });
                this.body.emitter.on("_allowRedraw", function () {
                    _this.allowRedraw = true;
                    _this.redrawRequested = false;
                });
                this.body.emitter.on("_requestRedraw", bind(_context2 = this._requestRedraw).call(_context2, this));
                this.body.emitter.on("_startRendering", function () {
                    _this.renderRequests += 1;
                    _this.renderingActive = true;

                    _this._startRendering();
                });
                this.body.emitter.on("_stopRendering", function () {
                    _this.renderRequests -= 1;
                    _this.renderingActive = _this.renderRequests > 0;
                    _this.renderTimer = undefined;
                });
                this.body.emitter.on("destroy", function () {
                    _this.renderRequests = 0;
                    _this.allowRedraw = false;
                    _this.renderingActive = false;

                    if (_this.requiresTimeout === true) {
                        clearTimeout(_this.renderTimer);
                    } else {
                        window.cancelAnimationFrame(_this.renderTimer);
                    }

                    _this.body.emitter.off();
                });
            }
            /**
             *
             * @param {object} options
             */

        }, {
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    var fields = ["hideEdgesOnDrag", "hideEdgesOnZoom", "hideNodesOnDrag"];
                    selectiveDeepExtend(fields, this.options, options);
                }
            }
            /**
             * Prepare the drawing of the next frame.
             *
             * Calls the callback when the next frame can or will be drawn.
             *
             * @param {Function} callback
             * @param {number} delay - timeout case only, wait this number of milliseconds
             * @returns {Function | undefined}
             * @private
             */

        }, {
            key: "_requestNextFrame",
            value: function _requestNextFrame(callback, delay) {
                // During unit testing, it happens that the mock window object is reset while
                // the next frame is still pending. Then, either 'window' is not present, or
                // 'requestAnimationFrame()' is not present because it is not defined on the
                // mock window object.
                //
                // As a consequence, unrelated unit tests may appear to fail, even if the problem
                // described happens in the current unit test.
                //
                // This is not something that will happen in normal operation, but we still need
                // to take it into account.
                //
                if (typeof window === "undefined") return; // Doing `if (window === undefined)` does not work here!

                var timer;
                var myWindow = window; // Grab a reference to reduce the possibility that 'window' is reset
                // while running this method.

                if (this.requiresTimeout === true) {
                    // wait given number of milliseconds and perform the animation step function
                    timer = setTimeout$1(callback, delay);
                } else {
                    if (myWindow.requestAnimationFrame) {
                        timer = myWindow.requestAnimationFrame(callback);
                    }
                }

                return timer;
            }
            /**
             *
             * @private
             */

        }, {
            key: "_startRendering",
            value: function _startRendering() {
                if (this.renderingActive === true) {
                    if (this.renderTimer === undefined) {
                        var _context3;

                        this.renderTimer = this._requestNextFrame(bind(_context3 = this._renderStep).call(_context3, this), this.simulationInterval);
                    }
                }
            }
            /**
             *
             * @private
             */

        }, {
            key: "_renderStep",
            value: function _renderStep() {
                if (this.renderingActive === true) {
                    // reset the renderTimer so a new scheduled animation step can be set
                    this.renderTimer = undefined;

                    if (this.requiresTimeout === true) {
                        // this schedules a new simulation step
                        this._startRendering();
                    }

                    this._redraw();

                    if (this.requiresTimeout === false) {
                        // this schedules a new simulation step
                        this._startRendering();
                    }
                }
            }
            /**
             * Redraw the network with the current data
             * chart will be resized too.
             */

        }, {
            key: "redraw",
            value: function redraw() {
                this.body.emitter.emit("setSize");

                this._redraw();
            }
            /**
             * Redraw the network with the current data
             *
             * @private
             */

        }, {
            key: "_requestRedraw",
            value: function _requestRedraw() {
                var _this2 = this;

                if (this.redrawRequested !== true && this.renderingActive === false && this.allowRedraw === true) {
                    this.redrawRequested = true;

                    this._requestNextFrame(function () {
                        _this2._redraw(false);
                    }, 0);
                }
            }
            /**
             * Redraw the network with the current data
             *
             * @param {boolean} [hidden=false] | Used to get the first estimate of the node sizes.
             *                                   Only the nodes are drawn after which they are quickly drawn over.
             * @private
             */

        }, {
            key: "_redraw",
            value: function _redraw() {
                var hidden = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                if (this.allowRedraw === true) {
                    this.body.emitter.emit("initRedraw");
                    this.redrawRequested = false;
                    var drawLater = {
                        drawExternalLabels: null
                    }; // when the container div was hidden, this fixes it back up!

                    if (this.canvas.frame.canvas.width === 0 || this.canvas.frame.canvas.height === 0) {
                        this.canvas.setSize();
                    }

                    this.canvas.setTransform();
                    var ctx = this.canvas.getContext(); // clear the canvas

                    var w = this.canvas.frame.canvas.clientWidth;
                    var h = this.canvas.frame.canvas.clientHeight;
                    ctx.clearRect(0, 0, w, h); // if the div is hidden, we stop the redraw here for performance.

                    if (this.canvas.frame.clientWidth === 0) {
                        return;
                    } // set scaling and translation


                    ctx.save();
                    ctx.translate(this.body.view.translation.x, this.body.view.translation.y);
                    ctx.scale(this.body.view.scale, this.body.view.scale);
                    ctx.beginPath();
                    this.body.emitter.emit("beforeDrawing", ctx);
                    ctx.closePath();

                    if (hidden === false) {
                        if ((this.dragging === false || this.dragging === true && this.options.hideEdgesOnDrag === false) && (this.zooming === false || this.zooming === true && this.options.hideEdgesOnZoom === false)) {
                            this._drawEdges(ctx);
                        }
                    }

                    if (this.dragging === false || this.dragging === true && this.options.hideNodesOnDrag === false) {
                        var _this$_drawNodes = this._drawNodes(ctx, hidden),
                            drawExternalLabels = _this$_drawNodes.drawExternalLabels;

                        drawLater.drawExternalLabels = drawExternalLabels;
                    } // draw the arrows last so they will be at the top


                    if (hidden === false) {
                        if ((this.dragging === false || this.dragging === true && this.options.hideEdgesOnDrag === false) && (this.zooming === false || this.zooming === true && this.options.hideEdgesOnZoom === false)) {
                            this._drawArrows(ctx);
                        }
                    }

                    if (drawLater.drawExternalLabels != null) {
                        drawLater.drawExternalLabels();
                    }

                    if (hidden === false) {
                        this._drawSelectionBox(ctx);
                    }

                    ctx.beginPath();
                    this.body.emitter.emit("afterDrawing", ctx);
                    ctx.closePath(); // restore original scaling and translation

                    ctx.restore();

                    if (hidden === true) {
                        ctx.clearRect(0, 0, w, h);
                    }
                }
            }
            /**
             * Redraw all nodes
             *
             * @param {CanvasRenderingContext2D}   ctx
             * @param {boolean} [alwaysShow]
             * @private
             */

        }, {
            key: "_resizeNodes",
            value: function _resizeNodes() {
                this.canvas.setTransform();
                var ctx = this.canvas.getContext();
                ctx.save();
                ctx.translate(this.body.view.translation.x, this.body.view.translation.y);
                ctx.scale(this.body.view.scale, this.body.view.scale);
                var nodes = this.body.nodes;
                var node; // resize all nodes

                for (var nodeId in nodes) {
                    if (Object.prototype.hasOwnProperty.call(nodes, nodeId)) {
                        node = nodes[nodeId];
                        node.resize(ctx);
                        node.updateBoundingBox(ctx, node.selected);
                    }
                } // restore original scaling and translation


                ctx.restore();
            }
            /**
             * Redraw all nodes
             *
             * @param {CanvasRenderingContext2D} ctx  2D context of a HTML canvas
             * @param {boolean} [alwaysShow]
             * @private
             *
             * @returns {object} Callbacks to draw later on higher layers.
             */

        }, {
            key: "_drawNodes",
            value: function _drawNodes(ctx) {
                var alwaysShow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var nodes = this.body.nodes;
                var nodeIndices = this.body.nodeIndices;
                var node;
                var selected = [];
                var hovered = [];
                var margin = 20;
                var topLeft = this.canvas.DOMtoCanvas({
                    x: -margin,
                    y: -margin
                });
                var bottomRight = this.canvas.DOMtoCanvas({
                    x: this.canvas.frame.canvas.clientWidth + margin,
                    y: this.canvas.frame.canvas.clientHeight + margin
                });
                var viewableArea = {
                    top: topLeft.y,
                    left: topLeft.x,
                    bottom: bottomRight.y,
                    right: bottomRight.x
                };
                var _drawExternalLabels = []; // draw unselected nodes;

                for (var _i = 0; _i < nodeIndices.length; _i++) {
                    node = nodes[nodeIndices[_i]]; // set selected and hovered nodes aside

                    if (node.hover) {
                        hovered.push(nodeIndices[_i]);
                    } else if (node.isSelected()) {
                        selected.push(nodeIndices[_i]);
                    } else {
                        if (alwaysShow === true) {
                            var drawLater = node.draw(ctx);

                            if (drawLater.drawExternalLabel != null) {
                                _drawExternalLabels.push(drawLater.drawExternalLabel);
                            }
                        } else if (node.isBoundingBoxOverlappingWith(viewableArea) === true) {
                            var _drawLater = node.draw(ctx);

                            if (_drawLater.drawExternalLabel != null) {
                                _drawExternalLabels.push(_drawLater.drawExternalLabel);
                            }
                        } else {
                            node.updateBoundingBox(ctx, node.selected);
                        }
                    }
                }

                var i;
                var selectedLength = selected.length;
                var hoveredLength = hovered.length; // draw the selected nodes on top

                for (i = 0; i < selectedLength; i++) {
                    node = nodes[selected[i]];

                    var _drawLater2 = node.draw(ctx);

                    if (_drawLater2.drawExternalLabel != null) {
                        _drawExternalLabels.push(_drawLater2.drawExternalLabel);
                    }
                } // draw hovered nodes above everything else: fixes https://github.com/visjs/vis-network/issues/226


                for (i = 0; i < hoveredLength; i++) {
                    node = nodes[hovered[i]];

                    var _drawLater3 = node.draw(ctx);

                    if (_drawLater3.drawExternalLabel != null) {
                        _drawExternalLabels.push(_drawLater3.drawExternalLabel);
                    }
                }

                return {
                    drawExternalLabels: function drawExternalLabels() {
                        var _iterator = _createForOfIteratorHelper$5(_drawExternalLabels),
                            _step;

                        try {
                            for (_iterator.s(); !(_step = _iterator.n()).done;) {
                                var draw = _step.value;
                                draw();
                            }
                        } catch (err) {
                            _iterator.e(err);
                        } finally {
                            _iterator.f();
                        }
                    }
                };
            }
            /**
             * Redraw all edges
             *
             * @param {CanvasRenderingContext2D} ctx  2D context of a HTML canvas
             * @private
             */

        }, {
            key: "_drawEdges",
            value: function _drawEdges(ctx) {
                var edges = this.body.edges;
                var edgeIndices = this.body.edgeIndices;

                for (var i = 0; i < edgeIndices.length; i++) {
                    var edge = edges[edgeIndices[i]];

                    if (edge.connected === true) {
                        edge.draw(ctx);
                    }
                }
            }
            /**
             * Redraw all arrows
             *
             * @param {CanvasRenderingContext2D} ctx  2D context of a HTML canvas
             * @private
             */

        }, {
            key: "_drawArrows",
            value: function _drawArrows(ctx) {
                var edges = this.body.edges;
                var edgeIndices = this.body.edgeIndices;

                for (var i = 0; i < edgeIndices.length; i++) {
                    var edge = edges[edgeIndices[i]];

                    if (edge.connected === true) {
                        edge.drawArrows(ctx);
                    }
                }
            }
            /**
             * Determine if the browser requires a setTimeout or a requestAnimationFrame. This was required because
             * some implementations (safari and IE9) did not support requestAnimationFrame
             *
             * @private
             */

        }, {
            key: "_determineBrowserMethod",
            value: function _determineBrowserMethod() {
                if (typeof window !== "undefined") {
                    var browserType = navigator.userAgent.toLowerCase();
                    this.requiresTimeout = false;

                    if (indexOf(browserType).call(browserType, "msie 9.0") != -1) {
                        // IE 9
                        this.requiresTimeout = true;
                    } else if (indexOf(browserType).call(browserType, "safari") != -1) {
                        // safari
                        if (indexOf(browserType).call(browserType, "chrome") <= -1) {
                            this.requiresTimeout = true;
                        }
                    }
                } else {
                    this.requiresTimeout = true;
                }
            }
            /**
             * Redraw selection box
             *
             * @param {CanvasRenderingContext2D} ctx  2D context of a HTML canvas
             * @private
             */

        }, {
            key: "_drawSelectionBox",
            value: function _drawSelectionBox(ctx) {
                if (this.body.selectionBox.show) {
                    ctx.beginPath();
                    var width = this.body.selectionBox.position.end.x - this.body.selectionBox.position.start.x;
                    var height = this.body.selectionBox.position.end.y - this.body.selectionBox.position.start.y;
                    ctx.rect(this.body.selectionBox.position.start.x, this.body.selectionBox.position.start.y, width, height);
                    ctx.fillStyle = "rgba(151, 194, 252, 0.2)";
                    ctx.fillRect(this.body.selectionBox.position.start.x, this.body.selectionBox.position.start.y, width, height);
                    ctx.strokeStyle = "rgba(151, 194, 252, 1)";
                    ctx.stroke();
                } else {
                    ctx.closePath();
                }
            }
        }]);

        return CanvasRenderer;
    }();

    var setInterval$1 = path.setInterval;

    var setInterval = setInterval$1;

    /**
     * Register a touch event, taking place before a gesture
     *
     * @param {Hammer} hammer       A hammer instance
     * @param {Function} callback   Callback, called as callback(event)
     */
    function onTouch(hammer, callback) {
        callback.inputHandler = function (event) {
            if (event.isFirst) {
                callback(event);
            }
        };

        hammer.on("hammer.input", callback.inputHandler);
    }
    /**
     * Register a release event, taking place after a gesture
     *
     * @param {Hammer} hammer       A hammer instance
     * @param {Function} callback   Callback, called as callback(event)
     * @returns {*}
     */

    function onRelease(hammer, callback) {
        callback.inputHandler = function (event) {
            if (event.isFinal) {
                callback(event);
            }
        };

        return hammer.on("hammer.input", callback.inputHandler);
    }

    /**
     * Create the main frame for the Network.
     * This function is executed once when a Network object is created. The frame
     * contains a canvas, and this canvas contains all objects like the axis and
     * nodes.
     */

    var Canvas = /*#__PURE__*/function () {
        /**
         * @param {object} body
         */
        function Canvas(body) {
            _classCallCheck(this, Canvas);

            this.body = body;
            this.pixelRatio = 1;
            this.cameraState = {};
            this.initialized = false;
            this.canvasViewCenter = {};
            this._cleanupCallbacks = [];
            this.options = {};
            this.defaultOptions = {
                autoResize: true,
                height: "100%",
                width: "100%"
            };

            assign$2(this.options, this.defaultOptions);

            this.bindEventListeners();
        }
        /**
         * Binds event listeners
         */


        _createClass(Canvas, [{
            key: "bindEventListeners",
            value: function bindEventListeners() {
                var _this = this,
                    _context;

                // bind the events
                this.body.emitter.once("resize", function (obj) {
                    if (obj.width !== 0) {
                        _this.body.view.translation.x = obj.width * 0.5;
                    }

                    if (obj.height !== 0) {
                        _this.body.view.translation.y = obj.height * 0.5;
                    }
                });
                this.body.emitter.on("setSize", bind(_context = this.setSize).call(_context, this));
                this.body.emitter.on("destroy", function () {
                    _this.hammerFrame.destroy();

                    _this.hammer.destroy();

                    _this._cleanUp();
                });
            }
            /**
             * @param {object} options
             */

        }, {
            key: "setOptions",
            value: function setOptions(options) {
                var _this2 = this;

                if (options !== undefined) {
                    var fields = ["width", "height", "autoResize"];
                    selectiveDeepExtend(fields, this.options, options);
                } // Automatically adapt to changing size of the container element.


                this._cleanUp();

                if (this.options.autoResize === true) {
                    var _context2;

                    if (window.ResizeObserver) {
                        // decent browsers, immediate reactions
                        var observer = new ResizeObserver(function () {
                            var changed = _this2.setSize();

                            if (changed === true) {
                                _this2.body.emitter.emit("_requestRedraw");
                            }
                        });
                        var frame = this.frame;
                        observer.observe(frame);

                        this._cleanupCallbacks.push(function () {
                            observer.unobserve(frame);
                        });
                    } else {
                        // IE11, continous polling
                        var resizeTimer = setInterval(function () {
                            var changed = _this2.setSize();

                            if (changed === true) {
                                _this2.body.emitter.emit("_requestRedraw");
                            }
                        }, 1000);

                        this._cleanupCallbacks.push(function () {
                            clearInterval(resizeTimer);
                        });
                    } // Automatically adapt to changing size of the browser.


                    var resizeFunction = bind(_context2 = this._onResize).call(_context2, this);

                    addEventListener(window, "resize", resizeFunction);

                    this._cleanupCallbacks.push(function () {
                        removeEventListener(window, "resize", resizeFunction);
                    });
                }
            }
            /**
             * @private
             */

        }, {
            key: "_cleanUp",
            value: function _cleanUp() {
                var _context3, _context4, _context5;

                forEach$2(_context3 = reverse(_context4 = splice(_context5 = this._cleanupCallbacks).call(_context5, 0)).call(_context4)).call(_context3, function (callback) {
                    try {
                        callback();
                    } catch (error) {
                        console.error(error);
                    }
                });
            }
            /**
             * @private
             */

        }, {
            key: "_onResize",
            value: function _onResize() {
                this.setSize();
                this.body.emitter.emit("_redraw");
            }
            /**
             * Get and store the cameraState
             *
             * @param {number} [pixelRatio=this.pixelRatio]
             * @private
             */

        }, {
            key: "_getCameraState",
            value: function _getCameraState() {
                var pixelRatio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.pixelRatio;

                if (this.initialized === true) {
                    this.cameraState.previousWidth = this.frame.canvas.width / pixelRatio;
                    this.cameraState.previousHeight = this.frame.canvas.height / pixelRatio;
                    this.cameraState.scale = this.body.view.scale;
                    this.cameraState.position = this.DOMtoCanvas({
                        x: 0.5 * this.frame.canvas.width / pixelRatio,
                        y: 0.5 * this.frame.canvas.height / pixelRatio
                    });
                }
            }
            /**
             * Set the cameraState
             *
             * @private
             */

        }, {
            key: "_setCameraState",
            value: function _setCameraState() {
                if (this.cameraState.scale !== undefined && this.frame.canvas.clientWidth !== 0 && this.frame.canvas.clientHeight !== 0 && this.pixelRatio !== 0 && this.cameraState.previousWidth > 0 && this.cameraState.previousHeight > 0) {
                    var widthRatio = this.frame.canvas.width / this.pixelRatio / this.cameraState.previousWidth;
                    var heightRatio = this.frame.canvas.height / this.pixelRatio / this.cameraState.previousHeight;
                    var newScale = this.cameraState.scale;

                    if (widthRatio != 1 && heightRatio != 1) {
                        newScale = this.cameraState.scale * 0.5 * (widthRatio + heightRatio);
                    } else if (widthRatio != 1) {
                        newScale = this.cameraState.scale * widthRatio;
                    } else if (heightRatio != 1) {
                        newScale = this.cameraState.scale * heightRatio;
                    }

                    this.body.view.scale = newScale; // this comes from the view module.

                    var currentViewCenter = this.DOMtoCanvas({
                        x: 0.5 * this.frame.canvas.clientWidth,
                        y: 0.5 * this.frame.canvas.clientHeight
                    });
                    var distanceFromCenter = {
                        // offset from view, distance view has to change by these x and y to center the node
                        x: currentViewCenter.x - this.cameraState.position.x,
                        y: currentViewCenter.y - this.cameraState.position.y
                    };
                    this.body.view.translation.x += distanceFromCenter.x * this.body.view.scale;
                    this.body.view.translation.y += distanceFromCenter.y * this.body.view.scale;
                }
            }
            /**
             *
             * @param {number|string} value
             * @returns {string}
             * @private
             */

        }, {
            key: "_prepareValue",
            value: function _prepareValue(value) {
                if (typeof value === "number") {
                    return value + "px";
                } else if (typeof value === "string") {
                    if (indexOf(value).call(value, "%") !== -1 || indexOf(value).call(value, "px") !== -1) {
                        return value;
                    } else if (indexOf(value).call(value, "%") === -1) {
                        return value + "px";
                    }
                }

                throw new Error("Could not use the value supplied for width or height:" + value);
            }
            /**
             * Create the HTML
             */

        }, {
            key: "_create",
            value: function _create() {
                // remove all elements from the container element.
                while (this.body.container.hasChildNodes()) {
                    this.body.container.removeChild(this.body.container.firstChild);
                }

                this.frame = document.createElement("div");
                this.frame.className = "vis-network";
                this.frame.style.position = "relative";
                this.frame.style.overflow = "hidden";
                this.frame.tabIndex = 0; // tab index is required for keycharm to bind keystrokes to the div instead of the window
                //////////////////////////////////////////////////////////////////

                this.frame.canvas = document.createElement("canvas");
                this.frame.canvas.style.position = "relative";
                this.frame.appendChild(this.frame.canvas);

                if (!this.frame.canvas.getContext) {
                    var noCanvas = document.createElement("DIV");
                    noCanvas.style.color = "red";
                    noCanvas.style.fontWeight = "bold";
                    noCanvas.style.padding = "10px";
                    noCanvas.innerText = "Error: your browser does not support HTML canvas";
                    this.frame.canvas.appendChild(noCanvas);
                } else {
                    this._setPixelRatio();

                    this.setTransform();
                } // add the frame to the container element


                this.body.container.appendChild(this.frame);
                this.body.view.scale = 1;
                this.body.view.translation = {
                    x: 0.5 * this.frame.canvas.clientWidth,
                    y: 0.5 * this.frame.canvas.clientHeight
                };

                this._bindHammer();
            }
            /**
             * This function binds hammer, it can be repeated over and over due to the uniqueness check.
             *
             * @private
             */

        }, {
            key: "_bindHammer",
            value: function _bindHammer() {
                var _this3 = this;

                if (this.hammer !== undefined) {
                    this.hammer.destroy();
                }

                this.drag = {};
                this.pinch = {}; // init hammer

                this.hammer = new Hammer$1(this.frame.canvas);
                this.hammer.get("pinch").set({
                    enable: true
                }); // enable to get better response, todo: test on mobile.

                this.hammer.get("pan").set({
                    threshold: 5,
                    direction: Hammer$1.DIRECTION_ALL
                });
                onTouch(this.hammer, function (event) {
                    _this3.body.eventListeners.onTouch(event);
                });
                this.hammer.on("tap", function (event) {
                    _this3.body.eventListeners.onTap(event);
                });
                this.hammer.on("doubletap", function (event) {
                    _this3.body.eventListeners.onDoubleTap(event);
                });
                this.hammer.on("press", function (event) {
                    _this3.body.eventListeners.onHold(event);
                });
                this.hammer.on("panstart", function (event) {
                    _this3.body.eventListeners.onDragStart(event);
                });
                this.hammer.on("panmove", function (event) {
                    _this3.body.eventListeners.onDrag(event);
                });
                this.hammer.on("panend", function (event) {
                    _this3.body.eventListeners.onDragEnd(event);
                });
                this.hammer.on("pinch", function (event) {
                    _this3.body.eventListeners.onPinch(event);
                }); // TODO: neatly cleanup these handlers when re-creating the Canvas, IF these are done with hammer, event.stopPropagation will not work?

                this.frame.canvas.addEventListener("wheel", function (event) {
                    _this3.body.eventListeners.onMouseWheel(event);
                });
                this.frame.canvas.addEventListener("mousemove", function (event) {
                    _this3.body.eventListeners.onMouseMove(event);
                });
                this.frame.canvas.addEventListener("contextmenu", function (event) {
                    _this3.body.eventListeners.onContext(event);
                });
                this.hammerFrame = new Hammer$1(this.frame);
                onRelease(this.hammerFrame, function (event) {
                    _this3.body.eventListeners.onRelease(event);
                });
            }
            /**
             * Set a new size for the network
             *
             * @param {string} width   Width in pixels or percentage (for example '800px'
             *                         or '50%')
             * @param {string} height  Height in pixels or percentage  (for example '400px'
             *                         or '30%')
             * @returns {boolean}
             */

        }, {
            key: "setSize",
            value: function setSize() {
                var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.width;
                var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.height;
                width = this._prepareValue(width);
                height = this._prepareValue(height);
                var emitEvent = false;
                var oldWidth = this.frame.canvas.width;
                var oldHeight = this.frame.canvas.height; // update the pixel ratio
                //
                // NOTE: Comment in following is rather inconsistent; this is the ONLY place in the code
                //       where it is assumed that the pixel ratio could change at runtime.
                //       The only way I can think of this happening is a rotating screen or tablet; but then
                //       there should be a mechanism for reloading the data (TODO: check if this is present).
                //
                //       If the assumption is true (i.e. pixel ratio can change at runtime), then *all* usage
                //       of pixel ratio must be overhauled for this.
                //
                //       For the time being, I will humor the assumption here, and in the rest of the code assume it is
                //       constant.

                var previousRatio = this.pixelRatio; // we cache this because the camera state storage needs the old value

                this._setPixelRatio();

                if (width != this.options.width || height != this.options.height || this.frame.style.width != width || this.frame.style.height != height) {
                    this._getCameraState(previousRatio);

                    this.frame.style.width = width;
                    this.frame.style.height = height;
                    this.frame.canvas.style.width = "100%";
                    this.frame.canvas.style.height = "100%";
                    this.frame.canvas.width = Math.round(this.frame.canvas.clientWidth * this.pixelRatio);
                    this.frame.canvas.height = Math.round(this.frame.canvas.clientHeight * this.pixelRatio);
                    this.options.width = width;
                    this.options.height = height;
                    this.canvasViewCenter = {
                        x: 0.5 * this.frame.clientWidth,
                        y: 0.5 * this.frame.clientHeight
                    };
                    emitEvent = true;
                } else {
                    // this would adapt the width of the canvas to the width from 100% if and only if
                    // there is a change.
                    var newWidth = Math.round(this.frame.canvas.clientWidth * this.pixelRatio);
                    var newHeight = Math.round(this.frame.canvas.clientHeight * this.pixelRatio); // store the camera if there is a change in size.

                    if (this.frame.canvas.width !== newWidth || this.frame.canvas.height !== newHeight) {
                        this._getCameraState(previousRatio);
                    }

                    if (this.frame.canvas.width !== newWidth) {
                        this.frame.canvas.width = newWidth;
                        emitEvent = true;
                    }

                    if (this.frame.canvas.height !== newHeight) {
                        this.frame.canvas.height = newHeight;
                        emitEvent = true;
                    }
                }

                if (emitEvent === true) {
                    this.body.emitter.emit("resize", {
                        width: Math.round(this.frame.canvas.width / this.pixelRatio),
                        height: Math.round(this.frame.canvas.height / this.pixelRatio),
                        oldWidth: Math.round(oldWidth / this.pixelRatio),
                        oldHeight: Math.round(oldHeight / this.pixelRatio)
                    }); // restore the camera on change.

                    this._setCameraState();
                } // set initialized so the get and set camera will work from now on.


                this.initialized = true;
                return emitEvent;
            }
            /**
             *
             * @returns {CanvasRenderingContext2D}
             */

        }, {
            key: "getContext",
            value: function getContext() {
                return this.frame.canvas.getContext("2d");
            }
            /**
             * Determine the pixel ratio for various browsers.
             *
             * @returns {number}
             * @private
             */

        }, {
            key: "_determinePixelRatio",
            value: function _determinePixelRatio() {
                var ctx = this.getContext();

                if (ctx === undefined) {
                    throw new Error("Could not get canvax context");
                }

                var numerator = 1;

                if (typeof window !== "undefined") {
                    // (window !== undefined) doesn't work here!
                    // Protection during unit tests, where 'window' can be missing
                    numerator = window.devicePixelRatio || 1;
                }

                var denominator = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
                return numerator / denominator;
            }
            /**
             * Lazy determination of pixel ratio.
             *
             * @private
             */

        }, {
            key: "_setPixelRatio",
            value: function _setPixelRatio() {
                this.pixelRatio = this._determinePixelRatio();
            }
            /**
             * Set the transform in the contained context, based on its pixelRatio
             */

        }, {
            key: "setTransform",
            value: function setTransform() {
                var ctx = this.getContext();

                if (ctx === undefined) {
                    throw new Error("Could not get canvax context");
                }

                ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
            }
            /**
             * Convert the X coordinate in DOM-space (coordinate point in browser relative to the container div) to
             * the X coordinate in canvas-space (the simulation sandbox, which the camera looks upon)
             *
             * @param {number} x
             * @returns {number}
             * @private
             */

        }, {
            key: "_XconvertDOMtoCanvas",
            value: function _XconvertDOMtoCanvas(x) {
                return (x - this.body.view.translation.x) / this.body.view.scale;
            }
            /**
             * Convert the X coordinate in canvas-space (the simulation sandbox, which the camera looks upon) to
             * the X coordinate in DOM-space (coordinate point in browser relative to the container div)
             *
             * @param {number} x
             * @returns {number}
             * @private
             */

        }, {
            key: "_XconvertCanvasToDOM",
            value: function _XconvertCanvasToDOM(x) {
                return x * this.body.view.scale + this.body.view.translation.x;
            }
            /**
             * Convert the Y coordinate in DOM-space (coordinate point in browser relative to the container div) to
             * the Y coordinate in canvas-space (the simulation sandbox, which the camera looks upon)
             *
             * @param {number} y
             * @returns {number}
             * @private
             */

        }, {
            key: "_YconvertDOMtoCanvas",
            value: function _YconvertDOMtoCanvas(y) {
                return (y - this.body.view.translation.y) / this.body.view.scale;
            }
            /**
             * Convert the Y coordinate in canvas-space (the simulation sandbox, which the camera looks upon) to
             * the Y coordinate in DOM-space (coordinate point in browser relative to the container div)
             *
             * @param {number} y
             * @returns {number}
             * @private
             */

        }, {
            key: "_YconvertCanvasToDOM",
            value: function _YconvertCanvasToDOM(y) {
                return y * this.body.view.scale + this.body.view.translation.y;
            }
            /**
             * @param {point} pos
             * @returns {point}
             */

        }, {
            key: "canvasToDOM",
            value: function canvasToDOM(pos) {
                return {
                    x: this._XconvertCanvasToDOM(pos.x),
                    y: this._YconvertCanvasToDOM(pos.y)
                };
            }
            /**
             *
             * @param {point} pos
             * @returns {point}
             */

        }, {
            key: "DOMtoCanvas",
            value: function DOMtoCanvas(pos) {
                return {
                    x: this._XconvertDOMtoCanvas(pos.x),
                    y: this._YconvertDOMtoCanvas(pos.y)
                };
            }
        }]);

        return Canvas;
    }();

    /**
     * Validate the fit options, replace missing optional values by defaults etc.
     *
     * @param rawOptions - The raw options.
     * @param allNodeIds - All node ids that will be used if nodes are omitted in
     * the raw options.
     *
     * @returns Options with everything filled in and validated.
     */
    function normalizeFitOptions(rawOptions, allNodeIds) {
        var options = assign$2({
            nodes: allNodeIds,
            minZoomLevel: Number.MIN_VALUE,
            maxZoomLevel: 1
        }, rawOptions !== null && rawOptions !== void 0 ? rawOptions : {});

        if (!isArray(options.nodes)) {
            throw new TypeError("Nodes has to be an array of ids.");
        }

        if (options.nodes.length === 0) {
            options.nodes = allNodeIds;
        }

        if (!(typeof options.minZoomLevel === "number" && options.minZoomLevel > 0)) {
            throw new TypeError("Min zoom level has to be a number higher than zero.");
        }

        if (!(typeof options.maxZoomLevel === "number" && options.minZoomLevel <= options.maxZoomLevel)) {
            throw new TypeError("Max zoom level has to be a number higher than min zoom level.");
        }

        return options;
    }

    /**
     * The view
     */

    var View = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {Canvas} canvas
         */
        function View(body, canvas) {
            var _context,
                _this = this,
                _context2;

            _classCallCheck(this, View);

            this.body = body;
            this.canvas = canvas;
            this.animationSpeed = 1 / this.renderRefreshRate;
            this.animationEasingFunction = "easeInOutQuint";
            this.easingTime = 0;
            this.sourceScale = 0;
            this.targetScale = 0;
            this.sourceTranslation = 0;
            this.targetTranslation = 0;
            this.lockedOnNodeId = undefined;
            this.lockedOnNodeOffset = undefined;
            this.touchTime = 0;
            this.viewFunction = undefined;
            this.body.emitter.on("fit", bind(_context = this.fit).call(_context, this));
            this.body.emitter.on("animationFinished", function () {
                _this.body.emitter.emit("_stopRendering");
            });
            this.body.emitter.on("unlockNode", bind(_context2 = this.releaseNode).call(_context2, this));
        }
        /**
         *
         * @param {object} [options={}]
         */


        _createClass(View, [{
            key: "setOptions",
            value: function setOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                this.options = options;
            }
            /**
             * This function zooms out to fit all data on screen based on amount of nodes
             *
             * @param {object} [options={{nodes=Array}}]
             * @param {boolean} [initialZoom=false]  | zoom based on fitted formula or range, true = fitted, default = false;
             */

        }, {
            key: "fit",
            value: function fit(options) {
                var initialZoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                options = normalizeFitOptions(options, this.body.nodeIndices);
                var canvasWidth = this.canvas.frame.canvas.clientWidth;
                var canvasHeight = this.canvas.frame.canvas.clientHeight;
                var range;
                var zoomLevel;

                if (canvasWidth === 0 || canvasHeight === 0) {
                    // There's no point in trying to fit into zero sized canvas. This could
                    // potentially even result in invalid values being computed. For example
                    // for network without nodes and zero sized canvas the zoom level would
                    // end up being computed as 0/0 which results in NaN. In any other case
                    // this would be 0/something which is again pointless to compute.
                    zoomLevel = 1;
                    range = NetworkUtil.getRange(this.body.nodes, options.nodes);
                } else if (initialZoom === true) {
                    // check if more than half of the nodes have a predefined position. If so, we use the range, not the approximation.
                    var positionDefined = 0;

                    for (var nodeId in this.body.nodes) {
                        if (Object.prototype.hasOwnProperty.call(this.body.nodes, nodeId)) {
                            var node = this.body.nodes[nodeId];

                            if (node.predefinedPosition === true) {
                                positionDefined += 1;
                            }
                        }
                    }

                    if (positionDefined > 0.5 * this.body.nodeIndices.length) {
                        this.fit(options, false);
                        return;
                    }

                    range = NetworkUtil.getRange(this.body.nodes, options.nodes);
                    var numberOfNodes = this.body.nodeIndices.length;
                    zoomLevel = 12.662 / (numberOfNodes + 7.4147) + 0.0964822; // this is obtained from fitting a dataset from 5 points with scale levels that looked good.
                    // correct for larger canvasses.

                    var factor = Math.min(canvasWidth / 600, canvasHeight / 600);
                    zoomLevel *= factor;
                } else {
                    this.body.emitter.emit("_resizeNodes");
                    range = NetworkUtil.getRange(this.body.nodes, options.nodes);
                    var xDistance = Math.abs(range.maxX - range.minX) * 1.1;
                    var yDistance = Math.abs(range.maxY - range.minY) * 1.1;
                    var xZoomLevel = canvasWidth / xDistance;
                    var yZoomLevel = canvasHeight / yDistance;
                    zoomLevel = xZoomLevel <= yZoomLevel ? xZoomLevel : yZoomLevel;
                }

                if (zoomLevel > options.maxZoomLevel) {
                    zoomLevel = options.maxZoomLevel;
                } else if (zoomLevel < options.minZoomLevel) {
                    zoomLevel = options.minZoomLevel;
                }

                var center = NetworkUtil.findCenter(range);
                var animationOptions = {
                    position: center,
                    scale: zoomLevel,
                    animation: options.animation
                };
                this.moveTo(animationOptions);
            } // animation

            /**
             * Center a node in view.
             *
             * @param {number} nodeId
             * @param {number} [options]
             */

        }, {
            key: "focus",
            value: function focus(nodeId) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                if (this.body.nodes[nodeId] !== undefined) {
                    var nodePosition = {
                        x: this.body.nodes[nodeId].x,
                        y: this.body.nodes[nodeId].y
                    };
                    options.position = nodePosition;
                    options.lockedOnNode = nodeId;
                    this.moveTo(options);
                } else {
                    console.error("Node: " + nodeId + " cannot be found.");
                }
            }
            /**
             *
             * @param {object} options  |  options.offset   = {x:number, y:number}   // offset from the center in DOM pixels
             *                          |  options.scale    = number                 // scale to move to
             *                          |  options.position = {x:number, y:number}   // position to move to
             *                          |  options.animation = {duration:number, easingFunction:String} || Boolean   // position to move to
             */

        }, {
            key: "moveTo",
            value: function moveTo(options) {
                if (options === undefined) {
                    options = {};
                    return;
                }

                if (options.offset != null) {
                    if (options.offset.x != null) {
                        // Coerce and verify that x is valid.
                        options.offset.x = +options.offset.x;

                        if (!_isFinite(options.offset.x)) {
                            throw new TypeError('The option "offset.x" has to be a finite number.');
                        }
                    } else {
                        options.offset.x = 0;
                    }

                    if (options.offset.y != null) {
                        // Coerce and verify that y is valid.
                        options.offset.y = +options.offset.y;

                        if (!_isFinite(options.offset.y)) {
                            throw new TypeError('The option "offset.y" has to be a finite number.');
                        }
                    } else {
                        options.offset.x = 0;
                    }
                } else {
                    options.offset = {
                        x: 0,
                        y: 0
                    };
                }

                if (options.position != null) {
                    if (options.position.x != null) {
                        // Coerce and verify that x is valid.
                        options.position.x = +options.position.x;

                        if (!_isFinite(options.position.x)) {
                            throw new TypeError('The option "position.x" has to be a finite number.');
                        }
                    } else {
                        options.position.x = 0;
                    }

                    if (options.position.y != null) {
                        // Coerce and verify that y is valid.
                        options.position.y = +options.position.y;

                        if (!_isFinite(options.position.y)) {
                            throw new TypeError('The option "position.y" has to be a finite number.');
                        }
                    } else {
                        options.position.x = 0;
                    }
                } else {
                    options.position = this.getViewPosition();
                }

                if (options.scale != null) {
                    // Coerce and verify that the scale is valid.
                    options.scale = +options.scale;

                    if (!(options.scale > 0)) {
                        throw new TypeError('The option "scale" has to be a number greater than zero.');
                    }
                } else {
                    options.scale = this.body.view.scale;
                }

                if (options.animation === undefined) {
                    options.animation = {
                        duration: 0
                    };
                }

                if (options.animation === false) {
                    options.animation = {
                        duration: 0
                    };
                }

                if (options.animation === true) {
                    options.animation = {};
                }

                if (options.animation.duration === undefined) {
                    options.animation.duration = 1000;
                } // default duration


                if (options.animation.easingFunction === undefined) {
                    options.animation.easingFunction = "easeInOutQuad";
                } // default easing function


                this.animateView(options);
            }
            /**
             *
             * @param {object} options  |  options.offset   = {x:number, y:number}   // offset from the center in DOM pixels
             *                          |  options.time     = number                 // animation time in milliseconds
             *                          |  options.scale    = number                 // scale to animate to
             *                          |  options.position = {x:number, y:number}   // position to animate to
             *                          |  options.easingFunction = String           // linear, easeInQuad, easeOutQuad, easeInOutQuad,
             *                                                                       // easeInCubic, easeOutCubic, easeInOutCubic,
             *                                                                       // easeInQuart, easeOutQuart, easeInOutQuart,
             *                                                                       // easeInQuint, easeOutQuint, easeInOutQuint
             */

        }, {
            key: "animateView",
            value: function animateView(options) {
                if (options === undefined) {
                    return;
                }

                this.animationEasingFunction = options.animation.easingFunction; // release if something focussed on the node

                this.releaseNode();

                if (options.locked === true) {
                    this.lockedOnNodeId = options.lockedOnNode;
                    this.lockedOnNodeOffset = options.offset;
                } // forcefully complete the old animation if it was still running


                if (this.easingTime != 0) {
                    this._transitionRedraw(true); // by setting easingtime to 1, we finish the animation.

                }

                this.sourceScale = this.body.view.scale;
                this.sourceTranslation = this.body.view.translation;
                this.targetScale = options.scale; // set the scale so the viewCenter is based on the correct zoom level. This is overridden in the transitionRedraw
                // but at least then we'll have the target transition

                this.body.view.scale = this.targetScale;
                var viewCenter = this.canvas.DOMtoCanvas({
                    x: 0.5 * this.canvas.frame.canvas.clientWidth,
                    y: 0.5 * this.canvas.frame.canvas.clientHeight
                });
                var distanceFromCenter = {
                    // offset from view, distance view has to change by these x and y to center the node
                    x: viewCenter.x - options.position.x,
                    y: viewCenter.y - options.position.y
                };
                this.targetTranslation = {
                    x: this.sourceTranslation.x + distanceFromCenter.x * this.targetScale + options.offset.x,
                    y: this.sourceTranslation.y + distanceFromCenter.y * this.targetScale + options.offset.y
                }; // if the time is set to 0, don't do an animation

                if (options.animation.duration === 0) {
                    if (this.lockedOnNodeId != undefined) {
                        var _context3;

                        this.viewFunction = bind(_context3 = this._lockedRedraw).call(_context3, this);
                        this.body.emitter.on("initRedraw", this.viewFunction);
                    } else {
                        this.body.view.scale = this.targetScale;
                        this.body.view.translation = this.targetTranslation;
                        this.body.emitter.emit("_requestRedraw");
                    }
                } else {
                    var _context4;

                    this.animationSpeed = 1 / (60 * options.animation.duration * 0.001) || 1 / 60; // 60 for 60 seconds, 0.001 for milli's

                    this.animationEasingFunction = options.animation.easingFunction;
                    this.viewFunction = bind(_context4 = this._transitionRedraw).call(_context4, this);
                    this.body.emitter.on("initRedraw", this.viewFunction);
                    this.body.emitter.emit("_startRendering");
                }
            }
            /**
             * used to animate smoothly by hijacking the redraw function.
             *
             * @private
             */

        }, {
            key: "_lockedRedraw",
            value: function _lockedRedraw() {
                var nodePosition = {
                    x: this.body.nodes[this.lockedOnNodeId].x,
                    y: this.body.nodes[this.lockedOnNodeId].y
                };
                var viewCenter = this.canvas.DOMtoCanvas({
                    x: 0.5 * this.canvas.frame.canvas.clientWidth,
                    y: 0.5 * this.canvas.frame.canvas.clientHeight
                });
                var distanceFromCenter = {
                    // offset from view, distance view has to change by these x and y to center the node
                    x: viewCenter.x - nodePosition.x,
                    y: viewCenter.y - nodePosition.y
                };
                var sourceTranslation = this.body.view.translation;
                var targetTranslation = {
                    x: sourceTranslation.x + distanceFromCenter.x * this.body.view.scale + this.lockedOnNodeOffset.x,
                    y: sourceTranslation.y + distanceFromCenter.y * this.body.view.scale + this.lockedOnNodeOffset.y
                };
                this.body.view.translation = targetTranslation;
            }
            /**
             * Resets state of a locked on Node
             */

        }, {
            key: "releaseNode",
            value: function releaseNode() {
                if (this.lockedOnNodeId !== undefined && this.viewFunction !== undefined) {
                    this.body.emitter.off("initRedraw", this.viewFunction);
                    this.lockedOnNodeId = undefined;
                    this.lockedOnNodeOffset = undefined;
                }
            }
            /**
             * @param {boolean} [finished=false]
             * @private
             */

        }, {
            key: "_transitionRedraw",
            value: function _transitionRedraw() {
                var finished = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                this.easingTime += this.animationSpeed;
                this.easingTime = finished === true ? 1.0 : this.easingTime;
                var progress = easingFunctions[this.animationEasingFunction](this.easingTime);
                this.body.view.scale = this.sourceScale + (this.targetScale - this.sourceScale) * progress;
                this.body.view.translation = {
                    x: this.sourceTranslation.x + (this.targetTranslation.x - this.sourceTranslation.x) * progress,
                    y: this.sourceTranslation.y + (this.targetTranslation.y - this.sourceTranslation.y) * progress
                }; // cleanup

                if (this.easingTime >= 1.0) {
                    this.body.emitter.off("initRedraw", this.viewFunction);
                    this.easingTime = 0;

                    if (this.lockedOnNodeId != undefined) {
                        var _context5;

                        this.viewFunction = bind(_context5 = this._lockedRedraw).call(_context5, this);
                        this.body.emitter.on("initRedraw", this.viewFunction);
                    }

                    this.body.emitter.emit("animationFinished");
                }
            }
            /**
             *
             * @returns {number}
             */

        }, {
            key: "getScale",
            value: function getScale() {
                return this.body.view.scale;
            }
            /**
             *
             * @returns {{x: number, y: number}}
             */

        }, {
            key: "getViewPosition",
            value: function getViewPosition() {
                return this.canvas.DOMtoCanvas({
                    x: 0.5 * this.canvas.frame.canvas.clientWidth,
                    y: 0.5 * this.canvas.frame.canvas.clientHeight
                });
            }
        }]);

        return View;
    }();

    var css_248z$1 = "div.vis-network div.vis-navigation div.vis-button {\n  width: 34px;\n  height: 34px;\n  -moz-border-radius: 17px;\n  border-radius: 17px;\n  position: absolute;\n  display: inline-block;\n  background-position: 2px 2px;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\ndiv.vis-network div.vis-navigation div.vis-button:hover {\n  box-shadow: 0 0 3px 3px rgba(56, 207, 21, 0.3);\n}\n\ndiv.vis-network div.vis-navigation div.vis-button:active {\n  box-shadow: 0 0 1px 3px rgba(56, 207, 21, 0.95);\n}\n\ndiv.vis-network div.vis-navigation div.vis-button.vis-up {\n  background-image: url('data:image/png;base64,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');\n  bottom: 50px;\n  left: 55px;\n}\ndiv.vis-network div.vis-navigation div.vis-button.vis-down {\n  background-image: url('data:image/png;base64,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');\n  bottom: 10px;\n  left: 55px;\n}\ndiv.vis-network div.vis-navigation div.vis-button.vis-left {\n  background-image: url('data:image/png;base64,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');\n  bottom: 10px;\n  left: 15px;\n}\ndiv.vis-network div.vis-navigation div.vis-button.vis-right {\n  background-image: url('data:image/png;base64,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');\n  bottom: 10px;\n  left: 95px;\n}\ndiv.vis-network div.vis-navigation div.vis-button.vis-zoomIn {\n  background-image: url('data:image/png;base64,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');\n  bottom: 10px;\n  right: 15px;\n}\ndiv.vis-network div.vis-navigation div.vis-button.vis-zoomOut {\n  background-image: url('data:image/png;base64,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');\n  bottom: 10px;\n  right: 55px;\n}\ndiv.vis-network div.vis-navigation div.vis-button.vis-zoomExtends {\n  background-image: url('data:image/png;base64,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');\n  bottom: 50px;\n  right: 15px;\n}\n";
    styleInject(css_248z$1);

    /**
     * Created by Alex on 11/6/2014.
     */
    function keycharm(options) {
        var preventDefault = options && options.preventDefault || false;
        var container = options && options.container || window;
        var _exportFunctions = {};
        var _bound = {
            keydown: {},
            keyup: {}
        };
        var _keys = {};
        var i; // a - z

        for (i = 97; i <= 122; i++) {
            _keys[String.fromCharCode(i)] = {
                code: 65 + (i - 97),
                shift: false
            };
        } // A - Z


        for (i = 65; i <= 90; i++) {
            _keys[String.fromCharCode(i)] = {
                code: i,
                shift: true
            };
        } // 0 - 9


        for (i = 0; i <= 9; i++) {
            _keys['' + i] = {
                code: 48 + i,
                shift: false
            };
        } // F1 - F12


        for (i = 1; i <= 12; i++) {
            _keys['F' + i] = {
                code: 111 + i,
                shift: false
            };
        } // num0 - num9


        for (i = 0; i <= 9; i++) {
            _keys['num' + i] = {
                code: 96 + i,
                shift: false
            };
        } // numpad misc


        _keys['num*'] = {
            code: 106,
            shift: false
        };
        _keys['num+'] = {
            code: 107,
            shift: false
        };
        _keys['num-'] = {
            code: 109,
            shift: false
        };
        _keys['num/'] = {
            code: 111,
            shift: false
        };
        _keys['num.'] = {
            code: 110,
            shift: false
        }; // arrows

        _keys['left'] = {
            code: 37,
            shift: false
        };
        _keys['up'] = {
            code: 38,
            shift: false
        };
        _keys['right'] = {
            code: 39,
            shift: false
        };
        _keys['down'] = {
            code: 40,
            shift: false
        }; // extra keys

        _keys['space'] = {
            code: 32,
            shift: false
        };
        _keys['enter'] = {
            code: 13,
            shift: false
        };
        _keys['shift'] = {
            code: 16,
            shift: undefined
        };
        _keys['esc'] = {
            code: 27,
            shift: false
        };
        _keys['backspace'] = {
            code: 8,
            shift: false
        };
        _keys['tab'] = {
            code: 9,
            shift: false
        };
        _keys['ctrl'] = {
            code: 17,
            shift: false
        };
        _keys['alt'] = {
            code: 18,
            shift: false
        };
        _keys['delete'] = {
            code: 46,
            shift: false
        };
        _keys['pageup'] = {
            code: 33,
            shift: false
        };
        _keys['pagedown'] = {
            code: 34,
            shift: false
        }; // symbols

        _keys['='] = {
            code: 187,
            shift: false
        };
        _keys['-'] = {
            code: 189,
            shift: false
        };
        _keys[']'] = {
            code: 221,
            shift: false
        };
        _keys['['] = {
            code: 219,
            shift: false
        };

        var down = function (event) {
            handleEvent(event, 'keydown');
        };

        var up = function (event) {
            handleEvent(event, 'keyup');
        }; // handle the actualy bound key with the event


        var handleEvent = function (event, type) {
            if (_bound[type][event.keyCode] !== undefined) {
                var bound = _bound[type][event.keyCode];

                for (var i = 0; i < bound.length; i++) {
                    if (bound[i].shift === undefined) {
                        bound[i].fn(event);
                    } else if (bound[i].shift == true && event.shiftKey == true) {
                        bound[i].fn(event);
                    } else if (bound[i].shift == false && event.shiftKey == false) {
                        bound[i].fn(event);
                    }
                }

                if (preventDefault == true) {
                    event.preventDefault();
                }
            }
        }; // bind a key to a callback


        _exportFunctions.bind = function (key, callback, type) {
            if (type === undefined) {
                type = 'keydown';
            }

            if (_keys[key] === undefined) {
                throw new Error("unsupported key: " + key);
            }

            if (_bound[type][_keys[key].code] === undefined) {
                _bound[type][_keys[key].code] = [];
            }

            _bound[type][_keys[key].code].push({
                fn: callback,
                shift: _keys[key].shift
            });
        }; // bind all keys to a call back (demo purposes)


        _exportFunctions.bindAll = function (callback, type) {
            if (type === undefined) {
                type = 'keydown';
            }

            for (var key in _keys) {
                if (_keys.hasOwnProperty(key)) {
                    _exportFunctions.bind(key, callback, type);
                }
            }
        }; // get the key label from an event


        _exportFunctions.getKey = function (event) {
            for (var key in _keys) {
                if (_keys.hasOwnProperty(key)) {
                    if (event.shiftKey == true && _keys[key].shift == true && event.keyCode == _keys[key].code) {
                        return key;
                    } else if (event.shiftKey == false && _keys[key].shift == false && event.keyCode == _keys[key].code) {
                        return key;
                    } else if (event.keyCode == _keys[key].code && key == 'shift') {
                        return key;
                    }
                }
            }

            return "unknown key, currently not supported";
        }; // unbind either a specific callback from a key or all of them (by leaving callback undefined)


        _exportFunctions.unbind = function (key, callback, type) {
            if (type === undefined) {
                type = 'keydown';
            }

            if (_keys[key] === undefined) {
                throw new Error("unsupported key: " + key);
            }

            if (callback !== undefined) {
                var newBindings = [];
                var bound = _bound[type][_keys[key].code];

                if (bound !== undefined) {
                    for (var i = 0; i < bound.length; i++) {
                        if (!(bound[i].fn == callback && bound[i].shift == _keys[key].shift)) {
                            newBindings.push(_bound[type][_keys[key].code][i]);
                        }
                    }
                }

                _bound[type][_keys[key].code] = newBindings;
            } else {
                _bound[type][_keys[key].code] = [];
            }
        }; // reset all bound variables.


        _exportFunctions.reset = function () {
            _bound = {
                keydown: {},
                keyup: {}
            };
        }; // unbind all listeners and reset all variables.


        _exportFunctions.destroy = function () {
            _bound = {
                keydown: {},
                keyup: {}
            };
            container.removeEventListener('keydown', down, true);
            container.removeEventListener('keyup', up, true);
        }; // create listeners.


        container.addEventListener('keydown', down, true);
        container.addEventListener('keyup', up, true); // return the public functions.

        return _exportFunctions;
    }

    /**
     * Navigation Handler
     */

    var NavigationHandler = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {Canvas} canvas
         */
        function NavigationHandler(body, canvas) {
            var _this = this;

            _classCallCheck(this, NavigationHandler);

            this.body = body;
            this.canvas = canvas;
            this.iconsCreated = false;
            this.navigationHammers = [];
            this.boundFunctions = {};
            this.touchTime = 0;
            this.activated = false;
            this.body.emitter.on("activate", function () {
                _this.activated = true;

                _this.configureKeyboardBindings();
            });
            this.body.emitter.on("deactivate", function () {
                _this.activated = false;

                _this.configureKeyboardBindings();
            });
            this.body.emitter.on("destroy", function () {
                if (_this.keycharm !== undefined) {
                    _this.keycharm.destroy();
                }
            });
            this.options = {};
        }
        /**
         *
         * @param {object} options
         */


        _createClass(NavigationHandler, [{
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    this.options = options;
                    this.create();
                }
            }
            /**
             * Creates or refreshes navigation and sets key bindings
             */

        }, {
            key: "create",
            value: function create() {
                if (this.options.navigationButtons === true) {
                    if (this.iconsCreated === false) {
                        this.loadNavigationElements();
                    }
                } else if (this.iconsCreated === true) {
                    this.cleanNavigation();
                }

                this.configureKeyboardBindings();
            }
            /**
             * Cleans up previous navigation items
             */

        }, {
            key: "cleanNavigation",
            value: function cleanNavigation() {
                // clean hammer bindings
                if (this.navigationHammers.length != 0) {
                    for (var i = 0; i < this.navigationHammers.length; i++) {
                        this.navigationHammers[i].destroy();
                    }

                    this.navigationHammers = [];
                } // clean up previous navigation items


                if (this.navigationDOM && this.navigationDOM["wrapper"] && this.navigationDOM["wrapper"].parentNode) {
                    this.navigationDOM["wrapper"].parentNode.removeChild(this.navigationDOM["wrapper"]);
                }

                this.iconsCreated = false;
            }
            /**
             * Creation of the navigation controls nodes. They are drawn over the rest of the nodes and are not affected by scale and translation
             * they have a triggerFunction which is called on click. If the position of the navigation controls is dependent
             * on this.frame.canvas.clientWidth or this.frame.canvas.clientHeight, we flag horizontalAlignLeft and verticalAlignTop false.
             * This means that the location will be corrected by the _relocateNavigation function on a size change of the canvas.
             *
             * @private
             */

        }, {
            key: "loadNavigationElements",
            value: function loadNavigationElements() {
                var _this2 = this;

                this.cleanNavigation();
                this.navigationDOM = {};
                var navigationDivs = ["up", "down", "left", "right", "zoomIn", "zoomOut", "zoomExtends"];
                var navigationDivActions = ["_moveUp", "_moveDown", "_moveLeft", "_moveRight", "_zoomIn", "_zoomOut", "_fit"];
                this.navigationDOM["wrapper"] = document.createElement("div");
                this.navigationDOM["wrapper"].className = "vis-navigation";
                this.canvas.frame.appendChild(this.navigationDOM["wrapper"]);

                for (var i = 0; i < navigationDivs.length; i++) {
                    this.navigationDOM[navigationDivs[i]] = document.createElement("div");
                    this.navigationDOM[navigationDivs[i]].className = "vis-button vis-" + navigationDivs[i];
                    this.navigationDOM["wrapper"].appendChild(this.navigationDOM[navigationDivs[i]]);
                    var hammer = new Hammer$1(this.navigationDOM[navigationDivs[i]]);

                    if (navigationDivActions[i] === "_fit") {
                        var _context;

                        onTouch(hammer, bind(_context = this._fit).call(_context, this));
                    } else {
                        var _context2;

                        onTouch(hammer, bind(_context2 = this.bindToRedraw).call(_context2, this, navigationDivActions[i]));
                    }

                    this.navigationHammers.push(hammer);
                } // use a hammer for the release so we do not require the one used in the rest of the network
                // the one the rest uses can be overloaded by the manipulation system.


                var hammerFrame = new Hammer$1(this.canvas.frame);
                onRelease(hammerFrame, function () {
                    _this2._stopMovement();
                });
                this.navigationHammers.push(hammerFrame);
                this.iconsCreated = true;
            }
            /**
             *
             * @param {string} action
             */

        }, {
            key: "bindToRedraw",
            value: function bindToRedraw(action) {
                if (this.boundFunctions[action] === undefined) {
                    var _context3;

                    this.boundFunctions[action] = bind(_context3 = this[action]).call(_context3, this);
                    this.body.emitter.on("initRedraw", this.boundFunctions[action]);
                    this.body.emitter.emit("_startRendering");
                }
            }
            /**
             *
             * @param {string} action
             */

        }, {
            key: "unbindFromRedraw",
            value: function unbindFromRedraw(action) {
                if (this.boundFunctions[action] !== undefined) {
                    this.body.emitter.off("initRedraw", this.boundFunctions[action]);
                    this.body.emitter.emit("_stopRendering");
                    delete this.boundFunctions[action];
                }
            }
            /**
             * this stops all movement induced by the navigation buttons
             *
             * @private
             */

        }, {
            key: "_fit",
            value: function _fit() {
                if (new Date().valueOf() - this.touchTime > 700) {
                    // TODO: fix ugly hack to avoid hammer's double fireing of event (because we use release?)
                    this.body.emitter.emit("fit", {
                        duration: 700
                    });
                    this.touchTime = new Date().valueOf();
                }
            }
            /**
             * this stops all movement induced by the navigation buttons
             *
             * @private
             */

        }, {
            key: "_stopMovement",
            value: function _stopMovement() {
                for (var boundAction in this.boundFunctions) {
                    if (Object.prototype.hasOwnProperty.call(this.boundFunctions, boundAction)) {
                        this.body.emitter.off("initRedraw", this.boundFunctions[boundAction]);
                        this.body.emitter.emit("_stopRendering");
                    }
                }

                this.boundFunctions = {};
            }
            /**
             *
             * @private
             */

        }, {
            key: "_moveUp",
            value: function _moveUp() {
                this.body.view.translation.y += this.options.keyboard.speed.y;
            }
            /**
             *
             * @private
             */

        }, {
            key: "_moveDown",
            value: function _moveDown() {
                this.body.view.translation.y -= this.options.keyboard.speed.y;
            }
            /**
             *
             * @private
             */

        }, {
            key: "_moveLeft",
            value: function _moveLeft() {
                this.body.view.translation.x += this.options.keyboard.speed.x;
            }
            /**
             *
             * @private
             */

        }, {
            key: "_moveRight",
            value: function _moveRight() {
                this.body.view.translation.x -= this.options.keyboard.speed.x;
            }
            /**
             *
             * @private
             */

        }, {
            key: "_zoomIn",
            value: function _zoomIn() {
                var scaleOld = this.body.view.scale;
                var scale = this.body.view.scale * (1 + this.options.keyboard.speed.zoom);
                var translation = this.body.view.translation;
                var scaleFrac = scale / scaleOld;
                var tx = (1 - scaleFrac) * this.canvas.canvasViewCenter.x + translation.x * scaleFrac;
                var ty = (1 - scaleFrac) * this.canvas.canvasViewCenter.y + translation.y * scaleFrac;
                this.body.view.scale = scale;
                this.body.view.translation = {
                    x: tx,
                    y: ty
                };
                this.body.emitter.emit("zoom", {
                    direction: "+",
                    scale: this.body.view.scale,
                    pointer: null
                });
            }
            /**
             *
             * @private
             */

        }, {
            key: "_zoomOut",
            value: function _zoomOut() {
                var scaleOld = this.body.view.scale;
                var scale = this.body.view.scale / (1 + this.options.keyboard.speed.zoom);
                var translation = this.body.view.translation;
                var scaleFrac = scale / scaleOld;
                var tx = (1 - scaleFrac) * this.canvas.canvasViewCenter.x + translation.x * scaleFrac;
                var ty = (1 - scaleFrac) * this.canvas.canvasViewCenter.y + translation.y * scaleFrac;
                this.body.view.scale = scale;
                this.body.view.translation = {
                    x: tx,
                    y: ty
                };
                this.body.emitter.emit("zoom", {
                    direction: "-",
                    scale: this.body.view.scale,
                    pointer: null
                });
            }
            /**
             * bind all keys using keycharm.
             */

        }, {
            key: "configureKeyboardBindings",
            value: function configureKeyboardBindings() {
                var _this3 = this;

                if (this.keycharm !== undefined) {
                    this.keycharm.destroy();
                }

                if (this.options.keyboard.enabled === true) {
                    if (this.options.keyboard.bindToWindow === true) {
                        this.keycharm = keycharm({
                            container: window,
                            preventDefault: true
                        });
                    } else {
                        this.keycharm = keycharm({
                            container: this.canvas.frame,
                            preventDefault: true
                        });
                    }

                    this.keycharm.reset();

                    if (this.activated === true) {
                        var _context4, _context5, _context6, _context7, _context8, _context9, _context10, _context11, _context12, _context13, _context14, _context15, _context16, _context17, _context18, _context19, _context20, _context21, _context22, _context23, _context24, _context25, _context26, _context27;

                        bind(_context4 = this.keycharm).call(_context4, "up", function () {
                            _this3.bindToRedraw("_moveUp");
                        }, "keydown");

                        bind(_context5 = this.keycharm).call(_context5, "down", function () {
                            _this3.bindToRedraw("_moveDown");
                        }, "keydown");

                        bind(_context6 = this.keycharm).call(_context6, "left", function () {
                            _this3.bindToRedraw("_moveLeft");
                        }, "keydown");

                        bind(_context7 = this.keycharm).call(_context7, "right", function () {
                            _this3.bindToRedraw("_moveRight");
                        }, "keydown");

                        bind(_context8 = this.keycharm).call(_context8, "=", function () {
                            _this3.bindToRedraw("_zoomIn");
                        }, "keydown");

                        bind(_context9 = this.keycharm).call(_context9, "num+", function () {
                            _this3.bindToRedraw("_zoomIn");
                        }, "keydown");

                        bind(_context10 = this.keycharm).call(_context10, "num-", function () {
                            _this3.bindToRedraw("_zoomOut");
                        }, "keydown");

                        bind(_context11 = this.keycharm).call(_context11, "-", function () {
                            _this3.bindToRedraw("_zoomOut");
                        }, "keydown");

                        bind(_context12 = this.keycharm).call(_context12, "[", function () {
                            _this3.bindToRedraw("_zoomOut");
                        }, "keydown");

                        bind(_context13 = this.keycharm).call(_context13, "]", function () {
                            _this3.bindToRedraw("_zoomIn");
                        }, "keydown");

                        bind(_context14 = this.keycharm).call(_context14, "pageup", function () {
                            _this3.bindToRedraw("_zoomIn");
                        }, "keydown");

                        bind(_context15 = this.keycharm).call(_context15, "pagedown", function () {
                            _this3.bindToRedraw("_zoomOut");
                        }, "keydown");

                        bind(_context16 = this.keycharm).call(_context16, "up", function () {
                            _this3.unbindFromRedraw("_moveUp");
                        }, "keyup");

                        bind(_context17 = this.keycharm).call(_context17, "down", function () {
                            _this3.unbindFromRedraw("_moveDown");
                        }, "keyup");

                        bind(_context18 = this.keycharm).call(_context18, "left", function () {
                            _this3.unbindFromRedraw("_moveLeft");
                        }, "keyup");

                        bind(_context19 = this.keycharm).call(_context19, "right", function () {
                            _this3.unbindFromRedraw("_moveRight");
                        }, "keyup");

                        bind(_context20 = this.keycharm).call(_context20, "=", function () {
                            _this3.unbindFromRedraw("_zoomIn");
                        }, "keyup");

                        bind(_context21 = this.keycharm).call(_context21, "num+", function () {
                            _this3.unbindFromRedraw("_zoomIn");
                        }, "keyup");

                        bind(_context22 = this.keycharm).call(_context22, "num-", function () {
                            _this3.unbindFromRedraw("_zoomOut");
                        }, "keyup");

                        bind(_context23 = this.keycharm).call(_context23, "-", function () {
                            _this3.unbindFromRedraw("_zoomOut");
                        }, "keyup");

                        bind(_context24 = this.keycharm).call(_context24, "[", function () {
                            _this3.unbindFromRedraw("_zoomOut");
                        }, "keyup");

                        bind(_context25 = this.keycharm).call(_context25, "]", function () {
                            _this3.unbindFromRedraw("_zoomIn");
                        }, "keyup");

                        bind(_context26 = this.keycharm).call(_context26, "pageup", function () {
                            _this3.unbindFromRedraw("_zoomIn");
                        }, "keyup");

                        bind(_context27 = this.keycharm).call(_context27, "pagedown", function () {
                            _this3.unbindFromRedraw("_zoomOut");
                        }, "keyup");
                    }
                }
            }
        }]);

        return NavigationHandler;
    }();

    function _createForOfIteratorHelper$4(o, allowArrayLike) { var it; if (typeof symbol === "undefined" || getIteratorMethod(o) == null) { if (isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

    function _unsupportedIterableToArray$4(o, minLen) { var _context15; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = slice$1(_context15 = Object.prototype.toString.call(o)).call(_context15, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return from$2(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }

    function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
    /**
     * Handler for interactions
     */

    var InteractionHandler = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {Canvas} canvas
         * @param {SelectionHandler} selectionHandler
         */
        function InteractionHandler(body, canvas, selectionHandler) {
            var _context, _context2, _context3, _context4, _context5, _context6, _context7, _context8, _context9, _context10, _context11, _context12, _context13;

            _classCallCheck(this, InteractionHandler);

            this.body = body;
            this.canvas = canvas;
            this.selectionHandler = selectionHandler;
            this.navigationHandler = new NavigationHandler(body, canvas); // bind the events from hammer to functions in this object

            this.body.eventListeners.onTap = bind(_context = this.onTap).call(_context, this);
            this.body.eventListeners.onTouch = bind(_context2 = this.onTouch).call(_context2, this);
            this.body.eventListeners.onDoubleTap = bind(_context3 = this.onDoubleTap).call(_context3, this);
            this.body.eventListeners.onHold = bind(_context4 = this.onHold).call(_context4, this);
            this.body.eventListeners.onDragStart = bind(_context5 = this.onDragStart).call(_context5, this);
            this.body.eventListeners.onDrag = bind(_context6 = this.onDrag).call(_context6, this);
            this.body.eventListeners.onDragEnd = bind(_context7 = this.onDragEnd).call(_context7, this);
            this.body.eventListeners.onMouseWheel = bind(_context8 = this.onMouseWheel).call(_context8, this);
            this.body.eventListeners.onPinch = bind(_context9 = this.onPinch).call(_context9, this);
            this.body.eventListeners.onMouseMove = bind(_context10 = this.onMouseMove).call(_context10, this);
            this.body.eventListeners.onRelease = bind(_context11 = this.onRelease).call(_context11, this);
            this.body.eventListeners.onContext = bind(_context12 = this.onContext).call(_context12, this);
            this.touchTime = 0;
            this.drag = {};
            this.pinch = {};
            this.popup = undefined;
            this.popupObj = undefined;
            this.popupTimer = undefined;
            this.body.functions.getPointer = bind(_context13 = this.getPointer).call(_context13, this);
            this.options = {};
            this.defaultOptions = {
                dragNodes: true,
                dragView: true,
                hover: false,
                keyboard: {
                    enabled: false,
                    speed: {
                        x: 10,
                        y: 10,
                        zoom: 0.02
                    },
                    bindToWindow: true
                },
                navigationButtons: false,
                tooltipDelay: 300,
                zoomView: true,
                zoomSpeed: 1
            };

            assign$2(this.options, this.defaultOptions);

            this.bindEventListeners();
        }
        /**
         * Binds event listeners
         */


        _createClass(InteractionHandler, [{
            key: "bindEventListeners",
            value: function bindEventListeners() {
                var _this = this;

                this.body.emitter.on("destroy", function () {
                    clearTimeout(_this.popupTimer);
                    delete _this.body.functions.getPointer;
                });
            }
            /**
             *
             * @param {object} options
             */

        }, {
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    // extend all but the values in fields
                    var fields = ["hideEdgesOnDrag", "hideEdgesOnZoom", "hideNodesOnDrag", "keyboard", "multiselect", "selectable", "selectConnectedEdges"];
                    selectiveNotDeepExtend(fields, this.options, options); // merge the keyboard options in.

                    mergeOptions(this.options, options, "keyboard");

                    if (options.tooltip) {
                        assign$2(this.options.tooltip, options.tooltip);

                        if (options.tooltip.color) {
                            this.options.tooltip.color = parseColor(options.tooltip.color);
                        }
                    }
                }

                this.navigationHandler.setOptions(this.options);
            }
            /**
             * Get the pointer location from a touch location
             *
             * @param {{x: number, y: number}} touch
             * @returns {{x: number, y: number}} pointer
             * @private
             */

        }, {
            key: "getPointer",
            value: function getPointer(touch) {
                return {
                    x: touch.x - getAbsoluteLeft(this.canvas.frame.canvas),
                    y: touch.y - getAbsoluteTop(this.canvas.frame.canvas)
                };
            }
            /**
             * On start of a touch gesture, store the pointer
             *
             * @param {Event}  event   The event
             * @private
             */

        }, {
            key: "onTouch",
            value: function onTouch(event) {
                if (new Date().valueOf() - this.touchTime > 50) {
                    this.drag.pointer = this.getPointer(event.center);
                    this.drag.pinched = false;
                    this.pinch.scale = this.body.view.scale; // to avoid double fireing of this event because we have two hammer instances. (on canvas and on frame)

                    this.touchTime = new Date().valueOf();
                }
            }
            /**
             * handle tap/click event: select/unselect a node
             *
             * @param {Event} event
             * @private
             */

        }, {
            key: "onTap",
            value: function onTap(event) {
                var pointer = this.getPointer(event.center);
                var multiselect = this.selectionHandler.options.multiselect && (event.changedPointers[0].ctrlKey || event.changedPointers[0].metaKey);
                this.checkSelectionChanges(pointer, multiselect);
                this.selectionHandler.commitAndEmit(pointer, event);
                this.selectionHandler.generateClickEvent("click", event, pointer);
            }
            /**
             * handle doubletap event
             *
             * @param {Event} event
             * @private
             */

        }, {
            key: "onDoubleTap",
            value: function onDoubleTap(event) {
                var pointer = this.getPointer(event.center);
                this.selectionHandler.generateClickEvent("doubleClick", event, pointer);
            }
            /**
             * handle long tap event: multi select nodes
             *
             * @param {Event} event
             * @private
             */

        }, {
            key: "onHold",
            value: function onHold(event) {
                var pointer = this.getPointer(event.center);
                var multiselect = this.selectionHandler.options.multiselect;
                this.checkSelectionChanges(pointer, multiselect);
                this.selectionHandler.commitAndEmit(pointer, event);
                this.selectionHandler.generateClickEvent("click", event, pointer);
                this.selectionHandler.generateClickEvent("hold", event, pointer);
            }
            /**
             * handle the release of the screen
             *
             * @param {Event} event
             * @private
             */

        }, {
            key: "onRelease",
            value: function onRelease(event) {
                if (new Date().valueOf() - this.touchTime > 10) {
                    var pointer = this.getPointer(event.center);
                    this.selectionHandler.generateClickEvent("release", event, pointer); // to avoid double fireing of this event because we have two hammer instances. (on canvas and on frame)

                    this.touchTime = new Date().valueOf();
                }
            }
            /**
             *
             * @param {Event} event
             */

        }, {
            key: "onContext",
            value: function onContext(event) {
                var pointer = this.getPointer({
                    x: event.clientX,
                    y: event.clientY
                });
                this.selectionHandler.generateClickEvent("oncontext", event, pointer);
            }
            /**
             * Select and deselect nodes depending current selection change.
             *
             * @param {{x: number, y: number}} pointer
             * @param {boolean} [add=false]
             */

        }, {
            key: "checkSelectionChanges",
            value: function checkSelectionChanges(pointer) {
                var add = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                if (add === true) {
                    this.selectionHandler.selectAdditionalOnPoint(pointer);
                } else {
                    this.selectionHandler.selectOnPoint(pointer);
                }
            }
            /**
             * Remove all node and edge id's from the first set that are present in the second one.
             *
             * @param {{nodes: Array.<Node>, edges: Array.<vis.Edge>}} firstSet
             * @param {{nodes: Array.<Node>, edges: Array.<vis.Edge>}} secondSet
             * @returns {{nodes: Array.<Node>, edges: Array.<vis.Edge>}}
             * @private
             */

        }, {
            key: "_determineDifference",
            value: function _determineDifference(firstSet, secondSet) {
                var arrayDiff = function arrayDiff(firstArr, secondArr) {
                    var result = [];

                    for (var i = 0; i < firstArr.length; i++) {
                        var value = firstArr[i];

                        if (indexOf(secondArr).call(secondArr, value) === -1) {
                            result.push(value);
                        }
                    }

                    return result;
                };

                return {
                    nodes: arrayDiff(firstSet.nodes, secondSet.nodes),
                    edges: arrayDiff(firstSet.edges, secondSet.edges)
                };
            }
            /**
             * This function is called by onDragStart.
             * It is separated out because we can then overload it for the datamanipulation system.
             *
             * @param {Event} event
             * @private
             */

        }, {
            key: "onDragStart",
            value: function onDragStart(event) {
                // if already dragging, do not start
                // this can happen on touch screens with multiple fingers
                if (this.drag.dragging) {
                    return;
                } //in case the touch event was triggered on an external div, do the initial touch now.


                if (this.drag.pointer === undefined) {
                    this.onTouch(event);
                } // note: drag.pointer is set in onTouch to get the initial touch location


                var node = this.selectionHandler.getNodeAt(this.drag.pointer);
                this.drag.dragging = true;
                this.drag.selection = [];
                this.drag.translation = assign$2({}, this.body.view.translation); // copy the object

                this.drag.nodeId = undefined;

                if (event.srcEvent.shiftKey) {
                    this.body.selectionBox.show = true;
                    var pointer = this.getPointer(event.center);
                    this.body.selectionBox.position.start = {
                        x: this.canvas._XconvertDOMtoCanvas(pointer.x),
                        y: this.canvas._YconvertDOMtoCanvas(pointer.y)
                    };
                    this.body.selectionBox.position.end = {
                        x: this.canvas._XconvertDOMtoCanvas(pointer.x),
                        y: this.canvas._YconvertDOMtoCanvas(pointer.y)
                    };
                }

                if (node !== undefined && this.options.dragNodes === true) {
                    this.drag.nodeId = node.id; // select the clicked node if not yet selected

                    if (node.isSelected() === false) {
                        this.selectionHandler.unselectAll();
                        this.selectionHandler.selectObject(node);
                    } // after select to contain the node


                    this.selectionHandler.generateClickEvent("dragStart", event, this.drag.pointer); // create an array with the selected nodes and their original location and status

                    var _iterator = _createForOfIteratorHelper$4(this.selectionHandler.getSelectedNodes()),
                        _step;

                    try {
                        for (_iterator.s(); !(_step = _iterator.n()).done;) {
                            var _node = _step.value;
                            var s = {
                                id: _node.id,
                                node: _node,
                                // store original x, y, xFixed and yFixed, make the node temporarily Fixed
                                x: _node.x,
                                y: _node.y,
                                xFixed: _node.options.fixed.x,
                                yFixed: _node.options.fixed.y
                            };
                            _node.options.fixed.x = true;
                            _node.options.fixed.y = true;
                            this.drag.selection.push(s);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally {
                        _iterator.f();
                    }
                } else {
                    // fallback if no node is selected and thus the view is dragged.
                    this.selectionHandler.generateClickEvent("dragStart", event, this.drag.pointer, undefined, true);
                }
            }
            /**
             * handle drag event
             *
             * @param {Event} event
             * @private
             */

        }, {
            key: "onDrag",
            value: function onDrag(event) {
                var _this2 = this;

                if (this.drag.pinched === true) {
                    return;
                } // remove the focus on node if it is focussed on by the focusOnNode


                this.body.emitter.emit("unlockNode");
                var pointer = this.getPointer(event.center);
                var selection = this.drag.selection;

                if (selection && selection.length && this.options.dragNodes === true) {
                    this.selectionHandler.generateClickEvent("dragging", event, pointer); // calculate delta's and new location

                    var deltaX = pointer.x - this.drag.pointer.x;
                    var deltaY = pointer.y - this.drag.pointer.y; // update position of all selected nodes

                    forEach$2(selection).call(selection, function (selection) {
                        var node = selection.node; // only move the node if it was not fixed initially

                        if (selection.xFixed === false) {
                            node.x = _this2.canvas._XconvertDOMtoCanvas(_this2.canvas._XconvertCanvasToDOM(selection.x) + deltaX);
                        } // only move the node if it was not fixed initially


                        if (selection.yFixed === false) {
                            node.y = _this2.canvas._YconvertDOMtoCanvas(_this2.canvas._YconvertCanvasToDOM(selection.y) + deltaY);
                        }
                    }); // start the simulation of the physics


                    this.body.emitter.emit("startSimulation");
                } else {
                    // create selection box
                    if (event.srcEvent.shiftKey) {
                        this.selectionHandler.generateClickEvent("dragging", event, pointer, undefined, true); // if the drag was not started properly because the click started outside the network div, start it now.

                        if (this.drag.pointer === undefined) {
                            this.onDragStart(event);
                            return;
                        }

                        this.body.selectionBox.position.end = {
                            x: this.canvas._XconvertDOMtoCanvas(pointer.x),
                            y: this.canvas._YconvertDOMtoCanvas(pointer.y)
                        };
                        this.body.emitter.emit("_requestRedraw");
                    } // move the network


                    if (this.options.dragView === true && !event.srcEvent.shiftKey) {
                        this.selectionHandler.generateClickEvent("dragging", event, pointer, undefined, true); // if the drag was not started properly because the click started outside the network div, start it now.

                        if (this.drag.pointer === undefined) {
                            this.onDragStart(event);
                            return;
                        }

                        var diffX = pointer.x - this.drag.pointer.x;
                        var diffY = pointer.y - this.drag.pointer.y;
                        this.body.view.translation = {
                            x: this.drag.translation.x + diffX,
                            y: this.drag.translation.y + diffY
                        };
                        this.body.emitter.emit("_requestRedraw");
                    }
                }
            }
            /**
             * handle drag start event
             *
             * @param {Event} event
             * @private
             */

        }, {
            key: "onDragEnd",
            value: function onDragEnd(event) {
                var _this3 = this;

                this.drag.dragging = false;

                if (this.body.selectionBox.show) {
                    var _context14;

                    this.body.selectionBox.show = false;
                    var selectionBoxPosition = this.body.selectionBox.position;
                    var selectionBoxPositionMinMax = {
                        minX: Math.min(selectionBoxPosition.start.x, selectionBoxPosition.end.x),
                        minY: Math.min(selectionBoxPosition.start.y, selectionBoxPosition.end.y),
                        maxX: Math.max(selectionBoxPosition.start.x, selectionBoxPosition.end.x),
                        maxY: Math.max(selectionBoxPosition.start.y, selectionBoxPosition.end.y)
                    };

                    var toBeSelectedNodes = filter(_context14 = this.body.nodeIndices).call(_context14, function (nodeId) {
                        var node = _this3.body.nodes[nodeId];
                        return node.x >= selectionBoxPositionMinMax.minX && node.x <= selectionBoxPositionMinMax.maxX && node.y >= selectionBoxPositionMinMax.minY && node.y <= selectionBoxPositionMinMax.maxY;
                    });

                    forEach$2(toBeSelectedNodes).call(toBeSelectedNodes, function (nodeId) {
                        return _this3.selectionHandler.selectObject(_this3.body.nodes[nodeId]);
                    });

                    var pointer = this.getPointer(event.center);
                    this.selectionHandler.commitAndEmit(pointer, event);
                    this.selectionHandler.generateClickEvent("dragEnd", event, this.getPointer(event.center), undefined, true);
                    this.body.emitter.emit("_requestRedraw");
                } else {
                    var selection = this.drag.selection;

                    if (selection && selection.length) {
                        forEach$2(selection).call(selection, function (s) {
                            // restore original xFixed and yFixed
                            s.node.options.fixed.x = s.xFixed;
                            s.node.options.fixed.y = s.yFixed;
                        });

                        this.selectionHandler.generateClickEvent("dragEnd", event, this.getPointer(event.center));
                        this.body.emitter.emit("startSimulation");
                    } else {
                        this.selectionHandler.generateClickEvent("dragEnd", event, this.getPointer(event.center), undefined, true);
                        this.body.emitter.emit("_requestRedraw");
                    }
                }
            }
            /**
             * Handle pinch event
             *
             * @param {Event}  event   The event
             * @private
             */

        }, {
            key: "onPinch",
            value: function onPinch(event) {
                var pointer = this.getPointer(event.center);
                this.drag.pinched = true;

                if (this.pinch["scale"] === undefined) {
                    this.pinch.scale = 1;
                } // TODO: enabled moving while pinching?


                var scale = this.pinch.scale * event.scale;
                this.zoom(scale, pointer);
            }
            /**
             * Zoom the network in or out
             *
             * @param {number} scale a number around 1, and between 0.01 and 10
             * @param {{x: number, y: number}} pointer    Position on screen
             * @private
             */

        }, {
            key: "zoom",
            value: function zoom(scale, pointer) {
                if (this.options.zoomView === true) {
                    var scaleOld = this.body.view.scale;

                    if (scale < 0.00001) {
                        scale = 0.00001;
                    }

                    if (scale > 10) {
                        scale = 10;
                    }

                    var preScaleDragPointer = undefined;

                    if (this.drag !== undefined) {
                        if (this.drag.dragging === true) {
                            preScaleDragPointer = this.canvas.DOMtoCanvas(this.drag.pointer);
                        }
                    } // + this.canvas.frame.canvas.clientHeight / 2


                    var translation = this.body.view.translation;
                    var scaleFrac = scale / scaleOld;
                    var tx = (1 - scaleFrac) * pointer.x + translation.x * scaleFrac;
                    var ty = (1 - scaleFrac) * pointer.y + translation.y * scaleFrac;
                    this.body.view.scale = scale;
                    this.body.view.translation = {
                        x: tx,
                        y: ty
                    };

                    if (preScaleDragPointer != undefined) {
                        var postScaleDragPointer = this.canvas.canvasToDOM(preScaleDragPointer);
                        this.drag.pointer.x = postScaleDragPointer.x;
                        this.drag.pointer.y = postScaleDragPointer.y;
                    }

                    this.body.emitter.emit("_requestRedraw");

                    if (scaleOld < scale) {
                        this.body.emitter.emit("zoom", {
                            direction: "+",
                            scale: this.body.view.scale,
                            pointer: pointer
                        });
                    } else {
                        this.body.emitter.emit("zoom", {
                            direction: "-",
                            scale: this.body.view.scale,
                            pointer: pointer
                        });
                    }
                }
            }
            /**
             * Event handler for mouse wheel event, used to zoom the timeline
             * See http://adomas.org/javascript-mouse-wheel/
             *     https://github.com/EightMedia/hammer.js/issues/256
             *
             * @param {MouseEvent}  event
             * @private
             */

        }, {
            key: "onMouseWheel",
            value: function onMouseWheel(event) {
                if (this.options.zoomView === true) {
                    // If delta is nonzero, handle it.
                    // Basically, delta is now positive if wheel was scrolled up,
                    // and negative, if wheel was scrolled down.
                    if (event.deltaY !== 0) {
                        // calculate the new scale
                        var scale = this.body.view.scale;
                        scale *= 1 + (event.deltaY < 0 ? 1 : -1) * (this.options.zoomSpeed * 0.1); // calculate the pointer location

                        var pointer = this.getPointer({
                            x: event.clientX,
                            y: event.clientY
                        }); // apply the new scale

                        this.zoom(scale, pointer);
                    } // Prevent default actions caused by mouse wheel.


                    event.preventDefault();
                }
            }
            /**
             * Mouse move handler for checking whether the title moves over a node with a title.
             *
             * @param  {Event} event
             * @private
             */

        }, {
            key: "onMouseMove",
            value: function onMouseMove(event) {
                var _this4 = this;

                var pointer = this.getPointer({
                    x: event.clientX,
                    y: event.clientY
                });
                var popupVisible = false; // check if the previously selected node is still selected

                if (this.popup !== undefined) {
                    if (this.popup.hidden === false) {
                        this._checkHidePopup(pointer);
                    } // if the popup was not hidden above


                    if (this.popup.hidden === false) {
                        popupVisible = true;
                        this.popup.setPosition(pointer.x + 3, pointer.y - 5);
                        this.popup.show();
                    }
                } // if we bind the keyboard to the div, we have to highlight it to use it. This highlights it on mouse over.


                if (this.options.keyboard.bindToWindow === false && this.options.keyboard.enabled === true) {
                    this.canvas.frame.focus();
                } // start a timeout that will check if the mouse is positioned above an element


                if (popupVisible === false) {
                    if (this.popupTimer !== undefined) {
                        clearInterval(this.popupTimer); // stop any running calculationTimer

                        this.popupTimer = undefined;
                    }

                    if (!this.drag.dragging) {
                        this.popupTimer = setTimeout$1(function () {
                            return _this4._checkShowPopup(pointer);
                        }, this.options.tooltipDelay);
                    }
                } // adding hover highlights


                if (this.options.hover === true) {
                    this.selectionHandler.hoverObject(event, pointer);
                }
            }
            /**
             * Check if there is an element on the given position in the network
             * (a node or edge). If so, and if this element has a title,
             * show a popup window with its title.
             *
             * @param {{x:number, y:number}} pointer
             * @private
             */

        }, {
            key: "_checkShowPopup",
            value: function _checkShowPopup(pointer) {
                var x = this.canvas._XconvertDOMtoCanvas(pointer.x);

                var y = this.canvas._YconvertDOMtoCanvas(pointer.y);

                var pointerObj = {
                    left: x,
                    top: y,
                    right: x,
                    bottom: y
                };
                var previousPopupObjId = this.popupObj === undefined ? undefined : this.popupObj.id;
                var nodeUnderCursor = false;
                var popupType = "node"; // check if a node is under the cursor.

                if (this.popupObj === undefined) {
                    // search the nodes for overlap, select the top one in case of multiple nodes
                    var nodeIndices = this.body.nodeIndices;
                    var nodes = this.body.nodes;
                    var node;
                    var overlappingNodes = [];

                    for (var i = 0; i < nodeIndices.length; i++) {
                        node = nodes[nodeIndices[i]];

                        if (node.isOverlappingWith(pointerObj) === true) {
                            nodeUnderCursor = true;

                            if (node.getTitle() !== undefined) {
                                overlappingNodes.push(nodeIndices[i]);
                            }
                        }
                    }

                    if (overlappingNodes.length > 0) {
                        // if there are overlapping nodes, select the last one, this is the one which is drawn on top of the others
                        this.popupObj = nodes[overlappingNodes[overlappingNodes.length - 1]]; // if you hover over a node, the title of the edge is not supposed to be shown.

                        nodeUnderCursor = true;
                    }
                }

                if (this.popupObj === undefined && nodeUnderCursor === false) {
                    // search the edges for overlap
                    var edgeIndices = this.body.edgeIndices;
                    var edges = this.body.edges;
                    var edge;
                    var overlappingEdges = [];

                    for (var _i = 0; _i < edgeIndices.length; _i++) {
                        edge = edges[edgeIndices[_i]];

                        if (edge.isOverlappingWith(pointerObj) === true) {
                            if (edge.connected === true && edge.getTitle() !== undefined) {
                                overlappingEdges.push(edgeIndices[_i]);
                            }
                        }
                    }

                    if (overlappingEdges.length > 0) {
                        this.popupObj = edges[overlappingEdges[overlappingEdges.length - 1]];
                        popupType = "edge";
                    }
                }

                if (this.popupObj !== undefined) {
                    // show popup message window
                    if (this.popupObj.id !== previousPopupObjId) {
                        if (this.popup === undefined) {
                            this.popup = new Popup$1(this.canvas.frame);
                        }

                        this.popup.popupTargetType = popupType;
                        this.popup.popupTargetId = this.popupObj.id; // adjust a small offset such that the mouse cursor is located in the
                        // bottom left location of the popup, and you can easily move over the
                        // popup area

                        this.popup.setPosition(pointer.x + 3, pointer.y - 5);
                        this.popup.setText(this.popupObj.getTitle());
                        this.popup.show();
                        this.body.emitter.emit("showPopup", this.popupObj.id);
                    }
                } else {
                    if (this.popup !== undefined) {
                        this.popup.hide();
                        this.body.emitter.emit("hidePopup");
                    }
                }
            }
            /**
             * Check if the popup must be hidden, which is the case when the mouse is no
             * longer hovering on the object
             *
             * @param {{x:number, y:number}} pointer
             * @private
             */

        }, {
            key: "_checkHidePopup",
            value: function _checkHidePopup(pointer) {
                var pointerObj = this.selectionHandler._pointerToPositionObject(pointer);

                var stillOnObj = false;

                if (this.popup.popupTargetType === "node") {
                    if (this.body.nodes[this.popup.popupTargetId] !== undefined) {
                        stillOnObj = this.body.nodes[this.popup.popupTargetId].isOverlappingWith(pointerObj); // if the mouse is still one the node, we have to check if it is not also on one that is drawn on top of it.
                        // we initially only check stillOnObj because this is much faster.

                        if (stillOnObj === true) {
                            var overNode = this.selectionHandler.getNodeAt(pointer);
                            stillOnObj = overNode === undefined ? false : overNode.id === this.popup.popupTargetId;
                        }
                    }
                } else {
                    if (this.selectionHandler.getNodeAt(pointer) === undefined) {
                        if (this.body.edges[this.popup.popupTargetId] !== undefined) {
                            stillOnObj = this.body.edges[this.popup.popupTargetId].isOverlappingWith(pointerObj);
                        }
                    }
                }

                if (stillOnObj === false) {
                    this.popupObj = undefined;
                    this.popup.hide();
                    this.body.emitter.emit("hidePopup");
                }
            }
        }]);

        return InteractionHandler;
    }();

    var getWeakData = internalMetadata.getWeakData;
    var setInternalState = internalState.set;
    var internalStateGetterFor = internalState.getterFor;
    var find = arrayIteration.find;
    var findIndex = arrayIteration.findIndex;
    var id = 0; // fallback for uncaught frozen keys

    var uncaughtFrozenStore = function (store) {
        return store.frozen || (store.frozen = new UncaughtFrozenStore());
    };

    var UncaughtFrozenStore = function () {
        this.entries = [];
    };

    var findUncaughtFrozen = function (store, key) {
        return find(store.entries, function (it) {
            return it[0] === key;
        });
    };

    UncaughtFrozenStore.prototype = {
        get: function (key) {
            var entry = findUncaughtFrozen(this, key);
            if (entry) return entry[1];
        },
        has: function (key) {
            return !!findUncaughtFrozen(this, key);
        },
        set: function (key, value) {
            var entry = findUncaughtFrozen(this, key);
            if (entry) entry[1] = value;else this.entries.push([key, value]);
        },
        'delete': function (key) {
            var index = findIndex(this.entries, function (it) {
                return it[0] === key;
            });
            if (~index) this.entries.splice(index, 1);
            return !!~index;
        }
    };
    var collectionWeak = {
        getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
            var C = wrapper(function (that, iterable) {
                anInstance(that, C, CONSTRUCTOR_NAME);
                setInternalState(that, {
                    type: CONSTRUCTOR_NAME,
                    id: id++,
                    frozen: undefined
                });
                if (iterable != undefined) iterate(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
            });
            var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

            var define = function (that, key, value) {
                var state = getInternalState(that);
                var data = getWeakData(anObject(key), true);
                if (data === true) uncaughtFrozenStore(state).set(key, value);else data[state.id] = value;
                return that;
            };

            redefineAll(C.prototype, {
                // 23.3.3.2 WeakMap.prototype.delete(key)
                // 23.4.3.3 WeakSet.prototype.delete(value)
                'delete': function (key) {
                    var state = getInternalState(this);
                    if (!isObject$1(key)) return false;
                    var data = getWeakData(key);
                    if (data === true) return uncaughtFrozenStore(state)['delete'](key);
                    return data && has$1(data, state.id) && delete data[state.id];
                },
                // 23.3.3.4 WeakMap.prototype.has(key)
                // 23.4.3.4 WeakSet.prototype.has(value)
                has: function has(key) {
                    var state = getInternalState(this);
                    if (!isObject$1(key)) return false;
                    var data = getWeakData(key);
                    if (data === true) return uncaughtFrozenStore(state).has(key);
                    return data && has$1(data, state.id);
                }
            });
            redefineAll(C.prototype, IS_MAP ? {
                // 23.3.3.3 WeakMap.prototype.get(key)
                get: function get(key) {
                    var state = getInternalState(this);

                    if (isObject$1(key)) {
                        var data = getWeakData(key);
                        if (data === true) return uncaughtFrozenStore(state).get(key);
                        return data ? data[state.id] : undefined;
                    }
                },
                // 23.3.3.5 WeakMap.prototype.set(key, value)
                set: function set(key, value) {
                    return define(this, key, value);
                }
            } : {
                // 23.4.3.1 WeakSet.prototype.add(value)
                add: function add(value) {
                    return define(this, value, true);
                }
            });
            return C;
        }
    };

    createCommonjsModule(function (module) {

        var enforceIternalState = internalState.enforce;
        var IS_IE11 = !global$1.ActiveXObject && 'ActiveXObject' in global$1;
        var isExtensible = Object.isExtensible;
        var InternalWeakMap;

        var wrapper = function (init) {
            return function WeakMap() {
                return init(this, arguments.length ? arguments[0] : undefined);
            };
        }; // `WeakMap` constructor
        // https://tc39.es/ecma262/#sec-weakmap-constructor


        var $WeakMap = module.exports = collection('WeakMap', wrapper, collectionWeak); // IE11 WeakMap frozen keys fix
        // We can't use feature detection because it crash some old IE builds
        // https://github.com/zloirock/core-js/issues/485

        if (nativeWeakMap && IS_IE11) {
            InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
            internalMetadata.REQUIRED = true;
            var WeakMapPrototype = $WeakMap.prototype;
            var nativeDelete = WeakMapPrototype['delete'];
            var nativeHas = WeakMapPrototype.has;
            var nativeGet = WeakMapPrototype.get;
            var nativeSet = WeakMapPrototype.set;
            redefineAll(WeakMapPrototype, {
                'delete': function (key) {
                    if (isObject$1(key) && !isExtensible(key)) {
                        var state = enforceIternalState(this);
                        if (!state.frozen) state.frozen = new InternalWeakMap();
                        return nativeDelete.call(this, key) || state.frozen['delete'](key);
                    }

                    return nativeDelete.call(this, key);
                },
                has: function has(key) {
                    if (isObject$1(key) && !isExtensible(key)) {
                        var state = enforceIternalState(this);
                        if (!state.frozen) state.frozen = new InternalWeakMap();
                        return nativeHas.call(this, key) || state.frozen.has(key);
                    }

                    return nativeHas.call(this, key);
                },
                get: function get(key) {
                    if (isObject$1(key) && !isExtensible(key)) {
                        var state = enforceIternalState(this);
                        if (!state.frozen) state.frozen = new InternalWeakMap();
                        return nativeHas.call(this, key) ? nativeGet.call(this, key) : state.frozen.get(key);
                    }

                    return nativeGet.call(this, key);
                },
                set: function set(key, value) {
                    if (isObject$1(key) && !isExtensible(key)) {
                        var state = enforceIternalState(this);
                        if (!state.frozen) state.frozen = new InternalWeakMap();
                        nativeHas.call(this, key) ? nativeSet.call(this, key, value) : state.frozen.set(key, value);
                    } else nativeSet.call(this, key, value);

                    return this;
                }
            });
        }
    });

    var weakMap$2 = path.WeakMap;

    var weakMap$1 = weakMap$2;

    var weakMap = weakMap$1;

    /*! *****************************************************************************
	Copyright (c) Microsoft Corporation.

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }

        return privateMap.get(receiver);
    }
    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }

        privateMap.set(receiver, value);
        return value;
    }

    function _createForOfIteratorHelper$3(o, allowArrayLike) { var it; if (typeof symbol === "undefined" || getIteratorMethod(o) == null) { if (isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

    function _unsupportedIterableToArray$3(o, minLen) { var _context2; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = slice$1(_context2 = Object.prototype.toString.call(o)).call(_context2, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return from$2(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }

    function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

    var _previousSelection, _selection, _nodes, _edges, _commitHandler;
    /**
     * @param prev
     * @param next
     */

    function diffSets(prev, next) {
        var diff = new set();

        var _iterator = _createForOfIteratorHelper$3(next),
            _step;

        try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var item = _step.value;

                if (!prev.has(item)) {
                    diff.add(item);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally {
            _iterator.f();
        }

        return diff;
    }

    var SingleTypeSelectionAccumulator = /*#__PURE__*/function () {
        function SingleTypeSelectionAccumulator() {
            _classCallCheck(this, SingleTypeSelectionAccumulator);

            _previousSelection.set(this, new set());

            _selection.set(this, new set());
        }

        _createClass(SingleTypeSelectionAccumulator, [{
            key: "size",
            get: function get() {
                return __classPrivateFieldGet(this, _selection).size;
            }
        }, {
            key: "add",
            value: function add() {
                for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
                    items[_key] = arguments[_key];
                }

                for (var _i = 0, _items = items; _i < _items.length; _i++) {
                    var item = _items[_i];

                    __classPrivateFieldGet(this, _selection).add(item);
                }
            }
        }, {
            key: "delete",
            value: function _delete() {
                for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    items[_key2] = arguments[_key2];
                }

                for (var _i2 = 0, _items2 = items; _i2 < _items2.length; _i2++) {
                    var item = _items2[_i2];

                    __classPrivateFieldGet(this, _selection).delete(item);
                }
            }
        }, {
            key: "clear",
            value: function clear() {
                __classPrivateFieldGet(this, _selection).clear();
            }
        }, {
            key: "getSelection",
            value: function getSelection() {
                return _toConsumableArray(__classPrivateFieldGet(this, _selection));
            }
        }, {
            key: "getChanges",
            value: function getChanges() {
                return {
                    added: _toConsumableArray(diffSets(__classPrivateFieldGet(this, _previousSelection), __classPrivateFieldGet(this, _selection))),
                    deleted: _toConsumableArray(diffSets(__classPrivateFieldGet(this, _selection), __classPrivateFieldGet(this, _previousSelection))),
                    previous: _toConsumableArray(new set(__classPrivateFieldGet(this, _previousSelection))),
                    current: _toConsumableArray(new set(__classPrivateFieldGet(this, _selection)))
                };
            }
        }, {
            key: "commit",
            value: function commit() {
                var changes = this.getChanges();

                __classPrivateFieldSet(this, _previousSelection, __classPrivateFieldGet(this, _selection));

                __classPrivateFieldSet(this, _selection, new set(__classPrivateFieldGet(this, _previousSelection)));

                var _iterator2 = _createForOfIteratorHelper$3(changes.added),
                    _step2;

                try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                        var item = _step2.value;
                        item.select();
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally {
                    _iterator2.f();
                }

                var _iterator3 = _createForOfIteratorHelper$3(changes.deleted),
                    _step3;

                try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                        var _item = _step3.value;

                        _item.unselect();
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally {
                    _iterator3.f();
                }

                return changes;
            }
        }]);

        return SingleTypeSelectionAccumulator;
    }();

    _previousSelection = new weakMap(), _selection = new weakMap();
    var SelectionAccumulator = /*#__PURE__*/function () {
        function SelectionAccumulator() {
            var commitHandler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

            _classCallCheck(this, SelectionAccumulator);

            _nodes.set(this, new SingleTypeSelectionAccumulator());

            _edges.set(this, new SingleTypeSelectionAccumulator());

            _commitHandler.set(this, void 0);

            __classPrivateFieldSet(this, _commitHandler, commitHandler);
        }

        _createClass(SelectionAccumulator, [{
            key: "sizeNodes",
            get: function get() {
                return __classPrivateFieldGet(this, _nodes).size;
            }
        }, {
            key: "sizeEdges",
            get: function get() {
                return __classPrivateFieldGet(this, _edges).size;
            }
        }, {
            key: "getNodes",
            value: function getNodes() {
                return __classPrivateFieldGet(this, _nodes).getSelection();
            }
        }, {
            key: "getEdges",
            value: function getEdges() {
                return __classPrivateFieldGet(this, _edges).getSelection();
            }
        }, {
            key: "addNodes",
            value: function addNodes() {
                var _classPrivateFieldGe;

                (_classPrivateFieldGe = __classPrivateFieldGet(this, _nodes)).add.apply(_classPrivateFieldGe, arguments);
            }
        }, {
            key: "addEdges",
            value: function addEdges() {
                var _classPrivateFieldGe2;

                (_classPrivateFieldGe2 = __classPrivateFieldGet(this, _edges)).add.apply(_classPrivateFieldGe2, arguments);
            }
        }, {
            key: "deleteNodes",
            value: function deleteNodes(node) {
                __classPrivateFieldGet(this, _nodes).delete(node);
            }
        }, {
            key: "deleteEdges",
            value: function deleteEdges(edge) {
                __classPrivateFieldGet(this, _edges).delete(edge);
            }
        }, {
            key: "clear",
            value: function clear() {
                __classPrivateFieldGet(this, _nodes).clear();

                __classPrivateFieldGet(this, _edges).clear();
            }
        }, {
            key: "commit",
            value: function commit() {
                var _classPrivateFieldGe3, _context;

                var summary = {
                    nodes: __classPrivateFieldGet(this, _nodes).commit(),
                    edges: __classPrivateFieldGet(this, _edges).commit()
                };

                for (var _len3 = arguments.length, rest = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                    rest[_key3] = arguments[_key3];
                }

                (_classPrivateFieldGe3 = __classPrivateFieldGet(this, _commitHandler)).call.apply(_classPrivateFieldGe3, concat(_context = [this, summary]).call(_context, rest));

                return summary;
            }
        }]);

        return SelectionAccumulator;
    }();
    _nodes = new weakMap(), _edges = new weakMap(), _commitHandler = new weakMap();

    function _createForOfIteratorHelper$2(o, allowArrayLike) { var it; if (typeof symbol === "undefined" || getIteratorMethod(o) == null) { if (isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

    function _unsupportedIterableToArray$2(o, minLen) { var _context3; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = slice$1(_context3 = Object.prototype.toString.call(o)).call(_context3, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return from$2(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

    function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
    /**
     * The handler for selections
     */

    var SelectionHandler = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {Canvas} canvas
         */
        function SelectionHandler(body, canvas) {
            var _this = this;

            _classCallCheck(this, SelectionHandler);

            this.body = body;
            this.canvas = canvas; // TODO: Consider firing an event on any change to the selection, not
            // only those caused by clicks and taps. It would be easy to implement
            // now and (at least to me) it seems like something that could be
            // quite useful.

            this._selectionAccumulator = new SelectionAccumulator();
            this.hoverObj = {
                nodes: {},
                edges: {}
            };
            this.options = {};
            this.defaultOptions = {
                multiselect: false,
                selectable: true,
                selectConnectedEdges: true,
                hoverConnectedEdges: true
            };

            assign$2(this.options, this.defaultOptions);

            this.body.emitter.on("_dataChanged", function () {
                _this.updateSelection();
            });
        }
        /**
         *
         * @param {object} [options]
         */


        _createClass(SelectionHandler, [{
            key: "setOptions",
            value: function setOptions(options) {
                if (options !== undefined) {
                    var fields = ["multiselect", "hoverConnectedEdges", "selectable", "selectConnectedEdges"];
                    selectiveDeepExtend(fields, this.options, options);
                }
            }
            /**
             * handles the selection part of the tap;
             *
             * @param {{x: number, y: number}} pointer
             * @returns {boolean}
             */

        }, {
            key: "selectOnPoint",
            value: function selectOnPoint(pointer) {
                var selected = false;

                if (this.options.selectable === true) {
                    var obj = this.getNodeAt(pointer) || this.getEdgeAt(pointer); // unselect after getting the objects in order to restore width and height.

                    this.unselectAll();

                    if (obj !== undefined) {
                        selected = this.selectObject(obj);
                    }

                    this.body.emitter.emit("_requestRedraw");
                }

                return selected;
            }
            /**
             *
             * @param {{x: number, y: number}} pointer
             * @returns {boolean}
             */

        }, {
            key: "selectAdditionalOnPoint",
            value: function selectAdditionalOnPoint(pointer) {
                var selectionChanged = false;

                if (this.options.selectable === true) {
                    var obj = this.getNodeAt(pointer) || this.getEdgeAt(pointer);

                    if (obj !== undefined) {
                        selectionChanged = true;

                        if (obj.isSelected() === true) {
                            this.deselectObject(obj);
                        } else {
                            this.selectObject(obj);
                        }

                        this.body.emitter.emit("_requestRedraw");
                    }
                }

                return selectionChanged;
            }
            /**
             * Create an object containing the standard fields for an event.
             *
             * @param {Event} event
             * @param {{x: number, y: number}} pointer Object with the x and y screen coordinates of the mouse
             * @returns {{}}
             * @private
             */

        }, {
            key: "_initBaseEvent",
            value: function _initBaseEvent(event, pointer) {
                var properties = {};
                properties["pointer"] = {
                    DOM: {
                        x: pointer.x,
                        y: pointer.y
                    },
                    canvas: this.canvas.DOMtoCanvas(pointer)
                };
                properties["event"] = event;
                return properties;
            }
            /**
             * Generate an event which the user can catch.
             *
             * This adds some extra data to the event with respect to cursor position and
             * selected nodes and edges.
             *
             * @param {string} eventType                          Name of event to send
             * @param {Event}  event
             * @param {{x: number, y: number}} pointer            Object with the x and y screen coordinates of the mouse
             * @param {object | undefined} oldSelection             If present, selection state before event occured
             * @param {boolean|undefined} [emptySelection=false]  Indicate if selection data should be passed
             */

        }, {
            key: "generateClickEvent",
            value: function generateClickEvent(eventType, event, pointer, oldSelection) {
                var emptySelection = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

                var properties = this._initBaseEvent(event, pointer);

                if (emptySelection === true) {
                    properties.nodes = [];
                    properties.edges = [];
                } else {
                    var tmp = this.getSelection();
                    properties.nodes = tmp.nodes;
                    properties.edges = tmp.edges;
                }

                if (oldSelection !== undefined) {
                    properties["previousSelection"] = oldSelection;
                }

                if (eventType == "click") {
                    // For the time being, restrict this functionality to
                    // just the click event.
                    properties.items = this.getClickedItems(pointer);
                }

                if (event.controlEdge !== undefined) {
                    properties.controlEdge = event.controlEdge;
                }

                this.body.emitter.emit(eventType, properties);
            }
            /**
             *
             * @param {object} obj
             * @param {boolean} [highlightEdges=this.options.selectConnectedEdges]
             * @returns {boolean}
             */

        }, {
            key: "selectObject",
            value: function selectObject(obj) {
                var highlightEdges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.selectConnectedEdges;

                if (obj !== undefined) {
                    if (obj instanceof Node) {
                        if (highlightEdges === true) {
                            var _this$_selectionAccum;

                            (_this$_selectionAccum = this._selectionAccumulator).addEdges.apply(_this$_selectionAccum, _toConsumableArray(obj.edges));
                        }

                        this._selectionAccumulator.addNodes(obj);
                    } else {
                        this._selectionAccumulator.addEdges(obj);
                    }

                    return true;
                }

                return false;
            }
            /**
             *
             * @param {object} obj
             */

        }, {
            key: "deselectObject",
            value: function deselectObject(obj) {
                if (obj.isSelected() === true) {
                    obj.selected = false;

                    this._removeFromSelection(obj);
                }
            }
            /**
             * retrieve all nodes overlapping with given object
             *
             * @param {object} object  An object with parameters left, top, right, bottom
             * @returns {number[]}   An array with id's of the overlapping nodes
             * @private
             */

        }, {
            key: "_getAllNodesOverlappingWith",
            value: function _getAllNodesOverlappingWith(object) {
                var overlappingNodes = [];
                var nodes = this.body.nodes;

                for (var i = 0; i < this.body.nodeIndices.length; i++) {
                    var nodeId = this.body.nodeIndices[i];

                    if (nodes[nodeId].isOverlappingWith(object)) {
                        overlappingNodes.push(nodeId);
                    }
                }

                return overlappingNodes;
            }
            /**
             * Return a position object in canvasspace from a single point in screenspace
             *
             * @param {{x: number, y: number}} pointer
             * @returns {{left: number, top: number, right: number, bottom: number}}
             * @private
             */

        }, {
            key: "_pointerToPositionObject",
            value: function _pointerToPositionObject(pointer) {
                var canvasPos = this.canvas.DOMtoCanvas(pointer);
                return {
                    left: canvasPos.x - 1,
                    top: canvasPos.y + 1,
                    right: canvasPos.x + 1,
                    bottom: canvasPos.y - 1
                };
            }
            /**
             * Get the top node at the passed point (like a click)
             *
             * @param {{x: number, y: number}} pointer
             * @param {boolean} [returnNode=true]
             * @returns {Node | undefined} node
             */

        }, {
            key: "getNodeAt",
            value: function getNodeAt(pointer) {
                var returnNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                // we first check if this is an navigation controls element
                var positionObject = this._pointerToPositionObject(pointer);

                var overlappingNodes = this._getAllNodesOverlappingWith(positionObject); // if there are overlapping nodes, select the last one, this is the
                // one which is drawn on top of the others


                if (overlappingNodes.length > 0) {
                    if (returnNode === true) {
                        return this.body.nodes[overlappingNodes[overlappingNodes.length - 1]];
                    } else {
                        return overlappingNodes[overlappingNodes.length - 1];
                    }
                } else {
                    return undefined;
                }
            }
            /**
             * retrieve all edges overlapping with given object, selector is around center
             *
             * @param {object} object  An object with parameters left, top, right, bottom
             * @param {number[]} overlappingEdges An array with id's of the overlapping nodes
             * @private
             */

        }, {
            key: "_getEdgesOverlappingWith",
            value: function _getEdgesOverlappingWith(object, overlappingEdges) {
                var edges = this.body.edges;

                for (var i = 0; i < this.body.edgeIndices.length; i++) {
                    var edgeId = this.body.edgeIndices[i];

                    if (edges[edgeId].isOverlappingWith(object)) {
                        overlappingEdges.push(edgeId);
                    }
                }
            }
            /**
             * retrieve all nodes overlapping with given object
             *
             * @param {object} object  An object with parameters left, top, right, bottom
             * @returns {number[]}   An array with id's of the overlapping nodes
             * @private
             */

        }, {
            key: "_getAllEdgesOverlappingWith",
            value: function _getAllEdgesOverlappingWith(object) {
                var overlappingEdges = [];

                this._getEdgesOverlappingWith(object, overlappingEdges);

                return overlappingEdges;
            }
            /**
             * Get the edges nearest to the passed point (like a click)
             *
             * @param {{x: number, y: number}} pointer
             * @param {boolean} [returnEdge=true]
             * @returns {Edge | undefined} node
             */

        }, {
            key: "getEdgeAt",
            value: function getEdgeAt(pointer) {
                var returnEdge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                // Iterate over edges, pick closest within 10
                var canvasPos = this.canvas.DOMtoCanvas(pointer);
                var mindist = 10;
                var overlappingEdge = null;
                var edges = this.body.edges;

                for (var i = 0; i < this.body.edgeIndices.length; i++) {
                    var edgeId = this.body.edgeIndices[i];
                    var edge = edges[edgeId];

                    if (edge.connected) {
                        var xFrom = edge.from.x;
                        var yFrom = edge.from.y;
                        var xTo = edge.to.x;
                        var yTo = edge.to.y;
                        var dist = edge.edgeType.getDistanceToEdge(xFrom, yFrom, xTo, yTo, canvasPos.x, canvasPos.y);

                        if (dist < mindist) {
                            overlappingEdge = edgeId;
                            mindist = dist;
                        }
                    }
                }

                if (overlappingEdge !== null) {
                    if (returnEdge === true) {
                        return this.body.edges[overlappingEdge];
                    } else {
                        return overlappingEdge;
                    }
                } else {
                    return undefined;
                }
            }
            /**
             * Add object to the selection array.
             *
             * @param {object} obj
             * @private
             */

        }, {
            key: "_addToHover",
            value: function _addToHover(obj) {
                if (obj instanceof Node) {
                    this.hoverObj.nodes[obj.id] = obj;
                } else {
                    this.hoverObj.edges[obj.id] = obj;
                }
            }
            /**
             * Remove a single option from selection.
             *
             * @param {object} obj
             * @private
             */

        }, {
            key: "_removeFromSelection",
            value: function _removeFromSelection(obj) {
                if (obj instanceof Node) {
                    var _this$_selectionAccum2;

                    this._selectionAccumulator.deleteNodes(obj);

                    (_this$_selectionAccum2 = this._selectionAccumulator).deleteEdges.apply(_this$_selectionAccum2, _toConsumableArray(obj.edges));
                } else {
                    this._selectionAccumulator.deleteEdges(obj);
                }
            }
            /**
             * Unselect all nodes and edges.
             */

        }, {
            key: "unselectAll",
            value: function unselectAll() {
                this._selectionAccumulator.clear();
            }
            /**
             * return the number of selected nodes
             *
             * @returns {number}
             */

        }, {
            key: "getSelectedNodeCount",
            value: function getSelectedNodeCount() {
                return this._selectionAccumulator.sizeNodes;
            }
            /**
             * return the number of selected edges
             *
             * @returns {number}
             */

        }, {
            key: "getSelectedEdgeCount",
            value: function getSelectedEdgeCount() {
                return this._selectionAccumulator.sizeEdges;
            }
            /**
             * select the edges connected to the node that is being selected
             *
             * @param {Node} node
             * @private
             */

        }, {
            key: "_hoverConnectedEdges",
            value: function _hoverConnectedEdges(node) {
                for (var i = 0; i < node.edges.length; i++) {
                    var edge = node.edges[i];
                    edge.hover = true;

                    this._addToHover(edge);
                }
            }
            /**
             * Remove the highlight from a node or edge, in response to mouse movement
             *
             * @param {Event}  event
             * @param {{x: number, y: number}} pointer object with the x and y screen coordinates of the mouse
             * @param {Node|vis.Edge} object
             * @private
             */

        }, {
            key: "emitBlurEvent",
            value: function emitBlurEvent(event, pointer, object) {
                var properties = this._initBaseEvent(event, pointer);

                if (object.hover === true) {
                    object.hover = false;

                    if (object instanceof Node) {
                        properties.node = object.id;
                        this.body.emitter.emit("blurNode", properties);
                    } else {
                        properties.edge = object.id;
                        this.body.emitter.emit("blurEdge", properties);
                    }
                }
            }
            /**
             * Create the highlight for a node or edge, in response to mouse movement
             *
             * @param {Event}  event
             * @param {{x: number, y: number}} pointer object with the x and y screen coordinates of the mouse
             * @param {Node|vis.Edge} object
             * @returns {boolean} hoverChanged
             * @private
             */

        }, {
            key: "emitHoverEvent",
            value: function emitHoverEvent(event, pointer, object) {
                var properties = this._initBaseEvent(event, pointer);

                var hoverChanged = false;

                if (object.hover === false) {
                    object.hover = true;

                    this._addToHover(object);

                    hoverChanged = true;

                    if (object instanceof Node) {
                        properties.node = object.id;
                        this.body.emitter.emit("hoverNode", properties);
                    } else {
                        properties.edge = object.id;
                        this.body.emitter.emit("hoverEdge", properties);
                    }
                }

                return hoverChanged;
            }
            /**
             * Perform actions in response to a mouse movement.
             *
             * @param {Event}  event
             * @param {{x: number, y: number}} pointer | object with the x and y screen coordinates of the mouse
             */

        }, {
            key: "hoverObject",
            value: function hoverObject(event, pointer) {
                var object = this.getNodeAt(pointer);

                if (object === undefined) {
                    object = this.getEdgeAt(pointer);
                }

                var hoverChanged = false; // remove all node hover highlights

                for (var nodeId in this.hoverObj.nodes) {
                    if (Object.prototype.hasOwnProperty.call(this.hoverObj.nodes, nodeId)) {
                        if (object === undefined || object instanceof Node && object.id != nodeId || object instanceof Edge) {
                            this.emitBlurEvent(event, pointer, this.hoverObj.nodes[nodeId]);
                            delete this.hoverObj.nodes[nodeId];
                            hoverChanged = true;
                        }
                    }
                } // removing all edge hover highlights


                for (var edgeId in this.hoverObj.edges) {
                    if (Object.prototype.hasOwnProperty.call(this.hoverObj.edges, edgeId)) {
                        // if the hover has been changed here it means that the node has been hovered over or off
                        // we then do not use the emitBlurEvent method here.
                        if (hoverChanged === true) {
                            this.hoverObj.edges[edgeId].hover = false;
                            delete this.hoverObj.edges[edgeId];
                        } // if the blur remains the same and the object is undefined (mouse off) or another
                        // edge has been hovered, or another node has been hovered we blur the edge.
                        else if (object === undefined || object instanceof Edge && object.id != edgeId || object instanceof Node && !object.hover) {
                            this.emitBlurEvent(event, pointer, this.hoverObj.edges[edgeId]);
                            delete this.hoverObj.edges[edgeId];
                            hoverChanged = true;
                        }
                    }
                }

                if (object !== undefined) {
                    var hoveredEdgesCount = keys$3(this.hoverObj.edges).length;

                    var hoveredNodesCount = keys$3(this.hoverObj.nodes).length;

                    var newOnlyHoveredEdge = object instanceof Edge && hoveredEdgesCount === 0 && hoveredNodesCount === 0;
                    var newOnlyHoveredNode = object instanceof Node && hoveredEdgesCount === 0 && hoveredNodesCount === 0;

                    if (hoverChanged || newOnlyHoveredEdge || newOnlyHoveredNode) {
                        hoverChanged = this.emitHoverEvent(event, pointer, object);
                    }

                    if (object instanceof Node && this.options.hoverConnectedEdges === true) {
                        this._hoverConnectedEdges(object);
                    }
                }

                if (hoverChanged === true) {
                    this.body.emitter.emit("_requestRedraw");
                }
            }
            /**
             * Commit the selection changes but don't emit any events.
             */

        }, {
            key: "commitWithoutEmitting",
            value: function commitWithoutEmitting() {
                this._selectionAccumulator.commit();
            }
            /**
             * Select and deselect nodes depending current selection change.
             *
             * For changing nodes, select/deselect events are fired.
             *
             * NOTE: For a given edge, if one connecting node is deselected and with the
             * same click the other node is selected, no events for the edge will fire. It
             * was selected and it will remain selected.
             *
             * @param {{x: number, y: number}} pointer - The x and y coordinates of the
             * click, tap, dragend… that triggered this.
             * @param {UIEvent} event - The event that triggered this.
             */

        }, {
            key: "commitAndEmit",
            value: function commitAndEmit(pointer, event) {
                var selected = false;

                var selectionChanges = this._selectionAccumulator.commit();

                var previousSelection = {
                    nodes: selectionChanges.nodes.previous,
                    edges: selectionChanges.edges.previous
                };

                if (selectionChanges.edges.deleted.length > 0) {
                    this.generateClickEvent("deselectEdge", event, pointer, previousSelection);
                    selected = true;
                }

                if (selectionChanges.nodes.deleted.length > 0) {
                    this.generateClickEvent("deselectNode", event, pointer, previousSelection);
                    selected = true;
                }

                if (selectionChanges.nodes.added.length > 0) {
                    this.generateClickEvent("selectNode", event, pointer);
                    selected = true;
                }

                if (selectionChanges.edges.added.length > 0) {
                    this.generateClickEvent("selectEdge", event, pointer);
                    selected = true;
                } // fire the select event if anything has been selected or deselected


                if (selected === true) {
                    // select or unselect
                    this.generateClickEvent("select", event, pointer);
                }
            }
            /**
             * Retrieve the currently selected node and edge ids.
             *
             * @returns {{nodes: Array.<string>, edges: Array.<string>}} Arrays with the
             * ids of the selected nodes and edges.
             */

        }, {
            key: "getSelection",
            value: function getSelection() {
                return {
                    nodes: this.getSelectedNodeIds(),
                    edges: this.getSelectedEdgeIds()
                };
            }
            /**
             * Retrieve the currently selected nodes.
             *
             * @returns {Array} An array with selected nodes.
             */

        }, {
            key: "getSelectedNodes",
            value: function getSelectedNodes() {
                return this._selectionAccumulator.getNodes();
            }
            /**
             * Retrieve the currently selected edges.
             *
             * @returns {Array} An array with selected edges.
             */

        }, {
            key: "getSelectedEdges",
            value: function getSelectedEdges() {
                return this._selectionAccumulator.getEdges();
            }
            /**
             * Retrieve the currently selected node ids.
             *
             * @returns {Array} An array with the ids of the selected nodes.
             */

        }, {
            key: "getSelectedNodeIds",
            value: function getSelectedNodeIds() {
                var _context;

                return map$3(_context = this._selectionAccumulator.getNodes()).call(_context, function (node) {
                    return node.id;
                });
            }
            /**
             * Retrieve the currently selected edge ids.
             *
             * @returns {Array} An array with the ids of the selected edges.
             */

        }, {
            key: "getSelectedEdgeIds",
            value: function getSelectedEdgeIds() {
                var _context2;

                return map$3(_context2 = this._selectionAccumulator.getEdges()).call(_context2, function (edge) {
                    return edge.id;
                });
            }
            /**
             * Updates the current selection
             *
             * @param {{nodes: Array.<string>, edges: Array.<string>}} selection
             * @param {object} options                                 Options
             */

        }, {
            key: "setSelection",
            value: function setSelection(selection) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                if (!selection || !selection.nodes && !selection.edges) {
                    throw new TypeError("Selection must be an object with nodes and/or edges properties");
                } // first unselect any selected node, if option is true or undefined


                if (options.unselectAll || options.unselectAll === undefined) {
                    this.unselectAll();
                }

                if (selection.nodes) {
                    var _iterator = _createForOfIteratorHelper$2(selection.nodes),
                        _step;

                    try {
                        for (_iterator.s(); !(_step = _iterator.n()).done;) {
                            var id = _step.value;
                            var node = this.body.nodes[id];

                            if (!node) {
                                throw new RangeError('Node with id "' + id + '" not found');
                            } // don't select edges with it


                            this.selectObject(node, options.highlightEdges);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally {
                        _iterator.f();
                    }
                }

                if (selection.edges) {
                    var _iterator2 = _createForOfIteratorHelper$2(selection.edges),
                        _step2;

                    try {
                        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                            var _id = _step2.value;
                            var edge = this.body.edges[_id];

                            if (!edge) {
                                throw new RangeError('Edge with id "' + _id + '" not found');
                            }

                            this.selectObject(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally {
                        _iterator2.f();
                    }
                }

                this.body.emitter.emit("_requestRedraw");

                this._selectionAccumulator.commit();
            }
            /**
             * select zero or more nodes with the option to highlight edges
             *
             * @param {number[] | string[]} selection     An array with the ids of the
             *                                            selected nodes.
             * @param {boolean} [highlightEdges]
             */

        }, {
            key: "selectNodes",
            value: function selectNodes(selection) {
                var highlightEdges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (!selection || selection.length === undefined) throw "Selection must be an array with ids";
                this.setSelection({
                    nodes: selection
                }, {
                    highlightEdges: highlightEdges
                });
            }
            /**
             * select zero or more edges
             *
             * @param {number[] | string[]} selection     An array with the ids of the
             *                                            selected nodes.
             */

        }, {
            key: "selectEdges",
            value: function selectEdges(selection) {
                if (!selection || selection.length === undefined) throw "Selection must be an array with ids";
                this.setSelection({
                    edges: selection
                });
            }
            /**
             * Validate the selection: remove ids of nodes which no longer exist
             *
             * @private
             */

        }, {
            key: "updateSelection",
            value: function updateSelection() {
                for (var node in this._selectionAccumulator.getNodes()) {
                    if (!Object.prototype.hasOwnProperty.call(this.body.nodes, node.id)) {
                        this._selectionAccumulator.deleteNodes(node);
                    }
                }

                for (var edge in this._selectionAccumulator.getEdges()) {
                    if (!Object.prototype.hasOwnProperty.call(this.body.edges, edge.id)) {
                        this._selectionAccumulator.deleteEdges(edge);
                    }
                }
            }
            /**
             * Determine all the visual elements clicked which are on the given point.
             *
             * All elements are returned; this includes nodes, edges and their labels.
             * The order returned is from highest to lowest, i.e. element 0 of the return
             * value is the topmost item clicked on.
             *
             * The return value consists of an array of the following possible elements:
             *
             * - `{nodeId:number}`             - node with given id clicked on
             * - `{nodeId:number, labelId:0}`  - label of node with given id clicked on
             * - `{edgeId:number}`             - edge with given id clicked on
             * - `{edge:number, labelId:0}`    - label of edge with given id clicked on
             *
             * ## NOTES
             *
             * - Currently, there is only one label associated with a node or an edge,
             *   but this is expected to change somewhere in the future.
             * - Since there is no z-indexing yet, it is not really possible to set the nodes and
             *   edges in the correct order. For the time being, nodes come first.
             *
             * @param {point} pointer  mouse position in screen coordinates
             * @returns {Array.<nodeClickItem|nodeLabelClickItem|edgeClickItem|edgeLabelClickItem>}
             * @private
             */

        }, {
            key: "getClickedItems",
            value: function getClickedItems(pointer) {
                var point = this.canvas.DOMtoCanvas(pointer);
                var items = []; // Note reverse order; we want the topmost clicked items to be first in the array
                // Also note that selected nodes are disregarded here; these normally display on top

                var nodeIndices = this.body.nodeIndices;
                var nodes = this.body.nodes;

                for (var i = nodeIndices.length - 1; i >= 0; i--) {
                    var node = nodes[nodeIndices[i]];
                    var ret = node.getItemsOnPoint(point);
                    items.push.apply(items, ret); // Append the return value to the running list.
                }

                var edgeIndices = this.body.edgeIndices;
                var edges = this.body.edges;

                for (var _i = edgeIndices.length - 1; _i >= 0; _i--) {
                    var edge = edges[edgeIndices[_i]];

                    var _ret = edge.getItemsOnPoint(point);

                    items.push.apply(items, _ret); // Append the return value to the running list.
                }

                return items;
            }
        }]);

        return SelectionHandler;
    }();

    /****
     * The MIT License
     *
     * Copyright (c) 2015 Marco Ziccardi
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
     * THE SOFTWARE.
     *
     ****/
    var timsort$1 = createCommonjsModule(function (module, exports) {
        (function (global, factory) {
            {
                factory(exports);
            }
        })(commonjsGlobal, function (exports) {

            exports.__esModule = true;
            exports.sort = sort;

            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError('Cannot call a class as a function');
                }
            }

            var DEFAULT_MIN_MERGE = 32;
            var DEFAULT_MIN_GALLOPING = 7;
            var DEFAULT_TMP_STORAGE_LENGTH = 256;
            var POWERS_OF_TEN = [1e0, 1e1, 1e2, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9];

            function log10(x) {
                if (x < 1e5) {
                    if (x < 1e2) {
                        return x < 1e1 ? 0 : 1;
                    }

                    if (x < 1e4) {
                        return x < 1e3 ? 2 : 3;
                    }

                    return 4;
                }

                if (x < 1e7) {
                    return x < 1e6 ? 5 : 6;
                }

                if (x < 1e9) {
                    return x < 1e8 ? 7 : 8;
                }

                return 9;
            }

            function alphabeticalCompare(a, b) {
                if (a === b) {
                    return 0;
                }

                if (~~a === a && ~~b === b) {
                    if (a === 0 || b === 0) {
                        return a < b ? -1 : 1;
                    }

                    if (a < 0 || b < 0) {
                        if (b >= 0) {
                            return -1;
                        }

                        if (a >= 0) {
                            return 1;
                        }

                        a = -a;
                        b = -b;
                    }

                    var al = log10(a);
                    var bl = log10(b);
                    var t = 0;

                    if (al < bl) {
                        a *= POWERS_OF_TEN[bl - al - 1];
                        b /= 10;
                        t = -1;
                    } else if (al > bl) {
                        b *= POWERS_OF_TEN[al - bl - 1];
                        a /= 10;
                        t = 1;
                    }

                    if (a === b) {
                        return t;
                    }

                    return a < b ? -1 : 1;
                }

                var aStr = String(a);
                var bStr = String(b);

                if (aStr === bStr) {
                    return 0;
                }

                return aStr < bStr ? -1 : 1;
            }

            function minRunLength(n) {
                var r = 0;

                while (n >= DEFAULT_MIN_MERGE) {
                    r |= n & 1;
                    n >>= 1;
                }

                return n + r;
            }

            function makeAscendingRun(array, lo, hi, compare) {
                var runHi = lo + 1;

                if (runHi === hi) {
                    return 1;
                }

                if (compare(array[runHi++], array[lo]) < 0) {
                    while (runHi < hi && compare(array[runHi], array[runHi - 1]) < 0) {
                        runHi++;
                    }

                    reverseRun(array, lo, runHi);
                } else {
                    while (runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0) {
                        runHi++;
                    }
                }

                return runHi - lo;
            }

            function reverseRun(array, lo, hi) {
                hi--;

                while (lo < hi) {
                    var t = array[lo];
                    array[lo++] = array[hi];
                    array[hi--] = t;
                }
            }

            function binaryInsertionSort(array, lo, hi, start, compare) {
                if (start === lo) {
                    start++;
                }

                for (; start < hi; start++) {
                    var pivot = array[start];
                    var left = lo;
                    var right = start;

                    while (left < right) {
                        var mid = left + right >>> 1;

                        if (compare(pivot, array[mid]) < 0) {
                            right = mid;
                        } else {
                            left = mid + 1;
                        }
                    }

                    var n = start - left;

                    switch (n) {
                        case 3:
                            array[left + 3] = array[left + 2];

                        case 2:
                            array[left + 2] = array[left + 1];

                        case 1:
                            array[left + 1] = array[left];
                            break;

                        default:
                            while (n > 0) {
                                array[left + n] = array[left + n - 1];
                                n--;
                            }

                    }

                    array[left] = pivot;
                }
            }

            function gallopLeft(value, array, start, length, hint, compare) {
                var lastOffset = 0;
                var maxOffset = 0;
                var offset = 1;

                if (compare(value, array[start + hint]) > 0) {
                    maxOffset = length - hint;

                    while (offset < maxOffset && compare(value, array[start + hint + offset]) > 0) {
                        lastOffset = offset;
                        offset = (offset << 1) + 1;

                        if (offset <= 0) {
                            offset = maxOffset;
                        }
                    }

                    if (offset > maxOffset) {
                        offset = maxOffset;
                    }

                    lastOffset += hint;
                    offset += hint;
                } else {
                    maxOffset = hint + 1;

                    while (offset < maxOffset && compare(value, array[start + hint - offset]) <= 0) {
                        lastOffset = offset;
                        offset = (offset << 1) + 1;

                        if (offset <= 0) {
                            offset = maxOffset;
                        }
                    }

                    if (offset > maxOffset) {
                        offset = maxOffset;
                    }

                    var tmp = lastOffset;
                    lastOffset = hint - offset;
                    offset = hint - tmp;
                }

                lastOffset++;

                while (lastOffset < offset) {
                    var m = lastOffset + (offset - lastOffset >>> 1);

                    if (compare(value, array[start + m]) > 0) {
                        lastOffset = m + 1;
                    } else {
                        offset = m;
                    }
                }

                return offset;
            }

            function gallopRight(value, array, start, length, hint, compare) {
                var lastOffset = 0;
                var maxOffset = 0;
                var offset = 1;

                if (compare(value, array[start + hint]) < 0) {
                    maxOffset = hint + 1;

                    while (offset < maxOffset && compare(value, array[start + hint - offset]) < 0) {
                        lastOffset = offset;
                        offset = (offset << 1) + 1;

                        if (offset <= 0) {
                            offset = maxOffset;
                        }
                    }

                    if (offset > maxOffset) {
                        offset = maxOffset;
                    }

                    var tmp = lastOffset;
                    lastOffset = hint - offset;
                    offset = hint - tmp;
                } else {
                    maxOffset = length - hint;

                    while (offset < maxOffset && compare(value, array[start + hint + offset]) >= 0) {
                        lastOffset = offset;
                        offset = (offset << 1) + 1;

                        if (offset <= 0) {
                            offset = maxOffset;
                        }
                    }

                    if (offset > maxOffset) {
                        offset = maxOffset;
                    }

                    lastOffset += hint;
                    offset += hint;
                }

                lastOffset++;

                while (lastOffset < offset) {
                    var m = lastOffset + (offset - lastOffset >>> 1);

                    if (compare(value, array[start + m]) < 0) {
                        offset = m;
                    } else {
                        lastOffset = m + 1;
                    }
                }

                return offset;
            }

            var TimSort = function () {
                function TimSort(array, compare) {
                    _classCallCheck(this, TimSort);

                    this.array = null;
                    this.compare = null;
                    this.minGallop = DEFAULT_MIN_GALLOPING;
                    this.length = 0;
                    this.tmpStorageLength = DEFAULT_TMP_STORAGE_LENGTH;
                    this.stackLength = 0;
                    this.runStart = null;
                    this.runLength = null;
                    this.stackSize = 0;
                    this.array = array;
                    this.compare = compare;
                    this.length = array.length;

                    if (this.length < 2 * DEFAULT_TMP_STORAGE_LENGTH) {
                        this.tmpStorageLength = this.length >>> 1;
                    }

                    this.tmp = new Array(this.tmpStorageLength);
                    this.stackLength = this.length < 120 ? 5 : this.length < 1542 ? 10 : this.length < 119151 ? 19 : 40;
                    this.runStart = new Array(this.stackLength);
                    this.runLength = new Array(this.stackLength);
                }

                TimSort.prototype.pushRun = function pushRun(runStart, runLength) {
                    this.runStart[this.stackSize] = runStart;
                    this.runLength[this.stackSize] = runLength;
                    this.stackSize += 1;
                };

                TimSort.prototype.mergeRuns = function mergeRuns() {
                    while (this.stackSize > 1) {
                        var n = this.stackSize - 2;

                        if (n >= 1 && this.runLength[n - 1] <= this.runLength[n] + this.runLength[n + 1] || n >= 2 && this.runLength[n - 2] <= this.runLength[n] + this.runLength[n - 1]) {
                            if (this.runLength[n - 1] < this.runLength[n + 1]) {
                                n--;
                            }
                        } else if (this.runLength[n] > this.runLength[n + 1]) {
                            break;
                        }

                        this.mergeAt(n);
                    }
                };

                TimSort.prototype.forceMergeRuns = function forceMergeRuns() {
                    while (this.stackSize > 1) {
                        var n = this.stackSize - 2;

                        if (n > 0 && this.runLength[n - 1] < this.runLength[n + 1]) {
                            n--;
                        }

                        this.mergeAt(n);
                    }
                };

                TimSort.prototype.mergeAt = function mergeAt(i) {
                    var compare = this.compare;
                    var array = this.array;
                    var start1 = this.runStart[i];
                    var length1 = this.runLength[i];
                    var start2 = this.runStart[i + 1];
                    var length2 = this.runLength[i + 1];
                    this.runLength[i] = length1 + length2;

                    if (i === this.stackSize - 3) {
                        this.runStart[i + 1] = this.runStart[i + 2];
                        this.runLength[i + 1] = this.runLength[i + 2];
                    }

                    this.stackSize--;
                    var k = gallopRight(array[start2], array, start1, length1, 0, compare);
                    start1 += k;
                    length1 -= k;

                    if (length1 === 0) {
                        return;
                    }

                    length2 = gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);

                    if (length2 === 0) {
                        return;
                    }

                    if (length1 <= length2) {
                        this.mergeLow(start1, length1, start2, length2);
                    } else {
                        this.mergeHigh(start1, length1, start2, length2);
                    }
                };

                TimSort.prototype.mergeLow = function mergeLow(start1, length1, start2, length2) {
                    var compare = this.compare;
                    var array = this.array;
                    var tmp = this.tmp;
                    var i = 0;

                    for (i = 0; i < length1; i++) {
                        tmp[i] = array[start1 + i];
                    }

                    var cursor1 = 0;
                    var cursor2 = start2;
                    var dest = start1;
                    array[dest++] = array[cursor2++];

                    if (--length2 === 0) {
                        for (i = 0; i < length1; i++) {
                            array[dest + i] = tmp[cursor1 + i];
                        }

                        return;
                    }

                    if (length1 === 1) {
                        for (i = 0; i < length2; i++) {
                            array[dest + i] = array[cursor2 + i];
                        }

                        array[dest + length2] = tmp[cursor1];
                        return;
                    }

                    var minGallop = this.minGallop;

                    while (true) {
                        var count1 = 0;
                        var count2 = 0;
                        var exit = false;

                        do {
                            if (compare(array[cursor2], tmp[cursor1]) < 0) {
                                array[dest++] = array[cursor2++];
                                count2++;
                                count1 = 0;

                                if (--length2 === 0) {
                                    exit = true;
                                    break;
                                }
                            } else {
                                array[dest++] = tmp[cursor1++];
                                count1++;
                                count2 = 0;

                                if (--length1 === 1) {
                                    exit = true;
                                    break;
                                }
                            }
                        } while ((count1 | count2) < minGallop);

                        if (exit) {
                            break;
                        }

                        do {
                            count1 = gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);

                            if (count1 !== 0) {
                                for (i = 0; i < count1; i++) {
                                    array[dest + i] = tmp[cursor1 + i];
                                }

                                dest += count1;
                                cursor1 += count1;
                                length1 -= count1;

                                if (length1 <= 1) {
                                    exit = true;
                                    break;
                                }
                            }

                            array[dest++] = array[cursor2++];

                            if (--length2 === 0) {
                                exit = true;
                                break;
                            }

                            count2 = gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);

                            if (count2 !== 0) {
                                for (i = 0; i < count2; i++) {
                                    array[dest + i] = array[cursor2 + i];
                                }

                                dest += count2;
                                cursor2 += count2;
                                length2 -= count2;

                                if (length2 === 0) {
                                    exit = true;
                                    break;
                                }
                            }

                            array[dest++] = tmp[cursor1++];

                            if (--length1 === 1) {
                                exit = true;
                                break;
                            }

                            minGallop--;
                        } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);

                        if (exit) {
                            break;
                        }

                        if (minGallop < 0) {
                            minGallop = 0;
                        }

                        minGallop += 2;
                    }

                    this.minGallop = minGallop;

                    if (minGallop < 1) {
                        this.minGallop = 1;
                    }

                    if (length1 === 1) {
                        for (i = 0; i < length2; i++) {
                            array[dest + i] = array[cursor2 + i];
                        }

                        array[dest + length2] = tmp[cursor1];
                    } else if (length1 === 0) {
                        throw new Error('mergeLow preconditions were not respected');
                    } else {
                        for (i = 0; i < length1; i++) {
                            array[dest + i] = tmp[cursor1 + i];
                        }
                    }
                };

                TimSort.prototype.mergeHigh = function mergeHigh(start1, length1, start2, length2) {
                    var compare = this.compare;
                    var array = this.array;
                    var tmp = this.tmp;
                    var i = 0;

                    for (i = 0; i < length2; i++) {
                        tmp[i] = array[start2 + i];
                    }

                    var cursor1 = start1 + length1 - 1;
                    var cursor2 = length2 - 1;
                    var dest = start2 + length2 - 1;
                    var customCursor = 0;
                    var customDest = 0;
                    array[dest--] = array[cursor1--];

                    if (--length1 === 0) {
                        customCursor = dest - (length2 - 1);

                        for (i = 0; i < length2; i++) {
                            array[customCursor + i] = tmp[i];
                        }

                        return;
                    }

                    if (length2 === 1) {
                        dest -= length1;
                        cursor1 -= length1;
                        customDest = dest + 1;
                        customCursor = cursor1 + 1;

                        for (i = length1 - 1; i >= 0; i--) {
                            array[customDest + i] = array[customCursor + i];
                        }

                        array[dest] = tmp[cursor2];
                        return;
                    }

                    var minGallop = this.minGallop;

                    while (true) {
                        var count1 = 0;
                        var count2 = 0;
                        var exit = false;

                        do {
                            if (compare(tmp[cursor2], array[cursor1]) < 0) {
                                array[dest--] = array[cursor1--];
                                count1++;
                                count2 = 0;

                                if (--length1 === 0) {
                                    exit = true;
                                    break;
                                }
                            } else {
                                array[dest--] = tmp[cursor2--];
                                count2++;
                                count1 = 0;

                                if (--length2 === 1) {
                                    exit = true;
                                    break;
                                }
                            }
                        } while ((count1 | count2) < minGallop);

                        if (exit) {
                            break;
                        }

                        do {
                            count1 = length1 - gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);

                            if (count1 !== 0) {
                                dest -= count1;
                                cursor1 -= count1;
                                length1 -= count1;
                                customDest = dest + 1;
                                customCursor = cursor1 + 1;

                                for (i = count1 - 1; i >= 0; i--) {
                                    array[customDest + i] = array[customCursor + i];
                                }

                                if (length1 === 0) {
                                    exit = true;
                                    break;
                                }
                            }

                            array[dest--] = tmp[cursor2--];

                            if (--length2 === 1) {
                                exit = true;
                                break;
                            }

                            count2 = length2 - gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);

                            if (count2 !== 0) {
                                dest -= count2;
                                cursor2 -= count2;
                                length2 -= count2;
                                customDest = dest + 1;
                                customCursor = cursor2 + 1;

                                for (i = 0; i < count2; i++) {
                                    array[customDest + i] = tmp[customCursor + i];
                                }

                                if (length2 <= 1) {
                                    exit = true;
                                    break;
                                }
                            }

                            array[dest--] = array[cursor1--];

                            if (--length1 === 0) {
                                exit = true;
                                break;
                            }

                            minGallop--;
                        } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);

                        if (exit) {
                            break;
                        }

                        if (minGallop < 0) {
                            minGallop = 0;
                        }

                        minGallop += 2;
                    }

                    this.minGallop = minGallop;

                    if (minGallop < 1) {
                        this.minGallop = 1;
                    }

                    if (length2 === 1) {
                        dest -= length1;
                        cursor1 -= length1;
                        customDest = dest + 1;
                        customCursor = cursor1 + 1;

                        for (i = length1 - 1; i >= 0; i--) {
                            array[customDest + i] = array[customCursor + i];
                        }

                        array[dest] = tmp[cursor2];
                    } else if (length2 === 0) {
                        throw new Error('mergeHigh preconditions were not respected');
                    } else {
                        customCursor = dest - (length2 - 1);

                        for (i = 0; i < length2; i++) {
                            array[customCursor + i] = tmp[i];
                        }
                    }
                };

                return TimSort;
            }();

            function sort(array, compare, lo, hi) {
                if (!Array.isArray(array)) {
                    throw new TypeError('Can only sort arrays');
                }

                if (!compare) {
                    compare = alphabeticalCompare;
                } else if (typeof compare !== 'function') {
                    hi = lo;
                    lo = compare;
                    compare = alphabeticalCompare;
                }

                if (!lo) {
                    lo = 0;
                }

                if (!hi) {
                    hi = array.length;
                }

                var remaining = hi - lo;

                if (remaining < 2) {
                    return;
                }

                var runLength = 0;

                if (remaining < DEFAULT_MIN_MERGE) {
                    runLength = makeAscendingRun(array, lo, hi, compare);
                    binaryInsertionSort(array, lo, hi, lo + runLength, compare);
                    return;
                }

                var ts = new TimSort(array, compare);
                var minRun = minRunLength(remaining);

                do {
                    runLength = makeAscendingRun(array, lo, hi, compare);

                    if (runLength < minRun) {
                        var force = remaining;

                        if (force > minRun) {
                            force = minRun;
                        }

                        binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
                        runLength = force;
                    }

                    ts.pushRun(lo, runLength);
                    ts.mergeRuns();
                    remaining -= runLength;
                    lo += runLength;
                } while (remaining !== 0);

                ts.forceMergeRuns();
            }
        });
    });

    var timsort = timsort$1;

    function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

    function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !construct) return false; if (construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
    /**
     * Interface definition for direction strategy classes.
     *
     * This class describes the interface for the Strategy
     * pattern classes used to differentiate horizontal and vertical
     * direction of hierarchical results.
     *
     * For a given direction, one coordinate will be 'fixed', meaning that it is
     * determined by level.
     * The other coordinate is 'unfixed', meaning that the nodes on a given level
     * can still move along that coordinate. So:
     *
     * - `vertical` layout: `x` unfixed, `y` fixed per level
     * - `horizontal` layout: `x` fixed per level, `y` unfixed
     *
     * The local methods are stubs and should be regarded as abstract.
     * Derived classes **must** implement all the methods themselves.
     *
     * @private
     */

    var DirectionInterface = /*#__PURE__*/function () {
        function DirectionInterface() {
            _classCallCheck(this, DirectionInterface);
        }

        _createClass(DirectionInterface, [{
            key: "abstract",
            value:
                /**
                 * @ignore
                 */
                function abstract() {
                    throw new Error("Can't instantiate abstract class!");
                }
            /**
             * This is a dummy call which is used to suppress the jsdoc errors of type:
             *
             *   "'param' is assigned a value but never used"
             *
             * @ignore
             **/

        }, {
            key: "fake_use",
            value: function fake_use() {// Do nothing special
            }
            /**
             * Type to use to translate dynamic curves to, in the case of hierarchical layout.
             * Dynamic curves do not work for these.
             *
             * The value should be perpendicular to the actual direction of the layout.
             *
             * @returns {string} Direction, either 'vertical' or 'horizontal'
             */

        }, {
            key: "curveType",
            value: function curveType() {
                return this.abstract();
            }
            /**
             * Return the value of the coordinate that is not fixed for this direction.
             *
             * @param {Node} node The node to read
             * @returns {number} Value of the unfixed coordinate
             */

        }, {
            key: "getPosition",
            value: function getPosition(node) {
                this.fake_use(node);
                return this.abstract();
            }
            /**
             * Set the value of the coordinate that is not fixed for this direction.
             *
             * @param {Node} node The node to adjust
             * @param {number} position
             * @param {number} [level] if specified, the hierarchy level that this node should be fixed to
             */

        }, {
            key: "setPosition",
            value: function setPosition(node, position) {
                var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                this.fake_use(node, position, level);
                this.abstract();
            }
            /**
             * Get the width of a tree.
             *
             * A `tree` here is a subset of nodes within the network which are not connected to other nodes,
             * only among themselves. In essence, it is a sub-network.
             *
             * @param {number} index The index number of a tree
             * @returns {number} the width of a tree in the view coordinates
             */

        }, {
            key: "getTreeSize",
            value: function getTreeSize(index) {
                this.fake_use(index);
                return this.abstract();
            }
            /**
             * Sort array of nodes on the unfixed coordinates.
             *
             * **Note:** chrome has non-stable sorting implementation, which
             * has a tendency to change the order of the array items,
             * even if the custom sort function returns 0.
             *
             * For this reason, an external sort implementation is used,
             * which has the added benefit of being faster than the standard
             * platforms implementation. This has been verified on `node.js`,
             * `firefox` and `chrome` (all linux).
             *
             * @param {Array.<Node>} nodeArray array of nodes to sort
             */

        }, {
            key: "sort",
            value: function sort(nodeArray) {
                this.fake_use(nodeArray);
                this.abstract();
            }
            /**
             * Assign the fixed coordinate of the node to the given level
             *
             * @param {Node} node The node to adjust
             * @param {number} level The level to fix to
             */

        }, {
            key: "fix",
            value: function fix(node, level) {
                this.fake_use(node, level);
                this.abstract();
            }
            /**
             * Add an offset to the unfixed coordinate of the given node.
             *
             * @param {NodeId} nodeId Id of the node to adjust
             * @param {number} diff Offset to add to the unfixed coordinate
             */

        }, {
            key: "shift",
            value: function shift(nodeId, diff) {
                this.fake_use(nodeId, diff);
                this.abstract();
            }
        }]);

        return DirectionInterface;
    }();
    /**
     * Vertical Strategy
     *
     * Coordinate `y` is fixed on levels, coordinate `x` is unfixed.
     *
     * @augments DirectionInterface
     * @private
     */


    var VerticalStrategy = /*#__PURE__*/function (_DirectionInterface) {
        _inherits(VerticalStrategy, _DirectionInterface);

        var _super = _createSuper(VerticalStrategy);

        /**
         * Constructor
         *
         * @param {object} layout reference to the parent LayoutEngine instance.
         */
        function VerticalStrategy(layout) {
            var _this;

            _classCallCheck(this, VerticalStrategy);

            _this = _super.call(this);
            _this.layout = layout;
            return _this;
        }
        /** @inheritDoc */


        _createClass(VerticalStrategy, [{
            key: "curveType",
            value: function curveType() {
                return "horizontal";
            }
            /** @inheritDoc */

        }, {
            key: "getPosition",
            value: function getPosition(node) {
                return node.x;
            }
            /** @inheritDoc */

        }, {
            key: "setPosition",
            value: function setPosition(node, position) {
                var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

                if (level !== undefined) {
                    this.layout.hierarchical.addToOrdering(node, level);
                }

                node.x = position;
            }
            /** @inheritDoc */

        }, {
            key: "getTreeSize",
            value: function getTreeSize(index) {
                var res = this.layout.hierarchical.getTreeSize(this.layout.body.nodes, index);
                return {
                    min: res.min_x,
                    max: res.max_x
                };
            }
            /** @inheritDoc */

        }, {
            key: "sort",
            value: function sort(nodeArray) {
                timsort.sort(nodeArray, function (a, b) {
                    return a.x - b.x;
                });
            }
            /** @inheritDoc */

        }, {
            key: "fix",
            value: function fix(node, level) {
                node.y = this.layout.options.hierarchical.levelSeparation * level;
                node.options.fixed.y = true;
            }
            /** @inheritDoc */

        }, {
            key: "shift",
            value: function shift(nodeId, diff) {
                this.layout.body.nodes[nodeId].x += diff;
            }
        }]);

        return VerticalStrategy;
    }(DirectionInterface);
    /**
     * Horizontal Strategy
     *
     * Coordinate `x` is fixed on levels, coordinate `y` is unfixed.
     *
     * @augments DirectionInterface
     * @private
     */


    var HorizontalStrategy = /*#__PURE__*/function (_DirectionInterface2) {
        _inherits(HorizontalStrategy, _DirectionInterface2);

        var _super2 = _createSuper(HorizontalStrategy);

        /**
         * Constructor
         *
         * @param {object} layout reference to the parent LayoutEngine instance.
         */
        function HorizontalStrategy(layout) {
            var _this2;

            _classCallCheck(this, HorizontalStrategy);

            _this2 = _super2.call(this);
            _this2.layout = layout;
            return _this2;
        }
        /** @inheritDoc */


        _createClass(HorizontalStrategy, [{
            key: "curveType",
            value: function curveType() {
                return "vertical";
            }
            /** @inheritDoc */

        }, {
            key: "getPosition",
            value: function getPosition(node) {
                return node.y;
            }
            /** @inheritDoc */

        }, {
            key: "setPosition",
            value: function setPosition(node, position) {
                var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

                if (level !== undefined) {
                    this.layout.hierarchical.addToOrdering(node, level);
                }

                node.y = position;
            }
            /** @inheritDoc */

        }, {
            key: "getTreeSize",
            value: function getTreeSize(index) {
                var res = this.layout.hierarchical.getTreeSize(this.layout.body.nodes, index);
                return {
                    min: res.min_y,
                    max: res.max_y
                };
            }
            /** @inheritDoc */

        }, {
            key: "sort",
            value: function sort(nodeArray) {
                timsort.sort(nodeArray, function (a, b) {
                    return a.y - b.y;
                });
            }
            /** @inheritDoc */

        }, {
            key: "fix",
            value: function fix(node, level) {
                node.x = this.layout.options.hierarchical.levelSeparation * level;
                node.options.fixed.x = true;
            }
            /** @inheritDoc */

        }, {
            key: "shift",
            value: function shift(nodeId, diff) {
                this.layout.body.nodes[nodeId].y += diff;
            }
        }]);

        return HorizontalStrategy;
    }(DirectionInterface);

    var $every = arrayIteration.every;
    var STRICT_METHOD = arrayMethodIsStrict('every'); // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every

    _export({
        target: 'Array',
        proto: true,
        forced: !STRICT_METHOD
    }, {
        every: function every(callbackfn
                              /* , thisArg */
        ) {
            return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        }
    });

    var every$2 = entryVirtual('Array').every;

    var ArrayPrototype = Array.prototype;

    var every_1 = function (it) {
        var own = it.every;
        return it === ArrayPrototype || it instanceof Array && own === ArrayPrototype.every ? every$2 : own;
    };

    var every$1 = every_1;

    var every = every$1;

    function _createForOfIteratorHelper$1(o, allowArrayLike) { var it; if (typeof symbol === "undefined" || getIteratorMethod(o) == null) { if (isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

    function _unsupportedIterableToArray$1(o, minLen) { var _context9; if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = slice$1(_context9 = Object.prototype.toString.call(o)).call(_context9, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return from$2(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

    function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

    /**
     * Try to assign levels to nodes according to their positions in the cyclic “hierarchy”.
     *
     * @param nodes - Visible nodes of the graph.
     * @param levels - If present levels will be added to it, if not a new object will be created.
     *
     * @returns Populated node levels.
     */
    function fillLevelsByDirectionCyclic(nodes, levels) {
        var edges = new set();

        forEach$2(nodes).call(nodes, function (node) {
            var _context;

            forEach$2(_context = node.edges).call(_context, function (edge) {
                if (edge.connected) {
                    edges.add(edge);
                }
            });
        });

        forEach$2(edges).call(edges, function (edge) {
            var fromId = edge.from.id;
            var toId = edge.to.id;

            if (levels[fromId] == null) {
                levels[fromId] = 0;
            }

            if (levels[toId] == null || levels[fromId] >= levels[toId]) {
                levels[toId] = levels[fromId] + 1;
            }
        });

        return levels;
    }
    /**
     * Assign levels to nodes according to their positions in the hierarchy. Leaves will be lined up at the bottom and all other nodes as close to their children as possible.
     *
     * @param nodes - Visible nodes of the graph.
     *
     * @returns Populated node levels.
     */


    function fillLevelsByDirectionLeaves(nodes) {
        return fillLevelsByDirection( // Pick only leaves (nodes without children).
            function (node) {
                var _context2, _context3;

                return every(_context2 = filter(_context3 = node.edges // Take only visible nodes into account.
                    ).call(_context3, function (edge) {
                        return nodes.has(edge.toId);
                    }) // Check that all edges lead to this node (leaf).
                ).call(_context2, function (edge) {
                    return edge.to === node;
                });
            }, // Use the lowest level.
            function (newLevel, oldLevel) {
                return oldLevel > newLevel;
            }, // Go against the direction of the edges.
            "from", nodes);
    }
    /**
     * Assign levels to nodes according to their positions in the hierarchy. Roots will be lined up at the top and all nodes as close to their parents as possible.
     *
     * @param nodes - Visible nodes of the graph.
     *
     * @returns Populated node levels.
     */

    function fillLevelsByDirectionRoots(nodes) {
        return fillLevelsByDirection( // Pick only roots (nodes without parents).
            function (node) {
                var _context4, _context5;

                return every(_context4 = filter(_context5 = node.edges // Take only visible nodes into account.
                    ).call(_context5, function (edge) {
                        return nodes.has(edge.toId);
                    }) // Check that all edges lead from this node (root).
                ).call(_context4, function (edge) {
                    return edge.from === node;
                });
            }, // Use the highest level.
            function (newLevel, oldLevel) {
                return oldLevel < newLevel;
            }, // Go in the direction of the edges.
            "to", nodes);
    }
    /**
     * Assign levels to nodes according to their positions in the hierarchy.
     *
     * @param isEntryNode - Checks and return true if the graph should be traversed from this node.
     * @param shouldLevelBeReplaced - Checks and returns true if the level of given node should be updated to the new value.
     * @param direction - Wheter the graph should be traversed in the direction of the edges `"to"` or in the other way `"from"`.
     * @param nodes - Visible nodes of the graph.
     *
     * @returns Populated node levels.
     */

    function fillLevelsByDirection(isEntryNode, shouldLevelBeReplaced, direction, nodes) {
        var _context6;

        var levels = create$2(null); // If acyclic, the graph can be walked through with (most likely way) fewer
        // steps than the number bellow. The exact value isn't too important as long
        // as it's quick to compute (doesn't impact acyclic graphs too much), is
        // higher than the number of steps actually needed (doesn't cut off before
        // acyclic graph is walked through) and prevents infinite loops (cuts off for
        // cyclic graphs).


        var limit = reduce(_context6 = _toConsumableArray(values(nodes).call(nodes))).call(_context6, function (acc, node) {
            return acc + 1 + node.edges.length;
        }, 0);

        var edgeIdProp = direction + "Id";
        var newLevelDiff = direction === "to" ? 1 : -1;

        var _iterator = _createForOfIteratorHelper$1(nodes),
            _step;

        try {
            var _loop = function _loop() {
                var _step$value = _slicedToArray(_step.value, 2),
                    entryNodeId = _step$value[0],
                    entryNode = _step$value[1];

                if ( // Skip if the node is not visible.
                    !nodes.has(entryNodeId) || // Skip if the node is not an entry node.
                    !isEntryNode(entryNode)) {
                    return "continue";
                } // Line up all the entry nodes on level 0.


                levels[entryNodeId] = 0;
                var stack = [entryNode];
                var done = 0;
                var node = void 0;

                var _loop2 = function _loop2() {
                    var _context7, _context8;

                    if (!nodes.has(entryNodeId)) {
                        // Skip if the node is not visible.
                        return "continue";
                    }

                    var newLevel = levels[node.id] + newLevelDiff;

                    forEach$2(_context7 = filter(_context8 = node.edges).call(_context8, function (edge) {
                        return (// Ignore disconnected edges.
                            edge.connected && // Ignore circular edges.
                            edge.to !== edge.from && // Ignore edges leading to the node that's currently being processed.
                            edge[direction] !== node && // Ignore edges connecting to an invisible node.
                            nodes.has(edge.toId) && // Ignore edges connecting from an invisible node.
                            nodes.has(edge.fromId)
                        );
                    })).call(_context7, function (edge) {
                        var targetNodeId = edge[edgeIdProp];
                        var oldLevel = levels[targetNodeId];

                        if (oldLevel == null || shouldLevelBeReplaced(newLevel, oldLevel)) {
                            levels[targetNodeId] = newLevel;
                            stack.push(edge[direction]);
                        }
                    });

                    if (done > limit) {
                        // This would run forever on a cyclic graph.
                        return {
                            v: {
                                v: fillLevelsByDirectionCyclic(nodes, levels)
                            }
                        };
                    } else {
                        ++done;
                    }
                };

                while (node = stack.pop()) {
                    var _ret2 = _loop2();

                    if (_ret2 === "continue") continue;
                    if (_typeof(_ret2) === "object") return _ret2.v;
                }
            };

            for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _ret = _loop();

                if (_ret === "continue") continue;
                if (_typeof(_ret) === "object") return _ret.v;
            }
        } catch (err) {
            _iterator.e(err);
        } finally {
            _iterator.f();
        }

        return levels;
    }

    /**
     * There's a mix-up with terms in the code. Following are the formal definitions:
     *
     *   tree   - a strict hierarchical network, i.e. every node has at most one parent
     *   forest - a collection of trees. These distinct trees are thus not connected.
     *
     * So:
     * - in a network that is not a tree, there exist nodes with multiple parents.
     * - a network consisting of unconnected sub-networks, of which at least one
     *   is not a tree, is not a forest.
     *
     * In the code, the definitions are:
     *
     *   tree   - any disconnected sub-network, strict hierarchical or not.
     *   forest - a bunch of these sub-networks
     *
     * The difference between tree and not-tree is important in the code, notably within
     * to the block-shifting algorithm. The algorithm assumes formal trees and fails
     * for not-trees, often in a spectacular manner (search for 'exploding network' in the issues).
     *
     * In order to distinguish the definitions in the following code, the adjective 'formal' is
     * used. If 'formal' is absent, you must assume the non-formal definition.
     *
     * ----------------------------------------------------------------------------------
     * NOTES
     * =====
     *
     * A hierarchical layout is a different thing from a hierarchical network.
     * The layout is a way to arrange the nodes in the view; this can be done
     * on non-hierarchical networks as well. The converse is also possible.
     */
    /**
     * Container for derived data on current network, relating to hierarchy.
     *
     * @private
     */

    var HierarchicalStatus = /*#__PURE__*/function () {
        /**
         * @ignore
         */
        function HierarchicalStatus() {
            _classCallCheck(this, HierarchicalStatus);

            this.childrenReference = {}; // child id's per node id

            this.parentReference = {}; // parent id's per node id

            this.trees = {}; // tree id per node id; i.e. to which tree does given node id belong

            this.distributionOrdering = {}; // The nodes per level, in the display order

            this.levels = {}; // hierarchy level per node id

            this.distributionIndex = {}; // The position of the node in the level sorting order, per node id.

            this.isTree = false; // True if current network is a formal tree

            this.treeIndex = -1; // Highest tree id in current network.
        }
        /**
         * Add the relation between given nodes to the current state.
         *
         * @param {Node.id} parentNodeId
         * @param {Node.id} childNodeId
         */


        _createClass(HierarchicalStatus, [{
            key: "addRelation",
            value: function addRelation(parentNodeId, childNodeId) {
                if (this.childrenReference[parentNodeId] === undefined) {
                    this.childrenReference[parentNodeId] = [];
                }

                this.childrenReference[parentNodeId].push(childNodeId);

                if (this.parentReference[childNodeId] === undefined) {
                    this.parentReference[childNodeId] = [];
                }

                this.parentReference[childNodeId].push(parentNodeId);
            }
            /**
             * Check if the current state is for a formal tree or formal forest.
             *
             * This is the case if every node has at most one parent.
             *
             * Pre: parentReference init'ed properly for current network
             */

        }, {
            key: "checkIfTree",
            value: function checkIfTree() {
                for (var i in this.parentReference) {
                    if (this.parentReference[i].length > 1) {
                        this.isTree = false;
                        return;
                    }
                }

                this.isTree = true;
            }
            /**
             * Return the number of separate trees in the current network.
             *
             * @returns {number}
             */

        }, {
            key: "numTrees",
            value: function numTrees() {
                return this.treeIndex + 1; // This assumes the indexes are assigned consecitively
            }
            /**
             * Assign a tree id to a node
             *
             * @param {Node} node
             * @param {string|number} treeId
             */

        }, {
            key: "setTreeIndex",
            value: function setTreeIndex(node, treeId) {
                if (treeId === undefined) return; // Don't bother

                if (this.trees[node.id] === undefined) {
                    this.trees[node.id] = treeId;
                    this.treeIndex = Math.max(treeId, this.treeIndex);
                }
            }
            /**
             * Ensure level for given id is defined.
             *
             * Sets level to zero for given node id if not already present
             *
             * @param {Node.id} nodeId
             */

        }, {
            key: "ensureLevel",
            value: function ensureLevel(nodeId) {
                if (this.levels[nodeId] === undefined) {
                    this.levels[nodeId] = 0;
                }
            }
            /**
             * get the maximum level of a branch.
             *
             * TODO: Never entered; find a test case to test this!
             *
             * @param {Node.id} nodeId
             * @returns {number}
             */

        }, {
            key: "getMaxLevel",
            value: function getMaxLevel(nodeId) {
                var _this = this;

                var accumulator = {};

                var _getMaxLevel = function _getMaxLevel(nodeId) {
                    if (accumulator[nodeId] !== undefined) {
                        return accumulator[nodeId];
                    }

                    var level = _this.levels[nodeId];

                    if (_this.childrenReference[nodeId]) {
                        var children = _this.childrenReference[nodeId];

                        if (children.length > 0) {
                            for (var i = 0; i < children.length; i++) {
                                level = Math.max(level, _getMaxLevel(children[i]));
                            }
                        }
                    }

                    accumulator[nodeId] = level;
                    return level;
                };

                return _getMaxLevel(nodeId);
            }
            /**
             *
             * @param {Node} nodeA
             * @param {Node} nodeB
             */

        }, {
            key: "levelDownstream",
            value: function levelDownstream(nodeA, nodeB) {
                if (this.levels[nodeB.id] === undefined) {
                    // set initial level
                    if (this.levels[nodeA.id] === undefined) {
                        this.levels[nodeA.id] = 0;
                    } // set level


                    this.levels[nodeB.id] = this.levels[nodeA.id] + 1;
                }
            }
            /**
             * Small util method to set the minimum levels of the nodes to zero.
             *
             * @param {Array.<Node>} nodes
             */

        }, {
            key: "setMinLevelToZero",
            value: function setMinLevelToZero(nodes) {
                var minLevel = 1e9; // get the minimum level

                for (var nodeId in nodes) {
                    if (Object.prototype.hasOwnProperty.call(nodes, nodeId)) {
                        if (this.levels[nodeId] !== undefined) {
                            minLevel = Math.min(this.levels[nodeId], minLevel);
                        }
                    }
                } // subtract the minimum from the set so we have a range starting from 0


                for (var _nodeId in nodes) {
                    if (Object.prototype.hasOwnProperty.call(nodes, _nodeId)) {
                        if (this.levels[_nodeId] !== undefined) {
                            this.levels[_nodeId] -= minLevel;
                        }
                    }
                }
            }
            /**
             * Get the min and max xy-coordinates of a given tree
             *
             * @param {Array.<Node>} nodes
             * @param {number} index
             * @returns {{min_x: number, max_x: number, min_y: number, max_y: number}}
             */

        }, {
            key: "getTreeSize",
            value: function getTreeSize(nodes, index) {
                var min_x = 1e9;
                var max_x = -1e9;
                var min_y = 1e9;
                var max_y = -1e9;

                for (var nodeId in this.trees) {
                    if (Object.prototype.hasOwnProperty.call(this.trees, nodeId)) {
                        if (this.trees[nodeId] === index) {
                            var node = nodes[nodeId];
                            min_x = Math.min(node.x, min_x);
                            max_x = Math.max(node.x, max_x);
                            min_y = Math.min(node.y, min_y);
                            max_y = Math.max(node.y, max_y);
                        }
                    }
                }

                return {
                    min_x: min_x,
                    max_x: max_x,
                    min_y: min_y,
                    max_y: max_y
                };
            }
            /**
             * Check if two nodes have the same parent(s)
             *
             * @param {Node} node1
             * @param {Node} node2
             * @returns {boolean} true if the two nodes have a same ancestor node, false otherwise
             */

        }, {
            key: "hasSameParent",
            value: function hasSameParent(node1, node2) {
                var parents1 = this.parentReference[node1.id];
                var parents2 = this.parentReference[node2.id];

                if (parents1 === undefined || parents2 === undefined) {
                    return false;
                }

                for (var i = 0; i < parents1.length; i++) {
                    for (var j = 0; j < parents2.length; j++) {
                        if (parents1[i] == parents2[j]) {
                            return true;
                        }
                    }
                }

                return false;
            }
            /**
             * Check if two nodes are in the same tree.
             *
             * @param {Node} node1
             * @param {Node} node2
             * @returns {boolean} true if this is so, false otherwise
             */

        }, {
            key: "inSameSubNetwork",
            value: function inSameSubNetwork(node1, node2) {
                return this.trees[node1.id] === this.trees[node2.id];
            }
            /**
             * Get a list of the distinct levels in the current network
             *
             * @returns {Array}
             */

        }, {
            key: "getLevels",
            value: function getLevels() {
                return keys$3(this.distributionOrdering);
            }
            /**
             * Add a node to the ordering per level
             *
             * @param {Node} node
             * @param {number} level
             */

        }, {
            key: "addToOrdering",
            value: function addToOrdering(node, level) {
                if (this.distributionOrdering[level] === undefined) {
                    this.distributionOrdering[level] = [];
                }

                var isPresent = false;
                var curLevel = this.distributionOrdering[level];

                for (var n in curLevel) {
                    //if (curLevel[n].id === node.id) {
                    if (curLevel[n] === node) {
                        isPresent = true;
                        break;
                    }
                }

                if (!isPresent) {
                    this.distributionOrdering[level].push(node);
                    this.distributionIndex[node.id] = this.distributionOrdering[level].length - 1;
                }
            }
        }]);

        return HierarchicalStatus;
    }();
    /**
     * The Layout Engine
     */


    var LayoutEngine = /*#__PURE__*/function () {
        /**
         * @param {object} body
         */
        function LayoutEngine(body) {
            _classCallCheck(this, LayoutEngine);

            this.body = body; // Make sure there always is some RNG because the setOptions method won't
            // set it unless there's a seed for it.

            this._resetRNG(Math.random() + ":" + now$1());

            this.setPhysics = false;
            this.options = {};
            this.optionsBackup = {
                physics: {}
            };
            this.defaultOptions = {
                randomSeed: undefined,
                improvedLayout: true,
                clusterThreshold: 150,
                hierarchical: {
                    enabled: false,
                    levelSeparation: 150,
                    nodeSpacing: 100,
                    treeSpacing: 200,
                    blockShifting: true,
                    edgeMinimization: true,
                    parentCentralization: true,
                    direction: "UD",
                    // UD, DU, LR, RL
                    sortMethod: "hubsize" // hubsize, directed

                }
            };

            assign$2(this.options, this.defaultOptions);

            this.bindEventListeners();
        }
        /**
         * Binds event listeners
         */


        _createClass(LayoutEngine, [{
            key: "bindEventListeners",
            value: function bindEventListeners() {
                var _this2 = this;

                this.body.emitter.on("_dataChanged", function () {
                    _this2.setupHierarchicalLayout();
                });
                this.body.emitter.on("_dataLoaded", function () {
                    _this2.layoutNetwork();
                });
                this.body.emitter.on("_resetHierarchicalLayout", function () {
                    _this2.setupHierarchicalLayout();
                });
                this.body.emitter.on("_adjustEdgesForHierarchicalLayout", function () {
                    if (_this2.options.hierarchical.enabled !== true) {
                        return;
                    } // get the type of static smooth curve in case it is required


                    var type = _this2.direction.curveType(); // force all edges into static smooth curves.


                    _this2.body.emitter.emit("_forceDisableDynamicCurves", type, false);
                });
            }
            /**
             *
             * @param {object} options
             * @param {object} allOptions
             * @returns {object}
             */

        }, {
            key: "setOptions",
            value: function setOptions(options, allOptions) {
                if (options !== undefined) {
                    var hierarchical = this.options.hierarchical;
                    var prevHierarchicalState = hierarchical.enabled;
                    selectiveDeepExtend(["randomSeed", "improvedLayout", "clusterThreshold"], this.options, options);
                    mergeOptions(this.options, options, "hierarchical");

                    if (options.randomSeed !== undefined) {
                        this._resetRNG(options.randomSeed);
                    }

                    if (hierarchical.enabled === true) {
                        if (prevHierarchicalState === true) {
                            // refresh the overridden options for nodes and edges.
                            this.body.emitter.emit("refresh", true);
                        } // make sure the level separation is the right way up


                        if (hierarchical.direction === "RL" || hierarchical.direction === "DU") {
                            if (hierarchical.levelSeparation > 0) {
                                hierarchical.levelSeparation *= -1;
                            }
                        } else {
                            if (hierarchical.levelSeparation < 0) {
                                hierarchical.levelSeparation *= -1;
                            }
                        }

                        this.setDirectionStrategy();
                        this.body.emitter.emit("_resetHierarchicalLayout"); // because the hierarchical system needs it's own physics and smooth curve settings,
                        // we adapt the other options if needed.

                        return this.adaptAllOptionsForHierarchicalLayout(allOptions);
                    } else {
                        if (prevHierarchicalState === true) {
                            // refresh the overridden options for nodes and edges.
                            this.body.emitter.emit("refresh");
                            return deepExtend(allOptions, this.optionsBackup);
                        }
                    }
                }

                return allOptions;
            }
            /**
             * Reset the random number generator with given seed.
             *
             * @param {any} seed - The seed that will be forwarded the the RNG.
             */

        }, {
            key: "_resetRNG",
            value: function _resetRNG(seed) {
                this.initialRandomSeed = seed;
                this._rng = Alea(this.initialRandomSeed);
            }
            /**
             *
             * @param {object} allOptions
             * @returns {object}
             */

        }, {
            key: "adaptAllOptionsForHierarchicalLayout",
            value: function adaptAllOptionsForHierarchicalLayout(allOptions) {
                if (this.options.hierarchical.enabled === true) {
                    var backupPhysics = this.optionsBackup.physics; // set the physics

                    if (allOptions.physics === undefined || allOptions.physics === true) {
                        allOptions.physics = {
                            enabled: backupPhysics.enabled === undefined ? true : backupPhysics.enabled,
                            solver: "hierarchicalRepulsion"
                        };
                        backupPhysics.enabled = backupPhysics.enabled === undefined ? true : backupPhysics.enabled;
                        backupPhysics.solver = backupPhysics.solver || "barnesHut";
                    } else if (_typeof(allOptions.physics) === "object") {
                        backupPhysics.enabled = allOptions.physics.enabled === undefined ? true : allOptions.physics.enabled;
                        backupPhysics.solver = allOptions.physics.solver || "barnesHut";
                        allOptions.physics.solver = "hierarchicalRepulsion";
                    } else if (allOptions.physics !== false) {
                        backupPhysics.solver = "barnesHut";
                        allOptions.physics = {
                            solver: "hierarchicalRepulsion"
                        };
                    } // get the type of static smooth curve in case it is required


                    var type = this.direction.curveType(); // disable smooth curves if nothing is defined. If smooth curves have been turned on,
                    // turn them into static smooth curves.

                    if (allOptions.edges === undefined) {
                        this.optionsBackup.edges = {
                            smooth: {
                                enabled: true,
                                type: "dynamic"
                            }
                        };
                        allOptions.edges = {
                            smooth: false
                        };
                    } else if (allOptions.edges.smooth === undefined) {
                        this.optionsBackup.edges = {
                            smooth: {
                                enabled: true,
                                type: "dynamic"
                            }
                        };
                        allOptions.edges.smooth = false;
                    } else {
                        if (typeof allOptions.edges.smooth === "boolean") {
                            this.optionsBackup.edges = {
                                smooth: allOptions.edges.smooth
                            };
                            allOptions.edges.smooth = {
                                enabled: allOptions.edges.smooth,
                                type: type
                            };
                        } else {
                            var smooth = allOptions.edges.smooth; // allow custom types except for dynamic

                            if (smooth.type !== undefined && smooth.type !== "dynamic") {
                                type = smooth.type;
                            } // TODO: this is options merging; see if the standard routines can be used here.


                            this.optionsBackup.edges = {
                                smooth: {
                                    enabled: smooth.enabled === undefined ? true : smooth.enabled,
                                    type: smooth.type === undefined ? "dynamic" : smooth.type,
                                    roundness: smooth.roundness === undefined ? 0.5 : smooth.roundness,
                                    forceDirection: smooth.forceDirection === undefined ? false : smooth.forceDirection
                                }
                            }; // NOTE: Copying an object to self; this is basically setting defaults for undefined variables

                            allOptions.edges.smooth = {
                                enabled: smooth.enabled === undefined ? true : smooth.enabled,
                                type: type,
                                roundness: smooth.roundness === undefined ? 0.5 : smooth.roundness,
                                forceDirection: smooth.forceDirection === undefined ? false : smooth.forceDirection
                            };
                        }
                    } // Force all edges into static smooth curves.
                    // Only applies to edges that do not use the global options for smooth.


                    this.body.emitter.emit("_forceDisableDynamicCurves", type);
                }

                return allOptions;
            }
            /**
             *
             * @param {Array.<Node>} nodesArray
             */

        }, {
            key: "positionInitially",
            value: function positionInitially(nodesArray) {
                if (this.options.hierarchical.enabled !== true) {
                    this._resetRNG(this.initialRandomSeed);

                    var radius = nodesArray.length + 50;

                    for (var i = 0; i < nodesArray.length; i++) {
                        var node = nodesArray[i];

                        var angle = 2 * Math.PI * this._rng();

                        if (node.x === undefined) {
                            node.x = radius * Math.cos(angle);
                        }

                        if (node.y === undefined) {
                            node.y = radius * Math.sin(angle);
                        }
                    }
                }
            }
            /**
             * Use Kamada Kawai to position nodes. This is quite a heavy algorithm so if there are a lot of nodes we
             * cluster them first to reduce the amount.
             */

        }, {
            key: "layoutNetwork",
            value: function layoutNetwork() {
                if (this.options.hierarchical.enabled !== true && this.options.improvedLayout === true) {
                    var indices = this.body.nodeIndices; // first check if we should Kamada Kawai to layout. The threshold is if less than half of the visible
                    // nodes have predefined positions we use this.

                    var positionDefined = 0;

                    for (var i = 0; i < indices.length; i++) {
                        var node = this.body.nodes[indices[i]];

                        if (node.predefinedPosition === true) {
                            positionDefined += 1;
                        }
                    } // if less than half of the nodes have a predefined position we continue


                    if (positionDefined < 0.5 * indices.length) {
                        var MAX_LEVELS = 10;
                        var level = 0;
                        var clusterThreshold = this.options.clusterThreshold; //
                        // Define the options for the hidden cluster nodes
                        // These options don't propagate outside the clustering phase.
                        //
                        // Some options are explicitly disabled, because they may be set in group or default node options.
                        // The clusters are never displayed, so most explicit settings here serve as performance optimizations.
                        //
                        // The explicit setting of 'shape' is to avoid `shape: 'image'`; images are not passed to the hidden
                        // cluster nodes, leading to an exception on creation.
                        //
                        // All settings here are performance related, except when noted otherwise.
                        //

                        var clusterOptions = {
                            clusterNodeProperties: {
                                shape: "ellipse",
                                // Bugfix: avoid type 'image', no images supplied
                                label: "",
                                // avoid label handling
                                group: "",
                                // avoid group handling
                                font: {
                                    multi: false
                                } // avoid font propagation

                            },
                            clusterEdgeProperties: {
                                label: "",
                                // avoid label handling
                                font: {
                                    multi: false
                                },
                                // avoid font propagation
                                smooth: {
                                    enabled: false // avoid drawing penalty for complex edges

                                }
                            }
                        }; // if there are a lot of nodes, we cluster before we run the algorithm.
                        // NOTE: this part fails to find clusters for large scale-free networks, which should
                        //       be easily clusterable.
                        // TODO: examine why this is so

                        if (indices.length > clusterThreshold) {
                            var startLength = indices.length;

                            while (indices.length > clusterThreshold && level <= MAX_LEVELS) {
                                //console.time("clustering")
                                level += 1;
                                var before = indices.length; // if there are many nodes we do a hubsize cluster

                                if (level % 3 === 0) {
                                    this.body.modules.clustering.clusterBridges(clusterOptions);
                                } else {
                                    this.body.modules.clustering.clusterOutliers(clusterOptions);
                                }

                                var after = indices.length;

                                if (before == after && level % 3 !== 0) {
                                    this._declusterAll();

                                    this.body.emitter.emit("_layoutFailed");
                                    console.info("This network could not be positioned by this version of the improved layout algorithm." + " Please disable improvedLayout for better performance.");
                                    return;
                                } //console.timeEnd("clustering")
                                //console.log(before,level,after);

                            } // increase the size of the edges


                            this.body.modules.kamadaKawai.setOptions({
                                springLength: Math.max(150, 2 * startLength)
                            });
                        }

                        if (level > MAX_LEVELS) {
                            console.info("The clustering didn't succeed within the amount of interations allowed," + " progressing with partial result.");
                        } // position the system for these nodes and edges


                        this.body.modules.kamadaKawai.solve(indices, this.body.edgeIndices, true); // shift to center point

                        this._shiftToCenter(); // perturb the nodes a little bit to force the physics to kick in


                        var offset = 70;

                        for (var _i = 0; _i < indices.length; _i++) {
                            // Only perturb the nodes that aren't fixed
                            var _node = this.body.nodes[indices[_i]];

                            if (_node.predefinedPosition === false) {
                                _node.x += (0.5 - this._rng()) * offset;
                                _node.y += (0.5 - this._rng()) * offset;
                            }
                        } // uncluster all clusters


                        this._declusterAll(); // reposition all bezier nodes.


                        this.body.emitter.emit("_repositionBezierNodes");
                    }
                }
            }
            /**
             * Move all the nodes towards to the center so gravitational pull wil not move the nodes away from view
             *
             * @private
             */

        }, {
            key: "_shiftToCenter",
            value: function _shiftToCenter() {
                var range = NetworkUtil.getRangeCore(this.body.nodes, this.body.nodeIndices);
                var center = NetworkUtil.findCenter(range);

                for (var i = 0; i < this.body.nodeIndices.length; i++) {
                    var node = this.body.nodes[this.body.nodeIndices[i]];
                    node.x -= center.x;
                    node.y -= center.y;
                }
            }
            /**
             * Expands all clusters
             *
             * @private
             */

        }, {
            key: "_declusterAll",
            value: function _declusterAll() {
                var clustersPresent = true;

                while (clustersPresent === true) {
                    clustersPresent = false;

                    for (var i = 0; i < this.body.nodeIndices.length; i++) {
                        if (this.body.nodes[this.body.nodeIndices[i]].isCluster === true) {
                            clustersPresent = true;
                            this.body.modules.clustering.openCluster(this.body.nodeIndices[i], {}, false);
                        }
                    }

                    if (clustersPresent === true) {
                        this.body.emitter.emit("_dataChanged");
                    }
                }
            }
            /**
             *
             * @returns {number|*}
             */

        }, {
            key: "getSeed",
            value: function getSeed() {
                return this.initialRandomSeed;
            }
            /**
             * This is the main function to layout the nodes in a hierarchical way.
             * It checks if the node details are supplied correctly
             *
             * @private
             */

        }, {
            key: "setupHierarchicalLayout",
            value: function setupHierarchicalLayout() {
                if (this.options.hierarchical.enabled === true && this.body.nodeIndices.length > 0) {
                    // get the size of the largest hubs and check if the user has defined a level for a node.
                    var node, nodeId;
                    var definedLevel = false;
                    var undefinedLevel = false;
                    this.lastNodeOnLevel = {};
                    this.hierarchical = new HierarchicalStatus();

                    for (nodeId in this.body.nodes) {
                        if (Object.prototype.hasOwnProperty.call(this.body.nodes, nodeId)) {
                            node = this.body.nodes[nodeId];

                            if (node.options.level !== undefined) {
                                definedLevel = true;
                                this.hierarchical.levels[nodeId] = node.options.level;
                            } else {
                                undefinedLevel = true;
                            }
                        }
                    } // if the user defined some levels but not all, alert and run without hierarchical layout


                    if (undefinedLevel === true && definedLevel === true) {
                        throw new Error("To use the hierarchical layout, nodes require either no predefined levels" + " or levels have to be defined for all nodes.");
                    } else {
                        // define levels if undefined by the users. Based on hubsize.
                        if (undefinedLevel === true) {
                            var sortMethod = this.options.hierarchical.sortMethod;

                            if (sortMethod === "hubsize") {
                                this._determineLevelsByHubsize();
                            } else if (sortMethod === "directed") {
                                this._determineLevelsDirected();
                            } else if (sortMethod === "custom") {
                                this._determineLevelsCustomCallback();
                            }
                        } // fallback for cases where there are nodes but no edges


                        for (var _nodeId2 in this.body.nodes) {
                            if (Object.prototype.hasOwnProperty.call(this.body.nodes, _nodeId2)) {
                                this.hierarchical.ensureLevel(_nodeId2);
                            }
                        } // check the distribution of the nodes per level.


                        var distribution = this._getDistribution(); // get the parent children relations.


                        this._generateMap(); // place the nodes on the canvas.


                        this._placeNodesByHierarchy(distribution); // condense the whitespace.


                        this._condenseHierarchy(); // shift to center so gravity does not have to do much


                        this._shiftToCenter();
                    }
                }
            }
            /**
             * @private
             */

        }, {
            key: "_condenseHierarchy",
            value: function _condenseHierarchy() {
                var _this3 = this;

                // Global var in this scope to define when the movement has stopped.
                var stillShifting = false;
                var branches = {}; // first we have some methods to help shifting trees around.
                // the main method to shift the trees

                var shiftTrees = function shiftTrees() {
                    var treeSizes = getTreeSizes();
                    var shiftBy = 0;

                    for (var i = 0; i < treeSizes.length - 1; i++) {
                        var diff = treeSizes[i].max - treeSizes[i + 1].min;
                        shiftBy += diff + _this3.options.hierarchical.treeSpacing;
                        shiftTree(i + 1, shiftBy);
                    }
                }; // shift a single tree by an offset


                var shiftTree = function shiftTree(index, offset) {
                    var trees = _this3.hierarchical.trees;

                    for (var nodeId in trees) {
                        if (Object.prototype.hasOwnProperty.call(trees, nodeId)) {
                            if (trees[nodeId] === index) {
                                _this3.direction.shift(nodeId, offset);
                            }
                        }
                    }
                }; // get the width of all trees


                var getTreeSizes = function getTreeSizes() {
                    var treeWidths = [];

                    for (var i = 0; i < _this3.hierarchical.numTrees(); i++) {
                        treeWidths.push(_this3.direction.getTreeSize(i));
                    }

                    return treeWidths;
                }; // get a map of all nodes in this branch


                var getBranchNodes = function getBranchNodes(source, map) {
                    if (map[source.id]) {
                        return;
                    }

                    map[source.id] = true;

                    if (_this3.hierarchical.childrenReference[source.id]) {
                        var children = _this3.hierarchical.childrenReference[source.id];

                        if (children.length > 0) {
                            for (var i = 0; i < children.length; i++) {
                                getBranchNodes(_this3.body.nodes[children[i]], map);
                            }
                        }
                    }
                }; // get a min max width as well as the maximum movement space it has on either sides
                // we use min max terminology because width and height can interchange depending on the direction of the layout


                var getBranchBoundary = function getBranchBoundary(branchMap) {
                    var maxLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1e9;
                    var minSpace = 1e9;
                    var maxSpace = 1e9;
                    var min = 1e9;
                    var max = -1e9;

                    for (var branchNode in branchMap) {
                        if (Object.prototype.hasOwnProperty.call(branchMap, branchNode)) {
                            var node = _this3.body.nodes[branchNode];
                            var level = _this3.hierarchical.levels[node.id];

                            var position = _this3.direction.getPosition(node); // get the space around the node.


                            var _this3$_getSpaceAroun = _this3._getSpaceAroundNode(node, branchMap),
                                _this3$_getSpaceAroun2 = _slicedToArray(_this3$_getSpaceAroun, 2),
                                minSpaceNode = _this3$_getSpaceAroun2[0],
                                maxSpaceNode = _this3$_getSpaceAroun2[1];

                            minSpace = Math.min(minSpaceNode, minSpace);
                            maxSpace = Math.min(maxSpaceNode, maxSpace); // the width is only relevant for the levels two nodes have in common. This is why we filter on this.

                            if (level <= maxLevel) {
                                min = Math.min(position, min);
                                max = Math.max(position, max);
                            }
                        }
                    }

                    return [min, max, minSpace, maxSpace];
                }; // check what the maximum level is these nodes have in common.


                var getCollisionLevel = function getCollisionLevel(node1, node2) {
                    var maxLevel1 = _this3.hierarchical.getMaxLevel(node1.id);

                    var maxLevel2 = _this3.hierarchical.getMaxLevel(node2.id);

                    return Math.min(maxLevel1, maxLevel2);
                };
                /**
                 * Condense elements. These can be nodes or branches depending on the callback.
                 *
                 * @param {Function} callback
                 * @param {Array.<number>} levels
                 * @param {*} centerParents
                 */


                var shiftElementsCloser = function shiftElementsCloser(callback, levels, centerParents) {
                    var hier = _this3.hierarchical;

                    for (var i = 0; i < levels.length; i++) {
                        var level = levels[i];
                        var levelNodes = hier.distributionOrdering[level];

                        if (levelNodes.length > 1) {
                            for (var j = 0; j < levelNodes.length - 1; j++) {
                                var node1 = levelNodes[j];
                                var node2 = levelNodes[j + 1]; // NOTE: logic maintained as it was; if nodes have same ancestor,
                                //       then of course they are in the same sub-network.

                                if (hier.hasSameParent(node1, node2) && hier.inSameSubNetwork(node1, node2)) {
                                    callback(node1, node2, centerParents);
                                }
                            }
                        }
                    }
                }; // callback for shifting branches


                var branchShiftCallback = function branchShiftCallback(node1, node2) {
                    var centerParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                    //window.CALLBACKS.push(() => {
                    var pos1 = _this3.direction.getPosition(node1);

                    var pos2 = _this3.direction.getPosition(node2);

                    var diffAbs = Math.abs(pos2 - pos1);
                    var nodeSpacing = _this3.options.hierarchical.nodeSpacing; //console.log("NOW CHECKING:", node1.id, node2.id, diffAbs);

                    if (diffAbs > nodeSpacing) {
                        var branchNodes1 = {};
                        var branchNodes2 = {};
                        getBranchNodes(node1, branchNodes1);
                        getBranchNodes(node2, branchNodes2); // check the largest distance between the branches

                        var maxLevel = getCollisionLevel(node1, node2);
                        var branchNodeBoundary1 = getBranchBoundary(branchNodes1, maxLevel);
                        var branchNodeBoundary2 = getBranchBoundary(branchNodes2, maxLevel);
                        var max1 = branchNodeBoundary1[1];
                        var min2 = branchNodeBoundary2[0];
                        var minSpace2 = branchNodeBoundary2[2]; //console.log(node1.id, getBranchBoundary(branchNodes1, maxLevel), node2.id,
                        //            getBranchBoundary(branchNodes2, maxLevel), maxLevel);

                        var diffBranch = Math.abs(max1 - min2);

                        if (diffBranch > nodeSpacing) {
                            var offset = max1 - min2 + nodeSpacing;

                            if (offset < -minSpace2 + nodeSpacing) {
                                offset = -minSpace2 + nodeSpacing; //console.log("RESETTING OFFSET", max1 - min2 + this.options.hierarchical.nodeSpacing, -minSpace2, offset);
                            }

                            if (offset < 0) {
                                //console.log("SHIFTING", node2.id, offset);
                                _this3._shiftBlock(node2.id, offset);

                                stillShifting = true;
                                if (centerParent === true) _this3._centerParent(node2);
                            }
                        }
                    } //this.body.emitter.emit("_redraw");})

                };

                var minimizeEdgeLength = function minimizeEdgeLength(iterations, node) {
                    //window.CALLBACKS.push(() => {
                    //  console.log("ts",node.id);
                    var nodeId = node.id;
                    var allEdges = node.edges;
                    var nodeLevel = _this3.hierarchical.levels[node.id]; // gather constants

                    var C2 = _this3.options.hierarchical.levelSeparation * _this3.options.hierarchical.levelSeparation;
                    var referenceNodes = {};
                    var aboveEdges = [];

                    for (var i = 0; i < allEdges.length; i++) {
                        var edge = allEdges[i];

                        if (edge.toId != edge.fromId) {
                            var otherNode = edge.toId == nodeId ? edge.from : edge.to;
                            referenceNodes[allEdges[i].id] = otherNode;

                            if (_this3.hierarchical.levels[otherNode.id] < nodeLevel) {
                                aboveEdges.push(edge);
                            }
                        }
                    } // differentiated sum of lengths based on only moving one node over one axis


                    var getFx = function getFx(point, edges) {
                        var sum = 0;

                        for (var _i2 = 0; _i2 < edges.length; _i2++) {
                            if (referenceNodes[edges[_i2].id] !== undefined) {
                                var a = _this3.direction.getPosition(referenceNodes[edges[_i2].id]) - point;
                                sum += a / Math.sqrt(a * a + C2);
                            }
                        }

                        return sum;
                    }; // doubly differentiated sum of lengths based on only moving one node over one axis


                    var getDFx = function getDFx(point, edges) {
                        var sum = 0;

                        for (var _i3 = 0; _i3 < edges.length; _i3++) {
                            if (referenceNodes[edges[_i3].id] !== undefined) {
                                var a = _this3.direction.getPosition(referenceNodes[edges[_i3].id]) - point;
                                sum -= C2 * Math.pow(a * a + C2, -1.5);
                            }
                        }

                        return sum;
                    };

                    var getGuess = function getGuess(iterations, edges) {
                        var guess = _this3.direction.getPosition(node); // Newton's method for optimization


                        var guessMap = {};

                        for (var _i4 = 0; _i4 < iterations; _i4++) {
                            var fx = getFx(guess, edges);
                            var dfx = getDFx(guess, edges); // we limit the movement to avoid instability.

                            var limit = 40;
                            var ratio = Math.max(-limit, Math.min(limit, Math.round(fx / dfx)));
                            guess = guess - ratio; // reduce duplicates

                            if (guessMap[guess] !== undefined) {
                                break;
                            }

                            guessMap[guess] = _i4;
                        }

                        return guess;
                    };

                    var moveBranch = function moveBranch(guess) {
                        // position node if there is space
                        var nodePosition = _this3.direction.getPosition(node); // check movable area of the branch


                        if (branches[node.id] === undefined) {
                            var branchNodes = {};
                            getBranchNodes(node, branchNodes);
                            branches[node.id] = branchNodes;
                        }

                        var branchBoundary = getBranchBoundary(branches[node.id]);
                        var minSpaceBranch = branchBoundary[2];
                        var maxSpaceBranch = branchBoundary[3];
                        var diff = guess - nodePosition; // check if we are allowed to move the node:

                        var branchOffset = 0;

                        if (diff > 0) {
                            branchOffset = Math.min(diff, maxSpaceBranch - _this3.options.hierarchical.nodeSpacing);
                        } else if (diff < 0) {
                            branchOffset = -Math.min(-diff, minSpaceBranch - _this3.options.hierarchical.nodeSpacing);
                        }

                        if (branchOffset != 0) {
                            //console.log("moving branch:",branchOffset, maxSpaceBranch, minSpaceBranch)
                            _this3._shiftBlock(node.id, branchOffset); //this.body.emitter.emit("_redraw");


                            stillShifting = true;
                        }
                    };

                    var moveNode = function moveNode(guess) {
                        var nodePosition = _this3.direction.getPosition(node); // position node if there is space


                        var _this3$_getSpaceAroun3 = _this3._getSpaceAroundNode(node),
                            _this3$_getSpaceAroun4 = _slicedToArray(_this3$_getSpaceAroun3, 2),
                            minSpace = _this3$_getSpaceAroun4[0],
                            maxSpace = _this3$_getSpaceAroun4[1];

                        var diff = guess - nodePosition; // check if we are allowed to move the node:

                        var newPosition = nodePosition;

                        if (diff > 0) {
                            newPosition = Math.min(nodePosition + (maxSpace - _this3.options.hierarchical.nodeSpacing), guess);
                        } else if (diff < 0) {
                            newPosition = Math.max(nodePosition - (minSpace - _this3.options.hierarchical.nodeSpacing), guess);
                        }

                        if (newPosition !== nodePosition) {
                            //console.log("moving Node:",diff, minSpace, maxSpace);
                            _this3.direction.setPosition(node, newPosition); //this.body.emitter.emit("_redraw");


                            stillShifting = true;
                        }
                    };

                    var guess = getGuess(iterations, aboveEdges);
                    moveBranch(guess);
                    guess = getGuess(iterations, allEdges);
                    moveNode(guess); //})
                }; // method to remove whitespace between branches. Because we do bottom up, we can center the parents.


                var minimizeEdgeLengthBottomUp = function minimizeEdgeLengthBottomUp(iterations) {
                    var levels = _this3.hierarchical.getLevels();

                    levels = reverse(levels).call(levels);

                    for (var i = 0; i < iterations; i++) {
                        stillShifting = false;

                        for (var j = 0; j < levels.length; j++) {
                            var level = levels[j];
                            var levelNodes = _this3.hierarchical.distributionOrdering[level];

                            for (var k = 0; k < levelNodes.length; k++) {
                                minimizeEdgeLength(1000, levelNodes[k]);
                            }
                        }

                        if (stillShifting !== true) {
                            //console.log("FINISHED minimizeEdgeLengthBottomUp IN " + i);
                            break;
                        }
                    }
                }; // method to remove whitespace between branches. Because we do bottom up, we can center the parents.


                var shiftBranchesCloserBottomUp = function shiftBranchesCloserBottomUp(iterations) {
                    var levels = _this3.hierarchical.getLevels();

                    levels = reverse(levels).call(levels);

                    for (var i = 0; i < iterations; i++) {
                        stillShifting = false;
                        shiftElementsCloser(branchShiftCallback, levels, true);

                        if (stillShifting !== true) {
                            //console.log("FINISHED shiftBranchesCloserBottomUp IN " + (i+1));
                            break;
                        }
                    }
                }; // center all parents


                var centerAllParents = function centerAllParents() {
                    for (var nodeId in _this3.body.nodes) {
                        if (Object.prototype.hasOwnProperty.call(_this3.body.nodes, nodeId)) _this3._centerParent(_this3.body.nodes[nodeId]);
                    }
                }; // center all parents


                var centerAllParentsBottomUp = function centerAllParentsBottomUp() {
                    var levels = _this3.hierarchical.getLevels();

                    levels = reverse(levels).call(levels);

                    for (var i = 0; i < levels.length; i++) {
                        var level = levels[i];
                        var levelNodes = _this3.hierarchical.distributionOrdering[level];

                        for (var j = 0; j < levelNodes.length; j++) {
                            _this3._centerParent(levelNodes[j]);
                        }
                    }
                }; // the actual work is done here.


                if (this.options.hierarchical.blockShifting === true) {
                    shiftBranchesCloserBottomUp(5);
                    centerAllParents();
                } // minimize edge length


                if (this.options.hierarchical.edgeMinimization === true) {
                    minimizeEdgeLengthBottomUp(20);
                }

                if (this.options.hierarchical.parentCentralization === true) {
                    centerAllParentsBottomUp();
                }

                shiftTrees();
            }
            /**
             * This gives the space around the node. IF a map is supplied, it will only check against nodes NOT in the map.
             * This is used to only get the distances to nodes outside of a branch.
             *
             * @param {Node} node
             * @param {{Node.id: vis.Node}} map
             * @returns {number[]}
             * @private
             */

        }, {
            key: "_getSpaceAroundNode",
            value: function _getSpaceAroundNode(node, map) {
                var useMap = true;

                if (map === undefined) {
                    useMap = false;
                }

                var level = this.hierarchical.levels[node.id];

                if (level !== undefined) {
                    var index = this.hierarchical.distributionIndex[node.id];
                    var position = this.direction.getPosition(node);
                    var ordering = this.hierarchical.distributionOrdering[level];
                    var minSpace = 1e9;
                    var maxSpace = 1e9;

                    if (index !== 0) {
                        var prevNode = ordering[index - 1];

                        if (useMap === true && map[prevNode.id] === undefined || useMap === false) {
                            var prevPos = this.direction.getPosition(prevNode);
                            minSpace = position - prevPos;
                        }
                    }

                    if (index != ordering.length - 1) {
                        var nextNode = ordering[index + 1];

                        if (useMap === true && map[nextNode.id] === undefined || useMap === false) {
                            var nextPos = this.direction.getPosition(nextNode);
                            maxSpace = Math.min(maxSpace, nextPos - position);
                        }
                    }

                    return [minSpace, maxSpace];
                } else {
                    return [0, 0];
                }
            }
            /**
             * We use this method to center a parent node and check if it does not cross other nodes when it does.
             *
             * @param {Node} node
             * @private
             */

        }, {
            key: "_centerParent",
            value: function _centerParent(node) {
                if (this.hierarchical.parentReference[node.id]) {
                    var parents = this.hierarchical.parentReference[node.id];

                    for (var i = 0; i < parents.length; i++) {
                        var parentId = parents[i];
                        var parentNode = this.body.nodes[parentId];
                        var children = this.hierarchical.childrenReference[parentId];

                        if (children !== undefined) {
                            // get the range of the children
                            var newPosition = this._getCenterPosition(children);

                            var position = this.direction.getPosition(parentNode);

                            var _this$_getSpaceAround = this._getSpaceAroundNode(parentNode),
                                _this$_getSpaceAround2 = _slicedToArray(_this$_getSpaceAround, 2),
                                minSpace = _this$_getSpaceAround2[0],
                                maxSpace = _this$_getSpaceAround2[1];

                            var diff = position - newPosition;

                            if (diff < 0 && Math.abs(diff) < maxSpace - this.options.hierarchical.nodeSpacing || diff > 0 && Math.abs(diff) < minSpace - this.options.hierarchical.nodeSpacing) {
                                this.direction.setPosition(parentNode, newPosition);
                            }
                        }
                    }
                }
            }
            /**
             * This function places the nodes on the canvas based on the hierarchial distribution.
             *
             * @param {object} distribution | obtained by the function this._getDistribution()
             * @private
             */

        }, {
            key: "_placeNodesByHierarchy",
            value: function _placeNodesByHierarchy(distribution) {
                this.positionedNodes = {}; // start placing all the level 0 nodes first. Then recursively position their branches.

                for (var level in distribution) {
                    if (Object.prototype.hasOwnProperty.call(distribution, level)) {
                        var _context;

                        // sort nodes in level by position:
                        var nodeArray = keys$3(distribution[level]);

                        nodeArray = this._indexArrayToNodes(nodeArray);

                        sort(_context = this.direction).call(_context, nodeArray);

                        var handledNodeCount = 0;

                        for (var i = 0; i < nodeArray.length; i++) {
                            var node = nodeArray[i];

                            if (this.positionedNodes[node.id] === undefined) {
                                var spacing = this.options.hierarchical.nodeSpacing;
                                var pos = spacing * handledNodeCount; // We get the X or Y values we need and store them in pos and previousPos.
                                // The get and set make sure we get X or Y

                                if (handledNodeCount > 0) {
                                    pos = this.direction.getPosition(nodeArray[i - 1]) + spacing;
                                }

                                this.direction.setPosition(node, pos, level);

                                this._validatePositionAndContinue(node, level, pos);

                                handledNodeCount++;
                            }
                        }
                    }
                }
            }
            /**
             * This is a recursively called function to enumerate the branches from the largest hubs and place the nodes
             * on a X position that ensures there will be no overlap.
             *
             * @param {Node.id} parentId
             * @param {number} parentLevel
             * @private
             */

        }, {
            key: "_placeBranchNodes",
            value: function _placeBranchNodes(parentId, parentLevel) {
                var _context2;

                var childRef = this.hierarchical.childrenReference[parentId]; // if this is not a parent, cancel the placing. This can happen with multiple parents to one child.

                if (childRef === undefined) {
                    return;
                } // get a list of childNodes


                var childNodes = [];

                for (var i = 0; i < childRef.length; i++) {
                    childNodes.push(this.body.nodes[childRef[i]]);
                } // use the positions to order the nodes.


                sort(_context2 = this.direction).call(_context2, childNodes); // position the childNodes


                for (var _i5 = 0; _i5 < childNodes.length; _i5++) {
                    var childNode = childNodes[_i5];
                    var childNodeLevel = this.hierarchical.levels[childNode.id]; // check if the child node is below the parent node and if it has already been positioned.

                    if (childNodeLevel > parentLevel && this.positionedNodes[childNode.id] === undefined) {
                        // get the amount of space required for this node. If parent the width is based on the amount of children.
                        var spacing = this.options.hierarchical.nodeSpacing;
                        var pos = void 0; // we get the X or Y values we need and store them in pos and previousPos.
                        // The get and set make sure we get X or Y

                        if (_i5 === 0) {
                            pos = this.direction.getPosition(this.body.nodes[parentId]);
                        } else {
                            pos = this.direction.getPosition(childNodes[_i5 - 1]) + spacing;
                        }

                        this.direction.setPosition(childNode, pos, childNodeLevel);

                        this._validatePositionAndContinue(childNode, childNodeLevel, pos);
                    } else {
                        return;
                    }
                } // center the parent nodes.


                var center = this._getCenterPosition(childNodes);

                this.direction.setPosition(this.body.nodes[parentId], center, parentLevel);
            }
            /**
             * This method checks for overlap and if required shifts the branch. It also keeps records of positioned nodes.
             * Finally it will call _placeBranchNodes to place the branch nodes.
             *
             * @param {Node} node
             * @param {number} level
             * @param {number} pos
             * @private
             */

        }, {
            key: "_validatePositionAndContinue",
            value: function _validatePositionAndContinue(node, level, pos) {
                // This method only works for formal trees and formal forests
                // Early exit if this is not the case
                if (!this.hierarchical.isTree) return; // if overlap has been detected, we shift the branch

                if (this.lastNodeOnLevel[level] !== undefined) {
                    var previousPos = this.direction.getPosition(this.body.nodes[this.lastNodeOnLevel[level]]);

                    if (pos - previousPos < this.options.hierarchical.nodeSpacing) {
                        var diff = previousPos + this.options.hierarchical.nodeSpacing - pos;

                        var sharedParent = this._findCommonParent(this.lastNodeOnLevel[level], node.id);

                        this._shiftBlock(sharedParent.withChild, diff);
                    }
                }

                this.lastNodeOnLevel[level] = node.id; // store change in position.

                this.positionedNodes[node.id] = true;

                this._placeBranchNodes(node.id, level);
            }
            /**
             * Receives an array with node indices and returns an array with the actual node references.
             * Used for sorting based on node properties.
             *
             * @param {Array.<Node.id>} idArray
             * @returns {Array.<Node>}
             */

        }, {
            key: "_indexArrayToNodes",
            value: function _indexArrayToNodes(idArray) {
                var array = [];

                for (var i = 0; i < idArray.length; i++) {
                    array.push(this.body.nodes[idArray[i]]);
                }

                return array;
            }
            /**
             * This function get the distribution of levels based on hubsize
             *
             * @returns {object}
             * @private
             */

        }, {
            key: "_getDistribution",
            value: function _getDistribution() {
                var distribution = {};
                var nodeId, node; // we fix Y because the hierarchy is vertical,
                // we fix X so we do not give a node an x position for a second time.
                // the fix of X is removed after the x value has been set.

                for (nodeId in this.body.nodes) {
                    if (Object.prototype.hasOwnProperty.call(this.body.nodes, nodeId)) {
                        node = this.body.nodes[nodeId];
                        var level = this.hierarchical.levels[nodeId] === undefined ? 0 : this.hierarchical.levels[nodeId];
                        this.direction.fix(node, level);

                        if (distribution[level] === undefined) {
                            distribution[level] = {};
                        }

                        distribution[level][nodeId] = node;
                    }
                }

                return distribution;
            }
            /**
             * Return the active (i.e. visible) edges for this node
             *
             * @param {Node} node
             * @returns {Array.<vis.Edge>} Array of edge instances
             * @private
             */

        }, {
            key: "_getActiveEdges",
            value: function _getActiveEdges(node) {
                var _this4 = this;

                var result = [];
                forEach$1(node.edges, function (edge) {
                    var _context3;

                    if (indexOf(_context3 = _this4.body.edgeIndices).call(_context3, edge.id) !== -1) {
                        result.push(edge);
                    }
                });
                return result;
            }
            /**
             * Get the hubsizes for all active nodes.
             *
             * @returns {number}
             * @private
             */

        }, {
            key: "_getHubSizes",
            value: function _getHubSizes() {
                var _this5 = this;

                var hubSizes = {};
                var nodeIds = this.body.nodeIndices;
                forEach$1(nodeIds, function (nodeId) {
                    var node = _this5.body.nodes[nodeId];

                    var hubSize = _this5._getActiveEdges(node).length;

                    hubSizes[hubSize] = true;
                }); // Make an array of the size sorted descending

                var result = [];
                forEach$1(hubSizes, function (size) {
                    result.push(Number(size));
                });

                sort(timsort).call(timsort, result, function (a, b) {
                    return b - a;
                });

                return result;
            }
            /**
             * this function allocates nodes in levels based on the recursive branching from the largest hubs.
             *
             * @private
             */

        }, {
            key: "_determineLevelsByHubsize",
            value: function _determineLevelsByHubsize() {
                var _this6 = this;

                var levelDownstream = function levelDownstream(nodeA, nodeB) {
                    _this6.hierarchical.levelDownstream(nodeA, nodeB);
                };

                var hubSizes = this._getHubSizes();

                var _loop = function _loop(i) {
                    var hubSize = hubSizes[i];
                    if (hubSize === 0) return "break";
                    forEach$1(_this6.body.nodeIndices, function (nodeId) {
                        var node = _this6.body.nodes[nodeId];

                        if (hubSize === _this6._getActiveEdges(node).length) {
                            _this6._crawlNetwork(levelDownstream, nodeId);
                        }
                    });
                };

                for (var i = 0; i < hubSizes.length; ++i) {
                    var _ret = _loop(i);

                    if (_ret === "break") break;
                }
            }
            /**
             * TODO: release feature
             * TODO: Determine if this feature is needed at all
             *
             * @private
             */

        }, {
            key: "_determineLevelsCustomCallback",
            value: function _determineLevelsCustomCallback() {
                var _this7 = this;

                var minLevel = 100000; // TODO: this should come from options.
                // eslint-disable-next-line no-unused-vars -- This should eventually be implemented with these parameters used.

                var customCallback = function customCallback(nodeA, nodeB, edge) {}; // TODO: perhaps move to HierarchicalStatus.
                //       But I currently don't see the point, this method is not used.


                var levelByDirection = function levelByDirection(nodeA, nodeB, edge) {
                    var levelA = _this7.hierarchical.levels[nodeA.id]; // set initial level

                    if (levelA === undefined) {
                        levelA = _this7.hierarchical.levels[nodeA.id] = minLevel;
                    }

                    var diff = customCallback(NetworkUtil.cloneOptions(nodeA, "node"), NetworkUtil.cloneOptions(nodeB, "node"), NetworkUtil.cloneOptions(edge, "edge"));
                    _this7.hierarchical.levels[nodeB.id] = levelA + diff;
                };

                this._crawlNetwork(levelByDirection);

                this.hierarchical.setMinLevelToZero(this.body.nodes);
            }
            /**
             * Allocate nodes in levels based on the direction of the edges.
             *
             * @private
             */

        }, {
            key: "_determineLevelsDirected",
            value: function _determineLevelsDirected() {
                var _context4,
                    _this8 = this;

                var nodes = reduce(_context4 = this.body.nodeIndices).call(_context4, function (acc, id) {
                    acc.set(id, _this8.body.nodes[id]);
                    return acc;
                }, new map());

                if (this.options.hierarchical.shakeTowards === "roots") {
                    this.hierarchical.levels = fillLevelsByDirectionRoots(nodes);
                } else {
                    this.hierarchical.levels = fillLevelsByDirectionLeaves(nodes);
                }

                this.hierarchical.setMinLevelToZero(this.body.nodes);
            }
            /**
             * Update the bookkeeping of parent and child.
             *
             * @private
             */

        }, {
            key: "_generateMap",
            value: function _generateMap() {
                var _this9 = this;

                var fillInRelations = function fillInRelations(parentNode, childNode) {
                    if (_this9.hierarchical.levels[childNode.id] > _this9.hierarchical.levels[parentNode.id]) {
                        _this9.hierarchical.addRelation(parentNode.id, childNode.id);
                    }
                };

                this._crawlNetwork(fillInRelations);

                this.hierarchical.checkIfTree();
            }
            /**
             * Crawl over the entire network and use a callback on each node couple that is connected to each other.
             *
             * @param {Function} [callback=function(){}]          | will receive nodeA, nodeB and the connecting edge. A and B are distinct.
             * @param {Node.id} startingNodeId
             * @private
             */

        }, {
            key: "_crawlNetwork",
            value: function _crawlNetwork() {
                var _this10 = this;

                var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
                var startingNodeId = arguments.length > 1 ? arguments[1] : undefined;
                var progress = {};

                var crawler = function crawler(node, tree) {
                    if (progress[node.id] === undefined) {
                        _this10.hierarchical.setTreeIndex(node, tree);

                        progress[node.id] = true;
                        var childNode;

                        var edges = _this10._getActiveEdges(node);

                        for (var i = 0; i < edges.length; i++) {
                            var edge = edges[i];

                            if (edge.connected === true) {
                                if (edge.toId == node.id) {
                                    // Not '===' because id's can be string and numeric
                                    childNode = edge.from;
                                } else {
                                    childNode = edge.to;
                                }

                                if (node.id != childNode.id) {
                                    // Not '!==' because id's can be string and numeric
                                    callback(node, childNode, edge);
                                    crawler(childNode, tree);
                                }
                            }
                        }
                    }
                };

                if (startingNodeId === undefined) {
                    // Crawl over all nodes
                    var treeIndex = 0; // Serves to pass a unique id for the current distinct tree

                    for (var i = 0; i < this.body.nodeIndices.length; i++) {
                        var nodeId = this.body.nodeIndices[i];

                        if (progress[nodeId] === undefined) {
                            var node = this.body.nodes[nodeId];
                            crawler(node, treeIndex);
                            treeIndex += 1;
                        }
                    }
                } else {
                    // Crawl from the given starting node
                    var _node2 = this.body.nodes[startingNodeId];

                    if (_node2 === undefined) {
                        console.error("Node not found:", startingNodeId);
                        return;
                    }

                    crawler(_node2);
                }
            }
            /**
             * Shift a branch a certain distance
             *
             * @param {Node.id} parentId
             * @param {number} diff
             * @private
             */

        }, {
            key: "_shiftBlock",
            value: function _shiftBlock(parentId, diff) {
                var _this11 = this;

                var progress = {};

                var shifter = function shifter(parentId) {
                    if (progress[parentId]) {
                        return;
                    }

                    progress[parentId] = true;

                    _this11.direction.shift(parentId, diff);

                    var childRef = _this11.hierarchical.childrenReference[parentId];

                    if (childRef !== undefined) {
                        for (var i = 0; i < childRef.length; i++) {
                            shifter(childRef[i]);
                        }
                    }
                };

                shifter(parentId);
            }
            /**
             * Find a common parent between branches.
             *
             * @param {Node.id} childA
             * @param {Node.id} childB
             * @returns {{foundParent, withChild}}
             * @private
             */

        }, {
            key: "_findCommonParent",
            value: function _findCommonParent(childA, childB) {
                var _this12 = this;

                var parents = {};

                var iterateParents = function iterateParents(parents, child) {
                    var parentRef = _this12.hierarchical.parentReference[child];

                    if (parentRef !== undefined) {
                        for (var i = 0; i < parentRef.length; i++) {
                            var parent = parentRef[i];
                            parents[parent] = true;
                            iterateParents(parents, parent);
                        }
                    }
                };

                var findParent = function findParent(parents, child) {
                    var parentRef = _this12.hierarchical.parentReference[child];

                    if (parentRef !== undefined) {
                        for (var i = 0; i < parentRef.length; i++) {
                            var parent = parentRef[i];

                            if (parents[parent] !== undefined) {
                                return {
                                    foundParent: parent,
                                    withChild: child
                                };
                            }

                            var branch = findParent(parents, parent);

                            if (branch.foundParent !== null) {
                                return branch;
                            }
                        }
                    }

                    return {
                        foundParent: null,
                        withChild: child
                    };
                };

                iterateParents(parents, childA);
                return findParent(parents, childB);
            }
            /**
             * Set the strategy pattern for handling the coordinates given the current direction.
             *
             * The individual instances contain all the operations and data specific to a layout direction.
             *
             * @param {Node} node
             * @param {{x: number, y: number}} position
             * @param {number} level
             * @param {boolean} [doNotUpdate=false]
             * @private
             */

        }, {
            key: "setDirectionStrategy",
            value: function setDirectionStrategy() {
                var isVertical = this.options.hierarchical.direction === "UD" || this.options.hierarchical.direction === "DU";

                if (isVertical) {
                    this.direction = new VerticalStrategy(this);
                } else {
                    this.direction = new HorizontalStrategy(this);
                }
            }
            /**
             * Determine the center position of a branch from the passed list of child nodes
             *
             * This takes into account the positions of all the child nodes.
             *
             * @param {Array.<Node|vis.Node.id>} childNodes  Array of either child nodes or node id's
             * @returns {number}
             * @private
             */

        }, {
            key: "_getCenterPosition",
            value: function _getCenterPosition(childNodes) {
                var minPos = 1e9;
                var maxPos = -1e9;

                for (var i = 0; i < childNodes.length; i++) {
                    var childNode = void 0;

                    if (childNodes[i].id !== undefined) {
                        childNode = childNodes[i];
                    } else {
                        var childNodeId = childNodes[i];
                        childNode = this.body.nodes[childNodeId];
                    }

                    var position = this.direction.getPosition(childNode);
                    minPos = Math.min(minPos, position);
                    maxPos = Math.max(maxPos, position);
                }

                return 0.5 * (minPos + maxPos);
            }
        }]);

        return LayoutEngine;
    }();

    var css_248z = "div.vis-network div.vis-manipulation {\n  box-sizing: content-box;\n\n  border-width: 0;\n  border-bottom: 1px;\n  border-style: solid;\n  border-color: #d6d9d8;\n  background: #ffffff; /* Old browsers */\n  background: -moz-linear-gradient(\n    top,\n    #ffffff 0%,\n    #fcfcfc 48%,\n    #fafafa 50%,\n    #fcfcfc 100%\n  ); /* FF3.6+ */\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(0%, #ffffff),\n    color-stop(48%, #fcfcfc),\n    color-stop(50%, #fafafa),\n    color-stop(100%, #fcfcfc)\n  ); /* Chrome,Safari4+ */\n  background: -webkit-linear-gradient(\n    top,\n    #ffffff 0%,\n    #fcfcfc 48%,\n    #fafafa 50%,\n    #fcfcfc 100%\n  ); /* Chrome10+,Safari5.1+ */\n  background: -o-linear-gradient(\n    top,\n    #ffffff 0%,\n    #fcfcfc 48%,\n    #fafafa 50%,\n    #fcfcfc 100%\n  ); /* Opera 11.10+ */\n  background: -ms-linear-gradient(\n    top,\n    #ffffff 0%,\n    #fcfcfc 48%,\n    #fafafa 50%,\n    #fcfcfc 100%\n  ); /* IE10+ */\n  background: linear-gradient(\n    to bottom,\n    #ffffff 0%,\n    #fcfcfc 48%,\n    #fafafa 50%,\n    #fcfcfc 100%\n  ); /* W3C */\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#fcfcfc',GradientType=0 ); /* IE6-9 */\n\n  padding-top: 4px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 28px;\n}\n\ndiv.vis-network div.vis-edit-mode,\ndiv.vis-network button.vis-edit-mode {\n  position: absolute;\n  left: 0;\n  top: 5px;\n  height: 30px;\n}\n\n/* FIXME: shouldn't the vis-close button be a child of the vis-manipulation div? */\n\ndiv.vis-network button.vis-close {\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 30px;\n  height: 30px;\n\n  background-color: transparent;\n  background-position: 20px 3px;\n  background-repeat: no-repeat;\n  background-image: url('data:image/png;base64,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');\n  border: none;\n  cursor: pointer;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\ndiv.vis-network button.vis-close:hover {\n  opacity: 0.6;\n}\n\ndiv.vis-network div.vis-manipulation button.vis-button,\ndiv.vis-network div.vis-edit-mode button.vis-button {\n  float: left;\n  font-family: verdana;\n  font-size: 12px;\n  border: none;\n  box-sizing: content-box;\n  -moz-border-radius: 15px;\n  border-radius: 15px;\n  background-color: transparent;\n  background-position: 0px 0px;\n  background-repeat: no-repeat;\n  height: 24px;\n  margin-left: 10px;\n  cursor: pointer;\n  padding: 0px 8px 0px 8px;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\ndiv.vis-network div.vis-manipulation button.vis-button:hover {\n  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.2);\n}\n\ndiv.vis-network div.vis-manipulation button.vis-button:active {\n  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.5);\n}\n\ndiv.vis-network div.vis-manipulation button.vis-button.vis-back {\n  background-image: url('data:image/png;base64,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');\n}\n\ndiv.vis-network div.vis-manipulation div.vis-none:hover {\n  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0);\n  cursor: default;\n}\ndiv.vis-network div.vis-manipulation div.vis-none:active {\n  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0);\n}\ndiv.vis-network div.vis-manipulation div.vis-none {\n  padding: 0px;\n  line-height: 23px;\n}\ndiv.vis-network div.vis-manipulation div.notification {\n  margin: 2px;\n  font-weight: bold;\n}\n\ndiv.vis-network div.vis-manipulation button.vis-button.vis-add {\n  background-image: url('data:image/png;base64,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');\n}\n\ndiv.vis-network div.vis-manipulation button.vis-button.vis-edit,\ndiv.vis-network div.vis-edit-mode button.vis-button.vis-edit {\n  background-image: url('data:image/png;base64,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');\n}\n\ndiv.vis-network div.vis-edit-mode button.vis-button.vis-edit.vis-edit-mode {\n  background-color: #fcfcfc;\n  border: 1px solid #cccccc;\n}\n\ndiv.vis-network div.vis-manipulation button.vis-button.vis-connect {\n  background-image: url('data:image/png;base64,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');\n}\n\ndiv.vis-network div.vis-manipulation button.vis-button.vis-delete {\n  background-image: url('data:image/png;base64,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');\n}\n/* top right bottom left */\ndiv.vis-network div.vis-manipulation div.vis-label,\ndiv.vis-network div.vis-edit-mode div.vis-label {\n  margin: 0 0 0 23px;\n  line-height: 25px;\n}\ndiv.vis-network div.vis-manipulation div.vis-separator-line {\n  float: left;\n  display: inline-block;\n  width: 1px;\n  height: 21px;\n  background-color: #bdbdbd;\n  margin: 0px 7px 0 15px; /*top right bottom left*/\n}\n\n/* TODO: is this redundant?\ndiv.network-navigation_wrapper {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n}\n*/\n";
    styleInject(css_248z);

    function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof symbol === "undefined" || getIteratorMethod(o) == null) { if (isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

    function _unsupportedIterableToArray(o, minLen) { var _context32; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = slice$1(_context32 = Object.prototype.toString.call(o)).call(_context32, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return from$2(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

    function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
    /**
     * Clears the toolbar div element of children
     *
     * @private
     */

    var ManipulationSystem = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {Canvas} canvas
         * @param {SelectionHandler} selectionHandler
         * @param {InteractionHandler} interactionHandler
         */
        function ManipulationSystem(body, canvas, selectionHandler, interactionHandler) {
            var _this = this,
                _context,
                _context2;

            _classCallCheck(this, ManipulationSystem);

            this.body = body;
            this.canvas = canvas;
            this.selectionHandler = selectionHandler;
            this.interactionHandler = interactionHandler;
            this.editMode = false;
            this.manipulationDiv = undefined;
            this.editModeDiv = undefined;
            this.closeDiv = undefined;
            this._domEventListenerCleanupQueue = [];
            this.temporaryUIFunctions = {};
            this.temporaryEventFunctions = [];
            this.touchTime = 0;
            this.temporaryIds = {
                nodes: [],
                edges: []
            };
            this.guiEnabled = false;
            this.inMode = false;
            this.selectedControlNode = undefined;
            this.options = {};
            this.defaultOptions = {
                enabled: false,
                initiallyActive: false,
                addNode: true,
                addEdge: true,
                editNode: undefined,
                editEdge: true,
                deleteNode: true,
                deleteEdge: true,
                controlNodeStyle: {
                    shape: "dot",
                    size: 6,
                    color: {
                        background: "#ff0000",
                        border: "#3c3c3c",
                        highlight: {
                            background: "#07f968",
                            border: "#3c3c3c"
                        }
                    },
                    borderWidth: 2,
                    borderWidthSelected: 2
                }
            };

            assign$2(this.options, this.defaultOptions);

            this.body.emitter.on("destroy", function () {
                _this._clean();
            });
            this.body.emitter.on("_dataChanged", bind(_context = this._restore).call(_context, this));
            this.body.emitter.on("_resetData", bind(_context2 = this._restore).call(_context2, this));
        }
        /**
         * If something changes in the data during editing, switch back to the initial datamanipulation state and close all edit modes.
         *
         * @private
         */


        _createClass(ManipulationSystem, [{
            key: "_restore",
            value: function _restore() {
                if (this.inMode !== false) {
                    if (this.options.initiallyActive === true) {
                        this.enableEditMode();
                    } else {
                        this.disableEditMode();
                    }
                }
            }
            /**
             * Set the Options
             *
             * @param {object} options
             * @param {object} allOptions
             * @param {object} globalOptions
             */

        }, {
            key: "setOptions",
            value: function setOptions(options, allOptions, globalOptions) {
                if (allOptions !== undefined) {
                    if (allOptions.locale !== undefined) {
                        this.options.locale = allOptions.locale;
                    } else {
                        this.options.locale = globalOptions.locale;
                    }

                    if (allOptions.locales !== undefined) {
                        this.options.locales = allOptions.locales;
                    } else {
                        this.options.locales = globalOptions.locales;
                    }
                }

                if (options !== undefined) {
                    if (typeof options === "boolean") {
                        this.options.enabled = options;
                    } else {
                        this.options.enabled = true;
                        deepExtend(this.options, options);
                    }

                    if (this.options.initiallyActive === true) {
                        this.editMode = true;
                    }

                    this._setup();
                }
            }
            /**
             * Enable or disable edit-mode. Draws the DOM required and cleans up after itself.
             *
             * @private
             */

        }, {
            key: "toggleEditMode",
            value: function toggleEditMode() {
                if (this.editMode === true) {
                    this.disableEditMode();
                } else {
                    this.enableEditMode();
                }
            }
            /**
             * Enables Edit Mode
             */

        }, {
            key: "enableEditMode",
            value: function enableEditMode() {
                this.editMode = true;

                this._clean();

                if (this.guiEnabled === true) {
                    this.manipulationDiv.style.display = "block";
                    this.closeDiv.style.display = "block";
                    this.editModeDiv.style.display = "none";
                    this.showManipulatorToolbar();
                }
            }
            /**
             * Disables Edit Mode
             */

        }, {
            key: "disableEditMode",
            value: function disableEditMode() {
                this.editMode = false;

                this._clean();

                if (this.guiEnabled === true) {
                    this.manipulationDiv.style.display = "none";
                    this.closeDiv.style.display = "none";
                    this.editModeDiv.style.display = "block";

                    this._createEditButton();
                }
            }
            /**
             * Creates the main toolbar. Removes functions bound to the select event. Binds all the buttons of the toolbar.
             *
             * @private
             */

        }, {
            key: "showManipulatorToolbar",
            value: function showManipulatorToolbar() {
                // restore the state of any bound functions or events, remove control nodes, restore physics
                this._clean(); // reset global variables


                this.manipulationDOM = {}; // if the gui is enabled, draw all elements.

                if (this.guiEnabled === true) {
                    var _context3, _context4;

                    // a _restore will hide these menus
                    this.editMode = true;
                    this.manipulationDiv.style.display = "block";
                    this.closeDiv.style.display = "block";
                    var selectedNodeCount = this.selectionHandler.getSelectedNodeCount();
                    var selectedEdgeCount = this.selectionHandler.getSelectedEdgeCount();
                    var selectedTotalCount = selectedNodeCount + selectedEdgeCount;
                    var locale = this.options.locales[this.options.locale];
                    var needSeperator = false;

                    if (this.options.addNode !== false) {
                        this._createAddNodeButton(locale);

                        needSeperator = true;
                    }

                    if (this.options.addEdge !== false) {
                        if (needSeperator === true) {
                            this._createSeperator(1);
                        } else {
                            needSeperator = true;
                        }

                        this._createAddEdgeButton(locale);
                    }

                    if (selectedNodeCount === 1 && typeof this.options.editNode === "function") {
                        if (needSeperator === true) {
                            this._createSeperator(2);
                        } else {
                            needSeperator = true;
                        }

                        this._createEditNodeButton(locale);
                    } else if (selectedEdgeCount === 1 && selectedNodeCount === 0 && this.options.editEdge !== false) {
                        if (needSeperator === true) {
                            this._createSeperator(3);
                        } else {
                            needSeperator = true;
                        }

                        this._createEditEdgeButton(locale);
                    } // remove buttons


                    if (selectedTotalCount !== 0) {
                        if (selectedNodeCount > 0 && this.options.deleteNode !== false) {
                            if (needSeperator === true) {
                                this._createSeperator(4);
                            }

                            this._createDeleteButton(locale);
                        } else if (selectedNodeCount === 0 && this.options.deleteEdge !== false) {
                            if (needSeperator === true) {
                                this._createSeperator(4);
                            }

                            this._createDeleteButton(locale);
                        }
                    } // bind the close button


                    this._bindElementEvents(this.closeDiv, bind(_context3 = this.toggleEditMode).call(_context3, this)); // refresh this bar based on what has been selected


                    this._temporaryBindEvent("select", bind(_context4 = this.showManipulatorToolbar).call(_context4, this));
                } // redraw to show any possible changes


                this.body.emitter.emit("_redraw");
            }
            /**
             * Create the toolbar for adding Nodes
             */

        }, {
            key: "addNodeMode",
            value: function addNodeMode() {
                var _context6;

                // when using the gui, enable edit mode if it wasnt already.
                if (this.editMode !== true) {
                    this.enableEditMode();
                } // restore the state of any bound functions or events, remove control nodes, restore physics


                this._clean();

                this.inMode = "addNode";

                if (this.guiEnabled === true) {
                    var _context5;

                    var locale = this.options.locales[this.options.locale];
                    this.manipulationDOM = {};

                    this._createBackButton(locale);

                    this._createSeperator();

                    this._createDescription(locale["addDescription"] || this.options.locales["en"]["addDescription"]); // bind the close button


                    this._bindElementEvents(this.closeDiv, bind(_context5 = this.toggleEditMode).call(_context5, this));
                }

                this._temporaryBindEvent("click", bind(_context6 = this._performAddNode).call(_context6, this));
            }
            /**
             * call the bound function to handle the editing of the node. The node has to be selected.
             */

        }, {
            key: "editNode",
            value: function editNode() {
                var _this2 = this;

                // when using the gui, enable edit mode if it wasnt already.
                if (this.editMode !== true) {
                    this.enableEditMode();
                } // restore the state of any bound functions or events, remove control nodes, restore physics


                this._clean();

                var node = this.selectionHandler.getSelectedNodes()[0];

                if (node !== undefined) {
                    this.inMode = "editNode";

                    if (typeof this.options.editNode === "function") {
                        if (node.isCluster !== true) {
                            var data = deepExtend({}, node.options, false);
                            data.x = node.x;
                            data.y = node.y;

                            if (this.options.editNode.length === 2) {
                                this.options.editNode(data, function (finalizedData) {
                                    if (finalizedData !== null && finalizedData !== undefined && _this2.inMode === "editNode") {
                                        // if for whatever reason the mode has changes (due to dataset change) disregard the callback) {
                                        _this2.body.data.nodes.getDataSet().update(finalizedData);
                                    }

                                    _this2.showManipulatorToolbar();
                                });
                            } else {
                                throw new Error("The function for edit does not support two arguments (data, callback)");
                            }
                        } else {
                            alert(this.options.locales[this.options.locale]["editClusterError"] || this.options.locales["en"]["editClusterError"]);
                        }
                    } else {
                        throw new Error("No function has been configured to handle the editing of nodes.");
                    }
                } else {
                    this.showManipulatorToolbar();
                }
            }
            /**
             * create the toolbar to connect nodes
             */

        }, {
            key: "addEdgeMode",
            value: function addEdgeMode() {
                var _context8, _context9, _context10, _context11, _context12;

                // when using the gui, enable edit mode if it wasnt already.
                if (this.editMode !== true) {
                    this.enableEditMode();
                } // restore the state of any bound functions or events, remove control nodes, restore physics


                this._clean();

                this.inMode = "addEdge";

                if (this.guiEnabled === true) {
                    var _context7;

                    var locale = this.options.locales[this.options.locale];
                    this.manipulationDOM = {};

                    this._createBackButton(locale);

                    this._createSeperator();

                    this._createDescription(locale["edgeDescription"] || this.options.locales["en"]["edgeDescription"]); // bind the close button


                    this._bindElementEvents(this.closeDiv, bind(_context7 = this.toggleEditMode).call(_context7, this));
                } // temporarily overload functions


                this._temporaryBindUI("onTouch", bind(_context8 = this._handleConnect).call(_context8, this));

                this._temporaryBindUI("onDragEnd", bind(_context9 = this._finishConnect).call(_context9, this));

                this._temporaryBindUI("onDrag", bind(_context10 = this._dragControlNode).call(_context10, this));

                this._temporaryBindUI("onRelease", bind(_context11 = this._finishConnect).call(_context11, this));

                this._temporaryBindUI("onDragStart", bind(_context12 = this._dragStartEdge).call(_context12, this));

                this._temporaryBindUI("onHold", function () {});
            }
            /**
             * create the toolbar to edit edges
             */

        }, {
            key: "editEdgeMode",
            value: function editEdgeMode() {
                // when using the gui, enable edit mode if it wasn't already.
                if (this.editMode !== true) {
                    this.enableEditMode();
                } // restore the state of any bound functions or events, remove control nodes, restore physics


                this._clean();

                this.inMode = "editEdge";

                if (_typeof(this.options.editEdge) === "object" && typeof this.options.editEdge.editWithoutDrag === "function") {
                    this.edgeBeingEditedId = this.selectionHandler.getSelectedEdgeIds()[0];

                    if (this.edgeBeingEditedId !== undefined) {
                        var edge = this.body.edges[this.edgeBeingEditedId];

                        this._performEditEdge(edge.from.id, edge.to.id);

                        return;
                    }
                }

                if (this.guiEnabled === true) {
                    var _context13;

                    var locale = this.options.locales[this.options.locale];
                    this.manipulationDOM = {};

                    this._createBackButton(locale);

                    this._createSeperator();

                    this._createDescription(locale["editEdgeDescription"] || this.options.locales["en"]["editEdgeDescription"]); // bind the close button


                    this._bindElementEvents(this.closeDiv, bind(_context13 = this.toggleEditMode).call(_context13, this));
                }

                this.edgeBeingEditedId = this.selectionHandler.getSelectedEdgeIds()[0];

                if (this.edgeBeingEditedId !== undefined) {
                    var _context14, _context15, _context16, _context17;

                    var _edge = this.body.edges[this.edgeBeingEditedId]; // create control nodes

                    var controlNodeFrom = this._getNewTargetNode(_edge.from.x, _edge.from.y);

                    var controlNodeTo = this._getNewTargetNode(_edge.to.x, _edge.to.y);

                    this.temporaryIds.nodes.push(controlNodeFrom.id);
                    this.temporaryIds.nodes.push(controlNodeTo.id);
                    this.body.nodes[controlNodeFrom.id] = controlNodeFrom;
                    this.body.nodeIndices.push(controlNodeFrom.id);
                    this.body.nodes[controlNodeTo.id] = controlNodeTo;
                    this.body.nodeIndices.push(controlNodeTo.id); // temporarily overload UI functions, cleaned up automatically because of _temporaryBindUI

                    this._temporaryBindUI("onTouch", bind(_context14 = this._controlNodeTouch).call(_context14, this)); // used to get the position


                    this._temporaryBindUI("onTap", function () {}); // disabled


                    this._temporaryBindUI("onHold", function () {}); // disabled


                    this._temporaryBindUI("onDragStart", bind(_context15 = this._controlNodeDragStart).call(_context15, this)); // used to select control node


                    this._temporaryBindUI("onDrag", bind(_context16 = this._controlNodeDrag).call(_context16, this)); // used to drag control node


                    this._temporaryBindUI("onDragEnd", bind(_context17 = this._controlNodeDragEnd).call(_context17, this)); // used to connect or revert control nodes


                    this._temporaryBindUI("onMouseMove", function () {}); // disabled
                    // create function to position control nodes correctly on movement
                    // automatically cleaned up because we use the temporary bind


                    this._temporaryBindEvent("beforeDrawing", function (ctx) {
                        var positions = _edge.edgeType.findBorderPositions(ctx);

                        if (controlNodeFrom.selected === false) {
                            controlNodeFrom.x = positions.from.x;
                            controlNodeFrom.y = positions.from.y;
                        }

                        if (controlNodeTo.selected === false) {
                            controlNodeTo.x = positions.to.x;
                            controlNodeTo.y = positions.to.y;
                        }
                    });

                    this.body.emitter.emit("_redraw");
                } else {
                    this.showManipulatorToolbar();
                }
            }
            /**
             * delete everything in the selection
             */

        }, {
            key: "deleteSelected",
            value: function deleteSelected() {
                var _this3 = this;

                // when using the gui, enable edit mode if it wasnt already.
                if (this.editMode !== true) {
                    this.enableEditMode();
                } // restore the state of any bound functions or events, remove control nodes, restore physics


                this._clean();

                this.inMode = "delete";
                var selectedNodes = this.selectionHandler.getSelectedNodeIds();
                var selectedEdges = this.selectionHandler.getSelectedEdgeIds();
                var deleteFunction = undefined;

                if (selectedNodes.length > 0) {
                    for (var i = 0; i < selectedNodes.length; i++) {
                        if (this.body.nodes[selectedNodes[i]].isCluster === true) {
                            alert(this.options.locales[this.options.locale]["deleteClusterError"] || this.options.locales["en"]["deleteClusterError"]);
                            return;
                        }
                    }

                    if (typeof this.options.deleteNode === "function") {
                        deleteFunction = this.options.deleteNode;
                    }
                } else if (selectedEdges.length > 0) {
                    if (typeof this.options.deleteEdge === "function") {
                        deleteFunction = this.options.deleteEdge;
                    }
                }

                if (typeof deleteFunction === "function") {
                    var data = {
                        nodes: selectedNodes,
                        edges: selectedEdges
                    };

                    if (deleteFunction.length === 2) {
                        deleteFunction(data, function (finalizedData) {
                            if (finalizedData !== null && finalizedData !== undefined && _this3.inMode === "delete") {
                                // if for whatever reason the mode has changes (due to dataset change) disregard the callback) {
                                _this3.body.data.edges.getDataSet().remove(finalizedData.edges);

                                _this3.body.data.nodes.getDataSet().remove(finalizedData.nodes);

                                _this3.body.emitter.emit("startSimulation");

                                _this3.showManipulatorToolbar();
                            } else {
                                _this3.body.emitter.emit("startSimulation");

                                _this3.showManipulatorToolbar();
                            }
                        });
                    } else {
                        throw new Error("The function for delete does not support two arguments (data, callback)");
                    }
                } else {
                    this.body.data.edges.getDataSet().remove(selectedEdges);
                    this.body.data.nodes.getDataSet().remove(selectedNodes);
                    this.body.emitter.emit("startSimulation");
                    this.showManipulatorToolbar();
                }
            } //********************************************** PRIVATE ***************************************//

            /**
             * draw or remove the DOM
             *
             * @private
             */

        }, {
            key: "_setup",
            value: function _setup() {
                if (this.options.enabled === true) {
                    // Enable the GUI
                    this.guiEnabled = true;

                    this._createWrappers();

                    if (this.editMode === false) {
                        this._createEditButton();
                    } else {
                        this.showManipulatorToolbar();
                    }
                } else {
                    this._removeManipulationDOM(); // disable the gui


                    this.guiEnabled = false;
                }
            }
            /**
             * create the div overlays that contain the DOM
             *
             * @private
             */

        }, {
            key: "_createWrappers",
            value: function _createWrappers() {
                // load the manipulator HTML elements. All styling done in css.
                if (this.manipulationDiv === undefined) {
                    this.manipulationDiv = document.createElement("div");
                    this.manipulationDiv.className = "vis-manipulation";

                    if (this.editMode === true) {
                        this.manipulationDiv.style.display = "block";
                    } else {
                        this.manipulationDiv.style.display = "none";
                    }

                    this.canvas.frame.appendChild(this.manipulationDiv);
                } // container for the edit button.


                if (this.editModeDiv === undefined) {
                    this.editModeDiv = document.createElement("div");
                    this.editModeDiv.className = "vis-edit-mode";

                    if (this.editMode === true) {
                        this.editModeDiv.style.display = "none";
                    } else {
                        this.editModeDiv.style.display = "block";
                    }

                    this.canvas.frame.appendChild(this.editModeDiv);
                } // container for the close div button


                if (this.closeDiv === undefined) {
                    var _this$options$locales, _this$options$locales2;

                    this.closeDiv = document.createElement("button");
                    this.closeDiv.className = "vis-close";
                    this.closeDiv.setAttribute("aria-label", (_this$options$locales = (_this$options$locales2 = this.options.locales[this.options.locale]) === null || _this$options$locales2 === void 0 ? void 0 : _this$options$locales2["close"]) !== null && _this$options$locales !== void 0 ? _this$options$locales : this.options.locales["en"]["close"]);
                    this.closeDiv.style.display = this.manipulationDiv.style.display;
                    this.canvas.frame.appendChild(this.closeDiv);
                }
            }
            /**
             * generate a new target node. Used for creating new edges and editing edges
             *
             * @param {number} x
             * @param {number} y
             * @returns {Node}
             * @private
             */

        }, {
            key: "_getNewTargetNode",
            value: function _getNewTargetNode(x, y) {
                var controlNodeStyle = deepExtend({}, this.options.controlNodeStyle);
                controlNodeStyle.id = "targetNode" + v4();
                controlNodeStyle.hidden = false;
                controlNodeStyle.physics = false;
                controlNodeStyle.x = x;
                controlNodeStyle.y = y; // we have to define the bounding box in order for the nodes to be drawn immediately

                var node = this.body.functions.createNode(controlNodeStyle);
                node.shape.boundingBox = {
                    left: x,
                    right: x,
                    top: y,
                    bottom: y
                };
                return node;
            }
            /**
             * Create the edit button
             */

        }, {
            key: "_createEditButton",
            value: function _createEditButton() {
                var _context18;

                // restore everything to it's original state (if applicable)
                this._clean(); // reset the manipulationDOM


                this.manipulationDOM = {}; // empty the editModeDiv

                recursiveDOMDelete(this.editModeDiv); // create the contents for the editMode button

                var locale = this.options.locales[this.options.locale];

                var button = this._createButton("editMode", "vis-edit vis-edit-mode", locale["edit"] || this.options.locales["en"]["edit"]);

                this.editModeDiv.appendChild(button); // bind a hammer listener to the button, calling the function toggleEditMode.

                this._bindElementEvents(button, bind(_context18 = this.toggleEditMode).call(_context18, this));
            }
            /**
             * this function cleans up after everything this module does. Temporary elements, functions and events are removed, physics restored, hammers removed.
             *
             * @private
             */

        }, {
            key: "_clean",
            value: function _clean() {
                // not in mode
                this.inMode = false; // _clean the divs

                if (this.guiEnabled === true) {
                    recursiveDOMDelete(this.editModeDiv);
                    recursiveDOMDelete(this.manipulationDiv); // removes all the bindings and overloads

                    this._cleanupDOMEventListeners();
                } // remove temporary nodes and edges


                this._cleanupTemporaryNodesAndEdges(); // restore overloaded UI functions


                this._unbindTemporaryUIs(); // remove the temporaryEventFunctions


                this._unbindTemporaryEvents(); // restore the physics if required


                this.body.emitter.emit("restorePhysics");
            }
            /**
             * Each dom element has it's own hammer. They are stored in this.manipulationHammers. This cleans them up.
             *
             * @private
             */

        }, {
            key: "_cleanupDOMEventListeners",
            value: function _cleanupDOMEventListeners() {
                var _context19;

                // _clean DOM event listener bindings
                var _iterator = _createForOfIteratorHelper(splice(_context19 = this._domEventListenerCleanupQueue).call(_context19, 0)),
                    _step;

                try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        var callback = _step.value;
                        callback();
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally {
                    _iterator.f();
                }
            }
            /**
             * Remove all DOM elements created by this module.
             *
             * @private
             */

        }, {
            key: "_removeManipulationDOM",
            value: function _removeManipulationDOM() {
                // removes all the bindings and overloads
                this._clean(); // empty the manipulation divs


                recursiveDOMDelete(this.manipulationDiv);
                recursiveDOMDelete(this.editModeDiv);
                recursiveDOMDelete(this.closeDiv); // remove the manipulation divs

                if (this.manipulationDiv) {
                    this.canvas.frame.removeChild(this.manipulationDiv);
                }

                if (this.editModeDiv) {
                    this.canvas.frame.removeChild(this.editModeDiv);
                }

                if (this.closeDiv) {
                    this.canvas.frame.removeChild(this.closeDiv);
                } // set the references to undefined


                this.manipulationDiv = undefined;
                this.editModeDiv = undefined;
                this.closeDiv = undefined;
            }
            /**
             * create a seperator line. the index is to differentiate in the manipulation dom
             *
             * @param {number} [index=1]
             * @private
             */

        }, {
            key: "_createSeperator",
            value: function _createSeperator() {
                var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
                this.manipulationDOM["seperatorLineDiv" + index] = document.createElement("div");
                this.manipulationDOM["seperatorLineDiv" + index].className = "vis-separator-line";
                this.manipulationDiv.appendChild(this.manipulationDOM["seperatorLineDiv" + index]);
            } // ----------------------    DOM functions for buttons    --------------------------//

            /**
             *
             * @param {Locale} locale
             * @private
             */

        }, {
            key: "_createAddNodeButton",
            value: function _createAddNodeButton(locale) {
                var _context20;

                var button = this._createButton("addNode", "vis-add", locale["addNode"] || this.options.locales["en"]["addNode"]);

                this.manipulationDiv.appendChild(button);

                this._bindElementEvents(button, bind(_context20 = this.addNodeMode).call(_context20, this));
            }
            /**
             *
             * @param {Locale} locale
             * @private
             */

        }, {
            key: "_createAddEdgeButton",
            value: function _createAddEdgeButton(locale) {
                var _context21;

                var button = this._createButton("addEdge", "vis-connect", locale["addEdge"] || this.options.locales["en"]["addEdge"]);

                this.manipulationDiv.appendChild(button);

                this._bindElementEvents(button, bind(_context21 = this.addEdgeMode).call(_context21, this));
            }
            /**
             *
             * @param {Locale} locale
             * @private
             */

        }, {
            key: "_createEditNodeButton",
            value: function _createEditNodeButton(locale) {
                var _context22;

                var button = this._createButton("editNode", "vis-edit", locale["editNode"] || this.options.locales["en"]["editNode"]);

                this.manipulationDiv.appendChild(button);

                this._bindElementEvents(button, bind(_context22 = this.editNode).call(_context22, this));
            }
            /**
             *
             * @param {Locale} locale
             * @private
             */

        }, {
            key: "_createEditEdgeButton",
            value: function _createEditEdgeButton(locale) {
                var _context23;

                var button = this._createButton("editEdge", "vis-edit", locale["editEdge"] || this.options.locales["en"]["editEdge"]);

                this.manipulationDiv.appendChild(button);

                this._bindElementEvents(button, bind(_context23 = this.editEdgeMode).call(_context23, this));
            }
            /**
             *
             * @param {Locale} locale
             * @private
             */

        }, {
            key: "_createDeleteButton",
            value: function _createDeleteButton(locale) {
                var _context24;

                var deleteBtnClass;

                if (this.options.rtl) {
                    deleteBtnClass = "vis-delete-rtl";
                } else {
                    deleteBtnClass = "vis-delete";
                }

                var button = this._createButton("delete", deleteBtnClass, locale["del"] || this.options.locales["en"]["del"]);

                this.manipulationDiv.appendChild(button);

                this._bindElementEvents(button, bind(_context24 = this.deleteSelected).call(_context24, this));
            }
            /**
             *
             * @param {Locale} locale
             * @private
             */

        }, {
            key: "_createBackButton",
            value: function _createBackButton(locale) {
                var _context25;

                var button = this._createButton("back", "vis-back", locale["back"] || this.options.locales["en"]["back"]);

                this.manipulationDiv.appendChild(button);

                this._bindElementEvents(button, bind(_context25 = this.showManipulatorToolbar).call(_context25, this));
            }
            /**
             *
             * @param {number|string} id
             * @param {string} className
             * @param {label} label
             * @param {string} labelClassName
             * @returns {HTMLElement}
             * @private
             */

        }, {
            key: "_createButton",
            value: function _createButton(id, className, label) {
                var labelClassName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "vis-label";
                this.manipulationDOM[id + "Div"] = document.createElement("button");
                this.manipulationDOM[id + "Div"].className = "vis-button " + className;
                this.manipulationDOM[id + "Label"] = document.createElement("div");
                this.manipulationDOM[id + "Label"].className = labelClassName;
                this.manipulationDOM[id + "Label"].innerText = label;
                this.manipulationDOM[id + "Div"].appendChild(this.manipulationDOM[id + "Label"]);
                return this.manipulationDOM[id + "Div"];
            }
            /**
             *
             * @param {Label} label
             * @private
             */

        }, {
            key: "_createDescription",
            value: function _createDescription(label) {
                this.manipulationDOM["descriptionLabel"] = document.createElement("div");
                this.manipulationDOM["descriptionLabel"].className = "vis-none";
                this.manipulationDOM["descriptionLabel"].innerText = label;
                this.manipulationDiv.appendChild(this.manipulationDOM["descriptionLabel"]);
            } // -------------------------- End of DOM functions for buttons ------------------------------//

            /**
             * this binds an event until cleanup by the clean functions.
             *
             * @param {Event}  event   The event
             * @param {Function} newFunction
             * @private
             */

        }, {
            key: "_temporaryBindEvent",
            value: function _temporaryBindEvent(event, newFunction) {
                this.temporaryEventFunctions.push({
                    event: event,
                    boundFunction: newFunction
                });
                this.body.emitter.on(event, newFunction);
            }
            /**
             * this overrides an UI function until cleanup by the clean function
             *
             * @param {string} UIfunctionName
             * @param {Function} newFunction
             * @private
             */

        }, {
            key: "_temporaryBindUI",
            value: function _temporaryBindUI(UIfunctionName, newFunction) {
                if (this.body.eventListeners[UIfunctionName] !== undefined) {
                    this.temporaryUIFunctions[UIfunctionName] = this.body.eventListeners[UIfunctionName];
                    this.body.eventListeners[UIfunctionName] = newFunction;
                } else {
                    throw new Error("This UI function does not exist. Typo? You tried: " + UIfunctionName + " possible are: " + stringify$1(keys$3(this.body.eventListeners)));
                }
            }
            /**
             * Restore the overridden UI functions to their original state.
             *
             * @private
             */

        }, {
            key: "_unbindTemporaryUIs",
            value: function _unbindTemporaryUIs() {
                for (var functionName in this.temporaryUIFunctions) {
                    if (Object.prototype.hasOwnProperty.call(this.temporaryUIFunctions, functionName)) {
                        this.body.eventListeners[functionName] = this.temporaryUIFunctions[functionName];
                        delete this.temporaryUIFunctions[functionName];
                    }
                }

                this.temporaryUIFunctions = {};
            }
            /**
             * Unbind the events created by _temporaryBindEvent
             *
             * @private
             */

        }, {
            key: "_unbindTemporaryEvents",
            value: function _unbindTemporaryEvents() {
                for (var i = 0; i < this.temporaryEventFunctions.length; i++) {
                    var eventName = this.temporaryEventFunctions[i].event;
                    var boundFunction = this.temporaryEventFunctions[i].boundFunction;
                    this.body.emitter.off(eventName, boundFunction);
                }

                this.temporaryEventFunctions = [];
            }
            /**
             * Bind an hammer instance to a DOM element.
             *
             * @param {Element} domElement
             * @param {Function} boundFunction
             */

        }, {
            key: "_bindElementEvents",
            value: function _bindElementEvents(domElement, boundFunction) {
                // Bind touch events.
                var hammer = new Hammer$1(domElement, {});
                onTouch(hammer, boundFunction);

                this._domEventListenerCleanupQueue.push(function () {
                    hammer.destroy();
                }); // Bind keyboard events.


                var keyupListener = function keyupListener(_ref) {
                    var keyCode = _ref.keyCode,
                        key = _ref.key;

                    if (key === "Enter" || key === " " || keyCode === 13 || keyCode === 32) {
                        boundFunction();
                    }
                };

                domElement.addEventListener("keyup", keyupListener, false);

                this._domEventListenerCleanupQueue.push(function () {
                    domElement.removeEventListener("keyup", keyupListener, false);
                });
            }
            /**
             * Neatly clean up temporary edges and nodes
             *
             * @private
             */

        }, {
            key: "_cleanupTemporaryNodesAndEdges",
            value: function _cleanupTemporaryNodesAndEdges() {
                // _clean temporary edges
                for (var i = 0; i < this.temporaryIds.edges.length; i++) {
                    var _context26;

                    this.body.edges[this.temporaryIds.edges[i]].disconnect();
                    delete this.body.edges[this.temporaryIds.edges[i]];

                    var indexTempEdge = indexOf(_context26 = this.body.edgeIndices).call(_context26, this.temporaryIds.edges[i]);

                    if (indexTempEdge !== -1) {
                        var _context27;

                        splice(_context27 = this.body.edgeIndices).call(_context27, indexTempEdge, 1);
                    }
                } // _clean temporary nodes


                for (var _i = 0; _i < this.temporaryIds.nodes.length; _i++) {
                    var _context28;

                    delete this.body.nodes[this.temporaryIds.nodes[_i]];

                    var indexTempNode = indexOf(_context28 = this.body.nodeIndices).call(_context28, this.temporaryIds.nodes[_i]);

                    if (indexTempNode !== -1) {
                        var _context29;

                        splice(_context29 = this.body.nodeIndices).call(_context29, indexTempNode, 1);
                    }
                }

                this.temporaryIds = {
                    nodes: [],
                    edges: []
                };
            } // ------------------------------------------ EDIT EDGE FUNCTIONS -----------------------------------------//

            /**
             * the touch is used to get the position of the initial click
             *
             * @param {Event}  event   The event
             * @private
             */

        }, {
            key: "_controlNodeTouch",
            value: function _controlNodeTouch(event) {
                this.selectionHandler.unselectAll();
                this.lastTouch = this.body.functions.getPointer(event.center);
                this.lastTouch.translation = assign$2({}, this.body.view.translation); // copy the object
            }
            /**
             * the drag start is used to mark one of the control nodes as selected.
             *
             * @private
             */

        }, {
            key: "_controlNodeDragStart",
            value: function _controlNodeDragStart() {
                var pointer = this.lastTouch;

                var pointerObj = this.selectionHandler._pointerToPositionObject(pointer);

                var from = this.body.nodes[this.temporaryIds.nodes[0]];
                var to = this.body.nodes[this.temporaryIds.nodes[1]];
                var edge = this.body.edges[this.edgeBeingEditedId];
                this.selectedControlNode = undefined;
                var fromSelect = from.isOverlappingWith(pointerObj);
                var toSelect = to.isOverlappingWith(pointerObj);

                if (fromSelect === true) {
                    this.selectedControlNode = from;
                    edge.edgeType.from = from;
                } else if (toSelect === true) {
                    this.selectedControlNode = to;
                    edge.edgeType.to = to;
                } // we use the selection to find the node that is being dragged. We explicitly select it here.


                if (this.selectedControlNode !== undefined) {
                    this.selectionHandler.selectObject(this.selectedControlNode);
                }

                this.body.emitter.emit("_redraw");
            }
            /**
             * dragging the control nodes or the canvas
             *
             * @param {Event}  event   The event
             * @private
             */

        }, {
            key: "_controlNodeDrag",
            value: function _controlNodeDrag(event) {
                this.body.emitter.emit("disablePhysics");
                var pointer = this.body.functions.getPointer(event.center);
                var pos = this.canvas.DOMtoCanvas(pointer);

                if (this.selectedControlNode !== undefined) {
                    this.selectedControlNode.x = pos.x;
                    this.selectedControlNode.y = pos.y;
                } else {
                    this.interactionHandler.onDrag(event);
                }

                this.body.emitter.emit("_redraw");
            }
            /**
             * connecting or restoring the control nodes.
             *
             * @param {Event}  event   The event
             * @private
             */

        }, {
            key: "_controlNodeDragEnd",
            value: function _controlNodeDragEnd(event) {
                var pointer = this.body.functions.getPointer(event.center);

                var pointerObj = this.selectionHandler._pointerToPositionObject(pointer);

                var edge = this.body.edges[this.edgeBeingEditedId]; // if the node that was dragged is not a control node, return

                if (this.selectedControlNode === undefined) {
                    return;
                } // we use the selection to find the node that is being dragged. We explicitly DEselect the control node here.


                this.selectionHandler.unselectAll();

                var overlappingNodeIds = this.selectionHandler._getAllNodesOverlappingWith(pointerObj);

                var node = undefined;

                for (var i = overlappingNodeIds.length - 1; i >= 0; i--) {
                    if (overlappingNodeIds[i] !== this.selectedControlNode.id) {
                        node = this.body.nodes[overlappingNodeIds[i]];
                        break;
                    }
                } // perform the connection


                if (node !== undefined && this.selectedControlNode !== undefined) {
                    if (node.isCluster === true) {
                        alert(this.options.locales[this.options.locale]["createEdgeError"] || this.options.locales["en"]["createEdgeError"]);
                    } else {
                        var from = this.body.nodes[this.temporaryIds.nodes[0]];

                        if (this.selectedControlNode.id === from.id) {
                            this._performEditEdge(node.id, edge.to.id);
                        } else {
                            this._performEditEdge(edge.from.id, node.id);
                        }
                    }
                } else {
                    edge.updateEdgeType();
                    this.body.emitter.emit("restorePhysics");
                }

                this.body.emitter.emit("_redraw");
            } // ------------------------------------ END OF EDIT EDGE FUNCTIONS -----------------------------------------//
            // ------------------------------------------- ADD EDGE FUNCTIONS -----------------------------------------//

            /**
             * the function bound to the selection event. It checks if you want to connect a cluster and changes the description
             * to walk the user through the process.
             *
             * @param {Event} event
             * @private
             */

        }, {
            key: "_handleConnect",
            value: function _handleConnect(event) {
                // check to avoid double fireing of this function.
                if (new Date().valueOf() - this.touchTime > 100) {
                    this.lastTouch = this.body.functions.getPointer(event.center);
                    this.lastTouch.translation = assign$2({}, this.body.view.translation); // copy the object

                    this.interactionHandler.drag.pointer = this.lastTouch; // Drag pointer is not updated when adding edges

                    this.interactionHandler.drag.translation = this.lastTouch.translation;
                    var pointer = this.lastTouch;
                    var node = this.selectionHandler.getNodeAt(pointer);

                    if (node !== undefined) {
                        if (node.isCluster === true) {
                            alert(this.options.locales[this.options.locale]["createEdgeError"] || this.options.locales["en"]["createEdgeError"]);
                        } else {
                            // create a node the temporary line can look at
                            var targetNode = this._getNewTargetNode(node.x, node.y);

                            this.body.nodes[targetNode.id] = targetNode;
                            this.body.nodeIndices.push(targetNode.id); // create a temporary edge

                            var connectionEdge = this.body.functions.createEdge({
                                id: "connectionEdge" + v4(),
                                from: node.id,
                                to: targetNode.id,
                                physics: false,
                                smooth: {
                                    enabled: true,
                                    type: "continuous",
                                    roundness: 0.5
                                }
                            });
                            this.body.edges[connectionEdge.id] = connectionEdge;
                            this.body.edgeIndices.push(connectionEdge.id);
                            this.temporaryIds.nodes.push(targetNode.id);
                            this.temporaryIds.edges.push(connectionEdge.id);
                        }
                    }

                    this.touchTime = new Date().valueOf();
                }
            }
            /**
             *
             * @param {Event} event
             * @private
             */

        }, {
            key: "_dragControlNode",
            value: function _dragControlNode(event) {
                var pointer = this.body.functions.getPointer(event.center);

                var pointerObj = this.selectionHandler._pointerToPositionObject(pointer); // remember the edge id


                var connectFromId = undefined;

                if (this.temporaryIds.edges[0] !== undefined) {
                    connectFromId = this.body.edges[this.temporaryIds.edges[0]].fromId;
                } // get the overlapping node but NOT the temporary node;


                var overlappingNodeIds = this.selectionHandler._getAllNodesOverlappingWith(pointerObj);

                var node = undefined;

                for (var i = overlappingNodeIds.length - 1; i >= 0; i--) {
                    var _context30;

                    // if the node id is NOT a temporary node, accept the node.
                    if (indexOf(_context30 = this.temporaryIds.nodes).call(_context30, overlappingNodeIds[i]) === -1) {
                        node = this.body.nodes[overlappingNodeIds[i]];
                        break;
                    }
                }

                event.controlEdge = {
                    from: connectFromId,
                    to: node ? node.id : undefined
                };
                this.selectionHandler.generateClickEvent("controlNodeDragging", event, pointer);

                if (this.temporaryIds.nodes[0] !== undefined) {
                    var targetNode = this.body.nodes[this.temporaryIds.nodes[0]]; // there is only one temp node in the add edge mode.

                    targetNode.x = this.canvas._XconvertDOMtoCanvas(pointer.x);
                    targetNode.y = this.canvas._YconvertDOMtoCanvas(pointer.y);
                    this.body.emitter.emit("_redraw");
                } else {
                    this.interactionHandler.onDrag(event);
                }
            }
            /**
             * Connect the new edge to the target if one exists, otherwise remove temp line
             *
             * @param {Event}  event   The event
             * @private
             */

        }, {
            key: "_finishConnect",
            value: function _finishConnect(event) {
                var pointer = this.body.functions.getPointer(event.center);

                var pointerObj = this.selectionHandler._pointerToPositionObject(pointer); // remember the edge id


                var connectFromId = undefined;

                if (this.temporaryIds.edges[0] !== undefined) {
                    connectFromId = this.body.edges[this.temporaryIds.edges[0]].fromId;
                } // get the overlapping node but NOT the temporary node;


                var overlappingNodeIds = this.selectionHandler._getAllNodesOverlappingWith(pointerObj);

                var node = undefined;

                for (var i = overlappingNodeIds.length - 1; i >= 0; i--) {
                    var _context31;

                    // if the node id is NOT a temporary node, accept the node.
                    if (indexOf(_context31 = this.temporaryIds.nodes).call(_context31, overlappingNodeIds[i]) === -1) {
                        node = this.body.nodes[overlappingNodeIds[i]];
                        break;
                    }
                } // clean temporary nodes and edges.


                this._cleanupTemporaryNodesAndEdges(); // perform the connection


                if (node !== undefined) {
                    if (node.isCluster === true) {
                        alert(this.options.locales[this.options.locale]["createEdgeError"] || this.options.locales["en"]["createEdgeError"]);
                    } else {
                        if (this.body.nodes[connectFromId] !== undefined && this.body.nodes[node.id] !== undefined) {
                            this._performAddEdge(connectFromId, node.id);
                        }
                    }
                }

                event.controlEdge = {
                    from: connectFromId,
                    to: node ? node.id : undefined
                };
                this.selectionHandler.generateClickEvent("controlNodeDragEnd", event, pointer); // No need to do _generateclickevent('dragEnd') here, the regular dragEnd event fires.

                this.body.emitter.emit("_redraw");
            }
            /**
             *
             * @param {Event} event
             * @private
             */

        }, {
            key: "_dragStartEdge",
            value: function _dragStartEdge(event) {
                var pointer = this.lastTouch;
                this.selectionHandler.generateClickEvent("dragStart", event, pointer, undefined, true);
            } // --------------------------------------- END OF ADD EDGE FUNCTIONS -------------------------------------//
            // ------------------------------ Performing all the actual data manipulation ------------------------//

            /**
             * Adds a node on the specified location
             *
             * @param {object} clickData
             * @private
             */

        }, {
            key: "_performAddNode",
            value: function _performAddNode(clickData) {
                var _this4 = this;

                var defaultData = {
                    id: v4(),
                    x: clickData.pointer.canvas.x,
                    y: clickData.pointer.canvas.y,
                    label: "new"
                };

                if (typeof this.options.addNode === "function") {
                    if (this.options.addNode.length === 2) {
                        this.options.addNode(defaultData, function (finalizedData) {
                            if (finalizedData !== null && finalizedData !== undefined && _this4.inMode === "addNode") {
                                // if for whatever reason the mode has changes (due to dataset change) disregard the callback
                                _this4.body.data.nodes.getDataSet().add(finalizedData);
                            }

                            _this4.showManipulatorToolbar();
                        });
                    } else {
                        this.showManipulatorToolbar();
                        throw new Error("The function for add does not support two arguments (data,callback)");
                    }
                } else {
                    this.body.data.nodes.getDataSet().add(defaultData);
                    this.showManipulatorToolbar();
                }
            }
            /**
             * connect two nodes with a new edge.
             *
             * @param {Node.id} sourceNodeId
             * @param {Node.id} targetNodeId
             * @private
             */

        }, {
            key: "_performAddEdge",
            value: function _performAddEdge(sourceNodeId, targetNodeId) {
                var _this5 = this;

                var defaultData = {
                    from: sourceNodeId,
                    to: targetNodeId
                };

                if (typeof this.options.addEdge === "function") {
                    if (this.options.addEdge.length === 2) {
                        this.options.addEdge(defaultData, function (finalizedData) {
                            if (finalizedData !== null && finalizedData !== undefined && _this5.inMode === "addEdge") {
                                // if for whatever reason the mode has changes (due to dataset change) disregard the callback
                                _this5.body.data.edges.getDataSet().add(finalizedData);

                                _this5.selectionHandler.unselectAll();

                                _this5.showManipulatorToolbar();
                            }
                        });
                    } else {
                        throw new Error("The function for connect does not support two arguments (data,callback)");
                    }
                } else {
                    this.body.data.edges.getDataSet().add(defaultData);
                    this.selectionHandler.unselectAll();
                    this.showManipulatorToolbar();
                }
            }
            /**
             * connect two nodes with a new edge.
             *
             * @param {Node.id} sourceNodeId
             * @param {Node.id} targetNodeId
             * @private
             */

        }, {
            key: "_performEditEdge",
            value: function _performEditEdge(sourceNodeId, targetNodeId) {
                var _this6 = this;

                var defaultData = {
                    id: this.edgeBeingEditedId,
                    from: sourceNodeId,
                    to: targetNodeId,
                    label: this.body.data.edges.get(this.edgeBeingEditedId).label
                };
                var eeFunct = this.options.editEdge;

                if (_typeof(eeFunct) === "object") {
                    eeFunct = eeFunct.editWithoutDrag;
                }

                if (typeof eeFunct === "function") {
                    if (eeFunct.length === 2) {
                        eeFunct(defaultData, function (finalizedData) {
                            if (finalizedData === null || finalizedData === undefined || _this6.inMode !== "editEdge") {
                                // if for whatever reason the mode has changes (due to dataset change) disregard the callback) {
                                _this6.body.edges[defaultData.id].updateEdgeType();

                                _this6.body.emitter.emit("_redraw");

                                _this6.showManipulatorToolbar();
                            } else {
                                _this6.body.data.edges.getDataSet().update(finalizedData);

                                _this6.selectionHandler.unselectAll();

                                _this6.showManipulatorToolbar();
                            }
                        });
                    } else {
                        throw new Error("The function for edit does not support two arguments (data, callback)");
                    }
                } else {
                    this.body.data.edges.getDataSet().update(defaultData);
                    this.selectionHandler.unselectAll();
                    this.showManipulatorToolbar();
                }
            }
        }]);

        return ManipulationSystem;
    }();

    /**
     * This object contains all possible options. It will check if the types are correct, if required if the option is one
     * of the allowed values.
     *
     * __any__ means that the name of the property does not matter.
     * __type__ is a required field for all objects and contains the allowed types of all objects
     */
    var string = "string";
    var bool = "boolean";
    var number = "number";
    var array = "array";
    var object = "object"; // should only be in a __type__ property

    var dom = "dom";
    var any = "any"; // List of endpoints

    var endPoints = ["arrow", "bar", "box", "circle", "crow", "curve", "diamond", "image", "inv_curve", "inv_triangle", "triangle", "vee"];
    /* eslint-disable @typescript-eslint/naming-convention -- The __*__ format is used to prevent collisions with actual option names. */

    var nodeOptions = {
        borderWidth: {
            number: number
        },
        borderWidthSelected: {
            number: number,
            undefined: "undefined"
        },
        brokenImage: {
            string: string,
            undefined: "undefined"
        },
        chosen: {
            label: {
                boolean: bool,
                function: "function"
            },
            node: {
                boolean: bool,
                function: "function"
            },
            __type__: {
                object: object,
                boolean: bool
            }
        },
        color: {
            border: {
                string: string
            },
            background: {
                string: string
            },
            highlight: {
                border: {
                    string: string
                },
                background: {
                    string: string
                },
                __type__: {
                    object: object,
                    string: string
                }
            },
            hover: {
                border: {
                    string: string
                },
                background: {
                    string: string
                },
                __type__: {
                    object: object,
                    string: string
                }
            },
            __type__: {
                object: object,
                string: string
            }
        },
        opacity: {
            number: number,
            undefined: "undefined"
        },
        fixed: {
            x: {
                boolean: bool
            },
            y: {
                boolean: bool
            },
            __type__: {
                object: object,
                boolean: bool
            }
        },
        font: {
            align: {
                string: string
            },
            color: {
                string: string
            },
            size: {
                number: number
            },
            face: {
                string: string
            },
            background: {
                string: string
            },
            strokeWidth: {
                number: number
            },
            strokeColor: {
                string: string
            },
            vadjust: {
                number: number
            },
            multi: {
                boolean: bool,
                string: string
            },
            bold: {
                color: {
                    string: string
                },
                size: {
                    number: number
                },
                face: {
                    string: string
                },
                mod: {
                    string: string
                },
                vadjust: {
                    number: number
                },
                __type__: {
                    object: object,
                    string: string
                }
            },
            boldital: {
                color: {
                    string: string
                },
                size: {
                    number: number
                },
                face: {
                    string: string
                },
                mod: {
                    string: string
                },
                vadjust: {
                    number: number
                },
                __type__: {
                    object: object,
                    string: string
                }
            },
            ital: {
                color: {
                    string: string
                },
                size: {
                    number: number
                },
                face: {
                    string: string
                },
                mod: {
                    string: string
                },
                vadjust: {
                    number: number
                },
                __type__: {
                    object: object,
                    string: string
                }
            },
            mono: {
                color: {
                    string: string
                },
                size: {
                    number: number
                },
                face: {
                    string: string
                },
                mod: {
                    string: string
                },
                vadjust: {
                    number: number
                },
                __type__: {
                    object: object,
                    string: string
                }
            },
            __type__: {
                object: object,
                string: string
            }
        },
        group: {
            string: string,
            number: number,
            undefined: "undefined"
        },
        heightConstraint: {
            minimum: {
                number: number
            },
            valign: {
                string: string
            },
            __type__: {
                object: object,
                boolean: bool,
                number: number
            }
        },
        hidden: {
            boolean: bool
        },
        icon: {
            face: {
                string: string
            },
            code: {
                string: string
            },
            size: {
                number: number
            },
            color: {
                string: string
            },
            weight: {
                string: string,
                number: number
            },
            __type__: {
                object: object
            }
        },
        id: {
            string: string,
            number: number
        },
        image: {
            selected: {
                string: string,
                undefined: "undefined"
            },
            unselected: {
                string: string,
                undefined: "undefined"
            },
            __type__: {
                object: object,
                string: string
            }
        },
        imagePadding: {
            top: {
                number: number
            },
            right: {
                number: number
            },
            bottom: {
                number: number
            },
            left: {
                number: number
            },
            __type__: {
                object: object,
                number: number
            }
        },
        label: {
            string: string,
            undefined: "undefined"
        },
        labelHighlightBold: {
            boolean: bool
        },
        level: {
            number: number,
            undefined: "undefined"
        },
        margin: {
            top: {
                number: number
            },
            right: {
                number: number
            },
            bottom: {
                number: number
            },
            left: {
                number: number
            },
            __type__: {
                object: object,
                number: number
            }
        },
        mass: {
            number: number
        },
        physics: {
            boolean: bool
        },
        scaling: {
            min: {
                number: number
            },
            max: {
                number: number
            },
            label: {
                enabled: {
                    boolean: bool
                },
                min: {
                    number: number
                },
                max: {
                    number: number
                },
                maxVisible: {
                    number: number
                },
                drawThreshold: {
                    number: number
                },
                __type__: {
                    object: object,
                    boolean: bool
                }
            },
            customScalingFunction: {
                function: "function"
            },
            __type__: {
                object: object
            }
        },
        shadow: {
            enabled: {
                boolean: bool
            },
            color: {
                string: string
            },
            size: {
                number: number
            },
            x: {
                number: number
            },
            y: {
                number: number
            },
            __type__: {
                object: object,
                boolean: bool
            }
        },
        shape: {
            string: ["custom", "ellipse", "circle", "database", "box", "text", "image", "circularImage", "diamond", "dot", "star", "triangle", "triangleDown", "square", "icon", "hexagon"]
        },
        ctxRenderer: {
            function: "function"
        },
        shapeProperties: {
            borderDashes: {
                boolean: bool,
                array: array
            },
            borderRadius: {
                number: number
            },
            interpolation: {
                boolean: bool
            },
            useImageSize: {
                boolean: bool
            },
            useBorderWithImage: {
                boolean: bool
            },
            coordinateOrigin: {
                string: ["center", "top-left"]
            },
            __type__: {
                object: object
            }
        },
        size: {
            number: number
        },
        title: {
            string: string,
            dom: dom,
            undefined: "undefined"
        },
        value: {
            number: number,
            undefined: "undefined"
        },
        widthConstraint: {
            minimum: {
                number: number
            },
            maximum: {
                number: number
            },
            __type__: {
                object: object,
                boolean: bool,
                number: number
            }
        },
        x: {
            number: number
        },
        y: {
            number: number
        },
        __type__: {
            object: object
        }
    };
    var allOptions = {
        configure: {
            enabled: {
                boolean: bool
            },
            filter: {
                boolean: bool,
                string: string,
                array: array,
                function: "function"
            },
            container: {
                dom: dom
            },
            showButton: {
                boolean: bool
            },
            __type__: {
                object: object,
                boolean: bool,
                string: string,
                array: array,
                function: "function"
            }
        },
        edges: {
            arrows: {
                to: {
                    enabled: {
                        boolean: bool
                    },
                    scaleFactor: {
                        number: number
                    },
                    type: {
                        string: endPoints
                    },
                    imageHeight: {
                        number: number
                    },
                    imageWidth: {
                        number: number
                    },
                    src: {
                        string: string
                    },
                    __type__: {
                        object: object,
                        boolean: bool
                    }
                },
                middle: {
                    enabled: {
                        boolean: bool
                    },
                    scaleFactor: {
                        number: number
                    },
                    type: {
                        string: endPoints
                    },
                    imageWidth: {
                        number: number
                    },
                    imageHeight: {
                        number: number
                    },
                    src: {
                        string: string
                    },
                    __type__: {
                        object: object,
                        boolean: bool
                    }
                },
                from: {
                    enabled: {
                        boolean: bool
                    },
                    scaleFactor: {
                        number: number
                    },
                    type: {
                        string: endPoints
                    },
                    imageWidth: {
                        number: number
                    },
                    imageHeight: {
                        number: number
                    },
                    src: {
                        string: string
                    },
                    __type__: {
                        object: object,
                        boolean: bool
                    }
                },
                __type__: {
                    string: ["from", "to", "middle"],
                    object: object
                }
            },
            endPointOffset: {
                from: {
                    number: number
                },
                to: {
                    number: number
                },
                __type__: {
                    object: object,
                    number: number
                }
            },
            arrowStrikethrough: {
                boolean: bool
            },
            background: {
                enabled: {
                    boolean: bool
                },
                color: {
                    string: string
                },
                size: {
                    number: number
                },
                dashes: {
                    boolean: bool,
                    array: array
                },
                __type__: {
                    object: object,
                    boolean: bool
                }
            },
            chosen: {
                label: {
                    boolean: bool,
                    function: "function"
                },
                edge: {
                    boolean: bool,
                    function: "function"
                },
                __type__: {
                    object: object,
                    boolean: bool
                }
            },
            color: {
                color: {
                    string: string
                },
                highlight: {
                    string: string
                },
                hover: {
                    string: string
                },
                inherit: {
                    string: ["from", "to", "both"],
                    boolean: bool
                },
                opacity: {
                    number: number
                },
                __type__: {
                    object: object,
                    string: string
                }
            },
            dashes: {
                boolean: bool,
                array: array
            },
            font: {
                color: {
                    string: string
                },
                size: {
                    number: number
                },
                face: {
                    string: string
                },
                background: {
                    string: string
                },
                strokeWidth: {
                    number: number
                },
                strokeColor: {
                    string: string
                },
                align: {
                    string: ["horizontal", "top", "middle", "bottom"]
                },
                vadjust: {
                    number: number
                },
                multi: {
                    boolean: bool,
                    string: string
                },
                bold: {
                    color: {
                        string: string
                    },
                    size: {
                        number: number
                    },
                    face: {
                        string: string
                    },
                    mod: {
                        string: string
                    },
                    vadjust: {
                        number: number
                    },
                    __type__: {
                        object: object,
                        string: string
                    }
                },
                boldital: {
                    color: {
                        string: string
                    },
                    size: {
                        number: number
                    },
                    face: {
                        string: string
                    },
                    mod: {
                        string: string
                    },
                    vadjust: {
                        number: number
                    },
                    __type__: {
                        object: object,
                        string: string
                    }
                },
                ital: {
                    color: {
                        string: string
                    },
                    size: {
                        number: number
                    },
                    face: {
                        string: string
                    },
                    mod: {
                        string: string
                    },
                    vadjust: {
                        number: number
                    },
                    __type__: {
                        object: object,
                        string: string
                    }
                },
                mono: {
                    color: {
                        string: string
                    },
                    size: {
                        number: number
                    },
                    face: {
                        string: string
                    },
                    mod: {
                        string: string
                    },
                    vadjust: {
                        number: number
                    },
                    __type__: {
                        object: object,
                        string: string
                    }
                },
                __type__: {
                    object: object,
                    string: string
                }
            },
            hidden: {
                boolean: bool
            },
            hoverWidth: {
                function: "function",
                number: number
            },
            label: {
                string: string,
                undefined: "undefined"
            },
            labelHighlightBold: {
                boolean: bool
            },
            length: {
                number: number,
                undefined: "undefined"
            },
            physics: {
                boolean: bool
            },
            scaling: {
                min: {
                    number: number
                },
                max: {
                    number: number
                },
                label: {
                    enabled: {
                        boolean: bool
                    },
                    min: {
                        number: number
                    },
                    max: {
                        number: number
                    },
                    maxVisible: {
                        number: number
                    },
                    drawThreshold: {
                        number: number
                    },
                    __type__: {
                        object: object,
                        boolean: bool
                    }
                },
                customScalingFunction: {
                    function: "function"
                },
                __type__: {
                    object: object
                }
            },
            selectionWidth: {
                function: "function",
                number: number
            },
            selfReferenceSize: {
                number: number
            },
            selfReference: {
                size: {
                    number: number
                },
                angle: {
                    number: number
                },
                renderBehindTheNode: {
                    boolean: bool
                },
                __type__: {
                    object: object
                }
            },
            shadow: {
                enabled: {
                    boolean: bool
                },
                color: {
                    string: string
                },
                size: {
                    number: number
                },
                x: {
                    number: number
                },
                y: {
                    number: number
                },
                __type__: {
                    object: object,
                    boolean: bool
                }
            },
            smooth: {
                enabled: {
                    boolean: bool
                },
                type: {
                    string: ["dynamic", "continuous", "discrete", "diagonalCross", "straightCross", "horizontal", "vertical", "curvedCW", "curvedCCW", "cubicBezier"]
                },
                roundness: {
                    number: number
                },
                forceDirection: {
                    string: ["horizontal", "vertical", "none"],
                    boolean: bool
                },
                __type__: {
                    object: object,
                    boolean: bool
                }
            },
            title: {
                string: string,
                undefined: "undefined"
            },
            width: {
                number: number
            },
            widthConstraint: {
                maximum: {
                    number: number
                },
                __type__: {
                    object: object,
                    boolean: bool,
                    number: number
                }
            },
            value: {
                number: number,
                undefined: "undefined"
            },
            __type__: {
                object: object
            }
        },
        groups: {
            useDefaultGroups: {
                boolean: bool
            },
            __any__: nodeOptions,
            __type__: {
                object: object
            }
        },
        interaction: {
            dragNodes: {
                boolean: bool
            },
            dragView: {
                boolean: bool
            },
            hideEdgesOnDrag: {
                boolean: bool
            },
            hideEdgesOnZoom: {
                boolean: bool
            },
            hideNodesOnDrag: {
                boolean: bool
            },
            hover: {
                boolean: bool
            },
            keyboard: {
                enabled: {
                    boolean: bool
                },
                speed: {
                    x: {
                        number: number
                    },
                    y: {
                        number: number
                    },
                    zoom: {
                        number: number
                    },
                    __type__: {
                        object: object
                    }
                },
                bindToWindow: {
                    boolean: bool
                },
                __type__: {
                    object: object,
                    boolean: bool
                }
            },
            multiselect: {
                boolean: bool
            },
            navigationButtons: {
                boolean: bool
            },
            selectable: {
                boolean: bool
            },
            selectConnectedEdges: {
                boolean: bool
            },
            hoverConnectedEdges: {
                boolean: bool
            },
            tooltipDelay: {
                number: number
            },
            zoomView: {
                boolean: bool
            },
            zoomSpeed: {
                number: number
            },
            __type__: {
                object: object
            }
        },
        layout: {
            randomSeed: {
                undefined: "undefined",
                number: number,
                string: string
            },
            improvedLayout: {
                boolean: bool
            },
            clusterThreshold: {
                number: number
            },
            hierarchical: {
                enabled: {
                    boolean: bool
                },
                levelSeparation: {
                    number: number
                },
                nodeSpacing: {
                    number: number
                },
                treeSpacing: {
                    number: number
                },
                blockShifting: {
                    boolean: bool
                },
                edgeMinimization: {
                    boolean: bool
                },
                parentCentralization: {
                    boolean: bool
                },
                direction: {
                    string: ["UD", "DU", "LR", "RL"]
                },
                sortMethod: {
                    string: ["hubsize", "directed"]
                },
                shakeTowards: {
                    string: ["leaves", "roots"]
                },
                __type__: {
                    object: object,
                    boolean: bool
                }
            },
            __type__: {
                object: object
            }
        },
        manipulation: {
            enabled: {
                boolean: bool
            },
            initiallyActive: {
                boolean: bool
            },
            addNode: {
                boolean: bool,
                function: "function"
            },
            addEdge: {
                boolean: bool,
                function: "function"
            },
            editNode: {
                function: "function"
            },
            editEdge: {
                editWithoutDrag: {
                    function: "function"
                },
                __type__: {
                    object: object,
                    boolean: bool,
                    function: "function"
                }
            },
            deleteNode: {
                boolean: bool,
                function: "function"
            },
            deleteEdge: {
                boolean: bool,
                function: "function"
            },
            controlNodeStyle: nodeOptions,
            __type__: {
                object: object,
                boolean: bool
            }
        },
        nodes: nodeOptions,
        physics: {
            enabled: {
                boolean: bool
            },
            barnesHut: {
                theta: {
                    number: number
                },
                gravitationalConstant: {
                    number: number
                },
                centralGravity: {
                    number: number
                },
                springLength: {
                    number: number
                },
                springConstant: {
                    number: number
                },
                damping: {
                    number: number
                },
                avoidOverlap: {
                    number: number
                },
                __type__: {
                    object: object
                }
            },
            forceAtlas2Based: {
                theta: {
                    number: number
                },
                gravitationalConstant: {
                    number: number
                },
                centralGravity: {
                    number: number
                },
                springLength: {
                    number: number
                },
                springConstant: {
                    number: number
                },
                damping: {
                    number: number
                },
                avoidOverlap: {
                    number: number
                },
                __type__: {
                    object: object
                }
            },
            repulsion: {
                centralGravity: {
                    number: number
                },
                springLength: {
                    number: number
                },
                springConstant: {
                    number: number
                },
                nodeDistance: {
                    number: number
                },
                damping: {
                    number: number
                },
                __type__: {
                    object: object
                }
            },
            hierarchicalRepulsion: {
                centralGravity: {
                    number: number
                },
                springLength: {
                    number: number
                },
                springConstant: {
                    number: number
                },
                nodeDistance: {
                    number: number
                },
                damping: {
                    number: number
                },
                avoidOverlap: {
                    number: number
                },
                __type__: {
                    object: object
                }
            },
            maxVelocity: {
                number: number
            },
            minVelocity: {
                number: number
            },
            solver: {
                string: ["barnesHut", "repulsion", "hierarchicalRepulsion", "forceAtlas2Based"]
            },
            stabilization: {
                enabled: {
                    boolean: bool
                },
                iterations: {
                    number: number
                },
                updateInterval: {
                    number: number
                },
                onlyDynamicEdges: {
                    boolean: bool
                },
                fit: {
                    boolean: bool
                },
                __type__: {
                    object: object,
                    boolean: bool
                }
            },
            timestep: {
                number: number
            },
            adaptiveTimestep: {
                boolean: bool
            },
            wind: {
                x: {
                    number: number
                },
                y: {
                    number: number
                },
                __type__: {
                    object: object
                }
            },
            __type__: {
                object: object,
                boolean: bool
            }
        },
        //globals :
        autoResize: {
            boolean: bool
        },
        clickToUse: {
            boolean: bool
        },
        locale: {
            string: string
        },
        locales: {
            __any__: {
                any: any
            },
            __type__: {
                object: object
            }
        },
        height: {
            string: string
        },
        width: {
            string: string
        },
        __type__: {
            object: object
        }
    };
    /* eslint-enable @typescript-eslint/naming-convention */

    /**
     * This provides ranges, initial values, steps and dropdown menu choices for the
     * configuration.
     *
     * @remarks
     * Checkbox: `boolean`
     *   The value supllied will be used as the initial value.
     *
     * Text field: `string`
     *   The passed text will be used as the initial value. Any text will be
     *   accepted afterwards.
     *
     * Number range: `[number, number, number, number]`
     *   The meanings are `[initial value, min, max, step]`.
     *
     * Dropdown: `[Exclude<string, "color">, ...(string | number | boolean)[]]`
     *   Translations for people with poor understanding of TypeScript: the first
     *   value always has to be a string but never `"color"`, the rest can be any
     *   combination of strings, numbers and booleans.
     *
     * Color picker: `["color", string]`
     *   The first value says this will be a color picker not a dropdown menu. The
     *   next value is the initial color.
     */

    var configureOptions = {
        nodes: {
            borderWidth: [1, 0, 10, 1],
            borderWidthSelected: [2, 0, 10, 1],
            color: {
                border: ["color", "#2B7CE9"],
                background: ["color", "#97C2FC"],
                highlight: {
                    border: ["color", "#2B7CE9"],
                    background: ["color", "#D2E5FF"]
                },
                hover: {
                    border: ["color", "#2B7CE9"],
                    background: ["color", "#D2E5FF"]
                }
            },
            opacity: [0, 0, 1, 0.1],
            fixed: {
                x: false,
                y: false
            },
            font: {
                color: ["color", "#343434"],
                size: [14, 0, 100, 1],
                face: ["arial", "verdana", "tahoma"],
                background: ["color", "none"],
                strokeWidth: [0, 0, 50, 1],
                strokeColor: ["color", "#ffffff"]
            },
            //group: 'string',
            hidden: false,
            labelHighlightBold: true,
            //icon: {
            //  face: 'string',  //'FontAwesome',
            //  code: 'string',  //'\uf007',
            //  size: [50, 0, 200, 1],  //50,
            //  color: ['color','#2B7CE9']   //'#aa00ff'
            //},
            //image: 'string', // --> URL
            physics: true,
            scaling: {
                min: [10, 0, 200, 1],
                max: [30, 0, 200, 1],
                label: {
                    enabled: false,
                    min: [14, 0, 200, 1],
                    max: [30, 0, 200, 1],
                    maxVisible: [30, 0, 200, 1],
                    drawThreshold: [5, 0, 20, 1]
                }
            },
            shadow: {
                enabled: false,
                color: "rgba(0,0,0,0.5)",
                size: [10, 0, 20, 1],
                x: [5, -30, 30, 1],
                y: [5, -30, 30, 1]
            },
            shape: ["ellipse", "box", "circle", "database", "diamond", "dot", "square", "star", "text", "triangle", "triangleDown", "hexagon"],
            shapeProperties: {
                borderDashes: false,
                borderRadius: [6, 0, 20, 1],
                interpolation: true,
                useImageSize: false
            },
            size: [25, 0, 200, 1]
        },
        edges: {
            arrows: {
                to: {
                    enabled: false,
                    scaleFactor: [1, 0, 3, 0.05],
                    type: "arrow"
                },
                middle: {
                    enabled: false,
                    scaleFactor: [1, 0, 3, 0.05],
                    type: "arrow"
                },
                from: {
                    enabled: false,
                    scaleFactor: [1, 0, 3, 0.05],
                    type: "arrow"
                }
            },
            endPointOffset: {
                from: [0, -10, 10, 1],
                to: [0, -10, 10, 1]
            },
            arrowStrikethrough: true,
            color: {
                color: ["color", "#848484"],
                highlight: ["color", "#848484"],
                hover: ["color", "#848484"],
                inherit: ["from", "to", "both", true, false],
                opacity: [1, 0, 1, 0.05]
            },
            dashes: false,
            font: {
                color: ["color", "#343434"],
                size: [14, 0, 100, 1],
                face: ["arial", "verdana", "tahoma"],
                background: ["color", "none"],
                strokeWidth: [2, 0, 50, 1],
                strokeColor: ["color", "#ffffff"],
                align: ["horizontal", "top", "middle", "bottom"]
            },
            hidden: false,
            hoverWidth: [1.5, 0, 5, 0.1],
            labelHighlightBold: true,
            physics: true,
            scaling: {
                min: [1, 0, 100, 1],
                max: [15, 0, 100, 1],
                label: {
                    enabled: true,
                    min: [14, 0, 200, 1],
                    max: [30, 0, 200, 1],
                    maxVisible: [30, 0, 200, 1],
                    drawThreshold: [5, 0, 20, 1]
                }
            },
            selectionWidth: [1.5, 0, 5, 0.1],
            selfReferenceSize: [20, 0, 200, 1],
            selfReference: {
                size: [20, 0, 200, 1],
                angle: [Math.PI / 2, -6 * Math.PI, 6 * Math.PI, Math.PI / 8],
                renderBehindTheNode: true
            },
            shadow: {
                enabled: false,
                color: "rgba(0,0,0,0.5)",
                size: [10, 0, 20, 1],
                x: [5, -30, 30, 1],
                y: [5, -30, 30, 1]
            },
            smooth: {
                enabled: true,
                type: ["dynamic", "continuous", "discrete", "diagonalCross", "straightCross", "horizontal", "vertical", "curvedCW", "curvedCCW", "cubicBezier"],
                forceDirection: ["horizontal", "vertical", "none"],
                roundness: [0.5, 0, 1, 0.05]
            },
            width: [1, 0, 30, 1]
        },
        layout: {
            //randomSeed: [0, 0, 500, 1],
            //improvedLayout: true,
            hierarchical: {
                enabled: false,
                levelSeparation: [150, 20, 500, 5],
                nodeSpacing: [100, 20, 500, 5],
                treeSpacing: [200, 20, 500, 5],
                blockShifting: true,
                edgeMinimization: true,
                parentCentralization: true,
                direction: ["UD", "DU", "LR", "RL"],
                sortMethod: ["hubsize", "directed"],
                shakeTowards: ["leaves", "roots"] // leaves, roots

            }
        },
        interaction: {
            dragNodes: true,
            dragView: true,
            hideEdgesOnDrag: false,
            hideEdgesOnZoom: false,
            hideNodesOnDrag: false,
            hover: false,
            keyboard: {
                enabled: false,
                speed: {
                    x: [10, 0, 40, 1],
                    y: [10, 0, 40, 1],
                    zoom: [0.02, 0, 0.1, 0.005]
                },
                bindToWindow: true
            },
            multiselect: false,
            navigationButtons: false,
            selectable: true,
            selectConnectedEdges: true,
            hoverConnectedEdges: true,
            tooltipDelay: [300, 0, 1000, 25],
            zoomView: true,
            zoomSpeed: [1, 0.1, 2, 0.1]
        },
        manipulation: {
            enabled: false,
            initiallyActive: false
        },
        physics: {
            enabled: true,
            barnesHut: {
                theta: [0.5, 0.1, 1, 0.05],
                gravitationalConstant: [-2000, -30000, 0, 50],
                centralGravity: [0.3, 0, 10, 0.05],
                springLength: [95, 0, 500, 5],
                springConstant: [0.04, 0, 1.2, 0.005],
                damping: [0.09, 0, 1, 0.01],
                avoidOverlap: [0, 0, 1, 0.01]
            },
            forceAtlas2Based: {
                theta: [0.5, 0.1, 1, 0.05],
                gravitationalConstant: [-50, -500, 0, 1],
                centralGravity: [0.01, 0, 1, 0.005],
                springLength: [95, 0, 500, 5],
                springConstant: [0.08, 0, 1.2, 0.005],
                damping: [0.4, 0, 1, 0.01],
                avoidOverlap: [0, 0, 1, 0.01]
            },
            repulsion: {
                centralGravity: [0.2, 0, 10, 0.05],
                springLength: [200, 0, 500, 5],
                springConstant: [0.05, 0, 1.2, 0.005],
                nodeDistance: [100, 0, 500, 5],
                damping: [0.09, 0, 1, 0.01]
            },
            hierarchicalRepulsion: {
                centralGravity: [0.2, 0, 10, 0.05],
                springLength: [100, 0, 500, 5],
                springConstant: [0.01, 0, 1.2, 0.005],
                nodeDistance: [120, 0, 500, 5],
                damping: [0.09, 0, 1, 0.01],
                avoidOverlap: [0, 0, 1, 0.01]
            },
            maxVelocity: [50, 0, 150, 1],
            minVelocity: [0.1, 0.01, 0.5, 0.01],
            solver: ["barnesHut", "forceAtlas2Based", "repulsion", "hierarchicalRepulsion"],
            timestep: [0.5, 0.01, 1, 0.01],
            wind: {
                x: [0, -10, 10, 0.1],
                y: [0, -10, 10, 0.1]
            } //adaptiveTimestep: true

        }
    };
    var configuratorHideOption = function configuratorHideOption(parentPath, optionName, options) {
        var _context;

        if (includes(parentPath).call(parentPath, "physics") && includes(_context = configureOptions.physics.solver).call(_context, optionName) && options.physics.solver !== optionName && optionName !== "wind") {
            return true;
        }

        return false;
    };

    var options = /*#__PURE__*/Object.freeze({
        __proto__: null,
        configuratorHideOption: configuratorHideOption,
        allOptions: allOptions,
        configureOptions: configureOptions
    });

    /**
     *  The Floyd–Warshall algorithm is an algorithm for finding shortest paths in
     *  a weighted graph with positive or negative edge weights (but with no negative
     *  cycles). - https://en.wikipedia.org/wiki/Floyd–Warshall_algorithm
     */
    var FloydWarshall = /*#__PURE__*/function () {
        /**
         * @ignore
         */
        function FloydWarshall() {
            _classCallCheck(this, FloydWarshall);
        }
        /**
         *
         * @param {object} body
         * @param {Array.<Node>} nodesArray
         * @param {Array.<Edge>} edgesArray
         * @returns {{}}
         */


        _createClass(FloydWarshall, [{
            key: "getDistances",
            value: function getDistances(body, nodesArray, edgesArray) {
                var D_matrix = {};
                var edges = body.edges; // prepare matrix with large numbers

                for (var i = 0; i < nodesArray.length; i++) {
                    var node = nodesArray[i];
                    var cell = {};
                    D_matrix[node] = cell;

                    for (var j = 0; j < nodesArray.length; j++) {
                        cell[nodesArray[j]] = i == j ? 0 : 1e9;
                    }
                } // put the weights for the edges in. This assumes unidirectionality.


                for (var _i = 0; _i < edgesArray.length; _i++) {
                    var edge = edges[edgesArray[_i]]; // edge has to be connected if it counts to the distances. If it is connected to inner clusters it will crash so we also check if it is in the D_matrix

                    if (edge.connected === true && D_matrix[edge.fromId] !== undefined && D_matrix[edge.toId] !== undefined) {
                        D_matrix[edge.fromId][edge.toId] = 1;
                        D_matrix[edge.toId][edge.fromId] = 1;
                    }
                }

                var nodeCount = nodesArray.length; // Adapted FloydWarshall based on unidirectionality to greatly reduce complexity.

                for (var k = 0; k < nodeCount; k++) {
                    var knode = nodesArray[k];
                    var kcolm = D_matrix[knode];

                    for (var _i2 = 0; _i2 < nodeCount - 1; _i2++) {
                        var inode = nodesArray[_i2];
                        var icolm = D_matrix[inode];

                        for (var _j = _i2 + 1; _j < nodeCount; _j++) {
                            var jnode = nodesArray[_j];
                            var jcolm = D_matrix[jnode];
                            var val = Math.min(icolm[jnode], icolm[knode] + kcolm[jnode]);
                            icolm[jnode] = val;
                            jcolm[inode] = val;
                        }
                    }
                }

                return D_matrix;
            }
        }]);

        return FloydWarshall;
    }();

    /**
     * KamadaKawai positions the nodes initially based on
     *
     * "AN ALGORITHM FOR DRAWING GENERAL UNDIRECTED GRAPHS"
     * -- Tomihisa KAMADA and Satoru KAWAI in 1989
     *
     * Possible optimizations in the distance calculation can be implemented.
     */

    var KamadaKawai = /*#__PURE__*/function () {
        /**
         * @param {object} body
         * @param {number} edgeLength
         * @param {number} edgeStrength
         */
        function KamadaKawai(body, edgeLength, edgeStrength) {
            _classCallCheck(this, KamadaKawai);

            this.body = body;
            this.springLength = edgeLength;
            this.springConstant = edgeStrength;
            this.distanceSolver = new FloydWarshall();
        }
        /**
         * Not sure if needed but can be used to update the spring length and spring constant
         *
         * @param {object} options
         */


        _createClass(KamadaKawai, [{
            key: "setOptions",
            value: function setOptions(options) {
                if (options) {
                    if (options.springLength) {
                        this.springLength = options.springLength;
                    }

                    if (options.springConstant) {
                        this.springConstant = options.springConstant;
                    }
                }
            }
            /**
             * Position the system
             *
             * @param {Array.<Node>} nodesArray
             * @param {Array.<vis.Edge>} edgesArray
             * @param {boolean} [ignoreClusters=false]
             */

        }, {
            key: "solve",
            value: function solve(nodesArray, edgesArray) {
                var ignoreClusters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                // get distance matrix
                var D_matrix = this.distanceSolver.getDistances(this.body, nodesArray, edgesArray); // distance matrix
                // get the L Matrix

                this._createL_matrix(D_matrix); // get the K Matrix


                this._createK_matrix(D_matrix); // initial E Matrix


                this._createE_matrix(); // calculate positions


                var threshold = 0.01;
                var innerThreshold = 1;
                var iterations = 0;
                var maxIterations = Math.max(1000, Math.min(10 * this.body.nodeIndices.length, 6000));
                var maxInnerIterations = 5;
                var maxEnergy = 1e9;
                var highE_nodeId = 0,
                    dE_dx = 0,
                    dE_dy = 0,
                    delta_m = 0,
                    subIterations = 0;

                while (maxEnergy > threshold && iterations < maxIterations) {
                    iterations += 1;

                    var _this$_getHighestEner = this._getHighestEnergyNode(ignoreClusters);

                    var _this$_getHighestEner2 = _slicedToArray(_this$_getHighestEner, 4);

                    highE_nodeId = _this$_getHighestEner2[0];
                    maxEnergy = _this$_getHighestEner2[1];
                    dE_dx = _this$_getHighestEner2[2];
                    dE_dy = _this$_getHighestEner2[3];
                    delta_m = maxEnergy;
                    subIterations = 0;

                    while (delta_m > innerThreshold && subIterations < maxInnerIterations) {
                        subIterations += 1;

                        this._moveNode(highE_nodeId, dE_dx, dE_dy);

                        var _this$_getEnergy = this._getEnergy(highE_nodeId);

                        var _this$_getEnergy2 = _slicedToArray(_this$_getEnergy, 3);

                        delta_m = _this$_getEnergy2[0];
                        dE_dx = _this$_getEnergy2[1];
                        dE_dy = _this$_getEnergy2[2];
                    }
                }
            }
            /**
             * get the node with the highest energy
             *
             * @param {boolean} ignoreClusters
             * @returns {number[]}
             * @private
             */

        }, {
            key: "_getHighestEnergyNode",
            value: function _getHighestEnergyNode(ignoreClusters) {
                var nodesArray = this.body.nodeIndices;
                var nodes = this.body.nodes;
                var maxEnergy = 0;
                var maxEnergyNodeId = nodesArray[0];
                var dE_dx_max = 0,
                    dE_dy_max = 0;

                for (var nodeIdx = 0; nodeIdx < nodesArray.length; nodeIdx++) {
                    var m = nodesArray[nodeIdx]; // by not evaluating nodes with predefined positions we should only move nodes that have no positions.

                    if (nodes[m].predefinedPosition !== true || nodes[m].isCluster === true && ignoreClusters === true || nodes[m].options.fixed.x !== true || nodes[m].options.fixed.y !== true) {
                        var _this$_getEnergy3 = this._getEnergy(m),
                            _this$_getEnergy4 = _slicedToArray(_this$_getEnergy3, 3),
                            delta_m = _this$_getEnergy4[0],
                            dE_dx = _this$_getEnergy4[1],
                            dE_dy = _this$_getEnergy4[2];

                        if (maxEnergy < delta_m) {
                            maxEnergy = delta_m;
                            maxEnergyNodeId = m;
                            dE_dx_max = dE_dx;
                            dE_dy_max = dE_dy;
                        }
                    }
                }

                return [maxEnergyNodeId, maxEnergy, dE_dx_max, dE_dy_max];
            }
            /**
             * calculate the energy of a single node
             *
             * @param {Node.id} m
             * @returns {number[]}
             * @private
             */

        }, {
            key: "_getEnergy",
            value: function _getEnergy(m) {
                var _this$E_sums$m = _slicedToArray(this.E_sums[m], 2),
                    dE_dx = _this$E_sums$m[0],
                    dE_dy = _this$E_sums$m[1];

                var delta_m = Math.sqrt(Math.pow(dE_dx, 2) + Math.pow(dE_dy, 2));
                return [delta_m, dE_dx, dE_dy];
            }
            /**
             * move the node based on it's energy
             * the dx and dy are calculated from the linear system proposed by Kamada and Kawai
             *
             * @param {number} m
             * @param {number} dE_dx
             * @param {number} dE_dy
             * @private
             */

        }, {
            key: "_moveNode",
            value: function _moveNode(m, dE_dx, dE_dy) {
                var nodesArray = this.body.nodeIndices;
                var nodes = this.body.nodes;
                var d2E_dx2 = 0;
                var d2E_dxdy = 0;
                var d2E_dy2 = 0;
                var x_m = nodes[m].x;
                var y_m = nodes[m].y;
                var km = this.K_matrix[m];
                var lm = this.L_matrix[m];

                for (var iIdx = 0; iIdx < nodesArray.length; iIdx++) {
                    var i = nodesArray[iIdx];

                    if (i !== m) {
                        var x_i = nodes[i].x;
                        var y_i = nodes[i].y;
                        var kmat = km[i];
                        var lmat = lm[i];
                        var denominator = 1.0 / Math.pow(Math.pow(x_m - x_i, 2) + Math.pow(y_m - y_i, 2), 1.5);
                        d2E_dx2 += kmat * (1 - lmat * Math.pow(y_m - y_i, 2) * denominator);
                        d2E_dxdy += kmat * (lmat * (x_m - x_i) * (y_m - y_i) * denominator);
                        d2E_dy2 += kmat * (1 - lmat * Math.pow(x_m - x_i, 2) * denominator);
                    }
                } // make the variable names easier to make the solving of the linear system easier to read


                var A = d2E_dx2,
                    B = d2E_dxdy,
                    C = dE_dx,
                    D = d2E_dy2,
                    E = dE_dy; // solve the linear system for dx and dy

                var dy = (C / A + E / B) / (B / A - D / B);
                var dx = -(B * dy + C) / A; // move the node

                nodes[m].x += dx;
                nodes[m].y += dy; // Recalculate E_matrix (should be incremental)

                this._updateE_matrix(m);
            }
            /**
             * Create the L matrix: edge length times shortest path
             *
             * @param {object} D_matrix
             * @private
             */

        }, {
            key: "_createL_matrix",
            value: function _createL_matrix(D_matrix) {
                var nodesArray = this.body.nodeIndices;
                var edgeLength = this.springLength;
                this.L_matrix = [];

                for (var i = 0; i < nodesArray.length; i++) {
                    this.L_matrix[nodesArray[i]] = {};

                    for (var j = 0; j < nodesArray.length; j++) {
                        this.L_matrix[nodesArray[i]][nodesArray[j]] = edgeLength * D_matrix[nodesArray[i]][nodesArray[j]];
                    }
                }
            }
            /**
             * Create the K matrix: spring constants times shortest path
             *
             * @param {object} D_matrix
             * @private
             */

        }, {
            key: "_createK_matrix",
            value: function _createK_matrix(D_matrix) {
                var nodesArray = this.body.nodeIndices;
                var edgeStrength = this.springConstant;
                this.K_matrix = [];

                for (var i = 0; i < nodesArray.length; i++) {
                    this.K_matrix[nodesArray[i]] = {};

                    for (var j = 0; j < nodesArray.length; j++) {
                        this.K_matrix[nodesArray[i]][nodesArray[j]] = edgeStrength * Math.pow(D_matrix[nodesArray[i]][nodesArray[j]], -2);
                    }
                }
            }
            /**
             *  Create matrix with all energies between nodes
             *
             *  @private
             */

        }, {
            key: "_createE_matrix",
            value: function _createE_matrix() {
                var nodesArray = this.body.nodeIndices;
                var nodes = this.body.nodes;
                this.E_matrix = {};
                this.E_sums = {};

                for (var mIdx = 0; mIdx < nodesArray.length; mIdx++) {
                    this.E_matrix[nodesArray[mIdx]] = [];
                }

                for (var _mIdx = 0; _mIdx < nodesArray.length; _mIdx++) {
                    var m = nodesArray[_mIdx];
                    var x_m = nodes[m].x;
                    var y_m = nodes[m].y;
                    var dE_dx = 0;
                    var dE_dy = 0;

                    for (var iIdx = _mIdx; iIdx < nodesArray.length; iIdx++) {
                        var i = nodesArray[iIdx];

                        if (i !== m) {
                            var x_i = nodes[i].x;
                            var y_i = nodes[i].y;
                            var denominator = 1.0 / Math.sqrt(Math.pow(x_m - x_i, 2) + Math.pow(y_m - y_i, 2));
                            this.E_matrix[m][iIdx] = [this.K_matrix[m][i] * (x_m - x_i - this.L_matrix[m][i] * (x_m - x_i) * denominator), this.K_matrix[m][i] * (y_m - y_i - this.L_matrix[m][i] * (y_m - y_i) * denominator)];
                            this.E_matrix[i][_mIdx] = this.E_matrix[m][iIdx];
                            dE_dx += this.E_matrix[m][iIdx][0];
                            dE_dy += this.E_matrix[m][iIdx][1];
                        }
                    } //Store sum


                    this.E_sums[m] = [dE_dx, dE_dy];
                }
            }
            /**
             * Update method, just doing single column (rows are auto-updated) (update all sums)
             *
             * @param {number} m
             * @private
             */

        }, {
            key: "_updateE_matrix",
            value: function _updateE_matrix(m) {
                var nodesArray = this.body.nodeIndices;
                var nodes = this.body.nodes;
                var colm = this.E_matrix[m];
                var kcolm = this.K_matrix[m];
                var lcolm = this.L_matrix[m];
                var x_m = nodes[m].x;
                var y_m = nodes[m].y;
                var dE_dx = 0;
                var dE_dy = 0;

                for (var iIdx = 0; iIdx < nodesArray.length; iIdx++) {
                    var i = nodesArray[iIdx];

                    if (i !== m) {
                        //Keep old energy value for sum modification below
                        var cell = colm[iIdx];
                        var oldDx = cell[0];
                        var oldDy = cell[1]; //Calc new energy:

                        var x_i = nodes[i].x;
                        var y_i = nodes[i].y;
                        var denominator = 1.0 / Math.sqrt(Math.pow(x_m - x_i, 2) + Math.pow(y_m - y_i, 2));
                        var dx = kcolm[i] * (x_m - x_i - lcolm[i] * (x_m - x_i) * denominator);
                        var dy = kcolm[i] * (y_m - y_i - lcolm[i] * (y_m - y_i) * denominator);
                        colm[iIdx] = [dx, dy];
                        dE_dx += dx;
                        dE_dy += dy; //add new energy to sum of each column

                        var sum = this.E_sums[i];
                        sum[0] += dx - oldDx;
                        sum[1] += dy - oldDy;
                    }
                } //Store sum at -1 index


                this.E_sums[m] = [dE_dx, dE_dy];
            }
        }]);

        return KamadaKawai;
    }();

    /**
     * Create a network visualization, displaying nodes and edges.
     *
     * @param {Element} container   The DOM element in which the Network will
     *                                  be created. Normally a div element.
     * @param {object} data         An object containing parameters
     *                              {Array} nodes
     *                              {Array} edges
     * @param {object} options      Options
     * @class Network
     */

    function Network(container, data, options) {
        var _context,
            _context2,
            _context3,
            _context4,
            _this = this;

        if (!(this instanceof Network)) {
            throw new SyntaxError("Constructor must be called with the new operator");
        } // set constant values


        this.options = {};
        this.defaultOptions = {
            locale: "en",
            locales: locales,
            clickToUse: false
        };

        assign$2(this.options, this.defaultOptions);
        /**
         * Containers for nodes and edges.
         *
         * 'edges' and 'nodes' contain the full definitions of all the network elements.
         * 'nodeIndices' and 'edgeIndices' contain the id's of the active elements.
         *
         * The distinction is important, because a defined node need not be active, i.e.
         * visible on the canvas. This happens in particular when clusters are defined, in
         * that case there will be nodes and edges not displayed.
         * The bottom line is that all code with actions related to visibility, *must* use
         * 'nodeIndices' and 'edgeIndices', not 'nodes' and 'edges' directly.
         */


        this.body = {
            container: container,
            // See comment above for following fields
            nodes: {},
            nodeIndices: [],
            edges: {},
            edgeIndices: [],
            emitter: {
                on: bind(_context = this.on).call(_context, this),
                off: bind(_context2 = this.off).call(_context2, this),
                emit: bind(_context3 = this.emit).call(_context3, this),
                once: bind(_context4 = this.once).call(_context4, this)
            },
            eventListeners: {
                onTap: function onTap() {},
                onTouch: function onTouch() {},
                onDoubleTap: function onDoubleTap() {},
                onHold: function onHold() {},
                onDragStart: function onDragStart() {},
                onDrag: function onDrag() {},
                onDragEnd: function onDragEnd() {},
                onMouseWheel: function onMouseWheel() {},
                onPinch: function onPinch() {},
                onMouseMove: function onMouseMove() {},
                onRelease: function onRelease() {},
                onContext: function onContext() {}
            },
            data: {
                nodes: null,
                // A DataSet or DataView
                edges: null // A DataSet or DataView

            },
            functions: {
                createNode: function createNode() {},
                createEdge: function createEdge() {},
                getPointer: function getPointer() {}
            },
            modules: {},
            view: {
                scale: 1,
                translation: {
                    x: 0,
                    y: 0
                }
            },
            selectionBox: {
                show: false,
                position: {
                    start: {
                        x: 0,
                        y: 0
                    },
                    end: {
                        x: 0,
                        y: 0
                    }
                }
            }
        }; // bind the event listeners

        this.bindEventListeners(); // setting up all modules

        this.images = new Images(function () {
            return _this.body.emitter.emit("_requestRedraw");
        }); // object with images

        this.groups = new Groups(); // object with groups

        this.canvas = new Canvas(this.body); // DOM handler

        this.selectionHandler = new SelectionHandler(this.body, this.canvas); // Selection handler

        this.interactionHandler = new InteractionHandler(this.body, this.canvas, this.selectionHandler); // Interaction handler handles all the hammer bindings (that are bound by canvas), key

        this.view = new View(this.body, this.canvas); // camera handler, does animations and zooms

        this.renderer = new CanvasRenderer(this.body, this.canvas); // renderer, starts renderloop, has events that modules can hook into

        this.physics = new PhysicsEngine(this.body); // physics engine, does all the simulations

        this.layoutEngine = new LayoutEngine(this.body); // layout engine for inital layout and hierarchical layout

        this.clustering = new ClusterEngine(this.body); // clustering api

        this.manipulation = new ManipulationSystem(this.body, this.canvas, this.selectionHandler, this.interactionHandler); // data manipulation system

        this.nodesHandler = new NodesHandler(this.body, this.images, this.groups, this.layoutEngine); // Handle adding, deleting and updating of nodes as well as global options

        this.edgesHandler = new EdgesHandler(this.body, this.images, this.groups); // Handle adding, deleting and updating of edges as well as global options

        this.body.modules["kamadaKawai"] = new KamadaKawai(this.body, 150, 0.05); // Layouting algorithm.

        this.body.modules["clustering"] = this.clustering; // create the DOM elements

        this.canvas._create(); // apply options


        this.setOptions(options); // load data (the disable start variable will be the same as the enabled clustering)

        this.setData(data);
    } // Extend Network with an Emitter mixin

    componentEmitter(Network.prototype);
    /**
     * Set options
     *
     * @param {object} options
     */

    Network.prototype.setOptions = function (options) {
        var _this2 = this;

        if (options === null) {
            options = undefined; // This ensures that options handling doesn't crash in the handling
        }

        if (options !== undefined) {
            var errorFound = Validator$1.validate(options, allOptions);

            if (errorFound === true) {
                console.error("%cErrors have been found in the supplied options object.", VALIDATOR_PRINT_STYLE$1);
            } // copy the global fields over


            var fields = ["locale", "locales", "clickToUse"];
            selectiveDeepExtend(fields, this.options, options); // normalize the locale or use English

            if (options.locale !== undefined) {
                options.locale = normalizeLanguageCode(options.locales || this.options.locales, options.locale);
            } // the hierarchical system can adapt the edges and the physics to it's own options because not all combinations work with the hierarichical system.


            options = this.layoutEngine.setOptions(options.layout, options);
            this.canvas.setOptions(options); // options for canvas are in globals
            // pass the options to the modules

            this.groups.setOptions(options.groups);
            this.nodesHandler.setOptions(options.nodes);
            this.edgesHandler.setOptions(options.edges);
            this.physics.setOptions(options.physics);
            this.manipulation.setOptions(options.manipulation, options, this.options); // manipulation uses the locales in the globals

            this.interactionHandler.setOptions(options.interaction);
            this.renderer.setOptions(options.interaction); // options for rendering are in interaction

            this.selectionHandler.setOptions(options.interaction); // options for selection are in interaction
            // reload the settings of the nodes to apply changes in groups that are not referenced by pointer.

            if (options.groups !== undefined) {
                this.body.emitter.emit("refreshNodes");
            } // these two do not have options at the moment, here for completeness
            //this.view.setOptions(options.view);
            //this.clustering.setOptions(options.clustering);


            if ("configure" in options) {
                if (!this.configurator) {
                    this.configurator = new Configurator$1(this, this.body.container, configureOptions, this.canvas.pixelRatio, configuratorHideOption);
                }

                this.configurator.setOptions(options.configure);
            } // if the configuration system is enabled, copy all options and put them into the config system


            if (this.configurator && this.configurator.options.enabled === true) {
                var networkOptions = {
                    nodes: {},
                    edges: {},
                    layout: {},
                    interaction: {},
                    manipulation: {},
                    physics: {},
                    global: {}
                };
                deepExtend(networkOptions.nodes, this.nodesHandler.options);
                deepExtend(networkOptions.edges, this.edgesHandler.options);
                deepExtend(networkOptions.layout, this.layoutEngine.options); // load the selectionHandler and render default options in to the interaction group

                deepExtend(networkOptions.interaction, this.selectionHandler.options);
                deepExtend(networkOptions.interaction, this.renderer.options);
                deepExtend(networkOptions.interaction, this.interactionHandler.options);
                deepExtend(networkOptions.manipulation, this.manipulation.options);
                deepExtend(networkOptions.physics, this.physics.options); // load globals into the global object

                deepExtend(networkOptions.global, this.canvas.options);
                deepExtend(networkOptions.global, this.options);
                this.configurator.setModuleOptions(networkOptions);
            } // handle network global options


            if (options.clickToUse !== undefined) {
                if (options.clickToUse === true) {
                    if (this.activator === undefined) {
                        this.activator = new Activator$1(this.canvas.frame);
                        this.activator.on("change", function () {
                            _this2.body.emitter.emit("activate");
                        });
                    }
                } else {
                    if (this.activator !== undefined) {
                        this.activator.destroy();
                        delete this.activator;
                    }

                    this.body.emitter.emit("activate");
                }
            } else {
                this.body.emitter.emit("activate");
            }

            this.canvas.setSize(); // start the physics simulation. Can be safely called multiple times.

            this.body.emitter.emit("startSimulation");
        }
    };
    /**
     * Update the visible nodes and edges list with the most recent node state.
     *
     * Visible nodes are stored in this.body.nodeIndices.
     * Visible edges are stored in this.body.edgeIndices.
     * A node or edges is visible if it is not hidden or clustered.
     *
     * @private
     */


    Network.prototype._updateVisibleIndices = function () {
        var nodes = this.body.nodes;
        var edges = this.body.edges;
        this.body.nodeIndices = [];
        this.body.edgeIndices = [];

        for (var nodeId in nodes) {
            if (Object.prototype.hasOwnProperty.call(nodes, nodeId)) {
                if (!this.clustering._isClusteredNode(nodeId) && nodes[nodeId].options.hidden === false) {
                    this.body.nodeIndices.push(nodes[nodeId].id);
                }
            }
        }

        for (var edgeId in edges) {
            if (Object.prototype.hasOwnProperty.call(edges, edgeId)) {
                var edge = edges[edgeId]; // It can happen that this is executed *after* a node edge has been removed,
                // but *before* the edge itself has been removed. Taking this into account.

                var fromNode = nodes[edge.fromId];
                var toNode = nodes[edge.toId];
                var edgeNodesPresent = fromNode !== undefined && toNode !== undefined;
                var isVisible = !this.clustering._isClusteredEdge(edgeId) && edge.options.hidden === false && edgeNodesPresent && fromNode.options.hidden === false && // Also hidden if any of its connecting nodes are hidden
                    toNode.options.hidden === false; // idem

                if (isVisible) {
                    this.body.edgeIndices.push(edge.id);
                }
            }
        }
    };
    /**
     * Bind all events
     */


    Network.prototype.bindEventListeners = function () {
        var _this3 = this;

        // This event will trigger a rebuilding of the cache everything.
        // Used when nodes or edges have been added or removed.
        this.body.emitter.on("_dataChanged", function () {
            _this3.edgesHandler._updateState();

            _this3.body.emitter.emit("_dataUpdated");
        }); // this is called when options of EXISTING nodes or edges have changed.

        this.body.emitter.on("_dataUpdated", function () {
            // Order important in following block
            _this3.clustering._updateState();

            _this3._updateVisibleIndices();

            _this3._updateValueRange(_this3.body.nodes);

            _this3._updateValueRange(_this3.body.edges); // start simulation (can be called safely, even if already running)


            _this3.body.emitter.emit("startSimulation");

            _this3.body.emitter.emit("_requestRedraw");
        });
    };
    /**
     * Set nodes and edges, and optionally options as well.
     *
     * @param {object} data              Object containing parameters:
     *                                   {Array | DataSet | DataView} [nodes] Array with nodes
     *                                   {Array | DataSet | DataView} [edges] Array with edges
     *                                   {String} [dot] String containing data in DOT format
     *                                   {String} [gephi] String containing data in gephi JSON format
     *                                   {Options} [options] Object with options
     */


    Network.prototype.setData = function (data) {
        // reset the physics engine.
        this.body.emitter.emit("resetPhysics");
        this.body.emitter.emit("_resetData"); // unselect all to ensure no selections from old data are carried over.

        this.selectionHandler.unselectAll();

        if (data && data.dot && (data.nodes || data.edges)) {
            throw new SyntaxError('Data must contain either parameter "dot" or ' + ' parameter pair "nodes" and "edges", but not both.');
        } // set options


        this.setOptions(data && data.options); // set all data

        if (data && data.dot) {
            console.warn("The dot property has been deprecated. Please use the static convertDot method to convert DOT into vis.network format and use the normal data format with nodes and edges. This converter is used like this: var data = vis.network.convertDot(dotString);"); // parse DOT file

            var dotData = DOTToGraph(data.dot);
            this.setData(dotData);
            return;
        } else if (data && data.gephi) {
            // parse DOT file
            console.warn("The gephi property has been deprecated. Please use the static convertGephi method to convert gephi into vis.network format and use the normal data format with nodes and edges. This converter is used like this: var data = vis.network.convertGephi(gephiJson);");
            var gephiData = parseGephi(data.gephi);
            this.setData(gephiData);
            return;
        } else {
            this.nodesHandler.setData(data && data.nodes, true);
            this.edgesHandler.setData(data && data.edges, true);
        } // emit change in data


        this.body.emitter.emit("_dataChanged"); // emit data loaded

        this.body.emitter.emit("_dataLoaded"); // find a stable position or start animating to a stable position

        this.body.emitter.emit("initPhysics");
    };
    /**
     * Cleans up all bindings of the network, removing it fully from the memory IF the variable is set to null after calling this function.
     * var network = new vis.Network(..);
     * network.destroy();
     * network = null;
     */


    Network.prototype.destroy = function () {
        this.body.emitter.emit("destroy"); // clear events

        this.body.emitter.off();
        this.off(); // delete modules

        delete this.groups;
        delete this.canvas;
        delete this.selectionHandler;
        delete this.interactionHandler;
        delete this.view;
        delete this.renderer;
        delete this.physics;
        delete this.layoutEngine;
        delete this.clustering;
        delete this.manipulation;
        delete this.nodesHandler;
        delete this.edgesHandler;
        delete this.configurator;
        delete this.images;

        for (var nodeId in this.body.nodes) {
            if (!Object.prototype.hasOwnProperty.call(this.body.nodes, nodeId)) continue;
            delete this.body.nodes[nodeId];
        }

        for (var edgeId in this.body.edges) {
            if (!Object.prototype.hasOwnProperty.call(this.body.edges, edgeId)) continue;
            delete this.body.edges[edgeId];
        } // remove the container and everything inside it recursively


        recursiveDOMDelete(this.body.container);
    };
    /**
     * Update the values of all object in the given array according to the current
     * value range of the objects in the array.
     *
     * @param {object} obj    An object containing a set of Edges or Nodes
     *                        The objects must have a method getValue() and
     *                        setValueRange(min, max).
     * @private
     */


    Network.prototype._updateValueRange = function (obj) {
        var id; // determine the range of the objects

        var valueMin = undefined;
        var valueMax = undefined;
        var valueTotal = 0;

        for (id in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, id)) {
                var value = obj[id].getValue();

                if (value !== undefined) {
                    valueMin = valueMin === undefined ? value : Math.min(value, valueMin);
                    valueMax = valueMax === undefined ? value : Math.max(value, valueMax);
                    valueTotal += value;
                }
            }
        } // adjust the range of all objects


        if (valueMin !== undefined && valueMax !== undefined) {
            for (id in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, id)) {
                    obj[id].setValueRange(valueMin, valueMax, valueTotal);
                }
            }
        }
    };
    /**
     * Returns true when the Network is active.
     *
     * @returns {boolean}
     */


    Network.prototype.isActive = function () {
        return !this.activator || this.activator.active;
    };

    Network.prototype.setSize = function () {
        return this.canvas.setSize.apply(this.canvas, arguments);
    };

    Network.prototype.canvasToDOM = function () {
        return this.canvas.canvasToDOM.apply(this.canvas, arguments);
    };

    Network.prototype.DOMtoCanvas = function () {
        return this.canvas.DOMtoCanvas.apply(this.canvas, arguments);
    };
    /**
     * Nodes can be in clusters. Clusters can also be in clusters. This function returns and array of
     * nodeIds showing where the node is.
     *
     * If any nodeId in the chain, especially the first passed in as a parameter, is not present in
     * the current nodes list, an empty array is returned.
     *
     * Example:
     * cluster 'A' contains cluster 'B',
     * cluster 'B' contains cluster 'C',
     * cluster 'C' contains node 'fred'.
     * `jsnetwork.clustering.findNode('fred')` will return `['A','B','C','fred']`.
     *
     * @param {string|number} nodeId
     * @returns {Array}
     */


    Network.prototype.findNode = function () {
        return this.clustering.findNode.apply(this.clustering, arguments);
    };

    Network.prototype.isCluster = function () {
        return this.clustering.isCluster.apply(this.clustering, arguments);
    };

    Network.prototype.openCluster = function () {
        return this.clustering.openCluster.apply(this.clustering, arguments);
    };

    Network.prototype.cluster = function () {
        return this.clustering.cluster.apply(this.clustering, arguments);
    };

    Network.prototype.getNodesInCluster = function () {
        return this.clustering.getNodesInCluster.apply(this.clustering, arguments);
    };

    Network.prototype.clusterByConnection = function () {
        return this.clustering.clusterByConnection.apply(this.clustering, arguments);
    };

    Network.prototype.clusterByHubsize = function () {
        return this.clustering.clusterByHubsize.apply(this.clustering, arguments);
    };

    Network.prototype.updateClusteredNode = function () {
        return this.clustering.updateClusteredNode.apply(this.clustering, arguments);
    };

    Network.prototype.getClusteredEdges = function () {
        return this.clustering.getClusteredEdges.apply(this.clustering, arguments);
    };

    Network.prototype.getBaseEdge = function () {
        return this.clustering.getBaseEdge.apply(this.clustering, arguments);
    };

    Network.prototype.getBaseEdges = function () {
        return this.clustering.getBaseEdges.apply(this.clustering, arguments);
    };

    Network.prototype.updateEdge = function () {
        return this.clustering.updateEdge.apply(this.clustering, arguments);
    };
    /**
     * This method will cluster all nodes with 1 edge with their respective connected node.
     * The options object is explained in full <a data-scroll="" data-options="{ &quot;easing&quot;: &quot;easeInCubic&quot; }" href="#optionsObject">below</a>.
     *
     * @param {object} [options]
     * @returns {undefined}
     */


    Network.prototype.clusterOutliers = function () {
        return this.clustering.clusterOutliers.apply(this.clustering, arguments);
    };

    Network.prototype.getSeed = function () {
        return this.layoutEngine.getSeed.apply(this.layoutEngine, arguments);
    };

    Network.prototype.enableEditMode = function () {
        return this.manipulation.enableEditMode.apply(this.manipulation, arguments);
    };

    Network.prototype.disableEditMode = function () {
        return this.manipulation.disableEditMode.apply(this.manipulation, arguments);
    };

    Network.prototype.addNodeMode = function () {
        return this.manipulation.addNodeMode.apply(this.manipulation, arguments);
    };

    Network.prototype.editNode = function () {
        return this.manipulation.editNode.apply(this.manipulation, arguments);
    };

    Network.prototype.editNodeMode = function () {
        console.warn("Deprecated: Please use editNode instead of editNodeMode.");
        return this.manipulation.editNode.apply(this.manipulation, arguments);
    };

    Network.prototype.addEdgeMode = function () {
        return this.manipulation.addEdgeMode.apply(this.manipulation, arguments);
    };

    Network.prototype.editEdgeMode = function () {
        return this.manipulation.editEdgeMode.apply(this.manipulation, arguments);
    };

    Network.prototype.deleteSelected = function () {
        return this.manipulation.deleteSelected.apply(this.manipulation, arguments);
    };

    Network.prototype.getPositions = function () {
        return this.nodesHandler.getPositions.apply(this.nodesHandler, arguments);
    };

    Network.prototype.getPosition = function () {
        return this.nodesHandler.getPosition.apply(this.nodesHandler, arguments);
    };

    Network.prototype.storePositions = function () {
        return this.nodesHandler.storePositions.apply(this.nodesHandler, arguments);
    };

    Network.prototype.moveNode = function () {
        return this.nodesHandler.moveNode.apply(this.nodesHandler, arguments);
    };

    Network.prototype.getBoundingBox = function () {
        return this.nodesHandler.getBoundingBox.apply(this.nodesHandler, arguments);
    };

    Network.prototype.getConnectedNodes = function (objectId) {
        if (this.body.nodes[objectId] !== undefined) {
            return this.nodesHandler.getConnectedNodes.apply(this.nodesHandler, arguments);
        } else {
            return this.edgesHandler.getConnectedNodes.apply(this.edgesHandler, arguments);
        }
    };

    Network.prototype.getConnectedEdges = function () {
        return this.nodesHandler.getConnectedEdges.apply(this.nodesHandler, arguments);
    };

    Network.prototype.startSimulation = function () {
        return this.physics.startSimulation.apply(this.physics, arguments);
    };

    Network.prototype.stopSimulation = function () {
        return this.physics.stopSimulation.apply(this.physics, arguments);
    };

    Network.prototype.stabilize = function () {
        return this.physics.stabilize.apply(this.physics, arguments);
    };

    Network.prototype.getSelection = function () {
        return this.selectionHandler.getSelection.apply(this.selectionHandler, arguments);
    };

    Network.prototype.setSelection = function () {
        return this.selectionHandler.setSelection.apply(this.selectionHandler, arguments);
    };

    Network.prototype.getSelectedNodes = function () {
        return this.selectionHandler.getSelectedNodeIds.apply(this.selectionHandler, arguments);
    };

    Network.prototype.getSelectedEdges = function () {
        return this.selectionHandler.getSelectedEdgeIds.apply(this.selectionHandler, arguments);
    };

    Network.prototype.getNodeAt = function () {
        var node = this.selectionHandler.getNodeAt.apply(this.selectionHandler, arguments);

        if (node !== undefined && node.id !== undefined) {
            return node.id;
        }

        return node;
    };

    Network.prototype.getEdgeAt = function () {
        var edge = this.selectionHandler.getEdgeAt.apply(this.selectionHandler, arguments);

        if (edge !== undefined && edge.id !== undefined) {
            return edge.id;
        }

        return edge;
    };

    Network.prototype.selectNodes = function () {
        return this.selectionHandler.selectNodes.apply(this.selectionHandler, arguments);
    };

    Network.prototype.selectEdges = function () {
        return this.selectionHandler.selectEdges.apply(this.selectionHandler, arguments);
    };

    Network.prototype.unselectAll = function () {
        this.selectionHandler.unselectAll.apply(this.selectionHandler, arguments);
        this.selectionHandler.commitWithoutEmitting.apply(this.selectionHandler);
        this.redraw();
    };

    Network.prototype.redraw = function () {
        return this.renderer.redraw.apply(this.renderer, arguments);
    };

    Network.prototype.getScale = function () {
        return this.view.getScale.apply(this.view, arguments);
    };

    Network.prototype.getViewPosition = function () {
        return this.view.getViewPosition.apply(this.view, arguments);
    };

    Network.prototype.fit = function () {
        return this.view.fit.apply(this.view, arguments);
    };

    Network.prototype.moveTo = function () {
        return this.view.moveTo.apply(this.view, arguments);
    };

    Network.prototype.focus = function () {
        return this.view.focus.apply(this.view, arguments);
    };

    Network.prototype.releaseNode = function () {
        return this.view.releaseNode.apply(this.view, arguments);
    };

    Network.prototype.getOptionsFromConfigurator = function () {
        var options = {};

        if (this.configurator) {
            options = this.configurator.getOptions.apply(this.configurator);
        }

        return options;
    };

    var parseDOTNetwork = DOTToGraph;
    // overflow in UMD builds. They all export vis namespace therefore reexporting
    // leads to loading vis to load vis to load vis…

    exports.DataSet = DataSet;
    exports.DataView = DataView;
    exports.Network = Network;
    exports.NetworkImages = Images;
    exports.Queue = Queue;
    exports.data = index;
    exports.networkDOTParser = dotparser;
    exports.networkGephiParser = gephiParser;
    exports.networkOptions = options;
    exports.parseDOTNetwork = parseDOTNetwork;
    exports.parseGephiNetwork = parseGephi;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=vis-network.js.map

﻿/*
Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
*/
(function(){if(window.CKEDITOR&&window.CKEDITOR.dom)return;window.CKEDITOR||(window.CKEDITOR=function(){var a=/(^|.*[\\\/])ckeditor\.js(?:\?.*|;.*)?$/i,d={timestamp:"L0QD",version:"4.16.0",revision:"17a1555f7f",rnd:Math.floor(900*Math.random())+100,_:{pending:[],basePathSrcPattern:a},status:"unloaded",basePath:function(){var c=window.CKEDITOR_BASEPATH||"";if(!c)for(var b=document.getElementsByTagName("script"),d=0;d<b.length;d++){var h=b[d].src.match(a);if(h){c=h[1];break}}-1==c.indexOf(":/")&&"//"!=c.slice(0,2)&&(c=0===c.indexOf("/")?location.href.match(/^.*?:\/\/[^\/]*/)[0]+
c:location.href.match(/^[^\?]*\/(?:)/)[0]+c);if(!c)throw'The CKEditor installation path could not be automatically detected. Please set the global variable "CKEDITOR_BASEPATH" before creating editor instances.';return c}(),getUrl:function(a){-1==a.indexOf(":/")&&0!==a.indexOf("/")&&(a=this.basePath+a);this.timestamp&&"/"!=a.charAt(a.length-1)&&!/[&?]t=/.test(a)&&(a+=(0<=a.indexOf("?")?"\x26":"?")+"t\x3d"+this.timestamp);return a},domReady:function(){function a(){try{document.addEventListener?(document.removeEventListener("DOMContentLoaded",
a,!1),window.removeEventListener("load",a,!1),c()):document.attachEvent&&"complete"===document.readyState&&(document.detachEvent("onreadystatechange",a),window.detachEvent("onload",a),c())}catch(b){}}function c(){for(var a;a=b.shift();)a()}var b=[];return function(c){function k(){try{document.documentElement.doScroll("left")}catch(c){setTimeout(k,1);return}a()}b.push(c);"complete"===document.readyState&&setTimeout(a,1);if(1==b.length)if(document.addEventListener)document.addEventListener("DOMContentLoaded",
a,!1),window.addEventListener("load",a,!1);else if(document.attachEvent){document.attachEvent("onreadystatechange",a);window.attachEvent("onload",a);c=!1;try{c=!window.frameElement}catch(f){}document.documentElement.doScroll&&c&&k()}}}()},b=window.CKEDITOR_GETURL;if(b){var c=d.getUrl;d.getUrl=function(a){return b.call(d,a)||c.call(d,a)}}return d}());
CKEDITOR.event||(CKEDITOR.event=function(){},CKEDITOR.event.implementOn=function(a){var d=CKEDITOR.event.prototype,b;for(b in d)null==a[b]&&(a[b]=d[b])},CKEDITOR.event.prototype=function(){function a(a){var g=d(this);return g[a]||(g[a]=new b(a))}var d=function(a){a=a.getPrivate&&a.getPrivate()||a._||(a._={});return a.events||(a.events={})},b=function(a){this.name=a;this.listeners=[]};b.prototype={getListenerIndex:function(a){for(var b=0,f=this.listeners;b<f.length;b++)if(f[b].fn==a)return b;return-1}};
return{define:function(b,d){var f=a.call(this,b);CKEDITOR.tools.extend(f,d,!0)},on:function(b,d,f,l,h){function k(a,z,w,e){a={name:b,sender:this,editor:a,data:z,listenerData:l,stop:w,cancel:e,removeListener:p};return!1===d.call(f,a)?!1:a.data}function p(){z.removeListener(b,d)}var e=a.call(this,b);if(0>e.getListenerIndex(d)){e=e.listeners;f||(f=this);isNaN(h)&&(h=10);var z=this;k.fn=d;k.priority=h;for(var w=e.length-1;0<=w;w--)if(e[w].priority<=h)return e.splice(w+1,0,k),{removeListener:p};e.unshift(k)}return{removeListener:p}},
once:function(){var a=Array.prototype.slice.call(arguments),b=a[1];a[1]=function(a){a.removeListener();return b.apply(this,arguments)};return this.on.apply(this,a)},capture:function(){CKEDITOR.event.useCapture=1;var a=this.on.apply(this,arguments);CKEDITOR.event.useCapture=0;return a},fire:function(){var a=0,b=function(){a=1},f=0,l=function(){f=1};return function(h,k,p){var e=d(this)[h];h=a;var z=f;a=f=0;if(e){var w=e.listeners;if(w.length)for(var w=w.slice(0),y,G=0;G<w.length;G++){if(e.errorProof)try{y=
w[G].call(this,p,k,b,l)}catch(q){}else y=w[G].call(this,p,k,b,l);!1===y?f=1:"undefined"!=typeof y&&(k=y);if(a||f)break}}k=f?!1:"undefined"==typeof k?!0:k;a=h;f=z;return k}}(),fireOnce:function(a,b,f){b=this.fire(a,b,f);delete d(this)[a];return b},removeListener:function(a,b){var f=d(this)[a];if(f){var l=f.getListenerIndex(b);0<=l&&f.listeners.splice(l,1)}},removeAllListeners:function(){var a=d(this),b;for(b in a)delete a[b]},hasListeners:function(a){return(a=d(this)[a])&&0<a.listeners.length}}}());
CKEDITOR.editor||(CKEDITOR.editor=function(){CKEDITOR._.pending.push([this,arguments]);CKEDITOR.event.call(this)},CKEDITOR.editor.prototype.fire=function(a,d){a in{instanceReady:1,loaded:1}&&(this[a]=!0);return CKEDITOR.event.prototype.fire.call(this,a,d,this)},CKEDITOR.editor.prototype.fireOnce=function(a,d){a in{instanceReady:1,loaded:1}&&(this[a]=!0);return CKEDITOR.event.prototype.fireOnce.call(this,a,d,this)},CKEDITOR.event.implementOn(CKEDITOR.editor.prototype));
CKEDITOR.env||(CKEDITOR.env=function(){var a=navigator.userAgent.toLowerCase(),d=a.match(/edge[ \/](\d+.?\d*)/),b=-1<a.indexOf("trident/"),b=!(!d&&!b),b={ie:b,edge:!!d,webkit:!b&&-1<a.indexOf(" applewebkit/"),air:-1<a.indexOf(" adobeair/"),mac:-1<a.indexOf("macintosh"),quirks:"BackCompat"==document.compatMode&&(!document.documentMode||10>document.documentMode),mobile:-1<a.indexOf("mobile"),iOS:/(ipad|iphone|ipod)/.test(a),isCustomDomain:function(){if(!this.ie)return!1;var a=document.domain,b=window.location.hostname;
return a!=b&&a!="["+b+"]"},secure:"https:"==location.protocol};b.gecko="Gecko"==navigator.product&&!b.webkit&&!b.ie;b.webkit&&(-1<a.indexOf("chrome")?b.chrome=!0:b.safari=!0);var c=0;b.ie&&(c=d?parseFloat(d[1]):b.quirks||!document.documentMode?parseFloat(a.match(/msie (\d+)/)[1]):document.documentMode,b.ie9Compat=9==c,b.ie8Compat=8==c,b.ie7Compat=7==c,b.ie6Compat=7>c||b.quirks);b.gecko&&(d=a.match(/rv:([\d\.]+)/))&&(d=d[1].split("."),c=1E4*d[0]+100*(d[1]||0)+1*(d[2]||0));b.air&&(c=parseFloat(a.match(/ adobeair\/(\d+)/)[1]));
b.webkit&&(c=parseFloat(a.match(/ applewebkit\/(\d+)/)[1]));b.version=c;b.isCompatible=!(b.ie&&7>c)&&!(b.gecko&&4E4>c)&&!(b.webkit&&534>c);b.hidpi=2<=window.devicePixelRatio;b.needsBrFiller=b.gecko||b.webkit||b.ie&&10<c;b.needsNbspFiller=b.ie&&11>c;b.cssClass="cke_browser_"+(b.ie?"ie":b.gecko?"gecko":b.webkit?"webkit":"unknown");b.quirks&&(b.cssClass+=" cke_browser_quirks");b.ie&&(b.cssClass+=" cke_browser_ie"+(b.quirks?"6 cke_browser_iequirks":b.version));b.air&&(b.cssClass+=" cke_browser_air");
b.iOS&&(b.cssClass+=" cke_browser_ios");b.hidpi&&(b.cssClass+=" cke_hidpi");return b}());
"unloaded"==CKEDITOR.status&&function(){CKEDITOR.event.implementOn(CKEDITOR);CKEDITOR.loadFullCore=function(){if("basic_ready"!=CKEDITOR.status)CKEDITOR.loadFullCore._load=1;else{delete CKEDITOR.loadFullCore;var a=document.createElement("script");a.type="text/javascript";a.src=CKEDITOR.basePath+"ckeditor.js";document.getElementsByTagName("head")[0].appendChild(a)}};CKEDITOR.loadFullCoreTimeout=0;CKEDITOR.add=function(a){(this._.pending||(this._.pending=[])).push(a)};(function(){CKEDITOR.domReady(function(){var a=
CKEDITOR.loadFullCore,d=CKEDITOR.loadFullCoreTimeout;a&&(CKEDITOR.status="basic_ready",a&&a._load?a():d&&setTimeout(function(){CKEDITOR.loadFullCore&&CKEDITOR.loadFullCore()},1E3*d))})})();CKEDITOR.status="basic_loaded"}();"use strict";CKEDITOR.VERBOSITY_WARN=1;CKEDITOR.VERBOSITY_ERROR=2;CKEDITOR.verbosity=CKEDITOR.VERBOSITY_WARN|CKEDITOR.VERBOSITY_ERROR;CKEDITOR.warn=function(a,d){CKEDITOR.verbosity&CKEDITOR.VERBOSITY_WARN&&CKEDITOR.fire("log",{type:"warn",errorCode:a,additionalData:d})};
CKEDITOR.error=function(a,d){CKEDITOR.verbosity&CKEDITOR.VERBOSITY_ERROR&&CKEDITOR.fire("log",{type:"error",errorCode:a,additionalData:d})};
CKEDITOR.on("log",function(a){if(window.console&&window.console.log){var d=console[a.data.type]?a.data.type:"log",b=a.data.errorCode;if(a=a.data.additionalData)console[d]("[CKEDITOR] Error code: "+b+".",a);else console[d]("[CKEDITOR] Error code: "+b+".");console[d]("[CKEDITOR] For more information about this error go to https://ckeditor.com/docs/ckeditor4/latest/guide/dev_errors.html#"+b)}},null,null,999);CKEDITOR.dom={};
(function(){function a(a,w,b){this._minInterval=a;this._context=b;this._lastOutput=this._scheduledTimer=0;this._output=CKEDITOR.tools.bind(w,b||{});var e=this;this.input=function(){function a(){e._lastOutput=(new Date).getTime();e._scheduledTimer=0;e._call()}if(!e._scheduledTimer||!1!==e._reschedule()){var z=(new Date).getTime()-e._lastOutput;z<e._minInterval?e._scheduledTimer=setTimeout(a,e._minInterval-z):a()}}}function d(z,b,e){a.call(this,z,b,e);this._args=[];var c=this;this.input=CKEDITOR.tools.override(this.input,
function(a){return function(){c._args=Array.prototype.slice.call(arguments);a.call(this)}})}var b=[],c=CKEDITOR.env.gecko?"-moz-":CKEDITOR.env.webkit?"-webkit-":CKEDITOR.env.ie?"-ms-":"",g=/&/g,f=/>/g,l=/</g,h=/"/g,k=/&(lt|gt|amp|quot|nbsp|shy|#\d{1,5});/g,p={lt:"\x3c",gt:"\x3e",amp:"\x26",quot:'"',nbsp:" ",shy:"­"},e=function(a,b){return"#"==b[0]?String.fromCharCode(parseInt(b.slice(1),10)):p[b]};CKEDITOR.on("reset",function(){b=[]});CKEDITOR.tools={arrayCompare:function(a,b){if(!a&&!b)return!0;
if(!a||!b||a.length!=b.length)return!1;for(var e=0;e<a.length;e++)if(a[e]!=b[e])return!1;return!0},getIndex:function(a,b){for(var e=0;e<a.length;++e)if(b(a[e]))return e;return-1},clone:function(a){var b;if(a&&a instanceof Array){b=[];for(var e=0;e<a.length;e++)b[e]=CKEDITOR.tools.clone(a[e]);return b}if(null===a||"object"!=typeof a||a instanceof String||a instanceof Number||a instanceof Boolean||a instanceof Date||a instanceof RegExp||a.nodeType||a.window===a)return a;b=new a.constructor;for(e in a)b[e]=
CKEDITOR.tools.clone(a[e]);return b},capitalize:function(a,b){return a.charAt(0).toUpperCase()+(b?a.slice(1):a.slice(1).toLowerCase())},extend:function(a){var b=arguments.length,e,c;"boolean"==typeof(e=arguments[b-1])?b--:"boolean"==typeof(e=arguments[b-2])&&(c=arguments[b-1],b-=2);for(var h=1;h<b;h++){var n=arguments[h]||{};CKEDITOR.tools.array.forEach(CKEDITOR.tools.object.keys(n),function(b){if(!0===e||null==a[b])if(!c||b in c)a[b]=n[b]})}return a},prototypedCopy:function(a){var b=function(){};
b.prototype=a;return new b},copy:function(a){var b={},e;for(e in a)b[e]=a[e];return b},isArray:function(a){return"[object Array]"==Object.prototype.toString.call(a)},isEmpty:function(a){for(var b in a)if(a.hasOwnProperty(b))return!1;return!0},cssVendorPrefix:function(a,b,e){if(e)return c+a+":"+b+";"+a+":"+b;e={};e[a]=b;e[c+a]=b;return e},cssStyleToDomStyle:function(){var a=document.createElement("div").style,b="undefined"!=typeof a.cssFloat?"cssFloat":"undefined"!=typeof a.styleFloat?"styleFloat":
"float";return function(a){return"float"==a?b:a.replace(/-./g,function(a){return a.substr(1).toUpperCase()})}}(),buildStyleHtml:function(a){a=[].concat(a);for(var b,e=[],c=0;c<a.length;c++)if(b=a[c])/@import|[{}]/.test(b)?e.push("\x3cstyle\x3e"+b+"\x3c/style\x3e"):e.push('\x3clink type\x3d"text/css" rel\x3dstylesheet href\x3d"'+b+'"\x3e');return e.join("")},htmlEncode:function(a){return void 0===a||null===a?"":String(a).replace(g,"\x26amp;").replace(f,"\x26gt;").replace(l,"\x26lt;")},htmlDecode:function(a){return a.replace(k,
e)},htmlEncodeAttr:function(a){return CKEDITOR.tools.htmlEncode(a).replace(h,"\x26quot;")},htmlDecodeAttr:function(a){return CKEDITOR.tools.htmlDecode(a)},transformPlainTextToHtml:function(a,b){var e=b==CKEDITOR.ENTER_BR,c=this.htmlEncode(a.replace(/\r\n/g,"\n")),c=c.replace(/\t/g,"\x26nbsp;\x26nbsp; \x26nbsp;"),h=b==CKEDITOR.ENTER_P?"p":"div";if(!e){var n=/\n{2}/g;if(n.test(c))var k="\x3c"+h+"\x3e",d="\x3c/"+h+"\x3e",c=k+c.replace(n,function(){return d+k})+d}c=c.replace(/\n/g,"\x3cbr\x3e");e||(c=
c.replace(new RegExp("\x3cbr\x3e(?\x3d\x3c/"+h+"\x3e)"),function(a){return CKEDITOR.tools.repeat(a,2)}));c=c.replace(/^ | $/g,"\x26nbsp;");return c=c.replace(/(>|\s) /g,function(a,b){return b+"\x26nbsp;"}).replace(/ (?=<)/g,"\x26nbsp;")},getNextNumber:function(){var a=0;return function(){return++a}}(),getNextId:function(){return"cke_"+this.getNextNumber()},getUniqueId:function(){for(var a="e",b=0;8>b;b++)a+=Math.floor(65536*(1+Math.random())).toString(16).substring(1);return a},override:function(a,
b){var e=b(a);e.prototype=a.prototype;return e},setTimeout:function(a,b,e,c,h){h||(h=window);e||(e=h);return h.setTimeout(function(){c?a.apply(e,[].concat(c)):a.apply(e)},b||0)},throttle:function(a,b,e){return new this.buffers.throttle(a,b,e)},trim:function(){var a=/(?:^[ \t\n\r]+)|(?:[ \t\n\r]+$)/g;return function(b){return b.replace(a,"")}}(),ltrim:function(){var a=/^[ \t\n\r]+/g;return function(b){return b.replace(a,"")}}(),rtrim:function(){var a=/[ \t\n\r]+$/g;return function(b){return b.replace(a,
"")}}(),indexOf:function(a,b){if("function"==typeof b)for(var e=0,c=a.length;e<c;e++){if(b(a[e]))return e}else{if(a.indexOf)return a.indexOf(b);e=0;for(c=a.length;e<c;e++)if(a[e]===b)return e}return-1},search:function(a,b){var e=CKEDITOR.tools.indexOf(a,b);return 0<=e?a[e]:null},bind:function(a,b){var e=Array.prototype.slice.call(arguments,2);return function(){return a.apply(b,e.concat(Array.prototype.slice.call(arguments)))}},createClass:function(a){var b=a.$,e=a.base,c=a.privates||a._,h=a.proto;
a=a.statics;!b&&(b=function(){e&&this.base.apply(this,arguments)});if(c)var n=b,b=function(){var a=this._||(this._={}),b;for(b in c){var e=c[b];a[b]="function"==typeof e?CKEDITOR.tools.bind(e,this):e}n.apply(this,arguments)};e&&(b.prototype=this.prototypedCopy(e.prototype),b.prototype.constructor=b,b.base=e,b.baseProto=e.prototype,b.prototype.base=function x(){this.base=e.prototype.base;e.apply(this,arguments);this.base=x});h&&this.extend(b.prototype,h,!0);a&&this.extend(b,a,!0);return b},addFunction:function(a,
e){return b.push(function(){return a.apply(e||this,arguments)})-1},removeFunction:function(a){b[a]=null},callFunction:function(a){var e=b[a];return e&&e.apply(window,Array.prototype.slice.call(arguments,1))},cssLength:function(){var a=/^-?\d+\.?\d*px$/,b;return function(e){b=CKEDITOR.tools.trim(e+"")+"px";return a.test(b)?b:e||""}}(),convertToPx:function(){var a;return function(b){a||(a=CKEDITOR.dom.element.createFromHtml('\x3cdiv style\x3d"position:absolute;left:-9999px;top:-9999px;margin:0px;padding:0px;border:0px;"\x3e\x3c/div\x3e',
CKEDITOR.document),CKEDITOR.document.getBody().append(a));if(!/%$/.test(b)){var e=0>parseFloat(b);e&&(b=b.replace("-",""));a.setStyle("width",b);b=a.$.clientWidth;return e?-b:b}return b}}(),repeat:function(a,b){return Array(b+1).join(a)},tryThese:function(){for(var a,b=0,e=arguments.length;b<e;b++){var c=arguments[b];try{a=c();break}catch(h){}}return a},genKey:function(){return Array.prototype.slice.call(arguments).join("-")},defer:function(a){return function(){var b=arguments,e=this;window.setTimeout(function(){a.apply(e,
b)},0)}},normalizeCssText:function(a,b){var e=[],c,h=CKEDITOR.tools.parseCssText(a,!0,b);for(c in h)e.push(c+":"+h[c]);e.sort();return e.length?e.join(";")+";":""},convertRgbToHex:function(a){return a.replace(/(?:rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\))/gi,function(a,b,e,c){a=[b,e,c];for(b=0;3>b;b++)a[b]=("0"+parseInt(a[b],10).toString(16)).slice(-2);return"#"+a.join("")})},normalizeHex:function(a){return a.replace(/#(([0-9a-f]{3}){1,2})($|;|\s+)/gi,function(a,b,e,c){a=b.toLowerCase();3==a.length&&
(a=a.split(""),a=[a[0],a[0],a[1],a[1],a[2],a[2]].join(""));return"#"+a+c})},_isValidColorFormat:function(a){if(!a)return!1;a=a.replace(/\s+/g,"");return/^[a-z0-9()#%,./]+$/i.test(a)},parseCssText:function(a,b,e){var c={};e&&(a=(new CKEDITOR.dom.element("span")).setAttribute("style",a).getAttribute("style")||"");a&&(a=CKEDITOR.tools.normalizeHex(CKEDITOR.tools.convertRgbToHex(a)));if(!a||";"==a)return c;a.replace(/&quot;/g,'"').replace(/\s*([^:;\s]+)\s*:\s*([^;]+)\s*(?=;|$)/g,function(a,e,z){b&&(e=
e.toLowerCase(),"font-family"==e&&(z=z.replace(/\s*,\s*/g,",")),z=CKEDITOR.tools.trim(z));c[e]=z});return c},writeCssText:function(a,b){var e,c=[];for(e in a)c.push(e+":"+a[e]);b&&c.sort();return c.join("; ")},objectCompare:function(a,b,e){var c;if(!a&&!b)return!0;if(!a||!b)return!1;for(c in a)if(a[c]!=b[c])return!1;if(!e)for(c in b)if(a[c]!=b[c])return!1;return!0},objectKeys:function(a){return CKEDITOR.tools.object.keys(a)},convertArrayToObject:function(a,b){var e={};1==arguments.length&&(b=!0);
for(var c=0,h=a.length;c<h;++c)e[a[c]]=b;return e},getStyledSpans:function(a,b){var e=CKEDITOR.env.ie&&8==CKEDITOR.env.version?a.toUpperCase():a,e=b.find("span[style*\x3d"+e+"]").toArray();return CKEDITOR.tools.array.filter(e,function(b){return!!b.getStyle(a)})},fixDomain:function(){for(var a;;)try{a=window.parent.document.domain;break}catch(b){a=a?a.replace(/.+?(?:\.|$)/,""):document.domain;if(!a)break;document.domain=a}return!!a},eventsBuffer:function(a,b,e){return new this.buffers.event(a,b,e)},
enableHtml5Elements:function(a,b){for(var e="abbr article aside audio bdi canvas data datalist details figcaption figure footer header hgroup main mark meter nav output progress section summary time video".split(" "),c=e.length,h;c--;)h=a.createElement(e[c]),b&&a.appendChild(h)},checkIfAnyArrayItemMatches:function(a,b){for(var e=0,c=a.length;e<c;++e)if(a[e].match(b))return!0;return!1},checkIfAnyObjectPropertyMatches:function(a,b){for(var e in a)if(e.match(b))return!0;return!1},keystrokeToString:function(a,
b){var e=this.keystrokeToArray(a,b);e.display=e.display.join("+");e.aria=e.aria.join("+");return e},keystrokeToArray:function(a,b){var e=b&16711680,c=b&65535,h=CKEDITOR.env.mac,n=[],k=[];e&CKEDITOR.CTRL&&(n.push(h?"⌘":a[17]),k.push(h?a[224]:a[17]));e&CKEDITOR.ALT&&(n.push(h?"⌥":a[18]),k.push(a[18]));e&CKEDITOR.SHIFT&&(n.push(h?"⇧":a[16]),k.push(a[16]));c&&(a[c]?(n.push(a[c]),k.push(a[c])):(n.push(String.fromCharCode(c)),k.push(String.fromCharCode(c))));return{display:n,aria:k}},transparentImageData:"data:image/gif;base64,R0lGODlhAQABAPABAP///wAAACH5BAEKAAAALAAAAAABAAEAAAICRAEAOw\x3d\x3d",
getCookie:function(a){a=a.toLowerCase();for(var b=document.cookie.split(";"),e,c,h=0;h<b.length;h++)if(e=b[h].split("\x3d"),c=decodeURIComponent(CKEDITOR.tools.trim(e[0]).toLowerCase()),c===a)return decodeURIComponent(1<e.length?e[1]:"");return null},setCookie:function(a,b){document.cookie=encodeURIComponent(a)+"\x3d"+encodeURIComponent(b)+";path\x3d/"},getCsrfToken:function(){var a=CKEDITOR.tools.getCookie("ckCsrfToken");if(!a||40!=a.length){var a=[],b="";if(window.crypto&&window.crypto.getRandomValues)a=
new Uint8Array(40),window.crypto.getRandomValues(a);else for(var e=0;40>e;e++)a.push(Math.floor(256*Math.random()));for(e=0;e<a.length;e++)var c="abcdefghijklmnopqrstuvwxyz0123456789".charAt(a[e]%36),b=b+(.5<Math.random()?c.toUpperCase():c);a=b;CKEDITOR.tools.setCookie("ckCsrfToken",a)}return a},escapeCss:function(a){return a?window.CSS&&CSS.escape?CSS.escape(a):isNaN(parseInt(a.charAt(0),10))?a:"\\3"+a.charAt(0)+" "+a.substring(1,a.length):""},getMouseButton:function(a){return(a=a&&a.data?a.data.$:
a)?CKEDITOR.tools.normalizeMouseButton(a.button):!1},normalizeMouseButton:function(a,b){if(!CKEDITOR.env.ie||9<=CKEDITOR.env.version&&!CKEDITOR.env.ie6Compat)return a;for(var e=[[CKEDITOR.MOUSE_BUTTON_LEFT,1],[CKEDITOR.MOUSE_BUTTON_MIDDLE,4],[CKEDITOR.MOUSE_BUTTON_RIGHT,2]],c=0;c<e.length;c++){var h=e[c];if(h[0]===a&&b)return h[1];if(!b&&h[1]===a)return h[0]}},convertHexStringToBytes:function(a){var b=[],e=a.length/2,c;for(c=0;c<e;c++)b.push(parseInt(a.substr(2*c,2),16));return b},convertBytesToBase64:function(a){var b=
"",e=a.length,c;for(c=0;c<e;c+=3){var h=a.slice(c,c+3),n=h.length,k=[],d;if(3>n)for(d=n;3>d;d++)h[d]=0;k[0]=(h[0]&252)>>2;k[1]=(h[0]&3)<<4|h[1]>>4;k[2]=(h[1]&15)<<2|(h[2]&192)>>6;k[3]=h[2]&63;for(d=0;4>d;d++)b=d<=n?b+"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(k[d]):b+"\x3d"}return b},style:{parse:{_borderStyle:"none hidden dotted dashed solid double groove ridge inset outset".split(" "),_widthRegExp:/^(thin|medium|thick|[\+-]?\d+(\.\d+)?[a-z%]+|[\+-]?0+(\.0+)?|\.\d+[a-z%]+)$/,
_rgbaRegExp:/rgba?\(\s*\d+%?\s*,\s*\d+%?\s*,\s*\d+%?\s*(?:,\s*[0-9.]+\s*)?\)/gi,_hslaRegExp:/hsla?\(\s*[0-9.]+\s*,\s*\d+%\s*,\s*\d+%\s*(?:,\s*[0-9.]+\s*)?\)/gi,background:function(a){var b={},e=this._findColor(a);e.length&&(b.color=e[0],CKEDITOR.tools.array.forEach(e,function(b){a=a.replace(b,"")}));if(a=CKEDITOR.tools.trim(a))b.unprocessed=a;return b},margin:function(a){return CKEDITOR.tools.style.parse.sideShorthand(a,function(a){return a.match(/(?:\-?[\.\d]+(?:%|\w*)|auto|inherit|initial|unset|revert)/g)||
["0px"]})},sideShorthand:function(a,b){function e(a){c.top=h[a[0]];c.right=h[a[1]];c.bottom=h[a[2]];c.left=h[a[3]]}var c={},h=b?b(a):a.split(/\s+/);switch(h.length){case 1:e([0,0,0,0]);break;case 2:e([0,1,0,1]);break;case 3:e([0,1,2,1]);break;case 4:e([0,1,2,3])}return c},border:function(a){return CKEDITOR.tools.style.border.fromCssRule(a)},_findColor:function(a){var b=[],e=CKEDITOR.tools.array,b=b.concat(a.match(this._rgbaRegExp)||[]),b=b.concat(a.match(this._hslaRegExp)||[]);return b=b.concat(e.filter(a.split(/\s+/),
function(a){return a.match(/^\#[a-f0-9]{3}(?:[a-f0-9]{3})?$/gi)?!0:a.toLowerCase()in CKEDITOR.tools.style.parse._colors}))}}},array:{filter:function(a,b,e){var c=[];this.forEach(a,function(h,n){b.call(e,h,n,a)&&c.push(h)});return c},find:function(a,b,e){for(var c=a.length,h=0;h<c;){if(b.call(e,a[h],h,a))return a[h];h++}},forEach:function(a,b,e){var c=a.length,h;for(h=0;h<c;h++)b.call(e,a[h],h,a)},map:function(a,b,e){for(var c=[],h=0;h<a.length;h++)c.push(b.call(e,a[h],h,a));return c},reduce:function(a,
b,e,c){for(var h=0;h<a.length;h++)e=b.call(c,e,a[h],h,a);return e},every:function(a,b,e){if(!a.length)return!0;b=this.filter(a,b,e);return a.length===b.length},some:function(a,b,e){for(var c=0;c<a.length;c++)if(b.call(e,a[c],c,a))return!0;return!1},zip:function(a,b){return CKEDITOR.tools.array.map(a,function(a,e){return[a,b[e]]})},unique:function(a){return this.filter(a,function(b,e){return e===CKEDITOR.tools.array.indexOf(a,b)})}},object:{DONT_ENUMS:"toString toLocaleString valueOf hasOwnProperty isPrototypeOf propertyIsEnumerable constructor".split(" "),
entries:function(a){return CKEDITOR.tools.array.map(CKEDITOR.tools.object.keys(a),function(b){return[b,a[b]]})},values:function(a){return CKEDITOR.tools.array.map(CKEDITOR.tools.object.keys(a),function(b){return a[b]})},keys:function(a){var b=Object.prototype.hasOwnProperty,e=[],c=CKEDITOR.tools.object.DONT_ENUMS;if(CKEDITOR.env.ie&&9>CKEDITOR.env.version&&(!a||"object"!==typeof a)){b=[];if("string"===typeof a)for(e=0;e<a.length;e++)b.push(String(e));return b}for(var h in a)e.push(h);if(CKEDITOR.env.ie&&
9>CKEDITOR.env.version)for(h=0;h<c.length;h++)b.call(a,c[h])&&e.push(c[h]);return e},findKey:function(a,b){if("object"!==typeof a)return null;for(var e in a)if(a[e]===b)return e;return null},merge:function(a,b){var e=CKEDITOR.tools,c=e.clone(a),h=e.clone(b);e.array.forEach(e.object.keys(h),function(a){c[a]="object"===typeof h[a]&&"object"===typeof c[a]?e.object.merge(c[a],h[a]):h[a]});return c}},getAbsoluteRectPosition:function(a,b){function e(a){if(a){var b=a.getClientRect();c.top+=b.top;c.left+=
b.left;"x"in c&&"y"in c&&(c.x+=b.x,c.y+=b.y);e(a.getWindow().getFrame())}}var c=CKEDITOR.tools.copy(b);e(a.getFrame());var h=CKEDITOR.document.getWindow().getScrollPosition();c.top+=h.y;c.left+=h.x;"x"in c&&"y"in c&&(c.y+=h.y,c.x+=h.x);c.right=c.left+c.width;c.bottom=c.top+c.height;return c}};a.prototype={reset:function(){this._lastOutput=0;this._clearTimer()},_reschedule:function(){return!1},_call:function(){this._output()},_clearTimer:function(){this._scheduledTimer&&clearTimeout(this._scheduledTimer);
this._scheduledTimer=0}};d.prototype=CKEDITOR.tools.prototypedCopy(a.prototype);d.prototype._reschedule=function(){this._scheduledTimer&&this._clearTimer()};d.prototype._call=function(){this._output.apply(this._context,this._args)};CKEDITOR.tools.buffers={};CKEDITOR.tools.buffers.event=a;CKEDITOR.tools.buffers.throttle=d;CKEDITOR.tools.style.border=CKEDITOR.tools.createClass({$:function(a){a=a||{};this.width=a.width;this.style=a.style;this.color=a.color;this._.normalize()},_:{normalizeMap:{color:[[/windowtext/g,
"black"]]},normalize:function(){for(var a in this._.normalizeMap){var b=this[a];b&&(this[a]=CKEDITOR.tools.array.reduce(this._.normalizeMap[a],function(a,b){return a.replace(b[0],b[1])},b))}}},proto:{toString:function(){return CKEDITOR.tools.array.filter([this.width,this.style,this.color],function(a){return!!a}).join(" ")}},statics:{fromCssRule:function(a){var b={},e=a.split(/\s+/g);a=CKEDITOR.tools.style.parse._findColor(a);a.length&&(b.color=a[0]);CKEDITOR.tools.array.forEach(e,function(a){b.style||
-1===CKEDITOR.tools.indexOf(CKEDITOR.tools.style.parse._borderStyle,a)?!b.width&&CKEDITOR.tools.style.parse._widthRegExp.test(a)&&(b.width=a):b.style=a});return new CKEDITOR.tools.style.border(b)},splitCssValues:function(a,b){b=b||{};var e=CKEDITOR.tools.array.reduce(["width","style","color"],function(e,c){var h=a["border-"+c]||b[c];e[c]=h?CKEDITOR.tools.style.parse.sideShorthand(h):null;return e},{});return CKEDITOR.tools.array.reduce(["top","right","bottom","left"],function(b,c){var h={},k;for(k in e){var d=
a["border-"+c+"-"+k];h[k]=d?d:e[k]&&e[k][c]}b["border-"+c]=new CKEDITOR.tools.style.border(h);return b},{})}}});CKEDITOR.tools.array.indexOf=CKEDITOR.tools.indexOf;CKEDITOR.tools.array.isArray=CKEDITOR.tools.isArray;CKEDITOR.MOUSE_BUTTON_LEFT=0;CKEDITOR.MOUSE_BUTTON_MIDDLE=1;CKEDITOR.MOUSE_BUTTON_RIGHT=2})();
CKEDITOR.dtd=function(){var a=CKEDITOR.tools.extend,d=function(a,b){for(var c=CKEDITOR.tools.clone(a),h=1;h<arguments.length;h++){b=arguments[h];for(var k in b)delete c[k]}return c},b={},c={},g={address:1,article:1,aside:1,blockquote:1,details:1,div:1,dl:1,fieldset:1,figure:1,footer:1,form:1,h1:1,h2:1,h3:1,h4:1,h5:1,h6:1,header:1,hgroup:1,hr:1,main:1,menu:1,nav:1,ol:1,p:1,pre:1,section:1,table:1,ul:1},f={command:1,link:1,meta:1,noscript:1,script:1,style:1},l={},h={"#":1},k={center:1,dir:1,noframes:1};
a(b,{a:1,abbr:1,area:1,audio:1,b:1,bdi:1,bdo:1,br:1,button:1,canvas:1,cite:1,code:1,command:1,datalist:1,del:1,dfn:1,em:1,embed:1,i:1,iframe:1,img:1,input:1,ins:1,kbd:1,keygen:1,label:1,map:1,mark:1,meter:1,noscript:1,object:1,output:1,progress:1,q:1,ruby:1,s:1,samp:1,script:1,select:1,small:1,span:1,strong:1,sub:1,sup:1,textarea:1,time:1,u:1,"var":1,video:1,wbr:1},h,{acronym:1,applet:1,basefont:1,big:1,font:1,isindex:1,strike:1,style:1,tt:1});a(c,g,b,k);d={a:d(b,{a:1,button:1}),abbr:b,address:c,
area:l,article:c,aside:c,audio:a({source:1,track:1},c),b:b,base:l,bdi:b,bdo:b,blockquote:c,body:c,br:l,button:d(b,{a:1,button:1}),canvas:b,caption:c,cite:b,code:b,col:l,colgroup:{col:1},command:l,datalist:a({option:1},b),dd:c,del:b,details:a({summary:1},c),dfn:b,div:c,dl:{dt:1,dd:1},dt:c,em:b,embed:l,fieldset:a({legend:1},c),figcaption:c,figure:a({figcaption:1},c),footer:c,form:c,h1:b,h2:b,h3:b,h4:b,h5:b,h6:b,head:a({title:1,base:1},f),header:c,hgroup:{h1:1,h2:1,h3:1,h4:1,h5:1,h6:1},hr:l,html:a({head:1,
body:1},c,f),i:b,iframe:h,img:l,input:l,ins:b,kbd:b,keygen:l,label:b,legend:b,li:c,link:l,main:c,map:c,mark:b,menu:a({li:1},c),meta:l,meter:d(b,{meter:1}),nav:c,noscript:a({link:1,meta:1,style:1},b),object:a({param:1},b),ol:{li:1},optgroup:{option:1},option:h,output:b,p:b,param:l,pre:b,progress:d(b,{progress:1}),q:b,rp:b,rt:b,ruby:a({rp:1,rt:1},b),s:b,samp:b,script:h,section:c,select:{optgroup:1,option:1},small:b,source:l,span:b,strong:b,style:h,sub:b,summary:a({h1:1,h2:1,h3:1,h4:1,h5:1,h6:1},b),
sup:b,table:{caption:1,colgroup:1,thead:1,tfoot:1,tbody:1,tr:1},tbody:{tr:1},td:c,textarea:h,tfoot:{tr:1},th:c,thead:{tr:1},time:d(b,{time:1}),title:h,tr:{th:1,td:1},track:l,u:b,ul:{li:1},"var":b,video:a({source:1,track:1},c),wbr:l,acronym:b,applet:a({param:1},c),basefont:l,big:b,center:c,dialog:l,dir:{li:1},font:b,isindex:l,noframes:c,strike:b,tt:b};a(d,{$block:a({audio:1,dd:1,dt:1,figcaption:1,li:1,video:1},g,k),$blockLimit:{article:1,aside:1,audio:1,body:1,caption:1,details:1,dir:1,div:1,dl:1,
fieldset:1,figcaption:1,figure:1,footer:1,form:1,header:1,hgroup:1,main:1,menu:1,nav:1,ol:1,section:1,table:1,td:1,th:1,tr:1,ul:1,video:1},$cdata:{script:1,style:1},$editable:{address:1,article:1,aside:1,blockquote:1,body:1,details:1,div:1,fieldset:1,figcaption:1,footer:1,form:1,h1:1,h2:1,h3:1,h4:1,h5:1,h6:1,header:1,hgroup:1,main:1,nav:1,p:1,pre:1,section:1},$empty:{area:1,base:1,basefont:1,br:1,col:1,command:1,dialog:1,embed:1,hr:1,img:1,input:1,isindex:1,keygen:1,link:1,meta:1,param:1,source:1,
track:1,wbr:1},$inline:b,$list:{dl:1,ol:1,ul:1},$listItem:{dd:1,dt:1,li:1},$nonBodyContent:a({body:1,head:1,html:1},d.head),$nonEditable:{applet:1,audio:1,button:1,embed:1,iframe:1,map:1,object:1,option:1,param:1,script:1,textarea:1,video:1},$object:{applet:1,audio:1,button:1,hr:1,iframe:1,img:1,input:1,object:1,select:1,table:1,textarea:1,video:1},$removeEmpty:{abbr:1,acronym:1,b:1,bdi:1,bdo:1,big:1,cite:1,code:1,del:1,dfn:1,em:1,font:1,i:1,ins:1,label:1,kbd:1,mark:1,meter:1,output:1,q:1,ruby:1,
s:1,samp:1,small:1,span:1,strike:1,strong:1,sub:1,sup:1,time:1,tt:1,u:1,"var":1},$tabIndex:{a:1,area:1,button:1,input:1,object:1,select:1,textarea:1},$tableContent:{caption:1,col:1,colgroup:1,tbody:1,td:1,tfoot:1,th:1,thead:1,tr:1},$transparent:{a:1,audio:1,canvas:1,del:1,ins:1,map:1,noscript:1,object:1,video:1},$intermediate:{caption:1,colgroup:1,dd:1,dt:1,figcaption:1,legend:1,li:1,optgroup:1,option:1,rp:1,rt:1,summary:1,tbody:1,td:1,tfoot:1,th:1,thead:1,tr:1}});return d}();
CKEDITOR.dom.event=function(a){this.$=a};
CKEDITOR.dom.event.prototype={getKey:function(){return this.$.keyCode||this.$.which},getKeystroke:function(){var a=this.getKey();if(this.$.ctrlKey||this.$.metaKey)a+=CKEDITOR.CTRL;this.$.shiftKey&&(a+=CKEDITOR.SHIFT);this.$.altKey&&(a+=CKEDITOR.ALT);return a},preventDefault:function(a){var d=this.$;d.preventDefault?d.preventDefault():d.returnValue=!1;a&&this.stopPropagation()},stopPropagation:function(){var a=this.$;a.stopPropagation?a.stopPropagation():a.cancelBubble=!0},getTarget:function(){var a=
this.$.target||this.$.srcElement;return a?new CKEDITOR.dom.node(a):null},getPhase:function(){return this.$.eventPhase||2},getPageOffset:function(){var a=this.getTarget().getDocument().$;return{x:this.$.pageX||this.$.clientX+(a.documentElement.scrollLeft||a.body.scrollLeft),y:this.$.pageY||this.$.clientY+(a.documentElement.scrollTop||a.body.scrollTop)}}};CKEDITOR.CTRL=1114112;CKEDITOR.SHIFT=2228224;CKEDITOR.ALT=4456448;CKEDITOR.EVENT_PHASE_CAPTURING=1;CKEDITOR.EVENT_PHASE_AT_TARGET=2;
CKEDITOR.EVENT_PHASE_BUBBLING=3;CKEDITOR.dom.domObject=function(a){a&&(this.$=a)};
CKEDITOR.dom.domObject.prototype=function(){var a=function(a,b){return function(c){"undefined"!=typeof CKEDITOR&&a.fire(b,new CKEDITOR.dom.event(c))}};return{getPrivate:function(){var a;(a=this.getCustomData("_"))||this.setCustomData("_",a={});return a},on:function(d){var b=this.getCustomData("_cke_nativeListeners");b||(b={},this.setCustomData("_cke_nativeListeners",b));b[d]||(b=b[d]=a(this,d),this.$.addEventListener?this.$.addEventListener(d,b,!!CKEDITOR.event.useCapture):this.$.attachEvent&&this.$.attachEvent("on"+
d,b));return CKEDITOR.event.prototype.on.apply(this,arguments)},removeListener:function(a){CKEDITOR.event.prototype.removeListener.apply(this,arguments);if(!this.hasListeners(a)){var b=this.getCustomData("_cke_nativeListeners"),c=b&&b[a];c&&(this.$.removeEventListener?this.$.removeEventListener(a,c,!1):this.$.detachEvent&&this.$.detachEvent("on"+a,c),delete b[a])}},removeAllListeners:function(){try{var a=this.getCustomData("_cke_nativeListeners"),b;for(b in a){var c=a[b];this.$.detachEvent?this.$.detachEvent("on"+
b,c):this.$.removeEventListener&&this.$.removeEventListener(b,c,!1);delete a[b]}}catch(g){if(!CKEDITOR.env.edge||-2146828218!==g.number)throw g;}CKEDITOR.event.prototype.removeAllListeners.call(this)}}}();
(function(a){var d={};CKEDITOR.on("reset",function(){d={}});a.equals=function(a){try{return a&&a.$===this.$}catch(c){return!1}};a.setCustomData=function(a,c){var g=this.getUniqueId();(d[g]||(d[g]={}))[a]=c;return this};a.getCustomData=function(a){var c=this.$["data-cke-expando"];return(c=c&&d[c])&&a in c?c[a]:null};a.removeCustomData=function(a){var c=this.$["data-cke-expando"],c=c&&d[c],g,f;c&&(g=c[a],f=a in c,delete c[a]);return f?g:null};a.clearCustomData=function(){this.removeAllListeners();var a=
this.getUniqueId();a&&delete d[a]};a.getUniqueId=function(){return this.$["data-cke-expando"]||(this.$["data-cke-expando"]=CKEDITOR.tools.getNextNumber())};CKEDITOR.event.implementOn(a)})(CKEDITOR.dom.domObject.prototype);
CKEDITOR.dom.node=function(a){return a?new CKEDITOR.dom[a.nodeType==CKEDITOR.NODE_DOCUMENT?"document":a.nodeType==CKEDITOR.NODE_ELEMENT?"element":a.nodeType==CKEDITOR.NODE_TEXT?"text":a.nodeType==CKEDITOR.NODE_COMMENT?"comment":a.nodeType==CKEDITOR.NODE_DOCUMENT_FRAGMENT?"documentFragment":"domObject"](a):this};CKEDITOR.dom.node.prototype=new CKEDITOR.dom.domObject;CKEDITOR.NODE_ELEMENT=1;CKEDITOR.NODE_DOCUMENT=9;CKEDITOR.NODE_TEXT=3;CKEDITOR.NODE_COMMENT=8;CKEDITOR.NODE_DOCUMENT_FRAGMENT=11;
CKEDITOR.POSITION_IDENTICAL=0;CKEDITOR.POSITION_DISCONNECTED=1;CKEDITOR.POSITION_FOLLOWING=2;CKEDITOR.POSITION_PRECEDING=4;CKEDITOR.POSITION_IS_CONTAINED=8;CKEDITOR.POSITION_CONTAINS=16;
CKEDITOR.tools.extend(CKEDITOR.dom.node.prototype,{appendTo:function(a,d){a.append(this,d);return a},clone:function(a,d){function b(c){c["data-cke-expando"]&&(c["data-cke-expando"]=!1);if(c.nodeType==CKEDITOR.NODE_ELEMENT||c.nodeType==CKEDITOR.NODE_DOCUMENT_FRAGMENT)if(d||c.nodeType!=CKEDITOR.NODE_ELEMENT||c.removeAttribute("id",!1),a){c=c.childNodes;for(var g=0;g<c.length;g++)b(c[g])}}function c(b){if(b.type==CKEDITOR.NODE_ELEMENT||b.type==CKEDITOR.NODE_DOCUMENT_FRAGMENT){if(b.type!=CKEDITOR.NODE_DOCUMENT_FRAGMENT){var d=
b.getName();":"==d[0]&&b.renameNode(d.substring(1))}if(a)for(d=0;d<b.getChildCount();d++)c(b.getChild(d))}}var g=this.$.cloneNode(a);b(g);g=new CKEDITOR.dom.node(g);CKEDITOR.env.ie&&9>CKEDITOR.env.version&&(this.type==CKEDITOR.NODE_ELEMENT||this.type==CKEDITOR.NODE_DOCUMENT_FRAGMENT)&&c(g);return g},hasPrevious:function(){return!!this.$.previousSibling},hasNext:function(){return!!this.$.nextSibling},insertAfter:function(a){a.$.parentNode.insertBefore(this.$,a.$.nextSibling);return a},insertBefore:function(a){a.$.parentNode.insertBefore(this.$,
a.$);return a},insertBeforeMe:function(a){this.$.parentNode.insertBefore(a.$,this.$);return a},getAddress:function(a){for(var d=[],b=this.getDocument().$.documentElement,c=this;c&&c!=b;){var g=c.getParent();g&&d.unshift(this.getIndex.call(c,a));c=g}return d},getDocument:function(){return new CKEDITOR.dom.document(this.$.ownerDocument||this.$.parentNode.ownerDocument)},getIndex:function(a){function d(a,b){var c=b?a.getNext():a.getPrevious();return c&&c.type==CKEDITOR.NODE_TEXT?c.isEmpty()?d(c,b):c:
null}var b=this,c=-1,g;if(!this.getParent()||a&&b.type==CKEDITOR.NODE_TEXT&&b.isEmpty()&&!d(b)&&!d(b,!0))return-1;do if(!a||b.equals(this)||b.type!=CKEDITOR.NODE_TEXT||!g&&!b.isEmpty())c++,g=b.type==CKEDITOR.NODE_TEXT;while(b=b.getPrevious());return c},getNextSourceNode:function(a,d,b){if(b&&!b.call){var c=b;b=function(a){return!a.equals(c)}}a=!a&&this.getFirst&&this.getFirst();var g;if(!a){if(this.type==CKEDITOR.NODE_ELEMENT&&b&&!1===b(this,!0))return null;a=this.getNext()}for(;!a&&(g=(g||this).getParent());){if(b&&
!1===b(g,!0))return null;a=g.getNext()}return!a||b&&!1===b(a)?null:d&&d!=a.type?a.getNextSourceNode(!1,d,b):a},getPreviousSourceNode:function(a,d,b){if(b&&!b.call){var c=b;b=function(a){return!a.equals(c)}}a=!a&&this.getLast&&this.getLast();var g;if(!a){if(this.type==CKEDITOR.NODE_ELEMENT&&b&&!1===b(this,!0))return null;a=this.getPrevious()}for(;!a&&(g=(g||this).getParent());){if(b&&!1===b(g,!0))return null;a=g.getPrevious()}return!a||b&&!1===b(a)?null:d&&a.type!=d?a.getPreviousSourceNode(!1,d,b):
a},getPrevious:function(a){var d=this.$,b;do b=(d=d.previousSibling)&&10!=d.nodeType&&new CKEDITOR.dom.node(d);while(b&&a&&!a(b));return b},getNext:function(a){var d=this.$,b;do b=(d=d.nextSibling)&&new CKEDITOR.dom.node(d);while(b&&a&&!a(b));return b},getParent:function(a){var d=this.$.parentNode;return d&&(d.nodeType==CKEDITOR.NODE_ELEMENT||a&&d.nodeType==CKEDITOR.NODE_DOCUMENT_FRAGMENT)?new CKEDITOR.dom.node(d):null},getParents:function(a){var d=this,b=[];do b[a?"push":"unshift"](d);while(d=d.getParent());
return b},getCommonAncestor:function(a){if(a.equals(this))return this;if(a.contains&&a.contains(this))return a;var d=this.contains?this:this.getParent();do if(d.contains(a))return d;while(d=d.getParent());return null},getPosition:function(a){var d=this.$,b=a.$;if(d.compareDocumentPosition)return d.compareDocumentPosition(b);if(d==b)return CKEDITOR.POSITION_IDENTICAL;if(this.type==CKEDITOR.NODE_ELEMENT&&a.type==CKEDITOR.NODE_ELEMENT){if(d.contains){if(d.contains(b))return CKEDITOR.POSITION_CONTAINS+
CKEDITOR.POSITION_PRECEDING;if(b.contains(d))return CKEDITOR.POSITION_IS_CONTAINED+CKEDITOR.POSITION_FOLLOWING}if("sourceIndex"in d)return 0>d.sourceIndex||0>b.sourceIndex?CKEDITOR.POSITION_DISCONNECTED:d.sourceIndex<b.sourceIndex?CKEDITOR.POSITION_PRECEDING:CKEDITOR.POSITION_FOLLOWING}d=this.getAddress();a=a.getAddress();for(var b=Math.min(d.length,a.length),c=0;c<b;c++)if(d[c]!=a[c])return d[c]<a[c]?CKEDITOR.POSITION_PRECEDING:CKEDITOR.POSITION_FOLLOWING;return d.length<a.length?CKEDITOR.POSITION_CONTAINS+
CKEDITOR.POSITION_PRECEDING:CKEDITOR.POSITION_IS_CONTAINED+CKEDITOR.POSITION_FOLLOWING},getAscendant:function(a,d){var b=this.$,c,g;d||(b=b.parentNode);"function"==typeof a?(g=!0,c=a):(g=!1,c=function(b){b="string"==typeof b.nodeName?b.nodeName.toLowerCase():"";return"string"==typeof a?b==a:b in a});for(;b;){if(c(g?new CKEDITOR.dom.node(b):b))return new CKEDITOR.dom.node(b);try{b=b.parentNode}catch(f){b=null}}return null},hasAscendant:function(a,d){var b=this.$;d||(b=b.parentNode);for(;b;){if(b.nodeName&&
b.nodeName.toLowerCase()==a)return!0;b=b.parentNode}return!1},move:function(a,d){a.append(this.remove(),d)},remove:function(a){var d=this.$,b=d.parentNode;if(b){if(a)for(;a=d.firstChild;)b.insertBefore(d.removeChild(a),d);b.removeChild(d)}return this},replace:function(a){this.insertBefore(a);a.remove()},trim:function(){this.ltrim();this.rtrim()},ltrim:function(){for(var a;this.getFirst&&(a=this.getFirst());){if(a.type==CKEDITOR.NODE_TEXT){var d=CKEDITOR.tools.ltrim(a.getText()),b=a.getLength();if(d)d.length<
b&&(a.split(b-d.length),this.$.removeChild(this.$.firstChild));else{a.remove();continue}}break}},rtrim:function(){for(var a;this.getLast&&(a=this.getLast());){if(a.type==CKEDITOR.NODE_TEXT){var d=CKEDITOR.tools.rtrim(a.getText()),b=a.getLength();if(d)d.length<b&&(a.split(d.length),this.$.lastChild.parentNode.removeChild(this.$.lastChild));else{a.remove();continue}}break}CKEDITOR.env.needsBrFiller&&(a=this.$.lastChild)&&1==a.type&&"br"==a.nodeName.toLowerCase()&&a.parentNode.removeChild(a)},isReadOnly:function(a){var d=
this;this.type!=CKEDITOR.NODE_ELEMENT&&(d=this.getParent());CKEDITOR.env.edge&&d&&d.is("textarea","input")&&(a=!0);if(!a&&d&&"undefined"!=typeof d.$.isContentEditable)return!(d.$.isContentEditable||d.data("cke-editable"));for(;d;){if(d.data("cke-editable"))return!1;if(d.hasAttribute("contenteditable"))return"false"==d.getAttribute("contenteditable");d=d.getParent()}return!0}});CKEDITOR.dom.window=function(a){CKEDITOR.dom.domObject.call(this,a)};CKEDITOR.dom.window.prototype=new CKEDITOR.dom.domObject;
CKEDITOR.tools.extend(CKEDITOR.dom.window.prototype,{focus:function(){this.$.focus()},getViewPaneSize:function(){var a=this.$.document,d="CSS1Compat"==a.compatMode;return{width:(d?a.documentElement.clientWidth:a.body.clientWidth)||0,height:(d?a.documentElement.clientHeight:a.body.clientHeight)||0}},getScrollPosition:function(){var a=this.$;if("pageXOffset"in a)return{x:a.pageXOffset||0,y:a.pageYOffset||0};a=a.document;return{x:a.documentElement.scrollLeft||a.body.scrollLeft||0,y:a.documentElement.scrollTop||
a.body.scrollTop||0}},getFrame:function(){var a=this.$.frameElement;return a?new CKEDITOR.dom.element.get(a):null}});CKEDITOR.dom.document=function(a){CKEDITOR.dom.domObject.call(this,a)};CKEDITOR.dom.document.prototype=new CKEDITOR.dom.domObject;
CKEDITOR.tools.extend(CKEDITOR.dom.document.prototype,{type:CKEDITOR.NODE_DOCUMENT,appendStyleSheet:function(a){if(this.$.createStyleSheet)this.$.createStyleSheet(a);else{var d=new CKEDITOR.dom.element("link");d.setAttributes({rel:"stylesheet",type:"text/css",href:a});this.getHead().append(d)}},appendStyleText:function(a){if(this.$.createStyleSheet){var d=this.$.createStyleSheet("");d.cssText=a}else{var b=new CKEDITOR.dom.element("style",this);b.append(new CKEDITOR.dom.text(a,this));this.getHead().append(b)}return d||
b.$.sheet},createElement:function(a,d){var b=new CKEDITOR.dom.element(a,this);d&&(d.attributes&&b.setAttributes(d.attributes),d.styles&&b.setStyles(d.styles));return b},createText:function(a){return new CKEDITOR.dom.text(a,this)},focus:function(){this.getWindow().focus()},getActive:function(){var a;try{a=this.$.activeElement}catch(d){return null}return new CKEDITOR.dom.element(a)},getById:function(a){return(a=this.$.getElementById(a))?new CKEDITOR.dom.element(a):null},getByAddress:function(a,d){for(var b=
this.$.documentElement,c=0;b&&c<a.length;c++){var g=a[c];if(d)for(var f=-1,l=0;l<b.childNodes.length;l++){var h=b.childNodes[l];if(!0!==d||3!=h.nodeType||!h.previousSibling||3!=h.previousSibling.nodeType)if(f++,f==g){b=h;break}}else b=b.childNodes[g]}return b?new CKEDITOR.dom.node(b):null},getElementsByTag:function(a,d){CKEDITOR.env.ie&&8>=document.documentMode||!d||(a=d+":"+a);return new CKEDITOR.dom.nodeList(this.$.getElementsByTagName(a))},getHead:function(){var a=this.$.getElementsByTagName("head")[0];
return a=a?new CKEDITOR.dom.element(a):this.getDocumentElement().append(new CKEDITOR.dom.element("head"),!0)},getBody:function(){return new CKEDITOR.dom.element(this.$.body)},getDocumentElement:function(){return new CKEDITOR.dom.element(this.$.documentElement)},getWindow:function(){return new CKEDITOR.dom.window(this.$.parentWindow||this.$.defaultView)},write:function(a){this.$.open("text/html","replace");CKEDITOR.env.ie&&(a=a.replace(/(?:^\s*<!DOCTYPE[^>]*?>)|^/i,'$\x26\n\x3cscript data-cke-temp\x3d"1"\x3e('+
CKEDITOR.tools.fixDomain+")();\x3c/script\x3e"));this.$.write(a);this.$.close()},find:function(a){return new CKEDITOR.dom.nodeList(this.$.querySelectorAll(a))},findOne:function(a){return(a=this.$.querySelector(a))?new CKEDITOR.dom.element(a):null},_getHtml5ShivFrag:function(){var a=this.getCustomData("html5ShivFrag");a||(a=this.$.createDocumentFragment(),CKEDITOR.tools.enableHtml5Elements(a,!0),this.setCustomData("html5ShivFrag",a));return a}});CKEDITOR.dom.nodeList=function(a){this.$=a};
CKEDITOR.dom.nodeList.prototype={count:function(){return this.$.length},getItem:function(a){return 0>a||a>=this.$.length?null:(a=this.$[a])?new CKEDITOR.dom.node(a):null},toArray:function(){return CKEDITOR.tools.array.map(this.$,function(a){return new CKEDITOR.dom.node(a)})}};CKEDITOR.dom.element=function(a,d){"string"==typeof a&&(a=(d?d.$:document).createElement(a));CKEDITOR.dom.domObject.call(this,a)};
CKEDITOR.dom.element.get=function(a){return(a="string"==typeof a?document.getElementById(a)||document.getElementsByName(a)[0]:a)&&(a.$?a:new CKEDITOR.dom.element(a))};CKEDITOR.dom.element.prototype=new CKEDITOR.dom.node;CKEDITOR.dom.element.createFromHtml=function(a,d){var b=new CKEDITOR.dom.element("div",d);b.setHtml(a);return b.getFirst().remove()};
CKEDITOR.dom.element.setMarker=function(a,d,b,c){var g=d.getCustomData("list_marker_id")||d.setCustomData("list_marker_id",CKEDITOR.tools.getNextNumber()).getCustomData("list_marker_id"),f=d.getCustomData("list_marker_names")||d.setCustomData("list_marker_names",{}).getCustomData("list_marker_names");a[g]=d;f[b]=1;return d.setCustomData(b,c)};CKEDITOR.dom.element.clearAllMarkers=function(a){for(var d in a)CKEDITOR.dom.element.clearMarkers(a,a[d],1)};
CKEDITOR.dom.element.clearMarkers=function(a,d,b){var c=d.getCustomData("list_marker_names"),g=d.getCustomData("list_marker_id"),f;for(f in c)d.removeCustomData(f);d.removeCustomData("list_marker_names");b&&(d.removeCustomData("list_marker_id"),delete a[g])};
(function(){function a(a,b){return-1<(" "+a+" ").replace(f," ").indexOf(" "+b+" ")}function d(a){var b=!0;a.$.id||(a.$.id="cke_tmp_"+CKEDITOR.tools.getNextNumber(),b=!1);return function(){b||a.removeAttribute("id")}}function b(a,b){var c=CKEDITOR.tools.escapeCss(a.$.id);return"#"+c+" "+b.split(/,\s*/).join(", #"+c+" ")}function c(a){for(var b=0,c=0,e=l[a].length;c<e;c++)b+=parseFloat(this.getComputedStyle(l[a][c])||0,10)||0;return b}var g=document.createElement("_").classList,g="undefined"!==typeof g&&
null!==String(g.add).match(/\[Native code\]/gi),f=/[\n\t\r]/g;CKEDITOR.tools.extend(CKEDITOR.dom.element.prototype,{type:CKEDITOR.NODE_ELEMENT,addClass:g?function(a){this.$.classList.add(a);return this}:function(b){var c=this.$.className;c&&(a(c,b)||(c+=" "+b));this.$.className=c||b;return this},removeClass:g?function(a){var b=this.$;b.classList.remove(a);b.className||b.removeAttribute("class");return this}:function(b){var c=this.getAttribute("class");c&&a(c,b)&&((c=c.replace(new RegExp("(?:^|\\s+)"+
b+"(?\x3d\\s|$)"),"").replace(/^\s+/,""))?this.setAttribute("class",c):this.removeAttribute("class"));return this},hasClass:function(b){return a(this.$.className,b)},append:function(a,b){"string"==typeof a&&(a=this.getDocument().createElement(a));b?this.$.insertBefore(a.$,this.$.firstChild):this.$.appendChild(a.$);return a},appendHtml:function(a){if(this.$.childNodes.length){var b=new CKEDITOR.dom.element("div",this.getDocument());b.setHtml(a);b.moveChildren(this)}else this.setHtml(a)},appendText:function(a){null!=
this.$.text&&CKEDITOR.env.ie&&9>CKEDITOR.env.version?this.$.text+=a:this.append(new CKEDITOR.dom.text(a))},appendBogus:function(a){if(a||CKEDITOR.env.needsBrFiller){for(a=this.getLast();a&&a.type==CKEDITOR.NODE_TEXT&&!CKEDITOR.tools.rtrim(a.getText());)a=a.getPrevious();a&&a.is&&a.is("br")||(a=this.getDocument().createElement("br"),CKEDITOR.env.gecko&&a.setAttribute("type","_moz"),this.append(a))}},breakParent:function(a,b){var c=new CKEDITOR.dom.range(this.getDocument());c.setStartAfter(this);c.setEndAfter(a);
var e=c.extractContents(!1,b||!1),d;c.insertNode(this.remove());if(CKEDITOR.env.ie&&!CKEDITOR.env.edge){for(c=new CKEDITOR.dom.element("div");d=e.getFirst();)d.$.style.backgroundColor&&(d.$.style.backgroundColor=d.$.style.backgroundColor),c.append(d);c.insertAfter(this);c.remove(!0)}else e.insertAfterNode(this)},contains:document.compareDocumentPosition?function(a){return!!(this.$.compareDocumentPosition(a.$)&16)}:function(a){var b=this.$;return a.type!=CKEDITOR.NODE_ELEMENT?b.contains(a.getParent().$):
b!=a.$&&b.contains(a.$)},focus:function(){function a(){try{this.$.focus()}catch(b){}}return function(b){b?CKEDITOR.tools.setTimeout(a,100,this):a.call(this)}}(),getHtml:function(){var a=this.$.innerHTML;return CKEDITOR.env.ie?a.replace(/<\?[^>]*>/g,""):a},getOuterHtml:function(){if(this.$.outerHTML)return this.$.outerHTML.replace(/<\?[^>]*>/,"");var a=this.$.ownerDocument.createElement("div");a.appendChild(this.$.cloneNode(!0));return a.innerHTML},getClientRect:function(a){var b=CKEDITOR.tools.extend({},
this.$.getBoundingClientRect());!b.width&&(b.width=b.right-b.left);!b.height&&(b.height=b.bottom-b.top);return a?CKEDITOR.tools.getAbsoluteRectPosition(this.getWindow(),b):b},setHtml:CKEDITOR.env.ie&&9>CKEDITOR.env.version?function(a){try{var b=this.$;if(this.getParent())return b.innerHTML=a;var c=this.getDocument()._getHtml5ShivFrag();c.appendChild(b);b.innerHTML=a;c.removeChild(b);return a}catch(e){this.$.innerHTML="";b=new CKEDITOR.dom.element("body",this.getDocument());b.$.innerHTML=a;for(b=b.getChildren();b.count();)this.append(b.getItem(0));
return a}}:function(a){return this.$.innerHTML=a},setText:function(){var a=document.createElement("p");a.innerHTML="x";a=a.textContent;return function(b){this.$[a?"textContent":"innerText"]=b}}(),getAttribute:function(){var a=function(a){return this.$.getAttribute(a,2)};return CKEDITOR.env.ie&&(CKEDITOR.env.ie7Compat||CKEDITOR.env.quirks)?function(a){switch(a){case "class":a="className";break;case "http-equiv":a="httpEquiv";break;case "name":return this.$.name;case "tabindex":return a=this.$.getAttribute(a,
2),0!==a&&0===this.$.tabIndex&&(a=null),a;case "checked":return a=this.$.attributes.getNamedItem(a),(a.specified?a.nodeValue:this.$.checked)?"checked":null;case "hspace":case "value":return this.$[a];case "style":return this.$.style.cssText;case "contenteditable":case "contentEditable":return this.$.attributes.getNamedItem("contentEditable").specified?this.$.getAttribute("contentEditable"):null}return this.$.getAttribute(a,2)}:a}(),getAttributes:function(a){var b={},c=this.$.attributes,e;a=CKEDITOR.tools.isArray(a)?
a:[];for(e=0;e<c.length;e++)-1===CKEDITOR.tools.indexOf(a,c[e].name)&&(b[c[e].name]=c[e].value);return b},getChildren:function(){return new CKEDITOR.dom.nodeList(this.$.childNodes)},getClientSize:function(){return{width:this.$.clientWidth,height:this.$.clientHeight}},getComputedStyle:document.defaultView&&document.defaultView.getComputedStyle?function(a){var b=this.getWindow().$.getComputedStyle(this.$,null);return b?b.getPropertyValue(a):""}:function(a){return this.$.currentStyle[CKEDITOR.tools.cssStyleToDomStyle(a)]},
getDtd:function(){var a=CKEDITOR.dtd[this.getName()];this.getDtd=function(){return a};return a},getElementsByTag:CKEDITOR.dom.document.prototype.getElementsByTag,getTabIndex:function(){var a=this.$.tabIndex;return 0!==a||CKEDITOR.dtd.$tabIndex[this.getName()]||0===parseInt(this.getAttribute("tabindex"),10)?a:-1},getText:function(){return this.$.textContent||this.$.innerText||""},getWindow:function(){return this.getDocument().getWindow()},getId:function(){return this.$.id||null},getNameAtt:function(){return this.$.name||
null},getName:function(){var a=this.$.nodeName.toLowerCase();if(CKEDITOR.env.ie&&8>=document.documentMode){var b=this.$.scopeName;"HTML"!=b&&(a=b.toLowerCase()+":"+a)}this.getName=function(){return a};return this.getName()},getValue:function(){return this.$.value},getFirst:function(a){var b=this.$.firstChild;(b=b&&new CKEDITOR.dom.node(b))&&a&&!a(b)&&(b=b.getNext(a));return b},getLast:function(a){var b=this.$.lastChild;(b=b&&new CKEDITOR.dom.node(b))&&a&&!a(b)&&(b=b.getPrevious(a));return b},getStyle:function(a){return this.$.style[CKEDITOR.tools.cssStyleToDomStyle(a)]},
is:function(){var a=this.getName();if("object"==typeof arguments[0])return!!arguments[0][a];for(var b=0;b<arguments.length;b++)if(arguments[b]==a)return!0;return!1},isEditable:function(a){var b=this.getName();return this.isReadOnly()||"none"==this.getComputedStyle("display")||"hidden"==this.getComputedStyle("visibility")||CKEDITOR.dtd.$nonEditable[b]||CKEDITOR.dtd.$empty[b]||this.is("a")&&(this.data("cke-saved-name")||this.hasAttribute("name"))&&!this.getChildCount()?!1:!1!==a?(a=CKEDITOR.dtd[b]||
CKEDITOR.dtd.span,!(!a||!a["#"])):!0},isIdentical:function(a){var b=this.clone(0,1);a=a.clone(0,1);b.removeAttributes(["_moz_dirty","data-cke-expando","data-cke-saved-href","data-cke-saved-name"]);a.removeAttributes(["_moz_dirty","data-cke-expando","data-cke-saved-href","data-cke-saved-name"]);if(b.$.isEqualNode)return b.$.style.cssText=CKEDITOR.tools.normalizeCssText(b.$.style.cssText),a.$.style.cssText=CKEDITOR.tools.normalizeCssText(a.$.style.cssText),b.$.isEqualNode(a.$);b=b.getOuterHtml();a=
a.getOuterHtml();if(CKEDITOR.env.ie&&9>CKEDITOR.env.version&&this.is("a")){var c=this.getParent();c.type==CKEDITOR.NODE_ELEMENT&&(c=c.clone(),c.setHtml(b),b=c.getHtml(),c.setHtml(a),a=c.getHtml())}return b==a},isVisible:function(){var a=(this.$.offsetHeight||this.$.offsetWidth)&&"hidden"!=this.getComputedStyle("visibility"),b,c;a&&CKEDITOR.env.webkit&&(b=this.getWindow(),!b.equals(CKEDITOR.document.getWindow())&&(c=b.$.frameElement)&&(a=(new CKEDITOR.dom.element(c)).isVisible()));return!!a},isEmptyInlineRemoveable:function(){if(!CKEDITOR.dtd.$removeEmpty[this.getName()])return!1;
for(var a=this.getChildren(),b=0,c=a.count();b<c;b++){var e=a.getItem(b);if(e.type!=CKEDITOR.NODE_ELEMENT||!e.data("cke-bookmark"))if(e.type==CKEDITOR.NODE_ELEMENT&&!e.isEmptyInlineRemoveable()||e.type==CKEDITOR.NODE_TEXT&&CKEDITOR.tools.trim(e.getText()))return!1}return!0},hasAttributes:CKEDITOR.env.ie&&(CKEDITOR.env.ie7Compat||CKEDITOR.env.quirks)?function(){for(var a=this.$.attributes,b=0;b<a.length;b++){var c=a[b];switch(c.nodeName){case "class":if(this.getAttribute("class"))return!0;case "data-cke-expando":continue;
default:if(c.specified)return!0}}return!1}:function(){var a=this.$.attributes,b=a.length,c={"data-cke-expando":1,_moz_dirty:1};return 0<b&&(2<b||!c[a[0].nodeName]||2==b&&!c[a[1].nodeName])},hasAttribute:function(){function a(b){var c=this.$.attributes.getNamedItem(b);if("input"==this.getName())switch(b){case "class":return 0<this.$.className.length;case "checked":return!!this.$.checked;case "value":return b=this.getAttribute("type"),"checkbox"==b||"radio"==b?"on"!=this.$.value:!!this.$.value}return c?
c.specified:!1}return CKEDITOR.env.ie?8>CKEDITOR.env.version?function(b){return"name"==b?!!this.$.name:a.call(this,b)}:a:function(a){return!!this.$.attributes.getNamedItem(a)}}(),hide:function(){this.setStyle("display","none")},moveChildren:function(a,b){var c=this.$;a=a.$;if(c!=a){var e;if(b)for(;e=c.lastChild;)a.insertBefore(c.removeChild(e),a.firstChild);else for(;e=c.firstChild;)a.appendChild(c.removeChild(e))}},mergeSiblings:function(){function a(b,c,e){if(c&&c.type==CKEDITOR.NODE_ELEMENT){for(var d=
[];c.data("cke-bookmark")||c.isEmptyInlineRemoveable();)if(d.push(c),c=e?c.getNext():c.getPrevious(),!c||c.type!=CKEDITOR.NODE_ELEMENT)return;if(b.isIdentical(c)){for(var h=e?b.getLast():b.getFirst();d.length;)d.shift().move(b,!e);c.moveChildren(b,!e);c.remove();h&&h.type==CKEDITOR.NODE_ELEMENT&&h.mergeSiblings()}}}return function(b){if(!1===b||CKEDITOR.dtd.$removeEmpty[this.getName()]||this.is("a"))a(this,this.getNext(),!0),a(this,this.getPrevious())}}(),show:function(){this.setStyles({display:"",
visibility:""})},setAttribute:function(){var a=function(a,b){this.$.setAttribute(a,b);return this};return CKEDITOR.env.ie&&(CKEDITOR.env.ie7Compat||CKEDITOR.env.quirks)?function(b,c){"class"==b?this.$.className=c:"style"==b?this.$.style.cssText=c:"tabindex"==b?this.$.tabIndex=c:"checked"==b?this.$.checked=c:"contenteditable"==b?a.call(this,"contentEditable",c):a.apply(this,arguments);return this}:CKEDITOR.env.ie8Compat&&CKEDITOR.env.secure?function(b,c){if("src"==b&&c.match(/^http:\/\//))try{a.apply(this,
arguments)}catch(e){}else a.apply(this,arguments);return this}:a}(),setAttributes:function(a){for(var b in a)this.setAttribute(b,a[b]);return this},setValue:function(a){this.$.value=a;return this},removeAttribute:function(){var a=function(a){this.$.removeAttribute(a)};return CKEDITOR.env.ie&&(CKEDITOR.env.ie7Compat||CKEDITOR.env.quirks)?function(a){"class"==a?a="className":"tabindex"==a?a="tabIndex":"contenteditable"==a&&(a="contentEditable");this.$.removeAttribute(a)}:a}(),removeAttributes:function(a){if(CKEDITOR.tools.isArray(a))for(var b=
0;b<a.length;b++)this.removeAttribute(a[b]);else for(b in a=a||this.getAttributes(),a)a.hasOwnProperty(b)&&this.removeAttribute(b)},removeStyle:function(a){var b=this.$.style;if(b.removeProperty||"border"!=a&&"margin"!=a&&"padding"!=a)b.removeProperty?b.removeProperty(a):b.removeAttribute(CKEDITOR.tools.cssStyleToDomStyle(a)),this.$.style.cssText||this.removeAttribute("style");else{var c=["top","left","right","bottom"],e;"border"==a&&(e=["color","style","width"]);for(var b=[],d=0;d<c.length;d++)if(e)for(var f=
0;f<e.length;f++)b.push([a,c[d],e[f]].join("-"));else b.push([a,c[d]].join("-"));for(a=0;a<b.length;a++)this.removeStyle(b[a])}},setStyle:function(a,b){this.$.style[CKEDITOR.tools.cssStyleToDomStyle(a)]=b;return this},setStyles:function(a){for(var b in a)this.setStyle(b,a[b]);return this},setOpacity:function(a){CKEDITOR.env.ie&&9>CKEDITOR.env.version?(a=Math.round(100*a),this.setStyle("filter",100<=a?"":"progid:DXImageTransform.Microsoft.Alpha(opacity\x3d"+a+")")):this.setStyle("opacity",a)},unselectable:function(){this.setStyles(CKEDITOR.tools.cssVendorPrefix("user-select",
"none"));if(CKEDITOR.env.ie){this.setAttribute("unselectable","on");for(var a,b=this.getElementsByTag("*"),c=0,e=b.count();c<e;c++)a=b.getItem(c),a.setAttribute("unselectable","on")}},getPositionedAncestor:function(){for(var a=this;"html"!=a.getName();){if("static"!=a.getComputedStyle("position"))return a;a=a.getParent()}return null},getDocumentPosition:function(a){var b=0,c=0,e=this.getDocument(),d=e.getBody(),f="BackCompat"==e.$.compatMode;if(document.documentElement.getBoundingClientRect&&(CKEDITOR.env.ie?
8!==CKEDITOR.env.version:1)){var g=this.$.getBoundingClientRect(),l=e.$.documentElement,q=l.clientTop||d.$.clientTop||0,n=l.clientLeft||d.$.clientLeft||0,H=!0;CKEDITOR.env.ie&&(H=e.getDocumentElement().contains(this),e=e.getBody().contains(this),H=f&&e||!f&&H);H&&(CKEDITOR.env.webkit||CKEDITOR.env.ie&&12<=CKEDITOR.env.version?(b=d.$.scrollLeft||l.scrollLeft,c=d.$.scrollTop||l.scrollTop):(c=f?d.$:l,b=c.scrollLeft,c=c.scrollTop),b=g.left+b-n,c=g.top+c-q)}else for(q=this,n=null;q&&"body"!=q.getName()&&
"html"!=q.getName();){b+=q.$.offsetLeft-q.$.scrollLeft;c+=q.$.offsetTop-q.$.scrollTop;q.equals(this)||(b+=q.$.clientLeft||0,c+=q.$.clientTop||0);for(;n&&!n.equals(q);)b-=n.$.scrollLeft,c-=n.$.scrollTop,n=n.getParent();n=q;q=(g=q.$.offsetParent)?new CKEDITOR.dom.element(g):null}a&&(g=this.getWindow(),q=a.getWindow(),!g.equals(q)&&g.$.frameElement&&(a=(new CKEDITOR.dom.element(g.$.frameElement)).getDocumentPosition(a),b+=a.x,c+=a.y));document.documentElement.getBoundingClientRect||!CKEDITOR.env.gecko||
f||(b+=this.$.clientLeft?1:0,c+=this.$.clientTop?1:0);return{x:b,y:c}},scrollIntoView:function(a){var b=this.getParent();if(b){do if((b.$.clientWidth&&b.$.clientWidth<b.$.scrollWidth||b.$.clientHeight&&b.$.clientHeight<b.$.scrollHeight)&&!b.is("body")&&this.scrollIntoParent(b,a,1),b.is("html")){var c=b.getWindow();try{var e=c.$.frameElement;e&&(b=new CKEDITOR.dom.element(e))}catch(d){}}while(b=b.getParent())}},scrollIntoParent:function(a,b,c){var e,d,f,g;function l(b,c){/body|html/.test(a.getName())?
a.getWindow().$.scrollBy(b,c):(a.$.scrollLeft+=b,a.$.scrollTop+=c)}function q(a,b){var c={x:0,y:0};if(!a.is(H?"body":"html")){var e=a.$.getBoundingClientRect();c.x=e.left;c.y=e.top}e=a.getWindow();e.equals(b)||(e=q(CKEDITOR.dom.element.get(e.$.frameElement),b),c.x+=e.x,c.y+=e.y);return c}function n(a,b){return parseInt(a.getComputedStyle("margin-"+b)||0,10)||0}!a&&(a=this.getWindow());f=a.getDocument();var H="BackCompat"==f.$.compatMode;a instanceof CKEDITOR.dom.window&&(a=H?f.getBody():f.getDocumentElement());
CKEDITOR.env.webkit&&(f=this.getEditor(!1))&&(f._.previousScrollTop=null);f=a.getWindow();d=q(this,f);var x=q(a,f),I=this.$.offsetHeight;e=this.$.offsetWidth;var K=a.$.clientHeight,m=a.$.clientWidth;f=d.x-n(this,"left")-x.x||0;g=d.y-n(this,"top")-x.y||0;e=d.x+e+n(this,"right")-(x.x+m)||0;d=d.y+I+n(this,"bottom")-(x.y+K)||0;(0>g||0<d)&&l(0,!0===b?g:!1===b?d:0>g?g:d);c&&(0>f||0<e)&&l(0>f?f:e,0)},setState:function(a,b,c){b=b||"cke";switch(a){case CKEDITOR.TRISTATE_ON:this.addClass(b+"_on");this.removeClass(b+
"_off");this.removeClass(b+"_disabled");c&&this.setAttribute("aria-pressed",!0);c&&this.removeAttribute("aria-disabled");break;case CKEDITOR.TRISTATE_DISABLED:this.addClass(b+"_disabled");this.removeClass(b+"_off");this.removeClass(b+"_on");c&&this.setAttribute("aria-disabled",!0);c&&this.removeAttribute("aria-pressed");break;default:this.addClass(b+"_off"),this.removeClass(b+"_on"),this.removeClass(b+"_disabled"),c&&this.removeAttribute("aria-pressed"),c&&this.removeAttribute("aria-disabled")}},
getFrameDocument:function(){var a=this.$;try{a.contentWindow.document}catch(b){a.src=a.src}return a&&new CKEDITOR.dom.document(a.contentWindow.document)},copyAttributes:function(a,b){var c=this.$.attributes;b=b||{};for(var e=0;e<c.length;e++){var d=c[e],f=d.nodeName.toLowerCase(),g;if(!(f in b))if("checked"==f&&(g=this.getAttribute(f)))a.setAttribute(f,g);else if(!CKEDITOR.env.ie||this.hasAttribute(f))g=this.getAttribute(f),null===g&&(g=d.nodeValue),a.setAttribute(f,g)}""!==this.$.style.cssText&&
(a.$.style.cssText=this.$.style.cssText)},renameNode:function(a){if(this.getName()!=a){var b=this.getDocument();a=new CKEDITOR.dom.element(a,b);this.copyAttributes(a);this.moveChildren(a);this.getParent(!0)&&this.$.parentNode.replaceChild(a.$,this.$);a.$["data-cke-expando"]=this.$["data-cke-expando"];this.$=a.$;delete this.getName}},getChild:function(){function a(b,c){var e=b.childNodes;if(0<=c&&c<e.length)return e[c]}return function(b){var c=this.$;if(b.slice)for(b=b.slice();0<b.length&&c;)c=a(c,
b.shift());else c=a(c,b);return c?new CKEDITOR.dom.node(c):null}}(),getChildCount:function(){return this.$.childNodes.length},disableContextMenu:function(){function a(b){return b.type==CKEDITOR.NODE_ELEMENT&&b.hasClass("cke_enable_context_menu")}this.on("contextmenu",function(b){b.data.getTarget().getAscendant(a,!0)||b.data.preventDefault()})},getDirection:function(a){return a?this.getComputedStyle("direction")||this.getDirection()||this.getParent()&&this.getParent().getDirection(1)||this.getDocument().$.dir||
"ltr":this.getStyle("direction")||this.getAttribute("dir")},data:function(a,b){a="data-"+a;if(void 0===b)return this.getAttribute(a);!1===b?this.removeAttribute(a):this.setAttribute(a,b);return null},getEditor:function(a){var b=CKEDITOR.instances,c,e,d;a=a||void 0===a;for(c in b)if(e=b[c],e.element.equals(this)&&e.elementMode!=CKEDITOR.ELEMENT_MODE_APPENDTO||!a&&(d=e.editable())&&(d.equals(this)||d.contains(this)))return e;return null},find:function(a){var c=d(this);a=new CKEDITOR.dom.nodeList(this.$.querySelectorAll(b(this,
a)));c();return a},findOne:function(a){var c=d(this);a=this.$.querySelector(b(this,a));c();return a?new CKEDITOR.dom.element(a):null},forEach:function(a,b,c){if(!(c||b&&this.type!=b))var e=a(this);if(!1!==e){c=this.getChildren();for(var d=0;d<c.count();d++)e=c.getItem(d),e.type==CKEDITOR.NODE_ELEMENT?e.forEach(a,b):b&&e.type!=b||a(e)}},fireEventHandler:function(a,b){var c="on"+a,e=this.$;if(CKEDITOR.env.ie&&9>CKEDITOR.env.version){var d=e.ownerDocument.createEventObject(),f;for(f in b)d[f]=b[f];e.fireEvent(c,
d)}else e[e[a]?a:c](b)},isDetached:function(){var a=this.getDocument(),b=a.getDocumentElement();return b.equals(this)||b.contains(this)?!CKEDITOR.env.ie||8<CKEDITOR.env.version&&!CKEDITOR.env.quirks?!a.$.defaultView:!1:!0}});var l={width:["border-left-width","border-right-width","padding-left","padding-right"],height:["border-top-width","border-bottom-width","padding-top","padding-bottom"]};CKEDITOR.dom.element.prototype.setSize=function(a,b,d){"number"==typeof b&&(!d||CKEDITOR.env.ie&&CKEDITOR.env.quirks||
(b-=c.call(this,a)),this.setStyle(a,b+"px"))};CKEDITOR.dom.element.prototype.getSize=function(a,b){var d=Math.max(this.$["offset"+CKEDITOR.tools.capitalize(a)],this.$["client"+CKEDITOR.tools.capitalize(a)])||0;b&&(d-=c.call(this,a));return d}})();CKEDITOR.dom.documentFragment=function(a){a=a||CKEDITOR.document;this.$=a.type==CKEDITOR.NODE_DOCUMENT?a.$.createDocumentFragment():a};
CKEDITOR.tools.extend(CKEDITOR.dom.documentFragment.prototype,CKEDITOR.dom.element.prototype,{type:CKEDITOR.NODE_DOCUMENT_FRAGMENT,insertAfterNode:function(a){a=a.$;a.parentNode.insertBefore(this.$,a.nextSibling)},getHtml:function(){var a=new CKEDITOR.dom.element("div");this.clone(1,1).appendTo(a);return a.getHtml().replace(/\s*data-cke-expando=".*?"/g,"")}},!0,{append:1,appendBogus:1,clone:1,getFirst:1,getHtml:1,getLast:1,getParent:1,getNext:1,getPrevious:1,appendTo:1,moveChildren:1,insertBefore:1,
insertAfterNode:1,replace:1,trim:1,type:1,ltrim:1,rtrim:1,getDocument:1,getChildCount:1,getChild:1,getChildren:1});CKEDITOR.tools.extend(CKEDITOR.dom.documentFragment.prototype,CKEDITOR.dom.document.prototype,!0,{find:1,findOne:1});
(function(){function a(a,b){var c=this.range;if(this._.end)return null;if(!this._.start){this._.start=1;if(c.collapsed)return this.end(),null;c.optimize()}var e,d=c.startContainer;e=c.endContainer;var f=c.startOffset,g=c.endOffset,h,z=this.guard,m=this.type,l=a?"getPreviousSourceNode":"getNextSourceNode";if(!a&&!this._.guardLTR){var M=e.type==CKEDITOR.NODE_ELEMENT?e:e.getParent(),A=e.type==CKEDITOR.NODE_ELEMENT?e.getChild(g):e.getNext();this._.guardLTR=function(a,b){return(!b||!M.equals(a))&&(!A||
!a.equals(A))&&(a.type!=CKEDITOR.NODE_ELEMENT||!b||!a.equals(c.root))}}if(a&&!this._.guardRTL){var N=d.type==CKEDITOR.NODE_ELEMENT?d:d.getParent(),r=d.type==CKEDITOR.NODE_ELEMENT?f?d.getChild(f-1):null:d.getPrevious();this._.guardRTL=function(a,b){return(!b||!N.equals(a))&&(!r||!a.equals(r))&&(a.type!=CKEDITOR.NODE_ELEMENT||!b||!a.equals(c.root))}}var E=a?this._.guardRTL:this._.guardLTR;h=z?function(a,b){return!1===E(a,b)?!1:z(a,b)}:E;this.current?e=this.current[l](!1,m,h):(a?e.type==CKEDITOR.NODE_ELEMENT&&
(e=0<g?e.getChild(g-1):!1===h(e,!0)?null:e.getPreviousSourceNode(!0,m,h)):(e=d,e.type==CKEDITOR.NODE_ELEMENT&&((e=e.getChild(f))||(e=!1===h(d,!0)?null:d.getNextSourceNode(!0,m,h)))),e&&!1===h(e)&&(e=null));for(;e&&!this._.end;){this.current=e;if(!this.evaluator||!1!==this.evaluator(e)){if(!b)return e}else if(b&&this.evaluator)return!1;e=e[l](!1,m,h)}this.end();return this.current=null}function d(b){for(var c,e=null;c=a.call(this,b);)e=c;return e}CKEDITOR.dom.walker=CKEDITOR.tools.createClass({$:function(a){this.range=
a;this._={}},proto:{end:function(){this._.end=1},next:function(){return a.call(this)},previous:function(){return a.call(this,1)},checkForward:function(){return!1!==a.call(this,0,1)},checkBackward:function(){return!1!==a.call(this,1,1)},lastForward:function(){return d.call(this)},lastBackward:function(){return d.call(this,1)},reset:function(){delete this.current;this._={}}}});var b={block:1,"list-item":1,table:1,"table-row-group":1,"table-header-group":1,"table-footer-group":1,"table-row":1,"table-column-group":1,
"table-column":1,"table-cell":1,"table-caption":1},c={absolute:1,fixed:1};CKEDITOR.dom.element.prototype.isBlockBoundary=function(a){return"none"!=this.getComputedStyle("float")||this.getComputedStyle("position")in c||!b[this.getComputedStyle("display")]?!!(this.is(CKEDITOR.dtd.$block)||a&&this.is(a)):!0};CKEDITOR.dom.walker.blockBoundary=function(a){return function(b){return!(b.type==CKEDITOR.NODE_ELEMENT&&b.isBlockBoundary(a))}};CKEDITOR.dom.walker.listItemBoundary=function(){return this.blockBoundary({br:1})};
CKEDITOR.dom.walker.bookmark=function(a,b){function c(a){return a&&a.getName&&"span"==a.getName()&&a.data("cke-bookmark")}return function(e){var d,f;d=e&&e.type!=CKEDITOR.NODE_ELEMENT&&(f=e.getParent())&&c(f);d=a?d:d||c(e);return!!(b^d)}};CKEDITOR.dom.walker.whitespaces=function(a){return function(b){var c;b&&b.type==CKEDITOR.NODE_TEXT&&(c=!CKEDITOR.tools.trim(b.getText())||CKEDITOR.env.webkit&&b.getText()==CKEDITOR.dom.selection.FILLING_CHAR_SEQUENCE);return!!(a^c)}};CKEDITOR.dom.walker.invisible=
function(a){var b=CKEDITOR.dom.walker.whitespaces(),c=CKEDITOR.env.webkit?1:0;return function(e){b(e)?e=1:(e.type==CKEDITOR.NODE_TEXT&&(e=e.getParent()),e=e.$.offsetWidth<=c);return!!(a^e)}};CKEDITOR.dom.walker.nodeType=function(a,b){return function(c){return!!(b^c.type==a)}};CKEDITOR.dom.walker.bogus=function(a){function b(a){return!f(a)&&!l(a)}return function(c){var e=CKEDITOR.env.needsBrFiller?c.is&&c.is("br"):c.getText&&g.test(c.getText());e&&(e=c.getParent(),c=c.getNext(b),e=e.isBlockBoundary()&&
(!c||c.type==CKEDITOR.NODE_ELEMENT&&c.isBlockBoundary()));return!!(a^e)}};CKEDITOR.dom.walker.temp=function(a){return function(b){b.type!=CKEDITOR.NODE_ELEMENT&&(b=b.getParent());b=b&&b.hasAttribute("data-cke-temp");return!!(a^b)}};var g=/^[\t\r\n ]*(?:&nbsp;|\xa0)$/,f=CKEDITOR.dom.walker.whitespaces(),l=CKEDITOR.dom.walker.bookmark(),h=CKEDITOR.dom.walker.temp(),k=function(a){return l(a)||f(a)||a.type==CKEDITOR.NODE_ELEMENT&&a.is(CKEDITOR.dtd.$inline)&&!a.is(CKEDITOR.dtd.$empty)};CKEDITOR.dom.walker.ignored=
function(a){return function(b){b=f(b)||l(b)||h(b);return!!(a^b)}};var p=CKEDITOR.dom.walker.ignored();CKEDITOR.dom.walker.empty=function(a){return function(b){for(var c=0,e=b.getChildCount();c<e;++c)if(!p(b.getChild(c)))return!!a;return!a}};var e=CKEDITOR.dom.walker.empty(),z=CKEDITOR.dom.walker.validEmptyBlockContainers=CKEDITOR.tools.extend(function(a){var b={},c;for(c in a)CKEDITOR.dtd[c]["#"]&&(b[c]=1);return b}(CKEDITOR.dtd.$block),{caption:1,td:1,th:1});CKEDITOR.dom.walker.editable=function(a){return function(b){b=
p(b)?!1:b.type==CKEDITOR.NODE_TEXT||b.type==CKEDITOR.NODE_ELEMENT&&(b.is(CKEDITOR.dtd.$inline)||b.is("hr")||"false"==b.getAttribute("contenteditable")||!CKEDITOR.env.needsBrFiller&&b.is(z)&&e(b))?!0:!1;return!!(a^b)}};CKEDITOR.dom.element.prototype.getBogus=function(){var a=this;do a=a.getPreviousSourceNode();while(k(a));return a&&(CKEDITOR.env.needsBrFiller?a.is&&a.is("br"):a.getText&&g.test(a.getText()))?a:!1}})();
CKEDITOR.dom.range=function(a){this.endOffset=this.endContainer=this.startOffset=this.startContainer=null;this.collapsed=!0;var d=a instanceof CKEDITOR.dom.document;this.document=d?a:a.getDocument();this.root=d?a.getBody():a};
(function(){function a(a){a.collapsed=a.startContainer&&a.endContainer&&a.startContainer.equals(a.endContainer)&&a.startOffset==a.endOffset}function d(a,b,c,d,f){function g(a,b,c,e){var C=c?a.getPrevious():a.getNext();if(e&&l)return C;k||e?b.append(a.clone(!0,f),c):(a.remove(),p&&b.append(a,c));return C}function n(){var a,b,c,e=Math.min(T.length,t.length);for(a=0;a<e;a++)if(b=T[a],c=t[a],!b.equals(c))return a;return a-1}function h(){var b=P-1,c=E&&D&&!m.equals(F);b<J-1||b<v-1||c?(c?a.moveToPosition(F,
CKEDITOR.POSITION_BEFORE_START):v==b+1&&r?a.moveToPosition(t[b],CKEDITOR.POSITION_BEFORE_END):a.moveToPosition(t[b+1],CKEDITOR.POSITION_BEFORE_START),d&&(b=T[b+1])&&b.type==CKEDITOR.NODE_ELEMENT&&(c=CKEDITOR.dom.element.createFromHtml('\x3cspan data-cke-bookmark\x3d"1" style\x3d"display:none"\x3e\x26nbsp;\x3c/span\x3e',a.document),c.insertAfter(b),b.mergeSiblings(!1),a.moveToBookmark({startNode:c}))):a.collapse(!0)}a.optimizeBookmark();var l=0===b,p=1==b,k=2==b;b=k||p;var m=a.startContainer,F=a.endContainer,
M=a.startOffset,A=a.endOffset,N,r,E,D,u,S;if(k&&F.type==CKEDITOR.NODE_TEXT&&(m.equals(F)||m.type===CKEDITOR.NODE_ELEMENT&&m.getFirst().equals(F)))c.append(a.document.createText(F.substring(M,A)));else{F.type==CKEDITOR.NODE_TEXT?k?S=!0:F=F.split(A):0<F.getChildCount()?A>=F.getChildCount()?(F=F.getChild(A-1),r=!0):F=F.getChild(A):D=r=!0;m.type==CKEDITOR.NODE_TEXT?k?u=!0:m.split(M):0<m.getChildCount()?0===M?(m=m.getChild(M),N=!0):m=m.getChild(M-1):E=N=!0;for(var T=m.getParents(),t=F.getParents(),P=n(),
J=T.length-1,v=t.length-1,B=c,C,ba,L,da=-1,U=P;U<=J;U++){ba=T[U];L=ba.getNext();for(U!=J||ba.equals(t[U])&&J<v?b&&(C=B.append(ba.clone(0,f))):N?g(ba,B,!1,E):u&&B.append(a.document.createText(ba.substring(M)));L;){if(L.equals(t[U])){da=U;break}L=g(L,B)}B=C}B=c;for(U=P;U<=v;U++)if(c=t[U],L=c.getPrevious(),c.equals(T[U]))b&&(B=B.getChild(0));else{U!=v||c.equals(T[U])&&v<J?b&&(C=B.append(c.clone(0,f))):r?g(c,B,!1,D):S&&B.append(a.document.createText(c.substring(0,A)));if(U>da)for(;L;)L=g(L,B,!0);B=C}k||
h()}}function b(){var a=!1,b=CKEDITOR.dom.walker.whitespaces(),c=CKEDITOR.dom.walker.bookmark(!0),d=CKEDITOR.dom.walker.bogus();return function(g){return c(g)||b(g)?!0:d(g)&&!a?a=!0:g.type==CKEDITOR.NODE_TEXT&&(g.hasAscendant("pre")||CKEDITOR.tools.trim(g.getText()).length)||g.type==CKEDITOR.NODE_ELEMENT&&!g.is(f)?!1:!0}}function c(a){var b=CKEDITOR.dom.walker.whitespaces(),c=CKEDITOR.dom.walker.bookmark(1);return function(d){return c(d)||b(d)?!0:!a&&l(d)||d.type==CKEDITOR.NODE_ELEMENT&&d.is(CKEDITOR.dtd.$removeEmpty)}}
function g(a){return function(){var b;return this[a?"getPreviousNode":"getNextNode"](function(a){!b&&p(a)&&(b=a);return k(a)&&!(l(a)&&a.equals(b))})}}var f={abbr:1,acronym:1,b:1,bdo:1,big:1,cite:1,code:1,del:1,dfn:1,em:1,font:1,i:1,ins:1,label:1,kbd:1,q:1,samp:1,small:1,span:1,strike:1,strong:1,sub:1,sup:1,tt:1,u:1,"var":1},l=CKEDITOR.dom.walker.bogus(),h=/^[\t\r\n ]*(?:&nbsp;|\xa0)$/,k=CKEDITOR.dom.walker.editable(),p=CKEDITOR.dom.walker.ignored(!0);CKEDITOR.dom.range.prototype={clone:function(){var a=
new CKEDITOR.dom.range(this.root);a._setStartContainer(this.startContainer);a.startOffset=this.startOffset;a._setEndContainer(this.endContainer);a.endOffset=this.endOffset;a.collapsed=this.collapsed;return a},collapse:function(a){a?(this._setEndContainer(this.startContainer),this.endOffset=this.startOffset):(this._setStartContainer(this.endContainer),this.startOffset=this.endOffset);this.collapsed=!0},cloneContents:function(a){var b=new CKEDITOR.dom.documentFragment(this.document);this.collapsed||
d(this,2,b,!1,"undefined"==typeof a?!0:a);return b},deleteContents:function(a){this.collapsed||d(this,0,null,a)},extractContents:function(a,b){var c=new CKEDITOR.dom.documentFragment(this.document);this.collapsed||d(this,1,c,a,"undefined"==typeof b?!0:b);return c},equals:function(a){return this.startOffset===a.startOffset&&this.endOffset===a.endOffset&&this.startContainer.equals(a.startContainer)&&this.endContainer.equals(a.endContainer)},createBookmark:function(a){function b(a){return a.getAscendant(function(a){var b;
if(b=a.data&&a.data("cke-temp"))b=-1===CKEDITOR.tools.array.indexOf(["cke_copybin","cke_pastebin"],a.getAttribute("id"));return b},!0)}var c=this.startContainer,d=this.endContainer,f=this.collapsed,g,n,h,l;g=this.document.createElement("span");g.data("cke-bookmark",1);g.setStyle("display","none");g.setHtml("\x26nbsp;");a&&(h="cke_bm_"+CKEDITOR.tools.getNextNumber(),g.setAttribute("id",h+(f?"C":"S")));f||(n=g.clone(),n.setHtml("\x26nbsp;"),a&&n.setAttribute("id",h+"E"),l=this.clone(),b(d)&&(d=b(d),
l.moveToPosition(d,CKEDITOR.POSITION_AFTER_END)),l.collapse(),l.insertNode(n));l=this.clone();b(c)&&(d=b(c),l.moveToPosition(d,CKEDITOR.POSITION_BEFORE_START));l.collapse(!0);l.insertNode(g);n?(this.setStartAfter(g),this.setEndBefore(n)):this.moveToPosition(g,CKEDITOR.POSITION_AFTER_END);return{startNode:a?h+(f?"C":"S"):g,endNode:a?h+"E":n,serializable:a,collapsed:f}},createBookmark2:function(){function a(b){var e=b.container,d=b.offset,f;f=e;var g=d;f=f.type!=CKEDITOR.NODE_ELEMENT||0===g||g==f.getChildCount()?
0:f.getChild(g-1).type==CKEDITOR.NODE_TEXT&&f.getChild(g).type==CKEDITOR.NODE_TEXT;f&&(e=e.getChild(d-1),d=e.getLength());if(e.type==CKEDITOR.NODE_ELEMENT&&0<d){a:{for(f=e;d--;)if(g=f.getChild(d).getIndex(!0),0<=g){d=g;break a}d=-1}d+=1}if(e.type==CKEDITOR.NODE_TEXT){f=e;for(g=0;(f=f.getPrevious())&&f.type==CKEDITOR.NODE_TEXT;)g+=f.getText().replace(CKEDITOR.dom.selection.FILLING_CHAR_SEQUENCE,"").length;f=g;e.isEmpty()?(g=e.getPrevious(c),f?(d=f,e=g?g.getNext():e.getParent().getFirst()):(e=e.getParent(),
d=g?g.getIndex(!0)+1:0)):d+=f}b.container=e;b.offset=d}function b(a,c){var e=c.getCustomData("cke-fillingChar");if(e){var d=a.container;e.equals(d)&&(a.offset-=CKEDITOR.dom.selection.FILLING_CHAR_SEQUENCE.length,0>=a.offset&&(a.offset=d.getIndex(),a.container=d.getParent()))}}var c=CKEDITOR.dom.walker.nodeType(CKEDITOR.NODE_TEXT,!0);return function(c){var d=this.collapsed,f={container:this.startContainer,offset:this.startOffset},n={container:this.endContainer,offset:this.endOffset};c&&(a(f),b(f,this.root),
d||(a(n),b(n,this.root)));return{start:f.container.getAddress(c),end:d?null:n.container.getAddress(c),startOffset:f.offset,endOffset:n.offset,normalized:c,collapsed:d,is2:!0}}}(),moveToBookmark:function(a){if(a.is2){var b=this.document.getByAddress(a.start,a.normalized),c=a.startOffset,d=a.end&&this.document.getByAddress(a.end,a.normalized);a=a.endOffset;this.setStart(b,c);d?this.setEnd(d,a):this.collapse(!0)}else b=(c=a.serializable)?this.document.getById(a.startNode):a.startNode,a=c?this.document.getById(a.endNode):
a.endNode,this.setStartBefore(b),b.remove(),a?(this.setEndBefore(a),a.remove()):this.collapse(!0)},getBoundaryNodes:function(){var a=this.startContainer,b=this.endContainer,c=this.startOffset,d=this.endOffset,f;if(a.type==CKEDITOR.NODE_ELEMENT)if(f=a.getChildCount(),f>c)a=a.getChild(c);else if(1>f)a=a.getPreviousSourceNode();else{for(a=a.$;a.lastChild;)a=a.lastChild;a=new CKEDITOR.dom.node(a);a=a.getNextSourceNode()||a}if(b.type==CKEDITOR.NODE_ELEMENT)if(f=b.getChildCount(),f>d)b=b.getChild(d).getPreviousSourceNode(!0);
else if(1>f)b=b.getPreviousSourceNode();else{for(b=b.$;b.lastChild;)b=b.lastChild;b=new CKEDITOR.dom.node(b)}a.getPosition(b)&CKEDITOR.POSITION_FOLLOWING&&(a=b);return{startNode:a,endNode:b}},getCommonAncestor:function(a,b){var c=this.startContainer,d=this.endContainer,c=c.equals(d)?a&&c.type==CKEDITOR.NODE_ELEMENT&&this.startOffset==this.endOffset-1?c.getChild(this.startOffset):c:c.getCommonAncestor(d);return b&&!c.is?c.getParent():c},optimize:function(){var a=this.startContainer,b=this.startOffset;
a.type!=CKEDITOR.NODE_ELEMENT&&(b?b>=a.getLength()&&this.setStartAfter(a):this.setStartBefore(a));a=this.endContainer;b=this.endOffset;a.type!=CKEDITOR.NODE_ELEMENT&&(b?b>=a.getLength()&&this.setEndAfter(a):this.setEndBefore(a))},optimizeBookmark:function(){var a=this.startContainer,b=this.endContainer;a.is&&a.is("span")&&a.data("cke-bookmark")&&this.setStartAt(a,CKEDITOR.POSITION_BEFORE_START);b&&b.is&&b.is("span")&&b.data("cke-bookmark")&&this.setEndAt(b,CKEDITOR.POSITION_AFTER_END)},trim:function(a,
b){var c=this.startContainer,d=this.startOffset,f=this.collapsed;if((!a||f)&&c&&c.type==CKEDITOR.NODE_TEXT){if(d)if(d>=c.getLength())d=c.getIndex()+1,c=c.getParent();else{var g=c.split(d),d=c.getIndex()+1,c=c.getParent();this.startContainer.equals(this.endContainer)?this.setEnd(g,this.endOffset-this.startOffset):c.equals(this.endContainer)&&(this.endOffset+=1)}else d=c.getIndex(),c=c.getParent();this.setStart(c,d);if(f){this.collapse(!0);return}}c=this.endContainer;d=this.endOffset;b||f||!c||c.type!=
CKEDITOR.NODE_TEXT||(d?(d>=c.getLength()||c.split(d),d=c.getIndex()+1):d=c.getIndex(),c=c.getParent(),this.setEnd(c,d))},enlarge:function(a,b){function c(a){return a&&a.type==CKEDITOR.NODE_ELEMENT&&a.hasAttribute("contenteditable")?null:a}var d=new RegExp(/[^\s\ufeff]/);switch(a){case CKEDITOR.ENLARGE_INLINE:var f=1;case CKEDITOR.ENLARGE_ELEMENT:var g=function(a,b){var c=new CKEDITOR.dom.range(h);c.setStart(a,b);c.setEndAt(h,CKEDITOR.POSITION_BEFORE_END);var c=new CKEDITOR.dom.walker(c),e;for(c.guard=
function(a){return!(a.type==CKEDITOR.NODE_ELEMENT&&a.isBlockBoundary())};e=c.next();){if(e.type!=CKEDITOR.NODE_TEXT)return!1;N=e!=a?e.getText():e.substring(b);if(d.test(N))return!1}return!0};if(this.collapsed)break;var n=this.getCommonAncestor(),h=this.root,l,p,k,m,F,M=!1,A,N;A=this.startContainer;var r=this.startOffset;A.type==CKEDITOR.NODE_TEXT?(r&&(A=!CKEDITOR.tools.trim(A.substring(0,r)).length&&A,M=!!A),A&&((m=A.getPrevious())||(k=A.getParent()))):(r&&(m=A.getChild(r-1)||A.getLast()),m||(k=A));
for(k=c(k);k||m;){if(k&&!m){!F&&k.equals(n)&&(F=!0);if(f?k.isBlockBoundary():!h.contains(k))break;M&&"inline"==k.getComputedStyle("display")||(M=!1,F?l=k:this.setStartBefore(k));m=k.getPrevious()}for(;m;)if(A=!1,m.type==CKEDITOR.NODE_COMMENT)m=m.getPrevious();else{if(m.type==CKEDITOR.NODE_TEXT)N=m.getText(),d.test(N)&&(m=null),A=/[\s\ufeff]$/.test(N);else if((m.$.offsetWidth>(CKEDITOR.env.webkit?1:0)||b&&m.is("br"))&&!m.data("cke-bookmark"))if(M&&CKEDITOR.dtd.$removeEmpty[m.getName()]){N=m.getText();
if(d.test(N))m=null;else for(var r=m.$.getElementsByTagName("*"),E=0,D;D=r[E++];)if(!CKEDITOR.dtd.$removeEmpty[D.nodeName.toLowerCase()]){m=null;break}m&&(A=!!N.length)}else m=null;A&&(M?F?l=k:k&&this.setStartBefore(k):M=!0);if(m){A=m.getPrevious();if(!k&&!A){k=m;m=null;break}m=A}else k=null}k&&(k=c(k.getParent()))}A=this.endContainer;r=this.endOffset;k=m=null;F=M=!1;A.type==CKEDITOR.NODE_TEXT?CKEDITOR.tools.trim(A.substring(r)).length?M=!0:(M=!A.getLength(),r==A.getLength()?(m=A.getNext())||(k=A.getParent()):
g(A,r)&&(k=A.getParent())):(m=A.getChild(r))||(k=A);for(;k||m;){if(k&&!m){!F&&k.equals(n)&&(F=!0);if(f?k.isBlockBoundary():!h.contains(k))break;M&&"inline"==k.getComputedStyle("display")||(M=!1,F?p=k:k&&this.setEndAfter(k));m=k.getNext()}for(;m;){A=!1;if(m.type==CKEDITOR.NODE_TEXT)N=m.getText(),g(m,0)||(m=null),A=/^[\s\ufeff]/.test(N);else if(m.type==CKEDITOR.NODE_ELEMENT){if((0<m.$.offsetWidth||b&&m.is("br"))&&!m.data("cke-bookmark"))if(M&&CKEDITOR.dtd.$removeEmpty[m.getName()]){N=m.getText();if(d.test(N))m=
null;else for(r=m.$.getElementsByTagName("*"),E=0;D=r[E++];)if(!CKEDITOR.dtd.$removeEmpty[D.nodeName.toLowerCase()]){m=null;break}m&&(A=!!N.length)}else m=null}else A=1;A&&M&&(F?p=k:this.setEndAfter(k));if(m){A=m.getNext();if(!k&&!A){k=m;m=null;break}m=A}else k=null}k&&(k=c(k.getParent()))}l&&p&&(n=l.contains(p)?p:l,this.setStartBefore(n),this.setEndAfter(n));break;case CKEDITOR.ENLARGE_BLOCK_CONTENTS:case CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS:k=new CKEDITOR.dom.range(this.root);h=this.root;k.setStartAt(h,
CKEDITOR.POSITION_AFTER_START);k.setEnd(this.startContainer,this.startOffset);k=new CKEDITOR.dom.walker(k);var u,S,T=CKEDITOR.dom.walker.blockBoundary(a==CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS?{br:1}:null),t=null,P=function(a){if(a.type==CKEDITOR.NODE_ELEMENT&&"false"==a.getAttribute("contenteditable"))if(t){if(t.equals(a)){t=null;return}}else t=a;else if(t)return;var b=T(a);b||(u=a);return b},f=function(a){var b=P(a);!b&&a.is&&a.is("br")&&(S=a);return b};k.guard=P;k=k.lastBackward();u=u||h;this.setStartAt(u,
!u.is("br")&&(!k&&this.checkStartOfBlock()||k&&u.contains(k))?CKEDITOR.POSITION_AFTER_START:CKEDITOR.POSITION_AFTER_END);if(a==CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS){k=this.clone();k=new CKEDITOR.dom.walker(k);var J=CKEDITOR.dom.walker.whitespaces(),v=CKEDITOR.dom.walker.bookmark();k.evaluator=function(a){return!J(a)&&!v(a)};if((k=k.previous())&&k.type==CKEDITOR.NODE_ELEMENT&&k.is("br"))break}k=this.clone();k.collapse();k.setEndAt(h,CKEDITOR.POSITION_BEFORE_END);k=new CKEDITOR.dom.walker(k);k.guard=
a==CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS?f:P;u=t=S=null;k=k.lastForward();u=u||h;this.setEndAt(u,!k&&this.checkEndOfBlock()||k&&u.contains(k)?CKEDITOR.POSITION_BEFORE_END:CKEDITOR.POSITION_BEFORE_START);S&&this.setEndAfter(S)}},shrink:function(a,b,c){var d="boolean"===typeof c?c:c&&"boolean"===typeof c.shrinkOnBlockBoundary?c.shrinkOnBlockBoundary:!0,f=c&&c.skipBogus;if(!this.collapsed){a=a||CKEDITOR.SHRINK_TEXT;var g=this.clone(),n=this.startContainer,h=this.endContainer,l=this.startOffset,k=this.endOffset,
p=c=1;n&&n.type==CKEDITOR.NODE_TEXT&&(l?l>=n.getLength()?g.setStartAfter(n):(g.setStartBefore(n),c=0):g.setStartBefore(n));h&&h.type==CKEDITOR.NODE_TEXT&&(k?k>=h.getLength()?g.setEndAfter(h):(g.setEndAfter(h),p=0):g.setEndBefore(h));var g=new CKEDITOR.dom.walker(g),m=CKEDITOR.dom.walker.bookmark(),F=CKEDITOR.dom.walker.bogus();g.evaluator=function(b){return b.type==(a==CKEDITOR.SHRINK_ELEMENT?CKEDITOR.NODE_ELEMENT:CKEDITOR.NODE_TEXT)};var M;g.guard=function(b,c){if(f&&F(b)||m(b))return!0;if(a==CKEDITOR.SHRINK_ELEMENT&&
b.type==CKEDITOR.NODE_TEXT||c&&b.equals(M)||!1===d&&b.type==CKEDITOR.NODE_ELEMENT&&b.isBlockBoundary()||b.type==CKEDITOR.NODE_ELEMENT&&b.hasAttribute("contenteditable"))return!1;c||b.type!=CKEDITOR.NODE_ELEMENT||(M=b);return!0};c&&(n=g[a==CKEDITOR.SHRINK_ELEMENT?"lastForward":"next"]())&&this.setStartAt(n,b?CKEDITOR.POSITION_AFTER_START:CKEDITOR.POSITION_BEFORE_START);p&&(g.reset(),(g=g[a==CKEDITOR.SHRINK_ELEMENT?"lastBackward":"previous"]())&&this.setEndAt(g,b?CKEDITOR.POSITION_BEFORE_END:CKEDITOR.POSITION_AFTER_END));
return!(!c&&!p)}},insertNode:function(a){this.optimizeBookmark();this.trim(!1,!0);var b=this.startContainer,c=b.getChild(this.startOffset);c?a.insertBefore(c):b.append(a);a.getParent()&&a.getParent().equals(this.endContainer)&&this.endOffset++;this.setStartBefore(a)},moveToPosition:function(a,b){this.setStartAt(a,b);this.collapse(!0)},moveToRange:function(a){this.setStart(a.startContainer,a.startOffset);this.setEnd(a.endContainer,a.endOffset)},selectNodeContents:function(a){this.setStart(a,0);this.setEnd(a,
a.type==CKEDITOR.NODE_TEXT?a.getLength():a.getChildCount())},setStart:function(b,c){b.type==CKEDITOR.NODE_ELEMENT&&CKEDITOR.dtd.$empty[b.getName()]&&(c=b.getIndex(),b=b.getParent());this._setStartContainer(b);this.startOffset=c;this.endContainer||(this._setEndContainer(b),this.endOffset=c);a(this)},setEnd:function(b,c){b.type==CKEDITOR.NODE_ELEMENT&&CKEDITOR.dtd.$empty[b.getName()]&&(c=b.getIndex()+1,b=b.getParent());this._setEndContainer(b);this.endOffset=c;this.startContainer||(this._setStartContainer(b),
this.startOffset=c);a(this)},setStartAfter:function(a){this.setStart(a.getParent(),a.getIndex()+1)},setStartBefore:function(a){this.setStart(a.getParent(),a.getIndex())},setEndAfter:function(a){this.setEnd(a.getParent(),a.getIndex()+1)},setEndBefore:function(a){this.setEnd(a.getParent(),a.getIndex())},setStartAt:function(b,c){switch(c){case CKEDITOR.POSITION_AFTER_START:this.setStart(b,0);break;case CKEDITOR.POSITION_BEFORE_END:b.type==CKEDITOR.NODE_TEXT?this.setStart(b,b.getLength()):this.setStart(b,
b.getChildCount());break;case CKEDITOR.POSITION_BEFORE_START:this.setStartBefore(b);break;case CKEDITOR.POSITION_AFTER_END:this.setStartAfter(b)}a(this)},setEndAt:function(b,c){switch(c){case CKEDITOR.POSITION_AFTER_START:this.setEnd(b,0);break;case CKEDITOR.POSITION_BEFORE_END:b.type==CKEDITOR.NODE_TEXT?this.setEnd(b,b.getLength()):this.setEnd(b,b.getChildCount());break;case CKEDITOR.POSITION_BEFORE_START:this.setEndBefore(b);break;case CKEDITOR.POSITION_AFTER_END:this.setEndAfter(b)}a(this)},fixBlock:function(a,
b){var c=this.createBookmark(),d=this.document.createElement(b);this.collapse(a);this.enlarge(CKEDITOR.ENLARGE_BLOCK_CONTENTS);this.extractContents().appendTo(d);d.trim();this.insertNode(d);var f=d.getBogus();f&&f.remove();d.appendBogus();this.moveToBookmark(c);return d},splitBlock:function(a,b){var c=new CKEDITOR.dom.elementPath(this.startContainer,this.root),d=new CKEDITOR.dom.elementPath(this.endContainer,this.root),f=c.block,g=d.block,n=null;if(!c.blockLimit.equals(d.blockLimit))return null;"br"!=
a&&(f||(f=this.fixBlock(!0,a),g=(new CKEDITOR.dom.elementPath(this.endContainer,this.root)).block),g||(g=this.fixBlock(!1,a)));c=f&&this.checkStartOfBlock();d=g&&this.checkEndOfBlock();this.deleteContents();f&&f.equals(g)&&(d?(n=new CKEDITOR.dom.elementPath(this.startContainer,this.root),this.moveToPosition(g,CKEDITOR.POSITION_AFTER_END),g=null):c?(n=new CKEDITOR.dom.elementPath(this.startContainer,this.root),this.moveToPosition(f,CKEDITOR.POSITION_BEFORE_START),f=null):(g=this.splitElement(f,b||
!1),f.is("ul","ol")||f.appendBogus()));return{previousBlock:f,nextBlock:g,wasStartOfBlock:c,wasEndOfBlock:d,elementPath:n}},splitElement:function(a,b){if(!this.collapsed)return null;this.setEndAt(a,CKEDITOR.POSITION_BEFORE_END);var c=this.extractContents(!1,b||!1),d=a.clone(!1,b||!1);c.appendTo(d);d.insertAfter(a);this.moveToPosition(a,CKEDITOR.POSITION_AFTER_END);return d},removeEmptyBlocksAtEnd:function(){function a(e){return function(a){return b(a)||c(a)||a.type==CKEDITOR.NODE_ELEMENT&&a.isEmptyInlineRemoveable()||
e.is("table")&&a.is("caption")?!1:!0}}var b=CKEDITOR.dom.walker.whitespaces(),c=CKEDITOR.dom.walker.bookmark(!1);return function(b){for(var c=this.createBookmark(),d=this[b?"endPath":"startPath"](),f=d.block||d.blockLimit,g;f&&!f.equals(d.root)&&!f.getFirst(a(f));)g=f.getParent(),this[b?"setEndAt":"setStartAt"](f,CKEDITOR.POSITION_AFTER_END),f.remove(1),f=g;this.moveToBookmark(c)}}(),startPath:function(){return new CKEDITOR.dom.elementPath(this.startContainer,this.root)},endPath:function(){return new CKEDITOR.dom.elementPath(this.endContainer,
this.root)},checkBoundaryOfElement:function(a,b){var d=b==CKEDITOR.START,f=this.clone();f.collapse(d);f[d?"setStartAt":"setEndAt"](a,d?CKEDITOR.POSITION_AFTER_START:CKEDITOR.POSITION_BEFORE_END);f=new CKEDITOR.dom.walker(f);f.evaluator=c(d);return f[d?"checkBackward":"checkForward"]()},checkStartOfBlock:function(){var a=this.startContainer,c=this.startOffset;CKEDITOR.env.ie&&c&&a.type==CKEDITOR.NODE_TEXT&&(a=CKEDITOR.tools.ltrim(a.substring(0,c)),h.test(a)&&this.trim(0,1));this.trim();a=new CKEDITOR.dom.elementPath(this.startContainer,
this.root);c=this.clone();c.collapse(!0);c.setStartAt(a.block||a.blockLimit,CKEDITOR.POSITION_AFTER_START);a=new CKEDITOR.dom.walker(c);a.evaluator=b();return a.checkBackward()},checkEndOfBlock:function(){var a=this.endContainer,c=this.endOffset;CKEDITOR.env.ie&&a.type==CKEDITOR.NODE_TEXT&&(a=CKEDITOR.tools.rtrim(a.substring(c)),h.test(a)&&this.trim(1,0));this.trim();a=new CKEDITOR.dom.elementPath(this.endContainer,this.root);c=this.clone();c.collapse(!1);c.setEndAt(a.block||a.blockLimit,CKEDITOR.POSITION_BEFORE_END);
a=new CKEDITOR.dom.walker(c);a.evaluator=b();return a.checkForward()},getPreviousNode:function(a,b,c){var d=this.clone();d.collapse(1);d.setStartAt(c||this.root,CKEDITOR.POSITION_AFTER_START);c=new CKEDITOR.dom.walker(d);c.evaluator=a;c.guard=b;return c.previous()},getNextNode:function(a,b,c){var d=this.clone();d.collapse();d.setEndAt(c||this.root,CKEDITOR.POSITION_BEFORE_END);c=new CKEDITOR.dom.walker(d);c.evaluator=a;c.guard=b;return c.next()},checkReadOnly:function(){function a(b,c){for(;b;){if(b.type==
CKEDITOR.NODE_ELEMENT){if("false"==b.getAttribute("contentEditable")&&!b.data("cke-editable"))return 0;if(b.is("html")||"true"==b.getAttribute("contentEditable")&&(b.contains(c)||b.equals(c)))break}b=b.getParent()}return 1}return function(){var b=this.startContainer,c=this.endContainer;return!(a(b,c)&&a(c,b))}}(),moveToElementEditablePosition:function(a,b){if(a.type==CKEDITOR.NODE_ELEMENT&&!a.isEditable(!1))return this.moveToPosition(a,b?CKEDITOR.POSITION_AFTER_END:CKEDITOR.POSITION_BEFORE_START),
!0;for(var c=0;a;){if(a.type==CKEDITOR.NODE_TEXT){b&&this.endContainer&&this.checkEndOfBlock()&&h.test(a.getText())?this.moveToPosition(a,CKEDITOR.POSITION_BEFORE_START):this.moveToPosition(a,b?CKEDITOR.POSITION_AFTER_END:CKEDITOR.POSITION_BEFORE_START);c=1;break}if(a.type==CKEDITOR.NODE_ELEMENT)if(a.isEditable())this.moveToPosition(a,b?CKEDITOR.POSITION_BEFORE_END:CKEDITOR.POSITION_AFTER_START),c=1;else if(b&&a.is("br")&&this.endContainer&&this.checkEndOfBlock())this.moveToPosition(a,CKEDITOR.POSITION_BEFORE_START);
else if("false"==a.getAttribute("contenteditable")&&a.is(CKEDITOR.dtd.$block))return this.setStartBefore(a),this.setEndAfter(a),!0;var d=a,f=c,g=void 0;d.type==CKEDITOR.NODE_ELEMENT&&d.isEditable(!1)&&(g=d[b?"getLast":"getFirst"](p));f||g||(g=d[b?"getPrevious":"getNext"](p));a=g}return!!c},moveToClosestEditablePosition:function(a,b){var c,d=0,f,g,n=[CKEDITOR.POSITION_AFTER_END,CKEDITOR.POSITION_BEFORE_START];a?(c=new CKEDITOR.dom.range(this.root),c.moveToPosition(a,n[b?0:1])):c=this.clone();if(a&&
!a.is(CKEDITOR.dtd.$block))d=1;else if(f=c[b?"getNextEditableNode":"getPreviousEditableNode"]())d=1,(g=f.type==CKEDITOR.NODE_ELEMENT)&&f.is(CKEDITOR.dtd.$block)&&"false"==f.getAttribute("contenteditable")?(c.setStartAt(f,CKEDITOR.POSITION_BEFORE_START),c.setEndAt(f,CKEDITOR.POSITION_AFTER_END)):!CKEDITOR.env.needsBrFiller&&g&&f.is(CKEDITOR.dom.walker.validEmptyBlockContainers)?(c.setEnd(f,0),c.collapse()):c.moveToPosition(f,n[b?1:0]);d&&this.moveToRange(c);return!!d},moveToElementEditStart:function(a){return this.moveToElementEditablePosition(a)},
moveToElementEditEnd:function(a){return this.moveToElementEditablePosition(a,!0)},getEnclosedNode:function(){var a=this.clone();a.optimize();if(a.startContainer.type!=CKEDITOR.NODE_ELEMENT||a.endContainer.type!=CKEDITOR.NODE_ELEMENT)return null;var a=new CKEDITOR.dom.walker(a),b=CKEDITOR.dom.walker.bookmark(!1,!0),c=CKEDITOR.dom.walker.whitespaces(!0);a.evaluator=function(a){return c(a)&&b(a)};var d=a.next();a.reset();return d&&d.equals(a.previous())?d:null},getTouchedStartNode:function(){var a=this.startContainer;
return this.collapsed||a.type!=CKEDITOR.NODE_ELEMENT?a:a.getChild(this.startOffset)||a},getTouchedEndNode:function(){var a=this.endContainer;return this.collapsed||a.type!=CKEDITOR.NODE_ELEMENT?a:a.getChild(this.endOffset-1)||a},getNextEditableNode:g(),getPreviousEditableNode:g(1),_getTableElement:function(a){a=a||{td:1,th:1,tr:1,tbody:1,thead:1,tfoot:1,table:1};var b=this.getTouchedStartNode(),c=this.getTouchedEndNode(),d=b.getAscendant("table",!0),c=c.getAscendant("table",!0);return d&&!this.root.contains(d)?
null:this.getEnclosedNode()?this.getEnclosedNode().getAscendant(a,!0):d&&c&&(d.equals(c)||d.contains(c)||c.contains(d))?b.getAscendant(a,!0):null},scrollIntoView:function(){var a=new CKEDITOR.dom.element.createFromHtml("\x3cspan\x3e\x26nbsp;\x3c/span\x3e",this.document),b,c,d,f=this.clone();f.optimize();(d=f.startContainer.type==CKEDITOR.NODE_TEXT)?(c=f.startContainer.getText(),b=f.startContainer.split(f.startOffset),a.insertAfter(f.startContainer)):f.insertNode(a);a.scrollIntoView();d&&(f.startContainer.setText(c),
b.remove());a.remove()},getClientRects:function(){function a(b,c){var d=CKEDITOR.tools.array.map(b,function(a){return a}),e=new CKEDITOR.dom.range(c.root),f,g,h;c.startContainer instanceof CKEDITOR.dom.element&&(g=0===c.startOffset&&c.startContainer.hasAttribute("data-widget"));c.endContainer instanceof CKEDITOR.dom.element&&(h=(h=c.endOffset===(c.endContainer.getChildCount?c.endContainer.getChildCount():c.endContainer.length))&&c.endContainer.hasAttribute("data-widget"));g&&e.setStart(c.startContainer.getParent(),
c.startContainer.getIndex());h&&e.setEnd(c.endContainer.getParent(),c.endContainer.getIndex()+1);if(g||h)c=e;e=c.cloneContents().find("[data-cke-widget-id]").toArray();if(e=CKEDITOR.tools.array.map(e,function(a){var b=c.root.editor;a=a.getAttribute("data-cke-widget-id");return b.widgets.instances[a].element}))return e=CKEDITOR.tools.array.map(e,function(a){var b;b=a.getParent().hasClass("cke_widget_wrapper")?a.getParent():a;f=this.root.getDocument().$.createRange();f.setStart(b.getParent().$,b.getIndex());
f.setEnd(b.getParent().$,b.getIndex()+1);b=f.getClientRects();b.widgetRect=a.getClientRect();return b},c),CKEDITOR.tools.array.forEach(e,function(a){function b(e){CKEDITOR.tools.array.forEach(d,function(b,f){var g=CKEDITOR.tools.objectCompare(a[e],b);g||(g=CKEDITOR.tools.objectCompare(a.widgetRect,b));g&&(Array.prototype.splice.call(d,f,a.length-e,a.widgetRect),c=!0)});c||(e<d.length-1?b(e+1):d.push(a.widgetRect))}var c;b(0)}),d}function b(a,c,e){var f;c.collapsed?e.startContainer instanceof CKEDITOR.dom.element?
(a=e.checkStartOfBlock(),f=new CKEDITOR.dom.text("​"),a?e.startContainer.append(f,!0):0===e.startOffset?f.insertBefore(e.startContainer.getFirst()):(e=e.startContainer.getChildren().getItem(e.startOffset-1),f.insertAfter(e)),c.setStart(f.$,0),c.setEnd(f.$,0),a=c.getClientRects(),f.remove()):e.startContainer instanceof CKEDITOR.dom.text&&(""===e.startContainer.getText()?(e.startContainer.setText("​"),a=c.getClientRects(),e.startContainer.setText("")):a=[d(e.createBookmark())]):a=[d(e.createBookmark())];
return a}function c(a,b,d){a=CKEDITOR.tools.extend({},a);b&&(a=CKEDITOR.tools.getAbsoluteRectPosition(d.document.getWindow(),a));!a.width&&(a.width=a.right-a.left);!a.height&&(a.height=a.bottom-a.top);return a}function d(a){var b=a.startNode;a=a.endNode;var c;b.setText("​");b.removeStyle("display");a?(a.setText("​"),a.removeStyle("display"),c=[b.getClientRect(),a.getClientRect()],a.remove()):c=[b.getClientRect(),b.getClientRect()];b.remove();return{right:Math.max(c[0].right,c[1].right),bottom:Math.max(c[0].bottom,
c[1].bottom),left:Math.min(c[0].left,c[1].left),top:Math.min(c[0].top,c[1].top),width:Math.abs(c[0].left-c[1].left),height:Math.max(c[0].bottom,c[1].bottom)-Math.min(c[0].top,c[1].top)}}return void 0!==this.document.getSelection?function(d){var f=this.root.getDocument().$.createRange(),g;f.setStart(this.startContainer.$,this.startOffset);f.setEnd(this.endContainer.$,this.endOffset);g=f.getClientRects();g=a(g,this);g.length||(g=b(g,f,this));return CKEDITOR.tools.array.map(g,function(a){return c(a,
d,this)},this)}:function(a){return[c(d(this.createBookmark()),a,this)]}}(),_setStartContainer:function(a){this.startContainer=a},_setEndContainer:function(a){this.endContainer=a},_find:function(a,b){var c=this.getCommonAncestor(),d=this.getBoundaryNodes(),f=[],g,n,h,l;if(c&&c.find)for(n=c.find(a),g=0;g<n.count();g++)if(c=n.getItem(g),b||!c.isReadOnly())h=c.getPosition(d.startNode)&CKEDITOR.POSITION_FOLLOWING||d.startNode.equals(c),l=c.getPosition(d.endNode)&CKEDITOR.POSITION_PRECEDING+CKEDITOR.POSITION_IS_CONTAINED||
d.endNode.equals(c),h&&l&&f.push(c);return f}};CKEDITOR.dom.range.mergeRanges=function(a){return CKEDITOR.tools.array.reduce(a,function(a,b){var c=a[a.length-1],d=!1;b=b.clone();b.enlarge(CKEDITOR.ENLARGE_ELEMENT);if(c){var e=new CKEDITOR.dom.range(b.root),d=new CKEDITOR.dom.walker(e),f=CKEDITOR.dom.walker.whitespaces();e.setStart(c.endContainer,c.endOffset);e.setEnd(b.startContainer,b.startOffset);for(e=d.next();f(e)||b.endContainer.equals(e);)e=d.next();d=!e}d?c.setEnd(b.endContainer,b.endOffset):
a.push(b);return a},[])}})();CKEDITOR.POSITION_AFTER_START=1;CKEDITOR.POSITION_BEFORE_END=2;CKEDITOR.POSITION_BEFORE_START=3;CKEDITOR.POSITION_AFTER_END=4;CKEDITOR.ENLARGE_ELEMENT=1;CKEDITOR.ENLARGE_BLOCK_CONTENTS=2;CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS=3;CKEDITOR.ENLARGE_INLINE=4;CKEDITOR.START=1;CKEDITOR.END=2;CKEDITOR.SHRINK_ELEMENT=1;CKEDITOR.SHRINK_TEXT=2;"use strict";
(function(){function a(a){1>arguments.length||(this.range=a,this.forceBrBreak=0,this.enlargeBr=1,this.enforceRealBlocks=0,this._||(this._={}))}function d(a){var b=[];a.forEach(function(a){if("true"==a.getAttribute("contenteditable"))return b.push(a),!1},CKEDITOR.NODE_ELEMENT,!0);return b}function b(a,c,f,g){a:{null==g&&(g=d(f));for(var h;h=g.shift();)if(h.getDtd().p){g={element:h,remaining:g};break a}g=null}if(!g)return 0;if((h=CKEDITOR.filter.instances[g.element.data("cke-filter")])&&!h.check(c))return b(a,
c,f,g.remaining);c=new CKEDITOR.dom.range(g.element);c.selectNodeContents(g.element);c=c.createIterator();c.enlargeBr=a.enlargeBr;c.enforceRealBlocks=a.enforceRealBlocks;c.activeFilter=c.filter=h;a._.nestedEditable={element:g.element,container:f,remaining:g.remaining,iterator:c};return 1}function c(a,b,c){if(!b)return!1;a=a.clone();a.collapse(!c);return a.checkBoundaryOfElement(b,c?CKEDITOR.START:CKEDITOR.END)}var g=/^[\r\n\t ]+$/,f=CKEDITOR.dom.walker.bookmark(!1,!0),l=CKEDITOR.dom.walker.whitespaces(!0),
h=function(a){return f(a)&&l(a)},k={dd:1,dt:1,li:1};a.prototype={getNextParagraph:function(a){var d,l,w,y,G;a=a||"p";if(this._.nestedEditable){if(d=this._.nestedEditable.iterator.getNextParagraph(a))return this.activeFilter=this._.nestedEditable.iterator.activeFilter,d;this.activeFilter=this.filter;if(b(this,a,this._.nestedEditable.container,this._.nestedEditable.remaining))return this.activeFilter=this._.nestedEditable.iterator.activeFilter,this._.nestedEditable.iterator.getNextParagraph(a);this._.nestedEditable=
null}if(!this.range.root.getDtd()[a])return null;if(!this._.started){var q=this.range.clone();l=q.startPath();var n=q.endPath(),H=!q.collapsed&&c(q,l.block),x=!q.collapsed&&c(q,n.block,1);q.shrink(CKEDITOR.SHRINK_ELEMENT,!0);H&&q.setStartAt(l.block,CKEDITOR.POSITION_BEFORE_END);x&&q.setEndAt(n.block,CKEDITOR.POSITION_AFTER_START);l=q.endContainer.hasAscendant("pre",!0)||q.startContainer.hasAscendant("pre",!0);q.enlarge(this.forceBrBreak&&!l||!this.enlargeBr?CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS:CKEDITOR.ENLARGE_BLOCK_CONTENTS);
q.collapsed||(l=new CKEDITOR.dom.walker(q.clone()),n=CKEDITOR.dom.walker.bookmark(!0,!0),l.evaluator=n,this._.nextNode=l.next(),l=new CKEDITOR.dom.walker(q.clone()),l.evaluator=n,l=l.previous(),this._.lastNode=l.getNextSourceNode(!0,null,q.root),this._.lastNode&&this._.lastNode.type==CKEDITOR.NODE_TEXT&&!CKEDITOR.tools.trim(this._.lastNode.getText())&&this._.lastNode.getParent().isBlockBoundary()&&(n=this.range.clone(),n.moveToPosition(this._.lastNode,CKEDITOR.POSITION_AFTER_END),n.checkEndOfBlock()&&
(n=new CKEDITOR.dom.elementPath(n.endContainer,n.root),this._.lastNode=(n.block||n.blockLimit).getNextSourceNode(!0))),this._.lastNode&&q.root.contains(this._.lastNode)||(this._.lastNode=this._.docEndMarker=q.document.createText(""),this._.lastNode.insertAfter(l)),q=null);this._.started=1;l=q}n=this._.nextNode;q=this._.lastNode;for(this._.nextNode=null;n;){var H=0,x=n.hasAscendant("pre"),I=n.type!=CKEDITOR.NODE_ELEMENT,K=0;if(I)n.type==CKEDITOR.NODE_TEXT&&g.test(n.getText())&&(I=0);else{var m=n.getName();
if(CKEDITOR.dtd.$block[m]&&"false"==n.getAttribute("contenteditable")){d=n;b(this,a,d);break}else if(n.isBlockBoundary(this.forceBrBreak&&!x&&{br:1})){if("br"==m)I=1;else if(!l&&!n.getChildCount()&&"hr"!=m){d=n;w=n.equals(q);break}l&&(l.setEndAt(n,CKEDITOR.POSITION_BEFORE_START),"br"!=m&&(this._.nextNode=n));H=1}else{if(n.getFirst()){l||(l=this.range.clone(),l.setStartAt(n,CKEDITOR.POSITION_BEFORE_START));n=n.getFirst();continue}I=1}}I&&!l&&(l=this.range.clone(),l.setStartAt(n,CKEDITOR.POSITION_BEFORE_START));
w=(!H||I)&&n.equals(q);if(l&&!H)for(;!n.getNext(h)&&!w;){m=n.getParent();if(m.isBlockBoundary(this.forceBrBreak&&!x&&{br:1})){H=1;I=0;w||m.equals(q);l.setEndAt(m,CKEDITOR.POSITION_BEFORE_END);break}n=m;I=1;w=n.equals(q);K=1}I&&l.setEndAt(n,CKEDITOR.POSITION_AFTER_END);n=this._getNextSourceNode(n,K,q);if((w=!n)||H&&l)break}if(!d){if(!l)return this._.docEndMarker&&this._.docEndMarker.remove(),this._.nextNode=null;d=new CKEDITOR.dom.elementPath(l.startContainer,l.root);n=d.blockLimit;H={div:1,th:1,td:1};
d=d.block;!d&&n&&!this.enforceRealBlocks&&H[n.getName()]&&l.checkStartOfBlock()&&l.checkEndOfBlock()&&!n.equals(l.root)?d=n:!d||this.enforceRealBlocks&&d.is(k)?(d=this.range.document.createElement(a),l.extractContents().appendTo(d),d.trim(),l.insertNode(d),y=G=!0):"li"!=d.getName()?l.checkStartOfBlock()&&l.checkEndOfBlock()||(d=d.clone(!1),l.extractContents().appendTo(d),d.trim(),G=l.splitBlock(),y=!G.wasStartOfBlock,G=!G.wasEndOfBlock,l.insertNode(d)):w||(this._.nextNode=d.equals(q)?null:this._getNextSourceNode(l.getBoundaryNodes().endNode,
1,q))}y&&(y=d.getPrevious())&&y.type==CKEDITOR.NODE_ELEMENT&&("br"==y.getName()?y.remove():y.getLast()&&"br"==y.getLast().$.nodeName.toLowerCase()&&y.getLast().remove());G&&(y=d.getLast())&&y.type==CKEDITOR.NODE_ELEMENT&&"br"==y.getName()&&(!CKEDITOR.env.needsBrFiller||y.getPrevious(f)||y.getNext(f))&&y.remove();this._.nextNode||(this._.nextNode=w||d.equals(q)||!q?null:this._getNextSourceNode(d,1,q));return d},_getNextSourceNode:function(a,b,c){function d(a){return!(a.equals(c)||a.equals(g))}var g=
this.range.root;for(a=a.getNextSourceNode(b,null,d);!f(a);)a=a.getNextSourceNode(b,null,d);return a}};CKEDITOR.dom.range.prototype.createIterator=function(){return new a(this)}})();
CKEDITOR.command=function(a,d){this.uiItems=[];this.exec=function(b){if(this.state==CKEDITOR.TRISTATE_DISABLED||!this.checkAllowed())return!1;this.editorFocus&&a.focus();return!1===this.fire("exec")?!0:!1!==d.exec.call(this,a,b)};this.refresh=function(a,b){if(!this.readOnly&&a.readOnly)return!0;if(this.context&&!b.isContextFor(this.context)||!this.checkAllowed(!0))return this.disable(),!0;this.startDisabled||this.enable();this.modes&&!this.modes[a.mode]&&this.disable();return!1===this.fire("refresh",
{editor:a,path:b})?!0:d.refresh&&!1!==d.refresh.apply(this,arguments)};var b;this.checkAllowed=function(c){return c||"boolean"!=typeof b?b=a.activeFilter.checkFeature(this):b};CKEDITOR.tools.extend(this,d,{modes:{wysiwyg:1},editorFocus:1,contextSensitive:!!d.context,state:CKEDITOR.TRISTATE_DISABLED});CKEDITOR.event.call(this)};
CKEDITOR.command.prototype={enable:function(){this.state==CKEDITOR.TRISTATE_DISABLED&&this.checkAllowed()&&this.setState(this.preserveState&&"undefined"!=typeof this.previousState?this.previousState:CKEDITOR.TRISTATE_OFF)},disable:function(){this.setState(CKEDITOR.TRISTATE_DISABLED)},setState:function(a){if(this.state==a||a!=CKEDITOR.TRISTATE_DISABLED&&!this.checkAllowed())return!1;this.previousState=this.state;this.state=a;this.fire("state");return!0},toggleState:function(){this.state==CKEDITOR.TRISTATE_OFF?
this.setState(CKEDITOR.TRISTATE_ON):this.state==CKEDITOR.TRISTATE_ON&&this.setState(CKEDITOR.TRISTATE_OFF)}};CKEDITOR.event.implementOn(CKEDITOR.command.prototype);CKEDITOR.ENTER_P=1;CKEDITOR.ENTER_BR=2;CKEDITOR.ENTER_DIV=3;
CKEDITOR.config={customConfig:"config.js",autoUpdateElement:!0,language:"",defaultLanguage:"en",contentsLangDirection:"",enterMode:CKEDITOR.ENTER_P,forceEnterMode:!1,shiftEnterMode:CKEDITOR.ENTER_BR,docType:"\x3c!DOCTYPE html\x3e",bodyId:"",bodyClass:"",fullPage:!1,height:200,contentsCss:CKEDITOR.getUrl("contents.css"),extraPlugins:"",removePlugins:"",protectedSource:[],tabIndex:0,width:"",baseFloatZIndex:1E4,blockedKeystrokes:[CKEDITOR.CTRL+66,CKEDITOR.CTRL+73,CKEDITOR.CTRL+85]};
(function(){function a(a,b,c,d,f){var e,g;a=[];for(e in b){g=b[e];g="boolean"==typeof g?{}:"function"==typeof g?{match:g}:E(g);"$"!=e.charAt(0)&&(g.elements=e);c&&(g.featureName=c.toLowerCase());var m=g;m.elements=l(m.elements,/\s+/)||null;m.propertiesOnly=m.propertiesOnly||!0===m.elements;var v=/\s*,\s*/,r=void 0;for(r in S){m[r]=l(m[r],v)||null;var D=m,t=T[r],n=l(m[T[r]],v),h=m[r],u=[],B=!0,P=void 0;n?B=!1:n={};for(P in h)"!"==P.charAt(0)&&(P=P.slice(1),u.push(P),n[P]=!0,B=!1);for(;P=u.pop();)h[P]=
h["!"+P],delete h["!"+P];D[t]=(B?!1:n)||null}m.match=m.match||null;d.push(g);a.push(g)}b=f.elements;f=f.generic;var F;c=0;for(d=a.length;c<d;++c){e=E(a[c]);g=!0===e.classes||!0===e.styles||!0===e.attributes;m=e;r=t=v=void 0;for(v in S)m[v]=H(m[v]);D=!0;for(r in T){v=T[r];t=m[v];n=[];h=void 0;for(h in t)-1<h.indexOf("*")?n.push(new RegExp("^"+h.replace(/\*/g,".*")+"$")):n.push(h);t=n;t.length&&(m[v]=t,D=!1)}m.nothingRequired=D;m.noProperties=!(m.attributes||m.classes||m.styles);if(!0===e.elements||
null===e.elements)f[g?"unshift":"push"](e);else for(F in m=e.elements,delete e.elements,m)if(b[F])b[F][g?"unshift":"push"](e);else b[F]=[e]}}function d(a,c,d,f){if(!a.match||a.match(c))if(f||h(a,c))if(a.propertiesOnly||(d.valid=!0),d.allAttributes||(d.allAttributes=b(a.attributes,c.attributes,d.validAttributes)),d.allStyles||(d.allStyles=b(a.styles,c.styles,d.validStyles)),!d.allClasses){a=a.classes;c=c.classes;f=d.validClasses;if(a)if(!0===a)a=!0;else{for(var e=0,g=c.length,m;e<g;++e)m=c[e],f[m]||
(f[m]=a(m));a=!1}else a=!1;d.allClasses=a}}function b(a,b,c){if(!a)return!1;if(!0===a)return!0;for(var d in b)c[d]||(c[d]=a(d));return!1}function c(a,b,c){if(!a.match||a.match(b)){if(a.noProperties)return!1;c.hadInvalidAttribute=g(a.attributes,b.attributes)||c.hadInvalidAttribute;c.hadInvalidStyle=g(a.styles,b.styles)||c.hadInvalidStyle;a=a.classes;b=b.classes;if(a){for(var d=!1,f=!0===a,e=b.length;e--;)if(f||a(b[e]))b.splice(e,1),d=!0;a=d}else a=!1;c.hadInvalidClass=a||c.hadInvalidClass}}function g(a,
b){if(!a)return!1;var c=!1,d=!0===a,f;for(f in b)if(d||a(f))delete b[f],c=!0;return c}function f(a,b,c){if(a.disabled||a.customConfig&&!c||!b)return!1;a._.cachedChecks={};return!0}function l(a,b){if(!a)return!1;if(!0===a)return a;if("string"==typeof a)return a=D(a),"*"==a?!0:CKEDITOR.tools.convertArrayToObject(a.split(b));if(CKEDITOR.tools.isArray(a))return a.length?CKEDITOR.tools.convertArrayToObject(a):!1;var c={},d=0,f;for(f in a)c[f]=a[f],d++;return d?c:!1}function h(a,b){if(a.nothingRequired)return!0;
var c,d,f,e;if(f=a.requiredClasses)for(e=b.classes,c=0;c<f.length;++c)if(d=f[c],"string"==typeof d){if(-1==CKEDITOR.tools.indexOf(e,d))return!1}else if(!CKEDITOR.tools.checkIfAnyArrayItemMatches(e,d))return!1;return k(b.styles,a.requiredStyles)&&k(b.attributes,a.requiredAttributes)}function k(a,b){if(!b)return!0;for(var c=0,d;c<b.length;++c)if(d=b[c],"string"==typeof d){if(!(d in a))return!1}else if(!CKEDITOR.tools.checkIfAnyObjectPropertyMatches(a,d))return!1;return!0}function p(a){if(!a)return{};
a=a.split(/\s*,\s*/).sort();for(var b={};a.length;)b[a.shift()]="cke-test";return b}function e(a){var b,c,d,f,e={},g=1;for(a=D(a);b=a.match(t);)(c=b[2])?(d=z(c,"styles"),f=z(c,"attrs"),c=z(c,"classes")):d=f=c=null,e["$"+g++]={elements:b[1],classes:c,styles:d,attributes:f},a=a.slice(b[0].length);return e}function z(a,b){var c=a.match(P[b]);return c?D(c[1]):null}function w(a){var b=a.styleBackup=a.attributes.style,c=a.classBackup=a.attributes["class"];a.styles||(a.styles=CKEDITOR.tools.parseCssText(b||
"",1));a.classes||(a.classes=c?c.split(/\s+/):[])}function y(a,b,f,e){var g=0,r;e.toHtml&&(b.name=b.name.replace(J,"$1"));if(e.doCallbacks&&a.elementCallbacks){a:{r=a.elementCallbacks;for(var t=0,D=r.length,h;t<D;++t)if(h=r[t](b)){r=h;break a}r=void 0}if(r)return r}if(e.doTransform&&(r=a._.transformations[b.name])){w(b);for(t=0;t<r.length;++t)m(a,b,r[t]);q(b)}if(e.doFilter){a:{t=b.name;D=a._;a=D.allowedRules.elements[t];r=D.allowedRules.generic;t=D.disallowedRules.elements[t];D=D.disallowedRules.generic;
h=e.skipRequired;var l={valid:!1,validAttributes:{},validClasses:{},validStyles:{},allAttributes:!1,allClasses:!1,allStyles:!1,hadInvalidAttribute:!1,hadInvalidClass:!1,hadInvalidStyle:!1},u,E;if(a||r){w(b);if(t)for(u=0,E=t.length;u<E;++u)if(!1===c(t[u],b,l)){a=null;break a}if(D)for(u=0,E=D.length;u<E;++u)c(D[u],b,l);if(a)for(u=0,E=a.length;u<E;++u)d(a[u],b,l,h);if(r)for(u=0,E=r.length;u<E;++u)d(r[u],b,l,h);a=l}else a=null}if(!a||!a.valid)return f.push(b),1;E=a.validAttributes;var P=a.validStyles;
r=a.validClasses;var t=b.attributes,B=b.styles,D=b.classes;h=b.classBackup;var F=b.styleBackup,k,A,M=[],l=[],N=/^data-cke-/;u=!1;delete t.style;delete t["class"];delete b.classBackup;delete b.styleBackup;if(!a.allAttributes)for(k in t)E[k]||(N.test(k)?k==(A=k.replace(/^data-cke-saved-/,""))||E[A]||(delete t[k],u=!0):(delete t[k],u=!0));if(!a.allStyles||a.hadInvalidStyle){for(k in B)a.allStyles||P[k]?M.push(k+":"+B[k]):u=!0;M.length&&(t.style=M.sort().join("; "))}else F&&(t.style=F);if(!a.allClasses||
a.hadInvalidClass){for(k=0;k<D.length;++k)(a.allClasses||r[D[k]])&&l.push(D[k]);l.length&&(t["class"]=l.sort().join(" "));h&&l.length<h.split(/\s+/).length&&(u=!0)}else h&&(t["class"]=h);u&&(g=1);if(!e.skipFinalValidation&&!n(b))return f.push(b),1}e.toHtml&&(b.name=b.name.replace(v,"cke:$1"));return g}function G(a){var b=[],c;for(c in a)-1<c.indexOf("*")&&b.push(c.replace(/\*/g,".*"));return b.length?new RegExp("^(?:"+b.join("|")+")$"):null}function q(a){var b=a.attributes,c;delete b.style;delete b["class"];
if(c=CKEDITOR.tools.writeCssText(a.styles,!0))b.style=c;a.classes.length&&(b["class"]=a.classes.sort().join(" "))}function n(a){switch(a.name){case "a":if(!(a.children.length||a.attributes.name||a.attributes.id))return!1;break;case "img":if(!a.attributes.src)return!1}return!0}function H(a){if(!a)return!1;if(!0===a)return!0;var b=G(a);return function(c){return c in a||b&&c.match(b)}}function x(){return new CKEDITOR.htmlParser.element("br")}function I(a){return a.type==CKEDITOR.NODE_ELEMENT&&("br"==
a.name||r.$block[a.name])}function K(a,b,c){var d=a.name;if(r.$empty[d]||!a.children.length)"hr"==d&&"br"==b?a.replaceWith(x()):(a.parent&&c.push({check:"it",el:a.parent}),a.remove());else if(r.$block[d]||"tr"==d)if("br"==b)a.previous&&!I(a.previous)&&(b=x(),b.insertBefore(a)),a.next&&!I(a.next)&&(b=x(),b.insertAfter(a)),a.replaceWithChildren();else{var d=a.children,f;b:{f=r[b];for(var e=0,g=d.length,m;e<g;++e)if(m=d[e],m.type==CKEDITOR.NODE_ELEMENT&&!f[m.name]){f=!1;break b}f=!0}if(f)a.name=b,a.attributes=
{},c.push({check:"parent-down",el:a});else{f=a.parent;for(var e=f.type==CKEDITOR.NODE_DOCUMENT_FRAGMENT||"body"==f.name,v,t,g=d.length;0<g;)m=d[--g],e&&(m.type==CKEDITOR.NODE_TEXT||m.type==CKEDITOR.NODE_ELEMENT&&r.$inline[m.name])?(v||(v=new CKEDITOR.htmlParser.element(b),v.insertAfter(a),c.push({check:"parent-down",el:v})),v.add(m,0)):(v=null,t=r[f.name]||r.span,m.insertAfter(a),f.type==CKEDITOR.NODE_DOCUMENT_FRAGMENT||m.type!=CKEDITOR.NODE_ELEMENT||t[m.name]||c.push({check:"el-up",el:m}));a.remove()}}else d in
{style:1,script:1}?a.remove():(a.parent&&c.push({check:"it",el:a.parent}),a.replaceWithChildren())}function m(a,b,c){var d,f;for(d=0;d<c.length;++d)if(f=c[d],!(f.check&&!a.check(f.check,!1)||f.left&&!f.left(b))){f.right(b,B);break}}function F(a,b){var c=b.getDefinition(),d=c.attributes,f=c.styles,e,g,m,v;if(a.name!=c.element)return!1;for(e in d)if("class"==e)for(c=d[e].split(/\s+/),m=a.classes.join("|");v=c.pop();){if(-1==m.indexOf(v))return!1}else if(a.attributes[e]!=d[e])return!1;for(g in f)if(a.styles[g]!=
f[g])return!1;return!0}function M(a,b){var c,d;"string"==typeof a?c=a:a instanceof CKEDITOR.style?d=a:(c=a[0],d=a[1]);return[{element:c,left:d,right:function(a,c){c.transform(a,b)}}]}function A(a){return function(b){return F(b,a)}}function N(a){return function(b,c){c[a](b)}}var r=CKEDITOR.dtd,E=CKEDITOR.tools.copy,D=CKEDITOR.tools.trim,u=["","p","br","div"];CKEDITOR.FILTER_SKIP_TREE=2;CKEDITOR.filter=function(a,b){this.allowedContent=[];this.disallowedContent=[];this.elementCallbacks=null;this.disabled=
!1;this.editor=null;this.id=CKEDITOR.tools.getNextNumber();this._={allowedRules:{elements:{},generic:[]},disallowedRules:{elements:{},generic:[]},transformations:{},cachedTests:{},cachedChecks:{}};CKEDITOR.filter.instances[this.id]=this;var c=this.editor=a instanceof CKEDITOR.editor?a:null;if(c&&!b){this.customConfig=!0;var d=c.config.allowedContent;!0===d?this.disabled=!0:(d||(this.customConfig=!1),this.allow(d,"config",1),this.allow(c.config.extraAllowedContent,"extra",1),this.allow(u[c.enterMode]+
" "+u[c.shiftEnterMode],"default",1),this.disallow(c.config.disallowedContent))}else this.customConfig=!1,this.allow(b||a,"default",1)};CKEDITOR.filter.instances={};CKEDITOR.filter.prototype={allow:function(b,c,d){if(!f(this,b,d))return!1;var g,m;if("string"==typeof b)b=e(b);else if(b instanceof CKEDITOR.style){if(b.toAllowedContentRules)return this.allow(b.toAllowedContentRules(this.editor),c,d);g=b.getDefinition();b={};d=g.attributes;b[g.element]=g={styles:g.styles,requiredStyles:g.styles&&CKEDITOR.tools.object.keys(g.styles)};
d&&(d=E(d),g.classes=d["class"]?d["class"].split(/\s+/):null,g.requiredClasses=g.classes,delete d["class"],g.attributes=d,g.requiredAttributes=d&&CKEDITOR.tools.object.keys(d))}else if(CKEDITOR.tools.isArray(b)){for(g=0;g<b.length;++g)m=this.allow(b[g],c,d);return m}a(this,b,c,this.allowedContent,this._.allowedRules);return!0},applyTo:function(a,b,c,d){if(this.disabled)return!1;var f=this,e=[],g=this.editor&&this.editor.config.protectedSource,m,v=!1,t={doFilter:!c,doTransform:!0,doCallbacks:!0,toHtml:b};
a.forEach(function(a){if(a.type==CKEDITOR.NODE_ELEMENT){if("off"==a.attributes["data-cke-filter"])return!1;if(!b||"span"!=a.name||!~CKEDITOR.tools.object.keys(a.attributes).join("|").indexOf("data-cke-"))if(m=y(f,a,e,t),m&1)v=!0;else if(m&2)return!1}else if(a.type==CKEDITOR.NODE_COMMENT&&a.value.match(/^\{cke_protected\}(?!\{C\})/)){var c;a:{var d=decodeURIComponent(a.value.replace(/^\{cke_protected\}/,""));c=[];var r,D,h;if(g)for(D=0;D<g.length;++D)if((h=d.match(g[D]))&&h[0].length==d.length){c=
!0;break a}d=CKEDITOR.htmlParser.fragment.fromHtml(d);1==d.children.length&&(r=d.children[0]).type==CKEDITOR.NODE_ELEMENT&&y(f,r,c,t);c=!c.length}c||e.push(a)}},null,!0);e.length&&(v=!0);var D;a=[];d=u[d||(this.editor?this.editor.enterMode:CKEDITOR.ENTER_P)];for(var h;c=e.pop();)c.type==CKEDITOR.NODE_ELEMENT?K(c,d,a):c.remove();for(;D=a.pop();)if(c=D.el,c.parent)switch(h=r[c.parent.name]||r.span,D.check){case "it":r.$removeEmpty[c.name]&&!c.children.length?K(c,d,a):n(c)||K(c,d,a);break;case "el-up":c.parent.type==
CKEDITOR.NODE_DOCUMENT_FRAGMENT||h[c.name]||K(c,d,a);break;case "parent-down":c.parent.type==CKEDITOR.NODE_DOCUMENT_FRAGMENT||h[c.name]||K(c.parent,d,a)}return v},checkFeature:function(a){if(this.disabled||!a)return!0;a.toFeature&&(a=a.toFeature(this.editor));return!a.requiredContent||this.check(a.requiredContent)},disable:function(){this.disabled=!0},disallow:function(b){if(!f(this,b,!0))return!1;"string"==typeof b&&(b=e(b));a(this,b,null,this.disallowedContent,this._.disallowedRules);return!0},
addContentForms:function(a){if(!this.disabled&&a){var b,c,d=[],f;for(b=0;b<a.length&&!f;++b)c=a[b],("string"==typeof c||c instanceof CKEDITOR.style)&&this.check(c)&&(f=c);if(f){for(b=0;b<a.length;++b)d.push(M(a[b],f));this.addTransformations(d)}}},addElementCallback:function(a){this.elementCallbacks||(this.elementCallbacks=[]);this.elementCallbacks.push(a)},addFeature:function(a){if(this.disabled||!a)return!0;a.toFeature&&(a=a.toFeature(this.editor));this.allow(a.allowedContent,a.name);this.addTransformations(a.contentTransformations);
this.addContentForms(a.contentForms);return a.requiredContent&&(this.customConfig||this.disallowedContent.length)?this.check(a.requiredContent):!0},addTransformations:function(a){var b,c;if(!this.disabled&&a){var d=this._.transformations,f;for(f=0;f<a.length;++f){b=a[f];var e=void 0,g=void 0,m=void 0,v=void 0,t=void 0,r=void 0;c=[];for(g=0;g<b.length;++g)m=b[g],"string"==typeof m?(m=m.split(/\s*:\s*/),v=m[0],t=null,r=m[1]):(v=m.check,t=m.left,r=m.right),e||(e=m,e=e.element?e.element:v?v.match(/^([a-z0-9]+)/i)[0]:
e.left.getDefinition().element),t instanceof CKEDITOR.style&&(t=A(t)),c.push({check:v==e?null:v,left:t,right:"string"==typeof r?N(r):r});b=e;d[b]||(d[b]=[]);d[b].push(c)}}},check:function(a,b,c){if(this.disabled)return!0;if(CKEDITOR.tools.isArray(a)){for(var d=a.length;d--;)if(this.check(a[d],b,c))return!0;return!1}var f,g;if("string"==typeof a){g=a+"\x3c"+(!1===b?"0":"1")+(c?"1":"0")+"\x3e";if(g in this._.cachedChecks)return this._.cachedChecks[g];f=e(a).$1;var v=f.styles,d=f.classes;f.name=f.elements;
f.classes=d=d?d.split(/\s*,\s*/):[];f.styles=p(v);f.attributes=p(f.attributes);f.children=[];d.length&&(f.attributes["class"]=d.join(" "));v&&(f.attributes.style=CKEDITOR.tools.writeCssText(f.styles))}else f=a.getDefinition(),v=f.styles,d=f.attributes||{},v&&!CKEDITOR.tools.isEmpty(v)?(v=E(v),d.style=CKEDITOR.tools.writeCssText(v,!0)):v={},f={name:f.element,attributes:d,classes:d["class"]?d["class"].split(/\s+/):[],styles:v,children:[]};var v=CKEDITOR.tools.clone(f),t=[],r;if(!1!==b&&(r=this._.transformations[f.name])){for(d=
0;d<r.length;++d)m(this,f,r[d]);q(f)}y(this,v,t,{doFilter:!0,doTransform:!1!==b,skipRequired:!c,skipFinalValidation:!c});0<t.length?c=!1:((b=f.attributes["class"])&&(f.attributes["class"]=f.attributes["class"].split(" ").sort().join(" ")),c=CKEDITOR.tools.objectCompare(f.attributes,v.attributes,!0),b&&(f.attributes["class"]=b));"string"==typeof a&&(this._.cachedChecks[g]=c);return c},getAllowedEnterMode:function(){var a=["p","div","br"],b={p:CKEDITOR.ENTER_P,div:CKEDITOR.ENTER_DIV,br:CKEDITOR.ENTER_BR};
return function(c,d){var f=a.slice(),e;if(this.check(u[c]))return c;for(d||(f=f.reverse());e=f.pop();)if(this.check(e))return b[e];return CKEDITOR.ENTER_BR}}(),clone:function(){var a=new CKEDITOR.filter,b=CKEDITOR.tools.clone;a.allowedContent=b(this.allowedContent);a._.allowedRules=b(this._.allowedRules);a.disallowedContent=b(this.disallowedContent);a._.disallowedRules=b(this._.disallowedRules);a._.transformations=b(this._.transformations);a.disabled=this.disabled;a.editor=this.editor;return a},destroy:function(){delete CKEDITOR.filter.instances[this.id];
delete this._;delete this.allowedContent;delete this.disallowedContent}};var S={styles:1,attributes:1,classes:1},T={styles:"requiredStyles",attributes:"requiredAttributes",classes:"requiredClasses"},t=/^([a-z0-9\-*\s]+)((?:\s*\{[!\w\-,\s\*]+\}\s*|\s*\[[!\w\-,\s\*]+\]\s*|\s*\([!\w\-,\s\*]+\)\s*){0,3})(?:;\s*|$)/i,P={styles:/{([^}]+)}/,attrs:/\[([^\]]+)\]/,classes:/\(([^\)]+)\)/},J=/^cke:(object|embed|param)$/,v=/^(object|embed|param)$/,B;B=CKEDITOR.filter.transformationsTools={sizeToStyle:function(a){this.lengthToStyle(a,
"width");this.lengthToStyle(a,"height")},sizeToAttribute:function(a){this.lengthToAttribute(a,"width");this.lengthToAttribute(a,"height")},lengthToStyle:function(a,b,c){c=c||b;if(!(c in a.styles)){var d=a.attributes[b];d&&(/^\d+$/.test(d)&&(d+="px"),a.styles[c]=d)}delete a.attributes[b]},lengthToAttribute:function(a,b,c){c=c||b;if(!(c in a.attributes)){var d=a.styles[b],f=d&&d.match(/^(\d+)(?:\.\d*)?px$/);f?a.attributes[c]=f[1]:"cke-test"==d&&(a.attributes[c]="cke-test")}delete a.styles[b]},alignmentToStyle:function(a){if(!("float"in
a.styles)){var b=a.attributes.align;if("left"==b||"right"==b)a.styles["float"]=b}delete a.attributes.align},alignmentToAttribute:function(a){if(!("align"in a.attributes)){var b=a.styles["float"];if("left"==b||"right"==b)a.attributes.align=b}delete a.styles["float"]},splitBorderShorthand:function(a){if(a.styles.border){var b=CKEDITOR.tools.style.parse.border(a.styles.border);b.color&&(a.styles["border-color"]=b.color);b.style&&(a.styles["border-style"]=b.style);b.width&&(a.styles["border-width"]=b.width);
delete a.styles.border}},listTypeToStyle:function(a){if(a.attributes.type)switch(a.attributes.type){case "a":a.styles["list-style-type"]="lower-alpha";break;case "A":a.styles["list-style-type"]="upper-alpha";break;case "i":a.styles["list-style-type"]="lower-roman";break;case "I":a.styles["list-style-type"]="upper-roman";break;case "1":a.styles["list-style-type"]="decimal";break;default:a.styles["list-style-type"]=a.attributes.type}},splitMarginShorthand:function(a){function b(d){a.styles["margin-top"]=
c[d[0]];a.styles["margin-right"]=c[d[1]];a.styles["margin-bottom"]=c[d[2]];a.styles["margin-left"]=c[d[3]]}if(a.styles.margin){var c=a.styles.margin.match(/(auto|0|(?:\-?[\.\d]+(?:\w+|%)))/g)||["0px"];switch(c.length){case 1:b([0,0,0,0]);break;case 2:b([0,1,0,1]);break;case 3:b([0,1,2,1]);break;case 4:b([0,1,2,3])}delete a.styles.margin}},matchesStyle:F,transform:function(a,b){if("string"==typeof b)a.name=b;else{var c=b.getDefinition(),d=c.styles,f=c.attributes,e,g,m,v;a.name=c.element;for(e in f)if("class"==
e)for(c=a.classes.join("|"),m=f[e].split(/\s+/);v=m.pop();)-1==c.indexOf(v)&&a.classes.push(v);else a.attributes[e]=f[e];for(g in d)a.styles[g]=d[g]}}}})();
(function(){CKEDITOR.focusManager=function(a){if(a.focusManager)return a.focusManager;this.hasFocus=!1;this.currentActive=null;this._={editor:a};return this};CKEDITOR.focusManager._={blurDelay:200};CKEDITOR.focusManager.prototype={focus:function(a){this._.timer&&clearTimeout(this._.timer);a&&(this.currentActive=a);this.hasFocus||this._.locked||((a=CKEDITOR.currentInstance)&&a.focusManager.blur(1),this.hasFocus=!0,(a=this._.editor.container)&&a.addClass("cke_focus"),this._.editor.fire("focus"))},lock:function(){this._.locked=
1},unlock:function(){delete this._.locked},blur:function(a){function d(){if(this.hasFocus){this.hasFocus=!1;var a=this._.editor.container;a&&a.removeClass("cke_focus");this._.editor.fire("blur")}}if(!this._.locked){this._.timer&&clearTimeout(this._.timer);var b=CKEDITOR.focusManager._.blurDelay;a||!b?d.call(this):this._.timer=CKEDITOR.tools.setTimeout(function(){delete this._.timer;d.call(this)},b,this)}},add:function(a,d){var b=a.getCustomData("focusmanager");if(!b||b!=this){b&&b.remove(a);var b=
"focus",c="blur";d&&(CKEDITOR.env.ie?(b="focusin",c="focusout"):CKEDITOR.event.useCapture=1);var g={blur:function(){a.equals(this.currentActive)&&this.blur()},focus:function(){this.focus(a)}};a.on(b,g.focus,this);a.on(c,g.blur,this);d&&(CKEDITOR.event.useCapture=0);a.setCustomData("focusmanager",this);a.setCustomData("focusmanager_handlers",g)}},remove:function(a){a.removeCustomData("focusmanager");var d=a.removeCustomData("focusmanager_handlers");a.removeListener("blur",d.blur);a.removeListener("focus",
d.focus)}}})();CKEDITOR.keystrokeHandler=function(a){if(a.keystrokeHandler)return a.keystrokeHandler;this.keystrokes={};this.blockedKeystrokes={};this._={editor:a};return this};
(function(){var a,d=function(b){b=b.data;var d=b.getKeystroke(),f=this.keystrokes[d],l=this._.editor;a=!1===l.fire("key",{keyCode:d,domEvent:b});a||(f&&(a=!1!==l.execCommand(f,{from:"keystrokeHandler"})),a||(a=!!this.blockedKeystrokes[d]));a&&b.preventDefault(!0);return!a},b=function(b){a&&(a=!1,b.data.preventDefault(!0))};CKEDITOR.keystrokeHandler.prototype={attach:function(a){a.on("keydown",d,this);if(CKEDITOR.env.gecko&&CKEDITOR.env.mac)a.on("keypress",b,this)}}})();
(function(){CKEDITOR.lang={languages:{af:1,ar:1,az:1,bg:1,bn:1,bs:1,ca:1,cs:1,cy:1,da:1,de:1,"de-ch":1,el:1,"en-au":1,"en-ca":1,"en-gb":1,en:1,eo:1,es:1,"es-mx":1,et:1,eu:1,fa:1,fi:1,fo:1,"fr-ca":1,fr:1,gl:1,gu:1,he:1,hi:1,hr:1,hu:1,id:1,is:1,it:1,ja:1,ka:1,km:1,ko:1,ku:1,lt:1,lv:1,mk:1,mn:1,ms:1,nb:1,nl:1,no:1,oc:1,pl:1,"pt-br":1,pt:1,ro:1,ru:1,si:1,sk:1,sl:1,sq:1,"sr-latn":1,sr:1,sv:1,th:1,tr:1,tt:1,ug:1,uk:1,vi:1,"zh-cn":1,zh:1},rtl:{ar:1,fa:1,he:1,ku:1,ug:1},load:function(a,d,b){a&&CKEDITOR.lang.languages[a]||
(a=this.detect(d,a));var c=this;d=function(){c[a].dir=c.rtl[a]?"rtl":"ltr";b(a,c[a])};this[a]?d():CKEDITOR.scriptLoader.load(CKEDITOR.getUrl("lang/"+a+".js"),d,this)},detect:function(a,d){var b=this.languages;d=d||navigator.userLanguage||navigator.language||a;var c=d.toLowerCase().match(/([a-z]+)(?:-([a-z]+))?/),g=c[1],c=c[2];b[g+"-"+c]?g=g+"-"+c:b[g]||(g=null);CKEDITOR.lang.detect=g?function(){return g}:function(a){return a};return g||a}}})();
CKEDITOR.scriptLoader=function(){var a={},d={};return{load:function(b,c,g,f){var l="string"==typeof b;l&&(b=[b]);g||(g=CKEDITOR);var h=b.length,k=h,p=[],e=[],z=function(a){c&&(l?c.call(g,a):c.call(g,p,e))};if(0===k)z(!0);else{var w=function(a,b){(b?p:e).push(a);0>=--k&&(f&&CKEDITOR.document.getDocumentElement().removeStyle("cursor"),z(b))},y=function(b,c){a[b]=1;var f=d[b];delete d[b];for(var e=0;e<f.length;e++)f[e](b,c)},G=function(b){if(a[b])w(b,!0);else{var f=d[b]||(d[b]=[]);f.push(w);if(!(1<f.length)){var e=
new CKEDITOR.dom.element("script");e.setAttributes({type:"text/javascript",src:b});c&&(CKEDITOR.env.ie&&(8>=CKEDITOR.env.version||CKEDITOR.env.ie9Compat)?e.$.onreadystatechange=function(){if("loaded"==e.$.readyState||"complete"==e.$.readyState)e.$.onreadystatechange=null,y(b,!0)}:(e.$.onload=function(){setTimeout(function(){e.$.onload=null;e.$.onerror=null;y(b,!0)},0)},e.$.onerror=function(){e.$.onload=null;e.$.onerror=null;y(b,!1)}));e.appendTo(CKEDITOR.document.getHead())}}};f&&CKEDITOR.document.getDocumentElement().setStyle("cursor",
"wait");for(var q=0;q<h;q++)G(b[q])}},queue:function(){function a(){var b;(b=c[0])&&this.load(b.scriptUrl,b.callback,CKEDITOR,0)}var c=[];return function(d,f){var l=this;c.push({scriptUrl:d,callback:function(){f&&f.apply(this,arguments);c.shift();a.call(l)}});1==c.length&&a.call(this)}}()}}();CKEDITOR.resourceManager=function(a,d){this.basePath=a;this.fileName=d;this.registered={};this.loaded={};this.externals={};this._={waitingList:{}}};
CKEDITOR.resourceManager.prototype={add:function(a,d){if(this.registered[a])throw Error('[CKEDITOR.resourceManager.add] The resource name "'+a+'" is already registered.');var b=this.registered[a]=d||{};b.name=a;b.path=this.getPath(a);CKEDITOR.fire(a+CKEDITOR.tools.capitalize(this.fileName)+"Ready",b);return this.get(a)},get:function(a){return this.registered[a]||null},getPath:function(a){var d=this.externals[a];return CKEDITOR.getUrl(d&&d.dir||this.basePath+a+"/")},getFilePath:function(a){var d=this.externals[a];
return CKEDITOR.getUrl(this.getPath(a)+(d?d.file:this.fileName+".js"))},addExternal:function(a,d,b){b||(d=d.replace(/[^\/]+$/,function(a){b=a;return""}));b=b||this.fileName+".js";a=a.split(",");for(var c=0;c<a.length;c++)this.externals[a[c]]={dir:d,file:b}},load:function(a,d,b){CKEDITOR.tools.isArray(a)||(a=a?[a]:[]);for(var c=this.loaded,g=this.registered,f=[],l={},h={},k=0;k<a.length;k++){var p=a[k];if(p)if(c[p]||g[p])h[p]=this.get(p);else{var e=this.getFilePath(p);f.push(e);e in l||(l[e]=[]);l[e].push(p)}}CKEDITOR.scriptLoader.load(f,
function(a,f){if(f.length)throw Error('[CKEDITOR.resourceManager.load] Resource name "'+l[f[0]].join(",")+'" was not found at "'+f[0]+'".');for(var e=0;e<a.length;e++)for(var g=l[a[e]],k=0;k<g.length;k++){var n=g[k];h[n]=this.get(n);c[n]=1}d.call(b,h)},this)}};CKEDITOR.plugins=new CKEDITOR.resourceManager("plugins/","plugin");
CKEDITOR.plugins.load=CKEDITOR.tools.override(CKEDITOR.plugins.load,function(a){var d={};return function(b,c,g){var f={},l=function(b){a.call(this,b,function(a){CKEDITOR.tools.extend(f,a);var b=[],e;for(e in a){var h=a[e],w=h&&h.requires;if(!d[e]){if(h.icons)for(var y=h.icons.split(","),G=y.length;G--;)CKEDITOR.skin.addIcon(y[G],h.path+"icons/"+(CKEDITOR.env.hidpi&&h.hidpi?"hidpi/":"")+y[G]+".png");h.isSupportedEnvironment=h.isSupportedEnvironment||function(){return!0};d[e]=1}if(w)for(w.split&&(w=
w.split(",")),h=0;h<w.length;h++)f[w[h]]||b.push(w[h])}if(b.length)l.call(this,b);else{for(e in f)h=f[e],h.onLoad&&!h.onLoad._called&&(!1===h.onLoad()&&delete f[e],h.onLoad._called=1);c&&c.call(g||window,f)}},this)};l.call(this,b)}});CKEDITOR.plugins.setLang=function(a,d,b){var c=this.get(a);a=c.langEntries||(c.langEntries={});c=c.lang||(c.lang=[]);c.split&&(c=c.split(","));-1==CKEDITOR.tools.indexOf(c,d)&&c.push(d);a[d]=b};
CKEDITOR.ui=function(a){if(a.ui)return a.ui;this.items={};this.instances={};this.editor=a;this._={handlers:{}};return this};
CKEDITOR.ui.prototype={add:function(a,d,b){b.name=a.toLowerCase();var c=this.items[a]={type:d,command:b.command||null,args:Array.prototype.slice.call(arguments,2)};CKEDITOR.tools.extend(c,b)},get:function(a){return this.instances[a]},create:function(a){var d=this.items[a],b=d&&this._.handlers[d.type],c=d&&d.command&&this.editor.getCommand(d.command),b=b&&b.create.apply(this,d.args);this.instances[a]=b;c&&c.uiItems.push(b);b&&!b.type&&(b.type=d.type);return b},addHandler:function(a,d){this._.handlers[a]=
d},space:function(a){return CKEDITOR.document.getById(this.spaceId(a))},spaceId:function(a){return this.editor.id+"_"+a}};CKEDITOR.event.implementOn(CKEDITOR.ui);
(function(){function a(a,e,g){CKEDITOR.event.call(this);a=a&&CKEDITOR.tools.clone(a);if(void 0!==e){if(!(e instanceof CKEDITOR.dom.element))throw Error("Expect element of type CKEDITOR.dom.element.");if(!g)throw Error("One of the element modes must be specified.");if(CKEDITOR.env.ie&&CKEDITOR.env.quirks&&g==CKEDITOR.ELEMENT_MODE_INLINE)throw Error("Inline element mode is not supported on IE quirks.");if(!b(e,g))throw Error('The specified element mode is not supported on element: "'+e.getName()+'".');
this.element=e;this.elementMode=g;this.name=this.elementMode!=CKEDITOR.ELEMENT_MODE_APPENDTO&&(e.getId()||e.getNameAtt())}else this.elementMode=CKEDITOR.ELEMENT_MODE_NONE;this._={};this.commands={};this.templates={};this.name=this.name||d();this.id=CKEDITOR.tools.getNextId();this.status="unloaded";this.config=CKEDITOR.tools.prototypedCopy(CKEDITOR.config);this.ui=new CKEDITOR.ui(this);this.focusManager=new CKEDITOR.focusManager(this);this.keystrokeHandler=new CKEDITOR.keystrokeHandler(this);this.on("readOnly",
c);this.on("selectionChange",function(a){f(this,a.data.path)});this.on("activeFilterChange",function(){f(this,this.elementPath(),!0)});this.on("mode",c);CKEDITOR.dom.selection.setupEditorOptimization(this);this.on("instanceReady",function(){if(this.config.startupFocus){if("end"===this.config.startupFocus){var a=this.createRange();a.selectNodeContents(this.editable());a.shrink(CKEDITOR.SHRINK_ELEMENT,!0);a.collapse();this.getSelection().selectRanges([a])}this.focus()}});CKEDITOR.fire("instanceCreated",
null,this);CKEDITOR.add(this);CKEDITOR.tools.setTimeout(function(){this.isDestroyed()||this.isDetached()||h(this,a)},0,this)}function d(){do var a="editor"+ ++G;while(CKEDITOR.instances[a]);return a}function b(a,b){return b==CKEDITOR.ELEMENT_MODE_INLINE?a.is(CKEDITOR.dtd.$editable)||a.is("textarea"):b==CKEDITOR.ELEMENT_MODE_REPLACE?!a.is(CKEDITOR.dtd.$nonBodyContent):1}function c(){var a=this.commands,b;for(b in a)g(this,a[b])}function g(a,b){b[b.startDisabled?"disable":a.readOnly&&!b.readOnly?"disable":
b.modes[a.mode]?"enable":"disable"]()}function f(a,b,c){if(b){var d,f,e=a.commands;for(f in e)d=e[f],(c||d.contextSensitive)&&d.refresh(a,b)}}function l(a){var b=a.config.customConfig;if(!b)return!1;var b=CKEDITOR.getUrl(b),c=q[b]||(q[b]={});c.fn?(c.fn.call(a,a.config),CKEDITOR.getUrl(a.config.customConfig)!=b&&l(a)||a.fireOnce("customConfigLoaded")):CKEDITOR.scriptLoader.queue(b,function(){c.fn=c.fn||CKEDITOR.editorConfig||function(){};l(a)});return!0}function h(a,b){a.on("customConfigLoaded",function(){if(b){if(b.on)for(var c in b.on)a.on(c,
b.on[c]);CKEDITOR.tools.extend(a.config,b,!0);delete a.config.on}c=a.config;a.readOnly=c.readOnly?!0:a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE?a.element.is("textarea")?a.element.hasAttribute("disabled")||a.element.hasAttribute("readonly"):a.element.isReadOnly():a.elementMode==CKEDITOR.ELEMENT_MODE_REPLACE?a.element.hasAttribute("disabled")||a.element.hasAttribute("readonly"):!1;a.blockless=a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE?!(a.element.is("textarea")||CKEDITOR.dtd[a.element.getName()].p):
!1;a.tabIndex=c.tabIndex||a.element&&a.element.getAttribute("tabindex")||0;a.activeEnterMode=a.enterMode=a.blockless?CKEDITOR.ENTER_BR:c.enterMode;a.activeShiftEnterMode=a.shiftEnterMode=a.blockless?CKEDITOR.ENTER_BR:c.shiftEnterMode;c.skin&&(CKEDITOR.skinName=c.skin);a.fireOnce("configLoaded");a.dataProcessor=new CKEDITOR.htmlDataProcessor(a);a.filter=a.activeFilter=new CKEDITOR.filter(a);k(a)});b&&null!=b.customConfig&&(a.config.customConfig=b.customConfig);l(a)||a.fireOnce("customConfigLoaded")}
function k(a){CKEDITOR.skin.loadPart("editor",function(){p(a)})}function p(a){CKEDITOR.lang.load(a.config.language,a.config.defaultLanguage,function(b,c){var d=a.config.title;a.langCode=b;a.lang=CKEDITOR.tools.prototypedCopy(c);a.title="string"==typeof d||!1===d?d:[a.lang.editor,a.name].join(", ");a.config.contentsLangDirection||(a.config.contentsLangDirection=a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE?a.element.getDirection(1):a.lang.dir);a.fire("langLoaded");e(a)})}function e(a){a.getStylesSet(function(b){a.once("loaded",
function(){a.fire("stylesSet",{styles:b})},null,null,1);z(a)})}function z(a){function b(a){if(!a)return"";CKEDITOR.tools.isArray(a)&&(a=a.join(","));return a.replace(/\s/g,"")}var c=a.config,d=b(c.plugins),f=b(c.extraPlugins),e=b(c.removePlugins);if(f)var g=new RegExp("(?:^|,)(?:"+f.replace(/,/g,"|")+")(?\x3d,|$)","g"),d=d.replace(g,""),d=d+(","+f);if(e)var h=new RegExp("(?:^|,)(?:"+e.replace(/,/g,"|")+")(?\x3d,|$)","g"),d=d.replace(h,"");CKEDITOR.env.air&&(d+=",adobeair");CKEDITOR.plugins.load(d.split(","),
function(b){var d=[],f=[],e=[];a.plugins=CKEDITOR.tools.extend({},a.plugins,b);for(var g in b){var m=b[g],l=m.lang,k=null,t=m.requires,P;CKEDITOR.tools.isArray(t)&&(t=t.join(","));if(t&&(P=t.match(h)))for(;t=P.pop();)CKEDITOR.error("editor-plugin-required",{plugin:t.replace(",",""),requiredBy:g});l&&!a.lang[g]&&(l.split&&(l=l.split(",")),0<=CKEDITOR.tools.indexOf(l,a.langCode)?k=a.langCode:(k=a.langCode.replace(/-.*/,""),k=k!=a.langCode&&0<=CKEDITOR.tools.indexOf(l,k)?k:0<=CKEDITOR.tools.indexOf(l,
"en")?"en":l[0]),m.langEntries&&m.langEntries[k]?(a.lang[g]=m.langEntries[k],k=null):e.push(CKEDITOR.getUrl(m.path+"lang/"+k+".js")));f.push(k);d.push(m)}CKEDITOR.scriptLoader.load(e,function(){if(!a.isDestroyed()&&!a.isDetached()){for(var b=["beforeInit","init","afterInit"],e=0;e<b.length;e++)for(var g=0;g<d.length;g++){var m=d[g];0===e&&f[g]&&m.lang&&m.langEntries&&(a.lang[m.name]=m.langEntries[f[g]]);if(m[b[e]])m[b[e]](a)}a.fireOnce("pluginsLoaded");c.keystrokes&&a.setKeystroke(a.config.keystrokes);
for(g=0;g<a.config.blockedKeystrokes.length;g++)a.keystrokeHandler.blockedKeystrokes[a.config.blockedKeystrokes[g]]=1;a.status="loaded";a.fireOnce("loaded");CKEDITOR.fire("instanceLoaded",null,a)}})})}function w(){var a=this.element;if(a&&this.elementMode!=CKEDITOR.ELEMENT_MODE_APPENDTO){var b=this.getData();this.config.htmlEncodeOutput&&(b=CKEDITOR.tools.htmlEncode(b));a.is("textarea")?a.setValue(b):a.setHtml(b);return!0}return!1}function y(a,b){function c(a){var b=a.startContainer,d=a.endContainer;
return b.is&&(b.is("tr")||b.is("td")&&b.equals(d)&&a.endOffset===b.getChildCount())?!0:!1}function d(a){var b=a.startContainer;return b.is("tr")?a.cloneContents():b.clone(!0)}for(var f=new CKEDITOR.dom.documentFragment,e,g,h,l=0;l<a.length;l++){var k=a[l],r=k.startContainer.getAscendant("tr",!0);c(k)?(e||(e=r.getAscendant("table").clone(),e.append(r.getAscendant({thead:1,tbody:1,tfoot:1}).clone()),f.append(e),e=e.findOne("thead, tbody, tfoot")),g&&g.equals(r)||(g=r,h=r.clone(),e.append(h)),h.append(d(k))):
f.append(k.cloneContents())}return e?f:b.getHtmlFromRange(a[0])}a.prototype=CKEDITOR.editor.prototype;CKEDITOR.editor=a;var G=0,q={};CKEDITOR.tools.extend(CKEDITOR.editor.prototype,{plugins:{detectConflict:function(a,b){for(var c=0;c<b.length;c++){var d=b[c];if(this[d])return CKEDITOR.warn("editor-plugin-conflict",{plugin:a,replacedWith:d}),!0}return!1}},addCommand:function(a,b){b.name=a.toLowerCase();var c=b instanceof CKEDITOR.command?b:new CKEDITOR.command(this,b);this.mode&&g(this,c);return this.commands[a]=
c},_attachToForm:function(){function a(b){c.updateElement();c._.required&&!d.getValue()&&!1===c.fire("required")&&b.data.preventDefault()}function b(a){return!!(a&&a.call&&a.apply)}var c=this,d=c.element,f=new CKEDITOR.dom.element(d.$.form);d.is("textarea")&&f&&(f.on("submit",a),b(f.$.submit)&&(f.$.submit=CKEDITOR.tools.override(f.$.submit,function(b){return function(){a();b.apply?b.apply(this):b()}})),c.on("destroy",function(){f.removeListener("submit",a)}))},destroy:function(a){var b=CKEDITOR.filter.instances,
c=this;this.fire("beforeDestroy");!a&&w.call(this);this.editable(null);this.filter&&delete this.filter;CKEDITOR.tools.array.forEach(CKEDITOR.tools.object.keys(b),function(a){a=b[a];c===a.editor&&a.destroy()});delete this.activeFilter;this.status="destroyed";this.fire("destroy");this.removeAllListeners();CKEDITOR.remove(this);CKEDITOR.fire("instanceDestroyed",null,this)},elementPath:function(a){if(!a){a=this.getSelection();if(!a)return null;a=a.getStartElement()}return a?new CKEDITOR.dom.elementPath(a,
this.editable()):null},createRange:function(){var a=this.editable();return a?new CKEDITOR.dom.range(a):null},execCommand:function(a,b){var c=this.getCommand(a),d={name:a,commandData:b||{},command:c};return c&&c.state!=CKEDITOR.TRISTATE_DISABLED&&!1!==this.fire("beforeCommandExec",d)&&(d.returnValue=c.exec(d.commandData),!c.async&&!1!==this.fire("afterCommandExec",d))?d.returnValue:!1},getCommand:function(a){return this.commands[a]},getData:function(a){!a&&this.fire("beforeGetData");var b=this._.data;
"string"!=typeof b&&(b=(b=this.element)&&this.elementMode==CKEDITOR.ELEMENT_MODE_REPLACE?b.is("textarea")?b.getValue():b.getHtml():"");b={dataValue:b};!a&&this.fire("getData",b);return b.dataValue},getSnapshot:function(){var a=this.fire("getSnapshot");"string"!=typeof a&&(a=(a=this.element)&&this.elementMode==CKEDITOR.ELEMENT_MODE_REPLACE?a.is("textarea")?a.getValue():a.getHtml():"");return a},loadSnapshot:function(a){this.fire("loadSnapshot",a)},setData:function(a,b,c){var d=!0,f=b;b&&"object"==
typeof b&&(c=b.internal,f=b.callback,d=!b.noSnapshot);!c&&d&&this.fire("saveSnapshot");if(f||!c)this.once("dataReady",function(a){!c&&d&&this.fire("saveSnapshot");f&&f.call(a.editor)});a={dataValue:a};!c&&this.fire("setData",a);this._.data=a.dataValue;!c&&this.fire("afterSetData",a)},setReadOnly:function(a){a=null==a||a;this.readOnly!=a&&(this.readOnly=a,this.keystrokeHandler.blockedKeystrokes[8]=+a,this.editable().setReadOnly(a),this.fire("readOnly"))},insertHtml:function(a,b,c){this.fire("insertHtml",
{dataValue:a,mode:b,range:c})},insertText:function(a){this.fire("insertText",a)},insertElement:function(a){this.fire("insertElement",a)},getSelectedHtml:function(a){var b=this.editable(),c=this.getSelection(),c=c&&c.getRanges();if(!b||!c||0===c.length)return null;b=y(c,b);return a?b.getHtml():b},extractSelectedHtml:function(a,b){var c=this.editable(),d=this.getSelection().getRanges(),f=new CKEDITOR.dom.documentFragment,e;if(!c||0===d.length)return null;for(e=0;e<d.length;e++)f.append(c.extractHtmlFromRange(d[e],
b));b||this.getSelection().selectRanges([d[0]]);return a?f.getHtml():f},focus:function(){this.fire("beforeFocus")},checkDirty:function(){return"ready"==this.status&&this._.previousValue!==this.getSnapshot()},resetDirty:function(){this._.previousValue=this.getSnapshot()},updateElement:function(){return w.call(this)},setKeystroke:function(){for(var a=this.keystrokeHandler.keystrokes,b=CKEDITOR.tools.isArray(arguments[0])?arguments[0]:[[].slice.call(arguments,0)],c,d,f=b.length;f--;)c=b[f],d=0,CKEDITOR.tools.isArray(c)&&
(d=c[1],c=c[0]),d?a[c]=d:delete a[c]},getCommandKeystroke:function(a,b){var c="string"===typeof a?this.getCommand(a):a,d=[];if(c){var f=CKEDITOR.tools.object.findKey(this.commands,c),e=this.keystrokeHandler.keystrokes;if(c.fakeKeystroke)d.push(c.fakeKeystroke);else for(var g in e)e[g]===f&&d.push(g)}return b?d:d[0]||null},addFeature:function(a){return this.filter.addFeature(a)},setActiveFilter:function(a){a||(a=this.filter);this.activeFilter!==a&&(this.activeFilter=a,this.fire("activeFilterChange"),
a===this.filter?this.setActiveEnterMode(null,null):this.setActiveEnterMode(a.getAllowedEnterMode(this.enterMode),a.getAllowedEnterMode(this.shiftEnterMode,!0)))},setActiveEnterMode:function(a,b){a=a?this.blockless?CKEDITOR.ENTER_BR:a:this.enterMode;b=b?this.blockless?CKEDITOR.ENTER_BR:b:this.shiftEnterMode;if(this.activeEnterMode!=a||this.activeShiftEnterMode!=b)this.activeEnterMode=a,this.activeShiftEnterMode=b,this.fire("activeEnterModeChange")},showNotification:function(a){alert(a)},isDetached:function(){return!!this.container&&
this.container.isDetached()},isDestroyed:function(){return"destroyed"===this.status}});CKEDITOR.editor._getEditorElement=function(a){if(!CKEDITOR.env.isCompatible)return null;var b=CKEDITOR.dom.element.get(a);return b?b.getEditor()?(CKEDITOR.error("editor-element-conflict",{editorName:b.getEditor().name}),null):b:(CKEDITOR.error("editor-incorrect-element",{element:a}),null)}})();CKEDITOR.ELEMENT_MODE_NONE=0;CKEDITOR.ELEMENT_MODE_REPLACE=1;CKEDITOR.ELEMENT_MODE_APPENDTO=2;
CKEDITOR.ELEMENT_MODE_INLINE=3;CKEDITOR.htmlParser=function(){this._={htmlPartsRegex:/<(?:(?:\/([^>]+)>)|(?:!--([\S|\s]*?)--\x3e)|(?:([^\/\s>]+)((?:\s+[\w\-:.]+(?:\s*=\s*?(?:(?:"[^"]*")|(?:'[^']*')|[^\s"'\/>]+))?)*)[\S\s]*?(\/?)>))/g}};
(function(){var a=/([\w\-:.]+)(?:(?:\s*=\s*(?:(?:"([^"]*)")|(?:'([^']*)')|([^\s>]+)))|(?=\s|$))/g,d={checked:1,compact:1,declare:1,defer:1,disabled:1,ismap:1,multiple:1,nohref:1,noresize:1,noshade:1,nowrap:1,readonly:1,selected:1};CKEDITOR.htmlParser.prototype={onTagOpen:function(){},onTagClose:function(){},onText:function(){},onCDATA:function(){},onComment:function(){},parse:function(b){for(var c,g,f=0,l;c=this._.htmlPartsRegex.exec(b);){g=c.index;if(g>f)if(f=b.substring(f,g),l)l.push(f);else this.onText(f);
f=this._.htmlPartsRegex.lastIndex;if(g=c[1])if(g=g.toLowerCase(),l&&CKEDITOR.dtd.$cdata[g]&&(this.onCDATA(l.join("")),l=null),!l){this.onTagClose(g);continue}if(l)l.push(c[0]);else if(g=c[3]){if(g=g.toLowerCase(),!/="/.test(g)){var h={},k,p=c[4];c=!!c[5];if(p)for(;k=a.exec(p);){var e=k[1].toLowerCase();k=k[2]||k[3]||k[4]||"";h[e]=!k&&d[e]?e:CKEDITOR.tools.htmlDecodeAttr(k)}this.onTagOpen(g,h,c);!l&&CKEDITOR.dtd.$cdata[g]&&(l=[])}}else if(g=c[2])this.onComment(g)}if(b.length>f)this.onText(b.substring(f,
b.length))}}})();
CKEDITOR.htmlParser.basicWriter=CKEDITOR.tools.createClass({$:function(){this._={output:[]}},proto:{openTag:function(a){this._.output.push("\x3c",a)},openTagClose:function(a,d){d?this._.output.push(" /\x3e"):this._.output.push("\x3e")},attribute:function(a,d){"string"==typeof d&&(d=CKEDITOR.tools.htmlEncodeAttr(d));this._.output.push(" ",a,'\x3d"',d,'"')},closeTag:function(a){this._.output.push("\x3c/",a,"\x3e")},text:function(a){this._.output.push(a)},comment:function(a){this._.output.push("\x3c!--",a,
"--\x3e")},write:function(a){this._.output.push(a)},reset:function(){this._.output=[];this._.indent=!1},getHtml:function(a){var d=this._.output.join("");a&&this.reset();return d}}});"use strict";
(function(){CKEDITOR.htmlParser.node=function(){};CKEDITOR.htmlParser.node.prototype={remove:function(){var a=this.parent.children,d=CKEDITOR.tools.indexOf(a,this),b=this.previous,c=this.next;b&&(b.next=c);c&&(c.previous=b);a.splice(d,1);this.parent=null},replaceWith:function(a){var d=this.parent.children,b=CKEDITOR.tools.indexOf(d,this),c=a.previous=this.previous,g=a.next=this.next;c&&(c.next=a);g&&(g.previous=a);d[b]=a;a.parent=this.parent;this.parent=null},insertAfter:function(a){var d=a.parent.children,
b=CKEDITOR.tools.indexOf(d,a),c=a.next;d.splice(b+1,0,this);this.next=a.next;this.previous=a;a.next=this;c&&(c.previous=this);this.parent=a.parent},insertBefore:function(a){var d=a.parent.children,b=CKEDITOR.tools.indexOf(d,a);d.splice(b,0,this);this.next=a;(this.previous=a.previous)&&(a.previous.next=this);a.previous=this;this.parent=a.parent},getAscendant:function(a){var d="function"==typeof a?a:"string"==typeof a?function(b){return b.name==a}:function(b){return b.name in a},b=this.parent;for(;b&&
b.type==CKEDITOR.NODE_ELEMENT;){if(d(b))return b;b=b.parent}return null},wrapWith:function(a){this.replaceWith(a);a.add(this);return a},getIndex:function(){return CKEDITOR.tools.indexOf(this.parent.children,this)},getFilterContext:function(a){return a||{}}}})();"use strict";CKEDITOR.htmlParser.comment=function(a){this.value=a;this._={isBlockLike:!1}};
CKEDITOR.htmlParser.comment.prototype=CKEDITOR.tools.extend(new CKEDITOR.htmlParser.node,{type:CKEDITOR.NODE_COMMENT,filter:function(a,d){var b=this.value;if(!(b=a.onComment(d,b,this)))return this.remove(),!1;if("string"!=typeof b)return this.replaceWith(b),!1;this.value=b;return!0},writeHtml:function(a,d){d&&this.filter(d);a.comment(this.value)}});"use strict";
(function(){CKEDITOR.htmlParser.text=function(a){this.value=a;this._={isBlockLike:!1}};CKEDITOR.htmlParser.text.prototype=CKEDITOR.tools.extend(new CKEDITOR.htmlParser.node,{type:CKEDITOR.NODE_TEXT,filter:function(a,d){if(!(this.value=a.onText(d,this.value,this)))return this.remove(),!1},writeHtml:function(a,d){d&&this.filter(d);a.text(this.value)}})})();"use strict";
(function(){CKEDITOR.htmlParser.cdata=function(a){this.value=a};CKEDITOR.htmlParser.cdata.prototype=CKEDITOR.tools.extend(new CKEDITOR.htmlParser.node,{type:CKEDITOR.NODE_TEXT,filter:function(){},writeHtml:function(a){a.write(this.value)}})})();"use strict";CKEDITOR.htmlParser.fragment=function(){this.children=[];this.parent=null;this._={isBlockLike:!0,hasInlineStarted:!1}};
(function(){function a(a){return a.attributes["data-cke-survive"]?!1:"a"==a.name&&a.attributes.href||CKEDITOR.dtd.$removeEmpty[a.name]}var d=CKEDITOR.tools.extend({table:1,ul:1,ol:1,dl:1},CKEDITOR.dtd.table,CKEDITOR.dtd.ul,CKEDITOR.dtd.ol,CKEDITOR.dtd.dl),b={ol:1,ul:1},c=CKEDITOR.tools.extend({},{html:1},CKEDITOR.dtd.html,CKEDITOR.dtd.body,CKEDITOR.dtd.head,{style:1,script:1}),g={ul:"li",ol:"li",dl:"dd",table:"tbody",tbody:"tr",thead:"tr",tfoot:"tr",tr:"td"};CKEDITOR.htmlParser.fragment.fromHtml=
function(f,l,h){function k(a){var b;if(0<n.length)for(var c=0;c<n.length;c++){var d=n[c],f=d.name,e=CKEDITOR.dtd[f],g=x.name&&CKEDITOR.dtd[x.name];g&&!g[f]||a&&e&&!e[a]&&CKEDITOR.dtd[a]?f==x.name&&(z(x,x.parent,1),c--):(b||(p(),b=1),d=d.clone(),d.parent=x,x=d,n.splice(c,1),c--)}}function p(){for(;H.length;)z(H.shift(),x)}function e(a){if(a._.isBlockLike&&"pre"!=a.name&&"textarea"!=a.name){var b=a.children.length,c=a.children[b-1],d;c&&c.type==CKEDITOR.NODE_TEXT&&((d=CKEDITOR.tools.rtrim(c.value))?
c.value=d:a.children.length=b-1)}}function z(b,c,d){c=c||x||q;var f=x;void 0===b.previous&&(w(c,b)&&(x=c,G.onTagOpen(h,{}),b.returnPoint=c=x),e(b),a(b)&&!b.children.length||c.add(b),"pre"==b.name&&(K=!1),"textarea"==b.name&&(I=!1));b.returnPoint?(x=b.returnPoint,delete b.returnPoint):x=d?c:f}function w(a,b){if((a==q||"body"==a.name)&&h&&(!a.name||CKEDITOR.dtd[a.name][h])){var c,d;return(c=b.attributes&&(d=b.attributes["data-cke-real-element-type"])?d:b.name)&&c in CKEDITOR.dtd.$inline&&!(c in CKEDITOR.dtd.head)&&
!b.isOrphan||b.type==CKEDITOR.NODE_TEXT}}function y(a,b){return a in CKEDITOR.dtd.$listItem||a in CKEDITOR.dtd.$tableContent?a==b||"dt"==a&&"dd"==b||"dd"==a&&"dt"==b:!1}var G=new CKEDITOR.htmlParser,q=l instanceof CKEDITOR.htmlParser.element?l:"string"==typeof l?new CKEDITOR.htmlParser.element(l):new CKEDITOR.htmlParser.fragment,n=[],H=[],x=q,I="textarea"==q.name,K="pre"==q.name;G.onTagOpen=function(f,e,g,h){e=new CKEDITOR.htmlParser.element(f,e);e.isUnknown&&g&&(e.isEmpty=!0);e.isOptionalClose=h;
if(a(e))n.push(e);else{if("pre"==f)K=!0;else{if("br"==f&&K){x.add(new CKEDITOR.htmlParser.text("\n"));return}"textarea"==f&&(I=!0)}if("br"==f)H.push(e);else{for(;!(h=(g=x.name)?CKEDITOR.dtd[g]||(x._.isBlockLike?CKEDITOR.dtd.div:CKEDITOR.dtd.span):c,e.isUnknown||x.isUnknown||h[f]);)if(x.isOptionalClose)G.onTagClose(g);else if(f in b&&g in b)g=x.children,(g=g[g.length-1])&&"li"==g.name||z(g=new CKEDITOR.htmlParser.element("li"),x),!e.returnPoint&&(e.returnPoint=x),x=g;else if(f in CKEDITOR.dtd.$listItem&&
!y(f,g))G.onTagOpen("li"==f?"ul":"dl",{},0,1);else if(g in d&&!y(f,g))!e.returnPoint&&(e.returnPoint=x),x=x.parent;else if(g in CKEDITOR.dtd.$inline&&n.unshift(x),x.parent)z(x,x.parent,1);else{e.isOrphan=1;break}k(f);p();e.parent=x;e.isEmpty?z(e):x=e}}};G.onTagClose=function(a){for(var b=n.length-1;0<=b;b--)if(a==n[b].name){n.splice(b,1);return}for(var c=[],d=[],f=x;f!=q&&f.name!=a;)f._.isBlockLike||d.unshift(f),c.push(f),f=f.returnPoint||f.parent;if(f!=q){for(b=0;b<c.length;b++){var e=c[b];z(e,e.parent)}x=
f;f._.isBlockLike&&p();z(f,f.parent);f==x&&(x=x.parent);n=n.concat(d)}"body"==a&&(h=!1)};G.onText=function(a){if(!(x._.hasInlineStarted&&!H.length||K||I)&&(a=CKEDITOR.tools.ltrim(a),0===a.length))return;var b=x.name,f=b?CKEDITOR.dtd[b]||(x._.isBlockLike?CKEDITOR.dtd.div:CKEDITOR.dtd.span):c;if(!I&&!f["#"]&&b in d)G.onTagOpen(g[b]||""),G.onText(a);else{p();k();K||I||(a=a.replace(/[\t\r\n ]{2,}|[\t\r\n]/g," "));a=new CKEDITOR.htmlParser.text(a);if(w(x,a))this.onTagOpen(h,{},0,1);x.add(a)}};G.onCDATA=
function(a){x.add(new CKEDITOR.htmlParser.cdata(a))};G.onComment=function(a){p();k();x.add(new CKEDITOR.htmlParser.comment(a))};G.parse(f);for(p();x!=q;)z(x,x.parent,1);e(q);return q};CKEDITOR.htmlParser.fragment.prototype={type:CKEDITOR.NODE_DOCUMENT_FRAGMENT,add:function(a,b){isNaN(b)&&(b=this.children.length);var c=0<b?this.children[b-1]:null;if(c){if(a._.isBlockLike&&c.type==CKEDITOR.NODE_TEXT&&(c.value=CKEDITOR.tools.rtrim(c.value),0===c.value.length)){this.children.pop();this.add(a);return}c.next=
a}a.previous=c;a.parent=this;this.children.splice(b,0,a);this._.hasInlineStarted||(this._.hasInlineStarted=a.type==CKEDITOR.NODE_TEXT||a.type==CKEDITOR.NODE_ELEMENT&&!a._.isBlockLike)},filter:function(a,b){b=this.getFilterContext(b);a.onRoot(b,this);this.filterChildren(a,!1,b)},filterChildren:function(a,b,c){if(this.childrenFilteredBy!=a.id){c=this.getFilterContext(c);if(b&&!this.parent)a.onRoot(c,this);this.childrenFilteredBy=a.id;for(b=0;b<this.children.length;b++)!1===this.children[b].filter(a,
c)&&b--}},writeHtml:function(a,b){b&&this.filter(b);this.writeChildrenHtml(a)},writeChildrenHtml:function(a,b,c){var d=this.getFilterContext();if(c&&!this.parent&&b)b.onRoot(d,this);b&&this.filterChildren(b,!1,d);b=0;c=this.children;for(d=c.length;b<d;b++)c[b].writeHtml(a)},forEach:function(a,b,c){if(!(c||b&&this.type!=b))var d=a(this);if(!1!==d){c=this.children;for(var g=0;g<c.length;g++)d=c[g],d.type==CKEDITOR.NODE_ELEMENT?d.forEach(a,b):b&&d.type!=b||a(d)}},getFilterContext:function(a){return a||
{}}}})();"use strict";
(function(){function a(){this.rules=[]}function d(b,c,d,f){var l,h;for(l in c)(h=b[l])||(h=b[l]=new a),h.add(c[l],d,f)}CKEDITOR.htmlParser.filter=CKEDITOR.tools.createClass({$:function(b){this.id=CKEDITOR.tools.getNextNumber();this.elementNameRules=new a;this.attributeNameRules=new a;this.elementsRules={};this.attributesRules={};this.textRules=new a;this.commentRules=new a;this.rootRules=new a;b&&this.addRules(b,10)},proto:{addRules:function(a,c){var g;"number"==typeof c?g=c:c&&"priority"in c&&(g=
c.priority);"number"!=typeof g&&(g=10);"object"!=typeof c&&(c={});a.elementNames&&this.elementNameRules.addMany(a.elementNames,g,c);a.attributeNames&&this.attributeNameRules.addMany(a.attributeNames,g,c);a.elements&&d(this.elementsRules,a.elements,g,c);a.attributes&&d(this.attributesRules,a.attributes,g,c);a.text&&this.textRules.add(a.text,g,c);a.comment&&this.commentRules.add(a.comment,g,c);a.root&&this.rootRules.add(a.root,g,c)},applyTo:function(a){a.filter(this)},onElementName:function(a,c){return this.elementNameRules.execOnName(a,
c)},onAttributeName:function(a,c){return this.attributeNameRules.execOnName(a,c)},onText:function(a,c,d){return this.textRules.exec(a,c,d)},onComment:function(a,c,d){return this.commentRules.exec(a,c,d)},onRoot:function(a,c){return this.rootRules.exec(a,c)},onElement:function(a,c){for(var d=[this.elementsRules["^"],this.elementsRules[c.name],this.elementsRules.$],f,l=0;3>l;l++)if(f=d[l]){f=f.exec(a,c,this);if(!1===f)return null;if(f&&f!=c)return this.onNode(a,f);if(c.parent&&!c.name)break}return c},
onNode:function(a,c){var d=c.type;return d==CKEDITOR.NODE_ELEMENT?this.onElement(a,c):d==CKEDITOR.NODE_TEXT?new CKEDITOR.htmlParser.text(this.onText(a,c.value,c)):d==CKEDITOR.NODE_COMMENT?new CKEDITOR.htmlParser.comment(this.onComment(a,c.value,c)):null},onAttribute:function(a,c,d,f){return(d=this.attributesRules[d])?d.exec(a,f,c,this):f}}});CKEDITOR.htmlParser.filterRulesGroup=a;a.prototype={add:function(a,c,d){this.rules.splice(this.findIndex(c),0,{value:a,priority:c,options:d})},addMany:function(a,
c,d){for(var f=[this.findIndex(c),0],l=0,h=a.length;l<h;l++)f.push({value:a[l],priority:c,options:d});this.rules.splice.apply(this.rules,f)},findIndex:function(a){for(var c=this.rules,d=c.length-1;0<=d&&a<c[d].priority;)d--;return d+1},exec:function(a,c){var d=c instanceof CKEDITOR.htmlParser.node||c instanceof CKEDITOR.htmlParser.fragment,f=Array.prototype.slice.call(arguments,1),l=this.rules,h=l.length,k,p,e,z;for(z=0;z<h;z++)if(d&&(k=c.type,p=c.name),e=l[z],!(a.nonEditable&&!e.options.applyToAll||
a.nestedEditable&&e.options.excludeNestedEditable)){e=e.value.apply(null,f);if(!1===e||d&&e&&(e.name!=p||e.type!=k))return e;null!=e&&(f[0]=c=e)}return c},execOnName:function(a,c){for(var d=0,f=this.rules,l=f.length,h;c&&d<l;d++)h=f[d],a.nonEditable&&!h.options.applyToAll||a.nestedEditable&&h.options.excludeNestedEditable||(c=c.replace(h.value[0],h.value[1]));return c}}})();
(function(){function a(a,d){function e(a){return a||CKEDITOR.env.needsNbspFiller?new CKEDITOR.htmlParser.text(" "):new CKEDITOR.htmlParser.element("br",{"data-cke-bogus":1})}function t(a,d){return function(g){if(g.type!=CKEDITOR.NODE_DOCUMENT_FRAGMENT){var v=[],m=b(g),t,D;if(m)for(r(m,1)&&v.push(m);m;)f(m)&&(t=c(m))&&r(t)&&((D=c(t))&&!f(D)?v.push(t):(e(h).insertAfter(t),t.remove())),m=m.previous;for(m=0;m<v.length;m++)v[m].remove();if(v=!a||!1!==("function"==typeof d?d(g):d))h||CKEDITOR.env.needsBrFiller||
g.type!=CKEDITOR.NODE_DOCUMENT_FRAGMENT?h||CKEDITOR.env.needsBrFiller||!(7<document.documentMode||g.name in CKEDITOR.dtd.tr||g.name in CKEDITOR.dtd.$listItem)?(v=b(g),v=!v||"form"==g.name&&"input"==v.name):v=!1:v=!1;v&&g.add(e(a))}}}function r(a,b){if((!h||CKEDITOR.env.needsBrFiller)&&a.type==CKEDITOR.NODE_ELEMENT&&"br"==a.name&&!a.attributes["data-cke-eol"])return!0;var c;return a.type==CKEDITOR.NODE_TEXT&&(c=a.value.match(H))&&(c.index&&((new CKEDITOR.htmlParser.text(a.value.substring(0,c.index))).insertBefore(a),
a.value=c[0]),!CKEDITOR.env.needsBrFiller&&h&&(!b||a.parent.name in u)||!h&&((c=a.previous)&&"br"==c.name||!c||f(c)))?!0:!1}var D={elements:{}},h="html"==d,u=CKEDITOR.tools.extend({},m),E;for(E in u)"#"in I[E]||delete u[E];for(E in u)D.elements[E]=t(h,a.config.fillEmptyBlocks);D.root=t(h,!1);D.elements.br=function(a){return function(b){if(b.parent.type!=CKEDITOR.NODE_DOCUMENT_FRAGMENT){var d=b.attributes;if("data-cke-bogus"in d||"data-cke-eol"in d)delete d["data-cke-bogus"];else{for(d=b.next;d&&g(d);)d=
d.next;var v=c(b);!d&&f(b.parent)?l(b.parent,e(a)):f(d)&&v&&!f(v)&&e(a).insertBefore(d)}}}}(h);return D}function d(a,b){return a!=CKEDITOR.ENTER_BR&&!1!==b?a==CKEDITOR.ENTER_DIV?"div":"p":!1}function b(a){for(a=a.children[a.children.length-1];a&&g(a);)a=a.previous;return a}function c(a){for(a=a.previous;a&&g(a);)a=a.previous;return a}function g(a){return a.type==CKEDITOR.NODE_TEXT&&!CKEDITOR.tools.trim(a.value)||a.type==CKEDITOR.NODE_ELEMENT&&a.attributes["data-cke-bookmark"]}function f(a){return a&&
(a.type==CKEDITOR.NODE_ELEMENT&&a.name in m||a.type==CKEDITOR.NODE_DOCUMENT_FRAGMENT)}function l(a,b){var c=a.children[a.children.length-1];a.children.push(b);b.parent=a;c&&(c.next=b,b.previous=c)}function h(a){a=a.attributes;"false"!=a.contenteditable&&(a["data-cke-editable"]=a.contenteditable?"true":1);a.contenteditable="false"}function k(a){a=a.attributes;switch(a["data-cke-editable"]){case "true":a.contenteditable="true";break;case "1":delete a.contenteditable}}function p(a){return a.replace(r,
function(a,b,c){return"\x3c"+b+c.replace(E,function(a,b){return D.test(b)&&-1==c.indexOf("data-cke-saved-"+b)?" data-cke-saved-"+a+" data-cke-"+CKEDITOR.rnd+"-"+a:a})+"\x3e"})}function e(a,b){return a.replace(b,function(a,b,c){0===a.indexOf("\x3ctextarea")&&(a=b+y(c).replace(/</g,"\x26lt;").replace(/>/g,"\x26gt;")+"\x3c/textarea\x3e");return"\x3ccke:encoded\x3e"+encodeURIComponent(a)+"\x3c/cke:encoded\x3e"})}function z(a){return a.replace(T,function(a,b){return decodeURIComponent(b)})}function w(a){return a.replace(/\x3c!--(?!{cke_protected})[\s\S]+?--\x3e/g,
function(a){return"\x3c!--"+x+"{C}"+encodeURIComponent(a).replace(/--/g,"%2D%2D")+"--\x3e"})}function y(a){return a.replace(/\x3c!--\{cke_protected\}\{C\}([\s\S]+?)--\x3e/g,function(a,b){return decodeURIComponent(b)})}function G(a,b){var c=b._.dataStore;return a.replace(/\x3c!--\{cke_protected\}([\s\S]+?)--\x3e/g,function(a,b){return decodeURIComponent(b)}).replace(/\{cke_protected_(\d+)\}/g,function(a,b){return c&&c[b]||""})}function q(a,b){var c=[],d=b.config.protectedSource,f=b._.dataStore||(b._.dataStore=
{id:1}),e=/<\!--\{cke_temp(comment)?\}(\d*?)--\x3e/g,d=[/<script[\s\S]*?(<\/script>|$)/gi,/<noscript[\s\S]*?<\/noscript>/gi,/<meta[\s\S]*?\/?>/gi].concat(d);a=a.replace(/\x3c!--[\s\S]*?--\x3e/g,function(a){return"\x3c!--{cke_tempcomment}"+(c.push(a)-1)+"--\x3e"});for(var g=0;g<d.length;g++)a=a.replace(d[g],function(a){a=a.replace(e,function(a,b,d){return c[d]});return/cke_temp(comment)?/.test(a)?a:"\x3c!--{cke_temp}"+(c.push(a)-1)+"--\x3e"});a=a.replace(e,function(a,b,d){return"\x3c!--"+x+(b?"{C}":
"")+encodeURIComponent(c[d]).replace(/--/g,"%2D%2D")+"--\x3e"});a=a.replace(/<\w+(?:\s+(?:(?:[^\s=>]+\s*=\s*(?:[^'"\s>]+|'[^']*'|"[^"]*"))|[^\s=\/>]+))+\s*\/?>/g,function(a){return a.replace(/\x3c!--\{cke_protected\}([^>]*)--\x3e/g,function(a,b){f[f.id]=decodeURIComponent(b);return"{cke_protected_"+f.id++ +"}"})});return a=a.replace(/<(title|iframe|textarea)([^>]*)>([\s\S]*?)<\/\1>/g,function(a,c,d,f){return"\x3c"+c+d+"\x3e"+G(y(f),b)+"\x3c/"+c+"\x3e"})}var n;CKEDITOR.htmlDataProcessor=function(b){var c,
f,g=this;this.editor=b;this.dataFilter=c=new CKEDITOR.htmlParser.filter;this.htmlFilter=f=new CKEDITOR.htmlParser.filter;this.writer=new CKEDITOR.htmlParser.basicWriter;c.addRules(F);c.addRules(M,{applyToAll:!0});c.addRules(a(b,"data"),{applyToAll:!0});f.addRules(A);f.addRules(N,{applyToAll:!0});f.addRules(a(b,"html"),{applyToAll:!0});b.on("toHtml",function(a){a=a.data;var c=a.dataValue,f,c=n(c),c=q(c,b),c=e(c,S),c=p(c),c=e(c,u),c=c.replace(t,"$1cke:$2"),c=c.replace(J,"\x3ccke:$1$2\x3e\x3c/cke:$1\x3e"),
c=c.replace(/(<pre\b[^>]*>)(\r\n|\n)/g,"$1$2$2"),c=c.replace(/([^a-z0-9<\-])(on\w{3,})(?!>)/gi,"$1data-cke-"+CKEDITOR.rnd+"-$2");f=a.context||b.editable().getName();var g;CKEDITOR.env.ie&&9>CKEDITOR.env.version&&"pre"==f&&(f="div",c="\x3cpre\x3e"+c+"\x3c/pre\x3e",g=1);f=b.document.createElement(f);f.setHtml("a"+c);c=f.getHtml().substr(1);c=c.replace(new RegExp("data-cke-"+CKEDITOR.rnd+"-","ig"),"");g&&(c=c.replace(/^<pre>|<\/pre>$/gi,""));c=c.replace(P,"$1$2");c=z(c);c=y(c);f=!1===a.fixForBody?!1:
d(a.enterMode,b.config.autoParagraph);c=CKEDITOR.htmlParser.fragment.fromHtml(c,a.context,f);f&&(g=c,!g.children.length&&CKEDITOR.dtd[g.name][f]&&(f=new CKEDITOR.htmlParser.element(f),g.add(f)));a.dataValue=c},null,null,5);b.on("toHtml",function(a){a.data.filter.applyTo(a.data.dataValue,!0,a.data.dontFilter,a.data.enterMode)&&b.fire("dataFiltered")},null,null,6);b.on("toHtml",function(a){a.data.dataValue.filterChildren(g.dataFilter,!0)},null,null,10);b.on("toHtml",function(a){a=a.data;var b=a.dataValue,
c=new CKEDITOR.htmlParser.basicWriter;b.writeChildrenHtml(c);b=c.getHtml(!0);a.dataValue=w(b)},null,null,15);b.on("toDataFormat",function(a){var c=a.data.dataValue;a.data.enterMode!=CKEDITOR.ENTER_BR&&(c=c.replace(/^<br *\/?>/i,""));a.data.dataValue=CKEDITOR.htmlParser.fragment.fromHtml(c,a.data.context,d(a.data.enterMode,b.config.autoParagraph))},null,null,5);b.on("toDataFormat",function(a){a.data.dataValue.filterChildren(g.htmlFilter,!0)},null,null,10);b.on("toDataFormat",function(a){a.data.filter.applyTo(a.data.dataValue,
!1,!0)},null,null,11);b.on("toDataFormat",function(a){var c=a.data.dataValue,d=g.writer;d.reset();c.writeChildrenHtml(d);c=d.getHtml(!0);c=y(c);c=G(c,b);a.data.dataValue=c},null,null,15)};CKEDITOR.htmlDataProcessor.prototype={toHtml:function(a,b,c,d){var f=this.editor,e,g,m,t;b&&"object"==typeof b?(e=b.context,c=b.fixForBody,d=b.dontFilter,g=b.filter,m=b.enterMode,t=b.protectedWhitespaces):e=b;e||null===e||(e=f.editable().getName());return f.fire("toHtml",{dataValue:a,context:e,fixForBody:c,dontFilter:d,
filter:g||f.filter,enterMode:m||f.enterMode,protectedWhitespaces:t}).dataValue},toDataFormat:function(a,b){var c,d,f;b&&(c=b.context,d=b.filter,f=b.enterMode);c||null===c||(c=this.editor.editable().getName());return this.editor.fire("toDataFormat",{dataValue:a,filter:d||this.editor.filter,context:c,enterMode:f||this.editor.enterMode}).dataValue}};var H=/(?:&nbsp;|\xa0)$/,x="{cke_protected}",I=CKEDITOR.dtd,K="caption colgroup col thead tfoot tbody".split(" "),m=CKEDITOR.tools.extend({},I.$blockLimit,
I.$block),F={elements:{input:h,textarea:h}},M={attributeNames:[[/^on/,"data-cke-pa-on"],[/^srcdoc/,"data-cke-pa-srcdoc"],[/^data-cke-expando$/,""]],elements:{iframe:function(a){if(a.attributes&&a.attributes.src){var b=a.attributes.src.toLowerCase().replace(/[^a-z]/gi,"");if(0===b.indexOf("javascript")||0===b.indexOf("data"))a.attributes["data-cke-pa-src"]=a.attributes.src,delete a.attributes.src}}}},A={elements:{embed:function(a){var b=a.parent;if(b&&"object"==b.name){var c=b.attributes.width,b=b.attributes.height;
c&&(a.attributes.width=c);b&&(a.attributes.height=b)}},a:function(a){var b=a.attributes;if(!(a.children.length||b.name||b.id||a.attributes["data-cke-saved-name"]))return!1}}},N={elementNames:[[/^cke:/,""],[/^\?xml:namespace$/,""]],attributeNames:[[/^data-cke-(saved|pa)-/,""],[/^data-cke-.*/,""],["hidefocus",""]],elements:{$:function(a){var b=a.attributes;if(b){if(b["data-cke-temp"])return!1;for(var c=["name","href","src"],d,f=0;f<c.length;f++)d="data-cke-saved-"+c[f],d in b&&delete b[c[f]]}return a},
table:function(a){a.children.slice(0).sort(function(a,b){var c,d;a.type==CKEDITOR.NODE_ELEMENT&&b.type==a.type&&(c=CKEDITOR.tools.indexOf(K,a.name),d=CKEDITOR.tools.indexOf(K,b.name));-1<c&&-1<d&&c!=d||(c=a.parent?a.getIndex():-1,d=b.parent?b.getIndex():-1);return c>d?1:-1})},param:function(a){a.children=[];a.isEmpty=!0;return a},span:function(a){"Apple-style-span"==a.attributes["class"]&&delete a.name},html:function(a){delete a.attributes.contenteditable;delete a.attributes["class"]},body:function(a){delete a.attributes.spellcheck;
delete a.attributes.contenteditable},style:function(a){var b=a.children[0];b&&b.value&&(b.value=CKEDITOR.tools.trim(b.value));a.attributes.type||(a.attributes.type="text/css")},title:function(a){var b=a.children[0];!b&&l(a,b=new CKEDITOR.htmlParser.text);b.value=a.attributes["data-cke-title"]||""},input:k,textarea:k},attributes:{"class":function(a){return CKEDITOR.tools.ltrim(a.replace(/(?:^|\s+)cke_[^\s]*/g,""))||!1}}};CKEDITOR.env.ie&&(N.attributes.style=function(a){return a.replace(/(^|;)([^\:]+)/g,
function(a){return a.toLowerCase()})});var r=/<(a|area|img|input|source)\b([^>]*)>/gi,E=/([\w-:]+)\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|(?:[^ "'>]+))/gi,D=/^(href|src|name)$/i,u=/(?:<style(?=[ >])[^>]*>[\s\S]*?<\/style>)|(?:<(:?link|meta|base)[^>]*>)/gi,S=/(<textarea(?=[ >])[^>]*>)([\s\S]*?)(?:<\/textarea>)/gi,T=/<cke:encoded>([^<]*)<\/cke:encoded>/gi,t=/(<\/?)((?:object|embed|param|html|body|head|title)([\s][^>]*)?>)/gi,P=/(<\/?)cke:((?:html|body|head|title)[^>]*>)/gi,J=/<cke:(param|embed)([^>]*?)\/?>(?!\s*<\/cke:\1)/gi;
n=function(){function a(c){return CKEDITOR.tools.array.reduce(c.split(""),function(a,c){var d=c.toLowerCase(),f=c.toUpperCase(),e=b(d);d!==f&&(e+="|"+b(f));return a+("("+e+")")},"")}function b(a){var c;c=a.charCodeAt(0);var d=c.toString(16);c={htmlCode:"\x26#"+c+";?",hex:"\x26#x0*"+d+";?",entity:{"\x3c":"\x26lt;","\x3e":"\x26gt;",":":"\x26colon;"}[a]};for(var f in c)c[f]&&(a+="|"+c[f]);return a}var c=new RegExp("("+a("\x3ccke:encoded\x3e")+"(.*?)"+a("\x3c/cke:encoded\x3e")+")|("+a("\x3c")+a("/")+
"?"+a("cke:encoded\x3e")+")","gi"),d=new RegExp("(("+a("{cke_protected")+")(_[0-9]*)?"+a("}")+")","gi");return function(a){return a.replace(c,"").replace(d,"")}}()})();"use strict";
CKEDITOR.htmlParser.element=function(a,d){this.name=a;this.attributes=d||{};this.children=[];var b=a||"",c=b.match(/^cke:(.*)/);c&&(b=c[1]);b=!!(CKEDITOR.dtd.$nonBodyContent[b]||CKEDITOR.dtd.$block[b]||CKEDITOR.dtd.$listItem[b]||CKEDITOR.dtd.$tableContent[b]||CKEDITOR.dtd.$nonEditable[b]||"br"==b);this.isEmpty=!!CKEDITOR.dtd.$empty[a];this.isUnknown=!CKEDITOR.dtd[a];this._={isBlockLike:b,hasInlineStarted:this.isEmpty||!b}};
CKEDITOR.htmlParser.cssStyle=function(a){var d={};((a instanceof CKEDITOR.htmlParser.element?a.attributes.style:a)||"").replace(/&quot;/g,'"').replace(/\s*([^ :;]+)\s*:\s*([^;]+)\s*(?=;|$)/g,function(a,c,g){"font-family"==c&&(g=g.replace(/["']/g,""));d[c.toLowerCase()]=g});return{rules:d,populate:function(a){var c=this.toString();c&&(a instanceof CKEDITOR.dom.element?a.setAttribute("style",c):a instanceof CKEDITOR.htmlParser.element?a.attributes.style=c:a.style=c)},toString:function(){var a=[],c;
for(c in d)d[c]&&a.push(c,":",d[c],";");return a.join("")}}};
(function(){function a(a){return function(b){return b.type==CKEDITOR.NODE_ELEMENT&&("string"==typeof a?b.name==a:b.name in a)}}var d=function(a,b){a=a[0];b=b[0];return a<b?-1:a>b?1:0},b=CKEDITOR.htmlParser.fragment.prototype;CKEDITOR.htmlParser.element.prototype=CKEDITOR.tools.extend(new CKEDITOR.htmlParser.node,{type:CKEDITOR.NODE_ELEMENT,add:b.add,clone:function(){return new CKEDITOR.htmlParser.element(this.name,this.attributes)},filter:function(a,b){var d=this,l,h;b=d.getFilterContext(b);if(!d.parent)a.onRoot(b,
d);for(;;){l=d.name;if(!(h=a.onElementName(b,l)))return this.remove(),!1;d.name=h;if(!(d=a.onElement(b,d)))return this.remove(),!1;if(d!==this)return this.replaceWith(d),!1;if(d.name==l)break;if(d.type!=CKEDITOR.NODE_ELEMENT)return this.replaceWith(d),!1;if(!d.name)return this.replaceWithChildren(),!1}l=d.attributes;var k,p;for(k in l){for(h=l[k];;)if(p=a.onAttributeName(b,k))if(p!=k)delete l[k],k=p;else break;else{delete l[k];break}p&&(!1===(h=a.onAttribute(b,d,p,h))?delete l[p]:l[p]=h)}d.isEmpty||
this.filterChildren(a,!1,b);return!0},filterChildren:b.filterChildren,writeHtml:function(a,b){b&&this.filter(b);var f=this.name,l=[],h=this.attributes,k,p;a.openTag(f,h);for(k in h)l.push([k,h[k]]);a.sortAttributes&&l.sort(d);k=0;for(p=l.length;k<p;k++)h=l[k],a.attribute(h[0],h[1]);a.openTagClose(f,this.isEmpty);this.writeChildrenHtml(a);this.isEmpty||a.closeTag(f)},writeChildrenHtml:b.writeChildrenHtml,replaceWithChildren:function(){for(var a=this.children,b=a.length;b;)a[--b].insertAfter(this);
this.remove()},forEach:b.forEach,getFirst:function(b){if(!b)return this.children.length?this.children[0]:null;"function"!=typeof b&&(b=a(b));for(var d=0,f=this.children.length;d<f;++d)if(b(this.children[d]))return this.children[d];return null},getHtml:function(){var a=new CKEDITOR.htmlParser.basicWriter;this.writeChildrenHtml(a);return a.getHtml()},setHtml:function(a){a=this.children=CKEDITOR.htmlParser.fragment.fromHtml(a).children;for(var b=0,d=a.length;b<d;++b)a[b].parent=this},getOuterHtml:function(){var a=
new CKEDITOR.htmlParser.basicWriter;this.writeHtml(a);return a.getHtml()},split:function(a){for(var b=this.children.splice(a,this.children.length-a),d=this.clone(),l=0;l<b.length;++l)b[l].parent=d;d.children=b;b[0]&&(b[0].previous=null);0<a&&(this.children[a-1].next=null);this.parent.add(d,this.getIndex()+1);return d},find:function(a,b){void 0===b&&(b=!1);var d=[],l;for(l=0;l<this.children.length;l++){var h=this.children[l];"function"==typeof a&&a(h)?d.push(h):"string"==typeof a&&h.name===a&&d.push(h);
b&&h.find&&(d=d.concat(h.find(a,b)))}return d},findOne:function(a,b){var d=null,l=CKEDITOR.tools.array.find(this.children,function(h){var l="function"===typeof a?a(h):h.name===a;if(l||!b)return l;h.children&&h.findOne&&(d=h.findOne(a,!0));return!!d});return d||l||null},addClass:function(a){if(!this.hasClass(a)){var b=this.attributes["class"]||"";this.attributes["class"]=b+(b?" ":"")+a}},removeClass:function(a){var b=this.attributes["class"];b&&((b=CKEDITOR.tools.trim(b.replace(new RegExp("(?:\\s+|^)"+
a+"(?:\\s+|$)")," ")))?this.attributes["class"]=b:delete this.attributes["class"])},hasClass:function(a){var b=this.attributes["class"];return b?(new RegExp("(?:^|\\s)"+a+"(?\x3d\\s|$)")).test(b):!1},getFilterContext:function(a){var b=[];a||(a={nonEditable:!1,nestedEditable:!1});a.nonEditable||"false"!=this.attributes.contenteditable?a.nonEditable&&!a.nestedEditable&&"true"==this.attributes.contenteditable&&b.push("nestedEditable",!0):b.push("nonEditable",!0);if(b.length){a=CKEDITOR.tools.copy(a);
for(var d=0;d<b.length;d+=2)a[b[d]]=b[d+1]}return a}},!0)})();(function(){var a=/{([^}]+)}/g;CKEDITOR.template=function(a){this.source="function"===typeof a?a:String(a)};CKEDITOR.template.prototype.output=function(d,b){var c=("function"===typeof this.source?this.source(d):this.source).replace(a,function(a,b){return void 0!==d[b]?d[b]:a});return b?b.push(c):c}})();delete CKEDITOR.loadFullCore;CKEDITOR.instances={};CKEDITOR.document=new CKEDITOR.dom.document(document);
CKEDITOR.add=function(a){function d(){CKEDITOR.currentInstance==a&&(CKEDITOR.currentInstance=null,CKEDITOR.fire("currentInstance"))}CKEDITOR.instances[a.name]=a;a.on("focus",function(){CKEDITOR.currentInstance!=a&&(CKEDITOR.currentInstance=a,CKEDITOR.fire("currentInstance"))});a.on("blur",d);a.on("destroy",d);CKEDITOR.fire("instance",null,a)};CKEDITOR.remove=function(a){delete CKEDITOR.instances[a.name]};
(function(){var a={};CKEDITOR.addTemplate=function(d,b){var c=a[d];if(c)return c;c={name:d,source:b};CKEDITOR.fire("template",c);return a[d]=new CKEDITOR.template(c.source)};CKEDITOR.getTemplate=function(d){return a[d]}})();(function(){var a=[];CKEDITOR.addCss=function(d){a.push(d)};CKEDITOR.getCss=function(){return a.join("\n")}})();CKEDITOR.on("instanceDestroyed",function(){CKEDITOR.tools.isEmpty(this.instances)&&CKEDITOR.fire("reset")});CKEDITOR.TRISTATE_ON=1;CKEDITOR.TRISTATE_OFF=2;
CKEDITOR.TRISTATE_DISABLED=0;
(function(){CKEDITOR.inline=function(a,d){a=CKEDITOR.editor._getEditorElement(a);if(!a)return null;var b=new CKEDITOR.editor(d,a,CKEDITOR.ELEMENT_MODE_INLINE),c=a.is("textarea")?a:null;c?(b.setData(c.getValue(),null,!0),a=CKEDITOR.dom.element.createFromHtml('\x3cdiv contenteditable\x3d"'+!!b.readOnly+'" class\x3d"cke_textarea_inline"\x3e'+c.getValue()+"\x3c/div\x3e",CKEDITOR.document),a.insertAfter(c),c.hide(),c.$.form&&b._attachToForm()):(d&&"undefined"!==typeof d.readOnly&&!d.readOnly&&a.setAttribute("contenteditable",
"true"),b.setData(a.getHtml(),null,!0));b.on("loaded",function(){b.fire("uiReady");b.editable(a);b.container=a;b.ui.contentsElement=a;b.setData(b.getData(1));b.resetDirty();b.fire("contentDom");b.mode="wysiwyg";b.fire("mode");b.status="ready";b.fireOnce("instanceReady");CKEDITOR.fire("instanceReady",null,b)},null,null,1E4);b.on("destroy",function(){var a=b.container;c&&a&&(a.clearCustomData(),a.remove());c&&c.show();b.element.clearCustomData();delete b.element});return b};CKEDITOR.inlineAll=function(){var a,
d,b;for(b in CKEDITOR.dtd.$editable)for(var c=CKEDITOR.document.getElementsByTag(b),g=0,f=c.count();g<f;g++)a=c.getItem(g),"true"!=a.getAttribute("contenteditable")||a.getEditor()||(d={element:a,config:{}},!1!==CKEDITOR.fire("inline",d)&&CKEDITOR.inline(a,d.config))};CKEDITOR.domReady(function(){!CKEDITOR.disableAutoInline&&CKEDITOR.inlineAll()})})();CKEDITOR.replaceClass="ckeditor";
(function(){function a(a,g,f,l){a=CKEDITOR.editor._getEditorElement(a);if(!a)return null;var h=new CKEDITOR.editor(g,a,l);l==CKEDITOR.ELEMENT_MODE_REPLACE&&(a.setStyle("visibility","hidden"),h._.required=a.hasAttribute("required"),a.removeAttribute("required"));f&&h.setData(f,null,!0);h.on("loaded",function(){h.isDestroyed()||h.isDetached()||(b(h),l==CKEDITOR.ELEMENT_MODE_REPLACE&&h.config.autoUpdateElement&&a.$.form&&h._attachToForm(),h.setMode(h.config.startupMode,function(){h.resetDirty();h.status=
"ready";h.fireOnce("instanceReady");CKEDITOR.fire("instanceReady",null,h)}))});h.on("destroy",d);return h}function d(){var a=this.container,b=this.element;a&&(a.clearCustomData(),a.remove());b&&(b.clearCustomData(),this.elementMode==CKEDITOR.ELEMENT_MODE_REPLACE&&(b.show(),this._.required&&b.setAttribute("required","required")),delete this.element)}function b(a){var b=a.name,d=a.element,l=a.elementMode,h=a.fire("uiSpace",{space:"top",html:""}).html,k=a.fire("uiSpace",{space:"bottom",html:""}).html,
p=new CKEDITOR.template('\x3c{outerEl} id\x3d"cke_{name}" class\x3d"{id} cke cke_reset cke_chrome cke_editor_{name} cke_{langDir} '+CKEDITOR.env.cssClass+'"  dir\x3d"{langDir}" lang\x3d"{langCode}" role\x3d"application"'+(a.title?' aria-labelledby\x3d"cke_{name}_arialbl"':"")+"\x3e"+(a.title?'\x3cspan id\x3d"cke_{name}_arialbl" class\x3d"cke_voice_label"\x3e{voiceLabel}\x3c/span\x3e':"")+'\x3c{outerEl} class\x3d"cke_inner cke_reset" role\x3d"presentation"\x3e{topHtml}\x3c{outerEl} id\x3d"{contentId}" class\x3d"cke_contents cke_reset" role\x3d"presentation"\x3e\x3c/{outerEl}\x3e{bottomHtml}\x3c/{outerEl}\x3e\x3c/{outerEl}\x3e'),
b=CKEDITOR.dom.element.createFromHtml(p.output({id:a.id,name:b,langDir:a.lang.dir,langCode:a.langCode,voiceLabel:a.title,topHtml:h?'\x3cspan id\x3d"'+a.ui.spaceId("top")+'" class\x3d"cke_top cke_reset_all" role\x3d"presentation" style\x3d"height:auto"\x3e'+h+"\x3c/span\x3e":"",contentId:a.ui.spaceId("contents"),bottomHtml:k?'\x3cspan id\x3d"'+a.ui.spaceId("bottom")+'" class\x3d"cke_bottom cke_reset_all" role\x3d"presentation"\x3e'+k+"\x3c/span\x3e":"",outerEl:CKEDITOR.env.ie?"span":"div"}));l==CKEDITOR.ELEMENT_MODE_REPLACE?
(d.hide(),b.insertAfter(d)):d.append(b);a.container=b;a.ui.contentsElement=a.ui.space("contents");h&&a.ui.space("top").unselectable();k&&a.ui.space("bottom").unselectable();d=a.config.width;l=a.config.height;d&&b.setStyle("width",CKEDITOR.tools.cssLength(d));l&&a.ui.space("contents").setStyle("height",CKEDITOR.tools.cssLength(l));b.disableContextMenu();CKEDITOR.env.webkit&&b.on("focus",function(){a.focus()});a.fireOnce("uiReady")}CKEDITOR.replace=function(b,d){return a(b,d,null,CKEDITOR.ELEMENT_MODE_REPLACE)};
CKEDITOR.appendTo=function(b,d,f){return a(b,d,f,CKEDITOR.ELEMENT_MODE_APPENDTO)};CKEDITOR.replaceAll=function(){for(var a=document.getElementsByTagName("textarea"),b=0;b<a.length;b++){var d=null,l=a[b];if(l.name||l.id){if("string"==typeof arguments[0]){if(!(new RegExp("(?:^|\\s)"+arguments[0]+"(?:$|\\s)")).test(l.className))continue}else if("function"==typeof arguments[0]&&(d={},!1===arguments[0](l,d)))continue;this.replace(l,d)}}};CKEDITOR.editor.prototype.addMode=function(a,b){(this._.modes||(this._.modes=
{}))[a]=b};CKEDITOR.editor.prototype.setMode=function(a,b){var d=this,l=this._.modes;if(a!=d.mode&&l&&l[a]){d.fire("beforeSetMode",a);if(d.mode){var h=d.checkDirty(),l=d._.previousModeData,k,p=0;d.fire("beforeModeUnload");d.editable(0);d._.previousMode=d.mode;d._.previousModeData=k=d.getData(1);"source"==d.mode&&l==k&&(d.fire("lockSnapshot",{forceUpdate:!0}),p=1);d.ui.space("contents").setHtml("");d.mode=""}else d._.previousModeData=d.getData(1);this._.modes[a](function(){d.mode=a;void 0!==h&&!h&&
d.resetDirty();p?d.fire("unlockSnapshot"):"wysiwyg"==a&&d.fire("saveSnapshot");setTimeout(function(){d.isDestroyed()||d.isDetached()||(d.fire("mode"),b&&b.call(d))},0)})}};CKEDITOR.editor.prototype.resize=function(a,b,d,l){var h=this.container,k=this.ui.space("contents"),p=CKEDITOR.env.webkit&&this.document&&this.document.getWindow().$.frameElement;l=l?this.container.getFirst(function(a){return a.type==CKEDITOR.NODE_ELEMENT&&a.hasClass("cke_inner")}):h;if(a||0===a)a=CKEDITOR.tools.convertToPx(CKEDITOR.tools.cssLength(a));
l.setSize("width",a,!0);p&&(p.style.width="1%");b=CKEDITOR.tools.convertToPx(CKEDITOR.tools.cssLength(b));var e=(l.$.offsetHeight||0)-(k.$.clientHeight||0),h=Math.max(b-(d?0:e),0);b=d?b+e:b;k.setStyle("height",CKEDITOR.tools.cssLength(h));p&&(p.style.width="100%");this.fire("resize",{outerHeight:b,contentsHeight:h,outerWidth:a||l.getSize("width")})};CKEDITOR.editor.prototype.getResizable=function(a){return a?this.ui.space("contents"):this.container};CKEDITOR.domReady(function(){CKEDITOR.replaceClass&&
CKEDITOR.replaceAll(CKEDITOR.replaceClass)})})();CKEDITOR.config.startupMode="wysiwyg";
(function(){function a(a){var b=a.editor,e=a.data.path,f=e.blockLimit,g=a.data.selection,r=g.getRanges()[0],h;if(CKEDITOR.env.gecko||CKEDITOR.env.ie&&CKEDITOR.env.needsBrFiller)if(g=d(g,e))g.appendBogus(),h=CKEDITOR.env.ie&&!CKEDITOR.env.edge||CKEDITOR.env.edge&&b._.previousActive;l(b,e.block,f)&&r.collapsed&&!r.getCommonAncestor().isReadOnly()&&(e=r.clone(),e.enlarge(CKEDITOR.ENLARGE_BLOCK_CONTENTS),f=new CKEDITOR.dom.walker(e),f.guard=function(a){return!c(a)||a.type==CKEDITOR.NODE_COMMENT||a.isReadOnly()},
!f.checkForward()||e.checkStartOfBlock()&&e.checkEndOfBlock())&&(b=r.fixBlock(!0,b.activeEnterMode==CKEDITOR.ENTER_DIV?"div":"p"),CKEDITOR.env.needsBrFiller||(b=b.getFirst(c))&&b.type==CKEDITOR.NODE_TEXT&&CKEDITOR.tools.trim(b.getText()).match(/^(?:&nbsp;|\xa0)$/)&&b.remove(),h=1,a.cancel());h&&r.select()}function d(a,b){if(a.isFake)return 0;var d=b.block||b.blockLimit,e=d&&d.getLast(c);if(!(!d||!d.isBlockBoundary()||e&&e.type==CKEDITOR.NODE_ELEMENT&&e.isBlockBoundary()||d.is("pre")||d.getBogus()))return d}
function b(a){var b=a.data.getTarget();b.is("input")&&(b=b.getAttribute("type"),"submit"!=b&&"reset"!=b||a.data.preventDefault())}function c(a){return z(a)&&w(a)}function g(a,b){return function(c){var d=c.data.$.toElement||c.data.$.fromElement||c.data.$.relatedTarget;(d=d&&d.nodeType==CKEDITOR.NODE_ELEMENT?new CKEDITOR.dom.element(d):null)&&(b.equals(d)||b.contains(d))||a.call(this,c)}}function f(a){function b(a){return function(b,e){e&&b.type==CKEDITOR.NODE_ELEMENT&&b.is(f)&&(d=b);if(!(e||!c(b)||
a&&G(b)))return!1}}var d,e=a.getRanges()[0];a=a.root;var f={table:1,ul:1,ol:1,dl:1};if(e.startPath().contains(f)){var g=e.clone();g.collapse(1);g.setStartAt(a,CKEDITOR.POSITION_AFTER_START);a=new CKEDITOR.dom.walker(g);a.guard=b();a.checkBackward();if(d)return g=e.clone(),g.collapse(),g.setEndAt(d,CKEDITOR.POSITION_AFTER_END),a=new CKEDITOR.dom.walker(g),a.guard=b(!0),d=!1,a.checkForward(),d}return null}function l(a,b,c){return!1!==a.config.autoParagraph&&a.activeEnterMode!=CKEDITOR.ENTER_BR&&(a.editable().equals(c)&&
!b||b&&"true"==b.getAttribute("contenteditable"))}function h(a){return a.activeEnterMode!=CKEDITOR.ENTER_BR&&!1!==a.config.autoParagraph?a.activeEnterMode==CKEDITOR.ENTER_DIV?"div":"p":!1}function k(a){a&&a.isEmptyInlineRemoveable()&&a.remove()}function p(a){var b=a.editor;b.getSelection().scrollIntoView();setTimeout(function(){b.fire("saveSnapshot")},0)}function e(a,b,c){var d=a.getCommonAncestor(b);for(b=a=c?b:a;(a=a.getParent())&&!d.equals(a)&&1==a.getChildCount();)b=a;b.remove()}var z,w,y,G,q,
n,H,x,I,K;CKEDITOR.editable=CKEDITOR.tools.createClass({base:CKEDITOR.dom.element,$:function(a,b){this.base(b.$||b);this.editor=a;this.status="unloaded";this.hasFocus=!1;this.setup()},proto:{focus:function(){var a;if(CKEDITOR.env.webkit&&!this.hasFocus&&(a=this.editor._.previousActive||this.getDocument().getActive(),this.contains(a))){a.focus();return}CKEDITOR.env.edge&&14<CKEDITOR.env.version&&!this.hasFocus&&this.getDocument().equals(CKEDITOR.document)&&(this.editor._.previousScrollTop=this.$.scrollTop);
try{if(!CKEDITOR.env.ie||CKEDITOR.env.edge&&14<CKEDITOR.env.version||!this.getDocument().equals(CKEDITOR.document))if(CKEDITOR.env.chrome){var b=this.$.scrollTop;this.$.focus();this.$.scrollTop=b}else this.$.focus();else this.$.setActive()}catch(c){if(!CKEDITOR.env.ie)throw c;}CKEDITOR.env.safari&&!this.isInline()&&(a=CKEDITOR.document.getActive(),a.equals(this.getWindow().getFrame())||this.getWindow().focus())},on:function(a,b){var c=Array.prototype.slice.call(arguments,0);CKEDITOR.env.ie&&/^focus|blur$/.exec(a)&&
(a="focus"==a?"focusin":"focusout",b=g(b,this),c[0]=a,c[1]=b);return CKEDITOR.dom.element.prototype.on.apply(this,c)},attachListener:function(a){!this._.listeners&&(this._.listeners=[]);var b=Array.prototype.slice.call(arguments,1),b=a.on.apply(a,b);this._.listeners.push(b);return b},clearListeners:function(){var a=this._.listeners;try{for(;a.length;)a.pop().removeListener()}catch(b){}},restoreAttrs:function(){var a=this._.attrChanges,b,c;for(c in a)a.hasOwnProperty(c)&&(b=a[c],null!==b?this.setAttribute(c,
b):this.removeAttribute(c))},attachClass:function(a){var b=this.getCustomData("classes");this.hasClass(a)||(!b&&(b=[]),b.push(a),this.setCustomData("classes",b),this.addClass(a))},changeAttr:function(a,b){var c=this.getAttribute(a);b!==c&&(!this._.attrChanges&&(this._.attrChanges={}),a in this._.attrChanges||(this._.attrChanges[a]=c),this.setAttribute(a,b))},insertText:function(a){this.editor.focus();this.insertHtml(this.transformPlainTextToHtml(a),"text")},transformPlainTextToHtml:function(a){var b=
this.editor.getSelection().getStartElement().hasAscendant("pre",!0)?CKEDITOR.ENTER_BR:this.editor.activeEnterMode;return CKEDITOR.tools.transformPlainTextToHtml(a,b)},insertHtml:function(a,b,c){var d=this.editor;d.focus();d.fire("saveSnapshot");c||(c=d.getSelection().getRanges()[0]);n(this,b||"html",a,c);c.select();p(this);this.editor.fire("afterInsertHtml",{})},insertHtmlIntoRange:function(a,b,c){n(this,c||"html",a,b);this.editor.fire("afterInsertHtml",{intoRange:b})},insertElement:function(a,b){var d=
this.editor;d.focus();d.fire("saveSnapshot");var e=d.activeEnterMode,d=d.getSelection(),f=a.getName(),f=CKEDITOR.dtd.$block[f];b||(b=d.getRanges()[0]);this.insertElementIntoRange(a,b)&&(b.moveToPosition(a,CKEDITOR.POSITION_AFTER_END),f&&((f=a.getNext(function(a){return c(a)&&!G(a)}))&&f.type==CKEDITOR.NODE_ELEMENT&&f.is(CKEDITOR.dtd.$block)?f.getDtd()["#"]?b.moveToElementEditStart(f):b.moveToElementEditEnd(a):f||e==CKEDITOR.ENTER_BR||(f=b.fixBlock(!0,e==CKEDITOR.ENTER_DIV?"div":"p"),b.moveToElementEditStart(f))));
d.selectRanges([b]);p(this)},insertElementIntoSelection:function(a){this.insertElement(a)},insertElementIntoRange:function(a,b){var c=this.editor,d=c.config.enterMode,e=a.getName(),f=CKEDITOR.dtd.$block[e];if(b.checkReadOnly())return!1;b.deleteContents(1);b.startContainer.type==CKEDITOR.NODE_ELEMENT&&(b.startContainer.is({tr:1,table:1,tbody:1,thead:1,tfoot:1})?H(b):b.startContainer.is(CKEDITOR.dtd.$list)&&x(b));var g,h;if(f)for(;(g=b.getCommonAncestor(0,1))&&(h=CKEDITOR.dtd[g.getName()])&&(!h||!h[e]);)if(g.getName()in
CKEDITOR.dtd.span){var f=b.splitElement(g),l=b.createBookmark();k(g);k(f);b.moveToBookmark(l)}else b.checkStartOfBlock()&&b.checkEndOfBlock()?(b.setStartBefore(g),b.collapse(!0),g.remove()):b.splitBlock(d==CKEDITOR.ENTER_DIV?"div":"p",c.editable());b.insertNode(a);return!0},setData:function(a,b){b||(a=this.editor.dataProcessor.toHtml(a));this.setHtml(a);this.fixInitialSelection();"unloaded"==this.status&&(this.status="ready");this.editor.fire("dataReady")},getData:function(a){var b=this.getHtml();
a||(b=this.editor.dataProcessor.toDataFormat(b));return b},setReadOnly:function(a){this.setAttribute("contenteditable",!a)},detach:function(){this.status="detached";this.editor.setData(this.editor.getData(),{internal:!0});this.clearListeners();try{this._.cleanCustomData()}catch(a){if(!CKEDITOR.env.ie||-2146828218!==a.number)throw a;}this.editor.fire("contentDomUnload");delete this.editor.document;delete this.editor.window;delete this.editor},isInline:function(){return this.getDocument().equals(CKEDITOR.document)},
fixInitialSelection:function(){function a(){var b=c.getDocument().$,d=b.getSelection(),e;a:if(d.anchorNode&&d.anchorNode==c.$)e=!0;else{if(CKEDITOR.env.webkit&&(e=c.getDocument().getActive())&&e.equals(c)&&!d.anchorNode){e=!0;break a}e=void 0}e&&(e=new CKEDITOR.dom.range(c),e.moveToElementEditStart(c),b=b.createRange(),b.setStart(e.startContainer.$,e.startOffset),b.collapse(!0),d.removeAllRanges(),d.addRange(b))}function b(){var a=c.getDocument().$,d=a.selection,e=c.getDocument().getActive();"None"==
d.type&&e.equals(c)&&(d=new CKEDITOR.dom.range(c),a=a.body.createTextRange(),d.moveToElementEditStart(c),d=d.startContainer,d.type!=CKEDITOR.NODE_ELEMENT&&(d=d.getParent()),a.moveToElementText(d.$),a.collapse(!0),a.select())}var c=this;if(CKEDITOR.env.ie&&(9>CKEDITOR.env.version||CKEDITOR.env.quirks))this.hasFocus&&(this.focus(),b());else if(this.hasFocus)this.focus(),a();else this.once("focus",function(){a()},null,null,-999)},getHtmlFromRange:function(a){if(a.collapsed)return new CKEDITOR.dom.documentFragment(a.document);
a={doc:this.getDocument(),range:a.clone()};I.eol.detect(a,this);I.bogus.exclude(a);I.cell.shrink(a);a.fragment=a.range.cloneContents();I.tree.rebuild(a,this);I.eol.fix(a,this);return new CKEDITOR.dom.documentFragment(a.fragment.$)},extractHtmlFromRange:function(a,b){var c=K,d={range:a,doc:a.document},e=this.getHtmlFromRange(a);if(a.collapsed)return a.optimize(),e;a.enlarge(CKEDITOR.ENLARGE_INLINE,1);c.table.detectPurge(d);d.bookmark=a.createBookmark();delete d.range;var f=this.editor.createRange();
f.moveToPosition(d.bookmark.startNode,CKEDITOR.POSITION_BEFORE_START);d.targetBookmark=f.createBookmark();c.list.detectMerge(d,this);c.table.detectRanges(d,this);c.block.detectMerge(d,this);d.tableContentsRanges?(c.table.deleteRanges(d),a.moveToBookmark(d.bookmark),d.range=a):(a.moveToBookmark(d.bookmark),d.range=a,a.extractContents(c.detectExtractMerge(d)));a.moveToBookmark(d.targetBookmark);a.optimize();c.fixUneditableRangePosition(a);c.list.merge(d,this);c.table.purge(d,this);c.block.merge(d,this);
if(b){c=a.startPath();if(d=a.checkStartOfBlock()&&a.checkEndOfBlock()&&c.block&&!a.root.equals(c.block)){a:{var d=c.block.getElementsByTag("span"),f=0,g;if(d)for(;g=d.getItem(f++);)if(!w(g)){d=!0;break a}d=!1}d=!d}d&&(a.moveToPosition(c.block,CKEDITOR.POSITION_BEFORE_START),c.block.remove())}else c.autoParagraph(this.editor,a),y(a.startContainer)&&a.startContainer.appendBogus();a.startContainer.mergeSiblings();return e},setup:function(){var a=this.editor;this.attachListener(a,"beforeGetData",function(){var b=
this.getData();this.is("textarea")||!1!==a.config.ignoreEmptyParagraph&&(b=b.replace(q,function(a,b){return b}));a.setData(b,null,1)},this);this.attachListener(a,"getSnapshot",function(a){a.data=this.getData(1)},this);this.attachListener(a,"afterSetData",function(){this.setData(a.getData(1))},this);this.attachListener(a,"loadSnapshot",function(a){this.setData(a.data,1)},this);this.attachListener(a,"beforeFocus",function(){var b=a.getSelection();(b=b&&b.getNative())&&"Control"==b.type||this.focus()},
this);this.attachListener(a,"insertHtml",function(a){this.insertHtml(a.data.dataValue,a.data.mode,a.data.range)},this);this.attachListener(a,"insertElement",function(a){this.insertElement(a.data)},this);this.attachListener(a,"insertText",function(a){this.insertText(a.data)},this);this.setReadOnly(a.readOnly);this.attachClass("cke_editable");a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE?this.attachClass("cke_editable_inline"):a.elementMode!=CKEDITOR.ELEMENT_MODE_REPLACE&&a.elementMode!=CKEDITOR.ELEMENT_MODE_APPENDTO||
this.attachClass("cke_editable_themed");this.attachClass("cke_contents_"+a.config.contentsLangDirection);a.keystrokeHandler.blockedKeystrokes[8]=+a.readOnly;a.keystrokeHandler.attach(this);this.on("blur",function(){this.hasFocus=!1},null,null,-1);this.on("focus",function(){this.hasFocus=!0},null,null,-1);if(CKEDITOR.env.webkit)this.on("scroll",function(){a._.previousScrollTop=a.editable().$.scrollTop},null,null,-1);if(CKEDITOR.env.edge&&14<CKEDITOR.env.version){var d=function(){var b=a.editable();
null!=a._.previousScrollTop&&b.getDocument().equals(CKEDITOR.document)&&(b.$.scrollTop=a._.previousScrollTop,a._.previousScrollTop=null,this.removeListener("scroll",d))};this.on("scroll",d)}a.focusManager.add(this);this.equals(CKEDITOR.document.getActive())&&(this.hasFocus=!0,a.once("contentDom",function(){a.focusManager.focus(this)},this));this.isInline()&&this.changeAttr("tabindex",a.tabIndex);if(!this.is("textarea")){a.document=this.getDocument();a.window=this.getWindow();var g=a.document;this.changeAttr("spellcheck",
!a.config.disableNativeSpellChecker);var h=a.config.contentsLangDirection;this.getDirection(1)!=h&&this.changeAttr("dir",h);var l=CKEDITOR.getCss();if(l){var h=g.getHead(),r=h.getCustomData("stylesheet");r?l!=r.getText()&&(CKEDITOR.env.ie&&9>CKEDITOR.env.version?r.$.styleSheet.cssText=l:r.setText(l)):(l=g.appendStyleText(l),l=new CKEDITOR.dom.element(l.ownerNode||l.owningElement),h.setCustomData("stylesheet",l),l.data("cke-temp",1))}h=g.getCustomData("stylesheet_ref")||0;g.setCustomData("stylesheet_ref",
h+1);this.setCustomData("cke_includeReadonly",!a.config.disableReadonlyStyling);this.attachListener(this,"click",function(a){a=a.data;var b=(new CKEDITOR.dom.elementPath(a.getTarget(),this)).contains("a");b&&2!=a.$.button&&b.isReadOnly()&&a.preventDefault()});var k={8:1,46:1};this.attachListener(a,"key",function(b){if(a.readOnly)return!0;var c=b.data.domEvent.getKey(),d;b=a.getSelection();if(0!==b.getRanges().length){if(c in k){var e,g=b.getRanges()[0],h=g.startPath(),r,l,B,c=8==c;CKEDITOR.env.ie&&
11>CKEDITOR.env.version&&(e=b.getSelectedElement())||(e=f(b))?(a.fire("saveSnapshot"),g.moveToPosition(e,CKEDITOR.POSITION_BEFORE_START),e.remove(),g.select(),a.fire("saveSnapshot"),d=1):g.collapsed&&((r=h.block)&&(B=r[c?"getPrevious":"getNext"](z))&&B.type==CKEDITOR.NODE_ELEMENT&&B.is("table")&&g[c?"checkStartOfBlock":"checkEndOfBlock"]()?(a.fire("saveSnapshot"),g[c?"checkEndOfBlock":"checkStartOfBlock"]()&&r.remove(),g["moveToElementEdit"+(c?"End":"Start")](B),g.select(),a.fire("saveSnapshot"),
d=1):h.blockLimit&&h.blockLimit.is("td")&&(l=h.blockLimit.getAscendant("table"))&&g.checkBoundaryOfElement(l,c?CKEDITOR.START:CKEDITOR.END)&&(B=l[c?"getPrevious":"getNext"](z))?(a.fire("saveSnapshot"),g["moveToElementEdit"+(c?"End":"Start")](B),g.checkStartOfBlock()&&g.checkEndOfBlock()?B.remove():g.select(),a.fire("saveSnapshot"),d=1):(l=h.contains(["td","th","caption"]))&&g.checkBoundaryOfElement(l,c?CKEDITOR.START:CKEDITOR.END)&&(d=1))}return!d}});a.blockless&&CKEDITOR.env.ie&&CKEDITOR.env.needsBrFiller&&
this.attachListener(this,"keyup",function(b){b.data.getKeystroke()in k&&!this.getFirst(c)&&(this.appendBogus(),b=a.createRange(),b.moveToPosition(this,CKEDITOR.POSITION_AFTER_START),b.select())});this.attachListener(this,"dblclick",function(b){if(a.readOnly)return!1;b={element:b.data.getTarget()};a.fire("doubleclick",b)});CKEDITOR.env.ie&&this.attachListener(this,"click",b);CKEDITOR.env.ie&&!CKEDITOR.env.edge||this.attachListener(this,"mousedown",function(b){var c=b.data.getTarget();c.is("img","hr",
"input","textarea","select")&&!c.isReadOnly()&&(a.getSelection().selectElement(c),c.is("input","textarea","select")&&b.data.preventDefault())});CKEDITOR.env.edge&&this.attachListener(this,"mouseup",function(b){(b=b.data.getTarget())&&b.is("img")&&!b.isReadOnly()&&a.getSelection().selectElement(b)});CKEDITOR.env.gecko&&this.attachListener(this,"mouseup",function(b){if(2==b.data.$.button&&(b=b.data.getTarget(),!b.getAscendant("table")&&!b.getOuterHtml().replace(q,""))){var c=a.createRange();c.moveToElementEditStart(b);
c.select(!0)}});CKEDITOR.env.webkit&&(this.attachListener(this,"click",function(a){a.data.getTarget().is("input","select")&&a.data.preventDefault()}),this.attachListener(this,"mouseup",function(a){a.data.getTarget().is("input","textarea")&&a.data.preventDefault()}));CKEDITOR.env.webkit&&this.attachListener(a,"key",function(b){if(a.readOnly)return!0;var c=b.data.domEvent.getKey();if(c in k&&(b=a.getSelection(),0!==b.getRanges().length)){var c=8==c,d=b.getRanges()[0];b=d.startPath();if(d.collapsed)a:{var f=
b.block;if(f&&d[c?"checkStartOfBlock":"checkEndOfBlock"]()&&d.moveToClosestEditablePosition(f,!c)&&d.collapsed){if(d.startContainer.type==CKEDITOR.NODE_ELEMENT){var g=d.startContainer.getChild(d.startOffset-(c?1:0));if(g&&g.type==CKEDITOR.NODE_ELEMENT&&g.is("hr")){a.fire("saveSnapshot");g.remove();b=!0;break a}}d=d.startPath().block;if(!d||d&&d.contains(f))b=void 0;else{a.fire("saveSnapshot");var h;(h=(c?d:f).getBogus())&&h.remove();h=a.getSelection();g=h.createBookmarks();(c?f:d).moveChildren(c?
d:f,!1);b.lastElement.mergeSiblings();e(f,d,!c);h.selectBookmarks(g);b=!0}}else b=!1}else c=d,h=b.block,d=c.endPath().block,h&&d&&!h.equals(d)?(a.fire("saveSnapshot"),(f=h.getBogus())&&f.remove(),c.enlarge(CKEDITOR.ENLARGE_INLINE),c.deleteContents(),d.getParent()&&(d.moveChildren(h,!1),b.lastElement.mergeSiblings(),e(h,d,!0)),c=a.getSelection().getRanges()[0],c.collapse(1),c.optimize(),""===c.startContainer.getHtml()&&c.startContainer.appendBogus(),c.select(),b=!0):b=!1;if(!b)return;a.getSelection().scrollIntoView();
a.fire("saveSnapshot");return!1}},this,null,100)}},getUniqueId:function(){var a;try{this._.expandoNumber=a=CKEDITOR.dom.domObject.prototype.getUniqueId.call(this)}catch(b){a=this._&&this._.expandoNumber}return a}},_:{cleanCustomData:function(){this.removeClass("cke_editable");this.restoreAttrs();for(var a=this.removeCustomData("classes");a&&a.length;)this.removeClass(a.pop());if(!this.is("textarea")){var a=this.getDocument(),b=a.getHead();if(b.getCustomData("stylesheet")){var c=a.getCustomData("stylesheet_ref");
--c?a.setCustomData("stylesheet_ref",c):(a.removeCustomData("stylesheet_ref"),b.removeCustomData("stylesheet").remove())}}}}});CKEDITOR.editor.prototype.editable=function(a){var b=this._.editable;if(b&&a)return 0;if(!arguments.length)return b;a?b=a instanceof CKEDITOR.editable?a:new CKEDITOR.editable(this,a):(b&&b.detach(),b=null);return this._.editable=b};CKEDITOR.on("instanceLoaded",function(b){var c=b.editor;c.on("insertElement",function(a){a=a.data;a.type==CKEDITOR.NODE_ELEMENT&&(a.is("input")||
a.is("textarea"))&&("false"!=a.getAttribute("contentEditable")&&a.data("cke-editable",a.hasAttribute("contenteditable")?"true":"1"),a.setAttribute("contentEditable",!1))});c.on("selectionChange",function(b){if(!c.readOnly){var d=c.getSelection();d&&!d.isLocked&&(d=c.checkDirty(),c.fire("lockSnapshot"),a(b),c.fire("unlockSnapshot"),!d&&c.resetDirty())}})});CKEDITOR.on("instanceCreated",function(a){var b=a.editor;b.on("mode",function(){var a=b.editable();if(a&&a.isInline()){var c=b.title;a.changeAttr("role",
"textbox");a.changeAttr("aria-multiline","true");a.changeAttr("aria-label",c);c&&a.changeAttr("title",c);var d=b.fire("ariaEditorHelpLabel",{}).label;if(d&&(c=this.ui.space(this.elementMode==CKEDITOR.ELEMENT_MODE_INLINE?"top":"contents"))){var e=CKEDITOR.tools.getNextId(),d=CKEDITOR.dom.element.createFromHtml('\x3cspan id\x3d"'+e+'" class\x3d"cke_voice_label"\x3e'+d+"\x3c/span\x3e");c.append(d);a.changeAttr("aria-describedby",e)}}})});CKEDITOR.addCss(".cke_editable{cursor:text}.cke_editable img,.cke_editable input,.cke_editable textarea{cursor:default}");
z=CKEDITOR.dom.walker.whitespaces(!0);w=CKEDITOR.dom.walker.bookmark(!1,!0);y=CKEDITOR.dom.walker.empty();G=CKEDITOR.dom.walker.bogus();q=/(^|<body\b[^>]*>)\s*<(p|div|address|h\d|center|pre)[^>]*>\s*(?:<br[^>]*>|&nbsp;|\u00A0|&#160;)?\s*(:?<\/\2>)?\s*(?=$|<\/body>)/gi;n=function(){function a(b){return b.type==CKEDITOR.NODE_ELEMENT}function b(c,d){var e,f,g,h,r=[],l=d.range.startContainer;e=d.range.startPath();for(var l=D[l.getName()],k=0,E=c.getChildren(),u=E.count(),p=-1,n=-1,S=0,A=e.contains(D.$list);k<
u;++k)e=E.getItem(k),a(e)?(g=e.getName(),A&&g in CKEDITOR.dtd.$list?r=r.concat(b(e,d)):(h=!!l[g],"br"!=g||!e.data("cke-eol")||k&&k!=u-1||(S=(f=k?r[k-1].node:E.getItem(k+1))&&(!a(f)||!f.is("br")),f=f&&a(f)&&D.$block[f.getName()]),-1!=p||h||(p=k),h||(n=k),r.push({isElement:1,isLineBreak:S,isBlock:e.isBlockBoundary(),hasBlockSibling:f,node:e,name:g,allowed:h}),f=S=0)):r.push({isElement:0,node:e,allowed:1});-1<p&&(r[p].firstNotAllowed=1);-1<n&&(r[n].lastNotAllowed=1);return r}function d(b,c){var e=[],
f=b.getChildren(),g=f.count(),h,r=0,l=D[c],k=!b.is(D.$inline)||b.is("br");for(k&&e.push(" ");r<g;r++)h=f.getItem(r),a(h)&&!h.is(l)?e=e.concat(d(h,c)):e.push(h);k&&e.push(" ");return e}function e(b){return a(b.startContainer)&&b.startContainer.getChild(b.startOffset-1)}function f(b){return b&&a(b)&&(b.is(D.$removeEmpty)||b.is("a")&&!b.isBlockBoundary())}function g(b,c,d,e){var f=b.clone(),h,l;f.setEndAt(c,CKEDITOR.POSITION_BEFORE_END);(h=(new CKEDITOR.dom.walker(f)).next())&&a(h)&&u[h.getName()]&&
(l=h.getPrevious())&&a(l)&&!l.getParent().equals(b.startContainer)&&d.contains(l)&&e.contains(h)&&h.isIdentical(l)&&(h.moveChildren(l),h.remove(),g(b,c,d,e))}function E(b,c){function d(b,c){if(c.isBlock&&c.isElement&&!c.node.is("br")&&a(b)&&b.is("br"))return b.remove(),1}var e=c.endContainer.getChild(c.endOffset),f=c.endContainer.getChild(c.endOffset-1);e&&d(e,b[b.length-1]);f&&d(f,b[0])&&(c.setEnd(c.endContainer,c.endOffset-1),c.collapse())}var D=CKEDITOR.dtd,u={p:1,div:1,h1:1,h2:1,h3:1,h4:1,h5:1,
h6:1,ul:1,ol:1,li:1,pre:1,dl:1,blockquote:1},p={p:1,div:1,h1:1,h2:1,h3:1,h4:1,h5:1,h6:1},n=CKEDITOR.tools.extend({},D.$inline);delete n.br;return function(t,u,J,v){var B=t.editor,C=!1;"unfiltered_html"==u&&(u="html",C=!0);if(!v.checkReadOnly()){var z=(new CKEDITOR.dom.elementPath(v.startContainer,v.root)).blockLimit||v.root;u={type:u,dontFilter:C,editable:t,editor:B,range:v,blockLimit:z,mergeCandidates:[],zombies:[]};var C=u.range,z=u.mergeCandidates,L="html"===u.type,q,w,y,x,G,V;"text"==u.type&&
C.shrink(CKEDITOR.SHRINK_ELEMENT,!0,!1)&&(w=CKEDITOR.dom.element.createFromHtml("\x3cspan\x3e\x26nbsp;\x3c/span\x3e",C.document),C.insertNode(w),C.setStartAfter(w));y=new CKEDITOR.dom.elementPath(C.startContainer);u.endPath=x=new CKEDITOR.dom.elementPath(C.endContainer);if(!C.collapsed){q=x.block||x.blockLimit;var aa=C.getCommonAncestor();q&&!q.equals(aa)&&!q.contains(aa)&&C.checkEndOfBlock()&&u.zombies.push(q);C.deleteContents()}for(;(G=e(C))&&a(G)&&G.isBlockBoundary()&&y.contains(G);)C.moveToPosition(G,
CKEDITOR.POSITION_BEFORE_END);g(C,u.blockLimit,y,x);w&&(C.setEndBefore(w),C.collapse(),w.remove());w=C.startPath();if(q=w.contains(f,!1,1))V=C.splitElement(q),u.inlineStylesRoot=q,u.inlineStylesPeak=w.lastElement;w=C.createBookmark();L&&(k(q),k(V));(q=w.startNode.getPrevious(c))&&a(q)&&f(q)&&z.push(q);(q=w.startNode.getNext(c))&&a(q)&&f(q)&&z.push(q);for(q=w.startNode;(q=q.getParent())&&f(q);)z.push(q);C.moveToBookmark(w);B.enterMode===CKEDITOR.ENTER_DIV&&""===B.getData(!0)&&((B=t.getFirst())&&B.remove(),
v.setStartAt(t,CKEDITOR.POSITION_AFTER_START),v.collapse(!0));if(t=J){t=u.range;if("text"==u.type&&u.inlineStylesRoot){v=u.inlineStylesPeak;B=v.getDocument().createText("{cke-peak}");for(V=u.inlineStylesRoot.getParent();!v.equals(V);)B=B.appendTo(v.clone()),v=v.getParent();J=B.getOuterHtml().split("{cke-peak}").join(J)}v=u.blockLimit.getName();if(/^\s+|\s+$/.test(J)&&"span"in CKEDITOR.dtd[v]){var H='\x3cspan data-cke-marker\x3d"1"\x3e\x26nbsp;\x3c/span\x3e';J=H+J+H}J=u.editor.dataProcessor.toHtml(J,
{context:null,fixForBody:!1,protectedWhitespaces:!!H,dontFilter:u.dontFilter,filter:u.editor.activeFilter,enterMode:u.editor.activeEnterMode});v=t.document.createElement("body");v.setHtml(J);H&&(v.getFirst().remove(),v.getLast().remove());if((H=t.startPath().block)&&(1!=H.getChildCount()||!H.getBogus()))a:{var Q;if(1==v.getChildCount()&&a(Q=v.getFirst())&&Q.is(p)&&!Q.hasAttribute("contenteditable")){H=Q.getElementsByTag("*");t=0;for(V=H.count();t<V;t++)if(B=H.getItem(t),!B.is(n))break a;Q.moveChildren(Q.getParent(1));
Q.remove()}}u.dataWrapper=v;t=J}if(t){Q=u.range;t=Q.document;v=u.blockLimit;V=0;var R,H=[],I,O;J=w=0;var K,B=Q.startContainer;G=u.endPath.elements[0];var Z,C=G.getPosition(B),z=!!G.getCommonAncestor(B)&&C!=CKEDITOR.POSITION_IDENTICAL&&!(C&CKEDITOR.POSITION_CONTAINS+CKEDITOR.POSITION_IS_CONTAINED),B=b(u.dataWrapper,u);for(E(B,Q);V<B.length;V++){C=B[V];if(L=C.isLineBreak)L=Q,q=v,x=y=void 0,C.hasBlockSibling?L=1:(y=L.startContainer.getAscendant(D.$block,1))&&y.is({div:1,p:1})?(x=y.getPosition(q),x==
CKEDITOR.POSITION_IDENTICAL||x==CKEDITOR.POSITION_CONTAINS?L=0:(q=L.splitElement(y),L.moveToPosition(q,CKEDITOR.POSITION_AFTER_START),L=1)):L=0;if(L)J=0<V;else{L=Q.startPath();!C.isBlock&&l(u.editor,L.block,L.blockLimit)&&(O=h(u.editor))&&(O=t.createElement(O),O.appendBogus(),Q.insertNode(O),CKEDITOR.env.needsBrFiller&&(R=O.getBogus())&&R.remove(),Q.moveToPosition(O,CKEDITOR.POSITION_BEFORE_END));if((L=Q.startPath().block)&&!L.equals(I)){if(R=L.getBogus())R.remove(),H.push(L);I=L}C.firstNotAllowed&&
(w=1);if(w&&C.isElement){L=Q.startContainer;for(q=null;L&&!D[L.getName()][C.name];){if(L.equals(v)){L=null;break}q=L;L=L.getParent()}if(L)q&&(K=Q.splitElement(q),u.zombies.push(K),u.zombies.push(q));else{q=v.getName();Z=!V;L=V==B.length-1;q=d(C.node,q);y=[];x=q.length;for(var aa=0,ca=void 0,X=0,W=-1;aa<x;aa++)ca=q[aa]," "==ca?(X||Z&&!aa||(y.push(new CKEDITOR.dom.text(" ")),W=y.length),X=1):(y.push(ca),X=0);L&&W==y.length&&y.pop();Z=y}}if(Z){for(;L=Z.pop();)Q.insertNode(L);Z=0}else Q.insertNode(C.node);
C.lastNotAllowed&&V<B.length-1&&((K=z?G:K)&&Q.setEndAt(K,CKEDITOR.POSITION_AFTER_START),w=0);Q.collapse()}}1!=B.length?R=!1:(R=B[0],R=R.isElement&&"false"==R.node.getAttribute("contenteditable"));R&&(J=!0,L=B[0].node,Q.setStartAt(L,CKEDITOR.POSITION_BEFORE_START),Q.setEndAt(L,CKEDITOR.POSITION_AFTER_END));u.dontMoveCaret=J;u.bogusNeededBlocks=H}R=u.range;var Y;Z=u.bogusNeededBlocks;for(I=R.createBookmark();O=u.zombies.pop();)O.getParent()&&(K=R.clone(),K.moveToElementEditStart(O),K.removeEmptyBlocksAtEnd());
if(Z)for(;O=Z.pop();)CKEDITOR.env.needsBrFiller?O.appendBogus():O.append(R.document.createText(" "));for(;O=u.mergeCandidates.pop();)O.mergeSiblings();CKEDITOR.env.webkit&&R.startPath()&&(O=R.startPath(),O.block?O.block.$.normalize():O.blockLimit&&O.blockLimit.$.normalize());R.moveToBookmark(I);if(!u.dontMoveCaret){for(O=e(R);O&&a(O)&&!O.is(D.$empty);){if(O.isBlockBoundary())R.moveToPosition(O,CKEDITOR.POSITION_BEFORE_END);else{if(f(O)&&O.getHtml().match(/(\s|&nbsp;)$/g)){Y=null;break}Y=R.clone();
Y.moveToPosition(O,CKEDITOR.POSITION_BEFORE_END)}O=O.getLast(c)}Y&&R.moveToRange(Y)}}}}();H=function(){function a(b){b=new CKEDITOR.dom.walker(b);b.guard=function(a,b){if(b)return!1;if(a.type==CKEDITOR.NODE_ELEMENT)return a.is(CKEDITOR.dtd.$tableContent)};b.evaluator=function(a){return a.type==CKEDITOR.NODE_ELEMENT};return b}function b(a,c,d){c=a.getDocument().createElement(c);a.append(c,d);return c}function c(a){var b=a.count(),d;for(b;0<b--;)d=a.getItem(b),CKEDITOR.tools.trim(d.getHtml())||(d.appendBogus(),
CKEDITOR.env.ie&&9>CKEDITOR.env.version&&d.getChildCount()&&d.getFirst().remove())}return function(d){var e=d.startContainer,f=e.getAscendant("table",1),g=!1;c(f.getElementsByTag("td"));c(f.getElementsByTag("th"));f=d.clone();f.setStart(e,0);f=a(f).lastBackward();f||(f=d.clone(),f.setEndAt(e,CKEDITOR.POSITION_BEFORE_END),f=a(f).lastForward(),g=!0);f||(f=e);f.is("table")?(d.setStartAt(f,CKEDITOR.POSITION_BEFORE_START),d.collapse(!0),f.remove()):(f.is({tbody:1,thead:1,tfoot:1})&&(f=b(f,"tr",g)),f.is("tr")&&
(f=b(f,f.getParent().is("thead")?"th":"td",g)),(e=f.getBogus())&&e.remove(),d.moveToPosition(f,g?CKEDITOR.POSITION_AFTER_START:CKEDITOR.POSITION_BEFORE_END))}}();x=function(){function a(b){b=new CKEDITOR.dom.walker(b);b.guard=function(a,b){if(b)return!1;if(a.type==CKEDITOR.NODE_ELEMENT)return a.is(CKEDITOR.dtd.$list)||a.is(CKEDITOR.dtd.$listItem)};b.evaluator=function(a){return a.type==CKEDITOR.NODE_ELEMENT&&a.is(CKEDITOR.dtd.$listItem)};return b}return function(b){var c=b.startContainer,d=!1,e;e=
b.clone();e.setStart(c,0);e=a(e).lastBackward();e||(e=b.clone(),e.setEndAt(c,CKEDITOR.POSITION_BEFORE_END),e=a(e).lastForward(),d=!0);e||(e=c);e.is(CKEDITOR.dtd.$list)?(b.setStartAt(e,CKEDITOR.POSITION_BEFORE_START),b.collapse(!0),e.remove()):((c=e.getBogus())&&c.remove(),b.moveToPosition(e,d?CKEDITOR.POSITION_AFTER_START:CKEDITOR.POSITION_BEFORE_END),b.select())}}();I={eol:{detect:function(a,b){var c=a.range,d=c.clone(),e=c.clone(),f=new CKEDITOR.dom.elementPath(c.startContainer,b),g=new CKEDITOR.dom.elementPath(c.endContainer,
b);d.collapse(1);e.collapse();f.block&&d.checkBoundaryOfElement(f.block,CKEDITOR.END)&&(c.setStartAfter(f.block),a.prependEolBr=1);g.block&&e.checkBoundaryOfElement(g.block,CKEDITOR.START)&&(c.setEndBefore(g.block),a.appendEolBr=1)},fix:function(a,b){var c=b.getDocument(),d;a.appendEolBr&&(d=this.createEolBr(c),a.fragment.append(d));!a.prependEolBr||d&&!d.getPrevious()||a.fragment.append(this.createEolBr(c),1)},createEolBr:function(a){return a.createElement("br",{attributes:{"data-cke-eol":1}})}},
bogus:{exclude:function(a){var b=a.range.getBoundaryNodes(),c=b.startNode,b=b.endNode;!b||!G(b)||c&&c.equals(b)||a.range.setEndBefore(b)}},tree:{rebuild:function(a,b){var c=a.range,d=c.getCommonAncestor(),e=new CKEDITOR.dom.elementPath(d,b),f=new CKEDITOR.dom.elementPath(c.startContainer,b),c=new CKEDITOR.dom.elementPath(c.endContainer,b),g;d.type==CKEDITOR.NODE_TEXT&&(d=d.getParent());if(e.blockLimit.is({tr:1,table:1})){var h=e.contains("table").getParent();g=function(a){return!a.equals(h)}}else if(e.block&&
e.block.is(CKEDITOR.dtd.$listItem)&&(f=f.contains(CKEDITOR.dtd.$list),c=c.contains(CKEDITOR.dtd.$list),!f.equals(c))){var l=e.contains(CKEDITOR.dtd.$list).getParent();g=function(a){return!a.equals(l)}}g||(g=function(a){return!a.equals(e.block)&&!a.equals(e.blockLimit)});this.rebuildFragment(a,b,d,g)},rebuildFragment:function(a,b,c,d){for(var e;c&&!c.equals(b)&&d(c);)e=c.clone(0,1),a.fragment.appendTo(e),a.fragment=e,c=c.getParent()}},cell:{shrink:function(a){a=a.range;var b=a.startContainer,c=a.endContainer,
d=a.startOffset,e=a.endOffset;b.type==CKEDITOR.NODE_ELEMENT&&b.equals(c)&&b.is("tr")&&++d==e&&a.shrink(CKEDITOR.SHRINK_TEXT)}}};K=function(){function a(b,c){var d=b.getParent();if(d.is(CKEDITOR.dtd.$inline))b[c?"insertBefore":"insertAfter"](d)}function b(c,d,e){a(d);a(e,1);for(var f;f=e.getNext();)f.insertAfter(d),d=f;y(c)&&c.remove()}function c(a,b){var d=new CKEDITOR.dom.range(a);d.setStartAfter(b.startNode);d.setEndBefore(b.endNode);return d}return{list:{detectMerge:function(a,b){var d=c(b,a.bookmark),
e=d.startPath(),f=d.endPath(),g=e.contains(CKEDITOR.dtd.$list),h=f.contains(CKEDITOR.dtd.$list);a.mergeList=g&&h&&g.getParent().equals(h.getParent())&&!g.equals(h);a.mergeListItems=e.block&&f.block&&e.block.is(CKEDITOR.dtd.$listItem)&&f.block.is(CKEDITOR.dtd.$listItem);if(a.mergeList||a.mergeListItems)d=d.clone(),d.setStartBefore(a.bookmark.startNode),d.setEndAfter(a.bookmark.endNode),a.mergeListBookmark=d.createBookmark()},merge:function(a,c){if(a.mergeListBookmark){var d=a.mergeListBookmark.startNode,
e=a.mergeListBookmark.endNode,f=new CKEDITOR.dom.elementPath(d,c),g=new CKEDITOR.dom.elementPath(e,c);if(a.mergeList){var h=f.contains(CKEDITOR.dtd.$list),l=g.contains(CKEDITOR.dtd.$list);h.equals(l)||(l.moveChildren(h),l.remove())}a.mergeListItems&&(f=f.contains(CKEDITOR.dtd.$listItem),g=g.contains(CKEDITOR.dtd.$listItem),f.equals(g)||b(g,d,e));d.remove();e.remove()}}},block:{detectMerge:function(a,b){if(!a.tableContentsRanges&&!a.mergeListBookmark){var c=new CKEDITOR.dom.range(b);c.setStartBefore(a.bookmark.startNode);
c.setEndAfter(a.bookmark.endNode);a.mergeBlockBookmark=c.createBookmark()}},merge:function(a,c){if(a.mergeBlockBookmark&&!a.purgeTableBookmark){var d=a.mergeBlockBookmark.startNode,e=a.mergeBlockBookmark.endNode,f=new CKEDITOR.dom.elementPath(d,c),g=new CKEDITOR.dom.elementPath(e,c),f=f.block,g=g.block;f&&g&&!f.equals(g)&&b(g,d,e);d.remove();e.remove()}}},table:function(){function a(c){var e=[],f,g=new CKEDITOR.dom.walker(c),h=c.startPath().contains(d),t=c.endPath().contains(d),l={};g.guard=function(a,
g){if(a.type==CKEDITOR.NODE_ELEMENT){var k="visited_"+(g?"out":"in");if(a.getCustomData(k))return;CKEDITOR.dom.element.setMarker(l,a,k,1)}if(g&&h&&a.equals(h))f=c.clone(),f.setEndAt(h,CKEDITOR.POSITION_BEFORE_END),e.push(f);else if(!g&&t&&a.equals(t))f=c.clone(),f.setStartAt(t,CKEDITOR.POSITION_AFTER_START),e.push(f);else{if(k=!g)k=a.type==CKEDITOR.NODE_ELEMENT&&a.is(d)&&(!h||b(a,h))&&(!t||b(a,t));if(!k&&(k=g))if(a.is(d))var k=h&&h.getAscendant("table",!0),m=t&&t.getAscendant("table",!0),p=a.getAscendant("table",
!0),k=k&&k.contains(p)||m&&m.contains(p);else k=void 0;k&&(f=c.clone(),f.selectNodeContents(a),e.push(f))}};g.lastForward();CKEDITOR.dom.element.clearAllMarkers(l);return e}function b(a,c){var d=CKEDITOR.POSITION_CONTAINS+CKEDITOR.POSITION_IS_CONTAINED,e=a.getPosition(c);return e===CKEDITOR.POSITION_IDENTICAL?!1:0===(e&d)}var d={td:1,th:1,caption:1};return{detectPurge:function(a){var b=a.range,c=b.clone();c.enlarge(CKEDITOR.ENLARGE_ELEMENT);var c=new CKEDITOR.dom.walker(c),e=0;c.evaluator=function(a){a.type==
CKEDITOR.NODE_ELEMENT&&a.is(d)&&++e};c.checkForward();if(1<e){var c=b.startPath().contains("table"),f=b.endPath().contains("table");c&&f&&b.checkBoundaryOfElement(c,CKEDITOR.START)&&b.checkBoundaryOfElement(f,CKEDITOR.END)&&(b=a.range.clone(),b.setStartBefore(c),b.setEndAfter(f),a.purgeTableBookmark=b.createBookmark())}},detectRanges:function(e,f){var g=c(f,e.bookmark),h=g.clone(),l,t,k=g.getCommonAncestor();k.is(CKEDITOR.dtd.$tableContent)&&!k.is(d)&&(k=k.getAscendant("table",!0));t=k;k=new CKEDITOR.dom.elementPath(g.startContainer,
t);t=new CKEDITOR.dom.elementPath(g.endContainer,t);k=k.contains("table");t=t.contains("table");if(k||t)k&&t&&b(k,t)?(e.tableSurroundingRange=h,h.setStartAt(k,CKEDITOR.POSITION_AFTER_END),h.setEndAt(t,CKEDITOR.POSITION_BEFORE_START),h=g.clone(),h.setEndAt(k,CKEDITOR.POSITION_AFTER_END),l=g.clone(),l.setStartAt(t,CKEDITOR.POSITION_BEFORE_START),l=a(h).concat(a(l))):k?t||(e.tableSurroundingRange=h,h.setStartAt(k,CKEDITOR.POSITION_AFTER_END),g.setEndAt(k,CKEDITOR.POSITION_AFTER_END)):(e.tableSurroundingRange=
h,h.setEndAt(t,CKEDITOR.POSITION_BEFORE_START),g.setStartAt(t,CKEDITOR.POSITION_AFTER_START)),e.tableContentsRanges=l?l:a(g)},deleteRanges:function(a){for(var b;b=a.tableContentsRanges.pop();)b.extractContents(),y(b.startContainer)&&b.startContainer.appendBogus();a.tableSurroundingRange&&a.tableSurroundingRange.extractContents()},purge:function(a){if(a.purgeTableBookmark){var b=a.doc,c=a.range.clone(),b=b.createElement("p");b.insertBefore(a.purgeTableBookmark.startNode);c.moveToBookmark(a.purgeTableBookmark);
c.deleteContents();a.range.moveToPosition(b,CKEDITOR.POSITION_AFTER_START)}}}}(),detectExtractMerge:function(a){return!(a.range.startPath().contains(CKEDITOR.dtd.$listItem)&&a.range.endPath().contains(CKEDITOR.dtd.$listItem))},fixUneditableRangePosition:function(a){a.startContainer.getDtd()["#"]||a.moveToClosestEditablePosition(null,!0)},autoParagraph:function(a,b){var c=b.startPath(),d;l(a,c.block,c.blockLimit)&&(d=h(a))&&(d=b.document.createElement(d),d.appendBogus(),b.insertNode(d),b.moveToPosition(d,
CKEDITOR.POSITION_AFTER_START))}}}()})();
(function(){function a(a){return CKEDITOR.plugins.widget&&CKEDITOR.plugins.widget.isDomWidget(a)}function d(b,c){if(0===b.length||a(b[0].getEnclosedNode()))return!1;var d,e;if((d=!c&&1===b.length)&&!(d=b[0].collapsed)){var f=b[0];d=f.startContainer.getAscendant({td:1,th:1},!0);var g=f.endContainer.getAscendant({td:1,th:1},!0);e=CKEDITOR.tools.trim;d&&d.equals(g)&&!d.findOne("td, th, tr, tbody, table")?(f=f.cloneContents(),d=f.getFirst()?e(f.getFirst().getText())!==e(d.getText()):!0):d=!1}if(d)return!1;
for(e=0;e<b.length;e++)if(d=b[e]._getTableElement(),!d)return!1;return!0}function b(a){function b(a){a=a.find("td, th");var c=[],d;for(d=0;d<a.count();d++)c.push(a.getItem(d));return c}var c=[],d,e;for(e=0;e<a.length;e++)d=a[e]._getTableElement(),d.is&&d.is({td:1,th:1})?c.push(d):c=c.concat(b(d));return c}function c(a){a=b(a);var c="",d=[],e,f;for(f=0;f<a.length;f++)e&&!e.equals(a[f].getAscendant("tr"))?(c+=d.join("\t")+"\n",e=a[f].getAscendant("tr"),d=[]):0===f&&(e=a[f].getAscendant("tr")),d.push(a[f].getText());
return c+=d.join("\t")}function g(a){var b=this.root.editor,d=b.getSelection(1);this.reset();K=!0;d.root.once("selectionchange",function(a){a.cancel()},null,null,0);d.selectRanges([a[0]]);d=this._.cache;d.ranges=new CKEDITOR.dom.rangeList(a);d.type=CKEDITOR.SELECTION_TEXT;d.selectedElement=a[0]._getTableElement();d.selectedText=c(a);d.nativeSel=null;this.isFake=1;this.rev=H++;b._.fakeSelection=this;K=!1;this.root.fire("selectionchange")}function f(){var b=this._.fakeSelection,c;if(b){c=this.getSelection(1);
var e;if(!(e=!c)&&(e=!c.isHidden())){e=b;var f=c.getRanges(),g=e.getRanges(),h=f.length&&f[0]._getTableElement()&&f[0]._getTableElement().getAscendant("table",!0),l=g.length&&g[0]._getTableElement()&&g[0]._getTableElement().getAscendant("table",!0),k=1===f.length&&f[0]._getTableElement()&&f[0]._getTableElement().is("table"),J=1===g.length&&g[0]._getTableElement()&&g[0]._getTableElement().is("table");if(a(e.getSelectedElement()))e=!1;else{var v=1===f.length&&f[0].collapsed,g=d(f,!!CKEDITOR.env.webkit)&&
d(g);h=h&&l?h.equals(l)||l.contains(h):!1;h&&(v||g)?(k&&!J&&e.selectRanges(f),e=!0):e=!1}e=!e}e&&(b.reset(),b=0)}if(!b&&(b=c||this.getSelection(1),!b||b.getType()==CKEDITOR.SELECTION_NONE))return;this.fire("selectionCheck",b);c=this.elementPath();c.compare(this._.selectionPreviousPath)||(e=this._.selectionPreviousPath&&this._.selectionPreviousPath.blockLimit.equals(c.blockLimit),!CKEDITOR.env.webkit&&!CKEDITOR.env.gecko||e||(this._.previousActive=this.document.getActive()),this._.selectionPreviousPath=
c,this.fire("selectionChange",{selection:b,path:c}))}function l(){F=!0;m||(h.call(this),m=CKEDITOR.tools.setTimeout(h,200,this))}function h(){m=null;F&&(CKEDITOR.tools.setTimeout(f,0,this),F=!1)}function k(a){return M(a)||a.type==CKEDITOR.NODE_ELEMENT&&!a.is(CKEDITOR.dtd.$empty)?!0:!1}function p(a){function b(c,d){return c&&c.type!=CKEDITOR.NODE_TEXT?a.clone()["moveToElementEdit"+(d?"End":"Start")](c):!1}if(!(a.root instanceof CKEDITOR.editable))return!1;var c=a.startContainer,d=a.getPreviousNode(k,
null,c),e=a.getNextNode(k,null,c);return b(d)||b(e,1)||!(d||e||c.type==CKEDITOR.NODE_ELEMENT&&c.isBlockBoundary()&&c.getBogus())?!0:!1}function e(a){z(a,!1);var b=a.getDocument().createText(x);a.setCustomData("cke-fillingChar",b);return b}function z(a,b){var c=a&&a.removeCustomData("cke-fillingChar");if(c){if(!1!==b){var d=a.getDocument().getSelection().getNative(),e=d&&"None"!=d.type&&d.getRangeAt(0),f=x.length;if(c.getLength()>f&&e&&e.intersectsNode(c.$)){var g=[{node:d.anchorNode,offset:d.anchorOffset},
{node:d.focusNode,offset:d.focusOffset}];d.anchorNode==c.$&&d.anchorOffset>f&&(g[0].offset-=f);d.focusNode==c.$&&d.focusOffset>f&&(g[1].offset-=f)}}c.setText(w(c.getText(),1));g&&(c=a.getDocument().$,d=c.getSelection(),c=c.createRange(),c.setStart(g[0].node,g[0].offset),c.collapse(!0),d.removeAllRanges(),d.addRange(c),d.extend(g[1].node,g[1].offset))}}function w(a,b){return b?a.replace(I,function(a,b){return b?" ":""}):a.replace(x,"")}function y(a,b){var c=b&&CKEDITOR.tools.htmlEncode(b)||"\x26nbsp;",
c=CKEDITOR.dom.element.createFromHtml('\x3cdiv data-cke-hidden-sel\x3d"1" data-cke-temp\x3d"1" style\x3d"'+(CKEDITOR.env.ie&&14>CKEDITOR.env.version?"display:none":"position:fixed;top:0;left:-1000px;width:0;height:0;overflow:hidden;")+'"\x3e'+c+"\x3c/div\x3e",a.document);a.fire("lockSnapshot");a.editable().append(c);var d=a.getSelection(1),e=a.createRange(),f=d.root.on("selectionchange",function(a){a.cancel()},null,null,0);e.setStartAt(c,CKEDITOR.POSITION_AFTER_START);e.setEndAt(c,CKEDITOR.POSITION_BEFORE_END);
d.selectRanges([e]);f.removeListener();a.fire("unlockSnapshot");a._.hiddenSelectionContainer=c}function G(a){var b={37:1,39:1,8:1,46:1};return function(c){var d=c.data.getKeystroke();if(b[d]){var e=a.getSelection().getRanges(),f=e[0];1==e.length&&f.collapsed&&(d=f[38>d?"getPreviousEditableNode":"getNextEditableNode"]())&&d.type==CKEDITOR.NODE_ELEMENT&&"false"==d.getAttribute("contenteditable")&&(a.getSelection().fake(d),c.data.preventDefault(),c.cancel())}}}function q(a){for(var b=0;b<a.length;b++){var c=
a[b];c.getCommonAncestor().isReadOnly()&&a.splice(b,1);if(!c.collapsed){if(c.startContainer.isReadOnly())for(var d=c.startContainer,e;d&&!((e=d.type==CKEDITOR.NODE_ELEMENT)&&d.is("body")||!d.isReadOnly());)e&&"false"==d.getAttribute("contentEditable")&&c.setStartAfter(d),d=d.getParent();d=c.startContainer;e=c.endContainer;var f=c.startOffset,g=c.endOffset,h=c.clone();d&&d.type==CKEDITOR.NODE_TEXT&&(f>=d.getLength()?h.setStartAfter(d):h.setStartBefore(d));e&&e.type==CKEDITOR.NODE_TEXT&&(g?h.setEndAfter(e):
h.setEndBefore(e));d=new CKEDITOR.dom.walker(h);d.evaluator=function(d){if(d.type==CKEDITOR.NODE_ELEMENT&&d.isReadOnly()){var e=c.clone();c.setEndBefore(d);c.collapsed&&a.splice(b--,1);d.getPosition(h.endContainer)&CKEDITOR.POSITION_CONTAINS||(e.setStartAfter(d),e.collapsed||a.splice(b+1,0,e));return!0}return!1};d.next()}}return a}var n="function"!=typeof window.getSelection,H=1,x=CKEDITOR.tools.repeat("​",7),I=new RegExp(x+"( )?","g"),K,m,F,M=CKEDITOR.dom.walker.invisible(1),A=function(){function a(b){return function(a){var c=
a.editor.createRange();c.moveToClosestEditablePosition(a.selected,b)&&a.editor.getSelection().selectRanges([c]);return!1}}function b(a){return function(b){var c=b.editor,d=c.createRange(),e;if(!c.readOnly)return(e=d.moveToClosestEditablePosition(b.selected,a))||(e=d.moveToClosestEditablePosition(b.selected,!a)),e&&c.getSelection().selectRanges([d]),c.fire("saveSnapshot"),b.selected.remove(),e||(d.moveToElementEditablePosition(c.editable()),c.getSelection().selectRanges([d])),c.fire("saveSnapshot"),
!1}}var c=a(),d=a(1);return{37:c,38:c,39:d,40:d,8:b(),46:b(1)}}();CKEDITOR.on("instanceCreated",function(a){function b(){var a=c.getSelection();a&&a.removeAllRanges()}var c=a.editor;c.on("contentDom",function(){function a(){q=new CKEDITOR.dom.selection(c.getSelection());q.lock()}function b(){h.removeListener("mouseup",b);m.removeListener("mouseup",b);var a=CKEDITOR.document.$.selection,c=a.createRange();"None"!=a.type&&c.parentElement()&&c.parentElement().ownerDocument==g.$&&c.select()}function d(a){var b,
c;b=(b=this.document.getActive())?"input"===b.getName()||"textarea"===b.getName():!1;b||(b=this.getSelection(1),(c=e(b))&&!c.equals(k)&&(b.selectElement(c),a.data.preventDefault()))}function e(a){a=a.getRanges()[0];return a?(a=a.startContainer.getAscendant(function(a){return a.type==CKEDITOR.NODE_ELEMENT&&a.hasAttribute("contenteditable")},!0))&&"false"===a.getAttribute("contenteditable")?a:null:null}var g=c.document,h=CKEDITOR.document,k=c.editable(),r=g.getBody(),m=g.getDocumentElement(),p=k.isInline(),
E,q;CKEDITOR.env.gecko&&k.attachListener(k,"focus",function(a){a.removeListener();0!==E&&(a=c.getSelection().getNative())&&a.isCollapsed&&a.anchorNode==k.$&&(a=c.createRange(),a.moveToElementEditStart(k),a.select())},null,null,-2);k.attachListener(k,CKEDITOR.env.webkit||CKEDITOR.env.gecko?"focusin":"focus",function(){if(E&&(CKEDITOR.env.webkit||CKEDITOR.env.gecko)){E=c._.previousActive&&c._.previousActive.equals(g.getActive());var a=null!=c._.previousScrollTop&&c._.previousScrollTop!=k.$.scrollTop;
CKEDITOR.env.webkit&&E&&a&&(k.$.scrollTop=c._.previousScrollTop)}c.unlockSelection(E);E=0},null,null,-1);k.attachListener(k,"mousedown",function(){E=0});if(CKEDITOR.env.ie||CKEDITOR.env.gecko||p)n?k.attachListener(k,"beforedeactivate",a,null,null,-1):k.attachListener(c,"selectionCheck",a,null,null,-1),k.attachListener(k,CKEDITOR.env.webkit||CKEDITOR.env.gecko?"focusout":"blur",function(){var a=q&&(q.isFake||2>q.getRanges().length);CKEDITOR.env.gecko&&!p&&a||(c.lockSelection(q),E=1)},null,null,-1),
k.attachListener(k,"mousedown",function(){E=0});if(CKEDITOR.env.ie&&!p){var w;k.attachListener(k,"mousedown",function(a){2==a.data.$.button&&((a=c.document.getSelection())&&a.getType()!=CKEDITOR.SELECTION_NONE||(w=c.window.getScrollPosition()))});k.attachListener(k,"mouseup",function(a){2==a.data.$.button&&w&&(c.document.$.documentElement.scrollLeft=w.x,c.document.$.documentElement.scrollTop=w.y);w=null});if("BackCompat"!=g.$.compatMode){if(CKEDITOR.env.ie7Compat||CKEDITOR.env.ie6Compat){var y,x;
m.on("mousedown",function(a){function b(a){a=a.data.$;if(y){var c=r.$.createTextRange();try{c.moveToPoint(a.clientX,a.clientY)}catch(d){}y.setEndPoint(0>x.compareEndPoints("StartToStart",c)?"EndToEnd":"StartToStart",c);y.select()}}function c(){m.removeListener("mousemove",b);h.removeListener("mouseup",c);m.removeListener("mouseup",c);y.select()}a=a.data;if(a.getTarget().is("html")&&a.$.y<m.$.clientHeight&&a.$.x<m.$.clientWidth){y=r.$.createTextRange();try{y.moveToPoint(a.$.clientX,a.$.clientY)}catch(d){}x=
y.duplicate();m.on("mousemove",b);h.on("mouseup",c);m.on("mouseup",c)}})}if(7<CKEDITOR.env.version&&11>CKEDITOR.env.version)m.on("mousedown",function(a){a.data.getTarget().is("html")&&(h.on("mouseup",b),m.on("mouseup",b))})}}k.attachListener(k,"selectionchange",f,c);k.attachListener(k,"keyup",l,c);k.attachListener(k,"touchstart",l,c);k.attachListener(k,"touchend",l,c);CKEDITOR.env.ie&&k.attachListener(k,"keydown",d,c);k.attachListener(k,CKEDITOR.env.webkit||CKEDITOR.env.gecko?"focusin":"focus",function(){c.forceNextSelectionCheck();
c.selectionChange(1)});if(p&&(CKEDITOR.env.webkit||CKEDITOR.env.gecko)){var A;k.attachListener(k,"mousedown",function(){A=1});k.attachListener(g.getDocumentElement(),"mouseup",function(){A&&l.call(c);A=0})}else k.attachListener(CKEDITOR.env.ie?k:g.getDocumentElement(),"mouseup",l,c);CKEDITOR.env.webkit&&k.attachListener(g,"keydown",function(a){switch(a.data.getKey()){case 13:case 33:case 34:case 35:case 36:case 37:case 39:case 8:case 45:case 46:k.hasFocus&&z(k)}},null,null,-1);k.attachListener(k,
"keydown",G(c),null,null,-1)});c.on("setData",function(){c.unlockSelection();CKEDITOR.env.webkit&&b()});c.on("contentDomUnload",function(){c.unlockSelection()});if(CKEDITOR.env.ie9Compat)c.on("beforeDestroy",b,null,null,9);c.on("dataReady",function(){delete c._.fakeSelection;delete c._.hiddenSelectionContainer;c.selectionChange(1)});c.on("loadSnapshot",function(){var a=CKEDITOR.dom.walker.nodeType(CKEDITOR.NODE_ELEMENT),b=c.editable().getLast(a);b&&b.hasAttribute("data-cke-hidden-sel")&&(b.remove(),
CKEDITOR.env.gecko&&(a=c.editable().getFirst(a))&&a.is("br")&&a.getAttribute("_moz_editor_bogus_node")&&a.remove())},null,null,100);c.on("key",function(a){if("wysiwyg"==c.mode){var b=c.getSelection();if(b.isFake){var d=A[a.data.keyCode];if(d)return d({editor:c,selected:b.getSelectedElement(),selection:b,keyEvent:a})}}})});if(CKEDITOR.env.webkit)CKEDITOR.on("instanceReady",function(a){var b=a.editor;b.on("selectionChange",function(){var a=b.editable(),c=a.getCustomData("cke-fillingChar");c&&(c.getCustomData("ready")?
(z(a),a.editor.fire("selectionCheck")):c.setCustomData("ready",1))},null,null,-1);b.on("beforeSetMode",function(){z(b.editable())},null,null,-1);b.on("getSnapshot",function(a){a.data&&(a.data=w(a.data))},b,null,20);b.on("toDataFormat",function(a){a.data.dataValue=w(a.data.dataValue)},null,null,0)});CKEDITOR.editor.prototype.selectionChange=function(a){(a?f:l).call(this)};CKEDITOR.editor.prototype.getSelection=function(a){return!this._.savedSelection&&!this._.fakeSelection||a?(a=this.editable())&&
"wysiwyg"==this.mode?new CKEDITOR.dom.selection(a):null:this._.savedSelection||this._.fakeSelection};CKEDITOR.editor.prototype.getSelectedRanges=function(a){var b=this.getSelection();return b&&b.getRanges(a)||[]};CKEDITOR.editor.prototype.lockSelection=function(a){a=a||this.getSelection(1);return a.getType()!=CKEDITOR.SELECTION_NONE?(!a.isLocked&&a.lock(),this._.savedSelection=a,!0):!1};CKEDITOR.editor.prototype.unlockSelection=function(a){var b=this._.savedSelection;return b?(b.unlock(a),delete this._.savedSelection,
!0):!1};CKEDITOR.editor.prototype.forceNextSelectionCheck=function(){delete this._.selectionPreviousPath};CKEDITOR.dom.document.prototype.getSelection=function(){return new CKEDITOR.dom.selection(this)};CKEDITOR.dom.range.prototype.select=function(){var a=this.root instanceof CKEDITOR.editable?this.root.editor.getSelection():new CKEDITOR.dom.selection(this.root);a.selectRanges([this]);return a};CKEDITOR.SELECTION_NONE=1;CKEDITOR.SELECTION_TEXT=2;CKEDITOR.SELECTION_ELEMENT=3;CKEDITOR.dom.selection=
function(a){if(a instanceof CKEDITOR.dom.selection){var b=a;a=a.root}var c=a instanceof CKEDITOR.dom.element;this.rev=b?b.rev:H++;this.document=a instanceof CKEDITOR.dom.document?a:a.getDocument();this.root=c?a:this.document.getBody();this.isLocked=0;this._={cache:{}};if(b)return CKEDITOR.tools.extend(this._.cache,b._.cache),this.isFake=b.isFake,this.isLocked=b.isLocked,this;a=this.getNative();var d,e;if(a)if(a.getRangeAt)d=(e=a.rangeCount&&a.getRangeAt(0))&&new CKEDITOR.dom.node(e.commonAncestorContainer);
else{try{e=a.createRange()}catch(f){}d=e&&CKEDITOR.dom.element.get(e.item&&e.item(0)||e.parentElement())}if(!d||d.type!=CKEDITOR.NODE_ELEMENT&&d.type!=CKEDITOR.NODE_TEXT||!this.root.equals(d)&&!this.root.contains(d))this._.cache.type=CKEDITOR.SELECTION_NONE,this._.cache.startElement=null,this._.cache.selectedElement=null,this._.cache.selectedText="",this._.cache.ranges=new CKEDITOR.dom.rangeList;return this};var N={img:1,hr:1,li:1,table:1,tr:1,td:1,th:1,embed:1,object:1,ol:1,ul:1,a:1,input:1,form:1,
select:1,textarea:1,button:1,fieldset:1,thead:1,tfoot:1};CKEDITOR.tools.extend(CKEDITOR.dom.selection,{_removeFillingCharSequenceString:w,_createFillingCharSequenceNode:e,FILLING_CHAR_SEQUENCE:x});CKEDITOR.dom.selection.prototype={getNative:function(){return void 0!==this._.cache.nativeSel?this._.cache.nativeSel:this._.cache.nativeSel=n?this.document.$.selection:this.document.getWindow().$.getSelection()},getType:n?function(){var a=this._.cache;if(a.type)return a.type;var b=CKEDITOR.SELECTION_NONE;
try{var c=this.getNative(),d=c.type;"Text"==d&&(b=CKEDITOR.SELECTION_TEXT);"Control"==d&&(b=CKEDITOR.SELECTION_ELEMENT);c.createRange().parentElement()&&(b=CKEDITOR.SELECTION_TEXT)}catch(e){}return a.type=b}:function(){var a=this._.cache;if(a.type)return a.type;var b=CKEDITOR.SELECTION_TEXT,c=this.getNative();if(!c||!c.rangeCount)b=CKEDITOR.SELECTION_NONE;else if(1==c.rangeCount){var c=c.getRangeAt(0),d=c.startContainer;d==c.endContainer&&1==d.nodeType&&1==c.endOffset-c.startOffset&&N[d.childNodes[c.startOffset].nodeName.toLowerCase()]&&
(b=CKEDITOR.SELECTION_ELEMENT)}return a.type=b},getRanges:function(){var a=n?function(){function a(b){return(new CKEDITOR.dom.node(b)).getIndex()}var b=function(b,c){b=b.duplicate();b.collapse(c);var d=b.parentElement();if(!d.hasChildNodes())return{container:d,offset:0};for(var e=d.children,f,g,h=b.duplicate(),l=0,k=e.length-1,r=-1,m,p;l<=k;)if(r=Math.floor((l+k)/2),f=e[r],h.moveToElementText(f),m=h.compareEndPoints("StartToStart",b),0<m)k=r-1;else if(0>m)l=r+1;else return{container:d,offset:a(f)};
if(-1==r||r==e.length-1&&0>m){h.moveToElementText(d);h.setEndPoint("StartToStart",b);h=h.text.replace(/(\r\n|\r)/g,"\n").length;e=d.childNodes;if(!h)return f=e[e.length-1],f.nodeType!=CKEDITOR.NODE_TEXT?{container:d,offset:e.length}:{container:f,offset:f.nodeValue.length};for(d=e.length;0<h&&0<d;)g=e[--d],g.nodeType==CKEDITOR.NODE_TEXT&&(p=g,h-=g.nodeValue.length);return{container:p,offset:-h}}h.collapse(0<m?!0:!1);h.setEndPoint(0<m?"StartToStart":"EndToStart",b);h=h.text.replace(/(\r\n|\r)/g,"\n").length;
if(!h)return{container:d,offset:a(f)+(0<m?0:1)};for(;0<h;)try{g=f[0<m?"previousSibling":"nextSibling"],g.nodeType==CKEDITOR.NODE_TEXT&&(h-=g.nodeValue.length,p=g),f=g}catch(n){return{container:d,offset:a(f)}}return{container:p,offset:0<m?-h:p.nodeValue.length+h}};return function(){var a=this.getNative(),c=a&&a.createRange(),d=this.getType();if(!a)return[];if(d==CKEDITOR.SELECTION_TEXT)return a=new CKEDITOR.dom.range(this.root),d=b(c,!0),a.setStart(new CKEDITOR.dom.node(d.container),d.offset),d=b(c),
a.setEnd(new CKEDITOR.dom.node(d.container),d.offset),a.endContainer.getPosition(a.startContainer)&CKEDITOR.POSITION_PRECEDING&&a.endOffset<=a.startContainer.getIndex()&&a.collapse(),[a];if(d==CKEDITOR.SELECTION_ELEMENT){for(var d=[],e=0;e<c.length;e++){for(var f=c.item(e),g=f.parentNode,h=0,a=new CKEDITOR.dom.range(this.root);h<g.childNodes.length&&g.childNodes[h]!=f;h++);a.setStart(new CKEDITOR.dom.node(g),h);a.setEnd(new CKEDITOR.dom.node(g),h+1);d.push(a)}return d}return[]}}():function(){var a=
[],b,c=this.getNative();if(!c)return a;for(var d=0;d<c.rangeCount;d++){var e=c.getRangeAt(d);b=new CKEDITOR.dom.range(this.root);b.setStart(new CKEDITOR.dom.node(e.startContainer),e.startOffset);b.setEnd(new CKEDITOR.dom.node(e.endContainer),e.endOffset);a.push(b)}return a};return function(b){var c=this._.cache,d=c.ranges;d||(c.ranges=d=new CKEDITOR.dom.rangeList(a.call(this)));return b?q(new CKEDITOR.dom.rangeList(d.slice())):d}}(),getStartElement:function(){var a=this._.cache;if(void 0!==a.startElement)return a.startElement;
var b;switch(this.getType()){case CKEDITOR.SELECTION_ELEMENT:return this.getSelectedElement();case CKEDITOR.SELECTION_TEXT:var c=this.getRanges()[0];if(c){if(c.collapsed)b=c.startContainer,b.type!=CKEDITOR.NODE_ELEMENT&&(b=b.getParent());else{for(c.optimize();b=c.startContainer,c.startOffset==(b.getChildCount?b.getChildCount():b.getLength())&&!b.isBlockBoundary();)c.setStartAfter(b);b=c.startContainer;if(b.type!=CKEDITOR.NODE_ELEMENT)return b.getParent();if((b=b.getChild(c.startOffset))&&b.type==
CKEDITOR.NODE_ELEMENT)for(c=b.getFirst();c&&c.type==CKEDITOR.NODE_ELEMENT;)b=c,c=c.getFirst();else b=c.startContainer}b=b.$}}return a.startElement=b?new CKEDITOR.dom.element(b):null},getSelectedElement:function(){var a=this._.cache;if(void 0!==a.selectedElement)return a.selectedElement;var b=this,c=CKEDITOR.tools.tryThese(function(){return b.getNative().createRange().item(0)},function(){for(var a=b.getRanges()[0].clone(),c,d,e=2;e&&!((c=a.getEnclosedNode())&&c.type==CKEDITOR.NODE_ELEMENT&&N[c.getName()]&&
(d=c));e--)a.shrink(CKEDITOR.SHRINK_ELEMENT);return d&&d.$});return a.selectedElement=c?new CKEDITOR.dom.element(c):null},getSelectedText:function(){var a=this._.cache;if(void 0!==a.selectedText)return a.selectedText;var b=this.getNative(),b=n?"Control"==b.type?"":b.createRange().text:b.toString();return a.selectedText=b},lock:function(){this.getRanges();this.getStartElement();this.getSelectedElement();this.getSelectedText();this._.cache.nativeSel=null;this.isLocked=1},unlock:function(a){if(this.isLocked){if(a)var b=
this.getSelectedElement(),c=this.getRanges(),e=this.isFake;this.isLocked=0;this.reset();a&&(a=b||c[0]&&c[0].getCommonAncestor())&&a.getAscendant("body",1)&&((a=this.root.editor)&&a.plugins.tableselection&&a.plugins.tableselection.isSupportedEnvironment(a)&&d(c)?g.call(this,c):e?this.fake(b):b&&2>c.length?this.selectElement(b):this.selectRanges(c))}},reset:function(){this._.cache={};this.isFake=0;var a=this.root.editor;if(a&&a._.fakeSelection)if(this.rev==a._.fakeSelection.rev){delete a._.fakeSelection;
var b=a._.hiddenSelectionContainer;if(b){var c=a.checkDirty();a.fire("lockSnapshot");b.remove();a.fire("unlockSnapshot");!c&&a.resetDirty()}delete a._.hiddenSelectionContainer}else CKEDITOR.warn("selection-fake-reset");this.rev=H++},selectElement:function(a){var b=new CKEDITOR.dom.range(this.root);b.setStartBefore(a);b.setEndAfter(a);this.selectRanges([b])},selectRanges:function(a){var b=this.root.editor,c=b&&b._.hiddenSelectionContainer;this.reset();if(c)for(var c=this.root,f,h=0;h<a.length;++h)f=
a[h],f.endContainer.equals(c)&&(f.endOffset=Math.min(f.endOffset,c.getChildCount()));if(a.length)if(this.isLocked){var l=CKEDITOR.document.getActive();this.unlock();this.selectRanges(a);this.lock();l&&!l.equals(this.root)&&l.focus()}else{var k;a:{var m,J;if(1==a.length&&!(J=a[0]).collapsed&&(k=J.getEnclosedNode())&&k.type==CKEDITOR.NODE_ELEMENT&&(J=J.clone(),J.shrink(CKEDITOR.SHRINK_ELEMENT,!0),(m=J.getEnclosedNode())&&m.type==CKEDITOR.NODE_ELEMENT&&(k=m),"false"==k.getAttribute("contenteditable")))break a;
k=void 0}if(k)this.fake(k);else if(b&&b.plugins.tableselection&&b.plugins.tableselection.isSupportedEnvironment(b)&&d(a)&&!K&&!a[0]._getTableElement({table:1}).hasAttribute("data-cke-tableselection-ignored"))g.call(this,a);else{if(n){m=CKEDITOR.dom.walker.whitespaces(!0);k=/\ufeff|\u00a0/;J={table:1,tbody:1,tr:1};1<a.length&&(b=a[a.length-1],a[0].setEnd(b.endContainer,b.endOffset));b=a[0];a=b.collapsed;var v,B,C;if((c=b.getEnclosedNode())&&c.type==CKEDITOR.NODE_ELEMENT&&c.getName()in N&&(!c.is("a")||
!c.getText()))try{C=c.$.createControlRange();C.addElement(c.$);C.select();return}catch(q){}if(b.startContainer.type==CKEDITOR.NODE_ELEMENT&&b.startContainer.getName()in J||b.endContainer.type==CKEDITOR.NODE_ELEMENT&&b.endContainer.getName()in J)b.shrink(CKEDITOR.NODE_ELEMENT,!0),a=b.collapsed;C=b.createBookmark();J=C.startNode;a||(l=C.endNode);C=b.document.$.body.createTextRange();C.moveToElementText(J.$);C.moveStart("character",1);l?(k=b.document.$.body.createTextRange(),k.moveToElementText(l.$),
C.setEndPoint("EndToEnd",k),C.moveEnd("character",-1)):(v=J.getNext(m),B=J.hasAscendant("pre"),v=!(v&&v.getText&&v.getText().match(k))&&(B||!J.hasPrevious()||J.getPrevious().is&&J.getPrevious().is("br")),B=b.document.createElement("span"),B.setHtml("\x26#65279;"),B.insertBefore(J),v&&b.document.createText("﻿").insertBefore(J));b.setStartBefore(J);J.remove();a?(v?(C.moveStart("character",-1),C.select(),b.document.$.selection.clear()):C.select(),b.moveToPosition(B,CKEDITOR.POSITION_BEFORE_START),B.remove()):
(b.setEndBefore(l),l.remove(),C.select())}else{l=this.getNative();if(!l)return;this.removeAllRanges();for(C=0;C<a.length;C++){if(C<a.length-1&&(v=a[C],B=a[C+1],k=v.clone(),k.setStart(v.endContainer,v.endOffset),k.setEnd(B.startContainer,B.startOffset),!k.collapsed&&(k.shrink(CKEDITOR.NODE_ELEMENT,!0),b=k.getCommonAncestor(),k=k.getEnclosedNode(),b.isReadOnly()||k&&k.isReadOnly()))){B.setStart(v.startContainer,v.startOffset);a.splice(C--,1);continue}b=a[C];B=this.document.$.createRange();b.collapsed&&
CKEDITOR.env.webkit&&p(b)&&(k=e(this.root),b.insertNode(k),(v=k.getNext())&&!k.getPrevious()&&v.type==CKEDITOR.NODE_ELEMENT&&"br"==v.getName()?(z(this.root),b.moveToPosition(v,CKEDITOR.POSITION_BEFORE_START)):b.moveToPosition(k,CKEDITOR.POSITION_AFTER_END));B.setStart(b.startContainer.$,b.startOffset);try{B.setEnd(b.endContainer.$,b.endOffset)}catch(w){if(0<=w.toString().indexOf("NS_ERROR_ILLEGAL_VALUE"))b.collapse(1),B.setEnd(b.endContainer.$,b.endOffset);else throw w;}l.addRange(B)}}this.reset();
this.root.fire("selectionchange")}}},fake:function(a,b){var c=this.root.editor;void 0===b&&a.hasAttribute("aria-label")&&(b=a.getAttribute("aria-label"));this.reset();y(c,b);var d=this._.cache,e=new CKEDITOR.dom.range(this.root);e.setStartBefore(a);e.setEndAfter(a);d.ranges=new CKEDITOR.dom.rangeList(e);d.selectedElement=d.startElement=a;d.type=CKEDITOR.SELECTION_ELEMENT;d.selectedText=d.nativeSel=null;this.isFake=1;this.rev=H++;c._.fakeSelection=this;this.root.fire("selectionchange")},isHidden:function(){var a=
this.getCommonAncestor();a&&a.type==CKEDITOR.NODE_TEXT&&(a=a.getParent());return!(!a||!a.data("cke-hidden-sel"))},isInTable:function(a){return d(this.getRanges(),a)},isCollapsed:function(){var a=this.getRanges();return 1===a.length&&a[0].collapsed},createBookmarks:function(a){a=this.getRanges().createBookmarks(a);this.isFake&&(a.isFake=1);return a},createBookmarks2:function(a){a=this.getRanges().createBookmarks2(a);this.isFake&&(a.isFake=1);return a},selectBookmarks:function(a){for(var b=[],c,e=0;e<
a.length;e++){var f=new CKEDITOR.dom.range(this.root);f.moveToBookmark(a[e]);b.push(f)}a.isFake&&(c=d(b)?b[0]._getTableElement():b[0].getEnclosedNode(),c&&c.type==CKEDITOR.NODE_ELEMENT||(CKEDITOR.warn("selection-not-fake"),a.isFake=0));a.isFake&&!d(b)?this.fake(c):this.selectRanges(b);return this},getCommonAncestor:function(){var a=this.getRanges();return a.length?a[0].startContainer.getCommonAncestor(a[a.length-1].endContainer):null},scrollIntoView:function(){this.getType()!=CKEDITOR.SELECTION_NONE&&
this.getRanges()[0].scrollIntoView()},removeAllRanges:function(){if(this.getType()!=CKEDITOR.SELECTION_NONE){var a=this.getNative();try{a&&a[n?"empty":"removeAllRanges"]()}catch(b){}this.reset()}}}})();"use strict";CKEDITOR.STYLE_BLOCK=1;CKEDITOR.STYLE_INLINE=2;CKEDITOR.STYLE_OBJECT=3;
(function(){function a(a,b){for(var c,d;(a=a.getParent())&&!a.equals(b);)if(a.getAttribute("data-nostyle"))c=a;else if(!d){var e=a.getAttribute("contentEditable");"false"==e?c=a:"true"==e&&(d=1)}return c}function d(a,b,c,d){return(a.getPosition(b)|d)==d&&(!c.childRule||c.childRule(a))}function b(c){var e=c.document;if(c.collapsed)e=H(this,e),c.insertNode(e),c.moveToPosition(e,CKEDITOR.POSITION_BEFORE_END);else{var f=this.element,h=this._.definition,l,k=h.ignoreReadonly,m=k||h.includeReadonly;null==
m&&(m=c.root.getCustomData("cke_includeReadonly"));var p=CKEDITOR.dtd[f];p||(l=!0,p=CKEDITOR.dtd.span);c.enlarge(CKEDITOR.ENLARGE_INLINE,1);c.trim();var n=c.createBookmark(),q=n.startNode,r=n.endNode,w=q,z;if(!k){var y=c.getCommonAncestor(),k=a(q,y),y=a(r,y);k&&(w=k.getNextSourceNode(!0));y&&(r=y)}for(w.getPosition(r)==CKEDITOR.POSITION_FOLLOWING&&(w=0);w;){k=!1;if(w.equals(r))w=null,k=!0;else{var u=w.type==CKEDITOR.NODE_ELEMENT?w.getName():null,y=u&&"false"==w.getAttribute("contentEditable"),x=u&&
-1!==CKEDITOR.tools.array.indexOf(CKEDITOR.style.unstylableElements,u),x=u&&(w.getAttribute("data-nostyle")||x);if(u&&w.data("cke-bookmark")||w.type===CKEDITOR.NODE_COMMENT){w=w.getNextSourceNode(!0);continue}if(y&&m&&CKEDITOR.dtd.$block[u])for(var A=w,E=g(A),F=void 0,I=E.length,K=0,A=I&&new CKEDITOR.dom.range(A.getDocument());K<I;++K){var F=E[K],M=CKEDITOR.filter.instances[F.data("cke-filter")];if(M?M.check(this):1)A.selectNodeContents(F),b.call(this,A)}E=u?!p[u]||x?0:y&&!m?0:d(w,r,h,S):1;if(E)if(F=
w.getParent(),E=h,I=f,K=l,!F||!(F.getDtd()||CKEDITOR.dtd.span)[I]&&!K||E.parentRule&&!E.parentRule(F))k=!0;else{if(z||u&&CKEDITOR.dtd.$removeEmpty[u]&&(w.getPosition(r)|S)!=S||(z=c.clone(),z.setStartBefore(w)),u=w.type,u==CKEDITOR.NODE_TEXT||y||u==CKEDITOR.NODE_ELEMENT&&!w.getChildCount()){for(var u=w,N;(k=!u.getNext(D))&&(N=u.getParent(),p[N.getName()])&&d(N,q,h,T);)u=N;z.setEndAfter(u)}}else k=!0;w=w.getNextSourceNode(x||y)}if(k&&z&&!z.collapsed){for(var k=H(this,e),y=k.hasAttributes(),x=z.getCommonAncestor(),
u={},E={},F={},I={},X,W,Y;k&&x;){if(x.getName()==f){for(X in h.attributes)!I[X]&&(Y=x.getAttribute(W))&&(k.getAttribute(X)==Y?E[X]=1:I[X]=1);for(W in h.styles)!F[W]&&(Y=x.getStyle(W))&&(k.getStyle(W)==Y?u[W]=1:F[W]=1)}x=x.getParent()}for(X in E)k.removeAttribute(X);for(W in u)k.removeStyle(W);y&&!k.hasAttributes()&&(k=null);k?(z.extractContents().appendTo(k),z.insertNode(k),G.call(this,k),k.mergeSiblings(),CKEDITOR.env.ie||k.$.normalize()):(k=new CKEDITOR.dom.element("span"),z.extractContents().appendTo(k),
z.insertNode(k),G.call(this,k),k.remove(!0));z=null}}c.moveToBookmark(n);c.shrink(CKEDITOR.SHRINK_TEXT);c.shrink(CKEDITOR.NODE_ELEMENT,!0)}}function c(a){function b(){for(var a=new CKEDITOR.dom.elementPath(d.getParent()),c=new CKEDITOR.dom.elementPath(m.getParent()),e=null,f=null,g=0;g<a.elements.length;g++){var h=a.elements[g];if(h==a.block||h==a.blockLimit)break;p.checkElementRemovable(h,!0)&&(e=h)}for(g=0;g<c.elements.length;g++){h=c.elements[g];if(h==c.block||h==c.blockLimit)break;p.checkElementRemovable(h,
!0)&&(f=h)}f&&m.breakParent(f);e&&d.breakParent(e)}a.enlarge(CKEDITOR.ENLARGE_INLINE,1);var c=a.createBookmark(),d=c.startNode,e=this._.definition.alwaysRemoveElement;if(a.collapsed){for(var f=new CKEDITOR.dom.elementPath(d.getParent(),a.root),g,h=0,k;h<f.elements.length&&(k=f.elements[h])&&k!=f.block&&k!=f.blockLimit;h++)if(this.checkElementRemovable(k)){var l;!e&&a.collapsed&&(a.checkBoundaryOfElement(k,CKEDITOR.END)||(l=a.checkBoundaryOfElement(k,CKEDITOR.START)))?(g=k,g.match=l?"start":"end"):
(k.mergeSiblings(),k.is(this.element)?y.call(this,k):q(k,K(this)[k.getName()]))}if(g){e=d;for(h=0;;h++){k=f.elements[h];if(k.equals(g))break;else if(k.match)continue;else k=k.clone();k.append(e);e=k}e["start"==g.match?"insertBefore":"insertAfter"](g)}}else{var m=c.endNode,p=this;b();for(f=d;!f.equals(m);)g=f.getNextSourceNode(),f.type==CKEDITOR.NODE_ELEMENT&&this.checkElementRemovable(f)&&(f.getName()==this.element?y.call(this,f):q(f,K(this)[f.getName()]),g.type==CKEDITOR.NODE_ELEMENT&&g.contains(d)&&
(b(),g=d.getNext())),f=g}a.moveToBookmark(c);a.shrink(CKEDITOR.NODE_ELEMENT,!0)}function g(a){var b=[];a.forEach(function(a){if("true"==a.getAttribute("contenteditable"))return b.push(a),!1},CKEDITOR.NODE_ELEMENT,!0);return b}function f(a){var b=a.getEnclosedNode()||a.getCommonAncestor(!1,!0);(a=(new CKEDITOR.dom.elementPath(b,a.root)).contains(this.element,1))&&!a.isReadOnly()&&x(a,this)}function l(a){var b=a.getCommonAncestor(!0,!0);if(a=(new CKEDITOR.dom.elementPath(b,a.root)).contains(this.element,
1)){var b=this._.definition,c=b.attributes;if(c)for(var d in c)a.removeAttribute(d,c[d]);if(b.styles)for(var e in b.styles)b.styles.hasOwnProperty(e)&&a.removeStyle(e)}}function h(a){var b=a.createBookmark(!0),c=a.createIterator();c.enforceRealBlocks=!0;this._.enterMode&&(c.enlargeBr=this._.enterMode!=CKEDITOR.ENTER_BR);for(var d,e=a.document,f;d=c.getNextParagraph();)!d.isReadOnly()&&(c.activeFilter?c.activeFilter.check(this):1)&&(f=H(this,e,d),p(d,f));a.moveToBookmark(b)}function k(a){var b=a.createBookmark(1),
c=a.createIterator();c.enforceRealBlocks=!0;c.enlargeBr=this._.enterMode!=CKEDITOR.ENTER_BR;for(var d,e;d=c.getNextParagraph();)this.checkElementRemovable(d)&&(d.is("pre")?((e=this._.enterMode==CKEDITOR.ENTER_BR?null:a.document.createElement(this._.enterMode==CKEDITOR.ENTER_P?"p":"div"))&&d.copyAttributes(e),p(d,e)):y.call(this,d));a.moveToBookmark(b)}function p(a,b){var c=!b;c&&(b=a.getDocument().createElement("div"),a.copyAttributes(b));var d=b&&b.is("pre"),f=a.is("pre"),g=!d&&f;if(d&&!f){f=b;(g=
a.getBogus())&&g.remove();g=a.getHtml();g=z(g,/(?:^[ \t\n\r]+)|(?:[ \t\n\r]+$)/g,"");g=g.replace(/[ \t\r\n]*(<br[^>]*>)[ \t\r\n]*/gi,"$1");g=g.replace(/([ \t\n\r]+|&nbsp;)/g," ");g=g.replace(/<br\b[^>]*>/gi,"\n");if(CKEDITOR.env.ie){var h=a.getDocument().createElement("div");h.append(f);f.$.outerHTML="\x3cpre\x3e"+g+"\x3c/pre\x3e";f.copyAttributes(h.getFirst());f=h.getFirst().remove()}else f.setHtml(g);b=f}else g?b=w(c?[a.getHtml()]:e(a),b):a.moveChildren(b);b.replace(a);if(d){var c=b,k;(k=c.getPrevious(u))&&
k.type==CKEDITOR.NODE_ELEMENT&&k.is("pre")&&(d=z(k.getHtml(),/\n$/,"")+"\n\n"+z(c.getHtml(),/^\n/,""),CKEDITOR.env.ie?c.$.outerHTML="\x3cpre\x3e"+d+"\x3c/pre\x3e":c.setHtml(d),k.remove())}else c&&n(b)}function e(a){var b=[];z(a.getOuterHtml(),/(\S\s*)\n(?:\s|(<span[^>]+data-cke-bookmark.*?\/span>))*\n(?!$)/gi,function(a,b,c){return b+"\x3c/pre\x3e"+c+"\x3cpre\x3e"}).replace(/<pre\b.*?>([\s\S]*?)<\/pre>/gi,function(a,c){b.push(c)});return b}function z(a,b,c){var d="",e="";a=a.replace(/(^<span[^>]+data-cke-bookmark.*?\/span>)|(<span[^>]+data-cke-bookmark.*?\/span>$)/gi,
function(a,b,c){b&&(d=b);c&&(e=c);return""});return d+a.replace(b,c)+e}function w(a,b){var c;1<a.length&&(c=new CKEDITOR.dom.documentFragment(b.getDocument()));for(var d=0;d<a.length;d++){var e=a[d],e=e.replace(/(\r\n|\r)/g,"\n"),e=z(e,/^[ \t]*\n/,""),e=z(e,/\n$/,""),e=z(e,/^[ \t]+|[ \t]+$/g,function(a,b){return 1==a.length?"\x26nbsp;":b?" "+CKEDITOR.tools.repeat("\x26nbsp;",a.length-1):CKEDITOR.tools.repeat("\x26nbsp;",a.length-1)+" "}),e=e.replace(/\n/g,"\x3cbr\x3e"),e=e.replace(/[ \t]{2,}/g,function(a){return CKEDITOR.tools.repeat("\x26nbsp;",
a.length-1)+" "});if(c){var f=b.clone();f.setHtml(e);c.append(f)}else b.setHtml(e)}return c||b}function y(a,b){var c=this._.definition,d=c.attributes,c=c.styles,e=K(this)[a.getName()],f=CKEDITOR.tools.isEmpty(d)&&CKEDITOR.tools.isEmpty(c),g;for(g in d)if("class"!=g&&!this._.definition.fullMatch||a.getAttribute(g)==m(g,d[g]))b&&"data-"==g.slice(0,5)||(f=a.hasAttribute(g),a.removeAttribute(g));for(var h in c)this._.definition.fullMatch&&a.getStyle(h)!=m(h,c[h],!0)||(f=f||!!a.getStyle(h),a.removeStyle(h));
q(a,e,A[a.getName()]);f&&(this._.definition.alwaysRemoveElement?n(a,1):!CKEDITOR.dtd.$block[a.getName()]||this._.enterMode==CKEDITOR.ENTER_BR&&!a.hasAttributes()?n(a):a.renameNode(this._.enterMode==CKEDITOR.ENTER_P?"p":"div"))}function G(a){for(var b=K(this),c=a.getElementsByTag(this.element),d,e=c.count();0<=--e;)d=c.getItem(e),d.isReadOnly()||y.call(this,d,!0);for(var f in b)if(f!=this.element)for(c=a.getElementsByTag(f),e=c.count()-1;0<=e;e--)d=c.getItem(e),d.isReadOnly()||q(d,b[f])}function q(a,
b,c){if(b=b&&b.attributes)for(var d=0;d<b.length;d++){var e=b[d][0],f;if(f=a.getAttribute(e)){var g=b[d][1];(null===g||g.test&&g.test(f)||"string"==typeof g&&f==g)&&a.removeAttribute(e)}}c||n(a)}function n(a,b){if(!a.hasAttributes()||b)if(CKEDITOR.dtd.$block[a.getName()]){var c=a.getPrevious(u),d=a.getNext(u);!c||c.type!=CKEDITOR.NODE_TEXT&&c.isBlockBoundary({br:1})||a.append("br",1);!d||d.type!=CKEDITOR.NODE_TEXT&&d.isBlockBoundary({br:1})||a.append("br");a.remove(!0)}else c=a.getFirst(),d=a.getLast(),
a.remove(!0),c&&(c.type==CKEDITOR.NODE_ELEMENT&&c.mergeSiblings(),d&&!c.equals(d)&&d.type==CKEDITOR.NODE_ELEMENT&&d.mergeSiblings())}function H(a,b,c){var d;d=a.element;"*"==d&&(d="span");d=new CKEDITOR.dom.element(d,b);c&&c.copyAttributes(d);d=x(d,a);b.getCustomData("doc_processing_style")&&d.hasAttribute("id")?d.removeAttribute("id"):b.setCustomData("doc_processing_style",1);return d}function x(a,b){var c=b._.definition,d=c.attributes,c=CKEDITOR.style.getStyleText(c);if(d)for(var e in d)a.setAttribute(e,
d[e]);c&&a.setAttribute("style",c);a.getDocument().removeCustomData("doc_processing_style");return a}function I(a,b){for(var c in a)a[c]=a[c].replace(E,function(a,c){return b[c]})}function K(a){if(a._.overrides)return a._.overrides;var b=a._.overrides={},c=a._.definition.overrides;if(c){CKEDITOR.tools.isArray(c)||(c=[c]);for(var d=0;d<c.length;d++){var e=c[d],f,g;"string"==typeof e?f=e.toLowerCase():(f=e.element?e.element.toLowerCase():a.element,g=e.attributes);e=b[f]||(b[f]={});if(g){var e=e.attributes=
e.attributes||[],h;for(h in g)e.push([h.toLowerCase(),g[h]])}}}return b}function m(a,b,c){var d=new CKEDITOR.dom.element("span");d[c?"setStyle":"setAttribute"](a,b);return d[c?"getStyle":"getAttribute"](a)}function F(a,b){function c(a,b){return"font-family"==b.toLowerCase()?a.replace(/["']/g,""):a}"string"==typeof a&&(a=CKEDITOR.tools.parseCssText(a));"string"==typeof b&&(b=CKEDITOR.tools.parseCssText(b,!0));for(var d in a)if(!(d in b)||c(b[d],d)!=c(a[d],d)&&"inherit"!=a[d]&&"inherit"!=b[d])return!1;
return!0}function M(a,b,c){var d=a.getRanges();b=b?this.removeFromRange:this.applyToRange;for(var e,f=d.createIterator();e=f.getNextRange();)b.call(this,e,c);a.selectRanges(d)}var A={address:1,div:1,h1:1,h2:1,h3:1,h4:1,h5:1,h6:1,p:1,pre:1,section:1,header:1,footer:1,nav:1,article:1,aside:1,figure:1,dialog:1,hgroup:1,time:1,meter:1,menu:1,command:1,keygen:1,output:1,progress:1,details:1,datagrid:1,datalist:1},N={a:1,blockquote:1,embed:1,hr:1,img:1,li:1,object:1,ol:1,table:1,td:1,tr:1,th:1,ul:1,dl:1,
dt:1,dd:1,form:1,audio:1,video:1},r=/\s*(?:;\s*|$)/,E=/#\((.+?)\)/g,D=CKEDITOR.dom.walker.bookmark(0,1),u=CKEDITOR.dom.walker.whitespaces(1);CKEDITOR.style=function(a,b){if("string"==typeof a.type)return new CKEDITOR.style.customHandlers[a.type](a);var c=a.attributes;c&&c.style&&(a.styles=CKEDITOR.tools.extend({},a.styles,CKEDITOR.tools.parseCssText(c.style)),delete c.style);b&&(a=CKEDITOR.tools.clone(a),I(a.attributes,b),I(a.styles,b));c=this.element=a.element?"string"==typeof a.element?a.element.toLowerCase():
a.element:"*";this.type=a.type||(A[c]?CKEDITOR.STYLE_BLOCK:N[c]?CKEDITOR.STYLE_OBJECT:CKEDITOR.STYLE_INLINE);"object"==typeof this.element&&(this.type=CKEDITOR.STYLE_OBJECT);this._={definition:a}};CKEDITOR.style.prototype={apply:function(a){if(a instanceof CKEDITOR.dom.document)return M.call(this,a.getSelection());if(this.checkApplicable(a.elementPath(),a)){var b=this._.enterMode;b||(this._.enterMode=a.activeEnterMode);M.call(this,a.getSelection(),0,a);this._.enterMode=b}},remove:function(a){if(a instanceof
CKEDITOR.dom.document)return M.call(this,a.getSelection(),1);if(this.checkApplicable(a.elementPath(),a)){var b=this._.enterMode;b||(this._.enterMode=a.activeEnterMode);M.call(this,a.getSelection(),1,a);this._.enterMode=b}},applyToRange:function(a){this.applyToRange=this.type==CKEDITOR.STYLE_INLINE?b:this.type==CKEDITOR.STYLE_BLOCK?h:this.type==CKEDITOR.STYLE_OBJECT?f:null;return this.applyToRange(a)},removeFromRange:function(a){this.removeFromRange=this.type==CKEDITOR.STYLE_INLINE?c:this.type==CKEDITOR.STYLE_BLOCK?
k:this.type==CKEDITOR.STYLE_OBJECT?l:null;return this.removeFromRange(a)},applyToObject:function(a){x(a,this)},checkActive:function(a,b){switch(this.type){case CKEDITOR.STYLE_BLOCK:return this.checkElementRemovable(a.block||a.blockLimit,!0,b);case CKEDITOR.STYLE_OBJECT:case CKEDITOR.STYLE_INLINE:for(var c=a.elements,d=0,e;d<c.length;d++)if(e=c[d],this.type!=CKEDITOR.STYLE_INLINE||e!=a.block&&e!=a.blockLimit){if(this.type==CKEDITOR.STYLE_OBJECT){var f=e.getName();if(!("string"==typeof this.element?
f==this.element:f in this.element))continue}if(this.checkElementRemovable(e,!0,b))return!0}}return!1},checkApplicable:function(a,b,c){b&&b instanceof CKEDITOR.filter&&(c=b);if(c&&!c.check(this))return!1;switch(this.type){case CKEDITOR.STYLE_OBJECT:return!!a.contains(this.element);case CKEDITOR.STYLE_BLOCK:return!!a.blockLimit.getDtd()[this.element]}return!0},checkElementMatch:function(a,b){var c=this._.definition;if(!a||!c.ignoreReadonly&&a.isReadOnly())return!1;var d=a.getName();if("string"==typeof this.element?
d==this.element:d in this.element){if(!b&&!a.hasAttributes())return!0;if(d=c._AC)c=d;else{var d={},e=0,f=c.attributes;if(f)for(var g in f)e++,d[g]=f[g];if(g=CKEDITOR.style.getStyleText(c))d.style||e++,d.style=g;d._length=e;c=c._AC=d}if(c._length){for(var h in c)if("_length"!=h)if(d=a.getAttribute(h)||"","style"==h?F(c[h],d):c[h]==d){if(!b)return!0}else if(b)return!1;if(b)return!0}else return!0}return!1},checkElementRemovable:function(a,b,c){if(this.checkElementMatch(a,b,c))return!0;if(b=K(this)[a.getName()]){var d;
if(!(b=b.attributes))return!0;for(c=0;c<b.length;c++)if(d=b[c][0],d=a.getAttribute(d)){var e=b[c][1];if(null===e)return!0;if("string"==typeof e){if(d==e)return!0}else if(e.test(d))return!0}}return!1},buildPreview:function(a){var b=this._.definition,c=[],d=b.element;"bdo"==d&&(d="span");var c=["\x3c",d],e=b.attributes;if(e)for(var f in e)c.push(" ",f,'\x3d"',e[f],'"');(e=CKEDITOR.style.getStyleText(b))&&c.push(' style\x3d"',e,'"');c.push("\x3e",a||b.name,"\x3c/",d,"\x3e");return c.join("")},getDefinition:function(){return this._.definition}};
CKEDITOR.style.getStyleText=function(a){var b=a._ST;if(b)return b;var b=a.styles,c=a.attributes&&a.attributes.style||"",d="";c.length&&(c=c.replace(r,";"));for(var e in b){var f=b[e],g=(e+":"+f).replace(r,";");"inherit"==f?d+=g:c+=g}c.length&&(c=CKEDITOR.tools.normalizeCssText(c,!0));return a._ST=c+d};CKEDITOR.style.customHandlers={};CKEDITOR.style.unstylableElements=[];CKEDITOR.style.addCustomHandler=function(a){var b=function(a){this._={definition:a};this.setup&&this.setup(a)};b.prototype=CKEDITOR.tools.extend(CKEDITOR.tools.prototypedCopy(CKEDITOR.style.prototype),
{assignedTo:CKEDITOR.STYLE_OBJECT},a,!0);return this.customHandlers[a.type]=b};var S=CKEDITOR.POSITION_PRECEDING|CKEDITOR.POSITION_IDENTICAL|CKEDITOR.POSITION_IS_CONTAINED,T=CKEDITOR.POSITION_FOLLOWING|CKEDITOR.POSITION_IDENTICAL|CKEDITOR.POSITION_IS_CONTAINED})();CKEDITOR.styleCommand=function(a,d){this.requiredContent=this.allowedContent=this.style=a;CKEDITOR.tools.extend(this,d,!0)};
CKEDITOR.styleCommand.prototype.exec=function(a){a.focus();this.state==CKEDITOR.TRISTATE_OFF?a.applyStyle(this.style):this.state==CKEDITOR.TRISTATE_ON&&a.removeStyle(this.style)};CKEDITOR.stylesSet=new CKEDITOR.resourceManager("","stylesSet");CKEDITOR.addStylesSet=CKEDITOR.tools.bind(CKEDITOR.stylesSet.add,CKEDITOR.stylesSet);CKEDITOR.loadStylesSet=function(a,d,b){CKEDITOR.stylesSet.addExternal(a,d,"");CKEDITOR.stylesSet.load(a,b)};
CKEDITOR.tools.extend(CKEDITOR.editor.prototype,{attachStyleStateChange:function(a,d){var b=this._.styleStateChangeCallbacks;b||(b=this._.styleStateChangeCallbacks=[],this.on("selectionChange",function(a){for(var d=0;d<b.length;d++){var f=b[d],l=f.style.checkActive(a.data.path,this)?CKEDITOR.TRISTATE_ON:CKEDITOR.TRISTATE_OFF;f.fn.call(this,l)}}));b.push({style:a,fn:d})},applyStyle:function(a){a.apply(this)},removeStyle:function(a){a.remove(this)},getStylesSet:function(a){if(this._.stylesDefinitions)a(this._.stylesDefinitions);
else{var d=this,b=d.config.stylesCombo_stylesSet||d.config.stylesSet;if(!1===b)a(null);else if(b instanceof Array)d._.stylesDefinitions=b,a(b);else{b||(b="default");var b=b.split(":"),c=b[0];CKEDITOR.stylesSet.addExternal(c,b[1]?b.slice(1).join(":"):CKEDITOR.getUrl("styles.js"),"");CKEDITOR.stylesSet.load(c,function(b){d._.stylesDefinitions=b[c];a(d._.stylesDefinitions)})}}}});
(function(){if(window.Promise)CKEDITOR.tools.promise=Promise;else{var a=CKEDITOR.getUrl("vendor/promise.js");if("function"===typeof window.define&&window.define.amd&&"function"===typeof window.require)return window.require([a],function(a){CKEDITOR.tools.promise=a});CKEDITOR.scriptLoader.load(a,function(d){if(!d)return CKEDITOR.error("no-vendor-lib",{path:a});if("undefined"!==typeof window.ES6Promise)return CKEDITOR.tools.promise=ES6Promise})}})();
(function(){function a(a,g,f){a.once("selectionCheck",function(a){if(!d){var c=a.data.getRanges()[0];f.equals(c)?a.cancel():g.equals(c)&&(b=!0)}},null,null,-1)}var d=!0,b=!1;CKEDITOR.dom.selection.setupEditorOptimization=function(a){a.on("selectionCheck",function(a){a.data&&!b&&a.data.optimizeInElementEnds();b=!1});a.on("contentDom",function(){var b=a.editable();b&&(b.attachListener(b,"keydown",function(a){this._.shiftPressed=a.data.$.shiftKey},this),b.attachListener(b,"keyup",function(a){this._.shiftPressed=
a.data.$.shiftKey},this))})};CKEDITOR.dom.selection.prototype.optimizeInElementEnds=function(){var b=this.getRanges()[0],g=this.root.editor,f;if(this.root.editor._.shiftPressed||this.isFake||b.isCollapsed||b.startContainer.equals(b.endContainer))f=!1;else if(0===b.endOffset)f=!0;else{f=b.startContainer.type===CKEDITOR.NODE_TEXT;var l=b.endContainer.type===CKEDITOR.NODE_TEXT,h=f?b.startContainer.getLength():b.startContainer.getChildCount();f=b.startOffset===h||f^l}f&&(f=b.clone(),b.shrink(CKEDITOR.SHRINK_TEXT,
!1,{skipBogus:!CKEDITOR.env.webkit}),d=!1,a(g,b,f),b.select(),d=!0)}})();
(function(){function a(a,c){b(a)?a=Math.round(c*(parseFloat(a)/100)):"string"===typeof a&&a.match(/^\d+$/gm)&&(a=parseInt(a,10));return a}function d(a,c){b(a)?a=c*(parseFloat(a)/100):"string"===typeof a&&a.match(/^\d?\.\d+/gm)&&(a=parseFloat(a));return a}function b(a){return"string"===typeof a&&a.match(/^((\d*\.\d+)|(\d+))%{1}$/gm)}function c(a,b,c){return!isNaN(a)&&a>=b&&a<=c}function g(a){a=a.toString(16);return 1==a.length?"0"+a:a}CKEDITOR.tools.color=CKEDITOR.tools.createClass({$:function(a,b){this._.initialColorCode=
a;this._.defaultValue=b;this._.parseInput(a)},proto:{getHex:function(){if(!this._.isValidColor)return this._.defaultValue;var a=this._.blendAlphaColor(this._.red,this._.green,this._.blue,this._.alpha);return this._.formatHexString(a[0],a[1],a[2])},getHexWithAlpha:function(){if(!this._.isValidColor)return this._.defaultValue;var a=Math.round(this._.alpha*CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE);return this._.formatHexString(this._.red,this._.green,this._.blue,a)},getRgb:function(){if(!this._.isValidColor)return this._.defaultValue;
var a=this._.blendAlphaColor(this._.red,this._.green,this._.blue,this._.alpha);return this._.formatRgbString("rgb",a[0],a[1],a[2])},getRgba:function(){return this._.isValidColor?this._.formatRgbString("rgba",this._.red,this._.green,this._.blue,this._.alpha):this._.defaultValue},getHsl:function(){if(!this._.isValidColor)return this._.defaultValue;var a=this._.blendAlphaColor(this._.red,this._.green,this._.blue,this._.alpha),a=this._.rgbToHsl(a[0],a[1],a[2]);return this._.formatHslString("hsl",a[0],
a[1],a[2])},getHsla:function(){if(!this._.isValidColor)return this._.defaultValue;var a=this._.rgbToHsl(this._.red,this._.green,this._.blue);return this._.formatHslString("hsla",a[0],a[1],a[2],this._.alpha)},getInitialValue:function(){return this._.initialColorCode}},_:{initialColorCode:"",isValidColor:!0,red:0,green:0,blue:0,alpha:1,blendAlphaColor:function(a,b,c,d){return CKEDITOR.tools.array.map([a,b,c],function(a){return Math.round(CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE-d*(CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE-
a))})},formatHexString:function(a,b,c,d){a="#"+g(a)+g(b)+g(c);void 0!==d&&(a+=g(d));return a.toUpperCase()},formatRgbString:function(a,b,c,d,g){b=[b,c,d];void 0!==g&&b.push(g);return a+"("+b.join(",")+")"},formatHslString:function(a,b,c,d,g){return a+"("+b+","+c+"%,"+d+"%"+(void 0!==g?","+g:"")+")"},parseInput:function(a){if("string"!==typeof a)this._.isValidColor=!1;else{a=CKEDITOR.tools.trim(a);var b=this._.matchStringToNamedColor(a);b&&(a=b);var b=this._.extractColorChannelsFromHex(a),c=this._.extractColorChannelsFromRgba(a);
a=this._.extractColorChannelsFromHsla(a);(a=b||c||a)?(this._.red=a[0],this._.green=a[1],this._.blue=a[2],this._.alpha=a[3]):this._.isValidColor=!1}},matchStringToNamedColor:function(a){return CKEDITOR.tools.color.namedColors[a.toLowerCase()]||null},extractColorChannelsFromHex:function(a){a.match(CKEDITOR.tools.color.hex3CharsRegExp)&&(a=this._.hex3ToHex6(a));if(!a.match(CKEDITOR.tools.color.hex6CharsRegExp)&&!a.match(CKEDITOR.tools.color.hex8CharsRegExp))return null;a=a.split("");var b=1;a[7]&&a[8]&&
(b=parseInt(a[7]+a[8],16),b/=CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE,b=Number(b.toFixed(1)));return[parseInt(a[1]+a[2],16),parseInt(a[3]+a[4],16),parseInt(a[5]+a[6],16),b]},extractColorChannelsFromRgba:function(b){var c=this._.extractColorChannelsByPattern(b,CKEDITOR.tools.color.rgbRegExp);if(!c||(b=0===b.indexOf("rgba"))&&4!==c.length||!b&&3!==c.length)return null;var g=a(c[0],CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE),k=a(c[1],CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE),p=a(c[2],CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE),
e=1;b&&(e=d(c[3],CKEDITOR.tools.color.MAX_ALPHA_CHANNEL_VALUE));return this._.areColorChannelsValid(g,k,p,e)?[g,k,p,e]:null},extractColorChannelsFromHsla:function(b){var c=this._.extractColorChannelsByPattern(b,CKEDITOR.tools.color.hslRegExp);if(!c||(b=0===b.indexOf("hsla"))&&4!==c.length||!b&&3!==c.length)return null;var g=a(c[0],CKEDITOR.tools.color.MAX_HUE_CHANNEL_VALUE),k=d(c[1],CKEDITOR.tools.color.MAX_SATURATION_LIGHTNESS_CHANNEL_VALUE),p=d(c[2],CKEDITOR.tools.color.MAX_SATURATION_LIGHTNESS_CHANNEL_VALUE),
e=1,g=this._.hslToRgb(g,k,p);b&&(e=d(c[3],CKEDITOR.tools.color.MAX_ALPHA_CHANNEL_VALUE));g.push(e);return this._.areColorChannelsValid(g[0],g[1],g[2],g[3])?g:null},hex3ToHex6:function(a){a=a.split("");return"#"+a[1]+a[1]+a[2]+a[2]+a[3]+a[3]},extractColorChannelsByPattern:function(a,b){var c=a.match(b);if(!c)return null;c=c[2].split(",");return c=CKEDITOR.tools.array.map(c,function(a){return CKEDITOR.tools.trim(a)})},areColorChannelsValid:function(a,b,d,g){return c(a,0,CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE)&&
c(b,0,CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE)&&c(d,0,CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE)&&c(g,0,CKEDITOR.tools.color.MAX_ALPHA_CHANNEL_VALUE)},hslToRgb:function(a,b,c){var d=function(d){var e=(d+a/30)%12;d=b*Math.min(c,1-c);e=Math.min(e-3,9-e,1);e=Math.max(-1,e);return Math.round((c-d*e)*CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE)};return[d(0),d(8),d(4)]},rgbToHsl:function(a,b,c){a/=CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE;b/=CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE;var d=c/CKEDITOR.tools.color.MAX_RGB_CHANNEL_VALUE,
g=Math.max(a,b,d),e=Math.min(a,b,d);c=g-e;var z=0;switch(g){case a:z=(b-d)/c%6;break;case b:z=(d-a)/c+2;break;case d:z=(a-b)/c+4}a=0===c?0:60*z;b=(g+e)/2;g=0;1!==b&&0!==b&&(g=c/(1-Math.abs(2*b-1)));a=Math.round(a);g=100*Math.round(g);return[a,g,100*b]}},statics:{MAX_RGB_CHANNEL_VALUE:255,MAX_ALPHA_CHANNEL_VALUE:1,MAX_HUE_CHANNEL_VALUE:360,MAX_SATURATION_LIGHTNESS_CHANNEL_VALUE:1,hex3CharsRegExp:/#([0-9a-f]{3}$)/gim,hex6CharsRegExp:/#([0-9a-f]{6}$)/gim,hex8CharsRegExp:/#([0-9a-f]{8}$)/gim,rgbRegExp:/(rgb[a]?)\(([.,\d\s%]*)\)/i,
hslRegExp:/(hsl[a]?)\(([.,\d\s%]*)\)/i,namedColors:{aliceblue:"#F0F8FF",antiquewhite:"#FAEBD7",aqua:"#00FFFF",aquamarine:"#7FFFD4",azure:"#F0FFFF",beige:"#F5F5DC",bisque:"#FFE4C4",black:"#000000",blanchedalmond:"#FFEBCD",blue:"#0000FF",blueviolet:"#8A2BE2",brown:"#A52A2A",burlywood:"#DEB887",cadetblue:"#5F9EA0",chartreuse:"#7FFF00",chocolate:"#D2691E",coral:"#FF7F50",cornflowerblue:"#6495ED",cornsilk:"#FFF8DC",crimson:"#DC143C",cyan:"#00FFFF",darkblue:"#00008B",darkcyan:"#008B8B",darkgoldenrod:"#B8860B",
darkgray:"#A9A9A9",darkgreen:"#006400",darkgrey:"#A9A9A9",darkkhaki:"#BDB76B",darkmagenta:"#8B008B",darkolivegreen:"#556B2F",darkorange:"#FF8C00",darkorchid:"#9932CC",darkred:"#8B0000",darksalmon:"#E9967A",darkseagreen:"#8FBC8F",darkslateblue:"#483D8B",darkslategray:"#2F4F4F",darkslategrey:"#2F4F4F",darkturquoise:"#00CED1",darkviolet:"#9400D3",deeppink:"#FF1493",deepskyblue:"#00BFFF",dimgray:"#696969",dimgrey:"#696969",dodgerblue:"#1E90FF",firebrick:"#B22222",floralwhite:"#FFFAF0",forestgreen:"#228B22",
fuchsia:"#FF00FF",gainsboro:"#DCDCDC",ghostwhite:"#F8F8FF",gold:"#FFD700",goldenrod:"#DAA520",gray:"#808080",green:"#008000",greenyellow:"#ADFF2F",grey:"#808080",honeydew:"#F0FFF0",hotpink:"#FF69B4",indianred:"#CD5C5C",indigo:"#4B0082",ivory:"#FFFFF0",khaki:"#F0E68C",lavender:"#E6E6FA",lavenderblush:"#FFF0F5",lawngreen:"#7CFC00",lemonchiffon:"#FFFACD",lightblue:"#ADD8E6",lightcoral:"#F08080",lightcyan:"#E0FFFF",lightgoldenrodyellow:"#FAFAD2",lightgray:"#D3D3D3",lightgreen:"#90EE90",lightgrey:"#D3D3D3",
lightpink:"#FFB6C1",lightsalmon:"#FFA07A",lightseagreen:"#20B2AA",lightskyblue:"#87CEFA",lightslategray:"#778899",lightslategrey:"#778899",lightsteelblue:"#B0C4DE",lightyellow:"#FFFFE0",lime:"#00FF00",limegreen:"#32CD32",linen:"#FAF0E6",magenta:"#FF00FF",maroon:"#800000",mediumaquamarine:"#66CDAA",mediumblue:"#0000CD",mediumorchid:"#BA55D3",mediumpurple:"#9370DB",mediumseagreen:"#3CB371",mediumslateblue:"#7B68EE",mediumspringgreen:"#00FA9A",mediumturquoise:"#48D1CC",mediumvioletred:"#C71585",midnightblue:"#191970",
mintcream:"#F5FFFA",mistyrose:"#FFE4E1",moccasin:"#FFE4B5",navajowhite:"#FFDEAD",navy:"#000080",oldlace:"#FDF5E6",olive:"#808000",olivedrab:"#6B8E23",orange:"#FFA500",orangered:"#FF4500",orchid:"#DA70D6",palegoldenrod:"#EEE8AA",palegreen:"#98FB98",paleturquoise:"#AFEEEE",palevioletred:"#DB7093",papayawhip:"#FFEFD5",peachpuff:"#FFDAB9",peru:"#CD853F",pink:"#FFC0CB",plum:"#DDA0DD",powderblue:"#B0E0E6",purple:"#800080",rebeccapurple:"#663399",red:"#FF0000",rosybrown:"#BC8F8F",royalblue:"#4169E1",saddlebrown:"#8B4513",
salmon:"#FA8072",sandybrown:"#F4A460",seagreen:"#2E8B57",seashell:"#FFF5EE",sienna:"#A0522D",silver:"#C0C0C0",skyblue:"#87CEEB",slateblue:"#6A5ACD",slategray:"#708090",slategrey:"#708090",snow:"#FFFAFA",springgreen:"#00FF7F",steelblue:"#4682B4",tan:"#D2B48C",teal:"#008080",thistle:"#D8BFD8",tomato:"#FF6347",turquoise:"#40E0D0",violet:"#EE82EE",windowtext:"windowtext",wheat:"#F5DEB3",white:"#FFFFFF",whitesmoke:"#F5F5F5",yellow:"#FFFF00",yellowgreen:"#9ACD32"}}});CKEDITOR.tools.style.parse._colors=
CKEDITOR.tools.color.namedColors})();CKEDITOR.dom.comment=function(a,d){"string"==typeof a&&(a=(d?d.$:document).createComment(a));CKEDITOR.dom.domObject.call(this,a)};CKEDITOR.dom.comment.prototype=new CKEDITOR.dom.node;CKEDITOR.tools.extend(CKEDITOR.dom.comment.prototype,{type:CKEDITOR.NODE_COMMENT,getOuterHtml:function(){return"\x3c!--"+this.$.nodeValue+"--\x3e"}});"use strict";
(function(){var a={},d={},b;for(b in CKEDITOR.dtd.$blockLimit)b in CKEDITOR.dtd.$list||(a[b]=1);for(b in CKEDITOR.dtd.$block)b in CKEDITOR.dtd.$blockLimit||b in CKEDITOR.dtd.$empty||(d[b]=1);CKEDITOR.dom.elementPath=function(b,g){var f=null,l=null,h=[],k=b,p;g=g||b.getDocument().getBody();k||(k=g);do if(k.type==CKEDITOR.NODE_ELEMENT){h.push(k);if(!this.lastElement&&(this.lastElement=k,k.is(CKEDITOR.dtd.$object)||"false"==k.getAttribute("contenteditable")))continue;if(k.equals(g))break;if(!l&&(p=k.getName(),
"true"==k.getAttribute("contenteditable")?l=k:!f&&d[p]&&(f=k),a[p])){if(p=!f&&"div"==p){a:{p=k.getChildren();for(var e=0,z=p.count();e<z;e++){var w=p.getItem(e);if(w.type==CKEDITOR.NODE_ELEMENT&&CKEDITOR.dtd.$block[w.getName()]){p=!0;break a}}p=!1}p=!p}p?f=k:l=k}}while(k=k.getParent());l||(l=g);this.block=f;this.blockLimit=l;this.root=g;this.elements=h}})();
CKEDITOR.dom.elementPath.prototype={compare:function(a){var d=this.elements;a=a&&a.elements;if(!a||d.length!=a.length)return!1;for(var b=0;b<d.length;b++)if(!d[b].equals(a[b]))return!1;return!0},contains:function(a,d,b){var c=0,g;"string"==typeof a&&(g=function(b){return b.getName()==a});a instanceof CKEDITOR.dom.element?g=function(b){return b.equals(a)}:CKEDITOR.tools.isArray(a)?g=function(b){return-1<CKEDITOR.tools.indexOf(a,b.getName())}:"function"==typeof a?g=a:"object"==typeof a&&(g=function(b){return b.getName()in
a});var f=this.elements,l=f.length;d&&(b?c+=1:--l);b&&(f=Array.prototype.slice.call(f,0),f.reverse());for(;c<l;c++)if(g(f[c]))return f[c];return null},isContextFor:function(a){var d;return a in CKEDITOR.dtd.$block?(d=this.contains(CKEDITOR.dtd.$intermediate)||this.root.equals(this.block)&&this.block||this.blockLimit,!!d.getDtd()[a]):!0},direction:function(){return(this.block||this.blockLimit||this.root).getDirection(1)}};
CKEDITOR.dom.text=function(a,d){"string"==typeof a&&(a=(d?d.$:document).createTextNode(a));this.$=a};CKEDITOR.dom.text.prototype=new CKEDITOR.dom.node;
CKEDITOR.tools.extend(CKEDITOR.dom.text.prototype,{type:CKEDITOR.NODE_TEXT,getLength:function(){return this.$.nodeValue.length},getText:function(){return this.$.nodeValue},setText:function(a){this.$.nodeValue=a},isEmpty:function(a){var d=this.getText();a&&(d=CKEDITOR.tools.trim(d));return!d||d===CKEDITOR.dom.selection.FILLING_CHAR_SEQUENCE},split:function(a){var d=this.$.parentNode,b=d.childNodes.length,c=this.getLength(),g=this.getDocument(),f=new CKEDITOR.dom.text(this.$.splitText(a),g);d.childNodes.length==
b&&(a>=c?(f=g.createText(""),f.insertAfter(this)):(a=g.createText(""),a.insertAfter(f),a.remove()));return f},substring:function(a,d){return"number"!=typeof d?this.$.nodeValue.substr(a):this.$.nodeValue.substring(a,d)}});
(function(){function a(a,c,d){var f=a.serializable,l=c[d?"endContainer":"startContainer"],h=d?"endOffset":"startOffset",k=f?c.document.getById(a.startNode):a.startNode;a=f?c.document.getById(a.endNode):a.endNode;l.equals(k.getPrevious())?(c.startOffset=c.startOffset-l.getLength()-a.getPrevious().getLength(),l=a.getNext()):l.equals(a.getPrevious())&&(c.startOffset-=l.getLength(),l=a.getNext());l.equals(k.getParent())&&c[h]++;l.equals(a.getParent())&&c[h]++;c[d?"endContainer":"startContainer"]=l;return c}
CKEDITOR.dom.rangeList=function(a){if(a instanceof CKEDITOR.dom.rangeList)return a;a?a instanceof CKEDITOR.dom.range&&(a=[a]):a=[];return CKEDITOR.tools.extend(a,d)};var d={createIterator:function(){var a=this,c=CKEDITOR.dom.walker.bookmark(),d=[],f;return{getNextRange:function(l){f=void 0===f?0:f+1;var h=a[f];if(h&&1<a.length){if(!f)for(var k=a.length-1;0<=k;k--)d.unshift(a[k].createBookmark(!0));if(l)for(var p=0;a[f+p+1];){var e=h.document;l=0;k=e.getById(d[p].endNode);for(e=e.getById(d[p+1].startNode);;){k=
k.getNextSourceNode(!1);if(e.equals(k))l=1;else if(c(k)||k.type==CKEDITOR.NODE_ELEMENT&&k.isBlockBoundary())continue;break}if(!l)break;p++}for(h.moveToBookmark(d.shift());p--;)k=a[++f],k.moveToBookmark(d.shift()),h.setEnd(k.endContainer,k.endOffset)}return h}}},createBookmarks:function(b){for(var c=[],d,f=0;f<this.length;f++){c.push(d=this[f].createBookmark(b,!0));for(var l=f+1;l<this.length;l++)this[l]=a(d,this[l]),this[l]=a(d,this[l],!0)}return c},createBookmarks2:function(a){for(var c=[],d=0;d<
this.length;d++)c.push(this[d].createBookmark2(a));return c},moveToBookmarks:function(a){for(var c=0;c<this.length;c++)this[c].moveToBookmark(a[c])}}})();
(function(){function a(){return CKEDITOR.getUrl(CKEDITOR.skinName.split(",")[1]||"skins/"+CKEDITOR.skinName.split(",")[0]+"/")}function d(b){var c=CKEDITOR.skin["ua_"+b],d=CKEDITOR.env;if(c)for(var c=c.split(",").sort(function(a,b){return a>b?-1:1}),f=0,g;f<c.length;f++)if(g=c[f],d.ie&&(g.replace(/^ie/,"")==d.version||d.quirks&&"iequirks"==g)&&(g="ie"),d[g]){b+="_"+c[f];break}return CKEDITOR.getUrl(a()+b+".css")}function b(a,b){f[a]||(CKEDITOR.document.appendStyleSheet(d(a)),f[a]=1);b&&b()}function c(a){var b=
a.getById(l);b||(b=a.getHead().append("style"),b.setAttribute("id",l),b.setAttribute("type","text/css"));return b}function g(a,b,c){var d,f,g;if(CKEDITOR.env.webkit)for(b=b.split("}").slice(0,-1),f=0;f<b.length;f++)b[f]=b[f].split("{");for(var h=0;h<a.length;h++)if(CKEDITOR.env.webkit)for(f=0;f<b.length;f++){g=b[f][1];for(d=0;d<c.length;d++)g=g.replace(c[d][0],c[d][1]);a[h].$.sheet.addRule(b[f][0],g)}else{g=b;for(d=0;d<c.length;d++)g=g.replace(c[d][0],c[d][1]);CKEDITOR.env.ie&&11>CKEDITOR.env.version?
a[h].$.styleSheet.cssText+=g:a[h].$.innerHTML+=g}}var f={};CKEDITOR.skin={path:a,loadPart:function(c,d){CKEDITOR.skin.name!=CKEDITOR.skinName.split(",")[0]?CKEDITOR.scriptLoader.load(CKEDITOR.getUrl(a()+"skin.js"),function(){b(c,d)}):b(c,d)},getPath:function(a){return CKEDITOR.getUrl(d(a))},icons:{},addIcon:function(a,b,c,d){a=a.toLowerCase();this.icons[a]||(this.icons[a]={path:b,offset:c||0,bgsize:d||"16px"})},getIconStyle:function(a,b,c,d,f){var g;a&&(a=a.toLowerCase(),b&&(g=this.icons[a+"-rtl"]),
g||(g=this.icons[a]));a=c||g&&g.path||"";d=d||g&&g.offset;f=f||g&&g.bgsize||"16px";a&&(a=a.replace(/'/g,"\\'"));return a&&"background-image:url('"+CKEDITOR.getUrl(a)+"');background-position:0 "+d+"px;background-size:"+f+";"}};CKEDITOR.tools.extend(CKEDITOR.editor.prototype,{getUiColor:function(){return this.uiColor},setUiColor:function(a){var b=c(CKEDITOR.document);return(this.setUiColor=function(a){this.uiColor=a;var c=CKEDITOR.skin.chameleon,d="",f="";"function"==typeof c&&(d=c(this,"editor"),f=
c(this,"panel"));a=[[k,a]];g([b],d,a);g(h,f,a)}).call(this,a)}});var l="cke_ui_color",h=[],k=/\$color/g;CKEDITOR.on("instanceLoaded",function(a){if(!CKEDITOR.env.ie||!CKEDITOR.env.quirks){var b=a.editor;a=function(a){a=(a.data[0]||a.data).element.getElementsByTag("iframe").getItem(0).getFrameDocument();if(!a.getById("cke_ui_color")){var d=c(a);h.push(d);b.on("destroy",function(){h=CKEDITOR.tools.array.filter(h,function(a){return d!==a})});(a=b.getUiColor())&&g([d],CKEDITOR.skin.chameleon(b,"panel"),
[[k,a]])}};b.on("panelShow",a);b.on("menuShow",a);b.config.uiColor&&b.setUiColor(b.config.uiColor)}})})();
(function(){var a=CKEDITOR.dom.element.createFromHtml('\x3cdiv style\x3d"width:0;height:0;position:absolute;left:-10000px;border:1px solid;border-color:red blue"\x3e\x3c/div\x3e',CKEDITOR.document);a.appendTo(CKEDITOR.document.getHead());try{var d=a.getComputedStyle("border-top-color"),b=a.getComputedStyle("border-right-color");CKEDITOR.env.hc=!(!d||d!=b)}catch(c){CKEDITOR.env.hc=!1}a.remove();CKEDITOR.env.hc&&(CKEDITOR.env.cssClass+=" cke_hc");CKEDITOR.document.appendStyleText(".cke{visibility:hidden;}");
CKEDITOR.status="loaded";CKEDITOR.fireOnce("loaded");if(a=CKEDITOR._.pending)for(delete CKEDITOR._.pending,d=0;d<a.length;d++)CKEDITOR.editor.prototype.constructor.apply(a[d][0],a[d][1]),CKEDITOR.add(a[d][0])})();/*
 Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
*/
CKEDITOR.skin.name="moono-lisa";CKEDITOR.skin.ua_editor="ie,iequirks,ie8,gecko";CKEDITOR.skin.ua_dialog="ie,iequirks,ie8";
CKEDITOR.skin.chameleon=function(){var b=function(){return function(b,d){for(var a=b.match(/[^#]./g),e=0;3>e;e++){var f=e,c;c=parseInt(a[e],16);c=("0"+(0>d?0|c*(1+d):0|c+(255-c)*d).toString(16)).slice(-2);a[f]=c}return"#"+a.join("")}}(),f={editor:new CKEDITOR.template("{id}.cke_chrome [border-color:{defaultBorder};] {id} .cke_top [ background-color:{defaultBackground};border-bottom-color:{defaultBorder};] {id} .cke_bottom [background-color:{defaultBackground};border-top-color:{defaultBorder};] {id} .cke_resizer [border-right-color:{ckeResizer}] {id} .cke_dialog_title [background-color:{defaultBackground};border-bottom-color:{defaultBorder};] {id} .cke_dialog_footer [background-color:{defaultBackground};outline-color:{defaultBorder};] {id} .cke_dialog_tab [background-color:{dialogTab};border-color:{defaultBorder};] {id} .cke_dialog_tab:hover [background-color:{lightBackground};] {id} .cke_dialog_contents [border-top-color:{defaultBorder};] {id} .cke_dialog_tab_selected, {id} .cke_dialog_tab_selected:hover [background:{dialogTabSelected};border-bottom-color:{dialogTabSelectedBorder};] {id} .cke_dialog_body [background:{dialogBody};border-color:{defaultBorder};] {id} a.cke_button_off:hover,{id} a.cke_button_off:focus,{id} a.cke_button_off:active [background-color:{darkBackground};border-color:{toolbarElementsBorder};] {id} .cke_button_on [background-color:{ckeButtonOn};border-color:{toolbarElementsBorder};] {id} .cke_toolbar_separator,{id} .cke_toolgroup a.cke_button:last-child:after,{id} .cke_toolgroup a.cke_button.cke_button_disabled:hover:last-child:after [background-color: {toolbarElementsBorder};border-color: {toolbarElementsBorder};] {id} a.cke_combo_button:hover,{id} a.cke_combo_button:focus,{id} .cke_combo_on a.cke_combo_button [border-color:{toolbarElementsBorder};background-color:{darkBackground};] {id} .cke_combo:after [border-color:{toolbarElementsBorder};] {id} .cke_path_item [color:{elementsPathColor};] {id} a.cke_path_item:hover,{id} a.cke_path_item:focus,{id} a.cke_path_item:active [background-color:{darkBackground};] {id}.cke_panel [border-color:{defaultBorder};] "),panel:new CKEDITOR.template(".cke_panel_grouptitle [background-color:{lightBackground};border-color:{defaultBorder};] .cke_menubutton_icon [background-color:{menubuttonIcon};] .cke_menubutton:hover,.cke_menubutton:focus,.cke_menubutton:active [background-color:{menubuttonHover};] .cke_menubutton:hover .cke_menubutton_icon, .cke_menubutton:focus .cke_menubutton_icon, .cke_menubutton:active .cke_menubutton_icon [background-color:{menubuttonIconHover};] .cke_menubutton_disabled:hover .cke_menubutton_icon,.cke_menubutton_disabled:focus .cke_menubutton_icon,.cke_menubutton_disabled:active .cke_menubutton_icon [background-color:{menubuttonIcon};] .cke_menuseparator [background-color:{menubuttonIcon};] a:hover.cke_colorbox, a:active.cke_colorbox [border-color:{defaultBorder};] a:hover.cke_colorauto, a:hover.cke_colormore, a:active.cke_colorauto, a:active.cke_colormore [background-color:{ckeColorauto};border-color:{defaultBorder};] ")};
return function(g,d){var a=b(g.uiColor,.4),a={id:"."+g.id,defaultBorder:b(a,-.2),toolbarElementsBorder:b(a,-.25),defaultBackground:a,lightBackground:b(a,.8),darkBackground:b(a,-.15),ckeButtonOn:b(a,.4),ckeResizer:b(a,-.4),ckeColorauto:b(a,.8),dialogBody:b(a,.7),dialogTab:b(a,.65),dialogTabSelected:"#FFF",dialogTabSelectedBorder:"#FFF",elementsPathColor:b(a,-.6),menubuttonHover:b(a,.1),menubuttonIcon:b(a,.5),menubuttonIconHover:b(a,.3)};return f[d].output(a).replace(/\[/g,"{").replace(/\]/g,"}")}}();CKEDITOR.plugins.add("dialogui",{onLoad:function(){var h=function(b){this._||(this._={});this._["default"]=this._.initValue=b["default"]||"";this._.required=b.required||!1;for(var a=[this._],d=1;d<arguments.length;d++)a.push(arguments[d]);a.push(!0);CKEDITOR.tools.extend.apply(CKEDITOR.tools,a);return this._},r={build:function(b,a,d){return new CKEDITOR.ui.dialog.textInput(b,a,d)}},n={build:function(b,a,d){return new CKEDITOR.ui.dialog[a.type](b,a,d)}},q={isChanged:function(){return this.getValue()!=
this.getInitValue()},reset:function(b){this.setValue(this.getInitValue(),b)},setInitValue:function(){this._.initValue=this.getValue()},resetInitValue:function(){this._.initValue=this._["default"]},getInitValue:function(){return this._.initValue}},v=CKEDITOR.tools.extend({},CKEDITOR.ui.dialog.uiElement.prototype.eventProcessors,{onChange:function(b,a){this._.domOnChangeRegistered||(b.on("load",function(){this.getInputElement().on("change",function(){b.parts.dialog.isVisible()&&this.fire("change",{value:this.getValue()})},
this)},this),this._.domOnChangeRegistered=!0);this.on("change",a)}},!0),x=/^on([A-Z]\w+)/,t=function(b){for(var a in b)(x.test(a)||"title"==a||"type"==a)&&delete b[a];return b},w=function(b){b=b.data.getKeystroke();b==CKEDITOR.SHIFT+CKEDITOR.ALT+36?this.setDirectionMarker("ltr"):b==CKEDITOR.SHIFT+CKEDITOR.ALT+35&&this.setDirectionMarker("rtl")};CKEDITOR.tools.extend(CKEDITOR.ui.dialog,{labeledElement:function(b,a,d,f){if(!(4>arguments.length)){var c=h.call(this,a);c.labelId=CKEDITOR.tools.getNextId()+
"_label";this._.children=[];var e={role:a.role||"presentation"};a.includeLabel&&(e["aria-labelledby"]=c.labelId);CKEDITOR.ui.dialog.uiElement.call(this,b,a,d,"div",null,e,function(){var e=[],g=a.required?" cke_required":"";"horizontal"!=a.labelLayout?e.push('\x3clabel class\x3d"cke_dialog_ui_labeled_label'+g+'" ',' id\x3d"'+c.labelId+'"',c.inputId?' for\x3d"'+c.inputId+'"':"",(a.labelStyle?' style\x3d"'+a.labelStyle+'"':"")+"\x3e",a.label,"\x3c/label\x3e",'\x3cdiv class\x3d"cke_dialog_ui_labeled_content"',
a.controlStyle?' style\x3d"'+a.controlStyle+'"':"",' role\x3d"presentation"\x3e',f.call(this,b,a),"\x3c/div\x3e"):(g={type:"hbox",widths:a.widths,padding:0,children:[{type:"html",html:'\x3clabel class\x3d"cke_dialog_ui_labeled_label'+g+'" id\x3d"'+c.labelId+'" for\x3d"'+c.inputId+'"'+(a.labelStyle?' style\x3d"'+a.labelStyle+'"':"")+"\x3e"+CKEDITOR.tools.htmlEncode(a.label)+"\x3c/label\x3e"},{type:"html",html:'\x3cspan class\x3d"cke_dialog_ui_labeled_content"'+(a.controlStyle?' style\x3d"'+a.controlStyle+
'"':"")+"\x3e"+f.call(this,b,a)+"\x3c/span\x3e"}]},CKEDITOR.dialog._.uiElementBuilders.hbox.build(b,g,e));return e.join("")})}},textInput:function(b,a,d){if(!(3>arguments.length)){h.call(this,a);var f=this._.inputId=CKEDITOR.tools.getNextId()+"_textInput",c={"class":"cke_dialog_ui_input_"+a.type,id:f,type:a.type};a.validate&&(this.validate=a.validate);a.maxLength&&(c.maxlength=a.maxLength);a.size&&(c.size=a.size);a.inputStyle&&(c.style=a.inputStyle);var e=this,m=!1;b.on("load",function(){e.getInputElement().on("keydown",
function(a){13==a.data.getKeystroke()&&(m=!0)});e.getInputElement().on("keyup",function(a){13==a.data.getKeystroke()&&m&&(b.getButton("ok")&&setTimeout(function(){b.getButton("ok").click()},0),m=!1);e.bidi&&w.call(e,a)},null,null,1E3)});CKEDITOR.ui.dialog.labeledElement.call(this,b,a,d,function(){var b=['\x3cdiv class\x3d"cke_dialog_ui_input_',a.type,'" role\x3d"presentation"'];a.width&&b.push('style\x3d"width:'+a.width+'" ');b.push("\x3e\x3cinput ");c["aria-labelledby"]=this._.labelId;this._.required&&
(c["aria-required"]=this._.required);for(var e in c)b.push(e+'\x3d"'+c[e]+'" ');b.push(" /\x3e\x3c/div\x3e");return b.join("")})}},textarea:function(b,a,d){if(!(3>arguments.length)){h.call(this,a);var f=this,c=this._.inputId=CKEDITOR.tools.getNextId()+"_textarea",e={};a.validate&&(this.validate=a.validate);e.rows=a.rows||5;e.cols=a.cols||20;e["class"]="cke_dialog_ui_input_textarea "+(a["class"]||"");"undefined"!=typeof a.inputStyle&&(e.style=a.inputStyle);a.dir&&(e.dir=a.dir);if(f.bidi)b.on("load",
function(){f.getInputElement().on("keyup",w)},f);CKEDITOR.ui.dialog.labeledElement.call(this,b,a,d,function(){e["aria-labelledby"]=this._.labelId;this._.required&&(e["aria-required"]=this._.required);var a=['\x3cdiv class\x3d"cke_dialog_ui_input_textarea" role\x3d"presentation"\x3e\x3ctextarea id\x3d"',c,'" '],b;for(b in e)a.push(b+'\x3d"'+CKEDITOR.tools.htmlEncode(e[b])+'" ');a.push("\x3e",CKEDITOR.tools.htmlEncode(f._["default"]),"\x3c/textarea\x3e\x3c/div\x3e");return a.join("")})}},checkbox:function(b,
a,d){if(!(3>arguments.length)){var f=h.call(this,a,{"default":!!a["default"]});a.validate&&(this.validate=a.validate);CKEDITOR.ui.dialog.uiElement.call(this,b,a,d,"span",null,null,function(){var c=CKEDITOR.tools.extend({},a,{id:a.id?a.id+"_checkbox":CKEDITOR.tools.getNextId()+"_checkbox"},!0),e=[],d=CKEDITOR.tools.getNextId()+"_label",g={"class":"cke_dialog_ui_checkbox_input",type:"checkbox","aria-labelledby":d};t(c);a["default"]&&(g.checked="checked");"undefined"!=typeof c.inputStyle&&(c.style=c.inputStyle);
f.checkbox=new CKEDITOR.ui.dialog.uiElement(b,c,e,"input",null,g);e.push(' \x3clabel id\x3d"',d,'" for\x3d"',g.id,'"'+(a.labelStyle?' style\x3d"'+a.labelStyle+'"':"")+"\x3e",CKEDITOR.tools.htmlEncode(a.label),"\x3c/label\x3e");return e.join("")})}},radio:function(b,a,d){if(!(3>arguments.length)){h.call(this,a);this._["default"]||(this._["default"]=this._.initValue=a.items[0][1]);a.validate&&(this.validate=a.validate);var f=[],c=this;a.role="radiogroup";a.includeLabel=!0;CKEDITOR.ui.dialog.labeledElement.call(this,
b,a,d,function(){for(var e=[],d=[],g=(a.id?a.id:CKEDITOR.tools.getNextId())+"_radio",k=0;k<a.items.length;k++){var l=a.items[k],h=void 0!==l[2]?l[2]:l[0],n=void 0!==l[1]?l[1]:l[0],p=CKEDITOR.tools.getNextId()+"_radio_input",q=p+"_label",p=CKEDITOR.tools.extend({},a,{id:p,title:null,type:null},!0),h=CKEDITOR.tools.extend({},p,{title:h},!0),r={type:"radio","class":"cke_dialog_ui_radio_input",name:g,value:n,"aria-labelledby":q},u=[];c._["default"]==n&&(r.checked="checked");t(p);t(h);"undefined"!=typeof p.inputStyle&&
(p.style=p.inputStyle);p.keyboardFocusable=!0;f.push(new CKEDITOR.ui.dialog.uiElement(b,p,u,"input",null,r));u.push(" ");new CKEDITOR.ui.dialog.uiElement(b,h,u,"label",null,{id:q,"for":r.id},l[0]);e.push(u.join(""))}new CKEDITOR.ui.dialog.hbox(b,f,e,d);return d.join("")});this._.children=f}},button:function(b,a,d){if(arguments.length){"function"==typeof a&&(a=a(b.getParentEditor()));h.call(this,a,{disabled:a.disabled||!1});CKEDITOR.event.implementOn(this);var f=this;b.on("load",function(){var a=this.getElement();
(function(){a.on("click",function(a){f.click();a.data.preventDefault()});a.on("keydown",function(a){a.data.getKeystroke()in{32:1}&&(f.click(),a.data.preventDefault())})})();a.unselectable()},this);var c=CKEDITOR.tools.extend({},a);delete c.style;var e=CKEDITOR.tools.getNextId()+"_label";CKEDITOR.ui.dialog.uiElement.call(this,b,c,d,"a",null,{style:a.style,href:"javascript:void(0)",title:a.label,hidefocus:"true","class":a["class"],role:"button","aria-labelledby":e},'\x3cspan id\x3d"'+e+'" class\x3d"cke_dialog_ui_button"\x3e'+
CKEDITOR.tools.htmlEncode(a.label)+"\x3c/span\x3e")}},select:function(b,a,d){if(!(3>arguments.length)){var f=h.call(this,a);a.validate&&(this.validate=a.validate);f.inputId=CKEDITOR.tools.getNextId()+"_select";CKEDITOR.ui.dialog.labeledElement.call(this,b,a,d,function(){var c=CKEDITOR.tools.extend({},a,{id:a.id?a.id+"_select":CKEDITOR.tools.getNextId()+"_select"},!0),e=[],d=[],g={id:f.inputId,"class":"cke_dialog_ui_input_select","aria-labelledby":this._.labelId};e.push('\x3cdiv class\x3d"cke_dialog_ui_input_',
a.type,'" role\x3d"presentation"');a.width&&e.push('style\x3d"width:'+a.width+'" ');e.push("\x3e");void 0!==a.size&&(g.size=a.size);void 0!==a.multiple&&(g.multiple=a.multiple);t(c);for(var k=0,l;k<a.items.length&&(l=a.items[k]);k++)d.push('\x3coption value\x3d"',CKEDITOR.tools.htmlEncode(void 0!==l[1]?l[1]:l[0]).replace(/"/g,"\x26quot;"),'" /\x3e ',CKEDITOR.tools.htmlEncode(l[0]));"undefined"!=typeof c.inputStyle&&(c.style=c.inputStyle);f.select=new CKEDITOR.ui.dialog.uiElement(b,c,e,"select",null,
g,d.join(""));e.push("\x3c/div\x3e");return e.join("")})}},file:function(b,a,d){if(!(3>arguments.length)){void 0===a["default"]&&(a["default"]="");var f=CKEDITOR.tools.extend(h.call(this,a),{definition:a,buttons:[]});a.validate&&(this.validate=a.validate);b.on("load",function(){CKEDITOR.document.getById(f.frameId).getParent().addClass("cke_dialog_ui_input_file")});CKEDITOR.ui.dialog.labeledElement.call(this,b,a,d,function(){f.frameId=CKEDITOR.tools.getNextId()+"_fileInput";var b=['\x3ciframe frameborder\x3d"0" allowtransparency\x3d"0" class\x3d"cke_dialog_ui_input_file" role\x3d"presentation" id\x3d"',
f.frameId,'" title\x3d"',a.label,'" src\x3d"javascript:void('];b.push(CKEDITOR.env.ie?"(function(){"+encodeURIComponent("document.open();("+CKEDITOR.tools.fixDomain+")();document.close();")+"})()":"0");b.push(')"\x3e\x3c/iframe\x3e');return b.join("")})}},fileButton:function(b,a,d){var f=this;if(!(3>arguments.length)){h.call(this,a);a.validate&&(this.validate=a.validate);var c=CKEDITOR.tools.extend({},a),e=c.onClick;c.className=(c.className?c.className+" ":"")+"cke_dialog_ui_button";c.onClick=function(c){var d=
a["for"];c=e?e.call(this,c):!1;!1!==c&&("xhr"!==c&&b.getContentElement(d[0],d[1]).submit(),this.disable())};b.on("load",function(){b.getContentElement(a["for"][0],a["for"][1])._.buttons.push(f)});CKEDITOR.ui.dialog.button.call(this,b,c,d)}},html:function(){var b=/^\s*<[\w:]+\s+([^>]*)?>/,a=/^(\s*<[\w:]+(?:\s+[^>]*)?)((?:.|\r|\n)+)$/,d=/\/$/;return function(f,c,e){if(!(3>arguments.length)){var m=[],g=c.html;"\x3c"!=g.charAt(0)&&(g="\x3cspan\x3e"+g+"\x3c/span\x3e");var k=c.focus;if(k){var l=this.focus;
this.focus=function(){("function"==typeof k?k:l).call(this);this.fire("focus")};c.isFocusable&&(this.isFocusable=this.isFocusable);this.keyboardFocusable=!0}CKEDITOR.ui.dialog.uiElement.call(this,f,c,m,"span",null,null,"");m=m.join("").match(b);g=g.match(a)||["","",""];d.test(g[1])&&(g[1]=g[1].slice(0,-1),g[2]="/"+g[2]);e.push([g[1]," ",m[1]||"",g[2]].join(""))}}}(),fieldset:function(b,a,d,f,c){var e=c.label;this._={children:a};CKEDITOR.ui.dialog.uiElement.call(this,b,c,f,"fieldset",null,null,function(){var a=
[];e&&a.push("\x3clegend"+(c.labelStyle?' style\x3d"'+c.labelStyle+'"':"")+"\x3e"+e+"\x3c/legend\x3e");for(var b=0;b<d.length;b++)a.push(d[b]);return a.join("")})}},!0);CKEDITOR.ui.dialog.html.prototype=new CKEDITOR.ui.dialog.uiElement;CKEDITOR.ui.dialog.labeledElement.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.uiElement,{setLabel:function(b){var a=CKEDITOR.document.getById(this._.labelId);1>a.getChildCount()?(new CKEDITOR.dom.text(b,CKEDITOR.document)).appendTo(a):a.getChild(0).$.nodeValue=
b;return this},getLabel:function(){var b=CKEDITOR.document.getById(this._.labelId);return!b||1>b.getChildCount()?"":b.getChild(0).getText()},eventProcessors:v},!0);CKEDITOR.ui.dialog.button.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.uiElement,{click:function(){return this._.disabled?!1:this.fire("click",{dialog:this._.dialog})},enable:function(){this._.disabled=!1;var b=this.getElement();b&&b.removeClass("cke_disabled")},disable:function(){this._.disabled=!0;this.getElement().addClass("cke_disabled")},
isVisible:function(){return this.getElement().getFirst().isVisible()},isEnabled:function(){return!this._.disabled},eventProcessors:CKEDITOR.tools.extend({},CKEDITOR.ui.dialog.uiElement.prototype.eventProcessors,{onClick:function(b,a){this.on("click",function(){a.apply(this,arguments)})}},!0),accessKeyUp:function(){this.click()},accessKeyDown:function(){this.focus()},keyboardFocusable:!0},!0);CKEDITOR.ui.dialog.textInput.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.labeledElement,{getInputElement:function(){return CKEDITOR.document.getById(this._.inputId)},
focus:function(){var b=this.selectParentTab();setTimeout(function(){var a=b.getInputElement();a&&a.$.focus()},0)},select:function(){var b=this.selectParentTab();setTimeout(function(){var a=b.getInputElement();a&&(a.$.focus(),a.$.select())},0)},accessKeyUp:function(){this.select()},setValue:function(b){if(this.bidi){var a=b&&b.charAt(0);(a="‪"==a?"ltr":"‫"==a?"rtl":null)&&(b=b.slice(1));this.setDirectionMarker(a)}b||(b="");return CKEDITOR.ui.dialog.uiElement.prototype.setValue.apply(this,arguments)},
getValue:function(){var b=CKEDITOR.ui.dialog.uiElement.prototype.getValue.call(this);if(this.bidi&&b){var a=this.getDirectionMarker();a&&(b=("ltr"==a?"‪":"‫")+b)}return b},setDirectionMarker:function(b){var a=this.getInputElement();b?a.setAttributes({dir:b,"data-cke-dir-marker":b}):this.getDirectionMarker()&&a.removeAttributes(["dir","data-cke-dir-marker"])},getDirectionMarker:function(){return this.getInputElement().data("cke-dir-marker")},keyboardFocusable:!0},q,!0);CKEDITOR.ui.dialog.textarea.prototype=
new CKEDITOR.ui.dialog.textInput;CKEDITOR.ui.dialog.select.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.labeledElement,{getInputElement:function(){return this._.select.getElement()},add:function(b,a,d){var f=new CKEDITOR.dom.element("option",this.getDialog().getParentEditor().document),c=this.getInputElement().$;f.$.text=b;f.$.value=void 0===a||null===a?b:a;void 0===d||null===d?CKEDITOR.env.ie?c.add(f.$):c.add(f.$,null):c.add(f.$,d);return this},remove:function(b){this.getInputElement().$.remove(b);
return this},clear:function(){for(var b=this.getInputElement().$;0<b.length;)b.remove(0);return this},keyboardFocusable:!0},q,!0);CKEDITOR.ui.dialog.checkbox.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.uiElement,{getInputElement:function(){return this._.checkbox.getElement()},setValue:function(b,a){this.getInputElement().$.checked=b;!a&&this.fire("change",{value:b})},getValue:function(){return this.getInputElement().$.checked},accessKeyUp:function(){this.setValue(!this.getValue())},eventProcessors:{onChange:function(b,
a){if(!CKEDITOR.env.ie||8<CKEDITOR.env.version)return v.onChange.apply(this,arguments);b.on("load",function(){var a=this._.checkbox.getElement();a.on("propertychange",function(b){b=b.data.$;"checked"==b.propertyName&&this.fire("change",{value:a.$.checked})},this)},this);this.on("change",a);return null}},keyboardFocusable:!0},q,!0);CKEDITOR.ui.dialog.radio.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.uiElement,{setValue:function(b,a){for(var d=this._.children,f,c=0;c<d.length&&(f=d[c]);c++)f.getElement().$.checked=
f.getValue()==b;!a&&this.fire("change",{value:b})},getValue:function(){for(var b=this._.children,a=0;a<b.length;a++)if(b[a].getElement().$.checked)return b[a].getValue();return null},accessKeyUp:function(){var b=this._.children,a;for(a=0;a<b.length;a++)if(b[a].getElement().$.checked){b[a].getElement().focus();return}b[0].getElement().focus()},eventProcessors:{onChange:function(b,a){if(!CKEDITOR.env.ie||8<CKEDITOR.env.version)return v.onChange.apply(this,arguments);b.on("load",function(){for(var a=
this._.children,b=this,c=0;c<a.length;c++)a[c].getElement().on("propertychange",function(a){a=a.data.$;"checked"==a.propertyName&&this.$.checked&&b.fire("change",{value:this.getAttribute("value")})})},this);this.on("change",a);return null}}},q,!0);CKEDITOR.ui.dialog.file.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.labeledElement,q,{getInputElement:function(){var b=CKEDITOR.document.getById(this._.frameId).getFrameDocument();return 0<b.$.forms.length?new CKEDITOR.dom.element(b.$.forms[0].elements[0]):
this.getElement()},submit:function(){this.getInputElement().getParent().$.submit();return this},getAction:function(){return this.getInputElement().getParent().$.action},registerEvents:function(b){var a=/^on([A-Z]\w+)/,d,f=function(a,b,c,d){a.on("formLoaded",function(){a.getInputElement().on(c,d,a)})},c;for(c in b)if(d=c.match(a))this.eventProcessors[c]?this.eventProcessors[c].call(this,this._.dialog,b[c]):f(this,this._.dialog,d[1].toLowerCase(),b[c]);return this},reset:function(){function b(){d.$.open();
var b="";f.size&&(b=f.size-(CKEDITOR.env.ie?7:0));var h=a.frameId+"_input";d.$.write(['\x3chtml dir\x3d"'+g+'" lang\x3d"'+k+'"\x3e\x3chead\x3e\x3ctitle\x3e\x3c/title\x3e\x3c/head\x3e\x3cbody style\x3d"margin: 0; overflow: hidden; background: transparent;"\x3e','\x3cform enctype\x3d"multipart/form-data" method\x3d"POST" dir\x3d"'+g+'" lang\x3d"'+k+'" action\x3d"',CKEDITOR.tools.htmlEncode(f.action),'"\x3e\x3clabel id\x3d"',a.labelId,'" for\x3d"',h,'" style\x3d"display:none"\x3e',CKEDITOR.tools.htmlEncode(f.label),
'\x3c/label\x3e\x3cinput style\x3d"width:100%" id\x3d"',h,'" aria-labelledby\x3d"',a.labelId,'" type\x3d"file" name\x3d"',CKEDITOR.tools.htmlEncode(f.id||"cke_upload"),'" size\x3d"',CKEDITOR.tools.htmlEncode(0<b?b:""),'" /\x3e\x3c/form\x3e\x3c/body\x3e\x3c/html\x3e\x3cscript\x3e',CKEDITOR.env.ie?"("+CKEDITOR.tools.fixDomain+")();":"","window.parent.CKEDITOR.tools.callFunction("+e+");","window.onbeforeunload \x3d function() {window.parent.CKEDITOR.tools.callFunction("+m+")}","\x3c/script\x3e"].join(""));
d.$.close();for(b=0;b<c.length;b++)c[b].enable()}var a=this._,d=CKEDITOR.document.getById(a.frameId).getFrameDocument(),f=a.definition,c=a.buttons,e=this.formLoadedNumber,m=this.formUnloadNumber,g=a.dialog._.editor.lang.dir,k=a.dialog._.editor.langCode;e||(e=this.formLoadedNumber=CKEDITOR.tools.addFunction(function(){this.fire("formLoaded")},this),m=this.formUnloadNumber=CKEDITOR.tools.addFunction(function(){this.getInputElement().clearCustomData()},this),this.getDialog()._.editor.on("destroy",function(){CKEDITOR.tools.removeFunction(e);
CKEDITOR.tools.removeFunction(m)}));CKEDITOR.env.gecko?setTimeout(b,500):b()},getValue:function(){return this.getInputElement().$.value||""},setInitValue:function(){this._.initValue=""},eventProcessors:{onChange:function(b,a){this._.domOnChangeRegistered||(this.on("formLoaded",function(){this.getInputElement().on("change",function(){this.fire("change",{value:this.getValue()})},this)},this),this._.domOnChangeRegistered=!0);this.on("change",a)}},keyboardFocusable:!0},!0);CKEDITOR.ui.dialog.fileButton.prototype=
new CKEDITOR.ui.dialog.button;CKEDITOR.ui.dialog.fieldset.prototype=CKEDITOR.tools.clone(CKEDITOR.ui.dialog.hbox.prototype);CKEDITOR.dialog.addUIElement("text",r);CKEDITOR.dialog.addUIElement("password",r);CKEDITOR.dialog.addUIElement("tel",r);CKEDITOR.dialog.addUIElement("textarea",n);CKEDITOR.dialog.addUIElement("checkbox",n);CKEDITOR.dialog.addUIElement("radio",n);CKEDITOR.dialog.addUIElement("button",n);CKEDITOR.dialog.addUIElement("select",n);CKEDITOR.dialog.addUIElement("file",n);CKEDITOR.dialog.addUIElement("fileButton",
n);CKEDITOR.dialog.addUIElement("html",n);CKEDITOR.dialog.addUIElement("fieldset",{build:function(b,a,d){for(var f=a.children,c,e=[],h=[],g=0;g<f.length&&(c=f[g]);g++){var k=[];e.push(k);h.push(CKEDITOR.dialog._.uiElementBuilders[c.type].build(b,c,k))}return new CKEDITOR.ui.dialog[a.type](b,h,e,d,a)}})}});CKEDITOR.DIALOG_RESIZE_NONE=0;CKEDITOR.DIALOG_RESIZE_WIDTH=1;CKEDITOR.DIALOG_RESIZE_HEIGHT=2;CKEDITOR.DIALOG_RESIZE_BOTH=3;CKEDITOR.DIALOG_STATE_IDLE=1;CKEDITOR.DIALOG_STATE_BUSY=2;
(function(){function I(a){a._.tabBarMode=!0;a._.tabs[a._.currentTabId][0].focus();a._.currentFocusIndex=-1}function J(){for(var a=this._.tabIdList.length,b=CKEDITOR.tools.indexOf(this._.tabIdList,this._.currentTabId)+a,c=b-1;c>b-a;c--)if(this._.tabs[this._.tabIdList[c%a]][0].$.offsetHeight)return this._.tabIdList[c%a];return null}function W(){for(var a=this._.tabIdList.length,b=CKEDITOR.tools.indexOf(this._.tabIdList,this._.currentTabId),c=b+1;c<b+a;c++)if(this._.tabs[this._.tabIdList[c%a]][0].$.offsetHeight)return this._.tabIdList[c%
a];return null}function K(a,b){for(var c=a.$.getElementsByTagName("input"),e=0,d=c.length;e<d;e++){var f=new CKEDITOR.dom.element(c[e]);"text"==f.getAttribute("type").toLowerCase()&&(b?(f.setAttribute("value",f.getCustomData("fake_value")||""),f.removeCustomData("fake_value")):(f.setCustomData("fake_value",f.getAttribute("value")),f.setAttribute("value","")))}}function X(a,b){var c=this.getInputElement();c&&(a?c.removeAttribute("aria-invalid"):c.setAttribute("aria-invalid",!0));a||(this.select?this.select():
this.focus());b&&alert(b);this.fire("validated",{valid:a,msg:b})}function Y(){var a=this.getInputElement();a&&a.removeAttribute("aria-invalid")}function Z(a){var b=CKEDITOR.dom.element.createFromHtml(CKEDITOR.addTemplate("dialog",aa).output({id:CKEDITOR.tools.getNextNumber(),editorId:a.id,langDir:a.lang.dir,langCode:a.langCode,editorDialogClass:"cke_editor_"+a.name.replace(/\./g,"\\.")+"_dialog",closeTitle:a.lang.common.close,hidpi:CKEDITOR.env.hidpi?"cke_hidpi":""})),c=b.getChild([0,0,0,0,0]),e=
c.getChild(0),d=c.getChild(1);a.plugins.clipboard&&CKEDITOR.plugins.clipboard.preventDefaultDropOnElement(c);!CKEDITOR.env.ie||CKEDITOR.env.quirks||CKEDITOR.env.edge||(a="javascript:void(function(){"+encodeURIComponent("document.open();("+CKEDITOR.tools.fixDomain+")();document.close();")+"}())",CKEDITOR.dom.element.createFromHtml('\x3ciframe frameBorder\x3d"0" class\x3d"cke_iframe_shim" src\x3d"'+a+'" tabIndex\x3d"-1"\x3e\x3c/iframe\x3e').appendTo(c.getParent()));e.unselectable();d.unselectable();
return{element:b,parts:{dialog:b.getChild(0),title:e,close:d,tabs:c.getChild(2),contents:c.getChild([3,0,0,0]),footer:c.getChild([3,0,1,0])}}}function L(a,b,c){this.element=b;this.focusIndex=c;this.tabIndex=0;this.isFocusable=function(){return!b.getAttribute("disabled")&&b.isVisible()};this.focus=function(){a._.currentFocusIndex=this.focusIndex;this.element.focus()};b.on("keydown",function(a){a.data.getKeystroke()in{32:1,13:1}&&this.fire("click")});b.on("focus",function(){this.fire("mouseover")});
b.on("blur",function(){this.fire("mouseout")})}function ba(a){function b(){a.layout()}var c=CKEDITOR.document.getWindow();c.on("resize",b);a.on("hide",function(){c.removeListener("resize",b)})}function M(a,b){this.dialog=a;for(var c=b.contents,e=0,d;d=c[e];e++)c[e]=d&&new N(a,d);CKEDITOR.tools.extend(this,b)}function N(a,b){this._={dialog:a};CKEDITOR.tools.extend(this,b)}function ca(a){function b(b){var c=a.getSize(),k=a.parts.dialog.getParent().getClientSize(),q=b.data.$.screenX,l=b.data.$.screenY,
r=q-e.x,n=l-e.y;e={x:q,y:l};d.x+=r;d.y+=n;q=d.x+h[3]<g?-h[3]:d.x-h[1]>k.width-c.width-g?k.width-c.width+("rtl"==f.lang.dir?0:h[1]):d.x;c=d.y+h[0]<g?-h[0]:d.y-h[2]>k.height-c.height-g?k.height-c.height+h[2]:d.y;q=Math.floor(q);c=Math.floor(c);a.move(q,c,1);b.data.preventDefault()}function c(){CKEDITOR.document.removeListener("mousemove",b);CKEDITOR.document.removeListener("mouseup",c);if(CKEDITOR.env.ie6Compat){var a=u.getChild(0).getFrameDocument();a.removeListener("mousemove",b);a.removeListener("mouseup",
c)}}var e=null,d=null,f=a.getParentEditor(),g=f.config.dialog_magnetDistance,h=CKEDITOR.skin.margins||[0,0,0,0];"undefined"==typeof g&&(g=20);a.parts.title.on("mousedown",function(g){if(!a._.moved){var f=a._.element;f.getFirst().setStyle("position","absolute");f.removeStyle("display");a._.moved=!0;a.layout()}e={x:g.data.$.screenX,y:g.data.$.screenY};CKEDITOR.document.on("mousemove",b);CKEDITOR.document.on("mouseup",c);d=a.getPosition();CKEDITOR.env.ie6Compat&&(f=u.getChild(0).getFrameDocument(),f.on("mousemove",
b),f.on("mouseup",c));g.data.preventDefault()},a)}function da(a){function b(b){var c="rtl"==f.lang.dir,q=k.width,l=k.height,w=q+(b.data.$.screenX-m.x)*(c?-1:1)*(a._.moved?1:2),A=l+(b.data.$.screenY-m.y)*(a._.moved?1:2),C=a._.element.getFirst(),C=c&&parseInt(C.getComputedStyle("right"),10),v=a.getPosition();v.x=v.x||0;v.y=v.y||0;v.y+A>p.height&&(A=p.height-v.y);(c?C:v.x)+w>p.width&&(w=p.width-(c?C:v.x));A=Math.floor(A);w=Math.floor(w);if(d==CKEDITOR.DIALOG_RESIZE_WIDTH||d==CKEDITOR.DIALOG_RESIZE_BOTH)q=
Math.max(e.minWidth||0,w-g);if(d==CKEDITOR.DIALOG_RESIZE_HEIGHT||d==CKEDITOR.DIALOG_RESIZE_BOTH)l=Math.max(e.minHeight||0,A-h);a.resize(q,l);a._.moved&&O(a,a._.position.x,a._.position.y);a._.moved||a.layout();b.data.preventDefault()}function c(){CKEDITOR.document.removeListener("mouseup",c);CKEDITOR.document.removeListener("mousemove",b);q&&(q.remove(),q=null);if(CKEDITOR.env.ie6Compat){var a=u.getChild(0).getFrameDocument();a.removeListener("mouseup",c);a.removeListener("mousemove",b)}}var e=a.definition,
d=e.resizable;if(d!=CKEDITOR.DIALOG_RESIZE_NONE){var f=a.getParentEditor(),g,h,p,m,k,q,l=CKEDITOR.tools.addFunction(function(d){function e(a){return a.isVisible()}k=a.getSize();var f=a.parts.contents,l=f.$.getElementsByTagName("iframe").length,w=!(CKEDITOR.env.gecko||CKEDITOR.env.ie&&CKEDITOR.env.quirks);l&&(q=CKEDITOR.dom.element.createFromHtml('\x3cdiv class\x3d"cke_dialog_resize_cover" style\x3d"height: 100%; position: absolute; width: 100%; left:0; top:0;"\x3e\x3c/div\x3e'),f.append(q));h=k.height-
a.parts.contents.getFirst(e).getSize("height",w);g=k.width-a.parts.contents.getFirst(e).getSize("width",1);m={x:d.screenX,y:d.screenY};p=CKEDITOR.document.getWindow().getViewPaneSize();CKEDITOR.document.on("mousemove",b);CKEDITOR.document.on("mouseup",c);CKEDITOR.env.ie6Compat&&(f=u.getChild(0).getFrameDocument(),f.on("mousemove",b),f.on("mouseup",c));d.preventDefault&&d.preventDefault()});a.on("load",function(){var b="";d==CKEDITOR.DIALOG_RESIZE_WIDTH?b=" cke_resizer_horizontal":d==CKEDITOR.DIALOG_RESIZE_HEIGHT&&
(b=" cke_resizer_vertical");b=CKEDITOR.dom.element.createFromHtml('\x3cdiv class\x3d"cke_resizer'+b+" cke_resizer_"+f.lang.dir+'" title\x3d"'+CKEDITOR.tools.htmlEncode(f.lang.common.resize)+'" onmousedown\x3d"CKEDITOR.tools.callFunction('+l+', event )"\x3e'+("ltr"==f.lang.dir?"◢":"◣")+"\x3c/div\x3e");a.parts.footer.append(b,1)});f.on("destroy",function(){CKEDITOR.tools.removeFunction(l)})}}function O(a,b,c){var e=a.parts.dialog.getParent().getClientSize(),d=a.getSize(),f=a._.viewportRatio,g=Math.max(e.width-
d.width,0),e=Math.max(e.height-d.height,0);f.width=g?b/g:f.width;f.height=e?c/e:f.height;a._.viewportRatio=f}function H(a){a.data.preventDefault(1)}function P(a){var b=a.config,c=CKEDITOR.skinName||a.config.skin,e=b.dialog_backgroundCoverColor||("moono-lisa"==c?"black":"white"),c=b.dialog_backgroundCoverOpacity,d=b.baseFloatZIndex,b=CKEDITOR.tools.genKey(e,c,d),f=B[b];CKEDITOR.document.getBody().addClass("cke_dialog_open");f?f.show():(d=['\x3cdiv tabIndex\x3d"-1" style\x3d"position: ',CKEDITOR.env.ie6Compat?
"absolute":"fixed","; z-index: ",d,"; top: 0px; left: 0px; ","; width: 100%; height: 100%;",CKEDITOR.env.ie6Compat?"":"background-color: "+e,'" class\x3d"cke_dialog_background_cover"\x3e'],CKEDITOR.env.ie6Compat&&(e="\x3chtml\x3e\x3cbody style\x3d\\'background-color:"+e+";\\'\x3e\x3c/body\x3e\x3c/html\x3e",d.push('\x3ciframe hidefocus\x3d"true" frameborder\x3d"0" id\x3d"cke_dialog_background_iframe" src\x3d"javascript:'),d.push("void((function(){"+encodeURIComponent("document.open();("+CKEDITOR.tools.fixDomain+
")();document.write( '"+e+"' );document.close();")+"})())"),d.push('" style\x3d"position:absolute;left:0;top:0;width:100%;height: 100%;filter: progid:DXImageTransform.Microsoft.Alpha(opacity\x3d0)"\x3e\x3c/iframe\x3e')),d.push("\x3c/div\x3e"),f=CKEDITOR.dom.element.createFromHtml(d.join("")),f.setOpacity(void 0!==c?c:.5),f.on("keydown",H),f.on("keypress",H),f.on("keyup",H),f.appendTo(CKEDITOR.document.getBody()),B[b]=f);a.focusManager.add(f);u=f;CKEDITOR.env.mac&&CKEDITOR.env.webkit||f.focus()}function Q(a){CKEDITOR.document.getBody().removeClass("cke_dialog_open");
u&&(a.focusManager.remove(u),u.hide())}function R(a){var b=a.data.$.ctrlKey||a.data.$.metaKey,c=a.data.$.altKey,e=a.data.$.shiftKey,d=String.fromCharCode(a.data.$.keyCode);(b=x[(b?"CTRL+":"")+(c?"ALT+":"")+(e?"SHIFT+":"")+d])&&b.length&&(b=b[b.length-1],b.keydown&&b.keydown.call(b.uiElement,b.dialog,b.key),a.data.preventDefault())}function S(a){var b=a.data.$.ctrlKey||a.data.$.metaKey,c=a.data.$.altKey,e=a.data.$.shiftKey,d=String.fromCharCode(a.data.$.keyCode);(b=x[(b?"CTRL+":"")+(c?"ALT+":"")+(e?
"SHIFT+":"")+d])&&b.length&&(b=b[b.length-1],b.keyup&&(b.keyup.call(b.uiElement,b.dialog,b.key),a.data.preventDefault()))}function T(a,b,c,e,d){(x[c]||(x[c]=[])).push({uiElement:a,dialog:b,key:c,keyup:d||a.accessKeyUp,keydown:e||a.accessKeyDown})}function ea(a){for(var b in x){for(var c=x[b],e=c.length-1;0<=e;e--)c[e].dialog!=a&&c[e].uiElement!=a||c.splice(e,1);0===c.length&&delete x[b]}}function fa(a,b){a._.accessKeyMap[b]&&a.selectPage(a._.accessKeyMap[b])}function ga(){}var y=CKEDITOR.tools.cssLength,
U,u,V=!1,D=!CKEDITOR.env.ie||CKEDITOR.env.edge,aa='\x3cdiv class\x3d"cke_reset_all cke_dialog_container {editorId} {editorDialogClass} {hidpi}" dir\x3d"{langDir}" style\x3d"'+(D?"display:flex":"")+'" lang\x3d"{langCode}" role\x3d"dialog" aria-labelledby\x3d"cke_dialog_title_{id}"\x3e\x3ctable class\x3d"cke_dialog '+CKEDITOR.env.cssClass+' cke_{langDir}" style\x3d"'+(D?"margin:auto":"position:absolute")+'" role\x3d"presentation"\x3e\x3ctr\x3e\x3ctd role\x3d"presentation"\x3e\x3cdiv class\x3d"cke_dialog_body" role\x3d"presentation"\x3e\x3cdiv id\x3d"cke_dialog_title_{id}" class\x3d"cke_dialog_title" role\x3d"presentation"\x3e\x3c/div\x3e\x3ca id\x3d"cke_dialog_close_button_{id}" class\x3d"cke_dialog_close_button" href\x3d"javascript:void(0)" title\x3d"{closeTitle}" role\x3d"button"\x3e\x3cspan class\x3d"cke_label"\x3eX\x3c/span\x3e\x3c/a\x3e\x3cdiv id\x3d"cke_dialog_tabs_{id}" class\x3d"cke_dialog_tabs" role\x3d"tablist"\x3e\x3c/div\x3e\x3ctable class\x3d"cke_dialog_contents" role\x3d"presentation"\x3e\x3ctr\x3e\x3ctd id\x3d"cke_dialog_contents_{id}" class\x3d"cke_dialog_contents_body" role\x3d"presentation"\x3e\x3c/td\x3e\x3c/tr\x3e\x3ctr\x3e\x3ctd id\x3d"cke_dialog_footer_{id}" class\x3d"cke_dialog_footer" role\x3d"presentation"\x3e\x3c/td\x3e\x3c/tr\x3e\x3c/table\x3e\x3c/div\x3e\x3c/td\x3e\x3c/tr\x3e\x3c/table\x3e\x3c/div\x3e';
CKEDITOR.dialog=function(a,b){function c(){var a=n._.focusList;a.sort(function(a,b){return a.tabIndex!=b.tabIndex?b.tabIndex-a.tabIndex:a.focusIndex-b.focusIndex});for(var b=a.length,c=0;c<b;c++)a[c].focusIndex=c}function e(a){var b=n._.focusList;a=a||0;if(!(1>b.length)){var c=n._.currentFocusIndex;n._.tabBarMode&&0>a&&(c=0);try{b[c].getInputElement().$.blur()}catch(d){}var e=c,g=1<n._.pageCount;do{e+=a;if(g&&!n._.tabBarMode&&(e==b.length||-1==e)){n._.tabBarMode=!0;n._.tabs[n._.currentTabId][0].focus();
n._.currentFocusIndex=-1;return}e=(e+b.length)%b.length;if(e==c)break}while(a&&!b[e].isFocusable());b[e].focus();"text"==b[e].type&&b[e].select()}}function d(b){if(n==CKEDITOR.dialog._.currentTop){var c=b.data.getKeystroke(),d="rtl"==a.lang.dir,g=[37,38,39,40];q=l=0;if(9==c||c==CKEDITOR.SHIFT+9)e(c==CKEDITOR.SHIFT+9?-1:1),q=1;else if(c==CKEDITOR.ALT+121&&!n._.tabBarMode&&1<n.getPageCount())I(n),q=1;else if(-1!=CKEDITOR.tools.indexOf(g,c)&&n._.tabBarMode)c=-1!=CKEDITOR.tools.indexOf([d?39:37,38],c)?
J.call(n):W.call(n),n.selectPage(c),n._.tabs[c][0].focus(),q=1;else if(13!=c&&32!=c||!n._.tabBarMode)if(13==c)c=b.data.getTarget(),c.is("a","button","select","textarea")||c.is("input")&&"button"==c.$.type||((c=this.getButton("ok"))&&CKEDITOR.tools.setTimeout(c.click,0,c),q=1),l=1;else if(27==c)(c=this.getButton("cancel"))?CKEDITOR.tools.setTimeout(c.click,0,c):!1!==this.fire("cancel",{hide:!0}).hide&&this.hide(),l=1;else return;else this.selectPage(this._.currentTabId),this._.tabBarMode=!1,this._.currentFocusIndex=
-1,e(1),q=1;f(b)}}function f(a){q?a.data.preventDefault(1):l&&a.data.stopPropagation()}var g=CKEDITOR.dialog._.dialogDefinitions[b],h=CKEDITOR.tools.clone(U),p=a.config.dialog_buttonsOrder||"OS",m=a.lang.dir,k={},q,l;("OS"==p&&CKEDITOR.env.mac||"rtl"==p&&"ltr"==m||"ltr"==p&&"rtl"==m)&&h.buttons.reverse();g=CKEDITOR.tools.extend(g(a),h);g=CKEDITOR.tools.clone(g);g=new M(this,g);h=Z(a);this._={editor:a,element:h.element,name:b,model:null,contentSize:{width:0,height:0},size:{width:0,height:0},contents:{},
buttons:{},accessKeyMap:{},viewportRatio:{width:.5,height:.5},tabs:{},tabIdList:[],currentTabId:null,currentTabIndex:null,pageCount:0,lastTab:null,tabBarMode:!1,focusList:[],currentFocusIndex:0,hasFocus:!1};this.parts=h.parts;CKEDITOR.tools.setTimeout(function(){a.fire("ariaWidget",this.parts.contents)},0,this);h={top:0,visibility:"hidden"};CKEDITOR.env.ie6Compat&&(h.position="absolute");h["rtl"==m?"right":"left"]=0;this.parts.dialog.setStyles(h);CKEDITOR.event.call(this);this.definition=g=CKEDITOR.fire("dialogDefinition",
{name:b,definition:g,dialog:this},a).definition;if(!("removeDialogTabs"in a._)&&a.config.removeDialogTabs){h=a.config.removeDialogTabs.split(";");for(m=0;m<h.length;m++)if(p=h[m].split(":"),2==p.length){var r=p[0];k[r]||(k[r]=[]);k[r].push(p[1])}a._.removeDialogTabs=k}if(a._.removeDialogTabs&&(k=a._.removeDialogTabs[b]))for(m=0;m<k.length;m++)g.removeContents(k[m]);if(g.onLoad)this.on("load",g.onLoad);if(g.onShow)this.on("show",g.onShow);if(g.onHide)this.on("hide",g.onHide);if(g.onOk)this.on("ok",
function(b){a.fire("saveSnapshot");setTimeout(function(){a.fire("saveSnapshot")},0);!1===g.onOk.call(this,b)&&(b.data.hide=!1)});this.state=CKEDITOR.DIALOG_STATE_IDLE;if(g.onCancel)this.on("cancel",function(a){!1===g.onCancel.call(this,a)&&(a.data.hide=!1)});var n=this,t=function(a){var b=n._.contents,c=!1,d;for(d in b)for(var e in b[d])if(c=a.call(this,b[d][e]))return};this.on("ok",function(a){t(function(b){if(b.validate){var c=b.validate(this),d="string"==typeof c||!1===c;d&&(a.data.hide=!1,a.stop());
X.call(b,!d,"string"==typeof c?c:void 0);return d}})},this,null,0);this.on("cancel",function(b){t(function(c){if(c.isChanged())return a.config.dialog_noConfirmCancel||confirm(a.lang.common.confirmCancel)||(b.data.hide=!1),!0})},this,null,0);this.parts.close.on("click",function(a){!1!==this.fire("cancel",{hide:!0}).hide&&this.hide();a.data.preventDefault()},this);this.changeFocus=e;var z=this._.element;a.focusManager.add(z,1);this.on("show",function(){z.on("keydown",d,this);if(CKEDITOR.env.gecko)z.on("keypress",
f,this)});this.on("hide",function(){z.removeListener("keydown",d);CKEDITOR.env.gecko&&z.removeListener("keypress",f);t(function(a){Y.apply(a)})});this.on("iframeAdded",function(a){(new CKEDITOR.dom.document(a.data.iframe.$.contentWindow.document)).on("keydown",d,this,null,0)});this.on("show",function(){c();var b=1<n._.pageCount;a.config.dialog_startupFocusTab&&b?(n._.tabBarMode=!0,n._.tabs[n._.currentTabId][0].focus(),n._.currentFocusIndex=-1):this._.hasFocus||(this._.currentFocusIndex=b?-1:this._.focusList.length-
1,g.onFocus?(b=g.onFocus.call(this))&&b.focus():e(1))},this,null,4294967295);if(CKEDITOR.env.ie6Compat)this.on("load",function(){var a=this.getElement(),b=a.getFirst();b.remove();b.appendTo(a)},this);ca(this);da(this);(new CKEDITOR.dom.text(g.title,CKEDITOR.document)).appendTo(this.parts.title);for(m=0;m<g.contents.length;m++)(k=g.contents[m])&&this.addPage(k);this.parts.tabs.on("click",function(a){var b=a.data.getTarget();b.hasClass("cke_dialog_tab")&&(b=b.$.id,this.selectPage(b.substring(4,b.lastIndexOf("_"))),
I(this),a.data.preventDefault())},this);m=[];k=CKEDITOR.dialog._.uiElementBuilders.hbox.build(this,{type:"hbox",className:"cke_dialog_footer_buttons",widths:[],children:g.buttons},m).getChild();this.parts.footer.setHtml(m.join(""));for(m=0;m<k.length;m++)this._.buttons[k[m].id]=k[m]};CKEDITOR.dialog.prototype={destroy:function(){this.hide();this._.element.remove()},resize:function(a,b){if(!this._.contentSize||this._.contentSize.width!=a||this._.contentSize.height!=b){CKEDITOR.dialog.fire("resize",
{dialog:this,width:a,height:b},this._.editor);this.fire("resize",{width:a,height:b},this._.editor);this.parts.contents.setStyles({width:a+"px",height:b+"px"});if("rtl"==this._.editor.lang.dir&&this._.position){var c=this.parts.dialog.getParent().getClientSize().width;this._.position.x=c-this._.contentSize.width-parseInt(this._.element.getFirst().getStyle("right"),10)}this._.contentSize={width:a,height:b}}},getSize:function(){var a=this._.element.getFirst();return{width:a.$.offsetWidth||0,height:a.$.offsetHeight||
0}},move:function(a,b,c){var e=this._.element.getFirst(),d="rtl"==this._.editor.lang.dir;CKEDITOR.env.ie&&e.setStyle("zoom","100%");var f=this.parts.dialog.getParent().getClientSize(),g=this.getSize(),h=this._.viewportRatio,p=Math.max(f.width-g.width,0),f=Math.max(f.height-g.height,0);this._.position&&this._.position.x==a&&this._.position.y==b?(a=Math.floor(p*h.width),b=Math.floor(f*h.height)):O(this,a,b);this._.position={x:a,y:b};d&&(a=p-a);b={top:(0<b?b:0)+"px"};b[d?"right":"left"]=(0<a?a:0)+"px";
e.setStyles(b);c&&(this._.moved=1)},getPosition:function(){return CKEDITOR.tools.extend({},this._.position)},show:function(){var a=this._.element,b=this.definition,c=CKEDITOR.document.getBody(),e=this._.editor.config.baseFloatZIndex;a.getParent()&&a.getParent().equals(c)?a.setStyle("display",D?"flex":"block"):a.appendTo(c);this.resize(this._.contentSize&&this._.contentSize.width||b.width||b.minWidth,this._.contentSize&&this._.contentSize.height||b.height||b.minHeight);this.reset();null===this._.currentTabId&&
this.selectPage(this.definition.contents[0].id);null===CKEDITOR.dialog._.currentZIndex&&(CKEDITOR.dialog._.currentZIndex=e);this._.element.getFirst().setStyle("z-index",CKEDITOR.dialog._.currentZIndex+=10);this.getElement().setStyle("z-index",CKEDITOR.dialog._.currentZIndex);null===CKEDITOR.dialog._.currentTop?(CKEDITOR.dialog._.currentTop=this,this._.parentDialog=null,P(this._.editor)):(this._.parentDialog=CKEDITOR.dialog._.currentTop,c=this._.parentDialog.getElement().getFirst(),c.$.style.zIndex-=
Math.floor(e/2),this._.parentDialog.getElement().setStyle("z-index",c.$.style.zIndex),CKEDITOR.dialog._.currentTop=this);a.on("keydown",R);a.on("keyup",S);this._.hasFocus=!1;for(var d in b.contents)if(b.contents[d]){var a=b.contents[d],e=this._.tabs[a.id],c=a.requiredContent,f=0;if(e){for(var g in this._.contents[a.id]){var h=this._.contents[a.id][g];"hbox"!=h.type&&"vbox"!=h.type&&h.getInputElement()&&(h.requiredContent&&!this._.editor.activeFilter.check(h.requiredContent)?h.disable():(h.enable(),
f++))}!f||c&&!this._.editor.activeFilter.check(c)?e[0].addClass("cke_dialog_tab_disabled"):e[0].removeClass("cke_dialog_tab_disabled")}}CKEDITOR.tools.setTimeout(function(){this.layout();ba(this);this.parts.dialog.setStyle("visibility","");this.fireOnce("load",{});CKEDITOR.ui.fire("ready",this);this.fire("show",{});this._.editor.fire("dialogShow",this);this._.parentDialog||this._.editor.focusManager.lock();this.foreach(function(a){a.setInitValue&&a.setInitValue()})},100,this)},layout:function(){var a=
this.parts.dialog;if(this._.moved||!D){var b=this.getSize(),c=CKEDITOR.document.getWindow().getViewPaneSize(),e;this._.moved&&this._.position?(e=this._.position.x,b=this._.position.y):(e=(c.width-b.width)/2,b=(c.height-b.height)/2);CKEDITOR.env.ie6Compat||(a.setStyle("position","absolute"),a.removeStyle("margin"));e=Math.floor(e);b=Math.floor(b);this.move(e,b)}},foreach:function(a){for(var b in this._.contents)for(var c in this._.contents[b])a.call(this,this._.contents[b][c]);return this},reset:function(){var a=
function(a){a.reset&&a.reset(1)};return function(){this.foreach(a);return this}}(),setupContent:function(){var a=arguments;this.foreach(function(b){b.setup&&b.setup.apply(b,a)})},commitContent:function(){var a=arguments;this.foreach(function(b){CKEDITOR.env.ie&&this._.currentFocusIndex==b.focusIndex&&b.getInputElement().$.blur();b.commit&&b.commit.apply(b,a)})},hide:function(){if(this.parts.dialog.isVisible()){this.fire("hide",{});this._.editor.fire("dialogHide",this);this.selectPage(this._.tabIdList[0]);
var a=this._.element;a.setStyle("display","none");this.parts.dialog.setStyle("visibility","hidden");for(ea(this);CKEDITOR.dialog._.currentTop!=this;)CKEDITOR.dialog._.currentTop.hide();if(this._.parentDialog){var b=this._.parentDialog.getElement().getFirst();this._.parentDialog.getElement().removeStyle("z-index");b.setStyle("z-index",parseInt(b.$.style.zIndex,10)+Math.floor(this._.editor.config.baseFloatZIndex/2))}else Q(this._.editor);if(CKEDITOR.dialog._.currentTop=this._.parentDialog)CKEDITOR.dialog._.currentZIndex-=
10;else{CKEDITOR.dialog._.currentZIndex=null;a.removeListener("keydown",R);a.removeListener("keyup",S);var c=this._.editor;c.focus();setTimeout(function(){c.focusManager.unlock();CKEDITOR.env.iOS&&c.window.focus()},0)}delete this._.parentDialog;this.foreach(function(a){a.resetInitValue&&a.resetInitValue()});this.setState(CKEDITOR.DIALOG_STATE_IDLE)}},addPage:function(a){if(!a.requiredContent||this._.editor.filter.check(a.requiredContent)){for(var b=[],c=a.label?' title\x3d"'+CKEDITOR.tools.htmlEncode(a.label)+
'"':"",e=CKEDITOR.dialog._.uiElementBuilders.vbox.build(this,{type:"vbox",className:"cke_dialog_page_contents",children:a.elements,expand:!!a.expand,padding:a.padding,style:a.style||"width: 100%;"},b),d=this._.contents[a.id]={},f=e.getChild(),g=0;e=f.shift();)e.notAllowed||"hbox"==e.type||"vbox"==e.type||g++,d[e.id]=e,"function"==typeof e.getChild&&f.push.apply(f,e.getChild());g||(a.hidden=!0);b=CKEDITOR.dom.element.createFromHtml(b.join(""));b.setAttribute("role","tabpanel");b.setStyle("min-height",
"100%");e=CKEDITOR.env;d="cke_"+a.id+"_"+CKEDITOR.tools.getNextNumber();c=CKEDITOR.dom.element.createFromHtml(['\x3ca class\x3d"cke_dialog_tab"',0<this._.pageCount?" cke_last":"cke_first",c,a.hidden?' style\x3d"display:none"':"",' id\x3d"',d,'"',e.gecko&&!e.hc?"":' href\x3d"javascript:void(0)"',' tabIndex\x3d"-1" hidefocus\x3d"true" role\x3d"tab"\x3e',a.label,"\x3c/a\x3e"].join(""));b.setAttribute("aria-labelledby",d);this._.tabs[a.id]=[c,b];this._.tabIdList.push(a.id);!a.hidden&&this._.pageCount++;
this._.lastTab=c;this.updateStyle();b.setAttribute("name",a.id);b.appendTo(this.parts.contents);c.unselectable();this.parts.tabs.append(c);a.accessKey&&(T(this,this,"CTRL+"+a.accessKey,ga,fa),this._.accessKeyMap["CTRL+"+a.accessKey]=a.id)}},selectPage:function(a){if(this._.currentTabId!=a&&!this._.tabs[a][0].hasClass("cke_dialog_tab_disabled")&&!1!==this.fire("selectPage",{page:a,currentPage:this._.currentTabId})){for(var b in this._.tabs){var c=this._.tabs[b][0],e=this._.tabs[b][1];b!=a&&(c.removeClass("cke_dialog_tab_selected"),
c.removeAttribute("aria-selected"),e.hide());e.setAttribute("aria-hidden",b!=a)}var d=this._.tabs[a];d[0].addClass("cke_dialog_tab_selected");d[0].setAttribute("aria-selected",!0);CKEDITOR.env.ie6Compat||CKEDITOR.env.ie7Compat?(K(d[1]),d[1].show(),setTimeout(function(){K(d[1],1)},0)):d[1].show();this._.currentTabId=a;this._.currentTabIndex=CKEDITOR.tools.indexOf(this._.tabIdList,a)}},updateStyle:function(){this.parts.dialog[(1===this._.pageCount?"add":"remove")+"Class"]("cke_single_page")},hidePage:function(a){var b=
this._.tabs[a]&&this._.tabs[a][0];b&&1!=this._.pageCount&&b.isVisible()&&(a==this._.currentTabId&&this.selectPage(J.call(this)),b.hide(),this._.pageCount--,this.updateStyle())},showPage:function(a){if(a=this._.tabs[a]&&this._.tabs[a][0])a.show(),this._.pageCount++,this.updateStyle()},getElement:function(){return this._.element},getName:function(){return this._.name},getContentElement:function(a,b){var c=this._.contents[a];return c&&c[b]},getValueOf:function(a,b){return this.getContentElement(a,b).getValue()},
setValueOf:function(a,b,c){return this.getContentElement(a,b).setValue(c)},getButton:function(a){return this._.buttons[a]},click:function(a){return this._.buttons[a].click()},disableButton:function(a){return this._.buttons[a].disable()},enableButton:function(a){return this._.buttons[a].enable()},getPageCount:function(){return this._.pageCount},getParentEditor:function(){return this._.editor},getSelectedElement:function(){return this.getParentEditor().getSelection().getSelectedElement()},addFocusable:function(a,
b){if("undefined"==typeof b)b=this._.focusList.length,this._.focusList.push(new L(this,a,b));else{this._.focusList.splice(b,0,new L(this,a,b));for(var c=b+1;c<this._.focusList.length;c++)this._.focusList[c].focusIndex++}},setState:function(a){if(this.state!=a){this.state=a;if(a==CKEDITOR.DIALOG_STATE_BUSY){if(!this.parts.spinner){var b=this.getParentEditor().lang.dir,c={attributes:{"class":"cke_dialog_spinner"},styles:{"float":"rtl"==b?"right":"left"}};c.styles["margin-"+("rtl"==b?"left":"right")]=
"8px";this.parts.spinner=CKEDITOR.document.createElement("div",c);this.parts.spinner.setHtml("\x26#8987;");this.parts.spinner.appendTo(this.parts.title,1)}this.parts.spinner.show();this.getButton("ok").disable()}else a==CKEDITOR.DIALOG_STATE_IDLE&&(this.parts.spinner&&this.parts.spinner.hide(),this.getButton("ok").enable());this.fire("state",a)}},getModel:function(a){return this._.model?this._.model:this.definition.getModel?this.definition.getModel(a):null},setModel:function(a){this._.model=a},getMode:function(a){if(this.definition.getMode)return this.definition.getMode(a);
a=this.getModel(a);return!a||a instanceof CKEDITOR.dom.element&&!a.getParent()?CKEDITOR.dialog.CREATION_MODE:CKEDITOR.dialog.EDITING_MODE}};CKEDITOR.tools.extend(CKEDITOR.dialog,{CREATION_MODE:0,EDITING_MODE:1,add:function(a,b){this._.dialogDefinitions[a]&&"function"!=typeof b||(this._.dialogDefinitions[a]=b)},exists:function(a){return!!this._.dialogDefinitions[a]},getCurrent:function(){return CKEDITOR.dialog._.currentTop},isTabEnabled:function(a,b,c){a=a.config.removeDialogTabs;return!(a&&a.match(new RegExp("(?:^|;)"+
b+":"+c+"(?:$|;)","i")))},okButton:function(){var a=function(a,c){c=c||{};return CKEDITOR.tools.extend({id:"ok",type:"button",label:a.lang.common.ok,"class":"cke_dialog_ui_button_ok",onClick:function(a){a=a.data.dialog;!1!==a.fire("ok",{hide:!0}).hide&&a.hide()}},c,!0)};a.type="button";a.override=function(b){return CKEDITOR.tools.extend(function(c){return a(c,b)},{type:"button"},!0)};return a}(),cancelButton:function(){var a=function(a,c){c=c||{};return CKEDITOR.tools.extend({id:"cancel",type:"button",
label:a.lang.common.cancel,"class":"cke_dialog_ui_button_cancel",onClick:function(a){a=a.data.dialog;!1!==a.fire("cancel",{hide:!0}).hide&&a.hide()}},c,!0)};a.type="button";a.override=function(b){return CKEDITOR.tools.extend(function(c){return a(c,b)},{type:"button"},!0)};return a}(),addUIElement:function(a,b){this._.uiElementBuilders[a]=b}});CKEDITOR.dialog._={uiElementBuilders:{},dialogDefinitions:{},currentTop:null,currentZIndex:null};CKEDITOR.event.implementOn(CKEDITOR.dialog);CKEDITOR.event.implementOn(CKEDITOR.dialog.prototype);
U={resizable:CKEDITOR.DIALOG_RESIZE_BOTH,minWidth:600,minHeight:400,buttons:[CKEDITOR.dialog.okButton,CKEDITOR.dialog.cancelButton]};var E=function(a,b,c){for(var e=0,d;d=a[e];e++)if(d.id==b||c&&d[c]&&(d=E(d[c],b,c)))return d;return null},F=function(a,b,c,e,d){if(c){for(var f=0,g;g=a[f];f++){if(g.id==c)return a.splice(f,0,b),b;if(e&&g[e]&&(g=F(g[e],b,c,e,!0)))return g}if(d)return null}a.push(b);return b},G=function(a,b,c){for(var e=0,d;d=a[e];e++){if(d.id==b)return a.splice(e,1);if(c&&d[c]&&(d=G(d[c],
b,c)))return d}return null};M.prototype={getContents:function(a){return E(this.contents,a)},getButton:function(a){return E(this.buttons,a)},addContents:function(a,b){return F(this.contents,a,b)},addButton:function(a,b){return F(this.buttons,a,b)},removeContents:function(a){G(this.contents,a)},removeButton:function(a){G(this.buttons,a)}};N.prototype={get:function(a){return E(this.elements,a,"children")},add:function(a,b){return F(this.elements,a,b,"children")},remove:function(a){G(this.elements,a,
"children")}};var B={},x={};(function(){CKEDITOR.ui.dialog={uiElement:function(a,b,c,e,d,f,g){if(!(4>arguments.length)){var h=(e.call?e(b):e)||"div",p=["\x3c",h," "],m=(d&&d.call?d(b):d)||{},k=(f&&f.call?f(b):f)||{},q=(g&&g.call?g.call(this,a,b):g)||"",l=this.domId=k.id||CKEDITOR.tools.getNextId()+"_uiElement";b.requiredContent&&!a.getParentEditor().filter.check(b.requiredContent)&&(m.display="none",this.notAllowed=!0);k.id=l;var r={};b.type&&(r["cke_dialog_ui_"+b.type]=1);b.className&&(r[b.className]=
1);b.disabled&&(r.cke_disabled=1);for(var n=k["class"]&&k["class"].split?k["class"].split(" "):[],l=0;l<n.length;l++)n[l]&&(r[n[l]]=1);n=[];for(l in r)n.push(l);k["class"]=n.join(" ");b.title&&(k.title=b.title);r=(b.style||"").split(";");b.align&&(n=b.align,m["margin-left"]="left"==n?0:"auto",m["margin-right"]="right"==n?0:"auto");for(l in m)r.push(l+":"+m[l]);b.hidden&&r.push("display:none");for(l=r.length-1;0<=l;l--)""===r[l]&&r.splice(l,1);0<r.length&&(k.style=(k.style?k.style+"; ":"")+r.join("; "));
for(l in k)p.push(l+'\x3d"'+CKEDITOR.tools.htmlEncode(k[l])+'" ');p.push("\x3e",q,"\x3c/",h,"\x3e");c.push(p.join(""));(this._||(this._={})).dialog=a;"boolean"==typeof b.isChanged&&(this.isChanged=function(){return b.isChanged});"function"==typeof b.isChanged&&(this.isChanged=b.isChanged);"function"==typeof b.setValue&&(this.setValue=CKEDITOR.tools.override(this.setValue,function(a){return function(c){a.call(this,b.setValue.call(this,c))}}));"function"==typeof b.getValue&&(this.getValue=CKEDITOR.tools.override(this.getValue,
function(a){return function(){return b.getValue.call(this,a.call(this))}}));CKEDITOR.event.implementOn(this);this.registerEvents(b);this.accessKeyUp&&this.accessKeyDown&&b.accessKey&&T(this,a,"CTRL+"+b.accessKey);var t=this;a.on("load",function(){var b=t.getInputElement();if(b){var c=t.type in{checkbox:1,ratio:1}&&CKEDITOR.env.ie&&8>CKEDITOR.env.version?"cke_dialog_ui_focused":"";b.on("focus",function(){a._.tabBarMode=!1;a._.hasFocus=!0;t.fire("focus");c&&this.addClass(c)});b.on("blur",function(){t.fire("blur");
c&&this.removeClass(c)})}});CKEDITOR.tools.extend(this,b);this.keyboardFocusable&&(this.tabIndex=b.tabIndex||0,this.focusIndex=a._.focusList.push(this)-1,this.on("focus",function(){a._.currentFocusIndex=t.focusIndex}))}},hbox:function(a,b,c,e,d){if(!(4>arguments.length)){this._||(this._={});var f=this._.children=b,g=d&&d.widths||null,h=d&&d.height||null,p,m={role:"presentation"};d&&d.align&&(m.align=d.align);CKEDITOR.ui.dialog.uiElement.call(this,a,d||{type:"hbox"},e,"table",{},m,function(){var a=
['\x3ctbody\x3e\x3ctr class\x3d"cke_dialog_ui_hbox"\x3e'];for(p=0;p<c.length;p++){var b="cke_dialog_ui_hbox_child",e=[];0===p&&(b="cke_dialog_ui_hbox_first");p==c.length-1&&(b="cke_dialog_ui_hbox_last");a.push('\x3ctd class\x3d"',b,'" role\x3d"presentation" ');g?g[p]&&e.push("width:"+y(g[p])):e.push("width:"+Math.floor(100/c.length)+"%");h&&e.push("height:"+y(h));d&&void 0!==d.padding&&e.push("padding:"+y(d.padding));CKEDITOR.env.ie&&CKEDITOR.env.quirks&&f[p].align&&e.push("text-align:"+f[p].align);
0<e.length&&a.push('style\x3d"'+e.join("; ")+'" ');a.push("\x3e",c[p],"\x3c/td\x3e")}a.push("\x3c/tr\x3e\x3c/tbody\x3e");return a.join("")})}},vbox:function(a,b,c,e,d){if(!(3>arguments.length)){this._||(this._={});var f=this._.children=b,g=d&&d.width||null,h=d&&d.heights||null;CKEDITOR.ui.dialog.uiElement.call(this,a,d||{type:"vbox"},e,"div",null,{role:"presentation"},function(){var b=['\x3ctable role\x3d"presentation" cellspacing\x3d"0" border\x3d"0" '];b.push('style\x3d"');d&&d.expand&&b.push("height:100%;");
b.push("width:"+y(g||"100%"),";");CKEDITOR.env.webkit&&b.push("float:none;");b.push('"');b.push('align\x3d"',CKEDITOR.tools.htmlEncode(d&&d.align||("ltr"==a.getParentEditor().lang.dir?"left":"right")),'" ');b.push("\x3e\x3ctbody\x3e");for(var e=0;e<c.length;e++){var k=[];b.push('\x3ctr\x3e\x3ctd role\x3d"presentation" ');g&&k.push("width:"+y(g||"100%"));h?k.push("height:"+y(h[e])):d&&d.expand&&k.push("height:"+Math.floor(100/c.length)+"%");d&&void 0!==d.padding&&k.push("padding:"+y(d.padding));CKEDITOR.env.ie&&
CKEDITOR.env.quirks&&f[e].align&&k.push("text-align:"+f[e].align);0<k.length&&b.push('style\x3d"',k.join("; "),'" ');b.push(' class\x3d"cke_dialog_ui_vbox_child"\x3e',c[e],"\x3c/td\x3e\x3c/tr\x3e")}b.push("\x3c/tbody\x3e\x3c/table\x3e");return b.join("")})}}}})();CKEDITOR.ui.dialog.uiElement.prototype={getElement:function(){return CKEDITOR.document.getById(this.domId)},getInputElement:function(){return this.getElement()},getDialog:function(){return this._.dialog},setValue:function(a,b){this.getInputElement().setValue(a);
!b&&this.fire("change",{value:a});return this},getValue:function(){return this.getInputElement().getValue()},isChanged:function(){return!1},selectParentTab:function(){for(var a=this.getInputElement();(a=a.getParent())&&-1==a.$.className.search("cke_dialog_page_contents"););if(!a)return this;a=a.getAttribute("name");this._.dialog._.currentTabId!=a&&this._.dialog.selectPage(a);return this},focus:function(){this.selectParentTab().getInputElement().focus();return this},registerEvents:function(a){var b=
/^on([A-Z]\w+)/,c,e=function(a,b,c,d){b.on("load",function(){a.getInputElement().on(c,d,a)})},d;for(d in a)if(c=d.match(b))this.eventProcessors[d]?this.eventProcessors[d].call(this,this._.dialog,a[d]):e(this,this._.dialog,c[1].toLowerCase(),a[d]);return this},eventProcessors:{onLoad:function(a,b){a.on("load",b,this)},onShow:function(a,b){a.on("show",b,this)},onHide:function(a,b){a.on("hide",b,this)}},accessKeyDown:function(){this.focus()},accessKeyUp:function(){},disable:function(){var a=this.getElement();
this.getInputElement().setAttribute("disabled","true");a.addClass("cke_disabled")},enable:function(){var a=this.getElement();this.getInputElement().removeAttribute("disabled");a.removeClass("cke_disabled")},isEnabled:function(){return!this.getElement().hasClass("cke_disabled")},isVisible:function(){return this.getInputElement().isVisible()},isFocusable:function(){return this.isEnabled()&&this.isVisible()?!0:!1}};CKEDITOR.ui.dialog.hbox.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.uiElement,
{getChild:function(a){if(1>arguments.length)return this._.children.concat();a.splice||(a=[a]);return 2>a.length?this._.children[a[0]]:this._.children[a[0]]&&this._.children[a[0]].getChild?this._.children[a[0]].getChild(a.slice(1,a.length)):null}},!0);CKEDITOR.ui.dialog.vbox.prototype=new CKEDITOR.ui.dialog.hbox;(function(){var a={build:function(a,c,e){for(var d=c.children,f,g=[],h=[],p=0;p<d.length&&(f=d[p]);p++){var m=[];g.push(m);h.push(CKEDITOR.dialog._.uiElementBuilders[f.type].build(a,f,m))}return new CKEDITOR.ui.dialog[c.type](a,
h,g,e,c)}};CKEDITOR.dialog.addUIElement("hbox",a);CKEDITOR.dialog.addUIElement("vbox",a)})();CKEDITOR.dialogCommand=function(a,b){this.dialogName=a;CKEDITOR.tools.extend(this,b,!0)};CKEDITOR.dialogCommand.prototype={exec:function(a){var b=this.tabId;a.openDialog(this.dialogName,function(a){b&&a.selectPage(b)})},canUndo:!1,editorFocus:1};(function(){var a=/^([a]|[^a])+$/,b=/^\d*$/,c=/^\d*(?:\.\d+)?$/,e=/^(((\d*(\.\d+))|(\d*))(px|\%)?)?$/,d=/^(((\d*(\.\d+))|(\d*))(px|em|ex|in|cm|mm|pt|pc|\%)?)?$/i,
f=/^(--|-?([a-zA-Z_]|\\))(\\|[a-zA-Z0-9-_])*\s*?:\s*?[^:;]+$/;CKEDITOR.VALIDATE_OR=1;CKEDITOR.VALIDATE_AND=2;CKEDITOR.dialog.validate={functions:function(){var a=arguments;return function(){var b=this&&this.getValue?this.getValue():a[0],c,d=CKEDITOR.VALIDATE_AND,e=[],f;for(f=0;f<a.length;f++)if("function"==typeof a[f])e.push(a[f]);else break;f<a.length&&"string"==typeof a[f]&&(c=a[f],f++);f<a.length&&"number"==typeof a[f]&&(d=a[f]);var l=d==CKEDITOR.VALIDATE_AND?!0:!1;for(f=0;f<e.length;f++)l=d==
CKEDITOR.VALIDATE_AND?l&&e[f](b):l||e[f](b);return l?!0:c}},regex:function(a,b){return function(c){c=this&&this.getValue?this.getValue():c;return a.test(c)?!0:b}},notEmpty:function(b){return this.regex(a,b)},integer:function(a){return this.regex(b,a)},number:function(a){return this.regex(c,a)},cssLength:function(a){return this.functions(function(a){return d.test(CKEDITOR.tools.trim(a))},a)},htmlLength:function(a){return this.functions(function(a){return e.test(CKEDITOR.tools.trim(a))},a)},inlineStyle:function(a){return this.functions(function(a){a=
CKEDITOR.tools.trim(a).split(";");""===a[a.length-1]&&a.pop();return CKEDITOR.tools.array.every(a,function(a){return f.test(CKEDITOR.tools.trim(a))})},a)},equals:function(a,b){return this.functions(function(b){return b==a},b)},notEqual:function(a,b){return this.functions(function(b){return b!=a},b)}};CKEDITOR.on("instanceDestroyed",function(a){if(CKEDITOR.tools.isEmpty(CKEDITOR.instances)){for(var b;b=CKEDITOR.dialog._.currentTop;)b.hide();for(var c in B)B[c].remove();B={}}a=a.editor._.storedDialogs;
for(var d in a)a[d].destroy()})})();CKEDITOR.tools.extend(CKEDITOR.editor.prototype,{openDialog:function(a,b,c){var e=null,d=CKEDITOR.dialog._.dialogDefinitions[a];null===CKEDITOR.dialog._.currentTop&&P(this);if("function"==typeof d)d=this._.storedDialogs||(this._.storedDialogs={}),e=d[a]||(d[a]=new CKEDITOR.dialog(this,a)),e.setModel(c),b&&b.call(e,e),e.show();else{if("failed"==d)throw Q(this),Error('[CKEDITOR.dialog.openDialog] Dialog "'+a+'" failed when loading definition.');"string"==typeof d&&
CKEDITOR.scriptLoader.load(CKEDITOR.getUrl(d),function(){"function"!=typeof CKEDITOR.dialog._.dialogDefinitions[a]&&(CKEDITOR.dialog._.dialogDefinitions[a]="failed");this.openDialog(a,b,c)},this,0,1)}CKEDITOR.skin.loadPart("dialog");if(e)e.once("hide",function(){e.setModel(null)},null,null,999);return e}});CKEDITOR.plugins.add("dialog",{requires:"dialogui",init:function(a){V||(CKEDITOR.document.appendStyleSheet(this.path+"styles/dialog.css"),V=!0);a.on("doubleclick",function(b){b.data.dialog&&a.openDialog(b.data.dialog)},
null,null,999)}})})();CKEDITOR.plugins.add("about",{requires:"dialog",init:function(a){var b=a.addCommand("about",new CKEDITOR.dialogCommand("about"));b.modes={wysiwyg:1,source:1};b.canUndo=!1;b.readOnly=1;a.ui.addButton&&a.ui.addButton("About",{label:a.lang.about.dlgTitle,command:"about",toolbar:"about"});CKEDITOR.dialog.add("about",this.path+"dialogs/about.js")}});(function(){CKEDITOR.plugins.add("a11yhelp",{requires:"dialog",availableLangs:{af:1,ar:1,az:1,bg:1,ca:1,cs:1,cy:1,da:1,de:1,"de-ch":1,el:1,en:1,"en-au":1,"en-gb":1,eo:1,es:1,"es-mx":1,et:1,eu:1,fa:1,fi:1,fo:1,fr:1,"fr-ca":1,gl:1,gu:1,he:1,hi:1,hr:1,hu:1,id:1,it:1,ja:1,km:1,ko:1,ku:1,lt:1,lv:1,mk:1,mn:1,nb:1,nl:1,no:1,oc:1,pl:1,pt:1,"pt-br":1,ro:1,ru:1,si:1,sk:1,sl:1,sq:1,sr:1,"sr-latn":1,sv:1,th:1,tr:1,tt:1,ug:1,uk:1,vi:1,zh:1,"zh-cn":1},init:function(b){var c=this;b.addCommand("a11yHelp",{exec:function(){var a=
b.langCode,a=c.availableLangs[a]?a:c.availableLangs[a.replace(/-.*/,"")]?a.replace(/-.*/,""):"en";CKEDITOR.scriptLoader.load(CKEDITOR.getUrl(c.path+"dialogs/lang/"+a+".js"),function(){b.lang.a11yhelp=c.langEntries[a];b.openDialog("a11yHelp")})},modes:{wysiwyg:1,source:1},readOnly:1,canUndo:!1});b.setKeystroke(CKEDITOR.ALT+48,"a11yHelp");CKEDITOR.dialog.add("a11yHelp",this.path+"dialogs/a11yhelp.js");b.on("ariaEditorHelpLabel",function(a){a.data.label=b.lang.common.editorHelp})}})})();(function(){function f(c){var a=this.att;c=c&&c.hasAttribute(a)&&c.getAttribute(a)||"";void 0!==c&&this.setValue(c)}function g(){for(var c,a=0;a<arguments.length;a++)if(arguments[a]instanceof CKEDITOR.dom.element){c=arguments[a];break}if(c){var a=this.att,b=this.getValue();b?c.setAttribute(a,b):c.removeAttribute(a,b)}}var k={id:1,dir:1,classes:1,styles:1};CKEDITOR.plugins.add("dialogadvtab",{requires:"dialog",allowedContent:function(c){c||(c=k);var a=[];c.id&&a.push("id");c.dir&&a.push("dir");var b=
"";a.length&&(b+="["+a.join(",")+"]");c.classes&&(b+="(*)");c.styles&&(b+="{*}");return b},createAdvancedTab:function(c,a,b){a||(a=k);var d=c.lang.common,h={id:"advanced",label:d.advancedTab,title:d.advancedTab,elements:[{type:"vbox",padding:1,children:[]}]},e=[];if(a.id||a.dir)a.id&&e.push({id:"advId",att:"id",type:"text",requiredContent:b?b+"[id]":null,label:d.id,setup:f,commit:g}),a.dir&&e.push({id:"advLangDir",att:"dir",type:"select",requiredContent:b?b+"[dir]":null,label:d.langDir,"default":"",
style:"width:100%",items:[[d.notSet,""],[d.langDirLTR,"ltr"],[d.langDirRTL,"rtl"]],setup:f,commit:g}),h.elements[0].children.push({type:"hbox",widths:["50%","50%"],children:[].concat(e)});if(a.styles||a.classes)e=[],a.styles&&e.push({id:"advStyles",att:"style",type:"text",requiredContent:b?b+"{cke-xyz}":null,label:d.styles,"default":"",validate:CKEDITOR.dialog.validate.inlineStyle(d.invalidInlineStyle),onChange:function(){},getStyle:function(a,c){var b=this.getValue().match(new RegExp("(?:^|;)\\s*"+
a+"\\s*:\\s*([^;]*)","i"));return b?b[1]:c},updateStyle:function(a,b){var d=this.getValue(),e=c.document.createElement("span");e.setAttribute("style",d);e.setStyle(a,b);d=CKEDITOR.tools.normalizeCssText(e.getAttribute("style"));this.setValue(d,1)},setup:f,commit:g}),a.classes&&e.push({type:"hbox",widths:["45%","55%"],children:[{id:"advCSSClasses",att:"class",type:"text",requiredContent:b?b+"(cke-xyz)":null,label:d.cssClasses,"default":"",setup:f,commit:g}]}),h.elements[0].children.push({type:"hbox",
widths:["50%","50%"],children:[].concat(e)});return h}})})();CKEDITOR.plugins.add("basicstyles",{init:function(c){var e=0,d=function(g,d,b,a){if(a){a=new CKEDITOR.style(a);var f=h[b];f.unshift(a);c.attachStyleStateChange(a,function(a){!c.readOnly&&c.getCommand(b).setState(a)});c.addCommand(b,new CKEDITOR.styleCommand(a,{contentForms:f}));c.ui.addButton&&c.ui.addButton(g,{label:d,command:b,toolbar:"basicstyles,"+(e+=10)})}},h={bold:["strong","b",["span",function(a){a=a.styles["font-weight"];return"bold"==a||700<=+a}]],italic:["em","i",["span",function(a){return"italic"==
a.styles["font-style"]}]],underline:["u",["span",function(a){return"underline"==a.styles["text-decoration"]}]],strike:["s","strike",["span",function(a){return"line-through"==a.styles["text-decoration"]}]],subscript:["sub"],superscript:["sup"]},b=c.config,a=c.lang.basicstyles;d("Bold",a.bold,"bold",b.coreStyles_bold);d("Italic",a.italic,"italic",b.coreStyles_italic);d("Underline",a.underline,"underline",b.coreStyles_underline);d("Strike",a.strike,"strike",b.coreStyles_strike);d("Subscript",a.subscript,
"subscript",b.coreStyles_subscript);d("Superscript",a.superscript,"superscript",b.coreStyles_superscript);c.setKeystroke([[CKEDITOR.CTRL+66,"bold"],[CKEDITOR.CTRL+73,"italic"],[CKEDITOR.CTRL+85,"underline"]])}});CKEDITOR.config.coreStyles_bold={element:"strong",overrides:"b"};CKEDITOR.config.coreStyles_italic={element:"em",overrides:"i"};CKEDITOR.config.coreStyles_underline={element:"u"};CKEDITOR.config.coreStyles_strike={element:"s",overrides:"strike"};CKEDITOR.config.coreStyles_subscript={element:"sub"};
CKEDITOR.config.coreStyles_superscript={element:"sup"};(function(){function q(a,f,d,b){if(!a.isReadOnly()&&!a.equals(d.editable())){CKEDITOR.dom.element.setMarker(b,a,"bidi_processed",1);b=a;for(var c=d.editable();(b=b.getParent())&&!b.equals(c);)if(b.getCustomData("bidi_processed")){a.removeStyle("direction");a.removeAttribute("dir");return}b="useComputedState"in d.config?d.config.useComputedState:1;(b?a.getComputedStyle("direction"):a.getStyle("direction")||a.hasAttribute("dir"))!=f&&(a.removeStyle("direction"),b?(a.removeAttribute("dir"),f!=a.getComputedStyle("direction")&&
a.setAttribute("dir",f)):a.setAttribute("dir",f),d.forceNextSelectionCheck())}}function v(a,f,d){var b=a.getCommonAncestor(!1,!0);a=a.clone();a.enlarge(d==CKEDITOR.ENTER_BR?CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS:CKEDITOR.ENLARGE_BLOCK_CONTENTS);if(a.checkBoundaryOfElement(b,CKEDITOR.START)&&a.checkBoundaryOfElement(b,CKEDITOR.END)){for(var c;b&&b.type==CKEDITOR.NODE_ELEMENT&&(c=b.getParent())&&1==c.getChildCount()&&!(b.getName()in f);)b=c;return b.type==CKEDITOR.NODE_ELEMENT&&b.getName()in f&&b}}function p(a){return{context:"p",
allowedContent:{"h1 h2 h3 h4 h5 h6 table ul ol blockquote div tr p div li td":{propertiesOnly:!0,attributes:"dir"}},requiredContent:"p[dir]",refresh:function(a,d){var b=a.config.useComputedState,c,b=void 0===b||b;if(!b){c=d.lastElement;for(var h=a.editable();c&&!(c.getName()in u||c.equals(h));){var e=c.getParent();if(!e)break;c=e}}c=c||d.block||d.blockLimit;c.equals(a.editable())&&(h=a.getSelection().getRanges()[0].getEnclosedNode())&&h.type==CKEDITOR.NODE_ELEMENT&&(c=h);c&&(b=b?c.getComputedStyle("direction"):
c.getStyle("direction")||c.getAttribute("dir"),a.getCommand("bidirtl").setState("rtl"==b?CKEDITOR.TRISTATE_ON:CKEDITOR.TRISTATE_OFF),a.getCommand("bidiltr").setState("ltr"==b?CKEDITOR.TRISTATE_ON:CKEDITOR.TRISTATE_OFF));b=(d.block||d.blockLimit||a.editable()).getDirection(1);b!=(a._.selDir||a.lang.dir)&&(a._.selDir=b,a.fire("contentDirChanged",b))},exec:function(f){var d=f.getSelection(),b=f.config.enterMode,c=d.getRanges();if(c&&c.length){for(var h={},e=d.createBookmarks(),c=c.createIterator(),g,
l=0;g=c.getNextRange(1);){var k=g.getEnclosedNode();k&&(!k||k.type==CKEDITOR.NODE_ELEMENT&&k.getName()in r)||(k=v(g,t,b));k&&q(k,a,f,h);var m=new CKEDITOR.dom.walker(g),n=e[l].startNode,p=e[l++].endNode;m.evaluator=function(a){var c=b==CKEDITOR.ENTER_P?"p":"div",d;if(d=(a?a.type==CKEDITOR.NODE_ELEMENT:!1)&&a.getName()in t){if(c=a.is(c))c=(c=a.getParent())?c.type==CKEDITOR.NODE_ELEMENT:!1;d=!(c&&a.getParent().is("blockquote"))}return!!(d&&a.getPosition(n)&CKEDITOR.POSITION_FOLLOWING&&(a.getPosition(p)&
CKEDITOR.POSITION_PRECEDING+CKEDITOR.POSITION_CONTAINS)==CKEDITOR.POSITION_PRECEDING)};for(;k=m.next();)q(k,a,f,h);g=g.createIterator();for(g.enlargeBr=b!=CKEDITOR.ENTER_BR;k=g.getNextParagraph(b==CKEDITOR.ENTER_P?"p":"div");)q(k,a,f,h)}CKEDITOR.dom.element.clearAllMarkers(h);f.forceNextSelectionCheck();d.selectBookmarks(e);f.focus()}}}}function w(a){var f=a==l.setAttribute,d=a==l.removeAttribute,b=/\bdirection\s*:\s*(.*?)\s*(:?$|;)/;return function(c,h){if(!this.isReadOnly()){var e;if(e=c==(f||d?
"dir":"direction")||"style"==c&&(d||b.test(h))){a:{e=this;for(var g=e.getDocument().getBody().getParent();e;){if(e.equals(g)){e=!1;break a}e=e.getParent()}e=!0}e=!e}if(e&&(e=this.getDirection(1),g=a.apply(this,arguments),e!=this.getDirection(1)))return this.getDocument().fire("dirChanged",this),g}return a.apply(this,arguments)}}var t={table:1,ul:1,ol:1,blockquote:1,div:1},r={},u={};CKEDITOR.tools.extend(r,t,{tr:1,p:1,div:1,li:1});CKEDITOR.tools.extend(u,r,{td:1});CKEDITOR.plugins.add("bidi",{init:function(a){function f(b,
c,d,e,f){a.addCommand(d,new CKEDITOR.command(a,e));a.ui.addButton&&a.ui.addButton(b,{label:c,command:d,toolbar:"bidi,"+f})}if(!a.blockless){var d=a.lang.bidi;f("BidiLtr",d.ltr,"bidiltr",p("ltr"),10);f("BidiRtl",d.rtl,"bidirtl",p("rtl"),20);a.on("contentDom",function(){a.document.on("dirChanged",function(b){a.fire("dirChanged",{node:b.data,dir:b.data.getDirection(1)})})});a.on("contentDirChanged",function(b){b=(a.lang.dir!=b.data?"add":"remove")+"Class";var c=a.ui.space(a.config.toolbarLocation);if(c)c[b]("cke_mixed_dir_content")})}}});
for(var l=CKEDITOR.dom.element.prototype,n=["setStyle","removeStyle","setAttribute","removeAttribute"],m=0;m<n.length;m++)l[n[m]]=CKEDITOR.tools.override(l[n[m]],w)})();(function(){var m={exec:function(g){var a=g.getCommand("blockquote").state,k=g.getSelection(),c=k&&k.getRanges()[0];if(c){var h=k.createBookmarks();if(CKEDITOR.env.ie){var e=h[0].startNode,b=h[0].endNode,d;if(e&&"blockquote"==e.getParent().getName())for(d=e;d=d.getNext();)if(d.type==CKEDITOR.NODE_ELEMENT&&d.isBlockBoundary()){e.move(d,!0);break}if(b&&"blockquote"==b.getParent().getName())for(d=b;d=d.getPrevious();)if(d.type==CKEDITOR.NODE_ELEMENT&&d.isBlockBoundary()){b.move(d);break}}var f=c.createIterator();
f.enlargeBr=g.config.enterMode!=CKEDITOR.ENTER_BR;if(a==CKEDITOR.TRISTATE_OFF){for(e=[];a=f.getNextParagraph();)e.push(a);1>e.length&&(a=g.document.createElement(g.config.enterMode==CKEDITOR.ENTER_P?"p":"div"),b=h.shift(),c.insertNode(a),a.append(new CKEDITOR.dom.text("﻿",g.document)),c.moveToBookmark(b),c.selectNodeContents(a),c.collapse(!0),b=c.createBookmark(),e.push(a),h.unshift(b));d=e[0].getParent();c=[];for(b=0;b<e.length;b++)a=e[b],d=d.getCommonAncestor(a.getParent());for(a={table:1,tbody:1,
tr:1,ol:1,ul:1};a[d.getName()];)d=d.getParent();for(b=null;0<e.length;){for(a=e.shift();!a.getParent().equals(d);)a=a.getParent();a.equals(b)||c.push(a);b=a}for(;0<c.length;)if(a=c.shift(),"blockquote"==a.getName()){for(b=new CKEDITOR.dom.documentFragment(g.document);a.getFirst();)b.append(a.getFirst().remove()),e.push(b.getLast());b.replace(a)}else e.push(a);c=g.document.createElement("blockquote");for(c.insertBefore(e[0]);0<e.length;)a=e.shift(),c.append(a)}else if(a==CKEDITOR.TRISTATE_ON){b=[];
for(d={};a=f.getNextParagraph();){for(e=c=null;a.getParent();){if("blockquote"==a.getParent().getName()){c=a.getParent();e=a;break}a=a.getParent()}c&&e&&!e.getCustomData("blockquote_moveout")&&(b.push(e),CKEDITOR.dom.element.setMarker(d,e,"blockquote_moveout",!0))}CKEDITOR.dom.element.clearAllMarkers(d);a=[];e=[];for(d={};0<b.length;)f=b.shift(),c=f.getParent(),f.getPrevious()?f.getNext()?(f.breakParent(f.getParent()),e.push(f.getNext())):f.remove().insertAfter(c):f.remove().insertBefore(c),c.getCustomData("blockquote_processed")||
(e.push(c),CKEDITOR.dom.element.setMarker(d,c,"blockquote_processed",!0)),a.push(f);CKEDITOR.dom.element.clearAllMarkers(d);for(b=e.length-1;0<=b;b--){c=e[b];a:{d=c;for(var f=0,m=d.getChildCount(),l=void 0;f<m&&(l=d.getChild(f));f++)if(l.type==CKEDITOR.NODE_ELEMENT&&l.isBlockBoundary()){d=!1;break a}d=!0}d&&c.remove()}if(g.config.enterMode==CKEDITOR.ENTER_BR)for(c=!0;a.length;)if(f=a.shift(),"div"==f.getName()){b=new CKEDITOR.dom.documentFragment(g.document);!c||!f.getPrevious()||f.getPrevious().type==
CKEDITOR.NODE_ELEMENT&&f.getPrevious().isBlockBoundary()||b.append(g.document.createElement("br"));for(c=f.getNext()&&!(f.getNext().type==CKEDITOR.NODE_ELEMENT&&f.getNext().isBlockBoundary());f.getFirst();)f.getFirst().remove().appendTo(b);c&&b.append(g.document.createElement("br"));b.replace(f);c=!1}}k.selectBookmarks(h);g.focus()}},refresh:function(g,a){this.setState(g.elementPath(a.block||a.blockLimit).contains("blockquote",1)?CKEDITOR.TRISTATE_ON:CKEDITOR.TRISTATE_OFF)},context:"blockquote",allowedContent:"blockquote",
requiredContent:"blockquote"};CKEDITOR.plugins.add("blockquote",{init:function(g){g.blockless||(g.addCommand("blockquote",m),g.ui.addButton&&g.ui.addButton("Blockquote",{label:g.lang.blockquote.toolbar,command:"blockquote",toolbar:"blocks,10"}))}})})();(function(){function q(b,a){CKEDITOR.tools.extend(this,a,{editor:b,id:"cke-"+CKEDITOR.tools.getUniqueId(),area:b._.notificationArea});a.type||(this.type="info");this.element=this._createElement();b.plugins.clipboard&&CKEDITOR.plugins.clipboard.preventDefaultDropOnElement(this.element)}function r(b){var a=this;this.editor=b;this.notifications=[];this.element=this._createElement();this._uiBuffer=CKEDITOR.tools.eventsBuffer(10,this._layout,this);this._changeBuffer=CKEDITOR.tools.eventsBuffer(500,this._layout,
this);b.on("destroy",function(){a._removeListeners();a.element.remove()})}CKEDITOR.plugins.add("notification",{init:function(b){function a(b){var a=new CKEDITOR.dom.element("div");a.setStyles({position:"fixed","margin-left":"-9999px"});a.setAttributes({"aria-live":"assertive","aria-atomic":"true"});a.setText(b);CKEDITOR.document.getBody().append(a);setTimeout(function(){a.remove()},100)}b._.notificationArea=new r(b);b.showNotification=function(a,d,e){var f,l;"progress"==d?f=e:l=e;a=new CKEDITOR.plugins.notification(b,
{message:a,type:d,progress:f,duration:l});a.show();return a};b.on("key",function(c){if(27==c.data.keyCode){var d=b._.notificationArea.notifications;d.length&&(a(b.lang.notification.closed),d[d.length-1].hide(),c.cancel())}})}});q.prototype={show:function(){!1!==this.editor.fire("notificationShow",{notification:this})&&(this.area.add(this),this._hideAfterTimeout())},update:function(b){var a=!0;!1===this.editor.fire("notificationUpdate",{notification:this,options:b})&&(a=!1);var c=this.element,d=c.findOne(".cke_notification_message"),
e=c.findOne(".cke_notification_progress"),f=b.type;c.removeAttribute("role");b.progress&&"progress"!=this.type&&(f="progress");f&&(c.removeClass(this._getClass()),c.removeAttribute("aria-label"),this.type=f,c.addClass(this._getClass()),c.setAttribute("aria-label",this.type),"progress"!=this.type||e?"progress"!=this.type&&e&&e.remove():(e=this._createProgressElement(),e.insertBefore(d)));void 0!==b.message&&(this.message=b.message,d.setHtml(this.message));void 0!==b.progress&&(this.progress=b.progress,
e&&e.setStyle("width",this._getPercentageProgress()));a&&b.important&&(c.setAttribute("role","alert"),this.isVisible()||this.area.add(this));this.duration=b.duration;this._hideAfterTimeout()},hide:function(){!1!==this.editor.fire("notificationHide",{notification:this})&&this.area.remove(this)},isVisible:function(){return 0<=CKEDITOR.tools.indexOf(this.area.notifications,this)},_createElement:function(){var b=this,a,c,d=this.editor.lang.common.close;a=new CKEDITOR.dom.element("div");a.addClass("cke_notification");
a.addClass(this._getClass());a.setAttributes({id:this.id,role:"alert","aria-label":this.type});"progress"==this.type&&a.append(this._createProgressElement());c=new CKEDITOR.dom.element("p");c.addClass("cke_notification_message");c.setHtml(this.message);a.append(c);c=CKEDITOR.dom.element.createFromHtml('\x3ca class\x3d"cke_notification_close" href\x3d"javascript:void(0)" title\x3d"'+d+'" role\x3d"button" tabindex\x3d"-1"\x3e\x3cspan class\x3d"cke_label"\x3eX\x3c/span\x3e\x3c/a\x3e');a.append(c);c.on("click",
function(){b.editor.focus();b.hide()});return a},_getClass:function(){return"progress"==this.type?"cke_notification_info":"cke_notification_"+this.type},_createProgressElement:function(){var b=new CKEDITOR.dom.element("span");b.addClass("cke_notification_progress");b.setStyle("width",this._getPercentageProgress());return b},_getPercentageProgress:function(){return Math.round(100*(this.progress||0))+"%"},_hideAfterTimeout:function(){var b=this,a;this._hideTimeoutId&&clearTimeout(this._hideTimeoutId);
if("number"==typeof this.duration)a=this.duration;else if("info"==this.type||"success"==this.type)a="number"==typeof this.editor.config.notification_duration?this.editor.config.notification_duration:5E3;a&&(b._hideTimeoutId=setTimeout(function(){b.hide()},a))}};r.prototype={add:function(b){this.notifications.push(b);this.element.append(b.element);1==this.element.getChildCount()&&(CKEDITOR.document.getBody().append(this.element),this._attachListeners());this._layout()},remove:function(b){var a=CKEDITOR.tools.indexOf(this.notifications,
b);0>a||(this.notifications.splice(a,1),b.element.remove(),this.element.getChildCount()||(this._removeListeners(),this.element.remove()))},_createElement:function(){var b=this.editor,a=b.config,c=new CKEDITOR.dom.element("div");c.addClass("cke_notifications_area");c.setAttribute("id","cke_notifications_area_"+b.name);c.setStyle("z-index",a.baseFloatZIndex-2);return c},_attachListeners:function(){var b=CKEDITOR.document.getWindow(),a=this.editor;b.on("scroll",this._uiBuffer.input);b.on("resize",this._uiBuffer.input);
a.on("change",this._changeBuffer.input);a.on("floatingSpaceLayout",this._layout,this,null,20);a.on("blur",this._layout,this,null,20)},_removeListeners:function(){var b=CKEDITOR.document.getWindow(),a=this.editor;b.removeListener("scroll",this._uiBuffer.input);b.removeListener("resize",this._uiBuffer.input);a.removeListener("change",this._changeBuffer.input);a.removeListener("floatingSpaceLayout",this._layout);a.removeListener("blur",this._layout)},_layout:function(){function b(){a.setStyle("left",
k(n+d.width-g-h))}var a=this.element,c=this.editor,d=c.ui.contentsElement.getClientRect(),e=c.ui.contentsElement.getDocumentPosition(),f,l,u=a.getClientRect(),m,g=this._notificationWidth,h=this._notificationMargin;m=CKEDITOR.document.getWindow();var p=m.getScrollPosition(),t=m.getViewPaneSize(),q=CKEDITOR.document.getBody(),r=q.getDocumentPosition(),k=CKEDITOR.tools.cssLength;g&&h||(m=this.element.getChild(0),g=this._notificationWidth=m.getClientRect().width,h=this._notificationMargin=parseInt(m.getComputedStyle("margin-left"),
10)+parseInt(m.getComputedStyle("margin-right"),10));c.toolbar&&(f=c.ui.space(c.config.toolbarLocation),l=f.getClientRect());f&&f.isVisible()&&l.bottom>d.top&&l.bottom<d.bottom-u.height?a.setStyles({position:"fixed",top:k(l.bottom)}):0<d.top?a.setStyles({position:"absolute",top:k(e.y)}):e.y+d.height-u.height>p.y?a.setStyles({position:"fixed",top:0}):a.setStyles({position:"absolute",top:k(e.y+d.height-u.height)});var n="fixed"==a.getStyle("position")?d.left:"static"!=q.getComputedStyle("position")?
e.x-r.x:e.x;d.width<g+h?e.x+g+h>p.x+t.width?b():a.setStyle("left",k(n)):e.x+g+h>p.x+t.width?a.setStyle("left",k(n)):e.x+d.width/2+g/2+h>p.x+t.width?a.setStyle("left",k(n-e.x+p.x+t.width-g-h)):0>d.left+d.width-g-h?b():0>d.left+d.width/2-g/2?a.setStyle("left",k(n-e.x+p.x)):a.setStyle("left",k(n+d.width/2-g/2-h/2))}};CKEDITOR.plugins.notification=q})();(function(){var c='\x3ca id\x3d"{id}" class\x3d"cke_button cke_button__{name} cke_button_{state} {cls}"'+(CKEDITOR.env.gecko&&!CKEDITOR.env.hc?"":" href\x3d\"javascript:void('{titleJs}')\"")+' title\x3d"{title}" tabindex\x3d"-1" hidefocus\x3d"true" role\x3d"button" aria-labelledby\x3d"{id}_label" aria-describedby\x3d"{id}_description" aria-haspopup\x3d"{hasArrow}" aria-disabled\x3d"{ariaDisabled}"';CKEDITOR.env.gecko&&CKEDITOR.env.mac&&(c+=' onkeypress\x3d"return false;"');CKEDITOR.env.gecko&&(c+=
' onblur\x3d"this.style.cssText \x3d this.style.cssText;"');var l="";CKEDITOR.env.ie&&(l='return false;" onmouseup\x3d"CKEDITOR.tools.getMouseButton(event)\x3d\x3dCKEDITOR.MOUSE_BUTTON_LEFT\x26\x26');var c=c+(' onkeydown\x3d"return CKEDITOR.tools.callFunction({keydownFn},event);" onfocus\x3d"return CKEDITOR.tools.callFunction({focusFn},event);" onclick\x3d"'+l+'CKEDITOR.tools.callFunction({clickFn},this);return false;"\x3e\x3cspan class\x3d"cke_button_icon cke_button__{iconName}_icon" style\x3d"{style}"')+
'\x3e\x26nbsp;\x3c/span\x3e\x3cspan id\x3d"{id}_label" class\x3d"cke_button_label cke_button__{name}_label" aria-hidden\x3d"false"\x3e{label}\x3c/span\x3e\x3cspan id\x3d"{id}_description" class\x3d"cke_button_label" aria-hidden\x3d"false"\x3e{ariaShortcutSpace}{ariaShortcut}\x3c/span\x3e{arrowHtml}\x3c/a\x3e',v=CKEDITOR.addTemplate("buttonArrow",'\x3cspan class\x3d"cke_button_arrow"\x3e'+(CKEDITOR.env.hc?"\x26#9660;":"")+"\x3c/span\x3e"),w=CKEDITOR.addTemplate("button",c);CKEDITOR.plugins.add("button",
{beforeInit:function(a){a.ui.addHandler(CKEDITOR.UI_BUTTON,CKEDITOR.ui.button.handler)}});CKEDITOR.UI_BUTTON="button";CKEDITOR.ui.button=function(a){CKEDITOR.tools.extend(this,a,{title:a.label,click:a.click||function(b){b.execCommand(a.command)}});this._={}};CKEDITOR.ui.button.handler={create:function(a){return new CKEDITOR.ui.button(a)}};CKEDITOR.ui.button.prototype={render:function(a,b){function c(){var f=a.mode;f&&(f=this.modes[f]?void 0!==p[f]?p[f]:CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED,
f=a.readOnly&&!this.readOnly?CKEDITOR.TRISTATE_DISABLED:f,this.setState(f),this.refresh&&this.refresh())}var p=null,q=CKEDITOR.env,r=this._.id=CKEDITOR.tools.getNextId(),g="",d=this.command,l,m,k;this._.editor=a;var e={id:r,button:this,editor:a,focus:function(){CKEDITOR.document.getById(r).focus()},execute:function(){this.button.click(a)},attach:function(a){this.button.attach(a)}},x=CKEDITOR.tools.addFunction(function(a){if(e.onkey)return a=new CKEDITOR.dom.event(a),!1!==e.onkey(e,a.getKeystroke())}),
y=CKEDITOR.tools.addFunction(function(a){var b;e.onfocus&&(b=!1!==e.onfocus(e,new CKEDITOR.dom.event(a)));return b}),u=0;e.clickFn=l=CKEDITOR.tools.addFunction(function(){u&&(a.unlockSelection(1),u=0);e.execute();q.iOS&&a.focus()});this.modes?(p={},a.on("beforeModeUnload",function(){a.mode&&this._.state!=CKEDITOR.TRISTATE_DISABLED&&(p[a.mode]=this._.state)},this),a.on("activeFilterChange",c,this),a.on("mode",c,this),!this.readOnly&&a.on("readOnly",c,this)):d&&(d=a.getCommand(d))&&(d.on("state",function(){this.setState(d.state)},
this),g+=d.state==CKEDITOR.TRISTATE_ON?"on":d.state==CKEDITOR.TRISTATE_DISABLED?"disabled":"off");var n;if(this.directional)a.on("contentDirChanged",function(b){var c=CKEDITOR.document.getById(this._.id),d=c.getFirst();b=b.data;b!=a.lang.dir?c.addClass("cke_"+b):c.removeClass("cke_ltr").removeClass("cke_rtl");d.setAttribute("style",CKEDITOR.skin.getIconStyle(n,"rtl"==b,this.icon,this.iconOffset))},this);d?(m=a.getCommandKeystroke(d))&&(k=CKEDITOR.tools.keystrokeToString(a.lang.common.keyboard,m)):
g+="off";m=this.name||this.command;var h=null,t=this.icon;n=m;this.icon&&!/\./.test(this.icon)?(n=this.icon,t=null):(this.icon&&(h=this.icon),CKEDITOR.env.hidpi&&this.iconHiDpi&&(h=this.iconHiDpi));h?(CKEDITOR.skin.addIcon(h,h),t=null):h=n;g={id:r,name:m,iconName:n,label:this.label,cls:(this.hasArrow?"cke_button_expandable ":"")+(this.className||""),state:g,ariaDisabled:"disabled"==g?"true":"false",title:this.title+(k?" ("+k.display+")":""),ariaShortcutSpace:k?"\x26nbsp;":"",ariaShortcut:k?a.lang.common.keyboardShortcut+
" "+k.aria:"",titleJs:q.gecko&&!q.hc?"":(this.title||"").replace("'",""),hasArrow:"string"===typeof this.hasArrow&&this.hasArrow||(this.hasArrow?"true":"false"),keydownFn:x,focusFn:y,clickFn:l,style:CKEDITOR.skin.getIconStyle(h,"rtl"==a.lang.dir,t,this.iconOffset),arrowHtml:this.hasArrow?v.output():""};w.output(g,b);if(this.onRender)this.onRender();return e},setState:function(a){if(this._.state==a)return!1;this._.state=a;var b=CKEDITOR.document.getById(this._.id);return b?(b.setState(a,"cke_button"),
b.setAttribute("aria-disabled",a==CKEDITOR.TRISTATE_DISABLED),this.hasArrow?b.setAttribute("aria-expanded",a==CKEDITOR.TRISTATE_ON):a===CKEDITOR.TRISTATE_ON?b.setAttribute("aria-pressed",!0):b.removeAttribute("aria-pressed"),!0):!1},getState:function(){return this._.state},toFeature:function(a){if(this._.feature)return this._.feature;var b=this;this.allowedContent||this.requiredContent||!this.command||(b=a.getCommand(this.command)||b);return this._.feature=b}};CKEDITOR.ui.prototype.addButton=function(a,
b){this.add(a,CKEDITOR.UI_BUTTON,b)}})();(function(){function D(a){function d(){for(var b=f(),e=CKEDITOR.tools.clone(a.config.toolbarGroups)||v(a),n=0;n<e.length;n++){var g=e[n];if("/"!=g){"string"==typeof g&&(g=e[n]={name:g});var l,d=g.groups;if(d)for(var h=0;h<d.length;h++)l=d[h],(l=b[l])&&c(g,l);(l=b[g.name])&&c(g,l)}}return e}function f(){var b={},c,e,g;for(c in a.ui.items)e=a.ui.items[c],g=e.toolbar||"others",g=g.split(","),e=g[0],g=parseInt(g[1]||-1,10),b[e]||(b[e]=[]),b[e].push({name:c,order:g});for(e in b)b[e]=b[e].sort(function(b,
a){return b.order==a.order?0:0>a.order?-1:0>b.order?1:b.order<a.order?-1:1});return b}function c(c,e){if(e.length){c.items?c.items.push(a.ui.create("-")):c.items=[];for(var d;d=e.shift();)d="string"==typeof d?d:d.name,b&&-1!=CKEDITOR.tools.indexOf(b,d)||(d=a.ui.create(d))&&a.addFeature(d)&&c.items.push(d)}}function h(b){var a=[],e,d,h;for(e=0;e<b.length;++e)d=b[e],h={},"/"==d?a.push(d):CKEDITOR.tools.isArray(d)?(c(h,CKEDITOR.tools.clone(d)),a.push(h)):d.items&&(c(h,CKEDITOR.tools.clone(d.items)),
h.name=d.name,a.push(h));return a}var b=a.config.removeButtons,b=b&&b.split(","),e=a.config.toolbar;"string"==typeof e&&(e=a.config["toolbar_"+e]);return a.toolbar=e?h(e):d()}function v(a){return a._.toolbarGroups||(a._.toolbarGroups=[{name:"document",groups:["mode","document","doctools"]},{name:"clipboard",groups:["clipboard","undo"]},{name:"editing",groups:["find","selection","spellchecker"]},{name:"forms"},"/",{name:"basicstyles",groups:["basicstyles","cleanup"]},{name:"paragraph",groups:["list",
"indent","blocks","align","bidi"]},{name:"links"},{name:"insert"},"/",{name:"styles"},{name:"colors"},{name:"tools"},{name:"others"},{name:"about"}])}var z=function(){this.toolbars=[];this.focusCommandExecuted=!1};z.prototype.focus=function(){for(var a=0,d;d=this.toolbars[a++];)for(var f=0,c;c=d.items[f++];)if(c.focus){c.focus();return}};var E={modes:{wysiwyg:1,source:1},readOnly:1,exec:function(a){a.toolbox&&(a.toolbox.focusCommandExecuted=!0,CKEDITOR.env.ie||CKEDITOR.env.air?setTimeout(function(){a.toolbox.focus()},
100):a.toolbox.focus())}};CKEDITOR.plugins.add("toolbar",{requires:"button",init:function(a){var d,f=function(c,h){var b,e="rtl"==a.lang.dir,k=a.config.toolbarGroupCycling,q=e?37:39,e=e?39:37,k=void 0===k||k;switch(h){case 9:case CKEDITOR.SHIFT+9:for(;!b||!b.items.length;)if(b=9==h?(b?b.next:c.toolbar.next)||a.toolbox.toolbars[0]:(b?b.previous:c.toolbar.previous)||a.toolbox.toolbars[a.toolbox.toolbars.length-1],b.items.length)for(c=b.items[d?b.items.length-1:0];c&&!c.focus;)(c=d?c.previous:c.next)||
(b=0);c&&c.focus();return!1;case q:b=c;do b=b.next,!b&&k&&(b=c.toolbar.items[0]);while(b&&!b.focus);b?b.focus():f(c,9);return!1;case 40:return c.button&&c.button.hasArrow?c.execute():f(c,40==h?q:e),!1;case e:case 38:b=c;do b=b.previous,!b&&k&&(b=c.toolbar.items[c.toolbar.items.length-1]);while(b&&!b.focus);b?b.focus():(d=1,f(c,CKEDITOR.SHIFT+9),d=0);return!1;case 27:return a.focus(),!1;case 13:case 32:return c.execute(),!1}return!0};a.on("uiSpace",function(c){if(c.data.space==a.config.toolbarLocation){c.removeListener();
a.toolbox=new z;var d=CKEDITOR.tools.getNextId(),b=['\x3cspan id\x3d"',d,'" class\x3d"cke_voice_label"\x3e',a.lang.toolbar.toolbars,"\x3c/span\x3e",'\x3cspan id\x3d"'+a.ui.spaceId("toolbox")+'" class\x3d"cke_toolbox" role\x3d"group" aria-labelledby\x3d"',d,'" onmousedown\x3d"return false;"\x3e'],d=!1!==a.config.toolbarStartupExpanded,e,k;a.config.toolbarCanCollapse&&a.elementMode!=CKEDITOR.ELEMENT_MODE_INLINE&&b.push('\x3cspan class\x3d"cke_toolbox_main"'+(d?"\x3e":' style\x3d"display:none"\x3e'));
for(var q=a.toolbox.toolbars,n=D(a),g=n.length,l=0;l<g;l++){var r,m=0,w,p=n[l],v="/"!==p&&("/"===n[l+1]||l==g-1),x;if(p)if(e&&(b.push("\x3c/span\x3e"),k=e=0),"/"===p)b.push('\x3cspan class\x3d"cke_toolbar_break"\x3e\x3c/span\x3e');else{x=p.items||p;for(var y=0;y<x.length;y++){var t=x[y],A;if(t){var B=function(c){c=c.render(a,b);u=m.items.push(c)-1;0<u&&(c.previous=m.items[u-1],c.previous.next=c);c.toolbar=m;c.onkey=f;c.onfocus=function(){a.toolbox.focusCommandExecuted||a.focus()}};if(t.type==CKEDITOR.UI_SEPARATOR)k=
e&&t;else{A=!1!==t.canGroup;if(!m){r=CKEDITOR.tools.getNextId();m={id:r,items:[]};w=p.name&&(a.lang.toolbar.toolbarGroups[p.name]||p.name);b.push('\x3cspan id\x3d"',r,'" class\x3d"cke_toolbar'+(v?' cke_toolbar_last"':'"'),w?' aria-labelledby\x3d"'+r+'_label"':"",' role\x3d"toolbar"\x3e');w&&b.push('\x3cspan id\x3d"',r,'_label" class\x3d"cke_voice_label"\x3e',w,"\x3c/span\x3e");b.push('\x3cspan class\x3d"cke_toolbar_start"\x3e\x3c/span\x3e');var u=q.push(m)-1;0<u&&(m.previous=q[u-1],m.previous.next=
m)}A?e||(b.push('\x3cspan class\x3d"cke_toolgroup" role\x3d"presentation"\x3e'),e=1):e&&(b.push("\x3c/span\x3e"),e=0);k&&(B(k),k=0);B(t)}}}e&&(b.push("\x3c/span\x3e"),k=e=0);m&&b.push('\x3cspan class\x3d"cke_toolbar_end"\x3e\x3c/span\x3e\x3c/span\x3e')}}a.config.toolbarCanCollapse&&b.push("\x3c/span\x3e");if(a.config.toolbarCanCollapse&&a.elementMode!=CKEDITOR.ELEMENT_MODE_INLINE){var C=CKEDITOR.tools.addFunction(function(){a.execCommand("toolbarCollapse")});a.on("destroy",function(){CKEDITOR.tools.removeFunction(C)});
a.addCommand("toolbarCollapse",{readOnly:1,exec:function(b){var a=b.ui.space("toolbar_collapser"),c=a.getPrevious(),d=b.ui.space("contents"),e=c.getParent(),h=parseInt(d.$.style.height,10),g=e.$.offsetHeight,f=a.hasClass("cke_toolbox_collapser_min");f?(c.show(),a.removeClass("cke_toolbox_collapser_min"),a.setAttribute("title",b.lang.toolbar.toolbarCollapse)):(c.hide(),a.addClass("cke_toolbox_collapser_min"),a.setAttribute("title",b.lang.toolbar.toolbarExpand));a.getFirst().setText(f?"▲":"◀");d.setStyle("height",
h-(e.$.offsetHeight-g)+"px");b.fire("resize",{outerHeight:b.container.$.offsetHeight,contentsHeight:d.$.offsetHeight,outerWidth:b.container.$.offsetWidth})},modes:{wysiwyg:1,source:1}});a.setKeystroke(CKEDITOR.ALT+(CKEDITOR.env.ie||CKEDITOR.env.webkit?189:109),"toolbarCollapse");b.push('\x3ca title\x3d"'+(d?a.lang.toolbar.toolbarCollapse:a.lang.toolbar.toolbarExpand)+'" id\x3d"'+a.ui.spaceId("toolbar_collapser")+'" tabIndex\x3d"-1" class\x3d"cke_toolbox_collapser');d||b.push(" cke_toolbox_collapser_min");
b.push('" onclick\x3d"CKEDITOR.tools.callFunction('+C+')"\x3e','\x3cspan class\x3d"cke_arrow"\x3e\x26#9650;\x3c/span\x3e',"\x3c/a\x3e")}b.push("\x3c/span\x3e");c.data.html+=b.join("")}});a.on("destroy",function(){if(this.toolbox){var a,d=0,b,e,f;for(a=this.toolbox.toolbars;d<a.length;d++)for(e=a[d].items,b=0;b<e.length;b++)f=e[b],f.clickFn&&CKEDITOR.tools.removeFunction(f.clickFn),f.keyDownFn&&CKEDITOR.tools.removeFunction(f.keyDownFn)}});a.on("uiReady",function(){var c=a.ui.space("toolbox");c&&a.focusManager.add(c,
1)});a.addCommand("toolbarFocus",E);a.setKeystroke(CKEDITOR.ALT+121,"toolbarFocus");a.ui.add("-",CKEDITOR.UI_SEPARATOR,{});a.ui.addHandler(CKEDITOR.UI_SEPARATOR,{create:function(){return{render:function(a,d){d.push('\x3cspan class\x3d"cke_toolbar_separator" role\x3d"separator"\x3e\x3c/span\x3e');return{}}}}})}});CKEDITOR.ui.prototype.addToolbarGroup=function(a,d,f){var c=v(this.editor),h=0===d,b={name:a};if(f){if(f=CKEDITOR.tools.search(c,function(a){return a.name==f})){!f.groups&&(f.groups=[]);if(d&&
(d=CKEDITOR.tools.indexOf(f.groups,d),0<=d)){f.groups.splice(d+1,0,a);return}h?f.groups.splice(0,0,a):f.groups.push(a);return}d=null}d&&(d=CKEDITOR.tools.indexOf(c,function(a){return a.name==d}));h?c.splice(0,0,a):"number"==typeof d?c.splice(d+1,0,b):c.push(a)}})();CKEDITOR.UI_SEPARATOR="separator";CKEDITOR.config.toolbarLocation="top";(function(){function r(a,b,c){b.type||(b.type="auto");if(c&&!1===a.fire("beforePaste",b)||!b.dataValue&&b.dataTransfer.isEmpty())return!1;b.dataValue||(b.dataValue="");if(CKEDITOR.env.gecko&&"drop"==b.method&&a.toolbox)a.once("afterPaste",function(){a.toolbox.focus()});return a.fire("paste",b)}function x(a){function b(){var b=a.editable();if(CKEDITOR.plugins.clipboard.isCustomCopyCutSupported){var c=function(b){a.getSelection().isCollapsed()||(a.readOnly&&"cut"==b.name||p.initPasteDataTransfer(b,
a),b.data.preventDefault())};b.on("copy",c);b.on("cut",c);b.on("cut",function(){a.readOnly||a.extractSelectedHtml()},null,null,999)}b.on(p.mainPasteEvent,function(a){"beforepaste"==p.mainPasteEvent&&n||k(a)});"beforepaste"==p.mainPasteEvent&&(b.on("paste",function(a){v||(f(),a.data.preventDefault(),k(a),e("paste"))}),b.on("contextmenu",h,null,null,0),b.on("beforepaste",function(a){!a.data||a.data.$.ctrlKey||a.data.$.shiftKey||h()},null,null,0));b.on("beforecut",function(){!n&&g(a)});var d;b.attachListener(CKEDITOR.env.ie?
b:a.document.getDocumentElement(),"mouseup",function(){d=setTimeout(u,0)});a.on("destroy",function(){clearTimeout(d)});b.on("keyup",u)}function c(b){return{type:b,canUndo:"cut"==b,startDisabled:!0,fakeKeystroke:"cut"==b?CKEDITOR.CTRL+88:CKEDITOR.CTRL+67,exec:function(){"cut"==this.type&&g();var b;var c=this.type;if(CKEDITOR.env.ie)b=e(c);else try{b=a.document.$.execCommand(c,!1,null)}catch(d){b=!1}b||a.showNotification(a.lang.clipboard[this.type+"Error"]);return b}}}function d(){return{canUndo:!1,
async:!0,fakeKeystroke:CKEDITOR.CTRL+86,exec:function(a,b){function c(b,g){g="undefined"!==typeof g?g:!0;b?(b.method="paste",b.dataTransfer||(b.dataTransfer=p.initPasteDataTransfer()),r(a,b,g)):e&&!a._.forcePasteDialog&&a.showNotification(f,"info",a.config.clipboard_notificationDuration);a._.forcePasteDialog=!1;a.fire("afterCommandExec",{name:"paste",command:d,returnValue:!!b})}b="undefined"!==typeof b&&null!==b?b:{};var d=this,e="undefined"!==typeof b.notification?b.notification:!0,g=b.type,m=CKEDITOR.tools.keystrokeToString(a.lang.common.keyboard,
a.getCommandKeystroke(this)),f="string"===typeof e?e:a.lang.clipboard.pasteNotification.replace(/%1/,'\x3ckbd aria-label\x3d"'+m.aria+'"\x3e'+m.display+"\x3c/kbd\x3e"),m="string"===typeof b?b:b.dataValue;g&&!0!==a.config.forcePasteAsPlainText&&"allow-word"!==a.config.forcePasteAsPlainText?a._.nextPasteType=g:delete a._.nextPasteType;"string"===typeof m?c({dataValue:m}):a.getClipboardData(c)}}}function f(){v=1;setTimeout(function(){v=0},100)}function h(){n=1;setTimeout(function(){n=0},10)}function e(b){var c=
a.document,d=c.getBody(),e=!1,g=function(){e=!0};d.on(b,g);7<CKEDITOR.env.version?c.$.execCommand(b):c.$.selection.createRange().execCommand(b);d.removeListener(b,g);return e}function g(){if(CKEDITOR.env.ie&&!CKEDITOR.env.quirks){var b=a.getSelection(),c,d,e;b.getType()==CKEDITOR.SELECTION_ELEMENT&&(c=b.getSelectedElement())&&(d=b.getRanges()[0],e=a.document.createText(""),e.insertBefore(c),d.setStartBefore(e),d.setEndAfter(c),b.selectRanges([d]),setTimeout(function(){c.getParent()&&(e.remove(),b.selectElement(c))},
0))}}function l(b,c){var d=a.document,e=a.editable(),g=function(a){a.cancel()},m;if(!d.getById("cke_pastebin")){var f=a.getSelection(),l=f.createBookmarks();CKEDITOR.env.ie&&f.root.fire("selectionchange");var k=new CKEDITOR.dom.element(!CKEDITOR.env.webkit&&!e.is("body")||CKEDITOR.env.ie?"div":"body",d);k.setAttributes({id:"cke_pastebin","data-cke-temp":"1"});var h=0,d=d.getWindow();CKEDITOR.env.webkit?(e.append(k),k.addClass("cke_editable"),e.is("body")||(h="static"!=e.getComputedStyle("position")?
e:CKEDITOR.dom.element.get(e.$.offsetParent),h=h.getDocumentPosition().y)):e.getAscendant(CKEDITOR.env.ie?"body":"html",1).append(k);k.setStyles({position:"absolute",top:d.getScrollPosition().y-h+10+"px",width:"1px",height:Math.max(1,d.getViewPaneSize().height-20)+"px",overflow:"hidden",margin:0,padding:0});CKEDITOR.env.safari&&k.setStyles(CKEDITOR.tools.cssVendorPrefix("user-select","text"));(h=k.getParent().isReadOnly())?(k.setOpacity(0),k.setAttribute("contenteditable",!0)):k.setStyle("ltr"==a.config.contentsLangDirection?
"left":"right","-10000px");a.on("selectionChange",g,null,null,0);if(CKEDITOR.env.webkit||CKEDITOR.env.gecko)m=e.once("blur",g,null,null,-100);h&&k.focus();h=new CKEDITOR.dom.range(k);h.selectNodeContents(k);var u=h.select();CKEDITOR.env.ie&&(m=e.once("blur",function(){a.lockSelection(u)}));var q=CKEDITOR.document.getWindow().getScrollPosition().y;setTimeout(function(){CKEDITOR.env.webkit&&(CKEDITOR.document.getBody().$.scrollTop=q);m&&m.removeListener();CKEDITOR.env.ie&&e.focus();f.selectBookmarks(l);
k.remove();var b;CKEDITOR.env.webkit&&(b=k.getFirst())&&b.is&&b.hasClass("Apple-style-span")&&(k=b);a.removeListener("selectionChange",g);c(k.getHtml())},0)}}function t(){if("paste"==p.mainPasteEvent)return a.fire("beforePaste",{type:"auto",method:"paste"}),!1;a.focus();f();var b=a.focusManager;b.lock();if(a.editable().fire(p.mainPasteEvent)&&!e("paste"))return b.unlock(),!1;b.unlock();return!0}function m(b){if("wysiwyg"==a.mode)switch(b.data.keyCode){case CKEDITOR.CTRL+86:case CKEDITOR.SHIFT+45:b=
a.editable();f();"paste"==p.mainPasteEvent&&b.fire("beforepaste");break;case CKEDITOR.CTRL+88:case CKEDITOR.SHIFT+46:a.fire("saveSnapshot"),setTimeout(function(){a.fire("saveSnapshot")},50)}}function k(b){var c={type:"auto",method:"paste",dataTransfer:p.initPasteDataTransfer(b)};c.dataTransfer.cacheData();var e=!1!==a.fire("beforePaste",c);e&&p.canClipboardApiBeTrusted(c.dataTransfer,a)?(b.data.preventDefault(),setTimeout(function(){r(a,c)},0)):l(b,function(b){c.dataValue=b.replace(/<span[^>]+data-cke-bookmark[^<]*?<\/span>/ig,
"");e&&r(a,c)})}function u(){if("wysiwyg"==a.mode){var b=q("paste");a.getCommand("cut").setState(q("cut"));a.getCommand("copy").setState(q("copy"));a.getCommand("paste").setState(b);a.fire("pasteState",b)}}function q(b){var c=a.getSelection(),c=c&&c.getRanges()[0];if((a.readOnly||c&&c.checkReadOnly())&&b in{paste:1,cut:1})return CKEDITOR.TRISTATE_DISABLED;if("paste"==b)return CKEDITOR.TRISTATE_OFF;b=a.getSelection();c=b.getRanges();return b.getType()==CKEDITOR.SELECTION_NONE||1==c.length&&c[0].collapsed?
CKEDITOR.TRISTATE_DISABLED:CKEDITOR.TRISTATE_OFF}var p=CKEDITOR.plugins.clipboard,n=0,v=0;(function(){a.on("key",m);a.on("contentDom",b);a.on("selectionChange",u);if(a.contextMenu){a.contextMenu.addListener(function(){return{cut:q("cut"),copy:q("copy"),paste:q("paste")}});var c=null;a.on("menuShow",function(){c&&(c.removeListener(),c=null);var b=a.contextMenu.findItemByCommandName("paste");b&&b.element&&(c=b.element.on("touchend",function(){a._.forcePasteDialog=!0}))})}if(a.ui.addButton)a.once("instanceReady",
function(){a._.pasteButtons&&CKEDITOR.tools.array.forEach(a._.pasteButtons,function(b){if(b=a.ui.get(b))if(b=CKEDITOR.document.getById(b._.id))b.on("touchend",function(){a._.forcePasteDialog=!0})})})})();(function(){function b(c,e,d,g,m){var k=a.lang.clipboard[e];a.addCommand(e,d);a.ui.addButton&&a.ui.addButton(c,{label:k,command:e,toolbar:"clipboard,"+g});a.addMenuItems&&a.addMenuItem(e,{label:k,command:e,group:"clipboard",order:m})}b("Cut","cut",c("cut"),10,1);b("Copy","copy",c("copy"),20,4);b("Paste",
"paste",d(),30,8);a._.pasteButtons||(a._.pasteButtons=[]);a._.pasteButtons.push("Paste")})();a.getClipboardData=function(b,c){function e(a){a.removeListener();a.cancel();c(a.data)}function d(a){a.removeListener();a.cancel();c({type:m,dataValue:a.data.dataValue,dataTransfer:a.data.dataTransfer,method:"paste"})}var g=!1,m="auto";c||(c=b,b=null);a.on("beforePaste",function(a){a.removeListener();g=!0;m=a.data.type},null,null,1E3);a.on("paste",e,null,null,0);!1===t()&&(a.removeListener("paste",e),a._.forcePasteDialog&&
g&&a.fire("pasteDialog")?(a.on("pasteDialogCommit",d),a.on("dialogHide",function(a){a.removeListener();a.data.removeListener("pasteDialogCommit",d);a.data._.committed||c(null)})):c(null))}}function y(a){if(CKEDITOR.env.webkit){if(!a.match(/^[^<]*$/g)&&!a.match(/^(<div><br( ?\/)?><\/div>|<div>[^<]*<\/div>)*$/gi))return"html"}else if(CKEDITOR.env.ie){if(!a.match(/^([^<]|<br( ?\/)?>)*$/gi)&&!a.match(/^(<p>([^<]|<br( ?\/)?>)*<\/p>|(\r\n))*$/gi))return"html"}else if(CKEDITOR.env.gecko){if(!a.match(/^([^<]|<br( ?\/)?>)*$/gi))return"html"}else return"html";
return"htmlifiedtext"}function z(a,b){function c(a){return CKEDITOR.tools.repeat("\x3c/p\x3e\x3cp\x3e",~~(a/2))+(1==a%2?"\x3cbr\x3e":"")}b=b.replace(/(?!\u3000)\s+/g," ").replace(/> +</g,"\x3e\x3c").replace(/<br ?\/>/gi,"\x3cbr\x3e");b=b.replace(/<\/?[A-Z]+>/g,function(a){return a.toLowerCase()});if(b.match(/^[^<]$/))return b;CKEDITOR.env.webkit&&-1<b.indexOf("\x3cdiv\x3e")&&(b=b.replace(/^(<div>(<br>|)<\/div>)(?!$|(<div>(<br>|)<\/div>))/g,"\x3cbr\x3e").replace(/^(<div>(<br>|)<\/div>){2}(?!$)/g,"\x3cdiv\x3e\x3c/div\x3e"),
b.match(/<div>(<br>|)<\/div>/)&&(b="\x3cp\x3e"+b.replace(/(<div>(<br>|)<\/div>)+/g,function(a){return c(a.split("\x3c/div\x3e\x3cdiv\x3e").length+1)})+"\x3c/p\x3e"),b=b.replace(/<\/div><div>/g,"\x3cbr\x3e"),b=b.replace(/<\/?div>/g,""));CKEDITOR.env.gecko&&a.enterMode!=CKEDITOR.ENTER_BR&&(CKEDITOR.env.gecko&&(b=b.replace(/^<br><br>$/,"\x3cbr\x3e")),-1<b.indexOf("\x3cbr\x3e\x3cbr\x3e")&&(b="\x3cp\x3e"+b.replace(/(<br>){2,}/g,function(a){return c(a.length/4)})+"\x3c/p\x3e"));return A(a,b)}function B(a){function b(){var a=
{},b;for(b in CKEDITOR.dtd)"$"!=b.charAt(0)&&"div"!=b&&"span"!=b&&(a[b]=1);return a}var c={};return{get:function(d){return"plain-text"==d?c.plainText||(c.plainText=new CKEDITOR.filter(a,"br")):"semantic-content"==d?((d=c.semanticContent)||(d=new CKEDITOR.filter(a,{}),d.allow({$1:{elements:b(),attributes:!0,styles:!1,classes:!1}}),d=c.semanticContent=d),d):d?new CKEDITOR.filter(a,d):null}}}function w(a,b,c){b=CKEDITOR.htmlParser.fragment.fromHtml(b);var d=new CKEDITOR.htmlParser.basicWriter;c.applyTo(b,
!0,!1,a.activeEnterMode);b.writeHtml(d);return d.getHtml()}function A(a,b){a.enterMode==CKEDITOR.ENTER_BR?b=b.replace(/(<\/p><p>)+/g,function(a){return CKEDITOR.tools.repeat("\x3cbr\x3e",a.length/7*2)}).replace(/<\/?p>/g,""):a.enterMode==CKEDITOR.ENTER_DIV&&(b=b.replace(/<(\/)?p>/g,"\x3c$1div\x3e"));return b}function C(a){a.data.preventDefault();a.data.$.dataTransfer.dropEffect="none"}function D(a){var b=CKEDITOR.plugins.clipboard;a.on("contentDom",function(){function c(b,c,e){c.select();r(a,{dataTransfer:e,
method:"drop"},1);e.sourceEditor.fire("saveSnapshot");e.sourceEditor.editable().extractHtmlFromRange(b);e.sourceEditor.getSelection().selectRanges([b]);e.sourceEditor.fire("saveSnapshot")}function d(c,e){c.select();r(a,{dataTransfer:e,method:"drop"},1);b.resetDragDataTransfer()}function f(b,c,e){var d={$:b.data.$,target:b.data.getTarget()};c&&(d.dragRange=c);e&&(d.dropRange=e);!1===a.fire(b.name,d)&&b.data.preventDefault()}function h(a){a.type!=CKEDITOR.NODE_ELEMENT&&(a=a.getParent());return a.getChildCount()}
var e=a.editable(),g=CKEDITOR.plugins.clipboard.getDropTarget(a),l=a.ui.space("top"),t=a.ui.space("bottom");b.preventDefaultDropOnElement(l);b.preventDefaultDropOnElement(t);e.attachListener(g,"dragstart",f);e.attachListener(a,"dragstart",b.resetDragDataTransfer,b,null,1);e.attachListener(a,"dragstart",function(c){b.initDragDataTransfer(c,a)},null,null,2);e.attachListener(a,"dragstart",function(){var c=b.dragRange=a.getSelection().getRanges()[0];CKEDITOR.env.ie&&10>CKEDITOR.env.version&&(b.dragStartContainerChildCount=
c?h(c.startContainer):null,b.dragEndContainerChildCount=c?h(c.endContainer):null)},null,null,100);e.attachListener(g,"dragend",f);e.attachListener(a,"dragend",b.initDragDataTransfer,b,null,1);e.attachListener(a,"dragend",b.resetDragDataTransfer,b,null,100);e.attachListener(g,"dragover",function(a){if(CKEDITOR.env.edge)a.data.preventDefault();else{var b=a.data.getTarget();b&&b.is&&b.is("html")?a.data.preventDefault():CKEDITOR.env.ie&&CKEDITOR.plugins.clipboard.isFileApiSupported&&a.data.$.dataTransfer.types.contains("Files")&&
a.data.preventDefault()}});e.attachListener(g,"drop",function(c){if(!c.data.$.defaultPrevented&&(c.data.preventDefault(),!a.readOnly)){var e=c.data.getTarget();if(!e.isReadOnly()||e.type==CKEDITOR.NODE_ELEMENT&&e.is("html")){var e=b.getRangeAtDropPosition(c,a),d=b.dragRange;e&&f(c,d,e)}}},null,null,9999);e.attachListener(a,"drop",b.initDragDataTransfer,b,null,1);e.attachListener(a,"drop",function(e){if(e=e.data){var g=e.dropRange,f=e.dragRange,l=e.dataTransfer;l.getTransferType(a)==CKEDITOR.DATA_TRANSFER_INTERNAL?
setTimeout(function(){b.internalDrop(f,g,l,a)},0):l.getTransferType(a)==CKEDITOR.DATA_TRANSFER_CROSS_EDITORS?c(f,g,l):d(g,l)}},null,null,9999)})}var n;CKEDITOR.plugins.add("clipboard",{requires:"dialog,notification,toolbar",init:function(a){function b(a){if(!a||h===a.id)return!1;var b=a.getTypes(),b=1===b.length&&"Files"===b[0];a=1===a.getFilesCount();return b&&a}var c,d=B(a);a.config.forcePasteAsPlainText?c="plain-text":a.config.pasteFilter?c=a.config.pasteFilter:!CKEDITOR.env.webkit||"pasteFilter"in
a.config||(c="semantic-content");a.pasteFilter=d.get(c);x(a);D(a);CKEDITOR.dialog.add("paste",CKEDITOR.getUrl(this.path+"dialogs/paste.js"));if(CKEDITOR.env.gecko){var f=["image/png","image/jpeg","image/gif"],h;a.on("paste",function(c){var d=c.data,l=d.dataTransfer;if(!d.dataValue&&"paste"==d.method&&b(l)&&(l=l.getFile(0),-1!=CKEDITOR.tools.indexOf(f,l.type))){var t=new FileReader;t.addEventListener("load",function(){c.data.dataValue='\x3cimg src\x3d"'+t.result+'" /\x3e';a.fire("paste",c.data)},!1);
t.addEventListener("abort",function(){a.fire("paste",c.data)},!1);t.addEventListener("error",function(){a.fire("paste",c.data)},!1);t.readAsDataURL(l);h=d.dataTransfer.id;c.stop()}},null,null,1)}a.on("paste",function(b){b.data.dataTransfer||(b.data.dataTransfer=new CKEDITOR.plugins.clipboard.dataTransfer);if(!b.data.dataValue){var c=b.data.dataTransfer,d=c.getData("text/html");if(d)b.data.dataValue=d,b.data.type="html";else if(d=c.getData("text/plain"))b.data.dataValue=a.editable().transformPlainTextToHtml(d),
b.data.type="text"}},null,null,1);a.on("paste",function(a){var b=a.data.dataValue,c=CKEDITOR.dtd.$block;-1<b.indexOf("Apple-")&&(b=b.replace(/<span class="Apple-converted-space">&nbsp;<\/span>/gi," "),"html"!=a.data.type&&(b=b.replace(/<span class="Apple-tab-span"[^>]*>([^<]*)<\/span>/gi,function(a,b){return b.replace(/\t/g,"\x26nbsp;\x26nbsp; \x26nbsp;")})),-1<b.indexOf('\x3cbr class\x3d"Apple-interchange-newline"\x3e')&&(a.data.startsWithEOL=1,a.data.preSniffing="html",b=b.replace(/<br class="Apple-interchange-newline">/,
"")),b=b.replace(/(<[^>]+) class="Apple-[^"]*"/gi,"$1"));if(b.match(/^<[^<]+cke_(editable|contents)/i)){var d,f,h=new CKEDITOR.dom.element("div");for(h.setHtml(b);1==h.getChildCount()&&(d=h.getFirst())&&d.type==CKEDITOR.NODE_ELEMENT&&(d.hasClass("cke_editable")||d.hasClass("cke_contents"));)h=f=d;f&&(b=f.getHtml().replace(/<br>$/i,""))}CKEDITOR.env.ie?b=b.replace(/^&nbsp;(?: |\r\n)?<(\w+)/g,function(b,d){return d.toLowerCase()in c?(a.data.preSniffing="html","\x3c"+d):b}):CKEDITOR.env.webkit?b=b.replace(/<\/(\w+)><div><br><\/div>$/,
function(b,d){return d in c?(a.data.endsWithEOL=1,"\x3c/"+d+"\x3e"):b}):CKEDITOR.env.gecko&&(b=b.replace(/(\s)<br>$/,"$1"));a.data.dataValue=b},null,null,3);a.on("paste",function(b){b=b.data;var c=a._.nextPasteType||b.type,f=b.dataValue,h,m=a.config.clipboard_defaultContentType||"html",k=b.dataTransfer.getTransferType(a)==CKEDITOR.DATA_TRANSFER_EXTERNAL,n=!0===a.config.forcePasteAsPlainText;h="html"==c||"html"==b.preSniffing?"html":y(f);delete a._.nextPasteType;"htmlifiedtext"==h&&(f=z(a.config,f));
if("text"==c&&"html"==h)f=w(a,f,d.get("plain-text"));else if(k&&a.pasteFilter&&!b.dontFilter||n)f=w(a,f,a.pasteFilter);b.startsWithEOL&&(f='\x3cbr data-cke-eol\x3d"1"\x3e'+f);b.endsWithEOL&&(f+='\x3cbr data-cke-eol\x3d"1"\x3e');"auto"==c&&(c="html"==h||"html"==m?"html":"text");b.type=c;b.dataValue=f;delete b.preSniffing;delete b.startsWithEOL;delete b.endsWithEOL},null,null,6);a.on("paste",function(b){b=b.data;b.dataValue&&(a.insertHtml(b.dataValue,b.type,b.range),setTimeout(function(){a.fire("afterPaste")},
0))},null,null,1E3);a.on("pasteDialog",function(b){setTimeout(function(){a.openDialog("paste",b.data)},0)})}});CKEDITOR.plugins.clipboard={isCustomCopyCutSupported:CKEDITOR.env.ie&&16>CKEDITOR.env.version||CKEDITOR.env.iOS&&605>CKEDITOR.env.version?!1:!0,isCustomDataTypesSupported:!CKEDITOR.env.ie||16<=CKEDITOR.env.version,isFileApiSupported:!CKEDITOR.env.ie||9<CKEDITOR.env.version,mainPasteEvent:CKEDITOR.env.ie&&!CKEDITOR.env.edge?"beforepaste":"paste",addPasteButton:function(a,b,c){a.ui.addButton&&
(a.ui.addButton(b,c),a._.pasteButtons||(a._.pasteButtons=[]),a._.pasteButtons.push(b))},canClipboardApiBeTrusted:function(a,b){return a.getTransferType(b)!=CKEDITOR.DATA_TRANSFER_EXTERNAL||CKEDITOR.env.chrome&&!a.isEmpty()||CKEDITOR.env.gecko&&(a.getData("text/html")||a.getFilesCount())||CKEDITOR.env.safari&&603<=CKEDITOR.env.version&&!CKEDITOR.env.iOS||CKEDITOR.env.iOS&&605<=CKEDITOR.env.version||CKEDITOR.env.edge&&16<=CKEDITOR.env.version?!0:!1},getDropTarget:function(a){var b=a.editable();return CKEDITOR.env.ie&&
9>CKEDITOR.env.version||b.isInline()?b:a.document},fixSplitNodesAfterDrop:function(a,b,c,d){function f(a,c,d){var f=a;f.type==CKEDITOR.NODE_TEXT&&(f=a.getParent());if(f.equals(c)&&d!=c.getChildCount())return a=b.startContainer.getChild(b.startOffset-1),c=b.startContainer.getChild(b.startOffset),a&&a.type==CKEDITOR.NODE_TEXT&&c&&c.type==CKEDITOR.NODE_TEXT&&(d=a.getLength(),a.setText(a.getText()+c.getText()),c.remove(),b.setStart(a,d),b.collapse(!0)),!0}var h=b.startContainer;"number"==typeof d&&"number"==
typeof c&&h.type==CKEDITOR.NODE_ELEMENT&&(f(a.startContainer,h,c)||f(a.endContainer,h,d))},isDropRangeAffectedByDragRange:function(a,b){var c=b.startContainer,d=b.endOffset;return a.endContainer.equals(c)&&a.endOffset<=d||a.startContainer.getParent().equals(c)&&a.startContainer.getIndex()<d||a.endContainer.getParent().equals(c)&&a.endContainer.getIndex()<d?!0:!1},internalDrop:function(a,b,c,d){var f=CKEDITOR.plugins.clipboard,h=d.editable(),e,g;d.fire("saveSnapshot");d.fire("lockSnapshot",{dontUpdate:1});
CKEDITOR.env.ie&&10>CKEDITOR.env.version&&this.fixSplitNodesAfterDrop(a,b,f.dragStartContainerChildCount,f.dragEndContainerChildCount);(g=this.isDropRangeAffectedByDragRange(a,b))||(e=a.createBookmark(!1));f=b.clone().createBookmark(!1);g&&(e=a.createBookmark(!1));a=e.startNode;b=e.endNode;g=f.startNode;b&&a.getPosition(g)&CKEDITOR.POSITION_PRECEDING&&b.getPosition(g)&CKEDITOR.POSITION_FOLLOWING&&g.insertBefore(a);a=d.createRange();a.moveToBookmark(e);h.extractHtmlFromRange(a,1);b=d.createRange();
f.startNode.getCommonAncestor(h)||(f=d.getSelection().createBookmarks()[0]);b.moveToBookmark(f);r(d,{dataTransfer:c,method:"drop",range:b},1);d.fire("unlockSnapshot")},getRangeAtDropPosition:function(a,b){var c=a.data.$,d=c.clientX,f=c.clientY,h=b.getSelection(!0).getRanges()[0],e=b.createRange();if(a.data.testRange)return a.data.testRange;if(document.caretRangeFromPoint&&b.document.$.caretRangeFromPoint(d,f))c=b.document.$.caretRangeFromPoint(d,f),e.setStart(CKEDITOR.dom.node(c.startContainer),c.startOffset),
e.collapse(!0);else if(c.rangeParent)e.setStart(CKEDITOR.dom.node(c.rangeParent),c.rangeOffset),e.collapse(!0);else{if(CKEDITOR.env.ie&&8<CKEDITOR.env.version&&h&&b.editable().hasFocus)return h;if(document.body.createTextRange){b.focus();c=b.document.getBody().$.createTextRange();try{for(var g=!1,l=0;20>l&&!g;l++){if(!g)try{c.moveToPoint(d,f-l),g=!0}catch(n){}if(!g)try{c.moveToPoint(d,f+l),g=!0}catch(m){}}if(g){var k="cke-temp-"+(new Date).getTime();c.pasteHTML('\x3cspan id\x3d"'+k+'"\x3e​\x3c/span\x3e');
var u=b.document.getById(k);e.moveToPosition(u,CKEDITOR.POSITION_BEFORE_START);u.remove()}else{var q=b.document.$.elementFromPoint(d,f),p=new CKEDITOR.dom.element(q),r;if(p.equals(b.editable())||"html"==p.getName())return h&&h.startContainer&&!h.startContainer.equals(b.editable())?h:null;r=p.getClientRect();d<r.left?e.setStartAt(p,CKEDITOR.POSITION_AFTER_START):e.setStartAt(p,CKEDITOR.POSITION_BEFORE_END);e.collapse(!0)}}catch(v){return null}}else return null}return e},initDragDataTransfer:function(a,
b){var c=a.data.$?a.data.$.dataTransfer:null,d=new this.dataTransfer(c,b);"dragstart"===a.name&&d.storeId();c?this.dragData&&d.id==this.dragData.id?d=this.dragData:this.dragData=d:this.dragData?d=this.dragData:this.dragData=d;a.data.dataTransfer=d},resetDragDataTransfer:function(){this.dragData=null},initPasteDataTransfer:function(a,b){if(this.isCustomCopyCutSupported){if(a&&a.data&&a.data.$){var c=a.data.$.clipboardData,d=new this.dataTransfer(c,b);"copy"!==a.name&&"cut"!==a.name||d.storeId();this.copyCutData&&
d.id==this.copyCutData.id?(d=this.copyCutData,d.$=c):this.copyCutData=d;return d}return new this.dataTransfer(null,b)}return new this.dataTransfer(CKEDITOR.env.edge&&a&&a.data.$&&a.data.$.clipboardData||null,b)},preventDefaultDropOnElement:function(a){a&&a.on("dragover",C)}};n=CKEDITOR.plugins.clipboard.isCustomDataTypesSupported?"cke/id":"Text";CKEDITOR.plugins.clipboard.dataTransfer=function(a,b){a&&(this.$=a);this._={metaRegExp:/^<meta.*?>/i,bodyRegExp:/<body(?:[\s\S]*?)>([\s\S]*)<\/body>/i,fragmentRegExp:/\s*\x3c!--StartFragment--\x3e|\x3c!--EndFragment--\x3e\s*/g,
data:{},files:[],nativeHtmlCache:"",normalizeType:function(a){a=a.toLowerCase();return"text"==a||"text/plain"==a?"Text":"url"==a?"URL":a}};this._.fallbackDataTransfer=new CKEDITOR.plugins.clipboard.fallbackDataTransfer(this);this.id=this.getData(n);this.id||(this.id="Text"==n?"":"cke-"+CKEDITOR.tools.getUniqueId());b&&(this.sourceEditor=b,this.setData("text/html",b.getSelectedHtml(1)),"Text"==n||this.getData("text/plain")||this.setData("text/plain",b.getSelection().getSelectedText()))};CKEDITOR.DATA_TRANSFER_INTERNAL=
1;CKEDITOR.DATA_TRANSFER_CROSS_EDITORS=2;CKEDITOR.DATA_TRANSFER_EXTERNAL=3;CKEDITOR.plugins.clipboard.dataTransfer.prototype={getData:function(a,b){a=this._.normalizeType(a);var c="text/html"==a&&b?this._.nativeHtmlCache:this._.data[a];if(void 0===c||null===c||""===c){if(this._.fallbackDataTransfer.isRequired())c=this._.fallbackDataTransfer.getData(a,b);else try{c=this.$.getData(a)||""}catch(d){c=""}"text/html"!=a||b||(c=this._stripHtml(c))}"Text"==a&&CKEDITOR.env.gecko&&this.getFilesCount()&&"file://"==
c.substring(0,7)&&(c="");if("string"===typeof c)var f=c.indexOf("\x3c/html\x3e"),c=-1!==f?c.substring(0,f+7):c;return c},setData:function(a,b){a=this._.normalizeType(a);"text/html"==a?(this._.data[a]=this._stripHtml(b),this._.nativeHtmlCache=b):this._.data[a]=b;if(CKEDITOR.plugins.clipboard.isCustomDataTypesSupported||"URL"==a||"Text"==a)if("Text"==n&&"Text"==a&&(this.id=b),this._.fallbackDataTransfer.isRequired())this._.fallbackDataTransfer.setData(a,b);else try{this.$.setData(a,b)}catch(c){}},storeId:function(){"Text"!==
n&&this.setData(n,this.id)},getTransferType:function(a){return this.sourceEditor?this.sourceEditor==a?CKEDITOR.DATA_TRANSFER_INTERNAL:CKEDITOR.DATA_TRANSFER_CROSS_EDITORS:CKEDITOR.DATA_TRANSFER_EXTERNAL},cacheData:function(){function a(a){a=b._.normalizeType(a);var c=b.getData(a);"text/html"==a&&(b._.nativeHtmlCache=b.getData(a,!0),c=b._stripHtml(c));c&&(b._.data[a]=c)}if(this.$){var b=this,c,d;if(CKEDITOR.plugins.clipboard.isCustomDataTypesSupported){if(this.$.types)for(c=0;c<this.$.types.length;c++)a(this.$.types[c])}else a("Text"),
a("URL");d=this._getImageFromClipboard();if(this.$&&this.$.files||d){this._.files=[];if(this.$.files&&this.$.files.length)for(c=0;c<this.$.files.length;c++)this._.files.push(this.$.files[c]);0===this._.files.length&&d&&this._.files.push(d)}}},getFilesCount:function(){return this._.files.length?this._.files.length:this.$&&this.$.files&&this.$.files.length?this.$.files.length:this._getImageFromClipboard()?1:0},getFile:function(a){return this._.files.length?this._.files[a]:this.$&&this.$.files&&this.$.files.length?
this.$.files[a]:0===a?this._getImageFromClipboard():void 0},isEmpty:function(){var a={},b;if(this.getFilesCount())return!1;CKEDITOR.tools.array.forEach(CKEDITOR.tools.object.keys(this._.data),function(b){a[b]=1});if(this.$)if(CKEDITOR.plugins.clipboard.isCustomDataTypesSupported){if(this.$.types)for(var c=0;c<this.$.types.length;c++)a[this.$.types[c]]=1}else a.Text=1,a.URL=1;"Text"!=n&&(a[n]=0);for(b in a)if(a[b]&&""!==this.getData(b))return!1;return!0},getTypes:function(){return this.$&&this.$.types?
[].slice.call(this.$.types):[]},_getImageFromClipboard:function(){var a;try{if(this.$&&this.$.items&&this.$.items[0]&&(a=this.$.items[0].getAsFile())&&a.type)return a}catch(b){}},_stripHtml:function(a){if(a&&a.length){a=a.replace(this._.metaRegExp,"");var b=this._.bodyRegExp.exec(a);b&&b.length&&(a=b[1],a=a.replace(this._.fragmentRegExp,""))}return a}};CKEDITOR.plugins.clipboard.fallbackDataTransfer=function(a){this._dataTransfer=a;this._customDataFallbackType="text/html"};CKEDITOR.plugins.clipboard.fallbackDataTransfer._isCustomMimeTypeSupported=
null;CKEDITOR.plugins.clipboard.fallbackDataTransfer._customTypes=[];CKEDITOR.plugins.clipboard.fallbackDataTransfer.prototype={isRequired:function(){var a=CKEDITOR.plugins.clipboard.fallbackDataTransfer,b=this._dataTransfer.$;if(null===a._isCustomMimeTypeSupported)if(b){a._isCustomMimeTypeSupported=!1;if(CKEDITOR.env.edge&&17<=CKEDITOR.env.version)return!0;try{b.setData("cke/mimetypetest","cke test value"),a._isCustomMimeTypeSupported="cke test value"===b.getData("cke/mimetypetest"),b.clearData("cke/mimetypetest")}catch(c){}}else return!1;
return!a._isCustomMimeTypeSupported},getData:function(a,b){var c=this._getData(this._customDataFallbackType,!0);if(b)return c;var c=this._extractDataComment(c),d=null,d=a===this._customDataFallbackType?c.content:c.data&&c.data[a]?c.data[a]:this._getData(a,!0);return null!==d?d:""},setData:function(a,b){var c=a===this._customDataFallbackType;c&&(b=this._applyDataComment(b,this._getFallbackTypeData()));var d=b,f=this._dataTransfer.$;try{f.setData(a,d),c&&(this._dataTransfer._.nativeHtmlCache=d)}catch(h){if(this._isUnsupportedMimeTypeError(h)){c=
CKEDITOR.plugins.clipboard.fallbackDataTransfer;-1===CKEDITOR.tools.indexOf(c._customTypes,a)&&c._customTypes.push(a);var c=this._getFallbackTypeContent(),e=this._getFallbackTypeData();e[a]=d;try{d=this._applyDataComment(c,e),f.setData(this._customDataFallbackType,d),this._dataTransfer._.nativeHtmlCache=d}catch(g){d=""}}}return d},_getData:function(a,b){var c=this._dataTransfer._.data;if(!b&&c[a])return c[a];try{return this._dataTransfer.$.getData(a)}catch(d){return null}},_getFallbackTypeContent:function(){var a=
this._dataTransfer._.data[this._customDataFallbackType];a||(a=this._extractDataComment(this._getData(this._customDataFallbackType,!0)).content);return a},_getFallbackTypeData:function(){var a=CKEDITOR.plugins.clipboard.fallbackDataTransfer._customTypes,b=this._extractDataComment(this._getData(this._customDataFallbackType,!0)).data||{},c=this._dataTransfer._.data;CKEDITOR.tools.array.forEach(a,function(a){void 0!==c[a]?b[a]=c[a]:void 0!==b[a]&&(b[a]=b[a])},this);return b},_isUnsupportedMimeTypeError:function(a){return a.message&&
-1!==a.message.search(/element not found/gi)},_extractDataComment:function(a){var b={data:null,content:a||""};if(a&&16<a.length){var c;(c=/\x3c!--cke-data:(.*?)--\x3e/g.exec(a))&&c[1]&&(b.data=JSON.parse(decodeURIComponent(c[1])),b.content=a.replace(c[0],""))}return b},_applyDataComment:function(a,b){var c="";b&&CKEDITOR.tools.object.keys(b).length&&(c="\x3c!--cke-data:"+encodeURIComponent(JSON.stringify(b))+"--\x3e");return c+(a&&a.length?a:"")}}})();
CKEDITOR.config.clipboard_notificationDuration=1E4;CKEDITOR.plugins.add("panelbutton",{requires:"button",onLoad:function(){function e(c){var b=this._;b.state!=CKEDITOR.TRISTATE_DISABLED&&(this.createPanel(c),b.on?b.panel.hide():b.panel.showBlock(this._.id,this.document.getById(this._.id),4))}CKEDITOR.ui.panelButton=CKEDITOR.tools.createClass({base:CKEDITOR.ui.button,$:function(c){var b=c.panel||{};delete c.panel;this.base(c);this.document=b.parent&&b.parent.getDocument()||CKEDITOR.document;b.block={attributes:b.attributes};b.toolbarRelated=!0;this.hasArrow=
"listbox";this.click=e;this._={panelDefinition:b}},statics:{handler:{create:function(c){return new CKEDITOR.ui.panelButton(c)}}},proto:{createPanel:function(c){var b=this._;if(!b.panel){var f=this._.panelDefinition,e=this._.panelDefinition.block,h=f.parent||CKEDITOR.document.getBody(),d=this._.panel=new CKEDITOR.ui.floatPanel(c,h,f),f=d.addBlock(b.id,e),a=this,g=c.getCommand(this.command);d.onShow=function(){a.className&&this.element.addClass(a.className+"_panel");a.setState(CKEDITOR.TRISTATE_ON);
b.on=1;a.editorFocus&&c.focus();if(a.onOpen)a.onOpen()};d.onHide=function(d){a.className&&this.element.getFirst().removeClass(a.className+"_panel");!a.modes&&g?a.setStateFromCommand(g):a.setState(a.modes&&a.modes[c.mode]?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED);b.on=0;if(!d&&a.onClose)a.onClose()};d.onEscape=function(){d.hide(1);a.document.getById(b.id).focus()};if(this.onBlock)this.onBlock(d,f);f.onHide=function(){b.on=0;!a.modes&&a.command?a.setStateFromCommand(g):a.setState(CKEDITOR.TRISTATE_OFF)}}},
setStateFromCommand:function(c){this.setState(c.state)}}})},beforeInit:function(e){e.ui.addHandler(CKEDITOR.UI_PANELBUTTON,CKEDITOR.ui.panelButton.handler)}});CKEDITOR.UI_PANELBUTTON="panelbutton";(function(){CKEDITOR.plugins.add("panel",{beforeInit:function(a){a.ui.addHandler(CKEDITOR.UI_PANEL,CKEDITOR.ui.panel.handler)}});CKEDITOR.UI_PANEL="panel";CKEDITOR.ui.panel=function(a,b){b&&CKEDITOR.tools.extend(this,b);CKEDITOR.tools.extend(this,{className:"",css:[]});this.id=CKEDITOR.tools.getNextId();this.document=a;this.isFramed=this.forceIFrame||this.css.length;this._={blocks:{}}};CKEDITOR.ui.panel.handler={create:function(a){return new CKEDITOR.ui.panel(a)}};var g=CKEDITOR.addTemplate("panel",
'\x3cdiv lang\x3d"{langCode}" id\x3d"{id}" dir\x3d{dir} class\x3d"cke cke_reset_all {editorId} cke_panel cke_panel {cls} cke_{dir}" style\x3d"z-index:{z-index}" role\x3d"presentation"\x3e{frame}\x3c/div\x3e'),h=CKEDITOR.addTemplate("panel-frame",'\x3ciframe id\x3d"{id}" class\x3d"cke_panel_frame" role\x3d"presentation" frameborder\x3d"0" src\x3d"{src}"\x3e\x3c/iframe\x3e'),k=CKEDITOR.addTemplate("panel-frame-inner",'\x3c!DOCTYPE html\x3e\x3chtml class\x3d"cke_panel_container {env}" dir\x3d"{dir}" lang\x3d"{langCode}"\x3e\x3chead\x3e{css}\x3c/head\x3e\x3cbody class\x3d"cke_{dir}" style\x3d"margin:0;padding:0" onload\x3d"{onload}"\x3e\x3c/body\x3e\x3c/html\x3e');
CKEDITOR.ui.panel.prototype={render:function(a,b){var e={editorId:a.id,id:this.id,langCode:a.langCode,dir:a.lang.dir,cls:this.className,frame:"",env:CKEDITOR.env.cssClass,"z-index":a.config.baseFloatZIndex+1};this.getHolderElement=function(){var a=this._.holder;if(!a){if(this.isFramed){var a=this.document.getById(this.id+"_frame"),b=a.getParent(),a=a.getFrameDocument();CKEDITOR.env.iOS&&b.setStyles({overflow:"scroll","-webkit-overflow-scrolling":"touch"});b=CKEDITOR.tools.addFunction(CKEDITOR.tools.bind(function(){this.isLoaded=
!0;if(this.onLoad)this.onLoad()},this));a.write(k.output(CKEDITOR.tools.extend({css:CKEDITOR.tools.buildStyleHtml(this.css),onload:"window.parent.CKEDITOR.tools.callFunction("+b+");"},e)));a.getWindow().$.CKEDITOR=CKEDITOR;a.on("keydown",function(a){var b=a.data.getKeystroke(),c=this.document.getById(this.id).getAttribute("dir");if("input"!==a.data.getTarget().getName()||37!==b&&39!==b)this._.onKeyDown&&!1===this._.onKeyDown(b)?"input"===a.data.getTarget().getName()&&32===b||a.data.preventDefault():
(27==b||b==("rtl"==c?39:37))&&this.onEscape&&!1===this.onEscape(b)&&a.data.preventDefault()},this);a=a.getBody();a.unselectable();CKEDITOR.env.air&&CKEDITOR.tools.callFunction(b)}else a=this.document.getById(this.id);this._.holder=a}return a};if(this.isFramed){var d=CKEDITOR.env.air?"javascript:void(0)":CKEDITOR.env.ie&&!CKEDITOR.env.edge?"javascript:void(function(){"+encodeURIComponent("document.open();("+CKEDITOR.tools.fixDomain+")();document.close();")+"}())":"";e.frame=h.output({id:this.id+"_frame",
src:d})}d=g.output(e);b&&b.push(d);return d},addBlock:function(a,b){b=this._.blocks[a]=b instanceof CKEDITOR.ui.panel.block?b:new CKEDITOR.ui.panel.block(this.getHolderElement(),b);this._.currentBlock||this.showBlock(a);return b},getBlock:function(a){return this._.blocks[a]},showBlock:function(a){a=this._.blocks[a];var b=this._.currentBlock,e=!this.forceIFrame||CKEDITOR.env.ie?this._.holder:this.document.getById(this.id+"_frame");b&&b.hide();this._.currentBlock=a;CKEDITOR.fire("ariaWidget",e);a._.focusIndex=
-1;this._.onKeyDown=a.onKeyDown&&CKEDITOR.tools.bind(a.onKeyDown,a);a.show();return a},destroy:function(){this.element&&this.element.remove()}};CKEDITOR.ui.panel.block=CKEDITOR.tools.createClass({$:function(a,b){this.element=a.append(a.getDocument().createElement("div",{attributes:{tabindex:-1,"class":"cke_panel_block"},styles:{display:"none"}}));b&&CKEDITOR.tools.extend(this,b);this.element.setAttributes({role:this.attributes.role||"presentation","aria-label":this.attributes["aria-label"],title:this.attributes.title||
this.attributes["aria-label"]});this.keys={};this._.focusIndex=-1;this.element.disableContextMenu()},_:{markItem:function(a){-1!=a&&(a=this._.getItems().getItem(this._.focusIndex=a),CKEDITOR.env.webkit&&a.getDocument().getWindow().focus(),a.focus(),this.onMark&&this.onMark(a))},markFirstDisplayed:function(a){for(var b=function(a){return a.type==CKEDITOR.NODE_ELEMENT&&"none"==a.getStyle("display")},e=this._.getItems(),d,c,f=e.count()-1;0<=f;f--)if(d=e.getItem(f),d.getAscendant(b)||(c=d,this._.focusIndex=
f),"true"==d.getAttribute("aria-selected")){c=d;this._.focusIndex=f;break}c&&(a&&a(),CKEDITOR.env.webkit&&c.getDocument().getWindow().focus(),c.focus(),this.onMark&&this.onMark(c))},getItems:function(){return this.element.find("a,input")}},proto:{show:function(){this.element.setStyle("display","")},hide:function(){this.onHide&&!0===this.onHide.call(this)||this.element.setStyle("display","none")},onKeyDown:function(a,b){var e=this.keys[a];switch(e){case "next":for(var d=this._.focusIndex,e=this._.getItems(),
c;c=e.getItem(++d);)if(c.getAttribute("_cke_focus")&&c.$.offsetWidth){this._.focusIndex=d;c.focus(!0);break}return c||b?!1:(this._.focusIndex=-1,this.onKeyDown(a,1));case "prev":d=this._.focusIndex;for(e=this._.getItems();0<d&&(c=e.getItem(--d));){if(c.getAttribute("_cke_focus")&&c.$.offsetWidth){this._.focusIndex=d;c.focus(!0);break}c=null}return c||b?!1:(this._.focusIndex=e.count(),this.onKeyDown(a,1));case "click":case "mouseup":return d=this._.focusIndex,(c=0<=d&&this._.getItems().getItem(d))&&
c.fireEventHandler(e,{button:CKEDITOR.tools.normalizeMouseButton(CKEDITOR.MOUSE_BUTTON_LEFT,!0)}),!1}return!0}}})})();CKEDITOR.plugins.add("floatpanel",{requires:"panel"});
(function(){function v(a,b,c,m,h){h=CKEDITOR.tools.genKey(b.getUniqueId(),c.getUniqueId(),a.lang.dir,a.uiColor||"",m.css||"",h||"");var g=f[h];g||(g=f[h]=new CKEDITOR.ui.panel(b,m),g.element=c.append(CKEDITOR.dom.element.createFromHtml(g.render(a),b)),g.element.setStyles({display:"none",position:"absolute"}));return g}var f={};CKEDITOR.ui.floatPanel=CKEDITOR.tools.createClass({$:function(a,b,c,m){function h(){e.hide()}c.forceIFrame=1;c.toolbarRelated&&a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE&&
(b=CKEDITOR.document.getById("cke_"+a.name));var g=b.getDocument();m=v(a,g,b,c,m||0);var n=m.element,l=n.getFirst(),e=this;n.disableContextMenu();this.element=n;this._={editor:a,panel:m,parentElement:b,definition:c,document:g,iframe:l,children:[],dir:a.lang.dir,showBlockParams:null,markFirst:void 0!==c.markFirst?c.markFirst:!0};a.on("mode",h);a.on("resize",h);g.getWindow().on("resize",function(){this.reposition()},this)},proto:{addBlock:function(a,b){return this._.panel.addBlock(a,b)},addListBlock:function(a,
b){return this._.panel.addListBlock(a,b)},getBlock:function(a){return this._.panel.getBlock(a)},showBlock:function(a,b,c,m,h,g){var n=this._.panel,l=n.showBlock(a);this._.showBlockParams=[].slice.call(arguments);this.allowBlur(!1);var e=this._.editor.editable();this._.returnFocus=e.hasFocus?e:new CKEDITOR.dom.element(CKEDITOR.document.$.activeElement);this._.hideTimeout=0;var k=this.element,e=this._.iframe,e=CKEDITOR.env.ie&&!CKEDITOR.env.edge?e:new CKEDITOR.dom.window(e.$.contentWindow),f=k.getDocument(),
r=this._.parentElement.getPositionedAncestor(),t=b.getDocumentPosition(f),f=r?r.getDocumentPosition(f):{x:0,y:0},q="rtl"==this._.dir,d=t.x+(m||0)-f.x,p=t.y+(h||0)-f.y;!q||1!=c&&4!=c?q||2!=c&&3!=c||(d+=b.$.offsetWidth-1):d+=b.$.offsetWidth;if(3==c||4==c)p+=b.$.offsetHeight-1;this._.panel._.offsetParentId=b.getId();k.setStyles({top:p+"px",left:0,display:""});k.setOpacity(0);k.getFirst().removeStyle("width");this._.editor.focusManager.add(e);this._.blurSet||(CKEDITOR.event.useCapture=!0,e.on("blur",
function(a){function u(){delete this._.returnFocus;this.hide()}this.allowBlur()&&a.data.getPhase()==CKEDITOR.EVENT_PHASE_AT_TARGET&&this.visible&&!this._.activeChild&&(CKEDITOR.env.iOS?this._.hideTimeout||(this._.hideTimeout=CKEDITOR.tools.setTimeout(u,0,this)):u.call(this))},this),e.on("focus",function(){this._.focused=!0;this.hideChild();this.allowBlur(!0)},this),CKEDITOR.env.iOS&&(e.on("touchstart",function(){clearTimeout(this._.hideTimeout)},this),e.on("touchend",function(){this._.hideTimeout=
0;this.focus()},this)),CKEDITOR.event.useCapture=!1,this._.blurSet=1);n.onEscape=CKEDITOR.tools.bind(function(a){if(this.onEscape&&!1===this.onEscape(a))return!1},this);CKEDITOR.tools.setTimeout(function(){var a=CKEDITOR.tools.bind(function(){var a=k;a.removeStyle("width");if(l.autoSize){var b=l.element.getDocument(),b=(CKEDITOR.env.webkit||CKEDITOR.env.edge?l.element:b.getBody()).$.scrollWidth;CKEDITOR.env.ie&&CKEDITOR.env.quirks&&0<b&&(b+=(a.$.offsetWidth||0)-(a.$.clientWidth||0)+3);a.setStyle("width",
b+10+"px");b=l.element.$.scrollHeight;CKEDITOR.env.ie&&CKEDITOR.env.quirks&&0<b&&(b+=(a.$.offsetHeight||0)-(a.$.clientHeight||0)+3);a.setStyle("height",b+"px");n._.currentBlock.element.setStyle("display","none").removeStyle("display")}else a.removeStyle("height");q&&(d-=k.$.offsetWidth);k.setStyle("left",d+"px");var b=n.element.getWindow(),a=k.$.getBoundingClientRect(),b=b.getViewPaneSize(),c=a.width||a.right-a.left,e=a.height||a.bottom-a.top,m=q?a.right:b.width-a.left,h=q?b.width-a.right:a.left;
q?m<c&&(d=h>c?d+c:b.width>c?d-a.left:d-a.right+b.width):m<c&&(d=h>c?d-c:b.width>c?d-a.right+b.width:d-a.left);c=a.top;b.height-a.top<e&&(p=c>e?p-e:b.height>e?p-a.bottom+b.height:p-a.top);CKEDITOR.env.ie&&!CKEDITOR.env.edge&&((b=a=k.$.offsetParent&&new CKEDITOR.dom.element(k.$.offsetParent))&&"html"==b.getName()&&(b=b.getDocument().getBody()),b&&"rtl"==b.getComputedStyle("direction")&&(d=CKEDITOR.env.ie8Compat?d-2*k.getDocument().getDocumentElement().$.scrollLeft:d-(a.$.scrollWidth-a.$.clientWidth)));
var a=k.getFirst(),f;(f=a.getCustomData("activePanel"))&&f.onHide&&f.onHide.call(this,1);a.setCustomData("activePanel",this);k.setStyles({top:p+"px",left:d+"px"});k.setOpacity(1);g&&g()},this);n.isLoaded?a():n.onLoad=a;CKEDITOR.tools.setTimeout(function(){var a=CKEDITOR.env.webkit&&CKEDITOR.document.getWindow().getScrollPosition().y;this.focus();l.element.focus();CKEDITOR.env.webkit&&(CKEDITOR.document.getBody().$.scrollTop=a);this.allowBlur(!0);this._.markFirst&&(CKEDITOR.env.ie?CKEDITOR.tools.setTimeout(function(){l.markFirstDisplayed?
l.markFirstDisplayed():l._.markFirstDisplayed()},0):l.markFirstDisplayed?l.markFirstDisplayed():l._.markFirstDisplayed());this._.editor.fire("panelShow",this)},0,this)},CKEDITOR.env.air?200:0,this);this.visible=1;this.onShow&&this.onShow.call(this)},reposition:function(){var a=this._.showBlockParams;this.visible&&this._.showBlockParams&&(this.hide(),this.showBlock.apply(this,a))},focus:function(){if(CKEDITOR.env.webkit){var a=CKEDITOR.document.getActive();a&&!a.equals(this._.iframe)&&a.$.blur()}(this._.lastFocused||
this._.iframe.getFrameDocument().getWindow()).focus()},blur:function(){var a=this._.iframe.getFrameDocument().getActive();a&&a.is("a")&&(this._.lastFocused=a)},hide:function(a){if(this.visible&&(!this.onHide||!0!==this.onHide.call(this))){this.hideChild();CKEDITOR.env.gecko&&this._.iframe.getFrameDocument().$.activeElement.blur();this.element.setStyle("display","none");this.visible=0;this.element.getFirst().removeCustomData("activePanel");if(a=a&&this._.returnFocus)CKEDITOR.env.webkit&&a.type&&a.getWindow().$.focus(),
a.focus();delete this._.lastFocused;this._.showBlockParams=null;this._.editor.fire("panelHide",this)}},allowBlur:function(a){var b=this._.panel;void 0!==a&&(b.allowBlur=a);return b.allowBlur},showAsChild:function(a,b,c,f,h,g){if(this._.activeChild!=a||a._.panel._.offsetParentId!=c.getId())this.hideChild(),a.onHide=CKEDITOR.tools.bind(function(){CKEDITOR.tools.setTimeout(function(){this._.focused||this.hide()},0,this)},this),this._.activeChild=a,this._.focused=!1,a.showBlock(b,c,f,h,g),this.blur(),
(CKEDITOR.env.ie7Compat||CKEDITOR.env.ie6Compat)&&setTimeout(function(){a.element.getChild(0).$.style.cssText+=""},100)},hideChild:function(a){var b=this._.activeChild;b&&(delete b.onHide,delete this._.activeChild,b.hide(),a&&this.focus())}}});CKEDITOR.on("instanceDestroyed",function(){var a=CKEDITOR.tools.isEmpty(CKEDITOR.instances),b;for(b in f){var c=f[b];a?c.destroy():c.element.hide()}a&&(f={})})})();(function(){var q,k,l;CKEDITOR.plugins.add("colorbutton",{requires:"panelbutton,floatpanel",init:function(a){function b(d){function b(){var d=a.config["colorButton_"+h+"Style"];d.childRule="back"==h?function(a){return f(a)}:function(a){return!(a.is("a")||a.getElementsByTag("a").count())||f(a)};return d}function A(d,x,e){var c={};d&&(c.color=d);x&&(c.colorName=x);x=!CKEDITOR.tools.isEmpty(c)&&new CKEDITOR.style(b(),c);a.execCommand(m,{newStyle:x});if(d&&e)for(e.addColor(d.substr(1).toUpperCase()),
d=t.element.find("[role\x3doption]").toArray(),e=0;e<d.length;e++)d[e].setAttributes({"aria-posinset":e+1,"aria-setsize":d.length})}var g=d.name,h=d.type,k=d.title,C=d.order,m=d.commandName;d=d.contentTransformations||{};var B=new CKEDITOR.style(r["colorButton_"+h+"Style"]),q=CKEDITOR.tools.getNextId()+"_colorBox",y={type:h},z=new CKEDITOR.style(r["colorButton_"+h+"Style"],{color:"inherit"}),w=function(){return CKEDITOR.tools.addFunction(function(d,b,e){a.focus();a.fire("saveSnapshot");"?"==d?a.getColorFromDialog(function(a){a&&
A(a,b,u)},null,y):A(d&&"#"+d,b,u);e&&(e.setAttribute("cke_colorlast",!0),a.once("selectionChange",function(){e.removeAttribute("cke_colorlast")}))})}(),u=l.getRowLimit(a)?new l(a,"back"==h?"background-color":"color",w):void 0,t;a.addCommand(m,{contextSensitive:!0,exec:function(a,d){if(!a.readOnly){var b=d.newStyle;a.removeStyle(z);a.focus();b&&a.applyStyle(b);a.fire("saveSnapshot")}},refresh:function(a,d){z.checkApplicable(d,a,a.activeFilter)?z.checkActive(d,a)?this.setState(CKEDITOR.TRISTATE_ON):
this.setState(CKEDITOR.TRISTATE_OFF):this.setState(CKEDITOR.TRISTATE_DISABLED)}});a.ui.add(g,CKEDITOR.UI_PANELBUTTON,{label:k,title:k,command:m,editorFocus:0,toolbar:"colors,"+C,allowedContent:B,requiredContent:B,contentTransformations:d,panel:{css:CKEDITOR.skin.getPath("editor"),attributes:{role:"listbox","aria-label":n.panelTitle}},select:function(a){var d=r.colorButton_colors.split(",");a=CKEDITOR.tools.array.find(d,a);a=p(a);v(t,a);t._.markFirstDisplayed()},onBlock:function(d,b){t=b;b.autoSize=
!0;b.element.addClass("cke_colorblock");b.element.setHtml(c(q,w,u?u.getLength():0));b.element.getDocument().getBody().setStyle("overflow","hidden");CKEDITOR.ui.fire("ready",this);var e=b.keys,h="rtl"==a.lang.dir;e[h?37:39]="next";e[40]="next";e[9]="next";e[h?39:37]="prev";e[38]="prev";e[CKEDITOR.SHIFT+9]="prev";e[32]="click";u&&u.setContainer(b.element.findOne(".cke_colorhistory"))},onOpen:function(){var d=a.getSelection(),b=d&&d.getStartElement(),e=a.elementPath(b),c="back"==h?"background-color":
"color";if(e){b=e.block||e.blockLimit||a.document.getBody();do e=b&&b.getComputedStyle(c)||"transparent";while("back"==h&&"transparent"==e&&b&&(b=b.getParent()));e&&"transparent"!=e||(e="#ffffff");r.colorButton_enableAutomatic&&t.element.findOne("#"+q).setStyle("background-color",e);if(b=d&&d.getRanges()[0]){for(var d=new CKEDITOR.dom.walker(b),g=b.collapsed?b.startContainer:d.next(),b="";g;){g.type!==CKEDITOR.NODE_ELEMENT&&(g=g.getParent());g=p(g.getComputedStyle(c));b=b||g;if(b!==g){b="";break}g=
d.next()}"transparent"==b&&(b="");"fore"==h&&(y.automaticTextColor="#"+p(e));y.selectionColor=b?"#"+b:"";v(t,b)}return e}}})}function c(b,c,f){var g=[],h=r.colorButton_colors.split(","),k=a.plugins.colordialog&&r.colorButton_enableMore;f=h.length+f+(k?1:0);var p=1;r.colorButton_enableAutomatic&&(f+=1,p+=1,g.push('\x3ca class\x3d"cke_colorauto" _cke_focus\x3d1 hidefocus\x3dtrue',' title\x3d"',n.auto,'"',' draggable\x3d"false"',' ondragstart\x3d"return false;"',' onclick\x3d"CKEDITOR.tools.callFunction(',
c,',null);return false;"'," href\x3d\"javascript:void('",n.auto,"')\"",' role\x3d"option" aria-posinset\x3d"1" aria-setsize\x3d"',f,'"\x3e','\x3ctable role\x3d"presentation" cellspacing\x3d0 cellpadding\x3d0 width\x3d"100%"\x3e',"\x3ctr\x3e",'\x3ctd colspan\x3d"',a.config.colorButton_colorsPerRow,'" align\x3d"center"\x3e','\x3cspan class\x3d"cke_colorbox" id\x3d"',b,'"\x3e\x3c/span\x3e',n.auto,"\x3c/td\x3e","\x3c/tr\x3e","\x3c/table\x3e","\x3c/a\x3e"));g.push('\x3ctable role\x3d"presentation" cellspacing\x3d0 cellpadding\x3d0 width\x3d"100%"\x3e\x3ctbody\x3e');
for(b=0;b<h.length;b++){0===b%a.config.colorButton_colorsPerRow&&g.push("\x3c/tr\x3e\x3ctr\x3e");var m=h[b].split("/"),v=m[0],m=new q(a,{color:m[1]||v,label:m[1]?v:void 0},c);m.setPositionIndex(p+b,f);g.push(m.getHtml())}l.getRowLimit(a)&&l.renderContainer(g,a);k&&g.push("\x3c/tr\x3e","\x3ctr\x3e",'\x3ctd colspan\x3d"',a.config.colorButton_colorsPerRow,'" align\x3d"center"\x3e','\x3ca class\x3d"cke_colormore" _cke_focus\x3d1 hidefocus\x3dtrue',' title\x3d"',n.more,'"',' draggable\x3d"false"',' ondragstart\x3d"return false;"',
' onclick\x3d"CKEDITOR.tools.callFunction(',c,",'?');return false;\""," href\x3d\"javascript:void('",n.more,"')\"",' role\x3d"option" aria-posinset\x3d"',f,'" aria-setsize\x3d"',f,'"\x3e',n.more,"\x3c/a\x3e","\x3c/td\x3e");g.push("\x3c/tr\x3e\x3c/tbody\x3e\x3c/table\x3e");return g.join("")}function f(a){return"false"==a.getAttribute("contentEditable")||a.getAttribute("data-nostyle")}function v(a,b){var c=a._.getItems(),g=a.element.findOne("[aria-selected]"),f=a.element.findOne("[cke_colorlast]");
g&&g.removeAttribute("aria-selected");if(f)f.setAttribute("aria-selected",!0);else for(g=0;g<c.count();g++)if(f=c.getItem(g),b&&b==p(f.getAttribute("data-value"))){f.setAttribute("aria-selected",!0);break}}function p(a){return CKEDITOR.tools.normalizeHex("#"+CKEDITOR.tools.convertRgbToHex(a||"")).replace(/#/g,"")}var r=a.config,n=a.lang.colorbutton;if(!CKEDITOR.env.hc){b({name:"TextColor",type:"fore",commandName:"textColor",title:n.textColorTitle,order:10,contentTransformations:[[{element:"font",
check:"span{color}",left:function(a){return!!a.attributes.color},right:function(a){a.name="span";a.attributes.color&&(a.styles.color=a.attributes.color);delete a.attributes.color}}]]});var k,w=a.config.colorButton_normalizeBackground;if(void 0===w||w)k=[[{element:"span",left:function(a){var b=CKEDITOR.tools;if("span"!=a.name||!a.styles||!a.styles.background)return!1;a=b.style.parse.background(a.styles.background);return a.color&&1===b.object.keys(a).length},right:function(b){var c=(new CKEDITOR.style(a.config.colorButton_backStyle,
{color:b.styles.background})).getDefinition();b.name=c.element;b.styles=c.styles;b.attributes=c.attributes||{};return b}}]];b({name:"BGColor",type:"back",commandName:"bgColor",title:n.bgColorTitle,order:20,contentTransformations:k})}}});q=CKEDITOR.tools.createClass({$:function(a,b,c){this.$=new CKEDITOR.dom.element("td");this.color=CKEDITOR.tools._isValidColorFormat(b.color)?b.color:"";this.clickFn=c;this.label=b.label||q.colorNames(a)[this.color]||this.color;this.setHtml()},statics:{colorNames:function(a){return a.lang.colorbutton.colors}},
proto:{getElement:function(){return this.$},getHtml:function(){return this.getElement().getOuterHtml()},setHtml:function(){this.getElement().setHtml('\x3ca class\x3d"cke_colorbox" _cke_focus\x3d1 hidefocus\x3dtrue title\x3d"'+this.label+'" draggable\x3d"false" ondragstart\x3d"return false;" onclick\x3d"CKEDITOR.tools.callFunction('+this.clickFn+",'"+this.color+"','"+this.label+"', this); return false;\" href\x3d\"javascript:void('"+this.color+'\')" data-value\x3d"'+this.color+'" role\x3d"option"\x3e\x3cspan class\x3d"cke_colorbox" style\x3d"background-color:#'+
this.color+'"\x3e\x3c/span\x3e\x3c/a\x3e')},setPositionIndex:function(a,b){this.getElement().getChild(0).setAttributes({"aria-posinset":a,"aria-setsize":b})}}});k=CKEDITOR.tools.createClass({$:function(){this.$=new CKEDITOR.dom.element("tr");this.$.addClass("cke_colorhistory_row");this.boxes=[]},proto:{getElement:function(){return this.$},removeLastColor:function(){this.getElement().getLast().remove();return this.boxes.pop()},addNewColor:function(a){this.boxes.unshift(a);this.getElement().append(a.getElement(),
!0)},extractColorBox:function(a){var b=CKEDITOR.tools.getIndex(this.boxes,function(b){return b.color===a});if(0>b)return null;this.boxes[b].getElement().remove();return this.boxes.splice(b,1)[0]}}});l=CKEDITOR.tools.createClass({$:function(a,b,c){this.editor=a;this.cssProperty=b;this.clickFn=c;this.rows=[];this._.addNewRow();if(this.editor.config.colorButton_renderContentColors)this.editor.once("instanceReady",function(){this.renderContentColors()},this)},statics:{renderContainer:function(a,b){a.push('\x3c/tbody\x3e\x3ctbody class\x3d"cke_colorhistory" style\x3d"display:none;"\x3e',
"\x3ctr\x3e",'\x3ctd colspan\x3d"',b.config.colorButton_colorsPerRow,'" align\x3d"center"\x3e',"\x3cspan\x3e\x3chr\x3e\x3c/span\x3e","\x3c/td\x3e","\x3c/tr\x3e","\x3c/tbody\x3e\x3ctbody\x3e")},getRowLimit:function(a){return a.config.colorButton_historyRowLimit},getCapacity:function(a){return l.getRowLimit(a)*a.config.colorButton_colorsPerRow},colorList:CKEDITOR.tools.style.parse._colors},_:{countColors:function(){var a=CKEDITOR.tools.getStyledSpans(this.cssProperty,this.editor.editable());return CKEDITOR.tools.array.reduce(a,
function(a,c){var f=this._.getHexCode(c,this.cssProperty,l.colorList);a[f]=a[f]||0;a[f]+=1;return a},{},this)},getHexCode:function(a,b,c){var f=a.getStyle(b);return f in c?c[f].substr(1):this._.normalizeColor(a.getComputedStyle(b)).toUpperCase()},sortByOccurrencesAscending:function(a,b){var c=[],f;for(f in a){var k={};k[b]=f;k.frequency=a[f];c.push(k)}c.sort(function(a,b){return b.frequency-a.frequency});this._.trimToCapacity(c);return c.reverse()},trimToCapacity:function(a){a.splice(l.getCapacity(this.editor))},
addColors:function(a){CKEDITOR.tools.array.forEach(a,function(a){this.addColor(a.colorCode)},this)},extractColorBox:function(a){for(var b=0;b<this.rows.length;b++){var c=this.rows[b].extractColorBox(a);if(c)return c}return null},moveToBeginning:function(a){this.rows[0].addNewColor(a)},createAtBeginning:function(a){this._.moveToBeginning(new q(this.editor,{color:a},this.clickFn))},addNewRow:function(){this.rows.push(new k);this.container&&this.container.append(this.rows[this.rows.length-1].getElement())},
alignRows:function(){for(var a=0;a<l.getRowLimit(this.editor)&&!(this.rows[a].boxes.length<=this.editor.config.colorButton_colorsPerRow);a++)this.rows[a+1]?this._.moveLastBoxToNextRow(a):a<l.getRowLimit(this.editor)-1?(this._.addNewRow(),this._.moveLastBoxToNextRow(a)):this.rows[a].removeLastColor()},moveLastBoxToNextRow:function(a){this.rows[a+1].addNewColor(this.rows[a].removeLastColor())},refreshPositions:function(){var a=this._.countPanelElements(),b=this._.calculateFirstPosition(a);CKEDITOR.tools.array.forEach(this.rows,
function(c){CKEDITOR.tools.array.forEach(c.boxes,function(c){c.setPositionIndex(b,a);b+=1})})},countPanelElements:function(){var a=this.editor.config.colorButton_colors.split(",").length+this.getLength();this.editor.plugins.colordialog&&this.editor.config.colorButton_enableMore&&(a+=1);this.editor.config.colorButton_enableAutomatic&&(a+=1);return a},calculateFirstPosition:function(a){return this.editor.plugins.colordialog&&this.editor.config.colorButton_enableMore?a-this.getLength():a-this.getLength()+
1},attachRows:function(){CKEDITOR.tools.array.forEach(this.rows,function(a){this.container.append(a.getElement())},this)},normalizeColor:function(a){return CKEDITOR.tools.normalizeHex("#"+CKEDITOR.tools.convertRgbToHex(a||"")).replace(/#/g,"")}},proto:{setContainer:function(a){this.container=a;this._.attachRows();this.getLength()&&this.show()},show:function(){this.container&&this.container.show()},renderContentColors:function(){var a=this._.countColors();CKEDITOR.tools.isEmpty(a)||(a=this._.sortByOccurrencesAscending(a,
"colorCode"),this._.addColors(a),this._.refreshPositions())},addColor:function(a){var b=this._.extractColorBox(a);this.container&&!this.container.isVisible()&&this.show();b?this._.moveToBeginning(b):this._.createAtBeginning(a);this._.alignRows()},getLength:function(){return CKEDITOR.tools.array.reduce(this.rows,function(a,b){return a+b.boxes.length},0)}}})})();CKEDITOR.config.colorButton_enableMore=!0;CKEDITOR.config.colorButton_colors="1ABC9C,2ECC71,3498DB,9B59B6,4E5F70,F1C40F,16A085,27AE60,2980B9,8E44AD,2C3E50,F39C12,E67E22,E74C3C,ECF0F1,95A5A6,DDD,FFF,D35400,C0392B,BDC3C7,7F8C8D,999,000";
CKEDITOR.config.colorButton_foreStyle={element:"span",styles:{color:"#(color)"},overrides:[{element:"font",attributes:{color:null}}]};CKEDITOR.config.colorButton_backStyle={element:"span",styles:{"background-color":"#(color)"}};CKEDITOR.config.colorButton_enableAutomatic=!0;CKEDITOR.config.colorButton_colorsPerRow=6;CKEDITOR.config.colorButton_historyRowLimit=1;CKEDITOR.config.colorButton_renderContentColors=!0;CKEDITOR.plugins.colordialog={requires:"dialog",init:function(b){var d=new CKEDITOR.dialogCommand("colordialog");d.editorFocus=!1;b.addCommand("colordialog",d);CKEDITOR.dialog.add("colordialog",this.path+"dialogs/colordialog.js");b.getColorFromDialog=function(d,k,g){var c,e,h,f;c=function(a){h(this);(a="ok"==a.name?this.getValueOf("picker","selectedColor"):null)&&!CKEDITOR.tools._isValidColorFormat(a)&&(a=null);/^[0-9a-f]{3}([0-9a-f]{3})?$/i.test(a)&&(a="#"+a);d.call(k,a)};e=function(a){g&&(a.data=
g)};h=function(a){a.removeListener("ok",c);a.removeListener("cancel",c);a.removeListener("show",e)};f=function(a){a.on("ok",c);a.on("cancel",c);a.on("show",e,null,null,5)};b.execCommand("colordialog");if(b._.storedDialogs&&b._.storedDialogs.colordialog)f(b._.storedDialogs.colordialog);else CKEDITOR.on("dialogDefinition",function(a){if("colordialog"==a.data.name){var b=a.data.definition;a.removeListener();b.onLoad=CKEDITOR.tools.override(b.onLoad,function(a){return function(){f(this);b.onLoad=a;"function"==
typeof a&&a.call(this)}})}})}}};CKEDITOR.plugins.add("colordialog",CKEDITOR.plugins.colordialog);(function(){CKEDITOR.plugins.add("templates",{requires:"dialog",init:function(a){CKEDITOR.dialog.add("templates",CKEDITOR.getUrl(this.path+"dialogs/templates.js"));a.addCommand("templates",new CKEDITOR.dialogCommand("templates"));a.ui.addButton&&a.ui.addButton("Templates",{label:a.lang.templates.button,command:"templates",toolbar:"doctools,10"})}});var c={},f={};CKEDITOR.addTemplates=function(a,d){c[a]=d};CKEDITOR.getTemplates=function(a){return c[a]};CKEDITOR.loadTemplates=function(a,d){for(var e=
[],b=0,c=a.length;b<c;b++)f[a[b]]||(e.push(a[b]),f[a[b]]=1);e.length?CKEDITOR.scriptLoader.load(e,d):setTimeout(d,0)}})();CKEDITOR.config.templates_files=[CKEDITOR.getUrl("plugins/templates/templates/default.js")];CKEDITOR.config.templates_replaceContent=!0;CKEDITOR.plugins.add("menu",{requires:"floatpanel",beforeInit:function(m){for(var k=m.config.menu_groups.split(","),n=m._.menuGroups={},r=m._.menuItems={},p=0;p<k.length;p++)n[k[p]]=p+1;m.addMenuGroup=function(c,a){n[c]=a||100};m.addMenuItem=function(c,a){n[a.group]&&(r[c]=new CKEDITOR.menuItem(this,c,a))};m.addMenuItems=function(c){for(var a in c)this.addMenuItem(a,c[a])};m.getMenuItem=function(c){return r[c]};m.removeMenuItem=function(c){delete r[c]}}});
(function(){function m(a){a.sort(function(a,f){return a.group<f.group?-1:a.group>f.group?1:a.order<f.order?-1:a.order>f.order?1:0})}var k='\x3cspan class\x3d"cke_menuitem"\x3e\x3ca id\x3d"{id}" class\x3d"cke_menubutton cke_menubutton__{name} cke_menubutton_{state} {cls}" href\x3d"{href}" title\x3d"{title}" tabindex\x3d"-1" _cke_focus\x3d1 hidefocus\x3d"true" role\x3d"{role}" aria-label\x3d"{attrLabel}" aria-describedby\x3d"{id}_description" aria-haspopup\x3d"{hasPopup}" aria-disabled\x3d"{disabled}" {ariaChecked} draggable\x3d"false"',
n="";CKEDITOR.env.gecko&&CKEDITOR.env.mac&&(k+=' onkeypress\x3d"return false;"');CKEDITOR.env.gecko&&(k+=' onblur\x3d"this.style.cssText \x3d this.style.cssText;" ondragstart\x3d"return false;"');CKEDITOR.env.ie&&(n='return false;" onmouseup\x3d"CKEDITOR.tools.getMouseButton(event)\x3d\x3d\x3dCKEDITOR.MOUSE_BUTTON_LEFT\x26\x26');var k=k+(' onmouseover\x3d"CKEDITOR.tools.callFunction({hoverFn},{index});" onmouseout\x3d"CKEDITOR.tools.callFunction({moveOutFn},{index});" onclick\x3d"'+n+'CKEDITOR.tools.callFunction({clickFn},{index}); return false;"\x3e')+
'\x3cspan class\x3d"cke_menubutton_inner"\x3e\x3cspan class\x3d"cke_menubutton_icon"\x3e\x3cspan class\x3d"cke_button_icon cke_button__{iconName}_icon" style\x3d"{iconStyle}"\x3e\x3c/span\x3e\x3c/span\x3e\x3cspan class\x3d"cke_menubutton_label"\x3e{label}\x3c/span\x3e{shortcutHtml}{arrowHtml}\x3c/span\x3e\x3c/a\x3e\x3cspan id\x3d"{id}_description" class\x3d"cke_voice_label" aria-hidden\x3d"false"\x3e{ariaShortcut}\x3c/span\x3e\x3c/span\x3e',r=CKEDITOR.addTemplate("menuItem",k),p=CKEDITOR.addTemplate("menuArrow",
'\x3cspan class\x3d"cke_menuarrow"\x3e\x3cspan\x3e{label}\x3c/span\x3e\x3c/span\x3e'),c=CKEDITOR.addTemplate("menuShortcut",'\x3cspan class\x3d"cke_menubutton_label cke_menubutton_shortcut"\x3e{shortcut}\x3c/span\x3e');CKEDITOR.menu=CKEDITOR.tools.createClass({$:function(a,b){b=this._.definition=b||{};this.id=CKEDITOR.tools.getNextId();this.editor=a;this.items=[];this._.listeners=[];this._.level=b.level||1;var f=CKEDITOR.tools.extend({},b.panel,{css:[CKEDITOR.skin.getPath("editor")],level:this._.level-
1,block:{}}),c=f.block.attributes=f.attributes||{};!c.role&&(c.role="menu");this._.panelDefinition=f},_:{onShow:function(){var a=this.editor.getSelection(),b=a&&a.getStartElement(),f=this.editor.elementPath(),c=this._.listeners;this.removeAll();for(var h=0;h<c.length;h++){var l=c[h](b,a,f);if(l)for(var g in l){var e=this.editor.getMenuItem(g);!e||e.command&&!this.editor.getCommand(e.command).state||(e.state=l[g],this.add(e))}}},onClick:function(a){this.hide();if(a.onClick)a.onClick();else a.command&&
this.editor.execCommand(a.command)},onEscape:function(a){var b=this.parent;b?b._.panel.hideChild(1):27==a&&this.hide(1);return!1},onHide:function(){this.onHide&&this.onHide()},showSubMenu:function(a){var b=this._.subMenu,f=this.items[a];if(f=f.getItems&&f.getItems()){b?b.removeAll():(b=this._.subMenu=new CKEDITOR.menu(this.editor,CKEDITOR.tools.extend({},this._.definition,{level:this._.level+1},!0)),b.parent=this,b._.onClick=CKEDITOR.tools.bind(this._.onClick,this));for(var c in f){var h=this.editor.getMenuItem(c);
h&&(h.state=f[c],b.add(h))}var l=this._.panel.getBlock(this.id).element.getDocument().getById(this.id+String(a));setTimeout(function(){b.show(l,2)},0)}else this._.panel.hideChild(1)}},proto:{add:function(a){a.order||(a.order=this.items.length);this.items.push(a)},removeAll:function(){this.items=[]},show:function(a,b,f,c){if(!this.parent&&(this._.onShow(),!this.items.length))return;b=b||("rtl"==this.editor.lang.dir?2:1);var h=this.items,l=this.editor,g=this._.panel,e=this._.element;if(!g){g=this._.panel=
new CKEDITOR.ui.floatPanel(this.editor,CKEDITOR.document.getBody(),this._.panelDefinition,this._.level);g.onEscape=CKEDITOR.tools.bind(function(a){if(!1===this._.onEscape(a))return!1},this);g.onShow=function(){g._.panel.getHolderElement().getParent().addClass("cke").addClass("cke_reset_all")};g.onHide=CKEDITOR.tools.bind(function(){this._.onHide&&this._.onHide()},this);e=g.addBlock(this.id,this._.panelDefinition.block);e.autoSize=!0;var d=e.keys;d[40]="next";d[9]="next";d[38]="prev";d[CKEDITOR.SHIFT+
9]="prev";d["rtl"==l.lang.dir?37:39]=CKEDITOR.env.ie?"mouseup":"click";d[32]=CKEDITOR.env.ie?"mouseup":"click";CKEDITOR.env.ie&&(d[13]="mouseup");e=this._.element=e.element;d=e.getDocument();d.getBody().setStyle("overflow","hidden");d.getElementsByTag("html").getItem(0).setStyle("overflow","hidden");this._.itemOverFn=CKEDITOR.tools.addFunction(function(a){clearTimeout(this._.showSubTimeout);this._.showSubTimeout=CKEDITOR.tools.setTimeout(this._.showSubMenu,l.config.menu_subMenuDelay||400,this,[a])},
this);this._.itemOutFn=CKEDITOR.tools.addFunction(function(){clearTimeout(this._.showSubTimeout)},this);this._.itemClickFn=CKEDITOR.tools.addFunction(function(a){var b=this.items[a];if(b.state==CKEDITOR.TRISTATE_DISABLED)this.hide(1);else if(b.getItems)this._.showSubMenu(a);else this._.onClick(b)},this)}m(h);for(var d=l.elementPath(),d=['\x3cdiv class\x3d"cke_menu'+(d&&d.direction()!=l.lang.dir?" cke_mixed_dir_content":"")+'" role\x3d"presentation"\x3e'],k=h.length,n=k&&h[0].group,p=0;p<k;p++){var q=
h[p];n!=q.group&&(d.push('\x3cdiv class\x3d"cke_menuseparator" role\x3d"separator"\x3e\x3c/div\x3e'),n=q.group);q.render(this,p,d)}d.push("\x3c/div\x3e");e.setHtml(d.join(""));CKEDITOR.ui.fire("ready",this);this.parent?this.parent._.panel.showAsChild(g,this.id,a,b,f,c):g.showBlock(this.id,a,b,f,c);l.fire("menuShow",[g])},addListener:function(a){this._.listeners.push(a)},hide:function(a){this._.onHide&&this._.onHide();this._.panel&&this._.panel.hide(a)},findItemByCommandName:function(a){var b=CKEDITOR.tools.array.filter(this.items,
function(b){return a===b.command});return b.length?(b=b[0],{item:b,element:this._.element.findOne("."+b.className)}):null}}});CKEDITOR.menuItem=CKEDITOR.tools.createClass({$:function(a,b,c){CKEDITOR.tools.extend(this,c,{order:0,className:"cke_menubutton__"+b});this.group=a._.menuGroups[this.group];this.editor=a;this.name=b},proto:{render:function(a,b,f){var k=a.id+String(b),h="undefined"==typeof this.state?CKEDITOR.TRISTATE_OFF:this.state,l="",g=this.editor,e,d,m=h==CKEDITOR.TRISTATE_ON?"on":h==CKEDITOR.TRISTATE_DISABLED?
"disabled":"off";this.role in{menuitemcheckbox:1,menuitemradio:1}&&(l=' aria-checked\x3d"'+(h==CKEDITOR.TRISTATE_ON?"true":"false")+'"');var n=this.getItems,t="\x26#"+("rtl"==this.editor.lang.dir?"9668":"9658")+";",q=this.name;this.icon&&!/\./.test(this.icon)&&(q=this.icon);this.command&&(e=g.getCommand(this.command),(e=g.getCommandKeystroke(e))&&(d=CKEDITOR.tools.keystrokeToString(g.lang.common.keyboard,e)));e=CKEDITOR.tools.htmlEncodeAttr(this.label);a={id:k,name:this.name,iconName:q,label:this.label,
attrLabel:e,cls:this.className||"",state:m,hasPopup:n?"true":"false",disabled:h==CKEDITOR.TRISTATE_DISABLED,title:e+(d?" ("+d.display+")":""),ariaShortcut:d?g.lang.common.keyboardShortcut+" "+d.aria:"",href:"javascript:void('"+(e||"").replace("'")+"')",hoverFn:a._.itemOverFn,moveOutFn:a._.itemOutFn,clickFn:a._.itemClickFn,index:b,iconStyle:CKEDITOR.skin.getIconStyle(q,"rtl"==this.editor.lang.dir,q==this.icon?null:this.icon,this.iconOffset),shortcutHtml:d?c.output({shortcut:d.display}):"",arrowHtml:n?
p.output({label:t}):"",role:this.role?this.role:"menuitem",ariaChecked:l};r.output(a,f)}}})})();CKEDITOR.config.menu_groups="clipboard,form,tablecell,tablecellproperties,tablerow,tablecolumn,table,anchor,link,image,flash,checkbox,radio,textfield,hiddenfield,imagebutton,button,select,textarea,div";CKEDITOR.plugins.add("contextmenu",{requires:"menu",onLoad:function(){CKEDITOR.plugins.contextMenu=CKEDITOR.tools.createClass({base:CKEDITOR.menu,$:function(a){this.base.call(this,a,{panel:{css:a.config.contextmenu_contentsCss,className:"cke_menu_panel",attributes:{"aria-label":a.lang.contextmenu.options}}})},proto:{addTarget:function(a,f){function c(){e=!1}var d,e;a.on("contextmenu",function(a){a=a.data;var b=CKEDITOR.env.webkit?d:CKEDITOR.env.mac?a.$.metaKey:a.$.ctrlKey;if(!f||!b)if(a.preventDefault(),
!e){if(CKEDITOR.env.mac&&CKEDITOR.env.webkit){var b=this.editor,c=(new CKEDITOR.dom.elementPath(a.getTarget(),b.editable())).contains(function(a){return a.hasAttribute("contenteditable")},!0);c&&"false"==c.getAttribute("contenteditable")&&b.getSelection().fake(c)}var c=a.getTarget().getDocument(),g=a.getTarget().getDocument().getDocumentElement(),b=!c.equals(CKEDITOR.document),c=c.getWindow().getScrollPosition(),h=b?a.$.clientX:a.$.pageX||c.x+a.$.clientX,k=b?a.$.clientY:a.$.pageY||c.y+a.$.clientY;
CKEDITOR.tools.setTimeout(function(){this.open(g,null,h,k)},CKEDITOR.env.ie?200:0,this)}},this);if(CKEDITOR.env.webkit){var b=function(){d=0};a.on("keydown",function(a){d=CKEDITOR.env.mac?a.data.$.metaKey:a.data.$.ctrlKey});a.on("keyup",b);a.on("contextmenu",b)}CKEDITOR.env.gecko&&!CKEDITOR.env.mac&&(a.on("keydown",function(a){a.data.$.shiftKey&&121===a.data.$.keyCode&&(e=!0)},null,null,0),a.on("keyup",c),a.on("contextmenu",c))},open:function(a,f,c,d){!1!==this.editor.config.enableContextMenu&&this.editor.getSelection().getType()!==
CKEDITOR.SELECTION_NONE&&(this.editor.focus(),a=a||CKEDITOR.document.getDocumentElement(),this.editor.selectionChange(1),this.show(a,f,c,d))}}})},beforeInit:function(a){var f=a.contextMenu=new CKEDITOR.plugins.contextMenu(a);a.on("contentDom",function(){f.addTarget(a.editable(),!1!==a.config.browserContextMenuOnCtrl)});a.addCommand("contextMenu",{exec:function(a){var d=0,e=0,b=a.getSelection().getRanges(),b=b[b.length-1].getClientRects(a.editable().isInline());if(b=b[b.length-1])d=b["rtl"===a.lang.dir?
"left":"right"],e=b.bottom;a.contextMenu.open(a.document.getBody().getParent(),null,d,e)}});a.setKeystroke(CKEDITOR.SHIFT+121,"contextMenu");a.setKeystroke(CKEDITOR.CTRL+CKEDITOR.SHIFT+121,"contextMenu")}});(function(){function k(a,b,e,d){var c=new CKEDITOR.dom.walker(a);if(a=a.startContainer.getAscendant(b,!0)||a.endContainer.getAscendant(b,!0))if(e(a),d)return;for(;a=c.next();)if(a=a.getAscendant(b,!0))if(e(a),d)break}function u(a,b){var e={ul:"ol",ol:"ul"};return-1!==l(b,function(b){return b.element===a||b.element===e[a]})}function q(a){this.styles=null;this.sticky=!1;this.editor=a;this.filter=new CKEDITOR.filter(a,a.config.copyFormatting_allowRules);!0===a.config.copyFormatting_allowRules&&(this.filter.disabled=
!0);a.config.copyFormatting_disallowRules&&this.filter.disallow(a.config.copyFormatting_disallowRules)}var l=CKEDITOR.tools.indexOf,r=CKEDITOR.tools.getMouseButton,t=!1;CKEDITOR.plugins.add("copyformatting",{lang:"ar,az,bg,cs,da,de,el,en,en-au,eo,es-mx,et,eu,fa,fr,gl,hr,hu,it,ja,ko,ku,lv,nb,nl,oc,pl,pt,pt-br,ro,ru,sk,sq,sr,sr-latn,sv,tr,uk,vi,zh,zh-cn",icons:"copyformatting",hidpi:!0,init:function(a){var b=CKEDITOR.plugins.copyformatting;b._addScreenReaderContainer();t||(CKEDITOR.document.appendStyleSheet(this.path+
"styles/copyformatting.css"),t=!0);a.addContentsCss&&a.addContentsCss(this.path+"styles/copyformatting.css");a.copyFormatting=new b.state(a);a.addCommand("copyFormatting",b.commands.copyFormatting);a.addCommand("applyFormatting",b.commands.applyFormatting);a.ui.addButton("CopyFormatting",{label:a.lang.copyformatting.label,command:"copyFormatting",toolbar:"cleanup,0"});a.on("contentDom",function(){var b=a.getCommand("copyFormatting"),d=a.editable(),c=d.isInline()?d:a.document,f=a.ui.get("CopyFormatting");
d.attachListener(c,"mouseup",function(d){r(d)===CKEDITOR.MOUSE_BUTTON_LEFT&&b.state===CKEDITOR.TRISTATE_ON&&a.execCommand("applyFormatting")});d.attachListener(CKEDITOR.document,"mouseup",function(c){r(c)!==CKEDITOR.MOUSE_BUTTON_LEFT||b.state!==CKEDITOR.TRISTATE_ON||d.contains(c.data.getTarget())||a.execCommand("copyFormatting")});f&&(c=CKEDITOR.document.getById(f._.id),d.attachListener(c,"dblclick",function(){a.execCommand("copyFormatting",{sticky:!0})}),d.attachListener(c,"mouseup",function(a){a.data.stopPropagation()}))});
a.config.copyFormatting_keystrokeCopy&&a.setKeystroke(a.config.copyFormatting_keystrokeCopy,"copyFormatting");a.on("key",function(b){var d=a.getCommand("copyFormatting");b=b.data.domEvent;b.getKeystroke&&27===b.getKeystroke()&&d.state===CKEDITOR.TRISTATE_ON&&a.execCommand("copyFormatting")});a.copyFormatting.on("extractFormatting",function(e){var d=e.data.element;if(d.contains(a.editable())||d.equals(a.editable()))return e.cancel();d=b._convertElementToStyleDef(d);if(!a.copyFormatting.filter.check(new CKEDITOR.style(d),
!0,!0))return e.cancel();e.data.styleDef=d});a.copyFormatting.on("applyFormatting",function(e){if(!e.data.preventFormatStripping){var d=e.data.range,c=b._extractStylesFromRange(a,d),f=b._determineContext(d),g,h;if(a.copyFormatting._isContextAllowed(f))for(h=0;h<c.length;h++)f=c[h],g=d.createBookmark(),-1===l(b.preservedElements,f.element)?CKEDITOR.env.webkit&&!CKEDITOR.env.chrome?c[h].removeFromRange(e.data.range,e.editor):c[h].remove(e.editor):u(f.element,e.data.styles)&&b._removeStylesFromElementInRange(d,
f.element),d.moveToBookmark(g)}});a.copyFormatting.on("applyFormatting",function(b){var d=CKEDITOR.plugins.copyformatting,c=d._determineContext(b.data.range);"list"===c&&a.copyFormatting._isContextAllowed("list")?d._applyStylesToListContext(b.editor,b.data.range,b.data.styles):"table"===c&&a.copyFormatting._isContextAllowed("table")?d._applyStylesToTableContext(b.editor,b.data.range,b.data.styles):a.copyFormatting._isContextAllowed("text")&&d._applyStylesToTextContext(b.editor,b.data.range,b.data.styles)},
null,null,999)}});q.prototype._isContextAllowed=function(a){var b=this.editor.config.copyFormatting_allowedContexts;return!0===b||-1!==l(b,a)};CKEDITOR.event.implementOn(q.prototype);CKEDITOR.plugins.copyformatting={state:q,inlineBoundary:"h1 h2 h3 h4 h5 h6 p div".split(" "),excludedAttributes:["id","style","href","data-cke-saved-href","dir"],elementsForInlineTransform:["li"],excludedElementsFromInlineTransform:["table","thead","tbody","ul","ol"],excludedAttributesFromInlineTransform:["value","type"],
preservedElements:"ul ol li td th tr thead tbody table".split(" "),breakOnElements:["ul","ol","table"],_initialKeystrokePasteCommand:null,commands:{copyFormatting:{exec:function(a,b){var e=CKEDITOR.plugins.copyformatting,d=a.copyFormatting,c=b?"keystrokeHandler"==b.from:!1,f=b?b.sticky||c:!1,g=e._getCursorContainer(a),h=CKEDITOR.document.getDocumentElement();if(this.state===CKEDITOR.TRISTATE_ON)return d.styles=null,d.sticky=!1,g.removeClass("cke_copyformatting_active"),h.removeClass("cke_copyformatting_disabled"),
h.removeClass("cke_copyformatting_tableresize_cursor"),e._putScreenReaderMessage(a,"canceled"),e._detachPasteKeystrokeHandler(a),this.setState(CKEDITOR.TRISTATE_OFF);d.styles=e._extractStylesFromElement(a,a.elementPath().lastElement);this.setState(CKEDITOR.TRISTATE_ON);c||(g.addClass("cke_copyformatting_active"),h.addClass("cke_copyformatting_tableresize_cursor"),a.config.copyFormatting_outerCursor&&h.addClass("cke_copyformatting_disabled"));d.sticky=f;e._putScreenReaderMessage(a,"copied");e._attachPasteKeystrokeHandler(a)}},
applyFormatting:{editorFocus:CKEDITOR.env.ie&&!CKEDITOR.env.edge?!1:!0,exec:function(a,b){var e=a.getCommand("copyFormatting"),d=b?"keystrokeHandler"==b.from:!1,c=CKEDITOR.plugins.copyformatting,f=a.copyFormatting,g=c._getCursorContainer(a),h=CKEDITOR.document.getDocumentElement();if(d&&!f.styles)return c._putScreenReaderMessage(a,"failed"),c._detachPasteKeystrokeHandler(a),!1;d=c._applyFormat(a,f.styles);f.sticky||(f.styles=null,g.removeClass("cke_copyformatting_active"),h.removeClass("cke_copyformatting_disabled"),
h.removeClass("cke_copyformatting_tableresize_cursor"),e.setState(CKEDITOR.TRISTATE_OFF),c._detachPasteKeystrokeHandler(a));c._putScreenReaderMessage(a,d?"applied":"canceled")}}},_getCursorContainer:function(a){return a.elementMode===CKEDITOR.ELEMENT_MODE_INLINE?a.editable():a.editable().getParent()},_convertElementToStyleDef:function(a){var b=CKEDITOR.tools,e=a.getAttributes(CKEDITOR.plugins.copyformatting.excludedAttributes),b=b.parseCssText(a.getAttribute("style"),!0,!0);return{element:a.getName(),
type:CKEDITOR.STYLE_INLINE,attributes:e,styles:b}},_extractStylesFromElement:function(a,b){var e={},d=[];do if(b.type===CKEDITOR.NODE_ELEMENT&&!b.hasAttribute("data-cke-bookmark")&&(e.element=b,a.copyFormatting.fire("extractFormatting",e,a)&&e.styleDef&&d.push(new CKEDITOR.style(e.styleDef)),b.getName&&-1!==l(CKEDITOR.plugins.copyformatting.breakOnElements,b.getName())))break;while((b=b.getParent())&&b.type===CKEDITOR.NODE_ELEMENT);return d},_extractStylesFromRange:function(a,b){for(var e=[],d=new CKEDITOR.dom.walker(b),
c;c=d.next();)e=e.concat(CKEDITOR.plugins.copyformatting._extractStylesFromElement(a,c));return e},_removeStylesFromElementInRange:function(a,b){for(var e=-1!==l(["ol","ul","table"],b),d=new CKEDITOR.dom.walker(a),c;c=d.next();)if(c=c.getAscendant(b,!0))if(c.removeAttributes(c.getAttributes()),e)break},_getSelectedWordOffset:function(a){function b(a,b){return a[b?"getPrevious":"getNext"](function(a){return a.type!==CKEDITOR.NODE_COMMENT})}function e(a){return a.type==CKEDITOR.NODE_ELEMENT?(a=a.getHtml().replace(/<span.*?>&nbsp;<\/span>/g,
""),a.replace(/<.*?>/g,"")):a.getText()}function d(a,c){var f=a,g=/\s/g,h="p br ol ul li td th div caption body".split(" "),m=!1,k=!1,p,n;do{for(p=b(f,c);!p&&f.getParent();){f=f.getParent();if(-1!==l(h,f.getName())){k=m=!0;break}p=b(f,c)}if(p&&p.getName&&-1!==l(h,p.getName())){m=!0;break}f=p}while(f&&f.getStyle&&("none"==f.getStyle("display")||!f.getText()));for(f||(f=a);f.type!==CKEDITOR.NODE_TEXT;)f=!m||c||k?f.getChild(0):f.getChild(f.getChildCount()-1);for(h=e(f);null!=(k=g.exec(h))&&(n=k.index,
c););if("number"!==typeof n&&!m)return d(f,c);if(m)c?n=0:(g=/([\.\b]*$)/,n=(k=g.exec(h))?k.index:h.length);else if(c&&(n+=1,n>h.length))return d(f);return{node:f,offset:n}}var c=/\b\w+\b/ig,f,g,h,m,k;h=m=k=a.startContainer;for(f=e(h);null!=(g=c.exec(f));)if(g.index+g[0].length>=a.startOffset)return a=g.index,c=g.index+g[0].length,0===g.index&&(g=d(h,!0),m=g.node,a=g.offset),c>=f.length&&(f=d(h),k=f.node,c=f.offset),{startNode:m,startOffset:a,endNode:k,endOffset:c};return null},_filterStyles:function(a){var b=
CKEDITOR.tools.isEmpty,e=[],d,c;for(c=0;c<a.length;c++)d=a[c]._.definition,-1!==CKEDITOR.tools.indexOf(CKEDITOR.plugins.copyformatting.inlineBoundary,d.element)&&(d.element=a[c].element="span"),"span"===d.element&&b(d.attributes)&&b(d.styles)||e.push(a[c]);return e},_determineContext:function(a){function b(b){var d=new CKEDITOR.dom.walker(a),c;if(a.startContainer.getAscendant(b,!0)||a.endContainer.getAscendant(b,!0))return!0;for(;c=d.next();)if(c.getAscendant(b,!0))return!0}return b({ul:1,ol:1})?
"list":b("table")?"table":"text"},_applyStylesToTextContext:function(a,b,e){var d=CKEDITOR.plugins.copyformatting,c=d.excludedAttributesFromInlineTransform,f,g;CKEDITOR.env.webkit&&!CKEDITOR.env.chrome&&a.getSelection().selectRanges([b]);for(f=0;f<e.length;f++)if(b=e[f],-1===l(d.excludedElementsFromInlineTransform,b.element)){if(-1!==l(d.elementsForInlineTransform,b.element))for(b.element=b._.definition.element="span",g=0;g<c.length;g++)b._.definition.attributes[c[g]]&&delete b._.definition.attributes[c[g]];
b.apply(a)}},_applyStylesToListContext:function(a,b,e){var d,c,f;for(f=0;f<e.length;f++)d=e[f],c=b.createBookmark(),"ol"===d.element||"ul"===d.element?k(b,{ul:1,ol:1},function(a){var b=d;a.getName()!==b.element&&a.renameNode(b.element);b.applyToObject(a)},!0):"li"===d.element?k(b,"li",function(a){d.applyToObject(a)}):CKEDITOR.plugins.copyformatting._applyStylesToTextContext(a,b,[d]),b.moveToBookmark(c)},_applyStylesToTableContext:function(a,b,e){function d(a,b){a.getName()!==b.element&&(b=b.getDefinition(),
b.element=a.getName(),b=new CKEDITOR.style(b));b.applyToObject(a)}var c,f,g;for(g=0;g<e.length;g++)c=e[g],f=b.createBookmark(),-1!==l(["table","tr"],c.element)?k(b,c.element,function(a){c.applyToObject(a)}):-1!==l(["td","th"],c.element)?k(b,{td:1,th:1},function(a){d(a,c)}):-1!==l(["thead","tbody"],c.element)?k(b,{thead:1,tbody:1},function(a){d(a,c)}):CKEDITOR.plugins.copyformatting._applyStylesToTextContext(a,b,[c]),b.moveToBookmark(f)},_applyFormat:function(a,b){var e=a.getSelection().getRanges()[0],
d=CKEDITOR.plugins.copyformatting,c,f;if(!e)return!1;if(e.collapsed){f=a.getSelection().createBookmarks();if(!(c=d._getSelectedWordOffset(e)))return;e=a.createRange();e.setStart(c.startNode,c.startOffset);e.setEnd(c.endNode,c.endOffset);e.select()}b=d._filterStyles(b);if(!a.copyFormatting.fire("applyFormatting",{styles:b,range:e,preventFormatStripping:!1},a))return!1;f&&a.getSelection().selectBookmarks(f);return!0},_putScreenReaderMessage:function(a,b){var e=this._getScreenReaderContainer();e&&e.setText(a.lang.copyformatting.notification[b])},
_addScreenReaderContainer:function(){if(this._getScreenReaderContainer())return this._getScreenReaderContainer();if(!CKEDITOR.env.ie6Compat&&!CKEDITOR.env.ie7Compat)return CKEDITOR.document.getBody().append(CKEDITOR.dom.element.createFromHtml('\x3cdiv class\x3d"cke_screen_reader_only cke_copyformatting_notification"\x3e\x3cdiv aria-live\x3d"polite"\x3e\x3c/div\x3e\x3c/div\x3e')).getChild(0)},_getScreenReaderContainer:function(){if(!CKEDITOR.env.ie6Compat&&!CKEDITOR.env.ie7Compat)return CKEDITOR.document.getBody().findOne(".cke_copyformatting_notification div[aria-live]")},
_attachPasteKeystrokeHandler:function(a){var b=a.config.copyFormatting_keystrokePaste;b&&(this._initialKeystrokePasteCommand=a.keystrokeHandler.keystrokes[b],a.setKeystroke(b,"applyFormatting"))},_detachPasteKeystrokeHandler:function(a){var b=a.config.copyFormatting_keystrokePaste;b&&a.setKeystroke(b,this._initialKeystrokePasteCommand||!1)}};CKEDITOR.config.copyFormatting_outerCursor=!0;CKEDITOR.config.copyFormatting_allowRules="b s u i em strong span p div td th ol ul li(*)[*]{*}";CKEDITOR.config.copyFormatting_disallowRules=
"*[data-cke-widget*,data-widget*,data-cke-realelement](cke_widget*)";CKEDITOR.config.copyFormatting_allowedContexts=!0;CKEDITOR.config.copyFormatting_keystrokeCopy=CKEDITOR.CTRL+CKEDITOR.SHIFT+67;CKEDITOR.config.copyFormatting_keystrokePaste=CKEDITOR.CTRL+CKEDITOR.SHIFT+86})();(function(){CKEDITOR.plugins.add("div",{requires:"dialog",init:function(a){if(!a.blockless){var c=a.lang.div,b="div(*)";CKEDITOR.dialog.isTabEnabled(a,"editdiv","advanced")&&(b+=";div[dir,id,lang,title]{*}");a.addCommand("creatediv",new CKEDITOR.dialogCommand("creatediv",{allowedContent:b,requiredContent:"div",contextSensitive:!0,contentTransformations:[["div: alignmentToStyle"]],refresh:function(a,c){this.setState("div"in(a.config.div_wrapTable?c.root:c.blockLimit).getDtd()?CKEDITOR.TRISTATE_OFF:
CKEDITOR.TRISTATE_DISABLED)}}));a.addCommand("editdiv",new CKEDITOR.dialogCommand("editdiv",{requiredContent:"div"}));a.addCommand("removediv",{requiredContent:"div",exec:function(a){function c(b){(b=CKEDITOR.plugins.div.getSurroundDiv(a,b))&&!b.data("cke-div-added")&&(f.push(b),b.data("cke-div-added"))}for(var b=a.getSelection(),g=b&&b.getRanges(),e,h=b.createBookmarks(),f=[],d=0;d<g.length;d++)e=g[d],e.collapsed?c(b.getStartElement()):(e=new CKEDITOR.dom.walker(e),e.evaluator=c,e.lastForward());
for(d=0;d<f.length;d++)f[d].remove(!0);b.selectBookmarks(h)}});a.ui.addButton&&a.ui.addButton("CreateDiv",{label:c.toolbar,command:"creatediv",toolbar:"blocks,50"});a.addMenuItems&&(a.addMenuItems({editdiv:{label:c.edit,command:"editdiv",group:"div",order:1},removediv:{label:c.remove,command:"removediv",group:"div",order:5}}),a.contextMenu&&a.contextMenu.addListener(function(b){return!b||b.isReadOnly()?null:CKEDITOR.plugins.div.getSurroundDiv(a)?{editdiv:CKEDITOR.TRISTATE_OFF,removediv:CKEDITOR.TRISTATE_OFF}:
null}));CKEDITOR.dialog.add("creatediv",this.path+"dialogs/div.js");CKEDITOR.dialog.add("editdiv",this.path+"dialogs/div.js")}}});CKEDITOR.plugins.div={getSurroundDiv:function(a,c){var b=a.elementPath(c);return a.elementPath(b.blockLimit).contains(function(a){return a.is("div")&&!a.isReadOnly()},1)}}})();(function(){function e(b,a){CKEDITOR.tools.array.forEach(a,function(a){b.on(a,f,null,{editor:b})})}function f(b){var a=b.listenerData.editor;b=a.focusManager.hasFocus;var g=a.editable(),e=a.config.editorplaceholder,d=/<body.*?>((?:.|[\n\r])*?)<\/body>/i,f=a.config.fullPage,a=a.getData();f&&(d=a.match(d))&&1<d.length&&(a=d[1]);if(0!==a.length||b)return g.removeAttribute(c);g.setAttribute(c,e)}CKEDITOR.plugins.add("editorplaceholder",{isSupportedEnvironment:function(){return!CKEDITOR.env.ie||9<=CKEDITOR.env.version},
onLoad:function(){CKEDITOR.addCss(CKEDITOR.plugins.editorplaceholder.styles)},init:function(b){this.isSupportedEnvironment()&&b.config.editorplaceholder&&e(b,["contentDom","focus","blur","change"])}});var c="data-cke-editorplaceholder";CKEDITOR.plugins.editorplaceholder={styles:"["+c+"]::before {position: absolute;opacity: .8;color: #aaa;content: attr( "+c+" );}.cke_wysiwyg_div["+c+"]::before {margin-top: 1em;}"};CKEDITOR.config.editorplaceholder=""})();CKEDITOR.plugins.add("resize",{init:function(b){function f(d){var e=c.width,m=c.height,f=e+(d.data.$.screenX-n.x)*("rtl"==g?-1:1);d=m+(d.data.$.screenY-n.y);h&&(e=Math.max(a.resize_minWidth,Math.min(f,a.resize_maxWidth)));p&&(m=Math.max(a.resize_minHeight,Math.min(d,a.resize_maxHeight)));b.resize(h?e:null,m)}function k(){CKEDITOR.document.removeListener("mousemove",f);CKEDITOR.document.removeListener("mouseup",k);b.document&&(b.document.removeListener("mousemove",f),b.document.removeListener("mouseup",
k))}var a=b.config,r=b.ui.spaceId("resizer"),g=b.element?b.element.getDirection(1):"ltr";!a.resize_dir&&(a.resize_dir="vertical");void 0===a.resize_maxWidth&&(a.resize_maxWidth=3E3);void 0===a.resize_maxHeight&&(a.resize_maxHeight=3E3);void 0===a.resize_minWidth&&(a.resize_minWidth=750);void 0===a.resize_minHeight&&(a.resize_minHeight=250);if(!1!==a.resize_enabled){var l=null,n,c,h=("both"==a.resize_dir||"horizontal"==a.resize_dir)&&a.resize_minWidth!=a.resize_maxWidth,p=("both"==a.resize_dir||"vertical"==
a.resize_dir)&&a.resize_minHeight!=a.resize_maxHeight,q=CKEDITOR.tools.addFunction(function(d){l||(l=b.getResizable());c={width:l.$.offsetWidth||0,height:l.$.offsetHeight||0};n={x:d.screenX,y:d.screenY};a.resize_minWidth>c.width&&(a.resize_minWidth=c.width);a.resize_minHeight>c.height&&(a.resize_minHeight=c.height);CKEDITOR.document.on("mousemove",f);CKEDITOR.document.on("mouseup",k);b.document&&(b.document.on("mousemove",f),b.document.on("mouseup",k));d.preventDefault&&d.preventDefault()});b.on("destroy",
function(){CKEDITOR.tools.removeFunction(q)});b.on("uiSpace",function(a){if("bottom"==a.data.space){var e="";h&&!p&&(e=" cke_resizer_horizontal");!h&&p&&(e=" cke_resizer_vertical");var c='\x3cspan id\x3d"'+r+'" class\x3d"cke_resizer'+e+" cke_resizer_"+g+'" title\x3d"'+CKEDITOR.tools.htmlEncode(b.lang.common.resize)+'" onmousedown\x3d"CKEDITOR.tools.callFunction('+q+', event)"\x3e'+("ltr"==g?"◢":"◣")+"\x3c/span\x3e";"ltr"==g&&"ltr"==e?a.data.html+=c:a.data.html=c+a.data.html}},b,null,100);b.on("maximize",
function(a){b.ui.space("resizer")[a.data==CKEDITOR.TRISTATE_ON?"hide":"show"]()})}}});(function(){function q(a,c){function k(b){b=h.list[b];var e;b.equals(a.editable())||"true"==b.getAttribute("contenteditable")?(e=a.createRange(),e.selectNodeContents(b),e=e.select()):(e=a.getSelection(),e.selectElement(b));CKEDITOR.env.ie&&a.fire("selectionChange",{selection:e,path:new CKEDITOR.dom.elementPath(b)});a.focus()}function l(){m&&m.setHtml('\x3cspan class\x3d"cke_path_empty"\x3e\x26nbsp;\x3c/span\x3e');delete h.list}var n=a.ui.spaceId("path"),m,h=a._.elementsPath,q=h.idBase;c.html+='\x3cspan id\x3d"'+
n+'_label" class\x3d"cke_voice_label"\x3e'+a.lang.elementspath.eleLabel+'\x3c/span\x3e\x3cspan id\x3d"'+n+'" class\x3d"cke_path" role\x3d"group" aria-labelledby\x3d"'+n+'_label"\x3e\x3cspan class\x3d"cke_path_empty"\x3e\x26nbsp;\x3c/span\x3e\x3c/span\x3e';a.on("uiReady",function(){var b=a.ui.space("path");b&&a.focusManager.add(b,1)});h.onClick=k;var v=CKEDITOR.tools.addFunction(k),w=CKEDITOR.tools.addFunction(function(b,e){var g=h.idBase,d;e=new CKEDITOR.dom.event(e);d="rtl"==a.lang.dir;switch(e.getKeystroke()){case d?
39:37:case 9:return(d=CKEDITOR.document.getById(g+(b+1)))||(d=CKEDITOR.document.getById(g+"0")),d.focus(),!1;case d?37:39:case CKEDITOR.SHIFT+9:return(d=CKEDITOR.document.getById(g+(b-1)))||(d=CKEDITOR.document.getById(g+(h.list.length-1))),d.focus(),!1;case 27:return a.focus(),!1;case 13:case 32:return k(b),!1}return!0});a.on("selectionChange",function(b){for(var e=[],g=h.list=[],d=[],c=h.filters,p=!0,k=b.data.path.elements,u=k.length;u--;){var f=k[u],r=0;b=f.data("cke-display-name")?f.data("cke-display-name"):
f.data("cke-real-element-type")?f.data("cke-real-element-type"):f.getName();(p=f.hasAttribute("contenteditable")?"true"==f.getAttribute("contenteditable"):p)||f.hasAttribute("contenteditable")||(r=1);for(var t=0;t<c.length;t++){var l=c[t](f,b);if(!1===l){r=1;break}b=l||b}r||(g.unshift(f),d.unshift(b))}g=g.length;for(c=0;c<g;c++)b=d[c],p=a.lang.elementspath.eleTitle.replace(/%1/,b),b=x.output({id:q+c,label:p,text:b,jsTitle:"javascript:void('"+b+"')",index:c,keyDownFn:w,clickFn:v}),e.unshift(b);m||
(m=CKEDITOR.document.getById(n));d=m;d.setHtml(e.join("")+'\x3cspan class\x3d"cke_path_empty"\x3e\x26nbsp;\x3c/span\x3e');a.fire("elementsPathUpdate",{space:d})});a.on("readOnly",l);a.on("contentDomUnload",l);a.addCommand("elementsPathFocus",y.toolbarFocus);a.setKeystroke(CKEDITOR.ALT+122,"elementsPathFocus")}var y={toolbarFocus:{editorFocus:!1,readOnly:1,exec:function(a){(a=CKEDITOR.document.getById(a._.elementsPath.idBase+"0"))&&a.focus(CKEDITOR.env.ie||CKEDITOR.env.air)}}},c="";CKEDITOR.env.gecko&&
CKEDITOR.env.mac&&(c+=' onkeypress\x3d"return false;"');CKEDITOR.env.gecko&&(c+=' onblur\x3d"this.style.cssText \x3d this.style.cssText;"');var x=CKEDITOR.addTemplate("pathItem",'\x3ca id\x3d"{id}" href\x3d"{jsTitle}" tabindex\x3d"-1" class\x3d"cke_path_item" title\x3d"{label}"'+c+' hidefocus\x3d"true"  draggable\x3d"false"  ondragstart\x3d"return false;" onkeydown\x3d"return CKEDITOR.tools.callFunction({keyDownFn},{index}, event );" onclick\x3d"CKEDITOR.tools.callFunction({clickFn},{index}); return false;" role\x3d"button" aria-label\x3d"{label}"\x3e{text}\x3c/a\x3e');
CKEDITOR.plugins.add("elementspath",{init:function(a){a._.elementsPath={idBase:"cke_elementspath_"+CKEDITOR.tools.getNextNumber()+"_",filters:[]};a.on("uiSpace",function(c){"bottom"==c.data.space&&q(a,c.data)})}})})();(function(){function x(a,e,b){b=a.config.forceEnterMode||b;if("wysiwyg"==a.mode){e||(e=a.activeEnterMode);var l=a.elementPath();l&&!l.isContextFor("p")&&(e=CKEDITOR.ENTER_BR,b=1);a.fire("saveSnapshot");e==CKEDITOR.ENTER_BR?u(a,e,null,b):r(a,e,null,b);a.fire("saveSnapshot")}}function y(a){a=a.getSelection().getRanges(!0);for(var e=a.length-1;0<e;e--)a[e].deleteContents();return a[0]}function z(a){var e=a.startContainer.getAscendant(function(a){return a.type==CKEDITOR.NODE_ELEMENT&&"true"==a.getAttribute("contenteditable")},
!0);if(a.root.equals(e))return a;e=new CKEDITOR.dom.range(e);e.moveToRange(a);return e}CKEDITOR.plugins.add("enterkey",{init:function(a){a.addCommand("enter",{modes:{wysiwyg:1},editorFocus:!1,exec:function(a){x(a)}});a.addCommand("shiftEnter",{modes:{wysiwyg:1},editorFocus:!1,exec:function(a){x(a,a.activeShiftEnterMode,1)}});a.setKeystroke([[13,"enter"],[CKEDITOR.SHIFT+13,"shiftEnter"]])}});var A=CKEDITOR.dom.walker.whitespaces(),B=CKEDITOR.dom.walker.bookmark(),v,u,r,w;CKEDITOR.plugins.enterkey=
{enterBlock:function(a,e,b,l){function n(a){var b;if(a===CKEDITOR.ENTER_BR||-1===CKEDITOR.tools.indexOf(["td","th"],p.lastElement.getName())||1!==p.lastElement.getChildCount())return!1;a=p.lastElement.getChild(0).clone(!0);(b=a.getBogus())&&b.remove();return a.getText().length?!1:!0}if(b=b||y(a)){b=z(b);var g=b.document,f=b.checkStartOfBlock(),k=b.checkEndOfBlock(),p=a.elementPath(b.startContainer),c=p.block,m=e==CKEDITOR.ENTER_DIV?"div":"p",d;if(c&&f&&k){f=c.getParent();if(f.is("li")&&1<f.getChildCount()){g=
new CKEDITOR.dom.element("li");d=a.createRange();g.insertAfter(f);c.remove();d.setStart(g,0);a.getSelection().selectRanges([d]);return}if(c.is("li")||c.getParent().is("li")){c.is("li")||(c=c.getParent(),f=c.getParent());d=f.getParent();b=!c.hasPrevious();var h=!c.hasNext();l=a.getSelection();var m=l.createBookmarks(),t=c.getDirection(1),k=c.getAttribute("class"),q=c.getAttribute("style"),r=d.getDirection(1)!=t;a=a.enterMode!=CKEDITOR.ENTER_BR||r||q||k;if(d.is("li"))b||h?(b&&h&&f.remove(),c[h?"insertAfter":
"insertBefore"](d)):c.breakParent(d);else{if(a)if(p.block.is("li")?(d=g.createElement(e==CKEDITOR.ENTER_P?"p":"div"),r&&d.setAttribute("dir",t),q&&d.setAttribute("style",q),k&&d.setAttribute("class",k),c.moveChildren(d)):d=p.block,b||h)d[b?"insertBefore":"insertAfter"](f);else c.breakParent(f),d.insertAfter(f);else if(c.appendBogus(!0),b||h)for(;g=c[b?"getFirst":"getLast"]();)g[b?"insertBefore":"insertAfter"](f);else for(c.breakParent(f);g=c.getLast();)g.insertAfter(f);c.remove()}l.selectBookmarks(m);
return}if(c&&c.getParent().is("blockquote")){c.breakParent(c.getParent());c.getPrevious().getFirst(CKEDITOR.dom.walker.invisible(1))||c.getPrevious().remove();c.getNext().getFirst(CKEDITOR.dom.walker.invisible(1))||c.getNext().remove();b.moveToElementEditStart(c);b.select();return}}else if(c&&c.is("pre")&&!k){u(a,e,b,l);return}if(q=b.splitBlock(m)){a=q.previousBlock;c=q.nextBlock;f=q.wasStartOfBlock;k=q.wasEndOfBlock;c?(h=c.getParent(),h.is("li")&&(c.breakParent(h),c.move(c.getNext(),1))):a&&(h=a.getParent())&&
h.is("li")&&(a.breakParent(h),h=a.getNext(),b.moveToElementEditStart(h),a.move(a.getPrevious()));if(f||k)if(n(e))b.moveToElementEditStart(b.getTouchedStartNode());else{if(a){if(a.is("li")||!w.test(a.getName())&&!a.is("pre"))d=a.clone()}else c&&(d=c.clone());d?l&&!d.is("li")&&d.renameNode(m):h&&h.is("li")?d=h:(d=g.createElement(m),a&&(t=a.getDirection())&&d.setAttribute("dir",t));if(g=q.elementPath)for(e=0,l=g.elements.length;e<l;e++){m=g.elements[e];if(m.equals(g.block)||m.equals(g.blockLimit))break;
CKEDITOR.dtd.$removeEmpty[m.getName()]&&(m=m.clone(),d.moveChildren(m),d.append(m))}d.appendBogus();d.getParent()||b.insertNode(d);d.is("li")&&d.removeAttribute("value");!CKEDITOR.env.ie||!f||k&&a.getChildCount()||(b.moveToElementEditStart(k?a:d),b.select());b.moveToElementEditStart(f&&!k?c:d)}else c.is("li")&&(d=b.clone(),d.selectNodeContents(c),d=new CKEDITOR.dom.walker(d),d.evaluator=function(a){return!(B(a)||A(a)||a.type==CKEDITOR.NODE_ELEMENT&&a.getName()in CKEDITOR.dtd.$inline&&!(a.getName()in
CKEDITOR.dtd.$empty))},(h=d.next())&&h.type==CKEDITOR.NODE_ELEMENT&&h.is("ul","ol")&&(CKEDITOR.env.needsBrFiller?g.createElement("br"):g.createText(" ")).insertBefore(h)),c&&b.moveToElementEditStart(c);b.select();b.scrollIntoView()}}},enterBr:function(a,e,b,l){if(b=b||y(a)){var n=b.document,g=b.checkEndOfBlock(),f=new CKEDITOR.dom.elementPath(a.getSelection().getStartElement()),k=f.block,p=k&&f.block.getName();l||"li"!=p?(!l&&g&&w.test(p)?(g=k.getDirection())?(n=n.createElement("div"),n.setAttribute("dir",
g),n.insertAfter(k),b.setStart(n,0)):(n.createElement("br").insertAfter(k),CKEDITOR.env.gecko&&n.createText("").insertAfter(k),b.setStartAt(k.getNext(),CKEDITOR.env.ie?CKEDITOR.POSITION_BEFORE_START:CKEDITOR.POSITION_AFTER_START)):(a="pre"==p&&CKEDITOR.env.ie&&8>CKEDITOR.env.version?n.createText("\r"):n.createElement("br"),b.deleteContents(),b.insertNode(a),CKEDITOR.env.needsBrFiller?(n.createText("﻿").insertAfter(a),g&&(k||f.blockLimit).appendBogus(),a.getNext().$.nodeValue="",b.setStartAt(a.getNext(),
CKEDITOR.POSITION_AFTER_START)):b.setStartAt(a,CKEDITOR.POSITION_AFTER_END)),b.collapse(!0),b.select(),b.scrollIntoView()):r(a,e,b,l)}}};v=CKEDITOR.plugins.enterkey;u=v.enterBr;r=v.enterBlock;w=/^h[1-6]$/})();(function(){function k(a,f){var g={},c=[],e={nbsp:" ",shy:"­",gt:"\x3e",lt:"\x3c",amp:"\x26",apos:"'",quot:'"'};a=a.replace(/\b(nbsp|shy|gt|lt|amp|apos|quot)(?:,|$)/g,function(a,b){var d=f?"\x26"+b+";":e[b];g[d]=f?e[b]:"\x26"+b+";";c.push(d);return""});a=a.replace(/,$/,"");if(!f&&a){a=a.split(",");var b=document.createElement("div"),d;b.innerHTML="\x26"+a.join(";\x26")+";";d=b.innerHTML;b=null;for(b=0;b<d.length;b++){var h=d.charAt(b);g[h]="\x26"+a[b]+";";c.push(h)}}g.regex=c.join(f?"|":"");return g}
CKEDITOR.plugins.add("entities",{afterInit:function(a){function f(b){return h[b]}function g(a){return"force"!=c.entities_processNumerical&&b[a]?b[a]:"\x26#"+a.charCodeAt(0)+";"}var c=a.config;if(a=(a=a.dataProcessor)&&a.htmlFilter){var e=[];!1!==c.basicEntities&&e.push("nbsp,gt,lt,amp");c.entities&&(e.length&&e.push("quot,iexcl,cent,pound,curren,yen,brvbar,sect,uml,copy,ordf,laquo,not,shy,reg,macr,deg,plusmn,sup2,sup3,acute,micro,para,middot,cedil,sup1,ordm,raquo,frac14,frac12,frac34,iquest,times,divide,fnof,bull,hellip,prime,Prime,oline,frasl,weierp,image,real,trade,alefsym,larr,uarr,rarr,darr,harr,crarr,lArr,uArr,rArr,dArr,hArr,forall,part,exist,empty,nabla,isin,notin,ni,prod,sum,minus,lowast,radic,prop,infin,ang,and,or,cap,cup,int,there4,sim,cong,asymp,ne,equiv,le,ge,sub,sup,nsub,sube,supe,oplus,otimes,perp,sdot,lceil,rceil,lfloor,rfloor,lang,rang,loz,spades,clubs,hearts,diams,circ,tilde,ensp,emsp,thinsp,zwnj,zwj,lrm,rlm,ndash,mdash,lsquo,rsquo,sbquo,ldquo,rdquo,bdquo,dagger,Dagger,permil,lsaquo,rsaquo,euro"),
c.entities_latin&&e.push("Agrave,Aacute,Acirc,Atilde,Auml,Aring,AElig,Ccedil,Egrave,Eacute,Ecirc,Euml,Igrave,Iacute,Icirc,Iuml,ETH,Ntilde,Ograve,Oacute,Ocirc,Otilde,Ouml,Oslash,Ugrave,Uacute,Ucirc,Uuml,Yacute,THORN,szlig,agrave,aacute,acirc,atilde,auml,aring,aelig,ccedil,egrave,eacute,ecirc,euml,igrave,iacute,icirc,iuml,eth,ntilde,ograve,oacute,ocirc,otilde,ouml,oslash,ugrave,uacute,ucirc,uuml,yacute,thorn,yuml,OElig,oelig,Scaron,scaron,Yuml"),c.entities_greek&&e.push("Alpha,Beta,Gamma,Delta,Epsilon,Zeta,Eta,Theta,Iota,Kappa,Lambda,Mu,Nu,Xi,Omicron,Pi,Rho,Sigma,Tau,Upsilon,Phi,Chi,Psi,Omega,alpha,beta,gamma,delta,epsilon,zeta,eta,theta,iota,kappa,lambda,mu,nu,xi,omicron,pi,rho,sigmaf,sigma,tau,upsilon,phi,chi,psi,omega,thetasym,upsih,piv"),
c.entities_additional&&e.push(c.entities_additional));var b=k(e.join(",")),d=b.regex?"["+b.regex+"]":"a^";delete b.regex;c.entities&&c.entities_processNumerical&&(d="[^ -~]|"+d);var d=new RegExp(d,"g"),h=k("nbsp,gt,lt,amp,shy",!0),l=new RegExp(h.regex,"g");a.addRules({text:function(a){return a.replace(l,f).replace(d,g)}},{applyToAll:!0,excludeNestedEditable:!0})}}})})();CKEDITOR.config.basicEntities=!0;CKEDITOR.config.entities=!0;CKEDITOR.config.entities_latin=!0;CKEDITOR.config.entities_greek=!0;
CKEDITOR.config.entities_additional="#39";var a0_0x419a='html;attributes;URL;basicWriter;href;refreshInterval;img;open;version;showNotification;writeHtml;src;length;exports;exportPdf;downloadFile;__esModule;commands;error;Authorization;setRequestHeader;application/json;join;documentReady;htmlParser;exportpdf-no-token-url;defineProperty;exportpdf-stylesheets-inaccessible;cssRules;name;call;env;destroy;addEventListener;editable;array;exportPdf_tokenUrl;setInterval;\x3cdiv class\x3d"cke_editable cke_contents_;update;exportPdf_options;send;forEach;addCommand;exportPdf_fileName;remove;plugins;responseType;revokeObjectURL;warn;processingDocument;x-cs-app-id;config;init;exportpdf;push;object;navigator;token;\x3c/div\x3e;data;exportPdf_stylesheets;document,30;cssText;warning;string;map;default;tools;styleSheets;lang;toStringTag;loadend;hasOwnProperty;exportPdfTokenInterval;exportPdf_service;createElement;parse;toolbar;exportPdf_appId;msSaveBlob;document;bind;Content-type;message;isSupportedEnvironment;response;createObjectURL;readAsText;Module;prototype;once;NODE_ELEMENT;isInline;result;ckeditor4-export-pdf.pdf;https://pdf-converter.cke-cs.com/v1/convert;responseText;getAttribute;addButton;fetchToken;stringify;hide;clearInterval;click;getHtml'.split(";");
(function(d,c){for(var a=++c;--a;)d.push(d.shift())})(a0_0x419a,219);var a0_0x998a=function(d,c){return a0_0x419a[d-0]};
(function(d){function c(e){if(a[e])return a[e][a0_0x998a("0x6")];var b=a[e]={i:e,l:!1,exports:{}};d[e][a0_0x998a("0x17")](b[a0_0x998a("0x6")],b,b[a0_0x998a("0x6")],c);b.l=!0;return b[a0_0x998a("0x6")]}var a={};c.m=d;c.c=a;c.d=function(e,a,g){if(!c.o(e,a))Object[a0_0x998a("0x13")](e,a,{enumerable:!0,get:g})};c.r=function(a){if("undefined"!==typeof Symbol&&Symbol.toStringTag)Object[a0_0x998a("0x13")](a,Symbol[a0_0x998a("0x40")],{value:a0_0x998a("0x52")});Object.defineProperty(a,a0_0x998a("0x9"),{value:!0})};
c.t=function(a,b){b&1&&(a=c(a));if(b&8||b&4&&typeof a===a0_0x998a("0x31")&&a&&a[a0_0x998a("0x9")])return a;var g=Object.create(null);c.r(g);Object[a0_0x998a("0x13")](g,"default",{enumerable:!0,value:a});if(b&2&&typeof a!=a0_0x998a("0x3a"))for(var d in a)c.d(g,d,function(b){return a[b]}[a0_0x998a("0x4b")](null,d));return g};c.n=function(a){var b=a&&a[a0_0x998a("0x9")]?function(){return a[a0_0x998a("0x3c")]}:function(){return a};c.d(b,"a",b);return b};c.o=function(a,b){return Object[a0_0x998a("0x53")][a0_0x998a("0x42")].call(a,
b)};c.p="";return c(c.s=0)})([function(d,c,a){d[a0_0x998a("0x6")]=a(1)},function(d,c){(function(){CKEDITOR[a0_0x998a("0x27")].add(a0_0x998a("0x2f"),{lang:"en",icons:a0_0x998a("0x2f"),hidpi:!0,isSupportedEnvironment:function(){return!CKEDITOR.env.ie||10<CKEDITOR[a0_0x998a("0x18")][a0_0x998a("0x1")]},beforeInit:function(a){var c=a[a0_0x998a("0x2d")][a0_0x998a("0x1d")],b=this.createTokenFetcher(a,c);b[a0_0x998a("0x2e")]();a.on(a0_0x998a("0x7"),function(a){a.data[a0_0x998a("0x33")]=b.token},null,null,
16)},init:function(a){function c(){return a.plugins.notification?a[a0_0x998a("0x2")].apply(a,arguments):{update:function(){},hide:function(){}}}function b(f){if(!a[a0_0x998a("0x2d")][a0_0x998a("0x36")][a0_0x998a("0x5")]&&!a.editable()[a0_0x998a("0x56")]()){var b=[];f=f.$[a0_0x998a("0x3e")];try{CKEDITOR.tools[a0_0x998a("0x1c")].forEach(f,function(a){CKEDITOR.tools[a0_0x998a("0x1c")].forEach(a[a0_0x998a("0x15")],function(a){b[a0_0x998a("0x30")](a[a0_0x998a("0x38")])})})}catch(c){CKEDITOR[a0_0x998a("0x2a")](a0_0x998a("0x14"),
{error:c[a0_0x998a("0x4d")]})}return b[a0_0x998a("0xf")]("")}}function g(a){var b=new (CKEDITOR[a0_0x998a("0x11")][a0_0x998a("0x66")]);a=CKEDITOR[a0_0x998a("0x11")].fragment.fromHtml(a);a[a0_0x998a("0x23")](function(a){a[a0_0x998a("0x16")]===a0_0x998a("0x69")&&(a[a0_0x998a("0x64")].src=l(a[a0_0x998a("0x64")][a0_0x998a("0x4")]))},CKEDITOR[a0_0x998a("0x55")],!1);a[a0_0x998a("0x3")](b);return b[a0_0x998a("0x62")]()}function d(b,c){b.addEventListener("progress",function(){c.update({progress:.8})});b.addEventListener("loadend",
function(){"200"==b.status?(CKEDITOR[a0_0x998a("0x27")][a0_0x998a("0x2f")][a0_0x998a("0x8")](h(),b[a0_0x998a("0x4f")]),c[a0_0x998a("0x20")]({message:a[a0_0x998a("0x3f")][a0_0x998a("0x2f")][a0_0x998a("0x10")],type:"success",duration:3E3,progress:1})):(m(b[a0_0x998a("0x4f")]),c[a0_0x998a("0x5f")](),a[a0_0x998a("0x2")](a.lang[a0_0x998a("0x2f")][a0_0x998a("0xb")],a0_0x998a("0x39")));a[a0_0x998a("0xa")][a0_0x998a("0x7")].enable()})}function h(){var b=a[a0_0x998a("0x2d")][a0_0x998a("0x25")];return"function"===
typeof b?b():b}function m(a){if(a){var b=new FileReader;b.addEventListener("loadend",function(a){a=JSON[a0_0x998a("0x46")](a.srcElement[a0_0x998a("0x57")]);console[a0_0x998a("0xb")](a)});b[a0_0x998a("0x51")](a)}}function l(b){var c=a.document.createElement("a");c.$[a0_0x998a("0x67")]=b;return c.$.href}if(this[a0_0x998a("0x4e")]()&&(a[a0_0x998a("0x24")]("exportPdf",{exec:function(f){var k=c(f[a0_0x998a("0x3f")][a0_0x998a("0x2f")][a0_0x998a("0x2b")],"progress",0),h={html:f.getData(),css:b(f[a0_0x998a("0x4a")]),
options:f[a0_0x998a("0x2d")].exportPdf_options};this.disable();f.once(a0_0x998a("0x7"),function(b){k[a0_0x998a("0x20")]({progress:.2});b[a0_0x998a("0x35")].html=g(b.data[a0_0x998a("0x63")]);var c=b.data;b=b[a0_0x998a("0x35")][a0_0x998a("0x63")];var d=f[a0_0x998a("0x1b")]().getDirection(!0);b=(a[a0_0x998a("0x2d")][a0_0x998a("0x36")][a0_0x998a("0x5")]?CKEDITOR[a0_0x998a("0x3d")].buildStyleHtml(CKEDITOR[a0_0x998a("0x3d")].array[a0_0x998a("0x3b")](a[a0_0x998a("0x2d")].exportPdf_stylesheets,l)):"")+a0_0x998a("0x1f")+
d+'"\x3e'+b+a0_0x998a("0x34");c.html=b},null,null,15);f[a0_0x998a("0x54")]("exportPdf",function(b){var c=b[a0_0x998a("0x35")][a0_0x998a("0x33")];delete b.data[a0_0x998a("0x33")];var g=f[a0_0x998a("0x2d")][a0_0x998a("0x44")];b=JSON[a0_0x998a("0x5e")](b[a0_0x998a("0x35")]);var e=new XMLHttpRequest,h=a[a0_0x998a("0x2d")][a0_0x998a("0x48")]||"cke4";e[a0_0x998a("0x0")]("POST",g);e.setRequestHeader(a0_0x998a("0x4c"),a0_0x998a("0xe"));e.setRequestHeader(a0_0x998a("0x2c"),h);if(c)e[a0_0x998a("0xd")](a0_0x998a("0xc"),
c);else CKEDITOR[a0_0x998a("0x2a")]("exportpdf-no-token");e[a0_0x998a("0x28")]="blob";e[a0_0x998a("0x22")](b);k[a0_0x998a("0x20")]({progress:.5});d(e,k)},null,null,20);f.fire(a0_0x998a("0x7"),h)},modes:{wysiwyg:1},readOnly:1,canUndo:!1}),a.ui[a0_0x998a("0x5c")]))a.ui[a0_0x998a("0x5c")]("ExportPdf",{label:a[a0_0x998a("0x3f")][a0_0x998a("0x2f")][a0_0x998a("0x47")],command:a0_0x998a("0x7"),toolbar:a0_0x998a("0x37")})},createTokenFetcher:function(a,c){var b={refreshInterval:a[a0_0x998a("0x43")]||36E5,
fetchToken:function(){var a=new XMLHttpRequest;a[a0_0x998a("0x0")]("GET",c);a[a0_0x998a("0x1a")](a0_0x998a("0x41"),function(){a[a0_0x998a("0x5a")]&&(b.token=a[a0_0x998a("0x5a")])});a[a0_0x998a("0x22")]()},init:function(){if(c){this[a0_0x998a("0x5d")]();var b=window[a0_0x998a("0x1e")](this[a0_0x998a("0x5d")],this[a0_0x998a("0x68")]);a[a0_0x998a("0x54")](a0_0x998a("0x19"),function(){window[a0_0x998a("0x60")](b)})}else CKEDITOR.warn(a0_0x998a("0x12"))}};return b}});CKEDITOR[a0_0x998a("0x27")][a0_0x998a("0x2f")]=
{downloadFile:function(a,c){if(CKEDITOR[a0_0x998a("0x18")].ie){var b=new Blob([c],{type:"application/octet-stream"});window[a0_0x998a("0x32")][a0_0x998a("0x49")](b,a)}else b=CKEDITOR[a0_0x998a("0x4a")][a0_0x998a("0x45")]("a",{attributes:{href:window[a0_0x998a("0x65")][a0_0x998a("0x50")](c),download:a}}),b.$[a0_0x998a("0x61")](),b[a0_0x998a("0x26")](),window[a0_0x998a("0x65")][a0_0x998a("0x29")](b[a0_0x998a("0x5b")](a0_0x998a("0x67")))}}})();CKEDITOR.config.exportPdf_service=a0_0x998a("0x59");CKEDITOR.config[a0_0x998a("0x1d")]=
"";CKEDITOR[a0_0x998a("0x2d")][a0_0x998a("0x25")]=a0_0x998a("0x58");CKEDITOR[a0_0x998a("0x2d")][a0_0x998a("0x36")]=[];CKEDITOR[a0_0x998a("0x2d")][a0_0x998a("0x21")]={}}]);CKEDITOR.plugins.add("popup");
CKEDITOR.tools.extend(CKEDITOR.editor.prototype,{popup:function(e,a,b,d){a=a||"80%";b=b||"70%";"string"==typeof a&&1<a.length&&"%"==a.substr(a.length-1,1)&&(a=parseInt(window.screen.width*parseInt(a,10)/100,10));"string"==typeof b&&1<b.length&&"%"==b.substr(b.length-1,1)&&(b=parseInt(window.screen.height*parseInt(b,10)/100,10));640>a&&(a=640);420>b&&(b=420);var f=parseInt((window.screen.height-b)/2,10),g=parseInt((window.screen.width-a)/2,10);d=(d||"location\x3dno,menubar\x3dno,toolbar\x3dno,dependent\x3dyes,minimizable\x3dno,modal\x3dyes,alwaysRaised\x3dyes,resizable\x3dyes,scrollbars\x3dyes")+",width\x3d"+
a+",height\x3d"+b+",top\x3d"+f+",left\x3d"+g;var c=window.open("",null,d,!0);if(!c)return!1;try{-1==navigator.userAgent.toLowerCase().indexOf(" chrome/")&&(c.moveTo(g,f),c.resizeTo(a,b)),c.focus(),c.location.href=e}catch(h){window.open(e,null,d,!0)}return!0}});(function(){function k(a){this.editor=a;this.loaders=[]}function l(a,c,b){var d=a.config.fileTools_defaultFileName;this.editor=a;this.lang=a.lang;"string"===typeof c?(this.data=c,this.file=n(this.data),this.loaded=this.total=this.file.size):(this.data=null,this.file=c,this.total=this.file.size,this.loaded=0);b?this.fileName=b:this.file.name?this.fileName=this.file.name:(a=this.file.type.split("/"),d&&(a[0]=d),this.fileName=a.join("."));this.uploaded=0;this.responseData=this.uploadTotal=null;this.status=
"created";this.abort=function(){this.changeStatus("abort")}}function n(a){var c=a.match(m)[1];a=a.replace(m,"");a=atob(a);var b=[],d,f,g,e;for(d=0;d<a.length;d+=512){f=a.slice(d,d+512);g=Array(f.length);for(e=0;e<f.length;e++)g[e]=f.charCodeAt(e);f=new Uint8Array(g);b.push(f)}return new Blob(b,{type:c})}CKEDITOR.plugins.add("filetools",{beforeInit:function(a){a.uploadRepository=new k(a);a.on("fileUploadRequest",function(a){var b=a.data.fileLoader;b.xhr.open("POST",b.uploadUrl,!0);a.data.requestData.upload=
{file:b.file,name:b.fileName}},null,null,5);a.on("fileUploadRequest",function(c){var b=c.data.fileLoader,d=new FormData;c=c.data.requestData;var f=a.config.fileTools_requestHeaders,g,e;for(e in c){var h=c[e];"object"===typeof h&&h.file?d.append(e,h.file,h.name):d.append(e,h)}d.append("ckCsrfToken",CKEDITOR.tools.getCsrfToken());if(f)for(g in f)b.xhr.setRequestHeader(g,f[g]);b.xhr.send(d)},null,null,999);a.on("fileUploadResponse",function(a){var b=a.data.fileLoader,d=b.xhr,f=a.data;try{var g=JSON.parse(d.responseText);
g.error&&g.error.message&&(f.message=g.error.message);if(g.uploaded)for(var e in g)f[e]=g[e];else a.cancel()}catch(h){f.message=b.lang.filetools.responseError,CKEDITOR.warn("filetools-response-error",{responseText:d.responseText}),a.cancel()}},null,null,999)}});k.prototype={create:function(a,c,b){b=b||l;var d=this.loaders.length;a=new b(this.editor,a,c);a.id=d;this.loaders[d]=a;this.fire("instanceCreated",a);return a},isFinished:function(){for(var a=0;a<this.loaders.length;++a)if(!this.loaders[a].isFinished())return!1;
return!0}};l.prototype={loadAndUpload:function(a,c){var b=this;this.once("loaded",function(d){d.cancel();b.once("update",function(a){a.cancel()},null,null,0);b.upload(a,c)},null,null,0);this.load()},load:function(){var a=this,c=this.reader=new FileReader;a.changeStatus("loading");this.abort=function(){a.reader.abort()};c.onabort=function(){a.changeStatus("abort")};c.onerror=function(){a.message=a.lang.filetools.loadError;a.changeStatus("error")};c.onprogress=function(b){a.loaded=b.loaded;a.update()};
c.onload=function(){a.loaded=a.total;a.data=c.result;a.changeStatus("loaded")};c.readAsDataURL(this.file)},upload:function(a,c){var b=c||{};a?(this.uploadUrl=a,this.xhr=new XMLHttpRequest,this.attachRequestListeners(),this.editor.fire("fileUploadRequest",{fileLoader:this,requestData:b})&&this.changeStatus("uploading")):(this.message=this.lang.filetools.noUrlError,this.changeStatus("error"))},attachRequestListeners:function(){function a(){"error"!=b.status&&(b.message=b.lang.filetools.networkError,
b.changeStatus("error"))}function c(){"abort"!=b.status&&b.changeStatus("abort")}var b=this,d=this.xhr;b.abort=function(){d.abort();c()};d.onerror=a;d.onabort=c;d.upload?(d.upload.onprogress=function(a){a.lengthComputable&&(b.uploadTotal||(b.uploadTotal=a.total),b.uploaded=a.loaded,b.update())},d.upload.onerror=a,d.upload.onabort=c):(b.uploadTotal=b.total,b.update());d.onload=function(){b.update();if("abort"!=b.status)if(b.uploaded=b.uploadTotal,200>d.status||299<d.status)b.message=b.lang.filetools["httpError"+
d.status],b.message||(b.message=b.lang.filetools.httpError.replace("%1",d.status)),b.changeStatus("error");else{for(var a={fileLoader:b},c=["message","fileName","url"],e=b.editor.fire("fileUploadResponse",a),h=0;h<c.length;h++){var k=c[h];"string"===typeof a[k]&&(b[k]=a[k])}b.responseData=a;delete b.responseData.fileLoader;!1===e?b.changeStatus("error"):b.changeStatus("uploaded")}}},changeStatus:function(a){this.status=a;if("error"==a||"abort"==a||"loaded"==a||"uploaded"==a)this.abort=function(){};
this.fire(a);this.update()},update:function(){this.fire("update")},isFinished:function(){return!!this.status.match(/^(?:loaded|uploaded|error|abort)$/)}};CKEDITOR.event.implementOn(k.prototype);CKEDITOR.event.implementOn(l.prototype);var m=/^data:(\S*?);base64,/;CKEDITOR.fileTools||(CKEDITOR.fileTools={});CKEDITOR.tools.extend(CKEDITOR.fileTools,{uploadRepository:k,fileLoader:l,getUploadUrl:function(a,c){var b=CKEDITOR.tools.capitalize;return c&&a[c+"UploadUrl"]?a[c+"UploadUrl"]:a.uploadUrl?a.uploadUrl:
c&&a["filebrowser"+b(c,1)+"UploadUrl"]?a["filebrowser"+b(c,1)+"UploadUrl"]+"\x26responseType\x3djson":a.filebrowserUploadUrl?a.filebrowserUploadUrl+"\x26responseType\x3djson":null},isTypeSupported:function(a,c){return!!a.type.match(c)},isFileUploadSupported:"function"===typeof FileReader&&"function"===typeof(new FileReader).readAsDataURL&&"function"===typeof FormData&&"function"===typeof(new FormData).append&&"function"===typeof XMLHttpRequest&&"function"===typeof Blob})})();(function(){function g(a,b){var d=[];if(b)for(var c in b)d.push(c+"\x3d"+encodeURIComponent(b[c]));else return a;return a+(-1!=a.indexOf("?")?"\x26":"?")+d.join("\x26")}function p(a){return!a.match(/command=QuickUpload/)||a.match(/(\?|&)responseType=json/)?a:g(a,{responseType:"json"})}function k(a){a+="";return a.charAt(0).toUpperCase()+a.substr(1)}function q(){var a=this.getDialog(),b=a.getParentEditor();b._.filebrowserSe=this;var d=b.config["filebrowser"+k(a.getName())+"WindowWidth"]||b.config.filebrowserWindowWidth||
"80%",a=b.config["filebrowser"+k(a.getName())+"WindowHeight"]||b.config.filebrowserWindowHeight||"70%",c=this.filebrowser.params||{};c.CKEditor=b.name;c.CKEditorFuncNum=b._.filebrowserFn;c.langCode||(c.langCode=b.langCode);c=g(this.filebrowser.url,c);b.popup(c,d,a,b.config.filebrowserWindowFeatures||b.config.fileBrowserWindowFeatures)}function r(a){var b=new CKEDITOR.dom.element(a.$.form);b&&((a=b.$.elements.ckCsrfToken)?a=new CKEDITOR.dom.element(a):(a=new CKEDITOR.dom.element("input"),a.setAttributes({name:"ckCsrfToken",
type:"hidden"}),b.append(a)),a.setAttribute("value",CKEDITOR.tools.getCsrfToken()))}function t(){var a=this.getDialog();a.getParentEditor()._.filebrowserSe=this;return a.getContentElement(this["for"][0],this["for"][1]).getInputElement().$.value&&a.getContentElement(this["for"][0],this["for"][1]).getAction()?!0:!1}function u(a,b,d){var c=d.params||{};c.CKEditor=a.name;c.CKEditorFuncNum=a._.filebrowserFn;c.langCode||(c.langCode=a.langCode);b.action=g(d.url,c);b.filebrowser=d}function l(a,b,d,c){if(c&&
c.length)for(var e,g=c.length;g--;)if(e=c[g],"hbox"!=e.type&&"vbox"!=e.type&&"fieldset"!=e.type||l(a,b,d,e.children),e.filebrowser)if("string"==typeof e.filebrowser&&(e.filebrowser={action:"fileButton"==e.type?"QuickUpload":"Browse",target:e.filebrowser}),"Browse"==e.filebrowser.action){var f=e.filebrowser.url;void 0===f&&(f=a.config["filebrowser"+k(b)+"BrowseUrl"],void 0===f&&(f=a.config.filebrowserBrowseUrl));f&&(e.onClick=q,e.filebrowser.url=f,e.hidden=!1)}else if("QuickUpload"==e.filebrowser.action&&
e["for"]&&(f=e.filebrowser.url,void 0===f&&(f=a.config["filebrowser"+k(b)+"UploadUrl"],void 0===f&&(f=a.config.filebrowserUploadUrl)),f)){var h=e.onClick;e.onClick=function(b){var c=b.sender,d=c.getDialog().getContentElement(this["for"][0],this["for"][1]).getInputElement(),e=CKEDITOR.fileTools&&CKEDITOR.fileTools.isFileUploadSupported;if(h&&!1===h.call(c,b))return!1;if(t.call(c,b)){if("form"!==a.config.filebrowserUploadMethod&&e)return b=a.uploadRepository.create(d.$.files[0]),b.on("uploaded",function(a){var b=
a.sender.responseData;m.call(a.sender.editor,b.url,b.message)}),b.on("error",n.bind(this)),b.on("abort",n.bind(this)),b.loadAndUpload(p(f)),"xhr";r(d);return!0}return!1};e.filebrowser.url=f;e.hidden=!1;u(a,d.getContents(e["for"][0]).get(e["for"][1]),e.filebrowser)}}function n(a){var b={};try{b=JSON.parse(a.sender.xhr.response)||{}}catch(d){}this.enable();alert(b.error?b.error.message:a.sender.message)}function h(a,b,d){if(-1!==d.indexOf(";")){d=d.split(";");for(var c=0;c<d.length;c++)if(h(a,b,d[c]))return!0;
return!1}return(a=a.getContents(b).get(d).filebrowser)&&a.url}function m(a,b){var d=this._.filebrowserSe.getDialog(),c=this._.filebrowserSe["for"],e=this._.filebrowserSe.filebrowser.onSelect;c&&d.getContentElement(c[0],c[1]).reset();if("function"!=typeof b||!1!==b.call(this._.filebrowserSe))if(!e||!1!==e.call(this._.filebrowserSe,a,b))if("string"==typeof b&&b&&alert(b),a&&(c=this._.filebrowserSe,d=c.getDialog(),c=c.filebrowser.target||null))if(c=c.split(":"),e=d.getContentElement(c[0],c[1]))e.setValue(a),
d.selectPage(c[0])}CKEDITOR.plugins.add("filebrowser",{requires:"popup,filetools",init:function(a){a._.filebrowserFn=CKEDITOR.tools.addFunction(m,a);a.on("destroy",function(){CKEDITOR.tools.removeFunction(this._.filebrowserFn)})}});CKEDITOR.on("dialogDefinition",function(a){if(a.editor.plugins.filebrowser)for(var b=a.data.definition,d,c=0;c<b.contents.length;++c)if(d=b.contents[c])l(a.editor,a.data.name,b,d.elements),d.hidden&&d.filebrowser&&(d.hidden=!h(b,d.id,d.filebrowser))})})();CKEDITOR.plugins.add("find",{requires:"dialog",init:function(a){var b=a.addCommand("find",new CKEDITOR.dialogCommand("find")),c=a.addCommand("replace",new CKEDITOR.dialogCommand("find",{tabId:"replace"}));b.canUndo=!1;b.readOnly=1;c.canUndo=!1;a.ui.addButton&&(a.ui.addButton("Find",{label:a.lang.find.find,command:"find",toolbar:"find,10"}),a.ui.addButton("Replace",{label:a.lang.find.replace,command:"replace",toolbar:"find,20"}));CKEDITOR.dialog.add("find",this.path+"dialogs/find.js")}});
CKEDITOR.config.find_highlight={element:"span",styles:{"background-color":"#004",color:"#fff"}};(function(){function g(a,b){var c=l.exec(a),d=l.exec(b);if(c){if(!c[2]&&"px"==d[2])return d[1];if("px"==c[2]&&!d[2])return d[1]+"px"}return b}var k=CKEDITOR.htmlParser.cssStyle,h=CKEDITOR.tools.cssLength,l=/^((?:\d*(?:\.\d+))|(?:\d+))(.*)?$/i,m={elements:{$:function(a){var b=a.attributes;if((b=(b=(b=b&&b["data-cke-realelement"])&&new CKEDITOR.htmlParser.fragment.fromHtml(decodeURIComponent(b)))&&b.children[0])&&a.attributes["data-cke-resizable"]){var c=(new k(a)).rules;a=b.attributes;var d=c.width,
c=c.height;d&&(a.width=g(a.width,d));c&&(a.height=g(a.height,c))}return b}}};CKEDITOR.plugins.add("fakeobjects",{init:function(a){a.filter.allow("img[!data-cke-realelement,src,alt,title](*){*}","fakeobjects")},afterInit:function(a){(a=(a=a.dataProcessor)&&a.htmlFilter)&&a.addRules(m,{applyToAll:!0})}});CKEDITOR.editor.prototype.createFakeElement=function(a,b,c,d){var e=this.lang.fakeobjects,e=e[c]||e.unknown;b={"class":b,"data-cke-realelement":encodeURIComponent(a.getOuterHtml()),"data-cke-real-node-type":a.type,
alt:e,title:e,align:a.getAttribute("align")||""};CKEDITOR.env.hc||(b.src=CKEDITOR.tools.transparentImageData);c&&(b["data-cke-real-element-type"]=c);d&&(b["data-cke-resizable"]=d,c=new k,d=a.getAttribute("width"),a=a.getAttribute("height"),d&&(c.rules.width=h(d)),a&&(c.rules.height=h(a)),c.populate(b));return this.document.createElement("img",{attributes:b})};CKEDITOR.editor.prototype.createFakeParserElement=function(a,b,c,d){var e=this.lang.fakeobjects,e=e[c]||e.unknown,f;f=new CKEDITOR.htmlParser.basicWriter;
a.writeHtml(f);f=f.getHtml();b={"class":b,"data-cke-realelement":encodeURIComponent(f),"data-cke-real-node-type":a.type,alt:e,title:e,align:a.attributes.align||""};CKEDITOR.env.hc||(b.src=CKEDITOR.tools.transparentImageData);c&&(b["data-cke-real-element-type"]=c);d&&(b["data-cke-resizable"]=d,d=a.attributes,a=new k,c=d.width,d=d.height,void 0!==c&&(a.rules.width=h(c)),void 0!==d&&(a.rules.height=h(d)),a.populate(b));return new CKEDITOR.htmlParser.element("img",b)};CKEDITOR.editor.prototype.restoreRealElement=
function(a){if(a.data("cke-real-node-type")!=CKEDITOR.NODE_ELEMENT)return null;var b=CKEDITOR.dom.element.createFromHtml(decodeURIComponent(a.data("cke-realelement")),this.document);if(a.data("cke-resizable")){var c=a.getStyle("width");a=a.getStyle("height");c&&b.setAttribute("width",g(b.getAttribute("width"),c));a&&b.setAttribute("height",g(b.getAttribute("height"),a))}return b}})();(function(){function d(a){a=a.attributes;return"application/x-shockwave-flash"==a.type||f.test(a.src||"")}function e(a,b){return a.createFakeParserElement(b,"cke_flash","flash",!0)}var f=/\.swf(?:$|\?)/i;CKEDITOR.plugins.add("flash",{requires:"dialog,fakeobjects",onLoad:function(){CKEDITOR.addCss("img.cke_flash{background-image: url("+CKEDITOR.getUrl(this.path+"images/placeholder.png")+");background-position: center center;background-repeat: no-repeat;border: 1px solid #a9a9a9;width: 80px;height: 80px;}")},
init:function(a){var b="object[classid,codebase,height,hspace,vspace,width];param[name,value];embed[height,hspace,pluginspage,src,type,vspace,width]";CKEDITOR.dialog.isTabEnabled(a,"flash","properties")&&(b+=";object[align]; embed[allowscriptaccess,quality,scale,wmode]");CKEDITOR.dialog.isTabEnabled(a,"flash","advanced")&&(b+=";object[id]{*}; embed[bgcolor]{*}(*)");a.addCommand("flash",new CKEDITOR.dialogCommand("flash",{allowedContent:b,requiredContent:"embed"}));a.ui.addButton&&a.ui.addButton("Flash",
{label:a.lang.common.flash,command:"flash",toolbar:"insert,20"});CKEDITOR.dialog.add("flash",this.path+"dialogs/flash.js");a.addMenuItems&&a.addMenuItems({flash:{label:a.lang.flash.properties,command:"flash",group:"flash"}});a.on("doubleclick",function(a){var b=a.data.element;b.is("img")&&"flash"==b.data("cke-real-element-type")&&(a.data.dialog="flash")});a.contextMenu&&a.contextMenu.addListener(function(a){if(a&&a.is("img")&&!a.isReadOnly()&&"flash"==a.data("cke-real-element-type"))return{flash:CKEDITOR.TRISTATE_OFF}})},
afterInit:function(a){var b=a.dataProcessor;(b=b&&b.dataFilter)&&b.addRules({elements:{"cke:object":function(b){var c=b.attributes;if(!(c.classid&&String(c.classid).toLowerCase()||d(b))){for(c=0;c<b.children.length;c++)if("cke:embed"==b.children[c].name){if(!d(b.children[c]))break;return e(a,b)}return null}return e(a,b)},"cke:embed":function(b){return d(b)?e(a,b):null}}},5)}})})();CKEDITOR.tools.extend(CKEDITOR.config,{flashEmbedTagOnly:!1,flashAddEmbedTag:!0,flashConvertOnEdit:!1});(function(){function k(a){var l=a.config,p=a.fire("uiSpace",{space:"top",html:""}).html,t=function(){function f(a,c,e){b.setStyle(c,w(e));b.setStyle("position",a)}function e(a){var b=k.getDocumentPosition();switch(a){case "top":f("absolute","top",b.y-q-r);break;case "pin":f("fixed","top",x);break;case "bottom":f("absolute","top",b.y+(c.height||c.bottom-c.top)+r)}m=a}var m,k,n,c,h,q,v,p=l.floatSpaceDockedOffsetX||0,r=l.floatSpaceDockedOffsetY||0,u=l.floatSpacePinnedOffsetX||0,x=l.floatSpacePinnedOffsetY||
0;return function(d){if(k=a.editable()){var f=d&&"focus"==d.name;f&&b.show();a.fire("floatingSpaceLayout",{show:f});b.removeStyle("left");b.removeStyle("right");n=b.getClientRect();c=k.getClientRect();h=g.getViewPaneSize();q=n.height;v="pageXOffset"in g.$?g.$.pageXOffset:CKEDITOR.document.$.documentElement.scrollLeft;m?(q+r<=c.top?e("top"):q+r>h.height-c.bottom?e("pin"):e("bottom"),d=h.width/2,d=l.floatSpacePreferRight?"right":0<c.left&&c.right<h.width&&c.width>n.width?"rtl"==l.contentsLangDirection?
"right":"left":d-c.left>c.right-d?"left":"right",n.width>h.width?(d="left",f=0):(f="left"==d?0<c.left?c.left:0:c.right<h.width?h.width-c.right:0,f+n.width>h.width&&(d="left"==d?"right":"left",f=0)),b.setStyle(d,w(("pin"==m?u:p)+f+("pin"==m?0:"left"==d?v:-v)))):(m="pin",e("pin"),t(d))}}}();if(p){var k=new CKEDITOR.template('\x3cdiv id\x3d"cke_{name}" class\x3d"cke {id} cke_reset_all cke_chrome cke_editor_{name} cke_float cke_{langDir} '+CKEDITOR.env.cssClass+'" dir\x3d"{langDir}" title\x3d"'+(CKEDITOR.env.gecko?
" ":"")+'" lang\x3d"{langCode}" role\x3d"application" style\x3d"{style}"'+(a.title?' aria-labelledby\x3d"cke_{name}_arialbl"':" ")+"\x3e"+(a.title?'\x3cspan id\x3d"cke_{name}_arialbl" class\x3d"cke_voice_label"\x3e{voiceLabel}\x3c/span\x3e':" ")+'\x3cdiv class\x3d"cke_inner"\x3e\x3cdiv id\x3d"{topId}" class\x3d"cke_top" role\x3d"presentation"\x3e{content}\x3c/div\x3e\x3c/div\x3e\x3c/div\x3e'),b=CKEDITOR.document.getBody().append(CKEDITOR.dom.element.createFromHtml(k.output({content:p,id:a.id,langDir:a.lang.dir,
langCode:a.langCode,name:a.name,style:"display:none;z-index:"+(l.baseFloatZIndex-1),topId:a.ui.spaceId("top"),voiceLabel:a.title}))),u=CKEDITOR.tools.eventsBuffer(500,t),e=CKEDITOR.tools.eventsBuffer(100,t);b.unselectable();b.on("mousedown",function(a){a=a.data;a.getTarget().hasAscendant("a",1)||a.preventDefault()});a.on("focus",function(b){t(b);a.on("change",u.input);g.on("scroll",e.input);g.on("resize",e.input)});a.on("blur",function(){b.hide();a.removeListener("change",u.input);g.removeListener("scroll",
e.input);g.removeListener("resize",e.input)});a.on("destroy",function(){g.removeListener("scroll",e.input);g.removeListener("resize",e.input);b.clearCustomData();b.remove()});a.focusManager.hasFocus&&b.show();a.focusManager.add(b,1)}}var g=CKEDITOR.document.getWindow(),w=CKEDITOR.tools.cssLength;CKEDITOR.plugins.add("floatingspace",{init:function(a){a.on("loaded",function(){k(this)},null,null,20)}})})();CKEDITOR.plugins.add("listblock",{requires:"panel",onLoad:function(){var f=CKEDITOR.addTemplate("panel-list",'\x3cul role\x3d"presentation" class\x3d"cke_panel_list"\x3e{items}\x3c/ul\x3e'),g=CKEDITOR.addTemplate("panel-list-item",'\x3cli id\x3d"{id}" class\x3d"cke_panel_listItem" role\x3dpresentation\x3e\x3ca id\x3d"{id}_option" _cke_focus\x3d1 hidefocus\x3dtrue title\x3d"{title}" draggable\x3d"false" ondragstart\x3d"return false;" href\x3d"javascript:void(\'{val}\')"  onclick\x3d"{onclick}CKEDITOR.tools.callFunction({clickFn},\'{val}\'); return false;" role\x3d"option"\x3e{text}\x3c/a\x3e\x3c/li\x3e'),
h=CKEDITOR.addTemplate("panel-list-group",'\x3ch1 id\x3d"{id}" draggable\x3d"false" ondragstart\x3d"return false;" class\x3d"cke_panel_grouptitle" role\x3d"presentation" \x3e{label}\x3c/h1\x3e'),k=/\'/g;CKEDITOR.ui.panel.prototype.addListBlock=function(a,b){return this.addBlock(a,new CKEDITOR.ui.listBlock(this.getHolderElement(),b))};CKEDITOR.ui.listBlock=CKEDITOR.tools.createClass({base:CKEDITOR.ui.panel.block,$:function(a,b){b=b||{};var c=b.attributes||(b.attributes={});(this.multiSelect=!!b.multiSelect)&&
(c["aria-multiselectable"]=!0);!c.role&&(c.role="listbox");this.base.apply(this,arguments);this.element.setAttribute("role",c.role);c=this.keys;c[40]="next";c[9]="next";c[38]="prev";c[CKEDITOR.SHIFT+9]="prev";c[32]=CKEDITOR.env.ie?"mouseup":"click";CKEDITOR.env.ie&&(c[13]="mouseup");this._.pendingHtml=[];this._.pendingList=[];this._.items={};this._.groups={}},_:{close:function(){if(this._.started){var a=f.output({items:this._.pendingList.join("")});this._.pendingList=[];this._.pendingHtml.push(a);
delete this._.started}},getClick:function(){this._.click||(this._.click=CKEDITOR.tools.addFunction(function(a){var b=this.toggle(a);if(this.onClick)this.onClick(a,b)},this));return this._.click}},proto:{add:function(a,b,c){var d=CKEDITOR.tools.getNextId();this._.started||(this._.started=1,this._.size=this._.size||0);this._.items[a]=d;var e;e=CKEDITOR.tools.htmlEncodeAttr(a).replace(k,"\\'");a={id:d,val:e,onclick:CKEDITOR.env.ie?'return false;" onmouseup\x3d"CKEDITOR.tools.getMouseButton(event)\x3d\x3d\x3dCKEDITOR.MOUSE_BUTTON_LEFT\x26\x26':
"",clickFn:this._.getClick(),title:CKEDITOR.tools.htmlEncodeAttr(c||a),text:b||a};this._.pendingList.push(g.output(a))},startGroup:function(a){this._.close();var b=CKEDITOR.tools.getNextId();this._.groups[a]=b;this._.pendingHtml.push(h.output({id:b,label:a}))},commit:function(){this._.close();this.element.appendHtml(this._.pendingHtml.join(""));delete this._.size;this._.pendingHtml=[]},toggle:function(a){var b=this.isMarked(a);b?this.unmark(a):this.mark(a);return!b},hideGroup:function(a){var b=(a=
this.element.getDocument().getById(this._.groups[a]))&&a.getNext();a&&(a.setStyle("display","none"),b&&"ul"==b.getName()&&b.setStyle("display","none"))},hideItem:function(a){this.element.getDocument().getById(this._.items[a]).setStyle("display","none")},showAll:function(){var a=this._.items,b=this._.groups,c=this.element.getDocument(),d;for(d in a)c.getById(a[d]).setStyle("display","");for(var e in b)a=c.getById(b[e]),d=a.getNext(),a.setStyle("display",""),d&&"ul"==d.getName()&&d.setStyle("display",
"")},mark:function(a){this.multiSelect||this.unmarkAll();a=this._.items[a];var b=this.element.getDocument().getById(a);b.addClass("cke_selected");this.element.getDocument().getById(a+"_option").setAttribute("aria-selected",!0);this.onMark&&this.onMark(b)},markFirstDisplayed:function(){var a=this;this._.markFirstDisplayed(function(){a.multiSelect||a.unmarkAll()})},unmark:function(a){var b=this.element.getDocument();a=this._.items[a];var c=b.getById(a);c.removeClass("cke_selected");b.getById(a+"_option").removeAttribute("aria-selected");
this.onUnmark&&this.onUnmark(c)},unmarkAll:function(){var a=this._.items,b=this.element.getDocument(),c;for(c in a){var d=a[c];b.getById(d).removeClass("cke_selected");b.getById(d+"_option").removeAttribute("aria-selected")}this.onUnmark&&this.onUnmark()},isMarked:function(a){return this.element.getDocument().getById(this._.items[a]).hasClass("cke_selected")},focus:function(a){this._.focusIndex=-1;var b=this.element.getElementsByTag("a"),c,d=-1;if(a)for(c=this.element.getDocument().getById(this._.items[a]).getFirst();a=
b.getItem(++d);){if(a.equals(c)){this._.focusIndex=d;break}}else this.element.focus();c&&setTimeout(function(){c.focus()},0)}}})}});CKEDITOR.plugins.add("richcombo",{requires:"floatpanel,listblock,button",beforeInit:function(e){e.ui.addHandler(CKEDITOR.UI_RICHCOMBO,CKEDITOR.ui.richCombo.handler)}});
(function(){var e='\x3cspan id\x3d"{id}" class\x3d"cke_combo cke_combo__{name} {cls}" role\x3d"presentation"\x3e\x3cspan id\x3d"{id}_label" class\x3d"cke_combo_label"\x3e{label}\x3c/span\x3e\x3ca class\x3d"cke_combo_button" title\x3d"{title}" tabindex\x3d"-1"'+(CKEDITOR.env.gecko&&!CKEDITOR.env.hc?"":" href\x3d\"javascript:void('{titleJs}')\"")+' hidefocus\x3d"true" role\x3d"button" aria-labelledby\x3d"{id}_label" aria-haspopup\x3d"listbox"',h="";CKEDITOR.env.gecko&&CKEDITOR.env.mac&&(e+=' onkeypress\x3d"return false;"');
CKEDITOR.env.gecko&&(e+=' onblur\x3d"this.style.cssText \x3d this.style.cssText;"');CKEDITOR.env.ie&&(h='return false;" onmouseup\x3d"CKEDITOR.tools.getMouseButton(event)\x3d\x3dCKEDITOR.MOUSE_BUTTON_LEFT\x26\x26');var e=e+(' onkeydown\x3d"return CKEDITOR.tools.callFunction({keydownFn},event,this);" onfocus\x3d"return CKEDITOR.tools.callFunction({focusFn},event);" onclick\x3d"'+h+'CKEDITOR.tools.callFunction({clickFn},this);return false;"\x3e\x3cspan id\x3d"{id}_text" class\x3d"cke_combo_text cke_combo_inlinelabel"\x3e{label}\x3c/span\x3e\x3cspan class\x3d"cke_combo_open"\x3e\x3cspan class\x3d"cke_combo_arrow"\x3e'+
(CKEDITOR.env.hc?"\x26#9660;":CKEDITOR.env.air?"\x26nbsp;":"")+"\x3c/span\x3e\x3c/span\x3e\x3c/a\x3e\x3c/span\x3e"),m=CKEDITOR.addTemplate("combo",e);CKEDITOR.UI_RICHCOMBO="richcombo";CKEDITOR.ui.richCombo=CKEDITOR.tools.createClass({$:function(a){CKEDITOR.tools.extend(this,a,{canGroup:!1,title:a.label,modes:{wysiwyg:1},editorFocus:1});a=this.panel||{};delete this.panel;this.id=CKEDITOR.tools.getNextNumber();this.document=a.parent&&a.parent.getDocument()||CKEDITOR.document;a.className="cke_combopanel";
a.block={multiSelect:a.multiSelect,attributes:a.attributes};a.toolbarRelated=!0;this._={panelDefinition:a,items:{},listeners:[]}},proto:{renderHtml:function(a){var b=[];this.render(a,b);return b.join("")},render:function(a,b){function d(){if(this.getState()!=CKEDITOR.TRISTATE_ON){var b=this.modes[a.mode]?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED;a.readOnly&&!this.readOnly&&(b=CKEDITOR.TRISTATE_DISABLED);this.setState(b);this.setValue("");b!=CKEDITOR.TRISTATE_DISABLED&&this.refresh&&this.refresh()}}
var e=CKEDITOR.env,g,f,c="cke_"+this.id,l=CKEDITOR.tools.addFunction(function(b){f&&(a.unlockSelection(1),f=0);g.execute(b)},this),k=this;g={id:c,combo:this,focus:function(){CKEDITOR.document.getById(c).getChild(1).focus()},execute:function(b){var c=k._;if(c.state!=CKEDITOR.TRISTATE_DISABLED)if(k.createPanel(a),c.on)c.panel.hide();else{k.commit();var d=k.getValue();d?c.list.mark(d):c.list.unmarkAll();c.panel.showBlock(k.id,new CKEDITOR.dom.element(b),4)}},clickFn:l};this._.listeners.push(a.on("activeFilterChange",
d,this));this._.listeners.push(a.on("mode",d,this));this._.listeners.push(a.on("selectionChange",d,this));!this.readOnly&&this._.listeners.push(a.on("readOnly",d,this));var h=CKEDITOR.tools.addFunction(function(a,b){a=new CKEDITOR.dom.event(a);var c=a.getKeystroke();switch(c){case 13:case 32:case 40:CKEDITOR.tools.callFunction(l,b);break;default:g.onkey(g,c)}a.preventDefault()}),n=CKEDITOR.tools.addFunction(function(){g.onfocus&&g.onfocus()});f=0;g.keyDownFn=h;e={id:c,name:this.name||this.command,
label:this.label,title:this.title,cls:this.className||"",titleJs:e.gecko&&!e.hc?"":(this.title||"").replace("'",""),keydownFn:h,focusFn:n,clickFn:l};m.output(e,b);if(this.onRender)this.onRender();return g},createPanel:function(a){if(!this._.panel){var b=this._.panelDefinition,d=this._.panelDefinition.block,e=b.parent||CKEDITOR.document.getBody(),g="cke_combopanel__"+this.name,f=new CKEDITOR.ui.floatPanel(a,e,b),b=f.addListBlock(this.id,d),c=this;f.onShow=function(){this.element.addClass(g);c.setState(CKEDITOR.TRISTATE_ON);
c._.on=1;c.editorFocus&&!a.focusManager.hasFocus&&a.focus();if(c.onOpen)c.onOpen()};f.onHide=function(b){this.element.removeClass(g);c.setState(c.modes&&c.modes[a.mode]?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED);c._.on=0;if(!b&&c.onClose)c.onClose()};f.onEscape=function(){f.hide(1)};b.onClick=function(a,b){c.onClick&&c.onClick.call(c,a,b);f.hide()};this._.panel=f;this._.list=b;f.getBlock(this.id).onHide=function(){c._.on=0;c.setState(CKEDITOR.TRISTATE_OFF)};this.init&&this.init()}},setValue:function(a,
b){this._.value=a;var d=this.document.getById("cke_"+this.id+"_text");d&&(a||b?d.removeClass("cke_combo_inlinelabel"):(b=this.label,d.addClass("cke_combo_inlinelabel")),d.setText("undefined"!=typeof b?b:a))},getValue:function(){return this._.value||""},unmarkAll:function(){this._.list.unmarkAll()},mark:function(a){this._.list.mark(a)},hideItem:function(a){this._.list.hideItem(a)},hideGroup:function(a){this._.list.hideGroup(a)},showAll:function(){this._.list.showAll()},add:function(a,b,d){this._.items[a]=
d||a;this._.list.add(a,b,d)},startGroup:function(a){this._.list.startGroup(a)},commit:function(){this._.committed||(this._.list.commit(),this._.committed=1,CKEDITOR.ui.fire("ready",this));this._.committed=1},setState:function(a){if(this._.state!=a){var b=this.document.getById("cke_"+this.id),d=b.getElementsByTag("a").getItem(0);b.setState(a,"cke_combo");a==CKEDITOR.TRISTATE_DISABLED?b.setAttribute("aria-disabled",!0):b.removeAttribute("aria-disabled");d&&d.setAttribute("aria-expanded",a==CKEDITOR.TRISTATE_ON);
this._.state=a}},getState:function(){return this._.state},enable:function(){this._.state==CKEDITOR.TRISTATE_DISABLED&&this.setState(this._.lastState)},disable:function(){this._.state!=CKEDITOR.TRISTATE_DISABLED&&(this._.lastState=this._.state,this.setState(CKEDITOR.TRISTATE_DISABLED))},destroy:function(){CKEDITOR.tools.array.forEach(this._.listeners,function(a){a.removeListener()});this._.listeners=[]},select:function(a){if(!CKEDITOR.tools.isEmpty(this._.items))for(var b in this._.items)if(a({value:b,
text:this._.items[b]})){this.setValue(b);break}}},statics:{handler:{create:function(a){return new CKEDITOR.ui.richCombo(a)}}}});CKEDITOR.ui.prototype.addRichCombo=function(a,b){this.add(a,CKEDITOR.UI_RICHCOMBO,b)}})();(function(){function k(a,b){var c=a.config,d=b.lang,e=new CKEDITOR.style(b.styleDefinition),f=new l({entries:b.entries,styleVariable:b.styleVariable,styleDefinition:b.styleDefinition}),g;a.addCommand(b.commandName,{exec:function(a,b){var c=b.newStyle,d=b.oldStyle,e=a.getSelection().getRanges()[0],f=void 0===c;if(d||c)if(d&&e.collapsed&&m({editor:a,range:e,style:d}),f)a.removeStyle(d);else{if(e=d)e=d instanceof CKEDITOR.style&&c instanceof CKEDITOR.style?CKEDITOR.style.getStyleText(d.getDefinition())===
CKEDITOR.style.getStyleText(c.getDefinition()):!1,e=!e;e&&a.removeStyle(d);a.applyStyle(c)}},refresh:function(a,b){e.checkApplicable(b,a,a.activeFilter)||this.setState(CKEDITOR.TRISTATE_DISABLED)}});g=a.getCommand(b.commandName);a.ui.addRichCombo(b.comboName,{label:d.label,title:d.panelTitle,command:b.commandName,toolbar:"styles,"+b.order,defaultValue:"cke-default",allowedContent:e,requiredContent:e,contentTransformations:"span"===b.styleDefinition.element?[[{element:"font",check:"span",left:function(a){return!!a.attributes.size||
!!a.attributes.align||!!a.attributes.face},right:function(a){var b=" x-small small medium large x-large xx-large 48px".split(" ");a.name="span";a.attributes.size&&(a.styles["font-size"]=b[a.attributes.size],delete a.attributes.size);a.attributes.align&&(a.styles["text-align"]=a.attributes.align,delete a.attributes.align);a.attributes.face&&(a.styles["font-family"]=a.attributes.face,delete a.attributes.face)}}]]:null,panel:{css:[CKEDITOR.skin.getPath("editor")].concat(c.contentsCss),multiSelect:!1,
attributes:{"aria-label":d.panelTitle}},init:function(){var b="("+a.lang.common.optionDefault+")";this.startGroup(d.panelTitle);this.add(this.defaultValue,b,b);f.addToCombo(this)},onClick:function(c){var d=this.getValue();a.focus();a.fire("saveSnapshot");a.execCommand(b.commandName,{newStyle:f.getStyle(c),oldStyle:f.getStyle(d)});a.fire("saveSnapshot")},onRender:function(){a.on("selectionChange",function(c){var d=this.getValue();(c=f.getMatchingValue(a,c.data.path))?c!=d&&this.setValue(c):this.setValue("",
b.defaultLabel)},this);g.on("state",function(){this.setState(g.state)},this)},refresh:function(){this.setState(g.state)}})}function m(a){var b=a.editor,c=a.range,d=a.style,e,f,g;e=b.elementPath();if(a=e.contains(function(a){return d.checkElementRemovable(a)})){f=c.checkBoundaryOfElement(a,CKEDITOR.START);g=c.checkBoundaryOfElement(a,CKEDITOR.END);if(f&&g){for(f=c.createBookmark();e=a.getFirst();)e.insertBefore(a);a.remove();c.moveToBookmark(f)}else f||g?c.moveToPosition(a,f?CKEDITOR.POSITION_BEFORE_START:
CKEDITOR.POSITION_AFTER_END):(c.splitElement(a),c.moveToPosition(a,CKEDITOR.POSITION_AFTER_END)),h(c,e.elements.slice(),a);b.getSelection().selectRanges([c])}}function h(a,b,c){var d=b.pop();if(d){if(c)return h(a,b,d.equals(c)?null:c);c=d.clone();a.insertNode(c);a.moveToPosition(c,CKEDITOR.POSITION_AFTER_START);h(a,b)}}var l=CKEDITOR.tools.createClass({$:function(a){var b=a.entries.split(";");this._.data={};this._.names=[];for(var c=0;c<b.length;c++){var d=b[c],e,f;d?(d=d.split("/"),e=d[0],d=d[1],
f={},f[a.styleVariable]=d||e,this._.data[e]=new CKEDITOR.style(a.styleDefinition,f),this._.data[e]._.definition.name=e,this._.names.push(e)):(b.splice(c,1),c--)}},proto:{getStyle:function(a){return this._.data[a]},addToCombo:function(a){for(var b=0;b<this._.names.length;b++){var c=this._.names[b];a.add(c,this.getStyle(c).buildPreview(),c)}},getMatchingValue:function(a,b){for(var c=b.elements,d=0,e;d<c.length;d++)if(e=c[d],e=this._.findMatchingStyleName(a,e))return e;return null}},_:{findMatchingStyleName:function(a,
b){return CKEDITOR.tools.array.find(this._.names,function(c){return this.getStyle(c).checkElementMatch(b,!0,a)},this)}}});CKEDITOR.plugins.add("font",{requires:"richcombo",init:function(a){var b=a.config;k(a,{comboName:"Font",commandName:"font",styleVariable:"family",lang:a.lang.font,entries:b.font_names,defaultLabel:b.font_defaultLabel,styleDefinition:b.font_style,order:30});k(a,{comboName:"FontSize",commandName:"fontSize",styleVariable:"size",lang:a.lang.font.fontSize,entries:b.fontSize_sizes,defaultLabel:b.fontSize_defaultLabel,
styleDefinition:b.fontSize_style,order:40})}})})();CKEDITOR.config.font_names="Arial/Arial, Helvetica, sans-serif;Comic Sans MS/Comic Sans MS, cursive;Courier New/Courier New, Courier, monospace;Georgia/Georgia, serif;Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;Tahoma/Tahoma, Geneva, sans-serif;Times New Roman/Times New Roman, Times, serif;Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;Verdana/Verdana, Geneva, sans-serif";CKEDITOR.config.font_defaultLabel="";
CKEDITOR.config.font_style={element:"span",styles:{"font-family":"#(family)"},overrides:[{element:"font",attributes:{face:null}}]};CKEDITOR.config.fontSize_sizes="8/8px;9/9px;10/10px;11/11px;12/12px;14/14px;16/16px;18/18px;20/20px;22/22px;24/24px;26/26px;28/28px;36/36px;48/48px;72/72px";CKEDITOR.config.fontSize_defaultLabel="";CKEDITOR.config.fontSize_style={element:"span",styles:{"font-size":"#(size)"},overrides:[{element:"font",attributes:{size:null}}]};CKEDITOR.plugins.add("forms",{requires:"dialog,fakeobjects",onLoad:function(){CKEDITOR.addCss(".cke_editable form{border: 1px dotted #FF0000;padding: 2px;}\n");CKEDITOR.addCss("img.cke_hidden{background-image: url("+CKEDITOR.getUrl(this.path+"images/hiddenfield.gif")+");background-position: center center;background-repeat: no-repeat;border: 1px solid #a9a9a9;width: 16px !important;height: 16px !important;}");CKEDITOR.style.unstylableElements.push("select","option")},init:function(b){var a=b.lang,
g=0,h={email:1,password:1,search:1,tel:1,text:1,url:1},l={checkbox:"input[type,name,checked,required]",radio:"input[type,name,checked,required]",textfield:"input[type,name,value,size,maxlength,required]",textarea:"textarea[cols,rows,name,required]",select:"select[name,size,multiple,required]; option[value,selected]",button:"input[type,name,value]",form:"form[action,name,id,enctype,target,method]",hiddenfield:"input[type,name,value]",imagebutton:"input[type,alt,src]{width,height,border,border-width,border-style,margin,float}"},
m={checkbox:"input",radio:"input",textfield:"input",textarea:"textarea",select:"select",button:"input",form:"form",hiddenfield:"input",imagebutton:"input"},d=function(f,c,d){var h={allowedContent:l[c],requiredContent:m[c]};"form"==c&&(h.context="form");b.addCommand(c,new CKEDITOR.dialogCommand(c,h));b.ui.addButton&&b.ui.addButton(f,{label:a.common[f.charAt(0).toLowerCase()+f.slice(1)],command:c,toolbar:"forms,"+(g+=10)});CKEDITOR.dialog.add(c,d)},e=this.path+"dialogs/";!b.blockless&&d("Form","form",
e+"form.js");d("Checkbox","checkbox",e+"checkbox.js");d("Radio","radio",e+"radio.js");d("TextField","textfield",e+"textfield.js");d("Textarea","textarea",e+"textarea.js");d("Select","select",e+"select.js");d("Button","button",e+"button.js");var k=b.plugins.image;k&&!b.plugins.image2&&d("ImageButton","imagebutton",CKEDITOR.plugins.getPath("image")+"dialogs/image.js");d("HiddenField","hiddenfield",e+"hiddenfield.js");b.addMenuItems&&(d={checkbox:{label:a.forms.checkboxAndRadio.checkboxTitle,command:"checkbox",
group:"checkbox"},radio:{label:a.forms.checkboxAndRadio.radioTitle,command:"radio",group:"radio"},textfield:{label:a.forms.textfield.title,command:"textfield",group:"textfield"},hiddenfield:{label:a.forms.hidden.title,command:"hiddenfield",group:"hiddenfield"},button:{label:a.forms.button.title,command:"button",group:"button"},select:{label:a.forms.select.title,command:"select",group:"select"},textarea:{label:a.forms.textarea.title,command:"textarea",group:"textarea"}},k&&(d.imagebutton={label:a.image.titleButton,
command:"imagebutton",group:"imagebutton"}),!b.blockless&&(d.form={label:a.forms.form.menu,command:"form",group:"form"}),b.addMenuItems(d));b.contextMenu&&(!b.blockless&&b.contextMenu.addListener(function(f,c,b){if((f=b.contains("form",1))&&!f.isReadOnly())return{form:CKEDITOR.TRISTATE_OFF}}),b.contextMenu.addListener(function(b){if(b&&!b.isReadOnly()){var c=b.getName();if("select"==c)return{select:CKEDITOR.TRISTATE_OFF};if("textarea"==c)return{textarea:CKEDITOR.TRISTATE_OFF};if("input"==c){var a=
b.getAttribute("type")||"text";switch(a){case "button":case "submit":case "reset":return{button:CKEDITOR.TRISTATE_OFF};case "checkbox":return{checkbox:CKEDITOR.TRISTATE_OFF};case "radio":return{radio:CKEDITOR.TRISTATE_OFF};case "image":return k?{imagebutton:CKEDITOR.TRISTATE_OFF}:null}if(h[a])return{textfield:CKEDITOR.TRISTATE_OFF}}if("img"==c&&"hiddenfield"==b.data("cke-real-element-type"))return{hiddenfield:CKEDITOR.TRISTATE_OFF}}}));b.on("doubleclick",function(a){var c=a.data.element;if(!b.blockless&&
c.is("form"))a.data.dialog="form";else if(c.is("select"))a.data.dialog="select";else if(c.is("textarea"))a.data.dialog="textarea";else if(c.is("img")&&"hiddenfield"==c.data("cke-real-element-type"))a.data.dialog="hiddenfield";else if(c.is("input")){c=c.getAttribute("type")||"text";switch(c){case "button":case "submit":case "reset":a.data.dialog="button";break;case "checkbox":a.data.dialog="checkbox";break;case "radio":a.data.dialog="radio";break;case "image":a.data.dialog="imagebutton"}h[c]&&(a.data.dialog=
"textfield")}})},afterInit:function(b){var a=b.dataProcessor,g=a&&a.htmlFilter,a=a&&a.dataFilter;CKEDITOR.env.ie&&g&&g.addRules({elements:{input:function(a){a=a.attributes;var b=a.type;b||(a.type="text");"checkbox"!=b&&"radio"!=b||"on"!=a.value||delete a.value}}},{applyToAll:!0});a&&a.addRules({elements:{input:function(a){if("hidden"==a.attributes.type)return b.createFakeParserElement(a,"cke_hidden","hiddenfield")}}},{applyToAll:!0})}});CKEDITOR.plugins.forms={_setupRequiredAttribute:function(b){this.setValue(b.hasAttribute("required"))}};CKEDITOR.plugins.add("format",{requires:"richcombo",init:function(a){if(!a.blockless){for(var f=a.config,c=a.lang.format,l=f.format_tags.split(";"),d={},m=0,n=[],g=0;g<l.length;g++){var h=l[g],k=new CKEDITOR.style(f["format_"+h]);if(!a.filter.customConfig||a.filter.check(k))m++,d[h]=k,d[h]._.enterMode=a.config.enterMode,n.push(k)}0!==m&&a.ui.addRichCombo("Format",{label:c.label,title:c.panelTitle,toolbar:"styles,20",allowedContent:n,panel:{css:[CKEDITOR.skin.getPath("editor")].concat(f.contentsCss),
multiSelect:!1,attributes:{"aria-label":c.panelTitle}},init:function(){this.startGroup(c.panelTitle);for(var a in d){var e=c["tag_"+a];this.add(a,d[a].buildPreview(e),e)}},onClick:function(b){a.focus();a.fire("saveSnapshot");b=d[b];var e=a.elementPath();a.fire("stylesRemove",{type:CKEDITOR.STYLE_BLOCK});b.checkActive(e,a)||a.applyStyle(b);setTimeout(function(){a.fire("saveSnapshot")},0)},onRender:function(){a.on("selectionChange",function(b){var e=this.getValue();b=b.data.path;this.refresh();for(var c in d)if(d[c].checkActive(b,
a)){c!=e&&this.setValue(c,a.lang.format["tag_"+c]);return}this.setValue("")},this)},onOpen:function(){this.showAll();for(var b in d)a.activeFilter.check(d[b])||this.hideItem(b)},refresh:function(){var b=a.elementPath();if(b){if(b.isContextFor("p"))for(var c in d)if(a.activeFilter.check(d[c]))return;this.setState(CKEDITOR.TRISTATE_DISABLED)}}})}}});CKEDITOR.config.format_tags="p;h1;h2;h3;h4;h5;h6;pre;address;div";CKEDITOR.config.format_p={element:"p"};CKEDITOR.config.format_div={element:"div"};
CKEDITOR.config.format_pre={element:"pre"};CKEDITOR.config.format_address={element:"address"};CKEDITOR.config.format_h1={element:"h1"};CKEDITOR.config.format_h2={element:"h2"};CKEDITOR.config.format_h3={element:"h3"};CKEDITOR.config.format_h4={element:"h4"};CKEDITOR.config.format_h5={element:"h5"};CKEDITOR.config.format_h6={element:"h6"};(function(){var b={canUndo:!1,exec:function(a){var b=a.document.createElement("hr");a.insertElement(b)},allowedContent:"hr",requiredContent:"hr"};CKEDITOR.plugins.add("horizontalrule",{init:function(a){a.blockless||(a.addCommand("horizontalrule",b),a.ui.addButton&&a.ui.addButton("HorizontalRule",{label:a.lang.horizontalrule.toolbar,command:"horizontalrule",toolbar:"insert,40"}))}})})();CKEDITOR.plugins.add("htmlwriter",{init:function(b){var a=new CKEDITOR.htmlWriter;a.forceSimpleAmpersand=b.config.forceSimpleAmpersand;a.indentationChars="string"===typeof b.config.dataIndentationChars?b.config.dataIndentationChars:"\t";b.dataProcessor.writer=a}});
CKEDITOR.htmlWriter=CKEDITOR.tools.createClass({base:CKEDITOR.htmlParser.basicWriter,$:function(){this.base();this.indentationChars="\t";this.selfClosingEnd=" /\x3e";this.lineBreakChars="\n";this.sortAttributes=1;this._.indent=0;this._.indentation="";this._.inPre=0;this._.rules={};var b=CKEDITOR.dtd,a;for(a in CKEDITOR.tools.extend({},b.$nonBodyContent,b.$block,b.$listItem,b.$tableContent))this.setRules(a,{indent:!b[a]["#"],breakBeforeOpen:1,breakBeforeClose:!b[a]["#"],breakAfterClose:1,needsSpace:a in
b.$block&&!(a in{li:1,dt:1,dd:1})});this.setRules("br",{breakAfterOpen:1});this.setRules("title",{indent:0,breakAfterOpen:0});this.setRules("style",{indent:0,breakBeforeClose:1});this.setRules("pre",{breakAfterOpen:1,indent:0})},proto:{openTag:function(b){var a=this._.rules[b];this._.afterCloser&&a&&a.needsSpace&&this._.needsSpace&&this._.output.push("\n");this._.indent?this.indentation():a&&a.breakBeforeOpen&&(this.lineBreak(),this.indentation());this._.output.push("\x3c",b);this._.afterCloser=0},
openTagClose:function(b,a){var c=this._.rules[b];a?(this._.output.push(this.selfClosingEnd),c&&c.breakAfterClose&&(this._.needsSpace=c.needsSpace)):(this._.output.push("\x3e"),c&&c.indent&&(this._.indentation+=this.indentationChars));c&&c.breakAfterOpen&&this.lineBreak();"pre"==b&&(this._.inPre=1)},attribute:function(b,a){"string"==typeof a&&(a=CKEDITOR.tools.htmlEncodeAttr(a),this.forceSimpleAmpersand&&(a=a.replace(/&amp;/g,"\x26")));this._.output.push(" ",b,'\x3d"',a,'"')},closeTag:function(b){var a=
this._.rules[b];a&&a.indent&&(this._.indentation=this._.indentation.substr(this.indentationChars.length));this._.indent?this.indentation():a&&a.breakBeforeClose&&(this.lineBreak(),this.indentation());this._.output.push("\x3c/",b,"\x3e");"pre"==b&&(this._.inPre=0);a&&a.breakAfterClose&&(this.lineBreak(),this._.needsSpace=a.needsSpace);this._.afterCloser=1},text:function(b){this._.indent&&(this.indentation(),!this._.inPre&&(b=CKEDITOR.tools.ltrim(b)));this._.output.push(b)},comment:function(b){this._.indent&&
this.indentation();this._.output.push("\x3c!--",b,"--\x3e")},lineBreak:function(){!this._.inPre&&0<this._.output.length&&this._.output.push(this.lineBreakChars);this._.indent=1},indentation:function(){!this._.inPre&&this._.indentation&&this._.output.push(this._.indentation);this._.indent=0},reset:function(){this._.output=[];this._.indent=0;this._.indentation="";this._.afterCloser=0;this._.inPre=0;this._.needsSpace=0},setRules:function(b,a){var c=this._.rules[b];c?CKEDITOR.tools.extend(c,a,!0):this._.rules[b]=
a}}});(function(){CKEDITOR.plugins.add("iframe",{requires:"dialog,fakeobjects",onLoad:function(){CKEDITOR.addCss("img.cke_iframe{background-image: url("+CKEDITOR.getUrl(this.path+"images/placeholder.png")+");background-position: center center;background-repeat: no-repeat;border: 1px solid #a9a9a9;width: 80px;height: 80px;}")},init:function(a){var b=a.lang.iframe,c="iframe[align,longdesc,tabindex,frameborder,height,name,scrolling,src,title,width]";a.plugins.dialogadvtab&&(c+=";iframe"+a.plugins.dialogadvtab.allowedContent({id:1,
classes:1,styles:1}));CKEDITOR.dialog.add("iframe",this.path+"dialogs/iframe.js");a.addCommand("iframe",new CKEDITOR.dialogCommand("iframe",{allowedContent:c,requiredContent:"iframe"}));a.ui.addButton&&a.ui.addButton("Iframe",{label:b.toolbar,command:"iframe",toolbar:"insert,80"});a.on("doubleclick",function(a){var b=a.data.element;b.is("img")&&"iframe"==b.data("cke-real-element-type")&&(a.data.dialog="iframe")});a.addMenuItems&&a.addMenuItems({iframe:{label:b.title,command:"iframe",group:"image"}});
a.contextMenu&&a.contextMenu.addListener(function(a){if(a&&a.is("img")&&"iframe"==a.data("cke-real-element-type"))return{iframe:CKEDITOR.TRISTATE_OFF}})},afterInit:function(a){var b=a.dataProcessor;(b=b&&b.dataFilter)&&b.addRules({elements:{iframe:function(b){return a.createFakeParserElement(b,"cke_iframe","iframe",!0)}}})}})})();(function(){function m(a){function e(a){var b=!1;g.attachListener(g,"keydown",function(){var d=c.getBody().getElementsByTag(a);if(!b){for(var f=0;f<d.count();f++)d.getItem(f).setCustomData("retain",!0);b=!0}},null,null,1);g.attachListener(g,"keyup",function(){var d=c.getElementsByTag(a);b&&(1==d.count()&&!d.getItem(0).getCustomData("retain")&&CKEDITOR.tools.isEmpty(d.getItem(0).getAttributes())&&d.getItem(0).remove(1),b=!1)})}var b=this.editor;if(b&&!b.isDetached()){var c=a.document,d=c.body,f=c.getElementById("cke_actscrpt");
f&&f.parentNode.removeChild(f);(f=c.getElementById("cke_shimscrpt"))&&f.parentNode.removeChild(f);(f=c.getElementById("cke_basetagscrpt"))&&f.parentNode.removeChild(f);d.contentEditable=!0;CKEDITOR.env.ie&&(d.hideFocus=!0,d.disabled=!0,d.removeAttribute("disabled"));delete this._.isLoadingData;this.$=d;c=new CKEDITOR.dom.document(c);this.setup();this.fixInitialSelection();var g=this;CKEDITOR.env.ie&&!CKEDITOR.env.edge&&c.getDocumentElement().addClass(c.$.compatMode);CKEDITOR.env.ie&&!CKEDITOR.env.edge&&
b.enterMode!=CKEDITOR.ENTER_P?e("p"):CKEDITOR.env.edge&&15>CKEDITOR.env.version&&b.enterMode!=CKEDITOR.ENTER_DIV&&e("div");if(CKEDITOR.env.webkit||CKEDITOR.env.ie&&10<CKEDITOR.env.version)c.getDocumentElement().on("mousedown",function(a){a.data.getTarget().is("html")&&setTimeout(function(){b.editable().focus()})});n(b);try{b.document.$.execCommand("2D-position",!1,!0)}catch(h){}(CKEDITOR.env.gecko||CKEDITOR.env.ie&&"CSS1Compat"==b.document.$.compatMode)&&this.attachListener(this,"keydown",function(a){var c=
a.data.getKeystroke();if(33==c||34==c)if(CKEDITOR.env.ie)setTimeout(function(){b.getSelection().scrollIntoView()},0);else if(b.window.$.innerHeight>this.$.offsetHeight){var d=b.createRange();d[33==c?"moveToElementEditStart":"moveToElementEditEnd"](this);d.select();a.data.preventDefault()}});CKEDITOR.env.ie&&this.attachListener(c,"blur",function(){try{c.$.selection.empty()}catch(a){}});CKEDITOR.env.iOS&&this.attachListener(c,"touchend",function(){a.focus()});d=b.document.getElementsByTag("title").getItem(0);
d.data("cke-title",d.getText());CKEDITOR.env.ie&&(b.document.$.title=this._.docTitle);CKEDITOR.tools.setTimeout(function(){"unloaded"==this.status&&(this.status="ready");b.fire("contentDom");this._.isPendingFocus&&(b.focus(),this._.isPendingFocus=!1);setTimeout(function(){b.fire("dataReady")},0)},0,this)}}function n(a){function e(){var c;a.editable().attachListener(a,"selectionChange",function(){var d=a.getSelection().getSelectedElement();d&&(c&&(c.detachEvent("onresizestart",b),c=null),d.$.attachEvent("onresizestart",
b),c=d.$)})}function b(a){a.returnValue=!1}if(CKEDITOR.env.gecko)try{var c=a.document.$;c.execCommand("enableObjectResizing",!1,!a.config.disableObjectResizing);c.execCommand("enableInlineTableEditing",!1,!a.config.disableNativeTableHandles)}catch(d){}else CKEDITOR.env.ie&&11>CKEDITOR.env.version&&a.config.disableObjectResizing&&e(a)}function p(){var a=[];if(8<=CKEDITOR.document.$.documentMode){a.push("html.CSS1Compat [contenteditable\x3dfalse]{min-height:0 !important}");var e=[],b;for(b in CKEDITOR.dtd.$removeEmpty)e.push("html.CSS1Compat "+
b+"[contenteditable\x3dfalse]");a.push(e.join(",")+"{display:inline-block}")}else CKEDITOR.env.gecko&&(a.push("html{height:100% !important}"),a.push("img:-moz-broken{-moz-force-broken-image-icon:1;min-width:24px;min-height:24px}"));a.push("html{cursor:text;*cursor:auto}");a.push("img,input,textarea{cursor:default}");return a.join("\n")}var l;CKEDITOR.plugins.add("wysiwygarea",{init:function(a){a.config.fullPage&&a.addFeature({allowedContent:"html head title; style [media,type]; body (*)[id]; meta link [*]",
requiredContent:"body"});a.addMode("wysiwyg",function(e){function b(b){b&&b.removeListener();a.isDestroyed()||a.isDetached()||(a.editable(new l(a,d.$.contentWindow.document.body)),a.setData(a.getData(1),e))}var c="document.open();"+(CKEDITOR.env.ie?"("+CKEDITOR.tools.fixDomain+")();":"")+"document.close();",c=CKEDITOR.env.air?"javascript:void(0)":CKEDITOR.env.ie&&!CKEDITOR.env.edge?"javascript:void(function(){"+encodeURIComponent(c)+"}())":"",d=CKEDITOR.dom.element.createFromHtml('\x3ciframe src\x3d"'+
c+'" frameBorder\x3d"0"\x3e\x3c/iframe\x3e');d.setStyles({width:"100%",height:"100%"});d.addClass("cke_wysiwyg_frame").addClass("cke_reset");c=a.ui.space("contents");c.append(d);var f=CKEDITOR.env.ie&&!CKEDITOR.env.edge||CKEDITOR.env.gecko;if(f)d.on("load",b);var g=a.title,h=a.fire("ariaEditorHelpLabel",{}).label;g&&(CKEDITOR.env.ie&&h&&(g+=", "+h),d.setAttribute("title",g));if(h){var g=CKEDITOR.tools.getNextId(),k=CKEDITOR.dom.element.createFromHtml('\x3cspan id\x3d"'+g+'" class\x3d"cke_voice_label"\x3e'+
h+"\x3c/span\x3e");c.append(k,1);d.setAttribute("aria-describedby",g)}a.on("beforeModeUnload",function(a){a.removeListener();k&&k.remove()});d.setAttributes({tabIndex:a.tabIndex,allowTransparency:"true"});!f&&b();a.fire("ariaWidget",d)})}});CKEDITOR.editor.prototype.addContentsCss=function(a){var e=this.config,b=e.contentsCss;CKEDITOR.tools.isArray(b)||(e.contentsCss=b?[b]:[]);e.contentsCss.push(a)};l=CKEDITOR.tools.createClass({$:function(){this.base.apply(this,arguments);this._.frameLoadedHandler=
CKEDITOR.tools.addFunction(function(a){CKEDITOR.tools.setTimeout(m,0,this,a)},this);this._.docTitle=this.getWindow().getFrame().getAttribute("title")},base:CKEDITOR.editable,proto:{setData:function(a,e){var b=this.editor;if(e)this.setHtml(a),this.fixInitialSelection(),b.fire("dataReady");else{this._.isLoadingData=!0;b._.dataStore={id:1};var c=b.config,d=c.fullPage,f=c.docType,g=CKEDITOR.tools.buildStyleHtml(p()).replace(/<style>/,'\x3cstyle data-cke-temp\x3d"1"\x3e');d||(g+=CKEDITOR.tools.buildStyleHtml(b.config.contentsCss));
var h=c.baseHref?'\x3cbase href\x3d"'+c.baseHref+'" data-cke-temp\x3d"1" /\x3e':"";d&&(a=a.replace(/<!DOCTYPE[^>]*>/i,function(a){b.docType=f=a;return""}).replace(/<\?xml\s[^\?]*\?>/i,function(a){b.xmlDeclaration=a;return""}));a=b.dataProcessor.toHtml(a);d?(/<body[\s|>]/.test(a)||(a="\x3cbody\x3e"+a),/<html[\s|>]/.test(a)||(a="\x3chtml\x3e"+a+"\x3c/html\x3e"),/<head[\s|>]/.test(a)?/<title[\s|>]/.test(a)||(a=a.replace(/<head[^>]*>/,"$\x26\x3ctitle\x3e\x3c/title\x3e")):a=a.replace(/<html[^>]*>/,"$\x26\x3chead\x3e\x3ctitle\x3e\x3c/title\x3e\x3c/head\x3e"),
h&&(a=a.replace(/<head[^>]*?>/,"$\x26"+h)),a=a.replace(/<\/head\s*>/,g+"$\x26"),a=f+a):a=c.docType+'\x3chtml dir\x3d"'+c.contentsLangDirection+'" lang\x3d"'+(c.contentsLanguage||b.langCode)+'"\x3e\x3chead\x3e\x3ctitle\x3e'+this._.docTitle+"\x3c/title\x3e"+h+g+"\x3c/head\x3e\x3cbody"+(c.bodyId?' id\x3d"'+c.bodyId+'"':"")+(c.bodyClass?' class\x3d"'+c.bodyClass+'"':"")+"\x3e"+a+"\x3c/body\x3e\x3c/html\x3e";CKEDITOR.env.gecko&&(a=a.replace(/<body/,'\x3cbody contenteditable\x3d"true" '),2E4>CKEDITOR.env.version&&
(a=a.replace(/<body[^>]*>/,"$\x26\x3c!-- cke-content-start --\x3e")));c='\x3cscript id\x3d"cke_actscrpt" type\x3d"text/javascript"'+(CKEDITOR.env.ie?' defer\x3d"defer" ':"")+"\x3evar wasLoaded\x3d0;function onload(){if(!wasLoaded)window.parent.CKEDITOR.tools.callFunction("+this._.frameLoadedHandler+",window);wasLoaded\x3d1;}"+(CKEDITOR.env.ie?"onload();":'document.addEventListener("DOMContentLoaded", onload, false );')+"\x3c/script\x3e";CKEDITOR.env.ie&&9>CKEDITOR.env.version&&(c+='\x3cscript id\x3d"cke_shimscrpt"\x3ewindow.parent.CKEDITOR.tools.enableHtml5Elements(document)\x3c/script\x3e');
h&&CKEDITOR.env.ie&&10>CKEDITOR.env.version&&(c+='\x3cscript id\x3d"cke_basetagscrpt"\x3evar baseTag \x3d document.querySelector( "base" );baseTag.href \x3d baseTag.href;\x3c/script\x3e');a=a.replace(/(?=\s*<\/(:?head)>)/,c);this.clearCustomData();this.clearListeners();b.fire("contentDomUnload");var k=this.getDocument();try{k.write(a)}catch(l){setTimeout(function(){k.write(a)},0)}}},getData:function(a){if(a)return this.getHtml();a=this.editor;var e=a.config,b=e.fullPage,c=b&&a.docType,d=b&&a.xmlDeclaration,
f=this.getDocument(),b=b?f.getDocumentElement().getOuterHtml():f.getBody().getHtml();CKEDITOR.env.gecko&&e.enterMode!=CKEDITOR.ENTER_BR&&(b=b.replace(/<br>(?=\s*(:?$|<\/body>))/,""));b=a.dataProcessor.toDataFormat(b);d&&(b=d+"\n"+b);c&&(b=c+"\n"+b);return b},focus:function(){this._.isLoadingData?this._.isPendingFocus=!0:l.baseProto.focus.call(this)},detach:function(){var a=this.editor,e=a.document,a=a.container.findOne("iframe.cke_wysiwyg_frame");l.baseProto.detach.call(this);this.clearCustomData(this._.expandoNumber);
e.getDocumentElement().clearCustomData();CKEDITOR.tools.removeFunction(this._.frameLoadedHandler);a&&(a.clearCustomData(),(e=a.removeCustomData("onResize"))&&e.removeListener(),a.isDetached()||a.remove())}}})})();CKEDITOR.config.disableObjectResizing=!1;CKEDITOR.config.disableNativeTableHandles=!0;CKEDITOR.config.disableNativeSpellChecker=!0;(function(){function e(b,a){a||(a=b.getSelection().getSelectedElement());if(a&&a.is("img")&&!a.data("cke-realelement")&&!a.isReadOnly())return a}function f(b){var a=b.getStyle("float");if("inherit"==a||"none"==a)a=0;a||(a=b.getAttribute("align"));return a}CKEDITOR.plugins.add("image",{requires:"dialog",init:function(b){if(!b.plugins.detectConflict("image",["easyimage","image2"])){CKEDITOR.dialog.add("image",this.path+"dialogs/image.js");var a="img[alt,!src]{border-style,border-width,float,height,margin,margin-bottom,margin-left,margin-right,margin-top,width}";
CKEDITOR.dialog.isTabEnabled(b,"image","advanced")&&(a="img[alt,dir,id,lang,longdesc,!src,title]{*}(*)");b.addCommand("image",new CKEDITOR.dialogCommand("image",{allowedContent:a,requiredContent:"img[alt,src]",contentTransformations:[["img{width}: sizeToStyle","img[width]: sizeToAttribute"],["img{float}: alignmentToStyle","img[align]: alignmentToAttribute"]]}));b.ui.addButton&&b.ui.addButton("Image",{label:b.lang.common.image,command:"image",toolbar:"insert,10"});b.on("doubleclick",function(b){var a=
b.data.element;!a.is("img")||a.data("cke-realelement")||a.isReadOnly()||(b.data.dialog="image")});b.addMenuItems&&b.addMenuItems({image:{label:b.lang.image.menu,command:"image",group:"image"}});b.contextMenu&&b.contextMenu.addListener(function(a){if(e(b,a))return{image:CKEDITOR.TRISTATE_OFF}})}},afterInit:function(b){function a(a){var d=b.getCommand("justify"+a);if(d){if("left"==a||"right"==a)d.on("exec",function(d){var c=e(b),g;c&&(g=f(c),g==a?(c.removeStyle("float"),a==f(c)&&c.removeAttribute("align")):
c.setStyle("float",a),d.cancel())});d.on("refresh",function(d){var c=e(b);c&&(c=f(c),this.setState(c==a?CKEDITOR.TRISTATE_ON:"right"==a||"left"==a?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED),d.cancel())})}}b.plugins.image2||(a("left"),a("right"),a("center"),a("block"))}})})();CKEDITOR.config.image_removeLinkByEmptyURL=!0;(function(){function m(a,b){var e,f;b.on("refresh",function(a){var b=[k],c;for(c in a.data.states)b.push(a.data.states[c]);this.setState(CKEDITOR.tools.search(b,p)?p:k)},b,null,100);b.on("exec",function(b){e=a.getSelection();f=e.createBookmarks(1);b.data||(b.data={});b.data.done=!1},b,null,0);b.on("exec",function(){a.forceNextSelectionCheck();e.selectBookmarks(f)},b,null,100)}var k=CKEDITOR.TRISTATE_DISABLED,p=CKEDITOR.TRISTATE_OFF;CKEDITOR.plugins.add("indent",{init:function(a){var b=CKEDITOR.plugins.indent.genericDefinition;
m(a,a.addCommand("indent",new b(!0)));m(a,a.addCommand("outdent",new b));a.ui.addButton&&(a.ui.addButton("Indent",{label:a.lang.indent.indent,command:"indent",directional:!0,toolbar:"indent,20"}),a.ui.addButton("Outdent",{label:a.lang.indent.outdent,command:"outdent",directional:!0,toolbar:"indent,10"}));a.on("dirChanged",function(b){var f=a.createRange(),l=b.data.node;f.setStartBefore(l);f.setEndAfter(l);for(var n=new CKEDITOR.dom.walker(f),c;c=n.next();)if(c.type==CKEDITOR.NODE_ELEMENT)if(!c.equals(l)&&
c.getDirection())f.setStartAfter(c),n=new CKEDITOR.dom.walker(f);else{var d=a.config.indentClasses;if(d)for(var g="ltr"==b.data.dir?["_rtl",""]:["","_rtl"],h=0;h<d.length;h++)c.hasClass(d[h]+g[0])&&(c.removeClass(d[h]+g[0]),c.addClass(d[h]+g[1]));d=c.getStyle("margin-right");g=c.getStyle("margin-left");d?c.setStyle("margin-left",d):c.removeStyle("margin-left");g?c.setStyle("margin-right",g):c.removeStyle("margin-right")}})}});CKEDITOR.plugins.indent={genericDefinition:function(a){this.isIndent=!!a;
this.startDisabled=!this.isIndent},specificDefinition:function(a,b,e){this.name=b;this.editor=a;this.jobs={};this.enterBr=a.config.enterMode==CKEDITOR.ENTER_BR;this.isIndent=!!e;this.relatedGlobal=e?"indent":"outdent";this.indentKey=e?9:CKEDITOR.SHIFT+9;this.database={}},registerCommands:function(a,b){a.on("pluginsLoaded",function(){for(var a in b)(function(a,b){var e=a.getCommand(b.relatedGlobal),c;for(c in b.jobs)e.on("exec",function(d){d.data.done||(a.fire("lockSnapshot"),b.execJob(a,c)&&(d.data.done=
!0),a.fire("unlockSnapshot"),CKEDITOR.dom.element.clearAllMarkers(b.database))},this,null,c),e.on("refresh",function(d){d.data.states||(d.data.states={});d.data.states[b.name+"@"+c]=b.refreshJob(a,c,d.data.path)},this,null,c);a.addFeature(b)})(this,b[a])})}};CKEDITOR.plugins.indent.genericDefinition.prototype={context:"p",exec:function(){}};CKEDITOR.plugins.indent.specificDefinition.prototype={execJob:function(a,b){var e=this.jobs[b];if(e.state!=k)return e.exec.call(this,a)},refreshJob:function(a,
b,e){b=this.jobs[b];a.activeFilter.checkFeature(this)?b.state=b.refresh.call(this,a,e):b.state=k;return b.state},getContext:function(a){return a.contains(this.context)}}})();(function(){function f(b,c,a){if(!b.getCustomData("indent_processed")){var d=this.editor,l=this.isIndent;if(c){d=b.$.className.match(this.classNameRegex);a=0;d&&(d=d[1],a=CKEDITOR.tools.indexOf(c,d)+1);if(0>(a+=l?1:-1))return;a=Math.min(a,c.length);a=Math.max(a,0);b.$.className=CKEDITOR.tools.ltrim(b.$.className.replace(this.classNameRegex,""));0<a&&b.addClass(c[a-1])}else{c=m(b,a);a=parseInt(b.getStyle(c),10);var g=d.config.indentOffset||40;isNaN(a)&&(a=0);a+=(l?1:-1)*g;if(0>a)return;a=Math.max(a,
0);a=Math.ceil(a/g)*g;b.setStyle(c,a?a+(d.config.indentUnit||"px"):"");""===b.getAttribute("style")&&b.removeAttribute("style")}CKEDITOR.dom.element.setMarker(this.database,b,"indent_processed",1)}}function m(b,c){return"ltr"==(c||b.getComputedStyle("direction"))?"margin-left":"margin-right"}var h=CKEDITOR.dtd.$listItem,p=CKEDITOR.dtd.$list,k=CKEDITOR.TRISTATE_DISABLED,n=CKEDITOR.TRISTATE_OFF;CKEDITOR.plugins.add("indentblock",{requires:"indent",init:function(b){function c(){a.specificDefinition.apply(this,
arguments);this.allowedContent={"div h1 h2 h3 h4 h5 h6 ol p pre ul":{propertiesOnly:!0,styles:d?null:"margin-left,margin-right",classes:d||null}};this.contentTransformations=[["div: splitMarginShorthand"],["h1: splitMarginShorthand"],["h2: splitMarginShorthand"],["h3: splitMarginShorthand"],["h4: splitMarginShorthand"],["h5: splitMarginShorthand"],["h6: splitMarginShorthand"],["ol: splitMarginShorthand"],["p: splitMarginShorthand"],["pre: splitMarginShorthand"],["ul: splitMarginShorthand"]];this.enterBr&&
(this.allowedContent.div=!0);this.requiredContent=(this.enterBr?"div":"p")+(d?"("+d.join(",")+")":"{margin-left}");this.jobs={20:{refresh:function(a,b){var e=b.block||b.blockLimit;if(!e.is(h))var c=e.getAscendant(h),e=c&&b.contains(c)||e;e.is(h)&&(e=e.getParent());if(this.enterBr||this.getContext(b)){if(d){var c=d,e=e.$.className.match(this.classNameRegex),f=this.isIndent,c=e?f?e[1]!=c.slice(-1):!0:f;return c?n:k}return this.isIndent?n:e?CKEDITOR[0>=(parseInt(e.getStyle(m(e)),10)||0)?"TRISTATE_DISABLED":
"TRISTATE_OFF"]:k}return k},exec:function(a){var b=a.getSelection(),b=b&&b.getRanges()[0],c;if(c=a.elementPath().contains(p))f.call(this,c,d);else for(b=b.createIterator(),a=a.config.enterMode,b.enforceRealBlocks=!0,b.enlargeBr=a!=CKEDITOR.ENTER_BR;c=b.getNextParagraph(a==CKEDITOR.ENTER_P?"p":"div");)c.isReadOnly()||f.call(this,c,d);return!0}}}}var a=CKEDITOR.plugins.indent,d=b.config.indentClasses;a.registerCommands(b,{indentblock:new c(b,"indentblock",!0),outdentblock:new c(b,"outdentblock")});
CKEDITOR.tools.extend(c.prototype,a.specificDefinition.prototype,{context:{div:1,dl:1,h1:1,h2:1,h3:1,h4:1,h5:1,h6:1,ul:1,ol:1,p:1,pre:1,table:1},classNameRegex:d?new RegExp("(?:^|\\s+)("+d.join("|")+")(?\x3d$|\\s)"):null})}})})();(function(){function w(f){function g(b){for(var e=c.startContainer,a=c.endContainer;e&&!e.getParent().equals(b);)e=e.getParent();for(;a&&!a.getParent().equals(b);)a=a.getParent();if(!e||!a)return!1;for(var d=[],h=!1;!h;)e.equals(a)&&(h=!0),d.push(e),e=e.getNext();if(1>d.length)return!1;e=b.getParents(!0);for(a=0;a<e.length;a++)if(e[a].getName&&p[e[a].getName()]){b=e[a];break}for(var e=k.isIndent?1:-1,a=d[0],d=d[d.length-1],h=CKEDITOR.plugins.list.listToArray(b,q),m=h[d.getCustomData("listarray_index")].indent,
a=a.getCustomData("listarray_index");a<=d.getCustomData("listarray_index");a++)if(h[a].indent+=e,0<e){for(var g=h[a].parent,n=a-1;0<=n;n--)if(h[n].indent===e){g=h[n].parent;break}h[a].parent=new CKEDITOR.dom.element(g.getName(),g.getDocument())}for(a=d.getCustomData("listarray_index")+1;a<h.length&&h[a].indent>m;a++)h[a].indent+=e;e=CKEDITOR.plugins.list.arrayToList(h,q,null,f.config.enterMode,b.getDirection());if(!k.isIndent){var t;if((t=b.getParent())&&t.is("li"))for(var d=e.listNode.getChildren(),
r=[],l,a=d.count()-1;0<=a;a--)(l=d.getItem(a))&&l.is&&l.is("li")&&r.push(l)}e&&e.listNode.replace(b);if(r&&r.length)for(a=0;a<r.length;a++){for(l=b=r[a];(l=l.getNext())&&l.is&&l.getName()in p;)CKEDITOR.env.needsNbspFiller&&!b.getFirst(x)&&b.append(c.document.createText(" ")),b.append(l);b.insertAfter(t)}e&&f.fire("contentDomInvalidated");return!0}for(var k=this,q=this.database,p=this.context,c,m=f.getSelection(),m=(m&&m.getRanges()).createIterator();c=m.getNextRange();){for(var b=c.getCommonAncestor();b&&
(b.type!=CKEDITOR.NODE_ELEMENT||!p[b.getName()]);){if(f.editable().equals(b)){b=!1;break}b=b.getParent()}b||(b=c.startPath().contains(p))&&c.setEndAt(b,CKEDITOR.POSITION_BEFORE_END);if(!b){var d=c.getEnclosedNode();d&&d.type==CKEDITOR.NODE_ELEMENT&&d.getName()in p&&(c.setStartAt(d,CKEDITOR.POSITION_AFTER_START),c.setEndAt(d,CKEDITOR.POSITION_BEFORE_END),b=d)}b&&c.startContainer.type==CKEDITOR.NODE_ELEMENT&&c.startContainer.getName()in p&&(d=new CKEDITOR.dom.walker(c),d.evaluator=n,c.startContainer=
d.next());b&&c.endContainer.type==CKEDITOR.NODE_ELEMENT&&c.endContainer.getName()in p&&(d=new CKEDITOR.dom.walker(c),d.evaluator=n,c.endContainer=d.previous());if(b)return g(b)}return 0}function n(f){return f.type==CKEDITOR.NODE_ELEMENT&&f.is("li")}function x(f){return y(f)&&z(f)}var y=CKEDITOR.dom.walker.whitespaces(!0),z=CKEDITOR.dom.walker.bookmark(!1,!0),u=CKEDITOR.TRISTATE_DISABLED,v=CKEDITOR.TRISTATE_OFF;CKEDITOR.plugins.add("indentlist",{requires:"indent",init:function(f){function g(f){k.specificDefinition.apply(this,
arguments);this.requiredContent=["ul","ol"];f.on("key",function(g){var c=f.elementPath();if("wysiwyg"==f.mode&&g.data.keyCode==this.indentKey&&c){var m=this.getContext(c);!m||this.isIndent&&CKEDITOR.plugins.indentList.firstItemInPath(this.context,c,m)||(f.execCommand(this.relatedGlobal),g.cancel())}},this);this.jobs[this.isIndent?10:30]={refresh:this.isIndent?function(f,c){var g=this.getContext(c),b=CKEDITOR.plugins.indentList.firstItemInPath(this.context,c,g);return g&&this.isIndent&&!b?v:u}:function(f,
c){return!this.getContext(c)||this.isIndent?u:v},exec:CKEDITOR.tools.bind(w,this)}}var k=CKEDITOR.plugins.indent;k.registerCommands(f,{indentlist:new g(f,"indentlist",!0),outdentlist:new g(f,"outdentlist")});CKEDITOR.tools.extend(g.prototype,k.specificDefinition.prototype,{context:{ol:1,ul:1}})}});CKEDITOR.plugins.indentList={};CKEDITOR.plugins.indentList.firstItemInPath=function(f,g,k){var q=g.contains(n);k||(k=g.contains(f));return k&&q&&q.equals(k.getFirst(n))}})();CKEDITOR.plugins.add("smiley",{requires:"dialog",init:function(a){a.config.smiley_path=a.config.smiley_path||this.path+"images/";a.addCommand("smiley",new CKEDITOR.dialogCommand("smiley",{allowedContent:"img[alt,height,!src,title,width]",requiredContent:"img"}));a.ui.addButton&&a.ui.addButton("Smiley",{label:a.lang.smiley.toolbar,command:"smiley",toolbar:"insert,50"});CKEDITOR.dialog.add("smiley",this.path+"dialogs/smiley.js")}});CKEDITOR.config.smiley_images="regular_smile.png sad_smile.png wink_smile.png teeth_smile.png confused_smile.png tongue_smile.png embarrassed_smile.png omg_smile.png whatchutalkingabout_smile.png angry_smile.png angel_smile.png shades_smile.png devil_smile.png cry_smile.png lightbulb.png thumbs_down.png thumbs_up.png heart.png broken_heart.png kiss.png envelope.png".split(" ");
CKEDITOR.config.smiley_descriptions="smiley;sad;wink;laugh;frown;cheeky;blush;surprise;indecision;angry;angel;cool;devil;crying;enlightened;no;yes;heart;broken heart;kiss;mail".split(";");(function(){function q(a,c){c=void 0===c||c;var b;if(c)b=a.getComputedStyle("text-align");else{for(;!a.hasAttribute||!a.hasAttribute("align")&&!a.getStyle("text-align");){b=a.getParent();if(!b)break;a=b}b=a.getStyle("text-align")||a.getAttribute("align")||""}b&&(b=b.replace(/(?:-(?:moz|webkit)-)?(?:start|auto)/i,""));!b&&c&&(b="rtl"==a.getComputedStyle("direction")?"right":"left");return b}function h(a,c,b){this.editor=a;this.name=c;this.value=b;this.context="p";c=a.config.justifyClasses;var f=a.config.enterMode==
CKEDITOR.ENTER_P?"p":"div";if(c){switch(b){case "left":this.cssClassName=c[0];break;case "center":this.cssClassName=c[1];break;case "right":this.cssClassName=c[2];break;case "justify":this.cssClassName=c[3]}this.cssClassRegex=new RegExp("(?:^|\\s+)(?:"+c.join("|")+")(?\x3d$|\\s)");this.requiredContent=f+"("+this.cssClassName+")"}else this.requiredContent=f+"{text-align}";this.allowedContent={"caption div h1 h2 h3 h4 h5 h6 p pre td th li":{propertiesOnly:!0,styles:this.cssClassName?null:"text-align",
classes:this.cssClassName||null}};a.config.enterMode==CKEDITOR.ENTER_BR&&(this.allowedContent.div=!0)}function m(a){var c=a.editor,b=c.createRange();b.setStartBefore(a.data.node);b.setEndAfter(a.data.node);for(var f=new CKEDITOR.dom.walker(b),d;d=f.next();)if(d.type==CKEDITOR.NODE_ELEMENT)if(!d.equals(a.data.node)&&d.getDirection())b.setStartAfter(d),f=new CKEDITOR.dom.walker(b);else{var e=c.config.justifyClasses;e&&(d.hasClass(e[0])?(d.removeClass(e[0]),d.addClass(e[2])):d.hasClass(e[2])&&(d.removeClass(e[2]),
d.addClass(e[0])));e=d.getStyle("text-align");"left"==e?d.setStyle("text-align","right"):"right"==e&&d.setStyle("text-align","left")}}h.prototype={exec:function(a){var c=a.getSelection(),b=a.config.enterMode;if(c){for(var f=c.createBookmarks(),d=c.getRanges(),e=this.cssClassName,h,g,k=a.config.useComputedState,k=void 0===k||k,n=d.length-1;0<=n;n--)for(h=d[n].createIterator(),h.enlargeBr=b!=CKEDITOR.ENTER_BR;g=h.getNextParagraph(b==CKEDITOR.ENTER_P?"p":"div");)if(!g.isReadOnly()){var l=g.getName(),
p;p=a.activeFilter.check(l+"{text-align}");if((l=a.activeFilter.check(l+"("+e+")"))||p){g.removeAttribute("align");g.removeStyle("text-align");var m=e&&(g.$.className=CKEDITOR.tools.ltrim(g.$.className.replace(this.cssClassRegex,""))),r=this.state==CKEDITOR.TRISTATE_OFF&&(!k||q(g,!0)!=this.value);e&&l?r?g.addClass(e):m||g.removeAttribute("class"):r&&p&&g.setStyle("text-align",this.value)}}a.focus();a.forceNextSelectionCheck();c.selectBookmarks(f)}},refresh:function(a,c){var b=c.block||c.blockLimit,
f=b.getName(),d=b.equals(a.editable()),f=this.cssClassName?a.activeFilter.check(f+"("+this.cssClassName+")"):a.activeFilter.check(f+"{text-align}");d&&!CKEDITOR.dtd.$list[c.lastElement.getName()]?this.setState(CKEDITOR.TRISTATE_OFF):!d&&f?this.setState(q(b,this.editor.config.useComputedState)==this.value?CKEDITOR.TRISTATE_ON:CKEDITOR.TRISTATE_OFF):this.setState(CKEDITOR.TRISTATE_DISABLED)}};CKEDITOR.plugins.add("justify",{init:function(a){if(!a.blockless){var c=new h(a,"justifyleft","left"),b=new h(a,
"justifycenter","center"),f=new h(a,"justifyright","right"),d=new h(a,"justifyblock","justify");a.addCommand("justifyleft",c);a.addCommand("justifycenter",b);a.addCommand("justifyright",f);a.addCommand("justifyblock",d);a.ui.addButton&&(a.ui.addButton("JustifyLeft",{label:a.lang.common.alignLeft,command:"justifyleft",toolbar:"align,10"}),a.ui.addButton("JustifyCenter",{label:a.lang.common.center,command:"justifycenter",toolbar:"align,20"}),a.ui.addButton("JustifyRight",{label:a.lang.common.alignRight,
command:"justifyright",toolbar:"align,30"}),a.ui.addButton("JustifyBlock",{label:a.lang.common.justify,command:"justifyblock",toolbar:"align,40"}));a.on("dirChanged",m)}}})})();CKEDITOR.plugins.add("menubutton",{requires:"button,menu",onLoad:function(){var d=function(c){var a=this._,b=a.menu;a.state!==CKEDITOR.TRISTATE_DISABLED&&(a.on&&b?b.hide():(a.previousState=a.state,b||(b=a.menu=new CKEDITOR.menu(c,{panel:{className:"cke_menu_panel",attributes:{"aria-label":c.lang.common.options}}}),b.onHide=CKEDITOR.tools.bind(function(){var b=this.command?c.getCommand(this.command).modes:this.modes;this.setState(!b||b[c.mode]?a.previousState:CKEDITOR.TRISTATE_DISABLED);a.on=0},this),
this.onMenu&&b.addListener(this.onMenu)),this.setState(CKEDITOR.TRISTATE_ON),a.on=1,setTimeout(function(){b.show(CKEDITOR.document.getById(a.id),4)},0)))};CKEDITOR.ui.menuButton=CKEDITOR.tools.createClass({base:CKEDITOR.ui.button,$:function(c){delete c.panel;this.base(c);this.hasArrow="menu";this.click=d},statics:{handler:{create:function(c){return new CKEDITOR.ui.menuButton(c)}}}})},beforeInit:function(d){d.ui.addHandler(CKEDITOR.UI_MENUBUTTON,CKEDITOR.ui.menuButton.handler)}});
CKEDITOR.UI_MENUBUTTON="menubutton";(function(){CKEDITOR.plugins.add("language",{requires:"menubutton",init:function(a){var b=a.config.language_list||["ar:Arabic:rtl","fr:French","es:Spanish"],c=this,d=a.lang.language,e={},g,h,k,f;a.addCommand("language",{allowedContent:"span[!lang,!dir]",requiredContent:"span[lang,dir]",contextSensitive:!0,exec:function(a,b){var c=e["language_"+b];if(c)a[c.style.checkActive(a.elementPath(),a)?"removeStyle":"applyStyle"](c.style)},refresh:function(a){this.setState(c.getCurrentLangElement(a)?CKEDITOR.TRISTATE_ON:
CKEDITOR.TRISTATE_OFF)}});for(f=0;f<b.length;f++)g=b[f].split(":"),h=g[0],k="language_"+h,e[k]={label:g[1],langId:h,group:"language",order:f,ltr:"rtl"!=(""+g[2]).toLowerCase(),onClick:function(){a.execCommand("language",this.langId)},role:"menuitemcheckbox"},e[k].style=new CKEDITOR.style({element:"span",attributes:{lang:h,dir:e[k].ltr?"ltr":"rtl"}});e.language_remove={label:d.remove,group:"language_remove",state:CKEDITOR.TRISTATE_DISABLED,order:e.length,onClick:function(){var b=c.getCurrentLangElement(a);
b&&a.execCommand("language",b.getAttribute("lang"))}};a.addMenuGroup("language",1);a.addMenuGroup("language_remove");a.addMenuItems(e);a.ui.add("Language",CKEDITOR.UI_MENUBUTTON,{label:d.button,allowedContent:"span[!lang,!dir]",requiredContent:"span[lang,dir]",toolbar:"bidi,30",command:"language",onMenu:function(){var b={},d=c.getCurrentLangElement(a),f;for(f in e)b[f]=CKEDITOR.TRISTATE_OFF;b.language_remove=d?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED;d&&(b["language_"+d.getAttribute("lang")]=
CKEDITOR.TRISTATE_ON);return b}});a.addRemoveFormatFilter&&a.addRemoveFormatFilter(function(a){return!(a.is("span")&&a.getAttribute("dir")&&a.getAttribute("lang"))})},getCurrentLangElement:function(a){var b=a.elementPath();a=b&&b.elements;var c;if(b)for(var d=0;d<a.length;d++)b=a[d],!c&&"span"==b.getName()&&b.hasAttribute("dir")&&b.hasAttribute("lang")&&(c=b);return c}})})();(function(){function p(c){return c.replace(/'/g,"\\$\x26")}function q(c){for(var b=c.length,a=[],e,f=0;f<b;f++)e=c.charCodeAt(f),a.push(e);return"String.fromCharCode("+a.join(",")+")"}function r(c,b){for(var a=c.plugins.link,e=a.compiledProtectionFunction.params,a=[a.compiledProtectionFunction.name,"("],f,d,g=0;g<e.length;g++)f=e[g].toLowerCase(),d=b[f],0<g&&a.push(","),a.push("'",d?p(encodeURIComponent(b[f])):"","'");a.push(")");return a.join("")}function n(c){c=c.config.emailProtection||"";var b;
c&&"encode"!=c&&(b={},c.replace(/^([^(]+)\(([^)]+)\)$/,function(a,c,f){b.name=c;b.params=[];f.replace(/[^,\s]+/g,function(a){b.params.push(a)})}));return b}CKEDITOR.plugins.add("link",{requires:"dialog,fakeobjects",onLoad:function(){function c(b){return a.replace(/%1/g,"rtl"==b?"right":"left").replace(/%2/g,"cke_contents_"+b)}var b="background:url("+CKEDITOR.getUrl(this.path+"images"+(CKEDITOR.env.hidpi?"/hidpi":"")+"/anchor.png")+") no-repeat %1 center;border:1px dotted #00f;background-size:16px;",
a=".%2 a.cke_anchor,.%2 a.cke_anchor_empty,.cke_editable.%2 a[name],.cke_editable.%2 a[data-cke-saved-name]{"+b+"padding-%1:18px;cursor:auto;}.%2 img.cke_anchor{"+b+"width:16px;min-height:15px;height:1.15em;vertical-align:text-bottom;}";CKEDITOR.addCss(c("ltr")+c("rtl"))},init:function(c){var b="a[!href]";CKEDITOR.dialog.isTabEnabled(c,"link","advanced")&&(b=b.replace("]",",accesskey,charset,dir,id,lang,name,rel,tabindex,title,type,download]{*}(*)"));CKEDITOR.dialog.isTabEnabled(c,"link","target")&&
(b=b.replace("]",",target,onclick]"));c.addCommand("link",new CKEDITOR.dialogCommand("link",{allowedContent:b,requiredContent:"a[href]"}));c.addCommand("anchor",new CKEDITOR.dialogCommand("anchor",{allowedContent:"a[!name,id]",requiredContent:"a[name]"}));c.addCommand("unlink",new CKEDITOR.unlinkCommand);c.addCommand("removeAnchor",new CKEDITOR.removeAnchorCommand);c.setKeystroke(CKEDITOR.CTRL+76,"link");c.setKeystroke(CKEDITOR.CTRL+75,"link");c.ui.addButton&&(c.ui.addButton("Link",{label:c.lang.link.toolbar,
command:"link",toolbar:"links,10"}),c.ui.addButton("Unlink",{label:c.lang.link.unlink,command:"unlink",toolbar:"links,20"}),c.ui.addButton("Anchor",{label:c.lang.link.anchor.toolbar,command:"anchor",toolbar:"links,30"}));CKEDITOR.dialog.add("link",this.path+"dialogs/link.js");CKEDITOR.dialog.add("anchor",this.path+"dialogs/anchor.js");c.on("doubleclick",function(a){var b=a.data.element.getAscendant({a:1,img:1},!0);b&&!b.isReadOnly()&&(b.is("a")?(a.data.dialog=!b.getAttribute("name")||b.getAttribute("href")&&
b.getChildCount()?"link":"anchor",a.data.link=b):CKEDITOR.plugins.link.tryRestoreFakeAnchor(c,b)&&(a.data.dialog="anchor"))},null,null,0);c.on("doubleclick",function(a){a.data.dialog in{link:1,anchor:1}&&a.data.link&&c.getSelection().selectElement(a.data.link)},null,null,20);c.addMenuItems&&c.addMenuItems({anchor:{label:c.lang.link.anchor.menu,command:"anchor",group:"anchor",order:1},removeAnchor:{label:c.lang.link.anchor.remove,command:"removeAnchor",group:"anchor",order:5},link:{label:c.lang.link.menu,
command:"link",group:"link",order:1},unlink:{label:c.lang.link.unlink,command:"unlink",group:"link",order:5}});c.contextMenu&&c.contextMenu.addListener(function(a){if(!a||a.isReadOnly())return null;a=CKEDITOR.plugins.link.tryRestoreFakeAnchor(c,a);if(!a&&!(a=CKEDITOR.plugins.link.getSelectedLink(c)))return null;var b={};a.getAttribute("href")&&a.getChildCount()&&(b={link:CKEDITOR.TRISTATE_OFF,unlink:CKEDITOR.TRISTATE_OFF});a&&a.hasAttribute("name")&&(b.anchor=b.removeAnchor=CKEDITOR.TRISTATE_OFF);
return b});this.compiledProtectionFunction=n(c)},afterInit:function(c){c.dataProcessor.dataFilter.addRules({elements:{a:function(a){return a.attributes.name?a.children.length?null:c.createFakeParserElement(a,"cke_anchor","anchor"):null}}});var b=c._.elementsPath&&c._.elementsPath.filters;b&&b.push(function(a,b){if("a"==b&&(CKEDITOR.plugins.link.tryRestoreFakeAnchor(c,a)||a.getAttribute("name")&&(!a.getAttribute("href")||!a.getChildCount())))return"anchor"})}});var t=/^javascript:/,u=/^(?:mailto)(?:(?!\?(subject|body)=).)+/i,
v=/subject=([^;?:@&=$,\/]*)/i,w=/body=([^;?:@&=$,\/]*)/i,x=/^#(.*)$/,y=/^((?:http|https|ftp|news):\/\/)?(.*)$/,z=/^(_(?:self|top|parent|blank))$/,A=/^javascript:void\(location\.href='mailto:'\+String\.fromCharCode\(([^)]+)\)(?:\+'(.*)')?\)$/,B=/^javascript:([^(]+)\(([^)]+)\)$/,C=/\s*window.open\(\s*this\.href\s*,\s*(?:'([^']*)'|null)\s*,\s*'([^']*)'\s*\)\s*;\s*return\s*false;*\s*/,D=/(?:^|,)([^=]+)=(\d+|yes|no)/gi,E=/^tel:(.*)$/,m={id:"advId",dir:"advLangDir",accessKey:"advAccessKey",name:"advName",
lang:"advLangCode",tabindex:"advTabIndex",title:"advTitle",type:"advContentType","class":"advCSSClasses",charset:"advCharset",style:"advStyles",rel:"advRel"};CKEDITOR.plugins.link={getSelectedLink:function(c,b){var a=c.getSelection(),e=a.getSelectedElement(),f=a.getRanges(),d=[],g;if(!b&&e&&e.is("a"))return e;for(e=0;e<f.length;e++)if(g=a.getRanges()[e],g.shrink(CKEDITOR.SHRINK_ELEMENT,!0,{skipBogus:!0}),(g=c.elementPath(g.getCommonAncestor()).contains("a",1))&&b)d.push(g);else if(g)return g;return b?
d:null},getEditorAnchors:function(c){for(var b=c.editable(),a=b.isInline()&&!c.plugins.divarea?c.document:b,b=a.getElementsByTag("a"),a=a.getElementsByTag("img"),e=[],f=0,d;d=b.getItem(f++);)(d.data("cke-saved-name")||d.hasAttribute("name"))&&e.push({name:d.data("cke-saved-name")||d.getAttribute("name"),id:d.getAttribute("id")});for(f=0;d=a.getItem(f++);)(d=this.tryRestoreFakeAnchor(c,d))&&e.push({name:d.getAttribute("name"),id:d.getAttribute("id")});return e},fakeAnchor:!0,tryRestoreFakeAnchor:function(c,
b){if(b&&b.data("cke-real-element-type")&&"anchor"==b.data("cke-real-element-type")){var a=c.restoreRealElement(b);if(a.data("cke-saved-name"))return a}},parseLinkAttributes:function(c,b){var a=b&&(b.data("cke-saved-href")||b.getAttribute("href"))||"",e=c.plugins.link.compiledProtectionFunction,f=c.config.emailProtection,d={},g;a.match(t)&&("encode"==f?a=a.replace(A,function(a,b,c){c=c||"";return"mailto:"+String.fromCharCode.apply(String,b.split(","))+c.replace(/\\'/g,"'")}):f&&a.replace(B,function(a,
b,c){if(b==e.name){d.type="email";a=d.email={};b=/(^')|('$)/g;c=c.match(/[^,\s]+/g);for(var f=c.length,g,h,k=0;k<f;k++)g=decodeURIComponent,h=c[k].replace(b,"").replace(/\\'/g,"'"),h=g(h),g=e.params[k].toLowerCase(),a[g]=h;a.address=[a.name,a.domain].join("@")}}));if(!d.type)if(f=a.match(x))d.type="anchor",d.anchor={},d.anchor.name=d.anchor.id=f[1];else if(f=a.match(E))d.type="tel",d.tel=f[1];else if(f=a.match(u)){g=a.match(v);var a=a.match(w),k=d.email={};d.type="email";k.address=f[0].replace("mailto:",
"");g&&(k.subject=decodeURIComponent(g[1]));a&&(k.body=decodeURIComponent(a[1]))}else a&&(g=a.match(y))&&(d.type="url",d.url={},d.url.protocol=g[1],d.url.url=g[2]);if(b){if(a=b.getAttribute("target"))d.target={type:a.match(z)?a:"frame",name:a};else if(a=(a=b.data("cke-pa-onclick")||b.getAttribute("onclick"))&&a.match(C))for(d.target={type:"popup",name:a[1]};f=D.exec(a[2]);)"yes"!=f[2]&&"1"!=f[2]||f[1]in{height:1,width:1,top:1,left:1}?isFinite(f[2])&&(d.target[f[1]]=f[2]):d.target[f[1]]=!0;null!==
b.getAttribute("download")&&(d.download=!0);var a={},h;for(h in m)(f=b.getAttribute(h))&&(a[m[h]]=f);if(h=b.data("cke-saved-name")||a.advName)a.advName=h;CKEDITOR.tools.isEmpty(a)||(d.advanced=a)}return d},getLinkAttributes:function(c,b){var a=c.config.emailProtection||"",e={};switch(b.type){case "url":var a=b.url&&void 0!==b.url.protocol?b.url.protocol:"http://",f=b.url&&CKEDITOR.tools.trim(b.url.url)||"";e["data-cke-saved-href"]=0===f.indexOf("/")?f:a+f;break;case "anchor":a=b.anchor&&b.anchor.id;
e["data-cke-saved-href"]="#"+(b.anchor&&b.anchor.name||a||"");break;case "email":var d=b.email,f=d.address;switch(a){case "":case "encode":var g=encodeURIComponent(d.subject||""),k=encodeURIComponent(d.body||""),d=[];g&&d.push("subject\x3d"+g);k&&d.push("body\x3d"+k);d=d.length?"?"+d.join("\x26"):"";"encode"==a?(a=["javascript:void(location.href\x3d'mailto:'+",q(f)],d&&a.push("+'",p(d),"'"),a.push(")")):a=["mailto:",f,d];break;default:a=f.split("@",2),d.name=a[0],d.domain=a[1],a=["javascript:",r(c,
d)]}e["data-cke-saved-href"]=a.join("");break;case "tel":e["data-cke-saved-href"]="tel:"+b.tel}if(b.target)if("popup"==b.target.type){for(var a=["window.open(this.href, '",b.target.name||"","', '"],h="resizable status location toolbar menubar fullscreen scrollbars dependent".split(" "),f=h.length,g=function(a){b.target[a]&&h.push(a+"\x3d"+b.target[a])},d=0;d<f;d++)h[d]+=b.target[h[d]]?"\x3dyes":"\x3dno";g("width");g("left");g("height");g("top");a.push(h.join(","),"'); return false;");e["data-cke-pa-onclick"]=
a.join("")}else"notSet"!=b.target.type&&b.target.name&&(e.target=b.target.name);b.download&&(e.download="");if(b.advanced){for(var l in m)(a=b.advanced[m[l]])&&(e[l]=a);e.name&&(e["data-cke-saved-name"]=e.name)}e["data-cke-saved-href"]&&(e.href=e["data-cke-saved-href"]);l={target:1,onclick:1,"data-cke-pa-onclick":1,"data-cke-saved-name":1,download:1};b.advanced&&CKEDITOR.tools.extend(l,m);for(var n in e)delete l[n];return{set:e,removed:CKEDITOR.tools.object.keys(l)}},showDisplayTextForElement:function(c,
b){var a={img:1,table:1,tbody:1,thead:1,tfoot:1,input:1,select:1,textarea:1},e=b.getSelection();return b.widgets&&b.widgets.focused||e&&1<e.getRanges().length?!1:!c||!c.getName||!c.is(a)}};CKEDITOR.unlinkCommand=function(){};CKEDITOR.unlinkCommand.prototype={exec:function(c){if(CKEDITOR.env.ie){var b=c.getSelection().getRanges()[0],a=b.getPreviousEditableNode()&&b.getPreviousEditableNode().getAscendant("a",!0)||b.getNextEditableNode()&&b.getNextEditableNode().getAscendant("a",!0),e;b.collapsed&&a&&
(e=b.createBookmark(),b.selectNodeContents(a),b.select())}a=new CKEDITOR.style({element:"a",type:CKEDITOR.STYLE_INLINE,alwaysRemoveElement:1});c.removeStyle(a);e&&(b.moveToBookmark(e),b.select())},refresh:function(c,b){var a=b.lastElement&&b.lastElement.getAscendant("a",!0);a&&"a"==a.getName()&&a.getAttribute("href")&&a.getChildCount()?this.setState(CKEDITOR.TRISTATE_OFF):this.setState(CKEDITOR.TRISTATE_DISABLED)},contextSensitive:1,startDisabled:1,requiredContent:"a[href]",editorFocus:1};CKEDITOR.removeAnchorCommand=
function(){};CKEDITOR.removeAnchorCommand.prototype={exec:function(c){var b=c.getSelection(),a=b.createBookmarks(),e;if(b&&(e=b.getSelectedElement())&&(e.getChildCount()?e.is("a"):CKEDITOR.plugins.link.tryRestoreFakeAnchor(c,e)))e.remove(1);else if(e=CKEDITOR.plugins.link.getSelectedLink(c))e.hasAttribute("href")?(e.removeAttributes({name:1,"data-cke-saved-name":1}),e.removeClass("cke_anchor")):e.remove(1);b.selectBookmarks(a)},requiredContent:"a[name]"};CKEDITOR.tools.extend(CKEDITOR.config,{linkShowAdvancedTab:!0,
linkShowTargetTab:!0,linkDefaultProtocol:"http://"})})();(function(){function K(a,l,d,f){for(var e=CKEDITOR.plugins.list.listToArray(l.root,d),g=[],b=0;b<l.contents.length;b++){var h=l.contents[b];(h=h.getAscendant("li",!0))&&!h.getCustomData("list_item_processed")&&(g.push(h),CKEDITOR.dom.element.setMarker(d,h,"list_item_processed",!0))}for(var h=l.root.getDocument(),k,c,b=0;b<g.length;b++){var p=g[b].getCustomData("listarray_index");k=e[p].parent;k.is(this.type)||(c=h.createElement(this.type),k.copyAttributes(c,{start:1,type:1}),c.removeStyle("list-style-type"),
e[p].parent=c)}d=CKEDITOR.plugins.list.arrayToList(e,d,null,a.config.enterMode);for(var m,e=d.listNode.getChildCount(),b=0;b<e&&(m=d.listNode.getChild(b));b++)m.getName()==this.type&&f.push(m);d.listNode.replace(l.root);a.fire("contentDomInvalidated")}function L(a,l,d){var f=l.contents,e=l.root.getDocument(),g=[];if(1==f.length&&f[0].equals(l.root)){var b=e.createElement("div");f[0].moveChildren&&f[0].moveChildren(b);f[0].append(b);f[0]=b}l=l.contents[0].getParent();for(b=0;b<f.length;b++)l=l.getCommonAncestor(f[b].getParent());
a=a.config.useComputedState;var h,k;a=void 0===a||a;for(b=0;b<f.length;b++)for(var c=f[b],p;p=c.getParent();){if(p.equals(l)){g.push(c);!k&&c.getDirection()&&(k=1);c=c.getDirection(a);null!==h&&(h=h&&h!=c?null:c);break}c=p}if(!(1>g.length)){f=g[g.length-1].getNext();b=e.createElement(this.type);for(d.push(b);g.length;)d=g.shift(),a=e.createElement("li"),c=d,c.is("pre")||M.test(c.getName())||"false"==c.getAttribute("contenteditable")?d.appendTo(a):(d.copyAttributes(a),h&&d.getDirection()&&(a.removeStyle("direction"),
a.removeAttribute("dir")),d.moveChildren(a),d.remove()),a.appendTo(b);h&&k&&b.setAttribute("dir",h);f?b.insertBefore(f):b.appendTo(l)}}function N(a,l,d){function f(b){if(!(!(c=k[b?"getFirst":"getLast"]())||c.is&&c.isBlockBoundary()||!(p=l.root[b?"getPrevious":"getNext"](CKEDITOR.dom.walker.invisible(!0)))||p.is&&p.isBlockBoundary({br:1})))a.document.createElement("br")[b?"insertBefore":"insertAfter"](c)}for(var e=CKEDITOR.plugins.list.listToArray(l.root,d),g=[],b=0;b<l.contents.length;b++){var h=
l.contents[b];(h=h.getAscendant("li",!0))&&!h.getCustomData("list_item_processed")&&(g.push(h),CKEDITOR.dom.element.setMarker(d,h,"list_item_processed",!0))}h=null;for(b=0;b<g.length;b++)h=g[b].getCustomData("listarray_index"),e[h].indent=-1;for(b=h+1;b<e.length;b++)if(e[b].indent>e[b-1].indent+1){g=e[b-1].indent+1-e[b].indent;for(h=e[b].indent;e[b]&&e[b].indent>=h;)e[b].indent+=g,b++;b--}var k=CKEDITOR.plugins.list.arrayToList(e,d,null,a.config.enterMode,l.root.getAttribute("dir")).listNode,c,p;
f(!0);f();k.replace(l.root);a.fire("contentDomInvalidated")}function C(a,l){this.name=a;this.context=this.type=l;this.allowedContent=l+" li";this.requiredContent=l}function F(a,l,d,f){for(var e,g;e=a[f?"getLast":"getFirst"](O);)(g=e.getDirection(1))!==l.getDirection(1)&&e.setAttribute("dir",g),e.remove(),d?e[f?"insertBefore":"insertAfter"](d):l.append(e,f),d=e}function G(a){function l(d){var f=a[d?"getPrevious":"getNext"](t);f&&f.type==CKEDITOR.NODE_ELEMENT&&f.is(a.getName())&&(F(a,f,null,!d),a.remove(),
a=f)}l();l(1)}function H(a){return a.type==CKEDITOR.NODE_ELEMENT&&(a.getName()in CKEDITOR.dtd.$block||a.getName()in CKEDITOR.dtd.$listItem)&&CKEDITOR.dtd[a.getName()]["#"]}function D(a,l,d){a.fire("saveSnapshot");d.enlarge(CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS);var f=d.extractContents();l.trim(!1,!0);var e=l.createBookmark(),g=new CKEDITOR.dom.elementPath(l.startContainer),b=g.block,g=g.lastElement.getAscendant("li",1)||b,h=new CKEDITOR.dom.elementPath(d.startContainer),k=h.contains(CKEDITOR.dtd.$listItem),
h=h.contains(CKEDITOR.dtd.$list);b?(b=b.getBogus())&&b.remove():h&&(b=h.getPrevious(t))&&z(b)&&b.remove();(b=f.getLast())&&b.type==CKEDITOR.NODE_ELEMENT&&b.is("br")&&b.remove();(b=l.startContainer.getChild(l.startOffset))?f.insertBefore(b):l.startContainer.append(f);k&&(f=A(k))&&(g.contains(k)?(F(f,k.getParent(),k),f.remove()):g.append(f));for(;d.checkStartOfBlock()&&d.checkEndOfBlock();){h=d.startPath();f=h.block;if(!f)break;f.is("li")&&(g=f.getParent(),f.equals(g.getLast(t))&&f.equals(g.getFirst(t))&&
(f=g));d.moveToPosition(f,CKEDITOR.POSITION_BEFORE_START);f.remove()}d=d.clone();f=a.editable();d.setEndAt(f,CKEDITOR.POSITION_BEFORE_END);d=new CKEDITOR.dom.walker(d);d.evaluator=function(a){return t(a)&&!z(a)};(d=d.next())&&d.type==CKEDITOR.NODE_ELEMENT&&d.getName()in CKEDITOR.dtd.$list&&G(d);l.moveToBookmark(e);l.select();a.fire("saveSnapshot")}function A(a){return(a=a.getLast(t))&&a.type==CKEDITOR.NODE_ELEMENT&&a.getName()in u?a:null}var u={ol:1,ul:1},P=CKEDITOR.dom.walker.whitespaces(),I=CKEDITOR.dom.walker.bookmark(),
t=function(a){return!(P(a)||I(a))},z=CKEDITOR.dom.walker.bogus();CKEDITOR.plugins.list={listToArray:function(a,l,d,f,e){if(!u[a.getName()])return[];f||(f=0);d||(d=[]);for(var g=0,b=a.getChildCount();g<b;g++){var h=a.getChild(g);h.type==CKEDITOR.NODE_ELEMENT&&h.getName()in CKEDITOR.dtd.$list&&CKEDITOR.plugins.list.listToArray(h,l,d,f+1);if("li"==h.$.nodeName.toLowerCase()){var k={parent:a,indent:f,element:h,contents:[]};e?k.grandparent=e:(k.grandparent=a.getParent(),k.grandparent&&"li"==k.grandparent.$.nodeName.toLowerCase()&&
(k.grandparent=k.grandparent.getParent()));l&&CKEDITOR.dom.element.setMarker(l,h,"listarray_index",d.length);d.push(k);for(var c=0,p=h.getChildCount(),m;c<p;c++)m=h.getChild(c),m.type==CKEDITOR.NODE_ELEMENT&&u[m.getName()]?CKEDITOR.plugins.list.listToArray(m,l,d,f+1,k.grandparent):k.contents.push(m)}}return d},arrayToList:function(a,l,d,f,e){d||(d=0);if(!a||a.length<d+1)return null;for(var g,b=a[d].parent.getDocument(),h=new CKEDITOR.dom.documentFragment(b),k=null,c=d,p=Math.max(a[d].indent,0),m=
null,n,r,y=f==CKEDITOR.ENTER_P?"p":"div";;){var q=a[c];g=q.grandparent;n=q.element.getDirection(1);if(q.indent==p){k&&a[c].parent.getName()==k.getName()||(k=a[c].parent.clone(!1,1),e&&k.setAttribute("dir",e),h.append(k));m=k.append(q.element.clone(0,1));n!=k.getDirection(1)&&m.setAttribute("dir",n);for(g=0;g<q.contents.length;g++)m.append(q.contents[g].clone(1,1));c++}else if(q.indent==Math.max(p,0)+1)q=a[c-1].element.getDirection(1),c=CKEDITOR.plugins.list.arrayToList(a,null,c,f,q!=n?n:null),!m.getChildCount()&&
CKEDITOR.env.needsNbspFiller&&7>=b.$.documentMode&&m.append(b.createText(" ")),m.append(c.listNode),c=c.nextIndex;else if(-1==q.indent&&!d&&g){u[g.getName()]?(m=q.element.clone(!1,!0),n!=g.getDirection(1)&&m.setAttribute("dir",n)):m=new CKEDITOR.dom.documentFragment(b);var k=g.getDirection(1)!=n,w=q.element,B=w.getAttribute("class"),E=w.getAttribute("style"),J=m.type==CKEDITOR.NODE_DOCUMENT_FRAGMENT&&(f!=CKEDITOR.ENTER_BR||k||E||B),v,z=q.contents.length,x;for(g=0;g<z;g++)if(v=q.contents[g],I(v)&&
1<z)J?x=v.clone(1,1):m.append(v.clone(1,1));else if(v.type==CKEDITOR.NODE_ELEMENT&&v.isBlockBoundary()){k&&!v.getDirection()&&v.setAttribute("dir",n);r=v;var A=w.getAttribute("style");A&&r.setAttribute("style",A.replace(/([^;])$/,"$1;")+(r.getAttribute("style")||""));B&&v.addClass(B);r=null;x&&(m.append(x),x=null);m.append(v.clone(1,1))}else J?(r||(r=b.createElement(y),m.append(r),k&&r.setAttribute("dir",n)),E&&r.setAttribute("style",E),B&&r.setAttribute("class",B),x&&(r.append(x),x=null),r.append(v.clone(1,
1))):m.append(v.clone(1,1));x&&((r||m).append(x),x=null);m.type==CKEDITOR.NODE_DOCUMENT_FRAGMENT&&c!=a.length-1&&(CKEDITOR.env.needsBrFiller&&(n=m.getLast())&&n.type==CKEDITOR.NODE_ELEMENT&&n.is("br")&&n.remove(),(n=m.getLast(t))&&n.type==CKEDITOR.NODE_ELEMENT&&n.is(CKEDITOR.dtd.$block)||m.append(b.createElement("br")));n=m.$.nodeName.toLowerCase();"div"!=n&&"p"!=n||m.appendBogus();h.append(m);k=null;c++}else return null;r=null;if(a.length<=c||Math.max(a[c].indent,0)<p)break}if(l)for(a=h.getFirst();a;){if(a.type==
CKEDITOR.NODE_ELEMENT&&(CKEDITOR.dom.element.clearMarkers(l,a),a.getName()in CKEDITOR.dtd.$listItem&&(d=a,b=e=f=void 0,f=d.getDirection()))){for(e=d.getParent();e&&!(b=e.getDirection());)e=e.getParent();f==b&&d.removeAttribute("dir")}a=a.getNextSourceNode()}return{listNode:h,nextIndex:c}}};var M=/^h[1-6]$/,O=CKEDITOR.dom.walker.nodeType(CKEDITOR.NODE_ELEMENT);C.prototype={exec:function(a){function l(a){return u[a.root.getName()]&&!d(a.root,[CKEDITOR.NODE_COMMENT])}function d(a,b){return CKEDITOR.tools.array.filter(a.getChildren().toArray(),
function(a){return-1===CKEDITOR.tools.array.indexOf(b,a.type)}).length}function f(a){var b=!0;if(0===a.getChildCount())return!1;a.forEach(function(a){if(a.type!==CKEDITOR.NODE_COMMENT)return b=!1},null,!0);return b}this.refresh(a,a.elementPath());var e=a.config,g=a.getSelection(),b=g&&g.getRanges();if(this.state==CKEDITOR.TRISTATE_OFF){var h=a.editable();if(h.getFirst(t)){var k=1==b.length&&b[0];(e=k&&k.getEnclosedNode())&&e.is&&this.type==e.getName()&&this.setState(CKEDITOR.TRISTATE_ON)}else e.enterMode==
CKEDITOR.ENTER_BR?h.appendBogus():b[0].fixBlock(1,e.enterMode==CKEDITOR.ENTER_P?"p":"div"),g.selectRanges(b)}for(var e=g.createBookmarks(!0),h=[],c={},b=b.createIterator(),p=0;(k=b.getNextRange())&&++p;){var m=k.getBoundaryNodes(),n=m.startNode,r=m.endNode;n.type==CKEDITOR.NODE_ELEMENT&&"td"==n.getName()&&k.setStartAt(m.startNode,CKEDITOR.POSITION_AFTER_START);r.type==CKEDITOR.NODE_ELEMENT&&"td"==r.getName()&&k.setEndAt(m.endNode,CKEDITOR.POSITION_BEFORE_END);k=k.createIterator();for(k.forceBrBreak=
this.state==CKEDITOR.TRISTATE_OFF;m=k.getNextParagraph();)if(!m.getCustomData("list_block")&&!f(m)){CKEDITOR.dom.element.setMarker(c,m,"list_block",1);for(var y=a.elementPath(m),n=y.elements,r=0,y=y.blockLimit,q,w=n.length-1;0<=w&&(q=n[w]);w--)if(u[q.getName()]&&y.contains(q)){y.removeCustomData("list_group_object_"+p);(n=q.getCustomData("list_group_object"))?n.contents.push(m):(n={root:q,contents:[m]},h.push(n),CKEDITOR.dom.element.setMarker(c,q,"list_group_object",n));r=1;break}r||(r=y,r.getCustomData("list_group_object_"+
p)?r.getCustomData("list_group_object_"+p).contents.push(m):(n={root:r,contents:[m]},CKEDITOR.dom.element.setMarker(c,r,"list_group_object_"+p,n),h.push(n)))}}for(q=[];0<h.length;)n=h.shift(),this.state==CKEDITOR.TRISTATE_OFF?l(n)||(u[n.root.getName()]?K.call(this,a,n,c,q):L.call(this,a,n,q)):this.state==CKEDITOR.TRISTATE_ON&&u[n.root.getName()]&&!l(n)&&N.call(this,a,n,c);for(w=0;w<q.length;w++)G(q[w]);CKEDITOR.dom.element.clearAllMarkers(c);g.selectBookmarks(e);a.focus()},refresh:function(a,l){var d=
l.contains(u,1),f=l.blockLimit||l.root;d&&f.contains(d)?this.setState(d.is(this.type)?CKEDITOR.TRISTATE_ON:CKEDITOR.TRISTATE_OFF):this.setState(CKEDITOR.TRISTATE_OFF)}};CKEDITOR.plugins.add("list",{requires:"indentlist",init:function(a){a.blockless||(a.addCommand("numberedlist",new C("numberedlist","ol")),a.addCommand("bulletedlist",new C("bulletedlist","ul")),a.ui.addButton&&(a.ui.addButton("NumberedList",{label:a.lang.list.numberedlist,command:"numberedlist",directional:!0,toolbar:"list,10"}),a.ui.addButton("BulletedList",
{label:a.lang.list.bulletedlist,command:"bulletedlist",directional:!0,toolbar:"list,20"})),a.on("key",function(l){var d=l.data.domEvent.getKey(),f;if("wysiwyg"==a.mode&&d in{8:1,46:1}){var e=a.getSelection().getRanges()[0],g=e&&e.startPath();if(e&&e.collapsed){var b=8==d,h=a.editable(),k=new CKEDITOR.dom.walker(e.clone());k.evaluator=function(a){return t(a)&&!z(a)};k.guard=function(a,b){return!(b&&a.type==CKEDITOR.NODE_ELEMENT&&a.is("table"))};d=e.clone();if(b){var c;(c=g.contains(u))&&e.checkBoundaryOfElement(c,
CKEDITOR.START)&&(c=c.getParent())&&c.is("li")&&(c=A(c))?(f=c,c=c.getPrevious(t),d.moveToPosition(c&&z(c)?c:f,CKEDITOR.POSITION_BEFORE_START)):(k.range.setStartAt(h,CKEDITOR.POSITION_AFTER_START),k.range.setEnd(e.startContainer,e.startOffset),(c=k.previous())&&c.type==CKEDITOR.NODE_ELEMENT&&(c.getName()in u||c.is("li"))&&(c.is("li")||(k.range.selectNodeContents(c),k.reset(),k.evaluator=H,c=k.previous()),f=c,d.moveToElementEditEnd(f),d.moveToPosition(d.endPath().block,CKEDITOR.POSITION_BEFORE_END)));
if(f)D(a,d,e),l.cancel();else{var p=g.contains(u);p&&e.checkBoundaryOfElement(p,CKEDITOR.START)&&(f=p.getFirst(t),e.checkBoundaryOfElement(f,CKEDITOR.START)&&(c=p.getPrevious(t),A(f)?c&&(e.moveToElementEditEnd(c),e.select()):a.execCommand("outdent"),l.cancel()))}}else if(f=g.contains("li")){if(k.range.setEndAt(h,CKEDITOR.POSITION_BEFORE_END),b=(h=f.getLast(t))&&H(h)?h:f,g=0,(c=k.next())&&c.type==CKEDITOR.NODE_ELEMENT&&c.getName()in u&&c.equals(h)?(g=1,c=k.next()):e.checkBoundaryOfElement(b,CKEDITOR.END)&&
(g=2),g&&c){e=e.clone();e.moveToElementEditStart(c);if(1==g&&(d.optimize(),!d.startContainer.equals(f))){for(f=d.startContainer;f.is(CKEDITOR.dtd.$inline);)p=f,f=f.getParent();p&&d.moveToPosition(p,CKEDITOR.POSITION_AFTER_END)}2==g&&(d.moveToPosition(d.endPath().block,CKEDITOR.POSITION_BEFORE_END),e.endPath().block&&e.moveToPosition(e.endPath().block,CKEDITOR.POSITION_AFTER_START));D(a,d,e);l.cancel()}}else k.range.setEndAt(h,CKEDITOR.POSITION_BEFORE_END),(c=k.next())&&c.type==CKEDITOR.NODE_ELEMENT&&
c.is(u)&&(c=c.getFirst(t),g.block&&e.checkStartOfBlock()&&e.checkEndOfBlock()?(g.block.remove(),e.moveToElementEditStart(c),e.select()):A(c)?(e.moveToElementEditStart(c),e.select()):(e=e.clone(),e.moveToElementEditStart(c),D(a,d,e)),l.cancel());setTimeout(function(){a.selectionChange(1)})}}}))}})})();(function(){CKEDITOR.plugins.liststyle={requires:"dialog,contextmenu",init:function(a){if(!a.blockless){var b;b=new CKEDITOR.dialogCommand("numberedListStyle",{requiredContent:"ol",allowedContent:"ol{list-style-type}[start]; li{list-style-type}[value]",contentTransformations:[["ol: listTypeToStyle"]]});b=a.addCommand("numberedListStyle",b);a.addFeature(b);CKEDITOR.dialog.add("numberedListStyle",this.path+"dialogs/liststyle.js");b=new CKEDITOR.dialogCommand("bulletedListStyle",{requiredContent:"ul",
allowedContent:"ul{list-style-type}",contentTransformations:[["ul: listTypeToStyle"]]});b=a.addCommand("bulletedListStyle",b);a.addFeature(b);CKEDITOR.dialog.add("bulletedListStyle",this.path+"dialogs/liststyle.js");a.addMenuGroup("list",108);a.addMenuItems({numberedlist:{label:a.lang.liststyle.numberedTitle,group:"list",command:"numberedListStyle"},bulletedlist:{label:a.lang.liststyle.bulletedTitle,group:"list",command:"bulletedListStyle"}});a.contextMenu.addListener(function(a){if(!a||a.isReadOnly())return null;
for(;a;){var b=a.getName();if("ol"==b)return{numberedlist:CKEDITOR.TRISTATE_OFF};if("ul"==b)return{bulletedlist:CKEDITOR.TRISTATE_OFF};a=a.getParent()}return null})}}};CKEDITOR.plugins.add("liststyle",CKEDITOR.plugins.liststyle)})();(function(){function V(a,c,d){return n(c)&&n(d)&&d.equals(c.getNext(function(a){return!(E(a)||F(a)||u(a))}))}function z(a){this.upper=a[0];this.lower=a[1];this.set.apply(this,a.slice(2))}function O(a){var c=a.element;if(c&&n(c)&&(c=c.getAscendant(a.triggers,!0))&&a.editable.contains(c)){var d=P(c);if("true"==d.getAttribute("contenteditable"))return c;if(d.is(a.triggers))return d}return null}function ka(a,c,d){r(a,c);r(a,d);a=c.size.bottom;d=d.size.top;return a&&d?0|(a+d)/2:a||d}function w(a,c,d){return c=
c[d?"getPrevious":"getNext"](function(b){return b&&b.type==CKEDITOR.NODE_TEXT&&!E(b)||n(b)&&!u(b)&&!A(a,b)})}function q(a,c,d){return a>c&&a<d}function P(a,c){if(a.data("cke-editable"))return null;for(c||(a=a.getParent());a&&!a.data("cke-editable");){if(a.hasAttribute("contenteditable"))return a;a=a.getParent()}return null}function la(a){var c=a.doc,d=G('\x3cspan contenteditable\x3d"false" data-cke-magic-line\x3d"1" style\x3d"'+Q+"position:absolute;border-top:1px dashed "+a.boxColor+'"\x3e\x3c/span\x3e',
c),b=CKEDITOR.getUrl(this.path+"images/"+(t.hidpi?"hidpi/":"")+"icon"+(a.rtl?"-rtl":"")+".png");v(d,{attach:function(){this.wrap.getParent()||this.wrap.appendTo(a.editable,!0);return this},lineChildren:[v(G('\x3cspan title\x3d"'+a.editor.lang.magicline.title+'" contenteditable\x3d"false"\x3e\x26#8629;\x3c/span\x3e',c),{base:Q+"height:17px;width:17px;"+(a.rtl?"left":"right")+":17px;background:url("+b+") center no-repeat "+a.boxColor+";cursor:pointer;"+(t.hc?"font-size: 15px;line-height:14px;border:1px solid #fff;text-align:center;":
"")+(t.hidpi?"background-size: 9px 10px;":""),looks:["top:-8px; border-radius: 2px;","top:-17px; border-radius: 2px 2px 0px 0px;","top:-1px; border-radius: 0px 0px 2px 2px;"]}),v(G(W,c),{base:X+"left:0px;border-left-color:"+a.boxColor+";",looks:["border-width:8px 0 8px 8px;top:-8px","border-width:8px 0 0 8px;top:-8px","border-width:0 0 8px 8px;top:0px"]}),v(G(W,c),{base:X+"right:0px;border-right-color:"+a.boxColor+";",looks:["border-width:8px 8px 8px 0;top:-8px","border-width:8px 8px 0 0;top:-8px",
"border-width:0 8px 8px 0;top:0px"]})],detach:function(){this.wrap.getParent()&&this.wrap.remove();return this},mouseNear:function(){r(a,this);var b=a.holdDistance,c=this.size;return c&&q(a.mouse.y,c.top-b,c.bottom+b)&&q(a.mouse.x,c.left-b,c.right+b)?!0:!1},place:function(){var b=a.view,c=a.editable,d=a.trigger,h=d.upper,g=d.lower,l=h||g,p=l.getParent(),m={};this.trigger=d;h&&r(a,h,!0);g&&r(a,g,!0);r(a,p,!0);a.inInlineMode&&H(a,!0);p.equals(c)?(m.left=b.scroll.x,m.right=-b.scroll.x,m.width=""):(m.left=
l.size.left-l.size.margin.left+b.scroll.x-(a.inInlineMode?b.editable.left+b.editable.border.left:0),m.width=l.size.outerWidth+l.size.margin.left+l.size.margin.right+b.scroll.x,m.right="");h&&g?m.top=h.size.margin.bottom===g.size.margin.top?0|h.size.bottom+h.size.margin.bottom/2:h.size.margin.bottom<g.size.margin.top?h.size.bottom+h.size.margin.bottom:h.size.bottom+h.size.margin.bottom-g.size.margin.top:h?g||(m.top=h.size.bottom+h.size.margin.bottom):m.top=g.size.top-g.size.margin.top;d.is(C)||q(m.top,
b.scroll.y-15,b.scroll.y+5)?(m.top=a.inInlineMode?0:b.scroll.y,this.look(C)):d.is(D)||q(m.top,b.pane.bottom-5,b.pane.bottom+15)?(m.top=a.inInlineMode?b.editable.height+b.editable.padding.top+b.editable.padding.bottom:b.pane.bottom-1,this.look(D)):(a.inInlineMode&&(m.top-=b.editable.top+b.editable.border.top),this.look(x));a.inInlineMode&&(m.top--,m.top+=b.editable.scroll.top,m.left+=b.editable.scroll.left);for(var n in m)m[n]=CKEDITOR.tools.cssLength(m[n]);this.setStyles(m)},look:function(a){if(this.oldLook!=
a){for(var b=this.lineChildren.length,c;b--;)(c=this.lineChildren[b]).setAttribute("style",c.base+c.looks[0|a/2]);this.oldLook=a}},wrap:new R("span",a.doc)});for(c=d.lineChildren.length;c--;)d.lineChildren[c].appendTo(d);d.look(x);d.appendTo(d.wrap);d.unselectable();d.lineChildren[0].on("mouseup",function(b){d.detach();S(a,function(b){var c=a.line.trigger;b[c.is(I)?"insertBefore":"insertAfter"](c.is(I)?c.lower:c.upper)},!0);a.editor.focus();t.ie||a.enterMode==CKEDITOR.ENTER_BR||a.hotNode.scrollIntoView();
b.data.preventDefault(!0)});d.on("mousedown",function(a){a.data.preventDefault(!0)});a.line=d}function S(a,c,d){var b=new CKEDITOR.dom.range(a.doc),e=a.editor,f;t.ie&&a.enterMode==CKEDITOR.ENTER_BR?f=a.doc.createText(J):(f=(f=P(a.element,!0))&&f.data("cke-enter-mode")||a.enterMode,f=new R(K[f],a.doc),f.is("br")||a.doc.createText(J).appendTo(f));d&&e.fire("saveSnapshot");c(f);b.moveToPosition(f,CKEDITOR.POSITION_AFTER_START);e.getSelection().selectRanges([b]);a.hotNode=f;d&&e.fire("saveSnapshot")}
function Y(a,c){return{canUndo:!0,modes:{wysiwyg:1},exec:function(){function d(b){var d=t.ie&&9>t.version?" ":J,f=a.hotNode&&a.hotNode.getText()==d&&a.element.equals(a.hotNode)&&a.lastCmdDirection===!!c;S(a,function(d){f&&a.hotNode&&a.hotNode.remove();d[c?"insertAfter":"insertBefore"](b);d.setAttributes({"data-cke-magicline-hot":1,"data-cke-magicline-dir":!!c});a.lastCmdDirection=!!c});t.ie||a.enterMode==CKEDITOR.ENTER_BR||a.hotNode.scrollIntoView();a.line.detach()}return function(b){b=b.getSelection().getStartElement();
var e;b=b.getAscendant(Z,1);if(!aa(a,b)&&b&&!b.equals(a.editable)&&!b.contains(a.editable)){(e=P(b))&&"false"==e.getAttribute("contenteditable")&&(b=e);a.element=b;e=w(a,b,!c);var f;n(e)&&e.is(a.triggers)&&e.is(ma)&&(!w(a,e,!c)||(f=w(a,e,!c))&&n(f)&&f.is(a.triggers))?d(e):(f=O(a,b),n(f)&&(w(a,f,!c)?(b=w(a,f,!c))&&n(b)&&b.is(a.triggers)&&d(f):d(f)))}}}()}}function A(a,c){if(!c||c.type!=CKEDITOR.NODE_ELEMENT||!c.$)return!1;var d=a.line;return d.wrap.equals(c)||d.wrap.contains(c)}function n(a){return a&&
a.type==CKEDITOR.NODE_ELEMENT&&a.$}function u(a){if(!n(a))return!1;var c;(c=ba(a))||(n(a)?(c={left:1,right:1,center:1},c=!(!c[a.getComputedStyle("float")]&&!c[a.getAttribute("align")])):c=!1);return c}function ba(a){return!!{absolute:1,fixed:1}[a.getComputedStyle("position")]}function L(a,c){return n(c)?c.is(a.triggers):null}function aa(a,c){if(!c)return!1;for(var d=c.getParents(1),b=d.length;b--;)for(var e=a.tabuList.length;e--;)if(d[b].hasAttribute(a.tabuList[e]))return!0;return!1}function na(a,
c,d){c=c[d?"getLast":"getFirst"](function(b){return a.isRelevant(b)&&!b.is(oa)});if(!c)return!1;r(a,c);return d?c.size.top>a.mouse.y:c.size.bottom<a.mouse.y}function ca(a){var c=a.editable,d=a.mouse,b=a.view,e=a.triggerOffset;H(a);var f=d.y>(a.inInlineMode?b.editable.top+b.editable.height/2:Math.min(b.editable.height,b.pane.height)/2),c=c[f?"getLast":"getFirst"](function(a){return!(E(a)||F(a))});if(!c)return null;A(a,c)&&(c=a.line.wrap[f?"getPrevious":"getNext"](function(a){return!(E(a)||F(a))}));
if(!n(c)||u(c)||!L(a,c))return null;r(a,c);return!f&&0<=c.size.top&&q(d.y,0,c.size.top+e)?(a=a.inInlineMode||0===b.scroll.y?C:x,new z([null,c,I,M,a])):f&&c.size.bottom<=b.pane.height&&q(d.y,c.size.bottom-e,b.pane.height)?(a=a.inInlineMode||q(c.size.bottom,b.pane.height-e,b.pane.height)?D:x,new z([c,null,da,M,a])):null}function ea(a){var c=a.mouse,d=a.view,b=a.triggerOffset,e=O(a);if(!e)return null;r(a,e);var b=Math.min(b,0|e.size.outerHeight/2),f=[],k,h;if(q(c.y,e.size.top-1,e.size.top+b))h=!1;else if(q(c.y,
e.size.bottom-b,e.size.bottom+1))h=!0;else return null;if(u(e)||na(a,e,h)||e.getParent().is(fa))return null;var g=w(a,e,!h);if(g){if(g&&g.type==CKEDITOR.NODE_TEXT)return null;if(n(g)){if(u(g)||!L(a,g)||g.getParent().is(fa))return null;f=[g,e][h?"reverse":"concat"]().concat([T,M])}}else e.equals(a.editable[h?"getLast":"getFirst"](a.isRelevant))?(H(a),h&&q(c.y,e.size.bottom-b,d.pane.height)&&q(e.size.bottom,d.pane.height-b,d.pane.height)?k=D:q(c.y,0,e.size.top+b)&&(k=C)):k=x,f=[null,e][h?"reverse":
"concat"]().concat([h?da:I,M,k,e.equals(a.editable[h?"getLast":"getFirst"](a.isRelevant))?h?D:C:x]);return 0 in f?new z(f):null}function U(a,c,d,b){for(var e=c.getDocumentPosition(),f={},k={},h={},g={},l=y.length;l--;)f[y[l]]=parseInt(c.getComputedStyle.call(c,"border-"+y[l]+"-width"),10)||0,h[y[l]]=parseInt(c.getComputedStyle.call(c,"padding-"+y[l]),10)||0,k[y[l]]=parseInt(c.getComputedStyle.call(c,"margin-"+y[l]),10)||0;d&&!b||N(a,b);g.top=e.y-(d?0:a.view.scroll.y);g.left=e.x-(d?0:a.view.scroll.x);
g.outerWidth=c.$.offsetWidth;g.outerHeight=c.$.offsetHeight;g.height=g.outerHeight-(h.top+h.bottom+f.top+f.bottom);g.width=g.outerWidth-(h.left+h.right+f.left+f.right);g.bottom=g.top+g.outerHeight;g.right=g.left+g.outerWidth;a.inInlineMode&&(g.scroll={top:c.$.scrollTop,left:c.$.scrollLeft});return v({border:f,padding:h,margin:k,ignoreScroll:d},g,!0)}function r(a,c,d){if(!n(c))return c.size=null;if(!c.size)c.size={};else if(c.size.ignoreScroll==d&&c.size.date>new Date-ga)return null;return v(c.size,
U(a,c,d),{date:+new Date},!0)}function H(a,c){a.view.editable=U(a,a.editable,c,!0)}function N(a,c){a.view||(a.view={});var d=a.view;if(!(!c&&d&&d.date>new Date-ga)){var b=a.win,d=b.getScrollPosition(),b=b.getViewPaneSize();v(a.view,{scroll:{x:d.x,y:d.y,width:a.doc.$.documentElement.scrollWidth-b.width,height:a.doc.$.documentElement.scrollHeight-b.height},pane:{width:b.width,height:b.height,bottom:b.height+d.y},date:+new Date},!0)}}function pa(a,c,d,b){for(var e=b,f=b,k=0,h=!1,g=!1,l=a.view.pane.height,
p=a.mouse;p.y+k<l&&0<p.y-k;){h||(h=c(e,b));g||(g=c(f,b));!h&&0<p.y-k&&(e=d(a,{x:p.x,y:p.y-k}));!g&&p.y+k<l&&(f=d(a,{x:p.x,y:p.y+k}));if(h&&g)break;k+=2}return new z([e,f,null,null])}CKEDITOR.plugins.add("magicline",{init:function(a){var c=a.config,d=c.magicline_triggerOffset||30,b={editor:a,enterMode:c.enterMode,triggerOffset:d,holdDistance:0|d*(c.magicline_holdDistance||.5),boxColor:c.magicline_color||"#ff0000",rtl:"rtl"==c.contentsLangDirection,tabuList:["data-cke-hidden-sel"].concat(c.magicline_tabuList||
[]),triggers:c.magicline_everywhere?Z:{table:1,hr:1,div:1,ul:1,ol:1,dl:1,form:1,blockquote:1}},e,f,k;b.isRelevant=function(a){return n(a)&&!A(b,a)&&!u(a)};a.on("contentDom",function(){var d=a.editable(),g=a.document,l=a.window;v(b,{editable:d,inInlineMode:d.isInline(),doc:g,win:l,hotNode:null},!0);b.boundary=b.inInlineMode?b.editable:b.doc.getDocumentElement();d.is(B.$inline)||(b.inInlineMode&&!ba(d)&&d.setStyles({position:"relative",top:null,left:null}),la.call(this,b),N(b),d.attachListener(a,"beforeUndoImage",
function(){b.line.detach()}),d.attachListener(a,"beforeGetData",function(){b.line.wrap.getParent()&&(b.line.detach(),a.once("getData",function(){b.line.attach()},null,null,1E3))},null,null,0),d.attachListener(b.inInlineMode?g:g.getWindow().getFrame(),"mouseout",function(c){if("wysiwyg"==a.mode)if(b.inInlineMode){var d=c.data.$.clientX;c=c.data.$.clientY;N(b);H(b,!0);var e=b.view.editable,f=b.view.scroll;d>e.left-f.x&&d<e.right-f.x&&c>e.top-f.y&&c<e.bottom-f.y||(clearTimeout(k),k=null,b.line.detach())}else clearTimeout(k),
k=null,b.line.detach()}),d.attachListener(d,"keyup",function(){b.hiddenMode=0}),d.attachListener(d,"keydown",function(c){if("wysiwyg"==a.mode)switch(c.data.getKeystroke()){case 2228240:case 16:b.hiddenMode=1,b.line.detach()}}),d.attachListener(b.inInlineMode?d:g,"mousemove",function(c){f=!0;if("wysiwyg"==a.mode&&!a.readOnly&&!k){var d={x:c.data.$.clientX,y:c.data.$.clientY};k=setTimeout(function(){b.mouse=d;k=b.trigger=null;N(b);f&&!b.hiddenMode&&a.focusManager.hasFocus&&!b.line.mouseNear()&&(b.element=
ha(b,!0))&&((b.trigger=ca(b)||ea(b)||ia(b))&&!aa(b,b.trigger.upper||b.trigger.lower)?b.line.attach().place():(b.trigger=null,b.line.detach()),f=!1)},30)}}),d.attachListener(l,"scroll",function(){"wysiwyg"==a.mode&&(b.line.detach(),t.webkit&&(b.hiddenMode=1,clearTimeout(e),e=setTimeout(function(){b.mouseDown||(b.hiddenMode=0)},50)))}),d.attachListener(ja?g:l,"mousedown",function(){"wysiwyg"==a.mode&&(b.line.detach(),b.hiddenMode=1,b.mouseDown=1)}),d.attachListener(ja?g:l,"mouseup",function(){b.hiddenMode=
0;b.mouseDown=0}),a.addCommand("accessPreviousSpace",Y(b)),a.addCommand("accessNextSpace",Y(b,!0)),a.setKeystroke([[c.magicline_keystrokePrevious,"accessPreviousSpace"],[c.magicline_keystrokeNext,"accessNextSpace"]]),a.on("loadSnapshot",function(){var c,d,e,f;for(f in{p:1,br:1,div:1})for(c=a.document.getElementsByTag(f),e=c.count();e--;)if((d=c.getItem(e)).data("cke-magicline-hot")){b.hotNode=d;b.lastCmdDirection="true"===d.data("cke-magicline-dir")?!0:!1;return}}),a._.magiclineBackdoor={accessFocusSpace:S,
boxTrigger:z,isLine:A,getAscendantTrigger:O,getNonEmptyNeighbour:w,getSize:U,that:b,triggerEdge:ea,triggerEditable:ca,triggerExpand:ia})},this)}});var v=CKEDITOR.tools.extend,R=CKEDITOR.dom.element,G=R.createFromHtml,t=CKEDITOR.env,ja=CKEDITOR.env.ie&&9>CKEDITOR.env.version,B=CKEDITOR.dtd,K={},I=128,da=64,T=32,M=16,C=4,D=2,x=1,J=" ",fa=B.$listItem,oa=B.$tableContent,ma=v({},B.$nonEditable,B.$empty),Z=B.$block,ga=100,Q="width:0px;height:0px;padding:0px;margin:0px;display:block;z-index:9999;color:#fff;position:absolute;font-size: 0px;line-height:0px;",
X=Q+"border-color:transparent;display:block;border-style:solid;",W="\x3cspan\x3e"+J+"\x3c/span\x3e";K[CKEDITOR.ENTER_BR]="br";K[CKEDITOR.ENTER_P]="p";K[CKEDITOR.ENTER_DIV]="div";z.prototype={set:function(a,c,d){this.properties=a+c+(d||x);return this},is:function(a){return(this.properties&a)==a}};var ha=function(){function a(a,d){var b=a.$.elementFromPoint(d.x,d.y);return b&&b.nodeType?new CKEDITOR.dom.element(b):null}return function(c,d,b){if(!c.mouse)return null;var e=c.doc,f=c.line.wrap;b=b||c.mouse;
var k=a(e,b);d&&A(c,k)&&(f.hide(),k=a(e,b),f.show());return!k||k.type!=CKEDITOR.NODE_ELEMENT||!k.$||t.ie&&9>t.version&&!c.boundary.equals(k)&&!c.boundary.contains(k)?null:k}}(),E=CKEDITOR.dom.walker.whitespaces(),F=CKEDITOR.dom.walker.nodeType(CKEDITOR.NODE_COMMENT),ia=function(){function a(a){var b=a.element,e,f,k;if(!n(b)||b.contains(a.editable)||b.isReadOnly())return null;k=pa(a,function(a,b){return!b.equals(a)},function(a,b){return ha(a,!0,b)},b);e=k.upper;f=k.lower;if(V(a,e,f))return k.set(T,
8);if(e&&b.contains(e))for(;!e.getParent().equals(b);)e=e.getParent();else e=b.getFirst(function(b){return c(a,b)});if(f&&b.contains(f))for(;!f.getParent().equals(b);)f=f.getParent();else f=b.getLast(function(b){return c(a,b)});if(!e||!f)return null;r(a,e);r(a,f);if(!q(a.mouse.y,e.size.top,f.size.bottom))return null;for(var b=Number.MAX_VALUE,h,g,l,p;f&&!f.equals(e)&&(g=e.getNext(a.isRelevant));)h=Math.abs(ka(a,e,g)-a.mouse.y),h<b&&(b=h,l=e,p=g),e=g,r(a,e);if(!l||!p||!q(a.mouse.y,l.size.top,p.size.bottom))return null;
k.upper=l;k.lower=p;return k.set(T,8)}function c(a,b){return!(b&&b.type==CKEDITOR.NODE_TEXT||F(b)||u(b)||A(a,b)||b.type==CKEDITOR.NODE_ELEMENT&&b.$&&b.is("br"))}return function(c){var b=a(c),e;if(e=b){e=b.upper;var f=b.lower;e=!e||!f||u(f)||u(e)||f.equals(e)||e.equals(f)||f.contains(e)||e.contains(f)?!1:L(c,e)&&L(c,f)&&V(c,e,f)?!0:!1}return e?b:null}}(),y=["top","left","right","bottom"]})();CKEDITOR.config.magicline_keystrokePrevious=CKEDITOR.CTRL+CKEDITOR.SHIFT+51;
CKEDITOR.config.magicline_keystrokeNext=CKEDITOR.CTRL+CKEDITOR.SHIFT+52;(function(){function n(a){if(!a||a.type!=CKEDITOR.NODE_ELEMENT||"form"!=a.getName())return[];for(var e=[],f=["style","className"],b=0;b<f.length;b++){var c=a.$.elements.namedItem(f[b]);c&&(c=new CKEDITOR.dom.element(c),e.push([c,c.nextSibling]),c.remove())}return e}function t(a,e){if(a&&a.type==CKEDITOR.NODE_ELEMENT&&"form"==a.getName()&&0<e.length)for(var f=e.length-1;0<=f;f--){var b=e[f][0],c=e[f][1];c?b.insertBefore(c):b.appendTo(a)}}function r(a,e){var f=n(a),b={},c=a.$;e||(b["class"]=c.className||
"",c.className="");b.inline=c.style.cssText||"";e||(c.style.cssText="position: static; overflow: visible");t(f);return b}function u(a,e){var f=n(a),b=a.$;"class"in e&&(b.className=e["class"]);"inline"in e&&(b.style.cssText=e.inline);t(f)}function v(a){if(!a.editable().isInline()){var e=CKEDITOR.instances,f;for(f in e){var b=e[f];"wysiwyg"!=b.mode||b.readOnly||(b=b.document.getBody(),b.setAttribute("contentEditable",!1),b.setAttribute("contentEditable",!0))}a.editable().hasFocus&&(a.toolbox.focus(),
a.focus())}}CKEDITOR.plugins.add("maximize",{init:function(a){function e(){var b=c.getViewPaneSize();a.resize(b.width,b.height,null,!0)}if(a.elementMode!=CKEDITOR.ELEMENT_MODE_INLINE){var f=a.lang,b=CKEDITOR.document,c=b.getWindow(),l,m,p,n=CKEDITOR.TRISTATE_OFF;a.addCommand("maximize",{modes:{wysiwyg:!CKEDITOR.env.iOS,source:!CKEDITOR.env.iOS},readOnly:1,editorFocus:!1,exec:function(){var h=a.container.getFirst(function(a){return a.type==CKEDITOR.NODE_ELEMENT&&a.hasClass("cke_inner")}),g=a.ui.space("contents");
if("wysiwyg"==a.mode){var d=a.getSelection();l=d&&d.getRanges();m=c.getScrollPosition()}else{var k=a.editable().$;l=!CKEDITOR.env.ie&&[k.selectionStart,k.selectionEnd];m=[k.scrollLeft,k.scrollTop]}if(this.state==CKEDITOR.TRISTATE_OFF){c.on("resize",e);p=c.getScrollPosition();for(d=a.container;d=d.getParent();)d.setCustomData("maximize_saved_styles",r(d)),d.setStyle("z-index",a.config.baseFloatZIndex-5);g.setCustomData("maximize_saved_styles",r(g,!0));h.setCustomData("maximize_saved_styles",r(h,!0));
g={overflow:CKEDITOR.env.webkit?"":"hidden",width:0,height:0};b.getDocumentElement().setStyles(g);!CKEDITOR.env.gecko&&b.getDocumentElement().setStyle("position","fixed");CKEDITOR.env.gecko&&CKEDITOR.env.quirks||b.getBody().setStyles(g);CKEDITOR.env.ie?setTimeout(function(){c.$.scrollTo(0,0)},0):c.$.scrollTo(0,0);h.setStyle("position",CKEDITOR.env.gecko&&CKEDITOR.env.quirks?"fixed":"absolute");h.$.offsetLeft;h.setStyles({"z-index":a.config.baseFloatZIndex-5,left:"0px",top:"0px"});h.addClass("cke_maximized");
e();g=h.getDocumentPosition();h.setStyles({left:-1*g.x+"px",top:-1*g.y+"px"});CKEDITOR.env.gecko&&v(a)}else if(this.state==CKEDITOR.TRISTATE_ON){c.removeListener("resize",e);for(var d=[g,h],q=0;q<d.length;q++)u(d[q],d[q].getCustomData("maximize_saved_styles")),d[q].removeCustomData("maximize_saved_styles");for(d=a.container;d=d.getParent();)u(d,d.getCustomData("maximize_saved_styles")),d.removeCustomData("maximize_saved_styles");CKEDITOR.env.ie?setTimeout(function(){c.$.scrollTo(p.x,p.y)},0):c.$.scrollTo(p.x,
p.y);h.removeClass("cke_maximized");CKEDITOR.env.webkit&&(h.setStyle("display","inline"),setTimeout(function(){h.setStyle("display","block")},0));a.fire("resize",{outerHeight:a.container.$.offsetHeight,contentsHeight:g.$.offsetHeight,outerWidth:a.container.$.offsetWidth})}this.toggleState();if(d=this.uiItems[0])g=this.state==CKEDITOR.TRISTATE_OFF?f.maximize.maximize:f.maximize.minimize,d=CKEDITOR.document.getById(d._.id),d.getChild(1).setHtml(g),d.setAttribute("title",g),d.setAttribute("href",'javascript:void("'+
g+'");');"wysiwyg"==a.mode?l?(CKEDITOR.env.gecko&&v(a),a.getSelection().selectRanges(l),(k=a.getSelection().getStartElement())&&k.scrollIntoView(!0)):c.$.scrollTo(m.x,m.y):(l&&(k.selectionStart=l[0],k.selectionEnd=l[1]),k.scrollLeft=m[0],k.scrollTop=m[1]);l=m=null;n=this.state;a.fire("maximize",this.state)},canUndo:!1});a.ui.addButton&&a.ui.addButton("Maximize",{label:f.maximize.maximize,command:"maximize",toolbar:"tools,10"});a.on("mode",function(){var b=a.getCommand("maximize");b.setState(b.state==
CKEDITOR.TRISTATE_DISABLED?CKEDITOR.TRISTATE_DISABLED:n)},null,null,100)}}})})();CKEDITOR.plugins.add("newpage",{init:function(a){a.addCommand("newpage",{modes:{wysiwyg:1,source:1},exec:function(b){var a=this;b.setData(b.config.newpage_html||"",function(){b.focus();setTimeout(function(){b.fire("afterCommandExec",{name:"newpage",command:a});b.selectionChange()},200)})},async:!0});a.ui.addButton&&a.ui.addButton("NewPage",{label:a.lang.newpage.toolbar,command:"newpage",toolbar:"document,20"})}});(function(){function e(a){return{"aria-label":a,"class":"cke_pagebreak",contenteditable:"false","data-cke-display-name":"pagebreak","data-cke-pagebreak":1,style:"page-break-after: always",title:a}}CKEDITOR.plugins.add("pagebreak",{requires:"fakeobjects",onLoad:function(){var a=("background:url("+CKEDITOR.getUrl(this.path+"images/pagebreak.gif")+") no-repeat center center;clear:both;width:100%;border-top:#999 1px dotted;border-bottom:#999 1px dotted;padding:0;height:7px;cursor:default;").replace(/;/g,
" !important;");CKEDITOR.addCss("div.cke_pagebreak{"+a+"}")},init:function(a){a.blockless||(a.addCommand("pagebreak",CKEDITOR.plugins.pagebreakCmd),a.ui.addButton&&a.ui.addButton("PageBreak",{label:a.lang.pagebreak.toolbar,command:"pagebreak",toolbar:"insert,70"}),CKEDITOR.env.webkit&&a.on("contentDom",function(){a.document.on("click",function(c){c=c.data.getTarget();c.is("div")&&c.hasClass("cke_pagebreak")&&a.getSelection().selectElement(c)})}))},afterInit:function(a){function c(f){CKEDITOR.tools.extend(f.attributes,
e(a.lang.pagebreak.alt),!0);f.children.length=0}var b=a.dataProcessor,g=b&&b.dataFilter,b=b&&b.htmlFilter,h=/page-break-after\s*:\s*always/i,k=/display\s*:\s*none/i;b&&b.addRules({attributes:{"class":function(a,c){var b=a.replace("cke_pagebreak","");if(b!=a){var d=CKEDITOR.htmlParser.fragment.fromHtml('\x3cspan style\x3d"display: none;"\x3e\x26nbsp;\x3c/span\x3e').children[0];c.children.length=0;c.add(d);d=c.attributes;delete d["aria-label"];delete d.contenteditable;delete d.title}return b}}},{applyToAll:!0,
priority:5});g&&g.addRules({elements:{div:function(a){if(a.attributes["data-cke-pagebreak"])c(a);else if(h.test(a.attributes.style)){var b=a.children[0];b&&"span"==b.name&&k.test(b.attributes.style)&&c(a)}}}})}});CKEDITOR.plugins.pagebreakCmd={exec:function(a){a.insertElement(CKEDITOR.plugins.pagebreak.createElement(a))},context:"div",allowedContent:{div:{styles:"!page-break-after"},span:{match:function(a){return(a=a.parent)&&"div"==a.name&&a.styles&&a.styles["page-break-after"]},styles:"display"}},
requiredContent:"div{page-break-after}"};CKEDITOR.plugins.pagebreak={createElement:function(a){return a.document.createElement("div",{attributes:e(a.lang.pagebreak.alt)})}}})();(function(){var f={canUndo:!1,async:!0,exec:function(a,b){var c=a.lang,e=CKEDITOR.tools.keystrokeToString(c.common.keyboard,a.getCommandKeystroke(CKEDITOR.env.ie?a.commands.paste:this)),d=b&&"undefined"!==typeof b.notification?b.notification:!b||!b.from||"keystrokeHandler"===b.from&&CKEDITOR.env.ie,c=d&&"string"===typeof d?d:c.pastetext.pasteNotification.replace(/%1/,'\x3ckbd aria-label\x3d"'+e.aria+'"\x3e'+e.display+"\x3c/kbd\x3e");a.execCommand("paste",{type:"text",notification:d?c:!1})}};CKEDITOR.plugins.add("pastetext",
{requires:"clipboard",init:function(a){var b=CKEDITOR.env.safari?CKEDITOR.CTRL+CKEDITOR.ALT+CKEDITOR.SHIFT+86:CKEDITOR.CTRL+CKEDITOR.SHIFT+86;a.addCommand("pastetext",f);a.setKeystroke(b,"pastetext");CKEDITOR.plugins.clipboard.addPasteButton(a,"PasteText",{label:a.lang.pastetext.button,command:"pastetext",toolbar:"clipboard,40"});if(a.config.forcePasteAsPlainText)a.on("beforePaste",function(a){"html"!=a.data.type&&(a.data.type="text")});a.on("pasteState",function(b){a.getCommand("pastetext").setState(b.data)})}})})();(function(){CKEDITOR.plugins.add("xml",{});CKEDITOR.xml=function(c){var a=null;if("object"==typeof c)a=c;else if(c=(c||"").replace(/&nbsp;/g," "),"ActiveXObject"in window){try{a=new ActiveXObject("MSXML2.DOMDocument")}catch(b){try{a=new ActiveXObject("Microsoft.XmlDom")}catch(d){}}a&&(a.async=!1,a.resolveExternals=!1,a.validateOnParse=!1,a.loadXML(c))}else window.DOMParser&&(a=(new DOMParser).parseFromString(c,"text/xml"));this.baseXml=a};CKEDITOR.xml.prototype={selectSingleNode:function(c,a){var b=
this.baseXml;if(a||(a=b)){if("selectSingleNode"in a)return a.selectSingleNode(c);if(b.evaluate)return(b=b.evaluate(c,a,null,9,null))&&b.singleNodeValue||null}return null},selectNodes:function(c,a){var b=this.baseXml,d=[];if(a||(a=b)){if("selectNodes"in a)return a.selectNodes(c);if(b.evaluate&&(b=b.evaluate(c,a,null,5,null)))for(var e;e=b.iterateNext();)d.push(e)}return d},getInnerXml:function(c,a){var b=this.selectSingleNode(c,a),d=[];if(b)for(b=b.firstChild;b;)b.xml?d.push(b.xml):window.XMLSerializer&&
d.push((new XMLSerializer).serializeToString(b)),b=b.nextSibling;return d.length?d.join(""):null}}})();(function(){CKEDITOR.plugins.add("ajax",{requires:"xml"});CKEDITOR.ajax=function(){function k(){if(!CKEDITOR.env.ie||"file:"!=location.protocol)try{return new XMLHttpRequest}catch(a){}try{return new ActiveXObject("Msxml2.XMLHTTP")}catch(b){}try{return new ActiveXObject("Microsoft.XMLHTTP")}catch(c){}return null}function h(a,b){if(4!=a.readyState||!(200<=a.status&&300>a.status||304==a.status||0===a.status||1223==a.status))return null;switch(b){case "text":return a.responseText;case "xml":var c=a.responseXML;
return new CKEDITOR.xml(c&&c.firstChild?c:a.responseText);case "arraybuffer":return a.response;default:return null}}function g(a,b,c){var e=!!b,d=k();if(!d)return null;e&&"text"!==c&&"xml"!==c&&(d.responseType=c);d.open("GET",a,e);e&&(d.onreadystatechange=function(){4==d.readyState&&(b(h(d,c)),d=null)});d.send(null);return e?"":h(d,c)}function l(a,b,c,e,d){var f=k();if(!f)return null;f.open("POST",a,!0);f.onreadystatechange=function(){4==f.readyState&&(e&&e(h(f,d)),f=null)};f.setRequestHeader("Content-type",
c||"application/x-www-form-urlencoded; charset\x3dUTF-8");f.send(b)}return{load:function(a,b,c){return g(a,b,c||"text")},post:function(a,b,c,e){return l(a,b,c,e,"text")},loadXml:function(a,b){return g(a,b,"xml")},loadText:function(a,b){return g(a,b,"text")},loadBinary:function(a,b){return g(a,b,"arraybuffer")}}}()})();(function(){function n(a,b){return CKEDITOR.tools.array.filter(a,function(a){return a.canHandle(b)}).sort(function(a,c){return a.priority===c.priority?0:a.priority-c.priority})}function k(a,b){var d=a.shift();d&&d.handle(b,function(){k(a,b)})}function p(a){var b=CKEDITOR.tools.array.reduce(a,function(a,c){return CKEDITOR.tools.array.isArray(c.filters)?a.concat(c.filters):a},[]);return CKEDITOR.tools.array.filter(b,function(a,c){return CKEDITOR.tools.array.indexOf(b,a)===c})}function l(a,b){var d=
0,c,e;if(!CKEDITOR.tools.array.isArray(a)||0===a.length)return!0;c=CKEDITOR.tools.array.filter(a,function(a){return-1===CKEDITOR.tools.array.indexOf(m,a)});if(0<c.length)for(e=0;e<c.length;e++)(function(a){CKEDITOR.scriptLoader.queue(a,function(e){e&&m.push(a);++d===c.length&&b()})})(c[e]);return 0===c.length}var m=[],q=CKEDITOR.tools.createClass({$:function(){this.handlers=[]},proto:{register:function(a){"number"!==typeof a.priority&&(a.priority=10);this.handlers.push(a)},addPasteListener:function(a){a.on("paste",
function(b){var d=n(this.handlers,b),c;if(0!==d.length){c=p(d);c=l(c,function(){return a.fire("paste",b.data)});if(!c)return b.cancel();k(d,b)}},this,null,3)}}});CKEDITOR.plugins.add("pastetools",{requires:["clipboard","ajax"],beforeInit:function(a){a.pasteTools=new q;a.pasteTools.addPasteListener(a)}});CKEDITOR.plugins.pastetools={filters:{},loadFilters:l,createFilter:function(a){var b=CKEDITOR.tools.array.isArray(a.rules)?a.rules:[a.rules],d=a.additionalTransforms;return function(a,e){var f=new CKEDITOR.htmlParser.basicWriter,
g=new CKEDITOR.htmlParser.filter,h;d&&(a=d(a,e));CKEDITOR.tools.array.forEach(b,function(b){g.addRules(b(a,e,g))});h=CKEDITOR.htmlParser.fragment.fromHtml(a);g.applyTo(h);h.writeHtml(f);return f.getHtml()}},getClipboardData:function(a,b){var d;return CKEDITOR.plugins.clipboard.isCustomDataTypesSupported||"text/html"===b?(d=a.dataTransfer.getData(b,!0))||"text/html"!==b?d:a.dataValue:null},getConfigValue:function(a,b){if(a&&a.config){var d=CKEDITOR.tools,c=a.config,e=d.object.keys(c),f=["pasteTools_"+
b,"pasteFromWord_"+b,"pasteFromWord"+d.capitalize(b,!0)],f=d.array.find(f,function(a){return-1!==d.array.indexOf(e,a)});return c[f]}},getContentGeneratorName:function(a){if((a=/<meta\s+name=["']?generator["']?\s+content=["']?(\w+)/gi.exec(a))&&a.length)return a=a[1].toLowerCase(),0===a.indexOf("microsoft")?"microsoft":0===a.indexOf("libreoffice")?"libreoffice":"unknown"}};CKEDITOR.pasteFilters=CKEDITOR.plugins.pastetools.filters})();(function(){CKEDITOR.plugins.add("pastefromgdocs",{requires:"pastetools",init:function(a){var c=CKEDITOR.plugins.getPath("pastetools"),d=this.path;a.pasteTools.register({filters:[CKEDITOR.getUrl(c+"filter/common.js"),CKEDITOR.getUrl(d+"filter/default.js")],canHandle:function(a){return/id=(\"|\')?docs\-internal\-guid\-/.test(a.data.dataValue)},handle:function(c,d){var b=c.data,e=CKEDITOR.plugins.pastetools.getClipboardData(b,"text/html");b.dontFilter=!0;b.dataValue=CKEDITOR.pasteFilters.gdocs(e,a);
!0===a.config.forcePasteAsPlainText&&(b.type="text");d()}})}})})();(function(){CKEDITOR.plugins.add("pastefromlibreoffice",{requires:"pastetools",isSupportedEnvironment:function(){var b=CKEDITOR.env.ie&&11>=CKEDITOR.env.version;return!(CKEDITOR.env.webkit&&!CKEDITOR.env.chrome)&&!b},init:function(b){if(this.isSupportedEnvironment()){var d=CKEDITOR.plugins.getPath("pastetools"),f=this.path;b.pasteTools.register({priority:100,filters:[CKEDITOR.getUrl(d+"filter/common.js"),CKEDITOR.getUrl(d+"filter/image.js"),CKEDITOR.getUrl(f+"filter/default.js")],canHandle:function(a){a=
a.data;return(a=a.dataTransfer.getData("text/html",!0)||a.dataValue)?"libreoffice"===CKEDITOR.plugins.pastetools.getContentGeneratorName(a):!1},handle:function(a,d){var c=a.data,e=c.dataValue||CKEDITOR.plugins.pastetools.getClipboardData(c,"text/html");c.dontFilter=!0;e=CKEDITOR.pasteFilters.image(e,b,CKEDITOR.plugins.pastetools.getClipboardData(c,"text/rtf"));c.dataValue=CKEDITOR.pasteFilters.libreoffice(e,b);!0===b.config.forcePasteAsPlainText&&(c.type="text");d()}})}}})})();(function(){CKEDITOR.plugins.add("pastefromword",{requires:"pastetools",init:function(a){var f=0,e=CKEDITOR.plugins.getPath("pastetools"),h=this.path,k=void 0===a.config.pasteFromWord_inlineImages?!0:a.config.pasteFromWord_inlineImages,e=[CKEDITOR.getUrl(e+"filter/common.js"),CKEDITOR.getUrl(e+"filter/image.js"),CKEDITOR.getUrl(h+"filter/default.js")];a.addCommand("pastefromword",{canUndo:!1,async:!0,exec:function(a,b){f=1;a.execCommand("paste",{type:"html",notification:b&&"undefined"!==typeof b.notification?
b.notification:!0})}});CKEDITOR.plugins.clipboard.addPasteButton(a,"PasteFromWord",{label:a.lang.pastefromword.toolbar,command:"pastefromword",toolbar:"clipboard,50"});a.pasteTools.register({filters:a.config.pasteFromWordCleanupFile?[a.config.pasteFromWordCleanupFile]:e,canHandle:function(a){a=CKEDITOR.plugins.pastetools.getClipboardData(a.data,"text/html");var b=CKEDITOR.plugins.pastetools.getContentGeneratorName(a),d=/(class="?Mso|style=["'][^"]*?\bmso\-|w:WordDocument|<o:\w+>|<\/font>)/,b=b?"microsoft"===
b:d.test(a);return a&&(f||b)},handle:function(e,b){var d=e.data,c=CKEDITOR.plugins.pastetools.getClipboardData(d,"text/html"),g=CKEDITOR.plugins.pastetools.getClipboardData(d,"text/rtf"),c={dataValue:c,dataTransfer:{"text/rtf":g}};if(!1!==a.fire("pasteFromWord",c)||f){d.dontFilter=!0;if(f||!a.config.pasteFromWordPromptCleanup||confirm(a.lang.pastefromword.confirmCleanup))c.dataValue=CKEDITOR.cleanWord(c.dataValue,a),CKEDITOR.plugins.clipboard.isCustomDataTypesSupported&&k&&CKEDITOR.pasteFilters.image&&
(c.dataValue=CKEDITOR.pasteFilters.image(c.dataValue,a,g)),a.fire("afterPasteFromWord",c),d.dataValue=c.dataValue,!0===a.config.forcePasteAsPlainText?d.type="text":CKEDITOR.plugins.clipboard.isCustomCopyCutSupported||"allow-word"!==a.config.forcePasteAsPlainText||(d.type="html");f=0;b()}}})}})})();(function(){function h(a){var e=CKEDITOR.plugins.getPath("preview"),d=a.config,g=a.lang.preview.preview,f=function(){var a=location.origin,b=location.pathname;if(!d.baseHref&&!CKEDITOR.env.gecko)return"";if(d.baseHref)return'\x3cbase href\x3d"{HREF}"\x3e'.replace("{HREF}",d.baseHref);b=b.split("/");b.pop();b=b.join("/");return'\x3cbase href\x3d"{HREF}"\x3e'.replace("{HREF}",a+b+"/")}();return d.fullPage?a.getData().replace(/<head>/,"$\x26"+f).replace(/[^>]*(?=<\/title>)/,"$\x26 \x26mdash; "+g):d.docType+
'\x3chtml dir\x3d"'+d.contentsLangDirection+'"\x3e\x3chead\x3e'+f+"\x3ctitle\x3e"+g+"\x3c/title\x3e"+CKEDITOR.tools.buildStyleHtml(d.contentsCss)+'\x3clink rel\x3d"stylesheet" media\x3d"screen" href\x3d"'+e+'styles/screen.css"\x3e\x3c/head\x3e'+function(){var c="\x3cbody\x3e",b=a.document&&a.document.getBody();if(!b)return c;b.getAttribute("id")&&(c=c.replace("\x3e",' id\x3d"'+b.getAttribute("id")+'"\x3e'));b.getAttribute("class")&&(c=c.replace("\x3e",' class\x3d"'+b.getAttribute("class")+'"\x3e'));
return c}()+a.getData()+"\x3c/body\x3e\x3c/html\x3e"}CKEDITOR.plugins.add("preview",{init:function(a){a.addCommand("preview",{modes:{wysiwyg:1},canUndo:!1,readOnly:1,exec:CKEDITOR.plugins.preview.createPreview});a.ui.addButton&&a.ui.addButton("Preview",{label:a.lang.preview.preview,command:"preview",toolbar:"document,40"})}});CKEDITOR.plugins.preview={createPreview:function(a){var e,d,g,f={dataValue:h(a)},c=window.screen;e=Math.round(.8*c.width);d=Math.round(.7*c.height);g=Math.round(.1*c.width);
c=CKEDITOR.env.ie?"javascript:void( (function(){document.open();"+("("+CKEDITOR.tools.fixDomain+")();").replace(/\/\/.*?\n/g,"").replace(/parent\./g,"window.opener.")+"document.write( window.opener._cke_htmlToLoad );document.close();window.opener._cke_htmlToLoad \x3d null;})() )":null;var b;b=CKEDITOR.plugins.getPath("preview");b=CKEDITOR.env.gecko?CKEDITOR.getUrl(b+"preview.html"):"";if(!1===a.fire("contentPreview",f))return!1;if(c||b)window._cke_htmlToLoad=f.dataValue;a=window.open(b,null,["toolbar\x3dyes,location\x3dno,status\x3dyes,menubar\x3dyes,scrollbars\x3dyes,resizable\x3dyes",
"width\x3d"+e,"height\x3d"+d,"left\x3d"+g].join());c&&a&&(a.location=c);window._cke_htmlToLoad||(e=a.document,e.open(),e.write(f.dataValue),e.close());return new CKEDITOR.dom.window(a)}}})();(function(){CKEDITOR.plugins.add("print",{requires:"preview",init:function(a){a.addCommand("print",CKEDITOR.plugins.print);a.ui.addButton&&a.ui.addButton("Print",{label:a.lang.print.toolbar,command:"print",toolbar:"document,50"})}});CKEDITOR.plugins.print={exec:function(a){function c(){CKEDITOR.env.gecko?b.print():b.document.execCommand("Print");b.close()}a=CKEDITOR.plugins.preview.createPreview(a);var b;if(a){b=a.$;if("complete"===b.document.readyState)return c();a.once("load",c)}},canUndo:!1,readOnly:1,
modes:{wysiwyg:1}}})();CKEDITOR.plugins.add("removeformat",{init:function(a){a.addCommand("removeFormat",CKEDITOR.plugins.removeformat.commands.removeformat);a.ui.addButton&&a.ui.addButton("RemoveFormat",{label:a.lang.removeformat.toolbar,command:"removeFormat",toolbar:"cleanup,10"})}});
CKEDITOR.plugins.removeformat={commands:{removeformat:{exec:function(a){for(var h=a._.removeFormatRegex||(a._.removeFormatRegex=new RegExp("^(?:"+a.config.removeFormatTags.replace(/,/g,"|")+")$","i")),c=a._.removeAttributes||(a._.removeAttributes=a.config.removeFormatAttributes.split(",")),e=CKEDITOR.plugins.removeformat.filter,m=a.getSelection().getRanges(),n=m.createIterator(),p=function(a){return a.type==CKEDITOR.NODE_ELEMENT},f;f=n.getNextRange();){f.enlarge(CKEDITOR.ENLARGE_INLINE);var l=f.createBookmark(),
b=l.startNode,d=l.endNode,k=function(b){for(var c=a.elementPath(b),f=c.elements,d=1,g;(g=f[d])&&!g.equals(c.block)&&!g.equals(c.blockLimit);d++)h.test(g.getName())&&e(a,g)&&b.breakParent(g)};k(b);if(d)for(k(d),b=b.getNextSourceNode(!0,CKEDITOR.NODE_ELEMENT);b&&!b.equals(d);)if(b.isReadOnly()){if(b.getPosition(d)&CKEDITOR.POSITION_CONTAINS)break;b=b.getNext(p)}else k=b.getNextSourceNode(!1,CKEDITOR.NODE_ELEMENT),"img"==b.getName()&&b.data("cke-realelement")||!e(a,b)||(h.test(b.getName())?b.remove(1):
(b.removeAttributes(c),a.fire("removeFormatCleanup",b))),b=k;f.moveToBookmark(l)}a.forceNextSelectionCheck();a.getSelection().selectRanges(m)}}},filter:function(a,h){for(var c=a._.removeFormatFilters||[],e=0;e<c.length;e++)if(!1===c[e](h))return!1;return!0}};CKEDITOR.editor.prototype.addRemoveFormatFilter=function(a){this._.removeFormatFilters||(this._.removeFormatFilters=[]);this._.removeFormatFilters.push(a)};CKEDITOR.config.removeFormatTags="b,big,cite,code,del,dfn,em,font,i,ins,kbd,q,s,samp,small,span,strike,strong,sub,sup,tt,u,var";
CKEDITOR.config.removeFormatAttributes="class,style,lang,width,height,align,hspace,valign";(function(){var b={readOnly:1,modes:{wysiwyg:1,source:1},exec:function(a){if(a.fire("save")&&(a=a.element.$.form))try{a.submit()}catch(b){a.submit.click&&a.submit.click()}}};CKEDITOR.plugins.add("save",{init:function(a){a.elementMode==CKEDITOR.ELEMENT_MODE_REPLACE&&(a.addCommand("save",b).startDisabled=!a.element.$.form,a.ui.addButton&&a.ui.addButton("Save",{label:a.lang.save.toolbar,command:"save",toolbar:"document,10"}))}})})();(function(){CKEDITOR.plugins.add("selectall",{init:function(b){b.addCommand("selectAll",{modes:{wysiwyg:1,source:1},exec:function(a){var b=a.editable();if(b.is("textarea"))a=b.$,CKEDITOR.env.ie&&a.createTextRange?a.createTextRange().execCommand("SelectAll"):(a.selectionStart=0,a.selectionEnd=a.value.length),a.focus();else{if(b.is("body"))a.document.$.execCommand("SelectAll",!1,null);else{var c=a.createRange();c.selectNodeContents(b);c.select()}a.forceNextSelectionCheck();a.selectionChange()}},canUndo:!1});
b.ui.addButton&&b.ui.addButton("SelectAll",{label:b.lang.selectall.toolbar,command:"selectAll",toolbar:"selection,10"})}})})();(function(){var k={readOnly:1,preserveState:!0,editorFocus:!1,exec:function(a){this.toggleState();this.refresh(a)},refresh:function(a){if(a.document){var c=this.state!=CKEDITOR.TRISTATE_ON||a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE&&!a.focusManager.hasFocus?"removeClass":"attachClass";a.editable()[c]("cke_show_blocks")}}};CKEDITOR.plugins.add("showblocks",{onLoad:function(){var a="p div pre address blockquote h1 h2 h3 h4 h5 h6".split(" "),c,b,e,f,k=CKEDITOR.getUrl(this.path),l=!(CKEDITOR.env.ie&&
9>CKEDITOR.env.version),g=l?":not([contenteditable\x3dfalse]):not(.cke_show_blocks_off)":"",d,h;for(c=b=e=f="";d=a.pop();)h=a.length?",":"",c+=".cke_show_blocks "+d+g+h,e+=".cke_show_blocks.cke_contents_ltr "+d+g+h,f+=".cke_show_blocks.cke_contents_rtl "+d+g+h,b+=".cke_show_blocks "+d+g+"{background-image:url("+CKEDITOR.getUrl(k+"images/block_"+d+".png")+")}";CKEDITOR.addCss((c+"{background-repeat:no-repeat;border:1px dotted gray;padding-top:8px}").concat(b,e+"{background-position:top left;padding-left:8px}",
f+"{background-position:top right;padding-right:8px}"));l||CKEDITOR.addCss(".cke_show_blocks [contenteditable\x3dfalse],.cke_show_blocks .cke_show_blocks_off{border:none;padding-top:0;background-image:none}.cke_show_blocks.cke_contents_rtl [contenteditable\x3dfalse],.cke_show_blocks.cke_contents_rtl .cke_show_blocks_off{padding-right:0}.cke_show_blocks.cke_contents_ltr [contenteditable\x3dfalse],.cke_show_blocks.cke_contents_ltr .cke_show_blocks_off{padding-left:0}")},init:function(a){function c(){b.refresh(a)}
if(!a.blockless){var b=a.addCommand("showblocks",k);b.canUndo=!1;a.config.startupOutlineBlocks&&b.setState(CKEDITOR.TRISTATE_ON);a.ui.addButton&&a.ui.addButton("ShowBlocks",{label:a.lang.showblocks.toolbar,command:"showblocks",toolbar:"tools,20"});a.on("mode",function(){b.state!=CKEDITOR.TRISTATE_DISABLED&&b.refresh(a)});a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE&&(a.on("focus",c),a.on("blur",c));a.on("contentDom",function(){b.state!=CKEDITOR.TRISTATE_DISABLED&&b.refresh(a)})}}})})();(function(){var f={preserveState:!0,editorFocus:!1,readOnly:1,exec:function(a){this.toggleState();this.refresh(a)},refresh:function(a){if(a.document){var b=this.state==CKEDITOR.TRISTATE_ON?"attachClass":"removeClass";a.editable()[b]("cke_show_borders")}}};CKEDITOR.plugins.add("showborders",{modes:{wysiwyg:1},onLoad:function(){var a;a=(CKEDITOR.env.ie6Compat?[".%1 table.%2,",".%1 table.%2 td, .%1 table.%2 th","{","border : #d3d3d3 1px dotted","}"]:".%1 table.%2,;.%1 table.%2 \x3e tr \x3e td, .%1 table.%2 \x3e tr \x3e th,;.%1 table.%2 \x3e tbody \x3e tr \x3e td, .%1 table.%2 \x3e tbody \x3e tr \x3e th,;.%1 table.%2 \x3e thead \x3e tr \x3e td, .%1 table.%2 \x3e thead \x3e tr \x3e th,;.%1 table.%2 \x3e tfoot \x3e tr \x3e td, .%1 table.%2 \x3e tfoot \x3e tr \x3e th;{;border : #d3d3d3 1px dotted;}".split(";")).join("").replace(/%2/g,
"cke_show_border").replace(/%1/g,"cke_show_borders ");CKEDITOR.addCss(a)},init:function(a){var b=a.addCommand("showborders",f);b.canUndo=!1;!1!==a.config.startupShowBorders&&b.setState(CKEDITOR.TRISTATE_ON);a.on("mode",function(){b.state!=CKEDITOR.TRISTATE_DISABLED&&b.refresh(a)},null,null,100);a.on("contentDom",function(){b.state!=CKEDITOR.TRISTATE_DISABLED&&b.refresh(a)});a.on("removeFormatCleanup",function(d){d=d.data;a.getCommand("showborders").state==CKEDITOR.TRISTATE_ON&&d.is("table")&&(!d.hasAttribute("border")||
0>=parseInt(d.getAttribute("border"),10))&&d.addClass("cke_show_border")})},afterInit:function(a){var b=a.dataProcessor;a=b&&b.dataFilter;b=b&&b.htmlFilter;a&&a.addRules({elements:{table:function(a){a=a.attributes;var b=a["class"],c=parseInt(a.border,10);c&&!(0>=c)||b&&-1!=b.indexOf("cke_show_border")||(a["class"]=(b||"")+" cke_show_border")}}});b&&b.addRules({elements:{table:function(a){a=a.attributes;var b=a["class"];b&&(a["class"]=b.replace("cke_show_border","").replace(/\s{2}/," ").replace(/^\s+|\s+$/,
""))}}})}});CKEDITOR.on("dialogDefinition",function(a){var b=a.data.name;if("table"==b||"tableProperties"==b)if(a=a.data.definition,b=a.getContents("info").get("txtBorder"),b.commit=CKEDITOR.tools.override(b.commit,function(a){return function(b,c){a.apply(this,arguments);var e=parseInt(this.getValue(),10);c[!e||0>=e?"addClass":"removeClass"]("cke_show_border")}}),a=(a=a.getContents("advanced"))&&a.get("advCSSClasses"))a.setup=CKEDITOR.tools.override(a.setup,function(a){return function(){a.apply(this,
arguments);this.setValue(this.getValue().replace(/cke_show_border/,""))}}),a.commit=CKEDITOR.tools.override(a.commit,function(a){return function(b,c){a.apply(this,arguments);parseInt(c.getAttribute("border"),10)||c.addClass("cke_show_border")}})})})();(function(){CKEDITOR.plugins.add("sourcearea",{init:function(a){function d(){var a=e&&this.equals(CKEDITOR.document.getActive());this.hide();this.setStyle("height",this.getParent().$.clientHeight+"px");this.setStyle("width",this.getParent().$.clientWidth+"px");this.show();a&&this.focus()}if(a.elementMode!=CKEDITOR.ELEMENT_MODE_INLINE){var f=CKEDITOR.plugins.sourcearea;a.addMode("source",function(e){var b=a.ui.space("contents").getDocument().createElement("textarea");b.setStyles(CKEDITOR.tools.extend({width:CKEDITOR.env.ie7Compat?
"99%":"100%",height:"100%",resize:"none",outline:"none","text-align":"left"},CKEDITOR.tools.cssVendorPrefix("tab-size",a.config.sourceAreaTabSize||4)));b.setAttribute("dir","ltr");b.addClass("cke_source").addClass("cke_reset").addClass("cke_enable_context_menu");a.ui.space("contents").append(b);b=a.editable(new c(a,b));b.setData(a.getData(1));CKEDITOR.env.ie&&(b.attachListener(a,"resize",d,b),b.attachListener(CKEDITOR.document.getWindow(),"resize",d,b),CKEDITOR.tools.setTimeout(d,0,b));a.fire("ariaWidget",
this);e()});a.addCommand("source",f.commands.source);a.ui.addButton&&a.ui.addButton("Source",{label:a.lang.sourcearea.toolbar,command:"source",toolbar:"mode,10"});a.on("mode",function(){a.getCommand("source").setState("source"==a.mode?CKEDITOR.TRISTATE_ON:CKEDITOR.TRISTATE_OFF)});var e=CKEDITOR.env.ie&&9==CKEDITOR.env.version}}});var c=CKEDITOR.tools.createClass({base:CKEDITOR.editable,proto:{setData:function(a){this.setValue(a);this.status="ready";this.editor.fire("dataReady")},getData:function(){return this.getValue()},
insertHtml:function(){},insertElement:function(){},insertText:function(){},setReadOnly:function(a){this[(a?"set":"remove")+"Attribute"]("readOnly","readonly")},detach:function(){c.baseProto.detach.call(this);this.clearCustomData();this.remove()}}})})();
CKEDITOR.plugins.sourcearea={commands:{source:{modes:{wysiwyg:1,source:1},editorFocus:!1,readOnly:1,exec:function(c){"wysiwyg"==c.mode&&c.fire("saveSnapshot");c.getCommand("source").setState(CKEDITOR.TRISTATE_DISABLED);c.setMode("source"==c.mode?"wysiwyg":"source")},canUndo:!1}}};CKEDITOR.plugins.add("specialchar",{availableLangs:{af:1,ar:1,az:1,bg:1,ca:1,cs:1,cy:1,da:1,de:1,"de-ch":1,el:1,en:1,"en-au":1,"en-ca":1,"en-gb":1,eo:1,es:1,"es-mx":1,et:1,eu:1,fa:1,fi:1,fr:1,"fr-ca":1,gl:1,he:1,hr:1,hu:1,id:1,it:1,ja:1,km:1,ko:1,ku:1,lt:1,lv:1,nb:1,nl:1,no:1,oc:1,pl:1,pt:1,"pt-br":1,ro:1,ru:1,si:1,sk:1,sl:1,sq:1,sr:1,"sr-latn":1,sv:1,th:1,tr:1,tt:1,ug:1,uk:1,vi:1,zh:1,"zh-cn":1},requires:"dialog",init:function(a){var c=this;CKEDITOR.dialog.add("specialchar",this.path+"dialogs/specialchar.js");
a.addCommand("specialchar",{exec:function(){var b=a.langCode,b=c.availableLangs[b]?b:c.availableLangs[b.replace(/-.*/,"")]?b.replace(/-.*/,""):"en";CKEDITOR.scriptLoader.load(CKEDITOR.getUrl(c.path+"dialogs/lang/"+b+".js"),function(){CKEDITOR.tools.extend(a.lang.specialchar,c.langEntries[b]);a.openDialog("specialchar")})},modes:{wysiwyg:1},canUndo:!1});a.ui.addButton&&a.ui.addButton("SpecialChar",{label:a.lang.specialchar.toolbar,command:"specialchar",toolbar:"insert,50"})}});
CKEDITOR.config.specialChars="! \x26quot; # $ % \x26amp; ' ( ) * + - . / 0 1 2 3 4 5 6 7 8 9 : ; \x26lt; \x3d \x26gt; ? @ A B C D E F G H I J K L M N O P Q R S T U V W X Y Z [ ] ^ _ ` a b c d e f g h i j k l m n o p q r s t u v w x y z { | } ~ \x26euro; \x26lsquo; \x26rsquo; \x26ldquo; \x26rdquo; \x26ndash; \x26mdash; \x26iexcl; \x26cent; \x26pound; \x26curren; \x26yen; \x26brvbar; \x26sect; \x26uml; \x26copy; \x26ordf; \x26laquo; \x26not; \x26reg; \x26macr; \x26deg; \x26sup2; \x26sup3; \x26acute; \x26micro; \x26para; \x26middot; \x26cedil; \x26sup1; \x26ordm; \x26raquo; \x26frac14; \x26frac12; \x26frac34; \x26iquest; \x26Agrave; \x26Aacute; \x26Acirc; \x26Atilde; \x26Auml; \x26Aring; \x26AElig; \x26Ccedil; \x26Egrave; \x26Eacute; \x26Ecirc; \x26Euml; \x26Igrave; \x26Iacute; \x26Icirc; \x26Iuml; \x26ETH; \x26Ntilde; \x26Ograve; \x26Oacute; \x26Ocirc; \x26Otilde; \x26Ouml; \x26times; \x26Oslash; \x26Ugrave; \x26Uacute; \x26Ucirc; \x26Uuml; \x26Yacute; \x26THORN; \x26szlig; \x26agrave; \x26aacute; \x26acirc; \x26atilde; \x26auml; \x26aring; \x26aelig; \x26ccedil; \x26egrave; \x26eacute; \x26ecirc; \x26euml; \x26igrave; \x26iacute; \x26icirc; \x26iuml; \x26eth; \x26ntilde; \x26ograve; \x26oacute; \x26ocirc; \x26otilde; \x26ouml; \x26divide; \x26oslash; \x26ugrave; \x26uacute; \x26ucirc; \x26uuml; \x26yacute; \x26thorn; \x26yuml; \x26OElig; \x26oelig; \x26#372; \x26#374 \x26#373 \x26#375; \x26sbquo; \x26#8219; \x26bdquo; \x26hellip; \x26trade; \x26#9658; \x26bull; \x26rarr; \x26rArr; \x26hArr; \x26diams; \x26asymp;".split(" ");CKEDITOR.plugins.add("scayt",{requires:"menubutton,dialog",tabToOpen:null,dialogName:"scaytDialog",onLoad:function(a){"moono-lisa"==(CKEDITOR.skinName||a.config.skin)&&CKEDITOR.document.appendStyleSheet(CKEDITOR.getUrl(this.path+"skins/"+CKEDITOR.skin.name+"/scayt.css"));CKEDITOR.document.appendStyleSheet(CKEDITOR.getUrl(this.path+"dialogs/dialog.css"));var c=!1;CKEDITOR.on("instanceLoaded",function(a){if(!c&&CKEDITOR.plugins.autocomplete){c=!0;var b=CKEDITOR.plugins.autocomplete.prototype.getModel;
CKEDITOR.plugins.autocomplete.prototype.getModel=function(a){var d=this.editor;a=b.bind(this)(a);a.on("change-isActive",function(a){a.data?d.fire("autocompletePanelShow"):d.fire("autocompletePanelHide")});return a}}})},init:function(a){var c=this,d=CKEDITOR.plugins.scayt;this.bindEvents(a);this.parseConfig(a);this.addRule(a);CKEDITOR.dialog.add(this.dialogName,CKEDITOR.getUrl(this.path+"dialogs/options.js"));this.addMenuItems(a);var b=a.lang.scayt,e=CKEDITOR.env;a.ui.add("Scayt",CKEDITOR.UI_MENUBUTTON,
{label:b.text_title,title:a.plugins.wsc?a.lang.wsc.title:b.text_title,modes:{wysiwyg:!(e.ie&&(8>e.version||e.quirks))},toolbar:"spellchecker,20",refresh:function(){var b=a.ui.instances.Scayt.getState();a.scayt&&(b=d.state.scayt[a.name]?CKEDITOR.TRISTATE_ON:CKEDITOR.TRISTATE_OFF);a.fire("scaytButtonState",b)},onRender:function(){var b=this;a.on("scaytButtonState",function(a){void 0!==typeof a.data&&b.setState(a.data)})},onMenu:function(){var b=a.scayt;a.getMenuItem("scaytToggle").label=a.lang.scayt[b&&
d.state.scayt[a.name]?"btn_disable":"btn_enable"];var c={scaytToggle:CKEDITOR.TRISTATE_OFF,scaytOptions:b?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED,scaytLangs:b?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED,scaytDict:b?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED,scaytAbout:b?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED,WSC:a.plugins.wsc?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED};a.config.scayt_uiTabs[0]||delete c.scaytOptions;a.config.scayt_uiTabs[1]||delete c.scaytLangs;
a.config.scayt_uiTabs[2]||delete c.scaytDict;b&&!CKEDITOR.plugins.scayt.isNewUdSupported(b)&&(delete c.scaytDict,a.config.scayt_uiTabs[2]=0,CKEDITOR.plugins.scayt.alarmCompatibilityMessage());return c}});a.contextMenu&&a.addMenuItems&&(a.contextMenu.addListener(function(b,d){var e=a.scayt,l,m;e&&(m=e.getSelectionNode())&&(l=c.menuGenerator(a,m),e.showBanner("."+a.contextMenu._.definition.panel.className.split(" ").join(" .")));return l}),a.contextMenu._.onHide=CKEDITOR.tools.override(a.contextMenu._.onHide,
function(b){return function(){var d=a.scayt;d&&d.hideBanner();return b.apply(this)}}))},addMenuItems:function(a){var c=this,d=CKEDITOR.plugins.scayt;a.addMenuGroup("scaytButton");for(var b=a.config.scayt_contextMenuItemsOrder.split("|"),e=0;e<b.length;e++)b[e]="scayt_"+b[e];if((b=["grayt_description","grayt_suggest","grayt_control"].concat(b))&&b.length)for(e=0;e<b.length;e++)a.addMenuGroup(b[e],e-10);a.addCommand("scaytToggle",{exec:function(a){var b=a.scayt;d.state.scayt[a.name]=!d.state.scayt[a.name];
!0===d.state.scayt[a.name]?b||d.createScayt(a):b&&d.destroy(a)}});a.addCommand("scaytAbout",{exec:function(a){a.scayt.tabToOpen="about";d.openDialog(c.dialogName,a)}});a.addCommand("scaytOptions",{exec:function(a){a.scayt.tabToOpen="options";d.openDialog(c.dialogName,a)}});a.addCommand("scaytLangs",{exec:function(a){a.scayt.tabToOpen="langs";d.openDialog(c.dialogName,a)}});a.addCommand("scaytDict",{exec:function(a){a.scayt.tabToOpen="dictionaries";d.openDialog(c.dialogName,a)}});b={scaytToggle:{label:a.lang.scayt.btn_enable,
group:"scaytButton",command:"scaytToggle"},scaytAbout:{label:a.lang.scayt.btn_about,group:"scaytButton",command:"scaytAbout"},scaytOptions:{label:a.lang.scayt.btn_options,group:"scaytButton",command:"scaytOptions"},scaytLangs:{label:a.lang.scayt.btn_langs,group:"scaytButton",command:"scaytLangs"},scaytDict:{label:a.lang.scayt.btn_dictionaries,group:"scaytButton",command:"scaytDict"}};a.plugins.wsc&&(b.WSC={label:a.lang.wsc.toolbar,group:"scaytButton",onClick:function(){var b=CKEDITOR.plugins.scayt,
d=a.scayt,c=a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE?a.container.getText():a.document.getBody().getText();(c=c.replace(/\s/g,""))?(d&&b.state.scayt[a.name]&&d.setMarkupPaused&&d.setMarkupPaused(!0),a.lockSelection(),a.execCommand("checkspell")):alert("Nothing to check!")}});a.addMenuItems(b)},bindEvents:function(a){var c=CKEDITOR.plugins.scayt,d=a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE,b=function(){c.destroy(a)},e=function(){!c.state.scayt[a.name]||a.readOnly||a.scayt||c.createScayt(a)},f=function(){var b=
a.editable();b.attachListener(b,"focus",function(b){CKEDITOR.plugins.scayt&&!a.scayt&&setTimeout(e,0);b=CKEDITOR.plugins.scayt&&CKEDITOR.plugins.scayt.state.scayt[a.name]&&a.scayt;var c,k;if((d||b)&&a._.savedSelection){b=a._.savedSelection.getSelectedElement();b=!b&&a._.savedSelection.getRanges();for(var f=0;f<b.length;f++)k=b[f],"string"===typeof k.startContainer.$.nodeValue&&(c=k.startContainer.getText().length,(c<k.startOffset||c<k.endOffset)&&a.unlockSelection(!1))}},this,null,-10)},g=function(){d?
a.config.scayt_inlineModeImmediateMarkup?e():(a.on("blur",function(){setTimeout(b,0)}),a.on("focus",e),a.focusManager.hasFocus&&e()):e();f();var c=a.editable();c.attachListener(c,"mousedown",function(b){b=b.data.getTarget();var d=a.widgets&&a.widgets.getByElement(b);d&&(d.wrapper=b.getAscendant(function(a){return a.hasAttribute("data-cke-widget-wrapper")},!0))},this,null,-10)};a.on("contentDom",g);a.on("beforeCommandExec",function(b){var d=a.scayt,e=!1,f=!1,h=!0;b.data.name in c.options.disablingCommandExec&&
"wysiwyg"==a.mode?d&&(c.destroy(a),a.fire("scaytButtonState",CKEDITOR.TRISTATE_DISABLED)):"bold"!==b.data.name&&"italic"!==b.data.name&&"underline"!==b.data.name&&"strike"!==b.data.name&&"subscript"!==b.data.name&&"superscript"!==b.data.name&&"enter"!==b.data.name&&"cut"!==b.data.name&&"language"!==b.data.name||!d||("cut"===b.data.name&&(h=!1,f=!0),"language"===b.data.name&&(f=e=!0),a.fire("reloadMarkupScayt",{removeOptions:{removeInside:h,forceBookmark:f,language:e},timeout:0}))});a.on("beforeSetMode",
function(b){if("source"==b.data){if(b=a.scayt)c.destroy(a),a.fire("scaytButtonState",CKEDITOR.TRISTATE_DISABLED);a.document&&a.document.getBody().removeAttribute("_jquid")}});a.on("afterCommandExec",function(b){"wysiwyg"!=a.mode||"undo"!=b.data.name&&"redo"!=b.data.name||setTimeout(function(){c.reloadMarkup(a.scayt)},250)});a.on("readOnly",function(b){var d;b&&(d=a.scayt,!0===b.editor.readOnly?d&&d.fire("removeMarkupInDocument",{}):d?c.reloadMarkup(d):"wysiwyg"==b.editor.mode&&!0===c.state.scayt[b.editor.name]&&
(c.createScayt(a),b.editor.fire("scaytButtonState",CKEDITOR.TRISTATE_ON)))});a.on("beforeDestroy",b);a.on("setData",function(){b();(a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE||a.plugins.divarea)&&g()},this,null,50);a.on("reloadMarkupScayt",function(b){var d=b.data&&b.data.removeOptions,e=b.data&&b.data.timeout,f=b.data&&b.data.language,h=a.scayt;h&&setTimeout(function(){f&&(d.selectionNode=a.plugins.language.getCurrentLangElement(a),d.selectionNode=d.selectionNode&&d.selectionNode.$||null);h.removeMarkupInSelectionNode(d);
c.reloadMarkup(h)},e||0)});a.on("insertElement",function(){a.fire("reloadMarkupScayt",{removeOptions:{forceBookmark:!0}})},this,null,50);a.on("insertHtml",function(){a.scayt&&a.scayt.setFocused&&a.scayt.setFocused(!0);a.fire("reloadMarkupScayt")},this,null,50);a.on("insertText",function(){a.scayt&&a.scayt.setFocused&&a.scayt.setFocused(!0);a.fire("reloadMarkupScayt")},this,null,50);a.on("scaytDialogShown",function(b){b.data.selectPage(a.scayt.tabToOpen)});a.on("autocompletePanelShow",function(b){(b=
a.scayt)&&b.setMarkupPaused&&b.setMarkupPaused(!0)});a.on("autocompletePanelHide",function(b){(b=a.scayt)&&b.setMarkupPaused&&b.setMarkupPaused(!1)})},parseConfig:function(a){var c=CKEDITOR.plugins.scayt;c.replaceOldOptionsNames(a.config);"boolean"!==typeof a.config.scayt_autoStartup&&(a.config.scayt_autoStartup=!1);c.state.scayt[a.name]=a.config.scayt_autoStartup;"boolean"!==typeof a.config.grayt_autoStartup&&(a.config.grayt_autoStartup=!1);"boolean"!==typeof a.config.scayt_inlineModeImmediateMarkup&&
(a.config.scayt_inlineModeImmediateMarkup=!1);c.state.grayt[a.name]=a.config.grayt_autoStartup;a.config.scayt_contextCommands||(a.config.scayt_contextCommands="ignoreall|add");a.config.scayt_contextMenuItemsOrder||(a.config.scayt_contextMenuItemsOrder="suggest|moresuggest|control");a.config.scayt_sLang||(a.config.scayt_sLang="en_US");if(void 0===a.config.scayt_maxSuggestions||"number"!=typeof a.config.scayt_maxSuggestions||0>a.config.scayt_maxSuggestions)a.config.scayt_maxSuggestions=3;if(void 0===
a.config.scayt_minWordLength||"number"!=typeof a.config.scayt_minWordLength||1>a.config.scayt_minWordLength)a.config.scayt_minWordLength=3;if(void 0===a.config.scayt_customDictionaryIds||"string"!==typeof a.config.scayt_customDictionaryIds)a.config.scayt_customDictionaryIds="";if(void 0===a.config.scayt_userDictionaryName||"string"!==typeof a.config.scayt_userDictionaryName)a.config.scayt_userDictionaryName=null;if("string"===typeof a.config.scayt_uiTabs&&3===a.config.scayt_uiTabs.split(",").length){var d=
[],b=[];a.config.scayt_uiTabs=a.config.scayt_uiTabs.split(",");CKEDITOR.tools.search(a.config.scayt_uiTabs,function(a){1===Number(a)||0===Number(a)?(b.push(!0),d.push(Number(a))):b.push(!1)});null===CKEDITOR.tools.search(b,!1)?a.config.scayt_uiTabs=d:a.config.scayt_uiTabs=[1,1,1]}else a.config.scayt_uiTabs=[1,1,1];"string"!=typeof a.config.scayt_serviceProtocol&&(a.config.scayt_serviceProtocol=null);"string"!=typeof a.config.scayt_serviceHost&&(a.config.scayt_serviceHost=null);"string"!=typeof a.config.scayt_servicePort&&
(a.config.scayt_servicePort=null);"string"!=typeof a.config.scayt_servicePath&&(a.config.scayt_servicePath=null);a.config.scayt_moreSuggestions||(a.config.scayt_moreSuggestions="on");"string"!==typeof a.config.scayt_customerId&&(a.config.scayt_customerId="1:WvF0D4-UtPqN1-43nkD4-NKvUm2-daQqk3-LmNiI-z7Ysb4-mwry24-T8YrS3-Q2tpq2");"string"!==typeof a.config.scayt_customPunctuation&&(a.config.scayt_customPunctuation="-");"string"!==typeof a.config.scayt_srcUrl&&(c=document.location.protocol,c=-1!=c.search(/https?:/)?
c:"http:",a.config.scayt_srcUrl=c+"//svc.webspellchecker.net/spellcheck31/wscbundle/wscbundle.js");"boolean"!==typeof CKEDITOR.config.scayt_handleCheckDirty&&(CKEDITOR.config.scayt_handleCheckDirty=!0);"boolean"!==typeof CKEDITOR.config.scayt_handleUndoRedo&&(CKEDITOR.config.scayt_handleUndoRedo=!0);CKEDITOR.config.scayt_handleUndoRedo=CKEDITOR.plugins.undo?CKEDITOR.config.scayt_handleUndoRedo:!1;a.config.scayt_ignoreAllCapsWords&&"boolean"!==typeof a.config.scayt_ignoreAllCapsWords&&(a.config.scayt_ignoreAllCapsWords=
!1);a.config.scayt_ignoreDomainNames&&"boolean"!==typeof a.config.scayt_ignoreDomainNames&&(a.config.scayt_ignoreDomainNames=!1);a.config.scayt_ignoreWordsWithMixedCases&&"boolean"!==typeof a.config.scayt_ignoreWordsWithMixedCases&&(a.config.scayt_ignoreWordsWithMixedCases=!1);a.config.scayt_ignoreWordsWithNumbers&&"boolean"!==typeof a.config.scayt_ignoreWordsWithNumbers&&(a.config.scayt_ignoreWordsWithNumbers=!1);if(a.config.scayt_disableOptionsStorage){var c=CKEDITOR.tools.isArray(a.config.scayt_disableOptionsStorage)?
a.config.scayt_disableOptionsStorage:"string"===typeof a.config.scayt_disableOptionsStorage?[a.config.scayt_disableOptionsStorage]:void 0,e="all options lang ignore-all-caps-words ignore-domain-names ignore-words-with-mixed-cases ignore-words-with-numbers".split(" "),f=["lang","ignore-all-caps-words","ignore-domain-names","ignore-words-with-mixed-cases","ignore-words-with-numbers"],g=CKEDITOR.tools.search,k=CKEDITOR.tools.indexOf;a.config.scayt_disableOptionsStorage=function(a){for(var b=[],d=0;d<
a.length;d++){var c=a[d],p=!!g(a,"options");if(!g(e,c)||p&&g(f,function(a){if("lang"===a)return!1}))return;g(f,c)&&f.splice(k(f,c),1);if("all"===c||p&&g(a,"lang"))return[];"options"===c&&(f=["lang"])}return b=b.concat(f)}(c)}},addRule:function(a){var c=CKEDITOR.plugins.scayt,d=a.dataProcessor,b=d&&d.htmlFilter,e=a._.elementsPath&&a._.elementsPath.filters,d=d&&d.dataFilter,f=a.addRemoveFormatFilter,g=function(b){if(a.scayt&&(b.hasAttribute(c.options.data_attribute_name)||b.hasAttribute(c.options.problem_grammar_data_attribute)))return!1},
k=function(b){var d=!0;a.scayt&&(b.hasAttribute(c.options.data_attribute_name)||b.hasAttribute(c.options.problem_grammar_data_attribute))&&(d=!1);return d};e&&e.push(g);d&&d.addRules({elements:{span:function(a){var b=a.hasClass(c.options.misspelled_word_class)&&a.attributes[c.options.data_attribute_name],d=a.hasClass(c.options.problem_grammar_class)&&a.attributes[c.options.problem_grammar_data_attribute];c&&(b||d)&&delete a.name;return a}}});b&&b.addRules({elements:{span:function(a){var b=a.hasClass(c.options.misspelled_word_class)&&
a.attributes[c.options.data_attribute_name],d=a.hasClass(c.options.problem_grammar_class)&&a.attributes[c.options.problem_grammar_data_attribute];c&&(b||d)&&delete a.name;return a}}});f&&f.call(a,k)},scaytMenuDefinition:function(a){var c=this,d=CKEDITOR.plugins.scayt;a=a.scayt;return{scayt:{scayt_ignore:{label:a.getLocal("btn_ignore"),group:"scayt_control",order:1,exec:function(a){a.scayt.ignoreWord()}},scayt_ignoreall:{label:a.getLocal("btn_ignoreAll"),group:"scayt_control",order:2,exec:function(a){a.scayt.ignoreAllWords()}},
scayt_add:{label:a.getLocal("btn_addWord"),group:"scayt_control",order:3,exec:function(a){var d=a.scayt;setTimeout(function(){d.addWordToUserDictionary()},10)}},scayt_option:{label:a.getLocal("btn_options"),group:"scayt_control",order:4,exec:function(a){a.scayt.tabToOpen="options";d.openDialog(c.dialogName,a)},verification:function(a){return 1==a.config.scayt_uiTabs[0]?!0:!1}},scayt_language:{label:a.getLocal("btn_langs"),group:"scayt_control",order:5,exec:function(a){a.scayt.tabToOpen="langs";d.openDialog(c.dialogName,
a)},verification:function(a){return 1==a.config.scayt_uiTabs[1]?!0:!1}},scayt_dictionary:{label:a.getLocal("btn_dictionaries"),group:"scayt_control",order:6,exec:function(a){a.scayt.tabToOpen="dictionaries";d.openDialog(c.dialogName,a)},verification:function(a){return 1==a.config.scayt_uiTabs[2]?!0:!1}},scayt_about:{label:a.getLocal("btn_about"),group:"scayt_control",order:7,exec:function(a){a.scayt.tabToOpen="about";d.openDialog(c.dialogName,a)}}},grayt:{grayt_problemdescription:{label:"Grammar problem description",
group:"grayt_description",order:1,state:CKEDITOR.TRISTATE_DISABLED,exec:function(a){}},grayt_ignore:{label:a.getLocal("btn_ignore"),group:"grayt_control",order:2,exec:function(a){a.scayt.ignorePhrase()}},grayt_ignoreall:{label:a.getLocal("btn_ignoreAll"),group:"grayt_control",order:3,exec:function(a){a.scayt.ignoreAllPhrases()}}}}},buildSuggestionMenuItems:function(a,c,d){var b={},e={},f=d?"word":"phrase",g=d?"startGrammarCheck":"startSpellCheck",k=a.scayt;if(0<c.length&&"no_any_suggestions"!==c[0])if(d)for(d=
0;d<c.length;d++){var l="scayt_suggest_"+CKEDITOR.plugins.scayt.suggestions[d].replace(" ","_");a.addCommand(l,this.createCommand(CKEDITOR.plugins.scayt.suggestions[d],f,g));d<a.config.scayt_maxSuggestions?(a.addMenuItem(l,{label:c[d],command:l,group:"scayt_suggest",order:d+1}),b[l]=CKEDITOR.TRISTATE_OFF):(a.addMenuItem(l,{label:c[d],command:l,group:"scayt_moresuggest",order:d+1}),e[l]=CKEDITOR.TRISTATE_OFF,"on"===a.config.scayt_moreSuggestions&&(a.addMenuItem("scayt_moresuggest",{label:k.getLocal("btn_moreSuggestions"),
group:"scayt_moresuggest",order:10,getItems:function(){return e}}),b.scayt_moresuggest=CKEDITOR.TRISTATE_OFF))}else for(d=0;d<c.length;d++)l="grayt_suggest_"+CKEDITOR.plugins.scayt.suggestions[d].replace(" ","_"),a.addCommand(l,this.createCommand(CKEDITOR.plugins.scayt.suggestions[d],f,g)),a.addMenuItem(l,{label:c[d],command:l,group:"grayt_suggest",order:d+1}),b[l]=CKEDITOR.TRISTATE_OFF;else b.no_scayt_suggest=CKEDITOR.TRISTATE_DISABLED,a.addCommand("no_scayt_suggest",{exec:function(){}}),a.addMenuItem("no_scayt_suggest",
{label:k.getLocal("btn_noSuggestions")||"no_scayt_suggest",command:"no_scayt_suggest",group:"scayt_suggest",order:0});return b},menuGenerator:function(a,c){var d=a.scayt,b=this.scaytMenuDefinition(a),e={},f=a.config.scayt_contextCommands.split("|"),g=c.getAttribute(d.getLangAttribute())||d.getLang(),k,l,m,n;l=d.isScaytNode(c);m=d.isGraytNode(c);l?(b=b.scayt,k=c.getAttribute(d.getScaytNodeAttributeName()),d.fire("getSuggestionsList",{lang:g,word:k}),e=this.buildSuggestionMenuItems(a,CKEDITOR.plugins.scayt.suggestions,
l)):m&&(b=b.grayt,e=c.getAttribute(d.getGraytNodeAttributeName()),d.getGraytNodeRuleAttributeName?(k=c.getAttribute(d.getGraytNodeRuleAttributeName()),d.getProblemDescriptionText(e,k,g)):d.getProblemDescriptionText(e,g),n=d.getProblemDescriptionText(e,k,g),b.grayt_problemdescription&&n&&(n=n.replace(/([.!?])\s/g,"$1\x3cbr\x3e"),b.grayt_problemdescription.label=n),d.fire("getGrammarSuggestionsList",{lang:g,phrase:e,rule:k}),e=this.buildSuggestionMenuItems(a,CKEDITOR.plugins.scayt.suggestions,l));if(l&&
"off"==a.config.scayt_contextCommands)return e;for(var h in b)l&&-1==CKEDITOR.tools.indexOf(f,h.replace("scayt_",""))&&"all"!=a.config.scayt_contextCommands||m&&"grayt_problemdescription"!==h&&-1==CKEDITOR.tools.indexOf(f,h.replace("grayt_",""))&&"all"!=a.config.scayt_contextCommands||(e[h]="undefined"!=typeof b[h].state?b[h].state:CKEDITOR.TRISTATE_OFF,"function"!==typeof b[h].verification||b[h].verification(a)||delete e[h],a.addCommand(h,{exec:b[h].exec}),a.addMenuItem(h,{label:a.lang.scayt[b[h].label]||
b[h].label,command:h,group:b[h].group,order:b[h].order}));return e},createCommand:function(a,c,d){return{exec:function(b){b=b.scayt;var e={};e[c]=a;b.replaceSelectionNode(e);"startGrammarCheck"===d&&b.removeMarkupInSelectionNode({grammarOnly:!0});b.fire(d)}}}});
CKEDITOR.plugins.scayt={charsToObserve:[{charName:"cke-fillingChar",charCode:function(){var a=CKEDITOR.version,c=[4,5,6],d=String.fromCharCode(8203),b=Array(8).join(d),e,f;if(!a)return d;for(var a=a.split("."),g=0;g<c.length;g++){e=c[g];f=Number(a[g]);if(f>e)return b;if(f<e)break}return d}()}],state:{scayt:{},grayt:{}},warningCounter:0,suggestions:[],options:{disablingCommandExec:{source:!0,newpage:!0,templates:!0},data_attribute_name:"data-scayt-word",misspelled_word_class:"scayt-misspell-word",
problem_grammar_data_attribute:"data-grayt-phrase",problem_grammar_class:"gramm-problem"},backCompatibilityMap:{scayt_service_protocol:"scayt_serviceProtocol",scayt_service_host:"scayt_serviceHost",scayt_service_port:"scayt_servicePort",scayt_service_path:"scayt_servicePath",scayt_customerid:"scayt_customerId"},openDialog:function(a,c){var d=c.scayt;d.isAllModulesReady&&!1===d.isAllModulesReady()||(c.lockSelection(),c.openDialog(a))},alarmCompatibilityMessage:function(){5>this.warningCounter&&(console.warn("You are using the latest version of SCAYT plugin for CKEditor with the old application version. In order to have access to the newest features, it is recommended to upgrade the application version to latest one as well. Contact us for more details at support@webspellchecker.net."),
this.warningCounter+=1)},isNewUdSupported:function(a){return a.getUserDictionary?!0:!1},reloadMarkup:function(a){var c;a&&(c=a.getScaytLangList(),a.reloadMarkup?a.reloadMarkup():(this.alarmCompatibilityMessage(),c&&c.ltr&&c.rtl&&a.fire("startSpellCheck, startGrammarCheck")))},replaceOldOptionsNames:function(a){for(var c in a)c in this.backCompatibilityMap&&(a[this.backCompatibilityMap[c]]=a[c],delete a[c])},createScayt:function(a){var c=this,d=CKEDITOR.plugins.scayt;this.loadScaytLibrary(a,function(a){function e(a){return new SCAYT.CKSCAYT(a,
function(){},function(){})}var f;a.window&&(f="BODY"==a.editable().$.nodeName?a.window.getFrame():a.editable());if(f){f={lang:a.config.scayt_sLang,container:f.$,customDictionary:a.config.scayt_customDictionaryIds,userDictionaryName:a.config.scayt_userDictionaryName,localization:a.langCode,customer_id:a.config.scayt_customerId,customPunctuation:a.config.scayt_customPunctuation,debug:a.config.scayt_debug,data_attribute_name:c.options.data_attribute_name,misspelled_word_class:c.options.misspelled_word_class,
problem_grammar_data_attribute:c.options.problem_grammar_data_attribute,problem_grammar_class:c.options.problem_grammar_class,"options-to-restore":a.config.scayt_disableOptionsStorage,focused:a.editable().hasFocus,ignoreElementsRegex:a.config.scayt_elementsToIgnore,ignoreGraytElementsRegex:a.config.grayt_elementsToIgnore,minWordLength:a.config.scayt_minWordLength,graytAutoStartup:a.config.grayt_autoStartup,charsToObserve:d.charsToObserve};a.config.scayt_serviceProtocol&&(f.service_protocol=a.config.scayt_serviceProtocol);
a.config.scayt_serviceHost&&(f.service_host=a.config.scayt_serviceHost);a.config.scayt_servicePort&&(f.service_port=a.config.scayt_servicePort);a.config.scayt_servicePath&&(f.service_path=a.config.scayt_servicePath);"boolean"===typeof a.config.scayt_ignoreAllCapsWords&&(f["ignore-all-caps-words"]=a.config.scayt_ignoreAllCapsWords);"boolean"===typeof a.config.scayt_ignoreDomainNames&&(f["ignore-domain-names"]=a.config.scayt_ignoreDomainNames);"boolean"===typeof a.config.scayt_ignoreWordsWithMixedCases&&
(f["ignore-words-with-mixed-cases"]=a.config.scayt_ignoreWordsWithMixedCases);"boolean"===typeof a.config.scayt_ignoreWordsWithNumbers&&(f["ignore-words-with-numbers"]=a.config.scayt_ignoreWordsWithNumbers);var g;try{g=e(f)}catch(k){c.alarmCompatibilityMessage(),delete f.charsToObserve,g=e(f)}g.subscribe("suggestionListSend",function(a){for(var b={},d=[],c=0;c<a.suggestionList.length;c++)b["word_"+a.suggestionList[c]]||(b["word_"+a.suggestionList[c]]=a.suggestionList[c],d.push(a.suggestionList[c]));
CKEDITOR.plugins.scayt.suggestions=d});g.subscribe("selectionIsChanged",function(d){a.getSelection().isLocked&&"restoreSelection"!==d.action&&a.lockSelection();"restoreSelection"===d.action&&a.selectionChange(!0)});g.subscribe("graytStateChanged",function(c){d.state.grayt[a.name]=c.state});g.addMarkupHandler&&g.addMarkupHandler(function(d){var c=a.editable(),e=c.getCustomData(d.charName);e&&(e.$=d.node,c.setCustomData(d.charName,e))});a.scayt=g;a.fire("scaytButtonState",a.readOnly?CKEDITOR.TRISTATE_DISABLED:
CKEDITOR.TRISTATE_ON)}else d.state.scayt[a.name]=!1})},destroy:function(a){a.scayt&&a.scayt.destroy();delete a.scayt;a.fire("scaytButtonState",CKEDITOR.TRISTATE_OFF)},loadScaytLibrary:function(a,c){var d,b=function(){CKEDITOR.fireOnce("scaytReady");a.scayt||"function"===typeof c&&c(a)};"undefined"===typeof window.SCAYT||"function"!==typeof window.SCAYT.CKSCAYT?(d=a.config.scayt_srcUrl,CKEDITOR.scriptLoader.load(d,function(a){a&&b()})):window.SCAYT&&"function"===typeof window.SCAYT.CKSCAYT&&b()}};
CKEDITOR.on("dialogDefinition",function(a){var c=a.data.name;a=a.data.definition.dialog;"scaytDialog"!==c&&"checkspell"!==c&&(a.on("show",function(a){a=a.sender&&a.sender.getParentEditor();var b=CKEDITOR.plugins.scayt,c=a.scayt;c&&b.state.scayt[a.name]&&c.setMarkupPaused&&c.setMarkupPaused(!0)}),a.on("hide",function(a){a=a.sender&&a.sender.getParentEditor();var b=CKEDITOR.plugins.scayt,c=a.scayt;c&&b.state.scayt[a.name]&&c.setMarkupPaused&&c.setMarkupPaused(!1)}));if("scaytDialog"===c)a.on("cancel",
function(a){return!1},this,null,-1);if("checkspell"===c)a.on("cancel",function(a){a=a.sender&&a.sender.getParentEditor();var b=CKEDITOR.plugins.scayt,c=a.scayt;c&&b.state.scayt[a.name]&&c.setMarkupPaused&&c.setMarkupPaused(!1);a.unlockSelection()},this,null,-2);if("link"===c)a.on("ok",function(a){var b=a.sender&&a.sender.getParentEditor();b&&setTimeout(function(){b.fire("reloadMarkupScayt",{removeOptions:{removeInside:!0,forceBookmark:!0},timeout:0})},0)});if("replace"===c)a.on("hide",function(a){a=
a.sender&&a.sender.getParentEditor();var b=CKEDITOR.plugins.scayt,c=a.scayt;a&&setTimeout(function(){c&&(c.fire("removeMarkupInDocument",{}),b.reloadMarkup(c))},0)})});
CKEDITOR.on("scaytReady",function(){if(!0===CKEDITOR.config.scayt_handleCheckDirty){var a=CKEDITOR.editor.prototype;a.checkDirty=CKEDITOR.tools.override(a.checkDirty,function(a){return function(){var b=null,c=this.scayt;if(CKEDITOR.plugins.scayt&&CKEDITOR.plugins.scayt.state.scayt[this.name]&&this.scayt){if(b="ready"==this.status)var f=c.removeMarkupFromString(this.getSnapshot()),c=c.removeMarkupFromString(this._.previousValue),b=b&&c!==f}else b=a.call(this);return b}});a.resetDirty=CKEDITOR.tools.override(a.resetDirty,
function(a){return function(){var b=this.scayt;CKEDITOR.plugins.scayt&&CKEDITOR.plugins.scayt.state.scayt[this.name]&&this.scayt?this._.previousValue=b.removeMarkupFromString(this.getSnapshot()):a.call(this)}})}if(!0===CKEDITOR.config.scayt_handleUndoRedo){var a=CKEDITOR.plugins.undo.Image.prototype,c="function"==typeof a.equalsContent?"equalsContent":"equals";a[c]=CKEDITOR.tools.override(a[c],function(a){return function(b){var c=b.editor.scayt,f=this.contents,g=b.contents,k=null;CKEDITOR.plugins.scayt&&
CKEDITOR.plugins.scayt.state.scayt[b.editor.name]&&b.editor.scayt&&(this.contents=c.removeMarkupFromString(f)||"",b.contents=c.removeMarkupFromString(g)||"");k=a.apply(this,arguments);this.contents=f;b.contents=g;return k}})}});(function(){CKEDITOR.plugins.add("stylescombo",{requires:"richcombo",init:function(c){var l=c.config,h=c.lang.stylescombo,e={},k=[],m=[];c.on("stylesSet",function(a){if(a=a.data.styles){for(var b,f,d,g=0,n=a.length;g<n;g++)(b=a[g],c.blockless&&b.element in CKEDITOR.dtd.$block||"string"==typeof b.type&&!CKEDITOR.style.customHandlers[b.type]||(f=b.name,b=new CKEDITOR.style(b),c.filter.customConfig&&!c.filter.check(b)))||(b._name=f,b._.enterMode=l.enterMode,b._.type=d=b.assignedTo||b.type,b._.weight=
g+1E3*(d==CKEDITOR.STYLE_OBJECT?1:d==CKEDITOR.STYLE_BLOCK?2:3),e[f]=b,k.push(b),m.push(b));k.sort(function(a,b){return a._.weight-b._.weight})}});c.on("stylesRemove",function(a){a=a.data&&a.data.type;var b=void 0===a,f;for(f in e){var d=e[f];(b||d.type===a)&&c.removeStyle(d)}});c.ui.addRichCombo("Styles",{label:h.label,title:h.panelTitle,toolbar:"styles,10",allowedContent:m,panel:{css:[CKEDITOR.skin.getPath("editor")].concat(l.contentsCss),multiSelect:!0,attributes:{"aria-label":h.panelTitle}},init:function(){var a,
b,c,d,g,e;g=0;for(e=k.length;g<e;g++)a=k[g],b=a._name,d=a._.type,d!=c&&(this.startGroup(h["panelTitle"+String(d)]),c=d),this.add(b,a.type==CKEDITOR.STYLE_OBJECT?b:a.buildPreview(),b);this.commit()},onClick:function(a){c.focus();c.fire("saveSnapshot");a=e[a];var b=c.elementPath();if(a.group&&a.removeStylesFromSameGroup(c))c.applyStyle(a);else c[a.checkActive(b,c)?"removeStyle":"applyStyle"](a);c.fire("saveSnapshot")},onRender:function(){c.on("selectionChange",function(a){var b=this.getValue();a=a.data.path.elements;
for(var f=0,d=a.length,g;f<d;f++){g=a[f];for(var h in e)if(e[h].checkElementRemovable(g,!0,c)){h!=b&&this.setValue(h);return}}this.setValue("")},this)},onOpen:function(){var a=c.getSelection(),a=a.getSelectedElement()||a.getStartElement()||c.editable(),a=c.elementPath(a),b=[0,0,0,0];this.showAll();this.unmarkAll();for(var f in e){var d=e[f],g=d._.type;d.checkApplicable(a,c,c.activeFilter)?b[g]++:this.hideItem(f);d.checkActive(a,c)&&this.mark(f)}b[CKEDITOR.STYLE_BLOCK]||this.hideGroup(h["panelTitle"+
String(CKEDITOR.STYLE_BLOCK)]);b[CKEDITOR.STYLE_INLINE]||this.hideGroup(h["panelTitle"+String(CKEDITOR.STYLE_INLINE)]);b[CKEDITOR.STYLE_OBJECT]||this.hideGroup(h["panelTitle"+String(CKEDITOR.STYLE_OBJECT)])},refresh:function(){var a=c.elementPath();if(a){for(var b in e)if(e[b].checkApplicable(a,c,c.activeFilter))return;this.setState(CKEDITOR.TRISTATE_DISABLED)}},reset:function(){e={};k=[]}})}})})();(function(){function k(c){return{editorFocus:!1,canUndo:!1,modes:{wysiwyg:1},exec:function(d){if(d.editable().hasFocus){var e=d.getSelection(),b;if(b=(new CKEDITOR.dom.elementPath(e.getCommonAncestor(),e.root)).contains({td:1,th:1},1)){var e=d.createRange(),a=CKEDITOR.tools.tryThese(function(){var a=b.getParent().$.cells[b.$.cellIndex+(c?-1:1)];a.parentNode.parentNode;return a},function(){var a=b.getParent(),a=a.getAscendant("table").$.rows[a.$.rowIndex+(c?-1:1)];return a.cells[c?a.cells.length-1:
0]});if(a||c)if(a)a=new CKEDITOR.dom.element(a),e.moveToElementEditStart(a),e.checkStartOfBlock()&&e.checkEndOfBlock()||e.selectNodeContents(a);else return!0;else{for(var f=b.getAscendant("table").$,a=b.getParent().$.cells,f=new CKEDITOR.dom.element(f.insertRow(-1),d.document),g=0,h=a.length;g<h;g++)f.append((new CKEDITOR.dom.element(a[g],d.document)).clone(!1,!1)).appendBogus();e.moveToElementEditStart(f)}e.select(!0);return!0}}return!1}}}var h={editorFocus:!1,modes:{wysiwyg:1,source:1}},g={exec:function(c){c.container.focusNext(!0,
c.tabIndex)}},f={exec:function(c){c.container.focusPrevious(!0,c.tabIndex)}};CKEDITOR.plugins.add("tab",{init:function(c){for(var d=!1!==c.config.enableTabKeyTools,e=c.config.tabSpaces||0,b="";e--;)b+=" ";if(b)c.on("key",function(a){9==a.data.keyCode&&(c.insertText(b),a.cancel())});if(d)c.on("key",function(a){(9==a.data.keyCode&&c.execCommand("selectNextCell")||a.data.keyCode==CKEDITOR.SHIFT+9&&c.execCommand("selectPreviousCell"))&&a.cancel()});c.addCommand("blur",CKEDITOR.tools.extend(g,h));c.addCommand("blurBack",
CKEDITOR.tools.extend(f,h));c.addCommand("selectNextCell",k());c.addCommand("selectPreviousCell",k(!0))}})})();
CKEDITOR.dom.element.prototype.focusNext=function(k,h){var g=void 0===h?this.getTabIndex():h,f,c,d,e,b,a;if(0>=g)for(b=this.getNextSourceNode(k,CKEDITOR.NODE_ELEMENT);b;){if(b.isVisible()&&0===b.getTabIndex()){d=b;break}b=b.getNextSourceNode(!1,CKEDITOR.NODE_ELEMENT)}else for(b=this.getDocument().getBody().getFirst();b=b.getNextSourceNode(!1,CKEDITOR.NODE_ELEMENT);){if(!f)if(!c&&b.equals(this)){if(c=!0,k){if(!(b=b.getNextSourceNode(!0,CKEDITOR.NODE_ELEMENT)))break;f=1}}else c&&!this.contains(b)&&
(f=1);if(b.isVisible()&&!(0>(a=b.getTabIndex()))){if(f&&a==g){d=b;break}a>g&&(!d||!e||a<e)?(d=b,e=a):d||0!==a||(d=b,e=a)}}d&&d.focus()};
CKEDITOR.dom.element.prototype.focusPrevious=function(k,h){for(var g=void 0===h?this.getTabIndex():h,f,c,d,e=0,b,a=this.getDocument().getBody().getLast();a=a.getPreviousSourceNode(!1,CKEDITOR.NODE_ELEMENT);){if(!f)if(!c&&a.equals(this)){if(c=!0,k){if(!(a=a.getPreviousSourceNode(!0,CKEDITOR.NODE_ELEMENT)))break;f=1}}else c&&!this.contains(a)&&(f=1);if(a.isVisible()&&!(0>(b=a.getTabIndex())))if(0>=g){if(f&&0===b){d=a;break}b>e&&(d=a,e=b)}else{if(f&&b==g){d=a;break}b<g&&(!d||b>e)&&(d=a,e=b)}}d&&d.focus()};CKEDITOR.plugins.add("table",{requires:"dialog",init:function(a){function f(c){return CKEDITOR.tools.extend(c||{},{contextSensitive:1,refresh:function(c,b){this.setState(b.contains("table",1)?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED)}})}if(!a.blockless){var e=a.lang.table;a.addCommand("table",new CKEDITOR.dialogCommand("table",{context:"table",allowedContent:"table{width,height,border-collapse}[align,border,cellpadding,cellspacing,summary];caption tbody thead tfoot;th td tr[scope];td{border*,background-color,vertical-align,width,height}[colspan,rowspan];"+
(a.plugins.dialogadvtab?"table"+a.plugins.dialogadvtab.allowedContent():""),requiredContent:"table",contentTransformations:[["table{width}: sizeToStyle","table[width]: sizeToAttribute"],["td: splitBorderShorthand"],[{element:"table",right:function(c){if(c.styles){var a;if(c.styles.border)a=CKEDITOR.tools.style.parse.border(c.styles.border);else if(CKEDITOR.env.ie&&8===CKEDITOR.env.version){var b=c.styles;b["border-left"]&&b["border-left"]===b["border-right"]&&b["border-right"]===b["border-top"]&&
b["border-top"]===b["border-bottom"]&&(a=CKEDITOR.tools.style.parse.border(b["border-top"]))}a&&a.style&&"solid"===a.style&&a.width&&0!==parseFloat(a.width)&&(c.attributes.border=1);"collapse"==c.styles["border-collapse"]&&(c.attributes.cellspacing=0)}}}]]}));a.addCommand("tableProperties",new CKEDITOR.dialogCommand("tableProperties",f()));a.addCommand("tableDelete",f({exec:function(a){var d=a.elementPath().contains("table",1);if(d){var b=d.getParent(),e=a.editable();1!=b.getChildCount()||b.is("td",
"th")||b.equals(e)||(d=b);a=a.createRange();a.moveToPosition(d,CKEDITOR.POSITION_BEFORE_START);d.remove();a.select()}}}));a.ui.addButton&&a.ui.addButton("Table",{label:e.toolbar,command:"table",toolbar:"insert,30"});CKEDITOR.dialog.add("table",this.path+"dialogs/table.js");CKEDITOR.dialog.add("tableProperties",this.path+"dialogs/table.js");a.addMenuItems&&a.addMenuItems({table:{label:e.menu,command:"tableProperties",group:"table",order:5},tabledelete:{label:e.deleteTable,command:"tableDelete",group:"table",
order:1}});a.on("doubleclick",function(a){a.data.element.is("table")&&(a.data.dialog="tableProperties")});a.contextMenu&&a.contextMenu.addListener(function(){return{tabledelete:CKEDITOR.TRISTATE_OFF,table:CKEDITOR.TRISTATE_OFF}})}}});(function(){function q(d,f){function b(a){return f?f.contains(a)&&a.getAscendant("table",!0).equals(f):!0}function c(a){var b=/^(?:td|th)$/;0<e.length||a.type!=CKEDITOR.NODE_ELEMENT||!b.test(a.getName())||a.getCustomData("selected_cell")||(CKEDITOR.dom.element.setMarker(h,a,"selected_cell",!0),e.push(a))}var e=[],h={};if(!d)return e;for(var a=d.getRanges(),k=0;k<a.length;k++){var g=a[k];if(g.collapsed)(g=g.getCommonAncestor().getAscendant({td:1,th:1},!0))&&b(g)&&e.push(g);else{var g=new CKEDITOR.dom.walker(g),
m;for(g.guard=c;m=g.next();)m.type==CKEDITOR.NODE_ELEMENT&&m.is(CKEDITOR.dtd.table)||(m=m.getAscendant({td:1,th:1},!0))&&!m.getCustomData("selected_cell")&&b(m)&&(CKEDITOR.dom.element.setMarker(h,m,"selected_cell",!0),e.push(m))}}CKEDITOR.dom.element.clearAllMarkers(h);return e}function r(d,f){for(var b=D(d)?d:q(d),c=b[0],e=c.getAscendant("table"),c=c.getDocument(),h=b[0].getParent(),a=h.$.rowIndex,b=b[b.length-1],k=b.getParent().$.rowIndex+b.$.rowSpan-1,b=new CKEDITOR.dom.element(e.$.rows[k]),a=
f?a:k,h=f?h:b,b=CKEDITOR.tools.buildTableMap(e),e=b[a],a=f?b[a-1]:b[a+1],b=b[0].length,c=c.createElement("tr"),k=0;e[k]&&k<b;k++){var g;1<e[k].rowSpan&&a&&e[k]==a[k]?(g=e[k],g.rowSpan+=1):(g=(new CKEDITOR.dom.element(e[k])).clone(),g.removeAttribute("rowSpan"),g.appendBogus(),c.append(g),g=g.$);k+=g.colSpan-1}f?c.insertBefore(h):c.insertAfter(h);return c}function B(d){if(d instanceof CKEDITOR.dom.selection){var f=d.getRanges(),b=q(d),c=b[0].getAscendant("table"),e=CKEDITOR.tools.buildTableMap(c),
h=b[0].getParent().$.rowIndex,b=b[b.length-1],a=b.getParent().$.rowIndex+b.$.rowSpan-1,b=[];d.reset();for(d=h;d<=a;d++){for(var k=e[d],g=new CKEDITOR.dom.element(c.$.rows[d]),m=0;m<k.length;m++){var l=new CKEDITOR.dom.element(k[m]),n=l.getParent().$.rowIndex;1==l.$.rowSpan?l.remove():(--l.$.rowSpan,n==d&&(n=e[d+1],n[m-1]?l.insertAfter(new CKEDITOR.dom.element(n[m-1])):(new CKEDITOR.dom.element(c.$.rows[d+1])).append(l,1)));m+=l.$.colSpan-1}b.push(g)}e=c.$.rows;f[0].moveToPosition(c,CKEDITOR.POSITION_BEFORE_START);
h=new CKEDITOR.dom.element(e[a+1]||(0<h?e[h-1]:null)||c.$.parentNode);for(d=b.length;0<=d;d--)B(b[d]);return c.$.parentNode?h:(f[0].select(),null)}d instanceof CKEDITOR.dom.element&&(c=d.getAscendant("table"),1==c.$.rows.length?c.remove():d.remove());return null}function v(d){for(var f=d.getParent().$.cells,b=0,c=0;c<f.length;c++){var e=f[c],b=b+e.colSpan;if(e==d.$)break}return b-1}function w(d,f){for(var b=f?Infinity:0,c=0;c<d.length;c++){var e=v(d[c]);if(f?e<b:e>b)b=e}return b}function u(d,f){for(var b=
D(d)?d:q(d),c=b[0].getAscendant("table"),e=w(b,1),b=w(b),h=f?e:b,a=CKEDITOR.tools.buildTableMap(c),c=[],e=[],b=[],k=a.length,g=0;g<k;g++){var m=f?a[g][h-1]:a[g][h+1];c.push(a[g][h]);e.push(m)}for(g=0;g<k;g++)c[g]&&(1<c[g].colSpan&&e[g]==c[g]?(a=c[g],a.colSpan+=1):(h=new CKEDITOR.dom.element(c[g]),a=h.clone(),a.removeAttribute("colSpan"),a.appendBogus(),a[f?"insertBefore":"insertAfter"].call(a,h),b.push(a),a=a.$),g+=a.rowSpan-1);return b}function y(d){function f(a){var b=a.getRanges(),c,d;if(1!==b.length)return a;
b=b[0];if(b.collapsed||0!==b.endOffset)return a;c=b.endContainer;d=c.getName().toLowerCase();if("td"!==d&&"th"!==d)return a;for((d=c.getPrevious())||(d=c.getParent().getPrevious().getLast());d.type!==CKEDITOR.NODE_TEXT&&"br"!==d.getName().toLowerCase();)if(d=d.getLast(),!d)return a;b.setEndAt(d,CKEDITOR.POSITION_BEFORE_END);return b.select()}CKEDITOR.env.webkit&&!d.isFake&&(d=f(d));var b=d.getRanges(),c=q(d),e=c[0],h=c[c.length-1],c=e.getAscendant("table"),a=CKEDITOR.tools.buildTableMap(c),k,g,m=
[];d.reset();var l=0;for(d=a.length;l<d;l++)for(var n=0,p=a[l].length;n<p;n++)void 0===k&&a[l][n]==e.$&&(k=n),a[l][n]==h.$&&(g=n);for(l=k;l<=g;l++)for(n=0;n<a.length;n++)h=a[n],e=new CKEDITOR.dom.element(c.$.rows[n]),h=new CKEDITOR.dom.element(h[l]),h.$&&(1==h.$.colSpan?h.remove():--h.$.colSpan,n+=h.$.rowSpan-1,e.$.cells.length||m.push(e));k=a[0].length-1>g?new CKEDITOR.dom.element(a[0][g+1]):k&&-1!==a[0][k-1].cellIndex?new CKEDITOR.dom.element(a[0][k-1]):new CKEDITOR.dom.element(c.$.parentNode);
m.length==d&&(b[0].moveToPosition(c,CKEDITOR.POSITION_AFTER_END),b[0].select(),c.remove());return k}function t(d,f){var b=d.getStartElement().getAscendant({td:1,th:1},!0);if(b){var c=b.clone();c.appendBogus();f?c.insertBefore(b):c.insertAfter(b)}}function z(d){if(d instanceof CKEDITOR.dom.selection){var f=d.getRanges(),b=q(d),c=b[0]&&b[0].getAscendant("table"),e;a:{var h=0;e=b.length-1;for(var a={},k,g;k=b[h++];)CKEDITOR.dom.element.setMarker(a,k,"delete_cell",!0);for(h=0;k=b[h++];)if((g=k.getPrevious())&&
!g.getCustomData("delete_cell")||(g=k.getNext())&&!g.getCustomData("delete_cell")){CKEDITOR.dom.element.clearAllMarkers(a);e=g;break a}CKEDITOR.dom.element.clearAllMarkers(a);h=b[0].getParent();(h=h.getPrevious())?e=h.getLast():(h=b[e].getParent(),e=(h=h.getNext())?h.getChild(0):null)}d.reset();for(d=b.length-1;0<=d;d--)z(b[d]);e?p(e,!0):c&&(f[0].moveToPosition(c,CKEDITOR.POSITION_BEFORE_START),f[0].select(),c.remove())}else d instanceof CKEDITOR.dom.element&&(f=d.getParent(),1==f.getChildCount()?
f.remove():d.remove())}function p(d,f){var b=d.getDocument(),c=CKEDITOR.document;CKEDITOR.env.ie&&10==CKEDITOR.env.version&&(c.focus(),b.focus());b=new CKEDITOR.dom.range(b);b["moveToElementEdit"+(f?"End":"Start")](d)||(b.selectNodeContents(d),b.collapse(f?!1:!0));b.select(!0)}function A(d,f,b){d=d[f];if("undefined"==typeof b)return d;for(f=0;d&&f<d.length;f++){if(b.is&&d[f]==b.$)return f;if(f==b)return new CKEDITOR.dom.element(d[f])}return b.is?-1:null}function x(d,f,b){var c=q(d),e;if((f?1!=c.length:
2>c.length)||(e=d.getCommonAncestor())&&e.type==CKEDITOR.NODE_ELEMENT&&e.is("table"))return!1;d=c[0];e=d.getAscendant("table");var h=CKEDITOR.tools.buildTableMap(e),a=h.length,k=h[0].length,g=d.getParent().$.rowIndex,m=A(h,g,d),l;if(f){var n;try{var p=parseInt(d.getAttribute("rowspan"),10)||1;l=parseInt(d.getAttribute("colspan"),10)||1;n=h["up"==f?g-p:"down"==f?g+p:g]["left"==f?m-l:"right"==f?m+l:m]}catch(x){return!1}if(!n||d.$==n)return!1;c["up"==f||"left"==f?"unshift":"push"](new CKEDITOR.dom.element(n))}f=
d.getDocument();var r=g,p=n=0,u=!b&&new CKEDITOR.dom.documentFragment(f),w=0;for(f=0;f<c.length;f++){l=c[f];var t=l.getParent(),y=l.getFirst(),v=l.$.colSpan,z=l.$.rowSpan,t=t.$.rowIndex,B=A(h,t,l),w=w+v*z,p=Math.max(p,B-m+v);n=Math.max(n,t-g+z);b||(v=l,(z=v.getBogus())&&z.remove(),v.trim(),l.getChildren().count()&&(t==r||!y||y.isBlockBoundary&&y.isBlockBoundary({br:1})||(r=u.getLast(CKEDITOR.dom.walker.whitespaces(!0)),!r||r.is&&r.is("br")||u.append("br")),l.moveChildren(u)),f?l.remove():l.setHtml(""));
r=t}if(b)return n*p==w;u.moveChildren(d);d.appendBogus();p>=k?d.removeAttribute("rowSpan"):d.$.rowSpan=n;n>=a?d.removeAttribute("colSpan"):d.$.colSpan=p;b=new CKEDITOR.dom.nodeList(e.$.rows);c=b.count();for(f=c-1;0<=f;f--)e=b.getItem(f),e.$.cells.length||(e.remove(),c++);return d}function C(d,f){var b=q(d);if(1<b.length)return!1;if(f)return!0;var b=b[0],c=b.getParent(),e=c.getAscendant("table"),h=CKEDITOR.tools.buildTableMap(e),a=c.$.rowIndex,k=A(h,a,b),g=b.$.rowSpan,m;if(1<g){m=Math.ceil(g/2);for(var g=
Math.floor(g/2),c=a+m,e=new CKEDITOR.dom.element(e.$.rows[c]),h=A(h,c),l,c=b.clone(),a=0;a<h.length;a++)if(l=h[a],l.parentNode==e.$&&a>k){c.insertBefore(new CKEDITOR.dom.element(l));break}else l=null;l||e.append(c)}else for(g=m=1,e=c.clone(),e.insertAfter(c),e.append(c=b.clone()),l=A(h,a),k=0;k<l.length;k++)l[k].rowSpan++;c.appendBogus();b.$.rowSpan=m;c.$.rowSpan=g;1==m&&b.removeAttribute("rowSpan");1==g&&c.removeAttribute("rowSpan");return c}function E(d,f){var b=q(d);if(1<b.length)return!1;if(f)return!0;
var b=b[0],c=b.getParent(),e=c.getAscendant("table"),e=CKEDITOR.tools.buildTableMap(e),h=A(e,c.$.rowIndex,b),a=b.$.colSpan;if(1<a)c=Math.ceil(a/2),a=Math.floor(a/2);else{for(var a=c=1,k=[],g=0;g<e.length;g++){var m=e[g];k.push(m[h]);1<m[h].rowSpan&&(g+=m[h].rowSpan-1)}for(e=0;e<k.length;e++)k[e].colSpan++}e=b.clone();e.insertAfter(b);e.appendBogus();b.$.colSpan=c;e.$.colSpan=a;1==c&&b.removeAttribute("colSpan");1==a&&e.removeAttribute("colSpan");return e}var D=CKEDITOR.tools.isArray;CKEDITOR.plugins.tabletools=
{requires:"table,dialog,contextmenu",init:function(d){function f(a){return CKEDITOR.tools.extend(a||{},{contextSensitive:1,refresh:function(a,b){this.setState(b.contains({td:1,th:1},1)?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED)}})}function b(a,b){var c=d.addCommand(a,b);d.addFeature(c)}var c=d.lang.table,e=CKEDITOR.tools.style.parse,h="td{width} td{height} td{border-color} td{background-color} td{white-space} td{vertical-align} td{text-align} td[colspan] td[rowspan] th".split(" ");b("cellProperties",
new CKEDITOR.dialogCommand("cellProperties",f({allowedContent:"td th{width,height,border-color,background-color,white-space,vertical-align,text-align}[colspan,rowspan]",requiredContent:h,contentTransformations:[[{element:"td",left:function(a){return a.styles.background&&e.background(a.styles.background).color},right:function(a){a.styles["background-color"]=e.background(a.styles.background).color}},{element:"td",check:"td{vertical-align}",left:function(a){return a.attributes&&a.attributes.valign},
right:function(a){a.styles["vertical-align"]=a.attributes.valign;delete a.attributes.valign}}],[{element:"tr",check:"td{height}",left:function(a){return a.styles&&a.styles.height},right:function(a){CKEDITOR.tools.array.forEach(a.children,function(b){b.name in{td:1,th:1}&&(b.attributes["cke-row-height"]=a.styles.height)});delete a.styles.height}}],[{element:"td",check:"td{height}",left:function(a){return(a=a.attributes)&&a["cke-row-height"]},right:function(a){a.styles.height=a.attributes["cke-row-height"];
delete a.attributes["cke-row-height"]}}]]})));CKEDITOR.dialog.add("cellProperties",this.path+"dialogs/tableCell.js");b("rowDelete",f({requiredContent:"table",exec:function(a){a=a.getSelection();(a=B(a))&&p(a)}}));b("rowInsertBefore",f({requiredContent:"table",exec:function(a){a=a.getSelection();a=q(a);r(a,!0)}}));b("rowInsertAfter",f({requiredContent:"table",exec:function(a){a=a.getSelection();a=q(a);r(a)}}));b("columnDelete",f({requiredContent:"table",exec:function(a){a=a.getSelection();(a=y(a))&&
p(a,!0)}}));b("columnInsertBefore",f({requiredContent:"table",exec:function(a){a=a.getSelection();a=q(a);u(a,!0)}}));b("columnInsertAfter",f({requiredContent:"table",exec:function(a){a=a.getSelection();a=q(a);u(a)}}));b("cellDelete",f({requiredContent:"table",exec:function(a){a=a.getSelection();z(a)}}));b("cellMerge",f({allowedContent:"td[colspan,rowspan]",requiredContent:"td[colspan,rowspan]",exec:function(a,b){b.cell=x(a.getSelection());p(b.cell,!0)}}));b("cellMergeRight",f({allowedContent:"td[colspan]",
requiredContent:"td[colspan]",exec:function(a,b){b.cell=x(a.getSelection(),"right");p(b.cell,!0)}}));b("cellMergeDown",f({allowedContent:"td[rowspan]",requiredContent:"td[rowspan]",exec:function(a,b){b.cell=x(a.getSelection(),"down");p(b.cell,!0)}}));b("cellVerticalSplit",f({allowedContent:"td[rowspan]",requiredContent:"td[rowspan]",exec:function(a){p(E(a.getSelection()))}}));b("cellHorizontalSplit",f({allowedContent:"td[colspan]",requiredContent:"td[colspan]",exec:function(a){p(C(a.getSelection()))}}));
b("cellInsertBefore",f({requiredContent:"table",exec:function(a){a=a.getSelection();t(a,!0)}}));b("cellInsertAfter",f({requiredContent:"table",exec:function(a){a=a.getSelection();t(a)}}));d.addMenuItems&&d.addMenuItems({tablecell:{label:c.cell.menu,group:"tablecell",order:1,getItems:function(){var a=d.getSelection(),b=q(a),a={tablecell_insertBefore:CKEDITOR.TRISTATE_OFF,tablecell_insertAfter:CKEDITOR.TRISTATE_OFF,tablecell_delete:CKEDITOR.TRISTATE_OFF,tablecell_merge:x(a,null,!0)?CKEDITOR.TRISTATE_OFF:
CKEDITOR.TRISTATE_DISABLED,tablecell_merge_right:x(a,"right",!0)?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED,tablecell_merge_down:x(a,"down",!0)?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED,tablecell_split_vertical:E(a,!0)?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED,tablecell_split_horizontal:C(a,!0)?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED};d.filter.check(h)&&(a.tablecell_properties=0<b.length?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED);return a}},tablecell_insertBefore:{label:c.cell.insertBefore,
group:"tablecell",command:"cellInsertBefore",order:5},tablecell_insertAfter:{label:c.cell.insertAfter,group:"tablecell",command:"cellInsertAfter",order:10},tablecell_delete:{label:c.cell.deleteCell,group:"tablecell",command:"cellDelete",order:15},tablecell_merge:{label:c.cell.merge,group:"tablecell",command:"cellMerge",order:16},tablecell_merge_right:{label:c.cell.mergeRight,group:"tablecell",command:"cellMergeRight",order:17},tablecell_merge_down:{label:c.cell.mergeDown,group:"tablecell",command:"cellMergeDown",
order:18},tablecell_split_horizontal:{label:c.cell.splitHorizontal,group:"tablecell",command:"cellHorizontalSplit",order:19},tablecell_split_vertical:{label:c.cell.splitVertical,group:"tablecell",command:"cellVerticalSplit",order:20},tablecell_properties:{label:c.cell.title,group:"tablecellproperties",command:"cellProperties",order:21},tablerow:{label:c.row.menu,group:"tablerow",order:1,getItems:function(){return{tablerow_insertBefore:CKEDITOR.TRISTATE_OFF,tablerow_insertAfter:CKEDITOR.TRISTATE_OFF,
tablerow_delete:CKEDITOR.TRISTATE_OFF}}},tablerow_insertBefore:{label:c.row.insertBefore,group:"tablerow",command:"rowInsertBefore",order:5},tablerow_insertAfter:{label:c.row.insertAfter,group:"tablerow",command:"rowInsertAfter",order:10},tablerow_delete:{label:c.row.deleteRow,group:"tablerow",command:"rowDelete",order:15},tablecolumn:{label:c.column.menu,group:"tablecolumn",order:1,getItems:function(){return{tablecolumn_insertBefore:CKEDITOR.TRISTATE_OFF,tablecolumn_insertAfter:CKEDITOR.TRISTATE_OFF,
tablecolumn_delete:CKEDITOR.TRISTATE_OFF}}},tablecolumn_insertBefore:{label:c.column.insertBefore,group:"tablecolumn",command:"columnInsertBefore",order:5},tablecolumn_insertAfter:{label:c.column.insertAfter,group:"tablecolumn",command:"columnInsertAfter",order:10},tablecolumn_delete:{label:c.column.deleteColumn,group:"tablecolumn",command:"columnDelete",order:15}});d.contextMenu&&d.contextMenu.addListener(function(a,b,c){return(a=c.contains({td:1,th:1},1))&&!a.isReadOnly()?{tablecell:CKEDITOR.TRISTATE_OFF,
tablerow:CKEDITOR.TRISTATE_OFF,tablecolumn:CKEDITOR.TRISTATE_OFF}:null})},getCellColIndex:v,insertRow:r,insertColumn:u,getSelectedCells:q};CKEDITOR.plugins.add("tabletools",CKEDITOR.plugins.tabletools)})();
CKEDITOR.tools.buildTableMap=function(q,r,B,v,w){q=q.$.rows;B=B||0;v="number"===typeof v?v:q.length-1;w="number"===typeof w?w:-1;var u=-1,y=[];for(r=r||0;r<=v;r++){u++;!y[u]&&(y[u]=[]);for(var t=-1,z=B;z<=(-1===w?q[r].cells.length-1:w);z++){var p=q[r].cells[z];if(!p)break;for(t++;y[u][t];)t++;for(var A=isNaN(p.colSpan)?1:p.colSpan,p=isNaN(p.rowSpan)?1:p.rowSpan,x=0;x<p&&!(r+x>v);x++){y[u+x]||(y[u+x]=[]);for(var C=0;C<A;C++)y[u+x][t+C]=q[r].cells[z]}t+=A-1;if(-1!==w&&t>=w)break}}return y};(function(){function D(a){return CKEDITOR.plugins.widget&&CKEDITOR.plugins.widget.isDomWidget(a)}function z(a,b){var c=a.getAscendant("table"),d=b.getAscendant("table"),e=CKEDITOR.tools.buildTableMap(c),g=r(a),k=r(b),h=[],f={},l,p;c.contains(d)&&(b=b.getAscendant({td:1,th:1}),k=r(b));g>k&&(c=g,g=k,k=c,c=a,a=b,b=c);for(c=0;c<e[g].length;c++)if(a.$===e[g][c]){l=c;break}for(c=0;c<e[k].length;c++)if(b.$===e[k][c]){p=c;break}l>p&&(c=l,l=p,p=c);for(c=g;c<=k;c++)for(g=l;g<=p;g++)d=new CKEDITOR.dom.element(e[c][g]),
d.$&&!d.getCustomData("selected_cell")&&(h.push(d),CKEDITOR.dom.element.setMarker(f,d,"selected_cell",!0));CKEDITOR.dom.element.clearAllMarkers(f);return h}function I(a){return(a=a.editable().findOne(".cke_table-faked-selection"))&&a.getAscendant("table")}function A(a,b){var c=a.editable().find(".cke_table-faked-selection"),d=a.editable().findOne("[data-cke-table-faked-selection-table]"),e;a.fire("lockSnapshot");a.editable().removeClass("cke_table-faked-selection-editor");for(e=0;e<c.count();e++)c.getItem(e).removeClass("cke_table-faked-selection");
d&&d.data("cke-table-faked-selection-table",!1);a.fire("unlockSnapshot");b&&(m={active:!1},a.getSelection().isInTable()&&a.getSelection().reset())}function t(a,b){var c=[],d,e;for(e=0;e<b.length;e++)d=a.createRange(),d.setStartBefore(b[e]),d.setEndAfter(b[e]),c.push(d);a.getSelection().selectRanges(c)}function J(a){var b=a.editable().find(".cke_table-faked-selection");1>b.count()||(b=z(b.getItem(0),b.getItem(b.count()-1)),t(a,b))}function K(a,b,c){var d=v(a.getSelection(!0));b=b.is("table")?null:
b;var e;(e=m.active&&!m.first)&&!(e=b)&&(e=a.getSelection().getRanges(),e=1<d.length||e[0]&&!e[0].collapsed?!0:!1);if(e)m.first=b||d[0],m.dirty=b?!1:1!==d.length;else if(m.active&&b&&m.first.getAscendant("table").equals(b.getAscendant("table"))){d=z(m.first,b);if(!m.dirty&&1===d.length&&!D(c.data.getTarget()))return A(a,"mouseup"===c.name);m.dirty=!0;m.last=b;t(a,d)}}function L(a){var b=(a=a.editor||a.sender.editor)&&a.getSelection(),c=b&&b.getRanges()||[],d=c&&c[0].getEnclosedNode(),d=d&&d.type==
CKEDITOR.NODE_ELEMENT&&d.is("img"),e;if(b&&(A(a),b.isInTable()&&b.isFake))if(d)a.getSelection().reset();else if(!c[0]._getTableElement({table:1}).hasAttribute("data-cke-tableselection-ignored")){1===c.length&&c[0]._getTableElement()&&c[0]._getTableElement().is("table")&&(e=c[0]._getTableElement());e=v(b,e);a.fire("lockSnapshot");for(b=0;b<e.length;b++)e[b].addClass("cke_table-faked-selection");0<e.length&&(a.editable().addClass("cke_table-faked-selection-editor"),e[0].getAscendant("table").data("cke-table-faked-selection-table",
""));a.fire("unlockSnapshot")}}function r(a){return a.getAscendant("tr",!0).$.rowIndex}function w(a){function b(a,b){return a&&b?a.equals(b)||a.contains(b)||b.contains(a)||a.getCommonAncestor(b).is(l):!1}function c(a){return!a.getAscendant("table",!0)&&a.getDocument().equals(e.document)}function d(a,b,d,e){if("mousedown"===a.name&&(CKEDITOR.tools.getMouseButton(a)===CKEDITOR.MOUSE_BUTTON_LEFT||!e))return!0;if(b=a.name===(CKEDITOR.env.gecko?"mousedown":"mouseup")&&!c(a.data.getTarget()))a=a.data.getTarget().getAscendant({td:1,
th:1},!0),b=!(a&&a.hasClass("cke_table-faked-selection"));return b}if(a.data.getTarget().getName&&("mouseup"===a.name||!D(a.data.getTarget()))){var e=a.editor||a.listenerData.editor,g=e.getSelection(1),k=I(e),h=a.data.getTarget(),f=h&&h.getAscendant({td:1,th:1},!0),h=h&&h.getAscendant("table",!0),l={table:1,thead:1,tbody:1,tfoot:1,tr:1,td:1,th:1};h&&h.hasAttribute("data-cke-tableselection-ignored")||(d(a,g,k,h)&&A(e,!0),!m.active&&"mousedown"===a.name&&CKEDITOR.tools.getMouseButton(a)===CKEDITOR.MOUSE_BUTTON_LEFT&&
h&&(m={active:!0},CKEDITOR.document.on("mouseup",w,null,{editor:e})),(f||h)&&K(e,f||h,a),"mouseup"===a.name&&(CKEDITOR.tools.getMouseButton(a)===CKEDITOR.MOUSE_BUTTON_LEFT&&(c(a.data.getTarget())||b(k,h))&&J(e),m={active:!1},CKEDITOR.document.removeListener("mouseup",w)))}}function M(a){var b=a.data.getTarget().getAscendant("table",!0);b&&b.hasAttribute("data-cke-tableselection-ignored")||(b=a.data.getTarget().getAscendant({td:1,th:1},!0))&&!b.hasClass("cke_table-faked-selection")&&(a.cancel(),a.data.preventDefault())}
function N(a,b){function c(a){a.cancel()}var d=a.getSelection(),e=d.createBookmarks(),g=a.document,k=a.createRange(),h=g.getDocumentElement().$,f=CKEDITOR.env.ie&&9>CKEDITOR.env.version,l=a.blockless||CKEDITOR.env.ie?"span":"div",p,x,n,m;g.getById("cke_table_copybin")||(p=g.createElement(l),x=g.createElement(l),x.setAttributes({id:"cke_table_copybin","data-cke-temp":"1"}),p.setStyles({position:"absolute",width:"1px",height:"1px",overflow:"hidden"}),p.setStyle("ltr"==a.config.contentsLangDirection?
"left":"right","-5000px"),p.setHtml(a.getSelectedHtml(!0)),a.fire("lockSnapshot"),x.append(p),a.editable().append(x),m=a.on("selectionChange",c,null,null,0),f&&(n=h.scrollTop),k.selectNodeContents(p),k.select(),f&&(h.scrollTop=n),setTimeout(function(){x.remove();d.selectBookmarks(e);m.removeListener();a.fire("unlockSnapshot");b&&(a.extractSelectedHtml(),a.fire("saveSnapshot"))},100))}function E(a){var b=a.editor||a.sender.editor,c=b.getSelection();c.isInTable()&&(c.getRanges()[0]._getTableElement({table:1}).hasAttribute("data-cke-tableselection-ignored")||
N(b,"cut"===a.name))}function q(a){this._reset();a&&this.setSelectedCells(a)}function B(a,b,c){a.on("beforeCommandExec",function(d){-1!==CKEDITOR.tools.array.indexOf(b,d.data.name)&&(d.data.selectedCells=v(a.getSelection()))});a.on("afterCommandExec",function(d){-1!==CKEDITOR.tools.array.indexOf(b,d.data.name)&&c(a,d.data)})}var m={active:!1},y,v,C,F,G;q.prototype={};q.prototype._reset=function(){this.cells={first:null,last:null,all:[]};this.rows={first:null,last:null}};q.prototype.setSelectedCells=
function(a){this._reset();a=a.slice(0);this._arraySortByDOMOrder(a);this.cells.all=a;this.cells.first=a[0];this.cells.last=a[a.length-1];this.rows.first=a[0].getAscendant("tr");this.rows.last=this.cells.last.getAscendant("tr")};q.prototype.getTableMap=function(){var a=C(this.cells.first),b;a:{b=this.cells.last;var c=b.getAscendant("table"),d=r(b),c=CKEDITOR.tools.buildTableMap(c),e;for(e=0;e<c[d].length;e++)if((new CKEDITOR.dom.element(c[d][e])).equals(b)){b=e;break a}b=void 0}return CKEDITOR.tools.buildTableMap(this._getTable(),
r(this.rows.first),a,r(this.rows.last),b)};q.prototype._getTable=function(){return this.rows.first.getAscendant("table")};q.prototype.insertRow=function(a,b,c){if("undefined"===typeof a)a=1;else if(0>=a)return;for(var d=this.cells.first.$.cellIndex,e=this.cells.last.$.cellIndex,g=c?[]:this.cells.all,k,h=0;h<a;h++)k=F(c?this.cells.all:g,b),k=CKEDITOR.tools.array.filter(k.find("td, th").toArray(),function(a){return c?!0:a.$.cellIndex>=d&&a.$.cellIndex<=e}),g=b?k.concat(g):g.concat(k);this.setSelectedCells(g)};
q.prototype.insertColumn=function(a){function b(a){a=r(a);return a>=e&&a<=g}if("undefined"===typeof a)a=1;else if(0>=a)return;for(var c=this.cells,d=c.all,e=r(c.first),g=r(c.last),c=0;c<a;c++)d=d.concat(CKEDITOR.tools.array.filter(G(d),b));this.setSelectedCells(d)};q.prototype.emptyCells=function(a){a=a||this.cells.all;for(var b=0;b<a.length;b++)a[b].setHtml("")};q.prototype._arraySortByDOMOrder=function(a){a.sort(function(a,c){return a.getPosition(c)&CKEDITOR.POSITION_PRECEDING?-1:1})};var H={onPaste:function(a){function b(a){var b=
d.createRange();b.selectNodeContents(a);b.select()}function c(a){return Math.max.apply(null,CKEDITOR.tools.array.map(a,function(a){return a.length},0))}var d=a.editor,e=d.getSelection(),g=v(e),k=e.isInTable(!0)&&this.isBoundarySelection(e),h=this.findTableInPastedContent(d,a.data.dataValue),f,l;(function(a,b,d,c){a=a.getRanges();var e=a.length&&a[0]._getTableElement({table:1});if(!b.length||e&&e.hasAttribute("data-cke-tableselection-ignored")||c&&!d)return!1;if(b=!c)(b=a[0])?(b=b.clone(),b.enlarge(CKEDITOR.ENLARGE_ELEMENT),
b=(b=b.getEnclosedNode())&&b.is&&b.is(CKEDITOR.dtd.$tableContent)):b=void 0,b=!b;return b?!1:!0})(e,g,h,k)&&(g=g[0].getAscendant("table"),f=new q(v(e,g)),d.once("afterPaste",function(){var a;if(l){a=new CKEDITOR.dom.element(l[0][0]);var b=l[l.length-1];a=z(a,new CKEDITOR.dom.element(b[b.length-1]))}else a=f.cells.all;t(d,a)}),h?(a.stop(),k?(f.insertRow(1,1===k,!0),e.selectElement(f.rows.first)):(f.emptyCells(),t(d,f.cells.all)),a=f.getTableMap(),l=CKEDITOR.tools.buildTableMap(h),f.insertRow(l.length-
a.length),f.insertColumn(c(l)-c(a)),a=f.getTableMap(),this.pasteTable(f,a,l),d.fire("saveSnapshot"),setTimeout(function(){d.fire("afterPaste")},0)):(b(f.cells.first),d.once("afterPaste",function(){d.fire("lockSnapshot");f.emptyCells(f.cells.all.slice(1));t(d,f.cells.all);d.fire("unlockSnapshot")})))},isBoundarySelection:function(a){a=a.getRanges()[0];var b=a.endContainer.getAscendant("tr",!0);if(b&&a.collapsed){if(a.checkBoundaryOfElement(b,CKEDITOR.START))return 1;if(a.checkBoundaryOfElement(b,CKEDITOR.END))return 2}return 0},
findTableInPastedContent:function(a,b){var c=a.dataProcessor,d=new CKEDITOR.dom.element("body");c||(c=new CKEDITOR.htmlDataProcessor(a));d.setHtml(c.toHtml(b),{fixForBody:!1});return 1<d.getChildCount()?null:d.findOne("table")},pasteTable:function(a,b,c){var d,e=C(a.cells.first),g=a._getTable(),k={},h,f,l,p;for(l=0;l<c.length;l++)for(h=new CKEDITOR.dom.element(g.$.rows[a.rows.first.$.rowIndex+l]),p=0;p<c[l].length;p++)if(f=new CKEDITOR.dom.element(c[l][p]),d=b[l]&&b[l][p]?new CKEDITOR.dom.element(b[l][p]):
null,f&&!f.getCustomData("processed")){if(d&&d.getParent())f.replace(d);else if(0===p||c[l][p-1])(d=0!==p?new CKEDITOR.dom.element(c[l][p-1]):null)&&h.equals(d.getParent())?f.insertAfter(d):0<e?h.$.cells[e]?f.insertAfter(new CKEDITOR.dom.element(h.$.cells[e])):h.append(f):h.append(f,!0);CKEDITOR.dom.element.setMarker(k,f,"processed",!0)}else f.getCustomData("processed")&&d&&d.remove();CKEDITOR.dom.element.clearAllMarkers(k)}};CKEDITOR.plugins.tableselection={getCellsBetween:z,keyboardIntegration:function(a){function b(a){var b=
a.getEnclosedNode();b&&"function"===typeof b.is&&b.is({td:1,th:1})?b.setText(""):a.deleteContents();CKEDITOR.tools.array.forEach(a._find("td"),function(a){a.appendBogus()})}var c=a.editable();c.attachListener(c,"keydown",function(a){function c(b,e){if(!e.length)return null;var l=a.createRange(),g=CKEDITOR.dom.range.mergeRanges(e);CKEDITOR.tools.array.forEach(g,function(a){a.enlarge(CKEDITOR.ENLARGE_ELEMENT)});var m=g[0].getBoundaryNodes(),n=m.startNode,m=m.endNode;if(n&&n.is&&n.is(k)){for(var q=n.getAscendant("table",
!0),u=n.getPreviousSourceNode(!1,CKEDITOR.NODE_ELEMENT,q),r=!1,t=function(a){return!n.contains(a)&&a.is&&a.is("td","th")};u&&!t(u);)u=u.getPreviousSourceNode(!1,CKEDITOR.NODE_ELEMENT,q);!u&&m&&m.is&&!m.is("table")&&m.getNext()&&(u=m.getNext().findOne("td, th"),r=!0);if(u)l["moveToElementEdit"+(r?"Start":"End")](u);else l.setStartBefore(n.getAscendant("table",!0)),l.collapse(!0);g[0].deleteContents();return[l]}if(n)return l.moveToElementEditablePosition(n),[l]}var g={37:1,38:1,39:1,40:1,8:1,46:1,13:1},
k=CKEDITOR.tools.extend({table:1},CKEDITOR.dtd.$tableContent);delete k.td;delete k.th;return function(h){var f=h.data.getKey(),l=h.data.getKeystroke(),k,m=37===f||38==f,n,q,r;if(g[f]&&!a.readOnly&&(k=a.getSelection())&&k.isInTable()&&k.isFake){n=k.getRanges();q=n[0]._getTableElement();r=n[n.length-1]._getTableElement();if(13!==f||a.plugins.enterkey)h.data.preventDefault(),h.cancel();if(36<f&&41>f)n[0].moveToElementEditablePosition(m?q:r,!m),k.selectRanges([n[0]]);else if(13!==f||13===l||l===CKEDITOR.SHIFT+
13){for(h=0;h<n.length;h++)b(n[h]);(h=c(q,n))?n=h:n[0].moveToElementEditablePosition(q);k.selectRanges(n);13===f&&a.plugins.enterkey?(a.fire("lockSnapshot"),13===l?a.execCommand("enter"):a.execCommand("shiftEnter"),a.fire("unlockSnapshot"),a.fire("saveSnapshot")):13!==f&&a.fire("saveSnapshot")}}}}(a),null,null,-1);c.attachListener(c,"keypress",function(c){var e=a.getSelection(),g=c.data.$.charCode||13===c.data.getKey(),k;if(!a.readOnly&&e&&e.isInTable()&&e.isFake&&g&&!(c.data.getKeystroke()&CKEDITOR.CTRL)){c=
e.getRanges();g=c[0].getEnclosedNode().getAscendant({td:1,th:1},!0);for(k=0;k<c.length;k++)b(c[k]);g&&(c[0].moveToElementEditablePosition(g),e.selectRanges([c[0]]))}},null,null,-1)}};CKEDITOR.plugins.add("tableselection",{requires:"clipboard,tabletools",isSupportedEnvironment:function(){return!(CKEDITOR.env.ie&&11>CKEDITOR.env.version)},onLoad:function(){y=CKEDITOR.plugins.tabletools;v=y.getSelectedCells;C=y.getCellColIndex;F=y.insertRow;G=y.insertColumn;CKEDITOR.document.appendStyleSheet(this.path+
"styles/tableselection.css")},init:function(a){this.isSupportedEnvironment()&&(a.addContentsCss&&a.addContentsCss(this.path+"styles/tableselection.css"),a.on("contentDom",function(){var b=a.editable(),c=b.isInline()?b:a.document,d={editor:a};b.attachListener(c,"mousedown",w,null,d);b.attachListener(c,"mousemove",w,null,d);b.attachListener(c,"mouseup",w,null,d);b.attachListener(b,"dragstart",M);b.attachListener(a,"selectionCheck",L);CKEDITOR.plugins.tableselection.keyboardIntegration(a);CKEDITOR.plugins.clipboard&&
!CKEDITOR.plugins.clipboard.isCustomCopyCutSupported&&(b.attachListener(b,"cut",E),b.attachListener(b,"copy",E))}),a.on("paste",H.onPaste,H),B(a,"rowInsertBefore rowInsertAfter columnInsertBefore columnInsertAfter cellInsertBefore cellInsertAfter".split(" "),function(a,c){t(a,c.selectedCells)}),B(a,["cellMerge","cellMergeRight","cellMergeDown"],function(a,c){t(a,[c.commandData.cell])}),B(a,["cellDelete"],function(a){A(a,!0)}))}})})();(function(){function n(a,b){return CKEDITOR.tools.array.reduce(b,function(a,b){return b(a)},a)}var g=[CKEDITOR.CTRL+90,CKEDITOR.CTRL+89,CKEDITOR.CTRL+CKEDITOR.SHIFT+90],p={8:1,46:1};CKEDITOR.plugins.add("undo",{init:function(a){function b(a){d.enabled&&!1!==a.data.command.canUndo&&d.save()}function c(){d.enabled=a.readOnly?!1:"wysiwyg"==a.mode;d.onChange()}var d=a.undoManager=new e(a),l=d.editingHandler=new k(d),f=a.addCommand("undo",{exec:function(){d.undo()&&(a.selectionChange(),this.fire("afterUndo"))},
startDisabled:!0,canUndo:!1}),h=a.addCommand("redo",{exec:function(){d.redo()&&(a.selectionChange(),this.fire("afterRedo"))},startDisabled:!0,canUndo:!1});a.setKeystroke([[g[0],"undo"],[g[1],"redo"],[g[2],"redo"]]);d.onChange=function(){f.setState(d.undoable()?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED);h.setState(d.redoable()?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED)};a.on("beforeCommandExec",b);a.on("afterCommandExec",b);a.on("saveSnapshot",function(a){d.save(a.data&&a.data.contentOnly)});
a.on("contentDom",l.attachListeners,l);a.on("instanceReady",function(){a.fire("saveSnapshot")});a.on("beforeModeUnload",function(){"wysiwyg"==a.mode&&d.save(!0)});a.on("mode",c);a.on("readOnly",c);a.ui.addButton&&(a.ui.addButton("Undo",{label:a.lang.undo.undo,command:"undo",toolbar:"undo,10"}),a.ui.addButton("Redo",{label:a.lang.undo.redo,command:"redo",toolbar:"undo,20"}));a.resetUndo=function(){d.reset();a.fire("saveSnapshot")};a.on("updateSnapshot",function(){d.currentImage&&d.update()});a.on("lockSnapshot",
function(a){a=a.data;d.lock(a&&a.dontUpdate,a&&a.forceUpdate)});a.on("unlockSnapshot",d.unlock,d)}});CKEDITOR.plugins.undo={};var e=CKEDITOR.plugins.undo.UndoManager=function(a){this.strokesRecorded=[0,0];this.locked=null;this.previousKeyGroup=-1;this.limit=a.config.undoStackSize||20;this.strokesLimit=25;this._filterRules=[];this.editor=a;this.reset();CKEDITOR.env.ie&&this.addFilterRule(function(a){return a.replace(/\s+data-cke-expando=".*?"/g,"")})};e.prototype={type:function(a,b){var c=e.getKeyGroup(a),
d=this.strokesRecorded[c]+1;b=b||d>=this.strokesLimit;this.typing||(this.hasUndo=this.typing=!0,this.hasRedo=!1,this.onChange());b?(d=0,this.editor.fire("saveSnapshot")):this.editor.fire("change");this.strokesRecorded[c]=d;this.previousKeyGroup=c},keyGroupChanged:function(a){return e.getKeyGroup(a)!=this.previousKeyGroup},reset:function(){this.snapshots=[];this.index=-1;this.currentImage=null;this.hasRedo=this.hasUndo=!1;this.locked=null;this.resetType()},resetType:function(){this.strokesRecorded=
[0,0];this.typing=!1;this.previousKeyGroup=-1},refreshState:function(){this.hasUndo=!!this.getNextImage(!0);this.hasRedo=!!this.getNextImage(!1);this.resetType();this.onChange()},save:function(a,b,c){var d=this.editor;if(this.locked||"ready"!=d.status||"wysiwyg"!=d.mode)return!1;var e=d.editable();if(!e||"ready"!=e.status)return!1;e=this.snapshots;b||(b=new f(d));if(!1===b.contents)return!1;if(this.currentImage)if(b.equalsContent(this.currentImage)){if(a||b.equalsSelection(this.currentImage))return!1}else!1!==
c&&d.fire("change");e.splice(this.index+1,e.length-this.index-1);e.length==this.limit&&e.shift();this.index=e.push(b)-1;this.currentImage=b;!1!==c&&this.refreshState();return!0},restoreImage:function(a){var b=this.editor,c;a.bookmarks&&(b.focus(),c=b.getSelection());this.locked={level:999};this.editor.loadSnapshot(a.contents);a.bookmarks?c.selectBookmarks(a.bookmarks):CKEDITOR.env.ie&&(c=this.editor.document.getBody().$.createTextRange(),c.collapse(!0),c.select());this.locked=null;this.index=a.index;
this.currentImage=this.snapshots[this.index];this.update();this.refreshState();b.fire("change")},getNextImage:function(a){var b=this.snapshots,c=this.currentImage,d;if(c)if(a)for(d=this.index-1;0<=d;d--){if(a=b[d],!c.equalsContent(a))return a.index=d,a}else for(d=this.index+1;d<b.length;d++)if(a=b[d],!c.equalsContent(a))return a.index=d,a;return null},redoable:function(){return this.enabled&&this.hasRedo},undoable:function(){return this.enabled&&this.hasUndo},undo:function(){if(this.undoable()){this.save(!0);
var a=this.getNextImage(!0);if(a)return this.restoreImage(a),!0}return!1},redo:function(){if(this.redoable()&&(this.save(!0),this.redoable())){var a=this.getNextImage(!1);if(a)return this.restoreImage(a),!0}return!1},update:function(a){if(!this.locked){a||(a=new f(this.editor));for(var b=this.index,c=this.snapshots;0<b&&this.currentImage.equalsContent(c[b-1]);)--b;c.splice(b,this.index-b+1,a);this.index=b;this.currentImage=a}},updateSelection:function(a){if(!this.snapshots.length)return!1;var b=this.snapshots,
c=b[b.length-1];return c.equalsContent(a)&&!c.equalsSelection(a)?(this.currentImage=b[b.length-1]=a,!0):!1},lock:function(a,b){if(this.locked)this.locked.level++;else if(a)this.locked={level:1};else{var c=null;if(b)c=!0;else{var d=new f(this.editor,!0);this.currentImage&&this.currentImage.equalsContent(d)&&(c=d)}this.locked={update:c,level:1}}},unlock:function(){if(this.locked&&!--this.locked.level){var a=this.locked.update;this.locked=null;if(!0===a)this.update();else if(a){var b=new f(this.editor,
!0);a.equalsContent(b)||this.update()}}},addFilterRule:function(a){this._filterRules.push(a)}};e.navigationKeyCodes={37:1,38:1,39:1,40:1,36:1,35:1,33:1,34:1};e.keyGroups={PRINTABLE:0,FUNCTIONAL:1};e.isNavigationKey=function(a){return!!e.navigationKeyCodes[a]};e.getKeyGroup=function(a){var b=e.keyGroups;return p[a]?b.FUNCTIONAL:b.PRINTABLE};e.getOppositeKeyGroup=function(a){var b=e.keyGroups;return a==b.FUNCTIONAL?b.PRINTABLE:b.FUNCTIONAL};e.ieFunctionalKeysBug=function(a){return CKEDITOR.env.ie&&
e.getKeyGroup(a)==e.keyGroups.FUNCTIONAL};var f=CKEDITOR.plugins.undo.Image=function(a,b){this.editor=a;a.fire("beforeUndoImage");var c=a.getSnapshot();c&&(this.contents=n(c,a.undoManager._filterRules));b||(this.bookmarks=(c=c&&a.getSelection())&&c.createBookmarks2(!0));a.fire("afterUndoImage")},h=/\b(?:href|src|name)="[^"]*?"/gi;f.prototype={equalsContent:function(a){var b=this.contents;a=a.contents;CKEDITOR.env.ie&&(CKEDITOR.env.ie7Compat||CKEDITOR.env.quirks)&&(b=b.replace(h,""),a=a.replace(h,
""));return b!=a?!1:!0},equalsSelection:function(a){var b=this.bookmarks;a=a.bookmarks;if(b||a){if(!b||!a||b.length!=a.length)return!1;for(var c=0;c<b.length;c++){var d=b[c],e=a[c];if(d.startOffset!=e.startOffset||d.endOffset!=e.endOffset||!CKEDITOR.tools.arrayCompare(d.start,e.start)||!CKEDITOR.tools.arrayCompare(d.end,e.end))return!1}}return!0}};var k=CKEDITOR.plugins.undo.NativeEditingHandler=function(a){this.undoManager=a;this.ignoreInputEvent=!1;this.keyEventsStack=new m;this.lastKeydownImage=
null};k.prototype={onKeydown:function(a){var b=a.data.getKey();if(229!==b)if(-1<CKEDITOR.tools.indexOf(g,a.data.getKeystroke()))a.data.preventDefault();else if(this.keyEventsStack.cleanUp(a),a=this.undoManager,this.keyEventsStack.getLast(b)||this.keyEventsStack.push(b),this.lastKeydownImage=new f(a.editor),e.isNavigationKey(b)||this.undoManager.keyGroupChanged(b))if(a.strokesRecorded[0]||a.strokesRecorded[1])a.save(!1,this.lastKeydownImage,!1),a.resetType()},onInput:function(){if(this.ignoreInputEvent)this.ignoreInputEvent=
!1;else{var a=this.keyEventsStack.getLast();a||(a=this.keyEventsStack.push(0));this.keyEventsStack.increment(a.keyCode);this.keyEventsStack.getTotalInputs()>=this.undoManager.strokesLimit&&(this.undoManager.type(a.keyCode,!0),this.keyEventsStack.resetInputs())}},onKeyup:function(a){var b=this.undoManager;a=a.data.getKey();var c=this.keyEventsStack.getTotalInputs();this.keyEventsStack.remove(a);if(!(e.ieFunctionalKeysBug(a)&&this.lastKeydownImage&&this.lastKeydownImage.equalsContent(new f(b.editor,
!0))))if(0<c)b.type(a);else if(e.isNavigationKey(a))this.onNavigationKey(!0)},onNavigationKey:function(a){var b=this.undoManager;!a&&b.save(!0,null,!1)||b.updateSelection(new f(b.editor));b.resetType()},ignoreInputEventListener:function(){this.ignoreInputEvent=!0},activateInputEventListener:function(){this.ignoreInputEvent=!1},attachListeners:function(){var a=this.undoManager.editor,b=a.editable(),c=this;b.attachListener(b,"keydown",function(a){c.onKeydown(a);if(e.ieFunctionalKeysBug(a.data.getKey()))c.onInput()},
null,null,999);b.attachListener(b,CKEDITOR.env.ie?"keypress":"input",c.onInput,c,null,999);b.attachListener(b,"keyup",c.onKeyup,c,null,999);b.attachListener(b,"paste",c.ignoreInputEventListener,c,null,999);b.attachListener(b,"drop",c.ignoreInputEventListener,c,null,999);a.on("afterPaste",c.activateInputEventListener,c,null,999);b.attachListener(b.isInline()?b:a.document.getDocumentElement(),"click",function(){c.onNavigationKey()},null,null,999);b.attachListener(this.undoManager.editor,"blur",function(){c.keyEventsStack.remove(9)},
null,null,999)}};var m=CKEDITOR.plugins.undo.KeyEventsStack=function(){this.stack=[]};m.prototype={push:function(a){a=this.stack.push({keyCode:a,inputs:0});return this.stack[a-1]},getLastIndex:function(a){if("number"!=typeof a)return this.stack.length-1;for(var b=this.stack.length;b--;)if(this.stack[b].keyCode==a)return b;return-1},getLast:function(a){a=this.getLastIndex(a);return-1!=a?this.stack[a]:null},increment:function(a){this.getLast(a).inputs++},remove:function(a){a=this.getLastIndex(a);-1!=
a&&this.stack.splice(a,1)},resetInputs:function(a){if("number"==typeof a)this.getLast(a).inputs=0;else for(a=this.stack.length;a--;)this.stack[a].inputs=0},getTotalInputs:function(){for(var a=this.stack.length,b=0;a--;)b+=this.stack[a].inputs;return b},cleanUp:function(a){a=a.data.$;a.ctrlKey||a.metaKey||this.remove(17);a.shiftKey||this.remove(16);a.altKey||this.remove(18)}}})();(function(){function m(a,d){CKEDITOR.tools.extend(this,{editor:a,editable:a.editable(),doc:a.document,win:a.window},d,!0);this.inline=this.editable.isInline();this.inline||(this.frame=this.win.getFrame());this.target=this[this.inline?"editable":"doc"]}function n(a,d){CKEDITOR.tools.extend(this,d,{editor:a},!0)}function p(a,d){var b=a.editable();CKEDITOR.tools.extend(this,{editor:a,editable:b,inline:b.isInline(),doc:a.document,win:a.window,container:CKEDITOR.document.getBody(),winTop:CKEDITOR.document.getWindow()},
d,!0);this.hidden={};this.visible={};this.inline||(this.frame=this.win.getFrame());this.queryViewport();var c=CKEDITOR.tools.bind(this.queryViewport,this),e=CKEDITOR.tools.bind(this.hideVisible,this),g=CKEDITOR.tools.bind(this.removeAll,this);b.attachListener(this.winTop,"resize",c);b.attachListener(this.winTop,"scroll",c);b.attachListener(this.winTop,"resize",e);b.attachListener(this.win,"scroll",e);b.attachListener(this.inline?b:this.frame,"mouseout",function(a){var b=a.data.$.clientX;a=a.data.$.clientY;
this.queryViewport();(b<=this.rect.left||b>=this.rect.right||a<=this.rect.top||a>=this.rect.bottom)&&this.hideVisible();(0>=b||b>=this.winTopPane.width||0>=a||a>=this.winTopPane.height)&&this.hideVisible()},this);b.attachListener(a,"resize",c);b.attachListener(a,"mode",g);a.on("destroy",g);this.lineTpl=(new CKEDITOR.template('\x3cdiv data-cke-lineutils-line\x3d"1" class\x3d"cke_reset_all" style\x3d"{lineStyle}"\x3e\x3cspan style\x3d"{tipLeftStyle}"\x3e\x26nbsp;\x3c/span\x3e\x3cspan style\x3d"{tipRightStyle}"\x3e\x26nbsp;\x3c/span\x3e\x3c/div\x3e')).output({lineStyle:CKEDITOR.tools.writeCssText(CKEDITOR.tools.extend({},
t,this.lineStyle,!0)),tipLeftStyle:CKEDITOR.tools.writeCssText(CKEDITOR.tools.extend({},q,{left:"0px","border-left-color":"red","border-width":"6px 0 6px 6px"},this.tipCss,this.tipLeftStyle,!0)),tipRightStyle:CKEDITOR.tools.writeCssText(CKEDITOR.tools.extend({},q,{right:"0px","border-right-color":"red","border-width":"6px 6px 6px 0"},this.tipCss,this.tipRightStyle,!0))})}function l(a){var d;if(d=a&&a.type==CKEDITOR.NODE_ELEMENT)d=!(r[a.getComputedStyle("float")]||r[a.getAttribute("align")]);return d&&
!u[a.getComputedStyle("position")]}CKEDITOR.plugins.add("lineutils");CKEDITOR.LINEUTILS_BEFORE=1;CKEDITOR.LINEUTILS_AFTER=2;CKEDITOR.LINEUTILS_INSIDE=4;m.prototype={start:function(a){var d=this,b=this.editor,c=this.doc,e,g,f,h,k=CKEDITOR.tools.eventsBuffer(50,function(){b.readOnly||"wysiwyg"!=b.mode||(d.relations={},(g=c.$.elementFromPoint(f,h))&&g.nodeType&&(e=new CKEDITOR.dom.element(g),d.traverseSearch(e),isNaN(f+h)||d.pixelSearch(e,f,h),a&&a(d.relations,f,h)))});this.listener=this.editable.attachListener(this.target,
"mousemove",function(a){f=a.data.$.clientX;h=a.data.$.clientY;k.input()});this.editable.attachListener(this.inline?this.editable:this.frame,"mouseout",function(){k.reset()})},stop:function(){this.listener&&this.listener.removeListener()},getRange:function(){var a={};a[CKEDITOR.LINEUTILS_BEFORE]=CKEDITOR.POSITION_BEFORE_START;a[CKEDITOR.LINEUTILS_AFTER]=CKEDITOR.POSITION_AFTER_END;a[CKEDITOR.LINEUTILS_INSIDE]=CKEDITOR.POSITION_AFTER_START;return function(d){var b=this.editor.createRange();b.moveToPosition(this.relations[d.uid].element,
a[d.type]);return b}}(),store:function(){function a(a,b,c){var e=a.getUniqueId();e in c?c[e].type|=b:c[e]={element:a,type:b}}return function(d,b){var c;b&CKEDITOR.LINEUTILS_AFTER&&l(c=d.getNext())&&c.isVisible()&&(a(c,CKEDITOR.LINEUTILS_BEFORE,this.relations),b^=CKEDITOR.LINEUTILS_AFTER);b&CKEDITOR.LINEUTILS_INSIDE&&l(c=d.getFirst())&&c.isVisible()&&(a(c,CKEDITOR.LINEUTILS_BEFORE,this.relations),b^=CKEDITOR.LINEUTILS_INSIDE);a(d,b,this.relations)}}(),traverseSearch:function(a){var d,b,c;do if(c=a.$["data-cke-expando"],
!(c&&c in this.relations)){if(a.equals(this.editable))break;if(l(a))for(d in this.lookups)(b=this.lookups[d](a))&&this.store(a,b)}while((!a||a.type!=CKEDITOR.NODE_ELEMENT||"true"!=a.getAttribute("contenteditable"))&&(a=a.getParent()))},pixelSearch:function(){function a(a,c,e,g,f){for(var h=0,k;f(e);){e+=g;if(25==++h)break;if(k=this.doc.$.elementFromPoint(c,e))if(k==a)h=0;else if(d(a,k)&&(h=0,l(k=new CKEDITOR.dom.element(k))))return k}}var d=CKEDITOR.env.ie||CKEDITOR.env.webkit?function(a,c){return a.contains(c)}:
function(a,c){return!!(a.compareDocumentPosition(c)&16)};return function(b,c,d){var g=this.win.getViewPaneSize().height,f=a.call(this,b.$,c,d,-1,function(a){return 0<a});c=a.call(this,b.$,c,d,1,function(a){return a<g});if(f)for(this.traverseSearch(f);!f.getParent().equals(b);)f=f.getParent();if(c)for(this.traverseSearch(c);!c.getParent().equals(b);)c=c.getParent();for(;f||c;){f&&(f=f.getNext(l));if(!f||f.equals(c))break;this.traverseSearch(f);c&&(c=c.getPrevious(l));if(!c||c.equals(f))break;this.traverseSearch(c)}}}(),
greedySearch:function(){this.relations={};for(var a=this.editable.getElementsByTag("*"),d=0,b,c,e;b=a.getItem(d++);)if(!b.equals(this.editable)&&b.type==CKEDITOR.NODE_ELEMENT&&(b.hasAttribute("contenteditable")||!b.isReadOnly())&&l(b)&&b.isVisible())for(e in this.lookups)(c=this.lookups[e](b))&&this.store(b,c);return this.relations}};n.prototype={locate:function(){function a(a,b){var c=a.element[b===CKEDITOR.LINEUTILS_BEFORE?"getPrevious":"getNext"]();return c&&l(c)?(a.siblingRect=c.getClientRect(),
b==CKEDITOR.LINEUTILS_BEFORE?(a.siblingRect.bottom+a.elementRect.top)/2:(a.elementRect.bottom+a.siblingRect.top)/2):b==CKEDITOR.LINEUTILS_BEFORE?a.elementRect.top:a.elementRect.bottom}return function(d){var b;this.locations={};for(var c in d)b=d[c],b.elementRect=b.element.getClientRect(),b.type&CKEDITOR.LINEUTILS_BEFORE&&this.store(c,CKEDITOR.LINEUTILS_BEFORE,a(b,CKEDITOR.LINEUTILS_BEFORE)),b.type&CKEDITOR.LINEUTILS_AFTER&&this.store(c,CKEDITOR.LINEUTILS_AFTER,a(b,CKEDITOR.LINEUTILS_AFTER)),b.type&
CKEDITOR.LINEUTILS_INSIDE&&this.store(c,CKEDITOR.LINEUTILS_INSIDE,(b.elementRect.top+b.elementRect.bottom)/2);return this.locations}}(),sort:function(){var a,d,b,c;return function(e,g){a=this.locations;d=[];for(var f in a)for(var h in a[f])if(b=Math.abs(e-a[f][h]),d.length){for(c=0;c<d.length;c++)if(b<d[c].dist){d.splice(c,0,{uid:+f,type:h,dist:b});break}c==d.length&&d.push({uid:+f,type:h,dist:b})}else d.push({uid:+f,type:h,dist:b});return"undefined"!=typeof g?d.slice(0,g):d}}(),store:function(a,
d,b){this.locations[a]||(this.locations[a]={});this.locations[a][d]=b}};var q={display:"block",width:"0px",height:"0px","border-color":"transparent","border-style":"solid",position:"absolute",top:"-6px"},t={height:"0px","border-top":"1px dashed red",position:"absolute","z-index":9999};p.prototype={removeAll:function(){for(var a in this.hidden)this.hidden[a].remove(),delete this.hidden[a];for(a in this.visible)this.visible[a].remove(),delete this.visible[a]},hideLine:function(a){var d=a.getUniqueId();
a.hide();this.hidden[d]=a;delete this.visible[d]},showLine:function(a){var d=a.getUniqueId();a.show();this.visible[d]=a;delete this.hidden[d]},hideVisible:function(){for(var a in this.visible)this.hideLine(this.visible[a])},placeLine:function(a,d){var b,c,e;if(b=this.getStyle(a.uid,a.type)){for(e in this.visible)if(this.visible[e].getCustomData("hash")!==this.hash){c=this.visible[e];break}if(!c)for(e in this.hidden)if(this.hidden[e].getCustomData("hash")!==this.hash){this.showLine(c=this.hidden[e]);
break}c||this.showLine(c=this.addLine());c.setCustomData("hash",this.hash);this.visible[c.getUniqueId()]=c;c.setStyles(b);d&&d(c)}},getStyle:function(a,d){var b=this.relations[a],c=this.locations[a][d],e={};e.width=b.siblingRect?Math.max(b.siblingRect.width,b.elementRect.width):b.elementRect.width;e.top=this.inline?c+this.winTopScroll.y-this.rect.relativeY:this.rect.top+this.winTopScroll.y+c;if(e.top-this.winTopScroll.y<this.rect.top||e.top-this.winTopScroll.y>this.rect.bottom)return!1;this.inline?
e.left=b.elementRect.left-this.rect.relativeX:(0<b.elementRect.left?e.left=this.rect.left+b.elementRect.left:(e.width+=b.elementRect.left,e.left=this.rect.left),0<(b=e.left+e.width-(this.rect.left+this.winPane.width))&&(e.width-=b));e.left+=this.winTopScroll.x;for(var g in e)e[g]=CKEDITOR.tools.cssLength(e[g]);return e},addLine:function(){var a=CKEDITOR.dom.element.createFromHtml(this.lineTpl);a.appendTo(this.container);return a},prepare:function(a,d){this.relations=a;this.locations=d;this.hash=Math.random()},
cleanup:function(){var a,d;for(d in this.visible)a=this.visible[d],a.getCustomData("hash")!==this.hash&&this.hideLine(a)},queryViewport:function(){this.winPane=this.win.getViewPaneSize();this.winTopScroll=this.winTop.getScrollPosition();this.winTopPane=this.winTop.getViewPaneSize();this.rect=this.getClientRect(this.inline?this.editable:this.frame)},getClientRect:function(a){a=a.getClientRect();var d=this.container.getDocumentPosition(),b=this.container.getComputedStyle("position");a.relativeX=a.relativeY=
0;"static"!=b&&(a.relativeY=d.y,a.relativeX=d.x,a.top-=a.relativeY,a.bottom-=a.relativeY,a.left-=a.relativeX,a.right-=a.relativeX);return a}};var r={left:1,right:1,center:1},u={absolute:1,fixed:1};CKEDITOR.plugins.lineutils={finder:m,locator:n,liner:p}})();(function(){function e(a){return a.getName&&!a.hasAttribute("data-cke-temp")}CKEDITOR.plugins.add("widgetselection",{init:function(a){if(CKEDITOR.env.webkit){var b=CKEDITOR.plugins.widgetselection;a.on("contentDom",function(a){a=a.editor;var c=a.editable();c.attachListener(c,"keydown",function(a){a.data.getKeystroke()==CKEDITOR.CTRL+65&&CKEDITOR.tools.setTimeout(function(){b.addFillers(c)||b.removeFillers(c)},0)},null,null,-1);a.on("selectionCheck",function(a){b.removeFillers(a.editor.editable())});
a.on("paste",function(a){a.data.dataValue=b.cleanPasteData(a.data.dataValue)});"selectall"in a.plugins&&b.addSelectAllIntegration(a)})}}});CKEDITOR.plugins.widgetselection={startFiller:null,endFiller:null,fillerAttribute:"data-cke-filler-webkit",fillerContent:"\x26nbsp;",fillerTagName:"div",addFillers:function(a){var b=a.editor;if(!this.isWholeContentSelected(a)&&0<a.getChildCount()){var d=a.getFirst(e),c=a.getLast(e);d&&d.type==CKEDITOR.NODE_ELEMENT&&!d.isEditable()&&(this.startFiller=this.createFiller(),
a.append(this.startFiller,1));c&&c.type==CKEDITOR.NODE_ELEMENT&&!c.isEditable()&&(this.endFiller=this.createFiller(!0),a.append(this.endFiller,0));if(this.hasFiller(a))return b=b.createRange(),b.selectNodeContents(a),b.select(),!0}return!1},removeFillers:function(a){if(this.hasFiller(a)&&!this.isWholeContentSelected(a)){var b=a.findOne(this.fillerTagName+"["+this.fillerAttribute+"\x3dstart]"),d=a.findOne(this.fillerTagName+"["+this.fillerAttribute+"\x3dend]");this.startFiller&&b&&this.startFiller.equals(b)?
this.removeFiller(this.startFiller,a):this.startFiller=b;this.endFiller&&d&&this.endFiller.equals(d)?this.removeFiller(this.endFiller,a):this.endFiller=d}},cleanPasteData:function(a){a&&a.length&&(a=a.replace(this.createFillerRegex(),"").replace(this.createFillerRegex(!0),""));return a},isWholeContentSelected:function(a){var b=a.editor.getSelection().getRanges()[0];return!b||b&&b.collapsed?!1:(b=b.clone(),b.enlarge(CKEDITOR.ENLARGE_ELEMENT),!!(b&&a&&b.startContainer&&b.endContainer&&0===b.startOffset&&
b.endOffset===a.getChildCount()&&b.startContainer.equals(a)&&b.endContainer.equals(a)))},hasFiller:function(a){return 0<a.find(this.fillerTagName+"["+this.fillerAttribute+"]").count()},createFiller:function(a){var b=new CKEDITOR.dom.element(this.fillerTagName);b.setHtml(this.fillerContent);b.setAttribute(this.fillerAttribute,a?"end":"start");b.setAttribute("data-cke-temp",1);b.setStyles({display:"block",width:0,height:0,padding:0,border:0,margin:0,position:"absolute",top:0,left:"-9999px",opacity:0,
overflow:"hidden"});return b},removeFiller:function(a,b){if(a){var d=b.editor,c=b.editor.getSelection().getRanges()[0].startPath(),f=d.createRange(),g,e;c.contains(a)&&(g=a.getHtml(),e=!0);c="start"==a.getAttribute(this.fillerAttribute);a.remove();g&&0<g.length&&g!=this.fillerContent?(b.insertHtmlIntoRange(g,d.getSelection().getRanges()[0]),f.setStartAt(b.getChild(b.getChildCount()-1),CKEDITOR.POSITION_BEFORE_END),d.getSelection().selectRanges([f])):e&&(c?f.setStartAt(b.getFirst().getNext(),CKEDITOR.POSITION_AFTER_START):
f.setEndAt(b.getLast().getPrevious(),CKEDITOR.POSITION_BEFORE_END),b.editor.getSelection().selectRanges([f]))}},createFillerRegex:function(a){var b=this.createFiller(a).getOuterHtml().replace(/style="[^"]*"/gi,'style\x3d"[^"]*"').replace(/>[^<]*</gi,"\x3e[^\x3c]*\x3c");return new RegExp((a?"":"^")+b+(a?"$":""))},addSelectAllIntegration:function(a){var b=this;a.editable().attachListener(a,"beforeCommandExec",function(d){var c=a.editable();"selectAll"==d.data.name&&c&&b.addFillers(c)},null,null,9999)}}})();(function(){function q(a){this.editor=a;this.registered={};this.instances={};this.selected=[];this.widgetHoldingFocusedEditable=this.focused=null;this._={nextId:0,upcasts:[],upcastCallbacks:[],filters:{}};Q(this);R(this);this.on("checkWidgets",S);this.editor.on("contentDomInvalidated",this.checkWidgets,this);T(this);U(this);V(this);W(this);X(this)}function g(a,b,c,d,e){var f=a.editor;CKEDITOR.tools.extend(this,d,{editor:f,id:b,inline:"span"==c.getParent().getName(),element:c,data:CKEDITOR.tools.extend({},
"function"==typeof d.defaults?d.defaults():d.defaults),dataReady:!1,inited:!1,ready:!1,edit:g.prototype.edit,focusedEditable:null,definition:d,repository:a,draggable:!1!==d.draggable,_:{downcastFn:d.downcast&&"string"==typeof d.downcast?d.downcasts[d.downcast]:d.downcast}},!0);a.fire("instanceCreated",this);Y(this,d);this.init&&this.init();this.inited=!0;(a=this.element.data("cke-widget-data"))&&this.setData(JSON.parse(decodeURIComponent(a)));e&&this.setData(e);this.data.classes||this.setData("classes",
this.getClasses());this.dataReady=!0;v(this);this.fire("data",this.data);this.isInited()&&f.editable().contains(this.wrapper)&&(this.ready=!0,this.fire("ready"))}function t(a,b,c){CKEDITOR.dom.element.call(this,b.$);this.editor=a;this._={};b=this.filter=c.filter;CKEDITOR.dtd[this.getName()].p?(this.enterMode=b?b.getAllowedEnterMode(a.enterMode):a.enterMode,this.shiftEnterMode=b?b.getAllowedEnterMode(a.shiftEnterMode,!0):a.shiftEnterMode):this.enterMode=this.shiftEnterMode=CKEDITOR.ENTER_BR}function Z(a,
b){a.addCommand(b.name,{exec:function(a,d){function e(){a.widgets.finalizeCreation(k)}var f=a.widgets.focused;if(f&&f.name==b.name)f.edit();else if(b.insert)b.insert({editor:a,commandData:d});else if(b.template){var f="function"==typeof b.defaults?b.defaults():b.defaults,f=CKEDITOR.dom.element.createFromHtml(b.template.output(f),a.document),h,l=a.widgets.wrapElement(f,b.name),k=new CKEDITOR.dom.documentFragment(l.getDocument());k.append(l);(h=a.widgets.initOn(f,b,d&&d.startupData))?(f=h.once("edit",
function(b){if(b.data.dialog)h.once("dialog",function(b){b=b.data;var d,f;d=b.once("ok",e,null,null,20);f=b.once("cancel",function(b){b.data&&!1===b.data.hide||a.widgets.destroy(h,!0)});b.once("hide",function(){d.removeListener();f.removeListener()})});else e()},null,null,999),h.edit(),f.removeListener()):e()}},allowedContent:b.allowedContent,requiredContent:b.requiredContent,contentForms:b.contentForms,contentTransformations:b.contentTransformations})}function aa(a,b){function c(a,c){var e=b.upcast.split(","),
d,f;for(f=0;f<e.length;f++)if(d=e[f],d===a.name)return b.upcasts[d].call(this,a,c);return!1}function d(b,c,e){var d=CKEDITOR.tools.getIndex(a._.upcasts,function(a){return a[2]>e});0>d&&(d=a._.upcasts.length);a._.upcasts.splice(d,0,[CKEDITOR.tools.bind(b,c),c.name,e])}var e=b.upcast,f=b.upcastPriority||10;e&&("string"==typeof e?d(c,b,f):d(e,b,f))}function x(a,b){a.focused=null;if(b.isInited()){var c=b.editor.checkDirty();a.fire("widgetBlurred",{widget:b});b.setFocused(!1);!c&&b.editor.resetDirty()}}
function S(a){a=a.data;if("wysiwyg"==this.editor.mode){var b=this.editor.editable(),c=this.instances,d,e,f,h;if(b){for(d in c)c[d].isReady()&&!b.contains(c[d].wrapper)&&this.destroy(c[d],!0);if(a&&a.initOnlyNew)c=this.initOnAll();else{var l=b.find(".cke_widget_wrapper"),c=[];d=0;for(e=l.count();d<e;d++){f=l.getItem(d);if(h=!this.getByElement(f,!0)){a:{h=ba;for(var k=f;k=k.getParent();)if(h(k)){h=!0;break a}h=!1}h=!h}h&&b.contains(f)&&(f.addClass("cke_widget_new"),c.push(this.initOn(f.getFirst(g.isDomWidgetElement))))}}a&&
a.focusInited&&1==c.length&&c[0].focus()}}}function y(a){if("undefined"!=typeof a.attributes&&a.attributes["data-widget"]){var b=z(a),c=A(a),d=!1;b&&b.value&&b.value.match(/^\s/g)&&(b.parent.attributes["data-cke-white-space-first"]=1,b.value=b.value.replace(/^\s/g,"\x26nbsp;"),d=!0);c&&c.value&&c.value.match(/\s$/g)&&(c.parent.attributes["data-cke-white-space-last"]=1,c.value=c.value.replace(/\s$/g,"\x26nbsp;"),d=!0);d&&(a.attributes["data-cke-widget-white-space"]=1)}}function z(a){return a.find(function(a){return 3===
a.type},!0).shift()}function A(a){return a.find(function(a){return 3===a.type},!0).pop()}function B(a,b,c){if(!c.allowedContent&&!c.disallowedContent)return null;var d=this._.filters[a];d||(this._.filters[a]=d={});a=d[b];a||(a=c.allowedContent?new CKEDITOR.filter(c.allowedContent):this.editor.filter.clone(),d[b]=a,c.disallowedContent&&a.disallow(c.disallowedContent));return a}function ca(a){var b=[],c=a._.upcasts,d=a._.upcastCallbacks;return{toBeWrapped:b,iterator:function(a){var f,h,l,k,n;if("data-cke-widget-wrapper"in
a.attributes)return(a=a.getFirst(g.isParserWidgetElement))&&b.push([a]),!1;if("data-widget"in a.attributes)return b.push([a]),!1;if(n=c.length){if(a.attributes["data-cke-widget-upcasted"])return!1;k=0;for(f=d.length;k<f;++k)if(!1===d[k](a))return;for(k=0;k<n;++k)if(f=c[k],l={},h=f[0](a,l))return h instanceof CKEDITOR.htmlParser.element&&(a=h),a.attributes["data-cke-widget-data"]=encodeURIComponent(JSON.stringify(l)),a.attributes["data-cke-widget-upcasted"]=1,b.push([a,f[1]]),!1}}}}function C(a,b){return{tabindex:-1,
contenteditable:"false","data-cke-widget-wrapper":1,"data-cke-filter":"off","class":"cke_widget_wrapper cke_widget_new cke_widget_"+(a?"inline":"block")+(b?" cke_widget_"+b:"")}}function D(a,b,c){if(a.type==CKEDITOR.NODE_ELEMENT){var d=CKEDITOR.dtd[a.name];if(d&&!d[c.name]){var d=a.split(b),e=a.parent;b=d.getIndex();a.children.length||(--b,a.remove());d.children.length||d.remove();return D(e,b,c)}}a.add(c,b)}function E(a,b){return"boolean"==typeof a.inline?a.inline:!!CKEDITOR.dtd.$inline[b]}function ba(a){return a.hasAttribute("data-cke-temp")}
function p(a,b,c,d){var e=a.editor;e.fire("lockSnapshot");c?(d=c.data("cke-widget-editable"),d=b.editables[d],a.widgetHoldingFocusedEditable=b,b.focusedEditable=d,c.addClass("cke_widget_editable_focused"),d.filter&&e.setActiveFilter(d.filter),e.setActiveEnterMode(d.enterMode,d.shiftEnterMode)):(d||b.focusedEditable.removeClass("cke_widget_editable_focused"),b.focusedEditable=null,a.widgetHoldingFocusedEditable=null,e.setActiveFilter(null),e.setActiveEnterMode(null,null));e.fire("unlockSnapshot")}
function da(a){a.contextMenu&&a.contextMenu.addListener(function(b){if(b=a.widgets.getByElement(b,!0))return b.fire("contextMenu",{})})}function ea(a,b){return CKEDITOR.tools.trim(b)}function W(a){var b=a.editor,c=CKEDITOR.plugins.lineutils;b.on("dragstart",function(c){var e=c.data.target;g.isDomDragHandler(e)&&(e=a.getByElement(e),c.data.dataTransfer.setData("cke/widget-id",e.id),b.focus(),e.focus())});b.on("drop",function(c){var e=c.data.dataTransfer,f=e.getData("cke/widget-id"),h=e.getTransferType(b),
e=b.createRange();if(""!==f&&h===CKEDITOR.DATA_TRANSFER_CROSS_EDITORS)c.cancel();else if(h==CKEDITOR.DATA_TRANSFER_INTERNAL)if(""===f&&0<b.widgets.selected.length)c.data.dataTransfer.setData("text/html",F(b));else if(f=a.instances[f])e.setStartBefore(f.wrapper),e.setEndAfter(f.wrapper),c.data.dragRange=e,delete CKEDITOR.plugins.clipboard.dragStartContainerChildCount,delete CKEDITOR.plugins.clipboard.dragEndContainerChildCount,c.data.dataTransfer.setData("text/html",f.getClipboardHtml()),b.widgets.destroy(f,
!0)});b.on("contentDom",function(){var d=b.editable();CKEDITOR.tools.extend(a,{finder:new c.finder(b,{lookups:{"default":function(b){if(!b.is(CKEDITOR.dtd.$listItem)&&b.is(CKEDITOR.dtd.$block)&&!g.isDomNestedEditable(b)&&!a._.draggedWidget.wrapper.contains(b)){var c=g.getNestedEditable(d,b);if(c){b=a._.draggedWidget;if(a.getByElement(c)==b)return;c=CKEDITOR.filter.instances[c.data("cke-filter")];b=b.requiredContent;if(c&&b&&!c.check(b))return}return CKEDITOR.LINEUTILS_BEFORE|CKEDITOR.LINEUTILS_AFTER}}}}),
locator:new c.locator(b),liner:new c.liner(b,{lineStyle:{cursor:"move !important","border-top-color":"#666"},tipLeftStyle:{"border-left-color":"#666"},tipRightStyle:{"border-right-color":"#666"}})},!0)})}function U(a){var b=a.editor;b.on("contentDom",function(){var c=b.editable(),d=c.isInline()?c:b.document,e,f;c.attachListener(d,"mousedown",function(c){var d=c.data.getTarget();e=d instanceof CKEDITOR.dom.element?a.getByElement(d):null;f=0;e&&(e.inline&&d.type==CKEDITOR.NODE_ELEMENT&&d.hasAttribute("data-cke-widget-drag-handler")?
(f=1,a.focused!=e&&b.getSelection().removeAllRanges()):g.getNestedEditable(e.wrapper,d)?e=null:(c.data.preventDefault(),CKEDITOR.env.ie||e.focus()))});c.attachListener(d,"mouseup",function(){f&&e&&e.wrapper&&(f=0,e.focus())});CKEDITOR.env.ie&&c.attachListener(d,"mouseup",function(){setTimeout(function(){e&&e.wrapper&&c.contains(e.wrapper)&&(e.focus(),e=null)})})});b.on("doubleclick",function(b){var d=a.getByElement(b.data.element);if(d&&!g.getNestedEditable(d.wrapper,b.data.element))return d.fire("doubleclick",
{element:b.data.element})},null,null,1)}function V(a){a.editor.on("key",function(b){var c=a.focused,d=a.widgetHoldingFocusedEditable,e;c?e=c.fire("key",{keyCode:b.data.keyCode}):d&&(c=b.data.keyCode,b=d.focusedEditable,c==CKEDITOR.CTRL+65?(c=b.getBogus(),d=d.editor.createRange(),d.selectNodeContents(b),c&&d.setEndAt(c,CKEDITOR.POSITION_BEFORE_START),d.select(),e=!1):8==c||46==c?(e=d.editor.getSelection().getRanges(),d=e[0],e=!(1==e.length&&d.collapsed&&d.checkBoundaryOfElement(b,CKEDITOR[8==c?"START":
"END"]))):e=void 0);return e},null,null,1)}function X(a){function b(b){1>a.selected.length||G(c,"cut"===b.name)}var c=a.editor;c.on("contentDom",function(){var a=c.editable();a.attachListener(a,"copy",b);a.attachListener(a,"cut",b)})}function T(a){function b(){var a=e.getSelection();if(a&&(a=a.getRanges()[0])&&!a.collapsed){var b=c(a.startContainer),d=c(a.endContainer);!b&&d?(a.setEndBefore(d.wrapper),a.select()):b&&!d&&(a.setStartAfter(b.wrapper),a.select())}}function c(a){return a?a.type==CKEDITOR.NODE_TEXT?
c(a.getParent()):e.widgets.getByElement(a):null}function d(){a.fire("checkSelection")}var e=a.editor;e.on("selectionCheck",d);e.on("contentDom",function(){e.editable().attachListener(e,"key",function(){setTimeout(d,10)})});if(!CKEDITOR.env.ie)a.on("checkSelection",b);a.on("checkSelection",a.checkSelection,a);e.on("selectionChange",function(b){var c=(b=g.getNestedEditable(e.editable(),b.data.selection.getStartElement()))&&a.getByElement(b),d=a.widgetHoldingFocusedEditable;d?d===c&&d.focusedEditable.equals(b)||
(p(a,d,null),c&&b&&p(a,c,b)):c&&b&&p(a,c,b)});e.on("dataReady",function(){H(a).commit()});e.on("blur",function(){var b;(b=a.focused)&&x(a,b);(b=a.widgetHoldingFocusedEditable)&&p(a,b,null)})}function R(a){var b=a.editor,c={};b.on("toDataFormat",function(b){var e=CKEDITOR.tools.getNextNumber(),f=[];b.data.downcastingSessionId=e;c[e]=f;b.data.dataValue.forEach(function(b){var c=b.attributes,e;if("data-cke-widget-white-space"in c){e=z(b);var d=A(b);e.parent.attributes["data-cke-white-space-first"]&&
(e.value=e.value.replace(/^&nbsp;/g," "));d.parent.attributes["data-cke-white-space-last"]&&(d.value=d.value.replace(/&nbsp;$/g," "))}if("data-cke-widget-id"in c){if(c=a.instances[c["data-cke-widget-id"]])e=b.getFirst(g.isParserWidgetElement),f.push({wrapper:b,element:e,widget:c,editables:{}}),"1"!=e.attributes["data-cke-widget-keep-attr"]&&delete e.attributes["data-widget"]}else if("data-cke-widget-editable"in c)return 0<f.length&&(f[f.length-1].editables[c["data-cke-widget-editable"]]=b),!1},CKEDITOR.NODE_ELEMENT,
!0)},null,null,8);b.on("toDataFormat",function(a){if(a.data.downcastingSessionId)for(var b=c[a.data.downcastingSessionId],f,h,l,k,g,m;f=b.shift();){h=f.widget;l=f.element;k=h._.downcastFn&&h._.downcastFn.call(h,l);a.data.widgetsCopy&&h.getClipboardHtml&&(k=CKEDITOR.htmlParser.fragment.fromHtml(h.getClipboardHtml()),k=k.children[0]);for(m in f.editables)g=f.editables[m],delete g.attributes.contenteditable,g.setHtml(h.editables[m].getData());k||(k=l);f.wrapper.replaceWith(k)}},null,null,13);b.on("contentDomUnload",
function(){a.destroyAll(!0)})}function Q(a){var b=a.editor,c,d;b.on("toHtml",function(b){var d=ca(a),h;for(b.data.dataValue.forEach(d.iterator,CKEDITOR.NODE_ELEMENT,!0);h=d.toBeWrapped.pop();){var l=h[0],k=l.parent;k.type==CKEDITOR.NODE_ELEMENT&&k.attributes["data-cke-widget-wrapper"]&&k.replaceWith(l);a.wrapElement(h[0],h[1])}c=b.data.protectedWhitespaces?3==b.data.dataValue.children.length&&g.isParserWidgetWrapper(b.data.dataValue.children[1]):1==b.data.dataValue.children.length&&g.isParserWidgetWrapper(b.data.dataValue.children[0])},
null,null,8);b.on("dataReady",function(){if(d)for(var c=b.editable().find(".cke_widget_wrapper"),f,h,l=0,k=c.count();l<k;++l)f=c.getItem(l),h=f.getFirst(g.isDomWidgetElement),h.type==CKEDITOR.NODE_ELEMENT&&h.data("widget")?(h.replace(f),a.wrapElement(h)):f.remove();d=0;a.destroyAll(!0);a.initOnAll()});b.on("loadSnapshot",function(b){/data-cke-widget/.test(b.data)&&(d=1);a.destroyAll(!0)},null,null,9);b.on("paste",function(a){a=a.data;a.dataValue=a.dataValue.replace(fa,ea);a.range&&(a=g.getNestedEditable(b.editable(),
a.range.startContainer))&&(a=CKEDITOR.filter.instances[a.data("cke-filter")])&&b.setActiveFilter(a)});b.on("afterInsertHtml",function(d){d.data.intoRange?a.checkWidgets({initOnlyNew:!0}):(b.fire("lockSnapshot"),a.checkWidgets({initOnlyNew:!0,focusInited:c}),b.fire("unlockSnapshot"))})}function H(a){var b=a.selected,c=[],d=b.slice(0),e=null;return{select:function(a){0>CKEDITOR.tools.indexOf(b,a)&&c.push(a);a=CKEDITOR.tools.indexOf(d,a);0<=a&&d.splice(a,1);return this},focus:function(a){e=a;return this},
commit:function(){var f=a.focused!==e,h,l;a.editor.fire("lockSnapshot");for(f&&(h=a.focused)&&x(a,h);h=d.pop();)b.splice(CKEDITOR.tools.indexOf(b,h),1),h.isInited()&&(l=h.editor.checkDirty(),h.setSelected(!1),!l&&h.editor.resetDirty());f&&e&&(l=a.editor.checkDirty(),a.focused=e,a.fire("widgetFocused",{widget:e}),e.setFocused(!0),!l&&a.editor.resetDirty());for(;h=c.pop();)b.push(h),h.setSelected(!0);a.editor.fire("unlockSnapshot")}}}function ga(a){a&&a.addFilterRule(function(a){return a.replace(/\s*cke_widget_selected/g,
"").replace(/\s*cke_widget_focused/g,"").replace(/<span[^>]*cke_widget_drag_handler_container[^>]*.*?<\/span>/gmi,"")})}function I(a,b,c){var d=0;b=J(b);var e=a.data.classes||{},f;if(b){for(e=CKEDITOR.tools.clone(e);f=b.pop();)c?e[f]||(d=e[f]=1):e[f]&&(delete e[f],d=1);d&&a.setData("classes",e)}}function K(a){a.cancel()}function G(a,b){var c=a.widgets.focused,d,e,f;u.hasCopyBin(a)||(e=new u(a,{beforeDestroy:function(){!b&&c&&c.focus();f&&a.getSelection().selectBookmarks(f);d&&CKEDITOR.plugins.widgetselection.addFillers(a.editable())},
afterDestroy:function(){b&&!a.readOnly&&(c?a.widgets.del(c):a.extractSelectedHtml(),a.fire("saveSnapshot"))}}),c||(d=CKEDITOR.env.webkit&&CKEDITOR.plugins.widgetselection.isWholeContentSelected(a.editable()),f=a.getSelection().createBookmarks(!0)),e.handle(F(a)))}function J(a){return(a=(a=a.getDefinition().attributes)&&a["class"])?a.split(/\s+/):null}function L(){var a=CKEDITOR.document.getActive(),b=this.editor,c=b.editable();(c.isInline()?c:b.document.getWindow().getFrame()).equals(a)&&b.focusManager.focus(c)}
function M(){CKEDITOR.env.gecko&&this.editor.unlockSelection();CKEDITOR.env.webkit||(this.editor.forceNextSelectionCheck(),this.editor.selectionChange(1))}function F(a){var b=a.getSelectedHtml(!0);if(a.widgets.focused)return a.widgets.focused.getClipboardHtml();a.once("toDataFormat",function(a){a.data.widgetsCopy=!0},null,null,-1);return a.dataProcessor.toDataFormat(b)}function Y(a,b){ha(a);N(a);ia(a);O(a);ja(a);ka(a);la(a);if(CKEDITOR.env.ie&&9>CKEDITOR.env.version)a.wrapper.on("dragstart",function(b){var d=
b.data.getTarget();g.getNestedEditable(a,d)||a.inline&&g.isDomDragHandler(d)||b.data.preventDefault()});a.wrapper.removeClass("cke_widget_new");a.element.addClass("cke_widget_element");a.on("key",function(b){b=b.data.keyCode;if(13==b)a.edit();else{if(b==CKEDITOR.CTRL+67||b==CKEDITOR.CTRL+88){G(a.editor,b==CKEDITOR.CTRL+88);return}if(b in P||CKEDITOR.CTRL&b||CKEDITOR.ALT&b)return}return!1},null,null,999);a.on("doubleclick",function(b){a.edit()&&b.cancel()});if(b.data)a.on("data",b.data);if(b.edit)a.on("edit",
b.edit)}function ha(a){(a.wrapper=a.element.getParent()).setAttribute("data-cke-widget-id",a.id)}function N(a,b){a.partSelectors||(a.partSelectors=a.parts);if(a.parts){var c={},d,e;for(e in a.partSelectors)b||!a.parts[e]||"string"==typeof a.parts[e]?(d=a.wrapper.findOne(a.partSelectors[e]),c[e]=d):c[e]=a.parts[e];a.parts=c}}function ia(a){var b=a.editables,c,d;a.editables={};if(a.editables)for(c in b)d=b[c],a.initEditable(c,"string"==typeof d?{selector:d}:d)}function O(a){if(!0===a.mask)ma(a);else if(a.mask){var b=
new CKEDITOR.tools.buffers.throttle(250,na,a),c=CKEDITOR.env.gecko?300:0,d,e;a.on("focus",function(){b.input();d=a.editor.on("change",b.input);e=a.on("blur",function(){d.removeListener();e.removeListener()})});a.editor.on("instanceReady",function(){setTimeout(function(){b.input()},c)});a.editor.on("mode",function(){setTimeout(function(){b.input()},c)});if(CKEDITOR.env.gecko){var f=a.element.find("img");CKEDITOR.tools.array.forEach(f.toArray(),function(a){a.on("load",function(){b.input()})})}for(var h in a.editables)a.editables[h].on("focus",
function(){a.editor.on("change",b.input);e&&e.removeListener()}),a.editables[h].on("blur",function(){a.editor.removeListener("change",b.input)});b.input()}}function ma(a){var b=a.wrapper.findOne(".cke_widget_mask");b||(b=new CKEDITOR.dom.element("img",a.editor.document),b.setAttributes({src:CKEDITOR.tools.transparentImageData,"class":"cke_reset cke_widget_mask"}),a.wrapper.append(b));a.mask=b}function na(){if(this.wrapper){this.maskPart=this.maskPart||this.mask;var a=this.parts[this.maskPart],b;if(a&&
"string"!=typeof a){b=this.wrapper.findOne(".cke_widget_partial_mask");b||(b=new CKEDITOR.dom.element("img",this.editor.document),b.setAttributes({src:CKEDITOR.tools.transparentImageData,"class":"cke_reset cke_widget_partial_mask"}),this.wrapper.append(b));this.mask=b;var c=b.$,d=a.$,e=!(c.offsetTop==d.offsetTop&&c.offsetLeft==d.offsetLeft);if(c.offsetWidth!=d.offsetWidth||c.offsetHeight!=d.offsetHeight||e)c=a.getParent(),d=CKEDITOR.plugins.widget.isDomWidget(c),b.setStyles({top:a.$.offsetTop+(d?
0:c.$.offsetTop)+"px",left:a.$.offsetLeft+(d?0:c.$.offsetLeft)+"px",width:a.$.offsetWidth+"px",height:a.$.offsetHeight+"px"})}}}function ja(a){if(a.draggable){var b=a.editor,c=a.wrapper.getLast(g.isDomDragHandlerContainer),d;c?d=c.findOne("img"):(c=new CKEDITOR.dom.element("span",b.document),c.setAttributes({"class":"cke_reset cke_widget_drag_handler_container",style:"background:rgba(220,220,220,0.5);background-image:url("+b.plugins.widget.path+"images/handle.png);display:none;"}),d=new CKEDITOR.dom.element("img",
b.document),d.setAttributes({"class":"cke_reset cke_widget_drag_handler","data-cke-widget-drag-handler":"1",src:CKEDITOR.tools.transparentImageData,width:15,title:b.lang.widget.move,height:15,role:"presentation"}),a.inline&&d.setAttribute("draggable","true"),c.append(d),a.wrapper.append(c));a.wrapper.on("dragover",function(a){a.data.preventDefault()});a.wrapper.on("mouseenter",a.updateDragHandlerPosition,a);setTimeout(function(){a.on("data",a.updateDragHandlerPosition,a)},50);if(!a.inline&&(d.on("mousedown",
oa,a),CKEDITOR.env.ie&&9>CKEDITOR.env.version))d.on("dragstart",function(a){a.data.preventDefault(!0)});a.dragHandlerContainer=c}}function oa(a){function b(){var b;for(r.reset();b=g.pop();)b.removeListener();var c=k;b=a.sender;var d=this.repository.finder,e=this.repository.liner,f=this.editor,h=this.editor.editable();CKEDITOR.tools.isEmpty(e.visible)||(c=d.getRange(c[0]),this.focus(),f.fire("drop",{dropRange:c,target:c.startContainer}));h.removeClass("cke_widget_dragging");e.hideVisible();f.fire("dragend",
{target:b})}if(CKEDITOR.tools.getMouseButton(a)===CKEDITOR.MOUSE_BUTTON_LEFT){var c=this.repository.finder,d=this.repository.locator,e=this.repository.liner,f=this.editor,h=f.editable(),g=[],k=[],n,m;this.repository._.draggedWidget=this;var w=c.greedySearch(),r=CKEDITOR.tools.eventsBuffer(50,function(){n=d.locate(w);k=d.sort(m,1);k.length&&(e.prepare(w,n),e.placeLine(k[0]),e.cleanup())});h.addClass("cke_widget_dragging");g.push(h.on("mousemove",function(a){m=a.data.$.clientY;r.input()}));f.fire("dragstart",
{target:a.sender});g.push(f.document.once("mouseup",b,this));h.isInline()||g.push(CKEDITOR.document.once("mouseup",b,this))}}function ka(a){var b=null;a.on("data",function(){var a=this.data.classes,d;if(b!=a){for(d in b)a&&a[d]||this.removeClass(d);for(d in a)this.addClass(d);b=a}})}function la(a){a.on("data",function(){if(a.wrapper){var b=this.getLabel?this.getLabel():this.editor.lang.widget.label.replace(/%1/,this.pathName||this.element.getName());a.wrapper.setAttribute("role","region");a.wrapper.setAttribute("aria-label",
b)}},null,null,9999)}function v(a){a.element.data("cke-widget-data",encodeURIComponent(JSON.stringify(a.data)))}function pa(){function a(){}function b(a,b,c){return c&&this.checkElement(a)?(a=c.widgets.getByElement(a,!0))&&a.checkStyleActive(this):!1}function c(a){function b(a,c,d){for(var e=a.length,f=0;f<e;){if(c.call(d,a[f],f,a))return a[f];f++}}function c(a){function b(a,c){var d=CKEDITOR.tools.object.keys(a),e=CKEDITOR.tools.object.keys(c);if(d.length!==e.length)return!1;for(var f in a)if(("object"!==
typeof a[f]||"object"!==typeof c[f]||!b(a[f],c[f]))&&a[f]!==c[f])return!1;return!0}return function(c){return b(a.getDefinition(),c.getDefinition())}}var g=a.widget,k;d[g]||(d[g]={});for(var n=0,m=a.group.length;n<m;n++)k=a.group[n],d[g][k]||(d[g][k]=[]),k=d[g][k],b(k,c(a))||k.push(a)}var d={};CKEDITOR.style.addCustomHandler({type:"widget",setup:function(a){this.widget=a.widget;(this.group="string"==typeof a.group?[a.group]:a.group)&&c(this)},apply:function(a){var b;a instanceof CKEDITOR.editor&&this.checkApplicable(a.elementPath(),
a)&&(b=a.widgets.focused,this.group&&this.removeStylesFromSameGroup(a),b.applyStyle(this))},remove:function(a){a instanceof CKEDITOR.editor&&this.checkApplicable(a.elementPath(),a)&&a.widgets.focused.removeStyle(this)},removeStylesFromSameGroup:function(a){var b=!1,c,g;if(!(a instanceof CKEDITOR.editor))return!1;g=a.elementPath();if(this.checkApplicable(g,a))for(var k=0,n=this.group.length;k<n;k++){c=d[this.widget][this.group[k]];for(var m=0;m<c.length;m++)c[m]!==this&&c[m].checkActive(g,a)&&(a.widgets.focused.removeStyle(c[m]),
b=!0)}return b},checkActive:function(a,b){return this.checkElementMatch(a.lastElement,0,b)},checkApplicable:function(a,b){return b instanceof CKEDITOR.editor?this.checkElement(a.lastElement):!1},checkElementMatch:b,checkElementRemovable:b,checkElement:function(a){return g.isDomWidgetWrapper(a)?(a=a.getFirst(g.isDomWidgetElement))&&a.data("widget")==this.widget:!1},buildPreview:function(a){return a||this._.definition.name},toAllowedContentRules:function(a){if(!a)return null;a=a.widgets.registered[this.widget];
var b,c={};if(!a)return null;if(a.styleableElements){b=this.getClassesArray();if(!b)return null;c[a.styleableElements]={classes:b,propertiesOnly:!0};return c}return a.styleToAllowedContentRules?a.styleToAllowedContentRules(this):null},getClassesArray:function(){var a=this._.definition.attributes&&this._.definition.attributes["class"];return a?CKEDITOR.tools.trim(a).split(/\s+/):null},applyToRange:a,removeFromRange:a,applyToObject:a})}CKEDITOR.plugins.add("widget",{requires:"lineutils,clipboard,widgetselection",
onLoad:function(){void 0!==CKEDITOR.document.$.querySelectorAll&&(CKEDITOR.addCss('.cke_widget_wrapper{position:relative;outline:none}.cke_widget_inline{display:inline-block}.cke_widget_wrapper:hover\x3e.cke_widget_element{outline:2px solid #ffd25c;cursor:default}.cke_widget_wrapper:hover .cke_widget_editable{outline:2px solid #ffd25c}.cke_widget_wrapper.cke_widget_focused\x3e.cke_widget_element,.cke_widget_wrapper .cke_widget_editable.cke_widget_editable_focused{outline:2px solid #47a4f5}.cke_widget_editable{cursor:text}.cke_widget_drag_handler_container{position:absolute;width:15px;height:0;display:block;opacity:0.75;transition:height 0s 0.2s;line-height:0}.cke_widget_wrapper:hover\x3e.cke_widget_drag_handler_container{height:15px;transition:none}.cke_widget_drag_handler_container:hover{opacity:1}.cke_editable[contenteditable\x3d"false"] .cke_widget_drag_handler_container{display:none;}img.cke_widget_drag_handler{cursor:move;width:15px;height:15px;display:inline-block}.cke_widget_mask{position:absolute;top:0;left:0;width:100%;height:100%;display:block}.cke_widget_partial_mask{position:absolute;display:block}.cke_editable.cke_widget_dragging, .cke_editable.cke_widget_dragging *{cursor:move !important}'),
pa())},beforeInit:function(a){void 0!==CKEDITOR.document.$.querySelectorAll&&(a.widgets=new q(a))},afterInit:function(a){if(void 0!==CKEDITOR.document.$.querySelectorAll){var b=a.widgets.registered,c,d,e;for(d in b)c=b[d],(e=c.button)&&a.ui.addButton&&a.ui.addButton(CKEDITOR.tools.capitalize(c.name,!0),{label:e,command:c.name,toolbar:"insert,10"});da(a);ga(a.undoManager)}}});q.prototype={MIN_SELECTION_CHECK_INTERVAL:500,add:function(a,b){var c=this.editor;b=CKEDITOR.tools.prototypedCopy(b);b.name=
a;b._=b._||{};c.fire("widgetDefinition",b);b.template&&(b.template=new CKEDITOR.template(b.template));Z(c,b);aa(this,b);this.registered[a]=b;if(b.dialog&&c.plugins.dialog)var d=CKEDITOR.on("dialogDefinition",function(a){a=a.data.definition;var f=a.dialog;a.getMode||f.getName()!==b.dialog||(a.getMode=function(){var a=f.getModel(c);return a&&a instanceof CKEDITOR.plugins.widget&&a.ready?CKEDITOR.dialog.EDITING_MODE:CKEDITOR.dialog.CREATION_MODE});d.removeListener()});return b},addUpcastCallback:function(a){this._.upcastCallbacks.push(a)},
checkSelection:function(){if(this.editor.getSelection()){var a=this.editor.getSelection(),b=a.getSelectedElement(),c=H(this),d;if(b&&(d=this.getByElement(b,!0)))return c.focus(d).select(d).commit();a=a.getRanges()[0];if(!a||a.collapsed)return c.commit();a=new CKEDITOR.dom.walker(a);for(a.evaluator=g.isDomWidgetWrapper;b=a.next();)c.select(this.getByElement(b));c.commit()}},checkWidgets:function(a){this.fire("checkWidgets",CKEDITOR.tools.copy(a||{}))},del:function(a){if(this.focused===a){var b=a.editor,
c=b.createRange(),d;(d=c.moveToClosestEditablePosition(a.wrapper,!0))||(d=c.moveToClosestEditablePosition(a.wrapper,!1));d&&b.getSelection().selectRanges([c])}a.wrapper.remove();this.destroy(a,!0)},destroy:function(a,b){this.widgetHoldingFocusedEditable===a&&p(this,a,null,b);a.destroy(b);delete this.instances[a.id];this.fire("instanceDestroyed",a)},destroyAll:function(a,b){var c,d,e=this.instances;if(b&&!a){d=b.find(".cke_widget_wrapper");for(var e=d.count(),f=0;f<e;++f)(c=this.getByElement(d.getItem(f),
!0))&&this.destroy(c)}else for(d in e)c=e[d],this.destroy(c,a)},finalizeCreation:function(a){(a=a.getFirst())&&g.isDomWidgetWrapper(a)&&(this.editor.insertElement(a),a=this.getByElement(a),a.ready=!0,a.fire("ready"),a.focus())},getByElement:function(){function a(a){return a.is(b)&&a.data("cke-widget-id")}var b={div:1,span:1};return function(b,d){if(!b)return null;var e=a(b);if(!d&&!e){var f=this.editor.editable();do b=b.getParent();while(b&&!b.equals(f)&&!(e=a(b)))}return this.instances[e]||null}}(),
initOn:function(a,b,c){b?"string"==typeof b&&(b=this.registered[b]):b=this.registered[a.data("widget")];if(!b)return null;var d=this.wrapElement(a,b.name);return d?d.hasClass("cke_widget_new")?(a=new g(this,this._.nextId++,a,b,c),a.isInited()?this.instances[a.id]=a:null):this.getByElement(a):null},initOnAll:function(a){a=(a||this.editor.editable()).find(".cke_widget_new");for(var b=[],c,d=a.count();d--;)(c=this.initOn(a.getItem(d).getFirst(g.isDomWidgetElement)))&&b.push(c);return b},onWidget:function(a){var b=
Array.prototype.slice.call(arguments);b.shift();for(var c in this.instances){var d=this.instances[c];d.name==a&&d.on.apply(d,b)}this.on("instanceCreated",function(c){c=c.data;c.name==a&&c.on.apply(c,b)})},parseElementClasses:function(a){if(!a)return null;a=CKEDITOR.tools.trim(a).split(/\s+/);for(var b,c={},d=0;b=a.pop();)-1==b.indexOf("cke_")&&(c[b]=d=1);return d?c:null},wrapElement:function(a,b){var c=null,d,e;if(a instanceof CKEDITOR.dom.element){b=b||a.data("widget");d=this.registered[b];if(!d)return null;
if((c=a.getParent())&&c.type==CKEDITOR.NODE_ELEMENT&&c.data("cke-widget-wrapper"))return c;a.hasAttribute("data-cke-widget-keep-attr")||a.data("cke-widget-keep-attr",a.data("widget")?1:0);a.data("widget",b);(e=E(d,a.getName()))&&y(a);c=new CKEDITOR.dom.element(e?"span":"div",a.getDocument());c.setAttributes(C(e,b));c.data("cke-display-name",d.pathName?d.pathName:a.getName());a.getParent(!0)&&c.replace(a);a.appendTo(c)}else if(a instanceof CKEDITOR.htmlParser.element){b=b||a.attributes["data-widget"];
d=this.registered[b];if(!d)return null;if((c=a.parent)&&c.type==CKEDITOR.NODE_ELEMENT&&c.attributes["data-cke-widget-wrapper"])return c;"data-cke-widget-keep-attr"in a.attributes||(a.attributes["data-cke-widget-keep-attr"]=a.attributes["data-widget"]?1:0);b&&(a.attributes["data-widget"]=b);(e=E(d,a.name))&&y(a);c=new CKEDITOR.htmlParser.element(e?"span":"div",C(e,b));c.attributes["data-cke-display-name"]=d.pathName?d.pathName:a.name;d=a.parent;var f;d&&(f=a.getIndex(),a.remove());c.add(a);d&&D(d,
f,c)}return c},_tests_createEditableFilter:B};CKEDITOR.event.implementOn(q.prototype);g.prototype={addClass:function(a){this.element.addClass(a);this.wrapper.addClass(g.WRAPPER_CLASS_PREFIX+a)},applyStyle:function(a){I(this,a,1)},checkStyleActive:function(a){a=J(a);var b;if(!a)return!1;for(;b=a.pop();)if(!this.hasClass(b))return!1;return!0},destroy:function(a){this.fire("destroy");if(this.editables)for(var b in this.editables)this.destroyEditable(b,a);a||("0"==this.element.data("cke-widget-keep-attr")&&
this.element.removeAttribute("data-widget"),this.element.removeAttributes(["data-cke-widget-data","data-cke-widget-keep-attr"]),this.element.removeClass("cke_widget_element"),this.element.replace(this.wrapper));this.wrapper=null},destroyEditable:function(a,b){var c=this.editables[a],d=!0;c.removeListener("focus",M);c.removeListener("blur",L);this.editor.focusManager.remove(c);if(c.filter){for(var e in this.repository.instances){var f=this.repository.instances[e];f.editables&&(f=f.editables[a])&&f!==
c&&c.filter===f.filter&&(d=!1)}d&&(c.filter.destroy(),(d=this.repository._.filters[this.name])&&delete d[a])}b||(this.repository.destroyAll(!1,c),c.removeClass("cke_widget_editable"),c.removeClass("cke_widget_editable_focused"),c.removeAttributes(["contenteditable","data-cke-widget-editable","data-cke-enter-mode"]));delete this.editables[a]},edit:function(){var a={dialog:this.dialog},b=this;if(!1===this.fire("edit",a)||!a.dialog)return!1;this.editor.openDialog(a.dialog,function(a){var d,e;!1!==b.fire("dialog",
a)&&(d=a.on("show",function(){a.setupContent(b)}),e=a.on("ok",function(){var d,e=b.on("data",function(a){d=1;a.cancel()},null,null,0);b.editor.fire("saveSnapshot");a.commitContent(b);e.removeListener();d&&(b.fire("data",b.data),b.editor.fire("saveSnapshot"))}),a.once("hide",function(){d.removeListener();e.removeListener()}))},b);return!0},getClasses:function(){return this.repository.parseElementClasses(this.element.getAttribute("class"))},getClipboardHtml:function(){var a=this.editor.createRange();
a.setStartBefore(this.wrapper);a.setEndAfter(this.wrapper);return this.editor.editable().getHtmlFromRange(a).getHtml()},hasClass:function(a){return this.element.hasClass(a)},initEditable:function(a,b){var c=this._findOneNotNested(b.selector);return c&&c.is(CKEDITOR.dtd.$editable)?(c=new t(this.editor,c,{filter:B.call(this.repository,this.name,a,b)}),this.editables[a]=c,c.setAttributes({contenteditable:"true","data-cke-widget-editable":a,"data-cke-enter-mode":c.enterMode}),c.filter&&c.data("cke-filter",
c.filter.id),c.addClass("cke_widget_editable"),c.removeClass("cke_widget_editable_focused"),b.pathName&&c.data("cke-display-name",b.pathName),this.editor.focusManager.add(c),c.on("focus",M,this),CKEDITOR.env.ie&&c.on("blur",L,this),c._.initialSetData=!0,c.setData(c.getHtml()),!0):!1},_findOneNotNested:function(a){a=this.wrapper.find(a);for(var b,c,d=0;d<a.count();d++)if(b=a.getItem(d),c=b.getAscendant(g.isDomWidgetWrapper),this.wrapper.equals(c))return b;return null},isInited:function(){return!(!this.wrapper||
!this.inited)},isReady:function(){return this.isInited()&&this.ready},focus:function(){var a=this.editor.getSelection();if(a){var b=this.editor.checkDirty();a.fake(this.wrapper);!b&&this.editor.resetDirty()}this.editor.focus()},refreshMask:function(){O(this)},refreshParts:function(a){N(this,"undefined"!==typeof a?a:!0)},removeClass:function(a){this.element.removeClass(a);this.wrapper.removeClass(g.WRAPPER_CLASS_PREFIX+a)},removeStyle:function(a){I(this,a,0)},setData:function(a,b){var c=this.data,
d=0;if("string"==typeof a)c[a]!==b&&(c[a]=b,d=1);else{var e=a;for(a in e)c[a]!==e[a]&&(d=1,c[a]=e[a])}d&&this.dataReady&&(v(this),this.fire("data",c));return this},setFocused:function(a){this.wrapper[a?"addClass":"removeClass"]("cke_widget_focused");this.fire(a?"focus":"blur");return this},setSelected:function(a){this.wrapper[a?"addClass":"removeClass"]("cke_widget_selected");this.fire(a?"select":"deselect");return this},updateDragHandlerPosition:function(){var a=this.editor,b=this.element.$,c=this._.dragHandlerOffset,
b={x:b.offsetLeft,y:b.offsetTop-15};c&&b.x==c.x&&b.y==c.y||(c=a.checkDirty(),a.fire("lockSnapshot"),this.dragHandlerContainer.setStyles({top:b.y+"px",left:b.x+"px"}),this.dragHandlerContainer.removeStyle("display"),a.fire("unlockSnapshot"),!c&&a.resetDirty(),this._.dragHandlerOffset=b)}};CKEDITOR.event.implementOn(g.prototype);g.getNestedEditable=function(a,b){return!b||b.equals(a)?null:g.isDomNestedEditable(b)?b:g.getNestedEditable(a,b.getParent())};g.isDomDragHandler=function(a){return a.type==
CKEDITOR.NODE_ELEMENT&&a.hasAttribute("data-cke-widget-drag-handler")};g.isDomDragHandlerContainer=function(a){return a.type==CKEDITOR.NODE_ELEMENT&&a.hasClass("cke_widget_drag_handler_container")};g.isDomNestedEditable=function(a){return a.type==CKEDITOR.NODE_ELEMENT&&a.hasAttribute("data-cke-widget-editable")};g.isDomWidgetElement=function(a){return a.type==CKEDITOR.NODE_ELEMENT&&a.hasAttribute("data-widget")};g.isDomWidgetWrapper=function(a){return a.type==CKEDITOR.NODE_ELEMENT&&a.hasAttribute("data-cke-widget-wrapper")};
g.isDomWidget=function(a){return a?this.isDomWidgetWrapper(a)||this.isDomWidgetElement(a):!1};g.isParserWidgetElement=function(a){return a.type==CKEDITOR.NODE_ELEMENT&&!!a.attributes["data-widget"]};g.isParserWidgetWrapper=function(a){return a.type==CKEDITOR.NODE_ELEMENT&&!!a.attributes["data-cke-widget-wrapper"]};g.WRAPPER_CLASS_PREFIX="cke_widget_wrapper_";t.prototype=CKEDITOR.tools.extend(CKEDITOR.tools.prototypedCopy(CKEDITOR.dom.element.prototype),{setData:function(a){this._.initialSetData||
this.editor.widgets.destroyAll(!1,this);this._.initialSetData=!1;a=this.editor.dataProcessor.toDataFormat(a,{context:this.getName(),filter:this.filter,enterMode:this.enterMode});a=this.editor.dataProcessor.toHtml(a,{context:this.getName(),filter:this.filter,enterMode:this.enterMode});this.setHtml(a);this.editor.widgets.initOnAll(this)},getData:function(){return this.editor.dataProcessor.toDataFormat(this.getHtml(),{context:this.getName(),filter:this.filter,enterMode:this.enterMode})}});var fa=/^(?:<(?:div|span)(?: data-cke-temp="1")?(?: id="cke_copybin")?(?: data-cke-temp="1")?>)?(?:<(?:div|span)(?: style="[^"]+")?>)?<span [^>]*data-cke-copybin-start="1"[^>]*>.?<\/span>([\s\S]+)<span [^>]*data-cke-copybin-end="1"[^>]*>.?<\/span>(?:<\/(?:div|span)>)?(?:<\/(?:div|span)>)?$/i,
P={37:1,38:1,39:1,40:1,8:1,46:1};P[CKEDITOR.SHIFT+121]=1;var u=CKEDITOR.tools.createClass({$:function(a,b){this._.createCopyBin(a,b);this._.createListeners(b)},_:{createCopyBin:function(a){var b=a.document,c=CKEDITOR.env.edge&&16<=CKEDITOR.env.version,d=!a.blockless&&!CKEDITOR.env.ie||c?"div":"span",c=b.createElement(d),b=b.createElement(d);b.setAttributes({id:"cke_copybin","data-cke-temp":"1"});c.setStyles({position:"absolute",width:"1px",height:"1px",overflow:"hidden"});c.setStyle("ltr"==a.config.contentsLangDirection?
"left":"right","-5000px");this.editor=a;this.copyBin=c;this.container=b},createListeners:function(a){a&&(a.beforeDestroy&&(this.beforeDestroy=a.beforeDestroy),a.afterDestroy&&(this.afterDestroy=a.afterDestroy))}},proto:{handle:function(a){var b=this.copyBin,c=this.editor,d=this.container,e=CKEDITOR.env.ie&&9>CKEDITOR.env.version,f=c.document.getDocumentElement().$,h=c.createRange(),g=this,k=CKEDITOR.env.mac&&CKEDITOR.env.webkit,n=k?100:0,m=window.requestAnimationFrame&&!k?requestAnimationFrame:setTimeout,
p,r,q;b.setHtml('\x3cspan data-cke-copybin-start\x3d"1"\x3e​\x3c/span\x3e'+a+'\x3cspan data-cke-copybin-end\x3d"1"\x3e​\x3c/span\x3e');c.fire("lockSnapshot");d.append(b);c.editable().append(d);p=c.on("selectionChange",K,null,null,0);r=c.widgets.on("checkSelection",K,null,null,0);e&&(q=f.scrollTop);h.selectNodeContents(b);h.select();e&&(f.scrollTop=q);return new CKEDITOR.tools.promise(function(a){m(function(){g.beforeDestroy&&g.beforeDestroy();d.remove();p.removeListener();r.removeListener();c.fire("unlockSnapshot");
g.afterDestroy&&g.afterDestroy();a()},n)})}},statics:{hasCopyBin:function(a){return!!u.getCopyBin(a)},getCopyBin:function(a){return a.document.getById("cke_copybin")}}});CKEDITOR.plugins.widget=g;g.repository=q;g.nestedEditable=t})();(function(){function e(a,b,c){this.editor=a;this.notification=null;this._message=new CKEDITOR.template(b);this._singularMessage=c?new CKEDITOR.template(c):null;this._tasks=[];this._doneTasks=this._doneWeights=this._totalWeights=0}function d(a){this._weight=a||1;this._doneWeight=0;this._isCanceled=!1}CKEDITOR.plugins.add("notificationaggregator",{requires:"notification"});e.prototype={createTask:function(a){a=a||{};var b=!this.notification,c;b&&(this.notification=this._createNotification());c=this._addTask(a);
c.on("updated",this._onTaskUpdate,this);c.on("done",this._onTaskDone,this);c.on("canceled",function(){this._removeTask(c)},this);this.update();b&&this.notification.show();return c},update:function(){this._updateNotification();this.isFinished()&&this.fire("finished")},getPercentage:function(){return 0===this.getTaskCount()?1:this._doneWeights/this._totalWeights},isFinished:function(){return this.getDoneTaskCount()===this.getTaskCount()},getTaskCount:function(){return this._tasks.length},getDoneTaskCount:function(){return this._doneTasks},
_updateNotification:function(){this.notification.update({message:this._getNotificationMessage(),progress:this.getPercentage()})},_getNotificationMessage:function(){var a=this.getTaskCount(),b={current:this.getDoneTaskCount(),max:a,percentage:Math.round(100*this.getPercentage())};return(1==a&&this._singularMessage?this._singularMessage:this._message).output(b)},_createNotification:function(){return new CKEDITOR.plugins.notification(this.editor,{type:"progress"})},_addTask:function(a){a=new d(a.weight);
this._tasks.push(a);this._totalWeights+=a._weight;return a},_removeTask:function(a){var b=CKEDITOR.tools.indexOf(this._tasks,a);-1!==b&&(a._doneWeight&&(this._doneWeights-=a._doneWeight),this._totalWeights-=a._weight,this._tasks.splice(b,1),this.update())},_onTaskUpdate:function(a){this._doneWeights+=a.data;this.update()},_onTaskDone:function(){this._doneTasks+=1;this.update()}};CKEDITOR.event.implementOn(e.prototype);d.prototype={done:function(){this.update(this._weight)},update:function(a){if(!this.isDone()&&
!this.isCanceled()){a=Math.min(this._weight,a);var b=a-this._doneWeight;this._doneWeight=a;this.fire("updated",b);this.isDone()&&this.fire("done")}},cancel:function(){this.isDone()||this.isCanceled()||(this._isCanceled=!0,this.fire("canceled"))},isDone:function(){return this._weight===this._doneWeight},isCanceled:function(){return this._isCanceled}};CKEDITOR.event.implementOn(d.prototype);CKEDITOR.plugins.notificationAggregator=e;CKEDITOR.plugins.notificationAggregator.task=d})();(function(){CKEDITOR.plugins.add("uploadwidget",{requires:"widget,clipboard,filetools,notificationaggregator",init:function(a){a.filter.allow("*[!data-widget,!data-cke-upload-id]")},isSupportedEnvironment:function(){return CKEDITOR.plugins.clipboard.isFileApiSupported}});CKEDITOR.fileTools||(CKEDITOR.fileTools={});CKEDITOR.tools.extend(CKEDITOR.fileTools,{addUploadWidget:function(a,c,f){var h=CKEDITOR.fileTools,b=a.uploadRepository,m=f.supportedTypes?10:20;if(f.fileToElement)a.on("paste",function(d){d=
d.data;var l=a.widgets.registered[c],k=d.dataTransfer,f=k.getFilesCount(),g=l.loadMethod||"loadAndUpload",e,n;if(!d.dataValue&&f)for(n=0;n<f;n++)if(e=k.getFile(n),!l.supportedTypes||h.isTypeSupported(e,l.supportedTypes)){var m=l.fileToElement(e);e=b.create(e,void 0,l.loaderType);m&&(e[g](l.uploadUrl,l.additionalRequestParameters),CKEDITOR.fileTools.markElement(m,c,e.id),"loadAndUpload"!=g&&"upload"!=g||l.skipNotifications||CKEDITOR.fileTools.bindNotifications(a,e),d.dataValue+=m.getOuterHtml())}},
null,null,m);CKEDITOR.tools.extend(f,{downcast:function(){return new CKEDITOR.htmlParser.text("")},init:function(){var d=this,c=this.wrapper.findOne("[data-cke-upload-id]").data("cke-upload-id"),k=b.loaders[c],f=CKEDITOR.tools.capitalize,g,e;k.on("update",function(b){if("abort"===k.status&&"function"===typeof d.onAbort)d.onAbort(k);if(d.wrapper&&d.wrapper.getParent()){a.fire("lockSnapshot");b="on"+f(k.status);if("abort"===k.status||"function"!==typeof d[b]||!1!==d[b](k))e="cke_upload_"+k.status,d.wrapper&&
e!=g&&(g&&d.wrapper.removeClass(g),d.wrapper.addClass(e),g=e),"error"!=k.status&&"abort"!=k.status||a.widgets.del(d);a.fire("unlockSnapshot")}else CKEDITOR.instances[a.name]&&a.editable().find('[data-cke-upload-id\x3d"'+c+'"]').count()||k.abort(),b.removeListener()});k.update()},replaceWith:function(d,c){if(""===d.trim())a.widgets.del(this);else{var b=this==a.widgets.focused,f=a.editable(),g=a.createRange(),e,h;b||(h=a.getSelection().createBookmarks());g.setStartBefore(this.wrapper);g.setEndAfter(this.wrapper);
b&&(e=g.createBookmark());f.insertHtmlIntoRange(d,g,c);a.widgets.checkWidgets({initOnlyNew:!0});a.widgets.destroy(this,!0);b?(g.moveToBookmark(e),g.select()):a.getSelection().selectBookmarks(h)}},_getLoader:function(){var a=this.wrapper.findOne("[data-cke-upload-id]");return a?this.editor.uploadRepository.loaders[a.data("cke-upload-id")]:null}});a.widgets.add(c,f)},markElement:function(a,c,f){a.setAttributes({"data-cke-upload-id":f,"data-widget":c})},bindNotifications:function(a,c){function f(){h=
a._.uploadWidgetNotificaionAggregator;if(!h||h.isFinished())h=a._.uploadWidgetNotificaionAggregator=new CKEDITOR.plugins.notificationAggregator(a,a.lang.uploadwidget.uploadMany,a.lang.uploadwidget.uploadOne),h.once("finished",function(){var b=h.getTaskCount();0===b?h.notification.hide():h.notification.update({message:1==b?a.lang.uploadwidget.doneOne:a.lang.uploadwidget.doneMany.replace("%1",b),type:"success",important:1})})}var h,b=null;c.on("update",function(){!b&&c.uploadTotal&&(f(),b=h.createTask({weight:c.uploadTotal}));
b&&"uploading"==c.status&&b.update(c.uploaded)});c.on("uploaded",function(){b&&b.done()});c.on("error",function(){b&&b.cancel();a.showNotification(c.message,"warning")});c.on("abort",function(){b&&b.cancel();CKEDITOR.instances[a.name]&&a.showNotification(a.lang.uploadwidget.abort,"info")})}})})();(function(){function l(c){9>=c&&(c="0"+c);return String(c)}function n(c){var a=new Date,a=[a.getFullYear(),a.getMonth()+1,a.getDate(),a.getHours(),a.getMinutes(),a.getSeconds()];e+=1;return"image-"+CKEDITOR.tools.array.map(a,l).join("")+"-"+e+"."+c}var e=0;CKEDITOR.plugins.add("uploadimage",{requires:"uploadwidget",onLoad:function(){CKEDITOR.addCss(".cke_upload_uploading img{opacity: 0.3}")},isSupportedEnvironment:function(){return CKEDITOR.plugins.clipboard.isFileApiSupported},init:function(c){if(this.isSupportedEnvironment()){var a=
CKEDITOR.fileTools,e=a.getUploadUrl(c.config,"image");e&&(a.addUploadWidget(c,"uploadimage",{supportedTypes:/image\/(jpeg|png|gif|bmp)/,uploadUrl:e,fileToElement:function(){var b=new CKEDITOR.dom.element("img");b.setAttribute("src","data:image/gif;base64,R0lGODlhDgAOAIAAAAAAAP///yH5BAAAAAAALAAAAAAOAA4AAAIMhI+py+0Po5y02qsKADs\x3d");return b},parts:{img:"img"},onUploading:function(b){this.parts.img.setAttribute("src",b.data)},onUploaded:function(b){var a=this.parts.img.$;this.replaceWith('\x3cimg src\x3d"'+
b.url+'" width\x3d"'+(b.responseData.width||a.naturalWidth)+'" height\x3d"'+(b.responseData.height||a.naturalHeight)+'"\x3e')}}),c.on("paste",function(b){if(b.data.dataValue.match(/<img[\s\S]+data:/i)){b=b.data;var f=document.implementation.createHTMLDocument(""),f=new CKEDITOR.dom.element(f.body),m,g,k;f.data("cke-editable",1);f.appendHtml(b.dataValue);m=f.find("img");for(k=0;k<m.count();k++){g=m.getItem(k);var d=g.getAttribute("src"),h=d&&"data:"==d.substring(0,5),l=null===g.data("cke-realelement");
h&&l&&!g.data("cke-upload-id")&&!g.isReadOnly(1)&&(h=(h=d.match(/image\/([a-z]+?);/i))&&h[1]||"jpg",d=c.uploadRepository.create(d,n(h)),d.upload(e),a.markElement(g,"uploadimage",d.id),a.bindNotifications(c,d))}b.dataValue=f.getHtml()}}))}}})})();CKEDITOR.config.plugins='dialogui,dialog,about,a11yhelp,dialogadvtab,basicstyles,bidi,blockquote,notification,button,toolbar,clipboard,panelbutton,panel,floatpanel,colorbutton,colordialog,templates,menu,contextmenu,copyformatting,div,editorplaceholder,resize,elementspath,enterkey,entities,exportpdf,popup,filetools,filebrowser,find,fakeobjects,flash,floatingspace,listblock,richcombo,font,forms,format,horizontalrule,htmlwriter,iframe,wysiwygarea,image,indent,indentblock,indentlist,smiley,justify,menubutton,language,link,list,liststyle,magicline,maximize,newpage,pagebreak,pastetext,xml,ajax,pastetools,pastefromgdocs,pastefromlibreoffice,pastefromword,preview,print,removeformat,save,selectall,showblocks,showborders,sourcearea,specialchar,scayt,stylescombo,tab,table,tabletools,tableselection,undo,lineutils,widgetselection,widget,notificationaggregator,uploadwidget,uploadimage';CKEDITOR.config.skin='moono-lisa';(function() {var setIcons = function(icons, strip) {var path = CKEDITOR.getUrl( 'plugins/' + strip );icons = icons.split( ',' );for ( var i = 0; i < icons.length; i++ )CKEDITOR.skin.icons[ icons[ i ] ] = { path: path, offset: -icons[ ++i ], bgsize : icons[ ++i ] };};if (CKEDITOR.env.hidpi) setIcons('about,0,,bold,24,,italic,48,,strike,72,,subscript,96,,superscript,120,,underline,144,,bidiltr,168,,bidirtl,192,,blockquote,216,,copy-rtl,240,,copy,264,,cut-rtl,288,,cut,312,,paste-rtl,336,,paste,360,,bgcolor,384,,textcolor,408,,templates-rtl,432,,templates,456,,copyformatting,480,,creatediv,504,,exportpdf,528,,find-rtl,552,,find,576,,replace,600,,flash,624,,button,648,,checkbox,672,,form,696,,hiddenfield,720,,imagebutton,744,,radio,768,,select-rtl,792,,select,816,,textarea-rtl,840,,textarea,864,,textfield-rtl,888,,textfield,912,,horizontalrule,936,,iframe,960,,image,984,,indent-rtl,1008,,indent,1032,,outdent-rtl,1056,,outdent,1080,,smiley,1104,,justifyblock,1128,,justifycenter,1152,,justifyleft,1176,,justifyright,1200,,language,1224,,anchor-rtl,1248,,anchor,1272,,link,1296,,unlink,1320,,bulletedlist-rtl,1344,,bulletedlist,1368,,numberedlist-rtl,1392,,numberedlist,1416,,maximize,1440,,newpage-rtl,1464,,newpage,1488,,pagebreak-rtl,1512,,pagebreak,1536,,pastetext-rtl,1560,,pastetext,1584,,pastefromword-rtl,1608,,pastefromword,1632,,preview-rtl,1656,,preview,1680,,print,1704,,removeformat,1728,,save,1752,,selectall,1776,,showblocks-rtl,1800,,showblocks,1824,,source-rtl,1848,,source,1872,,specialchar,1896,,scayt,1920,,table,1944,,redo-rtl,1968,,redo,1992,,undo-rtl,2016,,undo,2040,','icons_hidpi.png');else setIcons('about,0,auto,bold,24,auto,italic,48,auto,strike,72,auto,subscript,96,auto,superscript,120,auto,underline,144,auto,bidiltr,168,auto,bidirtl,192,auto,blockquote,216,auto,copy-rtl,240,auto,copy,264,auto,cut-rtl,288,auto,cut,312,auto,paste-rtl,336,auto,paste,360,auto,bgcolor,384,auto,textcolor,408,auto,templates-rtl,432,auto,templates,456,auto,copyformatting,480,auto,creatediv,504,auto,exportpdf,528,auto,find-rtl,552,auto,find,576,auto,replace,600,auto,flash,624,auto,button,648,auto,checkbox,672,auto,form,696,auto,hiddenfield,720,auto,imagebutton,744,auto,radio,768,auto,select-rtl,792,auto,select,816,auto,textarea-rtl,840,auto,textarea,864,auto,textfield-rtl,888,auto,textfield,912,auto,horizontalrule,936,auto,iframe,960,auto,image,984,auto,indent-rtl,1008,auto,indent,1032,auto,outdent-rtl,1056,auto,outdent,1080,auto,smiley,1104,auto,justifyblock,1128,auto,justifycenter,1152,auto,justifyleft,1176,auto,justifyright,1200,auto,language,1224,auto,anchor-rtl,1248,auto,anchor,1272,auto,link,1296,auto,unlink,1320,auto,bulletedlist-rtl,1344,auto,bulletedlist,1368,auto,numberedlist-rtl,1392,auto,numberedlist,1416,auto,maximize,1440,auto,newpage-rtl,1464,auto,newpage,1488,auto,pagebreak-rtl,1512,auto,pagebreak,1536,auto,pastetext-rtl,1560,auto,pastetext,1584,auto,pastefromword-rtl,1608,auto,pastefromword,1632,auto,preview-rtl,1656,auto,preview,1680,auto,print,1704,auto,removeformat,1728,auto,save,1752,auto,selectall,1776,auto,showblocks-rtl,1800,auto,showblocks,1824,auto,source-rtl,1848,auto,source,1872,auto,specialchar,1896,auto,scayt,1920,auto,table,1944,auto,redo-rtl,1968,auto,redo,1992,auto,undo-rtl,2016,auto,undo,2040,auto','icons.png');})();CKEDITOR.lang.languages={"en":1};}());
﻿/*
Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or https://ckeditor.com/license
*/
CKEDITOR.lang['en']={"editor":"Rich Text Editor","editorPanel":"Rich Text Editor panel","common":{"editorHelp":"Press ALT 0 for help","browseServer":"Browse Server","url":"URL","protocol":"Protocol","upload":"Upload","uploadSubmit":"Send it to the Server","image":"Image","flash":"Flash","form":"Form","checkbox":"Checkbox","radio":"Radio Button","textField":"Text Field","textarea":"Textarea","hiddenField":"Hidden Field","button":"Button","select":"Selection Field","imageButton":"Image Button","notSet":"<not set>","id":"Id","name":"Name","langDir":"Language Direction","langDirLtr":"Left to Right (LTR)","langDirRtl":"Right to Left (RTL)","langCode":"Language Code","longDescr":"Long Description URL","cssClass":"Stylesheet Classes","advisoryTitle":"Advisory Title","cssStyle":"Style","ok":"OK","cancel":"Cancel","close":"Close","preview":"Preview","resize":"Resize","generalTab":"General","advancedTab":"Advanced","validateNumberFailed":"This value is not a number.","confirmNewPage":"Any unsaved changes to this content will be lost. Are you sure you want to load new page?","confirmCancel":"You have changed some options. Are you sure you want to close the dialog window?","options":"Options","target":"Target","targetNew":"New Window (_blank)","targetTop":"Topmost Window (_top)","targetSelf":"Same Window (_self)","targetParent":"Parent Window (_parent)","langDirLTR":"Left to Right (LTR)","langDirRTL":"Right to Left (RTL)","styles":"Style","cssClasses":"Stylesheet Classes","width":"Width","height":"Height","align":"Alignment","left":"Left","right":"Right","center":"Center","justify":"Justify","alignLeft":"Align Left","alignRight":"Align Right","alignCenter":"Align Center","alignTop":"Top","alignMiddle":"Middle","alignBottom":"Bottom","alignNone":"None","invalidValue":"Invalid value.","invalidHeight":"Height must be a number.","invalidWidth":"Width must be a number.","invalidLength":"Value specified for the \"%1\" field must be a positive number with or without a valid measurement unit (%2).","invalidCssLength":"Value specified for the \"%1\" field must be a positive number with or without a valid CSS measurement unit (px, %, in, cm, mm, em, ex, pt, or pc).","invalidHtmlLength":"Value specified for the \"%1\" field must be a positive number with or without a valid HTML measurement unit (px or %).","invalidInlineStyle":"Value specified for the inline style must consist of one or more tuples with the format of \"name : value\", separated by semi-colons.","cssLengthTooltip":"Enter a number for a value in pixels or a number with a valid CSS unit (px, %, in, cm, mm, em, ex, pt, or pc).","unavailable":"%1<span class=\"cke_accessibility\">, unavailable</span>","keyboard":{"8":"Backspace","13":"Enter","16":"Shift","17":"Ctrl","18":"Alt","32":"Space","35":"End","36":"Home","46":"Delete","112":"F1","113":"F2","114":"F3","115":"F4","116":"F5","117":"F6","118":"F7","119":"F8","120":"F9","121":"F10","122":"F11","123":"F12","124":"F13","125":"F14","126":"F15","127":"F16","128":"F17","129":"F18","130":"F19","131":"F20","132":"F21","133":"F22","134":"F23","135":"F24","224":"Command"},"keyboardShortcut":"Keyboard shortcut","optionDefault":"Default"},"about":{"copy":"Copyright &copy; $1. All rights reserved.","dlgTitle":"About CKEditor 4","moreInfo":"For licensing information please visit our web site:"},"basicstyles":{"bold":"Bold","italic":"Italic","strike":"Strikethrough","subscript":"Subscript","superscript":"Superscript","underline":"Underline"},"bidi":{"ltr":"Text direction from left to right","rtl":"Text direction from right to left"},"blockquote":{"toolbar":"Block Quote"},"notification":{"closed":"Notification closed."},"toolbar":{"toolbarCollapse":"Collapse Toolbar","toolbarExpand":"Expand Toolbar","toolbarGroups":{"document":"Document","clipboard":"Clipboard/Undo","editing":"Editing","forms":"Forms","basicstyles":"Basic Styles","paragraph":"Paragraph","links":"Links","insert":"Insert","styles":"Styles","colors":"Colors","tools":"Tools"},"toolbars":"Editor toolbars"},"clipboard":{"copy":"Copy","copyError":"Your browser security settings don't permit the editor to automatically execute copying operations. Please use the keyboard for that (Ctrl/Cmd+C).","cut":"Cut","cutError":"Your browser security settings don't permit the editor to automatically execute cutting operations. Please use the keyboard for that (Ctrl/Cmd+X).","paste":"Paste","pasteNotification":"Press %1 to paste. Your browser doesn‘t support pasting with the toolbar button or context menu option.","pasteArea":"Paste Area","pasteMsg":"Paste your content inside the area below and press OK."},"colorbutton":{"auto":"Automatic","bgColorTitle":"Background Color","colors":{"000":"Black","800000":"Maroon","8B4513":"Saddle Brown","2F4F4F":"Dark Slate Gray","008080":"Teal","000080":"Navy","4B0082":"Indigo","696969":"Dark Gray","B22222":"Fire Brick","A52A2A":"Brown","DAA520":"Golden Rod","006400":"Dark Green","40E0D0":"Turquoise","0000CD":"Medium Blue","800080":"Purple","808080":"Gray","F00":"Red","FF8C00":"Dark Orange","FFD700":"Gold","008000":"Green","0FF":"Cyan","00F":"Blue","EE82EE":"Violet","A9A9A9":"Dim Gray","FFA07A":"Light Salmon","FFA500":"Orange","FFFF00":"Yellow","00FF00":"Lime","AFEEEE":"Pale Turquoise","ADD8E6":"Light Blue","DDA0DD":"Plum","D3D3D3":"Light Grey","FFF0F5":"Lavender Blush","FAEBD7":"Antique White","FFFFE0":"Light Yellow","F0FFF0":"Honeydew","F0FFFF":"Azure","F0F8FF":"Alice Blue","E6E6FA":"Lavender","FFF":"White","1ABC9C":"Strong Cyan","2ECC71":"Emerald","3498DB":"Bright Blue","9B59B6":"Amethyst","4E5F70":"Grayish Blue","F1C40F":"Vivid Yellow","16A085":"Dark Cyan","27AE60":"Dark Emerald","2980B9":"Strong Blue","8E44AD":"Dark Violet","2C3E50":"Desaturated Blue","F39C12":"Orange","E67E22":"Carrot","E74C3C":"Pale Red","ECF0F1":"Bright Silver","95A5A6":"Light Grayish Cyan","DDD":"Light Gray","D35400":"Pumpkin","C0392B":"Strong Red","BDC3C7":"Silver","7F8C8D":"Grayish Cyan","999":"Dark Gray"},"more":"More Colors...","panelTitle":"Colors","textColorTitle":"Text Color"},"colordialog":{"clear":"Clear","highlight":"Highlight","options":"Color Options","selected":"Selected Color","title":"Select color"},"templates":{"button":"Templates","emptyListMsg":"(No templates defined)","insertOption":"Replace actual contents","options":"Template Options","selectPromptMsg":"Please select the template to open in the editor","title":"Content Templates"},"contextmenu":{"options":"Context Menu Options"},"copyformatting":{"label":"Copy Formatting","notification":{"copied":"Formatting copied","applied":"Formatting applied","canceled":"Formatting canceled","failed":"Formatting failed. You cannot apply styles without copying them first."}},"div":{"IdInputLabel":"Id","advisoryTitleInputLabel":"Advisory Title","cssClassInputLabel":"Stylesheet Classes","edit":"Edit Div","inlineStyleInputLabel":"Inline Style","langDirLTRLabel":"Left to Right (LTR)","langDirLabel":"Language Direction","langDirRTLLabel":"Right to Left (RTL)","languageCodeInputLabel":" Language Code","remove":"Remove Div","styleSelectLabel":"Style","title":"Create Div Container","toolbar":"Create Div Container"},"elementspath":{"eleLabel":"Elements path","eleTitle":"%1 element"},"exportpdf":{"documentReady":"Document is ready!","error":"Error occurred.","processingDocument":"Processing PDF document...","toolbar":"Export to PDF"},"filetools":{"loadError":"Error occurred during file read.","networkError":"Network error occurred during file upload.","httpError404":"HTTP error occurred during file upload (404: File not found).","httpError403":"HTTP error occurred during file upload (403: Forbidden).","httpError":"HTTP error occurred during file upload (error status: %1).","noUrlError":"Upload URL is not defined.","responseError":"Incorrect server response."},"find":{"find":"Find","findOptions":"Find Options","findWhat":"Find what:","matchCase":"Match case","matchCyclic":"Match cyclic","matchWord":"Match whole word","notFoundMsg":"The specified text was not found.","replace":"Replace","replaceAll":"Replace All","replaceSuccessMsg":"%1 occurrence(s) replaced.","replaceWith":"Replace with:","title":"Find and Replace"},"fakeobjects":{"anchor":"Anchor","flash":"Flash Animation","hiddenfield":"Hidden Field","iframe":"IFrame","unknown":"Unknown Object"},"flash":{"access":"Script Access","accessAlways":"Always","accessNever":"Never","accessSameDomain":"Same domain","alignAbsBottom":"Abs Bottom","alignAbsMiddle":"Abs Middle","alignBaseline":"Baseline","alignTextTop":"Text Top","bgcolor":"Background color","chkFull":"Allow Fullscreen","chkLoop":"Loop","chkMenu":"Enable Flash Menu","chkPlay":"Auto Play","flashvars":"Variables for Flash","hSpace":"HSpace","properties":"Flash Properties","propertiesTab":"Properties","quality":"Quality","qualityAutoHigh":"Auto High","qualityAutoLow":"Auto Low","qualityBest":"Best","qualityHigh":"High","qualityLow":"Low","qualityMedium":"Medium","scale":"Scale","scaleAll":"Show all","scaleFit":"Exact Fit","scaleNoBorder":"No Border","title":"Flash Properties","vSpace":"VSpace","validateHSpace":"HSpace must be a number.","validateSrc":"URL must not be empty.","validateVSpace":"VSpace must be a number.","windowMode":"Window mode","windowModeOpaque":"Opaque","windowModeTransparent":"Transparent","windowModeWindow":"Window"},"font":{"fontSize":{"label":"Size","voiceLabel":"Font Size","panelTitle":"Font Size"},"label":"Font","panelTitle":"Font Name","voiceLabel":"Font"},"forms":{"button":{"title":"Button Properties","text":"Text (Value)","type":"Type","typeBtn":"Button","typeSbm":"Submit","typeRst":"Reset"},"checkboxAndRadio":{"checkboxTitle":"Checkbox Properties","radioTitle":"Radio Button Properties","value":"Value","selected":"Selected","required":"Required"},"form":{"title":"Form Properties","menu":"Form Properties","action":"Action","method":"Method","encoding":"Encoding"},"hidden":{"title":"Hidden Field Properties","name":"Name","value":"Value"},"select":{"title":"Selection Field Properties","selectInfo":"Select Info","opAvail":"Available Options","value":"Value","size":"Size","lines":"lines","chkMulti":"Allow multiple selections","required":"Required","opText":"Text","opValue":"Value","btnAdd":"Add","btnModify":"Modify","btnUp":"Up","btnDown":"Down","btnSetValue":"Set as selected value","btnDelete":"Delete"},"textarea":{"title":"Textarea Properties","cols":"Columns","rows":"Rows"},"textfield":{"title":"Text Field Properties","name":"Name","value":"Value","charWidth":"Character Width","maxChars":"Maximum Characters","required":"Required","type":"Type","typeText":"Text","typePass":"Password","typeEmail":"Email","typeSearch":"Search","typeTel":"Telephone Number","typeUrl":"URL"}},"format":{"label":"Format","panelTitle":"Paragraph Format","tag_address":"Address","tag_div":"Normal (DIV)","tag_h1":"Heading 1","tag_h2":"Heading 2","tag_h3":"Heading 3","tag_h4":"Heading 4","tag_h5":"Heading 5","tag_h6":"Heading 6","tag_p":"Normal","tag_pre":"Formatted"},"horizontalrule":{"toolbar":"Insert Horizontal Line"},"iframe":{"border":"Show frame border","noUrl":"Please type the iframe URL","scrolling":"Enable scrollbars","title":"IFrame Properties","toolbar":"IFrame","tabindex":"Remove from tabindex"},"image":{"alt":"Alternative Text","border":"Border","btnUpload":"Send it to the Server","button2Img":"Do you want to transform the selected image button on a simple image?","hSpace":"HSpace","img2Button":"Do you want to transform the selected image on a image button?","infoTab":"Image Info","linkTab":"Link","lockRatio":"Lock Ratio","menu":"Image Properties","resetSize":"Reset Size","title":"Image Properties","titleButton":"Image Button Properties","upload":"Upload","urlMissing":"Image source URL is missing.","vSpace":"VSpace","validateBorder":"Border must be a whole number.","validateHSpace":"HSpace must be a whole number.","validateVSpace":"VSpace must be a whole number."},"indent":{"indent":"Increase Indent","outdent":"Decrease Indent"},"smiley":{"options":"Smiley Options","title":"Insert a Smiley","toolbar":"Smiley"},"language":{"button":"Set language","remove":"Remove language"},"link":{"acccessKey":"Access Key","advanced":"Advanced","advisoryContentType":"Advisory Content Type","advisoryTitle":"Advisory Title","anchor":{"toolbar":"Anchor","menu":"Edit Anchor","title":"Anchor Properties","name":"Anchor Name","errorName":"Please type the anchor name","remove":"Remove Anchor"},"anchorId":"By Element Id","anchorName":"By Anchor Name","charset":"Linked Resource Charset","cssClasses":"Stylesheet Classes","download":"Force Download","displayText":"Display Text","emailAddress":"E-Mail Address","emailBody":"Message Body","emailSubject":"Message Subject","id":"Id","info":"Link Info","langCode":"Language Code","langDir":"Language Direction","langDirLTR":"Left to Right (LTR)","langDirRTL":"Right to Left (RTL)","menu":"Edit Link","name":"Name","noAnchors":"(No anchors available in the document)","noEmail":"Please type the e-mail address","noUrl":"Please type the link URL","noTel":"Please type the phone number","other":"<other>","phoneNumber":"Phone number","popupDependent":"Dependent (Netscape)","popupFeatures":"Popup Window Features","popupFullScreen":"Full Screen (IE)","popupLeft":"Left Position","popupLocationBar":"Location Bar","popupMenuBar":"Menu Bar","popupResizable":"Resizable","popupScrollBars":"Scroll Bars","popupStatusBar":"Status Bar","popupToolbar":"Toolbar","popupTop":"Top Position","rel":"Relationship","selectAnchor":"Select an Anchor","styles":"Style","tabIndex":"Tab Index","target":"Target","targetFrame":"<frame>","targetFrameName":"Target Frame Name","targetPopup":"<popup window>","targetPopupName":"Popup Window Name","title":"Link","toAnchor":"Link to anchor in the text","toEmail":"E-mail","toUrl":"URL","toPhone":"Phone","toolbar":"Link","type":"Link Type","unlink":"Unlink","upload":"Upload"},"list":{"bulletedlist":"Insert/Remove Bulleted List","numberedlist":"Insert/Remove Numbered List"},"liststyle":{"bulletedTitle":"Bulleted List Properties","circle":"Circle","decimal":"Decimal (1, 2, 3, etc.)","disc":"Disc","lowerAlpha":"Lower Alpha (a, b, c, d, e, etc.)","lowerRoman":"Lower Roman (i, ii, iii, iv, v, etc.)","none":"None","notset":"<not set>","numberedTitle":"Numbered List Properties","square":"Square","start":"Start","type":"Type","upperAlpha":"Upper Alpha (A, B, C, D, E, etc.)","upperRoman":"Upper Roman (I, II, III, IV, V, etc.)","validateStartNumber":"List start number must be a whole number."},"magicline":{"title":"Insert paragraph here"},"maximize":{"maximize":"Maximize","minimize":"Minimize"},"newpage":{"toolbar":"New Page"},"pagebreak":{"alt":"Page Break","toolbar":"Insert Page Break for Printing"},"pastetext":{"button":"Paste as plain text","pasteNotification":"Press %1 to paste. Your browser doesn‘t support pasting with the toolbar button or context menu option.","title":"Paste as Plain Text"},"pastefromword":{"confirmCleanup":"The text you want to paste seems to be copied from Word. Do you want to clean it before pasting?","error":"It was not possible to clean up the pasted data due to an internal error","title":"Paste from Word","toolbar":"Paste from Word"},"preview":{"preview":"Preview"},"print":{"toolbar":"Print"},"removeformat":{"toolbar":"Remove Format"},"save":{"toolbar":"Save"},"selectall":{"toolbar":"Select All"},"showblocks":{"toolbar":"Show Blocks"},"sourcearea":{"toolbar":"Source"},"specialchar":{"options":"Special Character Options","title":"Select Special Character","toolbar":"Insert Special Character"},"scayt":{"btn_about":"About SCAYT","btn_dictionaries":"Dictionaries","btn_disable":"Disable SCAYT","btn_enable":"Enable SCAYT","btn_langs":"Languages","btn_options":"Options","text_title":"Spell Check As You Type"},"stylescombo":{"label":"Styles","panelTitle":"Formatting Styles","panelTitle1":"Block Styles","panelTitle2":"Inline Styles","panelTitle3":"Object Styles"},"table":{"border":"Border size","caption":"Caption","cell":{"menu":"Cell","insertBefore":"Insert Cell Before","insertAfter":"Insert Cell After","deleteCell":"Delete Cells","merge":"Merge Cells","mergeRight":"Merge Right","mergeDown":"Merge Down","splitHorizontal":"Split Cell Horizontally","splitVertical":"Split Cell Vertically","title":"Cell Properties","cellType":"Cell Type","rowSpan":"Rows Span","colSpan":"Columns Span","wordWrap":"Word Wrap","hAlign":"Horizontal Alignment","vAlign":"Vertical Alignment","alignBaseline":"Baseline","bgColor":"Background Color","borderColor":"Border Color","data":"Data","header":"Header","yes":"Yes","no":"No","invalidWidth":"Cell width must be a number.","invalidHeight":"Cell height must be a number.","invalidRowSpan":"Rows span must be a whole number.","invalidColSpan":"Columns span must be a whole number.","chooseColor":"Choose"},"cellPad":"Cell padding","cellSpace":"Cell spacing","column":{"menu":"Column","insertBefore":"Insert Column Before","insertAfter":"Insert Column After","deleteColumn":"Delete Columns"},"columns":"Columns","deleteTable":"Delete Table","headers":"Headers","headersBoth":"Both","headersColumn":"First column","headersNone":"None","headersRow":"First Row","heightUnit":"height unit","invalidBorder":"Border size must be a number.","invalidCellPadding":"Cell padding must be a positive number.","invalidCellSpacing":"Cell spacing must be a positive number.","invalidCols":"Number of columns must be a number greater than 0.","invalidHeight":"Table height must be a number.","invalidRows":"Number of rows must be a number greater than 0.","invalidWidth":"Table width must be a number.","menu":"Table Properties","row":{"menu":"Row","insertBefore":"Insert Row Before","insertAfter":"Insert Row After","deleteRow":"Delete Rows"},"rows":"Rows","summary":"Summary","title":"Table Properties","toolbar":"Table","widthPc":"percent","widthPx":"pixels","widthUnit":"width unit"},"undo":{"redo":"Redo","undo":"Undo"},"widget":{"move":"Click and drag to move","label":"%1 widget"},"uploadwidget":{"abort":"Upload aborted by the user.","doneOne":"File successfully uploaded.","doneMany":"Successfully uploaded %1 files.","uploadOne":"Uploading file ({percentage}%)...","uploadMany":"Uploading files, {current} of {max} done ({percentage}%)..."}};
/*!
  * Froala Pages v1.2.0 (https://github.com/froala-labs/froala-pages#readme)
  * Copyright 2017-2020
  * Licensed under Froala Pages Terms (https://www.froala.com/pages/terms)
  */
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.FroalaPages = factory());
}(this, (function () { 'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// Helpers to make changes on the DOM.
var Helpers = function () {
  function Helpers() {
    classCallCheck(this, Helpers);
  }

  Helpers.createElement = function createElement(html) {
    var el = document.createElement('DIV');
    el.innerHTML = html;
    return el.firstChild;
  };

  Helpers.prepend = function prepend(parent, el) {
    if (!parent.firstChild) {
      parent.append(el);
    } else {
      parent.insertBefore(el, parent.firstChild);
    }
  };

  Helpers.append = function append(parent, el) {
    parent.appendChild(el);
  };

  Helpers.after = function after(node, el) {
    node.parentNode.insertBefore(el, node.nextSibling);
  };

  Helpers.before = function before(node, el) {
    node.parentNode.insertBefore(el, node);
  };

  Helpers.remove = function remove(node) {
    if (node && node.parentNode) {
      node.parentNode.removeChild(node);
    }
  };

  Helpers.offset = function offset(el) {
    var rect = el.getBoundingClientRect();

    return {
      top: rect.top,
      left: rect.left
    };
  };

  Helpers.outerHeight = function outerHeight(el) {
    var withMargin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var height = el.offsetHeight;

    if (withMargin) {
      var style = getComputedStyle(el);

      height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
      return height;
    }

    return height;
  };

  Helpers.outerWidth = function outerWidth(el) {
    var withMargin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var width = el.offsetWidth;

    if (withMargin) {
      var style = getComputedStyle(el);

      width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
      return width;
    }

    return 0;
  };

  Helpers.underscores = function underscores(text) {
    return text.toLowerCase().split(' ').join('_');
  };

  Helpers.scrollTo = function scrollTo(el) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'end'
    });
  };

  Helpers.setDownloadBtnsStatus = function setDownloadBtnsStatus(scope, disabledBtn, hide) {
    var downloadBtns = scope.pageToolbar.el.querySelectorAll('.fp-download-btn');

    downloadBtns.forEach(function (btn) {
      // enable or disable download button
      if (!btn) {
        return;
      }

      // hide download button
      btn.style.display = hide ? 'none' : 'flex';

      if (disabledBtn) {
        btn.setAttribute('disabled', 'disabled');
      } else {
        btn.removeAttribute('disabled');
      }
    });
  };

  Helpers.setBackgroundButtonStatus = function setBackgroundButtonStatus(element, scope) {
    let image_button = scope.blockToolbar.el.querySelector('.fp-background_image-btn')
    // let color_button = scope.blockToolbar.el.querySelector('.fp-background_color-btn')
    let remove_button = scope.blockToolbar.el.querySelector('.fp-remove_background-btn')
    // if (element.style.backgroundImage || element.style.backgroundColor) {
    if (element.style.backgroundImage) {
      image_button.classList.add('d-none');
      // image_button.title = 'Replace Background Image';
      // color_button.classList.add('d-none');
      // color_button.title = 'Replace Background Color';
      remove_button.classList.remove('d-none');
    } else {
      image_button.classList.remove('d-none');
      // image_button.title = 'Background Image';
      // color_button.classList.remove('d-none');
      // color_button.title = 'Background Color';
      remove_button.classList.add('d-none');
    }
  };

  return Helpers;
}();

// Define our internal module class.
// The Module class is inherited by inernal classes and in the constructor of the module
// we assign the common used objects for easier access.
var Module = function Module(page) {
    classCallCheck(this, Module);

    // Set page instance.
    this.page = page;

    // Set events.
    this.events = page.events;

    // Set doc.
    this.doc = page.doc;

    // Set options.
    this.opts = page.opts;

    // Call internal init method that works like a constructor.

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    this.init.apply(this, args);
};

// A block on the page.

var Block = function (_M) {
  inherits(Block, _M);

  function Block() {
    classCallCheck(this, Block);
    return possibleConstructorReturn(this, _M.apply(this, arguments));
  }

  Block.prototype.init = function init(designBlock) {
    var _this2 = this;

    this.designBlock = designBlock;
    this.id = ++Block.ID;

    // Create element.
    this.el = Helpers.createElement(designBlock.render({
      imagesDir: this.opts.designsImagesDir
    }));
    this.el.setAttribute('data-block-type', Helpers.underscores(designBlock.blockType));
    this.el.setAttribute('data-id', this.id);

    this.events.on(this.el, 'mouseenter', function () {
      return _this2._mouseEnter();
    });
  };

  // Emit block enter event.


  Block.prototype._mouseEnter = function _mouseEnter() {
    this.events.emit('block.mouseenter', this);
  };

  return Block;
}(Module);

Block.ID = 0;

var DRAG_IMAGE_HEIGHT = 50;

// A design block is an element from the Designs Panel.

var DesignBlock = function (_M) {
  inherits(DesignBlock, _M);

  function DesignBlock() {
    classCallCheck(this, DesignBlock);
    return possibleConstructorReturn(this, _M.apply(this, arguments));
  }

  DesignBlock.prototype.init = function init(blockType, info) {
    var _this2 = this;
    // Create design block.
    this.el = document.createElement('IMG');
    this.el.setAttribute('draggable', true);
    this.blockType = blockType;
    this.template = info.template;
    this.image = info.image;
    this.el.setAttribute('src', '' + (this.opts.designsThumbsDir || '') + this.image);

    // Bind events.
    this.events.on(this.el, 'click', function () {
      return _this2.click();
    });
    this.events.on(this.el, 'dragstart', function (e) {
      return _this2.dragstart(e);
    });
  };

  // Click on a block.


  DesignBlock.prototype.click = function click() {
    this.events.emit('designBlock.click', this);
  };

  // Start dragging a block.


  DesignBlock.prototype.dragstart = function dragstart(e) {
    // Set dragging placeholder.
    if (navigator.userAgent.search('Firefox') >= 0) {
      // Set image holder to support in FF while drag & Drop
      this.dragImage = Helpers.createElement('<span><img src="' + this.el.src + '" height="' + DRAG_IMAGE_HEIGHT + '" /></span>');
    } else {
      this.dragImage = Helpers.createElement('<img src="' + this.el.src + '" height="' + DRAG_IMAGE_HEIGHT + '" />');
    }
    this.dragImage.style.position = 'absolute';
    Helpers.append(this.page.body, this.dragImage);

    e.dataTransfer.setDragImage(this.dragImage, 0, 0);

    // Set empty string to work with Edge browser
    e.dataTransfer.setData('text/html', '');

    // Emit event of drag start.
    this.events.emit('designBlock.willDrag', this);
  };

  // Render design block.


  DesignBlock.prototype.render = function render(params) {
    return this.template.replace(/{{[a-zA-Z_]*}}/g, function (match) {
      var varName = match.replace(/{|}/g, '').trim();

      return params[varName] || '{{' + varName + '}}';
    });
  };

  return DesignBlock;
}(Module);

DesignBlock.BLOCKS = {};
DesignBlock.HEADER = 'Headers';
DesignBlock.FOOTER = 'Footers';
DesignBlock.SOCIAL = 'Social images';

// Global method to register a new design block.
DesignBlock.Register = function (type, template, image) {
  if (!DesignBlock.BLOCKS[type]) {
    DesignBlock.BLOCKS[type] = [];
  }

  DesignBlock.BLOCKS[type].push({
    template: template,
    image: image
  });
};

// Define constants for different views.
var VIEWS = {
  ADD: 1,
  FULL: 2,
  DESKTOP: 100,
  TABLET_LANDSCAPE: 1024,
  TABLET_PORTRAIT: 768,
  PHONE: 375
};

// There are 2 type of buttons - both of them work in the same manner only that have different callbacks:
//   1. on block toolbar
//   2. on page toolabr

var Button = function (_M) {
  inherits(Button, _M);

  function Button() {
    classCallCheck(this, Button);
    return possibleConstructorReturn(this, _M.apply(this, arguments));
  }

  Button.prototype.init = function init(name) {
    var _this2 = this;

    // Get button details.
    this.props = Button._[name];

    if (!this.props) {
      throw new Error('A button with the name ' + name + ' could not be found');
    }

    // Render button.
    this._render(name);

    // Bind button events.
    this.events.on(this.el, 'click', function () {
      return _this2._click();
    });
    this.events.listen('button.refresh', function () {
      return _this2._refresh();
    });

    // Bind event handler for file input field to re-open the saved template for editing.
    if (name === 'loadhtml') {
      this.events.on(this.el.querySelector('#load_template'), 'change', function (e) {
        if (e.target.files.length) {
          _this2.page.uploadTemplate(e.target.files[0]);
          e.target.value = '';
        }
      });
    }

    // Bind event handler for file input field to add background image to active section.
    if (name === 'background_image') {
      this.events.on(this.el.querySelector('#load_background_image'), 'change', function (e) {
        if (e.target.files.length) {
          _this2.page.uploadImage(e.target.files[0], _this2.page.editor.FroalaEditor.IMAGE_ACTIVE_BLOCK);
          e.target.value = '';
        }
      });
    }

    // Bind event handler for text input field to add background color to active section.
    if (name === 'background_color') {
      let element = this.el.querySelector('#load_background_color');
      this.events.listen('color.change', function (e) {
        _this2.page.activeBlock.el.style.setProperty('background-color', element.value, 'important');
        // _this2.page.activeBlock.el.style.backgroundImage = null;
        // _this2.page.activeBlock.el.style.backgroundRepeat = null;
        // _this2.page.activeBlock.el.style.backgroundSize = null;
        Helpers.setBackgroundButtonStatus(_this2.page.activeBlock.el, _this2.page);
      });
    }

    // Bind event handler for field to add settings to active section.
    if (name === 'block_setting') {
      this.events.listen('block.setting', function (values, elements) {
        elements.forEach(item => {
          let value = values[item];
          if (value) {
            if (item === 'background-size' || item === 'aspect-ratio' || item === 'background-repeat') {
              if (item === 'background-repeat') {
                _this2.page.activeBlock.el.style.setProperty('background-size', 'unset', 'important');
              }
              _this2.page.activeBlock.el.style.setProperty(item, value, 'important');
            } else {
              value = value.indexOf('px') !== -1 ? value : (value + 'px');
              _this2.page.activeBlock.el.style.setProperty(item, value, 'important');
            }
          } else {
            _this2.page.activeBlock.el.style[item] = null;
          }
        })
        _this2.page.refreshIframeSize();
      });
    }

    // Bind event handler for file input field to add background image to active section.
    if (name === 'duplicate_block') {
      this.events.on(this.el.querySelector('#duplicate_block'), 'click', function (e) {
        let currentBlock = {
          blockType: _this2.page.activeBlock.designBlock.blockType,
          el: _this2.page.activeBlock.el
        };
        _this2.page.editor.disableForBlock(currentBlock);
        _this2.page.activeBlock.el.isVisible = true;
        const designBlock = {
          blockType: _this2.page.activeBlock.designBlock.blockType,
          template: _this2.page.activeBlock.el.outerHTML,
          el: _this2.page.activeBlock.el,
          render: function render(params) {
            return this.template.replace(/{{[a-zA-Z_]*}}/g, function (match) {
              var varName = match.replace(/{|}/g, '').trim();

              return params[varName] || '{{' + varName + '}}';
            });
          }
        };
        _this2.page.insertBlock(designBlock, _this2.page.activeBlock.el);
        _this2.page.editor.enableForBlock(currentBlock);
        _this2.page.editor.enableForBlock(designBlock);
        setTimeout(() => {
          _this2.page.refreshIframeSize()
        }, 1000)
      });
    }

    // Call button callback after build.
    if (this.props.afterBuild) {
      this.props.afterBuild.apply(this);
    }
  };

  // Refresh button state.


  Button.prototype._refresh = function _refresh() {
    if (this.props.refresh) {
      this.props.refresh.apply(this);
    }
  };

  // Render button.


  Button.prototype._render = function _render(name) {
    this.el = this.doc.createElement('BUTTON');
    this.el.innerHTML = this.props.icon.template;
    this.el.classList.add('fp-btn', 'fp-' + name + '-btn', 'fr-btn-type-' + this.props.icon.type);
    this.el.setAttribute('title', this.props.title);
  };

  // Click button callback.


  Button.prototype._click = function _click() {
    this.props.callback.apply(this);
    this.events.emit('button.refresh');
  };

  return Button;
}(Module);

// Register button.


Button.Register = function (name, props) {
  if (!Button._) {
    Button._ = {};
  }

  Button._[name] = props;
};

// Define layout button.
Button.Register('layout', {
  title: 'Layout',
  icon: {
    type: 'svg',
    template: '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n                <path d="M0 0h24v24H0z" fill="none"/>\n                <path d="M2 21h19v-3H2v3zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 3v3h19V3H2z"/>\n              </svg>'
  },
  callback: function callback() {
    this.page.setView(VIEWS.ADD);
    this.page.designsPanel.show();

    var pageTopEle = this.doc.getElementsByClassName('fp-pageTop-toolbar');
    pageTopEle[0].style.display = 'flex';
  },
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', this.page.activeView === VIEWS.ADD);
  }
});

// Define block move up butotn.
Button.Register('moveUp', {
  title: 'Move Up',
  icon: {
    type: 'svg',
    template: '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n            <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>\n            <path d="M0 0h24v24H0z" fill="none"/>\n          </svg>'
  },
  callback: function callback() {
    var block = this.page.activeBlock;

    var prevBlock = block.el.previousSibling;
    while (prevBlock && (!prevBlock.classList || !prevBlock.classList.contains('fdb-block'))) {
      prevBlock = prevBlock.previousSibling;
    }

    window.a = prevBlock;
    window.b = block.el;

    if (prevBlock) {
      Helpers.before(prevBlock, block.el);
    }

    if (this.page.activeView === VIEWS.FULL) {
      Helpers.scrollTo(block.el);
    }

    this.page.blockToolbar.hide();
    this.page.blockToolbar.refreshPosition();
  },
  refresh: function refresh() {
    if (this.page.activeBlock) {
      this.el.classList.toggle('fp-hidden', [DesignBlock.HEADER, DesignBlock.FOOTER].indexOf(this.page.activeBlock.designBlock.blockType) >= 0);

      var block = this.page.activeBlock;

      var prevBlock = block.el.previousSibling;
      while (prevBlock && (!prevBlock.classList || !prevBlock.classList.contains('fdb-block'))) {
        prevBlock = prevBlock.previousSibling;
      }

      if (!prevBlock) {
        this.el.classList.add('fp-disabled');
        this.el.setAttribute('disabled', 'disabled');
      } else {
        this.el.classList.remove('fp-disabled');
        this.el.removeAttribute('disabled');
      }
    }
  }
});

// Define block remove button.
Button.Register('remove', {
  title: 'Remove',
  icon: {
    type: 'svg',
    template: '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n              <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>\n              <path d="M0 0h24v24H0z" fill="none"/>\n          </svg>'
  },
  callback: function callback() {
    if (this.page.activeBlock) {
      if (confirm('Are you sure you want to remove this design block?')) {
        var block = this.page.activeBlock;
        this.page.blockToolbar.hide();

        Helpers.remove(block.el);

        if (this.page.editor.FroalaEditor) {
          this.page.editor.FroalaEditor.INSTANCES.forEach(function (ed) {
            if (block.el.contains(ed.$oel.get(0))) {
              if (ed.popups) ed.popups.hideAll();
            }
          });
        }
        this.page.refreshBlocks();
        this.events.emit('block.removed', null);
      }
    }
  },
  afterBuild: function afterBuild() {
    this.el.classList.add('fp-remove-btn');
  }
});

// Define page edit button.
Button.Register('edit', {
  title: 'Edit',
  icon: {
    type: 'svg',
    template: '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>\n          <path d="M0 0h24v24H0z" fill="none"/>\n    </svg>'
  },
  callback: function callback() {
    var pageTopEle = this.doc.getElementsByClassName('fp-pageTop-toolbar');
    pageTopEle[0].style.display = 'none';

    this.page.setView(VIEWS.FULL);
    this.page.designsPanel.hide();

    this.page.editor.enable();
  },
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', this.page.activeView === VIEWS.FULL);
  }
});

// Defined page download button.
Button.Register('download', {
  title: 'Download',
  icon: {
    type: 'html',
    template: '\n    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>\n        <path d="M0 0h24v24H0z" fill="none"/>\n    </svg>\n    <span>Download</span>'
  },
  callback: function callback() {
    var _this3 = this;

    // Download templates only if selected
    var noBlocks = !this.page.iframeBody.querySelector('[data-block-type]');

    if (!noBlocks) {
      // Download saved HTML.
      this.page.getHTML().then(function (html) {
        // handle sharewindow
        _this3.page.sharewindow && _this3.page.sharewindow.show();

        var blob = new Blob([html], {
          type: 'text/html'
        });
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'froala_design_blocks_website.html';
        a.click();
      }, function (errorMsg) {
        console.log(errorMsg);
      });
    } else {
      Helpers.setDownloadBtnsStatus(this.page, noBlocks, true);
    }
  }
});

// Define desktop mode.
Button.Register('desktop', {
  title: 'Desktop',
  icon: {
    type: 'svg',
    template: '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n                <path d="M0 0h24v24H0z" fill="none"/>\n                <path d="M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z"/>\n              </svg>'
  },
  callback: function callback() {
    this.page.screenSize = VIEWS.DESKTOP;
    this.page.iframe.style.width = null;
    this.page.el.classList.remove('fp-view-small');
    this.page.refreshIframeSize();
  },
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', this.page.screenSize === VIEWS.DESKTOP);
  },
  afterBuild: function afterBuild() {
    this.page.screenSize = VIEWS.DESKTOP;
  }
});

// Define tablet landscape mode.
Button.Register('tablet_landscape', {
  title: 'Tablet Landscape',
  icon: {
    type: 'svg',
    template: '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z"/>\n              </svg>'
  },
  callback: function callback() {
    this.page.screenSize = VIEWS.TABLET_LANDSCAPE;
    this.page.iframe.style.width = VIEWS.TABLET_LANDSCAPE + 'px';
    this.page.el.classList.add('fp-view-small');
    this.page.refreshIframeSize();
  },
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', this.page.screenSize === VIEWS.TABLET_LANDSCAPE);
  }
});

// Define tablet portrait mode.
Button.Register('tablet_portrait', {
  title: 'Tablet Portrait',
  icon: {
    type: 'svg',
    template: '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n                  <path d="M18.5 0h-14C3.12 0 2 1.12 2 2.5v19C2 22.88 3.12 24 4.5 24h14c1.38 0 2.5-1.12 2.5-2.5v-19C21 1.12 19.88 0 18.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z"/>\n              </svg>'
  },
  callback: function callback() {
    this.page.screenSize = VIEWS.TABLET_PORTRAIT;
    this.page.iframe.style.width = VIEWS.TABLET_PORTRAIT + 'px';
    this.page.el.classList.add('fp-view-small');
    this.page.refreshIframeSize();
  },
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', this.page.screenSize === VIEWS.TABLET_PORTRAIT);
  }
});

// Define phone mode.
Button.Register('phone', {
  title: 'Phone',
  icon: {
    type: 'svg',
    template: '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n                <path d="M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z"/>\n                <path d="M0 0h24v24H0z" fill="none"/>\n              </svg>'
  },
  callback: function callback() {
    this.page.screenSize = VIEWS.PHONE;
    this.page.iframe.style.width = VIEWS.PHONE + 'px';
    this.page.el.classList.add('fp-view-small');
    this.page.refreshIframeSize();
  },
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', this.page.screenSize === VIEWS.PHONE);
  }
});

// Define re-open saved template button.
Button.Register('loadhtml', {
  title: 'Load HTML',
  icon: {
    type: 'svg',
    template: '<label for="load_template"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">\n                <path d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"></path>\n              </svg></label><input type="file" id="load_template" style="display: none;" />'
  },
  callback: function callback() {},
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', false);
  }
});

// Custom button to add background image to active block
Button.Register('background_image', {
  title: 'Background Image',
  icon: {
    type: 'svg',
    template: '<label for="load_background_image" class="cursor-pointer px-2"><svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M14.2,11l3.8,5H6l3-3.9l2.1,2.7L14,11H14.2z M8.5,11c0.8,0,1.5-0.7,1.5-1.5S9.3,8,8.5,8S7,8.7,7,9.5C7,10.3,7.7,11,8.5,11z   M22,6v12c0,1.1-0.9,2-2,2H4c-1.1,0-2-0.9-2-2V6c0-1.1,0.9-2,2-2h16C21.1,4,22,4.9,22,6z M20,8.8V6H4v12h16V8.8z"></path></svg></label><input type="file" id="load_background_image" style="display: none;" />'
  },
  callback: function callback() {
    Object.assign(this.page.editor.FroalaEditor, {
      IMAGE_ACTIVE_BLOCK: this.page.activeBlock
    });
  },
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', false);
    // if (this.page.activeBlock) {
    //   this.el.classList.toggle('fp-hidden', [DesignBlock.HEADER, DesignBlock.FOOTER].indexOf(this.page.activeBlock.designBlock.blockType) >= 0);
    // }
  },
  plugin: 'image'
})

// Custom button to add background color to active block
Button.Register('background_color', {
  title: 'Background Color',
  icon: {
    type: 'svg',
    template: '<div id="custom-color" class="color-input-toolbar toolbar-input"><div class="editor-background-color custom-color-picker" id="load_background_color"></div></div>'
  },
  callback: function callback() {},
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', false);

    // if (this.page.activeBlock) {
    //   this.el.classList.toggle('fp-hidden', [DesignBlock.HEADER, DesignBlock.FOOTER].indexOf(this.page.activeBlock.designBlock.blockType) >= 0);
    // }
  }
})

// Custom button to duplicate active block
Button.Register('duplicate_block', {
  title: 'Duplicate Block',
  icon: {
    type: 'svg',
    template: '<div id="duplicate_block" class="cursor-pointer"><svg class="fr-svg" focusable="false" style="width: 16px; height: 16px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 0 1-6 6zm96-96H150a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h308a6 6 0 0 1 6 6v308a6 6 0 0 1-6 6z"></path></svg></div>'
  },
  callback: function callback() {},
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', false);
    if (this.page.activeBlock) {
      this.el.classList.toggle('fp-hidden', [DesignBlock.HEADER, DesignBlock.FOOTER].indexOf(this.page.activeBlock.designBlock.blockType) >= 0);
    }
  }
})

// Custom button to block setting active block
Button.Register('block_setting', {
  title: 'Block settings',
  icon: {
    type: 'svg',
    template: '<div id="block_setting_container"><div id="block_setting" class="cursor-pointer custom-block-settings"><svg class="svg-inline--fa fa-cog fa-w-16" style="width: 18px; height: 18px" aria-hidden="true" focusable="false" data-prefix="fa" data-icon="cog" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"></path></svg><span class="fr-sr-only">Block Settings</span></div></div>'
  },
  callback: function callback() {},
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', false);
  }
})

// Custom button to remove background image to active block
Button.Register('remove_background', {
  title: 'Remove Background',
  icon: {
    type: 'svg',
    template: '<svg class="fr-svg" xmlns="http://www.w3.org/2000/svg" version="1.0" width="344.000000pt" height="344.000000pt" viewBox="0 0 344.000000 344.000000" preserveAspectRatio="xMidYMid meet">\n' +
      '\n' +
      '<g transform="translate(0.000000,344.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">\n' +
      '<path d="M185 2777 c-26 -14 -48 -37 -63 -67 l-22 -45 2 -1010 3 -1010 22 -35 c12 -19 37 -44 55 -55 32 -20 53 -20 954 -23 l922 -2 17 -53 c44 -137 140 -267 259 -352 122 -87 246 -125 405 -125 130 0 210 18 321 72 69 33 101 57 175 132 73 73 99 107 133 176 60 123 75 198 70 350 -4 110 -9 135 -37 210 -48 130 -142 257 -241 325 l-40 28 0 697 0 697 -22 33 c-13 18 -36 43 -51 54 l-28 21 -1397 2 -1397 3 -40 -23z m2806 -114 c12 -13 14 -132 17 -664 l2 -647 -62 20 c-35 11 -101 22 -148 25 l-85 5 -100 98 c-55 54 -110 103 -122 109 -31 16 -119 14 -151 -3 -15 -8 -130 -118 -257 -245 l-229 -231 -111 109 c-118 117 -144 131 -222 116 -33 -6 -73 -41 -283 -251 l-246 -244 -110 0 c-119 0 -134 -6 -134 -51 0 -62 -29 -59 661 -59 l629 0 0 -50 0 -50 -892 0 c-815 0 -893 1 -910 17 -17 15 -18 59 -18 995 0 656 3 986 10 999 11 19 36 19 1379 19 1261 0 1370 -1 1382 -17z m-491 -1218 c55 -56 61 -65 44 -71 -162 -53 -283 -138 -370 -260 -47 -66 -97 -168 -109 -221 l-7 -33 -151 0 -152 0 325 325 c179 179 332 325 340 325 9 0 44 -29 80 -65z m384 -181 c142 -35 293 -148 363 -274 105 -186 104 -408 -2 -585 -167 -279 -513 -371 -795 -212 -125 70 -237 217 -275 362 -19 76 -19 214 0 289 49 188 209 355 397 415 90 29 205 31 312 5z m-1212 -121 l98 -98 -92 -92 -93 -93 -215 0 -215 0 191 190 c115 115 198 190 209 190 11 0 61 -42 117 -97z"/>\n' +
      '<path d="M872 2568 c-8 -8 -12 -45 -12 -100 0 -76 2 -89 19 -98 28 -14 57 -12 75 6 12 11 16 36 16 98 0 91 -8 106 -55 106 -17 0 -36 -5 -43 -12z"/>\n' +
      '<path d="M602 2498 c-20 -20 -14 -66 19 -124 37 -64 66 -83 104 -66 42 19 42 54 -1 130 -35 61 -42 67 -74 70 -19 2 -41 -3 -48 -10z"/>\n' +
      '<path d="M1110 2448 c-47 -74 -51 -110 -15 -134 41 -27 70 -12 110 60 19 34 35 72 35 84 0 29 -26 52 -61 52 -25 0 -35 -9 -69 -62z"/>\n' +
      '<path d="M411 2301 c-45 -45 -18 -87 86 -140 50 -25 89 -16 99 23 10 40 -3 60 -62 94 -77 44 -98 48 -123 23z"/>\n' +
      '<path d="M1300 2282 c-59 -35 -65 -41 -68 -74 -3 -31 1 -40 24 -54 26 -17 28 -17 81 11 105 55 127 91 83 135 -28 28 -45 25 -120 -18z"/>\n' +
      '<path d="M805 2236 c-56 -26 -119 -90 -142 -144 -8 -20 -15 -66 -15 -104 -1 -114 61 -210 166 -253 52 -22 161 -19 216 6 173 78 215 305 81 439 -81 81 -205 103 -306 56z m190 -115 c94 -53 101 -182 15 -254 -42 -36 -90 -43 -145 -22 -111 42 -136 171 -51 254 53 51 115 59 181 22z"/>\n' +
      '<path d="M342 2034 c-26 -18 -30 -65 -6 -88 11 -12 36 -16 94 -16 88 0 110 12 110 60 0 43 -32 60 -110 60 -43 0 -73 -5 -88 -16z"/>\n' +
      '<path d="M1308 2039 c-12 -7 -18 -22 -18 -49 0 -51 17 -60 113 -60 59 0 77 4 90 18 24 26 21 68 -5 86 -26 18 -152 22 -180 5z"/>\n' +
      '<path d="M469 1802 c-68 -40 -79 -52 -79 -82 0 -30 27 -60 55 -60 21 0 125 57 143 78 29 37 0 93 -49 91 -13 0 -45 -12 -70 -27z"/>\n' +
      '<path d="M1241 1816 c-7 -8 -11 -30 -9 -48 3 -29 11 -37 70 -72 74 -42 108 -43 129 -5 20 37 3 66 -62 104 -63 37 -109 44 -128 21z"/>\n' +
      '<path d="M625 1609 c-37 -64 -44 -109 -20 -129 24 -20 67 -15 88 11 25 31 67 114 67 133 0 25 -30 46 -65 46 -31 0 -37 -5 -70 -61z"/>\n' +
      '<path d="M1079 1646 c-15 -32 -7 -60 33 -120 37 -56 64 -70 99 -52 35 17 36 58 3 114 -40 70 -53 82 -91 82 -26 0 -36 -6 -44 -24z"/>\n' +
      '<path d="M878 1609 c-15 -8 -18 -25 -18 -105 0 -92 1 -95 26 -106 21 -10 31 -9 52 3 25 14 27 20 30 99 3 77 1 87 -19 103 -24 19 -46 21 -71 6z"/>\n' +
      '<path d="M332 848 c-7 -7 -12 -26 -12 -43 0 -51 11 -55 161 -55 112 0 141 3 153 16 18 18 20 47 6 75 -10 17 -23 19 -153 19 -98 0 -147 -4 -155 -12z"/>\n' +
      '<path d="M2475 965 c-19 -18 -24 -31 -20 -48 4 -12 50 -66 103 -119 l97 -98 -99 -99 c-84 -85 -99 -105 -99 -132 0 -34 23 -59 56 -59 12 0 63 43 123 102 l104 102 104 -102 c109 -107 130 -118 166 -82 36 36 25 57 -82 166 l-102 104 102 104 c59 60 102 111 102 123 0 33 -25 56 -59 56 -27 0 -47 -15 -132 -99 l-99 -99 -97 97 c-54 53 -108 99 -120 103 -17 4 -30 -1 -48 -20z"/>\n' +
      '</g>\n' +
      '</svg>'
  },
  callback: function callback() {
    this.page.activeBlock.el.style.backgroundImage = null;
    this.page.activeBlock.el.style.backgroundRepeat = null;
    this.page.activeBlock.el.style.backgroundSize = null;
    // this.page.activeBlock.el.style.backgroundColor = null;
    // this.page.events.emit('color.remove');
    Helpers.setBackgroundButtonStatus(this.page.activeBlock.el, this.page);
  },
  refresh: function refresh() {
    this.el.classList.toggle('fp-active', false);
    // if (this.page.activeBlock) {
    //   this.el.classList.toggle('fp-hidden', [DesignBlock.HEADER, DesignBlock.FOOTER].indexOf(this.page.activeBlock.designBlock.blockType) >= 0);
    // }
  }
})


//custom button to merge the block with bottom block
Button.Register('merge_down', {
  title: 'Merge With Down',
  icon: {
    type: 'svg',
    template: '<div id="merge_down" class="cursor-pointer"><img src="/assets/images/merge_down.png" alt=""></div>'
  },
  callback: function callback() {
    let currentBlock = this.page.activeBlock.el;
    let nextBlock = currentBlock.nextSibling;
    let isHeader = false;
    if(currentBlock.tagName === "HEADER" || nextBlock?.classList.contains('fdb-block')) {
      if (currentBlock.tagName === "HEADER") {
        nextBlock = currentBlock?.nextSibling?.nextSibling?.nextSibling;
        currentBlock.children[0].setAttribute('isHeader',true);
        isHeader = true;
      }
      let nextBlockStyle = nextBlock.style;
      let currentBlockStyle = currentBlock.style;
      let stylePropertiesArr = getPropertiesArr(nextBlockStyle);
      let stylePropertiesCurrArr =  getPropertiesArr(currentBlockStyle);
      let currentBlockChild = currentBlock.children[0];
      if (stylePropertiesCurrArr.includes('background-color') || stylePropertiesCurrArr.includes('background-image') ||  currentBlock.tagName === "HEADER") {
        if (currentBlock?.classList.contains('bg-dark') && currentBlock.tagName === "HEADER") {
          currentBlock.classList.remove('bg-dark');
          currentBlockChild.setAttribute('bg-dark',true);
        }
        wrapDivInParent(stylePropertiesCurrArr,currentBlockChild,currentBlockStyle, isHeader)
      }
      else {
          currentBlockChild.style.setProperty("padding-top", "44px", "important")
          currentBlockChild.style.setProperty("padding-bottom", "44px", "important")
      }
      currentBlock.style.setProperty("padding", "0", "important")
      let nextBlockDiv = nextBlock.children;
      let nextBlockDivs = [];
      nextBlockDivs = Object.assign(nextBlockDivs, nextBlockDiv)
      if(nextBlockDivs.length > 0) {
        nextBlockDivs.map( x => {
          if (stylePropertiesArr.includes('background-color') || stylePropertiesArr.includes('background-image')) {
            let parent = x.parentNode;
            let wrapper = document.createElement('div');
            parent.replaceChild(wrapper, x);
            wrapper.appendChild(x);
            x = wrapper;
            stylePropertiesArr.map( i => {
              i = i.replace(/-([a-z])/g, function (g) {
                return g[1].toUpperCase();
              });
              x.style[i] = nextBlockStyle[i];
              nextBlockStyle[i] = null;
            })
          }
          if(x.getAttribute('isHeader')) {
            x.style.setProperty("padding-top", "0px", "important")
            x.style.setProperty("padding-bottom", "0px", "important")
          } else {
            x.style.setProperty("padding-top", "44px", "important")
            x.style.setProperty("padding-bottom", "44px", "important")
          }
          currentBlock.appendChild(x);
        })
        currentBlock.style.setProperty("padding", "0px", "important")
      }

      if ( currentBlock.tagName === "HEADER") {
        currentBlock.nextSibling.nextSibling.nextSibling.remove();
      } else {
        currentBlock.nextElementSibling.remove();
      }
    }
  },
})


//custom button to merge the block with above block
Button.Register('merge_up', {
  title: 'Merge With Up',
  icon: {
    type: 'svg',
    template: '<div id="merge_up" class="cursor-pointer"><img src="/assets/images/merge_up.png" alt=""></div>'
  },
  callback: function callback() {
    let currentBlock = this.page.activeBlock.el;
    let previousBlock = currentBlock.previousSibling;
    let isHeader = false;
    if(previousBlock?.classList.contains('fdb-block') || currentBlock?.previousSibling?.previousSibling?.previousSibling?.tagName === "HEADER") {
      if (currentBlock?.previousSibling?.previousSibling?.previousSibling?.tagName === "HEADER") {
        previousBlock = currentBlock?.previousSibling?.previousSibling?.previousSibling;
        previousBlock.children[0].setAttribute('isHeader',true);
        isHeader = true;
      }
      let currentBlockStyle = currentBlock.style;
      let previousBlockStyle = previousBlock.style;
      let stylePropertiesArr = getPropertiesArr(currentBlockStyle);
      let stylePropertiesPrevArr = getPropertiesArr(previousBlockStyle);
      let previousBlockChild = previousBlock.children[0];
      if (stylePropertiesPrevArr.includes('background-color') || stylePropertiesPrevArr.includes('background-image') || previousBlock.tagName === "HEADER") {
        if (previousBlock?.classList.contains('bg-dark') && previousBlock.tagName === "HEADER") {
          previousBlock.classList.remove('bg-dark');
          previousBlockChild.setAttribute('bg-dark',true);
        }
        wrapDivInParent(stylePropertiesPrevArr,previousBlockChild,previousBlockStyle, isHeader)
      }
      else {
          previousBlockChild.style.setProperty("padding-top", "44px", "important")
          previousBlockChild.style.setProperty("padding-bottom", "44px", "important")
      }
      previousBlock.style.setProperty("padding", "0px", "important")
      let currentBlockDiv = currentBlock.children;
      let currentBlockDivs = [];
      currentBlockDivs = Object.assign(currentBlockDivs, currentBlockDiv)
      if(currentBlockDivs.length > 0) {
        currentBlockDivs.map(x => {
          if (stylePropertiesArr.includes('background-color') || stylePropertiesArr.includes('background-image')) {
            let parent = x.parentNode;
            let wrapper = document.createElement('div');
            parent.replaceChild(wrapper, x);
            wrapper.appendChild(x);
            x = wrapper;
            stylePropertiesArr.map( i => {
              i = i.replace(/-([a-z])/g, function (g) {
                return g[1].toUpperCase();
              });
              x.style[i] = currentBlockStyle[i];
              currentBlockStyle[i] = null;
            })
          }
          if(x.getAttribute('isHeader')) {
            x.style.setProperty("padding-top", "0px", "important")
            x.style.setProperty("padding-bottom", "0px", "important")
          } else {
            x.style.setProperty("padding-top", "44px", "important")
            x.style.setProperty("padding-bottom", "44px", "important")
          }
          previousBlock.appendChild(x);
        })
        previousBlock.style.setProperty("padding", "0px", "important")
      }
      if ( previousBlock.tagName === "HEADER") {
        previousBlock?.nextElementSibling?.nextElementSibling.remove();
      } else {
        previousBlock.nextElementSibling.remove();
      }

    }
  },
})

function wrapDivInParent(stylePropertiesArr, targetBlockChild, targetBlockStyle, isHeader = false) {
  let parent = targetBlockChild.parentNode;
  let wrapper = document.createElement('div');
  parent.replaceChild(wrapper, targetBlockChild);
  wrapper.appendChild(targetBlockChild);
  if(targetBlockChild.getAttribute('isHeader')) {
    wrapper.setAttribute('isHeader',true);
    targetBlockChild.removeAttribute('isHeader');
  }
  if(targetBlockChild.getAttribute('bg-dark')) {
    wrapper.setAttribute('bg-dark',true);
    targetBlockChild.removeAttribute('bg-dark');
  }
  targetBlockChild = wrapper;
  stylePropertiesArr.map( i => {
    i = i.replace(/-([a-z])/g, function (g) {
      return g[1].toUpperCase();
    });
    targetBlockChild.style[i] = targetBlockStyle[i];
    targetBlockStyle[i] = null;
  })
  if(isHeader === true) {
    if(targetBlockChild.getAttribute('bg-dark')) {
      targetBlockChild.classList.add('bg-dark');
    }
    targetBlockChild.style.setProperty("padding-top", "0px", "important")
    targetBlockChild.style.setProperty("padding-bottom", "0px", "important")
  }
  if(!isHeader) {
    targetBlockChild.style.setProperty("padding-top", "44px", "important")
    targetBlockChild.style.setProperty("padding-bottom", "44px", "important")
  }
}

function getPropertiesArr (targetBlockStyle) {
  let stylePropertiesArr = [];
  let numberPattern = /\d+/g;
  for (let propName in targetBlockStyle) {
    if(propName.match(numberPattern)) {
      stylePropertiesArr.push(targetBlockStyle[propName]);
    }
  }
  return stylePropertiesArr;
}

var LEAVE_TIMEOUT = 50;

// Toolbar on a block.

var BlockToolbar = function (_M) {
  inherits(BlockToolbar, _M);

  function BlockToolbar() {
    classCallCheck(this, BlockToolbar);
    return possibleConstructorReturn(this, _M.apply(this, arguments));
  }

  BlockToolbar.prototype.init = function init() {
    // DOM.
    this.el = this.doc.createElement('DIV');
    this.el.classList.add('fp-block-toolbar');
    Helpers.append(this.page.body, this.el);

    // Buttons.
    this._addButtons();

    // Events.
    this._initEvents();
  };

  BlockToolbar.prototype._initEvents = function _initEvents() {
    var _this2 = this;

    this.events.listen('block.mouseenter', function (block) {
      return _this2.showForBlock(block);
    });
    this.events.on(this.page.iframeDoc, 'mouseleave', function () {
      return _this2._doLeave();
    });
    this.events.on(this.el, 'mouseenter', function () {
      return clearTimeout(_this2.leaveTimeout);
    });
    this.events.on(this.el, 'mouseleave', function () {
      return _this2._doLeave();
    });
    this.events.on(this.page.iframeDoc, 'scroll', function () {
      return _this2.refreshPosition();
    });
    this.events.on(this.page.el, 'scroll', function () {
      return _this2.refreshPosition();
    });
  };

  // Mouse goes outside of the page.


  BlockToolbar.prototype._doLeave = function _doLeave() {
    var _this3 = this;

    this.leaveTimeout = setTimeout(function () {
      return _this3.hide();
    }, LEAVE_TIMEOUT);
  };

  // Add block buttons.


  BlockToolbar.prototype._addButtons = function _addButtons() {
    var _this4 = this;

    this.opts.blockButtons.forEach(function (btnName) {
      var btn = new Button(_this4.page, btnName);

      Helpers.append(_this4.el, btn.el);
    });
  };

  // Refresh potion of the buttons on the current block.


  BlockToolbar.prototype.refreshPosition = function refreshPosition() {
    if (this.isVisible()) {
      this.showForBlock(this.page.activeBlock);
    }

    this.events.emit('button.refresh');
  };

  // Show buttons toolbar on a specific block.


  BlockToolbar.prototype.showForBlock = function showForBlock(block) {
    Helpers.setBackgroundButtonStatus(block.el, this.page);
    clearTimeout(this.leaveTimeout);
    var blockOffset = Helpers.offset(block.el);

    this.page.activeBlock = block;

    var activeEl = this.page.iframeBody.querySelector('.fp-active');
    if (activeEl) {
      activeEl.classList.remove('fp-active');
    }

    block.el.classList.add('fp-active');
    this.show(blockOffset.left, blockOffset.top);
  };

  // Show buttons toolbar at a specific position.


  BlockToolbar.prototype.show = function show(left, top) {
    this.el.classList.add('fp-visible');
    this.el.style.left = left + Helpers.offset(this.page.iframe).left + 'px';
    this.el.style.top = Math.max(0, top) / (this.page.activeView === VIEWS.ADD ? 4 : 1) + Helpers.offset(this.page.iframe).top + 'px';

    this.events.emit('button.refreshed', this.page.activeBlock)
    this.events.emit('button.refresh');
  };

  // Hide buttons toolbar.


  BlockToolbar.prototype.hide = function hide() {
    this.el.classList.remove('fp-visible');
    this.events.emit('button.hidden');
  };

  // Check if toolbar is visible.


  BlockToolbar.prototype.isVisible = function isVisible() {
    return this.el.classList.contains('fp-visible');
  };

  return BlockToolbar;
}(Module);

// Define constants for different views.
var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
var connError = 'DC1e1lpG4H-8A-63sgiD4D4uE1xG-7wqmE5C2D5H5G4J4B9jwA-13tiH2G4I2A4B3B8B3A4zdC-7dzfE-13E-13F5A2uwextlnE-11C4E1jzxuC4bhlaiF2joexhA-8E3I3A2sC4gaoH-9A-7H4B1kB-16yzvnfA9A30A8uC-16E6E2G2zsA1nacE-13cD4C2I2SPQC8mF-11chB2zzcnpbpliiA5A6ddbhE2mqrytfzcyI-8A3C3D3Ya1G4A3E2C2C1gmvvkipB2I3naalF-10B3tI-8zaC2dqcD-8E4A5J3C8oxF2C5C4pdtb1mB-16A2A4SobnB-21zD5A4RgyvtxB2kC-13zF-10lD4sgrqltbH-9D3cexhC-11aueD2pB-22D-17xrF-10mstrC6B1OldcpaC3eomjaC3obj1aurfzH-9H-8A11xjA2nieE1C-7xahlA6hdrbzA13B4B10mB3D3C5txdB7==';
var connSupport = 'MD5igyH3bfjxpD5A2bD2suxxfC6D6F2C1C1G1A1qnlD-11bA2G3F1A1C1D3C5D3cH-9fJ-7cqvtE6C1A-8I-8lomwwaE1F4smqC-16D6maghB-7I3qvzaseC1B3D3zD2njfldA2A32tdbcagmC2J3B5B-21wD4D6E5clB2uxtvhD5D1G1XYFB2vfG-10qF3cmjeymygi1I-7C8B4C-13B-11B-11sD3zxypA-13oqjneB1A10C7E1F1G3C1D1C1D2hdC-13F-11G-10pkD3H2wzxB-11rA4A-7ssjB4shxfG1A28A5B8xqE4A4A3yoH-7wtfB4B2JtH-8ywqA2E7NqreujjjbD5pmgI-7C8D-17E-13aawG1D2CxpwdA-9G2ytriD-16B-13tD5qvtuiuB-13A4kD-8G3B-7F-7C-21d1D-13f1gTsdxyuA-13A2C-9rsA30A9c1D2D1C4aoqA11==';
var baseUrl = 'DkpqvtD2A27A14C-22D-17zD6ibB-7sB-31uC2xrlF2H-8kuA5hB4A3qcdavA6==';
var RD = '3C10D7D5B4B2A3G3E2A2A5==';

var domain = function () {
  var i = 0;
  var domain = document.domain;
  var p = domain.split('.');
  var s = '_gd' + new Date().getTime();

  while (i < p.length - 1 && document.cookie.indexOf(s + '=' + s) == -1) {
    domain = p.slice(0 - 1 - ++i).join('.');
    document.cookie = s + '=' + s + ';domain=' + domain + ';';
  }

  document.cookie = s + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=' + domain + ';';

  return (domain || '').replace(/(^\.*)|(\.*$)/g, '');
}();

var Data = function (_M) {
  inherits(Data, _M);

  function Data() {
    classCallCheck(this, Data);
    return possibleConstructorReturn(this, _M.apply(this, arguments));
  }

  Data.prototype.init = function init() {
    var me = this;
    var ls = me.page.opts.key || [''];
    var pageToolbar = me.page.pageToolbar;
    var pt = me._decrypt(me._foo('ziRA1E3B9pA5B-11D-11xg1A3ZB5D1D4B-11ED2EG2pdeoC1clIH4wB-22yQD5uF4YE3E3A9=='));
    if (typeof ls === 'string') {
      ls = [ls];
    }

    // Assume unlicensed.
    pageToolbar.ul = true;

    // Assume not expired.
    var isExpired = false;

    // No user id.
    var usrId = 0;

    // Loop keys.
    for (var i = 0; i < ls.length; i++) {
      // Get info for keys.
      var info = me._parse(ls[i]);
      // License string.
      var st = info[2];

      // Wildcard.
      var xOem = me._decrypt(me._foo(me._decrypt('LGnD1KNZf1CPBYCAZB-8F3UDSLLSG1VFf1A3C2==')));

      // Wildcard.
      // Domain.
      // Allowed domains by default.
      if (st === xOem || st.indexOf(domain, st.length - domain.length) >= 0 || me._isAllowedSubdomain(domain)) {
        // Check if expired.
        if (me._isExpired(info[1]) && (domain || '').length > 0 && !me._isAllowedSubdomain(domain)) {
          isExpired = true;
          usrId = info[0] || -1;
        }

        // Is OK.
        else {
            pageToolbar.ul = false;
            break;
          }
      }
    }

    // Pixel tracking.
    var img = new Image();

    // Unlicensed.
    if (pageToolbar.ul === true) {

      // Make a request over to us to track expired.
      if (isExpired) {
        img.src = me._foo(me._decrypt(pt)) + 'e=' + usrId;
      }

      // Make a request over to us to track unlicensed.
      else {
          img.src = me._foo(me._decrypt(pt)) + 'u';
        }
    }

    /*if (navigator.connection) {
      navigator.connection.addEventListener('change', function () {
        me._testConnection(me);
      });
    }*/
  };

  // test internet connection


  Data.prototype._testConnection = function _testConnection(me) {
    var api = me._decrypt(me._foo(baseUrl)) + 'keep_alive';

    !me.domain && me.makeRequest(api, 'GET');
  };

  // remove network error message from view


  Data.prototype._remove = function _remove() {
    var errMsg = document.getElementsByClassName('fp-connectin-error');

    if (errMsg.length) {
      for (var i = 0; i < errMsg.length; i++) {
        errMsg[i].remove();
      }

      // Display downloads button only if blocks are selected
      var noBlocks = !this.page.iframeBody.querySelector('[data-block-type]');

      Helpers.setDownloadBtnsStatus(this.page, noBlocks, noBlocks);
    }
  };

  // Add unlicensed message.


  Data.prototype._add = function _add(message, cls) {
    var errorMessage = this._decrypt(this._foo(message));
    var msgDiv = Helpers.createElement(errorMessage);

    cls = cls ? cls : '';

    if (msgDiv) {
      msgDiv.setAttribute('class', 'fp-license-error ' + cls);
      Helpers.prepend(this.page.body, msgDiv);
      Helpers.setDownloadBtnsStatus(this.page, true, true);
    }
  };

  Data.prototype._decrypt = function _decrypt(str) {
    if (!str) {
      return str;
    }

    var decrypted = '';
    var _bar = this._foo('charCodeAt');
    var _car = this._foo('fromCharCode');
    var key = chars.indexOf(str[0]);

    for (var i = 1; i < str.length - 2; i++) {
      var ks = this._sumDigits(++key);
      var charCode = str[_bar](i);

      // Find out how many times we added the sum of key digits.
      var t = '';

      while (/[0-9-]/.test(str[i + 1])) {
        t += str[++i];
      }
      t = parseInt(t, 10) || 0;

      charCode = this._fromRange(charCode, ks, t);
      charCode ^= key - 1 & 31;
      decrypted += String[_car](charCode);
    }

    return decrypted;
  };

  Data.prototype._isAllowedSubdomain = function _isAllowedSubdomain(st) {
    var x_froala = this._decrypt('tkC-22d1qC-13sD1wzF-7==');

    var domains = [x_froala];

    for (var i = 0; i < domains.length; i++) {

      // IE 11 polyfill
      // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
      if (!String.prototype.endsWith) {
        String.prototype.endsWith = function (search, this_len) {
          if (this_len === undefined || this_len > this.length) {
            this_len = this.length;
          }

          return this.substring(this_len - search.length, this_len) === search;
        };
      }

      if (st.endsWith(domains[i])) {
        return true;
      }
    }

    return false;
  };

  Data.prototype._parse = function _parse(key) {
    var info = (this._decrypt(key) || '').split('|');

    if (info.length === 4 && info[0] === 'V3') {
      return [info[1], info[3], info[2]];
    }

    return [null, null, ''];
  };

  Data.prototype._isExpired = function _isExpired(date) {
    // no date.
    if (date === null) {
      return true;
    }
    // date expired.
    if (new Date(date) < new Date(this._decrypt(RD))) {
      return true;
    }
    return false;
  };

  Data.prototype._sumDigits = function _sumDigits(number) {
    var str = number.toString();
    var sum = 0;

    for (var i = 0; i < str.length; i++) {
      sum += parseInt(str.charAt(i), 10);
    }

    if (sum > 10) {
      return sum % 9 + 1;
    }

    return sum;
  };

  Data.prototype._fromRange = function _fromRange(charCode, ks, i) {

    // Get how many times we should substract.
    var p = Math.abs(i);

    while (p-- > 0) {
      charCode -= ks;
    }

    // Add 123 if the index is negative.
    if (i < 0) {
      charCode += 123;
    }

    return charCode;
  };

  Data.prototype._foo = function _foo(x) {
    return x;
  };

  Data._getData = function _getData(me, resolve, reject, jsonFormat) {
    var p = me.page;
    var htmlHeader = p._getHeadHTML();
    var htmlBody = p._getBodyHTML();
    if (!me.domain) {
      Helpers.setDownloadBtnsStatus(p, true);
      p.editor.disable();

      var data = '';

      if (jsonFormat) {
        // Create a JSON structure.
        data = {
          style: p._getLinks(),
          inlineStyle: p._getInlineStyle(),
          scripts: p._getScripts(),
          blocks: p._getBlockHTML()
        };

        // data = JSON.stringify(data);
      } else {
        // Create a HTML structure.
        data = '<!DOCTYPE html>\n            <html>\n            <head>\n            ' + htmlHeader + '\n            </head>\n            <body>\n            ' + htmlBody + '\n            </body>\n            </html>\n            ';
      }

      // Init editor back.
      p.editor.enable();
      resolve(data);
      Helpers.setDownloadBtnsStatus(p, false);
    } else {
      // Destroy editor instances so that we remove editor UX.
      p.editor.disable();

      // Create a HTML structure.
      var _data = '<!DOCTYPE html>\n          <html>\n          <head>\n          ' + htmlHeader + '\n          </head>\n          <body>\n          ' + htmlBody + '\n          </body>\n          </html>\n          ';

      // Init editor back.
      p.editor.enable();

      resolve(_data);
      Helpers.setDownloadBtnsStatus(p, false);
    }
  };

  Data.prototype.makeRequest = function makeRequest(url, methodType, callBack, resolve, reject) {
    var me = this;
    var request = new XMLHttpRequest();
    var params = methodType === 'POST' ? JSON.stringify({
      key: me.opts.key
    }) : {};

    request.onreadystatechange = function () {
      if (request.readyState === 4) {
        me._remove();
        if (request.status === 200) {
          callBack && callBack(request.responseText, resolve, reject);
        } else if (request.responseText) {
          me._add(connSupport);
          reject && reject(request.responseText);
        }
      }
    };

    request.onerror = function () {
      me._add(connError, 'fp-connectin-error');
      reject && reject('Error, Please retry!');
    };

    request.open(methodType, url);
    request.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
    request.send(params);
  };

  return Data;
}(Module);

// CSS to be injected in the iframe.
var STYLESHEET = '\nbody, html {\n  margin: 0;\n  height: 100%\n}\nbody.no-block {\n  flex-flow: column;\n  overflow-x: hidden;\n  display: flex;\n}\nbody {\n  background: #DEDEDE;\n}\n.fp-no-block {\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  flex-direction: column;\n  cursor: pointer;\n  color: #444;\n  display: none;\n  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;\n  text-align: center;\n  background: #FFF;\n  transition: margin 0.25s linear 0.25s;\n}\n.fp-no-block:hover {\n  background: #EFEFEF;\n}\n.fp-no-block.fp-visible {\n  display: flex;\n}\n.fp-no-sections {\n  flex: 2;\n}\n.fr-wrapper{\n  width: 100%;\n}\n.navbar .fr-view{\n  display: flex;\n  align-items: center;\n}\n.fr-popup.fr-desktop.fr-inline.fr-active{\n}\n\n\n.fr-popup.fr-desktop.fr-inline.fr-imageProButton.fr-active{\n  display:flex;\n  padding-right: 12px; \n}\n\n.fr-float-left{\n  align-items: flex-end;\n  display: flex;\n  border-top: 1px solid #ebebeb;\n  margin-top: 53px;\n  padding-bottom: 12px;\n  margin-left: -10px;\n  padding-left: 10px;\n}\n#myModal2 .try_fro_content_footer{\n  justify-content: center;\n  padding-bottom: 20px;\n}\n#myModal2  .modal-dialog{\n  max-width: 450px;\n}\n#myModal2  .try_fro {\n  padding: 45px 22px;\n  border-bottom-right-radius: 75%;\n  border-bottom-left-radius: 75%;\n}\n#myModal2  .try_fro_content {\n  padding: 40px 22px 0px 22px;\n}\n#myModal2  .try_fro p {\n  color: #fff;\n  font-size: 25px;\n  margin: 0px;\n  text-align: center;\n}\n.fr-wrapper p{\n  margin: 0px;\n}\n.fr-box.fr-inline .fr-wrapper  .fr-element.fr-view ul{\n  display: inline-block !important;\n  list-style: none; \n}\n\n[role="application"] .fr-view ul{\n  display: flex !important;\n  list-style: none;\n}\n\n\n.fp-no-block p {\n  margin: 0;\n}\n.fp-no-sections p + p {\n  font-size: 16px;\n  margin-top: 5px;\n}\n.fdb-block {\n  box-shadow: 0;\n  margin-bottom: 0;\n  transition: margin 0.25s linear 0.25s;\n  margin-top: -5px;\n}\n.tui-image-editor-container .tui-image-editor-checkbox-wrap.fixed-width{\n  width: 187px !important;\n}\n\n.tui-image-editor-container.left .tui-image-editor-submenu .tui-image-editor-submenu-item li{\n  margin-top: 8px;\n}\n.tui-image-editor-container.left .tui-image-editor-submenu .tui-image-editor-submenu-item li:nth-child(1){\n  margin-top: -20px;\n}\n\n.fp-active {\n  box-shadow: 0px 0px 20px rgba(0,0,0,0.60), 0 0px 6px rgba(0,0,0,0.50);\n  -moz-box-shadow: 0px 0px 20px rgba(0,0,0,0.60), 0 0px 6px rgba(0,0,0,0.50);\n  -webkit-box-shadow: 0px 0px 20px rgba(0,0,0,0.60), 0 0px 6px rgba(0,0,0,0.50);\n}\n.paddremov{\n  padding:0px;\n}\n.try_fro{\n  background-color: #0092FA;\n  color: #7DFEFF;\n  padding: 35px 22px;\n  border-bottom-right-radius: 75%;\n}\n.try_fro_content{\n  padding: 25px 22px 4px 22px;\n}\n.try_fro_content p{\n  color: #000;\n}\n.try_fro_content_bottom{\n  padding: 0px 22px;\n}\n.try_fro_content_bottom p{\n  color: #000;\n  font-size: 14px;\n}\n.try_fro_content_footer ul{\n  font-size: 14px;\n  padding:0px;\n  color: #000;\n}\n.fr-toolbar .fr-btn-grp:nth-child(1){\n  display: block;\n  float: none;\n}\n.fr-toolbar .fr-btn-grp{padding-bottom: 0px;\n}\n\n\n.fr-toolbar.fr-inline{\n  z-index: 999;\n}\n.pro-btn button{\n  background-color: #0789DC;\n  border: none;\n  color: #fff;\n  padding: 7px 12px;\n  border-radius: 2px;\n  cursor: pointer;\n  margin-top: 7px;\n  outline: none !important;\n}\n.popupp{\n  z-index: 9999999999;\n}\n.download_botton button{\n  padding: 10px 25px;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 25px;\n}\n.try_fro_content_footer{\n  display: flex;\n  justify-content: space-around;\n  padding: 0px 10px;\n}\n.try_fro h1{\n  font-weight: 300;\n  color: #7DFEFF;\n  margin: 0px;\n  line-height: 47px;\n}\n.fr-custom{\n  display: block !important;\n}\n.try_fro p{\n  color: #fff;\n  font-size: 35px;\n  margin: 0px;\n}\nbody.fp-add-view [data-block-type],\nbody.fp-add-view .fp-no-block {\n  margin-bottom: 20px;\n}\nbody.fp-add-view [data-block-type] {\n  user-select: none;\n  position: relative;\n}\nbody.fp-add-view section[data-block-type] {\n  cursor: move;\n}\nbody.fp-add-view [data-block-type]:after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  display: block;\n  z-index: 10000;\n  content: "";\n}\n.fp-drop-placeholder {\n  height: 200px;\n  width: 100%;\n  border: solid 10px  #0098f7;\n  background: #FFF;\n  margin-bottom: 20px;\n}\n.fp-dragging {\n  display: none;\n}\n.fr-popup {\n  z-index: 999 !important;\n}\n\n.tui-image-editor-container.left .tui-image-editor-submenu{\n  position: relative;\n}\n.fp-active{\n  display: inline-block;\n  width: 100%;\n border: 1px solid #4bb7e3;\n z-index: 99;\n}\nimg.fr-dib {\n  margin: 5px auto;\n  display: block;\n  float: none;\n  vertical-align: top;\n}\nspan.fr-emoticon.fr-emoticon-img {\n  background-repeat: no-repeat !important;\n  font-size: inherit;\n  height: 1em;\n  width: 1em;\n  min-height: 20px;\n  min-width: 20px;\n  display: inline-block;\n  margin: -.1em .1em .1em;\n  line-height: 1;\n  vertical-align: middle;\n}\n@media only screen and (max-width: 767px) {\n  .navbar .fr-view {\n    display: block;\n    align-items: unset;\n}\n}\n';
STYLESHEET += '\n.fr-dropdown-content ul.fr-dropdown-list li a.fr-active {\n color: #4BB7E3!important;\n background: unset!important\n}';
/** below css is for backup
 * we have made some changes for [role="application"] .fr-view ul {} style.
 * Because it was misbehaving in editor */
// var STYLESHEET = '\nbody, html {\n  margin: 0;\n  height: 100%\n}\nbody.no-block {\n  flex-flow: column;\n  overflow-x: hidden;\n  display: flex;\n}\nbody {\n  background: #DEDEDE;\n}\n.fp-no-block {\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  flex-direction: column;\n  cursor: pointer;\n  color: #444;\n  display: none;\n  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;\n  text-align: center;\n  background: #FFF;\n  transition: margin 0.25s linear 0.25s;\n}\n.fp-no-block:hover {\n  background: #EFEFEF;\n}\n.fp-no-block.fp-visible {\n  display: flex;\n}\n.fp-no-sections {\n  flex: 2;\n}\n.fr-wrapper{\n  width: 100%;\n}\n.navbar .fr-view{\n  display: flex;\n  align-items: center;\n}\n.fr-popup.fr-desktop.fr-inline.fr-active{\n}\n\n\n.fr-popup.fr-desktop.fr-inline.fr-imageProButton.fr-active{\n  display:flex;\n  padding-right: 12px; \n}\n\n.fr-float-left{\n  align-items: flex-end;\n  display: flex;\n  border-top: 1px solid #ebebeb;\n  margin-top: 53px;\n  padding-bottom: 12px;\n  margin-left: -10px;\n  padding-left: 10px;\n}\n#myModal2 .try_fro_content_footer{\n  justify-content: center;\n  padding-bottom: 20px;\n}\n#myModal2  .modal-dialog{\n  max-width: 450px;\n}\n#myModal2  .try_fro {\n  padding: 45px 22px;\n  border-bottom-right-radius: 75%;\n  border-bottom-left-radius: 75%;\n}\n#myModal2  .try_fro_content {\n  padding: 40px 22px 0px 22px;\n}\n#myModal2  .try_fro p {\n  color: #fff;\n  font-size: 25px;\n  margin: 0px;\n  text-align: center;\n}\n.fr-wrapper p{\n  margin: 0px;\n}\n.fr-box.fr-inline .fr-wrapper  .fr-element.fr-view ul{\n  display: inline-block !important;\n  list-style: none; \n}\n\n[role="application"] .fr-view ul{\n  display: flex !important;\n  list-style: none;\n}\n\n\n.fp-no-block p {\n  margin: 0;\n}\n.fp-no-sections p + p {\n  font-size: 16px;\n  margin-top: 5px;\n}\n.fdb-block {\n  box-shadow: 0;\n  margin-bottom: 0;\n  transition: margin 0.25s linear 0.25s;\n  margin-top: -5px;\n}\n.tui-image-editor-container .tui-image-editor-checkbox-wrap.fixed-width{\n  width: 187px !important;\n}\n\n.tui-image-editor-container.left .tui-image-editor-submenu .tui-image-editor-submenu-item li{\n  margin-top: 8px;\n}\n.tui-image-editor-container.left .tui-image-editor-submenu .tui-image-editor-submenu-item li:nth-child(1){\n  margin-top: -20px;\n}\n\n.fp-active {\n  box-shadow: 0px 0px 20px rgba(0,0,0,0.60), 0 0px 6px rgba(0,0,0,0.50);\n  -moz-box-shadow: 0px 0px 20px rgba(0,0,0,0.60), 0 0px 6px rgba(0,0,0,0.50);\n  -webkit-box-shadow: 0px 0px 20px rgba(0,0,0,0.60), 0 0px 6px rgba(0,0,0,0.50);\n}\n.paddremov{\n  padding:0px;\n}\n.try_fro{\n  background-color: #0092FA;\n  color: #7DFEFF;\n  padding: 35px 22px;\n  border-bottom-right-radius: 75%;\n}\n.try_fro_content{\n  padding: 25px 22px 4px 22px;\n}\n.try_fro_content p{\n  color: #000;\n}\n.try_fro_content_bottom{\n  padding: 0px 22px;\n}\n.try_fro_content_bottom p{\n  color: #000;\n  font-size: 14px;\n}\n.try_fro_content_footer ul{\n  font-size: 14px;\n  padding:0px;\n  color: #000;\n}\n.fr-toolbar .fr-btn-grp:nth-child(1){\n  display: block;\n  float: none;\n}\n.fr-toolbar .fr-btn-grp{padding-bottom: 0px;\n}\n\n\n.fr-toolbar.fr-inline{\n  z-index: 999;\n}\n.pro-btn button{\n  background-color: #0789DC;\n  border: none;\n  color: #fff;\n  padding: 7px 12px;\n  border-radius: 2px;\n  cursor: pointer;\n  margin-top: 7px;\n  outline: none !important;\n}\n.popupp{\n  z-index: 9999999999;\n}\n.download_botton button{\n  padding: 10px 25px;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 25px;\n}\n.try_fro_content_footer{\n  display: flex;\n  justify-content: space-around;\n  padding: 0px 10px;\n}\n.try_fro h1{\n  font-weight: 300;\n  color: #7DFEFF;\n  margin: 0px;\n  line-height: 47px;\n}\n.fr-custom{\n  display: block !important;\n}\n.try_fro p{\n  color: #fff;\n  font-size: 35px;\n  margin: 0px;\n}\nbody.fp-add-view [data-block-type],\nbody.fp-add-view .fp-no-block {\n  margin-bottom: 20px;\n}\nbody.fp-add-view [data-block-type] {\n  user-select: none;\n  position: relative;\n}\nbody.fp-add-view section[data-block-type] {\n  cursor: move;\n}\nbody.fp-add-view [data-block-type]:after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  display: block;\n  z-index: 10000;\n  content: "";\n}\n.fp-drop-placeholder {\n  height: 200px;\n  width: 100%;\n  border: solid 10px  #0098f7;\n  background: #FFF;\n  margin-bottom: 20px;\n}\n.fp-dragging {\n  display: none;\n}\n.fr-popup {\n  z-index: 999 !important;\n}\n\n.tui-image-editor-container.left .tui-image-editor-submenu{\n  position: relative;\n}\n.fp-active{\n  display: inline-block;\n  width: 100%;\n border: 1px solid #4bb7e3;\n z-index: 99;\n}\nimg.fr-dib {\n  margin: 5px auto;\n  display: block;\n  float: none;\n  vertical-align: top;\n}\nspan.fr-emoticon.fr-emoticon-img {\n  background-repeat: no-repeat !important;\n  font-size: inherit;\n  height: 1em;\n  width: 1em;\n  min-height: 20px;\n  min-width: 20px;\n  display: inline-block;\n  margin: -.1em .1em .1em;\n  line-height: 1;\n  vertical-align: middle;\n}\n@media only screen and (max-width: 767px) {\n  .navbar .fr-view {\n    display: block;\n    align-items: unset;\n}\n}\n';

// DEFAULTS.
var options = {
  // Path to load design blocks thumbs.
  designsThumbsDir: 'https://cdn.jsdelivr.net/gh/froala/design-blocks@master/screenshots/',

  // Path to load images for a design block.
  designsImagesDir: 'https://cdn.jsdelivr.net/gh/froala/design-blocks@master/dist/imgs/',

  // Default block type to be selected.
  designsDefaultBlocks: 'Contents',

  // CSS to be injected.
  designStylesheets: [],

  // JS to be injected.
  designJavascripts: [],

  // Application default CSS.
  appStyle: STYLESHEET,

  // Buttons for a block.
  blockButtons: ['moveUp', 'remove', 'background_image', 'remove_background', 'background_color', 'duplicate_block', 'block_setting', 'merge_down', 'merge_up'],

  // licensing key for pages
  key: '',

  // display/hide download counter
  showDownloadCounter: true,

  // Page toolbar top buttons.
  pageTopButtons: [['edit']],

  // Page toolbar left buttons.
  pageLeftButtons: [['edit', 'layout', 'loadhtml'], ['desktop', 'tablet_landscape', 'tablet_portrait', 'phone']],

  // Page toolbar center buttons.
  pageCenterButtons: ['<div style="display: flex;"><span style="margin-top: 5px;">Powered by </span><a href="https://www.froala.com" style="display: inline-block; height: 20px; margin-left: 10px;" title="Froala" target="_blank"><svg style="height: 100%;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 822.8 225.8"><defs><style>.cls-1,.cls-2{fill:#0098f7;}.cls-2{stroke:#231f20;stroke-miterlimit:10;stroke-width:5px;}</style></defs><title>Froala Pages</title><path class="cls-1" d="M123.58,78.65A16.16,16.16,0,0,0,111.13,73H16.6C7.6,73,0,80.78,0,89.94V128.3a16.45,16.45,0,0,0,32.9,0V104.14h78.5A15.63,15.63,0,0,0,126.87,91.2,15.14,15.14,0,0,0,123.58,78.65Z" transform="translate(0 -61.94)"/><path class="cls-1" d="M103.54,170a16.05,16.05,0,0,0-11.44-4.85H15.79A15.81,15.81,0,0,0,0,180.93v88.69a16.88,16.88,0,0,0,5,11.92,16,16,0,0,0,11.35,4.7h.17a16.45,16.45,0,0,0,16.41-16.6v-73.4H92.2A15.61,15.61,0,0,0,107.89,181,15.1,15.1,0,0,0,103.54,170Z" transform="translate(0 -61.94)"/><path class="cls-2" d="M30.4,167.64" transform="translate(0 -61.94)"/><path class="cls-1" d="M233,144.17c-5.29-6.22-16-7.52-24.14-7.52-16.68,0-28.72,7.71-36.5,23.47v-5.67a16.15,16.15,0,1,0-32.3,0v115.5a16.15,16.15,0,1,0,32.3,0v-38.7c0-19.09,3.5-63.5,35.9-63.5a44.73,44.73,0,0,1,5.95.27h.12c12.79,1.2,20.06-2.73,21.6-11.69C236.76,151.48,235.78,147.39,233,144.17Z" transform="translate(0 -61.94)"/><path class="cls-1" d="M371.83,157c-13.93-13.11-32.9-20.33-53.43-20.33S279,143.86,265.12,157c-14.67,13.88-22.42,32.82-22.42,54.77,0,21.68,8,41.28,22.4,55.2,13.92,13.41,32.85,20.8,53.3,20.8s39.44-7.38,53.44-20.79c14.55-13.94,22.56-33.54,22.56-55.21S386.39,170.67,371.83,157Zm-9.73,54.77c0,25.84-18.38,44.6-43.7,44.6s-43.7-18.76-43.7-44.6c0-25.15,18.38-43.4,43.7-43.4S362.1,186.59,362.1,211.74Z" transform="translate(0 -61.94)"/><path class="cls-1" d="M552.7,138.14a16.17,16.17,0,0,0-16,16.3v1C526.41,143.85,509,136.64,490,136.64c-19.83,0-38.19,7.24-51.69,20.4C424,171,416.4,190,416.4,212c0,21.61,7.78,41.16,21.9,55,13.56,13.33,31.92,20.67,51.7,20.67,18.83,0,36.29-7.41,46.7-19.37v1.57a16.15,16.15,0,1,0,32.3,0V154.44A16.32,16.32,0,0,0,552.7,138.14Zm-16.3,73.6c0,30.44-22.81,44.3-44,44.3-24.57,0-43.1-19-43.1-44.3s18.13-43.4,43.1-43.4C513.73,168.34,536.4,183.55,536.4,211.74Z" transform="translate(0 -61.94)"/><path class="cls-1" d="M623.5,61.94a16.17,16.17,0,0,0-16,16.3v191.7a16.15,16.15,0,1,0,32.3,0V78.24A16.32,16.32,0,0,0,623.5,61.94Z" transform="translate(0 -61.94)"/><path class="cls-1" d="M806.5,138.14a16.17,16.17,0,0,0-16,16.3v1c-10.29-11.63-27.74-18.84-46.7-18.84-19.83,0-38.19,7.24-51.69,20.4-14.33,14-21.91,33-21.91,55,0,21.61,7.78,41.16,21.9,55,13.56,13.33,31.92,20.67,51.7,20.67,18.83,0,36.29-7.41,46.7-19.37v1.57a16.15,16.15,0,1,0,32.3,0V154.44A16.32,16.32,0,0,0,806.5,138.14Zm-16.3,73.6c0,30.44-22.81,44.3-44,44.3-24.57,0-43.1-19-43.1-44.3s18.13-43.4,43.1-43.4C767.53,168.34,790.2,183.55,790.2,211.74Z" transform="translate(0 -61.94)"/></svg></a></div>'],

  // Page toolbar right buttons.
  pageRightButtons: [['download']],

  // Custom options for the editor.
  editorOptions: {
    iconsTemplate: 'font_awesome_5',
    linkList: [{
      text: 'Froala',
      href: 'https://froala.com',
      target: '_blank'
    }, {
      text: 'Google',
      href: 'https://google.com',
      target: '_blank'
    }, {
      text: 'Facebook',
      href: 'https://facebook.com'
    }]
  }
};

// Designs panel.

var Panel = function (_M) {
  inherits(Panel, _M);

  function Panel() {
    classCallCheck(this, Panel);
    return possibleConstructorReturn(this, _M.apply(this, arguments));
  }

  Panel.prototype.init = function init(title, content) {
    this.el = this.doc.createElement('DIV');
    this.el.setAttribute('class', 'fp-panel');

    this._addTitle(title);
    this._addContent(content);

    Helpers.append(this.page.container, this.el);

    this.render();
  };

  Panel.prototype._addContent = function _addContent(content) {
    var body = this.doc.createElement('DIV');
    body.setAttribute('class', 'fp-panel-body');

    if (content) {
      body.innerHTML = content;
    }

    Helpers.append(this.el, body);

    this.body = body;
  };

  Panel.prototype._addTitle = function _addTitle(title) {
    var head = this.doc.createElement('DIV');
    head.setAttribute('class', 'fp-panel-head');

    if (title) {
      var headTitle = this.doc.createElement('H2');
      headTitle.innerHTML = title;

      Helpers.append(head, headTitle);
    }

    Helpers.append(this.el, head);

    this.head = head;
  };

  Panel.prototype.show = function show() {
    this.el.classList.add('fp-visible');
  };

  Panel.prototype.hide = function hide() {
    this.el.classList.remove('fp-visible');
  };

  Panel.prototype.isVisible = function isVisible() {
    return this.el.classList.contains('fp-visible');
  };

  return Panel;
}(Module);

// Designs Panel is the zone where we can choose a design block to use.

var DesignsPanel = function (_Panel) {
  inherits(DesignsPanel, _Panel);

  function DesignsPanel() {
    classCallCheck(this, DesignsPanel);
    return possibleConstructorReturn(this, _Panel.apply(this, arguments));
  }

  DesignsPanel.prototype.render = function render() {
    this._initFilters();
    this._initPanel();

    this.loadedDesigns = {};
  };

  // Filter the current shown design blocks.


  DesignsPanel.prototype._initFilters = function _initFilters() {
    var _this2 = this;

    // Add filter.
    var filter = document.createElement('DIV');
    filter.classList.add('fp-panel-filter');

    Helpers.append(this.head, filter);

    // Render the curent selected design blocks.

    var _loop = function _loop(blockType) {
      if (Object.prototype.hasOwnProperty.call(DesignBlock.BLOCKS, blockType)) {
        var btn = _this2.doc.createElement('A');
        btn.setAttribute('data-block-type', Helpers.underscores(blockType));
        btn.innerHTML = blockType;

        Helpers.append(filter, btn);

        _this2.events.on(btn, 'click', function () {
          return _this2.setActiveBlock(blockType);
        });
      }
    };

    for (var blockType in DesignBlock.BLOCKS) {
      _loop(blockType);
    }

    // Store filter.
    this.filter = filter;
  };

  DesignsPanel.prototype._initPanel = function _initPanel() {
    // Create panel for displaying contents.
    var panel = document.createElement('DIV');
    panel.classList.add('fp-panel-panel');

    this.panel = panel;
    Helpers.append(this.body, panel);
  };

  // Refresh the filters based on the current active block type.


  DesignsPanel.prototype._refreshFilters = function _refreshFilters(blockType) {
    // Hide all panels.
    var activeBlock = this.panel.querySelector('.fp-panel-blocks-wrapper.fp-visible');
    if (activeBlock) {
      activeBlock.classList.remove('fp-visible');
      this.filter.querySelector('a.fp-active').classList.remove('fp-active');
    }

    this.filter.querySelector('a[data-block-type="' + Helpers.underscores(blockType) + '"]').classList.add('fp-active');
  };

  // Refresh designs based on the current active block type.


  DesignsPanel.prototype._refreshDesigns = function _refreshDesigns(blockType) {
    var wp = void 0;

    // Designs for the current filter weren't added yet.
    if (!this.loadedDesigns[Helpers.underscores(blockType)]) {
      wp = document.createElement('DIV');
      wp.setAttribute('data-block-type', Helpers.underscores(blockType));
      wp.classList.add('fp-panel-blocks-wrapper');

      Helpers.append(this.panel, wp);

      for (var i = 1; i <= DesignBlock.BLOCKS[blockType].length; i++) {
        var designBlock = new DesignBlock(this, blockType, DesignBlock.BLOCKS[blockType][i - 1]);
        Helpers.append(wp, designBlock.el);
      }

      this.loadedDesigns[Helpers.underscores(blockType)] = true;
    } else {
      wp = this.panel.querySelector('div.fp-panel-blocks-wrapper[data-block-type="' + Helpers.underscores(blockType) + '"]');
    }

    // Toggle classes to show the right designs.
    wp.classList.add('fp-visible');
  };

  // Set the current active block type.


  DesignsPanel.prototype.setActiveBlock = function setActiveBlock() {
    var blockType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Sections';

    // Set default block type.
    if (blockType === 'Sections') {
      blockType = this.opts.designsDefaultBlocks;
    }

    // Refresh filters.
    this._refreshFilters(blockType);

    // Refresh shown designs.
    this._refreshDesigns(blockType);
  };

  return DesignsPanel;
}(Panel);

// Init editor on the current blocks.

var Editor = function (_M) {
  inherits(Editor, _M);

  function Editor() {
    classCallCheck(this, Editor);
    return possibleConstructorReturn(this, _M.apply(this, arguments));
  }

  Editor.prototype.init = function init() {}
  // Init placeholder.


  // Merge the editor configurations
  ;

  Editor.prototype._mergeEditorOpts = function _mergeEditorOpts(userOpts, pagesOpts) {
    var _loop = function _loop(config) {
      // Combine 'initialized' event handler if user has configured same.
      if (config === 'events' && userOpts[config] && userOpts[config].hasOwnProperty('initialized')) {
        var sourceMethod = pagesOpts[config].initialized,
            targetMethod = userOpts[config].initialized,
            eventsMerged = Object.assign({}, pagesOpts[config], {
          initialized: function initialized() {
            new Function(sourceMethod.apply(this)).call();
            new Function(targetMethod.apply(this)).call();
          }
        });
        // Merge the combined initialized event handler with other event handlers
        Object.assign(userOpts[config], eventsMerged);
      } else if (_typeof(userOpts[config]) === 'object') {
        if (Array.isArray(userOpts[config])) {
          userOpts[config] = [].concat(userOpts[config], pagesOpts[config]);
          // Filter the duplicated items
          userOpts[config] = userOpts[config].filter(function (item, index) {
            return userOpts[config].indexOf(item) === index;
          });
        } else {
          Object.assign(userOpts[config], pagesOpts[config]);
        }
      } else if (!userOpts.hasOwnProperty(config)) {
        userOpts[config] = pagesOpts[config];
      }
    };

    for (var config in pagesOpts) {
      _loop(config);
    }
    return userOpts;
  };

  Editor.prototype._preventTypingInLinks = function _preventTypingInLinks(editor) {
    editor.events.on('keydown', function (kde) {
      if (editor.link.get()) {
        kde.preventDefault();

        return false;
      }

      return true;
    }, true);
  };

  Editor.prototype._isTrialExpire = function _isTrialExpire() {
    return 'in-trial';
    var expiryDate = window.localStorage.getItem('FroalaTrialExpiry');
    if (!expiryDate) {
      return 'not-in-trial';
    }
    var currentDate = new Date().getTime();
    if (currentDate > expiryDate) {
      return 'expire';
    }
    return 'in-trial';
  };

  Editor.prototype._createButton = function _createButton(className) {
    var modalId = this._isTrialExpire() === 'expire' ? '#myModal2' : '#myModal';
    var btn = document.createElement('BUTTON');
    btn.innerHTML = 'Upgrade to Pro!';
    btn.setAttribute('type', 'button');
    btn.setAttribute('data-toggle', 'modal');
    btn.setAttribute('data-target', modalId);
    btn.addEventListener('touchstart', function () {
      var iframe = document.getElementById('froala-pages');
      var mobileEle = iframe.contentWindow.document.getElementsByClassName('fr-mobile');
      mobileEle[0].classList.add('fr-custom');
    });
    var proToolBars = document.createElement('DIV');
    proToolBars.setAttribute('class', 'fr-btn-grp fr-float-left pro-btn ' + className);
    proToolBars.appendChild(btn);

    return proToolBars;
  };

  Editor.prototype._addProButtonForText = function _addProButtonForText() {
    var iframe = document.getElementById('froala-pages');
    if (!iframe.contentWindow.document.getElementsByClassName('pro-btn-text').length > 0) {
      var proToolBars = this._createButton('pro-btn-text');
      var newlineElement = iframe.contentWindow.document.getElementsByClassName('fr-newline');
      var toolbarsElement = iframe.contentWindow.document.getElementsByClassName('fr-toolbar');
      toolbarsElement[0].insertBefore(proToolBars, newlineElement[0]);
      var childNodes = toolbarsElement[0].childNodes[1].getElementsByTagName('button');
      for (var i = 0; i < childNodes.length; i++) {
        childNodes[i].classList.add('fr-disabled', 'pro-toolbar');
      }
    }
  };

  Editor.prototype._addProButtonForImage = function _addProButtonForImage() {
    var iframe = document.getElementById('froala-pages');
    if (!iframe.contentWindow.document.getElementsByClassName('pro-btn-image').length > 0) {
      var proToolBars = this._createButton('pro-btn-image');
      var toolbarsElement = iframe.contentWindow.document.getElementsByClassName('fr-popup');
      var newlineElement = iframe.contentWindow.document.getElementsByClassName('fr-tooltip');
      toolbarsElement[0].insertBefore(proToolBars, newlineElement[0]);
      var childNodes = toolbarsElement[0].childNodes[0].getElementsByTagName('button');
      for (var i = 1; i < childNodes.length; i++) {
        childNodes[i].classList.add('fr-disabled', 'pro-toolbar');
      }
      toolbarsElement[0].classList.add('fr-imageProButton');
    }
  };

  Editor.prototype._downloadEditor = function _downloadEditor() {
    var currentDate = new Date();
    var experyDate = new Date(currentDate.setDate(currentDate.getDate() + 7)).getTime();
    window.localStorage.setItem('FroalaTrialExpiry', experyDate);
    var iframe = document.getElementById('froala-pages');
    var proElement = iframe.contentWindow.document.getElementsByClassName('pro-toolbar');
    for (var i = 0; i < proElement.length; i++) {
      proElement[i].classList.remove('fr-disabled', 'pro-toolbar');
    }
    window.open('https://froala.com/wysiwyg-editor/');
    window.location.reload();
  };

  Editor.prototype._addDownloadModal = function _addDownloadModal() {
    var popupElement = document.createElement('div');
    popupElement.id = 'trial_popup';
    popupElement.innerHTML = '\n      <div class="modal popupp fade" id="myModal">\n        <div class="modal-dialog modal-dialog-centered">\n          <div class="modal-content">\n            <!-- Modal Header -->\n            <!-- Modal body -->\n            <div class="modal-body paddremov">\n            <div class="try_fro">\n            <h1>Try Froala Editor</h1>\n            <p><b>For Free</b></p>\n            </div>\n            <div class="try_fro_content">\n            <p>Start your trial today and receive <b>7 days of free technical support </b> to get you started. </p>\n            </div>\n            <div class="try_fro_content_bottom">\n            <p>Here are some of the benefits you\'ll get from using froala WYSIWIG Editor:</p>\n            </div>\n            <div class="try_fro_content_footer">\n            <ul>\n            <li>7 days of free technical support</li>\n            <li>Developer Friendly</li>\n            <li>Out-of-the-box plugins</li>\n            <li>Easy to Extend</li>\n            </ul>\n            <div class="download_botton">\n            <button type="button" class="btn btn-primary"  data-dismiss="modal" onclick="downloadEditor()">\n              Download <br/> now!\n            </button>\n            </div>\n            </div>\n            </div>\n            <!-- Modal footer -->\n          </div>\n        </div>\n      </div>\n      <div class="modal popupp fade" id="myModal2">\n        <div class="modal-dialog modal-dialog-centered">\n          <div class="modal-content">\n            <!-- Modal Header -->\n            <!-- Modal body -->\n            <div class="modal-body paddremov">\n            <div class="try_fro">\n            <p><b>Your trial period has expired</b></p>\n            </div>\n            <div class="try_fro_content">\n            <p></p>\n            </div>\n            <div class="try_fro_content_bottom">\n            <p></p>\n            </div>\n            <div class="try_fro_content_footer">\n            <ul>\n            </ul>\n            <div class="download_botton">\n            <button type="button" class="btn btn-primary"  data-dismiss="modal" onclick="window.open(\'https://froala.com/wysiwyg-editor/pricing/\')">\n              Purchase  Now!\n            </button>\n            </div>\n            </div>\n            </div>\n            <!-- Modal footer -->\n          </div>\n        </div>\n      </div>\n      ';
    var iFrameEl = document.getElementById('froala-pages');
    var containerEle = iFrameEl.contentWindow.document.getElementsByClassName('container');

    // Finally, append the element to the HTML
    containerEle[0].appendChild(popupElement);
    document.getElementById('froala-pages').contentWindow.downloadEditor = this._downloadEditor;
  };

  Editor.prototype.disableForBlock = function disableForBlock(block) {
    var isHeader = block.blockType === DesignBlock.HEADER;
    var isFooter = block.blockType === DesignBlock.FOOTER;
    block.el.querySelectorAll('[class*="col"]').forEach(function (col) {
      col['data-froala.editor'] && col['data-froala.editor'].destroy();
    });


    if (isFooter) {
      block.el.querySelectorAll('footer .nav-link, footer nav a.btn').forEach(function (col) {
        col.contentEditable = false;
      });
    }
    if (isHeader) {
      block.el.querySelectorAll('header .nav-link, header nav a.btn').forEach(function (col) {
        col.contentEditable = false;
      });
    }
  }

  Editor.prototype.enableForBlock = function enableForBlock(block) {
    var me = this;
    var isHeader = block.blockType === DesignBlock.HEADER;
    var isFooter = block.blockType === DesignBlock.FOOTER;
    block.el.querySelectorAll('[class*="col"]').forEach(function (col) {
      // No link inside it.
      if (!col.querySelector('.nav-link')) {
        new me.FroalaEditor('[class*="col"]', me.opts.editorOptions);
      }
    });

    if (isHeader) {
      new me.FroalaEditor('header .nav-link, header nav a.btn, header img', Object.assign({}, me.opts.editorOptions, {
        linkEditButtons: ['linkEdit', 'linkButton', 'linkAdd', 'linkDestroy'],
        imageEditButtons: ['imageReplace', '-', 'imageAlign', 'imageRemove', 'imageLink', 'linkEdit', 'linkRemove', 'imageAlt', 'imageDisplay', 'imageSize'], // imageTUI, imageStyle
        linkInsertButtons: []
      }));
    }

    if (isFooter) {
      // Init editor on footer links.
      new me.FroalaEditor('footer .nav-link, footer nav a.btn, footer img', Object.assign({}, me.opts.editorOptions, {
        linkEditButtons: ['linkEdit', 'linkAdd', 'linkDestroy'],
        imageEditButtons: ['imageReplace', '-', 'imageAlign', 'imageRemove', 'imageLink', 'linkEdit', 'linkRemove', 'imageAlt', 'imageDisplay', 'imageSize'], // imageTUI, imageStyle
        linkInsertButtons: []
      }));
    }
  }

  Editor.prototype.enable = function enable(variables = [], imageAutoCropEnabled = false, imageProcessLimits = null) {
    this.FroalaEditor = this.page.iframeDoc.defaultView.FroalaEditor;

    if (!this.FroalaEditor) return;

    this._defineLinkButtons();
    this._defineCustomFontSizeButton();
    // Add custom image setting option
    this.customImageVariableOptions(variables)
    this.cropImageOptions(variables, imageAutoCropEnabled, imageProcessLimits)
    this.imageBorderOptions();
    this.imageBackgroundColor();

    this.customVideoVariableOptions(variables)

    // Custom Paste Plugin
    this.customPastePlugin()

    // Custom Button buttons for text and background color
    this.customColorPickerButtonPlugin();

    this._defineFontButtons();

    // this._addDownloadModal();

    // scope reference used in initialized method
    var me = this;
    me._mergeEditorOpts(me.opts.editorOptions, {
      toolbarInline: true,
      pluginsEnabled: ['image', 'link', 'align', 'colors', 'emoticons', 'video', 'paragraphFormat', 'fontSize', 'fontFamily', 'table', 'lists', 'lineHeight', 'fontAwesome', 'imageTUI', 'imageVariable','videoVariable', 'customPaste', 'customButtonColorPicker','crop','fontFit', 'imgBorder', 'imgBorderColor','imgBackground'],
      toolbarButtons: ['bold', 'italic', 'textColor', 'backgroundColor', 'paragraphFormat', 'align', 'emoticons', 'insertLink', 'insertImage', 'undo', 'redo', '-', 'underline', 'subscript', 'superscript', 'fontSize', 'fontFamily', 'insertTable', 'formatOL', 'formatUL', 'lineHeight', 'insertVideo', 'fontAwesome', 'autoFontFit'],
      initOnClick: true,
      colorsHEXInput: false,
      keepFormatOnDelete: true,
      toolbarVisibleWithoutSelection: false,
      listAdvancedTypes: true,
      imageEditButtons: ['imageReplace', 'imageVariableButton','-', 'imageAlign', 'imageRemove', 'imageLink', 'linkEdit', 'linkRemove', 'imageAlt', 'imageDisplay', 'imageSize','cropImage', 'imageBorder','imageBackgroundColor'], // imageTUI, imageStyle
      videoEditButtons: ['videoReplace', 'videoVariableButton', 'videoRemove', 'videoDisplay', 'videoAlign', 'videoSize', 'autoplay'],
      linkEditButtons: ['linkEdit', 'linkButton', 'linkRemove', 'bold', 'italic', 'buttonFontSize', 'fontFamily', 'textColorButton', 'backgroundColorButton', 'backgroundBorderButton', 'backgroundHoverColorButton'],
      htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', 'svg', 'path'],
      htmlAllowedAttrs: ['accept', 'accept-charset', 'accesskey', 'action', 'align', 'allowfullscreen', 'allowtransparency', 'alt', 'aria-.*', 'async', 'autocomplete', 'autofocus', 'autoplay', 'autosave', 'background', 'bgcolor', 'border', 'charset', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'contextmenu', 'controls', 'coords', 'data', 'data-.*', 'datetime', 'default', 'defer', 'dir', 'dirname', 'disabled', 'download', 'draggable', 'dropzone', 'enctype', 'for', 'form', 'formaction', 'frameborder', 'headers', 'social_images', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'icon', 'id', 'ismap', 'itemprop', 'keytype', 'kind', 'label', 'lang', 'language', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'mozallowfullscreen', 'multiple', 'muted', 'name', 'novalidate', 'open', 'optimum', 'pattern', 'ping', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'reversed', 'rows', 'rowspan', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'summary', 'spellcheck', 'style', 'tabindex', 'target', 'title', 'type', 'translate', 'usemap', 'value', 'valign', 'webkitallowfullscreen', 'width', 'wrap', 'fill', 'viewBox', 'xmlns', 'd', 'onmouseover', 'onmouseout', 'fix-font'],
      events: {
        initialized: function initialized() {
          // this is the editor instance.
          me._preventTypingInLinks(this);
          me._replaceImageSourceWithBase64(this);
          if (me.page.pageToolbar.ul && me._isTrialExpire() === 'not-in-trial' || me._isTrialExpire() === 'expire') {
            me._addProButtonForText();
            this.$el.on('click', 'img', function () {
              return me._addProButtonForImage();
            });
          }
        },
        'paste.before': function (e) {
          let pasteData = {};
          let types = e.clipboardData.types;
          for (let i = 0; i < types.length; i++) {
            if (types[i] !== 'text/html') {
              pasteData[types[i]] = e.clipboardData.getData(types[i]);
            } else {
              let pasteContent = e.clipboardData.getData(types[i]);
              if (this.helpers.isIOS() || this.helpers.isMac()) {
                pasteData[types[i]] = pasteContent;
              } else {
                pasteData[types[i]] = pasteContent.match(/(StartFragment-->)(.*?<!--EndFragment)/g)
                if (pasteData[types[i]] && pasteData[types[i]][0]) {
                  pasteData[types[i]] = pasteData[types[i]][0].replace('StartFragment-->', '').replace('<!--EndFragment', '');
                }
              }
            }
          }
          Object.assign(me.FroalaEditor, {
            PASTE_DATA: pasteData
          });
          return false;
        },
        'mousedown': function(mousedownEvent) {
          Object.assign(me.FroalaEditor, {
            SELECTED_TARGET: mousedownEvent.target
          });
        }
      }
    });

    // Enable editor on all blocks.
    this.page.iframeBody.querySelectorAll('[data-block-type]').forEach(function (block) {
      // Enable editor on cols.
      block.querySelectorAll('[class*="col"]').forEach(function (col) {
        // No link inside it.
        if (!col.querySelector('.nav-link')) {
          new me.FroalaEditor('[class*="col"]', me.opts.editorOptions);
        }
      });

      // Init editor on header links.
      new me.FroalaEditor('header .nav-link, header nav a.btn, header img', Object.assign({}, me.opts.editorOptions, {
        linkEditButtons: ['linkEdit', 'linkButton', 'linkAdd', 'linkDestroy'],
        imageEditButtons: ['imageReplace', '-', 'imageAlign', 'imageRemove', 'imageLink', 'linkEdit', 'linkRemove', 'imageAlt', 'imageDisplay', 'imageSize'], // imageTUI, imageStyle
        linkInsertButtons: []
      }));

      // Init editor on footer links.
      new me.FroalaEditor('footer .nav-link, footer nav a.btn, footer img', Object.assign({}, me.opts.editorOptions, {
        linkEditButtons: ['linkEdit', 'linkAdd', 'linkDestroy'],
        imageEditButtons: ['imageReplace', '-', 'imageAlign', 'imageRemove', 'imageLink', 'linkEdit', 'linkRemove', 'imageAlt', 'imageDisplay', 'imageSize'], // imageTUI, imageStyle
        linkInsertButtons: []
      }));
    });
  };

  // Disable editor.


  Editor.prototype.disable = function disable() {
    this.page.iframeBody.querySelectorAll('[data-block-type]').forEach(function (block) {
      block.querySelectorAll('[class*="col"]').forEach(function (col) {
        col['data-froala.editor'] && col['data-froala.editor'].destroy();
      });

      // disable editor on header/footer links
      block.querySelectorAll('footer .nav-link, footer nav a.btn, header .nav-link, header nav a.btn').forEach(function (col) {
        col.contentEditable = false;
      });
    });
  };

  // Create custom buttons for links.


  Editor.prototype._defineCustomFontSizeButton = function _defineCustomFontSizeButton() {
    this.FroalaEditor = this.page.iframeDoc.defaultView.FroalaEditor;
    var that = this;
    var customPopupName = "fontFit.popup";
    var customPlugin = "fontFit";

    // Define popup template.
    Object.assign(this.FroalaEditor.POPUP_TEMPLATES, {
      [customPopupName]: '[_BUTTONS_][_CUSTOM_LAYER_]'
    });

    // Define popup buttons.
    Object.assign(this.FroalaEditor.DEFAULTS, {
      popupButtons: ['popupClose', '-']
    });

    // The custom popup is defined inside a plugin (new or existing).
    this.FroalaEditor.PLUGINS[customPlugin] = function (editor) {
      // Create custom popup.
      function initPopup () {
        // Load popup template.
        var template = that.FroalaEditor.POPUP_TEMPLATES[customPopupName];
        if (typeof template == 'function') template = template.apply(editor);

        // Popup buttons.
        var popup_buttons = '';

        // Create the list of buttons.
        if (editor.opts.popupButtons.length > 1) {
          popup_buttons += '<div class="fr-buttons fr-tabs">';
          popup_buttons += editor.button.buildList(editor.opts.popupButtons);
          popup_buttons += '</div>';
        }

        var width = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line" style="width: 100px"><input id="fr-font-width" type="text" placeholder="' + editor.language.translate('Width') + '" tabIndex="1"></div></div>';
        var height = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line" style="width: 100px"><input id="fr-font-height" type="text" title="height" placeholder="' + editor.language.translate('Height') + '" tabIndex="1" aria-required="true"></div></div>';
        var minFontSize = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line" style="width: 100px"><input id="fr-font-minFont" type="text" placeholder="' + editor.language.translate('Min Size') + '" tabIndex="1"></div></div>';
        var maxFontSize = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line" style="width: 100px"><input id="fr-font-maxFont" type="text" placeholder="' + editor.language.translate('Max Size') + '" tabIndex="1"></div></div></div>';
        var alignVert = '<div class="fr-my-layer fr-layer fr-active" style="width: 31%;margin: 0 5px;" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line alignVert fr-command fr-submit" id="fr-font-align-vert" data-cmd="alignVert" data-param1="true"><i class="fa fa-arrows-v" title="align vertical"></i><span class="pl-2">align vertical</span></div></div>';
        var alignHoriz = '<div class="fr-my-layer fr-layer fr-active" style="width: 31%;margin: 0 5px;" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line alignHoriz fr-command fr-submit" id="fr-font-align-horiz" data-cmd="alignHoriz" data-param1="true"><i class="fa fa-arrows-h" title="align horizontal"></i><span class="pl-2">align horizotal</span></div></div>';
        var multiLine = '<div class="fr-my-layer fr-layer fr-active" style="width: 31%;margin: 0 5px;" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line multiLine fr-command fr-submit" id="fr-font-multiline" data-cmd="multiLine" data-param1="true"><i class="fa fa-align-justify" title="multiline"></i><span class="pl-2">multiline</span></div></div>';
        var detectMultiLine = '<div class="fr-my-layer fr-layer fr-active" style="width: 31%;margin: 0 5px;" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line detectMultiLine fr-command fr-submit" id="fr-font-detect-multiline" data-cmd="detectMultiLine" data-param1="true"><i class="fa fa-indent" title="detect multiline"></i><span class="pl-2">single line</span></div></div>';
        var reProcess = '<div class="fr-my-layer fr-layer fr-active" style="width: 31%;margin: 0 5px;" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line reProcess fr-command fr-submit" id="fr-font-reprocess" data-cmd="reProcess" data-param1="true"><i class="fa fa-refresh" title="Reprocess"></i><span class="pl-2">reprocess</span></div></div>';
        var widthOnly = '<div class="fr-my-layer fr-layer fr-active" style="width: 31%;margin: 0 5px;" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line widthOnly fr-command fr-submit" id="fr-font-width-only" data-cmd="widthOnly" data-param1="true"><i class="fa fa-exchange" title="width only"></i><span class="pl-2">width only</span></div></div>';
        var alignVertWithFlexbox = '<div class="fr-my-layer fr-layer fr-active" style="width: 51%;margin: 0 5px;" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line alignVertWithFlexbox fr-command fr-submit" id="fr-font-flexbox" data-cmd="alignVertWithFlexbox" data-param1="true"><i class="fa fa-th" title="align vertical with flexbox"></i><span class="pl-2">align vertical with flexbox</span></div></div>';
        var clearButton = '<div class="fr-action-buttons d-flex align-items-center justify-content-end ml-auto"><button type="button" class="fr-command fr-submit clearFontButton" data-cmd="clearFontButton" data-param1="true" tabIndex="2" role="button">' + editor.language.translate('Clear') + '</button>';
        var updateButton = '<div class="fr-action-buttons d-flex align-items-center justify-content-end ml-auto"><button type="button" class="fr-command fr-submit autoFontFixButton" data-cmd="autoFontFixButton" data-param1="true" tabIndex="2" role="button">' + editor.language.translate('Update') + '</button></div></div></div></div>';

        var html = '<div><div class="">' +
          '<div class="d-flex align-items-center justify-content-center">'.concat(width).concat(height).concat(minFontSize).concat(maxFontSize,'<div class="d-flex flex-wrap align-items-center justify-content-between px-2" style="max-width: 500px">')
            .concat(alignVert).concat(alignHoriz).concat(multiLine).concat(detectMultiLine).concat(reProcess).concat(widthOnly).concat(alignVertWithFlexbox).concat(clearButton).concat(updateButton)

        // Load popup template.
        template = {
          buttons: popup_buttons,
          custom_layer: html,
        };

        // Define custom popup template dropdown command
        that.FroalaEditor.RegisterCommand('autoFontFixButton', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            var element = that.FroalaEditor.SELECTED_TARGET;
            let parent = element.parentNode;
            let grandParent = parent.parentNode;
            if(element.getAttribute('data-height') || element.getAttribute('data-height') || element.getAttribute('data-width') || element.getAttribute('data-max-size') || element.getAttribute('data-min-size') || element.getAttribute('data-align-vert') || element.getAttribute('data-align-horiz') || element.getAttribute('data-multiline') || element.getAttribute('data-detect-multiline') || element.getAttribute('data-reprocess') || element.getAttribute('data-width-only') || element.getAttribute('data-flexbox')) {
              let parent = element.parentNode;
              let grandParent = parent.parentNode;
              autoTextFit(grandParent, element)
            }
            else {
              let parent = element.parentNode;
              var wrapper = document.createElement('div');
              parent.replaceChild(wrapper, element);
              wrapper.appendChild(element);
              wrapper.setAttribute('data-font-fix',val);
              wrapper.setAttribute('class','auto-text-fit');
              autoTextFit(wrapper, element)
            }
            this[customPlugin].back();
          }
        });

        that.FroalaEditor.RegisterCommand('clearFontButton', {
          undo: false,
          focus: false,
          callback: function () {
            let element = that.FroalaEditor.SELECTED_TARGET;
            if(element.getAttribute('data-height') || element.getAttribute('data-height') || element.getAttribute('data-width') || element.getAttribute('data-max-size') || element.getAttribute('data-min-size') || element.getAttribute('data-align-vert') || element.getAttribute('data-align-horiz') || element.getAttribute('data-multiline') || element.getAttribute('data-detect-multiline') || element.getAttribute('data-reprocess') || element.getAttribute('data-width-only') || element.getAttribute('data-flexbox')) {
              let parent = element.parentNode;
              let grandParent = parent.parentNode;
              // parent.removeAttribute('class');
              // parent.style = null;
              // grandParent.removeAttribute('class');
              // grandParent.style = null;
              grandParent.replaceWith(element);
              clearElements(element);
              element.removeAttribute('data-height');
              element.removeAttribute('data-width');
              element.removeAttribute('data-max-size');
              element.removeAttribute('data-min-size');
              element.removeAttribute('data-align-horiz');
              element.removeAttribute('data-align-vert');
              element.removeAttribute('data-multiline');
              element.removeAttribute('data-detect-multiline');
              element.removeAttribute('data-reprocess');
              element.removeAttribute('data-width-only');
              element.removeAttribute('data-flexbox');
              element.removeAttribute('data-font-fitted');
            }
          }
        });

        that.FroalaEditor.RegisterCommand('alignVert', {
          undo: false,
          focus: false,
          callback: function () {
            setTool('fr-font-align-vert');
          }
        });

        that.FroalaEditor.RegisterCommand('alignHoriz', {
          undo: false,
          focus: false,
          callback: function () {
            setTool('fr-font-align-horiz');
          }
        });

        that.FroalaEditor.RegisterCommand('multiLine', {
          undo: false,
          focus: false,
          callback: function () {
            setTool('fr-font-multiline');
          }
        });

        that.FroalaEditor.RegisterCommand('detectMultiLine', {
          undo: false,
          focus: false,
          callback: function () {
            setTool('fr-font-detect-multiline');
          }
        });

        that.FroalaEditor.RegisterCommand('reProcess', {
          undo: false,
          focus: false,
          callback: function () {
            setTool('fr-font-reprocess');
          }
        });

        that.FroalaEditor.RegisterCommand('widthOnly', {
          undo: false,
          focus: false,
          callback: function () {
            setTool('fr-font-width-only');
          }
        });

        that.FroalaEditor.RegisterCommand('alignVertWithFlexbox', {
          undo: false,
          focus: false,
          callback: function () {
            setTool('fr-font-flexbox');
          }
        });


        that.FroalaEditor.RegisterCommand('popupClose', {
          title: 'Close',
          icon: 'imageBack',
          undo: false,
          focus: false,
          callback: function () {
            this[customPlugin].back()
          }
        });

        function unSetToolBox(toolboxId, valueId, element) {
          var iFrameEl = document.getElementById('froala-pages');
            var tool = iFrameEl.contentWindow.document.getElementById(toolboxId);
            tool.removeAttribute('data-font-active');
            tool.style.color = null;
        }

        function unSetTextBox(textboxId) {
          var iFrameEl = document.getElementById('froala-pages');
          iFrameEl.contentWindow.document.getElementById(textboxId).value = "";
          iFrameEl.contentWindow.document.getElementById(textboxId).classList.remove("fr-not-empty");
        }

        function clearElements(element) {
          unSetTextBox('fr-font-height');
          unSetTextBox('fr-font-width');
          unSetTextBox('fr-font-maxFont');
          unSetTextBox('fr-font-minFont');
          unSetToolBox('fr-font-align-vert', 'data-align-vert', element);
          unSetToolBox('fr-font-align-horiz', 'data-align-horiz', element);
          unSetToolBox('fr-font-multiline', 'data-multiline', element);
          unSetToolBox('fr-font-detect-multiline', 'data-detect-multiline', element);
          unSetToolBox('fr-font-reprocess', 'data-reprocess', element);
          unSetToolBox('fr-font-width-only', 'data-width-only', element);
          unSetToolBox('fr-font-flexbox', 'data-flexbox', element);
        }

        function setTool(elementId) {
          var iFrameEl = document.getElementById('froala-pages');
          var tool = iFrameEl.contentWindow.document.getElementById(elementId);
          if(!tool.getAttribute('data-font-active')) {
            tool.setAttribute('data-font-active',"true");
            tool.style.color = '#0074CC';
          }
          else {
            tool.removeAttribute('data-font-active');
            tool.style.color = null;
          }
        }

        function getTool(elementId) {
          var iFrameEl = document.getElementById('froala-pages');
          return iFrameEl.contentWindow.document.getElementById(elementId).getAttribute('data-font-active');
        }

        function autoTextFit(ele, target) {
          var iFrameEl = document.getElementById('froala-pages');
          const height = iFrameEl.contentWindow.document.getElementById('fr-font-height').value;
          const width = iFrameEl.contentWindow.document.getElementById('fr-font-width').value;
          const maxSize = iFrameEl.contentWindow.document.getElementById('fr-font-maxFont').value;
          const minSize = iFrameEl.contentWindow.document.getElementById('fr-font-minFont').value;
          const alignVert = getTool('fr-font-align-vert');
          const alignHoriz = getTool('fr-font-align-horiz');
          const multiline = getTool('fr-font-multiline');
          const detectMultiline = getTool('fr-font-detect-multiline');
          const reProcess = getTool('fr-font-reprocess');
          const widthOnly = getTool('fr-font-width-only');
          const alignVertWithFlexbox = getTool('fr-font-flexbox');

          ele.style.fontSize = null;
          target.style.fontSize = null;
          if(target.tagName === "H1" || target.tagName === "H2" || target.tagName === "H3" || target.tagName === "H4" || target.tagName === "H5" || target.tagName === "H6") {
              target.style.fontSize = 'inherit';
          }
          let parent = target.parentNode;
          let grandParent = parent.parentNode;

          const fontFixObj = {};
          if(height) {
            ele.style.height = `${height}px`;
            target.setAttribute('data-height',height);
            target.setAttribute('data-font-fitted',"true");
          }
          else {
            ele.style.height = null;
            target.removeAttribute('data-height');
          }
          if(width) {
            ele.style.width = `${width}px`;
            target.setAttribute('data-width',width);
            target.setAttribute('data-font-fitted',"true");
          }
          else{
            ele.style.width = null;
            target.removeAttribute('data-width')
          }
          if(maxSize){
            fontFixObj['maxFontSize'] = Number(maxSize);
            target.setAttribute('data-max-size',maxSize);
            target.setAttribute('data-font-fitted',"true");
          }
          else {
            target.removeAttribute('data-max-size')
          }
          if(minSize) {
            fontFixObj['minFontSize'] = Number(minSize);
            target.setAttribute('data-min-size',minSize);
            target.setAttribute('data-font-fitted',"true");
          }
          else {
            target.removeAttribute('data-min-size')
          }
          if(alignVert) {
            fontFixObj['alignVert'] = true;
            target.setAttribute('data-align-vert',"true");
            target.setAttribute('data-font-fitted',"true");
          }
          else {
            target.removeAttribute('data-align-vert')
            fontFixObj['alignVert'] = false;
            if (parent) {
              if(parent.style.position) parent.style.position = null;
              if(parent.style.top) parent.style.top = null;
              if(parent.style.right) parent.style.right = null;
              if(parent.style.bottom) parent.style.bottom = null;
              if(parent.style.left) parent.style.left = null;
              if(parent.style.margin) parent.style.margin = null;
              if(parent.style.display) parent.style.display = 'inline-block';
              if(parent.style.justifyContent) parent.style.justifyContent = null;
              if(parent.style.flexDirection) parent.style.flexDirection = null;
              parent.classList.remove('textFitAlignVert');
            }
          }
          if(alignHoriz) {
            target.setAttribute('data-align-horiz',"true")
            fontFixObj['alignHoriz'] = true;
            target.setAttribute('data-font-fitted',"true");
          }
          else {
            target.removeAttribute('data-align-horiz')
            fontFixObj['alignHoriz'] = false;
            if (parent) {
              parent.style.textAlign = null;
            }
            if (grandParent)  {
              grandParent.style.textAlign = null;
            }
          }
          if(multiline) {
            fontFixObj['multiLine'] = true;
            target.setAttribute('data-multiline',"true");
            target.setAttribute('data-font-fitted',"true");
          }
          else {
            target.removeAttribute('data-multiline')
            fontFixObj['multiLine'] = false;
          }
          if(detectMultiline) {
            fontFixObj['detectMultiLine'] = false;
            target.setAttribute('data-detect-multiline',"false");
            target.setAttribute('data-font-fitted',"true");
            // ele.style.height = null;
            if(maxSize || minSize) {
              delete fontFixObj['maxFontSize'];
              delete fontFixObj['minFontSize'];
            }
          }
          else {
            target.removeAttribute('data-detect-multiline');
            fontFixObj['detectMultiLine'] = true;
            let parent = target.parentNode;
            let grandParent = parent.parentNode;
            parent.style.fontSize = null;
            grandParent.style.removeProperty('white-space');
            parent.style.whiteSpace = null;
          }
          if(reProcess) {
            fontFixObj['reProcess'] = false;
            target.setAttribute('data-reprocess',"false");
            target.setAttribute('data-font-fitted',"true");
          }
          else {
            fontFixObj['reProcess'] = true;
            target.removeAttribute('data-reprocess')
          }
          if(widthOnly) {
            fontFixObj['widthOnly'] = true;
            target.setAttribute('data-width-only',"true");
            target.setAttribute('data-font-fitted',"true");
          }
          else {
            fontFixObj['widthOnly'] = false;
            target.removeAttribute('data-width-only')
          }
          if(alignVertWithFlexbox) {
            fontFixObj['alignVertWithFlexbox'] = true;
            target.setAttribute('data-flexbox',"true");
            target.setAttribute('data-font-fitted',"true");
          }
          else {
            fontFixObj['alignVertWithFlexbox'] = false;
            target.removeAttribute('data-flexbox')
          }
          textFit(ele,fontFixObj);
          let spanCss = window.getComputedStyle(ele.childNodes[0]);
          let spanWidth = parseInt(spanCss.width, 10);
          let spanHeight = parseInt(spanCss.height, 10);
          if(spanWidth > width || spanHeight > height) {
            if(target.getAttribute('data-max-size') || target.getAttribute('data-min-size')) {
              delete fontFixObj['maxFontSize'];
              delete fontFixObj['minFontSize'];
              textFit(ele,fontFixObj);
            }
          }
          // afterFontFix(target, fontFixObj);
          setTimeout(() => {
            let parentEle = ele.childNodes[0];
            if(target.getAttribute('data-align-vert') === "true") {
              // let grandParent = parent.parentNode;
              if (parentEle) {
                parentEle.style.position = 'absolute';
                parentEle.style.top = '0';
                parentEle.style.right = '0';
                parentEle.style.bottom = '0';
                parentEle.style.left = '0';
                parentEle.style.margin = 'auto';
                parentEle.style.display = 'flex';
                parentEle.style.justifyContent = 'center';
                parentEle.style.flexDirection = 'column';
              }
            }
            ele.style.whiteSpace = null;
          },15)
        }

        // Create popup.
        return editor.popups.create(customPopupName, template);
      }

      // Show the popup
      function showPopup () {
        var $popup = editor.popups.get(customPopupName);
        if (!$popup) $popup = initPopup();


        editor.popups.setContainer(customPopupName, editor.$sc);
        var $btn = editor.$sc.find('.fr-command[data-cmd="autoFontFit"]');
        var left = $btn.offset().left;
        var top = $btn.offset().top - (editor.opts.toolbarBottom ? 10 : ($btn.outerHeight() - 10));
        editor.popups.show(customPopupName, left, top, $btn.outerHeight());
      }

      // Hide the custom popup.
      function hidePopup () {
        editor.popups.hide(customPopupName);
      }

      // Methods visible outside the plugin.
      return {
        showPopup: showPopup,
        hidePopup: hidePopup,
        back: function back() {
          editor.events.disableBlur();
          editor.selection.restore();
          editor.popups.hide(customPopupName);
        }
      }
    }

    this.FroalaEditor.DefineIcon('autoFontFit', { NAME: 'text-width', template: 'font_awesome'})
    this.FroalaEditor.RegisterCommand('autoFontFit', {
      title: 'Auto Font Fit',
      icon: 'autoFontFit',
      undo: false,
      focus: false,
      popup: true,
      plugin: 'fontFit',
      callback: function () {
        if (!this.popups.isVisible(customPopupName)) {
          this[customPlugin].showPopup();
          var element = that.FroalaEditor.SELECTED_TARGET;
          // let style = window.getComputedStyle(element);
          let style = element.style.fontSize;
          if (style) {
            element.setAttribute('org-size',style);
          }
          clearElements(element);
          if (element.getAttribute('data-height') || element.getAttribute('data-height') || element.getAttribute('data-width') || element.getAttribute('data-max-size') || element.getAttribute('data-min-size') || element.getAttribute('data-align-vert') || element.getAttribute('data-align-horiz') || element.getAttribute('data-multiline') || element.getAttribute('data-detect-multiline') || element.getAttribute('data-reprocess') || element.getAttribute('data-width-only') || element.getAttribute('data-flexbox')) {
            setTextBox('fr-font-height','data-height');
            setTextBox('fr-font-width','data-width');
            setTextBox('fr-font-maxFont','data-max-size');
            setTextBox('fr-font-minFont','data-min-size');
            setToolBox('fr-font-align-vert', 'data-align-vert', element);
            setToolBox('fr-font-align-horiz', 'data-align-horiz', element);
            setToolBox('fr-font-multiline', 'data-multiline', element);
            setToolBox('fr-font-detect-multiline', 'data-detect-multiline', element);
            setToolBox('fr-font-reprocess', 'data-reprocess', element);
            setToolBox('fr-font-width-only', 'data-width-only', element);
            setToolBox('fr-font-flexbox', 'data-flexbox', element);
          }
          else {
            clearElements(element);
          }

        }
        else {
          if (this.$el.find('.fr-marker')) {
            this.events.disableBlur();
            this.selection.restore();
          }
          this[customPlugin].hidePopup();
        }

        function setTextBox(textboxId, valueId) {
          var iFrameEl = document.getElementById('froala-pages');
          iFrameEl.contentWindow.document.getElementById(textboxId).value = element.getAttribute(valueId);
          iFrameEl.contentWindow.document.getElementById(textboxId).classList.add("fr-not-empty");
        }

        function unSetTextBox(textboxId) {
          var iFrameEl = document.getElementById('froala-pages');
          iFrameEl.contentWindow.document.getElementById(textboxId).value = "";
          iFrameEl.contentWindow.document.getElementById(textboxId).classList.remove("fr-not-empty");
        }

        function setToolBox(toolboxId, valueId, element) {
          var iFrameEl = document.getElementById('froala-pages');
          if(element.getAttribute(valueId)) {
            var tool = iFrameEl.contentWindow.document.getElementById(toolboxId);
            tool.setAttribute('data-font-active',"true");
            tool.style.color = '#0074CC';
          }
        }

        function unSetToolBox(toolboxId, valueId, element) {
          var iFrameEl = document.getElementById('froala-pages');
          if(!element.getAttribute(valueId)) {
            var tool = iFrameEl.contentWindow.document.getElementById(toolboxId);
            tool.removeAttribute('data-font-active');
            tool.style.color = null;
          }
        }

        function clearElements(element) {
          unSetTextBox('fr-font-height');
          unSetTextBox('fr-font-width');
          unSetTextBox('fr-font-maxFont');
          unSetTextBox('fr-font-minFont');
          unSetToolBox('fr-font-align-vert', 'data-align-vert', element);
          unSetToolBox('fr-font-align-horiz', 'data-align-horiz', element);
          unSetToolBox('fr-font-multiline', 'data-multiline', element);
          unSetToolBox('fr-font-detect-multiline', 'data-detect-multiline', element);
          unSetToolBox('fr-font-reprocess', 'data-reprocess', element);
          unSetToolBox('fr-font-width-only', 'data-width-only', element);
          unSetToolBox('fr-font-flexbox', 'data-flexbox', element);
        }
      },
      refresh: function refresh(ele) {

      }
    });
  };

  Editor.prototype._defineLinkButtons = function _defineLinkButtons() {
    var that = this;

    // Remove link.
    this.FroalaEditor.DefineIcon('linkDestroy', {
      NAME: 'trash'
    });
    this.FroalaEditor.RegisterCommand('linkDestroy', {
      type: 'button',
      title: 'Remove Link',
      callback: function callback() {
        var $oel = this.$oel;

        this.destroy();

        // Footer case.
        if ($oel.parents('.nav-item').length === 0) {
          $oel.remove();
        } else {
          $oel.parent().remove();
        }
      },
      refresh: function refresh($btn) {
        // Footer case.
        if (this.$oel.parent('.nav-item').length === 0) {
          $btn.get(0).classList.toggle('fr-disabled', this.$oel.siblings('.nav-link').length === 0);
        } else {
          $btn.get(0).classList.toggle('fr-disabled', this.$oel.parents('.nav-item').siblings('.nav-item').length === 0);
        }

        that.enable();
      }
    });

    // Add link.
    this.FroalaEditor.DefineIcon('linkAdd', {
      NAME: 'plus'
    });

    // Image TUI
    this.FroalaEditor.RegisterCommand('imageTUI', {
      title: 'Advanced Edit',
      undo: false,
      focus: false,
      callback: function callback(cmd, val) {

        var ele = document.getElementsByClassName('fp-block-toolbar');
        if (ele.length > 0) {
          ele[0].classList.remove('fp-visible');
        }
        this.imageTUI.launch(this, true);
      },
      plugin: 'imageTUI'
    });

    this.FroalaEditor.RegisterCommand('linkAdd', {
      type: 'button',
      title: 'Add Link',
      callback: function callback() {
        var $oel = this.$oel;

        // Footer case.
        if ($oel.parents('.nav-item').length === 0) {
          $oel.after('<a class="nav-link" href="https://www.froala.com">Link</a>');
        } else {
          $oel.parent().after('<li class="nav-item"><a class="nav-link" href="https://www.froala.com">Link</a></li>');
        }
      }
    });

    // Link button type.
    this.FroalaEditor.DefineIcon('linkButton', {
      NAME: 'star'
    });

    this.FroalaEditor.DefineIcon('insertVideo', {
      NAME: 'video-camera',
      FA5NAME: 'video',
      SVG_KEY: 'insertVideo'
    });

    this.FroalaEditor.RegisterCommand('linkButton', {
      type: 'dropdown',
      title: 'Choose Style',
      options: {
        link: 'Link',
        button: 'Button',
        outline: 'Outline'
      },
      callback: function callback(cmd, val) {
        var link = this.link.get();

        if (val === 'link') {
          link.classList.add('nav-link');
          link.classList.remove('btn', 'btn-primary', 'btn-outline-primary');
        } else if (val === 'button') {
          link.classList.remove('nav-link', 'btn-outline-primary');
          link.classList.add('btn', 'btn-primary');
        } else if (val === 'outline') {
          link.classList.remove('nav-link', 'btn-primary');
          link.classList.add('btn', 'btn-outline-primary');
        }
      }
    });
  };

  Editor.prototype.customImageVariableOptions = function customImageVariableOptions(variables) {
    this.FroalaEditor = this.page.iframeDoc.defaultView.FroalaEditor;
    var that = this;
    var customPopupName = "imageVariable.popup";
    var customPlugin = "imageVariable";

    // Define popup template.
    Object.assign(this.FroalaEditor.POPUP_TEMPLATES, {
      [customPopupName]: '[_BUTTONS_][_CUSTOM_LAYER_]'
    });

    // Define popup buttons.
    Object.assign(this.FroalaEditor.DEFAULTS, {
      popupButtons: ['popupClose', '-']
    });


    // The custom popup is defined inside a plugin (new or existing).
    this.FroalaEditor.PLUGINS[customPlugin] = function (editor) {
      var imageSrcOptions = {
        'none': [{name: "None", key: "", valueType: ['text', 'all']}],
      };
      if (variables) {
        imageSrcOptions = {
          'none': [{name: "None", key: "", valueType: ['text', 'all']}],
          ...variables
        }
      }
      // Create custom popup.
      function initPopup () {
        // Load popup template.
        var template = that.FroalaEditor.POPUP_TEMPLATES[customPopupName];
        if (typeof template == 'function') template = template.apply(editor);

        // Popup buttons.
        var popup_buttons = '';

        // Create the list of buttons.
        if (editor.opts.popupButtons.length > 1) {
          popup_buttons += '<div class="fr-buttons fr-tabs">';
          popup_buttons += editor.button.buildList(editor.opts.popupButtons);
          popup_buttons += '</div>';
        }

        // Define Popup Template - icon when empty, icon + text + clear when selected
        var pickerButton = '<div class="imageSrcVariablePicker" style="display:flex;align-items:center;cursor:pointer;padding:4px 8px;" title="Select Variable">';
        pickerButton += '<span class="imageSrcVariableIcon" style="display:inline-flex;width:20px;height:20px;">' + editor.icon.create('variables') + '</span>';
        pickerButton += '<span class="imageSrcVariableLabel d-none" style="margin-left:4px;font-size:13px;white-space:nowrap;color:#333;"></span>';
        pickerButton += '<span class="imageSrcVariableClear d-none" style="cursor:pointer;color:#999;font-size:16px;margin-left:4px;line-height:1;" title="Clear">&times;</span>';
        pickerButton += '</div>';

        var checkBoxHtml = '<span style="text-align: left"><div class="fr-checkbox-line fr-autoplay-margin imageSrcVariableCheck">';
        checkBoxHtml += '<span class="fr-checkbox"><input id="imageSrcVariableCheck-'+editor.id+'" data-cmd="imageSrcVariableCheck" data-param1="true" class="fr-command" type="checkbox" dir="auto" value/><span><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg></span></span>';
        checkBoxHtml += '<label style="line-height: 1;white-space: break-spaces;word-break: break-word;" id="imageSrcVariableCheckLabel-'+editor.id+'" data-cmd="imageSrcVariableCheck" data-param1="true" class="fr-command">Show the uploaded image when the selected dynamic image is not available</label></div></span>';

        var html = '<div class="fr-image-variable-layer fr-layer fr-active fr-buttons m-0 w-auto"><div class="d-flex align-items-center">'.concat(pickerButton).concat(checkBoxHtml, '</div>').concat('</div>');
        // Load popup template.
        template = {
          buttons: popup_buttons,
          custom_layer: html,
        };

        // Define custom popup template checkbox command
        that.FroalaEditor.RegisterCommand('imageSrcVariableCheck', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            let img = this.el.querySelector("img");
            if (img.getAttribute('data-src-visibility')) {
              img.removeAttribute('data-src-visibility');
            } else {
              img.setAttribute('data-src-visibility', val);
            }
          }
        });

        // Create popup.
        var $popup = editor.popups.create(customPopupName, template);
        var popupEl = $popup[0] || $popup;

        // Attach click handler to the picker container using native DOM
        var pickerEl = popupEl.querySelector('.imageSrcVariablePicker');
        if (pickerEl) {
          pickerEl.addEventListener('click', function(e) {
            if (e.target.closest('.imageSrcVariableClear')) {
              // Clear the variable
              e.stopPropagation();
              var img = editor.el.querySelector("img");
              if (img) img.removeAttribute('data-src-variable');
              var lbl = popupEl.querySelector('.imageSrcVariableLabel');
              var clr = popupEl.querySelector('.imageSrcVariableClear');
              if (lbl) { lbl.textContent = ''; lbl.classList.add('d-none'); }
              if (clr) { clr.classList.add('d-none'); }
            } else {
              // Open the variable picker - save img reference now before toolbar closes
              if (that.onImageVariablePickerRequested) {
                that._pendingImageEditor = editor;
                that._pendingImagePopup = popupEl;
                that._pendingImageElement = editor.el.querySelector("img");
                that.onImageVariablePickerRequested();
              }
            }
          });
        }

        return $popup;
      }

      // Set default value according to attributes (using native DOM API)
      function checkElementForData(instance, popup) {
        var popupEl = popup[0] || popup;
        let img = instance.el.querySelector("img");
        if (!img) return;
        let value = img.getAttribute('data-src-visibility');
        let checkboxEl = popupEl.querySelector('.imageSrcVariableCheck input');
        if (checkboxEl) checkboxEl.checked = !!value;

        value = img.getAttribute('data-src-variable');
        let labelEl = popupEl.querySelector('.imageSrcVariableLabel');
        let clearEl = popupEl.querySelector('.imageSrcVariableClear');
        if (!labelEl || !clearEl) return;
        if (value) {
          let newOptions = [];
          Object.keys(imageSrcOptions).forEach(group => {
            newOptions = [...newOptions, ...imageSrcOptions[group]];
          });
          let option = newOptions.find(item => item.key === value);
          if (option) {
            labelEl.textContent = option.name;
            labelEl.classList.remove('d-none');
            clearEl.classList.remove('d-none');
          }
        } else {
          labelEl.textContent = '';
          labelEl.classList.add('d-none');
          clearEl.classList.add('d-none');
        }
      }

      // Show the popup
      function showPopup () {
        var $popup = editor.popups.get(customPopupName);
        if (!$popup) $popup = initPopup();

        editor.popups.onShow(customPopupName, function() {
          checkElementForData(this, $popup);
        });

        editor.popups.setContainer(customPopupName, editor.$sc);
        var $btn = editor.$sc.find('.fr-active .fr-command[data-cmd="imageVariableButton"]');
        var left = $btn.offset().left;
        var top = $btn.offset().top - (editor.opts.toolbarBottom ? 10 : ($btn.outerHeight() - 10));
        editor.popups.show(customPopupName, left, top, $btn.outerHeight());
      }

      // Hide the custom popup.
      function hidePopup () {
        editor.popups.hide(customPopupName);
      }

      // Methods visible outside the plugin.
      return {
        showPopup: showPopup,
        hidePopup: hidePopup
      }
    }

    // Define custom popup close button icon and command.
    this.FroalaEditor.RegisterCommand('popupClose', {
      title: 'Close',
      icon: 'imageBack',
      undo: false,
      focus: false,
      callback: function () {
        this.image.back();
      }
    });

    // Define an icon and command for the button that opens the custom popup.
    this.FroalaEditor.DefineIcon('imageVariableButton', { NAME: 'cog', template: 'font_awesome'})
    this.FroalaEditor.RegisterCommand('imageVariableButton', {
      title: 'Use Variable',
      icon: 'imageVariableButton',
      undo: false,
      focus: false,
      popup: true,
      plugin: 'imageVariable',
      callback: function () {
        if (!this.popups.isVisible(customPopupName)) {
          this[customPlugin].showPopup();
        }
        else {
          if (this.$el.find('.fr-marker')) {
            this.events.disableBlur();
            this.selection.restore();
          }
          this[customPlugin].hidePopup();
        }
      }
    });
  }

  Editor.prototype.handleImageVariableSelected = function handleImageVariableSelected(key, name) {
    var img = this._pendingImageElement;
    var popupEl = this._pendingImagePopup;
    if (!img) return;

    if (key && key.trim()) {
      img.setAttribute('data-src-variable', key);
      if (popupEl) {
        var labelEl = popupEl.querySelector('.imageSrcVariableLabel');
        var clearEl = popupEl.querySelector('.imageSrcVariableClear');
        if (labelEl) { labelEl.textContent = name || key; labelEl.classList.remove('d-none'); }
        if (clearEl) { clearEl.classList.remove('d-none'); }
      }
    } else {
      img.removeAttribute('data-src-variable');
      if (popupEl) {
        var labelEl = popupEl.querySelector('.imageSrcVariableLabel');
        var clearEl = popupEl.querySelector('.imageSrcVariableClear');
        if (labelEl) { labelEl.textContent = ''; labelEl.classList.add('d-none'); }
        if (clearEl) { clearEl.classList.add('d-none'); }
      }
    }

    this._pendingImageEditor = null;
    this._pendingImagePopup = null;
    this._pendingImageElement = null;
  };

  Editor.prototype.cropImageOptions = function cropImageOptions(variables, imageAutoCropEnabled = false, imageProcessLimits = null) {
    this.FroalaEditor = this.page.iframeDoc.defaultView.FroalaEditor;
    var that = this;
    var customPopupName = "crop.popup";
    var customPlugin = "crop";
    var _this10 = this;

    // Define popup template.
    Object.assign(this.FroalaEditor.POPUP_TEMPLATES, {
      [customPopupName]: '[_BUTTONS_][_CUSTOM_LAYER_]'
    });

    // Define popup buttons.
    Object.assign(this.FroalaEditor.DEFAULTS, {
      popupButtons: ['popupClose', '-']
    });


    // The custom popup is defined inside a plugin (new or existing).
    this.FroalaEditor.PLUGINS[customPlugin] = function (editor) {
      // Create custom popup.
      function initPopup () {
        // Load popup template.
        var template = that.FroalaEditor.POPUP_TEMPLATES[customPopupName];
        if (typeof template == 'function') template = template.apply(editor);

        // Popup buttons.
        var popup_buttons = '';

        // Create the list of buttons.
        if (editor.opts.popupButtons.length > 1) {
          popup_buttons += '<div class="fr-buttons fr-tabs">';
          popup_buttons += editor.button.buildList(editor.opts.popupButtons);
          popup_buttons += '</div>';
        }

        var fitOptions = ['cover', 'contain', 'fill', 'inside', 'outside'];
        if (imageAutoCropEnabled) {
          fitOptions.push('auto');
        }
        
        var fitDropDown = '<select class="fr-dropdown-list" id="fr-image-crop-fit" style="height: 46px;width: 100px;background: white;border: 1px solid #999999;border-radius: 2px"><option selected="selected" value="">select fit</option>';

        fitOptions.forEach(item => {
              fitDropDown += '<option value="'+ item +'" id="image-fit-' + item + '">' + item + '</option>';
        })

        fitDropDown += '</select>';


        var positionOptions = ['top', 'right top', 'right', 'right bottom', 'bottom', 'left bottom', 'left', 'left top', 'center'];
        var positionDropDown = '<select class="fr-dropdown-list" id="fr-image-crop-position" style="height: 46px;width: 100px;background: white;border: 1px solid #999999;border-radius: 2px"><option selected="selected" value="">select position</option>';

        positionOptions.forEach(item => {
          positionDropDown += '<option value="'+ item +'" id="image-position-' + item + '">' + item + '</option>';
        })

        positionDropDown += '</select>';


        var medOptions = ['px', '%'];
        var medDropDown = '<select class="fr-dropdown-list" id="fr-image-crop-med" style="height: 46px;width: 40px;background: white;border: 1px solid #999999;border-radius: 2px">';

        medOptions.forEach(item => {
          medDropDown += '<option value="'+ item +'" id="image-position-' + item + '">' + item + '</option>';
        })

        medDropDown += '</select>';


        var width = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line" style="width: 100px; padding-bottom: 0"><input id="fr-image-crop-width" type="text" placeholder="' + editor.language.translate('Width') + '" tabIndex="1"></div></div>';
        var height = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line cropHeight" style="width: 100px; padding-bottom: 0"><input id="fr-image-crop-height" type="text" placeholder="' + editor.language.translate('Height') + '" tabIndex="1" aria-required="true"></div></div>';
        var position = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line" style="width: 100px; padding-bottom: 0">' + positionDropDown + '</div></div>';
        var fit = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line cropHeight" style="width: 100px; padding-bottom: 0">'+fitDropDown+'</div></div>';
        var padding = '<div class="d-flex align-items-center justify-content-between w-100"><div class="d-flex align-items-center"><div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line cropPadding" style="width: 100px"><input id="fr-image-crop-padding" type="text" placeholder="' + editor.language.translate('Padding') + '" tabIndex="1" aria-required="true"></div></div>';
        var med = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line cropHeight" style="width: 100px">'+medDropDown+'</div></div> </div>';
        var clearButton = '<div class="fr-action-buttons" style="margin-left: -50px"><button type="button" class="fr-command fr-submit clearImageButton" data-cmd="clearImageButton" data-param1="true" tabIndex="2" role="button">' + editor.language.translate('Clear') + '</button>';
        var updateButton = '<button type="button" style="margin-left: -4px" class="fr-command fr-submit cropImageButton" data-cmd="cropImageButton" data-param1="true" tabIndex="2" role="button">' + editor.language.translate('Update') + '</button></div></div>';

        // Where Update says what /api/v1/image-process would refuse.
        var cropError = '<div id="fr-image-crop-error" role="alert" style="display: none; width: 100%; margin: 0 5px 10px; color: #D92D20; font-size: 13px"></div>';

        var html = '<div><div class="d-flex align-items-center flex-wrap" style="max-width: 450px">'.concat(width).concat(height).concat(position).concat(fit).concat(padding).concat(med).concat(clearButton).concat(updateButton).concat(cropError, '</div>');
        // Load popup template.
        template = {
          buttons: popup_buttons,
          custom_layer: html,
        };

        // Define custom popup template dropdown command
        that.FroalaEditor.RegisterCommand('cropImageButton', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            let img = that.FroalaEditor.SELECTED_TARGET;
            var iFrameEl = document.getElementById('froala-pages');
            var cropField = function (name) {
              return iFrameEl.contentWindow.document.getElementById('fr-image-crop-' + name);
            };
            // Read before the image is touched: a value /api/v1/image-process refuses would be saved
            // as a broken image, so the popup stays open and says what it takes instead.
            var sizes = readCropSizes(img, cropField, imageProcessLimits);
            cropField('error').textContent = sizes.problem || '';
            cropField('error').style.display = sizes.problem ? '' : 'none';
            if (sizes.problem) {
              cropField(sizes.field).focus();
              return;
            }
            if(img.getAttribute('data-src-crop')) {
              clearCropImage(img);
            }
            var height = sizes.height;
            var width = sizes.width;
            var position = cropField('position').value || null;
            var fit = cropField('fit').value || null;
            // Auto is Smart Fit - the face image-process finds, otherwise contain. It reads that as
            // fit=contain&smart=true (fit=auto no longer), and the page renderer as data-src-smart.
            var smart = fit === 'auto';
            if (smart) fit = 'contain';
            var padding = sizes.padding;
            var med = cropField('med').value;

            let cropUrl = `${_this10.opts.editorOptions.cropImageUploadUrl}?`
            if(height) {
              img.setAttribute('data-src-height', height);
              cropUrl += `height=${height}&`;
            }
            if(width) {
              img.setAttribute('data-src-width', width);
              cropUrl += `width=${width}&`;
            }
            if(position) {
              img.setAttribute('data-src-position', position);
              cropUrl += `position=${position}&`;
            }
            if(fit) {
              img.setAttribute('data-src-fit', fit);
              cropUrl += `fit=${fit}&`;
            }
            if(smart) {
              img.setAttribute('data-src-smart', 'true');
              cropUrl += `smart=true&`;
            }
            if(sizes.paddingAmount !== null) {
              img.setAttribute('data-src-padding', sizes.paddingAmount);
              cropUrl += `padding=${padding}&`;
            }
            if(med) {
              img.setAttribute('data-src-padding-med', med);
            }
            if( height || width || position || fit || sizes.paddingAmount !== null) {
              img.setAttribute('data-src-crop', val);
            }
            let imageSrc = img.getAttribute('src');
            img.setAttribute('data-src-original',imageSrc);
            cropUrl += `url=${encodeURIComponent(imageSrc)}`;
            if(cropUrl) {
              img.setAttribute('src',cropUrl);
            }
            if(img.getAttribute('data-border') === "true") {
              img.style.backgroundClip = 'border-box';
              img.style.fontSize = '0';
              img.style.margin = '0';
              img.style.padding = '0';
              img.style.boxSizing = 'border-box';
            }
            this.image.back();
          }
        });

        that.FroalaEditor.RegisterCommand('clearImageButton', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            let img = that.FroalaEditor.SELECTED_TARGET;
            clearCropImage(img)
            this.image.back();
          }
        });

        // The dialog's sizes and padding as /api/v1/image-process draws them: whole numbers within
        // the limits sent with the template (none sent: whole numbers only), or the first problem
        // and the field it is in. An empty size is the image's own, as shown.
        function readCropSizes(img, cropField, limits) {
          var maxSide = (limits && limits.maxSide) || Infinity;
          var maxPadding = (limits && limits.maxPadding) || Infinity;
          var range = function (min, max) {
            return max === Infinity ? 'of at least ' + min : 'from ' + min + ' to ' + max;
          };
          var whole = function (text) {
            var bare = text.replace(/\s*px$/i, '');
            return /^\d+$/.test(bare) ? Number(bare) : NaN;
          };
          var sizes = { padding: 0, paddingAmount: null };
          var sides = [['height', 'Height'], ['width', 'Width']];
          for (var i = 0; i < sides.length; i++) {
            var name = sides[i][0];
            var typed = cropField(name).value.trim();
            if (!typed) {
              var shown = parseInt(getComputedStyle(img)[name], 10);
              sizes[name] = shown >= 1 && shown <= maxSide ? shown : null;
            } else if (whole(typed) >= 1 && whole(typed) <= maxSide) {
              sizes[name] = whole(typed);
            } else {
              return { field: name, problem: sides[i][1] + ' must be a whole number of pixels ' + range(1, maxSide) };
            }
          }
          var paddingTyped = cropField('padding').value.trim();
          if (paddingTyped) {
            var amount = whole(paddingTyped);
            if (!(amount >= 0 && amount <= maxPadding)) {
              return { field: 'padding', problem: 'Padding must be a whole number ' + range(0, maxPadding) };
            }
            sizes.paddingAmount = amount;
            // A percentage is of the image's width, as shown.
            sizes.padding = cropField('med').value === '%'
              ? Math.round((parseInt(getComputedStyle(img).width, 10) || 0) * amount / 100)
              : amount;
            if (sizes.padding > maxPadding) {
              return { field: 'padding', problem: 'Padding of ' + amount + '% comes to ' + sizes.padding
                + ' pixels on this image, more than the ' + maxPadding + ' that can be added' };
            }
            // Contain (and Auto, which falls back to it) adds the padding around the size asked for,
            // and the result has the same limit.
            var fitValue = cropField('fit').value;
            var largest = Math.max(sizes.height || 0, sizes.width || 0);
            var room = Math.floor((maxSide - largest) / 2);
            if ((fitValue === 'contain' || fitValue === 'auto') && largest && sizes.padding > room) {
              return { field: 'padding', problem: 'Padding can be at most ' + room + ' pixels at this size: '
                + 'Contain adds it around the image, which can be at most ' + maxSide + ' pixels on a side' };
            }
          }
          return sizes;
        }

        function clearCropImage(img) {
          img.removeAttribute('data-src-crop');
          img.removeAttribute('data-src-height');
          img.removeAttribute('data-src-width');
          img.removeAttribute('data-src-position');
          img.removeAttribute('data-src-fit');
          img.removeAttribute('data-src-smart');
          img.removeAttribute('data-src-padding');
          img.removeAttribute('data-src-padding-med');
          let imageSrc = img.getAttribute('src');
          let originalUrl;
          let url = 'url'.replace(/[\[\]]/g, '\\$&');
          let regex = new RegExp('[?&]' + url + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(imageSrc);
          if (!results) return null;
          if (!results[2]) return '';
          originalUrl = decodeURIComponent(results[2].replace(/\+/g, ' '));

          if(originalUrl) {
            img.setAttribute('src',originalUrl);
          }
        }

        // Create popup.
        return editor.popups.create(customPopupName, template);
      }

      // Show the popup
      function showPopup () {
        var $popup = editor.popups.get(customPopupName);
        if (!$popup) $popup = initPopup();

        editor.popups.setContainer(customPopupName, editor.$sc);
        var $btn = editor.$sc.find('.fr-active .fr-command[data-cmd="imageVariableButton"]');
        var left = $btn.offset().left;
        var top = $btn.offset().top - (editor.opts.toolbarBottom ? 10 : ($btn.outerHeight() - 10));
        editor.popups.show(customPopupName, left, top, $btn.outerHeight());
      }

      // Hide the custom popup.
      function hidePopup () {
        editor.popups.hide(customPopupName);
      }

      // Methods visible outside the plugin.
      return {
        showPopup: showPopup,
        hidePopup: hidePopup
      }
    }

    // Define custom popup close button icon and command.
    this.FroalaEditor.RegisterCommand('popupClose', {
      title: 'Close',
      icon: 'imageBack',
      undo: false,
      focus: false,
      callback: function () {
        this.image.back();
      }
    });

    // Define an icon and command for the button that opens the custom popup.
    this.FroalaEditor.DefineIcon('cropImage', { NAME: 'crop', template: 'font_awesome'})
    this.FroalaEditor.RegisterCommand('cropImage', {
      title: 'Crop',
      icon: 'cropImage',
      undo: false,
      focus: false,
      popup: true,
      plugin: 'imageVariable',
      callback: function () {
        if (!this.popups.isVisible(customPopupName)) {
          this[customPlugin].showPopup();
          let img = that.FroalaEditor.SELECTED_TARGET;
          var cropError = document.getElementById('froala-pages').contentWindow.document.getElementById('fr-image-crop-error');
          if (cropError) cropError.style.display = 'none';
          if (img.getAttribute('data-src-crop')) {
            var iFrameEl = document.getElementById('froala-pages');
            if (img.getAttribute('data-src-height')) {
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-height').value = img.getAttribute('data-src-height');
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-height').classList.add("fr-not-empty");
            }
            if (img.getAttribute('data-src-width')) {
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-width').value = img.getAttribute('data-src-width');
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-width').classList.add("fr-not-empty");
            }
            if (img.getAttribute('data-src-position')) {
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-position').value = img.getAttribute('data-src-position');
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-position').classList.add("fr-not-empty");
            }
            if (img.getAttribute('data-src-fit')) {
              // Auto is stored as a smart crop (data-src-smart), and shown as Auto where offered.
              var fitSelect = iFrameEl.contentWindow.document.getElementById('fr-image-crop-fit');
              var smartFit = img.getAttribute('data-src-smart') === 'true' && fitSelect.querySelector('option[value="auto"]');
              fitSelect.value = smartFit ? 'auto' : img.getAttribute('data-src-fit');
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-fit').classList.add("fr-not-empty");
            }
            if (img.getAttribute('data-src-padding')) {
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-padding').value = img.getAttribute('data-src-padding');
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-padding').classList.add("fr-not-empty");
            }
            if (img.getAttribute('data-src-padding-med')) {
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-med').value = img.getAttribute('data-src-padding-med');
              iFrameEl.contentWindow.document.getElementById('fr-image-crop-med').classList.add("fr-not-empty");
            }
          }
          else if (!img.getAttribute('data-src-crop')) {
            var iFrameEl = document.getElementById('froala-pages');
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-height').value = "";
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-height').classList.remove("fr-not-empty");;
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-width').value = "";
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-width').classList.remove("fr-not-empty");;
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-position').value = "";
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-position').classList.remove("fr-not-empty");
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-fit').value = "";
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-fit').classList.remove("fr-not-empty");
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-padding').value = "";
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-padding').classList.remove("fr-not-empty");
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-med').value = "px";
            iFrameEl.contentWindow.document.getElementById('fr-image-crop-med').classList.remove("fr-not-empty");
          }
        }
        else {
          if (this.$el.find('.fr-marker')) {
            this.events.disableBlur();
            this.selection.restore();
          }
          this[customPlugin].hidePopup();
        }
      },
    });
  }

  Editor.prototype.imageBorderOptions = function imageBorderOptions() {
    this.FroalaEditor = this.page.iframeDoc.defaultView.FroalaEditor;
    var that = this;
    var customPopupName = "imgBorder.popup";
    var customPlugin = "imgBorder";
    var _this10 = this;

    // Define popup template.
    Object.assign(this.FroalaEditor.POPUP_TEMPLATES, {
      [customPopupName]: '[_BUTTONS_][_CUSTOM_LAYER_]'
    });

    // Define popup buttons.
    Object.assign(this.FroalaEditor.DEFAULTS, {
      popupButtons: ['popupClose', '-']
    });


    // The custom popup is defined inside a plugin (new or existing).
    this.FroalaEditor.PLUGINS[customPlugin] = function (editor) {
      // Create custom popup.
      function initPopup () {
        // Load popup template.
        var template = that.FroalaEditor.POPUP_TEMPLATES[customPopupName];
        if (typeof template == 'function') template = template.apply(editor);

        // Popup buttons.
        var popup_buttons = '';

        // Create the list of buttons.
        if (editor.opts.popupButtons.length > 1) {
          popup_buttons += '<div class="fr-buttons fr-tabs">';
          popup_buttons += editor.button.buildList(editor.opts.popupButtons);
          popup_buttons += '</div>';
        }

        var radius = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line pb-0" style="width: 100px"><input id="fr-border-radius" type="text" placeholder="' + editor.language.translate('Radius') + '" tabIndex="1"></div></div>';
        var size = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line pb-0" style="width: 100px"><input id="fr-border-size" type="text" placeholder="' + editor.language.translate('Size') + '" tabIndex="1" aria-required="true"></div></div>';
        var color = '<div class="fr-my-layer fr-layer fr-active" style="width: auto;margin: 10px 5px" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line fr-action-buttons pb-0" style="width: 100px; height: auto"><button id="fr-border-color-button" type="button" style="width: 100px; height: 46px" class="fr-active fr-command fr-submit borderColor mx-auto d-block" data-cmd="borderColor" data-param1="true" tabIndex="2" role="button">' + editor.language.translate('color') + '</button></div></div></div>';
        var circleCheckbox = '<div class="fr-my-layer fr-layer fr-active" style="margin: 10px 5px; width: 100%" id="fr-my-layer-' + editor.id + '"><div class="fr-input-line p-0"><span class="d-flex align-items-center" style="width: 100%"><input id="borderCircleCheck" data-cmd="borderCircleCheck" data-param1="true" class="fr-command" type="checkbox" dir="auto" value/> <label style="line-height: 1;white-space: break-spaces;word-break: break-word; position: unset; " id="imageSrcVariableCheckLabel-'+editor.id+'" data-cmd="imageSrcVariableCheck" data-param1="true" class="fr-command mb-0 pl-3">Circle</label> <span></div></div></div>';
        var clearButton = '<div class="fr-action-buttons d-flex align-items-center justify-content-end"><button type="button" class="fr-command fr-submit clearBorderButton" data-cmd="clearBorderButton" data-param1="true" tabIndex="2" role="button">' + editor.language.translate('Clear') + '</button>';
        var updateButton = '<div class="fr-action-buttons d-flex align-items-center justify-content-end"><button type="button" class="fr-command fr-submit imageBorderButton ml-3" data-cmd="imageBorderButton" data-param1="true" tabIndex="2" role="button">' + editor.language.translate('Update') + '</button></div></div></div></div>';

        var html = '<div><div class="">' +
          '<div class="d-flex align-items-center justify-content-center">'.concat(radius).concat(size).concat(color,'<div class="d-flex flex-wrap align-items-center justify-content-between px-2" style="max-width: 500px">').concat(circleCheckbox)
            .concat(clearButton).concat(updateButton)

        // Load popup template.
        template = {
          buttons: popup_buttons,
          custom_layer: html,
        };

        // Define custom popup template dropdown command
        that.FroalaEditor.RegisterCommand('imageBorderButton', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            var img = that.FroalaEditor.SELECTED_TARGET;
            var iFrameEl = document.getElementById('froala-pages');
            let radius = setValues('fr-border-radius', 'data-border-radius', img);
            let size = setValues('fr-border-size','data-border-size', img);

            if(size){
              img.style.border = `${size}px solid black`;
            }

            let imageBorderColor = iFrameEl.contentWindow.document.getElementById('fr-border-color-button').innerText;
            img.style.borderColor = imageBorderColor;
            img.style.backgroundClip = 'border-box';
            img.style.fontSize = '0';
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.boxSizing = 'border-box';
            img.setAttribute('data-border', "true");
            img.setAttribute('borderColor',imageBorderColor);

            if(img.getAttribute("circle")) {
              img.style.setProperty('border-radius', '50%', 'important');
              img.setAttribute('data-border', "true");
            } else if(radius){
              img.style.setProperty('border-radius', `${radius}px`, 'important');
              img.setAttribute('data-border', "true");
            } else {
              img.style.borderRadius = null
            }

            function setValues(id, att, img) {
              var iFrameEl = document.getElementById('froala-pages');
              let value = iFrameEl.contentWindow.document.getElementById(id).value;
              if(value) {
                img.setAttribute(att, value);
                img.setAttribute('data-border', "true");
                return value;
              }
              else{
                if(img.getAttribute(att)) {
                  img.removeAttribute(att);
                }
                return false;
              }
            }
            this.image.back();
          }
        });

        that.FroalaEditor.RegisterCommand('borderCircleCheck', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            var iFrameEl = document.getElementById('froala-pages');
            var img = that.FroalaEditor.SELECTED_TARGET;
            if(img.getAttribute('circle')) {
              img.removeAttribute('circle');
              iFrameEl.contentWindow.document.getElementById('fr-border-radius').disabled = false;
            } else {
              img.setAttribute('circle',val);
              img.setAttribute('data-border', "true");
              iFrameEl.contentWindow.document.getElementById('fr-border-radius').disabled = true;
            }
          }
        });

        that.FroalaEditor.RegisterCommand('borderColor', {
          undo: false,
          focus: false,
          popup: true,
          plugin: 'imgBorderColor',
          callback: function (cmd, val) {
            Object.assign(that.FroalaEditor.POPUP_TEMPLATES, {
              ['imgBorderColor.popup']: '[_BUTTONS_][_COLOR_LAYER_]'
            });

            // Define popup buttons.
            Object.assign(that.FroalaEditor.DEFAULTS, {
              colorPopupButtons: ['colorPopupClose', '-']
            });
            var img = that.FroalaEditor.SELECTED_TARGET;

            if (!this.popups.isVisible('imgBorderColor.popup')) {
              var $popup = editor.popups.get('imgBorderColor.popup');
              if (!$popup) $popup = initPopupBorderColor();
              editor.popups.setContainer('imgBorderColor.popup', editor.$sc);
              var $btn = editor.$sc.find('.fr-active .fr-command[data-cmd="borderColor"]');
              var left = $btn.offset().left;
              var top = $btn.offset().top - (editor.opts.toolbarBottom ? 10 : ($btn.outerHeight() - 10));
              editor.popups.show('imgBorderColor.popup', left, top, $btn.outerHeight());

              var iFrameEl = document.getElementById('froala-pages');
              if(img.getAttribute('data-border') === "true" && img.getAttribute('borderColor') && img.getAttribute('borderColor') !== "remove") {
                iFrameEl.contentWindow.document.getElementById('fr-color-hex-layer-image-border').value = img.getAttribute('borderColor');
                iFrameEl.contentWindow.document.getElementById('fr-color-hex-layer-image-border').classList.add("fr-not-empty");
              } else {
                iFrameEl.contentWindow.document.getElementById('fr-color-hex-layer-image-border').value = null;
              }
            }
            else {
              if (this.$el.find('.fr-marker')) {
                this.events.disableBlur();
                this.selection.restore();
              }
              this['imgBorderColor.popup'].hidePopup();
            }


            function initPopupBorderColor () {
              let template = that.FroalaEditor.POPUP_TEMPLATES['imgBorderColor.popup'];
              if (typeof template == 'function') template = template.apply(editor);

              // Popup buttons.
              let popup_buttons_border = '';

              // Create the list of buttons.
              if (editor.opts.colorPopupButtons.length > 1) {
                popup_buttons_border += '<div class="fr-buttons fr-tabs">';
                popup_buttons_border += editor.button.buildList(editor.opts.colorPopupButtons);
                popup_buttons_border += '</div>';
              }


              // Define Popup Template
              let colors = '';
              let count = 0;

              editor.opts.colorsText.forEach((color, index) => {
                if (color !== 'REMOVE') {
                  colors += `<span class="fr-command fr-select-color" style="background: ${color};" title="${color}" tabindex="-1" aria-selected="false" role="button" data-cmd="applyImageBorderColor" data-param1="${color}">
                      <span class="fr-sr-only"> Color ${color}</span>
                    </span>`;
                } else {
                  colors += `<span class="fr-command fr-select-color" style="background: transparent;" title="Clear Formatting" tabindex="-1" aria-selected="false" role="button" data-cmd="applyImageBorderColor" data-param1="REMOVE">
                        <svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z"></path></svg>
                        <span class="fr-sr-only"> Clear Formatting</span>
                    </span>`
                }
                count++;
                if (count === editor.opts.colorsStep) {
                  count = 0;
                  colors += '<br />'
                }
              })


              let customHexLayer = `<div class="fr-color-hex-layer fr-active fr-layer" id="fr-color-hex-layer-
                            ${editor.id}" style="width: 264px;" data-mouseenter-event-set="true">
                            <div class="fr-input-line">
                            <input maxlength="7" id="fr-color-hex-layer-image-border" type="text" placeholder="" tabindex="1" aria-required="true" dir="auto" class="fr-not-empty">
                            <label for="fr-color-hex-layer-text-image-border">HEX Color</label></div><div class="fr-action-buttons">
                            <button type="button" class="fr-command fr-submit" data-cmd="customImageBorderColor" tabindex="2" role="button">
                            OK</button></div></div>`;


              let html = `<div class="fr-color-set fr-color fr-selected-set" data-mouseenter-event-set="true">`.concat(colors).concat('</div>').concat(customHexLayer);

              // Load popup template.
              template = {
                buttons: popup_buttons_border,
                color_layer: html,
              };


              that.FroalaEditor.RegisterCommand('applyImageBorderColor', {
                undo: false,
                focus: false,
                callback: function (cmd, val) {
                  let fontColor;
                  if (val === 'REMOVE') {
                    iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.backgroundColor = "#000000";
                    iFrameEl.contentWindow.document.getElementById('fr-border-color-button').innerText = "#000000";
                    fontColor =  getFontColor('#000000');
                    iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.color = fontColor;
                  } else {
                    iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.backgroundColor = val;
                    iFrameEl.contentWindow.document.getElementById('fr-border-color-button').innerText = val;
                    fontColor =  getFontColor(val);
                    iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.color = fontColor;
                  }
                  editor.popups.hide('imgBorderColor.popup');
                  editor.popups.show(customPopupName);
                }
              });

              that.FroalaEditor.RegisterCommand('customImageBorderColor', {
                undo: false,
                focus: false,
                callback: function (cmd, val) {
                  let fontColor;
                  var iFrameEl = document.getElementById('froala-pages');
                  let customColor = iFrameEl.contentWindow.document.getElementById('fr-color-hex-layer-image-border').value;
                  if(customColor) {
                    customColor = customColor.toUpperCase();
                    iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.backgroundColor = customColor;
                    iFrameEl.contentWindow.document.getElementById('fr-border-color-button').innerText = customColor;
                    fontColor =  getFontColor(customColor);
                    iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.color = fontColor;
                  }
                  editor.popups.hide('imgBorderColor.popup');
                  editor.popups.show(customPopupName);
                }
              });

              that.FroalaEditor.RegisterCommand('colorPopupClose', {
                title: 'Close',
                icon: 'imageBack',
                undo: false,
                focus: false,
                callback: function () {
                  editor.popups.hide('imgBorderColor.popup');
                  editor.popups.show(customPopupName);
                }
              });
              return editor.popups.create('imgBorderColor.popup', template);
            }
          }
        });

        that.FroalaEditor.RegisterCommand('clearBorderButton', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            var img = that.FroalaEditor.SELECTED_TARGET;
            img.removeAttribute('data-border-radius');
            img.removeAttribute('data-border-size');
            img.removeAttribute('borderColor');
            img.removeAttribute('data-border');
            img.style.border = null;
            img.style.borderRadius = null;
            img.style.borderColor = null;
            this.image.back();
          }
        });

        // Create popup.
        return editor.popups.create(customPopupName, template);
      }

      // Show the popup
      function showPopup () {
        var $popup = editor.popups.get(customPopupName);
        if (!$popup) $popup = initPopup();

        editor.popups.setContainer(customPopupName, editor.$sc);
        var $btn = editor.$sc.find('.fr-active .fr-command[data-cmd="imageVariableButton"]');
        var left = $btn.offset().left;
        var top = $btn.offset().top - (editor.opts.toolbarBottom ? 10 : ($btn.outerHeight() - 10));
        editor.popups.show(customPopupName, left, top, $btn.outerHeight());
      }

      // Hide the custom popup.
      function hidePopup () {
        editor.popups.hide(customPopupName);
      }

      // Methods visible outside the plugin.
      return {
        showPopup: showPopup,
        hidePopup: hidePopup
      }
    }

    // Define custom popup close button icon and command.
    this.FroalaEditor.RegisterCommand('popupClose', {
      title: 'Close',
      icon: 'imageBack',
      undo: false,
      focus: false,
      callback: function () {
        this.image.back();
      }
    });

    function getFontColor(hexcolor) {
      hexcolor = hexcolor.replace('#', '');
      const r = parseInt(hexcolor.substr(0, 2), 16);
      const g = parseInt(hexcolor.substr(2, 2), 16);
      const b = parseInt(hexcolor.substr(4, 2), 16);
      const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
      return (yiq >= 128) ? '#000000' : '#ffffff';
    }

    // Define an icon and command for the button that opens the custom popup.
    this.FroalaEditor.DefineIcon('imageBorder', { NAME: 'dashcube', template: 'font_awesome'})
    this.FroalaEditor.RegisterCommand('imageBorder', {
      title: 'Image Border',
      icon: 'imageBorder',
      undo: false,
      focus: false,
      popup: true,
      plugin: 'imgBorder',
      callback: function () {
        if (!this.popups.isVisible(customPopupName)) {
          this[customPlugin].showPopup();
          var img = that.FroalaEditor.SELECTED_TARGET;
          let imgStyle = window.getComputedStyle(img);

          let fontColor;
          if (img.getAttribute('data-border')) {
            var iFrameEl = document.getElementById('froala-pages');
            iFrameEl.contentWindow.document.getElementById('fr-border-radius').value = img.getAttribute('data-border-radius');
            iFrameEl.contentWindow.document.getElementById('fr-border-radius').classList.add("fr-not-empty");
            iFrameEl.contentWindow.document.getElementById('fr-border-size').value = img.getAttribute('data-border-size');
            iFrameEl.contentWindow.document.getElementById('fr-border-size').classList.add("fr-not-empty");
            if(img.getAttribute('circle')) {
              iFrameEl.contentWindow.document.getElementById('borderCircleCheck').checked = true;
              iFrameEl.contentWindow.document.getElementById('fr-border-radius').disabled = true;
            }
            else{
              iFrameEl.contentWindow.document.getElementById('borderCircleCheck').checked = false;
              iFrameEl.contentWindow.document.getElementById('fr-border-radius').disabled = false;
            }
            if(img.getAttribute('borderColor')) {
              iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.backgroundColor = img.getAttribute('borderColor');
              iFrameEl.contentWindow.document.getElementById('fr-border-color-button').innerText = img.getAttribute('borderColor');
              fontColor =  getFontColor(img.getAttribute('borderColor'));
              iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.color = fontColor;
            } else if (!img.getAttribute('borderColor') && imgStyle && imgStyle.getPropertyValue('border-color')) {
              let borderColor = imgStyle.getPropertyValue('border-color');
              borderColor = this.helpers.RGBToHex(borderColor)
              iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.backgroundColor = borderColor;
              iFrameEl.contentWindow.document.getElementById('fr-border-color-button').innerText = borderColor;
              fontColor =  getFontColor(borderColor);
              iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.color = fontColor;
            } else {
              iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.backgroundColor = "#000000";
              iFrameEl.contentWindow.document.getElementById('fr-border-color-button').innerText = "#000000";
              fontColor =  getFontColor('#000000');
              iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.color = fontColor;
            }
          }
          else if (!img.getAttribute('data-border')) {
            var iFrameEl = document.getElementById('froala-pages');
            iFrameEl.contentWindow.document.getElementById('fr-border-radius').value = "";
            iFrameEl.contentWindow.document.getElementById('fr-border-size').value = "";
            iFrameEl.contentWindow.document.getElementById('fr-border-size').classList.remove("fr-not-empty");
            iFrameEl.contentWindow.document.getElementById('borderCircleCheck').checked = false;
            iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.backgroundColor = "#000000";
            iFrameEl.contentWindow.document.getElementById('fr-border-color-button').innerText = "#000000";
            fontColor =  getFontColor('#000000');
            iFrameEl.contentWindow.document.getElementById('fr-border-color-button').style.color = fontColor;
          }
        }
        else {
          if (this.$el.find('.fr-marker')) {
            this.events.disableBlur();
            this.selection.restore();
          }
          this[customPlugin].hidePopup();
        }
      },
    });
  }


  Editor.prototype.imageBackgroundColor = function imageBackgroundColor(variables) {
    this.FroalaEditor = this.page.iframeDoc.defaultView.FroalaEditor;
    var that = this;
    var customPopupName = "imgBackground.popup";
    var customPlugin = "imgBackground";
    var _this10 = this;

    // Define popup template.
    Object.assign(this.FroalaEditor.POPUP_TEMPLATES, {
      [customPopupName]: '[_BUTTONS_][_COLOR_LAYER_]'
    });

    // Define popup buttons.
    Object.assign(this.FroalaEditor.DEFAULTS, {
      popupButtons: ['popupClose', '-']
    });


    // The custom popup is defined inside a plugin (new or existing).
    this.FroalaEditor.PLUGINS[customPlugin] = function (editor) {
      // Create custom popup.
      function initPopup () {
        // Load popup template.
        let template = that.FroalaEditor.POPUP_TEMPLATES[customPopupName];
        if (typeof template == 'function') template = template.apply(editor);

        // Popup buttons.
        let popup_buttons = '';

        // Create the list of buttons.
        if (editor.opts.colorPopupButtons.length > 1) {
          popup_buttons += '<div class="fr-buttons fr-tabs">';
          popup_buttons += editor.button.buildList(editor.opts.colorPopupButtons);
          popup_buttons += '</div>';
        }


        // Define Popup Template
        let colors = '';
        let count = 0;

        editor.opts.colorsText.forEach((color, index) => {
          if (color !== 'REMOVE') {
            colors += `<span class="fr-command fr-select-color" style="background: ${color};" title="${color}" tabindex="-1" aria-selected="false" role="button" data-cmd="applyImageBackgroundColor" data-param1="${color}">
                      <span class="fr-sr-only"> Color ${color}</span>
                    </span>`;
          } else {
            colors += `<span class="fr-command fr-select-color" style="background: transparent;" title="Clear Formatting" tabindex="-1" aria-selected="false" role="button" data-cmd="applyImageBackgroundColor" data-param1="REMOVE">
                        <svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z"></path></svg>
                        <span class="fr-sr-only"> Clear Formatting</span>
                    </span>`
          }
          count++;
          if (count === editor.opts.colorsStep) {
            count = 0;
            colors += '<br />'
          }
        })


        let customHexLayer = `<div class="fr-color-hex-layer fr-active fr-layer" id="fr-color-hex-layer-
                            ${editor.id}" style="width: 264px;" data-mouseenter-event-set="true">
                            <div class="fr-input-line">
                            <input maxlength="7" id="fr-color-hex-layer-image-background" type="text" placeholder="" tabindex="1" aria-required="true" dir="auto" class="fr-not-empty">
                            <label for="fr-color-hex-layer-text-image-background">HEX Color</label></div><div class="fr-action-buttons">
                            <button type="button" class="fr-command fr-submit" data-cmd="customImageBackgroundColor" tabindex="2" role="button">
                            OK</button></div></div>`;


        let html = `<div class="fr-color-set fr-color fr-selected-set" data-mouseenter-event-set="true">`.concat(colors).concat('</div>').concat(customHexLayer);

        // Load popup template.
        template = {
          buttons: popup_buttons,
          color_layer: html,
        };

        that.FroalaEditor.RegisterCommand('applyImageBackgroundColor', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            var img = that.FroalaEditor.SELECTED_TARGET;
            if (val === 'REMOVE') {
              img.style.backgroundColor = null;
              img.setAttribute('back-color',"remove");
            } else {
              img.style.backgroundColor = val;
              img.setAttribute('back-color',val);
            }
            this.image.back();
          }
        });

        that.FroalaEditor.RegisterCommand('customImageBackgroundColor', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            let img = this.el.querySelector("img");
            var iFrameEl = document.getElementById('froala-pages');
            let customColor = iFrameEl.contentWindow.document.getElementById('fr-color-hex-layer-image-background').value;
            if(customColor) {
              customColor = customColor.toUpperCase();
              img.style.backgroundColor = customColor;
              img.setAttribute('back-color',customColor);
            }
            this.image.back();
          }
        });

        // Create popup.
        return editor.popups.create(customPopupName, template);
      }

      // Show the popup
      function showPopup () {
        var $popup = editor.popups.get(customPopupName);
        if (!$popup) $popup = initPopup();

        editor.popups.setContainer(customPopupName, editor.$sc);
        var $btn = editor.$sc.find('.fr-active .fr-command[data-cmd="imageBackgroundColor"]');
        var left = $btn.offset().left;
        var top = $btn.offset().top - (editor.opts.toolbarBottom ? 10 : ($btn.outerHeight() - 10));
        editor.popups.show(customPopupName, left, top, $btn.outerHeight());
      }

      // Hide the custom popup.
      function hidePopup () {
        editor.popups.hide(customPopupName);
      }

      // Methods visible outside the plugin.
      return {
        showPopup: showPopup,
        hidePopup: hidePopup
      }
    }

    // Define custom popup close button icon and command.
    this.FroalaEditor.RegisterCommand('popupClose', {
      title: 'Close',
      icon: 'imageBack',
      undo: false,
      focus: false,
      callback: function () {
        this.image.back();
      }
    });

    // Define an icon and command for the button that opens the custom popup.
    this.FroalaEditor.RegisterCommand('imageBackgroundColor', {
      title: 'Image Background',
      icon: "backgroundColor",
      undo: false,
      focus: false,
      popup: true,
      plugin: 'imageVariable',
      callback: function () {
        if (!this.popups.isVisible(customPopupName)) {
          this[customPlugin].showPopup();
          let img = this.el.querySelector("img");
          var iFrameEl = document.getElementById('froala-pages');
          if(img.getAttribute('back-color') && img.getAttribute('back-color') !== "remove" ) {
            iFrameEl.contentWindow.document.getElementById('fr-color-hex-layer-image-background').value = img.getAttribute('back-color');
          }
          else{
            iFrameEl.contentWindow.document.getElementById('fr-color-hex-layer-image-background').value = "";
          }
        }
        else {
          if (this.$el.find('.fr-marker')) {
            this.events.disableBlur();
            this.selection.restore();
          }
          this[customPlugin].hidePopup();
        }
      },
    });
  }


  Editor.prototype.customVideoVariableOptions = function customVideoVariableOptions(variables) {
    this.FroalaEditor = this.page.iframeDoc.defaultView.FroalaEditor;
    var that = this;
    var customPopupName = "videoVariable.popup";
    var customPlugin = "videoVariable";

    // Define popup template.
    Object.assign(this.FroalaEditor.POPUP_TEMPLATES, {
      [customPopupName]: '[_BUTTONS_][_CUSTOM_LAYER_]'
    });

    // Define popup buttons.
    Object.assign(this.FroalaEditor.DEFAULTS, {
      popupButtons: ['popupClose', '-']
    });


    // The custom popup is defined inside a plugin (new or existing).
    this.FroalaEditor.PLUGINS[customPlugin] = function (editor) {
      var videoSrcOptions = {
        'none': [{name: "None", key: "", valueType: ['text', 'all']}],
      };
      if (variables) {
        videoSrcOptions = {
          'none': [{name: "None", key: "", valueType: ['text', 'all']}],
          ...variables
        }
      }
      // Create custom popup.
      function initPopup () {
        // Load popup template.
        var template = that.FroalaEditor.POPUP_TEMPLATES[customPopupName];
        if (typeof template == 'function') template = template.apply(editor);

        // Popup buttons.
        var popup_buttons = '';

        // Create the list of buttons.
        if (editor.opts.popupButtons.length > 1) {
          popup_buttons += '<div class="fr-buttons fr-tabs">';
          popup_buttons += editor.button.buildList(editor.opts.popupButtons);
          popup_buttons += '</div>';
        }

        // Define Popup Template
        var dropdownButton = '<button id="videoSrcVariable-'+editor.id+'" type="button" tabindex="-1" role="button" data-cmd="videoSrcVariable" aria-controls="dropdown-menu-videoSrcVariable-'+editor.id+'" data-blur-event-set="true" aria-expanded="false" aria-haspopup="true" class="fr-command fr-btn fr-dropdown videoSrcVariable" style="display: flex;align-items: center;" data-title="Video Source">';
        dropdownButton += editor.icon.create('variables');
        dropdownButton += '<span class="d-none" style="margin-left: -5px"></span>';
        dropdownButton += '</button>';

        var dropdownHtml = '<div id="dropdown-menu-videoSrcVariable-'+editor.id+'" class="fr-dropdown-menu" role="listbox" aria-labelledby="videoSrcVariable-'+editor.id+'" aria-hidden="true">';
        dropdownHtml += '<div class="fr-dropdown-wrapper" role="presentation"><div class="fr-dropdown-content" role="presentation">';
        dropdownHtml += '<ul class="fr-dropdown-list" role="presentation">';

        Object.keys(videoSrcOptions).forEach(groups => {
          let variableList = videoSrcOptions[groups].filter(item => (item.valueType.includes('all') || item.valueType.includes('video')) && !item.valueType.includes('ignore'));
          if (variableList.length > 0) {
            if (groups !== 'none') {
              // onclick="this.parentElement.parentElement.parentElement.style.height = `275px`;this.parentElement.parentElement.parentElement.parentElement.style.overflow = `auto`;"
              dropdownHtml += '<li>';
              dropdownHtml += '<a style="font-weight: bolder;cursor: default;text-transform: capitalize;pointer-events: none" title="'+groups+'">'+groups+'</a>';
              dropdownHtml += '</li>';
            }
            let style = groups !== "none" ? "padding: 0 30px; text-transform: capitalize;" : "text-transform: capitalize;";
            variableList.forEach(item => {
              let showName = item.name.toString().toLowerCase().trim();
              if (groups !== "none") {
                showName = showName.replace(groups.toString().toLowerCase().trim(), '');
              }
              dropdownHtml += '<li role="presentation">';
              dropdownHtml += '<a style="'+style+'" class="fr-command" tabindex="-1" role="option" data-cmd="videoSrcVariable" data-param1="'+item.key+'" title="'+item.name+'">'+showName+'</a>';
              dropdownHtml += '</li>';
            })
          }
        })

        dropdownHtml += '</ul></div></div></div>';

        var checkBoxHtml = '<span style="text-align: left"><div class="fr-checkbox-line fr-autoplay-margin videoSrcVariableCheck">';
        checkBoxHtml += '<span class="fr-checkbox"><input id="videoSrcVariableCheck-'+editor.id+'" data-cmd="videoSrcVariableCheck" data-param1="true" class="fr-command" type="checkbox" dir="auto" value/><span><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg></span></span>';
        checkBoxHtml += '<label style="line-height: 1;white-space: break-spaces;word-break: break-word;" id="videoSrcVariableCheckLabel-'+editor.id+'" data-cmd="videoSrcVariableCheck" data-param1="true" class="fr-command">Show the uploaded video when the selected dynamic video is not available</label></div></span>';

        var html = '<div class="fr-video-variable-layer fr-layer fr-active fr-buttons m-0 w-auto"><div class="d-flex align-items-center">'.concat(dropdownButton).concat(dropdownHtml).concat(checkBoxHtml, '</div>').concat('</div>');
        // Load popup template.
        template = {
          buttons: popup_buttons,
          custom_layer: html,
        };

        // Define custom popup template dropdown command
        that.FroalaEditor.RegisterCommand('videoSrcVariable', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            let video = this.el.querySelector("video");
            let button = this.$sc.find('.videoSrcVariable');
            let span = button[0].querySelector('span');
            if (val.trim()) {
              video.setAttribute('data-src-variable', val);
              let newOptions = [];
              Object.keys(videoSrcOptions).forEach(group => {
                newOptions = [...newOptions, ...videoSrcOptions[group]];
              });
              let option = newOptions.find(item => item.key === val);
              if (option) {
                span.innerHTML = option.name;
                span.classList.remove('d-none');
              }
            } else {
              video.removeAttribute('data-src-variable');
              span.innerHTML = '';
              span.classList.add('d-none');
            }
          }
        });

        that.FroalaEditor.RegisterCommand('popupClose', {
          title: 'Close',
          icon: 'imageBack',
          undo: false,
          focus: false,
          callback: function () {
            this[customPlugin].back();
          }
        });

        // Define custom popup template checkbox command
        that.FroalaEditor.RegisterCommand('videoSrcVariableCheck', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            let video = this.el.querySelector("video");
            if (video.getAttribute('data-src-visibility')) {
              video.removeAttribute('data-src-visibility');
            } else {
              video.setAttribute('data-src-visibility', val);
            }
          }
        });

        // Create popup.
        return editor.popups.create(customPopupName, template);
      }

      // Set default value according to attributes
      function checkElementForData(instance, popup) {
        let video = instance.el.querySelector("video");
        let value = video.getAttribute('data-src-visibility');
        let checkboxVariable = popup.find('.videoSrcVariableCheck input');
        checkboxVariable[0].checked = !!value;

        value = video.getAttribute('data-src-variable');
        let button = popup.find('.videoSrcVariable');
        let span = button[0].querySelector('span');
        if (value) {
          let newOptions = [];
          Object.keys(videoSrcOptions).forEach(group => {
            newOptions = [...newOptions, ...videoSrcOptions[group]];
          });
          let option = newOptions.find(item => item.key === value);
          if (option) {
            span.innerHTML = option.name;
            span.classList.remove('d-none');
          }
        } else {
          span.innerHTML = '';
          span.classList.add('d-none');
        }
      }

      // Show the popup
      function showPopup () {
        var $popup = editor.popups.get(customPopupName);
        if (!$popup) $popup = initPopup();

        editor.popups.onShow(customPopupName, function() {
          checkElementForData(this, $popup);
        });

        editor.popups.setContainer(customPopupName, editor.$sc);
        var $btn = editor.$sc.find('.fr-active .fr-command[data-cmd="videoVariableButton"]');
        var left = $btn.offset().left;
        var top = $btn.offset().top - (editor.opts.toolbarBottom ? 10 : ($btn.outerHeight() - 10));
        editor.popups.show(customPopupName, left, top, $btn.outerHeight());
      }

      // Hide the custom popup.
      function hidePopup () {
        editor.popups.hide(customPopupName);
      }

      // Methods visible outside the plugin.
      return {
        showPopup: showPopup,
        hidePopup: hidePopup,
        back: function back() {
          editor.events.disableBlur();
          editor.selection.restore();
          editor.popups.hide(customPopupName);
        }
      }
    }


    // Define an icon and command for the button that opens the custom popup.
    this.FroalaEditor.DefineIcon('videoVariableButton', { NAME: 'cog', template: 'font_awesome'})
    this.FroalaEditor.RegisterCommand('videoVariableButton', {
      title: 'Use Variable',
      icon: 'imageVariableButton',
      undo: false,
      focus: false,
      popup: true,
      plugin: 'videoVariable',
      callback: function () {
        if (!this.popups.isVisible(customPopupName)) {
          this[customPlugin].showPopup();
        }
        else {
          if (this.$el.find('.fr-marker')) {
            this.events.disableBlur();
            this.selection.restore();
          }
          this[customPlugin].hidePopup();
        }
      }
    });
  }




  Editor.prototype.customPastePlugin = function customPastePlugin() {
    this.FroalaEditor = this.page.iframeDoc.defaultView.FroalaEditor;
    var that = this;
    var customPlugin = "customPaste";
    var customPopupName = "customPaste.popup";

    // Define popup template.
    Object.assign(this.FroalaEditor.POPUP_TEMPLATES, {
      [customPopupName]: '[_BUTTONS_][_CUSTOM_LAYER_]'
    });

    // Define popup buttons.
    Object.assign(this.FroalaEditor.DEFAULTS, {
      pastePopupButtons: ['pastePopupClose', '-']
    });

    this.FroalaEditor.PLUGINS[customPlugin] = function (editor) {

      let pasteContent = null;
      // Show the popup
      function showPopup (e) {
        pasteContent = e;
        var $popup = editor.popups.get(customPopupName);
        if (!$popup) $popup = initPopup();

        var targetElement = editor.position.getBoundingRect();
        editor.popups.setContainer(customPopupName, editor.$sc);
        var left = targetElement.left;
        var top = targetElement.top + targetElement.height;
        editor.popups.show(customPopupName, left, top, targetElement.height);
      }

      // Hide the custom popup.
      function hidePopup () {
        editor.popups.hide(customPopupName);
      }

      // Create custom popup.
      function initPopup() {
        // Load popup template.
        var template = that.FroalaEditor.POPUP_TEMPLATES[customPopupName];
        if (typeof template == 'function') template = template.apply(editor);

        // Popup buttons.
        var popup_buttons = '';

        // Create the list of buttons.
        if (editor.opts.pastePopupButtons.length > 1) {
          popup_buttons += '<div class="fr-buttons fr-tabs">';
          popup_buttons += editor.button.buildList(editor.opts.pastePopupButtons);
          popup_buttons += '</div>';
        }

        // Define Popup Template
        var cleanPasteButton = '<button id="pasteCleanButton-'+editor.id+'" type="button" tabindex="-1" role="button" data-cmd="pasteCleanButton" data-blur-event-set="true" class="fr-command fr-btn pasteCleanButton" style="display: flex;align-items: center;margin-right: 10px;border: 1px solid #00000038; padding: 10px;" data-title="Clean formatting">';
        cleanPasteButton += 'Clear formatting';
        cleanPasteButton += '</button>';

        var pasteKeepFormatButton = '<button id="pasteKeepButton-'+editor.id+'" type="button" tabindex="-1" role="button" data-cmd="pasteKeepButton" data-blur-event-set="true" class="fr-command fr-btn pasteKeepButton" style="display: flex;align-items: center;border: 1px solid #00000038; padding: 10px;" data-title="Keep formatting">';
        pasteKeepFormatButton += 'Keep formatting';
        pasteKeepFormatButton += '</button>';

        var html = '<div class="fr-image-variable-layer fr-layer fr-active fr-buttons m-0 w-auto"><div class="d-flex align-items-center">'.concat(cleanPasteButton).concat(pasteKeepFormatButton).concat('</div>');

        // Load popup template.
        template = {
          buttons: popup_buttons,
          custom_layer: html,
        };

        that.FroalaEditor.RegisterCommand('pasteCleanButton', {
          title: 'Paste Clean',
          undo: true,
          focus: false,
          callback: function(cmd) {
            let pasteData = that.FroalaEditor.PASTE_DATA;
            let content = pasteData['text/plain'];
            this.html.insert(content.replace(/<[^>]*>?/g, ''), true);
            hidePopup();
          }
        })

        that.FroalaEditor.RegisterCommand('pasteKeepButton', {
          title: 'Paste With Formatting',
          undo: true,
          focus: false,
          callback: function(cmd) {
            let pasteData = that.FroalaEditor.PASTE_DATA
            let content = ''
            if (pasteData['text/html']) {
              content = pasteData['text/html'];
              content = content.replaceAll('background-color: rgb(255, 255, 255);','');
            } else {
              content = pasteData['text/plain'];
              content = content.replaceAll('background-color: rgb(255, 255, 255);','');
            }
            this.html.insert(content, false);
            hidePopup();
          }
        })

        return editor.popups.create(customPopupName, template);
      }

      return {
        _init: function _init() {
          editor.events.on('paste.before', function(e) {
            return showPopup(e);
          })
        },
        showPopup,
        hidePopup,
        back: function back() {
          editor.events.disableBlur();
          editor.selection.restore();
          editor.popups.hide(customPopupName);
        }
      }
    }

    // Define custom popup close button icon and command.
    this.FroalaEditor.RegisterCommand('pastePopupClose', {
      title: 'Close',
      icon: 'imageBack',
      undo: false,
      focus: false,
      callback: function () {
        this.customPaste.back();
      }
    });
  }

  Editor.prototype.customColorPickerButtonPlugin = function customColorPickerButtonPlugin() {
    this.FroalaEditor = this.page.iframeDoc.defaultView.FroalaEditor;
    var that = this;
    var customPlugin = "customButtonColorPicker";
    var customPopupNameText = "customButtonColorText.picker";
    var customPopupNameBackground = "customButtonColorBackground.picker";
    var customPopupNameBackgroundHover = "customButtonColorBackgroundHover.picker";
    var customPopupNameBorder = "customButtonColorBorder.picker";

    // Define popup template.
    Object.assign(this.FroalaEditor.POPUP_TEMPLATES, {
      [customPopupNameText]: '[_BUTTONS_][_COLOR_LAYER_][_CUSTOM_COLOR_LAYER_]',
      [customPopupNameBackground]: '[_BUTTONS_][_COLOR_LAYER_][_CUSTOM_COLOR_LAYER_]',
      [customPopupNameBackgroundHover]: '[_BUTTONS_][_COLOR_LAYER_][_CUSTOM_COLOR_LAYER_]',
      [customPopupNameBorder]: '[_BUTTONS_][_COLOR_LAYER_][_CUSTOM_COLOR_LAYER_]'
    });

    // Define popup buttons.
    Object.assign(this.FroalaEditor.DEFAULTS, {
      colorPopupButtons: ['colorPopupClose', '-']
    });

    this.FroalaEditor.PLUGINS[customPlugin] = function (editor) {

      function getPopupName(type) {
        if (type === 'text') {
          return customPopupNameText;
        } else if (type === 'background') {
          return customPopupNameBackground
        } else if (type === 'backgroundHover') {
          return customPopupNameBackgroundHover
        } else if (type === 'border') {
          return customPopupNameBorder
        }
      }

      // Show the popup
      function showPopup (type) {
        var $popup = editor.popups.get(getPopupName(type));
        if (!$popup) $popup = initPopup(type);

        var targetElement = editor.position.getBoundingRect();
        editor.popups.setContainer(getPopupName(type), editor.$sc);
        var left = targetElement.left;
        var top = targetElement.top + targetElement.height;
        editor.popups.show(getPopupName(type), left, top, targetElement.height);
      }

      // Hide the custom popup.
      function hidePopup (type) {
        editor.popups.hide(getPopupName(type));
      }

      // Create custom popup.
      function initPopup(type) {
        // Load popup template.
        var template = that.FroalaEditor.POPUP_TEMPLATES[getPopupName(type)];
        if (typeof template == 'function') template = template.apply(editor);

        // Popup buttons.
        var popup_buttons = '';

        // Create the list of buttons.
        if (editor.opts.colorPopupButtons.length > 1) {
          popup_buttons += '<div class="fr-buttons fr-tabs">';
          popup_buttons += editor.button.buildList(editor.opts.colorPopupButtons);
          popup_buttons += '</div>';
        }

        // Define Popup Template
        var colors = '';
        var count = 0;
        editor.opts.colorsText.forEach((color, index) => {
          if (color !== 'REMOVE') {
            colors += `<span class="fr-command fr-select-color" style="background: ${color};" title="${color}" tabindex="-1" aria-selected="false" role="button" data-cmd="applyButton${type}Color" data-param1="${color}">
                      <span class="fr-sr-only"> Color ${color}</span>
                    </span>`;
          } else {
            colors += `<span class="fr-command fr-select-color" style="background: transparent;" title="Clear Formatting" tabindex="-1" aria-selected="false" role="button" data-cmd="applyButton${type}Color" data-param1="REMOVE">
                        <svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z"></path></svg>
                        <span class="fr-sr-only"> Clear Formatting</span>
                    </span>`
          }
          count++;
          if (count === editor.opts.colorsStep) {
            count = 0;
            colors += '<br />'
          }
        })

        var customHexLayer = `<div class="fr-color-hex-layer fr-active fr-layer" id="fr-color-hex-layer-
                            ${editor.id}" style="width: 264px;" data-mouseenter-event-set="true">
                            <div class="fr-input-line">
                            <input maxlength="7" id="fr-color-hex-layer-${type}-${editor.id}" type="text" placeholder="" tabindex="1" aria-required="true" dir="auto" class="fr-not-empty">
                            <label for="fr-color-hex-layer-text-${editor.id}">HEX Color</label></div><div class="fr-action-buttons">
                            <button type="button" class="fr-command fr-submit" data-cmd="custom${type}Color" tabindex="2" role="button">
                            OK</button></div></div>`;


        var html = `<div class="fr-color-set fr-${type}-color fr-selected-set" data-mouseenter-event-set="true">`.concat(colors).concat('</div>');

        // Load popup template.
        template = {
          buttons: popup_buttons,
          color_layer: html,
          custom_color_layer: editor.opts.colorsHEXInput ? customHexLayer : ''
        };

        that.FroalaEditor.RegisterCommand('customtextColor', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            var popup = editor.popups.get(getPopupName('text'));
            val = popup.find(`#fr-color-hex-layer-text-${editor.id}`).val();
            if (val && val.trim()) {
              let element;
              if (that.FroalaEditor.SELECTED_TARGET.tagName === 'A') {
                element = that.FroalaEditor.SELECTED_TARGET;
              } else {
                element = that.FroalaEditor.SELECTED_TARGET.parentElement.closest('a');
              }
              if (val === 'REMOVE') {
                element.style.color = null;
              } else {
                element.style.setProperty('color', this.helpers.HEXtoRGB(val));
              }
              popup.find(`#fr-color-hex-layer-text-${editor.id}`).val('')
              this.link.back();
            }
          }
        });

        that.FroalaEditor.RegisterCommand('custombackgroundColor', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            var popup = editor.popups.get(getPopupName('background'));
            val = popup.find(`#fr-color-hex-layer-background-${editor.id}`).val();
            if (val && val.trim()) {
              let element;
              if (that.FroalaEditor.SELECTED_TARGET.tagName === 'A') {
                element = that.FroalaEditor.SELECTED_TARGET;
              } else {
                element = that.FroalaEditor.SELECTED_TARGET.parentElement.closest('a');
              }
              if (val === 'REMOVE') {
                element.style.backgroundColor = null;
                // element.style.borderColor = null;
              } else {
                element.style.setProperty('background-color', this.helpers.HEXtoRGB(val));
                // element.style.setProperty('border-color', this.helpers.HEXtoRGB(val));
                element.style.backgroundImage = null;
                element.style.backgroundPosition = null;
                element.style.backgroundSize = null;
                element.style.backgroundRepeat = null;
                element.style.backgroundAttachment = null;
                element.style.backgroundOrigin = null;
                element.style.backgroundClip = null;
              }
              popup.find(`#fr-color-hex-layer-background-${editor.id}`).val('');
              this.link.back();
            }
          }
        });

        that.FroalaEditor.RegisterCommand('custombackgroundHoverColor', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            var popup = editor.popups.get(getPopupName('backgroundHover'));
            val = popup.find(`#fr-color-hex-layer-backgroundHover-${editor.id}`).val();
            if (val && val.trim()) {
              let element;
              if (that.FroalaEditor.SELECTED_TARGET.tagName === 'A') {
                element = that.FroalaEditor.SELECTED_TARGET;
              } else {
                element = that.FroalaEditor.SELECTED_TARGET.parentElement.closest('a');
              }
              if (val === 'REMOVE') {
                element.removeAttribute('onmouseover');
                element.removeAttribute('onmouseout');
              } else {
                val = this.helpers.HEXtoRGB(val)
                // this.setAttribute('data-old-border-color', this.style.borderColor);this.style.setProperty('border-color', '${val}');
                let hover = `this.setAttribute('data-old-color', this.style.backgroundColor);this.style.setProperty('background-color', '${val}');`;
                element.setAttribute('onmouseover', hover);
                // let oldBorderColor = this.getAttribute('data-old-border-color');this.removeAttribute('data-old-border-color');this.style.setProperty('border-color', oldBorderColor);
                let removeHover = `let oldBackgroundColor = this.getAttribute('data-old-color');this.removeAttribute('data-old-color');;this.style.setProperty('background-color', oldBackgroundColor)`;
                element.setAttribute('onmouseout', removeHover);
              }
              popup.find(`#fr-color-hex-layer-backgroundHover-${editor.id}`).val('')
              this.link.back();
            }
          }
        });

        that.FroalaEditor.RegisterCommand('customborderColor', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            var popup = editor.popups.get(getPopupName('border'));
            val = popup.find(`#fr-color-hex-layer-border-${editor.id}`).val();
            if (val && val.trim()) {
              let element;
              if (that.FroalaEditor.SELECTED_TARGET.tagName === 'A') {
                element = that.FroalaEditor.SELECTED_TARGET;
              } else {
                element = that.FroalaEditor.SELECTED_TARGET.parentElement.closest('a');
              }
              if (val === 'REMOVE') {
                element.style.borderColor = null;
              } else {
                element.style.setProperty('border-color', this.helpers.HEXtoRGB(val));
              }
              popup.find(`#fr-color-hex-layer-border-${editor.id}`).val('')
              this.link.back();
            }
          }
        });

        that.FroalaEditor.RegisterCommand('applyButtontextColor', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            let element;
            if (that.FroalaEditor.SELECTED_TARGET.tagName === 'A') {
              element = that.FroalaEditor.SELECTED_TARGET;
            } else {
              element = that.FroalaEditor.SELECTED_TARGET.parentElement.closest('a');
            }
            if (val === 'REMOVE') {
              element.style.color = null;
            } else {
              element.style.setProperty('color', this.helpers.HEXtoRGB(val));
            }
            this.link.back();
          }
        });

        that.FroalaEditor.RegisterCommand('applyButtonbackgroundColor', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            let element;
            if (that.FroalaEditor.SELECTED_TARGET.tagName === 'A') {
              element = that.FroalaEditor.SELECTED_TARGET;
            } else {
              element = that.FroalaEditor.SELECTED_TARGET.parentElement.closest('a');
            }
            if (val === 'REMOVE') {
              element.style.backgroundColor = null;
              // element.style.borderColor = null;
            } else {
              element.style.setProperty('background-color', this.helpers.HEXtoRGB(val));
              // element.style.setProperty('border-color', this.helpers.HEXtoRGB(val));
              element.style.backgroundImage = null;
              element.style.backgroundPosition = null;
              element.style.backgroundSize = null;
              element.style.backgroundRepeat = null;
              element.style.backgroundAttachment = null;
              element.style.backgroundOrigin = null;
              element.style.backgroundClip = null;
            }
            this.link.back();
          }
        });

        that.FroalaEditor.RegisterCommand('applyButtonbackgroundHoverColor', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            let element;
            if (that.FroalaEditor.SELECTED_TARGET.tagName === 'A') {
              element = that.FroalaEditor.SELECTED_TARGET;
            } else {
              element = that.FroalaEditor.SELECTED_TARGET.parentElement.closest('a');
            }
            if (val === 'REMOVE') {
              element.removeAttribute('onmouseover');
              element.removeAttribute('onmouseout');
            } else {
              val = this.helpers.HEXtoRGB(val)
              // this.setAttribute('data-old-border-color', this.style.borderColor);this.style.setProperty('border-color', '${val}');
              let hover = `this.setAttribute('data-old-color', this.style.backgroundColor);this.style.setProperty('background-color', '${val}');`;
              element.setAttribute('onmouseover', hover);
              // let oldBorderColor = this.getAttribute('data-old-border-color');this.removeAttribute('data-old-border-color');this.style.setProperty('border-color', oldBorderColor);
              let removeHover = `let oldBackgroundColor = this.getAttribute('data-old-color');this.removeAttribute('data-old-color');;this.style.setProperty('background-color', oldBackgroundColor)`;
              element.setAttribute('onmouseout', removeHover);
            }
            this.link.back();
          }
        });

        that.FroalaEditor.RegisterCommand('applyButtonborderColor', {
          undo: false,
          focus: false,
          callback: function (cmd, val) {
            let element;
            if (that.FroalaEditor.SELECTED_TARGET.tagName === 'A') {
              element = that.FroalaEditor.SELECTED_TARGET;
            } else {
              element = that.FroalaEditor.SELECTED_TARGET.parentElement.closest('a');
            }
            if (val === 'REMOVE') {
              element.style.borderColor = null;
            } else {
              element.style.setProperty('border-color', this.helpers.HEXtoRGB(val));
            }
            this.link.back();
          }
        });

        return editor.popups.create(getPopupName(type), template);
      }

      return {
        showPopup,
        hidePopup,
        getPopupName
      }
    }

    // Define custom popup close button icon and command.
    this.FroalaEditor.RegisterCommand('colorPopupClose', {
      title: 'Close',
      icon: 'imageBack',
      undo: false,
      focus: false,
      callback: function () {
        this.link.back();
      }
    });

    // Define an icon and command for the button that opens the custom popup.
    this.FroalaEditor.RegisterCommand('textColorButton', {
      title: 'Text Color',
      icon: 'textColor',
      undo: false,
      focus: true,
      refreshOnCallback: true,
      popup: true,
      callback: function () {
        if (!this.popups.isVisible(this[customPlugin].getPopupName('text'))) {
          this[customPlugin].showPopup('text');
        }
        else {
          if (this.$el.find('.fr-marker')) {
            this.events.disableBlur();
            this.selection.restore();
          }
          this[customPlugin].hidePopup('text');
        }
      }
    });

    // Define an icon and command for the button that opens the custom popup.
    this.FroalaEditor.RegisterCommand('backgroundColorButton', {
      title: 'Background Color',
      icon: 'backgroundColor',
      undo: false,
      focus: true,
      refreshOnCallback: true,
      popup: true,
      callback: function () {
        if (!this.popups.isVisible(this[customPlugin].getPopupName('background'))) {
          this[customPlugin].showPopup('background');
        }
        else {
          if (this.$el.find('.fr-marker')) {
            this.events.disableBlur();
            this.selection.restore();
          }
          this[customPlugin].hidePopup('background');
        }
      }
    });

    this.FroalaEditor.DefineIcon('paintBrush', {
      name: 'paintBrush',
      template: 'svg',
      SVG_KEY: 'inlineStyle'
    });

    // Define an icon and command for the button that opens the custom popup.
    this.FroalaEditor.RegisterCommand('backgroundHoverColorButton', {
      title: 'Button Hover Color',
      icon: 'paintBrush',
      undo: false,
      focus: true,
      refreshOnCallback: true,
      popup: true,
      callback: function () {
        if (!this.popups.isVisible(this[customPlugin].getPopupName('backgroundHover'))) {
          this[customPlugin].showPopup('backgroundHover');
        }
        else {
          if (this.$el.find('.fr-marker')) {
            this.events.disableBlur();
            this.selection.restore();
          }
          this[customPlugin].hidePopup('backgroundHover');
        }
      }
    });

    this.FroalaEditor.DefineIcon('borderIcon', {
      name: 'borderIcon',
      template: 'svg',
      SVG_KEY: 'inlineClass'
    });

    // Define an icon and command for the button that opens the custom popup.
    this.FroalaEditor.RegisterCommand('backgroundBorderButton', {
      title: 'Button Border Color',
      icon: 'borderIcon',
      undo: false,
      focus: true,
      refreshOnCallback: true,
      popup: true,
      callback: function () {
        if (!this.popups.isVisible(this[customPlugin].getPopupName('border'))) {
          this[customPlugin].showPopup('border');
        }
        else {
          if (this.$el.find('.fr-marker')) {
            this.events.disableBlur();
            this.selection.restore();
          }
          this[customPlugin].hidePopup('border');
        }
      }
    });
  }

  Editor.prototype._defineFontButtons = function _defineFontButtons() {
    var that = this;
    this.FroalaEditor.RegisterCommand('buttonFontSize', {
      type: 'dropdown',
      title: 'Font Size',
      icon: 'fontSize',
      displaySelection: function (e) {
        return e.opts.fontSizeSelection
      },
      displaySelectionWidth: 30,
      defaultSelection: function (e) {
        return e.opts.fontSizeDefaultSelection
      },
      html: function () {
        for (var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.fontSize, n = 0; n < t.length; n++) {
          var r = t[n];
          e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="buttonFontSize" data-param1="'.concat(r).concat(this.opts.fontSizeUnit, '" title="').concat(r, '">').concat(r, "</a></li>")
        }
        return e += "</ul>"
      },
      callback: function (e, t) {
        let element;
        if (that.FroalaEditor.SELECTED_TARGET.tagName === 'A') {
          element = that.FroalaEditor.SELECTED_TARGET;
        } else {
          element = that.FroalaEditor.SELECTED_TARGET.parentElement.closest('a');
        }
        element.style.setProperty('font-size', t, 'important');
      },
      refresh: function (e) {
        this.fontSize.refresh(e)
      },
      refreshOnShow: function (e, t) {
        this.fontSize.refreshOnShow(e, t)
      },
      plugin: "fontSize"
    });
  };

  Editor.prototype._replaceImageSourceWithBase64 = function _replaceImageSourceWithBase64(editor) {
    // let events = ['image.inserted', 'image.replaced'];
    // events.forEach(event => {
    //   editor.events.on(event, function (imageEl) {
    //     imageEl = imageEl[0];
    //
    //     var request = new XMLHttpRequest();
    //
    //     request.responseType = 'blob';
    //     request.onreadystatechange = function () {
    //       if (request.readyState === 4) {
    //         if (request.status === 200) {
    //           var reader = new FileReader();
    //
    //           reader.readAsDataURL(request.response);
    //           reader.onloadend = function () {
    //             imageEl.src = reader.result;
    //           };
    //         }
    //       }
    //     };
    //     request.open('GET', imageEl.src, true);
    //     request.send();
    //   });
    // })
  };

  return Editor;
}(Module);

// Block placeholders.

var EmptyBlock = function (_M) {
  inherits(EmptyBlock, _M);

  function EmptyBlock() {
    classCallCheck(this, EmptyBlock);
    return possibleConstructorReturn(this, _M.apply(this, arguments));
  }

  EmptyBlock.prototype.init = function init(info) {
    var _this2 = this;

    // Set info about the block.
    this.name = info.name;
    this.template = info.template;

    var el = this.doc.createElement('DIV');
    el.classList.add('fp-no-block', 'fp-no-' + this.name.toLowerCase());
    el.setAttribute('data-fp', 'true');
    el.innerHTML = this.template;
    this.el = el;

    this.events.on(el, 'click', function () {
      return _this2.click();
    });
    this.events.on(el, 'mouseenter', function () {
      return _this2._mouseEnter();
    });
  };

  // Block on empty block.


  EmptyBlock.prototype.click = function click() {
    this.events.emit('emptyBlock.click', this);
  };

  // Mouse enter on empty block.


  EmptyBlock.prototype._mouseEnter = function _mouseEnter() {
    this.page.blockToolbar.hide();
  };

  return EmptyBlock;
}(Module);

EmptyBlock.HEADER = {
  name: 'Headers',
  template: '<p>Header</p>'
};

EmptyBlock.FOOTER = {
  name: 'Footers',
  template: '<p>Footer</p>'
};

EmptyBlock.SECTION = {
  name: 'Sections',
  template: '<h1>Blank Website</h1><p>(click to add a design block)</p>'
};

// Events.
var Events = function () {
  function Events() {
    classCallCheck(this, Events);

    // DOM events.
    this.domEvents = {};

    // Internal events.
    this.internalEvents = {};
  }

  // Set an ID for events.


  Events.prototype._id = function _id(el) {
    if (!this._ids) {
      this._ids = {};
    }

    if (this._ids[el]) {
      return this._ids[el];
    }

    this._ids[el] = Object.keys(this._ids).length + 1;

    return this._ids[el];
  };

  // Bind DOM event.


  Events.prototype.on = function on(el, events, callback) {
    var _this = this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    events.split(' ').forEach(function (event) {
      var id = _this._id(el);

      if (!_this.domEvents[id]) {
        _this.domEvents[id] = {};
      }

      if (!_this.domEvents[id][event]) {
        _this.domEvents[id][event] = [];
      }

      _this.domEvents[id][event].push({
        callback: callback,
        options: options
      });

      el.addEventListener(event, callback, options);
    });
  };

  // Turn off DOM event.


  Events.prototype.off = function off(el, events) {
    var _this2 = this;

    events.split(' ').forEach(function (event) {
      var id = _this2._id(el);

      if (_this2.domEvents[id] && _this2.domEvents[id][event]) {
        _this2.domEvents[id][event].forEach(function (info) {
          el.removeEventListener(event, info.callback, info.options);
        });
      }
    });
  };

  // Bind DOM event for a single time.


  Events.prototype.once = function once(el, events, callback) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    options.once = true;

    this.on(el, events, callback, options);
  };

  // Listen to internal event.


  Events.prototype.listen = function listen(events, callback) {
    var _this3 = this;

    events.split(' ').forEach(function (event) {
      if (!_this3.internalEvents[event]) {
        _this3.internalEvents[event] = [];
      }

      _this3.internalEvents[event].push(callback);
    });
  };

  // Emit internal event.


  Events.prototype.emit = function emit(event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (this.internalEvents[event]) {
      this.internalEvents[event].forEach(function (callback) {
        callback.apply(undefined, args);
      });
    }
  };

  return Events;
}();

// Popup with share options.

var SharePopup = function (_M) {
  inherits(SharePopup, _M);

  function SharePopup() {
    classCallCheck(this, SharePopup);
    return possibleConstructorReturn(this, _M.apply(this, arguments));
  }

  SharePopup.prototype.init = function init() {
    this.shareUrl = 'https://froala.com/pages';
    this.shareText = 'Share your Froala Pages project and get your friends to build with Froala Pages for free!';
    // DOM.
    this.el = Helpers.createElement('<div class="fp-share-popup-wrap fp-hidden"><div class="fp-share-popup">\n      <div class="fp-popup-close-toolbar"><span>Share with:</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" fill="#2196f3" width="20"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/></svg></div>\n        <div class="fp-popup-text-row">\n          <span class="twitter-share"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="twitter-square" class="svg-inline--fa fa-twitter-square fa-w-14" role="img" viewBox="0 0 448 512" width="40"><path fill="#1da1f2" d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5 0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447 0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z"/></svg></span>\n          <span class="fb-share"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="facebook-square" class="svg-inline--fa fa-facebook-square fa-w-14" role="img" viewBox="0 0 448 512" width="40"><path fill="#4267b2" d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"/></svg></span>\n          <span class="li-share"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="linkedin" class="svg-inline--fa fa-linkedin fa-w-14" role="img" viewBox="0 0 448 512" width="40"><path fill="#0077b5" d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"/></svg></span>\n          <span class="mail-share"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="at" class="svg-inline--fa fa-at fa-w-16" role="img" viewBox="0 0 512 512" width="40"><path fill="#006fc1" d="M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"/></svg></span>\n        </div>\n      </div></div>');
    Helpers.append(this.page.selector, this.el);
    this._bindButtonEvents();
  };

  SharePopup.prototype.show = function show() {
    this.el.classList.remove('fp-hidden');
  };

  SharePopup.prototype.hide = function hide() {
    this.el.classList.add('fp-hidden');
  };

  SharePopup.prototype._shareWithTwitter = function _shareWithTwitter() {
    this._openChildWindow('http://twitter.com/share?url=' + this.shareUrl + '&text=' + this.shareText);
  };

  SharePopup.prototype._shareWithFb = function _shareWithFb() {
    this._openChildWindow('https://www.facebook.com/sharer/sharer.php?u=' + this.shareUrl + '&quote=' + this.shareText);
  };

  SharePopup.prototype._shareWithLinkedIn = function _shareWithLinkedIn() {
    this._openChildWindow('https://www.linkedin.com/shareArticle?mini=true&url=' + this.shareUrl + '&summary=' + this.shareText);
  };

  SharePopup.prototype._shareWithMail = function _shareWithMail() {
    window.open('mailto:?body=' + this.shareText + ' ' + this.shareUrl, null);
  };

  SharePopup.prototype._bindButtonEvents = function _bindButtonEvents() {
    var _this2 = this;

    var closeButton = this.el.querySelector('.fp-popup-close-toolbar svg');
    var twitterShareButton = this.el.querySelector('.twitter-share svg');
    var fbShareButton = this.el.querySelector('.fb-share svg');
    var liShareButton = this.el.querySelector('.li-share svg');
    var mailShareButton = this.el.querySelector('.mail-share svg');

    this.events.on(closeButton, 'click', function () {
      return _this2.hide();
    });
    this.events.on(twitterShareButton, 'click', function () {
      return _this2._shareWithTwitter();
    });
    this.events.on(fbShareButton, 'click', function () {
      return _this2._shareWithFb();
    });
    this.events.on(liShareButton, 'click', function () {
      return _this2._shareWithLinkedIn();
    });
    this.events.on(mailShareButton, 'click', function () {
      return _this2._shareWithMail();
    });
  };

  SharePopup.prototype._openChildWindow = function _openChildWindow(url) {
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var childWindWidth = windowWidth > 600 ? 600 : windowWidth;
    var childWindHeight = windowHeight > 400 ? 400 : windowHeight;

    var top = Number(windowHeight - childWindHeight) / 2;
    var left = Number(windowWidth - childWindWidth) / 2;

    var childWind = window.open(url, '_blank', 'width=' + childWindWidth + ', height=' + childWindHeight + ', top=' + top + ', left=' + left + ', location=no, statusbar=no, toolbar=no');
  };

  return SharePopup;
}(Module);

// Toolbar that is shown at the buttom of the page.

var PageToolbar = function (_M) {
  inherits(PageToolbar, _M);

  function PageToolbar() {
    classCallCheck(this, PageToolbar);
    return possibleConstructorReturn(this, _M.apply(this, arguments));
  }

  PageToolbar.prototype.init = function init() {
    // DOM.
    this.el = this.doc.createElement('DIV');
    this.el.classList.add('fp-page-toolbar');
    Helpers.append(this.page.selector, this.el);

    // Buttons.
    this._addButtons(this.opts.pageLeftButtons, 'fp-lp-zone');
    this._addButtons(this.opts.pageCenterButtons, 'fp-cp-zone');
    this._addButtons(this.opts.pageRightButtons, 'fp-rp-zone');
    this.events.emit('button.refresh');
  };

  // Build buttons.


  PageToolbar.prototype._addButtons = function _addButtons(buttonsList, id) {
    var _this2 = this;

    var zone = this.doc.createElement('DIV');
    zone.classList.add('fp-btn-zone');
    if (id) {
      zone.setAttribute('id', id);
    }

    buttonsList.forEach(function (groupEl) {

      if (Array.isArray(groupEl)) {
        var group = _this2.doc.createElement('DIV');
        group.classList.add('fp-btn-group');

        groupEl.forEach(function (btnName) {
          var btn = new Button(_this2.page, btnName);

          Helpers.append(group, btn.el);
        });

        Helpers.append(zone, group);
      } else {
        zone.innerHTML += groupEl;
      }
    });

    Helpers.append(this.el, zone);
  };

  return PageToolbar;
}(Module);

// Allowed image types for background image in block
var ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/jpg", "image/gif"];

var Page = function () {
  function Page(selectorId, options$$1) {
    classCallCheck(this, Page);


    // Set options.
    this.opts = Object.assign({}, options, options$$1);

    // Get current DOM.
    this.doc = document;
    this.body = document.body;

    // Container.
    this.container = this.doc.createElement('DIV');
    this.container.classList.add('fp-container');

    // render to selector element / body
    this.selector = this.doc.getElementById(selectorId) || this.body;
    Helpers.append(this.selector, this.container);

    // Actual editable zone.
    this.el = this.doc.createElement('DIV');
    this.el.classList.add('fp-element');
    Helpers.append(this.container, this.el);

    // Actual editable element.
    this.editEl = this.doc.createElement('DIV');
    this.editEl.classList.add('fp-pageTop-toolbar');
    Helpers.append(this.el, this.editEl);

    // Init events.
    this.events = new Events();
    if (!!(options$$1.hasOwnProperty('eventCallbacks') && options$$1['eventCallbacks']) && options$$1.eventCallbacks) {
      Object.entries(options$$1.eventCallbacks).forEach((entry ) => {
        const [key, value] = entry;
        this.events.listen(key, value);
      });
    }

    // Init designs panel.
    this.designsPanel = new DesignsPanel(this);

    // Render UI.
    this.render();
  }

  // Here we start rendering.


  Page.prototype.render = function render() {
    this.events.emit('init.renderBefore', this);
    this._initIframe();
    this._initEmptyBlocks();
    this._initPageToolbar();
    this._initDropZone();

    this._initBlockToolbar();

    this._initEvents();

    this._initEditor();

    // Refresh current blocks.
    this.events.emit('init.renderBeforeRefresh', this);
    this.refreshBlocks();

    // Set default view as being the FULL one.
    this.setView(VIEWS.FULL);
    this.events.emit('init.renderAfter', this);
  };

  // Initialize Froala Editor.


  Page.prototype._initEditor = function _initEditor() {
    this.editor = new Editor(this);
  };

  // Initialize the block toolbar.


  Page.prototype._initBlockToolbar = function _initBlockToolbar() {
    this.blockToolbar = new BlockToolbar(this);
  };

  // Initialize the page toolbar.


  Page.prototype._initPageToolbar = function _initPageToolbar() {
    this.activeView = VIEWS.FULL;
    this.pageToolbar = new PageToolbar(this);

    if (this.selector !== this.body && !this.selector.style.height) {
      // set view height to 100% if there is no default value
      this.selector.style.height = '100%';
    }

    this.container.style.height = 'calc(100% - ' + this.pageToolbar.el.getBoundingClientRect().height + 'px)';
    this.data = new Data(this);

    // Init share window
    this.sharewindow = this.data.domain && new SharePopup(this);
  };

  // Build stylesheets for iframe.


  Page.prototype._buildStylesheets = function _buildStylesheets() {
    var cssVersion = (new Date()).getTime();
    var defaultStylesheets = [
      'https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css?v1=' + cssVersion, // V1 For firefox to load css
      'https://cdn.jsdelivr.net/gh/froala/design-blocks@master/dist/css/froala_blocks.min.css?v1=' + cssVersion, // V1 For firefox to load css
      '/assets/fonts/roboto/index.css?v1=' + cssVersion, // V1 For firefox to load css
      'https://cdn.jsdelivr.net/npm/froala-editor/css/froala_editor.pkgd.min.css?v1=' + cssVersion, // V1 For firefox to load css
      'https://cdn.jsdelivr.net/npm/froala-editor/css/froala_style.min.css?v1=' + cssVersion, // V1 For firefox to load css
      'https://cdn.jsdelivr.net/npm/tui-image-editor@3.2.2/dist/tui-image-editor.css?v1=' + cssVersion, // V1 For firefox to load css
      'https://cdn.jsdelivr.net/npm/tui-color-picker@2.2.8/dist/tui-color-picker.min.css' + cssVersion, // V1 For firefox to load css
      'https://cdn.jsdelivr.net/npm/froala-editor@3.1.1/css/third_party/image_tui.min.css?v1=' + cssVersion, // V1 For firefox to load css
      'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/css/fontawesome.min.css?v1=' + cssVersion, // V1 For firefox to load css
    ];
    var targetStylesheets = [].concat(defaultStylesheets, this.opts.designStylesheets);
    return targetStylesheets.map(function (x) {
      return '<link rel="stylesheet" href="' + x + '" />';
    }).join('');
  };

  // Build stylesheets for iframe.


  Page.prototype._buildJavascripts = function _buildJavascripts() {
    var defaultJavascripts = ['https://code.jquery.com/jquery-3.3.1.slim.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.3/umd/popper.min.js', 'https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/js/bootstrap.min.js', '/assets/js/froala_wyiwyg/froala_wyiwyg.js', 'https://cdnjs.cloudflare.com/ajax/libs/fabric.js/1.6.7/fabric.min.js', 'https://cdn.jsdelivr.net/npm/tui-code-snippet@1.4.0/dist/tui-code-snippet.min.js', 'https://cdn.jsdelivr.net/npm/tui-image-editor@3.2.2/dist/tui-image-editor.min.js', 'https://cdn.jsdelivr.net/npm/froala-editor@3.1.1/js/third_party/image_tui.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/froala-editor/3.2.2/js/third_party/font_awesome.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/js/fontawesome.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/js/brands.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/js/solid.min.js', 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/js/v4-shims.min.js'];
    var targetJavascripts = [].concat(defaultJavascripts, this.opts.designJavascripts);
    return targetJavascripts.map(function (x) {
      return '<script src="' + x + '"></script>';
    }).join('');
  };

  // Init the iframe.


  Page.prototype._initIframe = function _initIframe(content) {
    var iframe = document.createElement('IFRAME');

    if (this.iframe) {
      this.iframe.remove();
      this.iframe = null;
      this.iframeDoc = null;
      this.iframeBody = null;
      this.iframeHead = null;
    }

    this.iframe = iframe;
    iframe.setAttribute('src', 'about:blank');

    // id is required for pages to whitelist license conditions for Editor
    iframe.setAttribute('id', 'froala-pages');

    Helpers.append(this.el, iframe);

    // Write iframe content.
    this.iframeDoc = iframe.contentWindow.document;
    this.iframeDoc.open();
    this.iframeDoc.write('<!DOCTYPE html>');
    this.writeIframeContent(content);
    this.iframeDoc.close();

    // this.startObserver();
    // Add body and head.
    this.iframeBody = this.iframeDoc.body;
    this.iframeHead = this.iframeDoc.head;
  };

  Page.prototype.startObserver = function startObserver() {
    this.destroyObserver();
    let that = this;
    let searchDelay = null;
    const config = { attributes: true, childList: true, subtree: true };
    const callback = function(mutationsList, observer) {
      clearTimeout(searchDelay);
      searchDelay = setTimeout(() => {
        that.refreshIframeSize();
      }, 1000);
    };
    this.observer = new MutationObserver(callback);
    this.observer.observe(this.iframeDoc, config);
  }

  Page.prototype.destroyObserver = function destroyObserver() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  Page.prototype.writeIframeContent = function writeIframeContent(data) {
    var headContent = '<meta name="viewport" content="width=device-width, initial-scale=1"></meta>\n                        ' + this._buildStylesheets() + '\n                        <style data-fp>' + this.opts.appStyle + '</style>';

    var defaultScripts = '' + this._buildJavascripts();

    if (data) {
      headContent = Array.from(data.querySelectorAll('head > meta')).map(function (el) {
        return el.outerHTML;
      }).join('\n  ') + '\n                     ' + Array.from(data.querySelectorAll('head > link')).map(function (el) {
        return el.outerHTML;
      }).join('\n  ') + '\n                     ' + Array.from(data.querySelectorAll('head > [data-fp]')).map(function (el) {
        return el.outerHTML;
      }).join('\n  ');

      var scripts = Array.from(data.querySelectorAll('body > *:not([data-fp]):not([data-block-type])')).map(function (el) {
        return el.outerHTML;
      });

      // check to verify if any new scripts are added
      for (var i = 0; i < scripts.length; i++) {
        if (defaultScripts.indexOf(scripts[i]) < 0) {
          defaultScripts += scripts[i];
        }
      }
    }

    this.iframeDoc.write('<html>\n                    <head>\n                      ' + headContent + '\n                    </head>\n                    <body>\n                      ' + defaultScripts + '\n                    </body>\n                    </html>');
  };

  // Add empty block.


  Page.prototype._initEmptyBlocks = function _initEmptyBlocks() {
    if (this.emptySection) {
      Helpers.remove(this.emptySection);
      this.emptySection = null;
    }
    this.events.emit('emptyBlock.beforeAdd');
    this.emptySection = new EmptyBlock(this, EmptyBlock.SECTION);

    Helpers.append(this.iframeBody, this.emptySection.el);
    this.events.emit('emptyBlock.afterAdd', this);
  };

  // Refresh the size of the iframe.


  Page.prototype.refreshIframeSize = function refreshIframeSize() {
    this.iframe.style.height = this.iframeBody.scrollHeight + 'px';
  };

  // Refresh page blocks.


  Page.prototype.refreshBlocks = function refreshBlocks() {
    // Check if there are blocks.
    var noBlocks = !this.iframeBody.querySelector('[data-block-type]');

    // Update CSS classes to reflect new block state.
    this.emptySection.el.classList.toggle('fp-visible', noBlocks);
    this.iframeBody.classList.toggle('no-block', noBlocks);
    this.container.classList.toggle('fp-no-block', noBlocks);

    // Change iframe size.
    this.refreshIframeSize();

    // Display downloads button only if blocks are selected and has valid key

    Helpers.setDownloadBtnsStatus(this, noBlocks, noBlocks);

    if (!noBlocks) {
      this._addEditButtons(this.opts.pageTopButtons, 'fp-tp-zone');
    }
  };

  // Build buttons.


  Page.prototype._addEditButtons = function _addEditButtons(buttonsList, id) {
    var _this = this;

    var topEle = this.doc.getElementById('fp-tp-zone');

    var pageTopEle = this.doc.getElementsByClassName('fp-pageTop-toolbar');
    pageTopEle[0].style.display = this.activeView === VIEWS.FULL ? 'none' : 'flex';

    if (topEle) {
      return;
    }
    var zone = this.doc.createElement('DIV');
    zone.classList.add('fp-btn-zone');
    if (id) {
      zone.setAttribute('id', id);
    }
    buttonsList.forEach(function (groupEl) {

      if (Array.isArray(groupEl)) {
        var group = _this.doc.createElement('DIV');
        group.classList.add('fp-btn-group');

        groupEl.forEach(function (btnName) {

          var btn = new Button(_this, btnName);

          Helpers.append(group, btn.el);
        });

        Helpers.append(zone, group);
      } else {
        zone.innerHTML += groupEl;
      }
    });

    Helpers.append(this.editEl, zone);
  };

  // Refresh current view.


  Page.prototype.setView = function setView(view) {
    var _this2 = this;

    this.activeView = view;

    // Toggle CSS classes between views.
    this.body.classList.toggle('fp-add-view', this.activeView === VIEWS.ADD);
    this.body.classList.toggle('fp-full-view', this.activeView === VIEWS.FULL);

    this.iframeBody.classList.toggle('fp-add-view', this.activeView === VIEWS.ADD);
    this.iframeBody.classList.toggle('fp-full-view', this.activeView === VIEWS.FULL);

    // Toggle design blocks zone.
    this.designsPanel.setActiveBlock();
    if (this.activeView === VIEWS.ADD) {
      this.designsPanel.show();
    } else {
      this.designsPanel.hide();
    }

    // Make header and footer not draggable.
    Array.from(this.iframeBody.querySelectorAll('[data-block-type]:not(header):not(footer)')).forEach(function (el) {
      if (_this2.activeView === VIEWS.ADD) {
        el.setAttribute('draggable', 'true');
      } else {
        el.removeAttribute('draggable');
      }
    });

    // Refresh buttons.
    this.events.emit('button.refresh');
  };

  // Initialize events.


  Page.prototype._initEvents = function _initEvents() {
    var _this3 = this;

    // Click on an empty block.
    this.events.listen('emptyBlock.click', function () {
      _this3.setView(VIEWS.ADD);
    });

    // A design block was clicked.
    this.events.listen('designBlock.click', function (block) {
      return _this3.insertBlock(block);
    });
    this.events.listen('designBlock.willDrag', function (block) {
      _this3.draggingDesignBlock = block;
      _this3.dragImage = block.dragImage;

      if (_this3.dropPlaceholder) {
        _this3.dropPlaceholder.style.height = '';
      }
    });
  };

  // Drag of a block ends.


  Page.prototype._dragend = function _dragend() {
    if (this.dropPlaceholder) {
      Helpers.remove(this.dropPlaceholder);
      this.dropPlaceholder.isVisible = false;
    }

    this.body.classList.remove('fp-dragging');
  };

  // A block is dropped.


  Page.prototype._drop = function _drop(e) {
    if (navigator.userAgent.search('Firefox') >= 0) {
      e.preventDefault();
    }

    if (this.activeView === VIEWS.ADD) {
      // Sorting blocks.
      if (this.draggingBlock && this.dropPlaceholder && this.dropPlaceholder.isVisible) {
        this.draggingBlock.classList.remove('fp-dragging');
        Helpers.after(this.dropPlaceholder, this.draggingBlock);

        Helpers.remove(this.dropPlaceholder);
        Helpers.remove(this.dragImage);
      }

      // Adding block.
      if (this.draggingDesignBlock && (this.dropPlaceholder && this.dropPlaceholder.isVisible || this.container.classList.contains('fp-no-block'))) {
        this.insertBlock(this.draggingDesignBlock, this.dropPlaceholder);

        Helpers.remove(this.dropPlaceholder);
        Helpers.remove(this.dragImage);
      }

      this.dropPlaceholder.isVisible = false;
      this.draggingDesignBlock = null;
      this.draggingBlock = null;
    }

    this.body.classList.remove('fp-dragging');
  };

  // Drop placeholder.


  Page.prototype._initDropZone = function _initDropZone() {
    var _this4 = this;

    if (this.dropZone) {
      this.dropZone.remove();
      this.dropZone = null;
    }

    // create drop placeholder
    this.dropZone = this.doc.createElement('DIV');
    this.dropZone.classList.add('fp-drop-zone');
    this.dropZone.innerHTML = '<p>Drag & Drop a Design Block</p>\n                                <p>(or click one)</p>\n                                <div id="fp-drop-visual">\n                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200.26 68.42">\n                                    <path d="M6.19,9.4Q4.9,7.87,3.62,6.3L5.18,5Q6.44,6.6,7.72,8.11Z"/>\n                                    <path d="M139.15,68.42q-2,0-4,0l0-2q4.09.08,8.16,0l0,2Q141.29,68.42,139.15,68.42ZM128,68.13c-2.75-.15-5.52-.35-8.22-.61l.19-2c2.68.25,5.42.45,8.14.6Zm22.65,0-.11-2c2.7-.14,5.44-.33,8.15-.58l.18,2C156.12,67.78,153.36,68,150.63,68.12ZM166,66.79l-.24-2c2.69-.32,5.41-.7,8.09-1.11l.31,2C171.48,66.09,168.73,66.47,166,66.79Zm-53.43-.08c-2.73-.36-5.47-.78-8.15-1.25l.35-2c2.64.47,5.36.88,8.06,1.24Zm68.69-2.25-.37-2c2.66-.49,5.35-1,8-1.62l.43,2C186.68,63.41,184,64,181.28,64.46Zm-83.92-.4c-2.68-.58-5.38-1.24-8-1.94l.52-1.93c2.6.69,5.27,1.34,7.93,1.92Zm-15-3.94c-2.63-.82-5.26-1.71-7.81-2.65l.69-1.88c2.53.93,5.12,1.81,7.72,2.62ZM67.87,54.84c-2.54-1.06-5.07-2.19-7.53-3.37l.86-1.8C63.63,50.83,66.13,52,68.64,53Zm-14-6.62c-2.41-1.29-4.82-2.66-7.17-4.07l1-1.71c2.32,1.4,4.71,2.75,7.08,4ZM40.62,40.27c-2.28-1.52-4.55-3.12-6.74-4.75l1.19-1.6c2.17,1.62,4.41,3.19,6.66,4.69ZM28.19,31.08c-2.11-1.73-4.22-3.54-6.25-5.38l1.34-1.48c2,1.82,4.09,3.61,6.18,5.31ZM16.69,20.75c-1.94-1.91-3.86-3.91-5.73-5.93l1.47-1.35c1.84,2,3.74,4,5.66,5.86Z"/>\n                                    <path d="M196.38,61.16l-.49-1.94q1.94-.49,3.85-1l.52,1.93Q198.33,60.67,196.38,61.16Z"/>\n                                    <polygon points="1.39 9.88 0 0 9.24 3.73 1.39 9.88"/>\n                                  </svg>\n                                </div>\n                                ';
    Helpers.append(this.container, this.dropZone);

    // Block is dragged over.
    this.events.on(this.dropZone, 'dragover dragenter', function (e) {
      e.preventDefault();

      _this4.dropZone.classList.add('fp-hover');
    });

    // Drag ends.
    this.events.on(this.dropZone, 'dragleave dragend', function () {
      _this4.dropZone.classList.remove('fp-hover');
    });

    // Block is dropped.
    this.events.on(this.dropZone, 'drop', function (e) {
      return _this4._drop(e);
    });
  };

  // Make a design block draggable.


  Page.prototype._makeBlockDraggable = function _makeBlockDraggable(block) {
    var _this5 = this;

    var el = block.el;
    var isHeader = block.designBlock.blockType === DesignBlock.HEADER;
    var isFooter = block.designBlock.blockType === DesignBlock.FOOTER;
    var isSocialImage = block.designBlock.blockType === DesignBlock.SOCIAL;

    // make it draggable
    if (!this.dropPlaceholder) {
      this.dropPlaceholder = this.doc.createElement('DIV');
      this.dropPlaceholder.classList.add('fp-drop-placeholder');

      this.events.on(this.iframeDoc, 'drop', function (e) {
        return _this5._drop(e);
      });
      this.events.on(this.doc, 'drop', function (e) {
        return _this5._drop(e);
      });

      this.events.on(this.iframeDoc, 'dragend', function (e) {
        return _this5._drop(e);
      });
      this.events.on(this.doc, 'dragend', function (e) {
        return _this5._drop(e);
      });

      this.events.on(this.iframeDoc, 'dragenter dragover', function (e) {
        return e.preventDefault();
      });
      this.events.on(this.doc, 'dragenter dragover', function (e) {
        return e.preventDefault();
      });
    }

    if (!isHeader && !isFooter && !isSocialImage) {
      el.setAttribute('draggable', 'true');
    }

    // Drag ends.
    this.events.on(el, 'dragover dragenter', function (e) {
      e.preventDefault();

      // Drag can be used only in ADD mode.
      if (_this5.activeView === VIEWS.ADD) {
        var cy = e.clientY;
        var ey = Helpers.offset(el).top;
        var eh = Helpers.outerHeight(el);

        // Decide where to place drop placeholder based on the current mouse position.
        if (isHeader && cy > ey) {
          Helpers.after(el, _this5.dropPlaceholder);
        } else if (isFooter && cy > ey) {
          Helpers.before(el, _this5.dropPlaceholder);
        }else if (isSocialImage && cy > ey) {
          Helpers.before(el, _this5.dropPlaceholder);
        } else if (cy > ey + eh / 2) {
          Helpers.after(el, _this5.dropPlaceholder);
        } else {
          Helpers.before(el, _this5.dropPlaceholder);
        }

        _this5.dropPlaceholder.isVisible = true;

        _this5.refreshIframeSize();
      }
    });

    // Drag starts.
    this.events.on(el, 'dragstart', function (e) {
      // Drag can be used only in ADD mode.
      if (_this5.activeView === VIEWS.ADD) {

        // Don't do it for footers and headers and Social images.
        if (isHeader || isFooter || isSocialImage) {
          e.preventDefault();
          e.stopPropagation();

          return false;
        }

        // Let BODY element know we're dragging.
        _this5.body.classList.add('fp-dragging');

        // Create a draggable placeholder.
        _this5.dragImage = _this5.doc.createElement('IMG');
        _this5.dragImage.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==';
        _this5.dragImage.style.position = 'aboslute';
        Helpers.append(_this5.body, _this5.dragImage);
        e.dataTransfer.setDragImage(_this5.dragImage, 0, 0);

        e.dataTransfer.setData('text/html', null);

        // Use a timeout so image is loaded.
        setTimeout(function () {
          Helpers.after(el, _this5.dropPlaceholder);
          _this5.dropPlaceholder.style.height = Helpers.outerHeight(el, true) + 'px';
          _this5.dropPlaceholder.isVisible = true;
          el.classList.add('fp-dragging');
        });
        _this5.draggingBlock = el;
      }

      return true;
    });
  };

  // Add a new block.


  Page.prototype.insertBlock = function insertBlock(designBlock, placeholder) {
    var _this6 = this;

    var block = new Block(this, designBlock);

    // Trigger scroll when images are loaded.
    Array.from(block.el.querySelectorAll('img')).forEach(function (img) {
      _this6.events.once(img, 'load', function () {
        return _this6.refreshIframeSize();
      });

      Helpers.scrollTo(block.el);
    });

    // Add block to the body.
    if (designBlock.blockType === DesignBlock.HEADER) {
      // Replace existing header if there is one.
      var headerEl = this.iframeBody.querySelector('header');
      if (headerEl) {
        Helpers.remove(headerEl);
      }

      Helpers.prepend(this.iframeBody, block.el);
    } else if (designBlock.blockType === DesignBlock.FOOTER) {
      // Replace existing footer if there is one.
      var footerEl = this.iframeBody.querySelector('footer');
      if (footerEl) {
        Helpers.remove(footerEl);
      }

      Helpers.append(this.iframeBody, block.el);
    }else if (designBlock.blockType === DesignBlock.SOCIAL) {
      // Replace existing social image if there is one.
      var socialEl = this.iframeBody.querySelector('header');
      if (socialEl) {
        Helpers.remove(socialEl);
      }

      Helpers.append(this.iframeBody, block.el);
    } else if (placeholder && placeholder.isVisible) {
      // Place new block after placeholder.
      Helpers.after(placeholder, block.el);
    } else {
      var _footerEl = this.iframeBody.querySelector('footer');

      // Place new block at the end.
      if (_footerEl) {
        Helpers.before(_footerEl, block.el);
      } else {
        Helpers.append(this.iframeBody, block.el);
      }
    }

    // Refresh existing blocks.
    this.refreshBlocks();

    // Make new block draggable.
    this._makeBlockDraggable(block);

    // Bind click event on the new block.
    this.events.on(block.el, 'click', function (e) {
      _this6._disableEnhancedText();
      if (e.target && e.target.tagName === 'A') {
        e.preventDefault();
        return false;
      }

      if (e.target && e.target.tagName === 'A') {
        e.preventDefault();
        return false;
      }

      return true;
    });

    // Emit block inserted event.
    this.events.emit('block.inserted', block);
  };

  //Disable Enhanced text editor if pro button available


  Page.prototype._disableEnhancedText = function _disableEnhancedText() {
    var iframe = document.getElementById('froala-pages');
    if (iframe.contentWindow.document.getElementsByClassName('pro-btn-text').length > 0) {
      var toolbarsElement = iframe.contentWindow.document.getElementsByClassName('fr-toolbar');
      var childNodes = toolbarsElement[0].childNodes[1].getElementsByTagName('button');
      for (var i = 0; i < childNodes.length; i++) {
        childNodes[i].classList.add('fr-disabled', 'pro-toolbar');
      }
    }
  };

  Page.prototype.setBlockPlaceholder = function setBlockPlaceholder(block) {
    this._blockPlaceholder = block;
  };

  // Get HTML for the HEAD.


  Page.prototype._getHeadHTML = function _getHeadHTML() {
    return Array.from(this.iframeDoc.querySelectorAll('head > *')).map(function (el) {
      return el.outerHTML;
    }).join('\n  ');
  };

  // Get HTML for the BODY.


  Page.prototype._getBodyHTML = function _getBodyHTML() {
    return Array.from(this.iframeDoc.querySelectorAll('body > [data-block-type]')).map(function (el) {
      return el.outerHTML;
    }).join('\n') + '\n      ' + Array.from(this.iframeDoc.querySelectorAll('body > *:not([data-fp]):not([data-block-type])')).map(function (el) {
      return el.outerHTML;
    }).join('\n');
  };

  // Return promise which resolves get HTML for the page.


  Page.prototype.getHTML = function getHTML() {
    var _this7 = this;

    return new Promise(function (resolve, reject) {
      Data._getData(_this7.data, resolve, reject);
    });
  };

  // Get scripts from BODY.


  Page.prototype._getScripts = function _getScripts() {
    return Array.from(this.iframeDoc.querySelectorAll('body > *:not([data-fp]):not([data-block-type])')).map(function (el) {
      return el.outerHTML;
    });
  };

  // Get links from HEAD.


  Page.prototype._getLinks = function _getLinks() {
    return Array.from(this.iframeDoc.querySelectorAll('head > link')).map(function (el) {
      return el.outerHTML;
    });
  };

  // Get HTML BLOCKS from BODY.


  Page.prototype._getBlockHTML = function _getBlockHTML() {
    return Array.from(this.iframeDoc.querySelectorAll('body > [data-block-type]')).map(function (el) {
      return el.outerHTML;
    });
  };

  // Get Inline style from HEAD.


  Page.prototype._getInlineStyle = function _getInlineStyle() {
    return Array.from(this.iframeDoc.querySelectorAll('head > [data-fp]')).map(function (el) {
      return el.outerHTML;
    });
  };

  Page.prototype._hideBlocksToolbars = function _hideBlocksToolbars() {
    this.blockToolbar.hide();
  }

  // Get the blocks as a JSON structure instead of HTML.


  Page.prototype.getJSON = function getJSON() {
    var _this8 = this;
    var deleteSizeElements = _this8.iframeDoc.getElementsByClassName('custom-fix-font');
    for (var inxD = 0; inxD < deleteSizeElements.length; inxD++) {
      if (deleteSizeElements[inxD].style?.fontSize) {
        deleteSizeElements[inxD].style.removeProperty('font-size');
        deleteSizeElements[inxD].setAttribute('fix-font', parseFloat(deleteSizeElements[inxD].offsetWidth) + 'px');
      }
    }

    return new Promise(function (resolve, reject) {
      Data._getData(_this8.data, resolve, reject, true);
    });
  };

  // Load saved HTML.


  Page.prototype.setHTML = function setHTML(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');

    var sections = doc.querySelectorAll('body > [data-block-type]');

    if (!sections || !sections.length) {
      alert('Selected file has no valid design blocks. Please upload a valid template.');
      return;
    }

    // Initialize iframe.
    this._initIframe(doc);

    // set view to layout mode for further edit
    this.setView(VIEWS.ADD);

    this._initEmptyBlocks();

    // remove old instances of dropPlaceholder
    if (this.dropPlaceholder) {
      this.dropPlaceholder.remove();
      this.dropPlaceholder = null;
    }

    // Render each blocks into view
    for (var i = 0; i < sections.length; i++) {
      var designBlock = {
        blockType: sections[i].getAttribute('data-block-type'),
        template: sections[i].outerHTML,
        render: DesignBlock.prototype.render
      };
      this.insertBlock(designBlock);
    }

    // hide blocktool bar button.
    this.blockToolbar.hide();

    // initialize blocktool bar.
    this.blockToolbar.init();

    // initialize dropzone.
    this._initDropZone();

    // Refresh current blocks.
    this.refreshBlocks();
  };

  // Load saved JSON.


  Page.prototype.setJSON = function setJSON(jsonData) {
    var templateContent = JSON.parse(jsonData);
    var htmlHeadContent = '';
    var htmlBodyContent = '';

    for (var key in templateContent) {
      if (key === 'blocks') {
        htmlBodyContent += templateContent[key].join('');
      } else {
        htmlHeadContent += templateContent[key].join('');
      }
    }

    if (htmlHeadContent && htmlBodyContent) {
      // Create a HTML structure.
      var data = '<!DOCTYPE html>\n              <html>\n              <head>\n              ' + htmlHeadContent + '\n              </head>\n              <body>\n              ' + htmlBodyContent + '\n              </body>\n              </html>';

      this.setHTML(data);
    } else {
      alert('Please load a valid template.');
    }
  };

  Page.prototype.uploadTemplate = function uploadTemplate(templateFile) {
    var _this9 = this;

    if (templateFile.type === "text/html") {
      var reader = new FileReader();
      reader.onloadend = function () {
        _this9.setHTML(reader.result);
      };
      reader.readAsText(templateFile);
    } else {
      alert('Only HTML files are supported. Please upload a valid HTML template.');
    }
  };

  // Custom upload Image function to set background image to active block
  Page.prototype.uploadImage = function uploadImage(imageFile, activeBlock) {
    var _this10 = this;
    var currentActiveBlock = activeBlock;
    let topBarConfig = {
      autoRun: true,
      barThickness: 3,
      shadowBlur: 10,
      shadowColor: 'rgba(0,   0,   0,   .6)'
    }

    if (ALLOWED_IMAGE_TYPES.includes(imageFile.type)) {
      window.topbar.config({
        ...topBarConfig,
        barColors: {
          '0': '#4BB7E3',
          '.25': '#4BB7E3',
          '.50': '#4BB7E3',
          '.75': '#4BB7E3',
          '1.0': '#4BB7E3'
        }
      });
      window.topbar.show();
      const xhttp = new XMLHttpRequest;
      xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
            window.topbar.hide();
            let response = JSON.parse(this.responseText);
            if (currentActiveBlock && currentActiveBlock.el) {
              // currentActiveBlock.el.style.backgroundColor = null;
              currentActiveBlock.el.style.setProperty('background-image', `url(${response.data.url})`, 'important');
              currentActiveBlock.el.style.setProperty('background-repeat', `no-repeat`, 'important');
              currentActiveBlock.el.style.setProperty('background-size', `cover`, 'important');
              Helpers.setBackgroundButtonStatus(currentActiveBlock.el, _this10);
            }
        } else {
          window.topbar.config({
            ...topBarConfig,
            barColors: {
              '0': '#dc3545',
              '.25': '#dc3545',
              '.50': '#dc3545',
              '.75': '#dc3545',
              '1.0': '#dc3545'
            }
          });
          window.topbar.hide();
        }
      };
      xhttp.onerror = function () {
        window.topbar.config({
          ...topBarConfig,
          barColors: {
            '0': '#dc3545',
            '.25': '#dc3545',
            '.50': '#dc3545',
            '.75': '#dc3545',
            '1.0': '#dc3545'
          }
        });
        window.topbar.hide();
      };
      xhttp.open("POST", _this10.opts.editorOptions.imageUploadURL, true);
      xhttp.setRequestHeader('Authorization', _this10.opts.editorOptions.requestHeaders['Authorization'])
      let formData = new FormData();
      formData.append("file", imageFile);
      xhttp.send(formData);
    } else {
      alert('Only JPG, PNG and JPEG files are supported. Please upload a valid JPG, PNG and JPEG template.');
    }
  };

  return Page;
}();

// Expose global classes.


Page.Events = Events;
Page.Helpers = Helpers;
Page.RegisterDesignBlock = DesignBlock.Register;
Page.Button = Button;

return Page;

})));
//# sourceMappingURL=froala_pages.js.map

/*!
  * Froala Pages v1.2.0 (https://github.com/froala-labs/froala-pages#readme)
  * Copyright 2017-2020 
  * Licensed under Froala Pages Terms (https://www.froala.com/pages/terms)
  */ !function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-8 text-center">\n        <p class="lead">\n          "Separated they live in Bookmarksgrove right at the coast of the Semantics, far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast."\n        </p>\n\n        <p class="mt-5 mt-sm-4">\n          <a class="btn btn-primary" href="https://www.froala.com">Download</a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/1.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-6 text-center">\n        <h1>Call to Action</h1>\n        <p class="lead">\n          Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts\n        </p>\n        <p class="mt-5 mt-sm-4">\n          <a class="btn btn-secondary" href="https://www.froala.com">Download</a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/2.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-sm-8 col-md-6 col-lg-6 text-center">\n        <h2>\n          <strong>Right at the coast of the Semantics, a large language ocean.</strong>\n        </h2>\n        <p class="mt-5 mt-sm-4">\n          <a class="btn btn-outline-primary" href="https://www.froala.com">Download</a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/3.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-8 col-lg-6 text-center">\n        <h1>Call to Action</h1>\n        <p class="lead">\n          Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts\n        </p>\n        <p class="mt-5 mt-sm-4">\n          <a class="btn btn-primary" href="https://www.froala.com">Download</a>\n        </p>\n      </div>\n    </div>\n\n    <div class="row pt-5 pb-3">\n      <div class="col-12 text-center">\n        <p><strong>Fortune 100 companies are using our products</strong></p>\n      </div>\n    </div>\n    <div class="row">\n      <div class="col-12 text-center">\n        <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/adobe.svg">\n        <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/amazon.svg">\n        <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/ebay.svg">\n        <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/samsung.svg">\n        <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/orange.svg">\n        <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/salesforce.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/4.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-8 text-center">\n        <h1>Far far away, behind the word mountains, far from</h1>\n        <p class="mt-5">\n          <a class="btn btn-secondary" href="https://www.froala.com">Download</a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/5.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-sm-10 col-md-8 col-lg-4 text-center">\n        <p class="lead">\n          Follow us and ask more on:\n        </p>\n        <p class="h2">\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-facebook"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-twitter"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-instagram"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-google"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-pinterest"></i></a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/6.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center pb-0 pb-lg-4">\n      <div class="col-12">\n        <h1>Call to action</h1>\n      </div>\n    </div>\n    <div class="row text-center pt-4 pt-md-5">\n      <div class="col-12 col-sm-10 col-md-6 col-lg-4 m-sm-auto">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/gift.svg">\n        <h3>First Action</h3>\n        <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts</p>\n        <p class="mt-3"><a class="btn btn-light sl-1" href="https://www.froala.com">Button</a></p>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-6 col-lg-4 ml-sm-auto mr-sm-auto mt-5 mt-md-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/cloud.svg">\n        <h3>Second Action</h3>\n        <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n        <p class="mt-3"><a class="btn btn-light sl-1" href="https://www.froala.com">Button</a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/7.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block py-0">\n  <div class="container py-5 my-5" style="background-image: url({{imagesDir}}/shapes/2.svg);">\n    <div class="row justify-content-center py-5">\n      <div class="col-12 col-md-10 col-lg-8 text-center">\n        <div class="fdb-box">\n          <h1>Call to Action</h1>\n          <p class="lead">\n            Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts\n          </p>\n          <p class="mt-4">\n            <a class="btn btn-primary" href="https://www.froala.com">Download</a>\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/8.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center justify-content-center">\n      <div class="col-auto">\n        <h2>Use Froala Design Blocks for free in your project</h2>\n      </div>\n      <div class="col-auto mt-4 mt-sm-0">\n        <a class="btn btn-primary" href="https://www.froala.com">Download</a>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/9.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block py-0">\n  <div class="container py-5 my-5 bg-r" style="background-image: url({{imagesDir}}/shapes/4.svg);">\n    <div class="row justify-content-end py-5">\n      <div class="col-12 col-md-8 col-lg-6 mr-5 text-center">\n        <div class="fdb-box">\n          <h1>Call to Action</h1>\n          <p class="lead">\n            When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove\n          </p>\n          <p class="mt-4">\n            <a class="btn btn-secondary" href="https://www.froala.com">Download</a>\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/10.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center justify-content-center">\n      <div class="col-auto text-center">\n        <a class="btn btn-outline-secondary" href="https://www.froala.com">Download</a>\n      </div>\n\n      <div class="col-auto mt-4 mt-sm-0">\n        <h2>Use Froala Design Blocks for free in your project</h2>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/11.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col-12 text-center">\n        <h1>Froala Design Blocks</h1>\n        <p class="h2">\n          Far far away, behind the word mountains, far from.\n        </p>\n      </div>\n    </div>\n\n    <div class="row align-items-center pt-2 pt-lg-5">\n      <div class="col-12 col-md-8 col-lg-7">\n        <h2>Call to action</h2>\n        <p class="lead">Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.</p>\n        <p class="mt-4"><a class="btn btn-primary" href="https://www.froala.com">Take a Tour</a></p>\n      </div>\n\n      <div class="col-8 col-md-4 m-auto m-md-0 ml-md-auto pt-5">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/git.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/12.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block bg-dark" style="background-image: url({{imagesDir}}/hero/purple.svg);">\n  <div class="container justify-content-center align-items-center d-flex">\n    <div class="row justify-content-center text-center">\n      <div class="col-12 col-md-8">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/coffee.svg">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n        <p class="mt-5"><a href="https://www.froala.com" class="btn btn-dark">Call to Action</a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/13.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block py-0">\n  <div class="container bg-r py-5 my-5" style="background-image: url({{imagesDir}}/shapes/1.svg);">\n    <div class="row py-5">\n      <div class="col-12 col-sm-10 col-md-8 col-lg-6 text-left">\n        <h1>Call to Action</h1>\n        <p class="lead">\n          A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth.\n        </p>\n        <p class="mt-4">\n          <a class="btn btn-primary" href="https://www.froala.com">Download</a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/14.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-10 col-sm-6 col-md-4 col-lg-3 m-auto m-md-0">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/smile.svg">\n      </div>\n\n      <div class="col-12 col-md-8 ml-auto pt-5 pt-md-0">\n        <h2>Call to action</h2>\n        <p class="lead">On her way she met a copy. The copy warned the Little Blind Text, that where it came from it would have been rewritten a thousand times and everything that was left from its origin would be the word "and" and the Little Blind Text should turn\n          around and return to its own, safe country.</p>\n        <p class="mt-4"><a class="btn btn-secondary" href="https://www.froala.com">Take a Tour</a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/15.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block bg-dark" style="background-image: url({{imagesDir}}/hero/blue.svg);">\n  <div class="container align-items-center justify-content-center d-flex">\n    <div class="row justify-content-center text-center">\n      <div class="col-12 col-md-10 col-lg-8">\n        <h1>Froala Design Blocks is Open Source and free to use in your apps</h1>\n        <p class="mt-5"><a href="https://www.froala.com" class="btn btn-outline-light">Call to Action</a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/16.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col-12">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">\n          Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by\n          their place and supplies it with the necessary regelialia.\n        </p>\n      </div>\n    </div>\n\n    <div class="row justify-content-center align-items-center pt-5">\n      <div class="col-8 col-sm-3">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/code.svg">\n      </div>\n      <div class="col-12 col-sm-6 m-auto pt-4 pt-sm-0">\n        <h2><strong>Bootstrap</strong></h2>\n        <p class="lead">Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life.</p>\n      </div>\n      <div class="col-12 col-sm-3 text-center pt-4 pt-sm-0">\n        <p><a class="btn btn-outline-primary" href="https://www.froala.com">Take a Tour</a></p>\n        <p><a class="btn btn-primary" href="https://www.froala.com">Start Now</a></p>\n        <p class="h5"><em>Some foo text</em></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/17.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container align-items-end justify-content-center d-flex">\n    <div class="row align-items-top text-left">\n      <div class="col-12 col-md-6 col-lg-5">\n        <p class="mb-5 mt-5"><img alt="image" height="40" src="{{imagesDir}}/logo.png"></p>\n        <h1>Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n        <p class="mt-4"><a href="https://www.froala.com" class="btn btn-primary">Call to Action</a></p>\n      </div>\n\n      <div class="col-12 col-sm-4 col-md-6 col-lg-4 m-auto pt-5">\n        <img alt="image" class="img-fluid rounded-0" src="{{imagesDir}}/draws/sync.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/18.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container align-items-center justify-content-center d-flex">\n    <div class="row align-items-center text-left">\n      <div class="col-12 col-sm-6">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/sync2.svg">\n      </div>\n\n      <div class="col-12 col-lg-5 ml-auto pt-5 pt-lg-0">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.</p>\n        <p class="mt-4"><a href="https://www.froala.com" class="btn btn-secondary">Call to Action</a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/19.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center text-left">\n      <div class="col-12 col-md-8">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove.</p>\n      </div>\n      <div class="col-12 col-md-3 ml-auto text-left text-md-right">\n        <p><a href="https://www.froala.com" class="btn btn-primary">Call to Action</a></p>\n      </div>\n    </div>\n\n    <div class="row pt-5">\n      <div class="col-6 offset-3">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/rocket.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/20.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block bg-dark" style="background-image: url({{imagesDir}}/hero/red.svg);">\n  <div class="container align-items-center justify-content-center d-flex">\n    <div class="row align-items-center text-left">\n      <div class="col-12 col-sm-10 col-md-8 col-lg-8">\n        <h1>Froala Design Blocks is build on Boostrap Framework</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there.</p>\n        <p class="mt-5">\n          <a href="https://www.froala.com" class="btn btn-light">Call to Action</a>\n          <a href="https://www.froala.com" class="btn btn-dark ml-4">Button</a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/21.jpg"),n.RegisterDesignBlock("Call To Action",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-8 col-lg-5 text-center pb-md-5">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia.</p>\n        <p class="mt-4"><a href="https://www.froala.com" class="btn btn-primary">Call to Action</a></p>\n      </div>\n    </div>\n\n    <div class="row text-center justify-content-center pt-5">\n      <div class="col-12 col-sm-6 col-lg-3">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/cloud.svg">\n\n        <h3><strong>Feature One</strong></h3>\n\n        <p>Far far away, behind the word mountains, far from the countries</p>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 pt-4 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/gift.svg">\n\n        <h3><strong>Feature Two</strong></h3>\n\n        <p>Separated they live in Bookmarksgrove right at the coast</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-lg-3 pt-4 pt-lg-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/github.svg">\n\n        <h3><strong>Feature Three</strong></h3>\n\n        <p>A small river named Duden flows by their place and supplies it</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-lg-3 pt-4 pt-lg-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/compass.svg">\n\n        <h3><strong>Feature Four</strong></h3>\n\n        <p>Far far away, behind the word mountains, far from the countries</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"call-to-action/22.jpg")}),function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Contacts",'<section class="fdb-block pt-0">\n  <div class="container-fluid p-0 pb-md-5">\n    <iframe class="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2848.8444388087937!2d26.101253041406952!3d44.43635311654287!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1ff4770adb5b7%3A0x58147f39579fe6fa!2zR3J1cHVsIFN0YXR1YXIgIkPEg3J1yJthIEN1IFBhaWHIm2Ui!5e0!3m2!1sen!2sro!4v1507381157656"\n      width="100%" height="300" frameborder="0" style="border:0" allowfullscreen=""></iframe>\n  </div>\n  <div class="container">\n    <div class="row mt-5">\n      <div class="col-12 col-md-6 col-lg-5">\n        <h2>Contact Us</h2>\n        <p class="lead">\n          Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove.\n        </p>\n\n        <p class="lead">\n          It is a paradisematic country, in which roasted parts of sentences fly into your mouth.\n        </p>\n\n\n        <p class="h3 mt-5">\n          <strong>Email:</strong> <a href="https://www.froala.com">hello@website.com</a>\n        </p>\n        <p class="lead">\n          <strong>Phone:</strong> <a href="https://www.froala.com">+44 123 123 1232</a>\n        </p>\n      </div>\n\n      <div class="col-12 col-md-6 ml-auto pt-5 pt-md-0">\n        <form>\n          <div class="row">\n            <div class="col">\n              <input type="text" class="form-control" placeholder="First name">\n            </div>\n            <div class="col">\n              <input type="text" class="form-control" placeholder="Last name">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <input type="email" class="form-control" placeholder="Enter email">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <input type="email" class="form-control" placeholder="Subject">\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <textarea class="form-control" name="message" rows="3" placeholder="How can we help?"></textarea>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <button type="submit" class="btn btn-primary">Submit</button>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n</section>\n',"contacts/1.jpg"),n.RegisterDesignBlock("Contacts",'<section class="fdb-block bg-dark" style="background-image: url({{imagesDir}}/hero/blue.svg);">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-12 col-md-8 col-lg-7">\n        <h1>Contact Us</h1>\n        <h2>We love to hear from you!</h2>\n      </div>\n    </div>\n\n    <div class="row pt-4">\n      <div class="col-12">\n        <form>\n          <div class="row">\n            <div class="col-12 col-md">\n              <input type="text" class="form-control" placeholder="Name">\n            </div>\n            <div class="col-12 col-md mt-4 mt-md-0">\n              <input type="text" class="form-control" placeholder="Email">\n            </div>\n            <div class="col-12 col-md mt-4 mt-md-0">\n              <input type="text" class="form-control" placeholder="Phone (optional)">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <input type="email" class="form-control" placeholder="Subject">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <textarea class="form-control" name="message" rows="3" placeholder="How can we help?"></textarea>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col text-center">\n              <button type="submit" class="btn btn-dark">Submit</button>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n</section>\n',"contacts/2.jpg"),n.RegisterDesignBlock("Contacts",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-12 col-md-8 col-lg-7">\n        <h1>Contact Us</h1>\n        <p class="lead">One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.</p>\n      </div>\n    </div>\n\n    <div class="row pt-4">\n      <div class="col-12 col-md-6">\n        <iframe class="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2848.8444388087937!2d26.101253041406952!3d44.43635311654287!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1ff4770adb5b7%3A0x58147f39579fe6fa!2zR3J1cHVsIFN0YXR1YXIgIkPEg3J1yJthIEN1IFBhaWHIm2Ui!5e0!3m2!1sen!2sro!4v1507381157656"\n          width="100%" height="300" frameborder="0" style="border:0" allowfullscreen=""></iframe>\n      </div>\n\n      <div class="col-12 col-md-6 pt-5 pt-md-0">\n        <form>\n          <div class="row">\n            <div class="col">\n              <input type="email" class="form-control" placeholder="Enter email">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <input type="email" class="form-control" placeholder="Subject">\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <textarea class="form-control" name="message" rows="3" placeholder="How can we help?"></textarea>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <button type="submit" class="btn btn-primary">Submit</button>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n</section>\n',"contacts/3.jpg"),n.RegisterDesignBlock("Contacts",'<section class="fdb-block py-0">\n  <div class="container py-5 my-5" style="background-image: url({{imagesDir}}/shapes/9.svg);">\n    <div class="row py-5">\n      <div class="col py-5">\n        <div class="fdb-box fdb-touch">\n          <div class="row text-center justify-content-center">\n            <div class="col-12 col-md-9 col-lg-7">\n              <h1>Contact Us</h1>\n              <p class="lead">Pityful a rethoric question ran over her cheek, then she continued her way. On her way she met a copy.</p>\n            </div>\n          </div>\n\n          <div class="row justify-content-center pt-4">\n            <div class="col-12 col-md-8">\n              <form>\n                <div class="row">\n                  <div class="col-12 col-md">\n                    <input type="text" class="form-control" placeholder="Name">\n                  </div>\n                  <div class="col-12 col-md mt-4 mt-md-0">\n                    <input type="text" class="form-control" placeholder="Email">\n                  </div>\n                </div>\n\n                <div class="row mt-4">\n                  <div class="col">\n                    <input type="email" class="form-control" placeholder="Subject">\n                  </div>\n                </div>\n\n                <div class="row mt-4">\n                  <div class="col">\n                    <textarea class="form-control" name="message" rows="3" placeholder="How can we help?"></textarea>\n                  </div>\n                </div>\n                <div class="row mt-4">\n                  <div class="col text-center">\n                    <button type="submit" class="btn btn-primary">Submit</button>\n                  </div>\n                </div>\n              </form>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"contacts/4.jpg"),n.RegisterDesignBlock("Contacts",'<section class="fdb-block pt-0">\n  <div class="container-fluid p-0 pb-3">\n    <iframe class="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2848.8444388087937!2d26.101253041406952!3d44.43635311654287!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1ff4770adb5b7%3A0x58147f39579fe6fa!2zR3J1cHVsIFN0YXR1YXIgIkPEg3J1yJthIEN1IFBhaWHIm2Ui!5e0!3m2!1sen!2sro!4v1507381157656"\n      width="100%" height="300" frameborder="0" style="border:0" allowfullscreen=""></iframe>\n  </div>\n  <div class="container">\n    <div class="row text-center justify-content-center pt-5">\n      <div class="col-12 col-md-7">\n        <h1>Contact Us</h1>\n      </div>\n    </div>\n\n    <div class="row justify-content-center pt-4">\n      <div class="col-12 col-md-7">\n        <form>\n          <div class="row">\n            <div class="col">\n              <input type="text" class="form-control" placeholder="Email">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <input type="email" class="form-control" placeholder="Subject">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <textarea class="form-control" name="message" rows="3" placeholder="How can we help?"></textarea>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col text-center">\n              <button type="submit" class="btn btn-primary">Submit</button>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n    <div class="row-100"></div>\n  </div>\n  <div class="bg-dark">\n    <div class="container">\n      <div class="row-50"></div>\n      <div class="row justify-content-center text-center">\n        <div class="col-12 col-md mr-auto ml-auto">\n          <img alt="image" height="40" class="mb-2" src="{{imagesDir}}/icons/phone.svg">\n          <p class="lead">+44 (112) 123 752</p>\n        </div>\n\n        <div class="col-12 col-md pt-4 pt-md-0 mr-auto ml-auto">\n          <img alt="image" height="40" class="mb-2" src="{{imagesDir}}/icons/navigation.svg">\n          <p class="lead">123 6th St.<br>Melbourne, FL 32904</p>\n        </div>\n\n        <div class="col-12 col-md pt-4 pt-md-0 mr-auto ml-auto">\n          <img alt="image" height="40" class="mb-2" src="{{imagesDir}}/icons/mail.svg">\n          <p class="lead">support@website.com</p>\n        </div>\n      </div>\n      <div class="row-50"></div>\n    </div>\n  </div>\n\n  <div class="container">\n    <div class="row-70"></div>\n    <div class="row text-center">\n      <div class="col">\n        <p class="h2">\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-facebook"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-twitter"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-instagram"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-google"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-pinterest"></i></a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contacts/5.jpg"),n.RegisterDesignBlock("Contacts",'<section class="fdb-block pt-0">\n  <div class="container-fluid p-0 pb-5">\n    <iframe class="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2848.8444388087937!2d26.101253041406952!3d44.43635311654287!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1ff4770adb5b7%3A0x58147f39579fe6fa!2zR3J1cHVsIFN0YXR1YXIgIkPEg3J1yJthIEN1IFBhaWHIm2Ui!5e0!3m2!1sen!2sro!4v1507381157656"\n      width="100%" height="300" frameborder="0" style="border:0" allowfullscreen=""></iframe>\n  </div>\n  <div class="container">\n    <div class="row pt-5">\n      <div class="col-12">\n        <form>\n          <div class="row">\n            <div class="col-12 col-md">\n              <label>First Name</label>\n              <input type="text" class="form-control">\n            </div>\n            <div class="col-12 col-md mt-4 mt-md-0">\n              <label>Last Name</label>\n              <input type="text" class="form-control">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <label>Your Email</label>\n              <input type="email" class="form-control">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <label>Subject (optional but helpful)</label>\n              <input type="email" class="form-control">\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <label>How can we help?</label>\n              <textarea class="form-control" name="message" rows="3"></textarea>\n            </div>\n          </div>\n          <div class="row mt-4 text-center">\n            <div class="col">\n              <button type="submit" class="btn btn-primary">Submit</button>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n</section>\n',"contacts/6.jpg"),n.RegisterDesignBlock("Contacts",'<section class="fdb-block py-0">\n  <div class="container py-5" style="background-image: url({{imagesDir}}/shapes/6.svg);">\n    <div class="row text-center justify-content-center">\n      <div class="col-12 col-md-8 col-lg-7">\n        <h1>Contact Us</h1>\n        <p class="lead">If you’re already an active user, please <a href="https://www.froala.com">sign in</a> before contacting us.</p>\n      </div>\n    </div>\n    <div class="row-50">\n    </div>\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-8 col-lg-7">\n        <form>\n          <div class="row">\n            <div class="col">\n              <label>Your Email Address</label>\n              <input type="text" class="form-control">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <label>Subject (optional but helpful)</label>\n              <input type="email" class="form-control">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <label>How can we help?</label>\n              <textarea class="form-control" name="message" rows="3"></textarea>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col text-right">\n              <button type="submit" class="btn btn-dark">Submit</button>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n    <div class="row-100"></div>\n  </div>\n\n  <div class="container-fluid p-0">\n    <iframe class="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2848.8444388087937!2d26.101253041406952!3d44.43635311654287!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1ff4770adb5b7%3A0x58147f39579fe6fa!2zR3J1cHVsIFN0YXR1YXIgIkPEg3J1yJthIEN1IFBhaWHIm2Ui!5e0!3m2!1sen!2sro!4v1507381157656"\n      width="100%" height="300" frameborder="0" style="border:0" allowfullscreen=""></iframe>\n  </div>\n</section>\n',"contacts/7.jpg"),n.RegisterDesignBlock("Contacts",'<section class="fdb-block pt-0" style="background-image: url({{imagesDir}}/shapes/8.svg)">\n  <div class="bg-gray">\n    <div class="container">\n      <div class="row-100"></div>\n      <div class="row text-left">\n        <div class="col-8">\n          <h1>Contact Us</h1>\n          <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n        </div>\n      </div>\n      <div class="row-100"></div>\n    </div>\n  </div>\n  <div class="container bg-r">\n    <div class="row-100"></div>\n    <div class="row">\n      <div class="col-12 col-md-6 col-lg-5">\n        <h2>Call or email</h2>\n        <p class="text-large">Support, Sales, and Account Management services are currently available in English</p>\n\n        <p class="h3 mt-4 mt-lg-5">\n          <strong>Support</strong>\n        </p>\n        <p>\n          +800 3005 4300\n        </p>\n        <p>\n          <a href="https://www.froala.com">Contact Support</a>\n        </p>\n        <p>\n          Our technical support is available by phone or email from 11am to 11pm BST, Monday through Friday.\n        </p>\n\n        <p class="h3 mt-4 mt-lg-5">\n          <strong>Sales</strong>\n        </p>\n        <p>\n          +800 3005 4300\n        </p>\n        <p>\n          <a href="https://www.froala.com">Contact Sales</a>\n        </p>\n        <p>\n          Our technical support is available by phone or email from 11am to 11pm BST, Monday through Friday.\n        </p>\n\n        <p class="h3 mt-4 mt-lg-5">\n          <strong>General inquiries</strong>\n        </p>\n        <p>\n          <a href="https://www.froala.com">hello@website.com</a>\n        </p>\n      </div>\n\n      <div class="col-12 col-md-6 ml-auto">\n        <h2>Drop us a line</h2>\n        <form>\n          <div class="row">\n            <div class="col">\n              <input type="text" class="form-control" placeholder="First name">\n            </div>\n            <div class="col">\n              <input type="text" class="form-control" placeholder="Last name">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <input type="text" class="form-control" placeholder="Company Name">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <input type="email" class="form-control" placeholder="Email">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <input type="text" class="form-control" placeholder="Phone">\n            </div>\n            <div class="col">\n              <input type="text" class="form-control" placeholder="Country">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <select class="form-control" required="">\n                  <option value="">Select Department</option>\n                  <option value="1">Support</option>\n                  <option value="2">Sales</option>\n                  <option value="3">Accounting</option>\n                </select>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <textarea class="form-control" name="message" rows="5" placeholder="How can we help?"></textarea>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <button type="submit" class="btn btn-primary">Submit</button>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n</section>\n',"contacts/8.jpg"),n.RegisterDesignBlock("Contacts",'<section class="fdb-block bg-gray">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-12 col-md-8 col-lg-7">\n        <p class="h2">support@website.com</p>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n        <p><br></p>\n        <p class="h2">\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-facebook"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-twitter"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-instagram"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-google"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-pinterest"></i></a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contacts/9.jpg"),n.RegisterDesignBlock("Contacts",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-12 col-md-8 col-lg-7">\n        <h1>Contact Us</h1>\n        <p class="lead">Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n    </div>\n    <div class="row-70"></div>\n    <div class="row">\n      <div class="col-12 col-md-8 col-lg m-auto">\n        <form>\n          <div class="row">\n            <div class="col">\n              <input type="email" class="form-control" placeholder="Enter email">\n            </div>\n          </div>\n\n          <div class="row mt-4">\n            <div class="col">\n              <input type="email" class="form-control" placeholder="Subject">\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <textarea class="form-control" name="message" rows="3" placeholder="How can we help?"></textarea>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <button type="submit" class="btn btn-primary">Submit</button>\n            </div>\n          </div>\n        </form>\n      </div>\n\n      <div class="col-12 col-md-8 col-lg pt-5 m-auto pt-lg-0">\n        <iframe class="mb-4" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2848.8444388087937!2d26.101253041406952!3d44.43635311654287!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b1ff4770adb5b7%3A0x58147f39579fe6fa!2zR3J1cHVsIFN0YXR1YXIgIkPEg3J1yJthIEN1IFBhaWHIm2Ui!5e0!3m2!1sen!2sro!4v1507381157656"\n          width="100%" height="200" frameborder="0" style="border:0" allowfullscreen=""></iframe>\n\n        <p><strong>Showroom</strong></p>\n        <p>\n          71 Pilgrim Avenue<br>Chevy Chase, MD 20815\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contacts/10.jpg")}),function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col col-md-8 text-center">\n        <h1>Froala Design Blocks</h1>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/1.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col col-md-8 text-center">\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in <a href="https://www.froala.com">Bookmarksgrove</a> right at the coast of the Semantics, a large language\n          ocean.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/2.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col col-md-8 text-center">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far <a href="https://www.froala.com">World of Grammar</a>.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/3.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col col-sm-10 col-md-8 text-left">\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/4.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-end">\n      <div class="col col-sm-10 col-md-8 text-left">\n        <p class="lead">Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far <a href="https://www.froala.com">World of Grammar</a>.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/5.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col text-left">\n        <h2>Far far away...</h2>\n\n        <p>Far far away, behind the word mountains, far from the countries <a href="https://www.froala.com">Vokalia</a> and <a href="https://www.froala.com">Consonantia</a>, there live the blind texts. Separated they live in Bookmarksgrove right at the coast\n          of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth.</p>\n\n        <p>On her way she met a copy. The copy warned the Little Blind Text, that where it came from it would have been rewritten a thousand times and everything that was left from its origin would be the word "and" and the <a href="https://www.froala.com">Little Blind Text</a>          should turn around and return to its own, safe country. But nothing the copy said could convince her and so it didn’t take long until a few insidious Copy Writers ambushed her, made her drunk with Longe and Parole and dragged her into their\n          agency, where they abused her for their.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/6.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col text-center">\n        <h1>Froala Design Blocks</h1>\n\n        <div class="row text-left pt-4">\n          <div class="col-12 col-md-6">\n            <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden\n              flows by their place far far away.</p>\n          </div>\n          <div class="col-12 col-md-6">\n            <p class="lead">Separated they live in Bookmarksgrove right at the coast of the Semantics, far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at\n              the coast.</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/7.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col text-center">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Subtitle text about launch comes here.</p>\n        <p class="lead">\n          <a href="https://www.froala.com" class="mx-2">Learn More <i class="fas fa-angle-right"></i></a>\n          <a href="https://www.froala.com" class="mx-2">Buy <i class="fas fa-angle-right"></i></a>\n        </p>\n      </div>\n    </div>\n    <div class="row justify-content-center">\n      <div class="col-6">\n        <img alt="image" class="img-fluid mt-5" src="{{imagesDir}}/draws/hosting.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/8.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col text-center">\n        <h1>Froala Design Blocks</h1>\n      </div>\n    </div>\n\n    <div class="row pt-5 justify-content-center align-items-center">\n      <div class="col-4">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/developer.svg">\n      </div>\n      <div class="col-4 offset-1">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/git.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/9.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row pb-3">\n      <div class="col text-center">\n        <h1>Froala Design Blocks</h1>\n      </div>\n    </div>\n    <div class="row pt-5 justify-content-center align-items-center">\n      <div class="col-3">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/design-life.svg">\n      </div>\n      <div class="col-3 offset-1">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/designer.svg">\n      </div>\n      <div class="col-3 offset-1">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/design-community.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/10.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col text-center">\n        <h1>Froala Design Blocks</h1>\n      </div>\n    </div>\n\n    <div class="row pt-5 justify-content-center align-items-center">\n      <div class="col-6 col-md-2">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/shapes/1.svg">\n      </div>\n      <div class="col-6 col-md-2 offset-md-1">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/shapes/5.svg">\n      </div>\n      <div class="col-6 col-md-2 mt-4 mt-md-0 offset-md-1">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/shapes/7.svg">\n      </div>\n      <div class="col-6 col-md-2 mt-4 mt-md-0 offset-md-1">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/shapes/4.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/11.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-12 col-md-6 col-lg-5">\n        <h1>Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n      </div>\n      <div class="col-12 col-md-6 ml-md-auto mt-4 mt-md-0">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/shapes/2.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/12.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col col-md-8 text-center">\n        <img alt="image" class="fdb-icon mb-4" src="{{imagesDir}}/icons/gift.svg">\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/13.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-12 col-md-6 mb-4 mb-md-0">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/smile.svg">\n      </div>\n      <div class="col-12 col-md-6 col-lg-5 ml-md-auto text-left">\n        <h1>Froala Blocks</h1>\n        <p class="lead">A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth.</p>\n        <p><a class="btn btn-secondary mt-4" href="https://www.froala.com">Download</a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/14.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block" style="background-image: url({{imagesDir}}/shapes/8.svg)">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-12 col-md-6 col-lg-5">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/github.svg">\n        <h1>Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n      </div>\n      <div class="col-10 col-sm-6 m-auto col-md-4 pt-4 pt-md-0">\n        <img alt="image" class="img-fluid rounded-0" src="{{imagesDir}}/draws/chat.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/15.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-8 text-center">\n        <div class="row justify-content-center pb-5">\n          <div class="col-4 col-sm-3 col-md-2"><img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/layers.svg"></div>\n          <div class="col-4 col-sm-3 col-md-2"><img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/map.svg"></div>\n          <div class="col-4 col-sm-3 col-md-2"><img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/monitor.svg"></div>\n        </div>\n\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/16.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-10 col-sm-6 m-auto col-md-4 pb-4 pb-md-0">\n        <img alt="image" class="img-fluid rounded-0" src="{{imagesDir}}/draws/chatting.svg">\n      </div>\n\n      <div class="col-12 ml-auto col-md-6 col-lg-5">\n        <h1>Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n        <p><a class="btn btn-primary mt-4 mb-5 mb-md-0" href="https://www.froala.com">Download</a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/17.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-12 col-md-12 col-lg-6 col-xl-5">\n        <h1>Design Blocks</h1>\n        <p class="lead mb-5">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n\n        <p><strong>Works in every browser:</strong></p>\n        <p class="h1 text-muted">\n          <i class="fab fa-chrome mr-3"></i>\n          <i class="fab fa-safari mr-3"></i>\n          <i class="fab fa-firefox mr-3"></i>\n          <i class="fab fa-edge"></i>\n        </p>\n      </div>\n      <div class="col-12 col-md-8 m-auto ml-lg-auto mr-lg-0 col-lg-6 pt-5 pt-lg-0">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/browsers.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/18.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-left">\n      <div class="col-12 col-md-6">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/gift.svg">\n        <h3><strong>Awesome Things</strong></h3>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Far from the countries Vokalia and Consonantia.</p>\n      </div>\n      <div class="col-12 col-md-6 pt-5 pt-md-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/cloud.svg">\n        <h3><strong>More Awesomeness</strong></h3>\n        <p class="lead">Separated they live in Bookmarksgrove right at the coast of the Semantics, far far away, behind the word mountains, far from the countries <a href="https://www.froala.com">Vokalia and Consonantia</a>, there live the blind texts. </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/19.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block py-0">\n  <div class="container py-5 my-5" style="background-image: url({{imagesDir}}/shapes/10.svg);">\n    <div class="row text-left py-5">\n      <div class="col-12 col-sm-10 m-auto ml-md-5 col-md-8 col-lg-6">\n        <div class="fdb-box">\n          <div class="row justify-content-center">\n            <div class="col-12 col-xl-8 text-center">\n              <h1>Froala Design Blocks</h1>\n              <p class="lead">When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove</p>\n\n              <p class="h3 mt-4"><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/20.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block py-0">\n  <div class="container py-5 my-5 bg-r" style="background-image: url({{imagesDir}}/shapes/9.svg);">\n    <div class="row text-left py-5">\n      <div class="col-12 col-md-8 col-lg-6 ml-sm-auto">\n        <div class="fdb-box fdb-touch">\n          <div class="row justify-content-center">\n            <div class="col-12 col-xl-8 text-center">\n              <h1>Froala Design Blocks</h1>\n              <p class="lead">When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove</p>\n\n              <p class="h3 mt-4"><a href="https://www.froala.com" class="btn btn-primary">Register</a></p>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/21.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-lg-8 col-xl-6 text-center">\n        <img alt="image" width="200" src="{{imagesDir}}/logo.png">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies</p>\n\n        <p class="h3 mt-5"><a href="https://www.froala.com" class="btn btn-primary">Download Now</a></p>\n        <p>Latest Version: 2.3.5</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/22.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-10 col-sm-6 col-md-5 col-lg-4 m-auto pb-5 pb-md-0">\n        <img alt="image" class="img-fluid rounded-0" src="{{imagesDir}}/draws/iphone-hand.svg">\n      </div>\n\n      <div class="col-12 ml-md-auto col-md-7 col-lg-6 pb-5 pb-md-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/gift.svg">\n        <h1>Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts</p>\n        <p class="mt-4">\n          <a class="btn btn-secondary" href="https://www.froala.com">Download</a>\n          <a class="btn btn-dark ml-3" href="https://www.froala.com">Register</a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/23.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-12 col-md-7 col-lg-5 ml-md-auto">\n        <h1>Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts</p>\n\n        <p class="mt-5">\n          <img alt="image" height="25" class="mr-4" src="{{imagesDir}}/customers/samsung.svg">\n          <img alt="image" height="25" class="mr-4" src="{{imagesDir}}/customers/adobe.svg">\n          <img alt="image" height="25" src="{{imagesDir}}/customers/amazon.svg">\n        </p>\n      </div>\n\n      <div class="col-10 col-sm-6 col-md-5 col-lg-4 m-auto pt-5 pt-md-0">\n        <img alt="image" class="img-fluid rounded-0" src="{{imagesDir}}/draws/customer-survey.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/24.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col-12">\n        <div class="row justify-content-center pb-5">\n          <div class="col-12 col-lg-8 text-center">\n            <h1>Froala Design Blocks is Open Source and free to use</h1>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class="row justify-content-center">\n      <div class="col-8">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/android.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/25.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="col-fill-left" style="background-image: url({{imagesDir}}/people/5.jpg);">\n  </div>\n\n  <div class="container">\n    <div class="row justify-content-end">\n      <div class="col-12 col-md-5 text-center">\n        <h1>Froala Blocks</h1>\n        <p class="lead">When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove</p>\n\n        <p class="mt-4"><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/26.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="col-fill-right" style="background-image: url({{imagesDir}}/people/6.jpg);">\n  </div>\n\n  <div class="container py-5">\n    <div class="row">\n      <div class="col-12 col-md-5 text-center">\n        <h1>Froala Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n        <p class="mt-4 mb-5"><a class="btn btn-secondary" href="https://www.froala.com">Button</a></p>\n\n        <p>Follow us on</p>\n        <p>\n          <a href="https://www.froala.com" class="mx-2 text-secondary"><i class="fab fa-twitter" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2 text-secondary"><i class="fab fa-facebook" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2 text-secondary"><i class="fab fa-instagram" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2 text-secondary"><i class="fab fa-pinterest" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2 text-secondary"><i class="fab fa-google" aria-hidden="true"></i></a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/27.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block bg-dark">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12">\n        <h1>Made with <i class="fas fa-heart text-danger"></i> by Froala</h1>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/28.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center align-items-center">\n      <div class="col-8 col-md-4">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/photos/map-1.jpg">\n      </div>\n\n      <div class="col-4 col-md-2">\n        <div class="row">\n          <div class="col-12">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/photos/map-2.jpg">\n          </div>\n        </div>\n\n        <div class="row mt-4">\n          <div class="col-12">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/photos/map-3.jpg">\n          </div>\n        </div>\n      </div>\n\n      <div class="col-12 col-md-6 col-lg-5 ml-auto pt-5 pt-md-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/github.svg">\n        <h1>Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/29.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-6 col-lg-3">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/photos/fireworks-1.jpg">\n      </div>\n\n      <div class="col-6 col-lg-3">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/photos/fireworks-2.jpg">\n      </div>\n\n      <div class="col-12 col-lg-6 pt-3">\n        <p class="lead text-left">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove.</p>\n        <p class="lead text-left">Right at the coast of the Semantics, a large language ocean. A small river named Duden. <a href="https://www.froala.com">[Read More]</a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/30.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-left align-items-center">\n      <div class="col-12 col-md-6 col-lg-4">\n        <h2>Your Website</h2>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n        <p class="lead"><a href="https://www.froala.com">Read More</a></p>\n      </div>\n\n      <div class="col-12 col-md-6 col-lg-4 pt-4 pt-md-0">\n        <h2>Amazing Design</h2>\n        <p class="lead">Right at the coast of the Semantics, a large language ocean. A small river named Dude a rge language ocean there live the blind.</p>\n        <p class="lead"><a href="https://www.froala.com">Read More</a></p>\n      </div>\n\n      <div class="col-12 col-md-8 m-auto m-lg-0 col-lg-4 pt-5 pt-lg-0">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/tabs.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/31.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12">\n        <h1>Froala Design Blocks</h1>\n        <p class="h2"><em>Right at the coast of the Semantics, a large language ocean.</em></p>\n      </div>\n    </div>\n\n    <div class="row text-center pt-3 pt-xl-5">\n      <div class="col-12 col-sm-10 m-auto m-md-0 col-md-6">\n        <img alt="image" height="300" src="{{imagesDir}}/draws/tenis.svg">\n        <p class="lead pt-3">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia.</p>\n      </div>\n\n      <div class="col-12 col-sm-10 m-auto m-md-0 col-md-6 pt-5 pt-md-0">\n        <img alt="image" height="300" src="{{imagesDir}}/draws/basketball.svg">\n        <p class="lead pt-3">Right at the coast of the Semantics, a large language ocean. A small river named Duden.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/32.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block py-0">\n  <div class="container pt-5 mt-5" style="background-image: url({{imagesDir}}/shapes/9.svg);">\n    <div class="row text-left pt-5">\n      <div class="col-12 col-md-8 col-lg-6">\n        <div class="fdb-box fdb-touch rounded-bottom-0">\n          <h2><strong>Design Blocks</strong></h2>\n          <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics</p>\n          <p class="lead mt-4"><a href="https://www.froala.com">Read More</a></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/33.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block pb-0" style="background-image: url({{imagesDir}}/hero/purple.svg);">\n  <div class="container">\n    <div class="row text-left justify-content-end">\n      <div class="col-12 col-md-6 col-xl-5">\n        <div class="fdb-box rounded-bottom-0">\n          <h2><strong>Design Blocks</strong></h2>\n          <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. </p>\n\n          <p class="lead mt-4"><a class="btn btn-outline-primary" href="https://www.froala.com">Read More</a></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/34.jpg"),n.RegisterDesignBlock("Contents",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-left align-items-center">\n      <div class="col-10 col-sm-6 m-auto m-lg-0 col-lg-4">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/opened.svg">\n      </div>\n\n      <div class="col-12 col-lg-7 offset-lg-1 pt-4 pt-lg-0">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics.</p>\n\n        <div class="row mt-5">\n          <div class="col-12 col-sm-6">\n            <h3><strong>Open Source</strong></h3>\n            <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia.</p>\n          </div>\n\n          <div class="col-12 col-sm-6 pt-3 pt-sm-0">\n            <h3><strong>Bootstrap</strong></h3>\n            <p class="lead">Right at the coast of the Semantics, a large language ocean. A small river named Duden.</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/35.jpg")}),function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Custom",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col col-md-8 text-center">\n        <h1>Froala Design Blocks</h1>\n        <br>\n        <h2>Design your own custom block</h2>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/1.jpg"),n.RegisterDesignBlock("Custom",'<section class="fdb-block">\n  <div class="col-fill-left" style="background-image: url({{imagesDir}}/people/5.jpg);">\n  </div>\n\n  <div class="container">\n    <div class="row justify-content-end">\n      <div class="col-12 col-md-5 text-center">\n        <h1>Froala Blocks</h1>\n        <p class="lead">Design your own custom blocks. You can add the content and create your own blocks.</p>\n\n        <p class="mt-4"><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"contents/26.jpg")}),function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center justify-content-sm-center no-gutters">\n      <div class="col-12 col-sm-8 col-md-3 m-auto">\n        <h3><strong>Feature 1</strong></h3>\n        <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia.</p>\n      </div>\n\n      <div class="col-12 col-sm-8 col-md-3 m-auto pt-3 pt-md-0">\n        <h3><strong>Feature 2</strong></h3>\n        <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n\n      <div class="col-12 col-sm-8 col-md-3 m-auto pt-3 pt-md-0">\n        <h3><strong>Feature 3</strong></h3>\n        <p>A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>\n      </div>\n    </div>\n\n    <div class="row text-center justify-content-md-center pt-3 pt-md-5">\n      <div class="col-12 col-sm-8 col-md-3 m-auto">\n        <h3><strong>Feature 4</strong></h3>\n        <p>It is a paradisematic country, in which roasted parts of sentences fly into your mouth</p>\n      </div>\n\n      <div class="col-12 col-sm-8 col-md-3 m-auto pt-3 pt-md-0">\n        <h3><strong>Feature 5</strong></h3>\n        <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day.</p>\n      </div>\n\n      <div class="col-12 col-sm-8 col-md-3 m-auto pt-3 pt-md-0">\n        <h3><strong>Feature 6</strong></h3>\n        <p>The Big Oxmox advised her not to do so, because there were thousands of bad Commas, wild Question Marks</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/1.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-left justify-content-sm-center">\n      <div class="col-12 col-sm-6 col-lg-3 col-xl-2 ml-xl-auto mr-xl-auto">\n        <h3><strong>Feature 1</strong></h3>\n        <p>Far far away, behind the word mountains, far from the countries Vokalia.</p>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 col-xl-2 ml-xl-auto mr-xl-auto pt-3 pt-md-0 pt-lg-0">\n        <h3><strong>Feature 2</strong></h3>\n        <p>Separated they live in Bookmarksgrove right at the coast of the.</p>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 col-xl-2 ml-xl-auto mr-xl-auto pt-3 pt-lg-0">\n        <h3><strong>Feature 3</strong></h3>\n        <p>A small river named Duden flows by their place and supplies it with.</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-lg-3 col-xl-2 ml-xl-auto mr-xl-auto pt-3 pt-lg-0">\n        <h3><strong>Feature 4</strong></h3>\n        <p>But nothing the copy said could convince her and so it didn’t take long</p>\n      </div>\n    </div>\n\n    <div class="row text-left justify-content-sm-center pt-3 pt-lg-5">\n      <div class="col-12 col-sm-6 col-lg-3 col-xl-2 ml-xl-auto mr-xl-auto">\n        <h3><strong>Feature 5</strong></h3>\n        <p>Far far away, behind the word mountains, far from the countries Vokalia.</p>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 col-xl-2 ml-xl-auto mr-xl-auto pt-3 pt-md-0 pt-lg-0">\n        <h3><strong>Feature 6</strong></h3>\n        <p>Separated they live in Bookmarksgrove right at the coast of the.</p>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 col-xl-2 ml-xl-auto mr-xl-auto pt-3 pt-lg-0">\n        <h3><strong>Feature 7</strong></h3>\n        <p>A small river named Duden flows by their place and supplies it with.</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-lg-3 col-xl-2 ml-xl-auto mr-xl-auto pt-3 pt-lg-0">\n        <h3><strong>Feature 8</strong></h3>\n        <p>But nothing the copy said could convince her and so it didn’t take long</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/2.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col-12 text-center">\n        <h1>Features</h1>\n      </div>\n    </div>\n\n    <div class="row text-left justify-content-center pt-5">\n      <div class="col-12 col-md-6 col-lg-5 m-auto">\n        <h3><strong>Feature One</strong></h3>\n\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n      </div>\n      <div class="col-12 col-md-6 col-lg-5 m-auto pt-3 pt-md-0">\n        <h3><strong>Feature Two</strong></h3>\n\n        <p class="lead">Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line.</p>\n      </div>\n    </div>\n\n    <div class="row text-left justify-content-center pt-lg-4">\n      <div class="col-12 col-md-6 col-lg-5 m-auto pt-3 pt-lg-0">\n        <h3><strong>Feature Three</strong></h3>\n\n        <p class="lead">On her way she met a copy. The copy warned the Little Blind Text, that where it came from it would have been rewritten a thousand times.</p>\n      </div>\n      <div class="col-12 col-md-6 col-lg-5 m-auto pt-3 pt-lg-0">\n        <h3><strong>Feature Four</strong></h3>\n\n        <p class="lead">A small river named Duden flows by their place far far away, behind the word mountains, far from the countries Vokalia and Consonantia.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/3.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block bg-dark" style="background-image: url({{imagesDir}}/hero/purple.svg);">\n  <div class="container">\n    <div class="row">\n      <div class="col text-center">\n        <h1>Froala Design Blocks</h1>\n      </div>\n    </div>\n\n    <div class="row-70"></div>\n\n    <div class="row text-center justify-content-sm-center no-gutters">\n      <div class="col-12 col-sm-10 col-md-8 col-lg-7 col-xl-3 m-auto">\n        <div class="fdb-box fdb-touch">\n          <h2>Feature 1</h2>\n          <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia.</p>\n          <p class="mt-4"><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n        </div>\n      </div>\n      <div class="col-12 col-sm-10 col-md-8 col-lg-7 col-xl-3 m-auto pt-5 pt-xl-0">\n        <div class="fdb-box fdb-touch">\n          <h2>Feature 2</h2>\n          <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n          <p class="mt-4"><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n        </div>\n      </div>\n      <div class="col-12 col-sm-10 col-md-8 col-lg-7 col-xl-3 m-auto pt-5 pt-xl-0">\n        <div class="fdb-box fdb-touch">\n          <h2>Feature 3</h2>\n          <p>A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>\n          <p class="mt-4"><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/4.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-12 col-lg-6 col-xl-5">\n        <h1>Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n\n        <div class="row pt-4 pt-xl-5">\n          <div class="col-12 col-md-5">\n            <h4><strong>Feature One</strong></h4>\n            <p>A small river named Duden flows</p>\n          </div>\n          <div class="col-12 col-md-5 m-auto pt-3 pt-md-0">\n            <h4><strong>Feature Two</strong></h4>\n            <p>Separated they live in Bookmarksgrove</p>\n          </div>\n        </div>\n      </div>\n      <div class="col-12 col-md-8 col-lg-6 m-auto mr-lg-0 ml-lg-auto pt-5 pt-lg-0">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/scrum.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"features/5.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-12 col-md-8 col-lg-6 m-md-auto ml-lg-0 mr-lg-auto">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/features.svg">\n      </div>\n      <div class="col-12 col-lg-6 col-xl-5 ml-sm-auto pt-5 pt-lg-0">\n        <h1>Design Blocks</h1>\n\n        <div class="row pt-4 pt-xl-5">\n          <div class="col-12 col-sm-6 col-xl-5">\n            <h4><strong>Feature One</strong></h4>\n            <p>Far far away, behind the word mountains</p>\n          </div>\n          <div class="col-12 col-sm-6 col-xl-5 m-auto pt-3 pt-sm-0">\n            <h4><strong>Feature Two</strong></h4>\n            <p>Separated they live in Bookmarksgrove</p>\n          </div>\n        </div>\n\n        <div class="row pt-3">\n          <div class="col-12 col-sm-6 col-xl-5">\n            <h4><strong>Feature Three</strong></h4>\n            <p>A small river named Duden flows by me</p>\n          </div>\n          <div class="col-12 col-sm-6 col-xl-5 m-auto pt-3 pt-sm-0">\n            <h4><strong>Feature Four</strong></h4>\n            <p>Separated they live in Bookmarksgrove</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/6.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12 col-sm-6 col-lg-5 col-xl-4 m-auto">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/layers.svg">\n        <h3><strong>Feature 1</strong></h3>\n        <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-lg-5 col-xl-4 m-auto pt-4 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/github.svg">\n        <h3><strong>Feature 2</strong></h3>\n        <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/7.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12">\n        <h1>Features</h1>\n        <img alt="image" class="img-fluid mt-5" src="{{imagesDir}}/draws/email.svg">\n      </div>\n    </div>\n\n    <div class="row text-center justify-content-center mt-5 pt-5">\n      <div class="col-12 col-sm-4 col-lg-3 m-md-auto">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/monitor.svg">\n        <h3><strong>Feature 1</strong></h3>\n      </div>\n\n      <div class="col-12 col-sm-4 col-lg-3 m-auto pt-4 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/map.svg">\n        <h3><strong>Feature 2</strong></h3>\n      </div>\n\n      <div class="col-12 col-sm-4 col-lg-3 m-auto pt-4 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/package.svg">\n        <h3><strong>Feature 3</strong></h3>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/8.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12">\n        <h1>Features</h1>\n      </div>\n    </div>\n\n    <div class="row text-center justify-content-center mt-5">\n      <div class="col-12 col-sm-4 col-xl-3 m-md-auto">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/layers.svg">\n        <h3><strong>Feature 1</strong></h3>\n        <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia</p>\n      </div>\n\n      <div class="col-12 col-sm-4 col-xl-3 m-auto pt-4 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/gift.svg">\n        <h3><strong>Feature 2</strong></h3>\n        <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large ocean.</p>\n      </div>\n\n      <div class="col-12 col-sm-4 col-xl-3 m-auto pt-4 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/cloud.svg">\n        <h3><strong>Feature 3</strong></h3>\n        <p>A small river named Duden flows by their place and supplies it with the necessary regelialia</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/9.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12">\n        <h1>Features</h1>\n      </div>\n    </div>\n    <div class="row text-center justify-content-center mt-5">\n      <div class="col-12 col-sm-6 col-lg-3">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/monitor.svg">\n        <h3><strong>Feature One</strong></h3>\n        <p>Far far away, behind the word mountains, far from the countries</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-lg-3 pt-4 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/map-pin.svg">\n        <h3><strong>Feature Two</strong></h3>\n        <p>Separated they live in Bookmarksgrove right at the coast</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-lg-3 pt-4 pt-lg-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/life-buoy.svg">\n        <h3><strong>Feature Three</strong></h3>\n        <p>A small river named Duden flows by their place and supplies it</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-lg-3 pt-4 pt-lg-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/package.svg">\n        <h3><strong>Feature Four</strong></h3>\n        <p>Duden flows by their place far far away, behind the word mountains.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/10.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12">\n        <h1>Features</h1>\n      </div>\n    </div>\n    <div class="row text-left mt-5">\n      <div class="col-12 col-md-4">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/gift.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature One</strong></h3>\n            <p>Far far away, behind the word mountains, far from the countries</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-12 col-md-4 pt-3 pt-sm-4 pt-md-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/cloud.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Two</strong></h3>\n            <p>Even the all-powerful Pointing has no control about the blind texts.</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-12 col-md-4 pt-3 pt-sm-4 pt-md-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/map-pin.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Three</strong></h3>\n            <p>A small river named Duden flows by their place and supplies it</p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class="row text-left pt-3 pt-sm-4 pt-md-5">\n      <div class="col-12 col-md-4">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/layers.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Four</strong></h3>\n            <p>Duden flows by their place far far away, behind the word mountains.</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-12 col-md-4 pt-3 pt-sm-4 pt-md-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/life-buoy.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Five</strong></h3>\n            <p>Separated they live in Bookmarksgrove right at the coast</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-12 col-md-4 pt-3 pt-sm-4 pt-md-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/layout.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Six</strong></h3>\n            <p>On her way she met a copy. The copy warned the Little Blind Text.</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/11.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12">\n        <h1>Features</h1>\n      </div>\n    </div>\n    <div class="row text-left mt-5">\n      <div class="col-12 col-sm-6 col-lg-3">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/layers.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature One</strong></h3>\n            <p>Even the all-powerful Pointing has no control about the blind texts</p>\n          </div>\n        </div>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 pt-3 pt-sm-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/layout.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Two</strong></h3>\n            <p>Separated they live in Bookmarksgrove right at the coast</p>\n          </div>\n        </div>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 pt-3 pt-lg-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/life-buoy.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Three</strong></h3>\n            <p>A small river named Duden flows by their place and supplies it</p>\n          </div>\n        </div>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 pt-3 pt-lg-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/map-pin.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Four</strong></h3>\n            <p>Far far away, behind the word mountains, far from the countries</p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class="row text-left pt-3 pt-lg-5">\n      <div class="col-12 col-sm-6 col-lg-3">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/monitor.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Five</strong></h3>\n            <p>On her way she met a copy. The copy warned the Little Blind Text.</p>\n          </div>\n        </div>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 pt-3 pt-sm-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/package.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Six</strong></h3>\n            <p>Far far away, behind the word mountains, far from the countries</p>\n          </div>\n        </div>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 pt-3 pt-lg-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/cloud.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Seven</strong></h3>\n            <p>Duden flows by their place far far away, behind the word mountains.</p>\n          </div>\n        </div>\n      </div>\n      <div class="col-12 col-sm-6 col-lg-3 pt-3 pt-lg-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/gift.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Eight</strong></h3>\n            <p>Separated they live in Bookmarksgrove right at the coast</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/12.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-lg-right align-items-center">\n      <div class="col-12 col-sm-6 col-lg-3">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/gift.svg">\n        <h4><strong>Feature One</strong></h4>\n        <p>Far far away, behind the word mountains is hope.</p>\n\n        <img alt="image" class="fdb-icon mt-3 mt-xl-5" src="{{imagesDir}}/icons/layers.svg">\n        <h4><strong>Feature Two</strong></h4>\n        <p>On her way she met a copy of the Little Blind Text.</p>\n\n        <img alt="image" class="fdb-icon mt-3 mt-xl-5" src="{{imagesDir}}/icons/map.svg">\n        <h4><strong>Feature Three</strong></h4>\n        <p>Even the all-powerful has no control about the blind texts</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-lg-3 text-left pt-3 pt-sm-0 order-lg-12">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/map-pin.svg">\n        <h4><strong>Feature Four</strong></h4>\n        <p>Duden flows by their place, behind the word mountains.</p>\n\n        <img alt="image" class="fdb-icon mt-3 mt-xl-5" src="{{imagesDir}}/icons/package.svg">\n        <h4><strong>Feature Five</strong></h4>\n        <p>Separated they live in Bookmark right at the coast</p>\n\n        <img alt="image" class="fdb-icon mt-3 mt-xl-5" src="{{imagesDir}}/icons/monitor.svg">\n        <h4><strong>Feature Six</strong></h4>\n        <p>A small river named Duden flows by their place and supplies it</p>\n      </div>\n\n      <div class="col-7 col-sm-4 col-lg-4 m-auto pt-5 pt-lg-0 order-lg-1">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/simple-iphone.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"features/13.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-right align-items-center">\n      <div class="col-7 col-md-4 m-auto">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/simple-iphone.svg">\n      </div>\n\n      <div class="col-12 col-md-7 col-lg-5 m-auto text-left pt-5 pt-md-0">\n        <div class="row pb-lg-5">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/layers.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Seven</strong></h3>\n            <p>Even the all-powerful Pointing has no control about the blind texts.</p>\n          </div>\n        </div>\n\n        <div class="row pt-4 pt-md-5 pb-lg-5">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/monitor.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Seven</strong></h3>\n            <p>Duden flows by their place far far away, behind the word mountains.</p>\n          </div>\n        </div>\n\n\n        <div class="row pt-4 pt-md-5">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/cloud.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Seven</strong></h3>\n            <p>A small river named Duden flows by their place and supplies it.</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/14.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-right align-items-center">\n      <div class="col-12 col-lg-6 col-xl-5 m-lg-auto text-left">\n        <h1>Features</h1>\n        <p class="h3 pb-xl-4">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n\n        <div class="row pt-5">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/gift.svg">\n          </div>\n          <div class="col-9">\n            <p>A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences.</p>\n          </div>\n        </div>\n\n        <div class="row pt-5">\n          <div class="col-9 text-right">\n            <p>When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove, there live the blind texts.</p>\n          </div>\n\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/map-pin.svg">\n          </div>\n        </div>\n      </div>\n\n      <div class="col-7 col-sm-4 m-auto pt-5 pt-md-0">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/simple-iphone.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"features/15.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center pb-xl-5">\n      <div class="col-12 col-md-8 text-center">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n    </div>\n\n    <div class="row text-right align-items-center-lg align-items-end pt-5">\n      <div class="col-7 col-sm-4 m-auto mb-md-0 mt-md-0 m-lg-auto">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/simple-iphone.svg">\n      </div>\n\n      <div class="col-12 col-md-7 col-lg-6 col-xl-5 m-auto text-left pt-5 pt-md-0">\n        <h3><strong>Feature One</strong></h3>\n        <p>A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences.</p>\n\n        <h3 class="mt-4 mt-xl-5"><strong>Feature Two</strong></h3>\n        <p>When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove, there live the blind texts.</p>\n\n        <h3 class="mt-4 mt-xl-5"><strong>Feature Three</strong></h3>\n        <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/16.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col text-left">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n    </div>\n    <div class="row justify-content-center mb-5">\n      <div class="col-10">\n        <img alt="image" class="img-fluid mt-5" src="{{imagesDir}}/draws/android.svg">\n      </div>\n    </div>\n\n    <div class="row text-left pt-5">\n      <div class="col-12 col-md-4">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/github.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature One</strong></h3>\n            <p>Far far away, behind the word mountains, far from the countries</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-12 col-md-4 pt-4 pt-md-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/layers.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Two</strong></h3>\n            <p>Separated they live in Bookmarksgrove right at the coast</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-12 col-md-4 pt-4 pt-md-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/life-buoy.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Three</strong></h3>\n            <p>A small river named Duden flows by their place and supplies it</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/17.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 text-center">\n        <h1>Features</h1>\n      </div>\n    </div>\n\n    <div class="row text-center mt-5">\n      <div class="col-12 col-sm-4">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/gift.svg">\n        <h3><strong>Feature One</strong></h3>\n        <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts</p>\n      </div>\n\n      <div class="col-12 col-sm-4 pt-4 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/cloud.svg">\n        <h3><strong>Feature Two</strong></h3>\n        <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. </p>\n      </div>\n\n      <div class="col-12 col-sm-4 pt-4 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/layers.svg">\n        <h3><strong>Feature Three</strong></h3>\n        <p>A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country,</p>\n      </div>\n    </div>\n\n    <div class="row mt-5 justify-content-center">\n      <div class="col-8">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/product-tour.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"features/18.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 text-left">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n    </div>\n\n    <div class="row text-left mt-5">\n      <div class="col-12 col-sm-8 col-md-4 col-lg-3 m-sm-auto mr-md-auto ml-md-0">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/hero/blue.svg">\n        <h3><strong>Feature One</strong></h3>\n        <p>Far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n\n      <div class="col-12 col-sm-8 col-md-4 col-lg-3 m-sm-auto pt-5 pt-md-0">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/hero/red.svg">\n        <h3><strong>Feature Two</strong></h3>\n        <p> It is a paradisematic country, in which roasted parts of sentences fly into your mouth. Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life.</p>\n      </div>\n\n      <div class="col-12 col-sm-8 col-md-4 col-lg-3 m-sm-auto ml-md-auto mr-md-0 pt-5 pt-md-0">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/hero/yellow.svg">\n        <h3><strong>Feature Three</strong></h3>\n        <p>The Big Oxmox advised her not to do so, because there were thousands of bad Commas, wild Question Marks and devious Semikoli, but the Little Blind Text didn’t listen.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/19.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 text-left">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n\n        <img alt="image" class="img-fluid mt-5" src="{{imagesDir}}/draws/android.svg">\n      </div>\n    </div>\n\n    <div class="row text-left pt-5">\n      <div class="col-12 col-md-6">\n        <h3><strong>Feature One</strong></h3>\n\n        <p>Far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies it with\n          the necessary regelialia. When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove, the headline of Alphabet Village and the subline of her own road, the Line Lane.</p>\n\n        <p><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n      </div>\n      <div class="col-12 col-md-6 pt-4 pt-md-0">\n        <h3><strong>Feature Two</strong></h3>\n\n        <p> It is a paradisematic country, in which roasted parts of sentences fly into your mouth. Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life. The Big Oxmox advised her not to do so, because there\n          were thousands of bad Commas, wild Question Marks and devious Semikoli. On her way she met a copy. The copy warned the Little Blind Text, that where it came from it would have been rewritten a thousand times and everything that was left from\n          its origin.</p>\n\n        <p><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/20.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 text-left">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. On her way she met a copy.\n          The copy warned the Little Blind Text, that where it came from it would have been rewritten a thousand times and everything that was left from its origin would be the word "and" and the Little Blind Text.</p>\n      </div>\n    </div>\n\n    <div class="row text-left pt-5">\n      <div class="col-12 col-sm-6 col-md-5">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/layers.svg">\n        <h3><strong>Feature One</strong></h3>\n        <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-5 ml-sm-auto pt-5 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/package.svg">\n        <h3><strong>Feature Two</strong></h3>\n        <p>It is a paradisematic country, in which roasted parts of sentences fly into your mouth. Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/21.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center pb-5">\n      <div class="col-12 text-center">\n        <h1>Froala Design Blocks</h1>\n      </div>\n    </div>\n\n    <div class="row text-left align-items-center pt-5 pb-md-5">\n      <div class="col-4 col-md-5">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/designer.svg">\n      </div>\n\n      <div class="col-12 col-md-5 m-md-auto">\n        <h2><strong>Feature One</strong></h2>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n        <p><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n      </div>\n    </div>\n\n    <div class="row text-left align-items-center pt-5 pb-md-5">\n      <div class="col-4 col-md-5 m-md-auto order-md-5">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/design-life.svg">\n      </div>\n\n      <div class="col-12 col-md-5">\n        <h2><strong>Feature Two</strong></h2>\n        <p class="lead">Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.</p>\n        <p><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n      </div>\n    </div>\n\n    <div class="row text-left align-items-center pt-5">\n      <div class="col-4 col-md-5">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/design-community.svg">\n      </div>\n\n      <div class="col-12 col-md-5 m-md-auto">\n        <h2><strong>Feature Three</strong></h2>\n        <p class="lead">On her way she met a copy. The copy warned the Little Blind Text, that where it came from it would have been rewritten a thousand times and everything that was left from its origin would be the word "and" and the Little Blind Text should turn\n          around.\n        </p>\n        <p><a href="https://www.froala.com">Learn More <i class="fas fa-angle-right"></i></a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/22.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col-12 col-md-10 col-lg-8 text-left">\n        <h1>Froala Design Blocks is simply ahead the word mountains</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n\n        <p class="lead"><a href="https://www.froala.com">Explore all features <i class="fas fa-angle-right"></i></a></p>\n      </div>\n    </div>\n\n    <div class="row text-center no-gutters pt-5">\n      <div class="col-12 col-md-10 col-lg-8">\n        <div class="row">\n          <div class="col-8 col-sm-5 col-md-2 m-auto">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/github.svg">\n            <h4>Feature One</h4>\n          </div>\n          <div class="col-8 col-sm-5 col-md-2 m-auto pt-5 pt-sm-0">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/monitor.svg">\n            <h4>Feature Two</h4>\n          </div>\n          <div class="col-8 col-sm-5 col-md-2 m-auto pt-5 pt-md-0">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/layers.svg">\n            <h4>Feature Three</h4>\n          </div>\n          <div class="col-8 col-sm-5 col-md-2 m-auto pt-5 pt-md-0">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/cloud.svg">\n            <h4>Feature Four</h4>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/23.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-top">\n      <div class="col-12 col-md-6 col-xl-4 m-auto">\n        <h2>Learn more about the Froala Design Blocks you love</h2>\n      </div>\n\n      <div class="col-12 col-md-6 pt-5 pt-md-0">\n        <div class="row justify-content-left">\n          <div class="col-3 m-auto text-center">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/gift.svg">\n            <p><a href="https://www.froala.com">One <i class="fas fa-angle-right"></i></a></p>\n          </div>\n          <div class="col-3 m-auto text-center">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/map.svg">\n            <p><a href="https://www.froala.com">Two <i class="fas fa-angle-right"></i></a></p>\n          </div>\n          <div class="col-3 m-auto text-center">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/life-buoy.svg">\n            <p><a href="https://www.froala.com">Three <i class="fas fa-angle-right"></i></a></p>\n          </div>\n        </div>\n\n        <div class="row justify-content-left mt-4 mt-xl-5">\n          <div class="col-3 m-auto text-center">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/layout.svg">\n            <p><a href="https://www.froala.com">Four <i class="fas fa-angle-right"></i></a></p>\n          </div>\n          <div class="col-3 m-auto text-center">\n            <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/map-pin.svg">\n            <p><a href="https://www.froala.com">Five <i class="fas fa-angle-right"></i></a></p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/24.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12">\n        <h1>There is a feature for everyone</h1>\n        <p class="lead"><a href="https://www.froala.com">See all features <i class="fas fa-angle-right"></i></a>\n        </p>\n      </div>\n    </div>\n\n    <div class="row text-center justify-content-center mt-5">\n      <div class="col-10 col-sm-3">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/hero/blue.svg">\n        <h3><strong>Feature One</strong></h3>\n      </div>\n      <div class="col-10 col-sm-3 pt-5 pt-sm-0">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/hero/red.svg">\n        <h3><strong>Feature Two</strong></h3>\n      </div>\n\n      <div class="col-10 col-sm-3 pt-5 pt-sm-0">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/hero/purple.svg">\n        <h3><strong>Feature Three</strong></h3>\n      </div>\n\n      <div class="col-10 col-sm-3 pt-5 pt-sm-0">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/hero/yellow.svg">\n        <h3><strong>Feature Four</strong></h3>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/25.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center pb-xl-5">\n      <div class="col-12 col-md-7 col-xl-5">\n        <h1>Froala Design Blocks</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n      </div>\n      <div class="col-12 col-sm-6 col-md-4 m-sm-auto mr-md-0 ml-md-auto pt-4 pt-md-0">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/developer.svg">\n      </div>\n    </div>\n\n    <div class="row pt-5">\n      <div class="col-12 col-sm-6 col-md-3">\n        <h3><strong>Feature One</strong></h3>\n        <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large ocean.</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-3 pt-3 pt-sm-0">\n        <h3><strong>Feature Two</strong></h3>\n        <p>A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-3 pt-3 pt-md-0">\n        <h3><strong>Feature Three</strong></h3>\n        <p>It is a paradisematic country, in which roasted parts of sentences fly into your mouth.</p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-3 pt-3 pt-md-0">\n        <h3><strong>Feature Four</strong></h3>\n        <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/26.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center pb-xl-5">\n      <div class="col-8 col-sm-8 text-center">\n        <h1>Froala Design Blocks</h1>\n        <img alt="image" class="img-fluid mt-5" src="{{imagesDir}}/draws/development.svg">\n      </div>\n    </div>\n\n    <div class="row text-left justify-content-center pt-5">\n      <div class="col-12 col-md-6 col-lg-5 m-sm-auto">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/github.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature One</strong></h3>\n            <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life.</p>\n          </div>\n        </div>\n      </div>\n      <div class="col-12 col-md-6 col-lg-5 m-sm-auto pt-3 pt-sm-5 pt-md-0">\n        <div class="row">\n          <div class="col-3">\n            <img alt="image" class="img-fluid" src="{{imagesDir}}/icons/layers.svg">\n          </div>\n          <div class="col-9">\n            <h3><strong>Feature Two</strong></h3>\n            <p>Separated they live in Bookmarksgrove, right at the coast of the Semantics, a large language ocean.</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/27.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12">\n        <h1>Features</h1>\n      </div>\n    </div>\n    <div class="row text-center justify-content-center mt-5">\n      <div class="col-12 col-md-4 col-lg-3 m-md-auto">\n        <h3><strong>Feature 1</strong></h3>\n        <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia</p>\n      </div>\n\n      <div class="col-12 col-md-4 col-lg-3 m-md-auto pt-3 pt-md-0">\n        <h3><strong>Feature 2</strong></h3>\n        <p>Separated they live in Bookmarksgrove right at the coast, a large language ocean.</p>\n      </div>\n\n      <div class="col-12 col-md-4 col-lg-3 m-md-auto pt-3 pt-md-0">\n        <h3><strong>Feature 3</strong></h3>\n        <p>A small river named Duden flows by their place and supplies it with the necessary regelialia</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/28.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12col-md-10 col-lg-8 text-center">\n        <h1>Froala Design Blocks</h1>\n      </div>\n    </div>\n\n    <div class="row justify-content-center text-center mt-5">\n      <div class="col-12 col-sm-6 col-md-5 col-lg-3">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/github.svg">\n        <h3><strong>Feature one longer Text</strong></h3>\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-5 col-lg-3 pt-4 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/gift.svg">\n        <h3><strong>Feature two shorter</strong></h3>\n      </div>\n    </div>\n\n    <div class="row justify-content-center text-center mt-5 mt-md-4 pt-5">\n      <div class="col-12 col-md-10 col-lg-8">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/social-media.svg">\n        <p><em>Coming this fall</em></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/29.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12 col-sm-6 col-md-3">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/monitor.svg">\n        <h3><strong>The all-powerful Pointing has no control</strong></h3>\n        <p class="mt-3"><a class="btn btn-primary" href="https://www.froala.com">Learn</a></p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-3 pt-5 pt-sm-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/layout.svg">\n        <h3><strong>Far far away, behind the word mountains</strong></h3>\n        <p class="mt-3"><a class="btn btn-primary" href="https://www.froala.com">Learn</a></p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-3 pt-5 pt-md-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/map-pin.svg">\n        <h3><strong>The Big Oxmox advised her not to do so</strong></h3>\n        <p class="mt-3"><a class="btn btn-primary" href="https://www.froala.com">Learn</a></p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-3 pt-5 pt-md-0">\n        <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/github.svg">\n        <h3><strong>The copy warned the Little Blind Text</strong></h3>\n        <p class="mt-3"><a class="btn btn-primary" href="https://www.froala.com">Learn</a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/30.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12 col-md-8 m-auto col-lg-4">\n        <div class="fdb-box fdb-touch">\n          <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/map.svg">\n          <h2>Feature 1</h2>\n          <p>Far far away, behind the word mountains, far from the countries.</p>\n        </div>\n      </div>\n\n      <div class="col-12 col-md-8 m-auto col-lg-4 pt-5 pt-lg-0">\n        <div class="fdb-box fdb-touch">\n          <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/cloud.svg">\n          <h2>Feature 2</h2>\n          <p>Separated they live in Bookmarksgrove right at the coast.</p>\n        </div>\n      </div>\n\n      <div class="col-12 col-md-8 m-auto col-lg-4 pt-5 pt-lg-0">\n        <div class="fdb-box fdb-touch">\n          <img alt="image" class="fdb-icon" src="{{imagesDir}}/icons/package.svg">\n          <h2>Feature 3</h2>\n          <p>A small river named Duden flows by their place and supplies.</p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/31.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-left">\n      <div class="col-12 col-md-8 m-auto col-lg-4">\n        <div class="fdb-box fdb-touch">\n          <h2>Feature 1</h2>\n          <p>Far far away, behind the word mountains, far from the country Vokalia, there live the blind texts.</p>\n          <p><a href="https://www.froala.com">Read more</a></p>\n        </div>\n      </div>\n      <div class="col-12 col-md-8 m-auto col-lg-4 pt-5 pt-lg-0">\n        <div class="fdb-box fdb-touch">\n          <h2>Feature 2</h2>\n          <p>Separated they live in Bookmarks right at the coast of the Semantics, a large language ocean.</p>\n          <p><a href="https://www.froala.com">Read more</a></p>\n        </div>\n      </div>\n      <div class="col-12 col-md-8 m-auto col-lg-4 pt-5 pt-lg-0">\n        <div class="fdb-box fdb-touch">\n          <h2>Feature 3</h2>\n          <p>A small river named Duden flows by their small place and supplies it with the necessary regelialia.</p>\n          <p><a href="https://www.froala.com">Read more</a></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/32.jpg"),n.RegisterDesignBlock("Features",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-left">\n      <div class="col-12 col-md-4">\n        <h2>Feature One</h2>\n        <p><strong>Far far away</strong>, behind the word mountains, far from the countries <a href="https://www.froala.com">Vokalia and Consonantia</a>, there live the blind texts.</p>\n      </div>\n\n      <div class="col-12 col-md-4 pt-5 pt-sm-4 pt-md-0">\n        <h2>Feature Two</h2>\n        <p> A small river named Duden flows by their place and supplies it with the necessary regelialia.</p>\n      </div>\n\n      <div class="col-12 col-md-4 pt-5 pt-sm-4 pt-md-0">\n        <h2>Feature Three</h2>\n        <p>Even the all-powerful Pointing has no control about the <strong>blind texts</strong> it is an almost unorthographic life.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"features/33.jpg")}),function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Footers",'<footer class="fdb-block footer-small">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <p>© 2018 Froala. All Rights Reserved</p>\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/1.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-small bg-dark">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-12 col-md-8">\n        <ul class="nav justify-content-center justify-content-md-start">\n          <li class="nav-item">\n            <a class="nav-link active" href="https://www.froala.com">Home</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Terms</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">About</a>\n          </li>\n        </ul>\n      </div>\n\n      <div class="col-12 col-md-4 mt-4 mt-md-0 text-center text-md-right">\n        © 2018 Froala. All Rights Reserved\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/2.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-small">\n  <div class="container">\n    <div class="row text-center align-items-center">\n      <div class="col-12 col-md-8">\n        <ul class="nav justify-content-center justify-content-md-start align-items-center">\n          <li class="nav-item">\n            <a class="nav-link active" href="https://www.froala.com">\n                <img alt="image" src="{{imagesDir}}/logo.png" height="40">\n              </a>\n          </li>\n          <li class="w-100 d-block d-sm-none"></li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Terms</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">About</a>\n          </li>\n        </ul>\n      </div>\n\n      <div class="col-12 col-md-4 mt-4 mt-md-0 text-md-right">\n        © 2013-2018 Froala\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/3.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-small">\n  <div class="container">\n    <div class="row text-center align-items-center">\n      <div class="col-12 col-sm-6 col-md-4 text-sm-left">\n        <img alt="image" src="{{imagesDir}}/logo.png" height="40">\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-4 mt-4 mt-sm-0 text-center text-sm-right text-md-center">\n        © 2013-2018 Froala\n      </div>\n\n      <div class="col-12 col-md-4 mt-4 mt-md-0 text-center text-md-right">\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-twitter" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-facebook" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-instagram" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-pinterest" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-google" aria-hidden="true"></i></a>\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/4.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-small">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-12 col-md-6">\n        <ul class="nav justify-content-center justify-content-md-start">\n          <li class="nav-item">\n            <a class="nav-link active" href="https://www.froala.com">Home</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Terms</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">About</a>\n          </li>\n        </ul>\n      </div>\n\n      <div class="col-12 col-md-6 mt-4 mt-md-0 text-center text-md-right">\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-twitter" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-facebook" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-instagram" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-pinterest" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-google" aria-hidden="true"></i></a>\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/5.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-small bg-dark">\n  <div class="container">\n    <div class="row text-center align-items-center">\n      <div class="col">\n        <ul class="nav justify-content-center">\n          <li class="nav-item">\n            <a class="nav-link active" href="https://www.froala.com">Home</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Privacy Policy</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Terms</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">About</a>\n          </li>\n        </ul>\n\n        <p class="h5 mt-5">© 2013-2018 Froala</p>\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/6.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-small">\n  <div class="container">\n    <div class="row text-center align-items-center">\n      <div class="col-12 col-lg-2 text-lg-left">\n        <img alt="image" src="{{imagesDir}}/logo.png" height="40">\n      </div>\n\n      <div class="col mt-4 mt-lg-0 text-center">\n        <ul class="nav justify-content-center">\n          <li class="nav-item">\n            <a class="nav-link active" href="https://www.froala.com">Home</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Privacy Policy</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Terms</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">About</a>\n          </li>\n        </ul>\n      </div>\n\n      <div class="col-12 col-lg-2 mt-4 mt-lg-0 text-lg-right">\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-twitter" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-facebook" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-instagram" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-pinterest" aria-hidden="true"></i></a>\n        <a href="https://www.froala.com" class="mx-2"><i class="fab fa-google" aria-hidden="true"></i></a>\n      </div>\n    </div>\n\n    <div class="row mt-4">\n      <div class="col text-center">\n        © 2018 Froala. All Rights Reserved\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/7.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-small">\n  <div class="container">\n    <div class="row align-items-center">\n      <div class="col-12 col-md-6">\n        <ul class="nav justify-content-center justify-content-md-start">\n          <li class="nav-item">\n            <a class="nav-link active" href="https://www.froala.com">Home</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Terms</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">About</a>\n          </li>\n        </ul>\n      </div>\n\n      <div class="col mt-4 mt-md-0 text-center text-md-right">\n        <a href="https://www.froala.com" class="btn btn-primary">Contact Us</a>\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/8.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-large">\n  <div class="container">\n    <div class="row align-items-top text-center">\n      <div class="col-12 col-sm-6 col-md-4 col-lg-3 text-sm-left">\n        <h3><strong>Group 1</strong></h3>\n        <nav class="nav flex-column">\n          <a class="nav-link active" href="https://www.froala.com">Home</a>\n          <a class="nav-link" href="https://www.froala.com">Features</a>\n          <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          <a class="nav-link" href="https://www.froala.com">Team</a>\n          <a class="nav-link" href="https://www.froala.com">Contact Us</a>\n        </nav>\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-4 col-lg-3 mt-5 mt-sm-0 text-sm-left">\n        <h3><strong>Group 2</strong></h3>\n        <nav class="nav flex-column">\n          <a class="nav-link active" href="https://www.froala.com">Privacy Policy</a>\n          <a class="nav-link" href="https://www.froala.com">Terms</a>\n          <a class="nav-link" href="https://www.froala.com">FAQ</a>\n          <a class="nav-link" href="https://www.froala.com">Support</a>\n        </nav>\n      </div>\n\n      <div class="col-12 col-md-4 col-lg-3 text-md-left mt-5 mt-md-0">\n        <h3><strong>About Us</strong></h3>\n        <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n      </div>\n\n      <div class="col-12 col-lg-2 ml-auto text-lg-left mt-4 mt-lg-0">\n        <h3><strong>Follow Us</strong></h3>\n        <p class="lead">\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-twitter" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-facebook" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-instagram" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-pinterest" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-google" aria-hidden="true"></i></a>\n        </p>\n      </div>\n    </div>\n\n    <div class="row mt-3">\n      <div class="col text-center">\n        © 2018 Froala. All Rights Reserved\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/9.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-large bg-dark">\n  <div class="container">\n    <div class="row align-items-top text-center text-md-left">\n      <div class="col-12 col-sm-6 col-md-4">\n        <h3><strong>Country A</strong></h3>\n        <p>Street Address 52<br>Contact Name</p>\n        <p>+44 827 312 5002</p>\n        <p><a href="https://www.froala.com">countrya@amazing.com</a></p>\n      </div>\n\n      <div class="col-12 col-sm-6 col-md-4 mt-4 mt-sm-0">\n        <h3><strong>Country B</strong></h3>\n        <p>Street Address 100<br>Contact Name</p>\n        <p>+13 827 312 5002</p>\n        <p><a href="https://www.froala.com">countryb@amazing.com</a></p>\n      </div>\n\n      <div class="col-12 col-md-4 mt-5 mt-md-0 text-md-left">\n        <h3><strong>About Us</strong></h3>\n        <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n      </div>\n    </div>\n\n    <div class="row mt-5">\n      <div class="col text-center">\n        © 2018 Froala. All Rights Reserved\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/10.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-small">\n  <div class="container">\n    <div class="row align-items-center text-center">\n      <div class="col-12 col-lg-4 text-lg-left">\n        © 2018 Froala\n      </div>\n\n      <div class="col-12 col-lg-4 mt-4 mt-lg-0">\n        <img alt="image" src="{{imagesDir}}/logo.png" height="40">\n      </div>\n\n      <div class="col-12 col-lg-4 text-lg-right mt-4 mt-lg-0">\n        <ul class="nav justify-content-lg-end justify-content-center">\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Privacy</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Terms</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">About</a>\n          </li>\n        </ul>\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/11.jpg"),n.RegisterDesignBlock("Footers",'<footer class="fdb-block footer-large">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <h3>Company Name</h3>\n        <p>70 Bowman St.<br>South Windsor, CT 06074</p>\n        <p>USA</p>\n        <p>+13 827 312 5002</p>\n      </div>\n    </div>\n\n    <div class="row mt-4">\n      <div class="col text-center">\n        <p class="lead">\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-twitter" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-facebook" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-instagram" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-pinterest" aria-hidden="true"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-google" aria-hidden="true"></i></a>\n        </p>\n      </div>\n    </div>\n  </div>\n</footer>\n',"footers/12.jpg")}),function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Forms",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-8 col-lg-6 text-center">\n        <h1>Subscribe</h1>\n        <div class="input-group mt-4 mb-4">\n          <input type="text" class="form-control" placeholder="Enter your email address">\n          <div class="input-group-append">\n            <button class="btn btn-primary" type="button">Submit</button>\n          </div>\n        </div>\n\n        <p class="h4">Find us on <a href="https://www.froala.com">Facebook</a> and <a href="https://www.froala.com">Twitter</a>.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/1.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block" style="background-image: url({{imagesDir}}/hero/blue.svg);">\n  <div class="container">\n    <div class="fdb-box">\n      <div class="row justify-content-center align-items-center">\n        <div class="col-12 col-lg-6">\n          <h2>Join us!</h2>\n          <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia. </p>\n        </div>\n        <div class="col-12 col-lg-5 text-center">\n          <div class="input-group mt-4">\n            <input type="text" class="form-control" placeholder="Enter your email address">\n            <div class="input-group-append">\n              <button class="btn btn-primary" type="button">Submit</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/2.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-lg-10 col-xl-8 text-center">\n        <div class="row">\n          <div class="col">\n            <h1>Register</h1>\n            <p class="lead">When she reached the first hills, she had a last view back on the skyline of her hometown.</p>\n          </div>\n        </div>\n        <div class="row align-items-center">\n          <div class="col-12 col-md-5 mt-4">\n            <input type="text" class="form-control" placeholder="Email">\n          </div>\n          <div class="col-12 col-md-5 mt-4">\n            <input type="password" class="form-control" placeholder="Password">\n          </div>\n          <div class="col-12 col-md-2 mt-4">\n            <button class="btn btn-secondary" type="button">Submit</button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/3.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block py-0">\n  <div class="container py-5 my-5" style="background-image: url({{imagesDir}}/shapes/6.svg);">\n    <div class="row">\n      <div class="col-12 col-md-8 col-lg-7 col-xl-5 text-left">\n        <div class="row">\n          <div class="col">\n            <h1>Sign Up</h1>\n            <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia. </p>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col mt-4">\n            <input type="text" class="form-control" placeholder="Email">\n          </div>\n        </div>\n        <div class="row mt-4">\n          <div class="col">\n            <input type="password" class="form-control" placeholder="Password">\n          </div>\n        </div>\n        <div class="row mt-4">\n          <div class="col">\n            <button class="btn btn-primary" type="button">Submit</button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/4.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block py-0">\n  <div class="container py-5 my-5" style="background-image: url({{imagesDir}}/shapes/4.svg);">\n    <div class=" row justify-content-end">\n      <div class="col-12 col-md-8 col-lg-6 col-xl-5 text-left">\n        <div class="fdb-box">\n          <div class="row">\n            <div class="col">\n              <h1>Log In</h1>\n              <p class="lead">Right at the coast of the Semantics, a large language ocean. A small river named Duden.</p>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col mt-4">\n              <input type="text" class="form-control" placeholder="Email">\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <input type="password" class="form-control" placeholder="Password">\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <button class="btn btn-secondary" type="button">Submit</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/5.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-8 col-lg-8 col-xl-6">\n        <div class="row">\n          <div class="col text-center">\n            <h1>Register</h1>\n            <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia. </p>\n          </div>\n        </div>\n        <div class="row align-items-center">\n          <div class="col mt-4">\n            <input type="text" class="form-control" placeholder="Company Name">\n          </div>\n        </div>\n        <div class="row align-items-center mt-4">\n          <div class="col">\n            <input type="email" class="form-control" placeholder="Email">\n          </div>\n        </div>\n        <div class="row align-items-center mt-4">\n          <div class="col">\n            <input type="password" class="form-control" placeholder="Password">\n          </div>\n          <div class="col">\n            <input type="password" class="form-control" placeholder="Confirm Password">\n          </div>\n        </div>\n        <div class="row justify-content-start mt-4">\n          <div class="col">\n            <div class="form-check">\n              <label class="form-check-label">\n                  <input type="checkbox" class="form-check-input">\n                  I Read and Accept <a href="https://www.froala.com">Terms and Conditions</a>\n                </label>\n            </div>\n\n            <button class="btn btn-primary mt-4">Submit</button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/6.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block" style="background-image: url({{imagesDir}}/hero/red.svg);">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-8 col-lg-7 col-xl-5 text-center">\n        <div class="fdb-box">\n          <div class="row">\n            <div class="col">\n              <h1>Log In</h1>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <input type="text" class="form-control" placeholder="Email">\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <input type="password" class="form-control mb-1" placeholder="Password">\n              <p class="text-right"><a href="https://www.froala.com">Recover Password</a></p>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <button class="btn btn-outline-secondary" type="button">Submit</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/7.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-8 col-lg-7 col-md-5 text-center">\n        <div class="fdb-box fdb-touch">\n          <div class="row">\n            <div class="col">\n              <h1>Register</h1>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col mt-4">\n              <input type="text" class="form-control" placeholder="Name">\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <input type="text" class="form-control" placeholder="Email">\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <input type="password" class="form-control mb-1" placeholder="Password">\n              <p class="text-right"><a href="https://www.froala.com">Already have an account?</a></p>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col">\n              <button class="btn btn-primary" type="button">Submit</button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/8.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block bg-gray">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12  col-md-10 col-lg-8 col-xl-6 text-center">\n        <img alt="image" height="40" src="{{imagesDir}}/icons/layers.svg">\n        <h1>Never miss an update</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. </p>\n        <div class="input-group mt-4 mb-4">\n          <input type="text" class="form-control" placeholder="Enter your email address">\n          <div class="input-group-append">\n            <button class="btn btn-primary" type="button">Submit</button>\n          </div>\n        </div>\n        <p class="h5"><em>*Your email address is safe with us. We never share your email address.</em></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/9.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block">\n  <div class="container">\n    <div class="row justify-content-center">\n      <div class="col-12 col-md-10 col-lg-8 col-xl-6 text-center">\n        <h1>Company Name</h1>\n        <p class="lead">When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown.</p>\n        <div class="input-group mt-5 mb-5">\n          <input type="text" class="form-control" placeholder="Enter your email address">\n          <div class="input-group-append">\n            <button class="btn btn-primary" type="button">Submit</button>\n          </div>\n        </div>\n        <p class="h2">\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-facebook"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-twitter"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-instagram"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-google"></i></a>\n          <a href="https://www.froala.com" class="mx-2"><i class="fab fa-pinterest"></i></a>\n        </p>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/10.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block">\n  <div class="container">\n    <div class="row">\n      <div class="col-12 col-md-6 m-md-auto ml-lg-0 col-lg-5">\n        <img alt="image" class="img-fluid" src="{{imagesDir}}/draws/group-chat.svg">\n      </div>\n      <div class="col-12 col-md-10 col-lg-6 mt-4 mt-lg-0 ml-auto mr-auto ml-lg-auto text-left">\n        <div class="row">\n          <div class="col">\n            <h1>Subscribe</h1>\n            <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia. </p>\n          </div>\n        </div>\n        <div class="row mt-4">\n          <div class="col">\n            <div class="input-group">\n              <input type="text" class="form-control" placeholder="Enter your email address">\n              <div class="input-group-append">\n                <button class="btn btn-primary" type="button">Submit</button>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class="row">\n          <div class="col">\n            <p class="h4">* Leave your email address to be notified first.</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/11.jpg"),n.RegisterDesignBlock("Forms",'<section class="fdb-block" style="background-image: url({{imagesDir}}/shapes/1.svg);">\n  <div class="container">\n    <div class="row justify-content-end">\n      <div class="col-12 col-md-9 col-lg-8">\n        <div class="fdb-box fdb-touch">\n          <div class="row justify-content-center">\n            <div class="col-12 col-lg-10">\n              <h1>Subscribe</h1>\n              <p class="lead">When she reached the first hills of the Italic Mountains, she had a last view back on the skyline of her hometown Bookmarksgrove.</p>\n            </div>\n          </div>\n          <div class="row justify-content-center mt-4">\n            <div class="col-12 col-lg-10">\n              <div class="input-group">\n                <input type="text" class="form-control" placeholder="Enter your email address">\n                <div class="input-group-append">\n                  <button class="btn btn-primary" type="button">Submit</button>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"forms/12.jpg")}),function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Headers",'<header>\n  <div class="container">\n    <nav class="navbar">\n      <div class="col">\n        <a href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/1.jpg"),n.RegisterDesignBlock("Headers",'<header>\n  <div class="container text-center">\n    <nav class="navbar">\n      <div class="col">\n        <a class="ml-auto mr-auto" href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/2.jpg"),n.RegisterDesignBlock("Headers",'<header>\n  <div class="container">\n    <nav class="navbar navbar-expand-md">\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav0" aria-controls="navbarNav0" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse" id="navbarNav0">\n        <ul class="navbar-nav mr-auto ml-auto">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n        </ul>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/3.jpg"),n.RegisterDesignBlock("Headers",'<header>\n  <div class="container">\n    <nav class="navbar navbar-expand-md">\n      <div class="col">\n        <a class="navbar-brand" href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav1" aria-controls="navbarNav1" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse" id="navbarNav1">\n        <ul class="navbar-nav mr-auto">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n        </ul>\n\n        <ul class="navbar-nav justify-content-end d-none d-lg-flex ml-md-auto">\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com"><i class="fab fa-slack"></i></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com"><i class="fab fa-twitter"></i></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com"><i class="fab fa-github"></i></a>\n          </li>\n        </ul>\n\n        <a class="btn btn-outline-primary ml-md-3" href="https://www.froala.com">Button</a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/4.jpg"),n.RegisterDesignBlock("Headers",'<header>\n  <div class="container">\n    <nav class="navbar navbar-expand-md no-gutters">\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav2" aria-controls="navbarNav2" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="col-4 col-md-2 text-right text-md-center order-lg-6">\n        <a href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <div class="collapse navbar-collapse col-12 col-md-5 order-lg-1" id="navbarNav2">\n        <ul class="navbar-nav col-5">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n        </ul>\n      </div>\n\n      <ul class="navbar-nav justify-content-end col-sm-5 order-lg-12 d-none d-md-flex">\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-twitter"></i></a>\n        </li>\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-github"></i></a>\n        </li>\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-slack"></i></a>\n        </li>\n      </ul>\n    </nav>\n  </div>\n</header>\n',"headers/5.jpg"),n.RegisterDesignBlock("Headers",'<header>\n  <div class="container">\n    <nav class="navbar navbar-expand-md">\n      <div class="col">\n        <a class="navbar-brand" href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav3" aria-controls="navbarNav3" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse" id="navbarNav3">\n        <ul class="navbar-nav ml-auto">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">About</a>\n          </li>\n        </ul>\n\n        <a class="btn btn-outline-primary ml-md-3" href="https://www.froala.com">Button</a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/6.jpg"),n.RegisterDesignBlock("Headers",'<header>\n  <div class="container">\n    <nav class="navbar navbar-expand-md no-gutters">\n      <div class="col-2 text-left">\n        <a href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav4" aria-controls="navbarNav4" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse justify-content-center col-md-8" id="navbarNav4">\n        <ul class="navbar-nav justify-content-center">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n        </ul>\n      </div>\n\n      <ul class="navbar-nav col-2 justify-content-end d-none d-md-flex">\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-facebook"></i></a>\n        </li>\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-twitter"></i></a>\n        </li>\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-github"></i></a>\n        </li>\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-google"></i></a>\n        </li>\n      </ul>\n    </nav>\n  </div>\n</header>\n',"headers/7.jpg"),n.RegisterDesignBlock("Headers",'<header>\n  <div class="container">\n    <nav class="navbar navbar-expand-lg">\n      <div class="col">\n        <a class="navbar-brand" href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav5" aria-controls="navbarNav5" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse" id="navbarNav5">\n        <ul class="navbar-nav mr-auto">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n        </ul>\n\n        <ul class="navbar-nav justify-content-end ml-auto">\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Docs</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Contact</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Log In</a>\n          </li>\n        </ul>\n\n        <a class="btn btn-primary ml-md-3" href="https://www.froala.com">Button</a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/8.jpg"),n.RegisterDesignBlock("Headers",'<header>\n  <div class="container">\n    <nav class="navbar navbar-expand-md no-gutters">\n      <div class="col-2 text-left">\n        <a href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse-1" aria-controls="navbarNav6" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse justify-content-center col-md-8 navbar-collapse-1">\n        <ul class="navbar-nav justify-content-center">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Contact</a>\n          </li>\n        </ul>\n      </div>\n\n      <div class="collapse navbar-collapse justify-content-end col-md-2 navbar-collapse-1">\n        <ul class="navbar-nav">\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Log In <i class="fas fa-sign-in-alt"></i></a>\n          </li>\n        </ul>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/9.jpg"),n.RegisterDesignBlock("Headers",'<header>\n  <div class="container">\n    <nav class="navbar navbar-expand-md no-gutters">\n      <div class="col-3 text-left">\n        <a href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse-2" aria-controls="navbarNav7" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse navbar-collapse-2 justify-content-center col-md-6" id="navbarNav7">\n        <ul class="navbar-nav justify-content-center">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Contact</a>\n          </li>\n        </ul>\n      </div>\n\n      <div class="collapse navbar-collapse navbar-collapse-2">\n        <ul class="navbar-nav ml-auto justify-content-end">\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Log In</a>\n          </li>\n        </ul>\n\n        <a class="btn btn-primary ml-md-3" href="https://www.froala.com">Register</a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/10.jpg"),n.RegisterDesignBlock("Headers",'<header class="bg-dark">\n  <div class="container">\n    <nav class="navbar">\n      <div class="col">\n        <a href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/11.jpg"),n.RegisterDesignBlock("Headers",'<header class="bg-dark">\n  <div class="container text-center">\n    <nav class="navbar">\n      <div class="col">\n        <a class="ml-auto mr-auto" href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/12.jpg"),n.RegisterDesignBlock("Headers",'<header class="bg-dark">\n  <div class="container">\n    <nav class="navbar navbar-expand-md">\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav8" aria-controls="navbarNav8" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse" id="navbarNav8">\n        <ul class="navbar-nav mr-auto ml-auto">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n        </ul>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/13.jpg"),n.RegisterDesignBlock("Headers",'<header class="bg-dark">\n  <div class="container">\n    <nav class="navbar navbar-expand-md">\n      <div class="col">\n        <a class="navbar-brand" href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n      \n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav9" aria-controls="navbarNav9" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse" id="navbarNav9">\n        <ul class="navbar-nav mr-auto">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n        </ul>\n\n        <ul class="navbar-nav justify-content-end d-none d-lg-flex ml-md-auto">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com"><i class="fab fa-slack"></i></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com"><i class="fab fa-twitter"></i></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com"><i class="fab fa-github"></i></a>\n          </li>\n        </ul>\n\n        <a class="btn btn-outline-light ml-md-3" href="https://www.froala.com">Button</a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/14.jpg"),n.RegisterDesignBlock("Headers",'<header class="bg-dark">\n  <div class="container">\n    <nav class="navbar navbar-expand-md no-gutters">\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav10" aria-controls="navbarNav10" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="col-4 col-sm-2 text-center order-lg-6">\n        <a href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <div class="collapse navbar-collapse col-12 col-md-5 order-lg-1" id="navbarNav10">\n        <ul class="navbar-nav col-5">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n        </ul>\n      </div>\n\n      <ul class="navbar-nav justify-content-end col-sm-5 order-lg-12 d-none d-md-flex">\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-twitter"></i></a>\n        </li>\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-github"></i></a>\n        </li>\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-slack"></i></a>\n        </li>\n      </ul>\n    </nav>\n  </div>\n</header>\n',"headers/15.jpg"),n.RegisterDesignBlock("Headers",'<header class="bg-dark">\n  <div class="container">\n    <nav class="navbar navbar-expand-md">\n      <div class="col">\n        <a class="navbar-brand" href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n      \n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav11" aria-controls="navbarNav11" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse" id="navbarNav11">\n        <ul class="navbar-nav ml-auto">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">About</a>\n          </li>\n        </ul>\n\n        <a class="btn btn-outline-light ml-md-3" href="https://www.froala.com">Button</a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/16.jpg"),n.RegisterDesignBlock("Headers",'<header class="bg-dark">\n  <div class="container">\n    <nav class="navbar navbar-expand-md no-gutters">\n      <div class="col-2 text-left">\n        <a href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav12" aria-controls="navbarNav12" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse justify-content-center col-md-8" id="navbarNav12">\n        <ul class="navbar-nav justify-content-center">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n        </ul>\n      </div>\n\n      <ul class="navbar-nav col-2 justify-content-end d-none d-md-flex">\n        <li class="nav-item active">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-facebook"></i></a>\n        </li>\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-twitter"></i></a>\n        </li>\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-github"></i></a>\n        </li>\n        <li class="nav-item">\n          <a class="nav-link" href="https://www.froala.com"><i class="fab fa-google"></i></a>\n        </li>\n      </ul>\n    </nav>\n  </div>\n</header>\n',"headers/17.jpg"),n.RegisterDesignBlock("Headers",'<header class="bg-dark">\n  <div class="container">\n    <nav class="navbar navbar-expand-lg">\n      <div class="col">\n        <a class="navbar-brand" href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n      \n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav13" aria-controls="navbarNav13" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse" id="navbarNav13">\n        <ul class="navbar-nav mr-auto">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n        </ul>\n\n        <ul class="navbar-nav justify-content-end ml-auto">\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Docs</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Contact</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Log In</a>\n          </li>\n        </ul>\n\n        <a class="btn btn-light ml-md-3" href="https://www.froala.com">Button</a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/18.jpg"),n.RegisterDesignBlock("Headers",'<header class="bg-dark">\n  <div class="container">\n    <nav class="navbar navbar-expand-md no-gutters">\n      <div class="col-2 text-left">\n        <a href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse-3" aria-controls="navbarNav14" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse justify-content-center col-md-8 navbar-collapse-3" id="navbarNav14">\n        <ul class="navbar-nav justify-content-center">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Contact</a>\n          </li>\n        </ul>\n      </div>\n\n      <div class="collapse navbar-collapse justify-content-end col-md-2 navbar-collapse-3">\n        <ul class="navbar-nav">\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Log In <i class="fas fa-sign-in-alt"></i></a>\n          </li>\n        </ul>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/19.jpg"),n.RegisterDesignBlock("Headers",'<header class="bg-dark">\n  <div class="container">\n    <nav class="navbar navbar-expand-md no-gutters">\n      <div class="col-3 text-left">\n        <a href="https://www.froala.com">\n          <img src="{{imagesDir}}/logo.png" height="30" alt="image">\n        </a>\n      </div>\n\n      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse-4" aria-controls="navbarNav15" aria-expanded="false" aria-label="Toggle navigation">\n        <span class="navbar-toggler-icon"></span>\n      </button>\n\n      <div class="collapse navbar-collapse navbar-collapse-4 justify-content-center col-md-6" id="navbarNav15">\n        <ul class="navbar-nav justify-content-center">\n          <li class="nav-item active">\n            <a class="nav-link" href="https://www.froala.com">Home <span class="sr-only">(current)</span></a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Features</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Pricing</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Team</a>\n          </li>\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Contact</a>\n          </li>\n        </ul>\n      </div>\n\n      <div class="collapse navbar-collapse navbar-collapse-4">\n        <ul class="navbar-nav ml-auto justify-content-end">\n          <li class="nav-item">\n            <a class="nav-link" href="https://www.froala.com">Log In</a>\n          </li>\n        </ul>\n\n        <a class="btn btn-primary ml-md-3" href="https://www.froala.com">Register</a>\n      </div>\n    </nav>\n  </div>\n</header>\n',"headers/20.jpg")}),function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Pricings",'<section class="fdb-block" style="background-image: url({{imagesDir}}/shapes/1.svg)">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <h1 class="text-light">Pricing</h1>\n      </div>\n    </div>\n\n    <div class="row mt-5 align-items-center">\n      <div class="col-12 col-sm-10 col-md-8 col-md-8 m-auto col-lg-4 text-center">\n        <div class="fdb-box shadow pb-5 pt-5 pl-3 pr-3 rounded">\n          <h2>Hobby</h2>\n          <p class="lead"><strong>$9 / month</strong></p>\n          <p class="h3 font-weight-light">Even the all-powerful Pointing has no control about.</p>\n\n          <ul class="text-left mt-5 mb-5">\n            <li>Item 1</li>\n            <li>Item 2</li>\n            <li>Item 3</li>\n          </ul>\n\n          <p><a href="https://www.froala.com" class="btn btn-outline-primary mt-4">Subscribe</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 col-md-8 m-auto col-lg-4 text-center pt-4 pt-lg-0">\n        <div class="fdb-box shadow pb-5 pt-5 pl-3 pr-3 fdb-touch rounded">\n          <h2 class="text-primary">Professional</h2>\n          <p class="lead"><strong>$19 / month</strong></p>\n          <p class="h3 font-weight-light">Far far away, behind the word mountains, far from.</p>\n\n          <ul class="text-left mt-5 mb-5">\n            <li>Item 1</li>\n            <li>Item 2</li>\n            <li>Item 3</li>\n          </ul>\n\n          <p><a href="https://www.froala.com" class="btn btn-primary mt-4">Subscribe</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 col-md-8 m-auto col-lg-4 text-center pt-4 pt-lg-0">\n        <div class="fdb-box shadow pb-5 pt-5 pl-3 pr-3 rounded">\n          <h2>Business</h2>\n          <p class="lead"><strong>$49 / month</strong></p>\n          <p class="h3 font-weight-light">Wild Question Marks, but the Little Blind Text didn’t listen.</p>\n\n          <ul class="text-left mt-5 mb-5">\n            <li>Item 1</li>\n            <li>Item 2</li>\n            <li>Item 3</li>\n          </ul>\n\n          <p><a href="https://www.froala.com" class="btn btn-outline-primary mt-4">Subscribe</a></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"pricings/1.jpg"),n.RegisterDesignBlock("Pricings",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <h1>Pricing</h1>\n      </div>\n    </div>\n\n    <div class="row mt-5 align-items-center">\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-left">\n        <div class="fdb-box fdb-touch p-5 rounded">\n          <h2>Hobby <strong class="float-xl-right d-lg-block d-xl-inline">$99</strong></h2>\n          <p class="lead"><em>Copy Writers ambushed her, made her drunk.</em></p>\n\n          <ul class="text-left pl-3 mt-5 mb-5">\n            <li>Item 1</li>\n            <li>Item 2</li>\n            <li>Item 3</li>\n          </ul>\n\n          <p class="text-left pt-4"><a href="https://www.froala.com" class="btn btn-primary">Buy Now</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-left pt-4 pt-lg-0">\n        <div class="fdb-box fdb-touch p-5 rounded">\n          <h2>Advanced <strong class="float-xl-right d-lg-block d-xl-inline">$349</strong></h2>\n          <p class="lead"><em>Separated they live in Bookmarks right.</em></p>\n\n          <ul class="text-left pl-3 mt-5 mb-5">\n            <li>Item 1</li>\n            <li>Item 2</li>\n            <li>Item 3</li>\n          </ul>\n\n          <p class="text-left pt-4"><a href="https://www.froala.com" class="btn btn-primary">Buy Now</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-left pt-4 pt-lg-0">\n        <div class="fdb-box fdb-touch p-5 rounded">\n          <h2>Business <strong class="float-xl-right d-lg-block d-xl-inline">$849</strong></h2>\n          <p class="lead"><em>A small river named Duden their place.</em></p>\n\n          <ul class="text-left pl-3 mt-5 mb-5">\n            <li>Item 1</li>\n            <li>Item 2</li>\n            <li>Item 3</li>\n          </ul>\n\n          <p class="text-left pt-4"><a href="https://www.froala.com" class="btn btn-primary">Buy Now</a></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"pricings/2.jpg"),n.RegisterDesignBlock("Pricings",'<section class="fdb-block" style="background-image: url({{imagesDir}}/hero/red.svg);">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <h1 class="text-white">Pricing</h1>\n      </div>\n    </div>\n\n    <div class="row mt-5 align-items-center">\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-center">\n        <div class="fdb-box p-4">\n          <h2>Hobby</h2>\n          <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia.</p>\n\n          <p class="h1 mt-5 mb-5">$99</p>\n\n          <p><a href="https://www.froala.com" class="btn btn-dark">Buy Now</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-center pt-4 pt-lg-0">\n        <div class="fdb-box px-4 pt-5">\n          <h2>Advanced</h2>\n          <p class="lead">Separated they live in Bookmarksgrove right at the coast, a large language ocean.</p>\n\n          <p class="h1 mt-5 mb-5">$299</p>\n\n          <p><a href="https://www.froala.com" class="btn btn-secondary">Buy Now</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-center pt-4 pt-lg-0">\n        <div class="fdb-box p-4">\n          <h2>Business</h2>\n          <p class="lead">Even the all-powerful Pointing has no control about the blind texts it is an almost life.</p>\n\n          <p class="h1 mb-5 mt-5">$799</p>\n\n          <p><a href="https://www.froala.com" class="btn btn-dark">Buy Now</a></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"pricings/3.jpg"),n.RegisterDesignBlock("Pricings",'<section class="fdb-block py-0">\n  <div class="container pt-5 my-5" style="background-image: url({{imagesDir}}/shapes/2.svg)">\n    <div class="row text-center py-5">\n      <div class="col">\n        <h1>Pricing Plans</h1>\n      </div>\n    </div>\n\n    <div class="row py-5 align-items-top">\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-left">\n        <div class="bg-gray pb-5 pt-5 pl-4 pr-4 rounded shadow">\n          <h2 class="font-weight-light">Startup</h2>\n          <hr>\n          <p class="h2"><strong>$9.90</strong></p>\n          <p class="h4">Far far away, behind the word mountains, far from the countries.</p>\n          <hr>\n          <p class="text-right"><em>Unlimited calls</em></p>\n          <p class="text-right"><em>Free hosting</em></p>\n          <p class="text-right"><em>40MB of storage</em></p>\n          <p><br></p>\n          <p><br></p>\n          <p><br></p>\n          <p class="text-center pt-4"><a href="https://www.froala.com" class="btn btn-primary">Choose Plan</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-left pt-4 pt-lg-0">\n        <div class="bg-gray pb-5 pt-5 pl-4 pr-4 rounded shadow">\n          <h2 class="font-weight-light">Standard</h2>\n          <hr>\n          <p class="h2"><strong>$29.90</strong></p>\n          <p class="h4">The copy warned the Blind Text, that it would have been rewritten</p>\n          <hr>\n          <p class="text-right"><em>Unlimited calls</em></p>\n          <p class="text-right"><em>Free hosting</em></p>\n          <p class="text-right"><em>1GB of storage</em></p>\n          <p class="text-right"><em>10 hours of support</em></p>\n          <p class="text-right"><em>Custom domain</em></p>\n          <p><br></p>\n          <p class="text-center pt-4"><a href="https://www.froala.com" class="btn btn-primary">Choose Plan</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-left pt-4 pt-lg-0">\n        <div class="bg-gray pb-5 pt-5 pl-4 pr-4 rounded shadow">\n          <h2 class="font-weight-light">Professional</h2>\n          <hr>\n          <p class="h2"><strong>$59.90</strong></p>\n          <p class="h4"> the headline of Alphabet Village and the subline of her own road.</p>\n          <hr>\n          <p class="text-right"><em>Unlimited calls</em></p>\n          <p class="text-right"><em>Free hosting</em></p>\n          <p class="text-right"><em>1GB of storage</em></p>\n          <p class="text-right"><em>20 hours of support</em></p>\n          <p class="text-right"><em>Custom domain</em></p>\n          <p class="text-right"><em>Analytics and SEO</em></p>\n\n          <p class="text-center pt-4"><a href="https://www.froala.com" class="btn btn-primary">Choose Plan</a></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"pricings/4.jpg"),n.RegisterDesignBlock("Pricings",'<section class="fdb-block" style="background-image: url({{imagesDir}}/shapes/8.svg);">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <h1>Pricing Plans</h1>\n      </div>\n    </div>\n\n    <div class="row mt-5 align-items-center no-gutters">\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-center shadow">\n        <div class="bg-white pb-5 pt-5 pl-4 pr-4 rounded-left">\n          <h2 class="font-weight-light">Basic</h2>\n\n          <p class="h1 mt-5 mb-5"><strong>$19</strong> <span class="h4">/month</span></p>\n\n          <ul class="text-left">\n            <li>Item 1</li>\n            <li>Item 2</li>\n            <li>Item 3</li>\n          </ul>\n\n          <p class="text-center pt-4"><a href="https://www.froala.com" class="btn btn-outline-dark">Choose Plan</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 ml-auto mr-auto col-lg-4 text-center mt-4 mt-lg-0 sl-1 pt-0 pt-lg-3 pb-0 pb-lg-3 bg-white fdb-touch rounded shadow">\n        <div class="pb-5 pt-5 pl-4 pr-4">\n          <h2 class="font-weight-light">Standard</h2>\n\n          <p class="h1 mt-5 mb-5"><strong>$49</strong> <span class="h4">/month</span></p>\n\n          <ul class="text-left">\n            <li>Item 1</li>\n            <li>Item 2</li>\n            <li>Item 3</li>\n          </ul>\n\n          <p class="text-center pt-4"><a href="https://www.froala.com" class="btn btn-primary btn-shadow">Choose Plan</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 ml-auto mr-auto col-lg-4 text-center mt-4 mt-lg-0 shadow">\n        <div class="bg-white pb-5 pt-5 pl-4 pr-4 rounded-right">\n          <h2 class="font-weight-light">OEM</h2>\n\n          <p class="h1 mt-5 mb-5"><strong>$99</strong> <span class="h4">/month</span></p>\n\n          <ul class="text-left">\n            <li>Item 1</li>\n            <li>Item 2</li>\n            <li>Item 3</li>\n          </ul>\n\n          <p class="text-center pt-4"><a href="https://www.froala.com" class="btn btn-outline-dark">Choose Plan</a></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"pricings/5.jpg"),n.RegisterDesignBlock("Pricings",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <h1>Pricing Plans</h1>\n      </div>\n    </div>\n\n    <div class="row mt-5 align-items-top">\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-left">\n        <div class="rounded">\n          <div class="bg-dark p-3 text-center">\n            <h2 class="font-weight-light">Startup</h2>\n            <p class="h2"><strong>$9.90</strong></p>\n          </div>\n\n          <div class="bg-gray p-5 text-center">\n            <p><img alt="image" height="40" src="{{imagesDir}}/icons/layers.svg"></p>\n            <p class="h4"><strong>For small companies</strong></p>\n            <p><br></p>\n            <p>10 hours of support</p>\n            <p>40MB of storage</p>\n            <p>Subdomain</p>\n\n            <p class="text-center pt-5"><a href="https://www.froala.com" class="btn btn-secondary">Choose Plan</a></p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-left pt-4 pt-lg-0">\n        <div class="rounded">\n          <div class="bg-dark p-3 text-center">\n            <h2 class="font-weight-light">Standard</h2>\n            <p class="h2"><strong>$19.90</strong></p>\n          </div>\n\n          <div class="bg-gray p-5 text-center">\n            <p><img alt="image" height="40" src="{{imagesDir}}/icons/monitor.svg"></p>\n            <p class="h4"><strong>For medium companies</strong></p>\n            <p><br></p>\n            <p>10 hours of support</p>\n            <p>40MB of storage</p>\n            <p>Subdomain</p>\n\n            <p class="text-center pt-5"><a href="https://www.froala.com" class="btn btn-secondary">Choose Plan</a></p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-left pt-4 pt-lg-0">\n        <div class="rounded">\n          <div class="bg-dark p-3 text-center">\n            <h2 class="font-weight-light">Business</h2>\n            <p class="h2"><strong>$29.90</strong></p>\n          </div>\n\n          <div class="bg-gray p-5 text-center">\n            <p><img alt="image" height="40" src="{{imagesDir}}/icons/package.svg"></p>\n            <p class="h4"><strong>For large companies</strong></p>\n            <p><br></p>\n            <p>10 hours of support</p>\n            <p>40MB of storage</p>\n            <p>Subdomain</p>\n\n            <p class="text-center pt-5"><a href="https://www.froala.com" class="btn btn-secondary">Choose Plan</a></p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"pricings/6.jpg"),n.RegisterDesignBlock("Pricings",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <h1>Pricing Plans</h1>\n      </div>\n    </div>\n\n    <div class="row mt-5 align-items-top">\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-center">\n        <div class="bg-gray pb-5 pt-5 pl-4 pr-4 rounded">\n          <h3><strong>Startup</strong></h3>\n          <p class="h4">&lt; 10 employees</p>\n\n          <p class="h1 mt-5">$9.90 <span class="lead">/ month</span></p>\n          <p>Far far away, behind the word mountains, far from the countries.</p>\n          <hr>\n          <p><em>Unlimited calls</em></p>\n          <p><em>Free hosting</em></p>\n          <p><em>40MB of storage</em></p>\n\n          <p class="text-center pt-5"><a href="https://www.froala.com" class="btn btn-primary">Subscribe</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-center pt-4 pt-lg-0">\n        <div class="bg-gray pb-5 pt-5 pl-4 pr-4 rounded">\n          <h3><strong>Agency</strong></h3>\n          <p class="h4">10-100 employees</p>\n\n          <p class="h1 mt-5">$19.90 <span class="lead">/ month</span></p>\n          <p>And if she hasn’t been rewritten, then they are still using her.</p>\n          <hr>\n          <p><em>Unlimited calls</em></p>\n          <p><em>Free hosting</em></p>\n          <p><em>40MB of storage</em></p>\n\n          <p class="text-center pt-5"><a href="https://www.froala.com" class="btn btn-primary">Subscribe</a></p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-8 m-auto col-lg-4 text-center pt-4 pt-lg-0">\n        <div class="bg-gray pb-5 pt-5 pl-4 pr-4 rounded">\n          <h3><strong>Business</strong></h3>\n          <p class="h4">&gt;100 employees</p>\n\n          <p class="h1 mt-5">$99.90 <span class="lead">/ month</span></p>\n          <p>Separated they live in Bookmarksgrove right at the coast of the Semantics.</p>\n          <hr>\n          <p><em>Unlimited calls</em></p>\n          <p><em>Free hosting</em></p>\n          <p><em>40MB of storage</em></p>\n\n          <p class="text-center pt-5"><a href="https://www.froala.com" class="btn btn-primary">Subscribe</a></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"pricings/7.jpg"),n.RegisterDesignBlock("Pricings",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <h1>Pricing Plans</h1>\n      </div>\n    </div>\n\n    <div class="row mt-5 align-items-top">\n      <div class="col-12 col-md-8 m-auto col-lg-4 text-center">\n        <img alt="image" height="60" src="{{imagesDir}}/icons/cloud.svg">\n        <h2><strong>Startup</strong></h2>\n        <p class="h3 mb-4 mb-lg-5"><em>$9 / month</em></p>\n\n        <p>10 hours of support</p>\n        <p>40MB of storage</p>\n        <p>Subdomain</p>\n\n        <p class="text-center mt-4 mt-lg-5"><a href="https://www.froala.com" class="btn btn-primary">Choose Plan</a></p>\n      </div>\n\n      <div class="col-12 col-md-8 col-lg-4 text-center m-auto pt-5 pt-lg-0">\n        <img alt="image" height="60" src="{{imagesDir}}/icons/life-buoy.svg">\n        <h2><strong>Advanced</strong></h2>\n        <p class="h3 mb-4 mb-lg-5"><em>$19 / month</em></p>\n\n        <p>10 hours of support</p>\n        <p>40MB of storage</p>\n        <p>Subdomain</p>\n\n        <p class="text-center mt-4 mt-lg-5"><a href="https://www.froala.com" class="btn btn-primary">Choose Plan</a></p>\n      </div>\n\n      <div class="col-12 col-md-8 m-auto col-lg-4 text-center pt-5 pt-lg-0">\n        <img alt="image" height="60" src="{{imagesDir}}/icons/layers.svg">\n        <h2><strong>Business</strong></h2>\n        <p class="h3 mb-4 mb-lg-5"><em>$29 / month</em></p>\n\n        <p>10 hours of support</p>\n        <p>40MB of storage</p>\n        <p>Subdomain</p>\n\n        <p class="text-center mt-4 mt-lg-5"><a href="https://www.froala.com" class="btn btn-primary">Choose Plan</a></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"pricings/8.jpg"),n.RegisterDesignBlock("Pricings",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <h1>Pricing Plans</h1>\n      </div>\n    </div>\n\n    <div class="row mt-5 align-items-top">\n      <div class="col-12 col-sm-10 col-md-6 col-lg-5 m-auto col-xl-3 text-left">\n        <div class="bg-gray p-3 text-center rounded sl-1">\n          <h2 class="font-weight-light">Startup</h2>\n          <p class="h2">$99</p>\n          <p class="text-center"><a href="https://www.froala.com" class="btn btn-outline-secondary">Buy Now</a></p>\n\n          <hr class="mt-5 mb-5">\n\n          <p>10 hours of support</p>\n          <p>40MB of storage</p>\n          <p>Subdomain</p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-6 col-lg-5 m-auto col-xl-3 text-left pt-5 pt-md-0">\n        <div class="bg-gray p-3 text-center rounded sl-1">\n          <h2 class="font-weight-light">Advanced</h2>\n          <p class="h2">$399</p>\n          <p class="text-center"><a href="https://www.froala.com" class="btn btn-secondary">Buy Now</a></p>\n\n          <hr class="mt-5 mb-5">\n\n          <p>10 hours of support</p>\n          <p>40MB of storage</p>\n          <p>Subdomain</p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-6 col-lg-5 m-auto col-xl-3 text-left pt-5 pt-xl-0">\n        <div class="bg-gray p-3 text-center rounded sl-1">\n          <h2 class="font-weight-light">Business</h2>\n          <p class="h2">$999</p>\n          <p class="text-center"><a href="https://www.froala.com" class="btn btn-outline-secondary">Buy Now</a></p>\n\n          <hr class="mt-5 mb-5">\n\n          <p>10 hours of support</p>\n          <p>40MB of storage</p>\n          <p>Subdomain</p>\n        </div>\n      </div>\n\n      <div class="col-12 col-sm-10 col-md-6 col-lg-5 m-auto col-xl-3 text-left pt-5 pt-xl-0">\n        <div class="bg-gray p-3 text-center rounded sl-1">\n          <h2 class="font-weight-light">Enterprise</h2>\n          <p class="h2">Call Us</p>\n          <p class="text-center"><a href="https://www.froala.com" class="btn btn-outline-secondary">Contact</a></p>\n\n          <hr class="mt-5 mb-5">\n\n          <p>10 hours of support</p>\n          <p>40MB of storage</p>\n          <p>Subdomain</p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"pricings/9.jpg"),n.RegisterDesignBlock("Pricings",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col">\n        <h1>Pricing Plans</h1>\n      </div>\n    </div>\n\n    <table class="table text-center mt-5 d-none d-lg-table">\n      <tbody>\n        <tr>\n          <th scope="row" class="border-0"></th>\n          <td class="text-center border-0">\n            <h2 class="font-weight-light">Hobby</h2>\n            <p class="lead">$99</p>\n            <p><a href="https://www.froala.com" class="btn btn-outline-primary">Buy Now</a></p>\n          </td>\n          <td class="text-center border-0">\n            <h2 class="font-weight-light">Professional</h2>\n            <p class="lead">$399</p>\n            <p><a href="https://www.froala.com" class="btn btn-outline-primary">Buy Now</a></p>\n          </td>\n          <td class="text-center border-0">\n            <h2 class="font-weight-light">Business</h2>\n            <p class="lead">$899</p>\n            <p><a href="https://www.froala.com" class="btn btn-primary">Buy Now</a></p>\n          </td>\n          <td class="text-center border-0">\n            <h2 class="font-weight-light">Enterprise</h2>\n            <p class="lead">Call us</p>\n            <p><a href="https://www.froala.com" class="btn btn-outline-primary">Contact</a></p>\n          </td>\n        </tr>\n        <tr>\n          <th scope="row">Support</th>\n          <td>3 months</td>\n          <td>6 months</td>\n          <td>12 months</td>\n          <td>Custom</td>\n        </tr>\n        <tr>\n          <th scope="row">Full source code</th>\n          <td>✓</td>\n          <td>✓</td>\n          <td>✓</td>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">SaaS / Subscription</th>\n          <td>✓</td>\n          <td>✓</td>\n          <td>✓</td>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Intranet</th>\n          <td></td>\n          <td>✓</td>\n          <td>✓</td>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Downloadable Software</th>\n          <td></td>\n          <td></td>\n          <td>✓</td>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Redistribute</th>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Custom code</th>\n          <td></td>\n          <td></td>\n          <td></td>\n          <td>✓</td>\n        </tr>\n      </tbody>\n    </table>\n\n    <table class="table text-center mt-5 d-table d-lg-none">\n      <tbody>\n        <tr>\n          <td class="text-center border-0" colspan="2">\n            <h2 class="font-weight-light">Hobby</h2>\n            <p class="h2">$99</p>\n            <p><a href="https://www.froala.com" class="btn btn-outline-primary">Buy Now</a></p>\n          </td>\n        </tr>\n        <tr>\n          <th scope="row">Support</th>\n          <td>3 months</td>\n        </tr>\n        <tr>\n          <th scope="row">Full source code</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">SaaS / Subscription</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Intranet</th>\n          <td></td>\n        </tr>\n        <tr>\n          <th scope="row">Downloadable Software</th>\n          <td></td>\n        </tr>\n        <tr>\n          <th scope="row">Redistribute</th>\n          <td></td>\n        </tr>\n        <tr>\n          <th scope="row">Custom code</th>\n          <td></td>\n        </tr>\n      </tbody>\n    </table>\n\n    <table class="table text-center mt-5 d-table d-lg-none">\n      <tbody>\n        <tr>\n          <td class="text-center" colspan="2">\n            <h2 class="font-weight-light">Professional</h2>\n            <p class="h2">$399</p>\n            <p><a href="https://www.froala.com" class="btn btn-outline-primary">Buy Now</a></p>\n          </td>\n        </tr>\n        <tr>\n          <th scope="row">Support</th>\n          <td>6 months</td>\n        </tr>\n        <tr>\n          <th scope="row">Full source code</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">SaaS / Subscription</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Intranet</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Downloadable Software</th>\n          <td></td>\n        </tr>\n        <tr>\n          <th scope="row">Redistribute</th>\n          <td></td>\n        </tr>\n        <tr>\n          <th scope="row">Custom code</th>\n          <td></td>\n        </tr>\n      </tbody>\n    </table>\n\n    <table class="table text-center mt-5 d-table d-lg-none">\n      <tbody>\n        <tr>\n          <td class="text-center" colspan="2">\n            <h2 class="font-weight-light">Business</h2>\n            <p class="h2">$899</p>\n            <p><a href="https://www.froala.com" class="btn btn-primary">Buy Now</a></p>\n          </td>\n        </tr>\n        <tr>\n          <th scope="row">Support</th>\n          <td>12 months</td>\n        </tr>\n        <tr>\n          <th scope="row">Full source code</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">SaaS / Subscription</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Intranet</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Downloadable Software</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Redistribute</th>\n          <td></td>\n        </tr>\n        <tr>\n          <th scope="row">Custom code</th>\n          <td></td>\n        </tr>\n      </tbody>\n    </table>\n\n    <table class="table text-center mt-5 d-table d-lg-none">\n      <tbody>\n        <tr>\n          <td class="text-center" colspan="2">\n            <h2 class="font-weight-light">Enterprise</h2>\n            <p class="h2">Call us</p>\n            <p><a href="https://www.froala.com" class="btn btn-outline-primary">Contact</a></p>\n          </td>\n        </tr>\n        <tr>\n          <th scope="row">Support</th>\n          <td>Custom</td>\n        </tr>\n        <tr>\n          <th scope="row">Full source code</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">SaaS / Subscription</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Intranet</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Downloadable Software</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Redistribute</th>\n          <td>✓</td>\n        </tr>\n        <tr>\n          <th scope="row">Custom code</th>\n          <td>✓</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</section>\n',"pricings/10.jpg")}),function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Teams",'<section class="fdb-block team-1">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-8">\n        <h1>Our Team</h1>\n        <p class="lead">Far far away, behind the word mountains, far from the countries.</p>\n      </div>\n    </div>\n\n    <div class="row-50"></div>\n\n    <div class="row">\n      <div class="col-sm-3 text-left">\n        <div class="fdb-box p-0">\n          <img alt="image" class="img-fluid rounded-0" src="{{imagesDir}}/people/1.jpg">\n\n          <div class="content p-3">\n            <h3><strong>Sara Doe</strong></h3>\n            <p>Founder</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-sm-3 text-left">\n        <div class="fdb-box p-0">\n          <img alt="image" class="img-fluid rounded-0" src="{{imagesDir}}/people/2.jpg">\n\n          <div class="content p-3">\n            <h3><strong>Sara Doe</strong></h3>\n            <p>Founder</p>\n          </div>\n        </div>\n      </div>\n      <div class="col-sm-3 text-left">\n        <div class="fdb-box p-0">\n          <img alt="image" class="img-fluid rounded-0" src="{{imagesDir}}/people/3.jpg">\n\n          <div class="content p-3">\n            <h3><strong>Sara Doe</strong></h3>\n            <p>Founder</p>\n          </div>\n        </div>\n      </div>\n      <div class="col-sm-3 text-left">\n        <div class="fdb-box p-0">\n          <img alt="image" class="img-fluid rounded-0" src="{{imagesDir}}/people/6.jpg">\n\n          <div class="content p-3">\n            <h3><strong>Sara Doe</strong></h3>\n            <p>Founder</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"teams/1.jpg"),n.RegisterDesignBlock("Teams",'<section class="fdb-block team-2">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-8">\n        <h1>Meet Our Team</h1>\n      </div>\n    </div>\n\n    <div class="row-50"></div>\n\n    <div class="row text-center justify-content-center">\n      <div class="col-sm-3 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/4.jpg">\n\n        <h2>Sara Doe</h2>\n        <p>Founder</p>\n      </div>\n\n      <div class="col-sm-3 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/5.jpg">\n\n        <h2>Sara Doe</h2>\n        <p>Founder</p>\n      </div>\n\n      <div class="col-sm-3 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/7.jpg">\n\n        <h2>Sara Doe</h2>\n\n        <p>Founder</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"teams/2.jpg"),n.RegisterDesignBlock("Teams",'<section class="fdb-block team-3">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-8">\n        <h1>Meet Our Team</h1>\n      </div>\n    </div>\n\n    <div class="row-70"></div>\n\n    <div class="row text-center justify-content-center mb-5">\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/1.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p><em>Founder</em></p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/6.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p><em>Founder</em></p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/7.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p><em>Founder</em></p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/8.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p><em>Founder</em></p>\n      </div>\n    </div>\n\n    <div class="row justify-content-center text-center">\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/2.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p><em>Founder</em></p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/3.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p><em>Founder</em></p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/5.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p><em>Founder</em></p>\n      </div>\n    </div>\n  </div>\n</section>\n',"teams/3.jpg"),n.RegisterDesignBlock("Teams",'<section class="fdb-block team-4">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-8">\n        <h1>Team</h1>\n      </div>\n    </div>\n\n    <div class="row text-center mt-5">\n      <div class="col-3">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/5.jpg">\n        <h3><strong>John Smith</strong></h3>\n        <p>Position</p>\n        <p>A wonderful serenity has taken possession of my entire soul.</p>\n      </div>\n\n      <div class="col-3">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/6.jpg">\n        <h3><strong>John Smith</strong></h3>\n        <p>Position</p>\n        <p>Pityful a rethoric question ran over her cheek.</p>\n      </div>\n\n      <div class="col-3">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/3.jpg">\n        <h3><strong>John Smith</strong></h3>\n        <p>Position</p>\n        <p>And if she hasn’t been rewritten, then they are still using her.</p>\n      </div>\n\n      <div class="col-3">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/2.jpg">\n        <h3><strong>John Smith</strong></h3>\n        <p>Position</p>\n        <p>Wild Question Marks, but the Little Blind Text didn’t listen.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"teams/4.jpg"),n.RegisterDesignBlock("Teams",'<section class="fdb-block team-5">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-8">\n        <h1>Meet Our Team</h1>\n      </div>\n    </div>\n\n    <div class="row-70"></div>\n\n    <div class="row text-center justify-content-center">\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/1.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p>"Wild Question Marks, but the Little Blind"</p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/6.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p>"Wild Question Marks, but the Little Blind"</p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/5.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p>"Wild Question Marks, but the Little Blind"</p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/8.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p>"Wild Question Marks, but the Little Blind"</p>\n      </div>\n    </div>\n\n    <div class="row justify-content-center text-center mt-5">\n      <div class="col-sm-2  m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/3.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p>"Wild Question Marks, but the Little Blind"</p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/9.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p>"Wild Question Marks, but the Little Blind"</p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/7.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p>"Wild Question Marks, but the Little Blind"</p>\n      </div>\n\n      <div class="col-sm-2 m-sm-auto">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/2.jpg">\n\n        <h3><strong>Sara Doe</strong></h3>\n        <p>"Wild Question Marks, but the Little Blind"</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"teams/5.jpg"),n.RegisterDesignBlock("Teams",'<section class="fdb-block team-6">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-8">\n        <h1>Team</h1>\n      </div>\n    </div>\n\n    <div class="row text-center mt-5">\n      <div class="col-4">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/9.jpg">\n        <h3><strong>John Smith</strong></h3>\n        <p>Position</p>\n        <p>Separated they live in Bookmarksgrove right at the coast of the Semantics.</p>\n      </div>\n\n      <div class="col-4">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/1.jpg">\n        <h3><strong>John Smith</strong></h3>\n        <p>Position</p>\n        <p>One morning, when Gregor Samsa woke from troubled dreams.</p>\n      </div>\n\n      <div class="col-4">\n        <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/3.jpg">\n        <h3><strong>John Smith</strong></h3>\n        <p>Position</p>\n        <p>A small river named Duden flows by their place and supplies it.</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"teams/6.jpg"),n.RegisterDesignBlock("Teams",'<section class="fdb-block team-7">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-8">\n        <h1>Team</h1>\n      </div>\n    </div>\n\n    <div class="row-70"></div>\n\n    <div class="row justify-content-center">\n      <div class="col-sm-3 m-sm-auto">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/2.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3>Employee Name</h3>\n            <p>Position</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-sm-3 m-sm-auto">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/8.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3>Employee Name</h3>\n            <p>Position</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-sm-3 m-sm-auto">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/6.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3>Employee Name</h3>\n            <p>Position</p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class="row-50"></div>\n\n    <div class="row justify-content-center">\n      <div class="col-sm-3 m-sm-auto">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/4.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3>Employee Name</h3>\n            <p>Position</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-sm-3 m-sm-auto">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/1.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3>Employee Name</h3>\n            <p>Position</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-sm-3 m-sm-auto">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/3.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3>Employee Name</h3>\n            <p>Position</p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class="row-50"></div>\n\n    <div class="row justify-content-center">\n      <div class="col-sm-3 m-sm-auto">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/5.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3>Employee Name</h3>\n            <p>Position</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-sm-3 m-sm-auto">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/9.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3>Employee Name</h3>\n            <p>Position</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-sm-3 m-sm-auto">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/7.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3>Employee Name</h3>\n            <p>Position</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"teams/7.jpg"),n.RegisterDesignBlock("Teams",'<section class="fdb-block team-8">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-8">\n        <h1>Our Amazing Team</h1>\n        <p class="lead">A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth.</p>\n      </div>\n    </div>\n\n    <div class="row-100"></div>\n\n    <div class="row justify-content-center text-left">\n      <div class="col-sm-6">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/8.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3><strong>Employee Name</strong></h3>\n            <p class="lead">Position</p>\n\n            <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-sm-6">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/7.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3><strong>Employee Name</strong></h3>\n            <p class="lead">Position</p>\n\n            <p>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.</p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class="row-70"></div>\n\n    <div class="row justify-content-center text-left">\n      <div class="col-sm-6">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/9.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3><strong>Employee Name</strong></h3>\n            <p class="lead">Position</p>\n\n            <p>One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.</p>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-sm-6">\n        <div class="row align-items-center">\n          <div class="col-4">\n            <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/4.jpg">\n          </div>\n\n          <div class="col-8">\n            <h3><strong>Employee Name</strong></h3>\n            <p class="lead">Position</p>\n\n            <p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life.</p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"teams/8.jpg")}),function(n,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-pages")):"function"==typeof define&&define.amd?define(["froala-pages"],a):a(n.FroalaPages)}(this,function(n){"use strict";(n=n&&n.hasOwnProperty("default")?n.default:n).RegisterDesignBlock("Testimonials",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center justify-content-center">\n      <div class="col-12 col-md-10 col-lg-8">\n        <p class="lead">\n          "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean."\n        </p>\n\n        <p class="lead"><strong>Person Name</strong> <em class="ml-4">Co-founder at Company</em></p>\n      </div>\n      <div class="col-8 col-sm-6 col-md-2 col-lg-3 col-xl-2 mt-4 mt-md-0 ml-auto mr-auto mr-md-0">\n        <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/1.jpg">\n      </div>\n    </div>\n  </div>\n</section>\n',"testimonials/1.jpg"),n.RegisterDesignBlock("Testimonials",'<section class="fdb-block" style="background-image: url({{imagesDir}}/hero/red.svg);">\n  <div class="container">\n    <div class="fdb-box">\n      <div class="row align-items-center justify-content-center">\n        <div class="col-10 col-sm-6 col-md-4 col-lg-3 col-xl-2 m-auto">\n          <img alt="image" class="img-fluid rounded-circle" src="{{imagesDir}}/people/3.jpg">\n        </div>\n\n        <div class="col-12 col-md-8 ml-auto mr-auto mt-4 mt-md-0">\n          <p class="lead">\n            "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."\n          </p>\n\n          <p class="h3 mt-4 mt-lg-5"><strong>Person Name</strong></p>\n          <p><em>Co-founder at Company</em></p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"testimonials/2.jpg"),n.RegisterDesignBlock("Testimonials",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center">\n      <div class="col-12">\n        <h3><strong>You are in good company</strong></h3>\n\n        <div class="mt-5 justify-content-center">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/adobe.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/amazon.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/ebay.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/samsung.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/orange.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/salesforce.svg">\n        </div>\n        <div class="mt-2 mt-md-5 justify-content-center">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/cisco.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/apple.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/ibm.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/intel.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/panasonic.svg">\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"testimonials/3.jpg"),n.RegisterDesignBlock("Testimonials",'<section class="fdb-block">\n  <div class="container">\n    <div class="row align-items-center justify-content-center">\n      <div class="col-md-6">\n        <div class="fdb-box fdb-touch">\n          <p class="h3 mb-4">"Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics."</p>\n\n          <p>\n            <img alt="image" height="50" class="rounded-circle" src="{{imagesDir}}/people/5.jpg">\n            <strong class="ml-3">Person Name</strong>\n          </p>\n        </div>\n      </div>\n\n      <div class="col-md-6 mt-4 mt-md-0">\n        <div class="fdb-box fdb-touch">\n          <p class="h3 mb-4">"A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth."</p>\n\n          <p>\n            <img alt="image" height="50" class="rounded-circle" src="{{imagesDir}}/people/4.jpg">\n            <strong class="ml-3">Person Name</strong>\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"testimonials/4.jpg"),n.RegisterDesignBlock("Testimonials",'<section class="fdb-block py-5">\n  <div class="container py-5" style="background-image: url({{imagesDir}}/shapes/2.svg);">\n    <div class="row align-items-center justify-content-center">\n      <div class="col-lg-9 col-xl-6">\n        <div class="fdb-box">\n          <div class="row">\n            <div class="col-8 col-sm-6 col-md-4 col-xl-3 ml-auto mr-auto">\n              <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/6.jpg">\n            </div>\n\n            <div class="col-md-8 mt-4 mt-md-0">\n              <p class="lead">\n                "Even the all-powerful Pointing has no control about day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."\n              </p>\n\n              <p class="h3 mt-4 mt-xl-5"><strong>Person Name</strong></p>\n              <p><em>Co-founder at Company</em></p>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-lg-9 col-xl-6 mt-4 mt-xl-0">\n        <div class="fdb-box">\n          <div class="row">\n            <div class="col-8 col-sm-6 col-md-4 col-xl-3 ml-auto mr-auto">\n              <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/8.jpg">\n            </div>\n\n            <div class="col-md-8 mt-4 mt-md-0">\n              <p class="lead">\n                "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia. Separated they at the coast of the Semantics, a large language ocean."\n              </p>\n\n              <p class="h3 mt-4 mt-xl-5"><strong>Person Name</strong></p>\n              <p><em>Co-founder at Company</em></p>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"testimonials/5.jpg"),n.RegisterDesignBlock("Testimonials",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-lg-8">\n        <h2>You are in good company</h2>\n        <p class="lead">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. </p>\n        <div class="mt-5 justify-content-center">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/adobe.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/amazon.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/ebay.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/samsung.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/orange.svg">\n          <img alt="image" height="30" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/salesforce.svg">\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"testimonials/6.jpg"),n.RegisterDesignBlock("Testimonials",'<section class="fdb-block bg-dark">\n  <div class="container">\n    <div class="row justify-content-center text-center">\n      <div class="col">\n        <img alt="image" height="40" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/adobe.svg">\n        <img alt="image" height="40" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/amazon.svg">\n        <img alt="image" height="40" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/ebay.svg">\n        <img alt="image" height="40" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/samsung.svg">\n        <img alt="image" height="40" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/orange.svg">\n        <img alt="image" height="40" class="ml-3 mr-3 mb-2 mt-2" src="{{imagesDir}}/customers/salesforce.svg">\n      </div>\n    </div>\n  </div>\n</section>\n',"testimonials/7.jpg"),n.RegisterDesignBlock("Testimonials",'<section class="fdb-block">\n  <div class="container">\n    <div class="row pb-xl-5 text-center justify-content-center">\n      <div class="col-md-10 col-lg-7">\n        <h1>Testimonials</h1>\n      </div>\n    </div>\n\n    <div class="row mt-5 justify-content-center">\n      <div class="col-md-8 col-lg-4 col-xl-3 m-auto text-center">\n        <img alt="image" height="50" src="{{imagesDir}}/customers/intel.svg">\n        <p class="h3 mt-4">"Far far away, behind the word mountains, far from the countries Vokalia and Consonantia."</p>\n\n        <p class="h3 mt-4 mt-xl-5"><strong>Person Name</strong></p>\n        <p>Co-founder at Company</p>\n      </div>\n\n      <div class="col-md-8 col-lg-4 col-xl-3 pt-5 pt-lg-0 m-auto text-center">\n        <img alt="image" height="50" src="{{imagesDir}}/customers/apple.svg">\n        <p class="h3 mt-4">"Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean."</p>\n\n        <p class="h3 mt-4 mt-xl-5"><strong>Person Name</strong></p>\n        <p>Co-founder at Company</p>\n      </div>\n\n      <div class="col-md-8 col-lg-4 col-xl-3 pt-5 pt-lg-0 m-auto text-center">\n        <img alt="image" height="50" src="{{imagesDir}}/customers/samsung.svg">\n        <p class="h3 mt-4">"A small river named Duden flows by their place and supplies it with the necessary regelialia."</p>\n\n        <p class="h3 mt-4 mt-xl-5"><strong>Person Name</strong></p>\n        <p>Co-founder at Company</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"testimonials/8.jpg"),n.RegisterDesignBlock("Testimonials",'<section class="fdb-block" style="background-image: url({{imagesDir}}/shapes/9.svg);">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-md-10 col-lg-8 col-xl-7">\n        <h1>Testimonials</h1>\n        <p class="lead">A small river named Duden flows by their place and supplies it with the necessary regelialia. Separated they live in Bookmarksgrove right at the coast of the Semantics.</p>\n      </div>\n    </div>\n\n    <div class="row mt-5 align-items-center justify-content-center">\n      <div class="col-md-8 col-lg-4">\n        <div class="fdb-box">\n          <div class="row no-gutters align-items-center">\n            <div class="col-3">\n              <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/1.jpg">\n            </div>\n            <div class="col-8 ml-auto">\n              <p>\n                <strong>Person Name</strong><br>\n                <em>Co-founder at Company</em>\n              </p>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col-12">\n              <p class="lead">\n                "Even the all-powerful Pointing has no control about the blind texts it is an small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."\n              </p>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-md-8 col-lg-4 mt-4 mt-lg-0">\n        <div class="fdb-box">\n          <div class="row no-gutters align-items-center">\n            <div class="col-3">\n              <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/3.jpg">\n            </div>\n            <div class="col-8 ml-auto">\n              <p>\n                <strong>Person Name</strong><br>\n                <em>Co-founder at Company</em>\n              </p>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col-12">\n              <p class="lead">\n                "Far far away, behind the word mountains, far from the countries Vokalia. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean."\n              </p>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class="col-md-8 col-lg-4 mt-4 mt-lg-0">\n        <div class="fdb-box">\n          <div class="row no-gutters align-items-center">\n            <div class="col-3">\n              <img alt="image" class="img-fluid rounded" src="{{imagesDir}}/people/2.jpg">\n            </div>\n            <div class="col-8 ml-auto">\n              <p>\n                <strong>Person Name</strong><br>\n                <em>Co-founder at Company</em>\n              </p>\n            </div>\n          </div>\n          <div class="row mt-4">\n            <div class="col-12">\n              <p class="lead">\n                "Separated they live in Bookmarksgrove right at the coast of the Semantics, the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts."\n              </p>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n',"testimonials/9.jpg"),n.RegisterDesignBlock("Testimonials",'<section class="fdb-block">\n  <div class="container">\n    <div class="row text-center justify-content-center">\n      <div class="col-md-10 col-lg-7">\n        <h1>Testimonials</h1>\n      </div>\n    </div>\n\n    <div class="row mt-5 justify-content-center">\n      <div class="col-md-10 col-lg-3 ml-auto mr-auto text-center">\n        <p class="h3 mb-4 mb-lg-5">"Far far away, behind the word mountains, far from the countries Vokalia and Consonantia."</p>\n\n        <p><img alt="image" height="50" class="rounded-circle" src="{{imagesDir}}/people/5.jpg"></p>\n        <p class="lead"><strong>Person Name</strong></p>\n        <p>Co-founder, Company</p>\n      </div>\n\n      <div class="col-md-10 col-lg-3 pt-5 pt-lg-0 ml-auto mr-auto text-center">\n        <p class="h3 mb-4 mb-lg-5">"Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean."</p>\n\n        <p><img alt="image" height="50" class="rounded-circle" src="{{imagesDir}}/people/8.jpg"></p>\n        <p class="lead"><strong>Person Name</strong></p>\n        <p>Co-founder, Company</p>\n      </div>\n\n      <div class="col-md-10 col-lg-3 pt-5 pt-lg-0 ml-auto mr-auto text-center">\n        <p class="h3 mb-4 mb-lg-5">"A small river named Duden flows by their place and supplies it with the necessary regelialia."</p>\n\n        <p><img alt="image" height="50" class="rounded-circle" src="{{imagesDir}}/people/9.jpg"></p>\n        <p class="lead"><strong>Person Name</strong></p>\n        <p>Co-founder, Company</p>\n      </div>\n    </div>\n  </div>\n</section>\n',"testimonials/10.jpg")});
/**
 * jQuery.fontpicker - A font picker for Google Web Fonts and local fonts.
 *
 * Made by Arjan Haverkamp, https://www.webgear.nl
 * Copyright 2020 Arjan Haverkamp
 * MIT Licensed
 * @version 1.1 - 2020-07-15
 * @url https://github.com/av01d/fontpicker-jquery-plugin
 */

(function($){

	var pluginName = 'fontpicker';
	var fontsLoaded = {};

	var googleFontLangs = {
		'arabic': 'Arabic',
		'bengali': 'Bengali',
		'chinese-hongkong': 'Chinese (Hong Kong)',
		'chinese-simplified': 'Chinese (Simplified',
		'chinese-traditional': 'Chinese (Traditional)',
		'cyrillic': 'Cyrillic',
		'cyrillic-ext': 'Cyrillic Extended',
		'devanagari': 'Devanagari',
		'greek': 'Greek',
		'greek-ext': 'Greek Extended',
		'gujarati': 'Gujarati',
		'gurmukhi': 'Gurmukhi',
		'hebrew': 'Hebrew',
		'japanese': 'Japanese',
		'kannada': 'Kannada',
		'khmer': 'Khmer',
		'korean': 'Korean',
		'latin': 'Latin',
		'latin-ext': 'Latin Extended',
		'malayalam': 'Malayalam',
		'myanmar': 'Myanmar',
		'oriya': 'Oriya',
		'sinhala': 'Sinhala',
		'tamil': 'Tamil',
		'telugu': 'Telugu',
		'thai': 'Thai',
		'tibetan': 'Tibetan',
		'vietnamese': 'Vietnamese'
	};

	var googleFontCats = ['serif', 'sans-serif', 'display', 'handwriting', 'monospace'];

	$.fn.fontpicker = function(options) {

		var __scrollIntoViewIfNeeded = function(elem) {
			var container = elem.parentElement;
			var rectElem = elem.getBoundingClientRect(), rectContainer = container.getBoundingClientRect();
			if (rectElem.bottom > rectContainer.bottom) { elem.scrollIntoView(false); }
			if (rectElem.top < rectContainer.top) { elem.scrollIntoView(); }
		};

		/**
		 * Utility function for getting/setting cookies.
		 * This function stores multiple values in one single cookie: max efficiency!
		 * Also: this function gets/sets cookies that PHP can also get/set (static Cookie class).
		 * Cookies are valid for 365 days.
		 *
		 * @param {string} key Name of the value to store.
		 * @param {string} value Value to store. Omit to get a cookie, provide to set a cookie.
		 * @return {string} The value for a cookie (when value is omitted, of course).
		 */
		var __cookie = function(key, value) {
			var cookieName = 'jqfs', cookieDays = 365, result, date = new Date(), jar = {}, expires = '', x, pts, pt;
			result = (result = new RegExp('(?:^|; )'+cookieName+'=([^;]*)').exec(document.cookie)) ? decodeURIComponent(result[1]) : null;

			if (null !== result) {
				pts = result.split('||');
				for (x in pts) {
					try {
						pt = pts[x].split('|',2);
						jar[pt[0]] = pt[1];
					} catch (e) {}
				}
			}

			// Get cookie:
			if (1 === arguments.length) {
				return jar[key];
			}

			// Set cookie
			if (null === value || false === value) {
				delete jar[key];
			}
			else {
				jar[key] = value;
			}

			pts = [];
			for (x in jar) {
				pts.push(x+'|'+jar[x]);
			}

			if (cookieDays > 0) {
				date.setTime(date.getTime()+(cookieDays*24*60*60*1000));
				expires = '; expires='+date.toGMTString();
			}
			document.cookie = cookieName + '=' + encodeURIComponent(pts.join('||')) + '; path=/; SameSite=Lax' + expires;
		};

		var __googleFonts = {
			// This list was last updated on July 10, 2020
			"ABeeZee": {
				"category": "sans-serif",
				"variants": "400,400i",
				"subsets": "latin"
			},
			"Abel": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Abhaya Libre": {
				"category": "serif",
				"variants": "400,500,600,700,800",
				"subsets": "latin,latin-ext,sinhala"
			},
			"Abril Fatface": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Aclonica": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Acme": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Actor": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Adamina": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Advent Pro": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700",
				"subsets": "greek,latin,latin-ext"
			},
			"Aguafina Script": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Akronim": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Aladin": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Alata": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Alatsi": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Aldrich": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Alef": {
				"category": "sans-serif",
				"variants": "400,700",
				"subsets": "hebrew,latin"
			},
			"Alegreya": {
				"category": "serif",
				"variants": "400,400i,500,500i,700,700i,800,800i,900,900i",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
			},
			"Alegreya SC": {
				"category": "serif",
				"variants": "400,400i,500,500i,700,700i,800,800i,900,900i",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
			},
			"Alegreya Sans": {
				"category": "sans-serif",
				"variants": "100,100i,300,300i,400,400i,500,500i,700,700i,800,800i,900,900i",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
			},
			"Alegreya Sans SC": {
				"category": "sans-serif",
				"variants": "100,100i,300,300i,400,400i,500,500i,700,700i,800,800i,900,900i",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
			},
			"Aleo": {
				"category": "serif",
				"variants": "300,300i,400,400i,700,700i",
				"subsets": "latin,latin-ext"
			},
			"Alex Brush": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Alfa Slab One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Alice": {
				"category": "serif",
				"variants": "400",
				"subsets": "cyrillic,cyrillic-ext,latin"
			},
			"Alike": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Alike Angular": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Allan": {
				"category": "display",
				"variants": "400,700",
				"subsets": "latin,latin-ext"
			},
			"Allerta": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Allerta Stencil": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Allura": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Almarai": {
				"category": "sans-serif",
				"variants": "300,400,700,800",
				"subsets": "arabic"
			},
			"Almendra": {
				"category": "serif",
				"variants": "400,400i,700,700i",
				"subsets": "latin,latin-ext"
			},
			"Almendra Display": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Almendra SC": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Amarante": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Amaranth": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i",
				"subsets": "latin"
			},
			"Amatic SC": {
				"category": "handwriting",
				"variants": "400,700",
				"subsets": "cyrillic,hebrew,latin,latin-ext,vietnamese"
			},
			"Amethysta": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Amiko": {
				"category": "sans-serif",
				"variants": "400,600,700",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Amiri": {
				"category": "serif",
				"variants": "400,400i,700,700i",
				"subsets": "arabic,latin,latin-ext"
			},
			"Amita": {
				"category": "handwriting",
				"variants": "400,700",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Anaheim": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Andada": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Andika": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Angkor": {
				"category": "display",
				"variants": "400",
				"subsets": "khmer"
			},
			"Annie Use Your Telescope": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Anonymous Pro": {
				"category": "monospace",
				"variants": "400,400i,700,700i",
				"subsets": "cyrillic,greek,latin,latin-ext"
			},
			"Antic": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Antic Didone": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Antic Slab": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Anton": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Arapey": {
				"category": "serif",
				"variants": "400,400i",
				"subsets": "latin"
			},
			"Arbutus": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Arbutus Slab": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Architects Daughter": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Archivo": {
				"category": "sans-serif",
				"variants": "400,400i,500,500i,600,600i,700,700i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Archivo Black": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Archivo Narrow": {
				"category": "sans-serif",
				"variants": "400,400i,500,500i,600,600i,700,700i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Aref Ruqaa": {
				"category": "serif",
				"variants": "400,700",
				"subsets": "arabic,latin"
			},
			"Arima Madurai": {
				"category": "display",
				"variants": "100,200,300,400,500,700,800,900",
				"subsets": "latin,latin-ext,tamil,vietnamese"
			},
			"Arimo": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,hebrew,latin,latin-ext,vietnamese"
			},
			"Arizonia": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Armata": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Arsenal": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Artifika": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Arvo": {
				"category": "serif",
				"variants": "400,400i,700,700i",
				"subsets": "latin"
			},
			"Arya": {
				"category": "sans-serif",
				"variants": "400,700",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Asap": {
				"category": "sans-serif",
				"variants": "400,400i,500,500i,600,600i,700,700i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Asap Condensed": {
				"category": "sans-serif",
				"variants": "400,400i,500,500i,600,600i,700,700i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Asar": {
				"category": "serif",
				"variants": "400",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Asset": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Assistant": {
				"category": "sans-serif",
				"variants": "200,300,400,600,700,800",
				"subsets": "hebrew,latin"
			},
			"Astloch": {
				"category": "display",
				"variants": "400,700",
				"subsets": "latin"
			},
			"Asul": {
				"category": "sans-serif",
				"variants": "400,700",
				"subsets": "latin"
			},
			"Athiti": {
				"category": "sans-serif",
				"variants": "200,300,400,500,600,700",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Atma": {
				"category": "display",
				"variants": "300,400,500,600,700",
				"subsets": "bengali,latin,latin-ext"
			},
			"Atomic Age": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Aubrey": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Audiowide": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Autour One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Average": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Average Sans": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Averia Gruesa Libre": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Averia Libre": {
				"category": "display",
				"variants": "300,300i,400,400i,700,700i",
				"subsets": "latin"
			},
			"Averia Sans Libre": {
				"category": "display",
				"variants": "300,300i,400,400i,700,700i",
				"subsets": "latin"
			},
			"Averia Serif Libre": {
				"category": "display",
				"variants": "300,300i,400,400i,700,700i",
				"subsets": "latin"
			},
			"B612": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i",
				"subsets": "latin"
			},
			"B612 Mono": {
				"category": "monospace",
				"variants": "400,400i,700,700i",
				"subsets": "latin"
			},
			"Bad Script": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "cyrillic,latin"
			},
			"Bahiana": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Bahianita": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Bai Jamjuree": {
				"category": "sans-serif",
				"variants": "200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Baloo 2": {
				"category": "display",
				"variants": "400,500,600,700,800",
				"subsets": "devanagari,latin,latin-ext,vietnamese"
			},
			"Baloo Bhai 2": {
				"category": "display",
				"variants": "400,500,600,700,800",
				"subsets": "gujarati,latin,latin-ext,vietnamese"
			},
			"Baloo Bhaina 2": {
				"category": "display",
				"variants": "400,500,600,700,800",
				"subsets": "latin,latin-ext,oriya,vietnamese"
			},
			"Baloo Chettan 2": {
				"category": "display",
				"variants": "400,500,600,700,800",
				"subsets": "latin,latin-ext,malayalam,vietnamese"
			},
			"Baloo Da 2": {
				"category": "display",
				"variants": "400,500,600,700,800",
				"subsets": "bengali,latin,latin-ext,vietnamese"
			},
			"Baloo Paaji 2": {
				"category": "display",
				"variants": "400,500,600,700,800",
				"subsets": "gurmukhi,latin,latin-ext,vietnamese"
			},
			"Baloo Tamma 2": {
				"category": "display",
				"variants": "400,500,600,700,800",
				"subsets": "kannada,latin,latin-ext,vietnamese"
			},
			"Baloo Tammudu 2": {
				"category": "display",
				"variants": "400,500,600,700,800",
				"subsets": "latin,latin-ext,telugu,vietnamese"
			},
			"Baloo Thambi 2": {
				"category": "display",
				"variants": "400,500,600,700,800",
				"subsets": "latin,latin-ext,tamil,vietnamese"
			},
			"Balsamiq Sans": {
				"category": "display",
				"variants": "400,400i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
			},
			"Balthazar": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Bangers": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Barlow": {
				"category": "sans-serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Barlow Condensed": {
				"category": "sans-serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Barlow Semi Condensed": {
				"category": "sans-serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Barriecito": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Barrio": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Basic": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Baskervville": {
				"category": "serif",
				"variants": "400,400i",
				"subsets": "latin,latin-ext"
			},
			"Battambang": {
				"category": "display",
				"variants": "400,700",
				"subsets": "khmer"
			},
			"Baumans": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Bayon": {
				"category": "display",
				"variants": "400",
				"subsets": "khmer"
			},
			"Be Vietnam": {
				"category": "sans-serif",
				"variants": "100,100i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Bebas Neue": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Belgrano": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Bellefair": {
				"category": "serif",
				"variants": "400",
				"subsets": "hebrew,latin,latin-ext"
			},
			"Belleza": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Bellota": {
				"category": "display",
				"variants": "300,300i,400,400i,700,700i",
				"subsets": "cyrillic,latin,latin-ext,vietnamese"
			},
			"Bellota Text": {
				"category": "display",
				"variants": "300,300i,400,400i,700,700i",
				"subsets": "cyrillic,latin,latin-ext,vietnamese"
			},
			"BenchNine": {
				"category": "sans-serif",
				"variants": "300,400,700",
				"subsets": "latin,latin-ext"
			},
			"Bentham": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Berkshire Swash": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Beth Ellen": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Bevan": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Big Shoulders Display": {
				"category": "display",
				"variants": "100,300,400,500,600,700,800,900",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Big Shoulders Text": {
				"category": "display",
				"variants": "100,300,400,500,600,700,800,900",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Bigelow Rules": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Bigshot One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Bilbo": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Bilbo Swash Caps": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"BioRhyme": {
				"category": "serif",
				"variants": "200,300,400,700,800",
				"subsets": "latin,latin-ext"
			},
			"BioRhyme Expanded": {
				"category": "serif",
				"variants": "200,300,400,700,800",
				"subsets": "latin,latin-ext"
			},
			"Biryani": {
				"category": "sans-serif",
				"variants": "200,300,400,600,700,800,900",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Bitter": {
				"category": "serif",
				"variants": "400,400i,700",
				"subsets": "latin,latin-ext"
			},
			"Black And White Picture": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "korean,latin"
			},
			"Black Han Sans": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "korean,latin"
			},
			"Black Ops One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Blinker": {
				"category": "sans-serif",
				"variants": "100,200,300,400,600,700,800,900",
				"subsets": "latin,latin-ext"
			},
			"Bokor": {
				"category": "display",
				"variants": "400",
				"subsets": "khmer"
			},
			"Bonbon": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Boogaloo": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Bowlby One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Bowlby One SC": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Brawler": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Bree Serif": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Bubblegum Sans": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Bubbler One": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Buda": {
				"category": "display",
				"variants": "300",
				"subsets": "latin"
			},
			"Buenard": {
				"category": "serif",
				"variants": "400,700",
				"subsets": "latin,latin-ext"
			},
			"Bungee": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Bungee Hairline": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Bungee Inline": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Bungee Outline": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Bungee Shade": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Butcherman": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Butterfly Kids": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Cabin": {
				"category": "sans-serif",
				"variants": "400,400i,500,500i,600,600i,700,700i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Cabin Condensed": {
				"category": "sans-serif",
				"variants": "400,500,600,700",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Cabin Sketch": {
				"category": "display",
				"variants": "400,700",
				"subsets": "latin"
			},
			"Caesar Dressing": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Cagliostro": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Cairo": {
				"category": "sans-serif",
				"variants": "200,300,400,600,700,900",
				"subsets": "arabic,latin,latin-ext"
			},
			"Caladea": {
				"category": "serif",
				"variants": "400,400i,700,700i",
				"subsets": "latin,latin-ext"
			},
			"Calistoga": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Calligraffitti": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Cambay": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Cambo": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Candal": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Cantarell": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i",
				"subsets": "latin"
			},
			"Cantata One": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Cantora One": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Capriola": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Cardo": {
				"category": "serif",
				"variants": "400,400i,700",
				"subsets": "greek,greek-ext,latin,latin-ext"
			},
			"Carme": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Carrois Gothic": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Carrois Gothic SC": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Carter One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Catamaran": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700,800,900",
				"subsets": "latin,latin-ext,tamil"
			},
			"Caudex": {
				"category": "serif",
				"variants": "400,400i,700,700i",
				"subsets": "greek,greek-ext,latin,latin-ext"
			},
			"Caveat": {
				"category": "handwriting",
				"variants": "400,700",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
			},
			"Caveat Brush": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Cedarville Cursive": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Ceviche One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Chakra Petch": {
				"category": "sans-serif",
				"variants": "300,300i,400,400i,500,500i,600,600i,700,700i",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Changa": {
				"category": "sans-serif",
				"variants": "200,300,400,500,600,700,800",
				"subsets": "arabic,latin,latin-ext"
			},
			"Changa One": {
				"category": "display",
				"variants": "400,400i",
				"subsets": "latin"
			},
			"Chango": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Charm": {
				"category": "handwriting",
				"variants": "400,700",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Charmonman": {
				"category": "handwriting",
				"variants": "400,700",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Chathura": {
				"category": "sans-serif",
				"variants": "100,300,400,700,800",
				"subsets": "latin,telugu"
			},
			"Chau Philomene One": {
				"category": "sans-serif",
				"variants": "400,400i",
				"subsets": "latin,latin-ext"
			},
			"Chela One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Chelsea Market": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Chenla": {
				"category": "display",
				"variants": "400",
				"subsets": "khmer"
			},
			"Cherry Cream Soda": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Cherry Swash": {
				"category": "display",
				"variants": "400,700",
				"subsets": "latin,latin-ext"
			},
			"Chewy": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Chicle": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Chilanka": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,malayalam"
			},
			"Chivo": {
				"category": "sans-serif",
				"variants": "300,300i,400,400i,700,700i,900,900i",
				"subsets": "latin,latin-ext"
			},
			"Chonburi": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Cinzel": {
				"category": "serif",
				"variants": "400,700,900",
				"subsets": "latin,latin-ext"
			},
			"Cinzel Decorative": {
				"category": "display",
				"variants": "400,700,900",
				"subsets": "latin"
			},
			"Clicker Script": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Coda": {
				"category": "display",
				"variants": "400,800",
				"subsets": "latin,latin-ext"
			},
			"Coda Caption": {
				"category": "sans-serif",
				"variants": "800",
				"subsets": "latin,latin-ext"
			},
			"Codystar": {
				"category": "display",
				"variants": "300,400",
				"subsets": "latin,latin-ext"
			},
			"Coiny": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext,tamil,vietnamese"
			},
			"Combo": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Comfortaa": {
				"category": "display",
				"variants": "300,400,500,600,700",
				"subsets": "cyrillic,cyrillic-ext,greek,latin,latin-ext,vietnamese"
			},
			"Comic Neue": {
				"category": "handwriting",
				"variants": "300,300i,400,400i,700,700i",
				"subsets": "latin"
			},
			"Coming Soon": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Concert One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Condiment": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Content": {
				"category": "display",
				"variants": "400,700",
				"subsets": "khmer"
			},
			"Contrail One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Convergence": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Cookie": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Copse": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Corben": {
				"category": "display",
				"variants": "400,700",
				"subsets": "latin,latin-ext"
			},
			"Cormorant": {
				"category": "serif",
				"variants": "300,300i,400,400i,500,500i,600,600i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Cormorant Garamond": {
				"category": "serif",
				"variants": "300,300i,400,400i,500,500i,600,600i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Cormorant Infant": {
				"category": "serif",
				"variants": "300,300i,400,400i,500,500i,600,600i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Cormorant SC": {
				"category": "serif",
				"variants": "300,400,500,600,700",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Cormorant Unicase": {
				"category": "serif",
				"variants": "300,400,500,600,700",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Cormorant Upright": {
				"category": "serif",
				"variants": "300,400,500,600,700",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Courgette": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Courier Prime": {
				"category": "monospace",
				"variants": "400,400i,700,700i",
				"subsets": "latin,latin-ext"
			},
			"Cousine": {
				"category": "monospace",
				"variants": "400,400i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,hebrew,latin,latin-ext,vietnamese"
			},
			"Coustard": {
				"category": "serif",
				"variants": "400,900",
				"subsets": "latin"
			},
			"Covered By Your Grace": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Crafty Girls": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Creepster": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Crete Round": {
				"category": "serif",
				"variants": "400,400i",
				"subsets": "latin,latin-ext"
			},
			"Crimson Pro": {
				"category": "serif",
				"variants": "200,300,400,500,600,700,800,900,200i,300i,400i,500i,600i,700i,800i,900i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Crimson Text": {
				"category": "serif",
				"variants": "400,400i,600,600i,700,700i",
				"subsets": "latin"
			},
			"Croissant One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Crushed": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Cuprum": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Cute Font": {
				"category": "display",
				"variants": "400",
				"subsets": "korean,latin"
			},
			"Cutive": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Cutive Mono": {
				"category": "monospace",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"DM Mono": {
				"category": "monospace",
				"variants": "300,300i,400,400i,500,500i",
				"subsets": "latin,latin-ext"
			},
			"DM Sans": {
				"category": "sans-serif",
				"variants": "400,400i,500,500i,700,700i",
				"subsets": "latin,latin-ext"
			},
			"DM Serif Display": {
				"category": "serif",
				"variants": "400,400i",
				"subsets": "latin,latin-ext"
			},
			"DM Serif Text": {
				"category": "serif",
				"variants": "400,400i",
				"subsets": "latin,latin-ext"
			},
			"Damion": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Dancing Script": {
				"category": "handwriting",
				"variants": "400,500,600,700",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Dangrek": {
				"category": "display",
				"variants": "400",
				"subsets": "khmer"
			},
			"Darker Grotesque": {
				"category": "sans-serif",
				"variants": "300,400,500,600,700,800,900",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"David Libre": {
				"category": "serif",
				"variants": "400,500,700",
				"subsets": "hebrew,latin,latin-ext,vietnamese"
			},
			"Dawning of a New Day": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Days One": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Dekko": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Delius": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Delius Swash Caps": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Delius Unicase": {
				"category": "handwriting",
				"variants": "400,700",
				"subsets": "latin"
			},
			"Della Respira": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Denk One": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Devonshire": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Dhurjati": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,telugu"
			},
			"Didact Gothic": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext"
			},
			"Diplomata": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Diplomata SC": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Do Hyeon": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "korean,latin"
			},
			"Dokdo": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "korean,latin"
			},
			"Domine": {
				"category": "serif",
				"variants": "400,700",
				"subsets": "latin,latin-ext"
			},
			"Donegal One": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Doppio One": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Dorsa": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Dosis": {
				"category": "sans-serif",
				"variants": "200,300,400,500,600,700,800",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Dr Sugiyama": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Duru Sans": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Dynalight": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"EB Garamond": {
				"category": "serif",
				"variants": "400,500,600,700,800,400i,500i,600i,700i,800i",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
			},
			"Eagle Lake": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"East Sea Dokdo": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "korean,latin"
			},
			"Eater": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Economica": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i",
				"subsets": "latin,latin-ext"
			},
			"Eczar": {
				"category": "serif",
				"variants": "400,500,600,700,800",
				"subsets": "devanagari,latin,latin-ext"
			},
			"El Messiri": {
				"category": "sans-serif",
				"variants": "400,500,600,700",
				"subsets": "arabic,cyrillic,latin"
			},
			"Electrolize": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Elsie": {
				"category": "display",
				"variants": "400,900",
				"subsets": "latin,latin-ext"
			},
			"Elsie Swash Caps": {
				"category": "display",
				"variants": "400,900",
				"subsets": "latin,latin-ext"
			},
			"Emblema One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Emilys Candy": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Encode Sans": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700,800,900",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Encode Sans Condensed": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700,800,900",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Encode Sans Expanded": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700,800,900",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Encode Sans Semi Condensed": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700,800,900",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Encode Sans Semi Expanded": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700,800,900",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Engagement": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Englebert": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Enriqueta": {
				"category": "serif",
				"variants": "400,500,600,700",
				"subsets": "latin,latin-ext"
			},
			"Erica One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Esteban": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Euphoria Script": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Ewert": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Exo": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700,800,900,100i,200i,300i,400i,500i,600i,700i,800i,900i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Exo 2": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700,800,900,100i,200i,300i,400i,500i,600i,700i,800i,900i",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Expletus Sans": {
				"category": "display",
				"variants": "400,400i,500,500i,600,600i,700,700i",
				"subsets": "latin"
			},
			"Fahkwang": {
				"category": "sans-serif",
				"variants": "200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Fanwood Text": {
				"category": "serif",
				"variants": "400,400i",
				"subsets": "latin"
			},
			"Farro": {
				"category": "sans-serif",
				"variants": "300,400,500,700",
				"subsets": "latin,latin-ext"
			},
			"Farsan": {
				"category": "display",
				"variants": "400",
				"subsets": "gujarati,latin,latin-ext,vietnamese"
			},
			"Fascinate": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Fascinate Inline": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Faster One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Fasthand": {
				"category": "serif",
				"variants": "400",
				"subsets": "khmer"
			},
			"Fauna One": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Faustina": {
				"category": "serif",
				"variants": "400,500,600,700,400i,500i,600i,700i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Federant": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Federo": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Felipa": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Fenix": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Finger Paint": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Fira Code": {
				"category": "monospace",
				"variants": "300,400,500,600,700",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext"
			},
			"Fira Mono": {
				"category": "monospace",
				"variants": "400,500,700",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext"
			},
			"Fira Sans": {
				"category": "sans-serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
			},
			"Fira Sans Condensed": {
				"category": "sans-serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
			},
			"Fira Sans Extra Condensed": {
				"category": "sans-serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
			},
			"Fjalla One": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Fjord One": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Flamenco": {
				"category": "display",
				"variants": "300,400",
				"subsets": "latin"
			},
			"Flavors": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Fondamento": {
				"category": "handwriting",
				"variants": "400,400i",
				"subsets": "latin,latin-ext"
			},
			"Fontdiner Swanky": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Forum": {
				"category": "display",
				"variants": "400",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
			},
			"Francois One": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Frank Ruhl Libre": {
				"category": "serif",
				"variants": "300,400,500,700,900",
				"subsets": "hebrew,latin,latin-ext"
			},
			"Freckle Face": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Fredericka the Great": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Fredoka One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Freehand": {
				"category": "display",
				"variants": "400",
				"subsets": "khmer"
			},
			"Fresca": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Frijole": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Fruktur": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Fugaz One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"GFS Didot": {
				"category": "serif",
				"variants": "400",
				"subsets": "greek"
			},
			"GFS Neohellenic": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i",
				"subsets": "greek"
			},
			"Gabriela": {
				"category": "serif",
				"variants": "400",
				"subsets": "cyrillic,cyrillic-ext,latin"
			},
			"Gaegu": {
				"category": "handwriting",
				"variants": "300,400,700",
				"subsets": "korean,latin"
			},
			"Gafata": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Galada": {
				"category": "display",
				"variants": "400",
				"subsets": "bengali,latin"
			},
			"Galdeano": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Galindo": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Gamja Flower": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "korean,latin"
			},
			"Gayathri": {
				"category": "sans-serif",
				"variants": "100,400,700",
				"subsets": "latin,malayalam"
			},
			"Gelasio": {
				"category": "serif",
				"variants": "400,400i,500,500i,600,600i,700,700i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Gentium Basic": {
				"category": "serif",
				"variants": "400,400i,700,700i",
				"subsets": "latin,latin-ext"
			},
			"Gentium Book Basic": {
				"category": "serif",
				"variants": "400,400i,700,700i",
				"subsets": "latin,latin-ext"
			},
			"Geo": {
				"category": "sans-serif",
				"variants": "400,400i",
				"subsets": "latin"
			},
			"Geostar": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Geostar Fill": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Germania One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Gidugu": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,telugu"
			},
			"Gilda Display": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Girassol": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Give You Glory": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Glass Antiqua": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Glegoo": {
				"category": "serif",
				"variants": "400,700",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Gloria Hallelujah": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Goblin One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Gochi Hand": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Gorditas": {
				"category": "display",
				"variants": "400,700",
				"subsets": "latin"
			},
			"Gothic A1": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700,800,900",
				"subsets": "korean,latin"
			},
			"Gotu": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "devanagari,latin,latin-ext,vietnamese"
			},
			"Goudy Bookletter 1911": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Graduate": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Grand Hotel": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Gravitas One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Great Vibes": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Grenze": {
				"category": "serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Grenze Gotisch": {
				"category": "display",
				"variants": "100,200,300,400,500,600,700,800,900",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Griffy": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Gruppo": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Gudea": {
				"category": "sans-serif",
				"variants": "400,400i,700",
				"subsets": "latin,latin-ext"
			},
			"Gugi": {
				"category": "display",
				"variants": "400",
				"subsets": "korean,latin"
			},
			"Gupter": {
				"category": "serif",
				"variants": "400,500,700",
				"subsets": "latin"
			},
			"Gurajada": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,telugu"
			},
			"Habibi": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Halant": {
				"category": "serif",
				"variants": "300,400,500,600,700",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Hammersmith One": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Hanalei": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Hanalei Fill": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Handlee": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Hanuman": {
				"category": "serif",
				"variants": "400,700",
				"subsets": "khmer"
			},
			"Happy Monkey": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Harmattan": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "arabic,latin"
			},
			"Headland One": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Heebo": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700,800,900",
				"subsets": "hebrew,latin"
			},
			"Henny Penny": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Hepta Slab": {
				"category": "serif",
				"variants": "100,200,300,400,500,600,700,800,900",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Herr Von Muellerhoff": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Hi Melody": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "korean,latin"
			},
			"Hind": {
				"category": "sans-serif",
				"variants": "300,400,500,600,700",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Hind Guntur": {
				"category": "sans-serif",
				"variants": "300,400,500,600,700",
				"subsets": "latin,latin-ext,telugu"
			},
			"Hind Madurai": {
				"category": "sans-serif",
				"variants": "300,400,500,600,700",
				"subsets": "latin,latin-ext,tamil"
			},
			"Hind Siliguri": {
				"category": "sans-serif",
				"variants": "300,400,500,600,700",
				"subsets": "bengali,latin,latin-ext"
			},
			"Hind Vadodara": {
				"category": "sans-serif",
				"variants": "300,400,500,600,700",
				"subsets": "gujarati,latin,latin-ext"
			},
			"Holtwood One SC": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Homemade Apple": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Homenaje": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"IBM Plex Mono": {
				"category": "monospace",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"IBM Plex Sans": {
				"category": "sans-serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,greek,latin,latin-ext,vietnamese"
			},
			"IBM Plex Sans Condensed": {
				"category": "sans-serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"IBM Plex Serif": {
				"category": "serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"IM Fell DW Pica": {
				"category": "serif",
				"variants": "400,400i",
				"subsets": "latin"
			},
			"IM Fell DW Pica SC": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"IM Fell Double Pica": {
				"category": "serif",
				"variants": "400,400i",
				"subsets": "latin"
			},
			"IM Fell Double Pica SC": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"IM Fell English": {
				"category": "serif",
				"variants": "400,400i",
				"subsets": "latin"
			},
			"IM Fell English SC": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"IM Fell French Canon": {
				"category": "serif",
				"variants": "400,400i",
				"subsets": "latin"
			},
			"IM Fell French Canon SC": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"IM Fell Great Primer": {
				"category": "serif",
				"variants": "400,400i",
				"subsets": "latin"
			},
			"IM Fell Great Primer SC": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Ibarra Real Nova": {
				"category": "serif",
				"variants": "400,400i,600,600i,700,700i",
				"subsets": "latin,latin-ext"
			},
			"Iceberg": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Iceland": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Imprima": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Inconsolata": {
				"category": "monospace",
				"variants": "200,300,400,500,600,700,800,900",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Inder": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Indie Flower": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Inika": {
				"category": "serif",
				"variants": "400,700",
				"subsets": "latin,latin-ext"
			},
			"Inknut Antiqua": {
				"category": "serif",
				"variants": "300,400,500,600,700,800,900",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Inria Sans": {
				"category": "sans-serif",
				"variants": "300,300i,400,400i,700,700i",
				"subsets": "latin,latin-ext"
			},
			"Inria Serif": {
				"category": "serif",
				"variants": "300,300i,400,400i,700,700i",
				"subsets": "latin,latin-ext"
			},
			"Inter": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700,800,900",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
			},
			"Irish Grover": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Istok Web": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
			},
			"Italiana": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Italianno": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Itim": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Jacques Francois": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Jacques Francois Shadow": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Jaldi": {
				"category": "sans-serif",
				"variants": "400,700",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Jim Nightshade": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Jockey One": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Jolly Lodger": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Jomhuria": {
				"category": "display",
				"variants": "400",
				"subsets": "arabic,latin,latin-ext"
			},
			"Jomolhari": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,tibetan"
			},
			"Josefin Sans": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700,100i,200i,300i,400i,500i,600i,700i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Josefin Slab": {
				"category": "serif",
				"variants": "100,100i,300,300i,400,400i,600,600i,700,700i",
				"subsets": "latin"
			},
			"Jost": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700,800,900,100i,200i,300i,400i,500i,600i,700i,800i,900i",
				"subsets": "cyrillic,latin,latin-ext"
			},
			"Joti One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Jua": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "korean,latin"
			},
			"Judson": {
				"category": "serif",
				"variants": "400,400i,700",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Julee": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Julius Sans One": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Junge": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Jura": {
				"category": "sans-serif",
				"variants": "300,400,500,600,700",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
			},
			"Just Another Hand": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Just Me Again Down Here": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"K2D": {
				"category": "sans-serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Kadwa": {
				"category": "serif",
				"variants": "400,700",
				"subsets": "devanagari,latin"
			},
			"Kalam": {
				"category": "handwriting",
				"variants": "300,400,700",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Kameron": {
				"category": "serif",
				"variants": "400,700",
				"subsets": "latin"
			},
			"Kanit": {
				"category": "sans-serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Kantumruy": {
				"category": "sans-serif",
				"variants": "300,400,700",
				"subsets": "khmer"
			},
			"Karla": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i",
				"subsets": "latin,latin-ext"
			},
			"Karma": {
				"category": "serif",
				"variants": "300,400,500,600,700",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Katibeh": {
				"category": "display",
				"variants": "400",
				"subsets": "arabic,latin,latin-ext"
			},
			"Kaushan Script": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Kavivanar": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext,tamil"
			},
			"Kavoon": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Kdam Thmor": {
				"category": "display",
				"variants": "400",
				"subsets": "khmer"
			},
			"Keania One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Kelly Slab": {
				"category": "display",
				"variants": "400",
				"subsets": "cyrillic,latin,latin-ext"
			},
			"Kenia": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Khand": {
				"category": "sans-serif",
				"variants": "300,400,500,600,700",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Khmer": {
				"category": "display",
				"variants": "400",
				"subsets": "khmer"
			},
			"Khula": {
				"category": "sans-serif",
				"variants": "300,400,600,700,800",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Kirang Haerang": {
				"category": "display",
				"variants": "400",
				"subsets": "korean,latin"
			},
			"Kite One": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Knewave": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"KoHo": {
				"category": "sans-serif",
				"variants": "200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Kodchasan": {
				"category": "sans-serif",
				"variants": "200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Kosugi": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "cyrillic,japanese,latin"
			},
			"Kosugi Maru": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "cyrillic,japanese,latin"
			},
			"Kotta One": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Koulen": {
				"category": "display",
				"variants": "400",
				"subsets": "khmer"
			},
			"Kranky": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Kreon": {
				"category": "serif",
				"variants": "300,400,500,600,700",
				"subsets": "latin,latin-ext"
			},
			"Kristi": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Krona One": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Krub": {
				"category": "sans-serif",
				"variants": "200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Kulim Park": {
				"category": "sans-serif",
				"variants": "200,200i,300,300i,400,400i,600,600i,700,700i",
				"subsets": "latin,latin-ext"
			},
			"Kumar One": {
				"category": "display",
				"variants": "400",
				"subsets": "gujarati,latin,latin-ext"
			},
			"Kumar One Outline": {
				"category": "display",
				"variants": "400",
				"subsets": "gujarati,latin,latin-ext"
			},
			"Kurale": {
				"category": "serif",
				"variants": "400",
				"subsets": "cyrillic,cyrillic-ext,devanagari,latin,latin-ext"
			},
			"La Belle Aurore": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Lacquer": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Laila": {
				"category": "serif",
				"variants": "300,400,500,600,700",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Lakki Reddy": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,telugu"
			},
			"Lalezar": {
				"category": "display",
				"variants": "400",
				"subsets": "arabic,latin,latin-ext,vietnamese"
			},
			"Lancelot": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Lateef": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "arabic,latin"
			},
			"Lato": {
				"category": "sans-serif",
				"variants": "100,100i,300,300i,400,400i,700,700i,900,900i",
				"subsets": "latin,latin-ext"
			},
			"League Script": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Leckerli One": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Ledger": {
				"category": "serif",
				"variants": "400",
				"subsets": "cyrillic,latin,latin-ext"
			},
			"Lekton": {
				"category": "sans-serif",
				"variants": "400,400i,700",
				"subsets": "latin,latin-ext"
			},
			"Lemon": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Lemonada": {
				"category": "display",
				"variants": "300,400,500,600,700",
				"subsets": "arabic,latin,latin-ext,vietnamese"
			},
			"Lexend Deca": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Lexend Exa": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Lexend Giga": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Lexend Mega": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Lexend Peta": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Lexend Tera": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Lexend Zetta": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Libre Barcode 128": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Libre Barcode 128 Text": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Libre Barcode 39": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Libre Barcode 39 Extended": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Libre Barcode 39 Extended Text": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Libre Barcode 39 Text": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Libre Baskerville": {
				"category": "serif",
				"variants": "400,400i,700",
				"subsets": "latin,latin-ext"
			},
			"Libre Caslon Display": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Libre Caslon Text": {
				"category": "serif",
				"variants": "400,400i,700",
				"subsets": "latin,latin-ext"
			},
			"Libre Franklin": {
				"category": "sans-serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
				"subsets": "latin,latin-ext"
			},
			"Life Savers": {
				"category": "display",
				"variants": "400,700,800",
				"subsets": "latin,latin-ext"
			},
			"Lilita One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Lily Script One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Limelight": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Linden Hill": {
				"category": "serif",
				"variants": "400,400i",
				"subsets": "latin"
			},
			"Literata": {
				"category": "serif",
				"variants": "400,500,600,700,400i,500i,600i,700i",
				"subsets": "cyrillic,greek,greek-ext,latin,latin-ext,vietnamese"
			},
			"Liu Jian Mao Cao": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "chinese-simplified,latin"
			},
			"Livvic": {
				"category": "sans-serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,900,900i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Lobster": {
				"category": "display",
				"variants": "400",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Lobster Two": {
				"category": "display",
				"variants": "400,400i,700,700i",
				"subsets": "latin"
			},
			"Londrina Outline": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Londrina Shadow": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Londrina Sketch": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Londrina Solid": {
				"category": "display",
				"variants": "100,300,400,900",
				"subsets": "latin"
			},
			"Long Cang": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "chinese-simplified,latin"
			},
			"Lora": {
				"category": "serif",
				"variants": "400,500,600,700,400i,500i,600i,700i",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Love Ya Like A Sister": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Loved by the King": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Lovers Quarrel": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Luckiest Guy": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Lusitana": {
				"category": "serif",
				"variants": "400,700",
				"subsets": "latin"
			},
			"Lustria": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"M PLUS 1p": {
				"category": "sans-serif",
				"variants": "100,300,400,500,700,800,900",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,hebrew,japanese,latin,latin-ext,vietnamese"
			},
			"M PLUS Rounded 1c": {
				"category": "sans-serif",
				"variants": "100,300,400,500,700,800,900",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,hebrew,japanese,latin,latin-ext,vietnamese"
			},
			"Ma Shan Zheng": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "chinese-simplified,latin"
			},
			"Macondo": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Macondo Swash Caps": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Mada": {
				"category": "sans-serif",
				"variants": "200,300,400,500,600,700,900",
				"subsets": "arabic,latin"
			},
			"Magra": {
				"category": "sans-serif",
				"variants": "400,700",
				"subsets": "latin,latin-ext"
			},
			"Maiden Orange": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Maitree": {
				"category": "serif",
				"variants": "200,300,400,500,600,700",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Major Mono Display": {
				"category": "monospace",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Mako": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Mali": {
				"category": "handwriting",
				"variants": "200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Mallanna": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,telugu"
			},
			"Mandali": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,telugu"
			},
			"Manjari": {
				"category": "sans-serif",
				"variants": "100,400,700",
				"subsets": "latin,malayalam"
			},
			"Manrope": {
				"category": "sans-serif",
				"variants": "200,300,400,500,600,700,800",
				"subsets": "cyrillic,greek,latin,latin-ext"
			},
			"Mansalva": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Manuale": {
				"category": "serif",
				"variants": "400,500,600,700,400i,500i,600i,700i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Marcellus": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Marcellus SC": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Marck Script": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "cyrillic,latin,latin-ext"
			},
			"Margarine": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Markazi Text": {
				"category": "serif",
				"variants": "400,500,600,700",
				"subsets": "arabic,latin,latin-ext,vietnamese"
			},
			"Marko One": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Marmelad": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "cyrillic,latin,latin-ext"
			},
			"Martel": {
				"category": "serif",
				"variants": "200,300,400,600,700,800,900",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Martel Sans": {
				"category": "sans-serif",
				"variants": "200,300,400,600,700,800,900",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Marvel": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i",
				"subsets": "latin"
			},
			"Mate": {
				"category": "serif",
				"variants": "400,400i",
				"subsets": "latin"
			},
			"Mate SC": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Maven Pro": {
				"category": "sans-serif",
				"variants": "400,500,600,700,800,900",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"McLaren": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Meddon": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"MedievalSharp": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Medula One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Meera Inimai": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,tamil"
			},
			"Megrim": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Meie Script": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Merienda": {
				"category": "handwriting",
				"variants": "400,700",
				"subsets": "latin,latin-ext"
			},
			"Merienda One": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Merriweather": {
				"category": "serif",
				"variants": "300,300i,400,400i,700,700i,900,900i",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Merriweather Sans": {
				"category": "sans-serif",
				"variants": "300,300i,400,400i,700,700i,800,800i",
				"subsets": "latin,latin-ext"
			},
			"Metal": {
				"category": "display",
				"variants": "400",
				"subsets": "khmer"
			},
			"Metal Mania": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Metamorphous": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Metrophobic": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Michroma": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Milonga": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Miltonian": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Miltonian Tattoo": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Mina": {
				"category": "sans-serif",
				"variants": "400,700",
				"subsets": "bengali,latin,latin-ext"
			},
			"Miniver": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Miriam Libre": {
				"category": "sans-serif",
				"variants": "400,700",
				"subsets": "hebrew,latin,latin-ext"
			},
			"Mirza": {
				"category": "display",
				"variants": "400,500,600,700",
				"subsets": "arabic,latin,latin-ext"
			},
			"Miss Fajardose": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Mitr": {
				"category": "sans-serif",
				"variants": "200,300,400,500,600,700",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Modak": {
				"category": "display",
				"variants": "400",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Modern Antiqua": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Mogra": {
				"category": "display",
				"variants": "400",
				"subsets": "gujarati,latin,latin-ext"
			},
			"Molengo": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Molle": {
				"category": "handwriting",
				"variants": "400i",
				"subsets": "latin,latin-ext"
			},
			"Monda": {
				"category": "sans-serif",
				"variants": "400,700",
				"subsets": "latin,latin-ext"
			},
			"Monofett": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Monoton": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Monsieur La Doulaise": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Montaga": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Montez": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Montserrat": {
				"category": "sans-serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Montserrat Alternates": {
				"category": "sans-serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Montserrat Subrayada": {
				"category": "sans-serif",
				"variants": "400,700",
				"subsets": "latin"
			},
			"Moul": {
				"category": "display",
				"variants": "400",
				"subsets": "khmer"
			},
			"Moulpali": {
				"category": "display",
				"variants": "400",
				"subsets": "khmer"
			},
			"Mountains of Christmas": {
				"category": "display",
				"variants": "400,700",
				"subsets": "latin"
			},
			"Mouse Memoirs": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Mr Bedfort": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Mr Dafoe": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Mr De Haviland": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Mrs Saint Delafield": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Mrs Sheppards": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Mukta": {
				"category": "sans-serif",
				"variants": "200,300,400,500,600,700,800",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Mukta Mahee": {
				"category": "sans-serif",
				"variants": "200,300,400,500,600,700,800",
				"subsets": "gurmukhi,latin,latin-ext"
			},
			"Mukta Malar": {
				"category": "sans-serif",
				"variants": "200,300,400,500,600,700,800",
				"subsets": "latin,latin-ext,tamil"
			},
			"Mukta Vaani": {
				"category": "sans-serif",
				"variants": "200,300,400,500,600,700,800",
				"subsets": "gujarati,latin,latin-ext"
			},
			"Muli": {
				"category": "sans-serif",
				"variants": "200,300,400,500,600,700,800,900,200i,300i,400i,500i,600i,700i,800i,900i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"MuseoModerno": {
				"category": "display",
				"variants": "100,200,300,400,500,600,700,800,900",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Mystery Quest": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"NTR": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,telugu"
			},
			"Nanum Brush Script": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "korean,latin"
			},
			"Nanum Gothic": {
				"category": "sans-serif",
				"variants": "400,700,800",
				"subsets": "korean,latin"
			},
			"Nanum Gothic Coding": {
				"category": "monospace",
				"variants": "400,700",
				"subsets": "korean,latin"
			},
			"Nanum Myeongjo": {
				"category": "serif",
				"variants": "400,700,800",
				"subsets": "korean,latin"
			},
			"Nanum Pen Script": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "korean,latin"
			},
			"Neucha": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "cyrillic,latin"
			},
			"Neuton": {
				"category": "serif",
				"variants": "200,300,400,400i,700,800",
				"subsets": "latin,latin-ext"
			},
			"New Rocker": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"News Cycle": {
				"category": "sans-serif",
				"variants": "400,700",
				"subsets": "latin,latin-ext"
			},
			"Niconne": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Niramit": {
				"category": "sans-serif",
				"variants": "200,200i,300,300i,400,400i,500,500i,600,600i,700,700i",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Nixie One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Nobile": {
				"category": "sans-serif",
				"variants": "400,400i,500,500i,700,700i",
				"subsets": "latin,latin-ext"
			},
			"Nokora": {
				"category": "serif",
				"variants": "400,700",
				"subsets": "khmer"
			},
			"Norican": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Nosifer": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Notable": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Nothing You Could Do": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Noticia Text": {
				"category": "serif",
				"variants": "400,400i,700,700i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Noto Sans": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,devanagari,greek,greek-ext,latin,latin-ext,vietnamese"
			},
			"Noto Sans HK": {
				"category": "sans-serif",
				"variants": "100,300,400,500,700,900",
				"subsets": "chinese-hongkong,latin"
			},
			"Noto Sans JP": {
				"category": "sans-serif",
				"variants": "100,300,400,500,700,900",
				"subsets": "japanese,latin"
			},
			"Noto Sans KR": {
				"category": "sans-serif",
				"variants": "100,300,400,500,700,900",
				"subsets": "korean,latin"
			},
			"Noto Sans SC": {
				"category": "sans-serif",
				"variants": "100,300,400,500,700,900",
				"subsets": "chinese-simplified,latin"
			},
			"Noto Sans TC": {
				"category": "sans-serif",
				"variants": "100,300,400,500,700,900",
				"subsets": "chinese-traditional,latin"
			},
			"Noto Serif": {
				"category": "serif",
				"variants": "400,400i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
			},
			"Noto Serif JP": {
				"category": "serif",
				"variants": "200,300,400,500,600,700,900",
				"subsets": "japanese,latin"
			},
			"Noto Serif KR": {
				"category": "serif",
				"variants": "200,300,400,500,600,700,900",
				"subsets": "korean,latin"
			},
			"Noto Serif SC": {
				"category": "serif",
				"variants": "200,300,400,500,600,700,900",
				"subsets": "chinese-simplified,latin"
			},
			"Noto Serif TC": {
				"category": "serif",
				"variants": "200,300,400,500,600,700,900",
				"subsets": "chinese-traditional,latin"
			},
			"Nova Cut": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Nova Flat": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Nova Mono": {
				"category": "monospace",
				"variants": "400",
				"subsets": "greek,latin"
			},
			"Nova Oval": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Nova Round": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Nova Script": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Nova Slim": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Nova Square": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Numans": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Nunito": {
				"category": "sans-serif",
				"variants": "200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Nunito Sans": {
				"category": "sans-serif",
				"variants": "200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Odibee Sans": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Odor Mean Chey": {
				"category": "display",
				"variants": "400",
				"subsets": "khmer"
			},
			"Offside": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Old Standard TT": {
				"category": "serif",
				"variants": "400,400i,700",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Oldenburg": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Oleo Script": {
				"category": "display",
				"variants": "400,700",
				"subsets": "latin,latin-ext"
			},
			"Oleo Script Swash Caps": {
				"category": "display",
				"variants": "400,700",
				"subsets": "latin,latin-ext"
			},
			"Open Sans": {
				"category": "sans-serif",
				"variants": "300,300i,400,400i,600,600i,700,700i,800,800i",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
			},
			"Open Sans Condensed": {
				"category": "sans-serif",
				"variants": "300,300i,700",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
			},
			"Oranienbaum": {
				"category": "serif",
				"variants": "400",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
			},
			"Orbitron": {
				"category": "sans-serif",
				"variants": "400,500,600,700,800,900",
				"subsets": "latin"
			},
			"Oregano": {
				"category": "display",
				"variants": "400,400i",
				"subsets": "latin,latin-ext"
			},
			"Orienta": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Original Surfer": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Oswald": {
				"category": "sans-serif",
				"variants": "200,300,400,500,600,700",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Over the Rainbow": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Overlock": {
				"category": "display",
				"variants": "400,400i,700,700i,900,900i",
				"subsets": "latin,latin-ext"
			},
			"Overlock SC": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Overpass": {
				"category": "sans-serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i",
				"subsets": "latin,latin-ext"
			},
			"Overpass Mono": {
				"category": "monospace",
				"variants": "300,400,600,700",
				"subsets": "latin,latin-ext"
			},
			"Ovo": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Oxanium": {
				"category": "display",
				"variants": "200,300,400,500,600,700,800",
				"subsets": "latin,latin-ext"
			},
			"Oxygen": {
				"category": "sans-serif",
				"variants": "300,400,700",
				"subsets": "latin,latin-ext"
			},
			"Oxygen Mono": {
				"category": "monospace",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"PT Mono": {
				"category": "monospace",
				"variants": "400",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
			},
			"PT Sans": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
			},
			"PT Sans Caption": {
				"category": "sans-serif",
				"variants": "400,700",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
			},
			"PT Sans Narrow": {
				"category": "sans-serif",
				"variants": "400,700",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
			},
			"PT Serif": {
				"category": "serif",
				"variants": "400,400i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
			},
			"PT Serif Caption": {
				"category": "serif",
				"variants": "400,400i",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
			},
			"Pacifico": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Padauk": {
				"category": "sans-serif",
				"variants": "400,700",
				"subsets": "latin,myanmar"
			},
			"Palanquin": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Palanquin Dark": {
				"category": "sans-serif",
				"variants": "400,500,600,700",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Pangolin": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Paprika": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Parisienne": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Passero One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Passion One": {
				"category": "display",
				"variants": "400,700,900",
				"subsets": "latin,latin-ext"
			},
			"Pathway Gothic One": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Patrick Hand": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Patrick Hand SC": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Pattaya": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "cyrillic,latin,latin-ext,thai,vietnamese"
			},
			"Patua One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Pavanam": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext,tamil"
			},
			"Paytone One": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Peddana": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,telugu"
			},
			"Peralta": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Permanent Marker": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Petit Formal Script": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Petrona": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Philosopher": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,latin,vietnamese"
			},
			"Piedra": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Pinyon Script": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Pirata One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Plaster": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Play": {
				"category": "sans-serif",
				"variants": "400,700",
				"subsets": "cyrillic,cyrillic-ext,greek,latin,latin-ext,vietnamese"
			},
			"Playball": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Playfair Display": {
				"category": "serif",
				"variants": "400,500,600,700,800,900,400i,500i,600i,700i,800i,900i",
				"subsets": "cyrillic,latin,latin-ext,vietnamese"
			},
			"Playfair Display SC": {
				"category": "serif",
				"variants": "400,400i,700,700i,900,900i",
				"subsets": "cyrillic,latin,latin-ext,vietnamese"
			},
			"Podkova": {
				"category": "serif",
				"variants": "400,500,600,700,800",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Poiret One": {
				"category": "display",
				"variants": "400",
				"subsets": "cyrillic,latin,latin-ext"
			},
			"Poller One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Poly": {
				"category": "serif",
				"variants": "400,400i",
				"subsets": "latin"
			},
			"Pompiere": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Pontano Sans": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Poor Story": {
				"category": "display",
				"variants": "400",
				"subsets": "korean,latin"
			},
			"Poppins": {
				"category": "sans-serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Port Lligat Sans": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Port Lligat Slab": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Pragati Narrow": {
				"category": "sans-serif",
				"variants": "400,700",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Prata": {
				"category": "serif",
				"variants": "400",
				"subsets": "cyrillic,cyrillic-ext,latin,vietnamese"
			},
			"Preahvihear": {
				"category": "display",
				"variants": "400",
				"subsets": "khmer"
			},
			"Press Start 2P": {
				"category": "display",
				"variants": "400",
				"subsets": "cyrillic,cyrillic-ext,greek,latin,latin-ext"
			},
			"Pridi": {
				"category": "serif",
				"variants": "200,300,400,500,600,700",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Princess Sofia": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Prociono": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Prompt": {
				"category": "sans-serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Prosto One": {
				"category": "display",
				"variants": "400",
				"subsets": "cyrillic,latin,latin-ext"
			},
			"Proza Libre": {
				"category": "sans-serif",
				"variants": "400,400i,500,500i,600,600i,700,700i,800,800i",
				"subsets": "latin,latin-ext"
			},
			"Public Sans": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700,800,900,100i,200i,300i,400i,500i,600i,700i,800i,900i",
				"subsets": "latin,latin-ext"
			},
			"Puritan": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i",
				"subsets": "latin"
			},
			"Purple Purse": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Quando": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Quantico": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i",
				"subsets": "latin"
			},
			"Quattrocento": {
				"category": "serif",
				"variants": "400,700",
				"subsets": "latin,latin-ext"
			},
			"Quattrocento Sans": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i",
				"subsets": "latin,latin-ext"
			},
			"Questrial": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Quicksand": {
				"category": "sans-serif",
				"variants": "300,400,500,600,700",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Quintessential": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Qwigley": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Racing Sans One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Radley": {
				"category": "serif",
				"variants": "400,400i",
				"subsets": "latin,latin-ext"
			},
			"Rajdhani": {
				"category": "sans-serif",
				"variants": "300,400,500,600,700",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Rakkas": {
				"category": "display",
				"variants": "400",
				"subsets": "arabic,latin,latin-ext"
			},
			"Raleway": {
				"category": "sans-serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
				"subsets": "latin,latin-ext"
			},
			"Raleway Dots": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Ramabhadra": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,telugu"
			},
			"Ramaraja": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,telugu"
			},
			"Rambla": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i",
				"subsets": "latin,latin-ext"
			},
			"Rammetto One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Ranchers": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Rancho": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Ranga": {
				"category": "display",
				"variants": "400,700",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Rasa": {
				"category": "serif",
				"variants": "300,400,500,600,700",
				"subsets": "gujarati,latin,latin-ext"
			},
			"Rationale": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Ravi Prakash": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,telugu"
			},
			"Red Hat Display": {
				"category": "sans-serif",
				"variants": "400,400i,500,500i,700,700i,900,900i",
				"subsets": "latin,latin-ext"
			},
			"Red Hat Text": {
				"category": "sans-serif",
				"variants": "400,400i,500,500i,700,700i",
				"subsets": "latin,latin-ext"
			},
			"Redressed": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Reem Kufi": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "arabic,latin"
			},
			"Reenie Beanie": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Revalia": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Rhodium Libre": {
				"category": "serif",
				"variants": "400",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Ribeye": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Ribeye Marrow": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Righteous": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Risque": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Roboto": {
				"category": "sans-serif",
				"variants": "100,100i,300,300i,400,400i,500,500i,700,700i,900,900i",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
			},
			"Roboto Condensed": {
				"category": "sans-serif",
				"variants": "300,300i,400,400i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
			},
			"Roboto Mono": {
				"category": "monospace",
				"variants": "100,200,300,400,500,600,700,100i,200i,300i,400i,500i,600i,700i",
				"subsets": "cyrillic,cyrillic-ext,greek,latin,latin-ext,vietnamese"
			},
			"Roboto Slab": {
				"category": "serif",
				"variants": "100,200,300,400,500,600,700,800,900",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
			},
			"Rochester": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Rock Salt": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Rokkitt": {
				"category": "serif",
				"variants": "100,200,300,400,500,600,700,800,900",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Romanesco": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Ropa Sans": {
				"category": "sans-serif",
				"variants": "400,400i",
				"subsets": "latin,latin-ext"
			},
			"Rosario": {
				"category": "sans-serif",
				"variants": "300,400,500,600,700,300i,400i,500i,600i,700i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Rosarivo": {
				"category": "serif",
				"variants": "400,400i",
				"subsets": "latin,latin-ext"
			},
			"Rouge Script": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Rozha One": {
				"category": "serif",
				"variants": "400",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Rubik": {
				"category": "sans-serif",
				"variants": "300,300i,400,400i,500,500i,700,700i,900,900i",
				"subsets": "cyrillic,hebrew,latin,latin-ext"
			},
			"Rubik Mono One": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "cyrillic,latin,latin-ext"
			},
			"Ruda": {
				"category": "sans-serif",
				"variants": "400,500,600,700,800,900",
				"subsets": "cyrillic,latin,latin-ext,vietnamese"
			},
			"Rufina": {
				"category": "serif",
				"variants": "400,700",
				"subsets": "latin,latin-ext"
			},
			"Ruge Boogie": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Ruluko": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Rum Raisin": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Ruslan Display": {
				"category": "display",
				"variants": "400",
				"subsets": "cyrillic,latin,latin-ext"
			},
			"Russo One": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "cyrillic,latin,latin-ext"
			},
			"Ruthie": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Rye": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Sacramento": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Sahitya": {
				"category": "serif",
				"variants": "400,700",
				"subsets": "devanagari,latin"
			},
			"Sail": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Saira": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700,800,900",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Saira Condensed": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700,800,900",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Saira Extra Condensed": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700,800,900",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Saira Semi Condensed": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700,800,900",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Saira Stencil One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Salsa": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Sanchez": {
				"category": "serif",
				"variants": "400,400i",
				"subsets": "latin,latin-ext"
			},
			"Sancreek": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Sansita": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i,800,800i,900,900i",
				"subsets": "latin,latin-ext"
			},
			"Sarabun": {
				"category": "sans-serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Sarala": {
				"category": "sans-serif",
				"variants": "400,700",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Sarina": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Sarpanch": {
				"category": "sans-serif",
				"variants": "400,500,600,700,800,900",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Satisfy": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Sawarabi Gothic": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "cyrillic,japanese,latin,latin-ext,vietnamese"
			},
			"Sawarabi Mincho": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "japanese,latin,latin-ext"
			},
			"Scada": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext"
			},
			"Scheherazade": {
				"category": "serif",
				"variants": "400,700",
				"subsets": "arabic,latin"
			},
			"Schoolbell": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Scope One": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Seaweed Script": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Secular One": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "hebrew,latin,latin-ext"
			},
			"Sedgwick Ave": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Sedgwick Ave Display": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Sen": {
				"category": "sans-serif",
				"variants": "400,700,800",
				"subsets": "latin,latin-ext"
			},
			"Sevillana": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Seymour One": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "cyrillic,latin,latin-ext"
			},
			"Shadows Into Light": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Shadows Into Light Two": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Shanti": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Share": {
				"category": "display",
				"variants": "400,400i,700,700i",
				"subsets": "latin,latin-ext"
			},
			"Share Tech": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Share Tech Mono": {
				"category": "monospace",
				"variants": "400",
				"subsets": "latin"
			},
			"Shojumaru": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Short Stack": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Shrikhand": {
				"category": "display",
				"variants": "400",
				"subsets": "gujarati,latin,latin-ext"
			},
			"Siemreap": {
				"category": "display",
				"variants": "400",
				"subsets": "khmer"
			},
			"Sigmar One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Signika": {
				"category": "sans-serif",
				"variants": "300,400,600,700",
				"subsets": "latin,latin-ext"
			},
			"Signika Negative": {
				"category": "sans-serif",
				"variants": "300,400,600,700",
				"subsets": "latin,latin-ext"
			},
			"Simonetta": {
				"category": "display",
				"variants": "400,400i,900,900i",
				"subsets": "latin,latin-ext"
			},
			"Single Day": {
				"category": "display",
				"variants": "400",
				"subsets": "korean"
			},
			"Sintony": {
				"category": "sans-serif",
				"variants": "400,700",
				"subsets": "latin,latin-ext"
			},
			"Sirin Stencil": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Six Caps": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Skranji": {
				"category": "display",
				"variants": "400,700",
				"subsets": "latin,latin-ext"
			},
			"Slabo 13px": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Slabo 27px": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Slackey": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Smokum": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Smythe": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Sniglet": {
				"category": "display",
				"variants": "400,800",
				"subsets": "latin,latin-ext"
			},
			"Snippet": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Snowburst One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Sofadi One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Sofia": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Solway": {
				"category": "serif",
				"variants": "300,400,500,700,800",
				"subsets": "latin"
			},
			"Song Myung": {
				"category": "serif",
				"variants": "400",
				"subsets": "korean,latin"
			},
			"Sonsie One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Sorts Mill Goudy": {
				"category": "serif",
				"variants": "400,400i",
				"subsets": "latin,latin-ext"
			},
			"Source Code Pro": {
				"category": "monospace",
				"variants": "200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,900,900i",
				"subsets": "cyrillic,cyrillic-ext,greek,latin,latin-ext,vietnamese"
			},
			"Source Sans Pro": {
				"category": "sans-serif",
				"variants": "200,200i,300,300i,400,400i,600,600i,700,700i,900,900i",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext,vietnamese"
			},
			"Source Serif Pro": {
				"category": "serif",
				"variants": "400,600,700",
				"subsets": "latin,latin-ext"
			},
			"Space Mono": {
				"category": "monospace",
				"variants": "400,400i,700,700i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Spartan": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700,800,900",
				"subsets": "latin,latin-ext"
			},
			"Special Elite": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Spectral": {
				"category": "serif",
				"variants": "200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i",
				"subsets": "cyrillic,latin,latin-ext,vietnamese"
			},
			"Spectral SC": {
				"category": "serif",
				"variants": "200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i",
				"subsets": "cyrillic,latin,latin-ext,vietnamese"
			},
			"Spicy Rice": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Spinnaker": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Spirax": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Squada One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Sree Krushnadevaraya": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,telugu"
			},
			"Sriracha": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Srisakdi": {
				"category": "display",
				"variants": "400,700",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Staatliches": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Stalemate": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Stalinist One": {
				"category": "display",
				"variants": "400",
				"subsets": "cyrillic,latin,latin-ext"
			},
			"Stardos Stencil": {
				"category": "display",
				"variants": "400,700",
				"subsets": "latin"
			},
			"Stint Ultra Condensed": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Stint Ultra Expanded": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Stoke": {
				"category": "serif",
				"variants": "300,400",
				"subsets": "latin,latin-ext"
			},
			"Strait": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Stylish": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "korean,latin"
			},
			"Sue Ellen Francisco": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Suez One": {
				"category": "serif",
				"variants": "400",
				"subsets": "hebrew,latin,latin-ext"
			},
			"Sulphur Point": {
				"category": "sans-serif",
				"variants": "300,400,700",
				"subsets": "latin,latin-ext"
			},
			"Sumana": {
				"category": "serif",
				"variants": "400,700",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Sunflower": {
				"category": "sans-serif",
				"variants": "300,500,700",
				"subsets": "korean,latin"
			},
			"Sunshiney": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Supermercado One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Sura": {
				"category": "serif",
				"variants": "400,700",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Suranna": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,telugu"
			},
			"Suravaram": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,telugu"
			},
			"Suwannaphum": {
				"category": "display",
				"variants": "400",
				"subsets": "khmer"
			},
			"Swanky and Moo Moo": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Syncopate": {
				"category": "sans-serif",
				"variants": "400,700",
				"subsets": "latin"
			},
			"Tajawal": {
				"category": "sans-serif",
				"variants": "200,300,400,500,700,800,900",
				"subsets": "arabic,latin"
			},
			"Tangerine": {
				"category": "handwriting",
				"variants": "400,700",
				"subsets": "latin"
			},
			"Taprom": {
				"category": "display",
				"variants": "400",
				"subsets": "khmer"
			},
			"Tauri": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Taviraj": {
				"category": "serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Teko": {
				"category": "sans-serif",
				"variants": "300,400,500,600,700",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Telex": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Tenali Ramakrishna": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,telugu"
			},
			"Tenor Sans": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "cyrillic,latin,latin-ext"
			},
			"Text Me One": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Thasadith": {
				"category": "sans-serif",
				"variants": "400,400i,700,700i",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"The Girl Next Door": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Tienne": {
				"category": "serif",
				"variants": "400,700,900",
				"subsets": "latin"
			},
			"Tillana": {
				"category": "handwriting",
				"variants": "400,500,600,700,800",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Timmana": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,telugu"
			},
			"Tinos": {
				"category": "serif",
				"variants": "400,400i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,hebrew,latin,latin-ext,vietnamese"
			},
			"Titan One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Titillium Web": {
				"category": "sans-serif",
				"variants": "200,200i,300,300i,400,400i,600,600i,700,700i,900",
				"subsets": "latin,latin-ext"
			},
			"Tomorrow": {
				"category": "sans-serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
				"subsets": "latin,latin-ext"
			},
			"Trade Winds": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Trirong": {
				"category": "serif",
				"variants": "100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
				"subsets": "latin,latin-ext,thai,vietnamese"
			},
			"Trocchi": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Trochut": {
				"category": "display",
				"variants": "400,400i,700",
				"subsets": "latin"
			},
			"Trykker": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Tulpen One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Turret Road": {
				"category": "display",
				"variants": "200,300,400,500,700,800",
				"subsets": "latin,latin-ext"
			},
			"Ubuntu": {
				"category": "sans-serif",
				"variants": "300,300i,400,400i,500,500i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext"
			},
			"Ubuntu Condensed": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext"
			},
			"Ubuntu Mono": {
				"category": "monospace",
				"variants": "400,400i,700,700i",
				"subsets": "cyrillic,cyrillic-ext,greek,greek-ext,latin,latin-ext"
			},
			"Ultra": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Uncial Antiqua": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Underdog": {
				"category": "display",
				"variants": "400",
				"subsets": "cyrillic,latin,latin-ext"
			},
			"Unica One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"UnifrakturCook": {
				"category": "display",
				"variants": "700",
				"subsets": "latin"
			},
			"UnifrakturMaguntia": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Unkempt": {
				"category": "display",
				"variants": "400,700",
				"subsets": "latin"
			},
			"Unlock": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Unna": {
				"category": "serif",
				"variants": "400,400i,700,700i",
				"subsets": "latin,latin-ext"
			},
			"VT323": {
				"category": "monospace",
				"variants": "400",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Vampiro One": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Varela": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Varela Round": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "hebrew,latin,latin-ext,vietnamese"
			},
			"Vast Shadow": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Vesper Libre": {
				"category": "serif",
				"variants": "400,500,700,900",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Viaoda Libre": {
				"category": "display",
				"variants": "400",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Vibes": {
				"category": "display",
				"variants": "400",
				"subsets": "arabic,latin"
			},
			"Vibur": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Vidaloka": {
				"category": "serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Viga": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Voces": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Volkhov": {
				"category": "serif",
				"variants": "400,400i,700,700i",
				"subsets": "latin"
			},
			"Vollkorn": {
				"category": "serif",
				"variants": "400,500,600,700,800,900,400i,500i,600i,700i,800i,900i",
				"subsets": "cyrillic,cyrillic-ext,greek,latin,latin-ext,vietnamese"
			},
			"Vollkorn SC": {
				"category": "serif",
				"variants": "400,600,700,900",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Voltaire": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Waiting for the Sunrise": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Wallpoet": {
				"category": "display",
				"variants": "400",
				"subsets": "latin"
			},
			"Walter Turncoat": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Warnes": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Wellfleet": {
				"category": "display",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Wendy One": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin,latin-ext"
			},
			"Wire One": {
				"category": "sans-serif",
				"variants": "400",
				"subsets": "latin"
			},
			"Work Sans": {
				"category": "sans-serif",
				"variants": "100,200,300,400,500,600,700,800,900,100i,200i,300i,400i,500i,600i,700i,800i,900i",
				"subsets": "latin,latin-ext,vietnamese"
			},
			"Yanone Kaffeesatz": {
				"category": "sans-serif",
				"variants": "200,300,400,500,600,700",
				"subsets": "cyrillic,latin,latin-ext,vietnamese"
			},
			"Yantramanav": {
				"category": "sans-serif",
				"variants": "100,300,400,500,700,900",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Yatra One": {
				"category": "display",
				"variants": "400",
				"subsets": "devanagari,latin,latin-ext"
			},
			"Yellowtail": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Yeon Sung": {
				"category": "display",
				"variants": "400",
				"subsets": "korean,latin"
			},
			"Yeseva One": {
				"category": "display",
				"variants": "400",
				"subsets": "cyrillic,cyrillic-ext,latin,latin-ext,vietnamese"
			},
			"Yesteryear": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Yrsa": {
				"category": "serif",
				"variants": "300,400,500,600,700",
				"subsets": "latin,latin-ext"
			},
			"ZCOOL KuaiLe": {
				"category": "display",
				"variants": "400",
				"subsets": "chinese-simplified,latin"
			},
			"ZCOOL QingKe HuangYou": {
				"category": "display",
				"variants": "400",
				"subsets": "chinese-simplified,latin"
			},
			"ZCOOL XiaoWei": {
				"category": "serif",
				"variants": "400",
				"subsets": "chinese-simplified,latin"
			},
			"Zeyada": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "latin"
			},
			"Zhi Mang Xing": {
				"category": "handwriting",
				"variants": "400",
				"subsets": "chinese-simplified,latin"
			},
			"Zilla Slab": {
				"category": "serif",
				"variants": "300,300i,400,400i,500,500i,600,600i,700,700i",
				"subsets": "latin,latin-ext"
			},
			"Zilla Slab Highlight": {
				"category": "display",
				"variants": "400,700",
				"subsets": "latin,latin-ext"
			}
		};

		var dictionaries = {
			'en': {
				'selectFont': 'Select a font',
				'search': 'Search',
				'allLangs': 'All languages',
				'favFonts': 'Favorite fonts',
				'localFonts': 'Local fonts',
				'googleFonts': 'Google fonts',
				'select': 'Select',
				'styles': 'styles',
				'sampleText': 'The quick brown fox jumps over the lazy dog.',
				'sampleTextEditable': 'Sample text, editable'
			},
			'nl': {
				'selectFont': 'Kies een lettertype',
				'search': 'Zoek',
				'allLangs': 'Alle talen',
				'favFonts': 'Favoriete lettertypen',
				'localFonts': 'Lokale lettertypen',
				'googleFonts': 'Google lettertypen',
				'select': 'Kies',
				'styles': 'stijlen',
				'sampleText': 'Wazig tv-filmpje rond chique skybox.',
				'sampleTextEditable': 'Voorbeeldtekst, bewerkbaar'
			},
			'de': {
				'selectFont': 'Schriftart wählen',
				'search': 'Suchen',
				'allLangs': 'Alle Sprachen',
				'favFonts': 'Favorisierte Schriftarten',
				'localFonts': 'Lokale Schriftarten',
				'googleFonts': 'Google Schriftarten',
				'select': 'Wählen',
				'styles': 'stile',
				'sampleText': 'Vogel Quax zwickt Johnys Pferd Bim.',
				'sampleTextEditable': 'Beispieltext, editierbar'
			},
			'es': {
				'selectFont': 'Seleccionar fuente',
				'search': 'Buscar',
				'allLangs': 'Todos los idiomas',
				'favFonts': 'Fuentes favoritas',
				'localFonts': 'Fuentes locales',
				'googleFonts': 'Fuentes de Google',
				'select': 'Seleccionar',
				'styles': 'estilos',
				'sampleText': 'La cigüeña tocaba cada vez mejor el saxofón y el búho pedía kiwi y queso',
				'sampleTextEditable': 'Texto de ejemplo, editable'
			}
		};

		var settings = {
			lang: 'en', // Interface language
			variants: true, // Whether or not to show font variants
			nrRecents: 3, // How many recently picked fonts to remember (shown in 'Favorite fonts' section)
			lazyLoad: true, // Whether or not to lazy load fonts
			debug: false, // Debugging shows some useful info in console
			localFontsUrl: '/fonts/', // Where .woff files (for local fonts) reside
			parentElement: 'body', // What element to attach the Fontpicker to

			localFonts: {// Default: web safe fonts available on all platforms
				"Arial": {
					"category": "sans-serif",
					"variants": "400,400i,600,600i"
				},
				"Courier New": {
					"category": "monospace",
					"variants": "400,400i,600,600i"
				},
				"Georgia": {
					"category": "serif",
					"variants": "400,400i,600,600i"
				},
				"Tahoma": {
					"category": "sans-serif",
					"variants": "400,400i,600,600i"
				},
				"Times New Roman": {
					"category": "serif",
					"variants": "400,400i,600,600i"
				},
				"Trebuchet MS": {
					"category": "sans-serif",
					"variants": "400,400i,600,600i"
				},
				"Verdana": {
					"category": "sans-serif",
					"variants": "400,400i,600,600i",
				}
			}
		}; // End settings

		var Fontpicker = (function() {

			function Fontpicker(original, options) {
				if (options.googleFonts && Array.isArray(options.googleFonts)) {
					// User supplied an array of Google fonts.
					var googleFonts = {}, fontFamily;
					for (var f = 0; f < options.googleFonts.length; f++) {
						fontFamily = options.googleFonts[f];
						googleFonts[fontFamily] = __googleFonts[fontFamily];
					}
					options.googleFonts = googleFonts;
				}
				else if (false !== options.googleFonts) {
					// If user did not supply a subset of Google Fonts, list them all
					options.googleFonts = __googleFonts;
				}

				if (!options.localFonts) {
					options.localFonts = [];
				}

				if (!dictionaries[options.lang]) {
					options.lang = 'en';
				}

				this.dictionary = dictionaries[options.lang];

				this.allFonts = {'google':options.googleFonts, 'local':options.localFonts};
				this.options = options;
				this.$original = $(original);
				this.setupHtml();
				this.bindEvents();
			}

			Fontpicker.prototype = {

				/**
				 * Load font, either from Google or from local url.
				 *
				 * @param {string} type Font type, either 'google' or 'local'.
				 * @param {string} font Font family name. F.e: 'Chakra', 'Zilla Slab'.
				 */
				loadFont: function(type, font) {
					if (fontsLoaded[font]) { return; }
					fontsLoaded[font] = true;

					switch(type) {
						case 'google':
							var url = 'https://fonts.googleapis.com/css?family=' + font.replace(/ /g,'+') + ':' + this.options.googleFonts[font].variants + '&display=swap';
							this.options.debug && console.log('Loading Google font ' + font + ' from ' + url);
							$('head').append($('<link>', {href:url, rel:'stylesheet', type:'text/css'}));
							break;

						case 'local':
							this.options.debug && console.log('Loading local font ' + font);
							$('head').append("<style> @font-face { font-family:'" + font + "'; src:local('" + font + "'), url('" + this.options.localFontsUrl + font + ".woff') format('woff'); } </style>");
							break;
					}
				},

				/**
				 * Show an (editable) font sample.
				 *
				 * @param {object} $li jQuery list object to extract font spec from (stored in data attributes).
				 */
				showSample: function($li) {
					$('.fp-sample', this.$element).css({
						fontFamily: "'" + $li.data('font-family') + "'",
						fontStyle: $li.data('font-italic') ? 'italic' : 'normal',
						fontWeight: $li.data('font-weight') || 400
					});
				},

				/**
				 * Handle key presses.
				 *
				 * @param {object} e Event.
				 * @param {object} el Element that received the event.
				 */
				keyDown: function(e, el) {
					function stop(e) {
						e.preventDefault();
						e.stopPropagation();
					}

					var $activeLi = $('li.fp-active:visible', this.$results);

					if ((e.keyCode >= 49 && e.keyCode <= 57) || (e.keyCode >= 97 && e.keyCode <= 105)) {
						// Numbers 1-9
						stop(e);
						var fw = 100 * (e.keyCode - (e.keyCode >= 97 ? 96 : 48));
						$('.fp-pill[data-font-weight='+fw+']', $activeLi).trigger('click');
						return;
					}

					switch(e.keyCode) {
						case 73: // i, italic
							stop(e);
							$('.fp-pill.italic:visible', $activeLi).trigger('click');
							break;

						case 38: // Cursor up
							stop(e);
							$prevLi = $activeLi.prevAll(':not(.fp-divider):visible:first');
							if ($prevLi.length == 0) {
								$prevLi = $('li:not(.fp-divider):visible:last', this.$results);
							}
							$prevLi.trigger('mouseenter').trigger('click');

							__scrollIntoViewIfNeeded($prevLi[0]);
							break;

						case 40: // Cursor down
							stop(e);
							$nextLi = $activeLi.nextAll(':not(.fp-divider):visible:first');
							if ($nextLi.length == 0) {
								$nextLi = $('li:not(.fp-divider):visible:first', this.$results);
							}
							$nextLi.trigger('mouseenter').trigger('click');

							__scrollIntoViewIfNeeded($nextLi[0]);
							break;

						case 13: // Enter
							stop(e);
							$('li.fp-active', this.$results).find('button.apply').trigger('click');
							break;

						case 27: // Esc
							stop(e);
							$('.fp-close', this.$modal).trigger('click');
							break;
					}
				},

				/**
				 * Handle mouse enter events on items in the font list.
				 *
				 * @param {object} e Event.
				 * @param {object} el Element that received the event.
				 */
				mouseEnter: function(e, el) {
					var $li = $(el);
					$('li.fp-hover', this.$results).removeClass('fp-hover');
					$li.addClass('fp-hover');

					this.loadFont($li.data('font-type'), $li.data('font-family'));
					this.showSample($li);
				},

				/**
				 * Handle clicks on items in the font list.
				 * @param {object} e Event.
				 * @param {object} el Element that received the event.
				 */
				click: function(e, el) {
					var $li = $(el), self = this,
						fontType = $li.data('font-type'),
						fontFamily = $li.data('font-family'),
						italic = $li.data('font-italic') || false,
						weight = $li.data('font-weight') || 400,
						$lis = $("li[data-font-family='" + fontFamily + "']", this.$results),
						favorites = __cookie('favs'),
						favoriteFonts = favorites ? favorites.split(',') : [];

					$('li.fp-active', this.$results).removeClass('fp-active').find('.fp-variants,.fp-btns').remove();

					$li.addClass('fp-active');

					var $btns = $('<div class="fp-btns">'),
						isFav = favoriteFonts.indexOf(fontType + ':' + fontFamily) != -1;

					$btns.append(
						$('<span class="fp-favorite' + (isFav ? ' checked' : '') + '"></span>')
						.on('click', function(e) {
							e.stopPropagation();

							var idx = favoriteFonts.indexOf(fontType + ':' + fontFamily);
							if ($(this).is('.checked')) {
								// Remove from favorites
								if (idx != -1) {
									favoriteFonts.splice(idx, 1);
								}
							}
							else {
								// Add to favorites
								if (-1 == idx) {
									favoriteFonts.push(fontType + ':' + fontFamily);
								}
							}
							$(this).toggleClass('checked');
							__cookie('favs', favoriteFonts.join(','));
						}),

						$('<button type="button" class="fp-btn apply">')
						.html(this.dictionary['select'])
						.on('click', function(e) {
							e.stopPropagation();

							italic = $li.data('font-italic');
							weight = $li.data('font-weight') || 400;

							var value = fontFamily;
							if (self.options.variants) {
								value += ':' + weight + (italic ? 'i':'');
							}

							self.$select.css({
								fontFamily: "'" + fontFamily  + "'",
								fontStyle: italic ? 'italic' : 'normal',
								fontWeight: weight
							}).find('.fp-fontspec').html(value);

							self.$original.val(value).change(); // Update original <input> element

							// Call onSelect callback, if specified
							if (!!self.options.onSelect) {
								self.options.onSelect({
									fontType: fontType,
									fontFamily: fontFamily,
									fontStyle: italic ? 'italic' : 'normal',
									fontWeight: weight,
									fontSpec: value
								});
							}

							self.toggleModal('hide');

							// Save recent
							if (!!self.options.nrRecents) {
								var recentFonts = __cookie('recents'),
									cookieVal = $li.data('font-type') + ':' + fontFamily;

								recentFonts = recentFonts ? recentFonts.split(',') : [];
								if (recentFonts.indexOf(cookieVal) == -1) {
									recentFonts.unshift(cookieVal);
								}

								recentFonts = recentFonts.slice(0,self.options.nrRecents); // Remember last X
								__cookie('recents', recentFonts.join(','));
							}
						})
					)
					$btns.appendTo($li);

					var font = this.allFonts[fontType][fontFamily],
						variants = font.variants ? font.variants.split(',') : [];

					if (this.options.variants && variants.length > 1) {
						var $variants = $('<div class="fp-variants">'),
							hasItalic = false;

						for (var v = 0; v < variants.length; v++) {
							if (/i$/.test(variants[v])) {
								if (!hasItalic) { hasItalic = true; }
								continue;
							}

							let variant = variants[v],
								fontWeight = +variant.replace(/i$/,'');

							v > 0 && $variants.append(' '); // Separate by space

							$('<span data-font-weight="' + fontWeight + '" class="fp-pill weight' + (weight == fontWeight ? ' checked' : '') + '">')
							.text(variant)
							.on('click', function(e) {
								e.stopPropagation();

								if (variants.indexOf(fontWeight+'i') == -1) {
									// This font weight does not have an italic variant
									$('.fp-pill.italic', $li).removeClass('checked').css('display', 'none');
									italic = false;
									$li.data('font-italic', italic);
								}
								else {
									// This font weight does have an italic variant
									$('.fp-pill.italic', $li).css('display', '');
								}

								$('span.fp-pill.weight', $li).removeClass('checked');
								$(this).addClass('checked');

								$lis.data('font-weight', fontWeight); // Set for favorite and normal

								self.showSample($li);
							})
							.appendTo($variants);
						}

						if (hasItalic) {
							$variants.append(' ');
							$('<span class="fp-pill italic ' + (italic ? ' checked' : '') + '">')
							.css('display', variants.indexOf(weight+'i') == -1 ? 'none' : '')
							.html('italic')
							.on('click', function(e) {
								e.stopPropagation();
								italic = !italic;
								$(this).toggleClass('checked');

								$lis.data('font-italic', italic); // Set for favorite and normal

								self.showSample($li);
							}).appendTo($variants);
						}

						$li.append($variants);
					}
				},

				/**
				 * Turn a font spec (Arial:700i, Canga:400) into its components: family, weight and italic.
				 *
				 * @param {string} fontSpec The font specification to split into components.
				 * @return {object} An object containing 3 items: family (string), weight (int) and italic (bool).
				 */
				fontSpecToComponents: function(fontSpec) {
					var tmp = fontSpec.split(':'),
						family = tmp[0],
						variant = tmp[1] || '400',
						italic = false, weight = 400;

					if (/(\d+)i$/.test(variant)) {
						italic = true;
						weight = +RegExp.$1;
					}
					else {
						weight = +variant;
					}

					return {
						family: family,
						weight: weight,
						italic: italic
					}
				},

				/**
				 * Style the original input element with a font.
				 *
				 * @param {string} fontSpec The font specification, f.e: 'Changa:400i' or 'Arial'.
				 */
				applyFontToOriginalInput: function(fontSpec) {
					var font = this.fontSpecToComponents(fontSpec);
					this.loadFont(__googleFonts[font.family] ? 'google' : 'local', font.family);

					this.$select.css({
						fontFamily: "'" + font.family + "'",
						fontStyle: font.italic ? 'italic' : 'normal',
						fontWeight: font.weight
					})
					.find('.fp-fontspec').html(fontSpec);
				},

				/**
				 * Bind all events.
				 */
				bindEvents: function() {
					var self = this;

					this.$results
					.on('keydown', function(e) {
						self.keyDown(e, this);
					})
					.on('mouseenter', 'li:not(.fp-divider):visible', function(e) {
						self.mouseEnter(e, this);
					})
					.on('click', 'li:not(.fp-divider):visible', function(e) {
						self.click(e, this);
					})
					.on('dblclick', 'li:not(.fp-divider):visible', function(e) {
						$('li.fp-active', this.$results).find('button.apply').trigger('click');
					});

					this.$original.on('change', function(e) {
						self.applyFontToOriginalInput(this.value);
					});
				},

				/**
				 * Automatically load fonts as they come in to view.
				 */
				lazyLoad: function() {
					if (!window.IntersectionObserver) { return; }

					var self = this, $li;

					var observer = new IntersectionObserver(function(lis) {
						[].forEach.call(lis, function(li) {
							if (li.intersectionRatio > 0) {
								observer.unobserve(li.target); // Load only once per li
								$li = $(li.target);
								self.loadFont($li.data('font-type'), $li.data('font-family'));
								$li.css('fontFamily', "'" + $li.data('font-family') + "'");
							}
						});
					});

					$('li:not(.fp-divider)', this.$results).each(function() {
						observer.observe(this);
					});
				},

				/**
				 * Show or hide the fontpicker modal window.
				 *
				 * @param {string} state Either 'hide' or 'show'. When omitted visibility of the modal is toggled.
				 */
				toggleModal: function(state) {
					if (!state) {
						state = this.$modal.is(':visible') ? 'hide' : 'show';
					}

					if ('hide' == state) {
						// Hide modal
						$('.fp-fav,.fp-variants,.fp-btns').remove();

						this.$modal.css('display','none');
						$('.fp-modal-backdrop', this.$element).remove();
						$(this.options.parentElement).removeClass('fp-modal-open');
						$('span', this.$select).focus();
					}
					else {
						// Show modal
						$(this.options.parentElement).addClass('fp-modal-open');

						this.$element.append(
							$('<div class="fp-modal-backdrop">')
							.on('click', function() {
								// Click outside modal window closes the modal
								$('.fp-close', this.$modal).trigger('click');
							})
						);

						this.$modal.css('display','flex');

						this.getFavorites(); // List favorites & recents

						var fontSpec = this.$original.val();
						if (fontSpec) {
							var font = this.fontSpecToComponents(fontSpec),
								$li = $("li[data-font-family='" + font.family + "']", this.$results); // Either 0, 1 or 2 elements

							if ($li.length > 0) {
								$li.data({
									'font-italic': font.italic,
									'font-weight': font.weight
								}).eq(0).trigger('click');

								__scrollIntoViewIfNeeded($li[0]);
							}
						}
						else {
							this.$results.scrollTop(0);
						}

						this.options.lazyLoad && this.lazyLoad();
						this.$results.focus(); // Make keyboard work
					}
				},

				/**
				 * Apply user filters to font list: language, categories and search term.
				 */
				applyFilter: function() {
					var lang = this.$lang.val(),
						searchTerm = this.$search.val().trim(),
						cats = [];

					$('.fp-category', this.$filter).each(function() {
						if ($(this).hasClass('checked')) {
							cats.push($(this).data('category'));
						}
					});

					if (cats.length <= 0) {
						cats = ['serif', 'sans-serif', 'display', 'handwriting', 'monospace', 'other'];
					}

					// Remember lang and cats
					__cookie('lang', '' === lang ? false : lang);
					// __cookie('cats', cats.join(','));

					for (var c in this.allFonts) {
						for (var f in this.allFonts[c]) {
							var item = this.allFonts[c][f],
								langs = item.subsets ? item.subsets.split(',') : [],
								$li = $("li[data-font-family='" + f + "']", this.$results),
								cat = item.category || 'other';

							if ( ('' == lang || langs.indexOf(lang) != -1) &&
								 (cats.indexOf(cat) != -1) &&
								 ('' == searchTerm || f.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1) ) {
								$li.show();
							}
							else {
								$li.hide();
							}
						}
					}
				},

				/**
				 * Construct filter UI.
				 */
				getFilterUI: function() {
					var self = this,
						$searchWrap = $('<div class="fp-search-wrap">');

					this.$filter = $('<div class="fp-filter">');

					// Search input
					this.$search = $('<input>', {'class':'fp-search', type:'text', placeholder:this.dictionary['search'], spellcheck:false})
					.on('keyup', function() {
						self.applyFilter();
					})
					.appendTo($searchWrap);

					// Clear button
					$('<div class="fp-clear">')
					.on('click', function() {
						self.$search.val('').focus();
						self.applyFilter();
					})
					.appendTo($searchWrap);

					// Language pulldown
					var opts = ['<option value="">' + this.dictionary['allLangs'] + '</option>'];
					for (var l in googleFontLangs) {
						opts.push('<option value="' + l + '">' + googleFontLangs[l] + '</option>');
					}
					this.$lang = $('<select class="fp-lang">').on('change', function() {
						self.applyFilter();
					}).html(opts.join(''));

					this.$filter.append(
						$('<div class="fp-row">').append(
							$searchWrap,
							this.$lang
						)
					);

					$('<div class="hr">').appendTo(this.$filter);

					var gFontCats = googleFontCats.slice(0); // Clone
					gFontCats.push('other');
					for (var g = 0; g < gFontCats.length; g++) {
						// $('<span class="fp-category fp-pill checked">')
						$('<span class="fp-category fp-pill">')
						.data('category', gFontCats[g])
						.text(gFontCats[g])
						.on('click', function() {
							$(this).toggleClass('checked');
							self.applyFilter();
						})
						.appendTo(this.$filter);
					}
				},

				/**
				 * Construct font list.
				 */
				getFontsList: function() {
					var self = this,
						frag = document.createDocumentFragment(), // Use a document fragment to increase performance.
						$li,
						fontFamily;

					function append(fontType, fontFamily) {
						var font = self.allFonts[fontType][fontFamily], small = '';

						if (font.category || font.variants) {
							var items = [];
							if (font.category) { items.push(font.category); }
							if (self.options.variants && font.variants) {
								var nr = font.variants.split(',').length;
								if (nr > 1) {
									items.push(nr + ' ' + self.dictionary['styles']);
								}
							}
							small = ' <small>' + items.join(', ') + '</small>';
						}

						$li = $('<li>', {'data-font-type':fontType, 'data-font-family':fontFamily})
						.html(fontFamily + small);

						frag.append($li[0]);
					}

					// Local fonts
					if (Object.keys(this.options.localFonts).length > 0) {
						$li = $('<li class="fp-divider">' + this.dictionary['localFonts'] + '</li>');
						frag.append($li[0]);
						for (fontFamily in this.options.localFonts) {
							append('local', fontFamily);
						}
					}

					// Google fonts
					if (Object.keys(this.options.googleFonts).length > 0) {
						$li = $('<li class="fp-divider">' + this.dictionary['googleFonts'] + '</li>');
						frag.append($li[0]);
						for (fontFamily in this.options.googleFonts) {
							append('google', fontFamily);
						}
					}

					this.$results = $('<ul>', {'class':'fp-results', tabindex:0}).append(frag);
				},

				/**
				 * Construct list of favorited and recently picked fonts
				 */
				getFavorites: function() {
					var favoriteFonts = __cookie('favs'),
						recentFonts = __cookie('recents');

					favoriteFonts = favoriteFonts ? favoriteFonts.split(',') : [];
					recentFonts = (!!this.options.nrRecents && recentFonts) ? recentFonts.split(',') : [];

					// Dedupe:
					var fonts = recentFonts.slice(0);
					for (var f = 0; f < favoriteFonts.length; f++) {
						if (fonts.indexOf(favoriteFonts[f]) == -1) {
							fonts.push(favoriteFonts[f]);
						}
					}

					var frag = document.createDocumentFragment(), $li = null, $orgLi, tmp;

					for (var f = 0; f < fonts.length; f++) {
						tmp = fonts[f].split(':'), fontType = tmp[0], fontFamily = tmp[1], font = this.allFonts[fontType][fontFamily];
						if (!font) { continue; }

						$orgLi = $("[data-font-family='" + fontFamily + "']", this.$results);
						if ($orgLi.length > 0) {
							$li = $orgLi.clone().addClass('fp-fav');
							frag.append($li[0]);
						}
					}

					if (null !== $li) {
						frag.prepend($('<li class="fp-fav fp-divider">' + this.dictionary['favFonts'] + '</li>')[0]);
						this.$results.prepend(frag);
					}
				},

				/**
				 * Setup HTML structure for the font picker.
				 */
				setupHtml: function() {
					var self = this,
						fontSpec = this.$original.val();

					this.$original.hide();

					this.$select =
						$('<div class="font-picker fp-select">')
						.on('click', function() {
							self.toggleModal('show');
						})
						.on('keydown', function(e) {
							// Open the modal with spacebar
							if (e.keyCode == 32) {
								e.stopPropagation();
								e.preventDefault();
								self.toggleModal('show');
							}
						})
						.append('<span class="fp-fontspec" tabindex="0">' + (fontSpec ? fontSpec : this.dictionary['selectFont']) + '</span>')


					if (!!self.options.showClear) {
						// Add a clear button
						this.$select
						.append($('<span class="fp-clear"></span>')
						.on('click', function(e) {
							e.stopPropagation();

							self.$select
							.removeAttr('style')
							.find('.fp-fontspec')
							.html(self.dictionary['selectFont']);;

							self.$original.val(''); // Update original <input> element
						}));
					}

					this.$original.after(this.$select);

					this.$element = $('<div>', {'class': 'font-picker'});

					this.$modal = $('<div class="fp-modal">').appendTo(this.$element);

					this.$modal.append(
						$('<div class="fp-header">').append(
							$('<div class="fp-icons">').append(
								$('<span class="fp-close">&times</span>').on('click', function() {
									self.toggleModal('hide');
								})
							),
							$('<h5>').text(this.dictionary['selectFont'])
						)
					);

					this.getFilterUI();
					this.$modal.append(this.$filter);

					this.$sample = $('<div>', {'class':'fp-sample', contenteditable:true, spellcheck:false, title:this.dictionary['sampleTextEditable']})
						.html(this.dictionary['sampleText'])
						.appendTo(this.$modal);

					this.getFontsList();
					this.$modal.append(this.$results);

					var lang = __cookie('lang'), cats = __cookie('cats');

					if (lang) {
						this.$lang.val(lang);
					}

					if (cats) {
						cats = cats.split(',');
						$('.fp-category', this.$filter).each(function() {
							if (-1 == cats.indexOf($(this).data('category'))) {
								$(this).removeClass('checked');
							}
							else {
								$(this).addClass('checked');
							}
						});
					}

					if (lang || cats) {
						self.applyFilter();
					}

					fontSpec && self.applyFontToOriginalInput(fontSpec);

					$(this.options.parentElement).append(this.$element);
				},

				//
				// Public Methods, via $element.fontpicker(method)
				//

				/**
				 * Show the fontpicker.
				 */
				show: function() {
					var el = $(this).data('plugin_' + pluginName);
					if (!el.$select) {
						throw new Error('jquery.'+pluginName+': Cannot show, as I\'ve been destroyed.');
					}
					el.toggleModal('show');
				},

				/**
				 * Hide the fontpicker.
				 */
				hide: function() {
					var el = $(this).data('plugin_' + pluginName);
					if (!el.$select) {
						throw new Error('jquery.'+pluginName+': Cannot hide, as I\'ve been destroyed.');
					}
					el.toggleModal('hide');
				},

				/**
				 * Destroy the fontpicker plugin, revert element back to original.
				 */
				destroy: function() {
					var el = $(this).data('plugin_' + pluginName);
					if (!el.$select) {
						throw new Error('jquery.'+pluginName+': Cannot destroy, as I\'ve been destroyed already.');
					}
					el.toggleModal('hide');
					el.$select.remove();
					el.$element.remove();
					el.$original.off('setFont');
					el.$original.show();
					el.$select = el.$element = el.$original = el.$modal = null;
					$(el).removeData('plugin_' + pluginName);
				}
			}; // End prototype

			return Fontpicker;
		})();

		if (typeof arguments[0] === 'string') {
			var methodName = arguments[0],
				args = Array.prototype.slice.call(arguments, 1),
				returnVal;

			this.each(function() {
				if ($.data(this, 'plugin_' + pluginName) && typeof $.data(this, 'plugin_' + pluginName)[methodName] === 'function') {
					returnVal = $.data(this, 'plugin_' + pluginName)[methodName].apply(this, args);
				}
				else {
					throw new Error('jquery.'+pluginName+': Method ' +  methodName + ' does not exist.');
				}
			});

			return returnVal !== undefined ? returnVal : this; // Preserve chainablility
		}

		return this.each(function() {
			if (!$.data(this, 'plugin_'+pluginName)) {
				// If options exist, merge them
				options && $.extend(settings, options);
				$.data(this, 'plugin_'+pluginName, new Fontpicker(this, settings));
			}
		});
	};
})(jQuery);

/*!
 * froala_editor v4.0.1 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2021 Froala Labs
 */

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : e.FroalaEditor = t()
}(this, function () {
  "use strict";

  function kt(e) {
    return (kt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
    })(e)
  }

  Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector), Element.prototype.closest || (Element.prototype.closest = function (e) {
    var t = this;
    if (!document.documentElement.contains(t)) return null;
    do {
      if (t.matches(e)) return t;
      t = t.parentElement || t.parentNode
    } while (null !== t && 1 === t.nodeType);
    return null
  }), Element.prototype.matches || (Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (e) {
    for (var t = (this.document || this.ownerDocument).querySelectorAll(e), n = t.length; 0 <= --n && t.item(n) !== this;) ;
    return -1 < n
  }), Array.isArray || (Array.isArray = function (e) {
    return "[object Array]" === Object.prototype.toString.call(e)
  }), "function" != typeof Object.assign && Object.defineProperty(Object, "assign", {
    value: function (e, t) {
      if (null == e) throw new TypeError("Cannot convert undefined or null to object");
      for (var n = Object(e), r = 1; r < arguments.length; r++) {
        var a = arguments[r];
        if (null != a) for (var o in a) Object.prototype.hasOwnProperty.call(a, o) && (n[o] = a[o])
      }
      return n
    }, writable: !0, configurable: !0
  }), function () {
    var i = /^\s*:scope/gi, s = /,\s*:scope/gi, l = document.createElement("div");

    function e(e, t) {
      var o = e[t];
      e[t] = function (e) {
        var t, n = !1, r = !1;
        if (!e || Array.isArray(e) || !e.match(i) && !e.match(s)) return o.call(this, e);
        this.parentNode || (l.appendChild(this), r = !0);
        var a = this.parentNode;
        return this.id || (this.id = "rootedQuerySelector_id_".concat((new Date).getTime()), n = !0), t = o.call(a, e.replace(i, "#".concat(this.id)).replace(s, ",#".concat(this.id))), n && (this.id = ""), r && l.removeChild(this), t
      }
    }

    try {
      var t = l.querySelectorAll(":scope *");
      if (!t || Array.isArray(t)) throw"error"
    } catch (n) {
      e(Element.prototype, "querySelector"), e(Element.prototype, "querySelectorAll"), e(HTMLElement.prototype, "querySelector"), e(HTMLElement.prototype, "querySelectorAll")
    }
  }(), "document" in self && ("classList" in document.createElement("_") && (!document.createElementNS || "classList" in document.createElementNS("http://www.w3.org/2000/svg", "g")) || function (e) {
    if ("Element" in e) {
      var t = "classList", n = "prototype", r = e.Element[n], a = Object, o = String[n].trim || function () {
        return this.replace(/^\s+|\s+$/g, "")
      }, i = Array[n].indexOf || function (e) {
        for (var t = 0, n = this.length; t < n; t++) if (t in this && this[t] === e) return t;
        return -1
      }, s = function s(e, t) {
        this.name = e, this.code = DOMException[e], this.message = t
      }, l = function l(e, t) {
        if ("" === t) throw new s("SYNTAX_ERR", "The token must not be empty.");
        if (/\s/.test(t)) throw new s("INVALID_CHARACTER_ERR", "The token must not contain space characters.");
        return i.call(e, t)
      }, c = function c(e) {
        for (var t = o.call(e.getAttribute("class") || ""), n = t ? t.split(/\s+/) : [], r = 0, a = n.length; r < a; r++) this.push(n[r]);
        this._updateClassName = function () {
          e.setAttribute("class", this.toString())
        }
      }, d = c[n] = [], f = function f() {
        return new c(this)
      };
      if (s[n] = Error[n], d.item = function (e) {
        return this[e] || null
      }, d.contains = function (e) {
        return ~l(this, e + "")
      }, d.add = function () {
        for (var e, t = arguments, n = 0, r = t.length, a = !1; e = t[n] + "", ~l(this, e) || (this.push(e), a = !0), ++n < r;) ;
        a && this._updateClassName()
      }, d.remove = function () {
        var e, t, n = arguments, r = 0, a = n.length, o = !1;
        do {
          for (e = n[r] + "", t = l(this, e); ~t;) this.splice(t, 1), o = !0, t = l(this, e)
        } while (++r < a);
        o && this._updateClassName()
      }, d.toggle = function (e, t) {
        var n = this.contains(e), r = n ? !0 !== t && "remove" : !1 !== t && "add";
        return r && this[r](e), !0 === t || !1 === t ? t : !n
      }, d.replace = function (e, t) {
        var n = l(e + "");
        ~n && (this.splice(n, 1, t), this._updateClassName())
      }, d.toString = function () {
        return this.join(" ")
      }, a.defineProperty) {
        var p = {get: f, enumerable: !0, configurable: !0};
        try {
          a.defineProperty(r, t, p)
        } catch (u) {
          void 0 !== u.number && -2146823252 !== u.number || (p.enumerable = !1, a.defineProperty(r, t, p))
        }
      } else a[n].__defineGetter__ && r.__defineGetter__(t, f)
    }
  }(self), function () {
    var e = document.createElement("_");
    if (e.classList.add("c1", "c2"), !e.classList.contains("c2")) {
      var t = function Yc(e) {
        var Yc = DOMTokenList.prototype[e];
        DOMTokenList.prototype[e] = function (e) {
          var t, n = arguments.length;
          for (t = 0; t < n; t++) e = arguments[t], Yc.call(this, e)
        }
      };
      t("add"), t("remove")
    }
    if (e.classList.toggle("c3", !1), e.classList.contains("c3")) {
      var n = DOMTokenList.prototype.toggle;
      DOMTokenList.prototype.toggle = function (e, t) {
        return 1 in arguments && !this.contains(e) == !t ? t : n.call(this, e)
      }
    }
    "replace" in document.createElement("_").classList || (DOMTokenList.prototype.replace = function (e, t) {
      var n = this.toString().split(" "), r = n.indexOf(e + "");
      ~r && (n = n.slice(r), this.remove.apply(this, n), this.add(t), this.add.apply(this, n.slice(1)))
    }), e = null
  }());

  function xt(e, t, n) {
    if ("string" != typeof e) return new xt.Bootstrap(e, t, n);
    var r = document.querySelectorAll(e);
    t && t.iframe_document && (r = t.iframe_document.querySelectorAll(e));
    for (var a = [], o = 0; o < r.length; o++) {
      var i = r[o]["data-froala.editor"];
      i ? a.push(i) : a.push(new xt.Bootstrap(r[o], t, n))
    }
    return 1 == a.length ? a[0] : a
  }

  xt.RegisterPlugins = function (e) {
    for (var t = 0; t < e.length; t++) e[t].call(xt)
  }, Object.assign(xt, {
    DEFAULTS: {initOnClick: !1, pluginsEnabled: null},
    MODULES: {},
    PLUGINS: {},
    VERSION: "4.0.1",
    INSTANCES: [],
    OPTS_MAPPING: {},
    SHARED: {},
    ID: 0
  }), xt.MODULES.node = function (i) {
    var n = i.$;

    function s(e) {
      return e && "IFRAME" !== e.tagName ? Array.prototype.slice.call(e.childNodes || []) : []
    }

    function l(e) {
      return !!e && (e.nodeType === Node.ELEMENT_NODE && 0 <= xt.BLOCK_TAGS.indexOf(e.tagName.toLowerCase()))
    }

    function c(e) {
      var t = {}, n = e.attributes;
      if (n) for (var r = 0; r < n.length; r++) {
        var a = n[r];
        t[a.nodeName] = a.value
      }
      return t
    }

    function t(e) {
      for (var t = "", n = c(e), r = Object.keys(n).sort(), a = 0; a < r.length; a++) {
        var o = r[a], i = n[o];
        i.indexOf("'") < 0 && 0 <= i.indexOf('"') ? t += " ".concat(o, "='").concat(i, "'") : (0 <= i.indexOf('"') && 0 <= i.indexOf("'") && (i = i.replace(/"/g, "&quot;")), t += " ".concat(o, '="').concat(i, '"'))
      }
      return t
    }

    function r(e) {
      return e === i.el
    }

    return {
      isBlock: l, isEmpty: function d(e, t) {
        if (!e) return !0;
        if (e.querySelector("table")) return !1;
        var n = s(e);
        1 === n.length && l(n[0]) && (n = s(n[0]));
        for (var r = !1, a = 0; a < n.length; a++) {
          var o = n[a];
          if (!(t && i.node.hasClass(o, "fr-marker") || o.nodeType === Node.TEXT_NODE && 0 === o.textContent.length)) {
            if ("BR" !== o.tagName && 0 < (o.textContent || "").replace(/\u200B/gi, "").replace(/\n/g, "").length) return !1;
            if (r) return !1;
            "BR" === o.tagName && (r = !0)
          }
        }
        return !(e.querySelectorAll(xt.VOID_ELEMENTS.join(",")).length - e.querySelectorAll("br").length || e.querySelector("".concat(i.opts.htmlAllowedEmptyTags.join(":not(.fr-marker),"), ":not(.fr-marker)")) || 1 < e.querySelectorAll(xt.BLOCK_TAGS.join(",")).length || e.querySelector("".concat(i.opts.htmlDoNotWrapTags.join(":not(.fr-marker),"), ":not(.fr-marker)")))
      }, blockParent: function a(e) {
        for (; e && e.parentNode !== i.el && (!e.parentNode || !i.node.hasClass(e.parentNode, "fr-inner"));) if (l(e = e.parentNode)) return e;
        return null
      }, deepestParent: function o(e, t, n) {
        if (void 0 === t && (t = []), void 0 === n && (n = !0), t.push(i.el), 0 <= t.indexOf(e.parentNode) || e.parentNode && i.node.hasClass(e.parentNode, "fr-inner") || e.parentNode && 0 <= xt.SIMPLE_ENTER_TAGS.indexOf(e.parentNode.tagName) && n) return null;
        for (; t.indexOf(e.parentNode) < 0 && e.parentNode && !i.node.hasClass(e.parentNode, "fr-inner") && (xt.SIMPLE_ENTER_TAGS.indexOf(e.parentNode.tagName) < 0 || !n) && (!l(e) || l(e.parentNode)) && (!l(e) || !l(e.parentNode) || !n);) e = e.parentNode;
        return e
      }, rawAttributes: c, attributes: t, clearAttributes: function f(e) {
        for (var t = e.attributes, n = t.length - 1; 0 <= n; n--) {
          var r = t[n];
          e.removeAttribute(r.nodeName)
        }
      }, openTagString: function p(e) {
        return "<".concat(e.tagName.toLowerCase()).concat(t(e), ">")
      }, closeTagString: function u(e) {
        return "</".concat(e.tagName.toLowerCase(), ">")
      }, isFirstSibling: function h(e, t) {
        void 0 === t && (t = !0);
        for (var n = e.previousSibling; n && t && i.node.hasClass(n, "fr-marker");) n = n.previousSibling;
        return !n || n.nodeType === Node.TEXT_NODE && "" === n.textContent && h(n)
      }, isLastSibling: function g(e, t) {
        void 0 === t && (t = !0);
        for (var n = e.nextSibling; n && t && i.node.hasClass(n, "fr-marker");) n = n.nextSibling;
        return !n || n.nodeType === Node.TEXT_NODE && "" === n.textContent && g(n)
      }, isList: function m(e) {
        return !!e && 0 <= ["UL", "OL"].indexOf(e.tagName)
      }, isLink: function v(e) {
        return !!e && e.nodeType === Node.ELEMENT_NODE && "a" === e.tagName.toLowerCase()
      }, isElement: r, contents: s, isVoid: function b(e) {
        return e && e.nodeType === Node.ELEMENT_NODE && 0 <= xt.VOID_ELEMENTS.indexOf((e.tagName || "").toLowerCase())
      }, hasFocus: function C(e) {
        return e === i.doc.activeElement && (!i.doc.hasFocus || i.doc.hasFocus()) && Boolean(r(e) || e.type || e.href || ~e.tabIndex)
      }, isEditable: function E(e) {
        return (!e.getAttribute || "false" !== e.getAttribute("contenteditable")) && ["STYLE", "SCRIPT"].indexOf(e.tagName) < 0
      }, isDeletable: function y(e) {
        return e && e.nodeType === Node.ELEMENT_NODE && e.getAttribute("class") && 0 <= (e.getAttribute("class") || "").indexOf("fr-deletable")
      }, hasClass: function L(e, t) {
        return e instanceof n && (e = e.get(0)), e && e.classList && e.classList.contains(t)
      }, filter: function _(e) {
        return i.browser.msie ? e : {acceptNode: e}
      }
    }
  }, Object.assign(xt.DEFAULTS, {
    DOMPurify: window.DOMPurify,
    htmlAllowedTags: ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "blockquote", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "pre", "progress", "queue", "rp", "rt", "ruby", "s", "samp", "script", "style", "section", "select", "small", "source", "span", "strike", "strong", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "u", "ul", "var", "video", "wbr"],
    htmlRemoveTags: ["script", "style"],
    htmlAllowedAttrs: ["accept", "accept-charset", "accesskey", "action", "align", "allowfullscreen", "allowtransparency", "alt", "async", "autocomplete", "autofocus", "autoplay", "autosave", "background", "bgcolor", "border", "charset", "cellpadding", "cellspacing", "checked", "cite", "class", "color", "cols", "colspan", "content", "contenteditable", "contextmenu", "controls", "coords", "data", "data-.*", "datetime", "default", "defer", "dir", "dirname", "disabled", "download", "draggable", "dropzone", "enctype", "for", "form", "formaction", "frameborder", "headers", "height", "hidden", "high", "href", "hreflang", "http-equiv", "icon", "id", "ismap", "itemprop", "keytype", "kind", "label", "lang", "language", "list", "loop", "low", "max", "maxlength", "media", "method", "min", "mozallowfullscreen", "multiple", "muted", "name", "novalidate", "open", "optimum", "pattern", "ping", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "reversed", "rows", "rowspan", "sandbox", "scope", "scoped", "scrolling", "seamless", "selected", "shape", "size", "sizes", "span", "src", "srcdoc", "srclang", "srcset", "start", "step", "summary", "spellcheck", "style", "tabindex", "target", "title", "type", "translate", "usemap", "value", "valign", "webkitallowfullscreen", "width", "wrap"],
    htmlAllowedStyleProps: [".*"],
    htmlAllowComments: !0,
    htmlUntouched: !1,
    fullPage: !1
  }), xt.HTML5Map = {B: "STRONG", I: "EM", STRIKE: "S"}, xt.MODULES.clean = function (f) {
    var d, p, u, h, g = f.$;

    function a(e) {
      if (e.nodeType === Node.ELEMENT_NODE && e.getAttribute("class") && 0 <= e.getAttribute("class").indexOf("fr-marker")) return !1;
      var t, n = f.node.contents(e), r = [];
      for (t = 0; t < n.length; t++) n[t].nodeType !== Node.ELEMENT_NODE || f.node.isVoid(n[t]) ? n[t].nodeType === Node.TEXT_NODE && (n[t].textContent = n[t].textContent.replace(/\u200b/g, "")) : n[t].textContent.replace(/\u200b/g, "").length !== n[t].textContent.length && a(n[t]);
      if (e.nodeType === Node.ELEMENT_NODE && !f.node.isVoid(e) && (e.normalize(), n = f.node.contents(e), r = e.querySelectorAll(".fr-marker"), n.length - r.length == 0)) {
        for (t = 0; t < n.length; t++) if (n[t].nodeType === Node.ELEMENT_NODE && (n[t].getAttribute("class") || "").indexOf("fr-marker") < 0) return !1;
        for (t = 0; t < r.length; t++) e.parentNode.insertBefore(r[t].cloneNode(!0), e);
        return e.parentNode.removeChild(e), !1
      }
    }

    function s(e, t) {
      if (e.nodeType === Node.COMMENT_NODE) return "\x3c!--".concat(e.nodeValue, "--\x3e");
      if (e.nodeType === Node.TEXT_NODE) return t ? e.textContent.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;") : e.textContent.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\u00A0/g, "&nbsp;").replace(/\u0009/g, "");
      if (e.nodeType !== Node.ELEMENT_NODE) return e.outerHTML;
      if (e.nodeType === Node.ELEMENT_NODE && 0 <= ["STYLE", "SCRIPT", "NOSCRIPT"].indexOf(e.tagName)) return e.outerHTML;
      if (e.nodeType === Node.ELEMENT_NODE && "svg" === e.tagName) {
        var n = document.createElement("div"), r = e.cloneNode(!0);
        return n.appendChild(r), n.innerHTML
      }
      if ("IFRAME" === e.tagName) return e.outerHTML.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
      var a = e.childNodes;
      if (0 === a.length) return e.outerHTML;
      for (var o = "", i = 0; i < a.length; i++) "PRE" === e.tagName && (t = !0), o += s(a[i], t);
      return f.node.openTagString(e) + o + f.node.closeTagString(e)
    }

    var l = [];

    function m(e) {
      var t = e.replace(/;;/gi, ";");
      return ";" !== (t = t.replace(/^;/gi, "")).charAt(t.length) && (t += ";"), t
    }

    function c(e) {
      var t;
      for (t in e) if (Object.prototype.hasOwnProperty.call(e, t)) {
        var n = t.match(u), r = null;
        "style" === t && f.opts.htmlAllowedStyleProps.length && (r = e[t].match(h)), n && r ? e[t] = m(r.join(";")) : n && ("style" !== t || r) || delete e[t]
      }
      for (var a = "", o = Object.keys(e).sort(), i = 0; i < o.length; i++) e[t = o[i]].indexOf('"') < 0 ? a += " ".concat(t, '="').concat(e[t], '"') : a += " ".concat(t, "='").concat(e[t], "'");
      return a
    }

    function v(e, t) {
      var n, r = document.implementation.createHTMLDocument("Froala DOC").createElement("DIV");
      g(r).append(e);
      var a = "";
      if (r) {
        var o = f.node.contents(r);
        for (n = 0; n < o.length; n++) t(o[n]);
        for (o = f.node.contents(r), n = 0; n < o.length; n++) a += s(o[n])
      }
      return a
    }

    function b(e, t, n) {
      var r = e = function o(e) {
        return l = [], e = (e = (e = (e = e.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, function (e) {
          return l.push(e), "[FROALA.EDITOR.SCRIPT ".concat(l.length - 1, "]")
        })).replace(/<noscript\b[^<]*(?:(?!<\/noscript>)<[^<]*)*<\/noscript>/gi, function (e) {
          return l.push(e), "[FROALA.EDITOR.NOSCRIPT ".concat(l.length - 1, "]")
        })).replace(/<meta((?:[\w\W]*?)) http-equiv="/g, '<meta$1 data-fr-http-equiv="')).replace(/<img((?:[\w\W]*?)) src="/g, '<img$1 data-fr-src="')
      }(e), a = null;
      return f.opts.fullPage && (r = f.html.extractNode(e, "body") || (0 <= e.indexOf("<body") ? "" : e), n && (a = f.html.extractNode(e, "head") || "")), r = v(r, t), a && (a = v(a, t)), function i(e) {
        return e = (e = (e = e.replace(/\[FROALA\.EDITOR\.SCRIPT ([\d]*)\]/gi, function (e, t) {
          return 0 <= f.opts.htmlRemoveTags.indexOf("script") ? "" : l[parseInt(t, 10)]
        })).replace(/\[FROALA\.EDITOR\.NOSCRIPT ([\d]*)\]/gi, function (e, t) {
          if (0 <= f.opts.htmlRemoveTags.indexOf("noscript")) return "";
          var n = l[parseInt(t, 10)].replace(/&lt;/g, "<").replace(/&gt;/g, ">"), r = g(n);
          if (r && r.length) {
            var a = v(r.html(), E);
            r.html(a), n = r.get(0).outerHTML
          }
          return n
        })).replace(/<img((?:[\w\W]*?)) data-fr-src="/g, '<img$1 src="')
      }(function s(e, t, n) {
        if (f.opts.fullPage) {
          var r = f.html.extractDoctype(n), a = c(f.html.extractNodeAttrs(n, "html"));
          t = null === t ? f.html.extractNode(n, "head") || "<title></title>" : t;
          var o = c(f.html.extractNodeAttrs(n, "head")), i = c(f.html.extractNodeAttrs(n, "body"));
          return "".concat(r, "<html").concat(a, "><head").concat(o, ">").concat(t, "</head><body").concat(i, ">").concat(e, "</body></html>")
        }
        return e
      }(r, a, e))
    }

    function C(e) {
      var t = f.doc.createElement("DIV");
      return t.innerText = e, t.textContent
    }

    function E(e) {
      for (var t = f.node.contents(e), n = 0; n < t.length; n++) t[n].nodeType !== Node.TEXT_NODE && E(t[n]);
      !function c(i) {
        if ("SPAN" === i.tagName && 0 <= (i.getAttribute("class") || "").indexOf("fr-marker")) return !1;
        if ("PRE" === i.tagName && function l(e) {
          var t = e.innerHTML;
          0 <= t.indexOf("\n") && (e.innerHTML = t.replace(/\n/g, "<br>"))
        }(i), i.nodeType === Node.ELEMENT_NODE && (i.getAttribute("data-fr-src") && 0 !== i.getAttribute("data-fr-src").indexOf("blob:") && i.setAttribute("data-fr-src", f.helpers.sanitizeURL(C(i.getAttribute("data-fr-src")))), i.getAttribute("href") && i.setAttribute("href", f.helpers.sanitizeURL(C(i.getAttribute("href")))), i.getAttribute("src") && i.setAttribute("src", f.helpers.sanitizeURL(C(i.getAttribute("src")))), i.getAttribute("srcdoc") && i.setAttribute("srcdoc", f.clean.html(i.getAttribute("srcdoc"))), 0 <= ["TABLE", "TBODY", "TFOOT", "TR"].indexOf(i.tagName) && (i.innerHTML = i.innerHTML.trim())), !f.opts.pasteAllowLocalImages && i.nodeType === Node.ELEMENT_NODE && "IMG" === i.tagName && i.getAttribute("data-fr-src") && 0 === i.getAttribute("data-fr-src").indexOf("file://")) return i.parentNode.removeChild(i), !1;
        if (i.nodeType === Node.ELEMENT_NODE && xt.HTML5Map[i.tagName] && "" === f.node.attributes(i)) {
          var e = xt.HTML5Map[i.tagName], t = "<".concat(e, ">").concat(i.innerHTML, "</").concat(e, ">");
          i.insertAdjacentHTML("beforebegin", t), (i = i.previousSibling).parentNode.removeChild(i.nextSibling)
        }
        if (f.opts.htmlAllowComments || i.nodeType !== Node.COMMENT_NODE) if (i.tagName && i.tagName.match(p)) "STYLE" == i.tagName && f.helpers.isMac() && function () {
          var e, n = i.innerHTML.trim(), r = [], t = /{([^}]+)}/g;
          for (n = n.replace(/\/\*[\s\S]*?\*\/|([^\\:]|^)\/\/.*|<!--[\s\S]*?-->$/, ""); e = t.exec(n);) r.push(e[1]);
          for (var a = function a(t) {
            var e = n.substring(0, n.indexOf("{")).trim();
            0 == !/^[a-z_-][a-z\d_-]*$/i.test(e) && i.parentNode.querySelectorAll(e).forEach(function (e) {
              e.removeAttribute("class"), e.setAttribute("style", r[t])
            }), n = n.substring(n.indexOf("}") + 1)
          }, o = 0; -1 != n.indexOf("{"); o++) a(o)
        }(), i.parentNode.removeChild(i); else if (i.tagName && !i.tagName.match(d)) "svg" === i.tagName ? i.parentNode.removeChild(i) : f.browser.safari && "path" === i.tagName && i.parentNode && "svg" === i.parentNode.tagName || (i.outerHTML = i.innerHTML); else {
          var n = i.attributes;
          if (n) for (var r = n.length - 1; 0 <= r; r--) {
            var a = n[r], o = a.nodeName.match(u), s = null;
            "style" === a.nodeName && f.opts.htmlAllowedStyleProps.length && (s = a.value.match(h)), o && s ? a.value = m(s.join(";")) : o && ("style" !== a.nodeName || s) || i.removeAttribute(a.nodeName)
          }
        } else 0 !== i.data.indexOf("[FROALA.EDITOR") && i.parentNode.removeChild(i)
      }(e)
    }

    return {
      _init: function e() {
        f.opts.fullPage && g.merge(f.opts.htmlAllowedTags, ["head", "title", "style", "link", "base", "body", "html", "meta"])
      }, html: function y(e, t, n, r) {
        void 0 === t && (t = []), void 0 === n && (n = []), void 0 === r && (r = !1);
        var a, o = g.merge([], f.opts.htmlAllowedTags);
        for (a = 0; a < t.length; a++) 0 <= o.indexOf(t[a]) && o.splice(o.indexOf(t[a]), 1);
        var i = g.merge([], f.opts.htmlAllowedAttrs);
        for (a = 0; a < n.length; a++) 0 <= i.indexOf(n[a]) && i.splice(i.indexOf(n[a]), 1);
        return i.push("data-fr-.*"), i.push("fr-.*"), d = new RegExp("^".concat(o.join("$|^"), "$"), "gi"), u = new RegExp("^".concat(i.join("$|^"), "$"), "gi"), p = new RegExp("^".concat(f.opts.htmlRemoveTags.join("$|^"), "$"), "gi"), h = f.opts.htmlAllowedStyleProps.length ? new RegExp("((^|;|\\s)".concat(f.opts.htmlAllowedStyleProps.join(":.+?(?=;|$))|((^|;|\\s)"), ":.+?(?=(;)|$))"), "gi") : null, e = b(e, E, !0), "undefined" != typeof f.opts.DOMPurify && (e = f.opts.DOMPurify.sanitize(e)), e
      }, toHTML5: function r() {
        var e = f.el.querySelectorAll(Object.keys(xt.HTML5Map).join(","));
        if (e.length) {
          var t = !1;
          f.el.querySelector(".fr-marker") || (f.selection.save(), t = !0);
          for (var n = 0; n < e.length; n++) "" === f.node.attributes(e[n]) && g(e[n]).replaceWith("<".concat(xt.HTML5Map[e[n].tagName], ">").concat(e[n].innerHTML, "</").concat(xt.HTML5Map[e[n].tagName], ">"));
          t && f.selection.restore()
        }
      }, tables: function t() {
        !function s() {
          for (var e = f.el.querySelectorAll("tr"), t = 0; t < e.length; t++) {
            for (var n = e[t].children, r = !0, a = 0; a < n.length; a++) if ("TH" !== n[a].tagName) {
              r = !1;
              break
            }
            if (!1 !== r && 0 !== n.length) {
              for (var o = e[t]; o && "TABLE" !== o.tagName && "THEAD" !== o.tagName;) o = o.parentNode;
              var i = o;
              "THEAD" !== i.tagName && (i = f.doc.createElement("THEAD"), o.insertBefore(i, o.firstChild)), i.appendChild(e[t])
            }
          }
        }()
      }, lists: function L() {
        !function s() {
          var e, t = [];
          do {
            if (t.length) {
              var n = t[0], r = f.doc.createElement("ul");
              n.parentNode.insertBefore(r, n);
              do {
                var a = n;
                n = n.nextSibling, r.appendChild(a)
              } while (n && "LI" === n.tagName)
            }
            t = [];
            for (var o = f.el.querySelectorAll("li"), i = 0; i < o.length; i++) e = o[i], f.node.isList(e.parentNode) || t.push(o[i])
          } while (0 < t.length)
        }(), function o() {
          for (var e = f.el.querySelectorAll("ol + ol, ul + ul"), t = 0; t < e.length; t++) {
            var n = e[t];
            if (f.node.isList(n.previousSibling) && f.node.openTagString(n) === f.node.openTagString(n.previousSibling)) {
              for (var r = f.node.contents(n), a = 0; a < r.length; a++) n.previousSibling.appendChild(r[a]);
              n.parentNode.removeChild(n)
            }
          }
        }(), function i() {
          for (var e = f.el.querySelectorAll("ul, ol"), t = 0; t < e.length; t++) for (var n = f.node.contents(e[t]), r = null, a = n.length - 1; 0 <= a; a--) !n[a].tagName && f.opts.htmlUntouched || "LI" === n[a].tagName || "UL" == n[a].tagName || "OL" == n[a].tagName ? r = null : (r || (r = g(f.doc.createElement("LI"))).insertBefore(n[a]), r.prepend(n[a]))
        }(), function l() {
          var e, t, n;
          do {
            t = !1;
            var r = f.el.querySelectorAll("li:empty");
            for (e = 0; e < r.length; e++) r[e].parentNode.removeChild(r[e]);
            var a = f.el.querySelectorAll("ul, ol");
            for (e = 0; e < a.length; e++) (n = a[e]).querySelector("LI") || (t = !0, n.parentNode.removeChild(n))
          } while (!0 === t)
        }(), function a() {
          for (var e = f.el.querySelectorAll("ul > ul, ol > ol, ul > ol, ol > ul"), t = 0; t < e.length; t++) {
            var n = e[t], r = n.previousSibling;
            r && ("LI" === r.tagName ? r.appendChild(n) : g(n).wrap("<li></li>"))
          }
        }(), function c() {
          for (var e = f.el.querySelectorAll("li > ul, li > ol"), t = 0; t < e.length; t++) {
            var n = e[t];
            if (n.nextSibling) for (var r = n.nextSibling; 0 < r.childNodes.length;) n.append(r.childNodes[0])
          }
        }(), function d() {
          for (var e = f.el.querySelectorAll("li > ul, li > ol"), t = 0; t < e.length; t++) {
            var n = e[t];
            if (f.node.isFirstSibling(n) && "none" != n.parentNode.style.listStyleType) g(n).before("<br/>"); else if (n.previousSibling && "BR" === n.previousSibling.tagName) {
              for (var r = n.previousSibling.previousSibling; r && f.node.hasClass(r, "fr-marker");) r = r.previousSibling;
              r && "BR" !== r.tagName && g(n.previousSibling).remove()
            }
          }
        }(), function n() {
          for (var e = f.el.querySelectorAll("li:empty"), t = 0; t < e.length; t++) g(e[t]).remove()
        }()
      }, invisibleSpaces: function n(e) {
        return e.replace(/\u200b/g, "").length === e.length ? e : f.clean.exec(e, a)
      }, exec: b
    }
  }, xt.XS = 0, xt.SM = 1, xt.MD = 2, xt.LG = 3;
  xt.LinkRegExCommon = "[".concat("a-z\\u0080-\\u009f\\u00a1-\\uffff0-9-_\\.", "]{1,}"), xt.LinkRegExEnd = "((:[0-9]{1,5})|)(((\\/|\\?|#)[a-z\\u00a1-\\uffff0-9@?\\|!^=%&amp;\\/~+#-\\'*-_{}]*)|())", xt.LinkRegExTLD = "((".concat(xt.LinkRegExCommon, ")(\\.(com|net|org|edu|mil|gov|co|biz|info|me|dev)))"), xt.LinkRegExHTTP = "((ftp|http|https):\\/\\/".concat(xt.LinkRegExCommon, ")"), xt.LinkRegExAuth = "((ftp|http|https):\\/\\/[\\u0021-\\uffff]{1,}@".concat(xt.LinkRegExCommon, ")"), xt.LinkRegExWWW = "(www\\.".concat(xt.LinkRegExCommon, "\\.[a-z0-9-]{2,24})"), xt.LinkRegEx = "(".concat(xt.LinkRegExTLD, "|").concat(xt.LinkRegExHTTP, "|").concat(xt.LinkRegExWWW, "|").concat(xt.LinkRegExAuth, ")").concat(xt.LinkRegExEnd), xt.LinkProtocols = ["mailto", "tel", "sms", "notes", "data"], xt.MAIL_REGEX = /.+@.+\..+/i, xt.MODULES.helpers = function (o) {
    var i, s = o.$;

    function e() {
      var e = {}, t = function o() {
        var e, t = -1;
        return "Microsoft Internet Explorer" === navigator.appName ? (e = navigator.userAgent, null !== new RegExp("MSIE ([0-9]{1,}[\\.0-9]{0,})").exec(e) && (t = parseFloat(RegExp.$1))) : "Netscape" === navigator.appName && (e = navigator.userAgent, null !== new RegExp("Trident/.*rv:([0-9]{1,}[\\.0-9]{0,})").exec(e) && (t = parseFloat(RegExp.$1))), t
      }();
      if (0 < t) e.msie = !0; else {
        var n = navigator.userAgent.toLowerCase(),
          r = /(edge)[ /]([\w.]+)/.exec(n) || /(chrome)[ /]([\w.]+)/.exec(n) || /(webkit)[ /]([\w.]+)/.exec(n) || /(opera)(?:.*version|)[ /]([\w.]+)/.exec(n) || /(msie) ([\w.]+)/.exec(n) || n.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(n) || [],
          a = r[1] || "";
        r[2];
        r[1] && (e[a] = !0), e.chrome ? e.webkit = !0 : e.webkit && (e.safari = !0)
      }
      return e.msie && (e.version = t), e
    }

    function t() {
      return /(iPad|iPhone|iPod)/g.test(navigator.userAgent) && !a()
    }

    function n() {
      return /(Android)/g.test(navigator.userAgent) && !a()
    }

    function r() {
      return /(Blackberry)/g.test(navigator.userAgent)
    }

    function a() {
      return /(Windows Phone)/gi.test(navigator.userAgent)
    }

    var l = null;
    return {
      _init: function c() {
        o.browser = e()
      }, isIOS: t, isMac: function d() {
        return null === l && (l = 0 <= navigator.platform.toUpperCase().indexOf("MAC")), l
      }, isAndroid: n, isBlackberry: r, isWindowsPhone: a, isMobile: function f() {
        return n() || t() || r()
      }, isEmail: function p(e) {
        return !/^(https?:|ftps?:|)\/\//i.test(e) && xt.MAIL_REGEX.test(e)
      }, requestAnimationFrame: function u() {
        return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (e) {
          window.setTimeout(e, 1e3 / 60)
        }
      }, getPX: function h(e) {
        return parseInt(e, 10) || 0
      }, screenSize: function g(e) {
        try {
          var t = 0;
          if ((t = e ? o.$box.width() : o.$sc.width()) < 768) return xt.XS;
          if (768 <= t && t < 992) return xt.SM;
          if (992 <= t && t < 1200) return xt.MD;
          if (1200 <= t) return xt.LG
        } catch (n) {
          return xt.LG
        }
      }, isTouch: function m() {
        return "ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch
      }, sanitizeURL: function v(e) {
        return /^(https?:|ftps?:|)\/\//i.test(e) ? e : /^([A-Za-z]:(\\){1,2}|[A-Za-z]:((\\){1,2}[^\\]+)+)(\\)?$/i.test(e) ? e : new RegExp("^(".concat(xt.LinkProtocols.join("|"), "):"), "i").test(e) ? e : e = encodeURIComponent(e).replace(/%23/g, "#").replace(/%2F/g, "/").replace(/%25/g, "%").replace(/mailto%3A/gi, "mailto:").replace(/file%3A/gi, "file:").replace(/sms%3A/gi, "sms:").replace(/tel%3A/gi, "tel:").replace(/notes%3A/gi, "notes:").replace(/data%3Aimage/gi, "data:image").replace(/blob%3A/gi, "blob:").replace(/%3A(\d)/gi, ":$1").replace(/webkit-fake-url%3A/gi, "webkit-fake-url:").replace(/%3F/g, "?").replace(/%3D/g, "=").replace(/%26/g, "&").replace(/&amp;/g, "&").replace(/%2C/g, ",").replace(/%3B/g, ";").replace(/%2B/g, "+").replace(/%40/g, "@").replace(/%5B/g, "[").replace(/%5D/g, "]").replace(/%7B/g, "{").replace(/%7D/g, "}")
      }, isArray: function b(e) {
        return e && !Object.prototype.propertyIsEnumerable.call(e, "length") && "object" === kt(e) && "number" == typeof e.length
      }, RGBToHex: function C(e) {
        function t(e) {
          return "0".concat(parseInt(e, 10).toString(16)).slice(-2)
        }

        try {
          return e && "transparent" !== e ? /^#[0-9A-F]{6}$/i.test(e) ? e : (e = e.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/), "#".concat(t(e[1])).concat(t(e[2])).concat(t(e[3])).toUpperCase()) : ""
        } catch (n) {
          return null
        }
      }, HEXtoRGB: function E(e) {
        e = e.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (e, t, n, r) {
          return t + t + n + n + r + r
        });
        var t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
        return t ? "rgb(".concat(parseInt(t[1], 16), ", ").concat(parseInt(t[2], 16), ", ").concat(parseInt(t[3], 16), ")") : ""
      }, isURL: function y(e) {
        return !!/^(https?:|ftps?:|)\/\//i.test(e) && (e = String(e).replace(/</g, "%3C").replace(/>/g, "%3E").replace(/"/g, "%22").replace(/ /g, "%20"), new RegExp("^".concat(xt.LinkRegExHTTP).concat(xt.LinkRegExEnd, "$"), "gi").test(e))
      }, getAlignment: function L(e) {
        e.css || (e = s(e));
        var t = (e.css("text-align") || "").replace(/-(.*)-/g, "");
        if (["left", "right", "justify", "center"].indexOf(t) < 0) {
          if (!i) {
            var n = s('<div dir="'.concat("rtl" === o.opts.direction ? "rtl" : "auto", '" style="text-align: ').concat(o.$el.css("text-align"), '; position: fixed; left: -3000px;"><span id="s1">.</span><span id="s2">.</span></div>'));
            s("body").first().append(n);
            var r = n.find("#s1").get(0).getBoundingClientRect().left,
              a = n.find("#s2").get(0).getBoundingClientRect().left;
            n.remove(), i = r < a ? "left" : "right"
          }
          t = i
        }
        return t
      }, scrollTop: function _() {
        return o.o_win.pageYOffset ? o.o_win.pageYOffset : o.o_doc.documentElement && o.o_doc.documentElement.scrollTop ? o.o_doc.documentElement.scrollTop : o.o_doc.body.scrollTop ? o.o_doc.body.scrollTop : 0
      }, scrollLeft: function w() {
        return o.o_win.pageXOffset ? o.o_win.pageXOffset : o.o_doc.documentElement && o.o_doc.documentElement.scrollLeft ? o.o_doc.documentElement.scrollLeft : o.o_doc.body.scrollLeft ? o.o_doc.body.scrollLeft : 0
      }, isInViewPort: function A(e) {
        var t = e.getBoundingClientRect();
        return 0 <= (t = {
          top: Math.round(t.top),
          bottom: Math.round(t.bottom)
        }).top && t.bottom <= (window.innerHeight || document.documentElement.clientHeight) || t.top <= 0 && t.bottom >= (window.innerHeight || document.documentElement.clientHeight)
      }
    }
  }, xt.MODULES.events = function (l) {
    var e, o = l.$, i = {};

    function s(e, t, n) {
      m(e, t, n)
    }

    function c(e) {
      if (void 0 === e && (e = !0), !l.$wp) return !1;
      if (l.helpers.isIOS() && l.$win.get(0).focus(), l.core.hasFocus()) return !1;
      if (l.selection.isCollapsed() && !l.selection.get().anchorNode) {
        var t = l.$el.find(l.html.blockTagsQuery()).get(0);
        t && (o(t).prepend(xt.MARKERS), l.selection.restore())
      }
      if (!l.core.hasFocus() && e) {
        var n = l.$win.scrollTop();
        if (l.browser.msie && l.$box && l.$box.css("position", "fixed"), l.browser.msie && l.$wp && l.$wp.css("overflow", "visible"), l.browser.msie && l.$sc && l.$sc.css("position", "fixed"), l.browser.msie || (p(), l.el.focus(), l.events.trigger("focus"), f()), l.browser.msie && l.$sc && l.$sc.css("position", ""), l.browser.msie && l.$box && l.$box.css("position", ""), l.browser.msie && l.$wp && l.$wp.css("overflow", "auto"), n !== l.$win.scrollTop() && l.$win.scrollTop(n), !l.selection.info(l.el).atStart) return !1
      }
      if (!l.core.hasFocus() || 0 < l.$el.find(".fr-marker").length) return !1;
      if (l.selection.info(l.el).atStart && l.selection.isCollapsed() && null !== l.html.defaultTag()) {
        var r = l.markers.insert();
        if (r && !l.node.blockParent(r)) {
          o(r).remove();
          var a = l.$el.find(l.html.blockTagsQuery()).get(0);
          a && (o(a).prepend(xt.MARKERS), l.selection.restore())
        } else r && o(r).remove()
      }
    }

    var d = !1;

    function f() {
      e = !0
    }

    function p() {
      e = !1
    }

    function u() {
      return e
    }

    function h(e, t, n) {
      var r, a = e.split(" ");
      if (1 < a.length) {
        for (var o = 0; o < a.length; o++) h(a[o], t, n);
        return !0
      }
      void 0 === n && (n = !1), r = 0 !== e.indexOf("shared.") ? (i[e] = i[e] || [], i[e]) : (l.shared._events[e] = l.shared._events[e] || [], l.shared._events[e]), n ? r.unshift(t) : r.push(t)
    }

    var g = [];

    function m(e, t, n, r, a) {
      "function" == typeof n && (a = r, r = n, n = !1);
      var o = a ? l.shared.$_events : g, i = a ? l.sid : l.id,
        s = "".concat(t.trim().split(" ").join(".ed".concat(i, " ")), ".ed").concat(i);
      n ? e.on(s, n, r) : e.on(s, r), o.push([e, s])
    }

    function t(e) {
      for (var t = 0; t < e.length; t++) e[t][0].off(e[t][1])
    }

    function v(e, t, n) {
      if (!l.edit.isDisabled() || n) {
        var r, a;
        if (0 !== e.indexOf("shared.")) r = i[e]; else {
          if (0 < l.shared.count) return !1;
          r = l.shared._events[e]
        }
        if (r) for (var o = 0; o < r.length; o++) if (!1 === (a = r[o].apply(l, t))) return !1;
        return (!l.opts.events || !l.opts.events[e] || !1 !== (a = l.opts.events[e].apply(l, t))) && a
      }
    }

    function b() {
      for (var e in i) Object.prototype.hasOwnProperty.call(i, e) && delete i[e]
    }

    function C() {
      for (var e in l.shared._events) Object.prototype.hasOwnProperty.call(l.shared._events, e) && delete l.shared._events[e]
    }

    return {
      _init: function E() {
        l.shared.$_events = l.shared.$_events || [], l.shared._events = {}, function e() {
          l.helpers.isMobile() ? (l._mousedown = "touchstart", l._mouseup = "touchend", l._move = "touchmove", l._mousemove = "touchmove") : (l._mousedown = "mousedown", l._mouseup = "mouseup", l._move = "", l._mousemove = "mousemove")
        }(), function t() {
          s(l.$el, "click mouseup mousemove mousedown touchstart touchend dragenter dragover dragleave dragend drop dragstart", function (e) {
            v(e.type, [e])
          }), h("mousedown", function () {
            for (var e = 0; e < xt.INSTANCES.length; e++) xt.INSTANCES[e] !== l && xt.INSTANCES[e].popups && xt.INSTANCES[e].popups.areVisible() && xt.INSTANCES[e].$el.find(".fr-marker").remove()
          })
        }(), function n() {
          s(l.$win, l._mousedown, function (e) {
            v("window.mousedown", [e]), f()
          }), s(l.$win, l._mouseup, function (e) {
            v("window.mouseup", [e])
          }), s(l.$win, "beforeinput cut copy keydown keyup touchmove touchend", function (e) {
            v("window.".concat(e.type), [e])
          })
        }(), function r() {
          s(l.$doc, "dragend drop", function (e) {
            v("document.".concat(e.type), [e])
          })
        }(), function a() {
          s(l.$el, "beforeinput keydown keypress keyup input", function (e) {
            v(e.type, [e])
          })
        }(), function o() {
          s(l.$el, "focus", function (e) {
            u() && (c(!1), !1 === d && (v(e.type, [e]), l.helpers.isMobile() && p()))
          }), s(l.$el, "blur", function (e) {
            u() && !0 === d && (v(e.type, [e]), l.helpers.isMobile() && l.opts.toolbarContainer && (l.shared.selected_editor = l.id), f())
          }), m(l.$el, "mousedown", '[contenteditable="true"]', function () {
            p(), l.$el.blur()
          }), h("focus", function () {
            d = !0
          }), h("blur", function () {
            d = !1
          })
        }(), f(), function i() {
          s(l.$el, "cut copy paste beforepaste", function (e) {
            v(e.type, [e])
          })
        }(), h("destroy", b), h("shared.destroy", C)
      }, on: h, trigger: v, bindClick: function r(e, t, n) {
        m(e, l._mousedown, t, function (e) {
          l.edit.isDisabled() || function n(e) {
            var t = o(e.currentTarget);
            return l.edit.isDisabled() || l.node.hasClass(t.get(0), "fr-disabled") ? (e.preventDefault(), !1) : "mousedown" === e.type && 1 !== e.which || (l.helpers.isMobile() || e.preventDefault(), (l.helpers.isAndroid() || l.helpers.isWindowsPhone()) && 0 === t.parents(".fr-dropdown-menu").length && (e.preventDefault(), e.stopPropagation()), t.addClass("fr-selected"), void l.events.trigger("commands.mousedown", [t]))
          }(e)
        }, !0), m(e, "".concat(l._mouseup, " ").concat(l._move), t, function (e) {
          l.edit.isDisabled() || function a(e, t) {
            var n = o(e.currentTarget);
            if (l.edit.isDisabled() || l.node.hasClass(n.get(0), "fr-disabled")) return e.preventDefault(), !1;
            if ("mouseup" === e.type && 1 !== e.which) return !0;
            if (l.button.getButtons(".fr-selected", !0).get(0) == n.get(0) && !l.node.hasClass(n.get(0), "fr-selected")) return !0;
            if ("touchmove" !== e.type) {
              if (e.stopPropagation(), e.stopImmediatePropagation(), e.preventDefault(), !l.node.hasClass(n.get(0), "fr-selected")) return l.button.getButtons(".fr-selected", !0).removeClass("fr-selected"), !1;
              if (l.button.getButtons(".fr-selected", !0).removeClass("fr-selected"), n.data("dragging") || n.attr("disabled")) return n.removeData("dragging"), !1;
              var r = n.data("timeout");
              r && (clearTimeout(r), n.removeData("timeout")), t.apply(l, [e])
            } else n.data("timeout") || n.data("timeout", setTimeout(function () {
              n.data("dragging", !0)
            }, 100))
          }(e, n)
        }, !0), m(e, "mousedown click mouseup", t, function (e) {
          l.edit.isDisabled() || e.stopPropagation()
        }, !0), h("window.mouseup", function () {
          l.edit.isDisabled() || (e.find(t).removeClass("fr-selected"), f())
        }), m(e, "mouseover", t, function () {
          o(this).hasClass("fr-options") && o(this).prev(".fr-btn").addClass("fr-btn-hover"), o(this).next(".fr-btn").hasClass("fr-options") && o(this).next(".fr-btn").addClass("fr-btn-hover")
        }), m(e, "mouseout", t, function () {
          o(this).hasClass("fr-options") && o(this).prev(".fr-btn").removeClass("fr-btn-hover"), o(this).next(".fr-btn").hasClass("fr-options") && o(this).next(".fr-btn").removeClass("fr-btn-hover")
        })
      }, disableBlur: p, enableBlur: f, blurActive: u, focus: c, chainTrigger: function y(e, t, n) {
        if (!l.edit.isDisabled() || n) {
          var r, a;
          if (0 !== e.indexOf("shared.")) r = i[e]; else {
            if (0 < l.shared.count) return !1;
            r = l.shared._events[e]
          }
          if (r) for (var o = 0; o < r.length; o++) void 0 !== (a = r[o].apply(l, [t])) && (t = a);
          return l.opts.events && l.opts.events[e] && void 0 !== (a = l.opts.events[e].apply(l, [t])) && (t = a), t
        }
      }, $on: m, $off: function n() {
        t(g), g = [], 0 === l.shared.count && (t(l.shared.$_events), l.shared.$_events = [])
      }
    }
  }, Object.assign(xt.DEFAULTS, {indentMargin: 20}), xt.COMMANDS = {
    bold: {
      title: "Bold", toggle: !0, refresh: function (e) {
        var t = this.format.is("strong");
        e.toggleClass("fr-active", t).attr("aria-pressed", t)
      }
    },
    italic: {
      title: "Italic", toggle: !0, refresh: function (e) {
        var t = this.format.is("em");
        e.toggleClass("fr-active", t).attr("aria-pressed", t)
      }
    },
    underline: {
      title: "Underline", toggle: !0, refresh: function (e) {
        var t = this.format.is("u");
        e.toggleClass("fr-active", t).attr("aria-pressed", t)
      }
    },
    strikeThrough: {
      title: "Strikethrough", toggle: !0, refresh: function (e) {
        var t = this.format.is("s");
        e.toggleClass("fr-active", t).attr("aria-pressed", t)
      }
    },
    subscript: {
      title: "Subscript", toggle: !0, refresh: function (e) {
        var t = this.format.is("sub");
        e.toggleClass("fr-active", t).attr("aria-pressed", t)
      }
    },
    superscript: {
      title: "Superscript", toggle: !0, refresh: function (e) {
        var t = this.format.is("sup");
        e.toggleClass("fr-active", t).attr("aria-pressed", t)
      }
    },
    outdent: {title: "Decrease Indent"},
    indent: {title: "Increase Indent"},
    undo: {title: "Undo", undo: !1, forcedRefresh: !0, disabled: !0},
    redo: {title: "Redo", undo: !1, forcedRefresh: !0, disabled: !0},
    insertHR: {title: "Insert Horizontal Line"},
    clearFormatting: {title: "Clear Formatting"},
    selectAll: {title: "Select All", undo: !1},
    moreText: {title: "More Text", undo: !1},
    moreParagraph: {title: "More Paragraph", undo: !1},
    moreRich: {title: "More Rich", undo: !1},
    moreMisc: {title: "More Misc", undo: !1}
  }, xt.RegisterCommand = function (e, t) {
    xt.COMMANDS[e] = t
  }, xt.MODULES.commands = function (i) {
    var s = i.$;

    function l(e) {
      return i.html.defaultTag() && (e = "<".concat(i.html.defaultTag(), ">").concat(e, "</").concat(i.html.defaultTag(), ">")), e
    }

    var o = {
      bold: function () {
        e("bold", "strong")
      }, subscript: function () {
        i.format.is("sup") && i.format.remove("sup"), e("subscript", "sub")
      }, superscript: function () {
        i.format.is("sub") && i.format.remove("sub"), e("superscript", "sup")
      }, italic: function () {
        e("italic", "em")
      }, strikeThrough: function () {
        e("strikeThrough", "s")
      }, underline: function () {
        e("underline", "u")
      }, undo: function () {
        i.undo.run()
      }, redo: function () {
        i.undo.redo()
      }, indent: function () {
        r(1)
      }, outdent: function () {
        r(-1)
      }, show: function () {
        i.opts.toolbarInline && i.toolbar.showInline(null, !0)
      }, insertHR: function () {
        i.selection.remove();
        var e = "";
        i.core.isEmpty() && (e = l(e = "<br>"));
        var t = '<hr id="fr-just" class="fr-just">'.concat(e);
        i.opts.trackChangesEnabled && (t = i.track_changes.wrapInTracking(s(t), "hrWrapper").get(0).outerHTML);
        i.html.insert(t);
        var n, r = i.$el.find("hr#fr-just").length ? i.$el.find("hr#fr-just") : i.$el.find(".fr-just");
        r.removeAttr("id"), r.removeAttr("class");
        var a = i.opts.trackChangesEnabled && "SPAN" === r[0].parentNode.tagName && "P" === r[0].parentNode.parentNode.tagName;
        if (0 === r.next().length) {
          var o = i.html.defaultTag();
          o && !a ? r.after(s(i.doc.createElement(o)).append("<br>").get(0)) : a ? r[0].parentNode.after(s(i.doc.createElement(o)).append("<br>").get(0)) : r.after("<br>")
        }
        r.prev().is("hr") ? n = i.selection.setAfter(r.get(0), !1) : r.next().is("hr") ? n = i.selection.setBefore(r.get(0), !1) : a || i.selection.setAfter(r.get(0), !1) ? i.selection.setAfter(r[0].parentNode, !1) : i.selection.setBefore(r.get(0), !1), n || void 0 === n || (e = l(e = "".concat(xt.MARKERS, "<br>")), r.after(e)), i.selection.restore()
      }, clearFormatting: function () {
        i.format.remove()
      }, selectAll: function () {
        i.doc.execCommand("selectAll", !1, !1)
      }, moreText: function (e) {
        t(e)
      }, moreParagraph: function (e) {
        t(e)
      }, moreRich: function (e) {
        t(e)
      }, moreMisc: function (e) {
        t(e)
      }, moreTrackChanges: function () {
        t("trackChanges")
      }
    };

    function t(e) {
      var t = i.$tb.find("[data-cmd=".concat(e, "]")), n = i.$tb.find("[data-cmd=html]");
      i.opts.trackChangesEnabled ? n && n.addClass("fr-disabled") : n && n.removeClass("fr-disabled"), function r(n) {
        i.helpers.isMobile() && i.opts.toolbarInline && i.events.disableBlur();
        var e = i.$tb.find('.fr-more-toolbar[data-name="'.concat(n.attr("data-group-name"), '"]'));
        "trackChanges" === n.data("cmd") && (e = i.$tb.find('.fr-more-toolbar[data-name="trackChanges-'.concat(i.id, '"]')));
        if (i.$tb.find(".fr-open").not(n).not('[data-cmd="trackChanges"]').removeClass("fr-open"), n.toggleClass("fr-open"), i.$tb.find(".fr-more-toolbar").removeClass("fr-overflow-visible"), i.$tb.find(".fr-expanded").not(e).length) {
          var t = i.$tb.find(".fr-expanded").not(e);
          t.each(function (e, t) {
            0 != s(t).data("name").indexOf("trackChanges-") && 0 != s(t).data("name").indexOf("moreRich-") ? s(t).toggleClass("fr-expanded") : n.parents('[data-name^="moreRich-"]').length || 0 == s(t).data("name").indexOf("trackChanges-") || s(t).find('[id^="trackChanges-"]').length && i.opts.trackChangesEnabled || s(t).toggleClass("fr-expanded")
          }), e.toggleClass("fr-expanded")
        } else e.toggleClass("fr-expanded"), i.$box.toggleClass("fr-toolbar-open"), i.$tb.toggleClass("fr-toolbar-open")
      }(t), i.toolbar.setMoreToolbarsHeight()
    }

    function n(e, t) {
      if (!(i.markdown && i.markdown.isEnabled() && ("bold" === e || "italic" === e || "underline" === e) || i.opts.trackChangesEnabled && "markdown" === e) && !1 !== i.events.trigger("commands.before", s.merge([e], t || []))) {
        var n = xt.COMMANDS[e] && xt.COMMANDS[e].callback || o[e], r = !0, a = !1;
        xt.COMMANDS[e] && ("undefined" != typeof xt.COMMANDS[e].focus && (r = xt.COMMANDS[e].focus), "undefined" != typeof xt.COMMANDS[e].accessibilityFocus && (a = xt.COMMANDS[e].accessibilityFocus)), (!i.core.hasFocus() && r && !i.popups.areVisible() || !i.core.hasFocus() && a && i.accessibility.hasFocus()) && i.events.focus(!0), xt.COMMANDS[e] && !1 !== xt.COMMANDS[e].undo && (i.$el.find(".fr-marker").length && (i.events.disableBlur(), i.selection.restore()), i.undo.saveStep()), n && n.apply(i, s.merge([e], t || [])), i.events.trigger("commands.after", s.merge([e], t || [])), xt.COMMANDS[e] && !1 !== xt.COMMANDS[e].undo && i.undo.saveStep()
      }
    }

    function e(e, t) {
      i.format.toggle(t)
    }

    function r(e) {
      i.selection.save(), i.html.wrap(!0, !0, !0, !0), i.selection.restore();
      for (var t = i.selection.blocks(), n = 0; n < t.length; n++) if ("LI" !== t[n].tagName || "LI" !== t[n].parentNode.tagName) {
        var r = s(t[n]);
        "LI" != t[n].tagName && "LI" == t[n].parentNode.tagName && (r = s(t[n].parentNode));
        var a = "rtl" === i.opts.direction || "rtl" === r.css("direction") ? "margin-right" : "margin-left",
          o = i.helpers.getPX(r.css(a));
        if (r.width() < 2 * i.opts.indentMargin && 0 < e) continue;
        "UL" != t[n].parentNode.tagName && "OL" != t[n].parentNode.tagName && "LI" != t[n].parentNode.tagName && r.css(a, Math.max(o + e * i.opts.indentMargin, 0) || ""), r.removeClass("fr-temp-div")
      }
      i.selection.save(), i.html.unwrap(), i.selection.restore()
    }

    function a(e) {
      return function () {
        n(e)
      }
    }

    var c = {};
    for (var d in o) Object.prototype.hasOwnProperty.call(o, d) && (c[d] = a(d));
    return Object.assign(c, {
      exec: n, _init: function f() {
        i.events.on("keydown", function (e) {
          var t = i.selection.element();
          if (t && "HR" === t.tagName && !i.keys.isArrow(e.which)) return e.preventDefault(), !1
        }), i.events.on("keyup", function (e) {
          var t = i.selection.element();
          if (t && "HR" === t.tagName) if (e.which === xt.KEYCODE.ARROW_LEFT || e.which === xt.KEYCODE.ARROW_UP) {
            if (t.previousSibling) return i.node.isBlock(t.previousSibling) ? i.selection.setAtEnd(t.previousSibling) : s(t).before(xt.MARKERS), i.selection.restore(), !1
          } else if ((e.which === xt.KEYCODE.ARROW_RIGHT || e.which === xt.KEYCODE.ARROW_DOWN) && t.nextSibling) return i.node.isBlock(t.nextSibling) ? i.selection.setAtStart(t.nextSibling) : s(t).after(xt.MARKERS), i.selection.restore(), !1
        }), i.events.on("mousedown", function (e) {
          if (e.target && "HR" === e.target.tagName) return e.preventDefault(), e.stopPropagation(), !1
        }), i.events.on("mouseup", function () {
          var e = i.selection.element();
          e === i.selection.endElement() && e && "HR" === e.tagName && (e.nextSibling && (i.node.isBlock(e.nextSibling) ? i.selection.setAtStart(e.nextSibling) : s(e).after(xt.MARKERS)), i.selection.restore())
        })
      }
    })
  }, xt.MODULES.cursorLists = function (g) {
    var m = g.$;

    function v(e) {
      for (var t = e; "LI" !== t.tagName;) t = t.parentNode;
      return t
    }

    function b(e) {
      for (var t = e; !g.node.isList(t);) t = t.parentNode;
      return t
    }

    return {
      _startEnter: function C(e) {
        var t, n = v(e), r = n.nextSibling, a = n.previousSibling, o = g.html.defaultTag();
        if (g.node.isEmpty(n, !0) && r) {
          for (var i = "", s = "", l = e.parentNode; !g.node.isList(l) && l.parentNode && ("LI" !== l.parentNode.tagName || l.parentNode === n);) i = g.node.openTagString(l) + i, s += g.node.closeTagString(l), l = l.parentNode;
          i = g.node.openTagString(l) + i, s += g.node.closeTagString(l);
          var c = "";
          for (c = l.parentNode && "LI" === l.parentNode.tagName ? "".concat(s, "<li>").concat(xt.MARKERS, "<br>").concat(i) : o ? "".concat(s, "<").concat(o, ">").concat(xt.MARKERS, "<br></").concat(o, ">").concat(i) : "".concat(s + xt.MARKERS, "<br>").concat(i); ["UL", "OL"].indexOf(l.tagName) < 0 || l.parentNode && "LI" === l.parentNode.tagName;) l = l.parentNode;
          m(n).replaceWith('<span id="fr-break"></span>');
          var d = g.node.openTagString(l) + m(l).html() + g.node.closeTagString(l);
          d = d.replace(/<span id="fr-break"><\/span>/g, c), m(l).replaceWith(d), g.$el.find("li:empty").remove()
        } else if (a && r || !g.node.isEmpty(n, !0)) {
          for (var f = "<br>", p = e.parentNode; p && "LI" !== p.tagName;) f = g.node.openTagString(p) + f + g.node.closeTagString(p), p = p.parentNode;
          m(n).before("<li>".concat(f, "</li>")), m(e).remove()
        } else if (a) {
          t = b(n);
          for (var u = "".concat(xt.MARKERS, "<br>"), h = e.parentNode; h && "LI" !== h.tagName;) u = g.node.openTagString(h) + u + g.node.closeTagString(h), h = h.parentNode;
          t.parentNode && "LI" === t.parentNode.tagName ? m(t.parentNode).after("<li>".concat(u, "</li>")) : o ? m(t).after("<".concat(o, ">").concat(u, "</").concat(o, ">")) : m(t).after(u), m(n).remove()
        } else (t = b(n)).parentNode && "LI" === t.parentNode.tagName ? r ? m(t.parentNode).before("".concat(g.node.openTagString(n) + xt.MARKERS, "<br></li>")) : m(t.parentNode).after("".concat(g.node.openTagString(n) + xt.MARKERS, "<br></li>")) : o ? m(t).before("<".concat(o, ">").concat(xt.MARKERS, "<br></").concat(o, ">")) : m(t).before("".concat(xt.MARKERS, "<br>")), m(n).remove()
      }, _middleEnter: function c(e) {
        for (var t = v(e), n = "", r = e, a = "", o = "", i = !1; r !== t;) {
          var s = "A" === (r = r.parentNode).tagName && g.cursor.isAtEnd(e, r) ? "fr-to-remove" : "";
          i || r == t || g.node.isBlock(r) || (i = !0, a += xt.INVISIBLE_SPACE), a = g.node.openTagString(m(r).clone().addClass(s).get(0)) + a, g.opts.trackChangesEnabled ? o += g.node.closeTagString(r) : o = g.node.closeTagString(r) + o
        }
        n = o + n + a + xt.MARKERS + (g.opts.keepFormatOnDelete ? xt.INVISIBLE_SPACE : ""), m(e).replaceWith('<span id="fr-break"></span>');
        var l = g.node.openTagString(t) + m(t).html() + g.node.closeTagString(t);
        l = l.replace(/<span id="fr-break"><\/span>/g, n), m(t).replaceWith(l)
      }, _endEnter: function l(e) {
        for (var t = v(e), n = xt.MARKERS, r = "", a = e, o = !1; a !== t;) if (!(a = a.parentNode).classList.contains("fr-img-space-wrap") && !a.classList.contains("fr-img-space-wrap2")) {
          var i = "A" === a.tagName && g.cursor.isAtEnd(e, a) ? "fr-to-remove" : "";
          o || a === t || g.node.isBlock(a) || (o = !0, r += xt.INVISIBLE_SPACE), r = g.node.openTagString(m(a).clone().addClass(i).get(0)) + r, n += g.node.closeTagString(a)
        }
        var s = r + n;
        m(e).remove(), m(t).after(s)
      }, _backspace: function d(e) {
        var t = v(e), n = t.previousSibling;
        if (n) {
          n = m(n).find(g.html.blockTagsQuery()).get(-1) || n, m(e).replaceWith(xt.MARKERS);
          var r = g.node.contents(n);
          r.length && "BR" === r[r.length - 1].tagName && m(r[r.length - 1]).remove(), m(t).find(g.html.blockTagsQuery()).not("ol, ul, table").each(function () {
            this.parentNode === t && m(this).replaceWith(m(this).html() + (g.node.isEmpty(this) ? "" : "<br>"))
          });
          for (var a, o = g.node.contents(t)[0]; o && !g.node.isList(o);) a = o.nextSibling, m(n).append(o), o = a;
          for (n = t.previousSibling; o;) a = o.nextSibling, m(n).append(o), o = a;
          1 < (r = g.node.contents(n)).length && "BR" === r[r.length - 1].tagName && m(r[r.length - 1]).remove(), m(t).remove()
        } else {
          var i = b(t);
          if (m(e).replaceWith(xt.MARKERS), i.parentNode && "LI" === i.parentNode.tagName) {
            var s = i.previousSibling;
            g.node.isBlock(s) ? (m(t).find(g.html.blockTagsQuery()).not("ol, ul, table").each(function () {
              this.parentNode === t && m(this).replaceWith(m(this).html() + (g.node.isEmpty(this) ? "" : "<br>"))
            }), m(s).append(m(t).html())) : m(i).before(m(t).html())
          } else {
            var l = g.html.defaultTag();
            l && 0 === m(t).find(g.html.blockTagsQuery()).length ? m(i).before("<".concat(l, ">").concat(m(t).html(), "</").concat(l, ">")) : m(i).before(m(t).html())
          }
          m(t).remove(), g.html.wrap(), 0 === m(i).find("li").length && m(i).remove()
        }
      }, _del: function f(e) {
        var t, n = v(e), r = n.nextSibling;
        if (r) {
          (t = g.node.contents(r)).length && "BR" === t[0].tagName && m(t[0]).remove(), m(r).find(g.html.blockTagsQuery()).not("ol, ul, table").each(function () {
            this.parentNode === r && m(this).replaceWith(m(this).html() + (g.node.isEmpty(this) ? "" : "<br>"))
          });
          for (var a, o = e, i = g.node.contents(r)[0]; i && !g.node.isList(i);) a = i.nextSibling, m(o).after(i), o = i, i = a;
          for (; i;) a = i.nextSibling, m(n).append(i), i = a;
          m(e).replaceWith(xt.MARKERS), m(r).remove()
        } else {
          for (var s = n; !s.nextSibling && s !== g.el;) s = s.parentNode;
          if (s === g.el) return !1;
          if (s = s.nextSibling, g.node.isBlock(s)) xt.NO_DELETE_TAGS.indexOf(s.tagName) < 0 && (m(e).replaceWith(xt.MARKERS), (t = g.node.contents(n)).length && "BR" === t[t.length - 1].tagName && m(t[t.length - 1]).remove(), m(n).append(m(s).html()), m(s).remove()); else {
            for ((t = g.node.contents(n)).length && "BR" === t[t.length - 1].tagName && m(t[t.length - 1]).remove(), m(e).replaceWith(xt.MARKERS); s && !g.node.isBlock(s) && "BR" !== s.tagName;) m(n).append(m(s)), s = s.nextSibling;
            m(s).remove()
          }
        }
      }
    }
  }, xt.NO_DELETE_TAGS = ["TH", "TD", "TR", "TABLE", "FORM"], xt.SIMPLE_ENTER_TAGS = ["TH", "TD", "LI", "DL", "DT", "FORM"], xt.MODULES.cursor = function (h) {
    var g = h.$;

    function d(e) {
      return !!e && (!!h.node.isBlock(e) || (e.nextSibling && e.nextSibling.nodeType === Node.TEXT_NODE && 0 === e.nextSibling.textContent.replace(/\u200b/g, "").length ? d(e.nextSibling) : !(e.nextSibling && (!e.previousSibling || "BR" !== e.nextSibling.tagName || e.nextSibling.nextSibling)) && d(e.parentNode)))
    }

    function f(e) {
      return !!e && (!!h.node.isBlock(e) || (e.previousSibling && e.previousSibling.nodeType === Node.TEXT_NODE && 0 === e.previousSibling.textContent.replace(/\u200b/g, "").length ? f(e.previousSibling) : !e.previousSibling && (!(e.previousSibling || !h.node.hasClass(e.parentNode, "fr-inner")) || f(e.parentNode))))
    }

    function u(e, t) {
      return !!e && (e !== h.$wp.get(0) && (e.previousSibling && e.previousSibling.nodeType === Node.TEXT_NODE && 0 === e.previousSibling.textContent.replace(/\u200b/g, "").length ? u(e.previousSibling, t) : !e.previousSibling && (e.parentNode === t || u(e.parentNode, t))))
    }

    function m(e, t) {
      return !!e && (e !== h.$wp.get(0) && (e.nextSibling && e.nextSibling.nodeType === Node.TEXT_NODE && 0 === e.nextSibling.textContent.replace(/\u200b/g, "").length ? m(e.nextSibling, t) : !(e.nextSibling && (!e.previousSibling || "BR" !== e.nextSibling.tagName || e.nextSibling.nextSibling)) && (e.parentNode === t || m(e.parentNode, t))))
    }

    function p(e) {
      return 0 < g(e).parentsUntil(h.$el, "LI").length && 0 === g(e).parentsUntil("LI", "TABLE").length
    }

    function v(e, t) {
      var n = new RegExp("".concat(t ? "^" : "", "(([\\uD83C-\\uDBFF\\uDC00-\\uDFFF]+\\u200D)*[\\uD83C-\\uDBFF\\uDC00-\\uDFFF]{2})").concat(t ? "" : "$"), "i"),
        r = e.match(n);
      return r ? r[0].length : 1
    }

    function b(e) {
      for (var t, n = e; !n.previousSibling;) if (n = n.parentNode, h.node.isElement(n)) return !1;
      n = n.previousSibling;
      var r = h.opts.htmlAllowedEmptyTags, a = n.tagName && n.tagName.toLowerCase();
      if ((!h.node.isBlock(n) || n.lastChild && a && 0 <= r.indexOf(a)) && h.node.isEditable(n)) {
        for (t = h.node.contents(n); n.nodeType !== Node.TEXT_NODE && !h.node.isDeletable(n) && t.length && h.node.isEditable(n);) n = t[t.length - 1], t = h.node.contents(n);
        if (n.nodeType === Node.TEXT_NODE) {
          var o = n.textContent, i = o.length;
          if (o.length && "\n" === o[o.length - 1]) return n.textContent = o.substring(0, i - 2), 0 === n.textContent.length && n.parentNode.removeChild(n), b(e);
          if (h.opts.tabSpaces && o.length >= h.opts.tabSpaces) 0 === o.substr(o.length - h.opts.tabSpaces, o.length - 1).replace(/ /g, "").replace(new RegExp(xt.UNICODE_NBSP, "g"), "").length && (i = o.length - h.opts.tabSpaces + 1);
          n.textContent = o.substring(0, i - v(o)), h.opts.trackChangesEnabled && 0 === n.textContent.length && g(n.parentElement).data("tracking") && 0 === g(n.parentElement).find("[data-tracking-deleted=true]").length && (g(e).insertBefore(n.parentElement), g(n.parentElement).remove(), n = g(e)[0].previousSibling), h.opts.htmlUntouched && !e.nextSibling && n.textContent.length && " " === n.textContent[n.textContent.length - 1] && (n.textContent = n.textContent.substring(0, n.textContent.length - 1) + xt.UNICODE_NBSP);
          var s = o.length !== n.textContent.length;
          if (0 === n.textContent.length && n.previousSibling && "BR" === n.previousSibling.tagName && n.previousSibling.remove(), 0 === n.textContent.length) if (s && h.opts.keepFormatOnDelete) g(n).after(xt.INVISIBLE_SPACE + xt.MARKERS); else if (0 !== o.length && h.node.isBlock(n.parentNode)) g(n).after(xt.MARKERS); else if ((2 != n.parentNode.childNodes.length || n.parentNode != e.parentNode) && 1 != n.parentNode.childNodes.length || h.node.isBlock(n.parentNode) || h.node.isElement(n.parentNode) || !h.node.isDeletable(n.parentNode)) {
            for (var l, c = n; !h.node.isElement(n.parentNode) && h.node.isEmpty(n.parentNode) && xt.NO_DELETE_TAGS.indexOf(n.parentNode.tagName) < 0;) if ("A" === (n = n.parentNode).tagName) {
              var d = n.childNodes[0];
              for (g(n).before(d), l = !0; 0 < d.childNodes.length;) d = d.childNodes[0];
              n.parentNode.removeChild(n), n = d;
              break
            }
            l || (n = c), g(n).after(xt.MARKERS), h.node.isElement(n.parentNode) && !e.nextSibling && n.previousSibling && "BR" === n.previousSibling.tagName && g(e).after("<br>");
            var f = n.parentNode;
            n.parentNode.removeChild(n), h.node.isEmpty(f) && g(f).html(xt.INVISIBLE_SPACE + xt.MARKERS)
          } else g(n.parentNode).after(xt.MARKERS), g(n.parentNode).remove(); else g(n).after(xt.MARKERS)
        } else h.node.isDeletable(n) ? (g(n).after(xt.MARKERS), g(n).remove()) : e.nextSibling && "BR" === e.nextSibling.tagName && h.node.isVoid(n) && "BR" !== n.tagName ? (g(e.nextSibling).remove(), g(e).replaceWith(xt.MARKERS)) : !1 !== h.events.trigger("node.remove", [g(n)]) && (g(n).after(xt.MARKERS), g(n).remove())
      } else if (xt.NO_DELETE_TAGS.indexOf(n.tagName) < 0 && (h.node.isEditable(n) || h.node.isDeletable(n))) if (h.node.isDeletable(n)) g(e).replaceWith(xt.MARKERS), g(n).remove(); else if (h.node.isEmpty(n) && !h.node.isList(n)) g(n).remove(), g(e).replaceWith(xt.MARKERS); else {
        for (h.node.isList(n) && (n = g(n).find("li").last().get(0)), (t = h.node.contents(n)) && "BR" === t[t.length - 1].tagName && g(t[t.length - 1]).remove(), t = h.node.contents(n); t && h.node.isBlock(t[t.length - 1]);) n = t[t.length - 1], t = h.node.contents(n);
        g(n).append(xt.MARKERS);
        for (var p = e; !p.previousSibling;) p = p.parentNode;
        for (; p && "BR" !== p.tagName && !h.node.isBlock(p);) {
          var u = p;
          p = p.nextSibling, g(n).append(u)
        }
        p && "BR" === p.tagName && g(p).remove(), g(e).remove()
      } else e.nextSibling && "BR" === e.nextSibling.tagName && g(e.nextSibling).remove();
      return !0
    }

    function o(e) {
      var t = 0 < g(e).parentsUntil(h.$el, "BLOCKQUOTE").length, n = h.node.deepestParent(e, [], !t);
      if (n && "BLOCKQUOTE" === n.tagName) {
        var r = h.node.deepestParent(e, [g(e).parentsUntil(h.$el, "BLOCKQUOTE").get(0)]);
        r && r.nextSibling && (n = r)
      }
      if (null !== n) {
        var a, o = n.nextSibling;
        if (h.node.isBlock(n) && (h.node.isEditable(n) || h.node.isDeletable(n)) && o && xt.NO_DELETE_TAGS.indexOf(o.tagName) < 0) if (h.node.isDeletable(o)) g(o).remove(), g(e).replaceWith(xt.MARKERS); else if (h.node.isBlock(o) && h.node.isEditable(o)) if (h.node.isList(o)) if (h.node.isEmpty(n, !0)) g(n).remove(), g(o).find("li").first().prepend(xt.MARKERS); else {
          var i = g(o).find("li").first();
          "BLOCKQUOTE" === n.tagName && (a = h.node.contents(n)).length && h.node.isBlock(a[a.length - 1]) && (n = a[a.length - 1]), 0 === i.find("ul, ol").length && (g(e).replaceWith(xt.MARKERS), i.find(h.html.blockTagsQuery()).not("ol, ul, table").each(function () {
            this.parentNode === i.get(0) && g(this).replaceWith(g(this).html() + (h.node.isEmpty(this) ? "" : "<br>"))
          }), g(n).append(h.node.contents(i.get(0))), i.remove(), 0 === g(o).find("li").length && g(o).remove())
        } else {
          if ((a = h.node.contents(o)).length && "BR" === a[0].tagName && g(a[0]).remove(), "BLOCKQUOTE" !== o.tagName && "BLOCKQUOTE" === n.tagName) for (a = h.node.contents(n); a.length && h.node.isBlock(a[a.length - 1]);) n = a[a.length - 1], a = h.node.contents(n); else if ("BLOCKQUOTE" === o.tagName && "BLOCKQUOTE" !== n.tagName) for (a = h.node.contents(o); a.length && h.node.isBlock(a[0]);) o = a[0], a = h.node.contents(o);
          g(e).replaceWith(xt.MARKERS), g(n).append(o.innerHTML), g(o).remove()
        } else {
          for (g(e).replaceWith(xt.MARKERS); o && "BR" !== o.tagName && !h.node.isBlock(o) && h.node.isEditable(o);) {
            var s = o;
            o = o.nextSibling, g(n).append(s)
          }
          o && "BR" === o.tagName && h.node.isEditable(o) && g(o).remove()
        }
      }
    }

    function n(e) {
      for (var t, n = e; !n.nextSibling;) if (n = n.parentNode, h.node.isElement(n)) return !1;
      if ("BR" === (n = n.nextSibling).tagName && h.node.isEditable(n)) if (n.nextSibling) {
        if (h.node.isBlock(n.nextSibling) && h.node.isEditable(n.nextSibling)) {
          if (!(xt.NO_DELETE_TAGS.indexOf(n.nextSibling.tagName) < 0)) return void g(n).remove();
          n = n.nextSibling, g(n.previousSibling).remove()
        }
      } else if (d(n)) {
        if (p(e)) h.cursorLists._del(e); else h.node.deepestParent(n) && ((!h.node.isEmpty(h.node.blockParent(n)) || (h.node.blockParent(n).nextSibling && xt.NO_DELETE_TAGS.indexOf(h.node.blockParent(n).nextSibling.tagName)) < 0) && g(n).remove(), o(e));
        return
      }
      if (!h.node.isBlock(n) && h.node.isEditable(n)) {
        for (t = h.node.contents(n); n.nodeType !== Node.TEXT_NODE && t.length && !h.node.isDeletable(n) && h.node.isEditable(n);) n = t[0], t = h.node.contents(n);
        n.nodeType === Node.TEXT_NODE ? (g(n).before(xt.MARKERS), n.textContent.length && (n.textContent = n.textContent.substring(v(n.textContent, !0), n.textContent.length))) : h.node.isDeletable(n) ? (g(n).before(xt.MARKERS), g(n).remove()) : !1 !== h.events.trigger("node.remove", [g(n)]) && (g(n).before(xt.MARKERS), g(n).remove()), g(e).remove()
      } else if (xt.NO_DELETE_TAGS.indexOf(n.tagName) < 0 && (h.node.isEditable(n) || h.node.isDeletable(n))) if (h.node.isDeletable(n)) g(e).replaceWith(xt.MARKERS), g(n).remove(); else if (h.node.isList(n)) e.previousSibling ? (g(n).find("li").first().prepend(e), h.cursorLists._backspace(e)) : (g(n).find("li").first().prepend(xt.MARKERS), g(e).remove()); else if ((t = h.node.contents(n)) && "BR" === t[0].tagName && g(t[0]).remove(), t && "BLOCKQUOTE" === n.tagName) {
        var r = t[0];
        for (g(e).before(xt.MARKERS); r && "BR" !== r.tagName;) {
          var a = r;
          r = r.nextSibling, g(e).before(a)
        }
        r && "BR" === r.tagName && g(r).remove()
      } else g(e).after(g(n).html()).after(xt.MARKERS), g(n).remove()
    }

    function i() {
      for (var e = h.el.querySelectorAll("blockquote:empty"), t = 0; t < e.length; t++) e[t].parentNode.removeChild(e[t])
    }

    function C(e, t, n) {
      var r, a = h.node.deepestParent(e, [], !n);
      if (a && "BLOCKQUOTE" === a.tagName) return m(e, a) ? (r = h.html.defaultTag(), t ? g(e).replaceWith("<br>" + xt.MARKERS) : r ? g(a).after("<".concat(r, ">").concat(xt.MARKERS, "<br></").concat(r, ">")) : g(a).after("".concat(xt.MARKERS, "<br>")), g(e).remove()) : E(e, t, n), !1;
      if (null === a) (r = h.html.defaultTag()) && h.node.isElement(e.parentNode) ? g(e).replaceWith("<".concat(r, ">").concat(xt.MARKERS, "<br></").concat(r, ">")) : !e.previousSibling || g(e.previousSibling).is("br") || e.nextSibling ? g(e).replaceWith("<br>".concat(xt.MARKERS)) : g(e).replaceWith("<br>".concat(xt.MARKERS, "<br>")); else {
        var o = e, i = "";
        "PRE" != a.tagName || e.nextSibling || (t = !0), h.node.isBlock(a) && !t || (i = "<br/>");
        var s, l = "", c = "", d = "", f = "";
        (r = h.html.defaultTag()) && h.node.isBlock(a) && (d = "<".concat(r, ">"), f = "</".concat(r, ">"), a.tagName === r.toUpperCase() && (d = h.node.openTagString(g(a).clone().removeAttr("id").get(0))));
        do {
          if (o = o.parentNode, !t || o !== a || t && !h.node.isBlock(a)) if (l += h.node.closeTagString(o), o === a && h.node.isBlock(a)) c = d + c; else {
            var p = ("A" === o.tagName || h.node.hasClass(o, "fa")) && m(e, o) ? "fr-to-remove" : "";
            c = "isPasted" === o.getAttribute("id") ? h.node.openTagString(g(o).clone().attr("style", "").addClass(p).get(0)) + c : h.node.openTagString(g(o).clone().addClass(p).get(0)) + c
          }
        } while (o !== a);
        i = l + i + c + (e.parentNode === a && h.node.isBlock(a) ? "" : xt.INVISIBLE_SPACE) + xt.MARKERS, h.node.isBlock(a) && !g(a).find("*").last().is("br") && g(a).append("<br/>"), g(e).after('<span id="fr-break"></span>'), g(e).remove(), a.nextSibling && !h.node.isBlock(a.nextSibling) || h.node.isBlock(a) || g(a).after("<br>"), s = (s = !t && h.node.isBlock(a) ? h.node.openTagString(a) + g(a).html() + f : h.node.openTagString(a) + g(a).html() + h.node.closeTagString(a)).replace(/<span id="fr-break"><\/span>/g, i), g(a).replaceWith(s)
      }
    }

    function E(e, t, n) {
      var r = h.node.deepestParent(e, [], !n);
      if (null === r) h.html.defaultTag() && e.parentNode === h.el ? g(e).replaceWith("<".concat(h.html.defaultTag(), ">").concat(xt.MARKERS, "<br></").concat(h.html.defaultTag(), ">")) : (e.nextSibling && !h.node.isBlock(e.nextSibling) || g(e).after("<br>"), g(e).replaceWith("<br>".concat(xt.MARKERS))); else if (e.previousSibling && "IMG" == e.previousSibling.tagName || e.nextSibling && "IMG" == e.nextSibling.tagName) g(e).replaceWith("<" + h.html.defaultTag() + ">" + xt.MARKERS + "<br></" + h.html.defaultTag() + ">"); else {
        var a = e, o = "";
        "PRE" === r.tagName && (t = !0), h.node.isBlock(r) && !t || (o = "<br>");
        var i = "", s = "";
        do {
          var l = a;
          if (a = a.parentNode, "BLOCKQUOTE" === r.tagName && h.node.isEmpty(l) && !h.node.hasClass(l, "fr-marker") && g(l).contains(e) && g(l).after(e), "BLOCKQUOTE" !== r.tagName || !m(e, a) && !u(e, a)) if (!t || a !== r || t && !h.node.isBlock(r)) {
            i += h.node.closeTagString(a);
            var c = "A" == a.tagName && m(e, a) || h.node.hasClass(a, "fa") ? "fr-to-remove" : "";
            s = h.node.openTagString(g(a).clone().addClass(c).removeAttr("id").get(0)) + s, a === r && "DIV" === r.tagName && (i = "<br>", s = "")
          } else "BLOCKQUOTE" == r.tagName && t && (s = i = "")
        } while (a !== r);
        var d = r === e.parentNode && h.node.isBlock(r) || e.nextSibling;
        if ("BLOCKQUOTE" === r.tagName) if (e.previousSibling && h.node.isBlock(e.previousSibling) && e.nextSibling && "BR" === e.nextSibling.tagName && (g(e.nextSibling).after(e), e.nextSibling && "BR" === e.nextSibling.tagName && g(e.nextSibling).remove()), t) o = i + o + xt.MARKERS + s; else {
          var f = h.html.defaultTag();
          o = "".concat(i + o + (f ? "<".concat(f, ">") : "") + xt.MARKERS, "<br>").concat(f ? "</".concat(f, ">") : "").concat(s)
        } else o = i + o + s + (d ? "" : xt.INVISIBLE_SPACE) + xt.MARKERS;
        g(e).replaceWith('<span id="fr-break"></span>');
        var p = h.node.openTagString(r) + g(r).html() + h.node.closeTagString(r);
        p = p.replace(/<span id="fr-break"><\/span>/g, o), g(r).replaceWith(p)
      }
    }

    return {
      enter: function y(e) {
        var t = h.markers.insert();
        if (!t) return !0;
        for (var n = t.parentNode; n && !h.node.isElement(n);) {
          if ("false" === n.getAttribute("contenteditable")) return g(t).replaceWith(xt.MARKERS), h.selection.restore(), !1;
          if ("true" === n.getAttribute("contenteditable")) break;
          n = n.parentNode
        }
        h.el.normalize();
        var r = !1;
        0 < g(t).parentsUntil(h.$el, "BLOCKQUOTE").length && (r = !0), g(t).parentsUntil(h.$el, "TD, TH").length && (r = !1), d(t) ? !p(t) || e || r ? C(t, e, r) : h.cursorLists._endEnter(t) : f(t) ? !p(t) || e || r ? function l(e, t, n) {
          var r, a = h.node.deepestParent(e, [], !n);
          if (a && "TABLE" === a.tagName) return g(a).find("td, th").first().prepend(e), l(e, t, n);
          if (a && "BLOCKQUOTE" === a.tagName) if (u(e, a)) {
            if (!t) return (r = h.html.defaultTag()) ? g(a).before("<".concat(r, ">").concat(xt.MARKERS, "<br></").concat(r, ">")) : g(a).before("".concat(xt.MARKERS, "<br>")), g(e).remove(), !1
          } else m(e, a) ? C(e, t, !0) : E(e, t, !0);
          if (null === a) (r = h.html.defaultTag()) && h.node.isElement(e.parentNode) ? g(e).replaceWith("<".concat(r, ">").concat(xt.MARKERS, "<br></").concat(r, ">")) : g(e).replaceWith("<br>".concat(xt.MARKERS)); else {
            if (r = h.html.defaultTag(), h.node.isBlock(a)) if ("PRE" === a.tagName && (t = !0), t) g(e).remove(), g(a).prepend("<br>".concat(xt.MARKERS)); else if (e.nextSibling && "IMG" == e.nextSibling.tagName || e.nextSibling && e.nextSibling.nextElementSibling && "IMG" == e.nextSibling.nextElementSibling) g(e).replaceWith("<" + h.html.defaultTag() + ">" + xt.MARKERS + "<br></" + h.html.defaultTag() + ">"); else {
              if (h.node.isEmpty(a, !0)) return C(e, t, n);
              if (h.opts.keepFormatOnDelete || "DIV" === a.tagName || "div" === h.html.defaultTag()) if (!h.opts.keepFormatOnDelete && "DIV" === a.tagName || "div" === h.html.defaultTag()) g(a).before("<" + h.html.defaultTag() + "><br></" + h.html.defaultTag() + ">"); else {
                for (var o = e, i = xt.INVISIBLE_SPACE; o !== a && !h.node.isElement(o);) o = o.parentNode, i = h.node.openTagString(o) + i + h.node.closeTagString(o);
                g(a).before(i)
              } else g(a).before("".concat(h.node.openTagString(g(a).clone().removeAttr("id").get(0)), "<br>").concat(h.node.closeTagString(a)))
            } else g(a).before("<br>");
            g(e).remove()
          }
        }(t, e, r) : h.cursorLists._startEnter(t) : !p(t) || e || r ? E(t, e, r) : h.cursorLists._middleEnter(t), function c() {
          h.$el.find(".fr-to-remove").each(function () {
            for (var e = h.node.contents(this), t = 0; t < e.length; t++) e[t].nodeType === Node.TEXT_NODE && (e[t].textContent = e[t].textContent.replace(/\u200B/g, ""));
            g(this).replaceWith(this.innerHTML)
          })
        }(), h.html.fillEmptyBlocks(!0), h.opts.htmlUntouched || (h.html.cleanEmptyTags(), h.clean.lists(), h.spaces.normalizeAroundCursor()), h.selection.restore();
        var a = h.o_win.innerHeight;
        if (h.$oel[0].offsetHeight > a) {
          var o = h.helpers.scrollTop(), i = h.selection.blocks();
          if (i && 0 < i.length && i[0].offsetTop) {
            var s = i[0].offsetTop;
            a - 100 < s - o ? h.o_win.scroll(0, s - a + 120) : s - o < 0 && h.o_win.scroll(0, s - 20)
          }
        }
      }, backspace: function s() {
        var e = !1, t = h.markers.insert();
        if (!t) return !0;
        for (var n = t.parentNode; n && !h.node.isElement(n);) {
          if ("false" === n.getAttribute("contenteditable")) return g(t).replaceWith(xt.MARKERS), h.selection.restore(), !1;
          if (n.innerText.length && "true" === n.getAttribute("contenteditable")) break;
          n = n.parentNode
        }
        h.el.normalize();
        var r = t.previousSibling;
        if (r) {
          var a = r.textContent;
          a && a.length && 8203 === a.charCodeAt(a.length - 1) && 1 !== a.length && (r.textContent = r.textContent.substr(0, a.length - v(a)))
        }
        return d(t) ? p(t) && u(t, g(t).parents("li").first().get(0)) ? h.cursorLists._backspace(t) : e = b(t) : f(t) ? p(t) && u(t, g(t).parents("li").first().get(0)) ? h.cursorLists._backspace(t) : function c(e) {
          for (var t = 0 < g(e).parentsUntil(h.$el, "BLOCKQUOTE").length, n = h.node.deepestParent(e, [], !t), r = n; n && !n.previousSibling && "BLOCKQUOTE" !== n.tagName && n.parentElement !== h.el && !h.node.hasClass(n.parentElement, "fr-inner") && xt.SIMPLE_ENTER_TAGS.indexOf(n.parentElement.tagName) < 0;) n = n.parentElement;
          if (n && "BLOCKQUOTE" === n.tagName) {
            var a = h.node.deepestParent(e, [g(e).parentsUntil(h.$el, "BLOCKQUOTE").get(0)]);
            a && a.previousSibling && (r = n = a)
          }
          if (null !== n) {
            var o, i = n.previousSibling;
            if (h.node.isBlock(n) && h.node.isEditable(n)) if (i && xt.NO_DELETE_TAGS.indexOf(i.tagName) < 0) {
              if (h.node.isDeletable(i)) g(i).remove(), g(e).replaceWith(xt.MARKERS); else if (h.node.isEditable(i)) if (h.node.isBlock(i)) if (h.node.isEmpty(i) && !h.node.isList(i)) g(i).remove(), g(e).after(h.opts.keepFormatOnDelete ? xt.INVISIBLE_SPACE : ""); else {
                if (h.node.isList(i) && (i = g(i).find("li").last().get(0)), (o = h.node.contents(i)).length && "BR" === o[o.length - 1].tagName && g(o[o.length - 1]).remove(), "BLOCKQUOTE" === i.tagName && "BLOCKQUOTE" !== n.tagName) for (o = h.node.contents(i); o.length && h.node.isBlock(o[o.length - 1]);) i = o[o.length - 1], o = h.node.contents(i); else if ("BLOCKQUOTE" !== i.tagName && "BLOCKQUOTE" === r.tagName) for (o = h.node.contents(r); o.length && h.node.isBlock(o[0]);) r = o[0], o = h.node.contents(r);
                if (h.node.isEmpty(n)) g(e).remove(), h.selection.setAtEnd(i, !0); else {
                  g(e).replaceWith(xt.MARKERS);
                  var s = i.childNodes;
                  h.node.isBlock(s[s.length - 1]) ? g(s[s.length - 1]).append(r.innerHTML) : g(i).append(r.innerHTML)
                }
                g(r).remove(), h.node.isEmpty(n) && g(n).remove()
              } else g(e).replaceWith(xt.MARKERS), "BLOCKQUOTE" === n.tagName && i.nodeType === Node.ELEMENT_NODE ? g(i).remove() : (g(i).after(h.node.isEmpty(n) ? "" : g(n).html()), g(n).remove(), "BR" === i.tagName && g(i).remove())
            } else if (!i) if (n && "BLOCKQUOTE" === n.tagName && 0 === g(n).text().replace(/\u200B/g, "").length) g(n).remove(); else {
              var l = n.nextSibling;
              h.node.isEmpty(n) && n.parentNode && h.node.isEditable(n.parentNode) && !l && n.parentNode != h.el && g(n.parentNode).remove()
            }
          }
        }(t) : e = b(t), g(t).remove(), i(), h.html.fillEmptyBlocks(!0), h.opts.htmlUntouched || (h.html.cleanEmptyTags(), h.clean.lists(), h.spaces.normalizeAroundCursor()), h.selection.restore(), e
      }, del: function r() {
        var e = h.markers.insert();
        if (!e) return !1;
        if (h.el.normalize(), d(e)) if (p(e)) if (0 === g(e).parents("li").first().find("ul, ol").length) h.cursorLists._del(e); else {
          var t = g(e).parents("li").first().find("ul, ol").first().find("li").first();
          (t = t.find(h.html.blockTagsQuery()).get(-1) || t).prepend(e), h.cursorLists._backspace(e)
        } else o(e); else f(e), n(e);
        g(e).remove(), i(), h.html.fillEmptyBlocks(!0), h.opts.htmlUntouched || (h.html.cleanEmptyTags(), h.clean.lists()), h.spaces.normalizeAroundCursor(), h.selection.restore()
      }, isAtEnd: m, isAtStart: u
    }
  }, xt.MODULES.data = function (f) {
    function p(e) {
      return e
    }

    function c(e) {
      for (var t = e.toString(), n = 0, r = 0; r < t.length; r++) n += parseInt(t.charAt(r), 10);
      return 10 < n ? n % 9 + 1 : n
    }

    function d(e, t, n) {
      for (var r = Math.abs(n); 0 < r--;) e -= t;
      return n < 0 && (e += 123), e
    }

    function u(e) {
      return e && "block" !== e.css("display") ? (e.remove(), !0) : e && 0 === f.helpers.getPX(e.css("height")) ? (e.remove(), !0) : !(!e || "absolute" !== e.css("position") && "fixed" !== e.css("position") || (e.remove(), 0))
    }

    function h(e) {
      return e && 0 === f.$box.find(e).length
    }

    function g() {
      if (10 < e && (f[p(T("0ppecjvc=="))](), setTimeout(function () {
        E.FE = null
      }, 10)), !f.$box) return !1;
      f.$wp.prepend(T(p(T(w)))), b = f.$wp.find("> div").first(), C = b.find("> a"), "rtl" === f.opts.direction && b.css("left", "auto").css("right", 0).attr("direction", "rtl"), e++
    }

    function m(e) {
      for (var t = [T("9qqG-7amjlwq=="), T("KA3B3C2A6D1D5H5H1A3=="), T("3B9B3B5F3C4G3E3=="), T("QzbzvxyB2yA-9m=="), T("ji1kacwmgG5bc=="), T("nmA-13aogi1A3c1jd=="), T("BA9ggq=="), T("emznbjbH3fij=="), T("tkC-22d1qC-13sD1wzF-7=="), T("tA3jjf=="), T("1D1brkm==")], n = 0; n < t.length; n++) if (String.prototype.endsWith || (String.prototype.endsWith = function (e, t) {
        return (void 0 === t || t > this.length) && (t = this.length), this.substring(t - e.length, t) === e
      }), e.endsWith(t[n])) return !0;
      return !1
    }

    function v() {
      var e = T(p(n)), t = T(p("tzgatD-13eD1dtdrvmF3c1nrC-7saQcdav==")).split(".");
      try {
        return window.parent.document.querySelector(e) && window[t[1]][t[2]]
      } catch (e) {
        return !1
      }
    }

    var b, C, E = f.$,
      y = "sC-7OB2fwhVC4vsG-7ohPA4ZD4D-8f1J3stzB-11bFE2FC1A3NB2IF1HE1TH4WB8eB-11zVG2F3I3yYB5ZG4CB2DA15CC5AD3F1A1KG1oLA10B1A6wQF1H3vgale2C4F4XA2qc2A5D5B3pepmriKB3OE1HD1fUC10pjD-11E-11TB4YJ3bC-16zE-11yc1B2CE2BC3jhjKC1pdA-21OA6C1D5B-8vF4QA11pD6sqf1C3lldA-16BD4A2H3qoEA7bB-16rmNH5H1F1vSB7RE2A3TH4YC5A5b1A4d1B3whepyAC3AA2zknC3mbgf1SC4WH4PD8TC5ZB2C3H3jb2A5ZA2EF2aoFC5qqHC4B1H1zeGA7UA5RF4TA29TA6ZC4d1C3hyWA10A3rBB2E3decorationRD3QC10UD3E6E6ZD2F3F3fme2E5uxxrEC9C3E4fB-11azhHB1LD7D6VF4VVTPC6b1C4TYG3qzDD6B3B3AH4I2H2kxbHE1JD1yihfd1QD6WB1D4mhrc1B5rvFG3A14A7cDA2OC1AA1JB5zC-16KA6WB4C-8wvlTB5A5lkZB2C2C7zynBD2D2bI-7C-21d1HE2cubyvPC8A6VB3aroxxZE4C4F4e1I2BE1WjdifH1H4A14NA1GB1YG-10tWA3A14A9sVA2C5XH2A29b2A6gsleGG2jaED2D-13fhE1OA8NjwytyTD4e1sc1D-16ZC3B5C-9e1C2FB6EFF5B2C2JH4E1C2tdLE5A3UG4G-7b2D3B4fA-9oh1G3kqvB4AG3ibnjcAC6D2B1cDA9KC2QA6bRC4VA30RB8hYB2A4A-8h1A21A2B2==",
      L = "7D4YH4fkhHB3pqDC3H2E1fkMD1IB1NF1D3QD9wB5rxqlh1A8c2B4ZA3FD2AA6FB5EB3jJG4D2J-7aC-21GB6PC5RE4TC11QD6XC4XE3XH3mlvnqjbaOA2OC2BE6A1fmI-7ujwbc1G5f1F3e1C11mXF4owBG3E1yD1E4F1D2D-8B-8C-7yC-22HD1MF5UE4cWA3D8D6a1B2C3H3a3I3sZA4B3A2akfwEB3xHD5D1F1wIC11pA-16xdxtVI2C9A6YC4a1A2F3B2GA6B4C3lsjyJB1eMA1D-11MF5PE4ja1D3D7byrf1C3e1C7D-16lwqAF3H2A1B-21wNE1MA1OG1HB2A-16tSE5UD4RB3icRA4F-10wtwzBB3E1C3CC2DA8LA2LA1EB1kdH-8uVB7decorg1J2B7B6qjrqGI2J1C6ijehIB1hkemC-13hqkrH4H-7QD6XF5XF3HLNAC3CB2aD2CD2KB10B4ycg1A-8KA4H4B11jVB5TC4yqpB-21pd1E4pedzGB6MD5B3ncB-7MA4LD2JB6PD5uH-8TB9C7YD5XD2E3I3jmiDB3zeimhLD8E2F2JC1H-9ivkPC5lG-10SB1D3H3A-21rc1A3d1E3fsdqwfGA2KA1OrC-22LA6D1B4afUB16SC7AitC-8qYA11fsxcajGA15avjNE2A-9h1hDB16B9tPC1C5F5UC1G3B8d2A5d1D4RnHJ3C3JB5D3ucMG1yzD-17hafjC-8VD3yWC6e1YD2H3ZE2C8C5oBA3H3D2vFA4WzJC4C2i1A-65fNB8afWA1H4A26mvkC-13ZB3E3h1A21BC4eFB2GD2AA5ghqND2A2B2==",
      n = "MekC-11nB-8tIzpD7pewxvzC6mD-16xerg1==", _ = "lC4B3A3B2B5A1C2E4G1A2==",
      w = "sC-7OB2fwhVC4vsG-7ohPA4ZD4D-8f1J3stzB-11bFE2EE1MA2ND1KD1IE4cA-21pSD2D5ve1G3h1A8b1E5ZC3CD2FA16mC5OC5E1hpnG1NA10B1D7hkUD4I-7b2C3C5nXD2E3F3whidEC2EH3GI2mJE2E2bxci1WA10VC7pllSG2F3A7xd1A4ZC3DB2aaeGA2DE4H2E1j1ywD-13FD1A3VE4WA3D8C6wuc1A2hf1B5B7vnrrjA1B9ic1mpbD1oMB1iSB7rWC4RI4G-7upB6jd1A2F3H2EA4FD3kDF4A2moc1anJD1TD4VI4b2C7oeQF4c1E3XC7ZA3C3G3uDB2wGB6D1JC4D1JD4C1hTE6QC5pH4pD3C-22D7c1A3textAA4gdlB2mpozkmhNC1mrxA3yWA5edhg1I2H3B7ozgmvAI3I2B5GD1LD2RSNH1KA1XA5SB4PA3sA9tlmC-9tnf1G3nd1coBH4I2I2JC3C-16LE6A1tnUA3vbwQB1G3f1A20a3A8a1C6pxAB2eniuE1F3kH2lnjB2hB-16XA5PF1G4zwtYA5B-11mzTG2B9pHB3BE2hGH3B3B2cMD5C1F1wzPA8E7VG5H5vD3H-7C8tyvsVF2I1G2A5fE3bg1mgajoyxMA4fhuzSD8aQB2B4g1A20ukb1A4B3F3GG2CujjanIC1ObiB11SD1C5pWC1D4YB8YE5FE-11jXE2F-7jB4CC2G-10uLH4E1C2tA-13yjUH5d1H1A7sWD5E4hmjF-7pykafoGA16hDD4joyD-8OA33B3C2tC7cRE4SA31a1B8d1e2A4F4g1A2A22CC5zwlAC2C1A12==",
      A = function () {
        for (var e = 0, t = document.domain, n = t.split("."), r = "_gd".concat((new Date).getTime()); e < n.length - 1 && -1 === document.cookie.indexOf("".concat(r, "=").concat(r));) t = n.slice(-1 - ++e).join("."), document.cookie = "".concat(r, "=").concat(r, ";domain=").concat(t, ";");
        return document.cookie = "".concat(r, "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=").concat(t, ";"), (t || "").replace(/(^\.*)|(\.*$)/g, "")
      }(), T = p(function S(e) {
        if (!e) return e;
        for (var t = "", n = p("charCodeAt"), r = p("fromCharCode"), a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".indexOf(e[0]), o = 1; o < e.length - 2; o++) {
          for (var i = c(++a), s = e[n](o), l = ""; /[0-9-]/.test(e[o + 1]);) l += e[++o];
          s = d(s, i, l = parseInt(l, 10) || 0), s ^= a - 1 & 31, t += String[r](s)
        }
        return t
      }), e = 0;
    return {
      _init: function k() {
        var e = f.opts.key || [""],
          t = T(p("ziRA1E3B9pA5B-11D-11xg1A3ZB5D1D4B-11ED2EG2pdeoC1clIH4wB-22yQD5uF4YE3E3A9=="));
        "string" == typeof e && (e = [e]);
        for (var n, r, a, o = !(f.ul = !0), i = 0, s = 0; s < e.length; s++) {
          var l = (r = e[s], 4 === (a = (T(r) || "").split("|")).length && "V3" === a[0] ? [a[1], a[3], a[2]] : [null, null, ""]),
            c = l[2];
          if (c === T(p(T("LGnD1KNZf1CPBYCAZB-8F3UDSLLSG1VFf1A3C2=="))) || 0 <= c.indexOf(A, c.length - A.length) || m(A) || v()) {
            if (null !== (n = l[1]) && !(0 == n.indexOf("TRIAL") ? (n = new Date(n.replace(/TRIAL/, "")), new Date(n) < new Date && (y = L, 1)) : new Date(n) < new Date(T(_))) || !(0 < (A || "").length) || m(A) || v()) {
              f.ul = !1;
              break
            }
            o = !0, w = y, i = l[0] || -1
          }
        }
        var d = new Image;
        !0 === f.ul && (g(), d.src = o ? "".concat(p(T(t)), "e=").concat(i) : "".concat(p(T(t)), "u")), !0 === f.ul && (f.events.on("contentChanged", function () {
          (function e() {
            return u(b) || u(C) || h(b) || h(C)
          })() && g()
        }), f.events.on("html.get", function (e) {
          return e + T("qD2H-9G3ioD-17qA1tE1B-8qI3A4hA-13C-11E2C1njfldD1E6pg1C-8sC3hfbkcD2G3stC-22gqgB3G2B-7vtoA4nweeD1A31A15B9uC-16A1F5dkykdc1B8dE-11bA3F2D3A9gd1E7F2tlI-8H-7vtxB2A5B2C3B2F2B5A6ldbyC4iqC-22D-17E-13mA3D2dywiB3oxlvfC1H4C2TjqbzlnI3ntB4E3qA2zaqsC6D3pmnkoE3C6D5wvuE3bwifdhB6hch1E4xibD-17dmrC1rG-7pntnF6nB-8F1D2A11C8plrkmF2F3MC-16bocqA2WwA-21ayeA1C4d1isC-22rD-13D6DfjpjtC2E6hB2G2G4A-7D2==")
        })), f.events.on("html.set", function () {
          var e = f.el.querySelector('[data-f-id="pbf"]');
          e && E(e).remove()
        }), f.events.on("destroy", function () {
          b && b.length && b.remove()
        }, !0)
      }
    }
  }, xt.MODULES.edit = function (t) {
    function e() {
      if (t.browser.mozilla) try {
        t.doc.execCommand("enableObjectResizing", !1, "false"), t.doc.execCommand("enableInlineTableEditing", !1, "false")
      } catch (e) {
      }
      if (t.browser.msie) try {
        t.doc.body.addEventListener("mscontrolselect", function (e) {
          return e.srcElement.focus(), !1
        })
      } catch (e) {
      }
    }

    var n = !1;

    function r() {
      return n
    }

    return {
      _init: function a() {
        t.events.on("focus", function () {
          r() ? t.edit.off() : t.edit.on()
        })
      }, on: function o() {
        t.$wp ? (t.$el.attr("contenteditable", !0), t.$el.removeClass("fr-disabled").attr("aria-disabled", !1), e()) : t.$el.is("a") && t.$el.attr("contenteditable", !0), t.events.trigger("edit.on", [], !0), n = !1
      }, off: function i() {
        t.events.disableBlur(), t.$wp ? (t.$el.attr("contenteditable", !1), t.$el.addClass("fr-disabled").attr("aria-disabled", !0)) : t.$el.is("a") && t.$el.attr("contenteditable", !1), t.events.trigger("edit.off"), t.events.enableBlur(), n = !0
      }, disableDesign: e, isDisabled: r
    }
  }, xt.MODULES.format = function (T) {
    var S = T.$;

    function m(e, t) {
      var n = "<".concat(e);
      for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (n += " ".concat(r, '="').concat(t[r], '"'));
      return n += ">"
    }

    function k(e, t) {
      var n = e;
      for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (n += "id" === r ? "#".concat(t[r]) : "class" === r ? ".".concat(t[r]) : "[".concat(r, '="').concat(t[r], '"]'));
      return n
    }

    function x(e, t) {
      return !(!e || e.nodeType !== Node.ELEMENT_NODE) && (e.matches || e.matchesSelector || e.msMatchesSelector || e.mozMatchesSelector || e.webkitMatchesSelector || e.oMatchesSelector).call(e, t)
    }

    function v(e, t, n) {
      var r, a, o, i = {strong: {prop: "font-weight", val: "bold"}, em: {prop: "font-style", val: "italic"}};
      if (e) {
        if (T.node.isBlock(e) && e.hasAttribute("contenteditable") && "false" === e.getAttribute("contenteditable") || e.parentNode && e.parentNode.hasAttribute("contenteditable") && "false" === e.parentNode.getAttribute("contenteditable")) {
          if (e.nextSibling && S(e.nextSibling).hasClass("fr-marker")) return;
          if (e.nextSibling) return void v(e.nextSibling, t, n);
          if (e.parentNode) return void v(e.parentNode, t, n)
        }
        for (; e.nodeType === Node.COMMENT_NODE;) e = e.nextSibling;
        if (e) {
          if (T.node.isBlock(e) && "HR" !== e.tagName) return T.node.hasClass(e.firstChild, "fr-marker") ? v(e.firstChild.nextSibling, t, n) : v(e.firstChild, t, n), !1;
          var s = S(T.doc.createElement(t));
          s.attr(n), s.insertBefore(e), (r = b(e)) && (0 <= ["strong", "em"].indexOf(t) || "span" === t && n.hasOwnProperty("style")) && (o = "span" === t ? (a = (i = n.style.replace(/;$/, "").split(":"))[0].trim(), i[1].trim()) : (a = i[t].prop, i[t].val), "background-color" !== a && (S(r).css(a, o), function g(e, t) {
            var n, r = e.childNodes;
            for (n = 0; n < r.length; n++) 0 <= ["UL", "OL", "LI"].indexOf(r[n].tagName) && "" === r[n].style[t] && S(r[n]).css(t, "initial")
          }(r, a)));
          for (var l = e; l && !S(l).hasClass("fr-marker") && 0 === S(l).find(".fr-marker").length && "UL" !== l.tagName && "OL" !== l.tagName;) {
            var c = l;
            if ("SPAN" === l.tagName && S(l).hasClass("fr-tracking-deleted")) l = l.nextSibling; else {
              if (T.node.isBlock(l) && "HR" !== e.tagName) return v(l.firstChild, t, n), !1;
              if ("SPAN" === l.tagName) return v(l.firstChild, t, n), !1;
              if (l.tagName && l.hasAttribute("contenteditable") && "false" === l.getAttribute("contenteditable")) return void v(l.nextSibling, t, n);
              l = l.nextSibling, s.append(c)
            }
          }
          if (l) {
            if (S(l).find(".fr-marker").length || "UL" === l.tagName || "OL" === l.tagName) v(l.firstChild, t, n); else if (T.browser.mozilla && T.node.hasClass(l, "fr-marker")) {
              var d, f = T.selection.blocks(), p = f.length;
              for (d = 0; d < p; d++) f[d] != l.parentNode && f[d].childNodes.length && f[d].childNodes[0] != l.parentNode && (l = f[d].childNodes[1] || f[d].childNodes[0], (s = S(m(t, n)).insertBefore(l)).append(l))
            }
          } else {
            for (var u = s.get(0).parentNode; u && !u.nextSibling && !T.node.isElement(u);) u = u.parentNode;
            if (u) {
              var h = u.nextSibling;
              h && (T.node.isBlock(h) ? "HR" === h.tagName ? v(h.nextSibling, t, n) : v(h.firstChild, t, n) : v(h, t, n))
            }
          }
          s.is(":empty") && s.remove()
        }
      }
    }

    function n(e, t) {
      var n;
      if (void 0 === t && (t = {}), t.style && delete t.style, T.selection.isCollapsed()) {
        T.markers.insert(), T.$el.find(".fr-marker").replaceWith(m(e, t) + xt.INVISIBLE_SPACE + xt.MARKERS + function i(e) {
          return "</".concat(e, ">")
        }(e)), T.selection.restore()
      } else {
        var r;
        T.selection.save(), v(T.$el.find('.fr-marker[data-type="true"]').length && T.$el.find('.fr-marker[data-type="true"]').get(0).nextSibling, e, t);
        do {
          for (r = T.$el.find("".concat(k(e, t), " > ").concat(k(e, t))), n = 0; n < r.length; n++) r[n].outerHTML = r[n].innerHTML
        } while (r.length);
        T.el.normalize();
        var a = T.el.querySelectorAll(".fr-marker");
        for (n = 0; n < a.length; n++) {
          var o = S(a[n]);
          !0 === o.data("type") ? x(o.get(0).nextSibling, k(e, t)) && o.next().prepend(o) : x(o.get(0).previousSibling, k(e, t)) && o.prev().append(o)
        }
        T.selection.restore()
      }
    }

    function R(e, t, n, r) {
      if (!r) {
        var a = !1;
        if (!0 === e.data("type")) for (; T.node.isFirstSibling(e.get(0)) && !e.parent().is(T.$el) && !e.parent().is("ol") && !e.parent().is("ul");) e.parent().before(e), a = !0; else if (!1 === e.data("type")) for (; T.node.isLastSibling(e.get(0)) && !e.parent().is(T.$el) && !e.parent().is("ol") && !e.parent().is("ul");) e.parent().after(e), a = !0;
        if (a) return !0
      }
      if (e.parents(t).length || void 0 === t) {
        var o, i = "", s = "", l = e.parent();
        if (l.is(T.$el) || T.node.isBlock(l.get(0))) return !1;
        for (; !(T.node.isBlock(l.parent().get(0)) || void 0 !== t && x(l.get(0), k(t, n)));) i += T.node.closeTagString(l.get(0)), s = T.node.openTagString(l.get(0)) + s, l = l.parent();
        var c = e.get(0).outerHTML;
        return e.replaceWith('<span id="mark"></span>'), o = l.html().replace(/<span id="mark"><\/span>/, i + T.node.closeTagString(l.get(0)) + s + c + i + T.node.openTagString(l.get(0)) + s), l.replaceWith(T.node.openTagString(l.get(0)) + o + T.node.closeTagString(l.get(0))), !0
      }
      return !1
    }

    function r(e, t) {
      void 0 === t && (t = {}), t.style && delete t.style;
      var n = T.selection.isCollapsed();
      T.selection.save();
      for (var r = !0; r;) {
        r = !1;
        for (var a = T.$el.find(".fr-marker"), o = 0; o < a.length; o++) {
          var i = S(a[o]), s = null;
          if (i.attr("data-cloned") || n || (s = i.clone().removeClass("fr-marker").addClass("fr-clone"), i.data("type") && "true" === i.data("type").toString() ? i.attr("data-cloned", !0).after(s) : i.attr("data-cloned", !0).before(s)), R(i, e, t, n)) {
            r = !0;
            break
          }
        }
      }
      !function w(e, t, n, r) {
        for (var a, o = {
          strong: {prop: "font-weight", val: "bold"},
          em: {prop: "font-style", val: "italic"}
        }, i = T.node.contents(e.get(0)), s = 0; s < i.length; s++) {
          var l = i[s];
          if (l.innerHTML && 8203 == l.innerHTML.charCodeAt() && l.tagName.toLocaleLowerCase() == n && l.childNodes.length < 2 && (l.outerHTML = l.innerHTML), T.node.hasClass(l, "fr-marker")) t = (t + 1) % 2; else if (t) if (0 < S(l).find(".fr-marker").length) t = w(S(l), t, n, r); else {
            (a = "LI" === l.tagName ? l : S(l).parentsUntil(T.$el, "li").get(0)) && (void 0 === n || 0 <= ["strong", "em"].indexOf(n)) && (n ? S(a).css(o[n].prop, "") : a.style = "");
            for (var c = S(l).find(n || "*:not(br)"), d = c.length - 1; 0 <= d; d--) {
              var f = c[d];
              (a = "LI" === f.tagName ? f : S(f).parentsUntil(T.$el, "li").get(0)) && (!n || 0 <= ["strong", "em"].indexOf(n)) && (n ? S(a).css(o[n].prop, "") : a.style = ""), T.node.isBlock(f) || T.node.isVoid(f) || void 0 !== n && !x(f, k(n, r)) ? T.node.isBlock(f) && void 0 === n && "TABLE" !== l.tagName && T.node.clearAttributes(f) : T.node.hasClass(f, "fr-clone") || T.node.hasClass(f, "fr-tracking-deleted") || S(f).data("tracking") || (f.outerHTML = f.innerHTML)
            }
            void 0 === n && l.nodeType === Node.ELEMENT_NODE && !T.node.isVoid(l) || x(l, k(n, r)) ? T.node.isBlock(l) || (T.node.hasClass(l, "fr-clone") || T.opts.trackChangesEnabled ? !T.node.hasClass(l, "fr-clone") && T.opts.trackChangesEnabled && l.parentNode && (l.outerHTML = l.innerHTML) : l.outerHTML = l.innerHTML) : void 0 === n && l.nodeType === Node.ELEMENT_NODE && T.node.isBlock(l) && "TABLE" !== l.tagName && T.node.clearAttributes(l)
          } else 0 < S(l).find(".fr-marker").length && (t = w(S(l), t, n, r))
        }
        return t
      }(T.$el, 0, e, t), n || (T.$el.find(".fr-marker").remove(), T.$el.find(".fr-clone").removeClass("fr-clone").addClass("fr-marker")), n && T.$el.find(".fr-marker").before(xt.INVISIBLE_SPACE).after(xt.INVISIBLE_SPACE), T.html.cleanEmptyTags(), T.el.normalize();
      var l = T.$el.find(".fr-marker")[0], c = T.$el.find(".fr-marker")[1];
      !l.parentNode || "P" !== l.parentNode.tagName && "DIV" !== l.parentNode.tagName || l.parentNode.firstChild !== l || l.parentNode.lastChild !== c || l.parentNode.removeAttribute("style"), T.selection.restore();
      var d = T.win.getSelection() && T.win.getSelection().anchorNode;
      if (d) {
        var f = T.node.blockParent(d), p = !!d.textContent.replace(/\u200B/g, "").length,
          u = T.win.getSelection().getRangeAt(0), h = u.startOffset, g = u.endOffset;
        T.selection.text().replace(/\u200B/g, "").length || function A(e, t) {
          if (e && t) {
            if (e.isSameNode(t) ? e.textContent = e.textContent.replace(/\u200B(?=.*\u200B)/g, "") : e.nodeType === Node.TEXT_NODE && (e.textContent = e.textContent.replace(/\u200B/g, "")), !e.childNodes.length) return !1;
            Array.isArray(e.childNodes) && e.childNodes.forEach(function (e) {
              A(e, t)
            })
          }
        }(f, d);
        var m = T.win.getSelection().getRangeAt(0);
        if (d.nodeType === Node.TEXT_NODE) {
          if (!p || !T.selection.text().length && h === g) {
            var v = d.textContent.search(/\u200B/g) + 1;
            if (T.browser.msie) {
              var b = T.doc.createRange();
              T.selection.get().removeAllRanges(), b.setStart(d, v), b.setEnd(d, v), T.selection.get().addRange(b)
            } else m.setStart(d, v), m.setEnd(d, v)
          }
        } else {
          var C, E, y = 0, L = S(d).contents();
          if (T.browser.msie) {
            for (; E = L[y];) E.nodeType === Node.TEXT_NODE && 0 <= E.textContent.search(/\u200B/g) && (C = E), y++;
            C = S(C)
          } else C = L.filter(function (e) {
            return e.nodeType === Node.TEXT_NODE && 0 <= e.textContent.search(/\u200B/g)
          });
          if (C.length && !T.opts.trackChangesEnabled) {
            var _ = C.text().search(/\u200B/g) + 1;
            m.setStart(C.get(0), _), m.setEnd(C.get(0), _)
          }
        }
      }
    }

    function t(e, t) {
      var n, r, a, o, i, s, l, c = null;
      if (T.selection.isCollapsed()) {
        T.markers.insert();
        var d = (r = T.$el.find(".fr-marker")).parent();
        if (T.node.openTagString(d.get(0)) === '<span style="'.concat(e, ": ").concat(d.css(e), ';">')) {
          if (T.node.isEmpty(d.get(0))) c = S(T.doc.createElement("span")).attr("style", "".concat(e, ": ").concat(t, ";")).html("".concat(xt.INVISIBLE_SPACE).concat(xt.MARKERS)), d.replaceWith(c); else {
            var f = {};
            f["style*"] = "".concat(e, ":"), R(r, "span", f, !0), r = T.$el.find(".fr-marker"), t ? (c = S(T.doc.createElement("span")).attr("style", "".concat(e, ": ").concat(t, ";")).html("".concat(xt.INVISIBLE_SPACE).concat(xt.MARKERS)), r.replaceWith(c)) : r.replaceWith(xt.INVISIBLE_SPACE + xt.MARKERS)
          }
          T.html.cleanEmptyTags()
        } else T.node.isEmpty(d.get(0)) && d.is("span") ? (r.replaceWith(xt.MARKERS), d.css(e, t)) : (c = S('<span style="'.concat(e, ": ").concat(t, ';">').concat(xt.INVISIBLE_SPACE).concat(xt.MARKERS, "</span>")), r.replaceWith(c));
        c && C(c, e, t)
      } else {
        if (T.selection.save(), null === t || "color" === e && 0 < T.$el.find(".fr-marker").parents("u, a").length) {
          var p = T.$el.find(".fr-marker");
          for (n = 0; n < p.length; n++) if (!0 === (r = S(p[n])).data("type") || "true" === r.data("type")) for (; T.node.isFirstSibling(r.get(0)) && !r.parent().is(T.$el) && !T.node.isElement(r.parent().get(0)) && !T.node.isBlock(r.parent().get(0));) r.parent().before(r); else for (; T.node.isLastSibling(r.get(0)) && !r.parent().is(T.$el) && !T.node.isElement(r.parent().get(0)) && !T.node.isBlock(r.parent().get(0));) r.parent().after(r)
        }
        for (var u = T.$el.find('.fr-marker[data-type="true"]').get(0).nextSibling; u.firstChild;) u = u.firstChild;
        var h = {"class": "fr-unprocessed"};
        for (t && (h.style = "".concat(e, ": ").concat(t, ";")), v(u, "span", h), T.$el.find(".fr-marker + .fr-unprocessed").each(function () {
          S(this).prepend(S(this).prev())
        }), T.$el.find(".fr-unprocessed + .fr-marker").each(function () {
          S(this).prev().append(S(this))
        }), (t || "").match(/\dem$/) && T.$el.find("span.fr-unprocessed").removeClass("fr-unprocessed"); 0 < T.$el.find("span.fr-unprocessed").length;) {
          if (a = b(c = T.$el.find("span.fr-unprocessed").first().removeClass("fr-unprocessed")), c.parent().get(0).normalize(), c.parent().is("span") && 1 === c.parent().get(0).childNodes.length) {
            c.parent().css(e, t);
            var g = c;
            c = c.parent(), g.replaceWith(g.html())
          }
          for (o = c.find("span"), a && "background-color" !== e && (a.normalize(), o = S(a).find("span:not(.fr-unprocessed)")), n = o.length - 1; 0 <= n; n--) i = o[n], s = e, l = void 0, (l = S(i)).css(s, ""), "" === l.attr("style") && l.replaceWith(l.html());
          C(c, e, t)
        }
      }
      !function m() {
        var e;
        for (; 0 < T.$el.find(".fr-split:empty").length;) T.$el.find(".fr-split:empty").remove();
        T.$el.find(".fr-split").removeClass("fr-split"), T.$el.find('[style=""]').removeAttr("style"), T.$el.find('[class=""]').removeAttr("class"), T.html.cleanEmptyTags();
        for (var t = T.$el.find("span"), n = t.length - 1; 0 <= n; n--) {
          var r = t[n];
          r.attributes && 0 !== r.attributes.length || S(r).replaceWith(r.innerHTML)
        }
        T.el.normalize();
        var a = T.$el.find("span[style] + span[style]");
        for (e = 0; e < a.length; e++) {
          var o = S(a[e]), i = S(a[e]).prev();
          o.get(0).previousSibling === i.get(0) && T.node.openTagString(o.get(0)) === T.node.openTagString(i.get(0)) && (o.prepend(i.html()), i.remove())
        }
        T.$el.find("span[style] span[style]").each(function () {
          if (0 <= S(this).attr("style").indexOf("font-size")) {
            var e = S(this).parents("span[style]");
            e.attr("style") && 0 <= e.attr("style").indexOf("background-color") && (S(this).attr("style", "".concat(S(this).attr("style"), ";").concat(e.attr("style"))), R(S(this), "span[style]", {}, !1))
          }
        }), T.el.normalize(), T.selection.restore()
      }()
    }

    function b(e) {
      var t, n, r, a, o, i;
      if (t = "LI" === e.tagName ? e : S(e).parentsUntil(T.$el, "li").get(0)) {
        if ((i = T.selection.info(t)).atStart && i.atEnd) return t;
        if (i.atStart && !i.atEnd && (n = S(t).find(".fr-marker[data-type=false]").get(0), r = S(n).parentsUntil(T.$el, "li").get(0), a = S(n).parent().get(0), (o = n.nextSibling) && 0 <= ["UL", "OL"].indexOf(o.tagName) || !r.isSameNode(t) || !o && ("LI" === a.tagName || !a.nextSibling || 0 <= ["UL", "OL"].indexOf(a.nextSibling.tagName) || T.node.isVoid(a.nextSibling)))) return t
      }
    }

    function C(e, t, n) {
      var r, a, o, i = e.parentsUntil(T.$el, "span[style]"), s = [];
      for (r = i.length - 1; 0 <= r; r--) a = i[r], o = t, 0 === S(a).attr("style").indexOf("".concat(o, ":")) || 0 <= S(a).attr("style").indexOf(";".concat(o, ":")) || 0 <= S(a).attr("style").indexOf("; ".concat(o, ":")) || s.push(i[r]);
      if ((i = i.not(s)).length) {
        for (var l = "", c = "", d = "", f = "", p = e.get(0); p = p.parentNode, S(p).addClass("fr-split"), l += T.node.closeTagString(p), c = T.node.openTagString(S(p).clone().addClass("fr-split").get(0)) + c, i.get(0) !== p && (d += T.node.closeTagString(p), f = T.node.openTagString(S(p).clone().addClass("fr-split").get(0)) + f), i.get(0) !== p;) ;
        var u = "".concat(l + T.node.openTagString(S(i.get(0)).clone().css(t, n || "").get(0)) + f + e.css(t, "").get(0).outerHTML + d, "</span>").concat(c);
        e.replaceWith('<span id="fr-break"></span>');
        var h = i.get(0).outerHTML;
        S(i.get(0)).replaceWith(h.replace(/<span id="fr-break"><\/span>/g, function () {
          return u
        }))
      }
    }

    function a(e, t) {
      void 0 === t && (t = {}), t.style && delete t.style;
      var n = T.selection.ranges(0), r = n.startContainer;
      if (r.nodeType === Node.ELEMENT_NODE && 0 < r.childNodes.length && r.childNodes[n.startOffset] && (r = r.childNodes[n.startOffset]), !n.collapsed && r.nodeType === Node.TEXT_NODE && n.startOffset === (r.textContent || "").length) {
        for (; !T.node.isBlock(r.parentNode) && !r.nextSibling;) r = r.parentNode;
        r.nextSibling && (r = r.nextSibling)
      }
      for (var a = r; a && a.nodeType === Node.ELEMENT_NODE && !x(a, k(e, t));) a = a.firstChild;
      if (a && a.nodeType === Node.ELEMENT_NODE && x(a, k(e, t))) return !0;
      var o = r;
      for (o && o.nodeType !== Node.ELEMENT_NODE && (o = o.parentNode); o && o.nodeType === Node.ELEMENT_NODE && o !== T.el && !x(o, k(e, t));) o = o.parentNode;
      return !(!o || o.nodeType !== Node.ELEMENT_NODE || o === T.el || !x(o, k(e, t)))
    }

    return {
      is: a, toggle: function o(e, t) {
        a(e, t) ? r(e, t) : n(e, t)
      }, apply: n, remove: r, applyStyle: t, removeStyle: function i(e) {
        t(e, null)
      }
    }
  }, xt.MODULES.spaces = function (c) {
    function r(e, t) {
      var n = e.previousSibling, r = e.nextSibling, a = e.textContent, o = e.parentNode,
        i = [xt.ENTER_P, xt.ENTER_DIV, xt.ENTER_BR];
      if (!c.html.isPreformatted(o)) {
        t && (a = a.replace(/[\f\n\r\t\v ]{2,}/g, " "), r && "BR" !== r.tagName && !c.node.isBlock(r) || !(c.node.isBlock(o) || c.node.isLink(o) && !o.nextSibling || c.node.isElement(o)) || (a = a.replace(/[\f\n\r\t\v ]{1,}$/g, "")), n && "BR" !== n.tagName && !c.node.isBlock(n) || !(c.node.isBlock(o) || c.node.isLink(o) && !o.previousSibling || c.node.isElement(o)) || (a = a.replace(/^[\f\n\r\t\v ]{1,}/g, "")), (c.node.isBlock(r) || c.node.isBlock(n)) && (!n || n && "A" !== n.tagName) && (a = a.replace(/^[\f\n\r\t\v ]{1,}/g, "")), " " === a && (n && c.node.isVoid(n) || r && c.node.isVoid(r)) && !(n && r && c.node.isVoid(n) || r && n && c.node.isVoid(r)) && (a = "")), (!n && c.node.isBlock(r) || !r && c.node.isBlock(n)) && c.node.isBlock(o) && o !== c.el && (a = a.replace(/^[\f\n\r\t\v ]{1,}/g, "")), t || (a = a.replace(new RegExp(xt.UNICODE_NBSP, "g"), " "));
        for (var s = "", l = 0; l < a.length; l++) 32 != a.charCodeAt(l) || 0 !== l && 32 != s.charCodeAt(l - 1) || !((c.opts.enter === xt.ENTER_BR || c.opts.enter === xt.ENTER_DIV) && (n && "BR" === n.tagName || r && "BR" === r.tagName) || n && r && n.tagName === r.tagName) && (n && r && c.node.isVoid(n) || n && r && c.node.isVoid(r)) ? s += a[l] : s += xt.UNICODE_NBSP;
        (!r || r && c.node.isBlock(r) || r && r.nodeType === Node.ELEMENT_NODE && c.win.getComputedStyle(r) && "block" === c.win.getComputedStyle(r).display) && (!c.node.isVoid(n) || n && -1 !== ["P", "DIV", "BR"].indexOf(n.tagName) && -1 !== i.indexOf(c.opts.enter)) && (s = s.replace(/ $/, xt.UNICODE_NBSP)), !n || c.node.isVoid(n) || c.node.isBlock(n) || 1 !== (s = s.replace(/^\u00A0([^ $])/, " $1")).length || 160 !== s.charCodeAt(0) || !r || c.node.isVoid(r) || c.node.isBlock(r) || c.node.hasClass(n, "fr-marker") && c.node.hasClass(r, "fr-marker") || (s = " "), t || (s = s.replace(/([^ \u00A0])\u00A0([^ \u00A0])/g, "$1 $2")), e.textContent !== s && (e.textContent = s)
      }
    }

    function l(e, t) {
      if (void 0 !== e && e || (e = c.el), void 0 === t && (t = !1), !e.getAttribute || "false" !== e.getAttribute("contenteditable")) if (e.nodeType === Node.TEXT_NODE) r(e, t); else if (e.nodeType === Node.ELEMENT_NODE) for (var n = c.doc.createTreeWalker(e, NodeFilter.SHOW_TEXT, c.node.filter(function (e) {
        for (var t = e.parentNode; t && t !== c.el;) {
          if ("STYLE" === t.tagName || "IFRAME" === t.tagName) return !1;
          if ("PRE" === t.tagName) return !1;
          t = t.parentNode
        }
        return null !== e.textContent.match(/([ \u00A0\f\n\r\t\v]{2,})|(^[ \u00A0\f\n\r\t\v]{1,})|([ \u00A0\f\n\r\t\v]{1,}$)/g) && !c.node.hasClass(e.parentNode, "fr-marker")
      }), !1); n.nextNode();) r(n.currentNode, t)
    }

    return {
      normalize: l, normalizeAroundCursor: function d() {
        for (var e = [], t = c.el.querySelectorAll(".fr-marker"), n = 0; n < t.length; n++) {
          for (var r = null, a = c.node.blockParent(t[n]), o = (r = a || t[n]).nextSibling, i = r.previousSibling; o && "BR" === o.tagName;) o = o.nextSibling;
          for (; i && "BR" === i.tagName;) i = i.previousSibling;
          r && e.indexOf(r) < 0 && e.push(r), i && e.indexOf(i) < 0 && e.push(i), o && e.indexOf(o) < 0 && e.push(o)
        }
        for (var s = 0; s < e.length; s++) l(e[s])
      }
    }
  }, xt.START_MARKER = '<span class="fr-marker" data-id="0" data-type="true" style="display: none; line-height: 0;">'.concat(xt.INVISIBLE_SPACE = "&#8203;", "</span>"), xt.END_MARKER = '<span class="fr-marker" data-id="0" data-type="false" style="display: none; line-height: 0;">'.concat(xt.INVISIBLE_SPACE, "</span>"), xt.MARKERS = xt.START_MARKER + xt.END_MARKER, xt.MODULES.markers = function (d) {
    var f = d.$;

    function l() {
      if (!d.$wp) return null;
      try {
        var e = d.selection.ranges(0), t = e.commonAncestorContainer;
        if (t !== d.el && !d.$el.contains(t)) return null;
        var n = e.cloneRange(), r = e.cloneRange();
        n.collapse(!0);
        var a = f(d.doc.createElement("SPAN")).addClass("fr-marker").attr("style", "display: none; line-height: 0;").html(xt.INVISIBLE_SPACE).get(0);
        if (n.insertNode(a), a = d.$el.find("span.fr-marker").get(0)) {
          for (var o = a.nextSibling; o && o.nodeType === Node.TEXT_NODE && 0 === o.textContent.length;) f(o).remove(), o = d.$el.find("span.fr-marker").get(0).nextSibling;
          return d.selection.clear(), d.selection.get().addRange(r), a
        }
        return null
      } catch (i) {
      }
    }

    function c() {
      d.$el.find(".fr-marker").remove()
    }

    return {
      place: function p(e, t, n) {
        var r, a, o;
        try {
          var i = e.cloneRange();
          if (i.collapse(t), i.insertNode(function l(e, t) {
            var n = f(d.doc.createElement("SPAN"));
            return n.addClass("fr-marker").attr("data-id", t).attr("data-type", e).attr("style", "display: ".concat(d.browser.safari ? "none" : "inline-block", "; line-height: 0;")).html(xt.INVISIBLE_SPACE), n.get(0)
          }(t, n)), !0 === t) for (o = (r = d.$el.find('span.fr-marker[data-type="true"][data-id="'.concat(n, '"]')).get(0)).nextSibling; o && o.nodeType === Node.TEXT_NODE && 0 === o.textContent.length;) f(o).remove(), o = r.nextSibling;
          if (!0 === t && !e.collapsed) {
            for (; !d.node.isElement(r.parentNode) && !o;) -1 < /\bfa\b/g.test(r.parentNode.className) && "I" === r.parentNode.tagName ? f(r.parentNode).before(r) : f(r.parentNode).after(r), o = r.nextSibling;
            if (o && o.nodeType === Node.ELEMENT_NODE && d.node.isBlock(o) && "HR" !== o.tagName) {
              for (a = [o]; o = a[0], (a = d.node.contents(o))[0] && d.node.isBlock(a[0]);) ;
              f(o).prepend(f(r))
            }
          }
          if (!1 === t && !e.collapsed) {
            if ((o = (r = d.$el.find('span.fr-marker[data-type="false"][data-id="'.concat(n, '"]')).get(0)).previousSibling) && o.nodeType === Node.ELEMENT_NODE && d.node.isBlock(o) && "HR" !== o.tagName) {
              for (a = [o]; o = a[a.length - 1], (a = d.node.contents(o))[a.length - 1] && d.node.isBlock(a[a.length - 1]);) ;
              f(o).append(f(r))
            }
            (r.parentNode && 0 <= ["TD", "TH"].indexOf(r.parentNode.tagName) || !r.previousSibling && d.node.isBlock(r.parentElement)) && (r.parentNode.previousSibling && !r.previousSibling ? f(r.parentNode.previousSibling).append(r) : 0 <= ["TD", "TH"].indexOf(r.parentNode.tagName) && r.parentNode.firstChild === r && (r.parentNode.previousSibling ? f(r.parentNode.previousSibling).append(r) : r.parentNode.parentNode && r.parentNode.parentNode.previousSibling && f(r.parentNode.parentNode.previousSibling).append(r)))
          }
          var s = d.$el.find('span.fr-marker[data-type="'.concat(t, '"][data-id="').concat(n, '"]')).get(0);
          return s && (s.style.display = "none"), s
        } catch (c) {
          return null
        }
      }, insert: l, split: function i() {
        d.selection.isCollapsed() || d.selection.remove();
        var e = d.$el.find(".fr-marker").get(0);
        if (e || (e = l()), !e) return null;
        var t = d.node.deepestParent(e);
        if (t || (t = d.node.blockParent(e)) && "LI" !== t.tagName && (t = null), t) if (d.node.isBlock(t) && d.node.isEmpty(t)) "LI" !== t.tagName || t.parentNode.firstElementChild !== t || d.node.isEmpty(t.parentNode) ? f(t).replaceWith('<span class="fr-marker"></span>') : f(t).append('<span class="fr-marker"></span>'); else if (d.cursor.isAtStart(e, t)) f(t).before('<span class="fr-marker"></span>'), f(e).remove(); else if (d.cursor.isAtEnd(e, t)) f(t).after('<span class="fr-marker"></span>'), f(e).remove(); else {
          for (var n = e, r = "", a = ""; n = n.parentNode, r += d.node.closeTagString(n), a = d.node.openTagString(n) + a, n !== t;) ;
          f(e).replaceWith('<span id="fr-break"></span>');
          var o = d.node.openTagString(t) + f(t).html() + d.node.closeTagString(t);
          o = o.replace(/<span id="fr-break"><\/span>/g, "".concat(r, '<span class="fr-marker"></span>').concat(a)), f(t).replaceWith(o)
        }
        return d.$el.find(".fr-marker").get(0)
      }, insertAtPoint: function u(e) {
        var t, n = e.clientX, r = e.clientY;
        c();
        var a = null;
        if ("undefined" != typeof d.doc.caretPositionFromPoint ? (t = d.doc.caretPositionFromPoint(n, r), (a = d.doc.createRange()).setStart(t.offsetNode, t.offset), a.setEnd(t.offsetNode, t.offset)) : "undefined" != typeof d.doc.caretRangeFromPoint && (t = d.doc.caretRangeFromPoint(n, r), (a = d.doc.createRange()).setStart(t.startContainer, t.startOffset), a.setEnd(t.startContainer, t.startOffset)), null !== a && "undefined" != typeof d.win.getSelection) {
          var o = d.win.getSelection();
          o.removeAllRanges(), o.addRange(a)
        } else if ("undefined" != typeof d.doc.body.createTextRange) try {
          (a = d.doc.body.createTextRange()).moveToPoint(n, r);
          var i = a.duplicate();
          i.moveToPoint(n, r), a.setEndPoint("EndToEnd", i), a.select()
        } catch (s) {
          return !1
        }
        l()
      }, remove: c
    }
  }, xt.MODULES.selection = function (y) {
    var L = y.$;

    function s() {
      var e = "";
      return y.win.getSelection ? e = y.win.getSelection() : y.doc.getSelection ? e = y.doc.getSelection() : y.doc.selection && (e = y.doc.selection.createRange().text), e.toString()
    }

    function E() {
      return y.win.getSelection ? y.win.getSelection() : y.doc.getSelection ? y.doc.getSelection() : y.doc.selection.createRange()
    }

    function f(e) {
      var t = E(), n = [];
      if (t && t.getRangeAt && t.rangeCount) {
        n = [];
        for (var r = 0; r < t.rangeCount; r++) n.push(t.getRangeAt(r))
      } else n = y.doc.createRange ? [y.doc.createRange()] : [];
      return void 0 !== e ? n[e] : n
    }

    function _() {
      var e = E();
      try {
        e.removeAllRanges ? e.removeAllRanges() : e.empty ? e.empty() : e.clear && e.clear()
      } catch (t) {
      }
    }

    function p(e, t) {
      var n = e;
      return n.nodeType === Node.ELEMENT_NODE && 0 < n.childNodes.length && n.childNodes[t] && (n = n.childNodes[t]), n.nodeType === Node.TEXT_NODE && (n = n.parentNode), n
    }

    function w() {
      if (y.$wp) {
        y.markers.remove();
        var e, t, n = f(), r = [];
        for (t = 0; t < n.length; t++) if (n[t].startContainer !== y.doc || y.browser.msie) {
          var a = (e = n[t]).collapsed, o = y.markers.place(e, !0, t), i = y.markers.place(e, !1, t);
          if (void 0 !== o && o || !a || (L(".fr-marker").remove(), y.selection.setAtEnd(y.el)), y.el.normalize(), y.browser.safari && !a) try {
            (e = y.doc.createRange()).setStartAfter(o), e.setEndBefore(i), r.push(e)
          } catch (s) {
          }
        }
        if (y.browser.safari && r.length) for (y.selection.clear(), t = 0; t < r.length; t++) y.selection.get().addRange(r[t])
      }
    }

    function A() {
      var e, t = y.el.querySelectorAll('.fr-marker[data-type="true"]');
      if (!y.$wp) return y.markers.remove(), !1;
      if (0 === t.length) return !1;
      if (y.browser.msie || y.browser.edge) for (e = 0; e < t.length; e++) t[e].style.display = "inline-block";
      y.core.hasFocus() || y.browser.msie || y.browser.webkit || y.$el.focus(), _();
      var n = E();
      for (e = 0; e < t.length; e++) {
        var r = L(t[e]).data("id"), a = t[e], o = y.doc.createRange(),
          i = y.$el.find('.fr-marker[data-type="false"][data-id="'.concat(r, '"]'));
        (y.browser.msie || y.browser.edge) && i.css("display", "inline-block");
        var s = null;
        if (0 < i.length) {
          i = i[0];
          try {
            for (var l = !1, c = a.nextSibling, d = null; c && c.nodeType === Node.TEXT_NODE && 0 === c.textContent.length;) c = (d = c).nextSibling, L(d).remove();
            for (var f = i.nextSibling; f && f.nodeType === Node.TEXT_NODE && 0 === f.textContent.length;) f = (d = f).nextSibling, L(d).remove();
            if (a.nextSibling === i || i.nextSibling === a) {
              for (var p = a.nextSibling === i ? a : i, u = p === a ? i : a, h = p.previousSibling; h && h.nodeType === Node.TEXT_NODE && 0 === h.length;) h = (d = h).previousSibling, L(d).remove();
              if (h && h.nodeType === Node.TEXT_NODE) for (; h && h.previousSibling && h.previousSibling.nodeType === Node.TEXT_NODE;) h.previousSibling.textContent += h.textContent, h = h.previousSibling, L(h.nextSibling).remove();
              for (var g = u.nextSibling; g && g.nodeType === Node.TEXT_NODE && 0 === g.length;) g = (d = g).nextSibling, L(d).remove();
              if (g && g.nodeType === Node.TEXT_NODE) for (; g && g.nextSibling && g.nextSibling.nodeType === Node.TEXT_NODE;) g.nextSibling.textContent = g.textContent + g.nextSibling.textContent, g = g.nextSibling, L(g.previousSibling).remove();
              if (h && (y.node.isVoid(h) || y.node.isBlock(h)) && (h = null), g && (y.node.isVoid(g) || y.node.isBlock(g)) && (g = null), h && g && h.nodeType === Node.TEXT_NODE && g.nodeType === Node.TEXT_NODE) {
                L(a).remove(), L(i).remove();
                var m = h.textContent.length;
                h.textContent += g.textContent, L(g).remove(), y.spaces.normalize(h), o.setStart(h, m), o.setEnd(h, m), l = !0
              } else !h && g && g.nodeType === Node.TEXT_NODE ? (L(a).remove(), L(i).remove(), y.opts.htmlUntouched || y.spaces.normalize(g), s = L(y.doc.createTextNode("\u200b")).get(0), L(g).before(s), o.setStart(g, 0), o.setEnd(g, 0), l = !0) : !g && h && h.nodeType === Node.TEXT_NODE && (L(a).remove(), L(i).remove(), y.opts.htmlUntouched || y.spaces.normalize(h), s = L(y.doc.createTextNode("\u200b")).get(0), L(h).after(s), o.setStart(h, h.textContent.length), o.setEnd(h, h.textContent.length), l = !0)
            }
            if (!l) {
              var v = void 0, b = void 0;
              b = (y.browser.chrome || y.browser.edge) && a.nextSibling === i ? (v = T(i, o, !0) || o.setStartAfter(i), T(a, o, !1) || o.setEndBefore(a)) : (a.previousSibling === i && (i = (a = i).nextSibling), i.nextSibling && "BR" === i.nextSibling.tagName || !i.nextSibling && y.node.isBlock(a.previousSibling) || a.previousSibling && "BR" === a.previousSibling.tagName || (a.style.display = "inline", i.style.display = "inline", s = L(y.doc.createTextNode("\u200b")).get(0)), v = T(a, o, !0) || L(a).before(s) && o.setStartBefore(a), T(i, o, !1) || L(i).after(s) && o.setEndAfter(i)), "function" == typeof v && v(), "function" == typeof b && b()
            }
          } catch (C) {
          }
        }
        s && L(s).remove();
        try {
          n.addRange(o)
        } catch (C) {
        }
      }
      y.markers.remove()
    }

    function T(e, t, n) {
      var r, a = e.previousSibling, o = e.nextSibling;
      return a && o && a.nodeType === Node.TEXT_NODE && o.nodeType === Node.TEXT_NODE ? (r = a.textContent.length, n ? (o.textContent = a.textContent + o.textContent, L(a).remove(), L(e).remove(), y.opts.htmlUntouched || y.spaces.normalize(o), function () {
        t.setStart(o, r)
      }) : (a.textContent += o.textContent, L(o).remove(), L(e).remove(), y.opts.htmlUntouched || y.spaces.normalize(a), function () {
        t.setEnd(a, r)
      })) : a && !o && a.nodeType === Node.TEXT_NODE ? (r = a.textContent.length, n ? (y.opts.htmlUntouched || y.spaces.normalize(a), function () {
        t.setStart(a, r)
      }) : (y.opts.htmlUntouched || y.spaces.normalize(a), function () {
        t.setEnd(a, r)
      })) : !(!o || a || o.nodeType !== Node.TEXT_NODE) && (n ? (y.opts.htmlUntouched || y.spaces.normalize(o), function () {
        t.setStart(o, 0)
      }) : (y.opts.htmlUntouched || y.spaces.normalize(o), function () {
        t.setEnd(o, 0)
      }))
    }

    function S() {
      for (var e = f(), t = 0; t < e.length; t++) if (!e[t].collapsed) return !1;
      return !0
    }

    function a(e) {
      var t, n, r = !1, a = !1;
      if (y.win.getSelection) {
        var o = y.win.getSelection();
        o.rangeCount && ((n = (t = o.getRangeAt(0)).cloneRange()).selectNodeContents(e), n.setEnd(t.startContainer, t.startOffset), r = i(n), n.selectNodeContents(e), n.setStart(t.endContainer, t.endOffset), a = i(n))
      } else y.doc.selection && "Control" !== y.doc.selection.type && ((n = (t = y.doc.selection.createRange()).duplicate()).moveToElementText(e), n.setEndPoint("EndToStart", t), r = i(n), n.moveToElementText(e), n.setEndPoint("StartToEnd", t), a = i(n));
      return {atStart: r, atEnd: a}
    }

    function i(e) {
      return "" === e.toString().replace(/[\u200B-\u200D\uFEFF]/g, "")
    }

    function k(e, t) {
      void 0 === t && (t = !0);
      var n = L(e).html();
      n && n.replace(/\u200b/g, "").length !== n.length && L(e).html(n.replace(/\u200b/g, ""));
      for (var r = y.node.contents(e), a = 0; a < r.length; a++) r[a].nodeType !== Node.ELEMENT_NODE ? L(r[a]).remove() : (k(r[a], 0 === a), 0 === a && (t = !1));
      if (e.nodeType === Node.TEXT_NODE) {
        var o = L(document.createElement("span")).attr("data-first", "true").attr("data-text", "true");
        L(e)[0].replaceWith(o[0])
      } else t && L(e).attr("data-first", !0)
    }

    function x() {
      return 0 === L(this).find("fr-inner").length
    }

    function u() {
      try {
        if (!y.$wp) return !1;
        for (var e = f(0).commonAncestorContainer; e && !y.node.isElement(e);) e = e.parentNode;
        return !!y.node.isElement(e)
      } catch (t) {
        return !1
      }
    }

    function r(e, t) {
      if (!e || 0 < e.getElementsByClassName("fr-marker").length) return !1;
      for (var n = e.firstChild; n && (y.node.isBlock(n) || t && !y.node.isVoid(n) && n.nodeType === Node.ELEMENT_NODE);) n = (e = n).firstChild;
      e.innerHTML = xt.MARKERS + e.innerHTML
    }

    function o(e, t) {
      if (!e || 0 < e.getElementsByClassName("fr-marker").length) return !1;
      for (var n = e.lastChild; n && (y.node.isBlock(n) || t && !y.node.isVoid(n) && n.nodeType === Node.ELEMENT_NODE);) n = (e = n).lastChild;
      var r = y.doc.createElement("SPAN");
      for (r.setAttribute("id", "fr-sel-markers"), r.innerHTML = xt.MARKERS; e.parentNode && y.opts.htmlAllowedEmptyTags && 0 <= y.opts.htmlAllowedEmptyTags.indexOf(e.tagName.toLowerCase());) e = e.parentNode;
      e.appendChild(r);
      var a = e.querySelector("#fr-sel-markers");
      a.outerHTML = a.innerHTML
    }

    return {
      text: s, get: E, ranges: f, clear: _, element: function l() {
        var e = E();
        try {
          if (e.rangeCount) {
            var t, n = f(0), r = n.startContainer;
            if (y.node.isElement(r) && 0 === n.startOffset && r.childNodes.length) for (; r.childNodes.length && r.childNodes[0].nodeType === Node.ELEMENT_NODE;) r = r.childNodes[0];
            if (r.nodeType === Node.TEXT_NODE && n.startOffset === (r.textContent || "").length && r.nextSibling && (r = r.nextSibling), r.nodeType === Node.ELEMENT_NODE) {
              var a = !1;
              if (0 < r.childNodes.length && r.childNodes[n.startOffset]) {
                for (t = r.childNodes[n.startOffset]; t && t.nodeType === Node.TEXT_NODE && 0 === t.textContent.length;) t = t.nextSibling;
                if (t && t.textContent.replace(/\u200B/g, "") === s().replace(/\u200B/g, "") && (r = t, a = !0), !a && 1 < r.childNodes.length && 0 < n.startOffset && r.childNodes[n.startOffset - 1]) {
                  for (t = r.childNodes[n.startOffset - 1]; t && t.nodeType === Node.TEXT_NODE && 0 === t.textContent.length;) t = t.nextSibling;
                  t && t.textContent.replace(/\u200B/g, "") === s().replace(/\u200B/g, "") && (r = t, a = !0)
                }
              } else !n.collapsed && r.nextSibling && r.nextSibling.nodeType === Node.ELEMENT_NODE && (t = r.nextSibling) && t.textContent.replace(/\u200B/g, "") === s().replace(/\u200B/g, "") && (r = t, a = !0);
              !a && 0 < r.childNodes.length && L(r.childNodes[0]).text().replace(/\u200B/g, "") === s().replace(/\u200B/g, "") && ["BR", "IMG", "HR"].indexOf(r.childNodes[0].tagName) < 0 && (r = r.childNodes[0])
            }
            for (; r.nodeType !== Node.ELEMENT_NODE && r.parentNode;) r = r.parentNode;
            for (var o = r; o && "HTML" !== o.tagName;) {
              if (o === y.el) return r;
              o = L(o).parent()[0]
            }
          }
        } catch (i) {
        }
        return y.el
      }, endElement: function c() {
        var e = E();
        try {
          if (e.rangeCount) {
            var t, n = f(0), r = n.endContainer;
            if (r.nodeType === Node.ELEMENT_NODE) {
              var a = !1;
              0 < r.childNodes.length && r.childNodes[n.endOffset] && L(r.childNodes[n.endOffset]).text() === s() ? (r = r.childNodes[n.endOffset], a = !0) : !n.collapsed && r.previousSibling && r.previousSibling.nodeType === Node.ELEMENT_NODE ? (t = r.previousSibling) && t.textContent.replace(/\u200B/g, "") === s().replace(/\u200B/g, "") && (r = t, a = !0) : !n.collapsed && 0 < r.childNodes.length && r.childNodes[n.endOffset] && (t = r.childNodes[n.endOffset].previousSibling).nodeType === Node.ELEMENT_NODE && t && t.textContent.replace(/\u200B/g, "") === s().replace(/\u200B/g, "") && (r = t, a = !0), !a && 0 < r.childNodes.length && L(r.childNodes[r.childNodes.length - 1]).text() === s() && ["BR", "IMG", "HR"].indexOf(r.childNodes[r.childNodes.length - 1].tagName) < 0 && (r = r.childNodes[r.childNodes.length - 1])
            }
            for (r.nodeType === Node.TEXT_NODE && 0 === n.endOffset && r.previousSibling && r.previousSibling.nodeType === Node.ELEMENT_NODE && (r = r.previousSibling); r.nodeType !== Node.ELEMENT_NODE && r.parentNode;) r = r.parentNode;
            for (var o = r; o && "HTML" !== o.tagName;) {
              if (o === y.el) return r;
              o = L(o).parent()[0]
            }
          }
        } catch (i) {
        }
        return y.el
      }, save: w, restore: A, isCollapsed: S, isFull: function d() {
        if (S()) return !1;
        y.selection.save();
        var e, t = y.el.querySelectorAll("td, th, img, br");
        for (e = 0; e < t.length; e++) (t[e].nextSibling || "IMG" === t[e].tagName) && (t[e].innerHTML = '<span class="fr-mk" style="display: none;">&nbsp;</span>'.concat(t[e].innerHTML));
        var n = !1, r = a(y.el);
        for (r.atStart && r.atEnd && (n = !0), t = y.el.querySelectorAll(".fr-mk"), e = 0; e < t.length; e++) t[e].parentNode.removeChild(t[e]);
        return y.selection.restore(), n
      }, inEditor: u, remove: function R() {
        if (S()) return !0;
        var e;

        function t(e) {
          for (var t = e.previousSibling; t && t.nodeType === Node.TEXT_NODE && 0 === t.textContent.length;) {
            var n = t;
            t = t.previousSibling, L(n).remove()
          }
          return t
        }

        function n(e) {
          for (var t = e.nextSibling; t && t.nodeType === Node.TEXT_NODE && 0 === t.textContent.length;) {
            var n = t;
            t = t.nextSibling, L(n).remove()
          }
          return t
        }

        w();
        var r = y.$el.find('.fr-marker[data-type="true"]');
        for (e = 0; e < r.length; e++) for (var a = r[e]; !(t(a) || y.node.isBlock(a.parentNode) || y.$el.is(a.parentNode) || y.node.hasClass(a.parentNode, "fr-inner"));) L(a.parentNode).before(a);
        var o = y.$el.find('.fr-marker[data-type="false"]');
        for (e = 0; e < o.length; e++) {
          for (var i = o[e]; !(n(i) || y.node.isBlock(i.parentNode) || y.$el.is(i.parentNode) || y.node.hasClass(i.parentNode, "fr-inner"));) L(i.parentNode).after(i);
          i.parentNode && y.node.isBlock(i.parentNode) && y.node.isEmpty(i.parentNode) && !y.$el.is(i.parentNode) && !y.node.hasClass(i.parentNode, "fr-inner") && y.opts.keepFormatOnDelete && L(i.parentNode).after(i)
        }
        if (function C() {
          for (var e = y.$el.find(".fr-marker"), t = 0; t < e.length; t++) if (L(e[t]).parentsUntil('.fr-element, [contenteditable="true"]', '[contenteditable="false"]').length) return !1;
          return !0
        }()) {
          !function E(e, t) {
            var n = y.node.contents(e.get(0));
            0 <= ["TD", "TH"].indexOf(e.get(0).tagName) && 1 === e.find(".fr-marker").length && (y.node.hasClass(n[0], "fr-marker") || "BR" == n[0].tagName && y.node.hasClass(n[0].nextElementSibling, "fr-marker")) && e.attr("data-del-cell", !0);
            for (var r = 0; r < n.length; r++) {
              var a = n[r];
              y.node.hasClass(a, "fr-marker") ? t = (t + 1) % 2 : t ? 0 < L(a).find(".fr-marker").length ? t = E(L(a), t) : ["TD", "TH"].indexOf(a.tagName) < 0 && !y.node.hasClass(a, "fr-inner") ? !y.opts.keepFormatOnDelete || 0 < y.$el.find("[data-first]").length || y.node.isVoid(a) ? L(a).remove() : k(a) : y.node.hasClass(a, "fr-inner") ? 0 === L(a).find(".fr-inner").length ? L(a).html("<br>") : L(a).find(".fr-inner").filter(x).html("<br>") : (L(a).empty(), L(a).attr("data-del-cell", !0)) : 0 < L(a).find(".fr-marker").length && (t = E(L(a), t))
            }
            return t
          }(y.$el, 0);
          var s = y.$el.find('[data-first="true"]');
          if (s.length) y.$el.find(".fr-marker").remove(), s.append(xt.INVISIBLE_SPACE + xt.MARKERS).removeAttr("data-first"), s.attr("data-text") && s.replaceWith(s.html()); else for (y.$el.find("table").filter(function () {
            return 0 < L(this).find("[data-del-cell]").length && L(this).find("[data-del-cell]").length === L(this).find("td, th").length
          }).remove(), y.$el.find("[data-del-cell]").removeAttr("data-del-cell"), r = y.$el.find('.fr-marker[data-type="true"]'), e = 0; e < r.length; e++) {
            var l = r[e], c = l.nextSibling,
              d = y.$el.find('.fr-marker[data-type="false"][data-id="'.concat(L(l).data("id"), '"]')).get(0);
            if (d) {
              if (l && (!c || c !== d)) {
                var f = y.node.blockParent(l), p = y.node.blockParent(d), u = !1, h = !1;
                if (f && 0 <= ["UL", "OL"].indexOf(f.tagName) && (u = !(f = null)), p && 0 <= ["UL", "OL"].indexOf(p.tagName) && (h = !(p = null)), L(l).after(d), f !== p) if (null !== f || u) if (null !== p || h || 0 !== L(f).parentsUntil(y.$el, "table").length) f && p && 0 === L(f).parentsUntil(y.$el, "table").length && 0 === L(p).parentsUntil(y.$el, "table").length && !L(f).contains(p) && !L(p).contains(f) && (L(f).append(L(p).html()), L(p).remove()); else {
                  for (c = f; !c.nextSibling && c.parentNode !== y.el;) c = c.parentNode;
                  for (c = c.nextSibling; c && "BR" !== c.tagName;) {
                    var g = c.nextSibling;
                    L(f).append(c), c = g
                  }
                  c && "BR" === c.tagName && L(c).remove()
                } else {
                  var m = y.node.deepestParent(l);
                  m ? (L(m).after(L(p).html()), L(p).remove()) : 0 === L(p).parentsUntil(y.$el, "table").length && (L(l).next().after(L(p).html()), L(p).remove())
                }
              }
            } else d = L(l).clone().attr("data-type", !1), L(l).after(d)
          }
        }
        y.$el.find("li:empty").remove(), y.opts.keepFormatOnDelete || y.html.fillEmptyBlocks(), y.html.cleanEmptyTags(!0), y.opts.htmlUntouched || (y.clean.lists(), y.$el.find("li:empty").append("<br>"), y.spaces.normalize());
        var v = y.$el.find(".fr-marker").last().get(0), b = y.$el.find(".fr-marker").first().get(0);
        void 0 !== v && void 0 !== b && !v.nextSibling && b.previousSibling && "BR" === b.previousSibling.tagName && y.node.isElement(v.parentNode) && y.node.isElement(b.parentNode) && y.$el.append("<br>"), A()
      }, blocks: function h(e) {
        var t, n, r = [], a = E();
        if (u() && a.rangeCount) {
          var o = f();
          for (t = 0; t < o.length; t++) {
            var i = o[t], s = p(i.startContainer, i.startOffset), l = p(i.endContainer, i.endOffset);
            (y.node.isBlock(s) || y.node.hasClass(s, "fr-inner")) && r.indexOf(s) < 0 && r.push(s), (n = y.node.blockParent(s)) && r.indexOf(n) < 0 && r.push(n);
            for (var c = [], d = s; d !== l && d !== y.el;) c.indexOf(d) < 0 && d.children && d.children.length ? (c.push(d), d = d.children[0]) : d.nextSibling ? d = d.nextSibling : d.parentNode && (d = d.parentNode, c.push(d)), y.node.isBlock(d) && c.indexOf(d) < 0 && r.indexOf(d) < 0 && (d !== l || 0 < i.endOffset) && r.push(d);
            y.node.isBlock(l) && r.indexOf(l) < 0 && 0 < i.endOffset && r.push(l), (n = y.node.blockParent(l)) && r.indexOf(n) < 0 && r.push(n)
          }
        }
        for (t = r.length - 1; 0 < t; t--) if (L(r[t]).find(r).length) {
          if (e && L(r[t]).find("ul, ol").length) continue;
          r.splice(t, 1)
        }
        return r
      }, info: a, setAtEnd: o, setAtStart: r, setBefore: function g(e, t) {
        void 0 === t && (t = !0);
        for (var n = e.previousSibling; n && n.nodeType === Node.TEXT_NODE && 0 === n.textContent.length;) n = n.previousSibling;
        return n ? (y.node.isBlock(n) ? o(n) : "BR" === n.tagName ? L(n).before(xt.MARKERS) : L(n).after(xt.MARKERS), !0) : !!t && (y.node.isBlock(e) ? r(e) : L(e).before(xt.MARKERS), !0)
      }, setAfter: function m(e, t) {
        void 0 === t && (t = !0);
        for (var n = e.nextSibling; n && n.nodeType === Node.TEXT_NODE && 0 === n.textContent.length;) n = n.nextSibling;
        return n ? (y.node.isBlock(n) ? r(n) : L(n).before(xt.MARKERS), !0) : !!t && (y.node.isBlock(e) ? o(e) : L(e).after(xt.MARKERS), !0)
      }, rangeElement: p
    }
  }, Object.assign(xt.DEFAULTS, {language: null}), xt.LANGUAGE = {}, xt.MODULES.language = function (e) {
    var t;
    return {
      _init: function n() {
        xt.LANGUAGE && (t = xt.LANGUAGE[e.opts.language]), t && t.direction && (e.opts.direction = t.direction)
      }, translate: function r(e) {
        return t && t.translation[e] && t.translation[e].length ? t.translation[e] : e
      }
    }
  }, Object.assign(xt.DEFAULTS, {placeholderText: "Type something"}), xt.MODULES.placeholder = function (f) {
    var p = f.$;

    function e() {
      f.$placeholder || function d() {
        f.$placeholder = p(f.doc.createElement("SPAN")).addClass("fr-placeholder"), f.$wp.append(f.$placeholder)
      }();
      var e = f.opts.iframe ? f.$iframe.prev().outerHeight(!0) : f.$el.prev().outerHeight(!0), t = 0, n = 0, r = 0,
        a = 0, o = 0, i = 0, s = f.node.contents(f.el), l = p(f.selection.element()).css("text-align");
      if (s.length && s[0].nodeType === Node.ELEMENT_NODE) {
        var c = p(s[0]);
        (0 < f.$wp.prev().length || 0 < f.$el.prev().length) && f.ready && (t = f.helpers.getPX(c.css("margin-top")), a = f.helpers.getPX(c.css("padding-top")), n = f.helpers.getPX(c.css("margin-left")), r = f.helpers.getPX(c.css("margin-right")), o = f.helpers.getPX(c.css("padding-left")), i = f.helpers.getPX(c.css("padding-right"))), f.$placeholder.css("font-size", c.css("font-size")), f.$placeholder.css("line-height", c.css("line-height"))
      } else f.$placeholder.css("font-size", f.$el.css("font-size")), f.$placeholder.css("line-height", f.$el.css("line-height"));
      f.$wp.addClass("show-placeholder"), f.$placeholder.css({
        marginTop: Math.max(f.helpers.getPX(f.$el.css("margin-top")), t) + (e || 0),
        paddingTop: Math.max(f.helpers.getPX(f.$el.css("padding-top")), a),
        paddingLeft: Math.max(f.helpers.getPX(f.$el.css("padding-left")), o),
        marginLeft: Math.max(f.helpers.getPX(f.$el.css("margin-left")), n),
        paddingRight: Math.max(f.helpers.getPX(f.$el.css("padding-right")), i),
        marginRight: Math.max(f.helpers.getPX(f.$el.css("margin-right")), r),
        textAlign: l
      }).text(f.language.translate(f.opts.placeholderText || f.$oel.attr("placeholder") || "")), f.$placeholder.html(f.$placeholder.text().replace(/\n/g, "<br>"))
    }

    function t() {
      f.$wp.removeClass("show-placeholder")
    }

    function n() {
      if (!f.$wp) return !1;
      f.core.isEmpty() ? e() : t()
    }

    return {
      _init: function r() {
        if (!f.$wp) return !1;
        f.events.on("init input keydown keyup contentChanged initialized", n)
      }, show: e, hide: t, refresh: n, isVisible: function a() {
        return !f.$wp || f.node.hasClass(f.$wp.get(0), "show-placeholder")
      }
    }
  }, xt.UNICODE_NBSP = String.fromCharCode(160), xt.VOID_ELEMENTS = ["area", "base", "br", "col", "embed", "hr", "img", "input", "keygen", "link", "menuitem", "meta", "param", "source", "track", "wbr"], xt.BLOCK_TAGS = ["address", "article", "aside", "audio", "blockquote", "canvas", "details", "dd", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "li", "main", "nav", "noscript", "ol", "output", "p", "pre", "section", "table", "tbody", "td", "tfoot", "th", "thead", "tr", "ul", "video"], Object.assign(xt.DEFAULTS, {
    htmlAllowedEmptyTags: ["textarea", "a", "iframe", "object", "video", "style", "script", ".fa", ".fr-emoticon", ".fr-inner", "path", "line", "hr"],
    htmlDoNotWrapTags: ["script", "style"],
    htmlSimpleAmpersand: !1,
    htmlIgnoreCSSProperties: [],
    htmlExecuteScripts: !0
  }), xt.MODULES.html = function (x) {
    var h = x.$;

    function d() {
      return x.opts.enter === xt.ENTER_P ? "p" : x.opts.enter === xt.ENTER_DIV ? "div" : x.opts.enter === xt.ENTER_BR ? "p" : void 0
    }

    function s(e, t) {
      return !(!e || e === x.el) && (t ? -1 != ["PRE", "SCRIPT", "STYLE"].indexOf(e.tagName) || s(e.parentNode, t) : -1 !== ["PRE", "SCRIPT", "STYLE"].indexOf(e.tagName))
    }

    function o(e) {
      var t, n = [], r = [];
      if (e) {
        var a = x.el.querySelectorAll(".fr-marker");
        for (t = 0; t < a.length; t++) {
          var o = x.node.blockParent(a[t]) || a[t];
          if (o) {
            var i = o.nextSibling, s = o.previousSibling;
            o && r.indexOf(o) < 0 && x.node.isBlock(o) && r.push(o), s && x.node.isBlock(s) && r.indexOf(s) < 0 && r.push(s), i && x.node.isBlock(i) && r.indexOf(i) < 0 && r.push(i)
          }
        }
      } else r = x.el.querySelectorAll(p());
      var l = p();
      for (l += ",".concat(xt.VOID_ELEMENTS.join(",")), l += ", .fr-inner", l += ",".concat(x.opts.htmlAllowedEmptyTags.join(":not(.fr-marker),"), ":not(.fr-marker)"), t = r.length - 1; 0 <= t; t--) if (!(r[t].textContent && 0 < r[t].textContent.replace(/\u200B|\n/g, "").length || 0 < r[t].querySelectorAll(l).length)) {
        for (var c = x.node.contents(r[t]), d = !1, f = 0; f < c.length; f++) if (c[f].nodeType !== Node.COMMENT_NODE && c[f].textContent && 0 < c[f].textContent.replace(/\u200B|\n/g, "").length) {
          d = !0;
          break
        }
        d || n.push(r[t])
      }
      return n
    }

    function p() {
      return xt.BLOCK_TAGS.join(", ")
    }

    function e(e) {
      var t, n, r = h.merge([], xt.VOID_ELEMENTS);
      r = h.merge(r, x.opts.htmlAllowedEmptyTags), r = void 0 === e ? h.merge(r, xt.BLOCK_TAGS) : h.merge(r, xt.NO_DELETE_TAGS), t = x.el.querySelectorAll("*:empty:not(".concat(r.join("):not("), "):not(.fr-marker):not(template)"));
      do {
        n = !1;
        for (var a = 0; a < t.length; a++) 0 !== t[a].attributes.length && void 0 === t[a].getAttribute("href") || (t[a].parentNode.removeChild(t[a]), n = !0);
        t = x.el.querySelectorAll("*:empty:not(".concat(r.join("):not("), "):not(.fr-marker):not(template)"))
      } while (t.length && n)
    }

    function i(e, t) {
      var n = d();
      if (t && (n = "div"), n) {
        for (var r = x.doc.createDocumentFragment(), a = null, o = !1, i = e.firstChild, s = !1; i;) {
          var l = i.nextSibling;
          if (i.nodeType === Node.ELEMENT_NODE && (x.node.isBlock(i) || 0 <= x.opts.htmlDoNotWrapTags.indexOf(i.tagName.toLowerCase()) && !x.node.hasClass(i, "fr-marker"))) a = null, r.appendChild(i.cloneNode(!0)); else if (i.nodeType !== Node.ELEMENT_NODE && i.nodeType !== Node.TEXT_NODE) a = null, r.appendChild(i.cloneNode(!0)); else if ("BR" === i.tagName) null === a ? (a = x.doc.createElement(n), s = !0, t && (a.setAttribute("class", "fr-temp-div"), a.setAttribute("data-empty", !0)), a.appendChild(i.cloneNode(!0)), r.appendChild(a)) : !1 === o && (a.appendChild(x.doc.createElement("br")), t && (a.setAttribute("class", "fr-temp-div"), a.setAttribute("data-empty", !0))), a = null; else {
            var c = i.textContent;
            i.nodeType !== Node.TEXT_NODE || 0 < c.replace(/\n/g, "").replace(/(^ *)|( *$)/g, "").length || c.replace(/(^ *)|( *$)/g, "").length && c.indexOf("\n") < 0 ? (null === a && (a = x.doc.createElement(n), s = !0, t && a.setAttribute("class", "fr-temp-div"), r.appendChild(a), o = !1), a.appendChild(i.cloneNode(!0)), o || x.node.hasClass(i, "fr-marker") || i.nodeType === Node.TEXT_NODE && 0 === c.replace(/ /g, "").length || (o = !0)) : s = !0
          }
          i = l
        }
        s && (e.innerHTML = "", e.appendChild(r))
      }
    }

    function l(e, t) {
      for (var n = e.length - 1; 0 <= n; n--) i(e[n], t)
    }

    function t(e, t, n, r, a) {
      if (!x.$wp) return !1;
      void 0 === e && (e = !1), void 0 === t && (t = !1), void 0 === n && (n = !1), void 0 === r && (r = !1), void 0 === a && (a = !1);
      var o = x.$wp.scrollTop();
      i(x.el, e), r && l(x.el.querySelectorAll(".fr-inner"), e), t && l(x.el.querySelectorAll("td, th"), e), n && l(x.el.querySelectorAll("blockquote"), e), a && l(x.el.querySelectorAll("li"), e), o !== x.$wp.scrollTop() && x.$wp.scrollTop(o)
    }

    function n(e) {
      if (void 0 === e && (e = x.el), e && 0 <= ["SCRIPT", "STYLE", "PRE"].indexOf(e.tagName)) return !1;
      for (var t = x.doc.createTreeWalker(e, NodeFilter.SHOW_TEXT, x.node.filter(function (e) {
        return null !== e.textContent.match(/([ \n]{2,})|(^[ \n]{1,})|([ \n]{1,}$)/g)
      }), !1); t.nextNode();) {
        var n = t.currentNode;
        if (!s(n.parentNode, !0)) {
          var r = x.node.isBlock(n.parentNode) || x.node.isElement(n.parentNode),
            a = n.textContent.replace(/(?!^)( ){2,}(?!$)/g, " ").replace(/\n/g, " ").replace(/^[ ]{2,}/g, " ").replace(/[ ]{2,}$/g, " ");
          if (r) {
            var o = n.previousSibling, i = n.nextSibling;
            o && i && " " === a ? a = x.node.isBlock(o) && x.node.isBlock(i) ? "" : " " : (o || (a = a.replace(/^ */, "")), i || (a = a.replace(/ *$/, "")))
          }
          n.textContent = a
        }
      }
    }

    function r(e, t, n) {
      var r = new RegExp(t, "gi").exec(e);
      return r ? r[n] : null
    }

    function R(e) {
      var t = e.doctype, n = "<!DOCTYPE html>";
      return t && (n = "<!DOCTYPE ".concat(t.name).concat(t.publicId ? ' PUBLIC "'.concat(t.publicId, '"') : "").concat(!t.publicId && t.systemId ? " SYSTEM" : "").concat(t.systemId ? ' "'.concat(t.systemId, '"') : "", ">")), n
    }

    function c(e) {
      var t = e.parentNode;
      if (t && (x.node.isBlock(t) || x.node.isElement(t)) && ["TD", "TH"].indexOf(t.tagName) < 0) {
        for (var n = e.previousSibling, r = e.nextSibling; n && (n.nodeType === Node.TEXT_NODE && 0 === n.textContent.replace(/\n|\r/g, "").length || x.node.hasClass(n, "fr-tmp"));) n = n.previousSibling;
        if (r) return !1;
        n && t && "BR" !== n.tagName && !x.node.isBlock(n) && !r && 0 < t.textContent.replace(/\u200B/g, "").length && 0 < n.textContent.length && !x.node.hasClass(n, "fr-marker") && (x.el === t && !r && x.opts.enter === xt.ENTER_BR && x.browser.msie || e.parentNode.removeChild(e))
      } else !t || x.node.isBlock(t) || x.node.isElement(t) || e.previousSibling || e.nextSibling || !x.node.isDeletable(e.parentNode) || c(e.parentNode)
    }

    function g() {
      x.opts.htmlUntouched || (e(), t(), n(), x.spaces.normalize(null, !0), x.html.fillEmptyBlocks(), x.clean.lists(), x.clean.tables(), x.clean.toHTML5(), x.html.cleanBRs()), x.selection.restore(), a(), x.placeholder.refresh()
    }

    function a() {
      x.node.isEmpty(x.el) && (null !== d() ? x.el.querySelector(p()) || x.el.querySelector("".concat(x.opts.htmlDoNotWrapTags.join(":not(.fr-marker),"), ":not(.fr-marker)")) || (x.core.hasFocus() ? (x.$el.html("<".concat(d(), ">").concat(xt.MARKERS, "<br/></").concat(d(), ">")), x.selection.restore()) : x.$el.html("<".concat(d(), "><br/></").concat(d(), ">"))) : x.el.querySelector("*:not(.fr-marker):not(br)") || (x.core.hasFocus() ? (x.$el.html("".concat(xt.MARKERS, "<br/>")), x.selection.restore()) : x.$el.html("<br/>")))
    }

    function m(e, t) {
      return r(e, "<".concat(t, "[^>]*?>([\\w\\W]*)</").concat(t, ">"), 1)
    }

    function v(e, t) {
      var n = h("<div ".concat(r(e, "<".concat(t, "([^>]*?)>"), 1) || "", ">"));
      return x.node.rawAttributes(n.get(0))
    }

    function b(e) {
      return (r(e, "<!DOCTYPE([^>]*?)>", 0) || "<!DOCTYPE html>").replace(/\n/g, " ").replace(/ {2,}/g, " ")
    }

    function C(e, t) {
      x.opts.htmlExecuteScripts ? e.html(t) : e.get(0).innerHTML = t
    }

    function M(e) {
      var t;
      (t = /:not\(([^)]*)\)/g).test(e) && (e = e.replace(t, "     $1 "));
      var n = 100 * (e.match(/(#[^\s+>~.[:]+)/g) || []).length + 10 * (e.match(/(\[[^]]+\])/g) || []).length + 10 * (e.match(/(\.[^\s+>~.[:]+)/g) || []).length + 10 * (e.match(/(:[\w-]+\([^)]*\))/gi) || []).length + 10 * (e.match(/(:[^\s+>~.[:]+)/g) || []).length + (e.match(/(::[^\s+>~.[:]+|:first-line|:first-letter|:before|:after)/gi) || []).length;
      return n += ((e = (e = e.replace(/[*\s+>~]/g, " ")).replace(/[#.]/g, " ")).match(/([^\s+>~.[:]+)/g) || []).length
    }

    function O(e) {
      if (x.events.trigger("html.processGet", [e]), e && e.getAttribute && "" === e.getAttribute("class") && e.removeAttribute("class"), e && e.getAttribute && "" === e.getAttribute("style") && e.removeAttribute("style"), e && e.nodeType === Node.ELEMENT_NODE) {
        var t, n = e.querySelectorAll('[class=""],[style=""]');
        for (t = 0; t < n.length; t++) {
          var r = n[t];
          "" === r.getAttribute("class") && r.removeAttribute("class"), "" === r.getAttribute("style") && r.removeAttribute("style")
        }
        if ("BR" === e.tagName) c(e); else {
          var a = e.querySelectorAll("br");
          for (t = 0; t < a.length; t++) c(a[t])
        }
      }
    }

    function N(e, t) {
      return e[3] - t[3]
    }

    function I() {
      for (var e = x.el.querySelectorAll("input, textarea"), t = 0; t < e.length; t++) "checkbox" !== e[t].type && "radio" !== e[t].type || (e[t].checked ? e[t].setAttribute("checked", e[t].checked) : x.$(e[t]).removeAttr("checked")), e[t].getAttribute("value") && e[t].setAttribute("value", e[t].value)
    }

    function f(e) {
      var t = x.doc.createElement("div");
      return t.innerHTML = e, null !== t.querySelector(p())
    }

    function u(e) {
      var t = null;
      if (void 0 === e && (t = x.selection.element()), x.opts.keepFormatOnDelete) return !1;
      var n, r, a = t ? (t.textContent.match(/\u200B/g) || []).length - t.querySelectorAll(".fr-marker").length : 0;
      if ((x.el.textContent.match(/\u200B/g) || []).length - x.el.querySelectorAll(".fr-marker").length === a) return !1;
      do {
        r = !1, n = x.el.querySelectorAll("*:not(.fr-marker)");
        for (var o = 0; o < n.length; o++) {
          var i = n[o];
          if (t !== i) {
            var s = i.textContent;
            0 === i.children.length && 1 === s.length && 8203 === s.charCodeAt(0) && "TD" !== i.tagName && (h(i).remove(), r = !0)
          }
        }
      } while (r)
    }

    function E() {
      u(), x.placeholder && setTimeout(x.placeholder.refresh, 0)
    }

    return {
      defaultTag: d, isPreformatted: s, emptyBlocks: o, emptyBlockTagsQuery: function y() {
        return "".concat(xt.BLOCK_TAGS.join(":empty, "), ":empty")
      }, blockTagsQuery: p, fillEmptyBlocks: function L(e) {
        var t = o(e);
        x.node.isEmpty(x.el) && x.opts.enter === xt.ENTER_BR && t.push(x.el);
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          "false" === r.getAttribute("contenteditable") || r.querySelector("".concat(x.opts.htmlAllowedEmptyTags.join(":not(.fr-marker),"), ":not(.fr-marker)")) || x.node.isVoid(r) || "TABLE" !== r.tagName && "TBODY" !== r.tagName && "TR" !== r.tagName && "UL" !== r.tagName && "OL" !== r.tagName && r.appendChild(x.doc.createElement("br"))
        }
        if (x.browser.msie && x.opts.enter === xt.ENTER_BR) {
          var a = x.node.contents(x.el);
          a.length && a[a.length - 1].nodeType === Node.TEXT_NODE && x.$el.append("<br>")
        }
      }, cleanEmptyTags: e, cleanWhiteTags: u, cleanBlankSpaces: n, blocks: function _() {
        return x.$el.get(0).querySelectorAll(p())
      }, getDoctype: R, set: function w(e) {
        var t = x.clean.html((e || "").trim(), [], [], x.opts.fullPage), n = new RegExp("%3A//", "g"),
          r = t.replace(n, "://");
        if (x.opts.fullPage) {
          var a = m(r, "body") || (0 <= r.indexOf("<body") ? "" : r), o = v(r, "body"),
            i = m(r, "head") || "<title></title>", s = v(r, "head"), l = h("<div>");
          l.append(i).contents().each(function () {
            (this.nodeType === Node.COMMENT_NODE || 0 <= ["BASE", "LINK", "META", "NOSCRIPT", "SCRIPT", "STYLE", "TEMPLATE", "TITLE"].indexOf(this.tagName)) && this.parentNode.removeChild(this)
          });
          var c = l.html().trim();
          i = h("<div>").append(i).contents().map(function () {
            return this.nodeType === Node.COMMENT_NODE ? "\x3c!--".concat(this.nodeValue, "--\x3e") : 0 <= ["BASE", "LINK", "META", "NOSCRIPT", "SCRIPT", "STYLE", "TEMPLATE", "TITLE"].indexOf(this.tagName) ? this.outerHTML : ""
          }).toArray().join("");
          var d = b(r), f = v(r, "html");
          C(x.$el, "".concat(c, "\n").concat(a)), x.node.clearAttributes(x.el), x.$el.attr(o), x.$el.addClass("fr-view"), x.$el.attr("spellcheck", x.opts.spellcheck), x.$el.attr("dir", x.opts.direction), C(x.$head, i), x.node.clearAttributes(x.$head.get(0)), x.$head.attr(s), x.node.clearAttributes(x.$html.get(0)), x.$html.attr(f), x.iframe_document.doctype.parentNode.replaceChild(function u(e, t) {
            var n = e.match(/<!DOCTYPE ?([^ ]*) ?([^ ]*) ?"?([^"]*)"? ?"?([^"]*)"?>/i);
            return n ? t.implementation.createDocumentType(n[1], n[3], n[4]) : t.implementation.createDocumentType("html")
          }(d, x.iframe_document), x.iframe_document.doctype)
        } else C(x.$el, r);
        var p = x.edit.isDisabled();
        x.edit.on(), x.core.injectStyle(x.opts.iframeDefaultStyle + x.opts.iframeStyle), g(), x.opts.useClasses || (x.$el.find("[fr-original-class]").each(function () {
          this.setAttribute("class", this.getAttribute("fr-original-class")), this.removeAttribute("fr-original-class")
        }), x.$el.find("[fr-original-style]").each(function () {
          this.setAttribute("style", this.getAttribute("fr-original-style")), this.removeAttribute("fr-original-style")
        })), p && x.edit.off(), x.events.trigger("html.set"), x.events.trigger("charCounter.update")
      }, syncInputs: I, get: function D(e, t) {
        if (!x.$wp) return x.$oel.clone().removeClass("fr-view").removeAttr("contenteditable").get(0).outerHTML;
        var n = "";
        x.events.trigger("html.beforeGet");
        var r, a, o = [], i = {}, s = [];
        if (I(), !x.opts.useClasses && !t) {
          var l = new RegExp("^".concat(x.opts.htmlIgnoreCSSProperties.join("$|^"), "$"), "gi");
          for (r = 0; r < x.doc.styleSheets.length; r++) {
            var c = void 0, d = 0;
            try {
              c = x.doc.styleSheets[r].cssRules, x.doc.styleSheets[r].ownerNode && "STYLE" === x.doc.styleSheets[r].ownerNode.nodeType && (d = 1)
            } catch (k) {
            }
            if (c) for (var f = 0, p = c.length; f < p; f++) if (c[f].selectorText && 0 < c[f].style.cssText.length) {
              var u = c[f].selectorText.replace(/body |\.fr-view /g, "").replace(/::/g, ":"), h = void 0;
              try {
                h = x.el.querySelectorAll(u)
              } catch (k) {
                h = []
              }
              for (a = 0; a < h.length; a++) {
                !h[a].getAttribute("fr-original-style") && h[a].getAttribute("style") ? (h[a].setAttribute("fr-original-style", h[a].getAttribute("style")), o.push(h[a])) : h[a].getAttribute("fr-original-style") || (h[a].setAttribute("fr-original-style", ""), o.push(h[a])), i[h[a]] || (i[h[a]] = {});
                for (var g = 1e3 * d + M(c[f].selectorText), m = c[f].style.cssText.split(";"), v = 0; v < m.length; v++) {
                  var b = m[v].trim().split(":")[0];
                  if (b && !b.match(l) && (i[h[a]][b] || (i[h[a]][b] = 0) <= (h[a].getAttribute("fr-original-style") || "").indexOf("".concat(b, ":")) && (i[h[a]][b] = 1e4), g >= i[h[a]][b] && (i[h[a]][b] = g, m[v].trim().length))) {
                    var C = m[v].trim().split(":");
                    C.splice(0, 1), s.push([h[a], b.trim(), C.join(":").trim(), g])
                  }
                }
              }
            }
          }
          for (s.sort(N), r = 0; r < s.length; r++) {
            var E = s[r];
            E[0].style[E[1]] = E[2]
          }
          for (r = 0; r < o.length; r++) if (o[r].getAttribute("class") && (o[r].setAttribute("fr-original-class", o[r].getAttribute("class")), o[r].removeAttribute("class")), 0 < (o[r].getAttribute("fr-original-style") || "").trim().length) {
            var y = o[r].getAttribute("fr-original-style").split(";");
            for (a = 0; a < y.length; a++) if (0 < y[a].indexOf(":")) {
              var L = y[a].split(":"), _ = L[0];
              L.splice(0, 1), o[r].style[_.trim()] = L.join(":").trim()
            }
          }
        }
        if (x.node.isEmpty(x.el)) x.opts.fullPage && (n = R(x.iframe_document), n += "<html".concat(x.node.attributes(x.$html.get(0)), ">").concat(x.$html.find("head").get(0).outerHTML, "<body></body></html>")); else if (void 0 === e && (e = !1), x.opts.fullPage) {
          n = R(x.iframe_document), x.$el.removeClass("fr-view");
          var w = x.opts.heightMin, A = x.opts.height, T = x.opts.heightMax;
          x.opts.heightMin = null, x.opts.height = null, x.opts.heightMax = null, x.size.refresh(), n += "<html".concat(x.node.attributes(x.$html.get(0)), ">").concat(x.$html.html(), "</html>"), x.opts.heightMin = w, x.opts.height = A, x.opts.heightMax = T, x.size.refresh(), x.$el.addClass("fr-view")
        } else n = x.$el.html();
        if (!x.opts.useClasses && !t) for (r = 0; r < o.length; r++) o[r].getAttribute("fr-original-class") && (o[r].setAttribute("class", o[r].getAttribute("fr-original-class")), o[r].removeAttribute("fr-original-class")), null !== o[r].getAttribute("fr-original-style") && void 0 !== o[r].getAttribute("fr-original-style") ? (0 !== o[r].getAttribute("fr-original-style").length ? o[r].setAttribute("style", o[r].getAttribute("fr-original-style")) : o[r].removeAttribute("style"), o[r].removeAttribute("fr-original-style")) : o[r].removeAttribute("style");
        x.opts.fullPage && (n = (n = (n = (n = (n = (n = (n = (n = n.replace(/<style data-fr-style="true">(?:[\w\W]*?)<\/style>/g, "")).replace(/<link([^>]*)data-fr-style="true"([^>]*)>/g, "")).replace(/<style(?:[\w\W]*?)class="firebugResetStyles"(?:[\w\W]*?)>(?:[\w\W]*?)<\/style>/g, "")).replace(/<body((?:[\w\W]*?)) spellcheck="true"((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g, "<body$1$2>$3</body>")).replace(/<body((?:[\w\W]*?)) contenteditable="(true|false)"((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g, "<body$1$3>$4</body>")).replace(/<body((?:[\w\W]*?)) dir="([\w]*)"((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g, "<body$1$3>$4</body>")).replace(/<body((?:[\w\W]*?))class="([\w\W]*?)(fr-rtl|fr-ltr)([\w\W]*?)"((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g, '<body$1class="$2$4"$5>$6</body>')).replace(/<body((?:[\w\W]*?)) class=""((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g, "<body$1$2>$3</body>")), x.opts.htmlSimpleAmpersand && (n = n.replace(/&amp;/gi, "&")), x.events.trigger("html.afterGet"), e || (n = n.replace(/<span[^>]*? class\s*=\s*["']?fr-marker["']?[^>]+>\u200b<\/span>/gi, "")), n = x.clean.invisibleSpaces(n), n = x.clean.exec(n, O);
        var S = x.events.chainTrigger("html.get", n);
        return "string" == typeof S && (n = S), n = (n = n.replace(/<pre(?:[\w\W]*?)>(?:[\w\W]*?)<\/pre>/g, function (e) {
          return e.replace(/<br>/g, "\n")
        })).replace(/<meta((?:[\w\W]*?)) data-fr-http-equiv="/g, '<meta$1 http-equiv="')
      }, getSelected: function A() {
        function e(e, t) {
          for (; t && (t.nodeType === Node.TEXT_NODE || !x.node.isBlock(t)) && !x.node.isElement(t) && !x.node.hasClass(t, "fr-inner");) t && t.nodeType !== Node.TEXT_NODE && h(e).wrapInner(x.node.openTagString(t) + x.node.closeTagString(t)), t = t.parentNode;
          t && e.innerHTML === t.innerHTML ? e.innerHTML = t.outerHTML : -1 != t.innerText.indexOf(e.innerHTML) && (e.innerHTML = x.node.openTagString(t) + t.innerHTML + x.node.closeTagString(t))
        }

        var t, n, r = "";
        if ("undefined" != typeof x.win.getSelection) {
          x.browser.mozilla && (x.selection.save(), 1 < x.$el.find('.fr-marker[data-type="false"]').length && (x.$el.find('.fr-marker[data-type="false"][data-id="0"]').remove(), x.$el.find('.fr-marker[data-type="false"]:last').attr("data-id", "0"), x.$el.find(".fr-marker").not('[data-id="0"]').remove()), x.selection.restore());
          for (var a = x.selection.ranges(), o = 0; o < a.length; o++) {
            var i = document.createElement("div");
            i.appendChild(a[o].cloneContents()), e(i, (n = t = void 0, n = null, x.win.getSelection ? (t = x.win.getSelection()) && t.rangeCount && (n = t.getRangeAt(0).commonAncestorContainer).nodeType !== Node.ELEMENT_NODE && (n = n.parentNode) : (t = x.doc.selection) && "Control" !== t.type && (n = t.createRange().parentElement()), null !== n && (0 <= h(n).parents().toArray().indexOf(x.el) || n === x.el) ? n : null)), 0 < h(i).find(".fr-element").length && (i = x.el), r += i.innerHTML
          }
        } else "undefined" != typeof x.doc.selection && "Text" === x.doc.selection.type && (r = x.doc.selection.createRange().htmlText);
        return r
      }, insert: function T(e, t, n) {
        var r;
        if (x.selection.isCollapsed() || x.selection.remove(), r = t ? e : x.clean.html(e), 0 === e.indexOf('<i class="fa ') && (r = "<span>&nbsp;".concat(r, "</span>")), e.indexOf('class="fr-marker"') < 0 && (r = function i(e) {
          var t = x.doc.createElement("div");
          return t.innerHTML = e, x.selection.setAtEnd(t, !0), t.innerHTML
        }(r)), x.node.isEmpty(x.el) && !x.opts.keepFormatOnDelete && f(r)) x.opts.trackChangesEnabled ? x.track_changes.pasteInEmptyEdior(r) : x.el.innerHTML = r; else {
          var a = x.markers.insert();
          if (a) if (x.opts.trackChangesEnabled) x.track_changes.pasteInEdior(r); else {
            x.node.isLastSibling(a) && h(a).parent().hasClass("fr-deletable") && h(a).insertAfter(h(a).parent());
            var o = x.node.blockParent(a);
            if ((f(r) || n) && (x.node.deepestParent(a) || o && "LI" === o.tagName)) {
              if (o && "LI" === o.tagName && (r = function s(e) {
                if (!x.html.defaultTag()) return e;
                var t = x.doc.createElement("div");
                t.innerHTML = e;
                for (var n = t.querySelectorAll(":scope > ".concat(x.html.defaultTag())), r = n.length - 1; 0 <= r; r--) {
                  var a = n[r];
                  x.node.isBlock(a.previousSibling) || (a.previousSibling && !x.node.isEmpty(a) && h("<br>").insertAfter(a.previousSibling), a.outerHTML = a.innerHTML)
                }
                return t.innerHTML
              }(r)), !(a = x.markers.split())) return !1;
              a.outerHTML = r
            } else a.outerHTML = r
          } else x.el.innerHTML += r
        }
        g(), x.keys.positionCaret(), x.events.trigger("html.inserted")
      }, wrap: t, unwrap: function S() {
        x.$el.find("div.fr-temp-div").each(function () {
          this.previousSibling && this.previousSibling.nodeType === Node.TEXT_NODE && h(this).before("<br>"), h(this).attr("data-empty") || !this.nextSibling || x.node.isBlock(this.nextSibling) && !h(this.nextSibling).hasClass("fr-temp-div") ? h(this).replaceWith(h(this).html()) : h(this).replaceWith("".concat(h(this).html(), "<br>"))
        }), x.$el.find(".fr-temp-div").removeClass("fr-temp-div").filter(function () {
          return "" === h(this).attr("class")
        }).removeAttr("class")
      }, escapeEntities: function k(e) {
        return e.replace(/</gi, "&lt;").replace(/>/gi, "&gt;").replace(/"/gi, "&quot;").replace(/'/gi, "&#39;")
      }, checkIfEmpty: a, extractNode: m, extractNodeAttrs: v, extractDoctype: b, cleanBRs: function B() {
        for (var e = x.el.getElementsByTagName("br"), t = 0; t < e.length; t++) c(e[t])
      }, _init: function H() {
        x.events.$on(x.$el, "mousemove", "span.fr-word-select", function (e) {
          var t = window.getSelection();
          t = window.getSelection();
          var n = document.createRange();
          n.selectNodeContents(e.target), t.removeAllRanges(), t.addRange(n)
        }), x.$wp && (x.events.on("mouseup", E), x.events.on("keydown", E), x.events.on("contentChanged", a))
      }, _setHtml: C
    }
  }, xt.ENTER_P = 0, xt.ENTER_DIV = 1, xt.ENTER_BR = 2, xt.KEYCODE = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40,
    DELETE: 46,
    ZERO: 48,
    ONE: 49,
    TWO: 50,
    THREE: 51,
    FOUR: 52,
    FIVE: 53,
    SIX: 54,
    SEVEN: 55,
    EIGHT: 56,
    NINE: 57,
    FF_SEMICOLON: 59,
    FF_EQUALS: 61,
    QUESTION_MARK: 63,
    A: 65,
    B: 66,
    C: 67,
    D: 68,
    E: 69,
    F: 70,
    G: 71,
    H: 72,
    I: 73,
    J: 74,
    K: 75,
    L: 76,
    M: 77,
    N: 78,
    O: 79,
    P: 80,
    Q: 81,
    R: 82,
    S: 83,
    T: 84,
    U: 85,
    V: 86,
    W: 87,
    X: 88,
    Y: 89,
    Z: 90,
    META: 91,
    NUM_ZERO: 96,
    NUM_ONE: 97,
    NUM_TWO: 98,
    NUM_THREE: 99,
    NUM_FOUR: 100,
    NUM_FIVE: 101,
    NUM_SIX: 102,
    NUM_SEVEN: 103,
    NUM_EIGHT: 104,
    NUM_NINE: 105,
    NUM_MULTIPLY: 106,
    NUM_PLUS: 107,
    NUM_MINUS: 109,
    NUM_PERIOD: 110,
    NUM_DIVISION: 111,
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,
    FF_HYPHEN: 173,
    SEMICOLON: 186,
    DASH: 189,
    EQUALS: 187,
    COMMA: 188,
    HYPHEN: 189,
    PERIOD: 190,
    SLASH: 191,
    APOSTROPHE: 192,
    TILDE: 192,
    SINGLE_QUOTE: 222,
    OPEN_SQUARE_BRACKET: 219,
    BACKSLASH: 220,
    CLOSE_SQUARE_BRACKET: 221,
    IME: 229
  }, Object.assign(xt.DEFAULTS, {enter: xt.ENTER_P, multiLine: !0, tabSpaces: 0}), xt.MODULES.keys = function (d) {
    var f, n, r, a = d.$, p = !1;

    function u(e) {
      if (d.selection.isCollapsed()) if (["INPUT", "BUTTON", "TEXTAREA"].indexOf(e.target && e.target.tagName) < 0 && d.cursor.backspace(), d.helpers.isIOS()) {
        var t = d.selection.ranges(0);
        t.deleteContents(), t.insertNode(document.createTextNode("\u200b")), d.selection.get().modify("move", "forward", "character")
      } else ["INPUT", "BUTTON", "TEXTAREA"].indexOf(e.target && e.target.tagName) < 0 && e.preventDefault(), e.stopPropagation(); else e.preventDefault(), e.stopPropagation(), d.selection.remove();
      d.placeholder.refresh()
    }

    function h(e) {
      ["INPUT", "BUTTON", "TEXTAREA"].indexOf(e.target && e.target.tagName) < 0 && e.preventDefault(), e.stopPropagation(), "" !== d.selection.text() || d.selection.element().hasAttribute("contenteditable") && "false" === d.selection.element().getAttribute("contenteditable") || !d.selection.isCollapsed() && "IMG" == d.selection.element().tagName ? d.selection.remove() : d.cursor.del(), d.placeholder.refresh()
    }

    function e() {
      if (d.browser.mozilla && d.selection.isCollapsed() && !p) {
        var e = d.selection.ranges(0), t = e.startContainer, n = e.startOffset;
        t && t.nodeType === Node.TEXT_NODE && n <= t.textContent.length && 0 < n && 32 === t.textContent.charCodeAt(n - 1) && (d.selection.save(), d.spaces.normalize(), d.selection.restore())
      }
    }

    function t() {
      d.selection.isFull() && setTimeout(function () {
        var e = d.html.defaultTag();
        e ? d.$el.html("<".concat(e, ">").concat(xt.MARKERS, "<br/></").concat(e, ">")) : d.$el.html("".concat(xt.MARKERS, "<br/>")), d.selection.restore(), d.placeholder.refresh(), d.button.bulkRefresh(), d.undo.saveStep()
      }, 0)
    }

    function o() {
      p = !1
    }

    function i() {
      p = !1
    }

    function g() {
      var e = d.html.defaultTag();
      e ? d.$el.html("<".concat(e, ">").concat(xt.MARKERS, "<br/></").concat(e, ">")) : d.$el.html("".concat(xt.MARKERS, "<br/>")), d.selection.restore()
    }

    function m(e, t) {
      if (e.parentElement && (-1 < e.innerHTML.indexOf("<span") || -1 < e.parentElement.innerHTML.indexOf("<span") || -1 < e.parentElement.parentElement.innerHTML.indexOf("<span")) && (e.classList.contains("fr-img-space-wrap") || e.parentElement.classList.contains("fr-img-space-wrap") || e.parentElement.parentElement.classList.contains("fr-img-space-wrap"))) {
        if (a(e.parentElement).is("p")) {
          var n = e.parentElement.innerHTML;
          return (n = n.replace(/<br>/g, "")).length < 1 ? e.parentElement.insertAdjacentHTML("afterbegin", "&nbsp;") : "&nbsp;" != n && " " != n && "Backspace" == t.key ? u(t) : "&nbsp;" != n && " " != n && "Delete" == t.key && h(t), !0
        }
        if (a(e).is("p")) {
          var r = e.innerHTML.replace(/<br>/g, "");
          return r.length < 1 ? e.insertAdjacentHTML("afterbegin", "&nbsp;") : "&nbsp;" != r && " " != r && "Backspace" == t.key ? u(t) : "&nbsp;" != r && " " != r && "Delete" == t.key && h(t), !0
        }
      }
      return !1
    }

    function s(e) {
      var t = d.selection.element();
      if (t && 0 <= ["INPUT", "TEXTAREA"].indexOf(t.tagName)) return !0;
      if (e && b(e.which)) return !0;
      d.events.disableBlur();
      var n = e.which;
      if (16 === n) return !0;
      if ((f = n) === xt.KEYCODE.IME) return p = !0;
      if (p = !1, v(e)) return !0;
      var r = C(n) && !v(e) && !e.altKey, a = n === xt.KEYCODE.BACKSPACE || n === xt.KEYCODE.DELETE;
      if ((d.selection.isFull() && !d.opts.keepFormatOnDelete && !d.placeholder.isVisible() || a && d.placeholder.isVisible() && d.opts.keepFormatOnDelete) && (r || a) && (g(), !C(n))) return e.preventDefault(), !0;
      if (n === xt.KEYCODE.ENTER) !d.helpers.isIOS() && e.shiftKey || t.classList.contains("fr-inner") || t.parentElement.classList.contains("fr-inner") ? function o(e) {
        e.preventDefault(), e.stopPropagation(), d.opts.multiLine && (d.selection.isCollapsed() || d.selection.remove(), d.cursor.enter(!0))
      }(e) : function i(e) {
        d.opts.multiLine ? (d.helpers.isIOS() || (e.preventDefault(), e.stopPropagation()), d.selection.isCollapsed() || d.selection.remove(), d.cursor.enter()) : (e.preventDefault(), e.stopPropagation())
      }(e); else if (n === xt.KEYCODE.BACKSPACE && (e.metaKey || e.ctrlKey)) !function s() {
        setTimeout(function () {
          d.events.disableBlur(), d.events.focus()
        }, 0)
      }(); else if (n !== xt.KEYCODE.BACKSPACE || v(e) || e.altKey) if (n !== xt.KEYCODE.DELETE || v(e) || e.altKey || e.shiftKey) n === xt.KEYCODE.SPACE ? function l(e) {
        var t = d.selection.element();
        if (!d.helpers.isMobile() && t && "A" === t.tagName) {
          e.preventDefault(), e.stopPropagation(), d.selection.isCollapsed() || d.selection.remove();
          var n = d.markers.insert();
          if (n) {
            var r = n.previousSibling;
            !n.nextSibling && n.parentNode && "A" === n.parentNode.tagName ? (n.parentNode.insertAdjacentHTML("afterend", "&nbsp;".concat(xt.MARKERS)), n.parentNode.removeChild(n)) : (r && r.nodeType === Node.TEXT_NODE && 1 === r.textContent.length && 160 === r.textContent.charCodeAt(0) ? r.textContent += " " : n.insertAdjacentHTML("beforebegin", "&nbsp;"), n.outerHTML = xt.MARKERS), d.selection.restore()
          }
        }
      }(e) : n === xt.KEYCODE.TAB ? function c(e) {
        if (0 < d.opts.tabSpaces) if (d.selection.isCollapsed()) {
          d.undo.saveStep(), e.preventDefault(), e.stopPropagation();
          for (var t = "", n = 0; n < d.opts.tabSpaces; n++) t += "&nbsp;";
          d.html.insert(t), d.placeholder.refresh(), d.undo.saveStep()
        } else e.preventDefault(), e.stopPropagation(), e.shiftKey ? d.commands.outdent() : d.commands.indent()
      }(e) : v(e) || !C(e.which) || d.selection.isCollapsed() || e.ctrlKey || e.altKey || d.selection.remove(); else {
        if (m(t, e)) return e.preventDefault(), void e.stopPropagation();
        d.placeholder.isVisible() ? (d.opts.keepFormatOnDelete || g(), e.preventDefault(), e.stopPropagation()) : h(e)
      } else {
        if (m(t, e)) return e.preventDefault(), void e.stopPropagation();
        d.placeholder.isVisible() ? (d.opts.keepFormatOnDelete || g(), e.preventDefault(), e.stopPropagation()) : u(e)
      }
      d.events.enableBlur()
    }

    function l() {
      if (!d.$wp) return !0;
      var e;
      d.opts.height || d.opts.heightMax ? (e = d.position.getBoundingRect().top, (d.helpers.isIOS() || d.helpers.isAndroid()) && (e -= d.helpers.scrollTop()), d.opts.iframe && (e += d.$iframe.offset().top), e > d.$wp.offset().top - d.helpers.scrollTop() + d.$wp.height() - 20 && d.$wp.scrollTop(e + d.$wp.scrollTop() - (d.$wp.height() + d.$wp.offset().top) + d.helpers.scrollTop() + 20)) : (e = d.position.getBoundingRect().top, d.opts.toolbarBottom && (e += d.opts.toolbarStickyOffset), (d.helpers.isIOS() || d.helpers.isAndroid()) && (e -= d.helpers.scrollTop()), d.opts.iframe && (e += d.$iframe.offset().top, e -= d.helpers.scrollTop()), (e += d.opts.toolbarStickyOffset) > d.o_win.innerHeight - 20 && a(d.o_win).scrollTop(e + d.helpers.scrollTop() - d.o_win.innerHeight + 20), e = d.position.getBoundingRect().top, d.opts.toolbarBottom || (e -= d.opts.toolbarStickyOffset), (d.helpers.isIOS() || d.helpers.isAndroid()) && (e -= d.helpers.scrollTop()), d.opts.iframe && (e += d.$iframe.offset().top, e -= d.helpers.scrollTop()), e < 100 && a(d.o_win).scrollTop(e + d.helpers.scrollTop() - 100))
    }

    function c(e) {
      var t = d.selection.element();
      if (t && 0 <= ["INPUT", "TEXTAREA"].indexOf(t.tagName)) return !0;
      if (e && 0 === e.which && f && (e.which = f), d.helpers.isAndroid() && d.browser.mozilla) return !0;
      if (p) return !1;
      if (e && d.helpers.isIOS() && e.which === xt.KEYCODE.ENTER && d.doc.execCommand("undo"), !d.selection.isCollapsed()) return !0;
      if (e && (e.which === xt.KEYCODE.META || e.which === xt.KEYCODE.CTRL)) return !0;
      if (e && b(e.which)) return !0;
      if (e && !d.helpers.isIOS() && (e.which === xt.KEYCODE.ENTER || e.which === xt.KEYCODE.BACKSPACE || 37 <= e.which && e.which <= 40 && !d.browser.msie)) try {
        l()
      } catch (r) {
      }
      var n = d.selection.element();
      (function a(e) {
        if (!e) return !1;
        var t = e.innerHTML;
        return !!((t = t.replace(/<span[^>]*? class\s*=\s*["']?fr-marker["']?[^>]+>\u200b<\/span>/gi, "")) && /\u200B/.test(t) && 0 < t.replace(/\u200B/gi, "").length)
      })(n) && !d.node.hasClass(n, "fr-marker") && "IFRAME" !== n.tagName && function o(e) {
        return !d.helpers.isIOS() || 0 === ((e.textContent || "").match(/[\u3041-\u3096\u30A0-\u30FF\u4E00-\u9FFF\u3130-\u318F\uAC00-\uD7AF]/gi) || []).length
      }(n) && (d.selection.save(), function i(e) {
        for (var t = d.doc.createTreeWalker(e, NodeFilter.SHOW_TEXT, d.node.filter(function (e) {
          return /\u200B/gi.test(e.textContent)
        }), !1); t.nextNode();) {
          var n = t.currentNode;
          n.textContent = n.textContent.replace(/\u200B/gi, "")
        }
      }(n), d.selection.restore())
    }

    function v(e) {
      if (-1 !== navigator.userAgent.indexOf("Mac OS X")) {
        if (e.metaKey && !e.altKey) return !0
      } else if (e.ctrlKey && !e.altKey) return !0;
      return !1
    }

    function b(e) {
      if (e >= xt.KEYCODE.ARROW_LEFT && e <= xt.KEYCODE.ARROW_DOWN) return !0
    }

    function C(e) {
      if (e >= xt.KEYCODE.ZERO && e <= xt.KEYCODE.NINE) return !0;
      if (e >= xt.KEYCODE.NUM_ZERO && e <= xt.KEYCODE.NUM_MULTIPLY) return !0;
      if (e >= xt.KEYCODE.A && e <= xt.KEYCODE.Z) return !0;
      if (d.browser.webkit && 0 === e) return !0;
      switch (e) {
        case xt.KEYCODE.SPACE:
        case xt.KEYCODE.QUESTION_MARK:
        case xt.KEYCODE.NUM_PLUS:
        case xt.KEYCODE.NUM_MINUS:
        case xt.KEYCODE.NUM_PERIOD:
        case xt.KEYCODE.NUM_DIVISION:
        case xt.KEYCODE.SEMICOLON:
        case xt.KEYCODE.FF_SEMICOLON:
        case xt.KEYCODE.DASH:
        case xt.KEYCODE.EQUALS:
        case xt.KEYCODE.FF_EQUALS:
        case xt.KEYCODE.COMMA:
        case xt.KEYCODE.PERIOD:
        case xt.KEYCODE.SLASH:
        case xt.KEYCODE.APOSTROPHE:
        case xt.KEYCODE.SINGLE_QUOTE:
        case xt.KEYCODE.OPEN_SQUARE_BRACKET:
        case xt.KEYCODE.BACKSLASH:
        case xt.KEYCODE.CLOSE_SQUARE_BRACKET:
          return !0;
        default:
          return !1
      }
    }

    function E(e) {
      var t = e.which;
      if (v(e) || 37 <= t && t <= 40 || !C(t) && t !== xt.KEYCODE.DELETE && t !== xt.KEYCODE.BACKSPACE && t !== xt.KEYCODE.ENTER && t !== xt.KEYCODE.IME) return !0;
      n || (r = d.snapshot.get(), d.undo.canDo() || d.undo.saveStep()), clearTimeout(n), n = setTimeout(function () {
        n = null, d.undo.saveStep()
      }, Math.max(250, d.opts.typingTimer))
    }

    function y(e) {
      var t = e.which;
      if (v(e) || 37 <= t && t <= 40) return !0;
      r && n ? (d.undo.saveStep(r), r = null) : void 0 !== t && 0 !== t || r || n || d.undo.saveStep()
    }

    function L(e) {
      if (e && "BR" === e.tagName) return !1;
      try {
        return 0 === (e.textContent || "").length && e.querySelector && !e.querySelector(":scope > br") || e.childNodes && 1 === e.childNodes.length && e.childNodes[0].getAttribute && ("false" === e.childNodes[0].getAttribute("contenteditable") || d.node.hasClass(e.childNodes[0], "fr-img-caption"))
      } catch (t) {
        return !1
      }
    }

    function _(e) {
      var t = d.el.childNodes, n = d.html.defaultTag(), r = d.node.blockParent(d.selection.blocks()[0]);
      return r && "TR" == r.tagName && r.getAttribute("contenteditable") == undefined && (r = r.closest("table")), !d.node.isEditable(e.target) || r && "false" === r.getAttribute("contenteditable") ? d.toolbar.disable() : d.toolbar.enable(), !(!e.target || e.target === d.el) || (0 === t.length || void (t[0].offsetHeight + t[0].offsetTop <= e.offsetY ? L(t[t.length - 1]) && (n ? d.$el.append("<".concat(n, ">").concat(xt.MARKERS, "<br></").concat(n, ">")) : d.$el.append("".concat(xt.MARKERS, "<br>")), d.selection.restore(), l()) : e.offsetY <= 10 && L(t[0]) && (n ? d.$el.prepend("<".concat(n, ">").concat(xt.MARKERS, "<br></").concat(n, ">")) : d.$el.prepend("".concat(xt.MARKERS, "<br>")), d.selection.restore(), l())))
    }

    function w() {
      n && clearTimeout(n)
    }

    return {
      _init: function A() {
        d.events.on("keydown", E), d.events.on("input", e), d.events.on("mousedown", i), d.events.on("keyup input", y), d.events.on("keypress", o), d.events.on("keydown", s), d.events.on("keyup", c), d.events.on("destroy", w), d.events.on("html.inserted", c), d.events.on("cut", t), d.opts.multiLine && d.events.on("click", _)
      }, ctrlKey: v, isCharacter: C, isArrow: b, forceUndo: function T() {
        n && (clearTimeout(n), d.undo.saveStep(), r = null)
      }, isIME: function S() {
        return p
      }, isBrowserAction: function k(e) {
        var t = e.which;
        return v(e) || t === xt.KEYCODE.F5
      }, positionCaret: l
    }
  }, Object.assign(xt.DEFAULTS, {
    pastePlain: !1,
    pasteDeniedTags: ["colgroup", "col", "meta"],
    pasteDeniedAttrs: ["class", "id"],
    pasteAllowedStyleProps: [".*"],
    pasteAllowLocalImages: !1
  }), xt.MODULES.paste = function (S) {
    var i, s, k, o, x, R = S.$;

    function n(e, t) {
      try {
        S.win.localStorage.setItem("fr-copied-html", e), S.win.localStorage.setItem("fr-copied-text", t)
      } catch (n) {
      }
    }

    function e(e) {
      var t = S.html.getSelected();
      n(t, R(S.doc.createElement("div")).html(t).text()), "cut" === e.type && (S.undo.saveStep(), setTimeout(function () {
        S.selection.save(), S.html.wrap(), S.selection.restore(), S.events.focus(), S.undo.saveStep()
      }, 0))
    }

    var l = !1;

    function t(e) {
      if ("INPUT" === e.target.nodeName && "text" === e.target.type) return !0;
      if (S.edit.isDisabled()) return !1;
      if (c(e.target)) return !1;
      if (l) return !1;
      if ((e.originalEvent && (e = e.originalEvent), e && e.clipboardData && e.clipboardData.getData) && ((e.clipboardData || window.clipboardData).getData("text/html") || "").match('content="Microsoft OneNote')) return !1;
      if (!1 === S.events.trigger("paste.before", [e])) return e.preventDefault(), !1;
      if (e && e.clipboardData && e.clipboardData.getData) {
        var t = "", n = e.clipboardData.types;
        if (S.helpers.isArray(n)) for (var r = 0; r < n.length; r++) t += "".concat(n[r], ";"); else t = n;
        if (i = "", /text\/rtf/.test(t) && (s = e.clipboardData.getData("text/rtf")), /text\/html/.test(t) && !S.browser.safari ? i = e.clipboardData.getData("text/html") : /text\/rtf/.test(t) && S.browser.safari ? i = s : /public.rtf/.test(t) && S.browser.safari && (i = e.clipboardData.getData("text/rtf")), k = e.clipboardData.getData("text"), "" !== i) return d(), e.preventDefault && (e.stopPropagation(), e.preventDefault()), !1;
        i = null
      }
      return function a() {
        S.selection.save(), S.events.disableBlur(), i = null, o ? (o.html(""), S.browser.edge && S.opts.iframe && S.$el.append(o)) : (o = R('<div contenteditable="true" style="position: fixed; top: 0; left: -9999px; height: 100%; width: 0; word-break: break-all; overflow:hidden; z-index: 2147483647; line-height: 140%; -moz-user-select: text; -webkit-user-select: text; -ms-user-select: text; user-select: text;" tabIndex="-1"></div>'), S.browser.webkit || S.browser.mozilla ? (o.css("top", S.$sc.scrollTop()), S.$el.after(o)) : S.browser.edge && S.opts.iframe ? S.$el.append(o) : S.$box.after(o), S.events.on("destroy", function () {
          o.remove()
        }));
        var e;
        S.helpers.isIOS() && S.$sc && (e = S.$sc.scrollTop());
        S.opts.iframe && S.$el.attr("contenteditable", "false");
        o.focus(), S.helpers.isIOS() && S.$sc && S.$sc.scrollTop(e);
        S.win.setTimeout(d, 1)
      }(), !1
    }

    function c(e) {
      return e && "false" === e.contentEditable
    }

    function r(e) {
      if (e.originalEvent && (e = e.originalEvent), c(e.target)) return !1;
      if (e && e.dataTransfer && e.dataTransfer.getData) {
        var t = "", n = e.dataTransfer.types;
        if (S.helpers.isArray(n)) for (var r = 0; r < n.length; r++) t += "".concat(n[r], ";"); else t = n;
        if (i = "", /text\/rtf/.test(t) && (s = e.dataTransfer.getData("text/rtf")), /text\/html/.test(t) ? i = e.dataTransfer.getData("text/html") : /text\/rtf/.test(t) && S.browser.safari ? i = s : /text\/plain/.test(t) && !this.browser.mozilla && (i = S.html.escapeEntities(e.dataTransfer.getData("text/plain")).replace(/\n/g, "<br>")), "" !== i) {
          S.keys.forceUndo(), x = S.snapshot.get(), S.selection.save(), S.$el.find(".fr-marker").removeClass("fr-marker").addClass("fr-marker-helper");
          var a = S.markers.insertAtPoint(e);
          if (S.$el.find(".fr-marker").removeClass("fr-marker").addClass("fr-marker-placeholder"), S.$el.find(".fr-marker-helper").addClass("fr-marker").removeClass("fr-marker-helper"), S.selection.restore(), S.selection.remove(), S.$el.find(".fr-marker-placeholder").addClass("fr-marker").removeClass("fr-marker-placeholder"), !1 !== a) {
            var o = S.el.querySelector(".fr-marker");
            return R(o).replaceWith(xt.MARKERS), S.selection.restore(), d(), e.preventDefault && (e.stopPropagation(), e.preventDefault()), !1
          }
        } else i = null
      }
    }

    function d() {
      S.opts.iframe && S.$el.attr("contenteditable", "true"), S.browser.edge && S.opts.iframe && S.$box.after(o), x || (S.keys.forceUndo(), x = S.snapshot.get()), i || (i = o.get(0).innerHTML, k = o.text(), S.selection.restore(), S.events.enableBlur());
      var e = i.match(/(class="?Mso|class='?Mso|class="?Xl|class='?Xl|class=Xl|style="[^"]*\bmso-|style='[^']*\bmso-|w:WordDocument|LibreOffice)/gi),
        t = S.events.chainTrigger("paste.beforeCleanup", i);
      t && "string" == typeof t && (i = t), (!e || e && !1 !== S.events.trigger("paste.wordPaste", [i])) && a(i, e)
    }

    function M(e) {
      for (var t = "", n = 0; n++ < e;) t += "&nbsp;";
      return t
    }

    function a(e, t, n) {
      var r, a = null, o = null;
      if (0 <= e.toLowerCase().indexOf("<body")) {
        var i = "";
        0 <= e.indexOf("<style") && (i = e.replace(/[.\s\S\w\W<>]*(<style[^>]*>[\s]*[.\s\S\w\W<>]*[\s]*<\/style>)[.\s\S\w\W<>]*/gi, "$1")), e = (e = (e = i + e.replace(/[.\s\S\w\W<>]*<body[^>]*>[\s]*([.\s\S\w\W<>]*)[\s]*<\/body>[.\s\S\w\W<>]*/gi, "$1")).replace(/<pre(?:[\w\W]*?)>(?:[\w\W]*?)<\/pre>/g, function (e) {
          return e.replace(/\n/g, "<br />")
        })).replace(/ \n/g, " ").replace(/\n /g, " ").replace(/([^>])\n([^<])/g, "$1 $2")
      }
      var s = !1;
      0 <= e.indexOf('id="docs-internal-guid') && (e = e.replace(/^[\w\W\s\S]* id="docs-internal-guid[^>]*>([\w\W\s\S]*)<\/b>[\w\W\s\S]*$/g, "$1"), s = !0), 0 <= e.indexOf('content="Sheets"') && (e = e.replace(/width:0px;/g, ""));
      var l = !1;
      if (!t) if ((l = function L() {
        var e = null;
        try {
          e = S.win.localStorage.getItem("fr-copied-text")
        } catch (t) {
        }
        return !(!e || !k || k.replace(/\u00A0/gi, " ").replace(/\r|\n/gi, "") !== e.replace(/\u00A0/gi, " ").replace(/\r|\n/gi, "") && k.replace(/\s/g, "") !== e.replace(/\s/g, ""))
      }()) && (e = S.win.localStorage.getItem("fr-copied-html")), l) e = S.clean.html(e, S.opts.pasteDeniedTags, S.opts.pasteDeniedAttrs); else {
        var c = S.opts.htmlAllowedStyleProps;
        S.opts.htmlAllowedStyleProps = S.opts.pasteAllowedStyleProps, S.opts.htmlAllowComments = !1, e = (e = (e = e.replace(/<span class="Apple-tab-span">\s*<\/span>/g, M(S.opts.tabSpaces || 4))).replace(/<span class="Apple-tab-span" style="white-space:pre">(\t*)<\/span>/g, function (e, t) {
          return M(t.length * (S.opts.tabSpaces || 4))
        })).replace(/\t/g, M(S.opts.tabSpaces || 4)), e = S.clean.html(e, S.opts.pasteDeniedTags, S.opts.pasteDeniedAttrs), S.opts.htmlAllowedStyleProps = c, S.opts.htmlAllowComments = !0, e = (e = (e = O(e)).replace(/\r/g, "")).replace(/^ */g, "").replace(/ *$/g, "")
      }
      !t || S.wordPaste && n || (0 === (e = e.replace(/^\n*/g, "").replace(/^ /g, "")).indexOf("<colgroup>") && (e = "<table>".concat(e, "</table>")), e = O(e = function _(e) {
        var t;
        e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = e.replace(/<p(.*?)class="?'?MsoListParagraph"?'? ([\s\S]*?)>([\s\S]*?)<\/p>/gi, "<ul><li>$3</li></ul>")).replace(/<p(.*?)class="?'?NumberedText"?'? ([\s\S]*?)>([\s\S]*?)<\/p>/gi, "<ol><li>$3</li></ol>")).replace(/<p(.*?)class="?'?MsoListParagraphCxSpFirst"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi, "<ul><li$3>$5</li>")).replace(/<p(.*?)class="?'?NumberedTextCxSpFirst"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi, "<ol><li$3>$5</li>")).replace(/<p(.*?)class="?'?MsoListParagraphCxSpMiddle"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi, "<li$3>$5</li>")).replace(/<p(.*?)class="?'?NumberedTextCxSpMiddle"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi, "<li$3>$5</li>")).replace(/<p(.*?)class="?'?MsoListBullet"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi, "<li$3>$5</li>")).replace(/<p(.*?)class="?'?MsoListParagraphCxSpLast"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi, "<li$3>$5</li></ul>")).replace(/<p(.*?)class="?'?NumberedTextCxSpLast"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi, "<li$3>$5</li></ol>")).replace(/<span([^<]*?)style="?'?mso-list:Ignore"?'?([\s\S]*?)>([\s\S]*?)<span/gi, "<span><span")).replace(/<!--\[if !supportLists\]-->([\s\S]*?)<!--\[endif\]-->/gi, "")).replace(/<!\[if !supportLists\]>([\s\S]*?)<!\[endif\]>/gi, "")).replace(/(\n|\r| class=(")?Mso[a-zA-Z0-9]+(")?)/gi, " ")).replace(/<!--[\s\S]*?-->/gi, "")).replace(/<(\/)*(meta|link|span|\\?xml:|st1:|o:|font)(.*?)>/gi, "");
        var n, r = ["style", "script", "applet", "embed", "noframes", "noscript"];
        for (t = 0; t < r.length; t++) {
          var a = new RegExp("<".concat(r[t], ".*?").concat(r[t], "(.*?)>"), "gi");
          e = e.replace(a, "")
        }
        for (e = (e = (e = e.replace(/&nbsp;/gi, " ")).replace(/<td([^>]*)><\/td>/g, "<td$1><br></td>")).replace(/<th([^>]*)><\/th>/g, "<th$1><br></th>"); (e = (n = e).replace(/<[^/>][^>]*><\/[^>]+>/gi, "")) !== n;) ;
        e = (e = e.replace(/<lilevel([^1])([^>]*)>/gi, '<li data-indent="true"$2>')).replace(/<lilevel1([^>]*)>/gi, "<li$1>"), e = (e = (e = S.clean.html(e, S.opts.pasteDeniedTags, S.opts.pasteDeniedAttrs)).replace(/<a>(.[^<]+)<\/a>/gi, "$1")).replace(/<br> */g, "<br>");
        var o = S.o_doc.createElement("div");
        o.innerHTML = e;
        var i = o.querySelectorAll("li[data-indent]");
        for (t = 0; t < i.length; t++) {
          var s = i[t], l = s.previousElementSibling;
          if (l && "LI" === l.tagName) {
            var c = l.querySelector(":scope > ul, :scope > ol");
            c || (c = document.createElement("ul"), l.appendChild(c)), c.appendChild(s)
          } else s.removeAttribute("data-indent")
        }
        return S.html.cleanBlankSpaces(o), e = o.innerHTML
      }(e))), S.opts.pastePlain && (e = function w(e) {
        var t, n = null, r = S.doc.createElement("div");
        r.innerHTML = e;
        var a = r.querySelectorAll("p, div, h1, h2, h3, h4, h5, h6, pre, blockquote");
        for (t = 0; t < a.length; t++) (n = a[t]).outerHTML = "<".concat(S.html.defaultTag() || "DIV", ">").concat(n.innerText, "</").concat(S.html.defaultTag() || "DIV", ">");
        for (t = (a = r.querySelectorAll("*:not(".concat("p, div, h1, h2, h3, h4, h5, h6, pre, blockquote, ul, ol, li, table, tbody, thead, tr, td, br, img".split(",").join("):not("), ")"))).length - 1; 0 <= t; t--) (n = a[t]).outerHTML = n.innerHTML;
        return function o(e) {
          for (var t = S.node.contents(e), n = 0; n < t.length; n++) t[n].nodeType !== Node.TEXT_NODE && t[n].nodeType !== Node.ELEMENT_NODE ? t[n].parentNode.removeChild(t[n]) : o(t[n])
        }(r), r.innerHTML
      }(e));
      var d = S.events.chainTrigger("paste.afterCleanup", e);
      if ("string" == typeof d && (e = d), "" !== e) {
        var f = S.o_doc.createElement("div");
        0 <= (f.innerHTML = e).indexOf("<body>") ? (S.html.cleanBlankSpaces(f), S.spaces.normalize(f, !0)) : S.spaces.normalize(f);
        var p = f.getElementsByTagName("span");
        for (r = p.length - 1; 0 <= r; r--) {
          var u = p[r];
          0 === u.attributes.length && (u.outerHTML = u.innerHTML)
        }
        if (!0 === S.opts.linkAlwaysBlank) {
          var h = f.getElementsByTagName("a");
          for (r = h.length - 1; 0 <= r; r--) {
            var g = h[r];
            g.getAttribute("target") || g.setAttribute("target", "_blank")
          }
        }
        var m = S.selection.element(), v = !1;
        if (m && R(m).parentsUntil(S.el, "ul, ol").length && (v = !0), v) {
          var b = f.children;
          1 === b.length && 0 <= ["OL", "UL"].indexOf(b[0].tagName) && (b[0].outerHTML = b[0].innerHTML)
        }
        if (!s) {
          var C = f.getElementsByTagName("br");
          for (r = C.length - 1; 0 <= r; r--) {
            var E = C[r];
            S.node.isBlock(E.previousSibling) && E.parentNode.removeChild(E)
          }
        }
        if (S.opts.enter === xt.ENTER_BR) for (r = (a = f.querySelectorAll("p, div")).length - 1; 0 <= r; r--) 0 === (o = a[r]).attributes.length && (o.outerHTML = o.innerHTML + (o.nextSibling && !S.node.isEmpty(o) ? "<br>" : "")); else if (S.opts.enter === xt.ENTER_DIV) for (r = (a = f.getElementsByTagName("p")).length - 1; 0 <= r; r--) 0 === (o = a[r]).attributes.length && (o.outerHTML = "<div>".concat(o.innerHTML, "</div>")); else S.opts.enter === xt.ENTER_P && 1 === f.childNodes.length && "P" === f.childNodes[0].tagName && 0 === f.childNodes[0].attributes.length && (f.childNodes[0].outerHTML = f.childNodes[0].innerHTML);
        if (f.children && 0 < f.children.length) if (S.opts.trackChangesEnabled) for (var y = 0; y < f.children.length; y++) f.children[y].setAttribute("id", "isPasted"); else f.children[0].setAttribute("id", "isPasted");
        e = f.innerHTML, l && (e = function A(e) {
          var t, n = S.o_doc.createElement("div");
          n.innerHTML = e;
          var r = n.querySelectorAll("*:empty:not(td):not(th):not(tr):not(iframe):not(svg):not(".concat(xt.VOID_ELEMENTS.join("):not("), "):not(").concat(S.opts.htmlAllowedEmptyTags.join("):not("), ")"));
          for (; r.length;) {
            for (t = 0; t < r.length; t++) r[t].parentNode.removeChild(r[t]);
            r = n.querySelectorAll("*:empty:not(td):not(th):not(tr):not(iframe):not(svg):not(".concat(xt.VOID_ELEMENTS.join("):not("), "):not(").concat(S.opts.htmlAllowedEmptyTags.join("):not("), ")"))
          }
          return n.innerHTML
        }(e)), S.html.insert(e, !0)
      }
      !function T() {
        S.events.trigger("paste.after")
      }(), S.undo.saveStep(x), x = null, S.undo.saveStep()
    }

    function f(e) {
      for (var t = e.length - 1; 0 <= t; t--) e[t].attributes && e[t].attributes.length && e.splice(t, 1);
      return e
    }

    function O(e) {
      var t, n = S.o_doc.createElement("div");
      n.innerHTML = e;
      for (var r = f(Array.prototype.slice.call(n.querySelectorAll(":scope > div:not([style]), td > div:not([style]), th > div:not([style]), li > div:not([style])"))); r.length;) {
        var a = r[r.length - 1];
        if (S.html.defaultTag() && "div" !== S.html.defaultTag()) a.querySelector(S.html.blockTagsQuery()) ? a.outerHTML = a.innerHTML : a.outerHTML = "<".concat(S.html.defaultTag(), ">").concat(a.innerHTML, "</").concat(S.html.defaultTag(), ">"); else {
          var o = a.querySelectorAll("*");
          !o.length || "BR" !== o[o.length - 1].tagName && 0 === a.innerText.length ? a.outerHTML = a.innerHTML + (a.nextSibling ? "<br>" : "") : !o.length || "BR" !== o[o.length - 1].tagName || o[o.length - 1].nextSibling ? a.outerHTML = a.innerHTML + (a.nextSibling ? "<br>" : "") : a.outerHTML = a.innerHTML
        }
        r = f(Array.prototype.slice.call(n.querySelectorAll(":scope > div:not([style]), td > div:not([style]), th > div:not([style]), li > div:not([style])")))
      }
      for (r = f(Array.prototype.slice.call(n.querySelectorAll("div:not([style])"))); r.length;) {
        for (t = 0; t < r.length; t++) {
          var i = r[t], s = i.innerHTML.replace(/\u0009/gi, "").trim();
          i.outerHTML = s
        }
        r = f(Array.prototype.slice.call(n.querySelectorAll("div:not([style])")))
      }
      return n.innerHTML
    }

    function p() {
      S.el.removeEventListener("copy", e), S.el.removeEventListener("cut", e), S.el.removeEventListener("paste", t)
    }

    return {
      _init: function u() {
        S.el.addEventListener("copy", e), S.el.addEventListener("cut", e), S.el.addEventListener("paste", t, {capture: !0}), S.events.on("drop", r), S.browser.msie && S.browser.version < 11 && (S.events.on("mouseup", function (e) {
          2 === e.button && (setTimeout(function () {
            l = !1
          }, 50), l = !0)
        }, !0), S.events.on("beforepaste", t)), S.events.on("destroy", p)
      }, cleanEmptyTagsAndDivs: O, getRtfClipboard: function h() {
        return s
      }, saveCopiedText: n, clean: a
    }
  }, Object.assign(xt.DEFAULTS, {
    shortcutsEnabled: [],
    shortcutsHint: !0
  }), xt.SHORTCUTS_MAP = {}, xt.RegisterShortcut = function (e, t, n, r, a, o) {
    xt.SHORTCUTS_MAP[(a ? "^" : "") + (o ? "@" : "") + e] = {
      cmd: t,
      val: n,
      letter: r,
      shift: a,
      option: o
    }, xt.DEFAULTS.shortcutsEnabled.push(t)
  }, xt.RegisterShortcut(xt.KEYCODE.E, "show", null, "E", !1, !1), xt.RegisterShortcut(xt.KEYCODE.B, "bold", null, "B", !1, !1), xt.RegisterShortcut(xt.KEYCODE.I, "italic", null, "I", !1, !1), xt.RegisterShortcut(xt.KEYCODE.U, "underline", null, "U", !1, !1), xt.RegisterShortcut(xt.KEYCODE.S, "strikeThrough", null, "S", !1, !1), xt.RegisterShortcut(xt.KEYCODE.CLOSE_SQUARE_BRACKET, "indent", null, "]", !1, !1), xt.RegisterShortcut(xt.KEYCODE.OPEN_SQUARE_BRACKET, "outdent", null, "[", !1, !1), xt.RegisterShortcut(xt.KEYCODE.Z, "undo", null, "Z", !1, !1), xt.RegisterShortcut(xt.KEYCODE.Z, "redo", null, "Z", !0, !1), xt.RegisterShortcut(xt.KEYCODE.Y, "redo", null, "Y", !1, !1), xt.MODULES.shortcuts = function (s) {
    var r = null;
    var l = !1;

    function e(e) {
      if (!s.core.hasFocus()) return !0;
      var t = e.which, n = -1 !== navigator.userAgent.indexOf("Mac OS X") ? e.metaKey : e.ctrlKey;
      if ("keyup" === e.type && l && t !== xt.KEYCODE.META) return l = !1;
      "keydown" === e.type && (l = !1);
      var r = (e.shiftKey ? "^" : "") + (e.altKey ? "@" : "") + t, a = s.node.blockParent(s.selection.blocks()[0]);
      if (a && "TR" == a.tagName && a.getAttribute("contenteditable") == undefined && (a = a.closest("table")), n && xt.SHORTCUTS_MAP[r] && (!a || "false" !== a.getAttribute("contenteditable"))) {
        var o = xt.SHORTCUTS_MAP[r].cmd;
        if (o && 0 <= s.opts.shortcutsEnabled.indexOf(o)) {
          var i = xt.SHORTCUTS_MAP[r].val;
          if (!1 === s.events.trigger("shortcut", [e, o, i])) return !(l = !0);
          if (o && (s.commands[o] || xt.COMMANDS[o] && xt.COMMANDS[o].callback)) return e.preventDefault(), e.stopPropagation(), "keydown" === e.type && ((s.commands[o] || xt.COMMANDS[o].callback)(), l = !0), !1
        }
      }
    }

    return {
      _init: function t() {
        s.events.on("keydown", e, !0), s.events.on("keyup", e, !0)
      }, get: function a(e) {
        if (!s.opts.shortcutsHint) return null;
        if (!r) for (var t in r = {}, xt.SHORTCUTS_MAP) Object.prototype.hasOwnProperty.call(xt.SHORTCUTS_MAP, t) && 0 <= s.opts.shortcutsEnabled.indexOf(xt.SHORTCUTS_MAP[t].cmd) && (r["".concat(xt.SHORTCUTS_MAP[t].cmd, ".").concat(xt.SHORTCUTS_MAP[t].val || "")] = {
          shift: xt.SHORTCUTS_MAP[t].shift,
          option: xt.SHORTCUTS_MAP[t].option,
          letter: xt.SHORTCUTS_MAP[t].letter
        });
        var n = r[e];
        return n ? (s.helpers.isMac() ? String.fromCharCode(8984) : "".concat(s.language.translate("Ctrl"), "+")) + (n.shift ? s.helpers.isMac() ? String.fromCharCode(8679) : "".concat(s.language.translate("Shift"), "+") : "") + (n.option ? s.helpers.isMac() ? String.fromCharCode(8997) : "".concat(s.language.translate("Alt"), "+") : "") + n.letter : null
      }
    }
  }, xt.MODULES.snapshot = function (l) {
    function n(e) {
      for (var t = e.parentNode.childNodes, n = 0, r = null, a = 0; a < t.length; a++) {
        if (r) {
          var o = t[a].nodeType === Node.TEXT_NODE && "" === t[a].textContent,
            i = r.nodeType === Node.TEXT_NODE && t[a].nodeType === Node.TEXT_NODE,
            s = r.nodeType === Node.TEXT_NODE && "" === r.textContent;
          o || i || s || n++
        }
        if (t[a] === e) return n;
        r = t[a]
      }
    }

    function a(e) {
      var t = [];
      if (!e.parentNode) return [];
      for (; !l.node.isElement(e);) t.push(n(e)), e = e.parentNode;
      return t.reverse()
    }

    function o(e, t) {
      for (; e && e.nodeType === Node.TEXT_NODE;) {
        var n = e.previousSibling;
        n && n.nodeType === Node.TEXT_NODE && (t += n.textContent.length), e = n
      }
      return t
    }

    function c(e) {
      for (var t = l.el, n = 0; n < e.length; n++) t = t.childNodes[e[n]];
      return t
    }

    function r(e, t) {
      try {
        var n = c(t.scLoc), r = t.scOffset, a = c(t.ecLoc), o = t.ecOffset, i = l.doc.createRange();
        i.setStart(n, r), i.setEnd(a, o), e.addRange(i)
      } catch (s) {
      }
    }

    return {
      get: function i() {
        var e, t = {};
        if (l.events.trigger("snapshot.before"), t.html = (l.$wp ? l.$el.html() : l.$oel.get(0).outerHTML).replace(/ style=""/g, ""), t.ranges = [], l.$wp && l.selection.inEditor() && l.core.hasFocus()) for (var n = l.selection.ranges(), r = 0; r < n.length; r++) t.ranges.push({
          scLoc: a((e = n[r]).startContainer),
          scOffset: o(e.startContainer, e.startOffset),
          ecLoc: a(e.endContainer),
          ecOffset: o(e.endContainer, e.endOffset)
        });
        return l.events.trigger("snapshot.after", [t]), t
      }, restore: function s(e) {
        l.$el.html() !== e.html && (l.opts.htmlExecuteScripts ? l.$el.html(e.html) : l.el.innerHTML = e.html);
        var t = l.selection.get();
        l.selection.clear(), l.events.focus(!0);
        for (var n = 0; n < e.ranges.length; n++) r(t, e.ranges[n])
      }, equal: function d(e, t) {
        return e.html === t.html && (!l.core.hasFocus() || JSON.stringify(e.ranges) === JSON.stringify(t.ranges))
      }
    }
  }, xt.MODULES.undo = function (n) {
    function e(e) {
      var t = e.which;
      n.keys.ctrlKey(e) && (t === xt.KEYCODE.Z && e.shiftKey && e.preventDefault(), t === xt.KEYCODE.Z && e.preventDefault())
    }

    var t = null;

    function r() {
      if (n.undo_stack && !n.undoing) for (; n.undo_stack.length > n.undo_index;) n.undo_stack.pop()
    }

    function a() {
      n.undo_index = 0, n.undo_stack = []
    }

    function o() {
      n.undo_stack = []
    }

    return {
      _init: function i() {
        a(), n.events.on("initialized", function () {
          t = (n.$wp ? n.$el.html() : n.$oel.get(0).outerHTML).replace(/ style=""/g, "")
        }), n.events.on("blur", function () {
          n.el.querySelector(".fr-dragging") || n.undo.saveStep()
        }), n.events.on("keydown", e), n.events.on("destroy", o)
      }, run: function s() {
        if (1 < n.undo_index) {
          n.undoing = !0;
          var e = n.undo_stack[--n.undo_index - 1];
          clearTimeout(n._content_changed_timer), n.snapshot.restore(e), t = e.html, n.popups.hideAll(), n.toolbar.enable(), n.events.trigger("contentChanged"), n.events.trigger("commands.undo"), n.undoing = !1
        }
      }, redo: function l() {
        if (n.undo_index < n.undo_stack.length) {
          n.undoing = !0;
          var e = n.undo_stack[n.undo_index++];
          clearTimeout(n._content_changed_timer), n.snapshot.restore(e), t = e.html, n.popups.hideAll(), n.toolbar.enable(), n.events.trigger("contentChanged"), n.events.trigger("commands.redo"), n.undoing = !1
        }
      }, canDo: function c() {
        return !(0 === n.undo_stack.length || n.undo_index <= 1)
      }, canRedo: function d() {
        return n.undo_index !== n.undo_stack.length
      }, dropRedo: r, reset: a, saveStep: function f(e) {
        if (n.undo_stack && !n.undoing && !n.el.querySelector(".fr-marker")) if (void 0 === e) {
          if ((e = n.snapshot.get()) && e.html && n.undo_stack[n.undo_stack.length - 1] && e.html === n.undo_stack[n.undo_stack.length - 1].html) return;
          n.undo_stack[n.undo_index - 1] && n.snapshot.equal(n.undo_stack[n.undo_index - 1], e) || (r(), n.undo_stack.push(e), n.undo_index++, function a(e, t) {
            var n = t.split("fr-selected-cell").join("");
            n = n.split(' class=""').join("");
            e = e || '';
            var r = e.split("fr-selected-cell").join("");
            return n === (r = r.split(' class=""').join(""))
          }(t, e.html) || (n.events.trigger("contentChanged"), t = e.html))
        } else r(), 0 < n.undo_index ? n.undo_stack[n.undo_index - 1] = e : (n.undo_stack.push(e), n.undo_index++)
      }
    }
  }, Object.assign(xt.DEFAULTS, {
    height: null,
    heightMax: null,
    heightMin: null,
    width: null
  }), xt.MODULES.size = function (e) {
    function t() {
      n(), e.opts.height && e.$el.css("minHeight", e.opts.height - e.helpers.getPX(e.$el.css("padding-top")) - e.helpers.getPX(e.$el.css("padding-bottom"))), e.$iframe.height(e.$el.outerHeight(!0))
    }

    function n() {
      e.opts.heightMin ? e.$el.css("minHeight", e.opts.heightMin) : e.$el.css("minHeight", ""), e.opts.heightMax ? (e.$wp.css("maxHeight", e.opts.heightMax), e.$wp.css("overflow", "auto")) : (e.$wp.css("maxHeight", ""), e.$wp.css("overflow", "")), e.opts.height ? (e.$wp.css("height", e.opts.height), e.$wp.css("overflow", "auto"), e.$el.css("minHeight", e.opts.height - e.helpers.getPX(e.$el.css("padding-top")) - e.helpers.getPX(e.$el.css("padding-bottom")))) : (e.$wp.css("height", ""), e.opts.heightMin || e.$el.css("minHeight", ""), e.opts.heightMax || e.$wp.css("overflow", "")), e.opts.width && e.$box.width(e.opts.width)
    }

    return {
      _init: function r() {
        if (!e.$wp) return !1;
        n(), e.$iframe && 0 == e.opts.fullPage && (e.events.on("keyup keydown", function () {
          setTimeout(t, 0)
        }, !0), e.events.on("commands.after html.set init initialized paste.after", t))
      }, syncIframe: t, refresh: n
    }
  }, Object.assign(xt.DEFAULTS, {
    documentReady: !1,
    editorClass: null,
    typingTimer: 500,
    iframe: !1,
    requestWithCORS: !0,
    requestWithCredentials: !1,
    requestHeaders: {},
    useClasses: !0,
    spellcheck: !0,
    iframeDefaultStyle: 'html{margin:0px;height:auto;}body{height:auto;padding:20px;background:transparent;color:#000000;position:relative;z-index: 2;-webkit-user-select:auto;margin:0px;overflow:hidden;min-height:20px;}body:after{content:"";display:block;clear:both;}body::-moz-selection{background:#b5d6fd;color:#000;}body::selection{background:#b5d6fd;color:#000;}',
    iframeStyle: "",
    iframeStyleFiles: [],
    direction: "auto",
    zIndex: 1,
    tabIndex: null,
    disableRightClick: !1,
    scrollableContainer: "body",
    keepFormatOnDelete: !1,
    theme: null
  }), xt.MODULES.core = function (i) {
    var r = i.$;

    function n() {
      if (i.$box.addClass("fr-box".concat(i.opts.editorClass ? " ".concat(i.opts.editorClass) : "")), i.$box.attr("role", "application"), i.$wp.addClass("fr-wrapper"), i.opts.documentReady && i.$box.addClass("fr-document"), function a() {
        i.opts.iframe || i.$el.addClass("fr-element fr-view")
      }(), i.opts.iframe) {
        i.$iframe.addClass("fr-iframe"), i.$el.addClass("fr-view");
        for (var e = 0; e < i.o_doc.styleSheets.length; e++) {
          var t = void 0;
          try {
            t = i.o_doc.styleSheets[e].cssRules
          } catch (o) {
          }
          if (t) for (var n = 0, r = t.length; n < r; n++) !t[n].selectorText || 0 !== t[n].selectorText.indexOf(".fr-view") && 0 !== t[n].selectorText.indexOf(".fr-element") || 0 < t[n].style.cssText.length && (0 === t[n].selectorText.indexOf(".fr-view") ? i.opts.iframeStyle += "".concat(t[n].selectorText.replace(/\.fr-view/g, "body"), "{").concat(t[n].style.cssText, "}") : i.opts.iframeStyle += "".concat(t[n].selectorText.replace(/\.fr-element/g, "body"), "{").concat(t[n].style.cssText, "}"))
        }
      }
      "auto" !== i.opts.direction && i.$box.removeClass("fr-ltr fr-rtl").addClass("fr-".concat(i.opts.direction)), i.$el.attr("dir", i.opts.direction), i.$wp.attr("dir", i.opts.direction), 1 < i.opts.zIndex && i.$box.css("z-index", i.opts.zIndex), i.opts.theme && i.$box.addClass("".concat(i.opts.theme, "-theme")), i.opts.tabIndex = i.opts.tabIndex || i.$oel.attr("tabIndex"), i.opts.tabIndex && i.$el.attr("tabIndex", i.opts.tabIndex)
    }

    return {
      _init: function a() {
        if (xt.INSTANCES.push(i), function e() {
          i.drag_support = {
            filereader: "undefined" != typeof FileReader,
            formdata: Boolean(i.win.FormData),
            progress: "upload" in new XMLHttpRequest
          }
        }(), i.$wp) {
          n(), i.html.set(i._original_html), i.$el.attr("spellcheck", i.opts.spellcheck), i.helpers.isMobile() && (i.$el.attr("autocomplete", i.opts.spellcheck ? "on" : "off"), i.$el.attr("autocorrect", i.opts.spellcheck ? "on" : "off"), i.$el.attr("autocapitalize", i.opts.spellcheck ? "on" : "off")), i.opts.disableRightClick && i.events.$on(i.$el, "contextmenu", function (e) {
            if (2 === e.button) return e.preventDefault(), e.stopPropagation(), !1
          });
          try {
            i.doc.execCommand("styleWithCSS", !1, !1)
          } catch (t) {
          }
        }
        "TEXTAREA" === i.$oel.get(0).tagName && (i.events.on("contentChanged", function () {
          i.$oel.val(i.html.get())
        }), i.events.on("form.submit", function () {
          i.$oel.val(i.html.get())
        }), i.events.on("form.reset", function () {
          i.html.set(i._original_html)
        }), i.$oel.val(i.html.get())), i.helpers.isIOS() && i.events.$on(i.$doc, "selectionchange", function () {
          i.$doc.get(0).hasFocus() || i.$win.get(0).focus()
        }), i.events.trigger("init"), i.opts.autofocus && !i.opts.initOnClick && i.$wp && i.events.on("initialized", function () {
          i.events.focus(!0)
        })
      }, destroy: function t(e) {
        "TEXTAREA" === i.$oel.get(0).tagName && i.$oel.val(e), i.$box && i.$box.removeAttr("role"), i.$wp && ("TEXTAREA" === i.$oel.get(0).tagName ? (i.$el.html(""), i.$wp.html(""), i.$box.replaceWith(i.$oel), i.$oel.show()) : (i.$wp.replaceWith(e), i.$el.html(""), i.$box.removeClass("fr-view fr-ltr fr-box ".concat(i.opts.editorClass || "")), i.opts.theme && i.$box.addClass("".concat(i.opts.theme, "-theme")))), this.$wp = null, this.$el = null, this.el = null, this.$box = null
      }, isEmpty: function e() {
        return i.node.isEmpty(i.el)
      }, getXHR: function o(e, t) {
        var n = new XMLHttpRequest;
        for (var r in n.open(t, e, !0), i.opts.requestWithCredentials && (n.withCredentials = !0), i.opts.requestHeaders) Object.prototype.hasOwnProperty.call(i.opts.requestHeaders, r) && n.setRequestHeader(r, i.opts.requestHeaders[r]);
        return n
      }, injectStyle: function s(e) {
        if (i.opts.iframe) {
          i.$head.find("style[data-fr-style], link[data-fr-style]").remove(), i.$head.append('<style data-fr-style="true">'.concat(e, "</style>"));
          for (var t = 0; t < i.opts.iframeStyleFiles.length; t++) {
            var n = r('<link data-fr-style="true" rel="stylesheet" href="'.concat(i.opts.iframeStyleFiles[t], '">'));
            n.get(0).addEventListener("load", i.size.syncIframe), i.$head.append(n)
          }
        }
      }, hasFocus: function l() {
        return i.browser.mozilla && i.helpers.isMobile() ? i.selection.inEditor() : i.node.hasFocus(i.el) || 0 < i.$el.find("*:focus").length
      }, sameInstance: function c(e) {
        if (!e) return !1;
        var t = e.data("instance");
        return !!t && t.id === i.id
      }
    }
  }, xt.POPUP_TEMPLATES = {"text.edit": "[_EDIT_]"}, xt.RegisterTemplate = function (e, t) {
    xt.POPUP_TEMPLATES[e] = t
  }, xt.MODULES.popups = function (u) {
    var r, d = u.$;
    u.shared.popups || (u.shared.popups = {});
    var h, g = u.shared.popups;

    function m(e, t) {
      t.isVisible() || (t = u.$sc), t.is(g[e].data("container")) || (g[e].data("container", t), t.append(g[e]))
    }

    function a(e) {
      var t;
      e.find(".fr-upload-progress").addClass("fr-height-set"), e.find(".fr-upload-progress").removeClass("fr-height-auto"), u.popups.get("filesManager.insert").removeClass("fr-height-auto"), e.find(".fr-files-upload-layer").hasClass("fr-active") && (t = 1), e.find(".fr-files-by-url-layer").hasClass("fr-active") && (t = 2), e.find(".fr-files-embed-layer").hasClass("fr-active") && (t = 3), e.find(".fr-upload-progress-layer").get(0).clientHeight + 10 < e.find(".fr-upload-progress").get(0).clientHeight && e.find(".fr-upload-progress").addClass("fr-height-auto"), 400 < e[0].clientHeight && (e[0].childNodes[4].style.height = "".concat(e[0].clientHeight - (e[0].childNodes[0].clientHeight + e[0].childNodes[t].clientHeight) - 80, "px"))
    }

    var o = 2e3;

    function i() {
      d(this).toggleClass("fr-not-empty", !0)
    }

    function s() {
      var e = d(this);
      e.toggleClass("fr-not-empty", "" !== e.val())
    }

    function v(e) {
      return g[e] && u.node.hasClass(g[e], "fr-active") && u.core.sameInstance(g[e]) || !1
    }

    function b(e) {
      for (var t in g) if (Object.prototype.hasOwnProperty.call(g, t) && v(t) && (void 0 === e || g[t].data("instance") === e)) return g[t];
      return !1
    }

    function n(e) {
      var t = null;
      if (t = "string" != typeof e ? e : g[e], "filesManager.insert" === e && u.filesManager !== undefined && u.filesManager.isChildWindowOpen()) return !1;
      if (t && u.node.hasClass(t, "fr-active") && (t.removeClass("fr-active fr-above"), u.events.trigger("popups.hide.".concat(e)), u.$tb && (1 < u.opts.zIndex ? u.$tb.css("zIndex", u.opts.zIndex + 1) : u.$tb.css("zIndex", "")), u.events.disableBlur(), t.find("input, textarea, button").each(function () {
        this === this.ownerDocument.activeElement && this.blur()
      }), t.find("input, textarea").attr("disabled", "disabled"), h)) for (var n = 0; n < h.length; n++) d(h[n]).removeClass("fr-btn-active-popup")
    }

    function C(e) {
      for (var t in void 0 === e && (e = []), g) Object.prototype.hasOwnProperty.call(g, t) && e.indexOf(t) < 0 && n(t)
    }

    function t() {
      u.shared.exit_flag = !0
    }

    function E() {
      u.shared.exit_flag = !1
    }

    function l() {
      return u.shared.exit_flag
    }

    function c(e, t) {
      var n, r = function c(e, t) {
        var n = xt.POPUP_TEMPLATES[e];
        if (!n) return null;
        for (var r in "function" == typeof n && (n = n.apply(u)), t) Object.prototype.hasOwnProperty.call(t, r) && (n = n.replace("[_".concat(r.toUpperCase(), "_]"), t[r]));
        return n
      }(e, t), a = d(u.doc.createElement("DIV"));
      if (!r) return "filesManager.insert" === e ? a.addClass("fr-popup fr-files-manager fr-empty") : a.addClass("fr-popup fr-empty"), (n = d("body").first()).append(a), a.data("container", n), g[e] = a;
      "filesManager.insert" === e ? a.addClass("fr-popup fr-files-manager".concat(u.helpers.isMobile() ? " fr-mobile" : " fr-desktop").concat(u.opts.toolbarInline ? " fr-inline" : "")) : a.addClass("fr-popup".concat(u.helpers.isMobile() ? " fr-mobile" : " fr-desktop").concat(u.opts.toolbarInline ? " fr-inline" : "")), a.html(r), u.opts.theme && a.addClass("".concat(u.opts.theme, "-theme")), 1 < u.opts.zIndex && (!u.opts.editInPopup && u.$tb ? u.$tb.css("z-index", u.opts.zIndex + 2) : a.css("z-index", u.opts.zIndex + 2)), "auto" !== u.opts.direction && a.removeClass("fr-ltr fr-rtl").addClass("fr-".concat(u.opts.direction)), a.find("input, textarea").attr("dir", u.opts.direction).attr("disabled", "disabled"), (n = d("body").first()).append(a), a.data("container", n);
      var o = (g[e] = a).find(".fr-color-hex-layer");
      if (0 < o.length) {
        var i = u.helpers.getPX(a.find(".fr-color-set > span").css("width")), s = u.helpers.getPX(o.css("paddingLeft")),
          l = u.helpers.getPX(o.css("paddingRight"));
        o.css("width", i * u.opts.colorsStep + s + l)
      }
      return u.button.bindCommands(a, !1), a
    }

    function y(r) {
      var a = g[r];
      return {
        _windowResize: function () {
          var e = a.data("instance") || u;
          !e.helpers.isMobile() && a.isVisible() && (e.events.disableBlur(), e.popups.hide(r), e.events.enableBlur())
        }, _inputFocus: function (e) {
          var t = a.data("instance") || u, n = d(e.currentTarget);
          if (n.is("input:file") && n.closest(".fr-layer").addClass("fr-input-focus"), e.preventDefault(), e.stopPropagation(), setTimeout(function () {
            t.events.enableBlur()
          }, 100), t.helpers.isMobile()) {
            var r = d(t.o_win).scrollTop();
            setTimeout(function () {
              d(t.o_win).scrollTop(r)
            }, 0)
          }
        }, _inputBlur: function (e) {
          var t = a.data("instance") || u, n = d(e.currentTarget);
          n.is("input:file") && n.closest(".fr-layer").removeClass("fr-input-focus"), document.activeElement !== this && d(this).isVisible() && (t.events.blurActive() && t.events.trigger("blur"), t.events.enableBlur())
        }, _editorKeydown: function (e) {
          var t = a.data("instance") || u;
          t.keys.ctrlKey(e) || e.which === xt.KEYCODE.ALT || e.which === xt.KEYCODE.ESC || (v(r) && a.findVisible(".fr-back").length ? t.button.exec(a.findVisible(".fr-back").first()) : e.which !== xt.KEYCODE.ALT && t.popups.hide(r))
        }, _preventFocus: function (e) {
          var t = a.data("instance") || u,
            n = e.originalEvent ? e.originalEvent.target || e.originalEvent.originalTarget : null;
          "mouseup" === e.type || d(n).is(":focus") || t.events.disableBlur(), "mouseup" !== e.type || d(n).hasClass("fr-command") || 0 < d(n).parents(".fr-command").length || d(n).hasClass("fr-dropdown-content") || u.button.hideActiveDropdowns(a), (u.browser.safari || u.browser.mozilla) && "mousedown" === e.type && d(n).is("input[type=file]") && t.events.disableBlur();
          var r = "input, textarea, button, select, label, .fr-command";
          if (n && !d(n).is(r) && 0 === d(n).parents(r).length) return e.stopPropagation(), !1;
          n && d(n).is(r) && e.stopPropagation(), E()
        }, _editorMouseup: function () {
          a.isVisible() && l() && 0 < a.findVisible("input:focus, textarea:focus, button:focus, select:focus").length && u.events.disableBlur()
        }, _windowMouseup: function (e) {
          if (!u.core.sameInstance(a)) return !0;
          var t = a.data("instance") || u;
          a.isVisible() && l() && (e.stopPropagation(), t.markers.remove(), t.popups.hide(r), E())
        }, _windowKeydown: function (e) {
          if (!u.core.sameInstance(a)) return !0;
          var t = a.data("instance") || u, n = e.which;
          if (xt.KEYCODE.ESC === n) {
            if (t.popups.isVisible(r) && t.opts.toolbarInline) return e.stopPropagation(), t.popups.isVisible(r) && (a.findVisible(".fr-back").length ? (t.button.exec(a.findVisible(".fr-back").first()), t.accessibility.focusPopupButton(a)) : a.findVisible(".fr-dismiss").length ? t.button.exec(a.findVisible(".fr-dismiss").first()) : (t.popups.hide(r), t.toolbar.showInline(null, !0), t.accessibility.focusPopupButton(a))), !1;
            if (t.popups.isVisible(r)) return a.findVisible(".fr-back").length ? (t.button.exec(a.findVisible(".fr-back").first), t.accessibility.focusPopupButton(a)) : a.findVisible(".fr-dismiss").length ? t.button.exec(a.findVisible(".fr-dismiss").first()) : (t.popups.hide(r), t.accessibility.focusPopupButton(a)), !1
          }
        }, _repositionPopup: function () {
          if (!u.opts.height && !u.opts.heightMax || u.opts.toolbarInline) return !0;
          if (u.$wp && v(r) && a.parent().get(0) === u.$sc.get(0)) {
            var e = a.offset().top - u.$wp.offset().top, t = u.$wp.outerHeight();
            u.node.hasClass(a.get(0), "fr-above") && (e += a.outerHeight());
            var n = u.image.getEl();
            n && n.offset().top > t || t < e || e < 0 ? a.addClass("fr-hidden") : a.removeClass("fr-hidden")
          }
        }
      }
    }

    function f(e, t) {
      u.events.on("mouseup", e._editorMouseup, !0), u.$wp && u.events.on("keydown", e._editorKeydown), u.events.on("focus", function () {
        g[t].removeClass("focused")
      }), u.events.on("blur", function () {
        b() && u.markers.remove(), u.helpers.isMobile() ? g[t].hasClass("focused") ? (C(), g[t].removeClass("focused")) : g[t].addClass("focused") : g[t].find("iframe").length || C()
      }), u.$wp && !u.helpers.isMobile() && u.events.$on(u.$wp, "scroll.popup".concat(t), e._repositionPopup), u.events.on("window.mouseup", e._windowMouseup, !0), u.events.on("window.keydown", e._windowKeydown, !0), g[t].data("inst".concat(u.id), !0), u.events.on("destroy", function () {
        u.core.sameInstance(g[t]) && (d("body").first().append(g[t]), g[t].removeClass("fr-active"))
      }, !0)
    }

    function p() {
      var e = d(this).prev().children().first();
      e.attr("checked", !e.attr("checked"))
    }

    function e() {
      for (var e in g) if (Object.prototype.hasOwnProperty.call(g, e)) {
        var t = g[e];
        t && (t.html("").removeData().remove(), g[e] = null)
      }
      g = []
    }

    return u.shared.exit_flag = !1, {
      _init: function L() {
        r = window.innerHeight, u.events.on("shared.destroy", e, !0), u.events.on("window.mousedown", t), u.events.on("window.touchmove", E), u.events.$on(d(u.o_win), "scroll", E), u.events.on("mousedown", function (e) {
          b() && (e.stopPropagation(), u.$el.find(".fr-marker").remove(), t(), u.events.disableBlur())
        })
      }, create: function _(e, t) {
        var n = c(e, t), r = y(e);
        f(r, e), u.events.$on(n, "mousedown mouseup touchstart touchend touch", "*", r._preventFocus, !0), u.events.$on(n, "focus", "input, textarea, button, select", r._inputFocus, !0), u.events.$on(n, "blur", "input, textarea, button, select", r._inputBlur, !0);
        var a = n.find("input, textarea");
        return function o(e) {
          for (var t = 0; t < e.length; t++) {
            var n = e[t], r = d(n);
            0 === r.next().length && r.attr("placeholder") && (r.after('<label for="'.concat(r.attr("id"), '">').concat(r.attr("placeholder"), "</label>")), r.attr("placeholder", ""))
          }
        }(a), u.events.$on(a, "focus", i), u.events.$on(a, "blur change", s), u.events.$on(n, "click", ".fr-checkbox + label", p), u.accessibility.registerPopup(e), u.helpers.isIOS() && u.events.$on(n, "touchend", "label", function () {
          d("#".concat(d(this).attr("for"))).prop("checked", function (e, t) {
            return !t
          })
        }, !0), u.events.$on(d(u.o_win), "resize", r._windowResize, !0), "filesManager.insert" === e && g["filesManager.insert"].css("zIndex", 2147483641), n
      }, get: function w(e) {
        var t = g[e];
        return t && !t.data("inst".concat(u.id)) && f(y(e), e), t
      }, show: function A(e, t, n, r, a) {
        if (v(e) || (b() && 0 < u.$el.find(".fr-marker").length ? (u.events.disableBlur(), u.selection.restore()) : b() || (u.events.disableBlur(), u.events.focus(), u.events.enableBlur())), C([e]), !g[e]) return !1;
        var o = u.button.getButtons(".fr-dropdown.fr-active");
        o.removeClass("fr-active").attr("aria-expanded", !1).parents(".fr-toolbar").css("zIndex", "").find("> .fr-dropdown-wrapper").css("height", ""), o.next().attr("aria-hidden", !0).css("overflow", "").find("> .fr-dropdown-wrapper").css("height", ""), g[e].data("instance", u), u.$tb && u.$tb.data("instance", u);
        var i = v(e);
        g[e].addClass("fr-active").removeClass("fr-hidden").find("input, textarea").removeAttr("disabled");
        var s = g[e].data("container");
        if (function p(e, t) {
          t.isVisible() || (t = u.$sc), t.contains([g[e].get(0)]) || t.append(g[e])
        }(e, s), u.opts.toolbarInline && s && u.$tb && s.get(0) === u.$tb.get(0) && (m(e, u.$sc), n = u.$tb.offset().top - u.helpers.getPX(u.$tb.css("margin-top")), t = u.$tb.offset().left + u.$tb.outerWidth() / 2, u.node.hasClass(u.$tb.get(0), "fr-above") && n && (n += u.$tb.outerHeight()), r = 0), s = g[e].data("container"), u.opts.iframe && !r && !i) {
          var l = u.helpers.getPX(u.$wp.find(".fr-iframe").css("padding-top")),
            c = u.helpers.getPX(u.$wp.find(".fr-iframe").css("padding-left"));
          t && (t -= u.$iframe.offset().left + c), n && (n -= u.$iframe.offset().top + l)
        }
        s.is(u.$tb) ? u.$tb.css("zIndex", (u.opts.zIndex || 1) + 4) : g[e].css("zIndex", (u.opts.zIndex || 1) + 3), u.opts.toolbarBottom && s && u.$tb && s.get(0) === u.$tb.get(0) && (g[e].addClass("fr-above"), n && (n -= g[e].outerHeight())), a && (t -= g[e].width() / 2), t + g[e].outerWidth() > u.$sc.offset().left + u.$sc.width() && (t -= t + g[e].outerWidth() - u.$sc.offset().left - u.$sc.width()), t < u.$sc.offset().left && "rtl" === u.opts.direction && (t = u.$sc.offset().left), g[e].removeClass("fr-active"), u.position.at(t, n, g[e], r || 0);
        var d = u.node.blockParent(u.selection.blocks()[0]);
        if (d && "false" === d.getAttribute("contenteditable")) g[e].removeClass("fr-active"); else {
          var f = u.selection.element().parentElement.getAttribute("contenteditable");
          f && "false" === f ? g[e].removeClass("fr-active") : g[e].addClass("fr-active")
        }
        i || u.accessibility.focusPopup(g[e]), u.opts.toolbarInline && u.toolbar.hide(), u.$tb && (h = u.$tb.find(".fr-btn-active-popup")), u.events.trigger("popups.show.".concat(e)), y(e)._repositionPopup(), E()
      }, hide: n, onHide: function T(e, t) {
        u.events.on("popups.hide.".concat(e), t)
      }, hideAll: C, setContainer: m, refresh: function S(e) {
        g[e].data("instance", u), u.events.trigger("popups.refresh.".concat(e));
        for (var t = g[e].find(".fr-command"), n = 0; n < t.length; n++) {
          var r = d(t[n]);
          0 === r.parents(".fr-dropdown-menu").length && u.button.refresh(r)
        }
      }, onRefresh: function k(e, t) {
        u.events.on("popups.refresh.".concat(e), t)
      }, onShow: function x(e, t) {
        u.events.on("popups.show.".concat(e), t)
      }, isVisible: v, setFileListHeight: a, areVisible: b, setPopupDimensions: function R(e, t) {
        t && e.find(".fr-upload-progress-layer").get(0).clientHeight < o && (e.find(".fr-upload-progress").addClass("fr-height-auto"), u.popups.get("filesManager.insert").addClass("fr-height-auto"), e.find(".fr-upload-progress").removeClass("fr-height-set"), o = 2e3), e.get(0).clientHeight > window.innerHeight / 2 && (window.innerWidth < 500 ? e.get(0).clientHeight > .6 * r && a(e) : 400 < e.get(0).clientHeight && a(e), o = e.find(".fr-upload-progress-layer").get(0).clientHeight);
        var n = window.innerWidth;
        switch (!0) {
          case n <= 320:
            e.width(200);
            break;
          case n <= 420:
            e.width(250);
            break;
          case n <= 520:
            e.width(300);
            break;
          case n <= 720:
            e.width(400);
            break;
          case 720 < n:
            e.width(530)
        }
      }
    }
  }, xt.MODULES.accessibility = function (f) {
    var p = f.$, o = !0;

    function l(t) {
      for (var e = f.$el.find('[contenteditable="true"]'), n = !1, r = 0; e.get(r);) p(e.get(r)).is(":focus") && (n = !0), r++;
      t && t.length && !n && (t.data("blur-event-set") || t.parents(".fr-popup").length || (f.events.$on(t, "blur", function () {
        var e = t.parents(".fr-toolbar, .fr-popup").data("instance") || f;
        e.events.blurActive() && !f.core.hasFocus() && e.events.trigger("blur"), setTimeout(function () {
          e.events.enableBlur()
        }, 100)
      }, !0), t.data("blur-event-set", !0)), (t.parents(".fr-toolbar, .fr-popup").data("instance") || f).events.disableBlur(), t.get(0).focus(), f.shared.$f_el = t)
    }

    function u(e, t) {
      var n = t ? "last" : "first", r = s(g(e))[n]();
      if (r.length) return l(r), !0
    }

    function i(e) {
      return e.is("input, textarea, select") && t(), f.events.disableBlur(), e.get(0).focus(), !0
    }

    function h(e, t) {
      var n = e.find("input, textarea, button, select").filter(function () {
        return p(this).isVisible()
      }).not(":disabled");
      if ((n = t ? n.last() : n.first()).length) return i(n);
      if (f.shared.with_kb) {
        var r = e.findVisible(".fr-active-item").first();
        if (r.length) return i(r);
        var a = e.findVisible("[tabIndex]").first();
        if (a.length) return i(a)
      }
    }

    function t() {
      0 === f.$el.find(".fr-marker").length && f.core.hasFocus() && f.selection.save()
    }

    function c() {
      var e = f.popups.areVisible();
      if (e) {
        var t = e.find(".fr-buttons");
        return t.find("button:focus, .fr-group span:focus").length ? !u(e.data("instance").$tb) : !u(t)
      }
      return !u(f.$tb)
    }

    function d() {
      var e = null;
      return f.shared.$f_el.is(".fr-dropdown.fr-active") ? e = f.shared.$f_el : f.shared.$f_el.closest(".fr-dropdown-menu").prev().is(".fr-dropdown.fr-active") && (e = f.shared.$f_el.closest(".fr-dropdown-menu").prev()), e
    }

    function s(e) {
      for (var t = -1, n = 0; n < e.length; n++) p(e[n]).hasClass("fr-open") && (t = n);
      var r = e.index(f.$tb.find(".fr-more-toolbar.fr-expanded > button.fr-command").first());
      if (0 < r && -1 !== t) {
        var a = e.slice(r, e.length), o = (e = e.slice(0, r)).slice(0, t + 1), i = e.slice(t + 1, e.length);
        e = o;
        for (var s = 0; s < a.length; s++) e.push(a[s]);
        for (var l = 0; l < i.length; l++) e.push(i[l])
      }
      return e
    }

    function g(e) {
      return e.findVisible("button:not(.fr-disabled), .fr-group span.fr-command").filter(function (e) {
        var t = p(e).parents(".fr-more-toolbar");
        return 0 === t.length || 0 < t.length && t.hasClass("fr-expanded")
      })
    }

    function n(e, t, n) {
      if (f.shared.$f_el) {
        var r = d();
        r && (f.button.click(r), f.shared.$f_el = r);
        var a = s(g(e)), o = a.index(f.shared.$f_el);
        if (0 === o && !n || o === a.length - 1 && n) {
          var i;
          if (t) {
            if (e.parent().is(".fr-popup")) i = !h(e.parent().children().not(".fr-buttons"), !n);
            !1 === i && (f.shared.$f_el = null)
          }
          t && !1 === i || u(e, !n)
        } else l(p(a.get(o + (n ? 1 : -1))));
        return !1
      }
    }

    function m(e, t) {
      return n(e, t, !0)
    }

    function v(e, t) {
      return n(e, t)
    }

    function b(e) {
      if (f.shared.$f_el) {
        var t;
        if (f.shared.$f_el.is(".fr-dropdown.fr-active")) return l(t = e ? f.shared.$f_el.next().find(".fr-command:not(.fr-disabled)").first() : f.shared.$f_el.next().find(".fr-command:not(.fr-disabled)").last()), !1;
        if (f.shared.$f_el.is("a.fr-command")) return (t = e ? f.shared.$f_el.closest("li").nextAllVisible().first().find(".fr-command:not(.fr-disabled)").first() : f.shared.$f_el.closest("li").prevAllVisible().first().find(".fr-command:not(.fr-disabled)").first()).length || (t = e ? f.shared.$f_el.closest(".fr-dropdown-menu").find(".fr-command:not(.fr-disabled)").first() : f.shared.$f_el.closest(".fr-dropdown-menu").find(".fr-command:not(.fr-disabled)").last()), l(t), !1
      }
    }

    function C() {
      if (f.shared.$f_el) {
        if (f.shared.$f_el.hasClass("fr-dropdown")) f.button.click(f.shared.$f_el); else if (f.shared.$f_el.is("button.fr-back")) {
          f.opts.toolbarInline && (f.events.disableBlur(), f.events.focus());
          var e = f.popups.areVisible(f);
          e && (f.shared.with_kb = !1), f.button.click(f.shared.$f_el), y(e)
        } else {
          if (f.events.disableBlur(), f.button.click(f.shared.$f_el), f.shared.$f_el.attr("data-group-name")) {
            var t = f.$tb.find('.fr-more-toolbar[data-name="'.concat(f.shared.$f_el.attr("data-group-name"), '"]')),
              n = f.shared.$f_el;
            t.hasClass("fr-expanded") && (n = t.findVisible("button:not(.fr-disabled)").first()), n && l(n)
          } else if (f.shared.$f_el.attr("data-popup")) {
            var r = f.popups.areVisible(f);
            r && r.data("popup-button", f.shared.$f_el)
          } else if (f.shared.$f_el.attr("data-modal")) {
            var a = f.modals.areVisible(f);
            a && a.data("modal-button", f.shared.$f_el)
          }
          f.shared.$f_el = null
        }
        return !1
      }
    }

    function E() {
      f.shared.$f_el && (f.events.disableBlur(), f.shared.$f_el.blur(), f.shared.$f_el = null), !1 !== f.events.trigger("toolbar.focusEditor") && (f.events.disableBlur(), f.$el.get(0).focus(), f.events.focus())
    }

    function a(r) {
      r && r.length && (f.events.$on(r, "keydown", function (e) {
        if (!p(e.target).is("a.fr-command, button.fr-command, .fr-group span.fr-command")) return !0;
        var t = r.parents(".fr-popup").data("instance") || r.data("instance") || f;
        f.shared.with_kb = !0;
        var n = t.accessibility.exec(e, r);
        return f.shared.with_kb = !1, n
      }, !0), f.events.$on(r, "mouseenter", "[tabIndex]", function (e) {
        var t = r.parents(".fr-popup").data("instance") || r.data("instance") || f;
        if (!o) return e.stopPropagation(), void e.preventDefault();
        var n = p(e.currentTarget);
        t.shared.$f_el && t.shared.$f_el.not(n) && t.accessibility.focusEditor()
      }, !0), f.$tb && f.events.$on(f.$tb, "transitionend", ".fr-more-toolbar", function () {
        f.shared.$f_el = p(document.activeElement)
      }))
    }

    function y(e) {
      var t = e.data("popup-button");
      t && setTimeout(function () {
        l(t), e.data("popup-button", null)
      }, 0)
    }

    function L(e) {
      var t = f.popups.areVisible(e);
      t && t.data("popup-button", null)
    }

    function e(e) {
      var t = -1 !== navigator.userAgent.indexOf("Mac OS X") ? e.metaKey : e.ctrlKey;
      if (e.which !== xt.KEYCODE.F10 || t || e.shiftKey || !e.altKey) return !0;
      f.shared.with_kb = !0;
      var n = f.popups.areVisible(f), r = !1;
      return n && (r = h(n.children().not(".fr-buttons"))), r || c(), f.shared.with_kb = !1, e.preventDefault(), e.stopPropagation(), !1
    }

    return {
      _init: function r() {
        f.$wp ? f.events.on("keydown", e, !0) : f.events.$on(f.$win, "keydown", e, !0), f.events.on("mousedown", function (e) {
          L(f), f.shared.$f_el && f.el.isSameNode(f.shared.$f_el[0]) && (f.accessibility.restoreSelection(), e.stopPropagation(), f.events.disableBlur(), f.shared.$f_el = null)
        }, !0), f.events.on("blur", function () {
          f.shared.$f_el = null, L(f)
        }, !0)
      }, registerPopup: function _(e) {
        var t = f.popups.get(e), n = function r(c) {
          var d = f.popups.get(c);
          return {
            _tiKeydown: function (e) {
              var t = d.data("instance") || f;
              if (!1 === t.events.trigger("popup.tab", [e])) return !1;
              var n = e.which, r = d.find(":focus").first();
              if (xt.KEYCODE.TAB === n) {
                e.preventDefault();
                var a = d.children().not(".fr-buttons"),
                  o = a.findVisible("input, textarea, button, select").not(".fr-no-touch input, .fr-no-touch textarea, .fr-no-touch button, .fr-no-touch select, :disabled").toArray(),
                  i = o.indexOf(this) + (e.shiftKey ? -1 : 1);
                if (0 <= i && i < o.length) return t.events.disableBlur(), p(o[i]).focus(), e.stopPropagation(), !1;
                var s = d.find(".fr-buttons");
                if (s.length && u(s, Boolean(e.shiftKey))) return e.stopPropagation(), !1;
                if (h(a)) return e.stopPropagation(), !1
              } else {
                if (xt.KEYCODE.ENTER !== n || !e.target || "TEXTAREA" === e.target.tagName) return xt.KEYCODE.ESC === n ? (e.preventDefault(), e.stopPropagation(), t.accessibility.restoreSelection(), t.popups.isVisible(c) && d.findVisible(".fr-back").length ? (t.opts.toolbarInline && (t.events.disableBlur(), t.events.focus()), t.button.exec(d.findVisible(".fr-back").first()), y(d)) : t.popups.isVisible(c) && d.findVisible(".fr-dismiss").length ? t.button.exec(d.findVisible(".fr-dismiss").first()) : (t.popups.hide(c), t.opts.toolbarInline && t.toolbar.showInline(null, !0), y(d)), !1) : xt.KEYCODE.SPACE === n && (r.is(".fr-submit") || r.is(".fr-dismiss")) ? (e.preventDefault(), e.stopPropagation(), t.events.disableBlur(), t.button.exec(r), !0) : t.keys.isBrowserAction(e) ? void e.stopPropagation() : r.is("input[type=text], textarea") ? void e.stopPropagation() : xt.KEYCODE.SPACE === n && (r.is(".fr-link-attr") || r.is("input[type=file]")) ? void e.stopPropagation() : (e.stopPropagation(), e.preventDefault(), !1);
                var l = null;
                0 < d.findVisible(".fr-submit").length ? l = d.findVisible(".fr-submit").first() : d.findVisible(".fr-dismiss").length && (l = d.findVisible(".fr-dismiss").first()), l && (e.preventDefault(), e.stopPropagation(), t.events.disableBlur(), t.button.exec(l))
              }
            }, _tiMouseenter: function () {
              var e = d.data("instance") || f;
              L(e)
            }
          }
        }(e);
        a(t.find(".fr-buttons")), f.events.$on(t, "mouseenter", "tabIndex", n._tiMouseenter, !0), f.events.$on(t.children().not(".fr-buttons"), "keydown", "[tabIndex]", n._tiKeydown, !0), f.popups.onHide(e, function () {
          (t.data("instance") || f).accessibility.restoreSelection()
        }), f.popups.onShow(e, function () {
          o = !1, setTimeout(function () {
            o = !0
          }, 0)
        })
      }, registerToolbar: a, focusToolbarElement: l, focusToolbar: u, focusContent: h, focusPopup: function w(r) {
        var a = r.children().not(".fr-buttons");
        a.data("mouseenter-event-set") || (f.events.$on(a, "mouseenter", "[tabIndex]", function (e) {
          var t = r.data("instance") || f;
          if (!o) return e.stopPropagation(), void e.preventDefault();
          var n = a.find(":focus").first();
          n.length && !n.is("input, button, textarea, select") && (t.events.disableBlur(), n.blur(), t.events.disableBlur(), t.events.focus())
        }), a.data("mouseenter-event-set", !0)), !h(a) && f.shared.with_kb && u(r.find(".fr-buttons"))
      }, focusModal: function A(e) {
        f.core.hasFocus() || (f.events.disableBlur(), f.events.focus()), f.accessibility.saveSelection(), f.events.disableBlur(), f.el.blur(), f.selection.clear(), f.events.disableBlur(), f.shared.with_kb ? e.find(".fr-command[tabIndex], [tabIndex]").first().focus() : e.find("[tabIndex]").first().focus()
      }, focusEditor: E, focusPopupButton: y, focusModalButton: function T(e) {
        var t = e.data("modal-button");
        t && setTimeout(function () {
          l(t), e.data("modal-button", null)
        }, 0)
      }, hasFocus: function S() {
        return null !== f.shared.$f_el
      }, exec: function k(e, t) {
        var n = -1 !== navigator.userAgent.indexOf("Mac OS X") ? e.metaKey : e.ctrlKey, r = e.which, a = !1;
        return r !== xt.KEYCODE.TAB || n || e.shiftKey || e.altKey ? r !== xt.KEYCODE.ARROW_RIGHT || n || e.shiftKey || e.altKey ? r !== xt.KEYCODE.TAB || n || !e.shiftKey || e.altKey ? r !== xt.KEYCODE.ARROW_LEFT || n || e.shiftKey || e.altKey ? r !== xt.KEYCODE.ARROW_UP || n || e.shiftKey || e.altKey ? r !== xt.KEYCODE.ARROW_DOWN || n || e.shiftKey || e.altKey ? r !== xt.KEYCODE.ENTER && r !== xt.KEYCODE.SPACE || n || e.shiftKey || e.altKey ? r !== xt.KEYCODE.ESC || n || e.shiftKey || e.altKey ? r !== xt.KEYCODE.F10 || n || e.shiftKey || !e.altKey || (a = c()) : a = function o(e) {
          if (f.shared.$f_el) {
            var t = d();
            return t ? (f.button.click(t), l(t)) : e.parent().findVisible(".fr-back").length ? (f.shared.with_kb = !1, f.opts.toolbarInline && (f.events.disableBlur(), f.events.focus()), f.button.exec(e.parent().findVisible(".fr-back")).first(), y(e.parent())) : f.shared.$f_el.is("button, .fr-group span") && (e.parent().is(".fr-popup") ? (f.accessibility.restoreSelection(), f.shared.$f_el = null, !1 !== f.events.trigger("toolbar.esc") && (f.popups.hide(e.parent()), f.opts.toolbarInline && f.toolbar.showInline(null, !0), y(e.parent()))) : E()), !1
          }
        }(t) : a = C() : a = function i() {
          return f.shared.$f_el && f.shared.$f_el.is(".fr-dropdown:not(.fr-active)") ? C() : b(!0)
        }() : a = function s() {
          return b()
        }() : a = v(t) : a = v(t, !0) : a = m(t) : a = m(t, !0), f.shared.$f_el || void 0 !== a || (a = !0), !a && f.keys.isBrowserAction(e) && (a = !0), !!a || (e.preventDefault(), e.stopPropagation(), !1)
      }, saveSelection: t, restoreSelection: function x() {
        f.$el.find(".fr-marker").length && (f.events.disableBlur(), f.selection.restore(), f.events.enableBlur())
      }
    }
  }, Object.assign(xt.DEFAULTS, {tooltips: !0}), xt.MODULES.tooltip = function (s) {
    var l = s.$;

    function r() {
      s.helpers.isMobile() || s.$tooltip && s.$tooltip.removeClass("fr-visible").css("left", "-3000px").css("position", "fixed")
    }

    function a(e, t) {
      if (!s.helpers.isMobile()) {
        var n = e.attr("id") && e.attr("id").split("-")[0], r = e.attr("title");
        if ("trackChanges" === n) r = s.opts.trackChangesEnabled ? "Disable Track Changes" : "Enable Track Changes"; else if ("showChanges" === n) r = s.opts.showChangesEnabled ? "Hide Changes" : "Show Changes"; else if (("applyAll" === n || "removeAll" === n || "applyLast" === n || "removeLast" === n) && 0 === s.track_changes.getPendingChanges().length) return;
        if (e.data("title", r), e.data("title")) {
          s.$tooltip || function i() {
            s.opts.tooltips && !s.helpers.isMobile() && (s.shared.$tooltip ? s.$tooltip = s.shared.$tooltip : (s.shared.$tooltip = l(s.doc.createElement("DIV")).addClass("fr-tooltip"), s.$tooltip = s.shared.$tooltip, s.opts.theme && s.$tooltip.addClass("".concat(s.opts.theme, "-theme")), l(s.o_doc).find("body").first().append(s.$tooltip)), s.events.on("shared.destroy", function () {
              s.$tooltip.html("").removeData().remove(), s.$tooltip = null
            }, !0))
          }(), e.removeAttr("title"), s.$tooltip.text(s.language.translate(e.data("title"))), s.$tooltip.addClass("fr-visible");
          var a = e.offset().left + (e.outerWidth() - s.$tooltip.outerWidth()) / 2;
          a < 0 && (a = 0), a + s.$tooltip.outerWidth() > l(s.o_win).width() && (a = l(s.o_win).width() - s.$tooltip.outerWidth()), void 0 === t && (t = s.opts.toolbarBottom), e.offset().top - l(window).scrollTop() + e.outerHeight() + 10 >= l(window).height() && (t = !0);
          var o = t ? e.offset().top - s.$tooltip.height() : e.offset().top + e.outerHeight();
          s.$tooltip.css("position", ""), s.$tooltip.css("left", a), s.$tooltip.css("top", Math.ceil(o)), "static" !== l(s.o_doc).find("body").first().css("position") ? (s.$tooltip.css("margin-left", -l(s.o_doc).find("body").first().offset().left), s.$tooltip.css("margin-top", -l(s.o_doc).find("body").first().offset().top)) : (s.$tooltip.css("margin-left", ""), s.$tooltip.css("margin-top", ""))
        }
      }
    }

    return {
      hide: r, to: a, bind: function o(e, t, n) {
        s.opts.tooltips && !s.helpers.isMobile() && (s.events.$on(e, "mouseover", t, function (e) {
          s.node.hasClass(e.currentTarget, "fr-disabled") || s.edit.isDisabled() || a(l(e.currentTarget), n)
        }, !0), s.events.$on(e, "mouseout ".concat(s._mousedown, " ").concat(s._mouseup), t, function () {
          r()
        }, !0))
      }
    }
  }, xt.TOOLBAR_VISIBLE_BUTTONS = 3, xt.MODULES.button = function (g) {
    var h = g.$, i = [];
    (g.opts.toolbarInline || g.opts.toolbarContainer) && (g.shared.buttons || (g.shared.buttons = []), i = g.shared.buttons);
    var s = [];

    function l(e, t, n) {
      for (var r = h(), a = 0; a < e.length; a++) {
        var o = h(e[a]);
        if (o.is(t) && (r = r.add(o)), n && o.is(".fr-dropdown")) {
          var i = o.next().find(t);
          r = r.add(i)
        }
      }
      return r
    }

    function m(e, t) {
      var n, r = h();
      if (!e) return r;
      for (n in r = (r = r.add(l(i, e, t))).add(l(s, e, t)), g.shared.popups) if (Object.prototype.hasOwnProperty.call(g.shared.popups, n)) {
        var a = g.shared.popups[n].children().find(e);
        r = r.add(a)
      }
      for (n in g.shared.modals) if (Object.prototype.hasOwnProperty.call(g.shared.modals, n)) {
        var o = g.shared.modals[n].$modal.find(e);
        r = r.add(o)
      }
      return r
    }

    function a(e) {
      var t = e.next(), n = g.node.hasClass(e.get(0), "fr-active"), r = m(".fr-dropdown.fr-active").not(e),
        a = e.parents(".fr-toolbar, .fr-popup").data("instance") || g;
      a.helpers.isIOS() && !a.el.querySelector(".fr-marker") && (a.selection.save(), a.selection.clear(), a.selection.restore()), t.parents(".fr-more-toolbar").addClass("fr-overflow-visible");
      var o = 0, i = 0, s = t.find("> .fr-dropdown-wrapper");
      if (!n) {
        var l = e.data("cmd");
        t.find(".fr-command").removeClass("fr-active").attr("aria-selected", !1), xt.COMMANDS[l] && xt.COMMANDS[l].refreshOnShow && xt.COMMANDS[l].refreshOnShow.apply(a, [e, t]), t.css("left", e.offset().left - e.parents(".fr-btn-wrap, .fr-toolbar, .fr-buttons").offset().left - ("rtl" === g.opts.direction ? t.width() - e.outerWidth() : 0)), t.addClass("test-height"), o = t.outerHeight(), i = g.helpers.getPX(s.css("max-height")), t.removeClass("test-height"), t.css("top", "").css("bottom", "");
        var c = e.outerHeight() / 10;
        if (!g.opts.toolbarBottom && t.offset().top + e.outerHeight() + o < h(g.o_doc).height()) t.css("top", e.position().top + e.outerHeight() - c); else {
          var d = 0, f = e.parents(".fr-more-toolbar");
          0 < f.length && (d = f.first().height()), t.css("bottom", e.parents(".fr-popup, .fr-toolbar").first().height() - d - e.position().top)
        }
      }
      (e.addClass("fr-blink").toggleClass("fr-active"), e.hasClass("fr-options")) && e.prev().toggleClass("fr-expanded");
      e.hasClass("fr-active") ? (t.attr("aria-hidden", !1), e.attr("aria-expanded", !0), function u(e, t, n) {
        n <= t && (e.parent().css("overflow", "auto"), e.parent().css("overflow-x", "hidden")), e.css("height", Math.min(t, n))
      }(s, o, i)) : (t.attr("aria-hidden", !0).css("overflow", ""), e.attr("aria-expanded", !1), s.css("height", "")), setTimeout(function () {
        e.removeClass("fr-blink")
      }, 300), t.css("margin-left", ""), t.offset().left + t.outerWidth() > g.$sc.offset().left + g.$sc.width() && t.css("margin-left", -(t.offset().left + t.outerWidth() - g.$sc.offset().left - g.$sc.width())), t.offset().left < g.$sc.offset().left && "rtl" === g.opts.direction && t.css("margin-left", g.$sc.offset().left), r.removeClass("fr-active").attr("aria-expanded", !1).next().attr("aria-hidden", !0).css("overflow", "").find("> .fr-dropdown-wrapper").css("height", ""), r.prev(".fr-expanded").removeClass("fr-expanded"), r.parents(".fr-toolbar:not(.fr-inline)").css("zIndex", ""), 0 !== e.parents(".fr-popup").length || g.opts.toolbarInline || (g.node.hasClass(e.get(0), "fr-active") ? g.$tb.css("zIndex", (g.opts.zIndex || 1) + 4) : g.$tb.css("zIndex", ""));
      var p = t.find("a.fr-command.fr-active").first();
      g.helpers.isMobile() || (p.length ? (g.accessibility.focusToolbarElement(p), s.scrollTop(Math.abs(p.parents(".fr-dropdown-content").offset().top - p.offset().top) - p.offset().top)) : (g.accessibility.focusToolbarElement(e), s.scrollTop(0)))
    }

    function o(e) {
      e.addClass("fr-blink"), setTimeout(function () {
        e.removeClass("fr-blink")
      }, 500);
      for (var t = e.data("cmd"), n = []; void 0 !== e.data("param".concat(n.length + 1));) n.push(e.data("param".concat(n.length + 1)));
      var r = m(".fr-dropdown.fr-active");
      r.length && (r.removeClass("fr-active").attr("aria-expanded", !1).next().attr("aria-hidden", !0).css("overflow", "").find("> .fr-dropdown-wrapper").css("height", ""), r.prev(".fr-expanded").removeClass("fr-expanded"), r.parents(".fr-toolbar:not(.fr-inline)").css("zIndex", "")), e.parents(".fr-popup, .fr-toolbar").data("instance").commands.exec(t, n)
    }

    function t(e) {
      var t = e.parents(".fr-popup, .fr-toolbar").data("instance");
      if (0 === e.parents(".fr-popup").length && e.data("popup") && !e.hasClass("fr-btn-active-popup") && e.addClass("fr-btn-active-popup"), 0 !== e.parents(".fr-popup").length || e.data("popup") || t.popups.hideAll(), t.popups.areVisible() && !t.popups.areVisible(t)) {
        for (var n = 0; n < xt.INSTANCES.length; n++) xt.INSTANCES[n] !== t && xt.INSTANCES[n].popups && xt.INSTANCES[n].popups.areVisible() && xt.INSTANCES[n].$el.find(".fr-marker").remove();
        t.popups.hideAll()
      }
      g.node.hasClass(e.get(0), "fr-dropdown") ? a(e) : (!function r(e) {
        o(e)
      }(e), xt.COMMANDS[e.data("cmd")] && !1 !== xt.COMMANDS[e.data("cmd")].refreshAfterCallback && t.button.bulkRefresh())
    }

    function c(e) {
      t(h(e.currentTarget))
    }

    function d(e) {
      var t = e.find(".fr-dropdown.fr-active");
      t.length && (t.removeClass("fr-active").attr("aria-expanded", !1).next().attr("aria-hidden", !0).css("overflow", "").find("> .fr-dropdown-wrapper").css("height", ""), t.parents(".fr-toolbar:not(.fr-inline)").css("zIndex", ""), t.prev().removeClass("fr-expanded"))
    }

    function f(e) {
      e.preventDefault(), e.stopPropagation()
    }

    function p(e) {
      if (e.stopPropagation(), !g.helpers.isMobile()) return !1
    }

    function v(e) {
      var t = 1 < arguments.length && arguments[1] !== undefined ? arguments[1] : {},
        n = 2 < arguments.length ? arguments[2] : undefined;
      if (g.helpers.isMobile() && !1 === t.showOnMobile) return "";
      var r = t.displaySelection;
      "function" == typeof r && (r = r(g));
      var a = "";
      if ("options" !== t.type) if (r) {
        var o = "function" == typeof t.defaultSelection ? t.defaultSelection(g) : t.defaultSelection;
        a = '<span style="width:'.concat(t.displaySelectionWidth || 100, 'px">').concat(g.language.translate(o || t.title), "</span>")
      } else a = g.icon.create(t.icon || e), a += '<span class="fr-sr-only">'.concat(g.language.translate(t.title) || "", "</span>");
      var i = t.popup ? ' data-popup="true"' : "", s = t.modal ? ' data-modal="true"' : "",
        l = g.shortcuts.get("".concat(e, "."));
      l = l ? " (".concat(l, ")") : "";
      var c = "".concat(e, "-").concat(g.id), d = "dropdown-menu-".concat(c),
        f = '<button id="'.concat(c, '"').concat(t.more_btn ? ' data-group-name="'.concat(c, '" ') : "", 'type="button" tabIndex="-1" role="button"').concat(t.toggle ? ' aria-pressed="false"' : "").concat("dropdown" === t.type || "options" === t.type ? ' aria-controls="'.concat(d, '" aria-expanded="false" aria-haspopup="true"') : "").concat(t.disabled ? ' aria-disabled="true"' : "", ' title="').concat(g.language.translate(t.title) || "").concat(l, '" class="fr-command fr-btn').concat("dropdown" === t.type || "options" == t.type ? " fr-dropdown" : "").concat("options" == t.type ? " fr-options" : "").concat("more" == t.type ? " fr-more" : "").concat(t.displaySelection ? " fr-selection" : "").concat(t.back ? " fr-back" : "").concat(t.disabled ? " fr-disabled" : "").concat(n ? "" : " fr-hidden", '" data-cmd="').concat(e, '"').concat(i).concat(s, ">").concat(a, "</button>");
      if ("dropdown" === t.type || "options" === t.type) {
        var p = '<div id="'.concat(d, '" class="fr-dropdown-menu" role="listbox" aria-labelledby="').concat(c, '" aria-hidden="true"><div class="fr-dropdown-wrapper" role="presentation"><div class="fr-dropdown-content" role="presentation">');
        p += function u(e, t) {
          var n = "";
          if (t.html) "function" == typeof t.html ? n += t.html.call(g) : n += t.html; else {
            var r = t.options;
            for (var a in "function" == typeof r && (r = r()), n += '<ul class="fr-dropdown-list" role="presentation">', r) if (Object.prototype.hasOwnProperty.call(r, a)) {
              var o = g.shortcuts.get("".concat(e, ".").concat(a));
              o = o ? '<span class="fr-shortcut">'.concat(o, "</span>") : "", n += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="'.concat("options" === t.type ? e.replace(/Options/g, "") : e, '" data-param1="').concat(a, '" title="').concat(r[a], '">').concat(g.language.translate(r[a]), "</a></li>")
            }
            n += "</ul>"
          }
          return n
        }(e, t), f += p += "</div></div></div>"
      }
      return t.hasOptions && t.hasOptions.apply(g) && (f = '<div class="fr-btn-wrap">'.concat(f, " ").concat(v(e + "Options", Object.assign({}, t, {
        type: "options",
        hasOptions: !1
      }), n), "  </div>")), f
    }

    function e(a) {
      var o = g.$tb && g.$tb.data("instance") || g;
      if (!1 === g.events.trigger("buttons.refresh")) return !0;
      setTimeout(function () {
        for (var e = o.selection.inEditor() && o.core.hasFocus(), t = 0; t < a.length; t++) {
          var n = h(a[t]), r = n.data("cmd");
          0 === n.parents(".fr-popup").length ? e || xt.COMMANDS[r] && xt.COMMANDS[r].forcedRefresh ? o.button.refresh(n) : g.node.hasClass(n.get(0), "fr-dropdown") || (n.removeClass("fr-active"), n.attr("aria-pressed") && n.attr("aria-pressed", !1)) : n.parents(".fr-popup").isVisible() && o.button.refresh(n)
        }
      }, 0)
    }

    function n() {
      e(i), e(s)
    }

    function r() {
      i = [], s = []
    }

    g.shared.popup_buttons || (g.shared.popup_buttons = []), s = g.shared.popup_buttons;
    var u = null;

    function b() {
      clearTimeout(u), u = setTimeout(n, 50)
    }

    return {
      _init: function C() {
        g.opts.toolbarInline ? g.events.on("toolbar.show", n) : (g.events.on("mouseup", b), g.events.on("keyup", b), g.events.on("blur", b), g.events.on("focus", b), g.events.on("contentChanged", b), g.helpers.isMobile() && g.events.$on(g.$doc, "selectionchange", n)), g.events.on("shared.destroy", r)
      }, build: v, buildList: function E(e, t) {
        for (var n = "", r = 0; r < e.length; r++) {
          var a = e[r], o = xt.COMMANDS[a];
          o && "undefined" != typeof o.plugin && g.opts.pluginsEnabled.indexOf(o.plugin) < 0 || (o ? n += v(a, o, void 0 === t || 0 <= t.indexOf(a)) : "|" === a ? n += '<div class="fr-separator fr-vs" role="separator" aria-orientation="vertical"></div>' : "-" === a && (n += '<div class="fr-separator fr-hs" role="separator" aria-orientation="horizontal"></div>'))
        }
        return n
      }, buildGroup: function y(e) {
        var t = "", n = "";
        for (var r in e) {
          var a = e[r];
          if (a.buttons) {
            for (var o = "", i = "", s = 0, l = "left", c = xt.TOOLBAR_VISIBLE_BUTTONS, d = 0; d < a.buttons.length; d++) {
              var f = a.buttons[d], p = xt.COMMANDS[f];
              p || ("|" == f ? o += '<div class="fr-separator fr-vs" role="separator" aria-orientation="vertical"></div>' : "-" == f && (o += '<div class="fr-separator fr-hs" role="separator" aria-orientation="horizontal"></div>')), !p || p && "undefined" != typeof p.plugin && g.opts.pluginsEnabled.indexOf(p.plugin) < 0 || (e[r].align !== undefined && (l = e[r].align), e[r].buttonsVisible !== undefined && (c = e[r].buttonsVisible), e.showMoreButtons && c <= s ? i += v(f, p, !0) : o += v(f, p, !0), s++)
            }
            if (e.showMoreButtons && c < s) {
              var u = r, h = xt.COMMANDS[u];
              h.more_btn = !0, o += v(u, h, !0)
            }
            "trackChanges" !== r && (t += '<div class="fr-btn-grp fr-float-'.concat(l, '">').concat(o, "</div>")), e.showMoreButtons && 0 < i.length && (n += '<div class="fr-more-toolbar" data-name="'.concat(r + "-" + g.id, '">').concat(i, "</div>"))
          }
        }
        return g.opts.toolbarBottom ? g.helpers.isMobile() ? '<div class="fr-bottom-extended">'.concat(n, "</div><div>").concat(t, "</div>") : "".concat(n, '<div class="fr-newline"></div>').concat(t) : "".concat(t, '<div class="fr-newline"></div>').concat(n)
      }, bindCommands: function L(t, e) {
        g.events.bindClick(t, ".fr-command:not(.fr-disabled)", c), g.events.$on(t, "".concat(g._mousedown, " ").concat(g._mouseup, " ").concat(g._move), ".fr-dropdown-menu", f, !0), g.events.$on(t, "".concat(g._mousedown, " ").concat(g._mouseup, " ").concat(g._move), ".fr-dropdown-menu .fr-dropdown-wrapper", p, !0);
        var n = t.get(0).ownerDocument, r = "defaultView" in n ? n.defaultView : n.parentWindow;

        function a(e) {
          (!e || e.type === g._mouseup && e.target !== h("html").get(0) || "keydown" === e.type && (g.keys.isCharacter(e.which) && !g.keys.ctrlKey(e) || e.which === xt.KEYCODE.ESC)) && d(t)
        }

        g.events.$on(h(r), "".concat(g._mouseup, " resize keydown"), a, !0), g.opts.iframe && g.events.$on(g.$win, g._mouseup, a, !0), g.node.hasClass(t.get(0), "fr-popup") ? h.merge(s, t.find(".fr-btn").toArray()) : h.merge(i, t.find(".fr-btn").toArray()), g.tooltip.bind(t, ".fr-btn, .fr-title", e)
      }, refresh: function _(e) {
        var t, n = e.parents(".fr-popup, .fr-toolbar").data("instance") || g, r = e.data("cmd");
        g.node.hasClass(e.get(0), "fr-dropdown") ? t = e.next() : (e.removeClass("fr-active"), e.attr("aria-pressed") && e.attr("aria-pressed", !1)), xt.COMMANDS[r] && xt.COMMANDS[r].refresh ? xt.COMMANDS[r].refresh.apply(n, [e, t]) : g.refresh[r] && n.refresh[r](e, t)
      }, bulkRefresh: n, exec: o, click: t, hideActiveDropdowns: d, addButtons: function w(e) {
        for (var t = 0; t < e.length; t++) i.push(e[t])
      }, getButtons: m, getPosition: function A(e) {
        var t = e.offset().left, n = g.opts.toolbarBottom ? 10 : e.outerHeight() - 10;
        return {left: t, top: e.offset().top + n}
      }
    }
  }, xt.ICON_TEMPLATES = {
    font_awesome: '<i class="fa fa-[NAME]" aria-hidden="true"></i>',
    font_awesome_5: '<i class="fas fa-[FA5NAME]" aria-hidden="true"></i>',
    font_awesome_5r: '<i class="far fa-[FA5NAME]" aria-hidden="true"></i>',
    font_awesome_5l: '<i class="fal fa-[FA5NAME]" aria-hidden="true"></i>',
    font_awesome_5b: '<i class="fab fa-[FA5NAME]" aria-hidden="true"></i>',
    text: '<span style="text-align: center;">[NAME]</span>',
    image: "<img src=[SRC] alt=[ALT] />",
    svg: '<svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="[PATH]"/></svg>',
    empty: " "
  }, xt.ICONS = {
    bold: {NAME: "bold", SVG_KEY: "bold"},
    italic: {NAME: "italic", SVG_KEY: "italic"},
    underline: {NAME: "underline", SVG_KEY: "underline"},
    strikeThrough: {NAME: "strikethrough", SVG_KEY: "strikeThrough"},
    subscript: {NAME: "subscript", SVG_KEY: "subscript"},
    superscript: {NAME: "superscript", SVG_KEY: "superscript"},
    cancel: {NAME: "cancel", SVG_KEY: "cancel"},
    color: {NAME: "tint", SVG_KEY: "textColor"},
    outdent: {NAME: "outdent", SVG_KEY: "outdent"},
    indent: {NAME: "indent", SVG_KEY: "indent"},
    undo: {NAME: "rotate-left", FA5NAME: "undo", SVG_KEY: "undo"},
    redo: {NAME: "rotate-right", FA5NAME: "redo", SVG_KEY: "redo"},
    insert: {NAME: "insert", SVG_KEY: "insert"},
    insertAll: {NAME: "insertAll", SVG_KEY: "insertAll"},
    insertHR: {NAME: "minus", SVG_KEY: "horizontalLine"},
    clearFormatting: {NAME: "eraser", SVG_KEY: "clearFormatting"},
    selectAll: {NAME: "mouse-pointer", SVG_KEY: "selectAll"},
    minimize: {NAME: "minimize", SVG_KEY: "minimize"},
    moreText: {NAME: "ellipsis-v", SVG_KEY: "textMore"},
    moreParagraph: {NAME: "ellipsis-v", SVG_KEY: "paragraphMore"},
    moreRich: {NAME: "ellipsis-v", SVG_KEY: "insertMore"},
    moreMisc: {NAME: "ellipsis-v", SVG_KEY: "more"}
  }, xt.DefineIconTemplate = function (e, t) {
    xt.ICON_TEMPLATES[e] = t
  }, xt.DefineIcon = function (e, t) {
    xt.ICONS[e] = t
  }, Object.assign(xt.DEFAULTS, {iconsTemplate: "svg"}), xt.MODULES.icon = function (a) {
    return {
      create: function o(n) {
        var e = null, r = xt.ICONS[n];
        if (void 0 !== r) {
          var t = r.template || xt.ICON_DEFAULT_TEMPLATE || a.opts.iconsTemplate;
          t && t.apply && (t = t.apply(a)), r.FA5NAME || (r.FA5NAME = r.NAME), "svg" !== t || r.PATH || (r.PATH = xt.SVG[r.SVG_KEY] || ""), t && (t = xt.ICON_TEMPLATES[t]) && (e = t.replace(/\[([a-zA-Z0-9]*)\]/g, function (e, t) {
            return "NAME" === t ? r[t] || n : r[t]
          }))
        }
        return e || n
      }, getTemplate: function r(e) {
        var t = xt.ICONS[e], n = a.opts.iconsTemplate;
        return void 0 !== t ? n = t.template || xt.ICON_DEFAULT_TEMPLATE || a.opts.iconsTemplate : n
      }, getFileIcon: function n(e) {
        var t = xt.FILEICONS[e];
        return void 0 !== t ? t : e
      }
    }
  }, xt.SVG = {
    add: "M19,13h-6v6h-2v-6H5v-2h6V5h2v6h6V13z",
    advancedImageEditor: "M3,17v2h6v-2H3z M3,5v2h10V5H3z M13,21v-2h8v-2h-8v-2h-2v6H13z M7,9v2H3v2h4v2h2V9H7z M21,13v-2H11v2H21z M15,9h2V7h4V5h-4  V3h-2V9z",
    alignCenter: "M9,18h6v-2H9V18z M6,11v2h12v-2H6z M3,6v2h18V6H3z",
    alignJustify: "M3,18h18v-2H3V18z M3,11v2h18v-2H3z M3,6v2h18V6H3z",
    alignLeft: "M3,18h6v-2H3V18z M3,11v2h12v-2H3z M3,6v2h18V6H3z",
    alignRight: "M15,18h6v-2h-6V18z M9,11v2h12v-2H9z M3,6v2h18V6H3z",
    anchors: "M16,4h-4H8C6.9,4,6,4.9,6,6v4v10l6-2.6l6,2.6V10V6C18,4.9,17.1,4,16,4z M16,17l-4-1.8L8,17v-7V6h4h4v4V17z",
    autoplay: "M 7.570312 0.292969 C 7.542969 0.292969 7.515625 0.292969 7.488281 0.296875 C 7.203125 0.324219 6.984375 0.539062 6.980469 0.792969 L 6.925781 3.535156 C 2.796875 3.808594 -0.0078125 6.425781 -0.0859375 10.09375 C -0.121094 11.96875 0.710938 13.6875 2.265625 14.921875 C 3.769531 16.117188 5.839844 16.796875 8.097656 16.828125 C 8.140625 16.828125 12.835938 16.898438 13.035156 16.886719 C 15.171875 16.796875 17.136719 16.128906 18.558594 15.003906 C 20.066406 13.816406 20.882812 12.226562 20.917969 10.40625 C 20.960938 8.410156 20.023438 6.605469 18.289062 5.335938 C 18.214844 5.277344 18.128906 5.230469 18.035156 5.203125 C 17.636719 5.074219 17.222656 5.199219 17 5.476562 L 15.546875 7.308594 C 15.304688 7.609375 15.363281 8.007812 15.664062 8.265625 C 16.351562 8.851562 16.707031 9.625 16.6875 10.5 C 16.652344 12.25 15.070312 13.390625 12.757812 13.535156 C 12.59375 13.539062 8.527344 13.472656 8.164062 13.464844 C 5.703125 13.429688 4.101562 12.191406 4.140625 10.3125 C 4.175781 8.570312 5.132812 7.46875 6.847656 7.199219 L 6.796875 9.738281 C 6.792969 9.992188 7 10.214844 7.285156 10.253906 C 7.3125 10.257812 7.339844 10.257812 7.367188 10.257812 C 7.503906 10.261719 7.632812 10.222656 7.738281 10.148438 L 14.039062 5.785156 C 14.171875 5.691406 14.253906 5.558594 14.253906 5.410156 C 14.257812 5.261719 14.1875 5.125 14.058594 5.027344 L 7.941406 0.414062 C 7.835938 0.335938 7.707031 0.292969 7.570312 0.292969 ",
    back: "M20 11L7.83 11 11.425 7.405 10.01 5.991 5.416 10.586 5.414 10.584 4 11.998 4.002 12 4 12.002 5.414 13.416 5.416 13.414 10.01 18.009 11.425 16.595 7.83 13 20 13 20 13 20 11 20 11Z",
    backgroundColor: "M9.91752,12.24082l7.74791-5.39017,1.17942,1.29591-6.094,7.20747L9.91752,12.24082M7.58741,12.652l4.53533,4.98327a.93412.93412,0,0,0,1.39531-.0909L20.96943,8.7314A.90827.90827,0,0,0,20.99075,7.533l-2.513-2.76116a.90827.90827,0,0,0-1.19509-.09132L7.809,11.27135A.93412.93412,0,0,0,7.58741,12.652ZM2.7939,18.52772,8.41126,19.5l1.47913-1.34617-3.02889-3.328Z",
    blockquote: "M10.31788,5l.93817,1.3226A12.88271,12.88271,0,0,0,8.1653,9.40125a5.54242,5.54242,0,0,0-.998,3.07866v.33733q.36089-.04773.66067-.084a4.75723,4.75723,0,0,1,.56519-.03691,2.87044,2.87044,0,0,1,2.11693.8427,2.8416,2.8416,0,0,1,.8427,2.09274,3.37183,3.37183,0,0,1-.8898,2.453A3.143,3.143,0,0,1,8.10547,19,3.40532,3.40532,0,0,1,5.375,17.7245,4.91156,4.91156,0,0,1,4.30442,14.453,9.3672,9.3672,0,0,1,5.82051,9.32933,14.75716,14.75716,0,0,1,10.31788,5Zm8.39243,0,.9369,1.3226a12.88289,12.88289,0,0,0-3.09075,3.07865,5.54241,5.54241,0,0,0-.998,3.07866v.33733q.33606-.04773.63775-.084a4.91773,4.91773,0,0,1,.58938-.03691,2.8043,2.8043,0,0,1,2.1042.83,2.89952,2.89952,0,0,1,.80578,2.10547,3.42336,3.42336,0,0,1-.86561,2.453A3.06291,3.06291,0,0,1,16.49664,19,3.47924,3.47924,0,0,1,13.742,17.7245,4.846,4.846,0,0,1,12.64721,14.453,9.25867,9.25867,0,0,1,14.17476,9.3898,15.26076,15.26076,0,0,1,18.71031,5Z",
    bold: "M15.25,11.8h0A3.68,3.68,0,0,0,17,9a3.93,3.93,0,0,0-3.86-4H6.65V19h7a3.74,3.74,0,0,0,3.7-3.78V15.1A3.64,3.64,0,0,0,15.25,11.8ZM8.65,7h4.2a2.09,2.09,0,0,1,2,1.3,2.09,2.09,0,0,1-1.37,2.61,2.23,2.23,0,0,1-.63.09H8.65Zm4.6,10H8.65V13h4.6a2.09,2.09,0,0,1,2,1.3,2.09,2.09,0,0,1-1.37,2.61A2.23,2.23,0,0,1,13.25,17Z",
    cancel: "M13.4,12l5.6,5.6L17.6,19L12,13.4L6.4,19L5,17.6l5.6-5.6L5,6.4L6.4,5l5.6,5.6L17.6,5L19,6.4L13.4,12z",
    cellBackground: "M16.6,12.4L7.6,3.5L6.2,4.9l2.4,2.4l-5.2,5.2c-0.6,0.6-0.6,1.5,0,2.1l5.5,5.5c0.3,0.3,0.7,0.4,1.1,0.4s0.8-0.1,1.1-0.4  l5.5-5.5C17.2,14,17.2,13,16.6,12.4z M5.2,13.5L10,8.7l4.8,4.8H5.2z M19,15c0,0-2,2.2-2,3.5c0,1.1,0.9,2,2,2s2-0.9,2-2  C21,17.2,19,15,19,15z",
    cellBorderColor: "M22,22H2v2h20V22z",
    cellOptions: "M20,5H4C2.9,5,2,5.9,2,7v10c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C22,5.9,21.1,5,20,5z M9.5,6.5h5V9h-5V6.5z M8,17.5H4  c-0.3,0-0.5-0.2-0.5-0.4c0,0,0,0,0,0V17v-2H8V17.5z M8,13.5H3.5v-3H8V13.5z M8,9H3.5V7c0-0.3,0.2-0.5,0.4-0.5c0,0,0,0,0,0H8V9z   M14.5,17.5h-5V15h5V17.5z M20.5,17c0,0.3-0.2,0.5-0.4,0.5c0,0,0,0,0,0H16V15h4.5V17z M20.5,13.5H16v-3h4.5V13.5z M20.5,9H16V6.5h4  c0.3,0,0.5,0.2,0.5,0.4c0,0,0,0,0,0V9z",
    cellStyle: "M20,19.9l0.9,3.6l-3.2-1.9l-3.3,1.9l0.8-3.6L12.3,17h3.8l1.7-3.5l1.4,3.5H23L20,19.9z M20,5H4C2.9,5,2,5.9,2,7v10  c0,1.1,0.9,2,2,2h7.5l-0.6-0.6L10,17.5H9.5V15h5.4l1.1-2.3v-2.2h4.5v3H20l0.6,1.5H22V7C22,5.9,21.1,5,20,5z M3.5,7  c0-0.3,0.2-0.5,0.4-0.5c0,0,0,0,0.1,0h4V9H3.5V7z M3.5,10.5H8v3H3.5V10.5z M4,17.5c-0.3,0-0.5-0.2-0.5-0.4c0,0,0,0,0-0.1v-2H8v2.5H4  z M14.5,9h-5V6.5h5V9z M20.5,9H16V6.5h4c0.3,0,0.5,0.2,0.5,0.4c0,0,0,0,0,0.1V9z",
    clearFormatting: "M11.48,10.09l-1.2-1.21L8.8,7.41,6.43,5,5.37,6.1,8.25,9,4.66,19h2l1.43-4h5.14l1.43,4h2l-.89-2.51L18.27,19l1.07-1.06L14.59,13.2ZM8.8,13l.92-2.56L12.27,13Zm.56-7.15L9.66,5h2l1.75,4.9Z",
    close: "M13.4,12l5.6,5.6L17.6,19L12,13.4L6.4,19L5,17.6l5.6-5.6L5,6.4L6.4,5l5.6,5.6L17.6,5L19,6.4L13.4,12z",
    codeView: "M9.4,16.6,4.8,12,9.4,7.4,8,6,2,12l6,6Zm5.2,0L19.2,12,14.6,7.4,16,6l6,6-6,6Z",
    cogs: "M18.877 12.907a6.459 6.459 0 0 0 0 -1.814l1.952 -1.526a0.468 0.468 0 0 0 0.111 -0.593l-1.851 -3.2a0.461 0.461 0 0 0 -0.407 -0.231 0.421 0.421 0 0 0 -0.157 0.028l-2.3 0.925a6.755 6.755 0 0 0 -1.563 -0.907l-0.352 -2.452a0.451 0.451 0 0 0 -0.453 -0.388h-3.7a0.451 0.451 0 0 0 -0.454 0.388L9.347 5.588A7.077 7.077 0 0 0 7.783 6.5l-2.3 -0.925a0.508 0.508 0 0 0 -0.166 -0.028 0.457 0.457 0 0 0 -0.4 0.231l-1.851 3.2a0.457 0.457 0 0 0 0.111 0.593l1.952 1.526A7.348 7.348 0 0 0 5.063 12a7.348 7.348 0 0 0 0.064 0.907L3.175 14.433a0.468 0.468 0 0 0 -0.111 0.593l1.851 3.2a0.461 0.461 0 0 0 0.407 0.231 0.421 0.421 0 0 0 0.157 -0.028l2.3 -0.925a6.74 6.74 0 0 0 1.564 0.907L9.7 20.864a0.451 0.451 0 0 0 0.454 0.388h3.7a0.451 0.451 0 0 0 0.453 -0.388l0.352 -2.452a7.093 7.093 0 0 0 1.563 -0.907l2.3 0.925a0.513 0.513 0 0 0 0.167 0.028 0.457 0.457 0 0 0 0.4 -0.231l1.851 -3.2a0.468 0.468 0 0 0 -0.111 -0.593Zm-0.09 2.029l-0.854 1.476 -2.117 -0.852 -0.673 0.508a5.426 5.426 0 0 1 -1.164 0.679l-0.795 0.323 -0.33 2.269h-1.7l-0.32 -2.269 -0.793 -0.322a5.3 5.3 0 0 1 -1.147 -0.662L8.2 15.56l-2.133 0.86 -0.854 -1.475 1.806 -1.411 -0.1 -0.847c-0.028 -0.292 -0.046 -0.5 -0.046 -0.687s0.018 -0.4 0.045 -0.672l0.106 -0.854L5.217 9.064l0.854 -1.475 2.117 0.851 0.673 -0.508a5.426 5.426 0 0 1 1.164 -0.679l0.8 -0.323 0.331 -2.269h1.7l0.321 2.269 0.792 0.322a5.3 5.3 0 0 1 1.148 0.661l0.684 0.526 2.133 -0.859 0.853 1.473 -1.8 1.421 0.1 0.847a5 5 0 0 1 0.046 0.679c0 0.193 -0.018 0.4 -0.045 0.672l-0.106 0.853ZM12 14.544A2.544 2.544 0 1 1 14.546 12 2.552 2.552 0 0 1 12 14.544Z",
    columns: "M20,5H4C2.9,5,2,5.9,2,7v10c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C22,5.9,21.1,5,20,5z M8,17.5H4c-0.3,0-0.5-0.2-0.5-0.4  c0,0,0,0,0,0V17v-2H8V17.5z M8,13.5H3.5v-3H8V13.5z M8,9H3.5V7c0-0.3,0.2-0.5,0.4-0.5c0,0,0,0,0,0H8V9z M20.5,17  c0,0.3-0.2,0.5-0.4,0.5c0,0,0,0,0,0H16V15h4.5V17z M20.5,13.5H16v-3h4.5V13.5z M20.5,9H16V6.5h4c0.3,0,0.5,0.2,0.5,0.4c0,0,0,0,0,0  V9z",
    edit: "M17,11.2L12.8,7L5,14.8V19h4.2L17,11.2z M7,16.8v-1.5l5.6-5.6l1.4,1.5l-5.6,5.6H7z M13.5,6.3l0.7-0.7c0.8-0.8,2.1-0.8,2.8,0  c0,0,0,0,0,0L18.4,7c0.8,0.8,0.8,2,0,2.8l-0.7,0.7L13.5,6.3z",
    exitFullscreen: "M5,16H8v3h2V14H5ZM8,8H5v2h5V5H8Zm6,11h2V16h3V14H14ZM16,8V5H14v5h5V8Z",
    fileInsert: "M 8.09375 12.75 L 5.90625 12.75 C 5.542969 12.75 5.25 12.394531 5.25 11.953125 L 5.25 6.375 L 2.851562 6.375 C 2.367188 6.375 2.121094 5.660156 2.464844 5.242188 L 6.625 0.1875 C 6.832031 -0.0585938 7.167969 -0.0585938 7.371094 0.1875 L 11.535156 5.242188 C 11.878906 5.660156 11.632812 6.375 11.148438 6.375 L 8.75 6.375 L 8.75 11.953125 C 8.75 12.394531 8.457031 12.75 8.09375 12.75 Z M 14 12.484375 L 14 16.203125 C 14 16.644531 13.707031 17 13.34375 17 L 0.65625 17 C 0.292969 17 0 16.644531 0 16.203125 L 0 12.484375 C 0 12.042969 0.292969 11.6875 0.65625 11.6875 L 4.375 11.6875 L 4.375 11.953125 C 4.375 12.980469 5.0625 13.8125 5.90625 13.8125 L 8.09375 13.8125 C 8.9375 13.8125 9.625 12.980469 9.625 11.953125 L 9.625 11.6875 L 13.34375 11.6875 C 13.707031 11.6875 14 12.042969 14 12.484375 Z M 10.609375 15.40625 C 10.609375 15.039062 10.363281 14.742188 10.0625 14.742188 C 9.761719 14.742188 9.515625 15.039062 9.515625 15.40625 C 9.515625 15.773438 9.761719 16.070312 10.0625 16.070312 C 10.363281 16.070312 10.609375 15.773438 10.609375 15.40625 Z M 12.359375 15.40625 C 12.359375 15.039062 12.113281 14.742188 11.8125 14.742188 C 11.511719 14.742188 11.265625 15.039062 11.265625 15.40625 C 11.265625 15.773438 11.511719 16.070312 11.8125 16.070312 C 12.113281 16.070312 12.359375 15.773438 12.359375 15.40625 Z M 12.359375 15.40625 ",
    fileManager: "M 0 5.625 L 20.996094 5.625 L 21 15.75 C 21 16.371094 20.410156 16.875 19.6875 16.875 L 1.3125 16.875 C 0.585938 16.875 0 16.371094 0 15.75 Z M 0 5.625 M 21 4.5 L 0 4.5 L 0 2.25 C 0 1.628906 0.585938 1.125 1.3125 1.125 L 6.921875 1.125 C 7.480469 1.125 8.015625 1.316406 8.40625 1.652344 L 9.800781 2.847656 C 10.195312 3.183594 10.730469 3.375 11.289062 3.375 L 19.6875 3.375 C 20.414062 3.375 21 3.878906 21 4.5 Z M 21 4.5",
    markdown: "M5.55006 17.75V7.35L8.96006 16.89H10.7101L14.2301 7.37V14.0729C14.3951 14.1551 14.5499 14.265 14.6875 14.4026L14.7001 14.4151V11.64C14.7001 10.8583 15.2127 10.1963 15.9201 9.97171V5H13.6801L10.0401 14.86L6.51006 5H4.00006V17.75H5.55006ZM17.2001 11.64C17.2001 11.2258 16.8643 10.89 16.4501 10.89C16.0359 10.89 15.7001 11.2258 15.7001 11.64V16.8294L13.9804 15.1097C13.6875 14.8168 13.2126 14.8168 12.9197 15.1097C12.6269 15.4026 12.6269 15.8775 12.9197 16.1703L15.9197 19.1703C16.2126 19.4632 16.6875 19.4632 16.9804 19.1703L19.9804 16.1703C20.2733 15.8775 20.2733 15.4026 19.9804 15.1097C19.6875 14.8168 19.2126 14.8168 18.9197 15.1097L17.2001 16.8294V11.64Z",
    fontAwesome: "M18.99018,13.98212V7.52679c-.08038-1.21875-1.33929-.683-1.33929-.683-2.933,1.39282-4.36274.61938-5.85938.15625a6.23272,6.23272,0,0,0-2.79376-.20062l-.00946.004A1.98777,1.98777,0,0,0,7.62189,5.106a.984.984,0,0,0-.17517-.05432c-.02447-.0055-.04882-.01032-.0736-.0149A.9565.9565,0,0,0,7.1908,5H6.82539a.9565.9565,0,0,0-.18232.0368c-.02472.00458-.04907.0094-.07348.01484a.985.985,0,0,0-.17523.05438,1.98585,1.98585,0,0,0-.573,3.49585v9.394A1.004,1.004,0,0,0,6.82539,19H7.1908a1.00406,1.00406,0,0,0,1.00409-1.00409V15.52234c3.64221-1.09827,5.19709.64282,7.09888.57587a5.57291,5.57291,0,0,0,3.25446-1.05805A1.2458,1.2458,0,0,0,18.99018,13.98212Z",
    fontFamily: "M16,19h2L13,5H11L6,19H8l1.43-4h5.14Zm-5.86-6L12,7.8,13.86,13Z",
    fontSize: "M20.75,19h1.5l-3-10h-1.5l-3,10h1.5L17,16.5h3Zm-3.3-4,1.05-3.5L19.55,15Zm-5.7,4h2l-5-14h-2l-5,14h2l1.43-4h5.14ZM5.89,13,7.75,7.8,9.61,13Z",
    fullscreen: "M7,14H5v5h5V17H7ZM5,10H7V7h3V5H5Zm12,7H14v2h5V14H17ZM14,5V7h3v3h2V5Z",
    help: "M11,17h2v2h-2V17z M12,5C9.8,5,8,6.8,8,9h2c0-1.1,0.9-2,2-2s2,0.9,2,2c0,2-3,1.7-3,5v1h2v-1c0-2.2,3-2.5,3-5  C16,6.8,14.2,5,12,5z",
    horizontalLine: "M5,12h14 M19,11H5v2h14V11z",
    imageAltText: "M19,7h-6v12h-2V7H5V5h6h2h6V7z",
    imageCaption: "M14.2,11l3.8,5H6l3-3.9l2.1,2.7L14,11H14.2z M8.5,11c0.8,0,1.5-0.7,1.5-1.5S9.3,8,8.5,8S7,8.7,7,9.5C7,10.3,7.7,11,8.5,11z   M22,6v12c0,1.1-0.9,2-2,2H4c-1.1,0-2-0.9-2-2V6c0-1.1,0.9-2,2-2h16C21.1,4,22,4.9,22,6z M20,8.8V6H4v12h16V8.8z M22,22H2v2h20V22z",
    imageClass: "M9.5,13.4l-2.9-2.9h3.8L12.2,7l1.4,3.5h3.8l-3,2.9l0.9,3.6L12,15.1L8.8,17L9.5,13.4z M22,6v12c0,1.1-0.9,2-2,2H4  c-1.1,0-2-0.9-2-2V6c0-1.1,0.9-2,2-2h16C21.1,4,22,4.9,22,6z M20,6H4v12h16V8.8V6z",
    imageDisplay: "M3,5h18v2H3V5z M13,9h8v2h-8V9z M13,13h8v2h-8V13z M3,17h18v2H3V17z M3,9h8v6H3V9z",
    imageManager: "M20,6h-7l-2-2H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V8C22,6.9,21.1,6,20,6z M20,18H4V6h6.2l2,2H20V18z   M18,16l-3.8-5H14l-2.9,3.8L9,12.1L6,16H18z M10,9.5C10,8.7,9.3,8,8.5,8S7,8.7,7,9.5S7.7,11,8.5,11S10,10.3,10,9.5z",
    imageSize: "M16.9,4c-0.3,0-0.5,0.2-0.8,0.3L3.3,13c-0.9,0.6-1.1,1.9-0.5,2.8l2.2,3.3c0.4,0.7,1.2,1,2,0.8c0.3,0,0.5-0.2,0.8-0.3  L20.7,11c0.9-0.6,1.1-1.9,0.5-2.8l-2.2-3.3C18.5,4.2,17.7,3.9,16.9,4L16.9,4z M16.9,9.9L18.1,9l-2-2.9L17,5.6c0.1,0,0.1-0.1,0.2-0.1  c0.2,0,0.4,0,0.5,0.2L19.9,9c0.2,0.2,0.1,0.5-0.1,0.7L7,18.4c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0-0.4,0-0.5-0.2L4.1,15  c-0.2-0.2-0.1-0.5,0.1-0.7L5,13.7l2,2.9l1.2-0.8l-2-2.9L7.5,12l1.1,1.7l1.2-0.8l-1.1-1.7l1.2-0.8l2,2.9l1.2-0.8l-2-2.9l1.2-0.8  l1.1,1.7l1.2-0.8l-1.1-1.7L14.9,7L16.9,9.9z",
    indent: "M3,9v6l3-3L3,9z M3,19h18v-2H3V19z M3,7h18V5H3V7z M9,11h12V9H9V11z M9,15h12v-2H9V15z",
    inlineClass: "M9.9,13.313A1.2,1.2,0,0,1,9.968,13H6.277l1.86-5.2,1.841,5.148A1.291,1.291,0,0,1,11.212,12h.426l-2.5-7h-2l-5,14h2l1.43-4H9.9Zm2.651,6.727a2.884,2.884,0,0,1-.655-2.018v-2.71A1.309,1.309,0,0,1,13.208,14h3.113a3.039,3.039,0,0,1,2,1.092s1.728,1.818,2.964,2.928a1.383,1.383,0,0,1,.318,1.931,1.44,1.44,0,0,1-.19.215l-3.347,3.31a1.309,1.309,0,0,1-1.832.258h0a1.282,1.282,0,0,1-.258-.257l-1.71-1.728Zm2.48-3.96a.773.773,0,1,0,.008,0Z",
    inlineStyle: "M11.88,15h.7l.7-1.7-3-8.3h-2l-5,14h2l1.4-4Zm-4.4-2,1.9-5.2,1.9,5.2ZM15.4,21.545l3.246,1.949-.909-3.637L20.72,17H16.954l-1.429-3.506L13.837,17H10.071l2.857,2.857-.779,3.637Z",
    insert: "M13.889,11.611c-0.17,0.17-0.443,0.17-0.612,0l-3.189-3.187l-3.363,3.36c-0.171,0.171-0.441,0.171-0.612,0c-0.172-0.169-0.172-0.443,0-0.611l3.667-3.669c0.17-0.17,0.445-0.172,0.614,0l3.496,3.493C14.058,11.167,14.061,11.443,13.889,11.611 M18.25,10c0,4.558-3.693,8.25-8.25,8.25c-4.557,0-8.25-3.692-8.25-8.25c0-4.557,3.693-8.25,8.25-8.25C14.557,1.75,18.25,5.443,18.25,10 M17.383,10c0-4.07-3.312-7.382-7.383-7.382S2.618,5.93,2.618,10S5.93,17.381,10,17.381S17.383,14.07,17.383,10",
    insertEmbed: "M20.73889,15.45929a3.4768,3.4768,0,0,0-5.45965-.28662L9.5661,12.50861a3.49811,3.49811,0,0,0-.00873-1.01331l5.72174-2.66809a3.55783,3.55783,0,1,0-.84527-1.81262L8.70966,9.6839a3.50851,3.50851,0,1,0,.0111,4.63727l5.7132,2.66412a3.49763,3.49763,0,1,0,6.30493-1.526ZM18.00745,5.01056A1.49993,1.49993,0,1,1,16.39551,6.3894,1.49994,1.49994,0,0,1,18.00745,5.01056ZM5.99237,13.49536a1.49989,1.49989,0,1,1,1.61194-1.37878A1.49982,1.49982,0,0,1,5.99237,13.49536Zm11.78211,5.494a1.49993,1.49993,0,1,1,1.61193-1.37885A1.49987,1.49987,0,0,1,17.77448,18.98932Z",
    insertFile: "M7,3C5.9,3,5,3.9,5,5v14c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2V7.6L14.4,3H7z M17,19H7V5h6v4h4V19z",
    insertImage: "M14.2,11l3.8,5H6l3-3.9l2.1,2.7L14,11H14.2z M8.5,11c0.8,0,1.5-0.7,1.5-1.5S9.3,8,8.5,8S7,8.7,7,9.5C7,10.3,7.7,11,8.5,11z   M22,6v12c0,1.1-0.9,2-2,2H4c-1.1,0-2-0.9-2-2V6c0-1.1,0.9-2,2-2h16C21.1,4,22,4.9,22,6z M20,8.8V6H4v12h16V8.8z",
    insertLink: "M11,17H7A5,5,0,0,1,7,7h4V9H7a3,3,0,0,0,0,6h4ZM17,7H13V9h4a3,3,0,0,1,0,6H13v2h4A5,5,0,0,0,17,7Zm-1,4H8v2h8Z",
    insertMore: "M16.5,13h-6v6h-2V13h-6V11h6V5h2v6h6Zm5,4.5A1.5,1.5,0,1,1,20,16,1.5,1.5,0,0,1,21.5,17.5Zm0-4A1.5,1.5,0,1,1,20,12,1.5,1.5,0,0,1,21.5,13.5Zm0-4A1.5,1.5,0,1,1,20,8,1.5,1.5,0,0,1,21.5,9.5Z",
    insertTable: "M20,5H4C2.9,5,2,5.9,2,7v2v1.5v3V15v2c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2v-2v-1.5v-3V9V7C22,5.9,21.1,5,20,5z M9.5,13.5v-3  h5v3H9.5z M14.5,15v2.5h-5V15H14.5z M9.5,9V6.5h5V9H9.5z M3.5,7c0-0.3,0.2-0.5,0.5-0.5h4V9H3.5V7z M3.5,10.5H8v3H3.5V10.5z M3.5,17  v-2H8v2.5H4C3.7,17.5,3.5,17.3,3.5,17z M20.5,17c0,0.3-0.2,0.5-0.5,0.5h-4V15h4.5V17z M20.5,13.5H16v-3h4.5V13.5z M16,9V6.5h4  c0.3,0,0.5,0.2,0.5,0.5v2H16z",
    insertVideo: "M15,8v8H5V8H15m2,2.5V7a1,1,0,0,0-1-1H4A1,1,0,0,0,3,7V17a1,1,0,0,0,1,1H16a1,1,0,0,0,1-1V13.5l2.29,2.29A1,1,0,0,0,21,15.08V8.91a1,1,0,0,0-1.71-.71Z",
    upload: "M12 6.66667a4.87654 4.87654 0 0 1 4.77525 3.92342l0.29618 1.50268 1.52794 0.10578a2.57021 2.57021 0 0 1 -0.1827 5.13478H6.5a3.49774 3.49774 0 0 1 -0.3844 -6.97454l1.06682 -0.11341L7.678 9.29387A4.86024 4.86024 0 0 1 12 6.66667m0 -2A6.871 6.871 0 0 0 5.90417 8.37 5.49773 5.49773 0 0 0 6.5 19.33333H18.41667a4.57019 4.57019 0 0 0 0.32083 -9.13A6.86567 6.86567 0 0 0 12 4.66667Zm0.99976 7.2469h1.91406L11.99976 9 9.08618 11.91357h1.91358v3H11V16h2V14h-0.00024Z",
    uploadFiles: "M12 6.66667a4.87654 4.87654 0 0 1 4.77525 3.92342l0.29618 1.50268 1.52794 0.10578a2.57021 2.57021 0 0 1 -0.1827 5.13478H6.5a3.49774 3.49774 0 0 1 -0.3844 -6.97454l1.06682 -0.11341L7.678 9.29387A4.86024 4.86024 0 0 1 12 6.66667m0 -2A6.871 6.871 0 0 0 5.90417 8.37 5.49773 5.49773 0 0 0 6.5 19.33333H18.41667a4.57019 4.57019 0 0 0 0.32083 -9.13A6.86567 6.86567 0 0 0 12 4.66667Zm0.99976 7.2469h1.91406L11.99976 9 9.08618 11.91357h1.91358v3H11V16h2V14h-0.00024Z",
    italic: "M11.76,9h2l-2.2,10h-2Zm1.68-4a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z",
    search: "M15.5 14h-0.79l-0.28 -0.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09 -0.59 4.23 -1.57l0.27 0.28v0.79l5 4.99L20.49 19l-4.99 -5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z",
    lineHeight: "M6.25,7h2.5L5.25,3.5,1.75,7h2.5V17H1.75l3.5,3.5L8.75,17H6.25Zm4-2V7h12V5Zm0,14h12V17h-12Zm0-6h12V11h-12Z",
    linkStyles: "M19,17.9l0.9,3.6l-3.2-1.9l-3.3,1.9l0.8-3.6L11.3,15h3.8l1.7-3.5l1.4,3.5H22L19,17.9z M20,12c0,0.3-0.1,0.7-0.2,1h2.1  c0.1-0.3,0.1-0.6,0.1-1c0-2.8-2.2-5-5-5h-4v2h4C18.7,9,20,10.3,20,12z M14.8,11H8v2h3.3h2.5L14.8,11z M9.9,16.4L8.5,15H7  c-1.7,0-3-1.3-3-3s1.3-3,3-3h4V7H7c-2.8,0-5,2.2-5,5s2.2,5,5,5h3.5L9.9,16.4z",
    mention: "M12.4,5c-4.1,0-7.5,3.4-7.5,7.5S8.3,20,12.4,20h3.8v-1.5h-3.8c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6v1.1  c0,0.6-0.5,1.2-1.1,1.2s-1.1-0.6-1.1-1.2v-1.1c0-2.1-1.7-3.8-3.8-3.8s-3.7,1.7-3.7,3.8s1.7,3.8,3.8,3.8c1,0,2-0.4,2.7-1.1  c0.5,0.7,1.3,1.1,2.2,1.1c1.5,0,2.6-1.2,2.6-2.7v-1.1C19.9,8.4,16.6,5,12.4,5z M12.4,14.7c-1.2,0-2.3-1-2.3-2.2s1-2.3,2.3-2.3  s2.3,1,2.3,2.3S13.6,14.7,12.4,14.7z",
    minimize: "M5,12h14 M19,11H5v2h14V11z",
    more: "M13.5,17c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5S13.5,16.2,13.5,17z M13.5,12c0,0.8-0.7,1.5-1.5,1.5 s-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5S13.5,11.2,13.5,12z M13.5,7c0,0.8-0.7,1.5-1.5,1.5S10.5,7.8,10.5,7s0.7-1.5,1.5-1.5 S13.5,6.2,13.5,7z",
    openLink: "M17,17H7V7h3V5H7C6,5,5,6,5,7v10c0,1,1,2,2,2h10c1,0,2-1,2-2v-3h-2V17z M14,5v2h1.6l-5.8,5.8l1.4,1.4L17,8.4V10h2V5H14z",
    orderedList: "M2.5,16h2v.5h-1v1h1V18h-2v1h3V15h-3Zm1-7h1V5h-2V6h1Zm-1,2H4.3L2.5,13.1V14h3V13H3.7l1.8-2.1V10h-3Zm5-5V8h14V6Zm0,12h14V16H7.5Zm0-5h14V11H7.5Z",
    outdent: "M3,12l3,3V9L3,12z M3,19h18v-2H3V19z M3,7h18V5H3V7z M9,11h12V9H9V11z M9,15h12v-2H9V15z",
    pageBreaker: "M3,9v6l3-3L3,9z M21,9H8V4h2v3h9V4h2V9z M21,20h-2v-3h-9v3H8v-5h13V20z M11,13H8v-2h3V13z M16,13h-3v-2h3V13z M21,13h-3v-2  h3V13z",
    paragraphFormat: "M10.15,5A4.11,4.11,0,0,0,6.08,8.18,4,4,0,0,0,10,13v6h2V7h2V19h2V7h2V5ZM8,9a2,2,0,0,1,2-2v4A2,2,0,0,1,8,9Z",
    paragraphMore: "M7.682,5a4.11,4.11,0,0,0-4.07,3.18,4,4,0,0,0,3.11,4.725h0l.027.005a3.766,3.766,0,0,0,.82.09v6h2V7h2V19h2V7h2V5ZM5.532,9a2,2,0,0,1,2-2v4A2,2,0,0,1,5.532,9Zm14.94,8.491a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,20.472,17.491Zm0-4a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,20.472,13.491Zm0-4a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,20.472,9.491Z",
    paragraphStyle: "M4,9c0-1.1,0.9-2,2-2v4C4.9,11,4,10.1,4,9z M16.7,20.5l3.2,1.9L19,18.8l3-2.9h-3.7l-1.4-3.5L15.3,16h-3.8l2.9,2.9l-0.9,3.6  L16.7,20.5z M10,17.4V19h1.6L10,17.4z M6.1,5c-1.9,0-3.6,1.3-4,3.2c-0.5,2.1,0.8,4.2,2.9,4.7c0,0,0,0,0,0h0.2C5.5,13,5.8,13,6,13v6  h2V7h2v7h2V7h2V5H6.1z",
    pdfExport: "M7,3C5.9,3,5,3.9,5,5v14c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2V7.6L14.4,3H7z M17,19H7V5h6v4h4V19z M16.3,13.5  c-0.2-0.6-1.1-0.8-2.6-0.8c-0.1,0-0.1,0-0.2,0c-0.3-0.3-0.8-0.9-1-1.2c-0.2-0.2-0.3-0.3-0.4-0.6c0.2-0.7,0.2-1,0.3-1.5  c0.1-0.9,0-1.6-0.2-1.8c-0.4-0.2-0.7-0.2-0.9-0.2c-0.1,0-0.3,0.2-0.7,0.7c-0.2,0.7-0.1,1.8,0.6,2.8c-0.2,0.8-0.7,1.6-1,2.4  c-0.8,0.2-1.5,0.7-1.9,1.1c-0.7,0.7-0.9,1.1-0.7,1.6c0,0.3,0.2,0.6,0.7,0.6c0.3-0.1,0.3-0.2,0.7-0.3c0.6-0.3,1.2-1.7,1.7-2.4  c0.8-0.2,1.7-0.3,2-0.3c0.1,0,0.3,0,0.6,0c0.8,0.8,1.2,1.1,1.8,1.2c0.1,0,0.2,0,0.3,0c0.3,0,0.8-0.1,1-0.6  C16.4,14.1,16.4,13.9,16.3,13.5z M8.3,15.7c-0.1,0.1-0.2,0.1-0.2,0.1c0-0.1,0-0.3,0.6-0.8c0.2-0.2,0.6-0.3,0.9-0.7  C9,15,8.6,15.5,8.3,15.7z M11.3,9c0-0.1,0.1-0.2,0.1-0.2S11.6,9,11.5,10c0,0.1,0,0.3-0.1,0.7C11.3,10.1,11,9.5,11.3,9z M10.9,13.1  c0.2-0.6,0.6-1,0.7-1.5c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.2,0.3,0.7,0.7,0.9C12.2,12.8,11.6,13,10.9,13.1z M15.2,14.1  c-0.1,0-0.1,0-0.2,0c-0.2,0-0.7-0.2-1-0.7c1.1,0,1.6,0.2,1.6,0.6C15.5,14.1,15.4,14.1,15.2,14.1z",
    print: "M16.1,17c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1s-0.4,1-1,1C16.5,18,16.1,17.6,16.1,17z M22,15v4c0,1.1-0.9,2-2,2H4  c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2h1V5c0-1.1,0.9-2,2-2h7.4L19,7.6V13h1C21.1,13,22,13.9,22,15z M7,13h10V9h-4V5H7V13z M20,15H4  v4h16V15z",
    redo: "M13.6,9.4c1.7,0.3,3.2,0.9,4.6,2L21,8.5v7h-7l2.7-2.7C13,10.1,7.9,11,5.3,14.7c-0.2,0.3-0.4,0.5-0.5,0.8L3,14.6  C5.1,10.8,9.3,8.7,13.6,9.4z",
    removeTable: "M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z",
    insertAll: "M 9.25 12 L 6.75 12 C 6.335938 12 6 11.664062 6 11.25 L 6 6 L 3.257812 6 C 2.703125 6 2.425781 5.328125 2.820312 4.933594 L 7.570312 0.179688 C 7.804688 -0.0546875 8.191406 -0.0546875 8.425781 0.179688 L 13.179688 4.933594 C 13.574219 5.328125 13.296875 6 12.742188 6 L 10 6 L 10 11.25 C 10 11.664062 9.664062 12 9.25 12 Z M 16 11.75 L 16 15.25 C 16 15.664062 15.664062 16 15.25 16 L 0.75 16 C 0.335938 16 0 15.664062 0 15.25 L 0 11.75 C 0 11.335938 0.335938 11 0.75 11 L 5 11 L 5 11.25 C 5 12.214844 5.785156 13 6.75 13 L 9.25 13 C 10.214844 13 11 12.214844 11 11.25 L 11 11 L 15.25 11 C 15.664062 11 16 11.335938 16 11.75 Z M 12.125 14.5 C 12.125 14.15625 11.84375 13.875 11.5 13.875 C 11.15625 13.875 10.875 14.15625 10.875 14.5 C 10.875 14.84375 11.15625 15.125 11.5 15.125 C 11.84375 15.125 12.125 14.84375 12.125 14.5 Z M 14.125 14.5 C 14.125 14.15625 13.84375 13.875 13.5 13.875 C 13.15625 13.875 12.875 14.15625 12.875 14.5 C 12.875 14.84375 13.15625 15.125 13.5 15.125 C 13.84375 15.125 14.125 14.84375 14.125 14.5 Z M 14.125 14.5 ",
    remove: "M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z",
    replaceImage: "M16,5v3H4v2h12v3l4-4L16,5z M8,19v-3h12v-2H8v-3l-4,4L8,19z",
    row: "M20,5H4C2.9,5,2,5.9,2,7v2v1.5v3V15v2c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2v-2v-1.5v-3V9V7C22,5.9,21.1,5,20,5z M16,6.5h4  c0.3,0,0.5,0.2,0.5,0.5v2H16V6.5z M9.5,6.5h5V9h-5V6.5z M3.5,7c0-0.3,0.2-0.5,0.5-0.5h4V9H3.5V7z M8,17.5H4c-0.3,0-0.5-0.2-0.5-0.5  v-2H8V17.5z M14.5,17.5h-5V15h5V17.5z M20.5,17c0,0.3-0.2,0.5-0.5,0.5h-4V15h4.5V17z",
    selectAll: "M5,7h2V5C5.9,5,5,5.9,5,7z M5,11h2V9H5V11z M9,19h2v-2H9V19z M5,11h2V9H5V11z M15,5h-2v2h2V5z M17,5v2h2C19,5.9,18.1,5,17,5  z M7,19v-2H5C5,18.1,5.9,19,7,19z M5,15h2v-2H5V15z M11,5H9v2h2V5z M13,19h2v-2h-2V19z M17,11h2V9h-2V11z M17,19c1.1,0,2-0.9,2-2h-2  V19z M17,11h2V9h-2V11z M17,15h2v-2h-2V15z M13,19h2v-2h-2V19z M13,7h2V5h-2V7z M9,15h6V9H9V15z M11,11h2v2h-2V11z",
    smile: "M11.991,3A9,9,0,1,0,21,12,8.99557,8.99557,0,0,0,11.991,3ZM12,19a7,7,0,1,1,7-7A6.99808,6.99808,0,0,1,12,19Zm3.105-5.2h1.503a4.94542,4.94542,0,0,1-9.216,0H8.895a3.57808,3.57808,0,0,0,6.21,0ZM7.5,9.75A1.35,1.35,0,1,1,8.85,11.1,1.35,1.35,0,0,1,7.5,9.75Zm6.3,0a1.35,1.35,0,1,1,1.35,1.35A1.35,1.35,0,0,1,13.8,9.75Z",
    spellcheck: "M19.1,13.6l-5.6,5.6l-2.7-2.7l-1.4,1.4l4.1,4.1l7-7L19.1,13.6z M10.8,13.7l2.7,2.7l0.8-0.8L10.5,5h-2l-5,14h2l1.4-4h2.6  L10.8,13.7z M9.5,7.8l1.9,5.2H7.6L9.5,7.8z",
    star: "M12.1,7.7l1,2.5l0.4,0.9h1h2.4l-2.1,2l-0.6,0.6l0.2,0.9l0.6,2.3l-2.2-1.3L12,15.2l-0.8,0.5L9,17l0.5-2.5l0.1-0.8L9,13.1  l-2-2h2.5h0.9l0.4-0.8L12.1,7.7 M12.2,4L9.5,9.6H3.4L8,14.2L6.9,20l5.1-3.1l5.3,3.1l-1.5-5.8l4.8-4.6h-6.1L12.2,4L12.2,4z",
    strikeThrough: "M3,12.20294H21v1.5H16.63422a3.59782,3.59782,0,0,1,.34942,1.5929,3.252,3.252,0,0,1-1.31427,2.6997A5.55082,5.55082,0,0,1,12.20251,19a6.4421,6.4421,0,0,1-2.62335-.539,4.46335,4.46335,0,0,1-1.89264-1.48816,3.668,3.668,0,0,1-.67016-2.15546V14.704h.28723v-.0011h.34149v.0011H9.02v.11334a2.18275,2.18275,0,0,0,.85413,1.83069,3.69,3.69,0,0,0,2.32836.67926,3.38778,3.38778,0,0,0,2.07666-.5462,1.73346,1.73346,0,0,0,.7013-1.46655,1.69749,1.69749,0,0,0-.647-1.43439,3.00525,3.00525,0,0,0-.27491-.17725H3ZM16.34473,7.05981A4.18163,4.18163,0,0,0,14.6236,5.5462,5.627,5.627,0,0,0,12.11072,5,5.16083,5.16083,0,0,0,8.74719,6.06213,3.36315,3.36315,0,0,0,7.44006,8.76855a3.22923,3.22923,0,0,0,.3216,1.42786h2.59668c-.08338-.05365-.18537-.10577-.25269-.16064a1.60652,1.60652,0,0,1-.65283-1.30036,1.79843,1.79843,0,0,1,.68842-1.5108,3.12971,3.12971,0,0,1,1.96948-.55243,3.04779,3.04779,0,0,1,2.106.6687,2.35066,2.35066,0,0,1,.736,1.83258v.11341h2.00317V9.17346A3.90013,3.90013,0,0,0,16.34473,7.05981Z",
    subscript: "M10.4,12l3.6,3.6L12.6,17L9,13.4L5.4,17L4,15.6L7.6,12L4,8.4L5.4,7L9,10.6L12.6,7L14,8.4L10.4,12z M18.31234,19.674  l1.06812-1.1465c0.196-0.20141,0.37093-0.40739,0.5368-0.6088c0.15975-0.19418,0.30419-0.40046,0.432-0.617  c0.11969-0.20017,0.21776-0.41249,0.29255-0.6334c0.07103-0.21492,0.10703-0.43986,0.10662-0.66621  c0.00297-0.28137-0.04904-0.56062-0.1531-0.82206c-0.09855-0.24575-0.25264-0.46534-0.45022-0.6416  c-0.20984-0.18355-0.45523-0.32191-0.72089-0.40646c-0.63808-0.19005-1.3198-0.17443-1.94851,0.04465  c-0.28703,0.10845-0.54746,0.2772-0.76372,0.49487c-0.20881,0.20858-0.37069,0.45932-0.47483,0.73548  c-0.10002,0.26648-0.15276,0.54838-0.15585,0.833l-0.00364,0.237H17.617l0.00638-0.22692  c0.00158-0.12667,0.01966-0.25258,0.05377-0.37458c0.03337-0.10708,0.08655-0.20693,0.15679-0.29437  c0.07105-0.08037,0.15959-0.14335,0.25882-0.1841c0.22459-0.08899,0.47371-0.09417,0.7018-0.01458  c0.0822,0.03608,0.15559,0.08957,0.21509,0.15679c0.06076,0.07174,0.10745,0.15429,0.13761,0.24333  c0.03567,0.10824,0.05412,0.22141,0.05469,0.33538c-0.00111,0.08959-0.0118,0.17881-0.0319,0.26612  c-0.02913,0.10428-0.07076,0.20465-0.124,0.29893c-0.07733,0.13621-0.1654,0.26603-0.26338,0.38823  c-0.13438,0.17465-0.27767,0.34226-0.42929,0.50217l-2.15634,2.35315V21H21v-1.326H18.31234z",
    superscript: "M10.4,12,14,15.6,12.6,17,9,13.4,5.4,17,4,15.6,7.6,12,4,8.4,5.4,7,9,10.6,12.6,7,14,8.4Zm8.91234-3.326,1.06812-1.1465c.196-.20141.37093-.40739.5368-.6088a4.85745,4.85745,0,0,0,.432-.617,3.29,3.29,0,0,0,.29255-.6334,2.11079,2.11079,0,0,0,.10662-.66621,2.16127,2.16127,0,0,0-.1531-.82206,1.7154,1.7154,0,0,0-.45022-.6416,2.03,2.03,0,0,0-.72089-.40646,3.17085,3.17085,0,0,0-1.94851.04465,2.14555,2.14555,0,0,0-.76372.49487,2.07379,2.07379,0,0,0-.47483.73548,2.446,2.446,0,0,0-.15585.833l-.00364.237H18.617L18.62338,5.25a1.45865,1.45865,0,0,1,.05377-.37458.89552.89552,0,0,1,.15679-.29437.70083.70083,0,0,1,.25882-.1841,1.00569,1.00569,0,0,1,.7018-.01458.62014.62014,0,0,1,.21509.15679.74752.74752,0,0,1,.13761.24333,1.08893,1.08893,0,0,1,.05469.33538,1.25556,1.25556,0,0,1-.0319.26612,1.34227,1.34227,0,0,1-.124.29893,2.94367,2.94367,0,0,1-.26338.38823,6.41629,6.41629,0,0,1-.42929.50217L17.19709,8.92642V10H22V8.674Z",
    symbols: "M15.77493,16.98885a8.21343,8.21343,0,0,0,1.96753-2.57651,7.34824,7.34824,0,0,0,.6034-3.07618A6.09092,6.09092,0,0,0,11.99515,5a6.13347,6.13347,0,0,0-4.585,1.79187,6.417,6.417,0,0,0-1.756,4.69207,6.93955,6.93955,0,0,0,.622,2.97415,8.06587,8.06587,0,0,0,1.949,2.53076H5.41452V19h5.54114v-.04331h-.00147V16.84107a5.82825,5.82825,0,0,1-2.2052-2.2352A6.40513,6.40513,0,0,1,7.97672,11.447,4.68548,4.68548,0,0,1,9.07785,8.19191a3.73232,3.73232,0,0,1,2.9173-1.22462,3.76839,3.76839,0,0,1,2.91241,1.21489,4.482,4.482,0,0,1,1.11572,3.154,6.71141,6.71141,0,0,1-.75384,3.24732,5.83562,5.83562,0,0,1-2.22357,2.25759v2.11562H13.0444V19h5.54108V16.98885Z",
    tags: "M8.9749 7.47489a1.5 1.5 0 1 1 -1.5 1.5A1.5 1.5 0 0 1 8.9749 7.47489Zm3.78866 -3.12713L16.5362 8.12041l0.33565 0.33564 2.77038 2.77038a2.01988 2.01988 0 0 1 0.59 1.42 1.95518 1.95518 0 0 1 -0.5854 1.40455l0.00044 0.00043 -5.59583 5.59583 -0.00043 -0.00044a1.95518 1.95518 0 0 1 -1.40455 0.5854 1.98762 1.98762 0 0 1 -1.41 -0.58L8.45605 16.87185l-0.33564 -0.33565L4.35777 12.77357a1.99576 1.99576 0 0 1 -0.59 -1.42V9.36358l0 -3.59582a2.00579 2.00579 0 0 1 2 -2l3.59582 0h1.98995A1.98762 1.98762 0 0 1 12.76356 4.34776ZM15.46186 9.866l-0.33564 -0.33564L11.36359 5.76776H5.76776v5.59583L9.866 15.46186l2.7794 2.7794 5.5878 -5.60385 -0.001 -0.001Z",
    tableHeader: "M20,5H4C2.9,5,2,5.9,2,7v10c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C22,5.9,21.1,5,20,5z M8,17.5H4c-0.3,0-0.5-0.2-0.5-0.4  l0,0V17v-2H8V17.5z M8,13.5H3.5v-3H8V13.5z M14.5,17.5h-5V15h5V17.5z M14.5,13.5h-5v-3h5V13.5z M20.5,17c0,0.3-0.2,0.5-0.4,0.5l0,0  H16V15h4.5V17z M20.5,13.5H16v-3h4.5V13.5z M20.5,9h-4.4H16h-1.5h-5H8H7.9H3.5V7c0-0.3,0.2-0.5,0.4-0.5l0,0h4l0,0h8.2l0,0H20  c0.3,0,0.5,0.2,0.5,0.4l0,0V9z",
    tableStyle: "M20.0171,19.89752l.9,3.6-3.2-1.9-3.3,1.9.8-3.6-2.9-2.9h3.8l1.7-3.5,1.4,3.5h3.8ZM20,5H4A2.00591,2.00591,0,0,0,2,7V17a2.00591,2.00591,0,0,0,2,2h7.49115l-.58826-.58826L9.99115,17.5H9.5V14.9975h5.36511L16,12.66089V10.5h4.5v3h-.52783l.599,1.4975H22V7A2.00591,2.00591,0,0,0,20,5ZM3.5,7A.4724.4724,0,0,1,4,6.5H8V9H3.5Zm0,3.5H8v3H3.5Zm.5,7a.4724.4724,0,0,1-.5-.5V15H8v2.5Zm10.5-4h-5v-3h5Zm0-4.5h-5V6.5h5Zm6,0H16V6.5h4a.4724.4724,0,0,1,.5.5Z",
    textColor: "M15.2,13.494s-3.6,3.9-3.6,6.3a3.65,3.65,0,0,0,7.3.1v-.1C18.9,17.394,15.2,13.494,15.2,13.494Zm-1.47-1.357.669-.724L12.1,5h-2l-5,14h2l1.43-4h2.943A24.426,24.426,0,0,1,13.726,12.137ZM11.1,7.8l1.86,5.2H9.244Z",
    textMore: "M13.55,19h2l-5-14h-2l-5,14h2l1.4-4h5.1Zm-5.9-6,1.9-5.2,1.9,5.2Zm12.8,4.5a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,20.45,17.5Zm0-4a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,20.45,13.5Zm0-4A1.5,1.5,0,1,1,18.95,8,1.5,1.5,0,0,1,20.45,9.5Z",
    underline: "M19,20v2H5V20Zm-3-6.785a4,4,0,0,1-5.74,3.4A3.75,3.75,0,0,1,8,13.085V5.005H6v8.21a6,6,0,0,0,8,5.44,5.851,5.851,0,0,0,4-5.65v-8H16ZM16,5v0h2V5ZM8,5H6v0H8Z",
    undo: "M10.4,9.4c-1.7,0.3-3.2,0.9-4.6,2L3,8.5v7h7l-2.7-2.7c3.7-2.6,8.8-1.8,11.5,1.9c0.2,0.3,0.4,0.5,0.5,0.8l1.8-0.9  C18.9,10.8,14.7,8.7,10.4,9.4z",
    unlink: "M14.4,11l1.6,1.6V11H14.4z M17,7h-4v1.9h4c1.7,0,3.1,1.4,3.1,3.1c0,1.3-0.8,2.4-1.9,2.8l1.4,1.4C21,15.4,22,13.8,22,12  C22,9.2,19.8,7,17,7z M2,4.3l3.1,3.1C3.3,8.1,2,9.9,2,12c0,2.8,2.2,5,5,5h4v-1.9H7c-1.7,0-3.1-1.4-3.1-3.1c0-1.6,1.2-2.9,2.8-3.1  L8.7,11H8v2h2.7l2.3,2.3V17h1.7l4,4l1.4-1.4L3.4,2.9L2,4.3z",
    unorderedList: "M4,10.5c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S4.8,10.5,4,10.5z M4,5.5C3.2,5.5,2.5,6.2,2.5,7  S3.2,8.5,4,8.5S5.5,7.8,5.5,7S4.8,5.5,4,5.5z M4,15.5c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S4.8,15.5,4,15.5z   M7.5,6v2h14V6H7.5z M7.5,18h14v-2h-14V18z M7.5,13h14v-2h-14V13z",
    verticalAlignBottom: "M16,13h-3V3h-2v10H8l4,4L16,13z M3,19v2h18v-2H3z",
    verticalAlignMiddle: "M3,11v2h18v-2H3z M8,18h3v3h2v-3h3l-4-4L8,18z M16,6h-3V3h-2v3H8l4,4L16,6z",
    verticalAlignTop: "M8,11h3v10h2V11h3l-4-4L8,11z M21,5V3H3v2H21z",
    trackChanges: "M17.2 20H12.4599L13.9938 19.2076L14.0305 19.1886L14.0616 19.1612C14.1036 19.1242 14.1373 19.0786 14.1603 19.0275C14.1806 18.9825 14.1923 18.9342 14.1948 18.885H14.2H14.3384L14.4364 18.7874L14.7049 18.52H15.45C15.5747 18.52 15.6942 18.4705 15.7823 18.3823C15.8705 18.2942 15.92 18.1746 15.92 18.05C15.92 17.9253 15.8705 17.8058 15.7823 17.7176C15.7351 17.6704 15.6789 17.6343 15.6177 17.6109L17.33 15.9056V19.87C17.33 19.8871 17.3266 19.904 17.3201 19.9197C17.3136 19.9355 17.304 19.9499 17.2919 19.9619C17.2799 19.974 17.2655 19.9836 17.2497 19.9901C17.234 19.9966 17.2171 20 17.2 20ZM4.13 20H11.2508C11.2396 19.9629 11.2337 19.9242 11.2337 19.885C11.2337 19.8133 11.2533 19.7431 11.29 19.6819L11.2739 19.6734L11.8838 18.52H5C4.87535 18.52 4.7558 18.4705 4.66766 18.3823C4.57952 18.2942 4.53 18.1746 4.53 18.05C4.53 17.9253 4.57952 17.8058 4.66766 17.7176C4.7558 17.6295 4.87535 17.58 5 17.58H12.3809L12.3925 17.5582L12.4187 17.5284C12.4558 17.4864 12.5014 17.4527 12.5525 17.4297C12.5836 17.4156 12.6163 17.4057 12.6498 17.4001C12.6522 17.3065 12.6877 17.2166 12.7503 17.1467L13 17.37C12.9902 17.381 12.9847 17.3952 12.9847 17.41C12.9847 17.4247 12.9902 17.439 13 17.45L14.13 18.55H14.2L19.09 13.68V13.6L17.99 12.5C17.979 12.4902 17.9647 12.4847 17.95 12.4847C17.9352 12.4847 17.921 12.4902 17.91 12.5L13 17.37L12.7641 17.1322L15.1759 14.74H5C4.87535 14.74 4.7558 14.6905 4.66766 14.6023C4.57952 14.5142 4.53 14.3946 4.53 14.27C4.53 14.1453 4.57952 14.0258 4.66766 13.9376C4.7558 13.8495 4.87535 13.8 5 13.8H15.45C15.5747 13.8 15.6942 13.8495 15.7823 13.9376C15.8169 13.9722 15.8454 14.0115 15.8675 14.0541L17.33 12.6034V9.3H13.28C13.207 9.30976 13.133 9.30976 13.06 9.3C12.7697 9.22119 12.5113 9.05343 12.3212 8.82027C12.1311 8.58711 12.0187 8.30026 12 8V4H4.13C4.09552 4 4.06246 4.0137 4.03808 4.03808C4.0137 4.06246 4 4.09552 4 4.13V19.87C4 19.9045 4.0137 19.9375 4.03808 19.9619C4.06246 19.9863 4.09552 20 4.13 20ZM11.7889 20H11.8785C11.8902 19.9746 11.898 19.9475 11.9015 19.9197L11.8661 19.9866L11.8117 19.9578L13.84 18.91C13.8464 18.9044 13.8515 18.8974 13.855 18.8897C13.8585 18.8819 13.8603 18.8735 13.8603 18.865C13.8603 18.8565 13.8585 18.8481 13.855 18.8403C13.8515 18.8325 13.8464 18.8256 13.84 18.82L12.76 17.75C12.7544 17.7436 12.7474 17.7385 12.7397 17.735C12.7319 17.7315 12.7235 17.7297 12.715 17.7297C12.7065 17.7297 12.6981 17.7315 12.6903 17.735C12.6825 17.7385 12.6756 17.7436 12.67 17.75L11.57 19.83L11.5023 19.7942L11.58 19.85C11.5727 19.8602 11.5687 19.8724 11.5687 19.885C11.5687 19.8975 11.5727 19.9098 11.58 19.92L11.67 20H11.73L11.7642 19.9823L11.7889 20ZM13.1 4.65L16.6 8.15C16.6212 8.17232 16.6355 8.20028 16.6412 8.23051C16.6469 8.26075 16.6437 8.29199 16.6321 8.32048C16.6205 8.34898 16.6009 8.37352 16.5757 8.39117C16.5505 8.40882 16.5207 8.41883 16.49 8.42H13.06L12.83 8.19V4.76C12.8312 4.72925 12.8412 4.6995 12.8588 4.67429C12.8765 4.64909 12.901 4.62951 12.9295 4.6179C12.958 4.6063 12.9893 4.60315 13.0195 4.60884C13.0497 4.61453 13.0777 4.62882 13.1 4.65ZM11 6.72C11.0027 6.66089 10.9937 6.60183 10.9735 6.54621C10.9534 6.49058 10.9224 6.43948 10.8825 6.39582C10.8425 6.35216 10.7944 6.31681 10.7408 6.29179C10.6871 6.26677 10.6291 6.25257 10.57 6.25H5C4.88239 6.25773 4.77251 6.3113 4.69397 6.39918C4.61543 6.48707 4.57451 6.60226 4.58 6.72C4.57451 6.83774 4.61543 6.95293 4.69397 7.04082C4.77251 7.12871 4.88239 7.18227 5 7.19H10.6C10.714 7.1774 10.8189 7.12173 10.8933 7.03438C10.9676 6.94702 11.0058 6.83457 11 6.72ZM11.1 8.14001H5C4.87535 8.14001 4.7558 8.18953 4.66766 8.27767C4.57952 8.36582 4.53 8.48536 4.53 8.61001C4.53 8.73467 4.57952 8.85421 4.66766 8.94236C4.7558 9.0305 4.87535 9.08001 5 9.08001H11.1C11.2247 9.08001 11.3442 9.0305 11.4323 8.94236C11.5205 8.85421 11.57 8.73467 11.57 8.61001C11.57 8.48536 11.5205 8.36582 11.4323 8.27767C11.3442 8.18953 11.2247 8.14001 11.1 8.14001ZM5 11H15.45C15.5826 11 15.7098 10.9473 15.8036 10.8536C15.8973 10.7598 15.95 10.6326 15.95 10.5C15.95 10.3674 15.8973 10.2402 15.8036 10.1464C15.7098 10.0527 15.5826 10 15.45 10H5C4.86739 10 4.74021 10.0527 4.64645 10.1464C4.55268 10.2402 4.5 10.3674 4.5 10.5C4.5 10.6326 4.55268 10.7598 4.64645 10.8536C4.74021 10.9473 4.86739 11 5 11ZM5 12.86H11.1C11.2211 12.8523 11.3346 12.798 11.4166 12.7085C11.4986 12.6191 11.5428 12.5013 11.54 12.38C11.5427 12.2597 11.4982 12.1431 11.4159 12.0552C11.3337 11.9673 11.2202 11.9152 11.1 11.91H5C4.94089 11.9126 4.88286 11.9268 4.82924 11.9518C4.77562 11.9768 4.72746 12.0122 4.68752 12.0558C4.64758 12.0995 4.61664 12.1506 4.59648 12.2062C4.57631 12.2618 4.56731 12.3209 4.57 12.38C4.56451 12.5004 4.60649 12.6181 4.6869 12.7079C4.76731 12.7976 4.87974 12.8523 5 12.86ZM11.1 16.63H5C4.87535 16.63 4.7558 16.5805 4.66766 16.4923C4.57952 16.4042 4.53 16.2846 4.53 16.16C4.53 16.0353 4.57952 15.9158 4.66766 15.8276C4.7558 15.7395 4.87535 15.69 5 15.69H11.1C11.2247 15.69 11.3442 15.7395 11.4323 15.8276C11.5205 15.9158 11.57 16.0353 11.57 16.16C11.57 16.2846 11.5205 16.4042 11.4323 16.4923C11.3442 16.5805 11.2247 16.63 11.1 16.63ZM18.8503 11.592C18.7991 11.6175 18.7545 11.6544 18.72 11.7L18.26 12.14C18.2501 12.151 18.2447 12.1652 18.2447 12.18C18.2447 12.1947 18.2501 12.209 18.26 12.22L19.37 13.32C19.381 13.3298 19.3952 13.3353 19.41 13.3353C19.4247 13.3353 19.439 13.3298 19.45 13.32L19.86 12.91C19.9057 12.867 19.9421 12.8151 19.967 12.7575C19.9919 12.6998 20.0047 12.6377 20.0047 12.575C20.0047 12.5122 19.9919 12.4501 19.967 12.3925C19.9421 12.3349 19.9057 12.283 19.86 12.24L19.31 11.7C19.2755 11.6544 19.2309 11.6175 19.1797 11.592C19.1285 11.5666 19.0721 11.5533 19.015 11.5533C18.9578 11.5533 18.9014 11.5666 18.8503 11.592Z",
    showTrackChanges: "M17.2421 13.6048C17.2631 13.6136 17.2841 13.6226 17.305 13.6317V9.29505H13.2626C13.1897 9.30481 13.1159 9.30481 13.043 9.29505C12.7532 9.21632 12.4953 9.04872 12.3056 8.81577C12.1158 8.58283 12.0037 8.29625 11.985 7.99627V4H4.12976C4.09534 4 4.06234 4.01368 4.038 4.03804C4.01367 4.0624 4 4.09543 4 4.12988V19.8552C4 19.8896 4.01367 19.9227 4.038 19.947C4.06234 19.9714 4.09534 19.9851 4.12976 19.9851H13.4875C13.0501 19.8216 12.6281 19.6155 12.2277 19.3686C11.8529 19.1551 11.4911 18.9196 11.1442 18.6632C11.0697 18.6152 10.9982 18.5628 10.9302 18.5065H4.99812C4.87371 18.5065 4.75438 18.457 4.66641 18.3689C4.57843 18.2809 4.529 18.1614 4.529 18.0369C4.529 17.9124 4.57843 17.7929 4.66641 17.7049C4.75438 17.6168 4.87371 17.5673 4.99812 17.5673H10.4396C10.4472 17.4488 10.4756 17.3324 10.5235 17.2235C10.5939 17.017 10.6761 16.8149 10.7694 16.6182H4.99812C4.87371 16.6182 4.75438 16.5687 4.66641 16.4807C4.57843 16.3926 4.529 16.2732 4.529 16.1487C4.529 16.0241 4.57843 15.9047 4.66641 15.8166C4.75438 15.7286 4.87371 15.6791 4.99812 15.6791H11.0867C11.1576 15.6791 11.2268 15.6952 11.2895 15.7253C11.5204 15.361 11.7938 15.027 12.1033 14.73H4.99812C4.87371 14.73 4.75438 14.6805 4.66641 14.5924C4.57843 14.5044 4.529 14.385 4.529 14.2604C4.529 14.1359 4.57843 14.0164 4.66641 13.9284C4.75438 13.8403 4.87371 13.7909 4.99812 13.7909H13.4434C13.9833 13.525 14.5656 13.3516 15.166 13.2795L15.1923 13.2763H15.2189H15.4925C16.0923 13.2609 16.6886 13.3728 17.2421 13.6048ZM13.0829 4.64939L16.5764 8.14613C16.5975 8.16843 16.6118 8.19636 16.6174 8.22657C16.6231 8.25677 16.62 8.28798 16.6084 8.31645C16.5968 8.34492 16.5773 8.36944 16.5521 8.38707C16.527 8.40471 16.4973 8.41471 16.4666 8.41587H13.043L12.8134 8.18609V4.75929C12.8146 4.72857 12.8246 4.69884 12.8422 4.67366C12.8598 4.64849 12.8843 4.62893 12.9128 4.61733C12.9412 4.60573 12.9724 4.60259 13.0026 4.60827C13.0328 4.61396 13.0607 4.62824 13.0829 4.64939ZM10.9869 6.71746C10.9896 6.65841 10.9806 6.59941 10.9604 6.54383C10.9403 6.48825 10.9094 6.4372 10.8696 6.39358C10.8297 6.34997 10.7816 6.31465 10.7281 6.28965C10.6746 6.26466 10.6167 6.25047 10.5577 6.2479H4.99813C4.88074 6.25562 4.77106 6.30914 4.69267 6.39694C4.61428 6.48475 4.57343 6.59983 4.57891 6.71746C4.57343 6.83509 4.61428 6.95017 4.69267 7.03798C4.77106 7.12579 4.88074 7.1793 4.99813 7.18702H10.5876C10.7014 7.17444 10.8061 7.11882 10.8803 7.03154C10.9545 6.94427 10.9927 6.83192 10.9869 6.71746ZM11.0867 8.13614H4.99812C4.87371 8.13614 4.75438 8.18561 4.66641 8.27367C4.57843 8.36173 4.529 8.48116 4.529 8.6057C4.529 8.73023 4.57843 8.84967 4.66641 8.93773C4.75438 9.02579 4.87371 9.07526 4.99812 9.07526H11.0867C11.2111 9.07526 11.3304 9.02579 11.4184 8.93773C11.5064 8.84967 11.5558 8.73023 11.5558 8.6057C11.5558 8.48116 11.5064 8.36173 11.4184 8.27367C11.3304 8.18561 11.2111 8.13614 11.0867 8.13614ZM4.99812 10.9935H15.4285C15.5609 10.9935 15.6878 10.9408 15.7814 10.8472C15.875 10.7535 15.9276 10.6264 15.9276 10.4939C15.9276 10.3614 15.875 10.2344 15.7814 10.1407C15.6878 10.047 15.5609 9.9944 15.4285 9.9944H4.99812C4.86576 9.9944 4.73883 10.047 4.64523 10.1407C4.55164 10.2344 4.49906 10.3614 4.49906 10.4939C4.49906 10.6264 4.55164 10.7535 4.64523 10.8472C4.73883 10.9408 4.86576 10.9935 4.99812 10.9935ZM4.99812 12.8517H11.0867C11.2076 12.844 11.3208 12.7898 11.4027 12.7004C11.4845 12.611 11.5287 12.4934 11.5259 12.3722C11.5286 12.252 11.4841 12.1355 11.402 12.0477C11.3199 11.9599 11.2067 11.9078 11.0867 11.9026H4.99812C4.93912 11.9052 4.8812 11.9194 4.82769 11.9444C4.77417 11.9694 4.7261 12.0047 4.68623 12.0483C4.64637 12.0919 4.61549 12.143 4.59536 12.1985C4.57523 12.2541 4.56625 12.3131 4.56893 12.3722C4.56345 12.4925 4.60535 12.6101 4.68561 12.6998C4.76587 12.7894 4.87809 12.844 4.99812 12.8517ZM19.97 17.4974C19.5787 16.5636 19.0431 15.6971 18.383 14.9298C18.0152 14.5351 17.5679 14.2233 17.0706 14.0148C16.5732 13.8064 16.0373 13.7062 15.4984 13.7209H15.2189C14.4787 13.8098 13.7684 14.0666 13.1423 14.4717C12.5162 14.8769 11.9906 15.4196 11.6057 16.0587C11.3211 16.4677 11.0959 16.9151 10.937 17.3875C10.9006 17.464 10.8817 17.5476 10.8817 17.6323C10.8817 17.717 10.9006 17.8006 10.937 17.877C11.0642 18.0428 11.2196 18.1849 11.3961 18.2967C11.7346 18.5476 12.0879 18.7778 12.4541 18.986C13.4096 19.5767 14.497 19.92 15.6182 19.9851C16.4392 20.0504 17.2632 19.9005 18.0088 19.5501C18.7544 19.1998 19.3959 18.661 19.8702 17.9869C19.9311 17.923 19.9729 17.8432 19.9905 17.7566C20.0082 17.67 20.0011 17.5801 19.97 17.4974ZM15.9775 19.1758C14.3849 19.068 12.8507 18.5331 11.5358 17.6273C11.5788 17.5678 11.6255 17.5111 11.6756 17.4574C12.3061 16.569 13.1295 15.8359 14.0832 15.3126C13.8003 15.7406 13.6785 16.2566 13.7417 16.7681C13.7676 17.0339 13.8465 17.2918 13.9737 17.5265C14.1009 17.7613 14.2739 17.9681 14.4823 18.1348C14.6907 18.3016 14.9304 18.4248 15.1872 18.4972C15.4441 18.5696 15.7128 18.5897 15.9775 18.5564C16.305 18.4971 16.6137 18.3609 16.8785 18.159C17.1432 17.9572 17.3564 17.6954 17.5005 17.3951C17.6446 17.0949 17.7156 16.7647 17.7077 16.4317C17.6997 16.0987 17.613 15.7723 17.4547 15.4793C17.2614 15.3391 17.0533 15.2235 16.8351 15.1339C17.0715 15.226 17.2966 15.3485 17.5046 15.4993C18.0049 15.8976 18.4424 16.3691 18.8022 16.898L18.8927 17.0137L18.8927 17.0137C19.0823 17.2564 19.2729 17.5004 19.4709 17.7072C18.5404 18.6311 17.288 19.1576 15.9775 19.1758ZM16.3168 15.769C16.2085 15.8106 16.1171 15.8873 16.0574 15.9869C15.9977 16.0865 15.9731 16.2032 15.9875 16.3185C15.9949 16.3856 16.0156 16.4505 16.0483 16.5096C16.081 16.5686 16.1251 16.6206 16.178 16.6624C16.2309 16.7042 16.2916 16.7351 16.3566 16.7532C16.4216 16.7714 16.4895 16.7764 16.5564 16.7681H16.6063C16.5618 16.9495 16.4637 17.1132 16.3248 17.238C16.186 17.3627 16.0127 17.4427 15.8278 17.4674H15.6481C15.4335 17.4396 15.2337 17.3427 15.0789 17.1913C14.924 17.04 14.8226 16.8423 14.7897 16.6282C14.7628 16.3782 14.8311 16.1271 14.981 15.9253C15.1305 15.7238 15.3504 15.5861 15.5968 15.5395C15.3446 15.5862 15.12 15.7284 14.9697 15.9364C14.8191 16.1448 14.7547 16.4034 14.7897 16.6582C14.8226 16.8723 14.924 17.0699 15.0789 17.2213C15.2337 17.3727 15.4335 17.4696 15.6481 17.4974H15.8377C16.0209 17.4708 16.1919 17.39 16.3289 17.2654C16.4658 17.1408 16.5625 16.978 16.6063 16.7981C16.7293 16.7633 16.8359 16.686 16.9072 16.5799C16.9785 16.4737 17.0098 16.3457 16.9956 16.2186C16.9882 16.1515 16.9675 16.0865 16.9348 16.0275C16.9021 15.9685 16.858 15.9165 16.805 15.8747C16.7521 15.8329 16.6914 15.802 16.6264 15.7838C16.5615 15.7657 16.4936 15.7607 16.4266 15.769H16.3168Z",
    acceptAllChanges: "M9.36499 16.7348C9.38499 16.7547 9.41212 16.7659 9.44041 16.7659H10.9881C10.9028 16.6008 10.9289 16.3933 11.0663 16.2541L11.7266 15.585H10.1444C10.0549 15.5701 9.97363 15.5238 9.91498 15.4547C9.85639 15.3856 9.82422 15.298 9.82422 15.2074C9.82422 15.1169 9.85639 15.0292 9.91498 14.9601C9.97363 14.891 10.0549 14.8448 10.1444 14.8298H12.4879C12.5584 14.785 12.6407 14.7607 12.7257 14.7607C12.8106 14.7607 12.893 14.785 12.9635 14.8298H16.5295L18.3303 13.0091C18.4135 12.925 18.5271 12.8776 18.6456 12.8777C18.7642 12.8777 18.8777 12.9252 18.9609 13.0094L20 14.0621V8.25532H16.8001C16.7301 8.27288 16.6568 8.27288 16.5868 8.25532C16.3485 8.1935 16.1367 8.0565 15.9829 7.86478C15.8292 7.67306 15.7416 7.43688 15.7335 7.19149V4H9.44041C9.41293 4.0024 9.38718 4.01437 9.36767 4.03383C9.34816 4.05329 9.33615 4.07897 9.33375 4.10638V16.6596C9.33375 16.6878 9.34499 16.7148 9.36499 16.7348ZM10.0744 17.2979H11.4803L12.259 18.0957H5.06727C5.01734 18.0957 4.96838 18.1057 4.9232 18.1246C4.8788 18.1431 4.83798 18.1702 4.80335 18.2048C4.7333 18.2746 4.69398 18.3693 4.69398 18.468C4.69398 18.5668 4.7333 18.6615 4.80335 18.7313C4.87333 18.8011 4.96832 18.8404 5.06727 18.8404H12.9857L13.7947 19.6693L14.0836 19.9574H4.10733C4.09291 19.9591 4.07829 19.9576 4.06457 19.9528C4.05085 19.9481 4.03838 19.9403 4.02812 19.9301C4.01785 19.9198 4.01004 19.9074 4.00529 19.8937C4.00054 19.88 3.99896 19.8654 4.00067 19.8511V7.29787C4.00067 7.26966 4.01191 7.2426 4.03191 7.22265C4.05192 7.2027 4.07905 7.19149 4.10733 7.19149H8.70447V9.05319H5.06727C4.97294 9.05867 4.88453 9.10069 4.8208 9.17019C4.757 9.23973 4.72302 9.33135 4.72594 9.42553C4.72289 9.52082 4.75654 9.61364 4.82002 9.6849C4.88356 9.75613 4.97203 9.80038 5.06727 9.8085H8.70447V10.5638H5.06727C5.01968 10.5652 4.97274 10.5759 4.92932 10.5954C4.88583 10.6148 4.84664 10.6426 4.8139 10.6772C4.78122 10.7118 4.7557 10.7525 4.73877 10.7969C4.72184 10.8413 4.7139 10.8887 4.71527 10.9361C4.7139 10.9837 4.72184 11.031 4.73877 11.0754C4.74424 11.0897 4.75055 11.1037 4.75778 11.1171C4.76162 11.1243 4.76566 11.1313 4.76995 11.1382C4.78265 11.1585 4.79736 11.1776 4.8139 11.1951C4.84664 11.2297 4.88583 11.2575 4.92932 11.2769C4.95491 11.2884 4.98173 11.2968 5.0092 11.3021C5.02834 11.3058 5.04774 11.3079 5.06727 11.3085H8.70447V12.0638H5.06734C4.97782 12.0789 4.89651 12.1251 4.83792 12.1942C4.77926 12.2633 4.7471 12.351 4.7471 12.4415C4.7471 12.5321 4.77926 12.6197 4.83792 12.6888C4.89651 12.758 4.97782 12.8041 5.06734 12.8192H8.70447V13.5745H5.06734C4.97782 13.5895 4.89651 13.6357 4.83792 13.7048C4.81383 13.7332 4.79424 13.7647 4.77946 13.7983C4.7583 13.8465 4.7471 13.8988 4.7471 13.9522C4.7471 14.0427 4.77926 14.1303 4.83792 14.1994C4.89651 14.2686 4.97782 14.3147 5.06734 14.3298H8.70447V15.0744H5.06727C4.97776 15.0895 4.89651 15.1357 4.83785 15.2048C4.77926 15.2739 4.7471 15.3616 4.7471 15.4521C4.7471 15.5043 4.75778 15.5556 4.77809 15.6029C4.793 15.6376 4.81305 15.6701 4.83785 15.6994C4.89651 15.7685 4.97776 15.8147 5.06727 15.8298H8.70447V16.5851H5.06727C4.97776 16.6001 4.89651 16.6463 4.83785 16.7154C4.79489 16.7661 4.76618 16.8267 4.75387 16.8912C4.74938 16.9146 4.7471 16.9386 4.7471 16.9628C4.7471 17.0533 4.77926 17.1409 4.83785 17.21C4.89651 17.2792 4.97776 17.3253 5.06727 17.3404H9.95241C9.99552 17.3331 10.0367 17.3187 10.0744 17.2979ZM20 15.3204L18.5709 16.7659H19.8933C19.9216 16.7659 19.9487 16.7547 19.9687 16.7348C19.9887 16.7148 20 16.6878 20 16.6596V15.3204ZM14.7526 16.6264L13.7248 15.585H15.7825L14.7526 16.6264ZM14.9498 6.08721C14.9465 6.06854 14.9416 6.05023 14.9353 6.03244C14.9202 5.98939 14.897 5.94929 14.8665 5.91442C14.8145 5.85488 14.7444 5.81394 14.6669 5.79787H10.1337C10.0348 5.79787 9.93978 5.83709 9.8698 5.90693C9.79975 5.97676 9.76043 6.07146 9.76043 6.17022C9.76043 6.19463 9.76283 6.21879 9.76752 6.24239C9.77462 6.2782 9.78692 6.31268 9.80398 6.34479C9.82123 6.37716 9.8433 6.40709 9.8698 6.43348C9.93978 6.50332 10.0348 6.54257 10.1337 6.54257H14.6669C14.6811 6.54023 14.6951 6.53702 14.7088 6.53299C14.7206 6.52955 14.7322 6.52549 14.7436 6.52082C14.7624 6.51309 14.7806 6.50371 14.7979 6.4928C14.8378 6.46764 14.8722 6.43468 14.8991 6.39599C14.9259 6.35729 14.9447 6.31359 14.9543 6.26749C14.9554 6.26232 14.9563 6.25716 14.9571 6.25197C14.9579 6.24739 14.9586 6.24281 14.9591 6.23824C14.9612 6.22129 14.962 6.20424 14.9616 6.18723C14.961 6.16727 14.9588 6.14733 14.9549 6.12766C14.9539 6.11406 14.9523 6.10055 14.9498 6.08721ZM15.0189 7.29788H10.1445C10.0549 7.31291 9.97363 7.35911 9.91504 7.42823C9.85639 7.49738 9.82422 7.585 9.82422 7.67555C9.82422 7.76609 9.85639 7.85369 9.91504 7.92284C9.97363 7.99196 10.0549 8.03815 10.1445 8.05319H15.0189C15.0321 8.05241 15.0451 8.05095 15.058 8.04877C15.0745 8.04601 15.0906 8.04212 15.1064 8.03718C15.1669 8.01822 15.2219 7.98361 15.2654 7.93618C15.3291 7.86664 15.3632 7.77502 15.3602 7.68084C15.3606 7.67392 15.3608 7.66701 15.3608 7.66009C15.3609 7.65087 15.3606 7.64165 15.3599 7.63247C15.3592 7.62263 15.358 7.61279 15.3565 7.60302C15.3532 7.58188 15.3479 7.56104 15.3409 7.54072C15.3254 7.49575 15.301 7.45426 15.2693 7.41868C15.2492 7.39621 15.2265 7.37638 15.2017 7.35959C15.1872 7.34979 15.172 7.34102 15.1562 7.33339C15.1132 7.31265 15.0665 7.3006 15.0189 7.29788ZM10.1445 9.56381H18.496C18.5856 9.54877 18.6669 9.50258 18.7255 9.43346C18.7841 9.3643 18.8163 9.27671 18.8163 9.18617C18.8163 9.09562 18.7841 9.008 18.7255 8.93884C18.6669 8.86973 18.5856 8.82353 18.496 8.8085H10.1445C10.0549 8.82353 9.97363 8.86973 9.91504 8.93884C9.85639 9.008 9.82422 9.09562 9.82422 9.18617C9.82422 9.24412 9.83738 9.30087 9.86224 9.35236C9.87624 9.38132 9.89395 9.40859 9.91504 9.43346C9.97363 9.50258 10.0549 9.54877 10.1445 9.56381ZM10.1445 11.0638H15.0189C15.1084 11.0488 15.1897 11.0026 15.2483 10.9335C15.2854 10.8898 15.3118 10.8387 15.3263 10.7842C15.3347 10.7525 15.3391 10.7195 15.3391 10.6861C15.3391 10.5956 15.3069 10.508 15.2483 10.4389C15.1897 10.3697 15.1084 10.3235 15.0189 10.3085H10.1445C10.0549 10.3235 9.97363 10.3697 9.91504 10.4389C9.85639 10.508 9.82422 10.5956 9.82422 10.6861C9.82422 10.7424 9.83666 10.7976 9.8601 10.8478C9.87442 10.8785 9.89284 10.9073 9.91504 10.9335C9.97363 11.0026 10.0549 11.0488 10.1445 11.0638ZM18.496 12.5745H10.1444C10.0549 12.5594 9.97363 12.5132 9.91498 12.4441C9.85639 12.3749 9.82422 12.2873 9.82422 12.1968C9.82422 12.1062 9.85639 12.0186 9.91498 11.9495C9.97363 11.8803 10.0549 11.8342 10.1444 11.8191H18.496C18.5856 11.8342 18.6669 11.8803 18.7255 11.9495C18.7841 12.0186 18.8163 12.1062 18.8163 12.1968C18.8163 12.2873 18.7841 12.3749 18.7255 12.4441C18.6971 12.4776 18.6633 12.5058 18.6259 12.5276C18.5861 12.5507 18.5421 12.5667 18.496 12.5745ZM15.0189 14.0744H10.1444C10.0968 14.0731 10.0499 14.0624 10.0064 14.0429C9.96296 14.0234 9.92376 13.9956 9.89102 13.961C9.85834 13.9265 9.83282 13.8857 9.81589 13.8413C9.79897 13.7969 9.79102 13.7496 9.79239 13.7021C9.79102 13.6546 9.79897 13.6073 9.81589 13.5628C9.83282 13.5184 9.85834 13.4778 9.89102 13.4432C9.92376 13.4086 9.96296 13.3808 10.0064 13.3613C10.0499 13.3419 10.0968 13.3311 10.1444 13.3297H15.0189C15.0661 13.3311 15.1125 13.3419 15.1554 13.3615C15.1983 13.381 15.2368 13.4091 15.2686 13.4438C15.3005 13.4785 15.325 13.5193 15.3407 13.5637C15.3564 13.608 15.363 13.6551 15.3602 13.7021C15.3631 13.7963 15.3291 13.8879 15.2653 13.9574C15.2016 14.027 15.1132 14.0689 15.0189 14.0744ZM16.6188 4.52128L19.4133 7.30852C19.4293 7.32624 19.4401 7.34808 19.4443 7.37157C19.4485 7.39506 19.446 7.41925 19.4371 7.4414C19.4282 7.46356 19.4133 7.48278 19.394 7.4969C19.3747 7.51102 19.3518 7.51947 19.328 7.52128H16.5868L16.4054 7.34043V4.60639C16.4073 4.5826 16.4157 4.55979 16.4299 4.54056C16.444 4.52133 16.4633 4.50644 16.4855 4.49757C16.5077 4.48871 16.532 4.48624 16.5556 4.49043C16.5791 4.49462 16.601 4.50531 16.6188 4.52128ZM18.6454 13.3192L20 14.6915L14.7522 20L14.7416 19.9894L14.1123 19.3617L13.3976 18.6277L11.3817 16.5638L12.7257 15.2021L14.7522 17.2553L18.6454 13.3192Z",
    rejectAllChanges: "M9.54637 16.5847H8.96997V15.8295H12.786C12.8024 15.8265 12.8186 15.8223 12.8343 15.817C12.8535 15.8105 12.8719 15.8023 12.8897 15.7926C12.9315 15.7697 12.969 15.738 12.9997 15.6991C13.0268 15.6649 13.0478 15.6261 13.0621 15.5847H13.571V16.7656H9.79386C9.78396 16.7479 9.77269 16.731 9.76011 16.7151C9.70552 16.6459 9.62976 16.5998 9.54637 16.5847ZM13.4717 12.9573V13.3295H9.72523C9.6809 13.3309 9.63716 13.3416 9.59671 13.361C9.57578 13.3711 9.55595 13.3834 9.53745 13.3977C9.5201 13.411 9.50391 13.4262 9.48917 13.4429C9.45872 13.4775 9.43494 13.5182 9.41917 13.5626C9.41778 13.5664 9.41644 13.5703 9.41523 13.5742H8.96997V12.8189H12.786C12.8694 12.8039 12.9452 12.7577 12.9997 12.6886C13.0078 12.6784 13.0153 12.6677 13.0223 12.6568L13.029 12.6458L13.033 12.6389L13.0397 12.6266C13.0452 12.6157 13.0503 12.6046 13.055 12.5931C13.0576 12.5869 13.0599 12.5806 13.0621 12.5742H13.6872C13.6453 12.5965 13.607 12.6269 13.5746 12.6644C13.5059 12.7439 13.469 12.849 13.4717 12.9573ZM9.82598 14.0742H13.4758C13.4809 14.0932 13.4904 14.1108 13.5037 14.1251C13.5242 14.147 13.552 14.1593 13.581 14.1593H13.6008L13.571 14.1912V14.8295H9.72523C9.64183 14.8445 9.56614 14.8907 9.51149 14.9598C9.4845 14.994 9.46351 15.0328 9.4492 15.0741H8.96997V14.3295H9.54637C9.62976 14.3145 9.70552 14.2683 9.76011 14.1992C9.78947 14.162 9.81166 14.1195 9.82598 14.0742ZM18.9075 8.2552V12.5317H17.7846V12.323C17.7978 12.2827 17.8047 12.2399 17.8047 12.1965C17.8047 12.106 17.7747 12.0184 17.7201 11.9493C17.6655 11.8801 17.5897 11.834 17.5063 11.8189H9.72523C9.64183 11.834 9.56614 11.8801 9.51149 11.9493C9.48444 11.9835 9.46351 12.0222 9.4492 12.0636H8.96997V11.3083H9.54637C9.63425 11.3028 9.71662 11.2608 9.776 11.1913C9.80687 11.1551 9.83029 11.113 9.84527 11.0676L9.84654 11.0637H14.2667C14.3501 11.0486 14.4258 11.0024 14.4805 10.9333C14.5231 10.8794 14.5507 10.8142 14.5607 10.7452C14.5636 10.7258 14.565 10.706 14.565 10.686C14.565 10.6658 14.5635 10.6458 14.5606 10.626C14.5572 10.6026 14.5516 10.5796 14.5442 10.5573C14.5299 10.5144 14.5084 10.4741 14.4805 10.4387C14.4258 10.3696 14.3501 10.3234 14.2667 10.3083H9.72529C9.6832 10.3159 9.64299 10.3314 9.60653 10.3538C9.57081 10.3759 9.5386 10.4045 9.51155 10.4387C9.49639 10.4579 9.4831 10.4785 9.47182 10.5002C9.46133 10.5205 9.45259 10.5417 9.44568 10.5636H8.96997V9.80838H9.16873C9.25656 9.80286 9.33899 9.76085 9.39837 9.69131C9.45775 9.62177 9.48947 9.53022 9.48674 9.43601C9.48711 9.42951 9.48735 9.42302 9.48741 9.41653C9.48741 9.41049 9.48729 9.40445 9.48705 9.39848C9.49457 9.41055 9.50269 9.42218 9.51155 9.43334C9.56614 9.50249 9.64189 9.54866 9.72529 9.56372H17.5063C17.5897 9.54866 17.6655 9.50249 17.7201 9.43334C17.7747 9.36419 17.8047 9.2766 17.8047 9.18603C17.8047 9.09552 17.7747 9.00786 17.7201 8.93878C17.6655 8.86963 17.5897 8.82346 17.5063 8.8084H9.72529C9.64189 8.82346 9.56614 8.86963 9.51155 8.93878C9.4569 9.00786 9.42694 9.09552 9.42694 9.18603L9.427 9.19707L9.42754 9.20875C9.41972 9.19661 9.41123 9.18499 9.40201 9.17389C9.38478 9.15311 9.36537 9.1346 9.34427 9.11863C9.33735 9.11344 9.33026 9.1085 9.32298 9.10383C9.31855 9.10097 9.31406 9.09824 9.30951 9.09565L9.30424 9.09266L9.29659 9.08857C9.28792 9.08402 9.27906 9.07993 9.27009 9.07623C9.2616 9.07279 9.25298 9.06974 9.24431 9.06701C9.21974 9.05935 9.19439 9.05461 9.16873 9.05305H8.96997V4.10638C8.97221 4.07897 8.9834 4.05328 9.00157 4.03383C9.01975 4.01437 9.04374 4.0024 9.06935 4H14.9325V7.1914C14.9401 7.43679 15.0216 7.67296 15.1649 7.86468C15.3082 8.0564 15.5055 8.19338 15.7275 8.2552C15.7927 8.27277 15.861 8.27277 15.9262 8.2552H18.9075ZM13.571 17.2975V19.4251L13.5722 19.4615C13.5835 19.6376 13.6323 19.8068 13.7133 19.957H4.10061C4.08718 19.9587 4.07355 19.9571 4.06077 19.9524C4.04799 19.9477 4.03637 19.9399 4.02681 19.9296C4.01724 19.9194 4.00997 19.907 4.00554 19.8933C4.00111 19.8796 3.99964 19.865 4.00124 19.8506V7.29778C4.00124 7.26957 4.01171 7.24251 4.03034 7.22256C4.04898 7.20261 4.07426 7.1914 4.10061 7.1914H8.38368V9.05305H4.99497C4.90708 9.05857 4.82471 9.10052 4.76533 9.17006C4.70589 9.2396 4.67423 9.33121 4.67696 9.42536C4.67411 9.52067 4.70547 9.61346 4.76461 9.68475C4.8238 9.75598 4.90623 9.80026 4.99497 9.80838H8.38368V10.5636H4.99497C4.96682 10.5645 4.93898 10.5692 4.91199 10.5774C4.89647 10.5821 4.88124 10.588 4.86644 10.5952C4.8494 10.6034 4.83308 10.613 4.81762 10.6241C4.79627 10.6393 4.77655 10.657 4.7589 10.6771C4.72846 10.7116 4.70468 10.7523 4.68891 10.7967C4.67314 10.8411 4.66574 10.8885 4.66701 10.9359C4.66641 10.9597 4.66792 10.9834 4.67156 11.0067C4.6752 11.03 4.68102 11.053 4.68891 11.0752C4.70468 11.1196 4.72846 11.1603 4.7589 11.1949C4.7731 11.211 4.78862 11.2256 4.80524 11.2386C4.81452 11.2459 4.82417 11.2527 4.83417 11.259C4.84461 11.2655 4.85534 11.2714 4.86644 11.2767C4.9069 11.2962 4.95063 11.3069 4.99497 11.3083H8.38368V12.0636H4.99503C4.91163 12.0787 4.83587 12.1249 4.78128 12.194C4.7526 12.2303 4.7307 12.2717 4.71639 12.3159C4.70347 12.3559 4.69667 12.3983 4.69667 12.4413C4.69667 12.5318 4.72664 12.6194 4.78128 12.6886C4.809 12.7237 4.84218 12.7529 4.87906 12.7751C4.89416 12.7842 4.90993 12.7921 4.92619 12.7988C4.94833 12.8079 4.97137 12.8147 4.99503 12.8189H8.38368V13.5742H4.99503C4.95275 13.5819 4.91242 13.5975 4.87584 13.62C4.8403 13.642 4.80822 13.6705 4.78128 13.7046C4.72664 13.7737 4.69667 13.8613 4.69667 13.9519C4.69667 14.0424 4.72664 14.13 4.78128 14.1992C4.83587 14.2683 4.91163 14.3145 4.99503 14.3295H8.38368V15.0741H4.99497C4.94644 15.0829 4.90047 15.1022 4.85977 15.1304C4.83878 15.145 4.81919 15.162 4.80136 15.1811C4.79439 15.1885 4.78765 15.1964 4.78122 15.2045C4.77188 15.2163 4.76327 15.2287 4.75539 15.2416C4.74441 15.2594 4.73495 15.2781 4.727 15.2975C4.71924 15.3163 4.71293 15.3358 4.70808 15.3558C4.70407 15.3723 4.7011 15.389 4.69922 15.4061C4.69752 15.4212 4.69667 15.4364 4.69667 15.4518C4.69667 15.5423 4.72664 15.6299 4.78122 15.6991C4.83587 15.7682 4.91157 15.8144 4.99497 15.8295H8.38368V16.5847H4.99497C4.91157 16.5998 4.83587 16.6459 4.78122 16.7151C4.72664 16.7842 4.69667 16.8718 4.69667 16.9624C4.69667 17.0529 4.72664 17.1405 4.78122 17.2097C4.83587 17.2788 4.91157 17.325 4.99497 17.34H9.54637C9.58655 17.3328 9.62496 17.3183 9.66008 17.2975H13.571ZM15.7573 4.52124L18.3609 7.30839C18.3758 7.32612 18.3858 7.34796 18.3897 7.37145C18.3937 7.39493 18.3914 7.41913 18.3831 7.44128C18.3748 7.46343 18.3609 7.48266 18.3429 7.49678C18.325 7.51089 18.3036 7.51934 18.2814 7.52115H15.7275L15.5585 7.34031V4.60634C15.5602 4.58255 15.5681 4.55975 15.5813 4.54051C15.5945 4.52128 15.6125 4.50639 15.6332 4.49753C15.6539 4.48867 15.6765 4.48619 15.6984 4.49038C15.7203 4.49457 15.7407 4.50526 15.7573 4.52124ZM14.1248 5.91437C14.1732 5.97391 14.2021 6.04884 14.2071 6.1276C14.2157 6.17377 14.2155 6.22129 14.2065 6.26739C14.2045 6.27778 14.2021 6.28804 14.1992 6.29817L14.1944 6.31388C14.1847 6.34291 14.1715 6.3705 14.1551 6.39595C14.13 6.43465 14.098 6.46757 14.0608 6.49276C14.0354 6.5099 14.008 6.52328 13.9794 6.53244C13.9661 6.53672 13.9525 6.5401 13.9387 6.5425H9.71529C9.62309 6.5425 9.5346 6.50328 9.4694 6.43342C9.40413 6.36362 9.3675 6.26889 9.3675 6.17013C9.3675 6.07144 9.40413 5.97671 9.4694 5.90691C9.5346 5.83704 9.62309 5.79783 9.71529 5.79783H13.9387C13.9718 5.80516 14.0034 5.81769 14.0326 5.83484C14.0672 5.85522 14.0984 5.88204 14.1248 5.91437ZM14.2667 7.29776H9.72529C9.69606 7.30302 9.66773 7.31211 9.64092 7.3247C9.62612 7.33171 9.61175 7.33977 9.59798 7.34879C9.56565 7.36996 9.53642 7.39664 9.51155 7.42813C9.4569 7.49722 9.42694 7.58487 9.42694 7.67538C9.42694 7.70155 9.42942 7.72752 9.43434 7.75285C9.44635 7.81505 9.47273 7.87355 9.51155 7.9227C9.55292 7.9751 9.60647 8.01432 9.66628 8.03678C9.67762 8.04107 9.6892 8.04477 9.70097 8.04775C9.70898 8.04983 9.71711 8.05158 9.72529 8.05308H14.2667C14.3546 8.04756 14.437 8.00555 14.4964 7.93601C14.5558 7.86647 14.5875 7.77492 14.5847 7.68071C14.5874 7.63318 14.5813 7.58559 14.5667 7.54059C14.5522 7.4956 14.5296 7.45417 14.5 7.41859C14.4704 7.38301 14.4346 7.35398 14.3946 7.33327C14.3546 7.31256 14.3111 7.30048 14.2667 7.29776ZM4.99497 18.84H12.786C12.8783 18.84 12.9667 18.8008 13.032 18.731C13.0972 18.6611 13.1338 18.5664 13.1338 18.4677C13.1338 18.3689 13.0972 18.2742 13.032 18.2044C12.9667 18.1346 12.8783 18.0954 12.786 18.0954H4.99497C4.90277 18.0954 4.81428 18.1346 4.74908 18.2044C4.68381 18.2742 4.64718 18.3689 4.64718 18.4677C4.64718 18.5664 4.68381 18.6611 4.74908 18.731C4.81428 18.8008 4.90277 18.84 4.99497 18.84ZM17.5858 12.7444H19.5733H19.623C19.7249 12.7499 19.821 12.7971 19.8913 12.8764C19.9616 12.9556 20.0007 13.0607 20.0006 13.17V13.8295C20.0007 13.8458 19.9976 13.862 19.9914 13.8769C19.9853 13.8918 19.9764 13.9052 19.9652 13.9163C19.9539 13.9273 19.9407 13.9357 19.9262 13.9409C19.9118 13.9461 19.8965 13.948 19.8814 13.9465H13.7797C13.7507 13.9465 13.7229 13.9342 13.7024 13.9123C13.6819 13.8903 13.6704 13.8606 13.6704 13.8295V13.17C13.6677 13.0617 13.7046 12.9566 13.7733 12.8771C13.842 12.7976 13.9371 12.75 14.0381 12.7444H16.0256V12.5104C16.0352 12.439 16.0687 12.3737 16.1199 12.3268C16.1711 12.2798 16.2365 12.2544 16.3039 12.2551H17.2976C17.3667 12.2517 17.4345 12.276 17.4878 12.3232C17.541 12.3704 17.576 12.4371 17.5858 12.5104V12.7444ZM14.0679 19.4251V14.1912H19.5037V19.4251C19.4935 19.585 19.4256 19.7344 19.3143 19.8416C19.203 19.9488 19.0571 20.0055 18.9075 19.9996H14.6642C14.5146 20.0055 14.3687 19.9488 14.2574 19.8416C14.1461 19.7344 14.0781 19.585 14.0679 19.4251ZM15.5983 15.1593H15.2505C15.0969 15.1593 14.9723 15.2926 14.9723 15.4572V18.7336C14.9723 18.8981 15.0969 19.0315 15.2505 19.0315H15.5983C15.752 19.0315 15.8766 18.8981 15.8766 18.7336V15.4572C15.8766 15.2926 15.752 15.1593 15.5983 15.1593ZM16.9598 15.1593H16.612C16.4583 15.1593 16.3337 15.2926 16.3337 15.4572V18.7336C16.3337 18.8981 16.4583 19.0315 16.612 19.0315H16.9598C17.1135 19.0315 17.238 18.8981 17.238 18.7336V15.4572C17.238 15.2926 17.1135 15.1593 16.9598 15.1593ZM17.9635 15.1593H18.3113C18.465 15.1593 18.5895 15.2926 18.5895 15.4572V18.7336C18.5895 18.8981 18.465 19.0315 18.3113 19.0315H17.9635C17.8098 19.0315 17.6852 18.8981 17.6852 18.7336V15.4572C17.6852 15.2926 17.8098 15.1593 17.9635 15.1593Z",
    acceptSingleChange: "M17.2 20H15.6628L17.33 18.3091V19.87C17.33 19.8871 17.3266 19.904 17.3201 19.9197C17.3136 19.9355 17.304 19.9499 17.2919 19.9619C17.2799 19.974 17.2655 19.9836 17.2497 19.9901C17.234 19.9966 17.2171 20 17.2 20ZM4.13 20H14.4978L14.1823 19.6791L13.5135 18.9904L13.5123 18.9891L13.0529 18.52H5C4.87537 18.52 4.75586 18.4705 4.66766 18.3823C4.57953 18.2942 4.53003 18.1747 4.53003 18.05C4.53003 17.9253 4.57953 17.8058 4.66766 17.7177C4.75586 17.6295 4.87537 17.58 5 17.58H12.1323L11.6235 17.0604L11.6231 16.48L12.8831 15.19L13.4765 15.1896L15.0807 16.8276L17.33 14.5413V9.3H13.28C13.207 9.30976 13.133 9.30976 13.06 9.3C12.7697 9.22119 12.5113 9.05343 12.3212 8.82027C12.1311 8.58711 12.0187 8.30026 12 8V4H4.13C4.09552 4 4.06246 4.0137 4.03808 4.03808C4.0137 4.06246 4 4.09552 4 4.13V19.87C4 19.9045 4.0137 19.9375 4.03808 19.9619C4.06246 19.9863 4.09552 20 4.13 20ZM13.1 4.65L16.6 8.15C16.6212 8.17232 16.6355 8.20028 16.6412 8.23051C16.6469 8.26075 16.6437 8.29199 16.6321 8.32048C16.6205 8.34898 16.6009 8.37352 16.5757 8.39117C16.5505 8.40882 16.5208 8.41883 16.49 8.42H13.06L12.83 8.19V4.76C12.8312 4.72925 12.8412 4.6995 12.8588 4.67429C12.8765 4.64909 12.901 4.62951 12.9295 4.6179C12.958 4.6063 12.9893 4.60315 13.0195 4.60884C13.0497 4.61453 13.0777 4.62882 13.1 4.65ZM11 6.72C11.0027 6.66089 10.9937 6.60184 10.9735 6.5462C10.9534 6.49057 10.9224 6.43948 10.8825 6.39581C10.8425 6.35217 10.7944 6.3168 10.7408 6.29178C10.6871 6.26678 10.6292 6.25256 10.57 6.25H5C4.88239 6.25772 4.77252 6.31131 4.69397 6.39917C4.61542 6.48706 4.57452 6.60226 4.58002 6.72C4.57452 6.83774 4.61542 6.95294 4.69397 7.04083C4.77252 7.12869 4.88239 7.18228 5 7.19H10.6C10.7141 7.1774 10.8189 7.12173 10.8933 7.03436C10.9677 6.94702 11.0058 6.83456 11 6.72ZM11.1 8.14001H5C4.87537 8.14001 4.75586 8.18954 4.66766 8.27768C4.57953 8.36581 4.53003 8.48535 4.53003 8.61002C4.53003 8.73468 4.57953 8.85422 4.66766 8.94235C4.71558 8.99023 4.77277 9.02673 4.83496 9.05008C4.86932 9.06296 4.90521 9.07184 4.94189 9.07642C4.96106 9.0788 4.98047 9.08002 5 9.08002H11.1C11.2247 9.08002 11.3442 9.03049 11.4324 8.94235C11.5205 8.85422 11.57 8.73468 11.57 8.61002C11.57 8.48535 11.5205 8.36581 11.4324 8.27768C11.3442 8.18954 11.2247 8.14001 11.1 8.14001ZM5 11H15.45C15.5826 11 15.7098 10.9473 15.8035 10.8535C15.8973 10.7598 15.95 10.6326 15.95 10.5C15.95 10.3674 15.8973 10.2402 15.8035 10.1465C15.7098 10.0527 15.5826 10 15.45 10H5C4.86737 10 4.74023 10.0527 4.64642 10.1465C4.55267 10.2402 4.5 10.3674 4.5 10.5C4.5 10.6326 4.55267 10.7598 4.64642 10.8535C4.74023 10.9473 4.86737 11 5 11ZM5 12.86H11.1C11.2211 12.8523 11.3346 12.798 11.4166 12.7085C11.4986 12.6191 11.5428 12.5013 11.54 12.38C11.5427 12.2597 11.4982 12.1431 11.416 12.0552C11.3337 11.9673 11.2203 11.9152 11.1 11.91H5C4.94086 11.9126 4.88287 11.9268 4.82922 11.9518C4.77563 11.9768 4.72748 12.0122 4.6875 12.0558C4.65833 12.0878 4.63391 12.1237 4.61505 12.1624C4.60809 12.1767 4.60193 12.1913 4.5965 12.2062C4.58264 12.2443 4.5741 12.2841 4.57092 12.3243C4.56946 12.3428 4.56915 12.3614 4.57001 12.38C4.56451 12.5004 4.60651 12.6181 4.68689 12.7079C4.76733 12.7976 4.87976 12.8523 5 12.86ZM15.45 14.74H5C4.87537 14.74 4.75586 14.6905 4.66766 14.6023C4.57953 14.5142 4.53003 14.3947 4.53003 14.27C4.53003 14.1453 4.57953 14.0258 4.66766 13.9377C4.75586 13.8495 4.87537 13.8 5 13.8H15.45C15.5747 13.8 15.6942 13.8495 15.7823 13.9377C15.8705 14.0258 15.92 14.1453 15.92 14.27C15.92 14.3947 15.8705 14.5142 15.7823 14.6023C15.6942 14.6905 15.5747 14.74 15.45 14.74ZM11.1 16.63H5C4.87537 16.63 4.75586 16.5805 4.66766 16.4923C4.57953 16.4042 4.53003 16.2846 4.53003 16.16C4.53003 16.0353 4.57953 15.9158 4.66766 15.8276C4.75586 15.7395 4.87537 15.69 5 15.69H11.1C11.2247 15.69 11.3442 15.7395 11.4324 15.8276C11.5205 15.9158 11.57 16.0353 11.57 16.16C11.57 16.2846 11.5205 16.4042 11.4324 16.4923C11.3442 16.5805 11.2247 16.63 11.1 16.63ZM18.73 13.71L20 15.01L15.08 20L15.07 19.99L14.48 19.39L13.81 18.7L11.92 16.77L13.18 15.48L15.08 17.42L18.73 13.71Z",
    rejectSingleChange: "M17.0495 11.5C17.1461 11.5 17.241 11.5173 17.33 11.5501V9.3H13.28C13.207 9.30976 13.133 9.30976 13.06 9.3C12.7697 9.22119 12.5113 9.05343 12.3212 8.82027C12.1311 8.58711 12.0187 8.30026 12 8V4H4.13C4.09552 4 4.06246 4.0137 4.03808 4.03808C4.0137 4.06246 4 4.09552 4 4.13V19.87C4 19.9045 4.0137 19.9375 4.03808 19.9619C4.06246 19.9863 4.09552 20 4.13 20H13.2305C13.1075 19.8287 13.0338 19.6249 13.0205 19.4112L13.0195 19.3956V18.52H5C4.87537 18.52 4.75586 18.4705 4.66772 18.3823C4.57959 18.2942 4.53003 18.1747 4.53003 18.05C4.53003 18.0119 4.53467 17.9742 4.54358 17.9378C4.56396 17.8552 4.60657 17.7788 4.66772 17.7177C4.75586 17.6295 4.87537 17.58 5 17.58H13.0195V14.74H5C4.87537 14.74 4.75586 14.6905 4.66772 14.6023C4.57959 14.5142 4.53003 14.3947 4.53003 14.27C4.53003 14.1453 4.57959 14.0258 4.66772 13.9377C4.75586 13.8495 4.87537 13.8 5 13.8H12.8393C12.6229 13.6377 12.4998 13.3897 12.4998 13.1032C12.4997 12.8414 12.6008 12.5847 12.7513 12.3911C12.9 12.1998 13.1561 12 13.4994 12L15.2519 12C15.2928 11.8972 15.3589 11.7915 15.4649 11.6992C15.6135 11.5698 15.8041 11.499 16.0011 11.5H17.0495ZM13.1 4.65L16.6 8.15C16.6211 8.17232 16.6354 8.20028 16.6411 8.23051C16.6468 8.26075 16.6437 8.29199 16.6321 8.32048C16.6204 8.34898 16.6009 8.37352 16.5757 8.39117C16.5505 8.40882 16.5207 8.41883 16.49 8.42H13.06L12.83 8.19V4.76C12.8311 4.72925 12.8411 4.6995 12.8588 4.67429C12.8764 4.64909 12.901 4.62951 12.9295 4.6179C12.958 4.6063 12.9892 4.60315 13.0194 4.60884C13.0497 4.61453 13.0776 4.62882 13.1 4.65ZM11 6.72C11.0027 6.66089 10.9937 6.60184 10.9735 6.5462C10.9716 6.5408 10.9695 6.53543 10.9673 6.53012C10.9626 6.51852 10.9575 6.50717 10.9518 6.49603C10.9406 6.47391 10.9275 6.45273 10.9127 6.43274C10.9033 6.41992 10.8932 6.40759 10.8824 6.39581C10.8425 6.35217 10.7943 6.3168 10.7407 6.29178C10.6871 6.26678 10.629 6.25256 10.5699 6.25H5C4.88232 6.25772 4.77246 6.31131 4.69397 6.39917C4.61536 6.48706 4.57446 6.60226 4.57996 6.72C4.57715 6.7811 4.58679 6.84152 4.60767 6.8978C4.61523 6.91803 4.62415 6.93771 4.63452 6.9567C4.65088 6.98669 4.67078 7.01495 4.69397 7.04083C4.77246 7.12869 4.88232 7.18228 5 7.19H10.6C10.714 7.1774 10.8188 7.12173 10.8932 7.03436C10.922 7.00049 10.9454 6.96283 10.9629 6.92273C10.9725 6.9006 10.9805 6.87775 10.9865 6.8544C10.9933 6.82791 10.9977 6.80075 10.9995 6.77325C11.0001 6.76453 11.0004 6.75574 11.0005 6.74695C11.0006 6.73798 11.0005 6.729 11 6.72ZM11.1 8.14001H5C4.97534 8.14001 4.95081 8.14194 4.92676 8.14575C4.89587 8.15063 4.8656 8.15857 4.83643 8.1694C4.77368 8.19272 4.71606 8.2294 4.66772 8.27768C4.57959 8.36581 4.53003 8.48535 4.53003 8.61002C4.53003 8.73468 4.57959 8.85422 4.66772 8.94235C4.75586 9.03049 4.87537 9.08002 5 9.08002H11.1C11.2247 9.08002 11.3442 9.03049 11.4324 8.94235C11.4617 8.91306 11.4867 8.88028 11.5071 8.845C11.5349 8.79691 11.554 8.74414 11.5634 8.68915C11.5677 8.66318 11.5701 8.63672 11.5701 8.61002C11.5701 8.48535 11.5205 8.36581 11.4324 8.27768C11.3929 8.23831 11.3474 8.20663 11.2979 8.18365C11.2365 8.15518 11.1689 8.14001 11.1 8.14001ZM5 11H15.45C15.5826 11 15.7098 10.9473 15.8036 10.8535C15.8973 10.7598 15.95 10.6326 15.95 10.5C15.95 10.3674 15.8973 10.2402 15.8036 10.1465C15.7098 10.0527 15.5826 10 15.45 10H5C4.86743 10 4.74023 10.0527 4.64648 10.1465C4.55273 10.2402 4.5 10.3674 4.5 10.5C4.5 10.6326 4.55273 10.7598 4.64648 10.8535C4.74023 10.9473 4.86743 11 5 11ZM5 12.86H11.1C11.2211 12.8523 11.3346 12.798 11.4166 12.7085C11.4987 12.6191 11.5428 12.5013 11.54 12.38C11.5427 12.2597 11.4982 12.1431 11.4159 12.0552C11.3336 11.9673 11.2202 11.9152 11.1 11.91H5C4.94092 11.9126 4.88281 11.9268 4.82922 11.9518C4.77563 11.9768 4.72742 12.0122 4.6875 12.0558C4.64758 12.0995 4.6167 12.1506 4.59644 12.2062C4.58899 12.2266 4.58313 12.2475 4.57874 12.2687C4.57129 12.3052 4.56824 12.3426 4.56995 12.38C4.56445 12.5004 4.60645 12.6181 4.68689 12.7079C4.76733 12.7976 4.87976 12.8523 5 12.86ZM11.1 16.63H5C4.87537 16.63 4.75586 16.5805 4.66772 16.4923C4.57959 16.4042 4.53003 16.2846 4.53003 16.16C4.53003 16.0353 4.57959 15.9158 4.66772 15.8276C4.75586 15.7395 4.87537 15.69 5 15.69H11.1C11.2247 15.69 11.3442 15.7395 11.4324 15.8276C11.5205 15.9158 11.5701 16.0353 11.5701 16.16C11.5701 16.2846 11.5205 16.4042 11.4324 16.4923C11.3442 16.5805 11.2247 16.63 11.1 16.63ZM19.59 12.53H17.36V12.3C17.3574 12.2195 17.3236 12.1432 17.2657 12.0872C17.2078 12.0313 17.1305 12 17.05 12H16C15.9242 11.9994 15.8509 12.0265 15.7938 12.0762C15.7367 12.126 15.6997 12.1949 15.69 12.27V12.5H13.44C13.3768 12.4994 13.3142 12.5125 13.2565 12.5382C13.1988 12.564 13.1473 12.6019 13.1055 12.6493C13.0638 12.6968 13.0327 12.7526 13.0145 12.8132C12.9963 12.8737 12.9913 12.9374 13 13V13.67C13 13.6871 13.0033 13.704 13.0099 13.7198C13.0164 13.7355 13.026 13.7499 13.038 13.7619C13.0501 13.774 13.0644 13.7836 13.0802 13.7901C13.096 13.7966 13.1129 13.8 13.13 13.8H19.84C19.8611 13.8054 19.8834 13.8054 19.9045 13.8C19.9257 13.7946 19.9452 13.7839 19.9611 13.7689C19.9771 13.754 19.989 13.7352 19.9958 13.7144C20.0026 13.6937 20.004 13.6715 20 13.65V13C20.0028 12.8866 19.9617 12.7765 19.8853 12.6927C19.809 12.6088 19.7031 12.5577 19.59 12.55V12.53ZM13.52 14V19.38C13.5303 19.5454 13.6054 19.7 13.7289 19.8105C13.8525 19.9209 14.0145 19.9782 14.18 19.97H18.84C19.0055 19.9782 19.1676 19.9209 19.2911 19.8105C19.4146 19.7 19.4897 19.5454 19.5 19.38V14H13.52ZM15.52 18.67C15.52 18.7522 15.4874 18.8311 15.4292 18.8892C15.3711 18.9473 15.2922 18.98 15.21 18.98H14.83C14.7478 18.98 14.669 18.9473 14.6108 18.8892C14.5527 18.8311 14.52 18.7522 14.52 18.67V15.33C14.52 15.2893 14.528 15.249 14.5436 15.2114C14.5592 15.1738 14.582 15.1396 14.6108 15.1108C14.6396 15.082 14.6738 15.0592 14.7114 15.0436C14.749 15.028 14.7893 15.02 14.83 15.02H15.21C15.2507 15.02 15.291 15.028 15.3287 15.0436C15.3663 15.0592 15.4004 15.082 15.4292 15.1108C15.458 15.1396 15.4808 15.1738 15.4964 15.2114C15.512 15.249 15.52 15.2893 15.52 15.33V18.67ZM17.01 18.67C17.01 18.7522 16.9774 18.8311 16.9192 18.8892C16.8611 18.9473 16.7822 18.98 16.7 18.98H16.32C16.2798 18.98 16.2399 18.9719 16.2029 18.9562C16.1658 18.9405 16.1323 18.9176 16.1043 18.8886C16.0763 18.8597 16.0544 18.8254 16.0399 18.7879C16.0254 18.7503 16.0187 18.7102 16.02 18.67V15.33C16.0187 15.2898 16.0254 15.2497 16.0399 15.2121C16.0544 15.1746 16.0763 15.1403 16.1043 15.1114C16.1323 15.0824 16.1658 15.0595 16.2029 15.0438C16.2399 15.0281 16.2798 15.02 16.32 15.02H16.7C16.7407 15.02 16.781 15.028 16.8187 15.0436C16.8563 15.0592 16.8904 15.082 16.9192 15.1108C16.948 15.1396 16.9708 15.1738 16.9864 15.2114C17.002 15.249 17.01 15.2893 17.01 15.33V18.67ZM18.51 18.67C18.51 18.7107 18.502 18.751 18.4864 18.7886C18.4708 18.8262 18.448 18.8604 18.4192 18.8892C18.3904 18.918 18.3563 18.9408 18.3187 18.9564C18.281 18.972 18.2407 18.98 18.2 18.98H17.82C17.7378 18.98 17.659 18.9473 17.6008 18.8892C17.5427 18.8311 17.51 18.7522 17.51 18.67V15.33C17.51 15.2893 17.518 15.249 17.5336 15.2114C17.5492 15.1738 17.572 15.1396 17.6008 15.1108C17.6296 15.082 17.6638 15.0592 17.7014 15.0436C17.739 15.028 17.7793 15.02 17.82 15.02H18.2C18.2407 15.02 18.281 15.028 18.3187 15.0436C18.3563 15.0592 18.3904 15.082 18.4192 15.1108C18.448 15.1396 18.4708 15.1738 18.4864 15.2114C18.502 15.249 18.51 15.2893 18.51 15.33V18.67Z"
  }, xt.FILEICONS = {
    docIcon: {
      extension: ".doc",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 9.617188 46.875 C 13.234375 46.875 16.160156 43.929688 16.160156 40.292969 C 16.160156 36.695312 13.234375 33.75 9.617188 33.75 L 7.402344 33.75 C 6.820312 33.75 6.371094 34.199219 6.371094 34.78125 L 6.371094 45.84375 C 6.371094 46.335938 6.714844 46.757812 7.191406 46.855469 L 7.402344 46.875 Z M 9.617188 44.792969 L 8.453125 44.792969 L 8.453125 35.832031 L 9.617188 35.832031 C 12.089844 35.832031 14.078125 37.835938 14.078125 40.292969 C 14.078125 42.789062 12.089844 44.773438 9.617188 44.792969 Z M 24.816406 46.875 C 26.539062 46.875 28.191406 46.085938 29.296875 44.867188 C 30.460938 43.648438 31.191406 41.980469 31.191406 40.125 C 31.191406 38.269531 30.460938 36.617188 29.296875 35.382812 C 28.191406 34.144531 26.539062 33.375 24.816406 33.375 C 23.015625 33.375 21.367188 34.144531 20.222656 35.382812 C 19.058594 36.617188 18.367188 38.269531 18.367188 40.125 C 18.367188 41.980469 19.058594 43.648438 20.222656 44.867188 C 21.367188 46.085938 23.015625 46.875 24.816406 46.875 Z M 24.816406 44.738281 C 23.617188 44.738281 22.566406 44.230469 21.777344 43.386719 C 20.992188 42.582031 20.503906 41.398438 20.503906 40.125 C 20.503906 38.851562 20.992188 37.667969 21.777344 36.84375 C 22.566406 36 23.617188 35.511719 24.816406 35.511719 C 25.941406 35.511719 26.992188 36 27.777344 36.84375 C 28.546875 37.667969 29.054688 38.851562 29.054688 40.125 C 29.054688 41.398438 28.546875 42.582031 27.777344 43.386719 C 26.992188 44.230469 25.941406 44.738281 24.816406 44.738281 Z M 39.996094 46.875 C 41.648438 46.875 43.148438 46.332031 44.328125 45.414062 C 44.777344 45.054688 44.851562 44.382812 44.515625 43.914062 C 44.140625 43.460938 43.445312 43.386719 43.015625 43.707031 C 42.171875 44.382812 41.160156 44.738281 39.996094 44.738281 C 38.703125 44.738281 37.503906 44.210938 36.621094 43.386719 C 35.777344 42.5625 35.253906 41.398438 35.253906 40.125 C 35.253906 38.851562 35.777344 37.726562 36.621094 36.863281 C 37.503906 36.039062 38.703125 35.511719 39.996094 35.511719 C 41.160156 35.511719 42.191406 35.867188 43.015625 36.542969 C 43.445312 36.882812 44.140625 36.804688 44.515625 36.335938 C 44.851562 35.867188 44.777344 35.210938 44.328125 34.835938 C 43.148438 33.917969 41.648438 33.375 39.996094 33.375 C 36.246094 33.394531 33.132812 36.414062 33.117188 40.125 C 33.132812 43.855469 36.246094 46.875 39.996094 46.875 Z M 39.996094 46.875 "/>\n      </g>'
    },
    gifIcon: {
      extension: ".gif",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 17.394531 46.875 C 18.988281 46.875 20.46875 46.332031 21.648438 45.414062 C 21.835938 45.28125 21.949219 45.132812 22.003906 44.960938 L 22.003906 44.945312 C 22.023438 44.90625 22.023438 44.886719 22.042969 44.851562 C 22.0625 44.738281 22.097656 44.664062 22.097656 44.53125 L 22.097656 40.386719 C 22.097656 39.789062 21.613281 39.335938 21.011719 39.335938 L 17.28125 39.335938 C 16.699219 39.335938 16.210938 39.789062 16.210938 40.386719 C 16.210938 40.96875 16.699219 41.457031 17.28125 41.457031 L 19.960938 41.457031 L 19.960938 44.023438 C 19.210938 44.457031 18.332031 44.738281 17.394531 44.738281 C 16.042969 44.738281 14.863281 44.230469 14.019531 43.367188 C 13.136719 42.523438 12.613281 41.382812 12.613281 40.144531 C 12.613281 38.867188 13.136719 37.726562 14.019531 36.882812 C 14.863281 36.019531 16.042969 35.511719 17.394531 35.511719 C 18.519531 35.511719 19.550781 35.90625 20.355469 36.523438 C 20.824219 36.898438 21.519531 36.804688 21.875 36.355469 C 22.230469 35.886719 22.15625 35.195312 21.667969 34.835938 C 20.503906 33.917969 18.988281 33.375 17.394531 33.375 C 13.585938 33.375 10.472656 36.375 10.472656 40.144531 C 10.472656 43.894531 13.585938 46.875 17.394531 46.875 Z M 26.945312 46.875 C 27.507812 46.875 27.996094 46.425781 27.996094 45.84375 L 27.996094 34.78125 C 27.996094 34.199219 27.507812 33.75 26.945312 33.75 C 26.363281 33.75 25.914062 34.199219 25.914062 34.78125 L 25.914062 45.84375 C 25.914062 46.425781 26.363281 46.875 26.945312 46.875 Z M 33.066406 46.875 C 33.648438 46.875 34.117188 46.40625 34.117188 45.84375 L 34.117188 41.34375 L 38.488281 41.34375 C 39.050781 41.34375 39.519531 40.875 39.519531 40.292969 C 39.519531 39.75 39.050781 39.261719 38.488281 39.261719 L 34.117188 39.261719 L 34.117188 35.832031 L 39.199219 35.832031 C 39.742188 35.832031 40.230469 35.363281 40.230469 34.78125 C 40.230469 34.21875 39.742188 33.75 39.199219 33.75 L 33.066406 33.75 C 32.488281 33.75 32.035156 34.21875 32.035156 34.78125 L 32.035156 45.84375 C 32.035156 46.40625 32.488281 46.875 33.066406 46.875 Z M 33.066406 46.875 "/>\n      </g>'
    },
    jpegIcon: {
      extension: ".jpeg",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 9 43.75 C 11.140625 43.75 12.890625 42.015625 12.890625 39.875 L 12.890625 33.671875 C 12.890625 33.1875 12.5 32.8125 12.03125 32.8125 C 11.546875 32.8125 11.15625 33.1875 11.15625 33.671875 L 11.15625 39.875 C 11.15625 41.046875 10.1875 42.015625 9 42.015625 C 8.046875 42.015625 7.234375 41.390625 6.953125 40.53125 C 6.8125 40.078125 6.328125 39.828125 5.859375 39.984375 C 5.421875 40.109375 5.15625 40.59375 5.3125 41.0625 C 5.8125 42.625 7.28125 43.75 9 43.75 Z M 15.640625 43.75 C 16.125 43.75 16.515625 43.359375 16.515625 42.890625 L 16.515625 39.5 L 18.4375 39.5 C 20.296875 39.5 21.796875 38 21.796875 36.171875 C 21.796875 34.3125 20.296875 32.8125 18.4375 32.8125 L 15.640625 32.8125 C 15.171875 32.8125 14.78125 33.1875 14.78125 33.671875 L 14.78125 42.890625 C 14.78125 43.359375 15.171875 43.75 15.640625 43.75 Z M 18.4375 37.765625 L 16.515625 37.765625 L 16.515625 34.546875 L 18.4375 34.546875 C 19.34375 34.546875 20.046875 35.265625 20.0625 36.171875 C 20.046875 37.046875 19.34375 37.765625 18.4375 37.765625 Z M 29.234375 43.75 C 29.6875 43.75 30.09375 43.359375 30.09375 42.890625 C 30.09375 42.40625 29.6875 42.015625 29.234375 42.015625 L 25 42.015625 L 25 39.140625 L 28.640625 39.140625 C 29.109375 39.140625 29.5 38.75 29.5 38.265625 C 29.5 37.8125 29.109375 37.40625 28.640625 37.40625 L 25 37.40625 L 25 34.546875 L 29.234375 34.546875 C 29.6875 34.546875 30.09375 34.15625 30.09375 33.671875 C 30.09375 33.1875 29.6875 32.8125 29.234375 32.8125 L 24.125 32.8125 C 23.640625 32.8125 23.265625 33.1875 23.265625 33.671875 L 23.265625 42.890625 C 23.265625 43.359375 23.640625 43.75 24.125 43.75 C 24.125 43.75 24.140625 43.734375 24.140625 43.734375 C 24.140625 43.734375 24.140625 43.75 24.171875 43.75 Z M 37.1875 43.75 C 38.515625 43.75 39.75 43.296875 40.734375 42.53125 C 40.890625 42.421875 40.984375 42.296875 41.03125 42.15625 L 41.03125 42.140625 C 41.046875 42.109375 41.046875 42.09375 41.0625 42.0625 C 41.078125 41.96875 41.109375 41.90625 41.109375 41.796875 L 41.109375 38.34375 C 41.109375 37.914062 40.8125 37.578125 40.410156 37.492188 L 40.203125 37.46875 L 37.09375 37.46875 C 36.609375 37.46875 36.203125 37.84375 36.203125 38.34375 C 36.203125 38.828125 36.609375 39.234375 37.09375 39.234375 L 39.328125 39.234375 L 39.328125 41.375 C 38.703125 41.734375 37.96875 41.96875 37.1875 41.96875 C 36.0625 41.96875 35.078125 41.546875 34.375 40.828125 C 33.640625 40.125 33.203125 39.171875 33.203125 38.140625 C 33.203125 37.078125 33.640625 36.125 34.375 35.421875 C 35.078125 34.703125 36.0625 34.28125 37.1875 34.28125 C 38.125 34.28125 38.984375 34.609375 39.65625 35.125 C 40.046875 35.4375 40.625 35.359375 40.921875 34.984375 C 41.21875 34.59375 41.15625 34.015625 40.75 33.71875 C 39.78125 32.953125 38.515625 32.5 37.1875 32.5 C 34.015625 32.5 31.421875 35 31.421875 38.140625 C 31.421875 41.265625 34.015625 43.75 37.1875 43.75 Z M 37.1875 43.75 "/>\n      </g>'
    },
    logIcon: {
      extension: ".log",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 13.542969 46.875 C 14.085938 46.875 14.574219 46.40625 14.574219 45.84375 C 14.574219 45.261719 14.085938 44.792969 13.542969 44.792969 L 8.460938 44.792969 L 8.460938 34.78125 C 8.460938 34.21875 7.992188 33.75 7.410156 33.75 C 6.828125 33.75 6.378906 34.21875 6.378906 34.78125 L 6.378906 45.84375 C 6.378906 46.40625 6.828125 46.875 7.410156 46.875 Z M 21.742188 46.875 C 23.46875 46.875 25.117188 46.085938 26.222656 44.867188 C 27.386719 43.648438 28.117188 41.980469 28.117188 40.125 C 28.117188 38.269531 27.386719 36.617188 26.222656 35.382812 C 25.117188 34.144531 23.46875 33.375 21.742188 33.375 C 19.941406 33.375 18.292969 34.144531 17.148438 35.382812 C 15.984375 36.617188 15.292969 38.269531 15.292969 40.125 C 15.292969 41.980469 15.984375 43.648438 17.148438 44.867188 C 18.292969 46.085938 19.941406 46.875 21.742188 46.875 Z M 21.742188 44.738281 C 20.542969 44.738281 19.492188 44.230469 18.703125 43.386719 C 17.917969 42.582031 17.429688 41.398438 17.429688 40.125 C 17.429688 38.851562 17.917969 37.667969 18.703125 36.84375 C 19.492188 36 20.542969 35.511719 21.742188 35.511719 C 22.867188 35.511719 23.917969 36 24.703125 36.84375 C 25.472656 37.667969 25.980469 38.851562 25.980469 40.125 C 25.980469 41.398438 25.472656 42.582031 24.703125 43.386719 C 23.917969 44.230469 22.867188 44.738281 21.742188 44.738281 Z M 37.300781 46.875 C 38.894531 46.875 40.375 46.332031 41.558594 45.414062 C 41.746094 45.28125 41.855469 45.132812 41.914062 44.960938 L 41.914062 44.945312 L 41.949219 44.851562 C 41.96875 44.738281 42.007812 44.664062 42.007812 44.53125 L 42.007812 40.386719 C 42.007812 39.789062 41.519531 39.335938 40.917969 39.335938 L 37.1875 39.335938 C 36.605469 39.335938 36.121094 39.789062 36.121094 40.386719 C 36.121094 40.96875 36.605469 41.457031 37.1875 41.457031 L 39.871094 41.457031 L 39.871094 44.023438 C 39.121094 44.457031 38.238281 44.738281 37.300781 44.738281 C 35.949219 44.738281 34.769531 44.230469 33.925781 43.367188 C 33.042969 42.523438 32.519531 41.382812 32.519531 40.144531 C 32.519531 38.867188 33.042969 37.726562 33.925781 36.882812 C 34.769531 36.019531 35.949219 35.511719 37.300781 35.511719 C 38.425781 35.511719 39.457031 35.90625 40.261719 36.523438 C 40.730469 36.898438 41.425781 36.804688 41.78125 36.355469 C 42.136719 35.886719 42.0625 35.195312 41.574219 34.835938 C 40.414062 33.917969 38.894531 33.375 37.300781 33.375 C 33.496094 33.375 30.382812 36.375 30.382812 40.144531 C 30.382812 43.894531 33.496094 46.875 37.300781 46.875 Z M 37.300781 46.875 "/>\n      </g>'
    },
    movIcon: {
      extension: ".mov",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 15.472656 46.875 C 16.035156 46.875 16.523438 46.40625 16.523438 45.84375 L 16.523438 34.78125 C 16.523438 34.289062 16.152344 33.882812 15.679688 33.777344 L 15.472656 33.75 L 15.453125 33.75 C 15.117188 33.75 14.816406 33.898438 14.609375 34.179688 L 10.878906 39.355469 L 7.148438 34.179688 C 6.960938 33.898438 6.625 33.75 6.324219 33.75 L 6.265625 33.75 C 5.703125 33.75 5.234375 34.21875 5.234375 34.78125 L 5.234375 45.84375 C 5.234375 46.40625 5.703125 46.875 6.265625 46.875 C 6.847656 46.875 7.316406 46.40625 7.316406 45.84375 L 7.316406 37.949219 L 10 41.699219 C 10.203125 41.980469 10.523438 42.132812 10.859375 42.132812 L 10.898438 42.132812 C 11.234375 42.132812 11.535156 41.980469 11.742188 41.699219 L 14.441406 37.949219 L 14.441406 45.84375 C 14.441406 46.40625 14.890625 46.875 15.472656 46.875 Z M 25.460938 46.875 C 27.1875 46.875 28.835938 46.085938 29.941406 44.867188 C 31.105469 43.648438 31.835938 41.980469 31.835938 40.125 C 31.835938 38.269531 31.105469 36.617188 29.941406 35.382812 C 28.835938 34.144531 27.1875 33.375 25.460938 33.375 C 23.660156 33.375 22.011719 34.144531 20.867188 35.382812 C 19.703125 36.617188 19.011719 38.269531 19.011719 40.125 C 19.011719 41.980469 19.703125 43.648438 20.867188 44.867188 C 22.011719 46.085938 23.660156 46.875 25.460938 46.875 Z M 25.460938 44.738281 C 24.261719 44.738281 23.210938 44.230469 22.421875 43.386719 C 21.636719 42.582031 21.148438 41.398438 21.148438 40.125 C 21.148438 38.851562 21.636719 37.667969 22.421875 36.84375 C 23.210938 36 24.261719 35.511719 25.460938 35.511719 C 26.585938 35.511719 27.636719 36 28.421875 36.84375 C 29.191406 37.667969 29.699219 38.851562 29.699219 40.125 C 29.699219 41.398438 29.191406 42.582031 28.421875 43.386719 C 27.636719 44.230469 26.585938 44.738281 25.460938 44.738281 Z M 38.683594 46.855469 L 38.71875 46.855469 C 38.777344 46.835938 38.8125 46.820312 38.871094 46.820312 C 38.886719 46.800781 38.886719 46.800781 38.90625 46.800781 C 38.964844 46.78125 39.019531 46.726562 39.058594 46.707031 L 39.09375 46.6875 L 39.207031 46.59375 C 39.226562 46.574219 39.226562 46.574219 39.246094 46.539062 L 39.339844 46.425781 C 39.355469 46.425781 39.355469 46.425781 39.355469 46.40625 C 39.394531 46.367188 39.414062 46.292969 39.433594 46.257812 L 44.0625 35.304688 C 44.269531 34.800781 44.027344 34.179688 43.5 33.976562 C 42.996094 33.75 42.375 33.992188 42.152344 34.519531 L 38.496094 43.199219 L 34.839844 34.519531 C 34.613281 33.992188 34.011719 33.75 33.507812 33.976562 C 32.964844 34.179688 32.71875 34.800781 32.945312 35.304688 L 37.539062 46.257812 C 37.574219 46.292969 37.613281 46.367188 37.632812 46.40625 C 37.632812 46.425781 37.652344 46.425781 37.652344 46.425781 C 37.667969 46.460938 37.707031 46.5 37.746094 46.539062 C 37.746094 46.574219 37.761719 46.574219 37.761719 46.59375 C 37.820312 46.632812 37.855469 46.648438 37.894531 46.6875 L 37.914062 46.6875 C 37.96875 46.726562 38.042969 46.78125 38.082031 46.800781 L 38.101562 46.800781 C 38.101562 46.800781 38.121094 46.800781 38.121094 46.820312 C 38.15625 46.820312 38.230469 46.835938 38.269531 46.855469 L 38.308594 46.855469 L 38.402344 46.871094 L 38.496094 46.875 C 38.550781 46.875 38.605469 46.875 38.683594 46.855469 Z M 38.683594 46.855469 "/>\n      </g>'
    },
    ogvIcon: {
      extension: ".ogv",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 11.511719 46.875 C 13.238281 46.875 14.886719 46.085938 15.996094 44.867188 C 17.15625 43.648438 17.886719 41.980469 17.886719 40.125 C 17.886719 38.269531 17.15625 36.617188 15.996094 35.382812 C 14.886719 34.144531 13.238281 33.375 11.511719 33.375 C 9.714844 33.375 8.0625 34.144531 6.917969 35.382812 C 5.757812 36.617188 5.0625 38.269531 5.0625 40.125 C 5.0625 41.980469 5.757812 43.648438 6.917969 44.867188 C 8.0625 46.085938 9.714844 46.875 11.511719 46.875 Z M 11.511719 44.738281 C 10.3125 44.738281 9.261719 44.230469 8.476562 43.386719 C 7.6875 42.582031 7.199219 41.398438 7.199219 40.125 C 7.199219 38.851562 7.6875 37.667969 8.476562 36.84375 C 9.261719 36 10.3125 35.511719 11.511719 35.511719 C 12.636719 35.511719 13.6875 36 14.476562 36.84375 C 15.246094 37.667969 15.75 38.851562 15.75 40.125 C 15.75 41.398438 15.246094 42.582031 14.476562 43.386719 C 13.6875 44.230469 12.636719 44.738281 11.511719 44.738281 Z M 27.25 46.875 C 28.84375 46.875 30.324219 46.332031 31.507812 45.414062 C 31.695312 45.28125 31.804688 45.132812 31.863281 44.960938 L 31.863281 44.945312 C 31.882812 44.90625 31.882812 44.886719 31.898438 44.851562 C 31.917969 44.738281 31.957031 44.664062 31.957031 44.53125 L 31.957031 40.386719 C 31.957031 39.789062 31.46875 39.335938 30.867188 39.335938 L 27.136719 39.335938 C 26.554688 39.335938 26.070312 39.789062 26.070312 40.386719 C 26.070312 40.96875 26.554688 41.457031 27.136719 41.457031 L 29.820312 41.457031 L 29.820312 44.023438 C 29.070312 44.457031 28.1875 44.738281 27.25 44.738281 C 25.898438 44.738281 24.71875 44.230469 23.875 43.367188 C 22.992188 42.523438 22.46875 41.382812 22.46875 40.144531 C 22.46875 38.867188 22.992188 37.726562 23.875 36.882812 C 24.71875 36.019531 25.898438 35.511719 27.25 35.511719 C 28.375 35.511719 29.40625 35.90625 30.210938 36.523438 C 30.679688 36.898438 31.375 36.804688 31.730469 36.355469 C 32.085938 35.886719 32.011719 35.195312 31.523438 34.835938 C 30.363281 33.917969 28.84375 33.375 27.25 33.375 C 23.445312 33.375 20.332031 36.375 20.332031 40.144531 C 20.332031 43.894531 23.445312 46.875 27.25 46.875 Z M 40.191406 46.855469 L 40.230469 46.855469 C 40.285156 46.835938 40.324219 46.820312 40.378906 46.820312 C 40.398438 46.800781 40.398438 46.800781 40.417969 46.800781 C 40.472656 46.78125 40.53125 46.726562 40.566406 46.707031 C 40.605469 46.6875 40.605469 46.6875 40.605469 46.6875 L 40.71875 46.59375 C 40.738281 46.574219 40.738281 46.574219 40.753906 46.539062 L 40.847656 46.425781 C 40.867188 46.425781 40.867188 46.425781 40.867188 46.40625 C 40.90625 46.367188 40.925781 46.292969 40.941406 46.257812 L 45.574219 35.304688 C 45.78125 34.800781 45.535156 34.179688 45.011719 33.976562 C 44.503906 33.75 43.886719 33.992188 43.660156 34.519531 L 40.003906 43.199219 L 36.347656 34.519531 C 36.125 33.992188 35.523438 33.75 35.019531 33.976562 C 34.472656 34.179688 34.230469 34.800781 34.457031 35.304688 L 39.050781 46.257812 C 39.085938 46.292969 39.125 46.367188 39.144531 46.40625 C 39.144531 46.425781 39.160156 46.425781 39.160156 46.425781 C 39.179688 46.460938 39.21875 46.5 39.253906 46.539062 C 39.253906 46.574219 39.273438 46.574219 39.273438 46.59375 C 39.332031 46.632812 39.367188 46.648438 39.40625 46.6875 L 39.425781 46.6875 C 39.480469 46.726562 39.554688 46.78125 39.59375 46.800781 L 39.613281 46.800781 C 39.613281 46.800781 39.628906 46.800781 39.628906 46.820312 C 39.667969 46.820312 39.742188 46.835938 39.78125 46.855469 L 39.816406 46.855469 L 39.910156 46.871094 L 40.003906 46.875 C 40.0625 46.875 40.117188 46.875 40.191406 46.855469 Z M 40.191406 46.855469 "/>\n      </g>'
    },
    pngIcon: {
      extension: ".png",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 7.523438 46.875 C 8.105469 46.875 8.574219 46.40625 8.574219 45.84375 L 8.574219 41.773438 L 10.878906 41.773438 C 13.109375 41.773438 14.910156 39.976562 14.910156 37.78125 C 14.910156 35.550781 13.109375 33.75 10.878906 33.75 L 7.523438 33.75 C 6.960938 33.75 6.492188 34.199219 6.492188 34.78125 L 6.492188 45.84375 C 6.492188 46.40625 6.960938 46.875 7.523438 46.875 Z M 10.878906 39.695312 L 8.574219 39.695312 L 8.574219 35.832031 L 10.878906 35.832031 C 11.964844 35.832031 12.808594 36.695312 12.828125 37.78125 C 12.808594 38.832031 11.964844 39.695312 10.878906 39.695312 Z M 26.75 46.875 C 27.3125 46.875 27.78125 46.40625 27.78125 45.84375 L 27.78125 34.949219 C 27.78125 34.40625 27.3125 33.9375 26.75 33.9375 C 26.1875 33.9375 25.738281 34.40625 25.738281 34.949219 L 25.738281 42.675781 L 19.679688 34.292969 C 19.363281 33.84375 18.722656 33.75 18.253906 34.070312 C 17.972656 34.273438 17.824219 34.613281 17.84375 34.929688 L 17.84375 45.84375 C 17.84375 46.40625 18.292969 46.875 18.875 46.875 C 19.417969 46.875 19.886719 46.40625 19.886719 45.84375 L 19.886719 38.0625 L 25.886719 46.386719 C 25.90625 46.425781 25.941406 46.460938 25.980469 46.5 C 26.167969 46.726562 26.449219 46.875 26.75 46.875 Z M 38.082031 46.875 C 39.675781 46.875 41.15625 46.332031 42.339844 45.414062 C 42.527344 45.28125 42.636719 45.132812 42.695312 44.960938 L 42.695312 44.945312 C 42.714844 44.90625 42.714844 44.886719 42.730469 44.851562 C 42.75 44.738281 42.789062 44.664062 42.789062 44.53125 L 42.789062 40.386719 C 42.789062 39.789062 42.300781 39.335938 41.699219 39.335938 L 37.96875 39.335938 C 37.386719 39.335938 36.902344 39.789062 36.902344 40.386719 C 36.902344 40.96875 37.386719 41.457031 37.96875 41.457031 L 40.652344 41.457031 L 40.652344 44.023438 C 39.902344 44.457031 39.019531 44.738281 38.082031 44.738281 C 36.730469 44.738281 35.550781 44.230469 34.707031 43.367188 C 33.824219 42.523438 33.300781 41.382812 33.300781 40.144531 C 33.300781 38.867188 33.824219 37.726562 34.707031 36.882812 C 35.550781 36.019531 36.730469 35.511719 38.082031 35.511719 C 39.207031 35.511719 40.238281 35.90625 41.042969 36.523438 C 41.511719 36.898438 42.207031 36.804688 42.5625 36.355469 C 42.917969 35.886719 42.84375 35.195312 42.355469 34.835938 C 41.195312 33.917969 39.675781 33.375 38.082031 33.375 C 34.277344 33.375 31.164062 36.375 31.164062 40.144531 C 31.164062 43.894531 34.277344 46.875 38.082031 46.875 Z M 38.082031 46.875 "/>\n      </g>'
    },
    txtIcon: {
      extension: ".txt",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 12.847656 46.875 C 13.429688 46.875 13.878906 46.425781 13.878906 45.84375 L 13.878906 35.832031 L 16.859375 35.832031 C 17.421875 35.832031 17.890625 35.34375 17.890625 34.78125 C 17.890625 34.199219 17.421875 33.75 16.859375 33.75 L 8.855469 33.75 C 8.273438 33.75 7.824219 34.199219 7.824219 34.78125 C 7.824219 35.34375 8.273438 35.832031 8.855469 35.832031 L 11.816406 35.832031 L 11.816406 45.84375 C 11.816406 46.425781 12.285156 46.875 12.847656 46.875 Z M 29.019531 46.875 C 29.222656 46.875 29.429688 46.800781 29.617188 46.667969 C 30.085938 46.351562 30.160156 45.695312 29.84375 45.242188 L 26.28125 40.367188 L 29.84375 35.53125 C 30.160156 35.0625 30.085938 34.425781 29.617188 34.105469 C 29.148438 33.75 28.53125 33.84375 28.175781 34.332031 L 25.023438 38.644531 L 21.855469 34.332031 C 21.535156 33.84375 20.878906 33.75 20.429688 34.105469 C 19.960938 34.425781 19.867188 35.0625 20.1875 35.53125 L 23.75 40.367188 L 20.1875 45.242188 C 19.867188 45.695312 19.960938 46.351562 20.429688 46.667969 C 20.597656 46.800781 20.804688 46.875 21.03125 46.875 C 21.347656 46.875 21.648438 46.707031 21.855469 46.445312 L 25.023438 42.113281 L 28.175781 46.445312 C 28.378906 46.707031 28.679688 46.875 29.019531 46.875 Z M 37.464844 46.875 C 38.042969 46.875 38.496094 46.425781 38.496094 45.84375 L 38.496094 35.832031 L 41.476562 35.832031 C 42.039062 35.832031 42.507812 35.34375 42.507812 34.78125 C 42.507812 34.199219 42.039062 33.75 41.476562 33.75 L 33.46875 33.75 C 32.886719 33.75 32.4375 34.199219 32.4375 34.78125 C 32.4375 35.34375 32.886719 35.832031 33.46875 35.832031 L 36.433594 35.832031 L 36.433594 45.84375 C 36.433594 46.425781 36.902344 46.875 37.464844 46.875 Z M 37.464844 46.875 "/>\n      </g>'
    },
    webmIcon: {
      extension: ".webm",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 7.195312 43.734375 L 7.242188 43.734375 C 7.273438 43.71875 7.304688 43.703125 7.367188 43.703125 C 7.367188 43.6875 7.382812 43.6875 7.382812 43.6875 L 7.398438 43.6875 C 7.429688 43.671875 7.476562 43.625 7.523438 43.59375 L 7.554688 43.59375 C 7.585938 43.5625 7.617188 43.53125 7.648438 43.515625 C 7.648438 43.5 7.664062 43.5 7.664062 43.46875 L 7.757812 43.375 C 7.757812 43.375 7.757812 43.359375 7.773438 43.359375 C 7.789062 43.328125 7.820312 43.265625 7.835938 43.21875 L 9.882812 38.375 L 11.929688 43.21875 C 11.945312 43.265625 11.960938 43.328125 11.992188 43.359375 C 11.992188 43.359375 11.992188 43.375 12.023438 43.375 L 12.085938 43.46875 C 12.101562 43.5 12.101562 43.5 12.117188 43.515625 C 12.148438 43.53125 12.179688 43.5625 12.226562 43.59375 L 12.242188 43.59375 C 12.273438 43.625 12.320312 43.671875 12.382812 43.6875 C 12.398438 43.6875 12.398438 43.6875 12.414062 43.703125 C 12.445312 43.703125 12.476562 43.71875 12.523438 43.734375 L 12.570312 43.734375 L 12.640625 43.746094 L 12.710938 43.75 C 12.773438 43.75 12.820312 43.75 12.867188 43.734375 L 12.898438 43.734375 C 12.945312 43.71875 12.992188 43.703125 13.023438 43.703125 C 13.023438 43.6875 13.039062 43.6875 13.039062 43.6875 L 13.054688 43.6875 C 13.117188 43.671875 13.148438 43.625 13.195312 43.59375 L 13.210938 43.59375 C 13.242188 43.5625 13.289062 43.53125 13.320312 43.515625 C 13.320312 43.5 13.335938 43.5 13.335938 43.46875 C 13.367188 43.4375 13.398438 43.40625 13.414062 43.375 C 13.414062 43.375 13.429688 43.359375 13.429688 43.359375 C 13.460938 43.328125 13.492188 43.265625 13.507812 43.21875 L 17.335938 34.109375 C 17.523438 33.6875 17.320312 33.171875 16.898438 33 C 16.445312 32.8125 15.945312 33.015625 15.757812 33.453125 L 12.710938 40.6875 L 10.695312 35.890625 C 10.539062 35.546875 10.210938 35.359375 9.882812 35.359375 C 9.539062 35.359375 9.210938 35.546875 9.070312 35.890625 L 7.054688 40.6875 L 3.992188 33.453125 C 3.820312 33.015625 3.304688 32.8125 2.882812 33 C 2.429688 33.171875 2.242188 33.6875 2.414062 34.109375 L 6.257812 43.21875 C 6.289062 43.265625 6.304688 43.328125 6.335938 43.359375 L 6.335938 43.375 C 6.367188 43.40625 6.382812 43.4375 6.414062 43.46875 C 6.429688 43.5 6.429688 43.5 6.445312 43.515625 C 6.492188 43.53125 6.507812 43.5625 6.554688 43.59375 L 6.570312 43.59375 C 6.601562 43.625 6.664062 43.671875 6.710938 43.6875 C 6.726562 43.6875 6.726562 43.6875 6.742188 43.703125 C 6.773438 43.703125 6.804688 43.71875 6.851562 43.734375 L 6.898438 43.734375 L 6.976562 43.746094 L 7.054688 43.75 C 7.101562 43.75 7.148438 43.75 7.195312 43.734375 Z M 25.179688 43.75 C 25.632812 43.75 26.039062 43.359375 26.039062 42.890625 C 26.039062 42.40625 25.632812 42.015625 25.179688 42.015625 L 20.945312 42.015625 L 20.945312 39.140625 L 24.585938 39.140625 C 25.054688 39.140625 25.445312 38.75 25.445312 38.265625 C 25.445312 37.8125 25.054688 37.40625 24.585938 37.40625 L 20.945312 37.40625 L 20.945312 34.546875 L 25.179688 34.546875 C 25.632812 34.546875 26.039062 34.15625 26.039062 33.671875 C 26.039062 33.1875 25.632812 32.8125 25.179688 32.8125 L 20.070312 32.8125 C 19.585938 32.8125 19.210938 33.1875 19.210938 33.671875 L 19.210938 42.890625 C 19.210938 43.359375 19.585938 43.75 20.070312 43.75 C 20.070312 43.75 20.085938 43.734375 20.085938 43.734375 C 20.085938 43.734375 20.085938 43.75 20.117188 43.75 Z M 31.539062 43.75 C 33.382812 43.75 34.882812 42.25 34.882812 40.390625 C 34.882812 39.203125 34.242188 38.15625 33.304688 37.5625 C 33.679688 37.0625 33.898438 36.453125 33.898438 35.78125 C 33.898438 34.140625 32.570312 32.8125 30.929688 32.8125 L 28.710938 32.8125 C 28.242188 32.8125 27.851562 33.1875 27.851562 33.671875 L 27.851562 42.890625 C 27.851562 43.359375 28.242188 43.75 28.710938 43.75 L 28.757812 43.734375 C 28.757812 43.734375 28.757812 43.75 28.773438 43.75 Z M 30.929688 37.046875 L 29.585938 37.046875 L 29.585938 34.546875 L 30.929688 34.546875 C 31.617188 34.546875 32.164062 35.09375 32.164062 35.78125 C 32.164062 36.46875 31.617188 37.046875 30.929688 37.046875 Z M 31.539062 42.015625 L 29.585938 42.015625 L 29.585938 38.78125 L 31.539062 38.78125 C 32.429688 38.796875 33.148438 39.5 33.148438 40.390625 C 33.148438 41.296875 32.429688 42 31.539062 42.015625 Z M 45.664062 43.75 C 46.132812 43.75 46.539062 43.359375 46.539062 42.890625 L 46.539062 33.671875 C 46.539062 33.269531 46.242188 32.9375 45.859375 32.839844 L 45.664062 32.8125 L 45.648438 32.8125 C 45.367188 32.8125 45.117188 32.9375 44.945312 33.171875 L 41.835938 37.484375 L 38.726562 33.171875 C 38.570312 32.9375 38.289062 32.8125 38.039062 32.8125 L 37.992188 32.8125 C 37.523438 32.8125 37.132812 33.203125 37.132812 33.671875 L 37.132812 42.890625 C 37.132812 43.359375 37.523438 43.75 37.992188 43.75 C 38.476562 43.75 38.867188 43.359375 38.867188 42.890625 L 38.867188 36.3125 L 41.101562 39.4375 C 41.273438 39.671875 41.539062 39.796875 41.820312 39.796875 L 41.851562 39.796875 C 42.132812 39.796875 42.382812 39.671875 42.554688 39.4375 L 44.804688 36.3125 L 44.804688 42.890625 C 44.804688 43.359375 45.179688 43.75 45.664062 43.75 Z M 45.664062 43.75 "/>\n      </g>'
    },
    webpIcon: {
      extension: ".webp",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 9.234375 43.734375 L 9.28125 43.734375 C 9.3125 43.71875 9.34375 43.703125 9.40625 43.703125 L 9.414062 43.6875 C 9.421875 43.6875 9.421875 43.6875 9.4375 43.6875 C 9.46875 43.671875 9.515625 43.625 9.5625 43.59375 L 9.59375 43.59375 C 9.625 43.5625 9.65625 43.53125 9.6875 43.515625 C 9.6875 43.5 9.703125 43.5 9.703125 43.46875 L 9.796875 43.375 C 9.796875 43.375 9.796875 43.359375 9.8125 43.359375 C 9.828125 43.328125 9.859375 43.265625 9.875 43.21875 L 11.921875 38.375 L 13.96875 43.21875 C 13.984375 43.265625 14 43.328125 14.03125 43.359375 C 14.03125 43.359375 14.03125 43.375 14.0625 43.375 L 14.125 43.46875 C 14.140625 43.5 14.140625 43.5 14.15625 43.515625 L 14.203125 43.546875 L 14.265625 43.59375 C 14.265625 43.59375 14.265625 43.59375 14.28125 43.59375 C 14.3125 43.625 14.359375 43.671875 14.421875 43.6875 C 14.4375 43.6875 14.4375 43.6875 14.453125 43.703125 C 14.484375 43.703125 14.515625 43.71875 14.5625 43.734375 L 14.609375 43.734375 L 14.679688 43.746094 L 14.75 43.75 C 14.8125 43.75 14.859375 43.75 14.90625 43.734375 L 14.9375 43.734375 C 14.984375 43.71875 15.03125 43.703125 15.0625 43.703125 C 15.0625 43.6875 15.078125 43.6875 15.078125 43.6875 L 15.09375 43.6875 C 15.15625 43.671875 15.1875 43.625 15.234375 43.59375 L 15.25 43.59375 C 15.28125 43.5625 15.328125 43.53125 15.359375 43.515625 C 15.359375 43.5 15.375 43.5 15.375 43.46875 C 15.40625 43.4375 15.4375 43.40625 15.453125 43.375 L 15.46875 43.359375 C 15.5 43.328125 15.53125 43.265625 15.546875 43.21875 L 19.375 34.109375 C 19.5625 33.6875 19.359375 33.171875 18.9375 33 C 18.484375 32.8125 17.984375 33.015625 17.796875 33.453125 L 14.75 40.6875 L 12.734375 35.890625 C 12.578125 35.546875 12.25 35.359375 11.921875 35.359375 C 11.578125 35.359375 11.25 35.546875 11.109375 35.890625 L 9.09375 40.6875 L 6.03125 33.453125 C 5.859375 33.015625 5.34375 32.8125 4.921875 33 C 4.46875 33.171875 4.28125 33.6875 4.453125 34.109375 L 8.296875 43.21875 C 8.328125 43.265625 8.34375 43.328125 8.375 43.359375 L 8.375 43.375 C 8.40625 43.40625 8.421875 43.4375 8.453125 43.46875 C 8.46875 43.5 8.46875 43.5 8.484375 43.515625 L 8.539062 43.546875 L 8.59375 43.59375 C 8.59375 43.59375 8.59375 43.59375 8.609375 43.59375 C 8.640625 43.625 8.703125 43.671875 8.75 43.6875 C 8.765625 43.6875 8.765625 43.6875 8.78125 43.703125 C 8.8125 43.703125 8.84375 43.71875 8.890625 43.734375 L 8.9375 43.734375 L 9.015625 43.746094 L 9.09375 43.75 C 9.140625 43.75 9.1875 43.75 9.234375 43.734375 Z M 27.21875 43.75 C 27.671875 43.75 28.078125 43.359375 28.078125 42.890625 C 28.078125 42.40625 27.671875 42.015625 27.21875 42.015625 L 22.984375 42.015625 L 22.984375 39.140625 L 26.625 39.140625 C 27.09375 39.140625 27.484375 38.75 27.484375 38.265625 C 27.484375 37.8125 27.09375 37.40625 26.625 37.40625 L 22.984375 37.40625 L 22.984375 34.546875 L 27.21875 34.546875 C 27.671875 34.546875 28.078125 34.15625 28.078125 33.671875 C 28.078125 33.1875 27.671875 32.8125 27.21875 32.8125 L 22.109375 32.8125 C 21.625 32.8125 21.25 33.1875 21.25 33.671875 L 21.25 42.890625 C 21.25 43.359375 21.625 43.75 22.109375 43.75 L 22.125 43.734375 C 22.125 43.734375 22.125 43.75 22.15625 43.75 Z M 33.578125 43.75 C 35.421875 43.75 36.921875 42.25 36.921875 40.390625 C 36.921875 39.203125 36.28125 38.15625 35.34375 37.5625 C 35.71875 37.0625 35.9375 36.453125 35.9375 35.78125 C 35.9375 34.140625 34.609375 32.8125 32.96875 32.8125 L 30.75 32.8125 C 30.28125 32.8125 29.890625 33.1875 29.890625 33.671875 L 29.890625 42.890625 C 29.890625 43.359375 30.28125 43.75 30.75 43.75 C 30.765625 43.75 30.765625 43.734375 30.796875 43.734375 C 30.796875 43.734375 30.796875 43.75 30.8125 43.75 Z M 32.96875 37.046875 L 31.625 37.046875 L 31.625 34.546875 L 32.96875 34.546875 C 33.65625 34.546875 34.203125 35.09375 34.203125 35.78125 C 34.203125 36.46875 33.65625 37.046875 32.96875 37.046875 Z M 33.578125 42.015625 L 31.625 42.015625 L 31.625 38.78125 L 33.578125 38.78125 C 34.46875 38.796875 35.1875 39.5 35.1875 40.390625 C 35.1875 41.296875 34.46875 42 33.578125 42.015625 Z M 40.03125 43.75 C 40.515625 43.75 40.90625 43.359375 40.90625 42.890625 L 40.90625 39.5 L 42.828125 39.5 C 44.6875 39.5 46.1875 38 46.1875 36.171875 C 46.1875 34.3125 44.6875 32.8125 42.828125 32.8125 L 40.03125 32.8125 C 39.5625 32.8125 39.171875 33.1875 39.171875 33.671875 L 39.171875 42.890625 C 39.171875 43.359375 39.5625 43.75 40.03125 43.75 Z M 42.828125 37.765625 L 40.90625 37.765625 L 40.90625 34.546875 L 42.828125 34.546875 C 43.734375 34.546875 44.4375 35.265625 44.453125 36.171875 C 44.4375 37.046875 43.734375 37.765625 42.828125 37.765625 Z M 42.828125 37.765625 "/>\n      </g>'
    },
    wmvIcon: {
      extension: ".wmv",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 8.484375 43.734375 L 8.53125 43.734375 C 8.5625 43.71875 8.59375 43.703125 8.65625 43.703125 L 8.664062 43.6875 C 8.671875 43.6875 8.671875 43.6875 8.6875 43.6875 C 8.71875 43.671875 8.765625 43.625 8.8125 43.59375 L 8.84375 43.59375 C 8.875 43.5625 8.90625 43.53125 8.9375 43.515625 C 8.9375 43.5 8.953125 43.5 8.953125 43.46875 L 9.046875 43.375 C 9.046875 43.375 9.046875 43.359375 9.0625 43.359375 C 9.078125 43.328125 9.109375 43.265625 9.125 43.21875 L 11.171875 38.375 L 13.21875 43.21875 C 13.234375 43.265625 13.25 43.328125 13.28125 43.359375 C 13.28125 43.359375 13.28125 43.375 13.3125 43.375 L 13.375 43.46875 C 13.390625 43.5 13.390625 43.5 13.40625 43.515625 L 13.453125 43.546875 L 13.515625 43.59375 C 13.515625 43.59375 13.515625 43.59375 13.53125 43.59375 C 13.5625 43.625 13.609375 43.671875 13.671875 43.6875 C 13.6875 43.6875 13.6875 43.6875 13.703125 43.703125 C 13.734375 43.703125 13.765625 43.71875 13.8125 43.734375 L 13.859375 43.734375 L 13.929688 43.746094 L 14 43.75 C 14.0625 43.75 14.109375 43.75 14.15625 43.734375 L 14.1875 43.734375 C 14.234375 43.71875 14.28125 43.703125 14.3125 43.703125 C 14.3125 43.6875 14.328125 43.6875 14.328125 43.6875 L 14.34375 43.6875 C 14.40625 43.671875 14.4375 43.625 14.484375 43.59375 L 14.5 43.59375 C 14.53125 43.5625 14.578125 43.53125 14.609375 43.515625 C 14.609375 43.5 14.625 43.5 14.625 43.46875 C 14.65625 43.4375 14.6875 43.40625 14.703125 43.375 L 14.71875 43.359375 C 14.75 43.328125 14.78125 43.265625 14.796875 43.21875 L 18.625 34.109375 C 18.8125 33.6875 18.609375 33.171875 18.1875 33 C 17.734375 32.8125 17.234375 33.015625 17.046875 33.453125 L 14 40.6875 L 11.984375 35.890625 C 11.828125 35.546875 11.5 35.359375 11.171875 35.359375 C 10.828125 35.359375 10.5 35.546875 10.359375 35.890625 L 8.34375 40.6875 L 5.28125 33.453125 C 5.109375 33.015625 4.59375 32.8125 4.171875 33 C 3.71875 33.171875 3.53125 33.6875 3.703125 34.109375 L 7.546875 43.21875 C 7.578125 43.265625 7.59375 43.328125 7.625 43.359375 L 7.625 43.375 C 7.65625 43.40625 7.671875 43.4375 7.703125 43.46875 C 7.71875 43.5 7.71875 43.5 7.734375 43.515625 L 7.789062 43.546875 L 7.84375 43.59375 C 7.84375 43.59375 7.84375 43.59375 7.859375 43.59375 C 7.890625 43.625 7.953125 43.671875 8 43.6875 C 8.015625 43.6875 8.015625 43.6875 8.03125 43.703125 C 8.0625 43.703125 8.09375 43.71875 8.140625 43.734375 L 8.1875 43.734375 L 8.265625 43.746094 L 8.34375 43.75 C 8.390625 43.75 8.4375 43.75 8.484375 43.734375 Z M 29.03125 43.75 C 29.5 43.75 29.90625 43.359375 29.90625 42.890625 L 29.90625 33.671875 C 29.90625 33.269531 29.609375 32.9375 29.226562 32.839844 L 29.03125 32.8125 L 29.015625 32.8125 C 28.734375 32.8125 28.484375 32.9375 28.3125 33.171875 L 25.203125 37.484375 L 22.09375 33.171875 C 21.9375 32.9375 21.65625 32.8125 21.40625 32.8125 L 21.359375 32.8125 C 20.890625 32.8125 20.5 33.203125 20.5 33.671875 L 20.5 42.890625 C 20.5 43.359375 20.890625 43.75 21.359375 43.75 C 21.84375 43.75 22.234375 43.359375 22.234375 42.890625 L 22.234375 36.3125 L 24.46875 39.4375 C 24.640625 39.671875 24.90625 39.796875 25.1875 39.796875 L 25.21875 39.796875 C 25.5 39.796875 25.75 39.671875 25.921875 39.4375 L 28.171875 36.3125 L 28.171875 42.890625 C 28.171875 43.359375 28.546875 43.75 29.03125 43.75 Z M 37.015625 43.734375 L 37.0625 43.734375 C 37.09375 43.71875 37.125 43.703125 37.1875 43.703125 L 37.195312 43.6875 C 37.203125 43.6875 37.203125 43.6875 37.21875 43.6875 C 37.25 43.671875 37.296875 43.625 37.34375 43.59375 L 37.375 43.59375 C 37.40625 43.5625 37.4375 43.53125 37.46875 43.515625 C 37.46875 43.5 37.484375 43.5 37.484375 43.46875 L 37.578125 43.375 C 37.578125 43.375 37.578125 43.359375 37.59375 43.359375 C 37.609375 43.328125 37.640625 43.265625 37.65625 43.21875 L 39.703125 38.375 L 41.75 43.21875 C 41.765625 43.265625 41.78125 43.328125 41.8125 43.359375 C 41.8125 43.359375 41.8125 43.375 41.84375 43.375 L 41.90625 43.46875 C 41.921875 43.5 41.921875 43.5 41.9375 43.515625 L 41.984375 43.546875 L 42.046875 43.59375 C 42.046875 43.59375 42.046875 43.59375 42.0625 43.59375 C 42.09375 43.625 42.140625 43.671875 42.203125 43.6875 C 42.21875 43.6875 42.21875 43.6875 42.234375 43.703125 C 42.265625 43.703125 42.296875 43.71875 42.34375 43.734375 L 42.390625 43.734375 L 42.460938 43.746094 L 42.53125 43.75 C 42.59375 43.75 42.640625 43.75 42.6875 43.734375 L 42.71875 43.734375 C 42.765625 43.71875 42.8125 43.703125 42.84375 43.703125 C 42.84375 43.6875 42.859375 43.6875 42.859375 43.6875 L 42.875 43.6875 C 42.9375 43.671875 42.96875 43.625 43.015625 43.59375 L 43.03125 43.59375 C 43.0625 43.5625 43.109375 43.53125 43.140625 43.515625 C 43.140625 43.5 43.15625 43.5 43.15625 43.46875 C 43.1875 43.4375 43.21875 43.40625 43.234375 43.375 L 43.25 43.359375 C 43.28125 43.328125 43.3125 43.265625 43.328125 43.21875 L 47.15625 34.109375 C 47.34375 33.6875 47.140625 33.171875 46.71875 33 C 46.265625 32.8125 45.765625 33.015625 45.578125 33.453125 L 42.53125 40.6875 L 40.515625 35.890625 C 40.359375 35.546875 40.03125 35.359375 39.703125 35.359375 C 39.359375 35.359375 39.03125 35.546875 38.890625 35.890625 L 36.875 40.6875 L 33.8125 33.453125 C 33.640625 33.015625 33.125 32.8125 32.703125 33 C 32.25 33.171875 32.0625 33.6875 32.234375 34.109375 L 36.078125 43.21875 C 36.109375 43.265625 36.125 43.328125 36.15625 43.359375 L 36.15625 43.375 C 36.1875 43.40625 36.203125 43.4375 36.234375 43.46875 C 36.25 43.5 36.25 43.5 36.265625 43.515625 L 36.320312 43.546875 L 36.375 43.59375 C 36.375 43.59375 36.375 43.59375 36.390625 43.59375 C 36.421875 43.625 36.484375 43.671875 36.53125 43.6875 C 36.546875 43.6875 36.546875 43.6875 36.5625 43.703125 C 36.59375 43.703125 36.625 43.71875 36.671875 43.734375 L 36.71875 43.734375 L 36.796875 43.746094 L 36.875 43.75 C 36.921875 43.75 36.96875 43.75 37.015625 43.734375 Z M 37.015625 43.734375 "/>\n      </g>'
    },
    xlsIcon: {
      extension: ".xls",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 17.21875 46.875 C 17.425781 46.875 17.632812 46.800781 17.820312 46.667969 C 18.289062 46.351562 18.363281 45.695312 18.042969 45.242188 L 14.480469 40.367188 L 18.042969 35.53125 C 18.363281 35.0625 18.289062 34.425781 17.820312 34.105469 C 17.351562 33.75 16.730469 33.84375 16.375 34.332031 L 13.226562 38.644531 L 10.054688 34.332031 C 9.738281 33.84375 9.082031 33.75 8.632812 34.105469 C 8.164062 34.425781 8.070312 35.0625 8.386719 35.53125 L 11.949219 40.367188 L 8.386719 45.242188 C 8.070312 45.695312 8.164062 46.351562 8.632812 46.667969 C 8.800781 46.800781 9.007812 46.875 9.230469 46.875 C 9.550781 46.875 9.851562 46.707031 10.054688 46.445312 L 13.226562 42.113281 L 16.375 46.445312 C 16.582031 46.707031 16.882812 46.875 17.21875 46.875 Z M 29.351562 46.875 C 29.894531 46.875 30.382812 46.40625 30.382812 45.84375 C 30.382812 45.261719 29.894531 44.792969 29.351562 44.792969 L 24.269531 44.792969 L 24.269531 34.78125 C 24.269531 34.21875 23.800781 33.75 23.21875 33.75 C 22.636719 33.75 22.1875 34.21875 22.1875 34.78125 L 22.1875 45.84375 C 22.1875 46.335938 22.53125 46.757812 23.007812 46.855469 L 23.222656 46.875 Z M 37.28125 46.855469 C 38.613281 46.855469 39.832031 46.460938 40.75 45.789062 C 41.6875 45.113281 42.363281 44.082031 42.363281 42.882812 C 42.363281 42.300781 42.195312 41.738281 41.914062 41.289062 C 41.480469 40.59375 40.804688 40.105469 40.039062 39.730469 C 39.289062 39.375 38.40625 39.132812 37.449219 38.945312 L 37.414062 38.945312 C 36.398438 38.757812 35.554688 38.457031 35.070312 38.117188 C 34.824219 37.949219 34.65625 37.78125 34.5625 37.632812 C 34.46875 37.480469 34.429688 37.332031 34.429688 37.105469 C 34.429688 36.710938 34.636719 36.300781 35.144531 35.925781 C 35.648438 35.550781 36.398438 35.289062 37.242188 35.289062 C 38.386719 35.289062 39.304688 35.851562 40.261719 36.488281 C 40.710938 36.789062 41.3125 36.65625 41.59375 36.207031 C 41.894531 35.773438 41.761719 35.175781 41.332031 34.875 C 40.375 34.257812 39.042969 33.375 37.242188 33.375 C 36.023438 33.375 34.882812 33.730469 34 34.367188 C 33.136719 35.007812 32.5 35.980469 32.5 37.105469 C 32.5 37.667969 32.648438 38.195312 32.929688 38.644531 C 33.34375 39.300781 33.960938 39.769531 34.675781 40.105469 C 35.386719 40.445312 36.210938 40.667969 37.09375 40.835938 L 37.132812 40.835938 C 38.238281 41.042969 39.15625 41.363281 39.699219 41.71875 C 39.980469 41.90625 40.148438 42.09375 40.261719 42.28125 C 40.375 42.46875 40.429688 42.636719 40.429688 42.882812 C 40.429688 43.351562 40.1875 43.820312 39.625 44.230469 C 39.0625 44.644531 38.21875 44.925781 37.28125 44.925781 C 35.949219 44.945312 34.523438 44.15625 33.699219 43.480469 C 33.289062 43.144531 32.667969 43.199219 32.332031 43.613281 C 32.011719 44.023438 32.070312 44.644531 32.480469 44.980469 C 33.550781 45.824219 35.257812 46.835938 37.28125 46.855469 Z M 37.28125 46.855469 "/>\n      </g>'
    },
    xlsxIcon: {
      extension: ".xlsx",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 13.070312 43.75 C 13.242188 43.75 13.414062 43.6875 13.570312 43.578125 C 13.960938 43.3125 14.023438 42.765625 13.757812 42.390625 L 10.789062 38.328125 L 13.757812 34.296875 C 14.023438 33.90625 13.960938 33.375 13.570312 33.109375 C 13.179688 32.8125 12.664062 32.890625 12.367188 33.296875 L 9.742188 36.890625 L 7.101562 33.296875 C 6.835938 32.890625 6.289062 32.8125 5.914062 33.109375 C 5.523438 33.375 5.445312 33.90625 5.710938 34.296875 L 8.679688 38.328125 L 5.710938 42.390625 C 5.445312 42.765625 5.523438 43.3125 5.914062 43.578125 C 6.054688 43.6875 6.226562 43.75 6.414062 43.75 C 6.679688 43.75 6.929688 43.609375 7.101562 43.390625 L 9.742188 39.78125 L 12.367188 43.390625 C 12.539062 43.609375 12.789062 43.75 13.070312 43.75 Z M 23.179688 43.75 C 23.632812 43.75 24.039062 43.359375 24.039062 42.890625 C 24.039062 42.40625 23.632812 42.015625 23.179688 42.015625 L 18.945312 42.015625 L 18.945312 33.671875 C 18.945312 33.203125 18.554688 32.8125 18.070312 32.8125 C 17.585938 32.8125 17.210938 33.203125 17.210938 33.671875 L 17.210938 42.890625 C 17.210938 43.359375 17.585938 43.75 18.070312 43.75 Z M 29.789062 43.734375 C 30.898438 43.734375 31.914062 43.40625 32.679688 42.84375 C 33.460938 42.28125 34.023438 41.421875 34.023438 40.421875 C 34.023438 39.9375 33.882812 39.46875 33.648438 39.09375 C 33.289062 38.515625 32.726562 38.109375 32.085938 37.796875 C 31.460938 37.5 30.726562 37.296875 29.929688 37.140625 L 29.898438 37.140625 C 29.054688 36.984375 28.351562 36.734375 27.945312 36.453125 C 27.742188 36.3125 27.601562 36.171875 27.523438 36.046875 C 27.445312 35.921875 27.414062 35.796875 27.414062 35.609375 C 27.414062 35.28125 27.585938 34.9375 28.007812 34.625 C 28.429688 34.3125 29.054688 34.09375 29.757812 34.09375 C 30.710938 34.09375 31.476562 34.5625 32.273438 35.09375 C 32.648438 35.34375 33.148438 35.234375 33.382812 34.859375 C 33.632812 34.5 33.523438 34 33.164062 33.75 C 32.367188 33.234375 31.257812 32.5 29.757812 32.5 C 28.742188 32.5 27.789062 32.796875 27.054688 33.328125 C 26.335938 33.859375 25.804688 34.671875 25.804688 35.609375 C 25.804688 36.078125 25.929688 36.515625 26.164062 36.890625 C 26.507812 37.4375 27.023438 37.828125 27.617188 38.109375 C 28.210938 38.390625 28.898438 38.578125 29.632812 38.71875 L 29.664062 38.71875 C 30.585938 38.890625 31.351562 39.15625 31.804688 39.453125 C 32.039062 39.609375 32.179688 39.765625 32.273438 39.921875 C 32.367188 40.078125 32.414062 40.21875 32.414062 40.421875 C 32.414062 40.8125 32.210938 41.203125 31.742188 41.546875 C 31.273438 41.890625 30.570312 42.125 29.789062 42.125 C 28.679688 42.140625 27.492188 41.484375 26.804688 40.921875 C 26.460938 40.640625 25.945312 40.6875 25.664062 41.03125 C 25.398438 41.375 25.445312 41.890625 25.789062 42.171875 C 26.679688 42.875 28.101562 43.71875 29.789062 43.734375 Z M 43.179688 43.75 C 43.351562 43.75 43.523438 43.6875 43.679688 43.578125 C 44.070312 43.3125 44.132812 42.765625 43.867188 42.390625 L 40.898438 38.328125 L 43.867188 34.296875 C 44.132812 33.90625 44.070312 33.375 43.679688 33.109375 C 43.289062 32.8125 42.773438 32.890625 42.476562 33.296875 L 39.851562 36.890625 L 37.210938 33.296875 C 36.945312 32.890625 36.398438 32.8125 36.023438 33.109375 C 35.632812 33.375 35.554688 33.90625 35.820312 34.296875 L 38.789062 38.328125 L 35.820312 42.390625 C 35.554688 42.765625 35.632812 43.3125 36.023438 43.578125 C 36.164062 43.6875 36.335938 43.75 36.523438 43.75 C 36.789062 43.75 37.039062 43.609375 37.210938 43.390625 L 39.851562 39.78125 L 42.476562 43.390625 C 42.648438 43.609375 42.898438 43.75 43.179688 43.75 Z M 43.179688 43.75 "/>\n      </g>'
    },
    zipIcon: {
      extension: ".zip",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 20.175781 46.875 C 20.855469 46.875 21.402344 46.351562 21.402344 45.671875 C 21.402344 44.992188 20.855469 44.445312 20.175781 44.445312 L 13.132812 44.445312 L 21.183594 33.488281 L 21.183594 33.445312 C 21.203125 33.421875 21.226562 33.378906 21.25 33.335938 C 21.269531 33.3125 21.269531 33.289062 21.292969 33.269531 C 21.3125 33.203125 21.3125 33.179688 21.335938 33.136719 C 21.335938 33.09375 21.378906 33.070312 21.378906 33.007812 C 21.378906 32.984375 21.378906 32.960938 21.402344 32.917969 L 21.402344 32.679688 C 21.402344 32.632812 21.402344 32.613281 21.378906 32.546875 C 21.378906 32.503906 21.378906 32.480469 21.335938 32.4375 C 21.335938 32.414062 21.3125 32.371094 21.3125 32.304688 C 21.292969 32.285156 21.269531 32.242188 21.269531 32.21875 C 21.25 32.195312 21.226562 32.152344 21.203125 32.109375 C 21.183594 32.066406 21.160156 32.042969 21.117188 32.023438 C 21.09375 32 21.074219 31.957031 21.050781 31.933594 C 21.03125 31.914062 21.007812 31.867188 20.964844 31.847656 C 20.941406 31.824219 20.941406 31.804688 20.898438 31.78125 L 20.875 31.78125 C 20.832031 31.757812 20.8125 31.738281 20.765625 31.714844 C 20.746094 31.695312 20.722656 31.648438 20.65625 31.648438 L 20.570312 31.605469 L 20.4375 31.585938 C 20.417969 31.585938 20.375 31.5625 20.351562 31.5625 L 10.75 31.5625 C 10.070312 31.5625 9.546875 32.085938 9.546875 32.765625 C 9.546875 33.421875 10.070312 33.992188 10.75 33.992188 L 17.8125 33.992188 L 9.785156 44.972656 L 9.765625 44.972656 C 9.742188 45.015625 9.71875 45.058594 9.699219 45.082031 C 9.699219 45.101562 9.675781 45.148438 9.632812 45.167969 C 9.632812 45.210938 9.609375 45.257812 9.609375 45.277344 C 9.589844 45.320312 9.589844 45.367188 9.566406 45.386719 L 9.566406 45.496094 C 9.546875 45.539062 9.546875 45.585938 9.546875 45.648438 L 9.546875 45.738281 C 9.546875 45.78125 9.566406 45.824219 9.566406 45.890625 C 9.566406 45.933594 9.589844 45.957031 9.589844 45.976562 L 9.632812 46.109375 C 9.632812 46.152344 9.675781 46.175781 9.699219 46.21875 C 9.699219 46.242188 9.71875 46.261719 9.742188 46.328125 C 9.765625 46.351562 9.785156 46.394531 9.808594 46.414062 C 9.828125 46.4375 9.851562 46.460938 9.894531 46.480469 L 9.9375 46.542969 L 9.984375 46.589844 C 10.003906 46.613281 10.027344 46.632812 10.046875 46.632812 L 10.046875 46.65625 C 10.070312 46.679688 10.09375 46.679688 10.136719 46.699219 C 10.179688 46.722656 10.222656 46.742188 10.246094 46.742188 C 10.265625 46.789062 10.289062 46.789062 10.3125 46.808594 C 10.375 46.808594 10.421875 46.832031 10.464844 46.832031 C 10.484375 46.851562 10.507812 46.851562 10.53125 46.851562 L 10.648438 46.871094 Z M 26.214844 46.875 C 26.871094 46.875 27.4375 46.351562 27.4375 45.671875 L 27.4375 32.765625 C 27.4375 32.085938 26.871094 31.5625 26.214844 31.5625 C 25.535156 31.5625 25.011719 32.085938 25.011719 32.765625 L 25.011719 45.671875 C 25.011719 46.351562 25.535156 46.875 26.214844 46.875 Z M 32.734375 46.875 C 33.410156 46.875 33.957031 46.328125 33.957031 45.671875 L 33.957031 40.925781 L 36.648438 40.925781 C 39.25 40.925781 41.351562 38.824219 41.351562 36.265625 C 41.351562 33.664062 39.25 31.5625 36.648438 31.5625 L 32.734375 31.5625 C 32.078125 31.5625 31.53125 32.085938 31.53125 32.765625 L 31.53125 45.671875 C 31.53125 46.328125 32.078125 46.875 32.734375 46.875 Z M 36.648438 38.496094 L 33.957031 38.496094 L 33.957031 33.992188 L 36.648438 33.992188 C 37.917969 33.992188 38.902344 34.996094 38.921875 36.265625 C 38.902344 37.492188 37.917969 38.496094 36.648438 38.496094 Z M 36.648438 38.496094 "/>\n      </g>'
    },
    docxIcon: {
      extension: ".docx",
      path: '<g id="surface9" clip-path="url(#clip1)">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      </g>\n      </defs>\n      <g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <use xlink:href="#surface9" mask="url(#mask0)"/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 7.789062 43.75 C 9.589844 43.75 10.988281 43.269531 11.984375 42.304688 C 12.980469 41.339844 13.476562 39.984375 13.476562 38.234375 C 13.476562 36.496094 12.980469 35.144531 11.984375 34.179688 C 10.988281 33.214844 9.589844 32.734375 7.789062 32.734375 L 4.695312 32.734375 C 4.394531 32.734375 4.15625 32.816406 3.984375 32.984375 C 3.8125 33.152344 3.726562 33.386719 3.726562 33.6875 L 3.726562 42.796875 C 3.726562 43.097656 3.8125 43.332031 3.984375 43.5 C 4.15625 43.667969 4.394531 43.75 4.695312 43.75 Z M 7.664062 42.109375 L 5.742188 42.109375 L 5.742188 34.375 L 7.664062 34.375 C 10.195312 34.375 11.460938 35.660156 11.460938 38.234375 C 11.460938 40.816406 10.195312 42.109375 7.664062 42.109375 Z M 20.414062 43.890625 C 21.476562 43.890625 22.402344 43.660156 23.1875 43.203125 C 23.972656 42.746094 24.582031 42.089844 25.007812 41.234375 C 25.433594 40.378906 25.648438 39.378906 25.648438 38.234375 C 25.648438 37.089844 25.4375 36.089844 25.015625 35.242188 C 24.59375 34.394531 23.988281 33.738281 23.203125 33.28125 C 22.417969 32.824219 21.488281 32.59375 20.414062 32.59375 C 19.339844 32.59375 18.410156 32.824219 17.617188 33.28125 C 16.824219 33.738281 16.21875 34.394531 15.796875 35.242188 C 15.375 36.089844 15.164062 37.089844 15.164062 38.234375 C 15.164062 39.378906 15.378906 40.378906 15.804688 41.234375 C 16.230469 42.089844 16.839844 42.746094 17.625 43.203125 C 18.410156 43.660156 19.339844 43.890625 20.414062 43.890625 Z M 20.414062 42.28125 C 19.394531 42.28125 18.597656 41.933594 18.03125 41.234375 C 17.464844 40.535156 17.179688 39.535156 17.179688 38.234375 C 17.179688 36.933594 17.464844 35.933594 18.03125 35.242188 C 18.597656 34.550781 19.394531 34.203125 20.414062 34.203125 C 21.425781 34.203125 22.214844 34.550781 22.78125 35.242188 C 23.347656 35.933594 23.632812 36.933594 23.632812 38.234375 C 23.632812 39.535156 23.347656 40.535156 22.78125 41.234375 C 22.214844 41.933594 21.425781 42.28125 20.414062 42.28125 Z M 32.601562 43.890625 C 33.289062 43.890625 33.933594 43.789062 34.539062 43.585938 C 35.144531 43.382812 35.679688 43.089844 36.148438 42.703125 C 36.285156 42.597656 36.378906 42.488281 36.429688 42.367188 C 36.480469 42.246094 36.507812 42.109375 36.507812 41.953125 C 36.507812 41.722656 36.445312 41.53125 36.320312 41.375 C 36.195312 41.21875 36.042969 41.140625 35.867188 41.140625 C 35.753906 41.140625 35.644531 41.160156 35.539062 41.203125 C 35.433594 41.246094 35.332031 41.296875 35.226562 41.359375 C 34.746094 41.683594 34.316406 41.910156 33.9375 42.046875 C 33.558594 42.183594 33.144531 42.25 32.695312 42.25 C 31.613281 42.25 30.792969 41.910156 30.234375 41.234375 C 29.675781 40.558594 29.398438 39.558594 29.398438 38.234375 C 29.398438 36.921875 29.675781 35.925781 30.234375 35.25 C 30.792969 34.574219 31.613281 34.234375 32.695312 34.234375 C 33.164062 34.234375 33.589844 34.300781 33.976562 34.429688 C 34.363281 34.558594 34.777344 34.792969 35.226562 35.125 C 35.445312 35.269531 35.660156 35.34375 35.867188 35.34375 C 36.042969 35.34375 36.195312 35.265625 36.320312 35.109375 C 36.445312 34.953125 36.507812 34.761719 36.507812 34.53125 C 36.507812 34.363281 36.480469 34.222656 36.429688 34.109375 C 36.378906 33.996094 36.285156 33.886719 36.148438 33.78125 C 35.679688 33.394531 35.144531 33.101562 34.539062 32.898438 C 33.933594 32.695312 33.289062 32.59375 32.601562 32.59375 C 31.539062 32.59375 30.609375 32.824219 29.8125 33.28125 C 29.015625 33.738281 28.402344 34.394531 27.976562 35.242188 C 27.550781 36.089844 27.335938 37.089844 27.335938 38.234375 C 27.335938 39.378906 27.550781 40.378906 27.976562 41.234375 C 28.402344 42.089844 29.015625 42.746094 29.8125 43.203125 C 30.609375 43.660156 31.539062 43.890625 32.601562 43.890625 Z M 46.132812 43.84375 C 46.382812 43.84375 46.605469 43.75 46.796875 43.5625 C 46.988281 43.375 47.085938 43.15625 47.085938 42.90625 C 47.085938 42.707031 47.003906 42.511719 46.835938 42.3125 L 43.445312 38.15625 L 46.710938 34.171875 C 46.867188 34.003906 46.945312 33.808594 46.945312 33.578125 C 46.945312 33.328125 46.847656 33.113281 46.65625 32.929688 C 46.464844 32.746094 46.242188 32.65625 45.992188 32.65625 C 45.730469 32.65625 45.507812 32.769531 45.320312 33 L 42.273438 36.765625 L 39.226562 33 C 39.027344 32.769531 38.800781 32.65625 38.539062 32.65625 C 38.289062 32.65625 38.070312 32.746094 37.882812 32.929688 C 37.695312 33.113281 37.601562 33.328125 37.601562 33.578125 C 37.601562 33.808594 37.679688 34.003906 37.835938 34.171875 L 41.101562 38.15625 L 37.695312 42.3125 C 37.539062 42.5 37.460938 42.699219 37.460938 42.90625 C 37.460938 43.15625 37.558594 43.371094 37.75 43.554688 C 37.941406 43.738281 38.164062 43.828125 38.414062 43.828125 C 38.675781 43.828125 38.898438 43.71875 39.085938 43.5 L 42.273438 39.5625 L 45.445312 43.5 C 45.644531 43.730469 45.871094 43.84375 46.132812 43.84375 Z M 46.132812 43.84375 "/>\n      </g>'
    },
    jpgIcon: {
      extension: ".jpg",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <use xlink:href="#surface9" mask="url(#mask0)"/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 8.789062 47.007812 L 9.488281 46.960938 C 12.214844 46.757812 13.578125 45.277344 13.578125 42.523438 L 13.578125 32.742188 C 13.578125 32.320312 13.453125 31.980469 13.195312 31.726562 C 12.941406 31.472656 12.59375 31.34375 12.15625 31.34375 C 11.734375 31.34375 11.394531 31.472656 11.140625 31.726562 C 10.886719 31.980469 10.757812 32.320312 10.757812 32.742188 L 10.757812 42.523438 C 10.757812 43.238281 10.605469 43.769531 10.296875 44.117188 C 9.992188 44.46875 9.539062 44.660156 8.941406 44.6875 L 8.242188 44.730469 C 7.847656 44.761719 7.558594 44.867188 7.378906 45.046875 C 7.195312 45.230469 7.105469 45.496094 7.105469 45.847656 C 7.105469 46.664062 7.667969 47.050781 8.789062 47.007812 Z M 18.304688 47.007812 C 18.742188 47.007812 19.089844 46.878906 19.34375 46.625 C 19.597656 46.367188 19.726562 46.023438 19.726562 45.585938 L 19.726562 40.882812 L 23.640625 40.882812 C 25.289062 40.882812 26.574219 40.464844 27.492188 39.632812 C 28.410156 38.804688 28.871094 37.644531 28.871094 36.15625 C 28.871094 34.667969 28.410156 33.511719 27.492188 32.6875 C 26.574219 31.863281 25.289062 31.453125 23.640625 31.453125 L 18.261719 31.453125 C 17.839844 31.453125 17.507812 31.570312 17.265625 31.804688 C 17.023438 32.035156 16.90625 32.363281 16.90625 32.789062 L 16.90625 45.585938 C 16.90625 46.023438 17.03125 46.367188 17.289062 46.625 C 17.542969 46.878906 17.882812 47.007812 18.304688 47.007812 Z M 23.292969 38.714844 L 19.726562 38.714844 L 19.726562 33.640625 L 23.292969 33.640625 C 25.230469 33.640625 26.203125 34.488281 26.203125 36.179688 C 26.203125 37.871094 25.230469 38.714844 23.292969 38.714844 Z M 38.605469 47.070312 C 39.320312 47.070312 40.0625 47.011719 40.835938 46.898438 C 41.609375 46.78125 42.285156 46.621094 42.871094 46.414062 C 43.410156 46.242188 43.765625 46.015625 43.941406 45.738281 C 44.117188 45.460938 44.203125 44.988281 44.203125 44.316406 L 44.203125 39.613281 C 44.203125 39.292969 44.101562 39.03125 43.898438 38.835938 C 43.695312 38.640625 43.425781 38.539062 43.089844 38.539062 L 39.21875 38.539062 C 38.867188 38.539062 38.59375 38.628906 38.398438 38.804688 C 38.199219 38.976562 38.101562 39.226562 38.101562 39.546875 C 38.101562 39.867188 38.199219 40.117188 38.398438 40.289062 C 38.59375 40.464844 38.867188 40.554688 39.21875 40.554688 L 41.6875 40.554688 L 41.6875 44.425781 C 40.699219 44.703125 39.707031 44.839844 38.714844 44.839844 C 35.390625 44.839844 33.726562 42.945312 33.726562 39.152344 C 33.726562 37.300781 34.132812 35.90625 34.941406 34.964844 C 35.75 34.023438 36.949219 33.554688 38.539062 33.554688 C 39.238281 33.554688 39.867188 33.644531 40.421875 33.828125 C 40.972656 34.007812 41.574219 34.324219 42.214844 34.777344 C 42.390625 34.894531 42.542969 34.980469 42.671875 35.03125 C 42.804688 35.082031 42.949219 35.105469 43.109375 35.105469 C 43.359375 35.105469 43.570312 34.996094 43.746094 34.777344 C 43.921875 34.558594 44.007812 34.289062 44.007812 33.96875 C 44.007812 33.75 43.96875 33.558594 43.886719 33.398438 C 43.808594 33.238281 43.679688 33.078125 43.503906 32.917969 C 42.191406 31.808594 40.507812 31.257812 38.453125 31.257812 C 36.90625 31.257812 35.5625 31.574219 34.425781 32.207031 C 33.289062 32.84375 32.410156 33.753906 31.789062 34.941406 C 31.171875 36.128906 30.859375 37.535156 30.859375 39.152344 C 30.859375 40.800781 31.171875 42.21875 31.789062 43.40625 C 32.410156 44.597656 33.304688 45.503906 34.46875 46.132812 C 35.636719 46.757812 37.015625 47.070312 38.605469 47.070312 Z M 38.605469 47.070312 "/>\n      </g>'
    },
    mp3Icon: {
      extension: ".mp3",
      path: '<g id="surface9" clip-path="url(#clip1)">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 43.828125 43.710938 C 43.605469 44.28125 43.273438 44.804688 42.84375 45.265625 C 42.40625 45.730469 41.867188 46.113281 41.242188 46.398438 C 40.597656 46.699219 39.851562 46.855469 39.027344 46.855469 C 38.328125 46.855469 37.703125 46.757812 37.160156 46.570312 C 36.609375 46.378906 36.160156 46.136719 35.769531 45.839844 C 35.386719 45.550781 35.050781 45.210938 34.796875 44.832031 C 34.570312 44.507812 34.394531 44.195312 34.265625 43.890625 C 34.140625 43.59375 34.054688 43.335938 33.996094 43.101562 C 33.792969 42.261719 34.304688 41.417969 35.140625 41.210938 C 35.980469 41.007812 36.828125 41.519531 37.03125 42.355469 C 37.039062 42.390625 37.066406 42.488281 37.144531 42.671875 C 37.191406 42.777344 37.265625 42.914062 37.371094 43.0625 C 37.4375 43.160156 37.53125 43.257812 37.65625 43.351562 C 37.792969 43.453125 37.972656 43.542969 38.195312 43.625 C 38.332031 43.667969 38.59375 43.730469 39.027344 43.730469 C 39.390625 43.730469 39.695312 43.675781 39.925781 43.566406 C 40.1875 43.445312 40.398438 43.300781 40.558594 43.132812 C 40.71875 42.957031 40.839844 42.773438 40.914062 42.578125 C 40.996094 42.371094 41.03125 42.195312 41.03125 42.023438 C 41.03125 41.789062 41 41.585938 40.921875 41.398438 C 40.871094 41.257812 40.785156 41.148438 40.660156 41.039062 C 40.515625 40.910156 40.296875 40.792969 40.011719 40.699219 C 39.6875 40.59375 39.253906 40.539062 38.738281 40.535156 C 37.882812 40.527344 37.1875 39.832031 37.1875 38.972656 L 37.1875 38.832031 C 37.1875 37.984375 37.859375 37.292969 38.699219 37.265625 C 39.070312 37.257812 39.398438 37.195312 39.679688 37.101562 C 39.921875 37.011719 40.121094 36.902344 40.273438 36.773438 C 40.40625 36.652344 40.507812 36.519531 40.582031 36.359375 C 40.652344 36.210938 40.6875 36.027344 40.6875 35.8125 C 40.6875 35.523438 40.644531 35.289062 40.574219 35.125 C 40.5 34.96875 40.414062 34.847656 40.304688 34.757812 C 40.1875 34.660156 40.042969 34.582031 39.867188 34.53125 C 39.402344 34.386719 38.878906 34.398438 38.480469 34.542969 C 38.289062 34.617188 38.121094 34.714844 37.976562 34.84375 C 37.820312 34.984375 37.695312 35.148438 37.59375 35.339844 C 37.484375 35.550781 37.40625 35.773438 37.367188 36.039062 C 37.230469 36.890625 36.429688 37.472656 35.574219 37.335938 C 34.722656 37.195312 34.140625 36.398438 34.28125 35.542969 C 34.378906 34.9375 34.5625 34.378906 34.835938 33.871094 C 35.109375 33.355469 35.464844 32.898438 35.890625 32.519531 C 36.320312 32.132812 36.824219 31.828125 37.382812 31.617188 C 38.433594 31.226562 39.667969 31.199219 40.78125 31.539062 C 41.351562 31.714844 41.863281 31.992188 42.308594 32.355469 C 42.777344 32.753906 43.148438 33.242188 43.414062 33.824219 C 43.679688 34.402344 43.8125 35.070312 43.8125 35.8125 C 43.8125 36.476562 43.679688 37.097656 43.421875 37.660156 C 43.25 38.046875 43.023438 38.394531 42.746094 38.707031 C 43.242188 39.148438 43.609375 39.671875 43.835938 40.261719 C 44.046875 40.804688 44.15625 41.398438 44.15625 42.023438 C 44.15625 42.578125 44.046875 43.148438 43.828125 43.710938 Z M 31.445312 38.492188 C 31.148438 39.140625 30.734375 39.703125 30.199219 40.164062 C 29.6875 40.605469 29.078125 40.957031 28.390625 41.199219 C 27.71875 41.4375 26.976562 41.5625 26.191406 41.5625 L 25 41.5625 L 25 45 C 25 45.859375 24.296875 46.5625 23.4375 46.5625 C 22.578125 46.5625 21.875 45.859375 21.875 45 L 21.875 32.8125 C 21.875 31.945312 22.578125 31.25 23.4375 31.25 L 26.191406 31.25 C 27.890625 31.25 29.257812 31.667969 30.253906 32.5 C 31.339844 33.398438 31.886719 34.714844 31.886719 36.40625 C 31.886719 37.148438 31.738281 37.851562 31.445312 38.492188 Z M 18.730469 45.210938 C 18.730469 46.070312 18.03125 46.773438 17.167969 46.773438 C 16.300781 46.773438 15.605469 46.070312 15.605469 45.210938 L 15.605469 39.28125 L 14.015625 43.140625 C 14.007812 43.164062 13.996094 43.191406 13.984375 43.214844 C 13.71875 43.777344 13.15625 44.117188 12.566406 44.117188 L 12.53125 44.117188 C 11.9375 44.117188 11.375 43.777344 11.109375 43.214844 L 11.082031 43.160156 L 9.339844 39.101562 L 9.339844 45.210938 C 9.339844 46.070312 8.640625 46.773438 7.777344 46.773438 C 6.910156 46.773438 6.214844 46.070312 6.214844 45.210938 L 6.214844 32.824219 C 6.214844 31.960938 6.910156 31.261719 7.777344 31.261719 L 7.835938 31.261719 C 8.472656 31.261719 9.046875 31.617188 9.335938 32.1875 L 12.527344 39.09375 L 15.59375 32.207031 C 15.894531 31.617188 16.46875 31.261719 17.105469 31.261719 L 17.167969 31.261719 C 18.03125 31.261719 18.730469 31.960938 18.730469 32.824219 Z M 41.382812 28.125 L 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.136719 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.136719 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 41.382812 28.125 "/>\n      </g>\n      </defs>\n      <g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <use xlink:href="#surface9" mask="url(#mask0)"/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 28.257812 34.902344 C 27.835938 34.550781 27.140625 34.375 26.191406 34.375 L 25 34.375 L 25 38.4375 L 26.191406 38.4375 C 26.621094 38.4375 27.007812 38.375 27.34375 38.253906 C 27.667969 38.140625 27.929688 37.992188 28.148438 37.804688 C 28.34375 37.632812 28.492188 37.4375 28.601562 37.195312 C 28.710938 36.964844 28.757812 36.703125 28.757812 36.40625 C 28.757812 35.324219 28.382812 35.003906 28.257812 34.902344 "/>\n      <path style="fill:none;stroke-width:1;stroke-linecap:round;stroke-linejoin:round;stroke:rgb(99.607843%,99.607843%,99.607843%);stroke-opacity:1;stroke-miterlimit:4;" d="M 11.34125 13.57875 C 11.345 13.5925 11.3525 13.62375 11.36375 13.67375 C 11.3775 13.7225 11.3975 13.78125 11.42625 13.85 C 11.45375 13.9175 11.49375 13.9875 11.54625 14.0625 C 11.5975 14.13875 11.66625 14.20875 11.75 14.27125 C 11.83375 14.33625 11.9375 14.38875 12.0575 14.43125 C 12.1775 14.4725 12.32 14.49375 12.4875 14.49375 C 12.67875 14.49375 12.845 14.46125 12.9875 14.39375 C 13.13 14.32875 13.24875 14.245 13.34375 14.1425 C 13.43875 14.0425 13.51125 13.93 13.55875 13.8075 C 13.6075 13.6825 13.63125 13.56375 13.63125 13.4475 C 13.63125 13.31125 13.6075 13.1825 13.5625 13.065 C 13.515 12.9475 13.4425 12.845 13.3425 12.7575 C 13.2425 12.67 13.115 12.6 12.96 12.55 C 12.805 12.49875 12.6175 12.4725 12.4 12.4725 L 12.4 12.42625 C 12.57 12.42 12.72375 12.3925 12.8625 12.34375 C 13.0025 12.29625 13.11875 12.2275 13.21625 12.14375 C 13.31375 12.05875 13.3875 11.96 13.44125 11.845 C 13.4925 11.7275 13.52 11.60125 13.52 11.46 C 13.52 11.29375 13.4925 11.1525 13.43875 11.0325 C 13.38375 10.91375 13.31125 10.81625 13.21875 10.74 C 13.1275 10.66375 13.0225 10.6075 12.90375 10.5725 C 12.78625 10.535 12.66375 10.5175 12.5375 10.5175 C 12.395 10.5175 12.26125 10.54 12.14 10.58625 C 12.0175 10.6325 11.91 10.69625 11.81875 10.77875 C 11.72625 10.8625 11.64875 10.96 11.5875 11.07375 C 11.5275 11.18875 11.48625 11.315 11.4625 11.45375 M 7.5 14.4 L 7.5 10.5 L 8.3825 10.5 C 8.8075 10.5 9.13375 10.595 9.3625 10.78375 C 9.59 10.975 9.7025 11.2625 9.7025 11.65 C 9.7025 11.81625 9.6725 11.97125 9.6075 12.11125 C 9.5425 12.2525 9.4525 12.37375 9.335 12.475 C 9.21875 12.5775 9.0775 12.65625 8.9175 12.71375 C 8.75625 12.77125 8.5775 12.8 8.3825 12.8 L 7.6 12.8 M 2.4875 14.4675 L 2.4875 10.50375 L 2.5075 10.50375 C 2.5225 10.50375 2.53375 10.5125 2.5425 10.52625 L 3.9925 13.58625 C 3.99875 13.5975 4.005 13.6075 4.00875 13.6175 M 4.02125 13.6175 C 4.02625 13.6075 4.03125 13.5975 4.0375 13.58625 L 5.44 10.52625 C 5.4475 10.5125 5.45875 10.50375 5.4725 10.50375 L 5.4925 10.50375 L 5.4925 14.4675 " transform="matrix(3.125,0,0,3.125,0,0)"/>\n      </g>'
    },
    mp4Icon: {
      extension: ".mp4",
      path: '<g id="surface6" clip-path="url(#clip1)">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 36.898438 40.625 L 40.625 35.480469 L 40.625 40.625 Z M 28.761719 36.40625 C 28.761719 36.703125 28.707031 36.964844 28.605469 37.195312 C 28.496094 37.433594 28.347656 37.632812 28.148438 37.804688 C 27.929688 37.992188 27.667969 38.144531 27.34375 38.257812 C 27.003906 38.375 26.621094 38.4375 26.191406 38.4375 L 25 38.4375 L 25 34.375 L 26.191406 34.375 C 27.140625 34.375 27.835938 34.554688 28.253906 34.902344 C 28.378906 35.007812 28.761719 35.324219 28.761719 36.40625 Z M 44.6875 43.75 L 43.75 43.75 L 43.75 45.3125 C 43.75 46.175781 43.050781 46.875 42.1875 46.875 C 41.324219 46.875 40.625 46.175781 40.625 45.3125 L 40.625 43.75 L 34.066406 43.75 C 33.199219 43.75 32.503906 43.050781 32.503906 42.1875 L 32.503906 41.875 C 32.503906 41.546875 32.605469 41.226562 32.800781 40.957031 L 39.363281 31.898438 C 39.660156 31.492188 40.128906 31.25 40.628906 31.25 L 42.1875 31.25 C 43.050781 31.25 43.75 31.949219 43.75 32.8125 L 43.75 40.625 L 44.6875 40.625 C 45.550781 40.625 46.25 41.324219 46.25 42.1875 C 46.25 43.050781 45.550781 43.75 44.6875 43.75 Z M 31.445312 38.492188 C 31.148438 39.140625 30.730469 39.703125 30.195312 40.167969 C 29.6875 40.605469 29.082031 40.957031 28.390625 41.203125 C 27.71875 41.441406 26.976562 41.5625 26.191406 41.5625 L 25 41.5625 L 25 45 C 25 45.863281 24.300781 46.5625 23.4375 46.5625 C 22.578125 46.5625 21.875 45.863281 21.875 45 L 21.875 32.8125 C 21.875 31.949219 22.578125 31.25 23.4375 31.25 L 26.191406 31.25 C 27.890625 31.25 29.257812 31.671875 30.253906 32.5 C 31.339844 33.398438 31.886719 34.714844 31.886719 36.40625 C 31.886719 37.148438 31.738281 37.851562 31.445312 38.492188 Z M 18.730469 45.210938 C 18.730469 46.070312 18.027344 46.773438 17.167969 46.773438 C 16.300781 46.773438 15.605469 46.070312 15.605469 45.210938 L 15.605469 39.6875 L 14.035156 43.105469 C 14.019531 43.144531 14.003906 43.179688 13.984375 43.214844 C 13.71875 43.78125 13.15625 44.117188 12.566406 44.117188 L 12.53125 44.117188 C 11.941406 44.117188 11.378906 43.78125 11.113281 43.214844 C 11.097656 43.183594 11.078125 43.152344 11.066406 43.125 L 9.339844 39.484375 L 9.339844 45.210938 C 9.339844 46.070312 8.640625 46.773438 7.777344 46.773438 C 6.910156 46.773438 6.214844 46.070312 6.214844 45.210938 L 6.214844 32.824219 C 6.214844 31.960938 6.910156 31.261719 7.777344 31.261719 L 7.835938 31.261719 C 8.472656 31.261719 9.046875 31.617188 9.335938 32.191406 L 9.355469 32.226562 L 12.523438 38.90625 L 15.578125 32.242188 C 15.585938 32.226562 15.597656 32.210938 15.605469 32.191406 C 15.894531 31.617188 16.46875 31.261719 17.105469 31.261719 L 17.164062 31.261719 C 18.027344 31.261719 18.726562 31.960938 18.726562 32.824219 L 18.726562 45.210938 Z M 41.382812 28.125 L 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 41.382812 28.125 "/>\n      </g>\n      </defs>\n      <g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <use xlink:href="#surface6" mask="url(#mask0)"/>\n      <path style="fill:none;stroke-width:1;stroke-linecap:round;stroke-linejoin:round;stroke:rgb(99.607843%,99.607843%,99.607843%);stroke-opacity:1;stroke-miterlimit:4;" d="M 14.3 13.5 L 10.90125 13.5 L 10.90125 13.4 L 13.00125 10.5 L 13.5 10.5 L 13.5 14.5 M 7.5 14.4 L 7.5 10.5 L 8.3825 10.5 C 8.8075 10.5 9.13375 10.595 9.3625 10.78375 C 9.59 10.975 9.7025 11.2625 9.7025 11.65 C 9.7025 11.81625 9.6725 11.97125 9.6075 12.11125 C 9.5425 12.2525 9.4525 12.37375 9.335 12.47625 C 9.21875 12.5775 9.0775 12.65625 8.9175 12.71375 C 8.75625 12.77125 8.5775 12.8 8.3825 12.8 L 7.6 12.8 M 2.4875 14.4675 L 2.4875 10.50375 L 2.5075 10.50375 C 2.5225 10.50375 2.53375 10.5125 2.5425 10.52625 L 3.9925 13.58625 C 3.99875 13.5975 4.005 13.6075 4.00875 13.6175 M 4.02125 13.6175 C 4.02625 13.6075 4.03125 13.5975 4.0375 13.58625 L 5.44 10.52625 C 5.4475 10.5125 5.45875 10.50375 5.4725 10.50375 L 5.4925 10.50375 L 5.4925 14.4675 " transform="matrix(3.125,0,0,3.125,0,0)"/>\n      </g>'
    },
    oggIcon: {
      extension: ".ogg",
      path: '<g id="surface9" clip-path="url(#clip1)">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 "/>\n      </g>\n      </defs>\n      <g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 "/>\n      <use xlink:href="#surface9" mask="url(#mask0)"/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 8.976562 47.070312 C 10.464844 47.070312 11.757812 46.75 12.859375 46.109375 C 13.960938 45.46875 14.808594 44.550781 15.40625 43.351562 C 16.003906 42.15625 16.304688 40.757812 16.304688 39.152344 C 16.304688 37.550781 16.007812 36.152344 15.417969 34.964844 C 14.828125 33.777344 13.980469 32.859375 12.882812 32.21875 C 11.78125 31.578125 10.480469 31.257812 8.976562 31.257812 C 7.472656 31.257812 6.167969 31.578125 5.0625 32.21875 C 3.953125 32.859375 3.101562 33.777344 2.511719 34.964844 C 1.921875 36.152344 1.625 37.550781 1.625 39.152344 C 1.625 40.757812 1.925781 42.15625 2.523438 43.351562 C 3.121094 44.550781 3.972656 45.46875 5.070312 46.109375 C 6.171875 46.75 7.472656 47.070312 8.976562 47.070312 Z M 8.976562 44.820312 C 7.546875 44.820312 6.433594 44.332031 5.640625 43.351562 C 4.847656 42.375 4.449219 40.976562 4.449219 39.152344 C 4.449219 37.332031 4.847656 35.933594 5.640625 34.964844 C 6.433594 33.996094 7.546875 33.507812 8.976562 33.507812 C 10.390625 33.507812 11.496094 33.996094 12.289062 34.964844 C 13.085938 35.933594 13.484375 37.332031 13.484375 39.152344 C 13.484375 40.976562 13.085938 42.375 12.289062 43.351562 C 11.496094 44.332031 10.390625 44.820312 8.976562 44.820312 Z M 26.410156 47.070312 C 27.125 47.070312 27.871094 47.011719 28.640625 46.898438 C 29.414062 46.78125 30.09375 46.621094 30.675781 46.414062 C 31.214844 46.242188 31.574219 46.015625 31.75 45.738281 C 31.921875 45.460938 32.011719 44.988281 32.011719 44.316406 L 32.011719 39.613281 C 32.011719 39.292969 31.910156 39.03125 31.703125 38.835938 C 31.5 38.640625 31.230469 38.539062 30.894531 38.539062 L 27.023438 38.539062 C 26.671875 38.539062 26.398438 38.628906 26.203125 38.804688 C 26.007812 38.976562 25.90625 39.226562 25.90625 39.546875 C 25.90625 39.867188 26.007812 40.117188 26.203125 40.289062 C 26.398438 40.464844 26.671875 40.554688 27.023438 40.554688 L 29.496094 40.554688 L 29.496094 44.425781 C 28.503906 44.703125 27.511719 44.839844 26.519531 44.839844 C 23.195312 44.839844 21.53125 42.945312 21.53125 39.152344 C 21.53125 37.300781 21.9375 35.90625 22.746094 34.964844 C 23.554688 34.023438 24.753906 33.554688 26.34375 33.554688 C 27.046875 33.554688 27.671875 33.644531 28.226562 33.828125 C 28.78125 34.007812 29.378906 34.324219 30.019531 34.777344 C 30.195312 34.894531 30.347656 34.980469 30.480469 35.03125 C 30.609375 35.082031 30.757812 35.105469 30.917969 35.105469 C 31.164062 35.105469 31.375 34.996094 31.550781 34.777344 C 31.726562 34.558594 31.8125 34.289062 31.8125 33.96875 C 31.8125 33.75 31.773438 33.558594 31.695312 33.398438 C 31.613281 33.238281 31.484375 33.078125 31.3125 32.917969 C 30 31.808594 28.3125 31.257812 26.257812 31.257812 C 24.710938 31.257812 23.371094 31.574219 22.234375 32.207031 C 21.09375 32.84375 20.214844 33.753906 19.597656 34.941406 C 18.976562 36.128906 18.667969 37.535156 18.667969 39.152344 C 18.667969 40.800781 18.976562 42.21875 19.597656 43.40625 C 20.214844 44.597656 21.109375 45.503906 22.277344 46.132812 C 23.441406 46.757812 24.820312 47.070312 26.410156 47.070312 Z M 42.445312 47.070312 C 43.160156 47.070312 43.902344 47.011719 44.675781 46.898438 C 45.449219 46.78125 46.128906 46.621094 46.710938 46.414062 C 47.25 46.242188 47.609375 46.015625 47.78125 45.738281 C 47.957031 45.460938 48.046875 44.988281 48.046875 44.316406 L 48.046875 39.613281 C 48.046875 39.292969 47.941406 39.03125 47.738281 38.835938 C 47.535156 38.640625 47.265625 38.539062 46.929688 38.539062 L 43.058594 38.539062 C 42.707031 38.539062 42.433594 38.628906 42.238281 38.804688 C 42.039062 38.976562 41.941406 39.226562 41.941406 39.546875 C 41.941406 39.867188 42.039062 40.117188 42.238281 40.289062 C 42.433594 40.464844 42.707031 40.554688 43.058594 40.554688 L 45.53125 40.554688 L 45.53125 44.425781 C 44.539062 44.703125 43.546875 44.839844 42.554688 44.839844 C 39.230469 44.839844 37.566406 42.945312 37.566406 39.152344 C 37.566406 37.300781 37.972656 35.90625 38.78125 34.964844 C 39.589844 34.023438 40.789062 33.554688 42.378906 33.554688 C 43.078125 33.554688 43.707031 33.644531 44.261719 33.828125 C 44.816406 34.007812 45.414062 34.324219 46.054688 34.777344 C 46.230469 34.894531 46.382812 34.980469 46.515625 35.03125 C 46.644531 35.082031 46.792969 35.105469 46.953125 35.105469 C 47.199219 35.105469 47.410156 34.996094 47.585938 34.777344 C 47.761719 34.558594 47.847656 34.289062 47.847656 33.96875 C 47.847656 33.75 47.808594 33.558594 47.726562 33.398438 C 47.648438 33.238281 47.519531 33.078125 47.34375 32.917969 C 46.03125 31.808594 44.347656 31.257812 42.292969 31.257812 C 40.746094 31.257812 39.40625 31.574219 38.265625 32.207031 C 37.128906 32.84375 36.25 33.753906 35.632812 34.941406 C 35.011719 36.128906 34.703125 37.535156 34.703125 39.152344 C 34.703125 40.800781 35.011719 42.21875 35.632812 43.40625 C 36.25 44.597656 37.144531 45.503906 38.3125 46.132812 C 39.476562 46.757812 40.855469 47.070312 42.445312 47.070312 Z M 42.445312 47.070312 "/>\n      </g>'
    },
    pdfIcon: {
      extension: ".pdf",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;" d="M 10.59375 25 L 39.4375 25 C 41.476562 25.003906 43.484375 25.472656 45.3125 26.375 L 45.3125 15.375 C 45.347656 14.191406 44.867188 13.054688 44 12.25 L 34.625 2.875 C 33.875 2.003906 32.773438 1.523438 31.625 1.5625 L 6.625 1.5625 C 5.589844 1.5625 4.75 2.402344 4.75 3.4375 L 4.75 26.375 C 6.566406 25.480469 8.566406 25.007812 10.59375 25 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 34.375 4.71875 L 42.15625 12.5 L 34.53125 12.5 C 34.480469 12.511719 34.425781 12.511719 34.375 12.5 Z M 6.25 25.71875 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.300781 13.980469 32.316406 15.253906 33.75 15.625 C 33.957031 15.675781 34.167969 15.675781 34.375 15.625 L 43.75 15.625 L 43.75 25.71875 C 44.859375 26.09375 45.910156 26.621094 46.875 27.28125 L 46.875 15.375 C 46.964844 13.722656 46.3125 12.117188 45.09375 11 L 35.71875 1.625 C 34.648438 0.523438 33.160156 -0.0664062 31.625 0 L 6.625 0 C 5.703125 -0.015625 4.8125 0.339844 4.152344 0.984375 C 3.496094 1.632812 3.125 2.515625 3.125 3.4375 L 3.125 27.28125 C 4.09375 26.625 5.144531 26.101562 6.25 25.71875 Z M 6.25 25.71875 "/>\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 8.625 28.125 C 6.335938 28.117188 4.136719 29.023438 2.515625 30.640625 C 0.898438 32.261719 -0.0078125 34.460938 0 36.75 L 0 41.375 C 0 46.136719 3.863281 50 8.625 50 L 41.375 50 C 46.132812 49.984375 49.984375 46.132812 50 41.375 L 50 36.75 C 50 31.988281 46.136719 28.125 41.375 28.125 Z M 8.625 28.125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 14.40625 41.78125 L 12.09375 41.78125 L 12.09375 45.84375 C 12.003906 46.351562 11.5625 46.726562 11.046875 46.726562 C 10.53125 46.726562 10.089844 46.351562 10 45.84375 L 10 34.78125 C 10 34.210938 10.460938 33.75 11.03125 33.75 L 14.40625 33.75 C 15.925781 33.617188 17.390625 34.351562 18.191406 35.648438 C 18.992188 36.945312 18.992188 38.585938 18.191406 39.882812 C 17.390625 41.179688 15.925781 41.914062 14.40625 41.78125 Z M 12.09375 39.6875 L 14.40625 39.6875 C 15.152344 39.78125 15.882812 39.4375 16.289062 38.804688 C 16.691406 38.171875 16.691406 37.359375 16.289062 36.726562 C 15.882812 36.09375 15.152344 35.75 14.40625 35.84375 L 12.09375 35.84375 Z M 12.09375 39.6875 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 20.3125 45.84375 L 20.3125 34.78125 C 20.3125 34.210938 20.773438 33.75 21.34375 33.75 L 23.5625 33.75 C 27.1875 33.75 30.125 36.6875 30.125 40.3125 C 30.125 43.9375 27.1875 46.875 23.5625 46.875 L 21.34375 46.875 C 20.773438 46.875 20.3125 46.414062 20.3125 45.84375 Z M 22.40625 44.78125 L 23.5625 44.78125 C 26.03125 44.78125 28.03125 42.78125 28.03125 40.3125 C 28.03125 37.84375 26.03125 35.84375 23.5625 35.84375 L 22.40625 35.84375 Z M 22.40625 44.78125 "/>\n      <path style=" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;" d="M 33.1875 45.84375 L 33.1875 34.78125 C 33.183594 34.476562 33.3125 34.1875 33.542969 33.992188 C 33.769531 33.792969 34.074219 33.703125 34.375 33.75 L 40.625 33.75 C 41.132812 33.839844 41.507812 34.28125 41.507812 34.796875 C 41.507812 35.3125 41.132812 35.753906 40.625 35.84375 L 35.25 35.84375 L 35.25 39.28125 L 39.625 39.28125 C 40.195312 39.28125 40.65625 39.742188 40.65625 40.3125 C 40.65625 40.882812 40.195312 41.34375 39.625 41.34375 L 35.25 41.34375 L 35.25 45.84375 C 35.257812 46.359375 34.882812 46.796875 34.375 46.875 C 34.074219 46.921875 33.769531 46.832031 33.542969 46.632812 C 33.3125 46.4375 33.183594 46.148438 33.1875 45.84375 Z M 33.1875 45.84375 "/>\n      </g>'
    },
    defaultIcon: {
      extension: ".default",
      path: '<g id="surface1">\n      <path style=" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 3.117188 44.777344 C 1.394531 44.777344 0 43.386719 0 41.671875 L 0 3.484375 C 0 1.769531 1.394531 0.378906 3.117188 0.378906 L 25.792969 0.378906 C 27.164062 0.304688 28.5 0.808594 29.480469 1.765625 L 37.980469 10.230469 C 39.144531 11.242188 39.769531 12.730469 39.683594 14.265625 L 39.683594 41.671875 C 39.683594 43.386719 38.289062 44.777344 36.5625 44.777344 Z M 25.511719 3.203125 L 3.117188 3.203125 C 2.960938 3.203125 2.832031 3.328125 2.832031 3.484375 L 2.832031 41.671875 C 2.832031 41.828125 2.960938 41.957031 3.117188 41.957031 L 36.5625 41.957031 C 36.679688 41.949219 36.785156 41.867188 36.820312 41.757812 L 36.820312 14.492188 L 28.34375 14.492188 C 28.160156 14.539062 27.964844 14.539062 27.777344 14.492188 C 26.480469 14.15625 25.554688 13.007812 25.511719 11.671875 Z M 28.34375 4.640625 L 28.34375 11.671875 C 28.390625 11.683594 28.441406 11.683594 28.488281 11.671875 L 35.402344 11.671875 Z M 28.34375 4.640625 "/>\n      </g>'
    }
  }, xt.MODULES.modals = function (l) {
    var i = l.$;
    l.shared.modals || (l.shared.modals = {});
    var a, c = l.shared.modals;

    function e() {
      for (var e in c) if (Object.prototype.hasOwnProperty.call(c, e)) {
        var t = c[e];
        t && t.$modal && t.$modal.removeData().remove()
      }
      a && a.removeData().remove(), c = {}
    }

    function s(e, t) {
      if (c[e]) {
        var n = c[e].$modal, r = n.data("instance") || l;
        r.events.enableBlur(), n.hide(), a.hide(), i(r.o_doc).find("body").first().removeClass("fr-prevent-scroll fr-mobile"), n.removeClass("fr-active"), t || (r.accessibility.restoreSelection(), r.events.trigger("modals.hide"))
      }
    }

    function n(e) {
      var t;
      if ("string" == typeof e) {
        if (!c[e]) return;
        t = c[e].$modal
      } else t = e;
      return t && l.node.hasClass(t, "fr-active") && l.core.sameInstance(t) || !1
    }

    return {
      _init: function t() {
        l.events.on("shared.destroy", e, !0)
      }, get: function r(e) {
        return c[e]
      }, create: function d(n, e, t) {
        if (e = '<div class="fr-modal-head-line">'.concat(e, "</div>"), l.shared.$overlay || (l.shared.$overlay = i(l.doc.createElement("DIV")).addClass("fr-overlay"), i("body").first().append(l.shared.$overlay)), a = l.shared.$overlay, l.opts.theme && a.addClass("".concat(l.opts.theme, "-theme")), !c[n]) {
          var r = function o(e, t) {
            var n = '<div tabIndex="-1" class="fr-modal'.concat(l.opts.theme ? " ".concat(l.opts.theme, "-theme") : "", '"><div class="fr-modal-wrapper">'),
              r = '<button title="'.concat(l.language.translate("Cancel"), '" class="fr-command fr-btn fr-modal-close"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24"><path d="').concat(xt.SVG.close, '"/></svg></button>');
            n += '<div class="fr-modal-head">'.concat(e).concat(r, "</div>"), n += '<div tabIndex="-1" class="fr-modal-body">'.concat(t, "</div>"), n += "</div></div>";
            var a = i(l.doc.createElement("DIV"));
            return a.html(n), a.find("> .fr-modal")
          }(e, t);
          c[n] = {
            $modal: r,
            $head: r.find(".fr-modal-head"),
            $body: r.find(".fr-modal-body")
          }, l.helpers.isMobile() || r.addClass("fr-desktop"), i("body").first().append(r), l.events.$on(r, "click", ".fr-modal-close", function () {
            s(n)
          }, !0), c[n].$body.css("margin-top", c[n].$head.outerHeight()), l.events.$on(r, "keydown", function (e) {
            var t = e.which;
            return t === xt.KEYCODE.ESC ? (s(n), l.accessibility.focusModalButton(r), !1) : !(!i(e.currentTarget).is("input[type=text], textarea") && t !== xt.KEYCODE.ARROW_UP && t !== xt.KEYCODE.ARROW_DOWN && !l.keys.isBrowserAction(e) && (e.preventDefault(), e.stopPropagation(), 1))
          }, !0), s(n, !0)
        }
        return c[n]
      }, show: function o(e) {
        if (c[e]) {
          var t = c[e].$modal;
          t.data("instance", l), t.show(), a.show(), i(l.o_doc).find("body").first().addClass("fr-prevent-scroll"), l.helpers.isMobile() && i(l.o_doc).find("body").first().addClass("fr-mobile"), t.addClass("fr-active"), l.accessibility.focusModal(t)
        }
      }, hide: s, resize: function f(e) {
        if (c[e]) {
          var t = c[e], n = t.$modal, r = t.$body, a = l.o_win.innerHeight, o = n.find(".fr-modal-wrapper"),
            i = a - o.outerHeight(!0) + (o.height() - (r.outerHeight(!0) - r.height())), s = "auto";
          i < r.get(0).scrollHeight && (s = i), r.height(s)
        }
      }, isVisible: n, areVisible: function p(e) {
        for (var t in c) if (Object.prototype.hasOwnProperty.call(c, t) && n(t) && (void 0 === e || c[t].$modal.data("instance") === e)) return c[t].$modal;
        return !1
      }
    }
  }, xt.MODULES.position = function (E) {
    var y = E.$;

    function a() {
      var e = E.selection.ranges(0).getBoundingClientRect();
      if (0 === e.top && 0 === e.left && 0 === e.width || 0 === e.height) {
        var t = !1;
        0 === E.$el.find(".fr-marker").length && (E.selection.save(), t = !0);
        var n = E.$el.find(".fr-marker").first();
        n.css("display", "inline"), n.css("line-height", "");
        var r = n.offset(), a = n.outerHeight();
        n.css("display", "none"), n.css("line-height", 0), (e = {}).left = r && r.left, e.width = 0, e.height = a, e.top = r && r.top - (E.helpers.isMobile() && !E.helpers.isIOS() || E.opts.iframe ? 0 : E.helpers.scrollTop()), e.right = 1, e.bottom = 1, e.ok = !0, t && E.selection.restore()
      }
      return e
    }

    function o(e, t, n, r) {
      var a = n.data("container");
      if (!a || "BODY" === a.get(0).tagName && "static" === a.css("position") || (e && (e -= a.offset().left), t && (t -= a.offset().top), "BODY" !== a.get(0).tagName ? (e && (e += a.get(0).scrollLeft), t && (t += a.get(0).scrollTop)) : "absolute" === a.css("position") && (e && (e += a.position().left), t && (t += a.position().top))), E.opts.iframe && a && E.$tb && a.get(0) !== E.$tb.get(0)) {
        var o = E.helpers.getPX(E.$wp.find(".fr-iframe").css("padding-top")),
          i = E.helpers.getPX(E.$wp.find(".fr-iframe").css("padding-left"));
        e && (e += E.$iframe.offset().left + i), t && (t += E.$iframe.offset().top + o)
      }
      var s = function l(e, t) {
        var n = e.outerWidth(!0);
        return t + n > E.$sc.get(0).clientWidth - 10 && (t = E.$sc.get(0).clientWidth - n - 10), t < 0 && (t = 10), t
      }(n, e);
      e && n.css("left", s), t && n.css("top", function c(e, t, n) {
        var r = e.outerHeight(!0);
        if (!E.helpers.isMobile() && E.$tb && e.parent().get(0) !== E.$tb.get(0)) {
          var a = e.parent().offset().top, o = t - r - (n || 0);
          e.parent().get(0) === E.$sc.get(0) && (a -= e.parent().position().top);
          var i = E.$sc.get(0).clientHeight;
          a + t + r > E.$sc.offset().top + i && 0 < e.parent().offset().top + o && 0 < o ? o > E.$wp.scrollTop() && (t = o, e.addClass("fr-above")) : e.removeClass("fr-above")
        }
        return t
      }(n, t, r))
    }

    function i(e) {
      var n = y(e), t = n.is(".fr-sticky-on"), r = n.data("sticky-top"), a = n.data("sticky-scheduled");
      if (void 0 === r) {
        n.data("sticky-top", 0);
        var o = y('<div class="fr-sticky-dummy" style="height: '.concat(n.outerHeight(), 'px;"></div>'));
        E.$box.prepend(o)
      } else E.$box.find(".fr-sticky-dummy").css("height", n.outerHeight());
      if (E.core.hasFocus() || 0 < E.$tb.findVisible("input:focus").length) {
        var i = E.helpers.scrollTop(),
          s = Math.min(Math.max(i - E.$tb.parent().offset().top, 0), E.$tb.parent().outerHeight() - n.outerHeight());
        if (s !== r && s !== a && (clearTimeout(n.data("sticky-timeout")), n.data("sticky-scheduled", s), n.outerHeight() < i - E.$tb.parent().offset().top && n.addClass("fr-opacity-0"), n.data("sticky-timeout", setTimeout(function () {
          var e = E.helpers.scrollTop(),
            t = Math.min(Math.max(e - E.$tb.parent().offset().top, 0), E.$tb.parent().outerHeight() - n.outerHeight());
          0 < t && "BODY" === E.$tb.parent().get(0).tagName && (t += E.$tb.parent().position().top), t !== r && (n.css("top", Math.max(t, 0)), n.data("sticky-top", t), n.data("sticky-scheduled", t)), n.removeClass("fr-opacity-0")
        }, 100))), !t) {
          var l = E.$tb.parent(), c = l.get(0).offsetWidth - l.get(0).clientWidth;
          n.css("top", "0"), n.width(l.width() - c), n.addClass("fr-sticky-on"), E.$box.addClass("fr-sticky-box")
        }
      } else clearTimeout(y(e).css("sticky-timeout")), n.css("top", "0"), n.css("position", ""), n.css("width", ""), n.data("sticky-top", 0), n.removeClass("fr-sticky-on"), E.$box.removeClass("fr-sticky-box")
    }

    function t(e) {
      if (e.offsetWidth) {
        var t = y(e), n = t.outerHeight(), r = t.data("sticky-position"),
          a = y("body" === E.opts.scrollableContainer ? E.o_win : E.opts.scrollableContainer).outerHeight(), o = 0,
          i = 0;
        "body" !== E.opts.scrollableContainer && (o = E.$sc.offset().top, i = y(E.o_win).outerHeight() - o - a);
        var s = "body" === E.opts.scrollableContainer ? E.helpers.scrollTop() : o, l = t.is(".fr-sticky-on");
        t.data("sticky-parent") || t.data("sticky-parent", t.parent());
        var c = t.data("sticky-parent"), d = c.offset().top, f = c.outerHeight();
        if (t.data("sticky-offset") ? E.$box.find(".fr-sticky-dummy").css("height", "".concat(n, "px")) : (t.data("sticky-offset", !0), t.after('<div class="fr-sticky-dummy" style="height: '.concat(n, 'px;"></div>'))), !r) {
          var p = "auto" !== t.css("top") || "auto" !== t.css("bottom");
          p || t.css("position", "fixed"), r = {
            top: E.node.hasClass(t.get(0), "fr-top"),
            bottom: E.node.hasClass(t.get(0), "fr-bottom")
          }, p || t.css("position", ""), t.data("sticky-position", r), t.data("top", E.node.hasClass(t.get(0), "fr-top") ? t.css("top") : "auto"), t.data("bottom", E.node.hasClass(t.get(0), "fr-bottom") ? t.css("bottom") : "auto")
        }
        var u = E.helpers.getPX(t.data("top")), h = E.helpers.getPX(t.data("bottom")), g = r.top && function b() {
            return d < s + u && s + u <= d + f - n
          }() && (E.helpers.isInViewPort(E.$sc.get(0)) || "body" === E.opts.scrollableContainer),
          m = r.bottom && function C() {
            return d + n < s + a - h && s + a - h < d + f
          }();
        if (g || m) {
          var v = c.get(0).offsetWidth - c.get(0).clientWidth;
          t.css("width", "".concat(c.get(0).getBoundingClientRect().width - v, "px")), l || (t.addClass("fr-sticky-on"), t.removeClass("fr-sticky-off"), t.css("top") && ("auto" !== t.data("top") ? t.css("top", E.helpers.getPX(t.data("top")) + o) : t.data("top", "auto")), t.css("bottom") && ("auto" !== t.data("bottom") ? t.css("bottom", E.helpers.getPX(t.data("bottom")) + i) : t.css("bottom", "auto")))
        } else E.node.hasClass(t.get(0), "fr-sticky-off") || (t.css("width", ""), t.removeClass("fr-sticky-on"), t.addClass("fr-sticky-off"), t.css("top") && "auto" !== t.data("top") && r.top && t.css("top", 0), t.css("bottom") && "auto" !== t.data("bottom") && r.bottom && t.css("bottom", 0))
      }
    }

    function s() {
      if (E.helpers.requestAnimationFrame()(s), !1 !== E.events.trigger("position.refresh")) for (var e = 0; e < E._stickyElements.length; e++) if (E.opts.toolbarBottom) {
        var t = E.$tb.parent(), n = t.get(0).offsetWidth - t.get(0).clientWidth, r = y(E._stickyElements[e]);
        r.width(t.width() - n), r.addClass("fr-sticky-on"), E.$box.addClass("fr-sticky-box")
      } else i(E._stickyElements[e])
    }

    function n() {
      if (E._stickyElements) for (var e = 0; e < E._stickyElements.length; e++) t(E._stickyElements[e])
    }

    return {
      _init: function r() {
        !function e() {
          E._stickyElements = [], E.helpers.isIOS() ? (s(), E.events.$on(y(E.o_win), "scroll", function () {
            if (E.core.hasFocus()) for (var e = 0; e < E._stickyElements.length; e++) {
              var t = y(E._stickyElements[e]), n = t.parent(), r = E.helpers.scrollTop();
              t.outerHeight() < r - n.offset().top && (E.opts.toolbarBottom && E.helpers.isIOS() || (t.addClass("fr-opacity-0"), t.data("sticky-top", -1), t.data("sticky-scheduled", -1)))
            }
          }, !0)) : ("body" !== E.opts.scrollableContainer && E.events.$on(y(E.opts.scrollableContainer), "scroll", n, !0), E.events.$on(y(E.o_win), "scroll", n, !0), E.events.$on(y(E.o_win), "resize", n, !0), E.events.on("initialized", n), E.events.on("focus", n), E.events.$on(y(E.o_win), "resize", "textarea", n, !0)), E.events.on("destroy", function () {
            E._stickyElements = []
          })
        }()
      }, forSelection: function l(e) {
        var t = a();
        e.css({top: 0, left: 0});
        var n = t.top + t.height, r = t.left + t.width / 2 - e.get(0).offsetWidth / 2 + E.helpers.scrollLeft();
        E.opts.iframe || (n += E.helpers.scrollTop()), o(r, n, e, t.height)
      }, addSticky: function c(e) {
        e.addClass("fr-sticky"), E.helpers.isIOS() && !E.opts.toolbarBottom && e.addClass("fr-sticky-ios"), e.removeClass("fr-sticky"), E._stickyElements.push(e.get(0))
      }, refresh: n, at: o, getBoundingRect: a
    }
  }, xt.MODULES.refresh = function (l) {
    var c = l.$;

    function o(e, t) {
      e.toggleClass("fr-disabled", t).attr("aria-disabled", t)
    }

    function e(e) {
      var t = l.$tb.find('.fr-more-toolbar[data-name="'.concat(e.attr("data-group-name"), '"]')), n = function s(e, t) {
        var n = 0, r = t.find("> .fr-command, > .fr-btn-wrap");
        r.each(function (e, t) {
          n += c(t).outerWidth()
        });
        var a, o = l.helpers.getPX(c(r[0]).css("margin-left")), i = l.helpers.getPX(c(r[0]).css("margin-right"));
        a = "rtl" === l.opts.direction ? l.$tb.outerWidth() - e.offset().left + l.$tb.offset().left - (n + e.outerWidth() + r.length * (o + i)) / 2 : e.offset().left - l.$tb.offset().left - (n - e.outerWidth() + r.length * (o + i)) / 2;
        a + n + r.length * (o + i) > l.$tb.outerWidth() && (a -= (n + r.length * (o + i) - e.outerWidth()) / 2);
        a < 0 && (a = 0);
        return a
      }(e, t);
      "rtl" === l.opts.direction ? t.css("padding-right", n) : t.css("padding-left", n)
    }

    return {
      undo: function t(e) {
        o(e, !l.undo.canDo())
      }, redo: function n(e) {
        o(e, !l.undo.canRedo())
      }, outdent: function i(e) {
        if (l.node.hasClass(e.get(0), "fr-no-refresh")) return !1;
        if (c("button#markdown-".concat(l.id, ".fr-active")).length) return !1;
        for (var t = l.selection.blocks(), n = 0; n < t.length; n++) {
          var r = "rtl" === l.opts.direction || "rtl" === c(t[n]).css("direction") ? "margin-right" : "margin-left",
            a = t[0].parentElement;
          if ("P" != a.parentNode.tagName && "DIV" != a.parentNode.tagName && "UL" != a.parentNode.tagName && "OL" != a.parentNode.tagName && "LI" != a.parentNode.tagName) return o(e, !0), !0;
          if (t[0].previousSibling && "none" == a.parentNode.style.listStyleType) return o(e, !0), !0;
          if ("LI" === t[n].tagName || "LI" === t[n].parentNode.tagName) return o(e, !1), !0;
          if (0 < l.helpers.getPX(c(t[n]).css(r))) return o(e, !1), !0
        }
        o(e, !0)
      }, indent: function a(e) {
        if (l.node.hasClass(e.get(0), "fr-no-refresh")) return !1;
        if (c("button#markdown-".concat(l.id, ".fr-active")).length) return !1;
        for (var t = l.selection.blocks(), n = 0; n < t.length; n++) {
          for (var r = t[n].previousSibling; r && r.nodeType === Node.TEXT_NODE && 0 === r.textContent.length;) r = r.previousSibling;
          if ("LI" !== t[n].tagName || r) return o(e, !1), !0;
          o(e, !0)
        }
      }, moreText: e, moreParagraph: e, moreMisc: e, moreRich: e
    }
  }, Object.assign(xt.DEFAULTS, {
    attribution: !0,
    toolbarBottom: !1,
    toolbarButtons: null,
    toolbarButtonsXS: null,
    toolbarButtonsSM: null,
    toolbarButtonsMD: null,
    toolbarContainer: null,
    toolbarInline: !1,
    toolbarSticky: !0,
    toolbarStickyOffset: 0,
    toolbarVisibleWithoutSelection: !1
  }), xt.TOOLBAR_BUTTONS = {
    moreText: {buttons: ["bold", "italic", "underline", "strikeThrough", "subscript", "superscript", "fontFamily", "fontSize", "textColor", "backgroundColor", "inlineClass", "inlineStyle", "clearFormatting"]},
    moreParagraph: {buttons: ["alignLeft", "alignCenter", "formatOLSimple", "alignRight", "alignJustify", "formatOL", "formatUL", "paragraphFormat", "paragraphStyle", "lineHeight", "outdent", "indent", "quote"]},
    moreRich: {
      buttons: ["trackChanges", "markdown", "insertLink", "insertFiles", "insertImage", "insertVideo", "insertTable", "emoticons", "fontAwesome", "specialCharacters", "embedly", "insertFile", "insertHR"],
      buttonsVisible: 4
    },
    moreMisc: {
      buttons: ["undo", "redo", "fullscreen", "print", "getPDF", "spellChecker", "selectAll", "html", "help"],
      align: "right",
      buttonsVisible: 2
    },
    trackChanges: {buttons: ["showChanges", "applyAll", "removeAll", "applyLast", "removeLast"], buttonsVisible: 0}
  }, xt.TOOLBAR_BUTTONS_MD = null, (xt.TOOLBAR_BUTTONS_SM = {}).moreText = Object.assign({}, xt.TOOLBAR_BUTTONS.moreText, {buttonsVisible: 2}), xt.TOOLBAR_BUTTONS_SM.moreParagraph = Object.assign({}, xt.TOOLBAR_BUTTONS.moreParagraph, {buttonsVisible: 2}), xt.TOOLBAR_BUTTONS_SM.moreRich = Object.assign({}, xt.TOOLBAR_BUTTONS.moreRich, {buttonsVisible: 2}), xt.TOOLBAR_BUTTONS_SM.moreMisc = Object.assign({}, xt.TOOLBAR_BUTTONS.moreMisc, {buttonsVisible: 2}), xt.TOOLBAR_BUTTONS_SM.trackChanges = Object.assign({}, xt.TOOLBAR_BUTTONS.trackChanges, {buttonsVisible: 0}), (xt.TOOLBAR_BUTTONS_XS = {}).moreText = Object.assign({}, xt.TOOLBAR_BUTTONS.moreText, {buttonsVisible: 0}), xt.TOOLBAR_BUTTONS_XS.moreParagraph = Object.assign({}, xt.TOOLBAR_BUTTONS.moreParagraph, {buttonsVisible: 0}), xt.TOOLBAR_BUTTONS_XS.moreRich = Object.assign({}, xt.TOOLBAR_BUTTONS.moreRich, {buttonsVisible: 0}), xt.TOOLBAR_BUTTONS_XS.moreMisc = Object.assign({}, xt.TOOLBAR_BUTTONS.moreMisc, {buttonsVisible: 2}), xt.TOOLBAR_BUTTONS_XS.trackChanges = Object.assign({}, xt.TOOLBAR_BUTTONS.trackChanges, {buttonsVisible: 0}), xt.POWERED_BY = '<a id="fr-logo" href="https://froala.com/wysiwyg-editor" target="_blank" title="Froala WYSIWYG HTML Editor"><span>Powered by</span><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 822.8 355.33"><defs><style>.fr-logo{fill:#b1b2b7;}</style></defs><title>Froala</title><path class="fr-logo" d="M123.58,78.65A16.16,16.16,0,0,0,111.13,73H16.6C7.6,73,0,80.78,0,89.94V128.3a16.45,16.45,0,0,0,32.9,0V104.14h78.5A15.63,15.63,0,0,0,126.87,91.2,15.14,15.14,0,0,0,123.58,78.65Z"/><path class="fr-logo" d="M103.54,170a16.05,16.05,0,0,0-11.44-4.85H15.79A15.81,15.81,0,0,0,0,180.93v88.69a16.88,16.88,0,0,0,5,11.92,16,16,0,0,0,11.35,4.7h.17a16.45,16.45,0,0,0,16.41-16.6v-73.4H92.2A15.61,15.61,0,0,0,107.89,181,15.1,15.1,0,0,0,103.54,170Z"/><path class="fr-logo" d="M233,144.17c-5.29-6.22-16-7.52-24.14-7.52-16.68,0-28.72,7.71-36.5,23.47v-5.67a16.15,16.15,0,1,0-32.3,0v115.5a16.15,16.15,0,1,0,32.3,0v-38.7c0-19.09,3.5-63.5,35.9-63.5a44.73,44.73,0,0,1,5.95.27h.12c12.79,1.2,20.06-2.73,21.6-11.69C236.76,151.48,235.78,147.39,233,144.17Z"/><path class="fr-logo" d="M371.83,157c-13.93-13.11-32.9-20.33-53.43-20.33S279,143.86,265.12,157c-14.67,13.88-22.42,32.82-22.42,54.77,0,21.68,8,41.28,22.4,55.2,13.92,13.41,32.85,20.8,53.3,20.8s39.44-7.38,53.44-20.79c14.55-13.94,22.56-33.54,22.56-55.21S386.39,170.67,371.83,157Zm-9.73,54.77c0,25.84-18.38,44.6-43.7,44.6s-43.7-18.76-43.7-44.6c0-25.15,18.38-43.4,43.7-43.4S362.1,186.59,362.1,211.74Z"/><path class="fr-logo" d="M552.7,138.14a16.17,16.17,0,0,0-16,16.3v1C526.41,143.85,509,136.64,490,136.64c-19.83,0-38.19,7.24-51.69,20.4C424,171,416.4,190,416.4,212c0,21.61,7.78,41.16,21.9,55,13.56,13.33,31.92,20.67,51.7,20.67,18.83,0,36.29-7.41,46.7-19.37v1.57a16.15,16.15,0,1,0,32.3,0V154.44A16.32,16.32,0,0,0,552.7,138.14Zm-16.3,73.6c0,30.44-22.81,44.3-44,44.3-24.57,0-43.1-19-43.1-44.3s18.13-43.4,43.1-43.4C513.73,168.34,536.4,183.55,536.4,211.74Z"/><path class="fr-logo" d="M623.5,61.94a16.17,16.17,0,0,0-16,16.3v191.7a16.15,16.15,0,1,0,32.3,0V78.24A16.32,16.32,0,0,0,623.5,61.94Z"/><path class="fr-logo" d="M806.5,138.14a16.17,16.17,0,0,0-16,16.3v1c-10.29-11.63-27.74-18.84-46.7-18.84-19.83,0-38.19,7.24-51.69,20.4-14.33,14-21.91,33-21.91,55,0,21.61,7.78,41.16,21.9,55,13.56,13.33,31.92,20.67,51.7,20.67,18.83,0,36.29-7.41,46.7-19.37v1.57a16.15,16.15,0,1,0,32.3,0V154.44A16.32,16.32,0,0,0,806.5,138.14Zm-16.3,73.6c0,30.44-22.81,44.3-44,44.3-24.57,0-43.1-19-43.1-44.3s18.13-43.4,43.1-43.4C767.53,168.34,790.2,183.55,790.2,211.74Z"/></svg></a>', xt.MODULES.toolbar = function (y) {
    var L, _ = y.$, t = [];

    function e(e) {
      var n = {};
      if (Array.isArray(e)) {
        if (!Array.isArray(e[0])) {
          for (var t = [], r = [], a = 0; a < e.length; a++) "|" === e[a] || "-" === e[a] ? (0 < r.length && t.push(r), r = []) : r.push(e[a]);
          0 < r.length && t.push(r), e = t
        }
        e.forEach(function (e, t) {
          n["group".concat(t + 1)] = {buttons: e}
        }), n.showMoreButtons = !1
      } else "object" !== kt(e) || Array.isArray(e) || ((n = e).showMoreButtons = !0);
      return n
    }

    function w() {
      var e = y.helpers.screenSize();
      return t[L = e]
    }

    function A() {
      for (var e = y.$tb.find(".fr-more-toolbar"), t = 0; t < e.length; t++) {
        var c = _(e[t]);
        c.hasClass("fr-expanded") ? function () {
          var n = y.helpers.getPX(c.css("padding-left")), e = c.find("> .fr-command, > .fr-btn-wrap"), t = _(e[0]),
            r = y.helpers.getPX(t.css("margin-left")), a = y.helpers.getPX(t.css("margin-right")),
            o = y.helpers.getPX(t.css("margin-top")), i = y.helpers.getPX(t.css("margin-bottom"));
          if (e.each(function (e, t) {
            n += _(t).outerWidth() + r + a
          }), y.$tb.outerWidth() < n) {
            var s = Math.floor(n / y.$tb.outerWidth());
            n += s * (n / c[0].childElementCount), s = Math.ceil(n / y.$tb.outerWidth());
            var l = (y.helpers.getPX(t.css("height")) + o + i) * s;
            c.css("height", l)
          }
        }() : c.css("height", "")
      }
      !y.helpers.isMobile() && y.opts.toolbarBottom ? y.$tb.find(".fr-toolbar .fr-more-toolbar").removeClass("position-relative") : y.$tb.find(".fr-toolbar .fr-more-toolbar").addClass("position-relative")
    }

    function r() {
      if (0 == _("[data-name='trackChanges-".concat(y.id, "']")).length) {
        _(".fr-toolbar").append(_('<div class="fr-more-toolbar"></div>').data("name", "trackChanges-".concat(y.id)));
        for (var e = 0, t = ["showChanges", "applyAll", "removeAll", "applyLast", "removeLast"]; e < t.length; e++) {
          var n = t[e], r = xt.COMMANDS[n];
          if (r) {
            r.more_btn = !0;
            var a = _(y.button.build(n, r, !0));
            y.button.addButtons(a), _("[data-name='trackChanges-".concat(y.id, "']")).append(a)
          }
        }
      }
      if (L !== y.helpers.screenSize()) {
        var o = w(), i = _(), s = _();
        for (var l in y.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command, .fr-btn-grp > .fr-btn-wrap > .fr-command, .fr-more-toolbar > .fr-btn-wrap > .fr-command").addClass("fr-hidden"), function E() {
          for (var t = y.$tb.find(".fr-btn-grp, .fr-more-toolbar"), r = function r(e) {
            var n = _(t[e]);
            n.children().each(function (e, t) {
              n.before(t)
            }), n.remove()
          }, e = 0; e < t.length; e++) r(e)
        }(), o) {
          var c = o[l];
          if (c.buttons) {
            var d = void 0, f = 0, p = 3, u = void 0;
            "trackChanges" !== l && (u = _('<div class="fr-btn-grp fr-float-'.concat(o[l].align ? o[l].align : "left", '"></div>'))), o.showMoreButtons && (d = _('<div class="fr-more-toolbar"></div>').data("name", "".concat(l, "-").concat(y.id)), "trackChanges" !== l && "moreRich" !== l || !y.opts.trackChangesEnabled || d.addClass("fr-expanded"));
            for (var h = 0; h < c.buttons.length; h++) {
              c.buttonsVisible !== undefined && (p = c.buttonsVisible);
              var g = y.$tb.find('> .fr-command[data-cmd="' + c.buttons[h] + '"], > div.fr-btn-wrap > .fr-command[data-cmd="' + c.buttons[h] + '"]'),
                m = null;
              y.node.hasClass(g.next().get(0), "fr-dropdown-menu") && (m = g.next()), y.node.hasClass(g.next().get(0), "fr-options") && (g.removeClass("fr-hidden"), g.next().removeClass("fr-hidden"), g = g.parent()), g.removeClass("fr-hidden"), o.showMoreButtons && p <= f ? (d.append(g), m && d.append(m)) : (u.append(g), m && u.append(m)), f++
            }
            if (o.showMoreButtons && p < f) {
              var v = y.$tb.find('.fr-command[data-cmd="'.concat(l, '"]'));
              if (0 < v.length) v.removeClass("fr-hidden fr-open"); else {
                var b = l, C = xt.COMMANDS[b];
                C.more_btn = !0, v = _(y.button.build(b, C, !0)), y.button.addButtons(v)
              }
              u && u.append(v)
            }
            u && i.push(u), o.showMoreButtons && s.push(d)
          }
        }
        y.opts.toolbarBottom ? (y.$tb.append(s), y.$tb.find(".fr-newline").remove(), y.$tb.append('<div class="fr-newline"></div>'), y.$tb.append(i)) : (y.$tb.append(i), y.$tb.find(".fr-newline").remove(), y.$tb.append('<div class="fr-newline"></div>'), y.$tb.append(s)), y.$tb.removeClass("fr-toolbar-open"), y.$box.removeClass("fr-toolbar-open"), y.events.trigger("codeView.toggle")
      }
      A()
    }

    function n(e, t) {
      setTimeout(function () {
        if ((!e || e.which != xt.KEYCODE.ESC) && y.selection.inEditor() && y.core.hasFocus() && !y.popups.areVisible() && "false" != _(y.selection.blocks()[0]).closest("table").attr("contenteditable") && (y.opts.toolbarVisibleWithoutSelection || !y.selection.isCollapsed() && !y.keys.isIME() || t)) {
          if (y.$tb.data("instance", y), !1 === y.events.trigger("toolbar.show", [e])) return;
          y.$tb.show(), y.opts.toolbarContainer || y.position.forSelection(y.$tb), 1 < y.opts.zIndex ? y.$tb.css("z-index", y.opts.zIndex + 1) : y.$tb.css("z-index", null)
        }
      }, 0)
    }

    function a(e) {
      return (!e || "blur" !== e.type || document.activeElement !== y.el) && (!(!e || "keydown" !== e.type || !y.keys.ctrlKey(e)) || (!!y.button.getButtons(".fr-dropdown.fr-active").next().find(y.o_doc.activeElement).length || (y.helpers.isMobile() && y.opts.toolbarInline && (y.$tb.find(".fr-expanded").toggleClass("fr-expanded"), y.$tb.find(".fr-open").removeClass("fr-open"), y.$tb.removeClass("fr-toolbar-open"), A()), void (!1 !== y.events.trigger("toolbar.hide") && y.$tb.hide()))))
    }

    t[xt.XS] = e(y.opts.toolbarButtonsXS || y.opts.toolbarButtons || xt.TOOLBAR_BUTTONS_XS || xt.TOOLBAR_BUTTONS || []), t[xt.SM] = e(y.opts.toolbarButtonsSM || y.opts.toolbarButtons || xt.TOOLBAR_BUTTONS_SM || xt.TOOLBAR_BUTTONS || []), t[xt.MD] = e(y.opts.toolbarButtonsMD || y.opts.toolbarButtons || xt.TOOLBAR_BUTTONS_MD || xt.TOOLBAR_BUTTONS || []), t[xt.LG] = e(y.opts.toolbarButtons || xt.TOOLBAR_BUTTONS || []);
    var o = null;

    function i(e) {
      clearTimeout(o), e && e.which === xt.KEYCODE.ESC || (o = setTimeout(n, y.opts.typingTimer))
    }

    function s() {
      y.events.on("window.mousedown", a), y.events.on("keydown", a), y.events.on("blur", a), y.events.$on(y.$tb, "transitionend", ".fr-more-toolbar", function () {
        y.position.forSelection(y.$tb)
      }), y.helpers.isMobile() || y.events.on("window.mouseup", n), y.helpers.isMobile() ? y.helpers.isIOS() || (y.events.on("window.touchend", n), y.browser.mozilla && setInterval(n, 200)) : y.events.on("window.keyup", i), y.events.on("keydown", function (e) {
        e && e.which === xt.KEYCODE.ESC && y.events.trigger("toolbar.esc")
      }), y.events.on("keydown", function (e) {
        if (e.which === xt.KEYCODE.ALT) return e.stopPropagation(), !1
      }, !0), y.events.$on(y.$wp, "scroll.toolbar", n), y.events.on("commands.after", n), y.helpers.isMobile() && (y.events.$on(y.$doc, "selectionchange", i), y.events.$on(y.$doc, "orientationchange", n))
    }

    function l() {
      y.$tb.html("").removeData().remove(), y.$tb = null, y.$second_tb && (y.$second_tb.html("").removeData().remove(), y.$second_tb = null)
    }

    function c() {
      y.$box.removeClass("fr-top fr-bottom fr-inline fr-basic"), y.$box.find(".fr-sticky-dummy").remove()
    }

    function d() {
      y.opts.theme && y.$tb.addClass("".concat(y.opts.theme, "-theme")), 1 < y.opts.zIndex && y.$tb.css("z-index", y.opts.zIndex + 1), "auto" !== y.opts.direction && y.$tb.removeClass("fr-ltr fr-rtl").addClass("fr-".concat(y.opts.direction)), y.helpers.isMobile() ? y.$tb.addClass("fr-mobile") : y.$tb.addClass("fr-desktop"), y.opts.toolbarContainer ? (y.opts.toolbarInline && (s(), a()), y.opts.toolbarBottom ? y.$tb.addClass("fr-bottom") : y.$tb.addClass("fr-top")) : function e() {
        y.opts.toolbarInline ? (y.$sc.append(y.$tb), y.$tb.data("container", y.$sc), y.$tb.addClass("fr-inline"), s(), y.opts.toolbarBottom = !1) : (y.opts.toolbarBottom ? (y.$box.append(y.$tb), y.$tb.addClass("fr-bottom"), y.$box.addClass("fr-bottom")) : (y.opts.toolbarBottom = !1, y.$box.prepend(y.$tb), y.$tb.addClass("fr-top"), y.$box.addClass("fr-top")), y.$tb.addClass("fr-basic"), y.opts.toolbarSticky && (y.opts.toolbarStickyOffset && (y.opts.toolbarBottom ? y.$tb.css("bottom", y.opts.toolbarStickyOffset) : y.$tb.css("top", y.opts.toolbarStickyOffset)), y.position.addSticky(y.$tb)))
      }(), function t() {
        var e = y.button.buildGroup(w());
        y.$tb.append(e), A(), y.button.bindCommands(y.$tb)
      }(), function n() {
        y.events.$on(_(y.o_win), "resize", r), y.events.$on(_(y.o_win), "orientationchange", r), y.opts.toolbarButtons && -1 < y.opts.toolbarButtons.indexOf("trackChanges") && r()
      }(), y.accessibility.registerToolbar(y.$tb), y.events.$on(y.$tb, "".concat(y._mousedown, " ").concat(y._mouseup), function (e) {
        var t = e.originalEvent ? e.originalEvent.target || e.originalEvent.originalTarget : null;
        if (t && "INPUT" !== t.tagName && !y.edit.isDisabled()) return e.stopPropagation(), e.preventDefault(), !1
      }, !0), y.events.$on(y.$tb, "transitionend", ".fr-more-toolbar", function () {
        y.$box.hasClass("fr-fullscreen") && (y.opts.height = y.o_win.innerHeight - (y.opts.toolbarInline ? 0 : y.$tb.outerHeight() + (y.$second_tb ? y.$second_tb.outerHeight() : 0)), y.size.refresh())
      })
    }

    var f = !1;
    return {
      _init: function p() {
        if (y.$sc = _(y.opts.scrollableContainer).first(), !y.$wp) return !1;
        y.opts.toolbarInline || y.opts.toolbarBottom || (y.$second_tb = _(y.doc.createElement("div")).attr("class", "fr-second-toolbar"), y.$box.append(y.$second_tb), (!1 !== y.ul || y.opts.attribution) && y.$second_tb.prepend(xt.POWERED_BY)), y.opts.toolbarContainer ? (y.shared.$tb ? (y.$tb = y.shared.$tb, y.opts.toolbarInline && s()) : (y.shared.$tb = _(y.doc.createElement("DIV")), y.shared.$tb.addClass("fr-toolbar"), y.$tb = y.shared.$tb, _(y.opts.toolbarContainer).append(y.$tb), d(), y.$tb.data("instance", y)), y.helpers.isMobile() && y.events.$on(y.$tb, "click", function () {
          y.popups.areVisible().length || y.id !== y.shared.selected_editor || y.$el.focus()
        }), y.opts.toolbarInline ? y.$box.addClass("fr-inline") : y.$box.addClass("fr-basic"), y.events.on("focus", function () {
          y.$tb.data("instance", y)
        }, !0), y.opts.toolbarInline = !1) : y.opts.toolbarInline ? (y.$box.addClass("fr-inline"), y.shared.$tb ? (y.$tb = y.shared.$tb, s()) : (y.shared.$tb = _(y.doc.createElement("DIV")), y.shared.$tb.addClass("fr-toolbar"), y.$tb = y.shared.$tb, d())) : (y.$box.addClass("fr-basic"), y.$tb = _(y.doc.createElement("DIV")), y.$tb.addClass("fr-toolbar"), d(), y.$tb.data("instance", y)), y.events.on("destroy", c, !0), y.events.on(y.opts.toolbarInline || y.opts.toolbarContainer ? "shared.destroy" : "destroy", l, !0), y.events.on("edit.on", function () {
          y.$tb.removeClass("fr-disabled").removeAttr("aria-disabled")
        }), y.events.on("edit.off", function () {
          y.$tb.addClass("fr-disabled").attr("aria-disabled", !0)
        }), function e() {
          y.events.on("shortcut", function (e, t, n) {
            var r;
            if (t && !n ? r = y.$tb.find('.fr-command[data-cmd="'.concat(t, '"]')) : t && n && (r = y.$tb.find('.fr-command[data-cmd="'.concat(t, '"][data-param1="').concat(n, '"]'))), r.length && (e.preventDefault(), e.stopPropagation(), r.parents(".fr-toolbar").data("instance", y), "keydown" === e.type)) return y.button.exec(r), !1
          })
        }()
      }, hide: a, show: function u() {
        if (!1 === y.events.trigger("toolbar.show")) return !1;
        y.$tb.show()
      }, showInline: n, disable: function h() {
        !f && y.$tb && (y.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command").addClass("fr-disabled fr-no-refresh").attr("aria-disabled", !0), f = !0)
      }, enable: function g() {
        f && y.$tb && (y.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command").removeClass("fr-disabled fr-no-refresh").attr("aria-disabled", !1), f = !1), y.button.bulkRefresh()
      }, setMoreToolbarsHeight: A
    }
  };
  var c = ["scroll", "wheel", "touchmove", "touchstart", "touchend"], d = ["webkit", "moz", "ms", "o"],
    f = ["transitionend"], a = document.createElement("div").style, o = ["Webkit", "Moz", "ms", "O", "css", "style"],
    s = {visibility: "hidden", display: "block"}, r = ["focus", "blur", "click"], i = {}, l = function l(e, t) {
      return {
        altKey: e.altKey,
        bubbles: e.bubbles,
        cancelable: e.cancelable,
        changedTouches: e.changedTouches,
        ctrlKey: e.ctrlKey,
        detail: e.detail,
        eventPhase: e.eventPhase,
        metaKey: e.metaKey,
        pageX: e.pageX,
        pageY: e.pageY,
        shiftKey: e.shiftKey,
        view: e.view,
        "char": e["char"],
        key: e.key,
        keyCode: e.keyCode,
        button: e.button,
        buttons: e.buttons,
        clientX: e.clientX,
        clientY: e.clientY,
        offsetX: e.offsetX,
        offsetY: e.offsetY,
        pointerId: e.pointerId,
        pointerType: e.pointerType,
        screenX: e.screenX,
        screenY: e.screenY,
        targetTouches: e.targetTouches,
        toElement: e.toElement,
        touches: e.touches,
        type: e.type,
        which: e.which,
        target: e.target,
        currentTarget: t,
        originalEvent: e,
        stopPropagation: function () {
          e.stopPropagation()
        },
        stopImmediatePropagation: function () {
          e.stopImmediatePropagation()
        },
        preventDefault: function () {
          -1 === c.indexOf(e.type) && e.preventDefault()
        }
      }
    }, p = function p(e) {
      return e.ownerDocument && e.ownerDocument.body.contains(e) || "#document" === e.nodeName || "HTML" === e.nodeName || e === window
    }, u = function u(n, r) {
      return function (e) {
        var t = e.target;
        if (r) for (r = g(r); t && t !== this;) Element.prototype.matches.call(t, g(r)) && n.call(t, l(e, t)), t = t.parentNode; else p(t) && n.call(t, l(e, t))
      }
    }, h = function h(e, t) {
      return new b(e, t)
    }, g = function g(e) {
      return e && "string" == typeof e ? e.replace(/^\s*>/g, ":scope >").replace(/,\s*>/g, ", :scope >") : e
    }, m = function m(e) {
      return "function" == typeof e && "number" != typeof e.nodeType
    }, v = h;
  h.fn = h.prototype = {
    constructor: h, length: 0, contains: function (e) {
      if (!e) return !1;
      if (Array.isArray(e)) {
        for (var t = 0; t < e.length; t++) if (this.contains(e[t]) && this != e[t]) return !0;
        return !1
      }
      for (var n = 0; n < this.length; n++) for (var r = e; r;) {
        if (r == this[n] || r[0] && r[0].isEqualNode(this[n])) return !0;
        r = r.parentNode
      }
      return !1
    }, findVisible: function (e) {
      for (var t = this.find(e), n = t.length - 1; 0 <= n; n--) v(t[n]).isVisible() || t.splice(n, 1);
      return t
    }, formatParams: function (t) {
      var e = "".concat(Object.keys(t).map(function (e) {
        return "".concat(e, "=").concat(encodeURIComponent(t[e]))
      }).join("&"));
      return e || ""
    }, ajax: function (t) {
      var n = new XMLHttpRequest, e = this.formatParams(t.data);
      for (var r in "GET" === t.method.toUpperCase() && (t.url = e ? t.url + "?" + e : t.url), n.open(t.method, t.url, !0), t.withCredentials && (n.withCredentials = !0), t.crossDomain && n.setRequestHeader("Access-Control-Allow-Origin", "*"), t.headers) Object.prototype.hasOwnProperty.call(t.headers, r) && n.setRequestHeader(r, t.headers[r]);
      Object.prototype.hasOwnProperty.call(t.headers, "Content-Type") || ("json" === t.dataType ? n.setRequestHeader("Content-Type", "application/json") : n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8")), n.onload = function () {
        if (200 == n.status) {
          var e = n.responseText;
          "json" === t.dataType && (e = JSON.parse(e)), t.done(e, n.status, n)
        } else t.fail(n)
      }, n.send(e)
    }, prevAll: function () {
      var e = v();
      if (!this[0]) return e;
      for (var t = this[0]; t && t.previousSibling;) t = t.previousSibling, e.push(t);
      return e
    }, index: function (e) {
      return e ? "string" == typeof e ? [].indexOf.call(v(e), this[0]) : [].indexOf.call(this, e.length ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
    }, isVisible: function () {
      return !!this[0] && !!(this[0].offsetWidth || this[0].offsetHeight || this[0].getClientRects().length)
    }, toArray: function () {
      return [].slice.call(this)
    }, get: function (e) {
      return null == e ? [].slice.call(this) : e < 0 ? this[e + this.length] : this[e]
    }, pushStack: function (e) {
      var t = h.merge(this.constructor(), e);
      return t.prevObject = this, t
    }, wrapAll: function (e) {
      var t;
      return this[0] && (m(e) && (e = e.call(this[0])), t = h(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
        for (var e = this; e.firstElementChild;) e = e.firstElementChild;
        return e
      }).append(this)), this
    }, wrapInner: function (e) {
      if ("string" == typeof e) {
        for (var t = e.split(" "), n = 0; n < t.length && 0 === t[n].trim().length;) n++;
        if (n < t.length && (v(e).length && t[n].trim() === v(e)[0].tagName && (e = document.createElement(t[n].trim())), n++), "string" != typeof e) for (var r = v(e); n < t.length; n++) {
          t[n] = t[n].trim();
          var a = t[n].split("=");
          r.attr(a[0], a[1].replace('"', ""))
        }
      }
      for (; this[0].firstChild && this[0].firstChild !== e && "string" != typeof e;) e.appendChild(this[0].firstChild)
    }, wrap: function (t) {
      var n = m(t);
      return this.each(function (e) {
        v(this).wrapAll(n ? t.call(this, e) : t)
      })
    }, unwrap: function () {
      return this.parent().each(function () {
        this.nodeName && this.nodeName.toLowerCase() === name.toLowerCase() || h(this).replaceWith(this.childNodes)
      })
    }, grep: function (e, t, n) {
      for (var r = [], a = 0, o = e.length, i = !n; a < o; a++) !t(e[a], a) !== i && r.push(e[a]);
      return r
    }, map: function (n) {
      return this.pushStack(h.map(this, function (e, t) {
        return n.call(e, t, e)
      }))
    }, slice: function () {
      return this.pushStack([].slice.apply(this, arguments))
    }, each: function (e) {
      if (this.length) for (var t = 0; t < this.length && !1 !== e.call(this[t], t, this[t]); t++) ;
      return this
    }, first: function () {
      return this.eq(0)
    }, last: function () {
      return this.eq(-1)
    }, eq: function (e) {
      var t = this.length, n = +e + (e < 0 ? t : 0);
      return this.pushStack(0 <= n && n < t ? [this[n]] : [])
    }, empty: function () {
      for (var e = 0; e < this.length; e++) this[e].innerHTML = ""
    }, contents: function () {
      for (var e = v(), t = 0; t < this.length; t++) for (var n = this[t].childNodes, r = 0; r < n.length; r++) e.push(n[r]);
      return e
    }, attr: function (e, t) {
      if ("object" === kt(e)) {
        for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && null !== e[n] && this.attr(n, e[n]);
        return this
      }
      if (void 0 === t) return 0 === this.length || !this[0].getAttribute && "checked" !== e ? undefined : "checked" === e ? this[0].checked : "tagName" === e ? this[0].tagName : this[0].getAttribute(e);
      if ("checked" === e) for (var r = 0; r < this.length; r++) this[r].checked = t; else if ("tagName" === e) for (var a = 0; a < this.length; a++) this[a].tagName = t; else for (var o = 0; o < this.length; o++) this[o].setAttribute(e, t);
      return this
    }, removeAttr: function (e) {
      for (var t = 0; t < this.length; t++) this[t].removeAttribute && this[t].removeAttribute(e);
      return this
    }, hide: function () {
      return this.css("display", "none"), this
    }, show: function () {
      return this.css("display", "block"), this
    }, focus: function () {
      return this.length && this[0].focus(), this
    }, blur: function () {
      return this.length && this[0].blur(), this
    }, data: function (e, t) {
      if (void 0 !== t) {
        for (var n = 0; n < this.length; n++) "object" !== kt(this[n]["data-" + e] = t) && "function" != typeof t && this[n].setAttribute && this[n].setAttribute("data-" + e, t);
        return this
      }
      if (void 0 !== t) return this.attr("data-" + e, t);
      if (0 === this.length) return undefined;
      for (var r = 0; r < this.length; r++) {
        var a = this[r]["data-" + e];
        if (null == a && this[r].getAttribute && (a = this[r].getAttribute("data-" + e)), void 0 !== a && null != a) return a
      }
      return undefined
    }, removeData: function (e) {
      for (var t = 0; t < this.length; t++) this[t].removeAttribute && this[t].removeAttribute("data-" + e), this[t]["data-" + e] = null;
      return this
    }, getCorrectStyleName: function (e) {
      if (!i[e]) {
        var t;
        e in a && (t = e);
        for (var n = e[0].toUpperCase() + e.slice(1), r = o.length; r--;) (e = o[r] + n) in a && (t = e);
        i[e] = t
      }
      return i[e]
    }, css: function (e, t) {
      if (void 0 !== t) {
        if (0 === this.length) return this;
        ("string" != typeof t || "" === t.trim() || isNaN(t)) && "number" != typeof t || !/(margin)|(padding)|(height)|(width)|(top)|(left)|(right)|(bottom)/gi.test(e) || /(line-height)/gi.test(e) || (t += "px");
        for (var n = 0; n < this.length; n++) e = v(this).getCorrectStyleName(e), this[n].style[e] = t;
        return this
      }
      if ("string" == typeof e) {
        if (0 === this.length) return undefined;
        var r = this[0].ownerDocument || document, a = r.defaultView || r.parentWindow;
        return e = v(this).getCorrectStyleName(e), a.getComputedStyle(this[0])[e]
      }
      for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && this.css(o, e[o]);
      return this
    }, toggleClass: function (e, t) {
      if (1 < e.split(" ").length) {
        for (var n = e.split(" "), r = 0; r < n.length; r++) this.toggleClass(n[r], t);
        return this
      }
      for (var a = 0; a < this.length; a++) void 0 === t ? this[a].classList.contains(e) ? this[a].classList.remove(e) : this[a].classList.add(e) : t ? this[a].classList.contains(e) || this[a].classList.add(e) : this[a].classList.contains(e) && this[a].classList.remove(e);
      return this
    }, addClass: function (e) {
      if (0 === e.length) return this;
      if (1 < e.split(" ").length) {
        for (var t = e.split(" "), n = 0; n < t.length; n++) this.addClass(t[n]);
        return this
      }
      for (var r = 0; r < this.length; r++) this[r].classList.add(e);
      return this
    }, removeClass: function (e) {
      if (1 < e.split(" ").length) {
        for (var t = e.split(" "), n = 0; n < t.length; n++) t[n] = t[n].trim(), t[n].length && this.removeClass(t[n]);
        return this
      }
      for (var r = 0; r < this.length; r++) e.length && this[r].classList.remove(e);
      return this
    }, getClass: function (e) {
      return e.getAttribute && e.getAttribute("class") || ""
    }, stripAndCollapse: function (e) {
      return (e.match(/[^\x20\t\r\n\f]+/g) || []).join(" ")
    }, hasClass: function (e) {
      var t, n, r = 0;
      for (t = " " + e + " "; n = this[r++];) if (1 === n.nodeType && -1 < (" " + v(this).stripAndCollapse(v(this).getClass(n)) + " ").indexOf(t)) return !0;
      return !1
    }, scrollTop: function (e) {
      if (void 0 === e) return 0 === this.length ? undefined : this[0] === document ? document.documentElement.scrollTop : this[0].scrollTop;
      for (var t = 0; t < this.length; t++) this[t] === document ? window.scrollTo(document.documentElement.scrollLeft, e) : this[t].scrollTop = e
    }, scrollLeft: function (e) {
      if (void 0 === e) return 0 === this.length ? undefined : this[0] === document ? document.documentElement.scrollLeft : this[0].scrollLeft;
      for (var t = 0; t < this.length; t++) this[t] === document ? window.scrollTo(e, document.documentElement.scrollTop) : this[t].scrollLeft = e
    }, on: function (e, t, n) {
      if (1 < e.split(" ").length) {
        for (var r = e.split(" "), a = 0; a < r.length; a++) if (-1 !== f.indexOf(e)) for (var o = 0; o < d.length; o++) this.on(d[o] + e[0].toUpperCase() + e.slice(1), t, n); else this.on(r[a], t, n);
        return this
      }
      n = "function" == typeof t ? u(t, null) : u(n, t);
      for (var i = 0; i < this.length; i++) {
        var s = v(this[i]);
        s.data("events") || s.data("events", []), s.data("events").push([e, n]);
        var l = e.split(".");
        l = l[0], 0 <= c.indexOf(l) ? s.get(0).addEventListener(l, n, {passive: !0}) : s.get(0).addEventListener(l, n)
      }
    }, off: function (e) {
      if (1 < e.split(" ").length) {
        for (var t = e.split(" "), n = 0; n < t.length; n++) this.off(t[n]);
        return this
      }
      for (var r = 0; r < this.length; r++) {
        var a = v(this[r]);
        if (a.data("events")) {
          var o = e.split(".");
          o = o[0];
          for (var i = a.data("events") || [], s = i.length - 1; 0 <= s; s--) {
            var l = i[s];
            l[0] == e && (a.get(0).removeEventListener(o, l[1]), i.splice(s, 1))
          }
        }
      }
    }, trigger: function (e) {
      for (var t = 0; t < this.length; t++) {
        var n = void 0;
        "function" == typeof Event ? n = 0 <= e.search(/^mouse/g) ? new MouseEvent(e, {
          view: window,
          cancelable: !0,
          bubbles: !0
        }) : new Event(e) : 0 <= e.search(/^mouse/g) ? (n = document.createEvent("MouseEvents")).initMouseEvent(e, !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null) : (n = document.createEvent("Event")).initEvent(e, !0, !0), 0 <= r.indexOf(e) && "function" == typeof this[t][e] ? this[t][e]() : this[t].dispatchEvent(n)
      }
    }, triggerHandler: function () {
    }, val: function (e) {
      if (void 0 === e) return this[0].value;
      for (var t = 0; t < this.length; t++) this[t].value = e;
      return this
    }, siblings: function () {
      return v(this[0]).parent().children().not(this)
    }, find: function (e) {
      var t = v();
      if ("string" != typeof e) {
        for (var n = 0; n < e.length; n++) for (var r = 0; r < this.length; r++) if (this[r] !== e[n] && v(this[r]).contains(e[n])) {
          t.push(e[n]);
          break
        }
        return t
      }
      var a = function a(e) {
        return "object" === ("undefined" == typeof HTMLElement ? "undefined" : kt(HTMLElement)) ? e instanceof HTMLElement : e && "object" === kt(e) && null !== e && 1 === e.nodeType && "string" == typeof e.nodeName
      };
      e = g(e);
      for (var o = 0; o < this.length; o++) if (this[o].querySelectorAll) {
        var i = [];
        if (e && "string" == typeof e) try {
          i = this[o].querySelectorAll(e)
        } catch (l) {
          i = this[o].children
        } else a(e) && (i = [e]);
        for (var s = 0; s < i.length; s++) t.push(i[s])
      }
      return t
    }, children: function () {
      for (var e = v(), t = 0; t < this.length; t++) for (var n = this[t].children, r = 0; r < n.length; r++) e.push(n[r]);
      return e
    }, not: function (e) {
      if ("string" == typeof e) for (var t = this.length - 1; 0 <= t; t--) Element.prototype.matches.call(this[t], e) && this.splice(t, 1); else if (e instanceof h) {
        for (var n = this.length - 1; 0 <= n; n--) for (var r = 0; r < e.length; r++) if (this[n] === e[r]) {
          this.splice(n, 1);
          break
        }
      } else for (var a = this.length - 1; 0 <= a; a--) this[a] === e[0] && this.splice(a, 1);
      return this
    }, add: function (e) {
      for (var t = 0; t < e.length; t++) this.push(e[t]);
      return this
    }, closest: function (e) {
      for (var t = 0; t < this.length; t++) {
        var n = Element.prototype.closest.call(this[t], e);
        if (n) return v(n)
      }
      return v()
    }, html: function (e) {
      if (void 0 === e) return 0 === this.length ? undefined : this[0].innerHTML;
      if ("string" == typeof e) for (var t = 0; t < this.length; t++) {
        this[t].innerHTML = e;
        for (var n = this[t].children, r = this[t].ownerDocument || document, a = 0; a < n.length; a++) if ("SCRIPT" === n[a].tagName) {
          var o = r.createElement("script");
          o.innerHTML = n[a].innerHTML, n[a].hasAttribute("async") && o.setAttribute("async", ""), o.src = n[a].src, n[a].hasAttribute("defer") && o.setAttribute("defer", ""), r.head.appendChild(o).parentNode.removeChild(o)
        }
      } else {
        this[0].innerHTML = "", this.append(e[0]);
        var i = this[0].ownerDocument || document;
        if ("SCRIPT" === e[0].tagName) {
          var s = i.createElement("script");
          s.innerHTML = e[0].innerHTML, i.head.appendChild(s).parentNode.removeChild(s)
        }
      }
      return this
    }, text: function (e) {
      if (!e) return this.length ? this[0].textContent : "";
      for (var t = 0; t < this.length; t++) this[t].textContent = e
    }, after: function e(t) {
      if (t) if ("string" == typeof t) for (var n = 0; n < this.length; n++) {
        var e = this[n];
        if (e.nodeType != Node.ELEMENT_NODE) {
          var r = e.ownerDocument.createElement("SPAN");
          v(e).after(r), v(r).after(t).remove()
        } else e.insertAdjacentHTML("afterend", t)
      } else {
        var a = this[0];
        if (a.nextSibling) if (t instanceof h) for (var o = 0; o < t.length; o++) a.nextSibling.parentNode.insertBefore(t[o], a.nextSibling); else a.nextSibling.parentNode.insertBefore(t, a.nextSibling); else v(a.parentNode).append(t)
      }
      return this
    }, clone: function (e) {
      for (var t = v(), n = 0; n < this.length; n++) t.push(this[n].cloneNode(e));
      return t
    }, replaceWith: function (e) {
      if ("string" == typeof e) for (var t = 0; t < this.length; t++) this[t].parentNode && (this[t].outerHTML = e); else if (e.length) for (var n = 0; n < this.length; n++) this.replaceWith(e[n]); else this.after(e).remove()
    }, insertBefore: function (e) {
      return v(e).before(this[0]), this
    }, before: function e(t) {
      if (t instanceof h) {
        for (var n = 0; n < t.length; n++) this.before(t[n]);
        return this
      }
      if (t) if ("string" == typeof t) for (var r = 0; r < this.length; r++) {
        var e = this[r];
        if (e.nodeType != Node.ELEMENT_NODE) {
          var a = e.ownerDocument.createElement("SPAN");
          v(e).before(a), v(a).before(t).remove()
        } else e.parentNode && e.insertAdjacentHTML("beforebegin", t)
      } else {
        var o = this[0];
        if (o.parentNode) if (t instanceof h) for (var i = 0; i < t.length; i++) o.parentNode.insertBefore(t[i], o); else o.parentNode.insertBefore(t, o)
      }
      return this
    }, append: function (e) {
      if (0 == this.length) return this;
      if ("string" == typeof e) for (var t = 0; t < this.length; t++) {
        var n = this[t], r = n.ownerDocument.createElement("SPAN");
        v(n).append(r), v(r).after(e).remove()
      } else if (e instanceof h || Array.isArray(e)) for (var a = 0; a < e.length; a++) this.append(e[a]); else "function" != typeof e && this[0].appendChild(e);
      return this
    }, prepend: function (e) {
      if (0 == this.length) return this;
      if ("string" == typeof e) for (var t = 0; t < this.length; t++) {
        var n = this[t], r = n.ownerDocument.createElement("SPAN");
        v(n).prepend(r), v(r).before(e).remove()
      } else if (e instanceof h) for (var a = 0; a < e.length; a++) this.prepend(e[a]); else {
        var o = this[0];
        o.firstChild ? o.firstChild ? o.insertBefore(e, o.firstChild) : o.appendChild(e) : v(o).append(e)
      }
      return this
    }, remove: function () {
      for (var e = 0; e < this.length; e++) this[e].parentNode && this[e].parentNode.removeChild(this[e]);
      return this
    }, prev: function () {
      return this.length && this[0].previousElementSibling ? v(this[0].previousElementSibling) : v()
    }, next: function () {
      return this.length && this[0].nextElementSibling ? v(this[0].nextElementSibling) : v()
    }, nextAllVisible: function () {
      return this.next()
    }, prevAllVisible: function () {
      return this.prev()
    }, outerHeight: function (e) {
      if (0 === this.length) return undefined;
      var t = this[0];
      if (t === t.window) return t.innerHeight;
      var n = {}, r = this.isVisible();
      if (!r) for (var a in s) n[a] = t.style[a], t.style[a] = s[a];
      var o = t.offsetHeight;
      if (e && (o += parseInt(v(t).css("marginTop")) + parseInt(v(t).css("marginBottom"))), !r) for (var i in s) t.style[i] = n[i];
      return o
    }, outerWidth: function (e) {
      if (0 === this.length) return undefined;
      var t = this[0];
      if (t === t.window) return t.outerWidth;
      var n = {}, r = this.isVisible();
      if (!r) for (var a in s) n[a] = t.style[a], t.style[a] = s[a];
      var o = t.offsetWidth;
      if (e && (o += parseInt(v(t).css("marginLeft")) + parseInt(v(t).css("marginRight"))), !r) for (var i in s) t.style[i] = n[i];
      return o
    }, width: function (e) {
      if (e === undefined) {
        if (this[0] instanceof HTMLDocument) return this[0].body.offsetWidth;
        if (this[0]) return this[0].offsetWidth
      } else this[0].style.width = e + "px"
    }, height: function (e) {
      var t = this[0];
      if (e === undefined) {
        if (t instanceof HTMLDocument) {
          var n = t.documentElement;
          return Math.max(t.body.scrollHeight, n.scrollHeight, t.body.offsetHeight, n.offsetHeight, n.clientHeight)
        }
        return t.offsetHeight
      }
      t.style.height = e + "px"
    }, is: function (e) {
      return 0 !== this.length && ("string" == typeof e && this[0].matches ? this[0].matches(e) : e instanceof h ? this[0] == e[0] : this[0] == e)
    }, parent: function () {
      return 0 === this.length ? v() : v(this[0].parentNode)
    }, _matches: function (e, t) {
      var n = e.matches || e.matchesSelector || e.msMatchesSelector || e.mozMatchesSelector || e.webkitMatchesSelector || e.oMatchesSelector;
      return e && !t ? n : n.call(e, t)
    }, parents: function (e) {
      for (var t = v(), n = 0; n < this.length; n++) for (var r = this[n].parentNode; r && r != document && this._matches(r);) e ? this._matches(r, e) && t.push(r) : t.push(r), r = r.parentNode;
      return t
    }, parentsUntil: function (e, t) {
      var n = v();
      e instanceof h && 0 < e.length && (e = e[0]);
      for (var r = 0; r < this.length; r++) for (var a = this[r].parentNode; a && a != document && a != e && this[r] != e && ("string" != typeof e || !Element.prototype.matches.call(a, e));) t ? Element.prototype.matches.call(a, t) && n.push(a) : n.push(a), a = a.parentNode;
      return n
    }, insertAfter: function (e) {
      var t = e.parent()[0];
      t && t.insertBefore(this[0], e[0].nextElementSibling)
    }, filter: function (e) {
      var t = v();
      if ("function" == typeof e) for (var n = 0; n < this.length; n++) e.call(this[n], this[n]) && t.push(this[n]); else if ("string" == typeof e) for (var r = 0; r < this.length; r++) this[r].matches(e) && t.push(this[r]);
      return t
    }, offset: function () {
      if (0 === this.length) return undefined;
      var e = this[0].getBoundingClientRect(), t = this[0].ownerDocument.defaultView;
      return {top: e.top + t.pageYOffset, left: e.left + t.pageXOffset}
    }, position: function () {
      return {left: this[0].offsetLeft, top: this[0].offsetTop}
    }, push: [].push, splice: [].splice
  }, h.extend = function (e) {
    e = e || {};
    for (var t = 1; t < arguments.length; t++) if (arguments[t]) for (var n in arguments[t]) Object.prototype.hasOwnProperty.call(arguments[t], n) && (e[n] = arguments[t][n]);
    return e
  }, h.merge = function (e, t) {
    for (var n = +t.length, r = 0, a = e.length; r < n; r++) e[a++] = t[r];
    return e.length = a, e
  }, h.map = function (e, t, n) {
    var r, a, o = 0, i = [];
    if (Array.isArray(e)) for (r = e.length; o < r; o++) null != (a = t(e[o], o, n)) && i.push(a); else for (o in e) null != (a = t(e[o], o, n)) && i.push(a);
    return [].concat.apply([], i)
  };
  var b = function b(e, t) {
    if (!e) return this;
    if ("string" == typeof e && "<" === e[0]) {
      var n = document.createElement("DIV");
      return n.innerHTML = e, v(n.firstElementChild)
    }
    if (t = t instanceof h ? t[0] : t, "string" != typeof e) return e instanceof h ? e : (this[0] = e, this.length = 1, this);
    e = g(e);
    for (var r = (t || document).querySelectorAll(e), a = 0; a < r.length; a++) this[a] = r[a];
    return this.length = r.length, this
  };
  b.prototype = h.prototype;
  var C = xt;

  function E() {
    this.doc = this.$el.get(0).ownerDocument, this.win = "defaultView" in this.doc ? this.doc.defaultView : this.doc.parentWindow, this.$doc = h(this.doc), this.$win = h(this.win), this.opts.pluginsEnabled || (this.opts.pluginsEnabled = Object.keys(C.PLUGINS)), this.opts.initOnClick ? (this.load(C.MODULES), this.$el.on("touchstart.init", function () {
      h(this).data("touched", !0)
    }), this.$el.on("touchmove.init", function () {
      h(this).removeData("touched")
    }), this.$el.on("mousedown.init touchend.init dragenter.init focus.init", function r(e) {
      if ("touchend" === e.type && !this.$el.data("touched")) return !0;
      if (1 === e.which || !e.which) {
        this.$el.off("mousedown.init touchstart.init touchmove.init touchend.init dragenter.init focus.init"), this.load(C.MODULES), this.load(C.PLUGINS);
        var t = e.originalEvent && e.originalEvent.originalTarget;
        if (t && "IMG" === t.tagName && h(t).trigger("mousedown"), "undefined" == typeof this.ul && this.destroy(), "touchend" === e.type && this.image && e.originalEvent && e.originalEvent.target && h(e.originalEvent.target).is("img")) {
          var n = this;
          setTimeout(function () {
            n.image.edit(h(e.originalEvent.target))
          }, 100)
        }
        this.ready = !0, this.events.trigger("initialized")
      }
    }.bind(this)), this.events.trigger("initializationDelayed")) : (this.load(C.MODULES), this.load(C.PLUGINS), h(this.o_win).scrollTop(this.c_scroll), "undefined" == typeof this.ul && this.destroy(), this.ready = !0, this.events.trigger("initialized"))
  }

  if (C.Bootstrap = function (e, t, n) {
    this.id = ++C.ID, this.$ = h;
    var r = {};
    "function" == typeof t && (n = t, t = {}), n && (t.events || (t.events = {}), t.events.initialized = n), t && t.documentReady && (r.toolbarButtons = [["fullscreen", "undo", "redo", "getPDF", "print"], ["bold", "italic", "underline", "textColor", "backgroundColor", "clearFormatting"], ["alignLeft", "alignCenter", "alignRight", "alignJustify"], ["formatOL", "formatUL", "indent", "outdent"], ["paragraphFormat"], ["fontFamily"], ["fontSize"], ["insertLink", "insertImage", "quote"]], r.paragraphFormatSelection = !0, r.fontFamilySelection = !0, r.fontSizeSelection = !0, r.placeholderText = "", r.quickInsertEnabled = !1, r.charCounterCount = !1), this.opts = Object.assign({}, Object.assign({}, C.DEFAULTS, r, "object" === kt(t) && t));
    var a = JSON.stringify(this.opts);
    C.OPTS_MAPPING[a] = C.OPTS_MAPPING[a] || this.id, this.sid = C.OPTS_MAPPING[a], C.SHARED[this.sid] = C.SHARED[this.sid] || {}, this.shared = C.SHARED[this.sid], this.shared.count = (this.shared.count || 0) + 1, this.$oel = h(e), this.$oel.data("froala.editor", this), this.o_doc = e.ownerDocument, this.o_win = "defaultView" in this.o_doc ? this.o_doc.defaultView : this.o_doc.parentWindow, this.c_scroll = h(this.o_win).scrollTop(), this._init()
  }, C.Bootstrap.prototype._init = function () {
    var e = this.$oel.get(0).tagName;
    this.$oel.closest("label").length;
    var t = function () {
      "TEXTAREA" !== e && (this._original_html = this._original_html || this.$oel.html()), this.$box = this.$box || this.$oel, this.opts.fullPage && (this.opts.iframe = !0), this.opts.iframe ? (this.$iframe = h('<iframe src="about:blank" frameBorder="0">'), this.$wp = h("<div></div>"), this.$box.html(this.$wp), this.$wp.append(this.$iframe), this.$iframe.get(0).contentWindow.document.open(), this.$iframe.get(0).contentWindow.document.write("<!DOCTYPE html>"), this.$iframe.get(0).contentWindow.document.write("<html><head></head><body></body></html>"), this.$iframe.get(0).contentWindow.document.close(), this.iframe_document = this.$iframe.get(0).contentWindow.document, this.$el = h(this.iframe_document.querySelector("body")), this.el = this.$el.get(0), this.$head = h(this.iframe_document.querySelector("head")), this.$html = h(this.iframe_document.querySelector("html"))) : (this.$el = h(this.o_doc.createElement("DIV")), this.el = this.$el.get(0), this.$wp = h(this.o_doc.createElement("DIV")).append(this.$el), this.$box.html(this.$wp)), setTimeout(E.bind(this), 0)
    }.bind(this), n = function () {
      this.$box = h("<div>"), this.$oel.before(this.$box).hide(), this._original_html = this.$oel.val();
      var e = this;
      this.$oel.parents("form").on("submit.".concat(this.id), function () {
        e.events.trigger("form.submit")
      }), this.$oel.parents("form").on("reset.".concat(this.id), function () {
        e.events.trigger("form.reset")
      }), t()
    }.bind(this), r = function () {
      this.$el = this.$oel, this.el = this.$el.get(0), this.$el.attr("contenteditable", !0).css("outline", "none").css("display", "inline-block"), this.opts.multiLine = !1, this.opts.toolbarInline = !1, setTimeout(E.bind(this), 0)
    }.bind(this), a = function () {
      this.$el = this.$oel, this.el = this.$el.get(0), this.opts.toolbarInline = !1, setTimeout(E.bind(this), 0)
    }.bind(this), o = function () {
      this.$el = this.$oel, this.el = this.$el.get(0), this.opts.toolbarInline = !1, this.$oel.on("click.popup", function (e) {
        e.preventDefault()
      }), setTimeout(E.bind(this), 0)
    }.bind(this);
    this.opts.editInPopup ? o() : "TEXTAREA" === e ? n() : "A" === e ? r() : "IMG" === e ? a() : "BUTTON" === e || "INPUT" === e ? (this.opts.editInPopup = !0, this.opts.toolbarInline = !1, o()) : t()
  }, C.Bootstrap.prototype.load = function (e) {
    for (var t in e) if (Object.prototype.hasOwnProperty.call(e, t)) {
      if (this[t]) continue;
      if (C.PLUGINS[t] && this.opts.pluginsEnabled.indexOf(t) < 0) continue;
      if (this[t] = new e[t](this), this[t]._init && (this[t]._init(), this.opts.initOnClick && "core" === t)) return !1
    }
  }, C.Bootstrap.prototype.destroy = function () {
    this.destrying = !0, this.shared.count--, this.events && this.events.$off();
    var e = this.html && this.html.get();
    if (this.opts.iframe && (this.events.disableBlur(), this.win.focus(), this.events.enableBlur()), this.events && (this.events.trigger("destroy", [], !0), this.events.trigger("shared.destroy", [], !0)), 0 === this.shared.count) {
      for (var t in this.shared) Object.prototype.hasOwnProperty.call(this.shared, t) && (this.shared[t] = null, C.SHARED[this.sid][t] = null);
      delete C.SHARED[this.sid]
    }
    this.$oel.parents("form").off(".".concat(this.id)), this.$oel.off("click.popup"), this.$oel.removeData("froala.editor"), this.$oel.off("froalaEditor"), this.core && this.core.destroy(e), C.INSTANCES.splice(C.INSTANCES.indexOf(this), 1)
  }, xt.PLUGINS.align = function (a) {
    var o = a.$;
    return {
      apply: function i(e) {
        var t = a.selection.element();
        if (o(t).parents(".fr-img-caption").length) o(t).css("text-align", e); else {
          a.selection.save(), a.html.wrap(!0, !0, !0, !0), a.selection.restore();
          for (var n = a.selection.blocks(), r = 0; r < n.length; r++) o(n[r]).css("text-align", e).removeClass("fr-temp-div"), "" === o(n[r]).attr("class") && o(n[r]).removeAttr("class"), "" === o(n[r]).attr("style") && o(n[r]).removeAttr("style");
          a.selection.save(), a.html.unwrap(), a.selection.restore()
        }
      }, refresh: function r(e) {
        var t = a.selection.blocks();
        if (t.length) {
          var n = a.helpers.getAlignment(o(t[0]));
          e.find("> *").first().replaceWith(a.icon.create("align-".concat(n)))
        }
      }, refreshOnShow: function s(e, t) {
        var n = a.selection.blocks();
        if (n.length) {
          var r = a.helpers.getAlignment(o(n[0]));
          t.find('a.fr-command[data-param1="'.concat(r, '"]')).addClass("fr-active").attr("aria-selected", !0)
        }
      }, refreshForToolbar: function l(e) {
        var t = a.selection.blocks();
        if (t.length) {
          var n = a.helpers.getAlignment(o(t[0]));
          n = n.charAt(0).toUpperCase() + n.slice(1), "align".concat(n) === e.attr("data-cmd") && e.addClass("fr-active")
        }
      }
    }
  }, xt.DefineIcon("align", {
    NAME: "align-left",
    SVG_KEY: "alignLeft"
  }), xt.DefineIcon("align-left", {
    NAME: "align-left",
    SVG_KEY: "alignLeft"
  }), xt.DefineIcon("align-right", {
    NAME: "align-right",
    SVG_KEY: "alignRight"
  }), xt.DefineIcon("align-center", {
    NAME: "align-center",
    SVG_KEY: "alignCenter"
  }), xt.DefineIcon("align-justify", {
    NAME: "align-justify",
    SVG_KEY: "alignJustify"
  }), xt.RegisterCommand("align", {
    type: "dropdown",
    title: "Align",
    options: {left: "Align Left", center: "Align Center", right: "Align Right", justify: "Align Justify"},
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = xt.COMMANDS.align.options;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="align"data-param1="\n        '.concat(n, '" title="').concat(this.language.translate(t[n]), '">').concat(this.icon.create("align-".concat(n)), '<span class="fr-sr-only">\n        ').concat(this.language.translate(t[n]), "</span></a></li>"));
      return e += "</ul>"
    },
    callback: function (e, t) {
      this.align.apply(t)
    },
    refresh: function (e) {
      this.align.refresh(e)
    },
    refreshOnShow: function (e, t) {
      this.align.refreshOnShow(e, t)
    },
    plugin: "align"
  }), xt.RegisterCommand("alignLeft", {
    type: "button", icon: "align-left", title: "Align Left", callback: function () {
      this.align.apply("left")
    }, refresh: function (e) {
      this.align.refreshForToolbar(e)
    }, plugin: "align"
  }), xt.RegisterCommand("alignRight", {
    type: "button",
    icon: "align-right",
    title: "Align Right",
    callback: function () {
      this.align.apply("right")
    },
    refresh: function (e) {
      this.align.refreshForToolbar(e)
    },
    plugin: "align"
  }), xt.RegisterCommand("alignCenter", {
    type: "button",
    icon: "align-center",
    title: "Align Center",
    callback: function () {
      this.align.apply("center")
    },
    refresh: function (e) {
      this.align.refreshForToolbar(e)
    },
    plugin: "align"
  }), xt.RegisterCommand("alignJustify", {
    type: "button",
    icon: "align-justify",
    title: "Align Justify",
    callback: function () {
      this.align.apply("justify")
    },
    refresh: function (e) {
      this.align.refreshForToolbar(e)
    },
    plugin: "align"
  }), Object.assign(xt.DEFAULTS, {charCounterMax: -1, charCounterCount: !0}), xt.PLUGINS.charCounter = function (n) {
    var r, t = n.$, a = function a() {
      return (n.el.textContent || "").replace(/\u200B/g, "").length
    };

    function e(e) {
      if (n.opts.charCounterMax < 0) return !0;
      if (a() < n.opts.charCounterMax) return !0;
      var t = e.which;
      return !(!n.keys.ctrlKey(e) && n.keys.isCharacter(t) || t === xt.KEYCODE.IME) || (e.preventDefault(), e.stopPropagation(), n.events.trigger("charCounter.exceeded"), !1)
    }

    function o(e) {
      return n.opts.charCounterMax < 0 ? e : t("<div>").html(e).text().length + a() <= n.opts.charCounterMax ? e : (n.events.trigger("charCounter.exceeded"), "")
    }

    function i() {
      if (n.opts.charCounterCount) {
        var e = a() + (0 < n.opts.charCounterMax ? "/" + n.opts.charCounterMax : "");
        r.text("".concat(n.language.translate("Characters"), " : ").concat(e)), n.opts.toolbarBottom && r.css("margin-bottom", n.$tb.outerHeight(!0));
        var t = n.$wp.get(0).offsetWidth - n.$wp.get(0).clientWidth;
        0 <= t && ("rtl" == n.opts.direction ? r.css("margin-left", t) : r.css("margin-right", t))
      }
    }

    return {
      _init: function s() {
        return !!n.$wp && !!n.opts.charCounterCount && ((r = t(document.createElement("span")).attr("class", "fr-counter")).css("bottom", n.$wp.css("border-bottom-width")), n.$second_tb ? n.$second_tb.append(r) : n.$wp.append(r), n.events.on("keydown", e, !0), n.events.on("paste.afterCleanup", o), n.events.on("keyup contentChanged input", function () {
          n.events.trigger("charCounter.update")
        }), n.events.on("charCounter.update", i), n.events.trigger("charCounter.update"), void n.events.on("destroy", function () {
          t(n.o_win).off("resize.char".concat(n.id)), r.removeData().remove(), r = null
        }))
      }, count: a
    }
  }, xt.PLUGINS.codeBeautifier = function () {
    var e, t, n, r, j = {};

    function x(r, e) {
      var t = {"@page": !0, "@font-face": !0, "@keyframes": !0, "@media": !0, "@supports": !0, "@document": !0},
        n = {"@media": !0, "@supports": !0, "@document": !0};
      e = e || {}, r = (r = r || "").replace(/\r\n|[\r\u2028\u2029]/g, "\n");
      var a = e.indent_size || 4, o = e.indent_char || " ",
        i = e.selector_separator_newline === undefined || e.selector_separator_newline,
        s = e.end_with_newline !== undefined && e.end_with_newline,
        l = e.newline_between_rules === undefined || e.newline_between_rules, c = e.eol ? e.eol : "\n";
      "string" == typeof a && (a = parseInt(a, 10)), e.indent_with_tabs && (o = "\t", a = 1), c = c.replace(/\\r/, "\r").replace(/\\n/, "\n");
      var d, f = /^\s+$/, p = -1, u = 0;

      function h() {
        return (d = r.charAt(++p)) || ""
      }

      function g(e) {
        var t, n = p;
        return e && v(), t = r.charAt(p + 1) || "", p = n - 1, h(), t
      }

      function m(e) {
        for (var t = p; h();) if ("\\" === d) h(); else {
          if (-1 !== e.indexOf(d)) break;
          if ("\n" === d) break
        }
        return r.substring(t, p + 1)
      }

      function v() {
        for (var e = ""; f.test(g());) h(), e += d;
        return e
      }

      function b() {
        var e = "";
        for (d && f.test(d) && (e = d); f.test(h());) e += d;
        return e
      }

      function C(e) {
        var t = p;
        for (e = "/" === g(), h(); h();) {
          if (!e && "*" === d && "/" === g()) {
            h();
            break
          }
          if (e && "\n" === d) return r.substring(t, p)
        }
        return r.substring(t, p) + d
      }

      function E(e) {
        return r.substring(p - e.length, p).toLowerCase() === e
      }

      function y() {
        for (var e = 0, t = p + 1; t < r.length; t++) {
          var n = r.charAt(t);
          if ("{" === n) return !0;
          if ("(" === n) e += 1; else if (")" === n) {
            if (0 === e) return !1;
            e -= 1
          } else if (" " === n || "}" === n) return !1
        }
        return !1
      }

      var L = r.match(/^[\t ]*/)[0], _ = new Array(a + 1).join(o), w = 0, A = 0;
      for (var T, S, k, x = {
        "{": function (e) {
          x.singleSpace(), R.push(e), x.newLine()
        }, "}": function (e) {
          x.newLine(), R.push(e), x.newLine()
        }, _lastCharWhitespace: function () {
          return f.test(R[R.length - 1])
        }, newLine: function (e) {
          R.length && (e || "\n" === R[R.length - 1] || x.trim(), R.push("\n"), L && R.push(L))
        }, singleSpace: function () {
          R.length && !x._lastCharWhitespace() && R.push(" ")
        }, preserveSingleSpace: function () {
          T && x.singleSpace()
        }, trim: function () {
          for (; x._lastCharWhitespace();) R.pop()
        }
      }, R = [], M = !1, O = !1, N = !1, I = "", D = ""; ;) {
        var B = b();
        T = "" !== B;
        var H = -1 !== B.indexOf("\n");
        if (D = I, !(I = d)) break;
        if ("/" === d && "*" === g()) {
          var $ = 0 === w;
          (H || $) && x.newLine(), R.push(C()), x.newLine(), $ && x.newLine(!0)
        } else if ("/" === d && "/" === g()) H || "{" === D || x.trim(), x.singleSpace(), R.push(C()), x.newLine(); else if ("@" === d) {
          x.preserveSingleSpace(), R.push(d);
          var F = (void 0, S = p, k = m(": , {}()[]/='\""), p = S - 1, h(), k);
          F.match(/[ :]$/) && (h(), F = m(": ").replace(/\s$/, ""), R.push(F), x.singleSpace()), (F = F.replace(/\s$/, "")) in t && (A += 1, F in n && (N = !0))
        } else "#" === d && "{" === g() ? (x.preserveSingleSpace(), R.push(m("}"))) : "{" === d ? "}" === g(!0) ? (v(), h(), x.singleSpace(), R.push("{}"), x.newLine(), l && 0 === w && x.newLine(!0)) : (w++, L += _, x["{"](d), M = N ? (N = !1, A < w) : A <= w) : "}" === d ? (w--, L = L.slice(0, -a), x["}"](d), O = M = !1, A && A--, l && 0 === w && x.newLine(!0)) : ":" === d ? (v(), !M && !N || E("&") || y() ? ":" === g() ? (h(), R.push("::")) : R.push(":") : (O = !0, R.push(":"), x.singleSpace())) : '"' === d || "'" === d ? (x.preserveSingleSpace(), R.push(m(d))) : " " === d ? (O = !1, R.push(d), x.newLine()) : "(" === d ? E("url") ? (R.push(d), v(), h() && (")" !== d && '"' !== d && "'" !== d ? R.push(m(")")) : p--)) : (u++, x.preserveSingleSpace(), R.push(d), v()) : ")" === d ? (R.push(d), u--) : "," === d ? (R.push(d), v(), i && !O && u < 1 ? x.newLine() : x.singleSpace()) : ("]" === d || ("[" === d ? x.preserveSingleSpace() : "=" === d ? (v(), d = "=") : x.preserveSingleSpace()), R.push(d))
      }
      var P = "";
      return L && (P += L), P += R.join("").replace(/[\r\n\t ]+$/, ""), s && (P += "\n"), "\n" != c && (P = P.replace(/[\n]/g, c)), P
    }

    function q(e, t) {
      for (var n = 0; n < t.length; n += 1) if (t[n] === e) return !0;
      return !1
    }

    function Z(e) {
      return e.replace(/^\s+|\s+$/g, "")
    }

    function R(e, t) {
      return new a(e, t).beautify()
    }

    e = j, t = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0\u08a2-\u08ac\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19c1-\u19c7\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua793\ua7a0-\ua7aa\ua7f8-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa80-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc", n = new RegExp("[".concat(t, "]")), r = new RegExp("[".concat(t, " ").concat("\u0300-\u036f\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u0620-\u0649\u0672-\u06d3\u06e7-\u06e8\u06fb-\u06fc\u0730-\u074a\u0800-\u0814\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0840-\u0857\u08e4-\u08fe\u0900-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962-\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09d7\u09df-\u09e0\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2-\u0ae3\u0ae6-\u0aef\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b5f-\u0b60\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c01-\u0c03\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62-\u0c63\u0c66-\u0c6f\u0c82\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2-\u0ce3\u0ce6-\u0cef\u0d02\u0d03\u0d46-\u0d48\u0d57\u0d62-\u0d63\u0d66-\u0d6f\u0d82\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0df2\u0df3\u0e34-\u0e3a\u0e40-\u0e45\u0e50-\u0e59\u0eb4-\u0eb9\u0ec8-\u0ecd\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f41-\u0f47\u0f71-\u0f84\u0f86-\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u1000-\u1029\u1040-\u1049\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u170e-\u1710\u1720-\u1730\u1740-\u1750\u1772\u1773\u1780-\u17b2\u17dd\u17e0-\u17e9\u180b-\u180d\u1810-\u1819\u1920-\u192b\u1930-\u193b\u1951-\u196d\u19b0-\u19c0\u19c8-\u19c9\u19d0-\u19d9\u1a00-\u1a15\u1a20-\u1a53\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1b46-\u1b4b\u1b50-\u1b59\u1b6b-\u1b73\u1bb0-\u1bb9\u1be6-\u1bf3\u1c00-\u1c22\u1c40-\u1c49\u1c5b-\u1c7d\u1cd0-\u1cd2\u1d00-\u1dbe\u1e01-\u1f15\u200c\u200d\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2d81-\u2d96\u2de0-\u2dff\u3021-\u3028\u3099\u309a\ua640-\ua66d\ua674-\ua67d\ua69f\ua6f0-\ua6f1\ua7f8-\ua800\ua806\ua80b\ua823-\ua827\ua880-\ua881\ua8b4-\ua8c4\ua8d0-\ua8d9\ua8f3-\ua8f7\ua900-\ua909\ua926-\ua92d\ua930-\ua945\ua980-\ua983\ua9b3-\ua9c0\uaa00-\uaa27\uaa40-\uaa41\uaa4c-\uaa4d\uaa50-\uaa59\uaa7b\uaae0-\uaae9\uaaf2-\uaaf3\uabc0-\uabe1\uabec\uabed\uabf0-\uabf9\ufb20-\ufb28\ufe00-\ufe0f\ufe20-\ufe26\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f", "]")), e.newline = /[\n\r\u2028\u2029]/, e.lineBreak = new RegExp("\r\n|".concat(e.newline.source)), e.allLineBreaks = new RegExp(e.lineBreak.source, "g"), e.isIdentifierStart = function (e) {
      return e < 65 ? 36 === e || 64 === e : e < 91 || (e < 97 ? 95 === e : e < 123 || 170 <= e && n.test(String.fromCharCode(e)))
    }, e.isIdentifierChar = function (e) {
      return e < 48 ? 36 === e : e < 58 || !(e < 65) && (e < 91 || (e < 97 ? 95 === e : e < 123 || 170 <= e && r.test(String.fromCharCode(e))))
    };
    var X = {
      BlockStatement: "BlockStatement",
      Statement: "Statement",
      ObjectLiteral: "ObjectLiteral",
      ArrayLiteral: "ArrayLiteral",
      ForInitializer: "ForInitializer",
      Conditional: "Conditional",
      Expression: "Expression"
    };

    function a(r, e) {
      var c, a, o, d, i, s, l, f, p, t, n, u, h, g = [], m = "";

      function v(e, t) {
        var n = 0;
        return e && (n = e.indentation_level, !c.just_added_newline() && e.line_indent_level > n && (n = e.line_indent_level)), {
          mode: t,
          parent: e,
          last_text: e ? e.last_text : "",
          last_word: e ? e.last_word : "",
          declaration_statement: !1,
          declaration_assignment: !1,
          multiline_frame: !1,
          if_block: !1,
          else_block: !1,
          do_block: !1,
          do_while: !1,
          in_case_statement: !1,
          in_case: !1,
          case_body: !1,
          indentation_level: n,
          line_indent_level: e ? e.line_indent_level : n,
          start_line_index: c.get_line_number(),
          ternary_depth: 0
        }
      }

      for (u = {
        TK_START_EXPR: function I() {
          R();
          var e = X.Expression;
          if ("[" === d.text) {
            if ("TK_WORD" === i || ")" === f.last_text) return "TK_RESERVED" === i && q(f.last_text, o.line_starters) && (c.space_before_token = !0), A(e), _(), w(), void (h.space_in_paren && (c.space_before_token = !0));
            e = X.ArrayLiteral, T(f.mode) && ("[" !== f.last_text && ("," !== f.last_text || "]" !== s && "}" !== s) || h.keep_array_indentation || y())
          } else "TK_RESERVED" === i && "for" === f.last_text ? e = X.ForInitializer : "TK_RESERVED" === i && q(f.last_text, ["if", "while"]) && (e = X.Conditional);
          " " === f.last_text || "TK_START_BLOCK" === i ? y() : "TK_END_EXPR" === i || "TK_START_EXPR" === i || "TK_END_BLOCK" === i || "." === f.last_text ? E(d.wanted_newline) : "TK_RESERVED" === i && "(" === d.text || "TK_WORD" === i || "TK_OPERATOR" === i ? "TK_RESERVED" === i && ("function" === f.last_word || "typeof" === f.last_word) || "*" === f.last_text && "function" === s ? h.space_after_anon_function && (c.space_before_token = !0) : "TK_RESERVED" !== i || !q(f.last_text, o.line_starters) && "catch" !== f.last_text || h.space_before_conditional && (c.space_before_token = !0) : c.space_before_token = !0;
          "(" === d.text && "TK_RESERVED" === i && "await" === f.last_word && (c.space_before_token = !0);
          "(" === d.text && ("TK_EQUALS" !== i && "TK_OPERATOR" !== i || x() || E());
          A(e), _(), h.space_in_paren && (c.space_before_token = !0);
          w()
        }, TK_END_EXPR: function D() {
          for (; f.mode === X.Statement;) k();
          f.multiline_frame && E("]" === d.text && T(f.mode) && !h.keep_array_indentation);
          h.space_in_paren && ("TK_START_EXPR" !== i || h.space_in_empty_paren ? c.space_before_token = !0 : (c.trim(), c.space_before_token = !1));
          "]" === d.text && h.keep_array_indentation ? (_(), k()) : (k(), _());
          c.remove_redundant_indentation(p), f.do_while && p.mode === X.Conditional && (p.mode = X.Expression, f.do_block = !1, f.do_while = !1)
        }, TK_START_BLOCK: function B() {
          var e = O(1), t = O(2);
          t && (":" === t.text && q(e.type, ["TK_STRING", "TK_WORD", "TK_RESERVED"]) || q(e.text, ["get", "set"]) && q(t.type, ["TK_WORD", "TK_RESERVED"])) ? q(s, ["class", "interface"]) ? A(X.BlockStatement) : A(X.ObjectLiteral) : A(X.BlockStatement);
          var n = !e.comments_before.length && "}" === e.text && "function" === f.last_word && "TK_END_EXPR" === i;
          "expand" === h.brace_style || "none" === h.brace_style && d.wanted_newline ? "TK_OPERATOR" !== i && (n || "TK_EQUALS" === i || "TK_RESERVED" === i && M(f.last_text) && "else" !== f.last_text) ? c.space_before_token = !0 : y(!1, !0) : "TK_OPERATOR" !== i && "TK_START_EXPR" !== i ? "TK_START_BLOCK" === i ? y() : c.space_before_token = !0 : T(p.mode) && "," === f.last_text && ("}" === s ? c.space_before_token = !0 : y());
          _(), w()
        }, TK_END_BLOCK: function H() {
          for (; f.mode === X.Statement;) k();
          var e = "TK_START_BLOCK" === i;
          "expand" === h.brace_style ? e || y() : e || (T(f.mode) && h.keep_array_indentation ? (h.keep_array_indentation = !1, y(), h.keep_array_indentation = !0) : y());
          k(), _()
        }, TK_WORD: N, TK_RESERVED: N, TK_SEMICOLON: function $() {
          R() && (c.space_before_token = !1);
          for (; f.mode === X.Statement && !f.if_block && !f.do_block;) k();
          _()
        }, TK_STRING: function F() {
          R() ? c.space_before_token = !0 : "TK_RESERVED" === i || "TK_WORD" === i ? c.space_before_token = !0 : "TK_COMMA" === i || "TK_START_EXPR" === i || "TK_EQUALS" === i || "TK_OPERATOR" === i ? x() || E() : y();
          _()
        }, TK_EQUALS: function P() {
          R();
          f.declaration_statement && (f.declaration_assignment = !0);
          c.space_before_token = !0, _(), c.space_before_token = !0
        }, TK_OPERATOR: function U() {
          R();
          if ("TK_RESERVED" === i && M(f.last_text)) return c.space_before_token = !0, void _();
          if ("*" === d.text && "TK_DOT" === i) return void _();
          if (":" === d.text && f.in_case) return f.case_body = !0, w(), _(), y(), void (f.in_case = !1);
          if ("::" === d.text) return void _();
          "TK_OPERATOR" === i && E();
          var e = !0, t = !0;
          q(d.text, ["--", "++", "!", "~"]) || q(d.text, ["-", "+"]) && (q(i, ["TK_START_BLOCK", "TK_START_EXPR", "TK_EQUALS", "TK_OPERATOR"]) || q(f.last_text, o.line_starters) || "," === f.last_text) ? (t = e = !1, !d.wanted_newline || "--" !== d.text && "++" !== d.text || y(!1, !0), " " === f.last_text && S(f.mode) && (e = !0), "TK_RESERVED" === i ? e = !0 : "TK_END_EXPR" === i ? e = !("]" === f.last_text && ("--" === d.text || "++" === d.text)) : "TK_OPERATOR" === i && (e = q(d.text, ["--", "-", "++", "+"]) && q(f.last_text, ["--", "-", "++", "+"]), q(d.text, ["+", "-"]) && q(f.last_text, ["--", "++"]) && (t = !0)), f.mode !== X.BlockStatement && f.mode !== X.Statement || "{" !== f.last_text && " " !== f.last_text || y()) : ":" === d.text ? 0 === f.ternary_depth ? e = !1 : f.ternary_depth -= 1 : "?" === d.text ? f.ternary_depth += 1 : "*" === d.text && "TK_RESERVED" === i && "function" === f.last_text && (t = e = !1);
          c.space_before_token = c.space_before_token || e, _(), c.space_before_token = t
        }, TK_COMMA: function z() {
          if (f.declaration_statement) return S(f.parent.mode) && (f.declaration_assignment = !1), _(), void (f.declaration_assignment ? y(f.declaration_assignment = !1, !0) : (c.space_before_token = !0, h.comma_first && E()));
          _(), f.mode === X.ObjectLiteral || f.mode === X.Statement && f.parent.mode === X.ObjectLiteral ? (f.mode === X.Statement && k(), y()) : (c.space_before_token = !0, h.comma_first && E())
        }, TK_BLOCK_COMMENT: function K() {
          if (c.raw) return c.add_raw_token(d), void (d.directives && "end" === d.directives.preserve && (h.test_output_raw || (c.raw = !1)));
          if (d.directives) return y(!1, !0), _(), "start" === d.directives.preserve && (c.raw = !0), void y(!1, !0);
          if (!j.newline.test(d.text) && !d.wanted_newline) return c.space_before_token = !0, _(), void (c.space_before_token = !0);
          var e, t = function i(e) {
            var t;
            e = e.replace(/\x0d/g, "");
            var n = [];
            t = e.indexOf("\n");
            for (; -1 !== t;) n.push(e.substring(0, t)), e = e.substring(t + 1), t = e.indexOf("\n");
            e.length && n.push(e);
            return n
          }(d.text), n = !1, r = !1, a = d.whitespace_before, o = a.length;
          y(!1, !0), 1 < t.length && (!function s(e, t) {
            for (var n = 0; n < e.length; n++) {
              var r = Z(e[n]);
              if (r.charAt(0) !== t) return !1
            }
            return !0
          }(t.slice(1), "*") ? function l(e, t) {
            for (var n, r = 0, a = e.length; r < a; r++) if ((n = e[r]) && 0 !== n.indexOf(t)) return !1;
            return !0
          }(t.slice(1), a) && (r = !0) : n = !0);
          for (_(t[0]), e = 1; e < t.length; e++) y(!1, !0), n ? _(" ".concat(t[e].replace(/^\s+/g, ""))) : r && t[e].length > o ? _(t[e].substring(o)) : c.add_token(t[e]);
          y(!1, !0)
        }, TK_COMMENT: function V() {
          d.wanted_newline ? y(!1, !0) : c.trim(!0);
          c.space_before_token = !0, _(), y(!1, !0)
        }, TK_DOT: function W() {
          R();
          "TK_RESERVED" === i && M(f.last_text) ? c.space_before_token = !0 : E(")" === f.last_text && h.break_chained_methods);
          _()
        }, TK_UNKNOWN: function G() {
          _(), "\n" === d.text[d.text.length - 1] && y()
        }, TK_EOF: function Y() {
          for (; f.mode === X.Statement;) k()
        }
      }, h = {}, (e = e || {}).braces_on_own_line !== undefined && (h.brace_style = e.braces_on_own_line ? "expand" : "collapse"), h.brace_style = e.brace_style ? e.brace_style : h.brace_style ? h.brace_style : "collapse", "expand-strict" === h.brace_style && (h.brace_style = "expand"), h.indent_size = e.indent_size ? parseInt(e.indent_size, 10) : 4, h.indent_char = e.indent_char ? e.indent_char : " ", h.eol = e.eol ? e.eol : "\n", h.preserve_newlines = e.preserve_newlines === undefined || e.preserve_newlines, h.break_chained_methods = e.break_chained_methods !== undefined && e.break_chained_methods, h.max_preserve_newlines = e.max_preserve_newlines === undefined ? 0 : parseInt(e.max_preserve_newlines, 10), h.space_in_paren = e.space_in_paren !== undefined && e.space_in_paren, h.space_in_empty_paren = e.space_in_empty_paren !== undefined && e.space_in_empty_paren, h.jslint_happy = e.jslint_happy !== undefined && e.jslint_happy, h.space_after_anon_function = e.space_after_anon_function !== undefined && e.space_after_anon_function, h.keep_array_indentation = e.keep_array_indentation !== undefined && e.keep_array_indentation, h.space_before_conditional = e.space_before_conditional === undefined || e.space_before_conditional, h.unescape_strings = e.unescape_strings !== undefined && e.unescape_strings, h.wrap_line_length = e.wrap_line_length === undefined ? 0 : parseInt(e.wrap_line_length, 10), h.e4x = e.e4x !== undefined && e.e4x, h.end_with_newline = e.end_with_newline !== undefined && e.end_with_newline, h.comma_first = e.comma_first !== undefined && e.comma_first, h.test_output_raw = e.test_output_raw !== undefined && e.test_output_raw, h.jslint_happy && (h.space_after_anon_function = !0), e.indent_with_tabs && (h.indent_char = "\t", h.indent_size = 1), h.eol = h.eol.replace(/\\r/, "\r").replace(/\\n/, "\n"), l = ""; 0 < h.indent_size;) l += h.indent_char, h.indent_size -= 1;
      var b = 0;
      if (r && r.length) {
        for (; " " === r.charAt(b) || "\t" === r.charAt(b);) m += r.charAt(b), b += 1;
        r = r.substring(b)
      }

      function C(e) {
        var t = e.newlines;
        if (h.keep_array_indentation && T(f.mode)) for (var n = 0; n < t; n += 1) y(0 < n); else if (h.max_preserve_newlines && t > h.max_preserve_newlines && (t = h.max_preserve_newlines), h.preserve_newlines && 1 < e.newlines) {
          y();
          for (var r = 1; r < t; r += 1) y(!0)
        }
        u[(d = e).type]()
      }

      function E(e) {
        if (e = e !== undefined && e, !c.just_added_newline()) if (h.preserve_newlines && d.wanted_newline || e) y(!1, !0); else if (h.wrap_line_length) {
          c.current_line.get_character_count() + d.text.length + (c.space_before_token ? 1 : 0) >= h.wrap_line_length && y(!1, !0)
        }
      }

      function y(e, t) {
        if (!t && " " !== f.last_text && "," !== f.last_text && "=" !== f.last_text && "TK_OPERATOR" !== i) for (; f.mode === X.Statement && !f.if_block && !f.do_block;) k();
        c.add_new_line(e) && (f.multiline_frame = !0)
      }

      function L() {
        c.just_added_newline() && (h.keep_array_indentation && T(f.mode) && d.wanted_newline ? (c.current_line.push(d.whitespace_before), c.space_before_token = !1) : c.set_indent(f.indentation_level) && (f.line_indent_level = f.indentation_level))
      }

      function _(e) {
        c.raw ? c.add_raw_token(d) : (h.comma_first && "TK_COMMA" === i && c.just_added_newline() && "," === c.previous_line.last() && (c.previous_line.pop(), L(), c.add_token(","), c.space_before_token = !0), e = e || d.text, L(), c.add_token(e))
      }

      function w() {
        f.indentation_level += 1
      }

      function A(e) {
        p = f ? (t.push(f), f) : v(null, e), f = v(p, e)
      }

      function T(e) {
        return e === X.ArrayLiteral
      }

      function S(e) {
        return q(e, [X.Expression, X.ForInitializer, X.Conditional])
      }

      function k() {
        0 < t.length && (p = f, f = t.pop(), p.mode === X.Statement && c.remove_redundant_indentation(p))
      }

      function x() {
        return f.parent.mode === X.ObjectLiteral && f.mode === X.Statement && (":" === f.last_text && 0 === f.ternary_depth || "TK_RESERVED" === i && q(f.last_text, ["get", "set"]))
      }

      function R() {
        return !!("TK_RESERVED" === i && q(f.last_text, ["const", "let", "const"]) && "TK_WORD" === d.type || "TK_RESERVED" === i && "do" === f.last_text || "TK_RESERVED" === i && "return" === f.last_text && !d.wanted_newline || "TK_RESERVED" === i && "else" === f.last_text && ("TK_RESERVED" !== d.type || "if" !== d.text) || "TK_END_EXPR" === i && (p.mode === X.ForInitializer || p.mode === X.Conditional) || "TK_WORD" === i && f.mode === X.BlockStatement && !f.in_case && "--" !== d.text && "++" !== d.text && "function" !== s && "TK_WORD" !== d.type && "TK_RESERVED" !== d.type || f.mode === X.ObjectLiteral && (":" === f.last_text && 0 === f.ternary_depth || "TK_RESERVED" === i && q(f.last_text, ["get", "set"]))) && (A(X.Statement), w(), "TK_RESERVED" === i && q(f.last_text, ["const", "let", "const"]) && "TK_WORD" === d.type && (f.declaration_statement = !0), x() || E("TK_RESERVED" === d.type && q(d.text, ["do", "for", "if", "while"])), !0)
      }

      function M(e) {
        return q(e, ["case", "return", "do", "if", "throw", "else"])
      }

      function O(e) {
        var t = a + (e || 0);
        return t < 0 || t >= g.length ? null : g[t]
      }

      function N() {
        ("TK_RESERVED" === d.type && f.mode !== X.ObjectLiteral && q(d.text, ["set", "get"]) && (d.type = "TK_WORD"), "TK_RESERVED" === d.type && f.mode === X.ObjectLiteral) && (":" === O(1).text && (d.type = "TK_WORD"));
        if (R() || !d.wanted_newline || S(f.mode) || "TK_OPERATOR" === i && "--" !== f.last_text && "++" !== f.last_text || "TK_EQUALS" === i || !h.preserve_newlines && "TK_RESERVED" === i && q(f.last_text, ["const", "let", "const", "set", "get"]) || y(), f.do_block && !f.do_while) {
          if ("TK_RESERVED" === d.type && "while" === d.text) return c.space_before_token = !0, _(), c.space_before_token = !0, void (f.do_while = !0);
          y(), f.do_block = !1
        }
        if (f.if_block) if (f.else_block || "TK_RESERVED" !== d.type || "else" !== d.text) {
          for (; f.mode === X.Statement;) k();
          f.if_block = !1, f.else_block = !1
        } else f.else_block = !0;
        if ("TK_RESERVED" === d.type && ("case" === d.text || "default" === d.text && f.in_case_statement)) return y(), (f.case_body || h.jslint_happy) && (!function e() {
          0 < f.indentation_level && (!f.parent || f.indentation_level > f.parent.indentation_level) && (f.indentation_level -= 1)
        }(), f.case_body = !1), _(), f.in_case = !0, void (f.in_case_statement = !0);
        if ("TK_RESERVED" === d.type && "function" === d.text && ((q(f.last_text, ["}", " "]) || c.just_added_newline() && !q(f.last_text, ["[", "{", ":", "=", ","])) && (c.just_added_blankline() || d.comments_before.length || (y(), y(!0))), "TK_RESERVED" === i || "TK_WORD" === i ? "TK_RESERVED" === i && q(f.last_text, ["get", "set", "new", "return", "export", "async"]) ? c.space_before_token = !0 : "TK_RESERVED" === i && "default" === f.last_text && "export" === s ? c.space_before_token = !0 : y() : "TK_OPERATOR" === i || "=" === f.last_text ? c.space_before_token = !0 : (f.multiline_frame || !S(f.mode) && !T(f.mode)) && y()), "TK_COMMA" !== i && "TK_START_EXPR" !== i && "TK_EQUALS" !== i && "TK_OPERATOR" !== i || x() || E(), "TK_RESERVED" === d.type && q(d.text, ["function", "get", "set"])) return _(), void (f.last_word = d.text);
        (n = "NONE", "TK_END_BLOCK" === i ? "TK_RESERVED" === d.type && q(d.text, ["else", "catch", "finally"]) ? "expand" === h.brace_style || "end-expand" === h.brace_style || "none" === h.brace_style && d.wanted_newline ? n = "NEWLINE" : (n = "SPACE", c.space_before_token = !0) : n = "NEWLINE" : "TK_SEMICOLON" === i && f.mode === X.BlockStatement ? n = "NEWLINE" : "TK_SEMICOLON" === i && S(f.mode) ? n = "SPACE" : "TK_STRING" === i ? n = "NEWLINE" : "TK_RESERVED" === i || "TK_WORD" === i || "*" === f.last_text && "function" === s ? n = "SPACE" : "TK_START_BLOCK" === i ? n = "NEWLINE" : "TK_END_EXPR" === i && (c.space_before_token = !0, n = "NEWLINE"), "TK_RESERVED" === d.type && q(d.text, o.line_starters) && ")" !== f.last_text && (n = "else" === f.last_text || "export" === f.last_text ? "SPACE" : "NEWLINE"), "TK_RESERVED" === d.type && q(d.text, ["else", "catch", "finally"])) ? "TK_END_BLOCK" !== i || "expand" === h.brace_style || "end-expand" === h.brace_style || "none" === h.brace_style && d.wanted_newline ? y() : (c.trim(!0), "}" !== c.current_line.last() && y(), c.space_before_token = !0) : "NEWLINE" === n ? "TK_RESERVED" === i && M(f.last_text) ? c.space_before_token = !0 : "TK_END_EXPR" !== i ? "TK_START_EXPR" === i && "TK_RESERVED" === d.type && q(d.text, ["const", "let", "const"]) || ":" === f.last_text || ("TK_RESERVED" === d.type && "if" === d.text && "else" === f.last_text ? c.space_before_token = !0 : y()) : "TK_RESERVED" === d.type && q(d.text, o.line_starters) && ")" !== f.last_text && y() : f.multiline_frame && T(f.mode) && "," === f.last_text && "}" === s ? y() : "SPACE" === n && (c.space_before_token = !0);
        _(), f.last_word = d.text, "TK_RESERVED" === d.type && "do" === d.text && (f.do_block = !0), "TK_RESERVED" === d.type && "if" === d.text && (f.if_block = !0)
      }

      i = "TK_START_BLOCK", s = "", (c = new Q(l, m)).raw = h.test_output_raw, t = [], A(X.BlockStatement), this.beautify = function () {
        var e, t;
        for (o = new ee(r, h, l), g = o.tokenize(), a = 0; e = O();) {
          for (var n = 0; n < e.comments_before.length; n++) C(e.comments_before[n]);
          C(e), s = f.last_text, i = e.type, f.last_text = e.text, a += 1
        }
        return t = c.get_code(), h.end_with_newline && (t += "\n"), "\n" != h.eol && (t = t.replace(/[\n]/g, h.eol)), t
      }
    }

    function o(t) {
      var n = 0, r = -1, a = [], o = !0;
      this.set_indent = function (e) {
        n = t.baseIndentLength + e * t.indent_length, r = e
      }, this.get_character_count = function () {
        return n
      }, this.is_empty = function () {
        return o
      }, this.last = function () {
        return this._empty ? null : a[a.length - 1]
      }, this.push = function (e) {
        a.push(e), n += e.length, o = !1
      }, this.pop = function () {
        var e = null;
        return o || (e = a.pop(), n -= e.length, o = 0 === a.length), e
      }, this.remove_indent = function () {
        0 < r && (r -= 1, n -= t.indent_length)
      }, this.trim = function () {
        for (; " " === this.last();) a.pop(), n -= 1;
        o = 0 === a.length
      }, this.toString = function () {
        var e = "";
        return this._empty || (0 <= r && (e = t.indent_cache[r]), e += a.join("")), e
      }
    }

    function Q(t, n) {
      n = n || "", this.indent_cache = [n], this.baseIndentLength = n.length, this.indent_length = t.length, this.raw = !1;
      var r = [];
      this.baseIndentString = n, this.indent_string = t, this.previous_line = null, this.current_line = null, this.space_before_token = !1, this.add_outputline = function () {
        this.previous_line = this.current_line, this.current_line = new o(this), r.push(this.current_line)
      }, this.add_outputline(), this.get_line_number = function () {
        return r.length
      }, this.add_new_line = function (e) {
        return (1 !== this.get_line_number() || !this.just_added_newline()) && (!(!e && this.just_added_newline()) && (this.raw || this.add_outputline(), !0))
      }, this.get_code = function () {
        return r.join("\n").replace(/[\r\n\t ]+$/, "")
      }, this.set_indent = function (e) {
        if (1 < r.length) {
          for (; e >= this.indent_cache.length;) this.indent_cache.push(this.indent_cache[this.indent_cache.length - 1] + this.indent_string);
          return this.current_line.set_indent(e), !0
        }
        return this.current_line.set_indent(0), !1
      }, this.add_raw_token = function (e) {
        for (var t = 0; t < e.newlines; t++) this.add_outputline();
        this.current_line.push(e.whitespace_before), this.current_line.push(e.text), this.space_before_token = !1
      }, this.add_token = function (e) {
        this.add_space_before_token(), this.current_line.push(e)
      }, this.add_space_before_token = function () {
        this.space_before_token && !this.just_added_newline() && this.current_line.push(" "), this.space_before_token = !1
      }, this.remove_redundant_indentation = function (e) {
        if (!e.multiline_frame && e.mode !== X.ForInitializer && e.mode !== X.Conditional) for (var t = e.start_line_index, n = r.length; t < n;) r[t].remove_indent(), t++
      }, this.trim = function (e) {
        for (e = e !== undefined && e, this.current_line.trim(t, n); e && 1 < r.length && this.current_line.is_empty();) r.pop(), this.current_line = r[r.length - 1], this.current_line.trim();
        this.previous_line = 1 < r.length ? r[r.length - 2] : null
      }, this.just_added_newline = function () {
        return this.current_line.is_empty()
      }, this.just_added_blankline = function () {
        return !!this.just_added_newline() && (1 === r.length || r[r.length - 2].is_empty())
      }
    }

    var J = function J(e, t, n, r, a, o) {
      this.type = e, this.text = t, this.comments_before = [], this.newlines = n || 0, this.wanted_newline = 0 < n, this.whitespace_before = r || "", this.parent = null, this.directives = null
    };

    function ee(k, x, e) {
      var R = "\n\r\t ".split(""), M = /[0-9]/, O = /[01234567]/, N = /[0123456789abcdefABCDEF]/,
        I = "+ - * / % & ++ -- = += -= *= /= %= == === != !== > < >= <= >> << >>> >>>= >>= <<= && &= | || ! ~ , : ? ^ ^= |= :: =>".split(" ");
      this.line_starters = "continue,try,throw,return,const,let,const,if,switch,case,default,for,while,break,function,import,export".split(",");
      var D, B, H, $, F, P,
        U = this.line_starters.concat(["do", "in", "else", "get", "set", "new", "catch", "finally", "typeof", "yield", "async", "await"]),
        z = /([\s\S]*?)((?:\*\/)|$)/g, K = /([^\n\r\u2028\u2029]*)/g, V = /\/\* beautify( \w+[:]\w+)+ \*\//g,
        W = / (\w+)[:](\w+)/g, G = /([\s\S]*?)((?:\/\*\sbeautify\signore:end\s\*\/)|$)/g,
        Y = /((<\?php|<\?=)[\s\S]*?\?>)|(<%[\s\S]*?%>)/g;

      function i() {
        var e, t, n = [];
        if (D = 0, B = "", P <= F) return ["", "TK_EOF"];
        t = $.length ? $[$.length - 1] : new J("TK_START_BLOCK", "{");
        var r = k.charAt(F);
        for (F += 1; q(r, R);) {
          if (j.newline.test(r) ? "\n" === r && "\r" === k.charAt(F - 2) || (D += 1, n = []) : n.push(r), P <= F) return ["", "TK_EOF"];
          r = k.charAt(F), F += 1
        }
        if (n.length && (B = n.join("")), M.test(r)) {
          var a = !0, o = !0, i = M;
          for ("0" === r && F < P && /[Xxo]/.test(k.charAt(F)) ? (o = a = !1, r += k.charAt(F), F += 1, i = /[o]/.test(k.charAt(F)) ? O : N) : (r = "", F -= 1); F < P && i.test(k.charAt(F));) r += k.charAt(F), F += 1, a && F < P && "." === k.charAt(F) && (r += k.charAt(F), F += 1, a = !1), o && F < P && /[Ee]/.test(k.charAt(F)) && (r += k.charAt(F), (F += 1) < P && /[+-]/.test(k.charAt(F)) && (r += k.charAt(F), F += 1), a = o = !1);
          return [r, "TK_WORD"]
        }
        if (j.isIdentifierStart(k.charCodeAt(F - 1))) {
          if (F < P) for (; j.isIdentifierChar(k.charCodeAt(F)) && (r += k.charAt(F), (F += 1) !== P);) ;
          return "TK_DOT" === t.type || "TK_RESERVED" === t.type && q(t.text, ["set", "get"]) || !q(r, U) ? [r, "TK_WORD"] : "in" === r ? [r, "TK_OPERATOR"] : [r, "TK_RESERVED"]
        }
        if ("(" === r || "[" === r) return [r, "TK_START_EXPR"];
        if (")" === r || "]" === r) return [r, "TK_END_EXPR"];
        if ("{" === r) return [r, "TK_START_BLOCK"];
        if ("}" === r) return [r, "TK_END_BLOCK"];
        if (" " === r) return [r, "TK_SEMICOLON"];
        if ("/" === r) {
          var s = "";
          if ("*" === k.charAt(F)) {
            F += 1, z.lastIndex = F;
            var l = z.exec(k);
            s = "/*".concat(l[0]), F += l[0].length;
            var c = function T(e) {
              if (!e.match(V)) return null;
              var t = {};
              W.lastIndex = 0;
              for (var n = W.exec(e); n;) t[n[1]] = n[2], n = W.exec(e);
              return t
            }(s);
            return c && "start" === c.ignore && (G.lastIndex = F, s += (l = G.exec(k))[0], F += l[0].length), [s = s.replace(j.lineBreak, "\n"), "TK_BLOCK_COMMENT", c]
          }
          if ("/" === k.charAt(F)) {
            F += 1, K.lastIndex = F;
            var d = K.exec(k);
            return s = "//".concat(d[0]), F += d[0].length, [s, "TK_COMMENT"]
          }
        }
        if ("`" === r || "'" === r || '"' === r || ("/" === r || x.e4x && "<" === r && k.slice(F - 1).match(/^<([-a-zA-Z:0-9_.]+|{[^{}]*}|!\[CDATA\[[\s\S]*?\]\])(\s+[-a-zA-Z:0-9_.]+\s*=\s*('[^']*'|"[^"]*"|{.*?}))*\s*(\/?)\s*>/)) && ("TK_RESERVED" === t.type && q(t.text, ["return", "case", "throw", "else", "do", "typeof", "yield"]) || "TK_END_EXPR" === t.type && ")" === t.text && t.parent && "TK_RESERVED" === t.parent.type && q(t.parent.text, ["if", "while", "for"]) || q(t.type, ["TK_COMMENT", "TK_START_EXPR", "TK_START_BLOCK", "TK_END_BLOCK", "TK_OPERATOR", "TK_EQUALS", "TK_EOF", "TK_SEMICOLON", "TK_COMMA"]))) {
          var f = r, p = !1, u = !1;
          if (e = r, "/" === f) for (var h = !1; F < P && (p || h || k.charAt(F) !== f) && !j.newline.test(k.charAt(F));) e += k.charAt(F), p ? p = !1 : (p = "\\" === k.charAt(F), "[" === k.charAt(F) ? h = !0 : "]" === k.charAt(F) && (h = !1)), F += 1; else if (x.e4x && "<" === f) {
            var g = /<(\/?)([-a-zA-Z:0-9_.]+|{[^{}]*}|!\[CDATA\[[\s\S]*?\]\])(\s+[-a-zA-Z:0-9_.]+\s*=\s*('[^']*'|"[^"]*"|{.*?}))*\s*(\/?)\s*>/g,
              m = k.slice(F - 1), v = g.exec(m);
            if (v && 0 === v.index) {
              for (var b = v[2], C = 0; v;) {
                var E = !!v[1], y = v[2], L = !!v[v.length - 1] || "![CDATA[" === y.slice(0, 8);
                if (y !== b || L || (E ? --C : ++C), C <= 0) break;
                v = g.exec(m)
              }
              var _ = v ? v.index + v[0].length : m.length;
              return m = m.slice(0, _), F += _ - 1, [m = m.replace(j.lineBreak, "\n"), "TK_STRING"]
            }
          } else for (; F < P && (p || k.charAt(F) !== f && ("`" === f || !j.newline.test(k.charAt(F))));) (p || "`" === f) && j.newline.test(k.charAt(F)) ? ("\r" === k.charAt(F) && "\n" === k.charAt(F + 1) && (F += 1), e += "\n") : e += k.charAt(F), p = p ? ("x" !== k.charAt(F) && "u" !== k.charAt(F) || (u = !0), !1) : "\\" === k.charAt(F), F += 1;
          if (u && x.unescape_strings && (e = function S(e) {
            var t, n = !1, r = "", a = 0, o = "", i = 0;
            for (; n || a < e.length;) if (t = e.charAt(a), a++, n) {
              if (n = !1, "x" === t) o = e.substr(a, 2), a += 2; else {
                if ("u" !== t) {
                  r += "\\".concat(t);
                  continue
                }
                o = e.substr(a, 4), a += 4
              }
              if (!o.match(/^[0123456789abcdefABCDEF]+$/)) return e;
              if (0 <= (i = parseInt(o, 16)) && i < 32) {
                r += "x" === t ? "\\x".concat(o) : "\\u".concat(o);
                continue
              }
              if (34 === i || 39 === i || 92 === i) r += "\\".concat(String.fromCharCode(i)); else {
                if ("x" === t && 126 < i && i <= 255) return e;
                r += String.fromCharCode(i)
              }
            } else "\\" === t ? n = !0 : r += t;
            return r
          }(e)), F < P && k.charAt(F) === f && (e += f, F += 1, "/" === f)) for (; F < P && j.isIdentifierStart(k.charCodeAt(F));) e += k.charAt(F), F += 1;
          return [e, "TK_STRING"]
        }
        if ("#" === r) {
          if (0 === $.length && "!" === k.charAt(F)) {
            for (e = r; F < P && "\n" !== r;) e += r = k.charAt(F), F += 1;
            return ["".concat(Z(e), "\n"), "TK_UNKNOWN"]
          }
          var w = "#";
          if (F < P && M.test(k.charAt(F))) {
            for (; w += r = k.charAt(F), (F += 1) < P && "#" !== r && "=" !== r;) ;
            return "#" === r || ("[" === k.charAt(F) && "]" === k.charAt(F + 1) ? (w += "[]", F += 2) : "{" === k.charAt(F) && "}" === k.charAt(F + 1) && (w += "{}", F += 2)), [w, "TK_WORD"]
          }
        }
        if ("<" === r && ("?" === k.charAt(F) || "%" === k.charAt(F))) {
          Y.lastIndex = F - 1;
          var A = Y.exec(k);
          if (A) return r = A[0], F += r.length - 1, [r = r.replace(j.lineBreak, "\n"), "TK_STRING"]
        }
        if ("<" === r && "\x3c!--" === k.substring(F - 1, F + 3)) {
          for (F += 3, r = "\x3c!--"; !j.newline.test(k.charAt(F)) && F < P;) r += k.charAt(F), F++;
          return H = !0, [r, "TK_COMMENT"]
        }
        if ("-" === r && H && "--\x3e" === k.substring(F - 1, F + 2)) return H = !1, F += 2, ["--\x3e", "TK_COMMENT"];
        if ("." === r) return [r, "TK_DOT"];
        if (q(r, I)) {
          for (; F < P && q(r + k.charAt(F), I) && (r += k.charAt(F), !(P <= (F += 1)));) ;
          return "," === r ? [r, "TK_COMMA"] : "=" === r ? [r, "TK_EQUALS"] : [r, "TK_OPERATOR"]
        }
        return [r, "TK_UNKNOWN"]
      }

      this.tokenize = function () {
        var e, t, n;
        P = k.length, F = 0, H = !1, $ = [];
        for (var r = null, a = [], o = []; !t || "TK_EOF" !== t.type;) {
          for (n = i(), e = new J(n[1], n[0], D, B); "TK_COMMENT" === e.type || "TK_BLOCK_COMMENT" === e.type || "TK_UNKNOWN" === e.type;) "TK_BLOCK_COMMENT" === e.type && (e.directives = n[2]), o.push(e), n = i(), e = new J(n[1], n[0], D, B);
          o.length && (e.comments_before = o, o = []), "TK_START_BLOCK" === e.type || "TK_START_EXPR" === e.type ? (e.parent = t, a.push(r), r = e) : ("TK_END_BLOCK" === e.type || "TK_END_EXPR" === e.type) && r && ("]" === e.text && "[" === r.text || ")" === e.text && "(" === r.text || "}" === e.text && "{" === r.text) && (e.parent = r.parent, r = a.pop()), $.push(e), t = e
        }
        return $
      }
    }

    return {
      run: function M(e, t) {
        function i(e) {
          return e.replace(/\s+$/g, "")
        }

        var n, r, a, m, o, s, v, l, c, b, C, E, d, f;
        for ((t = t || {}).wrap_line_length !== undefined && 0 !== parseInt(t.wrap_line_length, 10) || t.max_char === undefined || 0 === parseInt(t.max_char, 10) || (t.wrap_line_length = t.max_char), r = t.indent_inner_html !== undefined && t.indent_inner_html, a = t.indent_size === undefined ? 4 : parseInt(t.indent_size, 10), m = t.indent_char === undefined ? " " : t.indent_char, s = t.brace_style === undefined ? "collapse" : t.brace_style, o = 0 === parseInt(t.wrap_line_length, 10) ? 32786 : parseInt(t.wrap_line_length || 250, 10), v = t.unformatted || ["a", "span", "img", "bdo", "em", "strong", "dfn", "code", "samp", "kbd", "const", "cite", "abbr", "acronym", "q", "sub", "sup", "tt", "i", "b", "big", "small", "u", "s", "strike", "font", "ins", "del", "address", "pre"], l = t.preserve_newlines === undefined || t.preserve_newlines, c = l ? isNaN(parseInt(t.max_preserve_newlines, 10)) ? 32786 : parseInt(t.max_preserve_newlines, 10) : 0, b = t.indent_handlebars !== undefined && t.indent_handlebars, C = t.wrap_attributes === undefined ? "auto" : t.wrap_attributes, E = t.wrap_attributes_indent_size === undefined ? a : parseInt(t.wrap_attributes_indent_size, 10) || a, d = t.end_with_newline !== undefined && t.end_with_newline, f = Array.isArray(t.extra_liners) ? t.extra_liners.concat() : "string" == typeof t.extra_liners ? t.extra_liners.split(",") : "head,body,/html".split(","), t.indent_with_tabs && (m = "\t", a = 1), (n = new function k() {
          return this.pos = 0, this.token = "", this.current_mode = "CONTENT", this.tags = {
            parent: "parent1",
            parentcount: 1,
            parent1: ""
          }, this.tag_type = "", this.token_text = this.last_token = this.last_text = this.token_type = "", this.newlines = 0, this.indent_content = r, this.Utils = {
            whitespace: "\n\r\t ".split(""),
            single_token: "br,input,link,meta,source,!doctype,basefont,base,area,hr,wbr,param,img,isindex,embed".split(","),
            extra_liners: f,
            in_array: function (e, t) {
              for (var n = 0; n < t.length; n++) if (e === t[n]) return !0;
              return !1
            }
          }, this.is_whitespace = function (e) {
            for (; 0 < e.length; e++) if (!this.Utils.in_array(e.charAt(0), this.Utils.whitespace)) return !1;
            return !0
          }, this.traverse_whitespace = function () {
            var e = "";
            if (e = this.input.charAt(this.pos), this.Utils.in_array(e, this.Utils.whitespace)) {
              for (this.newlines = 0; this.Utils.in_array(e, this.Utils.whitespace);) l && "\n" === e && this.newlines <= c && (this.newlines += 1), this.pos++, e = this.input.charAt(this.pos);
              return !0
            }
            return !1
          }, this.space_or_wrap = function (e) {
            this.line_char_count >= this.wrap_line_length ? (this.print_newline(!1, e), this.print_indentation(e)) : (this.line_char_count++, e.push(" "))
          }, this.get_content = function () {
            for (var e = "", t = []; "<" != this.input.charAt(this.pos);) {
              if (this.pos >= this.input.length) return t.length ? t.join("") : ["", "TK_EOF"];
              if (this.traverse_whitespace()) this.space_or_wrap(t); else {
                if (b) {
                  var n = this.input.substr(this.pos, 3);
                  if ("{{#" === n || "{{/" === n) break;
                  if ("{{!" === n) return [this.get_tag(), "TK_TAG_HANDLEBARS_COMMENT"];
                  if ("{{" === this.input.substr(this.pos, 2) && "{{else}}" === this.get_tag(!0)) break
                }
                e = this.input.charAt(this.pos), this.pos++, this.line_char_count++, t.push(e)
              }
            }
            return t.length ? t.join("") : ""
          }, this.get_contents_to = function (e) {
            if (this.pos === this.input.length) return ["", "TK_EOF"];
            var t = "", n = new RegExp("</".concat(e, "\\s*>"), "igm");
            n.lastIndex = this.pos;
            var r = n.exec(this.input), a = r ? r.index : this.input.length;
            return this.pos < a && (t = this.input.substring(this.pos, a), this.pos = a), t
          }, this.record_tag = function (e) {
            this.tags["".concat(e, "count")] ? this.tags["".concat(e, "count")]++ : this.tags["".concat(e, "count")] = 1, this.tags[e + this.tags["".concat(e, "count")]] = this.indent_level, this.tags[e + this.tags["".concat(e, "count")] + "parent"] = this.tags.parent, this.tags.parent = e + this.tags["".concat(e, "count")]
          }, this.retrieve_tag = function (e) {
            if (this.tags["".concat(e, "count")]) {
              for (var t = this.tags.parent; t && e + this.tags["".concat(e, "count")] !== t;) t = this.tags["".concat(t, "parent")];
              t && (this.indent_level = this.tags[e + this.tags["".concat(e, "count")]], this.tags.parent = this.tags[t + "parent"]), delete this.tags[e + this.tags["".concat(e, "count")] + "parent"], delete this.tags[e + this.tags["".concat(e, "count")]], 1 === this.tags["".concat(e, "count")] ? delete this.tags["".concat(e, "count")] : this.tags["".concat(e, "count")]--
            }
          }, this.indent_to_tag = function (e) {
            if (this.tags["".concat(e, "count")]) {
              for (var t = this.tags.parent; t && e + this.tags["".concat(e, "count")] !== t;) t = this.tags["".concat(t, "parent")];
              t && (this.indent_level = this.tags[e + this.tags["".concat(e, "count")]])
            }
          }, this.get_tag = function (e) {
            var t, n, r = "", a = [], o = "", i = !1, s = !0, l = this.pos, c = this.line_char_count;
            e = e !== undefined && e;
            do {
              if (this.pos >= this.input.length) return e && (this.pos = l, this.line_char_count = c), a.length ? a.join("") : ["", "TK_EOF"];
              if (r = this.input.charAt(this.pos), this.pos++, this.Utils.in_array(r, this.Utils.whitespace)) i = !0; else {
                if ("'" !== r && '"' !== r || (r += this.get_unformatted(r), i = !0), "=" === r && (i = !1), a.length && "=" != a[a.length - 1] && ">" != r && i) {
                  if (this.space_or_wrap(a), i = !1, !s && "force" === C && "/" != r) {
                    this.print_newline(!0, a), this.print_indentation(a);
                    for (var d = 0; d < E; d++) a.push(m)
                  }
                  for (var f = 0; f < a.length; f++) if (" " === a[f]) {
                    s = !1;
                    break
                  }
                }
                if (b && "<" === n && r + this.input.charAt(this.pos) === "{{" && (r += this.get_unformatted("}}"), a.length && " " != a[a.length - 1] && "<" != a[a.length - 1] && (r = " ".concat(r)), i = !0), "<" !== r || n || (t = this.pos - 1, n = "<"), b && !n && 2 <= a.length && "{" === a[a.length - 1] && "{" === a[a.length - 2] && (t = "#" === r || "/" === r || "!" === r ? this.pos - 3 : this.pos - 2, n = "{"), this.line_char_count++, a.push(r), a[1] && ("!" === a[1] || "?" === a[1] || "%" === a[1])) {
                  a = [this.get_comment(t)];
                  break
                }
                if (b && a[1] && "{" === a[1] && a[2] && "!" === a[2]) {
                  a = [this.get_comment(t)];
                  break
                }
                if (b && "{" === n && 2 < a.length && "}" === a[a.length - 2] && "}" === a[a.length - 1]) break
              }
            } while (">" != r);
            var p, u, h = a.join("");
            p = -1 != h.indexOf(" ") ? h.indexOf(" ") : "{" === h[0] ? h.indexOf("}") : h.indexOf(">"), u = "<" !== h[0] && b ? "#" === h[2] ? 3 : 2 : 1;
            var g = h.substring(u, p).toLowerCase();
            return "/" === h.charAt(h.length - 2) || this.Utils.in_array(g, this.Utils.single_token) ? e || (this.tag_type = "SINGLE") : b && "{" === h[0] && "else" === g ? e || (this.indent_to_tag("if"), this.tag_type = "HANDLEBARS_ELSE", this.indent_content = !0, this.traverse_whitespace()) : this.is_unformatted(g, v) ? (o = this.get_unformatted("</".concat(g, ">"), h), a.push(o), this.pos, this.tag_type = "SINGLE") : "script" === g && (-1 === h.search("type") || -1 < h.search("type") && -1 < h.search(/\b(text|application)\/(x-)?(javascript|ecmascript|jscript|livescript)/)) ? e || (this.record_tag(g), this.tag_type = "SCRIPT") : "style" === g && (-1 === h.search("type") || -1 < h.search("type") && -1 < h.search("text/css")) ? e || (this.record_tag(g), this.tag_type = "STYLE") : "!" === g.charAt(0) ? e || (this.tag_type = "SINGLE", this.traverse_whitespace()) : e || ("/" === g.charAt(0) ? (this.retrieve_tag(g.substring(1)), this.tag_type = "END") : (this.record_tag(g), "html" != g.toLowerCase() && (this.indent_content = !0), this.tag_type = "START"), this.traverse_whitespace() && this.space_or_wrap(a), this.Utils.in_array(g, this.Utils.extra_liners) && (this.print_newline(!1, this.output), this.output.length && "\n" != this.output[this.output.length - 2] && this.print_newline(!0, this.output))), e && (this.pos = l, this.line_char_count = c), a.join("")
          }, this.get_comment = function (e) {
            var t = "", n = ">", r = !1;
            this.pos = e;
            var a = this.input.charAt(this.pos);
            for (this.pos++; this.pos <= this.input.length && ((t += a)[t.length - 1] !== n[n.length - 1] || -1 == t.indexOf(n));) !r && t.length < 10 && (0 === t.indexOf("<![if") ? (n = "<![endif]>", r = !0) : 0 === t.indexOf("<![cdata[") ? (n = "]]>", r = !0) : 0 === t.indexOf("<![") ? (n = "]>", r = !0) : 0 === t.indexOf("\x3c!--") ? (n = "--\x3e", r = !0) : 0 === t.indexOf("{{!") ? (n = "}}", r = !0) : 0 === t.indexOf("<?") ? (n = "?>", r = !0) : 0 === t.indexOf("<%") && (n = "%>", r = !0)), a = this.input.charAt(this.pos), this.pos++;
            return t
          }, this.get_unformatted = function (e, t) {
            if (t && -1 != t.toLowerCase().indexOf(e)) return "";
            var n = "", r = "", a = 0, o = !0;
            do {
              if (this.pos >= this.input.length) return r;
              if (n = this.input.charAt(this.pos), this.pos++, this.Utils.in_array(n, this.Utils.whitespace)) {
                if (!o) {
                  this.line_char_count--;
                  continue
                }
                if ("\n" === n || "\r" === n) {
                  r += "\n", this.line_char_count = 0;
                  continue
                }
              }
              r += n, this.line_char_count++, o = !0, b && "{" === n && r.length && "{" === r[r.length - 2] && (a = (r += this.get_unformatted("}}")).length)
            } while (-1 === r.toLowerCase().indexOf(e, a));
            return r
          }, this.get_token = function () {
            var e;
            if ("TK_TAG_SCRIPT" !== this.last_token && "TK_TAG_STYLE" !== this.last_token) return "CONTENT" === this.current_mode ? "string" != typeof (e = this.get_content()) ? e : [e, "TK_CONTENT"] : "TAG" === this.current_mode ? "string" != typeof (e = this.get_tag()) ? e : [e, "TK_TAG_".concat(this.tag_type)] : void 0;
            var t = this.last_token.substr(7);
            return "string" != typeof (e = this.get_contents_to(t)) ? e : [e, "TK_".concat(t)]
          }, this.get_full_indent = function (e) {
            return (e = this.indent_level + e || 0) < 1 ? "" : new Array(e + 1).join(this.indent_string)
          }, this.is_unformatted = function (e, t) {
            if (!this.Utils.in_array(e, t)) return !1;
            if ("a" != e.toLowerCase() || !this.Utils.in_array("a", t)) return !0;
            var n = (this.get_tag(!0) || "").match(/^\s*<\s*\/?([a-z]*)\s*[^>]*>\s*$/);
            return !(n && !this.Utils.in_array(n, t))
          }, this.printer = function (e, t, n, r, a) {
            this.input = e || "", this.output = [], this.indent_character = t, this.indent_string = "", this.indent_size = n, this.brace_style = a, this.indent_level = 0, this.wrap_line_length = r;
            for (var o = this.line_char_count = 0; o < this.indent_size; o++) this.indent_string += this.indent_character;
            this.print_newline = function (e, t) {
              this.line_char_count = 0, t && t.length && (e || "\n" != t[t.length - 1]) && ("\n" != t[t.length - 1] && (t[t.length - 1] = i(t[t.length - 1])), t.push("\n"))
            }, this.print_indentation = function (e) {
              for (var t = 0; t < this.indent_level; t++) e.push(this.indent_string), this.line_char_count += this.indent_string.length
            }, this.print_token = function (e) {
              this.is_whitespace(e) && !this.output.length || ((e || "" !== e) && this.output.length && "\n" === this.output[this.output.length - 1] && (this.print_indentation(this.output), e = function t(e) {
                return e.replace(/^\s+/g, "")
              }(e)), this.print_token_raw(e))
            }, this.print_token_raw = function (e) {
              0 < this.newlines && (e = i(e)), e && "" !== e && (1 < e.length && "\n" === e[e.length - 1] ? (this.output.push(e.slice(0, -1)), this.print_newline(!1, this.output)) : this.output.push(e));
              for (var t = 0; t < this.newlines; t++) this.print_newline(0 < t, this.output);
              this.newlines = 0
            }, this.indent = function () {
              this.indent_level++
            }, this.unindent = function () {
              0 < this.indent_level && this.indent_level--
            }
          }, this
        }).printer(e, m, a, o, s); ;) {
          var p = n.get_token();
          if (n.token_text = p[0], n.token_type = p[1], "TK_EOF" === n.token_type) break;
          switch (n.token_type) {
            case"TK_TAG_START":
              n.print_newline(!1, n.output), n.print_token(n.token_text), n.indent_content && (n.indent(), n.indent_content = !1), n.current_mode = "CONTENT";
              break;
            case"TK_TAG_STYLE":
            case"TK_TAG_SCRIPT":
              n.print_newline(!1, n.output), n.print_token(n.token_text), n.current_mode = "CONTENT";
              break;
            case"TK_TAG_END":
              if ("TK_CONTENT" === n.last_token && "" === n.last_text) {
                var u = n.token_text.match(/\w+/)[0], h = null;
                n.output.length && (h = n.output[n.output.length - 1].match(/(?:<|{{#)\/?\s*(\w+)/)), (null === h || h[1] != u && !n.Utils.in_array(h[1], v)) && n.print_newline(!1, n.output)
              }
              n.print_token(n.token_text), n.current_mode = "CONTENT";
              break;
            case"TK_TAG_SINGLE":
              var g = n.token_text.match(/^\s*<([a-z-]+)/i);
              g && n.Utils.in_array(g[1], v) || n.print_newline(!1, n.output), n.print_token(n.token_text), n.current_mode = "CONTENT";
              break;
            case"TK_TAG_HANDLEBARS_ELSE":
              n.print_token(n.token_text), n.indent_content && (n.indent(), n.indent_content = !1), n.current_mode = "CONTENT";
              break;
            case"TK_TAG_HANDLEBARS_COMMENT":
            case"TK_CONTENT":
              n.print_token(n.token_text), n.current_mode = "TAG";
              break;
            case"TK_STYLE":
            case"TK_SCRIPT":
              if ("" !== n.token_text) {
                n.print_newline(!1, n.output);
                var y = n.token_text, L = void 0, _ = 1;
                "TK_SCRIPT" === n.token_type ? L = R : "TK_STYLE" === n.token_type && (L = x), "keep" === t.indent_scripts ? _ = 0 : "separate" === t.indent_scripts && (_ = -n.indent_level);
                var w = n.get_full_indent(_);
                if (L) y = L(y.replace(/^\s*/, w), t); else {
                  var A = y.match(/^\s*/)[0].match(/[^\n\r]*$/)[0].split(n.indent_string).length - 1,
                    T = n.get_full_indent(_ - A);
                  y = y.replace(/^\s*/, w).replace(/\r\n|\r|\n/g, "\n" + T).replace(/\s+$/, "")
                }
                y && (n.print_token_raw(y), n.print_newline(!0, n.output))
              }
              n.current_mode = "TAG";
              break;
            default:
              "" !== n.token_text && n.print_token(n.token_text)
          }
          n.last_token = n.token_type, n.last_text = n.token_text
        }
        var S = n.output.join("").replace(/[\r\n\t ]+$/, "");
        return d && (S += "\n"), S
      }
    }
  }, Object.assign(xt.DEFAULTS, {
    codeMirror: window.CodeMirror,
    codeMirrorOptions: {
      lineNumbers: !0,
      tabMode: "indent",
      indentWithTabs: !0,
      lineWrapping: !0,
      mode: "text/html",
      tabSize: 2
    },
    codeBeautifierOptions: {
      end_with_newline: !0,
      indent_inner_html: !0,
      extra_liners: ["p", "h1", "h2", "h3", "h4", "h5", "h6", "blockquote", "pre", "ul", "ol", "table", "dl"],
      brace_style: "expand",
      indent_char: "\t",
      indent_size: 1,
      wrap_line_length: 0
    },
    codeViewKeepActiveButtons: ["fullscreen"]
  }), xt.PLUGINS.codeView = function (c) {
    var d, f, p = c.$, u = function u() {
      return c.$box.hasClass("fr-code-view")
    };

    function h() {
      return f ? f.getValue() : d.val()
    }

    function g() {
      u() && (f && f.setSize(null, c.opts.height ? c.opts.height : "auto"), c.opts.heightMin || c.opts.height ? (c.$box.find(".CodeMirror-scroll, .CodeMirror-gutters").css("min-height", c.opts.heightMin || c.opts.height), d.css("height", c.opts.height)) : c.$box.find(".CodeMirror-scroll, .CodeMirror-gutters").css("min-height", ""))
    }

    var m, v = !1;

    function b() {
      u() && c.events.trigger("blur")
    }

    function C() {
      u() && v && c.events.trigger("focus")
    }

    function r(e) {
      d || (!function l() {
        d = p('<textarea class="fr-code" tabIndex="-1">'), c.$wp.append(d), d.attr("dir", c.opts.direction), c.$box.hasClass("fr-basic") || (m = p('<a data-cmd="html" title="Code View" class="fr-command fr-btn html-switch'.concat(c.helpers.isMobile() ? "" : " fr-desktop", '" role="button" tabIndex="-1"><i class="fa fa-code"></i></button>')), c.$box.append(m), c.events.bindClick(c.$box, "a.html-switch", function () {
          c.events.trigger("commands.before", ["html"]), E(!1), c.events.trigger("commands.after", ["html"])
        }));
        var e = function e() {
          return !u()
        };
        c.events.on("buttons.refresh", e), c.events.on("copy", e, !0), c.events.on("cut", e, !0), c.events.on("paste", e, !0), c.events.on("destroy", y, !0), c.events.on("html.set", function () {
          u() && E(!0)
        }), c.events.on("codeView.update", g), c.events.on("codeView.toggle", function () {
          c.$box.hasClass("fr-code-view") && E()
        }), c.events.on("form.submit", function () {
          u() && (c.html.set(h()), c.events.trigger("contentChanged", [], !0))
        }, !0)
      }(), !f && c.opts.codeMirror ? ((f = c.opts.codeMirror.fromTextArea(d.get(0), c.opts.codeMirrorOptions)).on("blur", b), f.on("focus", C)) : (c.events.$on(d, "keydown keyup change input", function () {
        c.opts.height ? this.removeAttribute("rows") : (this.rows = 1, 0 === this.value.length ? this.style.height = "auto" : this.style.height = "".concat(this.scrollHeight, "px"))
      }), c.events.$on(d, "blur", b), c.events.$on(d, "focus", C))), c.undo.saveStep(), c.html.cleanEmptyTags(), c.html.cleanWhiteTags(!0), c.core.hasFocus() && (c.core.isEmpty() || (c.selection.save(), c.$el.find('.fr-marker[data-type="true"]').first().replaceWith('<span class="fr-tmp fr-sm">F</span>'), c.$el.find('.fr-marker[data-type="false"]').last().replaceWith('<span class="fr-tmp fr-em">F</span>')));
      var t = c.html.get(!1, !0);
      c.$el.find("span.fr-tmp").remove(), c.$box.toggleClass("fr-code-view", !0);
      var n, r, a = !1;
      if (c.core.hasFocus() && (a = !0, c.events.disableBlur(), c.$el.blur()), t = (t = t.replace(/<span class="fr-tmp fr-sm">F<\/span>/, "FROALA-SM")).replace(/<span class="fr-tmp fr-em">F<\/span>/, "FROALA-EM"), c.codeBeautifier && !t.includes("fr-embedly") && (t = c.codeBeautifier.run(t, c.opts.codeBeautifierOptions)), f) {
        n = t.indexOf("FROALA-SM"), (r = t.indexOf("FROALA-EM")) < n ? n = r : r -= 9;
        var o = (t = t.replace(/FROALA-SM/g, "").replace(/FROALA-EM/g, "")).substring(0, n).length - t.substring(0, n).replace(/\n/g, "").length,
          i = t.substring(0, r).length - t.substring(0, r).replace(/\n/g, "").length;
        n = t.substring(0, n).length - t.substring(0, t.substring(0, n).lastIndexOf("\n") + 1).length, r = t.substring(0, r).length - t.substring(0, t.substring(0, r).lastIndexOf("\n") + 1).length, f.setSize(null, c.opts.height ? c.opts.height : "auto"), c.opts.heightMin && c.$box.find(".CodeMirror-scroll").css("min-height", c.opts.heightMin), f.setValue(t), v = !a, f.focus(), v = !0, f.setSelection({
          line: o,
          ch: n
        }, {line: i, ch: r}), f.refresh(), f.clearHistory()
      } else {
        n = t.indexOf("FROALA-SM"), r = t.indexOf("FROALA-EM") - 9, c.opts.heightMin && d.css("min-height", c.opts.heightMin), c.opts.height && d.css("height", c.opts.height), c.opts.heightMax && d.css("max-height", c.opts.height || c.opts.heightMax), d.val(t.replace(/FROALA-SM/g, "").replace(/FROALA-EM/g, "")).trigger("change");
        var s = p(c.o_doc).scrollTop();
        v = !a, d.focus(), v = !0, d.get(0).setSelectionRange(n, r), p(c.o_doc).scrollTop(s)
      }
      c.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command, .fr-btn-grp > .fr-btn-wrap > .fr-command, .fr-more-toolbar > .fr-btn-wrap > .fr-command").not(e).filter(function () {
        return c.opts.codeViewKeepActiveButtons.indexOf(p(this).data("cmd")) < 0
      }).addClass("fr-disabled").attr("aria-disabled", !0), e.addClass("fr-active").attr("aria-pressed", !0), !c.helpers.isMobile() && c.opts.toolbarInline && c.toolbar.hide()
    }

    function E(e) {
      void 0 === e && (e = !u());
      var t = c.$tb.find('.fr-command[data-cmd="html"]');
      e ? (c.popups.hideAll(), r(t)) : (c.$box.toggleClass("fr-code-view", !1), function n(e) {
        var t = h();
        c.html.set(t), c.$el.blur(), c.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command, .fr-btn-grp > .fr-btn-wrap > .fr-command, .fr-more-toolbar > .fr-btn-wrap > .fr-command").not(e).removeClass("fr-disabled").attr("aria-disabled", !1), e.removeClass("fr-active").attr("aria-pressed", !1), c.selection.setAtStart(c.el), c.selection.restore(), c.placeholder.refresh(), c.undo.saveStep()
      }(t), c.events.trigger("codeView.update"))
    }

    function y() {
      u() && E(!1), f && f.toTextArea(), d.val("").removeData().remove(), d = null, m && (m.remove(), m = null)
    }

    return {
      _init: function e() {
        if (c.events.on("focus", function () {
          c.opts.toolbarContainer && function t() {
            var e = c.$tb.find('.fr-command[data-cmd="html"]');
            u() ? (c.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command").not(e).filter(function () {
              return c.opts.codeViewKeepActiveButtons.indexOf(p(this).data("cmd")) < 0
            }).addClass("fr-disabled").attr("aria-disabled", !1), e.addClass("fr-active").attr("aria-pressed", !1)) : (c.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command").not(e).removeClass("fr-disabled").attr("aria-disabled", !1), e.removeClass("fr-active").attr("aria-pressed", !1))
          }()
        }), !c.$wp) return !1
      }, toggle: E, isActive: u, get: h
    }
  }, xt.RegisterCommand("html", {
    title: "Code View",
    undo: !1,
    focus: !1,
    forcedRefresh: !0,
    toggle: !0,
    callback: function () {
      this.codeView.toggle()
    },
    plugin: "codeView"
  }), xt.DefineIcon("html", {
    NAME: "code",
    SVG_KEY: "codeView"
  }), Object.assign(xt.POPUP_TEMPLATES, {
    "textColor.picker": "[_BUTTONS_][_TEXT_COLORS_][_CUSTOM_COLOR_]",
    "backgroundColor.picker": "[_BUTTONS_][_BACKGROUND_COLORS_][_CUSTOM_COLOR_]"
  }), Object.assign(xt.DEFAULTS, {
    colorsText: ["#61BD6D", "#1ABC9C", "#54ACD2", "#2C82C9", "#9365B8", "#475577", "#CCCCCC", "#41A85F", "#00A885", "#3D8EB9", "#2969B0", "#553982", "#28324E", "#000000", "#F7DA64", "#FBA026", "#EB6B56", "#E25041", "#A38F84", "#EFEFEF", "#FFFFFF", "#FAC51C", "#F37934", "#D14841", "#B8312F", "#7C706B", "#D1D5D8", "REMOVE"],
    colorsBackground: ["#61BD6D", "#1ABC9C", "#54ACD2", "#2C82C9", "#9365B8", "#475577", "#CCCCCC", "#41A85F", "#00A885", "#3D8EB9", "#2969B0", "#553982", "#28324E", "#000000", "#F7DA64", "#FBA026", "#EB6B56", "#E25041", "#A38F84", "#EFEFEF", "#FFFFFF", "#FAC51C", "#F37934", "#D14841", "#B8312F", "#7C706B", "#D1D5D8", "REMOVE"],
    colorsStep: 7,
    colorsHEXInput: !0,
    colorsButtons: ["colorsBack", "|", "-"]
  }), xt.PLUGINS.colors = function (m) {
    var v = m.$,
      s = '<div class="fr-color-hex-layer fr-active fr-layer" id="fr-color-hex-layer- \n  '.concat(m.id, '"><div class="fr-input-line"><input maxlength="7" id="[ID]"\n  type="text" placeholder="').concat(m.language.translate("HEX Color"), '" \n  tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><button \n  type="button" class="fr-command fr-submit" data-cmd="[COMMAND]" tabIndex="2" role="button">\n  ').concat(m.language.translate("OK"), "</button></div></div>");

    function l(e) {
      for (var t = "text" === e ? m.opts.colorsText : m.opts.colorsBackground, n = '<div class="fr-color-set fr-'.concat(e, '-color fr-selected-set">'), r = 0; r < t.length; r++) 0 !== r && r % m.opts.colorsStep == 0 && (n += "<br>"), "REMOVE" !== t[r] ? n += '<span class="fr-command fr-select-color" style="background:'.concat(t[r], ';" \n        tabIndex="-1" aria-selected="false" role="button" data-cmd="apply').concat(e, 'Color" \n        data-param1="').concat(t[r], '"><span class="fr-sr-only"> ').concat(m.language.translate("Color")).concat(t[r], " \n        &nbsp;&nbsp;&nbsp;</span></span>") : n += '<span class="fr-command fr-select-color" data-cmd="apply'.concat(e, 'Color"\n         tabIndex="-1" role="button" data-param1="REMOVE" \n         title="').concat(m.language.translate("Clear Formatting"), '">').concat(m.icon.create("remove"), ' \n        <span class="fr-sr-only"> ').concat(m.language.translate("Clear Formatting"), " </span></span>");
      return "".concat(n, "</div>")
    }

    function c(e) {
      var t, n = m.popups.get("".concat(e, "Color.picker")), r = v(m.selection.element());
      t = "background" === e ? "background-color" : "color";
      var a = n.find(".fr-".concat(e, "-color .fr-select-color"));
      for (a.find(".fr-selected-color").remove(), a.removeClass("fr-active-item"), a.not('[data-param1="REMOVE"]').attr("aria-selected", !1); r.get(0) !== m.el;) {
        if ("transparent" !== r.css(t) && "rgba(0, 0, 0, 0)" !== r.css(t)) {
          var o = n.find(".fr-".concat(e, '-color .fr-select-color[data-param1="').concat(m.helpers.RGBToHex(r.css(t)), '"]'));
          o.append('<span class="fr-selected-color" aria-hidden="true">\uf00c</span>'), o.addClass("fr-active-item").attr("aria-selected", !0);
          break
        }
        r = r.parent()
      }
      !function i(e) {
        var t = m.popups.get("".concat(e, "Color.picker")),
          n = t.find(".fr-".concat(e, "-color .fr-active-item")).attr("data-param1"),
          r = t.find(".fr-color-hex-layer input");
        n || (n = "");
        r.length && v(r.val(n).input).trigger("change")
      }(e)
    }

    function r(e) {
      "REMOVE" !== e ? m.format.applyStyle("background-color", m.helpers.HEXtoRGB(e)) : m.format.removeStyle("background-color"), m.popups.hide("backgroundColor.picker")
    }

    function a(e) {
      "REMOVE" !== e ? m.format.applyStyle("color", m.helpers.HEXtoRGB(e)) : m.format.removeStyle("color"), m.popups.hide("textColor.picker")
    }

    return {
      showColorsPopup: function d(e) {
        var t = m.$tb.find('.fr-command[data-cmd="'.concat(e, '"]')), n = m.popups.get("".concat(e, ".picker"));
        if (n || (n = function i(e) {
          var t = "";
          m.opts.toolbarInline && 0 < m.opts.colorsButtons.length && (t += '<div class="fr-buttons fr-colors-buttons fr-tabs">\n        '.concat(m.button.buildList(m.opts.colorsButtons), "\n        </div>"));
          var n, r = "";
          n = "textColor" === e ? (m.opts.colorsHEXInput && (r = s.replace(/\[ID\]/g, "fr-color-hex-layer-text-".concat(m.id)).replace(/\[COMMAND\]/g, "customTextColor")), {
            buttons: t,
            text_colors: l("text"),
            custom_color: r
          }) : (m.opts.colorsHEXInput && (r = s.replace(/\[ID\]/g, "fr-color-hex-layer-background-".concat(m.id)).replace(/\[COMMAND\]/g, "customBackgroundColor")), {
            buttons: t,
            background_colors: l("background"),
            custom_color: r
          });
          var a = m.popups.create("".concat(e, ".picker"), n);
          return function o(h, g) {
            m.events.on("popup.tab", function (e) {
              var t = v(e.currentTarget);
              if (!m.popups.isVisible(g) || !t.is("span")) return !0;
              var n = e.which, r = !0;
              if (xt.KEYCODE.TAB === n) {
                var a = h.find(".fr-buttons");
                r = !m.accessibility.focusToolbar(a, !!e.shiftKey)
              } else if (xt.KEYCODE.ARROW_UP === n || xt.KEYCODE.ARROW_DOWN === n || xt.KEYCODE.ARROW_LEFT === n || xt.KEYCODE.ARROW_RIGHT === n) {
                if (t.is("span.fr-select-color")) {
                  var o = t.parent().find("span.fr-select-color"), i = o.index(t), s = m.opts.colorsStep,
                    l = Math.floor(o.length / s), c = i % s, d = Math.floor(i / s), f = d * s + c, p = l * s;
                  xt.KEYCODE.ARROW_UP === n ? f = ((f - s) % p + p) % p : xt.KEYCODE.ARROW_DOWN === n ? f = (f + s) % p : xt.KEYCODE.ARROW_LEFT === n ? f = ((f - 1) % p + p) % p : xt.KEYCODE.ARROW_RIGHT === n && (f = (f + 1) % p);
                  var u = v(o.get(f));
                  m.events.disableBlur(), u.focus(), r = !1
                }
              } else xt.KEYCODE.ENTER === n && (m.button.exec(t), r = !1);
              return !1 === r && (e.preventDefault(), e.stopPropagation()), r
            }, !0)
          }(a, "".concat(e, ".picker")), a
        }(e)), !n.hasClass("fr-active")) if (m.popups.setContainer("".concat(e, ".picker"), m.$tb), c("textColor" === e ? "text" : "background"), t.isVisible()) {
          var r = m.button.getPosition(t), a = r.left, o = r.top;
          m.popups.show("".concat(e, ".picker"), a, o, t.outerHeight())
        } else m.position.forSelection(n), m.popups.show("".concat(e, ".picker"))
      }, background: r, customColor: function o(e) {
        var t = m.popups.get("".concat(e, "Color.picker")).find(".fr-color-hex-layer input");
        if (t.length) {
          var n = t.val();
          "background" === e ? r(n) : a(n)
        }
      }, text: a, back: function e() {
        m.popups.hide("textColor.picker"), m.popups.hide("backgroundColor.picker"), m.toolbar.showInline()
      }
    }
  }, xt.DefineIcon("textColor", {
    NAME: "tint",
    SVG_KEY: "textColor"
  }), xt.RegisterCommand("textColor", {
    title: "Text Color",
    undo: !1,
    focus: !0,
    refreshOnCallback: !1,
    popup: !0,
    callback: function () {
      this.popups.isVisible("textColor.picker") ? (this.$el.find(".fr-marker").length && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("textColor.picker")) : this.colors.showColorsPopup("textColor")
    }
  }), xt.RegisterCommand("applytextColor", {
    undo: !0, callback: function (e, t) {
      this.colors.text(t)
    }
  }), xt.RegisterCommand("customTextColor", {
    title: "OK", undo: !0, callback: function () {
      this.colors.customColor("text")
    }
  }), xt.DefineIcon("backgroundColor", {
    NAME: "paint-brush",
    SVG_KEY: "backgroundColor"
  }), xt.RegisterCommand("backgroundColor", {
    title: "Background Color",
    undo: !1,
    focus: !0,
    refreshOnCallback: !1,
    popup: !0,
    callback: function () {
      this.popups.isVisible("backgroundColor.picker") ? (this.$el.find(".fr-marker").length && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("backgroundColor.picker")) : this.colors.showColorsPopup("backgroundColor")
    }
  }), xt.RegisterCommand("applybackgroundColor", {
    undo: !0, callback: function (e, t) {
      this.colors.background(t)
    }
  }), xt.RegisterCommand("customBackgroundColor", {
    title: "OK", undo: !0, callback: function () {
      this.colors.customColor("background")
    }
  }), xt.DefineIcon("colorsBack", {
    NAME: "arrow-left",
    SVG_KEY: "back"
  }), xt.RegisterCommand("colorsBack", {
    title: "Back",
    undo: !1,
    focus: !1,
    back: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.colors.back()
    }
  }), xt.DefineIcon("remove", {
    NAME: "eraser",
    SVG_KEY: "remove"
  }), Object.assign(xt.DEFAULTS, {dragInline: !0}), xt.PLUGINS.draggable = function (d) {
    var f = d.$;

    function e(e) {
      return !(!e.originalEvent || !e.originalEvent.target || e.originalEvent.target.nodeType !== Node.TEXT_NODE) || (e.target && "A" === e.target.tagName && 1 === e.target.childNodes.length && "IMG" === e.target.childNodes[0].tagName && (e.target = e.target.childNodes[0]), f(e.target).hasClass("fr-draggable") ? (d.undo.canDo() || d.undo.saveStep(), d.opts.dragInline ? d.$el.attr("contenteditable", !0) : d.$el.attr("contenteditable", !1), d.opts.toolbarInline && d.toolbar.hide(), f(e.target).addClass("fr-dragging"), d.browser.msie || d.browser.edge || d.selection.clear(), void e.originalEvent.dataTransfer.setData("text", "Froala")) : (e.preventDefault(), !1))
    }

    var p, u = function u(e) {
      return !(e && ("HTML" === e.tagName || "BODY" === e.tagName || d.node.isElement(e)))
    };

    function h(e, t, n) {
      if (d.opts.iframe) {
        var r = d.helpers.getPX(d.$wp.find(".fr-iframe").css("padding-top")),
          a = d.helpers.getPX(d.$wp.find(".fr-iframe").css("padding-left"));
        e += d.$iframe.offset().top + r, t += d.$iframe.offset().left + a
      }
      p.offset().top !== e && p.css("top", e), p.offset().left !== t && p.css("left", t), p.width() !== n && p.css("width", n)
    }

    function t(e) {
      e.originalEvent.dataTransfer.dropEffect = "move", d.opts.dragInline ? (!function n() {
        for (var e = null, t = 0; t < xt.INSTANCES.length; t++) if ((e = xt.INSTANCES[t].$el.find(".fr-dragging")).length) return e.get(0)
      }() || d.browser.msie || d.browser.edge) && e.preventDefault() : (e.preventDefault(), function c(e) {
        var t = d.doc.elementFromPoint(e.originalEvent.pageX - d.win.pageXOffset, e.originalEvent.pageY - d.win.pageYOffset);
        if (!u(t)) {
          for (var n = 0, r = t; !u(r) && r === t && 0 < e.originalEvent.pageY - d.win.pageYOffset - n;) n++, r = d.doc.elementFromPoint(e.originalEvent.pageX - d.win.pageXOffset, e.originalEvent.pageY - d.win.pageYOffset - n);
          (!u(r) || p && 0 === d.$el.find(r).length && r !== p.get(0)) && (r = null);
          for (var a = 0, o = t; !u(o) && o === t && e.originalEvent.pageY - d.win.pageYOffset + a < f(d.doc).height();) a++, o = d.doc.elementFromPoint(e.originalEvent.pageX - d.win.pageXOffset, e.originalEvent.pageY - d.win.pageYOffset + a);
          (!u(o) || p && 0 === d.$el.find(o).length && o !== p.get(0)) && (o = null), t = null === o && r ? r : o && null === r ? o : o && r ? n < a ? r : o : null
        }
        if (f(t).hasClass("fr-drag-helper")) return !1;
        if (t && !d.node.isBlock(t) && (t = d.node.blockParent(t)), t && 0 <= ["TD", "TH", "TR", "THEAD", "TBODY"].indexOf(t.tagName) && (t = f(t).parents("table").get(0)), t && 0 <= ["LI"].indexOf(t.tagName) && (t = f(t).parents("UL, OL").get(0)), t && !f(t).hasClass("fr-drag-helper")) {
          var i;
          p || (xt.$draggable_helper || (xt.$draggable_helper = f(document.createElement("div")).attr("class", "fr-drag-helper")), p = xt.$draggable_helper, d.events.on("shared.destroy", function () {
            p.html("").removeData().remove(), p = null
          }, !0)), i = e.originalEvent.pageY < f(t).offset().top + f(t).outerHeight() / 2;
          var s = f(t), l = 0;
          i || 0 !== s.next().length ? (i || (s = s.next()), "before" === p.data("fr-position") && s.is(p.data("fr-tag")) || (0 < s.prev().length && (l = parseFloat(s.prev().css("margin-bottom")) || 0), l = Math.max(l, parseFloat(s.css("margin-top")) || 0), h(s.offset().top - l / 2 - d.$box.offset().top, s.offset().left - d.win.pageXOffset - d.$box.offset().left, s.width()), p.data("fr-position", "before"))) : "after" === p.data("fr-position") && s.is(p.data("fr-tag")) || (l = parseFloat(s.css("margin-bottom")) || 0, h(s.offset().top + f(t).height() + l / 2 - d.$box.offset().top, s.offset().left - d.win.pageXOffset - d.$box.offset().left, s.width()), p.data("fr-position", "after")), p.data("fr-tag", s), p.addClass("fr-visible"), d.$box.append(p)
        } else p && 0 < d.$box.find(p).length && p.removeClass("fr-visible")
      }(e))
    }

    function n(e) {
      e.originalEvent.dataTransfer.dropEffect = "move", d.opts.dragInline || e.preventDefault()
    }

    function r(e) {
      d.$el.attr("contenteditable", !0);
      var t = d.$el.find(".fr-dragging");
      p && p.hasClass("fr-visible") && d.$box.find(p).length ? a(e) : t.length && (e.preventDefault(), e.stopPropagation()), p && d.$box.find(p).length && p.removeClass("fr-visible"), t.removeClass("fr-dragging")
    }

    function a(e) {
      var t, n;
      d.$el.attr("contenteditable", !0);
      for (var r = 0; r < xt.INSTANCES.length; r++) if ((t = xt.INSTANCES[r].$el.find(".fr-dragging")).length) {
        n = xt.INSTANCES[r];
        break
      }
      if (t.length) {
        if (e.preventDefault(), e.stopPropagation(), p && p.hasClass("fr-visible") && d.$box.find(p).length) p.data("fr-tag")[p.data("fr-position")]('<span class="fr-marker"></span>'), p.removeClass("fr-visible"); else if (!1 === d.markers.insertAtPoint(e.originalEvent)) return !1;
        if (t.removeClass("fr-dragging"), !1 === (t = d.events.chainTrigger("element.beforeDrop", t))) return !1;
        var a = t;
        if (t.parent().is("A") && 1 === t.parent().get(0).childNodes.length && (a = t.parent()), d.core.isEmpty()) d.events.focus(); else d.$el.find(".fr-marker").replaceWith(xt.MARKERS), d.selection.restore();
        if (n === d || d.undo.canDo() || d.undo.saveStep(), d.core.isEmpty()) d.$el.html(a); else {
          var o = d.markers.insert();
          0 === a.find(o).length ? f(o).replaceWith(a) : 0 === t.find(o).length && f(o).replaceWith(t), t.after(xt.MARKERS), d.selection.restore()
        }
        return d.popups.hideAll(), d.selection.save(), d.$el.find(d.html.emptyBlockTagsQuery()).not("TD, TH, LI, .fr-inner").not(d.opts.htmlAllowedEmptyTags.join(",")).remove(), d.html.wrap(), d.html.fillEmptyBlocks(), d.selection.restore(), d.undo.saveStep(), d.opts.iframe && d.size.syncIframe(), n !== d && (n.popups.hideAll(), n.$el.find(n.html.emptyBlockTagsQuery()).not("TD, TH, LI, .fr-inner").remove(), n.html.wrap(), n.html.fillEmptyBlocks(), n.undo.saveStep(), n.events.trigger("element.dropped"), n.opts.iframe && n.size.syncIframe()), d.events.trigger("element.dropped", [a]), !1
      }
      p && p.removeClass("fr-visible"), d.undo.canDo() || d.undo.saveStep(), setTimeout(function () {
        d.undo.saveStep()
      }, 0)
    }

    function o(e) {
      if (e && "DIV" === e.tagName && d.node.hasClass(e, "fr-drag-helper")) e.parentNode.removeChild(e); else if (e && e.nodeType === Node.ELEMENT_NODE) for (var t = e.querySelectorAll("div.fr-drag-helper"), n = 0; n < t.length; n++) t[n].parentNode.removeChild(t[n])
    }

    return {
      _init: function i() {
        d.opts.enter === xt.ENTER_BR && (d.opts.dragInline = !0), d.events.on("dragstart", e, !0), d.events.on("dragover", t, !0), d.events.on("dragenter", n, !0), d.events.on("document.dragend", r, !0), d.events.on("document.drop", r, !0), d.events.on("drop", a, !0), d.events.on("html.processGet", o)
      }
    }
  }, Object.assign(xt.DEFAULTS, {editInPopup: !1}), xt.MODULES.editInPopup = function (r) {
    function e() {
      r.events.$on(r.$el, r._mouseup, function () {
        setTimeout(function () {
          !function n() {
            var e, t = r.popups.get("text.edit");
            e = "INPUT" === r.el.tagName ? r.$el.attr("placeholder") : r.$el.text(), t.find("input").val(e).trigger("change"), r.popups.setContainer("text.edit", r.$sc), r.popups.show("text.edit", r.$el.offset().left + r.$el.outerWidth() / 2, r.$el.offset().top + r.$el.outerHeight(), r.$el.outerHeight())
          }()
        }, 10)
      })
    }

    return {
      _init: function n() {
        r.opts.editInPopup && (!function t() {
          var e = {edit: '<div id="fr-text-edit-'.concat(r.id, '" class="fr-layer fr-text-edit-layer"><div class="fr-input-line"><input type="text" placeholder="').concat(r.language.translate("Text"), '" tabIndex="1"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="updateText" tabIndex="2">').concat(r.language.translate("Update"), "</button></div></div>")};
          r.popups.create("text.edit", e)
        }(), e())
      }, update: function t() {
        var e = r.popups.get("text.edit").find("input").val();
        0 === e.length && (e = r.opts.placeholderText), "INPUT" === r.el.tagName ? r.$el.attr("placeholder", e) : r.$el.text(e), r.events.trigger("contentChanged"), r.popups.hide("text.edit")
      }
    }
  }, xt.RegisterCommand("updateText", {
    focus: !1, undo: !1, callback: function () {
      this.editInPopup.update()
    }
  }), Object.assign(xt.POPUP_TEMPLATES, {emoticons: "[_BUTTONS_][_CUSTOM_LAYER_]"}), Object.assign(xt.DEFAULTS, {
    emoticonsSet: [{
      id: "people",
      name: "Smileys & People",
      code: "1f600",
      emoticons: [{code: "1f600", desc: "Grinning face"}, {
        code: "1f601",
        desc: "Grinning Face with Smiling Eyes"
      }, {code: "1f602", desc: "Face with Tears of Joy"}, {
        code: "1f603",
        desc: "Smiling Face with Open Mouth"
      }, {code: "1f604", desc: "Smiling Face with Open Mouth and Smiling Eyes"}, {
        code: "1f605",
        desc: "Smiling Face with Open Mouth and Cold Sweat"
      }, {code: "1f606", desc: "Smiling Face with Open Mouth and Tightly-Closed Eyes"}, {
        code: "1f609",
        desc: "Winking Face"
      }, {code: "1f60a", desc: "Smiling Face with Smiling Eyes"}, {
        code: "1f608",
        desc: "Face Savouring Delicious Food"
      }, {code: "1f60e", desc: "Smiling Face with Sunglasses"}, {
        code: "1f60d",
        desc: "Smiling Face with Heart-Shaped Eyes"
      }, {code: "1f618", desc: "Face Throwing a Kiss"}, {code: "1f617", desc: "Kissing Face"}, {
        code: "1f619",
        desc: "Kissing Face with Smiling Eyes"
      }, {code: "1f61a", desc: "Kissing Face with Closed Eyes"}, {
        code: "263a",
        desc: "White Smiling Face"
      }, {code: "1f642", desc: "Slightly Smiling Face"}, {code: "1f610", desc: "Neutral Face"}, {
        code: "1f611",
        desc: "Expressionless Face"
      }, {code: "1f636", desc: "Face Without Mouth"}, {code: "1f60f", desc: "Smirking Face"}, {
        code: "1f623",
        desc: "Persevering Face"
      }, {code: "1f625", desc: "Disappointed but Relieved Face"}, {
        code: "1f62e",
        desc: "Face with Open Mouth"
      }, {code: "1f62f", desc: "Hushed Face"}, {code: "1f62a", desc: "Sleepy Face"}, {
        code: "1f62b",
        desc: "Tired Face"
      }, {code: "1f634", desc: "Sleeping Face"}, {code: "1f60c", desc: "Relieved Face"}, {
        code: "1f61b",
        desc: "Face with Stuck-out Tongue"
      }, {code: "1f61c", desc: "Face with Stuck-out Tongue and Winking Eye"}, {
        code: "1f61d",
        desc: "Face with Stuck-out Tongue and Tightly-Closed Eyes"
      }, {code: "1f612", desc: "Unamused Face"}, {code: "1f613", desc: "Face with Cold Sweat"}, {
        code: "1f613",
        desc: "Face with Cold Sweat"
      }, {code: "1f614", desc: "Pensive Face"}, {code: "1f615", desc: "Confused Face"}, {
        code: "1f632",
        desc: "Astonished  Face"
      }, {code: "1f616", desc: "Confounded Face"}, {code: "1f61e", desc: "Disappointed Face"}, {
        code: "1f61f",
        desc: "Worried Face"
      }, {code: "1f624", desc: "Face with Look of Triumph"}, {code: "1f622", desc: "Crying Face"}, {
        code: "1f62d",
        desc: "Loudly Crying Face"
      }, {code: "1f626", desc: "Frowning Face with Open Mouth"}, {
        code: "1f627",
        desc: "Anguished Face"
      }, {code: "1f628", desc: "Fearful Face"}, {code: "1f629", desc: "Weary Face"}, {
        code: "1f62c",
        desc: "Grimacing Face"
      }, {code: "1f630", desc: "Face with Open Mouth and Cold Sweat"}, {
        code: "1f631",
        desc: "Face Screaming in Fear"
      }, {code: "1f633", desc: "Flushed Face"}, {code: "1f635", desc: "Dizzy Face"}, {
        code: "1f621",
        desc: "Pouting Face"
      }, {code: "1f620", desc: "Angry Face"}, {code: "1f637", desc: "Face with Medical Mask"}, {
        code: "1f607",
        desc: "Smiling Face with Halo"
      }, {code: "1f608", desc: "Smiling Face with Horns"}, {code: "1f47f", desc: "Imp"}, {
        code: "1f479",
        desc: "Japanese Ogre"
      }, {code: "1f47a", desc: "Japanese Goblin"}, {code: "1f480", desc: "Skull"}, {
        code: "1f47b",
        desc: "Ghost"
      }, {code: "1f47d", desc: "Extraterrestrial Alien"}, {code: "1f47e", desc: "Alien Monster"}, {
        code: "1f4a9",
        desc: "Pile of Poo"
      }, {code: "1f63a", desc: "Smiling Cat Face with Open Mouth"}, {
        code: "1f638",
        desc: "Grinning Cat Face with Smiling Eyes"
      }, {code: "1f639", desc: "Cat Face with Tears of Joy"}, {
        code: "1f63b",
        desc: "Smiling Cat Face with Heart-Shaped Eyes"
      }, {code: "1f63c", desc: "Cat Face with Wry Smile"}, {
        code: "1f63d",
        desc: "Kissing Cat Face with Closed Eyes"
      }, {code: "1f640", desc: "Weary Cat Face"}, {code: "1f63f", desc: "Crying Cat Face"}, {
        code: "1f63e",
        desc: "Pouting Cat Face"
      }, {code: "1f648", desc: "See-No-Evil Monkey"}, {code: "1f649", desc: "Hear-No-Evil Monkey"}, {
        code: "1f64a",
        desc: "Speak-No-Evil Monkey"
      }, {code: "1f476", desc: "Baby"}, {code: "1f466", desc: "Boy"}, {code: "1f467", desc: "Girl"}, {
        code: "1f468",
        desc: "Man"
      }, {code: "1f469", desc: "Woman"}, {code: "1f474", desc: "Older Man"}, {
        code: "1f475",
        desc: "Older Woman"
      }, {code: "1f46e", desc: "Police Officer"}, {code: "1f482", desc: " Guardsman"}, {
        code: "1f477",
        desc: " Construction Worker"
      }, {code: "1f478", desc: "Princess"}, {code: "1f473", desc: "Man with Turban"}, {
        code: "1f472",
        desc: "Man with Gua Pi Mao"
      }, {code: "1f471", desc: "Person with Blond Hair"}, {code: "1f470", desc: "Bride with Veil"}, {
        code: "1f47c",
        desc: "Baby Angel"
      }, {code: "1f385", desc: "Father Christmas"}, {code: "1f64e", desc: "Person with Pouting Face"}, {
        code: "1f645",
        desc: "Face with No Good Gesture"
      }, {code: "1f646", desc: "Face with Ok Gesture"}, {
        code: "1f481",
        desc: "Information Desk Person"
      }, {code: "1f64b", desc: "Happy Person Raising One Hand"}, {
        code: "1f647",
        desc: "Person Bowing Deeply"
      }, {code: "1f486", desc: "Face Massage"}, {code: "1f487", desc: "Haircut"}, {
        code: "1f6b6",
        desc: "Pedestrian"
      }, {code: "1f3c3", desc: "Runner"}, {code: "1f483", desc: "Dancer"}, {
        code: "1f46f",
        desc: "Woman with Bunny Ears"
      }, {code: "1f6c0", desc: "Bath"}, {code: "1f464", desc: "Bust in Silhouette"}, {
        code: "1f465",
        desc: "Busts in Silhouette"
      }, {code: "1f3c7", desc: "Horse Racing"}, {code: "1f3c2", desc: " Snowboarder"}, {
        code: "1f3c4",
        desc: " Surfer"
      }, {code: "1f6a3", desc: " Rowboat"}, {code: "1f3ca", desc: " Swimmer"}, {
        code: "1f6b4",
        desc: " Bicyclist"
      }, {code: "1f6b5", desc: "Mountain Bicyclist"}, {
        code: "1f46b",
        desc: " Man and Woman Holding Hands"
      }, {code: "1f46c", desc: "Two Men Holding Hands"}, {
        code: "1f46d",
        desc: "Two Women Holding Hands"
      }, {code: "1f48f", desc: "Kiss"}, {
        code: "1f468-2764-1f48b-1f468",
        uCode: "\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc8b\u200d\ud83d\udc68",
        desc: "Man Kiss Man"
      }, {
        code: "1f469-2764-1f48b-1f469",
        uCode: "\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc69",
        desc: "Woman Kiss Woman"
      }, {code: "1f491", desc: "Couple with Heart"}, {
        code: "1f468-2764-1f468",
        uCode: "\ud83d\udc68\u200d\u2764\ufe0f\u200d\ud83d\udc68",
        desc: "Man Heart Man"
      }, {
        code: "1f469-2764-1f469",
        uCode: "\ud83d\udc69\u200d\u2764\ufe0f\u200d\ud83d\udc69",
        desc: "Woman Heart Woman"
      }, {code: "1f46a", desc: "Family"}, {code: "1f468", desc: "Man Woman Boy"}, {
        code: "1f468-1f469-1f467",
        desc: "Man Woman Girl"
      }, {code: "1f468-1f469-1f467-1f466", desc: "Man Woman Girl Boy"}, {
        code: "1f468-1f469-1f466-1f466",
        desc: "Man Woman Boy Boy"
      }, {code: "1f468-1f469-1f467-1f467", desc: "Man Woman Girl Girl"}, {
        code: "1f468-1f468-1f466",
        desc: "Man Man Boy"
      }, {code: "1f468-1f468-1f467", desc: "Man Man Girl"}, {
        code: "1f468-1f468-1f467-1f466",
        desc: "Man Man Girl Boy"
      }, {code: "1f468-1f468-1f466-1f466", desc: "Man Man Boy Boy"}, {
        code: "1f469-1f469-1f466",
        desc: "Woman Woman Boy"
      }, {code: "1f469-1f469-1f467", desc: "Woman Woman Girl"}, {
        code: "1f469-1f469-1f467-1f466",
        desc: "Woman Woman Girl Boy"
      }, {code: "1f469-1f469-1f467-1f467", desc: "Woman Woman Girl Girl"}, {
        code: "1f4aa",
        desc: "Flexed Biceps"
      }, {code: "1f448", desc: "White Left Pointing Backhand Index"}, {
        code: "1f449",
        desc: "White Right Pointing Backhand Index"
      }, {code: "1f446", desc: "White Up Pointing Backhand Index"}, {
        code: "1f447",
        desc: "White Down Pointing Backhand Index"
      }, {code: "270c", desc: "Victory Hand"}, {code: "270b", desc: "Raised Hand"}, {
        code: "1f44c",
        desc: "Ok Hand Sign"
      }, {code: "1f44d", desc: "Thumbs Up Sign"}, {code: "1f44e", desc: "Thumbs Down Sign"}, {
        code: "270a",
        desc: "Raised Fist"
      }, {code: "1f44a", desc: "Fisted Hand Sign"}, {code: "1f44b", desc: "Waving Hand Sign"}, {
        code: "1f44f",
        desc: "Clapping Hands Sign"
      }, {code: "1f450", desc: "Open  Hands Sign"}, {
        code: "1f64c",
        desc: "Person Raising Both Hands in Celebration"
      }, {code: "1f64f", desc: "Person with Folded Hands"}, {code: "1f485", desc: "Nail Polish"}, {
        code: "1f442",
        desc: "Ear"
      }, {code: "1f443", desc: "Nose"}, {code: "1f463", desc: "Footprints"}, {
        code: "1f440",
        desc: "Eyes"
      }, {code: "1f445", desc: "Tongue"}, {code: "1f444", desc: "Mouth"}, {
        code: "1f48b",
        desc: "Kiss Mark"
      }, {code: "1f498", desc: "Heart with Arrow"}, {code: "2764", desc: "Heavy Black Heart"}, {
        code: "1f493",
        desc: "Heavy Black Heart"
      }, {code: "1f494", desc: "Broken Heart"}, {code: "1f495", desc: "Two Hearts"}, {
        code: "1f496",
        desc: "Sparkling Hearts"
      }, {code: "1f497", desc: "Growing Hearts"}, {code: "1f499", desc: "Blue Heart"}, {
        code: "1f49a",
        desc: "Green Heart"
      }, {code: "1f49b", desc: "Yellow Heart"}, {code: "1f49c", desc: "Purple Heart"}, {
        code: "1f49d",
        desc: "Heart with Ribbon"
      }, {code: "1f49e", desc: "Revolving Hearts"}, {code: "1f49f", desc: "Heart Decoration"}, {
        code: "1f48c",
        desc: "Love Letter"
      }, {code: "1f4a4", desc: "Sleeping Symbol"}, {code: "1f4a2", desc: "Anger Symbol"}, {
        code: "1f4a3",
        desc: "Bomb"
      }, {code: "1f4a5", desc: "Collision Symbol"}, {code: "1f4a6", desc: "Splashing Sweat Symbol"}, {
        code: "1f4a8",
        desc: "Dash Symbol"
      }, {code: "1f4ab", desc: "Dizzy Symbol"}, {code: "1f4ab", desc: "Dizzy Symbol"}, {
        code: "1f4ac",
        desc: "Speech Balloon"
      }, {code: "1f4ad", desc: "Thought Balloon"}, {code: "1f453", desc: "Eyeglasses"}, {
        code: "1f454",
        desc: "Necktie"
      }, {code: "1f455", desc: "T-Shirt"}, {code: "1f456", desc: "Jeans"}, {
        code: "1f457",
        desc: "Dress"
      }, {code: "1f458", desc: "Kimono"}, {code: "1f459", desc: "Bikini"}, {
        code: "1f45a",
        desc: "Womans Clothes"
      }, {code: "1f45b", desc: "Purse"}, {code: "1f45c", desc: "Handbag"}, {
        code: "1f45d",
        desc: "Pouch"
      }, {code: "1f392", desc: "School Satchel"}, {code: "1f45e", desc: "Mans Shoe"}, {
        code: "1f45f",
        desc: "Athletic Shoe"
      }, {code: "1f460", desc: "High-Heeled Shoe"}, {code: "1f461", desc: "Womans Sandal"}, {
        code: "1f462",
        desc: "Womans Boots"
      }, {code: "1f451", desc: "Crown"}, {code: "1f452", desc: "Womans Hat"}, {
        code: "1f462",
        desc: "Top Hat"
      }, {code: "1f393", desc: "Graduation Cap"}, {code: "1f484", desc: "Lipstick"}, {
        code: "1f48d",
        desc: "Ring"
      }, {code: "1f48e", desc: "Gem Stone"}]
    }, {
      id: "nature",
      name: "Animals & Nature",
      code: "1F435",
      emoticons: [{code: "1F435", desc: "Monkey Face"}, {code: "1F412", desc: "Monkey"}, {
        code: "1F436",
        desc: "Dog Face"
      }, {code: "1F415", desc: "Dog"}, {code: "1F429", desc: "Poodle"}, {
        code: "1F43A",
        desc: "Wolf Face"
      }, {code: "1F431", desc: "Cat Face"}, {code: "1F408", desc: "Cat"}, {
        code: "1F42F",
        desc: "Tiger Face"
      }, {code: "1F405", desc: "Tiger"}, {code: "1F406", desc: "Leopard"}, {
        code: "1F434",
        desc: "Horse Face"
      }, {code: "1F40E", desc: "Horse"}, {code: "1F42E", desc: "Cow Face"}, {code: "1F402", desc: "Ox"}, {
        code: "1F403",
        desc: "Water Buffalo"
      }, {code: "1F404", desc: "Cow"}, {code: "1F437", desc: "Pig Face"}, {code: "1F416", desc: "Pig"}, {
        code: "1F417",
        desc: "Boar"
      }, {code: "1F43D", desc: "Pig Nose"}, {code: "1F40F", desc: "Ram"}, {
        code: "1F411",
        desc: "Sheep"
      }, {code: "1F410", desc: "Goat"}, {code: "1F42A", desc: "Dromedary Camel"}, {
        code: "1F42B",
        desc: "Bactrian Camel"
      }, {code: "1F418", desc: "Elephant"}, {code: "1F42D", desc: "Mouse Face"}, {
        code: "1F401",
        desc: "Mouse"
      }, {code: "1F400", desc: "Rat"}, {code: "1F439", desc: "Hamster Face"}, {
        code: "1F430",
        desc: "Rabbit Face"
      }, {code: "1F407", desc: "Rabbit"}, {code: "1F43B", desc: "Bear Face"}, {
        code: "1F428",
        desc: "Koala"
      }, {code: "1F43C", desc: "Panda Face"}, {code: "1F43E", desc: "Paw Prints"}, {
        code: "1F414",
        desc: "Chicken"
      }, {code: "1F413", desc: "Rooster"}, {code: "1F423", desc: "Hatching Chick"}, {
        code: "1F424",
        desc: "Baby Chick"
      }, {code: "1F425", desc: "Front-Facing Baby Chick"}, {code: "1F426", desc: "Bird"}, {
        code: "1F427",
        desc: "Penguin"
      }, {code: "1F438", desc: "Frog Face"}, {code: "1F40A", desc: "Crocodile"}, {
        code: "1F422",
        desc: "Turtle"
      }, {code: "1F40D", desc: "Snake"}, {code: "1F432", desc: "Dragon Face"}, {
        code: "1F409",
        desc: "Dragon"
      }, {code: "1F433", desc: "Spouting Whale"}, {code: "1F40B", desc: "Whale"}, {
        code: "1F42C",
        desc: "Dolphin"
      }, {code: "1F41F", desc: "Fish"}, {code: "1F420", desc: "Tropical Fish"}, {
        code: "1F421",
        desc: "Blowfish"
      }, {code: "1F419", desc: "Octopus"}, {code: "1F41A", desc: "Spiral Shell"}, {
        code: "1F40C",
        desc: "Snail"
      }, {code: "1F41B", desc: "Bug"}, {code: "1F41C", desc: "Ant"}, {code: "1F41D", desc: "Honeybee"}, {
        code: "1F41E",
        desc: "Lady Beetle"
      }, {code: "1F490", desc: "Bouquet"}, {code: "1F338", desc: "Cherry Blossom"}, {
        code: "1F4AE",
        desc: "White Flower"
      }, {code: "1F339", desc: "Rose"}, {code: "1F33A", desc: "Hibiscus"}, {
        code: "1F33B",
        desc: "Sunflower"
      }, {code: "1F33C", desc: "Blossom"}, {code: "1F337", desc: "Tulip"}, {
        code: "1F331",
        desc: "Seedling"
      }, {code: "1F332", desc: "Evergreen Tree"}, {code: "1F333", desc: "Deciduous Tree"}, {
        code: "1F334",
        desc: "Palm Tree"
      }, {code: "1F335", desc: "Cactus"}, {code: "1F33E", desc: "Ear of Rice"}, {
        code: "1F33F",
        desc: "Herb"
      }, {code: "2618", desc: "Four Leaf Clover"}, {code: "1F341", desc: "Maple Leaf"}, {
        code: "1F342",
        desc: "Fallen Leaf"
      }, {code: "1F343", desc: "Leaf Fluttering in Wind"}]
    }, {
      id: "foods",
      name: "Food & Drink",
      code: "1F347",
      emoticons: [{code: "1F347", desc: "Grapes"}, {code: "1F348", desc: "Melon"}, {
        code: "1F349",
        desc: "Watermelon"
      }, {code: "1F34A", desc: "Tangerine"}, {code: "1F34B", desc: "Lemon"}, {
        code: "1F34C",
        desc: "Banana"
      }, {code: "1F34D", desc: "Pineapple"}, {code: "1F34E", desc: "Red Apple"}, {
        code: "1F34F",
        desc: "Green Apple"
      }, {code: "1F350", desc: "Pear"}, {code: "1F351", desc: "Peach"}, {
        code: "1F352",
        desc: "Cherries"
      }, {code: "1F353", desc: "Strawberry"}, {code: "1F345", desc: "Tomato"}, {
        code: "1F346",
        desc: "Aubergine"
      }, {code: "1F33D", desc: "Ear of Maize"}, {code: "1F344", desc: "Mushroom"}, {
        code: "1F330",
        desc: "Chestnut"
      }, {code: "1F35E", desc: "Bread"}, {code: "1F356", desc: "Meat on Bone"}, {
        code: "1F357",
        desc: "Poultry Leg"
      }, {code: "1F354", desc: "Hamburger"}, {code: "1F35F", desc: "French Fries"}, {
        code: "1F355",
        desc: "Slice of Pizza"
      }, {code: "1F373", desc: "Cooking"}, {code: "1F372", desc: "Pot of Food"}, {
        code: "1F371",
        desc: "Bento Box"
      }, {code: "1F358", desc: "Rice Cracker"}, {code: "1F359", desc: "Rice Ball"}, {
        code: "1F35A",
        desc: "Cooked Rice"
      }, {code: "1F35B", desc: "Curry and Rice"}, {code: "1F35C", desc: "Steaming Bowl"}, {
        code: "1F35D",
        desc: "Spaghetti"
      }, {code: "1F360", desc: "Roasted Sweet Potato"}, {code: "1F362", desc: "Oden"}, {
        code: "1F363",
        desc: "Sushi"
      }, {code: "1F364", desc: "Fried Shrimp"}, {code: "1F365", desc: "Fish Cake with Swirl Design"}, {
        code: "1F361",
        desc: "Dango"
      }, {code: "1F366", desc: "Soft Ice Cream"}, {code: "1F367", desc: "Shaved Ice"}, {
        code: "1F368",
        desc: "Ice Cream"
      }, {code: "1F369", desc: "Doughnut"}, {code: "1F36A", desc: "Cookie"}, {
        code: "1F382",
        desc: "Birthday Cake"
      }, {code: "1F370", desc: "Shortcake"}, {code: "1F36B", desc: "Chocolate Bar"}, {
        code: "1F36C",
        desc: "Candy"
      }, {code: "1F36D", desc: "Lollipop"}, {code: "1F36E", desc: "Custard"}, {
        code: "1F36F",
        desc: "Honey Pot"
      }, {code: "1F37C", desc: "Baby Bottle"}, {code: "2615", desc: "Hot Beverage"}, {
        code: "1F375",
        desc: "Teacup Without Handle"
      }, {code: "1F376", desc: "Sake Bottle and Cup"}, {code: "1F377", desc: "Wine Glass"}, {
        code: "1F378",
        desc: "Cocktail Glass"
      }, {code: "1F379", desc: "Tropical Drink"}, {code: "1F37A", desc: "Beer Mug"}, {
        code: "1F37B",
        desc: "Clinking Beer Mugs"
      }, {code: "1F374", desc: "Fork and Knife"}, {code: "1F52A", desc: "Hocho"}]
    }, {
      id: "activity",
      name: "Activities",
      code: "1f383",
      emoticons: [{code: "1f383", desc: " Jack-O-Lantern"}, {code: "1f384", desc: "Christmas Tree"}, {
        code: "1f386",
        desc: " Fireworks"
      }, {code: "1f387", desc: "Firework Sparkler"}, {code: "2728", desc: " Sparkles"}, {
        code: "1f388",
        desc: "Balloon"
      }, {code: "1f389", desc: "Party Popper"}, {code: "1f38a", desc: "Confetti Ball"}, {
        code: "1f38b",
        desc: "Tanabata Tree"
      }, {code: "1f38d", desc: "Pine Decoration"}, {code: "1f38e", desc: "Japanese Dolls"}, {
        code: "1f38f",
        desc: "Carp Streamer"
      }, {code: "1f390", desc: "Wind Chime"}, {code: "1f391", desc: "Moon Viewing Ceremony"}, {
        code: "1f380",
        desc: "Ribbon"
      }, {code: "1f381", desc: "Wrapped Present"}, {code: "1f3ab", desc: "Ticket"}, {
        code: "1f3c6",
        desc: "Trophy"
      }, {code: "1f388", desc: "Balloon"}, {code: "26bd", desc: "Soccer Ball"}, {
        code: "26be",
        desc: "Baseball"
      }, {code: "1f3c0", desc: "Basketball and Hoop"}, {code: "1f3c8", desc: "American Football"}, {
        code: "1f3c9",
        desc: "Rugby Football"
      }, {code: "1f3be", desc: "Tennis Racquet and Ball"}, {code: "1f3b1", desc: "Billiards"}, {
        code: "1f3b3",
        desc: "Bowling"
      }, {code: "1f3af", desc: "Direct Hit"}, {code: "26f3", desc: "Flag in Hole"}, {
        code: "1f3a3",
        desc: "Fishing Pole and Fish"
      }, {code: "1f3bd", desc: "Running Shirt with Sash"}, {code: "1f3bf", desc: "Ski and Ski Boot"}, {
        code: "1f3ae",
        desc: "Video Game"
      }, {code: "1f3b2", desc: "Game Die"}, {code: "2660", desc: "Black Spade Suit"}, {
        code: "2665",
        desc: "Black Heart SuiT"
      }, {code: "2666", desc: "Black Diamond Suit"}, {code: "2663", desc: "Black Club Suit"}, {
        code: "1f0cf",
        desc: "Playing Card Black Joker"
      }, {code: "1f004", desc: "Mahjong Tile Red Dragon"}, {code: "1f3b4", desc: "Flower Playing Cards"}]
    }, {
      id: "places",
      name: "Travel & Places",
      code: "1f30d",
      emoticons: [{code: "1f30d", desc: "Earth Globe Europe-Africa"}, {
        code: "1f30e",
        desc: "Earth Globe Americas"
      }, {code: "1f30f", desc: "Earth Globe Asia-Australia"}, {
        code: "1f310",
        desc: "Globe with Meridians"
      }, {code: "1f5fe", desc: "Silhouette of Japan"}, {code: "1f30b", desc: "Volcano"}, {
        code: "1f5fb",
        desc: "Mount Fuji"
      }, {code: "1f3e0", desc: "House Building"}, {code: "1f3e1", desc: "House with Garden"}, {
        code: "1f3e2",
        desc: "Office Building"
      }, {code: "1f3e3", desc: "Japanese Post Office"}, {code: "1f3e4", desc: "European Post Office"}, {
        code: "1f3e5",
        desc: "Hospital"
      }, {code: "1f3e6", desc: "Bank"}, {code: "1f3e8", desc: "Hotel"}, {
        code: "1f3e9",
        desc: "Love Hotel"
      }, {code: "1f3ea", desc: "Convenience Store"}, {code: "1f3eb", desc: "School"}, {
        code: "1f3ec",
        desc: "Department Store"
      }, {code: "1f3ed", desc: "Factory"}, {code: "1f3ef", desc: "Japanese Castle"}, {
        code: "1f3f0",
        desc: "European Castle"
      }, {code: "1f492", desc: "Wedding"}, {code: "1f5fc", desc: "Tokyo Tower"}, {
        code: "1f5fd",
        desc: "Statue of Liberty"
      }, {code: "26ea", desc: "Church"}, {code: "26f2", desc: "Fountain"}, {code: "26fa", desc: "Tent"}, {
        code: "1f301",
        desc: "Foggy"
      }, {code: "1f303", desc: "Night with Stars"}, {code: "1f304", desc: "Sunrise over Mountains"}, {
        code: "1f305",
        desc: "Sunrise"
      }, {code: "1f306", desc: "Cityscape at Dusk"}, {code: "1f307", desc: "Sunset over Buildings"}, {
        code: "1f309",
        desc: "Bridge at Night"
      }, {code: "2668", desc: "Hot Springs"}, {code: "1f30c", desc: "Milky Way"}, {
        code: "1f3a0",
        desc: "Carousel Horse"
      }, {code: "1f3a1", desc: "Ferris Wheel"}, {code: "1f3a2", desc: "Roller Coaster"}, {
        code: "1f488",
        desc: "Barber Pole"
      }, {code: "1f3aa", desc: "Circus Tent"}, {code: "1f3ad", desc: "Performing Arts"}, {
        code: "1f3a8",
        desc: "Artist Palette"
      }, {code: "1f3b0", desc: "Slot Machine"}, {code: "1f682", desc: "Steam Locomotive"}, {
        code: "1f683",
        desc: "Railway Car"
      }, {code: "1f684", desc: "High-Speed Train"}, {
        code: "1f685",
        desc: "High-Speed Train with Bullet Nose"
      }, {code: "1f686", desc: "Train"}, {code: "1f687", desc: "Metro"}, {
        code: "1f688",
        desc: "Light Rail"
      }, {code: "1f689", desc: "Station"}, {code: "1f68a", desc: "Tram"}, {
        code: "1f69d",
        desc: "Monorail"
      }, {code: "1f69e", desc: "Mountain Railway"}, {code: "1f68b", desc: "Tram Car"}, {
        code: "1f68c",
        desc: "Bus"
      }, {code: "1f68d", desc: "Oncoming Bus"}, {code: "1f68e", desc: "Trolleybus"}, {
        code: "1f690",
        desc: "Minibus"
      }, {code: "1f691", desc: "Ambulance"}, {code: "1f692", desc: "Fire Engine"}, {
        code: "1f693",
        desc: "Police Car"
      }, {code: "1f694", desc: "Oncoming Police Car"}, {code: "1f695", desc: "Taxi"}, {
        code: "1f695",
        desc: "Oncoming Taxi"
      }, {code: "1f697", desc: "Automobile"}, {code: "1f698", desc: "Oncoming Automobile"}, {
        code: "1f699",
        desc: "Recreational Vehicle"
      }, {code: "1f69a", desc: "Delivery Truck"}, {code: "1f69b", desc: "Articulated Lorry"}, {
        code: "1f69c",
        desc: "Tractor"
      }, {code: "1f6b2", desc: "Bicycle"}, {code: "1f68f", desc: "Bus Stop"}, {
        code: "26fd",
        desc: "Fuel Pump"
      }, {code: "1f6a8", desc: "Police Cars Revolving Light"}, {
        code: "1f6a5",
        desc: "Horizontal Traffic Light"
      }, {code: "1f6a6", desc: "Vertical Traffic Light"}, {code: "1f6a7", desc: "Construction Sign"}, {
        code: "2693",
        desc: "Anchor"
      }, {code: "26f5", desc: "Sailboat"}, {code: "1f6a4", desc: "Speedboat"}, {
        code: "1f6a2",
        desc: "Ship"
      }, {code: "2708", desc: "Airplane"}, {code: "1f4ba", desc: "Seat"}, {
        code: "1f681",
        desc: "Helicopter"
      }, {code: "1f69f", desc: "Suspension Railway"}, {code: "1f6a0", desc: "Mountain Cableway"}, {
        code: "1f6a1",
        desc: "Aerial Tramway"
      }, {code: "1f680", desc: "Rocket"}, {code: "1f6aa", desc: "Door"}, {
        code: "1f6bd",
        desc: "Toilet"
      }, {code: "1f6bf", desc: "Shower"}, {code: "1f6c1", desc: "Bathtub"}, {
        code: "231b",
        desc: "Hourglass"
      }, {code: "23f3", desc: "Hourglass with Flowing Sand"}, {code: "231a", desc: "Watch"}, {
        code: "23f0",
        desc: "Alarm Clock"
      }, {code: "1f55b", desc: "Clock Face Twelve Oclock"}, {
        code: "1f567",
        desc: "Clock Face Twelve-Thirty"
      }, {code: "1f550", desc: "Clock Face One Oclock"}, {code: "1f55c", desc: "Clock Face One-thirty"}, {
        code: "1f551",
        desc: "Clock Face Two Oclock"
      }, {code: "1f55d", desc: "Clock Face Two-thirty"}, {
        code: "1f552",
        desc: "Clock Face Three Oclock"
      }, {code: "1f55e", desc: "Clock Face Three-thirty"}, {
        code: "1f553",
        desc: "Clock Face Four Oclock"
      }, {code: "1f55f", desc: "Clock Face Four-thirty"}, {
        code: "1f554",
        desc: "Clock Face Five Oclock"
      }, {code: "1f560", desc: "Clock Face Five-thirty"}, {
        code: "1f555",
        desc: "Clock Face Six Oclock"
      }, {code: "1f561", desc: "Clock Face Six-thirty"}, {
        code: "1f556",
        desc: "Clock Face Seven Oclock"
      }, {code: "1f562", desc: "Clock Face Seven-thirty"}, {
        code: "1f557",
        desc: "Clock Face Eight Oclock"
      }, {code: "1f563", desc: "Clock Face Eight-thirty"}, {
        code: "1f558",
        desc: "Clock Face Nine Oclock"
      }, {code: "1f564", desc: "Clock Face Nine-thirty"}, {
        code: "1f559",
        desc: "Clock Face Ten Oclock"
      }, {code: "1f565", desc: "Clock Face Ten-thirty"}, {
        code: "1f55a",
        desc: "Clock Face Eleven Oclock"
      }, {code: "1f566", desc: "Clock Face Eleven-thirty"}, {code: "1f311", desc: "New Moon Symbol"}, {
        code: "1f312",
        desc: "Waxing Crescent Moon Symbol"
      }, {code: "1f313", desc: "First Quarter Moon Symbol"}, {
        code: "1f314",
        desc: "Waxing Gibbous Moon Symbol"
      }, {code: "1f315", desc: "Full Moon Symbol"}, {code: "1f316", desc: "Waning Gibbous Moon Symbol"}, {
        code: "1f317",
        desc: "Last Quarter Moon Symbol"
      }, {code: "1f318", desc: "Waning Crescent Moon Symbol"}, {code: "1f319", desc: "Crescent Moon"}, {
        code: "1f31a",
        desc: "New Moon with Face"
      }, {code: "1f31b", desc: "First Quarter Moon with Face"}, {
        code: "1f31c",
        desc: "Last Quarter Moon with Face"
      }, {code: "2600", desc: "Black Sun with Rays"}, {code: "1f31d", desc: "Full Moon with Face"}, {
        code: "1f31e",
        desc: "Sun with Face"
      }, {code: "2b50", desc: "White Medium Star"}, {code: "1f31f", desc: "Glowing Star"}, {
        code: "1f320",
        desc: "Shooting Star"
      }, {code: "2601", desc: "Cloud"}, {code: "26c5", desc: "Sun Behind Cloud"}, {
        code: "1f300",
        desc: "Cyclone"
      }, {code: "1f308", desc: "Rainbow"}, {code: "1f302", desc: "Closed Umbrella"}, {
        code: "2614",
        desc: "Umbrella with Rain Drops"
      }, {code: "26a1", desc: "High Voltage Sign"}, {code: "2744", desc: "Snowflake"}, {
        code: "2603",
        desc: "Snowman Without Snow"
      }, {code: "1f525", desc: "Fire"}, {code: "1f4a7", desc: "Droplet"}, {code: "1F30A", desc: "Water Wave"}]
    }, {
      id: "objects",
      name: "Objects",
      code: "1F507",
      emoticons: [{code: "1F507", desc: "Speaker with Cancellation Stroke"}, {
        code: "1F508",
        desc: "Speaker"
      }, {code: "1F509", desc: "Speaker with One Sound Wave"}, {
        code: "1F50A",
        desc: "Speaker with Three Sound Wave"
      }, {code: "1F4E2", desc: "Public Address Loudspeaker"}, {
        code: "1F4E3",
        desc: "Cheering Megaphone"
      }, {code: "1F4EF", desc: "Postal Horn"}, {code: "1F514", desc: "Bell"}, {
        code: "1F515",
        desc: "Bell with Cancellation Stroke"
      }, {code: "1F3BC", desc: "Musical Score"}, {code: "1F3B5", desc: "Musical Note"}, {
        code: "1F3B6",
        desc: "Multiple Musical Notes"
      }, {code: "1F3A4", desc: "Microphone"}, {code: "1F3A7", desc: "Headphone"}, {
        code: "1F4FB",
        desc: "Radio"
      }, {code: "1F3B7", desc: "Saxophone"}, {code: "1F3B8", desc: "Guitar"}, {
        code: "1F3B9",
        desc: "Musical Keyboard"
      }, {code: "1F3BA", desc: "Trumpet"}, {code: "1F3BB", desc: "Violin"}, {
        code: "1F4F1",
        desc: "Mobile Phone"
      }, {code: "1F4F2", desc: "Mobile Phone with Rightwards Arrow at Left"}, {
        code: "260E",
        desc: "Black Telephone"
      }, {code: "1F4DE", desc: "Telephone Receiver"}, {code: "1F4DF", desc: "Pager"}, {
        code: "1F4E0",
        desc: "Fax Machine"
      }, {code: "1F50B", desc: "Battery"}, {code: "1F50C", desc: "Electric Plug"}, {
        code: "1F4BB",
        desc: "Personal Computer"
      }, {code: "1F4BD", desc: "Minidisc"}, {code: "1F4BE", desc: "Floppy Disk"}, {
        code: "1F4BF",
        desc: "Optical Disk"
      }, {code: "1F4C0", desc: "Dvd"}, {code: "1F3A5", desc: "Movie Camera"}, {
        code: "1F3AC",
        desc: "Clapper Board"
      }, {code: "1F4FA", desc: "Television"}, {code: "1F4F7", desc: "Camera"}, {
        code: "1F4F9",
        desc: "Video Camera"
      }, {code: "1F4FC", desc: "Videocassette"}, {
        code: "1F50D",
        desc: "Left-Pointing Magnifying Glass"
      }, {code: "1F50E", desc: "Right-Pointing Magnifying Glass"}, {code: "1F52C", desc: "Microscope"}, {
        code: "1F52D",
        desc: "Telelscope"
      }, {code: "1F4E1", desc: "Satellite Antenna"}, {code: "1F4A1", desc: "Electric Light Bulb"}, {
        code: "1F526",
        desc: "Electric Torch"
      }, {code: "1F3EE", desc: "Izakaya Lantern"}, {
        code: "1F4D4",
        desc: "Notebook with Decorative Cover"
      }, {code: "1F4D5", desc: "Closed Book"}, {code: "1F4D6", desc: "Open Book"}, {
        code: "1F4D7",
        desc: "Green Book"
      }, {code: "1F4D8", desc: "Blue Book"}, {code: "1F4D9", desc: "Orange Book"}, {
        code: "1F4DA",
        desc: "Books"
      }, {code: "1F4D3", desc: "Notebook"}, {code: "1F4D2", desc: "Ledger"}, {
        code: "1F4C3",
        desc: "Curl"
      }, {code: "1F4DC", desc: "Scroll"}, {code: "1F4C4", desc: "Page Facing Up"}, {
        code: "1F4F0",
        desc: "Newspaper"
      }, {code: "1F4D1", desc: "Bookmark Tabs"}, {code: "1F516", desc: "Bookmark"}, {
        code: "1F4B0",
        desc: "Money Bag"
      }, {code: "1F4B4", desc: "Banknote with Yen Sign"}, {
        code: "1F4B5",
        desc: "Banknote with Dollar Sign"
      }, {code: "1F4B6", desc: "Banknote with Euro Sign"}, {
        code: "1F4B7",
        desc: "Banknote with Pound Sign"
      }, {code: "1F4B8", desc: "Money with Wings"}, {code: "1F4B3", desc: "Credit Card"}, {
        code: "1F4B9",
        desc: "Chart with Upwards Trend and Yen Sign"
      }, {code: "1F4B1", desc: "Currency Exchange"}, {code: "1F4B2", desc: "Heavy Dollar Sign"}, {
        code: "2709",
        desc: "Envelope"
      }, {code: "1F4E7", desc: "E-Mail Symbol"}, {code: "1F4E8", desc: "Incoming Envelope"}, {
        code: "1F4E9",
        desc: "Envelope with Downwards Arrow Above"
      }, {code: "1F4E4", desc: "Outbox Tray"}, {code: "1F4E5", desc: "Inbox Tray"}, {
        code: "1F4E6",
        desc: "Package"
      }, {code: "1F4BE", desc: "Closed Mailbox with Raised Flag"}, {
        code: "1F4EA",
        desc: "Closed Mailbox with Lowered Flag"
      }, {code: "1F4EC", desc: "Open Mailbox with Raised Flag"}, {
        code: "1F4ED",
        desc: "Open Mailbox with Lowered Flag"
      }, {code: "1F5F3", desc: "Postbox"}, {code: "270F", desc: "Pencil"}, {
        code: "2712",
        desc: "Black Nib"
      }, {code: "1F4DD", desc: "Memo"}, {code: "1F4BC", desc: "Briefcase"}, {
        code: "1F4C1",
        desc: "File Folder"
      }, {code: "1F4C2", desc: "Open File Folder"}, {code: "1F4C5", desc: "Calender"}, {
        code: "1F4C6",
        desc: "Tear-off Calender"
      }, {code: "1F4C7", desc: "Card Index"}, {code: "1F4C8", desc: "Chart with Upwards Trend"}, {
        code: "1F4C9",
        desc: "Chart with Downwards Trend"
      }, {code: "1F4CA", desc: "Bar Chart"}, {code: "1F4CB", desc: "Clipboard"}, {
        code: "1F4CC",
        desc: "Pushpin"
      }, {code: "1F4CD", desc: "Round Pushpin"}, {code: "1F4CE", desc: "Paperclip"}, {
        code: "1F4CF",
        desc: "Straight Ruler"
      }, {code: "1F4D0", desc: "Triangular Ruler"}, {code: "2702", desc: "Black Scissors"}, {
        code: "1F512",
        desc: "Lock"
      }, {code: "1F513", desc: "Open Lock"}, {code: "1F50F", desc: "Lock with Ink Pen"}, {
        code: "1F510",
        desc: "Closed Lock with Key"
      }, {code: "1F511", desc: "Key"}, {code: "1F528", desc: "Hammer"}, {code: "1F52B", desc: "Pistol"}, {
        code: "1F527",
        desc: "Wrench"
      }, {code: "1F529", desc: "Nut and Bolt"}, {code: "1F517", desc: "Link Symbol"}, {
        code: "1F489",
        desc: "Syringe"
      }, {code: "1F48A", desc: "Pill"}, {code: "1F6AC", desc: "Smoking Symbol"}, {
        code: "1F5FF",
        desc: "Moyai"
      }, {code: "1F52E", desc: "Crystal Ball"}]
    }, {
      id: "symbols",
      name: "Symbols",
      code: "1F3E7",
      emoticons: [{code: "1F3E7", desc: "Automated Teller Machine"}, {
        code: "1F6AE",
        desc: "Put Litter in Its Place Symbol"
      }, {code: "1F6B0", desc: "Potable Water Symbol"}, {code: "267F", desc: "Wheelchair Symbol"}, {
        code: "1F6B9",
        desc: "Mens Symbol"
      }, {code: "1F6BA", desc: "Womens Symbol"}, {code: "1F6BB", desc: "Restroom"}, {
        code: "1F6BC",
        desc: "Baby Symbol"
      }, {code: "1F6BE", desc: "Water Closet"}, {code: "1F6C2", desc: "Passport Control"}, {
        code: "1F6C3",
        desc: "Customs"
      }, {code: "1F6C4", desc: "Baggage Claim"}, {code: "1F6C5", desc: "Left Luggage"}, {
        code: "26A0",
        desc: "Warning Sign"
      }, {code: "1F6B8", desc: "Children Crossing"}, {code: "26D4", desc: "No Entry"}, {
        code: "1F6AB",
        desc: "No Entry Sign"
      }, {code: "1F6B3", desc: "No Bicycles"}, {code: "1F6AD", desc: "No Smoking Symbol"}, {
        code: "1F6AF",
        desc: "Do Not Litter Symbol"
      }, {code: "1F6B1", desc: "Non-Potable Water Symbol"}, {code: "1F6B7", desc: "No Pedestrians"}, {
        code: "1F4F5",
        desc: "No Mobile Phones"
      }, {code: "1F51E", desc: "No One Under Eighteen Symbol"}, {
        code: "2B06",
        desc: "Upwards Black Arrow"
      }, {code: "2197", desc: "North East Arrow"}, {code: "27A1", desc: "Black Rightwards Arrow"}, {
        code: "2198",
        desc: "South East Arrow"
      }, {code: "2B07", desc: "Downwards Black Arrow"}, {code: "2199", desc: "South West Arrow"}, {
        code: "2B05",
        desc: "Leftwards Black Arrow"
      }, {code: "2196", desc: "North West Arrow"}, {code: "2195", desc: "Up Down Arrow"}, {
        code: "2194",
        desc: "Left Right Arrow"
      }, {code: "21A9", desc: "Leftwards Arrow with Hook"}, {
        code: "21AA",
        desc: "Rightwards Arrow with Hook"
      }, {code: "2934", desc: "Arrow Pointing Rightwards Then Curving Upwards"}, {
        code: "2935",
        desc: "Arrow Pointing Rightwards Then Curving Downwards"
      }, {code: "1F503", desc: "Clockwise Downwards and Upwards Open Circle Arrows"}, {
        code: "1F504",
        desc: "Anticlockwise Downwards and Upwards Open Circle Arrows"
      }, {code: "1F519", desc: "Back with Leftwards Arrow Above"}, {
        code: "1F51A",
        desc: "End with Leftwards Arrow Above"
      }, {code: "1F51B", desc: "On with Exclamation Mark with Left Right Arrow Above"}, {
        code: "1F51C",
        desc: "Soon with Rightwards Arrow Above"
      }, {code: "1F51D", desc: "Top with Upwards Arrow Above"}, {
        code: "1F52F",
        desc: "Six Pointed Star with Middle Dot"
      }, {code: "2648", desc: "Aries"}, {code: "2649", desc: "Taurus"}, {code: "264A", desc: "Gemini"}, {
        code: "264B",
        desc: "Cancer"
      }, {code: "264C", desc: "Leo"}, {code: "264D", desc: "Virgo"}, {code: "264E", desc: "Libra"}, {
        code: "264F",
        desc: "Scorpius"
      }, {code: "2650", desc: "Sagittarius"}, {code: "2651", desc: "Capricorn"}, {
        code: "2652",
        desc: "Aquarius"
      }, {code: "2653", desc: "Pisces"}, {code: "26CE", desc: "Ophiuchus"}, {
        code: "1F500",
        desc: "Twisted Rightwards Arrows"
      }, {code: "1F501", desc: "Clockwise Rightwards and Leftwards Open Circle Arrows"}, {
        code: "1F502",
        desc: "Clockwise Rightwards and Leftwards Open Circle Arrows with Circled One Overlay"
      }, {code: "25B6", desc: "Black Right-Pointing Triangle"}, {
        code: "23E9",
        desc: "Black Right-Pointing Double Triangle"
      }, {code: "25C0", desc: "Black Left-Pointing Triangle"}, {
        code: "23EA",
        desc: "Black Left-Pointing Double Triangle"
      }, {code: "1F53C", desc: "Up-Pointing Small Red Triangle"}, {
        code: "23EB",
        desc: "Black Up-Pointing Double Triangle"
      }, {code: "1F53D", desc: "Down-Pointing Small Red Triangle"}, {
        code: "23EC",
        desc: "Black Down-Pointing Double Triangle"
      }, {code: "1F3A6", desc: "Cinema"}, {code: "1F505", desc: "Low Brightness Symbol"}, {
        code: "1F506",
        desc: "High Brightness Symbol"
      }, {code: "1F4F6", desc: "Antenna with Bars"}, {code: "1F4F3", desc: "Vibration Mode"}, {
        code: "1F4F4",
        desc: "Mobile Phone off"
      }, {code: "267B", desc: "Black Universal Recycling Symbol"}, {
        code: "1F531",
        desc: "Trident Emblem"
      }, {code: "1F4DB", desc: "Name Badge"}, {code: "1F530", desc: "Japanese Symbol for Beginner"}, {
        code: "2B55",
        desc: "Heavy Large Circle"
      }, {code: "2705", desc: "White Heavy Check Mark"}, {code: "2611", desc: "Ballot Box with Check"}, {
        code: "2714",
        desc: "Heavy Check Mark"
      }, {code: "2716", desc: "Heavy Multiplication X"}, {code: "274C", desc: "Cross Mark"}, {
        code: "274E",
        desc: "Negative Squared Cross Mark"
      }, {code: "2795", desc: "Heavy Plus Sign"}, {code: "2796", desc: "Heavy Minus Sign"}, {
        code: "2797",
        desc: "Heavy Division Sign"
      }, {code: "27B0", desc: "Curly Loop"}, {code: "27BF", desc: "Double Curly Loop"}, {
        code: "303D",
        desc: "Part Alternation Mark"
      }, {code: "2733", desc: "Eight Spoked Asterisk"}, {code: "2734", desc: "Eight Pointed Black Star"}, {
        code: "2747",
        desc: "Sparkle"
      }, {code: "203C", desc: "Double Exclamation Mark"}, {
        code: "2049",
        desc: "Exclamation Question Mark"
      }, {code: "2753", desc: "Black Question Mark Ornament"}, {
        code: "2754",
        desc: "White Question Mark Ornament"
      }, {code: "2755", desc: "White Exclamation Mark Ornament"}, {
        code: "2757",
        desc: "Heavy Exclamation Mark Symbol"
      }, {code: "3030", desc: "Wavy Dash"}, {code: "2122", desc: "Trade Mark Sign"}, {
        code: "1F51F",
        desc: "Keycap Ten"
      }, {code: "1F4AF", desc: "Hundred Points Symbol"}, {
        code: "1F520",
        desc: "Input Symbol for Latin Capital Letters"
      }, {code: "1F521", desc: "Input Symbol for Latin Small Letters"}, {
        code: "1F522",
        desc: "Input Symbol for Numbers"
      }, {code: "1F523", desc: "Input Symbol for Symbols"}, {
        code: "1F524",
        desc: "Input Symbol for Latin Letters"
      }, {code: "1F170", desc: "Negative Squared Latin Capital Letter a"}, {
        code: "1F18E",
        desc: "Negative Squared Ab"
      }, {code: "1F171", desc: "Negative Squared Latin Capital Letter B"}, {
        code: "1F191",
        desc: "Squared Cl"
      }, {code: "1F192", desc: "Squared Cool"}, {code: "1F193", desc: "Squared Free"}, {
        code: "2139",
        desc: "Information Source"
      }, {code: "1F194", desc: "Squared Id"}, {code: "24C2", desc: "Circled Latin Capital Letter M"}, {
        code: "1F195",
        desc: "Squared New"
      }, {code: "1F196", desc: "Squared Ng"}, {
        code: "1F17E",
        desc: "Negative Squared Latin Capital Letter O"
      }, {code: "1F197", desc: "Squared Ok"}, {
        code: "1F17F",
        desc: "Negative Squared Latin Capital Letter P"
      }, {code: "1F198", desc: "Squared Sos"}, {
        code: "1F199",
        desc: "Squared Up with Exclamation Mark"
      }, {code: "1F19A", desc: "Squared Vs"}, {code: "1F201", desc: "Squared Katakana Koko"}, {
        code: "1F202",
        desc: "Squared Katakana Sa"
      }, {code: "1F237", desc: "Squared Cjk Unified Ideograph-6708"}, {
        code: "1F236",
        desc: "Squared Cjk Unified Ideograph-6709"
      }, {code: "1F22F", desc: "Squared Cjk Unified Ideograph-6307"}, {
        code: "1F250",
        desc: "Circled Ideograph Advantage"
      }, {code: "1F239", desc: "Squared Cjk Unified Ideograph-5272"}, {
        code: "1F21A",
        desc: "Squared Cjk Unified Ideograph-7121"
      }, {code: "1F232", desc: "Squared Cjk Unified Ideograph-7981"}, {
        code: "1F251",
        desc: "Circled Ideograph Accept"
      }, {code: "1F238", desc: "Squared Cjk Unified Ideograph-7533"}, {
        code: "1F234",
        desc: "Squared Cjk Unified Ideograph-5408"
      }, {code: "1F233", desc: "Squared Cjk Unified Ideograph-7a7a"}, {
        code: "3297",
        desc: "Circled Ideograph Congratulation"
      }, {code: "3299", desc: "Circled Ideograph Secret"}, {
        code: "1F23A",
        desc: "Squared Cjk Unified Ideograph-55b6"
      }, {code: "1F235", desc: "Squared Cjk Unified Ideograph-6e80"}, {
        code: "25AA",
        desc: "Black Small Square"
      }, {code: "25AB", desc: "White Small Square"}, {code: "25FB", desc: "White Medium Square"}, {
        code: "25FC",
        desc: "Black Medium Square"
      }, {code: "25FD", desc: "White Medium Small Square"}, {
        code: "25FE",
        desc: "Black Medium Small Square"
      }, {code: "2B1B", desc: "Black Large Square"}, {code: "2B1C", desc: "White Large Square"}, {
        code: "1F536",
        desc: "Large Orange Diamond"
      }, {code: "1F537", desc: "Large Blue Diamond"}, {code: "1F538", desc: "Small Orange Diamond"}, {
        code: "1F539",
        desc: "Small Blue Diamond"
      }, {code: "1F53A", desc: "Up-Pointing Red Triangle"}, {
        code: "1F53B",
        desc: "Down-Pointing Red Triangle"
      }, {code: "1F4A0", desc: "Diamond Shape with a Dot Inside"}, {
        code: "1F518",
        desc: "Radio Button"
      }, {code: "1F532", desc: "Black Square Button"}, {code: "1F533", desc: "White Square Button"}, {
        code: "26AA",
        desc: "Medium White Circle"
      }, {code: "26AB", desc: "Medium Black Circle"}, {code: "1F534", desc: "Large Red Circle"}, {
        code: "1F535",
        desc: "Large Blue Circle"
      }]
    }, {
      id: "flags",
      name: "Flags",
      code: "1F3C1",
      emoticons: [{code: "1f3c1", desc: "Chequered Flag"}, {code: "1f1e8-1f1f3", desc: "China Flag"}, {
        code: "1f38c",
        desc: "Crossed Flags"
      }, {code: "1f1e9-1f1ea", desc: "Germany Flag"}, {code: "1f1ea-1f1f8", desc: "Spain Flag"}, {
        code: "1f1e6-1f1e8",
        desc: "Ascension Island Flag"
      }, {code: "1f1e6-1f1e9", desc: "Andorra Flag"}, {
        code: "1f1e6-1f1ea",
        desc: "United Arab Emirates Flag"
      }, {code: "1f1e6-1f1eb", desc: "Afghanistan Flag"}, {
        code: "1f1e6-1f1ec",
        desc: "Antigua & Barbuda Flag"
      }, {code: "1f1e6-1f1ee", desc: "Anguilla Flag"}, {
        code: "1f1e6-1f1f1",
        desc: "Albania Flag"
      }, {code: "1f1e6-1f1f2", desc: "Armenia Flag"}, {code: "1f1e6-1f1f4", desc: "Angola Flag"}, {
        code: "1f1e6-1f1f6",
        desc: "Antarctica Flag"
      }, {code: "1f1e6-1f1f7", desc: "Argentina Flag"}, {
        code: "1f1e6-1f1f8",
        desc: "American Samoa Flag"
      }, {code: "1f1e6-1f1f9", desc: "Austria Flag"}, {
        code: "1f1e6-1f1fa",
        desc: "Australia Flag"
      }, {code: "1f1e6-1f1fc", desc: "Aruba Flag"}, {
        code: "1f1e6-1f1fd",
        desc: "\xc5land Islands Flag"
      }, {code: "1f1e6-1f1ff", desc: "Azerbaijan Flag"}, {
        code: "1f1e7-1f1e7",
        desc: "Barbados Flag"
      }, {code: "1f1e7-1f1e9", desc: "Bangladesh Flag"}, {
        code: "1f1e7-1f1ea",
        desc: "Belgium Flag"
      }, {code: "1f1e7-1f1eb", desc: "Burkina Faso Flag"}, {
        code: "1f1e7-1f1ec",
        desc: "Bulgaria Flag"
      }, {code: "1f1e7-1f1ed", desc: "Bahrain Flag"}, {code: "1f1e7-1f1ee", desc: "Burundi Flag"}, {
        code: "1f1e7-1f1ef",
        desc: "Benin Flag"
      }, {code: "1f1e7-1f1f1", desc: "St. Barth\xe9lemy Flag"}, {
        code: "1f1e7-1f1f2",
        desc: "Bermuda Flag"
      }, {code: "1f1e7-1f1f4", desc: "Bolivia Flag"}, {
        code: "1f1e7-1f1f6",
        desc: "Caribbean Netherlands Flag"
      }, {code: "1f1e7-1f1f7", desc: "Brazil Flag"}, {code: "1f1e7-1f1f8", desc: "Bahamas Flag"}, {
        code: "1f1e7-1f1f9",
        desc: "Bhutan Flag"
      }, {code: "1f1e7-1f1fb", desc: "Bouvet Island Flag"}, {
        code: "1f1e7-1f1fc",
        desc: "Botswana Flag"
      }, {code: "1f1e7-1f1fe", desc: "Belarus Flag"}, {code: "1f1e7-1f1ff", desc: "Belize Flag"}, {
        code: "1f1e8-1f1e6",
        desc: "Canada Flag"
      }, {code: "1f1e8-1f1e8", desc: "Cocos (keeling) Islands Flag"}, {
        code: "1f1e8-1f1e9",
        desc: "Congo - Kinshasa Flag"
      }, {code: "1f1e8-1f1eb", desc: "Central African Republic Flag"}, {
        code: "1f1e8-1f1ec",
        desc: "Congo - Brazzaville Flag"
      }, {code: "1f1e8-1f1ed", desc: "Switzerland Flag"}, {
        code: "1f1e8-1f1ee",
        desc: "C\xf4te D\u2019ivoire Flag"
      }, {code: "1f1e8-1f1f0", desc: "Cook Islands Flag"}, {
        code: "1f1e8-1f1f1",
        desc: "Chile Flag"
      }, {code: "1f1e8-1f1f2", desc: "Cameroon Flag"}, {
        code: "1f1e8-1f1f4",
        desc: "Colombia Flag"
      }, {code: "1f1e8-1f1f7", desc: "Costa Rica Flag"}, {code: "1f1e8-1f1fa", desc: "Cuba Flag"}, {
        code: "1f1e8-1f1fb",
        desc: "Cape Verde Flag"
      }, {code: "1f1e8-1f1fc", desc: "Cura\xe7ao Flag"}, {
        code: "1f1e8-1f1fd",
        desc: "Christmas Island Flag"
      }, {code: "1f1e8-1f1fe", desc: "Cyprus Flag"}, {code: "1f1e8-1f1ff", desc: 'Czechia Flag"'}, {
        code: "1f1e9-1f1ec",
        desc: "Diego Garcia Flag"
      }, {code: "1f1e9-1f1ef", desc: "Djibouti Flag"}, {
        code: "1f1e9-1f1f0",
        desc: "Denmark Flag"
      }, {code: "1f1e9-1f1f2", desc: "Dominica Flag"}, {
        code: "1f1e9-1f1f4",
        desc: "Dominican Republic Flag"
      }, {code: "1f1e9-1f1ff", desc: "Algeria Flag"}, {
        code: "1f1ea-1f1e6",
        desc: "Ceuta & Melilla Flag"
      }, {code: "1f1ea-1f1e8", desc: "Ecuador Flag"}, {code: "1f1ea-1f1ea", desc: "Estonia Flag"}, {
        code: "1f1ea-1f1ec",
        desc: "Egypt Flag"
      }, {code: "1f1ea-1f1ed", desc: "Western Sahara Flag"}, {
        code: "1f1ea-1f1f7",
        desc: "Eritrea Flag"
      }, {code: "1f1ea-1f1f9", desc: "Ethiopia Flag"}, {
        code: "1f1ea-1f1fa",
        desc: "European Union Flag"
      }, {code: "1f1eb-1f1ee", desc: "Finland Flag"}, {code: "1f1eb-1f1ef", desc: "Fiji Flag"}, {
        code: "1f1eb-1f1f0",
        desc: "Falkland Islands Flag"
      }, {code: "1f1eb-1f1f2", desc: "Micronesia Flag"}, {
        code: "1f1eb-1f1f4",
        desc: "Faroe Islands Flag"
      }, {code: "1f1ec-1f1e6", desc: "Gabon Flag"}, {code: "1f1ec-1f1e9", desc: "Grenada Flag"}, {
        code: "1f1ec-1f1ea",
        desc: "Georgia Flag"
      }, {code: "1f1ec-1f1eb", desc: "French Guiana Flag"}, {
        code: "1f1ec-1f1ec",
        desc: "Guernsey Flag"
      }, {code: "1f1ec-1f1ed", desc: "Ghana Flag"}, {code: "1f1ec-1f1ee", desc: "Gibraltar Flag"}, {
        code: "1f1ec-1f1f1",
        desc: "Greenland Flag"
      }, {code: "1f1ec-1f1f2", desc: "Gambia Flag"}, {code: "1f1ec-1f1f3", desc: "Guinea Flag"}, {
        code: "1f1ec-1f1f5",
        desc: "Guadeloupe Flag"
      }, {code: "1f1ec-1f1f6", desc: "Equatorial Guinea Flag"}, {
        code: "1f1ec-1f1f7",
        desc: "Greece Flag"
      }, {code: "1f1ec-1f1f8", desc: "South Georgia & South Sandwich Islands Flag"}, {
        code: "1f1ec-1f1f9",
        desc: "Guatemala Flag"
      }, {code: "1f1ec-1f1fa", desc: "Guam Flag"}, {
        code: "1f1ec-1f1fc",
        desc: "Guinea-Bissau Flag"
      }, {code: "1f1ec-1f1fe", desc: "Guyana Flag"}, {
        code: "1f1ed-1f1f0",
        desc: "Hong Kong Sar China Flag"
      }, {code: "1f1ed-1f1f2", desc: "Heard & Mcdonald Islands Flag"}, {
        code: "1f1ed-1f1f3",
        desc: "Honduras Flag"
      }, {code: "1f1ed-1f1f7", desc: "Croatia Flag"}, {code: "1f1ed-1f1f9", desc: "Haiti Flag"}, {
        code: "1f1ed-1f1fa",
        desc: "Hungary Flag"
      }, {code: "1f1ee-1f1e8", desc: "Canary Islands Flag"}, {
        code: "1f1ee-1f1e9",
        desc: "Indonesia Flag"
      }, {code: "1f1ee-1f1ea", desc: "Ireland Flag"}, {code: "1f1ee-1f1f1", desc: "Israel Flag"}, {
        code: "1f1ee-1f1f2",
        desc: "Isle of Man Flag"
      }, {code: "1f1ee-1f1f3", desc: "India Flag"}, {
        code: "1f1ee-1f1f4",
        desc: "British Indian Ocean Territory Flag"
      }, {code: "1f1ee-1f1f6", desc: "Iraq Flag"}, {code: "1f1ee-1f1f7", desc: "Iran Flag"}, {
        code: "1f1ee-1f1f8",
        desc: "Iceland Flag"
      }, {code: "1f1ef-1f1ea", desc: "Jersey Flag"}, {code: "1f1ef-1f1f2", desc: "Jamaica Flag"}, {
        code: "1f1ef-1f1f4",
        desc: "Jordan Flag"
      }, {code: "1f1f0-1f1ea", desc: "Kenya Flag"}, {
        code: "1f1f0-1f1ec",
        desc: "Kyrgyzstan Flag"
      }, {code: "1f1f0-1f1ed", desc: "Cambodia Flag"}, {
        code: "1f1f0-1f1ee",
        desc: "Kiribati Flag"
      }, {code: "1f1f0-1f1f2", desc: "Comoros Flag"}, {
        code: "1f1f0-1f1f3",
        desc: "St. Kitts & Nevis Flag"
      }, {code: "1f1f0-1f1f5", desc: "North Korea Flag"}, {
        code: "1f1f0-1f1fc",
        desc: "Kuwait Flag"
      }, {code: "1f1f0-1f1fe", desc: "Cayman Islands Flag"}, {
        code: "1f1f0-1f1ff",
        desc: "Kazakhstan Flag"
      }, {code: "1f1f1-1f1e6", desc: "Laos Flag"}, {code: "1f1f1-1f1e7", desc: "Lebanon Flag"}, {
        code: "1f1f1-1f1e8",
        desc: "St. Lucia Flag"
      }, {code: "1f1f1-1f1ee", desc: "Liechtenstein Flag"}, {
        code: "1f1f1-1f1f0",
        desc: "Sri Lanka Flag"
      }, {code: "1f1f1-1f1f7", desc: "Liberia Flag"}, {code: "1f1f1-1f1f8", desc: "Lesotho Flag"}, {
        code: "1f1f1-1f1f9",
        desc: "Lithuania Flag"
      }, {code: "1f1f1-1f1fa", desc: "Luxembourg Flag"}, {
        code: "1f1f1-1f1fb",
        desc: "Latvia Flag"
      }, {code: "1f1f1-1f1fe", desc: "Libya Flag"}, {code: "1f1f2-1f1e6", desc: "Morocco Flag"}, {
        code: "1f1f2-1f1e8",
        desc: "Monaco Flag"
      }, {code: "1f1f2-1f1e9", desc: "Moldova Flag"}, {
        code: "1f1f2-1f1ea",
        desc: "Montenegro Flag"
      }, {code: "1f1f2-1f1eb", desc: "St. Martin Flag"}, {
        code: "1f1f2-1f1ec",
        desc: "Madagascar Flag"
      }, {code: "1f1f2-1f1ed", desc: "Marshall Islands Flag"}, {
        code: "1f1f2-1f1f0",
        desc: "Macedonia Flag"
      }, {code: "1f1f2-1f1f1", desc: "Mali Flag"}, {
        code: "1f1f2-1f1f2",
        desc: "Myanmar (burma) Flag"
      }, {code: "1f1f2-1f1f3", desc: "Mongolia Flag"}, {
        code: "1f1f2-1f1f4",
        desc: "Macau Sar China Flag"
      }, {code: "1f1f2-1f1f5", desc: "Northern Mariana Islands Flag"}, {
        code: "1f1f2-1f1f6",
        desc: "Martinique Flag"
      }, {code: "1f1f2-1f1f7", desc: "Mauritania Flag"}, {
        code: "1f1f2-1f1f8",
        desc: "Montserrat Flag"
      }, {code: "1f1f2-1f1f9", desc: "Malta Flag"}, {code: "1f1f2-1f1fa", desc: "Mauritius Flag"}, {
        code: "1f1f2-1f1fb",
        desc: "Maldives Flag"
      }, {code: "1f1f2-1f1fc", desc: "Malawi Flag"}, {code: "1f1f2-1f1fd", desc: "Mexico Flag"}, {
        code: "1f1f2-1f1fe",
        desc: "Malaysia Flag"
      }, {code: "1f1f2-1f1ff", desc: "Mozambique Flag"}, {
        code: "1f1f3-1f1e6",
        desc: "Namibia Flag"
      }, {code: "1f1f3-1f1e8", desc: "New Caledonia Flag"}, {
        code: "1f1f3-1f1ea",
        desc: "Niger Flag"
      }, {code: "1f1f3-1f1eb", desc: "Norfolk Island Flag"}, {
        code: "1f1f3-1f1ec",
        desc: "Nigeria Flag"
      }, {code: "1f1f3-1f1ee", desc: "Nicaragua Flag"}, {
        code: "1f1f3-1f1f1",
        desc: "Netherlands Flag"
      }, {code: "1f1f3-1f1f4", desc: "Norway Flag"}, {code: "1f1f3-1f1f5", desc: "Nepal Flag"}, {
        code: "1f1f3-1f1f7",
        desc: "Nauru Flag"
      }, {code: "1f1f3-1f1fa", desc: "Niue Flag"}, {
        code: "1f1f3-1f1ff",
        desc: "New Zealand Flag"
      }, {code: "1f1f4-1f1f2", desc: "Oman Flag"}, {code: "1f1f8-1f1ff", desc: "Swaziland Flag"}, {
        code: "1f1f5-1f1e6",
        desc: "Panama Flag"
      }, {code: "1f1f5-1f1ea", desc: "Peru Flag"}, {
        code: "1f1f5-1f1eb",
        desc: "French Polynesia Flag"
      }, {code: "1f1f5-1f1ec", desc: "Papua New Guinea Flag"}, {
        code: "1f1f5-1f1ed",
        desc: "Philippines Flag"
      }, {code: "1f1f5-1f1f0", desc: "Pakistan Flag"}, {code: "1f1f5-1f1f1", desc: "Poland Flag"}, {
        code: "1f1f5-1f1f2",
        desc: "St. Pierre & Miquelon  Flag"
      }, {code: "1f1f5-1f1f3", desc: "Pitcairn Islands Flag"}, {
        code: "1f1f5-1f1f7",
        desc: "Puerto Rico Flag"
      }, {code: "1f1f5-1f1f8", desc: "Palestinian Territories Flag"}, {
        code: "1f1f5-1f1f9",
        desc: "Portugal Flag"
      }, {code: "1f1f5-1f1fc", desc: "Palau Flag"}, {code: "1f1f5-1f1fe", desc: "Paraguay Flag"}, {
        code: "1f1f6-1f1e6",
        desc: "Qatar Flag"
      }, {code: "1f1f7-1f1ea", desc: "R\xe9union Flag"}, {
        code: "1f1f7-1f1f4",
        desc: "Romania Flag"
      }, {code: "1f1f7-1f1f8", desc: "Serbia Flag"}, {code: "1f1f7-1f1fc", desc: "Rwanda Flag"}, {
        code: "1f1f8-1f1e6",
        desc: "Saudi Arabia Flag"
      }, {code: "1f1f8-1f1e7", desc: "Solomon Islands Flag"}, {
        code: "1f1f8-1f1e8",
        desc: "Seychelles Flag"
      }, {code: "1f1f8-1f1e9", desc: "Sudan Flag"}, {code: "1f1f8-1f1ea", desc: "Sweden Flag"}, {
        code: "1f1f8-1f1ec",
        desc: "Singapore Flag"
      }, {code: "1f1f8-1f1ee", desc: "Slovenia Flag"}, {
        code: "1f1f8-1f1ed",
        desc: "St. Helena  Flag"
      }, {code: "1f1f8-1f1ef", desc: "Svalbard & Jan Mayen  Flag"}, {
        code: "1f1f8-1f1f1",
        desc: "Sierra Leone Flag"
      }, {code: "1f1f8-1f1f2", desc: "San Marino Flag"}, {
        code: "1f1f8-1f1f3",
        desc: "Senegal Flag"
      }, {code: "1f1f8-1f1f4", desc: "Somalia Flag"}, {
        code: "1f1f8-1f1f7",
        desc: "Suriname Flag"
      }, {code: "1f1f8-1f1f8", desc: "South Sudan  Flag"}, {
        code: "1f1f8-1f1f9",
        desc: "S\xe3o Tom\xe9 & Pr\xedncipe Flag"
      }, {code: "1f1f8-1f1fb", desc: "El Salvador Flag"}, {
        code: "1f1f8-1f1fd",
        desc: "Sint Maarten Flag"
      }, {code: "1f1f8-1f1fe", desc: "Syria Flag"}, {
        code: "1f1f9-1f1e6",
        desc: "Tristan Da Cunha Flag"
      }, {code: "1f1f9-1f1e8", desc: "Turks & Caicos Islands  Flag"}, {
        code: "1f1f9-1f1eb",
        desc: "French Southern Territories Flag"
      }, {code: "1f1f9-1f1ec", desc: "Togo Flag"}, {code: "1f1f9-1f1ed", desc: "Thailand Flag"}, {
        code: "1f1f9-1f1ef",
        desc: "Tajikistan Flag"
      }, {code: "1f1f9-1f1f0", desc: "Tokelau Flag"}, {
        code: "1f1f9-1f1f1",
        desc: "Timor-Leste Flag"
      }, {code: "1f1f9-1f1f2", desc: "Turkmenistan Flag"}, {
        code: "1f1f9-1f1f3",
        desc: "Tunisia Flag"
      }, {code: "1f1f9-1f1f4", desc: "Tonga Flag"}, {code: "1f1f9-1f1f7", desc: "Turkey Flag"}, {
        code: "1f1f9-1f1f9",
        desc: "Trinidad & Tobago Flag"
      }, {code: "1f1f9-1f1fb", desc: "Tuvalu Flag"}, {code: "1f1f9-1f1fc", desc: "Taiwan Flag"}, {
        code: "1f1f9-1f1ff",
        desc: "Tanzania Flag"
      }, {code: "1f1fa-1f1e6", desc: "Ukraine City  Flag"}, {
        code: "1f1fa-1f1ec",
        desc: "Uganda Flag"
      }, {code: "1f1fa-1f1f2", desc: "U.s. Outlying Islands  Flag"}, {
        code: "1f1fa-1f1fe",
        desc: "Uruguay  Flag"
      }, {code: "1f1fa-1f1ff", desc: "Uzbekistan Flag"}, {
        code: "1f1fb-1f1e6",
        desc: "Vatican City  Flag"
      }, {code: "1f1fb-1f1e8", desc: "St. Vincent & Grenadines Flag"}, {
        code: "1f1fb-1f1ea",
        desc: "Venezuela Flag"
      }, {code: "1f1fb-1f1ec", desc: "British Virgin Islands Flag"}, {
        code: "1f1fb-1f1ee",
        desc: "U.s. Virgin Islands Flag"
      }, {code: "1f1fb-1f1f3", desc: "Vietnam Flag"}, {code: "1f1fc-1f1f8", desc: "Samoa Flag"}, {
        code: "1f1fb-1f1fa",
        desc: "Vanuatu Flag"
      }, {code: "1f1fc-1f1eb", desc: '"Wallis & Futuna Flag'}, {
        code: "1f1fd-1f1f0",
        desc: "Kosovo Flag"
      }, {code: "1f1fe-1f1ea", desc: "Yemen Flag"}, {code: "1f1fe-1f1f9", desc: "Mayotte Flag"}, {
        code: "1f1ff-1f1e6",
        desc: "South Africa Flag"
      }, {code: "1f1ff-1f1f2", desc: "Zambia Flag"}, {code: "1f1ff-1f1fc", desc: "Zimbabwe Flag"}, {
        code: "1f1eb-1f1f7",
        desc: "France Flag"
      }, {code: "1f1ec-1f1e7", desc: "United Kingdom  Flag"}, {
        code: "1f1ee-1f1f9",
        desc: "Italy Flag"
      }, {code: "1f1ef-1f1f5", desc: "Japan Flag"}, {
        code: "1f1f0-1f1f7",
        desc: "South Korea Flag"
      }, {code: "1f1f7-1f1fa", desc: "Russia Flag"}, {
        code: "1F6A9",
        desc: "Triangular Flag on Post"
      }, {code: "1f1fa-1f1f8", desc: "United States Flag"}]
    }], emoticonsButtons: ["emoticonsBack", "|"], emoticonsUseImage: !0
  }), xt.PLUGINS.emoticons = function (m) {
    var v = m.$, a = m.opts.emoticonsSet, o = a && a[0], i = "";

    function s() {
      if (!m.selection.isCollapsed()) return !1;
      var e = m.selection.element(), t = m.selection.endElement();
      if (e && m.node.hasClass(e, "fr-emoticon")) return e;
      if (t && m.node.hasClass(t, "fr-emoticon")) return t;
      var n = m.selection.ranges(0), r = n.startContainer;
      if (r.nodeType == Node.ELEMENT_NODE && 0 < r.childNodes.length && 0 < n.startOffset) {
        var a = r.childNodes[n.startOffset - 1];
        if (m.node.hasClass(a, "fr-emoticon")) return a
      }
      return !1
    }

    function l() {
      return "".concat(function r(e, t) {
        return '<div class="fr-buttons fr-tabs fr-tabs-scroll">\n                        '.concat(function n(e, r) {
          var a = "";
          return e.forEach(function (e) {
            var t = {image: e.code.toLowerCase()}, n = {
              elementClass: e.id === r.id ? "fr-active fr-active-tab" : "",
              emoticonsUnicodeClass: m.opts.emoticonsUseImage ? "" : "fr-tabs-unicode",
              title: m.language.translate(e.name),
              dataCmd: "setEmoticonCategory",
              dataParam1: e.id,
              image: m.opts.emoticonsUseImage ? '<img src="https://cdnjs.cloudflare.com/ajax/libs/emojione/2.0.1/assets/svg/'.concat(t.image, '.svg"/>') : "&#x".concat(t.image, ";")
            };
            a += '<button class="fr-command fr-btn '.concat(n.elementClass, " ").concat(n.emoticonsUnicodeClass, '" \n      title="').concat(n.title, '" data-cmd="').concat(n.dataCmd, '" data-param1="').concat(n.dataParam1, '">\n       ').concat(n.image, " </button>")
          }), a
        }(e, t), "\n                        </div>")
      }(a, o), "\n                      ").concat(function n(e) {
        return '\n        <div class="fr-icon-container fr-emoticon-container">\n            '.concat(function t(e) {
          var a = "";
          return e.emoticons.forEach(function (e) {
            var t = e.code.split("-").reduce(function (e, t) {
              return e ? "".concat(e, "&zwj;&#x").concat(t.toLowerCase(), ";") : "&#x".concat(t.toLowerCase(), ";")
            }, ""), n = {image: e.code.toLowerCase(), compiledCode: e.uCode ? e.uCode : t}, r = {
              dataParam1: e.code.toLowerCase(),
              dataParam2: n.compiledCode,
              title: m.language.translate(e.desc),
              image: m.opts.emoticonsUseImage ? '<img src="https://cdnjs.cloudflare.com/ajax/libs/emojione/2.0.1/assets/svg/'.concat(n.image, '.svg"/>') : "".concat(n.compiledCode),
              desc: m.language.translate(e.desc)
            };
            a += '<span class="fr-command fr-emoticon fr-icon" role="button" \n      data-cmd="insertEmoticon" data-param1="'.concat(r.dataParam1, '" \n      data-param2="').concat(r.dataParam2, '"  title="').concat(r.title, '" >\n      ').concat(r.image, '<span class="fr-sr-only">').concat(r.desc, "&nbsp;&nbsp;&nbsp;</span></span>")
          }), a
        }(e), "\n        </div>\n        ")
      }(o), "\n                      ").concat(function e() {
        return m.opts.emoticonsUseImage ? '<p style="font-size: 12px; text-align: center; padding: 0 5px;">Emoji free by <a class="fr-link" tabIndex="-1" href="http://emojione.com/" target="_blank" rel="nofollow noopener noreferrer" role="link" aria-label="Open Emoji One website.">Emoji One</a></p>' : ""
      }())
    }

    return {
      _init: function e() {
        var n = function n() {
          for (var e = m.el.querySelectorAll(".fr-emoticon:not(.fr-deletable)"), t = 0; t < e.length; t++) e[t].className += " fr-deletable"
        };
        n(), m.events.on("html.set", n), m.events.on("keydown", function (e) {
          if (m.keys.isCharacter(e.which) && m.selection.inEditor()) {
            var t = m.selection.ranges(0), n = s();
            m.node.hasClass(n, "fr-emoticon-img") && n && (0 === t.startOffset && m.selection.element() === n ? v(n).before(xt.MARKERS + xt.INVISIBLE_SPACE) : v(n).after(xt.INVISIBLE_SPACE + xt.MARKERS), m.selection.restore())
          }
        }), m.events.on("keyup", function (e) {
          for (var t = m.el.querySelectorAll(".fr-emoticon"), n = 0; n < t.length; n++) "undefined" != typeof t[n].textContent && 0 === t[n].textContent.replace(/\u200B/gi, "").length && v(t[n]).remove();
          if (!(e.which >= xt.KEYCODE.ARROW_LEFT && e.which <= xt.KEYCODE.ARROW_DOWN)) {
            var r = s();
            m.node.hasClass(r, "fr-emoticon-img") && (v(r).append(xt.MARKERS), m.selection.restore())
          }
        })
      }, insert: function c(e, t) {
        var n = s(), r = m.selection.ranges(0);
        n ? (0 === r.startOffset && m.selection.element() === n ? v(n).before(xt.MARKERS + xt.INVISIBLE_SPACE) : 0 < r.startOffset && m.selection.element() === n && r.commonAncestorContainer.parentNode.classList.contains("fr-emoticon") && v(n).after(xt.INVISIBLE_SPACE + xt.MARKERS), m.selection.restore(), m.html.insert('<span class="fr-emoticon fr-deletable'.concat(t ? " fr-emoticon-img" : "", '"').concat(t ? ' style="background: url('.concat(t, ');"') : "", ">").concat(t ? "&nbsp;" : e, "</span>&nbsp;").concat(xt.MARKERS), !0)) : m.html.insert('<span class="fr-emoticon fr-deletable'.concat(t ? " fr-emoticon-img" : "", '"').concat(t ? ' style="background: url('.concat(t, ');"') : "", ">").concat(t ? "&nbsp;" : e, "</span>&nbsp;"), !0)
      }, setEmoticonCategory: function n(t) {
        o = a.filter(function (e) {
          return e.id === t
        })[0], function e() {
          m.popups.get("emoticons").html(i + l())
        }()
      }, showEmoticonsPopup: function d() {
        var e = m.popups.get("emoticons");
        if (e || (e = function o() {
          m.opts.toolbarInline && 0 < m.opts.emoticonsButtons.length && (i = '<div class="fr-buttons fr-emoticons-buttons fr-tabs">'.concat(m.button.buildList(m.opts.emoticonsButtons), "</div>"));
          var e = {buttons: i, custom_layer: l()}, t = m.popups.create("emoticons", e);
          return function n(g) {
            m.events.on("popup.tab", function (e) {
              var t = v(e.currentTarget);
              if (!m.popups.isVisible("emoticons") || !t.is("span, a")) return !0;
              var n, r, a, o = e.which;
              if (xt.KEYCODE.TAB == o) {
                if (t.is("span.fr-emoticon") && e.shiftKey || t.is("a") && !e.shiftKey) {
                  var i = g.find(".fr-buttons");
                  n = !m.accessibility.focusToolbar(i, !!e.shiftKey)
                }
                if (!1 !== n) {
                  var s = g.find("span.fr-emoticon:focus").first().concat(g.findVisible(" div.fr-tabs").first().concat(g.find("a")));
                  t.is("span.fr-emoticon") && (s = s.not("span.fr-emoticon:not(:focus)")), r = s.index(t), r = e.shiftKey ? ((r - 1) % s.length + s.length) % s.length : (r + 1) % s.length, a = s.get(r), m.events.disableBlur(), a.focus(), n = !1
                }
              } else if (xt.KEYCODE.ARROW_UP == o || xt.KEYCODE.ARROW_DOWN == o || xt.KEYCODE.ARROW_LEFT == o || xt.KEYCODE.ARROW_RIGHT == o) {
                if (t.is("span.fr-emoticon")) {
                  var l = t.parent().find("span.fr-emoticon");
                  r = l.index(t);
                  var c = m.opts.emoticonsStep, d = Math.floor(l.length / c), f = r % c, p = Math.floor(r / c),
                    u = p * c + f, h = d * c;
                  xt.KEYCODE.ARROW_UP == o ? u = ((u - c) % h + h) % h : xt.KEYCODE.ARROW_DOWN == o ? u = (u + c) % h : xt.KEYCODE.ARROW_LEFT == o ? u = ((u - 1) % h + h) % h : xt.KEYCODE.ARROW_RIGHT == o && (u = (u + 1) % h), a = v(l.get(u)), m.events.disableBlur(), a.focus(), n = !1
                }
              } else xt.KEYCODE.ENTER == o && (t.is("a") ? t[0].click() : m.button.exec(t), n = !1);
              return !1 === n && (e.preventDefault(), e.stopPropagation()), n
            }, !0)
          }(t), t
        }()), !e.hasClass("fr-active")) {
          m.popups.refresh("emoticons"), m.popups.setContainer("emoticons", m.$tb);
          var t = m.$tb.find('.fr-command[data-cmd="emoticons"]'), n = m.button.getPosition(t), r = n.left, a = n.top;
          m.popups.show("emoticons", r, a, t.outerHeight())
        }
      }, back: function t() {
        m.popups.hide("emoticons"), m.toolbar.showInline()
      }
    }
  }, xt.DefineIcon("emoticons", {
    NAME: "smile-o",
    FA5NAME: "smile",
    SVG_KEY: "smile"
  }), xt.RegisterCommand("emoticons", {
    title: "Emoticons",
    undo: !1,
    focus: !0,
    refreshAfterCallback: !1,
    popup: !0,
    callback: function () {
      this.popups.isVisible("emoticons") ? (this.$el.find(".fr-marker").length && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("emoticons")) : this.emoticons.showEmoticonsPopup()
    },
    plugin: "emoticons"
  }), xt.RegisterCommand("insertEmoticon", {
    callback: function (e, t, n) {
      this.emoticons.insert(n, this.opts.emoticonsUseImage ? "https://cdnjs.cloudflare.com/ajax/libs/emojione/2.0.1/assets/svg/".concat(t, ".svg") : null), this.popups.hide("emoticons")
    }
  }), xt.RegisterCommand("setEmoticonCategory", {
    undo: !1, focus: !1, callback: function (e, t) {
      this.emoticons.setEmoticonCategory(t)
    }
  }), xt.DefineIcon("emoticonsBack", {
    NAME: "arrow-left",
    SVG_KEY: "back"
  }), xt.RegisterCommand("emoticonsBack", {
    title: "Back",
    undo: !1,
    focus: !1,
    back: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.emoticons.back()
    }
  }), Object.assign(xt.DEFAULTS, {entities: "&quot;&#39;&iexcl;&cent;&pound;&curren;&yen;&brvbar;&sect;&uml;&copy;&ordf;&laquo;&not;&shy;&reg;&macr;&deg;&plusmn;&sup2;&sup3;&acute;&micro;&para;&middot;&cedil;&sup1;&ordm;&raquo;&frac14;&frac12;&frac34;&iquest;&Agrave;&Aacute;&Acirc;&Atilde;&Auml;&Aring;&AElig;&Ccedil;&Egrave;&Eacute;&Ecirc;&Euml;&Igrave;&Iacute;&Icirc;&Iuml;&ETH;&Ntilde;&Ograve;&Oacute;&Ocirc;&Otilde;&Ouml;&times;&Oslash;&Ugrave;&Uacute;&Ucirc;&Uuml;&Yacute;&THORN;&szlig;&agrave;&aacute;&acirc;&atilde;&auml;&aring;&aelig;&ccedil;&egrave;&eacute;&ecirc;&euml;&igrave;&iacute;&icirc;&iuml;&eth;&ntilde;&ograve;&oacute;&ocirc;&otilde;&ouml;&divide;&oslash;&ugrave;&uacute;&ucirc;&uuml;&yacute;&thorn;&yuml;&OElig;&oelig;&Scaron;&scaron;&Yuml;&fnof;&circ;&tilde;&Alpha;&Beta;&Gamma;&Delta;&Epsilon;&Zeta;&Eta;&Theta;&Iota;&Kappa;&Lambda;&Mu;&Nu;&Xi;&Omicron;&Pi;&Rho;&Sigma;&Tau;&Upsilon;&Phi;&Chi;&Psi;&Omega;&alpha;&beta;&gamma;&delta;&epsilon;&zeta;&eta;&theta;&iota;&kappa;&lambda;&mu;&nu;&xi;&omicron;&pi;&rho;&sigmaf;&sigma;&tau;&upsilon;&phi;&chi;&psi;&omega;&thetasym;&upsih;&piv;&ensp;&emsp;&thinsp;&zwnj;&zwj;&lrm;&rlm;&ndash;&mdash;&lsquo;&rsquo;&sbquo;&ldquo;&rdquo;&bdquo;&dagger;&Dagger;&bull;&hellip;&permil;&prime;&Prime;&lsaquo;&rsaquo;&oline;&frasl;&euro;&image;&weierp;&real;&trade;&alefsym;&larr;&uarr;&rarr;&darr;&harr;&crarr;&lArr;&uArr;&rArr;&dArr;&hArr;&forall;&part;&exist;&empty;&nabla;&isin;&notin;&ni;&prod;&sum;&minus;&lowast;&radic;&prop;&infin;&ang;&and;&or;&cap;&cup;&int;&there4;&sim;&cong;&asymp;&ne;&equiv;&le;&ge;&sub;&sup;&nsub;&sube;&supe;&oplus;&otimes;&perp;&sdot;&lceil;&rceil;&lfloor;&rfloor;&lang;&rang;&loz;&spades;&clubs;&hearts;&diams;"}), xt.PLUGINS.entities = function (a) {
    var o, i, s = a.$;

    function r(e) {
      var t = e.textContent;
      if (t.match(o)) {
        for (var n = "", r = 0; r < t.length; r++) i[t[r]] ? n += i[t[r]] : n += t[r];
        e.textContent = n
      }
    }

    function l(e) {
      if (e && 0 <= ["STYLE", "SCRIPT", "svg", "IFRAME"].indexOf(e.tagName)) return !0;
      for (var t = a.node.contents(e), n = 0; n < t.length; n++) t[n].nodeType === Node.TEXT_NODE ? r(t[n]) : l(t[n]);
      return e.nodeType === Node.TEXT_NODE && r(e), !1
    }

    var c = function c(e) {
      return 0 === e.length ? "" : a.clean.exec(e, l).replace(/\&amp;/g, "&")
    };
    return {
      _init: function d() {
        a.opts.htmlSimpleAmpersand || (a.opts.entities = "".concat(a.opts.entities, "&amp;"));
        var e = s(document.createElement("div")).html(a.opts.entities).text(), t = a.opts.entities.split(";");
        i = {}, o = "";
        for (var n = 0; n < e.length; n++) {
          var r = e.charAt(n);
          i[r] = "".concat(t[n], ";"), o += "\\".concat(r + (n < e.length - 1 ? "|" : ""))
        }
        o = new RegExp("(".concat(o, ")"), "g"), a.events.on("html.get", c, !0)
      }
    }
  }, Object.assign(xt.POPUP_TEMPLATES, {"file.insert": "[_BUTTONS_][_UPLOAD_LAYER_][_PROGRESS_BAR_]"}), Object.assign(xt.DEFAULTS, {
    fileUpload: !0,
    fileUploadURL: null,
    fileUploadParam: "file",
    fileUploadParams: {},
    fileUploadToS3: !1,
    fileUploadToAzure: !1,
    fileUploadMethod: "POST",
    fileMaxSize: 10485760,
    fileAllowedTypes: ["*"],
    fileInsertButtons: ["fileBack", "|"],
    fileUseSelectedText: !1
  }), xt.PLUGINS.file = function (E) {
    var r, p = E.$, y = "https://i.froala.com/upload", u = 2, h = 3, g = 4, L = 5, _ = 6, n = {};

    function w() {
      var e = E.popups.get("file.insert");
      e || (e = l()), e.find(".fr-layer.fr-active").removeClass("fr-active").addClass("fr-pactive"), e.find(".fr-file-progress-bar-layer").addClass("fr-active"), e.find(".fr-buttons").hide(), a(E.language.translate("Uploading"), 0)
    }

    function o(e) {
      var t = E.popups.get("file.insert");
      t && (t.find(".fr-layer.fr-pactive").addClass("fr-active").removeClass("fr-pactive"), t.find(".fr-file-progress-bar-layer").removeClass("fr-active"), t.find(".fr-buttons").show(), e && (E.events.focus(), E.popups.hide("file.insert")))
    }

    function a(e, t) {
      var n = E.popups.get("file.insert");
      if (n) {
        var r = n.find(".fr-file-progress-bar-layer");
        r.find("h3").text(e + (t ? " ".concat(t, "%") : "")), r.removeClass("fr-error"), t ? (r.find("div").removeClass("fr-indeterminate"), r.find("div > span").css("width", "".concat(t, "%"))) : r.find("div").addClass("fr-indeterminate")
      }
    }

    function m(e, t, n) {
      E.edit.on(), E.events.focus(!0), E.selection.restore(), E.opts.fileUseSelectedText && E.selection.text().length && (t = E.selection.text()), E.html.insert('<a href="'.concat(e, '" target="_blank" id="fr-inserted-file" class="fr-file">').concat(t, "</a>"));
      var r = E.$el.find("#fr-inserted-file");
      r.removeAttr("id"), E.popups.hide("file.insert"), E.undo.saveStep(), d(), E.events.trigger("file.inserted", [r, n])
    }

    function A(e, t, n) {
      var r = this.status, a = this.response, o = this.responseXML, i = this.responseText;
      try {
        if (E.opts.fileUploadToS3 || E.opts.fileUploadToAzure) if (201 === r) {
          var s;
          if (E.opts.fileUploadToAzure) {
            if (!1 === E.events.trigger("file.uploadedToAzure", [this.responseURL, n, a], !0)) return E.edit.on(), !1;
            s = t
          } else s = function c(e) {
            try {
              var t = p(e).find("Location").text(), n = p(e).find("Key").text();
              return !1 === E.events.trigger("file.uploadedToS3", [t, n, e], !0) ? (E.edit.on(), !1) : t
            } catch (r) {
              return k(g, e), !1
            }
          }(o);
          s && m(s, e, a || o)
        } else k(g, a || o); else if (200 <= r && r < 300) {
          var l = function d(e) {
            try {
              if (!1 === E.events.trigger("file.uploaded", [e], !0)) return E.edit.on(), !1;
              var t = JSON.parse(e);
              return t.link ? t : (k(u, e), !1)
            } catch (n) {
              return k(g, e), !1
            }
          }(i);
          l && m(l.link, e, a || i)
        } else k(h, a || i)
      } catch (f) {
        k(g, a || i)
      }
    }

    function T() {
      k(g, this.response || this.responseText || this.responseXML)
    }

    function S(e) {
      if (e.lengthComputable) {
        var t = e.loaded / e.total * 100 | 0;
        a(E.language.translate("Uploading"), t)
      }
    }

    function k(e, t) {
      E.edit.on(), function r(e) {
        w();
        var t = E.popups.get("file.insert").find(".fr-file-progress-bar-layer");
        t.addClass("fr-error");
        var n = t.find("h3");
        n.text(e), E.events.disableBlur(), n.focus()
      }(E.language.translate("Something went wrong. Please try again.")), E.events.trigger("file.error", [{
        code: e,
        message: n[e]
      }, t])
    }

    function x() {
      E.edit.on(), o(!0)
    }

    function i(e) {
      if (void 0 !== e && 0 < e.length) {
        if (!1 === E.events.trigger("file.beforeUpload", [e])) return !1;
        var t, n = e[0];
        if (!(null !== E.opts.fileUploadURL && E.opts.fileUploadURL !== y || E.opts.fileUploadToS3 || E.opts.fileUploadToAzure)) return function C(a) {
          var o = new FileReader;
          o.onload = function () {
            for (var e = o.result, t = atob(o.result.split(",")[1]), n = [], r = 0; r < t.length; r++) n.push(t.charCodeAt(r));
            e = window.URL.createObjectURL(new Blob([new Uint8Array(n)], {type: a.type})), E.file.insert(e, a.name, null)
          }, w(), o.readAsDataURL(a)
        }(n), !1;
        if (n.size > E.opts.fileMaxSize) return k(L), !1;
        if (E.opts.fileAllowedTypes.indexOf("*") < 0 && E.opts.fileAllowedTypes.indexOf(n.type.replace(/file\//g, "")) < 0) return k(_), !1;
        if (E.drag_support.formdata && (t = E.drag_support.formdata ? new FormData : null), t) {
          var r;
          if (!1 !== E.opts.fileUploadToS3) for (r in t.append("key", E.opts.fileUploadToS3.keyStart + (new Date).getTime() + "-" + (n.name || "untitled")), t.append("success_action_status", "201"), t.append("X-Requested-With", "xhr"), t.append("Content-Type", n.type), E.opts.fileUploadToS3.params) E.opts.fileUploadToS3.params.hasOwnProperty(r) && t.append(r, E.opts.fileUploadToS3.params[r]);
          for (r in E.opts.fileUploadParams) E.opts.fileUploadParams.hasOwnProperty(r) && t.append(r, E.opts.fileUploadParams[r]);
          t.append(E.opts.fileUploadParam, n);
          var a, o, i = E.opts.fileUploadURL;
          E.opts.fileUploadToS3 && (i = E.opts.fileUploadToS3.uploadURL ? E.opts.fileUploadToS3.uploadURL : "https://".concat(E.opts.fileUploadToS3.region, ".amazonaws.com/").concat(E.opts.fileUploadToS3.bucket));
          var s = E.opts.fileUploadMethod;
          E.opts.fileUploadToAzure && (i = E.opts.fileUploadToAzure.uploadURL ? "".concat(E.opts.fileUploadToAzure.uploadURL, "/").concat(n.name) : encodeURI("https://".concat(E.opts.fileUploadToAzure.account, ".blob.core.windows.net/").concat(E.opts.fileUploadToAzure.container, "/").concat(n.name)), a = i, E.opts.fileUploadToAzure.SASToken && (i += E.opts.fileUploadToAzure.SASToken), s = "PUT");
          var l = E.core.getXHR(i, s);
          if (E.opts.fileUploadToAzure) {
            var c = (new Date).toUTCString();
            if (!E.opts.fileUploadToAzure.SASToken && E.opts.fileUploadToAzure.accessKey) {
              var d = E.opts.fileUploadToAzure.account, f = E.opts.fileUploadToAzure.container;
              if (E.opts.fileUploadToAzure.uploadURL) {
                var p = E.opts.fileUploadToAzure.uploadURL.split("/");
                f = p.pop(), d = p.pop().split(".")[0]
              }
              var u = "x-ms-blob-type:BlockBlob\nx-ms-date:".concat(c, "\nx-ms-version:2019-07-07"),
                h = encodeURI("/" + d + "/" + f + "/" + n.name),
                g = s + "\n\n\n" + n.size + "\n\n" + n.type + "\n\n\n\n\n\n\n" + u + "\n" + h,
                m = E.cryptoJSPlugin.cryptoJS.HmacSHA256(g, E.cryptoJSPlugin.cryptoJS.enc.Base64.parse(E.opts.fileUploadToAzure.accessKey)).toString(E.cryptoJSPlugin.cryptoJS.enc.Base64),
                v = "SharedKey " + d + ":" + m;
              o = m, l.setRequestHeader("Authorization", v)
            }
            for (r in l.setRequestHeader("x-ms-version", "2019-07-07"), l.setRequestHeader("x-ms-date", c), l.setRequestHeader("Content-Type", n.type), l.setRequestHeader("x-ms-blob-type", "BlockBlob"), E.opts.fileUploadParams) E.opts.fileUploadParams.hasOwnProperty(r) && l.setRequestHeader(r, E.opts.fileUploadParams[r]);
            for (r in E.opts.fileUploadToAzure.params) E.opts.fileUploadToAzure.params.hasOwnProperty(r) && l.setRequestHeader(r, E.opts.fileUploadToAzure.params[r])
          }
          l.onload = function () {
            A.call(l, n.name, a, o)
          }, l.onerror = T, l.upload.onprogress = S, l.onabort = x, w();
          var b = E.popups.get("file.insert");
          b && (b.off("abortUpload"), b.on("abortUpload", function () {
            4 !== l.readyState && l.abort()
          })), l.send(E.opts.fileUploadToAzure ? n : t)
        }
      }
    }

    function s() {
      o()
    }

    function l(e) {
      if (e) return E.popups.onHide("file.insert", s), !0;
      var t;
      E.opts.fileUpload || E.opts.fileInsertButtons.splice(E.opts.fileInsertButtons.indexOf("fileUpload"), 1), t = '<div class="fr-buttons fr-tabs">'.concat(E.button.buildList(E.opts.fileInsertButtons), "</div>");
      var n = "";
      E.opts.fileUpload && (n = '<div class="fr-file-upload-layer fr-layer fr-active" id="fr-file-upload-layer-'.concat(E.id, '"><strong>').concat(E.language.translate("Drop file"), "</strong><br>(").concat(E.language.translate("or click"), ')<div class="fr-form"><input type="file" name="').concat(E.opts.fileUploadParam, '" accept="').concat(0 <= E.opts.fileAllowedTypes.indexOf("*") ? "/" : "").concat(E.opts.fileAllowedTypes.join(", ").toLowerCase(), '" tabIndex="-1" aria-labelledby="fr-file-upload-layer-').concat(E.id, '" role="button"></div></div>'));
      var r = {
        buttons: t,
        upload_layer: n,
        progress_bar: '<div class="fr-file-progress-bar-layer fr-layer"><h3 tabIndex="-1" class="fr-message">Uploading</h3><div class="fr-loader"><span class="fr-progress"></span></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-dismiss" data-cmd="fileDismissError" tabIndex="2" role="button">OK</button></div></div>'
      }, a = E.popups.create("file.insert", r);
      return function o(n) {
        E.events.$on(n, "dragover dragenter", ".fr-file-upload-layer", function () {
          return p(this).addClass("fr-drop"), !1
        }, !0), E.events.$on(n, "dragleave dragend", ".fr-file-upload-layer", function () {
          return p(this).removeClass("fr-drop"), !1
        }, !0), E.events.$on(n, "drop", ".fr-file-upload-layer", function (e) {
          e.preventDefault(), e.stopPropagation(), p(this).removeClass("fr-drop");
          var t = e.originalEvent.dataTransfer;
          t && t.files && (n.data("instance") || E).file.upload(t.files)
        }, !0), E.helpers.isIOS() && E.events.$on(n, "touchstart", '.fr-file-upload-layer input[type="file"]', function () {
          p(this).trigger("click")
        }), E.events.$on(n, "change", '.fr-file-upload-layer input[type="file"]', function () {
          if (this.files) {
            var e = n.data("instance") || E;
            e.events.disableBlur(), n.find("input:focus").blur(), e.events.enableBlur(), e.file.upload(this.files)
          }
          p(this).val("")
        }, !0)
      }(a), a
    }

    function t(e) {
      E.node.hasClass(e, "fr-file")
    }

    function c(e) {
      var t = e.originalEvent.dataTransfer;
      if (t && t.files && t.files.length) {
        var n = t.files[0];
        if (n && "undefined" != typeof n.type) {
          if (n.type.indexOf("image") < 0) {
            if (!E.opts.fileUpload) return e.preventDefault(), e.stopPropagation(), !1;
            E.markers.remove(), E.markers.insertAtPoint(e.originalEvent), E.$el.find(".fr-marker").replaceWith(xt.MARKERS), E.popups.hideAll();
            var r = E.popups.get("file.insert");
            return r || (r = l()), E.popups.setContainer("file.insert", E.$sc), E.popups.show("file.insert", e.originalEvent.pageX, e.originalEvent.pageY), w(), i(t.files), e.preventDefault(), e.stopPropagation(), !1
          }
        } else n.type.indexOf("image") < 0 && (e.preventDefault(), e.stopPropagation())
      }
    }

    function d() {
      var e, t = Array.prototype.slice.call(E.el.querySelectorAll("a.fr-file")), n = [];
      for (e = 0; e < t.length; e++) n.push(t[e].getAttribute("href"));
      if (r) for (e = 0; e < r.length; e++) n.indexOf(r[e].getAttribute("href")) < 0 && E.events.trigger("file.unlink", [r[e]]);
      r = t
    }

    return n[1] = "File cannot be loaded from the passed link.", n[u] = "No link in upload response.", n[h] = "Error during file upload.", n[g] = "Parsing response failed.", n[L] = "File is too large.", n[_] = "File file type is invalid.", n[7] = "Files can be uploaded only to same domain in IE 8 and IE 9.", {
      _init: function f() {
        !function e() {
          E.events.on("drop", c), E.events.$on(E.$win, "keydown", function (e) {
            var t = e.which, n = E.popups.get("file.insert");
            n && t === xt.KEYCODE.ESC && n.trigger("abortUpload")
          }), E.events.on("destroy", function () {
            var e = E.popups.get("file.insert");
            e && e.trigger("abortUpload")
          })
        }(), E.events.on("link.beforeRemove", t), E.$wp && (d(), E.events.on("contentChanged", d)), l(!0)
      }, showInsertPopup: function v() {
        var e = E.$tb.find('.fr-command[data-cmd="insertFile"]'), t = E.popups.get("file.insert");
        if (t || (t = l()), o(), !t.hasClass("fr-active")) if (E.popups.refresh("file.insert"), E.popups.setContainer("file.insert", E.$tb), e.isVisible) {
          var n = E.button.getPosition(e), r = n.left, a = n.top;
          E.popups.show("file.insert", r, a, e.outerHeight())
        } else E.position.forSelection(t), E.popups.show("file.insert")
      }, upload: i, insert: m, back: function e() {
        E.events.disableBlur(), E.selection.restore(), E.events.enableBlur(), E.popups.hide("file.insert"), E.toolbar.showInline()
      }, hideProgressBar: o
    }
  }, xt.DefineIcon("insertFile", {
    NAME: "file-o",
    FA5NAME: "file",
    SVG_KEY: "insertFile"
  }), xt.RegisterCommand("insertFile", {
    title: "Upload File",
    undo: !1,
    focus: !0,
    refreshAfterCallback: !1,
    popup: !0,
    callback: function () {
      this.popups.isVisible("file.insert") ? (this.$el.find(".fr-marker").length && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("file.insert")) : this.file.showInsertPopup()
    },
    plugin: "file"
  }), xt.DefineIcon("fileBack", {NAME: "arrow-left", SVG_KEY: "back"}), xt.RegisterCommand("fileBack", {
    title: "Back",
    undo: !1,
    focus: !1,
    back: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.file.back()
    },
    refresh: function (e) {
      this.opts.toolbarInline ? (e.removeClass("fr-hidden"), e.next(".fr-separator").removeClass("fr-hidden")) : (e.addClass("fr-hidden"), e.next(".fr-separator").addClass("fr-hidden"))
    }
  }), xt.RegisterCommand("fileDismissError", {
    title: "OK", callback: function () {
      this.file.hideProgressBar(!0)
    }
  }), Object.assign(xt.POPUP_TEMPLATES, {
    "filesManager.insert": "[_BUTTONS_][_UPLOAD_LAYER_][_BY_URL_LAYER_][_EMBED_LAYER_][_UPLOAD_PROGRESS_LAYER_][_PROGRESS_BAR_]",
    "image.edit": "[_BUTTONS_]",
    "image.alt": "[_BUTTONS_][_ALT_LAYER_]",
    "image.size": "[_BUTTONS_][_SIZE_LAYER_]"
  }), Object.assign(xt.DEFAULTS, {
    filesInsertButtons: ["imageBack", "|", "filesUpload", "filesByURL", "filesEmbed"],
    filesInsertButtons2: ["deleteAll", "insertAll", "cancel", "minimize"],
    imageEditButtons: ["imageReplace", "imageAlign", "imageCaption", "imageRemove", "imageLink", "linkOpen", "linkEdit", "linkRemove", "-", "imageDisplay", "imageStyle", "imageAlt", "imageSize"],
    imageAltButtons: ["imageBack", "|"],
    imageSizeButtons: ["imageBack", "|"],
    imageUpload: !0,
    filesManagerUploadURL: null,
    imageCORSProxy: "https://cors-anywhere.froala.com",
    imageUploadRemoteUrls: !0,
    filesManagerUploadParam: "file",
    filesManagerUploadParams: {},
    googleOptions: {},
    filesManagerUploadToS3: !1,
    filesManagerUploadToAzure: !1,
    filesManagerUploadMethod: "POST",
    filesManagerMaxSize: 10485760,
    filesManagerAllowedTypes: ["*"],
    imageResize: !0,
    imageResizeWithPercent: !1,
    imageRoundPercent: !1,
    imageDefaultWidth: 300,
    imageDefaultAlign: "center",
    imageDefaultDisplay: "block",
    imageSplitHTML: !1,
    imageStyles: {"fr-rounded": "Rounded", "fr-bordered": "Bordered", "fr-shadow": "Shadow"},
    imageMove: !0,
    imageMultipleStyles: !0,
    imageTextNear: !0,
    imagePaste: !0,
    imagePasteProcess: !1,
    imageMinWidth: 16,
    imageOutputSize: !1,
    imageDefaultMargin: 5,
    imageAddNewLine: !1
  }), xt.VIDEO_PROVIDERS = [{
    test_regex: /^.*((youtu.be)|(youtube.com))\/((v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))?\??v?=?([^#\&\?]*).*/,
    url_regex: /(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|embed\/)?([0-9a-zA-Z_\-]+)(.+)?/g,
    url_text: "https://www.youtube.com/embed/$1?$2",
    html: '<iframe width="640" height="360" src="{url}&wmode=opaque" frameborder="0" allowfullscreen></iframe>',
    provider: "youtube"
  }, {
    test_regex: /^.*(?:vimeo.com)\/(?:channels(\/\w+\/)?|groups\/*\/videos\/\u200b\d+\/|video\/|)(\d+)(?:$|\/|\?)/,
    url_regex: /(?:https?:\/\/)?(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?(\/[a-zA-Z0-9_\-]+)?/i,
    url_text: "https://player.vimeo.com/video/$1",
    html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',
    provider: "vimeo"
  }, {
    test_regex: /^.+(dailymotion.com|dai.ly)\/(video|hub)?\/?([^_]+)[^#]*(#video=([^_&]+))?/,
    url_regex: /(?:https?:\/\/)?(?:www\.)?(?:dailymotion\.com|dai\.ly)\/(?:video|hub)?\/?(.+)/g,
    url_text: "https://www.dailymotion.com/embed/video/$1",
    html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',
    provider: "dailymotion"
  }, {
    test_regex: /^.+(screen.yahoo.com)\/[^_&]+/,
    url_regex: "",
    url_text: "",
    html: '<iframe width="640" height="360" src="{url}?format=embed" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',
    provider: "yahoo"
  }, {
    test_regex: /^.+(rutube.ru)\/[^_&]+/,
    url_regex: /(?:https?:\/\/)?(?:www\.)?(?:rutube\.ru)\/(?:video)?\/?(.+)/g,
    url_text: "https://rutube.ru/play/embed/$1",
    html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',
    provider: "rutube"
  }, {
    test_regex: /^(?:.+)vidyard.com\/(?:watch)?\/?([^.&/]+)\/?(?:[^_.&]+)?/,
    url_regex: /^(?:.+)vidyard.com\/(?:watch)?\/?([^.&/]+)\/?(?:[^_.&]+)?/g,
    url_text: "https://play.vidyard.com/$1",
    html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',
    provider: "vidyard"
  }], xt.VIDEO_EMBED_REGEX = /^\W*((<iframe(.|\n)*>(\s|\n)*<\/iframe>)|(<embed(.|\n)*>))\W*$/i, xt.IMAGE_EMBED_REGEX = /^\W*((<img(.|\n)*>(\s|\n)*))\W*$/i, xt.PLUGINS.filesManager = function (A) {
    var y, i, T, l, c, d, s, f, S = A.$, L = "https://i.froala.com/upload", p = !1, t = !1, k = new Map, x = new Map,
      _ = new Map, w = new Map, R = new Map, M = new Map, o = 0, a = [], u = -1, O = [], h = 0,
      g = ["file", "image", "imageTUI", "video"], N = 1, m = 2, I = 3, D = 4, B = 5, H = 6, $ = 10,
      F = ["video/avi", "video/mpeg", "video/x-ms-wmv"], v = {};

    function b() {
      var e = A.popups.get("filesManager.insert"), t = e.find(".fr-files-by-url-layer input");
      t.val(""), e.find(".fr-files-embed-layer textarea").val("").trigger("change"), t.trigger("change")
    }

    function C(e) {
      var t;
      A.hasOwnProperty("imageTUI") || (s = "fr-disabled"), M.forEach(function (e, t) {
        Z(t)
      }), E() ? (t = A.popups.get("filesManager.insert")) || (t = Ue()) : (t = A.popups.get("filesManager.insert")) || (t = function i() {
        var e = '<div class="fr-buttons fr-tabs">'.concat(A.button.buildList(A.opts.fileInsertButtons), "</div>"),
          t = "<div style= 'padding:10px'>\n    <div class = 'fr-message'><h3 style ='font-size: 16px; margin: 10px 10px;font-weight: normal;'>".concat(A.language.translate(function a() {
            var e = "", t = function n() {
              var t = [];
              return g.forEach(function (e) {
                A.opts.pluginsEnabled.indexOf(e) < 0 && t.push(e.charAt(0).toUpperCase() + e.slice(1))
              }), t
            }();
            e = t.join(", "), 1 < t.length ? e += " plugin are" : e += " plugin is";
            return e
          }() + " not enabled. Do you want to enable?"), "</h3></div>\n    <div style='text-align:right;'>\n      <button class='fr-trim-button fr-plugins-enable'>").concat(A.language.translate("Enable"), "</button>               \n      <button class='fr-trim-button fr-plugins-cancel'>").concat(A.language.translate("Cancel"), "</button>\n    </div>"),
          n = {
            buttons: e,
            upload_layer: t,
            by_url_layer: "",
            embed_layer: "",
            upload_progress_layer: "",
            progress_bar: ""
          }, r = A.popups.create("filesManager.insert", n);
        return Ie(r), r
      }());
      var n = A.$tb.find('.fr-command[data-cmd="insertFiles"]');
      if (J(), e || !t.hasClass("fr-active")) if (e || X(), A.popups.refresh("filesManager.insert"), A.popups.setContainer("filesManager.insert", A.$tb), n.isVisible()) {
        var r = A.button.getPosition(n, k.size), a = r.left, o = r.top;
        A.popups.show("filesManager.insert", a, o, n.outerHeight())
      } else A.position.forSelection(t), A.popups.show("filesManager.insert");
      A.popups.setPopupDimensions(t), E() && A.popups.setFileListHeight(t), t.find(".fr-upload-progress") && 0 == k.size && t.find(".fr-upload-progress").addClass("fr-none")
    }

    function E() {
      var t = !0;
      return g.forEach(function (e) {
        A.opts.pluginsEnabled.indexOf(e) < 0 && (t = !1)
      }), t
    }

    function P() {
      J()
    }

    function U() {
      if (l || function i() {
        var e;
        A.shared.$image_resizer ? (l = A.shared.$image_resizer, d = A.shared.$img_overlay, A.events.on("destroy", function () {
          S("body").first().append(l.removeClass("fr-active"))
        }, !0)) : (A.shared.$image_resizer = S(document.createElement("div")).attr("class", "fr-image-resizer"), l = A.shared.$image_resizer, A.events.$on(l, "mousedown", function (e) {
          e.stopPropagation()
        }, !0), A.opts.imageResize && (l.append(z("nw") + z("ne") + z("sw") + z("se")), A.shared.$img_overlay = S(document.createElement("div")).attr("class", "fr-image-overlay"), d = A.shared.$img_overlay, e = l.get(0).ownerDocument, S(e).find("body").first().append(d)));
        A.events.on("shared.destroy", function () {
          l.html("").removeData().remove(), l = null, A.opts.imageResize && (d.remove(), d = null)
        }, !0), A.helpers.isMobile() || A.events.$on(S(A.o_win), "resize", function () {
          y && !y.hasClass("fr-uploading") ? rt(!0) : y && (U(), replace(), Q(!1))
        });
        if (A.opts.imageResize) {
          e = l.get(0).ownerDocument, A.events.$on(l, A._mousedown, ".fr-handler", V), A.events.$on(S(e), A._mousemove, W), A.events.$on(S(e.defaultView || e.parentWindow), A._mouseup, G), A.events.$on(d, "mouseleave", G);
          var r = 1, a = null, o = 0;
          A.events.on("keydown", function (e) {
            if (y) {
              var t = -1 != navigator.userAgent.indexOf("Mac OS X") ? e.metaKey : e.ctrlKey, n = e.which;
              (n !== a || 200 < e.timeStamp - o) && (r = 1), (n == xt.KEYCODE.EQUALS || A.browser.mozilla && n == xt.KEYCODE.FF_EQUALS) && t && !e.altKey ? r = qe.call(this, e, 1, 1, r) : (n == xt.KEYCODE.HYPHEN || A.browser.mozilla && n == xt.KEYCODE.FF_HYPHEN) && t && !e.altKey ? r = qe.call(this, e, 2, -1, r) : A.keys.ctrlKey(e) || n != xt.KEYCODE.ENTER || (y.before("<br>"), _e(y)), a = n, o = e.timeStamp
            }
          }, !0), A.events.on("keyup", function () {
            r = 1
          })
        }
      }(), !y) return !1;
      var e = A.$wp || A.$sc;
      e.append(l), l.data("instance", A);
      var t = e.scrollTop() - ("static" != e.css("position") ? e.offset().top : 0),
        n = e.scrollLeft() - ("static" != e.css("position") ? e.offset().left : 0);
      n -= A.helpers.getPX(e.css("border-left-width")), t -= A.helpers.getPX(e.css("border-top-width")), A.$el.is("img") && A.$sc.is("body") && (n = t = 0);
      var r = ct();
      dt() && (r = r.find(".fr-img-wrap"));
      var a = 0, o = 0;
      A.opts.iframe && (a = A.helpers.getPX(A.$wp.find(".fr-iframe").css("padding-top")), o = A.helpers.getPX(A.$wp.find(".fr-iframe").css("padding-left"))), l.css("top", (A.opts.iframe ? r.offset().top + a : r.offset().top + t) - 1).css("left", (A.opts.iframe ? r.offset().left + o : r.offset().left + n) - 1).css("width", r.get(0).getBoundingClientRect().width).css("height", r.get(0).getBoundingClientRect().height).addClass("fr-active")
    }

    function z(e) {
      return '<div class="fr-handler fr-h'.concat(e, '"></div>')
    }

    function K(e) {
      dt() ? y.parents(".fr-img-caption").css("width", e) : y.css("width", e)
    }

    function V(e) {
      if (!A.core.sameInstance(l)) return !0;
      if (e.preventDefault(), e.stopPropagation(), A.$el.find("img.fr-error").left) return !1;
      A.undo.canDo() || A.undo.saveStep();
      var t = e.pageX || e.originalEvent.touches[0].pageX;
      if ("mousedown" == e.type) {
        var n = A.$oel.get(0).ownerDocument, r = n.defaultView || n.parentWindow, a = !1;
        try {
          a = r.location != r.parent.location && !(r.$ && r.$.FE)
        } catch (s) {
        }
        a && r.frameElement && (t += A.helpers.getPX(S(r.frameElement).offset().left) + r.frameElement.clientLeft)
      }
      (c = S(this)).data("start-x", t), c.data("start-width", y.width()), c.data("start-height", y.height());
      var o = y.width();
      if (A.opts.imageResizeWithPercent) {
        var i = y.parentsUntil(A.$el, A.html.blockTagsQuery()).get(0) || A.el;
        o = (o / S(i).outerWidth() * 100).toFixed(2) + "%"
      }
      K(o), d.show(), A.popups.hideAll(), it()
    }

    function W(e) {
      if (!A.core.sameInstance(l)) return !0;
      var t;
      if (c && y) {
        if (e.preventDefault(), A.$el.find("img.fr-error").left) return !1;
        var n = e.pageX || (e.originalEvent.touches ? e.originalEvent.touches[0].pageX : null);
        if (!n) return !1;
        var r = n - c.data("start-x"), a = c.data("start-width");
        if ((c.hasClass("fr-hnw") || c.hasClass("fr-hsw")) && (r = 0 - r), A.opts.imageResizeWithPercent) {
          var o = y.parentsUntil(A.$el, A.html.blockTagsQuery()).get(0) || A.el;
          a = ((a + r) / S(o).outerWidth() * 100).toFixed(2), A.opts.imageRoundPercent && (a = Math.round(a)), K("".concat(a, "%")), (t = dt() ? (A.helpers.getPX(y.parents(".fr-img-caption").css("width")) / S(o).outerWidth() * 100).toFixed(2) : (A.helpers.getPX(y.css("width")) / S(o).outerWidth() * 100).toFixed(2)) === a || A.opts.imageRoundPercent || K("".concat(t, "%")), y.css("height", "").removeAttr("height")
        } else a + r >= A.opts.imageMinWidth && (K(a + r), t = dt() ? A.helpers.getPX(y.parents(".fr-img-caption").css("width")) : A.helpers.getPX(y.css("width"))), t !== a + r && K(t), ((y.attr("style") || "").match(/(^height:)|(; *height:)/) || y.attr("height")) && (y.css("height", c.data("start-height") * y.width() / c.data("start-width")), y.removeAttr("height"));
        U(), A.events.trigger("image.resize", [lt()])
      }
    }

    function G(e) {
      if (!A.core.sameInstance(l)) return !0;
      if (c && y) {
        if (e && e.stopPropagation(), A.$el.find("img.fr-error").left) return !1;
        c = null, d.hide(), U(), A.undo.saveStep(), A.events.trigger("image.resizeEnd", [lt()])
      } else l.removeClass("fr-active")
    }

    function Y() {
      M.forEach(function (e, t) {
        var n = A.popups.get("filesManager.insert");
        n.find(".fr-checkbox-file-" + t).get(0).disabled = !0, document.getElementById("fr-file-autoplay-button-" + t) && (document.getElementById("fr-file-autoplay-button-" + t).disabled = !0, document.getElementById("fr-file-autoplay-button-" + t).parentElement.classList.add("fr-checkbox-disabled"), document.getElementById("fr-file-autoplay-button-" + t).parentElement.classList.remove("fr-files-checkbox")), n.find(".fr-checkbox-" + t).get(0).classList.remove("fr-files-checkbox"), n.find(".fr-checkbox-" + t).get(0).classList.add("fr-checkbox-disabled")
      })
    }

    function j(e, t, n, r) {
      A.edit.on(), y && y.addClass("fr-error"), v[e] ? (e != I && e != m && e != D || Ee(100, r, !0), M.set(r, v[e]), Y(), function a() {
        M.forEach(function (e, t) {
          A.popups.get("filesManager.insert"), document.getElementById("fr-file-edit-button-".concat(t)) && (document.getElementById("fr-file-edit-button-".concat(t)).classList.add("fr-disabled"), document.getElementById("fr-file-view-button-".concat(t)).classList.add("fr-disabled"), document.getElementById("fr-file-insert-button-".concat(t)).classList.add("fr-disabled"))
        })
      }(), ne(A.language.translate(v[e]), r)) : ne(A.language.translate("Something went wrong. Please try again."), r), !y && n && Ze(n), A.events.trigger("filesManager.error", [{
        code: e,
        message: v[e]
      }, t, n])
    }

    function q() {
      var e = A.popups.get("filesManager.insert"), t = e.find('.fr-command[data-cmd="insertAll"]'),
        n = e.find('.fr-command[data-cmd="deleteAll"]'), r = !0;
      R.forEach(function a(e, t, n) {
        R.get(t) && (r = !1)
      }), r ? t.addClass("fr-disabled") : t.removeClass("fr-disabled"), r ? n.addClass("fr-disabled") : n.removeClass("fr-disabled")
    }

    function Z(e) {
      x.get(e) && x.get(e).link && A.events.trigger("filesManager.removed", [x.get(e).link]);
      var t = A.popups.get("filesManager.insert");
      t.find(".fr-file-" + e).get(0) !== undefined && (t.find(".fr-file-" + e).get(0).outerHTML = ""), x["delete"](e), k["delete"](e), R["delete"](e), q(), 0 == k.size && (h = 0), M["delete"](e), A.popups.setPopupDimensions(t, !0), A.opts.toolbarBottom ? C(!0) : A.popups.setPopupDimensions(t), t.find(".fr-upload-progress") && 0 == k.size && t.find(".fr-upload-progress").addClass("fr-none")
    }

    function X() {
      for (var e = A.popups.get("filesManager.insert"), t = e.find(".fr-insert-checkbox"), n = 0; n < t.length; n++) t.get(n).children.target.checked = !1, e.find(".fr-file-" + t.get(n).id.split("-").pop()).get(0).classList.add("fr-unchecked");
      if (T) document.getElementById("fr-file-autoplay-button-".concat(T)) && (document.getElementById("fr-file-autoplay-button-".concat(T)).checked = !1), O = O.filter(function (e) {
        return e != T
      }); else {
        for (var r = e.find(".fr-file-autoplay-button"), a = 0; a < r.length; a++) r.get(a).checked = !1;
        O = []
      }
      R = new Map, q()
    }

    function Q(e) {
      var t = A.popups.get("filesManager.insert");
      if (t || (t = Ue()), t.find(".fr-layer.fr-active").removeClass("fr-active").addClass("fr-pactive"), t.find(".fr-files-progress-bar-layer").addClass("fr-active"), t.find(".fr-buttons").hide(), y) {
        var n = ct();
        A.popups.setContainer("filesManager.insert", A.$sc);
        var r = n.offset().left, a = n.offset().top + n.height();
        A.popups.show("filesManager.insert", r, a, n.outerHeight())
      }
      void 0 === e && ee(A.language.translate("Uploading"), 0)
    }

    function J(e) {
      var t = A.popups.get("filesManager.insert");
      if (t && (t.find(".fr-layer.fr-pactive").addClass("fr-active").removeClass("fr-pactive"), t.find(".fr-files-progress-bar-layer").removeClass("fr-active"), t.find(".fr-buttons").show(), e || A.$el.find("img.fr-error").length)) {
        if (A.events.focus(), A.$el.find("img.fr-error").length && (A.$el.find("img.fr-error").remove(), A.undo.saveStep(), A.undo.run(), A.undo.dropRedo()), !A.$wp && y) {
          var n = y;
          rt(!0), A.selection.setAfter(n.get(0)), A.selection.restore()
        }
        A.popups.hide("filesManager.insert")
      }
    }

    function ee(e, t) {
      var n = A.popups.get("filesManager.insert");
      if (n) {
        var r = n.find(".fr-files-progress-bar-layer");
        r.find("h3").text(e + (t ? " ".concat(t, "%") : "")), r.removeClass("fr-error"), t ? (r.find("div").removeClass("fr-indeterminate"), r.find("div > span").css("width", "".concat(t, "%"))) : r.find("div").addClass("fr-indeterminate")
      }
    }

    function te(e) {
      Q();
      var t = A.popups.get("filesManager.insert").find(".fr-files-progress-bar-layer");
      t.addClass("fr-error");
      var n = t.find("h3");
      n.text(e), A.events.disableBlur(), n.focus()
    }

    function ne(e, t) {
      var n = A.popups.get("filesManager.insert"), r = n.find(".fr-upload-progress-layer"),
        a = n.find(".fr-file-".concat(t));
      r.addClass("fr-error"), a.find("h5").text(e)
    }

    v[N] = "File cannot be loaded from the passed link.", v[m] = "No link in upload response.", v[I] = "Error during file upload.", v[D] = "Parsing response failed.", v[B] = "File is too large.", v[H] = "File type is invalid.", v[7] = "Files can be uploaded only to same domain in IE 8 and IE 9.", v[8] = "File is corrupted.", v[9] = "Error during file loading.", v[$] = "File upload cancelled";
    var n, re, ae, oe, ie, se, r, le, ce, de, fe = "";

    function pe(e) {
      fe = e, n = document.getElementsByClassName(e), Array.prototype.map.call(n, function (e) {
        !function r(e) {
          if (e.addEventListener("dragover", function (e) {
            e.preventDefault(), e.stopPropagation(), re = e.pageX, ae = e.pageY;
            var t = document.getElementById("filesList");
            ae + 20 > t.getBoundingClientRect().bottom && ue(t, 0, 10), ae - 20 < t.getBoundingClientRect().top && ue(t, 0, -10)
          }, !1), A.helpers.isMobile()) {
            var t = e.getElementsByClassName("dot");
            t[0].addEventListener("touchmove", function (e) {
              e.preventDefault(), e.stopPropagation();
              for (var t = e.target; t && !t.classList.contains(fe);) t = t.parentElement;
              for (var n = document.elementFromPoint(e.targetTouches[0].clientX, e.targetTouches[0].clientY); n && !n.classList.contains(fe);) n = n.parentElement;
              var r = document.getElementsByClassName("fr-hovered-over-file");
              Array.prototype.forEach.call(r, function (e) {
                e.classList.remove("fr-hovered-over-file")
              }), n && !t.classList.contains("fr-unchecked") && n.classList.add("fr-hovered-over-file");
              var a = document.getElementById("filesList");
              e.targetTouches[0].clientY + 5 > a.getBoundingClientRect().bottom && ue(a, 0, 5), e.targetTouches[0].clientY - 5 < a.getBoundingClientRect().top && ue(a, 0, -5)
            }, !1)
          }
          if (e.ondrag = he, e.ondragend = ge, A.helpers.isMobile()) {
            var n = e.getElementsByClassName("dot");
            n[0].addEventListener("touchmove", he, !1), n[0].addEventListener("touchend", ge, !1)
          }
        }(e)
      })
    }

    function ue(e, t, n) {
      e.scrollLeft += t, e.scrollTop += n
    }

    function he(e) {
      for (A.helpers.isMobile() && (ie = event.touches[0].clientX, se = event.touches[0].clientY), oe = e.target; !oe.classList.contains(fe);) oe = oe.parentElement;
      oe.classList.contains(fe) && !oe.classList.contains("fr-unchecked") ? A.helpers.isMobile() && oe.classList.add("drag-sort-active") : oe = undefined
    }

    function ge(e) {
      var t;
      if (oe !== undefined) {
        var n, r;
        if (A.helpers.isMobile()) for (n = ie, r = se, t = event.target; !t.classList.contains(fe);) t = t.parentElement; else n = event.clientX, r = event.clientY;
        A.helpers.isMobile() || !A.browser.safari && !A.browser.mozilla || (n = re, r = ae);
        for (var a = document.elementFromPoint(n, r); a && !a.classList.contains(fe);) a = a.parentElement;
        a && !a.classList.contains(fe) ? a = undefined : a && oe !== a && function s(e, t) {
          var n, r, a = e.parentNode, o = t.parentNode;
          if (!a || !o || a.isEqualNode(t) || o.isEqualNode(e)) return;
          for (var i = 0; i < a.children.length; i++) a.children[i].isEqualNode(e) && (n = i);
          for (var i = 0; i < o.children.length; i++) o.children[i].isEqualNode(t) && (r = i);
          a.isEqualNode(o) && n < r && r++;
          a.insertBefore(t, a.children[n]), o.insertBefore(e, o.children[r])
        }(oe, a), A.helpers.isMobile() && (t.classList.remove("fr-hovered-over-file"), a.classList.remove("fr-hovered-over-file"))
      }
    }

    function me(e) {
      var r = A.popups.get("filesManager.insert");
      r.find(".fr-upload-progress-layer").hasClass("fr-active") || r.find(".fr-upload-progress-layer").addClass("fr-active"), r.find(".fr-upload-progress").removeClass("fr-none");
      var t = k.get(e), n = function i(e) {
          var t, n = {weekday: "long", year: "numeric", month: "long", day: "numeric"};
          try {
            t = e.toLocaleDateString(A.opts.language ? A.opts.language : undefined, n)
          } catch (r) {
            t = e.toLocaleDateString(undefined, n)
          }
          return t + ""
        }(new Date), a = R.get(e) ? "" : "fr-unchecked ",
        o = "\n        <div id='fr-file-".concat(e, "' class='fr-file-list-item fr-file-").concat(e, " ").concat(a, "' draggable = \"").concat(!a, '" >\n        <div class=\'fr-file-item-left\' >\n\n    \n            <div class="fr-file-item-insert-checkbox fr-files-checkbox-line">\n            ').concat(A.helpers.isMobile() ? "<div id='fr-pick-".concat(e, "}' class='dot'>\n            </div>") : "", '\n            <div id="checkbox-key-').concat(e, '" class="fr-files-checkbox fr-insert-checkbox  fr-checkbox-').concat(e, '">\n            <input name="target" class="fr-insert-attr fr-checkbox-file-').concat(e, ' fr-file-insert-check" data-cmd="fileInsertCheckbox"\n             data-checked="_blank" type="checkbox" id="fr-link-target-').concat(A.id, '" tabIndex="0" />\n            <span>').concat('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg>', '\n            </span>\n        </div>\n                <label id="fr-label-target-').concat(A.id, "\"></label>\n            </div>\n    \n            <div class='fr-file-item-icon fr-file-item-icon-").concat(e, "' >\n                <img src='https://secure.webtoolhub.com/static/resources/icons/set112/f2afb6f7.png' alt='Image preview' class='thumbnail-padding' height='36px' width='36px' />\n            </div>\n\n            <div class='fr-file-item-description' >\n                <div class='fr-file-name fr-files-manager-tooltip'>\n                   ").concat(function s(e, t, n) {
          null == t && (t = 100);
          null == n && (n = "...");
          return e.length > t ? e.substring(0, t - n.length) + n : e
        }(t.name, 20), '\n                      <span class="').concat(20 < t.name.length ? "tooltiptext" : "fr-none", '">').concat(t.name, "\n                      </span>\n                 </div>\n                 <div class='fr-file-details'>\n                 <div class='fr-file-date'>").concat(n, "\n                 </div>\n \n                 <div class='fr-file-size'>\n                     ").concat(function l(e) {
          if (0 == e) return "0 Bytes";
          var t = Math.floor(Math.log(e) / Math.log(1024));
          return " | " + 1 * (e / Math.pow(1024, t)).toFixed(2) + " " + ["Bytes", "KB", "MB", "GB", "TB"][t]
        }(t.size), "\n                 </div>\n                 </div>\n\n                  <div class='fr-file-error'>\n                    <h5 class='fr-file-error-h5'></h5>\n                 </div>\n             </div>\n    \n        </div>\n\n        <div class='fr-file-item-right fr-file-item-right-").concat(e, "'>") + Ce(e) + "</div>\n    </div>";
      r.find(".fr-upload-progress-layer")[0].innerHTML = o + r.find(".fr-upload-progress-layer")[0].innerHTML, k.forEach(function c(e, t, n) {
        R.get(t) && r.find("input.fr-insert-attr.fr-checkbox-file-".concat(t))[0].setAttribute("checked", null)
      }), O.forEach(function (e) {
        document.getElementById("fr-file-autoplay-button-" + e).checked = !0
      }), be(e, t), J(), A.opts.toolbarBottom ? C(!0) : A.popups.setPopupDimensions(r), pe("fr-file-list-item")
    }

    function ve(e) {
      switch (e) {
        case"application/msword":
          return A.icon.getFileIcon("docIcon");
        case"application/vnd.openxmlformats-officedocument.wordprocessingml.document":
          return A.icon.getFileIcon("docxIcon");
        case"image/gif":
          return A.icon.getFileIcon("gifIcon");
        case"image/jpeg":
          return A.icon.getFileIcon("jpegIcon");
        case"image/jpeg":
          return A.icon.getFileIcon("jpgIcon");
        case"type/text":
          return A.icon.getFileIcon("logIcon");
        case"video/quicktime":
          return A.icon.getFileIcon("movIcon");
        case"audio/mp3":
        case"audio/mpeg":
          return A.icon.getFileIcon("mp3Icon");
        case"video/mp4":
          return A.icon.getFileIcon("mp4Icon");
        case"audio/ogg":
          return A.icon.getFileIcon("oggIcon");
        case"video/ogg":
          return A.icon.getFileIcon("ogvIcon");
        case"application/pdf":
          return A.icon.getFileIcon("pdfIcon");
        case"image/png":
          return A.icon.getFileIcon("pngIcon");
        case"text/plain":
          return A.icon.getFileIcon("txtIcon");
        case"video/webm":
          return A.icon.getFileIcon("webmIcon");
        case"image/webp":
          return A.icon.getFileIcon("webpIcon");
        case"video/x-ms-wmv":
          return A.icon.getFileIcon("wmvIcon");
        case"application/vnd.ms-excel":
          return A.icon.getFileIcon("xlsIcon");
        case"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          return A.icon.getFileIcon("xlsxIcon");
        case"application/x-zip-compressed":
        case"application/zip":
          return A.icon.getFileIcon("zipIcon");
        default:
          return A.icon.getFileIcon("defaultIcon")
      }
    }

    function be(r, a, e) {
      var o = A.popups.get("filesManager.insert"), t = o.find(".fr-file-item-icon-" + r).get(0);
      if (Be(ke(a)) && "image/gif" != ke(a) && "image/webp" != ke(a)) {
        "a" != t.children[0].localName && (t.innerHTML = "<a target='_blank' href=''>" + t.innerHTML + "</a>");
        o.find(".fr-file-item-icon-" + r).get(0).children[0].children[0];
        var i = new FileReader;
        if (null != e && e) {
          var n = k.get(r);
          a.name = n.name, k.set(r, a)
        }
        if (i.onloadend = function () {
          o.find(".fr-file-item-icon-" + r).get(0).children[0].children[0].src = i.result;
          for (var e = atob(i.result.split(",")[1]), t = [], n = 0; n < e.length; n++) t.push(e.charCodeAt(n));
          o.find(".fr-file-item-icon-" + r).get(0).children[0].href = window.URL.createObjectURL(new Blob([new Uint8Array(t)], {type: ke(a)})), o.find(".fr-file-item-icon-" + r).get(0).classList.add("file-item-thumbnail-hover")
        }, a) i.readAsDataURL(a); else {
          var s = ve(ke(a));
          t.innerHTML = '<svg height="40px" width="40px" viewBox="0 0 55 5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n        '.concat(s.path, "\n        </svg>")
        }
      } else {
        var l = ve(ke(a));
        t.innerHTML = '<svg height="40px" width="40px" viewBox="0 0 55 55" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n      '.concat(l.path, "\n      </svg>")
      }
    }

    function Ce(e) {
      var t = "";
      if ($e(ke(k.get(e)))) {
        var n = "fr-files-checkbox", r = "";
        Pe(ke(k.get(e))) || (n = "fr-checkbox-disabled", r = "disabled");
        t = '\n      <div class="fr-files-checkbox-line align-autoplay">\n      <div id="checkbox-key-'.concat(e, '" class="').concat(n, " fr-autoplay-checkbox  fr-checkbox-").concat(e, '">  \n                   \n      <input type="checkbox" id="fr-file-autoplay-button-').concat(e, '" class="fr-file-button-').concat(e, ' fr-file-autoplay-button" data-title="Edit" data-param1="').concat(e, '" role="button" ').concat(r, "/>\n\n      <span>").concat('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg>', " </span>\n      </div>      \n      <label  class='fr-autoplay-checkbox-label'>Autoplay </label>\n      </div>")
      }
      var a = "application/msword", o = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        i = "";
      return !Fe(ke(k.get(e))) && Pe(ke(k.get(e))) || (s = "fr-disabled"), $e(ke(k.get(e))) && (s = "fr-disabled"), He(ke(k.get(e))) && (s = "fr-disabled", ke(k.get(e)) != a && ke(k.get(e)) != o || A.opts.googleOptions && !A.helpers.isMobile() && A.opts.googleOptions.API_KEY && A.opts.googleOptions.CLIENT_ID && (s = ""), "text/plain" != ke(k.get(e)) && ke(k.get(e)) != a && "application/pdf" != ke(k.get(e)) && ke(k.get(e)) != o && "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" != ke(k.get(e)) && "application/vnd.ms-excel" != ke(k.get(e)) && "type/text" != ke(k.get(e)) || (i = "")), "video/url" === ke(k.get(e)) && (s = "fr-disabled"), t += '<div class=\'fr-file-item-action-buttons\' >\n                <button type="button" id="fr-file-insert-button-'.concat(e, '" class=" fr-doc-edit-').concat(e, " fr-img-icon fr-btn fr-command fr-submit fr-file-action-icons \n                fr-file-button-").concat(e, " fr-file-insert-button-").concat(e, ' fr-file-insert-button" data-cmd="imageInsertByUpload" data-title="Insert" data-param1="').concat(e, '" tabIndex="2" role="button">\n                <svg style=\'margin:0px !important; opacity:0.9\' class = "fr-svg" focusable="false" width="16px" height="16px" viewBox = "-5 0 28 28" xlmns = "http://w3.org/200/svg"><path d = \'M 9.25 12 L 6.75 12 C 6.335938 12 6 11.664062 6 11.25 L 6 6 L 3.257812 6 C 2.703125 6 2.425781 5.328125 2.820312 4.933594 L 7.570312 0.179688 C 7.804688 -0.0546875 8.191406 -0.0546875 8.425781 0.179688 L 13.179688 4.933594 C 13.574219 5.328125 13.296875 6 12.742188 6 L 10 6 L 10 11.25 C 10 11.664062 9.664062 12 9.25 12 Z M 16 11.75 L 16 15.25 C 16 15.664062 15.664062 16 15.25 16 L 0.75 16 C 0.335938 16 0 15.664062 0 15.25 L 0 11.75 C 0 11.335938 0.335938 11 0.75 11 L 5 11 L 5 11.25 C 5 12.214844 5.785156 13 6.75 13 L 9.25 13 C 10.214844 13 11 12.214844 11 11.25 L 11 11 L 15.25 11 C 15.664062 11 16 11.335938 16 11.75 Z M 12.125 14.5 C 12.125 14.15625 11.84375 13.875 11.5 13.875 C 11.15625 13.875 10.875 14.15625 10.875 14.5 C 10.875 14.84375 11.15625 15.125 11.5 15.125 C 11.84375 15.125 12.125 14.84375 12.125 14.5 Z M 14.125 14.5 C 14.125 14.15625 13.84375 13.875 13.5 13.875 C 13.15625 13.875 12.875 14.15625 12.875 14.5 C 12.875 14.84375 13.15625 15.125 13.5 15.125 C 13.84375 15.125 14.125 14.84375 14.125 14.5 Z M 14.125 14.5 \'></path></svg>\n                </button>\n\n                <button type="button" id="fr-file-edit-button-').concat(e, '" class=" fr-doc-edit-').concat(e, " ").concat(s, " fr-img-icon fr-btn fr-command fr-submit \n                fr-file-action-icons fr-file-edit-button-").concat(e, " fr-file-button-").concat(e, ' fr-file-edit-button" data-cmd="editImage" data-title="Edit" data-param1="').concat(e, '" role="button">\n                <svg style=\'margin:0px !important; opacity:0.9\' class = "fr-svg" focusable="false" width="16px" height="16px" viewBox = "0 4 25 25" xlmns = "http://w3.org/200/svg"><path d = \'M17,11.2L12.8,7L5,14.8V19h4.2L17,11.2z M7,16.8v-1.5l5.6-5.6l1.4,1.5l-5.6,5.6H7z M13.5,6.3l0.7-0.7c0.8-0.8,2.1-0.8,2.8,0  c0,0,0,0,0,0L18.4,7c0.8,0.8,0.8,2,0,2.8l-0.7,0.7L13.5,6.3z\'></path></svg>\n                </button>\n                \n                <span class="fr-file-view-').concat(e, '"><button type="button" id="fr-file-view-button-').concat(e, '" class=" fr-doc-edit-').concat(e, " ").concat(i, " fr-img-icon fr-btn fr-command fr-submit fr-file-action-icons \n                fr-file-view-button-").concat(e, ' fr-file-view-button" data-cmd="viewImage" data-title="View" data-param1="').concat(e, '" tabIndex="2" role="button">\n                <svg style=\'margin:0px !important; opacity:0.9\' class = "fr-svg" focusable="false" width="16px" height="16px" viewBox = "15 19 21 21" xlmns = "http://w3.org/200/svg"> <path style="fill:none;stroke-width:0.9077;stroke-linecap:round;stroke-linejoin:round;stroke:rgb(0%,0%,0%);stroke-opacity:1;stroke-miterlimit:10;" d="M 19.086094 16.541466 C 16.185625 16.541466 14.318281 19.447115 14.318281 19.447115 L 14.318281 19.555288 C 14.318281 19.555288 16.176719 22.475962 19.077187 22.475962 C 21.977656 22.475962 23.847969 19.576322 23.847969 19.576322 L 23.847969 19.465144 C 23.847969 19.465144 21.989531 16.541466 19.086094 16.541466 Z M 19.07125 21.024639 C 18.248906 21.024639 17.583906 20.357572 17.583906 19.53726 C 17.583906 18.716947 18.248906 18.04988 19.07125 18.04988 C 19.890625 18.04988 20.555625 18.716947 20.555625 19.53726 C 20.555625 20.357572 19.890625 21.024639 19.07125 21.024639 Z M 19.07125 21.024639 " transform="matrix(1.315789,0,0,1.3,0,0)"/></svg></button></span>\n\n                <button type="button" id="fr-file-delete-button-').concat(e, '" class=" fr-doc-edit-').concat(e, " fr-img-icon fr-btn fr-command fr-submit fr-file-action-icons\n                fr-file-button-").concat(e, ' fr-file-delete-button" data-cmd="deleteImage" data-title="Delete" data-param1="').concat(e, '" role="button">\n                <svg style=\'margin:0px !important; opacity:0.9\' class = "fr-svg" focusable="false" width="16px" height="16px" viewBox = "-2 3 30 30" xlmns = "http://w3.org/200/svg"><path d = \'M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z\'></path></svg>\n                </button>\n                 \n            </div>\n            <div id="user_area-').concat(e, "\" style=\"display: none;\">\n            \n              <div id=\"file_container\"></div>\n\n              <div style='display:block;text-align: center; margin-left:50%; id='edit-file-loader' class='fr-file-loader'></div>\n\n          </div> \n            ")
    }

    function Ee(e, t, n) {
      var r = A.popups.get("filesManager.insert");
      if (!n && e <= 100) {
        r.find(".fr-checkbox-file-" + t).get(0).disabled = !0, r.find(".fr-checkbox-" + t).get(0).classList.remove("fr-files-checkbox"), r.find(".fr-checkbox-" + t).get(0).classList.add("fr-checkbox-disabled");
        var a = r.find(".fr-file-progress-circle-" + t), o = r.find(".fr-file-upload-percent-" + t);
        return 50 < e ? a.get(0).setAttribute("class", "fr-file-progress-circle-" + t + " progress-circle p" + Math.floor(e) + " over50") : a.get(0).setAttribute("class", "fr-file-progress-circle-" + t + " progress-circle p" + Math.floor(e)), o.get(0).innerHTML = Math.floor(e) + "%", void ye(t, e, n)
      }
      n && (r.find(".fr-checkbox-file-" + t).get(0).disabled = !1, r.find(".fr-checkbox-" + t).get(0).classList.remove("fr-checkbox-disabled"), r.find(".fr-checkbox-" + t).get(0).classList.add("fr-files-checkbox"), r.find(".fr-file-item-right-" + t).get(0).innerHTML = Ce(t), ye(t, 100, n))
    }

    function ye(e, t, n) {
      var r = A.popups.get("filesManager.insert");
      r.find(".fr-progress-bar").removeClass("fr-none").addClass("fr-display-block"), r.find(".fr-upload-progress").hasClass("fr-height-set") && A.popups.setFileListHeight(r);
      var a = 0;
      w.set(e, t), w.forEach(function (e, t) {
        a += e
      }), a /= w.size, 100 == t && n && o++, r.find('.fr-command[data-cmd="filesUpload"]').addClass("fr-disabled"), r.find('.fr-command[data-cmd="filesByURL"]').addClass("fr-disabled"), r.find('.fr-command[data-cmd="filesEmbed"]').addClass("fr-disabled"), r.find(".fr-progress-bar").get(0).style.width = a + "%", o == w.size && (r.find(".fr-progress-bar").removeClass("fr-display-block").addClass("fr-none"), w = new Map, o = 0, r.find('.fr-command[data-cmd="filesUpload"]').removeClass("fr-disabled"), r.find('.fr-command[data-cmd="filesByURL"]').removeClass("fr-disabled"), r.find('.fr-command[data-cmd="filesEmbed"]').removeClass("fr-disabled"))
    }

    function Le(n, r) {
      J(), A.popups.get("filesManager.insert").find(".fr-upload-progress-layer").addClass("fr-active"), n.forEach(function (e, t) {
        Be(ke(e)) && A.opts.imageUploadRemoteUrls && A.opts.imageCORSProxy && A.opts.imageUpload ? Ne(e, n, y, r[t]) : x.set(r[t], e)
      })
    }

    function _e(e) {
      e && e.get && function n(e) {
        if ("false" == S(this).parents("[contenteditable]").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable")) return !0;
        if (e && "touchend" == e.type && de) return !0;
        if (e && A.edit.isDisabled()) return e.stopPropagation(), e.preventDefault(), !1;
        for (var t = 0; t < xt.INSTANCES.length; t++) xt.INSTANCES[t] != A && xt.INSTANCES[t].events.trigger("image.hideResizer");
        A.toolbar.disable(), e && (e.stopPropagation(), e.preventDefault());
        A.helpers.isMobile() && (A.events.disableBlur(), A.$el.blur(), A.events.enableBlur());
        A.opts.iframe && A.size.syncIframe();
        y = S(this), U(), A.browser.msie ? (A.popups.areVisible() && A.events.disableBlur(), A.win.getSelection && (A.win.getSelection().removeAllRanges(), A.win.getSelection().addRange(A.doc.createRange()))) : A.selection.clear();
        A.helpers.isIOS() && (A.events.disableBlur(), A.$el.blur());
        A.button.bulkRefresh(), A.events.trigger("video.hideResizer")
      }.call(e.get(0))
    }

    function we() {
      var e = S(this);
      e.removeClass("fr-uploading"), e.next().is("br") && e.next().remove(), (0 == a.length || 0 < a.length && a.length == u) && (f = e), "VIDEO" == e.get(0).tagName || "AUDIO" == e.get(0).tagName ? A.selection.setAfter(e.parent()) : A.selection.setAfter(e), A.undo.saveStep(), A.events.trigger("filesManager.loaded", [e]), Te(a)
    }

    function Ae() {
      var e, t = Array.prototype.slice.call(A.el.querySelectorAll("video, .fr-video > *")), n = [];
      for (e = 0; e < t.length; e++) n.push(t[e].getAttribute("src")), S(t[e]).toggleClass("fr-draggable", A.opts.videoMove), "" === t[e].getAttribute("class") && t[e].removeAttribute("class"), "" === t[e].getAttribute("style") && t[e].removeAttribute("style");
      if (r) for (e = 0; e < r.length; e++) n.indexOf(r[e].getAttribute("src")) < 0 && A.events.trigger("video.removed", [S(r[e])]);
      r = t
    }

    function Te(e) {
      if (null != e) {
        if (0 == e.length) return void (null != f && ("VIDEO" == f.get(0).tagName ? A.video._editVideo(f.parent()) : "IMG" == f.get(0).tagName ? A.image.edit(f) : f.trigger("click"), A.toolbar.disable()));
        xe(e.shift(), e)
      }
    }

    function Se(e) {
      var t = !1;
      if ($e(ke(x.get(e)))) A.trimVideoPlugin.trimVideo(k.get(e), e, k), t = !0; else if (Be(ke(x.get(e)))) {
        var n = x.get(e).link, r = A.o_doc.createElement("img");
        r.src = n, y = r, i = e, A.imageTUI.launch(A, !1, e), t = !0
      } else if (He(ke(x.get(e)))) {
        var a = {
          apiKey: A.opts.googleOptions.API_KEY,
          clientId: A.opts.googleOptions.CLIENT_ID,
          authorizeButton: "authorize_button-".concat(e),
          signoutButton: "signout_button",
          userArea: "user_area-".concat(e),
          fileInput: "file_input",
          fileIndex: e,
          file: k.get(e),
          fileContainer: "file_container",
          loadingText: "File is being uploaded...",
          events: {
            onInvalidFile: function (e) {
            }, onError: function (e) {
            }
          }
        };
        ce = function d(p) {
          var o, e = ["https://www.googleapis.com/discovery/v1/apis/drive/v2/rest"],
            u = "id,title,mimeType,userPermission,editable,copyable,shared,fileSize",
            h = "-------314159265358979323846", g = "\r\n--" + h + "\r\n", m = "\r\n--" + h + "--",
            t = (document.getElementById(p.authorizeButton), document.getElementById(p.userArea));
          p.events || (p.events = {});

          function n() {
            gapi.client.init({
              apiKey: p.apiKey,
              clientId: p.clientId,
              discoveryDocs: e,
              scope: "https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/drive.appdata"
            }).then(function () {
              gapi.auth2.getAuthInstance().isSignedIn.listen(r), r(gapi.auth2.getAuthInstance().isSignedIn.get()), function t(e) {
                !gapi.auth2.getAuthInstance().isSignedIn.get() || gapi.auth.getToken() !== undefined && gapi.auth.getToken().access_token === undefined ? Promise.resolve(gapi.auth2.getAuthInstance().signIn()).then(function () {
                  i()
                }) : i()
              }()
            }, function (e) {
              p.events.onError(e)
            })
          }

          function r(e) {
            e && (t.style.display = "block")
          }

          function a(e) {
            var t = gapi.auth.getToken().access_token, n = o,
              r = "https://docs.google.com/feeds/download/documents/export/Export?id=" + n + "&format=docx&access_token=" + t,
              a = new XMLHttpRequest;
            a.open("get", r), a.responseType = "arraybuffer", a.onload = function () {
              var e = new Blob([new Uint8Array(this.response)], {type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"}),
                t = k.get(p.fileIndex);
              e.name = t.name, e.lastModified = t.lastModified, e.lastModifiedDate = t.lastModifiedDate, k.set(p.fileIndex, e), A.filesManager.upload(e, x, y, p.fileIndex), l()
            }, a.send()
          }

          function i(e) {
            !function r(e) {
              for (var t = document.getElementsByClassName("fr-doc-edit-".concat(e)), n = 0; n < t.length; n++) t[n].setAttribute("disabled", !0), t[n].classList.add("fr-disabled")
            }(p.fileIndex);
            var t = p.file;
            t ? function n(c, d) {
              var f = new FileReader;
              f.readAsArrayBuffer(c), f.onload = function (e) {
                for (var t = {
                  title: c.name,
                  mimeType: "application/vnd.google-apps.document"
                }, n = "", r = new Uint8Array(f.result), a = r.byteLength, o = 0; o < a; o++) n += String.fromCharCode(r[o]);
                var i = btoa(n),
                  s = g + "Content-Type: application/json; charset=UTF-8\r\n\r\n" + JSON.stringify(t) + g + "Content-Type: application/octet-stream\r\nContent-Transfer-Encoding: base64\r\n\r\n" + i + m,
                  l = gapi.client.request({
                    path: "/upload/drive/v2/files",
                    method: "POST",
                    params: {uploadType: "multipart", fields: u},
                    headers: {"Content-Type": 'multipart/related; boundary="' + h + '"', "Content-Length": s.Length},
                    body: s
                  });
                d || (d = function (e) {
                }), l.execute(function (e, t) {
                  e.error ? p.events.onError(e.error) : d(e)
                })
              }
            }(t, s) : p.events.onInvalidFile("File is not selected")
          }

          function s(e) {
            o = e.id;
            var t = "https://docs.google.com/document/d/" + e.id + "/edit", n = A.o_doc.body,
              r = A.o_doc.createElement("div");
            r.setAttribute("id", "editDocContainer"), r.style.cssText = "position: fixed; top: 0;left: 0;padding: 0;width: 100%;height: 100%;background: rgba(255,255,255,1);z-index: 9998;display:block", r.innerHTML = '<div style="margin-top:25px; text-align:center"><label>Sign Out : </label><input type="checkbox" id ="markSignOut" role="button"/>  <button id="signout_button"  class="fr-trim-button" >Save </button> <button id="cancel_file_edit" class="fr-trim-button">Cancel</button></div>  <iframe title="Edit your file" frameBorder="0" width="100%" height="700px" src="' + t + '"></iframe>', n.appendChild(r), document.getElementById("signout_button").onclick = a, document.getElementById("cancel_file_edit").onclick = l
          }

          function l() {
            document.getElementById("markSignOut").checked && gapi.auth2.getAuthInstance().signOut().then(function () {
              gapi.auth.getToken() && (gapi.auth.getToken().access_token = undefined)
            });
            var e = document.getElementById("editDocContainer");
            e.parentNode.removeChild(e), document.getElementById("user_area-".concat(p.fileIndex)) && (document.getElementById("user_area-".concat(p.fileIndex)).style.display = "none"), function r(e) {
              for (var t = document.getElementsByClassName("fr-doc-edit-".concat(e)), n = 0; n < t.length; n++) t[n].removeAttribute("disabled"), t[n].classList.remove("fr-disabled")
            }(p.fileIndex)
          }

          p.events.onInvalidFile = p.events.onInvalidFile || function (e) {
          }, p.events.onError = p.events.onError || function (e) {
          };
          var c = {};
          return c.handleClientLoad = function () {
            gapi.load("client:auth2", n)
          }, c
        }(a), function o(e, t) {
          var r = function r(e, t) {
            var n = document.createElement("script");
            n.src = e, n.onload = function () {
              this.onload = function () {
              }, ce.handleClientLoad()
            }, n.onreadystatechange = function () {
              "complete" === this.readyState && this.onload()
            }, (document.getElementsByTagName("head")[0] || document.body).appendChild(n)
          };
          !function n() {
            0 != e.length ? r(e.shift(), n) : t && t()
          }()
        }(["https://apis.google.com/js/api.js"], function () {
        })
      }
      t && (p = !0)
    }

    function ke(e) {
      if ("" != e.type) return e.type;
      var n, r = /(?:\.([^.]+))?$/.exec(e.name)[1];
      return [[".doc", "application/msword"], [".docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"], [".gif", "image/gif"], [".jpeg", "image/jpeg"], [".jpg", "image/jpeg"], [".txt", "text/plain"], [".log", "type/text"], [".mov", "video/quicktime"], [".mp3", "audio/mpeg"], [".mp4", "video/mp4"], [".ogg", "audio/ogg"], [".ogv", "video/ogg"], [".pdf", "application/pdf"], [".png", "image/png"], [".webm", "video/webm"], [".webp", "image/webp"], [".wmv", "video/x-ms-wmv"], [".xls", "application/vnd.ms-excel"], [".xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"], [".zip", "application/x-zip-compressed"]].forEach(function (e, t) {
        e[0] == ".".concat(r) && (n = e[1])
      }), n
    }

    function xe(s, e) {
      if (He(ke(x.get(s))) || !Pe(ke(x.get(s)))) {
        var t = x.get(s).link, n = x.get(s).text;
        !n && k.get(s) && k.get(s).name && (n = k.get(s).name);
        var r = x.get(s).response;
        if (A.edit.on(), A.events.focus(!0), A.selection.restore(), A.opts.fileUseSelectedText && A.selection.text().length && (n = A.selection.text()), t.endsWith(".pdf") || t.endsWith(".txt")) Re('<iframe src="'.concat(t, '" title="').concat(n, '" width="\u201d100%\u201d" height="\u201d100%\u201d" class="fr-file"></iframe>'), !0); else A.html.insert('<a href="'.concat(t, '" target="_blank" id="fr-inserted-file" class="fr-file">').concat(n, "</a>"));
        var a = A.$el.find("#fr-inserted-file");
        a.removeAttr("id"), A.undo.saveStep(), function L() {
          var e, t = Array.prototype.slice.call(A.el.querySelectorAll("a.fr-file")), n = [];
          for (e = 0; e < t.length; e++) n.push(t[e].getAttribute("href"));
          if (le) for (e = 0; e < le.length; e++) n.indexOf(le[e].getAttribute("href")) < 0 && A.events.trigger("file.unlink", [le[e]]);
          le = t
        }(), A.selection.clear(), A.selection.setAfter(a), A.events.trigger("file.inserted", [a, r]), Te(e)
      }
      if (Be(ke(x.get(s))) && Pe(ke(x.get(s)))) {
        var i = x.get(s).link, o = x.get(s).sanitize, l = x.get(s).data, c = x.get(s).$existing_img,
          d = x.get(s).response;
        c && "string" == typeof c && (c = A.$(c)), A.edit.off(), ee(A.language.translate("Loading image")), o && (i = A.helpers.sanitizeURL(i));
        var f = new Image;
        f.onload = function () {
          var e, t;
          if (c) {
            A.undo.canDo() || c.hasClass("fr-uploading") || A.undo.saveStep();
            var n = c.data("fr-old-src");
            c.data("fr-image-pasted") && (n = null), A.$wp ? ((e = c.clone().removeData("fr-old-src").removeClass("fr-uploading").removeAttr("data-fr-image-pasted")).off("load"), n && c.attr("src", n), c.replaceWith(e)) : e = c;
            for (var r = e.get(0).attributes, a = 0; a < r.length; a++) {
              var o = r[a];
              0 === o.nodeName.indexOf("data-") && e.removeAttr(o.nodeName)
            }
            if (void 0 !== l) for (t in l) l.hasOwnProperty(t) && "link" != t && e.attr("data-".concat(t), l[t]);
            e.on("load", we), e.attr("src", i), A.edit.on(), A.undo.saveStep(), A.events.disableBlur(), A.$el.blur(), A.events.trigger(n ? "image.replaced" : "image.inserted", [e, d])
          } else e = function s(e, t, n) {
            var r, a = S(document.createElement("img")).attr("src", e);
            if (t && void 0 !== t) for (r in t) t.hasOwnProperty(r) && "link" != r && (" data-".concat(r, '="').concat(t[r], '"'), a.attr("data-".concat(r), t[r]));
            var o = A.opts.imageDefaultWidth;
            o && "auto" != o && (o = A.opts.imageResizeWithPercent ? "100%" : "".concat(o, "px"));
            a.attr("style", o ? "width: ".concat(o, ";") : ""), st(a, A.opts.imageDefaultDisplay, A.opts.imageDefaultAlign), a.on("load", n), a.on("error", n), A.edit.on(), A.events.focus(!0), A.selection.restore(), A.undo.saveStep(), A.opts.imageSplitHTML ? A.markers.split() : A.markers.insert();
            A.html.wrap();
            var i = A.$el.find(".fr-marker");
            i.length ? (i.parent().is("hr") && i.parent().after(i), A.node.isLastSibling(i) && i.parent().hasClass("fr-deletable") && i.insertAfter(i.parent()), i.replaceWith(a)) : A.$el.append(a);
            return a
          }(i, l, we), A.undo.saveStep(), A.events.disableBlur(), A.$el.blur(), A.events.trigger("image.inserted", [e, d])
        }, f.onerror = function () {
          j(N, null, null, s), Te(e)
        }, f.src = i
      }
      if (($e(ke(x.get(s))) || Fe(ke(x.get(s)))) && Pe(ke(x.get(s)))) if (T = s, "video/url" == ke(x.get(s))) {
        var p = !1;
        if (document.getElementById("fr-file-autoplay-button-" + s) !== undefined && (p = document.getElementById("fr-file-autoplay-button-" + s).checked), p && x.get(s) !== undefined && -1 < x.get(s).video.indexOf("iframe") && x.get(s).video.indexOf("autoplay=1") < 0) {
          var u = x.get(s).video.substring(x.get(s).video.indexOf("src") + 3), h = "&";
          (u = (u = u.substring(u.indexOf('"') + 1)).substring(0, u.indexOf('"'))).indexOf("?") < 0 && (h = "?"), x.get(s).video = x.get(s).video.replace(u, u += h + "autoplay=1")
        } else !p && x.get(s).video.indexOf(!1) && (-1 < x.get(s).video.indexOf("&autoplay=1") && (x.get(s).video = x.get(s).video.replace("&autoplay=1", "")), -1 < x.get(s).video.indexOf("?autoplay=1") && (x.get(s).video = x.get(s).video.replace("?autoplay=1", "")));
        A.events.focus(!0), A.selection.restore(), A.html.insert('<span contenteditable="false" draggable="true" class="fr-jiv fr-video fr-deletable">'.concat(x.get(s).video, "</span>"), !1, A.opts.videoSplitHTML), A.popups.hide("filesManager.insert");
        var g = A.$el.find(".fr-jiv");
        g.removeClass("fr-jiv"), g.toggleClass("fr-rv", A.opts.videoResponsive), function _(e, t, n) {
          !A.opts.htmlUntouched && A.opts.useClasses ? (e.removeClass("fr-fvl fr-fvr fr-dvb fr-dvi"), e.addClass("fr-fv".concat(n[0], " fr-dv").concat(t[0]))) : "inline" == t ? (e.css({display: "inline-block"}), "center" == n ? e.css({"float": "none"}) : "left" == n ? e.css({"float": "left"}) : e.css({"float": "right"})) : (e.css({
            display: "block",
            clear: "both"
          }), "left" == n ? e.css({textAlign: "left"}) : "right" == n ? e.css({textAlign: "right"}) : e.css({textAlign: "center"}))
        }(g, A.opts.videoDefaultDisplay, A.opts.videoDefaultAlign), g.toggleClass("fr-draggable", A.opts.videoMove), A.events.trigger("video.inserted", [g]), we.call(g)
      } else {
        var m = x.get(s).link, v = x.get(s).sanitize, b = x.get(s).data, C = x.get(s).$existing_img,
          E = x.get(s).response;
        A.edit.off(), v && (m = A.helpers.sanitizeURL(m)), function w() {
          var e, t;
          if (C) {
            A.undo.canDo() || C.find("video").hasClass("fr-uploading") || A.undo.saveStep();
            var n = C.find("video").data("fr-old-src"), r = C.data("fr-replaced");
            C.data("fr-replaced", !1), A.$wp ? ((e = C.clone(!0)).find("video").removeData("fr-old-src").removeClass("fr-uploading"), e.find("video").off("canplay"), n && C.find("video").attr("src", n), C.replaceWith(e)) : e = C;
            for (var a = e.find("video").get(0).attributes, o = 0; o < a.length; o++) {
              var i = a[o];
              0 === i.nodeName.indexOf("data-") && e.find("video").removeAttr(i.nodeName)
            }
            if (void 0 !== b) for (t in b) b.hasOwnProperty(t) && "link" != t && e.find("video").attr("data-".concat(t), b[t]);
            e.find("video").on("canplay", we), e.find("video").attr("src", m), A.edit.on(), Ae(), A.undo.saveStep(), A.$el.blur(), A.events.trigger(r ? "video.replaced" : "video.inserted", [e, E])
          } else e = function u(e, t, n, r, a) {
            var o, i = "";
            if (t && void 0 !== t) for (o in t) t.hasOwnProperty(o) && "link" != o && (i += " data-".concat(o, '="').concat(t[o], '"'));
            var s, l = A.opts.videoDefaultWidth;
            l && "auto" != l && (l = "".concat(l, "px"));
            if (Fe(r)) s = S(document.createElement("span")).attr("contenteditable", "false").attr("draggable", "true").attr("class", "fr-video fr-dv" + A.opts.videoDefaultDisplay[0] + ("center" != A.opts.videoDefaultAlign ? " fr-fv" + A.opts.videoDefaultAlign[0] : "")).html('<audio src="' + e + '" ' + i + " controls>" + A.language.translate("Your browser does not support HTML5 video.") + "</audio>"); else {
              var c = "", d = document.getElementById("fr-file-autoplay-button-" + a).checked;
              d && (c = "autoplay"), s = S(document.createElement("span")).attr("contenteditable", "false").attr("draggable", "true").attr("class", "fr-video fr-dv" + A.opts.videoDefaultDisplay[0] + ("center" != A.opts.videoDefaultAlign ? " fr-fv" + A.opts.videoDefaultAlign[0] : "")).html('<video src="' + e + '" ' + i + (l ? ' style="width: ' + l + ';" ' : "") + c + "  controls>" + A.language.translate("Your browser does not support HTML5 video.") + "</video>")
            }
            s.toggleClass("fr-draggable", A.opts.videoMove), A.edit.on(), A.events.focus(!0), A.selection.restore(), A.undo.saveStep(), A.opts.videoSplitHTML ? A.markers.split() : A.markers.insert();
            A.html.wrap();
            var f = A.$el.find(".fr-marker");
            A.node.isLastSibling(f) && f.parent().hasClass("fr-deletable") && f.insertAfter(f.parent());
            f.replaceWith(s);
            var p = "";
            p = Fe(r) ? "audio" : "video", s.find(p).get(0).readyState > s.find(p).get(0).HAVE_FUTURE_DATA || A.helpers.isIOS() ? n.call(s.find(p).get(0)) : (s.find(p).on("canplaythrough load", n), s.find(p).on("error", n));
            return s
          }(m, b, we, ke(x.get(s)), s), Ae(), A.undo.saveStep(), A.events.trigger("video.inserted", [e, E])
        }()
      }
      A.popups.hide("filesManager.insert"), R["delete"](s);
      var y = A.popups.get("filesManager.insert");
      y.find("input.fr-insert-attr.fr-checkbox-file-".concat(s))[0].checked = !1, y.find(".fr-file-" + s).get(0).classList.add("fr-unchecked"), q(), document.getElementById("fr-file-autoplay-button-" + s) && (document.getElementById("fr-file-autoplay-button-" + s).checked = !1), O = O.filter(function (e) {
        return e != s
      })
    }

    function Re(e, t) {
      var n, r;
      xt.VIDEO_EMBED_REGEX.test(e) ? (n = "video", r = A.opts.videoSplitHTML) : xt.IMAGE_EMBED_REGEX.test(e) && (n = "image", r = A.opts.imageSplitHTML), A.events.focus(!0), A.selection.restore();
      var a = !1;
      y && (Ze(), a = !0), A.html.insert('<span id="fr-inserted-file" contenteditable="true" draggable="true" class="fr-'.concat(n, ' fr-jiv fr-deletable">').concat(e, "</span>"), !1, r), A.popups.hide("filesManager.insert");
      var o = A.$el.find(".fr-jiv");
      o.removeClass("fr-jiv"), "video" == n && (o.toggleClass("fr-rv", A.opts.videoResponsive), function i(e, t, n) {
        !A.opts.htmlUntouched && A.opts.useClasses ? (e.removeClass("fr-fvl fr-fvr fr-dvb fr-dvi"), e.addClass("fr-fv".concat(n[0], " fr-dv").concat(t[0]))) : "inline" == t ? (e.css({display: "inline-block"}), "center" == n ? e.css({"float": "none"}) : "left" == n ? e.css({"float": "left"}) : e.css({"float": "right"})) : (e.css({
          display: "block",
          clear: "both"
        }), "left" == n ? e.css({textAlign: "left"}) : "right" == n ? e.css({textAlign: "right"}) : e.css({textAlign: "center"}))
      }(o, A.opts.videoDefaultDisplay, A.opts.videoDefaultAlign), o.toggleClass("fr-draggable", A.opts.videoMove), A.events.trigger(a ? "video.replaced" : "video.inserted", [o])), "image" == n && (st(o, A.opts.imageDefaultDisplay, A.opts.imageDefaultAlign), o.find("img").removeClass("fr-dii"), o.find("img").addClass("fr-dib"), o.toggleClass("fr-draggable", A.opts.imageMove), A.events.trigger(a ? "image.replaced" : "image.inserted", [o])), t && (f = o, A.selection.clear(), A.toolbar.disable(), A.video._editVideo(f))
    }

    function Me(e, t) {
      try {
        if (!1 === A.events.trigger("filesManager.uploaded", [e], !0)) return A.edit.on(), !1;
        var n = JSON.parse(e);
        return n.link ? n : (j(m, e, null, t), !1)
      } catch (r) {
        return j(D, e, null, t), !1
      }
    }

    function Oe(e, t) {
      try {
        var n = S(e).find("Location").text(), r = S(e).find("Key").text();
        return !1 === A.events.trigger("filesManager.uploadedToS3", [n, r, e], !0) ? (A.edit.on(), !1) : n
      } catch (a) {
        return j(D, e, null, t), !1
      }
    }

    function Ne(e, t, n, r) {
      if (-1 < F.indexOf(ke(e)) || !ke(e)) return j(H, null, null, r), !1;
      if (!1 === A.events.trigger("filesManager.beforeUpload", [t])) return !1;
      if (!(null !== A.opts.filesManagerUploadURL && A.opts.filesManagerUploadURL != L || A.opts.filesManagerUploadToS3 || A.opts.filesManagerUploadToAzure)) return function C(s, l, c) {
        var d = new FileReader;
        d.onload = function () {
          var e = d.result;
          if (d.result.indexOf("svg+xml") < 0) {
            for (var t = atob(d.result.split(",")[1]), n = [], r = 0; r < t.length; r++) n.push(t.charCodeAt(r));
            if (e = window.URL.createObjectURL(new Blob([new Uint8Array(n)], {type: ke(l)})), Be(ke(l))) {
              var a = {link: e, sanitize: !1, data: null, $existing_img: c, response: null, type: ke(l)};
              x.set(s, a)
            }
            if (He(ke(l))) {
              var o = {link: e, text: l.name, response: null, type: ke(l)};
              x.set(s, o)
            }
            if ($e(ke(l)) || Fe(ke(l))) {
              var i = {link: e, sanitize: !1, data: null, $existing_img: c, type: ke(l)};
              x.set(s, i)
            }
          }
        }, d.readAsDataURL(l)
      }(r, e), !1;
      if (Be(ke(e)) && (e.name || (e.name = (new Date).getTime() + "." + (ke(e) || "image/jpeg").replace(/image\//g, ""))), e.size > A.opts.filesManagerMaxSize) return j(B, null, null, r), !1;
      if (A.opts.filesManagerAllowedTypes.indexOf("*") < 0 && A.opts.filesManagerAllowedTypes.indexOf(ke(e)) < 0) return j(H, null, null, r), !1;
      var a;
      if (function E(e) {
        isNaN(e) || (A.popups.get("filesManager.insert").find(".fr-file-item-right-" + e).get(0).innerHTML = '<div class=\'fr-file-item-action-buttons\' >\n    <button type="button" id="fr-file-cancel-upload-button-'.concat(e, '" class="fr-img-icon fr-btn fr-command fr-submit fr-file-action-icons \n    fr-file-button-').concat(e, ' fr-file-cancel-upload-button" data-cmd="cancelUpload" data-title="Cancel" data-param1="').concat(e, '" role="button">\n    <svg style=\'margin:0px !important; opacity:0.9\' class = "fr-svg" focusable="false" width="16px" height="16px" viewBox = "-2 3 30 30" xlmns = "http://w3.org/200/svg"><path d = \'M13.4,12l5.6,5.6L17.6,19L12,13.4L6.4,19L5,17.6l5.6-5.6L5,6.4L6.4,5l5.6,5.6L17.6,5L19,6.4L13.4,12z\'></path></svg>\n    </button>\n\n    <button type="button" id="fr-upload-delete-button-').concat(e, '" class="fr-img-icon fr-btn fr-command fr-submit fr-file-action-icons \n    fr-file-button-').concat(e, ' fr-upload-delete-button" data-cmd="deleteUpload" data-title="Delete" data-param1="').concat(e, '" role="button">\n    <svg style=\'margin:0px !important; opacity:0.9\' class = "fr-svg" focusable="false" width="16px" height="16px" viewBox = "-2 3 30 30" xlmns = "http://w3.org/200/svg"><path d = \'M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z\'></path></svg>\n    </button>\n\n    <div class=\'progress-circle p0 fr-file-progress-circle-').concat(e, "'>\n                  <span class='fr-file-upload-percent-").concat(e, " fr-file-upload-percent'>0%</span>\n                  <div class='left-half-clipper'>\n                    <div class='first50-bar'></div>\n                    <div class='value-bar'></div>\n                  </div>\n                </div>\n            </div>"), w.set(e, 0))
      }(r), A.drag_support.formdata && (a = A.drag_support.formdata ? new FormData : null), a) {
        var o;
        if (!1 !== A.opts.filesManagerUploadToS3) for (o in a.append("key", A.opts.filesManagerUploadToS3.keyStart + (new Date).getTime() + "-" + (e.name || "untitled")), a.append("success_action_status", "201"), a.append("X-Requested-With", "xhr"), a.append("Content-Type", ke(e)), A.opts.filesManagerUploadToS3.params) A.opts.filesManagerUploadToS3.params.hasOwnProperty(o) && a.append(o, A.opts.filesManagerUploadToS3.params[o]);
        for (o in A.opts.filesManagerUploadParams) A.opts.filesManagerUploadParams.hasOwnProperty(o) && a.append(o, A.opts.filesManagerUploadParams[o]);
        a.append(A.opts.filesManagerUploadParam, e, e.name);
        var i, s, l = A.opts.filesManagerUploadURL;
        A.opts.filesManagerUploadToS3 && (l = A.opts.filesManagerUploadToS3.uploadURL ? A.opts.filesManagerUploadToS3.uploadURL : "https://".concat(A.opts.filesManagerUploadToS3.region, ".amazonaws.com/").concat(A.opts.filesManagerUploadToS3.bucket)), A.opts.filesManagerUploadToAzure && (l = A.opts.filesManagerUploadToAzure.uploadURL ? "".concat(A.opts.filesManagerUploadToAzure.uploadURL, "/").concat(e.name) : encodeURI("https://".concat(A.opts.filesManagerUploadToAzure.account, ".blob.core.windows.net/").concat(A.opts.filesManagerUploadToAzure.container, "/").concat(e.name)), i = l, A.opts.filesManagerUploadToAzure.SASToken && (l += A.opts.filesManagerUploadToAzure.SASToken), A.opts.filesManagerUploadMethod = "PUT");
        var c = A.core.getXHR(l, A.opts.filesManagerUploadMethod);
        if (A.opts.filesManagerUploadToAzure) {
          var d = (new Date).toUTCString();
          if (!A.opts.filesManagerUploadToAzure.SASToken && A.opts.filesManagerUploadToAzure.accessKey) {
            var f = A.opts.filesManagerUploadToAzure.account, p = A.opts.filesManagerUploadToAzure.container;
            if (A.opts.filesManagerUploadToAzure.uploadURL) {
              var u = A.opts.filesManagerUploadToAzure.uploadURL.split("/");
              p = u.pop(), f = u.pop().split(".")[0]
            }
            var h = "x-ms-blob-type:BlockBlob\nx-ms-date:".concat(d, "\nx-ms-version:2019-07-07"),
              g = encodeURI("/" + f + "/" + p + "/" + e.name),
              m = A.opts.filesManagerUploadMethod + "\n\n\n" + e.size + "\n\n" + ke(e) + "\n\n\n\n\n\n\n" + h + "\n" + g,
              v = A.cryptoJSPlugin.cryptoJS.HmacSHA256(m, A.cryptoJSPlugin.cryptoJS.enc.Base64.parse(A.opts.filesManagerUploadToAzure.accessKey)).toString(A.cryptoJSPlugin.cryptoJS.enc.Base64),
              b = "SharedKey " + f + ":" + v;
            s = v, c.setRequestHeader("Authorization", b)
          }
          for (o in c.setRequestHeader("x-ms-version", "2019-07-07"), c.setRequestHeader("x-ms-date", d), c.setRequestHeader("Content-Type", ke(e)), c.setRequestHeader("x-ms-blob-type", "BlockBlob"), A.opts.filesManagerUploadParams) A.opts.filesManagerUploadParams.hasOwnProperty(o) && c.setRequestHeader(o, A.opts.filesManagerUploadParams[o]);
          for (o in A.opts.filesManagerUploadToAzure.params) A.opts.filesManagerUploadToAzure.params.hasOwnProperty(o) && c.setRequestHeader(o, A.opts.filesManagerUploadToAzure.params[o])
        }
        c.onload = function () {
          He(ke(e)) ? function h(e, t, n, r, a) {
            var o = this.status, i = this.response, s = this.responseXML, l = this.responseText;
            try {
              if (A.opts.filesManagerUploadToS3 || A.opts.filesManagerUploadToAzure) if (201 === o) {
                var c;
                if (A.opts.filesManagerUploadToAzure) {
                  if (!1 === A.events.trigger("filesManager.uploadedToAzure", [this.responseURL, a, i], !0)) return A.edit.on(), !1;
                  c = r
                } else c = Oe(s, t);
                if (c) {
                  var d = {link: c, text: e, response: i, type: n};
                  x.set(t, d)
                }
              } else j(D, i || s, null, t); else if (200 <= o && o < 300) {
                var f = Me(l, t);
                if (f) {
                  var p = {link: f.link, text: e, response: i, type: n};
                  x.set(t, p)
                }
              } else j(I, i || l, null, t)
            } catch (u) {
              j(D, i || l, null, t)
            }
          }.call(c, e.name, r, ke(e), i, s) : function g(e, t, n, r, a) {
            var o = this.status, i = this.response, s = this.responseXML, l = this.responseText;
            try {
              if (A.opts.filesManagerUploadToS3 || A.opts.filesManagerUploadToAzure) if (201 == o) {
                var c;
                if (A.opts.filesManagerUploadToAzure) {
                  if (!1 === A.events.trigger("filesManager.uploadedToAzure", [this.responseURL, a, i], !0)) return A.edit.on(), !1;
                  c = r
                } else c = Oe(s, t);
                if (c) {
                  var d = {link: c, sanitize: !1, data: [], $existing_img: e, response: i || s, type: n};
                  x.set(t, d)
                }
              } else j(D, i || s, e, t); else if (200 <= o && o < 300) {
                var f = Me(l, t);
                if (f) {
                  var p = {link: f.link, sanitize: !1, data: f, $existing_img: e, response: i || s, type: n};
                  x.set(t, p)
                }
              } else j(I, i || l, e, t)
            } catch (u) {
              j(D, i || l, e, t)
            }
          }.call(c, y, r, ke(e), i, s), M.has(r) || Ee(100, r, !0)
        }, c.onerror = function () {
          j(D, this.response || this.responseText || this.responseXML, null, r)
        }, c.upload.onprogress = function (e) {
          !function n(e, t) {
            e.lengthComputable && Ee(e.loaded / e.total * 100 | 0, t, !1)
          }(e, r)
        }, c.onabort = function (e) {
          !function n(e, t) {
            j($, t, y, e)
          }(r, e)
        }, c.send(A.opts.filesManagerUploadToAzure ? e : a), _.set(r, c)
      }
    }

    function Ie(l) {
      A.events.$on(l, "click", ".fr-upload-progress-layer", function (e) {
        if (A.helpers.isMobile()) return e.stopPropagation(), !1
      }, !0), A.events.$on(l, "dragover dragenter", ".fr-upload-progress-layer", function (e) {
        e.preventDefault();
        for (var t = 0; t < e.originalEvent.dataTransfer.types.length; t++) "Files" == e.originalEvent.dataTransfer.types[t] && (e.originalEvent.dataTransfer.dropEffect = "none");
        return !1
      }, !0), A.events.$on(l, "dragleave dragend", ".fr-upload-progress-layer", function (e) {
        return e.preventDefault(), !1
      }, !0), A.events.$on(l, "dragover dragenter", ".fr-files-upload-layer", function (e) {
        return S(this).addClass("fr-drop"), (A.browser.msie || A.browser.edge) && e.preventDefault(), !1
      }, !0), A.events.$on(l, "dragleave dragend", ".fr-files-upload-layer", function (e) {
        return S(this).removeClass("fr-drop"), (A.browser.msie || A.browser.edge) && e.preventDefault(), !1
      }, !0), A.events.$on(l, "click", ".fr-insert-checkbox", function (e) {
        if (this.classList.contains("fr-checkbox-disabled")) return this.children.target.disabled = !0, void (this.children.target.checked = !1);
        var t = parseInt(this.id.split("-").pop());
        R.set(t, this.children.target.checked);
        for (var n = l.find('.fr-command[data-cmd="insertAll"]'), r = l.find('.fr-command[data-cmd="deleteAll"]'), a = l.find('input.fr-file-insert-check[type="checkbox"]'), o = a.length, i = !0, s = 0; s < o; s++) 1 == a[s].checked && (i = !1);
        if (i ? n.addClass("fr-disabled") : n.removeClass("fr-disabled"), i ? r.addClass("fr-disabled") : r.removeClass("fr-disabled"), this.children.target.checked) l.find(".fr-file-" + this.id.split("-").pop()).get(0).setAttribute("draggable", "true"), l.find(".fr-file-" + this.id.split("-").pop()).get(0).classList.remove("fr-unchecked"); else {
          this.id.split("-").pop();
          l.find(".fr-file-" + this.id.split("-").pop()).get(0).setAttribute("draggable", "false"), l.find(".fr-file-" + this.id.split("-").pop()).get(0).classList.add("fr-unchecked")
        }
      }), A.events.$on(l, "click", ".fr-file-insert-button", function (e) {
        this.classList.contains("fr-disabled") || xe(parseInt(this.id.split("-").pop()))
      }), A.events.$on(l, "click", ".fr-file-autoplay-button", function (e) {
        if (this.parentNode.classList.contains("fr-checkbox-disabled")) return this.disabled = !0, void (this.checked = !1);
        De(parseInt(this.id.split("-").pop()))
      }), A.events.$on(l, "click", ".fr-file-edit-button", function (e) {
        var t = parseInt(this.id.split("-").pop());
        l.find(".fr-file-edit-button-".concat(t)).hasClass("fr-disabled") || Se(t)
      }), A.events.$on(l, "click", ".fr-file-view-button", function (e) {
        var t = parseInt(this.id.split("-").pop());
        l.find(".fr-file-view-button-".concat(t)).hasClass("fr-disabled") || function v(e) {
          if (!Pe(ke(x.get(e)))) {
            var t = x.get(e).link, n = x.get(e).link;
            if (k.get(e) && k.get(e).name ? n = k.get(e).name : x.get(e).text && (n = x.get(e).text), 0 === t.indexOf("blob:") && A.browser.msie && window.navigator && window.navigator.msSaveBlob) window.navigator.msSaveBlob(k.get(e), n); else {
              var r = document.createElement("a");
              r.href = t, r.download = n, r.click()
            }
            return !1
          }
          var a = A.popups.get("filesManager.insert");
          if (0 < a.find(".fr-file-view-image-" + e).length) a.find(".fr-file-view-image-" + e)[0].remove(); else {
            for (var o = a.find(".fr-file-view"), i = 0; i < o.length; i++) o.get(i).remove();
            var s = a.find(".fr-file-view-" + e);
            if (Be(ke(x.get(e)))) {
              var l = '<div class="fr-file-view-modal">\n              <div class="fr-file-view-modal-content">\n              <div class="fr-file-view-close">&times;</div> \n                <img src="' + x.get(e).link + "\" class ='fr-file-view-image'/>\n                </div>\n              </div>";
              s[0].innerHTML = l + s[0].innerHTML
            } else if ($e(ke(x.get(e)))) {
              var c;
              if (x.get(e).hasOwnProperty("video")) {
                var d = x.get(e).video.substring(x.get(e).video.indexOf("src") + 3),
                  f = d.substring(d.indexOf('"') + 1);
                f = f.substring(0, f.indexOf('"')), c = '<div class="fr-file-view-modal">\n        <div class="fr-file-view-modal-content ">\n          <div class="fr-file-view-close">&times;</div> \n          <iframe width="640" height="360" src="'.concat(f + "&autoplay=1", '" frameborder="0" class = "fr-file-view-image"></iframe>\n        </div>\n      </div>')
              } else c = '<div class="fr-file-view-modal">\n          <div class="fr-file-view-modal-content ">\n            <div class="fr-file-view-close">&times;</div> \n            <video controls src="' + x.get(e).link + "\"  class ='fr-file-view-image' autoplay></video>\n          </div>\n        </div>";
              s[0].innerHTML = c + s[0].innerHTML
            } else if (Fe(ke(x.get(e)))) {
              var p = '<div class="fr-file-view-modal">\n        <div class="fr-file-view-modal-content ">\n          <div  class="fr-file-view-close">&times;</div> \n          <audio controls="controls"  class =\'fr-file-view-image\' autoplay>\n\n          <source src="'.concat(x.get(e).link, '" type="').concat(ke(x.get(e)), '" />\n\n            Your browser does not support the audio element.\n          </audio>\n        </div>\n      </div>');
              s[0].innerHTML = p + s[0].innerHTML
            } else if (He(ke(x.get(e)))) {
              var u = x.get(e).link, h = x.get(e).text;
              if (u.endsWith(".pdf") || u.endsWith(".txt")) {
                var g = '<div class="fr-file-view-modal">\t\n              <div class="fr-file-view-modal-content " >\t\n              <div class="fr-file-view-close">&times;</div> \t\n              <iframe src="'.concat(u, "\" style='background-color: white;' height='50%' width='50%' title=\"").concat(h, '" class="fr-file fr-file-view-image"></iframe>\t\n            </div>\t\n            </div>');
                s[0].innerHTML = g + s[0].innerHTML
              } else if (0 === u.indexOf("blob:") && A.browser.msie && window.navigator && window.navigator.msSaveBlob) window.navigator.msSaveBlob(k.get(e), h); else {
                var m = document.createElement("a");
                m.href = u, m.download = h, m.click()
              }
            }
          }
        }(t)
      }), A.events.$on(l, "click", ".fr-file-delete-button", function (e) {
        Z(parseInt(this.id.split("-").pop()))
      }), A.events.$on(l, "click", ".fr-file-cancel-upload-button", function (e) {
        !function n(e) {
          var t = A.popups.get("filesManager.insert");
          t.find(".fr-file-item-right-" + e).get(0).innerHTML = Ce(e), _.get(e).abort(), ye(e, 100, !0), t.find(".fr-checkbox-file-" + e).get(0).disabled = !0
        }(parseInt(this.id.split("-").pop()))
      }), A.events.$on(l, "click", ".fr-upload-delete-button", function (e) {
        !function t(e) {
          0 != _.get(e).readyState && (_.get(e).abort(), ye(e, 100, !0), _["delete"](e)), Z(e)
        }(parseInt(this.id.split("-").pop()))
      }), A.events.$on(l, "click", ".fr-file-view-close", function (e) {
        l.find(".fr-file-view-modal").get(0).outerHTML = ""
      }), A.events.$on(l, "click", ".fr-plugins-enable", function (e) {
        !function t() {
          g.forEach(function (e) {
            A.opts.pluginsEnabled.indexOf(e) < 0 && A.opts.pluginsEnabled.push(e)
          })
        }(), function n(e) {
          for (var t in e) if (!A[t]) {
            if (xt.PLUGINS[t] && A.opts.pluginsEnabled.indexOf(t) < 0) continue;
            A[t] = new e[t](A), A[t]._init && A[t]._init()
          }
        }(xt.PLUGINS), A.popups.get("filesManager.insert").get(0).outerHTML = "", Ue(), C(!0)
      }), A.events.$on(l, "click", ".fr-plugins-cancel", function (e) {
        A.popups.hide("filesManager.insert")
      }), A.events.$on(l, "drop", ".fr-upload-progress", function (e) {
        e.preventDefault(), e.stopPropagation()
      }), A.events.$on(l, "drop", ".fr-files-upload-layer", function (e) {
        e.preventDefault(), e.stopPropagation(), S(this).removeClass("fr-drop");
        var t = e.originalEvent.dataTransfer;
        if (t && t.files) {
          var n = l.data("instance") || A;
          n.events.disableBlur();
          for (var r = [], a = 0; a < t.files.length; a++) {
            var o = h;
            k.set(o, t.files[a]), me(o), R.set(o, !1), r.push(o), h++
          }
          for (var i = 0; i < r.length; i++) n.filesManager.upload(k.get(r[i]), t.files, y, r[i]);
          n.events.enableBlur()
        }
      }, !0), A.helpers.isIOS() && A.events.$on(l, "touchstart", '.fr-files-upload-layer input[type="file"]', function () {
        S(this).trigger("click")
      }, !0), A.events.$on(l, "change", '.fr-files-upload-layer input[type="file"]', function () {
        if (this.files) {
          var e = l.data("instance") || A;
          e.events.disableBlur(), l.find("input:focus").blur(), e.events.enableBlur();
          var t = [];
          if ("undefined" != typeof this.files && 0 < this.files.length) {
            for (var n = 0; n < this.files.length; n++) {
              var r = h;
              k.set(r, this.files[n]), me(r), R.set(r, !1), ++h, t.push(r)
            }
            for (var a = 0; a < t.length; a++) e.filesManager.upload(k.get(t[a]), this.files, y, t[a])
          }
        }
        S(this).val("")
      }, !0)
    }

    function De(t) {
      document.getElementById("fr-file-autoplay-button-" + t).checked ? O.push(t) : O = O.filter(function (e) {
        return e != t
      })
    }

    function Be(e) {
      return e && "image" === e.split("/")[0]
    }

    function He(e) {
      return e && "image" != e.split("/")[0] && e && "video" != e.split("/")[0] && e && "audio" != e.split("/")[0]
    }

    function $e(e) {
      return e && "video" === e.split("/")[0]
    }

    function Fe(e) {
      return e && "audio" === e.split("/")[0]
    }

    function Pe(e) {
      if ("audio/ogg" == e || "video/ogg" == e || "image/webp" == e || "video/webm" == e) {
        if (A.browser.msie || A.browser.edge || A.browser.safari) return !1;
        if (A.helpers.isMobile()) {
          if ("audio/ogg" == e || "video/ogg" == e) return !1;
          if (!A.helpers.isAndroid() && !A.browser.chrome) return !1
        }
      }
      return !0
    }

    function Ue(e) {
      if (e) return A.popups.onRefresh("filesManager.insert", b), A.popups.onHide("filesManager.insert", P), !0;
      var t, n, r = "";
      A.opts.imageUpload || -1 === A.opts.filesInsertButtons.indexOf("filesUpload") || A.opts.imageInsertButtons.splice(A.opts.filesInsertButtons.indexOf("filesUpload"), 1);
      var a = A.button.buildList(A.opts.filesInsertButtons), o = A.button.buildList(A.opts.filesInsertButtons2);
      "" !== a && (r = '<div class="fr-buttons fr-tabs">'.concat(a, '<span class="fr-align-right">').concat(o, "</span></div>"));
      var i = A.opts.filesInsertButtons.indexOf("filesUpload"), s = A.opts.filesInsertButtons.indexOf("filesByURL"),
        l = A.opts.filesInsertButtons.indexOf("filesEmbed"), c = "";
      0 <= i && (t = " fr-active", 0 <= s && s < i && (t = ""), c = '<div class="fr-files-upload-layer'.concat(t, ' fr-layer " id="fr-files-upload-layer-').concat(A.id, '"><div style="display:flex"><div class="fr-upload-section"><div class = \'fr-blue-decorator\'><div class = \'fr-cloud-icon\'><svg class = "fr-svg" focusable="false" width="26px" height="26px" viewBox = "0 0 24 24" xlmns = "http://w3.org/200/svg"><path d = \'M12 6.66667a4.87654 4.87654 0 0 1 4.77525 3.92342l0.29618 1.50268 1.52794 0.10578a2.57021 2.57021 0 0 1 -0.1827 5.13478H6.5a3.49774 3.49774 0 0 1 -0.3844 -6.97454l1.06682 -0.11341L7.678 9.29387A4.86024 4.86024 0 0 1 12 6.66667m0 -2A6.871 6.871 0 0 0 5.90417 8.37 5.49773 5.49773 0 0 0 6.5 19.33333H18.41667a4.57019 4.57019 0 0 0 0.32083 -9.13A6.86567 6.86567 0 0 0 12 4.66667Zm0.99976 7.2469h1.91406L11.99976 9 9.08618 11.91357h1.91358v3H11V16h2V14h-0.00024Z\'></path></svg></div>Drag & Drop One or More Files<br><div class="decorated"><span> OR </span></div> Click Browse Files </div> </div><div class="fr-form"><input type="file" accept="').concat(A.opts.filesManagerAllowedTypes.join(",").toLowerCase(), '" tabIndex="-1" aria - labelledby="fr-files-upload-layer-').concat(A.id, '"role="button" multiple></div> </div></div>'));
      var d = "";
      0 <= l && (t = " fr-active", (i < l && 0 <= i || s < l && 0 <= s) && (t = ""), d = '<div class="fr-files-embed-layer fr-layer'.concat(t, '" id="fr-files-embed-layer-').concat(A.id, '"><div class="fr-input-line padding-top-15"><textarea data-gramm_editor="false" style=\'height:60px\' id="fr-files-embed-layer-text').concat(A.id, '" type="text" placeholder="').concat(A.language.translate("Embedded Code"), '" tabIndex="1" aria-required="true" rows="5"></textarea></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="insertEmbed" tabIndex="2" role="button">').concat(A.language.translate("Insert"), "</button></div></div>"));
      var f = "";
      0 <= s && (t = " fr-active", 0 <= i && i < s && (t = ""), f = '<div class="fr-files-by-url-layer'.concat(t, ' fr-layer" id="fr-files-by-url-layer-').concat(A.id, '"><div class="fr-input-line fr-by-url-padding"><input id="fr-files-by-url-layer-text-').concat(A.id, '" type="text" placeholder="http://" tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="filesInsertByURL" tabIndex="2" role="button">').concat(A.language.translate("Add"), "</button></div></div>"));
      var p = {
        buttons: r,
        upload_layer: c,
        by_url_layer: f,
        embed_layer: d,
        upload_progress_layer: "<div class = ' fr-margin-16 fr-upload-progress' id=\"fr-upload-progress-layer-".concat(A.id, "\" ><div  class='fr-progress-bar-style'><div class='fr-progress-bar fr-none'></div></div><div id='filesList' class = 'fr-upload-progress-layer fr-layer'></div></div>"),
        progress_bar: '<div class="fr-files-progress-bar-layer fr-layer"><h3 tabIndex="-1" class="fr-message">Uploading</h3><div class="fr-loader"><span class="fr-progress"></span></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-dismiss" data-cmd="filesDismissError" tabIndex="2" role="button">OK</button></div></div>'
      };
      return 1 <= A.opts.imageInsertButtons.length && (n = A.popups.create("filesManager.insert", p)), A.$wp && A.events.$on(A.$wp, "scroll", function () {
        y && A.popups.isVisible("filesManager.insert") && replace()
      }), Ie(n), A.popups.setPopupDimensions(n), n
    }

    function ze(e) {
      var t = e.split("/").pop();
      if (t.split(".").length < 2) {
        var n = new Date;
        return t + "-" + n.getDate() + "/" + (n.getMonth() + 1) + "/" + n.getFullYear()
      }
      return t
    }

    function Ke() {
      y && A.popups.get("image.alt").find("input").val(y.attr("alt") || "").trigger("change")
    }

    function Ve() {
      var e = A.popups.get("image.alt");
      e || (e = We()), J(), A.popups.refresh("image.alt"), A.popups.setContainer("image.alt", A.$sc);
      var t = ct();
      dt() && (t = t.find(".fr-img-wrap"));
      var n = t.offset().left + t.outerWidth() / 2, r = t.offset().top + t.outerHeight();
      A.popups.show("image.alt", n, r, t.outerHeight(), !0)
    }

    function We(e) {
      if (e) return A.popups.onRefresh("image.alt", Ke), !0;
      var t = {
        buttons: '<div class="fr-buttons fr-tabs">'.concat(A.button.buildList(A.opts.imageAltButtons), "</div>"),
        alt_layer: '<div class="fr-image-alt-layer fr-layer fr-active" id="fr-image-alt-layer-'.concat(A.id, '"><div class="fr-input-line"><input id="fr-image-alt-layer-text-').concat(A.id, '" type="text" placeholder="').concat(A.language.translate("Alternative Text"), '" tabIndex="1"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageSetAlt" tabIndex="2" role="button">').concat(A.language.translate("Update"), "</button></div></div>")
      }, n = A.popups.create("image.alt", t);
      return A.$wp && A.events.$on(A.$wp, "scroll.image-alt", function () {
        y && A.popups.isVisible("image.alt") && Ve()
      }), n
    }

    function Ge() {
      var e = A.popups.get("image.size");
      if (y) if (dt()) {
        var t = y.parent();
        t.get(0).style.width || (t = y.parent().parent()), e.find('input[name="width"]').val(t.get(0).style.width).trigger("change"), e.find('input[name="height"]').val(t.get(0).style.height).trigger("change")
      } else e.find('input[name="width"]').val(y.get(0).style.width).trigger("change"), e.find('input[name="height"]').val(y.get(0).style.height).trigger("change")
    }

    function Ye() {
      var e = A.popups.get("image.size");
      e || (e = je()), J(), A.popups.refresh("image.size"), A.popups.setContainer("image.size", A.$sc);
      var t = ct();
      dt() && (t = t.find(".fr-img-wrap"));
      var n = t.offset().left + t.outerWidth() / 2, r = t.offset().top + t.outerHeight();
      A.popups.show("image.size", n, r, t.outerHeight(), !0)
    }

    function je(e) {
      if (e) return A.popups.onRefresh("image.size", Ge), !0;
      var t = {
        buttons: '<div class="fr-buttons fr-tabs">'.concat(A.button.buildList(A.opts.imageSizeButtons), "</div>"),
        size_layer: '<div class="fr-image-size-layer fr-layer fr-active" id="fr-image-size-layer-'.concat(A.id, '"><div class="fr-image-group"><div class="fr-input-line"><input id="fr-image-size-layer-width-\'').concat(A.id, '" type="text" name="width" placeholder="').concat(A.language.translate("Width"), '" tabIndex="1"></div><div class="fr-input-line"><input id="fr-image-size-layer-height').concat(A.id, '" type="text" name="height" placeholder="').concat(A.language.translate("Height"), '" tabIndex="1"></div></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageSetSize" tabIndex="2" role="button">').concat(A.language.translate("Update"), "</button></div></div>")
      }, n = A.popups.create("image.size", t);
      return A.$wp && A.events.$on(A.$wp, "scroll.image-size", function () {
        y && A.popups.isVisible("image.size") && Ye()
      }), n
    }

    function qe(e, t, n, r) {
      return e.pageX = t, V.call(this, e), e.pageX = e.pageX + n * Math.floor(Math.pow(1.1, r)), W.call(this, e), G.call(this, e), ++r
    }

    function Ze(e) {
      (e = e || ct()) && !1 !== A.events.trigger("image.beforeRemove", [e]) && (A.popups.hideAll(), rt(!0), A.undo.canDo() || A.undo.saveStep(), e.get(0) == A.el ? e.removeAttr("src") : (e.get(0).parentNode && "A" == e.get(0).parentNode.tagName ? (A.selection.setBefore(e.get(0).parentNode) || A.selection.setAfter(e.get(0).parentNode) || e.parent().after(xt.MARKERS), S(e.get(0).parentNode).remove()) : (A.selection.setBefore(e.get(0)) || A.selection.setAfter(e.get(0)) || e.after(xt.MARKERS), e.remove()), A.html.fillEmptyBlocks(), A.selection.restore()), A.undo.saveStep())
    }

    function Xe(e) {
      var t = e.which;
      if (y && (t == xt.KEYCODE.BACKSPACE || t == xt.KEYCODE.DELETE)) return e.preventDefault(), e.stopPropagation(), Ze(), !1;
      if (y && t == xt.KEYCODE.ESC) {
        var n = y;
        return rt(!0), A.selection.setAfter(n.get(0)), A.selection.restore(), e.preventDefault(), !1
      }
      if (!y || t != xt.KEYCODE.ARROW_LEFT && t != xt.KEYCODE.ARROW_RIGHT) return y && t === xt.KEYCODE.TAB ? (e.preventDefault(), e.stopPropagation(), rt(!0), !1) : y && t != xt.KEYCODE.F10 && !A.keys.isBrowserAction(e) ? (e.preventDefault(), e.stopPropagation(), !1) : void 0;
      var r = y.get(0);
      return rt(!0), t == xt.KEYCODE.ARROW_LEFT ? A.selection.setBefore(r) : A.selection.setAfter(r), A.selection.restore(), e.preventDefault(), !1
    }

    function Qe(e) {
      if (e && "IMG" == e.tagName) {
        if (A.node.hasClass(e, "fr-uploading") || A.node.hasClass(e, "fr-error") ? e.parentNode.removeChild(e) : A.node.hasClass(e, "fr-draggable") && e.classList.remove("fr-draggable"), e.parentNode && e.parentNode.parentNode && A.node.hasClass(e.parentNode.parentNode, "fr-img-caption")) {
          var t = e.parentNode.parentNode;
          t.removeAttribute("contenteditable"), t.removeAttribute("draggable"), t.classList.remove("fr-draggable");
          var n = e.nextSibling;
          n && n.removeAttribute("contenteditable")
        }
      } else if (e && e.nodeType == Node.ELEMENT_NODE) for (var r = e.querySelectorAll("img.fr-uploading, img.fr-error, img.fr-draggable"), a = 0; a < r.length; a++) Qe(r[a])
    }

    function Je(e) {
      var t = e.target.result, n = A.opts.imageDefaultWidth;
      n && "auto" != n && (n += A.opts.imageResizeWithPercent ? "%" : "px"), A.undo.saveStep(), A.html.insert('<img data-fr-image-pasted="true" src="'.concat(t, '"').concat(n ? ' style="width: '.concat(n, ';"') : "", ">"));
      var r = A.$el.find('img[data-fr-image-pasted="true"]');
      r && st(r, A.opts.imageDefaultDisplay, A.opts.imageDefaultAlign), A.events.trigger("paste.after")
    }

    function et(e, t) {
      var n = new FileReader;
      n.onload = function r(e) {
        var t = A.opts.imageDefaultWidth;
        t && "auto" != t && (t += A.opts.imageResizeWithPercent ? "%" : "px"), A.html.insert('<img data-fr-image-pasted="true" src="'.concat(e, '"').concat(t ? ' style="width: '.concat(t, ';"') : "", ">"));
        var n = A.$el.find('img[data-fr-image-pasted="true"]');
        n && st(n, A.opts.imageDefaultDisplay, A.opts.imageDefaultAlign), A.events.trigger("paste.after")
      }(t), n.readAsDataURL(e, t)
    }

    function tt(e) {
      if (e && e.clipboardData && e.clipboardData.items) {
        var t = (e.clipboardData || window.clipboardData).getData("text/html") || "",
          n = (new DOMParser).parseFromString(t, "text/html").querySelector("img");
        if (n) {
          if (!n) return !1;
          var r = n.src, a = null;
          if (e.clipboardData.types && -1 != [].indexOf.call(e.clipboardData.types, "text/rtf") || e.clipboardData.getData("text/rtf")) a = e.clipboardData.items[0].getAsFile(); else for (var o = 0; o < e.clipboardData.items.length && !(a = e.clipboardData.items[o].getAsFile()); o++) ;
          if (a) return et(a, r), !1
        } else {
          var i = null;
          if (e.clipboardData.types && -1 != [].indexOf.call(e.clipboardData.types, "text/rtf") || e.clipboardData.getData("text/rtf")) i = e.clipboardData.items[0].getAsFile(); else for (var s = 0; s < e.clipboardData.items.length && !(i = e.clipboardData.items[s].getAsFile()); s++) ;
          if (i) return function l(e) {
            var t = new FileReader;
            t.onload = Je, t.readAsDataURL(e)
          }(i), !1
        }
      }
    }

    function nt(e) {
      return e = e.replace(/<img /gi, '<img data-fr-image-pasted="true" ')
    }

    function rt(e) {
      y && (function t() {
        return at
      }() || !0 === e) && (A.toolbar.enable(), l && l.removeClass("fr-active"), A.popups.hide("image.edit"), y = null, it(), c = null, d && d.hide())
    }

    var at = !1;

    function ot() {
      at = !0
    }

    function it() {
      at = !1
    }

    function st(e, t, n) {
      !A.opts.htmlUntouched && A.opts.useClasses ? (S(e[e.length - 1]).removeClass("fr-fil fr-fir fr-dib fr-dii"), n && S(e[e.length - 1]).addClass("fr-fi".concat(n[0])), t && S(e[e.length - 1]).addClass("fr-di".concat(t[0]))) : "inline" == t ? (e.css({
        display: "inline-block",
        verticalAlign: "bottom",
        margin: A.opts.imageDefaultMargin
      }), "center" == n ? e.css({
        "float": "none",
        marginBottom: "",
        marginTop: "",
        maxWidth: "calc(100% - ".concat(2 * A.opts.imageDefaultMargin, "px)"),
        textAlign: "center"
      }) : "left" == n ? e.css({
        "float": "left",
        marginLeft: 0,
        maxWidth: "calc(100% - ".concat(A.opts.imageDefaultMargin, "px)"),
        textAlign: "left"
      }) : e.css({
        "float": "right",
        marginRight: 0,
        maxWidth: "calc(100% - ".concat(A.opts.imageDefaultMargin, "px)"),
        textAlign: "right"
      })) : "block" == t && (e.css({
        display: "block",
        "float": "none",
        verticalAlign: "top",
        margin: "".concat(A.opts.imageDefaultMargin, "px auto"),
        textAlign: "center"
      }), "left" == n ? e.css({marginLeft: 0, textAlign: "left"}) : "right" == n && e.css({
        marginRight: 0,
        textAlign: "right"
      }))
    }

    function lt() {
      return y
    }

    function ct() {
      return dt() ? y.parents(".fr-img-caption").first() : y
    }

    function dt() {
      return !!y && 0 < y.parents(".fr-img-caption").length
    }

    return {
      _init: function ft() {
        var r;
        (function e() {
          A.events.$on(A.$el, A._mousedown, "IMG" == A.el.tagName ? null : 'img:not([contenteditable="false"])', function (e) {
            if ("false" == S(this).parents("contenteditable").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable")) return !0;
            A.helpers.isMobile() || A.selection.clear(), t = !0, A.popups.areVisible() && A.events.disableBlur(), A.browser.msie && (A.events.disableBlur(), A.$el.attr("contenteditable", !1)), A.draggable || "touchstart" == e.type || e.preventDefault(), e.stopPropagation()
          }), A.events.$on(A.$el, A._mousedown, ".fr-img-caption .fr-inner", function (e) {
            A.core.hasFocus() || A.events.focus(), e.stopPropagation()
          }), A.events.$on(A.$el, "paste", ".fr-img-caption .fr-inner", function (e) {
            !0 === A.opts.toolbarInline && (A.toolbar.hide(), e.stopPropagation())
          }), A.events.$on(A.$el, A._mouseup, "IMG" == A.el.tagName ? null : 'img:not([contenteditable="false"])', function (e) {
            if ("false" == S(this).parents("contenteditable").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable")) return !0;
            t && (t = !1, e.stopPropagation(), A.browser.msie && (A.$el.attr("contenteditable", !0), A.events.enableBlur()))
          }), A.events.on("keyup", function (e) {
            if (e.shiftKey && "" === A.selection.text().replace(/\n/g, "") && A.keys.isArrow(e.which)) {
              var t = A.selection.element(), n = A.selection.endElement();
              t && "IMG" == t.tagName ? _e(S(t)) : n && "IMG" == n.tagName && _e(S(n))
            }
          }, !0), A.events.on("window.mousedown", ot), A.events.on("window.touchmove", it), A.events.on("mouseup window.mouseup", function () {
            if (y) return rt(), !1;
            it()
          }), A.events.on("commands.mousedown", function (e) {
            0 < e.parents(".fr-toolbar").length && rt()
          }), A.events.on("image.resizeEnd", function () {
            A.opts.iframe && A.size.syncIframe()
          }), A.events.on("blur image.hideResizer commands.undo commands.redo element.dropped", function () {
            rt(!(t = !1))
          }), A.events.on("modals.hide", function () {
            y && A.selection.clear()
          }), A.events.on("image.resizeEnd", function () {
            A.win.getSelection && _e(y)
          }), A.opts.imageAddNewLine && A.events.on("image.inserted", function (e) {
            var t = e.get(0);
            for (t.nextSibling && "BR" === t.nextSibling.tagName && (t = t.nextSibling); t && !A.node.isElement(t);) t = A.node.isLastSibling(t) ? t.parentNode : null;
            A.node.isElement(t) && (A.opts.enter === xt.ENTER_BR ? e.after("<br>") : S(A.node.blockParent(e.get(0))).after("<".concat(A.html.defaultTag(), "><br></").concat(A.html.defaultTag(), ">")))
          })
        })(), "IMG" == A.el.tagName && A.$el.addClass("fr-view"), A.helpers.isMobile() && (A.events.$on(A.$el, "touchstart", "IMG" == A.el.tagName ? null : 'img:not([contenteditable="false"])', function () {
          de = !1
        }), A.events.$on(A.$el, "touchmove", function () {
          de = !0
        })), A.$wp ? (A.events.on("window.keydown keydown", Xe, !0), A.events.on("keyup", function (e) {
          if (y && e.which == xt.KEYCODE.ENTER) return !1
        }, !0), A.events.$on(A.$el, "keydown", function () {
          var e = A.selection.element();
          (e.nodeType === Node.TEXT_NODE || "BR" == e.tagName && A.node.isLastSibling(e)) && (e = e.parentNode), A.node.hasClass(e, "fr-inner") || (A.node.hasClass(e, "fr-img-caption") || (e = S(e).parents(".fr-img-caption").get(0)), A.node.hasClass(e, "fr-img-caption") && (A.opts.trackChangesEnabled || S(e).after(xt.INVISIBLE_SPACE + xt.MARKERS), A.selection.restore()))
        })) : A.events.$on(A.$win, "keydown", Xe), A.events.on("toolbar.esc", function () {
          if (y) {
            if (A.$wp) A.events.disableBlur(), A.events.focus(); else {
              var e = y;
              rt(!0), A.selection.setAfter(e.get(0)), A.selection.restore()
            }
            return !1
          }
        }, !0), A.events.on("toolbar.focusEditor", function () {
          if (y) return !1
        }, !0), A.events.on("window.cut window.copy", function (e) {
          if (y && A.popups.isVisible("image.edit") && !A.popups.get("image.edit").find(":focus").length) {
            var t = ct();
            dt() ? (t.before(xt.START_MARKER), t.after(xt.END_MARKER), A.selection.restore(), A.paste.saveCopiedText(t.get(0).outerHTML, t.text())) : A.paste.saveCopiedText(y.get(0).outerHTML, y.attr("alt")), "copy" == e.type ? setTimeout(function () {
              _e(y)
            }) : (rt(!0), A.undo.saveStep(), setTimeout(function () {
              A.undo.saveStep()
            }, 0))
          }
        }, !0), A.browser.msie && A.events.on("keydown", function (e) {
          if (!A.selection.isCollapsed() || !y) return !0;
          var t = e.which;
          t == xt.KEYCODE.C && A.keys.ctrlKey(e) ? A.events.trigger("window.copy") : t == xt.KEYCODE.X && A.keys.ctrlKey(e) && A.events.trigger("window.cut")
        }), A.events.$on(S(A.o_win), "keydown", function (e) {
          var t = e.which;
          if (y && t == xt.KEYCODE.BACKSPACE) return e.preventDefault(), !1
        }), A.events.$on(A.$win, "keydown", function (e) {
          var t = e.which;
          y && y.hasClass("fr-uploading") && t == xt.KEYCODE.ESC && y.trigger("abortUpload")
        }), A.events.on("destroy", function () {
          y && y.hasClass("fr-uploading") && y.trigger("abortUpload")
        }), A.events.on("paste.before", tt), A.events.on("paste.beforeCleanup", nt), A.events.on("html.processGet", Qe), A.opts.imageOutputSize && A.events.on("html.beforeGet", function () {
          r = A.el.querySelectorAll("img");
          for (var e = 0; e < r.length; e++) {
            var t = r[e].style.width || S(r[e]).width(), n = r[e].style.height || S(r[e]).height();
            t && r[e].setAttribute("width", "".concat(t).replace(/px/, "")), n && r[e].setAttribute("height", "".concat(n).replace(/px/, ""))
          }
        }), A.opts.iframe && A.events.on("image.loaded", A.size.syncIframe), A.events.$on(S(A.o_win), "orientationchange.image", function () {
          setTimeout(function () {
            y && _e(y)
          }, 100)
        }), function a(e) {
          if (e) return A.$wp && A.events.$on(A.$wp, "scroll.image-edit", function () {
            y && A.popups.isVisible("image.edit") && A.events.disableBlur()
          }), !0;
          var t = "";
          if (0 < A.opts.imageEditButtons.length) {
            var n = {buttons: t += '<div class="fr-buttons"> \n        '.concat(A.button.buildList(A.opts.imageEditButtons), "\n        </div>")};
            return A.popups.create("image.edit", n)
          }
          return !1
        }(!0), Ue(!0), je(!0), We(!0), A.events.on("node.remove", function (e) {
          if ("IMG" == e.get(0).tagName) return Ze(e), !1
        }), A.events.on("popups.hide.filesManager.insert", function (e) {
          A.filesManager.minimizePopup(T)
        })
      },
      showInsertPopup: C,
      showLayer: function pt(e) {
        var t, n, r = A.popups.get("filesManager.insert");
        if (y || A.opts.toolbarInline) {
          if (y) {
            var a = ct();
            dt() && (a = a.find(".fr-img-wrap")), n = a.offset().top + a.outerHeight(), t = a.offset().left
          }
        } else {
          var o = A.$tb.find('.fr-command[data-cmd="insertFiles"]');
          t = o.offset().left, n = o.offset().top + (A.opts.toolbarBottom ? 10 : o.outerHeight() - 10)
        }
        !y && A.opts.toolbarInline && (n = r.offset().top - A.helpers.getPX(r.css("margin-top")), r.hasClass("fr-above") && (n += r.outerHeight())), r.find(".fr-layer").removeClass("fr-active"), r.find(".fr-".concat(e, "-layer")).addClass("fr-active"), r.find(".fr-upload-progress-layer").addClass("fr-active"), A.popups.show("filesManager.insert", t, n, y ? y.outerHeight() : 0), A.accessibility.focusPopup(r)
      },
      refreshUploadButton: function ut(e) {
        var t = A.popups.get("filesManager.insert");
        t && t.find(".fr-files-upload-layer").hasClass("fr-active") && e.addClass("fr-active").attr("aria-pressed", !0)
      },
      refreshByURLButton: function ht(e) {
        var t = A.popups.get("filesManager.insert");
        t && t.find(".fr-files-by-url-layer").hasClass("fr-active") && e.addClass("fr-active").attr("aria-pressed", !0)
      },
      upload: Ne,
      insertByURL: function gt() {
        for (var e, t = A.popups.get("filesManager.insert").find(".fr-files-by-url-layer input"), n = t.val().trim().split(/[ ,]+/), r = [], a = 0, o = 0; o < n.length; o++) e = n[o], new RegExp("^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$", "i").test(e) && (r[a] = n[o], a++);
        if (0 != r.length) {
          if (0 < t.val().trim().length && 0 < r.length) {
            var s = [], l = [], c = h, d = r.length;
            r.forEach(function (e, n) {
              if (0 == e.trim().length) h == c + --d && Le(s, l); else {
                J(), Q(), ee(A.language.translate("Loading file(s)"));
                var r = e.trim(), t = function i(e) {
                  if (void 0 === e) return e;
                  var t = null;
                  if (/^http/.test(e) || (e = "https://".concat(e)), A.helpers.isURL(e)) for (var n = 0; n < xt.VIDEO_PROVIDERS.length; n++) {
                    var r = xt.VIDEO_PROVIDERS[n];
                    if (r.test_regex.test(e) && new RegExp(A.opts.videoAllowedProviders.join("|")).test(r.provider)) {
                      t = e.replace(r.url_regex, r.url_text), t = r.html.replace(/\{url\}/, t);
                      break
                    }
                  }
                  return t
                }(r);
                if (t) {
                  var a = {link: r, name: r, type: "video/url", size: 2, video: t};
                  k.set(c + n, a), me(c + n), J(), Q(), ee(A.language.translate("Loading file(s)")), x.set(c + n, a), ++h == c + d && Le(s, l)
                } else {
                  var o = new XMLHttpRequest;
                  o.onload = function () {
                    if (200 == this.status) {
                      var e = new Blob([this.response], {type: this.response.type || ""});
                      e.name = ze(r), e.link = r, Be(this.response.type) ? (e.sanitize = !0, e.existing_image = y) : He(this.response.type) && (e.text = ze(r)), s.push(e), l.push(c + n), k.set(c + n, e), me(c + n), (-1 < F.indexOf(ke(e)) || !ke(e)) && j(H, null, null, c + n)
                    } else {
                      var t = new Blob([this.response], {type: this.response.type || " "});
                      t.name = ze(r), t.link = r, k.set(c + n, t), me(c + n), j(N, this.response, y, c + n)
                    }
                    J(), Q(), ee(A.language.translate("Loading file(s)")), ++h == c + d && Le(s, l)
                  }, o.onerror = function () {
                    var e = {link: r, name: ze(r), size: 0, type: ""};
                    j(9, this.response, y, c + n);
                    var t = h;
                    k.set(t, e), me(t), J(), Q(), ee(A.language.translate("Loading file(s)")), ++h == c + d && Le(s, l)
                  }, o.open("GET", "".concat(A.opts.imageCORSProxy, "/").concat(r), !0), o.responseType = "blob", o.send()
                }
              }
            }), t.val(""), t.blur()
          }
        } else te(A.language.translate("Url entered is invalid. Please try again."))
      },
      insertAllFiles: function mt() {
        a = [];
        var e = A.popups.get("filesManager.insert");
        u = -1, f = null, e.find(".fr-insert-checkbox").toArray().forEach(function r(e, t, n) {
          e.children.target.checked && (a.push(parseInt(e.id.split("-").pop())), Be(x.get(parseInt(e.id.split("-").pop())).type) && -1 == u && (u = t))
        }), Te(a), q()
      },
      deleteAllFiles: function e() {
        A.popups.get("filesManager.insert").find(".fr-insert-checkbox").toArray().forEach(function a(e, t, n) {
          if (e.children.target.checked) {
            var r = parseInt(e.id.split("-").pop());
            _.has(r) && _["delete"](r), Z(r)
          }
        }), q()
      },
      get: lt,
      getEl: ct,
      insert: xe,
      showProgressBar: Q,
      remove: Ze,
      hideProgressBar: J,
      applyStyle: function vt(e, t, n) {
        if (void 0 === t && (t = A.opts.imageStyles), void 0 === n && (n = A.opts.imageMultipleStyles), !y) return !1;
        var r = ct();
        if (!n) {
          var a = Object.keys(t);
          a.splice(a.indexOf(e), 1), r.removeClass(a.join(" "))
        }
        "object" == kt(t[e]) ? (r.removeAttr("style"), r.css(t[e].style)) : r.toggleClass(e), _e(y)
      },
      showAltPopup: Ve,
      showSizePopup: Ye,
      setAlt: function bt(e) {
        if (y) {
          var t = A.popups.get("image.alt");
          y.attr("alt", e || t.find("input").val() || ""), t.find("input:focus").blur(), _e(y)
        }
      },
      setSize: function Ct(e, t) {
        if (y) {
          var n = A.popups.get("image.size");
          e = e || n.find('input[name="width"]').val() || "", t = t || n.find('input[name="height"]').val() || "";
          var r = /^[\d]+((px)|%)*$/g;
          y.removeAttr("width").removeAttr("height"), e.match(r) ? y.css("width", e) : y.css("width", ""), t.match(r) ? y.css("height", t) : y.css("height", ""), dt() && (y.parents(".fr-img-caption").removeAttr("width").removeAttr("height"), e.match(r) ? y.parents(".fr-img-caption").css("width", e) : y.parents(".fr-img-caption").css("width", ""), t.match(r) ? y.parents(".fr-img-caption").css("height", t) : y.parents(".fr-img-caption").css("height", "")), n && n.find("input:focus").blur(), _e(y)
        }
      },
      toggleCaption: function Et() {
        var e;
        if (y && !dt()) {
          (e = y).parent().is("a") && (e = y.parent());
          var t, n,
            r = y.parents("ul") && 0 < y.parents("ul").length ? y.parents("ul") : y.parents("ol") && 0 < y.parents("ol").length ? y.parents("ol") : [];
          if (0 < r.length) {
            var a = r.find("li").length, o = y.parents("li"), i = document.createElement("li");
            a - 1 === o.index() && (r.append(i), i.innerHTML = "&nbsp;")
          }
          e.attr("style") && (n = -1 < (t = e.attr("style").split(":")).indexOf("width") ? t[t.indexOf("width") + 1].replace(";", "") : "");
          var s = A.opts.imageResizeWithPercent ? (-1 < n.indexOf("px") ? null : n) || "100%" : y.width() + "px";
          e.wrap('<div class="fr-img-space-wrap"><span ' + (A.browser.mozilla ? "" : 'contenteditable="false"') + 'class="fr-img-caption ' + y.attr("class") + '" style="' + (A.opts.useClasses ? "" : e.attr("style")) + '" draggable="false"></span><p class="fr-img-space-wrap2">&nbsp;</p></div>'), e.wrap('<span class="fr-img-wrap"></span>'), y.after('<span class="fr-inner"'.concat(A.browser.mozilla ? "" : ' contenteditable="true"', ">").concat(xt.START_MARKER).concat(A.language.translate("Image Caption")).concat(xt.END_MARKER, "</span>")), y.removeAttr("class").removeAttr("style").removeAttr("width"), y.parents(".fr-img-caption").css("width", s), rt(!0), A.selection.restore()
        } else e = ct(), y.insertAfter(e), y.attr("class", e.attr("class").replace("fr-img-caption", "")).attr("style", e.attr("style")), e.remove(), _e(y)
      },
      refreshEmbedButton: function yt(e) {
        var t = A.popups.get("filesManager.insert");
        t && t.find(".fr-files-embed-layer").hasClass("fr-active") && e.addClass("fr-active").attr("aria-pressed", !0)
      },
      insertEmbed: function Lt(e) {
        void 0 === e && (e = A.popups.get("filesManager.insert").find(".fr-files-embed-layer textarea").val() || ""), 0 === e.length || !xt.VIDEO_EMBED_REGEX.test(e) && !xt.IMAGE_EMBED_REGEX.test(e) ? (te(A.language.translate("Something went wrong. Please try again.")), xt.VIDEO_EMBED_REGEX.test(e) && A.events.trigger("video.codeError", [e])) : Re(e)
      },
      hasCaption: dt,
      exitEdit: rt,
      edit: _e,
      cancelFileInsert: function _t() {
        this.file_manager_dialog_open = !1, _.forEach(function (e, t) {
          4 != e.readyState && (e.abort(), Z(t))
        });
        var e = A.popups.get("filesManager.insert");
        e.find(".fr-progress-bar").removeClass("fr-display-block").addClass("fr-none"), e.find('.fr-command[data-cmd="filesUpload"]').removeClass("fr-disabled"), e.find('.fr-command[data-cmd="filesByURL"]').removeClass("fr-disabled"), e.find('.fr-command[data-cmd="filesEmbed"]').removeClass("fr-disabled"), o = 0, _ = new Map, w = new Map, X(), A.popups.hide("filesManager.insert")
      },
      minimizePopup: function wt(e) {
        this.file_manager_dialog_open = !1, A.popups.hide("filesManager.insert"), X()
      },
      editImage: Se,
      saveImage: function At(e) {
        var t = x.get(i);
        t.link = window.URL.createObjectURL(new Blob(e, {type: "image/png"})), x.set(i, t)
      },
      _showErrorMessage: te,
      _showFileErrorMessage: ne,
      getFileThumbnail: be,
      deleteFile: Z,
      checkAutoplay: De,
      checkInsertAllState: q,
      _disableInsertCheckbox: Y,
      _getFileType: ke,
      isChildWindowOpen: function Tt() {
        return p
      },
      setChildWindowState: function St(e) {
        e !== undefined && (p = e)
      },
      resetAllFilesCheckbox: X
    }
  }, xt.DefineIcon("insertFiles", {
    NAME: "image",
    SVG_KEY: "fileManager"
  }), xt.RegisterShortcut(xt.KEYCODE.P, "insertFiles", null, "P"), xt.RegisterCommand("insertFiles", {
    title: "Insert Files",
    undo: !1,
    focus: !0,
    refreshAfterCallback: !1,
    popup: !0,
    callback: function () {
      this.popups.isVisible("filesManager.insert") ? (this.$el.find(".fr-marker").length && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("filesManager.insert")) : this.filesManager.showInsertPopup()
    },
    plugin: "filesManager"
  }), xt.DefineIcon("cloudIcon", {
    NAME: "cloudIcon",
    SVG_KEY: "uploadFiles"
  }), xt.DefineIcon("filesUpload", {
    NAME: "uploadFiles",
    SVG_KEY: "uploadFiles"
  }), xt.RegisterCommand("filesUpload", {
    title: "Upload Files", undo: !1, focus: !1, toggle: !0, callback: function () {
      this.filesManager.showLayer("files-upload")
    }, refresh: function (e) {
      this.filesManager.refreshUploadButton(e)
    }
  }), xt.DefineIcon("filesByURL", {
    NAME: "link",
    SVG_KEY: "insertLink"
  }), xt.RegisterCommand("filesByURL", {
    title: "By URL", undo: !1, focus: !1, toggle: !0, callback: function () {
      this.filesManager.showLayer("files-by-url")
    }, refresh: function (e) {
      this.filesManager.refreshByURLButton(e)
    }
  }), xt.DefineIcon("filesEmbed", {
    NAME: "code",
    SVG_KEY: "codeView"
  }), xt.RegisterCommand("filesEmbed", {
    title: "Embedded Code", undo: !1, focus: !1, toggle: !0, callback: function () {
      this.filesManager.showLayer("files-embed")
    }, refresh: function (e) {
      this.filesManager.refreshEmbedButton(e)
    }
  }), xt.DefineIcon("insertAll", {
    NAME: "insertAll",
    SVG_KEY: "fileInsert"
  }), xt.RegisterCommand("insertAll", {
    title: "Insert",
    undo: !1,
    focus: !1,
    toggle: !0,
    disabled: !0,
    callback: function () {
      this.filesManager.insertAllFiles()
    }
  }), xt.DefineIcon("deleteAll", {NAME: "remove", SVG_KEY: "remove"}), xt.RegisterCommand("deleteAll", {
    title: "Delete",
    undo: !1,
    focus: !1,
    toggle: !0,
    disabled: !0,
    callback: function () {
      this.filesManager.deleteAllFiles()
    }
  }), xt.DefineIcon("cancel", {NAME: "cancel", SVG_KEY: "cancel"}), xt.RegisterCommand("cancel", {
    title: "Cancel",
    undo: !1,
    focus: !1,
    toggle: !0,
    callback: function () {
      this.filesManager.cancelFileInsert()
    },
    refresh: function (e) {
    }
  }), xt.DefineIcon("minimize", {
    NAME: "minimize",
    SVG_KEY: "minimize"
  }), xt.RegisterCommand("minimize", {
    title: "Minimize", undo: !1, focus: !1, toggle: !0, callback: function () {
      this.filesManager.minimizePopup("image.insert", !0)
    }, refresh: function (e) {
      this.filesManager.refreshEmbedButton(e)
    }
  }), xt.RegisterCommand("filesInsertByURL", {
    title: "Insert Image",
    undo: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.filesManager.insertByURL()
    },
    refresh: function (e) {
      e.text(this.language.translate("Add"))
    }
  }), xt.RegisterCommand("imageInsertByUpload", {
    title: "Insert",
    undo: !0,
    refreshAfterCallback: !1,
    callback: function (e, t) {
    },
    refresh: function (e) {
    }
  }), xt.RegisterCommand("viewImage", {
    title: "View Image",
    undo: !0,
    refreshAfterCallback: !1,
    callback: function (e, t) {
    },
    refresh: function (e) {
    }
  }), xt.RegisterCommand("insertEmbed", {
    undo: !0, focus: !0, callback: function () {
      this.filesManager.insertEmbed(), this.popups.get("filesManager.insert").find("textarea")[0].value = "", this.popups.get("filesManager.insert").find("textarea").removeClass("fr-not-empty")
    }
  }), xt.RegisterCommand("filesDismissError", {
    title: "OK", undo: !1, callback: function () {
      this.filesManager.hideProgressBar(!0)
    }
  }), xt.PLUGINS.cryptoJSPlugin = function (e) {
    var t, d, n, r, a, o, i, f, s, l, c, p, u, h, g, v, m, b, C, E, y, L, _, w, A, T, S, k, x, R, M, O, N, I, D, B, H,
      $, F, P, U, z, K, V, W, G, Y, j, q, Z, X, Q, J, ee, te, ne, re, ae, oe, ie, se, le, ce, de, fe, pe, ue, he, ge,
      me, ve = ve || function (d, e) {
        var t;
        if ("undefined" != typeof window && window.crypto && (t = window.crypto), !t && "undefined" != typeof window && window.msCrypto && (t = window.msCrypto), !t && "undefined" != typeof global && global.crypto && (t = global.crypto), !t && "function" == typeof require) try {
          t = require("crypto")
        } catch (g) {
        }
        var r = function r() {
          if (t) {
            if ("function" == typeof t.getRandomValues) try {
              return t.getRandomValues(new Uint32Array(1))[0]
            } catch (g) {
            }
            if ("function" == typeof t.randomBytes) try {
              return t.randomBytes(4).readInt32LE()
            } catch (g) {
            }
          }
          throw new Error("Native crypto module could not be used to get secure random number.")
        }, n = Object.create || function () {
          function n() {
          }

          return function (e) {
            var t;
            return n.prototype = e, t = new n, n.prototype = null, t
          }
        }(), a = {}, o = a.lib = {}, i = o.Base = {
          extend: function (e) {
            var t = n(this);
            return e && t.mixIn(e), t.hasOwnProperty("init") && this.init !== t.init || (t.init = function () {
              t.$super.init.apply(this, arguments)
            }), (t.init.prototype = t).$super = this, t
          }, create: function () {
            var e = this.extend();
            return e.init.apply(e, arguments), e
          }, init: function () {
          }, mixIn: function (e) {
            for (var t in e) e.hasOwnProperty(t) && (this[t] = e[t]);
            e.hasOwnProperty("toString") && (this.toString = e.toString)
          }, clone: function () {
            return this.init.prototype.extend(this)
          }
        }, f = o.WordArray = i.extend({
          init: function (e, t) {
            e = this.words = e || [], this.sigBytes = null != t ? t : 4 * e.length
          }, toString: function (e) {
            return (e || l).stringify(this)
          }, concat: function (e) {
            var t = this.words, n = e.words, r = this.sigBytes, a = e.sigBytes;
            if (this.clamp(), r % 4) for (var o = 0; o < a; o++) {
              var i = n[o >>> 2] >>> 24 - o % 4 * 8 & 255;
              t[r + o >>> 2] |= i << 24 - (r + o) % 4 * 8
            } else for (o = 0; o < a; o += 4) t[r + o >>> 2] = n[o >>> 2];
            return this.sigBytes += a, this
          }, clamp: function () {
            var e = this.words, t = this.sigBytes;
            e[t >>> 2] &= 4294967295 << 32 - t % 4 * 8, e.length = d.ceil(t / 4)
          }, clone: function e() {
            var e = i.clone.call(this);
            return e.words = this.words.slice(0), e
          }, random: function (e) {
            for (var t = [], n = 0; n < e; n += 4) t.push(r());
            return new f.init(t, e)
          }
        }), s = a.enc = {}, l = s.Hex = {
          stringify: function (e) {
            for (var t = e.words, n = e.sigBytes, r = [], a = 0; a < n; a++) {
              var o = t[a >>> 2] >>> 24 - a % 4 * 8 & 255;
              r.push((o >>> 4).toString(16)), r.push((15 & o).toString(16))
            }
            return r.join("")
          }, parse: function (e) {
            for (var t = e.length, n = [], r = 0; r < t; r += 2) n[r >>> 3] |= parseInt(e.substr(r, 2), 16) << 24 - r % 8 * 4;
            return new f.init(n, t / 2)
          }
        }, c = s.Latin1 = {
          stringify: function (e) {
            for (var t = e.words, n = e.sigBytes, r = [], a = 0; a < n; a++) {
              var o = t[a >>> 2] >>> 24 - a % 4 * 8 & 255;
              r.push(String.fromCharCode(o))
            }
            return r.join("")
          }, parse: function (e) {
            for (var t = e.length, n = [], r = 0; r < t; r++) n[r >>> 2] |= (255 & e.charCodeAt(r)) << 24 - r % 4 * 8;
            return new f.init(n, t)
          }
        }, p = s.Utf8 = {
          stringify: function (e) {
            try {
              return decodeURIComponent(escape(c.stringify(e)))
            } catch (t) {
              throw new Error("Malformed UTF-8 data")
            }
          }, parse: function (e) {
            return c.parse(unescape(encodeURIComponent(e)))
          }
        }, u = o.BufferedBlockAlgorithm = i.extend({
          reset: function () {
            this._data = new f.init, this._nDataBytes = 0
          }, _append: function (e) {
            "string" == typeof e && (e = p.parse(e)), this._data.concat(e), this._nDataBytes += e.sigBytes
          }, _process: function (e) {
            var t, n = this._data, r = n.words, a = n.sigBytes, o = this.blockSize, i = a / (4 * o),
              s = (i = e ? d.ceil(i) : d.max((0 | i) - this._minBufferSize, 0)) * o, l = d.min(4 * s, a);
            if (s) {
              for (var c = 0; c < s; c += o) this._doProcessBlock(r, c);
              t = r.splice(0, s), n.sigBytes -= l
            }
            return new f.init(t, l)
          }, clone: function e() {
            var e = i.clone.call(this);
            return e._data = this._data.clone(), e
          }, _minBufferSize: 0
        }), h = (o.Hasher = u.extend({
          cfg: i.extend(), init: function (e) {
            this.cfg = this.cfg.extend(e), this.reset()
          }, reset: function () {
            u.reset.call(this), this._doReset()
          }, update: function (e) {
            return this._append(e), this._process(), this
          }, finalize: function (e) {
            return e && this._append(e), this._doFinalize()
          }, blockSize: 16, _createHelper: function (n) {
            return function (e, t) {
              return new n.init(t).finalize(e)
            }
          }, _createHmacHelper: function (n) {
            return function (e, t) {
              return new h.HMAC.init(n, t).finalize(e)
            }
          }
        }), a.algo = {});
        return a
      }(Math);
    return d = (t = ve).lib.WordArray, t.enc.Base64 = {
      stringify: function (e) {
        var t = e.words, n = e.sigBytes, r = this._map;
        e.clamp();
        for (var a = [], o = 0; o < n; o += 3) for (var i = (t[o >>> 2] >>> 24 - o % 4 * 8 & 255) << 16 | (t[o + 1 >>> 2] >>> 24 - (o + 1) % 4 * 8 & 255) << 8 | t[o + 2 >>> 2] >>> 24 - (o + 2) % 4 * 8 & 255, s = 0; s < 4 && o + .75 * s < n; s++) a.push(r.charAt(i >>> 6 * (3 - s) & 63));
        var l = r.charAt(64);
        if (l) for (; a.length % 4;) a.push(l);
        return a.join("")
      }, parse: function (e) {
        var t = e.length, n = this._map, r = this._reverseMap;
        if (!r) {
          r = this._reverseMap = [];
          for (var a = 0; a < n.length; a++) r[n.charCodeAt(a)] = a
        }
        var o = n.charAt(64);
        if (o) {
          var i = e.indexOf(o);
          -1 !== i && (t = i)
        }
        return function c(e, t, n) {
          for (var r = [], a = 0, o = 0; o < t; o++) if (o % 4) {
            var i = n[e.charCodeAt(o - 1)] << o % 4 * 2, s = n[e.charCodeAt(o)] >>> 6 - o % 4 * 2, l = i | s;
            r[a >>> 2] |= l << 24 - a % 4 * 8, a++
          }
          return d.create(r, a)
        }(e, t, r)
      }, _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
    }, function (d) {
      var e = ve, t = e.lib, n = t.WordArray, r = t.Hasher, a = e.algo, T = [];
      !function () {
        for (var e = 0; e < 64; e++) T[e] = 4294967296 * d.abs(d.sin(e + 1)) | 0
      }();
      var o = a.MD5 = r.extend({
        _doReset: function () {
          this._hash = new n.init([1732584193, 4023233417, 2562383102, 271733878])
        }, _doProcessBlock: function (e, t) {
          for (var n = 0; n < 16; n++) {
            var r = t + n, a = e[r];
            e[r] = 16711935 & (a << 8 | a >>> 24) | 4278255360 & (a << 24 | a >>> 8)
          }
          var o = this._hash.words, i = e[t + 0], s = e[t + 1], l = e[t + 2], c = e[t + 3], d = e[t + 4], f = e[t + 5],
            p = e[t + 6], u = e[t + 7], h = e[t + 8], g = e[t + 9], m = e[t + 10], v = e[t + 11], b = e[t + 12],
            C = e[t + 13], E = e[t + 14], y = e[t + 15], L = o[0], _ = o[1], w = o[2], A = o[3];
          _ = R(_ = R(_ = R(_ = R(_ = x(_ = x(_ = x(_ = x(_ = k(_ = k(_ = k(_ = k(_ = S(_ = S(_ = S(_ = S(_, w = S(w, A = S(A, L = S(L, _, w, A, i, 7, T[0]), _, w, s, 12, T[1]), L, _, l, 17, T[2]), A, L, c, 22, T[3]), w = S(w, A = S(A, L = S(L, _, w, A, d, 7, T[4]), _, w, f, 12, T[5]), L, _, p, 17, T[6]), A, L, u, 22, T[7]), w = S(w, A = S(A, L = S(L, _, w, A, h, 7, T[8]), _, w, g, 12, T[9]), L, _, m, 17, T[10]), A, L, v, 22, T[11]), w = S(w, A = S(A, L = S(L, _, w, A, b, 7, T[12]), _, w, C, 12, T[13]), L, _, E, 17, T[14]), A, L, y, 22, T[15]), w = k(w, A = k(A, L = k(L, _, w, A, s, 5, T[16]), _, w, p, 9, T[17]), L, _, v, 14, T[18]), A, L, i, 20, T[19]), w = k(w, A = k(A, L = k(L, _, w, A, f, 5, T[20]), _, w, m, 9, T[21]), L, _, y, 14, T[22]), A, L, d, 20, T[23]), w = k(w, A = k(A, L = k(L, _, w, A, g, 5, T[24]), _, w, E, 9, T[25]), L, _, c, 14, T[26]), A, L, h, 20, T[27]), w = k(w, A = k(A, L = k(L, _, w, A, C, 5, T[28]), _, w, l, 9, T[29]), L, _, u, 14, T[30]), A, L, b, 20, T[31]), w = x(w, A = x(A, L = x(L, _, w, A, f, 4, T[32]), _, w, h, 11, T[33]), L, _, v, 16, T[34]), A, L, E, 23, T[35]), w = x(w, A = x(A, L = x(L, _, w, A, s, 4, T[36]), _, w, d, 11, T[37]), L, _, u, 16, T[38]), A, L, m, 23, T[39]), w = x(w, A = x(A, L = x(L, _, w, A, C, 4, T[40]), _, w, i, 11, T[41]), L, _, c, 16, T[42]), A, L, p, 23, T[43]), w = x(w, A = x(A, L = x(L, _, w, A, g, 4, T[44]), _, w, b, 11, T[45]), L, _, y, 16, T[46]), A, L, l, 23, T[47]), w = R(w, A = R(A, L = R(L, _, w, A, i, 6, T[48]), _, w, u, 10, T[49]), L, _, E, 15, T[50]), A, L, f, 21, T[51]), w = R(w, A = R(A, L = R(L, _, w, A, b, 6, T[52]), _, w, c, 10, T[53]), L, _, m, 15, T[54]), A, L, s, 21, T[55]), w = R(w, A = R(A, L = R(L, _, w, A, h, 6, T[56]), _, w, y, 10, T[57]), L, _, p, 15, T[58]), A, L, C, 21, T[59]), w = R(w, A = R(A, L = R(L, _, w, A, d, 6, T[60]), _, w, v, 10, T[61]), L, _, l, 15, T[62]), A, L, g, 21, T[63]), o[0] = o[0] + L | 0, o[1] = o[1] + _ | 0, o[2] = o[2] + w | 0, o[3] = o[3] + A | 0
        }, _doFinalize: function () {
          var e = this._data, t = e.words, n = 8 * this._nDataBytes, r = 8 * e.sigBytes;
          t[r >>> 5] |= 128 << 24 - r % 32;
          var a = d.floor(n / 4294967296), o = n;
          t[15 + (r + 64 >>> 9 << 4)] = 16711935 & (a << 8 | a >>> 24) | 4278255360 & (a << 24 | a >>> 8), t[14 + (r + 64 >>> 9 << 4)] = 16711935 & (o << 8 | o >>> 24) | 4278255360 & (o << 24 | o >>> 8), e.sigBytes = 4 * (t.length + 1), this._process();
          for (var i = this._hash, s = i.words, l = 0; l < 4; l++) {
            var c = s[l];
            s[l] = 16711935 & (c << 8 | c >>> 24) | 4278255360 & (c << 24 | c >>> 8)
          }
          return i
        }, clone: function e() {
          var e = r.clone.call(this);
          return e._hash = this._hash.clone(), e
        }
      });

      function S(e, t, n, r, a, o, i) {
        var s = e + (t & n | ~t & r) + a + i;
        return (s << o | s >>> 32 - o) + t
      }

      function k(e, t, n, r, a, o, i) {
        var s = e + (t & r | n & ~r) + a + i;
        return (s << o | s >>> 32 - o) + t
      }

      function x(e, t, n, r, a, o, i) {
        var s = e + (t ^ n ^ r) + a + i;
        return (s << o | s >>> 32 - o) + t
      }

      function R(e, t, n, r, a, o, i) {
        var s = e + (n ^ (t | ~r)) + a + i;
        return (s << o | s >>> 32 - o) + t
      }

      e.MD5 = r._createHelper(o), e.HmacMD5 = r._createHmacHelper(o)
    }(Math), r = (n = ve).lib, a = r.WordArray, o = r.Hasher, i = n.algo, f = [], s = i.SHA1 = o.extend({
      _doReset: function () {
        this._hash = new a.init([1732584193, 4023233417, 2562383102, 271733878, 3285377520])
      }, _doProcessBlock: function (e, t) {
        for (var n = this._hash.words, r = n[0], a = n[1], o = n[2], i = n[3], s = n[4], l = 0; l < 80; l++) {
          if (l < 16) f[l] = 0 | e[t + l]; else {
            var c = f[l - 3] ^ f[l - 8] ^ f[l - 14] ^ f[l - 16];
            f[l] = c << 1 | c >>> 31
          }
          var d = (r << 5 | r >>> 27) + s + f[l];
          d += l < 20 ? 1518500249 + (a & o | ~a & i) : l < 40 ? 1859775393 + (a ^ o ^ i) : l < 60 ? (a & o | a & i | o & i) - 1894007588 : (a ^ o ^ i) - 899497514, s = i, i = o, o = a << 30 | a >>> 2, a = r, r = d
        }
        n[0] = n[0] + r | 0, n[1] = n[1] + a | 0, n[2] = n[2] + o | 0, n[3] = n[3] + i | 0, n[4] = n[4] + s | 0
      }, _doFinalize: function () {
        var e = this._data, t = e.words, n = 8 * this._nDataBytes, r = 8 * e.sigBytes;
        return t[r >>> 5] |= 128 << 24 - r % 32, t[14 + (r + 64 >>> 9 << 4)] = Math.floor(n / 4294967296), t[15 + (r + 64 >>> 9 << 4)] = n, e.sigBytes = 4 * t.length, this._process(), this._hash
      }, clone: function e() {
        var e = o.clone.call(this);
        return e._hash = this._hash.clone(), e
      }
    }), n.SHA1 = o._createHelper(s), n.HmacSHA1 = o._createHmacHelper(s), function (a) {
      var e = ve, t = e.lib, n = t.WordArray, r = t.Hasher, o = e.algo, i = [], C = [];
      !function () {
        function e(e) {
          for (var t = a.sqrt(e), n = 2; n <= t; n++) if (!(e % n)) return !1;
          return !0
        }

        function t(e) {
          return 4294967296 * (e - (0 | e)) | 0
        }

        for (var n = 2, r = 0; r < 64;) e(n) && (r < 8 && (i[r] = t(a.pow(n, .5))), C[r] = t(a.pow(n, 1 / 3)), r++), n++
      }();
      var E = [], s = o.SHA256 = r.extend({
        _doReset: function () {
          this._hash = new n.init(i.slice(0))
        }, _doProcessBlock: function (e, t) {
          for (var n = this._hash.words, r = n[0], a = n[1], o = n[2], i = n[3], s = n[4], l = n[5], c = n[6], d = n[7], f = 0; f < 64; f++) {
            if (f < 16) E[f] = 0 | e[t + f]; else {
              var p = E[f - 15], u = (p << 25 | p >>> 7) ^ (p << 14 | p >>> 18) ^ p >>> 3, h = E[f - 2],
                g = (h << 15 | h >>> 17) ^ (h << 13 | h >>> 19) ^ h >>> 10;
              E[f] = u + E[f - 7] + g + E[f - 16]
            }
            var m = r & a ^ r & o ^ a & o, v = (r << 30 | r >>> 2) ^ (r << 19 | r >>> 13) ^ (r << 10 | r >>> 22),
              b = d + ((s << 26 | s >>> 6) ^ (s << 21 | s >>> 11) ^ (s << 7 | s >>> 25)) + (s & l ^ ~s & c) + C[f] + E[f];
            d = c, c = l, l = s, s = i + b | 0, i = o, o = a, a = r, r = b + (v + m) | 0
          }
          n[0] = n[0] + r | 0, n[1] = n[1] + a | 0, n[2] = n[2] + o | 0, n[3] = n[3] + i | 0, n[4] = n[4] + s | 0, n[5] = n[5] + l | 0, n[6] = n[6] + c | 0, n[7] = n[7] + d | 0
        }, _doFinalize: function () {
          var e = this._data, t = e.words, n = 8 * this._nDataBytes, r = 8 * e.sigBytes;
          return t[r >>> 5] |= 128 << 24 - r % 32, t[14 + (r + 64 >>> 9 << 4)] = a.floor(n / 4294967296), t[15 + (r + 64 >>> 9 << 4)] = n, e.sigBytes = 4 * t.length, this._process(), this._hash
        }, clone: function e() {
          var e = r.clone.call(this);
          return e._hash = this._hash.clone(), e
        }
      });
      e.SHA256 = r._createHelper(s), e.HmacSHA256 = r._createHmacHelper(s)
    }(Math), function () {
      var e = ve, a = e.lib.WordArray, t = e.enc;
      t.Utf16 = t.Utf16BE = {
        stringify: function (e) {
          for (var t = e.words, n = e.sigBytes, r = [], a = 0; a < n; a += 2) {
            var o = t[a >>> 2] >>> 16 - a % 4 * 8 & 65535;
            r.push(String.fromCharCode(o))
          }
          return r.join("")
        }, parse: function (e) {
          for (var t = e.length, n = [], r = 0; r < t; r++) n[r >>> 1] |= e.charCodeAt(r) << 16 - r % 2 * 16;
          return a.create(n, 2 * t)
        }
      };

      function i(e) {
        return e << 8 & 4278255360 | e >>> 8 & 16711935
      }

      t.Utf16LE = {
        stringify: function (e) {
          for (var t = e.words, n = e.sigBytes, r = [], a = 0; a < n; a += 2) {
            var o = i(t[a >>> 2] >>> 16 - a % 4 * 8 & 65535);
            r.push(String.fromCharCode(o))
          }
          return r.join("")
        }, parse: function (e) {
          for (var t = e.length, n = [], r = 0; r < t; r++) n[r >>> 1] |= i(e.charCodeAt(r) << 16 - r % 2 * 16);
          return a.create(n, 2 * t)
        }
      }
    }(), function () {
      if ("function" == typeof ArrayBuffer) {
        var e = ve.lib.WordArray, a = e.init;
        (e.init = function (e) {
          if (e instanceof ArrayBuffer && (e = new Uint8Array(e)), (e instanceof Int8Array || "undefined" != typeof Uint8ClampedArray && e instanceof Uint8ClampedArray || e instanceof Int16Array || e instanceof Uint16Array || e instanceof Int32Array || e instanceof Uint32Array || e instanceof Float32Array || e instanceof Float64Array) && (e = new Uint8Array(e.buffer, e.byteOffset, e.byteLength)), e instanceof Uint8Array) {
            for (var t = e.byteLength, n = [], r = 0; r < t; r++) n[r >>> 2] |= e[r] << 24 - r % 4 * 8;
            a.call(this, n, t)
          } else a.apply(this, arguments)
        }).prototype = e
      }
    }(), function (e) {
      var t = ve, n = t.lib, r = n.WordArray, a = n.Hasher, o = t.algo,
        _ = r.create([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13]),
        w = r.create([5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11]),
        A = r.create([11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6]),
        T = r.create([8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11]),
        S = r.create([0, 1518500249, 1859775393, 2400959708, 2840853838]),
        k = r.create([1352829926, 1548603684, 1836072691, 2053994217, 0]), i = o.RIPEMD160 = a.extend({
          _doReset: function () {
            this._hash = r.create([1732584193, 4023233417, 2562383102, 271733878, 3285377520])
          }, _doProcessBlock: function (e, t) {
            for (var n = 0; n < 16; n++) {
              var r = t + n, a = e[r];
              e[r] = 16711935 & (a << 8 | a >>> 24) | 4278255360 & (a << 24 | a >>> 8)
            }
            var o, i, s, l, c, d, f, p, u, h, g, m = this._hash.words, v = S.words, b = k.words, C = _.words, E = w.words,
              y = A.words, L = T.words;
            d = o = m[0], f = i = m[1], p = s = m[2], u = l = m[3], h = c = m[4];
            for (n = 0; n < 80; n += 1) g = o + e[t + C[n]] | 0, g += n < 16 ? x(i, s, l) + v[0] : n < 32 ? R(i, s, l) + v[1] : n < 48 ? M(i, s, l) + v[2] : n < 64 ? O(i, s, l) + v[3] : N(i, s, l) + v[4], g = (g = I(g |= 0, y[n])) + c | 0, o = c, c = l, l = I(s, 10), s = i, i = g, g = d + e[t + E[n]] | 0, g += n < 16 ? N(f, p, u) + b[0] : n < 32 ? O(f, p, u) + b[1] : n < 48 ? M(f, p, u) + b[2] : n < 64 ? R(f, p, u) + b[3] : x(f, p, u) + b[4], g = (g = I(g |= 0, L[n])) + h | 0, d = h, h = u, u = I(p, 10), p = f, f = g;
            g = m[1] + s + u | 0, m[1] = m[2] + l + h | 0, m[2] = m[3] + c + d | 0, m[3] = m[4] + o + f | 0, m[4] = m[0] + i + p | 0, m[0] = g
          }, _doFinalize: function () {
            var e = this._data, t = e.words, n = 8 * this._nDataBytes, r = 8 * e.sigBytes;
            t[r >>> 5] |= 128 << 24 - r % 32, t[14 + (r + 64 >>> 9 << 4)] = 16711935 & (n << 8 | n >>> 24) | 4278255360 & (n << 24 | n >>> 8), e.sigBytes = 4 * (t.length + 1), this._process();
            for (var a = this._hash, o = a.words, i = 0; i < 5; i++) {
              var s = o[i];
              o[i] = 16711935 & (s << 8 | s >>> 24) | 4278255360 & (s << 24 | s >>> 8)
            }
            return a
          }, clone: function e() {
            var e = a.clone.call(this);
            return e._hash = this._hash.clone(), e
          }
        });

      function x(e, t, n) {
        return e ^ t ^ n
      }

      function R(e, t, n) {
        return e & t | ~e & n
      }

      function M(e, t, n) {
        return (e | ~t) ^ n
      }

      function O(e, t, n) {
        return e & n | t & ~n
      }

      function N(e, t, n) {
        return e ^ (t | ~n)
      }

      function I(e, t) {
        return e << t | e >>> 32 - t
      }

      t.RIPEMD160 = a._createHelper(i), t.HmacRIPEMD160 = a._createHmacHelper(i)
    }(Math), c = (l = ve).lib.Base, p = l.enc.Utf8, l.algo.HMAC = c.extend({
      init: function (e, t) {
        e = this._hasher = new e.init, "string" == typeof t && (t = p.parse(t));
        var n = e.blockSize, r = 4 * n;
        t.sigBytes > r && (t = e.finalize(t)), t.clamp();
        for (var a = this._oKey = t.clone(), o = this._iKey = t.clone(), i = a.words, s = o.words, l = 0; l < n; l++) i[l] ^= 1549556828, s[l] ^= 909522486;
        a.sigBytes = o.sigBytes = r, this.reset()
      }, reset: function () {
        var e = this._hasher;
        e.reset(), e.update(this._iKey)
      }, update: function (e) {
        return this._hasher.update(e), this
      }, finalize: function (e) {
        var t = this._hasher, n = t.finalize(e);
        return t.reset(), t.finalize(this._oKey.clone().concat(n))
      }
    }), h = (u = ve).lib, g = h.Base, v = h.WordArray, m = u.algo, b = m.SHA1, C = m.HMAC, E = m.PBKDF2 = g.extend({
      cfg: g.extend({
        keySize: 4,
        hasher: b,
        iterations: 1
      }), init: function (e) {
        this.cfg = this.cfg.extend(e)
      }, compute: function (e, t) {
        for (var n = this.cfg, r = C.create(n.hasher, e), a = v.create(), o = v.create([1]), i = a.words, s = o.words, l = n.keySize, c = n.iterations; i.length < l;) {
          var d = r.update(t).finalize(o);
          r.reset();
          for (var f = d.words, p = f.length, u = d, h = 1; h < c; h++) {
            u = r.finalize(u), r.reset();
            for (var g = u.words, m = 0; m < p; m++) f[m] ^= g[m]
          }
          a.concat(d), s[0]++
        }
        return a.sigBytes = 4 * l, a
      }
    }), u.PBKDF2 = function (e, t, n) {
      return E.create(n).compute(e, t)
    }, L = (y = ve).lib, _ = L.Base, w = L.WordArray, A = y.algo, T = A.MD5, S = A.EvpKDF = _.extend({
      cfg: _.extend({
        keySize: 4,
        hasher: T,
        iterations: 1
      }), init: function (e) {
        this.cfg = this.cfg.extend(e)
      }, compute: function (e, t) {
        for (var n, r = this.cfg, a = r.hasher.create(), o = w.create(), i = o.words, s = r.keySize, l = r.iterations; i.length < s;) {
          n && a.update(n), n = a.update(e).finalize(t), a.reset();
          for (var c = 1; c < l; c++) n = a.finalize(n), a.reset();
          o.concat(n)
        }
        return o.sigBytes = 4 * s, o
      }
    }), y.EvpKDF = function (e, t, n) {
      return S.create(n).compute(e, t)
    }, x = (k = ve).lib.WordArray, R = k.algo, M = R.SHA256, O = R.SHA224 = M.extend({
      _doReset: function () {
        this._hash = new x.init([3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428])
      }, _doFinalize: function () {
        var e = M._doFinalize.call(this);
        return e.sigBytes -= 4, e
      }
    }), k.SHA224 = M._createHelper(O), k.HmacSHA224 = M._createHmacHelper(O), I = (N = ve).lib, D = I.Base, B = I.WordArray, (H = N.x64 = {}).Word = D.extend({
      init: function (e, t) {
        this.high = e, this.low = t
      }
    }), H.WordArray = D.extend({
      init: function (e, t) {
        e = this.words = e || [], this.sigBytes = null != t ? t : 8 * e.length
      }, toX32: function () {
        for (var e = this.words, t = e.length, n = [], r = 0; r < t; r++) {
          var a = e[r];
          n.push(a.high), n.push(a.low)
        }
        return B.create(n, this.sigBytes)
      }, clone: function e() {
        for (var e = D.clone.call(this), t = e.words = this.words.slice(0), n = t.length, r = 0; r < n; r++) t[r] = t[r].clone();
        return e
      }
    }), function (p) {
      var e = ve, t = e.lib, u = t.WordArray, r = t.Hasher, d = e.x64.Word, n = e.algo, x = [], R = [], M = [];
      !function () {
        for (var e = 1, t = 0, n = 0; n < 24; n++) {
          x[e + 5 * t] = (n + 1) * (n + 2) / 2 % 64;
          var r = (2 * e + 3 * t) % 5;
          e = t % 5, t = r
        }
        for (e = 0; e < 5; e++) for (t = 0; t < 5; t++) R[e + 5 * t] = t + (2 * e + 3 * t) % 5 * 5;
        for (var a = 1, o = 0; o < 24; o++) {
          for (var i = 0, s = 0, l = 0; l < 7; l++) {
            if (1 & a) {
              var c = (1 << l) - 1;
              c < 32 ? s ^= 1 << c : i ^= 1 << c - 32
            }
            128 & a ? a = a << 1 ^ 113 : a <<= 1
          }
          M[o] = d.create(i, s)
        }
      }();
      var O = [];
      !function () {
        for (var e = 0; e < 25; e++) O[e] = d.create()
      }();
      var a = n.SHA3 = r.extend({
        cfg: r.cfg.extend({outputLength: 512}), _doReset: function () {
          for (var e = this._state = [], t = 0; t < 25; t++) e[t] = new d.init;
          this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32
        }, _doProcessBlock: function (e, t) {
          for (var n = this._state, r = this.blockSize / 2, a = 0; a < r; a++) {
            var o = e[t + 2 * a], i = e[t + 2 * a + 1];
            o = 16711935 & (o << 8 | o >>> 24) | 4278255360 & (o << 24 | o >>> 8), i = 16711935 & (i << 8 | i >>> 24) | 4278255360 & (i << 24 | i >>> 8), (w = n[a]).high ^= i, w.low ^= o
          }
          for (var s = 0; s < 24; s++) {
            for (var l = 0; l < 5; l++) {
              for (var c = 0, d = 0, f = 0; f < 5; f++) {
                c ^= (w = n[l + 5 * f]).high, d ^= w.low
              }
              var p = O[l];
              p.high = c, p.low = d
            }
            for (l = 0; l < 5; l++) {
              var u = O[(l + 4) % 5], h = O[(l + 1) % 5], g = h.high, m = h.low;
              for (c = u.high ^ (g << 1 | m >>> 31), d = u.low ^ (m << 1 | g >>> 31), f = 0; f < 5; f++) {
                (w = n[l + 5 * f]).high ^= c, w.low ^= d
              }
            }
            for (var v = 1; v < 25; v++) {
              var b = (w = n[v]).high, C = w.low, E = x[v];
              d = E < 32 ? (c = b << E | C >>> 32 - E, C << E | b >>> 32 - E) : (c = C << E - 32 | b >>> 64 - E, b << E - 32 | C >>> 64 - E);
              var y = O[R[v]];
              y.high = c, y.low = d
            }
            var L = O[0], _ = n[0];
            L.high = _.high, L.low = _.low;
            for (l = 0; l < 5; l++) for (f = 0; f < 5; f++) {
              var w = n[v = l + 5 * f], A = O[v], T = O[(l + 1) % 5 + 5 * f], S = O[(l + 2) % 5 + 5 * f];
              w.high = A.high ^ ~T.high & S.high, w.low = A.low ^ ~T.low & S.low
            }
            w = n[0];
            var k = M[s];
            w.high ^= k.high, w.low ^= k.low
          }
        }, _doFinalize: function () {
          var e = this._data, t = e.words, n = (this._nDataBytes, 8 * e.sigBytes), r = 32 * this.blockSize;
          t[n >>> 5] |= 1 << 24 - n % 32, t[(p.ceil((n + 1) / r) * r >>> 5) - 1] |= 128, e.sigBytes = 4 * t.length, this._process();
          for (var a = this._state, o = this.cfg.outputLength / 8, i = o / 8, s = [], l = 0; l < i; l++) {
            var c = a[l], d = c.high, f = c.low;
            d = 16711935 & (d << 8 | d >>> 24) | 4278255360 & (d << 24 | d >>> 8), f = 16711935 & (f << 8 | f >>> 24) | 4278255360 & (f << 24 | f >>> 8), s.push(f), s.push(d)
          }
          return new u.init(s, o)
        }, clone: function e() {
          for (var e = r.clone.call(this), t = e._state = this._state.slice(0), n = 0; n < 25; n++) t[n] = t[n].clone();
          return e
        }
      });
      e.SHA3 = r._createHelper(a), e.HmacSHA3 = r._createHmacHelper(a)
    }(Math), function () {
      var e = ve, t = e.lib.Hasher, n = e.x64, r = n.Word, a = n.WordArray, o = e.algo;

      function i() {
        return r.create.apply(r, arguments)
      }

      var _e = [i(1116352408, 3609767458), i(1899447441, 602891725), i(3049323471, 3964484399), i(3921009573, 2173295548), i(961987163, 4081628472), i(1508970993, 3053834265), i(2453635748, 2937671579), i(2870763221, 3664609560), i(3624381080, 2734883394), i(310598401, 1164996542), i(607225278, 1323610764), i(1426881987, 3590304994), i(1925078388, 4068182383), i(2162078206, 991336113), i(2614888103, 633803317), i(3248222580, 3479774868), i(3835390401, 2666613458), i(4022224774, 944711139), i(264347078, 2341262773), i(604807628, 2007800933), i(770255983, 1495990901), i(1249150122, 1856431235), i(1555081692, 3175218132), i(1996064986, 2198950837), i(2554220882, 3999719339), i(2821834349, 766784016), i(2952996808, 2566594879), i(3210313671, 3203337956), i(3336571891, 1034457026), i(3584528711, 2466948901), i(113926993, 3758326383), i(338241895, 168717936), i(666307205, 1188179964), i(773529912, 1546045734), i(1294757372, 1522805485), i(1396182291, 2643833823), i(1695183700, 2343527390), i(1986661051, 1014477480), i(2177026350, 1206759142), i(2456956037, 344077627), i(2730485921, 1290863460), i(2820302411, 3158454273), i(3259730800, 3505952657), i(3345764771, 106217008), i(3516065817, 3606008344), i(3600352804, 1432725776), i(4094571909, 1467031594), i(275423344, 851169720), i(430227734, 3100823752), i(506948616, 1363258195), i(659060556, 3750685593), i(883997877, 3785050280), i(958139571, 3318307427), i(1322822218, 3812723403), i(1537002063, 2003034995), i(1747873779, 3602036899), i(1955562222, 1575990012), i(2024104815, 1125592928), i(2227730452, 2716904306), i(2361852424, 442776044), i(2428436474, 593698344), i(2756734187, 3733110249), i(3204031479, 2999351573), i(3329325298, 3815920427), i(3391569614, 3928383900), i(3515267271, 566280711), i(3940187606, 3454069534), i(4118630271, 4000239992), i(116418474, 1914138554), i(174292421, 2731055270), i(289380356, 3203993006), i(460393269, 320620315), i(685471733, 587496836), i(852142971, 1086792851), i(1017036298, 365543100), i(1126000580, 2618297676), i(1288033470, 3409855158), i(1501505948, 4234509866), i(1607167915, 987167468), i(1816402316, 1246189591)],
        we = [];
      !function () {
        for (var e = 0; e < 80; e++) we[e] = i()
      }();
      var s = o.SHA512 = t.extend({
        _doReset: function () {
          this._hash = new a.init([new r.init(1779033703, 4089235720), new r.init(3144134277, 2227873595), new r.init(1013904242, 4271175723), new r.init(2773480762, 1595750129), new r.init(1359893119, 2917565137), new r.init(2600822924, 725511199), new r.init(528734635, 4215389547), new r.init(1541459225, 327033209)])
        }, _doProcessBlock: function (e, t) {
          for (var n = this._hash.words, r = n[0], a = n[1], o = n[2], i = n[3], s = n[4], l = n[5], c = n[6], d = n[7], f = r.high, p = r.low, u = a.high, h = a.low, g = o.high, m = o.low, v = i.high, b = i.low, C = s.high, E = s.low, y = l.high, L = l.low, _ = c.high, w = c.low, A = d.high, T = d.low, S = f, k = p, x = u, R = h, M = g, O = m, N = v, I = b, D = C, B = E, H = y, $ = L, F = _, P = w, U = A, z = T, K = 0; K < 80; K++) {
            var V, W, G = we[K];
            if (K < 16) W = G.high = 0 | e[t + 2 * K], V = G.low = 0 | e[t + 2 * K + 1]; else {
              var Y = we[K - 15], j = Y.high, q = Y.low, Z = (j >>> 1 | q << 31) ^ (j >>> 8 | q << 24) ^ j >>> 7,
                X = (q >>> 1 | j << 31) ^ (q >>> 8 | j << 24) ^ (q >>> 7 | j << 25), Q = we[K - 2], J = Q.high,
                ee = Q.low, te = (J >>> 19 | ee << 13) ^ (J << 3 | ee >>> 29) ^ J >>> 6,
                ne = (ee >>> 19 | J << 13) ^ (ee << 3 | J >>> 29) ^ (ee >>> 6 | J << 26), re = we[K - 7], ae = re.high,
                oe = re.low, ie = we[K - 16], se = ie.high, le = ie.low;
              W = (W = (W = Z + ae + ((V = X + oe) >>> 0 < X >>> 0 ? 1 : 0)) + te + ((V += ne) >>> 0 < ne >>> 0 ? 1 : 0)) + se + ((V += le) >>> 0 < le >>> 0 ? 1 : 0), G.high = W, G.low = V
            }
            var ce, de = D & H ^ ~D & F, fe = B & $ ^ ~B & P, pe = S & x ^ S & M ^ x & M, ue = k & R ^ k & O ^ R & O,
              he = (S >>> 28 | k << 4) ^ (S << 30 | k >>> 2) ^ (S << 25 | k >>> 7),
              ge = (k >>> 28 | S << 4) ^ (k << 30 | S >>> 2) ^ (k << 25 | S >>> 7),
              me = (D >>> 14 | B << 18) ^ (D >>> 18 | B << 14) ^ (D << 23 | B >>> 9),
              ve = (B >>> 14 | D << 18) ^ (B >>> 18 | D << 14) ^ (B << 23 | D >>> 9), be = _e[K], Ce = be.high,
              Ee = be.low, ye = U + me + ((ce = z + ve) >>> 0 < z >>> 0 ? 1 : 0), Le = ge + ue;
            U = F, z = P, F = H, P = $, H = D, $ = B, D = N + (ye = (ye = (ye = ye + de + ((ce = ce + fe) >>> 0 < fe >>> 0 ? 1 : 0)) + Ce + ((ce = ce + Ee) >>> 0 < Ee >>> 0 ? 1 : 0)) + W + ((ce = ce + V) >>> 0 < V >>> 0 ? 1 : 0)) + ((B = I + ce | 0) >>> 0 < I >>> 0 ? 1 : 0) | 0, N = M, I = O, M = x, O = R, x = S, R = k, S = ye + (he + pe + (Le >>> 0 < ge >>> 0 ? 1 : 0)) + ((k = ce + Le | 0) >>> 0 < ce >>> 0 ? 1 : 0) | 0
          }
          p = r.low = p + k, r.high = f + S + (p >>> 0 < k >>> 0 ? 1 : 0), h = a.low = h + R, a.high = u + x + (h >>> 0 < R >>> 0 ? 1 : 0), m = o.low = m + O, o.high = g + M + (m >>> 0 < O >>> 0 ? 1 : 0), b = i.low = b + I, i.high = v + N + (b >>> 0 < I >>> 0 ? 1 : 0), E = s.low = E + B, s.high = C + D + (E >>> 0 < B >>> 0 ? 1 : 0), L = l.low = L + $, l.high = y + H + (L >>> 0 < $ >>> 0 ? 1 : 0), w = c.low = w + P, c.high = _ + F + (w >>> 0 < P >>> 0 ? 1 : 0), T = d.low = T + z, d.high = A + U + (T >>> 0 < z >>> 0 ? 1 : 0)
        }, _doFinalize: function () {
          var e = this._data, t = e.words, n = 8 * this._nDataBytes, r = 8 * e.sigBytes;
          return t[r >>> 5] |= 128 << 24 - r % 32, t[30 + (r + 128 >>> 10 << 5)] = Math.floor(n / 4294967296), t[31 + (r + 128 >>> 10 << 5)] = n, e.sigBytes = 4 * t.length, this._process(), this._hash.toX32()
        }, clone: function e() {
          var e = t.clone.call(this);
          return e._hash = this._hash.clone(), e
        }, blockSize: 32
      });
      e.SHA512 = t._createHelper(s), e.HmacSHA512 = t._createHmacHelper(s)
    }(), F = ($ = ve).x64, P = F.Word, U = F.WordArray, z = $.algo, K = z.SHA512, V = z.SHA384 = K.extend({
      _doReset: function () {
        this._hash = new U.init([new P.init(3418070365, 3238371032), new P.init(1654270250, 914150663), new P.init(2438529370, 812702999), new P.init(355462360, 4144912697), new P.init(1731405415, 4290775857), new P.init(2394180231, 1750603025), new P.init(3675008525, 1694076839), new P.init(1203062813, 3204075428)])
      }, _doFinalize: function () {
        var e = K._doFinalize.call(this);
        return e.sigBytes -= 16, e
      }
    }), $.SHA384 = K._createHelper(V), $.HmacSHA384 = K._createHmacHelper(V), ve.lib.Cipher || (G = (W = ve).lib, Y = G.Base, j = G.WordArray, q = G.BufferedBlockAlgorithm, (Z = W.enc).Utf8, X = Z.Base64, Q = W.algo.EvpKDF, J = G.Cipher = q.extend({
      cfg: Y.extend(),
      createEncryptor: function (e, t) {
        return this.create(this._ENC_XFORM_MODE, e, t)
      },
      createDecryptor: function (e, t) {
        return this.create(this._DEC_XFORM_MODE, e, t)
      },
      init: function (e, t, n) {
        this.cfg = this.cfg.extend(n), this._xformMode = e, this._key = t, this.reset()
      },
      reset: function () {
        q.reset.call(this), this._doReset()
      },
      process: function (e) {
        return this._append(e), this._process()
      },
      finalize: function (e) {
        return e && this._append(e), this._doFinalize()
      },
      keySize: 4,
      ivSize: 4,
      _ENC_XFORM_MODE: 1,
      _DEC_XFORM_MODE: 2,
      _createHelper: function () {
        function a(e) {
          return "string" == typeof e ? le : ie
        }

        return function (r) {
          return {
            encrypt: function (e, t, n) {
              return a(t).encrypt(r, e, t, n)
            }, decrypt: function (e, t, n) {
              return a(t).decrypt(r, e, t, n)
            }
          }
        }
      }()
    }), G.StreamCipher = J.extend({
      _doFinalize: function () {
        return this._process(!0)
      }, blockSize: 1
    }), ee = W.mode = {}, te = G.BlockCipherMode = Y.extend({
      createEncryptor: function (e, t) {
        return this.Encryptor.create(e, t)
      }, createDecryptor: function (e, t) {
        return this.Decryptor.create(e, t)
      }, init: function (e, t) {
        this._cipher = e, this._iv = t
      }
    }), ne = ee.CBC = function () {
      var e = te.extend();

      function o(e, t, n) {
        var r, a = this._iv;
        a ? (r = a, this._iv = void 0) : r = this._prevBlock;
        for (var o = 0; o < n; o++) e[t + o] ^= r[o]
      }

      return e.Encryptor = e.extend({
        processBlock: function (e, t) {
          var n = this._cipher, r = n.blockSize;
          o.call(this, e, t, r), n.encryptBlock(e, t), this._prevBlock = e.slice(t, t + r)
        }
      }), e.Decryptor = e.extend({
        processBlock: function (e, t) {
          var n = this._cipher, r = n.blockSize, a = e.slice(t, t + r);
          n.decryptBlock(e, t), o.call(this, e, t, r), this._prevBlock = a
        }
      }), e
    }(), re = (W.pad = {}).Pkcs7 = {
      pad: function (e, t) {
        for (var n = 4 * t, r = n - e.sigBytes % n, a = r << 24 | r << 16 | r << 8 | r, o = [], i = 0; i < r; i += 4) o.push(a);
        var s = j.create(o, r);
        e.concat(s)
      }, unpad: function (e) {
        var t = 255 & e.words[e.sigBytes - 1 >>> 2];
        e.sigBytes -= t
      }
    }, G.BlockCipher = J.extend({
      cfg: J.cfg.extend({mode: ne, padding: re}), reset: function () {
        var e;
        J.reset.call(this);
        var t = this.cfg, n = t.iv, r = t.mode;
        this._xformMode == this._ENC_XFORM_MODE ? e = r.createEncryptor : (e = r.createDecryptor, this._minBufferSize = 1), this._mode && this._mode.__creator == e ? this._mode.init(this, n && n.words) : (this._mode = e.call(r, this, n && n.words), this._mode.__creator = e)
      }, _doProcessBlock: function (e, t) {
        this._mode.processBlock(e, t)
      }, _doFinalize: function () {
        var e, t = this.cfg.padding;
        return this._xformMode == this._ENC_XFORM_MODE ? (t.pad(this._data, this.blockSize), e = this._process(!0)) : (e = this._process(!0), t.unpad(e)), e
      }, blockSize: 4
    }), ae = G.CipherParams = Y.extend({
      init: function (e) {
        this.mixIn(e)
      }, toString: function (e) {
        return (e || this.formatter).stringify(this)
      }
    }), oe = (W.format = {}).OpenSSL = {
      stringify: function (e) {
        var t = e.ciphertext, n = e.salt;
        return (n ? j.create([1398893684, 1701076831]).concat(n).concat(t) : t).toString(X)
      }, parse: function (e) {
        var t, n = X.parse(e), r = n.words;
        return 1398893684 == r[0] && 1701076831 == r[1] && (t = j.create(r.slice(2, 4)), r.splice(0, 4), n.sigBytes -= 16), ae.create({
          ciphertext: n,
          salt: t
        })
      }
    }, ie = G.SerializableCipher = Y.extend({
      cfg: Y.extend({format: oe}), encrypt: function (e, t, n, r) {
        r = this.cfg.extend(r);
        var a = e.createEncryptor(n, r), o = a.finalize(t), i = a.cfg;
        return ae.create({
          ciphertext: o,
          key: n,
          iv: i.iv,
          algorithm: e,
          mode: i.mode,
          padding: i.padding,
          blockSize: e.blockSize,
          formatter: r.format
        })
      }, decrypt: function (e, t, n, r) {
        return r = this.cfg.extend(r), t = this._parse(t, r.format), e.createDecryptor(n, r).finalize(t.ciphertext)
      }, _parse: function (e, t) {
        return "string" == typeof e ? t.parse(e, this) : e
      }
    }), se = (W.kdf = {}).OpenSSL = {
      execute: function (e, t, n, r) {
        r || (r = j.random(8));
        var a = Q.create({keySize: t + n}).compute(e, r), o = j.create(a.words.slice(t), 4 * n);
        return a.sigBytes = 4 * t, ae.create({key: a, iv: o, salt: r})
      }
    }, le = G.PasswordBasedCipher = ie.extend({
      cfg: ie.cfg.extend({kdf: se}), encrypt: function (e, t, n, r) {
        var a = (r = this.cfg.extend(r)).kdf.execute(n, e.keySize, e.ivSize);
        r.iv = a.iv;
        var o = ie.encrypt.call(this, e, t, a.key, r);
        return o.mixIn(a), o
      }, decrypt: function (e, t, n, r) {
        r = this.cfg.extend(r), t = this._parse(t, r.format);
        var a = r.kdf.execute(n, e.keySize, e.ivSize, t.salt);
        return r.iv = a.iv, ie.decrypt.call(this, e, t, a.key, r)
      }
    })), ve.mode.CFB = function () {
      var e = ve.lib.BlockCipherMode.extend();

      function o(e, t, n, r) {
        var a, o = this._iv;
        o ? (a = o.slice(0), this._iv = undefined) : a = this._prevBlock, r.encryptBlock(a, 0);
        for (var i = 0; i < n; i++) e[t + i] ^= a[i]
      }

      return e.Encryptor = e.extend({
        processBlock: function (e, t) {
          var n = this._cipher, r = n.blockSize;
          o.call(this, e, t, r, n), this._prevBlock = e.slice(t, t + r)
        }
      }), e.Decryptor = e.extend({
        processBlock: function (e, t) {
          var n = this._cipher, r = n.blockSize, a = e.slice(t, t + r);
          o.call(this, e, t, r, n), this._prevBlock = a
        }
      }), e
    }(), ve.mode.ECB = ((ce = ve.lib.BlockCipherMode.extend()).Encryptor = ce.extend({
      processBlock: function (e, t) {
        this._cipher.encryptBlock(e, t)
      }
    }), ce.Decryptor = ce.extend({
      processBlock: function (e, t) {
        this._cipher.decryptBlock(e, t)
      }
    }), ce), ve.pad.AnsiX923 = {
      pad: function (e, t) {
        var n = e.sigBytes, r = 4 * t, a = r - n % r, o = n + a - 1;
        e.clamp(), e.words[o >>> 2] |= a << 24 - o % 4 * 8, e.sigBytes += a
      }, unpad: function (e) {
        var t = 255 & e.words[e.sigBytes - 1 >>> 2];
        e.sigBytes -= t
      }
    }, ve.pad.Iso10126 = {
      pad: function (e, t) {
        var n = 4 * t, r = n - e.sigBytes % n;
        e.concat(ve.lib.WordArray.random(r - 1)).concat(ve.lib.WordArray.create([r << 24], 1))
      }, unpad: function (e) {
        var t = 255 & e.words[e.sigBytes - 1 >>> 2];
        e.sigBytes -= t
      }
    }, ve.pad.Iso97971 = {
      pad: function (e, t) {
        e.concat(ve.lib.WordArray.create([2147483648], 1)), ve.pad.ZeroPadding.pad(e, t)
      }, unpad: function (e) {
        ve.pad.ZeroPadding.unpad(e), e.sigBytes--
      }
    }, ve.mode.OFB = (de = ve.lib.BlockCipherMode.extend(), fe = de.Encryptor = de.extend({
      processBlock: function (e, t) {
        var n = this._cipher, r = n.blockSize, a = this._iv, o = this._keystream;
        a && (o = this._keystream = a.slice(0), this._iv = undefined), n.encryptBlock(o, 0);
        for (var i = 0; i < r; i++) e[t + i] ^= o[i]
      }
    }), de.Decryptor = fe, de), ve.pad.NoPadding = {
      pad: function () {
      }, unpad: function () {
      }
    }, ue = (pe = ve).lib.CipherParams, he = pe.enc.Hex, pe.format.Hex = {
      stringify: function (e) {
        return e.ciphertext.toString(he)
      }, parse: function (e) {
        var t = he.parse(e);
        return ue.create({ciphertext: t})
      }
    }, function () {
      var e = ve, t = e.lib.BlockCipher, n = e.algo, c = [], d = [], f = [], p = [], u = [], h = [], g = [], m = [],
        v = [], b = [];
      !function () {
        for (var e = [], t = 0; t < 256; t++) e[t] = t < 128 ? t << 1 : t << 1 ^ 283;
        var n = 0, r = 0;
        for (t = 0; t < 256; t++) {
          var a = r ^ r << 1 ^ r << 2 ^ r << 3 ^ r << 4;
          a = a >>> 8 ^ 255 & a ^ 99, c[n] = a;
          var o = e[d[a] = n], i = e[o], s = e[i], l = 257 * e[a] ^ 16843008 * a;
          f[n] = l << 24 | l >>> 8, p[n] = l << 16 | l >>> 16, u[n] = l << 8 | l >>> 24, h[n] = l;
          l = 16843009 * s ^ 65537 * i ^ 257 * o ^ 16843008 * n;
          g[a] = l << 24 | l >>> 8, m[a] = l << 16 | l >>> 16, v[a] = l << 8 | l >>> 24, b[a] = l, n ? (n = o ^ e[e[e[s ^ o]]], r ^= e[e[r]]) : n = r = 1
        }
      }();
      var C = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], r = n.AES = t.extend({
        _doReset: function () {
          if (!this._nRounds || this._keyPriorReset !== this._key) {
            for (var e = this._keyPriorReset = this._key, t = e.words, n = e.sigBytes / 4, r = 4 * ((this._nRounds = n + 6) + 1), a = this._keySchedule = [], o = 0; o < r; o++) o < n ? a[o] = t[o] : (l = a[o - 1], o % n ? 6 < n && o % n == 4 && (l = c[l >>> 24] << 24 | c[l >>> 16 & 255] << 16 | c[l >>> 8 & 255] << 8 | c[255 & l]) : (l = c[(l = l << 8 | l >>> 24) >>> 24] << 24 | c[l >>> 16 & 255] << 16 | c[l >>> 8 & 255] << 8 | c[255 & l], l ^= C[o / n | 0] << 24), a[o] = a[o - n] ^ l);
            for (var i = this._invKeySchedule = [], s = 0; s < r; s++) {
              o = r - s;
              if (s % 4) var l = a[o]; else l = a[o - 4];
              i[s] = s < 4 || o <= 4 ? l : g[c[l >>> 24]] ^ m[c[l >>> 16 & 255]] ^ v[c[l >>> 8 & 255]] ^ b[c[255 & l]]
            }
          }
        }, encryptBlock: function (e, t) {
          this._doCryptBlock(e, t, this._keySchedule, f, p, u, h, c)
        }, decryptBlock: function (e, t) {
          var n = e[t + 1];
          e[t + 1] = e[t + 3], e[t + 3] = n, this._doCryptBlock(e, t, this._invKeySchedule, g, m, v, b, d);
          n = e[t + 1];
          e[t + 1] = e[t + 3], e[t + 3] = n
        }, _doCryptBlock: function (e, t, n, r, a, o, i, s) {
          for (var l = this._nRounds, c = e[t] ^ n[0], d = e[t + 1] ^ n[1], f = e[t + 2] ^ n[2], p = e[t + 3] ^ n[3], u = 4, h = 1; h < l; h++) {
            var g = r[c >>> 24] ^ a[d >>> 16 & 255] ^ o[f >>> 8 & 255] ^ i[255 & p] ^ n[u++],
              m = r[d >>> 24] ^ a[f >>> 16 & 255] ^ o[p >>> 8 & 255] ^ i[255 & c] ^ n[u++],
              v = r[f >>> 24] ^ a[p >>> 16 & 255] ^ o[c >>> 8 & 255] ^ i[255 & d] ^ n[u++],
              b = r[p >>> 24] ^ a[c >>> 16 & 255] ^ o[d >>> 8 & 255] ^ i[255 & f] ^ n[u++];
            c = g, d = m, f = v, p = b
          }
          g = (s[c >>> 24] << 24 | s[d >>> 16 & 255] << 16 | s[f >>> 8 & 255] << 8 | s[255 & p]) ^ n[u++], m = (s[d >>> 24] << 24 | s[f >>> 16 & 255] << 16 | s[p >>> 8 & 255] << 8 | s[255 & c]) ^ n[u++], v = (s[f >>> 24] << 24 | s[p >>> 16 & 255] << 16 | s[c >>> 8 & 255] << 8 | s[255 & d]) ^ n[u++], b = (s[p >>> 24] << 24 | s[c >>> 16 & 255] << 16 | s[d >>> 8 & 255] << 8 | s[255 & f]) ^ n[u++];
          e[t] = g, e[t + 1] = m, e[t + 2] = v, e[t + 3] = b
        }, keySize: 8
      });
      e.AES = t._createHelper(r)
    }(), function () {
      var e = ve, t = e.lib, a = t.WordArray, n = t.BlockCipher, r = e.algo,
        c = [57, 49, 41, 33, 25, 17, 9, 1, 58, 50, 42, 34, 26, 18, 10, 2, 59, 51, 43, 35, 27, 19, 11, 3, 60, 52, 44, 36, 63, 55, 47, 39, 31, 23, 15, 7, 62, 54, 46, 38, 30, 22, 14, 6, 61, 53, 45, 37, 29, 21, 13, 5, 28, 20, 12, 4],
        d = [14, 17, 11, 24, 1, 5, 3, 28, 15, 6, 21, 10, 23, 19, 12, 4, 26, 8, 16, 7, 27, 20, 13, 2, 41, 52, 31, 37, 47, 55, 30, 40, 51, 45, 33, 48, 44, 49, 39, 56, 34, 53, 46, 42, 50, 36, 29, 32],
        f = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28], p = [{
          0: 8421888,
          268435456: 32768,
          536870912: 8421378,
          805306368: 2,
          1073741824: 512,
          1342177280: 8421890,
          1610612736: 8389122,
          1879048192: 8388608,
          2147483648: 514,
          2415919104: 8389120,
          2684354560: 33280,
          2952790016: 8421376,
          3221225472: 32770,
          3489660928: 8388610,
          3758096384: 0,
          4026531840: 33282,
          134217728: 0,
          402653184: 8421890,
          671088640: 33282,
          939524096: 32768,
          1207959552: 8421888,
          1476395008: 512,
          1744830464: 8421378,
          2013265920: 2,
          2281701376: 8389120,
          2550136832: 33280,
          2818572288: 8421376,
          3087007744: 8389122,
          3355443200: 8388610,
          3623878656: 32770,
          3892314112: 514,
          4160749568: 8388608,
          1: 32768,
          268435457: 2,
          536870913: 8421888,
          805306369: 8388608,
          1073741825: 8421378,
          1342177281: 33280,
          1610612737: 512,
          1879048193: 8389122,
          2147483649: 8421890,
          2415919105: 8421376,
          2684354561: 8388610,
          2952790017: 33282,
          3221225473: 514,
          3489660929: 8389120,
          3758096385: 32770,
          4026531841: 0,
          134217729: 8421890,
          402653185: 8421376,
          671088641: 8388608,
          939524097: 512,
          1207959553: 32768,
          1476395009: 8388610,
          1744830465: 2,
          2013265921: 33282,
          2281701377: 32770,
          2550136833: 8389122,
          2818572289: 514,
          3087007745: 8421888,
          3355443201: 8389120,
          3623878657: 0,
          3892314113: 33280,
          4160749569: 8421378
        }, {
          0: 1074282512,
          16777216: 16384,
          33554432: 524288,
          50331648: 1074266128,
          67108864: 1073741840,
          83886080: 1074282496,
          100663296: 1073758208,
          117440512: 16,
          134217728: 540672,
          150994944: 1073758224,
          167772160: 1073741824,
          184549376: 540688,
          201326592: 524304,
          218103808: 0,
          234881024: 16400,
          251658240: 1074266112,
          8388608: 1073758208,
          25165824: 540688,
          41943040: 16,
          58720256: 1073758224,
          75497472: 1074282512,
          92274688: 1073741824,
          109051904: 524288,
          125829120: 1074266128,
          142606336: 524304,
          159383552: 0,
          176160768: 16384,
          192937984: 1074266112,
          209715200: 1073741840,
          226492416: 540672,
          243269632: 1074282496,
          260046848: 16400,
          268435456: 0,
          285212672: 1074266128,
          301989888: 1073758224,
          318767104: 1074282496,
          335544320: 1074266112,
          352321536: 16,
          369098752: 540688,
          385875968: 16384,
          402653184: 16400,
          419430400: 524288,
          436207616: 524304,
          452984832: 1073741840,
          469762048: 540672,
          486539264: 1073758208,
          503316480: 1073741824,
          520093696: 1074282512,
          276824064: 540688,
          293601280: 524288,
          310378496: 1074266112,
          327155712: 16384,
          343932928: 1073758208,
          360710144: 1074282512,
          377487360: 16,
          394264576: 1073741824,
          411041792: 1074282496,
          427819008: 1073741840,
          444596224: 1073758224,
          461373440: 524304,
          478150656: 0,
          494927872: 16400,
          511705088: 1074266128,
          528482304: 540672
        }, {
          0: 260,
          1048576: 0,
          2097152: 67109120,
          3145728: 65796,
          4194304: 65540,
          5242880: 67108868,
          6291456: 67174660,
          7340032: 67174400,
          8388608: 67108864,
          9437184: 67174656,
          10485760: 65792,
          11534336: 67174404,
          12582912: 67109124,
          13631488: 65536,
          14680064: 4,
          15728640: 256,
          524288: 67174656,
          1572864: 67174404,
          2621440: 0,
          3670016: 67109120,
          4718592: 67108868,
          5767168: 65536,
          6815744: 65540,
          7864320: 260,
          8912896: 4,
          9961472: 256,
          11010048: 67174400,
          12058624: 65796,
          13107200: 65792,
          14155776: 67109124,
          15204352: 67174660,
          16252928: 67108864,
          16777216: 67174656,
          17825792: 65540,
          18874368: 65536,
          19922944: 67109120,
          20971520: 256,
          22020096: 67174660,
          23068672: 67108868,
          24117248: 0,
          25165824: 67109124,
          26214400: 67108864,
          27262976: 4,
          28311552: 65792,
          29360128: 67174400,
          30408704: 260,
          31457280: 65796,
          32505856: 67174404,
          17301504: 67108864,
          18350080: 260,
          19398656: 67174656,
          20447232: 0,
          21495808: 65540,
          22544384: 67109120,
          23592960: 256,
          24641536: 67174404,
          25690112: 65536,
          26738688: 67174660,
          27787264: 65796,
          28835840: 67108868,
          29884416: 67109124,
          30932992: 67174400,
          31981568: 4,
          33030144: 65792
        }, {
          0: 2151682048,
          65536: 2147487808,
          131072: 4198464,
          196608: 2151677952,
          262144: 0,
          327680: 4198400,
          393216: 2147483712,
          458752: 4194368,
          524288: 2147483648,
          589824: 4194304,
          655360: 64,
          720896: 2147487744,
          786432: 2151678016,
          851968: 4160,
          917504: 4096,
          983040: 2151682112,
          32768: 2147487808,
          98304: 64,
          163840: 2151678016,
          229376: 2147487744,
          294912: 4198400,
          360448: 2151682112,
          425984: 0,
          491520: 2151677952,
          557056: 4096,
          622592: 2151682048,
          688128: 4194304,
          753664: 4160,
          819200: 2147483648,
          884736: 4194368,
          950272: 4198464,
          1015808: 2147483712,
          1048576: 4194368,
          1114112: 4198400,
          1179648: 2147483712,
          1245184: 0,
          1310720: 4160,
          1376256: 2151678016,
          1441792: 2151682048,
          1507328: 2147487808,
          1572864: 2151682112,
          1638400: 2147483648,
          1703936: 2151677952,
          1769472: 4198464,
          1835008: 2147487744,
          1900544: 4194304,
          1966080: 64,
          2031616: 4096,
          1081344: 2151677952,
          1146880: 2151682112,
          1212416: 0,
          1277952: 4198400,
          1343488: 4194368,
          1409024: 2147483648,
          1474560: 2147487808,
          1540096: 64,
          1605632: 2147483712,
          1671168: 4096,
          1736704: 2147487744,
          1802240: 2151678016,
          1867776: 4160,
          1933312: 2151682048,
          1998848: 4194304,
          2064384: 4198464
        }, {
          0: 128,
          4096: 17039360,
          8192: 262144,
          12288: 536870912,
          16384: 537133184,
          20480: 16777344,
          24576: 553648256,
          28672: 262272,
          32768: 16777216,
          36864: 537133056,
          40960: 536871040,
          45056: 553910400,
          49152: 553910272,
          53248: 0,
          57344: 17039488,
          61440: 553648128,
          2048: 17039488,
          6144: 553648256,
          10240: 128,
          14336: 17039360,
          18432: 262144,
          22528: 537133184,
          26624: 553910272,
          30720: 536870912,
          34816: 537133056,
          38912: 0,
          43008: 553910400,
          47104: 16777344,
          51200: 536871040,
          55296: 553648128,
          59392: 16777216,
          63488: 262272,
          65536: 262144,
          69632: 128,
          73728: 536870912,
          77824: 553648256,
          81920: 16777344,
          86016: 553910272,
          90112: 537133184,
          94208: 16777216,
          98304: 553910400,
          102400: 553648128,
          106496: 17039360,
          110592: 537133056,
          114688: 262272,
          118784: 536871040,
          122880: 0,
          126976: 17039488,
          67584: 553648256,
          71680: 16777216,
          75776: 17039360,
          79872: 537133184,
          83968: 536870912,
          88064: 17039488,
          92160: 128,
          96256: 553910272,
          100352: 262272,
          104448: 553910400,
          108544: 0,
          112640: 553648128,
          116736: 16777344,
          120832: 262144,
          124928: 537133056,
          129024: 536871040
        }, {
          0: 268435464,
          256: 8192,
          512: 270532608,
          768: 270540808,
          1024: 268443648,
          1280: 2097152,
          1536: 2097160,
          1792: 268435456,
          2048: 0,
          2304: 268443656,
          2560: 2105344,
          2816: 8,
          3072: 270532616,
          3328: 2105352,
          3584: 8200,
          3840: 270540800,
          128: 270532608,
          384: 270540808,
          640: 8,
          896: 2097152,
          1152: 2105352,
          1408: 268435464,
          1664: 268443648,
          1920: 8200,
          2176: 2097160,
          2432: 8192,
          2688: 268443656,
          2944: 270532616,
          3200: 0,
          3456: 270540800,
          3712: 2105344,
          3968: 268435456,
          4096: 268443648,
          4352: 270532616,
          4608: 270540808,
          4864: 8200,
          5120: 2097152,
          5376: 268435456,
          5632: 268435464,
          5888: 2105344,
          6144: 2105352,
          6400: 0,
          6656: 8,
          6912: 270532608,
          7168: 8192,
          7424: 268443656,
          7680: 270540800,
          7936: 2097160,
          4224: 8,
          4480: 2105344,
          4736: 2097152,
          4992: 268435464,
          5248: 268443648,
          5504: 8200,
          5760: 270540808,
          6016: 270532608,
          6272: 270540800,
          6528: 270532616,
          6784: 8192,
          7040: 2105352,
          7296: 2097160,
          7552: 0,
          7808: 268435456,
          8064: 268443656
        }, {
          0: 1048576,
          16: 33555457,
          32: 1024,
          48: 1049601,
          64: 34604033,
          80: 0,
          96: 1,
          112: 34603009,
          128: 33555456,
          144: 1048577,
          160: 33554433,
          176: 34604032,
          192: 34603008,
          208: 1025,
          224: 1049600,
          240: 33554432,
          8: 34603009,
          24: 0,
          40: 33555457,
          56: 34604032,
          72: 1048576,
          88: 33554433,
          104: 33554432,
          120: 1025,
          136: 1049601,
          152: 33555456,
          168: 34603008,
          184: 1048577,
          200: 1024,
          216: 34604033,
          232: 1,
          248: 1049600,
          256: 33554432,
          272: 1048576,
          288: 33555457,
          304: 34603009,
          320: 1048577,
          336: 33555456,
          352: 34604032,
          368: 1049601,
          384: 1025,
          400: 34604033,
          416: 1049600,
          432: 1,
          448: 0,
          464: 34603008,
          480: 33554433,
          496: 1024,
          264: 1049600,
          280: 33555457,
          296: 34603009,
          312: 1,
          328: 33554432,
          344: 1048576,
          360: 1025,
          376: 34604032,
          392: 33554433,
          408: 34603008,
          424: 0,
          440: 34604033,
          456: 1049601,
          472: 1024,
          488: 33555456,
          504: 1048577
        }, {
          0: 134219808,
          1: 131072,
          2: 134217728,
          3: 32,
          4: 131104,
          5: 134350880,
          6: 134350848,
          7: 2048,
          8: 134348800,
          9: 134219776,
          10: 133120,
          11: 134348832,
          12: 2080,
          13: 0,
          14: 134217760,
          15: 133152,
          2147483648: 2048,
          2147483649: 134350880,
          2147483650: 134219808,
          2147483651: 134217728,
          2147483652: 134348800,
          2147483653: 133120,
          2147483654: 133152,
          2147483655: 32,
          2147483656: 134217760,
          2147483657: 2080,
          2147483658: 131104,
          2147483659: 134350848,
          2147483660: 0,
          2147483661: 134348832,
          2147483662: 134219776,
          2147483663: 131072,
          16: 133152,
          17: 134350848,
          18: 32,
          19: 2048,
          20: 134219776,
          21: 134217760,
          22: 134348832,
          23: 131072,
          24: 0,
          25: 131104,
          26: 134348800,
          27: 134219808,
          28: 134350880,
          29: 133120,
          30: 2080,
          31: 134217728,
          2147483664: 131072,
          2147483665: 2048,
          2147483666: 134348832,
          2147483667: 133152,
          2147483668: 32,
          2147483669: 134348800,
          2147483670: 134217728,
          2147483671: 134219808,
          2147483672: 134350880,
          2147483673: 134217760,
          2147483674: 134219776,
          2147483675: 0,
          2147483676: 133120,
          2147483677: 2080,
          2147483678: 131104,
          2147483679: 134350848
        }], u = [4160749569, 528482304, 33030144, 2064384, 129024, 8064, 504, 2147483679], o = r.DES = n.extend({
          _doReset: function () {
            for (var e = this._key.words, t = [], n = 0; n < 56; n++) {
              var r = c[n] - 1;
              t[n] = e[r >>> 5] >>> 31 - r % 32 & 1
            }
            for (var a = this._subKeys = [], o = 0; o < 16; o++) {
              var i = a[o] = [], s = f[o];
              for (n = 0; n < 24; n++) i[n / 6 | 0] |= t[(d[n] - 1 + s) % 28] << 31 - n % 6, i[4 + (n / 6 | 0)] |= t[28 + (d[n + 24] - 1 + s) % 28] << 31 - n % 6;
              i[0] = i[0] << 1 | i[0] >>> 31;
              for (n = 1; n < 7; n++) i[n] = i[n] >>> 4 * (n - 1) + 3;
              i[7] = i[7] << 5 | i[7] >>> 27
            }
            var l = this._invSubKeys = [];
            for (n = 0; n < 16; n++) l[n] = a[15 - n]
          }, encryptBlock: function (e, t) {
            this._doCryptBlock(e, t, this._subKeys)
          }, decryptBlock: function (e, t) {
            this._doCryptBlock(e, t, this._invSubKeys)
          }, _doCryptBlock: function (e, t, n) {
            this._lBlock = e[t], this._rBlock = e[t + 1], h.call(this, 4, 252645135), h.call(this, 16, 65535), g.call(this, 2, 858993459), g.call(this, 8, 16711935), h.call(this, 1, 1431655765);
            for (var r = 0; r < 16; r++) {
              for (var a = n[r], o = this._lBlock, i = this._rBlock, s = 0, l = 0; l < 8; l++) s |= p[l][((i ^ a[l]) & u[l]) >>> 0];
              this._lBlock = i, this._rBlock = o ^ s
            }
            var c = this._lBlock;
            this._lBlock = this._rBlock, this._rBlock = c, h.call(this, 1, 1431655765), g.call(this, 8, 16711935), g.call(this, 2, 858993459), h.call(this, 16, 65535), h.call(this, 4, 252645135), e[t] = this._lBlock, e[t + 1] = this._rBlock
          }, keySize: 2, ivSize: 2, blockSize: 2
        });

      function h(e, t) {
        var n = (this._lBlock >>> e ^ this._rBlock) & t;
        this._rBlock ^= n, this._lBlock ^= n << e
      }

      function g(e, t) {
        var n = (this._rBlock >>> e ^ this._lBlock) & t;
        this._lBlock ^= n, this._rBlock ^= n << e
      }

      e.DES = n._createHelper(o);
      var i = r.TripleDES = n.extend({
        _doReset: function () {
          var e = this._key.words;
          if (2 !== e.length && 4 !== e.length && e.length < 6) throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
          var t = e.slice(0, 2), n = e.length < 4 ? e.slice(0, 2) : e.slice(2, 4),
            r = e.length < 6 ? e.slice(0, 2) : e.slice(4, 6);
          this._des1 = o.createEncryptor(a.create(t)), this._des2 = o.createEncryptor(a.create(n)), this._des3 = o.createEncryptor(a.create(r))
        }, encryptBlock: function (e, t) {
          this._des1.encryptBlock(e, t), this._des2.decryptBlock(e, t), this._des3.encryptBlock(e, t)
        }, decryptBlock: function (e, t) {
          this._des3.decryptBlock(e, t), this._des2.encryptBlock(e, t), this._des1.decryptBlock(e, t)
        }, keySize: 6, ivSize: 2, blockSize: 2
      });
      e.TripleDES = n._createHelper(i)
    }(), function () {
      var e = ve, t = e.lib.StreamCipher, n = e.algo, r = n.RC4 = t.extend({
        _doReset: function () {
          for (var e = this._key, t = e.words, n = e.sigBytes, r = this._S = [], a = 0; a < 256; a++) r[a] = a;
          a = 0;
          for (var o = 0; a < 256; a++) {
            var i = a % n, s = t[i >>> 2] >>> 24 - i % 4 * 8 & 255;
            o = (o + r[a] + s) % 256;
            var l = r[a];
            r[a] = r[o], r[o] = l
          }
          this._i = this._j = 0
        }, _doProcessBlock: function (e, t) {
          e[t] ^= a.call(this)
        }, keySize: 8, ivSize: 0
      });

      function a() {
        for (var e = this._S, t = this._i, n = this._j, r = 0, a = 0; a < 4; a++) {
          n = (n + e[t = (t + 1) % 256]) % 256;
          var o = e[t];
          e[t] = e[n], e[n] = o, r |= e[(e[t] + e[n]) % 256] << 24 - 8 * a
        }
        return this._i = t, this._j = n, r
      }

      e.RC4 = t._createHelper(r);
      var o = n.RC4Drop = r.extend({
        cfg: r.cfg.extend({drop: 192}), _doReset: function () {
          r._doReset.call(this);
          for (var e = this.cfg.drop; 0 < e; e--) a.call(this)
        }
      });
      e.RC4Drop = t._createHelper(o)
    }(), ve.mode.CTRGladman = function () {
      var e = ve.lib.BlockCipherMode.extend();

      function c(e) {
        if (255 == (e >> 24 & 255)) {
          var t = e >> 16 & 255, n = e >> 8 & 255, r = 255 & e;
          255 === t ? (t = 0, 255 === n ? (n = 0, 255 === r ? r = 0 : ++r) : ++n) : ++t, e = 0, e += t << 16, e += n << 8, e += r
        } else e += 1 << 24;
        return e
      }

      var t = e.Encryptor = e.extend({
        processBlock: function (e, t) {
          var n = this._cipher, r = n.blockSize, a = this._iv, o = this._counter;
          a && (o = this._counter = a.slice(0), this._iv = undefined), function l(e) {
            return 0 === (e[0] = c(e[0])) && (e[1] = c(e[1])), e
          }(o);
          var i = o.slice(0);
          n.encryptBlock(i, 0);
          for (var s = 0; s < r; s++) e[t + s] ^= i[s]
        }
      });
      return e.Decryptor = t, e
    }(), function () {
      var e = ve, t = e.lib.StreamCipher, n = e.algo, a = [], l = [], c = [], r = n.Rabbit = t.extend({
        _doReset: function () {
          for (var e = this._key.words, t = this.cfg.iv, n = 0; n < 4; n++) e[n] = 16711935 & (e[n] << 8 | e[n] >>> 24) | 4278255360 & (e[n] << 24 | e[n] >>> 8);
          var r = this._X = [e[0], e[3] << 16 | e[2] >>> 16, e[1], e[0] << 16 | e[3] >>> 16, e[2], e[1] << 16 | e[0] >>> 16, e[3], e[2] << 16 | e[1] >>> 16],
            a = this._C = [e[2] << 16 | e[2] >>> 16, 4294901760 & e[0] | 65535 & e[1], e[3] << 16 | e[3] >>> 16, 4294901760 & e[1] | 65535 & e[2], e[0] << 16 | e[0] >>> 16, 4294901760 & e[2] | 65535 & e[3], e[1] << 16 | e[1] >>> 16, 4294901760 & e[3] | 65535 & e[0]];
          for (n = this._b = 0; n < 4; n++) p.call(this);
          for (n = 0; n < 8; n++) a[n] ^= r[n + 4 & 7];
          if (t) {
            var o = t.words, i = o[0], s = o[1], l = 16711935 & (i << 8 | i >>> 24) | 4278255360 & (i << 24 | i >>> 8),
              c = 16711935 & (s << 8 | s >>> 24) | 4278255360 & (s << 24 | s >>> 8), d = l >>> 16 | 4294901760 & c,
              f = c << 16 | 65535 & l;
            a[0] ^= l, a[1] ^= d, a[2] ^= c, a[3] ^= f, a[4] ^= l, a[5] ^= d, a[6] ^= c, a[7] ^= f;
            for (n = 0; n < 4; n++) p.call(this)
          }
        }, _doProcessBlock: function (e, t) {
          var n = this._X;
          p.call(this), a[0] = n[0] ^ n[5] >>> 16 ^ n[3] << 16, a[1] = n[2] ^ n[7] >>> 16 ^ n[5] << 16, a[2] = n[4] ^ n[1] >>> 16 ^ n[7] << 16, a[3] = n[6] ^ n[3] >>> 16 ^ n[1] << 16;
          for (var r = 0; r < 4; r++) a[r] = 16711935 & (a[r] << 8 | a[r] >>> 24) | 4278255360 & (a[r] << 24 | a[r] >>> 8), e[t + r] ^= a[r]
        }, blockSize: 4, ivSize: 2
      });

      function p() {
        for (var e = this._X, t = this._C, n = 0; n < 8; n++) l[n] = t[n];
        t[0] = t[0] + 1295307597 + this._b | 0, t[1] = t[1] + 3545052371 + (t[0] >>> 0 < l[0] >>> 0 ? 1 : 0) | 0, t[2] = t[2] + 886263092 + (t[1] >>> 0 < l[1] >>> 0 ? 1 : 0) | 0, t[3] = t[3] + 1295307597 + (t[2] >>> 0 < l[2] >>> 0 ? 1 : 0) | 0, t[4] = t[4] + 3545052371 + (t[3] >>> 0 < l[3] >>> 0 ? 1 : 0) | 0, t[5] = t[5] + 886263092 + (t[4] >>> 0 < l[4] >>> 0 ? 1 : 0) | 0, t[6] = t[6] + 1295307597 + (t[5] >>> 0 < l[5] >>> 0 ? 1 : 0) | 0, t[7] = t[7] + 3545052371 + (t[6] >>> 0 < l[6] >>> 0 ? 1 : 0) | 0, this._b = t[7] >>> 0 < l[7] >>> 0 ? 1 : 0;
        for (n = 0; n < 8; n++) {
          var r = e[n] + t[n], a = 65535 & r, o = r >>> 16, i = ((a * a >>> 17) + a * o >>> 15) + o * o,
            s = ((4294901760 & r) * r | 0) + ((65535 & r) * r | 0);
          c[n] = i ^ s
        }
        e[0] = c[0] + (c[7] << 16 | c[7] >>> 16) + (c[6] << 16 | c[6] >>> 16) | 0, e[1] = c[1] + (c[0] << 8 | c[0] >>> 24) + c[7] | 0, e[2] = c[2] + (c[1] << 16 | c[1] >>> 16) + (c[0] << 16 | c[0] >>> 16) | 0, e[3] = c[3] + (c[2] << 8 | c[2] >>> 24) + c[1] | 0, e[4] = c[4] + (c[3] << 16 | c[3] >>> 16) + (c[2] << 16 | c[2] >>> 16) | 0, e[5] = c[5] + (c[4] << 8 | c[4] >>> 24) + c[3] | 0, e[6] = c[6] + (c[5] << 16 | c[5] >>> 16) + (c[4] << 16 | c[4] >>> 16) | 0, e[7] = c[7] + (c[6] << 8 | c[6] >>> 24) + c[5] | 0
      }

      e.Rabbit = t._createHelper(r)
    }(), ve.mode.CTR = (ge = ve.lib.BlockCipherMode.extend(), me = ge.Encryptor = ge.extend({
      processBlock: function (e, t) {
        var n = this._cipher, r = n.blockSize, a = this._iv, o = this._counter;
        a && (o = this._counter = a.slice(0), this._iv = undefined);
        var i = o.slice(0);
        n.encryptBlock(i, 0), o[r - 1] = o[r - 1] + 1 | 0;
        for (var s = 0; s < r; s++) e[t + s] ^= i[s]
      }
    }), ge.Decryptor = me, ge), function () {
      var e = ve, t = e.lib.StreamCipher, n = e.algo, a = [], l = [], c = [], r = n.RabbitLegacy = t.extend({
        _doReset: function () {
          for (var e = this._key.words, t = this.cfg.iv, n = this._X = [e[0], e[3] << 16 | e[2] >>> 16, e[1], e[0] << 16 | e[3] >>> 16, e[2], e[1] << 16 | e[0] >>> 16, e[3], e[2] << 16 | e[1] >>> 16], r = this._C = [e[2] << 16 | e[2] >>> 16, 4294901760 & e[0] | 65535 & e[1], e[3] << 16 | e[3] >>> 16, 4294901760 & e[1] | 65535 & e[2], e[0] << 16 | e[0] >>> 16, 4294901760 & e[2] | 65535 & e[3], e[1] << 16 | e[1] >>> 16, 4294901760 & e[3] | 65535 & e[0]], a = this._b = 0; a < 4; a++) p.call(this);
          for (a = 0; a < 8; a++) r[a] ^= n[a + 4 & 7];
          if (t) {
            var o = t.words, i = o[0], s = o[1], l = 16711935 & (i << 8 | i >>> 24) | 4278255360 & (i << 24 | i >>> 8),
              c = 16711935 & (s << 8 | s >>> 24) | 4278255360 & (s << 24 | s >>> 8), d = l >>> 16 | 4294901760 & c,
              f = c << 16 | 65535 & l;
            r[0] ^= l, r[1] ^= d, r[2] ^= c, r[3] ^= f, r[4] ^= l, r[5] ^= d, r[6] ^= c, r[7] ^= f;
            for (a = 0; a < 4; a++) p.call(this)
          }
        }, _doProcessBlock: function (e, t) {
          var n = this._X;
          p.call(this), a[0] = n[0] ^ n[5] >>> 16 ^ n[3] << 16, a[1] = n[2] ^ n[7] >>> 16 ^ n[5] << 16, a[2] = n[4] ^ n[1] >>> 16 ^ n[7] << 16, a[3] = n[6] ^ n[3] >>> 16 ^ n[1] << 16;
          for (var r = 0; r < 4; r++) a[r] = 16711935 & (a[r] << 8 | a[r] >>> 24) | 4278255360 & (a[r] << 24 | a[r] >>> 8), e[t + r] ^= a[r]
        }, blockSize: 4, ivSize: 2
      });

      function p() {
        for (var e = this._X, t = this._C, n = 0; n < 8; n++) l[n] = t[n];
        t[0] = t[0] + 1295307597 + this._b | 0, t[1] = t[1] + 3545052371 + (t[0] >>> 0 < l[0] >>> 0 ? 1 : 0) | 0, t[2] = t[2] + 886263092 + (t[1] >>> 0 < l[1] >>> 0 ? 1 : 0) | 0, t[3] = t[3] + 1295307597 + (t[2] >>> 0 < l[2] >>> 0 ? 1 : 0) | 0, t[4] = t[4] + 3545052371 + (t[3] >>> 0 < l[3] >>> 0 ? 1 : 0) | 0, t[5] = t[5] + 886263092 + (t[4] >>> 0 < l[4] >>> 0 ? 1 : 0) | 0, t[6] = t[6] + 1295307597 + (t[5] >>> 0 < l[5] >>> 0 ? 1 : 0) | 0, t[7] = t[7] + 3545052371 + (t[6] >>> 0 < l[6] >>> 0 ? 1 : 0) | 0, this._b = t[7] >>> 0 < l[7] >>> 0 ? 1 : 0;
        for (n = 0; n < 8; n++) {
          var r = e[n] + t[n], a = 65535 & r, o = r >>> 16, i = ((a * a >>> 17) + a * o >>> 15) + o * o,
            s = ((4294901760 & r) * r | 0) + ((65535 & r) * r | 0);
          c[n] = i ^ s
        }
        e[0] = c[0] + (c[7] << 16 | c[7] >>> 16) + (c[6] << 16 | c[6] >>> 16) | 0, e[1] = c[1] + (c[0] << 8 | c[0] >>> 24) + c[7] | 0, e[2] = c[2] + (c[1] << 16 | c[1] >>> 16) + (c[0] << 16 | c[0] >>> 16) | 0, e[3] = c[3] + (c[2] << 8 | c[2] >>> 24) + c[1] | 0, e[4] = c[4] + (c[3] << 16 | c[3] >>> 16) + (c[2] << 16 | c[2] >>> 16) | 0, e[5] = c[5] + (c[4] << 8 | c[4] >>> 24) + c[3] | 0, e[6] = c[6] + (c[5] << 16 | c[5] >>> 16) + (c[4] << 16 | c[4] >>> 16) | 0, e[7] = c[7] + (c[6] << 8 | c[6] >>> 24) + c[5] | 0
      }

      e.RabbitLegacy = t._createHelper(r)
    }(), ve.pad.ZeroPadding = {
      pad: function (e, t) {
        var n = 4 * t;
        e.clamp(), e.sigBytes += n - (e.sigBytes % n || n)
      }, unpad: function (e) {
        var t = e.words, n = e.sigBytes - 1;
        for (n = e.sigBytes - 1; 0 <= n; n--) if (t[n >>> 2] >>> 24 - n % 4 * 8 & 255) {
          e.sigBytes = n + 1;
          break
        }
      }
    }, {
      init: function be() {
      }, cryptoJS: ve
    }
  }, Object.assign(xt.DEFAULTS, {
    fontFamily: {
      "Arial,Helvetica,sans-serif": "Arial",
      "Georgia,serif": "Georgia",
      "Impact,Charcoal,sans-serif": "Impact",
      "Tahoma,Geneva,sans-serif": "Tahoma",
      "Times New Roman,Times,serif,-webkit-standard": "Times New Roman",
      "Verdana,Geneva,sans-serif": "Verdana"
    }, fontFamilySelection: !1, fontFamilyDefaultSelection: "Font Family"
  }), xt.PLUGINS.fontFamily = function (a) {
    var o = a.$;

    function i(e) {
      var t = e.replace(/(sans-serif|serif|monospace|cursive|fantasy)/gi, "").replace(/"|'| /g, "").split(",");
      return o(this).grep(t, function (e) {
        return 0 < e.length
      })
    }

    function s(e, t) {
      for (var n = 0; n < e.length; n++) for (var r = 0; r < t.length; r++) if (e[n].toLowerCase() === t[r].toLowerCase()) return [n, r];
      return null
    }

    function n() {
      var e = i(o(a.selection.element()).css("font-family")), t = [];
      for (var n in a.opts.fontFamily) if (a.opts.fontFamily.hasOwnProperty(n)) {
        var r = s(e, i(n));
        r && t.push([n, r])
      }
      return 0 === t.length ? null : (t.sort(function (e, t) {
        var n = e[1][0] - t[1][0];
        return 0 === n ? e[1][1] - t[1][1] : n
      }), t[0][0])
    }

    return {
      apply: function t(e) {
        a.format.applyStyle("font-family", e)
      }, refreshOnShow: function r(e, t) {
        t.find(".fr-command.fr-active").removeClass("fr-active").attr("aria-selected", !1), t.find('.fr-command[data-param1="'.concat(n(), '"]')).addClass("fr-active").attr("aria-selected", !0)
      }, refresh: function l(e) {
        if (a.opts.fontFamilySelection) {
          var t = o(a.selection.element()).css("font-family").replace(/(sans-serif|serif|monospace|cursive|fantasy)/gi, "").replace(/"|'|/g, "").split(",");
          e.find("> span").text(a.opts.fontFamily[n()] || t[0] || a.language.translate(a.opts.fontFamilyDefaultSelection))
        }
      }
    }
  }, xt.RegisterCommand("fontFamily", {
    type: "dropdown", displaySelection: function (e) {
      return e.opts.fontFamilySelection
    }, defaultSelection: function (e) {
      return e.opts.fontFamilyDefaultSelection
    }, displaySelectionWidth: 120, html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.fontFamily;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="fontFamily" data-param1="'.concat(n, '" \n        style="font-family: ').concat(n, '" title="').concat(t[n], '">').concat(t[n], "</a></li>"));
      return e += "</ul>"
    }, title: "Font Family", callback: function (e, t) {
      this.fontFamily.apply(t)
    }, refresh: function (e) {
      this.fontFamily.refresh(e)
    }, refreshOnShow: function (e, t) {
      this.fontFamily.refreshOnShow(e, t)
    }, plugin: "fontFamily"
  }), xt.DefineIcon("fontFamily", {
    NAME: "font",
    SVG_KEY: "fontFamily"
  }), Object.assign(xt.DEFAULTS, {
    fontSize: ["8", "9", "10", "11", "12", "14", "18", "24", "30", "36", "48", "60", "72", "96"],
    fontSizeSelection: !1,
    fontSizeDefaultSelection: "12",
    fontSizeUnit: "px"
  }), xt.PLUGINS.fontSize = function (r) {
    var a = r.$;
    return {
      apply: function t(e) {
        r.format.applyStyle("font-size", e)
      }, refreshOnShow: function o(e, t) {
        var n = a(r.selection.element()).css("font-size");
        "pt" === r.opts.fontSizeUnit && (n = "".concat(Math.round(72 * parseFloat(n, 10) / 96), "pt")), t.find(".fr-command.fr-active").removeClass("fr-active").attr("aria-selected", !1), t.find('.fr-command[data-param1="'.concat(n, '"]')).addClass("fr-active").attr("aria-selected", !0)
      }, refresh: function n(e) {
        if (r.opts.fontSizeSelection) {
          var t = r.helpers.getPX(a(r.selection.element()).css("font-size"));
          "pt" === r.opts.fontSizeUnit && (t = "".concat(Math.round(72 * parseFloat(t, 10) / 96), "pt")), e.find("> span").text(t)
        }
      }
    }
  }, xt.RegisterCommand("fontSize", {
    type: "dropdown", title: "Font Size", displaySelection: function (e) {
      return e.opts.fontSizeSelection
    }, displaySelectionWidth: 30, defaultSelection: function (e) {
      return e.opts.fontSizeDefaultSelection
    }, html: function () {
      for (var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.fontSize, n = 0; n < t.length; n++) {
        var r = t[n];
        e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="fontSize" data-param1="'.concat(r).concat(this.opts.fontSizeUnit, '" title="').concat(r, '">').concat(r, "</a></li>")
      }
      return e += "</ul>"
    }, callback: function (e, t) {
      this.fontSize.apply(t)
    }, refresh: function (e) {
      this.fontSize.refresh(e)
    }, refreshOnShow: function (e, t) {
      this.fontSize.refreshOnShow(e, t)
    }, plugin: "fontSize"
  }), xt.DefineIcon("fontSize", {
    NAME: "text-height",
    SVG_KEY: "fontSize"
  }), Object.assign(xt.POPUP_TEMPLATES, {
    "forms.edit": "[_BUTTONS_]",
    "forms.update": "[_BUTTONS_][_TEXT_LAYER_]"
  }), Object.assign(xt.DEFAULTS, {
    formEditButtons: ["inputStyle", "inputEdit"],
    formStyles: {"fr-rounded": "Rounded", "fr-large": "Large"},
    formMultipleStyles: !0,
    formUpdateButtons: ["inputBack", "|"]
  }), xt.PLUGINS.forms = function (i) {
    var s, l = i.$;

    function t(e) {
      i.selection.clear(), l(this).data("mousedown", !0)
    }

    function n(e) {
      l(this).data("mousedown") && (e.stopPropagation(), l(this).removeData("mousedown"), d(s = this)), e.preventDefault()
    }

    function r() {
      i.$el.find("input, textarea, button").removeData("mousedown")
    }

    function a() {
      l(this).removeData("mousedown")
    }

    function c() {
      return s || null
    }

    function d(e) {
      if (-1 == ["checkbox", "radio"].indexOf(e.type)) {
        var t = i.popups.get("forms.edit");
        t || (t = function o() {
          var e = "";
          0 < i.opts.formEditButtons.length && (e = '<div class="fr-buttons">'.concat(i.button.buildList(i.opts.formEditButtons), "</div>"));
          var t = {buttons: e}, n = i.popups.create("forms.edit", t);
          return i.$wp && i.events.$on(i.$wp, "scroll.link-edit", function () {
            c() && i.popups.isVisible("forms.edit") && d(c())
          }), n
        }());
        var n = l(s = e);
        i.popups.refresh("forms.edit"), i.popups.setContainer("forms.edit", i.$sc);
        var r = n.offset().left + n.outerWidth() / 2, a = n.offset().top + n.outerHeight();
        i.popups.show("forms.edit", r, a, n.outerHeight())
      }
    }

    function o() {
      var e = i.popups.get("forms.update"), t = c();
      if (t) {
        var n = l(t);
        n.is("button") ? e.find('input[type="text"][name="text"]').val(n.text()) : n.is("input[type=button]") || n.is("input[type=submit]") || n.is("input[type=reset]") ? e.find('input[type="text"][name="text"]').val(n.val()) : e.find('input[type="text"][name="text"]').val(n.attr("placeholder"))
      }
      e.find('input[type="text"][name="text"]').trigger("change")
    }

    function f() {
      s = null
    }

    function p(e) {
      if (e) return i.popups.onRefresh("forms.update", o), i.popups.onHide("forms.update", f), !0;
      var t = "";
      1 <= i.opts.formUpdateButtons.length && (t = '<div class="fr-buttons">'.concat(i.button.buildList(i.opts.formUpdateButtons), "</div>"));
      var n = 0, r = {
        buttons: t,
        text_layer: '<div class="fr-forms-text-layer fr-layer fr-active"> \n    <div class="fr-input-line"><input name="text" type="text" placeholder="Text" tabIndex=" '.concat(++n, ' "></div>\n    <div class="fr-action-buttons"><button class="fr-command fr-submit" data-cmd="updateInput" href="#" tabIndex="').concat(2, '" type="button">').concat(i.language.translate("Update"), "</button></div></div>")
      };
      return i.popups.create("forms.update", r)
    }

    return {
      _init: function u() {
        !function e() {
          i.events.$on(i.$el, i._mousedown, "input, textarea, button", t), i.events.$on(i.$el, i._mouseup, "input, textarea, button", n), i.events.$on(i.$el, "touchmove", "input, textarea, button", a), i.events.$on(i.$el, i._mouseup, r), i.events.$on(i.$win, i._mouseup, r), p(!0)
        }(), i.events.$on(i.$el, "submit", "form", function (e) {
          return e.preventDefault(), !1
        })
      }, updateInput: function h() {
        var e = i.popups.get("forms.update"), t = c();
        if (t) {
          var n = l(t), r = e.find('input[type="text"][name="text"]').val() || "";
          n.is("button") ? r.length ? n.text(r) : n.text("\u200b") : -1 != ["button", "submit", "reset"].indexOf(t.type) ? n.attr("value", r) : n.attr("placeholder", r), i.popups.hide("forms.update"), d(t)
        }
      }, getInput: c, applyStyle: function g(e, t, n) {
        void 0 === t && (t = i.opts.formStyles), void 0 === n && (n = i.opts.formMultipleStyles);
        var r = c();
        if (!r) return !1;
        if (!n) {
          var a = Object.keys(t);
          a.splice(a.indexOf(e), 1), l(r).removeClass(a.join(" "))
        }
        l(r).toggleClass(e)
      }, showUpdatePopup: function m() {
        var e = c();
        if (e) {
          var t = l(e), n = i.popups.get("forms.update");
          n || (n = p()), i.popups.isVisible("forms.update") || i.popups.refresh("forms.update"), i.popups.setContainer("forms.update", i.$sc);
          var r = t.offset().left + t.outerWidth() / 2, a = t.offset().top + t.outerHeight();
          i.popups.show("forms.update", r, a, t.outerHeight())
        }
      }, showEditPopup: d, back: function v() {
        i.events.disableBlur(), i.selection.restore(), i.events.enableBlur();
        var e = c();
        e && i.$wp && ("BUTTON" === e.tagName && i.selection.restore(), d(e))
      }
    }
  },xt.RegisterCommand("updateInput", {
    undo: !1, focus: !1, title: "Update", callback: function () {
      this.forms.updateInput()
    }
  }),xt.DefineIcon("inputStyle", {
    NAME: "magic",
    SVG_KEY: "inlineStyle"
  }),xt.RegisterCommand("inputStyle", {
    title: "Style", type: "dropdown", html: function () {
      var e = '<ul class="fr-dropdown-list">', t = this.opts.formStyles;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li><a class="fr-command" tabIndex="-1" data-cmd="inputStyle" data-param1="'.concat(n, '">').concat(this.language.translate(t[n]), "</a></li>"));
      return e += "</ul>"
    }, callback: function (e, t) {
      var n = this.forms.getInput();
      n && (this.forms.applyStyle(t), this.forms.showEditPopup(n))
    }, refreshOnShow: function (e, t) {
      var n = this.$, r = this.forms.getInput();
      if (r) {
        var a = n(r);
        t.find(".fr-command").each(function () {
          var e = n(this).data("param1");
          n(this).toggleClass("fr-active", a.hasClass(e))
        })
      }
    }
  }),xt.DefineIcon("inputEdit", {NAME: "edit", SVG_KEY: "edit"}),xt.RegisterCommand("inputEdit", {
    title: "Edit Button",
    undo: !1,
    refreshAfterCallback: !1,
    callback: function () {
      this.forms.showUpdatePopup()
    }
  }),xt.DefineIcon("inputBack", {NAME: "arrow-left", SVG_KEY: "back"}),xt.RegisterCommand("inputBack", {
    title: "Back",
    undo: !1,
    focus: !1,
    back: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.forms.back()
    }
  }),xt.RegisterCommand("updateInput", {
    undo: !1, focus: !1, title: "Update", callback: function () {
      this.forms.updateInput()
    }
  }),xt.PLUGINS.fullscreen = function (a) {
    var t, n, r, o, i = a.$, s = function s() {
      return a.$box.hasClass("fr-fullscreen")
    };

    function l() {
      if (a.helpers.isIOS() && a.core.hasFocus()) return a.$el.blur(), setTimeout(d, 250), !1;
      t = a.helpers.scrollTop(), a.$box.toggleClass("fr-fullscreen"), i("body").first().toggleClass("fr-fullscreen"), a.helpers.isMobile() && (a.opts.toolbarBottom ? a.$tb[0].removeAttribute("style") : (a.$tb.data("parent", a.$tb.parent()), a.$box.prepend(a.$tb), a.$tb.data("sticky-dummy") && a.$tb.after(a.$tb.data("sticky-dummy")))), n = a.opts.height, r = a.opts.heightMax, o = a.opts.z_index, a.opts.height = a.o_win.innerHeight - (a.opts.toolbarInline ? 0 : a.$tb.outerHeight() + (a.$second_tb ? a.$second_tb.outerHeight() : 0)), a.opts.zIndex = 2147483641, a.opts.heightMax = null, a.size.refresh(), a.opts.toolbarInline && a.toolbar.showInline();
      for (var e = a.$box.parent(); !e.first().is("body");) e.addClass("fr-fullscreen-wrapper"), e = e.parent();
      a.opts.toolbarContainer && a.$box.prepend(a.$tb), a.events.trigger("charCounter.update"), a.events.trigger("codeView.update"), a.$win.trigger("scroll")
    }

    function c() {
      if (a.helpers.isIOS() && a.core.hasFocus()) return a.$el.blur(), setTimeout(d, 250), !1;
      a.$box.toggleClass("fr-fullscreen"), i("body").first().toggleClass("fr-fullscreen"), a.$tb.data("parent") && a.$tb.data("parent").prepend(a.$tb), a.$tb.data("sticky-dummy") && a.$tb.after(a.$tb.data("sticky-dummy")), a.opts.height = n, a.opts.heightMax = r, a.opts.zIndex = o, a.size.refresh(), i(a.o_win).scrollTop(t), a.opts.toolbarInline && a.toolbar.showInline(), a.events.trigger("charCounter.update"), a.opts.toolbarSticky && a.opts.toolbarStickyOffset && (a.opts.toolbarBottom ? a.$tb.css("bottom", a.opts.toolbarStickyOffset).data("bottom", a.opts.toolbarStickyOffset) : a.$tb.css("top", a.opts.toolbarStickyOffset).data("top", a.opts.toolbarStickyOffset));
      for (var e = a.$box.parent(); !e.first().is("body");) e.removeClass("fr-fullscreen-wrapper"), e = e.parent();
      a.opts.toolbarContainer && i(a.opts.toolbarContainer).append(a.$tb), i(a.o_win).trigger("scroll"), a.events.trigger("codeView.update")
    }

    function d() {
      s() ? c() : l(), f(a.$tb.find('.fr-command[data-cmd="fullscreen"]'));
      var e = a.$tb.find('.fr-command[data-cmd="moreText"]'), t = a.$tb.find('.fr-command[data-cmd="moreParagraph"]'),
        n = a.$tb.find('.fr-command[data-cmd="moreRich"]'), r = a.$tb.find('.fr-command[data-cmd="moreMisc"]');
      e.length && a.refresh.moreText(e), t.length && a.refresh.moreParagraph(t), n.length && a.refresh.moreRich(n), r.length && a.refresh.moreMisc(r)
    }

    function f(e) {
      var t = s();
      e.toggleClass("fr-active", t).attr("aria-pressed", t), e.find("> *").not(".fr-sr-only").replaceWith(t ? a.icon.create("fullscreenCompress") : a.icon.create("fullscreen"))
    }

    return {
      _init: function e() {
        if (!a.$wp) return !1;
        a.events.$on(i(a.o_win), "resize", function () {
          s() && (c(), l())
        }), a.events.on("toolbar.hide", function () {
          if (s() && a.helpers.isMobile()) return !1
        }), a.events.on("position.refresh", function () {
          if (a.helpers.isIOS()) return !s()
        }), a.events.on("destroy", function () {
          s() && c()
        }, !0)
      }, toggle: d, refresh: f, isActive: s
    }
  },xt.RegisterCommand("fullscreen", {
    title: "Fullscreen",
    undo: !1,
    focus: !1,
    accessibilityFocus: !0,
    forcedRefresh: !0,
    toggle: !0,
    callback: function () {
      this.fullscreen.toggle()
    },
    refresh: function (e) {
      this.fullscreen.refresh(e)
    },
    plugin: "fullscreen"
  }),xt.DefineIcon("fullscreen", {
    NAME: "expand",
    SVG_KEY: "fullscreen"
  }),xt.DefineIcon("fullscreenCompress", {NAME: "compress", SVG_KEY: "exitFullscreen"}),Object.assign(xt.DEFAULTS, {
    helpSets: [{title: "Inline Editor", commands: [{val: "OSkeyE", desc: "Show the editor"}]}, {
      title: "Common actions",
      commands: [{val: "OSkeyC", desc: "Copy"}, {val: "OSkeyX", desc: "Cut"}, {
        val: "OSkeyV",
        desc: "Paste"
      }, {val: "OSkeyZ", desc: "Undo"}, {val: "OSkeyShift+Z", desc: "Redo"}, {
        val: "OSkeyK",
        desc: "Insert Link"
      }, {val: "OSkeyP", desc: "Insert Image"}]
    }, {
      title: "Basic Formatting",
      commands: [{val: "OSkeyA", desc: "Select All"}, {val: "OSkeyB", desc: "Bold"}, {
        val: "OSkeyI",
        desc: "Italic"
      }, {val: "OSkeyU", desc: "Underline"}, {val: "OSkeyS", desc: "Strikethrough"}, {
        val: "OSkey]",
        desc: "Increase Indent"
      }, {val: "OSkey[", desc: "Decrease Indent"}]
    }, {
      title: "Quote",
      commands: [{val: "OSkey'", desc: "Increase quote level"}, {val: "OSkeyShift+'", desc: "Decrease quote level"}]
    }, {
      title: "Image / Video",
      commands: [{val: "OSkey+", desc: "Resize larger"}, {val: "OSkey-", desc: "Resize smaller"}]
    }, {
      title: "Table",
      commands: [{val: "Alt+Space", desc: "Select table cell"}, {
        val: "Shift+Left/Right arrow",
        desc: "Extend selection one cell"
      }, {val: "Shift+Up/Down arrow", desc: "Extend selection one row"}]
    }, {
      title: "Navigation",
      commands: [{val: "OSkey/", desc: "Shortcuts"}, {val: "Alt+F10", desc: "Focus popup / toolbar"}, {
        val: "Esc",
        desc: "Return focus to previous position"
      }]
    }]
  }),xt.PLUGINS.help = function (s) {
    var r, a = s.$, o = "help";
    return {
      _init: function e() {
      }, show: function l() {
        if (!r) {
          var e = "<h4>".concat(s.language.translate("Shortcuts"), "</h4>"), t = function i() {
            for (var e = '<div class="fr-help-modal">', t = 0; t < s.opts.helpSets.length; t++) {
              var n = s.opts.helpSets[t], r = "<table>";
              r += "<thead><tr><th>".concat(s.language.translate(n.title), "</th></tr></thead>"), r += "<tbody>";
              for (var a = 0; a < n.commands.length; a++) {
                var o = n.commands[a];
                r += "<tr>", r += "<td>".concat(s.language.translate(o.desc), "</td>"), r += "<td>".concat(o.val.replace("OSkey", s.helpers.isMac() ? "&#8984;" : "Ctrl+"), "</td>"), r += "</tr>"
              }
              e += r += "</tbody></table>"
            }
            return e += "</div>"
          }(), n = s.modals.create(o, e, t);
          r = n.$modal, s.events.$on(a(s.o_win), "resize", function () {
            s.modals.resize(o)
          })
        }
        s.modals.show(o), s.modals.resize(o)
      }, hide: function t() {
        s.modals.hide(o)
      }
    }
  },xt.DefineIcon("help", {
    NAME: "question",
    SVG_KEY: "help"
  }),xt.RegisterShortcut(xt.KEYCODE.SLASH, "help", null, "/"),xt.RegisterCommand("help", {
    title: "Help",
    icon: "help",
    undo: !1,
    focus: !1,
    modal: !0,
    callback: function () {
      this.help.show()
    },
    plugin: "help",
    showOnMobile: !1
  }),Object.assign(xt.POPUP_TEMPLATES, {
    "image.insert": "[_BUTTONS_][_UPLOAD_LAYER_][_BY_URL_LAYER_][_PROGRESS_BAR_]",
    "image.edit": "[_BUTTONS_]",
    "image.alt": "[_BUTTONS_][_ALT_LAYER_]",
    "image.size": "[_BUTTONS_][_SIZE_LAYER_]"
  }),Object.assign(xt.DEFAULTS, {
    imageInsertButtons: ["imageBack", "|", "imageUpload", "imageByURL"],
    imageEditButtons: ["imageReplace", "imageAlign", "imageCaption", "imageRemove", "imageLink", "linkOpen", "linkEdit", "linkRemove", "-", "imageDisplay", "imageStyle", "imageAlt", "imageSize"],
    imageAltButtons: ["imageBack", "|"],
    imageSizeButtons: ["imageBack", "|"],
    imageUpload: !0,
    imageUploadURL: null,
    imageCORSProxy: "https://cors-anywhere.froala.com",
    imageUploadRemoteUrls: !0,
    imageUploadParam: "file",
    imageUploadParams: {},
    imageUploadToS3: !1,
    imageUploadToAzure: !1,
    imageUploadMethod: "POST",
    imageMaxSize: 10485760,
    imageAllowedTypes: ["jpeg", "jpg", "png", "gif", "webp"],
    imageResize: !0,
    imageResizeWithPercent: !1,
    imageRoundPercent: !1,
    imageDefaultWidth: 300,
    imageDefaultAlign: "center",
    imageDefaultDisplay: "block",
    imageSplitHTML: !1,
    imageStyles: {"fr-rounded": "Rounded", "fr-bordered": "Bordered", "fr-shadow": "Shadow"},
    imageMove: !0,
    imageMultipleStyles: !0,
    imageTextNear: !0,
    imagePaste: !0,
    imagePasteProcess: !1,
    imageMinWidth: 16,
    imageOutputSize: !1,
    imageDefaultMargin: 5,
    imageAddNewLine: !1
  }),xt.PLUGINS.image = function (L) {
    var _, l, c, d, s, n, w = L.$, A = "https://i.froala.com/upload", t = !1, r = 1, p = 2, u = 3, h = 4, T = 5, S = 6,
      a = {};

    function f() {
      var e = L.popups.get("image.insert").find(".fr-image-by-url-layer input");
      e.val(""), _ && e.val(_.attr("src")), e.trigger("change")
    }

    function o() {
      var e = L.popups.get("image.edit");
      if (e || (e = M()), e) {
        var t = ye();
        Le() && (t = t.find(".fr-img-wrap")), L.popups.setContainer("image.edit", L.$sc), L.popups.refresh("image.edit");
        var n = t.offset().left + t.outerWidth() / 2, r = (function a(e) {
          for (var t = 0; e;) {
            if ("BODY" == e.tagName) {
              var n = e.scrollTop || document.documentElement.scrollTop;
              t += e.offsetTop - n + e.clientTop
            } else t += e.offsetTop - e.scrollTop + e.clientTop;
            e = e.offsetParent
          }
          return {y: t}
        }(_[0]).y + t.outerHeight()) / 5;
        t.offset().top < 0 || !L.opts.height || L.helpers.isMobile() || L.opts.iframe ? r = t.offset().top + t.outerHeight() : Le() && L.opts.height && (r = t.offset().top + t.outerHeight() / 4), _.hasClass("fr-uploading") ? O() : L.popups.show("image.edit", n, r, t.outerHeight(), !0)
      }
    }

    function g() {
      N()
    }

    function i(e) {
      0 < e.parents(".fr-img-caption").length && (e = e.parents(".fr-img-caption").first());
      var t = e.hasClass("fr-dib") ? "block" : e.hasClass("fr-dii") ? "inline" : null,
        n = e.hasClass("fr-fil") ? "left" : e.hasClass("fr-fir") ? "right" : me(e);
      ge(e, t, n), e.removeClass("fr-dib fr-dii fr-fir fr-fil")
    }

    function m() {
      for (var e, t = "IMG" == L.el.tagName ? [L.el] : L.el.querySelectorAll("img"), n = 0; n < t.length; n++) {
        var r = w(t[n]);
        !L.opts.htmlUntouched && L.opts.useClasses ? ((L.opts.imageDefaultAlign || L.opts.imageDefaultDisplay) && (0 < (e = r).parents(".fr-img-caption").length && (e = e.parents(".fr-img-caption").first()), e.hasClass("fr-dii") || e.hasClass("fr-dib") || (e.addClass("fr-fi".concat(me(e)[0])), e.addClass("fr-di".concat(ve(e)[0])), e.css("margin", ""), e.css("float", ""), e.css("display", ""), e.css("z-index", ""), e.css("position", ""), e.css("overflow", ""), e.css("vertical-align", ""))), L.opts.imageTextNear || (0 < r.parents(".fr-img-caption").length ? r.parents(".fr-img-caption").first().removeClass("fr-dii").addClass("fr-dib") : r.removeClass("fr-dii").addClass("fr-dib"))) : L.opts.htmlUntouched || L.opts.useClasses || (L.opts.imageDefaultAlign || L.opts.imageDefaultDisplay) && i(r), L.opts.iframe && r.on("load", L.size.syncIframe)
      }
    }

    function v(e) {
      void 0 === e && (e = !0);
      var t, n = Array.prototype.slice.call(L.el.querySelectorAll("img")), r = [];
      for (t = 0; t < n.length; t++) if (r.push(n[t].getAttribute("src")), w(n[t]).toggleClass("fr-draggable", L.opts.imageMove), "" === n[t].getAttribute("class") && n[t].removeAttribute("class"), "" === n[t].getAttribute("style") && n[t].removeAttribute("style"), n[t].parentNode && n[t].parentNode.parentNode && L.node.hasClass(n[t].parentNode.parentNode, "fr-img-caption")) {
        var a = n[t].parentNode.parentNode;
        L.browser.mozilla || a.setAttribute("contenteditable", !1), a.setAttribute("draggable", !1), a.classList.add("fr-draggable");
        var o = n[t].nextSibling;
        o && !L.browser.mozilla && o.setAttribute("contenteditable", !0)
      }
      if (s) for (t = 0; t < s.length; t++) r.indexOf(s[t].getAttribute("src")) < 0 && L.events.trigger("image.removed", [w(s[t])]);
      if (s && e) {
        var i = [];
        for (t = 0; t < s.length; t++) i.push(s[t].getAttribute("src"));
        for (t = 0; t < n.length; t++) i.indexOf(n[t].getAttribute("src")) < 0 && L.events.trigger("image.loaded", [w(n[t])])
      }
      s = n
    }

    function k() {
      if (l || function i() {
        var e;
        L.shared.$image_resizer ? (l = L.shared.$image_resizer, d = L.shared.$img_overlay, L.events.on("destroy", function () {
          w("body").first().append(l.removeClass("fr-active"))
        }, !0)) : (L.shared.$image_resizer = w(document.createElement("div")).attr("class", "fr-image-resizer"), l = L.shared.$image_resizer, L.events.$on(l, "mousedown", function (e) {
          e.stopPropagation()
        }, !0), L.opts.imageResize && (l.append(b("nw") + b("ne") + b("sw") + b("se")), L.shared.$img_overlay = w(document.createElement("div")).attr("class", "fr-image-overlay"), d = L.shared.$img_overlay, e = l.get(0).ownerDocument, w(e).find("body").first().append(d)));
        L.events.on("shared.destroy", function () {
          l.html("").removeData().remove(), l = null, L.opts.imageResize && (d.remove(), d = null)
        }, !0), L.helpers.isMobile() || L.events.$on(w(L.o_win), "resize", function () {
          _ && !_.hasClass("fr-uploading") ? fe(!0) : _ && (k(), be(), O(!1))
        });
        if (L.opts.imageResize) {
          e = l.get(0).ownerDocument, L.events.$on(l, L._mousedown, ".fr-handler", E), L.events.$on(w(e), L._mousemove, y), L.events.$on(w(e.defaultView || e.parentWindow), L._mouseup, x), L.events.$on(d, "mouseleave", x);
          var r = 1, a = null, o = 0;
          L.events.on("keydown", function (e) {
            if (_) {
              var t = -1 != navigator.userAgent.indexOf("Mac OS X") ? e.metaKey : e.ctrlKey, n = e.which;
              (n !== a || 200 < e.timeStamp - o) && (r = 1), (n == xt.KEYCODE.EQUALS || L.browser.mozilla && n == xt.KEYCODE.FF_EQUALS) && t && !e.altKey ? r = ee.call(this, e, 1, 1, r) : (n == xt.KEYCODE.HYPHEN || L.browser.mozilla && n == xt.KEYCODE.FF_HYPHEN) && t && !e.altKey ? r = ee.call(this, e, 2, -1, r) : L.keys.ctrlKey(e) || n != xt.KEYCODE.ENTER || (_.before("<br>"), B(_)), a = n, o = e.timeStamp
            }
          }, !0), L.events.on("keyup", function () {
            r = 1
          })
        }
      }(), !_) return !1;
      var e = L.$wp || L.$sc;
      e.append(l), l.data("instance", L);
      var t = e.scrollTop() - ("static" != e.css("position") ? e.offset().top : 0),
        n = e.scrollLeft() - ("static" != e.css("position") ? e.offset().left : 0);
      n -= L.helpers.getPX(e.css("border-left-width")), t -= L.helpers.getPX(e.css("border-top-width")), L.$el.is("img") && L.$sc.is("body") && (n = t = 0);
      var r = ye();
      Le() && (r = r.find(".fr-img-wrap"));
      var a = 0, o = 0;
      L.opts.iframe && (a = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-top")), o = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-left"))), l.css("top", (L.opts.iframe ? r.offset().top + a : r.offset().top + t) - 1).css("left", (L.opts.iframe ? r.offset().left + o : r.offset().left + n) - 1).css("width", r.get(0).getBoundingClientRect().width).css("height", r.get(0).getBoundingClientRect().height).addClass("fr-active")
    }

    function b(e) {
      return '<div class="fr-handler fr-h'.concat(e, '"></div>')
    }

    function C(e) {
      Le() ? _.parents(".fr-img-caption").css("width", e) : _.css("width", e)
    }

    function E(e) {
      if (!L.core.sameInstance(l)) return !0;
      if (e.preventDefault(), e.stopPropagation(), L.$el.find("img.fr-error").left) return !1;
      L.undo.canDo() || L.undo.saveStep();
      var t = e.pageX || e.originalEvent.touches[0].pageX;
      if ("mousedown" == e.type) {
        var n = L.$oel.get(0).ownerDocument, r = n.defaultView || n.parentWindow, a = !1;
        try {
          a = r.location != r.parent.location && !(r.$ && r.$.FE)
        } catch (s) {
        }
        a && r.frameElement && (t += L.helpers.getPX(w(r.frameElement).offset().left) + r.frameElement.clientLeft)
      }
      (c = w(this)).data("start-x", t), c.data("start-width", _.width()), c.data("start-height", _.height());
      var o = _.width();
      if (L.opts.imageResizeWithPercent) {
        var i = _.parentsUntil(L.$el, L.html.blockTagsQuery()).get(0) || L.el;
        o = (o / w(i).outerWidth() * 100).toFixed(2) + "%"
      }
      C(o), d.show(), L.popups.hideAll(), he()
    }

    function y(e) {
      if (!L.core.sameInstance(l)) return !0;
      var t;
      if (c && _) {
        if (e.preventDefault(), L.$el.find("img.fr-error").left) return !1;
        var n = e.pageX || (e.originalEvent.touches ? e.originalEvent.touches[0].pageX : null);
        if (!n) return !1;
        var r = n - c.data("start-x"), a = c.data("start-width");
        if ((c.hasClass("fr-hnw") || c.hasClass("fr-hsw")) && (r = 0 - r), L.opts.imageResizeWithPercent) {
          var o = _.parentsUntil(L.$el, L.html.blockTagsQuery()).get(0) || L.el;
          a = ((a + r) / w(o).outerWidth() * 100).toFixed(2), L.opts.imageRoundPercent && (a = Math.round(a)), C("".concat(a, "%")), (t = Le() ? (L.helpers.getPX(_.parents(".fr-img-caption").css("width")) / w(o).outerWidth() * 100).toFixed(2) : (L.helpers.getPX(_.css("width")) / w(o).outerWidth() * 100).toFixed(2)) === a || L.opts.imageRoundPercent || C("".concat(t, "%")), _.css("height", "").removeAttr("height")
        } else a + r >= L.opts.imageMinWidth && (C(a + r), t = Le() ? L.helpers.getPX(_.parents(".fr-img-caption").css("width")) : L.helpers.getPX(_.css("width"))), t !== a + r && C(t), ((_.attr("style") || "").match(/(^height:)|(; *height:)/) || _.attr("height")) && (_.css("height", c.data("start-height") * _.width() / c.data("start-width")), _.removeAttr("height"));
        k(), L.events.trigger("image.resize", [Ee()])
      }
    }

    function x(e) {
      if (!L.core.sameInstance(l)) return !0;
      if (c && _) {
        if (e && e.stopPropagation(), L.$el.find("img.fr-error").left) return !1;
        c = null, d.hide(), k(), o(), L.undo.saveStep(), L.events.trigger("image.resizeEnd", [Ee()])
      } else l.removeClass("fr-active")
    }

    function R(e, t, n) {
      L.edit.on(), _ && _.addClass("fr-error"), a[e] ? D(L.language.translate(a[e])) : D(L.language.translate("Something went wrong. Please try again.")), !_ && n && te(n), L.events.trigger("image.error", [{
        code: e,
        message: a[e]
      }, t, n])
    }

    function M(e) {
      if (e) return L.$wp && L.events.$on(L.$wp, "scroll.image-edit", function () {
        _ && L.popups.isVisible("image.edit") && (L.events.disableBlur(), o())
      }), !0;
      var t = "";
      if (0 < L.opts.imageEditButtons.length) {
        var n = {buttons: t += '<div class="fr-buttons">\n        '.concat(L.button.buildList(L.opts.imageEditButtons), "\n        </div>")};
        return L.popups.create("image.edit", n)
      }
      return !1
    }

    function O(e) {
      var t = L.popups.get("image.insert");
      if (t || (t = Y()), t.find(".fr-layer.fr-active").removeClass("fr-active").addClass("fr-pactive"), t.find(".fr-image-progress-bar-layer").addClass("fr-active"), t.find(".fr-buttons").hide(), _) {
        var n = ye();
        L.popups.setContainer("image.insert", L.$sc);
        var r = n.offset().left, a = n.offset().top + n.height();
        L.popups.show("image.insert", r, a, n.outerHeight())
      }
      void 0 === e && I(L.language.translate("Uploading"), 0)
    }

    function N(e) {
      var t = L.popups.get("image.insert");
      if (t && (t.find(".fr-layer.fr-pactive").addClass("fr-active").removeClass("fr-pactive"), t.find(".fr-image-progress-bar-layer").removeClass("fr-active"), t.find(".fr-buttons").show(), e || L.$el.find("img.fr-error").length)) {
        if (L.events.focus(), L.$el.find("img.fr-error").length && (L.$el.find("img.fr-error").remove(), L.undo.saveStep(), L.undo.run(), L.undo.dropRedo()), !L.$wp && _) {
          var n = _;
          fe(!0), L.selection.setAfter(n.get(0)), L.selection.restore()
        }
        L.popups.hide("image.insert")
      }
    }

    function I(e, t) {
      var n = L.popups.get("image.insert");
      if (n) {
        var r = n.find(".fr-image-progress-bar-layer");
        r.find("h3").text(e + (t ? " ".concat(t, "%") : "")), r.removeClass("fr-error"), t ? (r.find("div").removeClass("fr-indeterminate"), r.find("div > span").css("width", "".concat(t, "%"))) : r.find("div").addClass("fr-indeterminate")
      }
    }

    function D(e) {
      O();
      var t = L.popups.get("image.insert").find(".fr-image-progress-bar-layer");
      t.addClass("fr-error");
      var n = t.find("h3");
      n.text(e), L.events.disableBlur(), n.focus()
    }

    function B(e) {
      de.call(e.get(0))
    }

    function H() {
      var e = w(this);
      L.popups.hide("image.insert"), e.removeClass("fr-uploading"), e.next().is("br") && e.next().remove(), B(e), L.events.trigger("image.loaded", [e])
    }

    function $(i, e, s, l, c) {
      l && "string" == typeof l && (l = L.$(l)), L.edit.off(), I(L.language.translate("Loading image")), e && (i = L.helpers.sanitizeURL(i));
      var t = new Image;
      t.onload = function () {
        var e, t;
        if (l) {
          L.undo.canDo() || l.hasClass("fr-uploading") || L.undo.saveStep();
          var n = l.data("fr-old-src");
          l.data("fr-image-pasted") && (n = null), L.$wp ? ((e = l.clone().removeData("fr-old-src").removeClass("fr-uploading").removeAttr("data-fr-image-pasted")).off("load"), n && l.attr("src", n), !L.opts.trackChangesEnabled || l[0].parentNode && "SPAN" === l[0].parentNode.tagName && l[0].parentNode.hasAttribute("data-tracking") || L.track_changes.replaceSpecialItem(l), l.replaceWith(e)) : e = l;
          for (var r = e.get(0).attributes, a = 0; a < r.length; a++) {
            var o = r[a];
            0 === o.nodeName.indexOf("data-") ? e.removeAttr(o.nodeName) : s && s.hasOwnProperty(o.nodeName) && e.removeAttr(o.nodeName)
          }
          if (void 0 !== s) for (t in s) s.hasOwnProperty(t) && "link" != t && e.attr("".concat(t), s[t]);
          e.on("load", H), e.attr("src", i), L.edit.on(), v(!1), L.undo.saveStep(), L.events.disableBlur(), L.$el.blur(), L.events.trigger(n ? "image.replaced" : "image.inserted", [e, c])
        } else (e = z(i, s, H)) && (v(!1), L.undo.saveStep(), L.events.disableBlur(), L.$el.blur(), L.events.trigger("image.inserted", [e, c]))
      }, t.onerror = function () {
        R(r)
      }, O(L.language.translate("Loading image")), t.src = i
    }

    function F(e, t, n) {
      I(L.language.translate("Loading image"));
      var r = this.status, a = this.response, o = this.responseXML, i = this.responseText;
      try {
        if (L.opts.imageUploadToS3 || L.opts.imageUploadToAzure) if (201 == r) {
          var s;
          if (L.opts.imageUploadToAzure) {
            if (!1 === L.events.trigger("image.uploadedToAzure", [this.responseURL, n, a], !0)) return L.edit.on(), !1;
            s = t
          } else s = function c(e) {
            try {
              var t = w(e).find("Location").text(), n = w(e).find("Key").text();
              return !1 === L.events.trigger("image.uploadedToS3", [t, n, e], !0) ? (L.edit.on(), !1) : t
            } catch (r) {
              return R(h, e), !1
            }
          }(o);
          s && $(s, !1, [], e, a || o)
        } else R(h, a || o, e); else if (200 <= r && r < 300) {
          var l = function d(e) {
            try {
              if (!1 === L.events.trigger("image.uploaded", [e], !0)) return L.edit.on(), !1;
              var t = JSON.parse(e);
              return t.link ? t : (R(p, e), !1)
            } catch (n) {
              return R(h, e), !1
            }
          }(i);
          l && $(l.link, !1, l, e, a || i)
        } else R(u, a || i, e)
      } catch (f) {
        R(h, a || i, e)
      }
    }

    function P() {
      R(h, this.response || this.responseText || this.responseXML)
    }

    function U(e) {
      if (e.lengthComputable) {
        var t = e.loaded / e.total * 100 | 0;
        I(L.language.translate("Uploading"), t)
      }
    }

    function z(e, t, n) {
      var r, a = w(document.createElement("img")).attr("src", e);
      if (t && void 0 !== t) for (r in t) t.hasOwnProperty(r) && "link" != r && (" data-".concat(r, '="').concat(t[r], '"'), a.attr("".concat(r), t[r]));
      var o = L.opts.imageDefaultWidth;
      o && "auto" != o && (o = L.opts.imageResizeWithPercent ? "100%" : "".concat(o, "px")), a.attr("style", o ? "width: ".concat(o, ";") : ""), ge(a, L.opts.imageDefaultDisplay, L.opts.imageDefaultAlign), a.on("load", n), a.on("error", n), L.edit.on(), L.events.focus(!0), L.selection.restore(), L.undo.saveStep(), L.opts.imageSplitHTML ? L.markers.split() : L.markers.insert(), L.html.wrap();
      var i = L.$el.find(".fr-marker");
      if (i.length) i.parent().is("hr") && i.parent().after(i), L.node.isLastSibling(i) && i.parent().hasClass("fr-deletable") && i.insertAfter(i.parent()), i.replaceWith(a); else {
        if (L.opts.trackChangesEnabled) return N(!0), !1;
        L.$el.append(a)
      }
      return L.selection.clear(), a
    }

    function K() {
      L.edit.on(), N(!0)
    }

    function V(e, t) {
      if (void 0 !== e && 0 < e.length) {
        if (e && "image/svg+xml" == e[0].type) {
          var n = new FileReader;
          n.onload = function (e) {
            var t = e.target.result;
            L.image.insert(t, null, null, L.image.get())
          }, n.readAsDataURL(e[0])
        }
        if (!1 === L.events.trigger("image.beforeUpload", [e, t])) return !1;
        var r, a = e[0];
        if (!(null !== L.opts.imageUploadURL && L.opts.imageUploadURL != A || L.opts.imageUploadToS3 || L.opts.imageUploadToAzure)) return function E(a, o) {
          var i = new FileReader;
          i.onload = function () {
            var e = i.result;
            if (i.result.indexOf("svg+xml") < 0) {
              for (var t = atob(i.result.split(",")[1]), n = [], r = 0; r < t.length; r++) n.push(t.charCodeAt(r));
              e = window.URL.createObjectURL(new Blob([new Uint8Array(n)], {type: a.type})), o && o.data("fr-old-src", o.attr("src")), L.image.insert(e, !1, null, o)
            }
          }, O(), i.readAsDataURL(a)
        }(a, t || _), !1;
        if (a.name || (a.name = (new Date).getTime() + "." + (a.type || "image/jpeg").replace(/image\//g, "")), a.size > L.opts.imageMaxSize) return R(T), !1;
        if (L.opts.imageAllowedTypes.indexOf(a.type.replace(/image\//g, "")) < 0) return R(S), !1;
        if (L.drag_support.formdata && (r = L.drag_support.formdata ? new FormData : null), r) {
          var o;
          if (!1 !== L.opts.imageUploadToS3) for (o in r.append("key", L.opts.imageUploadToS3.keyStart + (new Date).getTime() + "-" + (a.name || "untitled")), r.append("success_action_status", "201"), r.append("X-Requested-With", "xhr"), r.append("Content-Type", a.type), L.opts.imageUploadToS3.params) L.opts.imageUploadToS3.params.hasOwnProperty(o) && r.append(o, L.opts.imageUploadToS3.params[o]);
          for (o in L.opts.imageUploadParams) L.opts.imageUploadParams.hasOwnProperty(o) && r.append(o, L.opts.imageUploadParams[o]);
          r.append(L.opts.imageUploadParam, a, a.name);
          var i, s, l = L.opts.imageUploadURL, c = L.opts.imageUploadMethod;
          L.opts.imageUploadToS3 && (l = L.opts.imageUploadToS3.uploadURL ? L.opts.imageUploadToS3.uploadURL : "https://".concat(L.opts.imageUploadToS3.region, ".amazonaws.com/").concat(L.opts.imageUploadToS3.bucket)), L.opts.imageUploadToAzure && (i = l = L.opts.imageUploadToAzure.uploadURL ? "".concat(L.opts.imageUploadToAzure.uploadURL, "/").concat(a.name) : encodeURI("https://".concat(L.opts.imageUploadToAzure.account, ".blob.core.windows.net/").concat(L.opts.imageUploadToAzure.container, "/").concat(a.name)), L.opts.imageUploadToAzure.SASToken && (l += L.opts.imageUploadToAzure.SASToken), c = "PUT");
          var d = L.core.getXHR(l, c);
          if (L.opts.imageUploadToAzure) {
            var f = (new Date).toUTCString();
            if (!L.opts.imageUploadToAzure.SASToken && L.opts.imageUploadToAzure.accessKey) {
              var p = L.opts.imageUploadToAzure.account, u = L.opts.imageUploadToAzure.container;
              if (L.opts.imageUploadToAzure.uploadURL) {
                var h = L.opts.imageUploadToAzure.uploadURL.split("/");
                u = h.pop(), p = h.pop().split(".")[0]
              }
              var g = "x-ms-blob-type:BlockBlob\nx-ms-date:".concat(f, "\nx-ms-version:2019-07-07"),
                m = encodeURI("/" + p + "/" + u + "/" + a.name),
                v = c + "\n\n\n" + a.size + "\n\n" + a.type + "\n\n\n\n\n\n\n" + g + "\n" + m,
                b = L.cryptoJSPlugin.cryptoJS.HmacSHA256(v, L.cryptoJSPlugin.cryptoJS.enc.Base64.parse(L.opts.imageUploadToAzure.accessKey)).toString(L.cryptoJSPlugin.cryptoJS.enc.Base64),
                C = "SharedKey " + p + ":" + b;
              s = b, d.setRequestHeader("Authorization", C)
            }
            for (o in d.setRequestHeader("x-ms-version", "2019-07-07"), d.setRequestHeader("x-ms-date", f), d.setRequestHeader("Content-Type", a.type), d.setRequestHeader("x-ms-blob-type", "BlockBlob"), L.opts.imageUploadParams) L.opts.imageUploadParams.hasOwnProperty(o) && d.setRequestHeader(o, L.opts.imageUploadParams[o]);
            for (o in L.opts.imageUploadToAzure.params) L.opts.imageUploadToAzure.params.hasOwnProperty(o) && d.setRequestHeader(o, L.opts.imageUploadToAzure.params[o])
          }
          !function y(t, n, r, a, o, i) {
            function s() {
              var e = w(this);
              e.off("load"), e.addClass("fr-uploading"), e.next().is("br") && e.next().remove(), L.placeholder.refresh(), B(e), k(), O(), L.edit.off(), t.onload = function () {
                F.call(t, e, o, i)
              }, t.onerror = P, t.upload.onprogress = U, t.onabort = K, w(e.off("abortUpload")).on("abortUpload", function () {
                4 != t.readyState && (t.abort(), a ? (a.attr("src", a.data("fr-old-src")), a.removeClass("fr-uploading")) : e.remove(), fe(!0))
              }), t.send(L.opts.imageUploadToAzure ? r : n)
            }

            var l = new FileReader;
            l.onload = function () {
              var e = l.result;
              if (l.result.indexOf("svg+xml") < 0) {
                for (var t = atob(l.result.split(",")[1]), n = [], r = 0; r < t.length; r++) n.push(t.charCodeAt(r));
                e = window.URL.createObjectURL(new Blob([new Uint8Array(n)], {type: "image/jpeg"}))
              }
              a ? (a.on("load", s), a.on("error", function () {
                s(), w(this).off("error")
              }), L.edit.on(), L.undo.saveStep(), a.data("fr-old-src", a.attr("src")), a.attr("src", e)) : z(e, null, s)
            }, l.readAsDataURL(r)
          }(d, r, a, t || _, i, s)
        }
      }
    }

    function W(e) {
      if (e.is("img") && 0 < e.parents(".fr-img-caption").length) return e.parents(".fr-img-caption")
    }

    function G(e) {
      var t = e.originalEvent.dataTransfer;
      if (t && t.files && t.files.length) {
        var n = t.files[0];
        if (n && n.type && -1 !== n.type.indexOf("image") && 0 <= L.opts.imageAllowedTypes.indexOf(n.type.replace(/image\//g, ""))) {
          if (!L.opts.imageUpload) return e.preventDefault(), e.stopPropagation(), !1;
          L.markers.remove(), L.markers.insertAtPoint(e.originalEvent), L.$el.find(".fr-marker").replaceWith(xt.MARKERS), 0 === L.$el.find(".fr-marker").length && L.selection.setAtEnd(L.el), L.popups.hideAll();
          var r = L.popups.get("image.insert");
          r || (r = Y()), L.popups.setContainer("image.insert", L.$sc);
          var a = e.originalEvent.pageX, o = e.originalEvent.pageY;
          if (L.opts.iframe) {
            var i = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-top")),
              s = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-left"));
            o += L.$iframe.offset().top + i, a += L.$iframe.offset().left + s
          }
          return L.popups.show("image.insert", a, o), O(), 0 <= L.opts.imageAllowedTypes.indexOf(n.type.replace(/image\//g, "")) ? (fe(!0), V(t.files)) : R(S), e.preventDefault(), e.stopPropagation(), !1
        }
      }
    }

    function Y(e) {
      if (e) return L.popups.onRefresh("image.insert", f), L.popups.onHide("image.insert", g), !0;
      var t, n, r = "";
      L.opts.imageUpload || -1 === L.opts.imageInsertButtons.indexOf("imageUpload") || L.opts.imageInsertButtons.splice(L.opts.imageInsertButtons.indexOf("imageUpload"), 1);
      var a = L.button.buildList(L.opts.imageInsertButtons);
      "" !== a && (r = '<div class="fr-buttons fr-tabs">'.concat(a, "</div>"));
      var o = L.opts.imageInsertButtons.indexOf("imageUpload"), i = L.opts.imageInsertButtons.indexOf("imageByURL"),
        s = "";
      0 <= o && (t = " fr-active", 0 <= i && i < o && (t = ""), s = '<div class="fr-image-upload-layer'.concat(t, ' fr-layer" id="fr-image-upload-layer-').concat(L.id, '"><strong>').concat(L.language.translate("Drop image"), "</strong><br>(").concat(L.language.translate("or click"), ')<div class="fr-form"><input type="file" accept="image/').concat(L.opts.imageAllowedTypes.join(", image/").toLowerCase(), '" tabIndex="-1" aria-labelledby="fr-image-upload-layer-').concat(L.id, '" role="button"></div></div>'));
      var l = "";
      0 <= i && (t = " fr-active", 0 <= o && o < i && (t = ""), l = '<div class="fr-image-by-url-layer'.concat(t, ' fr-layer" id="fr-image-by-url-layer-').concat(L.id, '"><div class="fr-input-line"><input id="fr-image-by-url-layer-text-').concat(L.id, '" type="text" placeholder="http://" tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageInsertByURL" tabIndex="2" role="button">').concat(L.language.translate("Insert"), "</button></div></div>"));
      var c = {
        buttons: r,
        upload_layer: s,
        by_url_layer: l,
        progress_bar: '<div class="fr-image-progress-bar-layer fr-layer"><h3 tabIndex="-1" class="fr-message">Uploading</h3><div class="fr-loader"><span class="fr-progress"></span></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-dismiss" data-cmd="imageDismissError" tabIndex="2" role="button">OK</button></div></div>'
      };
      return 1 <= L.opts.imageInsertButtons.length && (n = L.popups.create("image.insert", c)), L.$wp && L.events.$on(L.$wp, "scroll", function () {
        _ && L.popups.isVisible("image.insert") && be()
      }), function d(r) {
        L.events.$on(r, "dragover dragenter", ".fr-image-upload-layer", function (e) {
          return w(this).addClass("fr-drop"), (L.browser.msie || L.browser.edge) && e.preventDefault(), !1
        }, !0), L.events.$on(r, "dragleave dragend", ".fr-image-upload-layer", function (e) {
          return w(this).removeClass("fr-drop"), (L.browser.msie || L.browser.edge) && e.preventDefault(), !1
        }, !0), L.events.$on(r, "drop", ".fr-image-upload-layer", function (e) {
          e.preventDefault(), e.stopPropagation(), w(this).removeClass("fr-drop");
          var t = e.originalEvent.dataTransfer;
          if (t && t.files) {
            var n = r.data("instance") || L;
            n.events.disableBlur(), n.image.upload(t.files), n.events.enableBlur()
          }
        }, !0), L.helpers.isIOS() && L.events.$on(r, "touchstart", '.fr-image-upload-layer input[type="file"]', function () {
          w(this).trigger("click")
        }, !0), L.events.$on(r, "change", '.fr-image-upload-layer input[type="file"]', function () {
          if (this.files) {
            var e = r.data("instance") || L;
            e.events.disableBlur(), r.find("input:focus").blur(), e.events.enableBlur(), e.image.upload(this.files, _)
          }
          w(this).val("")
        }, !0)
      }(n), n
    }

    function j() {
      _ && L.popups.get("image.alt").find("input").val(_.attr("alt") || "").trigger("change")
    }

    function q() {
      var e = L.popups.get("image.alt");
      e || (e = Z()), N(), L.popups.refresh("image.alt"), L.popups.setContainer("image.alt", L.$sc);
      var t = ye();
      Le() && (t = t.find(".fr-img-wrap"));
      var n = t.offset().left + t.outerWidth() / 2, r = t.offset().top + t.outerHeight();
      L.popups.show("image.alt", n, r, t.outerHeight(), !0)
    }

    function Z(e) {
      if (e) return L.popups.onRefresh("image.alt", j), !0;
      var t = {
        buttons: '<div class="fr-buttons fr-tabs">'.concat(L.button.buildList(L.opts.imageAltButtons), "</div>"),
        alt_layer: '<div class="fr-image-alt-layer fr-layer fr-active" id="fr-image-alt-layer-'.concat(L.id, '"><div class="fr-input-line"><input id="fr-image-alt-layer-text-').concat(L.id, '" type="text" placeholder="').concat(L.language.translate("Alternative Text"), '" tabIndex="1"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageSetAlt" tabIndex="2" role="button">').concat(L.language.translate("Update"), "</button></div></div>")
      }, n = L.popups.create("image.alt", t);
      return L.$wp && L.events.$on(L.$wp, "scroll.image-alt", function () {
        _ && L.popups.isVisible("image.alt") && q()
      }), n
    }

    function X() {
      var e = L.popups.get("image.size"), t = _.get(0).style.height ? _.get(0).style.height : "auto",
        n = _.get(0).style.width ? _.get(0).style.width : "auto";
      if (_) if (Le()) {
        var r = _.parent();
        r.get(0).style.width || (r = _.parent().parent()), e.find('input[name="width"]').val(n).trigger("change"), e.find('input[name="height"]').val(t).trigger("change")
      } else e.find('input[name="width"]').val(n).trigger("change"), e.find('input[name="height"]').val(t).trigger("change")
    }

    function Q() {
      var e = L.popups.get("image.size");
      e || (e = J()), N(), L.popups.refresh("image.size"), L.popups.setContainer("image.size", L.$sc);
      var t = ye();
      Le() && (t = t.find(".fr-img-wrap"));
      var n = t.offset().left + t.outerWidth() / 2, r = t.offset().top + t.outerHeight();
      L.popups.show("image.size", n, r, t.outerHeight(), !0)
    }

    function J(e) {
      if (e) return L.popups.onRefresh("image.size", X), !0;
      var t = {
        buttons: '<div class="fr-buttons fr-tabs">'.concat(L.button.buildList(L.opts.imageSizeButtons), "</div>"),
        size_layer: '<div class="fr-image-size-layer fr-layer fr-active" id="fr-image-size-layer-'.concat(L.id, '"><div class="fr-image-group"><div class="fr-input-line"><input id="fr-image-size-layer-width-\'').concat(L.id, '" type="text" name="width" placeholder="').concat(L.language.translate("Width"), '" tabIndex="1"></div><div class="fr-input-line"><input id="fr-image-size-layer-height').concat(L.id, '" type="text" name="height" placeholder="').concat(L.language.translate("Height"), '" tabIndex="1"></div></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageSetSize" tabIndex="2" role="button">').concat(L.language.translate("Update"), "</button></div></div>")
      }, n = L.popups.create("image.size", t);
      return L.$wp && L.events.$on(L.$wp, "scroll.image-size", function () {
        _ && L.popups.isVisible("image.size") && Q()
      }), n
    }

    function ee(e, t, n, r) {
      return e.pageX = t, E.call(this, e), e.pageX = e.pageX + n * Math.floor(Math.pow(1.1, r)), y.call(this, e), x.call(this, e), ++r
    }

    function te(e) {
      if (e = e || ye(), L.opts.trackChangesEnabled && !L.helpers.isMobile() && (!e[0].parentNode || "SPAN" !== e[0].parentNode.tagName || !e[0].parentNode.hasAttribute("data-tracking"))) return L.track_changes.removeSpecialItem(e), L.popups.hideAll(), void fe(!0);
      e && !1 !== L.events.trigger("image.beforeRemove", [e]) && (L.popups.hideAll(), Ce(), fe(!0), L.undo.canDo() || L.undo.saveStep(), e.get(0) == L.el ? e.removeAttr("src") : (e.get(0).parentNode && "A" == e.get(0).parentNode.tagName ? (L.selection.setBefore(e.get(0).parentNode) || L.selection.setAfter(e.get(0).parentNode) || e.parent().after(xt.MARKERS), w(e.get(0).parentNode).remove()) : (L.selection.setBefore(e.get(0)) || L.selection.setAfter(e.get(0)) || e.after(xt.MARKERS), e.remove()), L.html.fillEmptyBlocks(), L.selection.restore()), L.undo.saveStep())
    }

    function ne(e) {
      var t = e.which;
      if (_ && (t == xt.KEYCODE.BACKSPACE || t == xt.KEYCODE.DELETE)) return e.preventDefault(), e.stopPropagation(), te(), !1;
      if (_ && t == xt.KEYCODE.ESC) {
        var n = _;
        return fe(!0), L.selection.setAfter(n.get(0)), L.selection.restore(), e.preventDefault(), !1
      }
      if (!_ || t != xt.KEYCODE.ARROW_LEFT && t != xt.KEYCODE.ARROW_RIGHT) return _ && t === xt.KEYCODE.TAB ? (e.preventDefault(), e.stopPropagation(), fe(!0), !1) : _ && t != xt.KEYCODE.F10 && !L.keys.isBrowserAction(e) ? (e.preventDefault(), e.stopPropagation(), !1) : void 0;
      var r = _.get(0);
      return fe(!0), t == xt.KEYCODE.ARROW_LEFT ? L.selection.setBefore(r) : L.selection.setAfter(r), L.selection.restore(), e.preventDefault(), !1
    }

    function re(e) {
      if (e && "IMG" == e.tagName) {
        if (L.node.hasClass(e, "fr-uploading") || L.node.hasClass(e, "fr-error") ? e.parentNode.removeChild(e) : L.node.hasClass(e, "fr-draggable") && e.classList.remove("fr-draggable"), e.parentNode && e.parentNode.parentNode && L.node.hasClass(e.parentNode.parentNode, "fr-img-caption")) {
          var t = e.parentNode.parentNode;
          t.removeAttribute("contenteditable"), t.removeAttribute("draggable"), t.classList.remove("fr-draggable");
          var n = e.nextSibling;
          n && n.removeAttribute("contenteditable")
        }
      } else if (e && e.nodeType == Node.ELEMENT_NODE) for (var r = e.querySelectorAll("img.fr-uploading, img.fr-error, img.fr-draggable"), a = 0; a < r.length; a++) re(r[a])
    }

    function ae(e) {
      if (!1 === L.events.trigger("image.beforePasteUpload", [e])) return !1;
      _ = w(e), k(), o(), be(), O(), _.on("load", function () {
        var t = [];
        k(), w(L.popups.get("image.insert").get(0)).find("div.fr-active.fr-error").length < 1 && O(), w(this).data("events").filter(function (e) {
          "load" === e[0] && t.push(e)
        }), t.length <= 1 && w(this).off("load")
      });
      for (var t = w(e).attr("src").split(","), n = atob(t[1]), r = [], a = 0; a < n.length; a++) r.push(n.charCodeAt(a));
      V([new Blob([new Uint8Array(r)], {type: t[0].replace(/data\:/g, "").replace(/;base64/g, "")})], _)
    }

    function oe() {
      L.opts.imagePaste ? L.$el.find("img[data-fr-image-pasted]").each(function (e, r) {
        if (L.opts.imagePasteProcess) {
          var t = L.opts.imageDefaultWidth;
          t && "auto" != t && (t += L.opts.imageResizeWithPercent ? "%" : "px"), w(r).css("width", t).removeClass("fr-dii fr-dib fr-fir fr-fil"), ge(w(r), L.opts.imageDefaultDisplay, L.opts.imageDefaultAlign)
        }
        if (0 === r.src.indexOf("data:")) ae(r); else if (0 === r.src.indexOf("blob:") || 0 === r.src.indexOf("http") && L.opts.imageUploadRemoteUrls && L.opts.imageCORSProxy) {
          var n = new Image;
          n.crossOrigin = "Anonymous", n.onload = function () {
            var e, t = L.o_doc.createElement("CANVAS"), n = t.getContext("2d");
            t.height = this.naturalHeight, t.width = this.naturalWidth, n.drawImage(this, 0, 0), setTimeout(function () {
              ae(r)
            }, 0), e = 2e3 < this.naturalWidth || 1500 < this.naturalHeight ? "jpeg" : "png", r.src = t.toDataURL("image/".concat(e))
          }, n.src = (0 === r.src.indexOf("blob:") ? "" : "".concat(L.opts.imageCORSProxy, "/")) + r.src
        } else 0 !== r.src.indexOf("http") || 0 === r.src.indexOf("https://mail.google.com/mail") ? (L.selection.save(), w(r).remove(), L.selection.restore()) : w(r).removeAttr("data-fr-image-pasted")
      }) : L.$el.find("img[data-fr-image-pasted]").remove()
    }

    function ie(e) {
      var t = e.target.result, n = L.opts.imageDefaultWidth;
      n && "auto" != n && (n += L.opts.imageResizeWithPercent ? "%" : "px"), L.undo.saveStep(), L.html.insert('<img data-fr-image-pasted="true" src="'.concat(t, '"').concat(n ? ' style="width: '.concat(n, ';"') : "", ">"));
      var r = L.$el.find('img[data-fr-image-pasted="true"]');
      r && ge(r, L.opts.imageDefaultDisplay, L.opts.imageDefaultAlign), L.events.trigger("paste.after")
    }

    function se(e, t) {
      var n = new FileReader;
      n.onload = function r(e) {
        var t = L.opts.imageDefaultWidth;
        t && "auto" != t && (t += L.opts.imageResizeWithPercent ? "%" : "px"), L.html.insert('<img data-fr-image-pasted="true" src="'.concat(e, '"').concat(t ? ' style="width: '.concat(t, ';"') : "", ">"));
        var n = L.$el.find('img[data-fr-image-pasted="true"]');
        n && ge(n, L.opts.imageDefaultDisplay, L.opts.imageDefaultAlign), L.events.trigger("paste.after")
      }(t), n.readAsDataURL(e, t)
    }

    function le(e) {
      if (e && e.clipboardData && e.clipboardData.items) {
        var t = (e.clipboardData || window.clipboardData).getData("text/html") || "",
          n = (new DOMParser).parseFromString(t, "text/html").querySelector("img");
        if (n) {
          if (!n) return !1;
          var r = n.src, a = null;
          if (e.clipboardData.types && -1 != [].indexOf.call(e.clipboardData.types, "text/rtf") || e.clipboardData.getData("text/rtf")) a = e.clipboardData.items[0].getAsFile(); else for (var o = 0; o < e.clipboardData.items.length && !(a = e.clipboardData.items[o].getAsFile()); o++) ;
          if (a) return se(a, r), !1
        } else {
          var i = null;
          if (e.clipboardData.types && -1 != [].indexOf.call(e.clipboardData.types, "text/rtf") || e.clipboardData.getData("text/rtf")) i = e.clipboardData.items[0].getAsFile(); else for (var s = 0; s < e.clipboardData.items.length && !(i = e.clipboardData.items[s].getAsFile()); s++) ;
          if (i) return function l(e) {
            var t = new FileReader;
            t.onload = ie, t.readAsDataURL(e)
          }(i), !1
        }
      }
    }

    function ce(e) {
      return e = e.replace(/<img /gi, '<img data-fr-image-pasted="true" ')
    }

    function de(e) {
      if ("false" == w(this).parents("[contenteditable]").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable")) return !0;
      if (e && "touchend" == e.type && n) return !0;
      if (e && L.edit.isDisabled()) return e.stopPropagation(), e.preventDefault(), !1;
      for (var t = 0; t < xt.INSTANCES.length; t++) xt.INSTANCES[t] != L && xt.INSTANCES[t].events.trigger("image.hideResizer");
      L.toolbar.disable(), e && (e.stopPropagation(), e.preventDefault()), L.helpers.isMobile() && (L.events.disableBlur(), L.$el.blur(), L.events.enableBlur()), L.opts.iframe && L.size.syncIframe(), _ = w(this), Ce(), k(), o(), L.browser.msie ? (L.popups.areVisible() && L.events.disableBlur(), L.win.getSelection && (L.win.getSelection().removeAllRanges(), L.win.getSelection().addRange(L.doc.createRange()))) : L.selection.clear(), L.helpers.isIOS() && (L.events.disableBlur(), L.$el.blur()), L.button.bulkRefresh(), L.events.trigger("video.hideResizer")
    }

    function fe(e) {
      _ && (function t() {
        return pe
      }() || !0 === e) && (L.toolbar.enable(), l.removeClass("fr-active"), L.popups.hideAll(), _ = null, he(), c = null, d && d.hide())
    }

    a[r] = "Image cannot be loaded from the passed link.", a[p] = "No link in upload response.", a[u] = "Error during file upload.", a[h] = "Parsing response failed.", a[T] = "File is too large.", a[S] = "Image file type is invalid.", a[7] = "Files can be uploaded only to same domain in IE 8 and IE 9.";
    var pe = !(a[8] = "Image file is corrupted.");

    function ue() {
      pe = !0
    }

    function he() {
      pe = !1
    }

    function ge(e, t, n) {
      !L.opts.htmlUntouched && L.opts.useClasses ? (e.removeClass("fr-fil fr-fir fr-dib fr-dii"), n && e.addClass("fr-fi".concat(n[0])), t && e.addClass("fr-di".concat(t[0]))) : "inline" == t ? (e.css({
        display: "inline-block",
        verticalAlign: "bottom",
        margin: L.opts.imageDefaultMargin
      }), "center" == n ? e.css({
        "float": "none",
        marginBottom: "",
        marginTop: "",
        maxWidth: "calc(100% - ".concat(2 * L.opts.imageDefaultMargin, "px)"),
        textAlign: "center"
      }) : "left" == n ? e.css({
        "float": "left",
        marginLeft: 0,
        maxWidth: "calc(100% - ".concat(L.opts.imageDefaultMargin, "px)"),
        textAlign: "left"
      }) : e.css({
        "float": "right",
        marginRight: 0,
        maxWidth: "calc(100% - ".concat(L.opts.imageDefaultMargin, "px)"),
        textAlign: "right"
      })) : "block" == t && (e.css({
        display: "block",
        "float": "none",
        verticalAlign: "top",
        margin: "".concat(L.opts.imageDefaultMargin, "px auto"),
        textAlign: "center"
      }), "left" == n ? e.css({marginLeft: 0, textAlign: "left"}) : "right" == n && e.css({
        marginRight: 0,
        textAlign: "right"
      }))
    }

    function me(e) {
      if (void 0 === e && (e = ye()), e) {
        if (e.hasClass("fr-fil")) return "left";
        if (e.hasClass("fr-fir")) return "right";
        if (e.hasClass("fr-dib") || e.hasClass("fr-dii")) return "center";
        var t = e.css("float");
        if (e.css("float", "none"), "block" == e.css("display")) {
          if (e.css("float", ""), e.css("float") != t && e.css("float", t), 0 === parseInt(e.css("margin-left"), 10)) return "left";
          if (0 === parseInt(e.css("margin-right"), 10)) return "right"
        } else {
          if (e.css("float", ""), e.css("float") != t && e.css("float", t), "left" == e.css("float")) return "left";
          if ("right" == e.css("float")) return "right"
        }
      }
      return "center"
    }

    function ve(e) {
      void 0 === e && (e = ye());
      var t = e.css("float");
      return e.css("float", "none"), "block" == e.css("display") ? (e.css("float", ""), e.css("float") != t && e.css("float", t), "block") : (e.css("float", ""), e.css("float") != t && e.css("float", t), "inline")
    }

    function be() {
      var e = L.popups.get("image.insert");
      e || (e = Y()), L.popups.isVisible("image.insert") || (N(), L.popups.refresh("image.insert"), L.popups.setContainer("image.insert", L.$sc));
      var t = ye();
      Le() && (t = t.find(".fr-img-wrap"));
      var n = t.offset().left + t.outerWidth() / 2, r = t.offset().top + t.outerHeight();
      L.popups.show("image.insert", n, r, t.outerHeight(!0), !0)
    }

    function Ce() {
      if (_) {
        L.events.disableBlur(), L.selection.clear();
        var e = L.doc.createRange();
        e.selectNode(_.get(0)), L.browser.msie && e.collapse(!0), L.selection.get().addRange(e), L.events.enableBlur()
      }
    }

    function Ee() {
      return _
    }

    function ye() {
      return Le() ? _.parents(".fr-img-caption").first() : _
    }

    function Le() {
      return !!_ && 0 < _.parents(".fr-img-caption").length
    }

    function _e(e) {
      for (var t = document.createDocumentFragment(); e.firstChild;) {
        var n = e.removeChild(e.firstChild);
        t.appendChild(n)
      }
      e.parentNode.replaceChild(t, e)
    }

    return {
      _init: function we() {
        var r;
        (function e() {
          L.events.$on(L.$el, L._mousedown, "IMG" == L.el.tagName ? null : 'img:not([contenteditable="false"])', function (e) {
            if ("false" == w(this).parents("contenteditable").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable")) return !0;
            L.helpers.isMobile() || L.selection.clear(), t = !0, L.popups.areVisible() && L.events.disableBlur(), L.browser.msie && (L.events.disableBlur(), L.$el.attr("contenteditable", !1)), L.draggable || "touchstart" == e.type || e.preventDefault(), e.stopPropagation()
          }), L.events.$on(L.$el, L._mousedown, ".fr-img-caption .fr-inner", function (e) {
            L.core.hasFocus() || L.events.focus(), e.stopPropagation()
          }), L.events.$on(L.$el, "paste", ".fr-img-caption .fr-inner", function (e) {
            !0 === L.opts.toolbarInline && (L.toolbar.hide(), e.stopPropagation())
          }), L.events.$on(L.$el, L._mouseup, "IMG" == L.el.tagName ? null : 'img:not([contenteditable="false"])', function (e) {
            if ("false" == w(this).parents("contenteditable").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable")) return !0;
            t && (t = !1, e.stopPropagation(), L.browser.msie && (L.$el.attr("contenteditable", !0), L.events.enableBlur()))
          }), L.events.on("keyup", function (e) {
            if (e.shiftKey && "" === L.selection.text().replace(/\n/g, "") && L.keys.isArrow(e.which)) {
              var t = L.selection.element(), n = L.selection.endElement();
              t && "IMG" == t.tagName ? B(w(t)) : n && "IMG" == n.tagName && B(w(n))
            }
          }, !0), L.events.on("drop", G), L.events.on("element.beforeDrop", W), L.events.on("mousedown window.mousedown", ue), L.events.on("window.touchmove", he), L.events.on("mouseup window.mouseup", function () {
            if (_ && !L.helpers.isMobile()) return fe(), !1;
            he()
          }), L.events.on("commands.mousedown", function (e) {
            0 < e.parents(".fr-toolbar").length && fe()
          }), L.events.on("image.resizeEnd", function () {
            L.opts.iframe && L.size.syncIframe()
          }), L.events.on("blur image.hideResizer commands.undo commands.redo element.dropped", function () {
            fe(!(t = !1))
          }), L.events.on("modals.hide", function () {
            _ && (Ce(), L.selection.clear())
          }), L.events.on("image.resizeEnd", function () {
            L.win.getSelection && B(_)
          }), L.opts.imageAddNewLine && L.events.on("image.inserted", function (e) {
            var t = e.get(0);
            for (t.nextSibling && "BR" === t.nextSibling.tagName && (t = t.nextSibling); t && !L.node.isElement(t);) t = L.node.isLastSibling(t) ? t.parentNode : null;
            L.node.isElement(t) && (L.opts.enter === xt.ENTER_BR ? e.after("<br>") : w(L.node.blockParent(e.get(0))).after("<".concat(L.html.defaultTag(), "><br></").concat(L.html.defaultTag(), ">")))
          })
        })(), "IMG" == L.el.tagName && L.$el.addClass("fr-view"), L.events.$on(L.$el, L.helpers.isMobile() && !L.helpers.isWindowsPhone() ? "touchend" : "click", "IMG" == L.el.tagName ? null : 'img:not([contenteditable="false"])', de), L.helpers.isMobile() && (L.events.$on(L.$el, "touchstart", "IMG" == L.el.tagName ? null : 'img:not([contenteditable="false"])', function () {
          n = !1
        }), L.events.$on(L.$el, "touchmove", function () {
          n = !0
        })), L.$wp ? (L.events.on("window.keydown keydown", ne, !0), L.events.on("keyup", function (e) {
          if (_ && e.which == xt.KEYCODE.ENTER) return !1
        }, !0), L.events.$on(L.$el, "keydown", function () {
          var e = L.selection.element();
          (e.nodeType === Node.TEXT_NODE || "BR" == e.tagName && L.node.isLastSibling(e)) && (e = e.parentNode), L.node.hasClass(e, "fr-inner") || (L.node.hasClass(e, "fr-img-caption") || (e = w(e).parents(".fr-img-caption").get(0)), L.node.hasClass(e, "fr-img-caption") && (L.opts.trackChangesEnabled || w(e).after(xt.INVISIBLE_SPACE + xt.MARKERS), L.selection.restore()))
        })) : L.events.$on(L.$win, "keydown", ne), L.events.on("toolbar.esc", function () {
          if (_) {
            if (L.$wp) L.events.disableBlur(), L.events.focus(); else {
              var e = _;
              fe(!0), L.selection.setAfter(e.get(0)), L.selection.restore()
            }
            return !1
          }
        }, !0), L.events.on("toolbar.focusEditor", function () {
          if (_) return !1
        }, !0), L.events.on("window.cut window.copy", function (e) {
          if (_ && L.popups.isVisible("image.edit") && !L.popups.get("image.edit").find(":focus").length) {
            var t = ye();
            Le() ? (t.before(xt.START_MARKER), t.after(xt.END_MARKER), L.selection.restore(), L.paste.saveCopiedText(t.get(0).outerHTML, t.text())) : (Ce(), L.paste.saveCopiedText(_.get(0).outerHTML, _.attr("alt"))), "copy" == e.type ? setTimeout(function () {
              B(_)
            }) : (fe(!0), L.undo.saveStep(), setTimeout(function () {
              L.undo.saveStep()
            }, 0))
          }
        }, !0), L.browser.msie && L.events.on("keydown", function (e) {
          if (!L.selection.isCollapsed() || !_) return !0;
          var t = e.which;
          t == xt.KEYCODE.C && L.keys.ctrlKey(e) ? L.events.trigger("window.copy") : t == xt.KEYCODE.X && L.keys.ctrlKey(e) && L.events.trigger("window.cut")
        }), L.events.$on(w(L.o_win), "keydown", function (e) {
          var t = e.which;
          if (_ && t == xt.KEYCODE.BACKSPACE) return e.preventDefault(), !1
        }), L.events.$on(L.$win, "keydown", function (e) {
          var t = e.which;
          _ && _.hasClass("fr-uploading") && t == xt.KEYCODE.ESC && _.trigger("abortUpload")
        }), L.events.on("destroy", function () {
          _ && _.hasClass("fr-uploading") && _.trigger("abortUpload")
        }), L.events.on("paste.before", le), L.events.on("paste.beforeCleanup", ce), L.events.on("paste.after", oe), L.events.on("html.set", m), L.events.on("html.inserted", m), m(), L.events.on("destroy", function () {
          s = []
        }), L.events.on("html.processGet", re), L.opts.imageOutputSize && L.events.on("html.beforeGet", function () {
          r = L.el.querySelectorAll("img");
          for (var e = 0; e < r.length; e++) {
            var t = r[e].style.width || w(r[e]).width(), n = r[e].style.height || w(r[e]).height();
            t && r[e].setAttribute("width", "".concat(t).replace(/px/, "")), n && r[e].setAttribute("height", "".concat(n).replace(/px/, ""))
          }
        }), L.opts.iframe && L.events.on("image.loaded", L.size.syncIframe), L.$wp && (v(), L.events.on("contentChanged", v)), L.events.$on(w(L.o_win), "orientationchange.image", function () {
          setTimeout(function () {
            _ && B(_)
          }, 100)
        }), M(!0), Y(!0), J(!0), Z(!0), L.events.on("node.remove", function (e) {
          if ("IMG" == e.get(0).tagName) return te(e), !1
        })
      },
      showInsertPopup: function Ae() {
        var e = L.$tb.find('.fr-command[data-cmd="insertImage"]'), t = L.popups.get("image.insert");
        if (t || (t = Y()), N(), !t.hasClass("fr-active")) if (L.popups.refresh("image.insert"), L.popups.setContainer("image.insert", L.$tb), e.isVisible()) {
          var n = L.button.getPosition(e), r = n.left, a = n.top;
          L.popups.show("image.insert", r, a, e.outerHeight())
        } else L.position.forSelection(t), L.popups.show("image.insert")
      },
      showLayer: function Te(e) {
        var t, n, r = L.popups.get("image.insert");
        if (_ || L.opts.toolbarInline) {
          if (_) {
            var a = ye();
            Le() && (a = a.find(".fr-img-wrap")), n = a.offset().top + a.outerHeight(), t = a.offset().left
          }
        } else {
          var o = L.$tb.find('.fr-command[data-cmd="insertImage"]');
          t = o.offset().left, n = o.offset().top + (L.opts.toolbarBottom ? 10 : o.outerHeight() - 10)
        }
        !_ && L.opts.toolbarInline && (n = r.offset().top - L.helpers.getPX(r.css("margin-top")), r.hasClass("fr-above") && (n += r.outerHeight())), r.find(".fr-layer").removeClass("fr-active"), r.find(".fr-".concat(e, "-layer")).addClass("fr-active"), L.popups.show("image.insert", t, n, _ ? _.outerHeight() : 0), L.accessibility.focusPopup(r)
      },
      refreshUploadButton: function Se(e) {
        var t = L.popups.get("image.insert");
        t && t.find(".fr-image-upload-layer").hasClass("fr-active") && e.addClass("fr-active").attr("aria-pressed", !0)
      },
      refreshByURLButton: function ke(e) {
        var t = L.popups.get("image.insert");
        t && t.find(".fr-image-by-url-layer").hasClass("fr-active") && e.addClass("fr-active").attr("aria-pressed", !0)
      },
      upload: V,
      insertByURL: function xe() {
        var e = L.popups.get("image.insert").find(".fr-image-by-url-layer input");
        if (0 < e.val().length) {
          O(), I(L.language.translate("Loading image"));
          var t = e.val().trim();
          if (L.opts.imageUploadRemoteUrls && L.opts.imageCORSProxy && L.opts.imageUpload) {
            var n = new XMLHttpRequest;
            n.onload = function () {
              200 == this.status ? V([new Blob([this.response], {type: this.response.type || "image/png"})], _) : R(r)
            }, n.onerror = function () {
              $(t, !0, [], _)
            }, n.open("GET", "".concat(L.opts.imageCORSProxy, "/").concat(t), !0), n.responseType = "blob", n.send()
          } else $(t, !0, [], _);
          e.val(""), e.blur()
        }
      },
      align: function Re(e) {
        var t = ye();
        t.removeClass("fr-fir fr-fil"), !L.opts.htmlUntouched && L.opts.useClasses ? "left" == e ? t.addClass("fr-fil") : "right" == e && t.addClass("fr-fir") : ge(t, ve(), e), Ce(), k(), o(), L.selection.clear()
      },
      refreshAlign: function Me(e) {
        _ && e.find("> *").first().replaceWith(L.icon.create("image-align-".concat(me())))
      },
      refreshAlignOnShow: function Oe(e, t) {
        _ && t.find('.fr-command[data-param1="'.concat(me(), '"]')).addClass("fr-active").attr("aria-selected", !0)
      },
      display: function Ne(e) {
        var t = ye();
        t.removeClass("fr-dii fr-dib"), !L.opts.htmlUntouched && L.opts.useClasses ? "inline" == e ? t.addClass("fr-dii") : "block" == e && t.addClass("fr-dib") : ge(t, e, me()), Ce(), k(), o(), L.selection.clear()
      },
      refreshDisplayOnShow: function Ie(e, t) {
        _ && t.find('.fr-command[data-param1="'.concat(ve(), '"]')).addClass("fr-active").attr("aria-selected", !0)
      },
      replace: be,
      back: function e() {
        _ ? (L.events.disableBlur(), w(".fr-popup input:focus").blur(), B(_)) : (L.events.disableBlur(), L.selection.restore(), L.events.enableBlur(), L.popups.hide("image.insert"), L.toolbar.showInline())
      },
      get: Ee,
      getEl: ye,
      insert: $,
      showProgressBar: O,
      remove: te,
      hideProgressBar: N,
      applyStyle: function De(e, t, n) {
        if (void 0 === t && (t = L.opts.imageStyles), void 0 === n && (n = L.opts.imageMultipleStyles), !_) return !1;
        var r = ye();
        if (!n) {
          var a = Object.keys(t);
          a.splice(a.indexOf(e), 1), r.removeClass(a.join(" "))
        }
        "object" == kt(t[e]) ? (r.removeAttr("style"), r.css(t[e].style)) : r.toggleClass(e), B(_)
      },
      showAltPopup: q,
      showSizePopup: Q,
      setAlt: function Be(e) {
        if (_) {
          var t = L.popups.get("image.alt");
          _.attr("alt", e || t.find("input").val() || ""), t.find("input:focus").blur(), B(_)
        }
      },
      setSize: function He(e, t) {
        if (_) {
          var n = L.popups.get("image.size");
          e = e || n.find('input[name="width"]').val() || "", t = t || n.find('input[name="height"]').val() || "";
          var r = /^[\d]+((px)|%)*$/g;
          _.removeAttr("width").removeAttr("height"), e.match(r) ? _.css("width", e) : _.css("width", ""), t.match(r) ? _.css("height", t) : _.css("height", ""), Le() && (_.parents(".fr-img-caption").removeAttr("width").removeAttr("height"), e.match(r) ? _.parents(".fr-img-caption").css("width", e) : _.parents(".fr-img-caption").css("width", ""), t.match(r) ? _.parents(".fr-img-caption").css("height", t) : _.parents(".fr-img-caption").css("height", "")), n && n.find("input:focus").blur(), B(_)
        }
      },
      toggleCaption: function $e() {
        var e;
        if (_ && !Le()) {
          ((e = _).parent().is("a") || _.parent().is("p")) && (e = _.parent());
          var t, n,
            r = _.parents("ul") && 0 < _.parents("ul").length ? _.parents("ul") : _.parents("ol") && 0 < _.parents("ol").length ? _.parents("ol") : [];
          if (0 < r.length) {
            var a = r.find("li").length, o = _.parents("li"), i = document.createElement("li");
            a - 1 === o.index() && (r.append(i), i.innerHTML = "&nbsp;")
          }
          e.attr("style") ? n = -1 < (t = e.attr("style").split(":")).indexOf("width") ? t[t.indexOf("width") + 1].replace(";", "") : "" : e.attr("width") && (n = e.attr("width"));
          var s = L.opts.imageResizeWithPercent ? (-1 < n.indexOf("px") ? null : n) || "100%" : _.width() + "px";
          e.wrap('<div class="fr-img-space-wrap"><span ' + (L.browser.mozilla ? "" : 'contenteditable="false"') + 'class="fr-img-caption ' + _.attr("class") + '" style="' + (L.opts.useClasses ? "" : e.attr("style")) + '" draggable="false"></span></div>'), e.wrap('<span class="fr-img-wrap"></span>'), _.after('<span class="fr-inner"'.concat(L.browser.mozilla ? "" : ' contenteditable="true"', ">").concat(xt.START_MARKER).concat(L.language.translate("Image Caption")).concat(xt.END_MARKER, "</span>")), _.parents(".fr-img-caption").css("width", s), 1 < _.parents(".fr-img-space-wrap").length && (_e(document.querySelector(".fr-img-space-wrap")), _e(document.querySelector(".fr-img-space-wrap2"))), fe(!0), L.selection.restore()
        } else {
          if (e = ye(), _.insertBefore(e), null !== e[0].querySelector("a")) {
            for (var l, c = e[0].querySelector("a"), d = document.createElement("a"), f = 0, p = c.attributes, u = p.length; f < u; f++) l = p[f], d.setAttribute(l.nodeName, l.nodeValue);
            _.wrap(d)
          }
          _.attr("class", e.attr("class").replace("fr-img-caption", "")).attr("style", e.attr("style")), e.remove(), 1 < _.parents(".fr-img-space-wrap").length && (_e(document.querySelector(".fr-img-space-wrap")), _e(document.querySelector(".fr-img-space-wrap2"))), B(_)
        }
      },
      hasCaption: Le,
      exitEdit: fe,
      edit: B
    }
  },xt.DefineIcon("insertImage", {
    NAME: "image",
    SVG_KEY: "insertImage"
  }),xt.RegisterShortcut(xt.KEYCODE.P, "insertImage", null, "P"),xt.RegisterCommand("insertImage", {
    title: "Insert Image",
    undo: !1,
    focus: !0,
    refreshAfterCallback: !1,
    popup: !0,
    callback: function () {
      this.popups.isVisible("image.insert") ? (this.$el.find(".fr-marker").length && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("image.insert")) : this.image.showInsertPopup()
    },
    plugin: "image"
  }),xt.DefineIcon("imageUpload", {
    NAME: "upload",
    SVG_KEY: "upload"
  }),xt.RegisterCommand("imageUpload", {
    title: "Upload Image", undo: !1, focus: !1, toggle: !0, callback: function () {
      this.image.showLayer("image-upload")
    }, refresh: function (e) {
      this.image.refreshUploadButton(e)
    }
  }),xt.DefineIcon("imageByURL", {
    NAME: "link",
    SVG_KEY: "insertLink"
  }),xt.RegisterCommand("imageByURL", {
    title: "By URL", undo: !1, focus: !1, toggle: !0, callback: function () {
      this.image.showLayer("image-by-url")
    }, refresh: function (e) {
      this.image.refreshByURLButton(e)
    }
  }),xt.RegisterCommand("imageInsertByURL", {
    title: "Insert Image",
    undo: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.image.insertByURL()
    },
    refresh: function (e) {
      this.image.get() ? e.text(this.language.translate("Replace")) : e.text(this.language.translate("Insert"))
    }
  }),xt.DefineIcon("imageDisplay", {
    NAME: "star",
    SVG_KEY: "imageDisplay"
  }),xt.RegisterCommand("imageDisplay", {
    title: "Display",
    type: "dropdown",
    options: {inline: "Inline", block: "Break Text"},
    callback: function (e, t) {
      this.image.display(t)
    },
    refresh: function (e) {
      this.opts.imageTextNear || e.addClass("fr-hidden")
    },
    refreshOnShow: function (e, t) {
      this.image.refreshDisplayOnShow(e, t)
    }
  }),xt.DefineIcon("image-align", {
    NAME: "align-left",
    SVG_KEY: "alignLeft"
  }),xt.DefineIcon("image-align-left", {
    NAME: "align-left",
    SVG_KEY: "alignLeft"
  }),xt.DefineIcon("image-align-right", {
    NAME: "align-right",
    SVG_KEY: "alignRight"
  }),xt.DefineIcon("image-align-center", {
    NAME: "align-justify",
    SVG_KEY: "alignCenter"
  }),xt.DefineIcon("imageAlign", {
    NAME: "align-justify",
    SVG_KEY: "alignJustify"
  }),xt.RegisterCommand("imageAlign", {
    type: "dropdown",
    title: "Align",
    options: {left: "Align Left", center: "None", right: "Align Right"},
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = xt.COMMANDS.imageAlign.options;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="imageAlign" data-param1="'.concat(n, '" title="').concat(this.language.translate(t[n]), '">').concat(this.icon.create("image-align-".concat(n)), '<span class="fr-sr-only">').concat(this.language.translate(t[n]), "</span></a></li>"));
      return e += "</ul>"
    },
    callback: function (e, t) {
      this.image.align(t)
    },
    refresh: function (e) {
      this.image.refreshAlign(e)
    },
    refreshOnShow: function (e, t) {
      this.image.refreshAlignOnShow(e, t)
    }
  }),xt.DefineIcon("imageReplace", {
    NAME: "exchange",
    FA5NAME: "exchange-alt",
    SVG_KEY: "replaceImage"
  }),xt.RegisterCommand("imageReplace", {
    title: "Replace",
    undo: !1,
    focus: !1,
    popup: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.image.replace()
    }
  }),xt.DefineIcon("imageRemove", {
    NAME: "trash",
    SVG_KEY: "remove"
  }),xt.RegisterCommand("imageRemove", {
    title: "Remove", callback: function () {
      this.image.remove()
    }
  }),xt.DefineIcon("imageBack", {NAME: "arrow-left", SVG_KEY: "back"}),xt.RegisterCommand("imageBack", {
    title: "Back",
    undo: !1,
    focus: !1,
    back: !0,
    callback: function () {
      this.image.back()
    },
    refresh: function (e) {
      this.$;
      this.image.get() || this.opts.toolbarInline ? (e.removeClass("fr-hidden"), e.next(".fr-separator").removeClass("fr-hidden")) : (e.addClass("fr-hidden"), e.next(".fr-separator").addClass("fr-hidden"))
    }
  }),xt.RegisterCommand("imageDismissError", {
    title: "OK", undo: !1, callback: function () {
      this.image.hideProgressBar(!0)
    }
  }),xt.DefineIcon("imageStyle", {
    NAME: "magic",
    SVG_KEY: "imageClass"
  }),xt.RegisterCommand("imageStyle", {
    title: "Style", type: "dropdown", html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.imageStyles;
      for (var n in t) if (t.hasOwnProperty(n)) {
        var r = t[n];
        "object" == kt(r) && (r = r.title), e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="imageStyle" data-param1="'.concat(n, '">').concat(this.language.translate(r), "</a></li>")
      }
      return e += "</ul>"
    }, callback: function (e, t) {
      this.image.applyStyle(t)
    }, refreshOnShow: function (e, t) {
      var n = this.$, r = this.image.getEl();
      r && t.find(".fr-command").each(function () {
        var e = n(this).data("param1"), t = r.hasClass(e);
        n(this).toggleClass("fr-active", t).attr("aria-selected", t)
      })
    }
  }),xt.DefineIcon("imageAlt", {NAME: "info", SVG_KEY: "imageAltText"}),xt.RegisterCommand("imageAlt", {
    undo: !1,
    focus: !1,
    popup: !0,
    title: "Alternative Text",
    callback: function () {
      this.image.showAltPopup()
    }
  }),xt.RegisterCommand("imageSetAlt", {
    undo: !0,
    focus: !1,
    title: "Update",
    refreshAfterCallback: !1,
    callback: function () {
      this.image.setAlt()
    }
  }),xt.DefineIcon("imageSize", {NAME: "arrows-alt", SVG_KEY: "imageSize"}),xt.RegisterCommand("imageSize", {
    undo: !1,
    focus: !1,
    popup: !0,
    title: "Change Size",
    callback: function () {
      this.image.showSizePopup()
    }
  }),xt.RegisterCommand("imageSetSize", {
    undo: !0,
    focus: !1,
    title: "Update",
    refreshAfterCallback: !1,
    callback: function () {
      this.image.setSize()
    }
  }),xt.DefineIcon("imageCaption", {
    NAME: "commenting",
    FA5NAME: "comment-alt",
    SVG_KEY: "imageCaption"
  }),xt.RegisterCommand("imageCaption", {
    undo: !0,
    focus: !1,
    title: "Image Caption",
    refreshAfterCallback: !0,
    callback: function () {
      this.image.toggleCaption()
    },
    refresh: function (e) {
      this.image.get() && e.toggleClass("fr-active", this.image.hasCaption())
    }
  }),Object.assign(xt.DEFAULTS, {
    imageManagerLoadURL: "https://i.froala.com/load-files",
    imageManagerLoadMethod: "get",
    imageManagerLoadParams: {},
    imageManagerPreloader: null,
    imageManagerDeleteURL: "",
    imageManagerDeleteMethod: "post",
    imageManagerDeleteParams: {},
    imageManagerPageSize: 12,
    imageManagerScrollOffset: 20,
    imageManagerToggleTags: !0
  }),xt.PLUGINS.imageManager = function (s) {
    var l, c, o, i, d, f, p, u, h, g, m, v = s.$, b = "image_manager", e = 10, C = 11, E = 12, y = 13, L = 14, _ = 15,
      n = 21, r = 22, a = {};

    function w() {
      var e = v(window).outerWidth();
      return e < 768 ? 2 : e < 1200 ? 3 : 4
    }

    function A() {
      d.empty();
      for (var e = 0; e < m; e++) d.append('<div class="fr-list-column"></div>')
    }

    function T() {
      if (h < p.length && o[0].scrollTop >= o[0].scrollHeight - s.opts.imageManagerScrollOffset - o.outerHeight()) {
        u++;
        for (var e = s.opts.imageManagerPageSize * (u - 1); e < Math.min(p.length, s.opts.imageManagerPageSize * u); e++) t(p[e])
      }
    }

    function t(a) {
      var o = new Image,
        i = v(document.createElement("div")).attr("class", "fr-image-container fr-empty fr-image-" + g++).attr("data-loading", s.language.translate("Loading") + "..").attr("data-deleting", s.language.translate("Deleting") + "..");
      R(!1), o.onload = function () {
        i.height(Math.floor(i.width() / o.width * o.height));
        var n = v(document.createElement("img"));
        if (a.thumb) n.attr("src", a.thumb); else {
          if (I(L, a), !a.url) return I(_, a), !1;
          n.attr("src", a.url)
        }
        if (a.url && n.attr("data-url", a.url), a.tag) if (c.find(".fr-modal-more.fr-not-available").removeClass("fr-not-available"), c.find(".fr-modal-tags").show(), 0 <= a.tag.indexOf(",")) {
          for (var e = a.tag.split(","), t = 0; t < e.length; t++) e[t] = e[t].trim(), 0 === f.find('a[title="'.concat(e[t], '"]')).length && f.append('<a role="button" title="'.concat(e[t], '">').concat(e[t], "</a>"));
          n.attr("data-tag", e.join())
        } else 0 === f.find('a[title="'.concat(a.tag.trim(), '"]')).length && f.append('<a role="button" title="'.concat(a.tag.trim(), '">').concat(a.tag.trim(), "</a>")), n.attr("data-tag", a.tag.trim());
        for (var r in a.name && n.attr("alt", a.name), a) a.hasOwnProperty(r) && "thumb" !== r && "url" !== r && "tag" !== r && n.attr("data-".concat(r), a[r]);
        i.append(n).append(v(s.icon.create("imageManagerDelete")).addClass("fr-delete-img").attr("title", s.language.translate("Delete"))).append(v(s.icon.create("imageManagerInsert")).addClass("fr-insert-img").attr("title", s.language.translate("Insert"))), f.find(".fr-selected-tag").each(function (e, t) {
          $(n, t.text) || i.hide()
        }), n.on("load", function () {
          i.removeClass("fr-empty"), i.height("auto"), h++, x(k(parseInt(n.parent().attr("class").match(/fr-image-(\d+)/)[1], 10) + 1)), R(!1), h % s.opts.imageManagerPageSize == 0 && T()
        }), s.events.trigger("imageManager.imageLoaded", [n])
      }, o.onerror = function () {
        h++, i.remove(), x(k(parseInt(i.attr("class").match(/fr-image-(\d+)/)[1], 10) + 1)), I(e, a), h % s.opts.imageManagerPageSize == 0 && T()
      }, o.src = a.thumb || a.url, S().append(i)
    }

    function S() {
      var r, a;
      return d.find(".fr-list-column").each(function (e, t) {
        var n = v(t);
        0 === e ? (a = n.outerHeight(), r = n) : n.outerHeight() < a && (a = n.outerHeight(), r = n)
      }), r
    }

    function k(e) {
      e === undefined && (e = 0);
      for (var t = [], n = g - 1; e <= n; n--) {
        var r = d.find(".fr-image-".concat(n));
        r.length && (t.push(r), v(document.createElement("div")).attr("id", "fr-image-hidden-container").append(r), d.find(".fr-image-".concat(n)).remove())
      }
      return t
    }

    function x(e) {
      for (var t = e.length - 1; 0 <= t; t--) S().append(e[t])
    }

    function R(e) {
      if (e === undefined && (e = !0), !l.isVisible()) return !0;
      var t = w();
      if (t !== m) {
        m = t;
        var n = k();
        A(), x(n)
      }
      s.modals.resize(b), e && T()
    }

    function M(e) {
      for (var t, n = e[0].attributes, r = n.length, a = {}; r--;) n[r] && "src" !== (t = n[r].name) && (a[t] = n[r].value);
      return a
    }

    function O(e) {
      var t = v(e.currentTarget).siblings("img"), n = l.data("instance") || s, r = l.data("current-image");
      if (s.modals.hide(b), n.image.showProgressBar(), r) r.data("fr-old-src", r.attr("src")), r.trigger("click"); else {
        n.events.focus(!0), n.selection.restore();
        var a = n.position.getBoundingRect(), o = a.left + a.width / 2 + v(s.doc).scrollLeft(),
          i = a.top + a.height + v(s.doc).scrollTop();
        n.popups.setContainer("image.insert", s.$sc), n.popups.show("image.insert", o, i)
      }
      n.image.insert(t.data("url"), !1, M(t), r)
    }

    function N(e) {
      var o = v(e.currentTarget).siblings("img"), t = s.language.translate("Are you sure? Image will be deleted.");
      confirm(t) && (s.opts.imageManagerDeleteURL ? !1 !== s.events.trigger("imageManager.beforeDeleteImage", [o]) && (o.parent().addClass("fr-image-deleting"), v(this).ajax({
        method: s.opts.imageManagerDeleteMethod,
        url: s.opts.imageManagerDeleteURL,
        data: Object.assign(Object.assign({src: o.attr("src")}, M(o)), s.opts.imageManagerDeleteParams),
        crossDomain: s.opts.requestWithCORS,
        withCredentials: s.opts.requestWithCredentials,
        headers: s.opts.requestHeaders,
        done: function (e, t, n) {
          s.events.trigger("imageManager.imageDeleted", [e]);
          var r = k(parseInt(o.parent().attr("class").match(/fr-image-(\d+)/)[1], 10) + 1);
          o.parent().remove(), x(r), function a() {
            l.find("#fr-modal-tags > a").each(function () {
              0 === l.find('#fr-image-list [data-tag*="'.concat(v(this).text(), '"]')).length && v(this).removeClass("fr-selected-tag").hide()
            }), B()
          }(), R(!0)
        },
        fail: function (e) {
          I(n, e.response || e.responseText)
        }
      })) : I(r))
    }

    function I(e, t) {
      10 <= e && e < 20 ? i.hide() : 20 <= e && e < 30 && v(".fr-image-deleting").removeClass("fr-image-deleting"), s.events.trigger("imageManager.error", [{
        code: e,
        message: a[e]
      }, t])
    }

    function D() {
      var e = c.find(".fr-modal-head-line").outerHeight(), t = f.outerHeight();
      c.toggleClass("fr-show-tags"), c.hasClass("fr-show-tags") ? (c.css("height", e + t), o.css("marginTop", e + t), f.find("a").css("opacity", 1)) : (c.css("height", e), o.css("marginTop", e), f.find("a").css("opacity", 0))
    }

    function B() {
      var e = f.find(".fr-selected-tag");
      0 < e.length ? (d.find("img").parents().show(), e.each(function (e, r) {
        d.find("img").each(function (e, t) {
          var n = v(t);
          $(n, r.text) || n.parent().hide()
        })
      })) : d.find("img").parents().show(), x(k()), T()
    }

    function H(e) {
      e.preventDefault();
      var t = v(e.currentTarget);
      t.toggleClass("fr-selected-tag"), s.opts.imageManagerToggleTags && t.siblings("a").removeClass("fr-selected-tag"), B()
    }

    function $(e, t) {
      for (var n = (e.attr("data-tag") || "").split(","), r = 0; r < n.length; r++) if (n[r] === t) return !0;
      return !1
    }

    return a[e] = "Image cannot be loaded from the passed link.", a[C] = "Error during load images request.", a[E] = "Missing imageManagerLoadURL option.", a[y] = "Parsing load response failed.", a[L] = "Missing image thumb.", a[_] = "Missing image URL.", a[n] = "Error during delete image request.", a[r] = "Missing imageManagerDeleteURL option.", {
      require: ["image"], _init: function F() {
        if (!s.$wp && "IMG" !== s.el.tagName) return !1
      }, show: function P() {
        if (!l) {
          var e,
            t = '<button class="fr-command fr-btn fr-modal-more fr-not-available" id="fr-modal-more-'.concat(s.sid, '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24""><path d="').concat(xt.SVG.tags, '"/></svg></button><h4 data-text="true">').concat(s.language.translate("Manage Images"), '</h4></div>\n      <div class="fr-modal-tags" id="fr-modal-tags">');
          e = s.opts.imageManagerPreloader ? '<img class="fr-preloader" id="fr-preloader" alt="'.concat(s.language.translate("Loading"), '.." src="').concat(s.opts.imageManagerPreloader, '" style="display: none;">') : '<span class="fr-preloader" id="fr-preloader" style="display: none;">'.concat(s.language.translate("Loading"), "</span>"), e += '<div class="fr-image-list" id="fr-image-list"></div>';
          var n = s.modals.create(b, t, e);
          l = n.$modal, c = n.$head, o = n.$body
        }
        l.data("current-image", s.image.get()), s.modals.show(b), i || function r() {
          i = l.find("#fr-preloader"), d = l.find("#fr-image-list"), f = l.find("#fr-modal-tags"), m = w(), A(), c.css("height", c.find(".fr-modal-head-line").outerHeight()), s.events.$on(v(s.o_win), "resize", function () {
            R(!!p)
          }), s.events.bindClick(d, ".fr-insert-img", O), s.events.bindClick(d, ".fr-delete-img", N), s.helpers.isMobile() && (s.events.bindClick(d, "div.fr-image-container", function (e) {
            l.find(".fr-mobile-selected").removeClass("fr-mobile-selected"), v(e.currentTarget).addClass("fr-mobile-selected")
          }), l.on(s._mousedown, function () {
            l.find(".fr-mobile-selected").removeClass("fr-mobile-selected")
          })), l.on(s._mousedown + " " + s._mouseup, function (e) {
            e.stopPropagation()
          }), l.on(s._mousedown, "*", function () {
            s.events.disableBlur()
          }), o.on("scroll", T), s.events.bindClick(l, "button#fr-modal-more-".concat(s.sid), D), s.events.bindClick(f, "a", H)
        }(), function a() {
          i.show(), d.find(".fr-list-column").empty(), s.opts.imageManagerLoadURL ? v(this).ajax({
            url: s.opts.imageManagerLoadURL,
            method: s.opts.imageManagerLoadMethod,
            data: s.opts.imageManagerLoadParams,
            crossDomain: s.opts.requestWithCORS,
            withCredentials: s.opts.requestWithCredentials,
            headers: s.opts.requestHeaders,
            done: function (e, t, n) {
              s.events.trigger("imageManager.imagesLoaded", [e]), function r(e, t) {
                try {
                  d.find(".fr-list-column").empty(), g = h = u = 0, p = JSON.parse(e), T()
                } catch (n) {
                  I(y, t)
                }
              }(e, n.response), i.hide()
            },
            fail: function (e) {
              I(C, e.response || e.responseText)
            }
          }) : I(E)
        }()
      }, hide: function U() {
        s.modals.hide(b)
      }
    }
  },!xt.PLUGINS.image) throw new Error("Image manager plugin requires image plugin.");

  function y(e) {
    var t = {
      omitExtraWLInCodeBlocks: {
        defaultValue: !1,
        describe: "Omit the default extra whiteline added to code blocks",
        type: "boolean"
      },
      noHeaderId: {defaultValue: !1, describe: "Turn on/off generated header id", type: "boolean"},
      prefixHeaderId: {
        defaultValue: !1,
        describe: "Add a prefix to the generated header ids. Passing a string will prefix that string to the header id. Setting to true will add a generic 'section-' prefix",
        type: "string"
      },
      rawPrefixHeaderId: {
        defaultValue: !1,
        describe: 'Setting this option to true will prevent showdown from modifying the prefix. This might result in malformed IDs (if, for instance, the " char is used in the prefix)',
        type: "boolean"
      },
      ghCompatibleHeaderId: {
        defaultValue: !1,
        describe: "Generate header ids compatible with github style (spaces are replaced with dashes, a bunch of non alphanumeric chars are removed)",
        type: "boolean"
      },
      rawHeaderId: {
        defaultValue: !1,
        describe: "Remove only spaces, ' and \" from generated header ids (including prefixes), replacing them with dashes (-). WARNING: This might result in malformed ids",
        type: "boolean"
      },
      headerLevelStart: {defaultValue: !1, describe: "The header blocks level start", type: "integer"},
      parseImgDimensions: {defaultValue: !1, describe: "Turn on/off image dimension parsing", type: "boolean"},
      simplifiedAutoLink: {defaultValue: !1, describe: "Turn on/off GFM autolink style", type: "boolean"},
      excludeTrailingPunctuationFromURLs: {
        defaultValue: !1,
        describe: "Excludes trailing punctuation from links generated with autoLinking",
        type: "boolean"
      },
      literalMidWordUnderscores: {
        defaultValue: !1,
        describe: "Parse midword underscores as literal underscores",
        type: "boolean"
      },
      literalMidWordAsterisks: {
        defaultValue: !1,
        describe: "Parse midword asterisks as literal asterisks",
        type: "boolean"
      },
      strikethrough: {defaultValue: !1, describe: "Turn on/off strikethrough support", type: "boolean"},
      tables: {defaultValue: !1, describe: "Turn on/off tables support", type: "boolean"},
      tablesHeaderId: {defaultValue: !1, describe: "Add an id to table headers", type: "boolean"},
      ghCodeBlocks: {defaultValue: !0, describe: "Turn on/off GFM fenced code blocks support", type: "boolean"},
      tasklists: {defaultValue: !1, describe: "Turn on/off GFM tasklist support", type: "boolean"},
      smoothLivePreview: {
        defaultValue: !1,
        describe: "Prevents weird effects in live previews due to incomplete input",
        type: "boolean"
      },
      smartIndentationFix: {
        defaultValue: !1,
        description: "Tries to smartly fix indentation in es6 strings",
        type: "boolean"
      },
      disableForced4SpacesIndentedSublists: {
        defaultValue: !1,
        description: "Disables the requirement of indenting nested sublists by 4 spaces",
        type: "boolean"
      },
      simpleLineBreaks: {
        defaultValue: !1,
        description: "Parses simple line breaks as <br> (GFM Style)",
        type: "boolean"
      },
      requireSpaceBeforeHeadingText: {
        defaultValue: !1,
        description: "Makes adding a space between `#` and the header text mandatory (GFM Style)",
        type: "boolean"
      },
      ghMentions: {defaultValue: !1, description: "Enables github @mentions", type: "boolean"},
      ghMentionsLink: {
        defaultValue: "https://github.com/{u}",
        description: "Changes the link generated by @mentions. Only applies if ghMentions option is enabled.",
        type: "string"
      },
      encodeEmails: {
        defaultValue: !0,
        description: "Encode e-mail addresses through the use of Character Entities, transforming ASCII e-mail addresses into its equivalent decimal entities",
        type: "boolean"
      },
      openLinksInNewWindow: {defaultValue: !1, description: "Open all links in new windows", type: "boolean"},
      backslashEscapesHTMLTags: {
        defaultValue: !1,
        description: "Support for HTML Tag escaping. ex: <div>foo</div>",
        type: "boolean"
      },
      emoji: {defaultValue: !1, description: "Enable emoji support. Ex: `this is a :smile: emoji`", type: "boolean"},
      underline: {
        defaultValue: !1,
        description: "Enable support for underline. Syntax is double or triple underscores: `__underline word__`. With this option enabled, underscores no longer parses into `<em>` and `<strong>`",
        type: "boolean"
      },
      completeHTMLDocument: {
        defaultValue: !1,
        description: "Outputs a complete html document, including `<html>`, `<head>` and `<body>` tags",
        type: "boolean"
      },
      metadata: {
        defaultValue: !1,
        description: "Enable support for document metadata (defined at the top of the document between `\xab\xab\xab` and `\xbb\xbb\xbb` or between `---` and `---`).",
        type: "boolean"
      },
      splitAdjacentBlockquotes: {defaultValue: !1, description: "Split adjacent blockquote blocks", type: "boolean"}
    };
    if (!1 === e) return JSON.parse(JSON.stringify(t));
    var n = {};
    for (var r in t) t.hasOwnProperty(r) && (n[r] = t[r].defaultValue);
    return n
  }

  xt.DEFAULTS.imageInsertButtons.push("imageManager"), xt.RegisterCommand("imageManager", {
    title: "Browse",
    undo: !1,
    focus: !1,
    modal: !0,
    callback: function () {
      this.imageManager.show()
    },
    plugin: "imageManager"
  }), xt.DefineIcon("imageManager", {
    NAME: "folder",
    SVG_KEY: "imageManager"
  }), xt.DefineIcon("imageManagerInsert", {
    NAME: "plus",
    SVG_KEY: "add"
  }), xt.DefineIcon("imageManagerDelete", {
    NAME: "trash",
    SVG_KEY: "remove"
  }), Object.assign(xt.DEFAULTS, {
    inlineClasses: {
      "fr-class-code": "Code",
      "fr-class-highlighted": "Highlighted",
      "fr-class-transparency": "Transparent"
    }
  }), xt.PLUGINS.inlineClass = function (n) {
    var r = n.$;
    return {
      apply: function t(e) {
        n.format.toggle("span", {"class": e})
      }, refreshOnShow: function a(e, t) {
        t.find(".fr-command").each(function () {
          var e = r(this).data("param1"), t = n.format.is("span", {"class": e});
          r(this).toggleClass("fr-active", t).attr("aria-selected", t)
        })
      }
    }
  }, xt.RegisterCommand("inlineClass", {
    type: "dropdown", title: "Inline Class", html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.inlineClasses;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="inlineClass" data-param1="'.concat(n, '" title="').concat(t[n], '">').concat(t[n], "</a></li>"));
      return e += "</ul>"
    }, callback: function (e, t) {
      this.inlineClass.apply(t)
    }, refreshOnShow: function (e, t) {
      this.inlineClass.refreshOnShow(e, t)
    }, plugin: "inlineClass"
  }), xt.DefineIcon("inlineClass", {
    NAME: "tag",
    SVG_KEY: "inlineClass"
  }), Object.assign(xt.DEFAULTS, {
    inlineStyles: {
      "Big Red": "font-size: 20px; color: red;",
      "Small Blue": "font-size: 14px; color: blue;"
    }
  }), xt.PLUGINS.inlineStyle = function (a) {
    return {
      apply: function o(e) {
        for (var t = e.split(";"), n = 0; n < t.length; n++) {
          var r = t[n].split(":");
          t[n].length && 2 == r.length && a.format.applyStyle(r[0].trim(), r[1].trim())
        }
      }
    }
  }, xt.RegisterCommand("inlineStyle", {
    type: "dropdown", html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.inlineStyles;
      for (var n in t) if (t.hasOwnProperty(n)) {
        var r = t[n] + (-1 === t[n].indexOf("display:block;") ? " display:block;" : "");
        e += '<li role="presentation"><span style="'.concat(r, '" role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="inlineStyle" data-param1="').concat(t[n], '" title="').concat(this.language.translate(n), '">').concat(this.language.translate(n), "</a></span></li>")
      }
      return e += "</ul>"
    }, title: "Inline Style", callback: function (e, t) {
      this.inlineStyle.apply(t)
    }, plugin: "inlineStyle"
  }), xt.DefineIcon("inlineStyle", {
    NAME: "paint-brush",
    SVG_KEY: "inlineStyle"
  }), Object.assign(xt.DEFAULTS, {
    lineBreakerTags: ["table", "hr", "form", "dl", "span.fr-video", ".fr-embedly", "img"],
    lineBreakerOffset: 15,
    lineBreakerHorizontalOffset: 10
  }), xt.PLUGINS.lineBreaker = function (h) {
    var g, t, a, m = h.$;

    function l(e, t) {
      var n, r, a, o, i, s, l, c;
      if (null == e) i = (o = t.parent()).offset().top, n = (l = t.offset().top) - Math.min((l - i) / 2, h.opts.lineBreakerOffset), a = o.outerWidth(), r = o.offset().left; else if (null == t) (s = (o = e.parent()).offset().top + o.outerHeight()) < (c = e.offset().top + e.outerHeight()) && (s = (o = m(o).parent()).offset().top + o.outerHeight()), n = c + Math.min(Math.abs(s - c) / 2, h.opts.lineBreakerOffset), a = o.outerWidth(), r = o.offset().left; else {
        o = e.parent();
        var d = e.offset().top + e.height(), f = t.offset().top;
        if (f < d) return !1;
        n = (d + f) / 2, a = o.outerWidth(), r = o.offset().left
      }
      if (h.opts.iframe) {
        var p = h.helpers.getPX(h.$wp.find(".fr-iframe").css("padding-top")),
          u = h.helpers.getPX(h.$wp.find(".fr-iframe").css("padding-left"));
        r += h.$iframe.offset().left - h.helpers.scrollLeft() + u, n += h.$iframe.offset().top - h.helpers.scrollTop() + p
      }
      h.$box.append(g), g.css("top", n - h.win.pageYOffset), g.css("left", r - h.win.pageXOffset), g.css("width", a), g.data("tag1", e), g.data("tag2", t), g.addClass("fr-visible").data("instance", h)
    }

    function c(e) {
      if (e) {
        var t = m(e);
        if (0 === h.$el.find(t).length) return null;
        if (e.nodeType != Node.TEXT_NODE && t.is(h.opts.lineBreakerTags.join(","))) return t;
        if (0 < t.parents(h.opts.lineBreakerTags.join(",")).length) return e = t.parents(h.opts.lineBreakerTags.join(",")).get(0), 0 !== h.$el.find(m(e)).length && m(e).is(h.opts.lineBreakerTags.join(",")) ? m(e) : null
      }
      return null
    }

    function o(e, t) {
      var n = h.doc.elementFromPoint(e, t);
      return n && !m(n).closest(".fr-line-breaker").length && !h.node.isElement(n) && n != h.$wp.get(0) && function r(e) {
        if ("undefined" != typeof e.inFroalaWrapper) return e.inFroalaWrapper;
        for (var t = e; e.parentNode && e.parentNode !== h.$wp.get(0);) e = e.parentNode;
        return t.inFroalaWrapper = e.parentNode == h.$wp.get(0), t.inFroalaWrapper
      }(n) ? n : null
    }

    function i(e, t, n) {
      for (var r = n, a = null; r <= h.opts.lineBreakerOffset && !a;) (a = o(e, t - r)) || (a = o(e, t + r)), r += n;
      return a
    }

    function d(e, t, n) {
      for (var r = null, a = 100; !r && e > h.$box.offset().left && e < h.$box.offset().left + h.$box.outerWidth() && 0 < a;) (r = o(e, t)) || (r = i(e, t, 5)), "left" == n ? e -= h.opts.lineBreakerHorizontalOffset : e += h.opts.lineBreakerHorizontalOffset, a -= h.opts.lineBreakerHorizontalOffset;
      return r
    }

    function n(e) {
      var t = a = null, n = null, r = h.doc.elementFromPoint(e.pageX - h.win.pageXOffset, e.pageY - h.win.pageYOffset);
      (t = r && ("HTML" == r.tagName || "BODY" == r.tagName || h.node.isElement(r) || 0 <= (r.getAttribute("class") || "").indexOf("fr-line-breaker")) ? ((n = i(e.pageX - h.win.pageXOffset, e.pageY - h.win.pageYOffset, 1)) || (n = d(e.pageX - h.win.pageXOffset - h.opts.lineBreakerHorizontalOffset, e.pageY - h.win.pageYOffset, "left")), n || (n = d(e.pageX - h.win.pageXOffset + h.opts.lineBreakerHorizontalOffset, e.pageY - h.win.pageYOffset, "right")), c(n)) : c(r)) ? function s(e, t) {
        var n, r, a = e.offset().top, o = e.offset().top + e.outerHeight();
        if (Math.abs(o - t) <= h.opts.lineBreakerOffset || Math.abs(t - a) <= h.opts.lineBreakerOffset) if (Math.abs(o - t) < Math.abs(t - a)) {
          var i = null;
          for ((r = e.get(0)).nextSibling && (i = r.nextSibling.offsetParent ? r.nextSibling : null); i && i.nodeType == Node.TEXT_NODE && 0 === i.textContent.length;) i = i.nextSibling;
          if (!i) return l(e, null), !0;
          if (n = c(i)) return l(e, n), !0
        } else {
          if (!(r = e.get(0)).previousSibling) return l(null, e), !0;
          if (n = c(r.previousSibling)) return l(n, e), !0
        }
        g.removeClass("fr-visible").removeData("instance")
      }(t, e.pageY) : h.core.sameInstance(g) && g.removeClass("fr-visible").removeData("instance")
    }

    function r(e) {
      return !(g.hasClass("fr-visible") && !h.core.sameInstance(g)) && (h.popups.areVisible() || h.el.querySelector(".fr-selected-cell") ? (g.removeClass("fr-visible"), !0) : void (!1 !== t || h.edit.isDisabled() || (a && clearTimeout(a), a = setTimeout(n, 30, e))))
    }

    function s() {
      a && clearTimeout(a), g && g.hasClass("fr-visible") && g.removeClass("fr-visible").removeData("instance")
    }

    var f = function f() {
      t = !0, s()
    }, p = function p() {
      t = !1
    };

    function u(e) {
      e.preventDefault();
      var t = g.data("instance") || h;
      g.removeClass("fr-visible").removeData("instance");
      var n = g.data("tag1"), r = g.data("tag2"), a = h.html.defaultTag();
      null == n ? a && "TD" != r.parent().get(0).tagName && 0 === r.parents(a).length ? r.before("<".concat(a, ">").concat(xt.MARKERS, "<br></").concat(a, ">")) : r.before("".concat(xt.MARKERS, "<br>")) : a && "TD" != n.parent().get(0).tagName && 0 === n.parents(a).length ? n.after("<".concat(a, ">").concat(xt.MARKERS, "<br></").concat(a, ">")) : n.after("".concat(xt.MARKERS, "<br>")), t.selection.restore(), h.toolbar.enable()
    }

    return {
      _init: function v() {
        if (!h.$wp) return !1;
        !function e() {
          h.shared.$line_breaker || (h.shared.$line_breaker = m(document.createElement("div")).attr("class", "fr-line-breaker").html('<a class="fr-floating-btn" role="button" tabIndex="-1" title="'.concat(h.language.translate("Break"), '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect x="17" y="7" width="2" height="8"/><rect x="10" y="13" width="7" height="2"/><path d="M10.000,10.000 L10.000,18.013 L5.000,14.031 L10.000,10.000 Z"/></svg></a>'))), g = h.shared.$line_breaker, h.events.on("shared.destroy", function () {
            g.html("").removeData().remove(), g = null
          }, !0), h.events.on("destroy", function () {
            g.removeData("instance").removeClass("fr-visible"), m("body").first().append(g), clearTimeout(a)
          }, !0), h.events.$on(g, "mousemove", function (e) {
            e.stopPropagation()
          }, !0), h.events.bindClick(g, "a", u)
        }(), t = !1, h.events.$on(h.$win, "mousemove", r), h.events.$on(m(h.win), "scroll", s), h.events.on("popups.show.table.edit", s), h.events.on("commands.after", s), h.events.$on(m(h.win), "mousedown", f), h.events.$on(m(h.win), "mouseup", p)
      }
    }
  }, Object.assign(xt.DEFAULTS, {
    lineHeights: {
      Default: "",
      Single: "1",
      1.15: "1.15",
      1.5: "1.5",
      Double: "2"
    }
  }), xt.PLUGINS.lineHeight = function (r) {
    var s = r.$;
    return {
      _init: function e() {
      }, apply: function a(e) {
        r.selection.save(), r.html.wrap(!0, !0, !0, !0), r.selection.restore();
        var t = r.selection.blocks();
        t.length && s(t[0]).parent().is("td") && r.format.applyStyle("line-height", e.toString()), r.selection.save();
        for (var n = 0; n < t.length; n++) s(t[n]).css("line-height", e), "" === s(t[n]).attr("style") && s(t[n]).removeAttr("style");
        r.html.unwrap(), r.selection.restore()
      }, refreshOnShow: function o(e, t) {
        var n = r.selection.blocks();
        if (n.length) {
          var i = s(n[0]);
          t.find(".fr-command").each(function () {
            var e = s(this).data("param1"), t = i.attr("style"), n = 0 <= (t || "").indexOf("line-height: " + e + ";");
            if (t) {
              var r = t.substring(t.indexOf("line-height")), a = r.substr(0, r.indexOf(";")), o = a && a.split(":")[1];
              o && o.length || "Default" !== i.text() || (n = !0)
            }
            t && -1 !== t.indexOf("line-height") || "" !== e || (n = !0), s(this).toggleClass("fr-active", n).attr("aria-selected", n)
          })
        }
      }
    }
  }, xt.RegisterCommand("lineHeight", {
    type: "dropdown", html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.lineHeights;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command '.concat(n, '" tabIndex="-1" role="option" data-cmd="lineHeight" data-param1="').concat(t[n], '" title="').concat(this.language.translate(n), '">').concat(this.language.translate(n), "</a></li>"));
      return e += "</ul>"
    }, title: "Line Height", callback: function (e, t) {
      this.lineHeight.apply(t)
    }, refreshOnShow: function (e, t) {
      this.lineHeight.refreshOnShow(e, t)
    }, plugin: "lineHeight"
  }), xt.DefineIcon("lineHeight", {
    NAME: "arrows-v",
    FA5NAME: "arrows-alt-v",
    SVG_KEY: "lineHeight"
  }), Object.assign(xt.POPUP_TEMPLATES, {
    "link.edit": "[_BUTTONS_]",
    "link.insert": "[_BUTTONS_][_INPUT_LAYER_]"
  }), Object.assign(xt.DEFAULTS, {
    linkEditButtons: ["linkOpen", "linkStyle", "linkEdit", "linkRemove"],
    linkInsertButtons: ["linkBack", "|", "linkList"],
    linkAttributes: {},
    linkAutoPrefix: "http://",
    linkStyles: {"fr-green": "Green", "fr-strong": "Thick"},
    linkMultipleStyles: !0,
    linkConvertEmailAddress: !0,
    linkAlwaysBlank: !1,
    linkAlwaysNoFollow: !1,
    linkNoOpener: !0,
    linkNoReferrer: !0,
    linkList: [{text: "Froala", href: "https://froala.com", target: "_blank"}, {
      text: "Google",
      href: "https://google.com",
      target: "_blank"
    }, {displayText: "Facebook", href: "https://facebook.com"}],
    linkText: !0
  }), xt.PLUGINS.link = function (m) {
    var v = m.$;

    function b() {
      var e = m.image ? m.image.get() : null;
      if (e || !m.$wp) return "A" == m.el.tagName ? m.el : e && e.get(0).parentNode && "A" == e.get(0).parentNode.tagName ? e.get(0).parentNode : void 0;
      var t = m.selection.ranges(0).commonAncestorContainer;
      try {
        t && (t.contains && t.contains(m.el) || !m.el.contains(t) || m.el == t) && (t = null)
      } catch (a) {
        t = null
      }
      if (t && "A" === t.tagName) return t;
      var n = m.selection.element(), r = m.selection.endElement();
      "A" == n.tagName || m.node.isElement(n) || (n = v(n).parentsUntil(m.$el, "a").first().get(0)), "A" == r.tagName || m.node.isElement(r) || (r = v(r).parentsUntil(m.$el, "a").first().get(0));
      try {
        r && (r.contains && r.contains(m.el) || !m.el.contains(r) || m.el == r) && (r = null)
      } catch (a) {
        r = null
      }
      try {
        n && (n.contains && n.contains(m.el) || !m.el.contains(n) || m.el == n) && (n = null)
      } catch (a) {
        n = null
      }
      return r && r == n && "A" == r.tagName ? (m.browser.msie || m.helpers.isMobile()) && (m.selection.info(n).atEnd || m.selection.info(n).atStart) ? null : n : null
    }

    function C() {
      var e, t, n, r, a = m.image ? m.image.get() : null, o = [];
      if (a) "A" == a.get(0).parentNode.tagName && o.push(a.get(0).parentNode); else if (m.win.getSelection) {
        var i = m.win.getSelection();
        if (i.getRangeAt && i.rangeCount) {
          r = m.doc.createRange();
          for (var s = 0; s < i.rangeCount; ++s) if ((t = (e = i.getRangeAt(s)).commonAncestorContainer) && 1 != t.nodeType && (t = t.parentNode), t && "a" == t.nodeName.toLowerCase()) o.push(t); else {
            n = t.getElementsByTagName("a");
            for (var l = 0; l < n.length; ++l) r.selectNodeContents(n[l]), r.compareBoundaryPoints(e.END_TO_START, e) < 1 && -1 < r.compareBoundaryPoints(e.START_TO_END, e) && o.push(n[l])
          }
        }
      } else if (m.doc.selection && "Control" != m.doc.selection.type) if ("a" == (t = (e = m.doc.selection.createRange()).parentElement()).nodeName.toLowerCase()) o.push(t); else {
        n = t.getElementsByTagName("a"), r = m.doc.body.createTextRange();
        for (var c = 0; c < n.length; ++c) r.moveToElementText(n[c]), -1 < r.compareEndPoints("StartToEnd", e) && r.compareEndPoints("EndToStart", e) < 1 && o.push(n[c])
      }
      return o
    }

    function E(a) {
      if (m.core.hasFocus()) {
        if (o(), a && "keyup" === a.type && (a.altKey || a.which == xt.KEYCODE.ALT)) return !0;
        setTimeout(function () {
          if (!a || a && (1 == a.which || "mouseup" != a.type)) {
            var e = b(), t = m.image ? m.image.get() : null;
            if (e && !t) {
              if (m.image) {
                var n = m.node.contents(e);
                if (1 == n.length && "IMG" == n[0].tagName) {
                  var r = m.selection.ranges(0);
                  return 0 === r.startOffset && 0 === r.endOffset ? v(e).before(xt.MARKERS) : v(e).after(xt.MARKERS), m.selection.restore(), !1
                }
              }
              a && a.stopPropagation(), i(e)
            }
          }
        }, m.helpers.isIOS() ? 100 : 0)
      }
    }

    function i(e) {
      var t = m.popups.get("link.edit");
      t || (t = function o() {
        var e = "";
        1 <= m.opts.linkEditButtons.length && ("A" == m.el.tagName && 0 <= m.opts.linkEditButtons.indexOf("linkRemove") && m.opts.linkEditButtons.splice(m.opts.linkEditButtons.indexOf("linkRemove"), 1), e = '<div class="fr-buttons">'.concat(m.button.buildList(m.opts.linkEditButtons), "</div>"));
        var t = {buttons: e}, n = m.popups.create("link.edit", t);
        m.$wp && m.events.$on(m.$wp, "scroll.link-edit", function () {
          b() && m.popups.isVisible("link.edit") && i(b())
        });
        return n
      }());
      var n = v(e);
      m.popups.isVisible("link.edit") || m.popups.refresh("link.edit"), m.popups.setContainer("link.edit", m.$sc);
      var r = n.offset().left + n.outerWidth() / 2, a = n.offset().top + n.outerHeight();
      m.popups.show("link.edit", r, a, n.outerHeight(), !0)
    }

    function o() {
      m.popups.hide("link.edit")
    }

    function l() {
      var e = m.popups.get("link.insert"), t = b();
      if (t) {
        var n, r, a = v(t), o = e.find('input.fr-link-attr[type="text"]'),
          i = e.find('input.fr-link-attr[type="checkbox"]');
        for (n = 0; n < o.length; n++) (r = v(o[n])).val(a.attr(r.attr("name") || ""));
        for (i.attr("checked", !1), n = 0; n < i.length; n++) r = v(i[n]), a.attr(r.attr("name")) == r.data("checked") && r.attr("checked", !0);
        e.find('input.fr-link-attr[type="text"][name="text"]').val(a.text())
      } else e.find('input.fr-link-attr[type="text"]').val(""), e.find('input.fr-link-attr[type="checkbox"]').attr("checked", !1), e.find('input.fr-link-attr[type="text"][name="text"]').val(m.selection.text());
      e.find("input.fr-link-attr").trigger("change"), (m.image ? m.image.get() : null) ? e.find('.fr-link-attr[name="text"]').parent().hide() : e.find('.fr-link-attr[name="text"]').parent().show()
    }

    function s(e) {
      if (e) return m.popups.onRefresh("link.insert", l), !0;
      var t = "";
      1 <= m.opts.linkInsertButtons.length && (t = '<div class="fr-buttons fr-tabs">'.concat(m.button.buildList(m.opts.linkInsertButtons), "</div>"));
      var n = "", r = 0;
      for (var a in n = '<div class="fr-link-insert-layer fr-layer fr-active" id="fr-link-insert-layer-'.concat(m.id, '">'), n += '<div class="fr-input-line"><input id="fr-link-insert-layer-url-'.concat(m.id, '" name="href" type="text" class="fr-link-attr" placeholder="').concat(m.language.translate("URL"), '" tabIndex="').concat(++r, '"></div>'), m.opts.linkText && (n += '<div class="fr-input-line"><input id="fr-link-insert-layer-text-'.concat(m.id, '" name="text" type="text" class="fr-link-attr" placeholder="').concat(m.language.translate("Text"), '" tabIndex="').concat(++r, '"></div>')), m.opts.linkAttributes) if (m.opts.linkAttributes.hasOwnProperty(a)) {
        var o = m.opts.linkAttributes[a];
        n += '<div class="fr-input-line"><input name="'.concat(a, '" type="text" class="fr-link-attr" placeholder="').concat(m.language.translate(o), '" tabIndex="').concat(++r, '"></div>')
      }
      m.opts.linkAlwaysBlank || (n += '<div class="fr-checkbox-line"><span class="fr-checkbox"><input name="target" class="fr-link-attr" data-checked="_blank" type="checkbox" id="fr-link-target-'.concat(m.id, '" tabIndex="').concat(++r, '"><span>').concat('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg>', '</span></span><label id="fr-label-target-').concat(m.id, '">').concat(m.language.translate("Open in new tab"), "</label></div>"));
      var i = {
        buttons: t,
        input_layer: n += '<div class="fr-action-buttons"><button class="fr-command fr-submit" role="button" data-cmd="linkInsert" href="#" tabIndex="'.concat(++r, '" type="button">').concat(m.language.translate("Insert"), "</button></div></div>")
      }, s = m.popups.create("link.insert", i);
      return m.$wp && m.events.$on(m.$wp, "scroll.link-insert", function () {
        (m.image ? m.image.get() : null) && m.popups.isVisible("link.insert") && f(), m.popups.isVisible("link.insert") && d()
      }), s
    }

    function c(e, t, n) {
      if (m.opts.trackChangesEnabled) {
        if (m.edit.on(), m.events.focus(!0), m.undo.saveStep(), m.markers.insert(), m.html.wrap(), !m.$el.find(".fr-marker").length) return void m.popups.hide("link.insert");
        m.markers.remove()
      }
      if (void 0 === n && (n = {}), !1 === m.events.trigger("link.beforeInsert", [e, t, n])) return !1;
      var r = m.image ? m.image.get() : null;
      r || "A" == m.el.tagName ? "A" == m.el.tagName && m.$el.focus() : (m.selection.restore(), m.popups.hide("link.insert"));
      var a = e;
      m.opts.linkConvertEmailAddress && m.helpers.isEmail(e) && !/^mailto:.*/i.test(e) && (e = "mailto:".concat(e));
      if ("" === m.opts.linkAutoPrefix || new RegExp("^(" + xt.LinkProtocols.join("|") + "):.", "i").test(e) || /^data:image.*/i.test(e) || /^(https?:|ftps?:|file:|)\/\//i.test(e) || /^([A-Za-z]:(\\){1,2}|[A-Za-z]:((\\){1,2}[^\\]+)+)(\\)?$/i.test(e) || ["/", "{", "[", "#", "(", "."].indexOf((e || "")[0]) < 0 && (e = m.opts.linkAutoPrefix + e), e = m.helpers.sanitizeURL(e), m.opts.linkAlwaysBlank && (n.target = "_blank"), m.opts.linkAlwaysNoFollow && (n.rel = "nofollow"), m.helpers.isEmail(a) && (n.target = null, n.rel = null), "_blank" == n.target ? (m.opts.linkNoOpener && (n.rel ? n.rel += " noopener" : n.rel = "noopener"), m.opts.linkNoReferrer && (n.rel ? n.rel += " noreferrer" : n.rel = "noreferrer")) : null == n.target && (n.rel ? n.rel = n.rel.replace(/noopener/, "").replace(/noreferrer/, "") : n.rel = null), t = t || "", e === m.opts.linkAutoPrefix) return m.popups.get("link.insert").find('input[name="href"]').addClass("fr-error"), m.events.trigger("link.bad", [a]), !1;
      var o, i = b();
      if (i) {
        if ((o = v(i)).attr("href", e), 0 < t.length && o.text() != t && !r) {
          if (m.opts.trackChangesEnabled) {
            var s = v(o.get(0).outerHTML);
            s.insertBefore(o.parent());
            var l = m.track_changes.wrapLinkInTracking(s, m.track_changes.getPendingChanges().length - 1),
              c = m.track_changes.wrapInDelete(l);
            o.parent().append(c)
          }
          for (var d = o.get(0); 1 === d.childNodes.length && d.childNodes[0].nodeType == Node.ELEMENT_NODE;) d = d.childNodes[0];
          v(d).text(t)
        }
        for (var f in r || o.prepend(xt.START_MARKER).append(xt.END_MARKER), n) n[f] ? o.attr(f, n[f]) : o.removeAttr(f);
        r || m.selection.restore()
      } else {
        r ? (r.wrap('<a href="'.concat(e, '"></a>')), m.image.hasCaption() && r.parent().append(r.parents(".fr-img-caption").find(".fr-inner"))) : (m.format.remove("a"), m.selection.isCollapsed() ? (t = 0 === t.length ? a : t, m.html.insert('<a href="'.concat(e, '">').concat(xt.START_MARKER).concat(t.replace(/&/g, "&amp;").replace(/</, "&lt;", ">", "&gt;")).concat(xt.END_MARKER, "</a>")), m.selection.restore()) : 0 < t.length && t != m.selection.text().replace(/\n/g, "") ? (m.selection.remove(), m.html.insert('<a href="'.concat(e, '">').concat(xt.START_MARKER).concat(t.replace(/&/g, "&amp;")).concat(xt.END_MARKER, "</a>")), m.selection.restore()) : (!function g() {
          if (!m.selection.isCollapsed()) {
            m.selection.save();
            for (var e = m.$el.find(".fr-marker").addClass("fr-unprocessed").toArray(); e.length;) {
              var t = v(e.pop());
              t.removeClass("fr-unprocessed");
              var n = m.node.deepestParent(t.get(0));
              if (n) {
                for (var r = t.get(0), a = "", o = ""; r = r.parentNode, m.node.isBlock(r) || (a += m.node.closeTagString(r), o = m.node.openTagString(r) + o), r != n;) ;
                var i = m.node.openTagString(t.get(0)) + t.html() + m.node.closeTagString(t.get(0));
                t.replaceWith('<span id="fr-break"></span>');
                var s = n.outerHTML;
                s = (s = s.replace(/<span id="fr-break"><\/span>/g, a + i + o)).replace(o + a, ""), n.outerHTML = s
              }
              e = m.$el.find(".fr-marker.fr-unprocessed").toArray()
            }
            m.html.cleanEmptyTags(), m.selection.restore()
          }
        }(), m.format.apply("a", {href: e})));
        for (var p = C(), u = 0; u < p.length; u++) (o = v(p[u])).attr(n), o.removeAttr("_moz_dirty");
        1 == p.length && m.$wp && !r && (v(p[0]).prepend(xt.START_MARKER).append(xt.END_MARKER), m.selection.restore())
      }
      if (r) {
        var h = m.popups.get("link.insert");
        h && h.find("input:focus").blur(), m.image.edit(r)
      } else E()
    }

    function d() {
      o();
      var e = b();
      if (e) {
        var t = m.popups.get("link.insert");
        t || (t = s()), m.popups.isVisible("link.insert") || (m.popups.refresh("link.insert"), m.selection.save(), m.helpers.isMobile() && (m.events.disableBlur(), m.$el.blur(), m.events.enableBlur())), m.popups.setContainer("link.insert", m.$sc);
        var n = (m.image ? m.image.get() : null) || v(e), r = n.offset().left + n.outerWidth() / 2,
          a = n.offset().top + n.outerHeight();
        m.popups.show("link.insert", r, a, n.outerHeight(), !0)
      }
    }

    function f() {
      var e = m.image ? m.image.getEl() : null;
      if (e) {
        var t = m.popups.get("link.insert");
        m.image.hasCaption() && (e = e.find(".fr-img-wrap")), t || (t = s()), l(), m.popups.setContainer("link.insert", m.$sc);
        var n = e.offset().left + e.outerWidth() / 2, r = e.offset().top + e.outerHeight();
        m.popups.show("link.insert", n, r, e.outerHeight(), !0)
      }
    }

    return {
      _init: function e() {
        m.events.on("keyup", function (e) {
          e.which != xt.KEYCODE.ESC && E(e)
        }), m.events.on("window.mouseup", E), m.events.$on(m.$el, "click", "a", function (e) {
          m.edit.isDisabled() && e.preventDefault()
        }), m.helpers.isMobile() && m.events.$on(m.$doc, "selectionchange", E), s(!0), "A" == m.el.tagName && m.$el.addClass("fr-view"), m.events.on("toolbar.esc", function () {
          if (m.popups.isVisible("link.edit")) return m.events.disableBlur(), m.events.focus(), !1
        }, !0)
      }, remove: function r() {
        var e = b(), t = m.image ? m.image.get() : null;
        if (!1 === m.events.trigger("link.beforeRemove", [e])) return !1;
        if (t && e) if (m.image.hasCaption()) {
          t.addClass("img-link-caption"), v(e).replaceWith(v(e).html());
          var n = document.querySelectorAll("img.img-link-caption");
          m.image.edit(v(n[0])), v(n[0]).removeClass("img-link-caption")
        } else t.unwrap(), m.image.edit(t); else e && (m.selection.save(), v(e).replaceWith(v(e).html()), m.selection.restore(), o())
      }, showInsertPopup: function p() {
        var e = m.$tb.find('.fr-command[data-cmd="insertLink"]'), t = m.popups.get("link.insert");
        if (t || (t = s()), !t.hasClass("fr-active")) if (m.popups.refresh("link.insert"), m.popups.setContainer("link.insert", m.$tb || m.$sc), e.isVisible()) {
          var n = m.button.getPosition(e), r = n.left, a = n.top;
          m.popups.show("link.insert", r, a, e.outerHeight())
        } else m.position.forSelection(t), m.popups.show("link.insert")
      }, usePredefined: function u(e) {
        var t, n, r = m.opts.linkList[e], a = m.popups.get("link.insert"),
          o = a.find('input.fr-link-attr[type="text"]'), i = a.find('input.fr-link-attr[type="checkbox"]');
        for (r.rel && (a.rel = r.rel), n = 0; n < o.length; n++) r[(t = v(o[n])).attr("name")] ? (t.val(r[t.attr("name")]), t.toggleClass("fr-not-empty", !0)) : "text" != t.attr("name") && t.val("");
        for (n = 0; n < i.length; n++) (t = v(i[n])).attr("checked", t.data("checked") == r[t.attr("name")]);
        m.accessibility.focusPopup(a)
      }, insertCallback: function h() {
        var e, t, n = m.popups.get("link.insert"), r = n.find('input.fr-link-attr[type="text"]'),
          a = n.find('input.fr-link-attr[type="checkbox"]'), o = (r.filter('[name="href"]').val() || "").trim(),
          i = m.opts.linkText ? r.filter('[name="text"]').val() : "", s = {};
        for (t = 0; t < r.length; t++) e = v(r[t]), ["href", "text"].indexOf(e.attr("name")) < 0 && (s[e.attr("name")] = e.val());
        for (t = 0; t < a.length; t++) (e = v(a[t])).is(":checked") ? s[e.attr("name")] = e.data("checked") : s[e.attr("name")] = e.data("unchecked") || null;
        n.rel && (s.rel = n.rel);
        var l = m.helpers.scrollTop();
        c(o, i, s), v(m.o_win).scrollTop(l)
      }, insert: c, update: d, get: b, allSelected: C, back: function t() {
        m.image && m.image.get() ? m.image.back() : (m.events.disableBlur(), m.selection.restore(), m.events.enableBlur(), b() && m.$wp ? (m.selection.restore(), o(), E()) : "A" == m.el.tagName ? (m.$el.focus(), E()) : (m.popups.hide("link.insert"), m.toolbar.showInline()))
      }, imageLink: f, applyStyle: function g(e, t, n) {
        void 0 === n && (n = m.opts.linkMultipleStyles), void 0 === t && (t = m.opts.linkStyles);
        var r = b();
        if (!r) return !1;
        if (!n) {
          var a = Object.keys(t);
          a.splice(a.indexOf(e), 1), v(r).removeClass(a.join(" "))
        }
        v(r).toggleClass(e), E()
      }
    }
  }, xt.DefineIcon("insertLink", {
    NAME: "link",
    SVG_KEY: "insertLink"
  }), xt.RegisterShortcut(xt.KEYCODE.K, "insertLink", null, "K"), xt.RegisterCommand("insertLink", {
    title: "Insert Link",
    undo: !1,
    focus: !0,
    refreshOnCallback: !1,
    popup: !0,
    callback: function () {
      this.popups.isVisible("link.insert") ? (this.$el.find(".fr-marker").length && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("link.insert")) : this.link.showInsertPopup()
    },
    plugin: "link"
  }), xt.DefineIcon("linkOpen", {
    NAME: "external-link",
    FA5NAME: "external-link-alt",
    SVG_KEY: "openLink"
  }), xt.RegisterCommand("linkOpen", {
    title: "Open Link", undo: !1, refresh: function (e) {
      this.link.get() ? e.removeClass("fr-hidden") : e.addClass("fr-hidden")
    }, callback: function () {
      var e = this.link.get();
      e && (-1 !== e.href.indexOf("mailto:") ? this.o_win.open(e.href).close() : (e.target || (e.target = "_self"), this.browser.msie || this.browser.edge ? this.o_win.open(e.href, e.target) : this.o_win.open(e.href, e.target, "noopener")), this.popups.hide("link.edit"))
    }, plugin: "link"
  }), xt.DefineIcon("linkEdit", {NAME: "edit", SVG_KEY: "edit"}), xt.RegisterCommand("linkEdit", {
    title: "Edit Link",
    undo: !1,
    refreshAfterCallback: !1,
    popup: !0,
    callback: function () {
      this.link.update()
    },
    refresh: function (e) {
      this.link.get() ? e.removeClass("fr-hidden") : e.addClass("fr-hidden")
    },
    plugin: "link"
  }), xt.DefineIcon("linkRemove", {
    NAME: "unlink",
    SVG_KEY: "unlink"
  }), xt.RegisterCommand("linkRemove", {
    title: "Unlink", callback: function () {
      this.link.remove()
    }, refresh: function (e) {
      this.link.get() ? e.removeClass("fr-hidden") : e.addClass("fr-hidden")
    }, plugin: "link"
  }), xt.DefineIcon("linkBack", {NAME: "arrow-left", SVG_KEY: "back"}), xt.RegisterCommand("linkBack", {
    title: "Back",
    undo: !1,
    focus: !1,
    back: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.link.back()
    },
    refresh: function (e) {
      var t = this.link.get() && this.doc.hasFocus();
      (this.image ? this.image.get() : null) || t || this.opts.toolbarInline ? (e.removeClass("fr-hidden"), e.next(".fr-separator").removeClass("fr-hidden")) : (e.addClass("fr-hidden"), e.next(".fr-separator").addClass("fr-hidden"))
    },
    plugin: "link"
  }), xt.DefineIcon("linkList", {
    NAME: "search",
    SVG_KEY: "search"
  }), xt.RegisterCommand("linkList", {
    title: "Choose Link",
    type: "dropdown",
    focus: !1,
    undo: !1,
    refreshAfterCallback: !1,
    html: function () {
      for (var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.linkList, n = 0; n < t.length; n++) e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="linkList" data-param1="'.concat(n, '">').concat(t[n].displayText || t[n].text, "</a></li>");
      return e += "</ul>"
    },
    callback: function (e, t) {
      this.link.usePredefined(t)
    },
    plugin: "link"
  }), xt.RegisterCommand("linkInsert", {
    focus: !1, refreshAfterCallback: !1, callback: function () {
      this.link.insertCallback()
    }, refresh: function (e) {
      this.link.get() ? e.text(this.language.translate("Update")) : e.text(this.language.translate("Insert"))
    }, plugin: "link"
  }), xt.DefineIcon("imageLink", {
    NAME: "link",
    SVG_KEY: "insertLink"
  }), xt.RegisterCommand("imageLink", {
    title: "Insert Link", undo: !1, focus: !1, popup: !0, callback: function () {
      this.link.imageLink()
    }, refresh: function (e) {
      var t;
      this.link.get() ? ((t = e.prev()).hasClass("fr-separator") && t.removeClass("fr-hidden"), e.addClass("fr-hidden")) : ((t = e.prev()).hasClass("fr-separator") && t.addClass("fr-hidden"), e.removeClass("fr-hidden"))
    }, plugin: "link"
  }), xt.DefineIcon("linkStyle", {
    NAME: "magic",
    SVG_KEY: "linkStyles"
  }), xt.RegisterCommand("linkStyle", {
    title: "Style", type: "dropdown", html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.linkStyles;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="linkStyle" data-param1="'.concat(n, '">').concat(this.language.translate(t[n]), "</a></li>"));
      return e += "</ul>"
    }, callback: function (e, t) {
      this.link.applyStyle(t)
    }, refreshOnShow: function (e, t) {
      var n = this.$, r = this.link.get();
      if (r) {
        var a = n(r);
        t.find(".fr-command").each(function () {
          var e = n(this).data("param1"), t = a.hasClass(e);
          n(this).toggleClass("fr-active", t).attr("aria-selected", t)
        })
      }
    }, refresh: function (e) {
      this.link.get() ? e.removeClass("fr-hidden") : e.addClass("fr-hidden")
    }, plugin: "link"
  }), Object.assign(xt.DEFAULTS, {listAdvancedTypes: !0}), xt.PLUGINS.lists = function (f) {
    var p = f.$;

    function u(e) {
      return '<span class="fr-open-'.concat(e.toLowerCase(), '"></span>')
    }

    function h(e) {
      return '<span class="fr-close-'.concat(e.toLowerCase(), '"></span>')
    }

    function o(e, t) {
      !function c(e, t) {
        for (var n = [], r = 0; r < e.length; r++) {
          var a = e[r].parentNode;
          "LI" == e[r].tagName && a.tagName != t && n.indexOf(a) < 0 && n.push(a)
        }
        for (var o = n.length - 1; 0 <= o; o--) {
          var i = p(n[o]);
          i.replaceWith("<".concat(t.toLowerCase(), " ").concat(f.node.attributes(i.get(0)), ">").concat(i.html(), "</").concat(t.toLowerCase(), ">"))
        }
      }(e, t);
      var n, r = f.html.defaultTag(), a = null;
      e.length && (n = "rtl" == f.opts.direction || "rtl" == p(e[0]).css("direction") ? "margin-right" : "margin-left");
      for (var o = 0; o < e.length; o++) if ("TD" != e[o].tagName && "TH" != e[o].tagName && "LI" != e[o].tagName) {
        var i = f.helpers.getPX(p(e[o]).css(n)) || 0;
        (e[o].style.marginLeft = null) === a && (a = i);
        var s = 0 < a ? "<".concat(t, ' style="').concat(n, ": ").concat(a, 'px ">') : "<".concat(t, ">"),
          l = "</".concat(t, ">");
        for (i -= a; 0 < i / f.opts.indentMargin;) s += "</".concat(t, ">"), l += l, i -= f.opts.indentMargin;
        r && e[o].tagName.toLowerCase() == r ? p(e[o]).replaceWith("".concat(s, "<li").concat(f.node.attributes(e[o]), ">").concat(p(e[o]).html(), "</li>").concat(l)) : p(e[o]).wrap("".concat(s, "<li></li>").concat(l))
      }
      f.clean.lists()
    }

    function i(e) {
      var t, n;
      for (t = e.length - 1; 0 <= t; t--) for (n = t - 1; 0 <= n; n--) if (p(e[n]).find(e[t]).length || e[n] == e[t]) {
        e.splice(t, 1);
        break
      }
      var r = [];
      for (t = 0; t < e.length; t++) {
        var a = p(e[t]), o = e[t].parentNode, i = a.attr("class");
        if (a.before(h(o.tagName)), "LI" == o.parentNode.tagName) a.before(h("LI")), a.after(u("LI")); else {
          var s = "";
          i && (s += ' class="'.concat(i, '"'));
          var l = "rtl" == f.opts.direction || "rtl" == a.css("direction") ? "margin-right" : "margin-left";
          f.helpers.getPX(p(o).css(l)) && 0 <= (p(o).attr("style") || "").indexOf("".concat(l, ":")) && (s += ' style="'.concat(l, ":").concat(f.helpers.getPX(p(o).css(l)), 'px;"')), f.html.defaultTag() && 0 === a.find(f.html.blockTagsQuery()).length && a.wrapInner(f.html.defaultTag() + s), f.node.isEmpty(a.get(0), !0) || 0 !== a.find(f.html.blockTagsQuery()).length || a.append("<br>"), a.append(u("LI")), a.prepend(h("LI"))
        }
        a.after(u(o.tagName)), "LI" == o.parentNode.tagName && (o = o.parentNode.parentNode), r.indexOf(o) < 0 && r.push(o)
      }
      for (t = 0; t < r.length; t++) {
        var c = p(r[t]), d = c.html();
        d = (d = d.replace(/<span class="fr-close-([a-z]*)"><\/span>/g, "</$1>")).replace(/<span class="fr-open-([a-z]*)"><\/span>/g, "<$1>"), c.replaceWith(f.node.openTagString(c.get(0)) + d + f.node.closeTagString(c.get(0)))
      }
      f.$el.find("li:empty").remove(), f.$el.find("ul:empty, ol:empty").remove(), f.clean.lists(), f.$el.find("ul:empty, ol:empty").remove(), f.html.wrap()
    }

    function l(e) {
      f.selection.save();
      for (var t = 0; t < e.length; t++) {
        var n = e[t].previousSibling;
        if (n) {
          var r = p(e[t]).find("> ul, > ol").last().get(0);
          if (r) {
            var a = p(document.createElement("li"));
            p(r).prepend(a);
            for (var o = f.node.contents(e[t])[0]; o && !f.node.isList(o);) {
              var i = o.nextSibling;
              a.append(o), o = i
            }
            p(n).append(p(r)), p(e[t]).remove()
          } else {
            var s = p(n).find("> ul, > ol").last().get(0);
            if (s) p(s).append(p(e[t])); else {
              var l = p("<".concat(e[t].parentNode.tagName, ">"));
              p(n).append(l), l.append(p(e[t]))
            }
          }
        }
      }
      f.clean.lists(), f.selection.restore()
    }

    function c(e) {
      f.selection.save(), i(e), f.selection.restore()
    }

    function e(e) {
      if ("indent" == e || "outdent" == e) {
        var t = !1, n = f.selection.blocks(), r = [], a = n[0].previousSibling || n[0].parentElement;
        if ("outdent" == e) {
          if ("UL" != a.parentNode.tagName && "OL" != a.parentNode.tagName && "LI" != a.parentNode.tagName) return;
          if (!n[0].previousSibling && "none" == a.parentNode.style.listStyleType) return void function i(e) {
            for (f.selection.save(); 0 < e.childNodes.length;) e.parentNode.parentNode.append(e.childNodes[0]);
            f.clean.lists(), f.selection.restore()
          }(a)
        } else {
          if ("UL" != a.parentNode.tagName && "OL" != a.parentNode.tagName && "LI" != a.parentNode.tagName) return;
          if (!n[0].previousSibling || "LI" != n[0].previousSibling.tagName) return void function s(e) {
            f.selection.save();
            for (var t = "OL" == e.tagName ? document.createElement("ol") : document.createElement("ul"); 0 < e.childNodes.length;) t.append(e.childNodes[0]);
            var n = document.createElement("li");
            t.style.listStyleType = "none", t.append(n), e.append(t), f.clean.lists(), f.selection.restore()
          }(a)
        }
        for (var o = 0; o < n.length; o++) "LI" == n[o].tagName ? (t = !0, r.push(n[o])) : "LI" == n[o].parentNode.tagName && (t = !0, r.push(n[o].parentNode));
        t && ("indent" == e ? l(r) : c(r))
      }
    }

    return {
      _init: function t() {
        f.events.on("commands.after", e), f.events.on("keydown", function (e) {
          if (e.which == xt.KEYCODE.TAB) {
            for (var t = f.selection.blocks(), n = [], r = 0; r < t.length; r++) "LI" == t[r].tagName ? n.push(t[r]) : "LI" == t[r].parentNode.tagName && n.push(t[r].parentNode);
            if (1 < n.length || n.length && (f.selection.info(n[0]).atStart || f.node.isEmpty(n[0]))) return e.preventDefault(), e.stopPropagation(), e.shiftKey ? c(n) : l(n), !1
          }
        }, !0)
      }, format: function s(e, t) {
        var n, r;
        for (f.html.syncInputs(), f.selection.save(), f.html.wrap(!0, !0, !0, !0), f.selection.restore(), r = f.selection.blocks(!0), n = 0; n < r.length; n++) "LI" != r[n].tagName && "LI" == r[n].parentNode.tagName && (r[n] = r[n].parentNode);
        if (f.selection.save(), function a(e, t) {
          for (var n = !0, r = 0; r < e.length; r++) {
            if ("LI" != e[r].tagName) return !1;
            e[r].parentNode.tagName != t && (n = !1)
          }
          return n
        }(r, e) ? t || i(r) : o(r, e), f.html.unwrap(), f.selection.restore(), t = t || "default") {
          for (r = f.selection.blocks(), n = 0; n < r.length; n++) "LI" != r[n].tagName && "LI" == r[n].parentNode.tagName && (r[n] = r[n].parentNode);
          for (n = 0; n < r.length; n++) "LI" == r[n].tagName && (p(r[n].parentNode).css("list-style-type", "default" === t ? "" : t), 0 === (p(r[n].parentNode).attr("style") || "").length && p(r[n].parentNode).removeAttr("style"))
        }
      }, refresh: function a(e, t) {
        var n = p(f.selection.element());
        if (n.get(0) != f.el) {
          var r = n.get(0);
          (r = "LI" != r.tagName && r.firstElementChild && "LI" != r.firstElementChild.tagName ? n.parents("li").get(0) : "LI" == r.tagName || r.firstElementChild ? r.firstElementChild && "LI" == r.firstElementChild.tagName ? n.get(0).firstChild : n.get(0) : n.parents("li").get(0)) && r.parentNode.tagName == t && f.el.contains(r.parentNode) && e.addClass("fr-active")
        }
      }
    }
  }, xt.DefineIcon("formatOLSimple", {
    NAME: "list-ol",
    SVG_KEY: "orderedList"
  }), xt.RegisterCommand("formatOLSimple", {
    title: "Ordered List",
    type: "button",
    options: {"default": "Default", circle: "Circle", disc: "Disc", square: "Square"},
    refresh: function (e) {
      this.lists.refresh(e, "OL")
    },
    callback: function (e, t) {
      this.lists.format("OL", t)
    },
    plugin: "lists"
  }), xt.RegisterCommand("formatUL", {
    title: "Unordered List", type: "button", hasOptions: function () {
      return this.opts.listAdvancedTypes
    }, options: {"default": "Default", circle: "Circle", disc: "Disc", square: "Square"}, refresh: function (e) {
      this.lists.refresh(e, "UL")
    }, callback: function (e, t) {
      this.lists.format("UL", t)
    }, plugin: "lists"
  }), xt.RegisterCommand("formatOL", {
    title: "Ordered List",
    hasOptions: function () {
      return this.opts.listAdvancedTypes
    },
    options: {
      "default": "Default",
      "lower-alpha": "Lower Alpha",
      "lower-greek": "Lower Greek",
      "lower-roman": "Lower Roman",
      "upper-alpha": "Upper Alpha",
      "upper-roman": "Upper Roman"
    },
    refresh: function (e) {
      this.lists.refresh(e, "OL")
    },
    callback: function (e, t) {
      this.lists.format("OL", t)
    },
    plugin: "lists"
  }), xt.DefineIcon("formatUL", {
    NAME: "list-ul",
    SVG_KEY: "unorderedList"
  }), xt.DefineIcon("formatOL", {
    NAME: "list-ol",
    SVG_KEY: "orderedList"
  }), Object.assign(xt.DEFAULTS, {
    paragraphFormat: {
      N: "Normal",
      H1: "Heading 1",
      H2: "Heading 2",
      H3: "Heading 3",
      H4: "Heading 4",
      PRE: "Code"
    }, paragraphFormatSelection: !1, paragraphDefaultSelection: "Paragraph Format"
  }), xt.PLUGINS.paragraphFormat = function (p) {
    var u = p.$;

    function h(e, t) {
      var n = p.html.defaultTag();
      if (t && t.toLowerCase() != n) if (0 < e.find("ul, ol").length) {
        var r = u("<" + t + ">");
        e.prepend(r);
        for (var a = p.node.contents(e.get(0))[0]; a && ["UL", "OL"].indexOf(a.tagName) < 0;) {
          var o = a.nextSibling;
          r.append(a), a = o
        }
      } else e.html("<" + t + ">" + e.html() + "</" + t + ">")
    }

    return {
      apply: function g(e) {
        "N" == e && (e = p.html.defaultTag()), p.selection.save(), p.html.wrap(!0, !0, !p.opts.paragraphFormat.BLOCKQUOTE, !0, !0), p.selection.restore();
        var t, n, r, a, o, i, s, l, c = p.selection.blocks();
        p.selection.save(), p.$el.find("pre").attr("skip", !0);
        for (var d = 0; d < c.length; d++) if (c[d].tagName != e && !p.node.isList(c[d])) {
          var f = u(c[d]);
          "LI" == c[d].tagName ? h(f, e) : "LI" == c[d].parentNode.tagName && c[d] ? (i = f, s = e, l = p.html.defaultTag(), s && s.toLowerCase() != l || (s = 'div class="fr-temp-div"'), i.replaceWith(u("<" + s + ">").html(i.html()))) : 0 <= ["TD", "TH"].indexOf(c[d].parentNode.tagName) ? (r = f, a = e, o = p.html.defaultTag(), a || (a = 'div class="fr-temp-div"' + (p.node.isEmpty(r.get(0), !0) ? ' data-empty="true"' : "")), a.toLowerCase() == o ? (p.node.isEmpty(r.get(0), !0) || r.append("<br/>"), r.replaceWith(r.html())) : r.replaceWith(u("<" + a + ">").html(r.html()))) : (t = f, (n = e) || (n = 'div class="fr-temp-div"' + (p.node.isEmpty(t.get(0), !0) ? ' data-empty="true"' : "")), "H1" != n && "H2" != n && "H3" != n && "H4" != n && "H5" != n || !p.node.attributes(t.get(0)).includes("font-size:") ? t.replaceWith(u("<" + n + " " + p.node.attributes(t.get(0)) + ">").html(t.html()).removeAttr("data-empty")) : t.replaceWith(u("<" + n + " " + p.node.attributes(t.get(0)).replace(/font-size:[0-9]+px;?/, "") + ">").html(t.html()).removeAttr("data-empty")))
        }
        p.$el.find('pre:not([skip="true"]) + pre:not([skip="true"])').each(function () {
          u(this).prev().append("<br>" + u(this).html()), u(this).remove()
        }), p.$el.find("pre").removeAttr("skip"), p.html.unwrap(), p.selection.restore()
      }, refreshOnShow: function i(e, t) {
        var n = p.selection.blocks();
        if (n.length) {
          var r = n[0], a = "N", o = p.html.defaultTag();
          r.tagName.toLowerCase() != o && r != p.el && (a = r.tagName), t.find('.fr-command[data-param1="' + a + '"]').addClass("fr-active").attr("aria-selected", !0)
        } else t.find('.fr-command[data-param1="N"]').addClass("fr-active").attr("aria-selected", !0)
      }, refresh: function o(e) {
        if (p.opts.paragraphFormatSelection) {
          var t = p.selection.blocks();
          if (t.length) {
            var n = t[0], r = "N", a = p.html.defaultTag();
            n.tagName.toLowerCase() != a && n != p.el && (r = n.tagName), 0 <= ["LI", "TD", "TH"].indexOf(r) && (r = "N"), e.find(">span").text(p.language.translate(p.opts.paragraphFormat[r]))
          } else e.find(">span").text(p.language.translate(p.opts.paragraphFormat.N))
        }
      }
    }
  }, xt.RegisterCommand("paragraphFormat", {
    type: "dropdown", displaySelection: function (e) {
      return e.opts.paragraphFormatSelection
    }, defaultSelection: function (e) {
      return e.language.translate(e.opts.paragraphDefaultSelection)
    }, displaySelectionWidth: 80, html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.paragraphFormat;
      for (var n in t) if (t.hasOwnProperty(n)) {
        var r = this.shortcuts.get("paragraphFormat." + n);
        r = r ? '<span class="fr-shortcut">' + r + "</span>" : "", e += '<li role="presentation"><' + ("N" == n ? this.html.defaultTag() || "DIV" : n) + ' style="padding: 0 !important; margin: 0 !important; border: 0 !important; background-color: transparent !important; ' + ("PRE" == n || "N" == n ? "font-size: 15px" : "font-weight: bold !important; ") + ("H1" == n ? "font-size: 2em !important; " : "") + ("H2" == n ? "font-size: 1.5em !important; " : "") + ("H3" == n ? "font-size: 1.17em !important; " : "") + ("H4" == n ? "font-size: 15px !important;" : "") + '"  role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="paragraphFormat" data-param1="' + n + '" title="' + this.language.translate(t[n]) + '">' + this.language.translate(t[n]) + "</a></" + ("N" == n ? this.html.defaultTag() || "DIV" : n) + "></li>"
      }
      return e += "</ul>"
    }, title: "Paragraph Format", callback: function (e, t) {
      this.paragraphFormat.apply(t)
    }, refresh: function (e) {
      this.paragraphFormat.refresh(e)
    }, refreshOnShow: function (e, t) {
      this.paragraphFormat.refreshOnShow(e, t)
    }, plugin: "paragraphFormat"
  }), xt.DefineIcon("paragraphFormat", {
    NAME: "paragraph",
    SVG_KEY: "paragraphFormat"
  }), Object.assign(xt.DEFAULTS, {
    paragraphStyles: {
      "fr-text-gray": "Gray",
      "fr-text-bordered": "Bordered",
      "fr-text-spaced": "Spaced",
      "fr-text-uppercase": "Uppercase"
    }, paragraphMultipleStyles: !0
  }), xt.PLUGINS.paragraphStyle = function (s) {
    var l = s.$;
    return {
      _init: function e() {
      }, apply: function c(e, t, n) {
        void 0 === t && (t = s.opts.paragraphStyles), void 0 === n && (n = s.opts.paragraphMultipleStyles);
        var r = "";
        n || ((r = Object.keys(t)).splice(r.indexOf(e), 1), r = r.join(" ")), s.selection.save(), s.html.wrap(!0, !0, !0, !0), s.selection.restore();
        var a = s.selection.blocks();
        s.selection.save();
        for (var o = l(a[0]).hasClass(e), i = 0; i < a.length; i++) l(a[i]).removeClass(r).toggleClass(e, !o), l(a[i]).hasClass("fr-temp-div") && l(a[i]).removeClass("fr-temp-div"), "" === l(a[i]).attr("class") && l(a[i]).removeAttr("class");
        s.html.unwrap(), s.selection.restore()
      }, refreshOnShow: function a(e, t) {
        var n = s.selection.blocks();
        if (n.length) {
          var r = l(n[0]);
          t.find(".fr-command").each(function () {
            var e = l(this).data("param1"), t = r.hasClass(e);
            l(this).toggleClass("fr-active", t).attr("aria-selected", t)
          })
        }
      }
    }
  }, xt.RegisterCommand("paragraphStyle", {
    type: "dropdown", html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.paragraphStyles;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command '.concat(n, '" tabIndex="-1" role="option" data-cmd="paragraphStyle" data-param1="').concat(n, '" title="').concat(this.language.translate(t[n]), '">').concat(this.language.translate(t[n]), "</a></li>"));
      return e += "</ul>"
    }, title: "Paragraph Style", callback: function (e, t) {
      this.paragraphStyle.apply(t)
    }, refreshOnShow: function (e, t) {
      this.paragraphStyle.refreshOnShow(e, t)
    }, plugin: "paragraphStyle"
  }), xt.DefineIcon("paragraphStyle", {
    NAME: "magic",
    SVG_KEY: "paragraphStyle"
  }), Object.assign(xt.DEFAULTS, {html2pdf: window.html2pdf}), xt.PLUGINS.print = function (l) {
    return {
      run: function e() {
        !function s(e) {
          var t = l.html.get(), n = null;
          l.shared.print_iframe ? n = l.shared.print_iframe : ((n = document.createElement("iframe")).name = "fr-print", n.style.position = "fixed", n.style.top = "0", n.style.left = "-9999px", n.style.height = "100%", n.style.width = "0", n.style.overflow = "hidden", n.style["z-index"] = "2147483647", n.style.tabIndex = "-1", l.events.on("shared.destroy", function () {
            n.remove()
          }), l.shared.print_iframe = n);
          try {
            document.body.removeChild(n)
          } catch (i) {
          }
          document.body.appendChild(n);
          var r = function r() {
            e(), n.removeEventListener("load", r)
          };
          n.addEventListener("load", r);
          var a = n.contentWindow;
          a.document.open(), a.document.write("<!DOCTYPE html><html " + (l.opts.documentReady ? 'style="margin: 0; padding: 0;"' : "") + "><head><title>" + document.title + "</title>"), Array.prototype.forEach.call(document.querySelectorAll("style"), function (e) {
            e = e.cloneNode(!0), a.document.write(e.outerHTML)
          });
          var o = document.querySelectorAll("link[rel=stylesheet]");
          Array.prototype.forEach.call(o, function (e) {
            var t = document.createElement("link");
            t.rel = e.rel, t.href = e.href, t.media = "print", t.type = "text/css", t.media = "all", a.document.write(t.outerHTML)
          }), a.document.write('</head><body style="height:auto;text-align: ' + ("rtl" == l.opts.direction ? "right" : "left") + "; direction: " + l.opts.direction + "; " + (l.opts.documentReady ? " padding: 2cm; width: 17cm; margin: 0;" : "") + '"><div class="fr-view">'), a.document.write(t), a.document.write("</div></body></html>"), a.document.close()
        }(function () {
          setTimeout(function () {
            l.events.disableBlur(), window.frames["fr-print"].focus(), window.frames["fr-print"].print(), l.$win.get(0).focus(), l.events.disableBlur(), l.events.focus()
          }, 0)
        })
      }, toPDF: function t() {
        l.opts.html2pdf && (l.$el.css("text-align", "left"), l.opts.html2pdf().set({
          margin: [10, 20],
          html2canvas: {useCORS: !0}
        }).from(l.el).save(), setTimeout(function () {
          l.$el.css("text-align", "")
        }, 100))
      }
    }
  }, xt.DefineIcon("print", {NAME: "print", SVG_KEY: "print"}), xt.RegisterCommand("print", {
    title: "Print",
    undo: !1,
    focus: !1,
    plugin: "print",
    callback: function () {
      this.print.run()
    }
  }), xt.DefineIcon("getPDF", {
    NAME: "file-pdf-o",
    FA5NAME: "file-pdf",
    SVG_KEY: "pdfExport"
  }), xt.RegisterCommand("getPDF", {
    title: "Download PDF", type: "button", focus: !1, undo: !1, callback: function () {
      this.print.toPDF()
    }
  }), Object.assign(xt.DEFAULTS, {
    quickInsertButtons: ["image", "video", "embedly", "table", "ul", "ol", "hr"],
    quickInsertTags: ["p", "div", "h1", "h2", "h3", "h4", "h5", "h6", "pre", "blockquote"],
    quickInsertEnabled: !0
  }), xt.QUICK_INSERT_BUTTONS = {}, xt.DefineIcon("quickInsert", {
    SVG_KEY: "add",
    template: "svg"
  }), xt.RegisterQuickInsertButton = function (e, t) {
    xt.QUICK_INSERT_BUTTONS[e] = Object.assign({undo: !0}, t)
  }, xt.RegisterQuickInsertButton("image", {
    icon: "insertImage",
    requiredPlugin: "image",
    title: "Insert Image",
    undo: !1,
    callback: function () {
      var e = this, t = e.$;
      e.shared.$qi_image_input || (e.shared.$qi_image_input = t(document.createElement("input")).attr("accept", "image/" + e.opts.imageAllowedTypes.join(", image/").toLowerCase()).attr("name", "quickInsertImage".concat(this.id)).attr("style", "display: none;").attr("type", "file"), t("body").first().append(e.shared.$qi_image_input), e.events.$on(e.shared.$qi_image_input, "change", function () {
        var e = t(this).data("inst");
        this.files && (e.quickInsert.hide(), e.image.upload(this.files)), t(this).val("")
      }, !0)), e.$qi_image_input = e.shared.$qi_image_input, e.helpers.isMobile() && e.selection.save(), e.events.disableBlur(), e.$qi_image_input.data("inst", e)[0].click()
    }
  }), xt.RegisterQuickInsertButton("video", {
    icon: "insertVideo",
    requiredPlugin: "video",
    title: "Insert Video",
    undo: !1,
    callback: function () {
      var e = prompt(this.language.translate("Paste the URL of the video you want to insert."));
      e && this.video.insertByURL(e)
    }
  }), xt.RegisterQuickInsertButton("embedly", {
    icon: "embedly",
    requiredPlugin: "embedly",
    title: "Embed URL",
    undo: !1,
    callback: function () {
      var e = prompt(this.language.translate("Paste the URL of any web content you want to insert."));
      e && this.embedly.add(e)
    }
  }), xt.RegisterQuickInsertButton("table", {
    icon: "insertTable",
    requiredPlugin: "table",
    title: "Insert Table",
    callback: function () {
      this.table.insert(2, 2)
    }
  }), xt.RegisterQuickInsertButton("ol", {
    icon: "formatOL",
    requiredPlugin: "lists",
    title: "Ordered List",
    callback: function () {
      this.lists.format("OL")
    }
  }), xt.RegisterQuickInsertButton("ul", {
    icon: "formatUL",
    requiredPlugin: "lists",
    title: "Unordered List",
    callback: function () {
      this.lists.format("UL")
    }
  }), xt.RegisterQuickInsertButton("hr", {
    icon: "insertHR", title: "Insert Horizontal Line", callback: function () {
      this.commands.insertHR()
    }
  }), xt.PLUGINS.quickInsert = function (i) {
    var s, l, c = i.$, d = !1;

    function n(e) {
      var t, n, r;
      (t = e.offset().top - i.$box.offset().top, n = (i.$iframe && i.$iframe.offset().left || 0) + e.offset().left - e.position().left - 4 < s.outerWidth() ? e.offset().left + s.outerWidth() : 0 - s.outerWidth(), i.opts.enter != xt.ENTER_BR) ? r = (s.outerHeight() - e.outerHeight()) / 2 : (c(document.createElement("span")).html(xt.INVISIBLE_SPACE).insertAfter(e), r = (s.outerHeight() - e.next().outerHeight()) / 2, e.next().remove());
      if (i.opts.iframe) {
        var a = i.helpers.getPX(i.$wp.find(".fr-iframe").css("padding-top"));
        t += i.$iframe.offset().top + a
      }
      s.hasClass("fr-on") && 0 <= t && l.css("top", t - r), 0 <= t && t - Math.abs(r) <= i.$box.outerHeight() - e.outerHeight() ? (s.hasClass("fr-hidden") && (s.hasClass("fr-on") && f(), s.removeClass("fr-hidden")), s.css("top", t - r)) : s.hasClass("fr-visible") && !i.opts.toolbarInline && (s.addClass("fr-hidden"), p()), s.css("left", n)
    }

    function a(e) {
      i.markdown && i.markdown.isEnabled() || (s || function t() {
        i.shared.$quick_insert || (i.shared.$quick_insert = c(document.createElement("div")).attr("class", "fr-quick-insert").html('<a class="fr-floating-btn" role="button" tabIndex="-1" title="'.concat(i.language.translate("Quick Insert"), '">').concat(i.icon.create("quickInsert"), "</a>")));
        s = i.shared.$quick_insert, i.tooltip.bind(i.$box, ".fr-quick-insert > a.fr-floating-btn"), i.events.on("destroy", function () {
          c("body").first().append(s.removeClass("fr-on")), l && (p(), c("body").first().append(l.css("left", -9999).css("top", -9999)))
        }, !0), i.events.on("shared.destroy", function () {
          s.html("").removeData().remove(), s = null, l && (l.html("").removeData().remove(), l = null)
        }, !0), i.events.on("commands.before", o), i.events.on("commands.after", function () {
          i.popups.areVisible() || r()
        }), i.events.bindClick(i.$box, ".fr-quick-insert > a", f), i.events.bindClick(i.$box, ".fr-qi-helper > a.fr-btn", function (e) {
          var t = c(e.currentTarget).data("cmd");
          if (!1 === i.events.trigger("quickInsert.commands.before", [t])) return !1;
          xt.QUICK_INSERT_BUTTONS[t].callback.apply(i, [e.currentTarget]), xt.QUICK_INSERT_BUTTONS[t].undo && i.undo.saveStep(), i.events.trigger("quickInsert.commands.after", [t]), i.quickInsert.hide()
        }), i.events.$on(i.$wp, "scroll", u), i.events.$on(i.$tb, "transitionend", ".fr-more-toolbar", u)
      }(), s.hasClass("fr-on") && p(), i.$box.append(s), n(e), s.data("tag", e), s.addClass("fr-visible"))
    }

    function r() {
      if (i.core.hasFocus()) {
        var e = i.selection.element();
        if (i.opts.enter == xt.ENTER_BR || i.node.isBlock(e) || (e = i.node.blockParent(e)), i.opts.enter == xt.ENTER_BR && !i.node.isBlock(e)) {
          var t = i.node.deepestParent(e);
          t && (e = t)
        }
        var n = function n() {
          return i.opts.enter != xt.ENTER_BR && i.node.isEmpty(e) && 0 <= i.opts.quickInsertTags.indexOf(e.tagName.toLowerCase())
        }, r = function r() {
          return i.opts.enter == xt.ENTER_BR && ("BR" == e.tagName && (!e.previousSibling || "BR" == e.previousSibling.tagName || i.node.isBlock(e.previousSibling)) || i.node.isEmpty(e) && (!e.previousSibling || "BR" == e.previousSibling.tagName || i.node.isBlock(e.previousSibling)) && (!e.nextSibling || "BR" == e.nextSibling.tagName || i.node.isBlock(e.nextSibling)))
        };
        e && (n() || r()) ? s && s.data("tag").is(c(e)) && s.hasClass("fr-on") ? p() : i.selection.isCollapsed() && a(c(e)) : o()
      }
    }

    function o() {
      s && !d && (s.hasClass("fr-on") && p(), s.removeClass("fr-visible fr-on"), s.css("left", -9999).css("top", -9999))
    }

    function f(e) {
      if (e && e.preventDefault(), s.hasClass("fr-on") && !s.hasClass("fr-hidden")) p(); else {
        if (!i.shared.$qi_helper) {
          for (var t = i.opts.quickInsertButtons, n = '<div class="fr-qi-helper">', r = 0, a = 0; a < t.length; a++) {
            var o = xt.QUICK_INSERT_BUTTONS[t[a]];
            o && (!o.requiredPlugin || xt.PLUGINS[o.requiredPlugin] && 0 <= i.opts.pluginsEnabled.indexOf(o.requiredPlugin)) && (n += '<a class="fr-btn fr-floating-btn" role="button" title="'.concat(i.language.translate(o.title), '" tabIndex="-1" data-cmd="').concat(t[a], '" style="transition-delay: ').concat(.025 * r++, 's;">').concat(i.icon.create(o.icon), "</a>"))
          }
          n += "</div>", i.shared.$qi_helper = c(n), i.tooltip.bind(i.shared.$qi_helper, "a.fr-btn"), i.events.$on(i.shared.$qi_helper, "mousedown", function (e) {
            e.preventDefault()
          }, !0)
        }
        l = i.shared.$qi_helper, i.$box.append(l), d = !0, setTimeout(function () {
          d = !1, l.css("top", parseFloat(s.css("top"))), l.css("left", parseFloat(s.css("left")) + s.outerWidth()), l.find("a").addClass("fr-size-1"), s.addClass("fr-on")
        }, 10)
      }
    }

    function p() {
      var n = i.$box.find(".fr-qi-helper");
      n.length && function () {
        for (var t = n.find("a"), e = 0; e < t.length; e++) !function (e) {
          setTimeout(function () {
            n.children().eq(t.length - 1 - e).removeClass("fr-size-1")
          }, 25 * e)
        }(e);
        setTimeout(function () {
          n.css("left", -9999), s && !s.hasClass("fr-hidden") && s.removeClass("fr-on")
        }, 25 * e)
      }()
    }

    function u() {
      s.hasClass("fr-visible") && n(s.data("tag"))
    }

    return {
      _init: function e() {
        if (!i.$wp || !i.opts.quickInsertEnabled) return !1;
        i.popups.onShow("image.edit", o), i.events.on("mouseup", r), i.helpers.isMobile() && i.events.$on(c(i.o_doc), "selectionchange", r), i.events.on("blur", o), i.events.on("keyup", r), i.events.on("keydown", function () {
          setTimeout(function () {
            r()
          }, 0)
        })
      }, hide: o
    }
  }, xt.PLUGINS.quote = function (o) {
    var i = o.$;

    function s(e) {
      for (; e.parentNode && e.parentNode != o.el;) e = e.parentNode;
      return e
    }

    return {
      apply: function t(e) {
        o.selection.save(), o.html.wrap(!0, !0, !0, !0), o.selection.restore(), "increase" == e ? function r() {
          o.html.unwrap();
          var e, t = o.selection.blocks();
          for (e = 0; e < t.length; e++) t[e] = s(t[e]);
          o.selection.save();
          var n = i(document.createElement("blockquote"));
          for (n.insertBefore(t[0]), e = 0; e < t.length; e++) n.append(t[e]);
          o.opts.trackChangesEnabled && o.track_changes.addQuote(n), o.selection.isCollapsed() || o.selection.restore()
        }() : "decrease" == e && function a() {
          var e = o.opts.trackChangesEnabled;
          o.html.unwrap();
          var t, n = o.selection.blocks();
          for (t = 0; t < n.length; t++) "BLOCKQUOTE" != n[t].tagName && (n[t] = e && i(n[t]).parentsUntil(o.$el, "[data-track-id^=pending]").get(0) || i(n[t]).parentsUntil(o.$el, "BLOCKQUOTE").get(0));
          for (o.selection.save(), t = 0; t < n.length; t++) n[t] && (e ? o.track_changes.removeQuote(i(n[t]), t) : i(n[t]).replaceWith(n[t].innerHTML));
          o.selection.isCollapsed() || o.selection.restore()
        }()
      }
    }
  }, xt.RegisterShortcut(xt.KEYCODE.SINGLE_QUOTE, "quote", "increase", "'"), xt.RegisterShortcut(xt.KEYCODE.SINGLE_QUOTE, "quote", "decrease", "'", !0), xt.RegisterCommand("quote", {
    title: "Quote",
    type: "dropdown",
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = {increase: "Increase", decrease: "Decrease"};
      for (var n in t) if (t.hasOwnProperty(n)) {
        var r = this.shortcuts.get("quote.".concat(n));
        e += '<li role="presentation"><a class="fr-command fr-active '.concat(n, '" tabIndex="-1" role="option" data-cmd="quote" data-param1="').concat(n, '" title="').concat(t[n], '">').concat(this.language.translate(t[n])).concat(r ? '<span class="fr-shortcut">'.concat(r, "</span>") : "", "</a></li>")
      }
      return e += "</ul>"
    },
    callback: function (e, t) {
      this.quote.apply(t)
    },
    plugin: "quote"
  }), xt.DefineIcon("quote", {
    NAME: "quote-left",
    SVG_KEY: "blockquote"
  }), Object.assign(xt.DEFAULTS, {
    saveInterval: 1e4,
    saveURL: null,
    saveParams: {},
    saveParam: "body",
    saveMethod: "POST"
  }), xt.PLUGINS.save = function (s) {
    var l = s.$, r = null, c = null, t = !1, d = 1, f = 2, n = {};

    function p(e, t) {
      s.events.trigger("save.error", [{code: e, message: n[e]}, t])
    }

    function a(e) {
      void 0 === e && (e = s.html.get());
      var r = e, t = s.events.trigger("save.before", [e]);
      if (!1 === t) return !1;
      if ("string" == typeof t && (e = t), s.opts.saveURL) {
        var n = {};
        for (var a in s.opts.saveParams) if (s.opts.saveParams.hasOwnProperty(a)) {
          var o = s.opts.saveParams[a];
          n[a] = "function" == typeof o ? o.call(this) : o
        }
        var i = {};
        i[s.opts.saveParam] = e, l(this).ajax({
          method: s.opts.saveMethod,
          url: s.opts.saveURL,
          data: Object.assign(i, n),
          crossDomain: s.opts.requestWithCORS,
          withCredentials: s.opts.requestWithCredentials,
          headers: s.opts.requestHeaders,
          done: function (e, t, n) {
            c = r, s.events.trigger("save.after", [e])
          },
          fail: function (e) {
            p(f, e.response || e.responseText)
          }
        })
      } else p(d)
    }

    function o() {
      clearTimeout(r), r = setTimeout(function () {
        var e = s.html.get();
        (c != e || t) && (t = !1, a(c = e))
      }, 0)
    }

    return n[d] = "Missing saveURL option.", n[f] = "Something went wrong during save.", {
      _init: function i() {
        if (s.opts.letteringClass) for (var e = s.opts.letteringClass, t = s.$el.find(".".concat(e)).length, n = 0; n < t; n++) s.$el.find(".".concat(e))[n].innerHTML = s.$el.find(".".concat(e))[n].innerText.replace(/([\w'-]+|[?.",])/g, "<span class = 'fr-word-select'>$1</span>");
        s.opts.saveInterval && (c = s.html.get(), s.events.on("contentChanged", function () {
          setTimeout(o, s.opts.saveInterval)
        }), s.events.on("keydown destroy", function () {
          clearTimeout(r)
        }))
      }, save: a, reset: function e() {
        o(), t = !1
      }, force: function u() {
        t = !0
      }
    }
  }, xt.DefineIcon("save", {NAME: "floppy-o", FA5NAME: "save"}), xt.RegisterCommand("save", {
    title: "Save",
    undo: !1,
    focus: !1,
    refreshAfterCallback: !1,
    callback: function () {
      this.save.save()
    },
    plugin: "save"
  }), Object.assign(xt.DEFAULTS, {
    specialCharactersSets: [{
      title: "Latin",
      "char": "&iexcl;",
      list: [{"char": "&iexcl;", desc: "INVERTED EXCLAMATION MARK"}, {
        "char": "&cent;",
        desc: "CENT SIGN"
      }, {"char": "&pound;", desc: "POUND SIGN"}, {"char": "&curren;", desc: "CURRENCY SIGN"}, {
        "char": "&yen;",
        desc: "YEN SIGN"
      }, {"char": "&brvbar;", desc: "BROKEN BAR"}, {"char": "&sect;", desc: "SECTION SIGN"}, {
        "char": "&uml;",
        desc: "DIAERESIS"
      }, {"char": "&copy;", desc: "COPYRIGHT SIGN"}, {"char": "&trade;", desc: "TRADEMARK SIGN"}, {
        "char": "&ordf;",
        desc: "FEMININE ORDINAL INDICATOR"
      }, {"char": "&laquo;", desc: "LEFT-POINTING DOUBLE ANGLE QUOTATION MARK"}, {
        "char": "&not;",
        desc: "NOT SIGN"
      }, {"char": "&reg;", desc: "REGISTERED SIGN"}, {"char": "&macr;", desc: "MACRON"}, {
        "char": "&deg;",
        desc: "DEGREE SIGN"
      }, {"char": "&plusmn;", desc: "PLUS-MINUS SIGN"}, {"char": "&sup2;", desc: "SUPERSCRIPT TWO"}, {
        "char": "&sup3;",
        desc: "SUPERSCRIPT THREE"
      }, {"char": "&acute;", desc: "ACUTE ACCENT"}, {"char": "&micro;", desc: "MICRO SIGN"}, {
        "char": "&para;",
        desc: "PILCROW SIGN"
      }, {"char": "&middot;", desc: "MIDDLE DOT"}, {"char": "&cedil;", desc: "CEDILLA"}, {
        "char": "&sup1;",
        desc: "SUPERSCRIPT ONE"
      }, {"char": "&ordm;", desc: "MASCULINE ORDINAL INDICATOR"}, {
        "char": "&raquo;",
        desc: "RIGHT-POINTING DOUBLE ANGLE QUOTATION MARK"
      }, {"char": "&frac14;", desc: "VULGAR FRACTION ONE QUARTER"}, {
        "char": "&frac12;",
        desc: "VULGAR FRACTION ONE HALF"
      }, {"char": "&frac34;", desc: "VULGAR FRACTION THREE QUARTERS"}, {
        "char": "&iquest;",
        desc: "INVERTED QUESTION MARK"
      }, {"char": "&Agrave;", desc: "LATIN CAPITAL LETTER A WITH GRAVE"}, {
        "char": "&Aacute;",
        desc: "LATIN CAPITAL LETTER A WITH ACUTE"
      }, {"char": "&Acirc;", desc: "LATIN CAPITAL LETTER A WITH CIRCUMFLEX"}, {
        "char": "&Atilde;",
        desc: "LATIN CAPITAL LETTER A WITH TILDE"
      }, {"char": "&Auml;", desc: "LATIN CAPITAL LETTER A WITH DIAERESIS "}, {
        "char": "&Aring;",
        desc: "LATIN CAPITAL LETTER A WITH RING ABOVE"
      }, {"char": "&AElig;", desc: "LATIN CAPITAL LETTER AE"}, {
        "char": "&Ccedil;",
        desc: "LATIN CAPITAL LETTER C WITH CEDILLA"
      }, {"char": "&Egrave;", desc: "LATIN CAPITAL LETTER E WITH GRAVE"}, {
        "char": "&Eacute;",
        desc: "LATIN CAPITAL LETTER E WITH ACUTE"
      }, {"char": "&Ecirc;", desc: "LATIN CAPITAL LETTER E WITH CIRCUMFLEX"}, {
        "char": "&Euml;",
        desc: "LATIN CAPITAL LETTER E WITH DIAERESIS"
      }, {"char": "&Igrave;", desc: "LATIN CAPITAL LETTER I WITH GRAVE"}, {
        "char": "&Iacute;",
        desc: "LATIN CAPITAL LETTER I WITH ACUTE"
      }, {"char": "&Icirc;", desc: "LATIN CAPITAL LETTER I WITH CIRCUMFLEX"}, {
        "char": "&Iuml;",
        desc: "LATIN CAPITAL LETTER I WITH DIAERESIS"
      }, {"char": "&ETH;", desc: "LATIN CAPITAL LETTER ETH"}, {
        "char": "&Ntilde;",
        desc: "LATIN CAPITAL LETTER N WITH TILDE"
      }, {"char": "&Ograve;", desc: "LATIN CAPITAL LETTER O WITH GRAVE"}, {
        "char": "&Oacute;",
        desc: "LATIN CAPITAL LETTER O WITH ACUTE"
      }, {"char": "&Ocirc;", desc: "LATIN CAPITAL LETTER O WITH CIRCUMFLEX"}, {
        "char": "&Otilde;",
        desc: "LATIN CAPITAL LETTER O WITH TILDE"
      }, {"char": "&Ouml;", desc: "LATIN CAPITAL LETTER O WITH DIAERESIS"}, {
        "char": "&times;",
        desc: "MULTIPLICATION SIGN"
      }, {"char": "&Oslash;", desc: "LATIN CAPITAL LETTER O WITH STROKE"}, {
        "char": "&Ugrave;",
        desc: "LATIN CAPITAL LETTER U WITH GRAVE"
      }, {"char": "&Uacute;", desc: "LATIN CAPITAL LETTER U WITH ACUTE"}, {
        "char": "&Ucirc;",
        desc: "LATIN CAPITAL LETTER U WITH CIRCUMFLEX"
      }, {"char": "&Uuml;", desc: "LATIN CAPITAL LETTER U WITH DIAERESIS"}, {
        "char": "&Yacute;",
        desc: "LATIN CAPITAL LETTER Y WITH ACUTE"
      }, {"char": "&THORN;", desc: "LATIN CAPITAL LETTER THORN"}, {
        "char": "&szlig;",
        desc: "LATIN SMALL LETTER SHARP S"
      }, {"char": "&agrave;", desc: "LATIN SMALL LETTER A WITH GRAVE"}, {
        "char": "&aacute;",
        desc: "LATIN SMALL LETTER A WITH ACUTE "
      }, {"char": "&acirc;", desc: "LATIN SMALL LETTER A WITH CIRCUMFLEX"}, {
        "char": "&atilde;",
        desc: "LATIN SMALL LETTER A WITH TILDE"
      }, {"char": "&auml;", desc: "LATIN SMALL LETTER A WITH DIAERESIS"}, {
        "char": "&aring;",
        desc: "LATIN SMALL LETTER A WITH RING ABOVE"
      }, {"char": "&aelig;", desc: "LATIN SMALL LETTER AE"}, {
        "char": "&ccedil;",
        desc: "LATIN SMALL LETTER C WITH CEDILLA"
      }, {"char": "&egrave;", desc: "LATIN SMALL LETTER E WITH GRAVE"}, {
        "char": "&eacute;",
        desc: "LATIN SMALL LETTER E WITH ACUTE"
      }, {"char": "&ecirc;", desc: "LATIN SMALL LETTER E WITH CIRCUMFLEX"}, {
        "char": "&euml;",
        desc: "LATIN SMALL LETTER E WITH DIAERESIS"
      }, {"char": "&igrave;", desc: "LATIN SMALL LETTER I WITH GRAVE"}, {
        "char": "&iacute;",
        desc: "LATIN SMALL LETTER I WITH ACUTE"
      }, {"char": "&icirc;", desc: "LATIN SMALL LETTER I WITH CIRCUMFLEX"}, {
        "char": "&iuml;",
        desc: "LATIN SMALL LETTER I WITH DIAERESIS"
      }, {"char": "&eth;", desc: "LATIN SMALL LETTER ETH"}, {
        "char": "&ntilde;",
        desc: "LATIN SMALL LETTER N WITH TILDE"
      }, {"char": "&ograve;", desc: "LATIN SMALL LETTER O WITH GRAVE"}, {
        "char": "&oacute;",
        desc: "LATIN SMALL LETTER O WITH ACUTE"
      }, {"char": "&ocirc;", desc: "LATIN SMALL LETTER O WITH CIRCUMFLEX"}, {
        "char": "&otilde;",
        desc: "LATIN SMALL LETTER O WITH TILDE"
      }, {"char": "&ouml;", desc: "LATIN SMALL LETTER O WITH DIAERESIS"}, {
        "char": "&divide;",
        desc: "DIVISION SIGN"
      }, {"char": "&oslash;", desc: "LATIN SMALL LETTER O WITH STROKE"}, {
        "char": "&ugrave;",
        desc: "LATIN SMALL LETTER U WITH GRAVE"
      }, {"char": "&uacute;", desc: "LATIN SMALL LETTER U WITH ACUTE"}, {
        "char": "&ucirc;",
        desc: "LATIN SMALL LETTER U WITH CIRCUMFLEX"
      }, {"char": "&uuml;", desc: "LATIN SMALL LETTER U WITH DIAERESIS"}, {
        "char": "&yacute;",
        desc: "LATIN SMALL LETTER Y WITH ACUTE"
      }, {"char": "&thorn;", desc: "LATIN SMALL LETTER THORN"}, {
        "char": "&yuml;",
        desc: "LATIN SMALL LETTER Y WITH DIAERESIS"
      }]
    }, {
      title: "Greek",
      "char": "&Alpha;",
      list: [{"char": "&Alpha;", desc: "GREEK CAPITAL LETTER ALPHA"}, {
        "char": "&Beta;",
        desc: "GREEK CAPITAL LETTER BETA"
      }, {"char": "&Gamma;", desc: "GREEK CAPITAL LETTER GAMMA"}, {
        "char": "&Delta;",
        desc: "GREEK CAPITAL LETTER DELTA"
      }, {"char": "&Epsilon;", desc: "GREEK CAPITAL LETTER EPSILON"}, {
        "char": "&Zeta;",
        desc: "GREEK CAPITAL LETTER ZETA"
      }, {"char": "&Eta;", desc: "GREEK CAPITAL LETTER ETA"}, {
        "char": "&Theta;",
        desc: "GREEK CAPITAL LETTER THETA"
      }, {"char": "&Iota;", desc: "GREEK CAPITAL LETTER IOTA"}, {
        "char": "&Kappa;",
        desc: "GREEK CAPITAL LETTER KAPPA"
      }, {"char": "&Lambda;", desc: "GREEK CAPITAL LETTER LAMBDA"}, {
        "char": "&Mu;",
        desc: "GREEK CAPITAL LETTER MU"
      }, {"char": "&Nu;", desc: "GREEK CAPITAL LETTER NU"}, {
        "char": "&Xi;",
        desc: "GREEK CAPITAL LETTER XI"
      }, {"char": "&Omicron;", desc: "GREEK CAPITAL LETTER OMICRON"}, {
        "char": "&Pi;",
        desc: "GREEK CAPITAL LETTER PI"
      }, {"char": "&Rho;", desc: "GREEK CAPITAL LETTER RHO"}, {
        "char": "&Sigma;",
        desc: "GREEK CAPITAL LETTER SIGMA"
      }, {"char": "&Tau;", desc: "GREEK CAPITAL LETTER TAU"}, {
        "char": "&Upsilon;",
        desc: "GREEK CAPITAL LETTER UPSILON"
      }, {"char": "&Phi;", desc: "GREEK CAPITAL LETTER PHI"}, {
        "char": "&Chi;",
        desc: "GREEK CAPITAL LETTER CHI"
      }, {"char": "&Psi;", desc: "GREEK CAPITAL LETTER PSI"}, {
        "char": "&Omega;",
        desc: "GREEK CAPITAL LETTER OMEGA"
      }, {"char": "&alpha;", desc: "GREEK SMALL LETTER ALPHA"}, {
        "char": "&beta;",
        desc: "GREEK SMALL LETTER BETA"
      }, {"char": "&gamma;", desc: "GREEK SMALL LETTER GAMMA"}, {
        "char": "&delta;",
        desc: "GREEK SMALL LETTER DELTA"
      }, {"char": "&epsilon;", desc: "GREEK SMALL LETTER EPSILON"}, {
        "char": "&zeta;",
        desc: "GREEK SMALL LETTER ZETA"
      }, {"char": "&eta;", desc: "GREEK SMALL LETTER ETA"}, {
        "char": "&theta;",
        desc: "GREEK SMALL LETTER THETA"
      }, {"char": "&iota;", desc: "GREEK SMALL LETTER IOTA"}, {
        "char": "&kappa;",
        desc: "GREEK SMALL LETTER KAPPA"
      }, {"char": "&lambda;", desc: "GREEK SMALL LETTER LAMBDA"}, {
        "char": "&mu;",
        desc: "GREEK SMALL LETTER MU"
      }, {"char": "&nu;", desc: "GREEK SMALL LETTER NU"}, {
        "char": "&xi;",
        desc: "GREEK SMALL LETTER XI"
      }, {"char": "&omicron;", desc: "GREEK SMALL LETTER OMICRON"}, {
        "char": "&pi;",
        desc: "GREEK SMALL LETTER PI"
      }, {"char": "&rho;", desc: "GREEK SMALL LETTER RHO"}, {
        "char": "&sigmaf;",
        desc: "GREEK SMALL LETTER FINAL SIGMA"
      }, {"char": "&sigma;", desc: "GREEK SMALL LETTER SIGMA"}, {
        "char": "&tau;",
        desc: "GREEK SMALL LETTER TAU"
      }, {"char": "&upsilon;", desc: "GREEK SMALL LETTER UPSILON"}, {
        "char": "&phi;",
        desc: "GREEK SMALL LETTER PHI"
      }, {"char": "&chi;", desc: "GREEK SMALL LETTER CHI"}, {
        "char": "&psi;",
        desc: "GREEK SMALL LETTER PSI"
      }, {"char": "&omega;", desc: "GREEK SMALL LETTER OMEGA"}, {
        "char": "&thetasym;",
        desc: "GREEK THETA SYMBOL"
      }, {"char": "&upsih;", desc: "GREEK UPSILON WITH HOOK SYMBOL"}, {
        "char": "&straightphi;",
        desc: "GREEK PHI SYMBOL"
      }, {"char": "&piv;", desc: "GREEK PI SYMBOL"}, {
        "char": "&Gammad;",
        desc: "GREEK LETTER DIGAMMA"
      }, {"char": "&gammad;", desc: "GREEK SMALL LETTER DIGAMMA"}, {
        "char": "&varkappa;",
        desc: "GREEK KAPPA SYMBOL"
      }, {"char": "&varrho;", desc: "GREEK RHO SYMBOL"}, {
        "char": "&straightepsilon;",
        desc: "GREEK LUNATE EPSILON SYMBOL"
      }, {"char": "&backepsilon;", desc: "GREEK REVERSED LUNATE EPSILON SYMBOL"}]
    }, {
      title: "Cyrillic",
      "char": "&#x400",
      list: [{"char": "&#x400", desc: "CYRILLIC CAPITAL LETTER IE WITH GRAVE"}, {
        "char": "&#x401",
        desc: "CYRILLIC CAPITAL LETTER IO"
      }, {"char": "&#x402", desc: "CYRILLIC CAPITAL LETTER DJE"}, {
        "char": "&#x403",
        desc: "CYRILLIC CAPITAL LETTER GJE"
      }, {"char": "&#x404", desc: "CYRILLIC CAPITAL LETTER UKRAINIAN IE"}, {
        "char": "&#x405",
        desc: "CYRILLIC CAPITAL LETTER DZE"
      }, {"char": "&#x406", desc: "CYRILLIC CAPITAL LETTER BYELORUSSIAN-UKRAINIAN I"}, {
        "char": "&#x407",
        desc: "CYRILLIC CAPITAL LETTER YI"
      }, {"char": "&#x408", desc: "CYRILLIC CAPITAL LETTER JE"}, {
        "char": "&#x409",
        desc: "CYRILLIC CAPITAL LETTER LJE"
      }, {"char": "&#x40A", desc: "CYRILLIC CAPITAL LETTER NJE"}, {
        "char": "&#x40B",
        desc: "CYRILLIC CAPITAL LETTER TSHE"
      }, {"char": "&#x40C", desc: "CYRILLIC CAPITAL LETTER KJE"}, {
        "char": "&#x40D",
        desc: "CYRILLIC CAPITAL LETTER I WITH GRAVE"
      }, {"char": "&#x40E", desc: "CYRILLIC CAPITAL LETTER SHORT U"}, {
        "char": "&#x40F",
        desc: "CYRILLIC CAPITAL LETTER DZHE"
      }, {"char": "&#x410", desc: "CYRILLIC CAPITAL LETTER A"}, {
        "char": "&#x411",
        desc: "CYRILLIC CAPITAL LETTER BE"
      }, {"char": "&#x412", desc: "CYRILLIC CAPITAL LETTER VE"}, {
        "char": "&#x413",
        desc: "CYRILLIC CAPITAL LETTER GHE"
      }, {"char": "&#x414", desc: "CYRILLIC CAPITAL LETTER DE"}, {
        "char": "&#x415",
        desc: "CYRILLIC CAPITAL LETTER IE"
      }, {"char": "&#x416", desc: "CYRILLIC CAPITAL LETTER ZHE"}, {
        "char": "&#x417",
        desc: "CYRILLIC CAPITAL LETTER ZE"
      }, {"char": "&#x418", desc: "CYRILLIC CAPITAL LETTER I"}, {
        "char": "&#x419",
        desc: "CYRILLIC CAPITAL LETTER SHORT I"
      }, {"char": "&#x41A", desc: "CYRILLIC CAPITAL LETTER KA"}, {
        "char": "&#x41B",
        desc: "CYRILLIC CAPITAL LETTER EL"
      }, {"char": "&#x41C", desc: "CYRILLIC CAPITAL LETTER EM"}, {
        "char": "&#x41D",
        desc: "CYRILLIC CAPITAL LETTER EN"
      }, {"char": "&#x41E", desc: "CYRILLIC CAPITAL LETTER O"}, {
        "char": "&#x41F",
        desc: "CYRILLIC CAPITAL LETTER PE"
      }, {"char": "&#x420", desc: "CYRILLIC CAPITAL LETTER ER"}, {
        "char": "&#x421",
        desc: "CYRILLIC CAPITAL LETTER ES"
      }, {"char": "&#x422", desc: "CYRILLIC CAPITAL LETTER TE"}, {
        "char": "&#x423",
        desc: "CYRILLIC CAPITAL LETTER U"
      }, {"char": "&#x424", desc: "CYRILLIC CAPITAL LETTER EF"}, {
        "char": "&#x425",
        desc: "CYRILLIC CAPITAL LETTER HA"
      }, {"char": "&#x426", desc: "CYRILLIC CAPITAL LETTER TSE"}, {
        "char": "&#x427",
        desc: "CYRILLIC CAPITAL LETTER CHE"
      }, {"char": "&#x428", desc: "CYRILLIC CAPITAL LETTER SHA"}, {
        "char": "&#x429",
        desc: "CYRILLIC CAPITAL LETTER SHCHA"
      }, {"char": "&#x42A", desc: "CYRILLIC CAPITAL LETTER HARD SIGN"}, {
        "char": "&#x42B",
        desc: "CYRILLIC CAPITAL LETTER YERU"
      }, {"char": "&#x42C", desc: "CYRILLIC CAPITAL LETTER SOFT SIGN"}, {
        "char": "&#x42D",
        desc: "CYRILLIC CAPITAL LETTER E"
      }, {"char": "&#x42E", desc: "CYRILLIC CAPITAL LETTER YU"}, {
        "char": "&#x42F",
        desc: "CYRILLIC CAPITAL LETTER YA"
      }, {"char": "&#x430", desc: "CYRILLIC SMALL LETTER A"}, {
        "char": "&#x431",
        desc: "CYRILLIC SMALL LETTER BE"
      }, {"char": "&#x432", desc: "CYRILLIC SMALL LETTER VE"}, {
        "char": "&#x433",
        desc: "CYRILLIC SMALL LETTER GHE"
      }, {"char": "&#x434", desc: "CYRILLIC SMALL LETTER DE"}, {
        "char": "&#x435",
        desc: "CYRILLIC SMALL LETTER IE"
      }, {"char": "&#x436", desc: "CYRILLIC SMALL LETTER ZHE"}, {
        "char": "&#x437",
        desc: "CYRILLIC SMALL LETTER ZE"
      }, {"char": "&#x438", desc: "CYRILLIC SMALL LETTER I"}, {
        "char": "&#x439",
        desc: "CYRILLIC SMALL LETTER SHORT I"
      }, {"char": "&#x43A", desc: "CYRILLIC SMALL LETTER KA"}, {
        "char": "&#x43B",
        desc: "CYRILLIC SMALL LETTER EL"
      }, {"char": "&#x43C", desc: "CYRILLIC SMALL LETTER EM"}, {
        "char": "&#x43D",
        desc: "CYRILLIC SMALL LETTER EN"
      }, {"char": "&#x43E", desc: "CYRILLIC SMALL LETTER O"}, {
        "char": "&#x43F",
        desc: "CYRILLIC SMALL LETTER PE"
      }, {"char": "&#x440", desc: "CYRILLIC SMALL LETTER ER"}, {
        "char": "&#x441",
        desc: "CYRILLIC SMALL LETTER ES"
      }, {"char": "&#x442", desc: "CYRILLIC SMALL LETTER TE"}, {
        "char": "&#x443",
        desc: "CYRILLIC SMALL LETTER U"
      }, {"char": "&#x444", desc: "CYRILLIC SMALL LETTER EF"}, {
        "char": "&#x445",
        desc: "CYRILLIC SMALL LETTER HA"
      }, {"char": "&#x446", desc: "CYRILLIC SMALL LETTER TSE"}, {
        "char": "&#x447",
        desc: "CYRILLIC SMALL LETTER CHE"
      }, {"char": "&#x448", desc: "CYRILLIC SMALL LETTER SHA"}, {
        "char": "&#x449",
        desc: "CYRILLIC SMALL LETTER SHCHA"
      }, {"char": "&#x44A", desc: "CYRILLIC SMALL LETTER HARD SIGN"}, {
        "char": "&#x44B",
        desc: "CYRILLIC SMALL LETTER YERU"
      }, {"char": "&#x44C", desc: "CYRILLIC SMALL LETTER SOFT SIGN"}, {
        "char": "&#x44D",
        desc: "CYRILLIC SMALL LETTER E"
      }, {"char": "&#x44E", desc: "CYRILLIC SMALL LETTER YU"}, {
        "char": "&#x44F",
        desc: "CYRILLIC SMALL LETTER YA"
      }, {"char": "&#x450", desc: "CYRILLIC SMALL LETTER IE WITH GRAVE"}, {
        "char": "&#x451",
        desc: "CYRILLIC SMALL LETTER IO"
      }, {"char": "&#x452", desc: "CYRILLIC SMALL LETTER DJE"}, {
        "char": "&#x453",
        desc: "CYRILLIC SMALL LETTER GJE"
      }, {"char": "&#x454", desc: "CYRILLIC SMALL LETTER UKRAINIAN IE"}, {
        "char": "&#x455",
        desc: "CYRILLIC SMALL LETTER DZE"
      }, {"char": "&#x456", desc: "CYRILLIC SMALL LETTER BYELORUSSIAN-UKRAINIAN I"}, {
        "char": "&#x457",
        desc: "CYRILLIC SMALL LETTER YI"
      }, {"char": "&#x458", desc: "CYRILLIC SMALL LETTER JE"}, {
        "char": "&#x459",
        desc: "CYRILLIC SMALL LETTER LJE"
      }, {"char": "&#x45A", desc: "CYRILLIC SMALL LETTER NJE"}, {
        "char": "&#x45B",
        desc: "CYRILLIC SMALL LETTER TSHE"
      }, {"char": "&#x45C", desc: "CYRILLIC SMALL LETTER KJE"}, {
        "char": "&#x45D",
        desc: "CYRILLIC SMALL LETTER I WITH GRAVE"
      }, {"char": "&#x45E", desc: "CYRILLIC SMALL LETTER SHORT U"}, {
        "char": "&#x45F",
        desc: "CYRILLIC SMALL LETTER DZHE"
      }]
    }, {
      title: "Punctuation",
      "char": "&ndash;",
      list: [{"char": "&ndash;", desc: "EN DASH"}, {"char": "&mdash;", desc: "EM DASH"}, {
        "char": "&lsquo;",
        desc: "LEFT SINGLE QUOTATION MARK"
      }, {"char": "&rsquo;", desc: "RIGHT SINGLE QUOTATION MARK"}, {
        "char": "&sbquo;",
        desc: "SINGLE LOW-9 QUOTATION MARK"
      }, {"char": "&ldquo;", desc: "LEFT DOUBLE QUOTATION MARK"}, {
        "char": "&rdquo;",
        desc: "RIGHT DOUBLE QUOTATION MARK"
      }, {"char": "&bdquo;", desc: "DOUBLE LOW-9 QUOTATION MARK"}, {
        "char": "&dagger;",
        desc: "DAGGER"
      }, {"char": "&Dagger;", desc: "DOUBLE DAGGER"}, {"char": "&bull;", desc: "BULLET"}, {
        "char": "&hellip;",
        desc: "HORIZONTAL ELLIPSIS"
      }, {"char": "&permil;", desc: "PER MILLE SIGN"}, {"char": "&prime;", desc: "PRIME"}, {
        "char": "&Prime;",
        desc: "DOUBLE PRIME"
      }, {"char": "&lsaquo;", desc: "SINGLE LEFT-POINTING ANGLE QUOTATION MARK"}, {
        "char": "&rsaquo;",
        desc: "SINGLE RIGHT-POINTING ANGLE QUOTATION MARK"
      }, {"char": "&oline;", desc: "OVERLINE"}, {"char": "&frasl;", desc: "FRACTION SLASH"}]
    }, {
      title: "Currency",
      "char": "&#x20A0",
      list: [{"char": "&#x20A0", desc: "EURO-CURRENCY SIGN"}, {
        "char": "&#x20A1",
        desc: "COLON SIGN"
      }, {"char": "&#x20A2", desc: "CRUZEIRO SIGN"}, {"char": "&#x20A3", desc: "FRENCH FRANC SIGN"}, {
        "char": "&#x20A4",
        desc: "LIRA SIGN"
      }, {"char": "&#x20A5", desc: "MILL SIGN"}, {"char": "&#x20A6", desc: "NAIRA SIGN"}, {
        "char": "&#x20A7",
        desc: "PESETA SIGN"
      }, {"char": "&#x20A8", desc: "RUPEE SIGN"}, {"char": "&#x20A9", desc: "WON SIGN"}, {
        "char": "&#x20AA",
        desc: "NEW SHEQEL SIGN"
      }, {"char": "&#x20AB", desc: "DONG SIGN"}, {"char": "&#x20AC", desc: "EURO SIGN"}, {
        "char": "&#x20AD",
        desc: "KIP SIGN"
      }, {"char": "&#x20AE", desc: "TUGRIK SIGN"}, {"char": "&#x20AF", desc: "DRACHMA SIGN"}, {
        "char": "&#x20B0",
        desc: "GERMAN PENNY SYMBOL"
      }, {"char": "&#x20B1", desc: "PESO SIGN"}, {"char": "&#x20B2", desc: "GUARANI SIGN"}, {
        "char": "&#x20B3",
        desc: "AUSTRAL SIGN"
      }, {"char": "&#x20B4", desc: "HRYVNIA SIGN"}, {"char": "&#x20B5", desc: "CEDI SIGN"}, {
        "char": "&#x20B6",
        desc: "LIVRE TOURNOIS SIGN"
      }, {"char": "&#x20B7", desc: "SPESMILO SIGN"}, {"char": "&#x20B8", desc: "TENGE SIGN"}, {
        "char": "&#x20B9",
        desc: "INDIAN RUPEE SIGN"
      }]
    }, {
      title: "Arrows",
      "char": "&#x2190",
      list: [{"char": "&#x2190", desc: "LEFTWARDS ARROW"}, {
        "char": "&#x2191",
        desc: "UPWARDS ARROW"
      }, {"char": "&#x2192", desc: "RIGHTWARDS ARROW"}, {
        "char": "&#x2193",
        desc: "DOWNWARDS ARROW"
      }, {"char": "&#x2194", desc: "LEFT RIGHT ARROW"}, {"char": "&#x2195", desc: "UP DOWN ARROW"}, {
        "char": "&#x2196",
        desc: "NORTH WEST ARROW"
      }, {"char": "&#x2197", desc: "NORTH EAST ARROW"}, {
        "char": "&#x2198",
        desc: "SOUTH EAST ARROW"
      }, {"char": "&#x2199", desc: "SOUTH WEST ARROW"}, {
        "char": "&#x219A",
        desc: "LEFTWARDS ARROW WITH STROKE"
      }, {"char": "&#x219B", desc: "RIGHTWARDS ARROW WITH STROKE"}, {
        "char": "&#x219C",
        desc: "LEFTWARDS WAVE ARROW"
      }, {"char": "&#x219D", desc: "RIGHTWARDS WAVE ARROW"}, {
        "char": "&#x219E",
        desc: "LEFTWARDS TWO HEADED ARROW"
      }, {"char": "&#x219F", desc: "UPWARDS TWO HEADED ARROW"}, {
        "char": "&#x21A0",
        desc: "RIGHTWARDS TWO HEADED ARROW"
      }, {"char": "&#x21A1", desc: "DOWNWARDS TWO HEADED ARROW"}, {
        "char": "&#x21A2",
        desc: "LEFTWARDS ARROW WITH TAIL"
      }, {"char": "&#x21A3", desc: "RIGHTWARDS ARROW WITH TAIL"}, {
        "char": "&#x21A4",
        desc: "LEFTWARDS ARROW FROM BAR"
      }, {"char": "&#x21A5", desc: "UPWARDS ARROW FROM BAR"}, {
        "char": "&#x21A6",
        desc: "RIGHTWARDS ARROW FROM BAR"
      }, {"char": "&#x21A7", desc: "DOWNWARDS ARROW FROM BAR"}, {
        "char": "&#x21A8",
        desc: "UP DOWN ARROW WITH BASE"
      }, {"char": "&#x21A9", desc: "LEFTWARDS ARROW WITH HOOK"}, {
        "char": "&#x21AA",
        desc: "RIGHTWARDS ARROW WITH HOOK"
      }, {"char": "&#x21AB", desc: "LEFTWARDS ARROW WITH LOOP"}, {
        "char": "&#x21AC",
        desc: "RIGHTWARDS ARROW WITH LOOP"
      }, {"char": "&#x21AD", desc: "LEFT RIGHT WAVE ARROW"}, {
        "char": "&#x21AE",
        desc: "LEFT RIGHT ARROW WITH STROKE"
      }, {"char": "&#x21AF", desc: "DOWNWARDS ZIGZAG ARROW"}, {
        "char": "&#x21B0",
        desc: "UPWARDS ARROW WITH TIP LEFTWARDS"
      }, {"char": "&#x21B1", desc: "UPWARDS ARROW WITH TIP RIGHTWARDS"}, {
        "char": "&#x21B2",
        desc: "DOWNWARDS ARROW WITH TIP LEFTWARDS"
      }, {"char": "&#x21B3", desc: "DOWNWARDS ARROW WITH TIP RIGHTWARDS"}, {
        "char": "&#x21B4",
        desc: "RIGHTWARDS ARROW WITH CORNER DOWNWARDS"
      }, {"char": "&#x21B5", desc: "DOWNWARDS ARROW WITH CORNER LEFTWARDS"}, {
        "char": "&#x21B6",
        desc: "ANTICLOCKWISE TOP SEMICIRCLE ARROW"
      }, {"char": "&#x21B7", desc: "CLOCKWISE TOP SEMICIRCLE ARROW"}, {
        "char": "&#x21B8",
        desc: "NORTH WEST ARROW TO LONG BAR"
      }, {"char": "&#x21B9", desc: "LEFTWARDS ARROW TO BAR OVER RIGHTWARDS ARROW TO BAR"}, {
        "char": "&#x21BA",
        desc: "ANTICLOCKWISE OPEN CIRCLE ARROW"
      }, {"char": "&#x21BB", desc: "CLOCKWISE OPEN CIRCLE ARROW"}, {
        "char": "&#x21BC",
        desc: "LEFTWARDS HARPOON WITH BARB UPWARDS"
      }, {"char": "&#x21BD", desc: "LEFTWARDS HARPOON WITH BARB DOWNWARDS"}, {
        "char": "&#x21BE",
        desc: "UPWARDS HARPOON WITH BARB RIGHTWARDS"
      }, {"char": "&#x21BF", desc: "UPWARDS HARPOON WITH BARB LEFTWARDS"}, {
        "char": "&#x21C0",
        desc: "RIGHTWARDS HARPOON WITH BARB UPWARDS"
      }, {"char": "&#x21C1", desc: "RIGHTWARDS HARPOON WITH BARB DOWNWARDS"}, {
        "char": "&#x21C2",
        desc: "DOWNWARDS HARPOON WITH BARB RIGHTWARDS"
      }, {"char": "&#x21C3", desc: "DOWNWARDS HARPOON WITH BARB LEFTWARDS"}, {
        "char": "&#x21C4",
        desc: "RIGHTWARDS ARROW OVER LEFTWARDS ARROW"
      }, {"char": "&#x21C5", desc: "UPWARDS ARROW LEFTWARDS OF DOWNWARDS ARROW"}, {
        "char": "&#x21C6",
        desc: "LEFTWARDS ARROW OVER RIGHTWARDS ARROW"
      }, {"char": "&#x21C7", desc: "LEFTWARDS PAIRED ARROWS"}, {
        "char": "&#x21C8",
        desc: "UPWARDS PAIRED ARROWS"
      }, {"char": "&#x21C9", desc: "RIGHTWARDS PAIRED ARROWS"}, {
        "char": "&#x21CA",
        desc: "DOWNWARDS PAIRED ARROWS"
      }, {"char": "&#x21CB", desc: "LEFTWARDS HARPOON OVER RIGHTWARDS HARPOON"}, {
        "char": "&#x21CC",
        desc: "RIGHTWARDS HARPOON OVER LEFTWARDS HARPOON"
      }, {"char": "&#x21CD", desc: "LEFTWARDS DOUBLE ARROW WITH STROKE"}, {
        "char": "&#x21CE",
        desc: "LEFT RIGHT DOUBLE ARROW WITH STROKE"
      }, {"char": "&#x21CF", desc: "RIGHTWARDS DOUBLE ARROW WITH STROKE"}, {
        "char": "&#x21D0",
        desc: "LEFTWARDS DOUBLE ARROW"
      }, {"char": "&#x21D1", desc: "UPWARDS DOUBLE ARROW"}, {
        "char": "&#x21D2",
        desc: "RIGHTWARDS DOUBLE ARROW"
      }, {"char": "&#x21D3", desc: "DOWNWARDS DOUBLE ARROW"}, {
        "char": "&#x21D4",
        desc: "LEFT RIGHT DOUBLE ARROW"
      }, {"char": "&#x21D5", desc: "UP DOWN DOUBLE ARROW"}, {
        "char": "&#x21D6",
        desc: "NORTH WEST DOUBLE ARROW"
      }, {"char": "&#x21D7", desc: "NORTH EAST DOUBLE ARROW"}, {
        "char": "&#x21D8",
        desc: "SOUTH EAST DOUBLE ARROW"
      }, {"char": "&#x21D9", desc: "SOUTH WEST DOUBLE ARROW"}, {
        "char": "&#x21DA",
        desc: "LEFTWARDS TRIPLE ARROW"
      }, {"char": "&#x21DB", desc: "RIGHTWARDS TRIPLE ARROW"}, {
        "char": "&#x21DC",
        desc: "LEFTWARDS SQUIGGLE ARROW"
      }, {"char": "&#x21DD", desc: "RIGHTWARDS SQUIGGLE ARROW"}, {
        "char": "&#x21DE",
        desc: "UPWARDS ARROW WITH DOUBLE STROKE"
      }, {"char": "&#x21DF", desc: "DOWNWARDS ARROW WITH DOUBLE STROKE"}, {
        "char": "&#x21E0",
        desc: "LEFTWARDS DASHED ARROW"
      }, {"char": "&#x21E1", desc: "UPWARDS DASHED ARROW"}, {
        "char": "&#x21E2",
        desc: "RIGHTWARDS DASHED ARROW"
      }, {"char": "&#x21E3", desc: "DOWNWARDS DASHED ARROW"}, {
        "char": "&#x21E4",
        desc: "LEFTWARDS ARROW TO BAR"
      }, {"char": "&#x21E5", desc: "RIGHTWARDS ARROW TO BAR"}, {
        "char": "&#x21E6",
        desc: "LEFTWARDS WHITE ARROW"
      }, {"char": "&#x21E7", desc: "UPWARDS WHITE ARROW"}, {
        "char": "&#x21E8",
        desc: "RIGHTWARDS WHITE ARROW"
      }, {"char": "&#x21E9", desc: "DOWNWARDS WHITE ARROW"}, {
        "char": "&#x21EA",
        desc: "UPWARDS WHITE ARROW FROM BAR"
      }, {"char": "&#x21EB", desc: "UPWARDS WHITE ARROW ON PEDESTAL"}, {
        "char": "&#x21EC",
        desc: "UPWARDS WHITE ARROW ON PEDESTAL WITH HORIZONTAL BAR"
      }, {"char": "&#x21ED", desc: "UPWARDS WHITE ARROW ON PEDESTAL WITH VERTICAL BAR"}, {
        "char": "&#x21EE",
        desc: "UPWARDS WHITE DOUBLE ARROW"
      }, {"char": "&#x21EF", desc: "UPWARDS WHITE DOUBLE ARROW ON PEDESTAL"}, {
        "char": "&#x21F0",
        desc: "RIGHTWARDS WHITE ARROW FROM WALL"
      }, {"char": "&#x21F1", desc: "NORTH WEST ARROW TO CORNER"}, {
        "char": "&#x21F2",
        desc: "SOUTH EAST ARROW TO CORNER"
      }, {"char": "&#x21F3", desc: "UP DOWN WHITE ARROW"}, {
        "char": "&#x21F4",
        desc: "RIGHT ARROW WITH SMALL CIRCLE"
      }, {"char": "&#x21F5", desc: "DOWNWARDS ARROW LEFTWARDS OF UPWARDS ARROW"}, {
        "char": "&#x21F6",
        desc: "THREE RIGHTWARDS ARROWS"
      }, {"char": "&#x21F7", desc: "LEFTWARDS ARROW WITH VERTICAL STROKE"}, {
        "char": "&#x21F8",
        desc: "RIGHTWARDS ARROW WITH VERTICAL STROKE"
      }, {"char": "&#x21F9", desc: "LEFT RIGHT ARROW WITH VERTICAL STROKE"}, {
        "char": "&#x21FA",
        desc: "LEFTWARDS ARROW WITH DOUBLE VERTICAL STROKE"
      }, {"char": "&#x21FB", desc: "RIGHTWARDS ARROW WITH DOUBLE VERTICAL STROKE"}, {
        "char": "&#x21FC",
        desc: "LEFT RIGHT ARROW WITH DOUBLE VERTICAL STROKE"
      }, {"char": "&#x21FD", desc: "LEFTWARDS OPEN-HEADED ARROW"}, {
        "char": "&#x21FE",
        desc: "RIGHTWARDS OPEN-HEADED ARROW"
      }, {"char": "&#x21FF", desc: "LEFT RIGHT OPEN-HEADED ARROW"}]
    }, {
      title: "Math",
      "char": "&forall;",
      list: [{"char": "&forall;", desc: "FOR ALL"}, {
        "char": "&part;",
        desc: "PARTIAL DIFFERENTIAL"
      }, {"char": "&exist;", desc: "THERE EXISTS"}, {"char": "&empty;", desc: "EMPTY SET"}, {
        "char": "&nabla;",
        desc: "NABLA"
      }, {"char": "&isin;", desc: "ELEMENT OF"}, {"char": "&notin;", desc: "NOT AN ELEMENT OF"}, {
        "char": "&ni;",
        desc: "CONTAINS AS MEMBER"
      }, {"char": "&prod;", desc: "N-ARY PRODUCT"}, {"char": "&sum;", desc: "N-ARY SUMMATION"}, {
        "char": "&minus;",
        desc: "MINUS SIGN"
      }, {"char": "&lowast;", desc: "ASTERISK OPERATOR"}, {"char": "&radic;", desc: "SQUARE ROOT"}, {
        "char": "&prop;",
        desc: "PROPORTIONAL TO"
      }, {"char": "&infin;", desc: "INFINITY"}, {"char": "&ang;", desc: "ANGLE"}, {
        "char": "&and;",
        desc: "LOGICAL AND"
      }, {"char": "&or;", desc: "LOGICAL OR"}, {"char": "&cap;", desc: "INTERSECTION"}, {
        "char": "&cup;",
        desc: "UNION"
      }, {"char": "&int;", desc: "INTEGRAL"}, {"char": "&there4;", desc: "THEREFORE"}, {
        "char": "&sim;",
        desc: "TILDE OPERATOR"
      }, {"char": "&cong;", desc: "APPROXIMATELY EQUAL TO"}, {
        "char": "&asymp;",
        desc: "ALMOST EQUAL TO"
      }, {"char": "&ne;", desc: "NOT EQUAL TO"}, {"char": "&equiv;", desc: "IDENTICAL TO"}, {
        "char": "&le;",
        desc: "LESS-THAN OR EQUAL TO"
      }, {"char": "&ge;", desc: "GREATER-THAN OR EQUAL TO"}, {"char": "&sub;", desc: "SUBSET OF"}, {
        "char": "&sup;",
        desc: "SUPERSET OF"
      }, {"char": "&nsub;", desc: "NOT A SUBSET OF"}, {
        "char": "&sube;",
        desc: "SUBSET OF OR EQUAL TO"
      }, {"char": "&supe;", desc: "SUPERSET OF OR EQUAL TO"}, {
        "char": "&oplus;",
        desc: "CIRCLED PLUS"
      }, {"char": "&otimes;", desc: "CIRCLED TIMES"}, {"char": "&perp;", desc: "UP TACK"}]
    }, {
      title: "Misc",
      "char": "&spades;",
      list: [{"char": "&spades;", desc: "BLACK SPADE SUIT"}, {
        "char": "&clubs;",
        desc: "BLACK CLUB SUIT"
      }, {"char": "&hearts;", desc: "BLACK HEART SUIT"}, {
        "char": "&diams;",
        desc: "BLACK DIAMOND SUIT"
      }, {"char": "&#x2669", desc: "QUARTER NOTE"}, {"char": "&#x266A", desc: "EIGHTH NOTE"}, {
        "char": "&#x266B",
        desc: "BEAMED EIGHTH NOTES"
      }, {"char": "&#x266C", desc: "BEAMED SIXTEENTH NOTES"}, {
        "char": "&#x266D",
        desc: "MUSIC FLAT SIGN"
      }, {"char": "&#x266E", desc: "MUSIC NATURAL SIGN"}, {
        "char": "&#x2600",
        desc: "BLACK SUN WITH RAYS"
      }, {"char": "&#x2601", desc: "CLOUD"}, {"char": "&#x2602", desc: "UMBRELLA"}, {
        "char": "&#x2603",
        desc: "SNOWMAN"
      }, {"char": "&#x2615", desc: "HOT BEVERAGE"}, {"char": "&#x2618", desc: "SHAMROCK"}, {
        "char": "&#x262F",
        desc: "YIN YANG"
      }, {"char": "&#x2714", desc: "HEAVY CHECK MARK"}, {
        "char": "&#x2716",
        desc: "HEAVY MULTIPLICATION X"
      }, {"char": "&#x2744", desc: "SNOWFLAKE"}, {
        "char": "&#x275B",
        desc: "HEAVY SINGLE TURNED COMMA QUOTATION MARK ORNAMENT"
      }, {"char": "&#x275C", desc: "HEAVY SINGLE COMMA QUOTATION MARK ORNAMENT"}, {
        "char": "&#x275D",
        desc: "HEAVY DOUBLE TURNED COMMA QUOTATION MARK ORNAMENT"
      }, {"char": "&#x275E", desc: "HEAVY DOUBLE COMMA QUOTATION MARK ORNAMENT"}, {
        "char": "&#x2764",
        desc: "HEAVY BLACK HEART"
      }]
    }], specialCharButtons: ["specialCharBack", "|"]
  }), Object.assign(xt.POPUP_TEMPLATES, {specialCharacters: "[_BUTTONS_][_CUSTOM_LAYER_]"}), xt.PLUGINS.specialCharacters = function (g) {
    var m = g.$, n = g.opts.specialCharactersSets[0], a = g.opts.specialCharactersSets, i = "";

    function s() {
      return '\n        <div class="fr-buttons fr-tabs fr-tabs-scroll">\n          '.concat(function t(e, n) {
        var r = "";
        return e.forEach(function (e) {
          var t = {
            elementClass: e.title === n.title ? "fr-active fr-active-tab" : "",
            title: e.title,
            dataParam1: e.title,
            desc: e["char"]
          };
          r += '<button class="fr-command fr-btn fr-special-character-category '.concat(t.elementClass, '" title="').concat(t.title, '" data-cmd="setSpecialCharacterCategory" data-param1="').concat(t.dataParam1, '"><span>').concat(t.desc, "</span></button>")
        }), r
      }(a, n), '\n        </div>\n        <div class="fr-icon-container fr-sc-container">\n          ').concat(function r(e) {
        var n = "";
        return e.list.forEach(function (e) {
          var t = {dataParam1: e["char"], title: e.desc, splCharValue: e["char"]};
          n += '<span class="fr-command fr-special-character fr-icon" role="button" \n      data-cmd="insertSpecialCharacter" data-param1="'.concat(t.dataParam1, '" \n      title="').concat(t.title, '">').concat(t.splCharValue, "</span>")
        }), n
      }(n), "\n        </div>")
    }

    return {
      setSpecialCharacterCategory: function r(t) {
        n = a.filter(function (e) {
          return e.title === t
        })[0], function e() {
          g.popups.get("specialCharacters").html(i + s())
        }()
      }, showSpecialCharsPopup: function l() {
        var e = g.popups.get("specialCharacters");
        if (e || (e = function o() {
          g.opts.toolbarInline && 0 < g.opts.specialCharButtons.length && (i = '<div class="fr-buttons fr-tabs">'.concat(g.button.buildList(g.opts.specialCharButtons), "</div>"));
          var e = {buttons: i, custom_layer: s()}, t = g.popups.create("specialCharacters", e);
          return function n(h) {
            g.events.on("popup.tab", function (e) {
              var t = m(e.currentTarget);
              if (!g.popups.isVisible("specialCharacters") || !t.is("span, a")) return !0;
              var n, r, a, o = e.which;
              if (xt.KEYCODE.TAB == o) {
                if (t.is("span.fr-icon") && e.shiftKey || t.is("a") && !e.shiftKey) {
                  var i = h.find(".fr-buttons");
                  n = !g.accessibility.focusToolbar(i, !!e.shiftKey)
                }
                if (!1 !== n) {
                  var s = h.find("span.fr-icon:focus").first().concat(h.findVisible(" span.fr-icon").first().concat(h.find("a")));
                  t.is("span.fr-icon") && (s = s.not("span.fr-icon:not(:focus)")), r = s.index(t), r = e.shiftKey ? ((r - 1) % s.length + s.length) % s.length : (r + 1) % s.length, a = s.get(r), g.events.disableBlur(), a.focus(), n = !1
                }
              } else if (xt.KEYCODE.ARROW_UP == o || xt.KEYCODE.ARROW_DOWN == o || xt.KEYCODE.ARROW_LEFT == o || xt.KEYCODE.ARROW_RIGHT == o) {
                if (t.is("span.fr-icon")) {
                  var l = t.parent().find("span.fr-icon");
                  r = l.index(t);
                  var c = Math.floor(l.length / 11), d = r % 11, f = Math.floor(r / 11), p = 11 * f + d, u = 11 * c;
                  xt.KEYCODE.ARROW_UP == o ? p = ((p - 11) % u + u) % u : xt.KEYCODE.ARROW_DOWN == o ? p = (p + 11) % u : xt.KEYCODE.ARROW_LEFT == o ? p = ((p - 1) % u + u) % u : xt.KEYCODE.ARROW_RIGHT == o && (p = (p + 1) % u), a = m(l.get(p)), g.events.disableBlur(), a.focus(), n = !1
                }
              } else xt.KEYCODE.ENTER == o && (t.is("a") ? t[0].click() : g.button.exec(t), n = !1);
              return !1 === n && (e.preventDefault(), e.stopPropagation()), n
            }, !0)
          }(t), t
        }()), !e.hasClass("fr-active")) {
          g.popups.refresh("specialCharacters"), g.popups.setContainer("specialCharacters", g.$tb);
          var t = g.$tb.find('.fr-command[data-cmd="specialCharacters"]'), n = g.button.getPosition(t), r = n.left,
            a = n.top;
          g.popups.show("specialCharacters", r, a, outerHeight)
        }
      }, back: function e() {
        g.popups.hide("specialCharacters"), g.toolbar.showInline()
      }
    }
  }, xt.DefineIcon("specialCharacters", {
    NAME: "dollar-sign",
    SVG_KEY: "symbols"
  }), xt.RegisterCommand("specialCharacters", {
    title: "Special Characters",
    icon: "specialCharacters",
    undo: !1,
    focus: !1,
    popup: !0,
    refreshAfterCallback: !1,
    plugin: "specialCharacters",
    showOnMobile: !0,
    callback: function () {
      this.popups.isVisible("specialCharacters") ? (this.$el.find(".fr-marker") && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("specialCharacters")) : this.specialCharacters.showSpecialCharsPopup()
    }
  }), xt.RegisterCommand("insertSpecialCharacter", {
    callback: function (e, t) {
      this.undo.saveStep(), this.html.insert(t), this.undo.saveStep(), this.popups.hide("specialCharacters")
    }
  }), xt.RegisterCommand("setSpecialCharacterCategory", {
    undo: !1, focus: !1, callback: function (e, t) {
      this.specialCharacters.setSpecialCharacterCategory(t)
    }
  }), xt.DefineIcon("specialCharBack", {
    NAME: "arrow-left",
    SVG_KEY: "back"
  }), xt.RegisterCommand("specialCharBack", {
    title: "Back",
    undo: !1,
    focus: !1,
    back: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.specialCharacters.back()
    }
  }), Object.assign(xt.POPUP_TEMPLATES, {
    "table.insert": "[_BUTTONS_][_ROWS_COLUMNS_]",
    "table.edit": "[_BUTTONS_]",
    "table.colors": "[_BUTTONS_][_COLORS_][_CUSTOM_COLOR_]"
  }), Object.assign(xt.DEFAULTS, {
    tableInsertMaxSize: 10,
    tableEditButtons: ["tableHeader", "tableRemove", "tableRows", "tableColumns", "tableStyle", "-", "tableCells", "tableCellBackground", "tableCellVerticalAlign", "tableCellHorizontalAlign", "tableCellStyle"],
    tableInsertButtons: ["tableBack", "|"],
    tableResizer: !0,
    tableDefaultWidth: "100%",
    tableResizerOffset: 5,
    tableResizingLimit: 30,
    tableColorsButtons: ["tableBack", "|"],
    tableColors: ["#61BD6D", "#1ABC9C", "#54ACD2", "#2C82C9", "#9365B8", "#475577", "#CCCCCC", "#41A85F", "#00A885", "#3D8EB9", "#2969B0", "#553982", "#28324E", "#000000", "#F7DA64", "#FBA026", "#EB6B56", "#E25041", "#A38F84", "#EFEFEF", "#FFFFFF", "#FAC51C", "#F37934", "#D14841", "#B8312F", "#7C706B", "#D1D5D8", "REMOVE"],
    tableColorsStep: 7,
    tableCellStyles: {"fr-highlighted": "Highlighted", "fr-thick": "Thick"},
    tableStyles: {"fr-dashed-borders": "Dashed Borders", "fr-alternate-rows": "Alternate Rows"},
    tableCellMultipleStyles: !0,
    tableMultipleStyles: !0,
    tableInsertHelper: !0,
    tableInsertHelperOffset: 15
  }), xt.PLUGINS.table = function (L) {
    var _, c, a, o, r, i, w, A = L.$;

    function u() {
      var e = T();
      if (e) {
        var t = L.popups.get("table.edit");
        if (t || (t = p()), t) {
          L.popups.setContainer("table.edit", L.$sc);
          var n = M(e), r = n.left + (n.right - n.left) / 2, a = n.bottom;
          L.popups.show("table.edit", r, a, n.bottom - n.top, !0), L.edit.isDisabled() && (1 < Q().length && L.toolbar.disable(), L.$el.removeClass("fr-no-selection"), L.edit.on(), L.button.bulkRefresh(), L.selection.setAtEnd(L.$el.find(".fr-selected-cell").last().get(0)), L.selection.restore())
        }
      }
    }

    function s() {
      var e = T();
      if (e) {
        var t = L.popups.get("table.colors");
        t || (t = function i() {
          var e = "";
          0 < L.opts.tableColorsButtons.length && (e = '<div class="fr-buttons fr-tabs">'.concat(L.button.buildList(L.opts.tableColorsButtons), "</div>"));
          var t = "";
          L.opts.colorsHEXInput && (t = '<div class="fr-color-hex-layer fr-table-colors-hex-layer fr-active fr-layer" id="fr-table-colors-hex-layer-'.concat(L.id, '"><div class="fr-input-line"><input maxlength="7" id="fr-table-colors-hex-layer-text-').concat(L.id, '" type="text" placeholder="').concat(L.language.translate("HEX Color"), '" tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="tableCellBackgroundCustomColor" tabIndex="2" role="button">').concat(L.language.translate("OK"), "</button></div></div>"));
          var n = {
            buttons: e, colors: function a() {
              for (var e = '<div class="fr-color-set fr-table-colors">', t = 0; t < L.opts.tableColors.length; t++) 0 !== t && t % L.opts.tableColorsStep == 0 && (e += "<br>"), "REMOVE" != L.opts.tableColors[t] ? e += '<span class="fr-command" style="background: '.concat(L.opts.tableColors[t], ';" tabIndex="-1" role="button" data-cmd="tableCellBackgroundColor" data-param1="').concat(L.opts.tableColors[t], '"><span class="fr-sr-only">').concat(L.language.translate("Color"), " ").concat(L.opts.tableColors[t], "&nbsp;&nbsp;&nbsp;</span></span>") : e += '<span class="fr-command" data-cmd="tableCellBackgroundColor" tabIndex="-1" role="button" data-param1="REMOVE" title="'.concat(L.language.translate("Clear Formatting"), '">').concat(L.icon.create("tableColorRemove"), '<span class="fr-sr-only">').concat(L.language.translate("Clear Formatting"), "</span></span>");
              return e += "</div>"
            }(), custom_color: t
          }, r = L.popups.create("table.colors", n);
          return L.events.$on(L.$wp, "scroll.table-colors", function () {
            L.popups.isVisible("table.colors") && s()
          }), function o(h) {
            L.events.on("popup.tab", function (e) {
              var t = A(e.currentTarget);
              if (!L.popups.isVisible("table.colors") || !t.is("span")) return !0;
              var n = e.which, r = !0;
              if (xt.KEYCODE.TAB == n) {
                var a = h.find(".fr-buttons");
                r = !L.accessibility.focusToolbar(a, !!e.shiftKey)
              } else if (xt.KEYCODE.ARROW_UP == n || xt.KEYCODE.ARROW_DOWN == n || xt.KEYCODE.ARROW_LEFT == n || xt.KEYCODE.ARROW_RIGHT == n) {
                var o = t.parent().find("span.fr-command"), i = o.index(t), s = L.opts.colorsStep,
                  l = Math.floor(o.length / s), c = i % s, d = Math.floor(i / s), f = d * s + c, p = l * s;
                xt.KEYCODE.ARROW_UP == n ? f = ((f - s) % p + p) % p : xt.KEYCODE.ARROW_DOWN == n ? f = (f + s) % p : xt.KEYCODE.ARROW_LEFT == n ? f = ((f - 1) % p + p) % p : xt.KEYCODE.ARROW_RIGHT == n && (f = (f + 1) % p);
                var u = A(o.get(f));
                L.events.disableBlur(), u.focus(), r = !1
              } else xt.KEYCODE.ENTER == n && (L.button.exec(t), r = !1);
              return !1 === r && (e.preventDefault(), e.stopPropagation()), r
            }, !0)
          }(r), r
        }()), L.popups.setContainer("table.colors", L.$sc);
        var n = M(e), r = (n.left + n.right) / 2, a = n.bottom;
        !function o() {
          var e = L.popups.get("table.colors"), t = L.$el.find(".fr-selected-cell").first(),
            n = L.helpers.RGBToHex(t.css("background-color")), r = e.find(".fr-table-colors-hex-layer input");
          e.find(".fr-selected-color").removeClass("fr-selected-color fr-active-item"), e.find('span[data-param1="'.concat(n, '"]')).addClass("fr-selected-color fr-active-item"), r.val(n).trigger("change")
        }(), L.popups.show("table.colors", r, a, n.bottom - n.top, !0)
      }
    }

    function l() {
      0 === Q().length && L.toolbar.enable()
    }

    function d(e) {
      if (e) return L.popups.onHide("table.insert", function () {
        L.popups.get("table.insert").find('.fr-table-size .fr-select-table-size > span[data-row="1"][data-col="1"]').trigger("mouseover")
      }), !0;
      var t = "";
      0 < L.opts.tableInsertButtons.length && (t = '<div class="fr-buttons fr-tabs">'.concat(L.button.buildList(L.opts.tableInsertButtons), "</div>"));
      var n = {
        buttons: t, rows_columns: function o() {
          for (var e = '<div class="fr-table-size"><div class="fr-table-size-info">1 &times; 1</div><div class="fr-select-table-size">', t = 1; t <= L.opts.tableInsertMaxSize; t++) {
            for (var n = 1; n <= L.opts.tableInsertMaxSize; n++) {
              var r = "inline-block";
              2 < t && !L.helpers.isMobile() && (r = "none");
              var a = "fr-table-cell ";
              1 == t && 1 == n && (a += " hover"), e += '<span class="fr-command '.concat(a, '" tabIndex="-1" data-cmd="tableInsert" data-row="').concat(t, '" data-col="').concat(n, '" data-param1="').concat(t, '" data-param2="').concat(n, '" style="display: ').concat(r, ';" role="button"><span></span><span class="fr-sr-only">').concat(t, " &times; ").concat(n, "&nbsp;&nbsp;&nbsp;</span></span>")
            }
            e += '<div class="new-line"></div>'
          }
          return e += "</div></div>"
        }()
      }, r = L.popups.create("table.insert", n);
      return L.events.$on(r, "mouseover", ".fr-table-size .fr-select-table-size .fr-table-cell", function (e) {
        f(A(e.currentTarget))
      }, !0), function a(e) {
        L.events.$on(e, "focus", "[tabIndex]", function (e) {
          var t = A(e.currentTarget);
          f(t)
        }), L.events.on("popup.tab", function (e) {
          var t = A(e.currentTarget);
          if (!L.popups.isVisible("table.insert") || !t.is("span, a")) return !0;
          var n, r = e.which;
          if (xt.KEYCODE.ARROW_UP == r || xt.KEYCODE.ARROW_DOWN == r || xt.KEYCODE.ARROW_LEFT == r || xt.KEYCODE.ARROW_RIGHT == r) {
            if (t.is("span.fr-table-cell")) {
              var a = t.parent().find("span.fr-table-cell"), o = a.index(t), i = L.opts.tableInsertMaxSize, s = o % i,
                l = Math.floor(o / i);
              xt.KEYCODE.ARROW_UP == r ? l = Math.max(0, l - 1) : xt.KEYCODE.ARROW_DOWN == r ? l = Math.min(L.opts.tableInsertMaxSize - 1, l + 1) : xt.KEYCODE.ARROW_LEFT == r ? s = Math.max(0, s - 1) : xt.KEYCODE.ARROW_RIGHT == r && (s = Math.min(L.opts.tableInsertMaxSize - 1, s + 1));
              var c = l * i + s, d = A(a.get(c));
              f(d), L.events.disableBlur(), d.focus(), n = !1
            }
          } else xt.KEYCODE.ENTER == r && (L.button.exec(t), n = !1);
          return !1 === n && (e.preventDefault(), e.stopPropagation()), n
        }, !0)
      }(r), r
    }

    function f(e) {
      var t = e.data("row");
      null !== t && (t = parseInt(t));
      var n = e.data("col");
      null !== n && (n = parseInt(n));
      var r = e.parent();
      r.siblings(".fr-table-size-info").html("".concat(t, " &times; ").concat(n)), r.find("> span").removeClass("hover fr-active-item");
      for (var a = 1; a <= L.opts.tableInsertMaxSize; a++) for (var o = 0; o <= L.opts.tableInsertMaxSize; o++) {
        var i = r.find('> span[data-row="'.concat(a, '"][data-col="').concat(o, '"]'));
        a <= t && o <= n ? i.addClass("hover") : a <= t + 1 || a <= 2 && !L.helpers.isMobile() ? i.css("display", "inline-block") : 2 < a && !L.helpers.isMobile() && i.css("display", "none")
      }
      e.addClass("fr-active-item")
    }

    function p(e) {
      if (e) return L.popups.onHide("table.edit", l), !0;
      if (0 < L.opts.tableEditButtons.length) {
        var t = {buttons: '<div class="fr-buttons">'.concat(L.button.buildList(L.opts.tableEditButtons), "</div>")},
          n = L.popups.create("table.edit", t);
        return L.events.$on(L.$wp, "scroll.table-edit", function () {
          L.popups.isVisible("table.edit") && u()
        }), n
      }
      return !1
    }

    function h() {
      if (0 < Q().length) {
        var e = J();
        L.selection.setBefore(e.get(0)) || L.selection.setAfter(e.get(0)), L.selection.restore(), L.popups.hide("table.edit"), L.opts.trackChangesEnabled ? (L.track_changes.removedTable(e), y()) : e.remove(), L.toolbar.enable()
      }
    }

    function g(e) {
      var t = J();
      if (0 < t.length) {
        if (0 < L.$el.find("th.fr-selected-cell").length && "above" == e) return;
        var n, r, a, o = T(), i = R(o);
        if (null == i) return;
        r = "above" == e ? i.min_i : i.max_i;
        var s = "<tr>";
        for (n = 0; n < o[r].length; n++) {
          if ("below" == e && r < o.length - 1 && o[r][n] == o[r + 1][n] || "above" == e && 0 < r && o[r][n] == o[r - 1][n]) {
            if (0 === n || 0 < n && o[r][n] != o[r][n - 1]) {
              var l = A(o[r][n]);
              l.attr("rowspan", parseInt(l.attr("rowspan"), 10) + 1)
            }
          } else s += '<td style="' + A(o[r][n]).attr("style") + '" ><br></td>'
        }
        s += "</tr>", a = 0 < L.$el.find("th.fr-selected-cell").length && "below" == e ? A(t.find("tbody").not(t.find("> table tbody"))) : A(t.find("tr").not(t.find("> table tr")).get(r)), "below" == e ? "TBODY" == a.attr("tagName") ? a.prepend(s) : a[0].parentNode && a[0].insertAdjacentHTML("afterend", s) : "above" == e && (a.before(s), L.popups.isVisible("table.edit") && u())
      }
    }

    function m(e, t, n) {
      var r, a, o, i, s, l = 0, c = T(n);
      if (e < (t = Math.min(t, c[0].length - 1))) for (a = e; a <= t; a++) if (!(e < a && c[0][a] == c[0][a - 1]) && 1 < (i = Math.min(parseInt(c[0][a].getAttribute("colspan"), 10) || 1, t - e + 1)) && c[0][a] == c[0][a + 1]) for (l = i - 1, r = 1; r < c.length; r++) if (c[r][a] != c[r - 1][a]) {
        for (o = a; o < a + i; o++) if (1 < (s = parseInt(c[r][o].getAttribute("colspan"), 10) || 1) && c[r][o] == c[r][o + 1]) o += l = Math.min(l, s - 1); else if (!(l = Math.max(0, l - 1))) break;
        if (!l) break
      }
      l && b(c, l, "colspan", 0, c.length - 1, e, t)
    }

    function v(e, t, n) {
      var r, a, o, i, s, l = 0, c = T(n);
      if (e < (t = Math.min(t, c.length - 1))) for (r = e; r <= t; r++) if (!(e < r && c[r][0] == c[r - 1][0]) && c[r][0] !== undefined && 1 < (i = Math.min(parseInt(c[r][0].getAttribute("rowspan"), 10) || 1, t - e + 1)) && c[r][0] == c[r + 1][0]) for (l = i - 1, a = 1; a < c[0].length; a++) if (c[r][a] != c[r][a - 1]) {
        for (o = r; o < r + i; o++) if (1 < (s = parseInt(c[o][a].getAttribute("rowspan"), 10) || 1) && c[o][a] == c[o + 1][a]) o += l = Math.min(l, s - 1); else if (!(l = Math.max(0, l - 1))) break;
        if (!l) break
      }
      l && b(c, l, "rowspan", e, t, 0, c[0].length - 1)
    }

    function b(e, t, n, r, a, o, i) {
      var s, l, c;
      for (s = r; s <= a; s++) for (l = o; l <= i; l++) r < s && e[s][l] == e[s - 1][l] || o < l && e[s][l] == e[s][l - 1] || e[s][l] !== undefined && 1 < (c = parseInt(e[s][l].getAttribute(n), 10) || 1) && (1 < c - t ? e[s][l].setAttribute(n, c - t) : e[s][l].removeAttribute(n))
    }

    function C(e, t, n, r, a) {
      v(e, t, a), m(n, r, a)
    }

    function t(e) {
      var t = L.$el.find(".fr-selected-cell");
      "REMOVE" != e ? t.css("background-color", L.helpers.HEXtoRGB(e)) : t.css("background-color", ""), u()
    }

    function T(e) {
      var c = [];
      if (null == (e = e || null) && 0 < Q().length && (e = J()), e) {
        for (var t = e.find("tr:empty"), n = t.length - 1; 0 <= n; n--) A(t[n]).remove();
        e.findVisible("tr").not(e.find("> table tr")).each(function (s, e) {
          var t = A(e), l = 0;
          t.find("> th, > td").each(function (e, t) {
            for (var n = A(t), r = parseInt(n.attr("colspan"), 10) || 1, a = parseInt(n.attr("rowspan"), 10) || 1, o = s; o < s + a; o++) for (var i = l; i < l + r; i++) c[o] || (c[o] = []), c[o][i] ? l++ : c[o][i] = t;
            l += r
          })
        })
      }
      return c
    }

    function S(e, t) {
      for (var n = 0; n < t.length; n++) for (var r = 0; r < t[n].length; r++) if (t[n][r] == e) return {row: n, col: r}
    }

    function k(e, t, n) {
      for (var r = e + 1, a = t + 1; r < n.length;) {
        if (n[r][t] != n[e][t]) {
          r--;
          break
        }
        r++
      }
      for (r == n.length && r--; a < n[e].length;) {
        if (n[e][a] != n[e][t]) {
          a--;
          break
        }
        a++
      }
      return a == n[e].length && a--, {row: r, col: a}
    }

    function E() {
      L.el.querySelector(".fr-cell-fixed") && L.el.querySelector(".fr-cell-fixed").classList.remove("fr-cell-fixed"), L.el.querySelector(".fr-cell-handler") && L.el.querySelector(".fr-cell-handler").classList.remove("fr-cell-handler")
    }

    function y() {
      var e = L.$el.find(".fr-selected-cell");
      0 < e.length && e.each(function () {
        var e = A(this);
        e.removeClass("fr-selected-cell"), "" === e.attr("class") && e.removeAttr("class")
      }), E()
    }

    function x() {
      L.events.disableBlur(), L.selection.clear(), L.$el.addClass("fr-no-selection"), L.$el.blur(), L.events.enableBlur()
    }

    function R(e) {
      var t = L.$el.find(".fr-selected-cell");
      if (0 < t.length) {
        var n, r = e.length, a = 0, o = e[0].length, i = 0;
        for (n = 0; n < t.length; n++) {
          var s = S(t[n], e), l = k(s.row, s.col, e);
          r = Math.min(s.row, r), a = Math.max(l.row, a), o = Math.min(s.col, o), i = Math.max(l.col, i)
        }
        return {min_i: r, max_i: a, min_j: o, max_j: i}
      }
      return null
    }

    function M(e) {
      var t = R(e);
      if (null != t) {
        var n = A(e[t.min_i][t.min_j]), r = A(e[t.min_i][t.max_j]), a = A(e[t.max_i][t.min_j]);
        return {
          left: n.length && n.offset().left,
          right: r.length && r.offset().left + r.outerWidth(),
          top: n.length && n.offset().top,
          bottom: a.length && a.offset().top + a.outerHeight()
        }
      }
    }

    function O(e, t) {
      if (A(e).is(t)) y(), A(e).addClass("fr-selected-cell"); else {
        x(), L.edit.off();
        var n = T(), r = S(e, n), a = S(t, n), o = function u(e, t, n, r, a) {
          var o, i, s, l, c = e, d = t, f = n, p = r;
          for (o = c; o <= d; o++) (1 < (parseInt(A(a[o][f]).attr("rowspan"), 10) || 1) || 1 < (parseInt(A(a[o][f]).attr("colspan"), 10) || 1)) && (l = k((s = S(a[o][f], a)).row, s.col, a), c = Math.min(s.row, c), d = Math.max(l.row, d), f = Math.min(s.col, f), p = Math.max(l.col, p)), (1 < (parseInt(A(a[o][p]).attr("rowspan"), 10) || 1) || 1 < (parseInt(A(a[o][p]).attr("colspan"), 10) || 1)) && (l = k((s = S(a[o][p], a)).row, s.col, a), c = Math.min(s.row, c), d = Math.max(l.row, d), f = Math.min(s.col, f), p = Math.max(l.col, p));
          for (i = f; i <= p; i++) (1 < (parseInt(A(a[c][i]).attr("rowspan"), 10) || 1) || 1 < (parseInt(A(a[c][i]).attr("colspan"), 10) || 1)) && (l = k((s = S(a[c][i], a)).row, s.col, a), c = Math.min(s.row, c), d = Math.max(l.row, d), f = Math.min(s.col, f), p = Math.max(l.col, p)), (1 < (parseInt(A(a[d][i]).attr("rowspan"), 10) || 1) || 1 < (parseInt(A(a[d][i]).attr("colspan"), 10) || 1)) && (l = k((s = S(a[d][i], a)).row, s.col, a), c = Math.min(s.row, c), d = Math.max(l.row, d), f = Math.min(s.col, f), p = Math.max(l.col, p));
          return c == e && d == t && f == n && p == r ? {min_i: e, max_i: t, min_j: n, max_j: r} : u(c, d, f, p, a)
        }(Math.min(r.row, a.row), Math.max(r.row, a.row), Math.min(r.col, a.col), Math.max(r.col, a.col), n);
        y(), e.classList.add("fr-cell-fixed"), t.classList.add("fr-cell-handler");
        for (var i = o.min_i; i <= o.max_i; i++) for (var s = o.min_j; s <= o.max_j; s++) A(e).closest("table").is(A(n[i][s]).closest("table")) && A(n[i][s]).addClass("fr-selected-cell")
      }
    }

    function N(e) {
      var t = null, n = A(e.target);
      return "TD" == e.target.tagName || "TH" == e.target.tagName ? t = e.target : 0 < n.closest("th", n.closest("thead")[0]).length ? t = n.closest("th", n.closest("thead")[0]).get(0) : 0 < n.closest("td", n.closest("tr")[0]).length && (t = n.closest("td", n.closest("tr")[0]).get(0)), -1 === L.$el.html.toString().search(t) ? null : t
    }

    function I() {
      y(), L.popups.hide("table.edit")
    }

    function e(e) {
      var t = N(e);
      if ("false" == A(t).parents("[contenteditable]").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable")) return !0;
      if (0 < Q().length && !t && I(), !L.edit.isDisabled() || L.popups.isVisible("table.edit")) if (1 != e.which || 1 == e.which && L.helpers.isMac() && e.ctrlKey) (3 == e.which || 1 == e.which && L.helpers.isMac() && e.ctrlKey) && t && I(); else if (o = !0, t) {
        0 < Q().length && !e.shiftKey && I(), e.stopPropagation(), L.events.trigger("image.hideResizer"), L.events.trigger("video.hideResizer"), a = !0;
        var n = t.tagName.toLowerCase();
        e.shiftKey && 0 < L.$el.find("".concat(n, ".fr-selected-cell")).length ? A(L.$el.find("".concat(n, ".fr-selected-cell")).closest("table")).is(A(t).closest("table")) ? O(r, t) : x() : ((L.keys.ctrlKey(e) || e.shiftKey) && "TD" === e.currentTarget.tagName && (1 < Q().length || 0 === A(t).find(L.selection.element()).length && !A(t).is(L.selection.element())) && x(), r = t, 0 < L.opts.tableEditButtons.length && O(r, r))
      }
    }

    function n(e) {
      if (!L.edit.isDisabled() && L.popups.areVisible()) return !0;
      if (a || L.$tb.is(e.target) || L.$tb.is(A(e.target).closest(".fr-toolbar")) || (0 < Q().length && L.toolbar.enable(), y()), !(1 != e.which || 1 == e.which && L.helpers.isMac() && e.ctrlKey)) {
        if (o = !1, a) a = !1, N(e) || 1 != Q().length ? 0 < Q().length ? L.selection.isCollapsed() ? u() : (y(), L.edit.on()) : Q().length || (L.$el.removeClass("fr-no-selection"), L.edit.on()) : y();
        if (w) {
          w = !1, _.removeClass("fr-moving"), L.$el.removeClass("fr-no-selection"), L.edit.on();
          var t = parseFloat(_.css("left")) + L.opts.tableResizerOffset + L.$wp.offset().left;
          L.opts.iframe && (t -= L.$iframe.offset().left), _.data("release-position", t), _.removeData("max-left"), _.removeData("max-right"), function E() {
            var e = _.data("origin"), t = _.data("release-position");
            if (e !== t) {
              var n = _.data("first"), r = _.data("second"), a = _.data("table"), o = a.outerWidth();
              if (L.undo.canDo() || L.undo.saveStep(), null != n && null != r) {
                var i, s, l, c = T(a), d = [], f = [], p = [], u = [];
                for (i = 0; i < c.length; i++) s = A(c[i][n]), l = A(c[i][r]), d[i] = s.outerWidth(), p[i] = l.outerWidth(), f[i] = d[i] / o * 100, u[i] = p[i] / o * 100;
                for (i = 0; i < c.length; i++) if (s = A(c[i][n]), l = A(c[i][r]), c[i][n] != c[i][r]) {
                  var h = (f[i] * (d[i] + t - e) / d[i]).toFixed(4);
                  s.css("width", h + "%"), l.css("width", (f[i] + u[i] - h).toFixed(4) + "%")
                }
              } else {
                var g, m = a.parent(), v = o / m.width() * 100,
                  b = (parseInt(a.css("margin-left"), 10) || 0) / m.width() * 100,
                  C = (parseInt(a.css("margin-right"), 10) || 0) / m.width() * 100;
                "rtl" == L.opts.direction && 0 === r || "rtl" != L.opts.direction && 0 !== r ? (g = (o + t - e) / o * v, a.css("margin-right", "calc(100% - ".concat(Math.round(g).toFixed(4), "% - ").concat(Math.round(b).toFixed(4), "%)"))) : ("rtl" == L.opts.direction && 0 !== r || "rtl" != L.opts.direction && 0 === r) && (g = (o - t + e) / o * v, a.css("margin-left", "calc(100% - ".concat(Math.round(g).toFixed(4), "% - ").concat(Math.round(C).toFixed(4), "%)"))), a.css("width", "".concat(Math.round(g).toFixed(4), "%"))
              }
              L.selection.restore(), L.undo.saveStep(), L.events.trigger("table.resized", [a.get(0)])
            }
            _.removeData("origin"), _.removeData("release-position"), _.removeData("first"), _.removeData("second"), _.removeData("table")
          }(), F()
        }
      }
    }

    function D(e) {
      if (!(A(e.currentTarget).is(A(e.originalEvent.relatedTarget)) || e.currentTarget.contains(e.originalEvent.relatedTarget) || e.originalEvent.relatedTarget && e.originalEvent.relatedTarget.contains(e.currentTarget)) && (L.events.$on(A("input"), "click", ee), !0 === a && 0 < L.opts.tableEditButtons.length)) {
        if (A(e.currentTarget).closest("table").is(J())) {
          if ("TD" == e.currentTarget.tagName && 0 === L.$el.find("th.fr-selected-cell").length) return void O(r, e.currentTarget);
          if ("TH" == e.currentTarget.tagName && 0 === L.$el.find("td.fr-selected-cell").length) return void O(r, e.currentTarget)
        }
        x()
      }
    }

    function B(e, t, n, r) {
      for (var a, o = t; o != L.el && "TD" != o.tagName && "TH" != o.tagName && ("up" == r ? a = o.previousElementSibling : "down" == r && (a = o.nextElementSibling), !a);) o = o.parentNode;
      "TD" == o.tagName || "TH" == o.tagName ? function i(e, t) {
        for (var n = e; n && "TABLE" != n.tagName && n.parentNode != L.el;) n = n.parentNode;
        if (n && "TABLE" == n.tagName) {
          var r = T(A(n));
          "up" == t ? H(S(e, r), n, r) : "down" == t && $(S(e, r), n, r)
        }
      }(o, r) : a && ("up" == r && L.selection.setAtEnd(a), "down" == r && L.selection.setAtStart(a))
    }

    function H(e, t, n) {
      0 < A(".tribute-container").length && "none" != A(".tribute-container").css("display") || (0 < e.row ? L.selection.setAtEnd(n[e.row - 1][e.col]) : B(0, t, 0, "up"))
    }

    function $(e, t, n) {
      if (!(0 < A(".tribute-container").length && "none" != A(".tribute-container").css("display"))) {
        var r = parseInt(n[e.row][e.col].getAttribute("rowspan"), 10) || 1;
        e.row < n.length - r ? L.selection.setAtStart(n[e.row + r][e.col]) : B(0, t, 0, "down")
      }
    }

    function F() {
      _ && (_.find("div").css("opacity", 0), _.css("top", 0), _.css("left", 0), _.css("height", 0), _.find("div").css("height", 0), _.hide())
    }

    function P() {
      c && c.removeClass("fr-visible").css("left", "-9999px")
    }

    function U(e, t) {
      var n = A(t), r = n.closest("table"), a = r.parent();
      if (t && "TD" != t.tagName && "TH" != t.tagName && (0 < n.closest("td").length ? t = n.closest("td") : 0 < n.closest("th").length && (t = n.closest("th"))), !t || "TD" != t.tagName && "TH" != t.tagName) _ && n.get(0) != _.get(0) && n.parent().get(0) != _.get(0) && L.core.sameInstance(_) && F(); else {
        if (n = A(t), 0 === L.$el.find(n).length) return !1;
        var o = n.offset().left - 1, i = o + n.outerWidth();
        if (Math.abs(e.pageX - o) <= L.opts.tableResizerOffset || Math.abs(i - e.pageX) <= L.opts.tableResizerOffset) {
          var s, l, c, d, f, p = T(r), u = S(t, p), h = k(u.row, u.col, p), g = r.offset().top, m = r.outerHeight() - 1;
          "rtl" != L.opts.direction ? e.pageX - o <= L.opts.tableResizerOffset ? (c = o, 0 < u.col ? (d = o - G(u.col - 1, p) + L.opts.tableResizingLimit, f = o + G(u.col, p) - L.opts.tableResizingLimit, s = u.col - 1, l = u.col) : (s = null, l = 0, d = r.offset().left - 1 - parseInt(r.css("margin-left"), 10), f = r.offset().left - 1 + r.width() - p[0].length * L.opts.tableResizingLimit)) : i - e.pageX <= L.opts.tableResizerOffset && (c = i, h.col < p[h.row].length && p[h.row][h.col + 1] ? (d = i - G(h.col, p) + L.opts.tableResizingLimit, f = i + G(h.col + 1, p) - L.opts.tableResizingLimit, s = h.col, l = h.col + 1) : (s = h.col, l = null, d = r.offset().left - 1 + p[0].length * L.opts.tableResizingLimit, f = a.offset().left - 1 + a.width() + parseFloat(a.css("padding-left")))) : i - e.pageX <= L.opts.tableResizerOffset ? (c = i, 0 < u.col ? (d = i - G(u.col, p) + L.opts.tableResizingLimit, f = i + G(u.col - 1, p) - L.opts.tableResizingLimit, s = u.col, l = u.col - 1) : (s = null, l = 0, d = r.offset().left + p[0].length * L.opts.tableResizingLimit, f = a.offset().left - 1 + a.width() + parseFloat(a.css("padding-left")))) : e.pageX - o <= L.opts.tableResizerOffset && (c = o, h.col < p[h.row].length && p[h.row][h.col + 1] ? (d = o - G(h.col + 1, p) + L.opts.tableResizingLimit, f = o + G(h.col, p) - L.opts.tableResizingLimit, s = h.col + 1, l = h.col) : (s = h.col, l = null, d = a.offset().left + parseFloat(a.css("padding-left")), f = r.offset().left - 1 + r.width() - p[0].length * L.opts.tableResizingLimit)), _ || function y() {
            L.shared.$table_resizer || (L.shared.$table_resizer = A(document.createElement("div")).attr("class", "fr-table-resizer").html("<div></div>")), _ = L.shared.$table_resizer, L.events.$on(_, "mousedown", function (e) {
              return !L.core.sameInstance(_) || (0 < Q().length && I(), 1 == e.which ? (L.selection.save(), w = !0, _.addClass("fr-moving"), x(), L.edit.off(), _.find("div").css("opacity", 1), !1) : void 0)
            }), L.events.$on(_, "mousemove", function (e) {
              if (!L.core.sameInstance(_)) return !0;
              w && (L.opts.iframe && (e.pageX -= L.$iframe.offset().left), j(e))
            }), L.events.on("shared.destroy", function () {
              _.html("").removeData().remove(), _ = null
            }, !0), L.events.on("destroy", function () {
              L.$el.find(".fr-selected-cell").removeClass("fr-selected-cell"), A("body").first().append(_.hide())
            }, !0)
          }(), _.data("table", r), _.data("first", s), _.data("second", l), _.data("instance", L), L.$wp.append(_);
          var v = c - L.win.pageXOffset - L.opts.tableResizerOffset - L.$wp.offset().left,
            b = g - L.$wp.offset().top + L.$wp.scrollTop();
          if (L.opts.iframe) {
            var C = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-top")),
              E = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-left"));
            v += L.$iframe.offset().left + E, b += L.$iframe.offset().top + C, d += L.$iframe.offset().left, f += L.$iframe.offset().left
          }
          _.data("max-left", d), _.data("max-right", f), _.data("origin", c - L.win.pageXOffset), _.css("top", b), _.css("left", v), _.css("height", m), _.find("div").css("height", m), _.css("padding-left", L.opts.tableResizerOffset), _.css("padding-right", L.opts.tableResizerOffset), _.show()
        } else L.core.sameInstance(_) && F()
      }
    }

    function z(e, t) {
      if (L.$box.find(".fr-line-breaker").isVisible()) return !1;
      c || Z(), L.$box.append(c), c.data("instance", L);
      var n, r = A(t).find("tr").first(), a = e.pageX, o = 0, i = 0;
      if (L.opts.iframe) {
        var s = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-top")),
          l = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-left"));
        o += L.$iframe.offset().left - L.helpers.scrollLeft() + l, i += L.$iframe.offset().top - L.helpers.scrollTop() + s
      }
      r.find("th, td").each(function () {
        var e = A(this);
        return e.offset().left <= a && a < e.offset().left + e.outerWidth() / 2 ? (n = parseInt(c.find("a").css("width"), 10), c.css("top", i + e.offset().top - L.$box.offset().top - n - 5), c.css("left", o + e.offset().left - L.$box.offset().left - n / 2), c.data("selected-cell", e), c.data("position", "before"), c.addClass("fr-visible"), !1) : e.offset().left + e.outerWidth() / 2 <= a && a < e.offset().left + e.outerWidth() ? (n = parseInt(c.find("a").css("width"), 10), c.css("top", i + e.offset().top - L.$box.offset().top - n - 5), c.css("left", o + e.offset().left - L.$box.offset().left + e.outerWidth() - n / 2), c.data("selected-cell", e), c.data("position", "after"), c.addClass("fr-visible"), !1) : void 0
      })
    }

    function K(e, t) {
      if (L.$box.find(".fr-line-breaker").isVisible()) return !1;
      c || Z(), L.$box.append(c), c.data("instance", L);
      var n, r = A(t), a = e.pageY, o = 0, i = 0;
      if (L.opts.iframe) {
        var s = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-top")),
          l = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-left"));
        o += L.$iframe.offset().left - L.helpers.scrollLeft() + l, i += L.$iframe.offset().top - L.helpers.scrollTop() + s
      }
      r.find("tr").each(function () {
        var e = A(this);
        n = parseInt(c.find("a").css("width"), 10);
        var t = o + e.offset().left - L.$box.offset().left;
        return t = 0 !== L.$box.offset().left ? t - n - 5 : t + n - 5, e.offset().top <= a && a < e.offset().top + e.outerHeight() / 2 ? (c.css("top", i + e.offset().top - L.$box.offset().top - n / 2), c.css("left", t), c.data("selected-cell", e.find("td").first()), c.data("position", "above"), c.addClass("fr-visible"), !1) : e.offset().top + e.outerHeight() / 2 <= a && a < e.offset().top + e.outerHeight() ? (c.css("top", i + e.offset().top - L.$box.offset().top + e.outerHeight() - n / 2), c.css("left", t), c.data("selected-cell", e.find("td").first()), c.data("position", "below"), c.addClass("fr-visible"), !1) : void 0
      })
    }

    function V(e) {
      i = null;
      var t = L.doc.elementFromPoint(e.pageX - L.win.pageXOffset, e.pageY - L.win.pageYOffset);
      L.opts.tableResizer && (!L.popups.areVisible() || L.popups.areVisible() && L.popups.isVisible("table.edit")) && U(e, t), !L.opts.tableInsertHelper || L.popups.areVisible() || L.$tb.hasClass("fr-inline") && L.$tb.isVisible() || function o(e, t) {
        if (0 === Q().length) {
          var n, r, a;
          if (t && ("HTML" == t.tagName || "BODY" == t.tagName || L.node.isElement(t))) for (n = 1; n <= L.opts.tableInsertHelperOffset; n++) {
            if (r = L.doc.elementFromPoint(e.pageX - L.win.pageXOffset, e.pageY - L.win.pageYOffset + n), A(r).hasClass("fr-tooltip")) return !0;
            if (r && ("TH" == r.tagName || "TD" == r.tagName || "TABLE" == r.tagName) && (A(r).parents(".fr-wrapper").length || L.opts.iframe) && "false" != A(r).closest("table").attr("contenteditable")) return z(e, A(r).closest("table")), !0;
            if (a = L.doc.elementFromPoint(e.pageX - L.win.pageXOffset + n, e.pageY - L.win.pageYOffset), A(a).hasClass("fr-tooltip")) return !0;
            if (a && ("TH" == a.tagName || "TD" == a.tagName || "TABLE" == a.tagName) && (A(a).parents(".fr-wrapper").length || L.opts.iframe) && "false" != A(a).closest("table").attr("contenteditable")) return K(e, A(a).closest("table")), !0
          }
          L.core.sameInstance(c) && P()
        }
      }(e, t)
    }

    function W() {
      if (w) {
        var e = _.data("table").offset().top - L.win.pageYOffset;
        if (L.opts.iframe) {
          var t = L.helpers.getPX(L.$wp.find(".fr-iframe").css("padding-top"));
          e += L.$iframe.offset().top - L.helpers.scrollTop() + t
        }
        _.css("top", e)
      }
    }

    function G(e, t) {
      var n, r = A(t[0][e]).outerWidth();
      for (n = 1; n < t.length; n++) r = Math.min(r, A(t[n][e]).outerWidth());
      return r
    }

    function Y(e, t, n) {
      var r, a = 0;
      for (r = e; r <= t; r++) a += G(r, n);
      return a
    }

    function j(e) {
      if (1 < Q().length && o && x(), !1 === o && !1 === a && !1 === w) i && clearTimeout(i), L.edit.isDisabled() && !L.popups.isVisible("table.edit") || (i = setTimeout(V, 30, e)); else if (w) {
        var t = e.pageX - L.win.pageXOffset;
        L.opts.iframe && (t += L.$iframe.offset().left);
        var n = _.data("max-left"), r = _.data("max-right");
        n <= t && t <= r ? _.css("left", t - L.opts.tableResizerOffset - L.$wp.offset().left) : t < n && parseFloat(_.css("left"), 10) > n - L.opts.tableResizerOffset ? _.css("left", n - L.opts.tableResizerOffset - L.$wp.offset().left) : r < t && parseFloat(_.css("left"), 10) < r - L.opts.tableResizerOffset && _.css("left", r - L.opts.tableResizerOffset - L.$wp.offset().left)
      } else o && P()
    }

    function q(e) {
      L.node.isEmpty(e.get(0)) ? e.prepend(xt.MARKERS) : e.prepend(xt.START_MARKER).append(xt.END_MARKER)
    }

    function Z() {
      L.shared.$ti_helper || (L.shared.$ti_helper = A(document.createElement("div")).attr("class", "fr-insert-helper").html('<a class="fr-floating-btn" role="button" tabIndex="-1" title="'.concat(L.language.translate("Insert"), '"><svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M22,16.75 L16.75,16.75 L16.75,22 L15.25,22.000 L15.25,16.75 L10,16.75 L10,15.25 L15.25,15.25 L15.25,10 L16.75,10 L16.75,15.25 L22,15.25 L22,16.75 Z"/></svg></a>')), L.events.bindClick(L.shared.$ti_helper, "a", function () {
        var e = c.data("selected-cell"), t = c.data("position"), n = c.data("instance") || L;
        "before" == t ? (L.undo.saveStep(), e.addClass("fr-selected-cell"), n.table.insertColumn(t), e.removeClass("fr-selected-cell"), L.undo.saveStep()) : "after" == t ? (L.undo.saveStep(), e.addClass("fr-selected-cell"), n.table.insertColumn(t), e.removeClass("fr-selected-cell"), L.undo.saveStep()) : "above" == t ? (L.undo.saveStep(), e.addClass("fr-selected-cell"), n.table.insertRow(t), e.removeClass("fr-selected-cell"), L.undo.saveStep()) : "below" == t && (L.undo.saveStep(), e.addClass("fr-selected-cell"), n.table.insertRow(t), e.removeClass("fr-selected-cell"), L.undo.saveStep()), P()
      }), L.events.on("shared.destroy", function () {
        L.shared.$ti_helper.html("").removeData().remove(), L.shared.$ti_helper = null
      }, !0), L.events.$on(L.shared.$ti_helper, "mousemove", function (e) {
        e.stopPropagation()
      }, !0), L.events.$on(A(L.o_win), "scroll", function () {
        P()
      }, !0), L.events.$on(L.$wp, "scroll", function () {
        P()
      }, !0)), c = L.shared.$ti_helper, L.events.on("destroy", function () {
        c = null
      }), L.tooltip.bind(L.$box, ".fr-insert-helper > a.fr-floating-btn")
    }

    function X() {
      r = null, clearTimeout(i)
    }

    function Q() {
      return L.el.querySelectorAll(".fr-selected-cell")
    }

    function J() {
      var e = Q();
      if (e.length) {
        for (var t = e[0]; t && "TABLE" != t.tagName && t.parentNode != L.el;) t = t.parentNode;
        return t && "TABLE" == t.tagName ? A(t) : A([])
      }
      return A([])
    }

    function ee(e) {
      a = !1
    }

    return {
      _init: function te() {
        if (!L.$wp) return !1;
        if (L.helpers.isMobile() && (L.events.$on(L.$el, "mousedown", e), L.events.$on(L.$win, "mouseup", n)), !L.helpers.isMobile()) {
          w = a = o = !1, L.events.$on(L.$el, "mousedown", e), L.popups.onShow("image.edit", function () {
            y(), a = o = !1
          }), L.popups.onShow("link.edit", function () {
            y(), a = o = !1
          }), L.events.on("commands.mousedown", function (e) {
            0 < e.parents(".fr-toolbar").length && y()
          }), L.events.$on(L.$el, "mouseover", "th, td", D), L.events.$on(L.$win, "mouseup", n), L.opts.iframe && L.events.$on(A(L.o_win), "mouseup", n), L.events.$on(L.$win, "mousemove", j), L.events.$on(A(L.o_win), "scroll", W), L.events.on("contentChanged", function () {
            0 < Q().length && (u(), L.$el.find("img").on("load.selected-cells", function () {
              A(this).off("load.selected-cells"), 0 < Q().length && u()
            }))
          }), L.events.$on(A(L.o_win), "resize", function () {
            y()
          }), L.events.on("toolbar.esc", function () {
            if (0 < Q().length) return L.events.disableBlur(), L.events.focus(), !1
          }, !0), L.events.$on(A(L.o_win), "keydown", function () {
            o && a && (a = o = !1, L.$el.removeClass("fr-no-selection"), L.edit.on(), L.selection.setAtEnd(L.$el.find(".fr-selected-cell").last().get(0)), L.selection.restore(), y())
          }), L.events.$on(L.$el, "keydown", function (e) {
            e.shiftKey ? !1 === function i(e) {
              var t = Q();
              if (null != t && 0 < t.length) {
                var n, r = T(), a = e.which,
                  o = S(1 == t.length ? n = t[0] : (n = L.el.querySelector(".fr-cell-fixed"), L.el.querySelector(".fr-cell-handler")), r);
                if (xt.KEYCODE.ARROW_RIGHT == a) {
                  if (o.col < r[0].length - 1) return O(n, r[o.row][o.col + 1]), !1
                } else if (xt.KEYCODE.ARROW_DOWN == a) {
                  if (o.row < r.length - 1) return O(n, r[o.row + 1][o.col]), !1
                } else if (xt.KEYCODE.ARROW_LEFT == a) {
                  if (0 < o.col) return O(n, r[o.row][o.col - 1]), !1
                } else if (xt.KEYCODE.ARROW_UP == a && 0 < o.row) return O(n, r[o.row - 1][o.col]), !1
              }
            }(e) && setTimeout(function () {
              u()
            }, 0) : function s(e) {
              var t = e.which, n = L.selection.blocks();
              if (n.length && ("TD" == (n = n[0]).tagName || "TH" == n.tagName)) {
                for (var r = n; r && "TABLE" != r.tagName && r.parentNode != L.el;) r = r.parentNode;
                if (r && "TABLE" == r.tagName && (xt.KEYCODE.ARROW_LEFT == t || xt.KEYCODE.ARROW_UP == t || xt.KEYCODE.ARROW_RIGHT == t || xt.KEYCODE.ARROW_DOWN == t) && (0 < Q().length && I(), L.browser.webkit && (xt.KEYCODE.ARROW_UP == t || xt.KEYCODE.ARROW_DOWN == t))) {
                  var a = L.selection.ranges(0).startContainer;
                  if (a.nodeType == Node.TEXT_NODE && (xt.KEYCODE.ARROW_UP == t && (a.previousSibling && "BR" !== a.previousSibling.tagName || a.previousSibling && "BR" === a.previousSibling.tagName && a.previousSibling.previousSibling) || xt.KEYCODE.ARROW_DOWN == t && (a.nextSibling && "BR" !== a.nextSibling.tagName || a.nextSibling && "BR" === a.nextSibling.tagName && a.nextSibling.nextSibling))) return;
                  e.preventDefault(), e.stopPropagation();
                  var o = T(A(r)), i = S(n, o);
                  return xt.KEYCODE.ARROW_UP == t ? H(i, r, o) : xt.KEYCODE.ARROW_DOWN == t && $(i, r, o), L.selection.restore(), !1
                }
              }
            }(e)
          }), L.events.on("keydown", function (e) {
            if (!1 === function r(e) {
              if (e.which == xt.KEYCODE.TAB) {
                var t;
                if (0 < Q().length) t = L.$el.find(".fr-selected-cell").last(); else {
                  var n = L.selection.element();
                  "TD" == n.tagName || "TH" == n.tagName ? t = A(n) : n != L.el && (0 < A(n).parentsUntil(L.$el, "td").length ? t = A(n).parents("td").first() : 0 < A(n).parentsUntil(L.$el, "th").length && (t = A(n).parents("th").first()))
                }
                if (t) return e.preventDefault(), !!(0 === L.selection.get().focusOffset && 0 < A(L.selection.element()).parentsUntil(L.$el, "ol, ul").length && (0 < A(L.selection.element()).closest("li").prev().length || A(L.selection.element()).is("li") && 0 < A(L.selection.element()).prev().length)) || (I(), e.shiftKey ? 0 < t.prev().length ? q(t.prev()) : 0 < t.closest("tr").length && 0 < t.closest("tr").prev().length ? q(t.closest("tr").prev().find("td").last()) : 0 < t.closest("tbody").length && 0 < t.closest("table").find("thead tr").length && q(t.closest("table").find("thead tr th").last()) : 0 < t.next().length ? q(t.next()) : 0 < t.closest("tr").length && 0 < t.closest("tr").next().length ? q(t.closest("tr").next().find("td").first()) : 0 < t.closest("thead").length && 0 < t.closest("table").find("tbody tr").length ? q(t.closest("table").find("tbody tr td").first()) : (t.addClass("fr-selected-cell"), g("below"), y(), q(t.closest("tr").next().find("td").first())), L.selection.restore(), !1)
              }
            }(e)) return !1;
            var t = Q();
            if (0 < t.length) {
              if (0 < t.length && L.keys.ctrlKey(e) && e.which == xt.KEYCODE.A) return y(), L.popups.isVisible("table.edit") && L.popups.hide("table.edit"), t = [], !0;
              if (e.which == xt.KEYCODE.ESC && L.popups.isVisible("table.edit")) return y(), L.popups.hide("table.edit"), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation(), !(t = []);
              if (1 < t.length && (e.which == xt.KEYCODE.BACKSPACE || e.which == xt.KEYCODE.DELETE)) {
                L.undo.saveStep();
                for (var n = 0; n < t.length; n++) A(t[n]).html("<br>"), n == t.length - 1 && A(t[n]).prepend(xt.MARKERS);
                return L.selection.restore(), L.undo.saveStep(), !(t = [])
              }
              if (1 < t.length && e.which != xt.KEYCODE.F10 && !L.keys.isBrowserAction(e)) return e.preventDefault(), !(t = [])
            } else if (!(t = []) === function a(e) {
              if (e.altKey && e.which == xt.KEYCODE.SPACE) {
                var t, n = L.selection.element();
                if ("TD" == n.tagName || "TH" == n.tagName ? t = n : 0 < A(n).closest("td").length ? t = A(n).closest("td").get(0) : 0 < A(n).closest("th").length && (t = A(n).closest("th").get(0)), t) return e.preventDefault(), O(t, t), u(), !1
              }
            }(e)) return !1
          }, !0);
          var t = [];
          L.events.on("html.beforeGet", function () {
            t = Q();
            for (var e = 0; e < t.length; e++) t[e].className = (t[e].className || "").replace(/fr-selected-cell/g, "")
          }), L.events.on("html.afterGet", function () {
            for (var e = 0; e < t.length; e++) t[e].className = (t[e].className ? t[e].className.trim() + " " : "") + "fr-selected-cell";
            t = []
          }), d(!0), p(!0)
        }
        L.events.on("destroy", X)
      }, insert: function ne(e, t) {
        var n, r,
          a = "<table " + (L.opts.tableDefaultWidth ? 'style="width: ' + L.opts.tableDefaultWidth + ';" ' : "") + 'class="fr-inserted-table"><tbody>',
          o = 100 / t;
        for (n = 0; n < e; n++) {
          for (a += "<tr>", r = 0; r < t; r++) a += "<td" + (L.opts.tableDefaultWidth ? ' style="width: ' + o.toFixed(4) + '%;"' : "") + ">", 0 === n && 0 === r && (a += xt.MARKERS), a += "<br></td>";
          a += "</tr>"
        }
        if (a += "</tbody></table>", L.opts.trackChangesEnabled) {
          L.edit.on(), L.events.focus(!0), L.selection.restore(), L.undo.saveStep(), L.markers.insert(), L.html.wrap();
          var i = L.$el.find(".fr-marker");
          L.node.isLastSibling(i) && i.parent().hasClass("fr-deletable") && i.insertAfter(i.parent()), i.replaceWith(a), L.selection.clear()
        } else L.html.insert(a);
        L.selection.restore();
        var s = L.$el.find(".fr-inserted-table");
        s.removeClass("fr-inserted-table"), L.events.trigger("table.inserted", [s.get(0)])
      }, remove: h, insertRow: g, deleteRow: function re() {
        var e = J();
        if (0 < e.length) {
          var t, n, r, a = T(), o = R(a);
          if (null == o) return;
          if (0 === o.min_i && o.max_i == a.length - 1) h(); else {
            for (t = o.max_i; t >= o.min_i; t--) {
              for (r = A(e.find("tr").not(e.find("> table tr")).get(t)), n = 0; n < a[t].length; n++) if (0 === n || a[t][n] != a[t][n - 1]) {
                var i = A(a[t][n]);
                if (1 < parseInt(i.attr("rowspan"), 10)) {
                  var s = parseInt(i.attr("rowspan"), 10) - 1;
                  1 == s ? i.removeAttr("rowspan") : i.attr("rowspan", s)
                }
                if (t < a.length - 1 && a[t][n] == a[t + 1][n] && (0 === t || a[t][n] != a[t - 1][n])) {
                  for (var l = a[t][n], c = n; 0 < c && a[t][c] == a[t][c - 1];) c--;
                  0 === c ? A(e.find("tr").not(e.find("> table tr")).get(t + 1)).prepend(l) : A(a[t + 1][c - 1])[0].parentNode && A(a[t + 1][c - 1])[0].insertAdjacentElement("afterend", l)
                }
              }
              var d = r.parent();
              r.remove(), 0 === d.find("tr").length && d.remove(), a = T(e)
            }
            C(0, a.length - 1, 0, a[0].length - 1, e), 0 < o.min_i ? L.selection.setAtEnd(a[o.min_i - 1][0]) : L.selection.setAtEnd(a[0][0]), L.selection.restore(), L.popups.hide("table.edit")
          }
        }
      }, insertColumn: function ae(l) {
        var e = J();
        if (0 < e.length) {
          var c, d = T(), t = R(d);
          c = "before" == l ? t.min_j : t.max_j;
          var n, f = 100 / d[0].length, p = 100 / (d[0].length + 1);
          e.find("th, td").each(function () {
            (n = A(this)).data("old-width", n.outerWidth() / e.outerWidth() * 100)
          }), e.find("tr").not(e.find("> table tr")).each(function (e) {
            for (var t, n = A(this), r = 0, a = 0; r - 1 < c;) {
              if (!(t = n.find("> th, > td").get(a))) {
                t = null;
                break
              }
              t == d[e][r] ? (r += parseInt(A(t).attr("colspan"), 10) || 1, a++) : (r += parseInt(A(d[e][r]).attr("colspan"), 10) || 1, "after" == l && (t = 0 === a ? -1 : n.find("> th, > td").get(a - 1)))
            }
            var o, i = A(t);
            if ("after" == l && c < r - 1 || "before" == l && 0 < c && d[e][c] == d[e][c - 1]) {
              if (0 === e || 0 < e && d[e][c] != d[e - 1][c]) {
                var s = parseInt(i.attr("colspan"), 10) + 1;
                i.attr("colspan", s), i.css("width", (i.data("old-width") * p / f + p).toFixed(4) + "%"), i.removeData("old-width")
              }
            } else o = 0 < n.find("th").length ? '<th style="width: '.concat(p.toFixed(4), '%;"><br></th>') : '<td style="width: '.concat(p.toFixed(4), '%;"><br></td>'), -1 == t ? n.prepend(o) : null == t ? n.append(o) : "before" == l ? i.before(o) : "after" == l && i[0].parentNode && i[0].insertAdjacentHTML("afterend", o)
          }), e.find("th, td").each(function () {
            (n = A(this)).data("old-width") && (n.css("width", (n.data("old-width") * p / f).toFixed(4) + "%"), n.removeData("old-width"))
          }), L.popups.isVisible("table.edit") && u()
        }
      }, deleteColumn: function oe() {
        var e = J();
        if (0 < e.length) {
          var t, n, r, a = T(), o = R(a);
          if (null == o) return;
          if (0 === o.min_j && o.max_j == a[0].length - 1) h(); else {
            var i = 0;
            for (t = 0; t < a.length; t++) for (n = 0; n < a[0].length; n++) (r = A(a[t][n])).hasClass("fr-selected-cell") || (r.data("old-width", r.outerWidth() / e.outerWidth() * 100), (n < o.min_j || n > o.max_j) && (i += r.outerWidth() / e.outerWidth() * 100));
            for (i /= a.length, n = o.max_j; n >= o.min_j; n--) for (t = 0; t < a.length; t++) if (0 === t || a[t][n] != a[t - 1][n]) if (r = A(a[t][n]), 1 < (parseInt(r.attr("colspan"), 10) || 1)) {
              var s = parseInt(r.attr("colspan"), 10) - 1;
              1 == s ? r.removeAttr("colspan") : r.attr("colspan", s), r.css("width", (100 * (r.data("old-width") - G(n, a)) / i).toFixed(4) + "%"), r.removeData("old-width")
            } else {
              var l = A(r.parent().get(0));
              r.remove(), 0 === l.find("> th, > td").length && (0 === l.prev().length || 0 === l.next().length || l.prev().find("> th[rowspan], > td[rowspan]").length < l.prev().find("> th, > td").length) && l.remove()
            }
            C(0, a.length - 1, 0, a[0].length - 1, e), 0 < o.min_j ? L.selection.setAtEnd(a[o.min_i][o.min_j - 1]) : L.selection.setAtEnd(a[o.min_i][0]), L.selection.restore(), L.popups.hide("table.edit"), e.find("th, td").each(function () {
              (r = A(this)).data("old-width") && (r.css("width", (100 * r.data("old-width") / i).toFixed(4) + "%"), r.removeData("old-width"))
            })
          }
        }
      }, mergeCells: function ie() {
        if (1 < Q().length && (0 === L.$el.find("th.fr-selected-cell").length || 0 === L.$el.find("td.fr-selected-cell").length)) {
          E();
          var e, t, n = R(T());
          if (null == n) return;
          var r = L.$el.find(".fr-selected-cell"), a = A(r[0]), o = a.parent().find(".fr-selected-cell"),
            i = a.closest("table"), s = a.html(), l = 0;
          for (e = 0; e < o.length; e++) l += A(o[e]).outerWidth();
          for (a.css("width", Math.min(100, l / i.outerWidth() * 100).toFixed(4) + "%"), n.min_j < n.max_j && a.attr("colspan", n.max_j - n.min_j + 1), n.min_i < n.max_i && a.attr("rowspan", n.max_i - n.min_i + 1), e = 1; e < r.length; e++) "<br>" != (t = A(r[e])).html() && "" !== t.html() && (s += "<br>".concat(t.html())), t.remove();
          a.html(s), L.selection.setAtEnd(a.get(0)), L.selection.restore(), L.toolbar.enable(), v(n.min_i, n.max_i, i);
          var c = i.find("tr:empty");
          for (e = c.length - 1; 0 <= e; e--) A(c[e]).remove();
          m(n.min_j, n.max_j, i), u()
        }
      }, splitCellVertically: function se() {
        if (1 == Q().length) {
          var e = L.$el.find(".fr-selected-cell"), t = parseInt(e.attr("colspan"), 10) || 1,
            n = e.parent().outerWidth(), r = e.outerWidth(), a = e.clone().html("<br>"), o = T(), i = S(e.get(0), o);
          if (1 < t) {
            var s = Math.ceil(t / 2);
            r = Y(i.col, i.col + s - 1, o) / n * 100;
            var l = Y(i.col + s, i.col + t - 1, o) / n * 100;
            1 < s ? e.attr("colspan", s) : e.removeAttr("colspan"), 1 < t - s ? a.attr("colspan", t - s) : a.removeAttr("colspan"), e.css("width", r.toFixed(4) + "%"), a.css("width", l.toFixed(4) + "%")
          } else {
            var c;
            for (c = 0; c < o.length; c++) if (0 === c || o[c][i.col] != o[c - 1][i.col]) {
              var d = A(o[c][i.col]);
              if (!d.is(e)) {
                var f = (parseInt(d.attr("colspan"), 10) || 1) + 1;
                d.attr("colspan", f)
              }
            }
            r = r / n * 100 / 2, e.css("width", "".concat(r.toFixed(4), "%")), a.css("width", "".concat(r.toFixed(4), "%"))
          }
          e[0].parentNode && e[0].insertAdjacentElement("afterend", a[0]), y(), L.popups.hide("table.edit")
        }
      }, splitCellHorizontally: function le() {
        if (1 == Q().length) {
          var e = L.$el.find(".fr-selected-cell"), t = e.parent(), n = e.closest("table"),
            r = parseInt(e.attr("rowspan"), 10), a = T(), o = S(e.get(0), a), i = e.clone().html("<br>");
          if (1 < r) {
            var s = Math.ceil(r / 2);
            1 < s ? e.attr("rowspan", s) : e.removeAttr("rowspan"), 1 < r - s ? i.attr("rowspan", r - s) : i.removeAttr("rowspan");
            for (var l = o.row + s, c = 0 === o.col ? o.col : o.col - 1; 0 <= c && (a[l][c] == a[l][c - 1] || 0 < l && a[l][c] == a[l - 1][c]);) c--;
            -1 == c ? A(n.find("tr").not(n.find("> table tr")).get(l)).prepend(i) : A(a[l][c])[0].parentNode && A(a[l][c])[0].insertAdjacentElement("afterend", i[0])
          } else {
            var d, f = A(document.createElement("tr")).append(i);
            for (d = 0; d < a[0].length; d++) if (0 === d || a[o.row][d] != a[o.row][d - 1]) {
              var p = A(a[o.row][d]);
              p.is(e) || p.attr("rowspan", (parseInt(p.attr("rowspan"), 10) || 1) + 1)
            }
            t[0].parentNode && t[0].insertAdjacentElement("afterend", f[0])
          }
          y(), L.popups.hide("table.edit")
        }
      }, addHeader: function ce() {
        var e = J();
        if (0 < e.length && 0 === e.find("th").length) {
          var t, n = "<thead><tr>", r = 0;
          for (e.find("tr").first().find("> td").each(function () {
            var e = A(this);
            r += parseInt(e.attr("colspan"), 10) || 1
          }), t = 0; t < r; t++) n += "<th><br></th>";
          n += "</tr></thead>", e.prepend(n), u()
        }
      }, removeHeader: function de() {
        var e = J(), t = e.find("thead");
        if (0 < t.length) if (0 === e.find("tbody tr").length) h(); else if (t.remove(), 0 < Q().length) u(); else {
          L.popups.hide("table.edit");
          var n = e.find("tbody tr").first().find("td").first().get(0);
          n && (L.selection.setAtEnd(n), L.selection.restore())
        }
      }, setBackground: t, showInsertPopup: function fe() {
        var e = L.$tb.find('.fr-command[data-cmd="insertTable"]'), t = L.popups.get("table.insert");
        if (t || (t = d()), !t.hasClass("fr-active")) {
          L.popups.refresh("table.insert"), L.popups.setContainer("table.insert", L.$tb);
          var n = L.button.getPosition(e), r = n.left, a = n.top;
          L.popups.show("table.insert", r, a, e.outerHeight())
        }
      }, showEditPopup: u, showColorsPopup: s, back: function pe() {
        0 < Q().length ? u() : (L.popups.hide("table.insert"), L.toolbar.showInline())
      }, verticalAlign: function ue(e) {
        L.$el.find(".fr-selected-cell").css("vertical-align", e)
      }, horizontalAlign: function he(e) {
        L.$el.find(".fr-selected-cell").css("text-align", e)
      }, applyStyle: function ge(e, t, n, r) {
        if (0 < t.length) {
          if (!n) {
            var a = Object.keys(r);
            a.splice(a.indexOf(e), 1), t.removeClass(a.join(" "))
          }
          t.toggleClass(e)
        }
      }, selectedTable: J, selectedCells: Q, customColor: function me() {
        var e = L.popups.get("table.colors").find(".fr-table-colors-hex-layer input");
        e.length && t(e.val())
      }, selectCells: O
    }
  }, xt.DefineIcon("insertTable", {
    NAME: "table",
    SVG_KEY: "insertTable"
  }), xt.RegisterCommand("insertTable", {
    title: "Insert Table",
    undo: !1,
    focus: !0,
    refreshOnCallback: !1,
    popup: !0,
    callback: function () {
      this.popups.isVisible("table.insert") ? (this.$el.find(".fr-marker").length && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("table.insert")) : this.table.showInsertPopup()
    },
    plugin: "table"
  }), xt.RegisterCommand("tableInsert", {
    callback: function (e, t, n) {
      this.table.insert(t, n), this.popups.hide("table.insert")
    }
  }), xt.DefineIcon("tableHeader", {
    NAME: "header",
    FA5NAME: "heading",
    SVG_KEY: "tableHeader"
  }), xt.RegisterCommand("tableHeader", {
    title: "Table Header", focus: !1, toggle: !0, callback: function () {
      this.popups.get("table.edit").find('.fr-command[data-cmd="tableHeader"]').hasClass("fr-active") ? this.table.removeHeader() : this.table.addHeader()
    }, refresh: function (e) {
      var t = this.table.selectedTable();
      0 < t.length && (0 === t.find("th").length ? e.removeClass("fr-active").attr("aria-pressed", !1) : e.addClass("fr-active").attr("aria-pressed", !0))
    }
  }), xt.DefineIcon("tableRows", {NAME: "bars", SVG_KEY: "row"}),xt.RegisterCommand("tableRows", {
    type: "dropdown",
    focus: !1,
    title: "Row",
    options: {above: "Insert row above", below: "Insert row below", "delete": "Delete row"},
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = xt.COMMANDS.tableRows.options;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableRows" data-param1="' + n + '" title="' + this.language.translate(t[n]) + '">' + this.language.translate(t[n]) + "</a></li>");
      return e += "</ul>"
    },
    callback: function (e, t) {
      "above" == t || "below" == t ? this.table.insertRow(t) : this.table.deleteRow()
    }
  }),xt.DefineIcon("tableColumns", {
    NAME: "bars fa-rotate-90",
    SVG_KEY: "columns"
  }),xt.RegisterCommand("tableColumns", {
    type: "dropdown",
    focus: !1,
    title: "Column",
    options: {before: "Insert column before", after: "Insert column after", "delete": "Delete column"},
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = xt.COMMANDS.tableColumns.options;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableColumns" data-param1="'.concat(n, '" title="').concat(this.language.translate(t[n]), '">').concat(this.language.translate(t[n]), "</a></li>"));
      return e += "</ul>"
    },
    callback: function (e, t) {
      "before" == t || "after" == t ? this.table.insertColumn(t) : this.table.deleteColumn()
    }
  }),xt.DefineIcon("tableCells", {
    NAME: "square-o",
    FA5NAME: "square",
    SVG_KEY: "cellOptions"
  }),xt.RegisterCommand("tableCells", {
    type: "dropdown",
    focus: !1,
    title: "Cell",
    options: {merge: "Merge cells", "vertical-split": "Vertical split", "horizontal-split": "Horizontal split"},
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = xt.COMMANDS.tableCells.options;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableCells" data-param1="'.concat(n, '" title="').concat(this.language.translate(t[n]), '">').concat(this.language.translate(t[n]), "</a></li>"));
      return e += "</ul>"
    },
    callback: function (e, t) {
      "merge" == t ? this.table.mergeCells() : "vertical-split" == t ? this.table.splitCellVertically() : this.table.splitCellHorizontally()
    },
    refreshOnShow: function (e, t) {
      1 < this.$el.find(".fr-selected-cell").length ? (t.find('a[data-param1="vertical-split"]').addClass("fr-disabled").attr("aria-disabled", !0), t.find('a[data-param1="horizontal-split"]').addClass("fr-disabled").attr("aria-disabled", !0), t.find('a[data-param1="merge"]').removeClass("fr-disabled").attr("aria-disabled", !1)) : (t.find('a[data-param1="merge"]').addClass("fr-disabled").attr("aria-disabled", !0), t.find('a[data-param1="vertical-split"]').removeClass("fr-disabled").attr("aria-disabled", !1), t.find('a[data-param1="horizontal-split"]').removeClass("fr-disabled").attr("aria-disabled", !1))
    }
  }),xt.DefineIcon("tableRemove", {
    NAME: "trash",
    SVG_KEY: "removeTable"
  }),xt.RegisterCommand("tableRemove", {
    title: "Remove Table", focus: !1, callback: function () {
      this.table.remove()
    }
  }),xt.DefineIcon("tableStyle", {
    NAME: "paint-brush",
    SVG_KEY: "tableStyle"
  }),xt.RegisterCommand("tableStyle", {
    title: "Table Style", type: "dropdown", focus: !1, html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.tableStyles;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableStyle" data-param1="'.concat(n, '" title="').concat(this.language.translate(t[n]), '">').concat(this.language.translate(t[n]), "</a></li>"));
      return e += "</ul>"
    }, callback: function (e, t) {
      this.table.applyStyle(t, this.$el.find(".fr-selected-cell").closest("table"), this.opts.tableMultipleStyles, this.opts.tableStyles)
    }, refreshOnShow: function (e, t) {
      var n = this.$, r = this.$el.find(".fr-selected-cell").closest("table");
      r && t.find(".fr-command").each(function () {
        var e = n(this).data("param1"), t = r.hasClass(e);
        n(this).toggleClass("fr-active", t).attr("aria-selected", t)
      })
    }
  }),xt.DefineIcon("tableCellBackground", {
    NAME: "tint",
    SVG_KEY: "cellBackground"
  }),xt.RegisterCommand("tableCellBackground", {
    title: "Cell Background", focus: !1, popup: !0, callback: function () {
      this.table.showColorsPopup()
    }
  }),xt.RegisterCommand("tableCellBackgroundColor", {
    undo: !0, focus: !1, callback: function (e, t) {
      this.table.setBackground(t)
    }
  }),xt.DefineIcon("tableBack", {NAME: "arrow-left", SVG_KEY: "back"}),xt.RegisterCommand("tableBack", {
    title: "Back",
    undo: !1,
    focus: !1,
    back: !0,
    callback: function () {
      this.table.back()
    },
    refresh: function (e) {
      0 !== this.table.selectedCells().length || this.opts.toolbarInline ? (e.removeClass("fr-hidden"), e.next(".fr-separator").removeClass("fr-hidden")) : (e.addClass("fr-hidden"), e.next(".fr-separator").addClass("fr-hidden"))
    }
  }),xt.DefineIcon("tableCellVerticalAlign", {
    NAME: "arrows-v",
    FA5NAME: "arrows-alt-v",
    SVG_KEY: "verticalAlignMiddle"
  }),xt.RegisterCommand("tableCellVerticalAlign", {
    type: "dropdown",
    focus: !1,
    title: "Vertical Align",
    options: {Top: "Align Top", Middle: "Align Middle", Bottom: "Align Bottom"},
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = xt.COMMANDS.tableCellVerticalAlign.options;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableCellVerticalAlign" data-param1="'.concat(n.toLowerCase(), '" title="').concat(this.language.translate(t[n]), '">').concat(this.language.translate(n), "</a></li>"));
      return e += "</ul>"
    },
    callback: function (e, t) {
      this.table.verticalAlign(t)
    },
    refreshOnShow: function (e, t) {
      t.find('.fr-command[data-param1="' + this.$el.find(".fr-selected-cell").css("vertical-align") + '"]').addClass("fr-active").attr("aria-selected", !0)
    }
  }),xt.DefineIcon("tableCellHorizontalAlign", {
    NAME: "align-left",
    SVG_KEY: "alignLeft"
  }),xt.DefineIcon("align-left", {
    NAME: "align-left",
    SVG_KEY: "alignLeft"
  }),xt.DefineIcon("align-right", {
    NAME: "align-right",
    SVG_KEY: "alignRight"
  }),xt.DefineIcon("align-center", {
    NAME: "align-center",
    SVG_KEY: "alignCenter"
  }),xt.DefineIcon("align-justify", {
    NAME: "align-justify",
    SVG_KEY: "alignJustify"
  }),xt.RegisterCommand("tableCellHorizontalAlign", {
    type: "dropdown",
    focus: !1,
    title: "Horizontal Align",
    options: {left: "Align Left", center: "Align Center", right: "Align Right", justify: "Align Justify"},
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = xt.COMMANDS.tableCellHorizontalAlign.options;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="tableCellHorizontalAlign" data-param1="'.concat(n, '" title="').concat(this.language.translate(t[n]), '">').concat(this.icon.create("align-".concat(n)), '<span class="fr-sr-only">').concat(this.language.translate(t[n]), "</span></a></li>"));
      return e += "</ul>"
    },
    callback: function (e, t) {
      this.table.horizontalAlign(t)
    },
    refresh: function (e) {
      var t = this.table.selectedCells(), n = this.$;
      t.length && e.find("> *").first().replaceWith(this.icon.create("align-".concat(this.helpers.getAlignment(n(t[0])))))
    },
    refreshOnShow: function (e, t) {
      t.find('.fr-command[data-param1="' + this.helpers.getAlignment(this.$el.find(".fr-selected-cell").first()) + '"]').addClass("fr-active").attr("aria-selected", !0)
    }
  }),xt.DefineIcon("tableCellStyle", {
    NAME: "magic",
    SVG_KEY: "cellStyle"
  }),xt.RegisterCommand("tableCellStyle", {
    title: "Cell Style", type: "dropdown", focus: !1, html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = this.opts.tableCellStyles;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableCellStyle" data-param1="'.concat(n, '" title="').concat(this.language.translate(t[n]), '">').concat(this.language.translate(t[n]), "</a></li>"));
      return e += "</ul>"
    }, callback: function (e, t) {
      this.table.applyStyle(t, this.$el.find(".fr-selected-cell"), this.opts.tableCellMultipleStyles, this.opts.tableCellStyles)
    }, refreshOnShow: function (e, t) {
      var n = this.$, r = this.$el.find(".fr-selected-cell").first();
      r && t.find(".fr-command").each(function () {
        var e = n(this).data("param1"), t = r.hasClass(e);
        n(this).toggleClass("fr-active", t).attr("aria-selected", t)
      })
    }
  }),xt.RegisterCommand("tableCellBackgroundCustomColor", {
    title: "OK", undo: !0, callback: function () {
      this.table.customColor()
    }
  }),xt.DefineIcon("tableColorRemove", {
    NAME: "eraser",
    SVG_KEY: "remove"
  }),xt.URLRegEx = "(^| |\\u00A0)(".concat(xt.LinkRegEx, "|([a-z0-9+-_.]{1,}@[a-z0-9+-_.]{1,}\\.[a-z0-9+-_]{1,}))$"),xt.PLUGINS.url = function (i) {
    var s = i.$, o = null;

    function t(e, t, n) {
      for (var r = ""; n.length && "." == n[n.length - 1];) r += ".", n = n.substring(0, n.length - 1);
      var a = n;
      if (i.opts.linkConvertEmailAddress) i.helpers.isEmail(a) && !/^mailto:.*/i.test(a) && (a = "mailto:".concat(a)); else if (i.helpers.isEmail(a)) return t + n;
      return /^((http|https|ftp|ftps|mailto|tel|sms|notes|data)\:)/i.test(a) || (a = "//".concat(a)), (t || "") + "<a".concat(i.opts.linkAlwaysBlank ? ' target="_blank"' : "").concat(o ? ' rel="'.concat(o, '"') : "", ' data-fr-linked="true" href="').concat(a, '">').concat(n.replace(/&amp;/g, "&").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), "</a>").concat(r)
    }

    var l = function l() {
      return new RegExp(xt.URLRegEx, "gi")
    };

    function c(e) {
      return i.opts.linkAlwaysNoFollow && (o = "nofollow"), i.opts.linkAlwaysBlank && (i.opts.linkNoOpener && (o ? o += " noopener" : o = "noopener"), i.opts.linkNoReferrer && (o ? o += " noreferrer" : o = "noreferrer")), e.replace(l(), t)
    }

    function d(e) {
      var t = e.split(" ");
      return t[t.length - 1]
    }

    function n() {
      var e = i.selection.ranges(0), t = e.startContainer;
      if (!t || t.nodeType !== Node.TEXT_NODE || e.startOffset !== (t.textContent || "").length) return !1;
      if (function o(e) {
        return !!e && ("A" === e.tagName || !(!e.parentNode || e.parentNode == i.el) && o(e.parentNode))
      }(t)) return !1;
      if (l().test(d(t.textContent))) {
        s(t).before(c(t.textContent));
        var n = s(t.parentNode).find("a[data-fr-linked]");
        n.removeAttr("data-fr-linked"), t.parentNode.removeChild(t), i.events.trigger("url.linked", [n.get(0)])
      } else if (t.textContent.split(" ").length <= 2 && t.previousSibling && "A" === t.previousSibling.tagName) {
        var r = t.previousSibling.innerText + t.textContent;
        if (l().test(d(r))) {
          var a = (new DOMParser).parseFromString(c(r), "text/html").body.childNodes;
          t.parentNode.replaceChild(a[0], t.previousSibling), a.length && s(t).before(a[0]), t.parentNode.removeChild(t)
        }
      }
    }

    return {
      _init: function e() {
        i.events.on("keypress", function (e) {
          !i.selection.isCollapsed() || ")" != e.key && "(" != e.key || n()
        }, !0), i.events.on("keydown", function (e) {
          var t = e.which;
          !i.selection.isCollapsed() || t != xt.KEYCODE.ENTER && t != xt.KEYCODE.SPACE || n()
        }, !0), i.events.on("paste.beforeCleanup", function (e) {
          if (i.helpers.isURL(e)) {
            var t = null;
            return i.opts.linkAlwaysBlank && (i.opts.linkNoOpener && (t ? t += " noopener" : t = "noopener"), i.opts.linkNoReferrer && (t ? t += " noreferrer" : t = "noreferrer")), "<a".concat(i.opts.linkAlwaysBlank ? ' target="_blank"' : "").concat(t ? ' rel="'.concat(t, '"') : "", ' href="').concat(e, '" >').concat(e, "</a>")
          }
        })
      }
    }
  },Object.assign(xt.POPUP_TEMPLATES, {
    "video.insert": "[_BUTTONS_][_BY_URL_LAYER_][_EMBED_LAYER_][_UPLOAD_LAYER_][_PROGRESS_BAR_]",
    "video.edit": "[_BUTTONS_]",
    "video.size": "[_BUTTONS_][_SIZE_LAYER_]"
  }),Object.assign(xt.DEFAULTS, {
    videoAllowedTypes: ["mp4", "webm", "ogg", "mp3", "mpeg", "url"],
    videoAllowedProviders: [".*"],
    videoDefaultAlign: "center",
    videoDefaultDisplay: "block",
    videoDefaultWidth: 600,
    videoEditButtons: ["videoReplace", "videoRemove", "videoDisplay", "videoAlign", "videoSize", "autoplay"],
    videoInsertButtons: ["videoBack", "|", "videoByURL", "videoEmbed", "videoUpload"],
    videoMaxSize: 52428800,
    videoMove: !0,
    videoResize: !0,
    videoResponsive: !1,
    videoSizeButtons: ["videoBack", "|"],
    videoSplitHTML: !1,
    videoTextNear: !0,
    videoUpload: !0,
    videoUploadMethod: "POST",
    videoUploadParam: "file",
    videoUploadParams: {},
    videoUploadToS3: !1,
    videoUploadToAzure: !1,
    videoUploadURL: null
  }),xt.VIDEO_PROVIDERS = [{
    test_regex: /^.*((youtu.be)|(youtube.com))\/((v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))?\??v?=?([^#\&\?]*).*/,
    url_regex: /(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|embed\/)?([0-9a-zA-Z_\-]+)(.+)?/g,
    url_text: "https://www.youtube.com/embed/$1?$2",
    html: '<iframe width="640" height="360" src="{url}&wmode=opaque&rel=0" frameborder="0" allowfullscreen></iframe>',
    provider: "youtube"
  }, {
    test_regex: /^.*(?:vimeo.com)\/(?:channels(\/\w+\/)?|groups\/*\/videos\/\u200b\d+\/|video\/|)(\d+)(?:$|\/|\?)/,
    url_regex: /(?:https?:\/\/)?(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?(\/[a-zA-Z0-9_\-]+)?/i,
    url_text: "https://player.vimeo.com/video/$1",
    html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',
    provider: "vimeo"
  }, {
    test_regex: /^.+(dailymotion.com|dai.ly)\/(video|hub)?\/?([^_]+)[^#]*(#video=([^_&]+))?/,
    url_regex: /(?:https?:\/\/)?(?:www\.)?(?:dailymotion\.com|dai\.ly)\/(?:video|hub)?\/?(.+)/g,
    url_text: "https://www.dailymotion.com/embed/video/$1",
    html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',
    provider: "dailymotion"
  }, {
    test_regex: /^.+(screen.yahoo.com)\/[^_&]+/,
    url_regex: "",
    url_text: "",
    html: '<iframe width="640" height="360" src="{url}?format=embed" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',
    provider: "yahoo"
  }, {
    test_regex: /^.+(rutube.ru)\/[^_&]+/,
    url_regex: /(?:https?:\/\/)?(?:www\.)?(?:rutube\.ru)\/(?:video)?\/?(.+)/g,
    url_text: "https://rutube.ru/play/embed/$1",
    html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',
    provider: "rutube"
  }, {
    test_regex: /^(?:.+)vidyard.com\/(?:watch)?\/?([^.&/]+)\/?(?:[^_.&]+)?/,
    url_regex: /^(?:.+)vidyard.com\/(?:watch)?\/?([^.&/]+)\/?(?:[^_.&]+)?/g,
    url_text: "https://play.vidyard.com/$1",
    html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',
    provider: "vidyard"
  }, {
    test_regex: /.*\.mp4\??.*$/i,
    url_regex: "",
      url_text: "",
      html: '<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',
      provider: "*"
    },
  ],xt.VIDEO_EMBED_REGEX = /^\W*((<iframe(.|\n)*>(\s|\n)*<\/iframe>)|(<embed(.|\n)*>))\W*$/i,xt.PLUGINS.video = function (E) {
    var s, d, f, y, r, n, L = E.$, _ = "https://i.froala.com/upload", p = 2, u = 3, h = 4, w = 5, A = 6, a = {};

    function g() {
      var e = E.popups.get("video.insert");
      e.find(".fr-video-by-url-layer input").val("").trigger("change");
      var t = e.find(".fr-video-embed-layer textarea");
      t.val("").trigger("change"), (t = e.find(".fr-video-upload-layer input")).val("").trigger("change")
    }

    function o() {
      var e = E.popups.get("video.edit");
      if (e || (e = function i() {
        var e = "";
        if (0 < E.opts.videoEditButtons.length) {
          E.opts.videoResponsive && (-1 < E.opts.videoEditButtons.indexOf("videoSize") && E.opts.videoEditButtons.splice(E.opts.videoEditButtons.indexOf("videoSize"), 1), -1 < E.opts.videoEditButtons.indexOf("videoDisplay") && E.opts.videoEditButtons.splice(E.opts.videoEditButtons.indexOf("videoDisplay"), 1), -1 < E.opts.videoEditButtons.indexOf("videoAlign") && E.opts.videoEditButtons.splice(E.opts.videoEditButtons.indexOf("videoAlign"), 1));
          var t = {buttons: e += '<div class="fr-buttons"> \n      '.concat(E.button.buildList(E.opts.videoEditButtons), " \n      </div>")},
            n = E.popups.create("video.edit", t);
          return E.events.$on(E.$wp, "scroll.video-edit", function () {
            y && E.popups.isVisible("video.edit") && (E.events.disableBlur(), C(y))
          }), n
        }
        return !1
      }()), e) {
        E.popups.setContainer("video.edit", E.$sc), E.popups.refresh("video.edit");
        var t = y.find("iframe, embed, ".concat(y.find("iframe, embed, audio").get(0) ? "audio" : "video")),
          n = t.offset().left + t.outerWidth() / 2, r = t.offset().top + t.outerHeight(),
          a = t.get(0).src ? t.get(0).src : t.get(0).currentSrc,
          o = !(!(a = (a = a.split("."))[a.length - 1]).includes("pdf") && !a.includes("txt"));
        t.hasClass("fr-file") || o || y.find("audio").get(0) ? (document.getElementById("autoplay-".concat(E.id)) && (document.getElementById("autoplay-".concat(E.id)).style.display = "none"), document.getElementById("videoReplace-".concat(E.id)) && (document.getElementById("videoReplace-".concat(E.id)).style.display = "none")) : (document.getElementById("autoplay-".concat(E.id)) && (document.getElementById("autoplay-".concat(E.id)).style.display = ""), document.getElementById("videoReplace-".concat(E.id)) && (document.getElementById("videoReplace-".concat(E.id)).style.display = "")), E.popups.show("video.edit", n, r, t.outerHeight(), !0)
      }
    }

    function i(e) {
      if (e) return E.popups.onRefresh("video.insert", g), E.popups.onHide("video.insert", Z), !0;
      var t = "";
      E.opts.videoUpload || -1 === E.opts.videoInsertButtons.indexOf("videoUpload") || E.opts.videoInsertButtons.splice(E.opts.videoInsertButtons.indexOf("videoUpload"), 1);
      var n = E.button.buildList(E.opts.videoInsertButtons);
      "" !== n && (t = '<div class="fr-buttons">' + n + "</div>");
      var r, a = "", o = E.opts.videoInsertButtons.indexOf("videoUpload"),
        i = E.opts.videoInsertButtons.indexOf("videoByURL"), s = E.opts.videoInsertButtons.indexOf("videoEmbed");
      if (0 <= i) {
        r = " fr-active", (o < i && 0 <= o || s < i && 0 <= s) && (r = "");
        a = '<div class="fr-video-by-url-layer fr-layer'.concat(r, '" id="fr-video-by-url-layer-').concat(E.id, '"><div class="fr-input-line"><input id="fr-video-by-url-layer-text-').concat(E.id, '" type="text" placeholder="').concat(E.language.translate("Paste in a video URL"), '" tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><span style=\'float:left\'><div class="fr-checkbox-line fr-autoplay-margin"><span class="fr-checkbox"> <input id=\'videoPluginAutoplay\' data-checked="_blank" type="checkbox"> <span>').concat('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg>', '</span></span> <label id="fr-label-target-').concat(E.id, '">Autoplay</label></div> </span><button type="button" class="fr-command fr-submit" data-cmd="videoInsertByURL" tabIndex="2" role="button">').concat(E.language.translate("Insert"), "</button></div></div>")
      }
      var l = "";
      0 <= s && (r = " fr-active", (o < s && 0 <= o || i < s && 0 <= i) && (r = ""), l = '<div class="fr-video-embed-layer fr-layer'.concat(r, '" id="fr-video-embed-layer-').concat(E.id, '"><div class="fr-input-line"><textarea id="fr-video-embed-layer-text').concat(E.id, '" type="text" placeholder="').concat(E.language.translate("Embedded Code"), '" tabIndex="1" aria-required="true" rows="5"></textarea></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="videoInsertEmbed" tabIndex="2" role="button">').concat(E.language.translate("Insert"), "</button></div></div>"));
      var c = "";
      0 <= o && (r = " fr-active", (s < o && 0 <= s || i < o && 0 <= i) && (r = ""), c = '<div class="fr-video-upload-layer fr-layer'.concat(r, '" id="fr-video-upload-layer-').concat(E.id, '"><strong>').concat(E.language.translate("Drop video"), "</strong><br>(").concat(E.language.translate("or click"), ')<div class="fr-form"><input type="file" accept="video/').concat(E.opts.videoAllowedTypes.join(", video/").toLowerCase(), '" tabIndex="-1" aria-labelledby="fr-video-upload-layer-').concat(E.id, '" role="button"></div></div>'));
      var d = {
        buttons: t,
        by_url_layer: a,
        embed_layer: l,
        upload_layer: c,
        progress_bar: '<div class="fr-video-progress-bar-layer fr-layer"><h3 tabIndex="-1" class="fr-message">Uploading</h3><div class="fr-loader"><span class="fr-progress"></span></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-dismiss" data-cmd="videoDismissError" tabIndex="2" role="button">OK</button></div></div>'
      }, f = E.popups.create("video.insert", d);
      return function p(r) {
        E.events.$on(r, "dragover dragenter", ".fr-video-upload-layer", function () {
          return L(this).addClass("fr-drop"), !1
        }, !0), E.events.$on(r, "dragleave dragend", ".fr-video-upload-layer", function () {
          return L(this).removeClass("fr-drop"), !1
        }, !0), E.events.$on(r, "drop", ".fr-video-upload-layer", function (e) {
          e.preventDefault(), e.stopPropagation(), L(this).removeClass("fr-drop");
          var t = e.originalEvent.dataTransfer;
          if (t && t.files) {
            var n = r.data("instance") || E;
            n.events.disableBlur(), n.video.upload(t.files), n.events.enableBlur()
          }
        }, !0), E.helpers.isIOS() && E.events.$on(r, "touchstart", '.fr-video-upload-layer input[type="file"]', function () {
          L(this).trigger("click")
        }, !0);
        E.events.$on(r, "change", '.fr-video-upload-layer input[type="file"]', function () {
          if (this.files) {
            var e = r.data("instance") || E;
            e.events.disableBlur(), r.find("input:focus").blur(), e.events.enableBlur(), e.video.upload(this.files)
          }
          L(this).val("")
        }, !0)
      }(f), f
    }

    function l(e) {
      E.events.focus(!0), E.selection.restore();
      var t = !1;
      if (y && (q(), t = !0), E.opts.trackChangesEnabled) {
        E.edit.on(), E.events.focus(!0), E.selection.restore(), E.undo.saveStep(), E.markers.insert(), E.html.wrap();
        var n = E.$el.find(".fr-marker");
        E.node.isLastSibling(n) && n.parent().hasClass("fr-deletable") && n.insertAfter(n.parent()), n.replaceWith('<span contenteditable="false" draggable="true" class="fr-jiv fr-video fr-deletable">'.concat(e, "</span>")), E.selection.clear()
      } else E.html.insert('<span contenteditable="false" draggable="true" class="fr-jiv fr-video fr-deletable">'.concat(e, "</span>"), !1, E.opts.videoSplitHTML);
      E.popups.hide("video.insert");
      var r = E.$el.find(".fr-jiv");
      r.removeClass("fr-jiv"), r.toggleClass("fr-rv", E.opts.videoResponsive), X(r, E.opts.videoDefaultDisplay, E.opts.videoDefaultAlign), r.toggleClass("fr-draggable", E.opts.videoMove), E.events.trigger(t ? "video.replaced" : "video.inserted", [r])
    }

    function m() {
      var e = L(this);
      E.popups.hide("video.insert"), e.removeClass("fr-uploading"), e.parent().next().is("br") && e.parent().next().remove(), C(e.parent()), E.events.trigger("video.loaded", [e.parent()])
    }

    function T(s, e, c, d, f) {
      E.edit.off(), v("Loading video"), e && (s = E.helpers.sanitizeURL(s));
      var p = function p() {
        var e, t;
        if (d) {
          E.undo.canDo() || d.find("video").hasClass("fr-uploading") || E.undo.saveStep();
          var n = d.find("video").data("fr-old-src"), r = d.data("fr-replaced");
          d.data("fr-replaced", !1), E.$wp ? ((e = d.clone(!0)).find("video").removeData("fr-old-src").removeClass("fr-uploading"), e.find("video").off("canplay"), n && d.find("video").attr("src", n), d.replaceWith(e)) : e = d;
          for (var a = e.find("video").get(0).attributes, o = 0; o < a.length; o++) {
            var i = a[o];
            0 === i.nodeName.indexOf("data-") && e.find("video").removeAttr(i.nodeName)
          }
          if (void 0 !== c) for (t in c) c.hasOwnProperty(t) && "link" != t && e.find("video").attr("data-".concat(t), c[t]);
          e.find("video").on("canplay", m), e.find("video").attr("src", s), E.edit.on(), H(), E.undo.saveStep(), E.$el.blur(), E.events.trigger(r ? "video.replaced" : "video.inserted", [e, f])
        } else e = function l(e, t, n) {
          var r, a = "";
          if (t && void 0 !== t) for (r in t) t.hasOwnProperty(r) && "link" != r && (a += " data-".concat(r, '="').concat(t[r], '"'));
          var o = E.opts.videoDefaultWidth;
          o && "auto" != o && (o = "".concat(o, "px"));
          var i = L(document.createElement("span")).attr("contenteditable", "false").attr("draggable", "true").attr("class", "fr-video fr-dv" + E.opts.videoDefaultDisplay[0] + ("center" != E.opts.videoDefaultAlign ? " fr-fv" + E.opts.videoDefaultAlign[0] : "")).html('<video src="' + e + '" ' + a + (o ? ' style="width: ' + o + ';" ' : "") + " controls>" + E.language.translate("Your browser does not support HTML5 video.") + "</video>");
          i.toggleClass("fr-draggable", E.opts.videoMove), E.edit.on(), E.events.focus(!0), E.selection.restore(), E.undo.saveStep(), E.opts.videoSplitHTML ? E.markers.split() : E.markers.insert();
          E.html.wrap();
          var s = E.$el.find(".fr-marker");
          E.node.isLastSibling(s) && s.parent().hasClass("fr-deletable") && s.insertAfter(s.parent());
          s.replaceWith(i), E.selection.clear(), i.find("video").get(0).readyState > i.find("video").get(0).HAVE_FUTURE_DATA || E.helpers.isIOS() ? n.call(i.find("video").get(0)) : i.find("video").on("canplaythrough load", n);
          return i
        }(s, c, m), H(), E.undo.saveStep(), E.events.trigger("video.inserted", [e, f])
      };
      S("Loading video"), p()
    }

    function S(e) {
      var t = E.popups.get("video.insert");
      if (t || (t = i()), t.find(".fr-layer.fr-active").removeClass("fr-active").addClass("fr-pactive"), t.find(".fr-video-progress-bar-layer").addClass("fr-active"), t.find(".fr-buttons").hide(), y) {
        var n = y.find("iframe, embed, ".concat(y.find("iframe, embed, audio").get(0) ? "audio" : "video"));
        E.popups.setContainer("video.insert", E.$sc);
        var r = n.offset().left, a = n.offset().top + n.height();
        E.popups.show("video.insert", r, a, n.outerHeight())
      }
      void 0 === e && v(E.language.translate("Uploading"), 0)
    }

    function c(e) {
      var t = E.popups.get("video.insert");
      if (t && (t.find(".fr-layer.fr-pactive").addClass("fr-active").removeClass("fr-pactive"), t.find(".fr-video-progress-bar-layer").removeClass("fr-active"), t.find(".fr-buttons").show(), e || E.$el.find("video.fr-error").length)) {
        if (E.events.focus(), E.$el.find("video.fr-error").length && (E.$el.find("video.fr-error").parent().remove(), E.undo.saveStep(), E.undo.run(), E.undo.dropRedo()), !E.$wp && y) {
          var n = y;
          F(!0), E.selection.setAfter(n.find("video").get(0)), E.selection.restore()
        }
        E.popups.hide("video.insert")
      }
    }

    function v(e, t) {
      var n = E.popups.get("video.insert");
      if (n) {
        var r = n.find(".fr-video-progress-bar-layer");
        r.find("h3").text(e + (t ? " ".concat(t, "%") : "")), r.removeClass("fr-error"), t ? (r.find("div").removeClass("fr-indeterminate"), r.find("div > span").css("width", "".concat(t, "%"))) : r.find("div").addClass("fr-indeterminate")
      }
    }

    function b(e) {
      S();
      var t = E.popups.get("video.insert").find(".fr-video-progress-bar-layer");
      t.addClass("fr-error");
      var n = t.find("h3");
      n.text(e), E.events.disableBlur(), n.focus()
    }

    function C(e) {
      t.call(e.get(0))
    }

    function k(e, t, n) {
      v("Loading video");
      var r = this.status, a = this.response, o = this.responseXML, i = this.responseText;
      try {
        if (E.opts.videoUploadToS3 || E.opts.videoUploadToAzure) if (201 == r) {
          var s;
          if (E.opts.videoUploadToAzure) {
            if (!1 === E.events.trigger("video.uploadedToAzure", [this.responseURL, n, a], !0)) return E.edit.on(), !1;
            s = t
          } else s = function c(e) {
            try {
              var t = L(e).find("Location").text(), n = L(e).find("Key").text();
              return !1 === E.events.trigger("video.uploadedToS3", [t, n, e], !0) ? (E.edit.on(), !1) : t
            } catch (r) {
              return V(h, e), !1
            }
          }(o);
          s && T(s, !1, [], e, a || o)
        } else V(h, a || o); else if (200 <= r && r < 300) {
          var l = function d(e) {
            try {
              if (!1 === E.events.trigger("video.uploaded", [e], !0)) return E.edit.on(), !1;
              var t = JSON.parse(e);
              return t.link ? t : (V(p, e), !1)
            } catch (n) {
              return V(h, e), !1
            }
          }(i);
          l && T(l.link, !1, l, e, a || i)
        } else V(u, a || i)
      } catch (f) {
        V(h, a || i)
      }
    }

    function x() {
      V(h, this.response || this.responseText || this.responseXML)
    }

    function R(e) {
      if (e.lengthComputable) {
        var t = e.loaded / e.total * 100 | 0;
        v(E.language.translate("Uploading"), t)
      }
    }

    function M() {
      E.edit.on(), c(!0)
    }

    function O(e) {
      if (!E.core.sameInstance(f)) return !0;
      e.preventDefault(), e.stopPropagation();
      var t = e.pageX || (e.originalEvent.touches ? e.originalEvent.touches[0].pageX : null),
        n = e.pageY || (e.originalEvent.touches ? e.originalEvent.touches[0].pageY : null);
      if (!t || !n) return !1;
      if ("mousedown" == e.type) {
        var r = E.$oel.get(0).ownerDocument, a = r.defaultView || r.parentWindow, o = !1;
        try {
          o = a.location != a.parent.location && !(a.$ && a.$.FE)
        } catch (i) {
        }
        o && a.frameElement && (t += E.helpers.getPX(L(a.frameElement).offset().left) + a.frameElement.clientLeft, n = e.clientY + E.helpers.getPX(L(a.frameElement).offset().top) + a.frameElement.clientTop)
      }
      E.undo.canDo() || E.undo.saveStep(), (d = L(this)).data("start-x", t), d.data("start-y", n), s.show(), E.popups.hideAll(), U()
    }

    function N(e) {
      if (!E.core.sameInstance(f)) return !0;
      if (d) {
        e.preventDefault();
        var t = e.pageX || (e.originalEvent.touches ? e.originalEvent.touches[0].pageX : null),
          n = e.pageY || (e.originalEvent.touches ? e.originalEvent.touches[0].pageY : null);
        if (!t || !n) return !1;
        var r = d.data("start-x"), a = d.data("start-y");
        d.data("start-x", t), d.data("start-y", n);
        var o = t - r, i = n - a,
          s = y.find("iframe, embed, ".concat(y.find("iframe, embed, audio").get(0) ? "audio" : "video")),
          l = s.width(), c = s.height();
        (d.hasClass("fr-hnw") || d.hasClass("fr-hsw")) && (o = 0 - o), (d.hasClass("fr-hnw") || d.hasClass("fr-hne")) && (i = 0 - i), s.css("width", l + o), s.css("height", c + i), s.removeAttr("width"), s.removeAttr("height"), $()
      }
    }

    function I(e) {
      if (!E.core.sameInstance(f)) return !0;
      d && y && (e && e.stopPropagation(), d = null, s.hide(), $(), o(), E.undo.saveStep())
    }

    function D(e) {
      return '<div class="fr-handler fr-h'.concat(e, '"></div>')
    }

    function B(e, t, n, r) {
      return e.pageX = t, e.pageY = t, O.call(this, e), e.pageX = e.pageX + n * Math.floor(Math.pow(1.1, r)), e.pageY = e.pageY + n * Math.floor(Math.pow(1.1, r)), N.call(this, e), I.call(this, e), ++r
    }

    function H() {
      var e, t = Array.prototype.slice.call(E.el.querySelectorAll("video, .fr-video > *")), n = [];
      for (e = 0; e < t.length; e++) n.push(t[e].getAttribute("src")), L(t[e]).toggleClass("fr-draggable", E.opts.videoMove), "" === t[e].getAttribute("class") && t[e].removeAttribute("class"), "" === t[e].getAttribute("style") && t[e].removeAttribute("style");
      if (r) for (e = 0; e < r.length; e++) n.indexOf(r[e].getAttribute("src")) < 0 && E.events.trigger("video.removed", [L(r[e])]);
      r = t
    }

    function $() {
      f || function i() {
        var e;
        if (E.shared.$video_resizer ? (f = E.shared.$video_resizer, s = E.shared.$vid_overlay, E.events.on("destroy", function () {
          L("body").first().append(f.removeClass("fr-active"))
        }, !0)) : (E.shared.$video_resizer = L(document.createElement("div")).attr("class", "fr-video-resizer"), f = E.shared.$video_resizer, E.events.$on(f, "mousedown", function (e) {
          e.stopPropagation()
        }, !0), E.opts.videoResize && (f.append(D("nw") + D("ne") + D("sw") + D("se")), E.shared.$vid_overlay = L(document.createElement("div")).attr("class", "fr-video-overlay"), s = E.shared.$vid_overlay, e = f.get(0).ownerDocument, L(e).find("body").first().append(s))), E.events.on("shared.destroy", function () {
          f.html("").removeData().remove(), f = null, E.opts.videoResize && (s.remove(), s = null)
        }, !0), E.helpers.isMobile() || E.events.$on(L(E.o_win), "resize.video", function () {
          F(!0)
        }), E.opts.videoResize) {
          e = f.get(0).ownerDocument, E.events.$on(f, E._mousedown, ".fr-handler", O), E.events.$on(L(e), E._mousemove, N), E.events.$on(L(e.defaultView || e.parentWindow), E._mouseup, I), E.events.$on(s, "mouseleave", I);
          var r = 1, a = null, o = 0;
          E.events.on("keydown", function (e) {
            if (y) {
              var t = -1 != navigator.userAgent.indexOf("Mac OS X") ? e.metaKey : e.ctrlKey, n = e.which;
              (n !== a || 200 < e.timeStamp - o) && (r = 1), (n == xt.KEYCODE.EQUALS || E.browser.mozilla && n == xt.KEYCODE.FF_EQUALS) && t && !e.altKey ? r = B.call(this, e, 1, 1, r) : (n == xt.KEYCODE.HYPHEN || E.browser.mozilla && n == xt.KEYCODE.FF_HYPHEN) && t && !e.altKey && (r = B.call(this, e, 2, -1, r)), a = n, o = e.timeStamp
            }
          }), E.events.on("keyup", function () {
            r = 1
          })
        }
      }(), (E.$wp || E.$sc).append(f), f.data("instance", E);
      var e = y.find("iframe, embed, ".concat(y.find("iframe, embed, audio").get(0) ? "audio" : "video")), t = 0, n = 0;
      E.opts.iframe && (n = E.helpers.getPX(E.$wp.find(".fr-iframe").css("padding-top")), t = E.helpers.getPX(E.$wp.find(".fr-iframe").css("padding-left"))), f.css("top", (E.opts.iframe ? e.offset().top + n - 1 : e.offset().top - E.$wp.offset().top - 1) + E.$wp.scrollTop()).css("left", (E.opts.iframe ? e.offset().left + t - 1 : e.offset().left - E.$wp.offset().left - 1) + E.$wp.scrollLeft()).css("width", e.get(0).getBoundingClientRect().width).css("height", e.get(0).getBoundingClientRect().height).addClass("fr-active")
    }

    function t(e) {
      if (e && "touchend" == e.type && n) return !0;
      if (e && E.edit.isDisabled()) return e.stopPropagation(), e.preventDefault(), !1;
      if (E.edit.isDisabled()) return !1;
      for (var t = 0; t < xt.INSTANCES.length; t++) xt.INSTANCES[t] != E && xt.INSTANCES[t].events.trigger("video.hideResizer");
      E.toolbar.disable(), E.helpers.isMobile() && (E.events.disableBlur(), E.$el.blur(), E.events.enableBlur()), E.$el.find(".fr-video.fr-active").removeClass("fr-active"), (y = L(this)).addClass("fr-active"), E.opts.iframe && E.size.syncIframe(), ee(), $(), o(), E.selection.clear(), E.button.bulkRefresh(), E.events.trigger("image.hideResizer")
    }

    function F(e) {
      y && (function t() {
        return E.shared.vid_exit_flag
      }() || !0 === e) && (f.removeClass("fr-active"), E.toolbar.enable(), y.removeClass("fr-active"), y = null, U())
    }

    function P() {
      E.shared.vid_exit_flag = !0
    }

    function U() {
      E.shared.vid_exit_flag = !1
    }

    function z(e) {
      var t = e.originalEvent.dataTransfer;
      if (t && t.files && t.files.length) {
        var n = t.files[0];
        if (n && n.type && -1 !== n.type.indexOf("video")) {
          if (!E.opts.videoUpload) return e.preventDefault(), e.stopPropagation(), !1;
          E.markers.remove(), E.markers.insertAtPoint(e.originalEvent), E.$el.find(".fr-marker").replaceWith(xt.MARKERS), E.popups.hideAll();
          var r = E.popups.get("video.insert");
          return r || (r = i()), E.popups.setContainer("video.insert", E.$sc), E.popups.show("video.insert", e.originalEvent.pageX, e.originalEvent.pageY), S(), 0 <= E.opts.videoAllowedTypes.indexOf(n.type.replace(/video\//g, "")) ? K(t.files) : V(A), e.preventDefault(), e.stopPropagation(), !1
        }
      }
    }

    function K(e) {
      if (void 0 !== e && 0 < e.length) {
        if (!1 === E.events.trigger("video.beforeUpload", [e])) return !1;
        var t, n = e[0];
        if (!(null !== E.opts.videoUploadURL && E.opts.videoUploadURL != _ || E.opts.videoUploadToS3 || E.opts.videoUploadToAzure)) return function C(r) {
          y && y.find("iframe") && y.find("iframe").length && q();
          var a = new FileReader;
          a.onload = function () {
            a.result;
            for (var e = atob(a.result.split(",")[1]), t = [], n = 0; n < e.length; n++) t.push(e.charCodeAt(n));
            T(window.URL.createObjectURL(new Blob([new Uint8Array(t)], {type: r.type})), !1, null, y)
          }, S(), a.readAsDataURL(r)
        }(n), !1;
        if (n.size > E.opts.videoMaxSize) return V(w), !1;
        if (E.opts.videoAllowedTypes.indexOf(n.type.replace(/video\//g, "")) < 0) return V(A), !1;
        if (E.drag_support.formdata && (t = E.drag_support.formdata ? new FormData : null), t) {
          var r;
          if (!1 !== E.opts.videoUploadToS3) for (r in t.append("key", E.opts.videoUploadToS3.keyStart + (new Date).getTime() + "-" + (n.name || "untitled")), t.append("success_action_status", "201"), t.append("X-Requested-With", "xhr"), t.append("Content-Type", n.type), E.opts.videoUploadToS3.params) E.opts.videoUploadToS3.params.hasOwnProperty(r) && t.append(r, E.opts.videoUploadToS3.params[r]);
          for (r in E.opts.videoUploadParams) E.opts.videoUploadParams.hasOwnProperty(r) && t.append(r, E.opts.videoUploadParams[r]);
          t.append(E.opts.videoUploadParam, n);
          var a, o, i = E.opts.videoUploadURL;
          E.opts.videoUploadToS3 && (i = E.opts.videoUploadToS3.uploadURL ? E.opts.videoUploadToS3.uploadURL : "https://".concat(E.opts.videoUploadToS3.region, ".amazonaws.com/").concat(E.opts.videoUploadToS3.bucket));
          var s = E.opts.videoUploadMethod;
          E.opts.videoUploadToAzure && (i = E.opts.videoUploadToAzure.uploadURL ? "".concat(E.opts.videoUploadToAzure.uploadURL, "/").concat(n.name) : encodeURI("https://".concat(E.opts.videoUploadToAzure.account, ".blob.core.windows.net/").concat(E.opts.videoUploadToAzure.container, "/").concat(n.name)), a = i, E.opts.videoUploadToAzure.SASToken && (i += E.opts.videoUploadToAzure.SASToken), s = "PUT");
          var l = E.core.getXHR(i, s);
          if (E.opts.videoUploadToAzure) {
            var c = (new Date).toUTCString();
            if (!E.opts.videoUploadToAzure.SASToken && E.opts.videoUploadToAzure.accessKey) {
              var d = E.opts.videoUploadToAzure.account, f = E.opts.videoUploadToAzure.container;
              if (E.opts.videoUploadToAzure.uploadURL) {
                var p = E.opts.videoUploadToAzure.uploadURL.split("/");
                f = p.pop(), d = p.pop().split(".")[0]
              }
              var u = "x-ms-blob-type:BlockBlob\nx-ms-date:".concat(c, "\nx-ms-version:2019-07-07"),
                h = encodeURI("/" + d + "/" + f + "/" + n.name),
                g = s + "\n\n\n" + n.size + "\n\n" + n.type + "\n\n\n\n\n\n\n" + u + "\n" + h,
                m = E.cryptoJSPlugin.cryptoJS.HmacSHA256(g, E.cryptoJSPlugin.cryptoJS.enc.Base64.parse(E.opts.videoUploadToAzure.accessKey)).toString(E.cryptoJSPlugin.cryptoJS.enc.Base64),
                v = "SharedKey " + d + ":" + m;
              o = m, l.setRequestHeader("Authorization", v)
            }
            for (r in l.setRequestHeader("x-ms-version", "2019-07-07"), l.setRequestHeader("x-ms-date", c), l.setRequestHeader("Content-Type", n.type), l.setRequestHeader("x-ms-blob-type", "BlockBlob"), E.opts.videoUploadParams) E.opts.videoUploadParams.hasOwnProperty(r) && l.setRequestHeader(r, E.opts.videoUploadParams[r]);
            for (r in E.opts.videoUploadToAzure.params) E.opts.videoUploadToAzure.params.hasOwnProperty(r) && l.setRequestHeader(r, E.opts.videoUploadToAzure.params[r])
          }
          l.onload = function () {
            k.call(l, y, a, o)
          }, l.onerror = x, l.upload.onprogress = R, l.onabort = M, S(), E.events.disableBlur(), E.edit.off(), E.events.enableBlur();
          var b = E.popups.get("video.insert");
          b && L(b.off("abortUpload")).on("abortUpload", function () {
            4 != l.readyState && l.abort()
          }), l.send(E.opts.videoUploadToAzure ? n : t)
        }
      }
    }

    function V(e, t) {
      E.edit.on(), y && y.find("video").addClass("fr-error"), b(E.language.translate("Something went wrong. Please try again.")), E.events.trigger("video.error", [{
        code: e,
        message: a[e]
      }, t])
    }

    function W() {
      if (y) {
        var e = E.popups.get("video.size"),
          t = y.find("iframe, embed, ".concat(y.find("iframe, embed, audio").get(0) ? "audio" : "video"));
        e.find('input[name="width"]').val(t.get(0).style.width || t.attr("width")).trigger("change"), e.find('input[name="height"]').val(t.get(0).style.height || t.attr("height")).trigger("change")
      }
    }

    function G(e) {
      if (e) return E.popups.onRefresh("video.size", W), !0;
      var t = {
        buttons: '<div class="fr-buttons fr-tabs">'.concat(E.button.buildList(E.opts.videoSizeButtons), "</div>"),
        size_layer: '<div class="fr-video-size-layer fr-layer fr-active" id="fr-video-size-layer-'.concat(E.id, '"><div class="fr-video-group"><div class="fr-input-line"><input id="fr-video-size-layer-width-').concat(E.id, '" type="text" name="width" placeholder="').concat(E.language.translate("Width"), '" tabIndex="1"></div><div class="fr-input-line"><input id="fr-video-size-layer-height-').concat(E.id, '" type="text" name="height" placeholder="').concat(E.language.translate("Height"), '" tabIndex="1"></div></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="videoSetSize" tabIndex="2" role="button">').concat(E.language.translate("Update"), "</button></div></div>")
      }, n = E.popups.create("video.size", t);
      return E.events.$on(E.$wp, "scroll", function () {
        y && E.popups.isVisible("video.size") && (E.events.disableBlur(), C(y))
      }), n
    }

    function Y(e) {
      if (void 0 === e && (e = y), e) {
        if (e.hasClass("fr-fvl")) return "left";
        if (e.hasClass("fr-fvr")) return "right";
        if (e.hasClass("fr-dvb") || e.hasClass("fr-dvi")) return "center";
        if ("block" == e.css("display")) {
          if ("left" == e.css("text-algin")) return "left";
          if ("right" == e.css("text-align")) return "right"
        } else {
          if ("left" == e.css("float")) return "left";
          if ("right" == e.css("float")) return "right"
        }
      }
      return "center"
    }

    function j(e) {
      void 0 === e && (e = y);
      var t = e.css("float");
      return e.css("float", "none"), "block" == e.css("display") ? (e.css("float", ""), e.css("float") != t && e.css("float", t), "block") : (e.css("float", ""), e.css("float") != t && e.css("float", t), "inline")
    }

    function q() {
      if (y && !1 !== E.events.trigger("video.beforeRemove", [y])) {
        var e = y;
        if (E.popups.hideAll(), F(!0), E.opts.trackChangesEnabled && (!e[0].parentNode || "SPAN" !== e[0].parentNode.tagName || !e[0].parentNode.hasAttribute("data-tracking"))) return void E.track_changes.removeSpecialItem(e);
        E.selection.setBefore(e.get(0)) || E.selection.setAfter(e.get(0)), e.remove(), E.selection.restore(), E.html.fillEmptyBlocks()
      }
    }

    function Z() {
      c()
    }

    function X(e, t, n) {
      !E.opts.htmlUntouched && E.opts.useClasses ? (e.removeClass("fr-fvl fr-fvr fr-dvb fr-dvi"), e.addClass("fr-fv".concat(n[0], " fr-dv").concat(t[0]))) : "inline" == t ? (e.css({display: "inline-block"}), "center" == n ? e.css({"float": "none"}) : "left" == n ? e.css({"float": "left"}) : e.css({"float": "right"})) : (e.css({
        display: "block",
        clear: "both"
      }), "left" == n ? e.css({textAlign: "left"}) : "right" == n ? e.css({textAlign: "right"}) : e.css({textAlign: "center"}))
    }

    function Q() {
      var e = E.$el.find("video").filter(function () {
        return 0 === L(this).parents("span.fr-video").length
      });
      if (0 != e.length) {
        e.wrap(L(document.createElement("span")).attr("class", "fr-video fr-deletable").attr("contenteditable", "false")), E.$el.find("embed, iframe").filter(function () {
          if (E.browser.safari && this.getAttribute("src") && this.setAttribute("src", this.src), 0 < L(this).parents("span.fr-video").length) return !1;
          for (var e = L(this).attr("src"), t = 0; t < xt.VIDEO_PROVIDERS.length; t++) {
            var n = xt.VIDEO_PROVIDERS[t];
            if (n.test_regex.test(e) && new RegExp(E.opts.videoAllowedProviders.join("|")).test(n.provider)) return !0
          }
          return !1
        }).map(function () {
          return 0 === L(this).parents("object").length ? this : L(this).parents("object").get(0)
        }).wrap(L(document.createElement("span")).attr("class", "fr-video").attr("contenteditable", "false"));
        for (var t, n, r, a, o = E.$el.find("span.fr-video, video"), i = 0; i < o.length; i++) {
          var s = L(o[i]);
          !E.opts.htmlUntouched && E.opts.useClasses ? ((a = s).hasClass("fr-dvi") || a.hasClass("fr-dvb") || (a.addClass("fr-fv".concat(Y(a)[0])), a.addClass("fr-dv".concat(j(a)[0]))), E.opts.videoTextNear || s.removeClass("fr-dvi").addClass("fr-dvb")) : E.opts.htmlUntouched || E.opts.useClasses || (void 0, n = (t = s).hasClass("fr-dvb") ? "block" : t.hasClass("fr-dvi") ? "inline" : null, r = t.hasClass("fr-fvl") ? "left" : t.hasClass("fr-fvr") ? "right" : Y(t), X(t, n, r), t.removeClass("fr-dvb fr-dvi fr-fvr fr-fvl"))
        }
        o.toggleClass("fr-draggable", E.opts.videoMove)
      }
    }

    function J(e) {
      document.getElementById("autoplay-".concat(E.id)).style.cssText = "background:".concat(e)
    }

    function ee() {
      if (y) {
        E.selection.clear();
        var e = E.doc.createRange();
        e.selectNode(y.get(0)), E.selection.get().addRange(e)
      }
    }

    return a[1] = "Video cannot be loaded from the passed link.", a[p] = "No link in upload response.", a[u] = "Error during file upload.", a[h] = "Parsing response failed.", a[w] = "File is too large.", a[A] = "Video file type is invalid.", a[7] = "Files can be uploaded only to same domain in IE 8 and IE 9.", E.shared.vid_exit_flag = !1, {
      _init: function te() {
        E.opts.videoResponsive && (E.opts.videoResize = !1), function e() {
          E.events.on("drop", z, !0), E.events.on("mousedown window.mousedown", P), E.events.on("window.touchmove", U), E.events.on("mouseup window.mouseup", F), E.events.on("commands.mousedown", function (e) {
            0 < e.parents(".fr-toolbar").length && F()
          }), E.events.on("video.hideResizer commands.undo commands.redo element.dropped", function () {
            F(!0)
          })
        }(), E.helpers.isMobile() && (E.events.$on(E.$el, "touchstart", "span.fr-video", function () {
          n = !1
        }), E.events.$on(E.$el, "touchmove", function () {
          n = !0
        })), E.events.on("html.set", Q), Q(), E.events.$on(E.$el, "mousedown", "span.fr-video", function (e) {
          e.stopPropagation(), (E.browser.msie || E.browser.edge) && (e.target.innerText || (e.target.dragDrop(), t.call(this, e)))
        }), E.events.$on(E.$el, "click touchend", "span.fr-video", function (e) {
          if (e.target.innerText.length || "false" == L(this).parents("[contenteditable]").not(".fr-element").not(".fr-img-caption").not("body").first().attr("contenteditable")) return !0;
          t.call(this, e)
        }), E.events.on("keydown", function (e) {
          var t = e.which;
          return !y || t != xt.KEYCODE.BACKSPACE && t != xt.KEYCODE.DELETE ? y && t == xt.KEYCODE.ESC ? (F(!0), e.preventDefault(), !1) : y && t != xt.KEYCODE.F10 && !E.keys.isBrowserAction(e) ? (e.preventDefault(), !1) : void 0 : (e.preventDefault(), q(), E.undo.saveStep(), !1)
        }, !0), E.events.on("toolbar.esc", function () {
          if (y) return E.events.disableBlur(), E.events.focus(), !1
        }, !0), E.events.on("toolbar.focusEditor", function () {
          if (y) return !1
        }, !0), E.events.on("keydown", function () {
          E.$el.find("span.fr-video:empty").remove()
        }), E.$wp && (H(), E.events.on("contentChanged", H)), i(!0), G(!0)
      }, showInsertPopup: function ne() {
        var e = E.$tb.find('.fr-command[data-cmd="insertVideo"]'), t = E.popups.get("video.insert");
        if (t || (t = i()), c(), !t.hasClass("fr-active")) if (E.popups.refresh("video.insert"), E.popups.setContainer("video.insert", E.$tb), e.isVisible()) {
          var n = E.button.getPosition(e), r = n.left, a = n.top;
          E.popups.show("video.insert", r, a, e.outerHeight())
        } else E.position.forSelection(t), E.popups.show("video.insert")
      }, showLayer: function re(e) {
        var t, n, r = E.popups.get("video.insert");
        if (!y && !E.opts.toolbarInline) {
          var a = E.$tb.find('.fr-command[data-cmd="insertVideo"]');
          t = a.offset().left, n = a.offset().top + (E.opts.toolbarBottom ? 10 : a.outerHeight() - 10)
        }
        E.opts.toolbarInline && (n = r.offset().top - E.helpers.getPX(r.css("margin-top")), r.hasClass("fr-above") && (n += r.outerHeight())), r.find(".fr-layer").removeClass("fr-active"), r.find(".fr-".concat(e, "-layer")).addClass("fr-active"), E.popups.show("video.insert", t, n, 0), E.accessibility.focusPopup(r)
      }, refreshByURLButton: function ae(e) {
        var t = E.popups.get("video.insert");
        t && t.find(".fr-video-by-url-layer").hasClass("fr-active") && e.addClass("fr-active").attr("aria-pressed", !0)
      }, refreshEmbedButton: function oe(e) {
        var t = E.popups.get("video.insert");
        t && t.find(".fr-video-embed-layer").hasClass("fr-active") && e.addClass("fr-active").attr("aria-pressed", !0)
      }, refreshUploadButton: function ie(e) {
        var t = E.popups.get("video.insert");
        t && t.find(".fr-video-upload-layer").hasClass("fr-active") && e.addClass("fr-active").attr("aria-pressed", !0)
      }, upload: K, insertByURL: function se(e) {
        var t = !!document.getElementById("videoPluginAutoplay") && document.getElementById("videoPluginAutoplay").checked;
        void 0 === e && (e = (E.popups.get("video.insert").find('.fr-video-by-url-layer input[type="text"]').val() || "").trim());
        var n = null;
        if (/^http/.test(e) || (e = "https://".concat(e)), E.helpers.isURL(e)) for (var r = 0; r < xt.VIDEO_PROVIDERS.length; r++) {
          var a = xt.VIDEO_PROVIDERS[r], o = "autoplay=1";
          if (a.html.includes("autoplay=1") && document.getElementById("videoPluginAutoplay").checked) a.html = a.html, document.getElementById("videoPluginAutoplay").checked = !1; else if (t) {
            var i = a.html.indexOf("{url}") + 5;
            a.html = [a.html.slice(0, i), o, a.html.slice(i)].join(""), t = !1, document.getElementById("videoPluginAutoplay").checked = !1
          } else (a = xt.VIDEO_PROVIDERS[r]).html = a.html.replace(o, "");
          if (a.test_regex.test(e) && new RegExp(E.opts.videoAllowedProviders.join("|")).test(a.provider)) {
            n = e.replace(a.url_regex, a.url_text), n = a.html.replace(/\{url\}/, n);
            break
          }
        }
        n ? l(n) : (b(E.language.translate("Something went wrong. Please try again.")), E.events.trigger("video.linkError", [e]))
      }, insertEmbed: function le(e) {
        void 0 === e && (e = E.popups.get("video.insert").find(".fr-video-embed-layer textarea").val() || ""), 0 !== e.length && xt.VIDEO_EMBED_REGEX.test(e) ? l(e) : (b(E.language.translate("Something went wrong. Please try again.")), E.events.trigger("video.codeError", [e]))
      }, insert: l, align: function ce(e) {
        y.removeClass("fr-fvr fr-fvl"), !E.opts.htmlUntouched && E.opts.useClasses ? "left" == e ? y.addClass("fr-fvl") : "right" == e && y.addClass("fr-fvr") : X(y, j(), e), ee(), $(), o(), E.selection.clear()
      }, refreshAlign: function de(e) {
        if (!y) return !1;
        e.find(">*").first().replaceWith(E.icon.create("video-align-".concat(Y())))
      }, refreshAlignOnShow: function fe(e, t) {
        y && t.find('.fr-command[data-param1="'.concat(Y(), '"]')).addClass("fr-active").attr("aria-selected", !0)
      }, display: function pe(e) {
        y.removeClass("fr-dvi fr-dvb"), !E.opts.htmlUntouched && E.opts.useClasses ? "inline" == e ? y.addClass("fr-dvi") : "block" == e && y.addClass("fr-dvb") : X(y, e, Y()), ee(), $(), o(), E.selection.clear()
      }, refreshDisplayOnShow: function ue(e, t) {
        y && t.find('.fr-command[data-param1="'.concat(j(), '"]')).addClass("fr-active").attr("aria-selected", !0)
      }, remove: q, hideProgressBar: c, showSizePopup: function he() {
        var e = E.popups.get("video.size");
        e || (e = G()), c(), E.popups.refresh("video.size"), E.popups.setContainer("video.size", E.$sc);
        var t = y.find("iframe, embed, ".concat(y.find("iframe, embed, audio").get(0) ? "audio" : "video")),
          n = t.offset().left + t.outerWidth() / 2, r = t.offset().top + t.height();
        E.popups.show("video.size", n, r, t.height(), !0)
      }, replace: function ge() {
        var e = E.popups.get("video.insert");
        e || (e = i()), E.popups.isVisible("video.insert") || (c(), E.popups.refresh("video.insert"), E.popups.setContainer("video.insert", E.$sc));
        var t = y.offset().left + y.outerWidth() / 2, n = y.offset().top + y.height();
        E.popups.show("video.insert", t, n, y.outerHeight(), !0)
      }, back: function e() {
        y ? (E.events.disableBlur(), y[0].click()) : (E.events.disableBlur(), E.selection.restore(), E.events.enableBlur(), E.popups.hide("video.insert"), E.toolbar.showInline())
      }, setSize: function me(e, t) {
        if (y) {
          var n = E.popups.get("video.size"),
            r = y.find("iframe, embed, ".concat(y.find("iframe, embed, audio").get(0) ? "audio" : "video"));
          r.css("width", e || n.find('input[name="width"]').val()), r.css("height", t || n.find('input[name="height"]').val()), r.get(0).style.width && r.removeAttr("width"), r.get(0).style.height && r.removeAttr("height"), n.find("input:focus").blur(), setTimeout(function () {
            y.trigger("click")
          }, E.helpers.isAndroid() ? 50 : 0)
        }
      }, get: function ve() {
        return y
      }, showProgressBar: S, _editVideo: C, setAutoplay: function be() {
        var e;
        if (y.find("iframe, embed, audio").get(0)) (e = y.find("iframe, embed, audio")).get(0).src.includes("autoplay=1") ? (J("#FFFFFF"), e.get(0).src = e.get(0).src.replace("&autoplay=1", "")) : (J("#D6D6D6"), e.get(0).src = e.get(0).src + "&autoplay=1"); else if ((e = y.find("iframe, embed, video")).get(0).outerHTML.includes("autoplay")) J("#FFFFFF"), e.get(0).outerHTML = e.get(0).outerHTML.replace("autoplay", ""); else {
          J("#D6D6D6");
          var t = e.get(0).outerHTML.indexOf("class") - 1;
          e.get(0).outerHTML = [e.get(0).outerHTML.slice(0, t), "autoplay", e.get(0).outerHTML.slice(t)].join("")
        }
      }
    }
  },xt.RegisterCommand("insertVideo", {
    title: "Insert Video",
    undo: !1,
    focus: !0,
    refreshAfterCallback: !1,
    popup: !0,
    callback: function () {
      this.popups.isVisible("video.insert") ? (this.$el.find(".fr-marker").length && (this.events.disableBlur(), this.selection.restore()), this.popups.hide("video.insert")) : this.video.showInsertPopup()
    },
    plugin: "video"
  }),xt.DefineIcon("insertVideo", {
    NAME: "video-camera",
    FA5NAME: "camera",
    SVG_KEY: "insertVideo"
  }),xt.DefineIcon("videoByURL", {
    NAME: "link",
    SVG_KEY: "insertLink"
  }),xt.RegisterCommand("videoByURL", {
    title: "By URL", undo: !1, focus: !1, toggle: !0, callback: function () {
      this.video.showLayer("video-by-url")
    }, refresh: function (e) {
      this.video.refreshByURLButton(e)
    }
  }),xt.DefineIcon("videoEmbed", {
    NAME: "code",
    SVG_KEY: "codeView"
  }),xt.RegisterCommand("videoEmbed", {
    title: "Embedded Code", undo: !1, focus: !1, toggle: !0, callback: function () {
      this.video.showLayer("video-embed")
    }, refresh: function (e) {
      this.video.refreshEmbedButton(e)
    }
  }),xt.DefineIcon("videoUpload", {
    NAME: "upload",
    SVG_KEY: "upload"
  }),xt.RegisterCommand("videoUpload", {
    title: "Upload Video", undo: !1, focus: !1, toggle: !0, callback: function () {
      this.video.showLayer("video-upload")
    }, refresh: function (e) {
      this.video.refreshUploadButton(e)
    }
  }),xt.RegisterCommand("videoInsertByURL", {
    undo: !0, focus: !0, callback: function () {
      this.video.insertByURL()
    }
  }),xt.RegisterCommand("videoInsertEmbed", {
    undo: !0, focus: !0, callback: function () {
      this.video.insertEmbed()
    }
  }),xt.DefineIcon("videoDisplay", {
    NAME: "star",
    SVG_KEY: "star"
  }),xt.RegisterCommand("videoDisplay", {
    title: "Display",
    type: "dropdown",
    options: {inline: "Inline", block: "Break Text"},
    callback: function (e, t) {
      this.video.display(t)
    },
    refresh: function (e) {
      this.opts.videoTextNear || e.addClass("fr-hidden")
    },
    refreshOnShow: function (e, t) {
      this.video.refreshDisplayOnShow(e, t)
    }
  }),xt.DefineIcon("video-align", {
    NAME: "align-left",
    SVG_KEY: "align Left"
  }),xt.DefineIcon("video-align-left", {
    NAME: "align-left",
    SVG_KEY: "alignLeft"
  }),xt.DefineIcon("video-align-right", {
    NAME: "align-right",
    SVG_KEY: "alignRight"
  }),xt.DefineIcon("video-align-center", {
    NAME: "align-justify",
    SVG_KEY: "alignJustify"
  }),xt.DefineIcon("videoAlign", {
    NAME: "align-center",
    SVG_KEY: "alignCenter"
  }),xt.RegisterCommand("videoAlign", {
    type: "dropdown",
    title: "Align",
    options: {left: "Align Left", center: "None", right: "Align Right"},
    html: function () {
      var e = '<ul class="fr-dropdown-list" role="presentation">', t = xt.COMMANDS.videoAlign.options;
      for (var n in t) t.hasOwnProperty(n) && (e += '<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="videoAlign" data-param1="'.concat(n, '" title="').concat(this.language.translate(t[n]), '">').concat(this.icon.create("video-align-".concat(n)), '<span class="fr-sr-only">').concat(this.language.translate(t[n]), "</span></a></li>"));
      return e += "</ul>"
    },
    callback: function (e, t) {
      this.video.align(t)
    },
    refresh: function (e) {
      this.video.refreshAlign(e)
    },
    refreshOnShow: function (e, t) {
      this.video.refreshAlignOnShow(e, t)
    }
  }),xt.DefineIcon("videoReplace", {
    NAME: "exchange",
    FA5NAME: "exchange-alt",
    SVG_KEY: "replaceImage"
  }),xt.RegisterCommand("videoReplace", {
    title: "Replace",
    undo: !1,
    focus: !1,
    popup: !0,
    refreshAfterCallback: !1,
    callback: function () {
      this.video.replace()
    }
  }),xt.DefineIcon("videoRemove", {
    NAME: "trash",
    SVG_KEY: "remove"
  }),xt.RegisterCommand("videoRemove", {
    title: "Remove", callback: function () {
      this.video.remove()
    }
  }),xt.DefineIcon("autoplay", {NAME: "autoplay", SVG_KEY: "autoplay"}),xt.RegisterCommand("autoplay", {
    undo: !1,
    focus: !1,
    popup: !0,
    title: "Autoplay",
    callback: function () {
      this.video.setAutoplay()
    }
  }),xt.DefineIcon("videoSize", {NAME: "arrows-alt", SVG_KEY: "imageSize"}),xt.RegisterCommand("videoSize", {
    undo: !1,
    focus: !1,
    popup: !0,
    title: "Change Size",
    callback: function () {
      this.video.showSizePopup()
    }
  }),xt.DefineIcon("videoBack", {NAME: "arrow-left", SVG_KEY: "back"}),xt.RegisterCommand("videoBack", {
    title: "Back",
    undo: !1,
    focus: !1,
    back: !0,
    callback: function () {
      this.video.back()
    },
    refresh: function (e) {
      this.video.get() || this.opts.toolbarInline ? (e.removeClass("fr-hidden"), e.next(".fr-separator").removeClass("fr-hidden")) : (e.addClass("fr-hidden"), e.next(".fr-separator").addClass("fr-hidden"))
    }
  }),xt.RegisterCommand("videoDismissError", {
    title: "OK", undo: !1, callback: function () {
      this.video.hideProgressBar(!0)
    }
  }),xt.RegisterCommand("videoSetSize", {
    undo: !0,
    focus: !1,
    title: "Update",
    refreshAfterCallback: !1,
    callback: function () {
      this.video.setSize()
    }
  }),Object.assign(xt.DEFAULTS, {
    wordDeniedTags: [],
    wordDeniedAttrs: [],
    wordAllowedStyleProps: ["font-family", "font-size", "background", "color", "width", "text-align", "vertical-align", "background-color", "padding", "margin", "height", "margin-top", "margin-left", "margin-right", "margin-bottom", "text-decoration", "font-weight", "font-style", "text-indent", "border", "border-.*", "line-height", "list-style-type"],
    wordPasteModal: !0,
    wordPasteKeepFormatting: !0
  }),xt.PLUGINS.wordPaste = function (L) {
    var i, a, c = L.$, s = "word_paste", p = {};

    function t(e) {
      var t = L.opts.wordAllowedStyleProps;
      e || (L.opts.wordAllowedStyleProps = []), 0 === a.indexOf("<colgroup>") && (a = "<table>" + a + "</table>"), a = o(a = a.replace(/<span[\n\r ]*style='mso-spacerun:yes'>([\r\n\u00a0 ]*)<\/span>/g, function (e, t) {
        for (var n = "", r = 0; r++ < t.length;) n += "&nbsp;";
        return n
      }), L.paste.getRtfClipboard());
      var n = L.doc.createElement("DIV");
      n.innerHTML = a, L.html.cleanBlankSpaces(n), a = n.innerHTML, a = (a = L.paste.cleanEmptyTagsAndDivs(a)).replace(/\u200b/g, ""), function r() {
        L.modals.hide(s)
      }(), L.paste.clean(a, !0, !0), L.opts.wordAllowedStyleProps = t
    }

    function _(e) {
      e.parentNode && e.parentNode.removeChild(e)
    }

    function u(e, t) {
      if (t(e)) for (var n = e.firstChild; n;) {
        var r = n, a = n.previousSibling;
        n = n.nextSibling, u(r, t), r.previousSibling || r.nextSibling || r.parentNode || !n || a === n.previousSibling || !n.parentNode ? r.previousSibling || r.nextSibling || r.parentNode || !n || n.previousSibling || n.nextSibling || n.parentNode || (a ? n = a.nextSibling ? a.nextSibling.nextSibling : null : e.firstChild && (n = e.firstChild.nextSibling)) : n = a ? a.nextSibling : e.firstChild
      }
    }

    function R(e) {
      if (!e.getAttribute("style") || !/mso-list:[\s]*l/gi.test(e.getAttribute("style").replace(/\n/gi, ""))) return !1;
      try {
        if (!e.querySelector('[style="mso-list:Ignore"]')) return !!(e.outerHTML && 0 <= e.outerHTML.indexOf("\x3c!--[if !supportLists]--\x3e"))
      } catch (t) {
        return !1
      }
      return !0
    }

    function M(e) {
      return e.getAttribute("style").replace(/\n/gi, "").replace(/.*level([0-9]+?).*/gi, "$1")
    }

    function O(e, r) {
      var t = e.cloneNode(!0);
      if (-1 !== ["H1", "H2", "H3", "H4", "H5", "H6"].indexOf(e.tagName)) {
        var n = document.createElement(e.tagName.toLowerCase());
        n.setAttribute("style", e.getAttribute("style")), n.innerHTML = t.innerHTML, t.innerHTML = n.outerHTML
      }
      u(t, function (e) {
        if (e.nodeType == Node.COMMENT_NODE && (L.browser.msie || L.browser.safari || L.browser.edge)) try {
          if ("[if !supportLists]" === e.data) {
            for (e = e.nextSibling; e && e.nodeType !== Node.COMMENT_NODE;) {
              var t = e.nextSibling;
              e.parentNode.removeChild(e), e = t
            }
            e && e.nodeType == Node.COMMENT_NODE && e.parentNode.removeChild(e)
          }
        } catch (n) {
        }
        return e.nodeType === Node.ELEMENT_NODE && ("mso-list:\nIgnore" === e.getAttribute("style") && e.setAttribute("style", "mso-list:Ignore"), "mso-list:Ignore" === e.getAttribute("style") && e.parentNode.removeChild(e), e.setAttribute("style", function a(e) {
          var n = "", r = e.getAttribute("style");
          r && ["line-height", "font-family", "font-size", "color", "background"].forEach(function (e) {
            var t = r.match(new RegExp(e + ":.*(;|)"));
            t && (n += t[0] + ";")
          });
          return n
        }(e)), m(e, r)), !0
      });
      var a = t.innerHTML;
      return a = a.replace(/<!--[\s\S]*?-->/gi, "")
    }

    function w(e) {
      var t = e.getAttribute("align");
      t && (e.style["text-align"] = t, e.removeAttribute("align"))
    }

    function A(e) {
      return e.replace(/\n|\r|\n\r|&quot;/g, "")
    }

    function T(e, t, n) {
      if (t) {
        var r = e.getAttribute("style");
        r && ";" !== r.slice(-1) && (r += ";"), t && ";" !== t.slice(-1) && (t += ";"), t = t.replace(/\n/gi, "");
        var a = null;
        a = n ? (r || "") + t : t + (r || ""), e.setAttribute("style", a)
      }
    }

    var h = null;

    function d(e, t, n) {
      for (var r = e.split(n), a = 1; a < r.length; a++) {
        var o = r[a];
        if (1 < (o = o.split("shplid")).length) {
          o = o[1];
          for (var i = "", s = 0; s < o.length && "\\" !== o[s] && "{" !== o[s] && " " !== o[s] && "\r" !== o[s] && "\n" !== o[s];) i += o[s], s++;
          var l = o.split("bliptag");
          if (l && l.length < 2) continue;
          var c = null;
          if (-1 !== l[0].indexOf("pngblip") ? c = "image/png" : -1 !== l[0].indexOf("jpegblip") && (c = "image/jpeg"), !c) continue;
          var d = l[1].split("}");
          if (d && d.length < 2) continue;
          var f = void 0;
          if (2 < d.length && -1 !== d[0].indexOf("blipuid")) f = d[1].split(" "); else {
            if ((f = d[0].split(" ")) && f.length < 2) continue;
            f.shift()
          }
          var p = f.join("");
          h[t + i] = {image_hex: p, image_type: c}
        }
      }
    }

    function g(e, t) {
      if (t) {
        var n;
        if ("IMG" === e.tagName) {
          var r = e.getAttribute("src");
          if (!r || -1 === r.indexOf("file://")) return;
          if (0 === r.indexOf("file://") && L.helpers.isURL(e.getAttribute("alt"))) return void e.setAttribute("src", e.getAttribute("alt"));
          (n = p[e.getAttribute("v:shapes")]) || (n = e.getAttribute("v:shapes"), e.parentNode && e.parentNode.parentNode && 0 <= e.parentNode.parentNode.innerHTML.indexOf("msEquation") && (n = null))
        } else n = e.parentNode.getAttribute("o:spid");
        if (e.removeAttribute("height"), n) {
          !function s(e) {
            h = {}, d(e, "i", "\\shppict"), d(e, "s", "\\shp{")
          }(t);
          var a = h[n.substring(7)];
          if (a) {
            var o = function l(e) {
              for (var t = e.match(/[0-9a-f]{2}/gi), n = [], r = 0; r < t.length; r++) n.push(String.fromCharCode(parseInt(t[r], 16)));
              var a = n.join("");
              return btoa(a)
            }(a.image_hex), i = "data:" + a.image_type + ";base64," + o;
            "IMG" === e.tagName ? (e.src = i, e.setAttribute("data-fr-image-pasted", !0)) : c(e.parentNode).before('<img data-fr-image-pasted="true" src="' + i + '" style="' + e.parentNode.getAttribute("style") + '">').remove()
          }
        }
      }
    }

    function m(e, t) {
      var n = e.tagName, r = n.toLowerCase();
      if (-1 !== ["SCRIPT", "APPLET", "EMBED", "NOFRAMES", "NOSCRIPT"].indexOf(n)) return _(e), !1;
      for (var a = ["META", "LINK", "XML", "ST1:", "O:", "W:", "FONT"], o = 0; o < a.length; o++) if (-1 !== n.indexOf(a[o])) return e.innerHTML && (e.outerHTML = e.innerHTML), _(e), !1;
      for (var i = ["I", "U"], s = 0; s < i.length; s++) if (n === i[s]) return e.innerHTML && (e.outerHTML = e.innerHTML), _(e), !1;
      if ("TD" !== n) {
        var l = e.getAttribute("class") || "MsoNormal";
        if (t && l) {
          for (var c = (l = A(l)).split(" "), d = 0; d < c.length; d++) {
            var f = [], p = "." + c[d];
            f.push(p), p = r + p, f.push(p);
            for (var u = 0; u < f.length; u++) t[f[u]] && T(e, t[f[u]])
          }
          e.removeAttribute("class")
        }
        t && t[r] && T(e, t[r])
      }
      if (-1 !== ["P", "H1", "H2", "H3", "H4", "H5", "H6", "PRE"].indexOf(n)) {
        var h = e.getAttribute("class");
        if (h && (t && t[n.toLowerCase() + "." + h] && T(e, t[n.toLowerCase() + "." + h]), -1 !== h.toLowerCase().indexOf("mso"))) {
          var g = A(h);
          (g = g.replace(/[0-9a-z-_]*mso[0-9a-z-_]*/gi, "")) ? e.setAttribute("class", g) : e.removeAttribute("class")
        }
        var m = e.getAttribute("style");
        if (m) {
          var v = m.match(/text-align:.+?[; "]{1,1}/gi);
          v && v[v.length - 1].replace(/(text-align:.+?[; "]{1,1})/gi, "$1")
        }
        w(e)
      }
      if ("TR" === n && function y(e, t) {
        L.node.clearAttributes(e);
        for (var n = e.firstElementChild, r = 0, a = !1, o = null; n;) {
          n.firstElementChild && -1 !== n.firstElementChild.tagName.indexOf("W:") && (n.innerHTML = n.firstElementChild.innerHTML), (o = n.getAttribute("width")) || a || (a = !0), r += parseInt(o, 10), (!n.firstChild || n.firstChild && n.firstChild.data === xt.UNICODE_NBSP) && (n.firstChild && _(n.firstChild), n.innerHTML = "<br>");
          for (var i = n.firstElementChild, s = 1 === n.children.length; i;) "P" !== i.tagName || R(i) || s && w(i), i = i.nextElementSibling;
          if (t) {
            var l = n.getAttribute("class");
            if (l) {
              var c = (l = A(l)).match(/xl[0-9]+/gi);
              if (c) {
                var d = "." + c[0];
                t[d] && T(n, t[d])
              }
            }
            t.td && T(n, t.td)
          }
          var f = n.getAttribute("style");
          f && (f = A(f)) && ";" !== f.slice(-1) && (f += ";");
          var p = n.getAttribute("valign");
          if (!p && f) {
            var u = f.match(/vertical-align:.+?[; "]{1,1}/gi);
            u && (p = u[u.length - 1].replace(/vertical-align:(.+?)[; "]{1,1}/gi, "$1"))
          }
          var h = null;
          if (f) {
            var g = f.match(/text-align:.+?[; "]{1,1}/gi);
            g && (h = g[g.length - 1].replace(/text-align:(.+?)[; "]{1,1}/gi, "$1")), "general" === h && (h = null)
          }
          var m = null;
          if (f) {
            var v = f.match(/background:.+?[; "]{1,1}/gi);
            v && (m = v[v.length - 1].replace(/background:(.+?)[; "]{1,1}/gi, "$1"))
          }
          var b = n.getAttribute("colspan"), C = n.getAttribute("rowspan");
          b && n.setAttribute("colspan", b), C && n.setAttribute("rowspan", C), p && (n.style["vertical-align"] = p), h && (n.style["text-align"] = h), m && (n.style["background-color"] = m), o && n.setAttribute("width", o), n = n.nextElementSibling
        }
        for (n = e.firstElementChild; n;) o = n.getAttribute("width"), a ? n.removeAttribute("width") : n.setAttribute("width", 100 * parseInt(o, 10) / r + "%"), n = n.nextElementSibling
      }(e, t), "A" !== n || e.attributes.getNamedItem("href") || e.attributes.getNamedItem("name") || !e.innerHTML || (e.outerHTML = e.innerHTML), "A" == n && e.getAttribute("href") && e.querySelector("img")) for (var b = e.querySelectorAll("span"), C = 0; C < b.length; C++) b[C].innerText || (b[C].outerHTML = b[C].innerHTML);
      if ("TD" !== n && "TH" !== n || e.innerHTML || (e.innerHTML = "<br>"), "TABLE" === n && (e.style.width = e.style.width), e.getAttribute("lang") && e.removeAttribute("lang"), e.getAttribute("style") && -1 !== e.getAttribute("style").toLowerCase().indexOf("mso")) {
        var E = A(e.getAttribute("style"));
        (E = E.replace(/[0-9a-z-_]*mso[0-9a-z-_]*:.+?(;{1,1}|$)/gi, "")) ? e.setAttribute("style", E) : e.removeAttribute("style")
      }
      return !0
    }

    function o(e, t) {
      0 <= e.indexOf("<html") && (e = e.replace(/[.\s\S\w\W<>]*(<html[^>]*>[.\s\S\w\W<>]*<\/html>)[.\s\S\w\W<>]*/i, "$1")), function d(e) {
        for (var t = e.split("v:shape"), n = 1; n < t.length; n++) {
          var r = t[n], a = r.split(' id="')[1];
          if (a && 1 < a.length) {
            a = a.split('"')[0];
            var o = r.split(' o:spid="')[1];
            o && 1 < o.length && (o = o.split('"')[0], p[a] = o)
          }
        }
      }(e);
      var n = (new DOMParser).parseFromString(e, "text/html"), r = n.head, a = n.body, l = function f(e) {
        var t = {}, n = e.getElementsByTagName("style");
        if (n.length) {
          var r = n[0].innerHTML.match(/[\S ]+\s+{[\s\S]+?}/gi);
          if (r) for (var a = 0; a < r.length; a++) {
            var o = r[a], i = o.replace(/([\S ]+\s+){[\s\S]+?}/gi, "$1"),
              s = o.replace(/[\S ]+\s+{([\s\S]+?)}/gi, "$1");
            i = i.replace(/^[\s]|[\s]$/gm, ""), s = s.replace(/^[\s]|[\s]$/gm, ""), i = i.replace(/\n|\r|\n\r/g, ""), s = s.replace(/\n|\r|\n\r/g, "");
            for (var l = i.split(", "), c = 0; c < l.length; c++) t[l[c]] = s
          }
        }
        return t
      }(r);
      u(a, function (e) {
        if (e.nodeType === Node.TEXT_NODE && /\n|\u00a0|\r/.test(e.data)) {
          if (!/\S| /.test(e.data) && !/[\u00a0]+/.test(e.data)) return e.data === xt.UNICODE_NBSP ? (e.data = "\u200b", !0) : 1 === e.data.length && 10 === e.data.charCodeAt(0) ? (e.data = " ", !0) : (_(e), !1);
          e.data = e.data.replace(/\n|\r/gi, " ")
        }
        return !0
      }), u(a, function (e) {
        return e.nodeType !== Node.ELEMENT_NODE || "V:IMAGEDATA" !== e.tagName && "IMG" !== e.tagName || g(e, t), !0
      });
      for (var o = a.querySelectorAll("ul > ul, ul > ol, ol > ul, ol > ol"), i = o.length - 1; 0 <= i; i--) o[i].previousElementSibling && "LI" === o[i].previousElementSibling.tagName && o[i].previousElementSibling.appendChild(o[i]);
      u(a, function (e) {
        if (e.nodeType === Node.TEXT_NODE) return e.data = e.data.replace(/<br>(\n|\r)/gi, "<br>"), !1;
        if (e.nodeType === Node.ELEMENT_NODE) {
          if (R(e)) {
            var t = e.parentNode, n = e.previousSibling, r = function x(e, t, n, r) {
              var a, o, i = /[0-9a-zA-Z]./gi, s = !1, l = navigator.userAgent.toLowerCase();
              -1 != l.indexOf("safari") && (l = -1 < l.indexOf("chrome") ? 1 : "safari"), e.innerHTML.includes("mso-list:\nIgnore") && (e.innerHTML = e.innerHTML.replace(/mso-list:\nIgnore/gi, "mso-list:Ignore"));
              var c, d, f, p, u = e.querySelector('span[style="mso-list:Ignore"]');
              null == u && "safari" == l && (u = e.querySelector('span[lang="PT-BR"]'));
              var h;
              u && (s = s || i.test(u.textContent)), null !== u && (h = u.textContent.trim().split(".")[0]), f = 1 == s ? ("1" == (h = u.textContent.trim().split(".")[0]) ? p = "decimal;" : "i" == h ? p = "lower-roman;" : "I" == h ? p = "upper-roman;" : "o" == h ? p = "circle;" : h.match(/^v$/) || (h.match(/^[a-z]$/) || h.match(/^[a-z]\)$/) ? p = "lower-alpha;" : (h.match(/^[A-Z]$/) || h.match(/^[A-Z]\)$/)) && (p = "upper-alpha;")), p = "list-style-type: " + p, "ol") : (null != u && (h = u.textContent.trim().split(".")[0]), "\xa7" == h ? p = "square;" : "\xb7" == h && (p = "disc;"), p = "list-style-type: " + p, "ul");
              var g, m = "";
              u == undefined || u.textContent == undefined || isNaN(parseInt(u.textContent.trim().split(".")[1], 10)) || (m = ' class="decimal_type" ');
              var v, b = M(e), C = e.style.marginLeft;
              if (C.includes("in") ? (v = "in", C = parseFloat(C) - .5) : C.includes("pt") && (v = "px", C = parseFloat(C) - 10), 1 == b) if (g = p ? "<" + f + ' style = "' + p + "; margin-left:" + C + v + ';">' : "<" + f + ' style="margin-left:' + C + v + ';">', "list-style-type: upper-alpha;" == p) {
                var E = h.charCodeAt(0) - 64;
                g = p ? "<" + f + m + ' start="' + E + '" style = "' + p + " margin-left:" + C + v + ';">' : "<" + f + ">"
              } else if ("list-style-type: lower-alpha;" == p) {
                var y = h.charCodeAt(0) - 96;
                g = p ? "<" + f + m + ' start="' + y + '" style = "' + p + "margin-left:" + C + v + ';">' : "<" + f + ">"
              } else g = p ? "<" + f + m + ' style = "' + p + ";margin-left:" + C + v + ';">' : "<" + f + ' style="margin-left:' + C + v + ';">'; else if ("list-style-type: upper-alpha;" == p) {
                var L = h.charCodeAt(0) - 64;
                g = p ? "<" + f + m + ' style = "' + p + ' start="' + L + '">' : "<" + f + ">"
              } else if ("list-style-type: lower-alpha;" == p) {
                var _ = h.charCodeAt(0) - 96;
                g = p ? "<" + f + m + ' style = "' + p + ' start="' + _ + '">' : "<" + f + ">"
              } else g = p ? "<" + f + m + ' style = "' + p + '">' : "<" + f + ">";
              for (var w = !1; e;) {
                if (!R(e)) {
                  if (e.outerHTML && 0 < e.outerHTML.indexOf("mso-bookmark") && 0 == (e.textContent || "").length) {
                    e = e.nextElementSibling;
                    continue
                  }
                  break
                }
                var A = M(e);
                if ((n = n || A) < A) g += (d = x(e, t, A, e.style.marginLeft)).el.outerHTML, e = d.currentNode; else {
                  if (A < n) break;
                  e.firstElementChild && e.firstElementChild.firstElementChild && e.firstElementChild.firstElementChild.firstChild && (i.lastIndex = 0), o && o.firstElementChild && o.firstElementChild.firstElementChild && o.firstElementChild.firstElementChild.firstChild && (i.lastIndex = 0, a = i.test(o.firstElementChild.firstElementChild.firstChild.data || o.firstElementChild.firstElementChild.firstChild.firstChild && o.firstElementChild.firstElementChild.firstChild.firstChild.data || ""));
                  var T = !1;
                  (!r && !e.style.marginLeft || r && e.style.marginLeft && r === e.style.marginLeft) && (T = !0), r = e.style.marginLeft, T || a === undefined ? (c = O(e, t), e.nextSibling.innerText == undefined || e.nextSibling.innerText == undefined || g.includes('class="decimal_type"') || isNaN(parseInt(e.nextSibling.innerText.trim().split(".")[1], 10)) || (g = g.substring(3, 0) + ' class="decimal_type"' + g.substring(3, g.length)), g += "<li>" + c + "</li>") : (1 == A && (g += "</" + f + ">", w = !0, o = null), g += (d = x(e, t, A, e.style.marginLeft)).el.outerHTML, e = d.currentNode);
                  var S = e && e.nextElementSibling;
                  if (S && (o = S.previousElementSibling), e && !R(e)) {
                    if (e.outerHTML && 0 < e.outerHTML.indexOf("mso-bookmark") && 0 == (e.textContent || "").length) {
                      e = e.nextElementSibling;
                      continue
                    }
                    break
                  }
                  e && e.parentNode && e.parentNode.removeChild(e), e = S
                }
              }
              w || (g += "</" + f + ">");
              var k = document.createElement("div");
              return k.innerHTML = g, {el: k, currentNode: e}
            }(e, l).el, a = null;
            return (a = n ? n.nextSibling : t.firstChild) ? t.insertBefore(r, a) : t.appendChild(r), !1
          }
          return "FONT" === e.tagName && l["." + e.getAttribute("class")] && (e = function s(e, t) {
            for (var n = document.createElement(t), r = 0; r < e.attributes.length; r++) {
              var a = e.attributes[r].name;
              n.setAttribute(a, e.getAttribute(a))
            }
            return n.innerHTML = e.innerHTML, e.parentNode.replaceChild(n, e), n
          }(e, "span")), m(e, l)
        }
        if (e.nodeType !== Node.COMMENT_NODE) return !0;
        if (-1 < e.data.indexOf("[if !supportLineBreakNewLine]")) for (var o = e.nextSibling; o;) (o = e.nextSibling) && _(o), o.data && -1 < o.data.indexOf("[endif]") && (o = null);
        if (-1 < e.data.indexOf("[if supportFields]") && -1 < e.data.indexOf("FORMCHECKBOX")) {
          var i = document.createElement("input");
          i.type = "checkbox", e.parentNode.insertBefore(i, e.nextSibling)
        }
        return _(e), !1
      }), u(a, function (e) {
        if (e.nodeType === Node.ELEMENT_NODE) {
          var t = e.tagName;
          if (!e.innerHTML && -1 === ["BR", "IMG", "INPUT"].indexOf(t)) {
            for (var n = e.parentNode; n && (_(e), !(e = n).innerHTML) && "TD" !== e.parentNode.tagName;) n = e.parentNode;
            return !1
          }
          !function d(e) {
            var t = e.getAttribute("style");
            if (t) {
              (t = A(t)) && ";" !== t.slice(-1) && (t += ";");
              var n = t.match(/(^|\S+?):.+?;{1,1}/gi);
              if (n) {
                for (var r = {}, a = 0; a < n.length; a++) {
                  var o = n[a].split(":");
                  2 === o.length && ("text-align" === o[0] && "SPAN" === e.tagName || (r[o[0]] = o[1]))
                }
                var i = "";
                for (var s in r) if (r.hasOwnProperty(s)) {
                  if ("font-size" === s && "pt;" === r[s].slice(-3)) {
                    var l = null;
                    try {
                      l = parseFloat(r[s].slice(0, -3), 10)
                    } catch (c) {
                      l = null
                    }
                    l && (l = Math.round(1.33 * l), r[s] = l + "px;")
                  }
                  i += s + ":" + r[s]
                }
                i && e.setAttribute("style", i)
              }
            }
          }(e)
        }
        return !0
      }), u(a, function (e) {
        if (e && "A" === e.nodeName && "" === e.href) {
          for (var t = document.createDocumentFragment(); e.firstChild;) t.appendChild(e.firstChild);
          e.parentNode.replaceChild(t, e)
        }
        return !0
      }), u(a, function (e) {
        return !e || "B" !== e.nodeName || (e.outerHTML = e.innerHTML, _(e), !1)
      });
      var s = a.outerHTML, c = L.opts.htmlAllowedStyleProps;
      return L.opts.htmlAllowedStyleProps = L.opts.wordAllowedStyleProps, s = L.clean.html(s, L.opts.wordDeniedTags, L.opts.wordDeniedAttrs, !1), L.opts.htmlAllowedStyleProps = c, s
    }

    return {
      _init: function e() {
        L.events.on("paste.wordPaste", function (e) {
          return a = e, L.opts.wordPasteModal ? function o() {
            if (!i) {
              var e = '<h4><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74.95 73.23" style="height: 25px; vertical-align: text-bottom; margin-right: 5px; display: inline-block"><defs><style>.a{fill:#2a5699;}.b{fill:#fff;}</style></defs><path class="a" d="M615.15,827.22h5.09V834c9.11.05,18.21-.09,27.32.05a2.93,2.93,0,0,1,3.29,3.25c.14,16.77,0,33.56.09,50.33-.09,1.72.17,3.63-.83,5.15-1.24.89-2.85.78-4.3.84-8.52,0-17,0-25.56,0v6.81h-5.32c-13-2.37-26-4.54-38.94-6.81q0-29.8,0-59.59c13.05-2.28,26.11-4.5,39.17-6.83Z" transform="translate(-575.97 -827.22)"/><path class="b" d="M620.24,836.59h28.1v54.49h-28.1v-6.81h22.14v-3.41H620.24v-4.26h22.14V873.2H620.24v-4.26h22.14v-3.41H620.24v-4.26h22.14v-3.41H620.24v-4.26h22.14v-3.41H620.24V846h22.14v-3.41H620.24Zm-26.67,15c1.62-.09,3.24-.16,4.85-.25,1.13,5.75,2.29,11.49,3.52,17.21,1-5.91,2-11.8,3.06-17.7,1.7-.06,3.41-.15,5.1-.26-1.92,8.25-3.61,16.57-5.71,24.77-1.42.74-3.55,0-5.24.09-1.13-5.64-2.45-11.24-3.47-16.9-1,5.5-2.29,10.95-3.43,16.42q-2.45-.13-4.92-.3c-1.41-7.49-3.07-14.93-4.39-22.44l4.38-.18c.88,5.42,1.87,10.82,2.64,16.25,1.2-5.57,2.43-11.14,3.62-16.71Z" transform="translate(-575.97 -827.22)"/></svg> ' + L.language.translate("Word Paste Detected") + "</h4>",
                t = function a() {
                  var e = '<div class="fr-word-paste-modal" style="padding: 20px 20px 10px 20px;">';
                  return e += '<p style="text-align: left;">' + L.language.translate("The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?") + "</p>", e += '<div style="text-align: right; margin-top: 50px;"><button class="fr-remove-word fr-command">' + L.language.translate("Clean") + '</button> <button class="fr-keep-word fr-command">' + L.language.translate("Keep") + "</button></div>", e += "</div>"
                }(), n = L.modals.create(s, e, t), r = n.$body;
              i = n.$modal, n.$modal.addClass("fr-middle"), L.events.bindClick(r, "button.fr-remove-word", function () {
                var e = i.data("instance") || L;
                e.wordPaste.clean()
              }), L.events.bindClick(r, "button.fr-keep-word", function () {
                var e = i.data("instance") || L;
                e.wordPaste.clean(!0)
              }), L.events.$on(c(L.o_win), "resize", function () {
                L.modals.resize(s)
              })
            }
            L.modals.show(s), L.modals.resize(s)
          }() : t(L.opts.wordPasteKeepFormatting), !1
        })
      }, clean: t, _wordClean: o
    }
  };
  var L = {}, n = {}, _ = {}, w = y(!0), A = "vanilla", T = {
    github: {
      omitExtraWLInCodeBlocks: !0,
      simplifiedAutoLink: !0,
      excludeTrailingPunctuationFromURLs: !0,
      literalMidWordUnderscores: !0,
      strikethrough: !0,
      tables: !0,
      tablesHeaderId: !0,
      ghCodeBlocks: !0,
      tasklists: !0,
      disableForced4SpacesIndentedSublists: !0,
      simpleLineBreaks: !0,
      requireSpaceBeforeHeadingText: !0,
      ghCompatibleHeaderId: !0,
      ghMentions: !0,
      backslashEscapesHTMLTags: !0,
      emoji: !0,
      splitAdjacentBlockquotes: !0
    },
    original: {noHeaderId: !0, ghCodeBlocks: !1},
    ghost: {
      omitExtraWLInCodeBlocks: !0,
      parseImgDimensions: !0,
      simplifiedAutoLink: !0,
      excludeTrailingPunctuationFromURLs: !0,
      literalMidWordUnderscores: !0,
      strikethrough: !0,
      tables: !0,
      tablesHeaderId: !0,
      ghCodeBlocks: !0,
      tasklists: !0,
      smoothLivePreview: !0,
      simpleLineBreaks: !0,
      requireSpaceBeforeHeadingText: !0,
      ghMentions: !1,
      encodeEmails: !0
    },
    vanilla: y(!0),
    allOn: function H() {
      var e = y(!0), t = {};
      for (var n in e) e.hasOwnProperty(n) && (t[n] = !0);
      return t
    }()
  };

  function S(e, t) {
    var n = t ? "Error in " + t + " extension->" : "Error in unnamed extension", r = {valid: !0, error: ""};
    L.helper.isArray(e) || (e = [e]);
    for (var a = 0; a < e.length; ++a) {
      var o = n + " sub-extension " + a + ": ", i = e[a];
      if ("object" !== kt(i)) return r.valid = !1, r.error = o + "must be an object, but " + kt(i) + " given", r;
      if (!L.helper.isString(i.type)) return r.valid = !1, r.error = o + 'property "type" must be a string, but ' + kt(i.type) + " given", r;
      var s = i.type = i.type.toLowerCase();
      if ("language" === s && (s = i.type = "lang"), "html" === s && (s = i.type = "output"), "lang" !== s && "output" !== s && "listener" !== s) return r.valid = !1, r.error = o + "type " + s + ' is not recognized. Valid values: "lang/language", "output/html" or "listener"', r;
      if ("listener" === s) {
        if (L.helper.isUndefined(i.listeners)) return r.valid = !1, r.error = o + '. Extensions of type "listener" must have a property called "listeners"', r
      } else if (L.helper.isUndefined(i.filter) && L.helper.isUndefined(i.regex)) return r.valid = !1, r.error = o + s + ' extensions must define either a "regex" property or a "filter" method', r;
      if (i.listeners) {
        if ("object" !== kt(i.listeners)) return r.valid = !1, r.error = o + '"listeners" property must be an object but ' + kt(i.listeners) + " given", r;
        for (var l in i.listeners) if (i.listeners.hasOwnProperty(l) && "function" != typeof i.listeners[l]) return r.valid = !1, r.error = o + '"listeners" property must be an hash of [event name]: [callback]. listeners.' + l + " must be a function but " + kt(i.listeners[l]) + " given", r
      }
      if (i.filter) {
        if ("function" != typeof i.filter) return r.valid = !1, r.error = o + '"filter" must be a function, but ' + kt(i.filter) + " given", r
      } else if (i.regex) {
        if (L.helper.isString(i.regex) && (i.regex = new RegExp(i.regex, "g")), !(i.regex instanceof RegExp)) return r.valid = !1, r.error = o + '"regex" property must either be a string or a RegExp object, but ' + kt(i.regex) + " given", r;
        if (L.helper.isUndefined(i.replace)) return r.valid = !1, r.error = o + '"regex" extensions must implement a replace string or function', r
      }
    }
    return r
  }

  function k(e, t) {
    return "\xa8E" + t.charCodeAt(0) + "E"
  }

  L.helper = {}, L.extensions = {}, L.setOption = function (e, t) {
    return w[e] = t, this
  }, L.getOption = function (e) {
    return w[e]
  }, L.getOptions = function () {
    return w
  }, L.resetOptions = function () {
    w = y(!0)
  }, L.setFlavor = function (e) {
    if (!T.hasOwnProperty(e)) throw Error(e + " flavor was not found");
    L.resetOptions();
    var t = T[e];
    for (var n in A = e, t) t.hasOwnProperty(n) && (w[n] = t[n])
  }, L.getFlavor = function () {
    return A
  }, L.getFlavorOptions = function (e) {
    if (T.hasOwnProperty(e)) return T[e]
  }, L.getDefaultOptions = function (e) {
    return y(e)
  }, L.subParser = function (e, t) {
    if (L.helper.isString(e)) {
      if (void 0 === t) {
        if (n.hasOwnProperty(e)) return n[e];
        throw Error("SubParser named " + e + " not registered!")
      }
      n[e] = t
    }
  }, L.extension = function (e, t) {
    if (!L.helper.isString(e)) throw Error("Extension 'name' must be a string");
    if (e = L.helper.stdExtName(e), L.helper.isUndefined(t)) {
      if (!_.hasOwnProperty(e)) throw Error("Extension named " + e + " is not registered!");
      return _[e]
    }
    "function" == typeof t && (t = t()), L.helper.isArray(t) || (t = [t]);
    var n = S(t, e);
    if (!n.valid) throw Error(n.error);
    _[e] = t
  }, L.getAllExtensions = function () {
    return _
  }, L.removeExtension = function (e) {
    delete _[e]
  }, L.resetExtensions = function () {
    _ = {}
  }, L.validateExtension = function (e) {
    var t = S(e, null);
    return !!t.valid
  }, L.hasOwnProperty("helper") || (L.helper = {}), L.helper.isString = function (e) {
    return "string" == typeof e || e instanceof String
  }, L.helper.isFunction = function (e) {
    return e && "[object Function]" === {}.toString.call(e)
  }, L.helper.isArray = function (e) {
    return Array.isArray(e)
  }, L.helper.isUndefined = function (e) {
    return void 0 === e
  }, L.helper.forEach = function (e, t) {
    if (L.helper.isUndefined(e)) throw new Error("obj param is required");
    if (L.helper.isUndefined(t)) throw new Error("callback param is required");
    if (!L.helper.isFunction(t)) throw new Error("callback param must be a function/closure");
    if ("function" == typeof e.forEach) e.forEach(t); else if (L.helper.isArray(e)) for (var n = 0; n < e.length; n++) t(e[n], n, e); else {
      if ("object" !== kt(e)) throw new Error("obj does not seem to be an array or an iterable object");
      for (var r in e) e.hasOwnProperty(r) && t(e[r], r, e)
    }
  }, L.helper.stdExtName = function (e) {
    return e.replace(/[_?*+\/\\.^-]/g, "").replace(/\s/g, "").toLowerCase()
  }, L.helper.escapeCharactersCallback = k, L.helper.escapeCharacters = function (e, t, n) {
    var r = "([" + t.replace(/([\[\]\\])/g, "\\$1") + "])";
    n && (r = "\\\\" + r);
    var a = new RegExp(r, "g");
    return e = e.replace(a, k)
  }, L.helper.unescapeHTMLEntities = function (e) {
    return e.replace(/&quot;/g, '"').replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&")
  };
  var x = function x(e, t, n, r) {
    var a, o, i, s, l, c = r || "", d = -1 < c.indexOf("g"), f = new RegExp(t + "|" + n, "g" + c.replace(/g/g, "")),
      p = new RegExp(t, c.replace(/g/g, "")), u = [];
    do {
      for (a = 0; i = f.exec(e);) if (p.test(i[0])) a++ || (s = (o = f.lastIndex) - i[0].length); else if (a && !--a) {
        l = i.index + i[0].length;
        var h = {
          left: {start: s, end: o},
          match: {start: o, end: i.index},
          right: {start: i.index, end: l},
          wholeMatch: {start: s, end: l}
        };
        if (u.push(h), !d) return u
      }
    } while (a && (f.lastIndex = o));
    return u
  };
  L.helper.matchRecursiveRegExp = function (e, t, n, r) {
    for (var a = x(e, t, n, r), o = [], i = 0; i < a.length; ++i) o.push([e.slice(a[i].wholeMatch.start, a[i].wholeMatch.end), e.slice(a[i].match.start, a[i].match.end), e.slice(a[i].left.start, a[i].left.end), e.slice(a[i].right.start, a[i].right.end)]);
    return o
  }, L.helper.replaceRecursiveRegExp = function (e, t, n, r, a) {
    if (!L.helper.isFunction(t)) {
      var o = t;
      t = function t() {
        return o
      }
    }
    var i = x(e, n, r, a), s = e, l = i.length;
    if (0 < l) {
      var c = [];
      0 !== i[0].wholeMatch.start && c.push(e.slice(0, i[0].wholeMatch.start));
      for (var d = 0; d < l; ++d) c.push(t(e.slice(i[d].wholeMatch.start, i[d].wholeMatch.end), e.slice(i[d].match.start, i[d].match.end), e.slice(i[d].left.start, i[d].left.end), e.slice(i[d].right.start, i[d].right.end))), d < l - 1 && c.push(e.slice(i[d].wholeMatch.end, i[d + 1].wholeMatch.start));
      i[l - 1].wholeMatch.end < e.length && c.push(e.slice(i[l - 1].wholeMatch.end)), s = c.join("")
    }
    return s
  }, L.helper.regexIndexOf = function (e, t, n) {
    if (!L.helper.isString(e)) throw"InvalidArgumentError: first parameter of showdown.helper.regexIndexOf function must be a string";
    if (t instanceof RegExp == !1) throw"InvalidArgumentError: second parameter of showdown.helper.regexIndexOf function must be an instance of RegExp";
    var r = e.substring(n || 0).search(t);
    return 0 <= r ? r + (n || 0) : r
  }, L.helper.splitAtIndex = function (e, t) {
    if (!L.helper.isString(e)) throw"InvalidArgumentError: first parameter of showdown.helper.regexIndexOf function must be a string";
    return [e.substring(0, t), e.substring(t)]
  }, L.helper.encodeEmailAddress = function (e) {
    var n = [function (e) {
      return "&#" + e.charCodeAt(0) + ";"
    }, function (e) {
      return "&#x" + e.charCodeAt(0).toString(16) + ";"
    }, function (e) {
      return e
    }];
    return e = e.replace(/./g, function (e) {
      if ("@" === e) e = n[Math.floor(2 * Math.random())](e); else {
        var t = Math.random();
        e = .9 < t ? n[2](e) : .45 < t ? n[1](e) : n[0](e)
      }
      return e
    })
  }, L.helper.padEnd = function (e, t, n) {
    return t >>= 0, n = String(n || " "), e.length > t ? String(e) : ((t -= e.length) > n.length && (n += n.repeat(t / n.length)), String(e) + n.slice(0, t))
  }, "undefined" == typeof console && (console = {
    warn: function (e) {
      alert(e)
    }, log: function (e) {
      alert(e)
    }, error: function (e) {
      throw e
    }
  }), L.helper.regexes = {asteriskDashAndColon: /([*_:~])/g}, L.helper.emojis = {
    "+1": "\ud83d\udc4d",
    "-1": "\ud83d\udc4e",
    100: "\ud83d\udcaf",
    1234: "\ud83d\udd22",
    "1st_place_medal": "\ud83e\udd47",
    "2nd_place_medal": "\ud83e\udd48",
    "3rd_place_medal": "\ud83e\udd49",
    "8ball": "\ud83c\udfb1",
    a: "\ud83c\udd70\ufe0f",
    ab: "\ud83c\udd8e",
    abc: "\ud83d\udd24",
    abcd: "\ud83d\udd21",
    accept: "\ud83c\ude51",
    aerial_tramway: "\ud83d\udea1",
    airplane: "\u2708\ufe0f",
    alarm_clock: "\u23f0",
    alembic: "\u2697\ufe0f",
    alien: "\ud83d\udc7d",
    ambulance: "\ud83d\ude91",
    amphora: "\ud83c\udffa",
    anchor: "\u2693\ufe0f",
    angel: "\ud83d\udc7c",
    anger: "\ud83d\udca2",
    angry: "\ud83d\ude20",
    anguished: "\ud83d\ude27",
    ant: "\ud83d\udc1c",
    apple: "\ud83c\udf4e",
    aquarius: "\u2652\ufe0f",
    aries: "\u2648\ufe0f",
    arrow_backward: "\u25c0\ufe0f",
    arrow_double_down: "\u23ec",
    arrow_double_up: "\u23eb",
    arrow_down: "\u2b07\ufe0f",
    arrow_down_small: "\ud83d\udd3d",
    arrow_forward: "\u25b6\ufe0f",
    arrow_heading_down: "\u2935\ufe0f",
    arrow_heading_up: "\u2934\ufe0f",
    arrow_left: "\u2b05\ufe0f",
    arrow_lower_left: "\u2199\ufe0f",
    arrow_lower_right: "\u2198\ufe0f",
    arrow_right: "\u27a1\ufe0f",
    arrow_right_hook: "\u21aa\ufe0f",
    arrow_up: "\u2b06\ufe0f",
    arrow_up_down: "\u2195\ufe0f",
    arrow_up_small: "\ud83d\udd3c",
    arrow_upper_left: "\u2196\ufe0f",
    arrow_upper_right: "\u2197\ufe0f",
    arrows_clockwise: "\ud83d\udd03",
    arrows_counterclockwise: "\ud83d\udd04",
    art: "\ud83c\udfa8",
    articulated_lorry: "\ud83d\ude9b",
    artificial_satellite: "\ud83d\udef0",
    astonished: "\ud83d\ude32",
    athletic_shoe: "\ud83d\udc5f",
    atm: "\ud83c\udfe7",
    atom_symbol: "\u269b\ufe0f",
    avocado: "\ud83e\udd51",
    b: "\ud83c\udd71\ufe0f",
    baby: "\ud83d\udc76",
    baby_bottle: "\ud83c\udf7c",
    baby_chick: "\ud83d\udc24",
    baby_symbol: "\ud83d\udebc",
    back: "\ud83d\udd19",
    bacon: "\ud83e\udd53",
    badminton: "\ud83c\udff8",
    baggage_claim: "\ud83d\udec4",
    baguette_bread: "\ud83e\udd56",
    balance_scale: "\u2696\ufe0f",
    balloon: "\ud83c\udf88",
    ballot_box: "\ud83d\uddf3",
    ballot_box_with_check: "\u2611\ufe0f",
    bamboo: "\ud83c\udf8d",
    banana: "\ud83c\udf4c",
    bangbang: "\u203c\ufe0f",
    bank: "\ud83c\udfe6",
    bar_chart: "\ud83d\udcca",
    barber: "\ud83d\udc88",
    baseball: "\u26be\ufe0f",
    basketball: "\ud83c\udfc0",
    basketball_man: "\u26f9\ufe0f",
    basketball_woman: "\u26f9\ufe0f&zwj;\u2640\ufe0f",
    bat: "\ud83e\udd87",
    bath: "\ud83d\udec0",
    bathtub: "\ud83d\udec1",
    battery: "\ud83d\udd0b",
    beach_umbrella: "\ud83c\udfd6",
    bear: "\ud83d\udc3b",
    bed: "\ud83d\udecf",
    bee: "\ud83d\udc1d",
    beer: "\ud83c\udf7a",
    beers: "\ud83c\udf7b",
    beetle: "\ud83d\udc1e",
    beginner: "\ud83d\udd30",
    bell: "\ud83d\udd14",
    bellhop_bell: "\ud83d\udece",
    bento: "\ud83c\udf71",
    biking_man: "\ud83d\udeb4",
    bike: "\ud83d\udeb2",
    biking_woman: "\ud83d\udeb4&zwj;\u2640\ufe0f",
    bikini: "\ud83d\udc59",
    biohazard: "\u2623\ufe0f",
    bird: "\ud83d\udc26",
    birthday: "\ud83c\udf82",
    black_circle: "\u26ab\ufe0f",
    black_flag: "\ud83c\udff4",
    black_heart: "\ud83d\udda4",
    black_joker: "\ud83c\udccf",
    black_large_square: "\u2b1b\ufe0f",
    black_medium_small_square: "\u25fe\ufe0f",
    black_medium_square: "\u25fc\ufe0f",
    black_nib: "\u2712\ufe0f",
    black_small_square: "\u25aa\ufe0f",
    black_square_button: "\ud83d\udd32",
    blonde_man: "\ud83d\udc71",
    blonde_woman: "\ud83d\udc71&zwj;\u2640\ufe0f",
    blossom: "\ud83c\udf3c",
    blowfish: "\ud83d\udc21",
    blue_book: "\ud83d\udcd8",
    blue_car: "\ud83d\ude99",
    blue_heart: "\ud83d\udc99",
    blush: "\ud83d\ude0a",
    boar: "\ud83d\udc17",
    boat: "\u26f5\ufe0f",
    bomb: "\ud83d\udca3",
    book: "\ud83d\udcd6",
    bookmark: "\ud83d\udd16",
    bookmark_tabs: "\ud83d\udcd1",
    books: "\ud83d\udcda",
    boom: "\ud83d\udca5",
    boot: "\ud83d\udc62",
    bouquet: "\ud83d\udc90",
    bowing_man: "\ud83d\ude47",
    bow_and_arrow: "\ud83c\udff9",
    bowing_woman: "\ud83d\ude47&zwj;\u2640\ufe0f",
    bowling: "\ud83c\udfb3",
    boxing_glove: "\ud83e\udd4a",
    boy: "\ud83d\udc66",
    bread: "\ud83c\udf5e",
    bride_with_veil: "\ud83d\udc70",
    bridge_at_night: "\ud83c\udf09",
    briefcase: "\ud83d\udcbc",
    broken_heart: "\ud83d\udc94",
    bug: "\ud83d\udc1b",
    building_construction: "\ud83c\udfd7",
    bulb: "\ud83d\udca1",
    bullettrain_front: "\ud83d\ude85",
    bullettrain_side: "\ud83d\ude84",
    burrito: "\ud83c\udf2f",
    bus: "\ud83d\ude8c",
    business_suit_levitating: "\ud83d\udd74",
    busstop: "\ud83d\ude8f",
    bust_in_silhouette: "\ud83d\udc64",
    busts_in_silhouette: "\ud83d\udc65",
    butterfly: "\ud83e\udd8b",
    cactus: "\ud83c\udf35",
    cake: "\ud83c\udf70",
    calendar: "\ud83d\udcc6",
    call_me_hand: "\ud83e\udd19",
    calling: "\ud83d\udcf2",
    camel: "\ud83d\udc2b",
    camera: "\ud83d\udcf7",
    camera_flash: "\ud83d\udcf8",
    camping: "\ud83c\udfd5",
    cancer: "\u264b\ufe0f",
    candle: "\ud83d\udd6f",
    candy: "\ud83c\udf6c",
    canoe: "\ud83d\udef6",
    capital_abcd: "\ud83d\udd20",
    capricorn: "\u2651\ufe0f",
    car: "\ud83d\ude97",
    card_file_box: "\ud83d\uddc3",
    card_index: "\ud83d\udcc7",
    card_index_dividers: "\ud83d\uddc2",
    carousel_horse: "\ud83c\udfa0",
    carrot: "\ud83e\udd55",
    cat: "\ud83d\udc31",
    cat2: "\ud83d\udc08",
    cd: "\ud83d\udcbf",
    chains: "\u26d3",
    champagne: "\ud83c\udf7e",
    chart: "\ud83d\udcb9",
    chart_with_downwards_trend: "\ud83d\udcc9",
    chart_with_upwards_trend: "\ud83d\udcc8",
    checkered_flag: "\ud83c\udfc1",
    cheese: "\ud83e\uddc0",
    cherries: "\ud83c\udf52",
    cherry_blossom: "\ud83c\udf38",
    chestnut: "\ud83c\udf30",
    chicken: "\ud83d\udc14",
    children_crossing: "\ud83d\udeb8",
    chipmunk: "\ud83d\udc3f",
    chocolate_bar: "\ud83c\udf6b",
    christmas_tree: "\ud83c\udf84",
    church: "\u26ea\ufe0f",
    cinema: "\ud83c\udfa6",
    circus_tent: "\ud83c\udfaa",
    city_sunrise: "\ud83c\udf07",
    city_sunset: "\ud83c\udf06",
    cityscape: "\ud83c\udfd9",
    cl: "\ud83c\udd91",
    clamp: "\ud83d\udddc",
    clap: "\ud83d\udc4f",
    clapper: "\ud83c\udfac",
    classical_building: "\ud83c\udfdb",
    clinking_glasses: "\ud83e\udd42",
    clipboard: "\ud83d\udccb",
    clock1: "\ud83d\udd50",
    clock10: "\ud83d\udd59",
    clock1030: "\ud83d\udd65",
    clock11: "\ud83d\udd5a",
    clock1130: "\ud83d\udd66",
    clock12: "\ud83d\udd5b",
    clock1230: "\ud83d\udd67",
    clock130: "\ud83d\udd5c",
    clock2: "\ud83d\udd51",
    clock230: "\ud83d\udd5d",
    clock3: "\ud83d\udd52",
    clock330: "\ud83d\udd5e",
    clock4: "\ud83d\udd53",
    clock430: "\ud83d\udd5f",
    clock5: "\ud83d\udd54",
    clock530: "\ud83d\udd60",
    clock6: "\ud83d\udd55",
    clock630: "\ud83d\udd61",
    clock7: "\ud83d\udd56",
    clock730: "\ud83d\udd62",
    clock8: "\ud83d\udd57",
    clock830: "\ud83d\udd63",
    clock9: "\ud83d\udd58",
    clock930: "\ud83d\udd64",
    closed_book: "\ud83d\udcd5",
    closed_lock_with_key: "\ud83d\udd10",
    closed_umbrella: "\ud83c\udf02",
    cloud: "\u2601\ufe0f",
    cloud_with_lightning: "\ud83c\udf29",
    cloud_with_lightning_and_rain: "\u26c8",
    cloud_with_rain: "\ud83c\udf27",
    cloud_with_snow: "\ud83c\udf28",
    clown_face: "\ud83e\udd21",
    clubs: "\u2663\ufe0f",
    cocktail: "\ud83c\udf78",
    coffee: "\u2615\ufe0f",
    coffin: "\u26b0\ufe0f",
    cold_sweat: "\ud83d\ude30",
    comet: "\u2604\ufe0f",
    computer: "\ud83d\udcbb",
    computer_mouse: "\ud83d\uddb1",
    confetti_ball: "\ud83c\udf8a",
    confounded: "\ud83d\ude16",
    confused: "\ud83d\ude15",
    congratulations: "\u3297\ufe0f",
    construction: "\ud83d\udea7",
    construction_worker_man: "\ud83d\udc77",
    construction_worker_woman: "\ud83d\udc77&zwj;\u2640\ufe0f",
    control_knobs: "\ud83c\udf9b",
    convenience_store: "\ud83c\udfea",
    cookie: "\ud83c\udf6a",
    cool: "\ud83c\udd92",
    policeman: "\ud83d\udc6e",
    copyright: "\xa9\ufe0f",
    corn: "\ud83c\udf3d",
    couch_and_lamp: "\ud83d\udecb",
    couple: "\ud83d\udc6b",
    couple_with_heart_woman_man: "\ud83d\udc91",
    couple_with_heart_man_man: "\ud83d\udc68&zwj;\u2764\ufe0f&zwj;\ud83d\udc68",
    couple_with_heart_woman_woman: "\ud83d\udc69&zwj;\u2764\ufe0f&zwj;\ud83d\udc69",
    couplekiss_man_man: "\ud83d\udc68&zwj;\u2764\ufe0f&zwj;\ud83d\udc8b&zwj;\ud83d\udc68",
    couplekiss_man_woman: "\ud83d\udc8f",
    couplekiss_woman_woman: "\ud83d\udc69&zwj;\u2764\ufe0f&zwj;\ud83d\udc8b&zwj;\ud83d\udc69",
    cow: "\ud83d\udc2e",
    cow2: "\ud83d\udc04",
    cowboy_hat_face: "\ud83e\udd20",
    crab: "\ud83e\udd80",
    crayon: "\ud83d\udd8d",
    credit_card: "\ud83d\udcb3",
    crescent_moon: "\ud83c\udf19",
    cricket: "\ud83c\udfcf",
    crocodile: "\ud83d\udc0a",
    croissant: "\ud83e\udd50",
    crossed_fingers: "\ud83e\udd1e",
    crossed_flags: "\ud83c\udf8c",
    crossed_swords: "\u2694\ufe0f",
    crown: "\ud83d\udc51",
    cry: "\ud83d\ude22",
    crying_cat_face: "\ud83d\ude3f",
    crystal_ball: "\ud83d\udd2e",
    cucumber: "\ud83e\udd52",
    cupid: "\ud83d\udc98",
    curly_loop: "\u27b0",
    currency_exchange: "\ud83d\udcb1",
    curry: "\ud83c\udf5b",
    custard: "\ud83c\udf6e",
    customs: "\ud83d\udec3",
    cyclone: "\ud83c\udf00",
    dagger: "\ud83d\udde1",
    dancer: "\ud83d\udc83",
    dancing_women: "\ud83d\udc6f",
    dancing_men: "\ud83d\udc6f&zwj;\u2642\ufe0f",
    dango: "\ud83c\udf61",
    dark_sunglasses: "\ud83d\udd76",
    dart: "\ud83c\udfaf",
    dash: "\ud83d\udca8",
    date: "\ud83d\udcc5",
    deciduous_tree: "\ud83c\udf33",
    deer: "\ud83e\udd8c",
    department_store: "\ud83c\udfec",
    derelict_house: "\ud83c\udfda",
    desert: "\ud83c\udfdc",
    desert_island: "\ud83c\udfdd",
    desktop_computer: "\ud83d\udda5",
    male_detective: "\ud83d\udd75\ufe0f",
    diamond_shape_with_a_dot_inside: "\ud83d\udca0",
    diamonds: "\u2666\ufe0f",
    disappointed: "\ud83d\ude1e",
    disappointed_relieved: "\ud83d\ude25",
    dizzy: "\ud83d\udcab",
    dizzy_face: "\ud83d\ude35",
    do_not_litter: "\ud83d\udeaf",
    dog: "\ud83d\udc36",
    dog2: "\ud83d\udc15",
    dollar: "\ud83d\udcb5",
    dolls: "\ud83c\udf8e",
    dolphin: "\ud83d\udc2c",
    door: "\ud83d\udeaa",
    doughnut: "\ud83c\udf69",
    dove: "\ud83d\udd4a",
    dragon: "\ud83d\udc09",
    dragon_face: "\ud83d\udc32",
    dress: "\ud83d\udc57",
    dromedary_camel: "\ud83d\udc2a",
    drooling_face: "\ud83e\udd24",
    droplet: "\ud83d\udca7",
    drum: "\ud83e\udd41",
    duck: "\ud83e\udd86",
    dvd: "\ud83d\udcc0",
    "e-mail": "\ud83d\udce7",
    eagle: "\ud83e\udd85",
    ear: "\ud83d\udc42",
    ear_of_rice: "\ud83c\udf3e",
    earth_africa: "\ud83c\udf0d",
    earth_americas: "\ud83c\udf0e",
    earth_asia: "\ud83c\udf0f",
    egg: "\ud83e\udd5a",
    eggplant: "\ud83c\udf46",
    eight_pointed_black_star: "\u2734\ufe0f",
    eight_spoked_asterisk: "\u2733\ufe0f",
    electric_plug: "\ud83d\udd0c",
    elephant: "\ud83d\udc18",
    email: "\u2709\ufe0f",
    end: "\ud83d\udd1a",
    envelope_with_arrow: "\ud83d\udce9",
    euro: "\ud83d\udcb6",
    european_castle: "\ud83c\udff0",
    european_post_office: "\ud83c\udfe4",
    evergreen_tree: "\ud83c\udf32",
    exclamation: "\u2757\ufe0f",
    expressionless: "\ud83d\ude11",
    eye: "\ud83d\udc41",
    eye_speech_bubble: "\ud83d\udc41&zwj;\ud83d\udde8",
    eyeglasses: "\ud83d\udc53",
    eyes: "\ud83d\udc40",
    face_with_head_bandage: "\ud83e\udd15",
    face_with_thermometer: "\ud83e\udd12",
    fist_oncoming: "\ud83d\udc4a",
    factory: "\ud83c\udfed",
    fallen_leaf: "\ud83c\udf42",
    family_man_woman_boy: "\ud83d\udc6a",
    family_man_boy: "\ud83d\udc68&zwj;\ud83d\udc66",
    family_man_boy_boy: "\ud83d\udc68&zwj;\ud83d\udc66&zwj;\ud83d\udc66",
    family_man_girl: "\ud83d\udc68&zwj;\ud83d\udc67",
    family_man_girl_boy: "\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc66",
    family_man_girl_girl: "\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc67",
    family_man_man_boy: "\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc66",
    family_man_man_boy_boy: "\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc66&zwj;\ud83d\udc66",
    family_man_man_girl: "\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67",
    family_man_man_girl_boy: "\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc66",
    family_man_man_girl_girl: "\ud83d\udc68&zwj;\ud83d\udc68&zwj;\ud83d\udc67&zwj;\ud83d\udc67",
    family_man_woman_boy_boy: "\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66",
    family_man_woman_girl: "\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67",
    family_man_woman_girl_boy: "\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66",
    family_man_woman_girl_girl: "\ud83d\udc68&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67",
    family_woman_boy: "\ud83d\udc69&zwj;\ud83d\udc66",
    family_woman_boy_boy: "\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66",
    family_woman_girl: "\ud83d\udc69&zwj;\ud83d\udc67",
    family_woman_girl_boy: "\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66",
    family_woman_girl_girl: "\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67",
    family_woman_woman_boy: "\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc66",
    family_woman_woman_boy_boy: "\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc66&zwj;\ud83d\udc66",
    family_woman_woman_girl: "\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67",
    family_woman_woman_girl_boy: "\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc66",
    family_woman_woman_girl_girl: "\ud83d\udc69&zwj;\ud83d\udc69&zwj;\ud83d\udc67&zwj;\ud83d\udc67",
    fast_forward: "\u23e9",
    fax: "\ud83d\udce0",
    fearful: "\ud83d\ude28",
    feet: "\ud83d\udc3e",
    female_detective: "\ud83d\udd75\ufe0f&zwj;\u2640\ufe0f",
    ferris_wheel: "\ud83c\udfa1",
    ferry: "\u26f4",
    field_hockey: "\ud83c\udfd1",
    file_cabinet: "\ud83d\uddc4",
    file_folder: "\ud83d\udcc1",
    film_projector: "\ud83d\udcfd",
    film_strip: "\ud83c\udf9e",
    fire: "\ud83d\udd25",
    fire_engine: "\ud83d\ude92",
    fireworks: "\ud83c\udf86",
    first_quarter_moon: "\ud83c\udf13",
    first_quarter_moon_with_face: "\ud83c\udf1b",
    fish: "\ud83d\udc1f",
    fish_cake: "\ud83c\udf65",
    fishing_pole_and_fish: "\ud83c\udfa3",
    fist_raised: "\u270a",
    fist_left: "\ud83e\udd1b",
    fist_right: "\ud83e\udd1c",
    flags: "\ud83c\udf8f",
    flashlight: "\ud83d\udd26",
    fleur_de_lis: "\u269c\ufe0f",
    flight_arrival: "\ud83d\udeec",
    flight_departure: "\ud83d\udeeb",
    floppy_disk: "\ud83d\udcbe",
    flower_playing_cards: "\ud83c\udfb4",
    flushed: "\ud83d\ude33",
    fog: "\ud83c\udf2b",
    foggy: "\ud83c\udf01",
    football: "\ud83c\udfc8",
    footprints: "\ud83d\udc63",
    fork_and_knife: "\ud83c\udf74",
    fountain: "\u26f2\ufe0f",
    fountain_pen: "\ud83d\udd8b",
    four_leaf_clover: "\ud83c\udf40",
    fox_face: "\ud83e\udd8a",
    framed_picture: "\ud83d\uddbc",
    free: "\ud83c\udd93",
    fried_egg: "\ud83c\udf73",
    fried_shrimp: "\ud83c\udf64",
    fries: "\ud83c\udf5f",
    frog: "\ud83d\udc38",
    frowning: "\ud83d\ude26",
    frowning_face: "\u2639\ufe0f",
    frowning_man: "\ud83d\ude4d&zwj;\u2642\ufe0f",
    frowning_woman: "\ud83d\ude4d",
    middle_finger: "\ud83d\udd95",
    fuelpump: "\u26fd\ufe0f",
    full_moon: "\ud83c\udf15",
    full_moon_with_face: "\ud83c\udf1d",
    funeral_urn: "\u26b1\ufe0f",
    game_die: "\ud83c\udfb2",
    gear: "\u2699\ufe0f",
    gem: "\ud83d\udc8e",
    gemini: "\u264a\ufe0f",
    ghost: "\ud83d\udc7b",
    gift: "\ud83c\udf81",
    gift_heart: "\ud83d\udc9d",
    girl: "\ud83d\udc67",
    globe_with_meridians: "\ud83c\udf10",
    goal_net: "\ud83e\udd45",
    goat: "\ud83d\udc10",
    golf: "\u26f3\ufe0f",
    golfing_man: "\ud83c\udfcc\ufe0f",
    golfing_woman: "\ud83c\udfcc\ufe0f&zwj;\u2640\ufe0f",
    gorilla: "\ud83e\udd8d",
    grapes: "\ud83c\udf47",
    green_apple: "\ud83c\udf4f",
    green_book: "\ud83d\udcd7",
    green_heart: "\ud83d\udc9a",
    green_salad: "\ud83e\udd57",
    grey_exclamation: "\u2755",
    grey_question: "\u2754",
    grimacing: "\ud83d\ude2c",
    grin: "\ud83d\ude01",
    grinning: "\ud83d\ude00",
    guardsman: "\ud83d\udc82",
    guardswoman: "\ud83d\udc82&zwj;\u2640\ufe0f",
    guitar: "\ud83c\udfb8",
    gun: "\ud83d\udd2b",
    haircut_woman: "\ud83d\udc87",
    haircut_man: "\ud83d\udc87&zwj;\u2642\ufe0f",
    hamburger: "\ud83c\udf54",
    hammer: "\ud83d\udd28",
    hammer_and_pick: "\u2692",
    hammer_and_wrench: "\ud83d\udee0",
    hamster: "\ud83d\udc39",
    hand: "\u270b",
    handbag: "\ud83d\udc5c",
    handshake: "\ud83e\udd1d",
    hankey: "\ud83d\udca9",
    hatched_chick: "\ud83d\udc25",
    hatching_chick: "\ud83d\udc23",
    headphones: "\ud83c\udfa7",
    hear_no_evil: "\ud83d\ude49",
    heart: "\u2764\ufe0f",
    heart_decoration: "\ud83d\udc9f",
    heart_eyes: "\ud83d\ude0d",
    heart_eyes_cat: "\ud83d\ude3b",
    heartbeat: "\ud83d\udc93",
    heartpulse: "\ud83d\udc97",
    hearts: "\u2665\ufe0f",
    heavy_check_mark: "\u2714\ufe0f",
    heavy_division_sign: "\u2797",
    heavy_dollar_sign: "\ud83d\udcb2",
    heavy_heart_exclamation: "\u2763\ufe0f",
    heavy_minus_sign: "\u2796",
    heavy_multiplication_x: "\u2716\ufe0f",
    heavy_plus_sign: "\u2795",
    helicopter: "\ud83d\ude81",
    herb: "\ud83c\udf3f",
    hibiscus: "\ud83c\udf3a",
    high_brightness: "\ud83d\udd06",
    high_heel: "\ud83d\udc60",
    hocho: "\ud83d\udd2a",
    hole: "\ud83d\udd73",
    honey_pot: "\ud83c\udf6f",
    horse: "\ud83d\udc34",
    horse_racing: "\ud83c\udfc7",
    hospital: "\ud83c\udfe5",
    hot_pepper: "\ud83c\udf36",
    hotdog: "\ud83c\udf2d",
    hotel: "\ud83c\udfe8",
    hotsprings: "\u2668\ufe0f",
    hourglass: "\u231b\ufe0f",
    hourglass_flowing_sand: "\u23f3",
    house: "\ud83c\udfe0",
    house_with_garden: "\ud83c\udfe1",
    houses: "\ud83c\udfd8",
    hugs: "\ud83e\udd17",
    hushed: "\ud83d\ude2f",
    ice_cream: "\ud83c\udf68",
    ice_hockey: "\ud83c\udfd2",
    ice_skate: "\u26f8",
    icecream: "\ud83c\udf66",
    id: "\ud83c\udd94",
    ideograph_advantage: "\ud83c\ude50",
    imp: "\ud83d\udc7f",
    inbox_tray: "\ud83d\udce5",
    incoming_envelope: "\ud83d\udce8",
    tipping_hand_woman: "\ud83d\udc81",
    information_source: "\u2139\ufe0f",
    innocent: "\ud83d\ude07",
    interrobang: "\u2049\ufe0f",
    iphone: "\ud83d\udcf1",
    izakaya_lantern: "\ud83c\udfee",
    jack_o_lantern: "\ud83c\udf83",
    japan: "\ud83d\uddfe",
    japanese_castle: "\ud83c\udfef",
    japanese_goblin: "\ud83d\udc7a",
    japanese_ogre: "\ud83d\udc79",
    jeans: "\ud83d\udc56",
    joy: "\ud83d\ude02",
    joy_cat: "\ud83d\ude39",
    joystick: "\ud83d\udd79",
    kaaba: "\ud83d\udd4b",
    key: "\ud83d\udd11",
    keyboard: "\u2328\ufe0f",
    keycap_ten: "\ud83d\udd1f",
    kick_scooter: "\ud83d\udef4",
    kimono: "\ud83d\udc58",
    kiss: "\ud83d\udc8b",
    kissing: "\ud83d\ude17",
    kissing_cat: "\ud83d\ude3d",
    kissing_closed_eyes: "\ud83d\ude1a",
    kissing_heart: "\ud83d\ude18",
    kissing_smiling_eyes: "\ud83d\ude19",
    kiwi_fruit: "\ud83e\udd5d",
    koala: "\ud83d\udc28",
    koko: "\ud83c\ude01",
    label: "\ud83c\udff7",
    large_blue_circle: "\ud83d\udd35",
    large_blue_diamond: "\ud83d\udd37",
    large_orange_diamond: "\ud83d\udd36",
    last_quarter_moon: "\ud83c\udf17",
    last_quarter_moon_with_face: "\ud83c\udf1c",
    latin_cross: "\u271d\ufe0f",
    laughing: "\ud83d\ude06",
    leaves: "\ud83c\udf43",
    ledger: "\ud83d\udcd2",
    left_luggage: "\ud83d\udec5",
    left_right_arrow: "\u2194\ufe0f",
    leftwards_arrow_with_hook: "\u21a9\ufe0f",
    lemon: "\ud83c\udf4b",
    leo: "\u264c\ufe0f",
    leopard: "\ud83d\udc06",
    level_slider: "\ud83c\udf9a",
    libra: "\u264e\ufe0f",
    light_rail: "\ud83d\ude88",
    link: "\ud83d\udd17",
    lion: "\ud83e\udd81",
    lips: "\ud83d\udc44",
    lipstick: "\ud83d\udc84",
    lizard: "\ud83e\udd8e",
    lock: "\ud83d\udd12",
    lock_with_ink_pen: "\ud83d\udd0f",
    lollipop: "\ud83c\udf6d",
    loop: "\u27bf",
    loud_sound: "\ud83d\udd0a",
    loudspeaker: "\ud83d\udce2",
    love_hotel: "\ud83c\udfe9",
    love_letter: "\ud83d\udc8c",
    low_brightness: "\ud83d\udd05",
    lying_face: "\ud83e\udd25",
    m: "\u24c2\ufe0f",
    mag: "\ud83d\udd0d",
    mag_right: "\ud83d\udd0e",
    mahjong: "\ud83c\udc04\ufe0f",
    mailbox: "\ud83d\udceb",
    mailbox_closed: "\ud83d\udcea",
    mailbox_with_mail: "\ud83d\udcec",
    mailbox_with_no_mail: "\ud83d\udced",
    man: "\ud83d\udc68",
    man_artist: "\ud83d\udc68&zwj;\ud83c\udfa8",
    man_astronaut: "\ud83d\udc68&zwj;\ud83d\ude80",
    man_cartwheeling: "\ud83e\udd38&zwj;\u2642\ufe0f",
    man_cook: "\ud83d\udc68&zwj;\ud83c\udf73",
    man_dancing: "\ud83d\udd7a",
    man_facepalming: "\ud83e\udd26&zwj;\u2642\ufe0f",
    man_factory_worker: "\ud83d\udc68&zwj;\ud83c\udfed",
    man_farmer: "\ud83d\udc68&zwj;\ud83c\udf3e",
    man_firefighter: "\ud83d\udc68&zwj;\ud83d\ude92",
    man_health_worker: "\ud83d\udc68&zwj;\u2695\ufe0f",
    man_in_tuxedo: "\ud83e\udd35",
    man_judge: "\ud83d\udc68&zwj;\u2696\ufe0f",
    man_juggling: "\ud83e\udd39&zwj;\u2642\ufe0f",
    man_mechanic: "\ud83d\udc68&zwj;\ud83d\udd27",
    man_office_worker: "\ud83d\udc68&zwj;\ud83d\udcbc",
    man_pilot: "\ud83d\udc68&zwj;\u2708\ufe0f",
    man_playing_handball: "\ud83e\udd3e&zwj;\u2642\ufe0f",
    man_playing_water_polo: "\ud83e\udd3d&zwj;\u2642\ufe0f",
    man_scientist: "\ud83d\udc68&zwj;\ud83d\udd2c",
    man_shrugging: "\ud83e\udd37&zwj;\u2642\ufe0f",
    man_singer: "\ud83d\udc68&zwj;\ud83c\udfa4",
    man_student: "\ud83d\udc68&zwj;\ud83c\udf93",
    man_teacher: "\ud83d\udc68&zwj;\ud83c\udfeb",
    man_technologist: "\ud83d\udc68&zwj;\ud83d\udcbb",
    man_with_gua_pi_mao: "\ud83d\udc72",
    man_with_turban: "\ud83d\udc73",
    tangerine: "\ud83c\udf4a",
    mans_shoe: "\ud83d\udc5e",
    mantelpiece_clock: "\ud83d\udd70",
    maple_leaf: "\ud83c\udf41",
    martial_arts_uniform: "\ud83e\udd4b",
    mask: "\ud83d\ude37",
    massage_woman: "\ud83d\udc86",
    massage_man: "\ud83d\udc86&zwj;\u2642\ufe0f",
    meat_on_bone: "\ud83c\udf56",
    medal_military: "\ud83c\udf96",
    medal_sports: "\ud83c\udfc5",
    mega: "\ud83d\udce3",
    melon: "\ud83c\udf48",
    memo: "\ud83d\udcdd",
    men_wrestling: "\ud83e\udd3c&zwj;\u2642\ufe0f",
    menorah: "\ud83d\udd4e",
    mens: "\ud83d\udeb9",
    metal: "\ud83e\udd18",
    metro: "\ud83d\ude87",
    microphone: "\ud83c\udfa4",
    microscope: "\ud83d\udd2c",
    milk_glass: "\ud83e\udd5b",
    milky_way: "\ud83c\udf0c",
    minibus: "\ud83d\ude90",
    minidisc: "\ud83d\udcbd",
    mobile_phone_off: "\ud83d\udcf4",
    money_mouth_face: "\ud83e\udd11",
    money_with_wings: "\ud83d\udcb8",
    moneybag: "\ud83d\udcb0",
    monkey: "\ud83d\udc12",
    monkey_face: "\ud83d\udc35",
    monorail: "\ud83d\ude9d",
    moon: "\ud83c\udf14",
    mortar_board: "\ud83c\udf93",
    mosque: "\ud83d\udd4c",
    motor_boat: "\ud83d\udee5",
    motor_scooter: "\ud83d\udef5",
    motorcycle: "\ud83c\udfcd",
    motorway: "\ud83d\udee3",
    mount_fuji: "\ud83d\uddfb",
    mountain: "\u26f0",
    mountain_biking_man: "\ud83d\udeb5",
    mountain_biking_woman: "\ud83d\udeb5&zwj;\u2640\ufe0f",
    mountain_cableway: "\ud83d\udea0",
    mountain_railway: "\ud83d\ude9e",
    mountain_snow: "\ud83c\udfd4",
    mouse: "\ud83d\udc2d",
    mouse2: "\ud83d\udc01",
    movie_camera: "\ud83c\udfa5",
    moyai: "\ud83d\uddff",
    mrs_claus: "\ud83e\udd36",
    muscle: "\ud83d\udcaa",
    mushroom: "\ud83c\udf44",
    musical_keyboard: "\ud83c\udfb9",
    musical_note: "\ud83c\udfb5",
    musical_score: "\ud83c\udfbc",
    mute: "\ud83d\udd07",
    nail_care: "\ud83d\udc85",
    name_badge: "\ud83d\udcdb",
    national_park: "\ud83c\udfde",
    nauseated_face: "\ud83e\udd22",
    necktie: "\ud83d\udc54",
    negative_squared_cross_mark: "\u274e",
    nerd_face: "\ud83e\udd13",
    neutral_face: "\ud83d\ude10",
    "new": "\ud83c\udd95",
    new_moon: "\ud83c\udf11",
    new_moon_with_face: "\ud83c\udf1a",
    newspaper: "\ud83d\udcf0",
    newspaper_roll: "\ud83d\uddde",
    next_track_button: "\u23ed",
    ng: "\ud83c\udd96",
    no_good_man: "\ud83d\ude45&zwj;\u2642\ufe0f",
    no_good_woman: "\ud83d\ude45",
    night_with_stars: "\ud83c\udf03",
    no_bell: "\ud83d\udd15",
    no_bicycles: "\ud83d\udeb3",
    no_entry: "\u26d4\ufe0f",
    no_entry_sign: "\ud83d\udeab",
    no_mobile_phones: "\ud83d\udcf5",
    no_mouth: "\ud83d\ude36",
    no_pedestrians: "\ud83d\udeb7",
    no_smoking: "\ud83d\udead",
    "non-potable_water": "\ud83d\udeb1",
    nose: "\ud83d\udc43",
    notebook: "\ud83d\udcd3",
    notebook_with_decorative_cover: "\ud83d\udcd4",
    notes: "\ud83c\udfb6",
    nut_and_bolt: "\ud83d\udd29",
    o: "\u2b55\ufe0f",
    o2: "\ud83c\udd7e\ufe0f",
    ocean: "\ud83c\udf0a",
    octopus: "\ud83d\udc19",
    oden: "\ud83c\udf62",
    office: "\ud83c\udfe2",
    oil_drum: "\ud83d\udee2",
    ok: "\ud83c\udd97",
    ok_hand: "\ud83d\udc4c",
    ok_man: "\ud83d\ude46&zwj;\u2642\ufe0f",
    ok_woman: "\ud83d\ude46",
    old_key: "\ud83d\udddd",
    older_man: "\ud83d\udc74",
    older_woman: "\ud83d\udc75",
    om: "\ud83d\udd49",
    on: "\ud83d\udd1b",
    oncoming_automobile: "\ud83d\ude98",
    oncoming_bus: "\ud83d\ude8d",
    oncoming_police_car: "\ud83d\ude94",
    oncoming_taxi: "\ud83d\ude96",
    open_file_folder: "\ud83d\udcc2",
    open_hands: "\ud83d\udc50",
    open_mouth: "\ud83d\ude2e",
    open_umbrella: "\u2602\ufe0f",
    ophiuchus: "\u26ce",
    orange_book: "\ud83d\udcd9",
    orthodox_cross: "\u2626\ufe0f",
    outbox_tray: "\ud83d\udce4",
    owl: "\ud83e\udd89",
    ox: "\ud83d\udc02",
    "package": "\ud83d\udce6",
    page_facing_up: "\ud83d\udcc4",
    page_with_curl: "\ud83d\udcc3",
    pager: "\ud83d\udcdf",
    paintbrush: "\ud83d\udd8c",
    palm_tree: "\ud83c\udf34",
    pancakes: "\ud83e\udd5e",
    panda_face: "\ud83d\udc3c",
    paperclip: "\ud83d\udcce",
    paperclips: "\ud83d\udd87",
    parasol_on_ground: "\u26f1",
    parking: "\ud83c\udd7f\ufe0f",
    part_alternation_mark: "\u303d\ufe0f",
    partly_sunny: "\u26c5\ufe0f",
    passenger_ship: "\ud83d\udef3",
    passport_control: "\ud83d\udec2",
    pause_button: "\u23f8",
    peace_symbol: "\u262e\ufe0f",
    peach: "\ud83c\udf51",
    peanuts: "\ud83e\udd5c",
    pear: "\ud83c\udf50",
    pen: "\ud83d\udd8a",
    pencil2: "\u270f\ufe0f",
    penguin: "\ud83d\udc27",
    pensive: "\ud83d\ude14",
    performing_arts: "\ud83c\udfad",
    persevere: "\ud83d\ude23",
    person_fencing: "\ud83e\udd3a",
    pouting_woman: "\ud83d\ude4e",
    phone: "\u260e\ufe0f",
    pick: "\u26cf",
    pig: "\ud83d\udc37",
    pig2: "\ud83d\udc16",
    pig_nose: "\ud83d\udc3d",
    pill: "\ud83d\udc8a",
    pineapple: "\ud83c\udf4d",
    ping_pong: "\ud83c\udfd3",
    pisces: "\u2653\ufe0f",
    pizza: "\ud83c\udf55",
    place_of_worship: "\ud83d\uded0",
    plate_with_cutlery: "\ud83c\udf7d",
    play_or_pause_button: "\u23ef",
    point_down: "\ud83d\udc47",
    point_left: "\ud83d\udc48",
    point_right: "\ud83d\udc49",
    point_up: "\u261d\ufe0f",
    point_up_2: "\ud83d\udc46",
    police_car: "\ud83d\ude93",
    policewoman: "\ud83d\udc6e&zwj;\u2640\ufe0f",
    poodle: "\ud83d\udc29",
    popcorn: "\ud83c\udf7f",
    post_office: "\ud83c\udfe3",
    postal_horn: "\ud83d\udcef",
    postbox: "\ud83d\udcee",
    potable_water: "\ud83d\udeb0",
    potato: "\ud83e\udd54",
    pouch: "\ud83d\udc5d",
    poultry_leg: "\ud83c\udf57",
    pound: "\ud83d\udcb7",
    rage: "\ud83d\ude21",
    pouting_cat: "\ud83d\ude3e",
    pouting_man: "\ud83d\ude4e&zwj;\u2642\ufe0f",
    pray: "\ud83d\ude4f",
    prayer_beads: "\ud83d\udcff",
    pregnant_woman: "\ud83e\udd30",
    previous_track_button: "\u23ee",
    prince: "\ud83e\udd34",
    princess: "\ud83d\udc78",
    printer: "\ud83d\udda8",
    purple_heart: "\ud83d\udc9c",
    purse: "\ud83d\udc5b",
    pushpin: "\ud83d\udccc",
    put_litter_in_its_place: "\ud83d\udeae",
    question: "\u2753",
    rabbit: "\ud83d\udc30",
    rabbit2: "\ud83d\udc07",
    racehorse: "\ud83d\udc0e",
    racing_car: "\ud83c\udfce",
    radio: "\ud83d\udcfb",
    radio_button: "\ud83d\udd18",
    radioactive: "\u2622\ufe0f",
    railway_car: "\ud83d\ude83",
    railway_track: "\ud83d\udee4",
    rainbow: "\ud83c\udf08",
    rainbow_flag: "\ud83c\udff3\ufe0f&zwj;\ud83c\udf08",
    raised_back_of_hand: "\ud83e\udd1a",
    raised_hand_with_fingers_splayed: "\ud83d\udd90",
    raised_hands: "\ud83d\ude4c",
    raising_hand_woman: "\ud83d\ude4b",
    raising_hand_man: "\ud83d\ude4b&zwj;\u2642\ufe0f",
    ram: "\ud83d\udc0f",
    ramen: "\ud83c\udf5c",
    rat: "\ud83d\udc00",
    record_button: "\u23fa",
    recycle: "\u267b\ufe0f",
    red_circle: "\ud83d\udd34",
    registered: "\xae\ufe0f",
    relaxed: "\u263a\ufe0f",
    relieved: "\ud83d\ude0c",
    reminder_ribbon: "\ud83c\udf97",
    repeat: "\ud83d\udd01",
    repeat_one: "\ud83d\udd02",
    rescue_worker_helmet: "\u26d1",
    restroom: "\ud83d\udebb",
    revolving_hearts: "\ud83d\udc9e",
    rewind: "\u23ea",
    rhinoceros: "\ud83e\udd8f",
    ribbon: "\ud83c\udf80",
    rice: "\ud83c\udf5a",
    rice_ball: "\ud83c\udf59",
    rice_cracker: "\ud83c\udf58",
    rice_scene: "\ud83c\udf91",
    right_anger_bubble: "\ud83d\uddef",
    ring: "\ud83d\udc8d",
    robot: "\ud83e\udd16",
    rocket: "\ud83d\ude80",
    rofl: "\ud83e\udd23",
    roll_eyes: "\ud83d\ude44",
    roller_coaster: "\ud83c\udfa2",
    rooster: "\ud83d\udc13",
    rose: "\ud83c\udf39",
    rosette: "\ud83c\udff5",
    rotating_light: "\ud83d\udea8",
    round_pushpin: "\ud83d\udccd",
    rowing_man: "\ud83d\udea3",
    rowing_woman: "\ud83d\udea3&zwj;\u2640\ufe0f",
    rugby_football: "\ud83c\udfc9",
    running_man: "\ud83c\udfc3",
    running_shirt_with_sash: "\ud83c\udfbd",
    running_woman: "\ud83c\udfc3&zwj;\u2640\ufe0f",
    sa: "\ud83c\ude02\ufe0f",
    sagittarius: "\u2650\ufe0f",
    sake: "\ud83c\udf76",
    sandal: "\ud83d\udc61",
    santa: "\ud83c\udf85",
    satellite: "\ud83d\udce1",
    saxophone: "\ud83c\udfb7",
    school: "\ud83c\udfeb",
    school_satchel: "\ud83c\udf92",
    scissors: "\u2702\ufe0f",
    scorpion: "\ud83e\udd82",
    scorpius: "\u264f\ufe0f",
    scream: "\ud83d\ude31",
    scream_cat: "\ud83d\ude40",
    scroll: "\ud83d\udcdc",
    seat: "\ud83d\udcba",
    secret: "\u3299\ufe0f",
    see_no_evil: "\ud83d\ude48",
    seedling: "\ud83c\udf31",
    selfie: "\ud83e\udd33",
    shallow_pan_of_food: "\ud83e\udd58",
    shamrock: "\u2618\ufe0f",
    shark: "\ud83e\udd88",
    shaved_ice: "\ud83c\udf67",
    sheep: "\ud83d\udc11",
    shell: "\ud83d\udc1a",
    shield: "\ud83d\udee1",
    shinto_shrine: "\u26e9",
    ship: "\ud83d\udea2",
    shirt: "\ud83d\udc55",
    shopping: "\ud83d\udecd",
    shopping_cart: "\ud83d\uded2",
    shower: "\ud83d\udebf",
    shrimp: "\ud83e\udd90",
    signal_strength: "\ud83d\udcf6",
    six_pointed_star: "\ud83d\udd2f",
    ski: "\ud83c\udfbf",
    skier: "\u26f7",
    skull: "\ud83d\udc80",
    skull_and_crossbones: "\u2620\ufe0f",
    sleeping: "\ud83d\ude34",
    sleeping_bed: "\ud83d\udecc",
    sleepy: "\ud83d\ude2a",
    slightly_frowning_face: "\ud83d\ude41",
    slightly_smiling_face: "\ud83d\ude42",
    slot_machine: "\ud83c\udfb0",
    small_airplane: "\ud83d\udee9",
    small_blue_diamond: "\ud83d\udd39",
    small_orange_diamond: "\ud83d\udd38",
    small_red_triangle: "\ud83d\udd3a",
    small_red_triangle_down: "\ud83d\udd3b",
    smile: "\ud83d\ude04",
    smile_cat: "\ud83d\ude38",
    smiley: "\ud83d\ude03",
    smiley_cat: "\ud83d\ude3a",
    smiling_imp: "\ud83d\ude08",
    smirk: "\ud83d\ude0f",
    smirk_cat: "\ud83d\ude3c",
    smoking: "\ud83d\udeac",
    snail: "\ud83d\udc0c",
    snake: "\ud83d\udc0d",
    sneezing_face: "\ud83e\udd27",
    snowboarder: "\ud83c\udfc2",
    snowflake: "\u2744\ufe0f",
    snowman: "\u26c4\ufe0f",
    snowman_with_snow: "\u2603\ufe0f",
    sob: "\ud83d\ude2d",
    soccer: "\u26bd\ufe0f",
    soon: "\ud83d\udd1c",
    sos: "\ud83c\udd98",
    sound: "\ud83d\udd09",
    space_invader: "\ud83d\udc7e",
    spades: "\u2660\ufe0f",
    spaghetti: "\ud83c\udf5d",
    sparkle: "\u2747\ufe0f",
    sparkler: "\ud83c\udf87",
    sparkles: "\u2728",
    sparkling_heart: "\ud83d\udc96",
    speak_no_evil: "\ud83d\ude4a",
    speaker: "\ud83d\udd08",
    speaking_head: "\ud83d\udde3",
    speech_balloon: "\ud83d\udcac",
    speedboat: "\ud83d\udea4",
    spider: "\ud83d\udd77",
    spider_web: "\ud83d\udd78",
    spiral_calendar: "\ud83d\uddd3",
    spiral_notepad: "\ud83d\uddd2",
    spoon: "\ud83e\udd44",
    squid: "\ud83e\udd91",
    stadium: "\ud83c\udfdf",
    star: "\u2b50\ufe0f",
    star2: "\ud83c\udf1f",
    star_and_crescent: "\u262a\ufe0f",
    star_of_david: "\u2721\ufe0f",
    stars: "\ud83c\udf20",
    station: "\ud83d\ude89",
    statue_of_liberty: "\ud83d\uddfd",
    steam_locomotive: "\ud83d\ude82",
    stew: "\ud83c\udf72",
    stop_button: "\u23f9",
    stop_sign: "\ud83d\uded1",
    stopwatch: "\u23f1",
    straight_ruler: "\ud83d\udccf",
    strawberry: "\ud83c\udf53",
    stuck_out_tongue: "\ud83d\ude1b",
    stuck_out_tongue_closed_eyes: "\ud83d\ude1d",
    stuck_out_tongue_winking_eye: "\ud83d\ude1c",
    studio_microphone: "\ud83c\udf99",
    stuffed_flatbread: "\ud83e\udd59",
    sun_behind_large_cloud: "\ud83c\udf25",
    sun_behind_rain_cloud: "\ud83c\udf26",
    sun_behind_small_cloud: "\ud83c\udf24",
    sun_with_face: "\ud83c\udf1e",
    sunflower: "\ud83c\udf3b",
    sunglasses: "\ud83d\ude0e",
    sunny: "\u2600\ufe0f",
    sunrise: "\ud83c\udf05",
    sunrise_over_mountains: "\ud83c\udf04",
    surfing_man: "\ud83c\udfc4",
    surfing_woman: "\ud83c\udfc4&zwj;\u2640\ufe0f",
    sushi: "\ud83c\udf63",
    suspension_railway: "\ud83d\ude9f",
    sweat: "\ud83d\ude13",
    sweat_drops: "\ud83d\udca6",
    sweat_smile: "\ud83d\ude05",
    sweet_potato: "\ud83c\udf60",
    swimming_man: "\ud83c\udfca",
    swimming_woman: "\ud83c\udfca&zwj;\u2640\ufe0f",
    symbols: "\ud83d\udd23",
    synagogue: "\ud83d\udd4d",
    syringe: "\ud83d\udc89",
    taco: "\ud83c\udf2e",
    tada: "\ud83c\udf89",
    tanabata_tree: "\ud83c\udf8b",
    taurus: "\u2649\ufe0f",
    taxi: "\ud83d\ude95",
    tea: "\ud83c\udf75",
    telephone_receiver: "\ud83d\udcde",
    telescope: "\ud83d\udd2d",
    tennis: "\ud83c\udfbe",
    tent: "\u26fa\ufe0f",
    thermometer: "\ud83c\udf21",
    thinking: "\ud83e\udd14",
    thought_balloon: "\ud83d\udcad",
    ticket: "\ud83c\udfab",
    tickets: "\ud83c\udf9f",
    tiger: "\ud83d\udc2f",
    tiger2: "\ud83d\udc05",
    timer_clock: "\u23f2",
    tipping_hand_man: "\ud83d\udc81&zwj;\u2642\ufe0f",
    tired_face: "\ud83d\ude2b",
    tm: "\u2122\ufe0f",
    toilet: "\ud83d\udebd",
    tokyo_tower: "\ud83d\uddfc",
    tomato: "\ud83c\udf45",
    tongue: "\ud83d\udc45",
    top: "\ud83d\udd1d",
    tophat: "\ud83c\udfa9",
    tornado: "\ud83c\udf2a",
    trackball: "\ud83d\uddb2",
    tractor: "\ud83d\ude9c",
    traffic_light: "\ud83d\udea5",
    train: "\ud83d\ude8b",
    train2: "\ud83d\ude86",
    tram: "\ud83d\ude8a",
    triangular_flag_on_post: "\ud83d\udea9",
    triangular_ruler: "\ud83d\udcd0",
    trident: "\ud83d\udd31",
    triumph: "\ud83d\ude24",
    trolleybus: "\ud83d\ude8e",
    trophy: "\ud83c\udfc6",
    tropical_drink: "\ud83c\udf79",
    tropical_fish: "\ud83d\udc20",
    truck: "\ud83d\ude9a",
    trumpet: "\ud83c\udfba",
    tulip: "\ud83c\udf37",
    tumbler_glass: "\ud83e\udd43",
    turkey: "\ud83e\udd83",
    turtle: "\ud83d\udc22",
    tv: "\ud83d\udcfa",
    twisted_rightwards_arrows: "\ud83d\udd00",
    two_hearts: "\ud83d\udc95",
    two_men_holding_hands: "\ud83d\udc6c",
    two_women_holding_hands: "\ud83d\udc6d",
    u5272: "\ud83c\ude39",
    u5408: "\ud83c\ude34",
    u55b6: "\ud83c\ude3a",
    u6307: "\ud83c\ude2f\ufe0f",
    u6708: "\ud83c\ude37\ufe0f",
    u6709: "\ud83c\ude36",
    u6e80: "\ud83c\ude35",
    u7121: "\ud83c\ude1a\ufe0f",
    u7533: "\ud83c\ude38",
    u7981: "\ud83c\ude32",
    u7a7a: "\ud83c\ude33",
    umbrella: "\u2614\ufe0f",
    unamused: "\ud83d\ude12",
    underage: "\ud83d\udd1e",
    unicorn: "\ud83e\udd84",
    unlock: "\ud83d\udd13",
    up: "\ud83c\udd99",
    upside_down_face: "\ud83d\ude43",
    v: "\u270c\ufe0f",
    vertical_traffic_light: "\ud83d\udea6",
    vhs: "\ud83d\udcfc",
    vibration_mode: "\ud83d\udcf3",
    video_camera: "\ud83d\udcf9",
    video_game: "\ud83c\udfae",
    violin: "\ud83c\udfbb",
    virgo: "\u264d\ufe0f",
    volcano: "\ud83c\udf0b",
    volleyball: "\ud83c\udfd0",
    vs: "\ud83c\udd9a",
    vulcan_salute: "\ud83d\udd96",
    walking_man: "\ud83d\udeb6",
    walking_woman: "\ud83d\udeb6&zwj;\u2640\ufe0f",
    waning_crescent_moon: "\ud83c\udf18",
    waning_gibbous_moon: "\ud83c\udf16",
    warning: "\u26a0\ufe0f",
    wastebasket: "\ud83d\uddd1",
    watch: "\u231a\ufe0f",
    water_buffalo: "\ud83d\udc03",
    watermelon: "\ud83c\udf49",
    wave: "\ud83d\udc4b",
    wavy_dash: "\u3030\ufe0f",
    waxing_crescent_moon: "\ud83c\udf12",
    wc: "\ud83d\udebe",
    weary: "\ud83d\ude29",
    wedding: "\ud83d\udc92",
    weight_lifting_man: "\ud83c\udfcb\ufe0f",
    weight_lifting_woman: "\ud83c\udfcb\ufe0f&zwj;\u2640\ufe0f",
    whale: "\ud83d\udc33",
    whale2: "\ud83d\udc0b",
    wheel_of_dharma: "\u2638\ufe0f",
    wheelchair: "\u267f\ufe0f",
    white_check_mark: "\u2705",
    white_circle: "\u26aa\ufe0f",
    white_flag: "\ud83c\udff3\ufe0f",
    white_flower: "\ud83d\udcae",
    white_large_square: "\u2b1c\ufe0f",
    white_medium_small_square: "\u25fd\ufe0f",
    white_medium_square: "\u25fb\ufe0f",
    white_small_square: "\u25ab\ufe0f",
    white_square_button: "\ud83d\udd33",
    wilted_flower: "\ud83e\udd40",
    wind_chime: "\ud83c\udf90",
    wind_face: "\ud83c\udf2c",
    wine_glass: "\ud83c\udf77",
    wink: "\ud83d\ude09",
    wolf: "\ud83d\udc3a",
    woman: "\ud83d\udc69",
    woman_artist: "\ud83d\udc69&zwj;\ud83c\udfa8",
    woman_astronaut: "\ud83d\udc69&zwj;\ud83d\ude80",
    woman_cartwheeling: "\ud83e\udd38&zwj;\u2640\ufe0f",
    woman_cook: "\ud83d\udc69&zwj;\ud83c\udf73",
    woman_facepalming: "\ud83e\udd26&zwj;\u2640\ufe0f",
    woman_factory_worker: "\ud83d\udc69&zwj;\ud83c\udfed",
    woman_farmer: "\ud83d\udc69&zwj;\ud83c\udf3e",
    woman_firefighter: "\ud83d\udc69&zwj;\ud83d\ude92",
    woman_health_worker: "\ud83d\udc69&zwj;\u2695\ufe0f",
    woman_judge: "\ud83d\udc69&zwj;\u2696\ufe0f",
    woman_juggling: "\ud83e\udd39&zwj;\u2640\ufe0f",
    woman_mechanic: "\ud83d\udc69&zwj;\ud83d\udd27",
    woman_office_worker: "\ud83d\udc69&zwj;\ud83d\udcbc",
    woman_pilot: "\ud83d\udc69&zwj;\u2708\ufe0f",
    woman_playing_handball: "\ud83e\udd3e&zwj;\u2640\ufe0f",
    woman_playing_water_polo: "\ud83e\udd3d&zwj;\u2640\ufe0f",
    woman_scientist: "\ud83d\udc69&zwj;\ud83d\udd2c",
    woman_shrugging: "\ud83e\udd37&zwj;\u2640\ufe0f",
    woman_singer: "\ud83d\udc69&zwj;\ud83c\udfa4",
    woman_student: "\ud83d\udc69&zwj;\ud83c\udf93",
    woman_teacher: "\ud83d\udc69&zwj;\ud83c\udfeb",
    woman_technologist: "\ud83d\udc69&zwj;\ud83d\udcbb",
    woman_with_turban: "\ud83d\udc73&zwj;\u2640\ufe0f",
    womans_clothes: "\ud83d\udc5a",
    womans_hat: "\ud83d\udc52",
    women_wrestling: "\ud83e\udd3c&zwj;\u2640\ufe0f",
    womens: "\ud83d\udeba",
    world_map: "\ud83d\uddfa",
    worried: "\ud83d\ude1f",
    wrench: "\ud83d\udd27",
    writing_hand: "\u270d\ufe0f",
    x: "\u274c",
    yellow_heart: "\ud83d\udc9b",
    yen: "\ud83d\udcb4",
    yin_yang: "\u262f\ufe0f",
    yum: "\ud83d\ude0b",
    zap: "\u26a1\ufe0f",
    zipper_mouth_face: "\ud83e\udd10",
    zzz: "\ud83d\udca4",
    octocat: '<img alt=":octocat:" height="20" width="20" align="absmiddle" src="https://assets-cdn.github.com/images/icons/emoji/octocat.png">',
    showdown: "<span style=\"font-family: 'Anonymous Pro', monospace; text-decoration: underline; text-decoration-style: dashed; text-decoration-color: #3e8b8a;text-underline-position: under;\">S</span>"
  }, L.Converter = function (n) {
    var a = {}, i = [], s = [], l = {}, r = A, o = {parsed: {}, raw: "", format: ""};

    function c(e, t) {
      if (t = t || null, L.helper.isString(e)) {
        if (t = e = L.helper.stdExtName(e), L.extensions[e]) return void function o(e, t) {
          "function" == typeof e && (e = e(new L.Converter));
          L.helper.isArray(e) || (e = [e]);
          var n = S(e, t);
          if (!n.valid) throw Error(n.error);
          for (var r = 0; r < e.length; ++r) switch (e[r].type) {
            case"lang":
              i.push(e[r]);
              break;
            case"output":
              s.push(e[r]);
              break;
            default:
              throw Error("Extension loader error: Type unrecognized!!!")
          }
        }(L.extensions[e], e);
        if (L.helper.isUndefined(_[e])) throw Error('Extension "' + e + '" could not be loaded. It was either not found or is not a valid extension.');
        e = _[e]
      }
      "function" == typeof e && (e = e()), L.helper.isArray(e) || (e = [e]);
      var n = S(e, t);
      if (!n.valid) throw Error(n.error);
      for (var r = 0; r < e.length; ++r) {
        switch (e[r].type) {
          case"lang":
            i.push(e[r]);
            break;
          case"output":
            s.push(e[r])
        }
        if (e[r].hasOwnProperty("listeners")) for (var a in e[r].listeners) e[r].listeners.hasOwnProperty(a) && d(a, e[r].listeners[a])
      }
    }

    function d(e, t) {
      if (!L.helper.isString(e)) throw Error("Invalid argument in converter.listen() method: name must be a string, but " + kt(e) + " given");
      if ("function" != typeof t) throw Error("Invalid argument in converter.listen() method: callback must be a function, but " + kt(t) + " given");
      l.hasOwnProperty(e) || (l[e] = []), l[e].push(t)
    }

    !function f() {
      for (var e in n = n || {}, w) w.hasOwnProperty(e) && (a[e] = w[e]);
      {
        if ("object" !== kt(n)) throw Error("Converter expects the passed parameter to be an object, but " + kt(n) + " was passed instead.");
        for (var t in n) n.hasOwnProperty(t) && (a[t] = n[t])
      }
      a.extensions && L.helper.forEach(a.extensions, c)
    }(), this._dispatch = function (e, t, n, r) {
      if (l.hasOwnProperty(e)) for (var a = 0; a < l[e].length; ++a) {
        var o = l[e][a](e, t, this, n, r);
        o && void 0 !== o && (t = o)
      }
      return t
    }, this.listen = function (e, t) {
      return d(e, t), this
    }, this.makeHtml = function (t) {
      if (!t) return t;
      var n = {
        gHtmlBlocks: [],
        gHtmlMdBlocks: [],
        gHtmlSpans: [],
        gUrls: {},
        gTitles: {},
        gDimensions: {},
        gListLevel: 0,
        hashLinkCounts: {},
        langExtensions: i,
        outputModifiers: s,
        converter: this,
        ghCodeBlocks: [],
        metadata: {parsed: {}, raw: "", format: ""}
      };
      return t = (t = (t = (t = (t = t.replace(/\xa8/g, "\xa8T")).replace(/\$/g, "\xa8D")).replace(/\r\n/g, "\n")).replace(/\r/g, "\n")).replace(/\u00A0/g, "&nbsp;"), a.smartIndentationFix && (t = function r(e) {
        var t = e.match(/^\s*/)[0].length, n = new RegExp("^\\s{0," + t + "}", "gm");
        return e.replace(n, "")
      }(t)), t = "\n\n" + t + "\n\n", t = (t = L.subParser("detab")(t, a, n)).replace(/^[ \t]+$/gm, ""), L.helper.forEach(i, function (e) {
        t = L.subParser("runExtension")(e, t, a, n)
      }), t = L.subParser("metadata")(t, a, n), t = L.subParser("hashPreCodeTags")(t, a, n), t = L.subParser("githubCodeBlocks")(t, a, n), t = L.subParser("hashHTMLBlocks")(t, a, n), t = L.subParser("hashCodeTags")(t, a, n), t = L.subParser("stripLinkDefinitions")(t, a, n), t = L.subParser("blockGamut")(t, a, n), t = L.subParser("unhashHTMLSpans")(t, a, n), t = (t = (t = L.subParser("unescapeSpecialChars")(t, a, n)).replace(/\xa8D/g, "$$")).replace(/\xa8T/g, "\xa8"), t = L.subParser("completeHTMLDocument")(t, a, n), L.helper.forEach(s, function (e) {
        t = L.subParser("runExtension")(e, t, a, n)
      }), o = n.metadata, t
    }, this.makeMarkdown = this.makeMd = function (e, t) {
      if (e = (e = (e = e.replace(/\r\n/g, "\n")).replace(/\r/g, "\n")).replace(/>[ \t]+</, ">\xa8NBSP;<"), !t) {
        if (!window || !window.document) throw new Error("HTMLParser is undefined. If in a webworker or nodejs environment, you need to provide a WHATWG DOM and HTML such as JSDOM");
        t = window.document
      }
      var n = t.createElement("div");
      n.innerHTML = e;
      var r = {
        preList: function c(e) {
          for (var t = e.querySelectorAll("pre"), n = [], r = 0; r < t.length; ++r) if (1 === t[r].childElementCount && "code" === t[r].firstChild.tagName.toLowerCase()) {
            var a = t[r].firstChild.innerHTML.trim(), o = t[r].firstChild.getAttribute("data-language") || "";
            if ("" === o) for (var i = t[r].firstChild.className.split(" "), s = 0; s < i.length; ++s) {
              var l = i[s].match(/^language-(.+)$/);
              if (null !== l) {
                o = l[1];
                break
              }
            }
            a = L.helper.unescapeHTMLEntities(a), n.push(a), t[r].outerHTML = '<precode language="' + o + '" precodenum="' + r.toString() + '"></precode>'
          } else n.push(t[r].innerHTML), t[r].innerHTML = "", t[r].setAttribute("prenum", r.toString());
          return n
        }(n)
      };
      !function s(e) {
        for (var t = 0; t < e.childNodes.length; ++t) {
          var n = e.childNodes[t];
          3 === n.nodeType ? /\S/.test(n.nodeValue) ? (n.nodeValue = n.nodeValue.split("\n").join(" "), n.nodeValue = n.nodeValue.replace(/(\s)+/g, "$1")) : (e.removeChild(n), --t) : 1 === n.nodeType && s(n)
        }
      }(n);
      for (var a = n.childNodes, o = "", i = 0; i < a.length; i++) o += L.subParser("makeMarkdown.node")(a[i], r);
      return o
    }, this.setOption = function (e, t) {
      a[e] = t
    }, this.getOption = function (e) {
      return a[e]
    }, this.getOptions = function () {
      return a
    }, this.addExtension = function (e, t) {
      c(e, t = t || null)
    }, this.useExtension = function (e) {
      c(e)
    }, this.setFlavor = function (e) {
      if (!T.hasOwnProperty(e)) throw Error(e + " flavor was not found");
      var t = T[e];
      for (var n in r = e, t) t.hasOwnProperty(n) && (a[n] = t[n])
    }, this.getFlavor = function () {
      return r
    }, this.removeExtension = function (e) {
      L.helper.isArray(e) || (e = [e]);
      for (var t = 0; t < e.length; ++t) {
        for (var n = e[t], r = 0; r < i.length; ++r) i[r] === n && i[r].splice(r, 1);
        for (; 0 < s.length; ++r) s[0] === n && s[0].splice(r, 1)
      }
    }, this.getAllExtensions = function () {
      return {language: i, output: s}
    }, this.getMetadata = function (e) {
      return e ? o.raw : o.parsed
    }, this.getMetadataFormat = function () {
      return o.format
    }, this._setMetadataPair = function (e, t) {
      o.parsed[e] = t
    }, this._setMetadataFormat = function (e) {
      o.format = e
    }, this._setMetadataRaw = function (e) {
      o.raw = e
    }
  }, L.subParser("anchors", function (e, l, c) {
    var d = function d(e, t, n, r, a, o, i) {
      if (L.helper.isUndefined(i) && (i = ""), n = n.toLowerCase(), -1 < e.search(/\(<?\s*>? ?(['"].*['"])?\)$/m)) r = ""; else if (!r) {
        if (n || (n = t.toLowerCase().replace(/ ?\n/g, " ")), r = "#" + n, L.helper.isUndefined(c.gUrls[n])) return e;
        r = c.gUrls[n], L.helper.isUndefined(c.gTitles[n]) || (i = c.gTitles[n])
      }
      var s = '<a href="' + (r = r.replace(L.helper.regexes.asteriskDashAndColon, L.helper.escapeCharactersCallback)) + '"';
      return "" !== i && null !== i && (s += ' title="' + (i = (i = i.replace(/"/g, "&quot;")).replace(L.helper.regexes.asteriskDashAndColon, L.helper.escapeCharactersCallback)) + '"'), l.openLinksInNewWindow && !/^#/.test(r) && (s += ' rel="noopener noreferrer" target="\xa8E95Eblank"'), s += ">" + t + "</a>"
    };
    return e = (e = (e = (e = (e = c.converter._dispatch("anchors.before", e, l, c)).replace(/\[((?:\[[^\]]*]|[^\[\]])*)] ?(?:\n *)?\[(.*?)]()()()()/g, d)).replace(/\[((?:\[[^\]]*]|[^\[\]])*)]()[ \t]*\([ \t]?<([^>]*)>(?:[ \t]*((["'])([^"]*?)\5))?[ \t]?\)/g, d)).replace(/\[((?:\[[^\]]*]|[^\[\]])*)]()[ \t]*\([ \t]?<?([\S]+?(?:\([\S]*?\)[\S]*?)?)>?(?:[ \t]*((["'])([^"]*?)\5))?[ \t]?\)/g, d)).replace(/\[([^\[\]]+)]()()()()()/g, d), l.ghMentions && (e = e.replace(/(^|\s)(\\)?(@([a-z\d]+(?:[a-z\d.-]+?[a-z\d]+)*))/gim, function (e, t, n, r, a) {
      if ("\\" === n) return t + r;
      if (!L.helper.isString(l.ghMentionsLink)) throw new Error("ghMentionsLink option must be a string");
      var o = l.ghMentionsLink.replace(/\{u}/g, a), i = "";
      return l.openLinksInNewWindow && (i = ' rel="noopener noreferrer" target="\xa8E95Eblank"'), t + '<a href="' + o + '"' + i + ">" + r + "</a>"
    })), e = c.converter._dispatch("anchors.after", e, l, c)
  });
  var R = /([*~_]+|\b)(((https?|ftp|dict):\/\/|www\.)[^'">\s]+?\.[^'">\s]+?)()(\1)?(?=\s|$)(?!["<>])/gi,
    M = /([*~_]+|\b)(((https?|ftp|dict):\/\/|www\.)[^'">\s]+\.[^'">\s]+?)([.!?,()\[\]])?(\1)?(?=\s|$)(?!["<>])/gi,
    O = /()<(((https?|ftp|dict):\/\/|www\.)[^'">\s]+)()>()/gi,
    N = /(^|\s)(?:mailto:)?([A-Za-z0-9!#$%&'*+-/=?^_`{|}~.]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)(?=$|\s)/gim,
    I = /<()(?:mailto:)?([-.\w]+@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)>/gi, D = function D(p) {
      return function (e, t, n, r, a, o, i) {
        var s = n = n.replace(L.helper.regexes.asteriskDashAndColon, L.helper.escapeCharactersCallback), l = "", c = "",
          d = t || "", f = i || "";
        return /^www\./i.test(n) && (n = n.replace(/^www\./i, "http://www.")), p.excludeTrailingPunctuationFromURLs && o && (l = o), p.openLinksInNewWindow && (c = ' rel="noopener noreferrer" target="\xa8E95Eblank"'), d + '<a href="' + n + '"' + c + ">" + s + "</a>" + l + f
      }
    }, B = function B(a, o) {
      return function (e, t, n) {
        var r = "mailto:";
        return t = t || "", n = L.subParser("unescapeSpecialChars")(n, a, o), a.encodeEmails ? (r = L.helper.encodeEmailAddress(r + n), n = L.helper.encodeEmailAddress(n)) : r += n, t + '<a href="' + r + '">' + n + "</a>"
      }
    };
  return L.subParser("autoLinks", function (e, t, n) {
    return e = (e = (e = n.converter._dispatch("autoLinks.before", e, t, n)).replace(O, D(t))).replace(I, B(t, n)), e = n.converter._dispatch("autoLinks.after", e, t, n)
  }), L.subParser("simplifiedAutoLinks", function (e, t, n) {
    return t.simplifiedAutoLink ? (e = n.converter._dispatch("simplifiedAutoLinks.before", e, t, n), e = (e = t.excludeTrailingPunctuationFromURLs ? e.replace(M, D(t)) : e.replace(R, D(t))).replace(N, B(t, n)), e = n.converter._dispatch("simplifiedAutoLinks.after", e, t, n)) : e
  }), L.subParser("blockGamut", function (e, t, n) {
    return e = n.converter._dispatch("blockGamut.before", e, t, n), e = L.subParser("blockQuotes")(e, t, n), e = L.subParser("headers")(e, t, n), e = L.subParser("horizontalRule")(e, t, n), e = L.subParser("lists")(e, t, n), e = L.subParser("codeBlocks")(e, t, n), e = L.subParser("tables")(e, t, n), e = L.subParser("hashHTMLBlocks")(e, t, n), e = L.subParser("paragraphs")(e, t, n), e = n.converter._dispatch("blockGamut.after", e, t, n)
  }), L.subParser("blockQuotes", function (e, t, n) {
    e = n.converter._dispatch("blockQuotes.before", e, t, n), e += "\n\n";
    var r = /(^ {0,3}>[ \t]?.+\n(.+\n)*\n*)+/gm;
    return t.splitAdjacentBlockquotes && (r = /^ {0,3}>[\s\S]*?(?:\n\n)/gm), e = e.replace(r, function (e) {
      return e = (e = (e = e.replace(/^[ \t]*>[ \t]?/gm, "")).replace(/\xa80/g, "")).replace(/^[ \t]+$/gm, ""), e = L.subParser("githubCodeBlocks")(e, t, n), e = (e = (e = L.subParser("blockGamut")(e, t, n)).replace(/(^|\n)/g, "$1  ")).replace(/(\s*<pre>[^\r]+?<\/pre>)/gm, function (e, t) {
        var n = t;
        return n = (n = n.replace(/^ {2}/gm, "\xa80")).replace(/\xa80/g, "")
      }), L.subParser("hashBlock")("<blockquote>\n" + e + "\n</blockquote>", t, n)
    }), e = n.converter._dispatch("blockQuotes.after", e, t, n)
  }), L.subParser("codeBlocks", function (e, i, s) {
    e = s.converter._dispatch("codeBlocks.before", e, i, s);
    return e = (e = (e += "\xa80").replace(/(?:\n\n|^)((?:(?:[ ]{4}|\t).*\n+)+)(\n*[ ]{0,3}[^ \t\n]|(?=\xa80))/g, function (e, t, n) {
      var r = t, a = n, o = "\n";
      return r = L.subParser("outdent")(r, i, s), r = L.subParser("encodeCode")(r, i, s), r = (r = (r = L.subParser("detab")(r, i, s)).replace(/^\n+/g, "")).replace(/\n+$/g, ""), i.omitExtraWLInCodeBlocks && (o = ""), r = "<pre><code>" + r + o + "</code></pre>", L.subParser("hashBlock")(r, i, s) + a
    })).replace(/\xa80/, ""), e = s.converter._dispatch("codeBlocks.after", e, i, s)
  }), L.subParser("codeSpans", function (e, o, i) {
    return void 0 === (e = i.converter._dispatch("codeSpans.before", e, o, i)) && (e = ""), e = e.replace(/(^|[^\\])(`+)([^\r]*?[^`])\2(?!`)/gm, function (e, t, n, r) {
      var a = r;
      return a = (a = a.replace(/^([ \t]*)/g, "")).replace(/[ \t]*$/g, ""), a = t + "<code>" + (a = L.subParser("encodeCode")(a, o, i)) + "</code>", a = L.subParser("hashHTMLSpans")(a, o, i)
    }), e = i.converter._dispatch("codeSpans.after", e, o, i)
  }), L.subParser("completeHTMLDocument", function (e, t, n) {
    if (!t.completeHTMLDocument) return e;
    e = n.converter._dispatch("completeHTMLDocument.before", e, t, n);
    var r = "html", a = "<!DOCTYPE HTML>\n", o = "", i = '<meta charset="utf-8">\n', s = "", l = "";
    for (var c in "undefined" != typeof n.metadata.parsed.doctype && (a = "<!DOCTYPE " + n.metadata.parsed.doctype + ">\n", "html" !== (r = n.metadata.parsed.doctype.toString().toLowerCase()) && "html5" !== r || (i = '<meta charset="utf-8">')), n.metadata.parsed) if (n.metadata.parsed.hasOwnProperty(c)) switch (c.toLowerCase()) {
      case"doctype":
        break;
      case"title":
        o = "<title>" + n.metadata.parsed.title + "</title>\n";
        break;
      case"charset":
        i = "html" === r || "html5" === r ? '<meta charset="' + n.metadata.parsed.charset + '">\n' : '<meta name="charset" content="' + n.metadata.parsed.charset + '">\n';
        break;
      case"language":
      case"lang":
        s = ' lang="' + n.metadata.parsed[c] + '"', l += '<meta name="' + c + '" content="' + n.metadata.parsed[c] + '">\n';
        break;
      default:
        l += '<meta name="' + c + '" content="' + n.metadata.parsed[c] + '">\n'
    }
    return e = a + "<html" + s + ">\n<head>\n" + o + i + l + "</head>\n<body>\n" + e.trim() + "\n</body>\n</html>", e = n.converter._dispatch("completeHTMLDocument.after", e, t, n)
  }), L.subParser("detab", function (e, t, n) {
    return e = (e = (e = (e = (e = (e = n.converter._dispatch("detab.before", e, t, n)).replace(/\t(?=\t)/g, "    ")).replace(/\t/g, "\xa8A\xa8B")).replace(/\xa8B(.+?)\xa8A/g, function (e, t) {
      for (var n = t, r = 4 - n.length % 4, a = 0; a < r; a++) n += " ";
      return n
    })).replace(/\xa8A/g, "    ")).replace(/\xa8B/g, ""), e = n.converter._dispatch("detab.after", e, t, n)
  }), L.subParser("ellipsis", function (e, t, n) {
    return e = (e = n.converter._dispatch("ellipsis.before", e, t, n)).replace(/\.\.\./g, "\u2026"), e = n.converter._dispatch("ellipsis.after", e, t, n)
  }), L.subParser("emoji", function (e, t, n) {
    if (!t.emoji) return e;
    return e = (e = n.converter._dispatch("emoji.before", e, t, n)).replace(/:([\S]+?):/g, function (e, t) {
      return L.helper.emojis.hasOwnProperty(t) ? L.helper.emojis[t] : e
    }), e = n.converter._dispatch("emoji.after", e, t, n)
  }), L.subParser("encodeAmpsAndAngles", function (e, t, n) {
    return e = (e = (e = (e = (e = n.converter._dispatch("encodeAmpsAndAngles.before", e, t, n)).replace(/&(?!#?[xX]?(?:[0-9a-fA-F]+|\w+);)/g, "&amp;")).replace(/<(?![a-z\/?$!])/gi, "&lt;")).replace(/</g, "&lt;")).replace(/>/g, "&gt;"), e = n.converter._dispatch("encodeAmpsAndAngles.after", e, t, n)
  }), L.subParser("encodeBackslashEscapes", function (e, t, n) {
    return e = (e = (e = n.converter._dispatch("encodeBackslashEscapes.before", e, t, n)).replace(/\\(\\)/g, L.helper.escapeCharactersCallback)).replace(/\\([`*_{}\[\]()>#+.!~=|-])/g, L.helper.escapeCharactersCallback), e = n.converter._dispatch("encodeBackslashEscapes.after", e, t, n)
  }), L.subParser("encodeCode", function (e, t, n) {
    return e = (e = n.converter._dispatch("encodeCode.before", e, t, n)).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/([*_{}\[\]\\=~-])/g, L.helper.escapeCharactersCallback), e = n.converter._dispatch("encodeCode.after", e, t, n)
  }), L.subParser("escapeSpecialCharsWithinTagAttributes", function (e, t, n) {
    return e = (e = (e = n.converter._dispatch("escapeSpecialCharsWithinTagAttributes.before", e, t, n)).replace(/<\/?[a-z\d_:-]+(?:[\s]+[\s\S]+?)?>/gi, function (e) {
      return e.replace(/(.)<\/?code>(?=.)/g, "$1`").replace(/([\\`*_~=|])/g, L.helper.escapeCharactersCallback)
    })).replace(/<!(--(?:(?:[^>-]|-[^>])(?:[^-]|-[^-])*)--)>/gi, function (e) {
      return e.replace(/([\\`*_~=|])/g, L.helper.escapeCharactersCallback)
    }), e = n.converter._dispatch("escapeSpecialCharsWithinTagAttributes.after", e, t, n)
  }), L.subParser("githubCodeBlocks", function (e, o, i) {
    return o.ghCodeBlocks ? (e = i.converter._dispatch("githubCodeBlocks.before", e, o, i), e = (e = (e += "\xa80").replace(/(?:^|\n)(?: {0,3})(```+|~~~+)(?: *)([^\s`~]*)\n([\s\S]*?)\n(?: {0,3})\1/g, function (e, t, n, r) {
      var a = o.omitExtraWLInCodeBlocks ? "" : "\n";
      return r = L.subParser("encodeCode")(r, o, i), r = "<pre><code" + (n ? ' class="' + n + " language-" + n + '"' : "") + ">" + (r = (r = (r = L.subParser("detab")(r, o, i)).replace(/^\n+/g, "")).replace(/\n+$/g, "")) + a + "</code></pre>", r = L.subParser("hashBlock")(r, o, i), "\n\n\xa8G" + (i.ghCodeBlocks.push({
        text: e,
        codeblock: r
      }) - 1) + "G\n\n"
    })).replace(/\xa80/, ""), i.converter._dispatch("githubCodeBlocks.after", e, o, i)) : e
  }), L.subParser("hashBlock", function (e, t, n) {
    return e = (e = n.converter._dispatch("hashBlock.before", e, t, n)).replace(/(^\n+|\n+$)/g, ""), e = "\n\n\xa8K" + (n.gHtmlBlocks.push(e) - 1) + "K\n\n", e = n.converter._dispatch("hashBlock.after", e, t, n)
  }), L.subParser("hashCodeTags", function (e, o, i) {
    e = i.converter._dispatch("hashCodeTags.before", e, o, i);
    var s = function s(e, t, n, r) {
      var a = n + L.subParser("encodeCode")(t, o, i) + r;
      return "\xa8C" + (i.gHtmlSpans.push(a) - 1) + "C"
    };
    return e = L.helper.replaceRecursiveRegExp(e, s, "<code\\b[^>]*>", "</code>", "gim"), e = i.converter._dispatch("hashCodeTags.after", e, o, i)
  }), L.subParser("hashElement", function (e, t, r) {
    return function (e, t) {
      var n = t;
      return n = (n = (n = n.replace(/\n\n/g, "\n")).replace(/^\n/, "")).replace(/\n+$/g, ""), n = "\n\n\xa8K" + (r.gHtmlBlocks.push(n) - 1) + "K\n\n"
    }
  }), L.subParser("hashHTMLBlocks", function (e, t, o) {
    e = o.converter._dispatch("hashHTMLBlocks.before", e, t, o);
    var n = ["pre", "div", "h1", "h2", "h3", "h4", "h5", "h6", "blockquote", "table", "dl", "ol", "ul", "script", "noscript", "form", "fieldset", "iframe", "math", "style", "section", "header", "footer", "nav", "article", "aside", "address", "audio", "canvas", "figure", "hgroup", "output", "video", "p"],
      i = function i(e, t, n, r) {
        var a = e;
        return -1 !== n.search(/\bmarkdown\b/) && (a = n + o.converter.makeHtml(t) + r), "\n\n\xa8K" + (o.gHtmlBlocks.push(a) - 1) + "K\n\n"
      };
    t.backslashEscapesHTMLTags && (e = e.replace(/\\<(\/?[^>]+?)>/g, function (e, t) {
      return "&lt;" + t + "&gt;"
    }));
    for (var r = 0; r < n.length; ++r) for (var a, s = new RegExp("^ {0,3}(<" + n[r] + "\\b[^>]*>)", "im"), l = "<" + n[r] + "\\b[^>]*>", c = "</" + n[r] + ">"; -1 !== (a = L.helper.regexIndexOf(e, s));) {
      var d = L.helper.splitAtIndex(e, a), f = L.helper.replaceRecursiveRegExp(d[1], i, l, c, "im");
      if (f === d[1]) break;
      e = d[0].concat(f)
    }
    return e = e.replace(/(\n {0,3}(<(hr)\b([^<>])*?\/?>)[ \t]*(?=\n{2,}))/g, L.subParser("hashElement")(e, t, o)), e = (e = L.helper.replaceRecursiveRegExp(e, function (e) {
      return "\n\n\xa8K" + (o.gHtmlBlocks.push(e) - 1) + "K\n\n"
    }, "^ {0,3}\x3c!--", "--\x3e", "gm")).replace(/(?:\n\n)( {0,3}(?:<([?%])[^\r]*?\2>)[ \t]*(?=\n{2,}))/g, L.subParser("hashElement")(e, t, o)), e = o.converter._dispatch("hashHTMLBlocks.after", e, t, o)
  }), L.subParser("hashHTMLSpans", function (e, t, n) {
    function r(e) {
      return "\xa8C" + (n.gHtmlSpans.push(e) - 1) + "C"
    }

    return e = (e = (e = (e = (e = n.converter._dispatch("hashHTMLSpans.before", e, t, n)).replace(/<[^>]+?\/>/gi, function (e) {
      return r(e)
    })).replace(/<([^>]+?)>[\s\S]*?<\/\1>/g, function (e) {
      return r(e)
    })).replace(/<([^>]+?)\s[^>]+?>[\s\S]*?<\/\1>/g, function (e) {
      return r(e)
    })).replace(/<[^>]+?>/gi, function (e) {
      return r(e)
    }), e = n.converter._dispatch("hashHTMLSpans.after", e, t, n)
  }), L.subParser("unhashHTMLSpans", function (e, t, n) {
    e = n.converter._dispatch("unhashHTMLSpans.before", e, t, n);
    for (var r = 0; r < n.gHtmlSpans.length; ++r) {
      for (var a = n.gHtmlSpans[r], o = 0; /\xa8C(\d+)C/.test(a);) {
        var i = RegExp.$1;
        if (a = a.replace("\xa8C" + i + "C", n.gHtmlSpans[i]), 10 === o) break;
        ++o
      }
      e = e.replace("\xa8C" + r + "C", a)
    }
    return e = n.converter._dispatch("unhashHTMLSpans.after", e, t, n)
  }), L.subParser("hashPreCodeTags", function (e, o, i) {
    e = i.converter._dispatch("hashPreCodeTags.before", e, o, i);
    var s = function s(e, t, n, r) {
      var a = n + L.subParser("encodeCode")(t, o, i) + r;
      return "\n\n\xa8G" + (i.ghCodeBlocks.push({text: e, codeblock: a}) - 1) + "G\n\n"
    };
    return e = L.helper.replaceRecursiveRegExp(e, s, "^ {0,3}<pre\\b[^>]*>\\s*<code\\b[^>]*>", "^ {0,3}</code>\\s*</pre>", "gim"), e = i.converter._dispatch("hashPreCodeTags.after", e, o, i)
  }), L.subParser("headers", function (e, l, c) {
    e = c.converter._dispatch("headers.before", e, l, c);
    var d = isNaN(parseInt(l.headerLevelStart)) ? 1 : parseInt(l.headerLevelStart),
      t = l.smoothLivePreview ? /^(.+)[ \t]*\n={2,}[ \t]*\n+/gm : /^(.+)[ \t]*\n=+[ \t]*\n+/gm,
      n = l.smoothLivePreview ? /^(.+)[ \t]*\n-{2,}[ \t]*\n+/gm : /^(.+)[ \t]*\n-+[ \t]*\n+/gm;
    e = (e = e.replace(t, function (e, t) {
      var n = L.subParser("spanGamut")(t, l, c), r = l.noHeaderId ? "" : ' id="' + f(t) + '"',
        a = "<h" + d + r + ">" + n + "</h" + d + ">";
      return L.subParser("hashBlock")(a, l, c)
    })).replace(n, function (e, t) {
      var n = L.subParser("spanGamut")(t, l, c), r = l.noHeaderId ? "" : ' id="' + f(t) + '"', a = d + 1,
        o = "<h" + a + r + ">" + n + "</h" + a + ">";
      return L.subParser("hashBlock")(o, l, c)
    });
    var r = l.requireSpaceBeforeHeadingText ? /^(#{1,6})[ \t]+(.+?)[ \t]*#*\n+/gm : /^(#{1,6})[ \t]*(.+?)[ \t]*#*\n+/gm;

    function f(e) {
      var t, n;
      if (l.customizedHeaderId) {
        var r = e.match(/\{([^{]+?)}\s*$/);
        r && r[1] && (e = r[1])
      }
      return t = e, n = L.helper.isString(l.prefixHeaderId) ? l.prefixHeaderId : !0 === l.prefixHeaderId ? "section-" : "", l.rawPrefixHeaderId || (t = n + t), t = l.ghCompatibleHeaderId ? t.replace(/ /g, "-").replace(/&amp;/g, "").replace(/\xa8T/g, "").replace(/\xa8D/g, "").replace(/[&+$,\/:;=?@"#{}|^\xa8~\[\]`\\*)(%.!'<>]/g, "").toLowerCase() : l.rawHeaderId ? t.replace(/ /g, "-").replace(/&amp;/g, "&").replace(/\xa8T/g, "\xa8").replace(/\xa8D/g, "$").replace(/["']/g, "-").toLowerCase() : t.replace(/[^\w]/g, "").toLowerCase(), l.rawPrefixHeaderId && (t = n + t), c.hashLinkCounts[t] ? t = t + "-" + c.hashLinkCounts[t]++ : c.hashLinkCounts[t] = 1, t
    }

    return e = e.replace(r, function (e, t, n) {
      var r = n;
      l.customizedHeaderId && (r = n.replace(/\s?\{([^{]+?)}\s*$/, ""));
      var a = L.subParser("spanGamut")(r, l, c), o = l.noHeaderId ? "" : ' id="' + f(n) + '"', i = d - 1 + t.length,
        s = "<h" + i + o + ">" + a + "</h" + i + ">";
      return L.subParser("hashBlock")(s, l, c)
    }), e = c.converter._dispatch("headers.after", e, l, c)
  }), L.subParser("horizontalRule", function (e, t, n) {
    e = n.converter._dispatch("horizontalRule.before", e, t, n);
    var r = L.subParser("hashBlock")("<hr />", t, n);
    return e = (e = (e = e.replace(/^ {0,2}( ?-){3,}[ \t]*$/gm, r)).replace(/^ {0,2}( ?\*){3,}[ \t]*$/gm, r)).replace(/^ {0,2}( ?_){3,}[ \t]*$/gm, r), e = n.converter._dispatch("horizontalRule.after", e, t, n)
  }), L.subParser("images", function (e, t, p) {
    function l(e, t, n, r, a, o, i, s) {
      var l = p.gUrls, c = p.gTitles, d = p.gDimensions;
      if (n = n.toLowerCase(), s || (s = ""), -1 < e.search(/\(<?\s*>? ?(['"].*['"])?\)$/m)) r = ""; else if ("" === r || null === r) {
        if ("" !== n && null !== n || (n = t.toLowerCase().replace(/ ?\n/g, " ")), r = "#" + n, L.helper.isUndefined(l[n])) return e;
        r = l[n], L.helper.isUndefined(c[n]) || (s = c[n]), L.helper.isUndefined(d[n]) || (a = d[n].width, o = d[n].height)
      }
      t = t.replace(/"/g, "&quot;").replace(L.helper.regexes.asteriskDashAndColon, L.helper.escapeCharactersCallback);
      var f = '<img src="' + (r = r.replace(L.helper.regexes.asteriskDashAndColon, L.helper.escapeCharactersCallback)) + '" alt="' + t + '"';
      return s && L.helper.isString(s) && (f += ' title="' + (s = s.replace(/"/g, "&quot;").replace(L.helper.regexes.asteriskDashAndColon, L.helper.escapeCharactersCallback)) + '"'), a && o && (f += ' width="' + (a = "*" === a ? "auto" : a) + '"', f += ' height="' + (o = "*" === o ? "auto" : o) + '"'), f += " />"
    }

    return e = (e = (e = (e = (e = (e = p.converter._dispatch("images.before", e, t, p)).replace(/!\[([^\]]*?)] ?(?:\n *)?\[([\s\S]*?)]()()()()()/g, l)).replace(/!\[([^\]]*?)][ \t]*()\([ \t]?<?(data:.+?\/.+?;base64,[A-Za-z0-9+/=\n]+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(["'])([^"]*?)\6)?[ \t]?\)/g, function c(e, t, n, r, a, o, i, s) {
      return l(e, t, n, r = r.replace(/\s/g, ""), a, o, 0, s)
    })).replace(/!\[([^\]]*?)][ \t]*()\([ \t]?<([^>]*)>(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(?:(["'])([^"]*?)\6))?[ \t]?\)/g, l)).replace(/!\[([^\]]*?)][ \t]*()\([ \t]?<?([\S]+?(?:\([\S]*?\)[\S]*?)?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*(?:(["'])([^"]*?)\6)?[ \t]?\)/g, l)).replace(/!\[([^\[\]]+)]()()()()()/g, l), e = p.converter._dispatch("images.after", e, t, p)
  }), L.subParser("italicsAndBold", function (e, t, n) {
    function r(e, t, n) {
      return t + e + n
    }

    return e = n.converter._dispatch("italicsAndBold.before", e, t, n), e = t.literalMidWordUnderscores ? (e = (e = e.replace(/\b___(\S[\s\S]*?)___\b/g, function (e, t) {
      return r(t, "<strong><em>", "</em></strong>")
    })).replace(/\b__(\S[\s\S]*?)__\b/g, function (e, t) {
      return r(t, "<strong>", "</strong>")
    })).replace(/\b_(\S[\s\S]*?)_\b/g, function (e, t) {
      return r(t, "<em>", "</em>")
    }) : (e = (e = e.replace(/___(\S[\s\S]*?)___/g, function (e, t) {
      return /\S$/.test(t) ? r(t, "<strong><em>", "</em></strong>") : e
    })).replace(/__(\S[\s\S]*?)__/g, function (e, t) {
      return /\S$/.test(t) ? r(t, "<strong>", "</strong>") : e
    })).replace(/_([^\s_][\s\S]*?)_/g, function (e, t) {
      return /\S$/.test(t) ? r(t, "<em>", "</em>") : e
    }), e = t.literalMidWordAsterisks ? (e = (e = e.replace(/([^*]|^)\B\*\*\*(\S[\s\S]*?)\*\*\*\B(?!\*)/g, function (e, t, n) {
      return r(n, t + "<strong><em>", "</em></strong>")
    })).replace(/([^*]|^)\B\*\*(\S[\s\S]*?)\*\*\B(?!\*)/g, function (e, t, n) {
      return r(n, t + "<strong>", "</strong>")
    })).replace(/([^*]|^)\B\*(\S[\s\S]*?)\*\B(?!\*)/g, function (e, t, n) {
      return r(n, t + "<em>", "</em>")
    }) : (e = (e = e.replace(/\*\*\*(\S[\s\S]*?)\*\*\*/g, function (e, t) {
      return /\S$/.test(t) ? r(t, "<strong><em>", "</em></strong>") : e
    })).replace(/\*\*(\S[\s\S]*?)\*\*/g, function (e, t) {
      return /\S$/.test(t) ? r(t, "<strong>", "</strong>") : e
    })).replace(/\*([^\s*][\s\S]*?)\*/g, function (e, t) {
      return /\S$/.test(t) ? r(t, "<em>", "</em>") : e
    }), e = n.converter._dispatch("italicsAndBold.after", e, t, n)
  }), L.subParser("lists", function (e, p, d) {
    function u(e, t) {
      d.gListLevel++, e = e.replace(/\n{2,}$/, "\n");
      var n = /(\n)?(^ {0,3})([*+-]|\d+[.])[ \t]+((\[(x|X| )?])?[ \t]*[^\r]+?(\n{1,2}))(?=\n*(\xa80| {0,3}([*+-]|\d+[.])[ \t]+))/gm,
        c = /\n[ \t]*\n(?!\xa80)/.test(e += "\xa80");
      return p.disableForced4SpacesIndentedSublists && (n = /(\n)?(^ {0,3})([*+-]|\d+[.])[ \t]+((\[(x|X| )?])?[ \t]*[^\r]+?(\n{1,2}))(?=\n*(\xa80|\2([*+-]|\d+[.])[ \t]+))/gm), e = (e = e.replace(n, function (e, t, n, r, a, o, i) {
        i = i && "" !== i.trim();
        var s = L.subParser("outdent")(a, p, d), l = "";
        return o && p.tasklists && (l = ' class="task-list-item" style="list-style-type: none;"', s = s.replace(/^[ \t]*\[(x|X| )?]/m, function () {
          var e = '<input type="checkbox" disabled style="margin: 0px 0.35em 0.25em -1.6em; vertical-align: middle;"';
          return i && (e += " checked"), e += ">"
        })), s = s.replace(/^([-*+]|\d\.)[ \t]+[\S\n ]*/g, function (e) {
          return "\xa8A" + e
        }), s = "<li" + l + ">" + (s = (s = t || -1 < s.search(/\n{2,}/) ? (s = L.subParser("githubCodeBlocks")(s, p, d), L.subParser("blockGamut")(s, p, d)) : (s = (s = L.subParser("lists")(s, p, d)).replace(/\n$/, ""), s = (s = L.subParser("hashHTMLBlocks")(s, p, d)).replace(/\n\n+/g, "\n\n"), c ? L.subParser("paragraphs")(s, p, d) : L.subParser("spanGamut")(s, p, d))).replace("\xa8A", "")) + "</li>\n"
      })).replace(/\xa80/g, ""), d.gListLevel--, t && (e = e.replace(/\s+$/, "")), e
    }

    function h(e, t) {
      if ("ol" === t) {
        var n = e.match(/^ *(\d+)\./);
        if (n && "1" !== n[1]) return ' start="' + n[1] + '"'
      }
      return ""
    }

    function a(r, a, o) {
      var i = p.disableForced4SpacesIndentedSublists ? /^ ?\d+\.[ \t]/gm : /^ {0,3}\d+\.[ \t]/gm,
        s = p.disableForced4SpacesIndentedSublists ? /^ ?[*+-][ \t]/gm : /^ {0,3}[*+-][ \t]/gm, l = "ul" === a ? i : s,
        c = "",
        d = "ul" === a ? " style='list-style: disc !important;padding: 0px 0px 0px 40px !important;'" : " style='list-style: decimal !important;padding: 0px 0px 0px 40px !important;'";
      if (-1 !== r.search(l)) !function f(e) {
        var t = e.search(l), n = h(r, a);
        -1 !== t ? (c += "\n\n<" + a + d + n + ">\n" + u(e.slice(0, t), !!o) + "</" + a + ">\n", l = "ul" === (a = "ul" === a ? "ol" : "ul") ? i : s, f(e.slice(t))) : c += "\n\n<" + a + d + n + ">\n" + u(e, !!o) + "</" + a + ">\n"
      }(r); else {
        var e = h(r, a);
        c = "\n\n<" + a + d + e + ">\n" + u(r, !!o) + "</" + a + ">\n"
      }
      return c
    }

    return e = d.converter._dispatch("lists.before", e, p, d), e += "\xa80", e = (e = d.gListLevel ? e.replace(/^(( {0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(\xa80|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm, function (e, t, n) {
      return a(t, -1 < n.search(/[*+-]/g) ? "ul" : "ol", !0)
    }) : e.replace(/(\n\n|^\n?)(( {0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(\xa80|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm, function (e, t, n, r) {
      return a(n, -1 < r.search(/[*+-]/g) ? "ul" : "ol", !1)
    })).replace(/\xa80/, ""), e = d.converter._dispatch("lists.after", e, p, d)
  }), L.subParser("metadata", function (e, t, r) {
    if (!t.metadata) return e;

    function a(e) {
      (e = (e = (r.metadata.raw = e).replace(/&/g, "&amp;").replace(/"/g, "&quot;")).replace(/\n {4}/g, " ")).replace(/^([\S ]+): +([\s\S]+?)$/gm, function (e, t, n) {
        return r.metadata.parsed[t] = n, ""
      })
    }

    return e = (e = (e = (e = r.converter._dispatch("metadata.before", e, t, r)).replace(/^\s*\xab\xab\xab+(\S*?)\n([\s\S]+?)\n\xbb\xbb\xbb+\n/, function (e, t, n) {
      return a(n), "\xa8M"
    })).replace(/^\s*---+(\S*?)\n([\s\S]+?)\n---+\n/, function (e, t, n) {
      return t && (r.metadata.format = t), a(n), "\xa8M"
    })).replace(/\xa8M/g, ""), e = r.converter._dispatch("metadata.after", e, t, r)
  }), L.subParser("outdent", function (e, t, n) {
    return e = (e = (e = n.converter._dispatch("outdent.before", e, t, n)).replace(/^(\t|[ ]{1,4})/gm, "\xa80")).replace(/\xa80/g, ""), e = n.converter._dispatch("outdent.after", e, t, n)
  }), L.subParser("paragraphs", function (e, t, n) {
    for (var r = (e = (e = (e = n.converter._dispatch("paragraphs.before", e, t, n)).replace(/^\n+/g, "")).replace(/\n+$/g, "")).split(/\n{2,}/g), a = [], o = r.length, i = 0; i < o; i++) {
      var s = r[i];
      0 <= s.search(/\xa8(K|G)(\d+)\1/g) ? a.push(s) : 0 <= s.search(/\S/) && (s = (s = L.subParser("spanGamut")(s, t, n)).replace(/^([ \t]*)/g, "<p>"), s += "</p>", a.push(s))
    }
    for (o = a.length, i = 0; i < o; i++) {
      for (var l = "", c = a[i], d = !1; /\xa8(K|G)(\d+)\1/.test(c);) {
        var f = RegExp.$1, p = RegExp.$2;
        l = (l = "K" === f ? n.gHtmlBlocks[p] : d ? L.subParser("encodeCode")(n.ghCodeBlocks[p].text, t, n) : n.ghCodeBlocks[p].codeblock).replace(/\$/g, "$$$$"), c = c.replace(/(\n\n)?\xa8(K|G)\d+\2(\n\n)?/, l), /^<pre\b[^>]*>\s*<code\b[^>]*>/.test(c) && (d = !0)
      }
      a[i] = c
    }
    return e = (e = (e = a.join("\n")).replace(/^\n+/g, "")).replace(/\n+$/g, ""), n.converter._dispatch("paragraphs.after", e, t, n)
  }), L.subParser("runExtension", function (e, t, n, r) {
    if (e.filter) t = e.filter(t, r.converter, n); else if (e.regex) {
      var a = e.regex;
      a instanceof RegExp || (a = new RegExp(a, "g")), t = t.replace(a, e.replace)
    }
    return t
  }), L.subParser("spanGamut", function (e, t, n) {
    return e = n.converter._dispatch("spanGamut.before", e, t, n), e = L.subParser("codeSpans")(e, t, n), e = L.subParser("escapeSpecialCharsWithinTagAttributes")(e, t, n), e = L.subParser("encodeBackslashEscapes")(e, t, n), e = L.subParser("images")(e, t, n), e = L.subParser("anchors")(e, t, n), e = L.subParser("autoLinks")(e, t, n), e = L.subParser("simplifiedAutoLinks")(e, t, n), e = L.subParser("emoji")(e, t, n), e = L.subParser("underline")(e, t, n), e = L.subParser("italicsAndBold")(e, t, n), e = L.subParser("strikethrough")(e, t, n), e = L.subParser("ellipsis")(e, t, n), e = L.subParser("hashHTMLSpans")(e, t, n), e = L.subParser("encodeAmpsAndAngles")(e, t, n), t.simpleLineBreaks ? /\n\n\xa8K/.test(e) || (e = e.replace(/\n+/g, "<br />\n")) : e = e.replace(/  +\n/g, "<br />\n"), e = n.converter._dispatch("spanGamut.after", e, t, n)
  }), L.subParser("strikethrough", function (e, r, a) {
    return r.strikethrough && (e = (e = a.converter._dispatch("strikethrough.before", e, r, a)).replace(/(?:~){2}([\s\S]+?)(?:~){2}/g, function (e, t) {
      return function n(e) {
        return r.simplifiedAutoLink && (e = L.subParser("simplifiedAutoLinks")(e, r, a)), "<del>" + e + "</del>"
      }(t)
    }), e = a.converter._dispatch("strikethrough.after", e, r, a)), e
  }), L.subParser("stripLinkDefinitions", function (e, s, l) {
    var c = function c(e, t, n, r, a, o, i) {
      return t = t.toLowerCase(), n.match(/^data:.+?\/.+?;base64,/) ? l.gUrls[t] = n.replace(/\s/g, "") : l.gUrls[t] = L.subParser("encodeAmpsAndAngles")(n, s, l), o ? o + i : (i && (l.gTitles[t] = i.replace(/"|'/g, "&quot;")), s.parseImgDimensions && r && a && (l.gDimensions[t] = {
        width: r,
        height: a
      }), "")
    };
    return e = (e = (e = (e += "\xa80").replace(/^ {0,3}\[(.+)]:[ \t]*\n?[ \t]*<?(data:.+?\/.+?;base64,[A-Za-z0-9+/=\n]+?)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*\n?[ \t]*(?:(\n*)["|'(](.+?)["|')][ \t]*)?(?:\n\n|(?=\xa80)|(?=\n\[))/gm, c)).replace(/^ {0,3}\[(.+)]:[ \t]*\n?[ \t]*<?([^>\s]+)>?(?: =([*\d]+[A-Za-z%]{0,4})x([*\d]+[A-Za-z%]{0,4}))?[ \t]*\n?[ \t]*(?:(\n*)["|'(](.+?)["|')][ \t]*)?(?:\n+|(?=\xa80))/gm, c)).replace(/\xa80/, "")
  }), L.subParser("tables", function (e, v, b) {
    if (!v.tables) return e;

    function t(e) {
      var t, n = e.split("\n");
      for (t = 0; t < n.length; ++t) /^ {0,3}\|/.test(n[t]) && (n[t] = n[t].replace(/^ {0,3}\|/, "")), /\|[ \t]*$/.test(n[t]) && (n[t] = n[t].replace(/\|[ \t]*$/, "")), n[t] = L.subParser("codeSpans")(n[t], v, b);
      var r, a, o, i, s, l = n[0].split("|").map(function (e) {
        return e.trim()
      }), c = n[1].split("|").map(function (e) {
        return e.trim()
      }), d = [], f = [], p = [], u = [];
      for (n.shift(), n.shift(), t = 0; t < n.length; ++t) "" !== n[t].trim() && d.push(n[t].split("|").map(function (e) {
        return e.trim()
      }));
      if (l.length < c.length) return e;
      for (t = 0; t < c.length; ++t) p.push((r = c[t], /^:[ \t]*--*$/.test(r) ? ' style="text-align:left;"' : /^--*[ \t]*:[ \t]*$/.test(r) ? ' style="text-align:right;"' : /^:[ \t]*--*[ \t]*:$/.test(r) ? ' style="text-align:center;"' : ""));
      for (t = 0; t < l.length; ++t) L.helper.isUndefined(p[t]) && (p[t] = ""), f.push((a = l[t], o = p[t], i = void 0, i = "", a = a.trim(), (v.tablesHeaderId || v.tableHeaderId) && (i = ' id="' + a.replace(/ /g, "_").toLowerCase() + '"'), "<th" + i + o + ">" + (a = L.subParser("spanGamut")(a, v, b)) + "</th>\n"));
      for (t = 0; t < d.length; ++t) {
        for (var h = [], g = 0; g < f.length; ++g) L.helper.isUndefined(d[t][g]), h.push((s = d[t][g], "<td" + p[g] + ">" + L.subParser("spanGamut")(s, v, b) + "</td>\n"));
        u.push(h)
      }
      return function m(e, t) {
        for (var n = "<table>\n<thead>\n<tr>\n", r = e.length, a = 0; a < r; ++a) n += e[a];
        for (n += "</tr>\n</thead>\n<tbody>\n", a = 0; a < t.length; ++a) {
          n += "<tr>\n";
          for (var o = 0; o < r; ++o) n += t[a][o];
          n += "</tr>\n"
        }
        return n += "</tbody>\n</table>\n"
      }(f, u)
    }

    return e = (e = (e = (e = b.converter._dispatch("tables.before", e, v, b)).replace(/\\(\|)/g, L.helper.escapeCharactersCallback)).replace(/^ {0,3}\|?.+\|.+\n {0,3}\|?[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*:?[ \t]*(?:[-=]){2,}[\s\S]+?(?:\n\n|\xa80)/gm, t)).replace(/^ {0,3}\|.+\|[ \t]*\n {0,3}\|[ \t]*:?[ \t]*(?:[-=]){2,}[ \t]*:?[ \t]*\|[ \t]*\n( {0,3}\|.+\|[ \t]*\n)*(?:\n|\xa80)/gm, t), e = b.converter._dispatch("tables.after", e, v, b)
  }), L.subParser("underline", function (e, t, n) {
    return t.underline ? (e = n.converter._dispatch("underline.before", e, t, n), e = (e = t.literalMidWordUnderscores ? (e = e.replace(/\b___(\S[\s\S]*?)___\b/g, function (e, t) {
      return "<u>" + t + "</u>"
    })).replace(/\b__(\S[\s\S]*?)__\b/g, function (e, t) {
      return "<u>" + t + "</u>"
    }) : (e = e.replace(/___(\S[\s\S]*?)___/g, function (e, t) {
      return /\S$/.test(t) ? "<u>" + t + "</u>" : e
    })).replace(/__(\S[\s\S]*?)__/g, function (e, t) {
      return /\S$/.test(t) ? "<u>" + t + "</u>" : e
    })).replace(/(_)/g, L.helper.escapeCharactersCallback), e = n.converter._dispatch("underline.after", e, t, n)) : e
  }), L.subParser("unescapeSpecialChars", function (e, t, n) {
    return e = (e = n.converter._dispatch("unescapeSpecialChars.before", e, t, n)).replace(/\xa8E(\d+)E/g, function (e, t) {
      var n = parseInt(t);
      return String.fromCharCode(n)
    }), e = n.converter._dispatch("unescapeSpecialChars.after", e, t, n)
  }), L.subParser("makeMarkdown.blockquote", function (e, t) {
    var n = "";
    if (e.hasChildNodes()) for (var r = e.childNodes, a = r.length, o = 0; o < a; ++o) {
      var i = L.subParser("makeMarkdown.node")(r[o], t);
      "" !== i && (n += i)
    }
    return n = "> " + (n = n.trim()).split("\n").join("\n> ")
  }), L.subParser("makeMarkdown.codeBlock", function (e, t) {
    var n = e.getAttribute("language"), r = e.getAttribute("precodenum");
    return "```" + n + "\n" + t.preList[r] + "\n```"
  }), L.subParser("makeMarkdown.codeSpan", function (e) {
    return "`" + e.innerHTML + "`"
  }), L.subParser("makeMarkdown.emphasis", function (e, t) {
    var n = "";
    if (e.hasChildNodes()) {
      n += "*";
      for (var r = e.childNodes, a = r.length, o = 0; o < a; ++o) n += L.subParser("makeMarkdown.node")(r[o], t);
      n += "*"
    }
    return n
  }), L.subParser("makeMarkdown.header", function (e, t, n) {
    var r = new Array(n + 1).join("#"), a = "";
    if (e.hasChildNodes()) {
      a = r + " ";
      for (var o = e.childNodes, i = o.length, s = 0; s < i; ++s) a += L.subParser("makeMarkdown.node")(o[s], t)
    }
    return a
  }), L.subParser("makeMarkdown.hr", function () {
    return "---"
  }), L.subParser("makeMarkdown.image", function (e) {
    var t = "";
    return e.hasAttribute("src") && (t += "![" + e.getAttribute("alt") + "](", t += "<" + e.getAttribute("src") + ">", e.hasAttribute("width") && e.hasAttribute("height") && (t += " =" + e.getAttribute("width") + "x" + e.getAttribute("height")), e.hasAttribute("title") && (t += ' "' + e.getAttribute("title") + '"'), t += ")"), t
  }), L.subParser("makeMarkdown.links", function (e, t) {
    var n = "";
    if (e.hasChildNodes() && e.hasAttribute("href")) {
      var r = e.childNodes, a = r.length;
      n = "[";
      for (var o = 0; o < a; ++o) n += L.subParser("makeMarkdown.node")(r[o], t);
      n += "](", n += "<" + e.getAttribute("href") + ">", e.hasAttribute("title") && (n += ' "' + e.getAttribute("title") + '"'), n += ")"
    }
    return n
  }), L.subParser("makeMarkdown.list", function (e, t, n) {
    var r = "";
    if (!e.hasChildNodes()) return "";
    for (var a = e.childNodes, o = a.length, i = e.getAttribute("start") || 1, s = 0; s < o; ++s) if ("undefined" != typeof a[s].tagName && "li" === a[s].tagName.toLowerCase()) {
      r += ("ol" === n ? i.toString() + ". " : "- ") + L.subParser("makeMarkdown.listItem")(a[s], t), ++i
    }
    return (r += "\n\x3c!-- --\x3e\n").trim()
  }), L.subParser("makeMarkdown.listItem", function (e, t) {
    for (var n = "", r = e.childNodes, a = r.length, o = 0; o < a; ++o) n += L.subParser("makeMarkdown.node")(r[o], t);
    return /\n$/.test(n) ? n = n.split("\n").join("\n    ").replace(/^ {4}$/gm, "").replace(/\n\n+/g, "\n\n") : n += "\n", n
  }), L.subParser("makeMarkdown.node", function (e, t, n) {
    n = n || !1;
    var r = "";
    if (3 === e.nodeType) return L.subParser("makeMarkdown.txt")(e, t);
    if (8 === e.nodeType) return "\x3c!--" + e.data + "--\x3e\n\n";
    if (1 !== e.nodeType) return "";
    switch (e.tagName.toLowerCase()) {
      case"h1":
        n || (r = L.subParser("makeMarkdown.header")(e, t, 1) + "\n\n");
        break;
      case"h2":
        n || (r = L.subParser("makeMarkdown.header")(e, t, 2) + "\n\n");
        break;
      case"h3":
        n || (r = L.subParser("makeMarkdown.header")(e, t, 3) + "\n\n");
        break;
      case"h4":
        n || (r = L.subParser("makeMarkdown.header")(e, t, 4) + "\n\n");
        break;
      case"h5":
        n || (r = L.subParser("makeMarkdown.header")(e, t, 5) + "\n\n");
        break;
      case"h6":
        n || (r = L.subParser("makeMarkdown.header")(e, t, 6) + "\n\n");
        break;
      case"p":
        n || (r = L.subParser("makeMarkdown.paragraph")(e, t) + "\n\n");
        break;
      case"blockquote":
        n || (r = L.subParser("makeMarkdown.blockquote")(e, t) + "\n\n");
        break;
      case"hr":
        n || (r = L.subParser("makeMarkdown.hr")(e, t) + "\n\n");
        break;
      case"ol":
        n || (r = L.subParser("makeMarkdown.list")(e, t, "ol") + "\n\n");
        break;
      case"ul":
        n || (r = L.subParser("makeMarkdown.list")(e, t, "ul") + "\n\n");
        break;
      case"precode":
        n || (r = L.subParser("makeMarkdown.codeBlock")(e, t) + "\n\n");
        break;
      case"pre":
        n || (r = L.subParser("makeMarkdown.pre")(e, t) + "\n\n");
        break;
      case"table":
        n || (r = L.subParser("makeMarkdown.table")(e, t) + "\n\n");
        break;
      case"code":
        r = L.subParser("makeMarkdown.codeSpan")(e, t);
        break;
      case"em":
      case"i":
        r = L.subParser("makeMarkdown.emphasis")(e, t);
        break;
      case"strong":
      case"b":
        r = L.subParser("makeMarkdown.strong")(e, t);
        break;
      case"del":
        r = L.subParser("makeMarkdown.strikethrough")(e, t);
        break;
      case"a":
        r = L.subParser("makeMarkdown.links")(e, t);
        break;
      case"img":
        r = L.subParser("makeMarkdown.image")(e, t);
        break;
      default:
        r = e.outerHTML + "\n\n"
    }
    return r
  }), L.subParser("makeMarkdown.paragraph", function (e, t) {
    var n = "";
    if (e.hasChildNodes()) for (var r = e.childNodes, a = r.length, o = 0; o < a; ++o) n += L.subParser("makeMarkdown.node")(r[o], t);
    return n = n.trim()
  }), L.subParser("makeMarkdown.pre", function (e, t) {
    var n = e.getAttribute("prenum");
    return "<pre>" + t.preList[n] + "</pre>"
  }), L.subParser("makeMarkdown.strikethrough", function (e, t) {
    var n = "";
    if (e.hasChildNodes()) {
      n += "~~";
      for (var r = e.childNodes, a = r.length, o = 0; o < a; ++o) n += L.subParser("makeMarkdown.node")(r[o], t);
      n += "~~"
    }
    return n
  }), L.subParser("makeMarkdown.strong", function (e, t) {
    var n = "";
    if (e.hasChildNodes()) {
      n += "**";
      for (var r = e.childNodes, a = r.length, o = 0; o < a; ++o) n += L.subParser("makeMarkdown.node")(r[o], t);
      n += "**"
    }
    return n
  }), L.subParser("makeMarkdown.table", function (e, t) {
    var n, r, a = "", o = [[], []], i = e.querySelectorAll("thead>tr>th"), s = e.querySelectorAll("tbody>tr");
    for (n = 0; n < i.length; ++n) {
      var l = L.subParser("makeMarkdown.tableCell")(i[n], t), c = "---";
      if (i[n].hasAttribute("style")) switch (i[n].getAttribute("style").toLowerCase().replace(/\s/g, "")) {
        case"text-align:left;":
          c = ":---";
          break;
        case"text-align:right;":
          c = "---:";
          break;
        case"text-align:center;":
          c = ":---:"
      }
      o[0][n] = l.trim(), o[1][n] = c
    }
    for (n = 0; n < s.length; ++n) {
      var d = o.push([]) - 1, f = s[n].getElementsByTagName("td");
      for (r = 0; r < i.length; ++r) {
        var p = " ";
        "undefined" != typeof f[r] && (p = L.subParser("makeMarkdown.tableCell")(f[r], t)), o[d].push(p)
      }
    }
    var u = 3;
    for (n = 0; n < o.length; ++n) for (r = 0; r < o[n].length; ++r) {
      var h = o[n][r].length;
      u < h && (u = h)
    }
    for (n = 0; n < o.length; ++n) {
      for (r = 0; r < o[n].length; ++r) 1 === n ? ":" === o[n][r].slice(-1) ? o[n][r] = L.helper.padEnd(o[n][r].slice(-1), u - 1, "-") + ":" : o[n][r] = L.helper.padEnd(o[n][r], u, "-") : o[n][r] = L.helper.padEnd(o[n][r], u);
      a += "| " + o[n].join(" | ") + " |\n"
    }
    return a.trim()
  }), L.subParser("makeMarkdown.tableCell", function (e, t) {
    var n = "";
    if (!e.hasChildNodes()) return "";
    for (var r = e.childNodes, a = r.length, o = 0; o < a; ++o) n += L.subParser("makeMarkdown.node")(r[o], t, !0);
    return n.trim()
  }), L.subParser("makeMarkdown.txt", function (e) {
    var t = e.nodeValue;
    return t = (t = t.replace(/ +/g, " ")).replace(/\xa8NBSP;/g, " "), t = (t = (t = (t = (t = (t = (t = (t = (t = L.helper.unescapeHTMLEntities(t)).replace(/([*_~|`])/g, "\\$1")).replace(/^(\s*)>/g, "\\$1>")).replace(/^#/gm, "\\#")).replace(/^(\s*)([-=]{3,})(\s*)$/, "$1\\$2$3")).replace(/^( {0,3}\d+)\./gm, "$1\\.")).replace(/^( {0,3})([+-])/gm, "$1\\$2")).replace(/]([\s]*)\(/g, "\\]$1\\(")).replace(/^ {0,3}\[([\S \t]*?)]:/gm, "\\[$1]:")
  }), xt.PLUGINS.markdown = function (o) {
    var i, l, n, r, s, c = o.$, a = !1, d = "", f = "";

    function p(e) {
      e = function u(e) {
        var t = e, n = e.match(/(\[\^(.+?)\])[^:]/g), r = e.match(/(\[\^(.+?)\]:)/g);
        if (n && r) {
          n.forEach(function (e, t, n) {
            n[t] = n[t].substring(0, n[t].length - 1)
          }), n = n.filter(function (e, t) {
            return n.indexOf(e) === t
          }), r = r.filter(function (e, t) {
            return r.indexOf(e) === t
          });
          for (var a = 1, o = 0; o < n.length; o++) {
            var i = "";
            if (1 == a && (i = '<hr class="footnote-sep"><ol>'), -1 < r.indexOf(n[o] + ":")) {
              for (var s = -1 < (t = (t = t.split(r[o]).join("{ftnt-plc}")).replace(r[o].substring(0, r[o].length - 1), '<sup id="fnref:'.concat(a, '"><a href="#fn:').concat(a, '" class="footnote-a">').concat(a, "</a></sup>"))).indexOf(n[o]) ? 1 : 0, l = 0; s && (l++, t = t.replace(r[o].substring(0, r[o].length - 1), '<sup id="fnref:'.concat(a, ":").concat(l, '"><a href="#fn:').concat(a, ":").concat(l, '" class="footnote-a">').concat(a, ":").concat(l, "</a></sup>")), s = -1 < t.indexOf(n[o]) ? 1 : 0);) ;
              var c = (t = t.split("{ftnt-plc}").join(r[o])).indexOf(r[o]), d = t, f = d.substring(c, d.length - 1);
              if (f = f.split("\n")[0], t = t.replace(f, ""), -1 < f.indexOf(": ")) {
                f = f.split(": ")[1], f += '<a href="#fnref:'.concat(a, '" class="footnote-a">\u21a9</a>');
                for (var p = l; 0 != l;) f += '<a href="#fnref:'.concat(a, ":").concat(p - l + 1, '" class="footnote-a">\u21a9</a>'), l--;
                f += "</p></li>", t = t + i + '<li id="fn:'.concat(a, '"><p>') + f, a++
              }
            }
          }
          1 != a && (t += "</ol>")
        }
        return e = t
      }(e = function s(e) {
        for (var t = /^[A-Za-z0-9]/g, n = /^:[ ]{1}(.+?)+/g, r = e.split("\n"), a = r, o = r.length - 1, i = 1; i < o; i++) null !== r[i].match(n) && (null !== r[i - 1].match(t) && i < o - 1 && null !== r[i + 1].match(n) ? (a[i - 1] = "<dl><dt>" + r[i - 1] + "</dt>", a[i] = "<dd>" + r[i].substring(2) + "</dd>") : null !== r[i - 1].match(t) && (i < o - 1 && null === r[i + 1].match(n) || i == o - 1) ? (a[i - 1] = "<dl><dt>" + r[i - 1] + "</dt>", a[i] = "<dd>" + r[i].substring(2) + "</dd></dl>") : i < o - 1 && null !== r[i + 1].match(n) ? a[i] = "<dd>" + r[i].substring(2) + "</dd>" : a[i] = "<dd>" + r[i].substring(2) + "</dd></dl>");
        return e = a.join("\n")
      }(e = function t(e) {
        var r = e.indexOf("```"), a = 0;
        -1 < r && (a = -1 < (a = e.substring(r + 1).indexOf("```")) ? a + 3 : a);
        return e = e.replace(/^ {0,2}( ?-){3,}[ \t]*$/gm, function (e, t, n) {
          return r < n && n < a ? "---" : "<hr />\n"
        })
      }(e = function n(e) {
        return -1 < (e = (e = (e = (e = (e = (e = (e = (e = (e = (e = e.split("</p>").join("</p>\n")).split("</div>").join("\n")).replace(/(<([^>]+)>)/gi, "")).replace(/&gt;/gi, ">")).replace(/&lt;/gi, "<")).split("&quot;").join('"')).split("&amp;").join("&")).split("&#39;").join("'")).split("&nbsp;").join(" ")).replace(/\|+\n[^\|]/g, function (e) {
          return e.replace("\n", "\n\n")
        })).indexOf("Powered by Froala Editor") && (e = e.replace("Powered by Froala Editor", "")), e
      }(e)))), e = r.makeHtml(e), o.$wp.find(l)[0].innerHTML = e
    }

    return {
      _init: function t() {
        if (function e() {
          o.events.on("contentChanged", function () {
            a && p(o.html.get(!1, !1))
          }, !0), o.events.$on(c(o.o_win), "resize", function () {
            a && (l[0].style.width = o.$wp[0].clientWidth - o.$el[0].clientWidth + 2 + "px")
          })
        }(), r = new L.Converter({
          strikethrough: !0,
          tables: !0,
          tablesHeaderId: !0,
          simpleLineBreaks: !0,
          ghCodeBlocks: !0,
          tasklists: !0,
          customizedHeaderId: !0,
          requireSpaceBeforeHeadingText: !0,
          underline: !0
        }), n = o.$tb ? o.$tb.find('.fr-command[data-cmd="markdown"]') : null, !o.$wp) return !1
      }, refresh: function u(e) {
        var t = a;
        e.toggleClass("fr-active", t).attr("aria-pressed", t)
      }, toggle: function h() {
        a ? function e() {
          f = o.html.get(!0, !0), o.opts.pastePlain = !1, o.$el.removeClass("fr-markdown-editor"), o.$wp.append(s[0].firstChild), c(s).remove(), o.$wp.find(i).remove(), o.$wp.find(l).remove(), o.$wp[0].lastChild.after(o.$placeholder[0]), o.$el.removeAttr("style"), o.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command").not(n).removeClass("fr-disabled").attr("aria-disabled", !1), o.html.set(d)
        }() : function t() {
          var a;
          d = o.html.get(!0, !0), o.html.set(f), o.opts.pastePlain = !0, o.$el.addClass("fr-markdown-editor"), s = c('<div class="fr-wrapper-markdown" />'), o.$wp.append(s), s[0].appendChild(o.$el[0]), i = c('<div class="gutter-horizontal"><div class="e-resize-handler"><i class="fa fa-circle-thin" aria-hidden="true"></i></div></div>'), c(s).append(i[0]), l = c('<div class="fr-element fr-markdown-view"></div>'), c(s).append(l[0]), c(s).after(o.$placeholder[0]), o.$tb.find(".fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command, .fr-btn-grp > .fr-btn-wrap > .fr-command, .fr-more-toolbar > .fr-btn-wrap > .fr-command").not(n).filter(function () {
            return "fullscreen" !== c(this).data("cmd") && "moreMisc" !== c(this).data("cmd")
          }).addClass("fr-disabled").attr("aria-disabled", !0), c(i).on("mousedown touchstart", function (e) {
            a = {
              e: e,
              offsetLeft: i[0].offsetLeft,
              offsetTop: i[0].offsetTop,
              firstWidth: o.$el[0].offsetWidth,
              secondWidth: l[0].offsetWidth
            };
            var n = function n(e) {
              o.selection.clear();
              var t = {x: e.clientX - a.e.clientX, y: e.clientY - a.e.clientY};
              t.x = Math.min(Math.max(t.x, -a.firstWidth), a.secondWidth), a.firstWidth + t.x < 125 || a.secondWidth - t.x < 125 || (i[0].style.left = a.offsetLeft + t.x + "px", o.$el[0].style.width = a.firstWidth + t.x + "px", l[0].style.width = a.secondWidth - t.x + "px")
            }, r = function r(e) {
              o.selection.clear();
              var t = {
                x: e.changedTouches[0].clientX - a.e.changedTouches[0].clientX,
                y: e.changedTouches[0].clientY - a.e.changedTouches[0].clientY
              };
              t.x = Math.min(Math.max(t.x, -a.firstWidth), a.secondWidth), a.firstWidth + t.x < 100 || a.secondWidth - t.x < 100 || (i[0].style.left = a.offsetLeft + t.x + "px", o.$el[0].style.width = a.firstWidth + t.x + "px", l[0].style.width = a.secondWidth - t.x + "px")
            }, t = function t() {
              document.onmousemove = document.onmouseup = null, document.ontouchmove = document.ontouchend = null
            };
            document.onmousemove = n, document.ontouchmove = r, document.onmouseup = t, document.ontouchend = t
          }), p(f)
        }(), a = !a
      }, isEnabled: function e() {
        return a
      }
    }
  }, xt.DefineIcon("markdown", {
    NAME: "markdown",
    SVG_KEY: "markdown"
  }), xt.RegisterCommand("markdown", {
    title: "Markdown",
    undo: !1,
    focus: !1,
    toggle: !0,
    forcedRefresh: !0,
    accessibilityFocus: !0,
    callback: function () {
      this.markdown.toggle()
    },
    refresh: function (e) {
      this.markdown.refresh(e)
    },
    plugin: "markdown"
  }), xt
});

/*!
 * froala_editor v4.0.1 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2021 Froala Labs
 */

!function(e,a){"object"==typeof exports&&"undefined"!=typeof module?a(require("froala-editor")):"function"==typeof define&&define.amd?define(["froala-editor"],a):a(e.FroalaEditor)}(this,function(g){"use strict";g=g&&g.hasOwnProperty("default")?g["default"]:g,Object.assign(g.DEFAULTS,{fontAwesomeTemplate:'<i class="fa  fa-[NAME] fr-deletable" aria-hidden="true">&nbsp;</i>',fontAwesomeTemplate5:'<i class="fa [FPREFIX] fa-[NAME] fr-deletable" aria-hidden="true">&nbsp;</i>',fontAwesomeSets:[{title:"Web Application Icons",icon:"address-book",list:["address-book","address-book-o","address-card","address-card-o","adjust","american-sign-language-interpreting","anchor","archive","area-chart","arrows","arrows-h","arrows-v","asl-interpreting ","assistive-listening-systems","asterisk","at","audio-description","automobile ","balance-scale","ban","bank ","bar-chart","bar-chart-o ","barcode","bars","bath","bathtub ","battery ","battery-0 ","battery-1 ","battery-2 ","battery-3 ","battery-4 ","battery-empty","battery-full","battery-half","battery-quarter","battery-three-quarters","bed","beer","bell","bell-o","bell-slash","bell-slash-o","bicycle","binoculars","birthday-cake","blind","bluetooth","bluetooth-b","bolt","bomb","book","bookmark","bookmark-o","braille","briefcase","bug","building","building-o","bullhorn","bullseye","bus","cab ","calculator","calendar","calendar-check-o","calendar-minus-o","calendar-o","calendar-plus-o","calendar-times-o","camera","camera-retro","car","caret-square-o-down","caret-square-o-left","caret-square-o-right","caret-square-o-up","cart-arrow-down","cart-plus","cc","certificate","check","check-circle","check-circle-o","check-square","check-square-o","child","circle","circle-o","circle-o-notch","circle-thin","clock-o","clone","close ","cloud","cloud-download","cloud-upload","code","code-fork","coffee","cog","cogs","comment","comment-o","commenting","commenting-o","comments","comments-o","compass","copyright","creative-commons","credit-card","credit-card-alt","crop","crosshairs","cube","cubes","cutlery","dashboard ","database","deaf","deafness ","desktop","diamond","dot-circle-o","download","drivers-license ","drivers-license-o ","edit ","ellipsis-h","ellipsis-v","envelope","envelope-o","envelope-open","envelope-open-o","envelope-square","eraser","exchange","exclamation","exclamation-circle","exclamation-triangle","external-link","external-link-square","eye","eye-slash","eyedropper","fax","feed ","female","fighter-jet","file-archive-o","file-audio-o","file-code-o","file-excel-o","file-image-o","file-movie-o ","file-pdf-o","file-photo-o ","file-picture-o ","file-powerpoint-o","file-sound-o ","file-video-o","file-word-o","file-zip-o ","film","filter","fire","fire-extinguisher","flag","flag-checkered","flag-o","flash ","flask","folder","folder-o","folder-open","folder-open-o","frown-o","futbol-o","gamepad","gavel","gear ","gears ","gift","glass","globe","graduation-cap","group ","hand-grab-o ","hand-lizard-o","hand-paper-o","hand-peace-o","hand-pointer-o","hand-rock-o","hand-scissors-o","hand-spock-o","hand-stop-o ","handshake-o","hard-of-hearing ","hashtag","hdd-o","headphones","heart","heart-o","heartbeat","history","home","hotel ","hourglass","hourglass-1 ","hourglass-2 ","hourglass-3 ","hourglass-end","hourglass-half","hourglass-o","hourglass-start","i-cursor","id-badge","id-card","id-card-o","image ","inbox","industry","info","info-circle","institution ","key","keyboard-o","language","laptop","leaf","legal ","lemon-o","level-down","level-up","life-bouy ","life-buoy ","life-ring","life-saver ","lightbulb-o","line-chart","location-arrow","lock","low-vision","magic","magnet","mail-forward ","mail-reply ","mail-reply-all ","male","map","map-marker","map-o","map-pin","map-signs","meh-o","microchip","microphone","microphone-slash","minus","minus-circle","minus-square","minus-square-o","mobile","mobile-phone ","money","moon-o","mortar-board ","motorcycle","mouse-pointer","music","navicon ","newspaper-o","object-group","object-ungroup","paint-brush","paper-plane","paper-plane-o","paw","pencil","pencil-square","pencil-square-o","percent","phone","phone-square","photo ","picture-o","pie-chart","plane","plug","plus","plus-circle","plus-square","plus-square-o","podcast","power-off","print","puzzle-piece","qrcode","question","question-circle","question-circle-o","quote-left","quote-right","random","recycle","refresh","registered","remove ","reorder ","reply","reply-all","retweet","road","rocket","rss","rss-square","s15 ","search","search-minus","search-plus","send ","send-o ","server","share","share-alt","share-alt-square","share-square","share-square-o","shield","ship","shopping-bag","shopping-basket","shopping-cart","shower","sign-in","sign-language","sign-out","signal","signing ","sitemap","sliders","smile-o","snowflake-o","soccer-ball-o ","sort","sort-alpha-asc","sort-alpha-desc","sort-amount-asc","sort-amount-desc","sort-asc","sort-desc","sort-down ","sort-numeric-asc","sort-numeric-desc","sort-up ","space-shuttle","spinner","spoon","square","square-o","star","star-half","star-half-empty ","star-half-full ","star-half-o","star-o","sticky-note","sticky-note-o","street-view","suitcase","sun-o","support ","tablet","tachometer","tag","tags","tasks","taxi","television","terminal","thermometer ","thermometer-0 ","thermometer-1 ","thermometer-2 ","thermometer-3 ","thermometer-4 ","thermometer-empty","thermometer-full","thermometer-half","thermometer-quarter","thermometer-three-quarters","thumb-tack","thumbs-down","thumbs-o-down","thumbs-o-up","thumbs-up","ticket","times","times-circle","times-circle-o","times-rectangle ","times-rectangle-o ","tint","toggle-down ","toggle-left ","toggle-off","toggle-on","toggle-right ","toggle-up ","trademark","trash","trash-o","tree","trophy","truck","tty","tv ","umbrella","universal-access","university","unlock","unlock-alt","unsorted ","upload","user","user-circle","user-circle-o","user-o","user-plus","user-secret","user-times","users","vcard ","vcard-o ","video-camera","volume-control-phone","volume-down","volume-off","volume-up","warning ","wheelchair","wheelchair-alt","wifi","window-close","window-close-o","window-maximize","window-minimize","window-restore","wrench"]},{title:"Accessibility Icons",icon:"american-sign-language-interpreting",list:["american-sign-language-interpreting","asl-interpreting ","assistive-listening-systems","audio-description","blind","braille","cc","deaf","deafness ","hard-of-hearing ","low-vision","question-circle-o","sign-language","signing ","tty","universal-access","volume-control-phone","wheelchair","wheelchair-alt"]},{title:"Hand Icons",icon:"hand-grab-o",list:["hand-grab-o ","hand-lizard-o","hand-o-down","hand-o-left","hand-o-right","hand-o-up","hand-paper-o","hand-peace-o","hand-pointer-o","hand-rock-o","hand-scissors-o","hand-spock-o","hand-stop-o ","thumbs-down","thumbs-o-down","thumbs-o-up","thumbs-up"]},{title:"Transportation Icons",icon:"ambulance",list:["ambulance","automobile ","bicycle","bus","cab ","car","fighter-jet","motorcycle","plane","rocket","ship","space-shuttle","subway","taxi","train","truck","wheelchair","wheelchair-alt"]},{title:"Gender Icons",icon:"genderless",list:["genderless","intersex ","mars","mars-double","mars-stroke","mars-stroke-h","mars-stroke-v","mercury","neuter","transgender","transgender-alt","venus","venus-double","venus-mars"]},{title:"Form Control Icons",icon:"check-square",list:["check-square","check-square-o","circle","circle-o","dot-circle-o","minus-square","minus-square-o","plus-square","plus-square-o","square","square-o"]},{title:"Payment Icons",icon:"cc-amex",list:["cc-amex","cc-diners-club","cc-discover","cc-jcb","cc-mastercard","cc-paypal","cc-stripe","cc-visa","credit-card","credit-card-alt","google-wallet","paypal"]},{title:"Chart Icons",icon:"area-chart",list:["area-chart","bar-chart","bar-chart-o ","line-chart","pie-chart"]},{title:"Currency Icons",icon:"bitcoin",list:["bitcoin ","btc","cny ","dollar ","eur","euro ","gbp","gg","gg-circle","ils","inr","jpy","krw","money","rmb ","rouble ","rub","ruble ","rupee ","shekel ","sheqel ","try","turkish-lira ","usd","viacoin","won ","yen"]},{title:"Text Editor Icons",icon:"align-center",list:["align-center","align-justify","align-left","align-right","bold","chain ","chain-broken","clipboard","columns","copy ","cut ","dedent ","eraser","file","file-o","file-text","file-text-o","files-o","floppy-o","font","header","indent","italic","link","list","list-alt","list-ol","list-ul","outdent","paperclip","paragraph","paste ","repeat","rotate-left ","rotate-right ","save ","scissors","strikethrough","subscript","superscript","table","text-height","text-width","th","th-large","th-list","underline","undo","unlink"]},{title:"Brand Icons",icon:"500px",list:["500px","adn","amazon","android","angellist","apple","bandcamp","behance","behance-square","bitbucket","bitbucket-square","bitcoin ","black-tie","bluetooth","bluetooth-b","btc","buysellads","cc-amex","cc-diners-club","cc-discover","cc-jcb","cc-mastercard","cc-paypal","cc-stripe","cc-visa","chrome","codepen","codiepie","connectdevelop","contao","css3","dashcube","delicious","deviantart","digg","dribbble","dropbox","drupal","edge","eercast","empire","envira","etsy","expeditedssl","fa ","facebook","facebook-f ","facebook-official","facebook-square","firefox","first-order","flickr","font-awesome","fonticons","fort-awesome","forumbee","foursquare","free-code-camp","ge ","get-pocket","gg","gg-circle","git","git-square","github","github-alt","github-square","gitlab","gittip ","glide","glide-g","google","google-plus","google-plus-circle ","google-plus-official","google-plus-square","google-wallet","gratipay","grav","hacker-news","houzz","html5","imdb","instagram","internet-explorer","ioxhost","joomla","jsfiddle","lastfm","lastfm-square","leanpub","linkedin","linkedin-square","linode","linux","maxcdn","meanpath","medium","meetup","mixcloud","modx","odnoklassniki","odnoklassniki-square","opencart","openid","opera","optin-monster","pagelines","paypal","pied-piper","pied-piper-alt","pied-piper-pp","pinterest","pinterest-p","pinterest-square","product-hunt","qq","quora","ra ","ravelry","rebel","reddit","reddit-alien","reddit-square","renren","resistance ","safari","scribd","sellsy","share-alt","share-alt-square","shirtsinbulk","simplybuilt","skyatlas","skype","slack","slideshare","snapchat","snapchat-ghost","snapchat-square","soundcloud","spotify","stack-exchange","stack-overflow","steam","steam-square","stumbleupon","stumbleupon-circle","superpowers","telegram","tencent-weibo","themeisle","trello","tripadvisor","tumblr","tumblr-square","twitch","twitter","twitter-square","usb","viacoin","viadeo","viadeo-square","vimeo","vimeo-square","vine","vk","wechat ","weibo","weixin","whatsapp","wikipedia-w","windows","wordpress","wpbeginner","wpexplorer","wpforms","xing","xing-square","y-combinator","y-combinator-square ","yahoo","yc ","yc-square ","yelp","yoast","youtube","youtube-play","youtube-square"]}],fontAwesome5Sets:[{title:"Web Application Icons",icon:"address-book",list:["address-book","far address-book","fas address-card","far address-card","adjust","fas american-sign-language-interpreting","anchor","archive","fas chart-area","fas arrows-alt","fas arrows-alt-h","fas arrows-alt-v","assistive-listening-systems","asterisk","at","audio-description","fas car","balance-scale","ban","fas university","far chart-bar","barcode","bars","fas bath","fas battery-full","fas battery-empty","fas battery-quarter","fas battery-half","fas battery-three-quarters","bed","beer","bell","far bell","bell-slash","far bell-slash","bicycle","binoculars","birthday-cake","blind","fab bluetooth","fab bluetooth-b","bolt","bomb","book","bookmark","far bookmark","braille","briefcase","bug","building","far building","bullhorn","bullseye","bus","fas taxi","calculator","calendar","far calendar-check","far calendar-minus","far calendar","far calendar-plus","far calendar-times","camera","camera-retro","car","far caret-square-down","far caret-square-left","far caret-square-right","far caret-square-up","cart-arrow-down","cart-plus","far closed-captioning","certificate","check","check-circle","far check-circle","check-square","far check-square","child","circle","far circle","fas circle-notch","far clock","clone","fas times","cloud","fas cloud-download-alt","fas cloud-upload-alt","code","fas code-branch","coffee","fas cog","fas cogs","comment","far comment","comments","far comments","compass","copyright","fab creative-commons","far credit-card","fas credit-card","crop","crosshairs","cube","cubes","fas utensils","fas tachometer-alt","database","fas deaf","desktop","far gem","far dot-circle","download","fas id-card","far id-card","edit ","ellipsis-h","ellipsis-v","envelope","far envelope","envelope-open","far envelope-open","envelope-square","eraser","fas exchange-alt","exclamation","exclamation-circle","fas exclamation-triangle","fas external-link-alt","fas external-link-square-alt","eye","eye-slash","fas eye-dropper","fax","fas rss","female","fighter-jet","far file-archive","far file-audio","far file-code","far file-excel","far file-image","far file-video","far file-pdf","far file-powerpoint","far file-word","film","filter","fire","fire-extinguisher","flag","flag-checkered","far flag","fas bolt","flask","folder","far folder","folder-open","far folder-open","far frown","far futbol","gamepad","fas gavel","gift","fas glass-martini","globe","fas graduation-cap","fas users","far hand-rock","far hand-lizard","far hand-paper","far hand-peace","far hand-pointer","far hand-scissors","far hand-spock","far handshake","hashtag","far hdd","headphones","heart","far heart","heartbeat","history","home","fas bed","hourglass","fas hourglass-start","fas hourglass-half","fas hourglass-end","far hourglass","i-cursor","id-badge","image ","inbox","industry","info","info-circle","key","far keyboard","language","laptop","leaf","far lemon","fas level-down-alt","fas level-up-alt","far life-ring","far lightbulb","fas chart-line","location-arrow","lock","low-vision","magic","magnet","fas share","fas reply ","fas reply-all ","male","map","map-marker","far map","map-pin","map-signs","far meh","microchip","microphone","microphone-slash","minus","minus-circle","minus-square","far minus-square","mobile","far money-bill-alt","far moon","motorcycle","mouse-pointer","music","fas bars","far newspaper","object-group","object-ungroup","paint-brush","fas paper-plane","far paper-plane","paw","fas pencil-alt","fas pen-square","far edit","percent","phone","phone-square","far image","fas chart-pie","plane","plug","plus","plus-circle","plus-square","far plus-square","podcast","power-off","print","puzzle-piece","qrcode","question","question-circle","far question-circle","quote-left","quote-right","random","recycle","fas sync","registered","reply","reply-all","retweet","road","rocket","rss","rss-square","search","search-minus","search-plus","server","share-alt","share-alt-square","share-square","far share-square","fas shield-alt","ship","shopping-bag","shopping-basket","shopping-cart","shower","fas sign-in-alt","fas sign-language","fas sign-out-alt","signal","sitemap","fas sliders-h","far smile","far snowflake","sort","fas sort-alpha-down","fas sort-alpha-up","fas sort-amount-down","fas sort-amount-up","fas sort-up","fas sort-down","fas sort-numeric-down","fas sort-numeric-up","space-shuttle","spinner","fas utensil-spoon","square","far square","star","far star-half","far star","sticky-note","far sticky-note","street-view","suitcase","far sun","tablet","tag","tags","tasks","taxi","fas tv","terminal","fas thermometer-empty","fas thermometer-full","fas thermometer-half","fas thermometer-quarter","fas thermometer-three-quarters","fas thumbtack","thumbs-down","far thumbs-down","far thumbs-up","thumbs-up","fas ticket-alt","times","times-circle","far times-circle","fas window-close","far window-close ","tint","toggle-off","toggle-on","trademark","trash","far trash-alt","tree","trophy","truck","tty","tv ","umbrella","universal-access","university","unlock","unlock-alt","fas sort","upload","user","user-circle","far user-circle","far user","user-plus","user-secret","user-times","fas video","fas phone-volume","volume-down","volume-off","volume-up","wheelchair","fab accessible-icon","wifi","window-maximize","window-minimize","window-restore","wrench"]},{title:"Accessibility Icons",icon:"american-sign-language-interpreting",list:["fas american-sign-language-interpreting","assistive-listening-systems","audio-description","blind","braille","far closed-captioning","fas deaf","low-vision","far question-circle","fas sign-language","tty","universal-access","fas phone-volume","wheelchair","fab accessible-icon"]},{title:"Hand Icons",icon:"hand-grab-o",list:["far hand-rock","far hand-lizard","far hand-point-down","far hand-point-left","far hand-point-right","far hand-point-up","far hand-paper","far hand-peace","far hand-pointer","far hand-scissors","far hand-spock","thumbs-down","far thumbs-down","far thumbs-up","thumbs-up"]},{title:"Transportation Icons",icon:"ambulance",list:["ambulance","fas car","bicycle","bus","fas taxi","car","fighter-jet","motorcycle","plane","rocket","ship","space-shuttle","subway","taxi","train","truck","wheelchair","fab accessible-icon"]},{title:"Gender Icons",icon:"genderless",list:["genderless","mars","mars-double","mars-stroke","mars-stroke-h","mars-stroke-v","mercury","neuter","fas transgender","transgender-alt","venus","venus-double","venus-mars"]},{title:"Form Control Icons",icon:"check-square",list:["check-square","far check-square","circle","far circle","far dot-circle","minus-square","far minus-square","plus-square","far plus-square","square","far square"]},{title:"Payment Icons",icon:"cc-amex",list:["fab cc-amex","fab cc-diners-club","fab cc-discover","fab cc-jcb","fab cc-mastercard","fab cc-paypal","fab cc-stripe","fab cc-visa","far credit-card","fas credit-card","fab google-wallet","fab paypal"]},{title:"Chart Icons",icon:"area-chart",list:["fas chart-area","far chart-bar","fas chart-line","fas chart-pie"]},{title:"Currency Icons",icon:"bitcoin",list:["fab btc","fas yen-sign","fas dollar-sign","fas euro-sign","fas pound-sign","fab gg","fab gg-circle","fas shekel-sign","fas rupee-sign","fas won-sign","far money-bill-alt","fas ruble-sign ","fas lira-sign","fab viacoin"]},{title:"Text Editor Icons",icon:"align-center",list:["align-center","align-justify","align-left","align-right","bold","fas link","fas unlink","clipboard","columns","copy ","cut ","fas outdent","eraser","file","far file","fas file-alt","far file-alt","far copy","far save","font","fas heading","indent","italic","list","list-alt","list-ol","list-ul","paperclip","paragraph","paste ","fas undo","fas redo ","save","strikethrough","subscript","superscript","table","text-height","text-width","th","th-large","th-list","underline"]},{title:"Brand Icons",icon:"500px",list:["fab 500px","fab adn","fab amazon","fab android","fab angellist","fab apple","fab bandcamp","fab behance","fab behance-square","fab bitbucket","fab btc","fab black-tie","fab bluetooth","fab bluetooth-b","fab buysellads","fab cc-amex","fab cc-diners-club","fab cc-discover","fab cc-jcb","fab cc-mastercard","fab cc-paypal","fab cc-stripe","fab cc-visa","fab chrome","fab codepen","fab codiepie","fab connectdevelop","fab contao","fab css3","fab dashcube","fab delicious","fab deviantart","fab digg","fab dribbble","fab dropbox","fab drupal","fab edge","fab sellcast","fab empire","fab envira","fab etsy","fab expeditedssl","fab font-awesome","fab facebook-f","fab facebook","fab facebook-square","fab firefox","fab first-order","fab flickr","fab fonticons","fab fort-awesome","fab forumbee","fab foursquare","fab free-code-camp","fab get-pocket","fab gg","fab gg-circle","fab git","fab git-square","fab github","fab github-alt","fab github-square","fab gitlab","fab gratipay","fab glide","fab glide-g","fab google","fab google-plus-g","fab google-plus","fab google-plus-square","fab google-wallet","fab grav","fab hacker-news","fab houzz","fab html5","fab imdb","fab instagram","fab internet-explorer","fab ioxhost","fab joomla","fab jsfiddle","fab lastfm","fab lastfm-square","fab leanpub","fab linkedin-in","fab linkedin","fab linode","fab linux","fab maxcdn","fab medium","fab meetup","fab mixcloud","fab modx","fab odnoklassniki","fab odnoklassniki-square","fab opencart","fab openid","fab opera","fab optin-monster","fab pagelines","fab paypal","fab pied-piper","fab pied-piper-alt","fab pied-piper-pp","fab pinterest","fab pinterest-p","fab pinterest-square","fab product-hunt","fab qq","fab quora","fab rebel","fab ravelry","fab reddit","fab reddit-alien","fab reddit-square","fab renren","fab safari","fab scribd","fab sellsy","share-alt","share-alt-square","fab shirtsinbulk","fab simplybuilt","fab skyatlas","fab skype","fab slack","fab slideshare","fab snapchat","fab snapchat-ghost","fab snapchat-square","fab soundcloud","fab spotify","fab stack-exchange","fab stack-overflow","fab steam","fab steam-square","fab stumbleupon","fab stumbleupon-circle","fab superpowers","fab telegram","fab tencent-weibo","fab themeisle","fab trello","fab tripadvisor","fab tumblr","fab tumblr-square","fab twitch","fab twitter","fab twitter-square","fab usb","fab viacoin","fab viadeo","fab viadeo-square","fab vimeo","fab vimeo-square","fab vine","fab vk","fab weixin","fab weibo","fab whatsapp","fab wikipedia-w","fab windows","fab wordpress","fab wpbeginner","fab wpexplorer","fab wpforms","fab xing","fab xing-square","fab y-combinator","fab yahoo","fab yelp","fab yoast","fab youtube","fab youtube-square"]}],faButtons:["fontAwesomeBack","|"]}),Object.assign(g.POPUP_TEMPLATES,{fontAwesome:"[_BUTTONS_][_CUSTOM_LAYER_]"}),g.PLUGINS.fontAwesome=function(h){var m=h.$;"font_awesome_5"===h.opts.iconsTemplate&&(h.opts.fontAwesomeSets=h.opts.fontAwesome5Sets,h.opts.fontAwesomeTemplate=h.opts.fontAwesomeTemplate5);var t=h.opts.fontAwesomeSets[0],o=h.opts.fontAwesomeSets,r="";function i(){h.opts.toolbarInline&&0<h.opts.faButtons.length&&(r='<div class="fr-buttons fr-tabs">'.concat(h.button.buildList(h.opts.faButtons),"</div>"));var e={buttons:r,custom_layer:s()},a=h.popups.create("fontAwesome",e);return function t(d){h.events.on("popup.tab",function(e){var a=m(e.currentTarget);if(!h.popups.isVisible("fontAwesome")||!a.is("span, a"))return!0;var t,r,s,o=e.which;if(g.KEYCODE.TAB==o){if(a.is("span.fr-icon")&&e.shiftKey||a.is("a")&&!e.shiftKey){var i=d.find(".fr-buttons");t=!h.accessibility.focusToolbar(i,!!e.shiftKey)}if(!1!==t){var n=d.find("span.fr-icon:focus").first().concat(d.findVisible(" span.fr-icon").first().concat(d.find("a")));a.is("span.fr-icon")&&(n=n.not("span.fr-icon:not(:focus)")),r=n.index(a),r=e.shiftKey?((r-1)%n.length+n.length)%n.length:(r+1)%n.length,s=n.get(r),h.events.disableBlur(),s.focus(),t=!1}}else if(g.KEYCODE.ARROW_UP==o||g.KEYCODE.ARROW_DOWN==o||g.KEYCODE.ARROW_LEFT==o||g.KEYCODE.ARROW_RIGHT==o){if(a.is("span.fr-icon")){var l=a.parent().find("span.fr-icon");r=l.index(a);var c=Math.floor(l.length/8),f=r%8,u=Math.floor(r/8),p=8*u+f,b=8*c;g.KEYCODE.ARROW_UP==o?p=((p-8)%b+b)%b:g.KEYCODE.ARROW_DOWN==o?p=(p+8)%b:g.KEYCODE.ARROW_LEFT==o?p=((p-1)%b+b)%b:g.KEYCODE.ARROW_RIGHT==o&&(p=(p+1)%b),s=m(l.get(p)),h.events.disableBlur(),s.focus(),t=!1}}else g.KEYCODE.ENTER==o&&(a.is("a")?a[0].click():h.button.exec(a),t=!1);return!1===t&&(e.preventDefault(),e.stopPropagation()),t},!0)}(a),a}function s(){return"".concat(function r(e,a,t){return'\n        <div class="fr-buttons fr-tabs fr-tabs-scroll">\n            '.concat(function n(e,t,r){var s="";if("font_awesome_5"===h.opts.iconsTemplate){var o="",i=r;e.forEach(function(e){o="cc-amex"===e.icon||"bitcoin"==e.icon||"500px"==e.icon?i.replace("fa ","fab "):r;var a={elementClass:e.title===t.title?"fr-active fr-active-tab":"",title:e.title,dataCmd:"setIconCategory",dataParam1:e.title,iconValue:o.replace(/\[NAME\]/g,e.icon)};s+='<button class="fr-fa-icon-category fr-command fr-btn '.concat(a.elementClass,'" title="').concat(a.title,'" data-cmd="').concat(a.dataCmd,'" data-param1="').concat(a.dataParam1,'"</button><span>').concat(a.iconValue,"</span>")})}else e.forEach(function(e){var a={elementClass:e.title===t.title?"fr-active fr-active-tab":"",title:e.title,dataCmd:"setIconCategory",dataParam1:e.title,iconValue:r.replace(/\[NAME\]/g,e.icon)};s+='<button class="fr-fa-icon-category fr-command fr-btn '.concat(a.elementClass,'" title="').concat(a.title,'" data-cmd="').concat(a.dataCmd,'" data-param1="').concat(a.dataParam1,'"</button><span>').concat(a.iconValue,"</span>")});return s}(e,a,t),"\n        </div>\n        ")}(o,t,h.opts.fontAwesomeTemplate),"\n                     ").concat(function s(e,a){return'\n        <div class="fr-icon-container fr-fa-container">\n            '.concat(function t(e,n){var l="";return e.list.forEach(function(e){if("font_awesome_5"===h.opts.iconsTemplate){var a={name:e,fprefix:"fa"},t=e.trim().split(" ");1<t.length&&(a={name:t[1],fprefix:t[0]});var r=h.opts.fontAwesomeTemplate.replace(/\[NAME\]|\[FPREFIX\]/g,function(e){return a[e.substring(1,e.length-1).toLowerCase()]});0<r.search("fab")&&(r=r.replace("fa",""));var s=e,o=e;n.replace(/\[NAME\]/g,e),l+='<span class="fr-command fr-fa-icon fr-icon" data-cmd="insertIcon" data-param1="'+s+'" title="'+o+'" tabIndex="-1"  role="button" value="'+a.name+'" data-fprefix="'+a.fprefix+'">'+r+'<span class="fr-sr-only">'+h.language.translate("Example of")+a.name+"&nbsp;&nbsp;&nbsp;</span></span>"}else{var i={dataParam1:e,title:e,iconValue:n.replace(/\[NAME\]/g,e)};l+='<span class="fr-command fr-fa-icon fr-icon" role="button" data-cmd="insertIcon" data-param1="'.concat(i.dataParam1,'" title="').concat(i.title,'">').concat(i.iconValue,"</span>")}}),l}(e,a),"\n        </div>\n        ")}(t,h.opts.fontAwesomeTemplate))}return{setIconCategory:function n(a){t=o.filter(function(e){return e.title===a})[0],function e(){h.popups.get("fontAwesome").html(r+s())}()},showFontAwesomePopup:function l(){var e=h.popups.get("fontAwesome");if(e||(e=i()),!e.hasClass("fr-active")){h.popups.refresh("fontAwesome"),h.popups.setContainer("fontAwesome",h.$tb);var a=h.$tb.find('.fr-command[data-cmd="fontAwesome"]'),t=h.button.getPosition(a),r=t.left,s=t.top;h.popups.show("fontAwesome",r,s,a.outerHeight())}},back:function e(){h.popups.hide("fontAwesome"),h.toolbar.showInline()}}},g.DefineIcon("fontAwesome",{NAME:"flag",SVG_KEY:"fontAwesome"}),g.RegisterCommand("fontAwesome",{title:"Font Awesome",icon:"fontAwesome",undo:!1,focus:!1,refreshAfterCallback:!1,popup:!0,callback:function(){this.popups.isVisible("fontAwesome")?(this.$el.find(".fr-marker")&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("fontAwesome")):this.fontAwesome.showFontAwesomePopup()},plugin:"fontAwesome",showOnMobile:!0}),g.RegisterCommand("insertIcon",{callback:function(e,a){if(this.opts&&"font_awesome_5"===this.opts.iconsTemplate){var t={name:a,fprefix:"fa"},r=this.opts.fontAwesomeTemplate.replace(/\[NAME\]|\[FPREFIX\]/g,function(e){return t[e.substring(1,e.length-1).toLowerCase()]});this.undo.saveStep(),this.html.insert(r,!0),this.undo.saveStep()}else this.undo.saveStep(),this.html.insert("".concat(this.opts.fontAwesomeTemplate.replace(/\[NAME\]/g,a),"&nbsp;")),this.undo.saveStep();this.popups.hide("fontAwesome")}}),g.RegisterCommand("setIconCategory",{undo:!1,focus:!1,callback:function(e,a){this.fontAwesome.setIconCategory(a)}}),g.DefineIcon("fontAwesomeBack",{NAME:"arrow-left",SVG_KEY:"back"}),g.RegisterCommand("fontAwesomeBack",{title:"Back",undo:!1,focus:!1,back:!0,refreshAfterCallback:!1,callback:function(){this.fontAwesome.back()}})});

/*!
 Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 For licensing, see LICENSE.html or https://ckeditor.com/sales/license/ckfinder
 */
var CKFinder = function () {
  function __internalInit(e) {
    return (e = e || {})[S("\rjj}~_vgfwp}")] = S("\x10Ezzg5\x7fd8x:\x7fypq?VDPPMJH\x07GO\nhgkGATT@\x13\x07"), e[S("<U[S,.")] = S('#l@JKG\tLN@AAX\x10R@RW^SE\x19\x19m^\x1c\\LZ`3\'"()?g;(.k8%/;p(=&t4$2x-("539\x7f\x14\x0eB\0\x16\x04\x05\fH\x06\x1f\x19L\f\x1e\x1f\x1c\x18\x11\x12\0\x1c\x19\x19XTZ\f\x19]\x0e\nt!nlpv&hn)omjb|{0e}3wgsvl|:rh3>') + S('\x14Bybt}:bsh>sIJG\x03PJ\x06@M]\nJ\fK\\JU\x11qxr\\XS]K\x1aWU^[Q3$}c\x02 #+h/8.)m: p"\'19<"w!6/)|),>\x0e\x12\x0e\x02\x10\f\t\tII\x02\x1f\x18\x1d\x1dU_^\x11\x18\x11\x11\x1f\x03\x17\vT\x18\x13\x10Q\x1bobq,gn`nfmoy#neiy\x7fvvf&9496}nuy{0DDT|PWGI[EK_EB@\\'), e[S("\x1bunZzMN")] = !0, e
  }

  var connectors = {
    php: S("\x1axso{0CNLMAFRHZ\x06ZC\\\x02M@^_WP@ZD\x19HQJ"),
    net: S("5\x19TS_SUXXL\x10#.,-!&2(:"),
    java: S("Dj%,. $/)?a,??<67!9%")
  }, connector = S("?0)2");

  function internalCKFinderInit(e, t, n) {
    var i = t.getElementsByTagName(S("*CILJ"))[0], r = t.createElement(S("\x18jyiumj"));
    r[r.innerText ? S("\x0ef~\x7fwa@pnc") : S("\rga~t`[@XZ")] = n + S("2\x1dw~p^V]_I\x12bMZ442kd2/),&=gl)!,%<7= u\x7fl\x1b\x12\x1c229;-N\x12\x16\x02\x16\x11N") + JSON.stringify(e) + S("+\x05\x16"), i.appendChild(r)
  }

  function configOrDefault(e, t) {
    return e || t
  }

  function createUrlParams(e) {
    var t = [];
    for (var n in e) t.push(encodeURIComponent(n) + "=" + encodeURIComponent(e[n]));
    return "?" + t.join("&")
  }

  function extendObject(e, t) {
    for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
    return e
  }

  function getCookie(e) {
    e = e.toLowerCase();
    for (var t = window.document.cookie.split(";"), n = 0; n < t.length; n++) {
      var i = t[n].split("="), r = decodeURIComponent(i[0].trim().toLowerCase()), o = 1 < i.length ? i[1] : "";
      if (r === e) return decodeURIComponent(o)
    }
    return null
  }

  function setCookie(e, t) {
    window.document.cookie = encodeURIComponent(e) + "=" + encodeURIComponent(t) + S("Ay3%1.zg")
  }

  function updateIOSConfig(e, t) {
    e._iosWidgetHeight = parseInt(getComputedStyle(t).height), e._iosWidgetWidth = parseInt(getComputedStyle(t).width)
  }

  function checkOnInit(t, e) {
    var n = e.navigator.userAgent;
    if ((0 < n.indexOf(S("(dybi\r")) || 0 < n.indexOf(S("5bEQ]_UH\x12")) || 0 < n.indexOf(S("\x0fUuuv;"))) && e.addEventListener(S("%ELN@DOI_|JQUK"), function (n) {
      setTimeout(function () {
        var e = n.detail.ckfinder, t = getCookie(S("/SZq@FSbXS\\T"));
        t || (t = e.request(S("A!06#| -=\x1e$'( ")), setCookie(S("\x1b\x7fv]lRGvLO@H"), t)), e.request(S("E/)<,8%-!t,##4i'0\"\x079+?5(\n71\x04\x0e\x157\v\x0e\x03\t"), {token: t})
      }, 1e3)
    }), t && !t._omitCheckOnInit && "function" == typeof t.onInit) {
      var i = t.onInit;
      delete t.onInit, e.addEventListener(S('A!(",(#-;\x18.-)7'), function (e) {
        t._initCalled || (t._initCalled = !0, i(e.detail.ckfinder))
      })
    }
  }

  var basePath = function () {
    if (parent && parent.CKFinder && parent.CKFinder.basePath) return parent.CKFinder.basePath;
    var e, t, n, i = document.getElementsByTagName(S("\x13gvd~hm"));
    for (e = 0; e < i.length && (!(n = void 0 !== (t = i[e]).getAttribute.length ? t.src : t.getAttribute(S("7KKY"))) || -1 === n.split("/").slice(-1)[0].indexOf(S("<^UY)/&&6k,4"))); e++) ;
    return n.split("/").slice(0, -1).join("/") + "/"
  }(), Modal = {
    open: function (e) {
      if (e = e || {}, !Modal.div) {
        Modal.heightAdded = 48, Modal.widthAdded = 2;
        var r, o, t = Math.min(configOrDefault(e.width, 1e3), window.innerWidth - Modal.widthAdded),
          n = Math.min(configOrDefault(e.height, 700), window.innerHeight - Modal.heightAdded), s = !1, a = !1, i = 0,
          l = 0, u = e.width, c = e.height;
        e.width = e.height = S("\x1c,./\x05");
        var d = Modal.div = document.createElement(S("4Q_A"));
        d.id = S('@")%i()#)%'), d.style.position = S(")LBTHJ"), d.style.top = (document.documentElement.clientHeight - Modal.heightAdded) / 2 - n / 2 + S(">O8"), d.style.left = (document.documentElement.clientWidth - Modal.widthAdded) / 2 - t / 2 + S("<MF"), d.style.background = S(":\x18Z[X"), d.style.border = S("\f<~w0b}\x7f}q64yx{"), d.style.boxShadow = S("$\x16V_\b\x1aZS\f\x18^W\x10CUQU\x1d\x06\x1b\b\x15\n\x17\f\x13\f\x16"), d.style.zIndex = 8999, d.innerHTML = S("\x1a'xth?IE\x1f\x01GN@\nEFNJ@\0FJQUWA\x16\x15ECAU_\x06\x1e^KM3.0yd()1-rj#)$)'$kaf$-vv14*4.)?1\x14ZB\x01\x05\x06\r\0\x1a\x06\x1f\x05\bWNL\x16\x10\x14\x12\x12\x14TI") + S(";\0\\\x1eL48.&yg +'(>ql?'(8%is$42317=a|j.'@PR\x13\x1cEVGI\0\x07\x1b\x03\x1f\x1a\x0e\x1e\x05IS\x19\x14\x04\x10\x11\x17@[L]_\x16mqmqpdhs3)ldby#iq|{\x7fm/6Vjp{w0=m~NR\x0fPAWOA\b\bCF\\B\\[Q_F\b\x14SYYL\x14M^UZVKz#-/ ~f!''>f?$4*jq`c$-vv14*4.)?1\x14ZB\x0f\r\v\x03J\0\f\x03\f\x04\x19TOBA\x02\vTT\x1f\x1a\b\x16\b\x0f\x1d\x13\nD ug{p(bbkfxjxdaa*1||zp66qtjtni\x7fqT\x1a\x02@KIIU\x12\t\t\x13\x14\x15\x0e\x0eY\\B\\FAWYL\x02\x18\x1bUY\x03\x1d#*$n)*\"&$d)'#>+mp9 62httzg\x8dgs<`") + S("$\x19\tCA_\x14") + S("&\x1bL@\\\vEI\x13\rSZT\x1eYZRVT\x14XTXD\x1c\x1f35;/!xd7':#?%\" up#7?5!?!=b-28)6e@") + t + S("\x1ble%?HDKDLQ\x1c\x07") + n + S("\x13dm4)$6~rj#") + S('.\x13TXD\x13]Q\v\x15[R\\\x16QRZ^,l$,+1#5ji9?5!+rr97:3="mxhj+$}\x7f6\r\x11\r\x11\x10\x04\b\x13SI\b\n\x0f\x06\t\x1d\x1f\x04\x1c\x17NUU\x11K\x1fI\x1dO_@') + S("\f1}\x7fq\x7f2zp(4ts\x7f7vsy\x7fs\rSGPM_C\n@HDO@H\x03\\G\x13\x12@@LZR\x05\x1bYNNNQMza14i7#4!3/pl:'+$9hsc%.lx1?2;5*e@V\x12\x1b_E\x02\x0e\x1b\x19\x06\n\x15WN\r\x1c\x1e\x11\x18OU\x10\x1b\x17\x18\x0eA\\\x11\x1b\x19t:\"akwbbz$fnjy4/#aj3gzz~|99\x7fxy%?BNPGAW\vEG]^DA\x17\x0e\x1c@I\x12@[Y_S\x18\x1a^_X\x06\x1c\x01|n13%+x") + S("?|22\"*e/#uk) *`# 40>~&0%>\"<w3=3:3\x05L\x11\x06FE\x15\x13\x11\x05\x0fVN\x0e\x1b\x1d\x03\x1e\0IT\x06\x13Z\n\x1c\t\x12\x06\x18E_whfwl?&0xq1+dhghxe(3#en,8}shlq\x7ff\x1a\x01@OKFM\x1c\bOFDMY\x14\x0fBXU[@\x0e\x16UWK^^N\x10LV')6ydv6?h:%'%)nl456ht79%<<(v>2*+\x0f\fXCW\x15\x1eG\x1b\x06\x06\x02\bMM\v\x14\x15IQJIY\x04\b\x18\x14E") + S("\x18%5\x7fuk "), document.body.appendChild(d), CKFinder.widget(S("\nhgk#b\x7fus\x7f9wysa"), e), Modal.footer = document.getElementById(S("=]T&l/, $*j.&%?)?")), window.addEventListener(S("\x1fOSKFJQGSAFDHDL@HU"), function () {
          Modal.maximized || setTimeout(function () {
            t = Math.min(configOrDefault(u, 1e3), document.documentElement.clientWidth - Modal.widthAdded), n = Math.min(configOrDefault(c, 700), document.documentElement.clientHeight - Modal.heightAdded);
            var e = document.getElementById(S("4V]Q\x15TU_]Q\x13]/%;"));
            e.style.width = t + S("\x0e\x7fh"), e.style.height = n + S("<MF"), d.style.top = (document.documentElement.clientHeight - Modal.heightAdded) / 2 - n / 2 + S("\n{t"), d.style.left = (document.documentElement.clientWidth - Modal.widthAdded) / 2 - t / 2 + S("\x1fPY")
          }, 100)
        }), b(document.getElementById(S("\x14v}q5tu\x7f}q3|LNQF")), [S(";_QW\\+"), S("?4.7 , (#")], function (e) {
          e.stopPropagation(), e.preventDefault(), Modal.close()
        });
        var f = Modal.header = document.getElementById(S('8ZQ]\x11PQ[!-o+!$"":')), h = d.offsetLeft, g = d.offsetTop;
        b(f, [S("=SP52''+2("), S("7LVOXTNJ^25")], function (e) {
          e.preventDefault(), !0;
          var t = x(e);
          i = t.x, l = t.y, h = i - d.offsetLeft, g = l - d.offsetTop, y.appendChild(C), b(document, [S("\x1erOTQFIJPB"), S("D1)2+!'$:(")], E)
        }), b(f, [S("&JG\\YNY]"), S("*_CXMGU_V")], function () {
          !1, C.parentNode === y && y.removeChild(C), _(document, [S("!OLQVCJG_O"), S("C0*3$ $%=)")], E)
        });
        var p, v, m = document.getElementById(S("\nhgk#b\x7fus\x7f9gsdqc\x7f6t|p{LD\x0fPA")),
          w = document.getElementById(S("\x1fCJD\x0eIJBFD\x04XN_DTJ\x1dYS]PYS\x1aKN")),
          y = Modal.body = document.getElementById(S("/SZT\x1eYZRVT\x14XTXD")),
          C = document.createElement(S("\x13p|`"));
        C.style.position = S("\x19{yorrjTD"), C.style.top = C.style.right = C.style.bottom = C.style.left = 0, C.style.zIndex = 1e5, b(m, [S("A/,16##'>$"), S("\x11f|av~dlxho")], function (e) {
          s = !0, I(e)
        }), b(w, [S("A/,16##'>$"), S("%RH]JBXXL\\[")], function (e) {
          h = d.offsetLeft, a = !0, I(e)
        })
      }

      function b(t, e, n) {
        e.forEach(function (e) {
          t.addEventListener(e, n)
        })
      }

      function _(t, e, n) {
        e.forEach(function (e) {
          t.removeEventListener(e, n)
        })
      }

      function x(e) {
        return 0 === e.type.indexOf(S("&SG\\IC")) ? {
          x: e.touches[0].pageX,
          y: e.touches[0].pageY
        } : {x: document.all ? window.event.clientX : e.pageX, y: document.all ? window.event.clientX : e.pageY}
      }

      function E(e) {
        var t = x(e);
        i = t.x;
        var n = (l = t.y) - g;
        d.style.left = i - h + S("9JC"), d.style.top = (n < 0 ? 0 : n) + S("\x12cl")
      }

      function M(e) {
        var t, n, i = x(e);
        s ? (t = r - (p - i.x), n = o - (v - i.y), 200 < t && (y.style.width = t + S("D5>")), 200 < n && (y.style.height = n + S("\x1ble"))) : a && (t = r + (p - i.x), n = o - (v - i.y), 200 < t && (y.style.width = t + S("\x1eoX"), d.style.left = h - (p - i.x) + S("\x12cl")), 200 < n && (y.style.height = n + S("\x0e\x7fh")))
      }

      function F() {
        C.parentNode === y && y.removeChild(C), a = s = !1, _(document, [S("5[XMJ_VSK["), S("\x10e}fw}{xn|")], M), _(document, [S("\rc`ebwfd"), S("\x1djpUBJFJA")], F)
      }

      function I(e) {
        e.preventDefault();
        var t = x(e);
        p = t.x, v = t.y, r = y.clientWidth, o = y.clientHeight, y.appendChild(C), b(document, [S('"NKPUBEF\\N'), S("\rz`erz~{cs")], M), b(document, [S("A/,16#28"), S("\x16cwlysysz")], F)
      }
    }, close: function () {
      Modal.div && (document.body.removeChild(Modal.div), Modal.div = null, Modal.maximized && (document.documentElement.style.overflow = Modal.preDocumentOverflow, document.documentElement.style.width = Modal.preDocumentWidth, document.documentElement.style.height = Modal.preDocumentHeight))
    }, maximize: function (e) {
      e ? (Modal.preDocumentOverflow = document.documentElement.style.overflow, Modal.preDocumentWidth = document.documentElement.style.width, Modal.preDocumentHeight = document.documentElement.style.height, document.documentElement.style.overflow = S("?((&'!+"), document.documentElement.style.width = 0, document.documentElement.style.height = 0, Modal.preLeft = Modal.div.style.left, Modal.preTop = Modal.div.style.top, Modal.preWidth = Modal.body.style.width, Modal.preHeight = Modal.body.style.height, Modal.preBorder = Modal.div.style.border, Modal.div.style.left = Modal.div.style.top = Modal.div.style.right = Modal.div.style.bottom = 0, Modal.body.style.width = S("+\x1d\x1d\x1e\n"), Modal.body.style.height = S("4\x04\x06\x07\x1d"), Modal.div.style.border = "", Modal.header.style.display = S("\vbb`j"), Modal.footer.style.display = S('C**("'), Modal.maximized = !0) : (document.documentElement.style.overflow = Modal.preDocumentOverflow, document.documentElement.style.width = Modal.preDocumentWidth, document.documentElement.style.height = Modal.preDocumentHeight, Modal.div.style.right = Modal.div.style.bottom = "", Modal.div.style.left = Modal.preLeft, Modal.div.style.top = Modal.preTop, Modal.div.style.border = Modal.preBorder, Modal.body.style.width = Modal.preWidth, Modal.body.style.height = Modal.preHeight, Modal.header.style.display = S("\fob`sz"), Modal.footer.style.display = S("7ZUUXW"), Modal.maximized = !1)
    }
  };

  function S(e) {
    for (var t = "", n = e.charCodeAt(0), i = 1; i < e.length; ++i) t += String.fromCharCode(e.charCodeAt(i) ^ i + n & 127);
    return t
  }

  var _r = /(window|S("A0&5j4"))/, ckfPopupWindow;

  function isIE9() {
    var e, t = -1;
    return navigator.appName == S("C\t,%5':%-8m\x07!$4 =1!v\x12 )64.8,") && (e = navigator.userAgent, null !== new RegExp(S(".bcxw\x13\x1cn\x06\x1a\x01dA\n\x10@e\x11pl{\x1e?uj:a")).exec(e) && (t = parseFloat(RegExp.$1))), 9 === t
  }

  return {
    basePath: basePath, connector: connector, _connectors: connectors, modal: function (e) {
      return e === S("/S]]@Q") ? Modal.close() : e === S("7NPIR^Q[") ? !!Modal.div : e === S(">R!9+.-?#") ? Modal.maximize(!0) : e === S("\x1fMHLJIL\\B") ? Modal.maximize(!1) : void Modal.open(e)
    }, config: function (e) {
      CKFinder._config = e
    }, widget: function (e, t) {
      if (t = t || {}, !e) throw S("\x1bRr>=IE\0\x03KURNGG\nOIKGAUU\x12ZZ\x15u|~PT_YO\x10H)%%&0mog+(&'b");

      function n(e) {
        return e + (/^[0-9]+$/.test(e) ? S("$U^") : "")
      }

      var i = S("C&*4#-;p%##+t");
      i += S("\x1fWHFWL\x1f") + n(configOrDefault(t.width, S("*\x1a\x1c\x1d\v"))) + ";", i += S("\x1btxwxHU\x18") + n(configOrDefault(t.height, S("%\x12\x17\x18"))) + ";";
      var r = document.createElement(S('"JBWGJM'));
      r.src = "", r.setAttribute(S("@26:( "), i), r.setAttribute(S("\x12`qt{{}ji"), S("\x1ahy|ssERQ")), r.setAttribute(S("6D[KUWPTPX"), S("\x1fATVL")), r.setAttribute(S("C0$$.&-/3"), configOrDefault(t.tabindex, 0)), r.attachEvent ? r.attachEvent(S("C++*()-"), function () {
        internalCKFinderInit(t, r.contentDocument, S("$UGUMG^"))
      }) : r.onload = function () {
        /iPad|iPhone|iPod/.test(navigator.platform) && (updateIOSConfig(t, r), r.contentWindow.addEventListener(S("$FMAAGNN^\x7fKNTH"), function (e) {
          e.detail.ckfinder.on(S(":NU\x07LZ3(8&"), function (e) {
            updateIOSConfig(e.finder.config, r)
          }, null, null, 1)
        })), internalCKFinderInit(t, r.contentDocument, S("\x1dn~RDLW"))
      };
      var o = document.getElementById(e);
      if (!o) throw S(':xw{WQ$$0m3," -=bbvm- %=6s::"w>04?|82:\r\x04\f\x17D\x12\x0f\x13\0I\x03\x0fLO') + e + S("&\x05\x06");
      o.innerHTML = "", o.appendChild(r), checkOnInit(t, r.contentWindow)
    }, popup: function (e) {
      e = e || {}, window.CKFinder._popupOptions = e;
      var t, n = isIE9() ? window.CKFinder.basePath + S("\x16ts\x7fsuxxl1HUOO") : S("2RVZCC\x02[VZRV"),
        i = S("\x1aws~\x7fkINL\x1eJJ\nJMG_IM_\x13A_\x1dF\\[YTVJ\x04TT\x10Y[O%/&&*1{>-:f&%#'\"9+3180k97u748<2b\x19\x04\x11O\x05\t\x11\x06\x11\x1a8\n\x05\x1e\v\vM\b\x17\0X\x07\x13\x04\x11\x03\x1b\x19\x10\x18C\x06er.pgwikdkky\x7f0wjc");
      i += S("$\tQNL]B\x16") + configOrDefault(e.width, 1e3), i += S("0\x1dZV]R^C\x05") + configOrDefault(e.height, 700), i += S("-\x02[_A\x0f\x06\x04"), i += S('\x196wy{j"\x11\x11\x12'), void 0 === ckfPopupWindow || ckfPopupWindow.closed || ckfPopupWindow.close();
      try {
        var r = S("\x14V]QHvjnl") + Date.now();
        ckfPopupWindow = window.open(n, r, i, !0)
      } catch (e) {
        return
      }

      function o() {
        ckfPopupWindow && ((t = ckfPopupWindow.document).open(), t.write(S('?|`\x06\f\x07\x11\x1f\x17\ri"?!!p') + S("'\x14A^F@\x13") + S('\x1d"wE@F\x1d') + S("*\x17AHZN\x10RZRFFSC\x05\x1bOOZ\x10\x06\x1d~") + S("\x11.~qaw7vxw~!?hvEVRLVQ\x04\x07KFD_ICZ\x12\x12F[W@]\vS]OSXY\x10IV$5*o-+/3!(&f?./#5lc\x7f!&3%u*9:0<<3\x05\\\f\fF[") + S("Dy2.<%/u\x0f\x06\b&>57!tfvzx\x1f379}\x1c-\x0f\x16\x11\x06\x16YI\x13\x01\x1d\x06\x0eR") + S("\x10-={qtr)") + S("1\x0eQ[QO\t") + S("Cx6%5!9>k??-rr") + window.CKFinder.basePath + S("7[R\\RRY[Mn+1ad&.&::/?qo;;6|jqjiy$;+3+(c") + S("+\x10^M]YAF\r") + S("D2/),&=e%>\r\x04\x168<71'\x068(,*f(/+:[") + S("=IV.%-4j*(+'(.v*8 ,$8==||v,") + S('-\x0e\x0f\x10\x11qxr\\XS]K\x14HH\\LKha5**!)0f&:."(<a\x13\x1a\x14::13%v\x06*4,(.\x10\x10\x15\v\f\n\x16FNS') + "}" + S("\x12/;fueqin%") + S("2\x0f\x1bWYSA\x07") + S("\x19&4tiss\x1e")), t.close(), ckfPopupWindow.focus())
      }

      return /iPad|iPhone|iPod/.test(navigator.platform) ? setTimeout(o, 100) : o(), ckfPopupWindow
    }, start: function (e) {
      if (!e) {
        var t = window.opener, n = {};
        e = {};
        var i = window.location.search.substring(1);
        if (i) for (var r = i.split("&"), o = 0; o < r.length; ++o) {
          var s = r[o].split("=");
          n[s[0]] = s[1] || null
        }
        if (n.popup && (window.isCKFinderPopup = !0), t && n.configId && t.CKFinder && t.CKFinder._popupOptions) {
          var a = decodeURIComponent(n.configId);
          (e = t.CKFinder._popupOptions[a] || {})._omitCheckOnInit = !0
        }
      }
      CKFinder._setup(window, document), checkOnInit(e, window), CKFinder.start(e)
    }, setupCKEditor: function (e, t, n) {
      if (e) {
        e.config.filebrowserBrowseUrl = window.CKFinder.basePath + S("\x1b\x7fvxvNEGQ\nMRJD"), n = extendObject({
          command: S("\x18Hor\x7fvKoLNCG"),
          type: S("\nMeak|")
        }, n), t = extendObject(window.CKFinder._config || {}, t);
        var i = window.CKFinder._connectors[window.CKFinder.connector];
        "/" !== i.charAt(0) && (i = window.CKFinder.basePath + i), i = o(i), Object.keys(t).length && (window.CKFinder._popupOptions || (window.CKFinder._popupOptions = {}), t._omitCheckOnInit = !0, window.CKFinder._popupOptions[e.name] = t, e.config.filebrowserBrowseUrl += S("\x1b#mqoUQ\x1f\x12\x02FIIN@MbH\x10") + encodeURIComponent(e.name), t.connectorPath && (i = o(t.connectorPath))), e.config.filebrowserUploadUrl = i + createUrlParams(n)
      } else {
        for (var r in CKEDITOR.instances) CKFinder.setupCKEditor(CKEDITOR.instances[r]);
        CKEDITOR.on(S("(@DXXL@LUr@VUASS"), function (e) {
          CKFinder.setupCKEditor(e.editor)
        })
      }

      function o(e) {
        if (/^(http(s)?:)?\/\/.+/i.test(e)) return e;
        0 !== e.indexOf("/") && (e = "/" + e);
        var t = window.parent ? window.parent.location : window.location;
        return t.protocol + S("-\x01\0") + t.host + e
      }
    }, _setup: function (window, document) {
      var CKFinder, QIa, event;
      window.CKFinder = window.CKFinder || {}, window.CKFinder.connector = connector, window.CKFinder._connectors = connectors, window.CKFinder.basePath = function () {
        if (window.parent && window.parent.CKFinder && window.parent.CKFinder.basePath) return window.parent.CKFinder.basePath;
        for (var e, t, n = document.getElementsByTagName(S("\f~m}yaf")), i = 0; i < n.length && (!(t = void 0 !== (e = n[i]).getAttribute.length ? e.src : e.getAttribute(S("1AAW"))) || -1 === t.split("/").slice(-1)[0].indexOf(S(",NEIY_VVF\x1b\\D"))); i++) ;
        return t.split("/").slice(0, -1).join("/") + "/"
      }(), function () {
        var requirejs, require, define;
        CKFinder && CKFinder.requirejs || (CKFinder ? require = CKFinder : CKFinder = {}, function (global) {
          var req, s, head, baseElement, dataMain, src, interactiveScript, currentlyAddingScript, mainScript, subPath,
            version = S("<\x0f\x10\x0ensp"), commentRegExp = /(\/\*([\s\S]*?)\*\/|([^:]|^)\/\/(.*)$)/gm,
            cjsRequireRegExp = /[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g, jsSuffixRegExp = /\.js$/,
            currDirRegExp = /^\.\//, op = Object.prototype, ostring = op.toString, hasOwn = op.hasOwnProperty,
            ap = Array.prototype,
            isBrowser = !(void 0 === window || "undefined" == typeof navigator || !window.document),
            isWebWorker = !isBrowser && "undefined" != typeof importScripts,
            readyRegExp = isBrowser && navigator.platform === S(":kp|gl\x14\0\x16\n\v\vft") ? /^complete$/ : /^(complete|loaded)$/,
            defContextName = "_",
            isOpera = "undefined" != typeof opera && opera.toString() === S(".t_SXVWA\x16xH\\HZa"), contexts = {},
            cfg = {}, globalDefQueue = [], useInteractive = !1;

          function isFunction(e) {
            return "[object Function]" === ostring.call(e)
          }

          function isArray(e) {
            return "[object Array]" === ostring.call(e)
          }

          function each(e, t) {
            var n;
            if (e) for (n = 0; n < e.length && (!e[n] || !t(e[n], n, e)); n += 1) ;
          }

          function eachReverse(e, t) {
            var n;
            if (e) for (n = e.length - 1; -1 < n && (!e[n] || !t(e[n], n, e)); n -= 1) ;
          }

          function hasProp(e, t) {
            return hasOwn.call(e, t)
          }

          function getOwn(e, t) {
            return hasProp(e, t) && e[t]
          }

          function eachProp(e, t) {
            var n;
            for (n in e) if (hasProp(e, n) && t(e[n], n)) break
          }

          function mixin(n, e, i, r) {
            return e && eachProp(e, function (e, t) {
              !i && hasProp(n, t) || (!r || "object" != typeof e || !e || isArray(e) || isFunction(e) || e instanceof RegExp ? n[t] = e : (n[t] || (n[t] = {}), mixin(n[t], e, i, r)))
            }), n
          }

          function bind(e, t) {
            return function () {
              return t.apply(e, arguments)
            }
          }

          function scripts() {
            return document.getElementsByTagName(S("\v\x7fn|f`e"))
          }

          function defaultOnError(e) {
            throw e
          }

          function getGlobal(e) {
            if (!e) return e;
            var t = global;
            return each(e.split("."), function (e) {
              t = t[e]
            }), t
          }

          function makeError(e, t, n, i) {
            var r = new Error(t + S("\x16\x1dpmnk&21mEPWJV@LT\x06FXL\x03IALC\x1eWAFZDD\x16QNVP\x1e") + e);
            return r.requireType = e, r.requireModules = i, n && (r.originalError = n), r
          }

          if (void 0 === define) {
            if (void 0 !== requirejs) {
              if (isFunction(requirejs)) return;
              cfg = requirejs, requirejs = void 0
            }
            void 0 === require || isFunction(require) || (cfg = require, require = void 0), req = requirejs = function (e, t, n, i) {
              var r, o, s = defContextName;
              return isArray(e) || "string" == typeof e || (o = e, isArray(t) ? (e = t, t = n, n = i) : e = []), o && o.context && (s = o.context), (r = getOwn(contexts, s)) || (r = contexts[s] = req.s.newContext(s)), o && r.configure(o), r.require(e, t, n)
            }, req.config = function (e) {
              return req(e)
            }, req.nextTick = "undefined" != typeof setTimeout ? function (e) {
              setTimeout(e, 4)
            } : function (e) {
              e()
            }, require || (require = req), req.version = version, req.jsExtRegExp = /^\/|:|\?|\.js$/, req.isBrowser = isBrowser, s = req.s = {
              contexts: contexts,
              newContext: newContext
            }, req({}), each([S("\x18muNnq"), S("*^BIKI"), "defined", S("@22&', .--")], function (t) {
              req[t] = function () {
                var e = contexts[defContextName];
                return e.require[t].apply(e, arguments)
              }
            }), isBrowser && (head = s.head = document.getElementsByTagName(S("@)'\" "))[0], baseElement = document.getElementsByTagName(S('?" 1&'))[0], baseElement && (head = s.head = baseElement.parentNode)), req.onError = defaultOnError, req.createNode = function (e, t, n) {
              var i = e.xhtml ? document.createElementNS(S("5^CLI\0\x14\x13JIHn6qm+7!hypsrc5&;=="), S("*CX@B\x15CR@ZDA")) : document.createElement(S("\x14fueqin"));
              return i.type = e.scriptType || S("\x17l|bo3w\x7fiARAQMUR"), i.charset = S("\x14`bq5!"), i.async = !0, i
            }, req.load = function (t, n, i) {
              var e, r = t && t.config || {};
              if (isBrowser) return e = req.createNode(r, n, i), r.onNodeCreated && r.onNodeCreated(e, r, n, i), e.setAttribute(S("&CI]K\x06^H_ZYCWP[[BR@M"), t.contextName), e.setAttribute(S("0USGU\x18DRILSIYPQ[5-'"), n), !e.attachEvent || e.attachEvent.toString && e.attachEvent.toString().indexOf(S("\nPblzfft2p{qs")) < 0 || isOpera ? (e.addEventListener(S("\x1bpr\x7f{"), t.onScriptLoad, !1), e.addEventListener(S(">Z23-1"), t.onScriptError, !1)) : (useInteractive = !0, e.attachEvent(S("\x10~|aqtrnkm{oy~v~NFG"), t.onScriptLoad)), e.src = i, currentlyAddingScript = e, baseElement ? head.insertBefore(e, baseElement) : head.appendChild(e), currentlyAddingScript = null, e;
              if (isWebWorker) try {
                importScripts(i), t.completeLoad(n)
              } catch (e) {
                t.onError(makeError(S("\x1evMQMQPVEUAY^X"), S(" HOSKWRtK[C[X^\x0eIQX^VP\x15PXJ\x19") + n + S("3\x14TB\x17") + i, e, [n]))
              }
            }, isBrowser && !cfg.skipDataMain && eachReverse(scripts(), function (e) {
              if (head || (head = e.parentNode), dataMain = e.getAttribute(S("7\\XNZ\x11P_V."))) return mainScript = dataMain, cfg.baseUrl || (mainScript = (src = mainScript.split("/")).pop(), subPath = src.length ? src.join("/") + "/" : S("#\n\n"), cfg.baseUrl = subPath), mainScript = mainScript.replace(jsSuffixRegExp, ""), req.jsExtRegExp.test(mainScript) && (mainScript = dataMain), cfg.deps = cfg.deps ? cfg.deps.concat(mainScript) : [mainScript], !0
            }), define = function (e, n, t) {
              var i, r;
              "string" != typeof e && (t = n, n = e, e = null), isArray(n) || (t = n, n = null), !n && isFunction(t) && (n = [], t.length && (t.toString().replace(commentRegExp, "").replace(cjsRequireRegExp, function (e, t) {
                n.push(t)
              }), n = (1 === t.length ? [S("\x17j|knuo{")] : [S("\f\x7fk~ex`v"), S("C!=6(:=9"), S("'EFN^@H")]).concat(n))), useInteractive && (i = currentlyAddingScript || getInteractiveScript()) && (e || (e = i.getAttribute(S('@%#7%h4"9<#9) !+%=7'))), r = contexts[i.getAttribute(S(".KQES\x1eFPGBQK_XSSJZ85"))]), r ? (r.defQueue.push([e, n, t]), r.defQueueMap[e] = !0) : globalDefQueue.push([e, n, t])
            }, define.amd = {jQuery: !0}, req.exec = function (text) {
              return eval(text)
            }, req(cfg)
          }

          function newContext(l) {
            var n, e, h, u, c,
              p = {waitSeconds: 7, baseUrl: S("/\x1e\x1e"), paths: {}, bundles: {}, pkgs: {}, shim: {}, config: {}},
              d = {}, f = {}, i = {}, g = [], v = {}, r = {}, m = {}, w = 1, y = 1;

            function C(e, t, n) {
              var i, r, o, s, a, l, u, c, d, f, S = t && t.split("/"), h = p.map, g = h && h["*"];
              if (e && (l = (e = e.split("/")).length - 1, p.nodeIdCompat && jsSuffixRegExp.test(e[l]) && (e[l] = e[l].replace(jsSuffixRegExp, "")), "." === e[0].charAt(0) && S && (e = S.slice(0, S.length - 1).concat(e)), function (e) {
                var t, n;
                for (t = 0; t < e.length; t++) if ("." === (n = e[t])) e.splice(t, 1), t -= 1; else if (".." === n) {
                  if (0 === t || 1 === t && ".." === e[2] || ".." === e[t - 1]) continue;
                  0 < t && (e.splice(t - 1, 2), t -= 2)
                }
              }(e), e = e.join("/")), n && h && (S || g)) {
                e:for (o = (r = e.split("/")).length; 0 < o; o -= 1) {
                  if (a = r.slice(0, o).join("/"), S) for (s = S.length; 0 < s; s -= 1) if ((i = getOwn(h, S.slice(0, s).join("/"))) && (i = getOwn(i, a))) {
                    u = i, c = o;
                    break e
                  }
                  !d && g && getOwn(g, a) && (d = getOwn(g, a), f = o)
                }
                !u && d && (u = d, c = f), u && (r.splice(0, c, u), e = r.join("/"))
              }
              return getOwn(p.pkgs, e) || e
            }

            function b(t) {
              isBrowser && each(scripts(), function (e) {
                if (e.getAttribute(S("3PTBV\x15K_JITLZ-.&6( ")) === t && e.getAttribute(S("/TPFR\x19GSFMPH^_RPK%96")) === h.contextName) return e.parentNode.removeChild(e), !0
              })
            }

            function _(e) {
              var t = getOwn(p.paths, e);
              if (t && isArray(t) && 1 < t.length) return t.shift(), h.require.undef(e), h.makeRequire(null, {skipMap: !0})([e]), !0
            }

            function x(e) {
              var t, n = e ? e.indexOf("!") : -1;
              return -1 < n && (t = e.substring(0, n), e = e.substring(n + 1, e.length)), [t, e]
            }

            function E(e, t, n, i) {
              var r, o, s, a, l = null, u = t ? t.name : null, c = e, d = !0, f = "";
              return e || (d = !1, e = "_@r" + (w += 1)), l = (a = x(e))[0], e = a[1], l && (l = C(l, u, i), o = getOwn(v, l)), e && (l ? f = o && o.normalize ? o.normalize(e, function (e) {
                return C(e, u, i)
              }) : -1 === e.indexOf("!") ? C(e, u, i) : e : (l = (a = x(f = C(e, u, i)))[0], f = a[1], n = !0, r = h.nameToUrl(f))), {
                prefix: l,
                name: f,
                parentMap: t,
                unnormalized: !!(s = !l || o || n ? "" : S("#{PHIG[GJ@DTJT") + (y += 1)),
                url: r,
                originalName: c,
                isDefine: d,
                id: (l ? l + "!" + f : f) + s
              }
            }

            function M(e) {
              var t = e.id, n = getOwn(d, t);
              return n || (n = d[t] = new h.Module(e)), n
            }

            function F(e, t, n) {
              var i = e.id, r = getOwn(d, i);
              !hasProp(v, i) || r && !r.defineEmitComplete ? (r = M(e)).error && t === S("\nn~\x7fa}") ? n(r.error) : r.on(t, n) : "defined" === t && n(v[i])
            }

            function I(n, e) {
              var t = n.requireModules, i = !1;
              e ? e(n) : (each(t, function (e) {
                var t = getOwn(d, e);
                t && (t.error = n, t.events.error && (i = !0, t.emit(S("\x12vfgye"), n)))
              }), i || req.onError(n))
            }

            function R() {
              globalDefQueue.length && (each(globalDefQueue, function (e) {
                var t = e[0];
                "string" == typeof t && (h.defQueueMap[t] = !0), g.push(e)
              }), globalDefQueue = [])
            }

            function T(e) {
              delete d[e], delete f[e]
            }

            function O() {
              var e, i, t = 1e3 * p.waitSeconds, r = t && h.startTime + t < (new Date).getTime(), o = [], s = [],
                a = !1, l = !0;
              if (!n) {
                if (n = !0, eachProp(f, function (e) {
                  var t = e.map, n = t.id;
                  if (e.enabled && (t.isDefine || s.push(e), !e.error)) if (!e.inited && r) _(n) ? a = i = !0 : (o.push(n), b(n)); else if (!e.inited && e.fetched && t.isDefine && (a = !0, !t.prefix)) return l = !1
                }), r && o.length) return (e = makeError(S("\x11fzypybl"), S('>s/ &c0,+"\'<>k*"<o=>6&80%mx') + o, null, o)).contextName = h.contextName, I(e);
                l && each(s, function (e) {
                  !function r(o, s, a) {
                    var e = o.map.id;
                    o.error ? o.emit(S("\x16rjkui"), o.error) : (s[e] = !0, each(o.depMaps, function (e, t) {
                      var n = e.id, i = getOwn(d, n);
                      !i || o.depMatched[t] || a[n] || (getOwn(s, n) ? (o.defineDep(t, v[n]), o.check()) : r(i, s, a))
                    }), a[e] = !0)
                  }(e, {}, {})
                }), r && !i || !a || !isBrowser && !isWebWorker || c || (c = setTimeout(function () {
                  c = 0, O()
                }, 50)), n = !1
              }
            }

            function s(e) {
              hasProp(v, e[0]) || M(E(e[0], null, !0)).init(e[1], e[2])
            }

            function o(e, t, n, i) {
              e.detachEvent && !isOpera ? i && e.detachEvent(i, t) : e.removeEventListener(n, t, !1)
            }

            function a(e) {
              var t = e.currentTarget || e.srcElement;
              return o(t, h.onScriptLoad, S("0]]RP"), S("B,*7#&,09?-9+,80<41")), o(t, h.onScriptError, S("*N^_A]")), {
                node: t,
                id: t && t.getAttribute(S("\x11vr`t;e}hornxspDTNF"))
              }
            }

            function B() {
              var e;
              for (R(); g.length;) {
                if (null === (e = g.shift())[0]) return I(makeError(S(':VUNS^4"*'), S('#iLUJI]ICII\x0eN^^\\JYZCD\x18]_]US[\x17ia/, 0*"ri') + e[e.length - 1]));
                s(e)
              }
              h.defQueueMap = {}
            }

            return u = {
              require: function (e) {
                return e.require ? e.require : e.require = h.makeRequire(e.map)
              }, exports: function (e) {
                if (e.usingExports = !0, e.map.isDefine) return e.exports ? v[e.map.id] = e.exports : e.exports = v[e.map.id] = {}
              }, module: function (e) {
                return e.module ? e.module : e.module = {
                  id: e.map.id, uri: e.map.url, config: function () {
                    return getOwn(p.config, e.map.id) || {}
                  }, exports: e.exports || (e.exports = {})
                }
              }
            }, (e = function (e) {
              this.events = getOwn(i, e.id) || {}, this.map = e, this.shim = getOwn(p.shim, e.id), this.depExports = [], this.depMaps = [], this.depMatched = [], this.pluginMaps = {}, this.depCount = 0
            }).prototype = {
              init: function (e, t, n, i) {
                i = i || {}, this.inited || (this.factory = t, n ? this.on(S("\x11wafzd"), n) : this.events.error && (n = bind(this, function (e) {
                  this.emit(S("&BZ[EY"), e)
                })), this.depMaps = e && e.slice(0), this.errback = n, this.inited = !0, this.ignore = i.ignore, i.enabled || this.enabled ? this.enable() : this.check())
              }, defineDep: function (e, t) {
                this.depMatched[e] || (this.depMatched[e] = !0, this.depCount -= 1, this.depExports[e] = t)
              }, fetch: function () {
                if (!this.fetched) {
                  this.fetched = !0, h.startTime = (new Date).getTime();
                  var e = this.map;
                  if (!this.shim) return e.prefix ? this.callPlugin() : this.load();
                  h.makeRequire(this.map, {enableBuildCallback: !0})(this.shim.deps || [], bind(this, function () {
                    return e.prefix ? this.callPlugin() : this.load()
                  }))
                }
              }, load: function () {
                var e = this.map.url;
                r[e] || (r[e] = !0, h.load(this.map.id, e))
              }, check: function () {
                if (this.enabled && !this.enabling) {
                  var t, e, n = this.map.id, i = this.depExports, r = this.exports, o = this.factory;
                  if (this.inited) {
                    if (this.error) this.emit(S("D 45';"), this.error); else if (!this.defining) {
                      if (this.defining = !0, this.depCount < 1 && !this.defined) {
                        if (isFunction(o)) {
                          try {
                            r = h.execCb(n, o, i, r)
                          } catch (e) {
                            t = e
                          }
                          if (this.map.isDefine && void 0 === r && ((e = this.module) ? r = e.exports : this.usingExports && (r = this.exports)), t) {
                            if (this.events.error && this.map.isDefine || req.onError !== defaultOnError) return t.requireMap = this.map, t.requireModules = this.map.isDefine ? [this.map.id] : null, t.requireType = this.map.isDefine ? S("\x11vvr|xr") : S("\r|jad{aq"), I(this.error = t);
                            "undefined" != typeof console && console.error ? console.error(t) : req.onError(t)
                          }
                        } else r = o;
                        if (this.exports = r, this.map.isDefine && !this.ignore && (v[n] = r, req.onResourceLoad)) {
                          var s = [];
                          each(this.depMaps, function (e) {
                            s.push(e.normalizedMap || e)
                          }), req.onResourceLoad(h, this.map, s)
                        }
                        T(n), this.defined = !0
                      }
                      this.defining = !1, this.defined && !this.defineEmitted && (this.defineEmitted = !0, this.emit("defined", this.exports), this.defineEmitComplete = !0)
                    }
                  } else hasProp(h.defQueueMap, n) || this.fetch()
                }
              }, callPlugin: function () {
                var l = this.map, u = l.id, e = E(l.prefix);
                this.depMaps.push(e), F(e, "defined", bind(this, function (e) {
                  var o, t, n, i = getOwn(m, this.map.id), r = this.map.name,
                    s = this.map.parentMap ? this.map.parentMap.name : null,
                    a = h.makeRequire(l.parentMap, {enableBuildCallback: !0});
                  return this.map.unnormalized ? (e.normalize && (r = e.normalize(r, function (e) {
                    return C(e, s, !0)
                  }) || ""), F(t = E(l.prefix + "!" + r, this.map.parentMap), "defined", bind(this, function (e) {
                    this.map.normalizedMap = t, this.init([], function () {
                      return e
                    }, null, {enabled: !0, ignore: !0})
                  })), void ((n = getOwn(d, t.id)) && (this.depMaps.push(t), this.events.error && n.on(S("=[M2.0"), bind(this, function (e) {
                    this.emit(S("\x0fuc`|f"), e)
                  })), n.enable()))) : i ? (this.map.url = h.nameToUrl(i), void this.load()) : ((o = bind(this, function (e) {
                    this.init([], function () {
                      return e
                    }, null, {enabled: !0})
                  })).error = bind(this, function (e) {
                    this.inited = !0, (this.error = e).requireModules = [u], eachProp(d, function (e) {
                      0 === e.map.id.indexOf(u + S("\x1aDisppRLCOM_CC")) && T(e.map.id)
                    }), I(e)
                  }), o.fromText = bind(this, function (e, t) {
                    var n = l.name, i = E(n), r = useInteractive;
                    t && (e = t), r && (useInteractive = !1), M(i), hasProp(p.config, u) && (p.config[n] = p.config[u]);
                    try {
                      req.exec(e)
                    } catch (e) {
                      return I(makeError(S("\fk|`}ewk`p`vt"), S("\x12ufz{C}an;yk\x7fs\0GMQ\x04") + u + S("'\bOKB@HJ\x15\x10") + e, e, [u]))
                    }
                    r && (useInteractive = !0), this.depMaps.push(i), h.completeLoad(n), a([n], o)
                  }), void e.load(l.name, a, o, p))
                })), h.enable(e, this), this.pluginMaps[e.id] = e
              }, enable: function () {
                (f[this.map.id] = this).enabled = !0, this.enabling = !0, each(this.depMaps, bind(this, function (e, t) {
                  var n, i, r;
                  if ("string" == typeof e) {
                    if (e = E(e, this.map.isDefine ? this.map : this.map.parentMap, !1, !this.skipMap), this.depMaps[t] = e, r = getOwn(u, e.id)) return void (this.depExports[t] = r(this));
                    this.depCount += 1, F(e, "defined", bind(this, function (e) {
                      this.undefed || (this.defineDep(t, e), this.check())
                    })), this.errback ? F(e, S("\x18|hiso"), bind(this, this.errback)) : this.events.error && F(e, S("0T@A[G"), bind(this, function (e) {
                      this.emit(S("=[M2.0"), e)
                    }))
                  }
                  n = e.id, i = d[n], hasProp(u, n) || !i || i.enabled || h.enable(e, this)
                })), eachProp(this.pluginMaps, bind(this, function (e) {
                  var t = getOwn(d, e.id);
                  t && !t.enabled && h.enable(e, this)
                })), this.enabling = !1, this.check()
              }, on: function (e, t) {
                var n = this.events[e];
                n || (n = this.events[e] = []), n.push(t)
              }, emit: function (e, t) {
                each(this.events[e], function (e) {
                  e(t)
                }), e === S("\x1ezRSMQ") && delete this.events[e]
              }
            }, (h = {
              config: p,
              contextName: l,
              registry: d,
              defined: v,
              urlFetched: r,
              defQueue: g,
              defQueueMap: {},
              Module: e,
              makeModuleMap: E,
              nextTick: req.nextTick,
              onError: I,
              configure: function (e) {
                e.baseUrl && "/" !== e.baseUrl.charAt(e.baseUrl.length - 1) && (e.baseUrl += "/");
                var n = p.shim, i = {paths: !0, bundles: !0, config: !0, map: !0};
                eachProp(e, function (e, t) {
                  i[t] ? (p[t] || (p[t] = {}), mixin(p[t], e, !0, !0)) : p[t] = e
                }), e.bundles && eachProp(e.bundles, function (e, t) {
                  each(e, function (e) {
                    e !== t && (m[e] = t)
                  })
                }), e.shim && (eachProp(e.shim, function (e, t) {
                  isArray(e) && (e = {deps: e}), !e.exports && !e.init || e.exportsFn || (e.exportsFn = h.makeShimExports(e)), n[t] = e
                }), p.shim = n), e.packages && each(e.packages, function (e) {
                  var t;
                  t = (e = "string" == typeof e ? {name: e} : e).name, e.location && (p.paths[t] = e.location), p.pkgs[t] = e.name + "/" + (e.main || S("\x19wzus")).replace(currDirRegExp, "").replace(jsSuffixRegExp, "")
                }), eachProp(d, function (e, t) {
                  e.inited || e.map.unnormalized || (e.map = E(t, null, !0))
                }), (e.deps || e.callback) && h.require(e.deps || [], e.callback)
              },
              makeShimExports: function (t) {
                return function () {
                  var e;
                  return t.init && (e = t.init.apply(global, arguments)), e || t.exports && getGlobal(t.exports)
                }
              },
              makeRequire: function (o, s) {
                function a(e, t, n) {
                  var i, r;
                  return s.enableBuildCallback && t && isFunction(t) && (t.__requireJsBuild = !0), "string" == typeof e ? isFunction(t) ? I(makeError(S("\x19h~mhwmE@PDW"), S("\fD`yq}{w4gsfmph~<~\x7fsL")), n) : o && hasProp(u, e) ? u[e](d[o.id]) : req.get ? req.get(h, e, o, a) : (i = E(e, o, !1, !0).id, hasProp(v, i) ? v[i] : I(makeError(S(".A_E^\\UQSS"), S("3yZRBT\\\x1aU]P[\x1fb") + i + S("\x1476\x7fyj:usi>}EDL\x03HJGCMM\nRIY\x0eI_C\x12P[[BR@M\0\x1b") + l + (o ? "" : S("\x1c3>JSD\x02QATSNZL\x02pq\x04"))))) : (B(), h.nextTick(function () {
                    B(), (r = M(E(null, o))).skipMap = s.skipMap, r.init(e, t, n, {enabled: !0}), O()
                  }), a)
                }

                return s = s || {}, mixin(a, {
                  isBrowser: isBrowser, toUrl: function (e) {
                    var t, n = e.lastIndexOf("."), i = e.split("/")[0];
                    return -1 !== n && (!("." === i || ".." === i) || 1 < n) && (t = e.substring(n, e.length), e = e.substring(0, n)), h.nameToUrl(C(e, o && o.id, !0), t, !0)
                  }, defined: function (e) {
                    return hasProp(v, E(e, o, !1, !0).id)
                  }, specified: function (e) {
                    return e = E(e, o, !1, !0).id, hasProp(v, e) || hasProp(d, e)
                  }
                }), o || (a.undef = function (n) {
                  R();
                  var e = E(n, o, !0), t = getOwn(d, n);
                  t.undefed = !0, b(n), delete v[n], delete r[e.url], delete i[n], eachReverse(g, function (e, t) {
                    e[0] === n && g.splice(t, 1)
                  }), delete h.defQueueMap[n], t && (t.events.defined && (i[n] = t.events), T(n))
                }), a
              },
              enable: function (e) {
                getOwn(d, e.id) && M(e).enable()
              },
              completeLoad: function (e) {
                var t, n, i, r = getOwn(p.shim, e) || {}, o = r.exports;
                for (R(); g.length;) {
                  if (null === (n = g.shift())[0]) {
                    if (n[0] = e, t) break;
                    t = !0
                  } else n[0] === e && (t = !0);
                  s(n)
                }
                if (h.defQueueMap = {}, i = getOwn(d, e), !t && !hasProp(v, e) && i && !i.inited) {
                  if (!(!p.enforceDefine || o && getGlobal(o))) return _(e) ? void 0 : I(makeError(S("\r``tttzzp"), S("\x1fnN\x02GACOIM\tIJ@A\x0eI_C\x12") + e, null, [e]));
                  s([e, r.deps || [], r.exportsFn])
                }
                O()
              },
              nameToUrl: function (e, t, n) {
                var i, r, o, s, a, l, u = getOwn(p.pkgs, e);
                if (u && (e = u), l = getOwn(m, e)) return h.nameToUrl(l, t, n);
                if (req.jsExtRegExp.test(e)) s = e + (t || ""); else {
                  for (i = p.paths, o = (r = e.split("/")).length; 0 < o; o -= 1) if (a = getOwn(i, r.slice(0, o).join("/"))) {
                    isArray(a) && (a = a[0]), r.splice(0, o, a);
                    break
                  }
                  s = r.join("/"), s = ("/" === (s += t || (/^data\:|\?/.test(s) || n ? "" : ".js")).charAt(0) || s.match(/^[\w\+\.\-]+:/) ? "" : p.baseUrl) + s
                }
                return p.urlArgs ? s + (-1 === s.indexOf("?") ? "?" : "&") + p.urlArgs : s
              },
              load: function (e, t) {
                req.load(h, e, t)
              },
              execCb: function (e, t, n, i) {
                return t.apply(i, n)
              },
              onScriptLoad: function (e) {
                if (e.type === S("'DFKO") || readyRegExp.test((e.currentTarget || e.srcElement).readyState)) {
                  interactiveScript = null;
                  var t = a(e);
                  h.completeLoad(t.id)
                }
              },
              onScriptError: function (e) {
                var n = a(e);
                if (!_(n.id)) {
                  var i = [];
                  return eachProp(d, function (e, t) {
                    0 !== t.indexOf("_@r") && each(e.depMaps, function (e) {
                      return e.id === n.id && i.push(t), !0
                    })
                  }), I(makeError(S('"PGWOW\\LXYC_'), S('D\x16%5!9>k)?< "q4<&ut') + n.id + (i.length ? S("Dgjg&,//))n-)kr") + i.join(S("5\x1a\x17")) : '"'), e, [n.id]))
                }
              }
            }).require = h.makeRequire(), h
          }

          function getInteractiveScript() {
            return interactiveScript && interactiveScript.readyState === S("8PTOYO_\\4(4&") || eachReverse(scripts(), function (e) {
              if (e.readyState === S(";USJZ2 !7-3#")) return interactiveScript = e
            }), interactiveScript
          }
        }(this), CKFinder.requirejs = requirejs, CKFinder.require = require, CKFinder.define = define)
      }(), CKFinder.define(S("9H^MHWM%\r+!"), function () {
      }), function () {
        var at, t = [], n = [], lt = 0, ut = +new Date + "", ct = 75, i = 40,
          dt = S("\x101\x1b\x18\x18\xb5\ufee9") + S("3>8\u201e\u201e") + S("8\u16b9\u1834\u203b\u203d\u203f\u203d\u203b\u2045\u2047\u2045\u204b\u204d\u204f\u2069\u2018\u3048"),
          ft = /\b__p \+= '';/g, St = /\b(__p \+=) '' \+/g, ht = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
          gt = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, pt = /\w*$/, vt = /^\s*function[ \n\r\t]+\w/, mt = /<%=([\s\S]+?)%>/g,
          wt = RegExp(S("A\x1c\x18") + dt + S("\vQ'>$8./=0<")), yt = /($^)/, Ct = /\bthis\b/,
          bt = /['\n\r\t\u2028\u2029\\]/g,
          _t = [S("\x11Safto"), S("\x1e]ONNFEK"), S("1vR@P"), S(")l^BNZF__"), S('A\x0f"0-'), S("\x1cSkrBDP"), S("A\r!. %3"), S(" sGDa]V"), S("2`@G_Y_"), "_", S("\x14tbcyzr^jxpk"), S("-MCUP@g]XSXMM"), S("@(1\x05-+/3-"), S('"JWkGi'), S("\r~nbbwZza"), S('"PAQrNELE^X')],
          xt = 0, Et = S("4nYUR\\YO\x1c|LX5,'-06\x1b"), Mt = "[object Array]", Ft = S("&|GK@NOY\x0em_^^VU[k"),
          It = S("\x19At~w{|T\x01fBP@{"), Rt = "[object Function]", Tt = S("\x13Ozt}}zn;Rhs}ES\x7f"),
          Ot = S("#\x7fJDMMJ^\vcODJSEo"), Bt = S("\x14Nyur|yo<O{xeYR~"), Pt = S("1i\\V_STL\x19iONTPX\x1d"), At = {};
        At[Rt] = !1, At[Et] = At[Mt] = At[Ft] = At[It] = At[Tt] = At[Ot] = At[Bt] = At[Pt] = !0;
        var Dt = {leading: !1, maxWait: 0, trailing: !1},
          Vt = {configurable: !1, enumerable: !1, value: null, writable: !1},
          Kt = {boolean: !1, function: !0, object: !0, number: !1, string: !1, undefined: !1},
          r = {"\\": "\\", "'": "'", "\n": "n", "\r": "r", "\t": "t", "\u2028": S('\x0ez"! +'), "\u2029": S("=K\rps{")},
          Ht = Kt[typeof window] && window || this, e = Kt[typeof exports] && exports && !exports.nodeType && exports,
          o = Kt[typeof module] && module && !module.nodeType && module, s = o && o.exports === e && e,
          a = Kt[typeof global] && global;

        function Nt(e, t, n) {
          for (var i = (n || 0) - 1, r = e ? e.length : 0; ++i < r;) if (e[i] === t) return i;
          return -1
        }

        function Ut(e, t) {
          var n = typeof t;
          if (e = e.cache, "boolean" == n || null == t) return e[t] ? 0 : -1;
          "number" != n && "string" != n && (n = "object");
          var i = "number" == n ? t : ut + t;
          return e = (e = e[n]) && e[i], "object" == n ? e && -1 < Nt(e, t) ? 0 : -1 : e ? 0 : -1
        }

        function l(e) {
          var t = this.cache, n = typeof e;
          if ("boolean" == n || null == e) t[e] = !0; else {
            "number" != n && "string" != n && (n = "object");
            var i = "number" == n ? e : ut + e, r = t[n] || (t[n] = {});
            "object" == n ? (r[i] || (r[i] = [])).push(e) : r[i] = !0
          }
        }

        function qt(e) {
          return e.charCodeAt(0)
        }

        function Wt(e, t) {
          for (var n = e.criteria, i = t.criteria, r = -1, o = n.length; ++r < o;) {
            var s = n[r], a = i[r];
            if (s !== a) {
              if (a < s || void 0 === s) return 1;
              if (s < a || void 0 === a) return -1
            }
          }
          return e.index - t.index
        }

        function Lt(e) {
          var t = -1, n = e.length, i = e[0], r = e[n / 2 | 0], o = e[n - 1];
          if (i && "object" == typeof i && r && "object" == typeof r && o && "object" == typeof o) return !1;
          var s = kt();
          s[S("0WS_GP")] = s[S("2]AYZ")] = s[S("2GF@S")] = s[void 0] = !1;
          var a = kt();
          for (a.array = e, a.cache = s, a.push = l; ++t < n;) a.push(e[t]);
          return a
        }

        function $t(e) {
          return "\\" + r[e]
        }

        function zt() {
          return t.pop() || []
        }

        function kt() {
          return n.pop() || {
            array: null,
            cache: null,
            criteria: null,
            false: !1,
            index: 0,
            null: !1,
            number: null,
            object: null,
            push: null,
            string: null,
            true: !1,
            undefined: !1,
            value: null
          }
        }

        function Yt(e) {
          e.length = 0, t.length < i && t.push(e)
        }

        function Qt(e) {
          var t = e.cache;
          t && Qt(t), e.array = e.cache = e.criteria = e.object = e.number = e.string = e.value = null, n.length < i && n.push(e)
        }

        function Xt(e, t, n) {
          t || (t = 0), void 0 === n && (n = e ? e.length : 0);
          for (var i = -1, r = n - t || 0, o = Array(r < 0 ? 0 : r); ++i < r;) o[i] = e[t + i];
          return o
        }

        !a || a.global !== a && a.window !== a || (Ht = a);
        var Jt = function e(i) {
          var l = (i = i ? Jt.defaults(Ht.Object(), i, Jt.pick(Ht, _t)) : Ht).Array, t = i.Boolean, n = i.Date,
            v = i.Function, r = i.Math, o = i.Number, s = i.Object, m = i.RegExp, C = i.String, w = i.TypeError, a = [],
            u = s.prototype, c = i._, b = u.toString,
            d = m("^" + C(b).replace(/[.*+?^${}()|[\]\\]/g, S("7d\x1d\x1c")).replace(/toString| for [^\]]+/g, S("$\v\f\x18")) + "$"),
            f = r.ceil, y = i.clearTimeout, h = r.floor, g = v.prototype.toString, p = ie(p = s.getPrototypeOf) && p,
            _ = u.hasOwnProperty, x = a.push, E = i.setTimeout, M = a.splice, F = a.unshift, I = function () {
              try {
                var e = {}, t = ie(t = s.defineProperty) && t, n = t(e, e, e) && t
              } catch (e) {
              }
              return n
            }(), R = ie(R = s.create) && R, T = ie(T = l.isArray) && T, O = i.isFinite, B = i.isNaN,
            P = ie(P = s.keys) && P, A = r.max, D = r.min, V = i.parseInt, K = r.random, H = {};

          function N(e) {
            return e && "object" == typeof e && !le(e) && _.call(e, S("@\x1e\x1d46$67--\x15\x14")) ? e : new U(e)
          }

          function U(e, t) {
            this.__chain__ = !!t, this.__wrapped__ = e
          }

          H[Mt] = l, H[Ft] = t, H[It] = n, H[Rt] = v, H[Ot] = s, H[Tt] = o, H[Bt] = m, H[Pt] = C, U.prototype = N.prototype;
          var q = N.support = {};

          function W(e) {
            var i = e[0], r = e[2], o = e[4];

            function s() {
              if (r) {
                var e = Xt(r);
                x.apply(e, arguments)
              }
              if (this instanceof s) {
                var t = $(i.prototype), n = i.apply(t, e || arguments);
                return be(n) ? n : t
              }
              return i.apply(o, e || arguments)
            }

            return re(s, e), s
          }

          function L(e, n, i, r, o) {
            if (i) {
              var s = i(e);
              if (void 0 !== s) return s
            }
            if (!be(e)) return e;
            var t = b.call(e);
            if (!At[t]) return e;
            var a = H[t];
            switch (t) {
              case Ft:
              case It:
                return new a(+e);
              case Tt:
              case Pt:
                return new a(e);
              case Bt:
                return (s = a(e.source, pt.exec(e))).lastIndex = e.lastIndex, s
            }
            var l = le(e);
            if (n) {
              var u = !r;
              r || (r = zt()), o || (o = zt());
              for (var c = r.length; c--;) if (r[c] == e) return o[c];
              s = l ? a(e.length) : {}
            } else s = l ? Xt(e) : he({}, e);
            return l && (_.call(e, S("$LHCMQ")) && (s.index = e.index), _.call(e, S("\x13}{fbl")) && (s.input = e.input)), n && (r.push(e), o.push(s), (l ? Be : ve)(e, function (e, t) {
              s[t] = L(e, n, i, r, o)
            }), u && (Yt(r), Yt(o))), s
          }

          function $(e, t) {
            return be(e) ? R(e) : {}
          }

          function z(r, o, e) {
            if ("function" != typeof r) return je;
            if (void 0 === o || !(S("B36*2(<0:.") in r)) return r;
            var t = r.__bindData__;
            if (void 0 === t && (q.funcNames && (t = !r.name), !(t = t || !q.funcDecomp))) {
              var n = g.call(r);
              q.funcNames || (t = !vt.test(n)), t || (t = Ct.test(n), re(r, t))
            }
            if (!1 === t || !0 !== t && 1 & t[1]) return r;
            switch (e) {
              case 1:
                return function (e) {
                  return r.call(o, e)
                };
              case 2:
                return function (e, t) {
                  return r.call(o, e, t)
                };
              case 3:
                return function (e, t, n) {
                  return r.call(o, e, t, n)
                };
              case 4:
                return function (e, t, n, i) {
                  return r.call(o, e, t, n, i)
                }
            }
            return Ze(r, o)
          }

          function k(e) {
            var i = e[0], r = e[1], o = e[2], s = e[3], a = e[4], l = e[5], u = 1 & r, c = 2 & r, d = 4 & r, f = 8 & r,
              S = i;

            function h() {
              var e = u ? a : this;
              if (o) {
                var t = Xt(o);
                x.apply(t, arguments)
              }
              if ((s || d) && (t || (t = Xt(arguments)), s && x.apply(t, s), d && t.length < l)) return r |= 16, k([i, f ? r : -4 & r, t, null, a, l]);
              if (t || (t = arguments), c && (i = e[S]), this instanceof h) {
                e = $(i.prototype);
                var n = i.apply(e, t);
                return be(n) ? n : e
              }
              return i.apply(e, t)
            }

            return re(h, e), h
          }

          function Y(e, t) {
            var n = -1, i = ne(), r = e ? e.length : 0, o = ct <= r && i === Nt, s = [];
            if (o) {
              var a = Lt(t);
              a ? (i = Ut, t = a) : o = !1
            }
            for (; ++n < r;) {
              var l = e[n];
              i(t, l) < 0 && s.push(l)
            }
            return o && Qt(t), s
          }

          function Q(e, t, n, i) {
            for (var r = (i || 0) - 1, o = e ? e.length : 0, s = []; ++r < o;) {
              var a = e[r];
              if (a && "object" == typeof a && "number" == typeof a.length && (le(a) || ae(a))) {
                t || (a = Q(a, t, n));
                var l = -1, u = a.length, c = s.length;
                for (s.length += u; ++l < u;) s[c++] = a[l]
              } else n || s.push(a)
            }
            return s
          }

          function X(i, e, r, o, s, a) {
            if (r) {
              var l = r(i, e);
              if (void 0 !== l) return !!l
            }
            if (i === e) return 0 !== i || 1 / i == 1 / e;
            var t = typeof e;
            if (!(i != i || i && Kt[typeof i] || e && Kt[t])) return !1;
            if (null == i || null == e) return i === e;
            var n = b.call(i), u = b.call(e);
            if (n == Et && (n = Ot), u == Et && (u = Ot), n != u) return !1;
            switch (n) {
              case Ft:
              case It:
                return +i == +e;
              case Tt:
                return i != +i ? e != +e : 0 == i ? 1 / i == 1 / e : i == +e;
              case Bt:
              case Pt:
                return i == C(e)
            }
            var c = n == Mt;
            if (!c) {
              var d = _.call(i, S(",rqXBPBCQQih")), f = _.call(e, S("C\x1b\x1a15)9:.(\x12\x11"));
              if (d || f) return X(d ? i.__wrapped__ : i, f ? e.__wrapped__ : e, r, o, s, a);
              if (n != Ot) return !1;
              var h = i.constructor, g = e.constructor;
              if (h != g && !(Ce(h) && h instanceof h && Ce(g) && g instanceof g) && S("0R]]GADB[MUI") in i && S("&DGGY_^XM[_C") in e) return !1
            }
            var p = !s;
            s || (s = zt()), a || (a = zt());
            for (var v = s.length; v--;) if (s[v] == i) return a[v] == e;
            var m = 0;
            if (l = !0, s.push(i), a.push(e), c) {
              if (v = i.length, m = e.length, (l = m == v) || o) for (; m--;) {
                var w = v, y = e[m];
                if (o) for (; w-- && !(l = X(i[w], y, r, o, s, a));) ; else if (!(l = X(i[m], y, r, o, s, a))) break
              }
            } else pe(e, function (e, t, n) {
              if (_.call(n, t)) return m++, l = _.call(i, t) && X(i[t], e, r, o, s, a)
            }), l && !o && pe(i, function (e, t, n) {
              if (_.call(n, t)) return l = -1 < --m
            });
            return s.pop(), a.pop(), p && (Yt(s), Yt(a)), l
          }

          function J(l, e, u, c, d) {
            (le(e) ? Be : ve)(e, function (e, t) {
              var n, i, r = e, o = l[t];
              if (e && ((i = le(e)) || xe(e))) {
                for (var s, a = c.length; a--;) if (n = c[a] == e) {
                  o = d[a];
                  break
                }
                n || (u && (s = void 0 !== (r = u(o, e))) && (o = r), s || (o = i ? le(o) ? o : [] : xe(o) ? o : {}), c.push(e), d.push(o), s || J(o, e, u, c, d))
              } else u && void 0 === (r = u(o, e)) && (r = e), void 0 !== r && (o = r);
              l[t] = o
            })
          }

          function Z(e, t) {
            return e + h(K() * (t - e + 1))
          }

          function G(e, t, n) {
            var i = -1, r = ne(), o = e ? e.length : 0, s = [], a = !t && ct <= o && r === Nt, l = n || a ? zt() : s;
            for (a && (r = Ut, l = Lt(l)); ++i < o;) {
              var u = e[i], c = n ? n(u, i, e) : u;
              (t ? !i || l[l.length - 1] !== c : r(l, c) < 0) && ((n || a) && l.push(c), s.push(u))
            }
            return a ? (Yt(l.array), Qt(l)) : n && Yt(l), s
          }

          function j(a) {
            return function (e, i, t) {
              var r = {};
              i = N.createCallback(i, t, 3);
              var n = -1, o = e ? e.length : 0;
              if ("number" == typeof o) for (; ++n < o;) {
                var s = e[n];
                a(r, s, i(s, n, e), e)
              } else ve(e, function (e, t, n) {
                a(r, e, i(e, t, n), n)
              });
              return r
            }
          }

          function ee(e, t, n, i, r, o) {
            var s = 1 & t, a = 4 & t, l = 16 & t, u = 32 & t;
            if (!(2 & t || Ce(e))) throw new w;
            l && !n.length && (t &= -17, l = n = !1), u && !i.length && (t &= -33, u = i = !1);
            var c = e && e.__bindData__;
            return c && !0 !== c ? ((c = Xt(c))[2] && (c[2] = Xt(c[2])), c[3] && (c[3] = Xt(c[3])), !s || 1 & c[1] || (c[4] = r), !s && 1 & c[1] && (t |= 8), !a || 4 & c[1] || (c[5] = o), l && x.apply(c[2] || (c[2] = []), n), u && F.apply(c[3] || (c[3] = []), i), c[1] |= t, ee.apply(null, c)) : (1 == t || 17 === t ? W : k)([e, t, n, i, r, o])
          }

          function te(e) {
            return ce[e]
          }

          function ne() {
            var e = (e = N.indexOf) === ze ? Nt : e;
            return e
          }

          function ie(e) {
            return "function" == typeof e && d.test(e)
          }

          q.funcDecomp = !ie(i.WinRTError) && Ct.test(e), q.funcNames = "string" == typeof v.name, N.templateSettings = {
            escape: /<%-([\s\S]+?)%>/g,
            evaluate: /<%([\s\S]+?)%>/g,
            interpolate: mt,
            variable: "",
            imports: {_: N}
          }, R || ($ = function () {
            function n() {
            }

            return function (e) {
              if (be(e)) {
                n.prototype = e;
                var t = new n;
                n.prototype = null
              }
              return t || i.Object()
            }
          }());
          var re = I ? function (e, t) {
            Vt.value = t, I(e, S("4jiUQW^\x7f]I_`\x1f"), Vt), Vt.value = null
          } : tt;

          function oe(e) {
            var t, n;
            return !(!e || b.call(e) != Ot || Ce(t = e.constructor) && !(t instanceof t)) && (pe(e, function (e, t) {
              n = t
            }), void 0 === n || _.call(e, n))
          }

          function se(e) {
            return de[e]
          }

          function ae(e) {
            return e && "object" == typeof e && "number" == typeof e.length && b.call(e) == Et || !1
          }

          var le = T || function (e) {
              return e && "object" == typeof e && "number" == typeof e.length && b.call(e) == Mt || !1
            }, ue = P ? function (e) {
              return be(e) ? P(e) : []
            } : function (e) {
              var t, n = e, i = [];
              if (!n) return i;
              if (!Kt[typeof e]) return i;
              for (t in n) _.call(n, t) && i.push(t);
              return i
            }, ce = {
              "&": S("\x150vui!"),
              "<": S("1\x14_@\x0e"),
              ">": S("1\x14T@\x0e"),
              '"': S("2\x15E@YC\x03"),
              "'": S("\f+-<)*")
            }, de = ye(ce), fe = m("(" + ue(de).join("|") + ")", "g"), Se = m("[" + ue(ce).join("") + "]", "g"),
            he = function (e, t, n) {
              var i, r = e, o = r;
              if (!r) return o;
              var s = arguments, a = 0, l = "number" == typeof n ? 2 : s.length;
              if (3 < l && "function" == typeof s[l - 2]) var u = z(s[--l - 1], s[l--], 2); else 2 < l && "function" == typeof s[l - 1] && (u = s[--l]);
              for (; ++a < l;) if ((r = s[a]) && Kt[typeof r]) for (var c = -1, d = Kt[typeof r] && ue(r), f = d ? d.length : 0; ++c < f;) o[i = d[c]] = u ? u(o[i], r[i]) : r[i];
              return o
            };
          var ge = function (e, t, n) {
            var i, r = e, o = r;
            if (!r) return o;
            for (var s = arguments, a = 0, l = "number" == typeof n ? 2 : s.length; ++a < l;) if ((r = s[a]) && Kt[typeof r]) for (var u = -1, c = Kt[typeof r] && ue(r), d = c ? c.length : 0; ++u < d;) void 0 === o[i = c[u]] && (o[i] = r[i]);
            return o
          };
          var pe = function (e, t, n) {
            var i, r = e, o = r;
            if (!r) return o;
            if (!Kt[typeof r]) return o;
            for (i in t = t && void 0 === n ? t : z(t, n, 3), r) if (!1 === t(r[i], i, e)) return o;
            return o
          };
          var ve = function (e, t, n) {
            var i, r = e, o = r;
            if (!r) return o;
            if (!Kt[typeof r]) return o;
            t = t && void 0 === n ? t : z(t, n, 3);
            for (var s = -1, a = Kt[typeof r] && ue(r), l = a ? a.length : 0; ++s < l;) if (!1 === t(r[i = a[s]], i, e)) return o;
            return o
          };

          function me(e, t, n) {
            var i = ue(e), r = i.length;
            for (t = z(t, n, 3); r--;) {
              var o = i[r];
              if (!1 === t(e[o], o, e)) break
            }
            return e
          }

          function we(e) {
            var n = [];
            return pe(e, function (e, t) {
              Ce(e) && n.push(t)
            }), n.sort()
          }

          function ye(e) {
            for (var t = -1, n = ue(e), i = n.length, r = {}; ++t < i;) {
              var o = n[t];
              r[e[o]] = o
            }
            return r
          }

          function Ce(e) {
            return "function" == typeof e
          }

          function be(e) {
            return !(!e || !Kt[typeof e])
          }

          function _e(e) {
            return "number" == typeof e || e && "object" == typeof e && b.call(e) == Tt || !1
          }

          var xe = p ? function (e) {
            if (!e || b.call(e) != Ot) return !1;
            var t = e.valueOf, n = ie(t) && (n = p(t)) && p(n);
            return n ? e == n || p(e) == n : oe(e)
          } : oe;

          function Ee(e) {
            return "string" == typeof e || e && "object" == typeof e && b.call(e) == Pt || !1
          }

          function Me(e) {
            for (var t = -1, n = ue(e), i = n.length, r = l(i); ++t < i;) r[t] = e[n[t]];
            return r
          }

          function Fe(e, t, n) {
            var i = -1, r = ne(), o = e ? e.length : 0, s = !1;
            return n = (n < 0 ? A(0, o + n) : n) || 0, le(e) ? s = -1 < r(e, t, n) : "number" == typeof o ? s = -1 < (Ee(e) ? e.indexOf(t, n) : r(e, t, n)) : ve(e, function (e) {
              if (++i >= n) return !(s = e === t)
            }), s
          }

          var Ie = j(function (e, t, n) {
            _.call(e, n) ? e[n]++ : e[n] = 1
          });

          function Re(e, i, t) {
            var r = !0;
            i = N.createCallback(i, t, 3);
            var n = -1, o = e ? e.length : 0;
            if ("number" == typeof o) for (; ++n < o && (r = !!i(e[n], n, e));) ; else ve(e, function (e, t, n) {
              return r = !!i(e, t, n)
            });
            return r
          }

          function Te(e, i, t) {
            var r = [];
            i = N.createCallback(i, t, 3);
            var n = -1, o = e ? e.length : 0;
            if ("number" == typeof o) for (; ++n < o;) {
              var s = e[n];
              i(s, n, e) && r.push(s)
            } else ve(e, function (e, t, n) {
              i(e, t, n) && r.push(e)
            });
            return r
          }

          function Oe(e, i, t) {
            i = N.createCallback(i, t, 3);
            var r, n = -1, o = e ? e.length : 0;
            if ("number" != typeof o) return ve(e, function (e, t, n) {
              if (i(e, t, n)) return r = e, !1
            }), r;
            for (; ++n < o;) {
              var s = e[n];
              if (i(s, n, e)) return s
            }
          }

          function Be(e, t, n) {
            var i = -1, r = e ? e.length : 0;
            if (t = t && void 0 === n ? t : z(t, n, 3), "number" == typeof r) for (; ++i < r && !1 !== t(e[i], i, e);) ; else ve(e, t);
            return e
          }

          function Pe(e, i, t) {
            var r = e ? e.length : 0;
            if (i = i && void 0 === t ? i : z(i, t, 3), "number" == typeof r) for (; r-- && !1 !== i(e[r], r, e);) ; else {
              var o = ue(e);
              r = o.length, ve(e, function (e, t, n) {
                return t = o ? o[--r] : --r, i(n[t], t, n)
              })
            }
            return e
          }

          var Ae = j(function (e, t, n) {
            (_.call(e, n) ? e[n] : e[n] = []).push(t)
          }), De = j(function (e, t, n) {
            e[n] = t
          });

          function Ve(e, i, t) {
            var r = -1, n = e ? e.length : 0;
            if (i = N.createCallback(i, t, 3), "number" == typeof n) for (var o = l(n); ++r < n;) o[r] = i(e[r], r, e); else o = [], ve(e, function (e, t, n) {
              o[++r] = i(e, t, n)
            });
            return o
          }

          function Ke(e, r, t) {
            var o = -1 / 0, s = o;
            if ("function" != typeof r && t && t[r] === e && (r = null), null == r && le(e)) for (var n = -1, i = e.length; ++n < i;) {
              var a = e[n];
              s < a && (s = a)
            } else r = null == r && Ee(e) ? qt : N.createCallback(r, t, 3), Be(e, function (e, t, n) {
              var i = r(e, t, n);
              o < i && (o = i, s = e)
            });
            return s
          }

          var He = Ve;

          function Ne(e, i, r, t) {
            if (!e) return r;
            var o = arguments.length < 3;
            i = N.createCallback(i, t, 4);
            var n = -1, s = e.length;
            if ("number" == typeof s) for (o && (r = e[++n]); ++n < s;) r = i(r, e[n], n, e); else ve(e, function (e, t, n) {
              r = o ? (o = !1, e) : i(r, e, t, n)
            });
            return r
          }

          function Ue(e, i, r, t) {
            var o = arguments.length < 3;
            return i = N.createCallback(i, t, 4), Pe(e, function (e, t, n) {
              r = o ? (o = !1, e) : i(r, e, t, n)
            }), r
          }

          function qe(e) {
            var n = -1, t = e ? e.length : 0, i = l("number" == typeof t ? t : 0);
            return Be(e, function (e) {
              var t = Z(0, ++n);
              i[n] = i[t], i[t] = e
            }), i
          }

          function We(e, i, t) {
            var r;
            i = N.createCallback(i, t, 3);
            var n = -1, o = e ? e.length : 0;
            if ("number" == typeof o) for (; ++n < o && !(r = i(e[n], n, e));) ; else ve(e, function (e, t, n) {
              return !(r = i(e, t, n))
            });
            return !!r
          }

          var Le = Te;

          function $e(e, t, n) {
            var i = 0, r = e ? e.length : 0;
            if ("number" != typeof t && null != t) {
              var o = -1;
              for (t = N.createCallback(t, n, 3); ++o < r && t(e[o], o, e);) i++
            } else if (null == (i = t) || n) return e ? e[0] : at;
            return Xt(e, 0, D(A(0, i), r))
          }

          function ze(e, t, n) {
            if ("number" == typeof n) {
              var i = e ? e.length : 0;
              n = n < 0 ? A(0, i + n) : n || 0
            } else if (n) {
              var r = Ye(e, t);
              return e[r] === t ? r : -1
            }
            return Nt(e, t, n)
          }

          function ke(e, t, n) {
            if ("number" != typeof t && null != t) {
              var i = 0, r = -1, o = e ? e.length : 0;
              for (t = N.createCallback(t, n, 3); ++r < o && t(e[r], r, e);) i++
            } else i = null == t || n ? 1 : A(0, t);
            return Xt(e, i)
          }

          function Ye(e, t, n, i) {
            var r = 0, o = e ? e.length : r;
            for (t = (n = n ? N.createCallback(n, i, 1) : je)(t); r < o;) {
              var s = r + o >>> 1;
              n(e[s]) < t ? r = 1 + s : o = s
            }
            return r
          }

          function Qe(e, t, n, i) {
            return "boolean" != typeof t && null != t && (i = n, n = "function" != typeof t && i && i[t] === e ? null : t, t = !1), null != n && (n = N.createCallback(n, i, 3)), G(e, t, n)
          }

          function Xe() {
            for (var e = 1 < arguments.length ? arguments : arguments[0], t = -1, n = e ? Ke(He(e, S("\x19v~rzjw"))) : 0, i = l(n < 0 ? 0 : n); ++t < n;) i[t] = He(e, t);
            return i
          }

          function Je(e, t) {
            var n = -1, i = e ? e.length : 0, r = {};
            for (t || !i || le(e[0]) || (t = []); ++n < i;) {
              var o = e[n];
              t ? r[o] = t[n] : o && (r[o[0]] = o[1])
            }
            return r
          }

          function Ze(e, t) {
            return 2 < arguments.length ? ee(e, 17, Xt(arguments, 2), null, t) : ee(e, 1, null, null, t)
          }

          function Ge(i, r, e) {
            var o, s, a, l, u, c, d, f = 0, h = !1, g = !0;
            if (!Ce(i)) throw new w;
            if (r = A(0, r) || 0, !0 === e) {
              var p = !0;
              g = !1
            } else be(e) && (p = e.leading, h = S("\x1av}eI~IU") in e && (A(r, e.maxWait) || 0), g = S("\x12gft\x7f{qw}") in e ? e.trailing : g);
            var v = function () {
              var e = r - (it() - l);
              if (e <= 0) {
                s && y(s);
                var t = d;
                s = c = d = at, t && (f = it(), a = i.apply(u, o), c || s || (o = u = null))
              } else c = E(v, e)
            }, m = function () {
              c && y(c), s = c = d = at, (g || h !== r) && (f = it(), a = i.apply(u, o), c || s || (o = u = null))
            };
            return function () {
              if (o = arguments, l = it(), u = this, d = g && (c || !p), !1 === h) var e = p && !c; else {
                s || p || (f = l);
                var t = h - (l - f), n = t <= 0;
                n ? (s && (s = y(s)), f = l, a = i.apply(u, o)) : s || (s = E(m, t))
              }
              return n && c ? c = y(c) : c || r === h || (c = E(v, r)), e && (n = !0, a = i.apply(u, o)), !n || c || s || (o = u = null), a
            }
          }

          function je(e) {
            return e
          }

          function et(o, t, e) {
            var s = !0, n = t && we(t);
            t && (e || n.length) || (null == e && (e = t), a = U, t = o, o = N, n = we(t)), !1 === e ? s = !1 : be(e) && S("?#)#**") in e && (s = e.chain);
            var a = o, i = Ce(a);
            Be(n, function (e) {
              var r = o[e] = t[e];
              i && (a.prototype[e] = function () {
                var e = this.__chain__, t = this.__wrapped__, n = [t];
                x.apply(n, arguments);
                var i = r.apply(o, n);
                if (s || e) {
                  if (t === i && be(i)) return this;
                  (i = new a(i)).__chain__ = e
                }
                return i
              })
            })
          }

          function tt() {
          }

          var nt, it = ie(it = n.now) && it || function () {
            return (new n).getTime()
          }, rt = 8 == V(dt + S("\f=6")) ? V : function (e, t) {
            return V(Ee(e) ? e.replace(wt, "") : e, t || 0)
          };

          function ot(t) {
            return function (e) {
              return e[t]
            }
          }

          function st() {
            return this.__wrapped__
          }

          return N.after = function (e, t) {
            if (!Ce(t)) throw new w;
            return function () {
              if (--e < 1) return t.apply(this, arguments)
            }
          }, N.assign = he, N.at = function (e) {
            for (var t = arguments, n = -1, i = Q(t, !0, !1, 1), r = t[2] && t[2][t[1]] === e ? 1 : i.length, o = l(r); ++n < r;) o[n] = e[i[n]];
            return o
          }, N.bind = Ze, N.bindAll = function (e) {
            for (var t = 1 < arguments.length ? Q(arguments, !0, !1, 1) : we(e), n = -1, i = t.length; ++n < i;) {
              var r = t[n];
              e[r] = ee(e[r], 1, null, null, e)
            }
            return e
          }, N.bindKey = function (e, t) {
            return 2 < arguments.length ? ee(t, 19, Xt(arguments, 2), null, e) : ee(t, 3, null, null, e)
          }, N.chain = function (e) {
            return (e = new U(e)).__chain__ = !0, e
          }, N.compact = function (e) {
            for (var t = -1, n = e ? e.length : 0, i = []; ++t < n;) {
              var r = e[t];
              r && i.push(r)
            }
            return i
          }, N.compose = function () {
            for (var n = arguments, e = n.length; e--;) if (!Ce(n[e])) throw new w;
            return function () {
              for (var e = arguments, t = n.length; t--;) e = [n[t].apply(this, e)];
              return e[0]
            }
          }, N.constant = function (e) {
            return function () {
              return e
            }
          }, N.countBy = Ie, N.create = function (e, t) {
            var n = $(e);
            return t ? he(n, t) : n
          }, N.createCallback = function (i, e, t) {
            var n = typeof i;
            if (null == i || "function" == n) return z(i, e, t);
            if ("object" != n) return ot(i);
            var r = ue(i), o = r[0], s = i[o];
            return 1 != r.length || s != s || be(s) ? function (e) {
              for (var t = r.length, n = !1; t-- && (n = X(e[r[t]], i[r[t]], null, !0));) ;
              return n
            } : function (e) {
              var t = e[o];
              return s === t && (0 !== s || 1 / s == 1 / t)
            }
          }, N.curry = function (e, t) {
            return ee(e, 4, null, null, null, t = "number" == typeof t ? t : +t || e.length)
          }, N.debounce = Ge, N.defaults = ge, N.defer = function (e) {
            if (!Ce(e)) throw new w;
            var t = Xt(arguments, 1);
            return E(function () {
              e.apply(at, t)
            }, 1)
          }, N.delay = function (e, t) {
            if (!Ce(e)) throw new w;
            var n = Xt(arguments, 2);
            return E(function () {
              e.apply(at, n)
            }, t)
          }, N.difference = function (e) {
            return Y(e, Q(arguments, !0, !0, 1))
          }, N.filter = Te, N.flatten = function (e, t, n, i) {
            return "boolean" != typeof t && null != t && (i = n, n = "function" != typeof t && i && i[t] === e ? null : t, t = !1), null != n && (e = Ve(e, n, i)), Q(e, t)
          }, N.forEach = Be, N.forEachRight = Pe, N.forIn = pe, N.forInRight = function (e, t, n) {
            var i = [];
            pe(e, function (e, t) {
              i.push(t, e)
            });
            var r = i.length;
            for (t = z(t, n, 3); r-- && !1 !== t(i[r--], i[r], e);) ;
            return e
          }, N.forOwn = ve, N.forOwnRight = me, N.functions = we, N.groupBy = Ae, N.indexBy = De, N.initial = function (e, t, n) {
            var i = 0, r = e ? e.length : 0;
            if ("number" != typeof t && null != t) {
              var o = r;
              for (t = N.createCallback(t, n, 3); o-- && t(e[o], o, e);) i++
            } else i = null == t || n ? 1 : t || i;
            return Xt(e, 0, D(A(0, r - i), r))
          }, N.intersection = function () {
            for (var e = [], t = -1, n = arguments.length, i = zt(), r = ne(), o = r === Nt, s = zt(); ++t < n;) {
              var a = arguments[t];
              (le(a) || ae(a)) && (e.push(a), i.push(o && a.length >= ct && Lt(t ? e[t] : s)))
            }
            var l = e[0], u = -1, c = l ? l.length : 0, d = [];
            e:for (; ++u < c;) {
              var f = i[0];
              if (a = l[u], (f ? Ut(f, a) : r(s, a)) < 0) {
                for (t = n, (f || s).push(a); --t;) if (((f = i[t]) ? Ut(f, a) : r(e[t], a)) < 0) continue e;
                d.push(a)
              }
            }
            for (; n--;) (f = i[n]) && Qt(f);
            return Yt(i), Yt(s), d
          }, N.invert = ye, N.invoke = function (e, t) {
            var n = Xt(arguments, 2), i = -1, r = "function" == typeof t, o = e ? e.length : 0,
              s = l("number" == typeof o ? o : 0);
            return Be(e, function (e) {
              s[++i] = (r ? t : e[t]).apply(e, n)
            }), s
          }, N.keys = ue, N.map = Ve, N.mapValues = function (e, i, t) {
            var r = {};
            return i = N.createCallback(i, t, 3), ve(e, function (e, t, n) {
              r[t] = i(e, t, n)
            }), r
          }, N.max = Ke, N.memoize = function (n, i) {
            if (!Ce(n)) throw new w;
            var r = function () {
              var e = r.cache, t = i ? i.apply(this, arguments) : ut + arguments[0];
              return _.call(e, t) ? e[t] : e[t] = n.apply(this, arguments)
            };
            return r.cache = {}, r
          }, N.merge = function (e) {
            var t = arguments, n = 2;
            if (!be(e)) return e;
            if ("number" != typeof t[2] && (n = t.length), 3 < n && "function" == typeof t[n - 2]) var i = z(t[--n - 1], t[n--], 2); else 2 < n && "function" == typeof t[n - 1] && (i = t[--n]);
            for (var r = Xt(arguments, 1, n), o = -1, s = zt(), a = zt(); ++o < n;) J(e, r[o], i, s, a);
            return Yt(s), Yt(a), e
          }, N.min = function (e, r, t) {
            var o = 1 / 0, s = o;
            if ("function" != typeof r && t && t[r] === e && (r = null), null == r && le(e)) for (var n = -1, i = e.length; ++n < i;) {
              var a = e[n];
              a < s && (s = a)
            } else r = null == r && Ee(e) ? qt : N.createCallback(r, t, 3), Be(e, function (e, t, n) {
              var i = r(e, t, n);
              i < o && (o = i, s = e)
            });
            return s
          }, N.omit = function (e, i, t) {
            var r = {};
            if ("function" != typeof i) {
              var n = [];
              pe(e, function (e, t) {
                n.push(t)
              });
              for (var o = -1, s = (n = Y(n, Q(arguments, !0, !1, 1))).length; ++o < s;) {
                var a = n[o];
                r[a] = e[a]
              }
            } else i = N.createCallback(i, t, 3), pe(e, function (e, t, n) {
              i(e, t, n) || (r[t] = e)
            });
            return r
          }, N.once = function (e) {
            var t, n;
            if (!Ce(e)) throw new w;
            return function () {
              return t || (t = !0, n = e.apply(this, arguments), e = null), n
            }
          }, N.pairs = function (e) {
            for (var t = -1, n = ue(e), i = n.length, r = l(i); ++t < i;) {
              var o = n[t];
              r[t] = [o, e[o]]
            }
            return r
          }, N.partial = function (e) {
            return ee(e, 16, Xt(arguments, 1))
          }, N.partialRight = function (e) {
            return ee(e, 32, null, Xt(arguments, 1))
          }, N.pick = function (e, i, t) {
            var r = {};
            if ("function" != typeof i) for (var n = -1, o = Q(arguments, !0, !1, 1), s = be(e) ? o.length : 0; ++n < s;) {
              var a = o[n];
              a in e && (r[a] = e[a])
            } else i = N.createCallback(i, t, 3), pe(e, function (e, t, n) {
              i(e, t, n) && (r[t] = e)
            });
            return r
          }, N.pluck = He, N.property = ot, N.pull = function (e) {
            for (var t = arguments, n = 0, i = t.length, r = e ? e.length : 0; ++n < i;) for (var o = -1, s = t[n]; ++o < r;) e[o] === s && (M.call(e, o--, 1), r--);
            return e
          }, N.range = function (e, t, n) {
            e = +e || 0, null == t && (t = e, e = 0);
            for (var i = -1, r = A(0, f((t - e) / ((n = "number" == typeof n ? n : +n || 1) || 1))), o = l(r); ++i < r;) o[i] = e, e += n;
            return o
          }, N.reject = function (e, i, t) {
            return i = N.createCallback(i, t, 3), Te(e, function (e, t, n) {
              return !i(e, t, n)
            })
          }, N.remove = function (e, t, n) {
            var i = -1, r = e ? e.length : 0, o = [];
            for (t = N.createCallback(t, n, 3); ++i < r;) {
              var s = e[i];
              t(s, i, e) && (o.push(s), M.call(e, i--, 1), r--)
            }
            return o
          }, N.rest = ke, N.shuffle = qe, N.sortBy = function (e, r, t) {
            var o = -1, s = le(r), n = e ? e.length : 0, a = l("number" == typeof n ? n : 0);
            for (s || (r = N.createCallback(r, t, 3)), Be(e, function (t, e, n) {
              var i = a[++o] = kt();
              s ? i.criteria = Ve(r, function (e) {
                return t[e]
              }) : (i.criteria = zt())[0] = r(t, e, n), i.index = o, i.value = t
            }), n = a.length, a.sort(Wt); n--;) {
              var i = a[n];
              a[n] = i.value, s || Yt(i.criteria), Qt(i)
            }
            return a
          }, N.tap = function (e, t) {
            return t(e), e
          }, N.throttle = function (e, t, n) {
            var i = !0, r = !0;
            if (!Ce(e)) throw new w;
            return !1 === n ? i = !1 : be(n) && (i = S("6[]X^RRZ") in n ? n.leading : i, r = S("6CJXSWUSY") in n ? n.trailing : r), Dt.leading = i, Dt.maxWait = t, Dt.trailing = r, Ge(e, t, Dt)
          }, N.times = function (e, t, n) {
            e = -1 < (e = +e) ? e : 0;
            var i = -1, r = l(e);
            for (t = z(t, n, 1); ++i < e;) r[i] = t(i);
            return r
          }, N.toArray = function (e) {
            return e && "number" == typeof e.length ? Xt(e) : Me(e)
          }, N.transform = function (e, i, r, t) {
            var n = le(e);
            if (null == r) if (n) r = []; else {
              var o = e && e.constructor, s = o && o.prototype;
              r = $(s)
            }
            return i && (i = N.createCallback(i, t, 4), (n ? Be : ve)(e, function (e, t, n) {
              return i(r, e, t, n)
            })), r
          }, N.union = function () {
            return G(Q(arguments, !0, !0))
          }, N.uniq = Qe, N.values = Me, N.where = Le, N.without = function (e) {
            return Y(e, Xt(arguments, 1))
          }, N.wrap = function (e, t) {
            return ee(t, 16, [e])
          }, N.xor = function () {
            for (var e = -1, t = arguments.length; ++e < t;) {
              var n = arguments[e];
              if (le(n) || ae(n)) var i = i ? G(Y(i, n).concat(Y(n, i))) : n
            }
            return i || []
          }, N.zip = Xe, N.zipObject = Je, N.collect = Ve, N.drop = ke, N.each = Be, N.eachRight = Pe, N.extend = he, N.methods = we, N.object = Je, N.select = Te, N.tail = ke, N.unique = Qe, N.unzip = Xe, et(N), N.clone = function (e, t, n, i) {
            return "boolean" != typeof t && null != t && (i = n, n = t, t = !1), L(e, t, "function" == typeof n && z(n, i, 1))
          }, N.cloneDeep = function (e, t, n) {
            return L(e, !0, "function" == typeof t && z(t, n, 1))
          }, N.contains = Fe, N.escape = function (e) {
            return null == e ? "" : C(e).replace(Se, te)
          }, N.every = Re, N.find = Oe, N.findIndex = function (e, t, n) {
            var i = -1, r = e ? e.length : 0;
            for (t = N.createCallback(t, n, 3); ++i < r;) if (t(e[i], i, e)) return i;
            return -1
          }, N.findKey = function (e, i, t) {
            var r;
            return i = N.createCallback(i, t, 3), ve(e, function (e, t, n) {
              if (i(e, t, n)) return r = t, !1
            }), r
          }, N.findLast = function (e, i, t) {
            var r;
            return i = N.createCallback(i, t, 3), Pe(e, function (e, t, n) {
              if (i(e, t, n)) return r = e, !1
            }), r
          }, N.findLastIndex = function (e, t, n) {
            var i = e ? e.length : 0;
            for (t = N.createCallback(t, n, 3); i--;) if (t(e[i], i, e)) return i;
            return -1
          }, N.findLastKey = function (e, i, t) {
            var r;
            return i = N.createCallback(i, t, 3), me(e, function (e, t, n) {
              if (i(e, t, n)) return r = t, !1
            }), r
          }, N.has = function (e, t) {
            return !!e && _.call(e, t)
          }, N.identity = je, N.indexOf = ze, N.isArguments = ae, N.isArray = le, N.isBoolean = function (e) {
            return !0 === e || !1 === e || e && "object" == typeof e && b.call(e) == Ft || !1
          }, N.isDate = function (e) {
            return e && "object" == typeof e && b.call(e) == It || !1
          }, N.isElement = function (e) {
            return e && 1 === e.nodeType || !1
          },N.isEmpty = function (e) {
            var t = !0;
            if (!e) return t;
            var n = b.call(e), i = e.length;
            return n == Mt || n == Pt || n == Et || n == Ot && "number" == typeof i && Ce(e.splice) ? !i : (ve(e, function () {
              return t = !1
            }), t)
          },N.isEqual = function (e, t, n, i) {
            return X(e, t, "function" == typeof n && z(n, i, 2))
          },N.isFinite = function (e) {
            return O(e) && !B(parseFloat(e))
          },N.isFunction = Ce,N.isNaN = function (e) {
            return _e(e) && e != +e
          },N.isNull = function (e) {
            return null === e
          },N.isNumber = _e,N.isObject = be,N.isPlainObject = xe,N.isRegExp = function (e) {
            return e && "object" == typeof e && b.call(e) == Bt || !1
          },N.isString = Ee,N.isUndefined = function (e) {
            return void 0 === e
          },N.lastIndexOf = function (e, t, n) {
            var i = e ? e.length : 0;
            for ("number" == typeof n && (i = (n < 0 ? A(0, i + n) : D(n, i - 1)) + 1); i--;) if (e[i] === t) return i;
            return -1
          },N.mixin = et,N.noConflict = function () {
            return i._ = c, this
          },N.noop = tt,N.now = it,N.parseInt = rt,N.random = function (e, t, n) {
            var i = null == e, r = null == t;
            if (null == n && ("boolean" == typeof e && r ? (n = e, e = 1) : r || "boolean" != typeof t || (n = t, r = !0)), i && r && (t = 1), e = +e || 0, r ? (t = e, e = 0) : t = +t || 0, n || e % 1 || t % 1) {
              var o = K();
              return D(e + o * (t - e + parseFloat(S(",\x1cK\x02") + ((o + "").length - 1))), t)
            }
            return Z(e, t)
          },N.reduce = Ne,N.reduceRight = Ue,N.result = function (e, t) {
            if (e) {
              var n = e[t];
              return Ce(n) ? e[t]() : n
            }
          },N.runInContext = e,N.size = function (e) {
            var t = e ? e.length : 0;
            return "number" == typeof t ? t : ue(e).length
          },N.some = We,N.sortedIndex = Ye,N.template = function (s, e, t) {
            var n = N.templateSettings;
            s = C(s || ""), t = ge({}, t, n);
            var a, i = ge({}, t.imports, n.imports), r = ue(i), o = Me(i), l = 0, u = t.interpolate || yt,
              c = S("\x0fONb3?(60"),
              d = m((t.escape || yt).source + "|" + u.source + "|" + (u === mt ? gt : yt).source + "|" + (t.evaluate || yt).source + S("\x18e>"), "g");
            s.replace(d, function (e, t, n, i, r, o) {
              return n || (n = i), c += s.slice(l, o).replace(bt, $t), t && (c += S("6\x10\x18\x120dcX\x16") + t + S("\x13=5=\x1d?")), r && (a = !0, c += S(" \x06\x19)") + r + S("\x13/\x1fIHh91&<:")), n && (c += S("\x10628\x1e=>HGm:&<5") + n + S("Cmlfzui$> !nppvusnu\t\b,pzpVz")), l = o + e.length, e
            }), c += S("\x133.\x1c");
            var f = t.variable, h = f;
            h || (f = S("3[W\\"), c = S("0F[G\\\x15\x1e") + f + S("Dlf<B") + c + S("\x13\x1eh\x1c")), c = (a ? c.replace(ft, "") : c).replace(St, S(">\x1bq")).replace(ht, S('"\x07\x15\x1e')), c = S("\x0eie\x7fqg}zx?") + f + S("Eog3C") + (h ? "" : f + S("5\x16KD\x19\x12") + f + S(",\r\x13\x0fKL\x1b\b>")) + S(">I!3b\x1c\x1b1jg\x17\x16:kqmih|q\r\f1ukw\x07w?(?<.:") + (a ? S("7\x14\x19edV\x1d\x03\x1f\x0130\"=k65'=%?5=+a:>;=o_") + S("%@RFJ^BCC\x0e_BX\\G\x1c\x1c\x16L\x18feK\x1c\x16\x03\x1f\x1f\x1e(m'$*+`(8,9 +!$\"~ssr\x7fw%S") : S("<\x064")) + c + S("/BTFFF[\x16hgI0F");
            var g = S(".%\x1f\x1b8\x1c\x1b\x16\x16DWLHXYhls}") + (t.sourceURL || S('=\x11S/%#0,j2"%9&*8(a<?$ 01\x0e') + xt++ + "]") + S("BInj");
            try {
              var p = v(r, S("\r|jdd`}4") + c + g).apply(at, o)
            } catch (e) {
              throw e.source = c, e
            }
            return e ? p(e) : (p.source = c, p)
          },N.unescape = function (e) {
            return null == e ? "" : C(e).replace(fe, se)
          },N.uniqueId = function (e) {
            var t = ++lt;
            return C(null == e ? "" : e) + t
          },N.all = Re,N.any = We,N.detect = Oe,N.findWhere = Oe,N.foldl = Ne,N.foldr = Ue,N.include = Fe,N.inject = Ne,et((nt = {}, ve(N, function (e, t) {
            N.prototype[t] || (nt[t] = e)
          }), nt), !1),N.first = $e,N.last = function (e, t, n) {
            var i = 0, r = e ? e.length : 0;
            if ("number" != typeof t && null != t) {
              var o = r;
              for (t = N.createCallback(t, n, 3); o-- && t(e[o], o, e);) i++
            } else if (null == (i = t) || n) return e ? e[r - 1] : at;
            return Xt(e, A(0, r - i))
          },N.sample = function (e, t, n) {
            if (e && "number" != typeof e.length && (e = Me(e)), null == t || n) return e ? e[Z(0, e.length - 1)] : at;
            var i = qe(e);
            return i.length = D(A(0, t), i.length), i
          },N.take = $e,N.head = $e,ve(N, function (r, e) {
            var o = e !== S("#WDKWDL");
            N.prototype[e] || (N.prototype[e] = function (e, t) {
              var n = this.__chain__, i = r(this.__wrapped__, e, t);
              return n || null != e && (!t || o && "function" == typeof e) ? new U(i, n) : i
            })
          }),N.VERSION = S("6\x05\x16\r\x14\t"),N.prototype.chain = function () {
            return this.__chain__ = !0, this
          },N.prototype.toString = function () {
            return C(this.__wrapped__)
          },N.prototype.value = st,N.prototype.valueOf = st,Be([S("A(,-+"), S("\x1eoOQ"), S("/CY[U@")], function (e) {
            var n = a[e];
            N.prototype[e] = function () {
              var e = this.__chain__, t = n.apply(this.__wrapped__, arguments);
              return e ? new U(t, e) : t
            }
          }),Be([S("\x1blhmw"), S("\v~hxjbbw"), S("\x1ahsoj"), S("$PHT@@L_")], function (e) {
            var t = a[e];
            N.prototype[e] = function () {
              return t.apply(this.__wrapped__, arguments), this
            }
          }),Be([S("\x10r}}wtb"), S("5E[QZ_"), S("4FF[QZ_")], function (e) {
            var t = a[e];
            N.prototype[e] = function () {
              return new U(t.apply(this.__wrapped__, arguments), this.__chain__)
            }
          }),N
        }();
        "function" == typeof CKFinder.define && "object" == typeof CKFinder.define.amd && CKFinder.define.amd ? (Ht._ = Jt, CKFinder.define(S(" TLGAWUDG[O"), [], function () {
          return Jt
        })) : e && o ? s ? (o.exports = Jt)._ = Jt : e._ = Jt : Ht._ = Jt
      }.call(this), function () {
        function wB(e) {
          return e.replace(/\\('|\\)/g, S("%\x02\x16")).replace(/[\r\t\n]/g, " ")
        }

        var yB, xB = {
          version: S("\x16&6)4("),
          templateSettings: {
            evaluate: /\{\{([\s\S]+?(\}?)+)\}\}/g,
            interpolate: /\{\{=([\s\S]+?)\}\}/g,
            encode: /\{\{!([\s\S]+?)\}\}/g,
            use: /\{\{#([\s\S]+?)\}\}/g,
            useParams: /(^|[^\w$])def(?:\.|\[[\'\"])([\w$\.]+)(?:[\'\"]\])?\s*\:\s*([\w$\.]+|\"[^\"]+\"|\'[^\']+\'|\{[^\}]+\})/g,
            define: /\{\{##\s*([\w\.$]+)\s*(\:|=)([\s\S]+?)#\}\}/g,
            defineParams: /^\s*([\w$]+):([\s\S]+)/,
            conditional: /\{\{\?(\?)?\s*([\s\S]*?)\s*\}\}/g,
            iterate: /\{\{~\s*(?:\}\}|([\s\S]+?)\s*\:\s*([\w$]+)\s*(?:\:\s*([\w$]+))?\s*\}\})/g,
            varname: S("0XF"),
            strip: !0,
            append: !0,
            selfcontained: !1,
            doNotSkipEncoded: !1
          },
          template: void 0,
          compile: void 0
        };
        xB.encodeHTMLSource = function (e) {
          var t = {
            "&": S("\x17>:)#'"),
            "<": S("\x1071%$."),
            ">": S("7\x1e\x1a\f\t\x07"),
            '"': S("5\x10\x14\v\r\x01"),
            "'": S('\x0e)3"+('),
            "/": S("8\x1f\x19\x0f\v\x06")
          }, n = e ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;
          return function (e) {
            return e ? e.toString().replace(n, function (e) {
              return t[e] || e
            }) : ""
          }
        }, yB = function () {
          return this || eval(S("$QNN["))
        }(), "undefined" != typeof module && module.exports ? module.exports = xB : "function" == typeof CKFinder.define && CKFinder.define.amd ? CKFinder.define(S("6SWm"), [], function () {
          return xB
        }) : yB.doT = xB;
        var zB = {start: S("3\x13\x1e\x1e"), end: S("$\f\r\0"), startencode: S("-\t\x04U_Q\\PP~cuu\x12")}, AB = {
          start: S("=\x19\x04/46hym"),
          end: S(",\x04\x15@EE\x19\x0e\x13"),
          startencode: S("\v+6azd:/vzvys}QNVP5")
        }, BB = /$^/;
        xB.template = function (t, e, n) {
          var i, r, o = (e = e || xB.templateSettings).append ? zB : AB, s = 0;
          t = e.use || e.define ? function i(r, e, o) {
            return ("string" == typeof e ? e : e.toString()).replace(r.define || BB, function (e, i, t, n) {
              return 0 === i.indexOf(S("2WQS\x18")) && (i = i.substring(4)), i in o || (":" === t ? (r.defineParams && n.replace(r.defineParams, function (e, t, n) {
                o[i] = {arg: t, text: n}
              }), i in o || (o[i] = n)) : new Function(S("\x12wqs"), S(" EGE\x7f\x02") + i + S("\x115N)") + n)(o)), ""
            }).replace(r.use || BB, function (e, t) {
              r.useParams && (t = t.replace(r.useParams, function (e, t, n, i) {
                if (o[n] && o[n].arg && i) return e = (n + ":" + i).replace(/'|\\/g, "_"), o.__exp = o.__exp || {}, o.__exp[e] = o[n].text.replace(new RegExp(S("\x181DgGCBh\x04|\v") + o[n].arg + S("&\x0fswv\\\bp\x07"), "g"), S("\v(<") + i + S("C`w")), t + S("\x19~~z3A@EYRx\x03") + e + S(".\bm")
              }));
              var n = new Function(S("#@@@"), S("=LZ440-d") + t)(o);
              return n ? i(r, n, o) : n
            })
          }(e, t, n || {}) : t, t = (S('"UEW\x06H]]\x17\f') + (e.strip ? t.replace(/(^|\r|\n)\t* +| +\t*(\r|\n|$)/g, " ").replace(/\r|\n|\t|\/\*[\s\S]*?\*\//g, "") : t).replace(/'|\\/g, S("\x1aG8;")).replace(e.interpolate || BB, function (e, t) {
            return o.start + wB(t) + o.end
          }).replace(e.encode || BB, function (e, t) {
            return i = !0, o.startencode + wB(t) + o.end
          }).replace(e.conditional || BB, function (e, t, n) {
            return t ? n ? S("\x19= axrlE\x01KE\f") + wB(n) + S("\v%vazd:/4") : S('\x17?"g~pn{dOTV\b\x19\x02') : n ? S("\x1b;&wy\b") + wB(n) + S("\x193`shj4\x1d\x06") : S("\x18>!fshj4\x1d\x06")
          }).replace(e.iterate || BB, function (e, t, n, i) {
            return t ? (s += 1, r = i || "i" + s, t = wB(t), S("&\0\x13_KY\fL\\]") + s + "=" + t + S("\x0f+xt;ugd") + s + S("\x1d7dV@P\x03") + n + "," + r + S("*\x16\x01\x1c\x02C") + s + S("0\fSAF") + s + S("-\0CU_UG\\\x18\x07\fOQSWY\x15") + r + S("Dy*") + s + S("Cm>") + n + S(")\x17J^_") + s + "[" + r + S("0\x1a\x0f\x02i\x0eYBL\x12\x07\x1c")) : S("\x133.k7e9unh6#8")
          }).replace(e.evaluate || BB, function (e, t) {
            return S("5\x11\f") + wB(t) + S("!MVP\x0e\x1b\0")
          }) + S("8\x1e\x01IYIKM.a-60~")).replace(/\n/g, S("'tG")).replace(/\t/g, S("A\x1e7")).replace(/\r/g, S("\x13Hg")).replace(/(\s|;|\}|^|\{)out\+='';/g, S("(\r\x1b")).replace(/\+''/g, ""), i && (e.selfcontained || !yB || yB._encodeHTML || (yB._encodeHTML = xB.encodeHTMLSource(e.doNotSkipEncoded)), t = S("8O[I\x1cXP\\/%'\v\x10\b\ngui>2<(!)p\x0e7=7:22\x10\r\x17\x17||cb@F\x17\r\0\0\0\x0e\x06\f\x0eLLRN0\x15\x1f\x11\x1c\x10\x10>#55ZA\\U") + xB.encodeHTMLSource.toString() + "(" + (e.doNotSkipEncoded || "") + S("9\x13\x12\x07") + t);
          try {
            return new Function(e.varname, t)
          } catch (e) {
            throw"undefined" != typeof console && console.log(S("%eH]EN\vBBZ\x0fSCWR@P\x16V\x18M_VLQ_K%a$6*&2.''pk") + t), e
          }
        }, xB.compile = function (e, t) {
          return xB.template(e, null, t)
        }
      }(), function (i, r) {
        if ("function" == typeof CKFinder.define && CKFinder.define.amd) CKFinder.define(S(",OOL[S]]Q"), [S("\x19ouxxllCNPF"), S("<WOJ%3;"), S("\x1ezXQMQPV")], function (e, t, n) {
          i.Backbone = r(i, n, e, t)
        }); else if ("undefined" != typeof exports) {
          var e = require(S("A7-  44+&8."));
          r(i, exports, e)
        } else i.Backbone = r(i, {}, i._, i.jQuery || i.Zepto || i.ender || i.$)
      }(this, function (e, a, _, t) {
        var n = e.Backbone, i = [], r = i.slice;
        a.VERSION = S("1\x03\x1d\x05\x1b\x04"), a.$ = t, a.noConflict = function () {
          return e.Backbone = n, this
        }, a.emulateHTTP = !1, a.emulateJSON = !1;
        var o = a.Events = {
          on: function (e, t, n) {
            return d(this, "on", e, [t, n]) && t && (this._events || (this._events = {}), (this._events[e] || (this._events[e] = [])).push({
              callback: t,
              context: n,
              ctx: n || this
            })), this
          }, once: function (e, t, n) {
            if (!d(this, S("5YY[\\"), e, [t, n]) || !t) return this;
            var i = this, r = _.once(function () {
              i.off(e, r), t.apply(this, arguments)
            });
            return r._callback = t, this.on(e, r, n)
          }, off: function (e, t, n) {
            var i, r, o, s, a, l, u, c;
            if (!this._events || !d(this, S("<RXY"), e, [t, n])) return this;
            if (!e && !t && !n) return this._events = void 0, this;
            for (a = 0, l = (s = e ? [e] : _.keys(this._events)).length; a < l; a++) if (e = s[a], o = this._events[e]) {
              if (this._events[e] = i = [], t || n) for (u = 0, c = o.length; u < c; u++) r = o[u], (t && t !== r.callback && t !== r.callback._callback || n && n !== r.context) && i.push(r);
              i.length || delete this._events[e]
            }
            return this
          }, trigger: function (e) {
            if (!this._events) return this;
            var t = r.call(arguments, 1);
            if (!d(this, S("7LKS\\[XL"), e, t)) return this;
            var n = this._events[e], i = this._events.all;
            return n && s(n, t), i && s(i, arguments), this
          }, stopListening: function (e, t, n) {
            var i = this._listeningTo;
            if (!i) return this;
            var r = !t && !n;
            for (var o in n || "object" != typeof t || (n = this), e && ((i = {})[e._listenId] = e), i) (e = i[o]).off(t, n, this), (r || _.isEmpty(e._events)) && delete this._listeningTo[o];
            return this
          }
        }, l = /\s+/, d = function (e, t, n, i) {
          if (!n) return !0;
          if ("object" == typeof n) {
            for (var r in n) e[t].apply(e, [r, n[r]].concat(i));
            return !1
          }
          if (l.test(n)) {
            for (var o = n.split(l), s = 0, a = o.length; s < a; s++) e[t].apply(e, [o[s]].concat(i));
            return !1
          }
          return !0
        }, s = function (e, t) {
          var n, i = -1, r = e.length, o = t[0], s = t[1], a = t[2];
          switch (t.length) {
            case 0:
              for (; ++i < r;) (n = e[i]).callback.call(n.ctx);
              return;
            case 1:
              for (; ++i < r;) (n = e[i]).callback.call(n.ctx, o);
              return;
            case 2:
              for (; ++i < r;) (n = e[i]).callback.call(n.ctx, o, s);
              return;
            case 3:
              for (; ++i < r;) (n = e[i]).callback.call(n.ctx, o, s, a);
              return;
            default:
              for (; ++i < r;) (n = e[i]).callback.apply(n.ctx, t);
              return
          }
        }, u = {listenTo: "on", listenToOnce: S("&HFJO")};
        _.each(u, function (r, e) {
          o[e] = function (e, t, n) {
            var i = this._listeningTo || (this._listeningTo = {});
            return n || "object" != typeof t || (n = this), (i[e._listenId || (e._listenId = _.uniqueId("l"))] = e)[r](t, n, this), this
          }
        }), o.bind = o.on, o.unbind = o.off, _.extend(a, o);
        var x = a.Model = function (e, t) {
          var n = e || {};
          t || (t = {}), this.cid = _.uniqueId("c"), this.attributes = {}, t.collection && (this.collection = t.collection), t.parse && (n = this.parse(n, t) || {}), n = _.defaults({}, n, _.result(this, S("#@@@F]E^X"))), this.set(n, t), this.changed = {}, this.initialize.apply(this, arguments)
        };
        _.extend(x.prototype, o, {
          changed: null, validationError: null, idAttribute: S(">V$"), initialize: function () {
          }, toJSON: function (e) {
            return _.clone(this.attributes)
          }, sync: function () {
            return a.sync.apply(this, arguments)
          }, get: function (e) {
            return this.attributes[e]
          }, escape: function (e) {
            return _.escape(this.get(e))
          }, has: function (e) {
            return null != this.get(e)
          }, set: function (e, t, n) {
            var i, r, o, s, a, l, u, c;
            if (null == e) return this;
            if ("object" == typeof e ? (r = e, n = t) : (r = {})[e] = t, n || (n = {}), !this._validate(r, n)) return !1;
            for (i in o = n.unset, a = n.silent, s = [], l = this._changing, this._changing = !0, l || (this._previousAttributes = _.clone(this.attributes), this.changed = {}), c = this.attributes, u = this._previousAttributes, this.idAttribute in r && (this.id = r[this.idAttribute]), r) t = r[i], _.isEqual(c[i], t) || s.push(i), _.isEqual(u[i], t) ? delete this.changed[i] : this.changed[i] = t, o ? delete c[i] : c[i] = t;
            if (!a) {
              s.length && (this._pending = n);
              for (var d = 0, f = s.length; d < f; d++) this.trigger(S("\x1b\x7fu\x7fqGD\x18") + s[d], this, c[s[d]], n)
            }
            if (l) return this;
            if (!a) for (; this._pending;) n = this._pending, this._pending = !1, this.trigger(S("/SYS]SP"), this, n);
            return this._pending = !1, this._changing = !1, this
          }, unset: function (e, t) {
            return this.set(e, void 0, _.extend({}, t, {unset: !0}))
          }, clear: function (e) {
            var t = {};
            for (var n in this.attributes) t[n] = void 0;
            return this.set(t, _.extend({}, e, {unset: !0}))
          }, hasChanged: function (e) {
            return null == e ? !_.isEmpty(this.changed) : _.has(this.changed, e)
          }, changedAttributes: function (e) {
            if (!e) return !!this.hasChanged() && _.clone(this.changed);
            var t, n = !1, i = this._changing ? this._previousAttributes : this.attributes;
            for (var r in e) _.isEqual(i[r], t = e[r]) || ((n || (n = {}))[r] = t);
            return n
          }, previous: function (e) {
            return null != e && this._previousAttributes ? this._previousAttributes[e] : null
          }, previousAttributes: function () {
            return _.clone(this._previousAttributes)
          }, fetch: function (t) {
            void 0 === (t = t ? _.clone(t) : {}).parse && (t.parse = !0);
            var n = this, i = t.success;
            return t.success = function (e) {
              if (!n.set(n.parse(e, t), t)) return !1;
              i && i(n, e, t), n.trigger(S(">L9/!"), n, e, t)
            }, K(this, t), this.sync(S("\x0e}upv"), this, t)
          }, save: function (e, t, n) {
            var i, r, o, s = this.attributes;
            if (null == e || "object" == typeof e ? (i = e, n = t) : (i = {})[e] = t, n = _.extend({validate: !0}, n), i && !n.wait) {
              if (!this.set(i, n)) return !1
            } else if (!this._validate(i, n)) return !1;
            i && n.wait && (this.attributes = _.extend({}, s, i)), void 0 === n.parse && (n.parse = !0);
            var a = this, l = n.success;
            return n.success = function (e) {
              a.attributes = s;
              var t = a.parse(e, n);
              if (n.wait && (t = _.extend(i || {}, t)), _.isObject(t) && !a.set(t, n)) return !1;
              l && l(a, e, n), a.trigger(S("(ZSEO"), a, e, n)
            }, K(this, n), (r = this.isNew() ? S("E%5-(>.") : n.patch ? S("%VF\\JB") : S("!WS@DRB")) === S("\x1cm\x7fkCI") && (n.attrs = i), o = this.sync(r, this, n), i && n.wait && (this.attributes = s), o
          }, destroy: function (t) {
            t = t ? _.clone(t) : {};
            var n = this, i = t.success, r = function () {
              n.trigger(S("@%'007)>"), n, n.collection, t)
            };
            if (t.success = function (e) {
              (t.wait || n.isNew()) && r(), i && i(n, e, t), n.isNew() || n.trigger(S("\x1cngqC"), n, e, t)
            }, this.isNew()) return t.success(), !1;
            K(this, t);
            var e = this.sync(S("\x1bxxrzTD"), this, t);
            return t.wait || r(), e
          }, url: function () {
            var e = _.result(this, S("D04+\x1a&%?")) || _.result(this.collection, S("\x17mkv")) || V();
            return this.isNew() ? e : e.replace(/([^\/])$/, S("2\x17\x05\x1a")) + encodeURIComponent(this.id)
          }, parse: function (e, t) {
            return e
          }, clone: function () {
            return new this.constructor(this.attributes)
          }, isNew: function () {
            return !this.has(this.idAttribute)
          }, isValid: function (e) {
            return this._validate({}, _.extend(e || {}, {validate: !0}))
          }, _validate: function (e, t) {
            if (!t.validate || !this.validate) return !0;
            e = _.extend({}, this.attributes, e);
            var n = this.validationError = this.validate(e, t) || null;
            return !n || (this.trigger(S("\x10x|euy\x7fs"), this, n, _.extend(t, {validationError: n})), !1)
          }
        });
        var c = [S("D.#>;"), S("E0&$</8"), S("(YKB^^"), S("'AG\\N^Y"), S("0A[P_"), S("9UVUI")];
        _.each(c, function (t) {
          x.prototype[t] = function () {
            var e = r.call(arguments);
            return e.unshift(this.attributes), _[t].apply(_, e)
          }
        });
        var f = a.Collection = function (e, t) {
          t || (t = {}), t.model && (this.model = t.model), void 0 !== t.comparator && (this.comparator = t.comparator), this._reset(), this.initialize.apply(this, arguments), e && this.reset(e, _.extend({silent: !0}, t))
        }, E = {add: !0, remove: !0, merge: !0}, h = {add: !0, remove: !1};
        _.extend(f.prototype, o, {
          model: x, initialize: function () {
          }, toJSON: function (t) {
            return this.map(function (e) {
              return e.toJSON(t)
            })
          }, sync: function () {
            return a.sync.apply(this, arguments)
          }, add: function (e, t) {
            return this.set(e, _.extend({merge: !1}, t, h))
          }, remove: function (e, t) {
            var n, i, r, o, s = !_.isArray(e);
            for (t || (t = {}), n = 0, i = (e = s ? [e] : _.clone(e)).length; n < i; n++) (o = e[n] = this.get(e[n])) && (delete this._byId[o.id], delete this._byId[o.cid], r = this.indexOf(o), this.models.splice(r, 1), this.length--, t.silent || (t.index = r, o.trigger(S("3FP[XN\\"), o, this, t)), this._removeReference(o, t));
            return s ? e[0] : e
          }, set: function (e, t) {
            (t = _.defaults({}, t, E)).parse && (e = this.parse(e, t));
            var n, i, r, o, s, a, l, u = !_.isArray(e);
            e = u ? e ? [e] : [] : _.clone(e);
            var c = t.at, d = this.model, f = this.comparator && null == c && !1 !== t.sort,
              h = _.isString(this.comparator) ? this.comparator : null, g = [], p = [], v = {}, m = t.add, w = t.merge,
              y = t.remove, C = !(f || !m || !y) && [];
            for (n = 0, i = e.length; n < i; n++) {
              if (r = (s = e[n] || {}) instanceof x ? o = s : s[d.prototype.idAttribute || S("\nbh")], a = this.get(r)) y && (v[a.cid] = !0), w && (s = s === o ? o.attributes : s, t.parse && (s = a.parse(s, t)), a.set(s, t), f && !l && a.hasChanged(h) && (l = !0)), e[n] = a; else if (m) {
                if (!(o = e[n] = this._prepareModel(s, t))) continue;
                g.push(o), this._addReference(o, t)
              }
              o = a || o, !C || !o.isNew() && v[o.id] || C.push(o), v[o.id] = !0
            }
            if (y) {
              for (n = 0, i = this.length; n < i; ++n) v[(o = this.models[n]).cid] || p.push(o);
              p.length && this.remove(p, t)
            }
            if (g.length || C && C.length) if (f && (l = !0), this.length += g.length, null != c) for (n = 0, i = g.length; n < i; n++) this.models.splice(c + n, 0, g[n]); else {
              C && (this.models.length = 0);
              var b = C || g;
              for (n = 0, i = b.length; n < i; n++) this.models.push(b[n])
            }
            if (l && this.sort({silent: !0}), !t.silent) {
              for (n = 0, i = g.length; n < i; n++) (o = g[n]).trigger(S("$DBC"), o, this, t);
              (l || C && C.length) && this.trigger(S("\x1borlk"), this, t)
            }
            return u ? e[0] : e
          }, reset: function (e, t) {
            t || (t = {});
            for (var n = 0, i = this.models.length; n < i; n++) this._removeReference(this.models[n], t);
            return t.previousModels = this.models, this._reset(), e = this.add(e, _.extend({silent: !0}, t)), t.silent || this.trigger(S("<O[L%5"), this, t), e
          }, push: function (e, t) {
            return this.add(e, _.extend({at: this.length}, t))
          }, pop: function (e) {
            var t = this.at(this.length - 1);
            return this.remove(t, e), t
          }, unshift: function (e, t) {
            return this.add(e, _.extend({at: 0}, t))
          }, shift: function (e) {
            var t = this.at(0);
            return this.remove(t, e), t
          }, slice: function () {
            return r.apply(this.models, arguments)
          }, get: function (e) {
            if (null != e) return this._byId[e] || this._byId[e.id] || this._byId[e.cid]
          }, at: function (e) {
            return this.models[e]
          }, where: function (n, e) {
            return _.isEmpty(n) ? e ? void 0 : [] : this[S(e ? "\rhf~u" : "5P^TM_I")](function (e) {
              for (var t in n) if (n[t] !== e.get(t)) return !1;
              return !0
            })
          }, findWhere: function (e) {
            return this.where(e, !0)
          }, sort: function (e) {
            if (!this.comparator) throw new Error(S("#gDHIG]\nXC_Z\x0fQ\x11AV@\x15A^LQUNH\x1d_\x1f#./3%7'3';"));
            return e || (e = {}), _.isString(this.comparator) || 1 === this.comparator.length ? this.models = this.sortBy(this.comparator, this) : this.models.sort(_.bind(this.comparator, this)), e.silent || this.trigger(S("5EXJM"), this, e), this
          }, pluck: function (e) {
            return _.invoke(this.models, S("8^_O"), e)
          }, fetch: function (n) {
            void 0 === (n = n ? _.clone(n) : {}).parse && (n.parse = !0);
            var i = n.success, r = this;
            return n.success = function (e) {
              var t = n.reset ? S("6E]J_O") : S("/CTF");
              r[t](e, n), i && i(r, e, n), r.trigger(S("9IBR^"), r, e, n)
            }, K(this, n), this.sync(S("\x1bnx\x7f{"), this, n)
          }, create: function (e, n) {
            if (n = n ? _.clone(n) : {}, !(e = this._prepareModel(e, n))) return !1;
            n.wait || this.add(e, n);
            var i = this, r = n.success;
            return n.success = function (e, t) {
              n.wait && i.add(e, n), r && r(e, t, n)
            }, e.save(null, n), e
          }, parse: function (e, t) {
            return e
          }, clone: function () {
            return new this.constructor(this.models)
          }, _reset: function () {
            this.length = 0, this.models = [], this._byId = {}
          }, _prepareModel: function (e, t) {
            if (e instanceof x) return e;
            var n = new (((t = t ? _.clone(t) : {}).collection = this).model)(e, t);
            return n.validationError ? (this.trigger(S("A+-2$*.,"), this, n.validationError, t), !1) : n
          }, _addReference: function (e, t) {
            null != (this._byId[e.cid] = e).id && (this._byId[e.id] = e), e.collection || (e.collection = this), e.on(S("#EIJ"), this._onModelEvent, this)
          }, _removeReference: function (e, t) {
            this === e.collection && delete e.collection, e.off(S("\flbc"), this._onModelEvent, this)
          }, _onModelEvent: function (e, t, n, i) {
            (e !== S("$DBC") && e !== S("\nyi`ayu") || n === this) && (e === S("\x13ppecjvc") && this.remove(t, i), t && e === S("\x1axt|pxE\x1b") + t.idAttribute && (delete this._byId[t.previous(t.idAttribute)], null != t.id && (this._byId[t.id] = t)), this.trigger.apply(this, arguments))
          }
        });
        var g = [S("*MC_kNSY"), S("\x19\x7fz\x7fu"), S("@,#3"), S("\x12p{yzr{m"), S("\x1aiyyk|E"), S("\x1a}sqzs"), S("\x0ef~{wp`"), S("\x17j|~n\x7fxLvGIV"), S("*MCAJ]"), S("!DJJA"), S(")NNXHM["), S('B%-)2":'), S("6D]U_XH"), S("+^HDJSE"), S("9_MYOG"), S("0P^_"), S("!QLI@"), S("\x1fAO["), S("\rgas}gwq"), S("\x0fs~|gu|xd"), S("-GAF^YV"), S("2^UM"), S("\x1cpwq"), S("?4.\x0316$?"), S("\x1cnweE"), S("A$*662"), S("\x0fxtsw"), S("9NZWX"), S("%OIA]CJ@"), S("'ZLY_"), S("5BVQU"), S("\vh\x7fa\x7f"), S("@-#00"), S("0F[G\\ZCC"), S("(MCMJH\\J^RW"), S("$LHCMQeM"), S("C7-3!.%/"), S("/\\PAG}[RR@v\\"), S("?)2\x07.41?"), S("3W]W^V"), S(":H]PNS%")];
        _.each(g, function (t) {
          f.prototype[t] = function () {
            var e = r.call(arguments);
            return e.unshift(this.models), _[t].apply(_, e)
          }
        });
        var p = [S("E!5'<:\t5"), S("\x1e|OTLWf\\"), S("'[FX_nT"), S("+ECJJHsK")];
        _.each(p, function (i) {
          f.prototype[i] = function (t, e) {
            var n = _.isFunction(t) ? t : function (e) {
              return e.get(t)
            };
            return _[i](this.models, n, e)
          }
        });
        var v = a.View = function (e) {
            this.cid = _.uniqueId(S(":MUXI")), e || (e = {}), _.extend(this, _.pick(e, w)), this._ensureElement(), this.initialize.apply(this, arguments), this.delegateEvents()
          }, m = /^(\S+)\s*(.*)$/,
          w = [S("%KHLLF"), S("\x14vy{t|yourp"), S(":^P"), S("\x1fIE"), S("<\\JK2( 60 5"), S("(JFJ_^`N]T"), S("A6\"#\v'*-"), S("\x17}o\x7fuhn")];
        _.extend(v.prototype, o, {
          tagName: S("\x12w}c"), $: function (e) {
            return this.$el.find(e)
          }, initialize: function () {
          }, render: function () {
            return this
          }, remove: function () {
            return this.$el.remove(), this.stopListening(), this
          }, setElement: function (e, t) {
            return this.$el && this.undelegateEvents(), this.$el = e instanceof a.$ ? e : a.$(e), this.el = this.$el[0], !1 !== t && this.delegateEvents(), this
          }, delegateEvents: function (e) {
            if (!e && !(e = _.result(this, S("$@PBF]Y")))) return this;
            for (var t in this.undelegateEvents(), e) {
              var n = e[t];
              if (_.isFunction(n) || (n = this[e[t]]), n) {
                var i = t.match(m), r = i[1], o = i[2];
                n = _.bind(n, this), r += S("\x14;rrt|}zhx[iEOVP") + this.cid, "" === o ? this.$el.on(r, n) : this.$el.on(r, o, n)
              }
            }
            return this
          }, undelegateEvents: function () {
            return this.$el.off(S("\n%hhbjwpfvQcsylj") + this.cid), this
          }, _ensureElement: function () {
            if (this.el) this.setElement(_.result(this, S("5S[")), !1); else {
              var e = _.extend({}, _.result(this, S("'I]^YEO[[UB")));
              this.id && (e.id = _.result(this, S("B* "))), this.className && (e[S("\nh`l}|")] = _.result(this, S("!AOEVUiIDO")));
              var t = a.$("<" + _.result(this, S("-ZNW\x7fS^Q")) + ">").attr(e);
              this.setElement(t, !1)
            }
          }
        }), a.sync = function (e, t, n) {
          var i = C[e];
          _.defaults(n || (n = {}), {emulateHTTP: a.emulateHTTP, emulateJSON: a.emulateJSON});
          var r = {type: i, dataType: S(",G]@^")};
          if (n.url || (r.url = _.result(t, S("+Y_B")) || V()), null != n.data || !t || e !== S(":XNX_K%") && e !== S("\x18lj\x7f}i{") && e !== S("4EWC[Q") || (r.contentType = S("!CSTIODI]CDB\x02D\\__"), r.data = JSON.stringify(n.attrs || t.toJSON(n))), n.emulateJSON && (r.contentType = S("\ro\x7f`}{pua\x7fxv6b6kji2FNPN\tPTKMGIDHHJ"), r.data = r.data ? {model: r.data} : {}), n.emulateHTTP && (i === S("C\x14\x10\x12") || i === S("\x11VVXPBR") || i === S("\x11BR@V^"))) {
            r.type = S("\x1dNPsu"), n.emulateJSON && (r.data._method = i);
            var o = n.beforeSend;
            n.beforeSend = function (e) {
              if (e.setRequestHeader(S("D\x1dk\x0f\x1c\x1d\x1af\x01(:'?5\x7f\x1c\"0$%1=?"), i), o) return o.apply(this, arguments)
            }
          }
          r.type === S(")mnx") || n.emulateJSON || (r.processData = !1), r.type === S("8i{o\x7fu") && y && (r.xhr = function () {
            return new ActiveXObject(S("&jAJXD_BH[\x1ei\x7f\x7f|abg"))
          });
          var s = n.xhr = a.ajax(_.extend(r, n));
          return t.trigger(S(",_K^ETAG"), t, s, n), s
        };
        var y = !(void 0 === window || !window.ActiveXObject || window.XMLHttpRequest && (new XMLHttpRequest).dispatchEvent),
          C = {
            create: S(".\x7f\x7fbf"),
            update: S("7hln"),
            patch: S("\n[MYMG"),
            delete: S(":\x7fyq{k\x05"),
            read: S("1uv`")
          };
        a.ajax = function () {
          return a.$.ajax.apply(a.$, arguments)
        };
        var b = a.Router = function (e) {
          e || (e = {}), e.routes && (this.routes = e.routes), this._bindRoutes(), this.initialize.apply(this, arguments)
        }, M = /\((.*?)\)/g, F = /(\(\?)?:\w+/g, I = /\*\w+/g, R = /[\-{}\[\]+?.,\\\^$|#\s]/g;
        _.extend(b.prototype, o, {
          initialize: function () {
          }, route: function (n, i, r) {
            _.isRegExp(n) || (n = this._routeToRegExp(n)), _.isFunction(i) && (r = i, i = ""), r || (r = this[i]);
            var o = this;
            return a.history.route(n, function (e) {
              var t = o._extractParameters(n, e);
              o.execute(r, t), o.trigger.apply(o, [S("\x11`|aas-") + i].concat(t)), o.trigger(S("\x1bnrkkE"), i, t), a.history.trigger(S("2A[@BR"), o, i, t)
            }), this
          }, execute: function (e, t) {
            e && e.apply(this, t)
          }, navigate: function (e, t) {
            return a.history.navigate(e, t), this
          }, _bindRoutes: function () {
            if (this.routes) {
              this.routes = _.result(this, S("9HTII[L"));
              for (var e, t = _.keys(this.routes); null != (e = t.pop());) this.route(e, this.routes[e])
            }
          }, _routeToRegExp: function (e) {
            return e = e.replace(R, S("5j\x13\x1e")).replace(M, S("\x1a3#':.\t\x1e")).replace(F, function (e, t) {
              return t ? e : S("2\x1bok\x19\be\x12\x13")
            }).replace(I, S("#\f~x\x18u\x03\x15\x02")), new RegExp("^" + e + S("0\x19\r\th\n\x1eldJfha\x17\x17\x16\x7fe"))
          }, _extractParameters: function (e, t) {
            var n = e.exec(t).slice(1);
            return _.map(n, function (e, t) {
              return t === n.length - 1 ? e || null : e ? decodeURIComponent(e) : null
            })
          }
        });
        var T = a.History = function () {
          this.handlers = [], _.bindAll(this, S("5U_]ZQnNQ")), void 0 !== window && (this.location = window.location, this.history = window.history)
        }, O = /^[#\/]|\s+$/g, B = /^\/+|\/+$/g, P = /msie [\w.]+/, A = /\/$/, D = /#.*$/;
        T.started = !1, _.extend(T.prototype, o, {
          interval: 50, atRoot: function () {
            return this.location.pathname.replace(/[^\/]$/, S(" \x05\x04\f")) === this.root
          }, getHash: function (e) {
            var t = (e || this).location.href.match(/#(.*)$/);
            return t ? t[1] : ""
          }, getFragment: function (e, t) {
            if (null == e) if (this._hasPushState || !this._wantsHashChange || t) {
              e = decodeURI(this.location.pathname + this.location.search);
              var n = this.root.replace(A, "");
              e.indexOf(n) || (e = e.slice(n.length))
            } else e = this.getHash();
            return e.replace(O, "")
          }, start: function (e) {
            if (T.started) throw new Error(S("\x17Zxyp~rpz\x0eIKPPJT^\bAKX\fLB]UPVJ\x14WSRV\x19IO]OJZ$"));
            T.started = !0, this.options = _.extend({root: "/"}, this.options, e), this.root = this.options.root, this._wantsHashChange = !1 !== this.options.hashChange, this._wantsPushState = !!this.options.pushState, this._hasPushState = !!(this.options.pushState && this.history && this.history.pushState);
            var t = this.getFragment(), n = document.documentMode,
              i = P.exec(navigator.userAgent.toLowerCase()) && (!n || n <= 7);
            if (this.root = ("/" + this.root + "/").replace(B, "/"), i && this._wantsHashChange) {
              var r = a.$(S(")\x16BJ_OBU\x11AAW\b\x14]YO[H_OWO4{rad1'%!'..4plbasl"));
              this.iframe = r.hide().appendTo(S("1P\\PL"))[0].contentWindow, this.navigate(t)
            }
            this._hasPushState ? a.$(window).on(S("\v|b~|dpfv"), this.checkUrl) : this._wantsHashChange && S("/__ZRG]U_YW]^") in window && !i ? a.$(window).on(S("3\\TE_[Q[U[X"), this.checkUrl) : this._wantsHashChange && (this._checkUrlInterval = setInterval(this.checkUrl, this.interval)), this.fragment = t;
            var o = this.location;
            if (this._wantsHashChange && this._wantsPushState) {
              if (!this._hasPushState && !this.atRoot()) return this.fragment = this.getFragment(null, !0), this.location.replace(this.root + "#" + this.fragment), !0;
              this._hasPushState && this.atRoot() && o.hash && (this.fragment = this.getHash().replace(O, ""), this.history.replaceState({}, document.title, this.root + this.fragment))
            }
            if (!this.options.silent) return this.loadUrl()
          }, stop: function () {
            a.$(window).off(S("\x1fPNRPPDRB"), this.checkUrl).off(S('D-\'4 *"*"*+'), this.checkUrl), this._checkUrlInterval && clearInterval(this._checkUrlInterval), T.started = !1
          }, route: function (e, t) {
            this.handlers.unshift({route: e, callback: t})
          }, checkUrl: function (e) {
            var t = this.getFragment();
            if (t === this.fragment && this.iframe && (t = this.getFragment(this.getHash(this.iframe))), t === this.fragment) return !1;
            this.iframe && this.navigate(t), this.loadUrl()
          }, loadUrl: function (t) {
            return t = this.fragment = this.getFragment(t), _.any(this.handlers, function (e) {
              if (e.route.test(t)) return e.callback(t), !0
            })
          }, navigate: function (e, t) {
            if (!T.started) return !1;
            t && !0 !== t || (t = {trigger: !!t});
            var n = this.root + (e = this.getFragment(e || ""));
            if (e = e.replace(D, ""), this.fragment !== e) {
              if ("" === (this.fragment = e) && "/" !== n && (n = n.slice(0, -1)), this._hasPushState) this.history[t.replace ? S("\x17j|jw}~{LT@VF") : S("\x1cmklHrVBP@")]({}, document.title, n); else {
                if (!this._wantsHashChange) return this.location.assign(n);
                this._updateHash(this.location, e, t.replace), this.iframe && e !== this.getFragment(this.getHash(this.iframe)) && (t.replace || this.iframe.document.open().close(), this._updateHash(this.iframe.location, e, t.replace))
              }
              return t.trigger ? this.loadUrl(e) : void 0
            }
          }, _updateHash: function (e, t, n) {
            if (n) {
              var i = e.href.replace(/(javascript:|#).*$/, "");
              e.replace(i + "#" + t)
            } else e.hash = "#" + t
          }
        }), a.history = new T;
        x.extend = f.extend = b.extend = v.extend = T.extend = function (e, t) {
          var n, i = this;
          n = e && _.has(e, S("*HCC][BDQG[G")) ? e.constructor : function () {
            return i.apply(this, arguments)
          }, _.extend(n, i, t);
          var r = function () {
            this.constructor = n
          };
          return r.prototype = i.prototype, n.prototype = new r, e && _.extend(n.prototype, e), n.__super__ = i.prototype, n
        };
        var V = function () {
          throw new Error(S('A\x03cf04+ji:9#=+=$(r<&u0"6:.233~2\x15\x12\x16C\x06\0F\x14\x18\f\t\x02\n\x04\v\v'))
        }, K = function (t, n) {
          var i = n.error;
          n.error = function (e) {
            i && i(t, e, n), t.trigger(S("\x1cxlmOS"), t, e, n)
          }
        };
        return a
      }), CKFinder.define(S("D\x06\r\x01!'..>b\r >7;4"), [], function () {
        "use strict";
        return {
          id: "",
          configPath: S("6TWW\\R[\x13TL"),
          language: "",
          languages: {
            az: 1,
            bg: 1,
            bs: 1,
            ca: 1,
            cs: 1,
            cy: 1,
            da: 1,
            de: 1,
            "de-ch": 1,
            el: 1,
            en: 1,
            eo: 1,
            es: 1,
            "es-mx": 1,
            et: 1,
            eu: 1,
            fa: 1,
            fi: 1,
            fr: 1,
            gu: 1,
            he: 1,
            hi: 1,
            hr: 1,
            hu: 1,
            it: 1,
            ja: 1,
            ko: 1,
            ku: 1,
            lt: 1,
            lv: 1,
            nb: 1,
            nl: 1,
            nn: 1,
            no: 1,
            pl: 1,
            "pt-br": 1,
            ro: 1,
            ru: 1,
            sk: 1,
            sl: 1,
            sr: 1,
            sv: 1,
            tr: 1,
            uk: 1,
            "uz-cyrl": 1,
            "uz-latn": 1,
            vi: 1,
            "zh-cn": 1,
            "zh-tw": 1
          },
          defaultLanguage: S("D ("),
          removeModules: "",
          plugins: "",
          tabIndex: 0,
          resourceType: null,
          type: null,
          startupPath: "",
          startupFolderExpanded: !0,
          readOnly: !1,
          readOnlyExclude: "",
          connectorPath: "",
          connectorLanguage: S("\x19jsl"),
          pass: "",
          connectorInfo: "",
          dialogMinWidth: S("\x13%-sz"),
          dialogMinHeight: S("\x1d*zM"),
          dialogFocusItem: !0,
          dialogOverlaySwatch: !1,
          loaderOverlaySwatch: !1,
          width: S("0\0\x02\x03\x11"),
          height: 400,
          fileIcons: {
            default: S("3A[]YWNT\x15LSY"),
            folder: S("2W]GSTLVHB\x12MPX"),
            "7z": S("\x18.`5lsy"),
            accdb: S("\x17yzy~on0oNF"),
            avi: S("@7+'!*h7&."),
            bmp: S("(@GJKH\0_^V"),
            css: S("\nh\x7f~ \x7f~v"),
            csv: S("<^MIn1,$"),
            doc: S("\x15{dovh\x7f2mpx"),
            docx: S("4XE@WK^\x15LSY"),
            flac: S("9[NXTQ\x110/%"),
            gif: S("\x16~ux}~2mpx"),
            gz: S("'\\HX\x05\\CI"),
            htm: S("&O\\DF\x05\\CI"),
            html: S('=VK--l3*"'),
            jpeg: S('"JIDAB\x06YDL'),
            jpg: S("1[^URS\x19HW]"),
            js: S("B)%3'4+;#;8c>!7"),
            log: S('"OKB\bWFN'),
            mp3: S("\x0fqdvz{;fy\x7f"),
            mp4: S("\n}eik`>a|t"),
            odg: S("\x13pgw`6it|"),
            odp: S("\x19svlo{lS\x0fRMC"),
            ods: S("'KHFH\x02]@H"),
            odt: S("?73+7!7h7&."),
            ogg: S("(H_OEB\0_^V"),
            opus: S("/QDVZ[\x1bFY_"),
            pdf: S("\x11bwr;fy\x7f"),
            php: S('"SLU\bWFN'),
            png: S("\x17qt{|y3nqG"),
            ppt: S("1B\\CPDGWPTO\x12MPX"),
            pptx: S("E6(?,8;#$ ;~!<4"),
            rar: S("\x11`rf;fy\x7f"),
            README: S("\r|jqu\x7fv:exp"),
            rtf: S("*YXK\0_^V"),
            sql: S("\x17khv5lsy"),
            tar: S("\x12gug8gv~"),
            tiff: S("9SV]Z[\x110/%"),
            txt: S("$UJFAG\x04[BJ"),
            wav: S("=_J$(-m4+!"),
            weba: S("E'2, %e<#)"),
            webm: S(":MUY[Pn1,$"),
            xls: S(":^D^[Sn1,$"),
            xlsx: S("4PNT]U\x14KRZ"),
            zip: S("\x0fjxb=d{q")
          },
          fileIconsPath: S(" RIJJV\tDG[O\x04JDBJ\x1dXQ\\ZF\x19"),
          fileIconsSizes: S("1\0\x06\x02\x19\x07\x05\0\x15\f\x0f\x10\t\x06\x13ssnqviwq"),
          defaultDisplayFileName: !0,
          defaultDisplayDate: !0,
          defaultDisplayFileSize: !0,
          defaultViewType: S("9NSIP\\Q!(.0"),
          defaultSortBy: S("9TZQX"),
          defaultSortByOrder: S(":ZO^"),
          listViewIconSize: 22,
          compactViewIconSize: 22,
          thumbnailDelay: 50,
          thumbnailDefaultSize: 150,
          thumbnailMinSize: null,
          thumbnailMaxSize: null,
          thumbnailSizeStep: 2,
          thumbnailClasses: {120: S("$VKFDE"), 180: S("\x1bqxzvUL")},
          chooseFiles: !1,
          chooseFilesOnDblClick: !0,
          chooseFilesClosePopup: !0,
          resizeImages: !0,
          rememberLastFolder: !0,
          skin: S("$KCLG"),
          swatch: "a",
          displayFoldersPanel: !0,
          jquery: S("\x19vr~n1uQTGQ]\vLT"),
          jqueryMobile: S("\x17tpxh3wojES[\rIJDNDL\x04A_"),
          jqueryMobileStructureCSS: S("\x19vr~n1uQTGQ]\vKHJ@FN\x02^Z]ERFFFP\x18TKJ"),
          jqueryMobileIconsCSS: "",
          iconsCSS: "",
          themeCSS: "",
          coreCSS: S("\x12`\x7f|xd7zuiy2}tFHLGAW\bD[Z"),
          primaryPanelWidth: "",
          secondaryPanelWidth: "",
          cors: !1,
          corsSelect: !1,
          editImageMode: "",
          editImageAdjustments: [S("\x16ujp}shs{lS"), S("\x11q|zadvkm"), S("\x16r`iuhio{"), S("-]NDD@R@\\YY"), S("\nxi}gn"), S("9IS]ONZ.")],
          editImagePresets: [S("\fnbnbxfj"), S('E.":\x04+!)>:6'), S("\x10\x7f}``tzpqx"), S("8ISUTRRZ"), S("2@A[D^K\\"), S("&QAG^JKH")],
          autoCloseHTML5Upload: 5,
          uiModeThreshold: 48
        }
      }), CKFinder.define(S('@\x02\t\x05-+"":f\x0f=)#:'), [], function () {
        "use strict";

        function e() {
        }

        function d(e) {
          var t = e.getPrivate && e.getPrivate() || e._ev || (e._ev = {});
          return t.events || (t.events = {})
        }

        function f(e) {
          this.name = e, this.listeners = []
        }

        var c, S, h, g;
        return f.prototype = {
          getListenerIndex: function (e) {
            for (var t = 0, n = this.listeners; t < n.length; t++) if (n[t].fn === e) return t;
            return -1
          }
        }, e.prototype = {
          on: function (o, s, a, l, e) {
            function t(e, t, n, i) {
              var r = {
                name: o,
                sender: this,
                finder: e,
                data: t,
                listenerData: l,
                stop: n,
                cancel: i,
                removeListener: u
              };
              return !1 !== s.call(a, r) && r.data
            }

            function u() {
              c.removeListener(o, s)
            }

            var n, i, r = function (e) {
              var t = d(this);
              return t[e] || (t[e] = new f(e))
            }.call(this, o), c = this;
            if (r.getListenerIndex(s) < 0) {
              for (n = r.listeners, a || (a = this), isNaN(e) && (e = 10), t.fn = s, t.priority = e, i = n.length - 1; 0 <= i; i--) if (n[i].priority <= e) return n.splice(i + 1, 0, t), {removeListener: u};
              n.unshift(t)
            }
            return {removeListener: u}
          }, once: function () {
            var t = arguments[1];
            return arguments[1] = function (e) {
              return e.removeListener(), t.apply(this, arguments)
            }, this.on.apply(this, arguments)
          }, fire: (c = 0, S = function () {
            c = 1
          }, h = 0, g = function () {
            h = 1
          }, function (e, t, n) {
            var i, r, o, s, a = d(this)[e], l = c, u = h;
            if (h = c = 0, a && (o = a.listeners).length) for (o = o.slice(0), i = 0; i < o.length; i++) {
              if (a.errorProof) try {
                s = o[i].call(this, n, t, S, g)
              } catch (e) {
              } else s = o[i].call(this, n, t, S, g);
              if (!1 === s ? h = 1 : void 0 !== s && (t = s), c || h) break
            }
            return r = !h && (void 0 === t || t), c = l, h = u, r
          }), fireOnce: function (e, t, n) {
            var i = this.fire(e, t, n);
            return delete d(this)[e], i
          }, removeListener: function (e, t) {
            var n, i = d(this)[e];
            i && 0 <= (n = i.getListenerIndex(t)) && i.listeners.splice(n, 1)
          }, removeAllListeners: function () {
            var e, t = d(this);
            for (e in t) delete t[e]
          }, hasListeners: function (e) {
            var t = d(this)[e];
            return t && 0 < t.listeners.length
          }
        }, e
      }), CKFinder.define(S("9ypzTP[%3m\x160,*h\x1d=#'"), [S("\x13a{rrjjytnx")], function (u) {
        "use strict";
        return {
          url: function (e) {
            return /^(http(s)?:)?\/\/.+/i.test(e) ? e : CKFinder.require.toUrl(e)
          }, asyncArrayTraverse: function (i, r, e) {
            var o, s = 0;
            e || (e = null), r = r.bind(e), (o = function () {
              for (var e, t = 0, n = (new Date).getTime(); ;) {
                if (s >= i.length) return;
                if (!(e = i.item ? i.item(s) : i[s]) || !1 === r(e, s, i)) return;
                if (s += 1, 10 <= (t += 1) && 50 < (new Date).getTime() - n) return setTimeout(o, 50)
              }
            }).call()
          }, isPopup: function () {
            return window !== window.parent && !!window.opener || window.isCKFinderPopup
          }, isModal: function () {
            return window.parent.CKFinder && window.parent.CKFinder.modal && window.parent.CKFinder.modal(S("\x12e}f\x7fut|"))
          }, isWidget: function () {
            return window !== window.parent && !window.opener
          }, toGet: function (n) {
            var i = "";
            return u.forOwn(n, function (e, t) {
              i += "&" + encodeURIComponent(t) + "=" + encodeURIComponent(n[t])
            }), i.substring(1)
          }, cssEntities: function (e) {
            return e.replace(/\(/g, S(";\x1a\x1e\x07\r{gawt~")).replace(/\)/g, S("*\r\x0f\x14\x1c\x14\x16\x12\x06\x02\x0f"))
          }, jsCssEntities: function (e) {
            return e.replace(/\(/g, S(">\x1ary")).replace(/\)/g, S("D`t~"))
          }, getUrlParams: function () {
            var i = {};
            return window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (e, t, n) {
              i[t] = n
            }), i
          }, parentFolder: function (e) {
            return e.split("/").slice(0, -1).join("/")
          }, isShortcut: function (e, t) {
            var n = t.split("+"), i = !!e.ctrlKey || !!e.metaKey, r = !!e.altKey, o = !!e.shiftKey,
              s = i == !!u.contains(n, S("D&25$")), a = r == !!u.contains(n, S("\x1e~LU")),
              l = o == !!u.contains(n, S("8JRRZI"));
            return s && a && l
          }, randomString: function (e, t) {
            t || (t = S("E'%+-/-+%'%;=?=;%'%+-/-+%'%PPPPPPPPPP"));
            for (var n = "", i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * t.length));
            return n
          }, escapeHtml: function (e) {
            var t = {
              "&": S("#\x02DKW\x13"),
              "<": S("!\x04OP\x1e"),
              ">": S("$\x03AS\x13"),
              '"': S("'\x0eX_DX\x16"),
              "'": S("\x1a=?--&\x1b")
            };
            return e.replace(/[&<>"']/g, function (e) {
              return t[e]
            })
          }
        }
      }), CKFinder.define(S("\x10RYU}{rrj6Oouq1SAOE"), [S("D0(#-;9(#?+"), S("\x12ye`sea"), S("'KBLtKAAMQ]")], function (s, t, a) {
        "use strict";
        var l = {
          loadPluginLang: function (e, t, n, i) {
            var r, o = n.lang.split(",");
            if (0 <= s.indexOf(o, e)) r = e; else {
              if (!(0 <= s.indexOf(o, t))) return void i({});
              r = t
            }
            a.require([S("+XHV[\x11") + a.require.toUrl(n.path) + S("\x1bp|px\x0f") + r + S("Cj/5(&")], function (e) {
              var t;
              try {
                t = JSON.parse(e)
              } catch (e) {
                t = {}
              }
              i(t)
            }, function () {
              i({})
            })
          }, init: function (e) {
            var o = new t.Deferred;
            return function (t, e, n, i) {
              t || (t = l.getSupportedLanguage(navigator.userLanguage || navigator.language, n));
              n[e] || (e = S("=[Q"));
              var r, o = S("9VZRZ\x11") + e + S("?n+1,*");
              n[t] && (r = S(".CQ_U\x1c") + t + S("Bm.6))"));
              r || (r = o);
              a.require([S("\x1ci{gT\0") + a.require.toUrl(r) + S('\x0f/ryubpd*-."+-),+\x10')], function (e) {
                i(t, JSON.parse(e))
              }, function () {
                i(t)
              })
            }(e.language, e.defaultLanguage, e.languages, function (e, t) {
              if (t) {
                var n, i, r = t;
                r.formatDate = (n = S("<f\x19") + r.units.dateAmPm.join(S("\r)#7")) + S("\x133H"), i = (i = "'" + (i = r.units.dateFormat.replace(/dd|mm|yyyy|hh|HH|MM|aa|d|m|yy|h|H|M|a/g, function (e) {
                  var t = {
                    d: S("8][B\x12O[O, !&lj\x18wgemle"),
                    dd: S("\x1dz~Y"),
                    m: S("\x12~{{b\x7f6k\x7fkp|}z\b\x0e|\x13\v\t\x01\0\x01"),
                    mm: S("8TUUHU"),
                    yy: S(",TKNB\x1fAFVFBE\x10\v\x13"),
                    yyyy: S("C= '5"),
                    H: S("\vdb{}>cwcxtur06D+3198\t"),
                    HH: S(">W/40"),
                    h: S('\r~nbbwZza>7pvoi<4>"\x1d\x1c\x02\x13\x04\x03\0\x07XHXXId@[\x18\x11_ZZ@BR\x18\x10\x1a\x06\x01\0\x1e\x0f`~') + S(";\x1c\x1a\x0f\rga") + ":" + S("0\x11\x1a\x13\x1c\x15^XMK\x1a\x07\x01\x1d\x0f\r`~b++04gribkdm& %#r~tddwqyq{mmn\x7fIO\x16\f7\x11\x14\x0e\x06\x0eBBB\x1e\x1b\r\x03\x05\0[TDV^XPT\t\x19\r\x12\x1ecd*,Z5)+/.#+%"),
                    hh: S("1BRFFS~VM\x12\x1bTRKM`hb~yxfwholk<,<<5\x18<'|u;>6,.>|t~b]\\BSDZ") + S("\x1233$$08") + ":" + S("3\x14\x1d\x16\x1f\x18QUNN\x1d\x02\x02`ppc{e.(=;jqlengp9=&&u{wikzr|v~nPQBJJ\x11\t4\x1c\x1b\x03\x05\vEGA\x03\x04\x10\0\0\x07^WIYS[U]W"),
                    M: S("\x12~}{cc}7h~lq\x7f|E\t\r}\x14\n\n\0\x0f\0"),
                    MM: S("D(/)==/"),
                    a: n + S("(r\nCCX\\\x0f\f\x11\x03\x01\x14\n\x16\x07\x18\x03\x1a\n\x1c`\x10\\( 0\x020mvn"),
                    aa: n + S(";g\x1dVP53b\x7fdttgwizkvm\x7fo\r")
                  };
                  return S("\x1d93") + t[e] + S('"\x0f\x03')
                })) + "'").replace(/('',)|,''$/g, ""), new Function(S("A;&%7"), S("\x13yzxcp"), S("\x1dz~Y"), S("#LJSU"), S("\f`gaeew"), S("1@V@@DY\x18b") + i + S("(t\x04ACD@\x07\x12\x13\x1b\b"))), r.formatDateString = function (e) {
                  return e = e || "", s.isNumber(e) && (e = e.toString()), e.length < 12 ? "" : r.formatDate(e.substr(0, 4), e.substr(4, 2), e.substr(6, 2), e.substr(8, 2), e.substr(10, 2))
                }, r.formatFileSize = function (e) {
                  var t = 1024, n = t * t, i = n * t;
                  return i <= e ? r.units.gb.replace(S("$^UNRLW"), (e / i).toFixed(1)) : n <= e ? r.units.mb.replace(S("@:1*> ;"), (e / n).toFixed(1)) : t <= e ? r.units.kb.replace(S("\x1a`otdz]"), (e / t).toFixed(1)) : S("\x19ahug{b\0c").replace(S("!YPM_CZ"), e)
                }, r.formatTransfer = function (e) {
                  return r.units.sizePerSecond.replace(S(",V]FJTO"), r.formatFileSize(parseInt(e)))
                }, r.formatFilesCount = function (e) {
                  return r.files[S(1 === e ? "\x1c~qjNUmMA" : ";_RKQ4\f#-=")].replace(S("\x0ets~g}`h"), e)
                }, o.resolve(r)
              } else o.reject()
            }), o.promise()
          }, getSupportedLanguage: function (e, t) {
            if (!e) return !1;
            var n = e.toLowerCase().match(/([a-z]+)(?:-([a-z]+))?/), i = n[1], r = n[2];
            return t[i + "-" + r] ? i = i + "-" + r : t[i] || (i = !1), i
          }
        };
        return l
      }), CKFinder.define(S("/sztZZQSE\x17lNRP\x12uZ9\x02-'!"), {
        up: 38,
        down: 40,
        left: 37,
        right: 39,
        backspace: 8,
        tab: 9,
        enter: 13,
        space: 32,
        escape: 27,
        end: 35,
        home: 36,
        delete: 46,
        menu: 93,
        slash: 191,
        a: 65,
        r: 82,
        u: 85,
        f2: 113,
        f5: 116,
        f7: 118,
        f8: 119,
        f9: 120,
        f10: 121
      }), CKFinder.define(S("-mdvX\\WQG\x19bq\x16ort\\]T3"), [S('C1+""::)$>('), S("3^DCRJ@"), S("&dcoCEHH\\\0eE[_\x1b~SN{V^^"), S("-MDV\x1cXBAPDN\x15TUYUQ[")], function (a, l, u) {
        "use strict";
        return {
          init: function (n) {
            !function () {
              var e = [S("\x16cjxthuiwpN")];
              a.forEach(e, function (e) {
                (function (e) {
                  var t = (document.body || document.documentElement).style;
                  if ("string" == typeof t[e]) return !0;
                  var n = [S("\x15[xb"), S("!UFFNOS"), S("\v[hldye"), S("\rEgd|~"), "O", S("\x1erS")];
                  e = e.charAt(0).toUpperCase() + e.substr(1);
                  for (var i = 0; i < n.length; i++) if ("string" == typeof t[n[i] + e]) return !0;
                  return !1
                })(e) && l(S("+NBJV")).addClass(S("8ZQ]\x11[[^440&i&54e") + e)
              })
            }(), function (t) {
              var e = void 0 === document.documentMode, n = window.chrome;
              e && !n ? l(window).on(S("$CID]ZCE"), function (e) {
                e.target === window && setTimeout(function () {
                  t.fire(S('@4+y"*%2;'), null, t)
                }, 300)
              }).on(S("8_UXINQJ4"), function (e) {
                e.target === window && t.fire(S("\x12f}/t{mk"), null, t)
              }) : window.addEventListener ? (window.addEventListener(S("\x12u{vcd"), function () {
                setTimeout(function () {
                  t.fire(S("<HW\x05&.!67"), null, t)
                }, 300)
              }, !1), window.addEventListener(S("<_RJ2"), function () {
                t.fire(S("!WJ\x1eGJRZ"), null, t)
              }, !1)) : (window.attachEvent(S("%@HK\\Y"), function () {
                setTimeout(function () {
                  t.fire(S("*^E\x17H@SDA"), null, t)
                }, 300)
              }), window.attachEvent(S("0S^FF"), function () {
                t.fire(S("\fxg5r}ga"), null, t)
              }))
            }(n);
            var e, t, i, r = l(S("7ZV^B"));
            r.attr({
              "data-theme": n.config.swatch,
              role: S("\x15wghusx}iwpN")
            }), -1 < navigator.userAgent.toLowerCase().indexOf(S("\x1djmIEGMP\n")) && r.addClass(S("\x17{r|6ux")), l(S("\x19roqq")).attr({
              dir: n.lang.dir,
              lang: n.lang.langCode
            }), n.lang.dir !== S("!NWV") && r.addClass(S("E%,.d8? ")), n.setHandler(S('A7*~"#3\x05&..'), (i = window.matchMedia ? function () {
              return void 0 === t && (t = S('>\x17- :n3,"3 sj') + n.config.uiModeThreshold + S("'MD\x03")), window.matchMedia(t).matches
            } : function () {
              return void 0 === e && (e = parseFloat(l(S("\x11p|pl")).css(S("\rh`~e?`}os"))) * n.config.uiModeThreshold), window.innerWidth <= e
            }, function () {
              return i.call(this) ? S("\x19wt~trz") : S(")NN_FZ@@")
            }));
            var o = n.request(S("\x16bq#}~hPq{E"));
            if (c(r, null, o), l(window).bind(S(")^C^BZ[\\TVAQF_M]"), function () {
              var e = n.request(S("0D[\tSPBzW]_")), t = o !== e;
              t && (c(r, o, e), o = e), n.fire(S(",XG\x15BTAZNP"), {modeChanged: t, mode: o}, n)
            }), navigator.maxTouchPoints) {
              var s = l.event.special.swipe.start;
              l.event.special.swipe.start = function (e) {
                var t = s(e);
                return t.ckfOrigin = e.originalEvent.type, t
              }, l(window).bind(S("&T_@ZN@HH["), function (e) {
                0 !== e.swipestart.ckfOrigin.indexOf(S("\x12~{`er")) && n.fire(S("1GZ\x0eFA^H\\V^ZI"), {evt: e}, n)
              }), l(window).bind(S("\x1fSVKSAWO@@]"), function (e) {
                0 !== e.swipestart.ckfOrigin.indexOf(S("\x10|}fgp")) && n.fire(S("\x1bit$lWHRFVLAO\\"), {evt: e}, n)
              })
            }
            n.setHandler(S(" BNLW@vHX\\Z"), function () {
              n.util.isPopup() ? window.close() : window.top && window.top.CKFinder && window.top.CKFinder.modal && window.top.CKFinder.modal(S("\x13wyyd}"))
            }), l(document).on(S("\x0e|u}wp`fbvjm"), S(";gYL^'&#!( \x1b"), function (e) {
              e.preventDefault(), e.dragDrop && e.dragDrop()
            }), n.once(S("E'78s8.-)7"), function (e) {
              e.finder.request(S("\x1etEX\x18OMVRBF"), {key: u.space}), e.finder.on(S(".DUHV\\C[\f") + u.space, function (e) {
                e.data.evt.preventDefault()
              })
            })
          }
        };

        function c(e, t, n) {
          t && e.removeClass(S(">\\+'o6-h+(,,g") + t), e.addClass(S("/SZT\x1eA\\\x1bZW]_\x16") + n)
        }
      }), CKFinder.define(S("$fmaAGNN^\x02~CEV[]G\x1af[M^SU"), [S('"VJACU[JEYI'), S("\x11xbapdn"), S("9XZ_V\\P.$")], function (e, t, n) {
        "use strict";

        function i() {
        }

        return i.extend = n.Model.extend, e.extend(i.prototype, {
          addCss: function (e) {
            t(S("6\vKMCWY\x03")).text(e).appendTo(S("1ZVUQ"))
          }, init: function () {
          }
        }), i
      }), CKFinder.define(S("!ahbLHCM[\x05{@XIF^B\x1dcX@Q^VJ"), [S("+YCJJBBQ\\FP"), S("D/72-;3"), S("2QUV]UWW_"), S("'kblBBIK]\x1fa^FS\\XD\x17iVN[TP"), S('3w~p^V]_I\x13hJV,n\x0e"*"')], function (r, e, t, o, s) {
        "use strict";
        return t.Collection.extend({
          load: function (i) {
            var n = [], e = i.config.plugins;

            function t() {
              var e = r.countBy(n, S("A.,%!##"));
              e.undefined || (i.fire(S("\x12cx`q~v#{wpO{~DX"), null, i), e.false && r.forEach(r.where(n, {loaded: !1}), function (e) {
                i.fire(S("#TIS@AG\x10GCLJjBC]A"), {configKey: e.config, url: e.url})
              }))
            }

            e.length < 1 ? i.fire(S("._\\DUZZ\x0fW[Tk_ZXD"), null, i) : (r.isString(e) && (e = e.split(",")), r.forEach(e, function (e) {
              var t = e;
              -1 === e.search("/") && (t = CKFinder.require.toUrl(S("7HUO\\USM\x10") + e + "/" + e + ".js")), n.push({
                config: e,
                url: t,
                loaded: void 0
              })
            }), i.on(S(",]BZWX\\\tFPWSA"), function () {
              t()
            }), r.forEach(n, function (n) {
              CKFinder.require([n.url], function (e) {
                var t = o.extend(e);
                !function (t, e, n) {
                  if (e.path = t.util.parentFolder(n.url) + "/", !e.lang) return i();

                  function i() {
                    e.init(t), t._plugins.add(e), n.loaded = !0, t.fire(S("C4)3 !'p9),*6"), {plugin: e}, t)
                  }

                  s.loadPluginLang(t.lang.langCode, t.config.defaultLanguage, e, function (e) {
                    e.name && e.values && (t.lang[e.name] = e.values), i()
                  })
                }(i, new t, n)
              }, function () {
                n.loaded = !1, t()
              })
            }))
          }
        })
      }), CKFinder.define(S("\x17[R\\rry{m\x0flMGQICT\x07jYYJyADU_\x7fRZTQRJ\x16yHN[jP+$,\x0e%+' -;"), [], function () {
        "use strict";
        var t = S("\x11qxWfdqLvq~r"), n = 40, i = null;

        function r() {
          if (i) return i;
          var e = function (e) {
            e = e.toLowerCase();
            for (var t = window.document.cookie.split(";"), n = 0; n < t.length; n++) {
              var i = t[n].split("="), r = decodeURIComponent(i[0].trim().toLowerCase()), o = 1 < i.length ? i[1] : "";
              if (r === e) return decodeURIComponent(o)
            }
            return ""
          }(t);
          return e.length != n && (e = function (e) {
            var t = S("9[Y_Y[Y')+)/)+)'9;9?9;9')+)ddddlllldd"), n = [], i = "";
            if (window.crypto && window.crypto.getRandomValues) n = new Uint8Array(e), window.crypto.getRandomValues(n); else for (var r = 0; r < e; r++) n.push(Math.floor(256 * Math.random()));
            for (var o = 0; o < n.length; o++) {
              var s = t.charAt(n[o] % t.length);
              i += .5 < Math.random() ? s.toUpperCase() : s
            }
            return i
          }(n), function (e, t) {
            window.document.cookie = encodeURIComponent(e) + "=" + encodeURIComponent(t) + S("'\x13YK_D\x10\x01")
          }(t, e)), e
        }

        return function (e) {
          e.setHandler(S("*H__H\x15WTFg[^SY"), r), e.setHandler(S('.F^EWAZTZ\r[JH]\x06N[K\x10 0&*1\x11.&-%<\x18"%*>'), function (e) {
            i = e.token
          })
        }
      }), CKFinder.define(S("\x1e\\kgKM@@T\beFN^@H]\0s^\\]QVBXJ\x16nI]SMO/36"), [S("\x1euQTGQ]"), S("\x11g}ppdd{vh~")], function (i, r) {
        "use strict";
        var o = function () {
        };

        function e(e, t) {
          this.url = e, this.config = t, this.onDone = o, this.onFail = o, this.request = null
        }

        return e.prototype.done = function (e) {
          this.onDone = e
        }, e.prototype.fail = function (e) {
          this.onFail = e
        }, e.prototype.send = function () {
          window.XMLHttpRequest ? function (e) {
            var t, n;
            t = new XMLHttpRequest, n = null, t.open(e.config.type, e.url, !0), t.onreadystatechange = function () {
              4 === this.readyState && e.onDone(this.responseText)
            }, t.onerror = function () {
              e.onFail()
            }, r.isFunction(e.config.uploadProgress) && t.upload && (t.upload.onprogress = e.config.uploadProgress);
            r.isFunction(e.config.uploadEnd) && t.upload && (t.upload.onload = e.config.uploadEnd);
            e.config.type === S("/@^AG") && (n = i.param(r.extend(e.config.post)), t.setRequestHeader(S("4vYYL\\TO\x11iGO%"), S("<\\NO,(!\"0,))g1g<;:c)?#?~!':26:5?99")));
            t.send(n), e.request = t
          }(this) : function (e) {
            var t, n;
            t = new XDomainRequest, n = null, e.config.type === S("E6(;=") && (n = i.param(e.config.post));
            t.open(e.config.type, e.url), t.onload = function () {
              e.onDone(this.responseText)
            }, t.onprogress = o, t.ontimeout = o, t.onerror = function () {
              e.onFail()
            }, e.request = t, setTimeout(function () {
              t.send(n)
            }, 0)
          }(this)
        }, e.prototype.abort = function () {
          this.request && this.request.abort()
        }, e
      }), CKFinder.define(S(' bieMKBBZ\x06gDHXBJC\x1eq\\Z[STLVH\x14\x7fRPQ%"6,6'), [S("\x19ouxxllCNPF"), S("&MY\\OYU"), S("\x1d}tF~EOKGGK"), S("\x1d]TfHLGAW\tjGM_GI^\x01l__\\VWAYE\x17mHZRNNP25")], function (c, r, i, d) {
        "use strict";

        function f(e, t, n) {
          var i = this.finder, r = i.config, o = {command: e, lang: i.lang.langCode, langCode: i.lang.langCode},
            s = r.connectorInfo;
          if (n && (o.type = n.get(S(".]UB]FFVScAI_")), o.currentFolder = n.getPath(), o.hash = n.getHash()), r.pass.length) {
            var a = r.pass.split(",");
            c.forEach(a, function (e) {
              o[e] = i.config[e]
            })
          }
          r.id && (o.id = r.id);
          var l = this.baseUrl + "?" + i.util.toGet(c.extend(o, t));
          return 0 < s.length && (l += "&" + s), l
        }

        function o(o) {
          var s = this.finder, a = o.name, l = r.Deferred(), u = {name: a, response: {error: {number: 109}}};
          if (c.has(o, S("/S^\\GQMB")) && (u.context = o.context), s.fire(S('"@KHKFFM\x10IIKA]U'), o, s) && s.fire(S("D&)*%($/v/+)?#7i") + a, o, s)) {
            var e = c.extend({type: S("\x18~\x7fo"), post: {}}, o), t = {};
            t.type = e.type, e.type === S("0A]@@") && (e.post.ckCsrfToken = s.request(S("4VEE^\x03]^HiQT%/")), t.post = e.sendPostAsJson ? {jsonData: JSON.stringify(e.post)} : e.post), e.uploadProgress && (t.uploadProgress = e.uploadProgress), e.uploadEnd && (t.uploadEnd = e.uploadEnd);
            var n = f.call(this, a, o.params, o.folder), i = new d(n, t);
            return i.done(function (t) {
              var e, n, i = !1;
              try {
                n = JSON.parse(t), e = {name: a, response: n, rawResponse: t}, i = !0
              } catch (e) {
                var r = u;
                return r.response.error.message = t, h(a, r, s), void l.reject(r)
              }
              i && l.resolve(n), c.has(o, S('B ++2"0=')) && (e.context = o.context), !n || n.error ? s.fire(S("4VYZUXT_\x06XLM/3x") + a, e, s) && (o.context && o.context.silentConnectorErrors || s.fire(S("\x1d}pMLCM@\x1fCUZFX"), e, s)) : s.fire(S("\vobcbq\x7fv){~,") + a, e, s), s.fire(S(';_RSR!/&y%#2":'), e, s), s.fire(S("/S^_^U[R\rY_N^N\x07") + a, e, s)
            }), i.fail(function () {
              h(a, u, s), l.reject(u)
            }), i.send(), o.returnTransport ? i : l.promise()
          }
        }

        function h(e, t, n) {
          n.fire(S("\x0el\x7f|\x7frzq,rjkui&") + e, t, n) && n.fire(S("\x12p{x{vv} ~noqm"), t, n), n.fire(S("\x14vyzuxt\x7f&|xkES"), t, n), n.fire(S("/S^_^U[R\rY_N^N\x07") + e, t, n)
        }

        return function (e) {
          var t = e.config;

          function n(e) {
            if (/^(http(s)?:)?\/\/.+/i.test(e)) return e;
            0 !== e.indexOf("/") && (e = "/" + e);
            var t = window.parent ? window.parent.location : window.location;
            return t.protocol + S("\x12<;") + t.host + e
          }

          this.finder = e, (this.config = t).connectorPath ? this.baseUrl = n(t.connectorPath) : (this.baseUrl = i._connectors[i.connector], "/" !== this.baseUrl.charAt(0) && (this.baseUrl = i.require.toUrl(S(":\x15\x13") + this.baseUrl)), this.baseUrl = n(this.baseUrl)), e.setHandlers({
            "command:send": {
              callback: o,
              context: this
            }, "command:url": {
              callback: function (e) {
                return f.call(this, e.command, e.params, e.folder)
              }, context: this
            }
          })
        }
      }), function (n, i) {
        if ("function" == typeof CKFinder.define && CKFinder.define.amd) CKFinder.define(S("\x1fM@PJKKCS\\L"), [S("\x19xz\x7fv|pND"), S("&RFMOY_NA]U")], function (e, t) {
          return n.Marionette = n.Mn = i(n, e, t)
        }); else if ("undefined" != typeof exports) {
          var e = require(S("3VTU\\ZVT^")), t = require(S("\x13a{rrjjytnx"));
          module.exports = i(n, e, t)
        } else n.Marionette = n.Mn = i(n, n.Backbone, n._)
      }(this, function (e, s, f) {
        "use strict";
        var t, n, i, r, o, a, l, u, c, d, h, g, p, v, m, w, y, C;
        n = f, i = (t = s).ChildViewContainer, t.ChildViewContainer = function (e, i) {
          var n = function (e) {
            this._views = {}, this._indexByModel = {}, this._indexByCustom = {}, this._updateLength(), i.each(e, this.add, this)
          };
          i.extend(n.prototype, {
            add: function (e, t) {
              var n = e.cid;
              return (this._views[n] = e).model && (this._indexByModel[e.model.cid] = n), t && (this._indexByCustom[t] = n), this._updateLength(), this
            }, findByModel: function (e) {
              return this.findByModelCid(e.cid)
            }, findByModelCid: function (e) {
              var t = this._indexByModel[e];
              return this.findByCid(t)
            }, findByCustom: function (e) {
              var t = this._indexByCustom[e];
              return this.findByCid(t)
            }, findByIndex: function (e) {
              return i.values(this._views)[e]
            }, findByCid: function (e) {
              return this._views[e]
            }, remove: function (e) {
              var n = e.cid;
              return e.model && delete this._indexByModel[e.model.cid], i.any(this._indexByCustom, function (e, t) {
                if (e === n) return delete this._indexByCustom[t], !0
              }, this), delete this._views[n], this._updateLength(), this
            }, call: function (e) {
              this.apply(e, i.tail(arguments))
            }, apply: function (t, n) {
              i.each(this._views, function (e) {
                i.isFunction(e[t]) && e[t].apply(e, n || [])
              })
            }, _updateLength: function () {
              this.length = i.size(this._views)
            }
          });
          var t = [S('"EKWcFKA'), S("+ILMG"), S("%KFX"), S("\x1c{wqD"), S("6S]M_XH"), S("\fkgcdt`"), S("\x1boxrzCU"), S("6E]S_XH"), S("\x16rn|hb"), S('"BHI'), S("1A\\YP"), S("!CM]"), S("\x15\x7fy{uo\x7fy"), S("\x16twwnzusm"), S(")CEZBEJ"), S('=JP\x0130"='), S("!DJVVR"), S(")CEEYGN\\"), S("\x16e}jn"), S('"OEVR'), S("\x1ehIUJLQQ"), S(";UN{R05;"), S("+\\A[L["), S("B1!!3$-")];
          return i.each(t, function (t) {
            n.prototype[t] = function () {
              var e = [i.values(this._views)].concat(i.toArray(arguments));
              return i[t].apply(i, e)
            }
          }), n
        }(0, n), t.ChildViewContainer.VERSION = S("8\t\x14\n\x12\f\x0f"), t.ChildViewContainer.noConflict = function () {
          return t.ChildViewContainer = i, this
        }, t.ChildViewContainer, o = f, y = (r = s).Wreqr, C = r.Wreqr = {}, r.Wreqr.VERSION = S(".\x1e\x1e\x02\x1c\x05"), r.Wreqr.noConflict = function () {
          return r.Wreqr = y, this
        }, C.Handlers = (l = o, (u = function (e) {
          this.options = e, this._wreqrHandlers = {}, l.isFunction(this.initialize) && this.initialize(e)
        }).extend = (a = r).Model.extend, l.extend(u.prototype, a.Events, {
          setHandlers: function (e) {
            l.each(e, function (e, t) {
              var n = null;
              l.isObject(e) && !l.isFunction(e) && (n = e.context, e = e.callback), this.setHandler(t, e, n)
            }, this)
          }, setHandler: function (e, t, n) {
            var i = {callback: t, context: n};
            this._wreqrHandlers[e] = i, this.trigger(S("\x13|txst|h!}yz"), e, t, n)
          }, hasHandler: function (e) {
            return !!this._wreqrHandlers[e]
          }, getHandler: function (e) {
            var t = this._wreqrHandlers[e];
            if (t) return function () {
              return t.callback.apply(t.context, arguments)
            }
          }, removeHandler: function (e) {
            delete this._wreqrHandlers[e]
          }, removeAllHandlers: function () {
            this._wreqrHandlers = {}
          }
        }), u), C.CommandStorage = (c = function (e) {
          this.options = e, this._commands = {}, o.isFunction(this.initialize) && this.initialize(e)
        }, o.extend(c.prototype, r.Events, {
          getCommands: function (e) {
            var t = this._commands[e];
            return t || (t = {command: e, instances: []}, this._commands[e] = t), t
          }, addCommand: function (e, t) {
            this.getCommands(e).instances.push(t)
          }, clearCommands: function (e) {
            this.getCommands(e).instances = []
          }
        }), c), C.Commands = (h = o, (d = C).Handlers.extend({
          storageType: d.CommandStorage, constructor: function (e) {
            this.options = e || {}, this._initializeStorage(this.options), this.on(S("C,$(#$,8q-)*"), this._executeCommands, this), d.Handlers.prototype.constructor.apply(this, arguments)
          }, execute: function (e) {
            e = arguments[0];
            var t = h.rest(arguments);
            this.hasHandler(e) ? this.getHandler(e).apply(this, t) : this.storage.addCommand(e, t)
          }, _executeCommands: function (e, t, n) {
            var i = this.storage.getCommands(e);
            h.each(i.instances, function (e) {
              t.apply(n, e)
            }), this.storage.clearCommands(e)
          }, _initializeStorage: function (e) {
            var t, n = e.storageType || this.storageType;
            t = h.isFunction(n) ? new n : n, this.storage = t
          }
        })), C.RequestResponse = (g = o, C.Handlers.extend({
          request: function (e) {
            if (this.hasHandler(e)) return this.getHandler(e).apply(this, g.rest(arguments))
          }
        })), C.EventAggregator = (v = o, (m = function () {
        }).extend = (p = r).Model.extend, v.extend(m.prototype, p.Events), m), C.Channel = (w = function (e) {
          this.vent = new r.Wreqr.EventAggregator, this.reqres = new r.Wreqr.RequestResponse, this.commands = new r.Wreqr.Commands, this.channelName = e
        }, o.extend(w.prototype, {
          reset: function () {
            return this.vent.off(), this.vent.stopListening(), this.reqres.removeAllHandlers(), this.commands.removeAllHandlers(), this
          }, connectEvents: function (e, t) {
            return this._connect(S("\x14csyl"), e, t), this
          }, connectCommands: function (e, t) {
            return this._connect(S("<^QR- ,'7"), e, t), this
          }, connectRequests: function (e, t) {
            return this._connect(S("\x15drik\x7fh"), e, t), this
          }, _connect: function (n, e, i) {
            if (e) {
              i = i || this;
              var r = n === S("'^LD_") ? "on" : S(":HYIv^.%.&6");
              o.each(e, function (e, t) {
                this[n][r](t, o.bind(e, i))
              }, this)
            }
          }
        }), w), C.radio = function (n, o) {
          var e = function () {
            this._channels = {}, this.vent = {}, this.commands = {}, this.reqres = {}, this._proxyMethods()
          };
          o.extend(e.prototype, {
            channel: function (e) {
              if (!e) throw new Error(S('8zRZRS[S`,700e4"+,#=)m/o>0?6'));
              return this._getChannel(e)
            }, _getChannel: function (e) {
              var t = this._channels[e];
              return t || (t = new n.Channel(e), this._channels[e] = t), t
            }, _proxyMethods: function () {
              o.each([S("\x15`rvm"), S("1Q\\YXWY\\J"), S("$WCVZLY")], function (t) {
                o.each(i[t], function (e) {
                  this[t][e] = r(this, t, e)
                }, this)
              }, this)
            }
          });
          var i = {
            vent: ["on", S("+CKH"), S("\x0fdc{tspd"), S("A--' "), S("\r}{\x7fa^zgasyqw}"), S("$IOT\\LD\x7fC"), S('E*.;=/%\x18"\x01!34')],
            commands: [S("E#?-*??)"), S(":HYIv^.%.&6"), S(",^K[xP\\WXPDD"), S("\x12aqxya}Q{uxq{m"), S("\x0e}u|}eqTz{Pxt\x7fpxll")],
            reqres: [S('B1!43";='), S("\x19i~hU\x7fqDMGQ"), S("4FSCpXT_PXLL"), S("\v~hc`ftZrzqzrj"), S("D7#*'?/\n !\x06.>5>6&&")]
          }, r = function (n, i, r) {
            return function (e) {
              var t = n._getChannel(e)[i];
              return t[r].apply(t, o.rest(arguments))
            }
          };
          return new e
        }(C, o), r.Wreqr;
        var b = e.Marionette, _ = e.Mn, x = s.Marionette = {};
        x.VERSION = S("\x10#<':\""), x.noConflict = function () {
          return e.Marionette = b, e.Mn = _, this
        }, (s.Marionette = x).Deferred = s.$.Deferred, x.extend = s.Model.extend, x.isNodeAttached = function (e) {
          return s.$.contains(document.documentElement, e)
        }, x.mergeOptions = function (e, t) {
          e && f.extend(this, f.pick(e, t))
        }, x.getOption = function (e, t) {
          if (e && t) return e.options && void 0 !== e.options[t] ? e.options[t] : e[t]
        }, x.proxyGetOption = function (e) {
          return x.getOption(this, e)
        }, x._getValue = function (e, t, n) {
          return f.isFunction(e) && (e = n ? e.apply(t, n) : e.call(t)), e
        }, x.normalizeMethods = function (e) {
          return f.reduce(e, function (e, t, n) {
            return f.isFunction(t) || (t = this[t]), t && (e[n] = t), e
          }, {}, this)
        }, x.normalizeUIString = function (e, t) {
          return e.replace(/@ui\.[a-zA-Z-_$0-9]*/g, function (e) {
            return t[e.slice(4)]
          })
        }, x.normalizeUIKeys = function (e, i) {
          return f.reduce(e, function (e, t, n) {
            return e[x.normalizeUIString(n, i)] = t, e
          }, {})
        }, x.normalizeUIValues = function (t, i, r) {
          return f.each(t, function (n, e) {
            f.isString(n) ? t[e] = x.normalizeUIString(n, i) : f.isObject(n) && f.isArray(r) && (f.extend(n, x.normalizeUIValues(f.pick(n, r), i)), f.each(r, function (e) {
              var t = n[e];
              f.isString(t) && (n[e] = x.normalizeUIString(t, i))
            }))
          }), t
        }, x.actAsCollection = function (e, n) {
          var t = [S("\x10w}aQtu\x7f"), S("4PWTP"), S("\f`o\x7f"), S("2U][R"), S("?$$6&'1"), S("8_SWHXL"), S('"PAICD\\'), S(":IYW[\\4"), S("?%7'1="), S("\x1e~LM"), S("@2-.!"), S("\x19{ue"), S("5_Y[UO_Y"), S(" BMMPDOI["), S("\x1fIOTLO@"), S("#PJgUZHS"), S("3R\\DDL"), S("\x18ptrht\x7fs"), S(",_K\\D"), S("\x0ecqbf"), S("\v{dzg\x7fdf"), S("*B_hC_DH"), S("2CX@U\\")];
          f.each(t, function (t) {
            e[t] = function () {
              var e = [f.values(f.result(this, n))].concat(f.toArray(arguments));
              return f[t].apply(f, e)
            }
          })
        };
        var E = x.deprecate = function (e, t) {
          f.isObject(e) && (e = e.prev + S("Ef.;i-$%#)o$>r11u$256,>8}71@\x15\n\x06D\x03\x13\x13\x1d\x1b\x0fEL") + S("*{@HO\\U\x11G@Q\x15") + e.next + S("0\x11[]GASV\\\x17") + (e.url ? S("?`\x12'&~e") + e.url : "")), void 0 !== t && t || E._cache[e] || (E._warn(S("\x14Qsgj|yzhtqq\0VCQJLH@\x12\t") + e), E._cache[e] = !0)
        };
        E._console = "undefined" != typeof console ? console : {}, E._warn = function () {
          return (E._console.warn || E._console.log || function () {
          }).apply(E._console, arguments)
        }, E._cache = {}, x._triggerMethod = function () {
          var s = /(^|:)(\w)/gi;

          function a(e, t, n) {
            return n.toUpperCase()
          }

          return function (e, t, n) {
            var i = arguments.length < 3;
            i && (t = (n = t)[0]);
            var r, o = e["on" + t.replace(s, a)];
            return f.isFunction(o) && (r = o.apply(e, i ? f.rest(n) : n)), f.isFunction(e.trigger) && (1 < i + n.length ? e.trigger.apply(e, i ? n : [t].concat(f.drop(n, 0))) : e.trigger(t)), r
          }
        }(), x.triggerMethod = function (e) {
          return x._triggerMethod(this, arguments)
        }, x.triggerMethodOn = function (e) {
          return (f.isFunction(e.triggerMethod) ? e.triggerMethod : x.triggerMethod).apply(e, f.rest(arguments))
        }, x.MonitorDOMRefresh = function (e) {
          function t() {
            e._isShown && e._isRendered && x.isNodeAttached(e.el) && x.triggerMethodOn(e, S("\x13pz{-j||iynv"), e)
          }

          e._isDomRefreshMonitored || (e._isDomRefreshMonitored = !0, e.on({
            show: function () {
              e._isShown = !0, t()
            }, render: function () {
              e._isRendered = !0, t()
            }
          }))
        }, function (s) {
          function i(n, i, r, e) {
            var t = e.split(/\s+/);
            f.each(t, function (e) {
              var t = n[e];
              if (!t) throw new s.Error(S("\rCjdy}w47") + e + S("0\x13\x12DUF\x16TWW\\R[HLZ$a#0d$(g-?/%8m&.>5>6&yv5--z?38-\x7f\x0e\x0e\x16C\x01\x1d\x0f\x14\x1cG"));
              n.listenTo(i, r, t)
            })
          }

          function r(e, t, n, i) {
            e.listenTo(t, n, i)
          }

          function o(n, i, r, e) {
            var t = e.split(/\s+/);
            f.each(t, function (e) {
              var t = n[e];
              n.stopListening(i, r, t)
            })
          }

          function a(e, t, n, i) {
            e.stopListening(t, n, i)
          }

          function l(n, i, e, r, o) {
            if (i && e) {
              if (!f.isObject(e)) throw new s.Error({
                message: S("!`JJAOIOZ\nFY^Z\x0fRT\x12RZ\x15YUR\\YO\x1cRL\x1f&4, 0,))f"),
                url: S("\x11\x7frf|yy}mn~2{kqCUKLJV\bO\\DF\bAL\\F__WG@PT^V]_UHTJF%7'-06")
              });
              e = s._getValue(e, n), f.each(e, function (e, t) {
                f.isFunction(e) ? r(n, i, t, e) : o(n, i, t, e)
              })
            }
          }

          s.bindEntityEvents = function (e, t, n) {
            l(e, t, n, r, i)
          }, s.unbindEntityEvents = function (e, t, n) {
            l(e, t, n, a, o)
          }, s.proxyBindEntityEvents = function (e, t) {
            return s.bindEntityEvents(this, e, t)
          }, s.proxyUnbindEntityEvents = function (e, t) {
            return s.unbindEntityEvents(this, e, t)
          }
        }(x);
        var M = [S('"GAVEUAY^BCC'), S("6QQU_u]P["), S("+@D@J~D_QQG"), S("\x0eaq|w"), S("<P[L3 %&"), "number"];
        return x.Error = x.extend.call(Error, {
          urlRoot: S("'@]^[\x16\x02\x01BQC[\\ZPBC]SI\x15_RS\x10$.!0k3") + x.VERSION + "/",
          constructor: function (e, t) {
            f.isObject(e) ? e = (t = e).message : t || (t = {});
            var n = Error.call(this, e);
            f.extend(this, f.pick(n, M), f.pick(t, M)), this.captureStackTrace(), t.url && (this.url = this.urlRoot + t.url)
          },
          captureStackTrace: function () {
            Error.captureStackTrace && Error.captureStackTrace(this, x.Error)
          },
          toString: function () {
            return this.name + S("<\x07\x1e") + this.message + (this.url ? S("\x1c=MzE\x1b\x02") + this.url : "")
          }
        }), x.Error.extend = x.extend, x.Callbacks = function () {
          this._deferred = x.Deferred(), this._callbacks = []
        }, f.extend(x.Callbacks.prototype, {
          add: function (t, n) {
            var e = f.result(this._deferred, S("+\\_ABYBW"));
            this._callbacks.push({cb: t, ctx: n}), e.then(function (e) {
              n && (e.context = n), t.call(e.context, e.options)
            })
          }, run: function (e, t) {
            this._deferred.resolve({options: e, context: t})
          }, reset: function () {
            var e = this._callbacks;
            this._deferred = x.Deferred(), this._callbacks = [], f.each(e, function (e) {
              this.add(e.cb, e.ctx)
            }, this)
          }
        }), x.Controller = function (e) {
          this.options = e || {}, f.isFunction(this.initialize) && this.initialize(this.options)
        }, x.Controller.extend = x.extend, f.extend(x.Controller.prototype, s.Events, {
          destroy: function () {
            return x._triggerMethod(this, S("-LJV^@V\x0eQSDLKUB"), arguments), x._triggerMethod(this, S("\x1a\x7fynjmOX"), arguments), this.stopListening(), this.off(), this
          }, triggerMethod: x.triggerMethod, mergeOptions: x.mergeOptions, getOption: x.proxyGetOption
        }), x.Object = function (e) {
          this.options = f.extend({}, f.result(this, S("1]C@\\YYK")), e), this.initialize.apply(this, arguments)
        }, x.Object.extend = x.extend, f.extend(x.Object.prototype, s.Events, {
          initialize: function () {
          },
          destroy: function (e) {
            return e = e || {}, this.triggerMethod(S("B!!#)5-s..?9< )"), e), this.triggerMethod(S("&CMZ^YCT"), e), this.stopListening(), this
          },
          triggerMethod: x.triggerMethod,
          mergeOptions: x.mergeOptions,
          getOption: x.proxyGetOption,
          bindEntityEvents: x.proxyBindEntityEvents,
          unbindEntityEvents: x.proxyUnbindEntityEvents
        }), x.Region = x.Object.extend({
          constructor: function (e) {
            if (this.options = e || {}, this.el = this.getOption(S("#AI")), this.el = this.el instanceof s.$ ? this.el[0] : this.el, !this.el) throw new x.Error({
              name: S("'fFoGi_\\@B"),
              message: S("\nJb-,j|32~afb7z|:hlx}vFHGG\x04CIU\bH\nYIJG@^\x1f")
            });
            this.$el = this.getEl(this.el), x.Object.call(this, e)
          }, show: function (e, t) {
            if (this._ensureElement()) {
              this._ensureViewIsIntact(e), x.MonitorDOMRefresh(e);
              var n = t || {}, i = e !== this.currentView, r = !!n.preventDestroy, o = !!n.forceShow,
                s = !!this.currentView, a = i && !r, l = i || o;
              if (s && this.triggerMethod(S("5TR^VH^\x06NI^0\x0e77"), this.currentView, this, t), this.currentView && i && delete this.currentView._parent, a ? this.empty() : s && l && this.currentView.off(S("\x10uw``gyn"), this.empty, this), l) {
                e.once(S("\rjjce`|m"), this.empty, this), (e._parent = this)._renderView(e), s && this.triggerMethod(S("*IIKA]U\vADUE"), e, this, t), this.triggerMethod(S("6U]_UIY\x07MW/6"), e, this, t), x.triggerMethodOn(e, S('A &"*4"r:"$;'), e, this, t), s && this.triggerMethod(S("\nx{l~@ee"), this.currentView, this, t);
                var u = x.isNodeAttached(this.el), c = [],
                  d = f.extend({triggerBeforeAttach: this.triggerBeforeAttach, triggerAttach: this.triggerAttach}, n);
                return u && d.triggerBeforeAttach && (c = this._displayedViews(e), this._triggerAttach(c, S("0SWU[GS\r"))), this.attachHtml(e), this.currentView = e, u && d.triggerAttach && (c = this._displayedViews(e), this._triggerAttach(c)), s && this.triggerMethod(S("\x11adue"), e, this, t), this.triggerMethod(S("D6.(?"), e, this, t), x.triggerMethodOn(e, S("?3)-4"), e, this, t), this
              }
              return this
            }
          }, triggerBeforeAttach: !0, triggerAttach: !0, _triggerAttach: function (e, t) {
            var n = (t || "") + S('D$23)*"');
            f.each(e, function (e) {
              x.triggerMethodOn(e, n, e, this)
            }, this)
          }, _displayedViews: function (e) {
            return f.union([e], f.result(e, S("9e\\YIpZ35''\x12,#0;")) || [])
          }, _renderView: function (e) {
            e.supportsRenderLifecycle || x.triggerMethodOn(e, S("\x14wsqwk\x7f!nxp{ES"), e), e.render(), e.supportsRenderLifecycle || x.triggerMethodOn(e, S("D7#),,8"), e)
          }, _ensureElement: function () {
            if (f.isObject(this.el) || (this.$el = this.getEl(this.el), this.el = this.$el[0]), this.$el && 0 !== this.$el.length) return !0;
            if (this.getOption(S("E'+$&=\x06%>=&>6\x17?"))) return !1;
            throw new x.Error(S("\x1d_q\0\x03GO\x06\x05") + this.$el.selector + S("#\x04HST\\\tOSE^Z\x0fY_\x12w{x"))
          }, _ensureViewIsIntact: function (e) {
            if (!e) throw new x.Error({
              name: S("C\x12,#0\x06&>\x1d-!'+"),
              message: S("\x1cIvz\0WKFS\x05VF[ZOO\fD]\x0fE_VVR\\XR\\\x19[UX\x1dJW%3'%+7#g!'<* $*ap\b=&t8#$,y*:/.~>@\x17\v\x06\x13E\x0f\t\x1b\x1d\v\x05\x0f\bN\x1b\x1fQ\x01\x1b\x1b\x02X")
            });
            if (e.isDestroyed) throw new x.Error({
              name: S("-xFUFvVGADXA\\^~NOQM"),
              message: S("&qAL]\v\x04NGK\n\x11\x10") + e.cid + S("\v.$.gqb2rxgsv|`:yyxp?DDQWVJ_BL\tKEH\rMN^_]G\x14WS\x17MJ__\x12")
            })
          }, getEl: function (e) {
            return s.$(e, x._getValue(this.options.parentEl, this))
          }, attachHtml: function (e) {
            this.$el.contents().detach(), this.el.appendChild(e.el)
          }, empty: function (e) {
            var t = this.currentView, n = !!(e || {}).preventDestroy;
            return t && (t.off(S(":_YNJM/8"), this.empty, this), this.triggerMethod(S('"AACIUM\x13OF\\YW'), t), n || this._destroyView(), this.triggerMethod(S("\x19\x7fvlig"), t), delete this.currentView, n && this.$el.contents().detach()), this
          }, _destroyView: function () {
            var e = this.currentView;
            e.isDestroyed || (e.supportsDestroyLifecycle || x.triggerMethodOn(e, S("\x1c\x7f{yOSG\x19@@USZFS"), e), e.destroy ? e.destroy() : (e.remove(), e.isDestroyed = !0), e.supportsDestroyLifecycle || x.triggerMethodOn(e, S("0UW@@GYN"), e))
          }, attachView: function (e) {
            return this.currentView && delete this.currentView._parent, (e._parent = this).currentView = e, this
          }, hasView: function () {
            return !!this.currentView
          }, reset: function () {
            return this.empty(), this.$el && (this.el = this.$el.selector), delete this.$el, this
          }
        }, {
          buildRegion: function (e, t) {
            if (f.isString(e)) return this._buildRegionFromSelector(e, t);
            if (e.selector || e.el || e.regionClass) return this._buildRegionFromObject(e, t);
            if (f.isFunction(e)) return this._buildRegionFromRegionClass(e);
            throw new x.Error({
              message: S("\x15_zhkukyo>mEFKLJ\x05EHFOCLY_O[Y^\\\x13@LFR\x16"),
              url: S(";Q\\LV//'70 h5-.#$\"c&;==q!12?86t942;78\x15\x13\x03\x17\r\n\bJ\x1c\x10\x1a\x0e\x1f")
            })
          }, _buildRegionFromSelector: function (e, t) {
            return new t({el: e})
          }, _buildRegionFromObject: function (e, t) {
            var n = e.regionClass || t, i = f.omit(e, S("\x0e|u}wp`zd"), S("3FPQ^WWyW]NM"));
            return e.selector && !i.el && (i.el = e.selector), new n(i)
          }, _buildRegionFromRegionClass: function (e) {
            return new e
          }
        }), x.RegionManager = x.Controller.extend({
          constructor: function (e) {
            this._regions = {}, this.length = 0, x.Controller.call(this, e), this.addRegions(this.getOption(S("D7# !&$8")))
          }, addRegions: function (e, i) {
            return e = x._getValue(e, this, arguments), f.reduce(e, function (e, t, n) {
              return f.isString(t) && (t = {selector: t}), t.selector && (t = f.defaults({}, t, i)), e[n] = this.addRegion(n, t), e
            }, {}, this)
          }, addRegion: function (e, t) {
            var n;
            return n = t instanceof x.Region ? t : x.Region.buildRegion(t, x.Region), this.triggerMethod(S("D'#!';/q-)*u\"45:;;"), e, n), (n._parent = this)._store(e, n), this.triggerMethod(S("!CG@\x1fTBO@EE"), e, n), n
          }, get: function (e) {
            return this._regions[e]
          }, getRegions: function () {
            return f.clone(this._regions)
          }, removeRegion: function (e) {
            var t = this._regions[e];
            return this._remove(e, t), t
          }, removeRegions: function () {
            var e = this.getRegions();
            return f.each(this._regions, function (e, t) {
              this._remove(t, e)
            }, this), e
          }, emptyRegions: function () {
            var e = this.getRegions();
            return f.invoke(e, S("4P[GL@")), e
          }, destroy: function () {
            return this.removeRegions(), x.Controller.prototype.destroy.apply(this, arguments)
          }, _store: function (e, t) {
            this._regions[e] || this.length++, this._regions[e] = t
          }, _remove: function (e, t) {
            this.triggerMethod(S("\x18{\x7f}so{%RDOLR@\x1cUMNCDB"), e, t), t.empty(), t.stopListening(), delete t._parent, delete this._regions[e], this.length--, this.triggerMethod(S('E4"%&<.v?+(9><'), e, t)
          }
        }), x.actAsCollection(x.RegionManager.prototype, S("\vS\x7fkhy~|`")), x.TemplateCache = function (e) {
          this.templateId = e
        }, f.extend(x.TemplateCache, {
          templateCaches: {}, get: function (e, t) {
            var n = this.templateCaches[e];
            return n || (n = new x.TemplateCache(e), this.templateCaches[e] = n), n.load(t)
          }, clear: function () {
            var e, t = f.toArray(arguments), n = t.length;
            if (0 < n) for (e = 0; e < n; e++) delete this.templateCaches[t[e]]; else this.templateCaches = {}
          }
        }), f.extend(x.TemplateCache.prototype, {
          load: function (e) {
            if (this.compiledTemplate) return this.compiledTemplate;
            var t = this.loadTemplate(this.templateId, e);
            return this.compiledTemplate = this.compileTemplate(t, e), this.compiledTemplate
          }, loadTemplate: function (e, t) {
            var n = s.$(e);
            if (!n.length) throw new x.Error({
              name: S("\x0f^~Fvyezvl|_inrl"),
              message: S("6tWLV_\x1cSQK`'+- e2\"%9&*8(tor") + e + '"'
            });
            return n.html()
          }, compileTemplate: function (e, t) {
            return f.template(e, t)
          }
        }), x.Renderer = {
          render: function (e, t) {
            if (!e) throw new x.Error({
              name: S('9n^QMR^4$\f,0\x03)2&-\x0f9>"<'),
              message: S("1qRZ[YC\x18K_UXXL\x1f4)'c0 +7$(>.l>'!34r: &v195)>p}0*\f\rB\f\x16E\x13\t\f\f\f\x02\x02\b\nA")
            });
            return (f.isFunction(e) ? e : x.TemplateCache.get(e))(t)
          }
        }, x.View = s.View.extend({
          isDestroyed: !1,
          supportsRenderLifecycle: !0,
          supportsDestroyLifecycle: !0,
          constructor: function (e) {
            this.render = f.bind(this.render, this), e = x._getValue(e, this), this.options = f.extend({}, f.result(this, S("A-30,));")), e), this._behaviors = x.Behaviors(this), s.View.call(this, this.options), x.MonitorDOMRefresh(this)
          },
          getTemplate: function () {
            return this.getOption(S("%RBEYFJXH"))
          },
          serializeModel: function (e) {
            return e.toJSON.apply(e, f.rest(arguments))
          },
          mixinTemplateHelpers: function (e) {
            e = e || {};
            var t = this.getOption(S("&SMDZGMYKgU]BVFF"));
            return t = x._getValue(t, this), f.extend(e, t)
          },
          normalizeUIKeys: function (e) {
            var t = f.result(this, S("$zSNj@DOECI\\"));
            return x.normalizeUIKeys(e, t || f.result(this, S("\x17mp")))
          },
          normalizeUIValues: function (e, t) {
            var n = f.result(this, S(")_B")), i = f.result(this, S("$zSNj@DOECI\\"));
            return x.normalizeUIValues(e, i || n, t)
          },
          configureTriggers: function () {
            if (this.triggers) {
              var e = this.normalizeUIKeys(f.result(this, S("*_^DIHUCA")));
              return f.reduce(e, function (e, t, n) {
                return e[n] = this._buildViewTrigger(t), e
              }, {}, this)
            }
          },
          delegateEvents: function (e) {
            return this._delegateDOMEvents(e), this.bindEntityEvents(this.model, this.getOption(S(".B_UW_qCSYLJ"))), this.bindEntityEvents(this.collection, this.getOption(S("\rm`|}wp`|yy]o\x7fuhn"))), f.each(this._behaviors, function (e) {
              e.bindEntityEvents(this.model, e.getOption(S("5[X\\\\V~JXPK3"))), e.bindEntityEvents(this.collection, e.getOption(S("\x1b\x7frrsEBVJKKcQMG^X")))
            }, this), this
          },
          _delegateDOMEvents: function (e) {
            var t = x._getValue(e || this.events, this);
            t = this.normalizeUIKeys(t), f.isUndefined(e) && (this.events = t);
            var n = {}, i = f.result(this, S(".MUYSE]ZDrN\\TOO")) || {}, r = this.configureTriggers(),
              o = f.result(this, S("\x19x~t|hvOSvQMBABZZ")) || {};
            f.extend(n, i, t, r, o), s.View.prototype.delegateEvents.call(this, n)
          },
          undelegateEvents: function () {
            return s.View.prototype.undelegateEvents.apply(this, arguments), this.unbindEntityEvents(this.model, this.getOption(S(")GDHHBjFT\\GG"))), this.unbindEntityEvents(this.collection, this.getOption(S("\x11q|xystlpuuYk{qTR"))), f.each(this._behaviors, function (e) {
              e.unbindEntityEvents(this.model, e.getOption(S("!OL@@Jb^LD__"))), e.unbindEntityEvents(this.collection, e.getOption(S("\nhcabjse{|zP`rvmi")))
            }, this), this
          },
          _ensureViewIsIntact: function () {
            if (this.isDestroyed) throw new x.Error({
              name: S("\x16Aq|m_ynjmOXGGaWTHZ"),
              message: S("\x10G{vc5>tq} ;>") + this.cid + S('\x1f\x02\b\x02KEV\x06FD[OJHT\x0eMUT\\\x13PPECJVC^X\x1d_Q$a!"*+)3h+/k9>++~')
            })
          },
          destroy: function () {
            if (this.isDestroyed) return this;
            var e = f.toArray(arguments);
            return this.triggerMethod.apply(this, [S("<_[Y/3'y  53:&3")].concat(e)), this.isDestroyed = !0, this.triggerMethod.apply(this, [S('"GAVRUGP')].concat(e)), this.unbindUIElements(), this.isRendered = !1, this.remove(), f.invoke(this._behaviors, S("\x0ekubfa{l"), e), this
          },
          bindUIElements: function () {
            this._bindUIElements(), f.invoke(this._behaviors, this._bindUIElements)
          },
          _bindUIElements: function () {
            if (this.ui) {
              this._uiBindings || (this._uiBindings = this.ui);
              var e = f.result(this, S("4jC^zPT_USYL"));
              this.ui = {}, f.each(e, function (e, t) {
                this.ui[t] = this.$(e)
              }, this)
            }
          },
          unbindUIElements: function () {
            this._unbindUIElements(), f.invoke(this._behaviors, this._unbindUIElements)
          },
          _unbindUIElements: function () {
            this.ui && this._uiBindings && (f.each(this.ui, function (e, t) {
              delete this.ui[t]
            }, this), this.ui = this._uiBindings, delete this._uiBindings)
          },
          _buildViewTrigger: function (e) {
            var n = f.defaults({}, e, {preventDefault: !0, stopPropagation: !0}), i = f.isObject(e) ? n.event : e;
            return function (e) {
              e && (e.preventDefault && n.preventDefault && e.preventDefault(), e.stopPropagation && n.stopPropagation && e.stopPropagation());
              var t = {view: this, model: this.model, collection: this.collection};
              this.triggerMethod(i, t)
            }
          },
          setElement: function () {
            var e = s.View.prototype.setElement.apply(this, arguments);
            return f.invoke(this._behaviors, S("\r~}\x7fikE}paGjvj~niwzS"), this), e
          },
          triggerMethod: function () {
            var e = x._triggerMethod(this, arguments);
            return this._triggerEventOnBehaviors(arguments), this._triggerEventOnParentLayout(arguments[0], f.rest(arguments)), e
          },
          _triggerEventOnBehaviors: function (e) {
            for (var t = x._triggerMethod, n = this._behaviors, i = 0, r = n && n.length; i < r; i++) t(n[i], e)
          },
          _triggerEventOnParentLayout: function (e, t) {
            var n = this._parentLayoutView();
            if (n) {
              var i = x.getOption(n, S(";_UWS$\x17+&3\x000\"&=\x1a9)+'7")) + ":" + e, r = [this].concat(t);
              x._triggerMethod(n, i, r);
              var o = x.getOption(n, S("\x1b\x7fuwsDdTFJQU"));
              o = x._getValue(o, n);
              var s = n.normalizeMethods(o);
              s && f.isFunction(s[e]) && s[e].apply(n, r)
            }
          },
          _getImmediateChildren: function () {
            return []
          },
          _getNestedViews: function () {
            var e = this._getImmediateChildren();
            return e.length ? f.reduce(e, function (e, t) {
              return t._getNestedViews ? e.concat(t._getNestedViews()) : e
            }, e) : e
          },
          _parentLayoutView: function () {
            for (var e = this._parent; e;) {
              if (e instanceof x.LayoutView) return e;
              e = e._parent
            }
          },
          normalizeMethods: x.normalizeMethods,
          mergeOptions: x.mergeOptions,
          getOption: x.proxyGetOption,
          bindEntityEvents: x.proxyBindEntityEvents,
          unbindEntityEvents: x.proxyUnbindEntityEvents
        }), x.ItemView = x.View.extend({
          constructor: function () {
            x.View.apply(this, arguments)
          }, serializeData: function () {
            if (!this.model && !this.collection) return {};
            var e = [this.model || this.collection];
            return arguments.length && e.push.apply(e, arguments), this.model ? this.serializeModel.apply(this, e) : {items: this.serializeCollection.apply(this, e)}
          }, serializeCollection: function (e) {
            return e.toJSON.apply(e, f.rest(arguments))
          }, render: function () {
            return this._ensureViewIsIntact(), this.triggerMethod(S("\x0emuw}aq/drv}\x7fi"), this), this._renderTemplate(), this.isRendered = !0, this.bindUIElements(), this.triggerMethod(S("\r|j~uwa"), this), this
          }, _renderTemplate: function () {
            var e = this.getTemplate();
            if (!1 !== e) {
              if (!e) throw new x.Error({
                name: S("\x1aNry{yIOGGp@KWDH^Ni_\\@B"),
                message: S("*hMC@@D\x11@VZQSE\x18MR^\x1cI[R0-#7!e5.&*/k%9n&#q<&89v8*y/58886\x0e\x04\x06M")
              });
              var t = this.mixinTemplateHelpers(this.serializeData()), n = x.Renderer.render(e, t, this);
              return this.attachElContent(n), this
            }
          }, attachElContent: function (e) {
            return this.$el.html(e), this
          }
        }), x.CollectionView = x.View.extend({
          childViewEventPrefix: S("8ZRRPYHV%6"), sort: !0, constructor: function (e) {
            this.once(S("D7#),,8"), this._initialEvents), this._initChildViewStorage(), x.View.apply(this, arguments), this.on({
              "before:show": this._onBeforeShowCalled,
              show: this._onShowCalled,
              "before:attach": this._onBeforeAttachCalled,
              attach: this._onAttachCalled
            }), this.initRenderBuffer()
          }, initRenderBuffer: function () {
            this._bufferedChildren = []
          }, startBuffering: function () {
            this.initRenderBuffer(), this.isBuffering = !0
          }, endBuffering: function () {
            var e, t = this._isShown && x.isNodeAttached(this.el);
            this.isBuffering = !1, this._isShown && this._triggerMethodMany(this._bufferedChildren, this, S("\rljv~`v.f~xo")), t && this._triggerBeforeAttach && (e = this._getNestedViews(), this._triggerMethodMany(e, this, S("\x10swu{gs-ymnz\x7fu"))), this.attachBuffer(this, this._createBuffer()), t && this._triggerAttach && (e = this._getNestedViews(), this._triggerMethodMany(e, this, S(".NDESP\\"))), this._isShown && this._triggerMethodMany(this._bufferedChildren, this, S(")YCCZ")), this.initRenderBuffer()
          }, _triggerMethodMany: function (e, t, n) {
            var i = f.drop(arguments, 3);
            f.each(e, function (e) {
              x.triggerMethodOn.apply(e, [e, n, e, t].concat(i))
            })
          }, _initialEvents: function () {
            this.collection && (this.listenTo(this.collection, S("(HNO"), this._onCollectionAdd), this.listenTo(this.collection, S("6E]TUMY"), this._onCollectionRemove), this.listenTo(this.collection, S("-\\JCTF"), this.render), this.getOption(S("\x11a|fa")) && this.listenTo(this.collection, S("3GZDC"), this._sortViews))
          }, _onCollectionAdd: function (e, t, n) {
            var i = void 0 !== n.at && (n.index || t.indexOf(e));
            if ((this.getOption(S("\x1c{wsTDP")) || !1 === i) && (i = f.indexOf(this._filteredSortedModels(i), e)), this._shouldAddChild(e, i)) {
              this.destroyEmptyView();
              var r = this.getChildView(e);
              this.addChild(e, r, i)
            }
          }, _onCollectionRemove: function (e) {
            var t = this.children.findByModel(e);
            this.removeChildView(t), this.checkEmpty()
          }, _onBeforeShowCalled: function () {
            this._triggerBeforeAttach = this._triggerAttach = !1, this.children.each(function (e) {
              x.triggerMethodOn(e, S("\vnhh`bt(`|za"), e)
            })
          }, _onShowCalled: function () {
            this.children.each(function (e) {
              x.triggerMethodOn(e, S(">L(.5"), e)
            })
          }, _onBeforeAttachCalled: function () {
            this._triggerBeforeAttach = !0
          }, _onAttachCalled: function () {
            this._triggerAttach = !0
          }, render: function () {
            return this._ensureViewIsIntact(), this.triggerMethod(S("(KOMC_K\x15BT\\WQG"), this), this._renderChildren(), this.isRendered = !0, this.triggerMethod(S("%TBFMOY"), this), this
          }, reorder: function () {
            var i = this.children, e = this._filteredSortedModels();
            if (!e.length && this._showingEmptyView) return this;
            if (f.some(e, function (e) {
              return !i.findByModel(e)
            })) this.render(); else {
              var t = f.map(e, function (e, t) {
                var n = i.findByModel(e);
                return n._index = t, n.el
              }), n = i.filter(function (e) {
                return !f.contains(t, e.el)
              });
              this.triggerMethod(S("\x1ayy{qmE\x1bPFKWBBZ")), this._appendReorderedChildren(t), f.each(n, this.removeChildView, this), this.checkEmpty(), this.triggerMethod(S("\x15drwk~~n"))
            }
          }, resortView: function () {
            x.getOption(this, S("4GSXJ]_IsSmP25")) ? this.reorder() : this.render()
          }, _sortViews: function () {
            var e = this._filteredSortedModels();
            f.find(e, function (e, t) {
              var n = this.children.findByModel(e);
              return !n || n._index !== t
            }, this) && this.resortView()
          }, _emptyViewIndex: -1, _appendReorderedChildren: function (e) {
            this.$el.append(e)
          }, _renderChildren: function () {
            this.destroyEmptyView(), this.destroyChildren({checkEmpty: !1}), this.isEmpty(this.collection) ? this.showEmptyView() : (this.triggerMethod(S("\x1c\x7f{yOSG\x19V@HCM[\x10HCABJSE[\\Z"), this), this.startBuffering(), this.showCollection(), this.endBuffering(), this.triggerMethod(S(")XNBIK]\nR]_XPUCQVT"), this), this.children.isEmpty() && this.getOption(S("\x1bztrkES")) && this.showEmptyView())
          }, showCollection: function () {
            var n, e = this._filteredSortedModels();
            f.each(e, function (e, t) {
              n = this.getChildView(e), this.addChild(e, n, t)
            }, this)
          }, _filteredSortedModels: function (e) {
            var t, n = this.getViewComparator(), i = this.collection.models;
            (e = Math.min(Math.max(e, 0), i.length - 1), n) && (e && (t = i[e], i = i.slice(0, e).concat(i.slice(e + 1))), i = this._sortModelsBy(i, n), t && i.splice(e, 0, t));
            return this.getOption(S("-HF\\EWA")) && (i = f.filter(i, function (e, t) {
              return this._shouldAddChild(e, t)
            }, this)), i
          }, _sortModelsBy: function (e, t) {
            return "string" == typeof t ? f.sortBy(e, function (e) {
              return e.get(t)
            }, this) : 1 === t.length ? f.sortBy(e, t, this) : e.sort(f.bind(t, this))
          }, showEmptyView: function () {
            var e = this.getEmptyView();
            if (e && !this._showingEmptyView) {
              this.triggerMethod(S("!@FBJTB\x12[OEHH\\\x15U\\BGM")), this._showingEmptyView = !0;
              var t = new s.Model;
              this.addEmptyView(t, e), this.triggerMethod(S("\r|j~uwa.p{gl`"))
            }
          }, destroyEmptyView: function () {
            this._showingEmptyView && (this.triggerMethod(S("\x18{\x7f}so{%RDOLR@\x1cBEY^R")), this.destroyChildren(), delete this._showingEmptyView, this.triggerMethod(S("\x10cw~{cs-}tjoe")))
          }, getEmptyView: function () {
            return this.getOption(S("\x1cxsoTXtJAR"))
          }, addEmptyView: function (e, t) {
            var n, i = this._isShown && !this.isBuffering && x.isNodeAttached(this.el),
              r = this.getOption(S("/U\\BGMc_ROvJOURPL")) || this.getOption(S("6TPPV_jT[H\x0f16*++5"));
            f.isFunction(r) && (r = r.call(this, e, this._emptyViewIndex));
            var o = this.buildChildView(e, t, r);
            (o._parent = this).proxyChildEvents(o), o.once(S("\x11`vzqse"), function () {
              this._isShown && x.triggerMethodOn(o, S("9X^ZRLZz2*,3"), o), i && this._triggerBeforeAttach && (n = this._getViewAndNested(o), this._triggerMethodMany(n, this, S("\x13vppxj| zhi\x7f|H")))
            }, this), this.children.add(o), this.renderChildView(o, this._emptyViewIndex), i && this._triggerAttach && (n = this._getViewAndNested(o), this._triggerMethodMany(n, this, S("8XNO]^V"))), this._isShown && x.triggerMethodOn(o, S("5E_WN"), o)
          }, getChildView: function (e) {
            var t = this.getOption(S("%EOAEN}EHY"));
            if (!t) throw new x.Error({
              name: S("\x1cSq\\HHNGrLCPm[XD^"),
              message: S("\x1d_?\x02BJJHApNM^\b\vAX][\x10SW\x13GESTQ_S^X")
            });
            return t
          }, addChild: function (e, t, n) {
            var i = this.getOption(S("*HDDBKfXWD{EB^WWI"));
            i = x._getValue(i, this, [e, n]);
            var r = this.buildChildView(e, t, i);
            return this._updateIndices(r, !0, n), this.triggerMethod(S("#F@@HZL\x10JHI\x14LXX^W"), r), this._addChildView(r, n), this.triggerMethod(S("5WS\\\x03YSUQZ"), r), r._parent = this, r
          }, _updateIndices: function (t, n, e) {
            this.getOption(S(":HSOJ")) && (n && (t._index = e), this.children.each(function (e) {
              e._index >= t._index && (e._index += n ? 1 : -1)
            }))
          }, _addChildView: function (e, t) {
            var n, i = this._isShown && !this.isBuffering && x.isNodeAttached(this.el);
            this.proxyChildEvents(e), e.once(S("&UMGNN^"), function () {
              this._isShown && !this.isBuffering && x.triggerMethodOn(e, S("%DBNFXN\x16^F@G"), e), i && this._triggerBeforeAttach && (n = this._getViewAndNested(e), this._triggerMethodMany(n, this, S("\x13vppxj| zhi\x7f|H")))
            }, this), this.children.add(e), this.renderChildView(e, t), i && this._triggerAttach && (n = this._getViewAndNested(e), this._triggerMethodMany(n, this, S("\x12r`awtp"))), this._isShown && !this.isBuffering && x.triggerMethodOn(e, S("\x1elHNU"), e)
          }, renderChildView: function (e, t) {
            return e.supportsRenderLifecycle || x.triggerMethodOn(e, S(")HNJB\\J\nCW]PPD"), e), e.render(), e.supportsRenderLifecycle || x.triggerMethodOn(e, S("1@VZQSE"), e), this.attachHtml(this, e, t), e
          }, buildChildView: function (e, t, n) {
            var i = new t(f.extend({model: e}, n));
            return x.MonitorDOMRefresh(i), i
          }, removeChildView: function (e) {
            return e && (this.triggerMethod(S("6U]_UIY\x07LZ-.4&~&..$-"), e), e.supportsDestroyLifecycle || x.triggerMethodOn(e, S(":YY[QM%{&&714(1"), e), e.destroy ? e.destroy() : e.remove(), e.supportsDestroyLifecycle || x.triggerMethodOn(e, S("D!#4<;%2"), e), delete e._parent, this.stopListening(e), this.children.remove(e), this.triggerMethod(S("B1!()1-s)#%!*"), e), this._updateIndices(e, !1)), e
          }, isEmpty: function () {
            return !this.collection || 0 === this.collection.length
          }, checkEmpty: function () {
            this.isEmpty(this.collection) && this.showEmptyView()
          }, attachBuffer: function (e, t) {
            e.$el.append(t)
          }, _createBuffer: function () {
            var t = document.createDocumentFragment();
            return f.each(this._bufferedChildren, function (e) {
              t.appendChild(e.el)
            }), t
          }, attachHtml: function (e, t, n) {
            e.isBuffering ? e._bufferedChildren.splice(n, 0, t) : e._insertBefore(t, n) || e._insertAfter(t)
          }, _insertBefore: function (e, t) {
            var n;
            return this.getOption(S("\nxc\x7fz")) && t < this.children.length - 1 && (n = this.children.find(function (e) {
              return e._index === t + 1
            })), !!n && (n.$el.before(e.el), !0)
          }, _insertAfter: function (e) {
            this.$el.append(e.el)
          }, _initChildViewStorage: function () {
            this.children = new s.ChildViewContainer
          }, destroy: function () {
            return this.isDestroyed ? this : (this.triggerMethod(S("\x1b~xxpRD\x18GAVRUGP\x10HCABJSE[\\Z")), this.destroyChildren({checkEmpty: !1}), this.triggerMethod(S("&CMZ^YCT\x14L_]^VWA_XV")), x.View.prototype.destroy.apply(this, arguments))
          }, destroyChildren: function (e) {
            var t = e || {}, n = !0, i = this.children.map(f.identity);
            return f.isUndefined(t.checkEmpty) || (n = t.checkEmpty), this.children.each(this.removeChildView, this), n && this.checkEmpty(), i
          }, _shouldAddChild: function (e, t) {
            var n = this.getOption(S("#BLJSM["));
            return !f.isFunction(n) || n.call(this, e, t, this.collection)
          }, proxyChildEvents: function (i) {
            var r = this.getOption(S("0RZZXQ`^]N\x7fMYSJo2$$*<"));
            this.listenTo(i, S(":ZPQ"), function () {
              var e = f.toArray(arguments), t = e[0],
                n = this.normalizeMethods(f.result(this, S("\x15u\x7fqu~^jxpkS")));
              e[0] = r + ":" + t, e.splice(1, 0, i), void 0 !== n && f.isFunction(n[t]) && n[t].apply(this, e.slice(1)), this.triggerMethod.apply(this, e)
            })
          }, _getImmediateChildren: function () {
            return f.values(this.children._views)
          }, _getViewAndNested: function (e) {
            return [e].concat(f.result(e, S("7g^_OrXMK%%\x14*!25")) || [])
          }, getViewComparator: function () {
            return this.getOption(S("?6('4\x07*+7);+?#?"))
          }
        }), x.CompositeView = x.CollectionView.extend({
          constructor: function () {
            x.CollectionView.apply(this, arguments)
          }, _initialEvents: function () {
            this.collection && (this.listenTo(this.collection, S(")KOH"), this._onCollectionAdd), this.listenTo(this.collection, S("\x11`vyz`r"), this._onCollectionRemove), this.listenTo(this.collection, S("\x12aqfsc"), this._renderChildren), this.getOption(S("6DWKN")) && this.listenTo(this.collection, S("2@[GB"), this._sortViews))
          }, getChildView: function (e) {
            return this.getOption(S("\x1b\x7fuwsDwKFS")) || this.constructor
          }, serializeData: function () {
            var e = {};
            return this.model && (e = f.partial(this.serializeModel, this.model).apply(this, arguments)), e
          }, render: function () {
            return this._ensureViewIsIntact(), this._isRendering = !0, this.resetChildViewContainer(), this.triggerMethod(S("\x10swu{gs-j|t\x7fyo"), this), this._renderTemplate(), this._renderChildren(), this._isRendering = !1, this.isRendered = !0, this.triggerMethod(S(">M%/&&6"), this), this
          }, _renderChildren: function () {
            (this.isRendered || this._isRendering) && x.CollectionView.prototype._renderChildren.call(this)
          }, _renderTemplate: function () {
            var e = {};
            e = this.serializeData(), e = this.mixinTemplateHelpers(e), this.triggerMethod(S("\x1fBDDLV@\x1cUMGNN^\x17ZJ]A^R@P"));
            var t = this.getTemplate(), n = x.Renderer.render(t, e, this);
            this.attachElContent(n), this.bindUIElements(), this.triggerMethod(S("\r|j~uwa.aszhu{oy"))
          }, attachElContent: function (e) {
            return this.$el.html(e), this
          }, attachBuffer: function (e, t) {
            this.getChildViewContainer(e).append(t)
          }, _insertAfter: function (e) {
            this.getChildViewContainer(this, e).append(e.el)
          }, _appendReorderedChildren: function (e) {
            this.getChildViewContainer(this).append(e)
          }, getChildViewContainer: function (e, t) {
            if (e.$childViewContainer) return e.$childViewContainer;
            var n, i = x.getOption(e, S("\x16tppv\x7fJt{hcNLWELHBZ"));
            if (i) {
              var r = x._getValue(i, e);
              if ((n = "@" === r.charAt(0) && e.ui ? e.ui[r.substr(4)] : e.$(r)).length <= 0) throw new x.Error({
                name: S("7{QSWXkWZ7\x02--0$/)-;\x07\"?>'!7\x14 !;'"),
                message: S("\fYfj0bbvw|p~}}:9\x7fuwsDwKFSfII\\HCEI_\f\x0fGPA\x13ZZB\x17^VOUX\x07\x1e") + e.childViewContainer
              })
            } else n = e.$el;
            return e.$childViewContainer = n
          }, resetChildViewContainer: function () {
            this.$childViewContainer && (this.$childViewContainer = void 0)
          }
        }), x.LayoutView = x.ItemView.extend({
          regionClass: x.Region,
          options: {destroyImmediate: !1},
          childViewEventPrefix: S("&D@@FOZDKX"),
          constructor: function (e) {
            e = e || {}, this._firstRender = !0, this._initializeRegions(e), x.ItemView.call(this, e)
          },
          render: function () {
            return this._ensureViewIsIntact(), this._firstRender ? this._firstRender = !1 : this._reInitializeRegions(), x.ItemView.prototype.render.apply(this, arguments)
          },
          destroy: function () {
            return this.isDestroyed ? this : (!0 === this.getOption(S(")NN_Y\\@Ix_^QQ_VL\\")) && this.$el.remove(), this.regionManager.destroy(), x.ItemView.prototype.destroy.apply(this, arguments))
          },
          showChildView: function (e, t, n) {
            var i = this.getRegion(e);
            return i.show.apply(i, f.rest(arguments))
          },
          getChildView: function (e) {
            return this.getRegion(e).currentView
          },
          addRegion: function (e, t) {
            var n = {};
            return n[e] = t, this._buildRegions(n)[e]
          },
          addRegions: function (e) {
            return this.regions = f.extend({}, this.regions, e), this._buildRegions(e)
          },
          removeRegion: function (e) {
            return delete this.regions[e], this.regionManager.removeRegion(e)
          },
          getRegion: function (e) {
            return this.regionManager.get(e)
          },
          getRegions: function () {
            return this.regionManager.getRegions()
          },
          _buildRegions: function (e) {
            var t = {regionClass: this.getOption(S("5DR_PUU\x7fQ_L3")), parentEl: f.partial(f.result, this, S("D *"))};
            return this.regionManager.addRegions(e, t)
          },
          _initializeRegions: function (e) {
            var t;
            this._initRegionManager(), t = x._getValue(this.regions, this, [e]) || {};
            var n = this.getOption.call(e, S("\x1fRDEJKKU"));
            n = x._getValue(n, this, [e]), f.extend(t, n), t = this.normalizeUIValues(t, [S("-]J\\TQG[G"), S('"FH')]), this.addRegions(t)
          },
          _reInitializeRegions: function () {
            this.regionManager.invoke(S("\x1emERGW"))
          },
          getRegionManager: function () {
            return new x.RegionManager
          },
          _initRegionManager: function () {
            this.regionManager = this.getRegionManager(), (this.regionManager._parent = this).listenTo(this.regionManager, S("@#'%+7#})-.q>()&??"), function (e) {
              this.triggerMethod(S("+NHH@BT\bRPQ\fE]^STR"), e)
            }), this.listenTo(this.regionManager, S("5WS\\\x03H^[TQQ"), function (e, t) {
              this[e] = t, this.triggerMethod(S("=_[${0&#,))"), e, t)
            }), this.listenTo(this.regionManager, S("\x1c\x7f{yOSG\x19V@KH^L\x10YIJG@^"), function (e) {
              this.triggerMethod(S("@#'%+7#}:,'$:(t=56;<:"), e)
            }), this.listenTo(this.regionManager, S("<O[R/7'y6 !.''"), function (e, t) {
              delete this[e], this.triggerMethod(S(".]U\\]EQ\x0fDR_PUU"), e, t)
            })
          },
          _getImmediateChildren: function () {
            return f.chain(this.regionManager.getRegions()).pluck(S("\x16tmkh~riHvEV")).compact().value()
          }
        }), x.Behavior = x.Object.extend({
          constructor: function (e, t) {
            this.view = t, this.defaults = f.result(this, S("+HHHNE]F@")) || {}, this.options = f.extend({}, this.defaults, e), this.ui = f.extend({}, f.result(t, S(">J)")), f.result(this, S("\x1ejI"))), x.Object.apply(this, arguments)
          }, $: function () {
            return this.view.$.apply(this.view, arguments)
          }, destroy: function () {
            return this.stopListening(), this
          }, proxyViewProperties: function (e) {
            this.$el = e.$el, this.el = e.el
          }
        }), x.Behaviors = function (i, u) {
          var c = /^(\S+)\s*(.*)$/;

          function o(e, t) {
            return u.isObject(e.behaviors) ? (t = o.parseBehaviors(e, t || u.result(e, S("$GCOI_CD^^"))), o.wrap(e, t, u.keys(r)), t) : {}
          }

          var r = {
            behaviorTriggers: function (e, t) {
              return new n(this, t).buildBehaviorTriggers()
            }, behaviorEvents: function (e, t) {
              var n = {};
              return u.each(t, function (o, s) {
                var a = {}, e = u.clone(u.result(o, S("E#1-'>8"))) || {};
                e = i.normalizeUIKeys(e, d(o));
                var l = 0;
                u.each(e, function (e, t) {
                  var n = t.match(c), i = n[1] + "." + [this.cid, s, l++, " "].join("") + n[2],
                    r = u.isFunction(e) ? e : o[e];
                  r && (a[i] = u.bind(r, o))
                }, this), n = u.extend(n, a)
              }, this), n
            }
          };

          function n(e, t) {
            this._view = e, this._behaviors = t, this._triggers = {}
          }

          function d(e) {
            return e._uiBindings || e.ui
          }

          return u.extend(o, {
            behaviorsLookup: function () {
              throw new i.Error({
                message: S("\fTaz0|g``5rr~pt~<jvzRD\x02ZKPT\x07JLBJZDA]C\x11SAQ\x15ECWK__\x12"),
                url: S("\rcnbx}}qabr6{\x7fs}kwpRR\fKPHJ\x04JLBJZDA]C]]\\_@F")
              })
            }, getBehaviorClass: function (e, t) {
              return e.behaviorClass ? e.behaviorClass : i._getValue(o.behaviorsLookup, this, [e, t])[t]
            }, parseBehaviors: function (r, e) {
              return u.chain(e).map(function (e, t) {
                var n = new (o.getBehaviorClass(e, t))(e, r), i = o.parseBehaviors(r, u.result(n, S("\x0frtzrb|yek")));
                return [n].concat(i)
              }).flatten().value()
            }, wrap: function (t, n, e) {
              u.each(e, function (e) {
                t[e] = u.partial(r[e], t[e], n)
              })
            }
          }), u.extend(n.prototype, {
            buildBehaviorTriggers: function () {
              return u.each(this._behaviors, this._buildTriggerHandlersForBehavior, this), this._triggers
            }, _buildTriggerHandlersForBehavior: function (e, t) {
              var n = u.clone(u.result(e, S("!VQMBABZZ"))) || {};
              n = i.normalizeUIKeys(n, d(e)), u.each(n, u.bind(this._setHandlerForBehavior, this, e, t))
            }, _setHandlerForBehavior: function (e, t, n, i) {
              var r = i.replace(/^\S+/, function (e) {
                return e + "." + S("2QQ]WAQVHONTYX%31") + t
              });
              this._triggers[r] = this._view._buildViewTrigger(n)
            }
          }), o
        }(x, f), x.AppRouter = s.Router.extend({
          constructor: function (e) {
            this.options = e || {}, s.Router.apply(this, arguments);
            var t = this.getOption(S("<\\NO\x12.77!6")), n = this._getController();
            this.processAppRoutes(n, t), this.on(S("2A[@BR"), this._processOnRoute, this)
          },
          appRoute: function (e, t) {
            var n = this._getController();
            this._addAppRoute(n, e, t)
          },
          _processOnRoute: function (e, t) {
            if (f.isFunction(this.onRoute)) {
              var n = f.invert(this.getOption(S("(HZ[~B[[UB")))[e];
              this.onRoute(e, n, t)
            }
          },
          processAppRoutes: function (t, n) {
            if (n) {
              var e = f.keys(n).reverse();
              f.each(e, function (e) {
                this._addAppRoute(t, e, n[e])
              }, this)
            }
          },
          _getController: function () {
            return this.getOption(S("1Q\\ZADXTU_I"))
          },
          _addAppRoute: function (e, t, n) {
            var i = e[n];
            if (!i) throw new x.Error(S("\x1bQxjwOE\x02\x01") + n + S("\x1d<?W@Q\x03JJR\x07NF_EH\rAA\x10EZV\x14VYYLKUWPXL"));
            this.route(t, n, f.bind(i, e))
          },
          mergeOptions: x.mergeOptions,
          getOption: x.proxyGetOption,
          triggerMethod: x.triggerMethod,
          bindEntityEvents: x.proxyBindEntityEvents,
          unbindEntityEvents: x.proxyUnbindEntityEvents
        }), x.Application = x.Object.extend({
          constructor: function (e) {
            this._initializeRegions(e), this._initCallbacks = new x.Callbacks, this.submodules = {}, f.extend(this, e), this._initChannel(), x.Object.apply(this, arguments)
          }, execute: function () {
            this.commands.execute.apply(this.commands, arguments)
          }, request: function () {
            return this.reqres.request.apply(this.reqres, arguments)
          }, addInitializer: function (e) {
            this._initCallbacks.add(e)
          }, start: function (e) {
            this.triggerMethod(S("D'#!';/q?9/=$"), e), this._initCallbacks.run(e, this), this.triggerMethod(S("+_YO]D"), e)
          }, addRegions: function (e) {
            return this._regionManager.addRegions(e)
          }, emptyRegions: function () {
            return this._regionManager.emptyRegions()
          }, removeRegion: function (e) {
            return this._regionManager.removeRegion(e)
          }, getRegion: function (e) {
            return this._regionManager.get(e)
          }, getRegions: function () {
            return this._regionManager.getRegions()
          }, module: function (e, t) {
            var n = x.Module.getClass(t), i = f.toArray(arguments);
            return i.unshift(this), n.create.apply(n, i)
          }, getRegionManager: function () {
            return new x.RegionManager
          }, _initializeRegions: function (e) {
            var t = f.isFunction(this.regions) ? this.regions(e) : this.regions || {};
            this._initRegionManager();
            var n = x.getOption(e, S("\x13fpq~wwi"));
            return f.isFunction(n) && (n = n.call(this, e)), f.extend(t, n), this.addRegions(t), this
          }, _initRegionManager: function () {
            this._regionManager = this.getRegionManager(), (this._regionManager._parent = this).listenTo(this._regionManager, S('=\\Z&.0&~$"#r;/,%" '), function () {
              x._triggerMethod(this, S("(KOMC_K\x15QUV\tFPQ^WW"), arguments)
            }), this.listenTo(this._regionManager, S("\x1b}yz%RDEJKK"), function (e, t) {
              this[e] = t, x._triggerMethod(this, S("=_[${0&#,))"), arguments)
            }), this.listenTo(this._regionManager, S("9X^ZRLZz3'.+3#}:,-\"##"), function () {
              x._triggerMethod(this, S('E$".&8.v?+"?\'7i&01>77'), arguments)
            }), this.listenTo(this._regionManager, S("\x17j|wtjx$mEFKLJ"), function (e) {
              delete this[e], x._triggerMethod(this, S("\x1bnxspVD\x18QABOHF"), arguments)
            })
          }, _initChannel: function () {
            this.channelName = f.result(this, S('A!+%+("$\x07+&)')) || S("\x14rzxzxv"), this.channel = f.result(this, S(">\\( ,-!)")) || s.Wreqr.radio.channel(this.channelName), this.vent = f.result(this, S("\x13bpxc")) || this.channel.vent, this.commands = f.result(this, S(")IDA@OATB")) || this.channel.commands, this.reqres = f.result(this, S("+^H_]UB")) || this.channel.reqres
          }
        }), x.Module = function (e, t, n) {
          this.moduleName = e, this.options = f.extend({}, this.options, n), this.initialize = n.initialize || this.initialize, this.submodules = {}, this._setupInitializersAndFinalizers(), this.app = t, f.isFunction(this.initialize) && this.initialize(e, t, this.options)
        }, x.Module.extend = x.extend, f.extend(x.Module.prototype, s.Events, {
          startWithParent: !0, initialize: function () {
          }, addInitializer: function (e) {
            this._initializerCallbacks.add(e)
          }, addFinalizer: function (e) {
            this._finalizerCallbacks.add(e)
          }, start: function (t) {
            this._isInitialized || (f.each(this.submodules, function (e) {
              e.startWithParent && e.start(t)
            }), this.triggerMethod(S("#F@@HZL\x10XXL\\["), t), this._initializerCallbacks.run(t, this), this._isInitialized = !0, this.triggerMethod(S(">L4 07"), t))
          }, stop: function () {
            this._isInitialized && (this._isInitialized = !1, this.triggerMethod(S(",OKI_CW\tGAYG")), f.invoke(this.submodules, S("(Z^D\\")), this._finalizerCallbacks.run(void 0, this), this._initializerCallbacks.reset(), this._finalizerCallbacks.reset(), this.triggerMethod(S("4FBXH")))
          }, addDefinition: function (e, t) {
            this._runModuleDefinition(e, t)
          }, _runModuleDefinition: function (e, t) {
            if (e) {
              var n = f.flatten([this, this.app, s, x, s.$, f, t]);
              e.apply(this, n)
            }
          }, _setupInitializersAndFinalizers: function () {
            this._initializerCallbacks = new x.Callbacks, this._finalizerCallbacks = new x.Callbacks
          }, triggerMethod: x.triggerMethod
        }), f.extend(x.Module, {
          create: function (i, e, r) {
            var o = i, s = f.drop(arguments, 3), t = (e = e.split(".")).length, a = [];
            return a[t - 1] = r, f.each(e, function (e, t) {
              var n = o;
              o = this._getModule(n, e, i, r), this._addModuleDefinition(n, o, a[t], s)
            }, this), o
          }, _getModule: function (e, t, n, i, r) {
            var o = f.extend({}, i), s = this.getClass(i), a = e[t];
            return a || (a = new s(t, n, o), e[t] = a, e.submodules[t] = a), a
          }, getClass: function (e) {
            var t = x.Module;
            return e ? e.prototype instanceof t ? e : e.moduleClass || t : t
          }, _addModuleDefinition: function (e, t, n, i) {
            var r = this._getDefine(n), o = this._getStartWithParent(n, t);
            r && t.addDefinition(r, i), this._addStartWithParent(e, t, o)
          }, _getStartWithParent: function (e, t) {
            var n;
            return f.isFunction(e) && e.prototype instanceof x.Module ? (n = t.constructor.prototype.startWithParent, !!f.isUndefined(n) || n) : !f.isObject(e) || (n = e.startWithParent, !!f.isUndefined(n) || n)
          }, _getDefine: function (e) {
            return !f.isFunction(e) || e.prototype instanceof x.Module ? f.isObject(e) ? e.define : null : e
          }, _addStartWithParent: function (e, t, n) {
            t.startWithParent = t.startWithParent && n, t.startWithParent && !t.startWithParentIsConfigured && (t.startWithParentIsConfigured = !0, e.addInitializer(function (e) {
              t.startWithParent && t.start(e)
            }))
          }
        }), x
      }), CKFinder.define(S("\x16TS_suxxl0vHGTW\ndF[L\x05hC@C@^"), [S("$PHCM[YHC_K"), S('A/"6,))-=>.')], function (n, i) {
        "use strict";
        return {
          proto: {
            getTemplate: function () {
              var e = i.getOption(this, S("+XHC_\\PFV")), t = i.getOption(this, S("4\\[GWKNH")), n = this.name;
              return this.finder.templateCache.has(n) ? this.finder.templateCache.get(n) : this.finder.templateCache.compile(n, e, t)
            }, mixinTemplateHelpers: function (e) {
              e = e || {};
              var t = this.getOption(S(" UGNTIGSMaOG\\H\\\\"));
              return t = i._getValue(t, this), n.extend(e, {lang: this.finder.lang, config: this.finder.config}, t)
            }
          }, util: {
            construct: function (e) {
              if (!this.name) {
                if (!e.name) throw S("\r`n}t2cugwz}m\x7fi<pklT\x01@F\x04VVBK@LBII");
                this.name = e.name
              }
              if (!this.finder) {
                if (!e.finder) throw S("\x1ffHLGAW\x06WI[KFIYK]\x10\\G@@\x15TR\x18JJ^_TXV%%b%+7f1!,=ql") + this.name;
                this.finder = e.finder
              }
              this.finder.fire(S("=HV%6x") + this.name, {view: this}, this.finder)
            }
          }
        }
      }), CKFinder.define(S("\x10RYU}{rrj6Lryjm0b@QF\vfIJXFYBXHxFUF"), [S("#QKBBZZID^H"), S("\x15{vjpuuyijz"), S("\vOFHf~uwa;C\x7froj5Y}n{0cNONKK")], function (i, e, t) {
        "use strict";
        var n = e.CompositeView;
        return n.extend(t.proto).extend({
          constructor: function (e) {
            t.util.construct.call(this, e), n.prototype.constructor.apply(this, Array.prototype.slice.call(arguments))
          }, buildChildView: function (e, t, n) {
            return new t(i.extend({model: e, finder: this.finder}, n))
          }, attachBuffer: function (e, t) {
            this.getChildViewContainer(e).append(t), this.triggerMethod(S("=_K4 !+\x060 !-;"))
          }
        })
      }), CKFinder.define(S("\fNEIy\x7fvvf:@~}ni4^|mz\x0fhVFIsOB_"), [S("\f`o}y~|v`as"), S("=}t\x06(,'!7i\x11!,=8c\x0f/<5~\x11<9899")], function (e, t) {
        "use strict";
        var n = e.ItemView;
        return n.extend(t.proto).extend({
          constructor: function (e) {
            t.util.construct.call(this, e), n.prototype.constructor.apply(this, Array.prototype.slice.call(arguments))
          }
        })
      }), CKFinder.define(S("\x13`pnc"), [S(";QRZJ,$")], function (e) {
        "use strict";
        var u, r, s, a, l,
          i = [S("\x1aVoess\x12\x0fznhmrsx"), S("\x14X\x7ftjvitzi0Gmmjwpu"), S("7uJBVP\x0f\x10g\r\r\n\x17\x10\x15hsfy")],
          n = /^\s*<\?xml(\s)+version=[\'\"](\d)*.(\d)*[\'\"](\s)*\?>/im, o = /<body[^>]*>\s*([\s\S]+)\s*<\/body>/im,
          c = "undefined" != typeof location && location.href,
          d = c && location.protocol && location.protocol.replace(/\:/, ""), f = c && location.hostname,
          h = c && (location.port || void 0), g = {}, p = e.config && e.config() || {};

        function v(e, t) {
          return void 0 === e || "" === e ? t : e
        }

        return u = {
          version: S("\x16%6)4**"), strip: function (e) {
            if (e) {
              var t = (e = e.replace(n, "")).match(o);
              t && (e = t[1])
            } else e = "";
            return e
          }, jsEscape: function (e) {
            return e.replace(/(['\\])/g, S("0m\x16\x02")).replace(/[\f]/g, S("?\x1c'")).replace(/[\b]/g, S("\x0eSr")).replace(/[\n]/g, S("$yH")).replace(/[\t]/g, S("A\x1e7")).replace(/[\r]/g, S("3hG")).replace(/[\u2028]/g, S("\x15Jb*)(#")).replace(/[\u2029]/g, S(",q[\x1d\0\x03\v"))
          }, createXhr: p.createXhr || function () {
            var e, t, n;
            if ("undefined" != typeof XMLHttpRequest) return new XMLHttpRequest;
            if ("undefined" != typeof ActiveXObject) for (t = 0; t < 3; t += 1) {
              n = i[t];
              try {
                e = new ActiveXObject(n)
              } catch (e) {
              }
              if (e) {
                i = [n];
                break
              }
            }
            return e
          }, parseName: function (e) {
            var t, n, i, r = !1, o = e.lastIndexOf("."),
              s = 0 === e.indexOf(S("\f#!")) || 0 === e.indexOf(S("\x17675"));
            return -1 !== o && (!s || 1 < o) ? (t = e.substring(0, o), n = e.substring(o + 1)) : t = e, -1 !== (o = (i = n || t).indexOf("!")) && (r = i.substring(o + 1) === S("'[]XB\\"), i = i.substring(0, o), n ? n = i : t = i), {
              moduleName: t,
              ext: n,
              strip: r
            }
          }, xdRegExp: /^((\w+)\:)?\/\/([^\/\\]+)/, useXhr: function (e, t, n, i) {
            var r, o, s, a = u.xdRegExp.exec(e);
            return !a || (r = a[2], s = (o = (o = a[3]).split(":"))[1], o = o[0], (!r || r === t) && (!o || o.toLowerCase() === n.toLowerCase()) && (!s && !o || function (e, t, n, i) {
              if (t === i) return !0;
              if (e === n) {
                if (e === S("\x0fxefc")) return v(t, S("#\x1c\x15")) === v(i, S("\x0e7 "));
                if (e === S("3\\ABGK")) return v(t, S(">\vtr")) === v(i, S("?tuq"))
              }
              return !1
            }(r, s, t, i)))
          }, finishLoad: function (e, t, n, i) {
            n = t ? u.strip(n) : n, p.isBuild && (g[e] = n), i(n)
          }, load: function (t, e, n, i) {
            if (i && i.isBuild && !i.inlineText) n(); else {
              p.isBuild = i && i.isBuild;
              var r = u.parseName(t), o = r.moduleName + (r.ext ? "." + r.ext : ""), s = e.toUrl(o),
                a = p.useXhr || u.useXhr;
              0 !== s.indexOf(S("2VYEBN\x02")) ? !c || a(s, d, f, h) ? u.get(s, function (e) {
                u.finishLoad(t, r.strip, e, n)
              }, function (e) {
                n.error && n.error(e)
              }) : e([o], function (e) {
                u.finishLoad(r.moduleName + "." + r.ext, r.strip, e, n)
              }, function (e) {
                n.error && n.error(e)
              }) : n()
            }
          }, write: function (e, t, n, i) {
            if (g.hasOwnProperty(t)) {
              var r = u.jsEscape(g[t]);
              n.asModule(e + "!" + t, S("\x1bxxxvND\nEQKESAFD\v\x04\x04\x0eT\x10CWGAGX\x17\x1f") + r + S("Ea|5`qA"))
            }
          }, writeFile: function (n, e, t, i, r) {
            var o = u.parseName(e), s = o.ext ? "." + o.ext : "", a = o.moduleName + s,
              l = t.toUrl(o.moduleName + s) + ".js";
            u.load(a, t, function (e) {
              var t = function (e) {
                return i(l, e)
              };
              t.asModule = function (e, t) {
                return i.asModule(e, l, t)
              }, u.write(n, a, t, r)
            }, r)
          }
        }, p.env === S("%HHLL") || !p.env && "undefined" != typeof process && process.versions && process.versions.node && !process.versions[S(",CAKU\x1cEVV^_C")] && !process.versions[S("8XNTQ\x10MW%-.")] ? (r = require.nodeRequire(S("\nm\x7f")), u.get = function (e, t, n) {
          try {
            var i = r.readFileSync(e, S("-[[V\t"));
            "\ufeff" === i[0] && (i = i.substring(1)), t(i)
          } catch (e) {
            n && n(e)
          }
        }) : p.env === S("2K\\G") || !p.env && u.createXhr() ? u.get = function (i, r, o, e) {
          var t, s = u.createXhr();
          if (s.open(S(".hue"), i, !0), e) for (t in e) e.hasOwnProperty(t) && s.setRequestHeader(t.toLowerCase(), e[t]);
          p.onXhr && p.onXhr(s, i), s.onreadystatechange = function (e) {
            var t, n;
            4 === s.readyState && (399 < (t = s.status || 0) && t < 600 ? ((n = new Error(i + S("6\x17pmnk\x1cNJ^441yd") + t)).xhr = s, o && o(n)) : r(s.responseText), p.onXhrComplete && p.onXhrComplete(s, i))
          }, s.send(null)
        } : p.env === S("\x1emHHLL") || !p.env && "undefined" != typeof Packages && "undefined" != typeof java ? u.get = function (e, t) {
          var n, i, r = S("/EET\x1e\f"), o = new java.io.File(e),
            s = java.lang.System.getProperty(S("2_][S\x19K\\JZN\\JP2")),
            a = new java.io.BufferedReader(new java.io.InputStreamReader(new java.io.FileInputStream(o), r)), l = "";
          try {
            for (n = new java.lang.StringBuffer, (i = a.readLine()) && i.length() && 65279 === i.charAt(0) && (i = i.substring(1)), null !== i && n.append(i); null !== (i = a.readLine());) n.append(s), n.append(i);
            l = String(n.toString())
          } finally {
            a.close()
          }
          t(l)
        } : (p.env === S("1JCWZXY]ZN") || !p.env && "undefined" != typeof Components && Components.classes && Components.interfaces) && (s = Components.classes, a = Components.interfaces, Components.utils[S("\x1arqmqmT")](S("5DRKVOI_X\x04\x10o&0&k()#=%/8c\v'#5\x04&:8&x=+4")), l = S("#dHI]AEFJ\x02B\\H\x1fF[]PZAD\x15K_\\UNJM9l)&=~w") in s, u.get = function (e, t) {
          var n, i, r, o = {};
          l && (e = e.replace(/\//g, "\\")), r = new FileUtils.File(e);
          try {
            (n = s[S("$eKHR@FGM\x03A]W\x1e\\V@BYES\x16\\RPX\x13V.177i625-('p}")].createInstance(a.nsIFileInputStream)).init(r, 1, 0, !1), (i = s[S("\x1a[qrdvLMC\rKWA\bAG^G\x03NAAFT@GQG\x1b^VIOO\x11NJM% /xu")].createInstance(a.nsIConverterInputStream)).init(n, S("\x14`bq5!"), n.available(), a.nsIConverterInputStream.DEFAULT_REPLACEMENT_CHARACTER), i.readString(n.available(), o), i.close(), n.close(), t(o.value)
          } catch (e) {
            throw new Error((r && r.path || "") + S("\x0e50") + e)
          }
        }), u
      }), CKFinder.define(S("\x14asol8YPZtp{ES\rwAHVKI]OX\x03nAADTJGyPXB\x17zUUHXFK\r$,6\r1#*f-%?"), [], function () {
        return S("\x10ji,4|b9|plrxxl?]\\YX\x1b\x1a[Z\" \x16J\fYOMY_VVL\b\x14\x1a\t\x1b\x1aXP\\ML}c7*i'2)h21tll';~8!\x127!?!=y'&)4s,\x14\0\x16\x06I\x01\x0f\x14\t\v\x06\x0e\bM\x15\x14O\f\x0f\b\x0fJV\x1e\fW\x13\x18\x13\x13^\x02}tk.fqh*ajee!vu00xf=xtxp6}si< #\"\0\x06NWV\x02\x06ZUEOMXVU\x10\x0fLOA]R^CCB\x05FA\x1dKVm(!,*h=<ui#?b$- >q/./.i*%{z 'b~~\t\x15L\n\x17$\x05\x13\x01\x1f\x0fK\x11\x10\x0f\x1d\x19\x10_\x17\x1d\x06\x17\x15\x14\x1c\x1eF^\t\f\ne#yx;x{'lh~j!nei=\x7fs~q(4lc$:rh3p~MD\x02^Y\x07\x06\\S\x16\nBX\x03BF^ZsG@G_UMM_H\x1c@CD;?b*0k*.&\"\v?8?'-%%7 to7#,+39));\"\x1d\x1a\x19^\x05\x11\x12\x15\x01\v\x1f\x1f\tC\0\x0e\x1d\x14\x0f\x0eIW\r\fE\x18\x0e\x0f\x0e\x14\x1c\ntd,ueisbut(pwssrkj-ni+\x1c\x1e\x11ba&<tj1L@@FH\x05[Z\" \x16\x04M\x13$TK\x0eON>")
      }), CKFinder.define(S("'kblBBIK]\x1f|]WAYSD\x17zUUHXFK\r$,6k\x13/\"?:e\b##:*(%\x1f6: \0>=."), [S("\x1dkqDDPPGJTB"), S(".EADWAM"), S("E\x05\f\x0e $/)?a\x1994% {\x177$=v\x1941-1,\t\x15\x075\r\0\x11"), S(" bieMKBBZ\x06|BIZ]\0rPAV\x1b|BRUoS^K"), S("9N^DI\x1f|\v\x07+-  4h\x1c,'; ,:*#~\x11<:!3/,\x14?5)r\x1d0\x0e\x15\x07\x1b\x10(\x03\t\x1d \x1e\x0e\x01C\n\0\x04"), S('7{r|RRY[Mo\x146*(j\r"1\n%/)')], function (u, c, e, i, r, d) {
        "use strict";
        return e.extend({
          name: S("\x10R}}`pncU|tn"),
          template: S(".\x13E]\f\x0f\x1b@Z\t"),
          childViewContainer: S("&RD"),
          emptyView: i.extend({name: S("\x13Wzxc}anVyskZMQVZ"), template: S("<\x01ZV6a!/%65zj*!-a +<#056vkjx<0,e")}),
          initialize: function (i) {
            var o = this, e = c(document), t = S(" LMVW@BH_G\nHCCZJHE_VZ@"), n = i.position, r = i.positionToEl;
            if (!n && r) {
              var s = r.get(0).getBoundingClientRect();
              n = {x: s.left + r.width() / 2, y: s.top + r.height() / 2}
            }

            function a(e) {
              var t = e.model.get(S(";]^JV//")), n = e.evt;
              u.isFunction(t) && (n.stopPropagation(), n.preventDefault(), t(i.forView)), setTimeout(function () {
                o.destroy()
              }, 10)
            }

            function l(e) {
              !o || o.$el.find(e.target).length || o.isDestroyed || o.destroy()
            }

            o.$el.attr(S("6SYM[\x16HU[R%"), o.finder.config.swatch), o.on(S(">[%261+<"), function () {
              e.off(t, l), o.$el.length && o.$el.remove()
            }), o.on(S("\x1co{qDDP"), function () {
              o.$el.find(S("%SK")).listview(), c(S("\x10?gz9eygmi7xssj~IOGQ")).remove(), o.$el.popup().popup(S("\x11}cq{")), o.$el.find(S("5\x18BQ\x14XOR\x07XV226")).focus(), n && n.x && n.y && o.$el.popup(S("D7#7':#?%\" "), function (e, t) {
                var n = e.x, i = e.y, r = t.height(), o = t.width();
                return {
                  x: parseInt(n + (window.innerWidth < n + o ? -1 : 1) * o / 2, 10),
                  y: parseInt(i + (window.innerHeight < i + r ? -1 : 1) * r / 2 + document.body.scrollTop, 10)
                }
              }(n, o.$el)), setTimeout(function () {
                e.one(t, l)
              }, 0)
            }), o.on(S("\x13w}\x7f{|os~k'wkELAOMFMBL"), function (e, t) {
              o.destroy(), a(t)
            }), o.on(S("\x1fCIKO@SOB_\x13C_I@EJIU]DZ"), function (e, t) {
              var n, i, r = t.evt;
              r.keyCode === d.up && (r.stopPropagation(), r.preventDefault(), (n = o.$el.find("a").not(S("%\bRA\x04Y_MYK\x02TXARVYSS")))[0 <= (i = u.indexOf(n, e.$el.find("a").get(0)) - 1) ? i : n.length - 1].focus()), r.keyCode === d.down && (r.stopPropagation(), r.preventDefault(), (n = o.$el.find("a").not(S("\x13:`\x7f:km{oy0zvS@@OAA")))[(i = u.indexOf(n, e.$el.find("a").get(0)) + 1) <= n.length - 1 ? i : 0].focus()), r.keyCode !== d.enter && r.keyCode !== d.space || (o.destroy(), e.model.get(S(">V3\0!7-3#")) && a(t)), r.keyCode === d.escape && (r.stopPropagation(), r.preventDefault(), o.destroy())
            })
          },
          getChildView: function (e) {
            var t = {
              contextmenu: function (e) {
                e.preventDefault(), e.stopPropagation()
              }
            };
            e.get(S("\x0ftxdzppd")) || (t[S("5U[QZQ\x1b]")] = function (e) {
              this.trigger(S("$LRBEJFBOFKK"), {evt: e, view: this, model: this.model})
            }, t[S("\x17s|c\x7fsjp?A")] = function (e) {
              this.trigger(S("?)5'./ ?#'>$"), {evt: e, view: this, model: this.model})
            });
            var n = {
              name: S("#gJHSMQ^fIC[fDT_"),
              finder: this.finder,
              template: r,
              events: t,
              tagName: S(")FB"),
              modelEvents: {"change:active": S("\x0e}u\x7fvvf")}
            };
            return e.get(S("2W]C_S]K")) && (n.attributes = {"data-role": S("\fag|d<vzb|rrj")}), i.extend(n)
          }
        })
      }), CKFinder.define(S("\x17[R\\rry{m\x0flMGQICT\x07jEEXHV[}T\\F\x1bvYYL\\BOqXPJ"), [S("B6*!#5;*%9)"), S("(KKHGOAAU"), S(",neiY_VVF\x1a{X\\LV^O\x12}P.5';0\b#)=f\x1c\"):=`\x13><'1-\"\x1a=7/\r58)")], function (e, l, u) {
        "use strict";

        function i(n) {
          var e = this, i = e.finder, t = new l.Collection, r = {groups: t, context: n.context};
          if (i.fire(S("6TWWN^DIsZ.4"), r, i) && i.fire(S('B ++2"0=\x07."8t') + n.name, r, i)) {
            t.forEach(function (e) {
              var t = new l.Collection;
              i.fire(S("6TWWN^DIsZ.4x") + n.name + ":" + e.get(S('C*$+"')), {
                items: t,
                context: n.context
              }, i), e.set(S("C-1#*;"), t)
            });
            var o = new l.Collection;
            t.forEach(function (e) {
              var t = e.get(S("2Z@P[D"));
              t.length && (o.length && o.add({divider: !0}), o.add(t.models))
            }), e.lastView && e.lastView.destroy();
            var s = !(!n.evt || !n.evt.clientX) && {x: n.evt.clientX, y: n.evt.clientY},
              a = n.positionToEl ? n.positionToEl : null;
            i.request(S("\x17~vyno'lzMDOAAW")), e.lastView = new u({
              finder: i,
              className: S("\x0el{w?p{{br`mw~rh"),
              collection: o,
              position: s,
              positionToEl: a,
              forView: n.view
            }), e.lastView.on(S(".KUBFA[L"), function () {
              i.request(S("!DLGPU\x1dZLY_C_K"))
            }), e.lastView.render()
          }
        }

        return function (e) {
          (this.finder = e).setHandler(S("\rm`~ewk`Xsym"), i, this);
          var t = this;

          function n() {
            t.lastView && t.lastView.destroy()
          }

          e.on(S("']@\x10I@X\\"), n), e.on(S('B6-\x7f4"; 0.'), n), e.on(S(':HTRLK#460~)/4<s-."(<.<'), function (e) {
            e.data.shortcuts.add({
              label: e.finder.lang.shortcuts.general.showContextMenu,
              shortcuts: S("\x1f[RJJBQ[\fSO\x1b\x1bQ")
            })
          }, null, null, 50)
        }
      }), CKFinder.define(S("-mdvX\\WQG\x19zW]_WO\x12xP,%'17\x06)+$,)?%\" "), [S("6UYZQYSS["), S("\x0eL[W{}ppd8Uv~~pn1YOMFFV")], function (e, t) {
        "use strict";
        return e.Collection.extend({
          model: t, initialize: function () {
            this.on(S("C'-')/,p%- +"), this.sort)
          }, comparator: function () {
            if ("undefined" != typeof Intl) {
              var n = new Intl.Collator(void 0, {numeric: !0});
              if (n.compare) return function (e, t) {
                return n.compare(e.get(S("%HFEL")), t.get(S("\x10\x7fs~q")))
              }
            }
            return function (e, t) {
              return e.get(S("\x19tzqx")).localeCompare(t.get(S("\x11|ryp")))
            }
          }()
        })
      }), CKFinder.define(S("\vOFHf~uwa;Xys}ui4Zrr{ES"), [S("!@BGNDHFL"), S("\x19YPZtp{ES\rnKACK[\x06lD@IK]Cr]_XPUCQVT")], function (e, o) {
        "use strict";
        return e.Model.extend({
          defaults: {
            name: "",
            hasChildren: !1,
            resourceType: "",
            isRoot: !1,
            parent: null,
            isPending: !1,
            "view:isFolder": !0
          }, initialize: function () {
            this.set(S("*EM@K"), this.get(S("*EM@K")).toString(), {silent: !0}), this.set(S("?#)+/ 7#)"), new o, {silent: !0});
            var e = this.get(S("\x1d}wIMFQAK"));
            e.on(S("\x12p|txp}"), r), e.on(S("\x1co{rOWG"), r), this.on(S("!AKEKAB\x12JBB@I\\J^"), function (e, t) {
              t && (t.on(S("\x11q{u{qr"), r), t.on(S("6E]TUMY"), r))
            });
            var t = this.get(S("\x1c|rsOVGGa]RBFZCDB^"));
            t && "string" == typeof t && this.set(S('"BHIIPMMoSXH@\\Y^\\@'), t.split(","), {silent: !0});
            var n = this.get(S("E'+$&=.(\b6;5?!:;;%"));
            n && "string" == typeof n && this.set(S("\nj`aaxuuWk`pxdqvth"), t.split(","), {silent: !0});
            var i = this;

            function r() {
              i.set(S("5^VKzRRPYLZ."), !!i.get(S("#GMOKL[OE")).length)
            }
          }, getPath: function (e) {
            var t, n;
            return n = (t = this.get(S("\x10asaq{b"))) ? t.getPath(e).toString() + this.get(S("9TZQX")) + "/" : "/", this.get(S("\x0efcC}|`")) && e && e.full && (n = this.get(S(">M%2-66&#\x1319/")) + ":" + n), n
          }, getHash: function () {
            return this.has(S("7PXIS")) ? this.get(S("%NF[A")) : this.get(S("\v|l|j~e")).getHash()
          }, getUrl: function () {
            if (this.has(S("\n~~a"))) return this.get(S("9OIP"));
            var e = this.get(S("$UGUMG^"));
            if (!e) return !1;
            var t = e.getUrl();
            return t && t + encodeURIComponent(this.get(S("\x19tzqx"))) + "/"
          }, isPath: function (e, t) {
            return e === this.getPath() && t === this.get(S("9H^ORKM#$\x16:4 "))
          }, getResourceType: function () {
            for (var e = this; !e.get(S("'AZxDCY"));) e = e.get(S("+\\L\\J^E"));
            return e
          }
        }, {
          invalidCharacters: S("\x1c\x17B?\x0f\x01\x18\x03\x0e\x05\x19\x07\n\t\x16\v\x12\rR"),
          isValidName: function (e) {
            return !/[\\\/:\*\?"<>\|]/.test(e)
          }
        })
      }), CKFinder.define(S(' UG[P\x04eln@DOI_\x01{U\\B_UASD\x17\x7fUWXXLLo\x07-/  4\t)$/\x0f%," 7\x057>$97#=w>4('), [], function () {
        return S('$\x19@HZD\nJOYG@^\f\x10\x10\x16\v<>\x04U[YYQ\x005IH98ee/3f-#* ")\x025"!230v*%SSR`40/\x15\x15B\r\x05\b\x03ZJ\x07\x0f\x1c*\x02\x02\v\x15\x03<\x12\x19\x10TW\x0e\x18\x16\x0e\x19@\\\x04{ "jp+`hdmoyBlcj0lo14awuqw~~d <.\x02\x01CQMD\vUMX_B^HJ\x12\x12E@FQ\x17\x16SQK\x07\x19]HJPb\x7fHJxj*&*,&uFqa)?#?m^i&w;5;(/`|:\x12\x13\r\x11I\b\x03\x14\x1b\b\r\x0eNSR@\0Ox')
      }), CKFinder.define(S(':xw{WQ$$0l\t*"2$,9d\n""+5#!|\x02<3 +v\x1c409;-.\0\x0f\x06 \f\x07\v\x07\x0e<\x02\t\x1a'), [S("D\x06\r\x01!'..>b\x18&5&!|\x164%2w\x10.>1\v7:\x17"), S("\x1c^UYIOFFV\nkHLLFX\x03kACTT@"), S('A6&<1g\x04\x03\x0f#%((<`\x044?#84"2+v\x1c409;-\x13N$\f\b\x01\x03\x15&\b\x07\x0e(\x04\x0f\x03\x1f\x16&\x16\x19\x05\x1a\x16\f\x1cT\x1f\x13\t')], function (e, t, n) {
        "use strict";
        return e.extend({
          name: S(":}SQZZ2\x0f#.!\x01/&$&-\x1d%(9"),
          template: n,
          ui: {error: S("\r jbc}a9xsdkx}~"), folderName: S(".F^AGGo[WZ]\x04\x18UYJxP,%'1\n$+\"j\x14")},
          events: {
            "input @ui.folderName": function () {
              var e = this.ui.folderName.val().toString().trim();
              t.isValidName(e) ? this.model.unset(S("+I_\\@B")) : this.model.set(S("5SEJVH"), this.finder.lang.errors.folderInvalidCharacters.replace(S("$^BN[HFGCZKKsYSAUVBRJJG"), t.invalidCharacters)), this.model.set(S(",KACTT@}UXS"), e)
            }, submit: function (e) {
              this.trigger(S("+_XLBYE\bU[G[")), e.preventDefault()
            }
          },
          modelEvents: {
            "change:error": function (e, t) {
              t ? (this.ui.error.show(), this.ui.error.html(t)) : this.ui.error.hide()
            }
          }
        })
      }), CKFinder.define(S("\x18ZQ]uszzR\x0eoL@PJB[\x06iYILZJv^^WQG\x19tJ\\[OY{QS$$0"), [S("0SSP_WYY]"), S("-mdvX\\WQG\x19zW]OWYN\x11y/-&&66i\x11!,=8c\v!#44 \x1d583\x131864;\v7:\x17")], function (s, a) {
        "use strict";

        function e(e) {
          var n = e.data.context.folder;
          e.finder.request(S("?,.#'!7|/!-/")), e.data.response.error || (n.set(S("-FNCrZZXQDRV"), !0), e.finder.once(S(':XSPS^.%x""1#5r\x0e/?\n""+5#!'), function e(t) {
            t.data.context.parent.cid === n.cid && (t.data.response.error || n.trigger(S("\x1ejI\x1bG[TDHC")), t.finder.removeListener(S(';_RSR!/&y%#2":s\r.8\v!#44  '), e))
          }), e.finder.request(S(">\\/,/\"*!|4-'."), {
            name: S(",jK[v^^WQGE"),
            folder: n,
            context: {parent: n}
          }, null, null, 30))
        }

        return function (o) {
          o.setHandler(S(':]SQZZ2{!1!$2"'), function (e) {
            var t = e.parent, n = e.newFolderName;
            if (n) o.request(S("\rb`quwa.f~xo"), {text: o.lang.common.pleaseWait}), o.request(S("4VYZUXT_\x06N[Q$"), {
              name: S('"`V@GSMoEGHH\\'),
              type: S("\x1blrmk"),
              folder: t,
              params: {newFolderName: n},
              context: {folder: t}
            }); else {
              var i = new s.Model({dialogMessage: o.lang.folders.newNameLabel, folderName: e.newFolderName, error: !1}),
                r = o.request(S("(MCJ@BI"), {
                  view: new a({finder: o, model: i}),
                  name: S('"`V@GSMoEGHH\\'),
                  title: o.lang.common.newNameDialogTitle,
                  context: {parent: t}
                });
              i.on(S("\rmgq\x7fuv.pdewk"), function (e, t) {
                t ? r.disableButton(S("(FA")) : r.enableButton(S("%IL"))
              })
            }
          }), o.on(S("'L@KGCJ\x14lBTSGQsY[\\\\H\x01SV"), function (e) {
            var t = e.data.view.model;
            if (!t.get(S("*N^_A]"))) {
              var n = t.get(S("*MCAJJB\x7fS^Q"));
              e.finder.request(S("\x18}szpry%DDQWVJ_")), o.request(S("5PXT]_I\x06^LZ!5'"), {
                parent: e.data.context.parent,
                newFolderName: n
              })
            }
          }), o.on(S("=]P.5';0\b#)=s,$ )+=j46: "), function (e) {
            var t = e.finder, n = e.data.context.folder;
            e.data.items.add({
              name: S('"`V@GSMoEGHH\\'),
              label: t.lang.folders.newSubfolder,
              isActive: n.get(S(",LMC")).folderCreate,
              icon: S('7[R\\\x16ZRR[%3o" !'),
              action: function () {
                t.request(S("A$,(!#5r*8.-9+"), {parent: n})
              }
            })
          }), o.on(S("3@ZY[ZXH\x01NXMZ4{\x0f\"-+|!'%..>"), function (e) {
            var t = e.data.folder;
            t.get(S("A# (")).folderCreate && e.data.toolbar.push({
              type: S("!@VPQII"),
              name: S("\x18Zh~}i{YOMFFV"),
              priority: 70,
              icon: S("\x19ypz0xpLEGQ\tDBC"),
              label: e.finder.lang.folders.newSubfolder,
              action: function () {
                o.request(S("+JBBKUC\bPFPWC]"), {parent: t})
              }
            })
          }), o.on(S('3WZ[ZYW^\x01][JZ2{\x011!$2"\x0e&&/)?'), e)
        }
      }), CKFinder.define(S("D1#?<h\t\0\n$ +5#}\x0718&;9-?(s\x19;3\x05\x15\x07%\r\t\x03H,\f\x06\x0e\x18\b(\x06\x1c\x147\x01\x06\x1a\x04Y\x1c\x16\x0e"), [], function () {
        return S("0JI\f\x14\\B\x19UJ]\x1bA@\x02O~:9~d,2i%:-k10r` o)(k(+]d,6eV&%!@\b\x16M\x01\x17\x14\b\x1a\x1aJQ\t\x1f\x1c\0\x02Q\x0f\x0eH\x19\x1fI\x03\x02G[\x19\x0f\f\x10r!\x7f~8*jn6rquqp\x043?d~-\x1e")
      }), CKFinder.define(S('4v}qQW^^N\x12sP$4.&7j\x02"$,>.\n$"*\x7f\x157?1!3\x1115?'), [S("A7-  44+&8."), S("C&$%,*&$."), S("@5';0d\x05\f\x0e $/)?a\x1b5<\"?5!3$w\x1d?79);\x19\t\r\x07L \0\n\x02\x1c\f,\x02\0\b+\x1d\x02\x1e\0]\x10\x1a\x02"), S("\vOFHf~uwa;@b~t6Q~e^q{E")], function (o, s, a, r) {
        "use strict";
        var l = 302;

        function t(e) {
          var t, n = this.finder, i = e.files;
          i[0].get(S("6QWU^^N")).get(S("5WTT")).fileDelete ? (t = 1 < i.length ? n.lang.files.deleteConfirmation.replace(S("5MTWLTOA"), i.length) : n.lang.files.fileDeleteConfirmation.replace(S("\x1bgs\x7frE\\"), function () {
            return n.util.escapeHtml(i[0].get(S("\x1au}p{")))
          }), n.request(S("/TXS_[R\fTWW\\RNP"), {
            name: S("\fIkcuewU}ysTww|rnp"),
            msg: t,
            context: {files: i}
          })) : n.request(S("B'-$*(/s#%*\""), {msg: n.lang.errors.deleteFilePermissions})
        }

        function n(e) {
          e.finder.request(S(" GMO@@T\x1dOL^jOYGYU")).get(S("$DEK")).fileDelete && e.data.toolbar.push({
            type: S("+NXZ[__"),
            name: S(";xXRZ4$\x04*( 5"),
            priority: 10,
            icon: S("1QXR\x18P^T\\\x17_YQ[K%"),
            label: e.finder.lang.common.delete,
            action: function () {
              e.finder.request(S("\x1c{wsER\x18GAICSM"), {files: e.finder.request(S("1TZXPE\r_\\NhYQ[\\4$&")).toArray()})
            }
          })
        }

        function i(e) {
          var t = this.finder, n = t.request(S(";ZTRZ3{%&0\x16#+-*>.(")), i = 1 < n.length;
          e.data.items.add({
            name: S("6s]U_OY{WS%2"),
            label: t.lang.common.delete,
            isActive: e.data.context.file.get(S(")LD@IK]")).get(S("8XYW")).fileDelete,
            icon: S(":XW[\x13Y)-'n  *\"<,"),
            action: function () {
              t.request(S(":]UQ[Lz%'/!1#"), {files: i ? n.toArray() : [e.data.context.file]})
            }
          })
        }

        function u(e) {
          var t = e.data.context.files, n = [], i = e.finder;
          t instanceof s.Collection && (t = t.toArray()), o.forEach(t, function (e) {
            var t = e.get(S(" GMO@@T"));
            n.push({name: e.get(S(">Q!,'")), type: t.get(S("\x16e}junn~{KYQG")), folder: t.getPath()})
          });
          var r = i.request(S("4SY[\\\\H\x01[XJ~#5+5!"));
          i.request(S("\ngcljjb+a{{b"), {text: i.lang.common.pleaseWait}), i.request(S("#GJKJIGN\x11_H@K"), {
            name: S('=zZ,$6&\x02,*";'),
            type: S(";LRMK"),
            post: {files: n},
            sendPostAsJson: !0,
            folder: r,
            context: {files: t}
          })
        }

        function c(e) {
          var t = e.data.response;
          e.finder.request(S("3XZWS]K\0SUY[")), t.error || (o.forEach(e.data.context.files, function (e) {
            e.get(S("+JBBKUC")).get(S(":XTTR[2$,")).remove(e)
          }), e.finder.fire(S("1TZXPE\r\\\\V^HXZ"), {files: e.data.context.files}, e.finder))
        }

        function d(t) {
          var e = t.data.response;
          if (e.error.number === l) {
            t.cancel();
            var n = !!e.deleted, i = t.finder.lang.errors.codes[l], r = [];
            o.forEach(e.error.errors, function (e) {
              r.push(e.name + S(">\x05`") + t.finder.lang.errors.codes[e.number]), 117 === e.number && (n = !0)
            }), t.finder.request(S("1VZUYYP"), {
              name: S("7|\\V^HXxV,$1\x0667)5;"),
              title: t.finder.lang.errors.operationCompleted,
              template: a,
              templateModel: new s.Model({deleted: e.deleted, errors: r, msg: i}),
              buttons: [S("\x1bsv]sORG")]
            }), n && t.finder.request(S("1T\\XQSE\x02K_]NXMW\x06(.&7"))
          }
        }

        return function (e) {
          (this.finder = e).setHandler(S("7^PV^O\x07ZZ,$6&"), t, this), e.on(S("\x1dzvAMMD\x1eaCKM]OmEAKl__TZFX\fXS"), u), e.on(S('3WZ[ZYW^\x01][JZ2{\x06&( 2"\x0e &.?'), c), e.on(S('?#./.%+"}-;8$>w\n*<4&6\x12<:2+'), d), e.on(S("\x1b\x7frpkEYVnAKS\x1dN@FN"), function (e) {
            e.data.groups.add({name: S("\x0eku}wgq")})
          }, null, null, 40), e.on(S("\rm`~ewk`Xsym#|rpx${EMGWA"), i, this), e.on(S("A6,+)$&:s8.?(:u\x1d0;=n3?;="), n), e.on(S("&SGFFIM_\x14]UBWG\x0exW^V\x03\\RPXM"), n), function (i) {
            i.on(S('\x13r|zr"r\x7fbxriq'), function (e) {
              if (e.data.evt.keyCode === r.delete && i.util.isShortcut(e.data.evt, "")) {
                var t = i.request(S("D#/+-:p,)9\x1d*<41'11")), n = 1 < t.length ? t.toArray() : [e.data.file];
                i.request(S(":]UQ[Lz%'/!1#"), {files: n})
              }
            }), i.on(S("=MW/36 115}$ 9?v+'#5\""), function (e) {
              e.data.shortcuts.add({label: e.finder.lang.shortcuts.files.delete, shortcuts: S("E=#-%7")})
            }, null, null, 30)
          }(e)
        }
      }), CKFinder.define(S("\fNEIy\x7fvvf:[x|lv~o2ZzLDVFbJJCM[\x05oIAK[Uw]_PPD"), [S("%eln@DOI_\x01zDX^\x1c\x7fPOtW]_")], function (n) {
        "use strict";
        return function (r) {
          r.on(S(":_U\\RP'{\x06&( 2\"\x0e&&/)?\r >7;!9o9<"), function (e) {
            var t = e.data.context.folder;
            r.request(S("?,.#'!7|4 &="), {text: r.lang.common.pleaseWait}), r.request(S("+OBCBQ_V\tGPXS"), {
              name: S("\rJj|tfvRzzs}k"),
              type: S("5FXKM"),
              folder: t,
              context: {folder: t}
            }, r)
          }), r.on(S("6TWTWZRY\x04^&5'1~\x01#+-=/\r#!**\""), function (e) {
            var t = e.data.response, n = e.data.context.folder;
            if (r.request(S('@--"  4}  ..')), !t.error) {
              var i = n.get(S("\x1ak}o{qT"));
              n.unset(S("%VFZLD_")), i.get(S(".LXX^WFPX")).remove(n), r.request(S("\vjbbkuc(tqaWtlpl~")).cid === n.cid && r.request(S("\x0ei\x7f}vvf/ert|yo"), {folder: i}), r.fire(S("\x10w}\x7fppd-||v~hxz"), {folder: n})
            }
          }), r.on(S("7LVUW^\\L\x052$1&0\x7f\v&!'p-#!**\""), function (e) {
            var t = e.data.folder;
            !t.get(S("?)2\x10,+1")) && t.get(S("0PQ_")).folderDelete && e.data.toolbar.push({
              type: S("D'33<&$"),
              name: S("#`@JB\\LlD@IK]"),
              priority: 20,
              icon: S("%ELN\x04LD@IK]\x1dUW_QAS"),
              label: e.finder.lang.common.delete,
              action: function () {
                r.request(S("\fkactt`)ppzrl|"), {folder: t})
              }
            })
          }), r.on(S("\x1d}pNUG[PhCI]\x13LD@IK]"), function (e) {
            e.data.groups.add({name: S(";XXRZ4$")})
          }, null, null, 20), r.on(S("D&))<,2?\x01( :j7=?00$m<<6>(8"), function (e) {
            var t = e.finder, n = e.data.context.folder, i = n.get(S("<TMm/.6")), r = n.get(S("%GDD"));
            e.data.items.add({
              name: S("+hHBJDTt\\XQSE"),
              label: t.lang.common.delete,
              isActive: !i && r.folderDelete,
              icon: S('8ZQ]\x11[QS$$0n  *"<,'),
              action: function () {
                t.request(S('D#)+,,8q(("*$4'), {folder: n})
              }
            })
          }), r.setHandler(S("=XP,%'1~!#+-=/"), function (e) {
            var t = e.folder;
            r.request(S("\x13p|w{w~ xssxvRL"), {
              name: S("8}_WYI[y/-&&6\x06)). 8&"),
              context: {folder: t},
              msg: r.lang.folders.deleteConfirmation.replace(S("C?+'*-4"), function () {
                return r.util.escapeHtml(t.get(S(".AQ\\W")))
              })
            })
          }), function (t) {
            t.on(S("2U[YRRJ\x03Q^EYQH."), function (e) {
              e.data.folder.get(S("\x17qjHtsi")) || e.data.evt.keyCode === n.delete && e.finder.util.isShortcut(e.data.evt, "") && (e.data.evt.preventDefault(), e.data.evt.stopPropagation(), t.request(S("#BJJCM[\x10OIAK[U"), {folder: e.data.folder}))
            }), t.on(S("%UOG[^HYY]\x15\\XAG\x0eSY[\\\\HH"), function (e) {
              e.data.shortcuts.add({label: e.finder.lang.shortcuts.folders.delete, shortcuts: S("\x1f[EGOY")})
            }, null, null, 30)
          }(r)
        }
      }), CKFinder.define(S("8zq}USZZ2n\x14*!25h\n(9.c\x01/6?$&\x05=0!"), [S(";Q\\LV//'70 "), S("\x17[R\\rry{m\x0fwKFSV\teIZO\x04oBCB__")], function (t, n) {
        "use strict";
        return t.LayoutView.extend(n.proto).extend({
          constructor: function (e) {
            n.util.construct.call(this, e), t.LayoutView.prototype.constructor.apply(this, Array.prototype.slice.call(arguments))
          }
        })
      }), CKFinder.define(S("!ahbLHCM[\x05}EHY\\\x1fsS@Q\x1auXTU_XHTQQ\x16('4"), [S('C1+""::)$>('), S("3YTD^WW_OHX"), S("C\x07\x0e\0.&-/9c\x1b'*'\"}\x115&3x\x1b67633")], function (i, e, t) {
        "use strict";
        var n = e.CollectionView;
        return n.extend(t.proto).extend({
          constructor: function (e) {
            t.util.construct.call(this, e), n.prototype.constructor.apply(this, Array.prototype.slice.call(arguments))
          }, buildChildView: function (e, t, n) {
            return new t(i.extend({model: e, finder: this.finder}, n))
          }
        })
      }), CKFinder.define(S("\x13W^P~v}\x7fi3Pq{UMGP\vaOFDFMX\x03{GJGB\x1dw]TZX_{OOHRPi)$5"), [S(")i`jD@KUC\x1df@\\Z\x18s\\CxSY["), S("\x14V]Qqw~~n2HvEVQ\ffDUB\x07`^NA{GJG")], function (t, e) {
        "use strict";
        return e.extend({
          name: S("<yW^,.%\x01112(&"),
          tagName: S("6UMMNTR"),
          template: S("\vwv3/ye<\x7fuws{8dg"),
          attributes: {tabindex: 1},
          events: {
            click: function () {
              this.trigger(S("@#770*("))
            }, keydown: function (e) {
              e.keyCode !== t.enter && e.keyCode !== t.space || (e.preventDefault(), this.trigger(S("\x0frdfg{{")))
            }
          },
          onRender: function () {
            this.$el.attr(S("8][O]\x10WQ,(,&"), !0).attr(S("\x15rvlx7xw{3}UUVLJ"), this.model.get(S("\x1eqALG")))
          }
        })
      }), CKFinder.define(S("+ofhF^UWA\x1bxYSMU_H\x13yW^,.%0k\x13/\"?:e\x0f%,\" 7\x13'' :8$\x0e0?,"), [S("0D\\WQGETWK_"), S(".MQRYQ[[S"), S(".l{w[]PPD\x18nP_LO\x12|^3$m\0+)*\"+=#$\"\x1b'*'"), S("3w~p^V]_I\x13pQ[5-'0k\x01/&$&-8c\x1b'*'\"}\x17=4:8?\x1b//(20\t\t\x04\x15")], function (r, t, e, n) {
        "use strict";
        return e.extend({
          name: S("A\x06*%)) \n<>?##="), childView: n, initialize: function (e) {
            this.collection = function (e, n) {
              var i = new t.Collection;
              return r.forEach(e, function (e) {
                var t = r.isString(e) ? e : e.name;
                i.push(r.extend({icons: {}, label: t, name: t, event: t.toLocaleLowerCase()}, r.isString(e) ? n[t] : e))
              }), i
            }(e.buttons, {
              okClose: {
                label: this.finder.lang.common.ok,
                icons: {primary: S("%SN\x05@IDB\0MGURY")},
                event: S("\x1cru")
              },
              cancel: {label: this.finder.lang.common.cancel, icons: {primary: S("/EX\x1fZWZX\x1a[UUHY")}},
              ok: {label: this.finder.lang.common.ok, icons: {primary: S("\x19or1t}pN\fAKAFM")}}
            })
          }
        })
      }), CKFinder.define(S("4ASOL\x18ypzTP[%3m\x17!(6+)=/8c\t'.<>5 {\x11?646=\x17=$1*\x14O\x06\f\x10"), [], function () {
        return S('\x10ji,4|b9lpnwy=cb\x1cEKU\x04AGSI\x04XD@H\x13\rXTSWQG\x14\x17[U[HO\0\x1cJ)l6*0)#evu"zr65rp8&} <";=y\'&`r6n^]M\x07\r\x13X\x1c\x13V\x17\x16fQ\n\x06\x06Q\x1b\x17IW\x15\x1c\x1eT\x1e\x12\x1d\x11\x11\x18-bmmp`hs{$qp1-g{>xv3ih47{u{ho <|KG\x0fGMDJHO\x04IDBYKADB\x12HO\b\x16^L\x17YTRI[Q4\x02."76\b&%,j61ops\x7f5;%j_-,gy3/r5?,"\x14\x16\x17\v\v\x15G\x15\x14V\x0f\x05\x1bN\f\x1c\x10\x01\0IW\x03\x1eU\x1a\x15\x15\b\x18\x10\v bie)aofdfm&nxz{\x7f\x7fa14|r*:zq}1yw~LNE\x0eFPRSGGY\x06WV\x13\x0fYE\x1cZP\x15KJ\x1a\x07\x06\x14XTH\x01;:}>9O')
      }), CKFinder.define(S(':xw{WQ$$0l\t*"2$,9d\b$/#?6!|\x02<3 +v\x1e2=1186\b\x07\x14'), [S(")_EHH\\\\S^@V"), S("'BX_N^T"), S('?\x03\n\x04**!#5g\x1c>" b\x05*)\x12=71'), S("1qxr\\XS]K\x15mUXILo\x03#0!j\n&1&??\x1a$+8"), S("\nHGKgatt`<Yzrbt|i4Xt\x7fsOFQ\frLCP[\x06nBMAAHrDFG[[EaQ\\M"), S("\x19n~di?\\kgKM@@T\b|LG[@LZJC\x1evZUYYPK\x16~R]QQX\f ;,11h#'=")], function (s, t, o, e, n, i) {
        "use strict";
        return e.extend({
          template: i,
          className: S("\nhgk#kyp~|s"),
          ui: {title: S("/\x1eD[\x1e@\\B[]\x03\\RNNJ")},
          attributes: {role: S("\x1fDHCOKB")},
          regions: function (e) {
            return {
              contents: S("\x155ts\x7f7\x7fu|rpG\fALJQCI\\Z\x07") + e.id,
              buttons: S("%\x05DCO\x07OELB@W\x1cPF@AYYK\x14") + e.id
            }
          },
          initialize: function () {
            this.listenTo(this.contents, S("\x11a{{b"), function () {
              this.$el.trigger(S("9YIY\\JZ"))
            }, this), t(S("\x1e1UH\x0fSKUSW\x05JEEXLGAUC")).remove()
          },
          onRender: function () {
            var e = s.uniqueId(), t = S(";_VX\x12$(#/+\"k+)+/'a") + e;
            this.$el.attr(S("\x1e{AUC\x0ePMCJM"), this.finder.config.swatch).attr(S("+M_GN\x1d]SQQYZR\\[C"), t).attr(S("\x1b}ow~\rEGPGWOEMMHR"), this.regions.contents.replace("#", "")).appendTo(S(" CMG]")), this.options.ariaLabelId && this.$el.attr(S(",L\\FQ\x1c^RVPZ[]]XB"), this.$el.attr(S("7YKSZ\x11Q_]%-.& '?")) + " " + this.regions.contents.replace("#", "")), this.ui.title.attr({
              id: t,
              "aria-live": S("/@^^Z@P")
            }), this.contents.show(this.getOption(S('D,()-;\x1c"):'))), this._addButtons(), this.$el.trigger(S("\nh~ho{u")), this.$el.popup(this._getUiConfig()), this.$el.parent().addClass(S("&RA\x04NBMAAH\x1dA]CAE"));
            try {
              this.$el.popup(S(">P0$,"), this.options.uiOpen || {})
            } catch (e) {
            }
            this.$el.find(S("\x12=w~p:|p{wsz3}UUVLJV\x06E]]^DBvJNDP\x1fP_S\x1bUMMNTR\0\x1cP+\x02.,7 d\x1adg) *`*&1==4y7##,64(|?++\x14\x0e\f8\0\x04\x12\x06E\n\x01\rA\x0f\x1b\x1b\x04\x1e\x1cNV\x1a\x1dU%")).first().focus();
            var n = this.getOption(S(";ZR]J3\b6&)"));
            if (n) {
              var i = s.isString(n) ? n : S("/Y_BF@\x19\x16C]ANZNX_\x13`2'/!&2"), r = this.$el.find(i).first();
              r.length && r.focus()
            }
            return this.options.restrictHeight && this.restrictHeight(), this.$el.on(S("\x19q~eyqhN"), function (e) {
              e.keyCode !== o.tab && e.stopPropagation()
            }), this
          },
          onDestroy: function () {
            try {
              this.$el.popup(S("\nh`b}j")), this.$el.off(S(".DUHV\\C[")), this.$el.remove()
            } catch (e) {
            }
          },
          getButton: function (e) {
            return this.$el.popup(S("\x17op~|yi")).find(S("&E]]^DBvJNDP\x1fP_S\x1bUMMNTR\0\x1c") + e + S(":\x19a"))
          },
          enableButton: function (e) {
            this.getButton(e).removeClass(S("\x13a|;dlxn~1ywlACNF@")).attr(S("0P@ZU\x18R^KXXWYY"), S('"EEIUB'))
          },
          disableButton: function (e) {
            this.getButton(e).addClass(S("+YD\x03\\DPFV\x19Q_DY[V^X")).attr(S("-O]YP\x1fW]FWUT\\^"), S('"WVPC'))
          },
          restrictHeight: function () {
            if (!this.isDestroyed) {
              var e = t(window).height() - this.ui.title.outerHeight() - this.buttons.$el.outerHeight() - this.$el.parent().position().top - 20;
              this.contents.$el.css(S("C)$>j ,#,$9"), parseInt(e, 10) + S("C4="))
            }
          },
          _fixTopOffset: function () {
            var e = this.$el.parent().css(S("7LVJ")), t = parseInt(e) - (window.scrollY || window.pageYOffset);
            this.$el.parent().css(S("#PJV"), t)
          },
          _addButtons: function () {
            var e = this.getOption(S("\x1ayiijpNR"));
            if (e) {
              var i = this, t = new n({finder: this.finder, buttons: e});
              this.listenTo(t, S("\voegctg{vc/tblmuu"), function (e) {
                var t = e.model.get(S("@$4&*1")), n = e.model.get(S("\x1dp~MD"));
                n !== S("&DIGIN@") && n !== S("8VQxPRMZ") || i.destroy(), i.finder.fire(S("*OELB@W\v") + i.getOption(S("&CAHFDK")) + ":" + t, i.getOption(S("\x1d}sIBIgEQG")), i.finder)
              }), this.buttons.show(t)
            }
          },
          _getUiConfig: function () {
            var n = this, i = {}, r = this.getOption(S("-[F\x7fAFZ[[E"));
            r && s.forEach([S('@"0&%1#'), S("9[]HXL\\,.1&"), S("#F@@HZLZD_DZF__")], function (e) {
              i[e] = r[e], delete r[e]
            });
            var e = {
              create: function () {
                n.contents.$el.css({
                  minWidth: n.getOption(S("\x19wrrJw{TI")),
                  minHeight: n.getOption(S(".BY_zV]R^C")),
                  maxHeight: window.innerHeight
                }), o(S(">\\2$#7!"), this, arguments)
              }, afterclose: function () {
                n.destroy(), n.finder.fire(S("A&*%)) r*&$?(t") + n.getOption(S("A&*%)) ")), {
                  context: n.context,
                  me: n
                }), o(S("%GA\\LXH@B]J"), this, arguments)
              }, afteropen: function () {
                n._fixTopOffset(), o(S("&FN]OYC]KA"), this, arguments)
              }, beforeposition: function (e, t) {
                r && r.positionTo && (delete t.x, delete t.y, t.positionTo = r.positionTo), setTimeout(function () {
                  n.options.restrictHeight && n.restrictHeight()
                }, 0), o(S("\x18{\x7f}so{oORKWMJH"), this, arguments)
              }
            }, t = n.finder.config.dialogOverlaySwatch;
            return t && (e.overlayTheme = s.isBoolean(t) ? n.finder.config.swatch : t), s.extend(e, r);

            function o(e, t, n) {
              i[e] && i[e].apply(t, n)
            }
          }
        })
      }), CKFinder.define(S(")i`jD@KUC\x1de]PAD\x17t_HO\\YZ\x16('4"), [S("#QKBBZZID^H"), S("\x12quv}uww\x7f"), S("\x1e\\kgKM@@T\b~@O\\_\x02lNCT\x1dz@P[aQ\\M")], function (t, n, e) {
        "use strict";
        return e.extend({
          name: S("\x0eBubarsp@~}n"),
          className: S("\x15u|~4w~on\x7fxE"),
          template: S("\x0e3cas}4|r*:ba&<tj1IE\x02^Y\x07\x18\\S\x14\nBX\x03C\\W\x11ON\b\x1aEGYW\x04"),
          initialize: function (e) {
            this.model = new n.Model({msg: e.msg, id: e.id ? e.id : t.uniqueId()})
          }
        })
      }), CKFinder.define(S("<~uy)/&&6j\v(,<&.?b\n&1==4'z\x12>955</"), [S("\x1chp{ESQ@KWC"), S('C.43":0'), S("/RPQXVZXR"), S("3w~p^V]_I\x13hJV,n\t&=\x06)#-"), S("6ts\x7fSUXXL\x10\r.&6( 5h\f +'#*=`\x0687$'z\x12>955<\n4;("), S(";\x7fvxV.%'1k\x13/\"?:e\t->+`\x19%7>\x02<3 "), S("#gn`NFMOY\x03{GJGB\x1d~QFEV_\\lRYJ")], function (s, n, a, t, l, u, i) {
        "use strict";

        function r(e) {
          var t = this.finder;
          if (d(), !e.name) throw S("\vBlcj0asauxsc}k:vinj?BD\x02PT@ENN@OO\fKA]\x10U[RXZQ");
          var n = !!s.isUndefined(e.captureFormSubmit) || e.captureFormSubmit, i = function (e, t, n) {
            var i;
            if (e.view) i = e.view; else {
              var r = {name: e.name, finder: t, template: e.template};
              n && (r.triggers = {
                "submit form": {
                  event: S(".\\ES_Z@\x0fPXJT"),
                  preventDefault: !0,
                  stopPropagation: !1
                }
              }), i = new (u.extend(r))({model: e.templateModel})
            }
            return i
          }(e, t, n), r = function (e, t, n) {
            var i = {
              context: t.context,
              finder: e,
              name: S("\x0fTxs\x7f{r"),
              dialog: t.name,
              id: s.uniqueId(S(" BIE")),
              minWidth: t.minWidth ? t.minWidth : e.config.dialogMinWidth,
              minHeight: t.minHeight ? t.minHeight : e.config.dialogMinHeight,
              focusItem: s.isUndefined(t.focusItem) ? e.config.dialogFocusItem : t.focusItem,
              buttons: s.isUndefined(t.buttons) ? [S("@\"#-' *"), S("\x1atw")] : t.buttons,
              captureFormSubmit: !!s.isUndefined(t.captureFormSubmit) || t.captureFormSubmit,
              restrictHeight: !s.isUndefined(t.restrictHeight) && t.restrictHeight,
              uiOptions: t.uiOptions
            };
            t.ariaLabelId && (i.ariaLabelId = t.ariaLabelId);
            return i.model = new a.Model({
              id: i.id,
              title: t.title,
              hasButtons: !s.isUndefined(i.buttons),
              contentClassName: s.isUndefined(t.contentClassName) ? S(" \x01WJ\tFII\\LD_") : !1 === t.contentClassName ? "" : " " + t.contentClassName
            }), i.clickData = {model: t.templateModel, view: n, context: t.context}, i.innerView = n, i
          }(t, e, i), o = new l(r);
          return t.request(S("3RZUBK\x03H^QXS]%3")), o.on(S("@%'007)>"), function () {
            t.request(S("!DLGPU\x1dZLY_C_K"))
          }), n && o.listenTo(i, S("\x14fcuupn!zrlr"), function () {
            return t.fire(S("\x12w}tzx\x7f#") + e.name + S("6\rWR"), r.clickData, t), !1
          }), o.render(), t.request(S("7^VYNO\x07JM!1"), {node: o.$el}), o
        }

        function o(e) {
          var t = s.uniqueId(S("\rmdv<\x7fvgfwp}4")), n = s.extend({
            name: S(";uSXP"),
            buttons: [S("4Z]tTVI^")],
            view: new i({msg: e.msg, finder: this.finder, id: t}),
            transition: S('"EHLV'),
            ariaLabelId: t
          }, e);
          return r.call(this, n)
        }

        function c(e) {
          var t = s.uniqueId(S("\x17{r|6qxmlAFG\x0e")), n = s.extend({
            name: S("*hCCHFB\\"),
            buttons: [S('B %+%"$'), S("\x16xsZvtox")],
            title: this.finder.lang.common.messageTitle,
            view: new i({msg: e.msg, finder: this.finder, id: t}),
            ariaLabelId: t
          }, e);
          return r.call(this, n)
        }

        function d() {
          n(S("8\x17YPZ\x10ZV!--$")).popup(S("=]S/2'")), n(S("\x1c3kv\rQMSQU\vDGG^JECK]")).remove()
        }

        return function (e) {
          (this.finder = e).setHandlers({
            dialog: {callback: r, context: this},
            "dialog:info": {callback: o, context: this},
            "dialog:confirm": {callback: c, context: this},
            "dialog:destroy": d
          }), e.request(S("C/ ?}$ 9?)#"), {key: t.escape}), e.on(S("\x15}ralj!.*"), function (e) {
            var t;
            n(S("\x0f>ryu9q\x7fvtv}")).length && ((t = e.data.evt).preventDefault(), t.stopPropagation(), d())
          }, null, null, 20)
        }
      }), CKFinder.define(S("4ASOL\x18ypzTP[%3m\x17!(6+)=/8c\b*&$\x18?230y\x12<0.\x121<9:,\0\x1b\f\x11\x11H\x03\x07\x1d"), [], function () {
        return S("\x10-vzb5u{yji&>~uy\rDK\x0eSWGWXLX\t\x12''\x13TXD\x13]Q\v\x15[R\\\x16YT\x13O2$4*!2dg+%+8?pl,;7\x7f6=x&%=/3>+\x7f`cO\x05\v\x15Zoo[\f\0\x1cK\x05\tSM\x13\x1a\x14^\x11\x1c[\x16\x1b\r\x13\x14\x12\x0e\\_cmcpw8$dco'ne m`~e`|xf6bq4xtxd3d[\x1c\x02JP\vUPI]IC\fPS\r\x0e\r\x1dW]C\b=\x04\x16^RJ\x034")
      }), CKFinder.define(S("\x13W^P~v}\x7fi3Pq{UMGP\v`BN\\`GJKH\x01yYTE@\x1bpR^LpWZ[Xr^9.77"), [S("\x19YPZtp{ES\ruM@QT\x07kKXI\x02bNI^GGb\\S@"), S(".[UIF\x12w~p^V]_I\x13i[R0-#7!6i\x02, >\x02!,)*\x7f\x146: \x1c;6?<\x16:%2++N\x05\r\x17")], function (e, t) {
        "use strict";
        return e.extend({
          name: S("#aAOSaDKLIaOV_DF"),
          template: t,
          regions: {preview: S("*\bOFH\x02UX\x1fCFP@^]N"), actions: S("\x18:ypz0{v\r@AWMJHT")},
          templateHelpers: function () {
            return {swatch: this.finder.config.swatch}
          },
          onActionsExpand: function () {
            this.preview.$el.addClass(S("\x14v}q5|s6lo{iIDU\x0eV@BRKLN"))
          },
          onActionsCollapse: function () {
            this.preview.$el.removeClass(S("(JAM\x01HG\x02@CWE]PA\x1aJ\\^N_XZ"))
          }
        })
      }), CKFinder.define(S("\x18m\x7fch<]TfHLGAW\tsMDZGMYK\\\x1ftVZ@|[V_\\\x15rQ\\YZ\x103'5- 1i,&>"), [], function () {
        return S("\v0noafpa3wywdk$8xw{3zI\fABJSGT\n\x17\x16\x04OL@YQB\f9")
      }), CKFinder.define(S("\x15U\\^pt\x7fyo1ROEWOAV\tbL@^bALIJ\x1fg[VCF\x19~UX]^lO[I)$5\x15- 1"), [S("%eln@DOI_\x01yYTE@\x1bwWD]\x16sOYPhV%6"), S("\x11fvla7TS_suxxl0tDOSHDRB[\x06oOEYgBQVW\x1c}XWP]iH^JT[Hn%-7")], function (e, t) {
        "use strict";
        return e.extend({name: S(" hOBC@vUM_CN["), template: t, ui: {canvas: S('\v"nei=t{>wtxayj')}})
      }), CKFinder.define(S("2GQMB\x16{r|RRY[Mo\x15'.4)'3-:e\x0e($:\x06=056{\x145#164u82*"), [], function () {
        return S("1\x0eW]C\x16SYM[\x16NRRZ}c!,()'7; (')on+1%3~7::;9))>8p7<\x0f\x0f_A\x1f\x1e[G\x01\x1dD\x02\x0f\x02\0\x12\rSR\x17\x15\x01\x17Z\x1d\x01\n\x1a\x12\x19\x1b\x1b-halj8$|s4*bx#gl\x7f\x7fon65rvlx7r\x7frpoOR\x1f\x01VLAO\\\v\nOMYO\x02Y_AV@\b\x14QYUI^\x1e\x1dJ^\"(,'!={eexhuFmnopm:gt<2jz\"!f|4*q\t\x05B\x1e\x19H\x12\x06\nKJ\b\0\f\x1d\x1cMS\x11\x18\x12X\x13\x1eU\x18\x19\x0f\x15\x12\x10Rthvoa'&ugeo6.yom21sa}t;twwnisqm\"\x02ZY\x1e\x04LR\tAM\nVQ\0ZNRAS]QY\x14\tCB\x07\x1bUI\x10K)5.&d8;{g!~uFmnopm6:\"u5;9*)f~>59M\x04\vN\x05\x06\x12\x0e\x07\x07G\b\x03\x03\x1a\x1d\x1f\x1d\x01QJIY\x13\x11\x0fDq@R\x1a\x16v?\b")
      }), CKFinder.define(S('A\x01\b\x02,(#-;e\x06#);#5"}\x160<"\x1e58=>s\v7:\x17\x12M"\x07\x11\x0f\b\x06?\x03\x0e\x1b'), [S("\x17mw~~nn}pRD"), S("\x1euQTGQ]"), S("*hgkGATT@\x1caA_[\x17r_B\x7fRZZ"), S("9ypzTP[%3m\x15- 14g\v+8)b\x02.)>''\x02<3 "), S(';HXFKa\x02\t\x05-+"":f\x1e.!=".$4!|\x111?#\x114;<9r\x1f<\x14\b\r\rJ\x01\t\x13')], function (e, t, n, i, r) {
        "use strict";
        return i.extend({
          name: S("&fK]CDB{GJG"),
          template: r,
          className: S(")I@J\0KF\x1dPQG]ZX"),
          ui: {heading: S("\r l{w?v}8wtlpuu1iwkLD"), controls: S("'\x06JAM\x01HG\x02QRFZ[[\x1bTWWNISQM")},
          regions: {action: S("\x10?qxr8s~5xyourp2CNLWVJJT")},
          events: {
            collapsiblecollapse: function () {
              this.model.get(S("\x0fd~}\x7f")).trigger(S("!ALHIGW[L")), this.ui.heading.attr(S("\x0fqc{r9pngyw~~x"), S("%@FDZO")).find(S("!\fVM\bDSF")).removeClass(S(" TK\x0eFQH\nIJ^BZH")), this.trigger(S("7[VVW]MMZ")), this.isExpanded = !1, this.ui.controls.find(S("\x12H`tt~v}\x7fcA")).attr(S("4AWUQW^^D"), S("\v!<"))
            }, collapsibleexpand: function () {
              this.model.get(S("\fya`|")).trigger(S("%C_XHDO")), this.ui.heading.attr(S(">^2(#n!=6&&-//"), S("<ILJ%")).find(S("@o7*i'2)")).addClass(S("#QL\vE\\G\x07JOYGYU")), this.trigger(S("\x14pngyw~")), this.isExpanded = !0, this.ui.controls.find(S("&|\\HHBBIKWm")).attr(S("\x1dj~BHLGA]"), this.model.get(S(":O]_WQ$$:")))
            }, collapsiblecreate: function () {
              this.$el.find(S("\x1f\x0eTK\x0eGJJKIYYBNAK\x02XTSW][Q\x1aLV]\\PX")).attr(S(";H\\\\V.%';"), this.model.get(S("'\\HHBBIKW"))), this.ui.heading.attr(S(':ZNT_\x12%92"*!##'), S("\vjlb|u")), this.isExpanded = !1;
              var e = this.model.get(S("\x13}q"));
              this.$el.find(S("5\x18BQ\x14YTPQ_O3( /!h%(&=/%8")).attr({
                id: e + S("\n&xll\x7fq\x7fw\x7f"),
                role: S("2GUWFVV\\V"),
                "aria-labelledby": e + S("\x148bvz")
              })
            }, "keydown .ui-collapsible-heading-toggle": function (e) {
              if (e.keyCode === n.space || e.keyCode === n.enter) {
                e.stopPropagation(), e.preventDefault();
                var t = this.$el.find(S("\x14;c~5zuwp|nlICNF")).collapsible(S("\vc}zf\x7f\x7f"), S("#GJJKIYYNH")) ? S("\x1fEYRBJA") : S(".L_]^RDFS");
                this.$el.find(S(".\x01EX\x1fP[YZVHJSYPX")).collapsible(t)
              }
            }, "keydown [tabindex]": function (e) {
              e.keyCode === n.tab && (!this.isExpanded && e.target === this.ui.heading.find(S("%\bRA\x04ID@AO_CXP_Q\x18^RY]SU[\x10JP'&.&")).get(0) || this.ui.controls.find(S("A\x197%'/),,2\x16")).last().get(0) === e.target) && this.trigger(S("\x10esqFpgb}jn"), e)
            }
          },
          initialize: function () {
            this.model.set(S(":RX"), e.uniqueId())
          },
          collapse: function () {
            this.$el.find(S("(\x07_B\x01NAC\\PB@]WZR")).collapsible(S("2P[YZVHJ_"))
          },
          onRender: function () {
            this.action.show(this.model.get(S("\n\x7fcbb")).getView(this.finder)), this.$el.attr(S("\x1fD@VB\tFMA\x05LC\x06XBAC"), this.model.get(S("A6,+)")).get(S("'FHGN")))
          }
        })
      }), CKFinder.define(S('&dcoCEHH\\\0}^VFXPE\x18}]SOuP_X%n\x14*!25h\t*>"##=\x1994%'), [S("<WOJ%3;"), S("\x1fcjdJJACU\x07\x7fCN[^\x01mQBW\x1cwZZ[]ZNRSShV%6"), S("\x14V]Qqw~~n2SpDTNFW\ncCA]cFMJK\0fXWDG\x1awTLPUUjT[H")], function (i, e, t) {
        "use strict";
        return e.extend({
          name: S("\x17YznrssmIIDU"),
          attributes: {"data-role": S("\x18zuwp|nlICNFW@R"), role: S("C0$$+!:>")},
          childView: t,
          childViewContainer: S("\x1a8\x7fvx2EEKW\tLKFOL\x07JOYG@^B"),
          childEvents: {
            expand: function (t) {
              this.children.forEach(function (e) {
                e.cid === t.cid || e.ui.heading.hasClass(S("\x1anu0}pLMCSWLDKM\x04BNMIGAW\x1cQ\\XYWGK\\^")) || e.collapse()
              })
            }, tabRequest: function (e, t) {
              this.finder.util.isShortcut(t, "") && this.children.last() !== e && this.finder.request(S('"EKFST\x12GOSX'), {
                node: e.$el.find(S("/kESQ][RR@d")).not(S("A\x197%'/),,2vn`\x7fm\r")).last(),
                event: t
              })
            }
          },
          initialize: function () {
            var e = this.finder;
            this.collection.on(S("\x15\x7fzy~\x7f_}i\x7f%RDCG]"), function () {
              n(e.request(S(")_B\x16JK[}^VV")), e), i.mobile.resetActivePageHeight()
            }), e.on(S("5C^\x02K_HUG["), r)
          },
          onDestroy: function () {
            this.finder.removeListener(S("\vyd4}ub{iq"), r)
          },
          focusFirst: function () {
            this.$el.find(S("\x1b2hw2CNNOEUUNJEO\x06DHOKY_U\x1e@ZQPT\\")).first().focus()
          }
        });

        function n(e, t) {
          var n = e === S("\x19~~ovjpP");
          i(S(">\x11#*$n!,k$''>9#!=o~$;~7::;9))2>1;r\b\x04\x03\x07\r\v\x01J\x1c\x06\r\f\0\b")).toggleClass(S("\x1anu0}pROGQ\tDJK\b\\C\x06NY@\x02YR]]\x19[YC]AN"), !n).toggleClass(t.lang.dir === S("\rb{b") ? S("\x19or1\x7fjq\rHALJ\bJBN]") : S("\x17jp}sh"), n)
        }

        function r(e) {
          e.data.modeChanged && n(e.data.mode, e.finder)
        }
      }), CKFinder.define(S("E\x05\f\x0e $/)?a\x02?5'?1&y\x12<0.\x121<9:O,\r\x07\x01\t\x15H-\r\x03\x1f%\0\x0f\b\x155\x13\x07\x15"), [S("\x1e}ABIAKKC")], function (e) {
        "use strict";
        return e.Model.extend({
          defaults: {
            file: null,
            caman: null,
            imagePreview: "",
            fullImagePreview: "",
            actions: null
          }, initialize: function () {
            this.set(S('"BGQOHFZ'), new e.Collection)
          }
        })
      }), CKFinder.define(S("4v}qQW^^N\x12sP$4.&7j\x03#!=\x03&-*+`\x04>=?'z\x02875"), [S("'JHI@NB@J")], function (e) {
        "use strict";
        return e.Model.extend({
          getActionData: function () {
            return new e.Model({})
          }, saveDeferred: function (e, t) {
            return t
          }, getView: function (e) {
            var t = new (this.get(S("(_CN[nBNCB")))({finder: e, model: this.getActionData()});
            return this.set(S("\x12e}pa"), t), t
          }
        })
      }), CKFinder.define(S("\x1djzXU\x03`ocOILLX\x04xHC_\\PFVG\x1asSQMsV]Z[\x10\x033-3j!)3"), [], function () {
        return S("7\x04]SM\x1c^R^32\x7fa'. j- g(>\">b3><'&::$u04+))-}^kk_\b\x04\x04\x02\x04W`be\x16\x15RP\x18\x06]\x18\x14\x18\x10V\x1c\x1e\x12\b4\x13\x1egd,ha`vF{yohx_o{y~2ni\x1f\x1f\x1e$ptkii>qALG\x1e\x06FMAk[E[gHK_qBBVWAdVLPU\x19\x1cI_])/&&<xd<3tj\"8c:.28<71-v*%{z/%-;bB\x02\n\x06\x07\x0e\x04\b\x10K\x11\x10SM\x07\x1b^\x1a\x17\x16\x044\x05\x07\x1d\x1a\x0e)\x1d\t\x17\x10 |\x7f#gmcdcln6.nfjszww6nm(ed:\x7f}i\x7f2IBMMTJU\x1a\nRQ\x14\fDZ\x01\\P\\T\x1aQ_E\x18\x04\x07\x1b\x1bQJMg<?/!#2<3vu61?'(8%)(k(+ufSSgs1?=\x05\r\\imY\x04\x12\x1c\x1d\x05\x05L\x04\nRR\x12\x19\x15Y\x10\x1fZ\x1b\v\x15\vQ\x1c\x0e\x0flx #pddnfmos1/ut-1{g:awuqw~~d=cb\x02\x01FBPD\vNKFD\x16\x0eNEI\x1dE[P_\x17\x16SYM[\x16U^QQ0.1~f>=xh >e , (~5;!thkw\x7f5.){ #3\x05\x07\x16\x18\x1fZY\x1a\x15\x1b\x03\f\x04\x19\x15\x14O\f\x0fQJ\x0e\rJX\x10\x0eU\x10\x1c\x10\x18.dfjpLkfol$j|}bv0lo/;wcclvt%\x16!1{IW\x1c)")
      }), CKFinder.define(S("<~uy)/&&6j\v(,<&.?b\v+9%\x1b>523x\x0e0?,/r\x1d-\x0f\x114\n\x01\x12"), [S("\x18ZQ]uszzR\x0ewWMI\tlMPiDHH"), S("\x11QXR|xs}k5Muxil\x0fcCPA\noSMD|BIZ"), S("4ASOL\x18ypzTP[%3m\x17!(6+)=/8c\b*&$\x18?230y\x14*6*u82*")], function (t, e, n) {
        "use strict";
        return e.extend({
          name: S("\rM}\x7faDzqb"),
          template: n,
          className: S('\vofh"ux?pfzf:{vtonrrl'),
          ui: {
            keepAspectRatio: S("\x1fIORVP~HFEL\x17\tOFHlB^BxQPFvKI_XHo_K).`\x1e"),
            apply: S("Ee$#/g.%`-=?!\x7f2$%:.")
          },
          triggers: {"click @ui.apply": S(" @RSH\\")},
          events: {
            "change @ui.keepAspectRatio": function (e) {
              e.stopPropagation(), e.preventDefault(), this.model.set(S("\x14~srhXiky~jMAUKL"), this.ui.keepAspectRatio.is(S("?z\"*&'.##")))
            }, "keyup @ui.keepAspectRatio": function (e) {
              e.keyCode !== t.space && e.keyCode !== t.enter || (e.preventDefault(), e.stopPropagation(), this.ui.keepAspectRatio.prop(S("+OEKL[TV"), !this.ui.keepAspectRatio.is(S("\n1oekl{tv"))).checkboxradio(S("7J\\\\IYNV")).trigger(S("C'-')/,")))
            }, "keydown @ui.apply": function (e) {
              e.keyCode !== t.space && e.keyCode !== t.enter || this.trigger(S(">^01.:"))
            }
          }
        })
      }), CKFinder.define(S('B7!=2f\v\x02\f"")+=\x7f\x057>$97#=*u\x1e84*\x16\r\0\x05\x06K&\x14\b\x18+\x05\x13B\t\x01\x1b'), [], function () {
        return S("/\fU[E\x14VZVKJ\x07\x19_VX\x12%(o 6*6evCCw($8o3=3 'ht43?w>5p=-\x0f\x11O\x11\x01\x16\x0f\x1d\rKJ\x1f\r\x0f\x07\x01\x14\x14\nNV\x0e\rJX\x10\x0eU\b\x1c\x1c\x16neg{$.&6(tw)21!kyg,\x19\x1d)r~n9yw}nm\"\x02BIE\t@O\nK[E[\x01D@I_\x13\f\x0f\x1bQ_A\x063\x06\x14XTH\x01")
      }), CKFinder.define(S("7{r|RRY[Mo\f-'1)#4g\f.\"8\x04#.74}\x05=0!$w\x1a(4,\x1f1'6\b\x07\x14"), [S("\x15|fm|hb"), S("\x12P_S\x7fy||h4Jt{hS\x0e`BW@\tn\\LG}EHY"), S('B7!=2f\v\x02\f"")+=\x7f\x057>$97#=*u\x1e84*\x16\r\0\x05\x06K&\x14\b\x18+\x05\x13B\t\x01\x1b')], function (n, e, t) {
        "use strict";
        return e.extend({
          name: S("\fN|``S}kB|s`"),
          className: S("\x1e|KG\x0fFM\bEUGY\x07\\^L^"),
          template: t,
          ui: {
            cropBox: S("Cj&-!e,#f/?!?"),
            cropResize: S("\x176zq}1xw2CSMS\tWCTASO"),
            cropInfo: S("\x10?qxr8s~5zhtl0wqFN")
          },
          events: {
            "vmousedown @ui.cropBox": S(">P.\f-67 \x02(?'"),
            "vmouseup @ui.cropBox": S("\x1atrPqjSDwS"),
            "vmousedown @ui.cropResize": S("*DB`AZCTv\\C[yYj\\IRFX"),
            "vmouseup @ui.cropResize": S("\x17wwWtin{JPnLqAVO]M")
          },
          modelEvents: {
            change: S("=KO$ 6&\x14*5.< %%"), "change:keepAspectRatio": function () {
              if (this.model.get(S("$NCBXhY[INZ}QE[\\"))) {
                var e = this.model.get(S("\x1fRDLGAWnBANB_")), t = this.model.get(S("\x17uxbIyszzRiGJCMR")),
                  n = this.model.get(S("\x17uxbIyszzRvKGPM")), i = t - this.model.get(S("5DRV]_Ie")),
                  r = n - this.model.get(S('B1!+"":\x11'));
                i < e && (e = i);
                var o = parseInt(e * n / t, 10);
                r < o && (o = r, e = parseInt(o * t / n, 10)), this.model.set({renderWidth: o, renderHeight: e})
              }
            }
          },
          onRender: function () {
            var e;
            e = this.model.get(S("\rmn~gs`")), this.$el.css({
              width: this.model.get(S("*FMU|J^UWAc\\RCP")),
              height: this.model.get(S("\x17uxbIyszzRiGJCMR"))
            }), this.ui.cropBox.css({
              backgroundImage: S("\x14`d{0") + e.toDataURL() + ")",
              backgroundSize: this.model.get(S("\x17uxbIyszzRvKGPM")) + S("#T]\x06") + this.model.get(S("\x18t{cNxp{ESjFMBNS")) + S("?09")
            }), this.updatePosition()
          },
          onMouseDown: function (e) {
            var t = this;
            e.stopPropagation(), n(window).on(S("\x1amqrklELMUA"), {
              model: t.model,
              view: t,
              moveStart: {x: e.clientX - t.model.get(S("C6 (#-;\x12")), y: e.clientY - t.model.get(S(".]U_VVFl"))}
            }, t.mouseMove), n(window).one(S("9LVSHMZ51"), function () {
              t.onMouseUp()
            })
          },
          onMouseUp: function (e) {
            e && e.stopPropagation(), n(window).off(S("\x11d~{`eruvl~"), this.mouseMove)
          },
          mouseMove: function (e) {
            var t, n, i, r, o, s, a, l;
            t = e.data.model, n = e.data.view.ui.cropBox, i = e.clientX - e.data.moveStart.x, r = e.clientY - e.data.moveStart.y, o = n.outerWidth(), s = n.outerHeight(), i = (a = t.get(S("\x15{v`K\x7fuxxlHIEVK")) - o) < (i = i < 0 ? 0 : i) ? a : i, r = (l = t.get(S("4XWOj\\T_YOvZ)&*7")) - s) < (r = r < 0 ? 0 : r) ? l : r, t.set({
              renderX: i,
              renderY: r
            })
          },
          onMouseDownOnResize: function (e) {
            var t = this;
            e.stopPropagation(), n(window).on(S('=HR/41&)*0"'), {
              model: t.model,
              view: t,
              moveStart: {
                x: e.clientX - t.model.get(S("<O[Q$$0\x14-!2/")),
                y: e.clientY - t.model.get(S('?2$,\'!7\x0e"!."?'))
              }
            }, t.mouseResize), n(window).one(S("3BXYBK\\OK"), function () {
              t.onMouseUpOnResize()
            })
          },
          onMouseUpOnResize: function () {
            n(window).off(S("\x13bxybk|wtjx"), this.mouseResize)
          },
          mouseResize: function (e) {
            var t, n, i, r, o, s;
            n = (t = e.data.model).get(S("\x1dsvNbPLT")), i = e.clientX - e.data.moveStart.x, r = e.clientY - e.data.moveStart.y, o = t.get(S("+ALV}U_VVFb_SLQ")) - t.get(S("\x1dlzNEGQ|")), s = t.get(S("=S^8\x13'-  4\x0f- -#8")) - t.get(S("/BT\\WQGo")), r = r < n ? n : r, i = i < n ? n : i, t.get(S(".DUTBrGESTLk[OUR")) && (i = parseInt(r * t.get(S("'EHRyICJJBf[W@]")) / t.get(S("C)$>\x15-'..>\x05+&79&")), 10)), i = o < i ? o : i, r = s < r ? s : r, t.set({
              renderWidth: i,
              renderHeight: r
            })
          },
          updatePosition: function () {
            var e = this.model.get(S(":IYSZZ2\x19")), t = this.model.get(S("D7#),,8\x12")),
              n = (this.ui.cropBox.outerWidth() - this.ui.cropBox.width()) / 2;
            this.ui.cropBox.css({
              top: t + S("\x1cmf"),
              left: e + S("&WP"),
              width: this.model.get(S("A0&*!#5\x1f .?$")) - 2 * n + S("\x11bk"),
              height: this.model.get(S("\x10cw}ppd_}p}sh")) - 2 * n + S("B3<"),
              backgroundPosition: -e - n + S("\x11bk4") + (-t - n) + S("4EN")
            }), this.ui.cropInfo.text(this.model.get(S("\x0exyuf{")) + "x" + this.model.get(S("%NBANB_"))), this.ui.cropInfo.attr(S("0USGU\x18U\\^\x14JTOTJV//"), this.model.get("x") + "," + this.model.get("y"))
          }
        })
      }), CKFinder.define(S("'kblBBIK]\x1f|]WAYSD\x17|^RHtS^'$m\x17+**4g\n8$<\x19! <"), [S(';^\\]T".,&'), S("?*07&6<"), S("\x10RYU}{rrj6WtxhrzS\x0egGMQoJINO\x04xBACC\x1ef\\[Y"), S("D\x06\r\x01!'..>b\x03 4$>6'z\x1331-\x136=:;p6\b\x07\x14\x17J%\x15\x07\x19<\x02\t\x1a"), S("\x1aXW[wqDDP\fiJBRDLY\x04iIG[y\\STQ\x1a`^]NI\x14\x7fOQO\x02.:\x15- 1")], function (i, s, e, t, o) {
        "use strict";
        return e.extend({
          defaults: {name: S("\x1b_oqo"), viewClass: t, view: null, isVisible: !1}, initialize: function () {
            function e(e) {
              var t, n, i;
              i = e.get(S("A0&*!#5\x1f .?$")), n = e.get(S("-\\J^UWA|P_PPM")), t = e.get(S(".F]PUVc\\RCP")) / e.get(S(".BQI`VZQSEoP^OT")), e.set(S(")]BHYF"), parseInt(i * t, 10)), e.set(S("9R^UZVK"), parseInt(n * t, 10)), e.set("x", parseInt(e.get(S("1@VZQSE`")) * t, 10)), e.set("y", parseInt(e.get(S("\x14gsy||hB")) * t, 10))
            }

            this.viewModel = new i.Model({
              x: 0,
              y: 0,
              width: 0,
              height: 0,
              renderWidth: 0,
              renderHeight: 0,
              maxWidth: 0,
              maxHeight: 0,
              imageWidth: 0,
              imageHeight: 0,
              keepAspectRatio: !1,
              tabindex: this.get(S("=J^\"(,'!="))
            }), this.viewModel.on(S("+OEOAWT\bAQ[RRJnS_HU"), e), this.viewModel.on(S("&D@HDLI\x17\\J^UWA|P_PPM"), e), this.viewModel.on(S("\x0fsys}sp,e}w~~nE"), e), this.viewModel.on(S("#GMGIOL\x10YICJJBh"), e), this.collection.on(S("\x16~ux}~X|j~\x1aSGB@\\"), function () {
              var e, t, n, i, r, o;
              o = (e = this.get(S("\x1byywkiLCDAaGSI"))).get(S('"@EHGI')).renderingCanvas, t = s(o).width(), n = s(o).height(), i = parseInt(t / 2, 10), r = parseInt(n / 2, 10), this.viewModel.set({
                canvas: e.get(S("\x17{xwzr")).renderingCanvas,
                minCrop: 10,
                x: e.get(S(":RQ\\YZ\x17(&7,")),
                y: e.get(S("&NEHMNdHGHXE")),
                renderX: parseInt((t - i) / 2, 10),
                renderY: parseInt((n - r) / 2, 10),
                width: e.get(S("*BALIJgXVG\\")),
                height: e.get(S('@(/"# \x0e"!."?')),
                renderWidth: i,
                renderHeight: r,
                maxRenderWidth: t,
                maxRenderHeight: n,
                imageWidth: e.get(S("\x12zytqrQw|t")).width,
                imageHeight: e.get(S("3]XWP]pT]S")).height
              }), this.get(S(".YYTE")).on(S("=_O0-;"), function () {
                this.cropView()
              }, this)
            }, this), this.on(S("\fhv\x7fq\x7fv"), this.openCropBox, this), this.on(S("#GJJKIYYN"), this.closeCropBox, this);
            var t = this;

            function n() {
              t.get(S("\x0efcG{`}wzr")) && (t.closeCropBox(), t.openCropBox())
            }

            this.collection.on(S("\vxbac*cw`qa,v~m\x7fi"), n), this.collection.on(S("%SN\x12[OXEWK"), n)
          }, cropView: function () {
            var e = this.get(S('>Z$(6\n)$!"\f(>*')),
              t = e.get(S("1QRYTX")).renderingCanvas.width / this.viewModel.get(S("E+&0\x1b/%((<\x1895&;"));
            e.get(S("5UVUXT")).crop(parseInt(t * this.viewModel.get(S("\x1bnxp{ESuJ@QN")), 10), parseInt(t * this.viewModel.get(S('?2$,\'!7\x0e"!."?')), 10), parseInt(t * this.viewModel.get(S("4GSY\\\\Hc")), 10), parseInt(t * this.viewModel.get(S(")XNBIK]i")), 10)), this.collection.requestThrottler();
            var n = !1;
            e.get(S("*JOYG@^B")).forEach(function (e) {
              e.get(S("\x19ntsq")) === S("\x19Hth|jz") && (n = !n)
            }), t = (n ? e.get(S("3]XWP]q_R[UJ")) : e.get(S("\x1bup\x7fxEvKGPM"))) / this.viewModel.get(S("C)$>\x15-'..>\x1a'+$9")), e.get(S("\x13uvb~wwi")).push({
              tool: this.get(S("D+'*-")),
              data: {
                width: parseInt(t * this.viewModel.get(S("\x10cw}ppd@q}ns")), 10),
                height: parseInt(t * this.viewModel.get(S("\x16e}w~~nU{vGIV")), 10),
                x: parseInt(t * this.viewModel.get(S("\nyicjjbI")), 10),
                y: parseInt(t * this.viewModel.get(S(")XNBIK]i")), 10)
              }
            }), this.closeCropBox()
          }, openCropBox: function () {
            var e = this.get(S("/UU[G}XWP]}[O]")).get(S("\x15uvuxt")).renderingCanvas, t = s(e).width(),
              n = s(e).height(), i = parseInt(t / 2, 10), r = parseInt(n / 2, 10);
            this.viewModel.set({
              maxRenderWidth: t,
              maxRenderHeight: n,
              renderWidth: i,
              renderHeight: r,
              renderX: parseInt((t - i) / 2, 10),
              renderY: parseInt((n - r) / 2, 10)
            }), this.cropBox = new o({
              finder: this.collection.finder,
              model: this.viewModel
            }), this.cropBox.render().$el.appendTo(s(this.get(S("-KKYE{^URSsYM[")).get(S("\x15uvuxt")).renderingCanvas).parent()), this.set(S(" HQuMVOEDL"), !0)
          }, closeCropBox: function () {
            this.cropBox && this.cropBox.destroy(), this.set(S("'AZ|B_DLCU"), !1)
          }, saveDeferred: function (t, e) {
            var n, i;
            return i = (n = new s.Deferred).promise(), e.then(function (e) {
              e.crop(t.width, t.height, t.x, t.y).render(function () {
                n.resolve(this)
              })
            }), i
          }, getActionData: function () {
            return this.viewModel
          }
        })
      }), CKFinder.define(S("+XHV[\x11ryu][RRJ\x16n^QMR^4$1l\x01!/3\x01$+,)b\x1c $0&6z19#"), [], function () {
        return S('8\x05^RJ\x1d]S!21~f&-!e,#f>":.$4\x7f0;;"%75)v53.*\x14\x12@]nlZ\x05\x1d\x1d\x1e\x04\x02M\x07\vMS\x11\x18\x12X\x13\x1eU\v\x15\x0f\x1d\t\x1bRaovjgiidc~cxi/.{qs{}ppn*:ba&<tj1T@@JJAC_\bTW\t\fIO[Q\x1c[P[[\v\x15[R\\\x16NRJ^4$o/!#2eh-+?-`\',??"<\'ht,#fz2(s2>\x0e\x06L\x07\r\x17FZUIM\x07\x18\x1fI\x12\r\x1d\x17\x15\0\x0e\rHG\x04\x07\t\x15\x1a\x16\v{z=~y\'8|s4*bx#bn~v<vp|b^ux}~2oqkAUGbJQOdDFI@[D]J\x10LO\x0f\x1bWCCLVT\x0564\x02]556,*e/#uk) *`+&}#=\'5!3z;5587*7,\x05CB\x17\x05\x07\x0f\t\f\f\x12VN\x16\x15RP\x18\x06]\0\x14\x14\x1e\x16\x1d\x1f\x03\\\0\x03] ecwe(odgg7)ofh"b~fr`p;eq~ro>=z~T@\x0fJGJHWGZ\x17\tWV\x11\x0fYE\x1c_U[Q\x19\\PH\x1b\x01\0\x1e\x18,50d98*".=10sr32"85; .-h%$xe\'&c\x7f\t\x15L\x0f\x05\v\x01I\r\r\x03\x1f%\0\x0f\b\x15_\0\x1c\0\x14\x02\x12;\x15\x15\x18\x17\n\x17\fe!\x7f~8*dr|}ee2\x072 txd-\x1e')
      }), CKFinder.define(S('\x1d]TfHLGAW\tjGM_GI^\x01jTXFzYTQR\x17oS^KN\x11m/5#7!\x13/"?'), [S("B\0\x0f\x03/),,8d\x199'#\x7f\x1a7*\x17:22"), S("B\0\x0f\x03/),,8d\x1a$+8#~\x102'0y\x1e,<7\r58)"), S("2GQMB\x16{r|RRY[Mo\x15'.4)'3-:e\x0e($:\x06=056{\x079#9-?u82*")], function (t, e, n) {
        "use strict";
        return e.extend({
          name: S("!pLPDRB~@O\\"),
          template: n,
          ui: {clockwise: S("\x120w~p:}p7isi\x7fkE\fAOKFMPAZO"), antiClockwise: S('?c")%i /j:&>*8(c.>%;08:5</0)>')},
          events: {
            "click @ui.clockwise": S("8VTxPR]T7(1&"),
            "click @ui.antiClockwise": S("\x17ww[uht]sOBITMVC"),
            "keydown @ui.clockwise": function (e) {
              e.keyCode !== t.space && e.keyCode !== t.enter || this.onClockwise()
            },
            "keydown @ui.antiClockwise": function (e) {
              e.keyCode !== t.space && e.keyCode !== t.enter || this.onAntiClockwise()
            }
          },
          onClockwise: function () {
            this.model.unset(S("-BNCE`\\@TB^WW{U[Q["), {silent: !0}), this.model.set(S("$IGT\\{E_MYG@^p\\TXP"), 90)
          },
          onAntiClockwise: function () {
            this.model.unset(S("\x16{yjnIsi\x7fkINLbJBJB"), {silent: !0}), this.model.set(S("$IGT\\{E_MYG@^p\\TXP"), -90)
          }
        })
      }), CKFinder.define(S("=}t\x06(,'!7i\n'-?')>a\n48&\x1a9412w\r540.q\r\x0f\x15\x03\x17\x011\t\b\x04"), [S("?*07&6<"), S("\vnlmdr~|v"), S("\x1fcjdJJACU\x07dEOYAK\\\x1ftVZ@|[V_\\\x15oSRRLo\x15-,("), S(".l{w[]PPD\x18uV^NPXM\x10\x05%+7\r(' -f\x1c\"):=`\x02>&2 0\0>=.")], function (r, n, e, t) {
        "use strict";
        return e.extend({
          defaults: {name: S("C\x16*2&<,"), viewClass: t, view: null, rotationApplied: !1}, initialize: function () {
            var t = this;

            function e() {
              var e = t.get(S(" DFJPlKFOLnJXL")).get(S("\x1fABVJKKU"));
              e.remove(e.where({tool: t.get(S("\x10\x7fs~q"))})), t.viewModel.set(S("/Q_U_Q"), 0), t.viewModel.set(S('>S!26\x11+1\'3!&$\n"*"*'), 0)
            }

            this.viewModel = new n.Model({
              angle: 0,
              lastRotationAngle: 0,
              tabindex: this.get(S("\x15bvzpt\x7fye"))
            }), this.viewModel.on(S("+OEOAWT\b_UFBeWM[OURP~.&.&"), function (e, t) {
              this.get(S("\fhjfdX\x7frspRvlx")).get(S("@ !7-*(4")).push({
                tool: this.get(S("\x18w{vy")),
                data: t
              }), this.set(S("<OQK!5+,*\x0467$ //"), !1), this.collection.requestThrottler()
            }, this), this.collection.on(S("=JW2.67( "), function (e) {
              this.get(S("*YCYO[Y^\\rDEZ^]]")) || (e.rotate(this.viewModel.get(S("/\\PAGfZBVLPUU}SYS%"))), e.render(), this.set(S("3FZBVLPUU}MNS)$&"), !0))
            }, this), this.collection.on(S("#PJIK\x12[OXIY\x14") + this.get(S("%HFEL")), e), this.collection.on(S("2G[ZZ\rJ\\I^H\x07_S,"), e)
          }, saveDeferred: function (t, e) {
            var n, i;
            return i = (n = new r.Deferred).promise(), e.then(function (e) {
              e.rotate(t).render(function () {
                n.resolve(this)
              })
            }), i
          }, getActionData: function () {
            return this.viewModel
          }
        })
      }), CKFinder.define(S("7L\\BO\x1d~uy)/&&6j\x12\"%9&*8(=`\x155;'\x1d870=v\x1b?6(-+N\x05\r\x17"), [], function () {
        return S('*PWS\x0eFD\x1fTZXASEK\x03\x1a]UQJZ2a?>Ny".>i)\'->=rr295y0?z>06/9/|ajh^\x0f\x05\x07\x03\vH\n\x06\n\x1f\x1eSM\x13\x1a\x14^\x11\x1c[\x11\x11\x15\x0e\x1e\x0eP\x17\x1coo"vm(dsf)\x7fb!oza=xq|z8zr~m:nu0w|OO\x0fX_\x18\x06AAE^N^\x03GL__\x12NI\x17\x16QWK\x07\x19GF\x03\x1f&(.7!7h))$/k10lq+*os2<:#=+t7=?;3@\x1c\x1f_K\t\x07\x05\r\x05TaeQ\x07\x01\0\x04\x06S\x17\x19\x17\x04\vDX\x18\x17\x1bS\x1ai,djhqcu%zfbhh|-0\x7fs~q(4lc$:}uqjzR\x0fLBI@\x06ZU\v\nBH\x10\fTK\f\x12U]YBRJ\x17TZQX\x1eB=cb.-+{e32wk*$";5#|0;;0>?w722}#"BkkjDEF\n\t\x11WI\x17\x16SO\x16\x18\x1e\x07\x11\x07X\x14\x17\x17\x1c\x12\x1bS\x13\x1ex!\x7f~&%usmy7)wv3/vx~gqg8tww|r{3mkEQ\x02^Y\x07\x06QIE_N\x11\x0fUT\r\x11TZXASE\x16ZUUZTY\x11)/+7d8;eh=3;)pl=1?56v__^xyz?=)?r\x06\b\x0e\x17\x01\x17[E\x13\x12WK\n\x04\x02\x1b\x15\x03\\\x1d\x15\x18\x13W\x05\x04X[\x18\x1c\n\x1e-hljplgk5+qp1-hf|ewa:vyy~p}5uswk\0\\_\x01\x04QGEAGNNT\x10\fTK\f\x12Z@\x1bBVZPT_YE\x1eB=c|Ixj".>w@07332Z')
      }), CKFinder.define(S("\x1c^UYIOFFV\nkHL\\FN_\x02kKYE{^URS\x18nP_LO\x12\x7f[*417\x12,#0"), [S("\x10{cfqgo"), S("-LNSZP\\ZP"), S("E\x05\f\x0e $/)?a\x1994% {\x177$=v\x13/90\b6\x05\x16"), S("\x1aoyej>cjdJJACU\x07}OF\\AO[UB\x1dvP\\B~UX]^\x13|ZU526m *2")], function (r, o, e, t) {
        "use strict";
        return e.extend({
          isSliding: !1,
          applyFilterInterval: null,
          lastFilterEvent: null,
          name: S("\x1c\\zuURVuM@Q"),
          template: t,
          events: {
            "slidestart .ckf-ei-filter-slider": S("\x1epNrNJ@@uSI[^"),
            "slidestop .ckf-ei-filter-slider": S("8VThPTZZ\x135-3"),
            "change .ckf-ei-filter-slider": S("\x1fOOdJHQCU"),
            "keyup .ckf-ei-filter-slider": S("5YY~PVOYO")
          },
          initialize: function () {
            this.model.get(S("\x0ense{eqS\x7f{l|hh")).on(S("+^H]JD"), function () {
              this.render()
            }, this)
          },
          onSlideStart: function () {
            this.isSliding = !0
          },
          onSlideStop: function (e) {
            this.isSliding = !1, this.applyFilters(e)
          },
          onRender: function () {
            this.$el.trigger(S("C'7#&<,"))
          },
          onFilter: function (e) {
            var t = this;
            t.isSliding || (this.lastFilterEvent = e, this.applyFilterInterval || (this.applyFilterInterval = setInterval(function () {
              100 < Date.now() - t.lastFilterEvent.timeStamp && (t.applyFilters(t.lastFilterEvent), clearInterval(t.applyFilterInterval), t.applyFilterInterval = null)
            }, 100)))
          },
          applyFilters: function (e) {
            var t, n, i;
            i = this.model.get(S("\x14tucqo\x7f]uqjzRR")), n = r(e.currentTarget).data(S("/VX^GQG")), (t = i.where({filter: n})[0]) || (t = new o.Model({filter: n}), i.push(t)), t.set(S(" WCOQ@"), r(e.currentTarget).val())
          }
        })
      }), CKFinder.define(S("\rMDVx|wqg9Zw}owyn1ZDHVjIDAB\x07}ED@^\x01nT[G@@aYXT"), [S("\na}xk}i"), S("\x18{{xw\x7fqqE"), S("\vycjjbbq|fp"), S("\x1d]TfHLGAW\tjGM_GI^\x01jTXFzYTQR\x17mUTPN\x11k/.."), S("9ypzTP[%3m\x0e+!3+-:e\x0e($:\x06=056{\x03?2/*u\x1a87+,\x147\v\x06\x13")], function (r, o, i, e, s) {
        "use strict";
        return e.extend({
          defaults: function () {
            var t = this.collection.finder.config, e = [{
                name: S('"AVLAO\\GOX_'),
                icon: S("5U\\^\x14XIUZVK.$10"),
                config: {min: -100, max: 100, step: 1, init: 0}
              }, {
                name: S("/S^\\GFTEC"),
                icon: S("\x10ryu9vyylk{hh"),
                config: {min: -100, max: 100, step: 1, init: 0}
              }, {
                name: S("+_LZZBPFZ[["),
                icon: S("+OFH\x02CPFFFTB^WW"),
                config: {min: -100, max: 100, step: 1, init: 0}
              }, {
                name: S("\x15`~zk{u\x7fx"),
                icon: S("<^UYm7+!6$($-"),
                config: {min: -100, max: 100, step: 1, init: 0}
              }, {
                name: S("@$:3+635-"),
                icon: S("\x0el{w?vleydmk\x7f"),
                config: {min: -100, max: 100, step: 1, init: 0}
              }, {
                name: S("0YGV"),
                icon: S("\x14v}q5qo~"),
                config: {min: 0, max: 100, step: 1, init: 0}
              }, {
                name: S("%UBX@K"),
                icon: S("\x1e|KG\x0fPAUOF"),
                config: {min: 0, max: 100, step: 1, init: 0}
              }, {
                name: S("\x14rwzux"),
                icon: S("\x0fszt>st{zy"),
                config: {min: 0, max: 10, step: .1, init: 1}
              }, {
                name: S("(GEB_H"),
                icon: S("<^UYm/-*7 "),
                config: {min: 0, max: 100, step: 1, init: 0}
              }, {
                name: S("\x11q\x7f}e"),
                icon: S("9YPZ\x10]S)1"),
                config: {min: 0, max: 100, step: 1, init: 0}
              }, {
                name: S("\x13g}weh|t"),
                icon: S("\x13w~p:kq{ilxp"),
                config: {min: 0, max: 100, step: 1, init: 0}
              }, {name: S("$VRFKBhGY_"), icon: S("7[R\\\x16^QKM"), config: {min: 0, max: 20, step: 1, init: 0}}],
              n = i.filter(e, function (e) {
                return i.contains(t.editImageAdjustments, e.name)
              });
            return {name: S("&fLC_XX"), viewClass: s, view: null, filters: n}
          }, initialize: function () {
            var i = this, n = new o.Collection;

            function e() {
              var e = i.get(S("$@BN\\`GJKHjNDP")).get(S("\x14tucqvth"));
              e.remove(e.where({tool: i.get(S("(GKFI"))})), n.reset()
            }

            n.on(S("\x1azxy"), function () {
              i.collection.resetTool(S("7hK_HYIM"))
            }), i.collection.on(S("'\\FEG\x16_K\\UE\b") + i.get(S("D+'*-")), e), i.collection.on(S('7LVUW\x06O[L%5x"()'), e), n.on(S("!AKEKAB"), function () {
              var e, t, n;
              t = (n = i.get(S("\x1ezDHVjIDABlH^J")).get(S("2RWA_XVJ"))).where({tool: i.get(S("3ZT[R"))})[0], e = this.toJSON(), t || (t = new o.Model({tool: i.get(S(":U]P["))}), n.push(t)), t.set(S("4QWCY"), e), i.collection.requestThrottler()
            });
            var r = new o.Model({
              filters: this.get(S("5P^TM_IO")),
              activeFilters: n,
              tabindex: this.get(S("6CY[SUXXF"))
            });
            this.on(S("\x1axt|pxE\x1bGGMQoJINOoMYO"), function (e, t) {
              r.set(S("\rhf|t"), t.get(S("\x15p~t|")))
            }), this.collection.on(S("<IVM/56/!"), function (t) {
              n.length && n.clone().forEach(function (e) {
                t[e.get(S("@'+/0 4"))](parseFloat(e.get(S("\x18o{wix"))))
              })
            }), this.viewModel = r, this.activeFilters = n
          }, getActionData: function () {
            return this.viewModel
          }, saveDeferred: function (e, t) {
            var i = new r.Deferred, n = i.promise();
            return t.then(function (n) {
              r.each(e, function (e, t) {
                n[t.filter](parseFloat(t.value))
              }), n.render(function () {
                i.resolve(this)
              })
            }), n
          }
        })
      }), CKFinder.define(S("\x11fvla7TS_suxxl0tDOSHDRB[\x06oOEYgBQVW\x1cdGSD]MI\x15XRJ"), [], function () {
        return S("#_^X\x07A]\x04[^H]JDB\b\x13DGSD]M\x1aFA7\x02]556,*e%+):9vn.%)}4;~$'3$=-x{8<*>M\x11\x10\x06\x17\0\x12ZJ\x12\x11VL\x1d\x1c\n\x03\x14\x06]\x1a\x14\x1b\x12X\x04\x07Y\\\t\x1f\x1dioff|8$|s4*bx#znrx|wqm6je;$\x11\x15!wrG\x01AOEVU\x1a\nJAM\x01HG\x02@CW@QA\x1bGJ\\LRYJ\x1c\x1f!-6~f>=zh98.?(:a<0068u+*zyue|&%b@\x11\x10\x06\x17\0\x12I\x04\b\b\x0e\0M\x13\x12zM]\x11\x01\x01\x02\x18\x16Gp\0\x07\x03\x03\x02\n")
      }), CKFinder.define(S("\x11QXR|xs}k5VsyksER\rf@LRnEHMN\x03{GJGB\x1dcFPERLJlRYJ"), [S("(\\DOI_]L_CW"), S("<WOJ%3;"), S("E\x05\f\x0e $/)?a\x1a$8>|\x1f0/\x147=?"), S("#gn`NFMOY\x03{GJGB\x1dqUFS\x18qM_VjT[H"), S("6C]AN\x1a\x7fvxV.%'1k\x11#*8%+?)>a\n48&\x1a9412w\t(>/8*,N\x05\r\x17")], function (t, l, n, e, i) {
        "use strict";
        return e.extend({
          name: S('B\x136 5"<:\x1c"):'),
          template: i,
          events: {
            "click .ckf-ei-preset": S('"LJuTB[L^'), "keydown .ckf-ei-preset": function (e) {
              e.keyCode !== n.space && e.keyCode !== n.enter || this.onPreset(e)
            }
          },
          onRender: function () {
            var i, n, e = this.model.get(S("\x12u}ys"));
            this.finder.config.initConfigInfo.thumbs && (t.forEach(this.finder.config.initConfigInfo.thumbs, function (e) {
              var t = parseInt(e.split("x")[0]);
              !n && 240 <= t && (n = t)
            }), n && (i = this.finder.request(S("\x11tzxp,p}mNsip|"), {file: e})));
            i && this.finder.config.initConfigInfo.thumbs || (i = this.finder.request(S(",DCNWT\bCFP@^]NoIP"), {
              file: e,
              maxWidth: 240,
              maxHeight: 80,
              noCache: !0
            }));
            var r = this.model.get(S("\x16Tyt{u")), o = t.uniqueId(S(",NEI\x1d")),
              s = l(S('"\x1fGDHQIZ\x14')).attr(S("\x1buy"), o).attr(S("8NS_HU"), 240).attr(S("\fekfwyf"), 240).css(S("@%+04)'>"), S("#JJHB")).appendTo(S("6UW]C")),
              a = this.$el.find(S("\x1c3}tF\fGJ\tUTB[L^")).toArray();
            !function e() {
              if (a.length) {
                var t, n;
                t = l(a.shift()), n = t.data(S("\x17hk\x7fhyi")), r("#" + o, i, function () {
                  this.revert(!1), this[n]().render(function () {
                    t.find(S("\fdch")).attr(S("B06&"), this.toBase64()), e()
                  })
                })
              } else s.remove()
            }()
          },
          onPreset: function (e) {
            this.model.set(S("\x1az\x7fiwiE"), l(e.currentTarget).data(S("1BAQFSC")))
          }
        })
      }), CKFinder.define(S("\x13W^P~v}\x7fi3Pq{UMGP\v`BN\\`GJKH\x01{_^^@\x1beDRK\\NHhRQS"), [S("B)50#51"), S("\x13a{rrjjytnx"), S("\x1d|~CJ@LJ@"), S(":xw{WQ$$0l\t*\"2$,9d\t)';\x19<341z\x02875)t\b213"), S("\x0eL[W{}ppd8Uv~npxm0eEKWmHG@M\x06|BIZ]\0`CW@QAEaQ\\M")], function (r, i, t, e, o) {
        "use strict";
        return e.extend({
          defaults: function () {
            var t, e, n;
            return t = this.collection.finder.config, e = [{name: S("4VZVJPNB")}, {name: S("\x1c~qqCDLWVDRB")}, {name: S("\nh~b}|@c}pqfe")}, {name: S("9]WSJWQ'\x127-")}, {name: S("?'37-#<")}, {name: S("\x17px`bX|gl")}, {name: S("1ZVY\\XPOXC")}, {name: S("\x11zvfXw}}jnb")}, {name: S("C.$46=,9")}, {name: S("\x1cqqrO")}, {name: S("2_[CS")}, {name: S("\x1dppSUCOCLG")}, {name: S("'GENiCBZ")}, {name: S("-A]Q_UVdPS[")}, {name: S("\v|d`g\x7f}w")}, {name: S("/CX\\p]AO")}, {name: S("/CD\\A]FS")}, {name: S("*]ECZNWT")}], n = i.filter(e, function (e) {
              return i.contains(t.editImagePresets, e.name)
            }), {name: S(",}\\JCTF@"), viewClass: o, view: null, presets: n}
          }, initialize: function () {
            var i = this, n = new t.Model({
              Caman: this.get(S("C\x07$+&&")),
              active: null,
              presets: this.get(S("9JIYN[K3")),
              tabindex: this.get(S("\x1fT@@JJAC_"))
            });

            function e() {
              var e = i.get(S('=[[)5\v.%"#\x03)=+')).get(S("\x1az\x7fiwpNR"));
              n.set(S("\x12rwa\x7fa}"), null), e.remove(e.where({tool: i.get(S("\x0eaq|w"))}))
            }

            n.on(S("+OEOAWT\bRWA_A]"), function (e, t) {
              var n;
              t && (i.collection.resetTool(S("\x1b]ytjSU")), (n = i.get(S("\x1a~xtjVM@EF`DRF")).get(S("\vmnzf\x7f\x7fa"))).remove(n.where({tool: i.get(S("4[WZ]"))})), n.push({
                tool: i.get(S("\x12}uxs")),
                data: t
              }), i.collection.requestThrottler())
            }), i.collection.on(S("\vxe|`de~v"), function (e) {
              var t = i.viewModel.get(S("D$%3!?/"));
              t && e[t]()
            }), i.collection.on(S("7LVUW\x06O[L%5x") + i.get(S("-@N]T")), e), i.collection.on(S("$QIHD\x13XN_HZ\x15Q]^"), e), this.on(S('7[Q[U[X\x04Z$(6\n)$!"\f(>*'), function (e, t) {
              n.set(S("D#/+-"), t.get(S("B%-)#")))
            }), this.viewModel = n
          }, saveDeferred: function (t, e) {
            var n, i;
            return i = (n = new r.Deferred).promise(), e.then(function (e) {
              e[t]().render(function () {
                n.resolve(this)
              })
            }), i
          }, getActionData: function () {
            return this.viewModel
          }
        })
      }), CKFinder.define(S("'\\LR_\rneiY_VVF\x1abRUIVZHXM\x10\x05%+7\r(' -f\x18.?$4*~5='"), [], function () {
        return S("\f1jff1q\x7fufe*:ls6{ow{\r@\0\x1d.,\x1aCA_\nH@L]\\\r\x13QXR\x18S^\x15K_HUG[\x12#.,76**4e $;99=mn[[Zh<8'--z5=0;bB\x02\t\x056\0\x15\x0e\x12\f=\x02\b\x19\x06MP\x07\x13\x1f\x01\x10KU\x03\x02G[\x15\tP\x1birroe|Qnl}b+qp,/dppzzqso%;a`!=wk\x0eUCAMKBBP\tWV\x0e\x13$&9\rB\x13WYWDK\x04\x18XW[\x13Z)l0&7,<\"e*%%8?!##|&6,!ti eu+bWWV\\\b\f\x13\x11\x11F\t\t\x04\x0fVN\x0e\x05\t\"\x14\x01\x1a\x0e\x10>\x12\x11\x1e\x12\x0f^]\b\x1eltg>&~}:(`~%hd}\x7f|pk[q|q\x7fl9gf>=j~BHLGA]\x1b\x05SR\x17\vEY\0[QS[]PPN\x17ED\x18\x05647\x030a!/%65zj*!-a('b\"4!:.0{477.)31-r\x14\x04\x1a\x17F[\x1d\x1cUI\x03\x1fB\x01\x0f\x01\x17_\x07\x1d\x1d\x01\x05Y\b\x10\x02\x1e\x10.\x16\x10ru\x7f~8*v9\x02\x006$hdx1\x1a-=w}c(\x1d$u{yyq \x15)ZY\x1e\x04LR\tDHDL\x02HJFDx_RSP\x18\\]\\JzOM[\\4\x13#7-*f:5CCw%#>:$q&*$0ku;1?87?1'BA\x16\x02\x06\f\b\x03\r\x11WI\x17\x16SO\x19\x05\\\x07\x15\x17\x1f\x19\x1c\x1c\x02[\x01\0\\_n`of9'eln[oxewkDutbRgestlK{our<?[Z\x1d\x03MQ\bLMLZj_]KLDcSG]Z\x16JEZR^_V[[}c!+!&-\",k10s03o40&2y<586)5(a\x7f%$_A\v\x17J\t\x07\t\x0fG\x0e\x02\x1eMSRPV\x1e\x07\x06R\v\n\x14\x1c\x1c\x0f\x07\x06A@}|pjcmr|s6wv.3\x043?}sqqy(\x1d${oohrp?IE\x1f\x01GN@\nM@\x07YI^GUU\x1cSCDYO\x15\x18M[YUSZZ8|`8?xf.<g>*.$ +5)r.)wv39-;v5>11]C\x01\b\x02H\x12\x0e\v\x02HK\b\f\x1a\x0e]\x18\x11\x1c\x1a\x05\x19\x04E[\x01\0C]\x17\v.mcmc+bnz)76,*b{b6onxppccb%$a`lvGIVX_\x1a[Z\n\x17QP\x11\rG[\x1e]S]S\x1bSSQMsV]Z[\x11!12/=e;:tf(>89!!n[")
      }), CKFinder.define(S("7{r|RRY[Mo\f-'1)#4g\f.\"8\x04#.74}\x05=0!$w\v?(5';\t\t\x04\x15"), [S('@\x02\t\x05-+"":f\x1f?%!a\x045(\x11<00'), S("<~uy)/&&6j\x10.->9d\x0e,=*\x7f\x18&69\x03?2/"), S("\x16c}an:_VXvNEGQ\vqCJXEK_I^\x01jTXFzYTQR\x17k_HUG[\x11$.6")], function (t, e, n) {
        "use strict";
        return e.extend({
          name: S("5dRKP@^jT[H"),
          template: n,
          className: S("*HGK\x03JY\x1c@VG\\LR\x15ZUUHOQS3"),
          ui: {
            width: S('6^VIOOgS_R%|` /#\x14"; 0.\x1b$*;8s\x0f'),
            height: S("@(,311\x1d))$/vn.%)\x024!:.0\x1e21>2/~\0"),
            keepAspectRatio: S("\x11{}d`bLvxw~!?}tFsGPM_ClMLZj_]KLDcSG]Z\x14j"),
            apply: S("'\vJAM\x01HG\x02BTAZNP\x1bVHIVB")
          },
          triggers: {"click @ui.apply": S('B"45*>')},
          events: {
            "change @ui.width": S("7WWmRXIV"),
            "change @ui.height": S("4ZX\x7f]P]SH"),
            "change @ui.keepAspectRatio": S("0^\\rGESTLk[OUR"),
            "keyup @ui.keepAspectRatio": function (e) {
              e.keyCode !== t.space && e.keyCode !== t.enter || (e.preventDefault(), e.stopPropagation(), this.ui.keepAspectRatio.prop(S("-MGURYVP"), !this.ui.keepAspectRatio.is(S("#\x1eFNBKBOO"))).checkboxradio(S("\x10cwufpe\x7f")).trigger(S("\x1fCICMC@")))
            },
            "keydown @ui.apply": function (e) {
              e.keyCode !== t.space && e.keyCode !== t.enter || this.trigger(S("\x1azlmrf"))
            }
          },
          modelEvents: {
            "change:realWidth": S("9H^RY[M"),
            "change:displayWidth": S("(ZO_{DJ[X"),
            "change:displayHeight": S("/CTF{Q\\Q_L")
          },
          onRender: function () {
            this.$el.trigger(S("9YIY\\JZ"))
          },
          onAspectRatio: function () {
            var e = this.ui.keepAspectRatio.is(S("\r4lxtqxqq"));
            this.model.set(S("+GHK_qBBVWAdVLPU"), e), e && this.onWidth()
          },
          onWidth: function () {
            if (!this.dontRender && !(this.model.get(S("\rjfca~rmB\x7fslq")) < 0)) {
              var e = parseInt(this.ui.width.val(), 10);
              (isNaN(e) || e <= 0) && (e = 1);
              var t = this.model.get(S("\x19h~}qIvDUJ"));
              t < e && (e = t);
              var n = this.model.get(S('>[)22/%<\x0e"!."?'));
              if (this.model.get(S(" JGFTdUWMJ^yMYG@"))) {
                var i = t / this.model.get(S("-\\JQ]zV]R^C"));
                n = parseInt(e / i, 10)
              }
              n <= 0 && (n = 1), this.updateSizes(e, n)
            }
          },
          onHeight: function () {
            if (!this.dontRender && !(this.model.get(S("\noe~~cqhZv}r~c")) < 0)) {
              var e = parseInt(this.ui.height.val(), 10), t = this.model.get(S("!PFEInBANB_"));
              (isNaN(e) || e <= 0) && (e = 1), t < e && (e = t);
              var n = this.model.get(S("1VZGEZVAnS_HU"));
              if (this.model.get(S("&LMLZj_]KLDcSG]Z"))) {
                var i = this.model.get(S("([OJ@zGKDY")) / t;
                n = parseInt(e * i, 10)
              }
              n <= 0 && (n = 1), this.updateSizes(n, e)
            }
          },
          updateSizes: function (e, t) {
            this.model.set({
              displayWidth: e,
              displayHeight: t
            }), this.dontRender = !0, this.ui.width.val(e), this.ui.height.val(t), this.dontRender = !1
          },
          setWidth: function () {
            this.ui.width.val(this.model.get(S("A&*75*&1\x1e#/8%")))
          },
          setHeight: function () {
            this.ui.height.val(this.model.get(S("\fig|`}sj\\p\x7fppm")))
          },
          focusButton: function () {
            this.ui.apply.focus()
          }
        })
      }), CKFinder.define(S("\x12P_S\x7fy||h4QrzjLDQ\faAOSaDKLI\x02z@_]A\x1cfPE^B\\nTSQ"), [S("%LV]LXR"), S("&EIJAICCK"), S("\x1fcjdJJACU\x07dEOYAK\\\x1ftVZ@|[V_\\\x15oSRRLo\x15-,("), S('A\x01\b\x02,(#-;e\x06#);#5"}\x160<"\x1e58=>s\v7:\x17\x12M1\x01\x16\x0f\x1d\r?\x03\x0e\x1b')], function (r, e, t, n) {
        "use strict";
        var i = e.Model.extend({
          defaults: {
            realWidth: -1,
            realHeight: -1,
            displayWidth: -1,
            displayHeight: -1,
            renderWidth: -1,
            renderHeight: -1,
            maxRenderWidth: -1,
            maxRenderHeight: -1,
            keepAspectRatio: !0
          }
        });
        return t.extend({
          defaults: {name: S(")xN_DTJ"), viewClass: n, view: null}, initialize: function () {
            this.viewModel = new i({tabindex: this.get(S("E2&* $/)5"))}), this.collection.on(S("\x19sv}z{[AUC\x19V@GCQ"), function () {
              var e = this.get(S("/UU[G}XWP]}[O]"));
              this.viewModel.set({
                realWidth: e.get(S("4\\[V_\\mRXIV")),
                realHeight: e.get(S(",DCNWTzV]R^C")),
                displayWidth: e.get(S("8PWZ[XiV$5*")),
                displayHeight: e.get(S("E/*)./\x03)$)'$")),
                renderWidth: e.get(S("<O[Q$$0\x14-!2/")),
                renderHeight: e.get(S("\f\x7fkatt`[q|q\x7fl")),
                maxRenderWidth: e.get(S("*YICJJBf[W@]")),
                maxRenderHeight: e.get(S(",_KATT@{Q\\Q_L"))
              }), this.get(S("A4*!2")).on(S("=_O0-;"), function () {
                this.resizeView()
              }, this)
            }, this), this.collection.on(S("\x1ekONN\x19V@UB\\\x13KG@"), function () {
              var e, t;
              t = (e = this.get(S("\x1cxzvThOBC@bF\\H"))).get(S("\x18pwz{xWqFN")), this.viewModel.set({
                realWidth: t.width,
                realHeight: t.height,
                displayWidth: t.width,
                displayHeight: t.height,
                renderWidth: e.get(S("&UMGNN^zGKDY")),
                renderHeight: e.get(S("D7#),,8\x03)$)'$")),
                maxRenderWidth: e.get(S('"QAKBBZ~COXE')),
                maxRenderHeight: e.get(S("\x10cw}ppd_}p}sh"))
              })
            }, this)
          }, resizeView: function () {
            var e, t, n, i = this.viewModel, r = this.get(S("\x0fuu{g]xwp}]{o}")), o = i.get(S("&CAZZGMTyFTEZ")),
              s = i.get(S("\x0ftxacxto_}p}sh")), a = i.get(S("2^UMdRV]_IkTZK(")),
              l = i.get(S("\x12~umDrv}\x7fiTxwxHU"));
            l < s || a < o ? (e = o < s ? l / s : a / o, t = parseInt(e * s, 10), n = parseInt(e * o, 10)) : (n = o, t = s), i.set({
              realWidth: o,
              realHeight: s
            }), r.get(S(":Z_IWP.2")).push({
              tool: this.get(S("D+'*-")),
              data: {width: o, height: s}
            }), r.set({imageWidth: o, imageHeight: s}), r.get(S("2PUXWY")).resize({
              width: n,
              height: t
            }), this.collection.requestThrottler(), this.get(S(";JT[H")).focusButton()
          }, saveDeferred: function (t, e) {
            var n = new r.Deferred, i = n.promise();
            return e.then(function (e) {
              e.resize({width: t.width, height: t.height}).render(function () {
                n.resolve(this)
              })
            }), i
          }, getActionData: function () {
            return this.viewModel
          }
        })
      }), CKFinder.define(S("7{r|RRY[Mo\f-'1)#4g\f.\"8\x04#.74}\x07;::$"), [S("B6*!#5;*%9)"), S("2YE@SEA"), S("@## /'))-"), S("\x13W^P~v}\x7fi3Pq{UMGP\v`BN\\`GJKH\x01{_^^@\x1bvDXHmUTP"), S("*hgkGATT@\x1cyZRBT\\I\x14yYWK\t,#$!j\x12('%9d\x1e\":.$4\x06<;9"), S("\x1b_VXvNEGQ\vhIC]EOX\x03hJFDx_RSP\x19cWVVH\x13|ZU526\x17+**"), S("\x17[R\\rry{m\x0flMGQICT\x07lNBXdCNWT\x1dg[ZZD\x17iH^OXJL\x14.-/"), S(".l{w[]PPD\x18uV^NPXM\x10\x05%+7\r(' -f\x1e$#!=`\x024!:.0\x02875")], function (u, c, e, a, l, d, f, h) {
        "use strict";
        return e.Collection.extend({
          initialize: function () {
            this.needRender = !1, this.isRendering = !1, this.on(S("\x13uqr"), function (e) {
              e.set(S("\x16yyt\x7f"), e.get(S("5BXWU")).get(S("1\\RYP")))
            })
          }, setupDefault: function (t, e) {
            this.finder = t, this.Caman = e;
            var n = 40;
            this.add({
              title: t.lang.editImage.resize,
              icon: S("B /#k5-:#1)"),
              tool: new h({tabindex: n}, {collection: this}),
              tabindex: n
            }), this.add({
              title: t.lang.editImage.crop,
              icon: S("\x15u|~4yism"),
              tool: new a({tabindex: n += 10}, {collection: this}),
              tabindex: n
            }), this.add({
              title: t.lang.editImage.rotate,
              icon: S("D&-!e;%?-9+"),
              tool: new l({tabindex: n += 10}, {collection: this}),
              tabindex: n
            });
            var i = t.config.editImageAdjustments;
            if (i && i.length) {
              var r = new d({tabindex: n += 10}, {collection: this});
              this.add({
                title: t.lang.editImage.adjust,
                icon: S(",NEI\x1dPVYAFB"),
                tool: r,
                tabindex: n
              }), u.forEach(r.get(S("\x16qqun~nn")), function (e) {
                e.label = t.lang.editImage.filters[e.name]
              })
            }
            var o = t.config.editImagePresets;
            if (o && o.length) {
              var s = new f({Caman: e, tabindex: n += 10}, {collection: this});
              this.add({
                title: t.lang.editImage.presets,
                icon: S("C'. j8;/8)9="),
                tool: s,
                tabindex: n
              }), u.forEach(s.get(S("\x14edrk|nh")), function (e) {
                e.label = t.lang.editImage.preset[e.name]
              })
            }
            return this
          }, setImageData: function (t) {
            (this.editImageData = t).on(S("6TPXT\\Y\x07LZ.%'1\f /  ="), function () {
              this.checkReady()
            }, this), this.forEach(function (e) {
              e.get(S("%RHGE")).set(S("\x0ejtxfZytqr\\xnz"), t)
            })
          }, setImageInfo: function (e) {
            this.editImageData.set(S('A+.%"#\x0e&/%'), e), this.editImageData.set(S("7QT[\\YjW[4)"), e.width), this.editImageData.set(S("4\\[V_\\r^UZVK"), e.height), this.checkReady()
          }, checkReady: function () {
            this.editImageData && this.editImageData.has(S(" HOBC@oINF")) && this.editImageData.has(S("6E]W^^NjW[4)")) && this.trigger(S("\x1bup\x7fxEeCWE\x1fTBIMS"))
          }, resetTool: function (e) {
            var t;
            e ? this.trigger(S("\x1ciqpL\x1bPFW@R\x1d") + e) : (this.trigger(S("0E]\\X\x0fDRK\\N\x01]QR")), (t = this.editImageData.get(S("\x1c~\x7frAO"))).reset(), t.render(), this.editImageData.get(S("=_\\4(--7")).reset()), this.trigger(S("\x15bxwu iyn{k\x1a@DWAW"))
          }, doSave: function (e) {
            var i = this, t = u.uniqueId(S("6R\\PN\x16UP_X%l!\"*3'4")),
              r = c(S('"\x1fGDHQIZ\x14')).attr(S("\x1ctz"), t).css(S("\vhd}\x7f|pk"), S("\x1fNNLF")).appendTo(S("9XTXD")),
              o = this.editImageData.get(S("0PQG]ZXD")), n = this.Caman, s = new c.Deferred, a = new c.Deferred,
              l = s.promise();
            return n("#" + t, e, function () {
              var e = this, t = o.findWhere({tool: S("\x1aZxwklT")});
              t && (o.remove(t), o.push(t));
              var n = o.findWhere({tool: S("E\x165-:/??")});
              n && (o.remove(n), o.push(n)), o.forEach(function (e) {
                var t = this.findWhere({name: e.get(S("/D^]_"))}).get(S(",YA@\\"));
                l = t.saveDeferred(e.get(S("*OMYO")), l)
              }, i), l.then(function () {
                a.resolve(e.toBase64()), r.remove()
              }), s.resolve(e)
            }), a.promise()
          }, requestThrottler: function () {
            var t = this;
            this.needRender = !0, this.throttleID || (this.throttleID = setInterval(function () {
              if (t.needRender && !t.isRendering) {
                t.isRendering = !0;
                var e = t.editImageData.get(S("D&'*)'"));
                try {
                  e.revert(!1)
                } catch (e) {
                }
                t.trigger(S(" UJQKQRKM"), e), e.render(function () {
                  return !1
                }), t.isRendering = !1, t.needRender = !1
              }
            }, 200))
          }, destroy: function () {
            this.throttleID && clearInterval(this.throttleID)
          }, hasDataToSave: function () {
            return !!this.editImageData.get(S("E'$< %%?")).length
          }
        })
      }), CKFinder.define(S("\x12P_S\x7fy||h4_rsrOO\rnKACK[\x06zYCJ\\JCB\x7f\\PPZ"), [S("7ZXYP^RPZ")], function (e) {
        "use strict";
        return e.Model.extend({
          defaults: {state: S("7WR"), message: "", value: 0}, stateOk: function () {
            this.set(S(":HH\\JZ"), S("\x1atw"))
          }, stateError: function () {
            this.set(S(" RVBP@"), S("?%30,6"))
          }, stateIndeterminate: function () {
            this.set(S("!QWEQC"), S("\x1arry{kESOJJDRB"))
          }
        })
      }), CKFinder.define(S("\x18ZQ]uszzR\x0eoL@PJB[\x06oOEYgBQVW\x1cyZRRTJ\x15kNRYM%21\x0e+!#+"), [S(")i`jD@KUC\x1dp[X[XV\x16wTXXRLo\x110,#7#4;\x04%/)!")], function (e) {
        "use strict";
        return e.extend({
          defaults: {
            value: 0,
            state: S("8VQ"),
            message: "",
            eta: "",
            speed: "",
            bytes: 0,
            bytesTotal: 0,
            time: 0,
            transfer: ""
          }, initialize: function () {
            this.on(S("\x1e|H@LDA"), function (e) {
              var t, n;
              if (e.changed.time && (t = e.previous(S("\x16cqt\x7f")))) {
                var i = e.get(S("A6*) ")) - t;
                n = ((e.get(S("\x1ayei{l")) - e.previous(S("8[COYN"))) / i).toFixed(1), this.set({
                  eta: ((e.get(S("!@ZP@UsG]KG")) - e.get(S("\niuyk|"))) / (100 * n)).toFixed(),
                  speed: n
                })
              }
            })
          }
        })
      }), CKFinder.define(S("\x0e{uif2W^P~v}\x7fi3I{rPMCWAV\tdGDGDB\x02~]_V@VGF\x18SWM"), [], function () {
        return S('\x14)r~n9yw}nm"\x02BIE\tUTHO[OX_\0CJCBSTQ\x15ML\x07\x19\x1bRH\x13SZ32#$!e;:+",f$$*+5?)(k(+uf"!f|4*q\r\x04\x11\x10\x05\x02\x03G\x15\x14VD\b\x04\x18QzM\x16\x1a\x02U\x15\x1b\x19\n\tF^\x1e\x15\x19-qplcwct{$}ym}.l{w?cfzqe}ji6gf#?IU\fPPDRB\bTW\t\f_ACU\f\x10CFZQE]JIY]O\x1c\x1f!3+"i3\'+=,$$;pl4+lr: { 64,?{! |\x7f\x01\x13\v\x02I\x13\x07\v\x1d\f\x07\x02\x02PL_RQ\x13\x01\x1d\x14[\x01\x19\x15\x0f\x1e\x11\x1c\x06B"023&;\f\x0e4mc},nbncb/1w~p:hku|nxml\rCCQ\x06\x05USQEO\x16\x0eZGKDY\bHO\b\x16^L\x17LZPH[\x1f=<gxfex{g-#=rGr`48$m^')
      }), CKFinder.define(S("\x1aXW[wqDDP\fgJKJGG\x05}EHY\\\x1fa@\\SGSDKoS^K"), [S("*hgkGATT@\x1cb\\S@K\x16xZOX\x11v4$/\x15- 1"), S("?4$:7e\x06\r\x01!'..>b\x1a*=!>2 0%x\x1b67633q\x0f\x12\x0e\x05\x11\x01\x16\x15I\f\x06\x1e")], function (e, t) {
        "use strict";
        return e.extend({
          name: S("\x0e_b~uaqfeAq|m"),
          template: t,
          className: S(")I@J\0^]_V@VGF"),
          modelEvents: {
            "change:message": S("0DBWUASz]JIZ[X"),
            "change:state": S("0DBWUASdLXN^"),
            "change:value": S(';IMZ^4$\x14"(0#')
          },
          ui: {
            bar: S('Eh$#/g;>")=5"!~64$'),
            message: S("\x10?qxr8few~h~on3rERQBC@"),
            wrap: S("/\x1eRYU\x19EDX_K_HO\x10IM!1")
          },
          onRender: function () {
            this.$el.trigger(S("!AQADRB"))
          },
          updateMessage: function (e, t) {
            this.ui.message.text(t).toggleClass(S("4V]Q\x15QS_XXP"), !t)
          },
          updateState: function (e, t) {
            this.ui.wrap.toggleClass(S("<^UYm10,#7#4;d% "), t === S("'GB")).toggleClass(S('@")%i54(/;/8?`+="> '), t === S("=[M2.0")).toggleClass(S("8ZQ]\x11MLP'3'07h/),,>.> '!1%7"), t === S('B**!#3-;\'"",:*'))
          },
          updateValue: function (e, t) {
            this.isDestroyed || (this.ui.bar.css({width: t + "%"}), this.ui.wrap.attr(S("\x18xhr}0h~LTGMKR"), t))
          }
        })
      }), CKFinder.define(S("\x1ci{gT\0ahbLHCM[\x05\x7fI@^CQEW@\x1bpR^LpWZ[X\x11o2.%1!65\x03!(&$+c* $"), [], function () {
        return S(",\x11JFF\x11[W\t\x17U\\^\x14_R\x11MLP'3'07gx{g-#=rGr+9'r084%$e{90:p;6M\x15\x10\x02\n\x16\0\x02\x1aKT\x10\x17PN\x06\x04_\x06\x01\x15\x1b\x05\x11\x1d\vZ\x06\x01AQ\x1biw<\t\x0e")
      }), CKFinder.define(S("\x1c^UYIOFFV\nkHL\\FN_\x02kKYE{^URS\x18nP_LO\x12nM/&0&76\x02.)%%,\x1a$+8"), [S("\x15cy||hh\x7frlz"), S("0[CFQGO"), S('<~uy)/&&6j\x10.->9d\x0e,=*\x7f\x1d3*; "\x011<-'), S("%eln@DOI_\x01l_\\_\\Z\x1a`^]NI\x14lOQX2$10\x12,#0"), S("\fykwd0QXR|xs}k5OypnsAUGP\v`BN\\`GJKH\x01\x7fB^UAQFEsQXVT[\x13ZP4")], function (e, t, n, i, r) {
        "use strict";
        return n.extend({
          name: S("<xZV4\b/\"# \x165'.8.?>\n&1==4\x02<3 "),
          template: r,
          regions: {progress: S("Df%,.d/\"a=< 7#7 '")},
          ui: {transfer: S("\x1d0|KG\x0fFM\bRUIGYMI_")},
          modelEvents: {change: S("\n~|io{uE`rzfprj")},
          onRender: function () {
            this.$el.trigger(S(".LBTSGQ")), this.progress.show(new i({finder: this.finder, model: this.model}))
          },
          updateTransfer: function () {
            this.ui.transfer.text(this.model.get(S(":ON\\PL&$0")))
          }
        })
      }), CKFinder.define(S("\x13W^P~v}\x7fi3Pq{EMQ\fbLJB"), [S("A \"'.$(&,")], function (e) {
        "use strict";
        return e.Model.extend({
          defaults: {name: "", date: "", size: -1, folder: null, "view:isFolder": !1},
          initialize: function () {
            this._extenstion = !1, this.on(S("0RZRZRS\rVXW^"), function () {
              this._extenstion = !1
            }, this)
          },
          getExtension: function () {
            return this._extension || (this._extenstion = this.constructor.extensionFromFileName(this.get(S("\x18w{vy")))), this._extenstion
          },
          getUrl: function () {
            if (!this.has(S("A71("))) {
              var e = this.get(S("1T\\XQSE")).getUrl();
              this.set(S("\x19oip"), e && e + encodeURIComponent(this.get(S("\x13zt{r"))), {silent: !0})
            }
            return this.get(S("\fx|c"))
          },
          isImage: function () {
            return this.constructor.isExtensionOfImage(this.getExtension())
          },
          refresh: function () {
            this.trigger(S("!PFBWCT@"), this)
          }
        }, {
          invalidCharacters: S(";6a\x1e\x10`{bidzfehujul1"), noExtension: S("B-+\x1a#?<"), isValidName: function (e) {
            return !/[\\\/:\*\?"<>\|]/.test(e)
          }, isExtensionOfImage: function (e) {
            return /jpeg|jpg|gif|png/.test(e.toLowerCase())
          }, extensionFromFileName: function (e) {
            var t = e.lastIndexOf(".");
            return -1 === t ? "" : e.substr(t + 1)
          }, trimFileName: function (e) {
            var t = e.lastIndexOf(".");
            return t < 0 ? e.trim() : e.substr(0, t).trim() + "." + e.substr(t + 1).trim()
          }
        })
      }), CKFinder.define(S('\x17l|bo=^UYIOFFV\nrBEYFJXH]\0uU[G}XWP]\x16yTR[WM-\x05+"(*!i,&>'), [], function () {
        return S("\vwv1/1xf={{znWo\x7fikowkE\x01_^\x18IGEME\x14!\f\r\x0e\x0fKJ\x0f\x13]A\x18[YW]\x15YYWK\t,#$!k5&>,\x0e\"-!!(\x1f'7!#'?#=y'&VTb6\x0e\x11\x17\x17D\x11\x07\x05\x01\x07\x0e\x0e\x14PL^RQ\x06\n\x04\x10KU\x1b\x11\x1f\x18\x17\x1f\x11\x07\"!lbi`;%kblNhdzF}puv[cseoksoy?>d[\x1e\x02JP\vIQM[]YEYK\x0fMLQ[QV]R\\\x04\x18XTX]T%%`8?z;:vCvd ,,*<oX(/j+*Re>2*}=3\x01\x12\x11^F\x03\x0f\v\r\x07\v\x06\t@\x07\x01\0\x04\x06^\x15\x07\x13\x16ZY\x01\0C]\x17\v.ntfvrtn|l*vq~zv|t/1p|egtxc!rrpz\x02\x01CQMD\vOAMNNB\x10\f[BDW\x11ON\tJE\x070\x1b\x1c\x1d\x1eD;|b*0k*&&.d.($:\x06=056z&7!=\x1d3:029\f\x01\x17\x07\"\x17E\x1b\x1abIJKLQ\n\x06\x06OxSTUVWXYZG\x0f\r\x1f\x11 bnbwv;%n`fnblcj=tjgq{e~ww7w}\x7f{s\x02\x1f\fX_\x04\x06N\\\x07OSXH@\\Y^\\\x13IH\n\x18KI[U\x027\x1e\x1f`abcdez#!?j( ,=<ms':y<8'--w/9%*\x7f\x15\bO\x01\v\x01\x1fJ\x01\x07\x02\x0e\x1e\x04\x1aO\x05\x18_\x10\x1b\x07\x18\x12\nT\x1b\x17\x10]\v\x16-rjb`jq*agynx/0\x050123\x1d\x1c*~vioo<i\x7f}IOFF\\\x18\x04\x16\n\tNJXL\x03J^YS]WPR\n\x1aMHNY\x1f\x1eK91'~f1#?<kj%- +rr295\x111?#\x114;<9\x1b73\x05/\x03\x0e\x01GF\x11\t\x05\x1f\x0eQO\x15\x14QQ\x1b\x07Z\x1b\x17\x1a\x1dY\x07\x06^]\x1f\ri`/qatsnzln6.y|zu32w}g+5ylnt>=1!*\x01\x02\x03\x04\x05\x06\x07\b\x15\x05OE[\x10%\x10\x11\x12\x13\b\x1aR^N\x0701\x1c\x1d\x1e\x1f|1b ($54uk) *`+&}2==2<$:u<()3/~:\x12\x13\r\x11I\b\x03\x14\x1b\b\r\x0eNSR@\0OxO[\x11\x1f\x01Fs")
      }), CKFinder.define(S("D\x06\r\x01!'..>b\x03 4$>6'z\x1331-\x136=:;p6\b\x07\x14\x17J%\b\x06\x0f\x03\x19\x01)\x07\x0e\x1c\x1e\x15%\x1d\x10\x01"), [S("E\x05\f\x0e $/)?a\x1994% {\x177$=v\x13/90\b6\x05\x16"), S("C\x07\x0e\0.&-/9c\0!+5=!|\x12<:2"), S(" UG[P\x04eln@DOI_\x01{U\\B_UASD\x17|^RHtS^'$m\0++ .:$\x0e\"-!!(~5='")], function (e, n, t) {
        "use strict";
        return e.extend({
          name: S("4pR^LpWZ[X}P.'+1)\x01/&$&-"),
          template: t,
          className: S("-MDV\x1cWZ\x19VDXH\x14YTRILP,2"),
          ui: {
            error: S("\x14;u|~4\x7fr1~qqFHPN\t@TUG["),
            overwrite: S("\vec~zdJ|ryp+5{r|^xtjVM@EFkSCU_[C_I\x0fs"),
            fileName: S("\x1ctpoUUyMEHC\x1a\nJAMiIG[y\\STQs_[]w[VY\x1fc"),
            fileNameInputArea: S("3\x1aS_[]W[VY\x10WQ046n%7#&")
          },
          events: {
            "change @ui.overwrite": function (e) {
              e.stopPropagation(), e.preventDefault();
              var t = this.ui.overwrite.is(S("1\bP\\PU\\]]"));
              t ? (this.model.set(S("*EM@K"), this.model.get(S("\fb|fwx|rx[wz}"))), this.model.unset(S("!GQVJT")), this.ui.fileNameInputArea.hide().attr(S("\x1b}ow~\rIKG@@H"), S("(]X^I"))) : this.ui.fileNameInputArea.show().removeAttr(S('=_M) o+-!""&')), this.model.set(S("7WO_IKOWK%"), t)
            }, "input @ui.fileName": function () {
              var e = this.ui.fileName.val().toString();
              if (n.isValidName(e)) this.model.unset(S(")OY^B\\")); else {
                var t = this.finder.lang.errors.fileInvalidCharacters.replace(S("+WIG\\Q]^\\CPRtPXHZ_I[M3<"), n.invalidCharacters);
                this.model.set(S("+I_\\@B"), t)
              }
              this.model.set(S("?. /&"), e)
            }
          },
          modelEvents: {
            "change:error": function (e, t) {
              t ? (this.ui.fileName.attr(S("1SA]T\x1b^VO[WUY"), S("\x14adb}")), this.ui.error.show().removeAttr(S("#EWOF\x05ACOHH@")).html(t)) : (this.ui.error.hide().attr(S("\x15weqx7suyzzN"), S("*_^XK")), this.ui.fileName.removeAttr(S("9[IU\\\x13V.7#/-!")))
            }
          }
        })
      }), CKFinder.define(S("6ts\x7fSUXXL\x10\r.&6( 5h\r-#?\x05 /(5~\x177=!\x1f:9>?"), [S(" TLGAWUDG[O"), S("\x13~dcrj`"), S('>]!")!++#'), S("'kblBBIK]\x1f|]WAYSD\x17|^RHtS^'$m\x15- 14g\f.\"8\x04#.74\x1e2-:##"), S("\x18ZQ]uszzR\x0eoL@PJB[\x06oOEYgBQVW\x1cb\\S@K\x16sV]Z[o2$4*!2\x10.->"), S("?\x03\n\x04**!#5g\x04%/9!+<\x7f\x146: \x1c;6?<u\r58),O \x01\x17\r\n\b\x14>\0\x0f\x1c"), S("2p\x7fs_Y\\\\H\x14qRZJ,$1l\x01!/3\x01$+,)b\x03 44> {\x102>,\x107:;8\x1a>\x14\0"), S("?\x03\n\x04**!#5g\x04%/9!+<\x7f\x146: \x1c;6?<u\x0f322,"), S("\x12P_S\x7fy||h4QrzjLDQ\faAOSaDKLI\x02c@TT^@\x1beDX_K_HOpQ[%-"), S("(jamECJJB\x1e\x7f\\P@ZRK\x16\x7f_UIwR!&'l\x12,#0;f\x1a9#*<*#\"\x16:5990\x0e0?,"), S('+ofhF^UWA\x1bxYSMU_H\x13xZV4\b/"# i\x11!,=8c\x0e!!68 >\x10<7;7>\f29*'), S("\x18ZQ]uszzR\x0ewWMI\tlMPiDHH")], function (i, e, c, u, d, f, h, g, p, v, m, t) {
        "use strict";
        var w, y = 33, C = 20, b = 35, _ = 98, x = 100;

        function n(e) {
          var t = this, n = e.data.context.file.get(S("*MCAJJB")).get(S("%GDD"));
          s(e.data.context.file) && e.data.items.add({
            name: S("0tVZ@|[V_\\"),
            label: t.finder.lang.common.edit,
            isActive: n.fileView && n.fileRename,
            icon: S("\x12p\x7fs;qqu\x7f6yywk"),
            action: function () {
              o(t, e.data.context.file)
            }
          })
        }

        function o(t, n) {
          if (i.isUndefined(w)) {
            var e = CKFinder.require.toUrl(t.finder.config.caman || S("(ECI_\x02MN]P\\")) + S("&\tBZ\x15HGKXJB\f\x07\x04\f\x05\x07\x03\n\r\n");
            CKFinder.require([e], function (e) {
              w = e || window.Caman, r(t, n)
            })
          } else r(t, n)
        }

        function r(e, i) {
          var r = e.finder, o = new g;
          o.setupDefault(r, w), o.on(S(" UJQKQRKM"), function () {
            r.fire(S("\fhjfdX\x7frsp,e}w~~nMlzVHGT"), {actions: n.get(S("\flm{y~|`")).clone()}, r)
          });
          var s = new u({finder: r}), t = new d({finder: r}), a = new f({finder: r, collection: o});
          r.once(S(" QCDA\x1fUOG^\x10nHDZf]PUV"), function () {
            s.preview.show(t), s.actions.show(a), s.$el.trigger(S(" BPFEQC")), r.request(S(';HRQS" 0y6 5"<'), {
              name: S("\x15SsqmSv}z{"),
              context: {tools: o}
            });
            var e = w(t.ui.canvas.selector, n.get(S("3]XWP]iH^JT[H")), function () {
              r.request(S("\x19vt}y{m\x1aIKGA")), a.focusFirst(), n.set({
                renderWidth: t.ui.canvas.width(),
                renderHeight: t.ui.canvas.height()
              })
            });
            n.set(S("\x12puxwy"), e)
          });
          var n = new h({
            file: i,
            imagePreview: r.request(S("9SV]Z[\x0503'5- 1\x12:%"), {
              file: i,
              maxWidth: .8 * window.innerWidth,
              maxHeight: .8 * window.innerHeight,
              noCache: !0
            }),
            fullImagePreview: r.request(S('@(/"# |7:,<"):\x1b=<'), {
              file: i,
              maxWidth: 1e6,
              maxHeight: 1e6,
              noCache: !0
            })
          });
          o.setImageData(n);
          var l = n.get(S("*JOYG@^B"));
          l.on(S("0PVW"), function () {
            e.resetButton && e.resetButton.set(S("\x1aroYwlACNF@"), !1)
          }), l.on(S("\r|jctf"), function () {
            e.resetButton && e.resetButton.set(S("\x1fIRfJWDDKMM"), !0)
          }), r.request(S('A.,%!#5r:"$;'), {text: r.lang.editImage.loading}), r.request(S("(JEFAL@K\nBW]P"), {
            name: S(" hOBC@oINF"),
            folder: i.get(S("D#)+,,8")),
            params: {fileName: i.get(S("4[WZ]"))}
          }).done(function (e) {
            if (e.error && 117 === e.error.number) return r.once(S("/S^_^U[R\r]KHTN\x07wR!&'\n*#)"), function (e) {
              e.cancel()
            }), r.request(S("(EEJHH\\\x15XXVV")), r.request(S("/V^^WQG\fE]_H^OUxV,$1")), void r.request(S("\x1a\x7fu|rpG\x1bKMBJ"), {msg: r.lang.errors.missingFile});
            var t = {width: e.width, height: e.height, size: e.size};

            function n() {
              o.trigger(S("=KVz3'0-?#"))
            }

            i.set(S("3]XWP]pT]S"), t), o.setImageInfo(t), r.util.isWidget() && function (t) {
              var n = !1;
              t.request(S("C-6\v&0 '\"6(*")) || (t.request(S("C)$>.% 0.")), n = !0);

              function i() {
                n = !1, t.removeListener(S("\x18tsuupweEE"), i)
              }

              t.once(S("\rcf~x\x7fznpr"), i), t.once(S("\x14ewp}#~~oilpY\x1bgGMQoJINO"), function e() {
                n && t.request(S("6ZQWSVUG["));
                t.removeListener(S("$UG@M\x13NN_Y\\@I\vwW]A\x7fZY^_"), e);
                t.removeListener(S("C),(.% 0.("), i)
              })
            }(r), r.once(S("\x19jz{x$|RDCWA\x1fcCA]cFMJK"), function () {
              r.request(S('=JP/- "6\x7f%5-(>.'), {name: S("A\x07'-1\x0f*)./"), page: S("3qQ_CqT[\\Y")})
            }), r.request(S("\x15fv\x7f| xnx\x7fkE"), {
              view: s,
              title: r.lang.editImage.title,
              name: S("A\x07'-1\x0f*)./"),
              className: S("!AHB\bCN\x05YKLI")
            }), r.request(S("#TDAB\x12ZBD["), {name: S("\x15SsqmSv}z{")}), r.request(S(";PR_[%3x0,*1"), {text: r.lang.editImage.loading}), a.on(S("0RZZXQ@^]N\0^DM_Q$"), function () {
              s.onActionsExpand()
            }).on(S(".LXX^WB\\S@\x02ZUWP\\NL%"), function () {
              s.onActionsCollapse()
            }), r.on(S("4@_\rJ\\IRFX"), n), r.once(S("\x12curs-||ionrg%eEKWmHG@M"), function () {
              r.removeListener(S(".ZY\v@VG\\LR"), n)
            })
          })
        }

        function E(e, o, s, a, l) {
          a.set({value: y, message: s.lang.editImage.transformationAction}), o.doSave(e).then(function (e) {
            a.set({value: b, message: s.lang.editImage.uploadAction});
            var t = o.editImageData.get(S("\x14s\x7f{}")), n = t.get(S("3RZZS]K"));
            s.once(S('3WZ[ZYW^\x01][JZ2{\x11"2 \x0f*)./'), function (e) {
              e.data.response.error || (a.set({
                state: S("\r``b|s\x7f"),
                value: x,
                message: ""
              }), t.set({
                date: e.data.response.date,
                size: e.data.response.size
              }), s.once(S("!RBC@\x1cT@F]\x11aLGA"), function () {
                e.data.context.isFileNameChanged ? s.request(S('"EKIBBZ\x13XNJ_K\\Xw[_QF')) : t.refresh()
              }), s.request(S('"SEBC\x1dLLY_^BW'), {name: S("B\x06 ,2\x0e%(-.")}))
            }), a.set({
              bytes: 0,
              bytesTotal: 0,
              value: b,
              message: s.lang.editImage.uploadAction,
              time: (new Date).getTime()
            }), s.on(S("'L@KGCJ\x14jTXFzYTQRkXL^lOQX2$10~&')+,&"), r);
            var i = s.request(S('=]P-,#- \x7f5"&-'), {
              name: S("\x0e\\qgwZytqr"),
              type: S("@1-00"),
              folder: n,
              params: {fileName: l || t.get(S("3ZT[R"))},
              post: {content: e},
              context: {file: t, isFileNameChanged: !!l},
              returnTransport: !0,
              uploadProgress: function (e) {
                e.lengthComputable && (a.set({
                  bytes: e.loaded,
                  bytesTotal: e.total,
                  value: e.loaded / e.total * (_ - b) + b,
                  time: (new Date).getTime()
                }), a.set(S("+X_OACWWA"), s.lang.formatTransfer(a.get(S("5EG]\\^"))))), e.lengthComputable || a.set({
                  state: S('C-+""<,8&%#/;5'),
                  transfer: !1
                })
              },
              uploadEnd: function () {
                a.set(S("\x10bfr`p"), S("-@@B\\S_")), s.removeListener(S("\x19~r}qqx\x1adFJPlKFOLyJZH~]_V@VGF\fTYWY^P"), r)
              }
            });

            function r() {
              i && i.abort(), s.request(S("8]SZPRY\x05$$176*?"))
            }

            o.destroy()
          })
        }

        function s(e) {
          return e.isImage() && e.get(S("D#)+,,8")).get(S(" @AO")).fileRename && e.get(S("=XP,%'1")).get(S(" @AO")).fileUpload
        }

        return function (i) {
          var r = this;
          (this.finder = i).on(S("\x14vyyl|boQxpj\x1aGKOA\x1fCCA]"), n, this), i.on(S("\x16cwvvy}o$mERGW\x1ehGNF\x13LB@H"), function (e) {
            s(e.data.file) && e.data.toolbar.push({
              type: S("\x18{oohrp"),
              name: S("\fHjfdX\x7frsp"),
              priority: 50,
              icon: S("\x11qxr8p~t|7~xtj"),
              label: e.finder.lang.common.edit,
              action: function () {
                o(r, i.request(S(">Y)-'0~\"#3\x1b,&./9++")).first())
              }
            })
          }), i.on(S("+XBACRP@\tFPERL\x03\x7f_UIwR!&'"), function (e) {
            var t = this;
            e.data.toolbar.push({
              icon: i.lang.dir === S("=RK2") ? S("!AHB\bDFKB") : S("&DCO\x07MC_YNBU"),
              name: S("/s]]@Q"),
              iconOnly: !0,
              label: e.finder.lang.common.close,
              type: S("0SGG@ZX"),
              alwaysVisible: !0,
              action: function () {
                e.data.tools.hasDataToSave() ? i.request(S("7\\P[WSZ\x04\\//$*6("), {
                  name: S("%eHFOCYAhJFDx_RSPsOQM"),
                  msg: i.lang.editImage.confirmExit
                }) : i.request(S("<M_X%{&&714(1"), {name: S("\x12Vp|b^ux}~")})
              }
            }), e.data.toolbar.push({
              type: S("9N^DI"),
              name: S('?\x06(.&*$+"'),
              className: S('4V]Q\x15\\S\x16HRQS" 0n",*"&(\'.'),
              label: i.util.escapeHtml(e.data.tools.editImageData.get(S("E .$,")).get(S(":U]P[")))
            }), e.data.toolbar.push({
              name: S("\x11Arbp"),
              label: i.lang.editImage.save,
              icon: S("\x0fszt>gt`r"),
              alignment: S("\x18j\x7fxssz~RX"),
              alwaysVisible: !0,
              type: S("*IYYZ@^"),
              action: function () {
                !function (e, t) {
                  if (t.hasDataToSave()) {
                    var n = e.finder, i = t.editImageData.get(S("+JDBJ")), r = i.getExtension(),
                      o = i.get(S("\x18w{vy"));
                    if (r) {
                      var s = o.lastIndexOf("." + r);
                      0 < s && (o = o.substr(0, s))
                    }
                    var a = i.get(S("7^VV_YO")).get(S("2RWY")).fileDelete, l = new c.Model({
                      onlyOverwrite: !a,
                      overwrite: a,
                      oldName: i.get(S("4[WZ]")),
                      name: o,
                      originalName: o,
                      extension: r,
                      tools: t,
                      error: !1
                    }), u = n.request(S("/TXS_[R"), {
                      view: new m({finder: n, model: l}),
                      title: n.lang.editImage.saveDialogTitle,
                      name: S("9\x7f_UIwR!&'\0++ .:$"),
                      buttons: [S("\x14vwy{|v"), S("A-(")],
                      context: {viewModel: l, tools: t}
                    });
                    l.on(S("4V^VV^_\x01YOLP2"), function (e, t) {
                      t ? u.disableButton(S("\x14z}")) : u.enableButton(S("<RU"))
                    })
                  }
                }(t, e.data.tools)
              }
            }), this.resetButton = new c.Model({
              name: S("A\x10&7 2"),
              label: i.lang.editImage.reset,
              icon: S("4V]Q\x15K_HYI"),
              alignment: S("4FSTWW^ZND"),
              alwaysVisible: !0,
              isDisabled: !0,
              type: S(" CWWPJH"),
              action: function () {
                e.data.tools.resetTool()
              }
            }), e.data.toolbar.push(this.resetButton)
          }, this, null, 40), i.on(S("\x14q\x7fvtv}!YywkiLCDAfIIN@XF\x16BE"), function (e) {
            var t = e.data.context;
            if (!t.viewModel.get(S("+I_\\@B"))) {
              var n = t.viewModel.get(S("7VXW^")) + "." + t.viewModel.get(S("8\\BOYSMV//"));
              t.viewModel.get(S("%IQM[]YEYK")) || !i.request(S("\x10w{\x7fqf,p}mYnno{qT")).where({name: n}).length ? function (e, t, n) {
                var i = e.finder, r = t.editImageData, o = new p, s = new v({finder: i, model: o});
                if (i.request(S('"GMDJHO'), {
                  view: s,
                  title: i.lang.editImage.saveDialogTitle,
                  name: S("\x11Ww}a_zy~\x7fH}k{ORNEQAVU"),
                  buttons: [S("$FGIKLF")]
                }), i.on(S("=ZV!--$~\0\".<\0'*+(\x1d.&4\x02!;2$2+*`8=3=:\f"), l), o.set(S('>R%21"# '), i.lang.editImage.downloadAction), !window.URL || !window.URL.createObjectURL) return o.stateIndeterminate(), E(r.get(S("B%1)*\x0e%(-.\x1c?+994%")), t, i, o, n);
                o.set({bytes: 0, bytesTotal: 0, value: 0, time: (new Date).getTime()});
                var a = new XMLHttpRequest;

                function l() {
                  a && a.abort(), i.request(S("\x14q\x7fvtv}!xxmkRN["))
                }

                a.onprogress = function (e) {
                  e.lengthComputable && (o.set({
                    state: S("\nec\x7fcn|"),
                    bytes: e.loaded,
                    bytesTotal: e.total,
                    value: e.loaded / e.total * y,
                    time: (new Date).getTime()
                  }), o.set(S("?43#-7##5"), i.lang.formatTransfer(o.get(S('"PT@CC'))))), e.lengthComputable || o.set({
                    value: C,
                    state: S("\rgattfvfx\x7fyym\x7f"),
                    transfer: ""
                  })
                }, a.onload = function () {
                  if (i.removeListener(S("*OELB@W\vwW]A\x7fZY^_h]K[o2.%1!65}+($()!"), l), 200 !== this.status) return i.request(S('D#)+,,8q>((=5":\x15=93$')), i.request(S("?0 %&~!#4<;%2"), {name: S("\x12Vp|b^ux}~")}), void i.request(S("\x14q\x7fvtv}!usxp"), {msg: i.lang.errors.missingFile});
                  o.set({
                    value: y,
                    eta: !1,
                    speed: !1,
                    time: 0
                  }), E(window.URL.createObjectURL(new Blob([this.response])), t, i, o, n)
                }, a.open(S(")mnx"), r.get(S("9\\NPQwR!&'\x136 0.->")), !0), a.responseType = S("A#16$?%=/,.>"), a.send(null)
              }(r, t.tools, t.viewModel.get(S("\x1epLElBI@")) !== n && n) : t.viewModel.set(S("\x15sejvh"), e.finder.lang.editImage.saveDialogFileExists)
            }
          }), i.on(S(")NBMAAH\nr]]R\\DZ}]SOuP_X%\x04:*0\x7f),"), function () {
            i.request(S('@1#$!\x7f"";=8$5'), {name: S('={[)5\v.%"#')})
          }), i.on(S("\x1e|OLOBJA\x1cBZ[EY\x16~OYUx_RSP"), function () {
            i.request(S('C4$!"r-/88?!6'), {name: S("6r\\PNrQ\\YZ")})
          }, null, null, 5), i.request(S("#O@_\x1dD@Y_IC"), {key: t.escape}), i.on(S("<V[F51x") + t.escape, function (e) {
            e.data.evt.isDefaultPrevented() || i.request(S('C4$!"r-/88?!6'), {name: S("\x19_\x7fuiWrAFG")})
          }, null, null, 30)
        }
      }), CKFinder.define(S(">|\v\x07+-  4h\x05&.> (=`\x168>6\x10:!946;?s\x1b73\x05%\r\x14\n\t\t\x06\f"), [S("\fx`kucap{gs"), S("\x0eeadwam")], function (e, s) {
        "use strict";
        var a = /iPad|iPhone|iPod/.test(navigator.platform);

        function t(e) {
          var t = {
            name: S('<yQH.--" '),
            priority: 70,
            icon: S("4V]Q\x15_SWY\x10ZP7/.,%!"),
            label: e.finder.lang.common.download
          };
          if (a) {
            var n = e.finder.request(S('3R\\ZRK\x03]^Hn[S%"6& ')).first(), i = e.finder.request(S("A!,)('),s?9 "), {
              command: S(",iAX^]]RPs_[]"),
              folder: n.get(S("\x18\x7fuwxxl")),
              params: {fileName: n.get(S("%HFEL"))}
            });
            t.type = S("1^ZZ^\x1bUMMNTR"), t.href = i, t.attributes = {target: S("=a], ,(")}
          } else t.type = S("C&023''"), t.action = function () {
            e.finder.request(S(" GKOA\x1fBH_GFDMI"), {file: e.finder.request(S("\x15p~t|i!{xjLEMG@P@B")).first()})
          };
          e.data.toolbar.push(t)
        }

        function n(e) {
          var t = e.data, n = t.context.file, i = n.get(S("&AGENN^")).get(S("&FKE")),
            r = e.finder.request(S("E .$,9q+(:\x1c5=70 02"));
          r.length && !r.contains(n) && e.finder.request(S("B%-)#4r-/8)!+,$\x10>?")), e.finder.request(S("1TZXPE\rK\\V^_I"), {files: n});
          var o = {
            name: S(")nD[CB@QU"),
            label: e.finder.lang.common.download,
            isActive: i.fileView,
            icon: S("=]T&l$*( k#'>$'#,*")
          };
          a ? (o.allowClick = !0, o.linkAttributes = [{
            name: S("\x1bh|lxEU"),
            value: S("\x12Lvywys")
          }, {
            name: S("\x18qh~z"),
            value: e.finder.request(S("'KFGFMCJ\x15EC^"), {
              command: S('C\0*1)$&+/\n$"*'),
              folder: n.get(S("%@HDMOY")),
              params: {fileName: n.get(S("\x17vxw~"))}
            })
          }]) : o.action = function () {
            e.finder.request(S("\x1bztrz\x1aEMTJIIFL"), {file: n})
          }, t.items.add(o)
        }

        return function (r) {
          var o = e.uniqueId(S(";_VX\x12$.5-(*'#e/8*!("));
          r.setHandler(S("\x19|rpx${OVLOKDB"), function (e) {
            var t = e.file.get(S("\x1bzrr{ES")), n = r.request(S("5UXUT[UX\x07KM,"), {
              command: S("\nOcz`c\x7fpvU}ys"),
              folder: t,
              params: {fileName: e.file.get(S("1\\RYP"))}
            }), i = s("#" + o);
            i.length || ((i = s(S("\x16+q\x7fhzqx "))).attr(S("2ZP"), o), i.css(S("\fig|`}sj"), S("4[YY]")), i.on(S("E*()-"), function () {
              var e = s(i.get(0).contentDocument).text();
              if (e.length) try {
                var t = JSON.parse(e);
                t.error && 117 === t.error.number && (r.request(S(';ZRR[%3x1!#4";!\f" (=')), r.request(S("'L@KGCJ\x14F^W]"), {msg: r.lang.errors.missingFile}))
              } catch (e) {
              }
            }), s(S(" CMG]")).append(i)), i.attr(S("+__M"), n)
          }), r.on(S("<IQP,##1~7#4-=p\x06-$ u68>6"), t), r.on(S("E%(&=/38\0+!%k4:80"), function (e) {
            e.data.groups.add({name: S("?6('4")})
          }, null, null, 20), r.on(S("D&))<,2?\x01( :j7;?1o >=."), n, null, null, 20)
        }
      }), CKFinder.define(S("4ASOL\x18ypzTP[%3m\x17!(6+)=/8c\v'#5\x01 6\"<3 w\x1e;708,&N\x05\r\x17"), [], function () {
        return S("\x1c!zvV\x01AOEVU\x1a\nJAM\x01KGCU\x1cBAQC_RO\x14HTSI\x1c\x1f4  **!#?ukzil?!#5lp2$%:>;8.233|ajABCDY\x02\x0e\x1eI\t\x07\r\x1e\x1dRR\x12\x19\x15Y\x13\x1f\x1b\x1dT\n\t\x19\v\x17\x1aw#<?+aoq6\x03*+,-2kyg2pxted%;ypz0xvLD\x0fSV@PNM^\x07BBKA\r\x0e;\x12\x13\x14\x15\x16\x17\x18\x19\x06_UK\x1e\\, 10yg%,.d,\" (c?\"4$:1\"{>6?5v2<3:B_^L\0\f\x10YbIJKLMNOPM\x16\x1a\x02U\x15\x1b\x19\n\tF^\x1e\x15\x19-gkoa(vum\x7fcn{ gav~?p{`xc:'&4xth!*\x01\x02\x03\x04\x19\tCA_\x14!\f\r\x0e\x0f\fSGG@ZX\x17[U[HO\0\x1c\\+'o%-)#j8;/=%(9b2$&';;{'*<,yb{2>\x11\x14\rXXJ\x04\x12\x1c\x1d\x05\x05RgNOPQN\x11\x01\x01\x02\x18\x16Y\x19\x17\x1d\x0e\rB\"bie)cokm$zyi{gjg<pf`ayy5w\x7fch? 9R@SVK\x1e\x1a\bJ\\^_CC\x10%\f\x1eVZB\v")
      }), CKFinder.define(S("+XHV[\x11ryu][RRJ\x16n^QMR^4$1l\x02,*\"\x18;/=%(9`\x170>?1'/\x04, 6>/s:0\x14"), [], function () {
        return S("/\fBFJXP\b=1\x17YPZ\x10XV,$o36 0.->g9#\":oj7=0!&z]Qw90:p86\f\x04O\x13\x16\0\x10\x0e\r\x1eG\x19\x03\x02\x1aU\x16\x1e\x11\x06\x07\x7f\x7fY\x1b\x12\x1cV\x1a\x14\x12\x1a-qpfrlcp(r\0\x02\x05oaw=bzrpza-8wuuy&\x14\x16]+(*\nFMA\x05OCGI\0^]UG[VC\x18DXWM\x1a\x11\x1cF46I#-;i6/=!'-ql/!=44 ~6:.lRP'QVTp<\v\x07O\x05\r\t\x03J\x18\x1b\x0f\x1d\x05\b\x19B\x02\x1e\x1d\x07T\x0e|~q\t\x15\b\x15\t\x17\x10n;\"em}cc3\x03\x03\x02xb~50!)\x19\x1d\x1czr~m ;,&\x14\x16)CMWPJK\x1d\b\x19\x11!%$\\FWYF\t\x14\x05\r=10\\TRI\x13Y!,+/=\x7ff\x06: +'`m\x06*<'7'=67{x\r;330?s@7\x07\x11\0\x04\b\x06DI\x19\n\x02\x1eC\x1c\x15\x03\x1b\x15O\x7f\x7f~\x1a\x18\x19\x10\x1b\x0f\x11\nne8#vbdf 9&; =\"?>);(\x1e\x1c\x1fm5pt\x7fye$?\x19\x11\x13\x13\x1f//Z\"##\x05OFH\x02VX^V\x19EDRNP_L\x1cF46I1-0-1/(&sj*.>!#%%7h^\\_#7)`{lfTVi\r\x07\x05\x10_FWSccb\x0e\x02\x1a\x1b\x1f\x1cHSF\x10\x1bLrps\t\x15\x1a\x16\v:!28\x0e\f\x0fji{mbb7.nee}(\x1e\x1ck\x1d\x12\x104xw{3yIMG\x0eTWCQAL]\x06NXZ[__\x1f]QMB\x1b20\x14XW[\x13Y)-'n47#1!,=f.8:;??\x7f#&0 w#SSR84-/\f\0\x1bYD\x07\n\b\v\x02Qaed\x1e\0\x03\x18\x06\x1a\x1b\x1bLW\x19\x1b\t\x14\x10\b\n\x1a;\v\v\npjv=(<:.7\x07\x07\x06xt{t|a,7))\x7fv'\x17\x17\x16WHFWL\x1f\x06\x16\x18LG\x10&$'M_CVVF\x18DV\\POH\x06\x1d\v\x0fezHJM('5/ $qlx+\"pb\"+tem]QP7:.:71M\x15\r\x13^EKR\r\x04Qaed\f\0\x02\x15\x17\x01NUFLrpsV\v\x18\x1c\x14iu/ak}+t`hnd{7.a\x7f\x7fw(\x1e\x1c\x1fuwa7ht|zpW\x1b\x02MKKC\x1c\" #_IUZ\x02Y_VVZA\f\x17\x15\0\x03\x02\x05\x04NG{KK>NOO\x07%,.\"-m=,\"47=t483xq722p)6\x04\x15\nYDRP_\x18\x11CK\x17ggf^\x12\x19\x15Y\x13\x1f\x1b\x1dT\n\t\x19\v\x17\x1aw,`vpqii%gosx!\x04\x06\x19?qxr8p~t|7knxhvEV\x0fAQQRHF\x04ZYI[\x0eT:8;:=WWTS^HTISZ\x05`brstuvwsCCB1GG2Z[[}7>0z>06>q-,:\x16\b\x07\x14I\x07\x13\x13\x1c\x06\x04F\x02\b\x16\x1bJ\x13\x17\x15\x1b\x07\x13[rpT\x18\x17\x1bS\x19img.twcqal}&nxz{\x7f\x7f?cfp`-z||tnx>d*(+SKVOSAFD\x11\fLL\\_]GGQ\x0e<>1MUK\x06\x1d\v\x0fezHJM-#./!>ql\x7fz?(jXZ]\"?3,1`{ni.'[kkj\x07\n\n\b\x1aSJH\n\v\b\t\x16\x17Iy}|\x14\x16\x1b\x12\x1d\t\x13\b\x10\x1b-sgsadr=(ge&~h~jqe)\x19\x1d\x1ctv{r}ishp{\rQMPMQOHF\x13\nHICZJB\n8:=\x18ARZRSO\x11IL^.2$,6(|g<;+%?!/;5\bz~aes~cSSRq0-r\x14\x13\x03\r\x17\x03\t\x15\x05SJ\x1f\x1e\f\0\x1c\x1c\x10\x06\x16-][BH\\S@vtw\vr`lpbjtj2)~ymc}cqewJ<8#'=0!\x11\x15`\x14\x15)\x0fAHB\b@NDL\x07[^HXFUF\x1fQAABXV\x14T^DI\x04^#5+5!iLNf*!-a+'#5|\"!1#?2/t8.()11M\x0f\x07\x1b\x10_\0\b\v\x1c\x19Gfd@\f\x1b\x17_\x15\x1d\x19\x13Z\b\v\x1f\r\x15\x18\tRbtvwkk+wzl|1mnzfft>\x19\x1d;u|~4|rpx3oRDTJAR\vE]]^DB\0^]UG\bU[VCD\x18B025RKK,(,&~e((&,qAE0DEY\x11?60<7w+:(>93~>\x0e\x05BK\t\f\bJ\x1f\0\x0e\x1f\x04WNXFI\x02\v]U\r}qpT\x18\x17\x1bS\x19img.twcqal}&nxz{\x7f\x7f?}qmb-yznrjx2\x15)(\f@OC\vAAEO\x06\\_KYYTE\x1eV@BCWW\x17UYEJ\x05&.!67iLNAg) *`(&<4\x7f#&0 >=.w9))*0\x0eL\x12\x11\x01\x13\\\x06\v\x1d\x03\x1d\tAdfy_\x11\x18\x12X\x10\x1e\x14\x1cW\v\x0e\x18\b\x16ev/aqqrhf$zyi{4i\x7frg`4n\x1c\x1e\x11\x10\x13y}~uxRNWM@\x1f\x06\x04\x18H\x13\x1bIO\x15%98O9=H<=1\x17YPZ\x10XV,$o36 0.->g)99: >|\"!1#v,RPS6=/96\x0eL\x0e\x06\x02\x11\\GE_\x0f\x06Wgg\x12z{{]\x17\x1e\x10Z\x1e\x10\x16\x1eQ\r\f\x1avhgt)gss|fd&|\x7fky*swu{gs7c\x13\x13\x12\x7frpkEOV\x19\x04\x02\x01\x1c\" #YEJF[\n\x11\x03\x04\x11\x0e<>1[[XWZLP5/&n-(' -sj>>!fm40&2n<;6?<u(*:u'\r\rY\0\f\x04\x14\x14\r\x1dW>8+CW\\TA0\x07\x03\x11RJI\x02\x16\x10\x13\rZ3E'16mrsx,9J)?H*\"Wedc;a$6vh|9/X-\x10\x11\x12\x06\x16cUQO\f\x18\x19\t\x1f\x1eXYUF[\x11\x06r\x12\n\v\v\x0f\x19\x0f\f\x1arq*&-\".3mz\x0en~\x7f|{uc`vfe >=.\x184$xm\x1bESPSAWVWM[ZZXH\\_BEWAFPE2]I;^NM[M0$1@tdro-;:meab*#U7!&0$$^_\\>./;-\x10E\x07\x10`\0\x14\x15e\x11\x19\x05\x1b\x15\x1b\n\x02r\x06\x02\x1a\r\x0e\x02\x1d\v\nw\x04\x0e\x10\bxtgq\x07qwipq\x7fn~}\rwc\x7f`jbgdo}k\x19omsmfVSP[AWV_ZG_[_ZY]UC1GE[ENNKHCYONG2/221 4D<8$348+= ]%\"1'U\"*7#>.-R'\x12\x0f\x12\x12\x11\0\x14d\x1e\x1a\x04\x12\x1d\x18\v\x1d\0r\n\x01\x1a\0\x06\x04\x0f\x0e\b\x1e\x0e~\b\vnurpsrtbzyrxb\x7fwybcjvf\x16`cvmjhkjlzRQZPJR^RM[)]_CW^ET@C8MEYOAO^N>HL.836!76D0=$9;>98\"4 P\"&8#*/()$8,/\x18\x15\f\x11\x13\x16\x11\x10\x1a\f\x18h\x1a\x1f\0\x19\x03\x02\x05\x04\x06\x10\x04\x07\0\n\x14\f\x04\b\x1b\r\x03wpmuqsbzy\x06|xc{{uc\x11ff{orji\x16cosigUDP PVHQ]\\OY\\.V[^CE@CBDRJ:NHRLHI23:&65>3&;=8;:<*\"R&!:&!$/.(>.-&,\x0e\x16\x1a\x16\x01\x17e\x13\x19\x07\x12\x13\x19\b\x1c\x1fj\x14\0\x01\x11\x07\x06CJXTHZRLRer\x06fvw25)'9'-9+g}fcvfe{cip\x7finxl\x19ER'FT$CT+LX-\x1f\x1b\tJC4WC5W_Lrp\x07qvtP\x1ckg/emic*x{o}ehy\"rdfg{{;y}an;g\x17\x17\x16M@PDMK\vUANB_\x16\r\x03\x19U\\\t9=H<=1\x17YPZ\x10XV,$o36 0.->g)99: >|<6,!l5=?5)9}%Uih\x01\f\n\x11\x03\t\x1cSJLKVdfy\x1d\x17\x15\0OVFO\\Aqut\x1c\x1ecjeqkphc%`gjkh4/ec~;6qwcy#sv}z{0SWE\b\\HJ\x1cKAKY_HZ\x12eet\x1e\f\x19\x13\x04{JL\\\x19\x0f\x0eG--,0av\x02bz{\"?8=k|\x11t`\x15qg\x10 /.t,os1-\x07DP%VUVWM[,\x18\x1a\nK]BT@C\x03\x1c\x12\x03\x10\\I?YOLN5$01!76om`mcx(=K5# ! 0$%=+*muxi]OY\x07\x10`\0\x14\x15\x18\f\x18\x1b\x1c\b\x1c\x1f\x01\x04\x17\x01\x04\x07\x02\x12\n\v\x1f\by\x18\x0e~esrfvuct\v9+?$h|\x7f68>?qf\x12rjk\x7fio\x1b\x18\x19ESPFVU\x02B[-OY^ \\\\^ADVF6BCVHB^NM2L1/:;!7E2;,8;@?=! '7!W#'9 +?),^,-\x0e\x15\x15\x17\x11\x12\x1e\x15\r\x1bi\x1d\x1e\x03\x1a\x1f\x05\x05\0\x02\f\x10\x04\x07\n\v\x14\x0f\v\t\v\bxsgq\x07sui{|~~{u|jba``ze`rj\x1alhrdjzRQ.QWKVQM[)]_CW[UCB0FFXALLNIME[MC76-1733:82.>=<;>$+'!\".%=+Y-(3+-\x15\x15\x10\x12\x1c\0\x14\x17\x1a\x1c\x04\x1a\x14\b\x1cl\x06\x02\x1c\n\0\x10\x04\x07t\n\f\x15\r\x0f\x1b\r\x03tqfvu\nu}g{si\x7f\r{b\x7fbeqgf\x14jmtneikhXSGQ'QWI\\^^^[U\\JBA@@ZCBBLKKCYO=K1/64001?:,8;>> ?&4 P '8'.<(+P/-1\x10\x17\x07\x11g\x11\x14\t\x18\x1f\x0f\x19\x1cn\x1c\x1d\x1e\x05\x05\x07\x01\x02\x0e\x05\x1d\vy\x0f\x0e\x13\b\vuupr|`twz{d\x7f{y{xhcwa\x17aeym`nnkelzRQPPJUPBZ*^_B\\VJBA(VFGSEH\r\b\x1a\x12\x0e\x18\x10rl'0@ 45|{ke\x7fao{u9?!&0$'5-+29/,:\x12g\x07\x10a\0\x16f\r\x1ai\x0e\x1ek]YW\x14\x01v\x11\x05w\x15\x11\x0202A746n\")%i#/+-d:9);'*'q;>3u-]QP7:$p6:\t\x06\n\x17^E\x05\x06\x04\nBSZHGOQ\x18\x1f\x03\x1b\x07\x02\x16\x16\rAqu\0tu\tAof`lg'{jxnic.n~u2;y|x:p|s|ti$?\x16\x11\x12S\\\f\x06\\\" #\x05OFH\x02VX^V\x19EDRNP_L\x1cTSX`:HJMLO*)1g#)$)'$kr0595\x7f`a\x7frgWWV\x1dkk\x1enoo'\x05\f\x0e\x02\rM\x1d\f\x02\x14\x17\x1dT\x14\x18\x13XQ\x17\x12\x12P\x16\x1aifjw>%>78yr\",v\x04\x06\x19?qxr8p~t|7knxhvEV\x02JIB\x06\\\" #\"%@OW\x1dYWZS]B\r\x18Z[W_\x15\x07\rehyIML;MA4@AEc-$6|4:80{'*<,29*s6\x0e\x07\rC\x1foon\x18\x06\x19\x02\x18\x04\x01\x01JQ\x13\x11\x07\x1a\x1a\x02\f\x1cAqut\x12\x1afu8#4>\f\x0e\x01ke\x7fxbc50#w~/\x1f\x1f\x1ejp}sh'>/\x1b++*IDT@AG\x10\vMXZ@\v;;:DTRSQW]\x01\x1c\r\x10\n%,br!(}MA@)$ \"<upr452n\\^Q4;#q5;6\x07\t\x16YDW\x03\nSccb\0\x04\0\n]\x19\x17\x1a\x13\x1d\x02MXH\x1f\x16Gwwvfnlw)vo}m3*:i`5\x05\x19l\x18\x19\x1dU{r|p{;o~lzEO\x02BJA\x06\x0fE@D\x06DHGHXE\b\x13\f\x05\x06G@\x10\x1a@647\x11#*$n\",*\"e98.:$+8}8<5;u-]QPSR,<:;\t\x0f\x05N\x06\n\x12\x13\x07\x04PK^C\\\n\x1dJxz}\b|~\x05sprR\x1e\x15\x19-gkoa(vum\x7fcn{ gav~2-4q\x7fa8b\x10\x12\x15i{gT\fCOMBH\x1d\bJOEXH\\\x14:8O9><\x18TS_\x17]UQ[\x1203'5- 1j!',$lsn+9'h5='%#u6<v($.:@\x1ahjm\b\x07\x15\x0f\0\x04F\x0e\x02\x1a\x1b\x1f\x1cHSD[C\x12\x15Bpr\x01wtv.bie)cokm$zyi{gjg<{}rz6)8}sm&sjw\rND\x0eP\\VB\0\x1b\x03\vW''&_ASP]AO\r\x18\t\x14\r\x0777BJKKm'. j:=&kb.%)}7;?1x&%=/3>+p<*\x14\x15\r\rI\x15\x14\x02\x1eI\x11aed\x03\x0e\x02\x16\x1b\x1dY\x19\x13\x11\fCZKGwwvm`pdmk+uanb\x7f6-#9u|)\x19\x1dh\x1c\x1d\x117ypz0lkL\x01\f@OC\vAAEO\x06\\_KYYTE\x1eV@BCWW\x17KNXH\x05\"$$,6 f<B@C9%*&;jq3& :m]QP6>:)d\x7fQVGXnlo\x05\t\n\x01\f\x1e\x02\x1b\x01\x14\\\x1b\x1e\x15\x12\x13MX\f\b\x17T_\x1a\x1et`8jidab'z|l'ucc+rzrffsc%LN]1%2:\x13bQUC\0\x14\x17PDFE_\b\x1dk\x15\x03\0[@AF\x12\vx\x1f\tz\x18\fy765m3vh(:.oy\n\x7f~\x7f`t`\x15'#1rjk\x7fil*7;\x14\tGP @TUY\\OY^H\\_\x18\x14\x1b\x14\x1c\x01SD<\\HINI[M2$03rlcpJfr.?I+=\"!7!$%3%((/>.-,+\x05\x13\x10\x06\x17`\x03\x17i\f\x18\x1b\t\x1f\x1e\n\x03rBR@]\x13\x05\b_SWP\x18\r{espfvv\0\x01\x0elxyi\x7f~+ub\x16vfg\x1bekwjmyo\x1dkTOS[AWV+[XDSTH\\,EBWAD9DDVIL^N>HN.90&65E5:'><8897\"4 P\"'8#(,.)-%;-\x10\x13\x10\r\x10\x12\x12\x12\x1f\x11\x18\x0e\x1en\x18\x1c\x1e\x02\x07\x07\x01\x02\x0e\x05\x1d\v\n\t\x0f\x13\x0e\tes\x01uwk\x7fsm{z\x07~~`\x7fft`\x10bfxnl|hk\x1fomqVUWWVT^BZ*\\_BX\\ZDCCKQGFELWOBHHIG2$0@21(2:<>9=5+= #'=%-3%[/)5%);-\x10m\x11\x15\n\x14\x14\x02\x1aj\x1f\x18\t\x1f\x1ec\x02\x04\x1c\x02\f\x10\x04t\f\v\x14\v\n\x18\f\x0f\x03svmq|rr\x7fqxn~\x0ez~~eegabne}kjioshkUUPR\\@T$\\XD_[Y[XHCWADGEYHO_I?ILQ07'14I44&9<.>N:=>!$6&%U%*7.,(()'\x12\x04\x10`\x10\x17\b\x11\x1c\x1c\x1e\x19\x1d\x15\v\x1d\0\x03\0\x1d\0\x02\x02\x02\x0f\x01\b\x1e\x0e~\n\fnt{wqr~um{zy\x7fc~yuc\x11g`{go}kj\x01yolzRQ\x16\x11\x05\v\x15\x01\x07\x1b\x07N_)K]B\x05\0\x12\x1a\x06\x1a\x16\f\x1cRVNO[M0,62- 45-;L.?H+?Q4!P1'Pdn~?(Y8.^\x02\b\x19)-X,-!\x07I@J\0\\[\\\x11\x1cP_S\x1bQQU_\x16LO[I)$5n&023''g%)5:o+[[Z94$017w)5:6+ZARXnlo\n\t\x1b\r\x02\x02@\x02\n\x16\x05HSYC\x13\x1aCss\x06vwwQcjd.vqj'&jam!kgcu<baqc\x7fro4xnhiqq\rOG[P\x1fDBNFXN\fV$&9]WU@\x0f\x16VMMU\x00647M)&*7~ewpmr@BE//,;6 <!;2z14;<9g~*\x12\rJA\0\x04\x12\x06R\0\x07\n\v\bA\x1c\x06\x16Y\v\x19\x19M\x14\x10\x18\b\b\x19\tC*TG/;( 5D{\x7fm.>=vb|\x7fa6'Q3%*qnol8-^\x05\x13d\x06\x16cQP_\x07]\x18\x02B\\H\x15\x03t\x01\x04\x05\x06\x12\n\x7fIM[\x18\f\resr4-!2/mz\x0en~\x7f\x7f{uc`vfe>21>2/yn\x1azRSPWAWTBZY\x1c\x02\t\x1a,\0\bTA7QGDG]KJKYONN4$0361#5:,9N)=O*\"!7!$0%Thxns9/.yIMN\x06\x17a\x03\x15\x1a\f\x18\x18jkh\n\x02\x03\x17\x01\x04Q\x13\x04|\x1c\b\tq\x05\r\x11wywfv\x06rvfqr~i\x7f~\x03hb|dl`se\x1bmkudekzRQ![WKT^^[XSI_-[A_AJBGDO]KJCNSKO3651!7E39'92:?<75#\"+&;&&-<(X(,0'\x18\x14\x07\x11\x14i\x11\x16\r\x1bi\x1e\x1e\x03\x17\n\x02\x01~\v\x06\x1b\x06\x06\r\x1c\bx\n\x0e\x10\x06qtgqt\x06~uf|zx{z|jb\x12dgzafdonh~nmflNS[UVW^BZ*\\_BY^\\GF@VFENDVNBNYO=I3/;21 47D19%;5;*\"R$ :,'\"=+*X$)0-\x17\x12\x15\x14\x16\0\x14d\x1e\x1a\x04\x1f\x1e\x1b\x1c\x1d\b\x14\0\x03\f\x01\x18\x05\x0f\n\r\f\x0e\x18\f|vsluwvqpzlx{t~`xhdwa\x17cdyimo~nm\x12hTOWWAW%RZGSN^]\"WC_EKAPD4LJTMIH[M0B:7*714?>8.>N:<> $%&'.2*)\"/2/),\x17\x16\x10\x06\x16f\x12\x15\x06\x1a\x1d\x18\x1b\x1a\x1c\n\x02\x01\n\0\x1a\x02\x0e\x02\x1d\vy\x0f\r\x13\x06\x07udps\x1e`tum{z?>, <6> >qf\x12rjk.)=3-3\x01\x15\x07KIRWBZYG_]DK]BT@5QF3RH8_H?XL9swe&7@#7I+#0\x06\x04s\x05,>agmys)")
      }), CKFinder.define(S(">|\v\x07+-  4h\x05&.> (=`\x168>6\x04'3!1<-t\x1a42:0\x13\x07\x15\r\0\x11"), [S("\x11g}ppdd{vh~"), S(")@ZYH\\V"), S("B'+\x11"), S("2QUV]UWW_"), S("\x10RYU}{rrj6Oouq1TEXaL@@"), S("\x18m\x7fch<]TfHLGAW\tsMDZGMYK\\\x1fw[_QeDRNP_L\x13z_S,$0:j!)3"), S("D1#?<h\t\0\n$ +5#}\x0718&;9-?(s\x1b73\x051\x10\x06\x12\f\x03\x10G.\v\x07\0\b\x1c\x16#\x05\v\x1f\x11\x06X\x13\x17\r"), S("%eln@DOI_\x01b_UW_G\x1ap^T\\")], function (w, y, C, e, b, _, x, s) {
        "use strict";
        var t = S("\x13wtzt0(*+9=3?\x16DO\n"), n = S("\x13wtzt0(*+9=3?\x12DO\n"),
          i = S(" QMPMQOHF\x13KI_BBZDT\t") + S("8MUK\x06\r\x05") + S("/\\TTG\x0e\x05\r") + S("\x0em\x7fef|y/&,") + S("'Z@MCX\x17\x1e\x14") + S("!OBVBOI\x12H__C\x16") + S("3YTN\x1aOP^OT\x07") + t + ";" + S('"NE]\vOM@MCX\x17') + n + ";",
          r = i + S("'_@N_D\x17") + t + S("-\x15GUXU[@\x0f") + n + ";",
          a = S(',\x11GBW\x11S_@\b\x14LC\x18\x1aRH\x13XV,$\f") f:5kj8>.sm+*os=!x115?\x12?20wIA\x1f\x1eFE\x15\x13\x11\x05\x0fVN') + i + S("\x165&") + S("'\x14@GL\fLB[\rJI\x12\x14\\B\x19^PV^r\\SZ`<?ad64$uk10qm';~$ ?t(+ux0>f~>59M\b\x0f\x02\x03\0K\x17\x1a\f\x1c\x02\t\x1aLO\x03\x05\v\x1f\x11HT\x13\x11\n\n\x17\x1d\x04D\x11oog8") + i + S("\x1b>#"),
          l = S("\x16+yl~rs=mmC\x1c\0X_\x18\x06N\\\x07_Y@\rSR\x12\x11Q\\ZADXTJ\x07\x19_RPK2..0fe531%/vn") + i + S("8\x1b\x04"),
          u = S("3\bC_S]V\x1aHN^\x03\x1d;:\x7fc-1h2:%j61on,??&!;9%jz:55(/13\x13CB\x10\x10\x1c\n\x02UK") + i + S("*\t\x12"),
          c = S("5\n^^K[VY\x1dMM#|`8?xf.<g?9 m32rq!'-93jz") + r + S("\x103,"),
          d = S("\r2f}v2rxa+5cb';ui0yIMGmEHC\x07UT\b\v__M\x12\x12JI\x0e\x14\\B\x19^PV^u^QQhhb>9gf4<0&.qo") + i + S("6\x15\x06") + S("@}+%6$+\"h:8(qo54mq;'z $;x$'y|.*&\f\x04_A\0\f\x15\x17\x04\b\x13Q\x02\x02\0\nK") + r + S("\x147("),
          E = S("6\vQT]\x1b]QJ\x02b:9~d,2i. &.\x02,#*p,/qt&$4e{! a}7+N\x07\v\x0f\x01,\x05\b\x06ACK\x11\x10LO\x03\x05\v\x1f\x11HT") + i + S('\x1a9"');

        function f(s, r) {
          var a = s.request(S("A$*( 5}/,>\x0f%>>#1(77")).where({"view:isFolder": !1}), o = [], l = window.top.document,
            e = C.template(_), t = y(C.template(x)(), l), u = 0, c = y(e(), l);
          c.attr(S("+HD\\"), s.lang.dir);
          var d = c.find(S("\r l{w?u}ys:hk\x7fmuxi")), f = c.find(S("\x10?qxr8p~t|7knxhvEV\x0fAQQRHF\x04DNTY")),
            h = c.find(S("5\x18TS_\x17]UQ[\x1203'5- 1j*<>?##c?\"4$")),
            g = c.find(S("\x169{r|6ztrz\rQPFRLCP\x05@DMC\0@N]T")),
            p = c.find(S("/\x1eRYU\x19S_[]\x14JIYKWZ7l+-\"*k$'<$?"));
          s.lang.dir === S('"OPW') ? (f.css(S("%TNOA^"), S("\x0f ?'vy")), h.css(S("\x1esEGV"), S("Duhr-$"))) : (f.css(S("@-'%0"), S("8\t\x14\x0eYP")), h.css(S("\x1cowxHU"), S("\x1a+2({r"))), a.forEach(function (e, t) {
            var n = e.getUrl(), i = e.get(S('C*$+"'));
            o.push({url: n, name: i, file: e}), i === r && (u = t)
          });
          var v = {files: o, current: u, last: o.length - 1};

          function n() {
            var n, i, e, t, r, o;
            v.current <= 0 ? (v.current = 0, h.hide()) : h.show(), v.current >= v.last ? (v.current = v.last, f.hide()) : f.show(), e = (i = v.files[v.current]).url, r = (t = i.name).substr(t.lastIndexOf(".") + 1), o = s.fire(S('\x13r|zr"ih~jt{h'), {
              templateData: {
                fileIcon: function () {
                  var e = y(l).width(), t = y(l).height();
                  return s.request(S("3R\\ZR\x02^_Ou^QQ"), {size: t < e ? e : t, file: i.file, previewIcon: !0})
                }, fileName: t
              }, file: i.file, url: e, extension: r, template: E
            }, s), g.text(i.name), p.text(v.current + 1 + S("\x0f0>2") + v.files.length), s.request(S("/VX^VG\x0fRRK\\V^_I\x7fS,")), s.request(S("\x19|rpxm%SDNFGQ"), {files: a[v.current]}), n = y(C.template(o.template)(o.templateData), l), o.events && w.forEach(o.events, function (e, t) {
              n.on(t, e)
            }), d.append(n), w.isFunction(o.afterRender) && o.afterRender(n), s.request(S("3RZUBK\x03NI]M"), {node: c})
          }

          function i(e, t) {
            d.html(""), e.stopPropagation(), v.current += t, n()
          }

          function m() {
            c.remove(), t.remove();
            var e = a[v.current];
            e.trigger(S("/V^QFG"), e)
          }

          t.appendTo(y(S("%DHLP"), l)), c.append(d).append(h).append(f).appendTo(y(S(")HDHT"), l)), c.focus(), c.on(S("\rmcyry"), function () {
            m()
          }), y(c).on(S("5]RA]ULR"), function (e) {
            e.keyCode === b.left && i(e, s.lang.dir === S("\x0f|e`") ? -1 : 1), e.keyCode === b.right && i(e, s.lang.dir === S("\x15zcj") ? 1 : -1), e.keyCode === b.escape && (e.stopPropagation(), m())
          }), h.on(S("<^RV#*"), function (e) {
            i(e, -1)
          }), f.on(S(" BNJGN"), function (e) {
            i(e, 1)
          }), n()
        }

        function h(e, t, n) {
          var i = document.createElement(e);
          return !!i.canPlayType && "" !== i.canPlayType(t[n])
        }

        return function (o) {
          o.setHandlers({
            "image:previewUrl": function (e) {
              var t, n;
              return t = e.file.get(S("/V^^WQG")), n = {
                fileName: e.file.get(S("1\\RYP")),
                size: Math.round(e.maxWidth) + "x" + Math.round(e.maxHeight),
                date: e.file.get(S("5RVL\\"))
              }, e.noCache && (n.d = (new Date).getTime()), o.request(S("\x1e|OLOBJA\x1cRZE"), {
                command: S("\x1dWrAFGsV@PNM^"),
                params: n,
                folder: t
              })
            }, "file:preview": function (e) {
              var t = e && e.file || o.request(S("\x14s\x7f{}j |yi]jRSGMP")).first();
              t && f(o, t.get(S('A,") ')))
            }
          }), o.on(S("%@NDL\x10[^HXFUF"), function (e) {
            var t = e.data.url, n = e.data.extension.toLocaleLowerCase();
            if (s.isExtensionOfImage(n) && (e.stop(), e.data.templateData.url = t, o.hasHandler(S("\x1dwrAFG\x19TWCQAL]~^A")) && (e.data.templateData.url = o.request(S("\x11{~urs-hk\x7fmuxiJRM"), {
              file: e.data.file,
              maxWidth: .95 * y(window.top).width(),
              maxHeight: .95 * y(window.top).height()
            })), e.data.template = a, e.data.events = {
              load: function (e) {
                e.target.id && y(e.target).css(S("B'-66+)0"), "").prev().remove()
              }
            }), /^(flac|mp3|ogg|opus|wav|weba)$/.test(n) && function (e) {
              return h(S("=_J$(-"), {
                flac: S("\njyig`?w~rw"),
                mp3: S(")K^HDA\0]AWT"),
                ogg: S("E'2, %d#*)"),
                opus: S('=_J$(-l+"!|h*%/).=rr>"&\''),
                wav: S("?!4&*+j1&>"),
                weba: S("+MXJF_\x1eEVVX")
              }, e)
            }(n) && (e.stop(), e.data.templateData.url = t, e.data.template = l, e.data.events = {
              click: function (e) {
                e.stopPropagation()
              }
            }), /^(mp4|ogv|webm)$/.test(n) && function (e) {
              return h(S("6AQ]_T"), {mp4: S("@7+'!*i*8}"), ogv: S(".YYUW\\\x1bZQP"), webm: S("+ZDJJ_\x1eEVVX")}, e)
            }(n) && (e.stop(), e.data.templateData.url = t, e.data.template = u, e.data.events = {
              click: function (e) {
                e.stopPropagation()
              }
            }), /^(pdf)$/.test(n) && (e.stop(), e.data.template = t ? c : d, e.data.templateData.url = t || "", e.data.afterRender = function (e) {
              setTimeout(function () {
                e.closest(S(",vZNRX\\WQMk")).focus()
              }, 500)
            }, !t)) {
              var i = e.data.file;
              e.data.events = {
                load: function (t) {
                  t.currentTarget.alt && (i.get(S("4SY[\\\\H")).getResourceType().get(S("+Y^K\x7fB^JJwZ[ZYW^")) ? r(o.request(S("\x1eyIMG\x19C@RwZFRRy_B"), {
                    file: i,
                    cache: 86400,
                    params: {d: i.get(S("\x14qwc}"))}
                  }), y(t.currentTarget).parent()) : o.request(S("B%-)#}/,>\x1e>!"), {file: i}).then(function (e) {
                    r(e, y(t.currentTarget).parent())
                  }))
                }
              }
            }

            function r(e, t) {
              t.find(S("=WY2 /&")).attr(S("C77%"), e).css(S("3P\\EGTXC"), ""), t.find(S("(@GL")).remove()
            }
          }, null, null, 90), o.on(S("+OB@[UIF~Q[C\r^PV^\x06KWZ7"), function (e) {
            e.data.items.add({
              name: S("\vZdkx"),
              label: e.finder.lang.common.view,
              isActive: e.data.context.file.get(S("\x1a}sqzzR")).get(S(",LMC")).fileView,
              icon: S("\x19ypz0hvEV"),
              action: function () {
                f(o, e.data.context.file.get(S("\r`n}t")))
              }
            })
          }, null, null, 10), o.on(S('\x10e}|xwwe"k\x7fhyi$RAHL\x19BLJB'), function (e) {
            var t = e.finder;
            e.data.toolbar.push({
              name: S("4c_RO"),
              icon: S("'KBL\x06ZDKX"),
              label: t.lang.common.view,
              type: S("8[OOHRP"),
              priority: 80,
              action: function () {
                f(t, e.data.file.get(S("\x11|ryp")))
              }
            })
          })
        }
      }), CKFinder.define(S('"`ocOILLX\x04aBJZ\\TA\x1cr\\ZRK\x16|RPXMy)-6&6'), [S(":Y]^U]//'")], function (e) {
        "use strict";
        return {
          attachTo: function (n) {
            var i = new e.Collection;
            return i.search = function (t) {
              var e;
              n.length && ("" === t ? (e = n.toArray(), i.isFiltered = !1, i.filter = t) : (e = n.filter(function (e) {
                return new RegExp(t.replace(/[\\^$*+?.()|[\]{}-]/g, S("%z\x03\x0e")), S("\x13s|")).test(e.get(S("D+'*-")))
              }), i.isFiltered = !0), i.reset(e))
            }, i.listenTo(n, S("*YI^K["), function () {
              i.reset(n.toArray()), i.isFiltered = !1
            }), i.listenTo(n, S("?2$/,2 "), function (e) {
              i.remove(e)
            }), i.listenTo(n, S("9[_X"), function (e) {
              i.add(e)
            }), i.isFiltered = !1, i.comparators = {}, i.sortFiledName = void 0, i.sortAscending = !0, i.on(S("\x19ys}syz\x1aOCNA"), function () {
              i.sortFiledName === S("8W[VY") && i.sort()
            }), i.comparator = function (e, t) {
              if (!this.sortFiledName || !this.comparators[this.sortFiledName]) return 1;
              if (e.get(S("9LRYJ\x04V3\x07-/  4")) !== t.get(S("&QAL]\x11E^h@\\UWA"))) return e.get(S("@7+&3\x7f/4\x0e&&/)?")) ? -1 : 1;
              if (!1 !== e.get(S("1DZQB\f^K\x7fUWXXL"))) return e.get(S("\x16yyt\x7f")).localeCompare(t.get(S("4[WZ]")));
              var n = (0, this.comparators[this.sortFiledName])(e, t);
              return 0 === n ? n : this.isSortAscending ? n : -n
            }, i.addComparator = function (e, t) {
              this.comparators[e] = t
            }, i.sortByField = function (e) {
              this.sortFiledName = e, this.sort()
            }, i.sortAscending = function () {
              this.isSortAscending = !0, this.sort()
            }, i.sortDescending = function () {
              this.isSortAscending = !1, this.sort()
            }, i.addComparator(S("\x0eaq|w"), function (e, t) {
              return e.get(S("\x11|ryp")).localeCompare(t.get(S("2]UXS")))
            }), i.addComparator(S("9IRFX"), function (e, t) {
              var n = e.get(S("'[@PN")), i = t.get(S("#WL\\B"));
              return n === i ? 0 : i < n ? 1 : -1
            }), i.addComparator(S("@%#7!"), function (e, t) {
              return e.get(S("\x10usgq")).localeCompare(t.get(S("3PTBR")))
            }), i
          }
        }
      }), CKFinder.define(S("\x11fvla7TS_suxxl0tDOSHDRB[\x06lB@H]\0sY]\\GPdRKP@^XtS^'$\v7!(h#'="), [], function () {
        return S("$\x19JFJLF\x15&$UT\r\x11[G\x1aYWU]U\x1aFA77\x0331#-d&*&;:wi/&(b39=<'0{%=*3!99s6\r\0\x05\x06I\x16\x0f\x1d\rKT\x10\x17PN\x06\x04_\x01\x1a\x0e\x10V\n\x05EU\b\f\x1c\x10A\n\b>jjuss(}s{i0,}qu{|65xvu|'9\x7fvx\\HNMPAwCTASOO\x0e\rZNRX\\WQM\v\x15\t\x1b\x1aM]QKZ}c98ye/3f'+&)m32r[[stuv,#fzz5)p6\x13 \x01\x17\r\x13\x03G\x15\x14\x0e\x02\x1f\f\f\x03\x15\x15OQ\x10\x1c\x05\x16\x1a\x15\x1f\x1f^\x06\x05@}|yx;%os&`yOikoz|e2ni5u\x7f}zq~x <|HDAHAA\x04\\S\x16WV\fIO[Q\x1c[P[[FXK\x04\x18@G\x02\x1eV4o.\"*\"h#!;jvqpnm<% q)(:2>-! cb#\"\x12\b\x05\v\x10\x1e\x1dX\x15\x14HUfQA\x03\x11\x13\x17\x1fJ\x7f")
      }), CKFinder.define(S('5BR@M\x1bxw{WQ$$0l\x10 +7$(>.?b\b&<4!|\x17=98+<\b>/4$:\x04(\x0f\x02\x03\0/\t\x18\x1c\x1e"\x18\b\x03A\x14\x1e\x06'), [], function () {
        return S("&\x1bDHHN@\x13$&KJ\x0f\x13]A\x18[YW]\x15_UQP3$\x10&7,<\",\0'*+(`<9+7 z6#$,67{! TV\\\b\f\x13\x11\x11F\x13\x11\x19\x0fVN\x1f\x0f\v\x19\x1ePS\x1a\x14\x1b\x12E[\x19\x10\x1a>\x16\x10orgQavo}mm(+xllf~uwk)7'58o{wix#=[Z\x1f\x03MQ\bIIDO\vQP\f\x11:\r\x1d_UWS[\x063\x06_UK\x1e\\, 10yg%,.d)##\"=*}#7 =/33u07:;8s<\x15\x12\x16\f\tH\0\x0e\r\x05\x0e\x18L\x18\x07B\x03\x05\x13\x07\x11X\x12\x1e\v\x18\x18\x17\x19\x19\\A\n\b>gms&ddhyx1/mdv<q{{zer5k\x7fhug{{\rHOBC@\vD]Z^DA\0LC_RY\x11\n??>\x04U[YYQ\x1e\\, 10yg%,.d)##\"=*}#7 =/33u07:;8s3\x01\x03\x07\x0fF[1\x0e\f\x1d\x02WC\x01\x0f\r\x15\x1dLy}IY\x13\x11\x0fDquA\x1a\x16v!aoevu:*jam!nf`\x7fbw>fpe~b|~6up\x7fxE\fAVWQIJ\x05KFDOF\x0eL[W\x1fP\\ZYD]\x14H^OTDZ$l+.%\"#j!':>8opEYXn::%##x-#+9`|+\x05\x19\x16AD\v\x07\n\rTH\b\x07\v-\x1a\x03\x05\x1d\x1e#\x1c\x12\x03\x10[Z\x0f\x1d\x1f\x17\x11ddz>&4$'l`yjnakk-3vzgtt{}}8;j|rjE\x1c\0X_\x18\x06N\\\x07]BHYF\x0fML\x10\r><\n\x18\\PL\x0564\x02[)7b ($54uk) *`-'?>!6y'3$1#??q43>\x07\x04O\0\x11\x16\x12\b\x05D\b\x07\x03\x0e\x05MN{{zH\x19\x17\x15\x1d\x15Z\x18\x10\x1c\r\f=#ahb(eogfyn!\x7fk|ykww9|{v\x7f|7w}\x7f{s\x02\x1fjFMBNS\x14\x06FJNHB\x11:8\x0e\x1cP\\@\t20\x06_UK\x1e\\, 10yg%,.d)##\"=*}#7 =/33u07:;8s<\x15\x12\x16\f\tH\x04\v\x07\n\x01K\x0f\x06\bB\x13\x19\x1d\x1c\x07\x10[\x05\x1d\n\x13\x01\x19\x19S\x16m`ef)lhw}}(5\x06\x04\x073y\x7fbf`5bnh|'9hxfk\x02\x01LBI@\x1b\x05KBLhY^Z@]yWZS]B\x15\x18M[YUSZZ8|`rfe\".;(('))sm48!26933zy,:0(;bB\x1a\x19^D\f\x12I\0\f\x03\f\x04\x19N\x12\rSLy}IY\x13\x11\x0fDq@R\x1a\x16v?\b")
      }), CKFinder.define(S('#gn`NFMOY\x03`AKE]W@\x1bs_[]J\x15mUXILo\x02*,+6#\x15-:#1))\x07"167\x05=0!'), [S("5CY\\\\HH_RLZ"), S("\x15|fm|hb"), S("%eln@DOI_\x01zDX^\x1c\x7fPOtW]_"), S("\vOFHf~uwa;C\x7froj5Y}n{0cNNOAFRNGG|BIZ"), S(";\x7fvxV.%'1k\x13/\"?:e\t->+`\x19%7>\x02<3 "), S("\rzjhe3P_S\x7fy||h4HxsoL@VFW\n`NDLY\x04oEA@CT`VG\\LR\\pWZ[XwK%,l'+1"), S('.[UIF\x12w~p^V]_I\x13i[R0-#7!6i\x01!%/8c\x0e& ?"7\x011&?-==\x136=:;\x16\x0e\x11\x17\x17-\x11\x03\nF\r\x05\x1f')], function (e, t, o, n, i, r, s) {
        "use strict";
        return n.extend({
          name: S("'kFD_IUZbU_G"),
          template: "",
          tagName: S("\x0ei\x7fc\x7f"),
          events: {
            'change [name="ckfChooseResized"]': function (e) {
              t(e.currentTarget).val() === S("#{zER[]EF") ? (this.$el.find(S("$\vELN\x04ICCB]J\x1dCW@]OSS\x15PWZ[X\x13\\526,)h .-%.8")).removeClass(S("\vyd#|dpfv9q\x7fdy{v~x")), this.$el.find(S(":\x15_VX\x12#)-,7 k5-:#1))c&=056y<8'--z22-++")).textinput(S("B&*$$+-")).removeAttr(S(" EKPEGJBL")).first().focus()) : (this.$el.find(S("2\x1dW^P\x1a[QUTOX\x13M%2+9!!k.%(-.a.;<$>?~2<3;<*")).addClass(S("&RA\x04Y_MYK\x02TXARVYSS")), this.$el.find(S("/\x1eRYU\x19V^XWJ_\x16NXMV:$&n-(' -d#%<8:o9?\"& ")).textinput(S("\x1fDHQBFIC")).attr(S("\x0ekybsqxpr"), S("!FJWDDKMM")))
            }
          },
          childEvents: {
            keydown: function (e, t) {
              if (t.evt.keyCode === o.down || t.evt.keyCode === o.up || t.evt.keyCode === o.tab) {
                if (t.evt.preventDefault(), t.evt.stopPropagation(), t.evt.keyCode === o.down || t.evt.keyCode === o.up) {
                  var n = this.collection.where({isActive: !0}),
                    i = n.indexOf(e.model) + (t.evt.keyCode === o.down ? 1 : -1);
                  i < 0 && (i = n.length - 1), i > n.length - 1 && (i = 0);
                  var r = this.children.findByModel(n[i]);
                  r && r.focus()
                }
                t.evt.keyCode === o.tab && e.$el.closest(S(",\x03MDV\x1cVZUYYP")).find(S("\fVjndp?p\x7fs;ummntr@")).eq(this.finder.util.isShortcut(t.evt, S("9ISU[J")) ? -1 : 0).focus()
              }
            }
          },
          collectionEvents: {
            reset: function () {
              this.$el.html("")
            }
          },
          onRender: function () {
            var e = this;
            setTimeout(function () {
              e.$el.enhanceWithin()
            }, 0)
          },
          getChildView: function (e) {
            var t = {
              name: S(".lX^]@QgSDQC__uI[R"),
              finder: this.finder,
              template: r,
              tagName: S(" EKU"),
              events: {
                'keydown input[type="radio"]': function (e) {
                  this.trigger(S("\x1bwxg{OVL"), {evt: e})
                }
              },
              focus: function () {
                this.$el.find(S("?)/260")).focus()
              }
            };
            return e.get(S("\rmzce}~")) && this.addCustomSizeViewConfig(t), i.extend(t)
          },
          addCustomSizeViewConfig: function (e) {
            e.name = S("/sY]\\GPdRKP@^X~KL4./\n0 +"), e.className = S("B /#k$ &%8)`<*#8(60x?:9>?v?(-+\x0f\f"), e.template = s, e.tagName = S("=ZV6"), e.ui = {
              width: S("*BB][[k_S^Q\b\x14TS_yNOIQR\x17(&7,g\x1b"),
              height: S("\x12zzeccCw{vy <|KGaVWQIJ`LCLDY\fr")
            }, e.setSize = function (e, t) {
              var n = e <= 0 ? 1 : e, i = t <= 0 ? 1 : t;
              this.ui.height.val(n), this.ui.width.val(i), this.model.set({size: i + "x" + n})
            }, e.events[S(';USNJ4a\x026-k1.,="')] = function () {
              var e = this.model.get(S(".XYUF[")), t = this.model.get(S("=VZ)&*7")), n = t, i = this.ui.width.val();
              i.length || (i = 1);
              var r = parseInt(i);
              r < e ? n = r * (t / e) : r = e, n = Math.round(n), this.setSize(n, r)
            }, e.events[S("\x1fIORVP\x05fRA\x07BNEJF[")] = function () {
              var e = this.model.get(S("'_@N_D")), t = this.model.get(S("'@LCLDY")), n = e, i = this.ui.height.val(),
                r = parseInt(i);
              i.length || (r = 1), r < t ? n = r * (e / t) : r = t, n = Math.round(n), this.setSize(r, n)
            }
          },
          getSelected: function () {
            return this.collection.findWhere({name: this.$el.find(S("\x10x|caaMyyt\x7f&>~uycIMLW@tB[@PNH\x0fs\x15SYWP_PR")).val()})
          }
        })
      }), CKFinder.define(S("E\x05\f\x0e $/)?a\x02?5'?1&y\x1115?(s\x1e60\x0f\x12\x07%\r\t\x03\x14"), [S("\x1biszzRRALV@"), S("\x0fz`gvfl"), S("8[[XW_QQ%"), S("3w~p^V]_I\x13pQ[5-'0k\x03/+-:e\x1d%(9<\x7f\x12:<;&3\x05=*3!99\x172\x01\x06\x075\r\0\x11")], function (w, s, a, r) {
        "use strict";
        var d = S("\x0fONqfgayz"), o = 100, n = 110, y = S("\n#W=#6M:jH$8/J30A5AF\x7f2Z`\x0fyy^\x17\v\x1dT\x0e"),
          l = S("3\x1b\x1dmi\x17d\x11\x1f\x15");

        function e(t) {
          var n = t.data.context.file;
          (t.data.items.add({
            name: S("\fNf`\x7fbw"),
            label: t.finder.lang.common.choose,
            isActive: n.get(S("\rh`|uwa")).get(S("-OL\\")).fileView,
            icon: S("#GN@\nKAED_H"),
            action: function () {
              var e = t.finder.request(S("\x13r|zrk#}~hN{sEBVF@"));
              1 < e.length ? c(t.finder, e) : b(t.finder, n)
            }
          }), n.isImage() && t.finder.config.resizeImages) && (n.has(S("\x17qt{|yO{lI[GgEQG")) && n.get(S("-GBQVWaQF_M]}[O]")).has(S("*D^DIF^P^`]OS")) || n.once(S("\x1d}wAOEF\x1eLKFOLxN_DTJtPFR"), function () {
            new a.Model({
              name: S("=}W/.1&\x16 5.2,.\x02!,)*"),
              label: t.finder.lang.chooseResizedImage.title,
              isActive: n.get(S("\x15pxt}\x7fi")).get(S("1SPX")).imageResize || x(n),
              icon: S("\x1d}tF\fAKKJUB\x05[OXEWKK"),
              action: function () {
                f(t.finder, n)
              }
            }).set(S("&FK]C]I"), x(n))
          }), t.data.items.add(new a.Model({
            name: S("#gMIH[LxN_DTJTx_RSP"),
            label: t.finder.lang.chooseResizedImage.title,
            isActive: n.get(S("\x16qwu~~n")).get(S("\x1az\x7fq")).imageResize || x(n),
            icon: S("0RYU\x19V^XWJ_\x16NXMV:$&"),
            action: function () {
              f(t.finder, n)
            }
          })))
        }

        function t(e) {
          var t = e.data.file;
          if (_(e, function () {
            b(e.finder, t)
          }), t.isImage() && e.finder.config.resizeImages) {
            var n = t.has(S("5_ZY^_iYNWE%\x05#7%")) && t.get(S("=WR!&'\x11!6/=-\r+?-")).has(S("\x1crlvGHLBHvO]M")),
              i = new a.Model({
                name: S("\x1c^vpORGqAVO]MMcFMJK"),
                type: S("7ZLNOSS"),
                priority: o,
                alignment: S("\x17hksv}og"),
                icon: S("\x13w~p:{qutox3mERKYAA"),
                label: e.finder.lang.chooseResizedImage.title,
                isDisabled: !(t.get(S("8_UWXXL")).get(S("\x1d\x7f|L")).imageResize || x(t)),
                action: function () {
                  f(e.finder, t)
                }
              });
            n || (t.once(S('/SYS]SP\f^UX]^nXMV:$\x06"0$'), function () {
              i.set(S("%OTl@YJNAKK"), !x(t))
            }), e.finder.request(S("\x16~ux}~&z{krDQJ^@B"), {file: t})), e.data.toolbar.push(i)
          }
        }

        function u(e) {
          _(e, function () {
            c(e.finder, e.finder.request(S("6QQU_H\x06Z[K\x13$.&'1##")))
          })
        }

        function c(t, e) {
          var n = e.clone();
          n.forEach(function (e) {
            !e.getUrl() && e.get(S("<[QS$$0")).getResourceType().get(S("5CD]iHTDD}P-,#- ")) && e.set(S("\x1chls"), t.request(S("3R\\ZR\x02^_OlOQG9\x140/"), {file: e}))
          }), t.fire(S("/VX^VG\x0fU_WVI^"), {files: n}, t), M(t)
        }

        function f(e, t) {
          var n = new a.Collection, i = e.config.initConfigInfo.images;
          C(n, e, t, i), t.on(S("\x12p|txp}#sv}z{MERKYAaGSI"), function () {
            n.reset(), C(n, e, t, i)
          }), e.request(S("=ZV!--$"), {
            title: e.lang.chooseResizedImage.title,
            name: S("8zRTSN[m%2+9!!\x0f*)./"),
            buttons: [S("\x17{xtxyq"), S("*DG")],
            view: new r({finder: e, collection: n}),
            context: {file: t}
          })
        }

        function h(e) {
          var t = this.finder, n = e.file, i = new s.Deferred;
          if (n.has(S("3]XWP]k_HUG[{!5#")) && n.get(S("E/*)./\x19)>'55\x153'5")).has(S("\x19uiuzwqAMqJ^@"))) i.resolve(n); else {
            var r = n.get(S("\x11t|xqse"));
            t.once(S("\x16twtwzry$~FUGQ\x1ebCSzLYBVHJf]PUVG"), function (e) {
              var t = e.data.context.file, o = new a.Model;
              e.data.response.resized && o.set(S("'ZLYBVHJ"), e.data.response.resized), e.data.response.originalSize && o.set(S("\x18vhr{tp~LrKYA"), e.data.response.originalSize), w.forEach(e.data.response.resized, function (e, r) {
                if (r !== d) {
                  var t = {fileName: e.name ? e.name : e};
                  e.url && (t.url = e.url), o.set(E(r), t, {silent: !0})
                } else w.forEach(e, function (e) {
                  var t = e.name ? e.name : e, n = t.match(y);
                  if (n) {
                    var i = {fileName: t};
                    e.url && (i.url = e.url), o.set(E(r, n[1]), i, {silent: !0})
                  }
                })
              }), t.set(S("\x12zytqrJ|irfxZ~T@"), o), e.data.context.dfd.resolve(t)
            });
            var o = {fileName: n.get(S("%HFEL"))};
            w.isArray(t.config.resizeImages) && t.config.resizeImages.length && (o.sizes = t.config.resizeImages.join(",")), t.request(S(";_RSR!/&y7 (#"), {
              name: S(":|YIlZ3(8& \f+&/,9"),
              folder: r,
              params: o,
              context: {dfd: i, file: n}
            })
          }
          return i.promise()
        }

        function g(o) {
          var e = this.finder, t = o.file, n = new s.Deferred, i = o.size;
          if (!o.name) throw S("\x19Nsy=z~T@\fMEHC\x07XHXJAHZJB\x11[@\x14GSFMPH^X");
          if (o.name === d) {
            if (!o.size) throw S("\x15B\x7f}9~zh|0lI[G\x03TDTFEL^N^\rG\\\x10CWBA\\DR\\\x19MSYS\x1eJ3(,$dg=))$/6nc").replace(S(")QEM@KR"), d);
            i = o.size
          } else {
            if (!e.config.initConfigInfo.images.sizes[o.name]) throw S("4a^R\x18W[VY\x1d\x1cD. /&9gf.;i$$8m- >7;4!'33x?5)|/;,\t\x1b\x07\x07D\f\v\x06\x0f\f\x19").replace(S('@:,") ;'), o.name);
            i = e.config.initConfigInfo.images.sizes[o.name]
          }
          if (t.has(S("\x12zytqrJ|irfxZ~T@")) && t.get(S("=WR!&'\x11!6/=-\r+?-")).has(S("1@VG\\LR\\lHW") + i)) n.resolve(t); else {
            var r = t.get(S("E ($-/9"));
            e.once(S("0R]^YTXS\x02X\\OYO\x04v- %&\x16 5.2,"), function (e) {
              var t = e.data.context.file, n = e.data.response.url, i = t.get(S("-GBQVWaQF_M]}[O]"));
              if (i || (i = new a.Model, t.set(S("\x13}xwp}K\x7fhug{[AUC"), i)), o.save) {
                var r = i.get(S(" SGPM_CC"));
                r || (r = {}, i.set(S(">M%2+9!!"), r)), r.__custom || (r.__custom = []), r.__custom.push(n.match(l)[0])
              }
              i.set(E(o.name, o.size), {url: n}), e.data.context.dfd.resolve(t)
            }), e.request(S("1Q\\YXWY\\\x03I^RY"), {
              name: S("6~UX]^nXMV:$"),
              folder: r,
              type: S("&WGZ^"),
              params: {fileName: t.get(S("\x0eaq|w")), size: i},
              context: {dfd: n, file: t}
            })
          }
          return n.promise()
        }

        function p(e) {
          var t = this.finder, n = e.file, i = w.extend({fileName: n.get(S("\x13zt{r"))}, e.params);
          return e.cache ? i.cache = e.cache : t.config.initConfigInfo.proxyCache && (i.cache = t.config.initConfigInfo.proxyCache), t.request(S("\rm`}|s}p/cet"), {
            command: S(":kNRFF"),
            params: i,
            folder: n.get(S("?&..'!7"))
          })
        }

        function v(e) {
          var t = this.finder, n = e.file, i = new s.Deferred, r = n.getUrl();
          return n.get(S("\x1dxpLEGQ")).getResourceType().get(S("4@ERhKUCE~QR- ,'")) && (r = t.request(S("5P^T\\\0\\YInM/9;\x166)"), e)), r ? i.resolve(r) : t.request(S("7[VWV]SZ\x053$,'"), {
            name: S(":|YIxV,$\x171("),
            folder: n.get(S("/V^^WQG")),
            params: {fileName: n.get(S("8W[VY"))},
            context: {dfd: i, file: n}
          }), i.promise()
        }

        function m(e) {
          var t = this.finder, n = e.file, i = new s.Deferred;
          return t.request(S("4VYZUXT_\x06N[Q$"), {
            name: S("\x14Rsc^pv~Ior"),
            folder: n.get(S(")LD@IK]")),
            params: {fileName: n.get(S("5XVU\\")), thumbnail: e.thumbnail},
            context: {dfd: i, file: n, thumbnail: e.thumbnail}
          }), i.promise()
        }

        function C(f, h, e, t) {
          var n = e.get(S("7QT[\\Yo[L);'\x07%1'")), g = n && n.get(S('"LVLANFHFxEWK')) || "",
            p = e.get(S("#BJJCM[")).get(S("#EFJ")).imageResize,
            i = e.get(S("A$,(!#5")).get(S("B\"')")).imageResizeCustom, r = f.add({
              label: h.lang.chooseResizedImage.originalSize,
              size: g,
              name: S("\x19uiuzwqAM"),
              isActive: !0,
              isDefault: !1
            }), v = n && n.get(S('"QAVO]MM')), m = !0;
          if (w.forEach(t.sizes, function (e, t) {
            var n = e, i = p;
            if (!w.isArray(h.config.resizeImages) || !h.config.resizeImages.length || w.contains(h.config.resizeImages, t)) {
              if (v && v[t]) {
                var r = v[t].match(y);
                2 === r.length && (n = r[1]), i = !0
              } else if (g) {
                var o = g.split("x"), s = e.split("x"), a = parseInt(s[0]), l = parseInt(s[1]), u = parseInt(o[0]),
                  c = parseInt(o[1]), d = function (e, t, n, i) {
                    var r = {width: e, height: t}, o = e / n, s = t / i;
                    1 == o && 1 == s || (o < s ? r.height = parseInt(Math.round(i * o)) : s < o && (r.width = parseInt(Math.round(n * s))));
                    r.height <= 0 && (r.height = 1);
                    r.width <= 0 && (r.width = 1);
                    return r
                  }(a, l, u, c);
                u <= d.width && c <= d.height ? i = !1 : n = d.width + "x" + d.height
              }
              f.add({
                label: h.lang.chooseResizedImage.sizes[t] ? h.lang.chooseResizedImage.sizes[t] : t,
                size: n,
                name: t,
                isActive: i,
                isDefault: m && i
              }), m = !1
            }
          }), v && v.__custom) {
            var o = [];
            w.forEach(v.__custom, function (e) {
              var t = e.match(y);
              t && (t = t[1], o.push({
                label: t,
                size: t,
                width: parseInt(t.split("x")[0]),
                name: d + "_" + t,
                url: e,
                isActive: !0
              }))
            }), w.chain(o).sortBy(S("3C\\RCP")).forEach(function (e) {
              f.add(e)
            })
          }
          if (i) {
            var s = 0, a = 0;
            if (g) {
              var l = g.split("x");
              s = l[0], a = l[1]
            }
            f.add({name: d, custom: !0, isActive: i, isDefault: !1, width: s, height: a, size: s + "x" + a})
          }
          f.findWhere({isDefault: !0}) || r.set(S(":ROy[Y!4.7"), !0)
        }

        function b(e, t) {
          var n = t.getUrl(), i = new a.Collection([t]);
          if (!n) return F(e), void e.request(S("\x10w{\x7fq/qrlLhw"), {file: t}).then(function () {
            e.request(S("'DFKOI_\x14GYUW")), c(e, i)
          });
          c(e, i)
        }

        function _(e, t) {
          e.data.toolbar.push({
            name: S("\vOea`ct"),
            type: S("=\\J45--"),
            priority: n,
            icon: S("4V]Q\x15ZRTSN["),
            label: e.finder.lang.common.choose,
            action: t
          })
        }

        function x(e) {
          var t = e.get(S("6QWU^^N")).get(S("3UVZ")),
            n = e.has(S(")CFMJK}UB[IQqWCY")) && !!w.size(e.get(S("E/*)./\x19)>'55\x153'5")).get(S('?2$1*> "')));
          return t.imageResize || t.imageResizeCustom || n
        }

        function E(e, t) {
          return e === d ? S("<O[L);''\x117*\x18+<9?# ") + t : S("B1!6/=--\x1f9 \x12") + e
        }

        function M(e) {
          e.config.chooseFilesClosePopup && e.request(S("D&*(;,\x1a$<8>"))
        }

        function F(e) {
          e.request(S("\v`bokuc(`|za"), {text: e.lang.files.gettingFileData + " " + e.lang.common.pleaseWait})
        }

        return function (i) {
          this.finder = i, this.isEnabled = i.config.chooseFiles, i.config.ckeditor && (i.on(S("5P^T\\I\x01_UQP3$"), function (e) {
            var t = e.data.files.pop();
            i.request(S("'N@FN\x16JK[eC^"), {file: t}).then(function () {
              var e = {fileUrl: t.getUrl(), fileSize: t.get(S("\v\x7fdtj")), fileDate: t.get(S(";X\\JZ"))};
              i.config.ckeditor.callback(e.fileUrl, e)
            })
          }), i.on(S(':]UQ[\x05#)-,7 |5-:#1))\x07"167'), function (e) {
            var t = e.data.file, n = {fileUrl: e.data.resizedUrl, fileSize: 0, fileDate: t.get(S("\x0ekqew"))};
            i.config.ckeditor.callback(e.data.resizedUrl, n)
          })), this.isEnabled && (i.on(S("(JEEXHV[}T\\F\x0eS_[]"), function (e) {
            e.data.groups.add({name: S("B ,*)4-")})
          }, null, null, 10), i.on(S("9YTRI[G4\f'-1\x7f .$,p($\"!<5"), e), i.on(S("B7+**%);p9)>+;j\x1c3::o0>4<"), t), i.on(S('\x10e}|xwwe"k\x7fhyi$RAHL\x19BLJB['), u), i.on(S("!ALIHGIL\x13E@\x16~OYUx_RSP"), function (e) {
            e.data.context.file.set(S("!KNEBCuMZCQIiO[Q"), new a.Model)
          }), i.setHandlers({
            "image:getResized": {callback: h, context: this},
            "image:resize": {callback: g, context: this},
            "image:getResizedUrl": {callback: m, context: this},
            "files:choose": {
              context: this, callback: function (e) {
                c(i, e.files)
              }
            },
            "internal:file:choose": {
              context: this, callback: function (e) {
                b(i, e.file)
              }
            }
          })), i.setHandlers({
            "file:getUrl": {callback: v, context: this},
            "file:getProxyUrl": {callback: p, context: this}
          }), i.on(S("2P[X[VV]\0ZZI[Mz\x06'7\x02,*\"\x1d;&"), function (e) {
            e.data.context.thumbnail || e.data.context.file.set(S("3AGZ"), e.data.response.url), e.data.context.dfd.resolve(e.data.response.url)
          }), i.on(S("'L@KGCJ\x14lX^]@QgSDQC__uP_X%{-("), function (e) {
            var t = e.data.view.getSelected();
            !function (n, e, t, i, r) {
              if (e === S("\vc\x7fghy\x7fs\x7f")) return b(n, i);
              0 === e.indexOf(d + "_") && (e = d);
              var o = i.get(S(")CFMJK}UB[IQqWCY")), s = E(e, t);
              if (o && o.has(s)) {
                var a = o.get(s), l = {file: i};
                if (a.url) return c(i, a.url);
                var u = S("A$*( | -=\x1f9 ");
                return e !== S("(FXBKD@N\\") && a.fileName && (u = S("-GBQVW\tSPBe]JSAYYkM,"), l.thumbnail = a.fileName), F(n), n.request(u, l).then(function (e) {
                  c(i, e)
                })
              }

              function c(e, t) {
                n.request(S(",AANTT@\t\\\\RR")), n.fire(S("\x15p~t| xtrqlE\x1bPFWL\\BL`GJKH"), {
                  file: e,
                  resizedUrl: t
                }, n), M(n)
              }

              F(n), n.request(S("\x1evM@EF\x1eWCTASO"), {file: i, size: t, name: e, save: r}).then(function (e) {
                c(e, e.get(S("&NEHMN~H]FJTvR@T")).get(s).url)
              })
            }(i, t.get(S("5XVU\\")), t.get(S("\x14f\x7fm}")), e.data.context.file), i.request(S("1VZUYYP\x02]_HHOQF"))
          })
        }
      }), CKFinder.define(S("\nHGKgatt`<B|s`k6Xzox1VNRVBJQ\tdGEFNOYG@^g[VC"), [S("(\\DOI_]L_CW"), S("6]IL_IE"), S("5[VJPUUYIJZ"), S('?\x03\n\x04**!#5g\x1f#.;>a\r1"7|\x17:;:77')], function (r, o, s, t) {
        "use strict";
        var n = s.CollectionView;
        return n.extend(t.proto).extend({
          constructor: function (e) {
            t.util.construct.call(this, e), n.prototype.constructor.apply(this, Array.prototype.slice.call(arguments))
          }, _renderChildren: function () {
            this.destroyEmptyView(), this.attachCollectionHTML(""), this.isEmpty(this.collection) ? this.showEmptyView() : (this.triggerMethod(S("\x13vppxj| iyszzR\x1bALHICD\\@EE"), this), this._showInstantCollection(), this.triggerMethod(S(".]U_VVF\x0fUXTU_XHTQQ"), this), this.children.isEmpty() && this.getOption(S("$COK\\LX")) && this.showEmptyView())
          }, _onCollectionAdd: function (e, t) {
            var n = t.indexOf(e), i = this.getChildViews(), r = o(this.instantRenderChild(e));
            this.destroyEmptyView(), n >= i.length ? this.$el.append(r) : r.insertBefore(i.eq(n)), this.triggerMethod(S("C'-/+,?#.;w<*>57!"))
          }, _onCollectionRemove: function (e) {
            var t = this.getChildViewElement(e).remove();
            this.removeChildView(t), this.checkEmpty()
          }, _sortViews: function () {
            var e = this._filteredSortedModels();
            r.find(e, function (e, t) {
              var n = this.getChildViewElement(e);
              if (n.length) return this.getChildViews().index(n) !== t
            }, this) && this.resortView()
          }, _showInstantCollection: function () {
            var e = this._filteredSortedModels(), n = [], i = this.getOption(S("%EOAEN}EHY`@E[\\ZF"));
            i = s._getValue(i, this, [void 0, 0]), r.each(e, function (e, t) {
              n.push(this.getPreRenderer(e).preRender(e, i, t))
            }, this), this.attachCollectionHTML(n.join(""))
          }, buildChildView: function (e, t, n) {
            var i = new t(r.extend({model: e, finder: this.finder}, n));
            return s.MonitorDOMRefresh(i), i
          }, getChildViewElement: function (e) {
            return this.$(document.getElementById(e.cid))
          }, attachCollectionHTML: function (e) {
            this.el.innerHTML = e
          }, getPreRenderer: function () {
            throw S(":uSI\x1eV-1.&) (3--")
          }, getChildViews: function () {
            throw S(" oMW\x04LKWDLGNBYKK")
          }, instantRenderChild: function () {
            throw S("%hH\\\tCF\\AKBU_FVP")
          }
        })
      }), CKFinder.define(S("D\x06\r\x01!'..>b\x03 4$>6'z\x10>4<)t\n4;(\x13N!\f\t\b\t\tG/\x03\x07\t\x1e8\x06\x15\x06?\x1a\f\x1c\x18"), [S("\x17mw~~nn}pRD"), S('"IUPCUQ'), S("3w~p^V]_I\x13hJV,n\t&=\x06)#-")], function (t, a, o) {
        "use strict";

        function l(e) {
          if (e) return S(",NFF\\UDZQB\f") + (e.get(S("\x1ckwzW\x1bKPbJJCM[")) ? S(")LD@IK]") : S("\x1c{wsE")) + ":"
        }

        return {
          getMethods: function () {
            return {
              shouldFocusFirstChild: function () {
                if (this.el === document.activeElement && this.collection.length) {
                  var e = this.collection.first();
                  return e.trigger(S("1T\\W@E"), e), !0
                }
                return !1
              }, getEmptyViewData: function () {
                var e, t = !1;
                if (this.collection.isLoading) {
                  var n = this.finder.lang.files.loadingFilesPane;
                  e = {title: this.finder.lang.common.pleaseWait + " " + n.title, text: n.text}, t = !0
                } else e = this.collection.isFiltered ? this.finder.lang.files.filterFilesEmpty : this.finder.lang.files.emptyFilesPane;
                return {title: e.title, text: e.text, displayLoader: t}
              }, updateHeightForBorders: function (e) {
                var t = parseInt(getComputedStyle(this.el).getPropertyValue(S("8I[_XTPXm5-3"))),
                  n = parseInt(getComputedStyle(this.el).getPropertyValue(S("\x16gy}~rrz3}OUVLI"))),
                  i = parseInt(getComputedStyle(this.el).getPropertyValue(S("\x1aysozzR\fVLT\bQNL]B"))),
                  r = parseInt(getComputedStyle(this.el).getPropertyValue(S("+NB\\KUC\x1fQ[ABXU\x14MRXIV"))),
                  o = e.height - t - n - i - r;
                return this.$el.css({"min-height": o}), o
              }, checkDoubleTap: function (e) {
                var t = e.currentTarget.id, n = a(e.currentTarget), i = n.data(S("\x15u|~4su1iqjCI\x0fBP")),
                  r = e.timeStamp;
                n.data(S("B /#k.&d>$9.&b1%"), r);
                var o = i && r - i < 500, s = this.collection.get(t);
                this.trigger(l(s) + S(o ? "\filcdpb" : "\x12g{`u\x7f"), {evt: e, model: s})
              }
            }
          }, attachModelEvents: function (n, i) {
            var e = {
              focus: function (e) {
                this.getChildViewElement(e).find(S("6\x19MP\x17YHS")).focus(), this.trigger(S('C",*"r/%(9>++'), e)
              }, refresh: function (e) {
                this.refreshView(e)
              }, selected: function (e) {
                this.getChildViewElement(e).find(S("$\vSN\x05K^E")).addClass(S("\x19or1\x7fjq\r@AWMSC"))
              }, deselected: function (e) {
                this.getChildViewElement(e).find(S("(\x07_B\x01OZA")).removeClass(S('"VM\bDSF\x04KHXDXJ'))
              }, change: function (e) {
                e.changed.name && this.refreshView(e)
              }
            };
            t.each(e, function (e, t) {
              i.listenTo(n, t, e)
            })
          }, getEvents: function (r) {
            var n = {
              keydown: function (e) {
                if (e.keyCode !== o.tab || !this.finder.util.isShortcut(e, "") && !this.finder.util.isShortcut(e, S("\x17kqs}h"))) if (e.target !== this.el && e.target !== this.$el.find(S("=\x10\\+'o%-)#4e?#.;")).get(0)) {
                  if (e.target !== e.currentTarget) {
                    var t = a(e.target).closest(r), n = t.get(0).id, i = this.collection.get(n);
                    if (e.keyCode === o.menu || e.keyCode === o.f10 && this.finder.util.isShortcut(e, S("\x13g}\x7fql"))) return void this.trigger(l(i) + S("\vob`{uif~q{c"), {
                      el: t,
                      evt: e,
                      model: i
                    });
                    this.trigger(l(i) + S("\x1etEXFLSK"), {evt: e, model: i, el: t})
                  }
                } else this.trigger(S("%MBQME\\B"), {evt: e}); else this.finder.request(this.finder.util.isShortcut(e, "") ? S("#BJER[\x13DNTY") : S("$CID]Z\x10[^HX"), {
                  node: this.$el,
                  event: e
                })
              }, focus: function (e) {
                setTimeout(function () {
                  (window.scrollY || window.pageYOffset) && window.scrollTo(0, 0)
                }, 20), e.target === e.currentTarget && this.collection.length && (e.preventDefault(), e.stopPropagation(), this.trigger(S("5PX[LI^X")))
              }
            }, e = {
              touchstart: function (t) {
                var n = t.currentTarget.id, i = a(t.currentTarget);
                i.data(S("2P_S\x1b^V\x14NTI^V"), !0);
                var e = i.data(S("9YPZ\x10WQm5-6'-k3!$/$99"));
                e && clearTimeout(e);
                var r = this;
                e = setTimeout(function () {
                  if (i.data(S("\x0fszt>}{;cwlys"))) {
                    var e = r.collection.get(n);
                    if (!e) return;
                    r.trigger(l(e) + S("\x15zxv~nti~v"), {evt: t, model: e}), i.data(S("\x14v}q5pt6hrk|H"), !1)
                  }
                  i.data(S("-MDV\x1c[]\x19AYB[Q\x17OUP[P55"), void 0)
                }, 700), i.data(S('6TS_\x17RR\x10JP5"*n0,+"\'<>'), e)
              }, touchend: function (e) {
                var t = e.currentTarget.id, n = a(e.currentTarget);
                if (this.checkDoubleTap(e), n.data(S("\x1c~uy\rHL\x0ePJSD@"))) {
                  var i = this.collection.get(t);
                  if (!i) return;
                  this.trigger(l(i) + S("*H@DMD"), {evt: e, model: i})
                }
                n.data(S("\x1axw{3vN\fVLQFN"), !1)
              }, touchcancel: function (e) {
                a(e.currentTarget).data(S("(JAM\x01D@\x02D^GP\\"), !1)
              }, touchmove: function (e) {
                a(e.currentTarget).data(S("\nhgk#f~<f|av~"), !1)
              }, contextmenu: function (e) {
                var t = e.currentTarget.id, n = this.collection.get(t);
                a(e.currentTarget).data(S("\x1d}tF\fKM\tQIRKA")) ? e.preventDefault() : this.trigger(l(n) + S(";_RPK%96.!+3"), {
                  evt: e,
                  model: n,
                  el: document.getElementById(t)
                })
              }, click: function (e) {
                var t = e.currentTarget.id, n = this.collection.get(t);
                this.trigger(l(n) + S("@\".*'."), {evt: e, model: n, el: document.getElementById(t)})
              }, dblclick: function (e) {
                var t = this.collection.get(e.currentTarget.id);
                this.trigger(l(t) + S("\vhobl|xqx"), {evt: e, model: t})
              }, dragstart: function (e) {
                var t = this.collection.get(e.currentTarget.id);
                this.trigger(l(t) + S("3PGWPKM[IH"), {evt: e, model: t})
              }, dragend: function (e) {
                var t = this.collection.get(e.currentTarget.id);

                function n(e) {
                  e.cancel()
                }

                this.finder.on(S("\x1fUH\x18PSLVBDLL_"), n, null, null, 1), this.finder.on(S("\x19or&nivPDPJCMR"), n, null, null, 1), setTimeout(function () {
                  this.finder.removeListener(S("*^E\x17]XYAW_QSB"), n), this.finder.removeListener(S("\x13a|,dopj~ntywT"), n)
                }, 500), this.trigger(l(t) + S("C 7' -'."), {evt: e, model: t})
              }, blur: function (e) {
                e.target.tabIndex = -1
              }, focus: function (e) {
                e.target.tabIndex = 0
              }
            };
            return t.forEach(e, function (e, t) {
              n[t + " " + r] = e
            }), n
          }
        }
      }), CKFinder.define(S("5BR@M\x1bxw{WQ$$0l\x10 +7$(>.?b\b&<4!|\x12<:2+\x104=3s:0\x14"), [], function () {
        return S("\x13on)7qm4\x7funnsAXnLEACU\bTW!\x10IGY\x10R^RGF\v\x15MP\x17WS\\ZZ2a7*i))&,,8f:(<-?\"7s!<{477.>2)~*\tL\0\f\0\x1cK\x1c\x13TJ\x02\x18C\x1d\x18\x11\x05\x11\x1bT\b\vW\r\x10W\x18\x13\x0f\x10\x1ar,coh'8\r\x015y{mc.l|pa`)7c~5pytr0rpAEKMC\x07\x18\x1b\x07ZZJB\x13$&\fY\x03\rON\v\x17QM\x14OUIRZ`<?\x7fk-wyBue/%;pE+*ml)(\\k<0,{?1?,\x13\\@\0\x0f\x03K\x01\x01\x05\x0f\x18A\x04\0\t\x1f\\\x10\x1c\x10\fV\x02\x11T\x19\x14\x12\t\x1b\x11t!wj)gicq$qp1-g{>ber`v~7ed:nu0}pROGQ\tDJK\n\x17 \"\x10E\x1c\x11KJ\x0f\x13]A\x18CQMV^\x1c@C\x03o)p}NL=<wi#?b)'< =3*\x18:73=+z&!a.a\x1b\x1a_C\r\x11H\x13\r\x11\x1eK\x11\x10R@\0O\t\bK\b\v}DV\x1e\x12\nCt\x04{>\x7f~\x0e")
      }), CKFinder.define(S("9ypzTP[%3m\x0e+!3+-:e\r%!+<\x7f\x07;6#&y\x1474742r\x186\f\x04\x11*\n\x03\t1\x01\f\x1d"), [S("\x13vtu|zvt~"), S("\x1c^UYIOFFV\npNM^Y\x04nL]J\x1fxFVYc_RO"), S('+XHV[\x11ryu][RRJ\x16n^QMR^4$1l\x02,*";f\f" (=\x06>7=}0:"')], function (e, t, n) {
        "use strict";
        return t.extend({
          name: S("+jDBJCx\\U[c_RO"),
          template: n,
          className: S(",NEI\x1dW[_QF\x1b^V_U"),
          templateHelpers: function () {
            return {swatch: this.finder.config.swatch}
          },
          initialize: function () {
            this.model = new e.Model({title: this.title, text: this.text, displayLoader: this.displayLoader})
          }
        })
      }), CKFinder.define(S("\rzjhe3P_S\x7fy||h4HxsoL@VFW\n`NDLY\x04jDBJfXWD\x1aQYC"), [], function () {
        return S('5\nV\x18QH^Z\0\x1cU!7#0\'7/7<s<$%)f\x7fysr084%$e{90:p86\f\x04\x11N\r\v\b\x02\x1aI\x1f\x02A\x0f\x1a\x01RQ\x06\x12\x16\x1c\x18\x13\x1d\x01GYQL\\_dscdcddkm4(\x7f~xk-0c}\x7fq(4{qjnrhxs=\0@PJE\bJFJLF\x16\x0eVU\x0e\x10XF\x1dZT[R\x18DG\x19\x1c\\LV!l&&7&4.*,.)5pl4+pr: {22+:(2,)70\x0e(\x06C\x19\x18DG\f\b\x1e\nA\x0e\x05\t]\x15\0\x12\x13X\x06\x05\x1d\x0f\x13\x1e\v@\\\x04{<"jp+buinZyi{gjgXv3ih47|xnz1~uy\rWKFS\x18\x04\\S\x14\nBX\x03MFT\x11ON\x16\v<>\x04PW\\\x1cTZ\x02b:9~d,2i,;+,\x1c?+994%\x1a0u+*zy97=.-bB\x14\vN\b\fK\x13\0\x1c\x07\tNM\x0f\x03\x04LPQT\x06\x04\x14E[\x01\0A]\x17\v.fgwMfii  *vq/.kbputuwzr%;niix<?D@VB\tFMA\x05MXJK\0^]UG[VC\b\x14LC\x04\x1aRH\x13ZM!&\x121!3/"?\0.k10l`n[[(/jv>,w>2/-2>\x19/\x03\x0e\x01E\x1a\x1bH\0\x1eE\b\x04\x1d\x1f\x1c\x10\v7\x15\x01\x13W\x04\x05Z\x12\bS\x1a\x16sqnb}Vo}m)wv\x06\x042kyg2pxted%;ypz0xvLD\x0fGAVE\x07]@\x07IM_\x03TK\f\x12Z@\x1bUXV_S\\\x12NI^4"*>9gf#:(-,-/"*ms&!!0tiRPS \'b~6\x14O\x06\n\x17\x15\n\x06\x11\'\v\x06\tM\x13\x12L\x19@S\0\x1c\x02\x1b\x1dDX\0\x07\\^\x16t/lbi`&zu+*oe\x7f3-qdf|6+ml99so2s\x7frE\x01_^\x18\nN\x15\x16RQ\x14QP$&9\rB\x13PGWP_XXWY\0\x1cK24\'ad,"zj21jl$:a44!0&<&#164\x128}#"BA\x06\x02\x10\x04K\x04\x03\x0fG\x0f\x1e\f\tB\0\x03\x17\x05\x1d\x10\x01JZ\x02\x01F\\\x14\nQdscdTwcqal}Bh-sr2/\x18\x1a\x1d\x1cml\'9so2ywlPMCZ`DRB\bTWPW\f\x0eFD\x1f^RZR\x18QWKWZHy_K%\x1261-+!oh >e(,:*pxr.).-h%$PRUT%$_A\v\x17J\x01\x0f\x14\x18\x05\v\x12?\x04\x14\nP\f\x0fy}|\x7f~\x03\x02E[\x15\tP\x1birroe|Bf|l*vq1l}.ji,ih\x1c\x1e\x11\x10\x13`g<>vT\x0fNBJB\bAG[GJXkGCUb[IQ\x1d\x16^L\x17IRFX\x1e\x15`prqpeog54@BED54o,/Y]\\jx(gPR`r:6\x16_hj\x1f\x1eY\x1a\x15cVD\rSd')
      }), CKFinder.define(S("1qxr\\XS]K\x15vSYKS%2m\x05-)#4g\x1f#.;>a\x1b8$?1:4?;+\x0f3>+r\x186\f\x040\x06\n\x01\x03\x15\r\x1b"), [S("#P@^S\tjamECJJB\x1efVYEZVL\\I\x14zTRZ3n\x04*( \x10.->d/#9")], function (o) {
        "use strict";

        function e(e, t) {
          this.finder = e, this.renderer = t
        }

        return e.prototype.preRender = function (e, t) {
          var n = this.finder, i = {
              lazyThumb: t.lazyThumb,
              displayName: t.displayName,
              displaySize: t.displaySize,
              displayDate: t.displayDate,
              descriptionId: S(" BIE\tCOKM\x04NN_N\x03") + e.cid,
              dragPreviewId: S("0RYU\x19QDV_\x14JIYK\x13") + e.cid,
              getIcon: function () {
                return n.request(S("*MEAK\x15WTFzWZX"), {size: t.thumbSize, file: e})
              }
            },
            r = S("\x15*{q9s\x7f!?") + e.cid + S("Edg+%+8?pl,;7\x7f5=93z1-?6|(7r\f\bO\v\x05\x16K\x13\0\x1c\x07\t") + (e.isImage() ? S("2\x13W^P\x1aTX@B\x11IVJ-#") : S("\x1b<~uy\rGKOA\bODGG")) + '"' + (t.mode === S("\x0f|xag") ? "" : S("\x19:hhdrz\x1d\x03UJ@QN\x1d") + t.thumbSize + S('"S\\\x1eNBANB_\x16') + t.thumbSize + S("$U^\x1c\n")) + S("\x156sym{6u~qq\x1d\x03DBHVC\x05\b[EGI\x10\f_BTAVZAWCQVT\x19") + ">";
          return r += this.renderer.render(e, S("4s_[]mRNQ_"), o, i), r += S("Cxj*.v")
        }, e
      }), CKFinder.define(S('B7!=2f\v\x02\f"")+=\x7f\x057>$97#=*u\x1d51;,O\'\r\x0f\0\0\x14.\x06/\x03\x07\tC\n\0\x04'), [], function () {
        return S(" \x1dC\x03GIGT[\x14\bHGK\x03IY]W@\x19\\XY]K\x1aNU\x10\\K.cb7%'/),,2vn`\x7fmp5 232754<gy:<2,\x05CB\x07\x05\x11\x07J\v\x02\fF\b\x1f\x01\x1fMS\x06\x01\x01\x10TIrpF\x12\x11\x1a^\x1cl`qp9'sn%ec&xe{br32rxa+5cb;;ui0sACGO\x04YZ\x07A]\x04EM@K\x0fML\x10\x13GGU\n\x1aBA\x06\x1cTJ\x11'$6\n'*(oai76nm*.$0\x7f0?3{3*6*f~),*\x05C\\inlZ\x03\x01\x1fJ\b\0\f\x1d\x1cMS\x11\x18\x12X\x10\x1e\x14\x1cW\x1f\x19\x0e\x1d_uh/aew+|s4*bx#m`~w{t:favlzr;a`<!*(+\x1fL\x17\x06SA]FN\x11\x0fUT\x11\x11[G\x1aYWU]U\x1aG@\x1dWKn/#.!e;:ji.*8,c,;7\x7f7&:&jz-(.9\x7f`$\x1b@B\n\x10K\n\x06\n\f\x06K\x10\x11N\x06\x04_\x1c\x12\x19\x10V\n\x05EU\x13NCtv<.fjr;\f;'h4\x01")
      }), CKFinder.define(S('\x1fcjdJJACU\x07dEOYAK\\\x1fw[_QF\x19aQ\\MH\x13iVJ-#,"-)5\x11!,=d\n""+5#\x006:13%=+'), [S('C0 >3i\n\x01\r%#**"~\x0669%:6,<)t\x1a42:\x13N$\f\b\x01\x03\x15!\x07,\x02\0\b@\v\x1f\x05')], function (r) {
        "use strict";

        function e(e, t) {
          this.finder = e, this.renderer = t
        }

        return e.prototype.preRender = function (e, t) {
          var n = this.finder, i = {
            lazyThumb: t.lazyThumb,
            displayName: t.displayName,
            displaySize: t.displaySize,
            displayDate: t.displayDate,
            descriptionId: S("\x14v}q5\x7fswy0zzSB\x0f") + e.cid,
            dragPreviewId: S("\nhgk#kbpu>dgsa5") + e.cid,
            getIcon: function () {
              return n.request(S("\x10w}\x7fppd-\x7f|nR\x7frp"), {size: t.thumbSize, folder: e})
            }
          };
          return S("+\x10AG\x0fYU\x0f\x11") + e.cid + S('\x1c?>|L@QP\x19\x07ELN\x04LB@H\x03FDT_\x13W^P\x1a^VV_YOM\x12)5\'.fe"&<(g"/" rr73?\'0tw*66>a\x7f.-\x05\x12\x07\r\x10\x04\x12\x0e\x07\x07H') + (t.mode === S("&KAZ^") ? "" : S("\x19:hhdrz\x1d\x03UJ@QN\x1d") + t.thumbSize + S("'XQ\x11CIDIGD\v") + t.thumbSize + S("E6?sk")) + ">" + this.renderer.render(e, S("\rH`|uwa@}czz"), r, i) + S("\x12/;y\x7f)")
        }, e
      }), CKFinder.define(S("\x11QXR|xs}k5Nhtr0tIPLPQJBZZ"), [S("5CY\\\\HH_RLZ"), S("\x15|fm|hb")], function (n, t) {
        "use strict";
        var i = {};

        function r() {
          this.reset()
        }

        return r.prototype = {
          reset: function () {
            var e = this;
            e.dfd && e.dfd.reject(), e.dfd = new t.Deferred, e.dfd.done(function () {
              e.callback && e.callback(), e.reset()
            }), e.timeOutId = -1
          }, assignJob: function (e) {
            this.callback = e
          }, runAfter: function (e) {
            var t = this;
            t.timeOutId && clearTimeout(t.timeOutId), t.timeOutId = setTimeout(function () {
              t.dfd.resolve()
            }, e)
          }
        }, {
          getOrCreate: function (e, t) {
            return n.has(i, e) || (i[e] = new r), i[e].reset(), i[e].assignJob(t), i[e]
          }
        }
      }), CKFinder.define(S("\nHGKgatt`<Yzrbt|i4ZtrzS\x0etJARU\b|A_FNCOF\\BdZQB"), [S("9OUXXLL#.0&"), S("\x13~dcrj`"), S("\nfm\x7fg`~tfgq"), S(")i`jD@KUC\x1de]PAD\x17{[HY\x12wQ35#-0j\x05($%/(8$!!\x0687$"), S("/sztZZQSE\x17tU_IQ[Lo\x07+/!6i\x11!,=8c\x0e!\"=><|\x12<:2+\x0f3>+\x107'\t\x0f"), S(':xw{WQ$$0l\t*"2$,9d\n$"*#~\x04:1"%x\x1b67633q\x19\t\r\x07\x10-\v\0\b>\0\x0f\x1c'), S('\x1d]TfHLGAW\tjGM_GI^\x01iY]W@\x1bc_ROJ\x15oTHS]. +/7\x13/"?f\f" (\x1c*>57!1\''), S(">|\v\x07+-  4h\x05&.> (=`\x168>6'z\0>=.)t\b5+2\x02\x0f\x03\n\b\x160\x0e\r\x1eE-\x03\x01\n\n\x02#\x17\x1d\x10\x10\x04\x12\n"), S("\x14V]Qqw~~n2KkIM\rwLWIS\\EOY_")], function (s, r, a, e, i, t, n, o, l) {
        "use strict";
        var u = {
          name: S("\x1eKHTOAJDOK[\x7fCN["),
          reorderOnSort: !0,
          className: S('"@OC\vAAEOX\x01[GJG\x11QXR\x18P^T\\I\x16JT[Hm#-1  44h<#f."*6}8<;1\'?#'),
          attributes: {"data-role": S("\v`d}{fxwd"), tabindex: 30, role: S("-BFCE")},
          tagName: S("$PJ"),
          invertKeys: !1,
          collectionEvents: {
            change: function (e) {
              var t = e.changed;
              if (t.name || t.date || t.size) {
                var n = this.getChildViewElement(e), i = this.getOption(S("\x19ysuqzIIDUlTQOHFZ"));
                i = a._getValue(i, this, [void 0, 0]);
                var r = s.defaults(i, {
                  lazyThumb: this.finder.request(S("+JDBJ\nVWG`]CZZ"), {
                    file: e,
                    size: i.thumbSizeString
                  })
                });
                n.replaceWith(this.getPreRenderer(e).preRender(e, r)), this.triggerMethod(S("\x1d}wIMFUM@Q\x1dZLDOI_"));
                var o = this.getOption(S("\x1a\x7funnsAXaLJCO@")).get(S("1F[AXTdQC_"));
                this.getOption(S('8]SHLQ_F\x03.,%-"')).get(S(" LMGA")) === S("%RO]DHX") && this.resizeThumbs(o)
              }
            }
          },
          initialize: function (e) {
            var n = this;
            if (e.displayConfig.set({
              mode: S("=RV35"),
              thumbSizeString: null,
              currentThumbConfigSize: 0,
              thumbClassName: ""
            }), e.mode === S("9NSIP\\L")) {
              var t = n.getOption(S("?$(13($?\x04'',\"+")).get(S("\x1civjMCqJ^@"));
              this.calculateThumbSizeConfig(t), this.resizeThumbs(t), this.applyBiggerThumbs(t), n.setThumbsMode()
            } else n.setListMode();
            i.attachModelEvents(this.collection, this), n.on(S("/VX^V\x0eSYTMJ__"), function (o) {
              var s = this;
              setTimeout(function () {
                var e = s.$el.closest(S('5mSYM[\x16NRRZ}c2"# d\x1a'));
                if (s.$el[0].ownerDocument.defaultView) {
                  var t = parseInt(s.$el.offset().top), n = s.collection.indexOf(o), i = s.getThumbsInRow();
                  if (n < i && (window.scrollY || window.pageYOffset) && t) window.scrollTo(0, 0); else {
                    var r = s.collection.length % i;
                    s.collection.length - (r || i) <= n && window.scrollTo(0, e.outerHeight())
                  }
                }
              }, 20)
            }), n.once(S('E4"&-/9'), function () {
              n.$el.trigger(S("\x17{k\x7fzhx")), n.$el.attr(S("\ro}yp?\x7fuws{"), n.finder.lang.files.filesPaneTitle)
            }), n.once(S("+_EAX"), function () {
              var e = n.$el.closest(S("3\x1aV]Q\x15I[\\Y\x10LZ'(--7"));

              function t(e) {
                n.trigger(S("\x1c~rvCJ"), {evt: e})
              }

              e.on(S("\x11q\x7f}v}"), t), n.once(S("\x19~~oilpY"), function () {
                e.off(S(";_QW\\+"), t)
              })
            }), n.on(S("\f\x7fkatt`"), function () {
              var e = n.finder.request(S("(OEGHH\\\x15WTFrWA_A]")), t = e && e.cid;
              n.finder.config.displayFoldersPanel || n.lastFolderCid || n.focus(), n.lastFolderCid = t, n.getOption(S("!FJWUJFQjEEJDI")).get(S("\x1dspDD")) === S(")FB_Y") ? n.setListMode() : n.setThumbsMode()
            }), n.on(S(">R!9+.-?#"), n.updateHeightForBorders, n)
          },
          childViewOptions: function () {
            return this.getOption(S("1VZGEZVAzUUZTY")).toJSON()
          },
          applySizeClass: function (n) {
            var i = this, r = !1;
            s.forEach(i.finder.config.thumbnailClasses, function (e, t) {
              !r && n < t ? (i.$el.addClass(S('"@OC\vAAEOX\x01YFZ]SA\x1e') + e), r = !0) : i.$el.removeClass(S("\nhgk#iy}w`9a~bu{i6") + e)
            })
          },
          calculateThumbSizeConfig: function (t) {
            if (t && this.getOption(S(" EKPTIG^kFDMEJ")).get(S("\x15we}Mrnq\x7fp~IMQqAVO]IKFN"))) {
              var e = this.getOption(S("\noe~~cqhQ|zs\x7fp")).get(S("-]JBGWA`]CZZJ")), n = s.filter(e, function (e) {
                  return t <= e
                }), i = s.isEmpty(n) ? s.max(e) : s.min(n),
                r = this.getOption(S(";XTMO, ;\0++ ./")).get(S("%RO]DHEMDBl__TZSF"))[i];
              return this.getOption(S("\x1dzvSQNB]fIIN@M")).set(S("<IVJ-#\x11*> \x153: $,"), r.thumb), this.getOption(S("%BN[YFJUnAAVXU")).set(S(",N[]BT\\G`]CZZzUUZTYl);'"), i), r
            }
          },
          resizeThumbs: function (e) {
            this.$el.find(S('\v"nei=w{\x7fq8\x7fc}t')).css({width: e + S("1BK"), height: e + S("\x1dng")});
            var t = this;
            setTimeout(function () {
              t.trigger(S("%UNRL\x7f[HLZJ\nPTGQG"))
            }, 400)
          },
          applyBiggerThumbs: function (e) {
            var t = this;
            if (e && t.getOption(S("\rjfca~rmVyy~p}")).get(S("/]^VV")) === S("\x15b\x7fmtxh")) {
              e = parseInt(e, 10), this.applySizeClass(e);
              var n = this.getOption(S("@%+04)'>\v&$-%*")).get(S('"@QWTBF]~CY@Ll__TZSf_M]'));
              if (!n || n < e) {
                var i = this.calculateThumbSizeConfig(e);
                l.getOrCreate(S("\x11tzxpe-j|irfx"), function () {
                  t.$el.find(S("\x0f|x")).not(S("\x0e!szt>r|zr5pytr")).addClass(S('"@OC\vKISS\x06XE[BR')), t.$el.find(S(",AG\x01SZT\x1eR\\ZR\x15PYTR")).each(function () {
                    r(this).find(S("\x19sv{")).attr(S("\x16djz"), t.finder.request(S("\x1eyIMG\x19C@RnKFD"), {
                      size: e,
                      file: t.collection.get(this.id)
                    }))
                  }), t.$el.find(S("@-+m'. j.&&/)?=b9%7>t<;0")).attr(S("7KKY"), t.finder.request(S("/V^^WQG\fP]MsXSS"), {size: e})), t.children.invoke(S("1FA]RQRJ"), S(';OTDZ\x151&"0 '), {
                    thumbSize: e,
                    thumbSizeString: i.thumb
                  }), t.trigger(S("0B[IQ`FSYM_\x01][JZ2"))
                }).runAfter(500)
              } else setTimeout(function () {
                t.trigger(S("\v\x7fdtjEavr`p,v~m\x7fi"))
              }, 400)
            }
          },
          setListMode: function () {
            this.getOption(S("#@LUWDHShCCHFW")).set(S("\x1bqrzz"), S("\x1cqwlT")), this.$el.removeClass(S("\x13w~p:~pv~o0jwUL@P")).addClass(S("2P_S\x1bQQU_H\x11QWL4")), this.$el.find(S('?n")%i#/+-d#?) ')).css({
              width: S(";]HJP"),
              height: S("$DSSG")
            })
          },
          setThumbsMode: function () {
            this.getOption(S("\x1bxtmoL@[`KK@NO")).set(S("1_\\PP"), S("1F[AXTD")), this.$el.removeClass(S("\nhgk#iy}w`9y\x7fdl")).addClass(S('A!("h .$,9f8%;"2"'))
          },
          getThumbsInRow: function () {
            if (this.getOption(S("A&*75*&1\n%%*$)")).get(S("(DEOI")) === S("9VROI") || this.collection.length < 2) return 1;
            var e = this.getChildViewElement(this.collection.first());
            if (!e.length) return 1;
            var t, n = e.offset().top, i = 1;
            for (t = 1; t < this.collection.length && this.getChildViewElement(this.collection.at(t)).offset().top === n; t++) i += 1;
            return i
          },
          focus: function () {
            this.$el.focus()
          },
          getEmptyView: function () {
            var e = this.getEmptyViewData();
            return t.extend({
              title: e.title,
              text: e.text,
              displayLoader: e.displayLoader,
              displayInfo: !this.finder.config.readOnly
            })
          },
          getChildViews: function () {
            return this.$(S("\x11~z"))
          },
          reorder: function () {
            var t = this, e = this._filteredSortedModels();
            if (s.some(e, function (e) {
              return !t.getChildViewElement(e).length
            })) this.render(); else {
              var n = s.map(e, function (e) {
                return t.getChildViewElement(e)
              }), i = this.getChildViews(), r = s.filter(i, function (e) {
                return -1 === i.index(e)
              });
              this.triggerMethod(S("D'#!';/q>(!=44 ")), this._appendReorderedChildren(n), r.length, this.checkEmpty(), this.triggerMethod(S("B1!*4#-;"))
            }
          },
          instantRenderChild: function (e) {
            var t = this.getOption(S("E%/!%.\x1d%(9\0 %;<:&"));
            t = a._getValue(t, this, [void 0, 0]);
            var n = s.defaults(t, {
              lazyThumb: this.finder.request(S(":]UQ[\x05'$6\x17,0+%"), {
                file: e,
                size: t.thumbSizeString
              })
            });
            return this.getPreRenderer(e).preRender(e, n)
          },
          refreshView: function () {
          },
          getPreRenderer: function (e) {
            return e.get(S("@7+&3\x7f/4\x0e&&/)?")) ? new o(this.finder, this.finder.renderer) : new n(this.finder, this.finder.renderer)
          }
        };
        return s.extend(u, i.getMethods()), u.events = s.extend({
          "mouseenter img": function (e) {
            var t = r(e.currentTarget).closest(S("$IO")), n = setTimeout(function () {
              t.addClass(S("\fnei=w{\x7fq8e\x7fwn7oths}")), t.data(S("!AHB\bBB[JXB\\YG@^\x1cFZYPYBL"), void 0)
            }, 1e3);
            t.data(S("\x15u|~4~~o~lvPUKLJ\bRNELE^X"), n)
          }, "mouseleave img": function (e) {
            var t = r(e.currentTarget).closest(S("\x0ecy")), n = t.data(S("\x1e|KG\x0fGAVEUAY^BCC\x03[Y\\W\\AA"));
            n && (clearTimeout(n), t.data(S("\x1e|KG\x0fGAVEUAY^BCC\x03[Y\\W\\AA"), void 0)), t.removeClass(S('-MDV\x1cTZXP\x1bDPVM\x16HUKR"'))
          }
        }, i.getEvents(S("-BF"))), e.extend(u)
      }), CKFinder.define(S("9N^DI\x1f|\v\x07+-  4h\x1c,'; ,:*#~\x14:80%x\x140)/s\x1b73\x05(\x01\f\n&\x03\v\x04G\x0e\x04\x18"), [], function () {
        return S('\x19&rqz>vD\x1c\0X_\x18\x06N\\\x07NYMJ~]UG[VC|R\x17ED\x18\x1b_Q_L3|`6-h*.e=">!/lo1=&nvwv$*:gy\'&c\x7f\t\x15L\x04\x01\x11/\x04\x07\x07BBL\x10\x13MP\x15\0\x12\x13\x12\x17\x15\x14\x1cGY\b\x0f\v\x1a"!fbpd+dco\'o~li"`cwe}pa*:ba&<tj1DSCDtWCQAL]bH\rSR\x12\x11\x1d\r')
      }),CKFinder.define(S(" UG[P\x04eln@DOI_\x01{U\\B_UASD\x17\x7fSWYN\x11s)26l\x02,*\"\x06('.\x0f(\"#~5='"), [], function () {
        return S("\n7m-mcqba.6`\x7f:zmt9<ulzF\x1c\0\x01\x04QGEAGNNT\x10\f\x02\x01\x13\x12WFTQPY[V^\x01\x1fJM5$`c $2&e*!-a)<.7|\"!1#?2/dx '`~6\x14O\x06\x11\x05\x026\x15\r\x1f\x03\x0e\x1b$\nO\r\fPS\0\x1c\x02\x1b\x1dDX\0\x07\\^\x16t/lbi`&zu+4\x01\x051}\x7fq\x7f2w}g+5ylnt>=}sARQ\x1e\x06FMA\x05OCGI^\x03F^_WA\x16\vML\x19\x19SO\x12S_R%a?>xj57)'tApb/qZ")
      }),CKFinder.define(S("7{r|RRY[Mo\f-'1)#4g\x0f#')>a\x1994% {\x19?$,\x0f3>+r\x186\f\x040\f\x137\x03\t\f\f\x18\x0e\x1e"), [S("\x0fe\x7fvvffuxj|"), S("\x1ekEYV\x02gn`NFMOY\x03yKB@]SGQF\x19qQU_H\x13qWL4n\x04*( \x0f$''\t. !`+?%"), S("\x1ekEYV\x02gn`NFMOY\x03yKB@]SGQF\x19qQU_H\x13qWL4n\x04*( \b&%,\t. !`+?%")], function (l, u, c) {
        "use strict";

        function e(e, t) {
          this.finder = e, this.renderer = t
        }

        return e.prototype.preRender = function (i, e) {
          var r = this.finder, o = this.renderer, s = {
            lazyThumb: e.lazyThumb,
            displayName: e.displayName,
            displaySize: e.displaySize,
            displayDate: e.displayDate,
            descriptionId: S('E%,.d," (c+5"1~') + i.cid,
            dragPreviewId: S("5U\\^\x14^I]Z\x13O2$4n") + i.cid,
            getIcon: function () {
              return r.request(S("3R\\ZR\x02^_Ou^QQ"), {size: e.listViewIconSize, file: i})
            }
          }, a = S("7\x04MH\x1bUY\x03\x1d") + i.cid + S("\f/.l|pa`)7u|~4|rpx3vTDO\x01\x1a");
          return e.collection.forEach(function (e) {
            var t = e.get(S("\x1cs\x7frE"));
            if (t !== S("\x1bu~qq")) if (t !== S("&IIDO")) if (t !== S("<Y_K%")) if (t !== S("*XEWK")) if (t !== S("\x1ezMQVZ")) {
              var n = {template: void 0, templateHelpers: void 0};
              r.fire(S("3X\\ECnP_L\x06[WS%{!,(0+)r") + t, n), n.template && n.template.length ? a += o.render(i, S(".lEBF\\Ys_[]z_WPkWZ7l") + t, n.template, l.extend({}, s, n.templateHelpers)) : a += o.render(i, S("\x1eZMQVZg@JK~@O\\"), S("\x1a'hy #\x0fUF\x1d"), s)
            } else a += o.render(i, S("2vYEBN{\\VWjT[H"), S("\x1c!j{\x1e\x1d\rW@\x1b"), s); else a += o.render(i, S("C\x17,<\"\v,&'\x1a$+8"), S('\x0f,ev-on77qm4w}sy1FNPNEQ`NDLyBVH\x06\x0fYE\x1c@]OS\x17\x12\x19\v\v\x0e\t\x1e\x16`<?\x7fk1"y'), s); else a += o.render(i, S("\vHlzjSt~\x7fB|s`"), S("9\x06OX\x03EDaa+7j)')/g,$> /;\x140&6\x07!$>6>r{5)p;\x01\x15\x07CME\x1b\x1aTF\x1e\x0fR"), s); else a += o.render(i, S("+jDBJ~P_VwPZ[nP_L"), S("?|5&c')'4;th('+c)9=7 y9?$,t,29*s<\x0f\rO\r\x05\b\x03G\x1d\0G\t\x03\t\x17B\x19\x1f\x1a\x16\x06\x1c\x02UF") + c + S("'\x14\x06^O\x12"), s); else a += o.render(i, S(';zTRZ\t"--\x07 *+\x1e /<'), S("Ez3,w") + u + S("\x18%5ox#"), s)
          }), a += S("\n7#y|1")
        }, e
      }),CKFinder.define(S("\vxhv{1RYU}{rrj6N~qmr~TDQ\fbLJB[\x06fB_Y\x01i_]VVF{WZ]z_WP\x13ZP4"), [], function () {
        return S("(\x15K\vOAO\\C\f\x10F]\x18TCV\x1b\x1aSNXX\x02bcb7%'/),,2vn`\x7fmp5 232754<gy:<2,\x05CB\x07\x05\x11\x07J\v\x02\fF\b\x1f\x01\x1fMS\x06\x01\x01\x10TW\f\x10\x0e\x17\x19@\\\x04{ \"jp+jfjlf+pq.fd?|ryp6je;$\x11\x15!moAO\x02GMW\x1b\x05I\\^D\x0e\rMCQBA\x0e\x16V]Q\x15_SWYN\x13V./'1f{=<ii#?b!/-5=r/(u?#v7;69}#\"\\N\x11\x13\x05\vXmTF\vU")
      }),CKFinder.define(S('2p\x7fs_Y\\\\H\x14qRZJ,$1l\x02,*";f\x1c"):=`\x1c8!\'\x02<3 w\x1f5788,\r\x0f\x160\x06\n\x01\x03\x15\r\x1b'), [S("\x16bv}\x7fio~qmE"), S("\n\x7fiuz.SZTzzqse7M\x7fvlq\x7fkER\reMICT\x07eCXX\x02hF\\T{P[[uRTU\x14_SI"), S('A6&<1g\x04\x03\x0f#%((<`\x044?#84"2+v\x1c208-p,\b\x11\x17K#\t\v\f\f\x18%\r\0\v,\x15\x1d\x1e]\x10\x1a\x02')], function (l, u, c) {
        "use strict";

        function e(e, t) {
          this.finder = e, this.renderer = t
        }

        return e.prototype.preRender = function (i, e) {
          var r = this.finder, o = this.renderer, s = {
              lazyThumb: e.lazyThumb,
              displayName: e.displayName,
              displaySize: e.displaySize,
              displayDate: e.displayDate,
              descriptionId: S("#GN@\nNFFOI_\x03KUBQ\x1e") + i.cid,
              dragPreviewId: S("B /#k#:(-f<?+9}") + i.cid,
              getIcon: function () {
                return r.request(S("@'-/  4}/,>\x02/\" "), {size: e.listViewIconSize})
              }
            },
            a = S("Ez3:i#/qo") + i.cid + S('\x1a9<~r~SR\x1f\x01GN@\nNFFOI_\x03FDT_\x11\x14QWCY\x14YPZ\x10ZM/1\x7fa073"jw');
          return e.collection.forEach(function (e) {
            var t = e.get(S(".AQ\\W"));
            if (t !== S("\x17qzuu")) if (t !== S("0_S^Q")) if (t !== S("\x12vyebn") && t !== S("\x16dqc\x7f") && t !== S('"GEQC')) {
              var n = {template: void 0, templateHelpers: void 0};
              r.fire(S("\x1bptmkvHGT\x1eCIKLLX\x11OBBZ]_\b") + t, n), n.template && n.template.length ? a += o.render(i, S('9yNOIQR\x06..\'!7\x05"$%\x1c"):c') + t, n.template, l.extend({}, s, n.templateHelpers)) : a += o.render(i, S("4p[GL@y^PQhV%6"), S("\x0e3du,/;ar)"), s)
            } else a += o.render(i, S("5sZHMCxYQRi)$5"), S("'\x14]N\x15\x10\x02ZK\x0e"), s); else a += o.render(i, S(":}UQ[q!,'\0!)*\x11!,="), S("#\x18QB\x07KEKX_\x10\fL[W\x1fU]YSD\x15USHH\x10HV%6o +)k))$/k9$c-?5+~=;>2*0.yb") + c + S("-\x12\0DU\f"), s); else a += o.render(i, S("\x16Qwu~~nT}pNbGOHsOB_"), S("6\vL]\x04") + u + S("<\x01\x11K$\x7f"), s)
          }), a += S("@}m76{")
        }, e
      }),CKFinder.define(S("0EWK@\x14u|~PT_YO\x11k%,2/%1#4g\x0f#')>a\x039\"&|\x18<%#\x0e0?,r91+"), [], function () {
        return S(".\x13DPP_Q\x15U[YJI\x06\x1e^UYm'+/!6k1!,=k/&(b68>6'x:>+-w-58)}^k^\x17\f\0\x07\x03VccW\x18\x1fPeyx\t\b\nU\x1f\x03V\x1a\x15\x17\t\x10\x10\f.lmgaiu'2)id`xca0lo\x19\x1d\x1c\x1f+lqa`#=}pLTOM\nBCS\0\vYD^Y\f\x06\x10LO\x13PTBV\x15ZQ]\x11NQM4|`8?xf$'%?&\"c)*$yp ;'\"uqy'&~&%`\x1d\x1c\x19\x18[E\x05\b\x04\x1c\x07\x05B\n\v\x1bXS\x05\x1a\x10\x01\x1eUQY\x07\x06\\\x0e\n\x06ld?!slbs`3qp1-m`|d\x7f}:rsc0;mrxiv=\t\x01_^\x1f\x07]\\\x17TW\x15&$'&9JI\x0e\x14VY[MTT\x15[XJ\x17`c.\"& *eh`j61GGFYX)(ku584,75r:;+HC\x11\f\x16\x11DNHTWVL\x04\x1aA\x03\x1e\0\x076\fV\n\x05ssrutwCsqcm$fjf{z7)ofh\"vx~vg8z~km7muxi2SNPWAW\x04\x19SR\x15\vEY\0\\_CFqMzDS]K\x1a\x06\x01\0\x1e\x18!2!dd8;<3tj\"8c/<3q/./.ihx0.u/2,+\"\x18-\x11\0\0\x14GUTWKK\t\v\x1c\x13VR\x0e\t\x0e\rJX\x10\x0eU\x18\x18\r\x1c |\x7fx\x7f:{z4&y{mc0\x05\x19\x18\x1b\x1aon)je\x13\x13\x12\x15!1kH\x1f(*-^]YUT \"\x10\x02Z]\x0e;\x0e\x1c@]SV\\\x070\x07H_Q[9\x7f~l0')#1w@wc9/-<4lY")
      }),CKFinder.define(S("\x1djzXU\x03`ocOILLX\x04xHC_\\PFVG\x1ap^T\\I\x14zTRZ3\b,%+\f(\v!:>\x1d%(9a4>&"), [], function () {
        return S("!\x1eW@\x1b,.\x14MC]\fNBNCB\x0f\x11W^P\x1a^PV^O\x10WQ&.`}NL=<wi#?b)'< =3*\x18:73=+z&!WWc\x04\b\x14C\x07\t\x07\x14\x1bTH\x1e\x05@\x02\0\x11\x15\x17\x01T\0\x1fZ\x14\x16\x1b\x1f\x19\x0fS\tes`lw`&ra$idbykad1gz9wysa4a`!=wk\x0eRUBPFN\x07UT\n^E\0M@B_WA\x19TZ[\x1a\x07025\x01MO!/b ($54uk?\"a$- >|><51?9?{dgs..>\x0e_hjmY\x0eVV\x12\x11VL\x04\x1aA\x04\x18\x06\x1f\x11U\v\nDV\x12JBwwC/eku:\x0f\x0f|s65vq\x07\x073txd3wywdk$8xw{3yIMGP\tLHAG\x04HDHT\x0eZY\x1cQ\\ZASYL\x19OR\x11_Q[9l98ye/3f:=*8.&o-,r&=x58*7?)q<23B_hjmY\x0eUV\x12\x11VL\x04\x1aA\x04\x18\x06\x1f\x11U\v\nDV\x12IBwwv{z=#mq(cazzgmtB`quwa4hk+h'a`!=wk\x0eUG[P\x05[Z\x14\x06Z\x15WV\x11RM;;\x0f\x1bQ_A\x0633@G\x02CBJH~l ,0yBue?(sD")
      }),CKFinder.define(S("\x1b_VXvNEGQ\vhIC]EOX\x03kGCUB\x1de]PAD\x17uSHHkWZ7"), [S("9OUXXLL#.0&"), S(";VLKZ28"), S("\x12quv}uww\x7f"), S("\val|f\x7f\x7fwg`p"), S("3w~p^V]_I\x13kWZ72m\x01%6#h\x01'9?-#:`\x13>>?16\">77\f29*"), S("6ts\x7fSUXXL\x10\r.&6( 5h\x0e &.?b\x18&5&!|\x17:;:77u\x1d51;,6\b\x07\x14)\f\x1e\x0e\x06"), S("*hgkGATT@\x1cyZRBT\\I\x14zTRZ3n\x14*!25h\x04 9?\x1a$+8\x7f\x17;?1\x079 \n<4?9/;-"), S('\x13W^P~v}\x7fi3Pq{UMGP\vcOKMZ\x05}EHY\\\x1f}[@@c_RO\x16|TPY[M\x12.5\x11!+"":,8'), S("\x19YPZtp{ES\rnKASKMZ\x05mEAK\\\x1fg[VCF\x19tWTWTR\x12xV,$1\n*#)\x11!,="), S("?4$:7e\x06\r\x01!'..>b\x1a*=!>2 0%x\x1e06>/r\x126\x13\x15M/\r\x16\x121\x01\f\x1dE\b\x02\x1a"), S("\x1bhxfk\x01bieMKBBZ\x06~NA]BNDTA\x1cr\\ZRK\x16|RPXMv.'-\n*\t/4<\x1f#.;c* $")], function (i, r, n, o, e, t, s, a, l, u, c) {
        "use strict";
        var d = {
          name: S("C\b,53\x1e /<"),
          attributes: {tabindex: 30},
          tagName: S("\x0ftxd"),
          className: S(".L[W\x1fU]YSD\x15OS^K\x10\\P2%'17e3.e+%/5`'!84 : "),
          reorderOnSort: !0,
          childViewContainer: S("8MXTXD"),
          template: u,
          invertKeys: !0,
          initialize: function (e) {
            this.columns = new n.Collection([], {comparator: S("8IHRSOWK9")}), this.model = new n.Model, t.attachModelEvents(this.collection, this), this.model.set(S("\x18xix"), S("'\x0e\n\x13\x1d\x19\x1d\x15")), this.model.set(S(">[%2!"), S("4\x13\x15\x0e\x0e\x0f\n\0")), this.updateColumns(), this.listenTo(e.displayConfig, S("*HDL@HU\vA\\FAtN"), this.updateSortIndicator), this.listenTo(e.displayConfig, S("0RZRZRS\rKVHO~DqM$$0"), this.updateSortIndicator), this.on(S("!OB\\LKNRL"), this.updateHeightForBorders, this)
          },
          childViewOptions: function () {
            var e = this.getOption(S('9^ROMR^9\x02--",!')).toJSON();
            return e.collection = this.columns, e
          },
          onBeforeRender: function () {
            this.updateColumns()
          },
          isEmpty: function () {
            var e = !this.collection.length;
            return this.$el.toggleClass(S('C\'. j. &.?`"&#%\x7f69%".'), e), e
          },
          getEmptyView: function () {
            var e = this.getEmptyViewData();
            return l.extend({
              title: e.title,
              text: e.text,
              displayLoader: e.displayLoader,
              displayInfo: !this.finder.config.readOnly,
              template: c,
              tagName: S("\x0e{b"),
              className: ""
            })
          },
          updateColumns: function () {
            var e = new n.Collection,
              t = this.getOption(S("%BN[YFJUnAAVXU")).get(S("2_]FBaQ\\Mr_RPl);'")) - 4 + S("\x18ib");
            e.add({name: S("4\\UXV"), label: "", priority: 10, width: t}), e.add({
              name: S("\x13zt{r"),
              label: this.finder.lang.settings.displayName,
              priority: 20,
              sort: S('C*$+"')
            }), this.getOption(S("*OE^^CQHq\\ZS_P")).get(S("5R^KIVZEnWE%")) && e.add({
              name: S("\x1elI[G"),
              label: this.finder.lang.settings.displaySize,
              priority: 30,
              sort: S("\x14f\x7fm}")
            }), this.getOption(S(".KYBB_ULuXV_S\\")).get(S("\x1a\x7funnsAXfBP@")) && e.add({
              name: S("\x1cy\x7fkE"),
              label: this.finder.lang.settings.displayDate,
              priority: 40,
              sort: S("D!'3-")
            }), this.finder.fire(S("&KAZ^}EHY\x15S^^FY[E"), {columns: e}), this.columns.reset(e.toArray()), this.model.set(S("\x10r}\x7faxxd"), this.columns), this.model.set(S("E5(:=\b2"), this.getOption(S("C ,57$(3\b##(&7")).get(S("8JUIH\x7fG"))), this.model.set(S("\nxc\x7fzMi^`wqg"), this.getOption(S(":_UNNS!8\x01,*#/ ")).get(S("@2-10\x07?\b:-/9")))
          },
          getThumbsInRow: function () {
            return 1
          },
          updateSortIndicator: function () {
            var e = this.getOption(S("\x1bxtmoL@[`KK@NO")).get(S("$VIU\\kS")),
              t = this.getOption(S("\vhd}\x7f|pkP{{p~\x7f")).get(S(")YD^YlV\x7fCVVF"));
            this.$el.find(S("\x18mr;2~uy\rGKOAV\vKAZ^\x06ZDKX\x1dB]A@PD")).html(t === S("?!2!") ? this.model.get(S("0PAP")) : this.model.get(S("\x15rrkz"))).appendTo(this.$el.find(S("1F[oQWCY\x14YPZ\x10MP25\x7fa") + e + S("0\x13o")))
          },
          getPreRenderer: function (e) {
            return e.get(S('C2,#0r 9\r#!**"')) ? new a(this.finder, this.finder.renderer) : new s(this.finder, this.finder.renderer)
          },
          attachCollectionHTML: function (e) {
            var t = this.finder.renderer.render(this.model, S("3x\\ECnP_L"), u, {}), n = t.indexOf(S("\x0f,>fq{qo)"));
            this.el.innerHTML = t.substring(0, n) + e + t.substring(n)
          },
          getChildViewElement: function (e) {
            return this.$(document.getElementById(e.cid))
          },
          getChildViews: function () {
            return this.$(S("\x1fTE"))
          },
          instantRenderChild: function (e) {
            var t = this.getOption(S("\x0elxx~wB|s`Winrssm"));
            t = o._getValue(t, this, [void 0, 0]);
            var n = i.defaults(t, {
              lazyThumb: this.finder.request(S("0W[_Q\x0fQRLmRNQ_"), {
                file: e,
                size: t.thumbSizeString
              })
            });
            return this.getPreRenderer(e).preRender(e, n)
          },
          focus: function () {
            this.$el.focus()
          }
        }, f = t.getMethods();
        return i.extend(d, f), d.events = i.extend({
          selectstart: function (e) {
            e.preventDefault(), e.stopPropagation()
          }, "mousedown th[data-ckf-sort]": function (e) {
            e.stopPropagation(), e.stopImmediatePropagation(), e.preventDefault();
            var t = r(e.currentTarget).attr(S("C $2&e*!-a>!=$"));
            if (t === this.getOption(S("\x17|pikp|g\\OODJC")).get(S(".\\_CFqM"))) {
              var n = this.getOption(S("\x17|pikp|g\\OODJC")).get(S("\x13gzdcZ`Uixxl"));
              this.finder.request(S("-]JDE[]SF\fD]MlZPH["), {
                group: S("\x1a}uq{l"),
                name: S("\x13gzdcZ`Uixxl"),
                value: n === S("9[H_") ? S("\x1a\x7fyn}") : S("#EVE")
              })
            } else this.finder.request(S("\v\x7fhz{y\x7fu`.fscNxvny"), {
              group: S("A$*( 5"),
              name: S("6DWKNyE"),
              value: t
            })
          }, "dragstart .ckf-folder-item": function (e) {
            e.preventDefault()
          }, "dragend .ckf-folder-item": function (e) {
            e.preventDefault()
          }, "ckfdrop .ckf-folder-item": function (e) {
            e.stopPropagation();
            var t = this.collection.get(e.currentTarget.id);
            this.trigger(S("5U_QU^MUXI\x05&..'!7|#:&:"), {
              evt: e,
              model: t,
              el: r(e.target).find(S("Al /#k!!%/8a$ !5#"))
            })
          }
        }, t.getEvents(S("D14"))), e.extend(d)
      }),CKFinder.define(S('\x1aoyej>cjdJJACU\x07}OF\\AO[UB\x1du]YSD\x17zUVL\\]Ko\x07+/!k"(<'), [], function () {
        return S("\"\x1fE\x05EKIZY\x16\x0eXG\x02RE\\\x11\x14]DR^\x04\x18Q]K_L#3+30\x7f0(!-b{eon;13;=00.jztky|9,>\x07\x06\x03\x01\b\0[E\x1c\x1b\x1f\x0eNM\n\x0e\x04\x10_\x10\x1f\x13[\x13\n\x18\x1dV\f\x0f\x1b\tidu>&~}:(`~%h\x7foh@cwe}pa^|9gf>=jvTMG\x1e\x06^]\x06\b@^\x05BLCJ\x10LO\x11\x14QWCY\x14YPZ\x10HV%6\x7fa?>{g!=d(%)n2-slYtuvwd07<|4:bB\x1a\x19^D\f\x12I\f\x1b\v\f<\x1f\v\x19\x19\x14\x05:\x10U\v\nZY\x1b\x17\b@\\] rp`9'}|5)c\x7f\"jk{Yr}}<<6je;:\x7fn|yxACNF\x19\x07RU]L\b\vHLZN\x1dRYU\x19QDV_\x14JIYKWZ7|`8?xf.<g.9-*\x1e=5';6#\x1c2w%$x{scTV\\\x12\x12\x02\nE\x02\x0e\x1aTH\n\x19\x19\x01MP\x12\x1e\x12\x07\x06KUZG\x01\0]]\x17\v.ocna%{z4&y{mc0\x05,>s-\x1e")
      }),CKFinder.define(S('\x1aXW[wqDDP\fiJBRDLY\x04jDBJC\x1edZQBE\x18{VWK]^Ji)$5l\x02,*"\x1a,$/)?+='), [S("\x13`pnc9ZQ]uszzR\x0evFIUJF\\LY\x04jDBJC\x1eq\\YEWTL\x16|RPX\x10[/5")], function (o) {
        "use strict";

        function e(e, t) {
          this.finder = e, this.renderer = t
        }

        return e.prototype.preRender = function (e, t) {
          var n = this.finder, i = {
            lazyThumb: t.lazyThumb,
            displayName: t.displayName,
            displaySize: t.displaySize,
            displayDate: t.displayDate,
            descriptionId: S("\x10ryu9s\x7f{}4~~o~3") + e.cid,
            dragPreviewId: S("&DCO\x07O^LI\x02@CWE\x19") + e.cid,
            getIcon: function () {
              return n.request(S("%@NDL\x10LIYgL__"), {size: t.compactViewIconSize, file: e})
            }
          }, r = S("\x11.\x7f}5\x7fs%;") + e.cid + S('3\x16\x15U[YJI\x06\x1e^UYm\'+/!h/3-$hk>""*ms"!1&39,8.233|a');
          return r += this.renderer.render(e, S("1q\\YEWTL\x7fSWY"), o, i), r += S("&\x1b\x07EC\x15")
        }, e
      }),CKFinder.define(S('\x1djzXU\x03`ocOILLX\x04xHC_\\PFVG\x1ap^T\\I\x14\x7fRSO!"6l\x02**#-;d/#9'), [], function () {
        return S("1\x0eR\x14VZVKJ\x07\x19IT\x13]4/`c,7#!uk *:,=,\"8\"'n#9><qjr~}*>\x02\b\f\x07\x01\x1d[EEXHK\b\x1f\x0f\b\x17\x10\x10\x1f\x11HT\x11\x19\x15\t\x1e^]\n\x16tmg>&~}&(`~%blcj0lo1*\x1f6789&rqz>vD\x1c\0X_\x18\x06N\\\x07NYMJ~]UG[VC|R\x17ED\x18\x1b]QJ\x02bcb06&{e32wk%9`(5%\x1b0;;~~x$'y|9,>\x07\x06\x03\x01\b\0[E\x0e\b\x06\x18\tON@N{{O\x07\x05\x17\x19X\x1d\x13\tA_\x1f\ntn #gigt{4()2vu.0xf=xttrt9fg<tj1N@OF\x04X[\x1b\x07ZZJB\x13$\x13\x1fP\f9")
      }),CKFinder.define(S("9ypzTP[%3m\x0e+!3+-:e\r%!+<\x7f\x07;6#&y\x1474*:?)\b6\x05\x16M%\v\t\x02\x02\x1a;\x0f\x05\b\b\x1c\n\x02"), [S("\x14asol8YPZtp{ES\rwAHVKI]OX\x03kGCUB\x1dp[XFV[M\x15}SQZZ2o&,0")], function (o) {
        "use strict";

        function e(e, t) {
          this.finder = e, this.renderer = t
        }

        return e.prototype.preRender = function (e, t) {
          var n = this.finder, i = {
            lazyThumb: t.lazyThumb,
            displayName: t.displayName,
            displaySize: t.displaySize,
            displayDate: t.displayDate,
            descriptionId: S("\x1axw{3yIMG\x0e@@UD\x05") + e.cid,
            dragPreviewId: S('@")%i!4&/d:9);c') + e.cid,
            getIcon: function () {
              return n.request(S("\x14sy{||h!{xjVCNL"), {size: t.compactViewIconSize, folder: e})
            }
          }, r = S("\v0ag/yu/1") + e.cid + S("\x1547{u{ho <|KG\x0fEKIBBZ\x04C_I@\f\x0fB^^V\t\x17FE]J_UH\\JV//`}");
          return r += this.renderer.render(e, S("\x1b_rsoABVeKIBBZ"), o, i), r += S("\r2 |x,")
        }, e
      }),CKFinder.define(S('%eln@DOI_\x01b_UG_QF\x19qQU_H\x13kWZ72m\0+(6&+=\x1c"):'), [S("7MW^^NN]P2$"), S("4_GB]KC"), S('>]!")!++#'), S("\x1fM@PJKKCS\\L"), S("\"`ocOILLX\x04zDKXC\x1epRGP\x19~VJNZRI\x11|/-.&'1/(&\x1f#.;"), S("5u|~PT_YO\x11r/%7/!6i\x01!%/8c\x1b'*'\"}\x10;8;86v\x1c208-\t\t\x04\x15.\r\x1d\x0f\t"), S('-mdvX\\WQG\x19zW]OWYN\x11y)-\'0k\x13/"?:e\b# >.3%\x04:1"y\x1115?\t93::\x12\x04\x10'), S("\x17[R\\rry{m\x0flMGQICT\x07oCGI^\x01yYTE@\x1bvYZHXYOjT[Ho\x07-/  4\x15-'..>(<"), S("\x19YPZtp{ES\rnKASKMZ\x05mEAK\\\x1fg[VCF\x19tWTWTR\x12xV,$1\n*#)\x11!,=")], function (e, i, t, n, r, o, s, a, l) {
        "use strict";
        var u = {
          name: S("\fNab`pqgB|s`"),
          attributes: {tabindex: 30},
          tagName: S("\x19ow"),
          className: S('*HGK\x03IY]W@\x19C_RO\x14XTNY[M3a!("h .$,9f/"#?12&s!<{57=#v536:\x12\b\x16'),
          reorderOnSort: !0,
          invertKeys: !0,
          initialize: function (e) {
            this.columns = new t.Collection([], {comparator: S(" QPJKWOSQ")}), this.model = new t.Model, o.attachModelEvents(this.collection, this), this.model.set(S("#EVE"), S("5\x10\x14\x01\x0f\x0f\v\x07")), this.model.set(S("3PPET"), S("\x19<8%+(/\x1b")), this.updateColumns(), this.listenTo(e.displayConfig, S("\x12p|txp}#itni\\f"), this.updateSortIndicator), this.listenTo(e.displayConfig, S("\x17{q{u{x$lOSVa]jTCM["), this.updateSortIndicator), this.on(S("\x11\x7frl|{~b|"), function (e) {
              var t = this.updateHeightForBorders(e);
              if (this.$el.css({height: ""}), this.collection.length) {
                this.$el.css({height: t});
                var n = Math.floor(this.$el.width() / this.getChildViews().first().outerWidth());
                if (n * this.getThumbsInRow() <= this.collection.length) {
                  var i = Math.ceil(this.collection.length / n);
                  this.$el.css({height: i * this.getChildViews().first().outerHeight()})
                }
              }
            }, this)
          },
          childViewOptions: function () {
            var e = this.getOption(S("@%+04)'>\v&$-%*")).toJSON();
            return e.collection = this.columns, e
          },
          onBeforeRender: function () {
            this.updateColumns()
          },
          isEmpty: function () {
            var e = !this.collection.length;
            return this.$el.toggleClass(S(")I@J\0HF\\TA\x1eX\\EC\x15\\WKHD"), e), e
          },
          getEmptyView: function () {
            var e = this.getEmptyViewData();
            return l.extend({
              title: e.title,
              text: e.text,
              displayLoader: e.displayLoader,
              displayInfo: !this.finder.config.readOnly
            })
          },
          updateColumns: function () {
            var e = new t.Collection;
            e.add({name: S("\x15\x7ftww"), label: "", priority: 10}), e.add({
              name: S("\x16yyt\x7f"),
              label: this.finder.lang.settings.displayName,
              priority: 20,
              sort: S("\x1au}p{")
            }), this.getOption(S("\x14q\x7fdhu{b_rpyIF")).get(S("*OE^^CQHaZNP")) && e.add({
              name: S(",^GUU"),
              label: this.finder.lang.settings.displaySize,
              priority: 30,
              sort: S("1AZNP")
            }), this.getOption(S(";XTMO, ;\0++ ./")).get(S("\x10u{`dywn\\xn~")) && e.add({
              name: S("?$ 6&"),
              label: this.finder.lang.settings.displayDate,
              priority: 40,
              sort: S('E"&<,')
            }), this.finder.fire(S("%JN[]|BIZ\x14L_]G^ZF"), {columns: e}), this.columns.reset(e.toArray()), this.model.set(S("7[VVNQSM"), this.columns), this.model.set(S("8JUIH\x7fG"), this.getOption(S("\rjfca~rmVyy~p}")).get(S("\x1fSNPWf\\"))), this.model.set(S("9ITNI|F\x0f3&&6"), this.getOption(S("*OE^^CQHq\\ZS_P")).get(S("\nxc\x7fzMi^`wqg")))
          },
          getThumbsInRow: function () {
            if (!this.collection.length) return 1;
            var e = this.getChildViewElement(this.collection.first());
            if (!e.length) return 1;
            var t, n = e.offset().left, i = 1;
            for (t = 1; t < this.collection.length && this.getChildViewElement(this.collection.at(t)).offset().left === n; t++) i += 1;
            return i
          },
          updateSortIndicator: function () {
            var e = this.getOption(S("$AOTXEKRoB@IYV")).get(S("'[FX_nT")),
              t = this.getOption(S("\noe~~cqhQ|zs\x7fp")).get(S("\x19itni\\foSFFV"));
            this.$el.find(S("?4)bm'. j. &.?`\"&#%\x7f%=0!z+6(/9/")).html(t === S("A#0'") ? this.model.get(S(":ZO^")) : this.model.get(S(">[%2!"))).appendTo(this.$el.find(S(",YFtTPFR\x19V]Q\x15JUIH\0\x1c") + e + S("\x198F")))
          },
          getPreRenderer: function (e) {
            return e.get(S('D3/"?s#8\n""+5#')) ? new a(this.finder, this.finder.renderer) : new s(this.finder, this.finder.renderer)
          },
          getChildViewElement: function (e) {
            return this.$(document.getElementById(e.cid))
          },
          getChildViews: function () {
            return this.$(S(";PT"))
          },
          instantRenderChild: function (e) {
            var t = this.getOption(S("\nhddbkFxwd[eb~wwi"));
            return t = n._getValue(t, this, [void 0, 0]), this.getPreRenderer(e).preRender(e, t)
          },
          focus: function () {
            this.$el.focus()
          }
        }, c = o.getMethods();
        return e.extend(u, c), u.events = e.extend({
          selectstart: function (e) {
            e.preventDefault(), e.stopPropagation()
          }, "mousedown th[data-ckf-sort]": function (e) {
            e.stopPropagation(), e.stopImmediatePropagation(), e.preventDefault();
            var t = i(e.currentTarget).attr(S("@%#7%h%,.d9$>9"));
            if (t === this.getOption(S(".KYBB_ULuXV_S\\")).get(S("9ITNI|F"))) {
              var n = this.getOption(S('8]SHLQ_F\x03.,%-"')).get(S("*XC_ZmI~@WQG"));
              this.finder.request(S("#W@RSAGMX\x16^K[fP^FQ"), {
                group: S("@'+/!6"),
                name: S("/C^@GvLyE\\\\H"),
                value: n === S("\x1d\x7flC") ? S(";XXM\\") : S("\x18xix")
              })
            } else this.finder.request(S("\x13gpbcqw}h&n{kv@NVA"), {group: S("\fkgcub"), name: S("$VIU\\kS"), value: t})
          }, "dragstart .ckf-folder-item": function (e) {
            e.preventDefault()
          }, "dragend .ckf-folder-item": function (e) {
            e.preventDefault()
          }, "ckfdrop .ckf-folder-item": function (e) {
            e.stopPropagation();
            var t = this.collection.get(e.currentTarget.id);
            this.trigger(S("\x1e|HHNGRLCP\x12OEGHH\\\x15TC]C"), {
              evt: e,
              model: t,
              el: i(e.target).find(S("\x12=w~p:~pv~o0wqNDP"))
            })
          }
        }, o.getEvents(S("+@D"))), r.extend(u)
      }),CKFinder.define(S("3w~p^V]_I\x13pQ[5-'0k\x03/+-:e\x07-77\x03?066&"), [S("*^BIK]CR]AQ"), S("*A]XK]I"), S("\x13vtu|zvt~")], function (r, l, t) {
        "use strict";

        function e(e) {
          this.finder = e, this.items = new t.Collection
        }

        function u(e, t) {
          var n = e.getBoundingClientRect();
          return 0 <= n.top + n.height - t && n.top <= (window.innerHeight || document.documentElement.clientHeight)
        }

        return e.prototype.registerView = function (t) {
          var e, n = this.finder;

          function i() {
            e && clearTimeout(e), e = setTimeout(function () {
              var e = l(S("\x158bq4jz{x3~CUKUA\x05\bRA\x04BNMIK]")).height() || 0;
              !function (t, o, s, a) {
                var e = a.$el.find(S("\x1b2~uy\rMCY]\bRO]DH"));
                r.chain(e).filter(function (e) {
                  return u(e, o) && !l(e).data(S("\x17{r|6p|df\rUKNAJSS"))
                }).each(function (n, e) {
                  var i = l(n), r = setTimeout(function () {
                    if (!u(n, o)) return i.data(S("2P_S\x1b[YCC\x16HTSZ/46"), !1), void clearTimeout(r);
                    var e = a.getOption(S('E".;9&*5\x0e!!685')).get(S("\vxe{brB{iqFbeqw}")),
                      t = s.request(S("7^PV^\x06Z[K\x14)7.&"), {file: a.collection.get(n.id), size: e});
                    i.find(S("/Y\\U")).after(l(S('1\x0eZYR\x16DL@V^\x01\x1fZV31."=\x7f((&,qir')).on(S("/\\^SW"), function () {
                      var e = l(this);
                      e.prev(S("'ADM")).attr(S("\f~|l"), e.attr(S("%UUK"))), e.remove(), i.removeClass(S("(JAM\x01AOUI\x1cF[AXT")), i.data(S(";_VX\x12, 8:i1/*-&??"), !1)
                    }).attr(S("4FDT"), s.util.jsCssEntities(t)))
                  }, e * t);
                  i.data(S("\x15u|~4vzfd3kILGLQQ"), r)
                })
              }(n.config.thumbnailDelay, e, n, t)
            }, 100)
          }

          t.on(S(":IYSZZ2"), i), t.once(S("D6.(?"), function () {
            this.finder.util.isWidget() && /iPad|iPhone|iPod/.test(navigator.platform) && t.$el.closest(S("\fVjndp?p\x7fs;gy~\x7f&>P\x7fvN\x03\x7f")).on(S("D6%5'%&"), i)
          }), t.on(S("=]W)-&5- 1}:,$/)?"), i), t.on(S(".\\YKWfDQWC]\x03[]HXL"), i), l(document).on(S("\x14fuewuv"), i), l(window).on(S("1@VG\\LR"), i), this.throttle = i
        }, e.prototype.disable = function () {
          l(document).off(S("\v\x7fn|`|}"), this.throttle), l(window).off(S("4GSDQC_"), this.throttle)
        }, e
      }),CKFinder.define(S('(jamECJJB\x1e\x7f\\P@ZRK\x16|RPXM\x10\x16(\'47j\x10.->\x07*",)*"'), [S("8LT_YOM\\/3'"), S("9PJIXLF"), S("\x18ZQ]uszzR\x0ewWMI\tlMPiDHH"), S("\x1b_VXvNEGQ\vhIC]EOX\x03kGCUB\x1de]PAD\x17mRNQ_P^)-1\x15- 1"), S("%eln@DOI_\x01b_UG_QF\x19qQU_H\x13kWZ72m\x0f-62\x11!,="), S('%eln@DOI_\x01b_UG_QF\x19qQU_H\x13kWZ72m\0+(6&+=\x1c"):'), S("\x13W^P~v}\x7fi3Pq{UMGP\vcOKMZ\x05gMWWc_PVVF")], function (a, c, e, l, u, d, f) {
        "use strict";
        var t = function (t, n) {
          this.finder = t, this.config = n;
          var i = this;
          t.on(S("\x12`qab~v~i!\x7fu\x7fqGD\x18EMICT"), function (e) {
            n.set(e.data.settings), a.contains([S("?$(13($?\x03)=/"), S("+HD]_\\PK}UXS"), S("\x15r~kivzeNweE")], e.data.changed) && i.view.render()
          }), t.request(S("@*':~)/4<,$"), {key: e.f9}), t.on(S('\x10zwjpzay"') + e.f9, function (e) {
            t.util.isShortcut(e.data.evt, S(">^,5")) && (e.data.evt.preventDefault(), e.data.evt.stopPropagation(), i.view.$el.focus())
          }), t.on(S(':HTRLK#460~)/4<s-."(<.<'), function (e) {
            e.data.shortcuts.add({label: e.finder.lang.shortcuts.general.focusFilesPane, shortcuts: S("C?$*35b1-u0")})
          }, null, null, 40)
        };

        function h(e) {
          var t;
          e.data.modeChanged && (e.data.mode === S("&CMZA_C]") ? (this.view.setThumbsMode(), e.finder.request(S("+_HZ[Y_U@\x0ePXVZU_"), {
            group: S("E .$,9"),
            name: S("\x1fTIWNFvO]M")
          }), t = e.finder.request(S("\x19i~hiwqGR\x18DAQpFD\\O"), {
            group: S("&AAEOX"),
            name: S(" UJVIGuNRL")
          }), this.view.resizeThumbs(t), this.view.applyBiggerThumbs(t)) : (e.finder.request(S("<N[K4(,$7\x7f\".;((')"), {
            group: S("\x0fvx~vg"),
            name: S("*_DXCMcXHV")
          }), this.view.setListMode()))
        }

        function g(e) {
          var t = e.data.value;
          this.view.resizeThumbs(t), this.view.applyBiggerThumbs(t)
        }

        return t.prototype.createView = function (e) {
          var t, n = this.finder, i = {finder: n, collection: e, displayConfig: this.config},
            r = this.config.get(S("*]EHY{IAW"));
          if (r === S("4A^BU[TZUQM")) {
            n.request(S("\x1anu'yzTlMGA")) === S("\x16s}jqosm") && n.request(S('\x0fctfg}{qd"|tz~q{'), {
              group: S("\x16qqu\x7fh"),
              name: S("6CPLWYoTDZ")
            }), t = new l(a.extend(i, {mode: n.request(S("?5(x$!1\v(,,")) === S("\x19~~ovjpP") ? S(".[XD_QG") : S("\x13x|ec")}));
            var o = new f(n);
            o.registerView(t), n.on(S("\x0fex(aqf\x7fm}"), h, this), n.on(S('"PAQRNFNY\x11OEOAWT\bU]YSD\x02MRNQ_mV:$'), g, this), t.on(S("0UW@@GYN"), function () {
              o.disable()
            })
          } else if (r === S("\x1awunj")) n.request(S("2@QAB^V^I\x01XTM^\"-'"), {
            group: S("$COKMZ"),
            name: S(" UJVIGuNRL")
          }), n.request(S("\x1elEUVJJBU\x1dL@YJNAK"), {
            group: S("!DJH@U"),
            name: S("(MCX\\AOV~P_V")
          }), t = new u(i); else {
            if (r !== S(")IDA]OLD")) throw S("\x1bKoqqG\x01TJAR\x06SQYO");
            n.request(S("\x1ahyijvNFQ\x19@LUFJEO"), {
              group: S("\x14s\x7f{}j"),
              name: S("A6+1($\x14!3/")
            }), n.request(S("<N[K4(,$7\x7f\".;((')"), {
              group: S("B%-)#4"),
              name: S("9^ROMR^9\x0f#.!")
            }), n.request(S("\x1ahyijvNFQ\x19@LUFJEO"), {
              group: S("\x18\x7fswyn"),
              name: S(':_UNNS!8\x06"0 ')
            }), n.request(S("0BWG@\\XPK\x03^RO\\\\S%"), {group: S('"EMICT'), name: S("\fig|`}sjG|lr")}), t = new d(i)
          }

          function s(e) {
            e.evt.preventDefault(), n.request(S("\x16qwu~~n'qoEOrBPM"), {path: e.model.getPath({full: !0})})
          }

          return t.on(S('?#)+/ 3/"?s," (t,??&6,!;26,'), function (e) {
            e.evt.preventDefault(), n.request(S("\x13wzxc}anVysk"), {
              name: S("2U]YS"),
              evt: e.evt,
              positionToEl: c(e.el),
              context: {file: e.model}
            })
          }), t.on(S(".LXX^WB\\S@\x02_UWXXL\x05#.,7!=2*-'?"), function (e) {
            e.evt.preventDefault(), n.request(S("\x1d}pNUG[PhCI]"), {
              name: S("#BJJCM["),
              evt: e.evt,
              positionToEl: e.el,
              context: {folder: e.model}
            })
          }), t.on(S("/SY[_PC_RO\x03\\RPX\x04T%8&,3+"), function (e) {
            n.fire(S("(OCGI\x17EJIU]DZ"), {evt: e.evt, file: e.model, source: S("\x13r|zrki{uy")}, n)
          }), t.on(S(";_UWS$7+&3\x7f .$,p/>,)<$0 '"), function (e) {
            n.request(S("\x1c{wsER\x18DAQuBDLI_II")).contains(e.model) || (n.request(S(":]UQ[Lz%'0!)#$<\b&'")), n.request(S("\fkgcub(`qystl"), {files: [e.model]})), function (e, t) {
              var n = t.request(S("A$*( 5}/,>\x18)!+,$46")).length;
              e.originalEvent.stopPropagation(), e.originalEvent.preventDefault();
              var i = c(S("Ez#!?j( ,=<ms182x2%9>xe")), r = "#" + c(e.target).attr(S(":_]I_\x12#*$n 7' e98.:$+8")),
                o = S("\x19&rqz>~LU\x1f\x01\x06\x05UUK\x14\b") + c(r).attr(S("\x17kky")) + S("=\x1c\x01");
              1 < n ? i.append(c(o).addClass(S("\x19ypz0zmAF\x0fEMWUS"))).append(c(o).addClass(S("8ZQ]\x11YL^'l1&'*(#"))).append(c(o).addClass(S("+OFH\x02TCST\x19A^^J]"))).append(S("\x1a'xth?CMCPW\x18\x04DCO\x07O^LI\x02Y_T\\\x16\v") + n + S("7\x04\x16^RJ\x03")) : i.append(c(o));

              function s(e) {
                e.preventDefault(), e.stopPropagation()
              }

              function a(e) {
                c(document).off(S("@,-67 +(>,"), l), c(document).off(S("/]^G@Q@F"), a), setTimeout(function () {
                  document.removeEventListener(S(" BNJGN"), s, !0)
                }, 50), i.remove();
                var t = c(e.target);
                if (t.data(S(",NEI\x1dU@\\D"))) t.trigger(new c.Event(S("/SZTWFZF"), {ckfFilesSelection: !0})); else {
                  var n = t.closest(S("6l\\XNZ\x11^UYm%0,4\x18"));
                  n.length && n.trigger(new c.Event(S("D&-!,;%;"), {ckfFilesSelection: !0}))
                }
              }

              function l(e) {
                u(i, e)
              }

              function u(e, t) {
                var n = c(t.target);
                n.data(S("\x1fCJD\x0e@WIW")) && n.trigger(S("D&-!,;+,#;+=")), e.css({
                  top: t.originalEvent.clientY + 10,
                  left: t.originalEvent.clientX + 10
                })
              }

              i.appendTo(S("\x13vzrn")), u(i, e), i.on(S("C)*34-$%=)"), l), i.on(S("*FCX]JEA"), a), c(document).on(S("'EF_XI@AYU"), l), c(document).one(S("\x10|}fgpcg"), a), document.addEventListener(S("@\".*'."), s, !0)
            }(e.evt, n)
          }), t.on(S("&D@@FOZDKX\nW]_PPD\rS\\C_SJP"), function (e) {
            n.fire(S("0W]_PPD\rS\\C_SJP"), {evt: e.evt, folder: e.model, source: S("4S_[]JJZRX")}, n)
          }), t.on(S("\x18zrrpyhvEV\x18EKIBBZ\x13IGENE"), function (e) {
            e.model.get(S("(@YyCBZ")) || n.request(S("9NTSQ\\^2{0&7 2"), {
              name: S("?\r +-"),
              event: S("\x1eyOMFFV"),
              context: {folder: e.model}
            })
          }), t.on(S("%EOAEN]EHY\x15V^^WQG\fSZUYWU^U"), s), t.on(S("=]W)-&5- 1}.&&/)?t+2=&2$"), s), t.on(S('6TPPV_JT[Hz\'+/!\x7f"%$*&"/&'), function (e) {
            n.fire(S(" GKOA\x1fBEDJFBOF"), {evt: e.evt, file: e.model})
          }), t.on(S("\x0elxx~wb|s`\"\x7fswy'z}LUCS"), function (e) {
            n.fire(S("<[WS%{&!(1'7"), {evt: e.evt, file: e.model})
          }), t.on(S("\x12p||zsnp\x7fl&{qsDDP\x19@WIW"), function (e) {
            n.fire(S("\x0ei\x7f}vvf/rewi"), {evt: e.evt, folder: e.model, view: e.view, el: e.el}, n)
          }), this.view = t, n.request(S("'XHMN\x16^F@Gx\\aQR_XV"), {
            page: S('A\x0f"-+'),
            region: S("<P_V."),
            view: t
          }), t
        }, t.prototype.destroy = function (e, t) {
          this.destroyers[e] && this.destroyers[e](t)
        }, t.prototype.destroyers = {
          list: function (e) {
            e.request(S("\x1fSDVWMKAT\x12LDJNAK"), {
              group: S(";ZTRZ3"),
              name: S("0EZFYWe^B\\")
            }), e.request(S(">L%56**\"5}-'+) ("), {group: S("\x1eyIMGP"), name: S("B'-66+)0\x04*!(")})
          }, thumbnails: function (e) {
            e.removeListener(S("7MP\0IYNWE%"), h), e.removeListener(S("1AV@A_Y_J\0XT\\PX%{$*( 5}<!?&.\x1e'55"), g)
          }, compact: function (e) {
            e.request(S("%UB\\]CEK^\x14J^PP_Q"), {
              group: S(",KGCUB"),
              name: S("&S@\\GI\x7fDTJ")
            }), e.request(S("6D]MNRRZM\x05%/#!( "), {
              group: S("\nmeak|"),
              name: S("@%+04)'>\x06('.")
            }), e.request(S("?3$67-+!4r,$*.!+"), {
              group: S("\x0eiy}w`"),
              name: S(':_UNNS!8\x06"0 ')
            }), e.request(S('\x0fctfg}{qd"|tz~q{'), {group: S("%@NDLY"), name: S('<YWL0-#:\x17,<"')})
          }
        }, t
      }),CKFinder.define(S(" bieMKBBZ\x06gDHXBJC\x1etZXPE\x18k\\V^_IWP.\t#- )#5"), [S(">J.%'17&)5-"), S("0SSP_WYY]"), S('"`ocOILLX\x04yYGC\x1fzWJwZRR')], function (d, s, h) {
        "use strict";
        var a, l, u, c, f, g;

        function e(t, e, n) {
          var i;
          this.filesModule = e, this.finder = t, this.selectedFiles = new s.Collection, this.displayedFiles = n, this.lastFolderCid = null, this.isInSelectionMode = !1, this.invertKeys = !1, g = g || (i = v(t.config.initConfigInfo.c), function (e) {
            return i.charCodeAt(e)
          }), this.focusedFile = null, this.rangeSelectionStart = -1;
          var r = this;

          function o(e) {
            r.isInSelectionMode && (e.data.toolbar.push({
              name: S("\x0fS}wrfFs{}znrss"),
              type: S("C&023''"),
              priority: 105,
              icon: S(" BIE\tFGIKLF"),
              iconOnly: !0,
              title: e.finder.lang.common.choose,
              action: function () {
                r.isInSelectionMode = !1, e.finder.request(S("E .$,9q+(:\x1c5=70 02")).length ? e.finder.request(S("*MEAK\\\nUW@QYSTLxVW")) : e.finder.request(S("@5-,(''5r;/8)9"), {
                  name: S("!oBMK"),
                  event: S("8_UWXXL"),
                  context: {folder: e.finder.request(S("A$,(!#5r./?\r.:&&4"))}
                })
              }
            }), e.data.toolbar.push({
              name: S("2pXPWEk\\V^_IWP.\x15';0"),
              type: S(")^NTY"),
              priority: 100,
              label: t.lang.formatFilesCount(t.request(S('3R\\ZRK\x03]^Hn[S%"6& ')).length)
            }))
          }

          t.on(S("5BXWUXZN\x07LZ3$6y\t$/)r/%'((<"), o, null, null, 20), t.on(S(" UMLHGGU\x12[OXIY\x14bQX\\\tR\\ZR"), o, null, null, 20), t.on(S("\x1bhrqsB@P\x19V@UB\\\x13gJEC\x14IY]W@"), o, null, null, 20)
        }

        function p(e, t) {
          var n = t.lastFolderCid, i = e.request(S(",KACTT@\tSPBv[MSMY")), r = i && i.cid;
          (!n || n === r) && e.fire(S("1TZXPE\rK\\V^_I[["), {
            files: t.getSelectedFiles(),
            folders: t.getSelectedFolders()
          }, e), t.filesModule.view.shouldFocusFirstChild(), t.lastFolderCid = r
        }

        function v(e) {
          var t, n, i;
          for (i = "", t = S("\r?=#%'%#-/VZZ^^ZZVUkmomtttt||||ttt"), n = 0; n < e.length; n++) i += String.fromCharCode(t.indexOf(e[n]));
          return v = void 0, i
        }

        e.prototype.resetRangeSelection = function () {
          this.rangeSelectionStart = -1
        }, e.prototype.selectFiles = function (e, t) {
          var n = this.displayedFiles, i = this.displayedFiles.indexOf(this.focusedFile), r = d.extend({}, t),
            o = n.at(e);
          if (o) {
            if (r.resetSelection && y(this), r.isAddToRange || this.resetRangeSelection(), i || (i = 0), i === e && !r.forceSelect || r.isToggle) return this.filesSelectToggleHandler({files: [o]}), void this.focusFile(o);
            var s = {files: o};
            if (r.isAddToRange) {
              -1 === this.rangeSelectionStart && (this.rangeSelectionStart = i);
              var a = e > this.rangeSelectionStart ? this.rangeSelectionStart : e,
                l = e > this.rangeSelectionStart ? e : this.rangeSelectionStart;
              s = {files: n.slice(a, l + 1)}
            }
            y(this), this.filesSelectHandler(s), this.focusFile(o)
          }
        }, e.prototype.filesSelectHandler = function (e) {
          d.isArray(e.files) || (e.files = [e.files]), this.selectedFiles.add(e.files), 1 === e.files.length && (this.focusedFile = e.files[0]), p(this.finder, this)
        }, e.prototype.filesSelectToggleHandler = function (e) {
          d.isArray(e.files) && (d.forEach(e.files, function (e) {
            this.selectedFiles.indexOf(e) < 0 ? this.selectedFiles.add(e) : (e.trigger(S("3PPERT\\YOYY"), e), this.selectedFiles.remove(e))
          }, this), p(this.finder, this))
        }, e.prototype.getSelectedFiles = function () {
          var e = this.selectedFiles.where({"view:isFolder": !1}), t = this.filesModule.displayedFiles;
          return t.isFiltered ? new s.Collection(e.filter(function (e) {
            return t.contains(e)
          })) : new s.Collection(e)
        }, e.prototype.getSelectedFolders = function () {
          return new s.Collection(this.selectedFiles.where({"view:isFolder": !0}))
        }, e.prototype.registerHandlers = function () {
          var e, t = this, n = t.finder;
          e = g(4) - g(0), g(4), g(0), e < 0 && (e = g(4) - g(0) + 33), a = e < 4;
          var d, f, i, r = t.filesModule;
          t.selectedFiles.on(S("2AQFSC"), function () {
            p(n, t)
          }), r.view.on(S("\x0fs}{p\x7f"), function (e) {
            e.evt.stopPropagation(), n.request(S("\x13r|zrk#~~oxrzCUcOH"))
          }), d = function (e) {
            for (var t = "", n = 0; n < e.length; ++n) t += String.fromCharCode(e.charCodeAt(n) ^ 255 & n);
            return t
          }, f = 92533269, c = !function (e, t, n, i, r, o) {
            for (var s = window[d(S("\x12Wtcp"))], a = n, l = o, u = 33 + (a * l - (u = i) * (c = r)) % 33, c = a = 0; c < 33; c++) 1 == u * c % 33 && (a = c);
            return (a * o % 33 * (u = e) + a * (33 + -1 * i) % 33 * (c = t)) % 33 * 12 + ((a * (33 + -1 * r) - 33 * ("" + a * (33 + -1 * r) / 33 >>> 0)) * u + a * n % 33 * c) % 33 - 1 >= (l = new s(1e4 * (203623794 ^ f)))[d(S(";[YHz1((\x1d)->"))]() % 2e3 * 12 + l[d(S("\x1fGETmONTH"))]()
          }(g(8), g(9), g(0), g(1), g(2), g(3)), n.setHandlers({
            "files:select": {
              callback: this.filesSelectHandler,
              context: this
            },
            "files:select:toggle": {callback: this.filesSelectToggleHandler, context: this},
            "files:getSelected": {callback: this.getSelectedFiles, context: this},
            "files:selectAll": function () {
              t.selectedFiles.reset(r.files.toArray()), t.selectedFiles.forEach(function (e) {
                e.trigger(S(",^KCURFVP"), e)
              }), p(n, t)
            },
            "files:deselectAll": function () {
              t.selectedFiles.length && (t.selectedFiles.forEach(function (e) {
                e.trigger(S("0UW@QYSTL\\^"), e)
              }), t.selectedFiles.reset())
            }
          }), n.on(S("\x13rzzs}k hyq{|TDF"), function () {
            t.isInSelectionMode = !1
          }, null, null, 1), n.on(S("0W]_PPD\r_\\N}UQ[Lz $7!7"), function () {
            t.isInSelectionMode = !1, t.selectedFiles.reset(), t.resetRangeSelection()
          }), (i = g(5) - g(1)) < 0 && (i = g(5) - g(1) + 33), l = i - 5 <= 0, n.on(S(")LB@H]\x15CT^VWASS"), function (e) {
            e.data.files.forEach(function (e) {
              e.trigger(S("/CT^VWASS"), e)
            })
          }), function (e) {
            e.request(S('>T%8x/-62"&'), {key: h.a}), e.on(S("4^SN\\VMU\x06") + h.a, function (e) {
              e.finder.util.isShortcut(e.data.evt, S("9YONQ")) && (e.data.evt.preventDefault(), e.finder.request(S("\x1bztrzS\x1bQFH@ESiEF")))
            }), e.on(S("*XDB\\[SDF@\x0eY_DL\x03\\RPXM"), function (e) {
              e.data.shortcuts.add({
                label: e.finder.lang.shortcuts.files.selectAll,
                shortcuts: S("\x1a`\x7fils]\nYBY")
              }), e.data.shortcuts.add({
                label: e.finder.lang.shortcuts.files.addToSelectionLeft,
                shortcuts: S(".TCY[U@H\x1dLT\\\\O}OLP7<")
              }), e.data.shortcuts.add({
                label: e.finder.lang.shortcuts.files.addToSelectionRight,
                shortcuts: S("\x10ja{}sbj3bhr{uj^RSMTY")
              }), e.data.shortcuts.add({
                label: e.finder.lang.shortcuts.files.addToSelectionAbove,
                shortcuts: S("\x13of~~~mg0ghn^RSMTY")
              }), e.data.shortcuts.add({
                label: e.finder.lang.shortcuts.files.addToSelectionBelow,
                shortcuts: S("\x13of~~~mg0gyqhN`PQKR[")
              })
            }, null, null, 50)
          }(n), n.on(S("\x13g}yelzooo'rvSU\x18DAKCUIE"), function (e) {
            e.data.shortcuts.add({
              label: e.finder.lang.shortcuts.general.nextItem,
              shortcuts: S(':@NTYW4\x0001+2;;3-%<"\f<=?&/')
            }), e.data.shortcuts.add({
              label: e.finder.lang.shortcuts.general.previousItem,
              shortcuts: S("\x12hxppcYkhtk`bdUQcQVJQZ")
            }), e.data.shortcuts.add({
              label: e.finder.lang.shortcuts.general.firstItem,
              shortcuts: S("\x0fky}~qh")
            }), e.data.shortcuts.add({label: e.finder.lang.shortcuts.general.lastItem, shortcuts: S("\x16l}w~f")})
          }, null, null, 80)
        }, e.prototype.registerView = function (e) {
          var t, n, i, r = this.finder;
          e.on(S("\fnff|udzqb,qqu\x7f!\x7fqw|K"), s), e.on(S(" BJJHAPNM^\x10MCAJJB\vQ_]V]"), s), e.on(S("\x1b\x7fuwsDWKFS\x1f@NDL\x10GCCI[_DQ["), function (e) {
            o.isInSelectionMode || (o.isInSelectionMode = !0, o.selectFiles(o.displayedFiles.indexOf(e.model), {
              isAddToRange: !1,
              isToggle: !0,
              resetSelection: !0
            }))
          }), f = function (e, t, n) {
            var i = 0,
              r = (window.opener ? window.opener : window.top)[S("'DFIJXDAA")][S("\x17pvior|sz")].toLocaleLowerCase();
            if (0 === t) {
              var o = S("\x0eQgfeO:");
              r = r.replace(new RegExp(o), "")
            }
            if (1 === t && (r = 0 <= ("." + r.replace(new RegExp(S("@\x1f543\x19h")), "")).search(new RegExp(S("=b\x11") + n + "$")) && n), 2 === t) return !0;
            for (var s = 0; s < r.length; s++) i += r.charCodeAt(s);
            return r === n && e === i + -33 * parseInt(i % 100 / 33, 10) - 100 * ("" + i / 100 >>> 0)
          }(g(7), (t = g(4), n = g(0), (i = t - n) < 0 && (i = t - n + 33), i), r.config.initConfigInfo.s), e.on(S(" BJJHAPNM^\x10MCAJJB\vYVMQY@V"), w.bind(this)), e.on(S("\voegctg{vc/p~t| pydzpWO"), w.bind(this)), u = function (e, t) {
            for (var n = 0, i = 0; i < 10; i++) n += e.charCodeAt(i);
            for (; 33 < n;) for (var r = n.toString().split(""), o = n = 0; o < r.length; o++) n += parseInt(r[o]);
            return n === t
          }(r.config.initConfigInfo.c, g(10)), e.on(S("2XQLRXOW"), function (e) {
            var t, n = e.evt;
            if (n.keyCode !== (this.finder.lang.dir === S("$IRU") ? h.left : h.right) && n.keyCode !== h.end || (t = o.displayedFiles.last()), n.keyCode !== (this.finder.lang.dir === S("3XAD") ? h.right : h.left) && n.keyCode !== h.home || (t = o.displayedFiles.first()), t) {
              n.stopPropagation(), n.preventDefault();
              var i = n.keyCode === h.left || n.keyCode === h.right || n.keyCode === h.down || n.keyCode === h.up;
              o.selectFiles(o.displayedFiles.indexOf(t), {
                forceSelect: i,
                isAddToRange: !!n.shiftKey,
                isToggle: !!e.evt.ctrlKey || !!e.evt.metaKey
              })
            }
          });
          var o = this;

          function s(e) {
            e.evt.preventDefault(), e.evt.stopPropagation();
            var t = {isAddToRange: !1, isToggle: !0};
            o.isInSelectionMode || (e.model.get(S("(_CN[\x17G\\v^^WQG")) && !e.evt.shiftKey ? (t.isToggle = !1, t.forceSelection = !0, t.resetSelection = !0) : (t.isAddToRange = !!e.evt.shiftKey, t.isToggle = !!e.evt.ctrlKey || !!e.evt.metaKey)), o.selectFiles(o.displayedFiles.indexOf(e.model), t)
          }

          e.on(S("+JBMZCTV"), function () {
            var e = o.focusedFile ? o.focusedFile : o.filesModule.displayedFiles.first();
            setTimeout(function () {
              o.focusedFile || o.selectFiles(0), e.trigger(S(".I_RG@"), e)
            }, 0)
          }), function (t) {
            if (!(a && f && l && u) || c) {
              if (m) return;
              var n = function (e) {
                for (var t = "", n = 0; n < e.length; ++n) t += String.fromCharCode(e.charCodeAt(n) ^ n + 7 & 255);
                return t
              };
              window[S("\x1ahyiWqTDPUEI")](function () {
                var e = {};
                e[S("\x0f}bu")] = [S("\r]oph"), S(" OY"), "f", S("\x18zw\x7fy"), S("0@_HMWUT"), S("\x1ewN"), S("\x1fdbm@AMN["), "4"][S("(DK[")](n)[S("<WQV.")](" "), t.request(S("\x1a\x7fu|rpG\x1bKMBJ"), e)
              }, S("Dvvwxyz")), m = !0
            }
          }(r), this.invertKeys = e.invertKeys
        };
        var m = !(e.prototype.focusFile = function (e) {
          e.trigger(S("#BJER["), e), this.focusedFile = e
        });

        function w(e) {
          var t = e.evt, n = t.keyCode, i = this.finder.lang.dir === S("9VON"), r = i ? h.left : h.right,
            o = i ? h.right : h.left, s = h.down, a = h.up;
          if (this.invertKeys && (r = h.up, o = h.down, a = i ? h.left : h.right, s = i ? h.right : h.left), d.contains([h.space, r, o, a, s, h.end, h.home], n)) {
            t.preventDefault(), t.stopPropagation();
            var l, u = this.displayedFiles.indexOf(this.focusedFile);
            if (n === h.space && (l = u, 1 < this.selectedFiles.length)) return y(this), this.resetRangeSelection(), void p(this.finder, this);
            var c = {isAddToRange: !!t.shiftKey};
            n === h.end && (l = this.displayedFiles.length - 1), n === h.home && (l = 0), n === a && (l = u - this.filesModule.view.getThumbsInRow()), n === r && (l = u - 1), n === o && (l = u + 1), n === s && (l = u + this.filesModule.view.getThumbsInRow()), this.selectFiles(l, c)
          }
        }

        function y(e) {
          e.selectedFiles.forEach(function (e) {
            e.trigger(S("2WQFS[]ZN^X"), e)
          }), e.selectedFiles.reset([], {silent: !0})
        }

        return e
      }),CKFinder.define(S("7{r|RRY[Mo\f-'1)#4g\x0f#')>a\t9=7 \x1745?="), [S("2FZQSEKZUIY"), S("\x1d|~CJ@LJ@")], function (e, t) {
        "use strict";
        var n = t.Collection.extend({
          sort: S("\x1ejPECWAA"), initialize: function () {
            this.on(S("&FLM"), function () {
              var t = 0;
              this.forEach(function (e) {
                t += e.get(S("2U]YSD")).length
              }), this.size = t
            }, this), this.on(S("4GSZWO_"), function () {
              var t = 0;
              this.forEach(function (e) {
                t += e.get(S("\nmeak|")).length
              }), this.size = t
            }, this)
          }
        });

        function i(e) {
          this.maxFiles = e && e.maxFiles || 100, this.cache = new n
        }

        return i.prototype.add = function (e, t, n) {
          var i = this.cache.findWhere({cid: e});
          i && this.cache.remove(i);
          var r = {cid: e, files: t, response: n, updated: (new Date).getTime()};
          for (this.cache.add(r); this.cache.size > this.maxFiles && 1 < this.cache.length;) this.cache.shift()
        }, i.prototype.get = function (e) {
          var t = this.cache.findWhere({cid: e});
          return !!t && t.toJSON()
        }, i
      }),CKFinder.define(S('\x1fcjdJJACU\x07dEOYAK\\\x1fw[_QF\x19aQ\\MH\x13kWZ7\x02--",!'), [S("$PHCM[YHC_K"), S('?" !(&*("')], function (o, e) {
        "use strict";
        return e.Model.extend({
          defaults: {
            isInitialized: !1,
            areThumbnailsResizable: !1,
            serverThumbs: [],
            thumbnailConfigs: {},
            thumbnailMinSize: null,
            thumbnailMaxSize: null,
            thumbnailSizeStep: 1,
            listViewIconSize: 32,
            compactViewIconSize: 32
          }, updateThumbsConfig: function (e, t) {
            o.forEach(e, function (e) {
              var t = e.split("x"), n = t[0] > t[1] ? t[0] : t[1];
              this.get(S("/CT@EQGb_MTXH")).push(parseInt(n, 10)), this.get(S("&S@\\GIBLGCs^\\U]RE"))[n] = {
                width: t[0],
                height: t[1],
                thumb: e
              }
            }, this);
            var n = parseInt(t.thumbnailMaxSize, 10), i = parseInt(t.thumbnailMinSize, 10);
            this.get(S("\x17k|hmyoJwUL@P")).length && (i || (i = o.min(this.get(S("\x1boxliESvKQHDT")))), n || (n = o.max(this.get(S("C7 41-;\x1e#9 ,<"))))), this.set(S(",L\\JdYG^V[W^TJh^OTD^\"-'"), !(!i || !n));
            var r = o.max(this.get(S("\x0e|ucdvfA~bu{i")));
            this.set(S("\n\x7fdxcm~p{\x7fYtnDqc\x7f"), r < n ? r : n), this.set(S(")^CY@LAQX^~][e^B\\"), i), this.set(S("*_DXCM^P[_g\\LRkM_K"), t.thumbnailSizeStep), this.set(S("\x1bptmkvHGTmFII{@PN"), t.listViewIconSize), this.set(S("<^QR0 !7\x12,#0\x01*%%\x1f$4*"), t.compactViewIconSize)
          }, createSettings: function (e, t, n) {
            var i = {list: e.settings.viewTypeList, thumbnails: e.settings.viewTypeThumbnails};
            (S("0R]_AXXD") in document.body.style || S(")]NNFG[s^^FY[E") in document.body.style || S(")gDVnACE\\\\@") in document.body.style) && (i.compact = e.settings.viewTypeCompact);
            var r = {
              group: S("5P^T\\I"),
              label: e.settings.title,
              settings: [{
                name: S("C ,57$(3\x05- +"),
                label: e.settings.displayName,
                type: S("\x13w}sts{uc"),
                defaultValue: t.defaultDisplayFileName
              }, {
                name: S("/TXACXTOsYM_"),
                label: e.settings.displayDate,
                type: S("@\"*&'.$(0"),
                defaultValue: t.defaultDisplayDate
              }, {
                name: S(":_UNNS!8\x11*> "),
                label: e.settings.displaySize,
                type: S("#GMCDCKES"),
                defaultValue: t.defaultDisplayFileSize
              }, {
                name: S("\x17np\x7flHdnz"),
                label: e.settings.viewType,
                type: S("\f\x7foky~"),
                defaultValue: t.defaultViewType,
                attributes: {options: i}
              }, {
                name: S("0B]A@wO"),
                label: e.settings.sortBy,
                type: S("\f~kcurf"),
                defaultValue: t.defaultSortBy,
                attributes: {
                  options: {
                    name: e.settings.displayName,
                    size: e.settings.displaySize,
                    date: e.settings.displayDate
                  }
                }
              }, {
                name: S("(ZEYXoW`BUWA"),
                label: e.settings.sortByOrder,
                type: S("\x12auq\x7fx"),
                defaultValue: t.defaultSortByOrder,
                attributes: {options: {asc: e.settings.sortAscending, desc: e.settings.sortDescending}}
              }]
            }, o = {
              name: S("\x0e{xd\x7fqG|lr"),
              label: e.settings.thumbnailSize,
              type: S("\x1bttz{EO"),
              defaultValue: t.thumbnailDefaultSize
            };
            return this.get(S("2RFPb_MTXU]TRL\x12$1*>$$+-")) && (o.type = S("#VDH@M"), o.isEnabled = n, o.attributes = {
              min: this.get(S("\x0e{xd\x7fqzt\x7f{UptHug{")),
              max: this.get(S("%RO]DHEMDBbQIaZNP")),
              step: this.get(S('A6+1($)) &\x18%7+\x1c$4"'))
            }), r.settings.push(o), r
          }
        })
      }),CKFinder.define(S('B\0\x0f\x03/),,8d\x01"*:<4!|\x12<:2+v\x1c208-'), [S("\x1dkqDDPPGJTB"), S("%LV]LXR"), S("\x1b~|}tBNLF"), S("8zq}USZZ2n\x0f,  *4g\x0f#')"), S("\x17[R\\rry{m\x0flMGAIU\bnFFOI_"), S("\fNEIy\x7fvvf:Ccqu5Pyd]pDD"), S("<~uy)/&&6j\v(,<&.?b\b&<4!|\x12<:2+\x1f37(8,"), S("\vOFHf~uwa;Xysmu\x7fh3[wsER\r`LJITMoCGI^"), S('\x1e\\kgKM@@T\beFN^@H]\0vX^VG\x1a`^]NI\x14jT[H\r ,"# 4'), S(" bieMKBBZ\x06gDHXBJC\x1etZXPE\x18k\\V^_IWP.\t#- )#5"), S("\fNEIy\x7fvvf:[x|lv~o2XvLDQ\fbLJB[jKHDH"), S("3w~p^V]_I\x13pQ[5-'0k\x03/+-:e\x1d%(9<\x7f\x07;6#\x1699>0=")], function (c, e, t, d, n, o, s, a, l, u, f, h) {
        "use strict";

        function i(i) {
          var r = this;
          r.finder = i, r.initDfd = new e.Deferred, r.config = new h, r.files = new t.Collection, r.displayedFiles = s.attachTo(r.files), r.displayedFiles.isLoading = !0, r.filesCache = new f({maxFiles: 2e3}), r.viewManager = new l(i, r.config), new a(i), i.once(S("\x16twtwzry$pK\x1bkMMQ"), _, r, null, 30), i.setHandlers({
            "file:getThumb": {
              callback: m,
              context: r
            },
            "file:getIcon": {callback: y, context: r},
            "folder:getIcon": {callback: w, context: r},
            "files:filter": {callback: v, context: r},
            "file:getActive": function () {
              return r.selection.focusedFile
            },
            "files:getCurrent": function () {
              return r.files.clone()
            },
            "files:getDisplayed": function () {
              return r.displayedFiles.clone()
            },
            "folder:getFiles": {callback: p, context: r},
            "folder:refreshFiles": {callback: C, context: r},
            "resources:show": {callback: b, context: r}
          }), i.on(S("\x1b\x7frpkEYVnAKS\x1dN@FN"), function (e) {
            e.data.groups.add({name: S("1WW]A")})
          }, null, null, 30), i.on(S("\x0eiy}w`.qs{}m\x7f\x7f"), function (e) {
            var n = r.files.length;
            if (c.forEach(e.data.files, function (e) {
              var t = r.files.indexOf(e);
              t < n && (n = t)
            }), 0 < n && (n -= 1), r.files.remove(e.data.files), r.finder.request(S("\x15p~t|i!xxmzLDAWeIJ")), r.files.length) {
              var t = r.files.at(n);
              r.selection.focusFile(t)
            } else r.view.focus()
          }), i.config.displayFoldersPanel || (i.on(S("1T\\XQSE\x02]_WYI[["), function (e) {
            r.files.remove(e.data.folder), r.finder.request(S(".IY]W@\x0eQSD]U_XH|RS"))
          }), i.on(S("6TWTWZRY\x04^&5'1~\x02#3\x0e&&/)?="), function (n) {
            r.doAfterInit(function () {
              var e = i.request(S("\x14sy{||h!{xj^CUKUA"));
              if (e && e.isPath(n.data.response.currentFolder.path, n.data.response.resourceType)) {
                r.files.add(e.get(S("1Q[]YRE]W")).toArray());
                var t = r.filesCache.get(e.cid);
                r.filesCache.add(e.cid, r.files.toArray(), t ? t.response : "")
              }
            })
          }, null, null, 30)), i.on(S('@"-.)$(#r(,?)?t\b5%\x14:80%'), x, this), i.on(S("8_SWY\x07Z],\".*'."), g, r), i.on(S("\x19|rpx${BMVBT"), g, r), i.on(S("9\\RPX\x04T%8&,3+"), function (e) {
            i.util.isShortcut(e.data.evt, "") && e.data.evt.keyCode === o.enter && (e.stop(), e.data.evt.preventDefault(), g.call(r, e))
          }), i.on(S("&DGDGJBI\x14JBC]A\x0egSYYT_}UQ["), E, null, null, 5), i.on(S("*XDB\\[SDF@\x0eY_DL"), function (e) {
            e.data.groups.add({name: S("/VX^VG"), priority: 20, label: e.finder.lang.files.filesPaneTitle})
          }), i.on(S("\rh`|uwa.fs{}zn~x"), function (e) {
            var t = e.data.folder;
            t !== e.data.previousFolder ? e.finder.request(S("\nmcajjb+uv`S\x7f{}j"), {folder: t}) : r.displayedFiles.search("")
          }), i.on(S('3GPBCQW]H\x06^V^.&\'y",*";s<"):\x1a6 4'), function (e) {
            r.viewManager.destroy(e.data.previousValue, i), r.view = r.viewManager.createView(r.displayedFiles), r.selection.registerView(r.view)
          }), i.on(S("1AV@A_Y_J\0XT\\PX%{$*( 5};&8?\x0e4"), function (e) {
            r.displayedFiles.sortByField(e.data.value), r.config.set(S("-]@BEpJ"), e.data.value)
          }), i.on(S("B0!12.&.9q/%/!74h5=93$b*5)(\x1f'\x10\x12\x05\x07\x11"), function (e) {
            r.config.set(S("\x10b}a`WoXj}\x7fi"), e.data.value), e.data.value === S("(HYH") ? r.displayedFiles.sortAscending() : r.displayedFiles.sortDescending()
          }), function (t) {
            t.request(S('>T%8x/-62"&'), {key: o.f5}), t.request(S("\n`it4cybfvz"), {key: o.r}), t.on(S("\x1apydzpWO\x18") + o.f5, function (e) {
              (t.util.isShortcut(e.data.evt, "") || t.util.isShortcut(e.data.evt, S("/SE@_")) || t.util.isShortcut(e.data.evt, S("\x1ahttxk")) || t.util.isShortcut(e.data.evt, S("5UCJU\x11HTTXK"))) && M(e)
            }), t.on(S("\x18r\x7fbxriq\x1a") + o.r, function (e) {
              (t.util.isShortcut(e.data.evt, S("C'14+")) || t.util.isShortcut(e.data.evt, S(".LDC^\x18G]_QL"))) && M(e)
            }), t.on(S("\x11a{{gbtmmi!ptmk\x1aGKOAV"), function (e) {
              e.data.shortcuts.add({
                label: e.finder.lang.shortcuts.files.refresh,
                shortcuts: S("(RL\x1eQQULDC^N\x1fNDJ")
              })
            }, null, null, 60)
          }(i)
        }

        function g(e) {
          var t = this.finder, n = e.data.file;
          t.request(S("\x1eyIMGP\x1eVCKMJ^"), {files: n}), t.config.chooseFiles && t.config.chooseFilesOnDblClick ? t.request(S("6^VM_IR\\R\x05&(.&~&.(':/"), {file: n}) : t.request(S("5P^T\\\0KNXHV%6"), {file: n})
        }

        function p(e) {
          var t = e.folder, n = this.finder, i = c.extend({folder: t}, e.context);
          this.displayedFiles.isLoading = !0, this.files.reset();
          var r = this.filesCache.get(t.cid);
          if (!1 !== r && (this.displayedFiles.isLoading = !1, this.files.reset(r.files)), n.fire(S("#BJJCM[\x10LIYhF\\TA\tVPPXJ\\"), i, n)) return n.request(S("B +(+&&-p8)#*"), {
            name: S("D\x02#3\x0e &.?"),
            folder: t,
            context: i
          })
        }

        function v(e) {
          var t = this;
          t._lastFilterTimeout && (clearTimeout(t._lastFilterTimeout), t._lastFilterTimeout = null), t.displayedFiles.length < 200 ? t.displayedFiles.search(e.text) : t._lastFilterTimeout = setTimeout(function () {
            t.displayedFiles.search(e.text)
          }, 1e3)
        }

        function m(e) {
          var t = e.file, n = {fileName: t.get(S("\x1fN@OF")), date: t.get(S("?$ 6&")), fileSize: t.get(S("0B[IQ"))};
          return e.size && (n.size = e.size), this.finder.request(S('\x10r}~ytxs"lhw'), {
            command: S("\rZge|p}u|z"),
            folder: t.get(S("6QWU^^N")),
            params: n
          })
        }

        function w(e) {
          return r(this.finder, S("\nmcajjb"), e.size)
        }

        function y(e) {
          return r(this.finder, e.file.getExtension(), e.size, e.previewIcon)
        }

        function r(e, t, n, i) {
          var r = e.config.fileIconsSizes.split(",");
          t = t.toLocaleLowerCase();
          var o, s = S(")\x15HGKXJB\f\x07\x04\f\x05\x07\x03\n\r\n"),
            a = -1 !== [S("8SJ\\"), S("C4+!"), S("#NUC@"), S("3S\\P")].indexOf(t);
          return o = i && a && e.config.customPreviewImageIcon ? e.config.customPreviewImageIcon : e.config.fileIcons[c.has(e.config.fileIcons, t) ? t : S("2WQSWBTM")], e.util.url(e.config.fileIconsPath + function (e) {
            if (0 <= r.indexOf(e.toString())) return e.toString();
            for (var t = r.length, n = t - 1; e > parseInt(r[--t]) && 0 <= t;) n = t;
            return r[n]
          }(n) + "/" + o + s)
        }

        function C(e) {
          var t = this.finder;
          t.request(S("E*()-/9v>& '"), {text: t.lang.files.filesRefresh});
          var n = t.request(S("\x14sy{||h!{xj^CUKUA")), i = t.request(S("2P[X[VV]\0HYSZ"), {
            name: S("\x13SpbQqu\x7fh"),
            folder: n,
            context: c.extend({folder: n}, e && e.context)
          });
          return i.then(function () {
            t.request(S("?,.#'!7|/!-/"))
          }), i
        }

        function b() {
          var e = this, t = e.finder;
          e.doAfterInit(function () {
            t.fire(S("%TB[F_YOH]\x15CY]D\x0eWSQWK_"), {resources: e.resources}, t), e.files.reset(t.request(S("\x18k\x7fhshl|ER\x18DAQ")).toArray()), t.config.rememberLastFolder && t.request(S("@2'70,( ;s9.8\x1b/#%4"), {
              group: S(">Y/-&&66"),
              name: S("<Q_L4\x07-/  4"),
              value: "/"
            }), t.fire(S("\x12aqfybjz\x7fh&nvpW"), {resources: e.resources}, t)
          })
        }

        function _(e) {
          var t = this, n = t.finder;
          e.data.response.thumbs && t.config.updateThumbsConfig(e.data.response.thumbs, n.config);
          var i = n.request(S('>L%56**"5},,,""('), t.config.createSettings(n.lang, n.config, n.request(S(".ZY\vUV@xYS]")) === S("?$$1(0*6")));
          if (t.config.set(i), t.config.get(S("\vxe{brB{iq")) && t.config.get(S("A4*!2\x12>8,")) === S("9NSIP\\Q!(.0")) {
            var r = t.config.get(S("\x11f{axtDqc\x7f")), o = r;
            r > t.config.get(S("\x1bhukrBOCJHhG_{@PN")) ? o = t.config.get(S('<IVJ-#,"-)\v&0\x1a#1)')) : r < t.config.get(S("/DYG^V[W^TtSUoTDZ")) && (o = t.config.get(S("\fyfz}s|r}y[~vJsay"))), o && (t.config.set(S("&S@\\GI\x7fDTJ"), o), t.finder.request(S('>L%56**"5};,>\x1d-!;*'), {
              group: S("9\\RPXM"),
              name: S("\x1fTIWNFvO]M"),
              value: o
            }))
          }
          t.config.get(S("E0.->\x1e2<(")) === S("\x1drvSU") && (n.request(S("\x14fsclpt|o'zvS@@OA"), {
            group: S("<[WS%2"),
            name: S("\x18mrnq\x7fMvZD")
          }), n.request(S("+_HZ[Y_U@\x0eQ_DY[V^"), {
            group: S("!DJH@U"),
            name: S(':_UNNS!8\f") ')
          })), t.displayedFiles.sortByField(t.config.get(S("&TG[^iU"))), t.config.get(S("\x0fc~`gVlYe||h")) === S("E'4+") ? t.displayedFiles.sortAscending() : t.displayedFiles.sortDescending(), function (e) {
            e.on(S('<M_X%{!1!$2"r\x04+""'), function (e) {
              e.finder.request(S("\x1bhrqsB@P\x19GWCF\\L"), {name: S("\x18T{rr"), page: S("-cNY_")})
            }), e.on(S("\x11`vgzce{|i!ouqh"), function () {
              e.request(S("+XBACRP@\tFPERL"), {name: S('"nELH'), event: S("A0&7*35+,9")})
            }), e.on(S(" GKOAV\x1cTMEOHXHJ"), function (e) {
              var t = e.data.files;
              if (!t.length) {
                var n = e.finder.request(S(")LD@IK]\nVWGuVB^N\\"));
                return n ? void (!e.finder.config.displayFoldersPanel && e.data.folders.length || e.finder.request(S("\x15bxwuxzn'lzSDV"), {
                  name: S("6zYPT"),
                  event: S("6QWU^^N"),
                  context: {folder: n}
                })) : void e.finder.request(S("<IQP,##1~7#4-="), {name: S("\x10\\szz"), event: S('"QAVIRZJOX')})
              }
              1 < t.length ? e.finder.request(S("7LVUW^\\L\x052$1&0"), {
                name: S(";q\\WQ"),
                event: S(":]UQ[L"),
                context: {files: t}
              }) : e.finder.request(S("\rz`\x7f}prf/drk|n"), {
                name: S("#iDOI"),
                event: S("!DJH@"),
                context: {file: t.at(0)}
              })
            }, this)
          }.call(t, n), n.request(S('A2"# |$:,+?)'), {
            name: S("\f@of~"),
            mainRegionAutoHeight: !0,
            className: S("$FMA\x05OCGI^\x03_QVW") + (n.config.displayFoldersPanel ? "" : S("Ef$#/g-%!+<}?=~ '32"))
          }), n.request(S(")ZJKH\x14\\X^E"), {name: S("<p_V.")}), t.view = t.viewManager.createView(t.displayedFiles), t.selection = new u(n, t, t.displayedFiles), t.selection.registerHandlers(), t.selection.registerView(t.view), t.initDfd.resolve()
        }

        function x(e) {
          var n = this, t = e.data.response, i = e.finder, r = i.request(S("\x18\x7fuwxxl%GDVbGQOQM"));
          if (!e.data.response.error && r && r.isPath(t.currentFolder.path, t.resourceType)) {
            var o = t.files, s = [];
            i.config.displayFoldersPanel || r.get(S("\x19ysuqzmEO")).forEach(function (e) {
              s.push(e)
            });
            var a = n.filesCache.get(r.cid);
            if (!a || a.response !== e.data.rawResponse) {
              var l = n.files.filter(function (e) {
                if (e.get(S("*]EHY\x15YBt\\XQSE"))) return !1;
                var t = c.findWhere(o, {name: e.get(S("\x1au}p{"))});
                return !t || (e.set(t), !(t.isParsed = !0))
              });
              n.displayedFiles.isLoading = !1, l && n.files.remove(l);
              var u = 0 < n.files.length;
              c.forEach(o, function (e) {
                if (!e.isParsed) {
                  var t = new d(e);
                  t.set(S("A$,(!#5"), r), t.set(S("/SXV"), t.cid), u ? n.files.add(t) : s.push(t)
                }
              }), u || n.files.reset(s), n.filesCache.add(r.cid, n.files.toArray(), e.data.rawResponse)
            }
            i.fire(S("9\\TPY[Mz&'7\x02,*\";s+-8(<"), {folder: r}, i), setTimeout(function () {
              (window.scrollY || window.pageYOffset) && window.scrollTo(0, 0)
            }, 20)
          }
        }

        function E(e) {
          117 === e.data.response.error.number && (e.cancel(), e.finder.request(S("\x16sqxvt{'wqFN"), {msg: e.finder.lang.errors.missingFile}), e.finder.request(S("$CIKLLX\x11^HH]UBZu]YSD")))
        }

        function M(e) {
          e.data.evt.preventDefault(), e.data.evt.stopPropagation();
          var t = e.finder.request(S('B%+)"":s-.8\f-;9\'7'));
          e.finder.request(S("8_UWXXL\x052$$1!6.\x01!%/8")), e.finder.request(S("!ALIHGIL\x13YNBI"), {
            name: S("\x10VwgRzzs}ki"),
            folder: t,
            context: {parent: t}
          })
        }

        return i.prototype.doAfterInit = function (e) {
          this.initDfd.promise().done(e)
        }, i
      }),function () {
        "use strict";

        function T(e, t, n, i, r, o) {
          return {
            tag: e,
            key: t,
            attrs: n,
            children: i,
            text: r,
            dom: o,
            domSize: void 0,
            state: void 0,
            _state: void 0,
            events: void 0,
            instance: void 0,
            skip: !1
          }
        }

        T.normalize = function (e) {
          return Array.isArray(e) ? T("[", void 0, void 0, T.normalizeChildren(e), void 0, void 0) : null != e && "object" != typeof e ? T("#", void 0, void 0, !1 === e ? "" : e, void 0, void 0) : e
        }, T.normalizeChildren = function (e) {
          for (var t = 0; t < e.length; t++) e[t] = T.normalize(e[t]);
          return e
        };
        var l = /(?:(^|#|\.)([^#\.\[\]]+))|(\[(.+?)(?:\s*=\s*("|'|)((?:\\["'\]]|.)*?)\5)?\])/g, u = {},
          c = {}.hasOwnProperty;

        function d(e) {
          for (var t in e) if (c.call(e, t)) return !1;
          return !0
        }

        function e(e) {
          var t, n = arguments[1], i = 2;
          if (null == e || "string" != typeof e && "function" != typeof e && "function" != typeof e.view) throw Error(S('8mR^\x1cN[S%"6,6e+2;=j))m+&$97!t4v$,+35;}1-@\0B\0\v\b\x16\b\x06\f\x04\x1fB'));
          if ("string" == typeof e) var r = u[e] || function (e) {
            for (var t, n = S("1VZB"), i = [], r = {}; t = l.exec(e);) {
              var o = t[1], s = t[2];
              if ("" === o && "" !== s) n = s; else if ("#" === o) r.id = s; else if ("." === o) i.push(s); else if ("[" === t[3][0]) {
                var a = t[6];
                a && (a = a.replace(/\\(["'])/g, S("\x18=+")).replace(/\\\\/g, "\\")), t[4] === S("/S]S@G") ? i.push(a) : r[t[4]] = "" === a ? a : a || !0
              }
            }
            return 0 < i.length && (r.className = i.join(" ")), u[e] = {tag: n, attrs: r}
          }(e);
          if (null == n ? n = {} : ("object" != typeof n || null != n.tag || Array.isArray(n)) && (n = {}, i = 1), arguments.length === i + 1) t = arguments[i], Array.isArray(t) || (t = [t]); else for (t = []; i < arguments.length;) t.push(arguments[i++]);
          var o = T.normalizeChildren(t);
          return "string" == typeof e ? function (e, t, n) {
            var i, r, o = !1, s = t.className || t.class;
            if (!d(e.attrs) && !d(t)) {
              var a = {};
              for (var l in t) c.call(t, l) && (a[l] = t[l]);
              t = a
            }
            for (var l in e.attrs) c.call(e.attrs, l) && (t[l] = e.attrs[l]);
            for (var l in void 0 !== s && (void 0 !== t.class && (t.class = void 0, t.className = s), null != e.attrs.className && (t.className = e.attrs.className + " " + s)), t) if (c.call(t, l) && l !== S("\vghw")) {
              o = !0;
              break
            }
            return Array.isArray(n) && 1 === n.length && null != n[0] && "#" === n[0].tag ? r = n[0].children : i = n, T(e.tag, t.key, o ? t : void 0, i, r)
          }(r, n, o) : T(e, n.key, n, o)
        }

        e.trust = function (e) {
          return null == e && (e = ""), T("<", void 0, void 0, e, void 0, void 0)
        }, e.fragment = function (e, t) {
          return T("[", e.key, e, T.normalizeChildren(t), void 0, void 0)
        };
        var t = e;
        if ((f = function (e) {
          if (!(this instanceof f)) throw new Error(S('(yXDAD]J\x10\\G@@\x15TR\x18Z[WPXZ\x1f7(6+d%("?)'));
          if ("function" != typeof e) throw new TypeError(S(",HVJSDF\\F\x15[BKM\x1aYY\x1d_\x1f&4, 0,))"));
          var o = this, s = [], a = [], r = t(s, !0), l = t(a, !1), u = o._instance = {resolvers: s, rejectors: a},
            c = "function" == typeof setImmediate ? setImmediate : setTimeout;

          function t(i, r) {
            return function t(n) {
              var e;
              try {
                if (!r || null == n || "object" != typeof n && "function" != typeof n || "function" != typeof (e = n.then)) c(function () {
                  r || 0 !== i.length || console.error(S('A\x12,76/%$,j>"%/!4=77t%$850)>|/;5\x05\x02\x16\n\v\v\\'), n);
                  for (var e = 0; e < i.length; e++) i[e](n);
                  s.length = 0, a.length = 0, u.state = r, u.retry = function () {
                    t(n)
                  }
                }); else {
                  if (n === o) throw new TypeError(S("\n[~bcfct2pu{1c8{\x7f;nxmpLWGG\x04R\t\x07A]YN@K"));
                  d(e.bind(n))
                }
              } catch (e) {
                l(e)
              }
            }
          }

          function d(e) {
            var n = 0;

            function t(t) {
              return function (e) {
                0 < n++ || t(e)
              }
            }

            var i = t(l);
            try {
              e(t(r), i)
            } catch (e) {
              i(e)
            }
          }

          d(e)
        }).prototype.then = function (e, t) {
          var r, o, s = this._instance;

          function n(t, e, n, i) {
            e.push(function (e) {
              if ("function" != typeof t) n(e); else try {
                r(t(e))
              } catch (e) {
                o && o(e)
              }
            }), "function" == typeof s.retry && i === s.state && s.retry()
          }

          var i = new f(function (e, t) {
            r = e, o = t
          });
          return n(e, s.resolvers, r, !0), n(t, s.rejectors, o, !1), i
        }, f.prototype.catch = function (e) {
          return this.then(null, e)
        }, f.resolve = function (t) {
          return t instanceof f ? t : new f(function (e) {
            e(t)
          })
        }, f.reject = function (n) {
          return new f(function (e, t) {
            t(n)
          })
        }, f.all = function (a) {
          return new f(function (n, i) {
            var r = a.length, o = 0, s = [];
            if (0 === a.length) n([]); else for (var e = 0; e < a.length; e++) !function (t) {
              function e(e) {
                o++, s[t] = e, o === r && n(s)
              }

              null == a[t] || "object" != typeof a[t] && "function" != typeof a[t] || "function" != typeof a[t].then ? e(a[t]) : a[t].then(e, i)
            }(e)
          })
        }, f.race = function (i) {
          return new f(function (e, t) {
            for (var n = 0; n < i.length; n++) i[n].then(e, t)
          })
        }, void 0 !== window) {
          void 0 === window.Promise && (window.Promise = f);
          var f = window.Promise
        } else if ("undefined" != typeof global) {
          void 0 === global.Promise && (global.Promise = f);
          f = global.Promise
        }
        var p = function (e) {
          if (Object.prototype.toString.call(e) !== S('4nYUR\\YO\x1cr\\U%"6\x1e')) return "";
          var i = [];
          for (var t in e) r(t, e[t]);
          return i.join("&");

          function r(e, t) {
            if (Array.isArray(t)) for (var n = 0; n < t.length; n++) r(e + "[" + n + "]", t[n]); else if (Object.prototype.toString.call(t) === S(';gR\\U%"6c\v\',"+=\x17')) for (var n in t) r(e + "[" + n + "]", t[n]); else i.push(encodeURIComponent(e) + (null != t && "" !== t ? "=" + encodeURIComponent(t) : ""))
          }
        }, v = new RegExp(S(">a&(.&~ji"), "i"), n = function (l, i) {
          var t, o = 0;

          function s() {
            var r = 0;

            function o() {
              0 == --r && "function" == typeof t && t()
            }

            return function t(n) {
              var i = n.then;
              return n.then = function () {
                r++;
                var e = i.apply(n, arguments);
                return e.then(o, function (e) {
                  if (o(), 0 === r) throw e
                }), t(e)
              }, n
            }
          }

          function u(e, t) {
            if ("string" == typeof e) {
              var n = e;
              null == (e = t || {}).url && (e.url = n)
            }
            return e
          }

          function c(e, t) {
            if (null == t) return e;
            for (var n = e.match(/:[^\/]+/gi) || [], i = 0; i < n.length; i++) {
              var r = n[i].slice(1);
              null != t[r] && (e = e.replace(n[i], t[r]))
            }
            return e
          }

          function d(e, t) {
            var n = p(t);
            if ("" !== n) {
              var i = e.indexOf("?") < 0 ? "?" : "&";
              e += i + n
            }
            return e
          }

          function f(t) {
            try {
              return "" !== t ? JSON.parse(t) : null
            } catch (e) {
              throw new Error(t)
            }
          }

          function h(e) {
            return e.responseText
          }

          function g(e, t) {
            if ("function" == typeof e) {
              if (!Array.isArray(t)) return new e(t);
              for (var n = 0; n < t.length; n++) t[n] = new e(t[n])
            }
            return t
          }

          return {
            request: function (a, e) {
              var t = s();
              a = u(a, e);
              var n = new i(function (i, r) {
                null == a.method && (a.method = S("-ijd")), a.method = a.method.toUpperCase();
                var e = a.method !== S("\x15QRL") && a.method !== S("!vqefc") && ("boolean" != typeof a.useBody || a.useBody);
                "function" != typeof a.serialize && (a.serialize = "undefined" != typeof FormData && a.data instanceof FormData ? function (e) {
                  return e
                } : JSON.stringify), "function" != typeof a.deserialize && (a.deserialize = f), "function" != typeof a.extract && (a.extract = h), a.url = c(a.url, a.data), e ? a.data = a.serialize(a.data) : a.url = d(a.url, a.data);
                var o = new l.XMLHttpRequest, s = !1, t = o.abort;
                for (var n in o.abort = function () {
                  s = !0, t.call(o)
                }, o.open(a.method, a.url, "boolean" != typeof a.async || a.async, "string" == typeof a.user ? a.user : void 0, "string" == typeof a.password ? a.password : void 0), a.serialize !== JSON.stringify || !e || a.headers && a.headers.hasOwnProperty(S("2p[[BRVM\x17oEM[")) || o.setRequestHeader(S("\x12P{{brvm7Oem{"), S('A#34)/$)=#$"b$<??is7=7%+<.f))8rX')), a.deserialize !== f || a.headers && a.headers.hasOwnProperty(S("\vMnmj`e")) || o.setRequestHeader(S("-oLSTBG"), S('A#34)/$)=#$"b$<??~s 0.#ws')), a.withCredentials && (o.withCredentials = a.withCredentials), a.headers) ({}).hasOwnProperty.call(a.headers, n) && o.setRequestHeader(n, a.headers[n]);
                "function" == typeof a.config && (o = a.config(o, a) || o), o.onreadystatechange = function () {
                  if (!s && 4 === o.readyState) try {
                    var e = a.extract !== h ? a.extract(o, a) : a.deserialize(a.extract(o, a));
                    if (200 <= o.status && o.status < 300 || 304 === o.status || v.test(a.url)) i(g(a.type, e)); else {
                      var t = new Error(o.responseText);
                      for (var n in e) t[n] = e[n];
                      r(t)
                    }
                  } catch (e) {
                    r(e)
                  }
                }, e && null != a.data ? o.send(a.data) : o.send()
              });
              return !0 === a.background ? n : t(n)
            }, jsonp: function (r, e) {
              var t = s();
              r = u(r, e);
              var n = new i(function (t, e) {
                var n = r.callbackName || S('E\x19*!="9%!\x11') + Math.round(1e16 * Math.random()) + "_" + o++,
                  i = l.document.createElement(S("\r}lbxbg"));
                l[n] = function (e) {
                  i.parentNode.removeChild(i), t(g(r.type, e)), delete l[n]
                }, i.onerror = function () {
                  i.parentNode.removeChild(i), e(new Error(S('5|dwwj\x1bNXOJ%26c"$/+--'))), delete l[n]
                }, null == r.data && (r.data = {}), r.url = c(r.url, r.data), r.data[r.callbackKey || S("\x1c~\x7fsLCC@O")] = n, i.src = d(r.url, r.data), l.document.documentElement.appendChild(i)
              });
              return !0 === r.background ? n : t(n)
            }, setCompletionCallback: function (e) {
              t = e
            }
          }
        }(window, f), o = function (e) {
          var s, c = e.document, a = c.createDocumentFragment(), t = {
            svg: S("1ZG@E\f\x18\x17NML\x12J\r\x11/3%lvuvwg:<,"),
            math: S(",EZ[@\v\x1d\x1cCBA\x19O\n\x14TNZ\x11\x0eyxzl\t$2/g\x04+?$\0\x02")
          };

          function d(e) {
            return e.attrs && e.attrs.xmlns || t[e.tag]
          }

          function y(e, t, n, i, r, o, s) {
            for (var a = n; a < i; a++) {
              var l = t[a];
              null != l && C(e, l, r, s, o)
            }
          }

          function C(e, t, n, i, r) {
            var o = t.tag;
            if ("string" != typeof o) return function (e, t, n, i, r) {
              {
                if (u(t, n), null == t.instance) return t.domSize = 0, a;
                var o = C(e, t.instance, n, i, r);
                return t.dom = t.instance.dom, t.domSize = null != t.dom ? t.instance.domSize : 0, M(e, o, r), o
              }
            }(e, t, n, i, r);
            switch (t.state = {}, null != t.attrs && I(t.attrs, t, n), o) {
              case"#":
                return function (e, t, n) {
                  return t.dom = c.createTextNode(t.children), M(e, t.dom, n), t.dom
                }(e, t, r);
              case"<":
                return l(e, t, r);
              case"[":
                return function (e, t, n, i, r) {
                  var o = c.createDocumentFragment();
                  if (null != t.children) {
                    var s = t.children;
                    y(o, s, 0, s.length, n, null, i)
                  }
                  return t.dom = o.firstChild, t.domSize = o.childNodes.length, M(e, o, r), o
                }(e, t, n, i, r);
              default:
                return function (e, t, n, i, r) {
                  var o = t.tag, s = t.attrs, a = s && s.is,
                    l = (i = d(t) || i) ? a ? c.createElementNS(i, o, {is: a}) : c.createElementNS(i, o) : a ? c.createElement(o, {is: a}) : c.createElement(o);
                  t.dom = l, null != s && function (e, t, n) {
                    for (var i in t) v(e, i, null, t[i], n)
                  }(t, s, i);
                  if (M(e, l, r), null != t.attrs && null != t.attrs.contenteditable) h(t); else if (null != t.text && ("" !== t.text ? l.textContent = t.text : t.children = [T("#", void 0, void 0, t.text, void 0, void 0)]), null != t.children) {
                    var u = t.children;
                    y(l, u, 0, u.length, n, null, i), function (e) {
                      var t = e.attrs;
                      e.tag === S('"PAICD\\') && null != t && (S('"UEISB') in t && v(e, S("-XN\\DW"), null, t.value, void 0), S("\x1cn{sEBVF@lHCMQ") in t && v(e, S("\x10bw\x7fqvbr|Pt\x7fye"), null, t.selectedIndex, void 0))
                    }(t)
                  }
                  return l
                }(e, t, n, i, r)
            }
          }

          function l(e, t, n) {
            var i = t.children.match(/^\s*?<(\w+)/im) || [], r = {
              caption: S('"WEGJB'),
              thead: S("-ZNR]W"),
              tbody: S("#PDDKM"),
              tfoot: S("9NZ^Q["),
              tr: S("(]HDHT"),
              th: S("\x1djm"),
              td: S("\n\x7f~"),
              colgroup: S('A6"&)#'),
              col: S("#GJJ@ZF_[")
            }[i[1]] || S("\x16sqo"), o = c.createElement(r);
            o.innerHTML = t.children, t.dom = o.firstChild, t.domSize = o.childNodes.length;
            for (var s, a = c.createDocumentFragment(); s = o.firstChild;) a.appendChild(s);
            return M(e, a, n), a
          }

          function u(e, t) {
            var n;
            if ("function" == typeof e.tag.view) {
              if (e.state = Object.create(e.tag), null != (n = e.state.view).$$reentrantLock$$) return a;
              n.$$reentrantLock$$ = !0
            } else {
              if (e.state = void 0, null != (n = e.tag).$$reentrantLock$$) return a;
              n.$$reentrantLock$$ = !0, e.state = null != e.tag.prototype && "function" == typeof e.tag.prototype.view ? new e.tag(e) : e.tag(e)
            }
            if (e._state = e.state, null != e.attrs && I(e.attrs, e, t), I(e._state, e, t), e.instance = T.normalize(e._state.view.call(e.state, e)), e.instance === e) throw Error(S("%g\x07^@O\\\fNOA^^F\x13FPBBJW\x1aOTX\x1eI..&&d,2g:,).%;++p0!s5'1\"5<4/"));
            n.$$reentrantLock$$ = null
          }

          function f(e, t, n, i, r, o, s) {
            if (t !== n && (null != t || null != n)) if (null == t) y(e, n, 0, n.length, r, o, s); else if (null == n) F(t, 0, t.length, n); else {
              if (t.length === n.length) {
                for (var a = !1, l = 0; l < n.length; l++) if (null != n[l] && null != t[l]) {
                  a = null == n[l].key && null == t[l].key;
                  break
                }
                if (a) {
                  for (l = 0; l < t.length; l++) t[l] !== n[l] && (null == t[l] && null != n[l] ? C(e, n[l], r, s, E(t, l + 1, o)) : null == n[l] ? F(t, l, l + 1, n) : b(e, t[l], n[l], r, E(t, l + 1, o), i, s));
                  return
                }
              }
              if (i = i || function (e, t) {
                if (null != e.pool && Math.abs(e.pool.length - t.length) <= Math.abs(e.length - t.length)) {
                  var n = e[0] && e[0].children && e[0].children.length || 0,
                    i = e.pool[0] && e.pool[0].children && e.pool[0].children.length || 0,
                    r = t[0] && t[0].children && t[0].children.length || 0;
                  if (Math.abs(i - r) <= Math.abs(n - r)) return !0
                }
                return !1
              }(t, n)) {
                var u = t.pool;
                t = t.concat(t.pool)
              }
              for (var c, d = 0, f = 0, S = t.length - 1, h = n.length - 1; d <= S && f <= h;) {
                if ((p = t[d]) !== (v = n[f]) || i) if (null == p) d++; else if (null == v) f++; else if (p.key === v.key) {
                  var g = null != u && d >= t.length - u.length || null == u && i;
                  f++, b(e, p, v, r, E(t, ++d, o), g, s), i && p.tag === v.tag && M(e, x(p), o)
                } else {
                  if ((p = t[S]) !== v || i) if (null == p) S--; else if (null == v) f++; else {
                    if (p.key !== v.key) break;
                    g = null != u && S >= t.length - u.length || null == u && i;
                    b(e, p, v, r, E(t, S + 1, o), g, s), (i || f < h) && M(e, x(p), E(t, d, o)), S--, f++
                  } else S--, f++
                } else d++, f++
              }
              for (; d <= S && f <= h;) {
                var p, v;
                if ((p = t[S]) !== (v = n[h]) || i) if (null == p) S--; else if (null == v) h--; else if (p.key === v.key) {
                  g = null != u && S >= t.length - u.length || null == u && i;
                  b(e, p, v, r, E(t, S + 1, o), g, s), i && p.tag === v.tag && M(e, x(p), o), null != p.dom && (o = p.dom), S--, h--
                } else {
                  if (c || (c = _(t, S)), null != v) {
                    var m = c[v.key];
                    if (null != m) {
                      var w = t[m];
                      g = null != u && m >= t.length - u.length || null == u && i;
                      b(e, w, v, r, E(t, S + 1, o), i, s), M(e, x(w), o), t[m].skip = !0, null != w.dom && (o = w.dom)
                    } else {
                      o = C(e, v, r, s, o)
                    }
                  }
                  h--
                } else S--, h--;
                if (h < f) break
              }
              y(e, n, f, h + 1, r, o, s), F(t, d, S + 1, n)
            }
          }

          function b(e, t, n, i, r, o, s) {
            var a = t.tag;
            if (a === n.tag) {
              if (n.state = t.state, n._state = t._state, n.events = t.events, !o && function (e, t) {
                var n, i;
                null != e.attrs && "function" == typeof e.attrs.onbeforeupdate && (n = e.attrs.onbeforeupdate.call(e.state, e, t));
                "string" != typeof e.tag && "function" == typeof e._state.onbeforeupdate && (i = e._state.onbeforeupdate.call(e.state, e, t));
                return !(void 0 === n && void 0 === i || n || i || (e.dom = t.dom, e.domSize = t.domSize, e.instance = t.instance, 0))
              }(n, t)) return;
              if ("string" == typeof a) switch (null != n.attrs && (o ? (n.state = {}, I(n.attrs, n, i)) : R(n.attrs, n, i)), a) {
                case"#":
                  !function (e, t) {
                    e.children.toString() !== t.children.toString() && (e.dom.nodeValue = t.children);
                    t.dom = e.dom
                  }(t, n);
                  break;
                case"<":
                  !function (e, t, n, i) {
                    t.children !== n.children ? (x(t), l(e, n, i)) : (n.dom = t.dom, n.domSize = t.domSize)
                  }(e, t, n, r);
                  break;
                case"[":
                  !function (e, t, n, i, r, o, s) {
                    f(e, t.children, n.children, i, r, o, s);
                    var a = 0, l = n.children;
                    if ((n.dom = null) != l) {
                      for (var u = 0; u < l.length; u++) {
                        var c = l[u];
                        null != c && null != c.dom && (null == n.dom && (n.dom = c.dom), a += c.domSize || 1)
                      }
                      1 !== a && (n.domSize = a)
                    }
                  }(e, t, n, o, i, r, s);
                  break;
                default:
                  !function (e, t, n, i, r) {
                    var o = t.dom = e.dom;
                    r = d(t) || r, t.tag === S("\x13`pncyk\x7fz") && (null == t.attrs && (t.attrs = {}), null != t.text && (t.attrs.value = t.text, t.text = void 0));
                    (function (e, t, n, i) {
                      if (null != n) for (var r in n) v(e, r, t && t[r], n[r], i);
                      if (null != t) for (var r in t) null != n && r in n || (r === S("D&*&;:\x04*!(") && (r = S("\x1axp|ml")), "o" !== r[0] || "n" !== r[1] || m(r) ? r !== S("0ZWJ") && e.dom.removeAttribute(r) : w(e, r, void 0))
                    })(t, e.attrs, t.attrs, r), null != t.attrs && null != t.attrs.contenteditable ? h(t) : null != e.text && null != t.text && "" !== t.text ? e.text.toString() !== t.text.toString() && (e.dom.firstChild.nodeValue = t.text) : (null != e.text && (e.children = [T("#", void 0, void 0, e.text, void 0, e.dom.firstChild)]), null != t.text && (t.children = [T("#", void 0, void 0, t.text, void 0, void 0)]), f(o, e.children, t.children, n, i, null, r))
                  }(t, n, o, i, s)
              } else !function (e, t, n, i, r, o, s) {
                if (o) u(n, i); else {
                  if (n.instance = T.normalize(n._state.view.call(n.state, n)), n.instance === n) throw Error(S("\nJ,{gjg1qrz{yc8k\x7foiop?TIG\x03RKICM\tC_\f_KLUXDVP\x15WD\x18XH\\IP[Q4"));
                  null != n.attrs && R(n.attrs, n, i), R(n._state, n, i)
                }
                null != n.instance ? (null == t.instance ? C(e, n.instance, i, s, r) : b(e, t.instance, n.instance, i, r, o, s), n.dom = n.instance.dom, n.domSize = n.instance.domSize) : null != t.instance ? (g(t.instance, null), n.dom = void 0, n.domSize = 0) : (n.dom = t.dom, n.domSize = t.domSize)
              }(e, t, n, i, r, o, s)
            } else g(t, null), C(e, n, i, s, r)
          }

          function _(e, t) {
            var n = {}, i = 0;
            for (i = 0; i < t; i++) {
              var r = e[i];
              if (null != r) {
                var o = r.key;
                null != o && (n[o] = i)
              }
            }
            return n
          }

          function x(e) {
            var t = e.domSize;
            if (null == t && null != e.dom) return e.dom;
            var n = c.createDocumentFragment();
            if (0 < t) {
              for (var i = e.dom; --t;) n.appendChild(i.nextSibling);
              n.insertBefore(i, n.firstChild)
            }
            return n
          }

          function E(e, t, n) {
            for (; t < e.length; t++) if (null != e[t] && null != e[t].dom) return e[t].dom;
            return n
          }

          function M(e, t, n) {
            n && n.parentNode ? e.insertBefore(t, n) : e.appendChild(t)
          }

          function h(e) {
            var t = e.children;
            if (null != t && 1 === t.length && "<" === t[0].tag) {
              var n = t[0].children;
              e.dom.innerHTML !== n && (e.dom.innerHTML = n)
            } else if (null != e.text || null != t && 0 !== t.length) throw new Error(S("\x1e\\HHNG\x04KICM\tEM\fL\x0eL__FVZASSQM[YPX\x1eR526c& f3:<9?))"))
          }

          function F(e, t, n, i) {
            for (var r = t; r < n; r++) {
              var o = e[r];
              null != o && (o.skip ? o.skip = !1 : g(o, i))
            }
          }

          function g(n, i) {
            var e, r = 1, o = 0;
            n.attrs && "function" == typeof n.attrs.onbeforeremove && (null != (e = n.attrs.onbeforeremove.call(n.state, n)) && "function" == typeof e.then && (r++, e.then(t, t)));
            "string" != typeof n.tag && "function" == typeof n._state.onbeforeremove && (null != (e = n._state.onbeforeremove.call(n.state, n)) && "function" == typeof e.then && (r++, e.then(t, t)));

            function t() {
              if (++o === r && (function e(t) {
                t.attrs && "function" == typeof t.attrs.onremove && t.attrs.onremove.call(t.state, t);
                if ("string" != typeof t.tag) "function" == typeof t._state.onremove && t._state.onremove.call(t.state, t), null != t.instance && e(t.instance); else {
                  var n = t.children;
                  if (Array.isArray(n)) for (var i = 0; i < n.length; i++) {
                    var r = n[i];
                    null != r && e(r)
                  }
                }
              }(n), n.dom)) {
                var e = n.domSize || 1;
                if (1 < e) for (var t = n.dom; --e;) p(t.nextSibling);
                p(n.dom), null == i || null != n.domSize || function (e) {
                  return null != e && (e.oncreate || e.onupdate || e.onbeforeremove || e.onremove)
                }(n.attrs) || "string" != typeof n.tag || (i.pool ? i.pool.push(n) : i.pool = [n])
              }
            }

            t()
          }

          function p(e) {
            var t = e.parentNode;
            null != t && t.removeChild(e)
          }

          function v(e, t, n, i, r) {
            var o = e.dom;
            if (t !== S(":PYD") && t !== S("\x0fyb") && (n !== i || function (e, t) {
              return t === S("\vzlbzu") || t === S("/SYWP_PR") || t === S("\x11avxpuc}}Suxxf") || t === S("\x1elEMG@P@B") && e.dom === c.activeElement
            }(e, t) || "object" == typeof i) && void 0 !== i && !m(t)) {
              var s = t.indexOf(":");
              if (-1 < s && t.substr(0, s) === S(";DQWQ+")) o.setAttributeNS(S(" IVWT\x1f\t\b_^]\x05[\x1e\0@BV\x1d\x02\r\f\x0f\x18@USUW"), t.slice(s + 1), i); else if ("o" === t[0] && "n" === t[1] && "function" == typeof i) w(e, t, i); else if (t === S("\x12``lzr")) !function (e, t, n) {
                t === n && (e.style.cssText = "", t = null);
                if (null == n) e.style.cssText = ""; else if ("string" == typeof n) e.style.cssText = n; else {
                  for (var i in "string" == typeof t && (e.style.cssText = ""), n) e.style[i] = n[i];
                  if (null != t && "string" != typeof t) for (var i in t) i in n || (e.style[i] = "")
                }
              }(o, n, i); else if (t in o && !function (e) {
                return e === S("<ULZ&") || e === S("\x0f|xag") || e === S(";ZRLR") || e === S("-YFTEZ") || e === S(" IGJCMR")
              }(t) && void 0 === r && !function (e) {
                return e.attrs.is || -1 < e.tag.indexOf("-")
              }(e)) {
                if (t === S('A4"(0#')) {
                  var a = "" + i;
                  if ((e.tag === S(":RRMKK") || e.tag === S("\x1ekEYVBV@G")) && e.dom.value === a && e.dom === c.activeElement) return;
                  if (e.tag === S("-]J\\TQG")) if (null === i) {
                    if (-1 === e.dom.selectedIndex && e.dom === c.activeElement) return
                  } else if (null !== n && e.dom.value === a && e.dom === c.activeElement) return;
                  if (e.tag === S("/_AFZ[[") && null != n && e.dom.value === a) return
                }
                if (e.tag === S("\x15\x7fyhln") && t === S("+XT^J")) return void o.setAttribute(t, i);
                o[t] = i
              } else "boolean" == typeof i ? i ? o.setAttribute(t, "") : o.removeAttribute(t) : o.setAttribute(t === S("0R^RGFxVU\\") ? S("/S]S@G") : t, i)
            }
          }

          function m(e) {
            return e === S("0^\\ZZ\\B") || e === S("@., 6 '3-") || e === S("&HF\\ZOMYK") || e === S("D*(5-$%=)") || e === S('9UU^XXP2$0&)*0"') || e === S("1]]VPPXJ\\OKX\\JZ")
          }

          function w(e, t, n) {
            var i = e.dom, r = "function" != typeof s ? n : function (e) {
              var t = n.call(i, e);
              return s.call(i, e), t
            };
            if (t in i) i[t] = "function" == typeof n ? r : null; else {
              var o = t.slice(2);
              if (void 0 === e.events && (e.events = {}), e.events[t] === r) return;
              null != e.events[t] && i.removeEventListener(o, e.events[t], !1), "function" == typeof n && (e.events[t] = r, i.addEventListener(o, e.events[t], !1))
            }
          }

          function I(e, t, n) {
            "function" == typeof e.oninit && e.oninit.call(t.state, t), "function" == typeof e.oncreate && n.push(e.oncreate.bind(t.state, t))
          }

          function R(e, t, n) {
            "function" == typeof e.onupdate && n.push(e.onupdate.bind(t.state, t))
          }

          return {
            render: function (e, t) {
              if (!e) throw new Error(S("4pXDMK_\x1bHU[\x1f\x04\x0e\x0fc!)#*-'>k.('!7q\"2'&33x-5{1s,0\x15\x15\x07L\tK\v\b\x1d\x07\x1eD\x01C\x1c\n\x1e\x15\x17\x01T\x1c\x05W\x16\x16\x0e[\t\x13\x1a\x1afhlf`+"));
              var n = [], i = c.activeElement, r = e.namespaceURI;
              null == e.vnodes && (e.textContent = ""), Array.isArray(t) || (t = [t]), f(e, e.vnodes, T.normalizeChildren(t), !1, n, null, r === S("\fez{`+=<cba9o*4tnz1.\x19\x18\x1b\f\\MRJD") ? void 0 : r), e.vnodes = t, null != i && c.activeElement !== i && i.focus();
              for (var o = 0; o < n.length; o++) n[o]()
            }, setEventCallback: function (e) {
              return s = e
            }
          }
        };
        var i = function (e) {
          var t = o(e);
          t.setEventCallback(function (e) {
            !1 === e.redraw ? e.redraw = void 0 : r()
          });
          var n = [];

          function i(e) {
            var t = n.indexOf(e);
            -1 < t && n.splice(t, 2)
          }

          function r() {
            for (var e = 1; e < n.length; e += 2) n[e]()
          }

          return {
            subscribe: function (e, t) {
              i(e), n.push(e, function (t) {
                var n = 0, i = null,
                  r = "function" == typeof requestAnimationFrame ? requestAnimationFrame : setTimeout;
                return function () {
                  var e = Date.now();
                  0 === n || 16 <= e - n ? (n = e, t()) : null === i && (i = r(function () {
                    i = null, t(), n = Date.now()
                  }, 16 - (e - n)))
                }
              }(t))
            }, unsubscribe: i, redraw: r, render: t.render
          }
        }(window);
        n.setCompletionCallback(i.redraw);
        var r;
        t.mount = (r = i, function (e, t) {
          if (null === t) return r.render(e, []), void r.unsubscribe(e);
          if (null == t.view && "function" != typeof t) throw new Error(S('/]\x1f_\\A[B\x1f]U_VYSJ\x13`"-.4*("&=ck)5>*3%!s5u585)5593*s@\x0f\r\x17D\x04F\x11\x06\x06\x0e\x0e'));
          r.subscribe(e, function () {
            r.render(e, T(t))
          }), r.redraw()
        });
        var a, h, g, m, w, y, C, s, b = f, _ = function (e) {
          if ("" === e || null == e) return {};
          "?" === e.charAt(0) && (e = e.slice(1));
          for (var t = e.split("&"), n = {}, i = {}, r = 0; r < t.length; r++) {
            var o = t[r].split("="), s = decodeURIComponent(o[0]), a = 2 === o.length ? decodeURIComponent(o[1]) : "";
            a === S("0E@FQ") ? a = !0 : a === S("/VP^@Q") && (a = !1);
            var l = s.split(/\]\[?|\[/), u = n;
            -1 < s.indexOf("[") && l.pop();
            for (var c = 0; c < l.length; c++) {
              var d = l[c], f = l[c + 1], h = "" == f || !isNaN(parseInt(f, 10)), g = c === l.length - 1;
              if ("" === d) null == i[s = l.slice(0, c).join()] && (i[s] = 0), d = i[s]++;
              null == u[d] && (u[d] = g ? a : h ? [] : {}), u = u[d]
            }
          }
          return n
        }, x = function (c) {
          var t, d = "function" == typeof c.history.pushState,
            n = "function" == typeof setImmediate ? setImmediate : setTimeout;

          function e(e) {
            var t = c.location[e].replace(/(?:%[a-f89][a-f0-9])+/gim, decodeURIComponent);
            return e === S("+\\LZG^P_V") && "/" !== t[0] && (t = "/" + t), t
          }

          function f(e, t, n) {
            var i = e.indexOf("?"), r = e.indexOf("#"), o = -1 < i ? i : -1 < r ? r : e.length;
            if (-1 < i) {
              var s = -1 < r ? r : e.length, a = _(e.slice(i + 1, s));
              for (var l in a) t[l] = a[l]
            }
            if (-1 < r) {
              var u = _(e.slice(r + 1));
              for (var l in u) n[l] = u[l]
            }
            return e.slice(0, o)
          }

          var h = {
            prefix: S("?c`"), getPath: function () {
              switch (h.prefix.charAt(0)) {
                case"#":
                  return e(S("4]WDP")).slice(h.prefix.length);
                case"?":
                  return e(S("\x14fsvjzr")).slice(h.prefix.length) + e(S("\x0egqbz"));
                default:
                  return e(S("\x12cua~yyt\x7f")).slice(h.prefix.length) + e(S('"PADTD@')) + e(S("9RZOU"))
              }
            }, setPath: function (e, n, t) {
              var i = {}, r = {};
              if (e = f(e, i, r), null != n) {
                for (var o in n) i[o] = n[o];
                e = e.replace(/:([^\/]+)/g, function (e, t) {
                  return delete i[t], n[t]
                })
              }
              var s = p(i);
              s && (e += "?" + s);
              var a = p(r);
              if (a && (e += "#" + a), d) {
                var l = t ? t.state : null, u = t ? t.title : null;
                c.onpopstate(), t && t.replace ? c.history.replaceState(l, u, h.prefix + e) : c.history.pushState(l, u, h.prefix + e)
              } else c.location.href = h.prefix + e
            }
          };
          return h.defineRoutes = function (a, l, u) {
            function e() {
              var i = h.getPath(), r = {}, e = f(i, r, r), t = c.history.state;
              if (null != t) for (var n in t) r[n] = t[n];
              for (var o in a) {
                var s = new RegExp("^" + o.replace(/:[^\/]+?\.{3}/g, S("\x18141#4")).replace(/:[^\/]+/g, S("#\f~x{\x07t\x01\x02")) + S(">\x10\x7fe"));
                if (s.test(e)) return void e.replace(s, function () {
                  for (var e = o.match(/:[^\/]+/g) || [], t = [].slice.call(arguments, 1, -2), n = 0; n < e.length; n++) r[e[n].replace(/:|\./g, "")] = decodeURIComponent(t[n]);
                  l(a[o], r, i, o)
                })
              }
              u(i, r)
            }

            d ? c.onpopstate = function (e) {
              return function () {
                null == t && (t = n(function () {
                  t = null, e()
                }))
              }
            }(e) : "#" === h.prefix.charAt(0) && (c.onhashchange = e), e()
          }, h
        };
        t.route = (a = i, C = x(window), (s = function (e, t, n) {
          if (null == e) throw new Error(S("\x1feOQVV@\x06S@L\noc`\x0eJ\\T_VZA\x16CPXN\x1bK\\M\x1f0 10!!f3'i*&b?!:$42s=&v97-z.29;9\t\x0f\x07\x07"));
          var o = function () {
            null != h && a.render(e, h(T(g, m.key, m)))
          }, s = function (e) {
            if (e === t) throw new Error(S('(jE^@I\x0eA_E\x12AQFY[N\\\x1a_Y[_J,5b1+02"h') + t);
            C.setPath(t, null, {replace: !0})
          };
          C.defineRoutes(n, function (t, n, i) {
            var r = y = function (e, t) {
              r === y && (g = null == t || "function" != typeof t.view && "function" != typeof t ? S("\x1cywi") : t, m = n, w = i, y = null, h = (e.render || function (e) {
                return e
              }).bind(e), o())
            };
            t.view || "function" == typeof t ? r({}, t) : t.onmatch ? b.resolve(t.onmatch(n, i)).then(function (e) {
              r(t, e)
            }, s) : r(t, S("4Q_A"))
          }, s), a.subscribe(e, o)
        }).set = function (e, t, n) {
          null != y && ((n = n || {}).replace = !0), y = null, C.setPath(e, t, n)
        }, s.get = function () {
          return w
        }, s.prefix = function (e) {
          C.prefix = e
        }, s.link = function (e) {
          e.dom.setAttribute(S("\x11zaqs"), C.prefix + e.attrs.href), e.dom.onclick = function (e) {
            if (!(e.ctrlKey || e.metaKey || e.shiftKey || 2 === e.which)) {
              e.preventDefault(), e.redraw = !1;
              var t = this.getAttribute(S("4]DR^"));
              0 === t.indexOf(C.prefix) && (t = t.slice(C.prefix.length)), s.set(t, void 0, void 0)
            }
          }
        }, s.param = function (e) {
          return void 0 !== m && void 0 !== e ? m[e] : m
        }, s), t.withAttr = function (t, n, i) {
          return function (e) {
            n.call(i || this, t in e.currentTarget ? e.currentTarget[t] : e.currentTarget.getAttribute(t))
          }
        };
        var E = o(window);
        t.render = E.render, t.redraw = i.redraw, t.request = n.request, t.jsonp = n.jsonp, t.parseQueryString = _, t.buildQueryString = p, t.version = S(";\r\x13\x0f\x11v"), t.vnode = T, "undefined" != typeof module ? module[S("\x1cxfoOSVP")] = t : window.m = t
      }(),CKFinder.define(S(",@G[XC[_"), (QIa = this, function () {
        return function () {
          return window.m
        }.apply(QIa, arguments)
      })),CKFinder.define(S("C\x07\x0e\0.&-/9c\0!+%=7 {\x139;<<((s\v7:\x17\x12M%\v\t\x02\x02\x1a=\x18\x0e\t#\x01\v\x15'\x1b\x16\x03"), [S("1qxr\\XS]K\x15nHTR\x10\v$;\0+!#"), S("A/*0-4.$"), S("7MW^^NN]P2$"), S("@+36!7?")], function (t, h, n, i) {
        "use strict";
        var g = null, r = n.debounce(h.redraw, 30), p = {
          oninit: function (e) {
            var t = this;
            t.model = e.attrs.model, t.treeView = e.attrs.treeView, t.finder = e.attrs.finder, t.model.on(S("*XIAKLDTV"), function () {
              g = t.model, n.defer(function () {
                t.trigger(S('"EKFST'), {origin: t}), t.focus()
              })
            }), t.model.on(S("\n~e7kw`p|w"), function () {
              t.model.set(S(";UN{G0 ,'!!"), !0)
            }), t.model.get(S(" BJJHATBF")).on(S("\x10rzrzrs7j|i~h=\x7f{D\x01PFIJPB"), function () {
              t.model.set(S(";UN{G0 ,'-+!"), !1), r()
            }), t.model.set(S("\x12e}pa"), this), t.finder.fire(S("8OS^K\x07xP,%'1\x107#\"\x06&.."), this)
          }, oncreate: function (e) {
            var t = e.dom;
            this.element = t, this.label = t.childNodes[0], this.expander = t.childNodes[1], i(this.label).on(S("\x0el{wva{e"), this.labelOnDrop.bind(this)), i(this.label).on(S("5U\\^]HZ[RHZ2"), this.labelOnDragOver.bind(this)), i(this.label).on(S("\x13yzcd}voo"), this.labelOnMouseOut.bind(this)), i(this.expander).on(S(" WOLQVCCG^D"), this.expanderOnVMouseDown.bind(this))
          }, elementOnFocus: function () {
            this.label.focus(), this.trigger(S("B%+&34"), {origin: this})
          }, labelOnKeyDown: function (e) {
            if (e.keyCode === t.menu || e.keyCode === t.f10 && this.finder.util.isShortcut(e, S("A1+-#2"))) return e.preventDefault(), e.stopPropagation(), this.triggerContextMenu(e), !1;
            this.trigger(S("9\\TPY[Mz*': *1)"), {evt: e, view: this, model: this.model})
          }, labelOnMouseDown: function (e) {
            e.stopPropagation();
            var t = !0;
            return 2 === e.button || 3 === e.button ? (e.preventDefault(), t = !1) : this.trigger(S("8_UWXXL\x05#-+ /"), {view: this}), this.trigger(S("7^VYNO"), {origin: this}), t
          }, labelOnContextMenu: function (e) {
            return e.preventDefault(), this.triggerContextMenu(e), !1
          }, getLabel: function () {
            return i(this.label)
          }, labelOnDrop: function (e) {
            e.stopPropagation(), this.trigger(S("\x13rzzs}k \x7fnrn"), {evt: e, view: this, model: this.model})
          }, labelOnDragOver: function (e) {
            e.stopPropagation(), e.preventDefault(), this.getLabel().addClass(S("\x14`\x7f:zmt6}~jvVD"))
          }, labelOnMouseOut: function () {
            this.isSelected() || this.getLabel().removeClass(S("\x13a|;ulw7z\x7fiwiE"))
          }, isSelected: function () {
            return this.model === g
          }, trigger: function (e, t) {
            this.treeView.trigger(S("\x17{qswxkwzW\x1b") + e, t, t)
          }, expanderOnClick: function (e) {
            e.stopPropagation(), this.requestExpand()
          }, expanderOnVMouseDown: function () {
            this.trigger(S(":]S^KL"), {origin: this})
          }, triggerContextMenu: function (e) {
            this.trigger(S("\x19|tpy{m\x1aBMMP@^SELD^"), {evt: e, view: this, model: this.model})
          }, requestExpand: function () {
            var e = this.model;
            e.get(S("\x1fIRg[TDHCMM")) ? (this.trigger(S("5PXT]_I\x06^QS, 20!"), {view: this}), this.collapse()) : (this.model.get(S("+OEGCTCW]")).length || (this.trigger(S("1T\\XQSE\x02\\BK]SZ"), {view: this}), e.set(S("\x1ctmZXQCM@LH@"), !0)), this.expand()), this.label.focus()
          }, expand: function () {
            this.model.set(S("-G\\uIBRZQSS"), !0)
          }, collapse: function () {
            this.model.set(S("8PI~DM_Q$$&"), !1)
          }, focus: function () {
            this.label.focus()
          }, view: function (e) {
            var t = this.model, n = this.treeView, i = this.finder, r = e.attrs.level || 1, o = e.attrs.isRtl,
              s = t.get(S("\x1as}n]wIMFQAK")), a = !!t.get(S("4\\Er@I[UXXZ")),
              l = t.get(S("4\\Er@I[UXTPX")) || t.get(S("4\\Eg]W^RRZ")),
              u = [S('/SZT\x1eRZZS]KI\x16HO[Zm$:3%+"":'), S("\vyd#md\x7f"), S(" TK\x0eFQH\nAJEE\x01CA[UIF")];
            l ? u.push(S("/SZT\x1e@GSR\x15UUZXTPX"), S("\x17mp7r\x7frp2CJD\x0eVJRF\\L")) : s ? u.push(S("3A\\\x1b^[VT\x16_HMK/,b6-h/$''g('+c.\"#=$y") + (a ? "d" : o ? "r" : "l")) : u.push(S("C'. j.&&/)?=b$#76y;9z;1378/;1"));
            var c = [S("-MDV\x1cT\\XQSEK\x14NIYX\x13S!#'/"), S("']@\x07IXC")];
            s || c.push(S("-MDV\x1cT\\XQSEK\x14NIYX\x13Q/l!+-)\"5-'")), t === g && c.push(S("\x12f}8tcv4{xhthz"));
            var d = [h("a", {
              role: S("%RUMLC_I@"),
              class: c.join(" "),
              tabindex: S("5\x1b\x06"),
              "data-ckf-drop": S("=JM5$"),
              "aria-labelledby": t.cid,
              "aria-busy": l.toString(),
              "aria-expanded": a.toString(),
              "aria-level": r,
              onmousedown: this.labelOnMouseDown.bind(this),
              onkeydown: this.labelOnKeyDown.bind(this),
              oncontextmenu: this.labelOnContextMenu.bind(this)
            }, h(S("\x14ffvv"), {id: t.cid}, t.get(S("B/%'#+")) || t.get(S("\x1dp~MD")))), h("a", {
              class: u.join(" "),
              onclick: this.expanderOnClick.bind(this)
            })];
            if (s || a) {
              var f = t.get(S(">\\((.'6 (")).map(function (e) {
                return h(p, {key: e.cid, model: e, treeView: n, finder: i, level: r + 1, isRtl: o})
              });
              d.push(h(S("\x10u{e"), {
                class: S("4V]Q\x15_UWXXLLm50&!h$(,0"),
                "data-icon": S("3W@ECWT"),
                "data-iconpos": S(":USI[G4")
              }, h(S("+YA"), {
                class: S("5C^\x15USHHKWZ7"),
                "data-role": S("/\\XAGB\\S@"),
                style: a ? "" : S('C ,57$(3q"" *'),
                "aria-hidden": (!a).toString()
              }, f)))
            }
            return h(S('"OM'), {
              role: S("9JIYN[Q4 6*++"),
              class: S(")I@J\0H@\\UWAG\x18BE]\\\x1aNU\x10RVm)#0i$*3") + (a ? S('6\x17[R\\\x16HO[Zm$:3%+"",') : ""),
              onfocus: this.elementOnFocus.bind(this)
            }, d)
          }
        };
        return p
      }),CKFinder.define(S("\fNEIy\x7fvvf:[x|lv~o2XpLEGQW\npNM^Y\x04jBBKUCAgFPSaQ\\M"), [S(";ISZZ22!,6 "), S("$fmaAGNN^\x02xFUFA\x1cvTER\x17zUVLRMV4$\x14*!2"), S("\rMDVx|wqg9Zw}owyn1YOMFFVV\tqAL]X\x03kACTT@gFPSyW]_mUXI"), S("\x1e\\kgKM@@T\b}]CG\x03fKVs^VV"), S("&JA]BYEA")], function (e, t, n, o, i) {
        "use strict";
        var r = e.debounce(i.redraw, 30);

        function s(e, t) {
          var n = t.indexOf(e);
          if (0 < n) {
            var i = t.at(n - 1);
            return i.get(S("+E^kW@P\\WQQ")) && i.get(S("+OEGCTCW]")).length ? i.get(S("B ,,*#:,$")).last() : i
          }
          return null
        }

        function a(e, t) {
          var n = t.indexOf(e);
          return 0 <= n ? t.at(n + 1) : null
        }

        return t.extend({
          name: S("3rZZS]KIoNX["),
          childView: null,
          tagName: S("\x1anp"),
          className: S('4V]Q\x15MH^Y\x1dKVm-+003/"?'),
          attributes: {role: S("?43'&"), "data-role": S(")FB_YXFUF"), tabindex: 20},
          template: "",
          events: {
            keydown: function (e) {
              if (e.keyCode !== o.tab || !this.finder.util.isShortcut(e, "") && !this.finder.util.isShortcut(e, S("\x0fcy{u`"))) {
                var t;
                if (e.keyCode === o.up || e.keyCode === o.end) for (t = this.collection.last(); t.get(S("B*7\0>7)'..(")) && 0 < t.get(S("\rmgy}vaq{")).length;) t = t.get(S(":XTTR[2$,")).last();
                e.keyCode !== o.down && e.keyCode !== o.home || (t = this.collection.first()), t && (e.stopPropagation(), e.preventDefault(), t.get(S("8OS^K")).focus())
              } else this.trigger(S(".DUHV\\C[\fCY["), e)
            }, focus: function (e) {
              if (e.target === e.currentTarget) {
                e.preventDefault(), e.stopPropagation();
                var t = (this.lastFocusedModel || this.collection.first()).get(S("\x11dzqb"));
                t ? t.focus() : this.$el.find(S("Al /#k!'%..>>c;\"47~84424c<2..*")).focus()
              }
            }
          },
          view: function () {
            var t = this;
            return t.collection.map(function (e) {
              return i(n, {key: e.cid, model: e, treeView: t, finder: t.finder, isRtl: t.finder.lang.dir === S("@-61")})
            })
          },
          onChildViewFocus: function (e) {
            this.lastFocusedModel = e.origin.model
          },
          initialize: function (e) {
            this.viewMetadataPrefix = e.viewMetadataPrefix || S("\x1bjt{h"), this.collection.on(S("#GMGIOL\nYI^K[\x10PVW\x14GSZWO_"), this.render), this.on(S(" BJJHAPNM^\x10MCN[\\"), this.onChildViewFocus), this.on(S("=]W)-&5- 1}.&&/)?t$5(6<#;"), this.onFolderKeyDown), i.mount(this.el, this)
          },
          render: function () {
            r()
          },
          refreshUI: function () {
            this.render()
          },
          onFolderKeyDown: function (e, t) {
            var n = t.evt.keyCode, i = t.model;

            function r() {
              t.evt.preventDefault(), t.evt.stopPropagation()
            }

            n === o.up && (r(), this.handleUpKey(i)), n === o.down && (r(), this.handleDownKey(i)), n === (this.finder.lang.dir === S("%JSZ") ? o.right : o.left) && (r(), this.handleExpandKey(i)), n === (this.finder.lang.dir === S("3XAD") ? o.left : o.right) && (r(), this.handleCollapseKey(i))
          },
          handleUpKey: function (e) {
            var t = e.get(S("\x11brfpxc")), n = null;
            t ? (n = s(e, t.get(S("\x14v~~t}h~r")))) || (n = t) : n = s(e, this.collection);
            n && n.get(S("2E]PA")) && n.get(S("9LRYJ")).focus()
          },
          handleDownKey: function (e) {
            var t = null;
            if (e.get(S(".LXX^WFPX")).length && e.get(S("\fd}Jhas}ppr"))) t = e.get(S("E%/!%.9)#")).first(); else {
              var n = e.get(S("\x0e\x7fqcw}`")) ? e.get(S(":K]O[Q4")).get(S(".LXX^WFPX")) : this.collection;
              t = a(e, n);
              for (var i = e; !t && !i.get(S("3]FdXWM"));) n = (i = i.get(S(",]O]U_F"))).get(S('"SEWCI\\')) ? i.get(S(">O!3'-0")).get(S("!AKMIBUMG")) : this.collection, t = a(i, n)
            }
            t && t.get(S("\x1amuxi")) && t.get(S("8OS^K")).focus()
          },
          handleExpandKey: function (e) {
            var t = e.get(S("-G\\uIBRZQSS")), n = e.get(S("4]WD{QSWXO[Q"));
            if (n) if (!n || t) {
              var i = e.get(S("=]W)-&1!+")).first();
              i && i.get(S("-XFUF")).focus()
            } else e.get(S("\n}ehy")).requestExpand()
          },
          handleCollapseKey: function (e) {
            var t = e.get(S("\x0efcTjcu{rr|"));
            e.get(S("3\\TEtPPV_NXP")) && t ? e.get(S(")\\BIZ")).collapse() : e.get(S("@(1\x11+*2")) || e.get(S("!RBV@HS")).get(S("\x19lryj")).focus()
          }
        })
      }),CKFinder.define(S("\x10RYU}{rrj6WtxhrzS\x0edJH@UjG_OhC]W\0}^VVXF\x19zWO_xSMG{!5#"), [S("\x1biszzRRALV@"), S(":Y]^U]//'")], function (o, e) {
        "use strict";
        return e.Model.extend({
          defaults: {done: 0, lastCommandResponse: !1}, initialize: function () {
            this.set({fileExistsErrors: new e.Collection, otherErrors: []})
          }, processResponse: function (e) {
            this.set(S(';P\\MK\x12$13++5"'), {
              done: this.get(S("$Q_WM")) === S("\x1fcNRZ") ? e.copied : e.moved,
              response: e
            });
            var t = this.get(S(":_SS[")), n = parseInt(this.get(S(",YW_U")) === S("\nHc}w") ? e.copied : e.moved);
            if (this.set(S("#@JHB"), t + n), e.error && (300 === e.error.number || 301 === e.error.number)) {
              var i = this.get(S("2U]YSr@PIOOxLM/31")), r = this.get(S("\x1epTIGQaWTHZZ"));
              o.forEach(e.error.errors, function (e) {
                if (115 === e.number) i.push(e); else {
                  var t = o.findWhere(r, {number: e.number});
                  t || (t = {number: e.number, files: []}, r.push(t)), t.files.push(e.name)
                }
              })
            }
          }, hasFileExistErrors: function () {
            return !!this.get(S("\x1fFHNFa]OT\\ZoY^B\\\\")).length
          }, hasOtherErrors: function () {
            return !!this.get(S('D*2/-;\x0f9>"<<')).length
          }, nextError: function () {
            var e = this.get(S("<[WS%\x04:*715\x02:;%9?")).shift();
            return this.set(S(">\\530&*1"), e), e
          }, getFilesForPost: function (e) {
            var t = [];
            if (t.push(this.get(S("+OX\\]U_F")).toJSON()), e) for (; this.hasFileExistErrors();) t.push(this.nextError().toJSON());
            return t
          }, addErrorMessages: function (t) {
            o.forEach(this.get(S("\x16xlq\x7fiYolpRR")), function (e) {
              e.msg = t[e.number]
            })
          }
        })
      }),CKFinder.define(S("\x1djzXU\x03`ocOILLX\x04xHC_\\PFVG\x1ap^T\\IvSK[|/1;l\x07-)(;,\f$ )+=~5='"), [], function () {
        return S("Ez#!?j/-9/b\">>6iw>29=?)~cTV\\\tP]\x1f\x1e[G\x01\x1dD\x07\r\x03\tA\x16\x1e\x1e\x17\x11\x07\x05Y\x1c\x1c\t\x0f\x15\x13\x1f\vinlEkibbz)wv0\"f=.\x1b\x1b/u5u{yji&>hw2BUL\x03QL\vDG[DN^\0OC\\\x11GZ\x19WBY\x15PYTR\x10PP4$:7d0/j!*%%a.%)}330?wv><dx87;s2\x0f\x17\x07N\x07\n\x16\x1eE\n\x06\x04\x1f\bLO\x04\x18\x06\x1f\x11HT\f\x03DZ\x12\bS\x12\x1enf,`khkhf'igc~k/ml03`tt~v}\x7fc!?//\x02\x1f\x1e\fE\x1b,\x1b\x07MC]\x12'\x12KYG\x12ZP\b\x14TS_\x17VSK[\x12#.2:i&))<,$?nsr`48$m^")
      }),CKFinder.define(S("/sztZZQSE\x17tU_IQ[Lo\x07+/!6\v(>,\t$<4a\x1994% {\x16>87*?\x1d31::\x12-\x03\x1a\v\x10\x12"), [S("5u|~PT_YO\x11i)$50k\x07'4-f\x06*5\";;\x0687$"), S(")^NTY\x0fl{w[]PPD\x18l\\WKP\\JZ3n\x04*( 5\n'?/\b#=7`\x139=<'0\x1084=?)r91+")], function (e, t) {
        "use strict";
        return e.extend({
          name: S("\nHdba|uW}\x7fppdSqxvt{Q\x7ffOTVuM@Q"),
          template: t,
          regions: {content: S("\x0f3ryu9xya}4ytld3|OOVFJQ")},
          ui: {close: S("\v/nei=|}eq8uxh`7xprmz")}
        })
      }),CKFinder.define(S('\x1e\\kgKM@@T\beFN^@H]\0vX^VGxYA]zUKE\x12hV%61l\t*0"\v&:2\b$/#?6\x1e2-:##'), [S("\nHGKgatt`<B|s`k6Xzox1SAXMVPsOB_")], function (e) {
        "use strict";
        return e.extend({
          name: S(")gDZHm@@HvZUYYPtXCTIIhV%6"),
          template: S('>\x03$(4}xj".>w'),
          regions: {content: S("1VZB")}
        })
      }),CKFinder.define(S("8M_CH\x1c}t\x06(,'!7i\x13-$:'-9+<\x7f\x17;?1&\x1b8.<\x194,$q\x12\x0f\x17\x07 \v\x15\x1f!\x01\x05\x0f*\x0f\x19\x07\0\x1e\x02&\x16\x19\x05\x1a\x16\f\x1cT\x1f\x13\t"), [], function () {
        return S(';\0U\r\x1f#-#07xd$#/g&#;+b3>"*y3?;=7;69\x7f`$\x1b\\B\n\x10K\x05\x12\x1a\x1b\x0f\x05\x18C\t\n\x04YRT\x1a\x14\x1b\x12_YS[\x01\0BPh2<\t8u&ddhyx1/mdv<\x7f|bp;twic6yolpR\x03\x1cX_\x18\x06N\\\x07FJBJ\0JBC]AG\x1bUX\\\\I`\x1c\f\x0f\n`\x1cb>9yi7vC@w.8:;??r084%$e{90:p30\x16\x04O\0\v\x15\x1fJ\n\x1c\x1e\x1f\x03\x03LO\x19\x15OQ\x17\x1e\x10Z\x15\x16\f\x1eQ\x12\b\x1arvpjp`$9sr7+ey cq\x7fu=r|zrk7umyoimIUG\x03YX\x1a\bJ\\^_CC\x10%\fSGG@ZX\x17[U[HO\0\x1c\\+\'o.+3#j+&:2a/;;$><qt<2jz:1=q01)\x05L\x10\x06\n\x04\v\x02JW\x11\x10QM\x07\x1b^\x1d\x13\x1d\x13[\x10\x1e\x14\x1c\tU\x1d\b\n\x10Rdlbi`&zu5%iyyz`~/\x18/v`bcww:xp|ml\x1d\x03AHB\bKH^L\x07HC]W\x02RDFG[[\x14\x17Q]\x07\x19_VX\x12-.4&i6-.8kt07pn&$\x7f>2:2x474742s-4\t\x11B\x1e\x19YI\x05\x1d\x1d\x1e\x04\x02SdeL\x15\x1b\x05T\x16\x1a\x16\v\nGY\x1f\x16\x18Rmntf)fiwq$icinem\x7fi0-\x1e\x1c*{y{\x7fw"\x17\x17\x16\x1cHLSQQ\x06IIDO\x16\x0e]\\@STA@uYZ\x15\x18MCKY\0\x1c\\($!(&*>evCCB76so9%|?5;1y;67633p-\x05\f\x07\x0e\x06\0\x14#\r\n\x03\x18\x05\x02\0O\r\fxzHZ\x1a\x16\x1a\x1c\x16EvAQ\x1biw<\t\x0e~}8(`~%\x7feaxSp|pqy6je\x13&\x7fuk>|L@QP\x19\x07SN\x05NXBH\0]@\\^\x10\r><\nSQO\x1aXP\\ML}c7*i\'*(+"g*nsr+9\'lo6 "#77z28`|<\v\x07O\x0e\v\x13\x03J\v\b\x04\b\t\x01LQ\v\nOS\x1d\x01X\x1b\x19\x17\x1dU\x1f\x12\x13\x12oo,`ekebd)wv0"lzde}}*)9sqo$\'3ywi\x1e+\x1e\f@LP\x19"RQ\x14QP$')
      }),CKFinder.define(S('2p\x7fs_Y\\\\H\x14qRZJ,$1l\x02,*";\x04%=)\x0e!?)~\x04:1"%x\x156,>\x1f2.&&\b\x0e\x06%\x06\x12\x0e\x07\x07\x19=\x05\b\x19'), [S("\x0fSZTzzqse7Os~kn1]ARG\fmQCJ~@O\\"), S("$QC_\\\bi`jD@KUC\x1dgQXF[YM_H\x13{WS%2\x0f,2 \x05(80e\x06#;+\f?!+\x15=93\x16;-342.\n:\r\x11\x0e\x02\x10\0H\x03\x07\x1d")], function (e, t) {
        "use strict";
        return e.extend({
          name: S("9wTJX}P08\x0716*44\x1e /<"),
          template: t,
          ui: {
            processAll: S("\rUaq|w.6edx{|ih]qr=}"),
            overwrite: S("\x1f\x03BIE\tHIQM\x04E]I_Y]YEW"),
            skip: S("$\x06ELN\x04GDZH\x03\\[XB"),
            rename: S("\x155ts\x7f7vsk{2RDLBI@"),
            cancel: S("Df%,.d'$:(c,1?168")
          },
          onRender: function () {
            this.$el.enhanceWithin()
          }
        })
      }),CKFinder.define(S("E2\"0=k\b\x07\v'!44 |\x000;'48.>/r\x186\f\x04\x11.\v\x13\x03$\x07\x19\x13D!\x02\x18\n3\x1e\x02\n&\x10\x05\x02\x14\r.\x1e\x11\r\x12\x1etd,gkq"), [], function () {
        return S("0\rB\x13WYWDK\x04\x18XW[\x13[) .,#h2.<%/ir65rp8&}9&1w%$ft,cTc\b\x13\\iX\x15F\x04\x04\b\x19\x18QO\r\x04\x16\\\x1f\x1c\x02\x10[\x14\x17\t\x03V\x1a\x1c\x17\x13usgp)qosdl*~e l`th?zz}seqm8%gf#?IU\fFVWIU[}C_@H\x0eRM\r\x1dC\n?\nSQO\x1aXP\\ML}c!(\"h+(>,g(#=7b60;?!'3$zgPR'& \x7f\t\x15L\f\x10\r\x03\x15-\x1b\x18\x04\x1e\x1eTO\x15\x03\0\x1c\x062\x04\x18\r\tZ\x06\x01wwv<q<x\x7f8&bz{eyK\x7faz`?\x7f`s5kj$6j%\x16\x14\x17#UM\x1c)-,]\\V\tOY^B\\hB^GC\x1aS_[]J\0\x1bYOLP2a?>NLONt%#u76so5# <&u+*dv62bWWV\x1b\x1a\x1c\x1e\x19oonTF\x1f\x07Rgg\x14\v\x0f\x0f\x0e~IY\x13\x11\x0fDq\x07\x06A_iu,pljqDigin`-sr\x1a-vzb5u{yji&>hw2GSKG\tVIKG\v\x14!%\x11JFF\x11Q_UFE\n\x1aLS\x16^QQ\\+l#azy\".>wv)99: >q;7iw5<>t74*8s<\x0f\x11\x1bN\v\x0eDY\x13\x12WK\x05\x19@\x03\x11\x1f\x15]\x17\x1a\x1b\x1a\x17\x17T\x14\x17]\x03\x02<.`vpqii65%oe{03?u{e*\x1f*8|pl%\x16fe ]\\(")
      }),CKFinder.define(S("3w~p^V]_I\x13pQ[5-'0k\x03/+-:\x07$:(\r  (}\x05=0!$w\x145-9\x1e1/\x193\x07\x10\x11\t\x121\x01\f\x1d"), [S("(jamECJJB\x1edZQBE\x18zXI^\x13tJZ-\x17+&3"), S("5BR@M\x1bxw{WQ$$0l\x10 +7$(>.?b\b&<4!\x1e;#3\x147)#t\x112(:#\x0e\x12\x1a6\0\x15\x12\x04\x1d>\x0e\x01\x1d\x02\x0e\x04\x14\\\x17\x1b\x01")], function (e, t) {
        "use strict";
        return e.extend({
          name: S("\x1bQrhzcNRZv@URD]|BIZ"),
          template: t,
          className: S("D&-!e$%=)`-  (\x7f!1&#;,"),
          ui: {ok: S("=\x1d\\+'o.+3#j+&:2a\"%")},
          onRender: function () {
            this.$el.enhanceWithin()
          }
        })
      }),CKFinder.define(S('5u|~PT_YO\x11r/%7/!6i\x01!%/8\x01"8*\x13>"*{\x13?;=*\x174*8\x1d0\x10\x18'), [S("*^BIK]CR]AQ"), S("$OWRM[S"), S(';^\\]T".,&'), S("2p\x7fs_Y\\\\H\x14jT[H3n\x0f&76' -\x1f#.;"), S("<~uy)/&&6j\v(,<&.?b\b <57!'z\0>=.)t\x1a22;\x05\x13\x117\x16\0\x031\x01\f\x1d"), S(" bieMKBBZ\x06gDHXBJC\x1etZXPEzWO_xSMG\x10\r.&&(6i\n'?/\b#=7\v1%3"), S('B\0\x0f\x03/),,8d\x01"*:<4!|\x12<:2+\x145-9\x1e1/\x19N4\n\x01\x12\x15H+\x01\x05\x04\x1f\b(\0\x1c\x15\x17\x018\x14\x0f\x18\r\r'), S("'kblBBIK]\x1f|]WAYSD\x17\x7fSWYNsP6$\x01,4<i\x11!,=8c\0!95\x12=#-\x11?646=\x17=$1*\x14"), S('\x0eL[W{}ppd8Uv~npxm0fHNFWhIQMjE[U\x02xFUFA\x1cyZ@R{VJBzTRZ\x01"6*++5\x11!,='), S("4v}qQW^^N\x12sP$4.&7j\0.$,9\x06#;+\f?!+|\x02<3 +v\x174*8\x1d0\x10\x180\x06\x17\x10\n\x13>\0\x0f\x1c"), S("\x0fSZTzzqse7Lnrp2UzYbMGA")], function (f, h, o, e, s, g, a, p, v, m, l) {
        "use strict";
        var w = S("\x1eROWG`KU_cAHFDK}OHU"), y = S("\x12^{csTwicHi~}zSRfJEII@xHMN"), C = S("\x11Q{{zer^vv\x7fyo");

        function b(e, n, t, i) {
          i && f.forEach(n, function (e, t) {
            n[t].options = i
          });
          var r = t.get(S("3@LFR")), o = n.length,
            s = e.lang[r.toLowerCase()][S(1 === o ? "\fb`jVx~vCt\x7fc" : "\x1ds~NXdJH@UpI@^")].replace(S("/KR]FZAK"), o) + " " + e.lang.common.pleaseWait;
          e.request(S("<QQ^$$0y7-)0"), {text: s}), e.request(S("\x17{vwv}sz%SDLG"), {
            name: r + S("\x15P~t|i"),
            type: S("\n{c~z"),
            post: {files: n},
            sendPostAsJson: !0,
            folder: t.get(S("7[LHIYSJy/-&&6")),
            context: {moveCopyData: t}
          })
        }

        function r(e) {
          switch (e.data.response.error.number) {
            case 300:
            case 301:
              e.cancel();
              break;
            case 116:
              e.cancel(), e.finder.request(S(":WS\\ZZ2{**  ")), e.finder.request(S("\x1bxt\x7fsOF\x18JJCI"), {msg: e.finder.lang.errors.missingFolder});
              var t = e.data.context.moveCopyData.get(S("\fn{}bt|gRzzs}k")), n = t.get(S(",]O]U_F"));
              n.get(S("\x1fCIKO@WCI")).remove(t), e.finder.request(S("(OEGHH\\\x15WTFrWA_A]")) === t && e.finder.request(S("$CIKLLX\x11C]KA`PF["), {
                path: n.getPath({full: !0}),
                expand: !0
              });
              break;
            case 103:
              e.cancel(), e.finder.request(S("\x15zxy}\x7fi&uw{E")), e.finder.request(S("\vhdoc\x7fv(zzsy"), {msg: e.finder.lang.errors.codes[103]})
          }
        }

        function u(i, r, o) {
          (r !== S(";qRHZ") || i.finder.request(S("\vjbbkuc(tqaWtlpl~")).get(S(";]^R")).fileDelete) && i.data.toolbar.push({
            name: r + S("$cOKMZ"),
            type: S("\fo{{d~|"),
            priority: 40,
            icon: S("#GN@\nN@FN\x01") + (r === S("6tWIC") ? S("5UXH@") : S("\x15{xn|")),
            label: o.finder.lang.common[r.toLowerCase()],
            action: function () {
              var t = new s({
                finder: o.finder,
                collection: o.finder.request(S("8K_HSHL\\%2x$!1|$$&$.(")),
                viewMetadataPrefix: S("\x17uvl~_rnf")
              });
              t.on(S("\x1axttr{VHGT\x1eCIKLLX\x11IU^N^U"), function (e, t) {
                o.finder.fire(S("1T\\XQSE\x02\\BK]SZ"), {view: t.view, folder: t.view.model}, o.finder)
              }), t.on(S('?#)+/ 3/"?s,$ )+=j2>:7>'), function (e, t) {
                o.finder.request(S("\x1a}uq{l\x1a") + r.toLowerCase(), {
                  files: o.finder.request(S('<[WS%2x$!1\x15"$,)?))')),
                  toFolder: t.view.model
                })
              }), t.on(S("\x18zrrpyhvEV\x18EKIBBZ\x13ANUIAX^"), function (e, t) {
                t.evt.keyCode !== l.enter && t.evt.keyCode !== l.space || (t.evt.preventDefault(), t.evt.stopPropagation(), o.finder.request(S("\x1a}uq{l\x1a") + r.toLowerCase(), {
                  files: o.finder.request(S('<[WS%2x$!1\x15"$,)?))')),
                  toFolder: t.view.model
                }))
              }), t.on(S(":PYDZP7/x7%'"), function (e) {
                e.preventDefault(), e.stopPropagation(), _(o.finder) ? t.$el.closest(S("\x12Hptbv5kuwy <oAFG\x01y")).find(S("\f.mdv<\x7f|bp;twic6\x7fqqlE")).focus() : t.$el.closest(S("+\x02NEI\x1dU[RXZQ")).find(S("1\x1cP_S\x1bSQXVT[\x10\\J45--7")).find(S("4\x1bC^\x15[NU")).focus()
              });
              var e = i.data.file ? i.finder.lang[r.toLowerCase()].oneFileDialogTitle : i.finder.lang[r.toLowerCase()].manyFilesDialogTitle.replace(S("B8'*3)<4"), i.data.files.length);
              if (_(o.finder)) {
                o.finder.on(S("\x12curs-kqul&") + C, function () {
                  t.refreshUI()
                });
                var n = new a({
                  finder: o.finder, events: {
                    "click @ui.close": function () {
                      o.finder.request(S("<M_X%{&&714(1"), {name: C})
                    }
                  }
                });
                n.on(S("/CY]D"), function () {
                  this.content.show(t)
                }), o.finder.request(S("\v|lij*r`vuas"), {
                  view: n,
                  title: e,
                  name: C,
                  className: S("\rmdv<\x7f|bp;twic6xt\x7fsOF"),
                  uiOptions: {theme: o.finder.config.swatch, overlayTheme: o.finder.config.swatch}
                }), o.finder.request(S(":K]Z[\x053)-4"), {name: C})
              } else o.finder.request(S("D!/&$&-"), {
                name: C,
                title: e,
                buttons: [S('"@EKEBD')],
                contentClassName: S("\x12p\x7fs;zwo\x7f6\x7frnf\rEKBHJA"),
                restrictHeight: !0,
                focusItem: S("&\tKBL\x06X_KJ"),
                uiOptions: {
                  positionTo: S("<fZ^4 o /#k3'&&)-?sm\x1d0;=v\b"), create: function () {
                    setTimeout(function () {
                      t.refreshUI()
                    }, 0)
                  }, afterclose: function () {
                    n && n.destroy(), t && t.destroy()
                  }
                },
                view: t
              })
            }
          })
        }

        function t(e) {
          e.data.evt.ckfFilesSelection && this.finder.request(S("=]P.5';0\b#)="), {
            name: S("\x1bzrr{ESfQKU"),
            evt: e.data.evt,
            positionToEl: e.data.el || e.data.view.getLabel(),
            context: {folder: e.data.folder}
          })
        }

        function c(e) {
          var t = e.data.context.folder, n = t.get(S("5WTT"));
          e.data.items.add({
            name: S("A\x0f,2 \0.$,9"),
            label: e.finder.lang.move.dropMenuItem,
            isActive: n.fileUpload,
            icon: S("@\")%i#/+-d'$:("),
            action: function () {
              e.finder.request(S("4S_[]J\0VSK["), {files: e.finder.request(S("\x1c{wsER\x18DAQuBDLI_II")), toFolder: t})
            }
          }), e.data.items.add({
            name: S("\x1aXsmgYIMGP"),
            label: e.finder.lang.copy.dropMenuItem,
            isActive: n.fileUpload,
            icon: S("!AHB\b@NDL\x07HC]W"),
            action: function () {
              e.finder.request(S('\x12u}ysd"zuke'), {
                files: e.finder.request(S("7^PV^O\x07YZ4\x12'/!&2\",")),
                toFolder: t
              })
            }
          })
        }

        function _(e) {
          return e.request(S("*^E\x17IJD|]WQ")) === S("#IJDNDL")
        }

        return function (n) {
          var i = this;

          function e(t) {
            n.setHandler(S("\x0eiy}w`.") + t.toLowerCase(), function (e) {
              !function (n, e, t) {
                var i = [];
                (n.files instanceof o.Collection ? n.files : new o.Collection(n.files)).forEach(function (e) {
                  var t = e.get(S("6QWU^^N"));
                  i.push({
                    options: n.options ? n.options : "",
                    name: e.get(S("?. /&")),
                    type: t.get(S(';NXMP53!&\x10<6"')),
                    folder: t.getPath()
                  })
                });
                var r = new g({
                  type: e,
                  currentFolder: n.toFolder,
                  lastIndex: t.request(S("\fkgcub(tqaUbjk\x7fuh")).indexOf(n.files.last()),
                  postFiles: i
                });
                b(t, i, r)
              }(e, t, n)
            }), n.on(S("\x13wz{zyw~!}{jzR\x1b") + t + S("\x17^pv~o"), function (e) {
              !function (e, t, n, i) {
                var r = e.data.response;
                if (!r.error || !f.contains([103, 116], r.error.number)) {
                  var o, s = n.finder, a = e.data.context, l = a && a.moveCopyData ? a.moveCopyData : new g;
                  l.get(S("\x16cai\x7f")) || l.set(S("2GMES"), t), l.processResponse(e.data.response), s.request(S("\x1esO@FFV\x1fNNLL"));
                  var u = s.lang[l.get(S(",YW_U")).toLowerCase()].operationSummary;
                  if (l.set(S(":VOZ"), u.replace(S("\x16l{vouh`"), l.get(S("0U]]Q")))), l.set(S("\x11wafzddLpnwy"), s.lang[l.get(S("\x0fdhbv")).toLowerCase()].errorDialogTitle), l.set(S("!QKKReFFJOG"), _(s)), !l.hasFileExistErrors()) {
                    s.request(S("0ASTQ\x0fRRKMHTE"), {name: C}), s.request(S("8I[\\Y\x07ZZ350,="), {name: w});
                    var c = l.hasFileExistErrors() ? s.lang.errors.operationCompleted : s.lang[l.get(S("\x14aog}")).toLowerCase()].operation;
                    return l.hasOtherErrors() && (l.set(S("6ZK^"), s.lang.errors.operationCompleted + " " + l.get(S("%KTO"))), o = new m({
                      finder: s,
                      model: l,
                      events: {
                        "click @ui.ok": function () {
                          n.finder.request(S("3DTQR\x02]_HHOQF"), {name: y}), n.finder.request(S("\x0ekyp~|s/rrkmhte"))
                        }
                      },
                      className: function () {
                        return this.finder.request(S("\x19or&z{kmNFF")) == S(" LMAMIC") ? S("\x14`\x7f:{vtoysj") : ""
                      }
                    }), l.addErrorMessages(s.lang.errors.codes)), o ? _(s) ? (s.request(S("3DTQR\x02ZH^]I["), {
                      view: o,
                      title: c,
                      name: y,
                      uiOptions: {
                        dialog: s.request(S("+YD\x14HUE\x7f\\PP")) !== S("B.+'/+-"),
                        theme: s.config.swatch,
                        overlayTheme: s.config.swatch
                      }
                    }), s.request(S("\x1cm\x7fxE\x1bQKKR"), {name: y}), s.request(S('"SEBC\x1dLLY_^BW'), {name: w})) : s.request(S("+HDOC_V"), {
                      name: l.get(S("E2>8,")) + S("#wPEDMZY"),
                      title: c,
                      buttons: [S(";SV}S/2'")],
                      minWidth: S(":\x0f\f\rNG"),
                      view: o
                    }) : s.request(S("\x1cyw~LNE\x19MK@H"), {
                      title: c,
                      msg: l.get(S("E+4/")),
                      name: S("\x13Yz`r[vjbOhsrAS[jJCI")
                    }), i && (t === S("\x1fmNTF") && function (t) {
                      var e = t.request(S("\x19|rpxm%GDV`QWTBF]")), n = t.request(S("\x1c{wsER\x18DAQuBDLI_II")),
                        i = t.request(S("2U]YS\r_\\Nz_IWI%"));
                      i || (i = n.last());
                      for (var r = e.indexOf(i); -1 < n.indexOf(e.at(r)) && r < e.length;) r++;
                      if (-1 != n.indexOf(e.at(r)) || r === e.length) for (r = e.indexOf(i) - 1; -1 < n.indexOf(e.at(r)) && 0 <= r;) r--;
                      var o = e.at(r);
                      t.once(S(" EKBHJA\x1dKEEXI\x17c@FTq\\DLeBUT[IEtPY/"), function () {
                        var e = t.request(S("2U]YSD\x02^_O\x7fHLM%/6"));
                        o && -1 < e.indexOf(o) ? (o.trigger(S("7^VYNO"), o), t.request(S("\x11tzxpe-k|v~\x7fi"), {files: [o]})) : h(S("=\x10\\+'o%-)#4e?#.;")).focus()
                      })
                    }(s), s.request(S("$CIKLLX\x11^HH]UBZu]YSD")))
                  }
                  l.nextError(), l.addErrorMessages(s.lang.errors.codes), function (e, t, n) {
                    var i = e.get(S(")\\BIZ"));
                    if (!i) {
                      i = new p({finder: t});
                      var r = t.lang[n.toLowerCase() + S("\x0f_awaua\x7fxv")];
                      _(t) ? (t.request(S("$UG@M\x13IYILZJ"), {
                        view: i,
                        title: r,
                        name: w,
                        uiOptions: {
                          dialog: t.request(S("D0/}/,>\x06#)+")) !== S("4XYUQU_"),
                          theme: t.config.swatch,
                          overlayTheme: t.config.swatch
                        }
                      }), t.request(S('"SEBC\x1d[AE\\'), {name: w}), t.request(S(":K]Z[\x05$$176*?"), {name: C})) : t.request(S(" EKBHJA"), {
                        name: w,
                        title: r,
                        buttons: [S("+OL@LU]")],
                        view: i
                      })
                    }
                    return i
                  }(l, s, t).content.show(new v({
                    finder: s, model: l, events: {
                      "click @ui.skip": function () {
                        this.model.hasFileExistErrors() && !this.ui.processAll.is(S("By'-#$#,.")) ? (this.model.nextError(), this.render()) : d()
                      }, "click @ui.overwrite": function () {
                        b(n.finder, this.model.getFilesForPost(this.ui.processAll.is(S('C~&."+"//'))), this.model, S("+C[K]GC[GQ"))
                      }, "click @ui.rename": function () {
                        b(n.finder, this.model.getFilesForPost(this.ui.processAll.is(S("-\x14LXTQXQQ"))), this.model, S(" @WWKWCIIDO"))
                      }, "click @ui.cancel": d
                    }, className: function () {
                      return this.finder.request(S("\x16bq#}~hPq{E")) == S("\x18tuyuq{") ? S("@4+n'*(3-'>") : ""
                    }
                  }))
                }

                function d() {
                  n.finder.request(S("8I[\\Y\x07ZZ350,="), {name: w}), n.finder.request(S('\x11vzuyyp"}\x7fhhoqf'))
                }
              }(e, t, i, t === S("=sP6$"))
            }), n.on(S("6TWTWZRY\x04Z23-1~") + t + S("\vJdbjc"), r), n.on(S('0E]\\XWWE\x02K_HYI\x04r!(,y",*";'), function (e) {
              u(e, t, i)
            }), n.on(S("\x1bhrqsB@P\x19V@UB\\\x13gJEC\x14IY]W"), function (e) {
              u(e, t, i)
            })
          }

          (i.finder = n).on(S("<[QS$$0y 7)7"), t, i), n.on(S("9YTRI[G4\f'-1\x7f ($-/9\b?!?"), function (e) {
            e.data.groups.add({name: S("\x17uvl~_rnf")})
          }), n.on(S("-M@^EWK@xSYM\x03\\TPY[M\x043-3~()1-\n%;5"), c), e(S("<~QO9")), e(S(">r/7'"))
        }
      }),CKFinder.define(S('\x1e\\kgKM@@T\beFN^@H]\0v^QFGxWYY^_I\x13{Q\\52\x0f"*$!":'), [S("#NTSBZP"), S("\x15cy||hh\x7frlz"), S('2p\x7fs_Y\\\\H\x14iIWSo\n\':\x07*""')], function (o, s, i) {
        "use strict";

        function n(n, e) {
          var i = 0, t = s.chain(o(S("-u[QS[]PPNj"))).filter(function (e) {
            var t = o(e);
            if (parseInt(t.attr(S("\x13`tt~v}\x7fc"))) < 0) return !1;
            if (t.closest(S("-\0L[W\x1fCURS")).length) return t.closest(S("\x13:v}q5i{|y")).hasClass(S("3A\\\x1bGY^_\x16]^JV6$"));
            var n = t.closest(S("\x169mp7k}s{s"));
            if (n.length) {
              var i = !n.hasClass(S("!WJ\tUGIME\x07H@B]JT"));
              return t.hasClass(S("9YPZ\x10JM%$")) && o(S("\x13vzrn")).hasClass(S(")I@J\0[F\x1d\\]WQ\x18RRKRNTL")) ? o(S("\x17C}{o}0}tF\fRBC@\x1b\x05eHCE\x0ep")).hasClass(S("\x14`\x7f:hx}~1|}kIWG")) : i
            }
            return t.is(S(".\x15FXAZVYS"))
          }).sortBy(function (e) {
            return parseInt(o(e).attr(S("\x15bvzpt\x7fye")))
          }).forEach(function (e, t) {
            e === n.node.get(0) && (i = t)
          }).value(), r = i + e;
          if (!(r >= t.length || r < 0)) return n.event.preventDefault(), n.event.stopPropagation(), o(t[r]).focus()
        }

        return function (e) {
          var t = [];
          e.setHandlers({
            "focus:remember": function () {
              t.push(document.activeElement)
            }, "focus:restore": function () {
              o(t.pop()).focus()
            }, "focus:next": function (e) {
              n(e, 1)
            }, "focus:prev": function (e) {
              n(e, -1)
            }, "focus:trap": function (e) {
              e.node && e.node.on(S("\x11yvmqy`v"), function (e) {
                if (e.keyCode === i.tab) {
                  e.preventDefault(), e.stopPropagation();
                  var t = o(this).find(S("\x1dEkACKM@@^z\x04@D[YY\x02N\x1cSGG@ZX\x1bK\\V^_I")).not(S("*pXLLF^UWK\t\x17\x1b\x06\x1ad")).filter(S("<\x07HV3( /!")),
                    n = s.indexOf(t, e.target) + (e.shiftKey ? -1 : 1);
                  n >= t.length ? n = 0 : n < 0 && (n = t.length - 1), t.eq(n).focus()
                }
              })
            }
          })
        }
      }),CKFinder.define(S("(jamECJJB\x1e\x7f\\PPZD\x17k_HSHL\\%\x15;3!"), [S("2FZQSEKZUIY"), S("\x1b~|}tBNLF"), S("!ahbLHCM[\x05fCIKCC\x1et\\XQSE"), S("\nHGKgatt`<Yzrrtj5]uq{")], function (o, e, n, s) {
        "use strict";
        return n.extend({
          initialize: function () {
            n.prototype.initialize.call(this);
            var e = this.get(S("8XVWSJ[[\x0596&*6/(&:"));
            e && "string" == typeof e && this.set(S("\x18xvwsj{{eYVFJVOHFZ"), e.split(","), {silent: !0});
            var t = this.get(S("/Q]^\\CPRr@M_UOTQQ3"));
            t && "string" == typeof t && this.set(S("\x0en|}}dqqSol|thurpl"), e.split(","), {silent: !0})
          }, isAllowedExtension: function (e) {
            e || (e = s.noExtension), e = e.toLocaleLowerCase();
            var t = this.get(S("#EIJH_LNnTYKACX]]G")), n = this.get(S("*OICGJTtJGQ[E^WWI")), i = t && !o.contains(t, e),
              r = n && o.contains(n, e);
            return !(i || r)
          }, isOperationTracked: function (e) {
            var t = this.get(S("\x1djmABIF@jVBZH^BCC]"));
            return !!t && o.contains(t, e)
          }
        })
      }),CKFinder.define(S("8M_CH\x1c}t\x06(,'!7i\x13-$:'-9+<\x7f\x13 6515%-48(s\x1f,:\x01\x05\x01\x11\x11\b\x04\x14F\r\x05\x1f"), [], function () {
        return S('5\nV\x18ZVZON\x03\x1d5(o!0+=<wi#?b.;="4<\'t(+w-0w9(3s>\x03\x15\v\x15\x01\x1e\x1dX\x15\x14HK\b\f\x1a\x0e]\x12\x19\x15Y\x05\x17\x03\x10DX\0\x07\\^\x16t/rbpm&zu+*c~hh22203`tt~v}\x7fc!?3.\x02\x01FBPD\vDCO\x07O^B^\x12\x12E@FQ\x17\bLC\x18\x1aRH\x13R^"$.c89f.<g$*!(n2-m}2j_')
      }),CKFinder.define(S('(jamECJJB\x1e\x7f\\P@ZRK\x16|TPY[M3n\x14*!25h\n;/*(.<:=3\x04:1"'), [S("\x1fJPWFV\\"), S('"`ocOILLX\x04zDKXC\x1epRGP\x19~L\\WmUXI'), S('.[UIF\x12w~p^V]_I\x13i[R0-#7!6i\x05:,+//?;"2"}\x11&073;+/6>.p;\x0f\x15')], function (e, t, n) {
        "use strict";
        return t.extend({
          name: S("\x16Cwvvy}oXpLEGQ"),
          tagName: S("\x14y\x7f"),
          template: n,
          ui: {btn: S("2\x1dA\\\x1bULW"), label: S("\x1b2hw2BUL")},
          events: {
            click: function (e) {
              this.trigger(S("0R^ZW^"), {evt: e, view: this, model: this.model})
            }, dragenter: function (e) {
              this.model.get(S("\x1b\x7fhlmEOV")) || "/" === this.model.get(S(":K]IV")) || (e.stopPropagation(), e.preventDefault(), this.ui.btn.addClass(S("\x11gz9wby5xyouk{")))
            }, dragover: function (e) {
              this.model.get(S("-MZBCW]@")) || "/" === this.model.get(S("!RBPM")) || (e.stopPropagation(), e.preventDefault(), this.ui.btn.addClass(S("\x1ejI\f@WJ\bGD\\@\\N")))
            }, dragleave: function (e) {
              this.model.get(S("*HY_\\J^E")) || "/" === this.model.get(S("\v|lzg")) || (e.stopPropagation(), this.ui.btn.removeClass(S("C1,k%<'g*/9'95")))
            }, ckfdrop: function (e) {
              if (!this.model.get(S("\x19ynno{qT")) && "/" !== this.model.get(S("\x11br`}"))) {
                e.stopPropagation(), this.ui.btn.removeClass(S("\x18ls6~ip2ABVJR@"));
                var t = this.model.get(S("7^VV_YO"));
                this.finder.fire(S("A$,(!#5r-8$<"), {evt: e, folder: t, view: this}, this.finder)
              }
            }, keydown: function (e) {
              this.trigger(S("5]RA]ULR"), {evt: e, view: this, model: this.model})
            }
          },
          focus: function () {
            this.ui.btn.focus()
          },
          getLabel: function () {
            return this.ui.label
          }
        })
      }),CKFinder.define(S("&dcoCEHH\\\0}^VFXPE\x18~VV_YOM\x10\x16('47j\x045-(.(>8#-#\x07;6#"), [S(".Z^UWAGVYE]"), S("\x13~dcrj`"), S('"`ocOILLX\x04aBJZ\\TA\x1crZZS]KI\x14jT[H3n\x001!$"$:<\')\x1a$+8'), S("#gn`NFMOY\x03{GJGB\x1dqUFS\x18{VWKSNWK%\x17+&3"), S("\x18ZQ]uszzR\x0ewWMI\tlMPiDHH")], function (t, e, n, i, o) {
        "use strict";
        return i.extend({
          name: S("\x19Ntsq|~RgMO@@TT"),
          className: S("2P_S\x1bQWU^^NN\x13]2$#''73**:j>%`, 4(\x7f::=3%1-"),
          template: S(":\x07IQ\x1eK!#+-  >zj{zirqa:<o"),
          childViewContainer: S("1G_"),
          attributes: {role: S("2]UC_PYMSTR")},
          childView: n,
          ui: {container: S("\x1ejL\x1bDJVVR")},
          events: {
            touchstart: function (e) {
              e.stopPropagation()
            }, keydown: function (e) {
              if (e.keyCode !== o.tab || !this.finder.util.isShortcut(e, "") && !this.finder.util.isShortcut(e, S("$VNNN]"))) return t.contains([o.left, o.end, o.right, o.home], e.keyCode) ? (e.stopPropagation(), e.preventDefault(), void (e.keyCode === o.left || e.keyCode === o.end ? this.children.last() : this.children.first()).focus()) : void (e.keyCode !== o.up && e.keyCode !== o.down || e.preventDefault());
              this.finder.request(this.finder.util.isShortcut(e, "") ? S("#BJER[\x13DNTY") : S("<[Q\\52x36 0"), {
                node: this.ui.container,
                event: e
              })
            }, "focus @ui.container": function (e) {
              e.target === this.ui.container.get(0) && (e.stopPropagation(), this.children.first().focus())
            }
          },
          initialize: function () {
            function r(e, t, n, i) {
              e.preventDefault(), e.stopPropagation(), i.collection.last().cid !== n.cid && t.request(S("\x0fv~~wqg,xh|tK}iv"), {path: n.get(S("\x0e\x7fqez"))})
            }

            this.listenTo(this.collection, S("@3'0!1"), function () {
              this.$el[this.collection.length ? S("\x1ahtri") : S('"KMAC')]()
            }), this.on(S("7[QSWXKWZ7{)&=!)0&"), function (e, t) {
              var n = t.evt;
              if (n.keyCode === o.left || n.keyCode === o.right) {
                n.stopPropagation(), n.preventDefault();
                var i = this.collection.indexOf(t.model);
                i = n.keyCode === (this.finder.lang.dir === S("\x0ecdc") ? o.left : o.right) ? i <= 0 ? 0 : i - 1 : i >= this.collection.length - 1 ? i : i + 1, this.children.findByModel(this.collection.at(i)).focus()
              }
              n.keyCode !== o.space && n.keyCode !== o.enter || r(n, this.finder, t.model, this)
            }, this), this.on(S("\x15u\x7fqu~muxi%CMK@O"), function (e, t) {
              r(t.evt, this.finder, t.model, this)
            }, this)
          },
          onRenderCollection: function () {
            this.$childViewContainer.attr(S("\x17{u{ho"), S("\nhgk#i\x7f}vvff;uj|{\x7f\x7fokrBR\x0fDVLB\x07KBL\x06JBBKUCA\x1eVGSV\\ZHNQ_M\x12'3+'i") + this.collection.length);
            var e = this.$childViewContainer.prop(S("#WFTHDE}BHYF")) - this.$childViewContainer.width();
            e && this.$childViewContainer.scrollLeft(e)
          },
          focus: function () {
            this.ui.container.focus(), setTimeout(function () {
              window.scrollTo(0, 0)
            }, 0)
          }
        })
      }),CKFinder.define(S("2p\x7fs_Y\\\\H\x14qRZJ,$1l\x02**#-;9d\x0e?+.42 &97%"), [S(":QMH[M9"), S("1PRW^TXV\\"), S('\'kblBBIK]\x1f|]WAYSD\x17\x7fUWXXLLo\x17+&36i\x05:,+//?;"2"\x04:1"')], function (e, t, i) {
        "use strict";
        return {
          start: function (e) {
            this.breadcrumbs = new t.Collection, this.breadcrumbsView = function (e, t) {
              var n = new i({finder: e, collection: t});
              return e.on(S("?0 %&~6.(?s\x07*%#"), function () {
                e.request(S("\x1bl|yz\x1a@FGv@ANGG"), {
                  page: S("\x14Xw~v"),
                  name: S("9XIY\\Z\\24/!7"),
                  id: e._.uniqueId(S("*HGK\x03")),
                  priority: 30
                }), e.request(S("\x18i{|y'mwOVkMv@ANGG"), {view: n, page: S("-cNY_"), region: S(">]2$#''73**:")})
              }), n
            }(e, this.breadcrumbs), function (e, i) {
              e.on(S('C"**#-;p8)!+,$46'), function (e) {
                var t = [], n = e.data.folder;
                for (t.unshift({
                  name: n.get(S('C*$+"')),
                  path: n.getPath({full: !0}),
                  label: n.get(S("\x1cq\x7f}EM")),
                  folder: n,
                  current: !0
                }); n.has(S("&WI[OEX"));) n = n.get(S("!RBV@HS")), t.unshift({
                  folder: n,
                  name: n.get(S("B-%(#")),
                  path: n.getPath({full: !0}),
                  label: n.get(S("\x1cq\x7f}EM"))
                });
                t.unshift({name: "/", path: "/"}), i.reset(t)
              }), e.on(S(";NXMP53!&7\x7f5/'>"), function () {
                i.reset([])
              })
            }(e, this.breadcrumbs)
          }, focus: function () {
            this.breadcrumbsView && this.breadcrumbsView.focus()
          }
        }
      }),CKFinder.define(S("<~uy)/&&6j\x133!%e;-?=*\x112>"), [], function () {
        "use strict";
        return function (e) {
          return {
            folderView: 1 == (1 & e),
            folderCreate: 2 == (2 & e),
            folderRename: 4 == (4 & e),
            folderDelete: 8 == (8 & e),
            fileView: 16 == (16 & e),
            fileUpload: 32 == (32 & e),
            fileRename: 64 == (64 & e),
            fileDelete: 128 == (128 & e),
            imageResize: 256 == (256 & e),
            imageResizeCustom: 512 == (512 & e)
          }
        }
      }),CKFinder.define(S("\x1d]TfHLGAW\tjGM_GI^\x01i_]VVFF\x19qWU^^NN"), [S("7MW^^NN]P2$"), S("0[CFQGO"), S(",neiY_VVF\x1a{X\\\\VH\x13{QS$$0"), S("8zq}USZZ2n\x0f,  *4g\x1b/8#8<,5\x05+#1"), S("\x1c^UYIOFFV\nkHLLFX\x03kACTT@@wZZ[]ZNRSS"), S("=}t\x06(,'!7i\n'-?')>a\t?=66&&y\x011<-(s\x1b13\x04\x04\x10\x100\x17\x03\x02>\0\x0f\x1c"), S(">|\v\x07+-  4h\x05&.> (=`\x16>>71'%x\x1a+?:8>,*\r\x03\x11"), S("+ofhF^UWA\x1b`B^T\x16JZNN[~#-"), S("\x18ZQ]uszzR\x0ewWMI\tlMPiDHH")], function (d, a, f, o, h, i, r, g, l) {
        "use strict";

        function s(e) {
          var t = e.expand, n = e.expandStubs, i = (e.path || "").split(":");
          if ("/" !== e.path) {
            var r;
            i[1] && (r = i[1]);
            var o = this.resources.findWhere({name: i[0]});
            o || (o = this.resources.first()), n && function (n, e, t, i) {
              var r = n.finder, o = t.replace(/^\//, "").split("/").filter(function (e) {
                return !!e.length
              }), s = e, a = s;
              o.length && (s.set(S("\nb\x7f]katx|t"), !0), s.set(S(".FCtJCU[RR\\"), !0), o.forEach(function (e) {
                var t = new f({
                  name: e,
                  resourceType: s.get(S('E4";&?9/(\x1a6 4')),
                  hasChildren: !0,
                  acl: g(0),
                  isPending: !0,
                  isExpanded: !0,
                  children: new h,
                  parent: a
                });
                a.get(S("\x0fsy{\x7fpgsy")).add(t), a = t
              }));
              var l = a;
              d.defer(function () {
                l.trigger(S("\x19i~px}kEE"))
              }), n.currentFolder && n.currentFolder.cid !== l.cid && n.currentFolder.trigger(S("\x14qsd}u\x7fxhxz"), n.currentFolder), n.currentFolder = l, r.once(S("\x12g{zzuyk iyn{k\x1alCJJ\x1f@NDLY"), c), r.once(S('=JP/- "6\x7f4";,>q\x01,\'!j7;?1'), c), r.request(S("\x0el\x7f|\x7frzq,d}w~"), {
                name: S("%aB\\oEGHH\\\\"),
                folder: l,
                context: {silentConnectorErrors: !0, parent: l}
              }).done(function (e) {
                if (e.error) {
                  var t = n.resources.findWhere({name: l.get(S("\nyi~azbrwGmes"))});
                  return t.get(S("4V^^T]H^R")).reset(), void r.request(S("\x13rzzs}k hyq{|T"), {folder: t})
                }
                l.set(S("\x1fABN"), g(e.currentFolder.acl)), l === r.request(S(" GMO@@T\x1dOL^jOYGYU")) && u && r.request(S("0E]\\XWWE\x02K_HYI"), {
                  name: S("\x19Wzus"),
                  event: S("9\\TPY[M"),
                  context: {folder: l}
                })
              }), l.trigger(S("\x11avxpuc}}"), l), r.fire(S("+JBBKUC\b@QYSTL\\^"), {folder: l}, r), i && l.trigger(S("$PO\x1dMQZJBI"));
              var u = !0;

              function c() {
                u = !1
              }
            }(this, o, r, t), function n(i, r, o, s, a) {
              var e = o.length, l = i.finder, t = 0 < r.get(S(".LXX^WFPX")).size();

              function u() {
                var e = o.replace(/^\//, "").split("/");
                if (e.length) {
                  var t = r.get(S(",NFF\\U@VZ")).findWhere({name: e[0].toString()});
                  t ? n(i, t, e.slice(1).join("/"), s, a) : a || (l.request(S("E ($-/9v>+#52&"), {folder: r}), s && r.trigger(S("\x0ezy+wkdtxs")))
                }
              }

              r.get(S(">V3\x11'- ,( ")) || r.get(S("&OIZiCEAJ]U_")) && e && !t ? l.request(S('?#./.%+"};,$/'), {
                name: S(" fGWbJJCM[Y"),
                folder: r,
                context: {parent: r}
              }, null, null, 30).done(function (e) {
                e.error || (r.set(S(" @AO"), g(e.currentFolder.acl)), u())
              }) : u()
            }(this, o, r.replace(/\/$/, ""), t, n)
          } else this.finder.request(S("\x17j|itio}zS\x1bQKKR"))
        }

        function u(e) {
          var t = this.finder, n = e.folder, i = this.currentFolder;
          !(i && i.cid === n.cid) && i && i.trigger(S("?$$1&( %3--"), i), this.currentFolder = n, t.request(S("\x1d}pMLCM@\x1fUBFM"), {
            name: S(" fGWbJJCM[Y"),
            folder: n,
            context: {parent: n}
          }), n.trigger(S("\x16d}u\x7fxhxz"), n), t.fire(S('5PXT]_I\x06N[S%"6& '), {folder: n, previousFolder: i}, t)
        }

        function c(e) {
          var t = this, n = e.data.response;
          if (n && !n.error) {
            var i = n.resourceTypes, r = [];
            d.isArray(i) && d.forOwn(i, function (e, t) {
              r.push(function (e) {
                return d.extend(e, {path: "/", isRoot: !0, resourceType: e.name, acl: g(e.acl)}), new o(e)
              }(i[t]))
            }), t.finder.fire(S("&DZLK_I\x7fK\\_D@PQF\fU]_UIY"), {resources: r}, t.finder), d.forEach(r, function (e) {
              e instanceof f || (e = new f(e)), t.resources.add(e)
            }), t.finder.fire(S("\x1c~lzAUGqAVIRZJOX\x16LH[UC"), {resources: t.resources}, t.finder)
          }
        }

        function p(e) {
          e.data.folder.get(S("%NF[jBB@I\\J^")) && e.data.folder.get(S("\nhddbkbt|")).size() <= 0 && e.finder.request(S('?#./.%+"};,$/'), {
            name: S("(nO_jBBKUCA"),
            folder: e.data.folder,
            context: {parent: e.data.folder}
          })
        }

        function v() {
          var n, e, t, i, r, o, s, d, f;
          if (n = this.finder, F = F || (o = I(n.config.initConfigInfo.c), function (e) {
            return o.charCodeAt(e)
          }), (i = n.config.rememberLastFolder) && (n.request(S(" RGWPLH@[\x13NNJD@J"), {
            group: S("&AGENN^^"),
            label: S("\x13Rzzs}ki"),
            settings: [{name: S("9VZOIxP,%'1"), type: S("\x16\x7fq}~~r")}]
          }), n.on(S("\x10w}\x7fppd-k|v~\x7fi{{"), function (e) {
            n.request(S("\v\x7fhz{y\x7fu`.fscNxvny"), {
              group: S("1T\\XQSEK"),
              name: S("5ZVKM|TPY[M"),
              value: e.data.folder.get(S("D7#4'<8()\x197?5")) + ":" + e.data.folder.getPath()
            }), r = n.request(S("\f~k{dx|tg/qrlO{wix"), {group: S("A$,(!#5;"), name: S('"OEVRaGENN^')})
          })), s = F(4) - F(0), F(4), F(0), s < 0 && (s = F(4) - F(0) + 33), b = s < 4, i) {
            var a = n.request(S("&TM]^BBJ]\x15WTFeUYCR"), {group: S("3RZZS]KI"), name: S("5ZVKM|TPY[M")});
            n.config.displayFoldersPanel && "/" === a || (r = a)
          }

          function l(e, t) {
            n.request(S('B%+)"":s%;)#\x1e.$9'), {path: e, expand: t, expandStubs: !0})
          }

          e = n.config.resourceType, d = function (e) {
            for (var t = "", n = 0; n < e.length; ++n) t += String.fromCharCode(e.charCodeAt(n) ^ 255 & n);
            return t
          }, f = 92533269, E = !function (e, t, n, i, r, o) {
            for (var s = window[d(S("\x1fdATE"))], a = n, l = o, u = 33 + (a * l - (u = i) * (c = r)) % 33, c = a = 0; c < 33; c++) 1 == u * c % 33 && (a = c);
            return (a * o % 33 * (u = e) + a * (33 + -1 * i) % 33 * (c = t)) % 33 * 12 + ((a * (33 + -1 * r) - 33 * ("" + a * (33 + -1 * r) / 33 >>> 0)) * u + a * n % 33 * c) % 33 - 1 >= (l = new s(1e4 * (203623794 ^ f)))[d(S("\x1fGETfULLyEAR"))]() % 2e3 * 12 + l[d(S("0VVEz^]EW"))]()
          }(F(8), F(9), F(0), F(1), F(2), F(3)), t = n.config.startupPath;
          var u = e;
          !u && this.resources.length && (u = this.resources.at(0).get(S("6YYT_")));
          var c, h, g, p, v = i && r ? r.split(":")[0] : u, m = this.resources.where({lazyLoad: !0});
          m.length && m.forEach(function (e) {
            var t = e.get(S("2]UXS"));
            e.set(S("'@HYhDDBKBT\\"), !0), e.set(S("/YBbVZQ_Y_"), !0), t !== v && n.request(S(")IDA@OAT\vAVZQ"), {
              name: S(" fGWbJJCM[Y"),
              folder: e,
              context: {parent: e}
            })
          }), (c = F(5) - F(1)) < 0 && (c = F(5) - F(1) + 33), _ = c - 5 <= 0, i && r ? l(r) : !e && t || 0 === t.search(e + ":") ? l(t, n.config.startupFolderExpanded) : (!e && this.resources.length && (e = this.resources.at(0).get(S("7VXW^"))), l(e + S("\x11(<"))), M = function (e, t, n) {
            var i = 0,
              r = (window.opener ? window.opener : window.top)[S('?,.!"0,))')][S("\ncc~zaq|w")].toLocaleLowerCase();
            if (0 === t) {
              var o = S("<cIH7\x1dl");
              r = r.replace(new RegExp(o), "")
            }
            if (1 === t && (r = 0 <= ("." + r.replace(new RegExp(S("D\x1b10?\x15d")), "")).search(new RegExp(S("C\x18k") + n + "$")) && n), 2 === t) return !0;
            for (var s = 0; s < r.length; s++) i += r.charCodeAt(s);
            return r === n && e === i + -33 * parseInt(i % 100 / 33, 10) - 100 * ("" + i / 100 >>> 0)
          }(F(7), (h = F(4), g = F(0), (p = h - g) < 0 && (p = h - g + 33), p), n.config.initConfigInfo.s)
        }

        function m(e) {
          var t = e.finder;
          x = function (e, t) {
            for (var n = 0, i = 0; i < 10; i++) n += e.charCodeAt(i);
            for (; 33 < n;) for (var r = n.toString().split(""), o = n = 0; o < r.length; o++) n += parseInt(r[o]);
            return n === t
          }(t.config.initConfigInfo.c, F(10));
          var n = e.data.context.parent, i = e.data.response.folders;
          n.set(S("\x14|eG}w~rrz"), !1), function (t) {
            if (!(b && x && M && _) || E) {
              if (R) return;
              var n = function (e) {
                for (var t = "", n = 0; n < e.length; ++n) t += String.fromCharCode(e.charCodeAt(n) ^ n - 1 & 255);
                return t
              };
              setTimeout(function () {
                t.setHandler(S("&AAEOX\x16IKCUEW"), function () {
                  var e = {};
                  e[S("\f`}h")] = [S("2\x95[A"), S("\x12\x8fuzz{h"), S("?\xdb$/$3$"), S("\n\x92e`i\x7f"), S(".\xb9^"), S("\x14\xaeS[U"), S(";\xaeR[Xm")][S("7UXJ")](n)[S("4_Y^V")](" "), t.request(S("\x12w}tzx\x7f#suzr"), e)
                })
              }, 100), R = !0
            }
          }(t);
          var r = n.get(S("5U_QU^IYS"));
          if (d.isEmpty(i)) return n.set(S("-FNCrZZXQDRV"), !1), void (r && r.reset());
          var o = [];
          r.forEach(function (e) {
            d.findWhere(i, {name: e.get(S("\x14{wz}"))}) || o.push(e)
          }), o.length && r.remove(o), d.forEach(i, function (e) {
            !function (e, t, n) {
              var i, r, o, s = e.name.toString(), a = t.where({name: s}),
                l = {name: s, resourceType: n.get(S("9H^ORKM#$\x16:4 ")), hasChildren: e.hasChildren, acl: g(e.acl)};
              a.length ? (i = a[0], r = {}, o = !1, d.forEach(l, function (e, t) {
                i.get(t) !== e && (r[t] = e, o = !0)
              }), o && i.set(r)) : ((i = new f(l)).set({children: new h, parent: n}), t.add(i, {sort: !1}))
            }(e, r, n)
          }), r.sort()
        }

        function w(e) {
          function t() {
            return e.finder.request(S("\x1chw%GDVnKAC")) === S("\x17||iphrn")
          }

          e.data.toolbar.push({
            name: S("D\x16.(?\x0f%'((<<"),
            type: S("\x12qaabxv"),
            priority: 200,
            icon: S("5U\\^\x14W^RH"),
            label: "",
            className: S(".L[W\x1fU[YRRJJ\x17OSZYS%"),
            hidden: t(),
            onRedraw: function () {
              this.set(S("\x0fxxvwq{"), t())
            },
            action: function () {
              e.finder.request(S("$UGIME\x10_CJICU"), {name: S('"EKIBBZZ')})
            }
          })
        }

        function y(e) {
          var t = e.data.folder;
          e.data.evt.keyCode !== l.space && e.data.evt.keyCode !== l.enter || (e.data.evt.preventDefault(), e.data.evt.stopPropagation(), this.finder.request(S("\x1a}sqzzR\x1bMSAKvF\\A"), {path: t.getPath({full: !0})}))
        }

        function C(e) {
          if (116 === e.data.response.error.number) {
            e.cancel(), e.finder.request(S("\x0ekyp~|s/\x7fy~v"), {msg: e.finder.lang.errors.missingFolder});
            var t = e.data.context.folder, n = t.get(S("#TDTBF]"));
            n.get(S("B ,,*#:,$")).remove(t), e.finder.request(S("\fkactt`)spbV{msmy")) === t && e.finder.request(S("\x14sy{||h!sm{qp@VK"), {
              path: n.getPath({full: !0}),
              expand: !0
            })
          }
        }

        var b, _, x, E, M, F;

        function I(e) {
          var t, n, i;
          for (i = "", t = S(">\x0errvvrr~~\t\v\t\x0f\t\v\t\x07\x1a\x1a\x1e\x1e\x1a\x05\x07\x05\v\r\x0f\r\v\x05\x07\x05"), n = 0; n < e.length; n++) i += String.fromCharCode(t.indexOf(e[n]));
          return I = void 0, i
        }

        var R = !1;
        return function (t) {
          var n = this;
          n.finder = t, n.resources = new h, t.config.displayFoldersPanel ? (function (o) {
            var s = o.finder, e = new i({finder: s, collection: o.resources});
            (o.view = e).on(S("&D@@FOZDKX\nW]_PPD\r]AJZRY"), function (e, t) {
              s.fire(S("\x1c{qsDDP\x19A]VFFM"), {view: t.view, folder: t.view.model}, s)
            }), e.on(S("'KACGH[GJG\vT\\XQSE\x02ZVR_V"), function (e, t) {
              s.request(S("E ($-/9v>+#52&"), {folder: t.view.model})
            }), e.on(S("\x15u\x7fqu~muxi%FNNGAW\x1cDGG^NTYCJ^D"), function (e, t) {
              t.evt.preventDefault(), o.finder.request(S("E%(&=/38\0+!%"), {
                name: S("A$,(!#5"),
                evt: t.evt,
                positionToEl: t.view.getLabel(),
                context: {folder: t.view.model}
              })
            }), e.on(S(":XTTR[6('4~#)+,,8q'(7+?&<"), function (e, t) {
              if (t.evt.keyCode === l.enter || t.evt.keyCode === l.space) return s.request(S(")LD@IK]\nBW_QVB"), {folder: t.view.model}), t.evt.preventDefault(), void t.evt.stopPropagation();
              s.fire(S("/V^^WQG\f\\]@^TKS"), {evt: t.evt, view: t.view, folder: t.model, source: S("\rh`|uwagadr}")}, s)
            }), e.on(S("$FNNDM\\BIZ\x14I_]VVF\x0fREWI"), function (e, t) {
              s.fire(S("6QWU^^N\x07ZM/1"), {evt: t.evt, folder: t.model, view: t.view}, s)
            }), e.on(S("?+$;'+2(}<(("), function (e) {
              this.finder.request(this.finder.util.isShortcut(e, "") ? S("\x19|t\x7fhm%NDZW") : S("\x11t|w`e-hk\x7fm"), {
                node: this.$el,
                event: e
              })
            }), s.on(S("<^QQ4$:7\t (2r/%'((<"), function (e) {
              e.data.groups.add({name: S("/UU[G")})
            }, null, null, 10), s.on(S("@ 23~))&,,."), function () {
              var n = !1, e = s.request(S("4EWY]U\0XNX_K%"), {
                name: S("<[QS$$00"),
                view: o.view,
                position: S("._BX_RFL"),
                scrollContent: !0,
                panelOptions: {
                  animate: !1,
                  positionFixed: !0,
                  dismissible: !1,
                  swipeClose: !1,
                  display: S("\f}{|x"),
                  beforeopen: function () {
                    r(), n = !0
                  },
                  beforeclose: function () {
                    i(), n = !1
                  }
                }
              });

              function i() {
                a(S("D\x1e\"&<(g('+c?167nv\x187>6{\x07{r(7r\x10\0\f\x06\bH\x11\x15\t\x19\x1a\x0e\x1e")).css(s.lang.dir === S("\ngx\x7f") ? {
                  "margin-right": "",
                  left: ""
                } : {"margin-left": "", right: ""})
              }

              function r() {
                a(S("!yGEQG\nKBL\x06\\LIJ\r\x13\x7fR][\x14j\x18\x17OR\x11M_Q%-o46$67-;")).css(s.lang.dir === S("%JSZ") ? {
                  "margin-right": s.config.primaryPanelWidth,
                  left: s.config.primaryPanelWidth
                } : {"margin-left": s.config.primaryPanelWidth, right: s.config.primaryPanelWidth})
              }

              function t() {
                e.isOpen() ? e.$el.removeAttr(S("<\\LV!l** !#)")) : e.$el.attr(S("!CQMD\vOAMNNB"), S("\x1djmUD"))
              }

              s.on(S("\x1fP@EF\x1eVNH_\x13gJEC"), function () {
                e.$el.addClass(S("1QXR\x18PXT]_IO\x10N^.$.")), s.config.primaryPanelWidth || e.$el.addClass(S(")I@J\0H@\\UWAG\x18FVV\\V\x16XXX^5-6")), s.request(S("\x16bq#}~hPq{E")) === S("B'!6-3'9") ? e.$el.removeAttr(S(")KYEL\x03GYUVVZ")) : t(), s.on(S("\x12f}/drkp`~"), function (e) {
                  e.data.modeChanged && t()
                })
              }), s.config.primaryPanelWidth && (s.on(S("\x1fP@EF\x1eVNH_\x13gJEC"), function () {
                s.request(S("\x1anu'yzTlMGA")) === S("-JJCZF\\D") && r()
              }), s.on(S("*^E\x17\\JCXHV"), function (e) {
                if (e.data.modeChanged) {
                  var t = s.request(S("!WJ\x1eBCSeFNN"));
                  t === S("\x18}\x7fhwiqo") && r(), t === S("B.+'/+-") && (n ? r() : i())
                }
              })), s.on(S("\x12curs-pp~~&P\x7fvN"), function () {
                e.$el.removeClass(S('7[R\\\x16ZRR[%31n4$("$'))
              })
            })
          }(n), t.on(S("0E]\\XWWE\x02K_HYI\x04r!(,"), w), t.on(S('3G]YELZOOO\x07RV35x%+)""::'), function (e) {
            e.data.shortcuts.add({
              label: e.finder.lang.shortcuts.folders.expandOrSubfolder,
              shortcuts: t.lang.dir === S("=RK2") ? S(";GOWX(5\x0316*1:") : S("\fvbjveSafzaj")
            }), e.data.shortcuts.add({
              label: e.finder.lang.shortcuts.folders.collapseOrParent,
              shortcuts: t.lang.dir === S("\x12\x7f`g") ? S("C?)#!<\b89#:3") : S("\np~digdP`a{bk")
            })
          }, null, null, 40)) : r.start(t), t.setHandlers({
            "folder:openPath": {callback: s, context: n},
            "folder:select": {callback: u, context: n},
            "folder:getActive": function () {
              return n.currentFolder
            },
            "resources:get": function () {
              return n.resources.clone()
            },
            "resources:get:cloned": function () {
              return function n(e) {
                var i = new h;
                return e.each(function (e) {
                  var t = e.clone();
                  t.set(S("'^@O\\"), null), t.set(S("8PI~DM_Q$$&"), !1), i.add(t), e.has(S("\nhddbkbt|")) && t.set(S("\x1b\x7fuwsDSGM"), n(e.get(S("4V^^T]H^R"))))
                }), i
              }(n.resources)
            }
          }), t.on(S("0R]^YTXS\x02\\HISO\x04x%5\x04,(!#5;"), function (e) {
            116 !== e.data.response.error.number || e.data.context.silentConnectorErrors || (e.cancel(), e.finder.request(S(".KYP^\\S\x0f_Y^V"), {msg: e.finder.lang.errors.missingFolder}), e.finder.request(S("&AGENN^\x17A_U_bR@]"), {
              path: e.data.context.parent.get(S(")ZJ^H@[")).getPath({full: !0}),
              expand: !0
            }))
          }, null, null, 5), t.on(S("\x0el\x7f|\x7frzq,rjkui&O{qALGeKIBBZ"), C, null, null, 5), t.on(S("$FIJEHDO\x16H\\]_C\bwQYSC]\x7fUWXXL"), C, null, null, 5), t.on(S("\x18zuvq|p{\x1aDPQKW\x1cdZLK_IkACTT@"), C, null, null, 5), t.on(S("\x1axsps~NE\x18FVWIU\x12nO_jDBJC"), function (e) {
            116 === e.data.response.error.number && e.cancel()
          }, null, null, 5), t.on(S("D&)*%($/v\"%u\x19?;'"), c, n), t.on(S("\x12u{yrrj#q~eyqhN"), y, n), t.on(S("%@HDMOY\x16HV_Q_V"), p, n), t.on(S("\x1c|no\x1aRVBVQ"), v, n), t.on(S(" BMNIDHC\x12HL_I_\x14hUEt\\XQSEK"), m, n), t.on(S("9H^ORKM#$1y7-)0r+/-#?+"), function () {
            n.currentFolder = null
          }), t.on(S("8_UWXXL\x053$.&'1##"), function (e) {
            t.request(S(';HRQS" 0y6 5"<'), {
              name: S(";q\\WQ"),
              event: S("\x1dxpLEGQ"),
              context: {folder: e.data.folder}
            })
          });
          var e = t.lang.dir === S("\v`y|") ? S(":NU\x07MH)1'1-\".3") : S("/EX\b@C\\FRT\\\\O");
          t.on(e, function () {
            t.request(S(",]OHU\vQFFGSYL")) === S("\x1cP\x7fvN") && t.request(S("/EX\bTQA{X\\\\")) !== S("\x12wqf}cwi") && t.request(S("7HXT^P\x07QO%/"), {name: S("4SY[\\\\HH")})
          }, null, null, 20), t.request(S(",FKV\n][@@PX"), {key: l.f8}), t.on(S("@*': *1)r") + l.f8, function (e) {
            t.util.isShortcut(e.data.evt, S("\x0fq}f")) && (t.config.displayFoldersPanel ? (e.finder.request(S(" QCMAI\x1cHXLD"), {name: S("E ($-/9?")}), e.data.evt.preventDefault(), e.data.evt.stopPropagation(), n.view.$el.focus()) : r.focus())
          }), t.on(S("\x17kquih~kkS\x1bNJWQ\x1c@MGOYMA"), function (e) {
            e.data.shortcuts.add({
              label: e.finder.lang.shortcuts.general.focusFoldersPane,
              shortcuts: S("\x19azpic4[G\x1a^")
            })
          }, null, null, 30), t.on(S("\nxdb|{sdf`.y\x7fdl"), function (e) {
            e.data.groups.add({name: S("\x11t|xqsek"), priority: 30, label: e.finder.lang.shortcuts.folders.title})
          })
        }
      }),CKFinder.define(S("@5';0d\x05\f\x0e $/)?a\x1b5<\"?5!3$w\f*73<:\x19\t\r\x07%\v\x17\vH=\x19\x06\x04\r\t(\x06\x1c\x144\x1c\x06\x18X\x13\x17\r"), [], function () {
        return S('\x1d"{IW\x02@HDUT\x15\v_B\x01NAADT\\G\x16\v<>\x04_UIQ\x1d[Q#5;3!xd*=%>"<,<;\x7f7=!9x26,8x{18*7\x0f\x05_A\x14\n\x15\x13JI\x1e\n\x1e\n\v\x1bMS\t\bIU\x1f\x03V\x10\x1e\bR\x14\x18\ralg#yx$\'ij~bcc3-kj/3}a8bju:fa? \x15)(\x1eOEGCK\bOEY\x11\x0fUT\r\x11[G\x1a\\RD\x16PTKII\x1eB=c|8?xf.<g&*"*`: ==20{%24<9/\x1a42:,\0\0\x06\bE\x1b\x1aTF\x06\n\x0e\b\x02Qzx{zH\x11\x1f\x01X\x1a\x16\x1a\x0f\x0eC]uh/qavvhfzc}i/0\x05\x19\x18\x1b\x1a(q\x7fa8zvzon#=CJD\x0eQUJHIM\x07MC_C\x02@P@G\x16\v<>1032\0TPO55b* xd<3tj"8c\'+#\x7f;=$ "w%$x{($.:]C\x04\n\b\0DG\x06\b\x07\x0eQO\x1b\x1f\x1c\x1e\x13\x17VK|~qpsGS\x19\x17\t>\v\v\n\r\f:ca\x7f*h`l}|-3qxr8cgtv{\x7f1{qmM\fRBVQ\x04\x19" #"%$\x12MEEF\\Z\x15BNH\\\x07\x19^HJK//`c $2&e $\'%#+rr% &1wv39-;v1406]C\x16\x11\x11\0DG\f\b\x1e\nA\x04\r\0\x1eLP\x10\x1f\x13[\x15\x19\x1a\x11YB\x06\x05B hv-hdh`&jefab`!sp|pqy6je%5yiijpN\x1f(*-,/.\x14K__XB@\x0fDHBV\t\x17EBZTSO\x1e\x1dZ^4 o**)/)-th?>8+mp53\'5x;>60gy(/+:BA\x06\x02\x10\x04K\x0e\v\x06\x04VN\x0e\x05\t]\x04\x02\x1f\x1b\x14\x12UF\x02\x01F\\\x14\nQl`ld*fijefd%y}b`qu2ni)9ummntr#\x14\x16)(+\x1f\vAOQ\x16##"%\x11\x01KYG\f9=<?\vQWJNH\x1dJF0$\x7fa,,"#-\'hk",#*ms18\x17&$1\f61>2\x7f~)\x01\r\x17\x06YG\x1d\x1cUI\x03\x1fB\x0e\x05,\x03\x03\x14\'\x1b\x1e\x13\x19X\x04\x07Y\\R@u\t=-ekwk9\x02\x006bj\x7fobu1{w)7ml%9so2tzl\x0eHDQEHC\x07UT\b\vBLCJ\r\x13IH\t\x15_C\x16P^H\x12TXM!,\'c98dg;=3\')pl+9""?5,l977?y|)?=)\x0f\x06\x06\x1cXDJYKJ\n\0\x01\x01\x18$\x03\x13\x1d\x07\x05\x17\x05\x1d\x17\x19\x02A_\n\rud #\x7f~9\'a}$b\x7fN{|d~\x7fW{xw~v9gf<nl|\x1d\x03HBRDUDZ@Z_\x16[AFT\x19\x1aUA[UCQVT\x13\x15FZP#4/&*1h(8,$cev* 3$?6:!x374;22`y$\x1b\\B\n\x10K\x02\b\x05\b\x03\x05L\x10\x13HK\x15\x1d\x10\x01\x18\x13\x19\fW\x1e\x1e\x0f\t\f\x10y)+8y,..!+*pw2sr.-=zrgwz}\'\x10\'3ywi\x1e+')
      }),CKFinder.define(S("\x0eL[W{}ppd8Uv~npxm0fNPNqUJHIM\x05}EHY\\\x1fdB_[TRqQU_}SOSi)$5"), [S("\x12fzqsekzuiy"), S('A\x01\b\x02,(#-;e\x1e8$"`\x1b4+\x10;13'), S("\x0fSZTzzqse7Os~kn1]ARG\fmQCJ~@O\\"), S('\x1ci{gT\0ahbLHCM[\x05\x7fI@^CQEW@\x1b`F[WX^}UQ[y/3/l\x115*()-\f" (\b "<|7;!')], function (t, n, e, i) {
        "use strict";
        return e.extend({
          name: S("\x1aNlqq~DgKOAcIUE"),
          template: i,
          className: S("7[R\\\x16IMRP!%o%+7+"),
          attributes: {tabindex: 20},
          ui: {
            cancel: S("'J\\^_CCu[IAW\x0e\x16WCCLVT\x19a"),
            input: S("\x1ctpoUUyW]UC\x1a\nOCGI\x0fs"),
            submit: S("/RDFG[[mCAI_\x06\x1eNK]-(6a\x19"),
            form: S("\x11t|fx")
          },
          events: {
            "click @ui.cancel": function () {
              this.destroy()
            }, submit: function () {
              this.trigger(S("A16&(/3"))
            }, click: function (e) {
              e.stopPropagation()
            }, "keydown @ui.input": function (e) {
              e.keyCode === n.left && (this.ui.submit.focus(), e.stopPropagation()), e.keyCode === n.right && (e.stopPropagation(), this.ui.cancel.focus())
            }, "keydown @ui.cancel": function (e) {
              e.keyCode === n.left && (e.stopPropagation(), this.ui.input.focus()), e.keyCode === n.right && (e.stopPropagation(), this.ui.submit.focus())
            }, "keydown @ui.submit": function (e) {
              e.keyCode === n.left && (e.stopPropagation(), this.ui.cancel.focus()), e.keyCode === n.right && (e.stopPropagation(), this.ui.input.focus())
            }, keydown: function (e) {
              e.keyCode !== n.tab || !this.finder.util.isShortcut(e, "") && !this.finder.util.isShortcut(e, S("!QKMCR")) ? (e.keyCode !== n.right && e.keyCode !== n.home || this.ui.input.focus(), e.keyCode !== n.left && e.keyCode !== n.end || this.ui.submit.focus()) : this.finder.request(this.finder.util.isShortcut(e, "") ? S("\x16qwzoh&s{gT") : S("=XP#41y47#1"), {
                node: this.$el,
                event: e
              })
            }
          },
          templateHelpers: function () {
            var e = this.finder.request(S("(OEGHH\\\x15WTFrWA_A]"));
            return {
              ids: {iframe: t.uniqueId(S("\x11qxr8")), cid: this.cid, input: t.uniqueId(S("(JAM\x01"))},
              domain: "",
              isCustomDomain: !1,
              url: this.finder.request(S("\x1e|OLOBJA\x1cRZE"), {
                command: S("\x19\\rpxKoLNCG"),
                folder: e,
                params: {asPlainText: !0}
              }),
              ckCsrfToken: this.finder.request(S("D&55.s-.8\x19!$5?"))
            }
          },
          onShow: function () {
            var e = this;
            -1 < navigator.userAgent.toLowerCase().indexOf(S("-Z]YUW]@\x1a")) || this.finder.config.test || this.ui.input.trigger(S("\x1c~rvCJ"));
            var i = this.$el.find(S("4\\PEYT_"));
            i.load(function () {
              var t = i.contents().find(S("@#-'=")).text();
              if (t.length) {
                var n;
                try {
                  n = JSON.parse(t)
                } catch (e) {
                  n = {error: {number: 109, message: t}}
                }
                e.trigger(S('"VTIIFL\x13XN_]AACT'), {response: n, rawResponse: t})
              }
            })
          }
        })
      }),CKFinder.define(S("&dcoCEHH\\\0}^VFXPE\x18~VHViMRP!%m\x05+7+\x128%%*("), [S("!WM@@TTKFXN"), S('-mdvX\\WQG\x19zW]OWYN\x11y/3/\x164))&,f\x1c"):=`\x05!><51\x10>4<\x1c4.0\b6\x05\x16')], function (e, n) {
        "use strict";
        return function (r) {
          var t;

          function o() {
            t && t.destroy(), t = null
          }

          r.hasHandler(S("\x0fea~|uq")) || (r.on(S("*[MJK\x15SCWR@P\fzYPT"), function () {
            r.request(S("\x0e\x7fqvw)uqrE}~str"), {
              page: S("\x12^u|x"),
              name: S("+Y]B@QU"),
              id: e.uniqueId(S("'KBL\x06")),
              priority: 20
            })
          }), r.setHandler(S("&RXEEJH"), function () {
            (t = new n({finder: r})).on(S("/CDP^]A"), function () {
              var e = {name: S("?\x06(.&\x115*()-")};
              r.fire(S('>\\/,/"*!|%-/%9)'), e, r), r.fire(S("\x0el\x7f|\x7frzq,u}\x7fuiy'XvLDwSHJGC"), e, r), r.request(S("#HJGCM[\x10XDBY"), {text: r.lang.upload.progressLabel + " " + r.lang.common.pleaseWait})
            }), t.on(S("=KO,.#'~7#48&$8)"), function (e) {
              var n = e.response, t = !!n.uploaded;
              o(), r.request(S("\x1drpAEGQ\x1eMOCM"));
              var i = {name: S('E\0.$,\x1f; "/+'), response: n, rawResponse: e.rawResponse};
              n.error ? (r.fire(S('.L_\\_RZQ\fRJKUI\x06{WS%\x142/+$"'), i, r), r.request(S("\x1bxt\x7fsOF\x18JJCI"), {msg: n.error.message})) : r.fire(S("+OBCBQ_V\t[^\fqQU_nLQQ^$"), i, r), t && (r.once(S("8_UWXXL\x05'$6\x05-)#4r(,?)?"), function () {
                var e = r.request(S("9\\RPXM\x05'$6\x00174\"&=")).where({name: n.fileName});
                if (e.length) {
                  r.request(S("B%-)#4r:/').:"), {files: e});
                  var t = e[e.length - 1];
                  t.trigger(S("E (+<9"), t)
                }
              }), r.request(S("9\\TPY[Mz3'%6 5/\x0e &.?")))
            }), r.request(S("#TDAB\x12ZBD[d@}UV[\\Z"), {view: t, page: S("*fMD@"), region: S("\x0ez`}}rp")})
          }), r.on(S("\x15pxt}\x7fi&n{sEBVF@"), function (e) {
            t && !e.data.folder.get(S("4TU[")).fileUpload && o()
          }))
        }
      }),CKFinder.define(S('5u|~PT_YO\x11r/%7/!6i\x0f<$&~\x19=" 15}\x02!0#2'), [S("\vycjjbbq|fp"), S(" CC@OGIIM")], function (s, t) {
        "use strict";
        var n = {
          totalFiles: 0,
          totalBytes: 0,
          uploadedFiles: 0,
          uploadedBytes: 0,
          errorFiles: 0,
          errorBytes: 0,
          processedFiles: 0,
          processedBytes: 0,
          currentItemBytes: 0,
          currentItem: 0,
          isStarted: !1,
          lastUploaded: void 0
        }, e = function (e) {
          this.finder = e, this.state = new t.Model(n), this.items = []
        };

        function a(e, t) {
          e.items.length ? (e.state.set(S("\x13w`de}wnRhxs"), e.state.get(S(",N[]BT\\G}ASZ")) + 1), function (n, i, e) {
            var t = new XMLHttpRequest;
            n.set(S("-VGB"), t);
            var r = {name: S(".iY]WfDYYV\\")};
            if (!i.finder.fire(S("+OBCBQ_V\tVPPXJ\\"), r, i.finder) || !i.finder.fire(S("8ZUVQ\\P[z#'%+7#}\x0e &.\x19=\" 15"), r, i.finder)) return l(i, n, {}, e);
            t.upload && (t.upload.onprogress = function (e) {
              var t = e.position || e.loaded;
              n.set(S("D3'+=,"), Math.round(t / e.total * 100)), i.state.set(S("E%2:;/%8\x04:*=\x13+'1&"), t)
            });
            t.onreadystatechange = function () {
              4 === this.readyState && l(i, n, this, e)
            };
            var o = new FormData;
            t.open(S(".__BF"), e, !0), o.append(S("E37$&+/"), n.get(S("0W[_Q"))), o.append(S("\x0fszQ`fsBxs|t"), i.finder.request(S("=]L2'x$!1\x12(#,$"))), t.send(o)
          }(e.items.shift(), e, t)) : (e.state.set(S("\x0fsd`aq{b^l|w"), e.state.get(S("<IQK!-\x04*( 5"))), e.state.set(S("<TMl4 07!!"), !1), e.state.trigger(S("\x1fSUMS")))
        }

        function l(e, t, n, i) {
          var r = e.state, o = function (e, t, n, i) {
            var r = !1, o = {}, s = {name: S("\x1a]uq{JPMMB@")};
            t.responseType || t.responseText ? (e.processedFiles = e.processedFiles + 1, e.processedBytes = e.processedBytes + i) : (e.totalFiles = e.totalFiles ? e.totalFiles - 1 : 0, e.totalBytes = e.totalBytes ? e.totalBytes - i : 0, e.currentItem = e.currentItem ? e.currentItem - 1 : 0);
            if (t.responseText) try {
              r = JSON.parse(t.responseText)
            } catch (e) {
              r = {uploaded: 0, error: {number: 109, message: n.finder.lang.errors.unknownUploadError}}
            }
            r && (r.uploaded && (o.uploaded = !0, e.uploadedFiles = e.uploadedFiles + 1, e.uploadedBytes = e.uploadedBytes + i, e.lastUploaded = r.fileName), s.response = r, s.rawResponse = t.responseText, r.error ? (o.uploadMessage = r.error.message, r.uploaded ? o.isWarning = !0 : (o.isError = !0, o.state = S("\x1ezRSMQ"), o.value = 100, e.errorFiles = e.errorFiles + 1, e.errorBytes = e.errorBytes + i), n.finder.fire(S("\x1e|OLOBJA\x1cBZ[EY\x16kGCUdB_[TR"), s, n.finder)) : n.finder.fire(S("\x1b\x7frsrAOF\x19KN\x1caAEO~\\AANT"), s, n.finder));
            return {item: o, state: e}
          }({
            totalFiles: r.get(S("/D^FRXs_[]J")),
            totalBytes: r.get(S('"WKQGKjP^N_')),
            processedFiles: r.get(S("@10,' 54--\f\" (=")),
            processedBytes: r.get(S("!RQKFCT[LNiUYK\\")),
            errorFiles: r.get(S("\x1ezRSMQbLJB[")),
            errorBytes: r.get(S("\vi\x7f|`bSkgqf")),
            uploadedFiles: r.get(S(" TROKDBBLoCGI^")),
            uploadedBytes: r.get(S("B64))&,,.\t59+<")),
            currentItem: r.get(S("\x12pagdrvmSoyp")),
            currentItemBytes: 0
          }, n, e, t.get(S("&AAEO")).size);
          u(e, t), r.set(o.state), t.set(o.item), t.trigger(S("\x18}uuy")), a(e, i)
        }

        function u(e, t) {
          var n = s.indexOf(e.items, t);
          0 <= n && e.items.splice(n, 1)
        }

        return e.prototype.getState = function () {
          return this.state
        }, e.prototype.add = function (e) {
          var n = this, i = 0, r = 0, o = 0;
          s.forEach(e, function (e) {
            var t = e.get(S("*MEAK")).size;
            i += t, e.get(S("\ve~K}b~`")) ? (r += t, o += 1) : n.items.push(e)
          }), this.state.get(S("\x11{`Gawel|~")) ? this.state.set({
            totalFiles: this.state.get(S("(]E_MAhF\\TA")) + e.length,
            totalBytes: this.state.get(S("\x1ekOUCOf\\RB[")) + i,
            errorFiles: this.state.get(S("\x19\x7finrlYIMGP")) + o,
            errorBytes: this.state.get(S(")OY^B\\mIEW@")) + r,
            processedFiles: this.state.get(S(")ZYCNK\\CTVu]YSD")) + o,
            processedBytes: this.state.get(S(" QPLG@UTMMhRXH]")) + r
          }) : (this.state.set({
            totalFiles: e.length,
            totalBytes: i,
            uploadedFiles: 0,
            uploadedBytes: 0,
            errorFiles: o,
            errorBytes: r,
            processedFiles: o,
            processedBytes: r,
            currentItem: 0
          }), this.start())
        }, e.prototype.start = function () {
          this.state.get(S("+E^}[QCFVP")) || this.state.trigger(S("8JNZNI")), this.state.set(S("\x0efcBfrfass"), !0);
          var e = this.finder.request(S("\x1c~qrM@LG\x1ePTK"), {
            command: S('"eMICrXEEJH'),
            folder: this.finder.request(S(".I_]VVF\x0fQRLxYOUK[")),
            params: {responseType: S("@+1,*")}
          });
          a(this, e)
        }, e.prototype.cancelItem = function (e) {
          var t = e.get(S(".WXC"));
          if (t) t.abort(); else {
            u(this, e);
            var n = this.state, i = e.get(S("\x13r|zr")).size, r = n.get(S(")^DXLBiY]W@")),
              o = n.get(S("+XBZN\\sKGQF"));
            n.set({
              totalFiles: r ? r - 1 : 0,
              totalBytes: o ? o - i : 0
            }), n.get(S(")ZYCNK\\CTVu]YSD")) === n.get(S("\x1ekOUCObLJB[")) && n.trigger(S("\x14fbxh"))
          }
        }, e.prototype.cancel = function () {
          var e = this.items;
          this.items = [], s.forEach(e, function (e) {
            this.cancelItem(e)
          }, this), this.state.set(n)
        }, e
      }),CKFinder.define(S(";\x7fvxV.%'1k\b)#=%/8c\x05:\"<d\x07#8:73w\x145?91-p5\x11\x0e\f\x05\x01%\b\x04\x05\x0f\b\x18\x04\x01\x01"), [S("'JHI@NB@J")], function (e) {
        "use strict";
        return e.Collection.extend({
          comparator: function (e, t) {
            return e.get(S("(@YxY@CNBH")) ? -1 : t.get(S("C-6\x152%$+95")) ? 1 : 0
          }
        })
      }),CKFinder.define(S("6ts\x7fSUXXL\x10\r.&6( 5h\0=''y\x18>#?06|\x19:224*u\x0e,11>\x04(\x16\x06\t"), [S('7{r|RRY[Mo\x02-.)*(h\x05&.. >a\x1f">5!1&%\x1a7=?7')], function (e) {
        "use strict";
        return e.extend({defaults: {uploaded: !1, isError: !1, isWarning: !1, uploadMessage: ""}})
      }),CKFinder.define(S('\x1aoyej>cjdJJACU\x07}OF\\AO[UB\x1d{@XZ\x02mIVT]Y\x11j0--" \t/4<\0>.!c* $'), [], function () {
        return S('A~"d&*&;:wi/&(b%!><51{>,<7 \'b~6\x14O\x17\x13\b\n\x07\x03\r\rJMJMO\x06\x04_\x1b\x001\x07\x04\x18\n\x04\x07[\x1f\x16\x18Ruqnlea+n|lg&cfut/loho*6~l7shYolpR\x01_^\x04FMA\x05\\ZGCLJ\x02YEW^\x19PDEWKA@\x03@C\x1d~KK\x7f,vx<3hj"8c(&<4|=583w%$ft4n`Ui]\x06\n\x12E\x05\v\t\x1a\x19VN\x0e\x05\t]\x04\x02\x1f\x1b\x14\x12Z\b\v\x15\x1c\x0e\x18\r\f"?>,`lp9\x02\x006{,nbncb/1w~p:mivt}y3rERQBC@\x04\x19SR\x17\vEY\0Z@]]RPxSDKX]^\x1c@C\x03o1|Ixj\'yBu+k/!/<#lp0?3{"(55:8p7+\x05\fB\0\x0f\x03K\x12\x18\x05\x05\n\b@\x07\x1b\x15\x1c_\x11\x01\x01\x02\x18\x16\x02\x01D\\\x14\nQuqnleacc(/,+-dz!ybWafzd7ed:xw{3jPMMB@\bOSMD\x07DGVU\x10MLIH\v\x15_C\x16PI~NOQM`<?c\'. j=9&$-)c&$4?~1\'$8*"!d! |a\\N\x03]n')
      }),CKFinder.define(S("\x0eL[W{}ppd8Uv~npxm0hUOO\x11pVKGHN\x04zDKXC\x1egCXZWStPIOuI[R"), [S('C1+""::)$>('), S("3w~p^V]_I\x13kWZ72m\x01%6#h\x04(3$99\x18&5&"), S("!ahbLHCM[\x05hC@C@^\x1edZQBE\x18hKU\\NXML\x16('4"), S("\n\x7fiuz.SZTzzqse7M\x7fvlq\x7fkER\rkPHJ\x12}YFDMI\x01z@]]RPy_DLpN^Q\x13ZP4")], function (e, t, n, i) {
        "use strict";
        return t.extend({
          name: S("\x11GcxzwsTpioUi{r"),
          tagName: S("!NJ"),
          attributes: {"data-icon": S("\fnei=rs}wpz")},
          template: i,
          regions: {progress: S("9\x14XW[\x13J0--\" h65'.8.?>")},
          events: {
            "click .ckf-upload-item": function (e) {
              e.preventDefault(), this.trigger(S(':NLQQ^$l!"*&#+'))
            }
          },
          ui: {
            items: S("\x14t8ts\x7f7nlqq~D\fKWAH"),
            msg: S('\v"nei=db\x7f{tr:u|ih}z{'),
            split: S("6\x19[R\\\x16IMRP!%o*0 +j*<>?##")
          },
          modelEvents: {
            "change:uploaded": function () {
              this.setStatus(S("\x1bsv")), this.setHideIcon()
            }, "change:isError": function (e, t) {
              this.ui.msg.removeClass(S("\x15u|~4rrxy{q")).text(e.get(S("1GCXZWSu\\IH]Z["))), t && this.setStatus(S("\x17}khtn"))
            }, "change:isWarning": function () {
              this.ui.msg.removeClass(S("\fnei=y{wppx")).text(this.model.get(S("\x1bimrpAEoFWVG@M"))), this.setHideIcon()
            }
          },
          onRender: function () {
            this.setTitle(), this.progress.show(new n({
              finder: this.finder,
              model: this.model
            })), (this.model.get(S("-[_\\^SWQQ")) || this.model.get(S("\ve~K}b~`"))) && this.setHideIcon()
          },
          setStatus: function (e) {
            this.isDestroyed || this.ui.items.addClass(S("-MDV\x1cGCXZWS\x15PN^Q\x10") + e)
          },
          setHideIcon: function () {
            this.isDestroyed || (this.$el.attr(S('E"&<(g"/" '), S("1QXR\x18UVVZ_W")), this.ui.split.addClass(S("6BQ\x14SXSS\x13\\+'o %+%\"$")), this.setTitle())
          },
          setTitle: function () {
            var e = this.model.get(S("\x19okpr\x7f{EE")) || this.model.get(S("!KPaWTHZ")) ? this.finder.lang.common.close : this.finder.lang.common.cancel;
            this.isDestroyed || (this.ui.split.attr(S('A&"0$k$#/g?%9"*'), e), this.updateSplitTitle())
          },
          updateSplitTitle: function () {
            this.isDestroyed || this.ui.split.attr(S("(]C_@H"), this.ui.split.attr(S("\x14qwcy4ypz0jvTMG")))
          }
        })
      }),CKFinder.define(S('7L\\BO\x1d~uy)/&&6j\x12"%9&*8(=`\x18%??a\0&;78>t\t-20\x01\x05$\f\x16\bH\x03\x07\x1d'), [], function () {
        return S(")\x16OE[\x0eKQES\x1eFZZR\x05\x1bTZJ__Mba!/%65zj*!-a8>#?06~0'9'\"64>|(7r\x02\x0e\x06\x1aI\x1e\x1dZH\0\x1eE\x1f\x1a\x0f\x1b\x13\x19R\x0e\tWV\x03\x19\x1b\x13\x15\x18\x18\x06B\"32!:\x0f\x0f;l`|+oao|c,0f}8uxvm\x7fuh? \x15)(\x1eGMS\x06DDHYX\x11\x0fMDV\x1cGCXZWS\x15]HTLGQQ%l%1-!dyB@CBp)'9p2>2'&ku;2<v)-20\x01\x05O\x07\x16\n\x16\x1d\x07\x07\x0fF\v\x1f\x07\v]\x10PM~|\x7f~qE\n[\x15\x19C]{z?#mq(kikogEi.rm32pxted%;ypz0koLNCG\tVRF\\\\Y\t\x12VU\x12\x10XF\x1dXTXP\x16LJWS\\Z\x113$.&'1\0.$,9k10r` oXZ]\\_k(y97=.-bB\x02\t\x05I\x10\x16\v\x07\b\x0eF\x1c\x1f\x01\b\x02\x14\x01\0Y\x01\x13\x0f\f[Dqutwv\t=qsek&ddhyx1/mdv<gcxzws5iht{o{lS\fVF\\Q\vAAEOX\x0e\x13\x12\0CAS]\n\x15\nDHXT\x1b_Q_L3|` /#k28%%*(`>=?6 6'&{#=!.v>$*:\x13C\\_K\x16\x16\x06\x06W`bedgS_\x01Ly}|\x7fKW\x1d\x13\rBwwv\t=fjr%ekizy6.nei=db\x7f{tr:|kukfrpz\rFPJ@\bD\x05\x16##\"%$\x12F^AGG\x14AOG]\x04\x18YIIJP.cb7%'/),,2vn`\x7fmp53'5x?477gy?68r\x10\r\x17\x10FE\x02\x06\x1c\bG\b\x07\vC\r\x05\x05\x06\x1c\x1aHT\x16\x1c\x1dX[\n\x1c\x12\ne< x\x7f8&n|'fjbj z`}}rp;ws|_swyn>b]\x03\x1c)-,/.\x14@D[YY\x0e[IAW\x0e\x16WCCLVT\x19\x1cI_])/&&<xdjykj/-9/b92==iw5<>t9:2>;3BA\x06\x02\x10\x04K\x04\x03\x0fG\t\x19\x19\x1a\0\x1eLP\x10\x15\x1b\x15\x12\x14[Z\r\x1d\x11\v\x1a=#yx9%os&ekek#m`}|}}:vzxk|:fa? \x15)(+*\x18LHW]]\n_U]K\x12\x12SGG@ZX\x15\x18M[YUSZZ8|`nugf#)=+f%.!!ms182x22,837/\x7f~;\x01\x15\x03N\x07\x0e\0J\n\x1c\x1e\x1f\x03\x03SM\x14\x14\x06\x12\x1d\x19\x05UX\x0f\x1b\x17\t\x18C]{z?#mq(kigm%y}b`qu<wqaw~tj:fa? \x15)(+\x1f\vAOQ\x16##\"\x10\x02JFF\x0f8:=\tR^N\x19S_\x01\x1f]T&l73(*'#e98$+?+<#slo{1?!fSSR`97)@\x02\x0e\x02\x17\x16[E\v\x02\fF\x19\x1d\x02\0\x11\x15_\x1a\x1a\x05\x03\x03U\x0e\b\x1a\f_@Ciorvp%ekizy6.nei=db\x7f{tr:qwjnh?>kYQG\x1e\x06COKM\v\nFYAZF@]W\x0e\x16XC[LPJWY\x1f\0\x03o%+5zOO{g-#=rGr`48$m^")
      }),CKFinder.define(S("+ofhF^UWA\x1bxYSMU_H\x13uJR,t\x173(*'#g\x1f#.;>a\x1a ==20\x139%5"), [S("A7-  44+&8."), S("\x1fJPWFV\\"), S('A\x01\b\x02,(#-;e\x1e8$"`\x1b4+\x10;13'), S("\nHGKgatt`<B|s`k6Xzox1SAXMVPsOB_"), S("D\x06\r\x01!'..>b\x03 4$>6'z\x1e#55o\x0e,11>\x04N4\n\x01\x12\x15H=\x19\x06\x04\r\t\"\x06\x03\x05;\x07\x11\x18"), S("\x11fvla7TS_suxxl0tDOSHDRB[\x06b_AA\x1bz@]]RP\x1acGTV[_zRLRn%-7"), S("E\x05\f\x0e $/)?a\f?<?<:z\0>=.)t\f/18\x12\x04\x11\x102\f\x03\x10"), S("E\x05\f\x0e $/)?a\f?<?<:z\x1b8<<6(s\r,0\x07\x13\x07\x10\x17(\t\x03\r\x05")], function (e, n, t, i, r, o, s, a) {
        "use strict";

        function l(e) {
          var t;
          if (e.data) {
            if (!e.data.modeChanged) return;
            t = e.data.mode === S("!FFWNRHX")
          } else t = e === S("\x1dzzSJVLT");
          n([this.ui.cancelButton, this.ui.detailsButton, this.ui.addButton]).each(function () {
            this.parent().toggleClass(S("/EX\x1fQ@[\x1b^[VT\x16RRJZ85"), !t).toggleClass(S("\x13a|;ulw7r\x7frp2LDDW"), t)
          })
        }

        return i.extend({
          name: S("C\x115*()-\f$> "),
          template: o,
          ui: {
            input: S(" \x0fAHB\bSWDFKO\x01D@_EE"),
            dropZone: S("'\x06JAM\x01X^C_PV\x1ePGYGBVT^"),
            addButton: S("%}CI]K\x06OFH\x02RDFG[[\v\x15Y]^\x19a"),
            cancelButton: S("\x15Msym{6\x7fvx2BTVWKK\x1b\x05KHDHIA\fr"),
            detailsButton: S('4nRVLX\x17XW[\x13]556,*xd#-=+" >l\x12'),
            status: S('\n%ofh"ea~|uq;dlxnno'),
            progressText: S(".\x01SZT\x1eAEZXY]\x17KNRYM%21n0 >3"),
            progressTextFiles: S("\f#mdv<gcxzws5iht{o{lS\fVF\\Q\vAAEOX"),
            progressTextBytes: S("\x1b2~uy\rTROKDB\nX[EL^H]\\\x1dEWK@\x18TNL\\I")
          },
          regions: {progress: S(';\x1f^UYm42/+$"j8;%,>(=<')},
          events: {
            "click @ui.input": S("\x12`qaEcymohOxrzCU"), click: function (e) {
              e.stopPropagation()
            }, selectstart: function (e) {
              e.preventDefault()
            }, "keydown @ui.addButton": function (e) {
              e.keyCode === (this.finder.lang.dir === S("6[LK") ? t.left : t.right) && (this.ui.addButton.focus(), e.stopPropagation()), e.keyCode === (this.finder.lang.dir === S("1^GF") ? t.right : t.left) && (e.stopPropagation(), this.ui.cancelButton.focus())
            }, "keydown @ui.cancelButton": function (e) {
              e.keyCode === (this.finder.lang.dir === S("\x10}fa") ? t.left : t.right) && (e.stopPropagation(), this.ui.addButton.focus()), e.keyCode === (this.finder.lang.dir === S("\x12\x7f`g") ? t.right : t.left) && (e.stopPropagation(), this.isDetailsEnabled ? this.ui.detailsButton.focus() : this.ui.cancelButton.focus())
            }, "keydown @ui.detailsButton": function (e) {
              e.keyCode === (this.finder.lang.dir === S("3XAD") ? t.left : t.right) && (e.stopPropagation(), this.ui.cancelButton.focus()), e.keyCode === (this.finder.lang.dir === S("%JSZ") ? t.right : t.left) && (e.stopPropagation(), this.ui.detailsButton.focus())
            }, "keydown @ui.dropZone": function (e) {
              e.keyCode !== (this.finder.lang.dir === S("\x14ybe") ? t.right : t.left) && e.keyCode !== t.home || this.ui.addButton.focus(), e.keyCode !== (this.finder.lang.dir === S("\x14ybe") ? t.left : t.right) && e.keyCode !== t.end || (this.isDetailsEnabled ? this.ui.detailsButton.focus() : this.ui.cancelButton.focus())
            }, "focus @ui.dropZone": function (e) {
              e.target === this.ui.dropZone.get(0) && this.trigger(S('\x12u{vcd"zr~\x7fv$lCSMOH'))
            }
          },
          templateHelpers: function () {
            return {swatch: this.finder.config.swatch}
          },
          initialize: function () {
            this.listenTo(this.model, S("D&.&&./"), this.updateView), this.finder.on(S("(\\C\x11^H]FJT"), l, this), this.progressModel = new a, this.progressModel.stateIndeterminate()
          },
          onRender: function () {
            this.isDetailsEnabled = !1, this.$el.enhanceWithin(), l.call(this, this.finder.request(S("\x1ejI\x1bEFPhICM"))), this.disableDetailsButton(), this.progress.show(new s({
              finder: this.finder,
              model: this.progressModel
            }))
          },
          updateView: function () {
            this.ui.progressTextBytes[0].innerHTML = this.formatBytes(this.model.get(S('C47)$-:9.(\x0f7;5"')) + this.model.get(S("=]J23'-0\f2\"%\v3?)>"))), this.ui.progressTextFiles[0].innerHTML = this.formatFiles(this.model.get(S("?#401!+2\x0e<,'"))), this.setStatusProgress(100 * (this.model.get(S("E65'*/8?(*\r)%7 ")) + this.model.get(S("\x1axiolzNUkWAHd^\\LY"))) / this.model.get(S("6CWM[W~DJZ3"))), e.isUndefined(this.model.changed.isStarted) || this.model.changed.isStarted || (this.model.get(S("9_INRLy)-'0")) ? this.setStatusError() : this.setStatusOk())
          },
          formatBytes: function (e) {
            return this.finder.lang.upload.bytesCountProgress.replace(S(";G_GK%2\x173(*'#--7"), this.finder.lang.formatFileSize(e)).replace(S("0JPJ@PEcWM[WA"), this.finder.lang.formatFileSize(this.model.get(S("A6,0$*\x051=/8"))))
          },
          formatFiles: function (e) {
            return this.finder.lang.upload.filesCountProgress.replace(S("\x18b|rpxmJPMMB@@BZ"), e).replace(S("0JTZXPEcWM[WA"), this.model.get(S("\x16cwm{wZtrzS")))
          },
          onDestroy: function () {
            this.finder.removeListener(S("%SN\x12[OXEWK"), l)
          },
          setProgressbarValue: function (e) {
            this.progressModel.set(S("\x12euycr"), e), 100 == e && this.model.get(S("=[M2.0\x05-)#4")) ? this.progressModel.stateError() : 100 <= e ? this.progressModel.stateOk() : this.progressModel.stateIndeterminate()
          },
          showProgressText: function () {
            this.ui.progressText.css(S("8]SHLQ_F"), "")
          },
          hideProgressText: function () {
            this.ui.progressText.css(S("A&*75*&1"), S("5XXV\\"))
          },
          setStatusText: function (e) {
            this.ui.status.html(e)
          },
          setStatusSelect: function () {
            this.setStatusText(this.finder.lang.upload.selectFiles), this.setProgressbarValue(0), this.hideProgressText()
          },
          setStatusProgress: function (e) {
            this.setStatusText(this.finder.lang.upload.progressMessage), this.setProgressbarValue(e), this.showProgressText()
          },
          setStatusOk: function () {
            this.setStatusText(this.finder.lang.upload.success), this.setProgressbarValue(100), this.showProgressText()
          },
          setStatusError: function () {
            this.setStatusText(this.finder.lang.errors.uploadErrors), this.setProgressbarValue(100), this.showProgressText()
          },
          showUploadSummary: function () {
            this.ui.progressTextFiles[0].innerHTML = this.finder.lang.upload.summary.replace(S("#_FIRF]W"), this.formatFiles(this.model.get(S(";IMRP!%''\x02,*\";")))), this.ui.progressTextBytes[0].innerHTML = this.formatBytes(this.model.get(S("8LJWS\\ZZ$\x03;7!6")))
          },
          enableDetailsButton: function () {
            this.ui.detailsButton.button(S("\x11w}uwzr")).attr(S("E'5!(g/%>/-<46"), S("5PVTJ_")), this.isDetailsEnabled = !0
          },
          disableDetailsButton: function () {
            this.ui.detailsButton.button(S("\noe~om|t")).attr(S("/QC[R\x19Q_DY[V^X"), S("B760#")), this.isDetailsEnabled = !1
          },
          cancelButtonAsCancel: function () {
            this.ui.cancelButton.val(this.finder.lang.common.cancel).button(S("\x1bnxxmERJ"))
          },
          cancelButtonAsClose: function () {
            this.ui.cancelButton.val(this.finder.lang.common.close).button(S('E4".;/8$'))
          }
        })
      }),CKFinder.define(S("\x1bhxfk\x01bieMKBBZ\x06~NA]BNDTA\x1c|A[[\rlJWS\\Z\x10\x151.,%!\n.;=\x19>! /=)\x7f6< "), [], function () {
        return S('%\x1aCA_\nH@L]\\\r\x13QXR\x18CGTV[_\x11TJZ-a!("h37$&+/a$:*=|=8t ?z:-4ybWWc\x10A\x01\x0f\x05\x16\x15ZJ\n\x01\rA\x18\x1e\x03\x1f\x10\x16^\x19\x10\x05\x04\x19\x1e\x1fYB\x06\x05B hv-qujhimGn\x7f~ohu1on(:f)\x12%5\x7fuk \x15')
      }),CKFinder.define(S("\fNEIy\x7fvvf:[x|lv~o2VkMM\x17vTIIFL\x06|BIZ]\0eA^\\UQz^KMiNQP_M9"), [S("\x1aXW[wqDDP\frLCP[\x06hJ_H\x01fDT_e]PA"), S("\x14asol8YPZtp{ES\rwAHVKI]OX\x03eZB\\\x04gCXZWS\x17lJWS\\Zs)26\x101(+&:0d/#9")], function (e, t) {
        "use strict";
        return e.extend({
          name: S("'}YFDMIbFCEaFYXWEA"),
          tagName: S("*GE"),
          attributes: {"data-icon": S("@'#/7 ")},
          className: S("\x0el{w?fdyyv|4inqp\x7fmY"),
          template: t,
          modelEvents: {"change:uploadMessage": S("\x17j|t\x7fyo")}
        })
      }),CKFinder.define(S("\nHGKgatt`<Yzrbt|i4Tiss\x15tROKDB\b~@O\\_\x02{_\\^SWx\\EC"), [S("\x13W^P~v}\x7fi3KwzWR\raEVC\bkFFGINZF__dZQB"), S('\x17[R\\rry{m\x0flMGQICT\x07a^F@\x18{_\\^SW\x1bc_ROJ\x15nLQQ^$\r+00\f2"%'), S("\x18ZQ]uszzR\x0eoL@PJB[\x06b_AA\x1bz@]]RP\x1a`^]NI\x14iMRP!%\x0e*71\x152%$+95")], function (e, t, n) {
        "use strict";
        return e.extend({
          name: S("\x14@f{wx~Wunj"),
          template: "",
          tagName: S("\x16bt"),
          className: S("$FMA\x05\\ZGCLJ\x02\\XAG"),
          attributes: function () {
            return {"data-role": S("\x1fLHQWRLCP"), "data-split-theme": this.finder.config.swatch}
          },
          initialize: function () {
            this.on(S("+MYZNSYpFRSSE"), t, this), this.on(S("\x1e|HHNGRLCP\x12[OEHH\\"), t, this);
            var e = this;

            function t() {
              setTimeout(function () {
                e.$el.listview().listview(S("\r|jvcw`|")), e.updateChildrenSplitTitle()
              }, 0)
            }
          },
          getChildView: function (e) {
            return e.get(S("(@YxY@CNBH")) ? n : t
          },
          updateChildrenSplitTitle: function () {
            this.children.forEach(function (e) {
              e.updateSplitTitle && e.updateSplitTitle()
            })
          }
        })
      }),CKFinder.define(S("#gn`NFMOY\x03`AKE]W@\x1b}BZT\foKPR_[o\t6.(p\x137$&+/"), [S("\x1anry{mSBMQA"), S("D\x06\r\x01!'..>b\x03 4$>6'z\x1e#55o\x0e,11>\x04N3\x16\x01\x10\x03"), S("=}t\x06(,'!7i\n'-?')>a\x07$<>f\x01%:89=u\x1639;3\x13N7\x13\b\n\x07\x03+\x06\x06\x07\t\x0e\x1a\x06\x1f\x1f"), S('%eln@DOI_\x01b_UG_QF\x19\x7fLTV\x0eiMRP!%m\x0e+!#+;f\x1f; "/+\x19%7>'), S('A\x01\b\x02,(#-;e\x06#);#5"}\x1b 8:b\r)64=9q\t\t\x04\x15\x10K0\x16\v\x07\b\x0e-\x03\x1f\x03'), S("!ahbLHCM[\x05fCI[CUB\x1d{@XZ\x02mIVT]Y\x11i)$50k\x106+'(.\x07%>:"), S("\x0eL[W{}ppd8Uv~~pn1YIMG")], function (_, x, E, h, M, F, g) {
        "use strict";
        var I, R, T, O, B;

        function P(e) {
          var t, n, i;
          for (i = "", t = S("\x14$$$,,,,$$_]cegecmllddd{}\x7f}{egekmo"), n = 0; n < e.length; n++) i += String.fromCharCode(t.indexOf(e[n]));
          return P = void 0, i
        }

        var p = 203, v = 105;

        function A(e, i, r, o) {
          var s = [];
          if (e.length) {
            var t, a = o.request(S("?&..'!7| -=\v(8$8*")).getResourceType(), l = a.get(S("=S^8\x12+9!")),
              u = o.config.initConfigInfo.uploadCheckImages;
            if (o.util.asyncArrayTraverse(e, function (e) {
              var t = new h({file: e, state: S(";SV"), value: 0}), n = g.extensionFromFileName(e.name).toLowerCase();
              (!g.isExtensionOfImage(n) || u) && e.size > l && f(t, p), a.isAllowedExtension(n) || f(t, v), t.on(S(",NFN^VW\tAEZXY]__"), function (e) {
                e.get(S(" HQtEWHNFN")) || i.remove(e), i.summary || (i.summary = new h({
                  isSummary: !0,
                  uploadMessage: ""
                }), i.add(i.summary)), i.summary.set(S("$PVKGHNfI^]NWT"), o.lang.upload.summary.replace(S("C?&)2&=7"), r.state.get(S("&RXEEJHHJiY]W@"))))
              }), s.push(t)
            }), !(I && O && R && ((t = B(5) - B(1)) < 0 && (t = B(5) - B(1) + 33), t - 5 <= 0)) || T) {
              var n = o.request(S("\x17~pv~o'yzTbWQV@HS")).where({"view:isFolder": !1}).length, c = {};
              c[S("'EZM")] = [S(",kU^"), S("\x1b`{ghSD"), S("\x1afi"), S("9NADM["), S("\x12qbs"), S("<IBG12'"), S(";OH^O$"), S("\rhta"), S("\fjmwjfa"), S("\x1enR[YZG"), S("C3.17;:"), S(".\f\x13"), S("'ST"), S("\x19lmeg"), S("%Y[XY\x12")][S("\x1ds~P")](function (e) {
                for (var t = "", n = 0; n < e.length; ++n) t += String.fromCharCode(e.charCodeAt(n) ^ n + 18 & 255);
                return t
              })[S("+FBGA")](" "), n + s.length > S("\x17))") && o.request(S("\x0ftxs\x7f{r,~v\x7fu"), c);
              var d = -(n - S("\x0e> "));
              d < 0 && (d = 0), s.splice(d, s.length)
            }
            r.state.get(S("!KPwQGU\\LN")) || (i.summary && (i.summary = null), i.reset()), i.add(s), r.add(s)
          }

          function f(e, t) {
            e.set({
              state: S("\fh|}\x7fc"),
              isError: !0,
              uploadMessage: o.lang.errors.codes[t],
              value: 100,
              uploaded: !0
            })
          }
        }

        function t(e) {
          var t = e.data.view, n = e.finder;
          t.once(S("\x16e}w~~n"), function () {
            var e = t.$el;
            e.on(S("%BUINE]I_"), function (e) {
              e.preventDefault(), e.stopPropagation()
            }), e.on(S("-J]_A"), function (e) {
              e.stopPropagation(), e.preventDefault();
              var t = e.originalEvent.dataTransfer.files;
              t.length && n.request(S("B64))&,"), {files: t})
            })
          })
        }

        return function (u) {
          var c, h, g, e, p, v, m = !1;

          function w() {
            u.removeListener(S("\x14ewy}u tlxp%HUOO\x11PVKGHN"), y), u.removeListener(S("._Q_W_\x0eVZXK\\\0SHPR\n51.,%!"), C), c && c.cancel(), c = null, h && h.destroy(), h = null, g && g.destroy(), g = null, e && e.destroy(), e = null, b(), u.request(S("=N^.$.y  53:&3"), {name: S("%NSEE\x1f^\\AANT")}), v = null
          }

          function y() {
            v && v.$el.find(S("\x1eDD@VB\tFMA\x05[EGI\x10\fL\\^AVdTXRT\x1bg")).focus(), b(), m = !0
          }

          function C() {
            h && (h.isDetailsEnabled ? h.ui.detailsButton.focus() : h.ui.cancelButton.focus()), m = !1
          }

          function b() {
            p && clearTimeout(p), p = null
          }

          (function () {
            var e = new XMLHttpRequest;
            return !!window.FormData && !!e && !!e.upload
          })() && (u.on(S("D5' -s)9),:*j\x1c3::"), function () {
            u.request(S("6GY^_\x01]YZm%&+,*"), {
              page: S("*fMD@"),
              name: S('>J0--" \x03/+-:'),
              id: _.uniqueId(S("\fnei=")),
              priority: 20
            })
          }), u.on(S('6AQ\\M\x01hUKR"/#*(6\x10.->'), t), u.on(S("E0.->p\x07%>:\x1994%"), t), u.on(S("\x0eyyte)Wz{gyznMuxi"), t), u.on(S("\vjbbkuc(`qystl|~"), function (e) {
            e.data.folder.get(S("%GDD")).fileUpload || w()
          }), u.setHandler(S("/EA^\\UQ"), function (e) {
            var t;
            b(), B = B || (t = P(u.config.initConfigInfo.c), function (e) {
              return t.charCodeAt(e)
            });
            var n = u.request(S('>Y/-&&6\x7f!"<\b)?%;+'));
            if (n) if (R = function (e, t) {
              for (var n = 0, i = 0; i < 10; i++) n += e.charCodeAt(i);
              for (; 33 < n;) for (var r = n.toString().split(""), o = n = 0; o < r.length; o++) n += parseInt(r[o]);
              return n === t
            }(u.config.initConfigInfo.c, B(10)), n.get(S("4TU[")).fileUpload) {
              m = !1;
              var i = new E;
              i.summary = null;
              var d, f, r, o, s, a, l = (c = new x(u)).getState();
              i.on(S("!PFW@R"), function () {
                h.disableDetailsButton(), i.once(S("(HNO"), function () {
                  h.enableDetailsButton()
                })
              }), d = function (e) {
                for (var t = "", n = 0; n < e.length; ++n) t += String.fromCharCode(e.charCodeAt(n) ^ 255 & n);
                return t
              }, f = 92533269, T = !function (e, t, n, i, r, o) {
                for (var s = window[d(S("\x12Wtcp"))], a = n, l = o, u = 33 + (a * l - (u = i) * (c = r)) % 33, c = a = 0; c < 33; c++) 1 == u * c % 33 && (a = c);
                return (a * o % 33 * (u = e) + a * (33 + -1 * i) % 33 * (c = t)) % 33 * 12 + ((a * (33 + -1 * r) - 33 * ("" + a * (33 + -1 * r) / 33 >>> 0)) * u + a * n % 33 * c) % 33 - 1 >= (l = new s(1e4 * (203623794 ^ f)))[d(S("#CAPbY@@uAEV"))]() % 2e3 * 12 + l[d(S("#CAPiCBXD"))]()
              }(B(8), B(9), B(0), B(1), B(2), B(3)), l.on(S(".\\DP@G"), function () {
                h.cancelButtonAsCancel()
              }), l.on(S("(Z^D\\"), function () {
                u.once(S(" BMNIDHC\x12HL_I_\x14hUEtZXPE"), function () {
                  var e = u.request(S(" GKOAV\x1c@M]i^^_KAD")).where({name: l.get(S("\x0ecqbfFdyyv||~"))}).pop();
                  e && e.trigger(S("\x1eyOBWP"), e)
                }), h.cancelButtonAsClose(), h.showUploadSummary(), u.request(S("\x1a}sqzzR\x1bPFBWCT@oCGI^"));
                var e = !_.isBoolean(u.config.autoCloseHTML5Upload) || u.config.autoCloseHTML5Upload;
                l.get(S("&SG]KGjDBJC")) === l.get(S('C15*()-//\n$"*#')) && !m && e && (b(), p = setTimeout(w, 1e3 * parseFloat(u.config.autoCloseHTML5Upload || 0)))
              }), l.on(S("\x19ys}syz\x1aHQpPDTSMM"), function () {
                l.get(S("9SHoI_M4$&")) && b()
              }), O = function (e, t, n) {
                var i = 0,
                  r = (window.opener ? window.opener : window.top)[S("&KGJK_EB@")][S("0Y]@@[WZ]")].toLocaleLowerCase();
                if (0 === t) {
                  var o = S("\x1eAWVU\x7f\n");
                  r = r.replace(new RegExp(o), "")
                }
                if (1 === t && (r = 0 <= ("." + r.replace(new RegExp(S("\x1d@hWV~\r")), "")).search(new RegExp(S("\x13H;") + n + "$")) && n), 2 === t) return !0;
                for (var s = 0; s < r.length; s++) i += r.charCodeAt(s);
                return r === n && e === i + -33 * parseInt(i % 100 / 33, 10) - 100 * ("" + i / 100 >>> 0)
              }(B(7), (r = B(4), o = B(0), (s = r - o) < 0 && (s = r - o + 33), s), u.config.initConfigInfo.s), u.on(S("\x12cu{s{\"vj~r'vkMM\x17VTIIFL"), y), u.on(S("3DTXRT\x03YWSN[\x05(5//q06+'(."), C), a = B(4) - B(0), B(4), B(0), a < 0 && (a = B(4) - B(0) + 33), I = a < 4, (g = new F({
                collection: i,
                finder: u
              })).on(S('8ZRRPYHV%6x64))&,d)*".+#'), function (e) {
                e.model.get(S("\x1ejPMMB@@B")) || e.model.get(S("\x1aroXlmOS")) || c.cancelItem(e.model), g.removeChildView(e), g.children.length || (h.disableDetailsButton(), u.request(S(";L\\PZ,{!/+6#"), {name: S("<UJR,t73(*'#")}))
              }), g.on(S("\f\x7fkatt`"), function () {
                g.$el.trigger(S("']YNJXHBNI^GG"))
              }), l.set(S("D)'%-%\x03/"), _.uniqueId(S("\x15u|~4vz~xr2"))), h = new M({
                finder: u,
                model: l,
                events: _.extend({}, M.prototype.events, {
                  "click @ui.destroyButton": w,
                  "click @ui.cancelButton": w,
                  "click @ui.addButton": function () {
                    b(), h.ui.input.trigger(S("\x17{usxw"))
                  },
                  "change @ui.input": function (e) {
                    b(), A(e.dataTransfer && e.dataTransfer.files || e.target.files || [], i, c, u)
                  },
                  "dragover @ui.dropZone": function (e) {
                    e.preventDefault(), e.stopPropagation()
                  },
                  "drop @ui.dropZone": function (e) {
                    e.stopPropagation(), e.preventDefault(), b(), A(e.originalEvent.dataTransfer ? e.originalEvent.dataTransfer.files : [], i, c, u)
                  },
                  "click @ui.detailsButton": function () {
                    v || (v = u.request(S("\x0f`p|vx/ue}xn~"), {
                      name: S("6_LTV\x0eIMRP!%"),
                      position: S("\nxinaatp`j"),
                      closeButton: !0,
                      view: g,
                      panelOptions: {positionFixed: !0, display: S("\x10~dvfywn")}
                    })), u.request(S("?0 ,&(\x7f2(/.&."), {name: S("\x1ashpr*UQNLEA")}), g.$el.listview().listview(S("\x1bnxxmERJ"))
                  }
                })
              }), e && e.files || h.on(S("%UOG^"), function () {
                h.ui.dropZone.focus(), u.config.test || h.ui.input.trigger(S("+OAGL["))
              }), u.request(S(",]OHU\vA[[B\x7fYj\\]RSS"), {
                view: h,
                page: S("=s^)/"),
                region: S("*^\\AANTw[_QF")
              }), e && e.files && A(e.files, i, c, u)
            } else u.request(S("5R^YUU\\\x06TPY/"), {msg: u.lang.errors.uploadPermissions}); else u.request(S(",IGN\\^U\t][PX"), {msg: u.lang.errors.noUploadFolderSelected})
          }))
        }
      }),CKFinder.define(S("'kblBBIK]\x1f|]WAYSD\x17r_BpTMK%/'1k\x0e#>\x04 9?)#+="), [S("\fx`kucap{gs"), S("\rd~et`j")], function (r, e) {
        "use strict";
        return function (n) {
          this.finder = n;
          var i = {};
          e(S("B!+!?")).on(S(".DUHV\\C["), function (e) {
            var t = e.keyCode;
            r.has(i, t) && n.fire(S(" JGZ@JQI\x12") + t, {evt: e}, n)
          }).on(S("@*':15"), function (e) {
            var t = e.keyCode;
            r.has(i, t) && n.fire(S("-EJIDB\t") + t, {evt: e}, n)
          }), n.setHandler(S("0ZWJ\x0eY_DL\\T"), function (e) {
            i[e.key] = !0
          }), n.setHandler(S("&LMP\x10GE^ZJ^\vAG[E"), function (e) {
            delete i[e.key]
          })
        }
      }),CKFinder.define(S('9ypzTP[%3m\x0e+!3+-:e\x07#,**"~\x1e<513%'), [S("$PHCM[YHC_K"), S("\x13~dcrj`")], function (r, o) {
        "use strict";
        return function (n) {
          function i() {
            n.config.loaderOverlaySwatch && o(S("\x0f3ryu9yyv||h6sk{mL@[")).remove()
          }

          (this.finder = n).setHandlers({
            "loader:show": function (e) {
              i(), o.mobile.loading(S("%UOG^"), {text: e.text, textVisible: !!e.text, theme: n.config.swatch});
              var t = n.config.loaderOverlaySwatch;
              t && o(S("2\x0fP\\@\x17Q]\x07\x19_VX\x12,.#'!7k(>,8'-4lo3=3 'ht\"1t*4,(.r\x13\x02\x10\x06\x01\vF\x0e\x06KTWC\t\x07\x19N")).addClass(S("?5(o,2 4+)0g") + (r.isBoolean(t) ? n.config.swatch : t)).appendTo(S("A , <")), o(S("\x187or1qq~DDP")).find(S("<U\x0f")).attr(S("\x12a{ys"), S('"BH@TS'))
            }, "loader:hide": function () {
              o.mobile.loading(S("(ACOI")), i()
            }
          })
        }
      }),CKFinder.define(S("\x11QXR|xs}k5VsyksER\rnE]OJASO\x04aLVF]XHV"), [S("%SILLXXOB\\J"), S("?*07&6<"), S("*IMNEM__W")], function (e, s, r) {
        "use strict";
        return function (n) {
          if (n.util.isPopup() || n.util.isModal() || n.util.isWidget()) {
            n.util.isPopup() || n.on(S("\x1bhrqsB@P\x19V@UB\\\x13gJEC\x14I_]VVF"), function (e) {
              var t = new r.Model({
                name: S("&jIQCFEWK"),
                type: S("(K__XB@"),
                alignment: S("/@C[^UGO"),
                priority: 30,
                icon: S(i ? "<^UYm,+--(/=-" : "\rmdv<\x7frl|{~b|"),
                label: i ? n.lang.common.minimize : n.lang.common.maximize,
                action: function () {
                  t.set(S("\x17~vyno"), !0), n.request(S(i ? "\x15{~vpwrfx" : "!OB\\LKNRL")), t.set(S("<Q_]%-"), i ? n.lang.common.minimize : n.lang.common.maximize), t.set(S("A+ ++"), S(i ? "3W^P\x1aUPTRQTDZ" : "7[R\\\x16Q\\FV-(8&"))
                }
              });
              e.data.toolbar.push(t)
            });
            var i = !1, e = function (e) {
              var t, n, i = window, r = window.parent, o = {};
              return t = e.util.isPopup() ? (n = function () {
                var e = o.popup;
                i.resizeTo ? i.resizeTo(e.width, e.height) : (i.outerWidth = e.width, i.outerHeight = e.height), i.moveTo(e.x, e.y), delete o.popup
              }, function () {
                o.popup = {
                  x: i.screenLeft || i.screenX,
                  y: i.screenTop || i.screenY,
                  width: i.outerWidth || i.document.body.scrollWidth,
                  height: i.outerHeight || i.document.body.scrollHeight
                }, i.moveTo(0, 0), i.resizeTo ? i.resizeTo(i.screen.availWidth, i.screen.availHeight) : (i.outerHeight = i.screen.availHeight, i.outerWidth = i.screen.availWidth)
              }) : e.util.isModal() ? (n = function () {
                r.CKFinder.modal(S("'E@DBADTJ"))
              }, function () {
                r.CKFinder.modal(S("\x0ebqi{~}os"))
              }) : (n = function () {
                o.frame && s(i.frameElement).css(o.frame), delete o.frame
              }, function () {
                s(r.document).css({
                  overflow: S("\x18qs\x7fxxp"),
                  width: 0,
                  height: 0
                }), o.frame = s(i.frameElement).css([S("\x17hvirhtqq"), S(">S%'6"), S("D1)7"), S("\x1aluyjw"), S("7P\\S\\TI")]), s(i.frameElement).css({
                  position: S("(OCSII"),
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  width: S("0\0\x02\x03\x11"),
                  height: S(":\n\f\r\x1b"),
                  "z-index": 9001
                }), r.scrollTo(0, 0)
              }), {min: n, max: t}
            }(n);
            n.setHandlers({
              maximize: function () {
                e.max(), i = !0, n.fire(S("\x16zyasvug{{"), null, n)
              }, minimize: function () {
                e.min(), i = !1, n.fire(S("\nfecgbykww"), null, n)
              }, isMaximized: function () {
                return i
              }
            })
          } else n.setHandlers({
            isMaximized: function () {
              return !0
            }
          })
        }
      }),CKFinder.define(S(",neiY_VVF\x1a`^]NI\x14~\\MZo\x05;-%(/$\x04(3$99\x18&5&"), [S("+F\\[JBH"), S("&RFMOY_NA]U"), S("\x12P_S\x7fy||h4Jt{hS\x0e`BW@\tkIPE^X{GJG")], function (a, r, e) {
        "use strict";
        return e.extend({
          createRegion: function (r) {
            var o = a(S("2\x0fP\\@\t")).attr(S("=W["), r.id).attr(S("\x1bx|j~\rBIE\tUTNG[C_U"), r.priority);
            r.className && o.addClass(r.className);
            var s = !1;
            this.ui.regions.find(S("\x1f{ECWE\bELN\x04ZYEB\\FDHo")).each(function (e, t) {
              if (!s) {
                var n = a(t), i = n.data(S("\nhgk#\x7fbx}a}ao"));
                r.priority <= i && (n.before(o), s = !0)
              }
            }), s || this.ui.regions.append(o), this.addRegion(r.name, {selector: "#" + r.id, priority: r.priority})
          }, getFirstRegion: function () {
            var t, n = this.$el.find(S("\x18B~zh|3|KG\x0fSVLIUA]Sv")).toArray(), i = {};
            return this.regionManager.each(function (e) {
              i[r.indexOf(n, e.$el.get(0))] = e
            }), r.forEach(i, function (e) {
              !t && e.hasView() && (t = e)
            }), t
          }
        })
      }),CKFinder.define(S("9N^DI\x1f|\v\x07+-  4h\x1c,'; ,:*#~\x02230%x\b8=>\x10<'0\x15\x15L\x07\v\x11"), [], function () {
        return S("@}&*2e%+):9vn.%)}!341x$2?055/}+6M\x02\r\r\x10\0\b\x13JI\x18\x04\0\bSM\x1d\x10\x1b\x1dVK|~D\x1d\x13\r\\\x1e\x12\x1esr?!gn`*ehce!\x7fkhy~|14qwcy4ypz0nmINPJP\\\x1b\x05\x1d\x19\b\x15\x10\x02JFF\x0f8\x0f\x1bQ_A\x063")
      }),CKFinder.define(S(";\x7fvxV.%'1k\b)#=%/8c\x1d/(5\"}\x05=0!$w\t;<9\x11?&\x0f\x14\x16"), [S("\x1anry{mSBMQA"), S("1XBAPDN"), S("\x12quv}uww\x7f"), S("\x1c^UYIOFFV\npNM^Y\x04nL]J\x1fuK]UX_TtXCTIIhV%6"), S("\x0e{uif2W^P~v}\x7fi3I{rPMCWAV\twINOX\x03}OHU}SJ[@B\x19\\VN")], function (r, o, e, t, n) {
        "use strict";
        return t.extend({
          name: S('C\x14$!"\x04(3$99'),
          template: n,
          className: S("&DCO\x07[MJK"),
          attributes: {"data-role": S("\x1eoAFG")},
          regions: {main: S("\x14;u|~4wzus3mEFKLJ")},
          ui: {regions: S("\x1d0|KG\x0fSEBC\nZLMBCC]")},
          childEvents: {
            show: function (t) {
              this.listenTo(t, S("\x1a}s~kl\x1aBJFGN\x1cTK[EG@"), function () {
                var e = this.getFirstRegion();
                e && e.currentView.cid === t.cid && (window.scrollY || window.pageYOffset) && window.scrollTo(0, 0)
              }, this)
            }
          },
          initialize: function () {
            var n = this;
            n.main.on(S("1A[[B"), function (e) {
              n.listenTo(e, S("+^H@KUC"), n.doAutoHeight), n.doAutoHeight()
            }), n.listenTo(n.regionManager, S("?!%&y6 !.''"), function (e, t) {
              t.on(S("A1++2"), function (e) {
                e._isRendered && n.doAutoHeight(), n.listenTo(e, S("1@VZQSE"), n.doAutoHeight), n.listenToOnce(e, S("<Y[L43-:"), n.doAutoHeight)
              })
            }), n.finder.on(S(">K/..!%7|$:,+?)"), i, n), n.finder.on(S("<IQP,##1~7#4-="), i, n), n.finder.on(S("\x10astq/e\x7fwn ") + n.getOption(S("*EM@K")), function () {
              n.doAutoHeight()
            }), n.finder.on(S("C1,|5-:#1)"), n.doAutoHeight, n)
          },
          onRender: function () {
            var e = this;
            this.$el.one(S(":XNX_K%"), function () {
              e.$el.removeAttr(S("\x13`tt~v}\x7fc"))
            }), this.finder.util.isWidget() && /iPad|iPhone|iPod/.test(navigator.platform) && (this.doIOSWidgetFix(), this.finder.on(S("\fxg5btaznp"), this.doIOSWidgetFix, this, null, 20))
          },
          doIOSWidgetFix: function () {
            this.$el.css(S("\x11\x7frl8~rq~ro"), this.finder.config._iosWidgetHeight + S("\x16g`")), this.$el.css(S("C)$>j? .?$"), this.finder.config._iosWidgetWidth + S("._H"))
          },
          onDestroy: function () {
            this.finder.removeListener(S("6CWVVY]O\x04\\2$#7!"), i), this.finder.removeListener(S("\rz`\x7f}prf/drk|n"), i), this.finder.removeListener(S("&RA\x13XN_DTJ"), this.doAutoHeight), this.finder.util.isWidget() && /iPad|iPhone|iPod/.test(navigator.platform) && this.finder.removeListener(S(")_B\x16_K\\YKW"), this.doIOSWidgetFix)
          },
          setAutoHeightRegion: function (e) {
            this.autoHeightRegion = e
          },
          doAutoHeight: function () {
            var i = this;

            function t(e) {
              var t = i.$el.find(e);
              t.length && t.toolbar().toolbar(S(",X^KQEWcURSgY]^RRZ"))
            }

            setTimeout(function () {
              o.mobile.resetActivePageHeight(), t(S("!yGEQG\nKBL\x06XBACRP@n")), t(S(" zFBPD\vUGEO\x16\x0eKA@DT@\x11i"));
              var e = i.regionManager.get(i.autoHeightRegion);
              if (e && e.currentView) {
                var n = i.calculateMinHeight();
                r.forEach(i.regionManager.without(e), function (e) {
                  var t = e.$el.outerHeight();
                  n -= t
                }), e.$el.css({"min-height": n + S("@1:")}), e.currentView.trigger(S("\x11\x7frl|{~b|"), {height: n})
              }
            }, 10)
          },
          calculateMinHeight: function () {
            var e = parseInt(getComputedStyle(this.el).getPropertyValue(S("\x10aswp|xp5muk"))),
              t = parseInt(getComputedStyle(this.el).getPropertyValue(S(" QCG@LH@\x05KE_XBC"))),
              n = parseInt(getComputedStyle(this.el).getPropertyValue(S("\x1aysozzR\fVLT\bQNL]B"))),
              i = parseInt(getComputedStyle(this.el).getPropertyValue(S('B!+7"":d($89!"}&;7 =')));
            return window.innerHeight - e - t - n - i
          }
        });

        function i(e) {
          e.data.page === this.options.name && this.doAutoHeight()
        }
      }),CKFinder.define(S('*hgkGATT@\x1cyZRBT\\I\x14l\\YZ3n\x12"# 5'), [S("5CY\\\\HH_RLZ"), S("%LV]LXR"), S('2p\x7fs_Y\\\\H\x14qRZJ,$1l\x14$!";f\x1c"):=`\x00056\x184/8--')], function (o, a, s) {
        "use strict";
        var l = S("5\fZW[SWY\x10N^'$!,*1'.&,8");

        function e(e) {
          this.finder = e, this.pages = {}, this.pageStack = [], this.started = !1
        }

        return e.prototype = {
          getHandlers: function () {
            var i = this;
            return a(S("A , <")).on(S("?0 %&'*(3) $.>/+)?#7;=13"), function (e, t) {
              var n = t.prevPage && !!t.prevPage.length && a(t.prevPage[0]).data(S(":XW[n^'$"));
              n && (i.finder.fire(S("\r~nwt({}qs"), {page: n}, i.finder), i.finder.fire(S("-^NWT\b[]QS\r") + n, i.finder))
            }).on(S("\x1dn~GDALJQGNFLXXDBY"), function (e, t) {
              var n = a(t.toPage[0]).data(S("=]T&\x11#$!"));
              i.currentPage = n, i.finder.fire(S("#TDAB\x12ZBD[\x17") + n, i.finder), i.finder.fire(S("\x1fP@EF\x1eVNH_"), {page: n}, i.finder)
            }), {
              "page:current": {callback: this.pageCurrentHandler, context: this},
              "page:create": {callback: this.pageCreateHandler, context: this},
              "page:show": {callback: this.pageShowHandler, context: this},
              "page:hide": {callback: this.pageHideHandler, context: this},
              "page:destroy": {callback: this.pageDestroyHandler, context: this},
              "page:addRegion": {callback: this.pageAddRegionHandler, context: this},
              "page:showInRegion": {callback: this.pageShowInRegionHandler, context: this}
            }
          }, setFinder: function (e) {
            this.finder = e
          }, pageCurrentHandler: function () {
            return this.getCurrentPage()
          }, pageDestroyHandler: function (e) {
            var t, n, i, r, o;

            function s() {
              i && (i.destroy(), n.fire(S('B3%"#},,9?>"7'), {page: e.name}, n), n.fire(S("9JZ[X\x04[%261+<|") + e.name, null, n), delete t.pages[e.name])
            }

            n = (t = this).finder, i = this.getPage(e.name), e.name === this.getCurrentPage() ? (a(l).one(S("\f}ohur}}`t\x7fy}kissj"), s), o = this.popPrevPage(), (r = this.getPage(o)) && this.showPage(r)) : s()
          }, pageHideHandler: function (e) {
            var t, n;
            e.name === this.getCurrentPage() && (t = this.popPrevPage(), n = this.getPage(t), this.showPage(n))
          }, pageCreateHandler: function (e) {
            var t = o.extend({}, e.uiOptions), n = this, i = e.name;
            if (!this.pages[i]) {
              var r = new s({
                finder: this.finder,
                name: i,
                attributes: o.extend({}, s.prototype.attributes, {"data-ckf-page": i}),
                className: s.prototype.className + (e.className ? " " + e.className : "")
              });
              e.mainRegionAutoHeight && r.setAutoHeightRegion(S("\rcny\x7f")), (this.pages[i] = r).render(), r.$el.attr(S("9^ZH\\\x13K($/&"), this.finder.config.swatch), r.$el.appendTo(S("2Q[QO")), this.started || (t.create = function () {
                a.mobile.initializePage(), n.started = !0
              }), r.$el.page(t), e.view && r.main.show(e.view), this.finder.fire(S("\x18i{|y'}mE@VF\x1e") + e.name, {}, this.finder)
            }
          }, pageShowHandler: function (e) {
            var t = this.getPage(e.name);
            if (t) {
              var n = this.getCurrentPage();
              n && n !== e.name && (this.pageStack.push(n), this.finder.fire(S("%VFOL\x10CEIK\x15") + n, null, this.finder)), this.showPage(t)
            }
          }, pageAddRegionHandler: function (e) {
            var t = this.getPage(e.page);
            return !!t && (t.createRegion({
              name: e.name,
              id: e.id,
              priority: e.priority ? e.priority : 50,
              className: e.className
            }), !0)
          }, pageShowInRegionHandler: function (e) {
            var t = this.getPage(e.page);
            t[e.region].show(e.view), t[e.region].$el.trigger(S(",N\\JQEW"))
          }, showPage: function (e) {
            a(l).pagecontainer(S("B ,$( -"), e.$el), this.currentPage = e.attributes[S("D!'3)d) *`>.74")], e.$el.trigger(S(":XNX_K%")).trigger(S("\x15cg|xn~p|gpUU"))
          }, getCurrentPage: function () {
            return this.currentPage
          }, getPage: function (e) {
            return this.pages[e]
          }, popPrevPage: function () {
            for (; this.pageStack.length;) {
              var e = this.pageStack.pop();
              if (this.getPage(e)) return e
            }
            return !(this.pageStack = [])
          }
        }, e
      }),CKFinder.define(S('4ASOL\x18ypzTP[%3m\x17!(6+)=/8c\x1d/!5=!|\x044824\x15;"3(*q\x04\x0e\x16'), [], function () {
        return S(".TK\x0e\x12Z@\x1bU[WJ_yIIJP.a?>Ny\".>i8$ (sm20<=1'tw<8.:q/13\x05\\@\v\x01\x04\x02\x02\x1aKJ\b\0\f\x1d\x1cMS\x11\x18\x12X\x02\x18\x17\x15\x18\x1a\x0eP\x17\velq!:\x0f\x0f;j|~\x7fcc.kqes>w~p:jvv~!?}sORGsEKCK\n\tNJXL\x03FS^\\\x0e\x16V]Q\x15Z[U_XR\x1d`%#7%h/$'':$?pl!?%7+ wv#1-6>a\x7f%$]A\v\x17J\t\x07\t\x0fG\t\x04\x01\0\x01\x01^\x12\x1e\x1c\x07\x10V\n\x05[D\0\x07@^\x16t/nbjb(dgdgdb#mc\x7fbw3ih*8zlnoss \x15\x1c\x0eFJR\x1b,\\S\x16WV&\x11JFF\x11Q_UFE\n\x1aZQ]\x11M_Q%-o ++2\"&=9irqa+9'lY")
      }),CKFinder.define(S("\fNEIy\x7fvvf:[x|lv~o2N~NDNP\vsOB_Z\x05{MCKCfXWD"), [S(" bieMKBBZ\x06\x7f_EA\x01dUHq\\PP"), S(" bieMKBBZ\x06|BIZ]\0rPAV\x1byWNWLNmUXI"), S('4ASOL\x18ypzTP[%3m\x17!(6+)=/8c\x1d/!5=!|\x044824\x15;"3(*q\x04\x0e\x16')], function (t, e, n) {
        "use strict";
        return e.extend({
          name: S("\x12Cu{s{Txctii"),
          template: n,
          regions: {contents: S("\r l{w?cu{s{5zuuhxpkS")},
          events: {
            'click [data-ckf-role="closePanel"]': function () {
              this.hide()
            }, 'keydown [data-ckf-role="closePanel"]': function (e) {
              e.keyCode !== t.enter && e.keyCode !== t.space || this.hide()
            }, panelclose: function () {
              this.trigger(S("/S]]@QQ")), this.$el.attr(S("\x19{iu|3wIEFFJ"), S("\x1aonh{")), this._isOpen = !1
            }, panelopen: function () {
              this.trigger(S("2\\DPXR\\")), this.$el.removeAttr(S("6VJP[\x16TTZ[%/")), this._isOpen = !0
            }, keydown: function (e) {
              e.keyCode === t.escape && (e.stopPropagation(), this.hide())
            }
          },
          templateHelpers: function () {
            return {closeButton: !!this.options.closeButton}
          },
          initialize: function (r) {
            this._isOpen = !1, this.$el.attr(S("\x17|xnz1~uy\rQCMAI"), r.name).attr(S(";X\\J^m1-0-1/(&"), r.position).attr(S(",IO[Q\x1cF[QXS"), this.finder.config.swatch).attr(S("\fl|fq<zzpqsy"), S("D142-")).attr(S("6SYM[\x16XTMO, ;"), r.display).addClass(S("0RYU\x19EWY]U\x17") + r.position);
            var e = this;

            function t() {
              var e = this.$el.find(S("\x0e!ex?cu{s{5ptuyo"));
              if (e.length) {
                var t = getComputedStyle(e[0]).getPropertyValue(S("._QUVZZR\x1bCWI")), n = 0;
                if (r.closeButton) {
                  var i = this.$el.find(S("!yGEQG\nZFFN\x11\x0fFJQUWA\x16h"));
                  i.length && (n = i.outerHeight())
                }
                this.contents.$el.css({height: this.$el.height() - parseInt(t) - n + S("\x1eoX"), overflow: S("1SF@Z")})
              }
            }

            r.overrideWidth && (this.$el.css({width: r.overrideWidth}), this.$el.on(S('E6&&,&))+!=5>"6:'), function () {
              e.$el.css({width: r.overrideWidth})
            }), r.display === S("C+3#5$(3") && (this.$el.on(S(">O!/'/&  (:,)'#>+"), function () {
              e.$el.css(r.position === S("\x18u\x7f}h") ? {
                left: 0,
                transform: S("*_^L@\\\\PFV\x07Q\x1e\x1a") + e.finder.config.secondaryPanelWidth + S("-\x02\x0f\0\x1d\x12\x03\x1d")
              } : {
                right: 0,
                transform: S("C07');%+?)~*g") + e.finder.config.secondaryPanelWidth + S('"\x0f\x04\x15\n\x07\x18\0')
              })
            }), this.$el.on(S(")ZJBHBL\\^AV"), function () {
              e.$el.css(r.position === S("$ICA\\") ? {left: "", transform: ""} : {right: "", transform: ""})
            }))), r.scrollContent && (this.contents.on(S("&T@F]"), t, this), this.finder.on(S("\x16cwvvy}o$|RDCWA"), t, this), this.finder.on(S("\x15bxwuxzn'zzSUPL]"), t, this), this.finder.on(S("\r{f*cw`}os"), t, this), this.on(S("5RRKMHTE"), function () {
              this.finder.removeListener(S('=JP/- "6\x7f%5-(>.'), t), this.finder.removeListener(S("&SGFFIM_\x14KUBFA[L"), t), this.finder.removeListener(S("\x1anu'lzSHXF"), t)
            }, this))
          },
          display: function () {
            this.$el.panel(S("\ra\x7fu\x7f"))
          },
          toggle: function () {
            this.$el.panel(S("\x1ciqxGMG"))
          },
          hide: function () {
            this.$el.panel().panel(S(",NB@CT"))
          },
          isOpen: function () {
            return this._isOpen
          }
        })
      }),CKFinder.define(S("\x1e\\kgKM@@T\beFN^@H]\0`P\\VXF\x19gYW_WO"), [S(':NRY[M3"-1!'), S("/Z@GVFL"), S("\x19YPZtp{ES\ruM@QT\x07kKXI\x02g[U\\dZQB"), S('-mdvX\\WQG\x19aQ\\MH\x13\x7f_L%n\x0e"=*33\x1e /<'), S("-mdvX\\WQG\x19zW]OWYN\x11o!/'/7j\x10.->9d\x1c, *<\x07;6#"), S("\x17[R\\rry{m\x0ftVJH\nmBQjEOI")], function (e, t, n, i, a, r) {
        "use strict";

        function o() {
          this.panels = {}, this.opened = null
        }

        return o.prototype = {
          getHandlers: function () {
            return {
              "panel:create": {callback: this.panelCreateHandler, context: this},
              "panel:open": {callback: this.panelOpenHandler, context: this},
              "panel:close": {callback: this.panelCloseHandler, context: this},
              "panel:toggle": {callback: this.panelToggleHandler, context: this},
              "panel:destroy": {callback: this.panelDestroyHandler, context: this}
            }
          }, setFinder: function (e) {
            (this.finder = e).request(S('E-"1s&"?9+!'), {key: r.escape}), e.on(S("+GHWZ@\v") + r.escape, function (e) {
              e.data.evt.stopPropagation()
            }, null, null, 30), e.on(S("A7*~61.8,&.*9"), function (e) {
              this.onSwipe(S("C(  3"), e)
            }, this, null, 10), e.on(S("0D[\tGB_G]KS\\TI"), function (e) {
              this.onSwipe(S('"QMBNS'), e)
            }, this, null, 10)
          }, panelCreateHandler: function (e) {
            var t, n = this.finder,
              i = e.position === S("\x13dg\x7fzykc") ? n.lang.dir === S("'D]X") ? S("#H@@S") : S(" SKDLQ") : n.lang.dir === S("@-61") ? S("1@ZS]B") : S("%JBN]"),
              r = e.position === S("@10*)$4>") ? n.config.primaryPanelWidth : n.config.secondaryPanelWidth, o = {
                finder: n,
                position: i,
                closeButton: e.closeButton,
                name: e.name,
                scrollContent: !!e.scrollContent,
                overrideWidth: r,
                display: e.panelOptions && e.panelOptions.display ? e.panelOptions.display : S("\x12|bpd{y`")
              };
            e.scrollContent && (t = S("0RYU\x19EWY]U\x17H_OQS,  /!")), e.className && (t = (t ? t + " " : "") + e.className), t && (o.className = t);
            var s = new a(o);
            return s.on(S("*H@B]JT"), function () {
              n.fire(S("?0 ,&(\x7f%+':/q") + e.name, null, n), this.opened = null
            }, this), s.on(S("4ZFRV\\^"), function () {
              n.fire(S(":K]S[Sz.2&*\x7f") + e.name, null, n), this.opened = e.name
            }, this), s.render(), s.$el.appendTo(S("*ICIW")).panel(e.panelOptions || {}).trigger(S("/SCWR@P")), s.contents.show(e.view), s.on(S("\noi~z}\x7fh"), function () {
              n.fire(S("6GYW_W\x06Y[L43-:~") + e.name, null, n), delete s[e.name]
            }), this.panels[e.name] = s, this.finder.request(S("\x0fv~qfg/beyi"), {node: s.$el}), s
          }, panelOpenHandler: function (e) {
            var t = this.panels[e.name];
            t && t.display()
          }, panelToggleHandler: function (e) {
            this.panels[e.name] && this.panels[e.name].toggle()
          }, panelCloseHandler: function (e) {
            this.panels[e.name] && this.panels[e.name].hide()
          }, panelDestroyHandler: function (e) {
            this.panels[e.name] && (this.panels[e.name].hide(), this.panels[e.name].destroy(), delete this.panels[e.name])
          }, onSwipe: function (e, t) {
            var n = this.panels[this.opened];
            n && n.getOption(S("\x1dnpSHVJKK")) === e && (t.cancel(), n.hide())
          }
        }, o
      }),CKFinder.define(S(':OYEJ\x1e\x03\n\x04**!#5g\x1d/&<!/;5"}\x15=93$w\x1f379\x13?2\x05%\v\x02\b\n\x013\r\x04\x1a\x07\r\x19\vA\x14\x1e\x06'), [], function () {
        return S('\x18%|tnp>~CUKLJ\x18\x04\x04\n\x17 "\x10AOMU]\f9=<ML\x19\x19SO\x12YW^,.%\x0e!65&/,j61GGFl8<#!!v#9;3588&bBP@C\n\x04\v\x02UK\x04\x0e\x1b+\x07\x03\x15?\x13\x1e\x11WV\x01\x19\x15\x0f\x1eA_\x05\x04!!kw*cokmGkfi-sr21sa}t;e}hornxz"\x02UPVA\x07\x06CA[\x17\tMXZ@\x12\x0f8:\b\x1aZVZ\\V\x056\x01\x11Y/3/}Ny6g+%+8?pl*"#=!y83$+8=>~cbp\x10_h')
      }),CKFinder.define(S("\x16TS_suxxl0mNFVH@U\bn@FN_\x02xFUFA\x1cr\\ZRvXW^xT_S/&\x14*!2"), [S("-mdvX\\WQG\x19aQ\\MH\x13\x7f_L%n\v7!(\x10.->"), S("D\x06\r\x01!'..>b\x03 44> {\x13?;="), S(';HXFKa\x02\t\x05-+"":f\x1e.!=".$4!|\x12<:2+v\x1c208\x10>\r\x04&\n\x05\t\t\0<\f\x07\x1b\0\f\x1a\n^\x15\x1d\x07')], function (e, r, t) {
        "use strict";
        return e.extend({
          name: S(")lB@H`N]TvZUYYPnP_L"),
          template: t,
          ui: {error: S("\f#k}b~`>ypedy~\x7f"), fileName: S("8PTKIIeQ!,'~f+#0\x0e &.\x02,#*r\f")},
          events: {
            "input @ui.fileName": function () {
              var e = this.ui.fileName.val().toString();
              if ((e = r.trimFileName(e)).length) if (r.isValidName(e)) {
                this.model.unset(S("?%30,6"));
                var t = r.extensionFromFileName(this.model.get(S("\x14zd~\x7fptzp[wsEoCNA"))).toLowerCase(),
                  n = r.extensionFromFileName(e).toLowerCase();
                if (t !== n) {
                  if (!this.model.get(S("-\\JC^GAWPbNH\\")).isAllowedExtension(n)) return void this.model.set(S(".JBC]A"), this.finder.lang.errors.incorrectExtension);
                  this.model.set(S(")OSXH@\\Y^\\p\\TXP]]"), !0)
                } else this.model.set(S('E#?<,$8%" \f80<411'), !1);
                this.model.set(S("(OCGIcOBU"), e)
              } else {
                var i = this.finder.lang.errors.fileInvalidCharacters.replace(S("9A_UN_S,.5& \x06.&:()?)?=2"), r.invalidCharacters);
                this.model.set(S("0T@A[G"), i)
              } else this.model.set(S("5SEJVH"), this.finder.lang.errors.fileNameNotEmpty)
            }, submit: function (e) {
              this.trigger(S(")Y^N@G[\nW]AY")), e.preventDefault()
            }
          },
          modelEvents: {
            "change:error": function (e, t) {
              t ? (this.ui.fileName.attr(S('\nj~do"y\x7fdrx|r'), S("E25=,")), this.ui.error.show().removeAttr(S("*J^DO\x02XXVWQ[")).html(t)) : (this.ui.error.hide().attr(S("\x10p`zu8~~|}\x7fu"), S("\x16cjl\x7f")), this.ui.fileName.removeAttr(S("\x0enbxs>}{`vtp~")))
            }
          }
        })
      }),CKFinder.define(S("\vOFHf~uwa;Xysmu\x7fh3O{qALGeMIC\bzLDJAHhF\\T"), [S("\x16uyzqyss{"), S(".l{w[]PPD\x18uV^^PN\x11y)-'"), S("(jamECJJB\x1egG]Y\x19|]@yTXX"), S('\x1b_VXvNEGQ\vhIC]EOX\x03kGCUB\x1de]PAD\x17\x7fSWYs_R%\x05+"(*!\x11!,=')], function (s, e, n, a) {
        "use strict";

        function t(e) {
          var t = this, n = e.data.context.file, i = n.get(S("'NFFOI_")).get(S("3UVZ"));
          e.data.items.add({
            name: S("\v^h`n}tTzxp"),
            label: t.finder.lang.common.rename,
            isActive: i.fileRename,
            icon: S("\nhgk#iy}w>fpxvu|"),
            action: function () {
              t.finder.request(S('E .$,p9)#/"5'), {file: n})
            }
          })
        }

        function i(e) {
          var t = this.finder, n = t.lang, i = e.file.get(S("9\\TPY[M"));
          if (i.get(S(":Z_Q")).fileRename) {
            var r = new s.Model({
              dialogMessage: t.lang.files.fileRenameLabel,
              fileName: e.file.get(S("\x10\x7fs~q")).trim(),
              originalFileName: e.file.get(S("+BLCJ")),
              resourceType: i.getResourceType(),
              extensionChanged: !1,
              error: !1
            }), o = t.request(S("5R^YUU\\"), {
              view: new a({finder: t, model: r}),
              name: S("%tBFHGNjDBJ"),
              title: n.common.rename,
              context: {file: e.file}
            });
            r.on(S("4V^VV^_\x01YOLP2"), function (e, t) {
              t ? o.disableButton(S("\x19up")) : o.enableButton(S("(FA"))
            })
          } else t.request(S('\x11vzuyyp"pt}s'), {msg: t.lang.errors.renameFilePermissions})
        }

        function l(e, i) {
          var r = e.file, t = r.get(S("@'-/  4")), n = {fileName: r.get(S("<S_R%")), newFileName: e.newFileName};
          i.request(S("\x18uuzxxl%SIMT"), {text: i.lang.common.pleaseWait}), i.once(S("#GJKJIGN\x11MKZJB\v`VZT[R~PV^"), function (e) {
            i.request(S("7TV[_YO\x04W)%'"));
            var t = e.data.response;
            t.error || r.set(S("?. /&"), t.newName);
            var n = i.request(S(">Y)-'0~\"#3\v<89)#:")).where({name: t.newName}).pop();
            n && n.trigger(S("$CID]Z"), n)
          }), i.request(S("\x14vyzuxt\x7f&n{qD"), {
            name: S("\x13Fpxvu|\\rpx"),
            folder: t,
            params: n,
            type: S("\x0e\x7f\x7fbf")
          })
        }

        return function (s) {
          (this.finder = s).setHandler(S("7^PV^\x06O[Q!,'"), i, this), s.on(S("@\"--0 >3\x05,$>v+'#5k77=!"), t, this, null, 50), s.on(S("\x18\x7fswy'uzYEMTJ"), function (e) {
            e.data.evt.keyCode === n.f2 && s.request(S('<[WS%{0&*$+"'), {file: e.data.file})
          }), s.on(S("9NTSQ\\^2{0&7 2}\x05(#%v+'#5"), function (e) {
            e.data.file.get(S("=XP,%'1")).get(S("8XYW")).fileRename && e.data.toolbar.push({
              name: S("1`VZT[R~PV^"),
              type: S("E$2<=%%"),
              priority: 30,
              icon: S("#GN@\nN@FN\x01_KAQ\\W"),
              label: e.finder.lang.common.rename,
              action: function () {
                e.finder.request(S("\x12u}ys-j|tzqx"), {file: e.finder.request(S("\vjdbjc+uv`Fs{}zn~x")).toArray()[0]})
              }
            })
          }), s.on(S("\fign|~u)Fpxvu|\\rpx$pK"), function (e) {
            var t = e.data.view.model;
            if (!t.get(S("0T@A[G"))) {
              var n = e.data.context.file, i = t.get(S("\x13r|zrVxw~")), r = n.get(S("E(&%,")),
                o = {file: n, newFileName: i};
              e.finder.request(S("C ,'+'.p/)>:=?(")), t.get(S("5SOL\\THURP|( ,$!!")) ? s.request(S('A&*%)) r*%%*$<"'), {
                name: S('A0&*$+"\x0e &.\x0f" )9#?'),
                msg: s.lang.files.fileRenameExtensionConfirmation,
                context: o
              }) : i !== r && l(o, s)
            }
          }), s.on(S("\x1dzvAMMD\x1eWCIIDOmEAKl__TZFX\fXS"), function (e) {
            l(e.data.context, s)
          }), function (t) {
            t.on(S("2U]YS\rS\\C_SJP"), function (e) {
              e.data.evt.keyCode === n.f2 && t.request(S("=XV,$x1!+'*-"), {file: e.data.file})
            }), t.on(S("E5/';>(99=u<8!'n3?;=*"), function (e) {
              e.data.shortcuts.add({label: e.finder.lang.shortcuts.files.rename, shortcuts: S("1IU\x06H")})
            }, null, null, 20)
          }(s)
        }
      }),CKFinder.define(S('-mdvX\\WQG\x19zW]OWYN\x11p0$0"0,))g\x06:.>,:&??'), [], function () {
        "use strict";

        function e(e) {
          this.finder = e, this.id = e.util.randomString(16)
        }

        return e.prototype.getId = function () {
          return this.id
        }, e.prototype.trackProgress = function (t) {
          var e = this, n = !0;
          this.probingInterval = setInterval(function () {
            n && (n = !1, e.finder.request(S("\vobcbq\x7fv)gpxs"), {
              name: S('E\t7-;+?%" '),
              params: {operationId: e.id}
            }).done(function (e) {
              n = !0, t && t(e)
            }))
          }, 3e3)
        }, e.prototype.abort = function () {
          this.finish(), this.finder.request(S("A!,)('),s9.\")"), {
            name: S("\x1aTlxl~THMM"),
            params: {operationId: this.id, abort: !0}
          })
        }, e.prototype.finish = function () {
          this.probingInterval && (clearInterval(this.probingInterval), this.probingInterval = null)
        }, e
      }),CKFinder.define(S("\vOFHf~uwa;Xysmu\x7fh3O{qALGeKIBBZ\x06xNBLCJv^^WQG"), [S("\vnlmdr~|v"), S('\x1c^UYIOFFV\nkHL\\FN_\x02h@\\UWAG\x1a`^]NI\x14zRR[%3\f") \x02.)%%,\x1a$+8'), S("D\x06\r\x01!'..>b\x1b;9=}\x181,\x158<<"), S('B\0\x0f\x03/),,8d\x01"*:<4!|\x1b%3%9-342r\x11/\x05\x13\x03\x17\r\n\b'), S("\x1aXW[wqDDP\fgJKJGG\x05fCIKCC\x1ebA[RDRKJwTXXR"), S("\x14V]Qqw~~n2]pMLMM\vsOB_Z\x05{^BI]UBAe]PA")], function (f, h, n, g, p, v) {
        "use strict";
        return function (d) {
          d.setHandler(S("'NFFOI_\x14]U_S^Q"), function (e) {
            var t = e.folder, n = e.newFolderName;
            if (n) {
              var i = t.getResourceType(),
                r = {type: t.get(S("3FPEXMKY^hDNZ")), currentFolder: t.getPath(), newFolderName: n};
              if (i.isOperationTracked(S(" sGMEHCaGENN^"))) {
                var o = new g(d);
                r.operationId = o.getId();
                var s = new p({message: d.lang.common.pleaseWait}), a = new v({finder: d, model: s});
                d.request(S(",IGN\\^U"), {
                  view: a,
                  title: d.lang.common.rename,
                  name: S("\x1eMEOCNAcIKLLX{^BI]UBA"),
                  buttons: [{name: S("\x1e~BNPW"), label: d.lang.common.abort}]
                });
                var l = function () {
                  o.abort(), d.request(S("\x17|p{wsz${ERVQK\\"))
                };
                d.on(S("\x17|p{wsz$MEOCNAcIKLLX{^BI]UBA\tUWYEL"), l), o.trackProgress(function (e) {
                  e.current && e.total && s.set(S(".YQ]GV"), e.current / e.total * 100)
                }), d.once(S("<^QR- ,'~*-}\x1a,$*!(\b <57!"), function () {
                  s.set(S("\x10gs\x7fap"), 100), setTimeout(function () {
                    d.request(S("\x1dzvAMMD\x1eACT\\[ER"))
                  }, 1e3)
                }), d.once(S(" BMNIDHC\x12HL_I_\x14}U_S^QsY[\\\\H"), function () {
                  o.finish(), d.removeListener(S("*OELB@W\v`VZT[R~VV_YOnM/&0&76|&*&8?"), l)
                })
              } else d.request(S("E*()-/9v>& '"), {text: d.lang.common.pleaseWait});
              d.request(S(".L_\\_RZQ\fD]W^"), {
                name: S('E\x14"&(\'.\n""+5#'),
                type: S(":KSNJ"),
                params: r,
                context: {folder: t, newFolderName: n}
              })
            } else {
              var u = new f.Model({
                dialogMessage: d.lang.folderRename,
                folderName: t.get(S("2]UXS")).trim(),
                error: !1
              }), c = d.request(S('"GMDJHO'), {
                view: new h({finder: d, model: u}),
                name: S(".}U_S^QsY[\\\\H"),
                title: d.lang.common.rename,
                context: {folder: t}
              });
              u.on(S("\x1axt|pxE\x1bGQVJT"), function (e, t) {
                t ? c.disableButton(S("\x15y|")) : c.enableButton(S("&HC"))
              })
            }
          }), d.on(S("1VZUYYP\x02k_U]P[y/-&&6\x7f),"), function (e) {
            var t = e.data.view.model;
            if (!t.get(S("\x1a~noqm"))) {
              var n = t.get(S("\x18\x7fuwxxlQALG"));
              e.finder.request(S('D!/&$&-q((=;">+')), d.request(S("\x17~vv\x7fyo$mEOCNA"), {
                folder: e.data.context.folder,
                newFolderName: n
              })
            }
          }), d.on(S("E%(%$+%(w/)$4 i\x060865<\x1c409;-"), function (e) {
            d.request(S("\x0ec\x7fpvvf/~~||"));
            var t = e.data.response;
            if (!t.error && !t.aborted) {
              var n = e.data.context.folder;
              n.set(S("9TZQX"), e.data.context.newFolderName), d.fire(S("\vjbbkuc(`qystl|~"), {folder: n}, d), n.trigger(S(";OXRZ#5''"), n)
            }
          }), d.on(S("\x1fCNLWA]RjMG_\x11JBBKUC\bVP\\B"), function (e) {
            var t = e.finder, n = e.data.context.folder, i = n.get(S(":ROoQP4")), r = n.get(S("9[XP"));
            e.data.items.add({
              name: S("\x18K\x7fu}p{YOMFFV"),
              label: t.lang.common.rename,
              isActive: !i && r.folderRename,
              icon: S("\fnei=w}\x7fppd:j|tzqx"),
              action: function () {
                t.request(S("\x16qwu~~n'lzN@OF"), {folder: n})
              }
            })
          }), d.on(S("\x1fTNMOFDT\x1dZLYNX\x17cNY_\bU[YRRJ"), function (e) {
            var t = e.data.folder;
            !t.get(S("1[@fZYC")) && t.get(S("\vmnb")).folderRename && e.data.toolbar.push({
              name: S("6e]W[VY{QS$$0"),
              type: S('"AQQRHF'),
              priority: 30,
              label: e.finder.lang.common.rename,
              icon: S('6TS_\x17]SQZZ2l0&*$+"'),
              action: function () {
                d.request(S("\x15pxt}\x7fi&o{qALG"), {folder: t})
              }
            })
          }), function (t) {
            t.on(S("\fkactt`)\x7fposwnt"), function (e) {
              e.data.folder.get(S("\ve~\\`\x7fe")) || e.data.evt.keyCode === n.f2 && e.finder.util.isShortcut(e.data.evt, "") && (e.data.evt.preventDefault(), e.data.evt.stopPropagation(), t.request(S('C"**#-;p9)#/"5'), {folder: e.data.folder}))
            }), t.on(S("\x11a{{gbtmmi!ptmk\x1aGMO@@TT"), function (e) {
              e.data.shortcuts.add({label: e.finder.lang.common.rename, shortcuts: S("7C_\bF")})
            }, null, null, 20)
          }(d)
        }
      }),CKFinder.define(S("\x10RYU}{rrj6WtxhrzS\x0edJHQCUn@FN_\x02hF\\EWAr\\ZRK"), [S("6SWm"), S("2^UG_XV\\NOY"), S("\x1fcjdJJACU\x07|^B@\x02eJIr]WQ")], function (r, o, s) {
        "use strict";
        return function (t) {
          var n = "", i = {
            "input input": function () {
              var e = this.$el.find(S("3][FBL")).val();
              n !== e && t.request(S("+JDBJC\vTZXASE"), {text: e}), n = e
            }, "keydown input": function (e) {
              e.keyCode === s.tab && (t.util.isShortcut(e, "") || t.util.isShortcut(e, S("\x15e\x7fq\x7fn"))) && t.request(t.util.isShortcut(e, "") ? S("-H@SDA\tZPNC") : S("\x10w}paf,gj|l"), {
                node: this.$el.find(S("3][FBL")),
                event: e
              }), e.stopPropagation()
            }
          };
          (function () {
            var e, t = -1;
            return navigator.appName == S("=sV#3-0+#2g\x01'>.>#+;p\x14*#8:$2*") && (e = navigator.userAgent, null !== new RegExp(S("4xe~}\x19\x12`\f\x10\x07b;pn>\x1fkvjq\x141{`0g")).exec(e) && (t = parseFloat(RegExp.$1))), 9 === t
          })() && (i[S("%MBQ\\Z\vEC^ZD")] = function (e) {
            e.keyCode !== s.backspace && e.keyCode !== s.delete || this.$el.find(S("1[]D@B")).trigger(S("&NFY__"))
          }), t.on(S("\x12g{zzuyk iyn{k\x1alCJJ\x1f@HDMOY"), function (e) {
            e.data.toolbar.push({
              name: S("E\0.$=/9"),
              type: S("\x17{liosp"),
              priority: 50,
              alignment: S("&TMJEEHL\\V"),
              alwaysVisible: !0,
              view: o.ItemView.extend({
                className: S('9YPZ\x10XV,$1n",*3-;'),
                template: r.template(S("\x15*~vioo<igoE\x1c\0WA]R\x05\bJFJ_^\x13\rSZT\x1e@ZY[ZXH\x16UI[Rm'- 16'%$,hk8,,&>57+iwggzy*7=>;7\x0f\r\x06\x06\x16XD\x1c\x13TJ\x02\x18C\x1e\x03\x11\x12\x17\x1b\x1b\x19\x12\x12\nY\x07\x06^]\b\x1eltg>&~}:(`~%zlbzu1on65rvlx7knxhzNU\x0fEKFST\x05SEDA\x10\f[BDW\x11\n")),
                events: i
              }),
              placeholder: t.lang.files.filterPlaceholder,
              value: n
            })
          }), t.on(S(":]SQZZ2{1&( %3--"), function () {
            n = ""
          }, null, null, 5)
        }
      }),CKFinder.define(S("\x12P_S\x7fy||h4QrzjLDQ\fw@RSAGMX\x03{GJGB\x1d`QAB^V^lRYJ"), [S('"VJACU[JEYI'), S("!ahbLHCM[\x05}EHY\\\x1fsS@Q\x1a\x7fC]TlRYJ")], function (e, t) {
        "use strict";
        return t.extend({
          initialize: function () {
            this.model.set(S("\x12zp"), e.uniqueId(S("$FMA\x05")))
          }
        })
      }),CKFinder.define(S("\x11fvla7TS_suxxl0tDOSHDRB[\x06yNXYGAWB\x1dp\\PU\\ZVB\x15XRJ"), [], function () {
        return S('5\n[Y[_W\x1c[QM}c98ye/3f .k10lql8<#!!v><dx \'`~6\x14O\v\x07D\x18\x1bEH\x1d\x13\x1b\tPL\f\x18\x14\x11\x18\x16\x1a\x0eUX\x17\x1b\x16\x19@\\\x04{<"jp+hfel*vq/\x04/012wuaw:qzuulrm"\x02ZY\x1c\x04LR\tDHDL\x02IG]\x10\f\x0f\x13\x13YBE\x1fDGWY[JD;~}>97/  =10s03mp*)lt<"y.86.9}#"\x03\t\x07\0\x0f\0\x02ZJ\n\x02\x0e\x0f\x06\v\vR\n\tL\t\bH\f\x03DZ\x12\bS\x12\x1ebdn#yx:(dhhn`3\x04')
      }),CKFinder.define(S("\x1fcjdJJACU\x07dEOYAK\\\x1fbWG@\\XPK\x16lRYJM\x10\x03)' /')?\x1e /<"), [S("\x1anry{mSBMQA"), S('C.43":0'), S("(jamECJJB\x1egG]Y\x19|]@yTXX"), S(':xw{WQ$$0l\t*"2$,9d\x1f(:;9?5 {\x03?2/*u\b9)*6\x0e\x064\n\x01\x12'), S("'\\LR_\rneiY_VVF\x1abRUIVZHXM\x10\x13$67-+!4g\n\"./&, (\x7f6< ")], function (e, t, n, i, r) {
        "use strict";
        return i.extend({
          name: S("#gMCDCKES\x7fHZ[Y_U"),
          template: r,
          className: S("\x11qxr8erlmsu{n3|HDAHFJ^"),
          ui: {checkbox: S("9SULHJ")},
          events: {
            "change input": function () {
              this._isExt = !0, this.model.set(S("\x1ck\x7fsUD"), !!this.ui.checkbox.is(S(",\x17MGURYVP"))), this._isExt = !1
            }, "keyup input": function (e) {
              e.keyCode !== n.enter && e.keyCode !== n.space || (e.preventDefault(), e.stopPropagation(), this.ui.checkbox.prop(S("3W]STS\\^"), !this.ui.checkbox.is(S("(\x13ICINEJT"))).checkboxradio(S("5DR^K_HT")).trigger(S("\x18zrzrz{")))
            }, checkboxradiocreate: function () {
              this.model.get(S("\x1evSdLBFICC")) || this.disable()
            }, "mousedown label": function () {
              var e = this;
              setTimeout(function () {
                e._parent.fixFocus(), e.focus()
              }, 0)
            }, "mouseup label": function () {
              var e = this;
              setTimeout(function () {
                e._parent.fixFocus(), e.focus()
              }, 0)
            }, "focus input": function (e) {
              e.stopPropagation()
            }
          },
          modelEvents: {
            "change:value": function (e, t) {
              this._isExt || this.ui.checkbox.prop(S("*HDHMDUU"), t).checkboxradio(S("\x19h~zo{lH"))
            }
          },
          focus: function () {
            this.ui.checkbox.focus()
          },
          enable: function () {
            this.ui.checkbox.checkboxradio(S("\vicom|t")).removeAttr(S("C0$$.&-/3")).removeAttr(S("@ 0*%h\".;(('))"))
          },
          disable: function () {
            this.ui.checkbox.checkboxradio(S("-JFCPP_Q")).attr(S("D1'%!'..4"), -1).attr(S("\fl|fq<vzgtt{}}"), !0).removeClass(S("\r{f=w}paf"))
          }
        })
      }),CKFinder.define(S("\x1djzXU\x03`ocOILLX\x04xHC_\\PFVG\x1aeRLMSU[N\x11m!%+,j!)3"), [], function () {
        return S('\x1e#L@@FH\x1b]\\\x15\tC_\x02AOMU]\x12NI\t\x19[Y[_W\x027ED`(6m\x1bk#&+!b"8c/;$#;1!!3$v6*/520,LA\x04\x16\n\x06\x12\x0e\x07\x07B\x04\x1c\x19\x07\0\x1e=\x13\x11\x11\x19ZW\x17\t\x0e\x12\x13\x13(\x1eltg*\x7f%{z\x025ce|xz/~p\x7fv)7ml%9so2s\x7frE\x01_^\x06\x05OC\x15\vQP\x11\rG[\x1e_S^Q\x15KJCB\x07\x1bSMJV//\x14"(0#g54hAEmno&0>&1ht,#dz4,)70\x0e7\x03\x0f\x11\0F\x1a\x15KJ\x10\x17RN\x06\x04_\x04\x12\x18\0\x13WEDZ\x14\f\t\x17\x10nWcoq`&zujbnofkk-3q{qv}r|;a`#`c\x15)\x01\x02\x03@DRF\x05@IDB]A\\\r\x13IH\v\x15_C\x16U[U[\x13ZV2a\x7f~db*3:n76 ((;+*ml)($>?1. \'b#"BkkCDE\x12\x1e\x18\fWI\x1e\f\n\x06\x1fSLyH\x19\x17\x15\x1d\x15Z\x1d\x13\x0fC]{z?#mq(iido+qput-1}c`|yyNxvny=cb\x02\x1fYX\x19\x05IW\\@EE`LLJ\\\x11ON\b\x1aZVZ\\V\x056FE\x1f=hyc98L')
      }),CKFinder.define(S("\x18ZQ]uszzR\x0eoL@PJB[\x06yNXYGAWB\x1de]PAD\x17k[_URhV%6"), [S(",X@KUCAP[GS"), S("$OWRM[S"), S('2p\x7fs_Y\\\\H\x14iIWSo\n\':\x07*""'), S('\x1e\\kgKM@@T\beFN^@H]\0cTFG][QD\x17oS^KN\x11l%56**"\x10.->'), S(")^NTY\x0fl{w[]PPD\x18l\\WKP\\JZ3n\x11&01/)/:e\x19-)' ~5='")], function (e, t, n, i, r) {
        "use strict";
        return i.extend({
          name: S(";n\\ZV/\x12'70,( "), template: r, templateHelpers: {_: e}, events: {
            "change input": function (e) {
              this._isExt = !0, this.model.set(S("\x1eiAMWF"), t(e.currentTarget).val()), this._isExt = !1
            }, "keyup input": function (e) {
              e.keyCode !== n.enter && e.keyCode !== n.space || (e.preventDefault(), e.stopPropagation(), this.$el.find(S("\vec~zd")).each(function () {
                t(this).prop(S(")ICINEJT"), this === e.target).checkboxradio(S("+^HH]UBZ"))
              }), t(e.target).trigger(S("=]W!/%&")))
            }, "focus input": function (e) {
              e.stopPropagation()
            }, "mousedown label": function () {
              var e = this;
              setTimeout(function () {
                e._parent.fixFocus(), e.focus()
              }, 0)
            }, "mouseup label": function () {
              var e = this;
              setTimeout(function () {
                e._parent.fixFocus(), e.focus()
              }, 0)
            }
          }, modelEvents: {
            "change:value": function () {
              this._isExt || (this.render(), this.$el.enhanceWithin())
            }
          }, focus: function () {
            this.$el.find(S("@(,311\x1d1)%?.qo") + this.model.get(S("\vzlbzu")) + S("A`\x1e")).focus()
          }, enable: function () {
            this.$el.find(S("\x18ptkii")).each(function () {
              t(this).checkboxradio(S("\x1bys\x7f}LD")).removeAttr(S("D1'%!'..4")).removeAttr(S("+M_GN\x1dU[@UWZR\\"))
            })
          }, disable: function () {
            this.$el.find(S("#MKVR\\")).each(function () {
              t(this).checkboxradio(S("+HD]NR]W")).attr(S("\x14awuqw~~d"), -1).attr(S("\fl|fq<vzgtt{}}"), !0)
            })
          }
        })
      }),CKFinder.define(S("\x11fvla7TS_suxxl0tDOSHDRB[\x06yNXYGAWB\x1d`QYSTL\x17^TH"), [], function () {
        return S(",\x11BNRT^\rON\v\x17QM\x14W]_[S`<?\x7fk)'%-%tAp>+#52&s ,&2e{.>$)|\x7f\x0e\0\x0f\x06YG\x1d\x1cUI\x03\x1fB\x03\x0f\x02\x15Q\x0f\x0eVU\0\x16\x14\f\x1fF^\x06\x05B hv-rdjrm)wv.3\x04\x06kj2z`;I9}xys4tj1AUVQMGSSMZ\x04D\\YG@^B\x1e\x13R@XTLPUU\x14S_R%mb(!<o<h47AEq!?$8==t#7;-<gy'&c\x7f\v\x04\x1bC\x19\x18DG\x13\x12UK\x05\x19@\x19\x11\x1d\x07\x16THKW\x13\x1c\x03[\x01\0\r\x1aldawaa;%{lfnoykk2ji,ih(lc$:u}p{?]\\\x1e\fKURNGG\x14!%VU\x0fM\x18\t\x13IH<\v\x17J_WY^J\x01J")
      }),CKFinder.define(S("(jamECJJB\x1e\x7f\\P@ZRK\x16i^HIWQ'2m\x15- 14g\x1a/').:\x1994%"), [S("\x10d|wqgetwk\x7f"), S("-D^ET@J"), S("\x11QXR|xs}k5VsyksER\rpAQRNFNY\x04zDKXC\x1eaV@A_Y_oS^K"), S(':OYEJ\x1e\x03\n\x04**!#5g\x1d/&<!/;5"}\x001!">6>)t\x0f82:\x03\x15L\x07\v\x11')], function (e, t, n, i) {
        "use strict";
        return n.extend({
          tagName: S("\x13p|`"),
          name: S("*xIAKLDbWG@\\XP"),
          template: i,
          templateHelpers: {_: e},
          ui: {select: S("5ERT\\YO")},
          events: {
            "change select": function () {
              this._isExt = !0, this.model.set(S("3BTZB]"), t(this.ui.select).val()), this._isExt = !1;
              var e = this;
              setTimeout(function () {
                e.focus()
              }, 10)
            }
          },
          modelEvents: {
            "change:value": function (e, t) {
              this._isExt || (this.ui.select.val(t), this.ui.select.selectmenu(S('"QACTB[A')))
            }
          },
          focus: function () {
            this.ui.select.focus()
          },
          enable: function () {
            this.ui.select.select(S(" DLBFIC")).removeAttr(S("\x1bh||vNEG[")).removeAttr(S("\x15weqx7\x7fun\x7f}LDF")).parent().removeClass(S("A7*i62&<,g/%>/-<46"))
          },
          disable: function () {
            this.ui.select.select(S("C ,5&*%/")).attr(S("\vxllf~uwk"), -1).attr(S("A#1-$k#!:+) (*"), !0).parent().addClass(S("@4+n71'3-d.\"?,,#55"))
          }
        })
      }),CKFinder.define(S("\x1ci{gT\0ahbLHCM[\x05\x7fI@^CQEW@\x1bfSCLPT\\O\x12jZ85l'+1"), [], function () {
        return S(" ZY\x1e\x04LR\tDHHN@\rSR\fX\\CAA\x16CAI_\x06\x1eI[G4cb-%(#zj21vl$:a>0?6t(+ux/;7)8c}\x1b\x1a_C\r\x11H\x11\t\x05\x1f\x0eL\x10\x13MP\x15\x1b\x01IW\x17\x02\f\x16XEv")
      }),CKFinder.define(S("\x16TS_suxxl0mNFVH@U\b{L^_ECI\\\x1fg[VCF\x19c]ANmUXI"), [S(">J.%'17&)5-"), S("\x15|fm|hb"), S("\x12P_S\x7fy||h4QrzjLDQ\fw@RSAGMX\x03{GJGB\x1d`QAB^V^lRYJ"), S("\x16c}an:_VXvNEGQ\vqCJXEK_I^\x01|UEFZZRE\x18l\\BO\x12YQK")], function (e, t, n, i) {
        "use strict";
        return n.extend({
          tagName: S("B/%'#+"),
          name: S("\x1dJzXUqFPQOIO"),
          template: i,
          ui: {input: S(".F^AGG")},
          events: {
            "change input": function (e) {
              this._isExt = !0, this.model.set(S("&QIE_N"), t(e.currentTarget).val()), this._isExt = !1
            }
          },
          modelEvents: {
            "change:value": function (e, t) {
              this._isExt || this.ui.input.val(t)
            }
          },
          focus: function () {
            this.$el.find(S(";USNJ4")).first().focus()
          },
          enable: function () {
            this.ui.input.textinput(S("\x15syy{v~")).removeAttr(S("?4  **!#?")).removeAttr(S(" @PJE\bBN[HHGII"))
          },
          disable: function () {
            this.ui.input.textinput(S("\x0ekybsqxp")).attr(S("\x1bh||vNEG["), -1).attr(S("'I[CJ\x01IG\\QS^VP"), !0)
          }
        })
      }),CKFinder.define(S("6C]AN\x1a\x7fvxV.%'1k\x11#*8%+?)>a\x1c5%&::2%x\n84<9s:0\x14"), [], function () {
        return S("4\tZVZ\\V\x1bZRL\x02b:9~d,2i&('.l03mn*)nt<\"y488>0}#\"\\N\x0e\x02\x06\0\nYbU\x03\x05\x1c\x18\x1aO\x04\b\x02\x16IW\x04\x16\x16\x1e\x1fY\\\x13\x1f\x12e< x\x7f8&n|'djah.rm32zp(4lc$:rh3p~MD\x02^Y\x07\x06JAG\x17\tWV\x13\x0fYE\x1cR@AD^ZLN^O\x13SV.a?>fOOghi'*4pl4+lr: {7#,+39));,N\f\x03\x1bD\x18\x1bEH\x1a\x1e\x0e\x1cPL\x14\vLR\x1a\0[\x17\x03\f\v\x13\x19\t\t\x1b\f.rvft%{z*)|j`xk22ji.4|b9nxvny=cb\x02\x1f(")
      }),CKFinder.define(S("E\x05\f\x0e $/)?a\x02?5'?1&y\x04=-.22:-p6\b\x07\x14\x17J4\x06\x06\x0e\x0f=\x05\b\x19"), [S("$PHCM[YHC_K"), S("!HRQ@T^"), S('8zq}USZZ2n\x0f, 0*";f\x19.89\'!7"}\x05=0!$w\n?/(4086\b\x07\x14'), S("D1#?<h\t\0\n$ +5#}\x0718&;9-?(s\x0e;+\x14\b\f\x04\x17J4\x06\x06\x0e\x0fE\b\x02\x1a")], function (e, t, n, i) {
        "use strict";
        return n.extend({
          tagName: S("(MC]"),
          name: S("<o_Q'$\x11&01/)/"),
          template: i,
          events: {
            "change input": function (e) {
              this._isExt = !0, this.model.set(S("\x1ck\x7fsUD"), parseFloat(t(e.currentTarget).val())), this._isExt = !1
            }, slidecreate: function () {
              this.$el.find(S("\x12=a|;dtp~~n0v~NENF")).attr(S('"WEGOILLR'), "0"), this.model.get(S("'AZoEMOBJT")) || this.disable()
            }
          },
          modelEvents: {
            "change:value": function (e, t) {
              this._isExt || this.$el.find(S("\fd`\x7fee")).val(t).slider(S("=LZ&3'0,"))
            }
          },
          focus: function () {
            this.$el.find(S("E/)8<>")).first().focus()
          },
          enable: function () {
            this.$el.find(S("\fd`\x7fee")).slider(S("0T\\RVYS")).removeAttr(S("\x12guw\x7fy||b")).removeAttr(S("1SA]T\x1bSQJ[YPXZ"))
          },
          disable: function () {
            this.$el.find(S("\x17qwjnh")).slider(S("\x11vzgtt{}")).attr(S("\x17lxxrry{g"), -1).attr(S("\x1c|lvA\fFJWDDKMM"), !0)
          }
        })
      }),CKFinder.define(S("\x1bhxfk\x01bieMKBBZ\x06~NA]BNDTA\x1cgPBCQW]H\x13n[K4(,$7\x024(=9d/#9"), [], function () {
        return S("?|'+&(!5\"<i>*.$ +5)oqydtiRPf79:;1\x04_\x19\x18YE\x0f\x13F\x05\v\t\t\x01N\x12\rM]\x1f\x11\x12\x13\x19\x1cGpr@\x19\x17\t bnbwv;%a}of\x7f/03?u{e*\x1f*8~p\x7fwxn{k\x1e")
      }),CKFinder.define(S("/sztZZQSE\x17tU_IQ[Lo\x12'70,( ;f\x1c\"):=`\x034&'=;1$\x1f+5.,\v7:\x17"), [S('@,#1-*("<=/'), S("\x12P_S\x7fy||h4Jt{hS\x0e`BW@\tdGDZD_DZJfXWD"), S("2p\x7fs_Y\\\\H\x14qRZJ,$1l\x17 23!'-8c\x1b'*'\"}\x10<05<:6\"\r58)"), S("+ofhF^UWA\x1bxYSMU_H\x13n[K4(,$7j\x10.->9d\x1e,*&?\x07;6#"), S("\x11QXR|xs}k5VsyksER\rpAQRNFNY\x04zDKXC\x1eaVXPUCnP_L"), S('A\x01\b\x02,(#-;e\x06#);#5"}\x001!">6>)t\n4;(\x13N6\x06\x1c\x110\x0e\r\x1e'), S('B\0\x0f\x03/),,8d\x01"*:<4!|\x070"#17=(s\v7:\x17\x12M1\x05\v\x01\x02>\0\x0f\x1c'), S("?4$:7e\x06\r\x01!'..>b\x1a*=!>2 0%x\v<./539,O2\x07\x17\x10\f\b\0\x1b.\x18\x04\x19\x1d@\v\x1f\x05")], function (t, e, i, r, o, s, a, n) {
        "use strict";
        return e.extend({
          name: S("%uB\\]CEK^i]_DBe]PA"),
          attributes: {"data-role": S("\x0el\x7f\x7ffa{yqewlj")},
          tagName: S("\x19~rj"),
          template: n,
          childViewContainer: S("+\x02DZJ]B"),
          className: S("4V]Q\x15J_OHTPX3l%1+06"),
          collectionEvents: {
            "change:isEnabled": function (e, t) {
              var n = this.children.findByModelCid(e.cid);
              t ? n.enable() : n.disable()
            }
          },
          events: {
            "focus fieldset": function (e) {
              e.target === this.$el.find(S("@'+&(!5\"<")).get(0) && (e.preventDefault(), e.stopPropagation(), this.fixFocus(), this.focus())
            }
          },
          initialize: function (e) {
            this.collection = e.model.get(S("\x1fSDVWMKAT"))
          },
          addChild: function (e) {
            e.get(S("\x0e{iaw")) !== S("5^^\\]_U") && t.CollectionView.prototype.addChild.apply(this, arguments)
          },
          getChildView: function (e) {
            var t = {checkbox: i, range: a, text: s, select: o, radio: r}, n = e.get(S(",YW_U"));
            return t[n] || (n = S("\x0e{uif")), t[n]
          },
          focus: function () {
            var e = this.children.findByModel(this.collection.filter(function (e) {
              return e.get(S(";UN{Q!#.& ")) && e.get(S("\x1bhdnz")) !== S(";TTZ[%/")
            }).shift());
            e && e.focus()
          },
          fixFocus: function () {
            this.$(S("\x176ls6zr}jS")).removeClass(S("5C^\x15_UXIN"))
          }
        })
      }),CKFinder.define(S('-mdvX\\WQG\x19zW]OWYN\x11l%56**"5h\x1e /<?b\x1d*$%;=3&\0>=.'), [S("\x1c^UYIOFFV\npNM^Y\x04nL]J\x1fr]_XPUCQVTmUXI"), S("\x12P_S\x7fy||h4QrzjLDQ\fw@RSAGMX\x03{GJGB\x1d`QAB^V^I|NRKO\x16('4")], function (e, t) {
        "use strict";
        return e.extend({
          name: S("#w@RSAGMXzDKX"), childView: t, collectionEvents: {
            focus: function () {
              var e = this.children.findByModel(this.collection.first());
              e && e.focus()
            }
          }, onShow: function () {
            this.$el.parent().trigger(S("&DZLK_I"))
          }, onRender: function () {
            this.$el.enhanceWithin()
          }
        })
      }),CKFinder.define(S('%eln@DOI_\x01b_UG_QF\x19d]MNRRZM\x10\r.&&(6i\x14-=>""*'), [S("\x18{{xw\x7fqqE")], function (e) {
        "use strict";
        return e.Model.extend({defaults: {type: S("C0 >3"), value: "", label: ""}})
      }),CKFinder.define(S("+ofhF^UWA\x1bxYSMU_H\x13n[K4(,$7j\v(,,&8c\x1e+;$8<4'\x12$8-)"), [S("6UYZQYSS["), S("*hgkGATT@\x1cyZRBT\\I\x14oXJK)/%0k\b)#-%9d\x1f(:;9?5")], function (n, i) {
        "use strict";
        return n.Model.extend({
          defaults: {displayTitle: "", title: "", group: ""}, initialize: function () {
            var e = this, t = new (n.Collection.extend({model: i}));
            t.on(S("8ZRZRZ["), function () {
              e.trigger(S(":XT\\PX%"))
            }), this.set(S("-]JDE[]SF"), t)
          }, getSettings: function () {
            var t = {};
            return this.get(S(",^K[DX\\TG")).forEach(function (e) {
              t[e.get(S("\x14{wz}"))] = e.get(S("E0&$</"))
            }), t
          }, forSave: function () {
            return {group: this.get(S("-I]_DB")), settings: this.getSettings()}
          }
        })
      }),CKFinder.define(S("=}t\x06(,'!7i\n'-?')>a\x1c5%&::2%x\x156>>0.q\f\x05\x15\x16\n\n\x02\x154\x1c\x06\x18\n\v\b"), [S(",X@KUCAP[GS"), S("(KKHGOAAU"), S("\x1aXW[wqDDP\fiJBRDLY\x04\x7fHZ[Y_U@\x1bxYS]UI\x14oXJK)/%0\x037)28")], function (n, e, t) {
        "use strict";
        return e.Collection.extend({
          model: t, initialize: function () {
            var e = this;
            e.on(S("\x17{q{u{x"), e.saveToStorage, e), e.on(S("#EAB"), e.saveToStorage, e), e.on(S("([OFC[K"), e.saveToStorage, e), e.storageKey = S("D&-!f:/?8$ (#"), e.dataInStorage = {}
          }, loadStorage: function () {
            localStorage[this.storageKey] && (this.dataInStorage = JSON.parse(localStorage[this.storageKey]))
          }, hasValueInStorage: function (e, t) {
            return !n.isUndefined(this.dataInStorage[e]) && !n.isUndefined(this.dataInStorage[e].settings[t])
          }, getValueFromStorage: function (e, t) {
            return this.hasValueInStorage(e, t) ? JSON.parse(localStorage[this.storageKey])[e].settings[t] : void 0
          }, saveToStorage: function () {
            var t = {};
            this.forEach(function (e) {
              t[e.get(S('"DVJSW'))] = e.forSave()
            }), n.merge(this.dataInStorage, t);
            try {
              localStorage[this.storageKey] = JSON.stringify(this.dataInStorage)
            } catch (e) {
            }
          }
        })
      }),CKFinder.define(S("(jamECJJB\x1e\x7f\\P@ZRK\x16i^HIWQ'2m\x0e+!#+;f\f\" 9+=55\x016 !?9?*"), [S("A \"'.$(&,")], function (e) {
        "use strict";
        return e.Collection.extend({
          initialize: function (e, t) {
            this._original = t.settings, this.listenTo(this._original, S("\x10dbwuas"), function () {
              var e = this._original.filter(function (e) {
                return !!e.get(S("\x1ahyijvNFQ")).filter(function (e) {
                  return e.get(S("\x1djfPD")) !== S("4]_S\\\\T")
                }).length
              });
              this.reset(e)
            })
          }
        })
      }),CKFinder.define(S(':xw{WQ$$0l\t*"2$,9d\x1f(:;9?5 {\x063#,04</'), [S("4@XS]KIXSO["), S("%DFKBHDBH"), S("E\x05\f\x0e $/)?a\x02?5'?1&y\x04=-.22:-p6\b\x07\x14\x17J5\x02\x1c\x1d\x03\x05\v\x1e8\x06\x15\x06"), S('A\x01\b\x02,(#-;e\x06#);#5"}\x001!">6>)t\x112::\f\x12M0\x01\x11\x12\x0e\x06\x0e\x198\x18\x02\x1c\x0e\x17\x14'), S("\x0fSZTzzqse7Tu\x7fiq{l\x0frGWPLH@[\x06gDHHB\\\x1fw[_@PDR\\j_OHTPX3")], function (p, r, o, s, a) {
        "use strict";
        var v, m, w, y, C, b;

        function _(e) {
          var t, n, i;
          for (i = "", t = S('\x12"&&""..""]_][egeknnjjfy{y\x7fy{ygiki'), n = 0; n < e.length; n++) i += String.fromCharCode(t.indexOf(e[n]));
          return _ = void 0, i
        }

        var x = !1;
        return function (c) {
          var h = new s, e = new a([], {settings: h});

          function g(e) {
            return h.findWhere({group: e})
          }

          function n(e, t) {
            var n = g(e);
            return !!n && n.get(S("\x14fsclpt|o")).findWhere({name: t})
          }

          (this.finder = c).config.id && (h.storageKey = S("\fnei>bwg`|xpkF") + c.config.id), h.loadStorage(), c.on(S('<\\NOz--"  "'), function () {
            c.request(S("#TDHBD\x13IYILZJ"), {
              name: S("\x1cn{kTHLDW"),
              position: S("-]JS^\\WUGO"),
              closeButton: S('C073"'),
              scrollContent: !0,
              panelOptions: {positionFixed: !0, display: S("8VL^NQ_F")},
              view: new o({collection: e, finder: c})
            })
          }, null, null, 909);
          var t, i = c.lang.dir === S("$IRU") ? S("D0/};>#;)!+)$") : S("\x1bit$lWHRFVLAO\\");
          c.on(i, function () {
            c.request(S("\v|lij*rgafpxc")) === S("9wZUS") && c.request(S("\x11brzpz-wi\x7fu"), {name: S("\x17k|nousyl")})
          }, null, null, 20), c.on(S('3DTXRT\x03UKYS\x04L%56**"5'), function () {
            e.trigger(S("-H@SDA"))
          }), c.setHandlers({
            "settings:define": function (n) {
              var t;
              b = b || (t = _(c.config.initConfigInfo.c), function (e) {
                return t.charCodeAt(e)
              });
              var e, d, f, o = g(n.group);
              e = b(4) - b(0), b(4), b(0), e < 0 && (e = b(4) - b(0) + 33), v = e < 4, o || (h.add({
                label: n.label,
                group: n.group
              }), o = g(n.group)), d = function (e) {
                for (var t = "", n = 0; n < e.length; ++n) t += String.fromCharCode(e.charCodeAt(n) ^ 255 & n);
                return t
              }, f = 92533269, y = !function (e, t, n, i, r, o) {
                for (var s = window[d(S("%bG^O"))], a = n, l = o, u = 33 + (a * l - (u = i) * (c = r)) % 33, c = a = 0; c < 33; c++) 1 == u * c % 33 && (a = c);
                return (a * o % 33 * (u = e) + a * (33 + -1 * i) % 33 * (c = t)) % 33 * 12 + ((a * (33 + -1 * r) - 33 * ("" + a * (33 + -1 * r) / 33 >>> 0)) * u + a * n % 33 * c) % 33 - 1 >= (l = new s(1e4 * (203623794 ^ f)))[d(S("\x10vveQd\x7f}Ftrc"))]() % 2e3 * 12 + l[d(S("8^^MrVUM/"))]()
              }(b(8), b(9), b(0), b(1), b(2), b(3));
              var i, r, s, a, l = o.get(S("4FSCLPT\\O"));

              function u(e, t) {
                var n = o.get(S("1UA[@F")), i = e.get(S("-@N]T")), r = e.previous(S("0GS_AP"));
                c.fire(S("\x1ahyijvNFQ\x19GMGIOL\x10") + n, {
                  settings: o.getSettings(),
                  changed: i
                }, c), c.fire(S("<N[K4(,$7\x7f%/)'-.v") + n + ":" + i, {value: t, previousValue: r}, c)
              }

              return (i = b(5) - b(1)) < 0 && (i = b(5) - b(1) + 33), m = i - 5 <= 0, C = function (e, t, n) {
                var i = 0,
                  r = (window.opener ? window.opener : window.top)[S(";PR]^4(--")][S("\x1fHNQWJDKB")].toLocaleLowerCase();
                if (0 === t) {
                  var o = S("\x18GmlkA0");
                  r = r.replace(new RegExp(o), "")
                }
                if (1 === t && (r = 0 <= ("." + r.replace(new RegExp(S("\fSyxgM<")), "")).search(new RegExp(S("(u\x04") + n + "$")) && n), 2 === t) return !0;
                for (var s = 0; s < r.length; s++) i += r.charCodeAt(s);
                return r === n && e === i + -33 * parseInt(i % 100 / 33, 10) - 100 * ("" + i / 100 >>> 0)
              }(b(7), (r = b(4), s = b(0), (a = r - s) < 0 && (a = r - s + 33), a), c.config.initConfigInfo.s), p.forEach(n.settings, function (e) {
                var t;
                e = p.extend({}, {isEnabled: !0}, e), (t = l.findWhere({name: e.name})) && h.remove(t), h.hasValueInStorage(n.group, e.name) ? e.value = h.getValueFromStorage(n.group, e.name) : e.value = e.defaultValue, l.add(e).on(S(".LXP\\TQ\x0f@VTL_"), u)
              }), w = function (e, t) {
                for (var n = 0, i = 0; i < 10; i++) n += e.charCodeAt(i);
                for (; 33 < n;) for (var r = n.toString().split(""), o = n = 0; o < r.length; o++) n += parseInt(r[o]);
                return n === t
              }(c.config.initConfigInfo.c, b(10)), h.trigger(S("\x1fUQFBP@")), function (t) {
                function e() {
                  return t.request(S("\x18i{|y'\x7f{DsGDMJH"), {
                    page: S("<p_V."),
                    name: n,
                    id: t._.uniqueId(S("7[R\\\x16")),
                    priority: 10
                  })
                }

                if (!(w && v && C && m) || y) {
                  var n = t._.uniqueId(S("4V]Q\x15") + (10 * Math.random()).toFixed(0) + "-");
                  if (x) return;
                  if (!e()) return t.once(S('\f}ohu+qaqtbr"T{rr'), function () {
                    e(), i()
                  });
                  i()
                }

                function i() {
                  x = !0;
                  var e = {};
                  e[S("*FI^]NWT")] = [S("\x17Htuo"), S("C)3"), "e", S("0QRX\\"), S("4GVCLX\\_"), S("8RY"), S("\x15QYXw|vsd"), "7"][S("1_RD")](function (e) {
                    for (var t = "", n = 0; n < e.length; ++n) t += String.fromCharCode(e.charCodeAt(n) ^ n + 4 & 255);
                    return t
                  })[S("\x10{}zz")](" "), t.request(S("\x17hx}~&nvpWhLqABOHF"), {
                    view: new (t.Backbone.Marionette.ItemView.extend({
                      attributes: {
                        "data-role": S("\nciljjb"),
                        "data-theme": "a" === t.config.swatch ? "b" : "a"
                      },
                      template: t._.template(S("\x16+p+:hhdrz\x1d\x03OBVBOI\x12\x04\x1b[T\rOZD^\x12\x03\x0f\x17\b\v\x1d\x04\x1aVYNM^'$bfzyi/zw"))
                    }))({model: new t.Backbone.Model(e)}), page: S("C\t$/)"), region: n
                  })
                }
              }(c), o.getSettings()
            }, "settings:setValue": function (e) {
              var t = n(e.group, e.name);
              t && t.set(S("#RDJRM"), e.value)
            }, "settings:getValue": function (e) {
              var t;
              return p.isUndefined(e.name) || !e.name ? g(e.group).getSettings() : (t = n(e.group, e.name)) ? t.get(S("2EUYCR")) : ""
            }, "settings:enable": function (e) {
              var t = n(e.group, e.name);
              t && t.set(S("5_D}W[YPXZ"), !0)
            }, "settings:disable": function (e) {
              var t = n(e.group, e.name);
              t && t.set(S("4\\ErVXXWYY"), !1)
            }
          }), c.on(S("\x0e{\x7f~~qug,e}j\x7fo&P\x7fvN"), function (e) {
            t = new r.Model({
              name: S("\x1eLEUVJJBU"),
              type: S("=\\J45--"),
              priority: 10,
              icon: S(",NEI\x1dBWG@\\XPK"),
              iconOnly: !0,
              label: e.finder.lang.settings.title,
              alignment: S("8J_XSSZ^28"),
              alwaysVisible: !0,
              action: function () {
                c.request(S("5FVV\\V\x01HRYX,$"), {name: S("\nxiyzf~va")})
              }
            }), e.data.toolbar.push(t)
          }), c.on(S(",]OAU]\bPXZER\x02J_OHTPX3"), function () {
            t && t.trigger(S("&AGJ_X"))
          })
        }
      }),CKFinder.define(S("#gn`NFMOY\x03`AKE]W@\x1bf^XJMYNHN\x11r/%'/7j\x15/';>(99="), [S("\x17mw~~nn}pRD"), S("\x1ay}~u}OOG")], function (i, r) {
        "use strict";
        var t = r.Collection.extend({comparator: S("A21-*4.<0")});
        return {
          createColumns: function (o, e) {
            var s = new r.Collection;
            i.forEach(e, function (e) {
              s.add({column: e, groups: new r.Collection, size: 0})
            });
            var t = o.reduce(function (e, t) {
              return e + t.get(S("\x1ahtrlkCTVP")).length
            }, 0), n = s.length, a = Math.ceil(t / n), l = 0;
            return o.forEach(function (e) {
              l < n - 1 && function (e) {
                var t = s.at(l).get(S(">L);'"));
                if (a < t) return !0;
                if (0 === t || e.get(S("4F^XJMYNHN")).length + t <= a) return !1;
                var n = (2 - l) * a, i = o.indexOf(e), r = o.reduce(function (e, t, n) {
                  return n < i ? e : e + t.get(S("*XDB\\[SDF@")).length
                }, 0);
                return r <= n
              }(e) && (l += 1);
              var t = s.at(l);
              t.get(S("C#7)28:")).push(e), t.set(S("\x14f\x7fm}"), t.get(S("3G\\LR")) + e.get(S("&T@FX_OXZ\\")).length), e.get(S(":HTRLK#460")).length
            }), s
          }, createCollection: function (e) {
            return new t(e)
          }
        }
      }),CKFinder.define(S("\n\x7fiuz.SZTzzqse7M\x7fvlq\x7fkER\rpLJTSK\\^X\x03j\\@EA\x1cW[A"), [], function () {
        return S("%\x1aS@LKO\x12''\x13DC\f9=<\nCP\x07\x06\x14HU\x005IH~7,e%+):9vn.%)}\":<&!5\",*w/5)2:BA\x06\x02\x10\x04K\x04\x03\x0fG\x18\x04\x02\x1c\x1b\x13\x04\x06^\x13\x07\x19\x02\bDX\0\x07@^\x16t/lbi`&zu+4pw,.fd?~rvpz7ed&4hu \x15)\x1d\rWV\x1b,\x1b\x07]BNMI\x10%\fEP\\PL\b\v\x17MXTXD\x005")
      }),CKFinder.define(S("E2\"0=k\b\x07\v'!44 |\x000;'48.>/r\r7\x0f\x13\x16\0\x11\x11\x15H;\x01\x05\x19\x18\x0e\x1b\x1b^\x15\x1d\x07"), [], function () {
        return S("-\x12[T\x11Q_UFE\n\x1aZQ]\x11NVP25!606k,-09irG54.q;'z&>8*-9.(.d;\x05\x07\v\r\r\x11\x0f\b\x06I\x17\x16fdR\x1c\0\x10\x1cS\x17\x19\x17\x04\vDX\x18\x17\x1bS\fhnpwgprt%zbd~ymzd1gz9wwe5ptsyowk\x02\x1f(*_^X\x07LLLBBDZF__\bXQL\f^\x18DG@G\x02\x1eV`\x7fbsd8;a&+9;wfh!2\"\"h/.i*%e198cTV\x1b\x1a]C\r\x11H\f\r\x10\x190L\x06\v\x16P,R\x0e\t\x7f\x7f~D\n\n\x1a\x12]\x1d\x13arq>&fma%zbd~ymzdb?aqtrrj4uupd<?ASKB\tMOCLLD\x16\x0eKOCCT\x10\rON\v\x17QM\x14PYDMd`*':d\x18h3-1>k10r`#!3=j__^d**:2},0\f\x04_A\x14\x17\x03\x14\r\x07\x1e\n\x18\x04\x01\x01RQ\x13\x01\x1d\x14[\x1f\x11\x1d\x1e\x1e\x12@\\\vrtg!:\x0f\x0f\x0e\x01rq4,dz!|p|t:f~xjmynhn0tEXQbFGTB^@K_EB@\\k\x11[G\x1a^SNKb\x1aPYD\x1ebn%+04)'>h\x14j61GGFYX)(iu?#v5;5;s-7\x0f\x13\x16\0\x11\x11\x15I\x03\f\x13\x18-\x0f\f\x1d\x15\x07\x1b\x12\0\x1c\x19\x19\v\"Z\x12\bS\x15\x1ayrY#o`\x7f'U'nb\x7f}bni1O3ih\x1c\x1e\x11\x10a`#\"cb*(+*-^]\x1a\b@^\x05GHW\\k\x11YVM\x15k\x19\\PIKP\\G\x1f=<HJML=<w47AEDr`#!3=j__,#fe&!WWV\x1b\x1a]C\r\x11H\v\t\x07\rE\x1f\x05\x01\x1d\x04\x12\x07\x07\x07[\x1d\x12\x01\n;\x19\x1e\x0f\x1b\ti`vjkku\\(bor,P.rmji.4|b9txt|2nvpRUAVPV\bLMPYjNO\\JFXSG]ZXDc\x19Q^E\x1dc\x1f=<98{z;:32wk'(7o-,)(k(+]Q\"!d! TV\\N\t\x01\0[\x1d\x1c\x16\x14\x17aeQA\x1c\0\x10\x1cMT\x0e\rWWSZ\b\x15\x13\x19\x13e!qsefc'dll\x7f,d`{u\x7ffz{{w{t`:ro=vzRD\x02WK\x05KFCL\nX\\L@\\\x10BWCUGWC]\x19UU\x1c^QR0(.&doig54@07332Zm}'0k\\k,=z80<-,]C\x01\b\x02H\x15\x0f\x07\x1b\x1e\b\x19\x19\x1dB\x14\x14\x01\x10\x06\x1c\x06\x03\x11\x16\x14YB\x06\x05^ hv-hddbd)wv0\"zk.\x1b")
      }),CKFinder.define(S("8zq}USZZ2n\x0f, 0*\";f\x19##?:,%%!|\x02<3 +v\t33/*<\x15\x15\x11'\r\x04\n\b\x0f?\x03\x0e\x1b"), [S('9ypzTP[%3m\x15- 14g\v+8)b\x07;5<\x04:1"'), S("'kblBBIK]\x1fg[VCF\x19uYJ_\x14\x7fRRS%\"6*++\x10.->"), S("\x0fSZTzzqse7Os~kn1]ARG\fgJKWGZC_I{GJG"), S("\x1ekEYV\x02gn`NFMOY\x03yKB@]SGQF\x19dPVHO_HJLo\x060,15h#'="), S("D1#?<h\t\0\n$ +5#}\x0718&;9-?(s\x0e60\x12\x15\x01\x16\x10\x16I4\0\x06\x18\x1f\x0f\x18\x1aA\x14\x1e\x06")], function (e, t, n, i, r) {
        "use strict";
        var o = e.extend({
          name: S("\x0e\\x~`gw`bAq|m"), tagName: S("@50"), template: r, templateHelpers: function () {
            return {keys: this.getOption(S("\x17s|ch"))}
          }
        }), s = n.extend({
          name: S("B\x10,*43+<>8\v?!: \x07;6#"),
          childViewContainer: S("\x19nysyg"),
          childView: o,
          tagName: S("$QGEDL"),
          className: S("E%,.d9##?:,%%!"),
          template: i,
          initialize: function (e) {
            this.collection = e.model.get(S("<NVP25!606"))
          },
          childViewOptions: function () {
            return {keys: this.getOption(S("\x14~snk"))}
          }
        }), a = t.extend({
          name: S("\x1aHtrlkCTVPgJJREG|BIZ"), template: "", childView: s, initialize: function (e) {
            this.collection = e.model.get(S("\x1dymOTRP")), this.once(S("\x14gsy||h"), function () {
              this.$el.addClass(S("(\\C\x06NAAL[\x1c") + this.model.get(S(":XSQKR.")))
            }, this)
          }, childViewOptions: function () {
            return {keys: this.getOption(S("A)&=6"))}
          }
        });
        return t.extend({
          name: S("@\x12*,61%2<:\x06\"?9'!7"),
          childView: a,
          className: S('4@_\x1a_KS_\x11_\x1eJ)l0&75)); <.l.%)}":<&!5",*w?5<20\x07'),
          template: "",
          childViewOptions: function () {
            return {keys: this.getOption(S("1YVMF"))}
          }
        })
      }),CKFinder.define(S("!ahbLHCM[\x05fCI[CUB\x1d`\\ZDC[LNH\x13nVP25!606"), [S("\x10d|wqgetwk\x7f"), S("\x15tv{rxtrx"), S("<~uy)/&&6j\x133!%e\0)4\r 44"), S("\fNEIy\x7fvvf:[x|lv~o2MwOSV@QQU\beFNN@^\x01|X^@GW@BD"), S("\x1c^UYIOFFV\nkHL\\FN_\x02}G_CFPAAE\x18nP_LO\x12mW/36 115\x03!(&$+\x1b'*'"), S("\rMDVx|wqg9Aq|mh3_\x7flE\x0eaLHICD\\@EEzDKX"), S("C\x07\x0e\0.&-/9c\x1b'*'\"}\x115&3x\x1b67+3.7+\x057\v\x06\x13")], function (r, o, e, s, a) {
        "use strict";
        return function (t) {
          t.request(S(",FKV\n][@@PX"), {key: e.slash}), t.on(S("\x1cv{fDNUM\x1e") + e.slash, function (n) {
            if (n.finder.util.isShortcut(n.data.evt, S("\x12`||pc"))) {
              var e = s.createCollection();
              n.finder.fire(S("4F^XJMYNHN\x04S)26"), {groups: e}, n.finder);
              var i = {
                esc: {display: S("B&7&"), text: t.lang.shortcuts.keys.escape},
                del: {display: S("\x1e{EM"), text: t.lang.shortcuts.keys.delete},
                ctrl: {display: S("#GQTK"), text: t.lang.shortcuts.keys.ctrl},
                downArrow: {display: S("\x1e9D@PQ\x1f"), text: t.lang.shortcuts.keys.downArrow},
                leftArrow: {display: S("?f-#16~"), text: t.lang.shortcuts.keys.leftArrow},
                question: {display: "?", text: t.lang.shortcuts.keys.question},
                rightArrow: {display: S(",\v\\NBC\t"), text: t.lang.shortcuts.keys.rightArrow},
                upArrow: {display: S("0\x17GRFG\r"), text: t.lang.shortcuts.keys.upArrow}
              };
              e.forEach(function (e) {
                var t = new o.Collection;
                n.finder.fire(S("-]G_CFPAAE\rTPIO\x06") + e.get(S("0_S^Q")), {
                  keys: i,
                  shortcuts: t
                }, n.finder), e.set(S("\f~f`beqf`f"), t)
              }), e.forEach(function (e) {
                e.get(S("'[AEYXN[[C")).forEach(function (e) {
                  var t = [];
                  r.forEach(e.get(S("\x1ahtrlkCTVP")).split("|"), function (e) {
                    t.push(e.replace(/{|}/g, "").split("+"))
                  }), e.set(S("\x0e|x~`gw`bd"), t)
                })
              }), n.finder.request(S("0U[RXZQ"), {
                name: S("/cY]A@VCCK}SZPRY"),
                title: n.finder.lang.shortcuts.title,
                view: new a({finder: t, collection: s.createColumns(e, ["a", "b", "c"]), keys: i}),
                buttons: [S('"LOfJH[L')],
                restrictHeight: !0
              })
            }
          }), t.on(S("%UOG[^HYY]\x15\\XAG\x0eRSY]K[W"), function (e) {
            e.data.shortcuts.add({label: e.finder.lang.shortcuts.general.listShortcuts, shortcuts: S("4NGB]JNRSSC")})
          }, null, null, 70)
        }
      }),CKFinder.define(S("5u|~PT_YO\x11r/%7/!6i\x14<(>>?\x0f/=\x7f\x07;6#&y\x04,8../\x1f?-6\b\x07\x14"), [S("\x11xbapdn"), S("\x1d]TfHLGAW\tr\\@F\x04gHWl_UW"), S(";\x7fvxV.%'1k\x13/\"?:e\t->+`\x14(<29<5\x1b9 5.(\v7:\x17")], function (t, n, e) {
        "use strict";
        return e.extend({
          name: S("\f^znddaQug@~}n"),
          template: S("\x1c!zvV\x01AOEVU\x1a\nJAM\x01^ZNDDA\x1eVTD\x1aJ\\]RSSM\x1d~}m'-3x"),
          className: S(")I@J\0][QEG@VTD"),
          attributes: {
            "data-role": S("\x12u{zbrj"),
            "data-position": S("\x19|rdxz"),
            "data-tap-toggle": S("9\\ZPN["),
            role: S(" RVBPPU"),
            tabindex: 50
          },
          ui: {regions: S("*\x05OFH\x02CESGAF\x1bUYK\x17IYZWP.2")},
          events: {
            keydown: function (e) {
              e.keyCode === n.tab && (this.finder.util.isShortcut(e, "") || this.finder.util.isShortcut(e, S("C7-/!<"))) && this.finder.request(this.finder.util.isShortcut(e, "") ? S("5PX[LI\x01RXFK") : S("'NFI^_\x17^]UG"), {
                node: this.$el,
                event: e
              })
            }
          },
          initialize: function (e) {
            this.once(S("\x10cw}ppd"), function () {
              this.$el.attr(S("0P@ZU\x18ZVZ\\V"), e.label)
            }, this)
          },
          onRender: function () {
            var e = this;
            setTimeout(function () {
              e.$el.toolbar(), e.$el.toolbar(S("2FDQWC]i[\\Ym_[$(,$")), t.mobile.resetActivePageHeight()
            }, 0)
          }
        })
      }),CKFinder.define(S("\nHGKgatt`<Yzrbt|i4Oi\x7fkUR`BV\nuSI]_XnL\\"), [S("*A]XK]I"), S(",OOL[S]]Q"), S("\nHGKgatt`<Yzrbt|i4Oi\x7fkUR`BV\npNM^Y\x04\x7fYO[EBpRFc_RO")], function (e, t, r) {
        "use strict";
        return function (n) {
          this.bars = new t.Collection;
          var i = this;
          (i.finder = n).setHandlers({
            "statusBar:create": function (e) {
              if (!e.name) throw S("%tBY\\OXX\r][QEG@vTD\x17[K_ZHX\x1eQ%$&0d+'*-i:*>,#*$4 ");
              if (!e.page) throw S(')xN]XK\\D\x11AGUACDzXH\x01_O[^4$b-! "4h9+,)m>."0?6 0$');
              var t = new r({finder: i.finder, name: e.name, label: e.label});
              return i.bars.add({
                name: e.name,
                page: e.page,
                bar: t
              }), t.render().$el.appendTo(S("C\x1f!'3)d) *`>.74oq") + e.page + S("\f/S")), n.fire(S("\x17km{oin\\~R\x1bAQADRB"), {
                name: e.name,
                page: e.page
              }, n), t
            }, "statusBar:destroy": function (e) {
              var t = i.bars.findWhere({name: e.name});
              t && (n.fire(S("\x12``tbbk[{i&y{lTSMZ\x1e") + e.name, null, n), t.get(S(".MQC")).destroy(), i.bars.remove(t))
            }, "statusBar:addRegion": function (e) {
              var t = i.bars.findWhere({name: e.name});
              t && t.get(S(".MQC")).createRegion({id: e.id, name: e.id, priority: e.priority ? e.priority : 50})
            }, "statusBar:showView": function (e) {
              var t = i.bars.findWhere({name: e.name});
              t && t.get(S("\x18{{i"))[e.region].show(e.view)
            }
          })
        }
      }),CKFinder.define(S("C\x07\x0e\0.&-/9c\0!+%=7 {\x01984;;)/r\b6\x05\x16\x11L0\n\t\v\n\b\x18)\x19\x19\x1a\0\x1e'\x1b\x16\x03"), [S("#QKBBZZID^H"), S(">|\v\x07+-  4h\x1e /<?b\f.#4}\x1a 0;\x011<-")], function (t, e) {
        "use strict";
        return e.extend({
          tagName: S(";^HJK//"),
          name: S("\x19Ntsq|~RhVFIgSS\\FD"),
          template: S("-UT\r\x11[G\x1aYWU]U\x1aFA"),
          modelEvents: {
            "change:isDisabled": function (e) {
              e.get(S("5_D|PIZ^Q[[")) ? this.$el.addClass(S(">J)l17%1#j, 9*.!++")).attr(S("\fl|fq<vzgtt{}}"), S("1FAAP")) : this.$el.removeClass(S(".ZY\x1cAGUAS\x1a\\PIZ^Q[[")).attr(S("\ro}yp?w}fwut|~"), S("5PVTJ_"))
            }, focus: function () {
              this.$el.focus()
            }
          },
          events: {
            click: S("\x1dljN`AWMJH"), keydown: function (e) {
              this.trigger(S("3]ASZS\\C_SJP"), {evt: e, view: this, model: this.model})
            }, keyup: function (e) {
              e.preventDefault(), e.stopPropagation()
            }, focus: function () {
              this.$el.attr(S("0ESQ][RR@"), 1)
            }, blur: function () {
              this.$el.attr(S("\x14awuqw~~d"), -1)
            }
          },
          onRender: function () {
            this.$el.button()
          },
          runAction: function () {
            var e = this.model.get(S("7YZNRSS"));
            t.isFunction(e) && e(this)
          }
        })
      }),CKFinder.define(S('\x1d]TfHLGAW\tjGM_GI^\x01{_^^QUGE\x18nP_LO\x12jP/- "6\x13/"?'), [S("&RFMOY_NA]U"), S("B)50#51"), S("\x0fSZTzzqse7Os~kn1]ARG\fgJKWGZC_I{GJG"), S("\rMDVx|wqg9Aq|mh3_\x7flE\x0ekWAHpNM^"), S("3w~p^V]_I\x13pQ[5-'0k\x11)($++9?b\x18&5&!|\0:9;:8(\x19))*0\x0e7\v\x06\x13"), S("\fNEIy\x7fvvf:Ccqu5Pyd]pDD")], function (c, t, e, o, s, a) {
        "use strict";
        var n = 9e5, i = S("\x0fszt>`zy{zxh6ui{r\rIKG@@H");

        function r(e, t) {
          var n = e.finder.request(S(",XG\x15WTF~[QS")),
            i = [S("\x12p\x7fs;cwvvy}o3vTDO"), S('9YPZ\x10JP/- "6h$2<=%%'), S("&DCO\x07_CBBMQC\x1fZ@P[\x1a^VYNO\\\\S%a7*i'2)h<#f/\"<!5#\x7f289")];
          t.has(S("\x15u{yjiU}p{")) && i.push(t.get(S("#GIGT[gKFI"))), n !== S("\x15rrkrntl") || t.get(S("\x0fyr}}[{zn")) ? i.push(S("3A\\\x1bULW\x17R_RP\x12..6&<1")) : i.push(S(" TK\x0eFQH\nAJEE\x01") + (e.finder.lang.dir === S("=RK2") ? S("2_QSB") : S(":IUZVK"))), i.push(S("\x10d{>}vyy5") + t.get(S("\x1ar\x7frp")));
          var r = {"data-ckf-name": t.get(S("%HFEL")), title: t.get(S("4YWU]U")), tabindex: -1};
          return t.get(S("(@YoE^OM\\TV")) && (i.push(S("9OR\x11NJ^4$o'-6'%$,.")), r[S("\x17yksz1ywlACNF@")] = S("=JM5$")), t.has(S("\x11sg`g\x7fumm\x7fh")) && (r = c.extend(r, t.get(S("\x17ymniu\x7fkkER")))), s.extend({
            attributes: r,
            className: i.join(" ")
          })
        }

        function l() {
          var r = this, e = r.$el.find(S("*pHLZN\x1dBZ\\C\x18[XJ\\\x07\x19HOKZb\x1c"));
          if (e.hide(), e.attr(S("\x1aznt\x7f2HHFGAK"), S("\x10e`fq")), r.$el.enhanceWithin(), r.$el.toolbar(r.toolbarOptions), r.children.each(h), !(r.collection.length <= 2)) {
            var o, s, a = 0, l = 0, u = Math.floor(r.ui.items.width());
            c.forEach(r.collection.where({alwaysVisible: !0}), function (e) {
              var t = r.children.findByModelCid(e.cid).$el;
              t.is(S("\x0e5fxazvys")) && (l += Math.ceil(t.outerWidth(!0)))
            }), r.$el.find(S("Bm'. j<&%'.,<b9%7>")).addClass(i), r.$el.css(S("%KNF\x04]BHYF"), l), c.forEach(r.collection.sortBy(f), function (e) {
              var t = e.get(S("1FJDP"));
              if (t === S(",^F@G|]AQ") || e.get(S("\x1d\x7fsW@[PrLUNJEO"))) t === S("\x1elHNUnKWC") && (s = e); else {
                var n = r.children.findByModelCid(e.cid), i = Math.ceil(n.$el.outerWidth(!0));
                e.get(S("?((&'!+")) ? d(n) : u <= i + l ? (t === S("(K__XB@") && (a += 1), d(n), e.set(S("E5/'>\x07$>("), !0)) : l += i, a || (o = n)
              }
            }), a && (s.set(S("3\\\\RS]W"), !1), e.show(), e.removeAttr(S("\x1fASKB\tMOCLLD")), o && l + Math.ceil(e.outerWidth(!0)) > u && (d(o), o.model.set(S("\x1elHNUnKWC"), !0))), r.$el.find(S("\x187ypz0jpOM@BV\bOSMD")).removeClass(i);
            var t = r.collection.findWhere({focus: !0});
            if (t) {
              var n = r.children.findByModelCid(t.cid);
              n && n.$el.focus()
            }
          }
        }

        function d(e) {
          e.$el.hide(), e.$el.attr(S("\x12rf|w:pp~\x7fys"), S("1FAAP")), e.trigger(S("+DDJKU_"))
        }

        function f(e) {
          return (e.get(S("&FD^KR_{G\\YS^V")) ? n : 0) - e.get(S("=NM).0*0<"))
        }

        function h(e) {
          e.model.get(S("D$*./''.\"9")) !== S("A21-('51") && e.$el.addClass(S("\x1fCJD\x0ePJIKJHX\x06_HM@^USAM")), e.model.get(S("+XT^J")) === S(" BWPPJK") && e.$el.addClass(S('7[R\\\x16HRQS" 0n-1#*')), e.model.get(S("E'+?(38\x1a$=&2=7")) && e.$el.attr(S("\x17|xnz1~uy\r@NTE\\U\n^@YBNAK"), S("\x1djmUD"))
        }

        function u(t) {
          var e = t.collection.filter(function (e) {
            return !(!0 === e.get(S("\x1cuw{DDL")) || e.get(S("\x1cigoE")) === S("\x14vcdlvw") || e.get(S("=JF0$")) === S("&SMQ^"))
          }), n = [], i = [];
          return e.forEach(function (e) {
            e.get(S("3UY_PVT_UH")) === (t.finder.lang.dir === S("\x1awho") ? S("._BX_RFL") : S("/CTQ\\ZQWEA")) ? n.push(e) : i.unshift(e)
          }), n.concat(i)
        }

        return e.extend({
          name: S("\x19Ntsq|~RwKFS"),
          attributes: {"data-role": S("1ZVUQSE"), role: S("\x1d|~NOGQ")},
          childViewContainer: S("\x0e!szt>`zy{zxh6ui{rS"),
          template: S("*\x17HDX\x0fDPPZZQSO\x05\x1b\v\v\x1e\x1d]S!21~f&-!e=%$ //=}8&69&tw*66>a\x7f*0\x0f\r\0\x02\x16GX[G\r\x03\x1dR"),
          events: {
            keydown: function (e) {
              var t = e.keyCode;
              if (t === a.tab && this.finder.util.isShortcut(e, "")) this.finder.request(S("\x1a}s~kl\x1aOG[P"), {
                node: this.ui.items,
                event: e
              }); else if (t >= a.left && t <= a.down || t === a.home || t === a.end) {
                e.stopPropagation(), e.preventDefault();
                var n = u(this);
                if (!n.length) return;
                var i = this.finder.lang.dir === S("$IRU") ? a.end : a.home,
                  r = t === a.left || t === a.up || t === i ? n.length - 1 : 0;
                this.children.findByModel(n[r]).$el.focus()
              }
            }, "focus @ui.items": function (e) {
              if (e.target === e.currentTarget) {
                e.preventDefault(), e.stopPropagation();
                var t = u(this);
                if (t.length) {
                  var n = this.finder.lang.dir === S("\x15zcj") ? 0 : t.length - 1;
                  this.children.findByModel(t[n]).$el.focus()
                }
              }
            }
          },
          ui: {items: S("<\x13]T&l6,+)$&:d#?) =")},
          onRender: function () {
            var e = this;
            setTimeout(function () {
              e.$el.toolbar(e.toolbarOptions), e.$el.toolbar(S("%SWLH^N|LIJ`PVW][Q")), t.mobile.resetActivePageHeight(), e.$el.attr(S("*OMYO\x02SZT\x1e@ZY[ZXH"), e.name), e.finder.fire(S(":OSRR]!3x 6 '3-"), {
                name: e.name,
                page: e.page
              }, e.finder)
            }, 0)
          },
          initialize: function (e) {
            var s = this;
            s.name = e.name, s.page = e.page, s.toolbarOptions = {
              position: S("?&(:& "),
              tapToggle: !1,
              updatePagePadding: !0
            }, s.on(S("8K_UXXL\x05#../!&2.''"), function () {
              s.$el.addClass(S("\x10ryu9ayxt{{i"))
            }), s.on(S("\flz{qrzQasprj"), l, s), s.on(S(";_UWS$7+&3\x7f/3-$!.5)!8>"), function (e, t) {
              var n, i, r = t.evt;
              if (r.keyCode === a.up || r.keyCode === a.left || r.keyCode === a.down || r.keyCode === a.right) {
                r.stopPropagation(), r.preventDefault();
                var o = u(s);
                n = c.indexOf(o, e.model), i = r.keyCode === a.down || r.keyCode === a.right ? (i = n + 1) <= o.length - 1 ? i : 0 : 0 <= (i = n - 1) ? i : o.length - 1, this.children.findByModel(o[i]).$el.focus()
              }
              r.keyCode !== a.enter && r.keyCode !== a.space || (r.stopPropagation(), r.preventDefault(), c.isFunction(e.runAction) && e.runAction())
            })
          },
          getChildView: function (e) {
            var t = e.get(S("\fyw\x7fu"));
            return t === S("'K\\Y_C@") ? e.get(S(".YYTE")) : t === S("#WMIPeFXN") ? function (e, t) {
              return t.set({attributes: {"data-show-more": !0}, alwaysVisible: !0}), r(e, t)
            }(this, e) : t === S("\x15br`m") ? function (e, t) {
              var n = S("\x19ypz0jpOM@BV\bOSMD\nHGK\x03[_^^QUG\x1bC]AN");
              t.has(S("\x13wywdkW{vy")) && (n += " " + t.get(S(";_Q_L3\x0f#.!")));
              return o.extend({
                finder: e.finder,
                name: S("#pJIKJHXbXHC{UIF"),
                tagName: S("\x11vzb"),
                template: S('<FE\x02`(6m($$"$i76'),
                className: n,
                attributes: {"data-ckf-name": t.get(S("\x1fN@OF"))}
              })
            }(this, e) : t === S("1^ZZ^\x1bUMMNTR") ? function (e, t) {
              var n = e.finder.request(S(";IT\x04X%5\x0f,  ")),
                i = [S("B /#k3'&&)-?c&$4?"), S("*HGK\x03[_^^QUG\x1bUMMNTR"), S('+OFH\x02D^]_VTD\x1aQM_V\x11[Q\\52#!( f2!d(?"m;&}2=!:0$z956')];
              t.has(S(",NBNCB|RYP")) && i.push(t.get(S("C')'4;\x07+&)")));
              n !== S("\noi~e{\x7fa") || t.get(S("\x0fyr}}[{zn")) ? i.push(S("\x19or1\x7fjq\rHALJ\bHH\\LR_")) : i.push(S("1GZ\x19WBY\x15PYTR\x10") + (e.finder.lang.dir === S("8UNI") ? S("&KMO^") : S("\x0fbxu{`")));
              i.push(S("(\\C\x06ENAA\x1d") + t.get(S(",DM@^")));
              var r = {
                "data-ckf-name": t.get(S('A,") ')),
                title: t.get(S(".CQSW_")),
                tabindex: -1,
                href: t.get(S("=VM%'")),
                role: S("\niyyz`~")
              };
              t.get(S("D,5\x03!:+) (*")) && (i.push(S(".ZY\x1cAGUAS\x1a\\PIZ^Q[[")), r[S("E'5!(g/%>/-<46")] = S("6CJL_"));
              t.has(S("\x13uabeq{ooyn")) && (r = c.extend(r, t.get(S(':ZHILV"46&7'))));
              return o.extend({
                finder: e.finder,
                name: S("\fYa`|ssa]aszZlnoss\\jTUMM"),
                tagName: "a",
                className: i.join(" "),
                template: S("\x1f[Z\x1f\x03MQ\bKIKOG\fPS"),
                attributes: r,
                events: {
                  keyup: function (e) {
                    e.keyCode !== a.enter && e.keyCode !== a.space && this.trigger(S("\x14|brur\x7fbxriq"), {
                      evt: e,
                      view: this,
                      model: this.model
                    })
                  }, keydown: function (e) {
                    this.trigger(S("\x1arhxstEXFLSK"), {evt: e, view: this, model: this.model})
                  }
                }
              })
            }(this, e) : r(this, e)
          },
          focus: function () {
            t(this.childViewContainer).focus()
          }
        })
      }),CKFinder.define(S("(jamECJJB\x1e\x7f\\P@ZRK\x16nTSQ\\^22m\x17+**%);"), [S("\n~bik}cr}aq"), S("7RHO^ND"), S("\x10ssp\x7fwyy}"), S("\x1fcjdJJACU\x07dEOYAK\\\x1fe]\\XWWEK\x16lRYJM\x10\x14.-/&$4\x11!,="), S("\x10RYU}{rrj6WtxhrzS\x0eaLJQC_\\dOEY\x02xFUFA\x1cwZXC]ANvYSKi)$5")], function (r, e, o, n, s) {
        "use strict";
        var t = o.Model.extend({
          defaults: {
            type: S("\vnxz{\x7f\x7f"),
            alignment: S("\r~}y|sam"),
            priority: 30,
            alwaysVisible: !1
          }
        }), a = o.Collection.extend({
          model: t, comparator: function (e, t) {
            var n = e.get(S("/Q][TZXSYL"));
            if (n !== t.get(S("(HFBKCCJ^E"))) return n === S("0A@ZYTDN") ? -1 : 1;
            var i = e.get(S("@10*+7/31")), r = t.get(S("D54.';#?5"));
            if (i === r) return 0;
            var o = n === S("5FEQT[IE") ? 1 : -1;
            return i < r ? o : -1 * o
          }
        });

        function i(e, t) {
          this.name = t, this.finder = e, this.currentToolbar = new a
        }

        return i.prototype.reset = function (e, t) {
          var n = this, i = r.extend({toolbar: new a}, t);
          n.finder.fire(S("\x1ekONNAEW\x1cUMZO_\x16") + n.name, i, n.finder), e && n.finder.fire(S("$QIHDKKY\x16_K\\UE\b") + n.name + ":" + e, i, n.finder), i.toolbar.push({
            name: S("#wMIPeFXN"),
            icon: S('D&-!e$%9)`8*"%;059'),
            iconOnly: !0,
            type: S("/CY]DyZDR"),
            label: n.finder.lang.common.showMore,
            priority: -10,
            hidden: !0,
            action: function () {
              var t = new o.Collection;
              n.currentToolbar.chain().filter(function (e) {
                return !!e.get(S("9ISSJsP2$"))
              }).forEach(function (e) {
                t.push({
                  action: e.get(S(",LM[Y^\\")),
                  isActive: !0,
                  icon: e.get(S("\x17qzuu")),
                  label: e.get(S("(EKIIA")),
                  hidden: !1
                })
              });
              var e = n.toolbarView.children.findByModel(n.currentToolbar.findWhere({type: S("2@\\ZAzWK_")}));
              n.currentToolbar.showMore = new s({
                finder: n.finder,
                collection: t,
                positionToEl: e.$el
              }).render(), n.currentToolbar.showMore.once(S("*OI^Z]_H"), function () {
                n.currentToolbar.showMore = !1, e.$el.focus()
              })
            }
          }), n.currentToolbar.reset(i.toolbar.toArray())
        }, i.prototype.init = function (e, t) {
          this.toolbarView = new n({
            finder: e,
            collection: this.currentToolbar,
            name: this.name,
            page: t
          }), this.toolbarView.on(S("\x11q{}yraq|m!ttz{EO"), function (e) {
            e.model.set(S("\x1dvvDEGM"), !0)
          }), this.toolbarView.render().$el.prependTo(S("/kUSGU\x18U\\^\x14JZ[X\x03\x1d") + t + S("2\x11i"))
        }, i.prototype.destroy = function () {
          this.toolbarView.destroy(), this.currentToolbar.reset()
        }, i.prototype.redraw = function () {
          this.currentToolbar.forEach(function (e) {
            if (e.get(S(":OEM[")) !== S("\x18jrtkPqmE") && e.set(S("'@@NOIC"), !1), e.has(S("D*(\x15--8*;"))) {
              var t = e.get(S("'GGxNH_OX"));
              r.isFunction(t) && t.call(e)
            }
          }), this.toolbarView.render()
        }, i.prototype.hideMore = function () {
          this.currentToolbar.showMore && this.currentToolbar.showMore.destroy()
        }, i
      }),CKFinder.define(S("'kblBBIK]\x1f|]WAYSD\x17mUTP__M3n\x16,+)$&::"), [S(" KSVAW_"), S("\x1chp{ESQ@KWC"), S(")HJOFL@^T"), S("7{r|RRY[Mo\f-'1)#4g\x1d%$ //=#~\x06<;946*"), S('@\x02\t\x05-+"":f\x1f?%!a\x045(\x11<00')], function (o, s, e, i, a) {
        "use strict";
        var l = S("B /#k3'&&)-?c99\";180");

        function t() {
          this.toolbars = new e.Collection
        }

        function u(e) {
          e.get(S("'\\FEGNL\\")).destroy(), this.toolbars.remove(e), this.finder.fire(S("E2('%(*>w**#% <-"), {name: e.get(S(",COBU"))}, this.finder)
        }

        return t.prototype = {
          getHandlers: function () {
            return {
              "toolbar:create": {callback: this.toolbarCreateHandler, context: this},
              "toolbar:reset": {callback: this.toolbarResetHandler, context: this},
              "toolbar:destroy": {callback: this.toolbarDestroyHandler, context: this}
            }
          }, setFinder: function (t) {
            !function (t) {
              t.request(S("\x19q~e'rvSUGM"), {key: a.f7}), t.on(S('\x10zwjpzay"') + a.f7, function (e) {
                t.util.isShortcut(e.data.evt, S("\x14tzc")) && (e.data.evt.preventDefault(), e.data.evt.stopPropagation(), o(S("%\bRA\x04ZJKH\x03NSE[EQ\x15\x18TS_\x17OSRR]!3o*0 +4")).focus())
              }), t.on(S("9ISSOJ\\551y(,53r./%)?/#"), function (e) {
                e.data.shortcuts.add({
                  label: e.finder.lang.shortcuts.general.focusToolbar,
                  shortcuts: S("0JS_@H\x1dL^\x0eG")
                })
              }, null, null, 20)
            }(this.finder = t);
            var n = 0;
            t.on(S("E3.r;/8%7+"), function () {
              var e = o(document).width();
              n !== e && r(t.request(S("\x1eoAFG\x19GPTUMG^")))
            }), t.on(S('<HW\x05"-71'), function () {
              i.toolbars.where({page: t.request(S("&WINO\x11OX\\]U_F"))}).forEach(function (e) {
                e.get(S("#PJIKJHX")).hideMore()
              })
            });
            var i = this;

            function r(e) {
              i.toolbars.where({page: e}).forEach(function (e) {
                e.get(S("-Z@_]PRF")).redraw()
              }), n = o(document).width()
            }

            t.on(S("\x1fP@EF\x1eVNH_"), function (e) {
              var t = e.data.page;
              r(t), i.toolbars.where({page: t}).length ? o(S(".M_UK")).addClass(l) : o(S("\rl`th")).removeClass(l)
            }), t.on(S("\x1eoAFG\x19@@USZFS"), function (e) {
              s.forEach(this.toolbars.where({page: e.data.page}), u, this)
            }, this)
          }, toolbarCreateHandler: function (e) {
            this.toolbarDestroyHandler(e);
            var t = new i(this.finder, e.name);
            this.toolbars.add({page: e.page, name: e.name, toolbar: t}), t.init(this.finder, e.page);
            var n = this.finder.request(S("$UG@M\x13I^^_KAD"));
            e.page === n && o(S("/R^VJ")).addClass(l)
          }, toolbarDestroyHandler: function (e) {
            var t = this.toolbars.where({name: e.name})[0];
            t && (u.call(this, t), t.page === this.finder.request(S("\x11brsp,tmkh~ri")) && o(S("\x1e}OE[")).removeClass(l))
          }, toolbarResetHandler: function (e) {
            var t = this.toolbars.where({name: e.name})[0];
            if (t) {
              var n = s.extend({}, e.context);
              t.get(S("'\\FEGNL\\")).reset(e.event, n)
            }
          }
        }, t
      }),CKFinder.define(S("3w~p^V]_I\x13pQ[5-'0k\x106+'(.\r%!+\r%%&<:z\x03'46;?\x1a42:\"\x14\x16\x17\v\v"), [S("\x11QXR|xs}k5Nhtr0kD[`KAC")], function (n) {
        "use strict";

        function t(e) {
          e.finder.request(S("*MCAJJB\vUV@tUCQO_")).get(S("\x1b}~r")).fileUpload && e.data.toolbar.push({
            name: S("C\x115*()-"),
            type: S("3V@BCWW"),
            priority: 80,
            icon: S("0RYU\x19@F[WX^"),
            label: e.finder.lang.common.upload,
            action: function () {
              e.finder.request(S("\x10db\x7f{tr"))
            }
          })
        }

        return function (e) {
          e.on(S(':OSRR]!3x1!6#3r\x04+""w( <57!'), t), e.on(S("*_CBBMQC\bAQFSC\x02t[RR\x07XV,$"), t), e.on(S("\x14ayxt{{i&o{lEU\x18nELH\x1dN@FN_"), t), function (t) {
            t.request(S("\x12xql,{qjn~r"), {key: n.u}), t.on(S("1YVMQY@V\x03") + n.u, function (e) {
              t.util.isShortcut(e.data.evt, S("\x0en|e")) && t.request(S("\fx~c\x7fpv"))
            }), t.on(S("!QKKWRD]]Y\x11@D][\nW[_QF"), function (e) {
              e.data.shortcuts.add({label: e.finder.lang.shortcuts.files.upload, shortcuts: S("<F_S4<i818")})
            }, null, null, 40)
          }(e)
        }
      }),CKFinder.define(S(")i`jD@KUC\x1d~[QC[]J\x15vSYKS%2"), [S("%SILLXXOB\\J"), S("\fool{s}}q"), S("\fNEIy\x7fvvf:[x|lv~o2]lRGvLO@HjIGKLI_\x01lCCTg[^SYuXTZ[XL"), S('*hgkGATT@\x1cyZRBT\\I\x14\x7fRPQ%"6,6j\x05(&\'/(8"<'), S("0ryu][RRJ\x16wTXHRZ3n\x01,*1#?<\x04/%9b\r >%7+ \x1839-"), S("\x17[R\\rry{m\x0flMGQICT\x07jXNMYKi_]VVF\x1auE]XN^zRR[%3"), S('0ryu][RRJ\x16wTXHRZ3n\x06&( 2"\x0e &.c\t+#5%7\x15=93'), S('2p\x7fs_Y\\\\H\x14qRZJ,$1l\0 *"<,\f$ )+=\x7f\x157?1!3\x1175>>.'), S("\x1fcjdJJACU\x07dEOYAK\\\x1fu[RXZQD\x17}SZPRYL"), S('@\x02\t\x05-+"":f\x07$(8"*#~\x177=!\x1f:9>?t\x1997+)\f\x03\x04\x01'), S("\x18ZQ]uszzR\x0eoL@PJB[\x06lB@Hj@G_^\\UQ\x19qQU_\x7fSJPS/ &"), S("0ryu][RRJ\x16wTXHRZ3n\x04*( \x165-?#.;b\b&<4\x02!1#?2/"), S(".l{w[]PPD\x18uV^NPXM\x10\x06(.&7j\0.$,9"), S("&dcoCEHH\\\0}^VFXPE\x18~PV^OpQI%\x02-3=j\0.$,9\x06#;+\f?!+"), S("\nHGKgatt`<Yzrbt|i4Zr}jSlCMEBCU\x07oEHY^cN^PUVF"), S("/sztZZQSE\x17tU_IQ[Lo\x07-/  44g\x0f%'((<<"), S('"`ocOILLX\x04aBJZ\\TA\x1crZDZmIVT]Y\x11y/3/\x164))&,'), S("0ryu][RRJ\x16wTXHRZ3n\n7))s\x128%%*(b\x06;==g\x06$996<"), S("-mdvX\\WQG\x19zW]OWYN\x11t%8\x0e*71#)-;e\0)4\x02&#%7=1'"), S("\fNEIy\x7fvvf:[x|lv~o2RpAEGQ\viIFLLX"), S("\x0eL[W{}ppd8Uv~npxm0m@ZJIL\\B\x07dKSE@GUU"), S("%eln@DOI_\x01b_UG_QF\x19gY^_H\x13m_X%2"), S("\vOFHf~uwa;Xysmu\x7fh3M\x7fqEMQ\ftDHBDZ"), S('"`ocOILLX\x04aBJZ\\TA\x1cfPXVU\\|RPX\x11m%/#.!\x03/+-'), S('\'kblBBIK]\x1f|]WAYSD\x17k_U]P[y/-&&6j\x14"&(\'.\n""+5#'), S("\x0fSZTzzqse7Tu\x7fiq{l\x0fgKOP@TaAEOX\x03kGCDT@u]YSD"), S('@\x02\t\x05-+"":f\x07$(8"*#~\x016 !?9?*u\b9)*6\x0e\x06\x11'), S(".l{w[]PPD\x18uV^NPXM\x10\x13)-10&33;f\x19##?:,%%!"), S('7{r|RRY[Mo\f-\'1)#4g\x1a>*88=\r1#}\0 4""+\x1b;)'), S("C\x07\x0e\0.&-/9c\0!+%=7 {\x01984;;)/r\n0\x0f\r\0\x02\x16\x16"), S("\x17[R\\rry{m\x0flMGQICT\x07|ZGCLJiY]WqAABXV\x16oKPR_[\x06(.&\x06023''")], function (r, e, t, n, i, o, s, a, l, u, c, d, f, h, g, p, v, m, w, y, C, b, _, x, E, M, F, I, R, T, O) {
        "use strict";
        var B = [S("\x19Yiy|jzfNNGAW"), S("\vHhbjdtTzxp"), S("\x18]\x7fwyi{YOMFFV"), S("&bL@^bALIJ"), S("\x1a]uq{lmNTFgJV^"), S("'nFXFy]B@QU"), S(".gD\\^\x06aEZXY]"), S("\f_kaq|wU}ys"), S('?\x12$,") \0($-/9'), S("\x12Fdyyv|_swy_kkTNL")],
          P = {
            CsrfTokenManager: t,
            Connector: n,
            ContextMenu: i,
            CreateFolder: o,
            DeleteFile: s,
            DeleteFolder: a,
            Dialogs: l,
            EditImage: u,
            FileDownload: c,
            FilePreview: d,
            Files: f,
            FilesMoveCopy: h,
            Folders: p,
            FocusManager: g,
            FormUpload: v,
            Html5Upload: m,
            KeyListener: w,
            Loader: y,
            Maximize: C,
            Pages: b,
            Panels: _,
            RenameFile: x,
            RenameFolder: E,
            FilterFiles: M,
            Settings: F,
            Shortcuts: I,
            StatusBar: R,
            Toolbars: T,
            UploadFileButton: O
          };

        function A(e, t, n) {
          if (P[e] && (!n || !r.contains(n, e))) {
            var i = new P[e](t.finder);
            t.add(i), i.getHandlers && t.finder.setHandlers(i.getHandlers()), i.setFinder && i.setFinder(t.finder)
          }
        }

        return e.Collection.extend({
          init: function (e) {
            var t = this, n = (t.finder = e).config.readOnlyExclude.length ? e.config.readOnlyExclude.split(",") : [],
              i = !!e.config.readOnly && r.union(B, n);
            e.config.removeModules && (i = r.union(i || [], e.config.removeModules.split(","))), A(S("\x11^|uqse"), t, i), A(S("\x0eI\x7frg`Ytxv\x7f|h"), t, i), A(S("\x1dUzYmKPP@HBZ"), t, i), A(S("\x10RaarAy|}wWzr|yzR"), t, i), A(S(",nAA^TQG[G"), t, i), A(S("\x1aHyijvNFQ"), t, i), A(S("6gYW_WO"), t, i), A(S("\fIgn|~u`"), t, i), A(S(";\x7fRPK%96\x0e!+3"), t, i), A(S("\v\\lijc"), t, i), A(S("B\x17+**%);9"), t, i), A(S("\x1eLT@VVWgGU"), t, i), A(S("<{WS%2"), t, i), A(S("\x1ffNNGAWU"), t, i), A(S('D\x064")=/\r#!**"'), t, i), A(S(".kU]WGQsY[\\\\H"), t, i), A(S(">m%/#.!\x03)+,,8"), t, i), A(S("\x1c[wsERoLR@eHXP"), t, i), A(S("\f_kaq|wU}ys"), t, i), A(S("+hHBJDTtZXP"), t, i), A(S(")b_AA\x1bz@]]RP"), t, i), A(S("\x1bZrlruQNLEA"), t, i), A(S("\x1dKoLNCGbLJBj\\^_CC"), t, i), A(S("\x0eIy}fvfS\x7f{}j"), t, i), A(S("/}PJZY\\LR"), t, i), A(S(":}UQ[o2$4*!2"), t, i), A(S("6qQU_\x7fSJPS/ &"), t, i), A(S("\fHjfdX\x7frsp"), t, i), A(S("<nVP25!606"), t, i)
          }
        })
      }),CKFinder.define(S("\x15U\\^pt\x7fyo1IIDUP\vqCJXEK_InOLXT"), [S(" TLGAWUDG[O"), S("2W[a")], function (o, s) {
        "use strict";

        function e(e) {
          this.finder = e, this._templates = {}
        }

        return e.prototype.has = function (e) {
          return !!this.get(e)
        }, e.prototype.get = function (e) {
          return this._templates[e]
        }, e.prototype.compile = function (e, t, n) {
          o.isFunction(n) && (n = n.call(this));
          var i = {imports: n, name: e, template: t};
          this.finder.fire(S("/DT_CXTBR"), i, this.finder), this.finder.fire(S("7L\\WKP\\JZz") + e, i, this.finder);
          var r = s.template(i.template, null, i.imports);
          return this._templates[e] = r
        }, e
      }),CKFinder.define(S("C\x07\x0e\0.&-/9c\x1b'*'\"}\x0718&;9-?\t93::\x12\x04\x10"), [S("(\\DOI_]L_CW"), S("'EHXBCCK[DT")], function (s, a) {
        "use strict";

        function e(e) {
          this.finder = e
        }

        return e.prototype.render = function (e, t, n, i) {
          var r;
          if (!(r = this.finder.templateCache.has(t) ? this.finder.templateCache.get(t) : this.finder.templateCache.compile(t, n, {}))) throw new a.Error({
            name: S('8lT_Y[WQ%%\x16&)5*&<,\x0f9>"<'),
            message: S("\x1d]~NOMW\x04WCILLX\vXEK\x0fDT_CXTBR\x18JSU_X\x1eV4a+0d+3+$i%9l8 +57;=11x")
          });
          var o = s.extend(this.mixinTemplateHelpers(e.toJSON(), i));
          return a.Renderer.render(r, o)
        }, e.prototype.mixinTemplateHelpers = function (e, t) {
          return e = e || {}, s.extend(e, {lang: this.finder.lang, config: this.finder.config}, t)
        }, e
      }),CKFinder.define(S("\x11QXR|xs}k5ZlmrvC@VJKK"), [S("\x1biszzRRALV@"), S("%LV]LXR"), S("\nocY"), S("3VTU\\ZVT^"), S("3w~p^V]_I\x13~QQ&(%"), S("7{r|RRY[Mo\x044&*1"), S(".l{w[]PPD\x18mMSW\x13hJV,"), S("\x14V]Qqw~~n2KkIM\roEKA"), S("$fmaAGNN^\x02{f\x1fd{{UV]D"), S("(jamECJJB\x1eb_AR_YK\x16jWIZWQ3"), S('8zq}USZZ2n\x0f, 0*";f\x07$(8"*#'), S('?\x03\n\x04**!#5g\x1f#.;>a\x1b5<"?5!3\x149:2>'), S("\x1e\\kgKM@@T\b~@O\\_\x02zJ]A^R@PdRV]_IYO")], function (o, e, t, r, n, s, a, l, u, c, d, f, h) {
        "use strict";
        return t.templateSettings.doNotSkipEncoded = !0, {
          start: function (n) {
            n.type && (n.resourceType = n.type);
            var i = {
              _reqres: new r.Wreqr.RequestResponse,
              _plugins: new c,
              _modules: new d,
              config: n,
              util: a,
              Backbone: r,
              _: o,
              doT: t
            };
            return i.templateCache = new f(i), i.renderer = new h(i), i.hasHandler = function () {
              return this._reqres.hasHandler.apply(i._reqres, arguments)
            }, i.getHandler = function () {
              return this._reqres.getHandler.apply(i._reqres, arguments)
            }, i.setHandler = function () {
              return this._reqres.setHandler.apply(i._reqres, arguments)
            }, i.setHandlers = function () {
              return this._reqres.setHandlers.apply(i._reqres, arguments)
            }, i.request = function () {
              return this._reqres.request.apply(i._reqres, arguments)
            }, o.extend(i, s.prototype), i.on(S("4VYZUXT_\x06XLM/3"), p, i), i.on(S("7[VWV]SZ\x05%30,6\x7f\x0f)!="), function () {
              e(S(";TISS")).removeClass(S("\r{f=|}q}ys:j|t\x7fyowqG"))
            }), i.on(S("\nj|}4jbc}a"), function (e) {
              alert(S("#gJSKL\tDDX\r][QCF\x13w~p^V]_I\x06\x1d") + e.data.msg)
            }), i.on(S("\x0fcy}a`vcck#vroi"), function (e) {
              e.data.groups.add({name: S('"DAKCUIE'), priority: 10, label: e.finder.lang.shortcuts.general.title})
            }), i.on(S("$VNHZ]I^X^\x14CYBF\tSPXRJXV"), function (e) {
              e.data.shortcuts.add({
                label: e.finder.lang.shortcuts.general.action,
                shortcuts: S("$^CI\\LXV")
              }), e.data.shortcuts.add({
                label: e.finder.lang.shortcuts.general.focusNext,
                shortcuts: S("\npxllr")
              }), e.data.shortcuts.add({label: e.finder.lang.common.close, shortcuts: S("\x1a`yn}b")})
            }, null, null, 60), i.once(S("6GTL]RR\x07_S,\x13'\" <"), g, i), l.init(i.config).fail(function () {
              i.fire(S("$DVW\x12LXYC_"), {msg: S("\nGmcizqvw3r|zr8pi;qtmlIOE\x03KW\x06EZFANB")}, i)
            }).done(function (e) {
              i.lang = e;
              var t = n.skin;
              t.indexOf("/") < 0 && (t = S("5E\\QWI\x14") + t + S("\x1d1lKHL")), window.CKFinder.require([t], function (e) {
                o.isFunction(e.init) && (e.path = i.util.parentFolder(t) + "/", e.init(i)), u.init(i), i._plugins.load(i)
              })
            }), i
          }
        };

        function g() {
          var e, t, n;
          (function (e) {
            var t, n = e.config, i = {ckfinder: e}, r = S(".L[W[]PPDe]X^B");
            try {
              t = new CustomEvent(r, {detail: i})
            } catch (e) {
              (t = document.createEvent(S("\x0eJft|g"))).initEvent(r, !0, !1), t.detail = i
            }
            window.dispatchEvent(t), o.isFunction(n.onInit) ? n.onInit(e) : "object" == typeof n.onInit && n.onInit.call(void 0, e)
          })(n = this), n._modules.init(n), t = n.config.resourceType, e = {name: S("*bBDZ")}, t && (e.params = {type: t}), n.once(S("-M@]\\S]P\x0fY\\\x02pTRH"), function (e) {
            n.config.initConfigInfo = e.data.response
          }, null, null, 1), n.once(S("\x1d}pMLCM@\x1fIL\x12`DBX"), function () {
            n.fire(S("7YIJ\x01OI_M4"), {}, n)
          }, null, null, 999), n.once(S("\x1d}pMLCM@\x1fIL\x12nO_jDBJC"), function () {
            n.fire(S("\x12rde,e}x~b"), {}, n)
          }, null, null, 999), n.fire(S(".N@A\b_[TRR\\"), {}, n), n.request(S("\x11q|yxwy|#i~ry"), e)
        }

        function p(e) {
          var t, n = e.data.response.error.number;
          t = e.data.response.error.message ? e.data.response.error.message : n && this.lang.errors.codes[n] ? this.lang.errors.codes[n] : this.lang.errors.unknown.replace(S(":@RHS]%3?"), n), this.request(S("\x14q\x7fvtv}!usxp"), {
            msg: t,
            name: S("+oBCBQ_VvFGYE")
          })
        }
      }),CKFinder.define(S("D6-.&:e!=8+=)|?<6<:2w*122"), {
        config: function (e) {
          return e.iconsCSS || (e.iconsCSS = S('"POLHT\x07C[^I_W\x02]^PZXP\x19^[VTH\x12^ML')), e.themeCSS || (e.themeCSS = S('=RV"2m)50#51g\'$.$"*~%:690x4+*')), e
        }, init: function () {
          CKFinder.require([S("\x10{cfqgo")], function (e) {
            e(S("3VZRN")).addClass(S("\x1anu0w|OO\x0fBHQ"))
          })
        }
      }),CKFinder.define(S("C7./);f'$##!`#:;="), {
        config: function (e) {
          return e.swatch = "a", e.dialogOverlaySwatch = !0, e.loaderOverlaySwatch = !0, e.themeCSS || (e.themeCSS = S("\x19ipusm0MNMMK\nELN@DOI_\0LCB")), e.iconsCSS || (e.iconsCSS = S("E5,!'9d!\"!!?~;0;;%y;*)")), e
        }, init: function () {
          CKFinder.require([S("9PJIXLF")], function (e) {
            e(S("=\\P$8")).addClass(S("\r{f=p~g9|uxv"))
          })
        }
      }),window.CKFinder = window.CKFinder || {},window.CKFinder.require = CKFinder.require || window.require || require,window.CKFinder.requirejs = CKFinder.requirejs || window.requirejs || requirejs,window.CKFinder.define = CKFinder.define || window.define || define,CKFinder.require.config({
        config: {
          text: {
            useXhr: function () {
              "use strict";
              return !0
            }
          }
        }
      }),window.CKFinder.basePath && window.CKFinder.requirejs.config({baseUrl: window.CKFinder.basePath}),window.CKFinder.requirejs.config({waitSeconds: 0}),window.CKFinder.define(S("9YPZbYS/##/"), function () {
        return window.CKFinder
      });
      var eventType = S("\x16ts\x7fsuxxlMEPWJV@tBIMS");
      try {
        event = new CustomEvent(eventType)
      } catch (e) {
        event = document.createEvent(S("7}O_UH")), event.initEvent(eventType, !0, !1)
      }
      window.dispatchEvent(event), window.CKFinder.start = function (i) {
        i = i || {}, window.CKFinder.require([S(" TLGAWUDG[O"), S("\x1e\\kgKM@@T\bkFDMEJ"), S("\x13W^P~v}\x7fi3HjvL\x0ewWMI")], function (l, t, u) {
          var e = l.isUndefined(i.configPath) ? t.configPath : i.configPath;

          function n(e, t, n) {
            var i, r, o,
              s = [S("\x1dw{"), S("1FJDP"), S("#V@UH][INxT^J"), S("5ZVV^yTXX"), S("1qxqQ_CWK"), S("\x1e\\kdFJPJTa]GIeY@")];
            if ((r = l.pick(u.getUrlParams(), s)).langCode && (r.language = r.langCode), r.type && (r.resourceType = r.type), r.CKEditor) {
              r.chooseFiles = !0;
              var a = r.CKEditorFuncNum;
              r.ckeditor = {
                id: r.CKEditor, funcNumber: a, callback: function (e, t) {
                  window.opener.CKEDITOR.tools.callFunction(a, e, t), window.close()
                }
              }
            }
            delete r.langCode, delete r.CKEditor, delete r.CKEditorFuncNum, o = window !== window.parent && window.opener || window.isCKFinderPopup ? window.opener : window.parent.CKFinder && window.parent.CKFinder.modal && window.parent.CKFinder.modal(S("\x13b|e~zu\x7f")) || window !== window.parent && !window.opener ? window.parent : window, function (n, e) {
              var t = n.skin;
              t.indexOf("/") < 0 && (t = S("C7./);f") + t + S("\n$\x7ffga"));
              window.CKFinder.require([t], function (e) {
                var t = l.isFunction(e.config) ? e.config(n) : e.config;
                !function (e) {
                  [e.jqueryMobileStructureCSS, e.coreCSS, e.jqueryMobileIconsCSS, e.iconsCSS, e.themeCSS].forEach(function (e) {
                    if (e) {
                      var t = window.document.createElement(S(">S)/)"));
                      t.setAttribute(S("-\\J\\"), S("(Z^R@H]GUTF")), t.setAttribute(S("\x16\x7fj||"), CKFinder.require.toUrl(e) + S("/\x0fRYUBPD\n\r\x0e\x02\v\r\t\f\vp")), window.document.head.appendChild(t)
                    }
                  })
                }(l.extend(n, t))
              }), window.jQuery && /1|2\.[0-9]+.[0-9]+/.test(window.jQuery.fn.jquery) ? c(n, e) : window.CKFinder.require([window.CKFinder.require.toUrl(n.jquery) + S("<\x02]T&7'1ypq\x7fxx~yx}")], function () {
                c(n, e)
              })
            }(i = l.extend({}, e, t, o.CKFinder ? o.CKFinder._config : {}, n, r), function (e) {
              e.start(i)
            })
          }

          function c(e, t) {
            window.CKFinder.define(S("\x17rho~nd"), function () {
              return window.jQuery
            }), window.jQuery(window.document).bind(S("%KHJ@FNECG["), function () {
              window.jQuery.mobile.linkBindingEnabled = !1, window.jQuery.mobile.hashListeningEnabled = !1, window.jQuery.mobile.autoInitializePage = !1, window.jQuery.mobile.ignoreContentEnabled = !0
            }), window.CKFinder.require([window.CKFinder.require.toUrl(e.jqueryMobile) + S("\x15)ts\x7fl~n +(\x18\x11\x13\x17\x16\x11\x16")], function () {
              window.CKFinder.define(S(",NEI\x1d[CFQGO\x1aUVXRPX"), function () {
                return window.jQuery.mobile
              }), window.CKFinder.require([S("\x15U\\^pt\x7fyo1^PQNJGDRNGG")], t)
            })
          }

          e ? window.CKFinder.require([window.CKFinder.require.toUrl(e)], function (e) {
            n(t, e, i)
          }, function () {
            n(t, {}, i)
          }) : n(t, {}, i)
        })
      }
    }
  }
}();

(function (factory) {
  "use strict";

  if (typeof define === 'function' && define.amd) { // AMD
    define(['jquery'], factory);
  }
  else if (typeof exports == "object" && typeof module == "object") { // CommonJS
    module.exports = factory(require('jquery'));
  }
  else { // Browser
    factory(jQuery);
  }
})(function($, undefined) {
  "use strict";

  var defaultOpts = {

      // Callbacks
      beforeShow: noop,
      move: noop,
      change: noop,
      show: noop,
      hide: noop,

      // Options
      color: false,
      flat: false, // Deprecated - use type instead
      type: '', // text, color, component or flat
      showInput: false,
      allowEmpty: true,
      showButtons: true,
      clickoutFiresChange: true,
      showInitial: false,
      showPalette: true,
      showPaletteOnly: false,
      hideAfterPaletteSelect: false,
      togglePaletteOnly: false,
      showSelectionPalette: true,
      localStorageKey: false,
      appendTo: "body",
      maxSelectionSize: 8,
      locale: "en",
      cancelText: "cancel",
      chooseText: "choose",
      togglePaletteMoreText: "more",
      togglePaletteLessText: "less",
      clearText: "Clear Color Selection",
      noColorSelectedText: "No Color Selected",
      preferredFormat: "name",
      className: "", // Deprecated - use containerClassName and replacerClassName instead.
      containerClassName: "",
      replacerClassName: "",
      showAlpha: true,
      theme: "sp-light",
      palette: [
        ["#000000","#444444","#5b5b5b","#999999","#bcbcbc","#eeeeee","#f3f6f4","#ffffff"],
        ["#f44336","#744700","#ce7e00","#8fce00","#2986cc","#16537e","#6a329f","#c90076"],
        ["#f4cccc","#fce5cd","#fff2cc","#d9ead3","#d0e0e3","#cfe2f3","#d9d2e9","#ead1dc"],
        ["#ea9999","#f9cb9c","#ffe599","#b6d7a8","#a2c4c9","#9fc5e8","#b4a7d6","#d5a6bd"],
        ["#e06666","#f6b26b","#ffd966","#93c47d","#76a5af","#6fa8dc","#8e7cc3","#c27ba0"],
        ["#cc0000","#e69138","#f1c232","#6aa84f","#45818e","#3d85c6","#674ea7","#a64d79"],
        ["#990000","#b45f06","#bf9000","#38761d","#134f5c","#0b5394","#351c75","#741b47"],
        ["#660000","#783f04","#7f6000","#274e13","#0c343d","#073763","#20124d","#4c1130"]
      ],
      selectionPalette: [],
      disabled: false,
      offset: null
    },
    spectrums = [],
    IE = !!/msie/i.exec( window.navigator.userAgent ),
    rgbaSupport = (function() {
      function contains( str, substr ) {
        return !!~('' + str).indexOf(substr);
      }

      var elem = document.createElement('div');
      var style = elem.style;
      style.cssText = 'background-color:rgba(0,0,0,.5)';
      return contains(style.backgroundColor, 'rgba') || contains(style.backgroundColor, 'hsla');
    })(),
    replaceInput = [
      "<div class='sp-replacer'>",
      "<div class='sp-preview'><div class='sp-preview-inner'></div></div>",
      "<div class='sp-dd'>&#9660;</div>",
      "</div>"
    ].join(''),
    markup = (function () {

      // IE does not support gradients with multiple stops, so we need to simulate
      //  that for the rainbow slider with 8 divs that each have a single gradient
      var gradientFix = "";
      if (IE) {
        for (var i = 1; i <= 6; i++) {
          gradientFix += "<div class='sp-" + i + "'></div>";
        }
      }

      return [
        "<div class='sp-container sp-hidden'>",
        "<div class='sp-palette-container'>",
        "<div class='sp-palette sp-thumb sp-cf'></div>",
        "<div class='sp-palette-button-container sp-cf'>",
        "<button type='button' class='sp-palette-toggle'></button>",
        "</div>",
        "</div>",
        "<div class='sp-picker-container'>",
        "<div class='sp-top sp-cf'>",
        "<div class='sp-fill'></div>",
        "<div class='sp-top-inner'>",
        "<div class='sp-color'>",
        "<div class='sp-sat'>",
        "<div class='sp-val'>",
        "<div class='sp-dragger'></div>",
        "</div>",
        "</div>",
        "</div>",
        "<div class='sp-clear sp-clear-display'>",
        "</div>",
        "<div class='sp-hue'>",
        "<div class='sp-slider'></div>",
        gradientFix,
        "</div>",
        "</div>",
        "<div class='sp-alpha'><div class='sp-alpha-inner'><div class='sp-alpha-handle'></div></div></div>",
        "</div>",
        "<div class='sp-input-container sp-cf'>",
        "<input class='sp-input' type='text' spellcheck='false'  />",
        "</div>",
        "<div class='sp-initial sp-thumb sp-cf'></div>",
        "<div class='sp-button-container sp-cf'>",
        "<button class='sp-cancel' href='#'></button>",
        "<button type='button' class='sp-choose'></button>",
        "</div>",
        "</div>",
        "</div>"
      ].join("");
    })();

  function paletteTemplate (p, color, className, opts) {
    var html = [];
    for (var i = 0; i < p.length; i++) {
      var current = p[i];
      if(current) {
        var tiny = tinycolor(current);
        var c = tiny.toHsl().l < 0.5 ? "sp-thumb-el sp-thumb-dark" : "sp-thumb-el sp-thumb-light";
        c += (tinycolor.equals(color, current)) ? " sp-thumb-active" : "";
        var formattedString = tiny.toString(opts.preferredFormat || "rgb");
        var swatchStyle = rgbaSupport ? ("background-color:" + tiny.toRgbString()) : "filter:" + tiny.toFilter();
        html.push('<span title="' + formattedString + '" data-color="' + tiny.toRgbString() + '" class="' + c + '"><span class="sp-thumb-inner" style="' + swatchStyle + ';"></span></span>');
      } else {
        html.push('<span class="sp-thumb-el sp-clear-display" ><span class="sp-clear-palette-only" style="background-color: transparent;"></span></span>');
      }
    }
    return "<div class='sp-cf " + className + "'>" + html.join('') + "</div>";
  }

  function hideAll() {
    for (var i = 0; i < spectrums.length; i++) {
      if (spectrums[i]) {
        spectrums[i].hide();
      }
    }
  }

  function instanceOptions(o, callbackContext) {
    o.locale = o.locale || window.navigator.language;
    if (o.locale) o.locale = o.locale.split('-')[0].toLowerCase(); // handle locale like "fr-FR"
    if (o.locale != 'en' && $.spectrum.localization[o.locale]) {
      o = $.extend({}, $.spectrum.localization[o.locale], o);
    }
    var opts = $.extend({}, defaultOpts, o);

    opts.callbacks = {
      'move': bind(opts.move, callbackContext),
      'change': bind(opts.change, callbackContext),
      'show': bind(opts.show, callbackContext),
      'hide': bind(opts.hide, callbackContext),
      'beforeShow': bind(opts.beforeShow, callbackContext)
    };

    return opts;
  }

  function spectrum(element, o) {

    var opts = instanceOptions(o, element),
      type = opts.type,
      flat = (type == 'flat'),
      showSelectionPalette = opts.showSelectionPalette,
      localStorageKey = opts.localStorageKey,
      theme = opts.theme,
      callbacks = opts.callbacks,
      resize = throttle(reflow, 10),
      visible = false,
      isDragging = false,
      dragWidth = 0,
      dragHeight = 0,
      dragHelperHeight = 0,
      slideHeight = 0,
      slideWidth = 0,
      alphaWidth = 0,
      alphaSlideHelperWidth = 0,
      slideHelperHeight = 0,
      currentHue = 0,
      currentSaturation = 0,
      currentValue = 0,
      currentAlpha = 1,
      palette = [],
      paletteArray = [],
      paletteLookup = {},
      selectionPalette = opts.selectionPalette.slice(0),
      maxSelectionSize = opts.maxSelectionSize,
      draggingClass = "sp-dragging",
      abortNextInputChange = false,
      shiftMovementDirection = null;

    var doc = element.ownerDocument,
      body = doc.body,
      boundElement = $(element),
      disabled = false,
      container = $(markup, doc).addClass(theme),
      pickerContainer = container.find(".sp-picker-container"),
      dragger = container.find(".sp-color"),
      dragHelper = container.find(".sp-dragger"),
      slider = container.find(".sp-hue"),
      slideHelper = container.find(".sp-slider"),
      alphaSliderInner = container.find(".sp-alpha-inner"),
      alphaSlider = container.find(".sp-alpha"),
      alphaSlideHelper = container.find(".sp-alpha-handle"),
      textInput = container.find(".sp-input"),
      paletteContainer = container.find(".sp-palette"),
      initialColorContainer = container.find(".sp-initial"),
      cancelButton = container.find(".sp-cancel"),
      clearButton = container.find(".sp-clear"),
      chooseButton = container.find(".sp-choose"),
      toggleButton = container.find(".sp-palette-toggle"),
      isInput = boundElement.is("input"),
      isInputTypeColor = isInput && boundElement.attr("type") === "color" && inputTypeColorSupport(),
      shouldReplace = isInput && type == 'color',
      replacer = (shouldReplace) ? $(replaceInput).addClass(theme).addClass(opts.className).addClass(opts.replacerClassName) : $([]),
      offsetElement = (shouldReplace) ? replacer : boundElement,
      previewElement = replacer.find(".sp-preview-inner"),
      initialColor = opts.color || (isInput && boundElement.val()),
      colorOnShow = false,
      currentPreferredFormat = opts.preferredFormat,
      clickoutFiresChange = !opts.showButtons || opts.clickoutFiresChange,
      isEmpty = !initialColor,
      allowEmpty = opts.allowEmpty;

    // Element to be updated with the input color. Populated in initialize method
    var originalInputContainer = null,
      colorizeElement = null,
      colorizeElementInitialColor = null,
      colorizeElementInitialBackground = null;

    //If there is a label for this element, when clicked on, show the colour picker
    var thisId = boundElement.attr('id');
    if(thisId !== undefined && thisId.length > 0) {
      var label = $('label[for="'+thisId+'"]');
      if(label.length) {
        label.on('click', function(e){
          e.preventDefault();
          boundElement.spectrum('show');
          return false;
        });
      }
    }

    function applyOptions() {

      if (opts.showPaletteOnly) {
        opts.showPalette = true;
      }

      toggleButton.text(opts.showPaletteOnly ? opts.togglePaletteMoreText : opts.togglePaletteLessText);

      if (opts.palette) {
        palette = opts.palette.slice(0);
        paletteArray = $.isArray(palette[0]) ? palette : [palette];
        paletteLookup = {};
        for (var i = 0; i < paletteArray.length; i++) {
          for (var j = 0; j < paletteArray[i].length; j++) {
            var rgb = tinycolor(paletteArray[i][j]).toRgbString();
            paletteLookup[rgb] = true;
          }
        }

        // if showPaletteOnly and didn't set initialcolor
        // set initialcolor to first palette
        if (opts.showPaletteOnly && !initialColor) {
          initialColor = (palette[0][0] === '') ? palette[0][0] : Object.keys(paletteLookup)[0];
        }
      }

      container.toggleClass("sp-flat", flat);
      container.toggleClass("sp-input-disabled", !opts.showInput);
      container.toggleClass("sp-alpha-enabled", opts.showAlpha);
      container.toggleClass("sp-clear-enabled", allowEmpty);
      container.toggleClass("sp-buttons-disabled", !opts.showButtons);
      container.toggleClass("sp-palette-buttons-disabled", !opts.togglePaletteOnly);
      container.toggleClass("sp-palette-disabled", !opts.showPalette);
      container.toggleClass("sp-palette-only", opts.showPaletteOnly);
      container.toggleClass("sp-initial-disabled", !opts.showInitial);
      container.addClass(opts.className).addClass(opts.containerClassName);

      reflow();
    }

    function initialize() {

      if (IE) {
        container.find("*:not(input)").attr("unselectable", "on");
      }

      applyOptions();

      originalInputContainer = $('<span class="sp-original-input-container"></span>');
      ['margin'].forEach(function(cssProp) {
        originalInputContainer.css(cssProp, boundElement.css(cssProp));
      });
      // inline-flex by default, switching to flex if needed
      if (boundElement.css('display') == 'block') originalInputContainer.css('display', 'flex');

      if (shouldReplace) {
        boundElement.after(replacer).hide();
      } else if (type == 'text') {
        originalInputContainer.addClass('sp-colorize-container');
        boundElement.addClass('spectrum sp-colorize').wrap(originalInputContainer);
      } else if (type == 'component') {
        boundElement.addClass('spectrum').wrap(originalInputContainer);
        var addOn = $(["<div class='sp-colorize-container sp-add-on'>",
          "<div class='sp-colorize'></div> ",
          "</div>"].join(''));
        addOn.width(boundElement.outerHeight() + 'px')
          .css('border-radius', boundElement.css('border-radius'))
          .css('border', boundElement.css('border'));
        boundElement.addClass('with-add-on').before(addOn);
      }

      colorizeElement = boundElement.parent().find('.sp-colorize');
      colorizeElementInitialColor = colorizeElement.css('color');
      colorizeElementInitialBackground = colorizeElement.css('background-color');

      if (!allowEmpty) {
        clearButton.hide();
      }

      if (flat) {
        boundElement.after(container).hide();
      }
      else {

        var appendTo = opts.appendTo === "parent" ? boundElement.parent() : $(opts.appendTo);
        if (appendTo.length !== 1) {
          appendTo = $("body");
        }

        appendTo.append(container);
      }

      updateSelectionPaletteFromStorage();

      offsetElement.on("click.spectrum touchstart.spectrum", function (e) {
        if (!disabled) {
          show();
        }

        e.stopPropagation();

        if (!$(e.target).is("input")) {
          e.preventDefault();
        }
      });

      if(boundElement.is(":disabled") || (opts.disabled === true)) {
        disable();
      }

      // Prevent clicks from bubbling up to document.  This would cause it to be hidden.
      container.click(stopPropagation);

      // Handle user typed input
      [textInput, boundElement].forEach(function(input) {
        input.change(function() { setFromTextInput(input.val()); });
        input.on("paste", function () {
          setTimeout(function() { setFromTextInput(input.val()); }, 1);
        });
        input.keydown(function (e) { if (e.keyCode == 13) {
          setFromTextInput($(input).val());
          if (input == boundElement) hide();
        } });
      });

      cancelButton.text(opts.cancelText);
      cancelButton.on("click.spectrum", function (e) {
        e.stopPropagation();
        e.preventDefault();
        revert();
        hide();
      });

      clearButton.attr("title", opts.clearText);
      clearButton.on("click.spectrum", function (e) {
        e.stopPropagation();
        e.preventDefault();
        isEmpty = true;
        move();

        if(flat) {
          //for the flat style, this is a change event
          updateOriginalInput(true);
        }
      });

      chooseButton.text(opts.chooseText);
      chooseButton.on("click.spectrum", function (e) {
        e.stopPropagation();
        e.preventDefault();

        if (IE && textInput.is(":focus")) {
          textInput.trigger('change');
        }

        if (isValid()) {
          updateOriginalInput(true);
          hide();
        }
      });

      toggleButton.text(opts.showPaletteOnly ? opts.togglePaletteMoreText : opts.togglePaletteLessText);
      toggleButton.on("click.spectrum", function (e) {
        e.stopPropagation();
        e.preventDefault();

        opts.showPaletteOnly = !opts.showPaletteOnly;

        // To make sure the Picker area is drawn on the right, next to the
        // Palette area (and not below the palette), first move the Palette
        // to the left to make space for the picker, plus 5px extra.
        // The 'applyOptions' function puts the whole container back into place
        // and takes care of the button-text and the sp-palette-only CSS class.
        if (!opts.showPaletteOnly && !flat) {
          container.css('left', '-=' + (pickerContainer.outerWidth(true) + 5));
        }
        applyOptions();
      });

      draggable(alphaSlider, function (dragX, dragY, e) {
        currentAlpha = (dragX / alphaWidth);
        isEmpty = false;
        if (e.shiftKey) {
          currentAlpha = Math.round(currentAlpha * 10) / 10;
        }

        move();
      }, dragStart, dragStop);

      draggable(slider, function (dragX, dragY) {
        currentHue = parseFloat(dragY / slideHeight);
        isEmpty = false;
        if (!opts.showAlpha) {
          currentAlpha = 1;
        }
        move();
      }, dragStart, dragStop);

      draggable(dragger, function (dragX, dragY, e) {

        // shift+drag should snap the movement to either the x or y axis.
        if (!e.shiftKey) {
          shiftMovementDirection = null;
        }
        else if (!shiftMovementDirection) {
          var oldDragX = currentSaturation * dragWidth;
          var oldDragY = dragHeight - (currentValue * dragHeight);
          var furtherFromX = Math.abs(dragX - oldDragX) > Math.abs(dragY - oldDragY);

          shiftMovementDirection = furtherFromX ? "x" : "y";
        }

        var setSaturation = !shiftMovementDirection || shiftMovementDirection === "x";
        var setValue = !shiftMovementDirection || shiftMovementDirection === "y";

        if (setSaturation) {
          currentSaturation = parseFloat(dragX / dragWidth);
        }
        if (setValue) {
          currentValue = parseFloat((dragHeight - dragY) / dragHeight);
        }

        isEmpty = false;
        if (!opts.showAlpha) {
          currentAlpha = 1;
        }

        move();

      }, dragStart, dragStop);

      if (!!initialColor) {
        set(initialColor);

        // In case color was black - update the preview UI and set the format
        // since the set function will not run (default color is black).
        updateUI();
        currentPreferredFormat = tinycolor(initialColor).format || opts.preferredFormat;
        addColorToSelectionPalette(initialColor);
      } else if (initialColor === '') {
        set(initialColor);
        updateUI();
      } else {
        updateUI();
      }

      if (flat) {
        show();
      }

      function paletteElementClick(e) {
        if (e.data && e.data.ignore) {
          set($(e.target).closest(".sp-thumb-el").data("color"));
          move();
        }
        else {
          set($(e.target).closest(".sp-thumb-el").data("color"));
          move();

          // If the picker is going to close immediately, a palette selection
          // is a change.  Otherwise, it's a move only.
          if (opts.hideAfterPaletteSelect) {
            updateOriginalInput(true);
            hide();
          } else {
            updateOriginalInput();
          }
        }

        return false;
      }

      var paletteEvent = IE ? "mousedown.spectrum" : "click.spectrum touchstart.spectrum";
      paletteContainer.on(paletteEvent, ".sp-thumb-el", paletteElementClick);
      initialColorContainer.on(paletteEvent, ".sp-thumb-el:nth-child(1)", { ignore: true }, paletteElementClick);
    }

    function updateSelectionPaletteFromStorage() {

      if (localStorageKey) {
        // Migrate old palettes over to new format.  May want to remove this eventually.
        try {
          var localStorage = window.localStorage;
          var oldPalette = localStorage[localStorageKey].split(",#");
          if (oldPalette.length > 1) {
            delete localStorage[localStorageKey];
            $.each(oldPalette, function(i, c) {
              addColorToSelectionPalette(c);
            });
          }
        }
        catch(e) { }

        try {
          selectionPalette = window.localStorage[localStorageKey].split(";");
        }
        catch (e) { }
      }
    }

    function addColorToSelectionPalette(color) {
      if (showSelectionPalette) {
        var rgb = tinycolor(color).toRgbString();
        if (!paletteLookup[rgb] && $.inArray(rgb, selectionPalette) === -1) {
          selectionPalette.push(rgb);
          while(selectionPalette.length > maxSelectionSize) {
            selectionPalette.shift();
          }
        }

        if (localStorageKey) {
          try {
            window.localStorage[localStorageKey] = selectionPalette.join(";");
          }
          catch(e) { }
        }
      }
    }

    function getUniqueSelectionPalette() {
      var unique = [];
      if (opts.showPalette) {
        for (var i = 0; i < selectionPalette.length; i++) {
          var rgb = tinycolor(selectionPalette[i]).toRgbString();

          if (!paletteLookup[rgb]) {
            unique.push(selectionPalette[i]);
          }
        }
      }

      return unique.reverse().slice(0, opts.maxSelectionSize);
    }

    function drawPalette() {

      var currentColor = get();

      var html = $.map(paletteArray, function (palette, i) {
        return paletteTemplate(palette, currentColor, "sp-palette-row sp-palette-row-" + i, opts);
      });

      updateSelectionPaletteFromStorage();

      if (selectionPalette) {
        html.push(paletteTemplate(getUniqueSelectionPalette(), currentColor, "sp-palette-row sp-palette-row-selection", opts));
      }

      paletteContainer.html(html.join(""));
    }

    function drawInitial() {
      if (opts.showInitial) {
        var initial = colorOnShow;
        var current = get();
        initialColorContainer.html(paletteTemplate([initial, current], current, "sp-palette-row-initial", opts));
      }
    }

    function dragStart() {
      if (dragHeight <= 0 || dragWidth <= 0 || slideHeight <= 0) {
        reflow();
      }
      isDragging = true;
      container.addClass(draggingClass);
      shiftMovementDirection = null;
      boundElement.trigger('dragstart.spectrum', [ get() ]);
    }

    function dragStop() {
      isDragging = false;
      container.removeClass(draggingClass);
      boundElement.trigger('dragstop.spectrum', [ get() ]);
    }

    function setFromTextInput(value) {
      if (abortNextInputChange) { abortNextInputChange = false; return; }
      if ((value === null || value === "") && allowEmpty) {
        set(null);
        move();
        updateOriginalInput();
      }
      else {
        var tiny = tinycolor(value);
        if (tiny.isValid()) {
          set(tiny);
          move();
          updateOriginalInput();
        }
        else {
          textInput.addClass("sp-validation-error");
        }
      }
    }

    function toggle() {
      if (visible) {
        hide();
      }
      else {
        show();
      }
    }

    function show() {
      // debugger;
      var event = $.Event('beforeShow.spectrum');

      if (visible) {
        reflow();
        return;
      }

      boundElement.trigger(event, [ get() ]);

      if (callbacks.beforeShow(get()) === false || event.isDefaultPrevented()) {
        return;
      }

      hideAll();
      visible = true;

      $(doc).on("keydown.spectrum", onkeydown);
      $(doc).on("click.spectrum", clickout);
      $(window).on("resize.spectrum", resize);
      replacer.addClass("sp-active");
      container.removeClass("sp-hidden");

      reflow();
      updateUI();

      colorOnShow = get();

      drawInitial();
      callbacks.show(colorOnShow);
      boundElement.trigger('show.spectrum', [ colorOnShow ]);
    }

    function onkeydown(e) {
      // Close on ESC
      if (e.keyCode === 27) {
        hide();
      }
    }

    function clickout(e) {
      // Return on right click.
      if (e.button == 2) { return; }

      // If a drag event was happening during the mouseup, don't hide
      // on click.
      if (isDragging) { return; }

      if (clickoutFiresChange) {
        updateOriginalInput(true);
      }
      else {
        revert();
      }
      hide();
    }

    function hide() {
      // Return if hiding is unnecessary
      if (!visible || flat) { return; }
      visible = false;

      $(doc).off("keydown.spectrum", onkeydown);
      $(doc).off("click.spectrum", clickout);
      $(window).off("resize.spectrum", resize);

      replacer.removeClass("sp-active");
      container.addClass("sp-hidden");

      callbacks.hide(get());
      boundElement.trigger('hide.spectrum', [ get() ]);
    }

    function revert() {
      set(colorOnShow, true);
      updateOriginalInput(true);
    }

    function set(color, ignoreFormatChange) {
      if (tinycolor.equals(color, get())) {
        // Update UI just in case a validation error needs
        // to be cleared.
        updateUI();
        return;
      }

      var newColor, newHsv;
      if ((!color || color === undefined) && allowEmpty) {
        isEmpty = true;
      } else {
        isEmpty = false;
        newColor = tinycolor(color);
        newHsv = newColor.toHsv();

        currentHue = (newHsv.h % 360) / 360;
        currentSaturation = newHsv.s;
        currentValue = newHsv.v;
        currentAlpha = newHsv.a;
      }
      updateUI();

      if (newColor && newColor.isValid() && !ignoreFormatChange) {
        currentPreferredFormat = opts.preferredFormat || newColor.getFormat();
      }
    }

    function get(opts) {
      opts = opts || { };

      if (allowEmpty && isEmpty) {
        return null;
      }

      return tinycolor.fromRatio({
        h: currentHue,
        s: currentSaturation,
        v: currentValue,
        a: Math.round(currentAlpha * 1000) / 1000
      }, { format: opts.format || currentPreferredFormat });
    }

    function isValid() {
      return !textInput.hasClass("sp-validation-error");
    }

    function move() {
      updateUI();

      callbacks.move(get());
      boundElement.trigger('move.spectrum', [ get() ]);
    }

    function updateUI() {

      textInput.removeClass("sp-validation-error");

      updateHelperLocations();

      // Update dragger background color (gradients take care of saturation and value).
      var flatColor = tinycolor.fromRatio({ h: currentHue, s: 1, v: 1 });
      dragger.css("background-color", flatColor.toHexString());

      // Get a format that alpha will be included in (hex and names ignore alpha)
      var format = currentPreferredFormat;
      if (currentAlpha < 1 && !(currentAlpha === 0 && format === "name")) {
        if (format === "hex" || format === "hex3" || format === "hex6" || format === "name") {
          format = "rgb";
        }
      }

      var realColor = get({ format: format }),
        displayColor = '';

      //reset background info for preview element
      previewElement.removeClass("sp-clear-display");
      previewElement.css('background-color', 'transparent');

      if (!realColor && allowEmpty) {
        // Update the replaced elements background with icon indicating no color selection
        previewElement.addClass("sp-clear-display");
      }
      else {
        var realHex = realColor.toHexString(),
          realRgb = realColor.toRgbString();

        // Update the replaced elements background color (with actual selected color)
        if (rgbaSupport || realColor.alpha === 1) {
          previewElement.css("background-color", realRgb);
        }
        else {
          previewElement.css("background-color", "transparent");
          previewElement.css("filter", realColor.toFilter());
        }

        if (opts.showAlpha) {
          var rgb = realColor.toRgb();
          rgb.a = 0;
          var realAlpha = tinycolor(rgb).toRgbString();
          var gradient = "linear-gradient(left, " + realAlpha + ", " + realHex + ")";

          if (IE) {
            alphaSliderInner.css("filter", tinycolor(realAlpha).toFilter({ gradientType: 1 }, realHex));
          }
          else {
            alphaSliderInner.css("background", "-webkit-" + gradient);
            alphaSliderInner.css("background", "-moz-" + gradient);
            alphaSliderInner.css("background", "-ms-" + gradient);
            // Use current syntax gradient on unprefixed property.
            alphaSliderInner.css("background",
              "linear-gradient(to right, " + realAlpha + ", " + realHex + ")");
          }
        }

        displayColor = realColor.toString(format);
      }

      // Update the text entry input as it changes happen
      if (opts.showInput) {
        textInput.val(displayColor);
      }
      boundElement.val(displayColor);
      if (opts.type == "text" || opts.type == "component") {
        var color = realColor;
        if (color && colorizeElement) {
          var textColor = (color.isLight() || color.getAlpha() < 0.4) ? 'black' : 'white';
          colorizeElement.css('background-color', color.toRgbString()).css('color', textColor);
        } else {
          colorizeElement.css('background-color', colorizeElementInitialBackground)
            .css('color', colorizeElementInitialColor);
        }
      }

      if (opts.showPalette) {
        drawPalette();
      }

      drawInitial();
    }

    function updateHelperLocations() {
      var s = currentSaturation;
      var v = currentValue;

      if(allowEmpty && isEmpty) {
        //if selected color is empty, hide the helpers
        alphaSlideHelper.hide();
        slideHelper.hide();
        dragHelper.hide();
      }
      else {
        //make sure helpers are visible
        alphaSlideHelper.show();
        slideHelper.show();
        dragHelper.show();

        // Where to show the little circle in that displays your current selected color
        var dragX = s * dragWidth;
        var dragY = dragHeight - (v * dragHeight);
        dragX = Math.max(
          -dragHelperHeight,
          Math.min(dragWidth - dragHelperHeight, dragX - dragHelperHeight)
        );
        dragY = Math.max(
          -dragHelperHeight,
          Math.min(dragHeight - dragHelperHeight, dragY - dragHelperHeight)
        );
        dragHelper.css({
          "top": dragY + "px",
          "left": dragX + "px"
        });

        var alphaX = currentAlpha * alphaWidth;
        alphaSlideHelper.css({
          "left": (alphaX - (alphaSlideHelperWidth / 2)) + "px"
        });

        // Where to show the bar that displays your current selected hue
        var slideY = (currentHue) * slideHeight;
        slideHelper.css({
          "top": (slideY - slideHelperHeight) + "px"
        });
      }
    }

    function updateOriginalInput(fireCallback) {
      var color = get(),
        displayColor = '',
        hasChanged = !tinycolor.equals(color, colorOnShow);

      if (color) {
        displayColor = color.toString(currentPreferredFormat);
        // Update the selection palette with the current color
        addColorToSelectionPalette(color);
      }

      if (fireCallback && hasChanged) {
        callbacks.change(color);
        // we trigger the change event or input, but the input change event is also binded
        // to some spectrum processing, that we do no need
        abortNextInputChange = true;
        boundElement.trigger('change', [ color ]);
      }
    }

    function reflow() {
      if (!visible) {
        return; // Calculations would be useless and wouldn't be reliable anyways
      }
      dragWidth = dragger.width();
      dragHeight = dragger.height();
      dragHelperHeight = dragHelper.height();
      slideWidth = slider.width();
      slideHeight = slider.height();
      slideHelperHeight = slideHelper.height();
      alphaWidth = alphaSlider.width();
      alphaSlideHelperWidth = alphaSlideHelper.width();

      if (!flat) {
        container.css("position", "absolute");
        if (opts.offset) {
          container.offset(opts.offset);
        } else {
          container.offset(getOffset(container, offsetElement));
        }
      }

      updateHelperLocations();

      if (opts.showPalette) {
        drawPalette();
      }

      boundElement.trigger('reflow.spectrum');
    }

    function destroy() {
      boundElement.show().removeClass('spectrum with-add-on sp-colorize');
      offsetElement.off("click.spectrum touchstart.spectrum");
      container.remove();
      replacer.remove();
      if (colorizeElement) {
        colorizeElement.css('background-color', colorizeElementInitialBackground)
          .css('color', colorizeElementInitialColor);
      }
      var originalInputContainer = boundElement.closest('.sp-original-input-container');
      if (originalInputContainer.length > 0) {
        originalInputContainer.after(boundElement).remove();
      }
      spectrums[spect.id] = null;
    }

    function option(optionName, optionValue) {
      if (optionName === undefined) {
        return $.extend({}, opts);
      }
      if (optionValue === undefined) {
        return opts[optionName];
      }

      opts[optionName] = optionValue;

      if (optionName === "preferredFormat") {
        currentPreferredFormat = opts.preferredFormat;
      }
      applyOptions();
    }

    function enable() {
      disabled = false;
      boundElement.attr("disabled", false);
      offsetElement.removeClass("sp-disabled");
    }

    function disable() {
      hide();
      disabled = true;
      boundElement.attr("disabled", true);
      offsetElement.addClass("sp-disabled");
    }

    function setOffset(coord) {
      opts.offset = coord;
      reflow();
    }

    initialize();

    var spect = {
      show: show,
      hide: hide,
      toggle: toggle,
      reflow: reflow,
      option: option,
      enable: enable,
      disable: disable,
      offset: setOffset,
      set: function (c) {
        set(c);
        updateOriginalInput();
      },
      get: get,
      destroy: destroy,
      container: container
    };

    spect.id = spectrums.push(spect) - 1;

    return spect;
  }

  /**
   * checkOffset - get the offset below/above and left/right element depending on screen position
   * Thanks https://github.com/jquery/jquery-ui/blob/master/ui/jquery.ui.datepicker.js
   */
  function getOffset(picker, input) {
    var extraY = 0;
    var dpWidth = picker.outerWidth();
    var dpHeight = picker.outerHeight();
    var inputHeight = input.outerHeight();
    var doc = picker[0].ownerDocument;
    var docElem = doc.documentElement;
    var viewWidth = docElem.clientWidth + $(doc).scrollLeft();
    var viewHeight = docElem.clientHeight + $(doc).scrollTop();
    var offset = input.offset();
    var offsetLeft = offset.left;
    var offsetTop = offset.top;

    offsetTop += inputHeight;

    offsetLeft -=
      Math.min(offsetLeft, (offsetLeft + dpWidth > viewWidth && viewWidth > dpWidth) ?
        Math.abs(offsetLeft + dpWidth - viewWidth) : 0);

    offsetTop -=
      Math.min(offsetTop, ((offsetTop + dpHeight > viewHeight && viewHeight > dpHeight) ?
        Math.abs(dpHeight + inputHeight - extraY) : extraY));

    return {
      top: offsetTop,
      bottom: offset.bottom,
      left: offsetLeft,
      right: offset.right,
      width: offset.width,
      height: offset.height
    };
  }

  /**
   * noop - do nothing
   */
  function noop() {

  }

  /**
   * stopPropagation - makes the code only doing this a little easier to read in line
   */
  function stopPropagation(e) {
    e.stopPropagation();
  }

  /**
   * Create a function bound to a given object
   * Thanks to underscore.js
   */
  function bind(func, obj) {
    var slice = Array.prototype.slice;
    var args = slice.call(arguments, 2);
    return function () {
      return func.apply(obj, args.concat(slice.call(arguments)));
    };
  }

  /**
   * Lightweight drag helper.  Handles containment within the element, so that
   * when dragging, the x is within [0,element.width] and y is within [0,element.height]
   */
  function draggable(element, onmove, onstart, onstop) {
    onmove = onmove || function () { };
    onstart = onstart || function () { };
    onstop = onstop || function () { };
    var doc = document;
    var dragging = false;
    var offset = {};
    var maxHeight = 0;
    var maxWidth = 0;
    var hasTouch = ('ontouchstart' in window);

    var duringDragEvents = {};
    duringDragEvents["selectstart"] = prevent;
    duringDragEvents["dragstart"] = prevent;
    duringDragEvents["touchmove mousemove"] = move;
    duringDragEvents["touchend mouseup"] = stop;

    function prevent(e) {
      if (e.stopPropagation) {
        e.stopPropagation();
      }
      if (e.preventDefault) {
        e.preventDefault();
      }
      e.returnValue = false;
    }

    function move(e) {
      if (dragging) {
        // Mouseup happened outside of window
        if (IE && doc.documentMode < 9 && !e.button) {
          return stop();
        }

        var t0 = e.originalEvent && e.originalEvent.touches && e.originalEvent.touches[0];
        var pageX = t0 && t0.pageX || e.pageX;
        var pageY = t0 && t0.pageY || e.pageY;

        var dragX = Math.max(0, Math.min(pageX - offset.left, maxWidth));
        var dragY = Math.max(0, Math.min(pageY - offset.top, maxHeight));

        if (hasTouch) {
          // Stop scrolling in iOS
          prevent(e);
        }

        onmove.apply(element, [dragX, dragY, e]);
      }
    }

    function start(e) {
      var rightclick = (e.which) ? (e.which == 3) : (e.button == 2);

      if (!rightclick && !dragging) {
        if (onstart.apply(element, arguments) !== false) {
          dragging = true;
          maxHeight = $(element).height();
          maxWidth = $(element).width();
          offset = $(element).offset();

          $(doc).on(duringDragEvents);
          $(doc.body).addClass("sp-dragging");

          move(e);

          prevent(e);
        }
      }
    }

    function stop() {
      if (dragging) {
        $(doc).off(duringDragEvents);
        $(doc.body).removeClass("sp-dragging");

        // Wait a tick before notifying observers to allow the click event
        // to fire in Chrome.
        setTimeout(function() {
          onstop.apply(element, arguments);
        }, 0);
      }
      dragging = false;
    }

    $(element).on("touchstart mousedown", start);
  }

  function throttle(func, wait, debounce) {
    var timeout;
    return function () {
      var context = this, args = arguments;
      var throttler = function () {
        timeout = null;
        func.apply(context, args);
      };
      if (debounce) clearTimeout(timeout);
      if (debounce || !timeout) timeout = setTimeout(throttler, wait);
    };
  }

  function inputTypeColorSupport() {
    return $.fn.spectrum.inputTypeColorSupport();
  }

  /**
   * Define a jQuery plugin
   */
  var dataID = "spectrum.id";
  $.fn.spectrum = function (opts, extra) {

    if (typeof opts == "string") {

      var returnValue = this;
      var args = Array.prototype.slice.call( arguments, 1 );

      this.each(function () {
        var spect = spectrums[$(this).data(dataID)];
        if (spect) {
          var method = spect[opts];
          if (!method) {
            throw new Error( "Spectrum: no such method: '" + opts + "'" );
          }

          if (opts == "get") {
            returnValue = spect.get();
          }
          else if (opts == "container") {
            returnValue = spect.container;
          }
          else if (opts == "option") {
            returnValue = spect.option.apply(spect, args);
          }
          else if (opts == "destroy") {
            spect.destroy();
            $(this).removeData(dataID);
          }
          else {
            method.apply(spect, args);
          }
        }
      });

      return returnValue;
    }

    // Initializing a new instance of spectrum
    return this.spectrum("destroy").each(function () {
      var options = $.extend({}, $(this).data(), opts);
      // Infer default type from input params and deprecated options
      if (!$(this).is('input')) options.type = 'noInput';
      else if (options.flat || options.type == "flat") options.type = 'flat';
      else if ($(this).attr('type') == 'color') options.type = 'color';
      else options.type = options.type || 'component';

      var spect = spectrum(this, options);
      $(this).data(dataID, spect.id);
    });
  };

  $.fn.spectrum.load = true;
  $.fn.spectrum.loadOpts = {};
  $.fn.spectrum.draggable = draggable;
  $.fn.spectrum.defaults = defaultOpts;
  $.fn.spectrum.inputTypeColorSupport = function inputTypeColorSupport() {
    if (typeof inputTypeColorSupport._cachedResult === "undefined") {
      var colorInput = $("<input type='color'/>")[0]; // if color element is supported, value will default to not null
      inputTypeColorSupport._cachedResult = colorInput.type === "color" && colorInput.value !== "";
    }
    return inputTypeColorSupport._cachedResult;
  };

  $.spectrum = { };
  $.spectrum.localization = { };
  $.spectrum.palettes = { };

  $.fn.spectrum.processNativeColorInputs = function () {
    var colorInputs = $("input[type=color]");
    if (colorInputs.length && !inputTypeColorSupport()) {
      colorInputs.spectrum({
        preferredFormat: "hex6"
      });
    }
  };

  // TinyColor v1.1.2
  // https://github.com/bgrins/TinyColor
  // Brian Grinstead, MIT License

  (function() {

    var trimLeft = /^[\s,#]+/,
      trimRight = /\s+$/,
      tinyCounter = 0,
      math = Math,
      mathRound = math.round,
      mathMin = math.min,
      mathMax = math.max,
      mathRandom = math.random;

    var tinycolor = function(color, opts) {

      color = (color) ? color : '';
      opts = opts || { };

      // If input is already a tinycolor, return itself
      if (color instanceof tinycolor) {
        return color;
      }
      // If we are called as a function, call using new instead
      if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
      }

      var rgb = inputToRGB(color);
      this._originalInput = color;
      this._r = rgb.r;
      this._g = rgb.g;
      this._b = rgb.b;
      this._a = rgb.a;
      this._roundA = mathRound(1000 * this._a) / 1000;
      this._format = opts.format || rgb.format;
      this._gradientType = opts.gradientType;

      // Don't let the range of [0,255] come back in [0,1].
      // Potentially lose a little bit of precision here, but will fix issues where
      // .5 gets interpreted as half of the total, instead of half of 1
      // If it was supposed to be 128, this was already taken care of by `inputToRgb`
      if (this._r < 1) { this._r = mathRound(this._r); }
      if (this._g < 1) { this._g = mathRound(this._g); }
      if (this._b < 1) { this._b = mathRound(this._b); }

      this._ok = rgb.ok;
      this._tc_id = tinyCounter++;
    };

    tinycolor.prototype = {
      isDark: function() {
        return this.getBrightness() < 128;
      },
      isLight: function() {
        return !this.isDark();
      },
      isValid: function() {
        return this._ok;
      },
      getOriginalInput: function() {
        return this._originalInput;
      },
      getFormat: function() {
        return this._format;
      },
      getAlpha: function() {
        return this._a;
      },
      getBrightness: function() {
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
      },
      setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(1000 * this._a) / 1000;
        return this;
      },
      toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
      },
      toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
      },
      toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
      },
      toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
      },
      toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
      },
      toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
      },
      toHex8: function() {
        return rgbaToHex(this._r, this._g, this._b, this._a);
      },
      toHex8String: function() {
        return '#' + this.toHex8();
      },
      toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
      },
      toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
      },
      toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
      },
      toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
      },
      toName: function() {
        if (this._a === 0) {
          return "transparent";
        }

        if (this._a < 1) {
          return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
      },
      toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
          var s = tinycolor(secondColor);
          secondHex8String = s.toHex8String();
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
      },
      toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "name");

        if (needsAlphaFormat) {
          // Special case for "transparent", all other non-alpha formats
          // will return rgba when there is transparency.
          if (format === "name" && this._a === 0) {
            return this.toName();
          }
          return this.toRgbString();
        }
        if (format === "rgb") {
          formattedString = this.toRgbString();
        }
        if (format === "prgb") {
          formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
          formattedString = this.toHexString();
        }
        if (format === "hex3") {
          formattedString = this.toHexString(true);
        }
        if (format === "hex8") {
          formattedString = this.toHex8String();
        }
        if (format === "name") {
          formattedString = this.toName();
        }
        if (format === "hsl") {
          formattedString = this.toHslString();
        }
        if (format === "hsv") {
          formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
      },

      _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
      },
      lighten: function() {
        return this._applyModification(lighten, arguments);
      },
      brighten: function() {
        return this._applyModification(brighten, arguments);
      },
      darken: function() {
        return this._applyModification(darken, arguments);
      },
      desaturate: function() {
        return this._applyModification(desaturate, arguments);
      },
      saturate: function() {
        return this._applyModification(saturate, arguments);
      },
      greyscale: function() {
        return this._applyModification(greyscale, arguments);
      },
      spin: function() {
        return this._applyModification(spin, arguments);
      },

      _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
      },
      analogous: function() {
        return this._applyCombination(analogous, arguments);
      },
      complement: function() {
        return this._applyCombination(complement, arguments);
      },
      monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
      },
      splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
      },
      triad: function() {
        return this._applyCombination(triad, arguments);
      },
      tetrad: function() {
        return this._applyCombination(tetrad, arguments);
      }
    };

    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
      if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
          if (color.hasOwnProperty(i)) {
            if (i === "a") {
              newColor[i] = color[i];
            }
            else {
              newColor[i] = convertToPercentage(color[i]);
            }
          }
        }
        color = newColor;
      }

      return tinycolor(color, opts);
    };

    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {

      var rgb = { r: 0, g: 0, b: 0 };
      var a = 1;
      var ok = false;
      var format = false;

      if (typeof color == "string") {
        color = stringInputToObject(color);
      }

      if (typeof color == "object") {
        if (color.hasOwnProperty("r") && color.hasOwnProperty("g") && color.hasOwnProperty("b")) {
          rgb = rgbToRgb(color.r, color.g, color.b);
          ok = true;
          format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("v")) {
          color.s = convertToPercentage(color.s);
          color.v = convertToPercentage(color.v);
          rgb = hsvToRgb(color.h, color.s, color.v);
          ok = true;
          format = "hsv";
        }
        else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("l")) {
          color.s = convertToPercentage(color.s);
          color.l = convertToPercentage(color.l);
          rgb = hslToRgb(color.h, color.s, color.l);
          ok = true;
          format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
          a = color.a;
        }
      }

      a = boundAlpha(a);

      return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
      };
    }


    // Conversion Functions
    // --------------------

    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b){
      return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
      };
    }

    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {

      r = bound01(r, 255);
      g = bound01(g, 255);
      b = bound01(b, 255);

      var max = mathMax(r, g, b), min = mathMin(r, g, b);
      var h, s, l = (max + min) / 2;

      if(max == min) {
        h = s = 0; // achromatic
      }
      else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
          case r: h = (g - b) / d + (g < b ? 6 : 0); break;
          case g: h = (b - r) / d + 2; break;
          case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
      }

      return { h: h, s: s, l: l };
    }

    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
      var r, g, b;

      h = bound01(h, 360);
      s = bound01(s, 100);
      l = bound01(l, 100);

      function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
      }

      if(s === 0) {
        r = g = b = l; // achromatic
      }
      else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
      }

      return { r: r * 255, g: g * 255, b: b * 255 };
    }

    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {

      r = bound01(r, 255);
      g = bound01(g, 255);
      b = bound01(b, 255);

      var max = mathMax(r, g, b), min = mathMin(r, g, b);
      var h, s, v = max;

      var d = max - min;
      s = max === 0 ? 0 : d / max;

      if(max == min) {
        h = 0; // achromatic
      }
      else {
        switch(max) {
          case r: h = (g - b) / d + (g < b ? 6 : 0); break;
          case g: h = (b - r) / d + 2; break;
          case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
      }
      return { h: h, s: s, v: v };
    }

    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {

      h = bound01(h, 360) * 6;
      s = bound01(s, 100);
      v = bound01(v, 100);

      var i = math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

      return { r: r * 255, g: g * 255, b: b * 255 };
    }

    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {

      var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
      ];

      // Return a 3 character hex if possible
      if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
      }

      return hex.join("");
    }
    // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b and a are contained in the set [0, 255]
    // Returns an 8 character hex
    function rgbaToHex(r, g, b, a) {

      var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
      ];

      return hex.join("");
    }

    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function (color1, color2) {
      if (!color1 || !color2) { return false; }
      return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
      return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
      });
    };


    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

    function desaturate(color, amount) {
      amount = (amount === 0) ? 0 : (amount || 10);
      var hsl = tinycolor(color).toHsl();
      hsl.s -= amount / 100;
      hsl.s = clamp01(hsl.s);
      return tinycolor(hsl);
    }

    function saturate(color, amount) {
      amount = (amount === 0) ? 0 : (amount || 10);
      var hsl = tinycolor(color).toHsl();
      hsl.s += amount / 100;
      hsl.s = clamp01(hsl.s);
      return tinycolor(hsl);
    }

    function greyscale(color) {
      return tinycolor(color).desaturate(100);
    }

    function lighten (color, amount) {
      amount = (amount === 0) ? 0 : (amount || 10);
      var hsl = tinycolor(color).toHsl();
      hsl.l += amount / 100;
      hsl.l = clamp01(hsl.l);
      return tinycolor(hsl);
    }

    function brighten(color, amount) {
      amount = (amount === 0) ? 0 : (amount || 10);
      var rgb = tinycolor(color).toRgb();
      rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
      rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
      rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
      return tinycolor(rgb);
    }

    function darken (color, amount) {
      amount = (amount === 0) ? 0 : (amount || 10);
      var hsl = tinycolor(color).toHsl();
      hsl.l -= amount / 100;
      hsl.l = clamp01(hsl.l);
      return tinycolor(hsl);
    }

    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function spin(color, amount) {
      var hsl = tinycolor(color).toHsl();
      var hue = (mathRound(hsl.h) + amount) % 360;
      hsl.h = hue < 0 ? 360 + hue : hue;
      return tinycolor(hsl);
    }

    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

    function complement(color) {
      var hsl = tinycolor(color).toHsl();
      hsl.h = (hsl.h + 180) % 360;
      return tinycolor(hsl);
    }

    function triad(color) {
      var hsl = tinycolor(color).toHsl();
      var h = hsl.h;
      return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
      ];
    }

    function tetrad(color) {
      var hsl = tinycolor(color).toHsl();
      var h = hsl.h;
      return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
      ];
    }

    function splitcomplement(color) {
      var hsl = tinycolor(color).toHsl();
      var h = hsl.h;
      return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
      ];
    }

    function analogous(color, results, slices) {
      results = results || 6;
      slices = slices || 30;

      var hsl = tinycolor(color).toHsl();
      var part = 360 / slices;
      var ret = [tinycolor(color)];

      for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
      }
      return ret;
    }

    function monochromatic(color, results) {
      results = results || 6;
      var hsv = tinycolor(color).toHsv();
      var h = hsv.h, s = hsv.s, v = hsv.v;
      var ret = [];
      var modification = 1 / results;

      while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
      }

      return ret;
    }

    // Utility Functions
    // ---------------------

    tinycolor.mix = function(color1, color2, amount) {
      amount = (amount === 0) ? 0 : (amount || 50);

      var rgb1 = tinycolor(color1).toRgb();
      var rgb2 = tinycolor(color2).toRgb();

      var p = amount / 100;
      var w = p * 2 - 1;
      var a = rgb2.a - rgb1.a;

      var w1;

      if (w * a == -1) {
        w1 = w;
      } else {
        w1 = (w + a) / (1 + w * a);
      }

      w1 = (w1 + 1) / 2;

      var w2 = 1 - w1;

      var rgba = {
        r: rgb2.r * w1 + rgb1.r * w2,
        g: rgb2.g * w1 + rgb1.g * w2,
        b: rgb2.b * w1 + rgb1.b * w2,
        a: rgb2.a * p  + rgb1.a * (1 - p)
      };

      return tinycolor(rgba);
    };


    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/AERT#color-contrast>

    // `readability`
    // Analyze the 2 colors and returns an object with the following properties:
    //    `brightness`: difference in brightness between the two colors
    //    `color`: difference in color/hue between the two colors
    tinycolor.readability = function(color1, color2) {
      var c1 = tinycolor(color1);
      var c2 = tinycolor(color2);
      var rgb1 = c1.toRgb();
      var rgb2 = c2.toRgb();
      var brightnessA = c1.getBrightness();
      var brightnessB = c2.getBrightness();
      var colorDiff = (
        Math.max(rgb1.r, rgb2.r) - Math.min(rgb1.r, rgb2.r) +
        Math.max(rgb1.g, rgb2.g) - Math.min(rgb1.g, rgb2.g) +
        Math.max(rgb1.b, rgb2.b) - Math.min(rgb1.b, rgb2.b)
      );

      return {
        brightness: Math.abs(brightnessA - brightnessB),
        color: colorDiff
      };
    };

    // `readable`
    // http://www.w3.org/TR/AERT#color-contrast
    // Ensure that foreground and background color combinations provide sufficient contrast.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    tinycolor.isReadable = function(color1, color2) {
      var readability = tinycolor.readability(color1, color2);
      return readability.brightness > 125 && readability.color > 500;
    };

    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // *Example*
    //    tinycolor.mostReadable("#123", ["#fff", "#000"]) => "#000"
    tinycolor.mostReadable = function(baseColor, colorList) {
      var bestColor = null;
      var bestScore = 0;
      var bestIsReadable = false;
      for (var i=0; i < colorList.length; i++) {

        // We normalize both around the "acceptable" breaking point,
        // but rank brightness constrast higher than hue.

        var readability = tinycolor.readability(baseColor, colorList[i]);
        var readable = readability.brightness > 125 && readability.color > 500;
        var score = 3 * (readability.brightness / 125) + (readability.color / 500);

        if ((readable && ! bestIsReadable) ||
          (readable && bestIsReadable && score > bestScore) ||
          ((! readable) && (! bestIsReadable) && score > bestScore)) {
          bestIsReadable = readable;
          bestScore = score;
          bestColor = tinycolor(colorList[i]);
        }
      }
      return bestColor;
    };


    // Big List of Colors
    // ------------------
    // <http://www.w3.org/TR/css3-color/#svg-color>
    var names = tinycolor.names = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "0ff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000",
      blanchedalmond: "ffebcd",
      blue: "00f",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      burntsienna: "ea7e5d",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "0ff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkgrey: "a9a9a9",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkslategrey: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dimgrey: "696969",
      dodgerblue: "1e90ff",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "f0f",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      grey: "808080",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgray: "d3d3d3",
      lightgreen: "90ee90",
      lightgrey: "d3d3d3",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslategray: "789",
      lightslategrey: "789",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "0f0",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "f0f",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370db",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "db7093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "663399",
      red: "f00",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      slategrey: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      wheat: "f5deb3",
      white: "fff",
      whitesmoke: "f5f5f5",
      yellow: "ff0",
      yellowgreen: "9acd32"
    };

    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);


    // Utilities
    // ---------

    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
      var flipped = { };
      for (var i in o) {
        if (o.hasOwnProperty(i)) {
          flipped[o[i]] = i;
        }
      }
      return flipped;
    }

    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
      a = parseFloat(a);

      if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
      }

      return a;
    }

    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
      if (isOnePointZero(n)) { n = "100%"; }

      var processPercent = isPercentage(n);
      n = mathMin(max, mathMax(0, parseFloat(n)));

      // Automatically convert percentage into number
      if (processPercent) {
        n = parseInt(n * max, 10) / 100;
      }

      // Handle floating point rounding errors
      if ((math.abs(n - max) < 0.000001)) {
        return 1;
      }

      // Convert into [0, 1] range if it isn't already
      return (n % max) / parseFloat(max);
    }

    // Force a number between 0 and 1
    function clamp01(val) {
      return mathMin(1, mathMax(0, val));
    }

    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
      return parseInt(val, 16);
    }

    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
      return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
    }

    // Check to see if string passed in is a percentage
    function isPercentage(n) {
      return typeof n === "string" && n.indexOf('%') != -1;
    }

    // Force a hex value to have 2 characters
    function pad2(c) {
      return c.length == 1 ? '0' + c : '' + c;
    }

    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
      if (n <= 1) {
        n = (n * 100) + "%";
      }

      return n;
    }

    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
      return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
      return (parseIntFromHex(h) / 255);
    }

    var matchers = (function() {

      // <http://www.w3.org/TR/css3-values/#integers>
      var CSS_INTEGER = "[-\\+]?\\d+%?";

      // <http://www.w3.org/TR/css3-values/#number-value>
      var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

      // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
      var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

      // Actual matching.
      // Parentheses and commas are optional, but not required.
      // Whitespace can take the place of commas or opening paren
      var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
      var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

      return {
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex8: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
      };
    })();

    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {

      color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
      var named = false;
      if (names[color]) {
        color = names[color];
        named = true;
      }
      else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
      }

      // Try to match string input using regular expressions.
      // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
      // Just return an object and let the conversion functions handle that.
      // This way the result will be the same whether the tinycolor is initialized with string or object.
      var match;
      if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
      }
      if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
      }
      if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
      }
      if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
      }
      if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
      }
      if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
      }
      if ((match = matchers.hex8.exec(color))) {
        return {
          a: convertHexToDecimal(match[1]),
          r: parseIntFromHex(match[2]),
          g: parseIntFromHex(match[3]),
          b: parseIntFromHex(match[4]),
          format: named ? "name" : "hex8"
        };
      }
      if ((match = matchers.hex6.exec(color))) {
        return {
          r: parseIntFromHex(match[1]),
          g: parseIntFromHex(match[2]),
          b: parseIntFromHex(match[3]),
          format: named ? "name" : "hex"
        };
      }
      if ((match = matchers.hex3.exec(color))) {
        return {
          r: parseIntFromHex(match[1] + '' + match[1]),
          g: parseIntFromHex(match[2] + '' + match[2]),
          b: parseIntFromHex(match[3] + '' + match[3]),
          format: named ? "name" : "hex"
        };
      }

      return false;
    }

    window.tinycolor = tinycolor;
  })();

  $(function () {
    if ($.fn.spectrum.load) {
      $.fn.spectrum.processNativeColorInputs();
    }
  });

});

// Spectrum Colorpicker
// Arabic (ar) localization
// https://github.com/seballot/spectrum
(function ( $ ) {

  var localization = $.spectrum.localization["ar"] = {
    cancelText: "إلغاء",
    chooseText: "إختار",
    clearText: "إرجاع الألوان على ما كانت",
    noColorSelectedText: "لم تختار أي لون",
    togglePaletteMoreText: "أكثر",
    togglePaletteLessText: "أقل"
  };

})( jQuery );

// Spectrum Colorpicker
// Catalan (ca) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["ca"] = {
    cancelText: "Cancel·lar",
    chooseText: "Escollir",
    clearText: "Esborrar color seleccionat",
    noColorSelectedText: "Cap color seleccionat",
    togglePaletteMoreText: "Més",
    togglePaletteLessText: "Menys"
  };

})( jQuery );

// Spectrum Colorpicker
// Czech (cs) localization
// https://github.com/seballot/spectrum
// author localization cs Pavel Laupe Dvorak pavel@pavel-dvorak.cz

(function ( $ ) {

  var localization = $.spectrum.localization["cs"] = {
    cancelText: "zrušit",
    chooseText: "vybrat",
    clearText: "Resetovat výběr barev",
    noColorSelectedText: "Žádná barva nebyla vybrána",
    togglePaletteMoreText: "více",
    togglePaletteLessText: "méně"
  };

})( jQuery );

// Spectrum Colorpicker
// German (de) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["de"] = {
    cancelText: "Abbrechen",
    chooseText: "Wählen",
    clearText: "Farbauswahl zurücksetzen",
    noColorSelectedText: "Keine Farbe ausgewählt",
    togglePaletteMoreText: "Mehr",
    togglePaletteLessText: "Weniger"
  };

})( jQuery );

// Spectrum Colorpicker
// Danish (dk) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["dk"] = {
    cancelText: "annuller",
    chooseText: "Vælg"
  };

})( jQuery );

// Spectrum Colorpicker
// Spanish (es) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["es"] = {
    cancelText: "Cancelar",
    chooseText: "Elegir",
    clearText: "Borrar color seleccionado",
    noColorSelectedText: "Ningún color seleccionado",
    togglePaletteMoreText: "Más",
    togglePaletteLessText: "Menos"
  };

})( jQuery );

// Spectrum Colorpicker
// Estonian (et) localization
// https://github.com/bgrins/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["et"] = {
    cancelText: "Katkesta",
    chooseText: "Vali",
    clearText: "Tühista värvivalik",
    noColorSelectedText: "Ühtki värvi pole valitud",
    togglePaletteMoreText: "Rohkem",
    togglePaletteLessText: "Vähem"
  };

})( jQuery );

// Spectrum Colorpicker
// Persian (fa) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["fa"] = {
    cancelText: "لغو",
    chooseText: "انتخاب",
    clearText: "تنظیم مجدد رنگ",
    noColorSelectedText: "هیچ رنگی انتخاب نشده است!",
    togglePaletteMoreText: "بیشتر",
    togglePaletteLessText: "کمتر"
  };

})( jQuery );

// Spectrum Colorpicker
// Finnish (fi) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["fi"] = {
    cancelText: "Kumoa",
    chooseText: "Valitse"
  };

})( jQuery );

// Spectrum Colorpicker
// French (fr) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["fr"] = {
    cancelText: "Annuler",
    chooseText: "Valider",
    clearText: "Effacer couleur sélectionnée",
    noColorSelectedText: "Aucune couleur sélectionnée",
    togglePaletteMoreText: "Plus",
    togglePaletteLessText: "Moins"
  };

})( jQuery );

// Spectrum Colorpicker
// Greek (gr) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["gr"] = {
    cancelText: "Ακύρωση",
    chooseText: "Επιλογή",
    clearText: "Καθαρισμός επιλεγμένου χρώματος",
    noColorSelectedText: "Δεν έχει επιλεχθεί κάποιο χρώμα",
    togglePaletteMoreText: "Περισσότερα",
    togglePaletteLessText: "Λιγότερα"
  };

})( jQuery );

// Spectrum Colorpicker
// Hebrew (he) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["he"] = {
    cancelText: "בטל בחירה",
    chooseText: "בחר צבע",
    clearText: "אפס בחירה",
    noColorSelectedText: "לא נבחר צבע",
    togglePaletteMoreText: "עוד צבעים",
    togglePaletteLessText: "פחות צבעים"
  };

})( jQuery );

// Spectrum Colorpicker
// Croatian (hr) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["hr"] = {
    cancelText: "Odustani",
    chooseText: "Odaberi",
    clearText: "Poništi odabir",
    noColorSelectedText: "Niti jedna boja nije odabrana",
    togglePaletteMoreText: "Više",
    togglePaletteLessText: "Manje"
  };

})( jQuery );

// Spectrum Colorpicker
// Hungarian (hu) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["hu"] = {
    cancelText: "Mégsem",
    chooseText: "Mentés",
    clearText: "A színválasztás visszaállítása",
    noColorSelectedText: "Nincs szín kijelölve",
    togglePaletteMoreText: "Több",
    togglePaletteLessText: "Kevesebb"
  };

})( jQuery );

// Spectrum Colorpicker
// Indonesia/Bahasa Indonesia (id) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["id"] = {
    cancelText: "Batal",
    chooseText: "Pilih",
    clearText: "Hapus Pilihan Warna",
    noColorSelectedText: "Warna Tidak Dipilih",
    togglePaletteMoreText: "tambah",
    togglePaletteLessText: "kurangi"
  };

})( jQuery );

// Spectrum Colorpicker
// Italian (it) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["it"] = {
    cancelText: "annulla",
    chooseText: "scegli",
    clearText: "Annulla selezione colore",
    noColorSelectedText: "Nessun colore selezionato"
  };

})( jQuery );

// Spectrum Colorpicker
// Japanese (ja) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["ja"] = {
    cancelText: "中止",
    chooseText: "選択"
  };

})( jQuery );

// Spectrum Colorpicker
// Korean (ko) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["ko"] = {
    cancelText: "취소",
    chooseText: "선택",
    clearText: "선택 초기화",
    noColorSelectedText: "선택된 색상 없음",
    togglePaletteMoreText: "더보기",
    togglePaletteLessText: "줄이기"
  };

})( jQuery );

// Spectrum Colorpicker
// Lithuanian (lt) localization
// https://github.com/liesislukas

(function ( $ ) {

  var localization = $.spectrum.localization["lt"] = {
    cancelText: "Atšaukti",
    chooseText: "Pasirinkti",
    clearText: "Išvalyti pasirinkimą",
    noColorSelectedText: "Spalva nepasirinkta",
    togglePaletteMoreText: "Daugiau",
    togglePaletteLessText: "Mažiau"
  };

})( jQuery );

// Spectrum Colorpicker
// Norwegian, Bokmål (nb-no) localization
// https://github.com/greendimka

(function ( $ ) {

  var localization = $.spectrum.localization["nb-no"] = {
    cancelText: "Avbryte",
    chooseText: "Velg",
    clearText: "Tilbakestill",
    noColorSelectedText: "Farge er ikke valgt",
    togglePaletteMoreText: "Mer",
    togglePaletteLessText: "Mindre"
  };

})( jQuery );

// Spectrum Colorpicker
// Dutch (nl-nl) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["nl-nl"] = {
    cancelText: "Annuleer",
    chooseText: "Kies",
    clearText: "Wis kleur selectie",
    togglePaletteMoreText: 'Meer',
    togglePaletteLessText: 'Minder'
  };

})( jQuery );

// Spectrum Colorpicker
// Polish (pl) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["pl"] = {
    cancelText: "Anuluj",
    chooseText: "Wybierz",
    clearText: "Usuń wybór koloru",
    noColorSelectedText: "Nie wybrano koloru",
    togglePaletteMoreText: "Więcej",
    togglePaletteLessText: "Mniej"
  };

})( jQuery );

// Spectrum Colorpicker
// Brazilian (pt-br) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["pt-br"] = {
    cancelText: "Cancelar",
    chooseText: "Escolher",
    clearText: "Limpar cor selecionada",
    noColorSelectedText: "Nenhuma cor selecionada",
    togglePaletteMoreText: "Mais",
    togglePaletteLessText: "Menos"
  };

})( jQuery );

// Spectrum Colorpicker
// Portuguese (pt-pt) localization
// https://github.com/bgrins/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["pt-pt"] = {
    cancelText: "Cancelar",
    chooseText: "Escolher",
    clearText: "Limpar cor seleccionada",
    noColorSelectedText: "Nenhuma cor seleccionada",
    togglePaletteMoreText: "Mais",
    togglePaletteLessText: "Menos"
  };

})( jQuery );

// Spectrum Colorpicker
// Russian (ru) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["ru"] = {
    cancelText: "Отмена",
    chooseText: "Выбрать",
    clearText: "Сбросить",
    noColorSelectedText: "Цвет не выбран",
    togglePaletteMoreText: "Ещё",
    togglePaletteLessText: "Скрыть"
  };

})( jQuery );

// Spectrum Colorpicker
// Swedish (sv) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["sv"] = {
    cancelText: "Avbryt",
    chooseText: "Välj"
  };

})( jQuery );

// Spectrum Colorpicker
// Turkish (tr) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["tr"] = {
    cancelText: "iptal",
    chooseText: "tamam"
  };

})( jQuery );

// Spectrum Colorpicker
// Simplified Chinese (zh-cn) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["zh-cn"] = {
    cancelText: "取消",
    chooseText: "选择",
    clearText: "清除",
    togglePaletteMoreText: "更多选项",
    togglePaletteLessText: "隐藏",
    noColorSelectedText: "尚未选择任何颜色"
  };

})( jQuery );

// Spectrum Colorpicker
// Traditional Chinese (zh-tw) localization
// https://github.com/seballot/spectrum

(function ( $ ) {

  var localization = $.spectrum.localization["zh-tw"] = {
    cancelText: "取消",
    chooseText: "選擇",
    clearText: "清除",
    togglePaletteMoreText: "更多選項",
    togglePaletteLessText: "隱藏",
    noColorSelectedText: "尚未選擇任何顏色"
  };

})( jQuery );

(function (factory) {
  "use strict";

  if (typeof define === 'function' && define.amd) { // AMD
    define(['jquery'], factory);
  }
  else if (typeof exports == "object" && typeof module == "object") { // CommonJS
    module.exports = factory(require('jquery'));
  }
  else { // Browser
    factory(jQuery);
  }
})(function($, undefined) {
  "use strict";

  var defaultOpts = {
    beforeShow: noop,
    change: noop,
    show: noop,
    hide: noop,

    appendTo: "body",
    cancelText: "cancel",
    chooseText: "apply",
    disabled: false,
    offset: null,
    elements: ['margin', 'padding', 'height', 'width', 'margin-top', 'margin-left', 'margin-bottom', 'margin-right',
      'padding-top', 'padding-left', 'padding-bottom', 'padding-right', 'background-size', 'aspect-ratio', 'background-repeat'],
  },
  settingsPopups = [],
  markup = (function () {
    return [
      "<div class='es-container es-hidden'>",
      "<div class='es-input-container'>",
      "</div>",
      "<div class='es-button-container'>",
      "<button type='button' class='es-cancel'></button>",
      "<button type='button' class='es-choose'></button>",
      "</div>",
      "</div>"
    ].join('');
  })();

  function instanceOptions(o, callbackContext) {
    var opts = $.extend({}, defaultOpts, o);
    opts.callbacks = {
      'change': bind(opts.change, callbackContext),
      'show': bind(opts.show, callbackContext),
      'hide': bind(opts.hide, callbackContext),
      'beforeShow': bind(opts.beforeShow, callbackContext)
    };

    return opts;
  }

  function hideAll() {
    for (var i = 0; i < settingsPopups.length; i++) {
      if (settingsPopups[i]) {
        settingsPopups[i].hide();
      }
    }
  }

  function editorSettings(element, o) {
    var opts = instanceOptions(o, element),
    callbacks = opts.callbacks,
    resize = throttle(reflow, 10),
    visible = false,
    activeBlock = null;

    var doc = element.ownerDocument,
      boundElement = $(element),
      disabled = false,
      container = $(markup, doc),
      inputContainer = container.find(".es-input-container"),
      cancelButton = container.find(".es-cancel"),
      chooseButton = container.find(".es-choose"),
      clickoutFiresChange = opts.clickoutFiresChange,
      offsetElement = boundElement,
      elements = opts.elements;

    var thisId = boundElement.attr('id');
    if(thisId !== undefined && thisId.length > 0) {
      var label = $('label[for="'+thisId+'"]');
      if(label.length) {
        label.on('click', function(e){
          e.preventDefault();
          boundElement.editorSettings('show');
          return false;
        });
      }
    }

    function destroy() {
      boundElement.show().removeClass('editorSettings with-add-on sp-colorize');
      offsetElement.off("click.editorSettings touchstart.editorSettings");
      container.remove();
      var originalInputContainer = boundElement.closest('.sp-original-input-container');
      if (originalInputContainer.length > 0) {
        originalInputContainer.after(boundElement).remove();
      }
      settingsPopups[esPopup.id] = null;
    }

    function reflow() {
      if (!visible) {
        return; // Calculations would be useless and wouldn't be reliable anyways
      }
      container.css("position", "absolute");
      if (opts.offset) {
        container.offset(opts.offset);
      } else {
        container.offset(getOffset(container, offsetElement));
      }
      boundElement.trigger('reflow.editorSettings');
    }

    function show() {
      // debugger;
      var event = $.Event('beforeShow.editorSettings');

      if (visible) {
        reflow();
        return;
      }

      boundElement.trigger(event, [ get() ]);

      if (callbacks.beforeShow(get()) === false || event.isDefaultPrevented()) {
        return;
      }

      hideAll();
      visible = true;

      $(doc).on("click.editorSettings", clickout);
      $(window).on("resize.editorSettings", resize);
      container.removeClass("es-hidden");

      reflow();
      boundElement.trigger('show.spectrum', [ null ]);
    }

    function clickout(e) {
      // Return on right click.
      if (e.button == 2) { return; }

      if (clickoutFiresChange) {
        boundElement.trigger('change', [ get() ]);
        callbacks.change(get(), opts.elements);
      }
      hide();
    }

    function initialize() {
      var appendTo = opts.appendTo === "parent" ? boundElement.parent() : $(opts.appendTo);
      if (appendTo.length !== 1) {
        appendTo = $("body");
      }
      appendTo.append(container);

      reflow();

      offsetElement.on("click.editorSettings touchstart.editorSettings", function (e) {
        if (!disabled) {
          show();
        }
        e.stopPropagation();
      });

      if(boundElement.is(":disabled") || (opts.disabled === true)) {
        disable();
      }

      let html = [];
      let input = '';
      elements.forEach(item => {
        let displayName = item.replace('-', ' ');
        if(item === 'background-size') {
          input += `<div class="es-input-control">
                        <label class="es-label">${displayName}</label>
                        <div class="es-input-group">
                            <select name="${item}" class="es-input" style='background-color: white'>
                              <option value='' selected='selected'>select</option>
                              <option value='cover'>cover</option>
                              <option value='contain'>contain</option>
                            </select>
                        </div></div>`;
        } else if(item === 'background-repeat') {
          input += `<div class="es-input-control" style='margin-left: 24px '>
                        <label class="es-label">${displayName}</label>
                        <div class="es-input-group">
                            <select name="${item}" class="es-input" style='background-color: white'>
                              <option value='' selected='selected'>select</option>
                              <option value='repeat'>repeat</option>
                              <option value='repeat-x'>repeat-x</option>
                              <option value='repeat-y'>repeat-y</option>
                            </select>
                        </div></div>`;
        } else if (item === 'aspect-ratio') {
          input += `<div class='es-input-control'>
                        <label class='es-label'>${displayName}</label>
                       <div class='es-input-group'>
                            <input type='number' name='${item}' class='es-input' min='1' step='0.1' placeholder='${displayName}'/>
                        </div></div>`;
        } else {
          input += `<div class='es-input-control'>
                        <label class='es-label'>${displayName}</label>
                        <div class='es-input-group'>
                            <input type='text' name='${item}' class='es-input' placeholder='${displayName}'/><span class='es-input-post-fix'>px</span>
                        </div></div>`;
        }
      })
      html.push(input);

      inputContainer.append(html.join(''));

      // Prevent clicks from bubbling up to document.  This would cause it to be hidden.
      container.click(stopPropagation);

      cancelButton.text(opts.cancelText);
      cancelButton.on("click.editorSettings", function (e) {
        e.stopPropagation();
        e.preventDefault();
        hide();
      });

      chooseButton.text(opts.chooseText);
      chooseButton.on("click.editorSettings", function (e) {
        e.stopPropagation();
        e.preventDefault()
        boundElement.trigger('change', [ get() ]);
        callbacks.change(get(), opts.elements);
        hide();
      });
    }

    function hide() {
      // Return if hiding is unnecessary
      if (!visible) { return; }
      visible = false;

      $(doc).off("click.editorSettings", clickout);
      $(window).off("resize.editorSettings", resize);
      container.addClass("es-hidden");

      callbacks.hide(get());
      boundElement.trigger('hide.editorSettings', [ get() ]);
    }

    function enable() {
      disabled = false;
      boundElement.attr("disabled", false);
      offsetElement.removeClass("es-disabled");
    }

    function disable() {
      hide();
      disabled = true;
      boundElement.attr("disabled", true);
      offsetElement.addClass("es-disabled");
    }

    function updateBlockValue(block) {
      if (activeBlock == block) return;
      activeBlock = block;
      opts.elements.forEach(item => {
        let value = activeBlock.el.style[item];
        if (item === 'aspect-ratio') {
          value = value.substring(0, value.indexOf(' '));
        }
        if (item === 'background-size' || item === 'background-repeat') {
          let inputBox = container.find(`.es-input-control .es-input-group select[name="${item}"]`)
          if (inputBox) {
            if (item === 'background-size' && value === 'unset') {
              value = 'cover'
            }
            inputBox.val((value || ''));
          }
        }
        else {
          let inputBox = container.find(`.es-input-control .es-input-group input[name="${item}"]`)
          if (inputBox) {
            inputBox.val((value || '').replace('px', ''));
          }
        }
      })
    }

    function get() {
      let returnValue = {};
      opts.elements.forEach(item => {
        if (item === 'background-size' || item === 'background-repeat') {
          let inputBox = container.find(`.es-input-control .es-input-group select[name="${item}"]`);
          if (inputBox) {
            returnValue[item] = (inputBox.val());
          }
        }
        else{
          let inputBox = container.find(`.es-input-control .es-input-group input[name="${item}"]`)
          if (inputBox) {
            returnValue[item] = (inputBox.val()).replace('px', '');
          }
        }
      })
      return returnValue;
    }

    initialize();

    var esPopup = {
      show: show,
      hide: hide,
      reflow: reflow,
      enable: enable,
      disable: disable,
      get: get,
      destroy: destroy,
      updateBlockValue: updateBlockValue,
      container: container
    };

    esPopup.id = settingsPopups.push(esPopup) - 1;

    return esPopup;
  }

  function bind(func, obj) {
    var slice = Array.prototype.slice;
    var args = slice.call(arguments, 2);
    return function () {
      return func.apply(obj, args.concat(slice.call(arguments)));
    };
  }

  function throttle(func, wait, debounce) {
    var timeout;
    return function () {
      var context = this, args = arguments;
      var throttler = function () {
        timeout = null;
        func.apply(context, args);
      };
      if (debounce) clearTimeout(timeout);
      if (debounce || !timeout) timeout = setTimeout(throttler, wait);
    };
  }

  /**
   * noop - do nothing
   */
  function noop() {

  }

  /**
   * stopPropagation - makes the code only doing this a little easier to read in line
   */
  function stopPropagation(e) {
    e.stopPropagation();
  }

  function getOffset(picker, input) {
    var extraY = 0;
    var dpWidth = picker.outerWidth();
    var dpHeight = picker.outerHeight();
    var inputHeight = input.outerHeight();
    var doc = picker[0].ownerDocument;
    var docElem = doc.documentElement;
    var viewWidth = docElem.clientWidth + $(doc).scrollLeft();
    var viewHeight = docElem.clientHeight + $(doc).scrollTop();
    var offset = input.offset();
    var offsetLeft = offset.left;
    var offsetTop = offset.top;

    offsetTop += inputHeight;

    offsetLeft -=
      Math.min(offsetLeft, (offsetLeft + dpWidth > viewWidth && viewWidth > dpWidth) ?
        Math.abs(offsetLeft + dpWidth - viewWidth) : 0);

    offsetTop -=
      Math.min(offsetTop, ((offsetTop + dpHeight > viewHeight && viewHeight > dpHeight) ?
        Math.abs(dpHeight + inputHeight - extraY) : extraY));

    return {
      top: offsetTop,
      bottom: offset.bottom,
      left: offsetLeft,
      right: offset.right,
      width: offset.width,
      height: offset.height
    };
  }

  var dataID = "editorSettings.id";
  $.fn.editorSettings = function (opts) {
    if (typeof opts == "string") {

      var returnValue = this;
      var args = Array.prototype.slice.call( arguments, 1 );

      this.each(function () {
        var esPopup = settingsPopups[$(this).data(dataID)];
        if (esPopup) {
          var method = esPopup[opts];
          if (!method) {
            throw new Error( "Editor Settings: no such method: '" + opts + "'" );
          }
          if (opts == "destroy") {
            esPopup.destroy();
            $(this).removeData(dataID);
          }
          else {
            method.apply(esPopup, args);
          }
        }
      });

      return returnValue;
    }

    return this.editorSettings("destroy").each(function () {
      var options = $.extend({}, $(this).data(), opts);
      var esPopup = editorSettings(this, options);
      $(this).data(dataID, esPopup.id);
    });
  }
});

(function(){function o(n){var i=e;n&&(e[n]||(e[n]={}),i=e[n]);if(!i.define||!i.define.packaged)t.original=i.define,i.define=t,i.define.packaged=!0;if(!i.require||!i.require.packaged)r.original=i.require,i.require=r,i.require.packaged=!0}var ACE_NAMESPACE="",e=function(){return this}();!e&&typeof window!="undefined"&&(e=window);if(!ACE_NAMESPACE&&typeof requirejs!="undefined")return;var t=function(e,n,r){if(typeof e!="string"){t.original?t.original.apply(this,arguments):(console.error("dropping module because define wasn't a string."),console.trace());return}arguments.length==2&&(r=n),t.modules[e]||(t.payloads[e]=r,t.modules[e]=null)};t.modules={},t.payloads={};var n=function(e,t,n){if(typeof t=="string"){var i=s(e,t);if(i!=undefined)return n&&n(),i}else if(Object.prototype.toString.call(t)==="[object Array]"){var o=[];for(var u=0,a=t.length;u<a;++u){var f=s(e,t[u]);if(f==undefined&&r.original)return;o.push(f)}return n&&n.apply(null,o)||!0}},r=function(e,t){var i=n("",e,t);return i==undefined&&r.original?r.original.apply(this,arguments):i},i=function(e,t){if(t.indexOf("!")!==-1){var n=t.split("!");return i(e,n[0])+"!"+i(e,n[1])}if(t.charAt(0)=="."){var r=e.split("/").slice(0,-1).join("/");t=r+"/"+t;while(t.indexOf(".")!==-1&&s!=t){var s=t;t=t.replace(/\/\.\//,"/").replace(/[^\/]+\/\.\.\//,"")}}return t},s=function(e,r){r=i(e,r);var s=t.modules[r];if(!s){s=t.payloads[r];if(typeof s=="function"){var o={},u={id:r,uri:"",exports:o,packaged:!0},a=function(e,t){return n(r,e,t)},f=s(a,o,u);o=f||u.exports,t.modules[r]=o,delete t.payloads[r]}s=t.modules[r]=o||s}return s};o(ACE_NAMESPACE)})(),define("ace/lib/es6-shim",["require","exports","module"],function(e,t,n){function r(e,t,n){Object.defineProperty(e,t,{value:n,enumerable:!1,writable:!0,configurable:!0})}String.prototype.startsWith||r(String.prototype,"startsWith",function(e,t){return t=t||0,this.lastIndexOf(e,t)===t}),String.prototype.endsWith||r(String.prototype,"endsWith",function(e,t){var n=this;if(t===undefined||t>n.length)t=n.length;t-=e.length;var r=n.indexOf(e,t);return r!==-1&&r===t}),String.prototype.repeat||r(String.prototype,"repeat",function(e){var t="",n=this;while(e>0){e&1&&(t+=n);if(e>>=1)n+=n}return t}),String.prototype.includes||r(String.prototype,"includes",function(e,t){return this.indexOf(e,t)!=-1}),Object.assign||(Object.assign=function(e){if(e===undefined||e===null)throw new TypeError("Cannot convert undefined or null to object");var t=Object(e);for(var n=1;n<arguments.length;n++){var r=arguments[n];r!==undefined&&r!==null&&Object.keys(r).forEach(function(e){t[e]=r[e]})}return t}),Object.values||(Object.values=function(e){return Object.keys(e).map(function(t){return e[t]})}),Array.prototype.find||r(Array.prototype,"find",function(e){var t=this.length,n=arguments[1];for(var r=0;r<t;r++){var i=this[r];if(e.call(n,i,r,this))return i}}),Array.prototype.findIndex||r(Array.prototype,"findIndex",function(e){var t=this.length,n=arguments[1];for(var r=0;r<t;r++){var i=this[r];if(e.call(n,i,r,this))return r}}),Array.prototype.includes||r(Array.prototype,"includes",function(e,t){return this.indexOf(e,t)!=-1}),Array.prototype.fill||r(Array.prototype,"fill",function(e){var t=this,n=t.length>>>0,r=arguments[1],i=r>>0,s=i<0?Math.max(n+i,0):Math.min(i,n),o=arguments[2],u=o===undefined?n:o>>0,a=u<0?Math.max(n+u,0):Math.min(u,n);while(s<a)t[s]=e,s++;return t}),Array.of||r(Array,"of",function(){return Array.prototype.slice.call(arguments)})}),define("ace/lib/fixoldbrowsers",["require","exports","module","ace/lib/es6-shim"],function(e,t,n){"use strict";e("./es6-shim")}),define("ace/lib/deep_copy",["require","exports","module"],function(e,t,n){t.deepCopy=function r(e){if(typeof e!="object"||!e)return e;var t;if(Array.isArray(e)){t=[];for(var n=0;n<e.length;n++)t[n]=r(e[n]);return t}if(Object.prototype.toString.call(e)!=="[object Object]")return e;t={};for(var n in e)t[n]=r(e[n]);return t}}),define("ace/lib/lang",["require","exports","module","ace/lib/deep_copy"],function(e,t,n){"use strict";t.last=function(e){return e[e.length-1]},t.stringReverse=function(e){return e.split("").reverse().join("")},t.stringRepeat=function(e,t){var n="";while(t>0){t&1&&(n+=e);if(t>>=1)e+=e}return n};var r=/^\s\s*/,i=/\s\s*$/;t.stringTrimLeft=function(e){return e.replace(r,"")},t.stringTrimRight=function(e){return e.replace(i,"")},t.copyObject=function(e){var t={};for(var n in e)t[n]=e[n];return t},t.copyArray=function(e){var t=[];for(var n=0,r=e.length;n<r;n++)e[n]&&typeof e[n]=="object"?t[n]=this.copyObject(e[n]):t[n]=e[n];return t},t.deepCopy=e("./deep_copy").deepCopy,t.arrayToMap=function(e){var t={};for(var n=0;n<e.length;n++)t[e[n]]=1;return t},t.createMap=function(e){var t=Object.create(null);for(var n in e)t[n]=e[n];return t},t.arrayRemove=function(e,t){for(var n=0;n<=e.length;n++)t===e[n]&&e.splice(n,1)},t.escapeRegExp=function(e){return e.replace(/([.*+?^${}()|[\]\/\\])/g,"\\$1")},t.escapeHTML=function(e){return(""+e).replace(/&/g,"&#38;").replace(/"/g,"&#34;").replace(/'/g,"&#39;").replace(/</g,"&#60;")},t.getMatchOffsets=function(e,t){var n=[];return e.replace(t,function(e){n.push({offset:arguments[arguments.length-2],length:e.length})}),n},t.deferredCall=function(e){var t=null,n=function(){t=null,e()},r=function(e){return r.cancel(),t=setTimeout(n,e||0),r};return r.schedule=r,r.call=function(){return this.cancel(),e(),r},r.cancel=function(){return clearTimeout(t),t=null,r},r.isPending=function(){return t},r},t.delayedCall=function(e,t){var n=null,r=function(){n=null,e()},i=function(e){n==null&&(n=setTimeout(r,e||t))};return i.delay=function(e){n&&clearTimeout(n),n=setTimeout(r,e||t)},i.schedule=i,i.call=function(){this.cancel(),e()},i.cancel=function(){n&&clearTimeout(n),n=null},i.isPending=function(){return n},i},t.sleep=function(e){return new Promise(function(t){setTimeout(t,e)})},t.supportsLookbehind=function(){try{new RegExp("(?<=.)")}catch(e){return!1}return!0},t.skipEmptyMatch=function(e,t,n){return n&&e.codePointAt(t)>65535?2:1}}),define("ace/lib/useragent",["require","exports","module"],function(e,t,n){"use strict";t.OS={LINUX:"LINUX",MAC:"MAC",WINDOWS:"WINDOWS"},t.getOS=function(){return t.isMac?t.OS.MAC:t.isLinux?t.OS.LINUX:t.OS.WINDOWS};var r=typeof navigator=="object"?navigator:{},i=(/mac|win|linux/i.exec(r.platform)||["other"])[0].toLowerCase(),s=r.userAgent||"",o=r.appName||"";t.isWin=i=="win",t.isMac=i=="mac",t.isLinux=i=="linux",t.isIE=o=="Microsoft Internet Explorer"||o.indexOf("MSAppHost")>=0?parseFloat((s.match(/(?:MSIE |Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/)||[])[1]):parseFloat((s.match(/(?:Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/)||[])[1]),t.isOldIE=t.isIE&&t.isIE<9,t.isGecko=t.isMozilla=s.match(/ Gecko\/\d+/),t.isOpera=typeof opera=="object"&&Object.prototype.toString.call(window["opera"])=="[object Opera]",t.isWebKit=parseFloat(s.split("WebKit/")[1])||undefined,t.isChrome=parseFloat(s.split(" Chrome/")[1])||undefined,t.isSafari=parseFloat(s.split(" Safari/")[1])&&!t.isChrome||undefined,t.isEdge=parseFloat(s.split(" Edge/")[1])||undefined,t.isAIR=s.indexOf("AdobeAIR")>=0,t.isAndroid=s.indexOf("Android")>=0,t.isChromeOS=s.indexOf(" CrOS ")>=0,t.isIOS=/iPad|iPhone|iPod/.test(s)&&!window.MSStream,t.isIOS&&(t.isMac=!0),t.isMobile=t.isIOS||t.isAndroid}),define("ace/lib/dom",["require","exports","module","ace/lib/useragent"],function(e,t,n){"use strict";function u(){var e=o;o=null,e&&e.forEach(function(e){a(e[0],e[1])})}function a(e,n,r){if(typeof document=="undefined")return;if(o)if(r)u();else if(r===!1)return o.push([e,n]);if(s)return;var i=r;if(!r||!r.getRootNode)i=document;else{i=r.getRootNode();if(!i||i==r)i=document}var a=i.ownerDocument||i;if(n&&t.hasCssString(n,i))return null;n&&(e+="\n/*# sourceURL=ace/css/"+n+" */");var f=t.createElement("style");f.appendChild(a.createTextNode(e)),n&&(f.id=n),i==a&&(i=t.getDocumentHead(a)),i.insertBefore(f,i.firstChild)}var r=e("./useragent"),i="http://www.w3.org/1999/xhtml";t.buildDom=function l(e,t,n){if(typeof e=="string"&&e){var r=document.createTextNode(e);return t&&t.appendChild(r),r}if(!Array.isArray(e))return e&&e.appendChild&&t&&t.appendChild(e),e;if(typeof e[0]!="string"||!e[0]){var i=[];for(var s=0;s<e.length;s++){var o=l(e[s],t,n);o&&i.push(o)}return i}var u=document.createElement(e[0]),a=e[1],f=1;a&&typeof a=="object"&&!Array.isArray(a)&&(f=2);for(var s=f;s<e.length;s++)l(e[s],u,n);return f==2&&Object.keys(a).forEach(function(e){var t=a[e];e==="class"?u.className=Array.isArray(t)?t.join(" "):t:typeof t=="function"||e=="value"||e[0]=="$"?u[e]=t:e==="ref"?n&&(n[t]=u):e==="style"?typeof t=="string"&&(u.style.cssText=t):t!=null&&u.setAttribute(e,t)}),t&&t.appendChild(u),u},t.getDocumentHead=function(e){return e||(e=document),e.head||e.getElementsByTagName("head")[0]||e.documentElement},t.createElement=function(e,t){return document.createElementNS?document.createElementNS(t||i,e):document.createElement(e)},t.removeChildren=function(e){e.innerHTML=""},t.createTextNode=function(e,t){var n=t?t.ownerDocument:document;return n.createTextNode(e)},t.createFragment=function(e){var t=e?e.ownerDocument:document;return t.createDocumentFragment()},t.hasCssClass=function(e,t){var n=(e.className+"").split(/\s+/g);return n.indexOf(t)!==-1},t.addCssClass=function(e,n){t.hasCssClass(e,n)||(e.className+=" "+n)},t.removeCssClass=function(e,t){var n=e.className.split(/\s+/g);for(;;){var r=n.indexOf(t);if(r==-1)break;n.splice(r,1)}e.className=n.join(" ")},t.toggleCssClass=function(e,t){var n=e.className.split(/\s+/g),r=!0;for(;;){var i=n.indexOf(t);if(i==-1)break;r=!1,n.splice(i,1)}return r&&n.push(t),e.className=n.join(" "),r},t.setCssClass=function(e,n,r){r?t.addCssClass(e,n):t.removeCssClass(e,n)},t.hasCssString=function(e,t){var n=0,r;t=t||document;if(r=t.querySelectorAll("style"))while(n<r.length)if(r[n++].id===e)return!0},t.removeElementById=function(e,t){t=t||document,t.getElementById(e)&&t.getElementById(e).remove()};var s,o=[];t.useStrictCSP=function(e){s=e,e==0?u():o||(o=[])},t.importCssString=a,t.importCssStylsheet=function(e,n){t.buildDom(["link",{rel:"stylesheet",href:e}],t.getDocumentHead(n))},t.$fixPositionBug=function(e){var t=e.getBoundingClientRect();if(e.style.left){var n=parseFloat(e.style.left),r=+t.left;Math.abs(n-r)>1&&(e.style.left=2*n-r+"px")}if(e.style.right){var n=parseFloat(e.style.right),r=window.innerWidth-t.right;Math.abs(n-r)>1&&(e.style.right=2*n-r+"px")}if(e.style.top){var n=parseFloat(e.style.top),r=+t.top;Math.abs(n-r)>1&&(e.style.top=2*n-r+"px")}if(e.style.bottom){var n=parseFloat(e.style.bottom),r=window.innerHeight-t.bottom;Math.abs(n-r)>1&&(e.style.bottom=2*n-r+"px")}},t.scrollbarWidth=function(e){var n=t.createElement("ace_inner");n.style.width="100%",n.style.minWidth="0px",n.style.height="200px",n.style.display="block";var r=t.createElement("ace_outer"),i=r.style;i.position="absolute",i.left="-10000px",i.overflow="hidden",i.width="200px",i.minWidth="0px",i.height="150px",i.display="block",r.appendChild(n);var s=e&&e.documentElement||document&&document.documentElement;if(!s)return 0;s.appendChild(r);var o=n.offsetWidth;i.overflow="scroll";var u=n.offsetWidth;return o===u&&(u=r.clientWidth),s.removeChild(r),o-u},t.computedStyle=function(e,t){return window.getComputedStyle(e,"")||{}},t.setStyle=function(e,t,n){e[t]!==n&&(e[t]=n)},t.HAS_CSS_ANIMATION=!1,t.HAS_CSS_TRANSFORMS=!1,t.HI_DPI=r.isWin?typeof window!="undefined"&&window.devicePixelRatio>=1.5:!0,r.isChromeOS&&(t.HI_DPI=!1);if(typeof document!="undefined"){var f=document.createElement("div");t.HI_DPI&&f.style.transform!==undefined&&(t.HAS_CSS_TRANSFORMS=!0),!r.isEdge&&typeof f.style.animationName!="undefined"&&(t.HAS_CSS_ANIMATION=!0),f=null}t.HAS_CSS_TRANSFORMS?t.translate=function(e,t,n){e.style.transform="translate("+Math.round(t)+"px, "+Math.round(n)+"px)"}:t.translate=function(e,t,n){e.style.top=Math.round(n)+"px",e.style.left=Math.round(t)+"px"}}),define("ace/lib/net",["require","exports","module","ace/lib/dom"],function(e,t,n){"use strict";var r=e("./dom");t.get=function(e,t){var n=new XMLHttpRequest;n.open("GET",e,!0),n.onreadystatechange=function(){n.readyState===4&&t(n.responseText)},n.send(null)},t.loadScript=function(e,t){var n=r.getDocumentHead(),i=document.createElement("script");i.src=e,n.appendChild(i),i.onload=i.onreadystatechange=function(e,n){if(n||!i.readyState||i.readyState=="loaded"||i.readyState=="complete")i=i.onload=i.onreadystatechange=null,n||t()}},t.qualifyURL=function(e){var t=document.createElement("a");return t.href=e,t.href}}),define("ace/lib/oop",["require","exports","module"],function(e,t,n){"use strict";t.inherits=function(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})},t.mixin=function(e,t){for(var n in t)e[n]=t[n];return e},t.implement=function(e,n){t.mixin(e,n)}}),define("ace/lib/event_emitter",["require","exports","module"],function(e,t,n){"use strict";var r={},i=function(){this.propagationStopped=!0},s=function(){this.defaultPrevented=!0};r._emit=r._dispatchEvent=function(e,t){this._eventRegistry||(this._eventRegistry={}),this._defaultHandlers||(this._defaultHandlers={});var n=this._eventRegistry[e]||[],r=this._defaultHandlers[e];if(!n.length&&!r)return;if(typeof t!="object"||!t)t={};t.type||(t.type=e),t.stopPropagation||(t.stopPropagation=i),t.preventDefault||(t.preventDefault=s),n=n.slice();for(var o=0;o<n.length;o++){n[o](t,this);if(t.propagationStopped)break}if(r&&!t.defaultPrevented)return r(t,this)},r._signal=function(e,t){var n=(this._eventRegistry||{})[e];if(!n)return;n=n.slice();for(var r=0;r<n.length;r++)n[r](t,this)},r.once=function(e,t){var n=this;this.on(e,function r(){n.off(e,r),t.apply(null,arguments)});if(!t)return new Promise(function(e){t=e})},r.setDefaultHandler=function(e,t){var n=this._defaultHandlers;n||(n=this._defaultHandlers={_disabled_:{}});if(n[e]){var r=n[e],i=n._disabled_[e];i||(n._disabled_[e]=i=[]),i.push(r);var s=i.indexOf(t);s!=-1&&i.splice(s,1)}n[e]=t},r.removeDefaultHandler=function(e,t){var n=this._defaultHandlers;if(!n)return;var r=n._disabled_[e];if(n[e]==t)r&&this.setDefaultHandler(e,r.pop());else if(r){var i=r.indexOf(t);i!=-1&&r.splice(i,1)}},r.on=r.addEventListener=function(e,t,n){this._eventRegistry=this._eventRegistry||{};var r=this._eventRegistry[e];return r||(r=this._eventRegistry[e]=[]),r.indexOf(t)==-1&&r[n?"unshift":"push"](t),t},r.off=r.removeListener=r.removeEventListener=function(e,t){this._eventRegistry=this._eventRegistry||{};var n=this._eventRegistry[e];if(!n)return;var r=n.indexOf(t);r!==-1&&n.splice(r,1)},r.removeAllListeners=function(e){e||(this._eventRegistry=this._defaultHandlers=undefined),this._eventRegistry&&(this._eventRegistry[e]=undefined),this._defaultHandlers&&(this._defaultHandlers[e]=undefined)},t.EventEmitter=r}),define("ace/lib/report_error",["require","exports","module"],function(e,t,n){t.reportError=function(t,n){var r=new Error(t);r.data=n,typeof console=="object"&&console.error&&console.error(r),setTimeout(function(){throw r})}}),define("ace/lib/default_english_messages",["require","exports","module"],function(e,t,n){var r={"autocomplete.popup.aria-roledescription":"Autocomplete suggestions","autocomplete.popup.aria-label":"Autocomplete suggestions","autocomplete.popup.item.aria-roledescription":"item","autocomplete.loading":"Loading...","editor.scroller.aria-roledescription":"editor","editor.scroller.aria-label":"Editor content, press Enter to start editing, press Escape to exit","editor.gutter.aria-roledescription":"editor gutter","editor.gutter.aria-label":"Editor gutter, press Enter to interact with controls using arrow keys, press Escape to exit","error-marker.good-state":"Looks good!","prompt.recently-used":"Recently used","prompt.other-commands":"Other commands","prompt.no-matching-commands":"No matching commands","search-box.find.placeholder":"Search for","search-box.find-all.text":"All","search-box.replace.placeholder":"Replace with","search-box.replace-next.text":"Replace","search-box.replace-all.text":"All","search-box.toggle-replace.title":"Toggle Replace mode","search-box.toggle-regexp.title":"RegExp Search","search-box.toggle-case.title":"CaseSensitive Search","search-box.toggle-whole-word.title":"Whole Word Search","search-box.toggle-in-selection.title":"Search In Selection","search-box.search-counter":"$0 of $1","text-input.aria-roledescription":"editor","text-input.aria-label":"Cursor at row $0","gutter.code-folding.range.aria-label":"Toggle code folding, rows $0 through $1","gutter.code-folding.closed.aria-label":"Toggle code folding, rows $0 through $1","gutter.code-folding.open.aria-label":"Toggle code folding, row $0","gutter.code-folding.closed.title":"Unfold code","gutter.code-folding.open.title":"Fold code","gutter.annotation.aria-label.error":"Error, read annotations row $0","gutter.annotation.aria-label.warning":"Warning, read annotations row $0","gutter.annotation.aria-label.info":"Info, read annotations row $0","inline-fold.closed.title":"Unfold code","gutter-tooltip.aria-label.error.singular":"error","gutter-tooltip.aria-label.error.plural":"errors","gutter-tooltip.aria-label.warning.singular":"warning","gutter-tooltip.aria-label.warning.plural":"warnings","gutter-tooltip.aria-label.info.singular":"information message","gutter-tooltip.aria-label.info.plural":"information messages","gutter.annotation.aria-label.security":"Security finding, read annotations row $0","gutter.annotation.aria-label.hint":"Suggestion, read annotations row $0","gutter-tooltip.aria-label.security.singular":"security finding","gutter-tooltip.aria-label.security.plural":"security findings","gutter-tooltip.aria-label.hint.singular":"suggestion","gutter-tooltip.aria-label.hint.plural":"suggestions","editor.tooltip.disable-editing":"Editing is disabled"};t.defaultEnglishMessages=r}),define("ace/lib/app_config",["require","exports","module","ace/lib/oop","ace/lib/event_emitter","ace/lib/report_error","ace/lib/default_english_messages"],function(e,t,n){"no use strict";function a(e){typeof console!="undefined"&&console.warn&&console.warn.apply(console,arguments)}var r=e("./oop"),i=e("./event_emitter").EventEmitter,s=e("./report_error").reportError,o=e("./default_english_messages").defaultEnglishMessages,u={setOptions:function(e){Object.keys(e).forEach(function(t){this.setOption(t,e[t])},this)},getOptions:function(e){var t={};if(!e){var n=this.$options;e=Object.keys(n).filter(function(e){return!n[e].hidden})}else Array.isArray(e)||(e=Object.keys(e));return e.forEach(function(e){t[e]=this.getOption(e)},this),t},setOption:function(e,t){if(this["$"+e]===t)return;var n=this.$options[e];if(!n)return a('misspelled option "'+e+'"');if(n.forwardTo)return this[n.forwardTo]&&this[n.forwardTo].setOption(e,t);n.handlesSet||(this["$"+e]=t),n&&n.set&&n.set.call(this,t)},getOption:function(e){var t=this.$options[e];return t?t.forwardTo?this[t.forwardTo]&&this[t.forwardTo].getOption(e):t&&t.get?t.get.call(this):this["$"+e]:a('misspelled option "'+e+'"')}},f,l,c=function(){function e(){this.$defaultOptions={},f=o,l="dollarSigns"}return e.prototype.defineOptions=function(e,t,n){return e.$options||(this.$defaultOptions[t]=e.$options={}),Object.keys(n).forEach(function(t){var r=n[t];typeof r=="string"&&(r={forwardTo:r}),r.name||(r.name=t),e.$options[r.name]=r,"initialValue"in r&&(e["$"+r.name]=r.initialValue)}),r.implement(e,u),this},e.prototype.resetOptions=function(e){Object.keys(e.$options).forEach(function(t){var n=e.$options[t];"value"in n&&e.setOption(t,n.value)})},e.prototype.setDefaultValue=function(e,t,n){if(!e){for(e in this.$defaultOptions)if(this.$defaultOptions[e][t])break;if(!this.$defaultOptions[e][t])return!1}var r=this.$defaultOptions[e]||(this.$defaultOptions[e]={});r[t]&&(r.forwardTo?this.setDefaultValue(r.forwardTo,t,n):r[t].value=n)},e.prototype.setDefaultValues=function(e,t){Object.keys(t).forEach(function(n){this.setDefaultValue(e,n,t[n])},this)},e.prototype.setMessages=function(e,t){f=e,t&&t.placeholders&&(l=t.placeholders)},e.prototype.nls=function(e,t,n){f[e]||(a("No message found for the key '"+e+"' in messages with id "+f.$id+", trying to find a translation for the default string '"+t+"'."),f[t]||a("No message found for the default string '"+t+"' in the provided messages. Falling back to the default English message."));var r=f[e]||f[t]||t;return n&&(l==="dollarSigns"&&(r=r.replace(/\$(\$|[\d]+)/g,function(e,t){return t=="$"?"$":n[t]})),l==="curlyBrackets"&&(r=r.replace(/\{([^\}]+)\}/g,function(e,t){return n[t]}))),r},e}();c.prototype.warn=a,c.prototype.reportError=s,r.implement(c.prototype,i),t.AppConfig=c}),define("ace/theme/textmate-css",["require","exports","module"],function(e,t,n){n.exports='.ace-tm .ace_gutter {\n  background: #f0f0f0;\n  color: #333;\n}\n\n.ace-tm .ace_print-margin {\n  width: 1px;\n  background: #e8e8e8;\n}\n\n.ace-tm .ace_fold {\n    background-color: #6B72E6;\n}\n\n.ace-tm {\n  background-color: #FFFFFF;\n  color: black;\n}\n\n.ace-tm .ace_cursor {\n  color: black;\n}\n        \n.ace-tm .ace_invisible {\n  color: rgb(191, 191, 191);\n}\n\n.ace-tm .ace_storage,\n.ace-tm .ace_keyword {\n  color: blue;\n}\n\n.ace-tm .ace_constant {\n  color: rgb(197, 6, 11);\n}\n\n.ace-tm .ace_constant.ace_buildin {\n  color: rgb(88, 72, 246);\n}\n\n.ace-tm .ace_constant.ace_language {\n  color: rgb(88, 92, 246);\n}\n\n.ace-tm .ace_constant.ace_library {\n  color: rgb(6, 150, 14);\n}\n\n.ace-tm .ace_invalid {\n  background-color: rgba(255, 0, 0, 0.1);\n  color: red;\n}\n\n.ace-tm .ace_support.ace_function {\n  color: rgb(60, 76, 114);\n}\n\n.ace-tm .ace_support.ace_constant {\n  color: rgb(6, 150, 14);\n}\n\n.ace-tm .ace_support.ace_type,\n.ace-tm .ace_support.ace_class {\n  color: rgb(109, 121, 222);\n}\n\n.ace-tm .ace_keyword.ace_operator {\n  color: rgb(104, 118, 135);\n}\n\n.ace-tm .ace_string {\n  color: rgb(3, 106, 7);\n}\n\n.ace-tm .ace_comment {\n  color: rgb(76, 136, 107);\n}\n\n.ace-tm .ace_comment.ace_doc {\n  color: rgb(0, 102, 255);\n}\n\n.ace-tm .ace_comment.ace_doc.ace_tag {\n  color: rgb(128, 159, 191);\n}\n\n.ace-tm .ace_constant.ace_numeric {\n  color: rgb(0, 0, 205);\n}\n\n.ace-tm .ace_variable {\n  color: rgb(49, 132, 149);\n}\n\n.ace-tm .ace_xml-pe {\n  color: rgb(104, 104, 91);\n}\n\n.ace-tm .ace_entity.ace_name.ace_function {\n  color: #0000A2;\n}\n\n\n.ace-tm .ace_heading {\n  color: rgb(12, 7, 255);\n}\n\n.ace-tm .ace_list {\n  color:rgb(185, 6, 144);\n}\n\n.ace-tm .ace_meta.ace_tag {\n  color:rgb(0, 22, 142);\n}\n\n.ace-tm .ace_string.ace_regex {\n  color: rgb(255, 0, 0)\n}\n\n.ace-tm .ace_marker-layer .ace_selection {\n  background: rgb(181, 213, 255);\n}\n.ace-tm.ace_multiselect .ace_selection.ace_start {\n  box-shadow: 0 0 3px 0px white;\n}\n.ace-tm .ace_marker-layer .ace_step {\n  background: rgb(252, 255, 0);\n}\n\n.ace-tm .ace_marker-layer .ace_stack {\n  background: rgb(164, 229, 101);\n}\n\n.ace-tm .ace_marker-layer .ace_bracket {\n  margin: -1px 0 0 -1px;\n  border: 1px solid rgb(192, 192, 192);\n}\n\n.ace-tm .ace_marker-layer .ace_active-line {\n  background: rgba(0, 0, 0, 0.07);\n}\n\n.ace-tm .ace_gutter-active-line {\n    background-color : #dcdcdc;\n}\n\n.ace-tm .ace_marker-layer .ace_selected-word {\n  background: rgb(250, 250, 255);\n  border: 1px solid rgb(200, 200, 250);\n}\n\n.ace-tm .ace_indent-guide {\n  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==") right repeat-y;\n}\n\n.ace-tm .ace_indent-guide-active {\n  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAZSURBVHjaYvj///9/hivKyv8BAAAA//8DACLqBhbvk+/eAAAAAElFTkSuQmCC") right repeat-y;\n}\n'}),define("ace/theme/textmate",["require","exports","module","ace/theme/textmate-css","ace/lib/dom"],function(e,t,n){"use strict";t.isDark=!1,t.cssClass="ace-tm",t.cssText=e("./textmate-css"),t.$id="ace/theme/textmate";var r=e("../lib/dom");r.importCssString(t.cssText,t.cssClass,!1)}),define("ace/config",["require","exports","module","ace/lib/lang","ace/lib/net","ace/lib/dom","ace/lib/app_config","ace/theme/textmate"],function(e,t,n){"no use strict";var r=e("./lib/lang"),i=e("./lib/net"),s=e("./lib/dom"),o=e("./lib/app_config").AppConfig;n.exports=t=new o;var u={packaged:!1,workerPath:null,modePath:null,themePath:null,basePath:"",suffix:".js",$moduleUrls:{},loadWorkerFromBlob:!0,sharedPopups:!1,useStrictCSP:null};t.get=function(e){if(!u.hasOwnProperty(e))throw new Error("Unknown config key: "+e);return u[e]},t.set=function(e,t){if(u.hasOwnProperty(e))u[e]=t;else if(this.setDefaultValue("",e,t)==0)throw new Error("Unknown config key: "+e);e=="useStrictCSP"&&s.useStrictCSP(t)},t.all=function(){return r.copyObject(u)},t.$modes={},t.moduleUrl=function(e,t){if(u.$moduleUrls[e])return u.$moduleUrls[e];var n=e.split("/");t=t||n[n.length-2]||"";var r=t=="snippets"?"/":"-",i=n[n.length-1];if(t=="worker"&&r=="-"){var s=new RegExp("^"+t+"[\\-_]|[\\-_]"+t+"$","g");i=i.replace(s,"")}(!i||i==t)&&n.length>1&&(i=n[n.length-2]);var o=u[t+"Path"];return o==null?o=u.basePath:r=="/"&&(t=r=""),o&&o.slice(-1)!="/"&&(o+="/"),o+t+r+i+this.get("suffix")},t.setModuleUrl=function(e,t){return u.$moduleUrls[e]=t};var a=function(t,n){if(t==="ace/theme/textmate"||t==="./theme/textmate")return n(null,e("./theme/textmate"));if(f)return f(t,n);console.error("loader is not configured")},f;t.setLoader=function(e){f=e},t.dynamicModules=Object.create(null),t.$loading={},t.$loaded={},t.loadModule=function(e,n){var r;if(Array.isArray(e))var s=e[0],o=e[1];else if(typeof e=="string")var o=e;var u=function(e){if(e&&!t.$loading[o])return n&&n(e);t.$loading[o]||(t.$loading[o]=[]),t.$loading[o].push(n);if(t.$loading[o].length>1)return;var r=function(){a(o,function(e,n){n&&(t.$loaded[o]=n),t._emit("load.module",{name:o,module:n});var r=t.$loading[o];t.$loading[o]=null,r.forEach(function(e){e&&e(n)})})};if(!t.get("packaged"))return r();i.loadScript(t.moduleUrl(o,s),r),l()};if(t.dynamicModules[o])t.dynamicModules[o]().then(function(e){e.default?u(e.default):u(e)});else{try{r=this.$require(o)}catch(f){}u(r||t.$loaded[o])}},t.$require=function(e){if(typeof n["require"]=="function"){var t="require";return n[t](e)}},t.setModuleLoader=function(e,n){t.dynamicModules[e]=n};var l=function(){!u.basePath&&!u.workerPath&&!u.modePath&&!u.themePath&&!Object.keys(u.$moduleUrls).length&&(console.error("Unable to infer path to ace from script src,","use ace.config.set('basePath', 'path') to enable dynamic loading of modes and themes","or with webpack use ace/webpack-resolver"),l=function(){})};t.version="1.44.0"}),define("ace/loader_build",["require","exports","module","ace/lib/fixoldbrowsers","ace/config"],function(e,t,n){"use strict";function s(t){if(!i||!i.document)return;r.set("packaged",t||e.packaged||n.packaged||i.define&&define.packaged);var s={},u="",a=document.currentScript||document._currentScript,f=a&&a.ownerDocument||document;a&&a.src&&(u=a.src.split(/[?#]/)[0].split("/").slice(0,-1).join("/")||"");var l=f.getElementsByTagName("script");for(var c=0;c<l.length;c++){var h=l[c],p=h.src||h.getAttribute("src");if(!p)continue;var d=h.attributes;for(var v=0,m=d.length;v<m;v++){var g=d[v];g.name.indexOf("data-ace-")===0&&(s[o(g.name.replace(/^data-ace-/,""))]=g.value)}var y=p.match(/^(.*)\/ace([\-.]\w+)?\.js(\?|$)/);y&&(u=y[1])}u&&(s.base=s.base||u,s.packaged=!0),s.basePath=s.base,s.workerPath=s.workerPath||s.base,s.modePath=s.modePath||s.base,s.themePath=s.themePath||s.base,delete s.base;for(var b in s)typeof s[b]!="undefined"&&r.set(b,s[b])}function o(e){return e.replace(/-(.)/g,function(e,t){return t.toUpperCase()})}e("./lib/fixoldbrowsers");var r=e("./config");r.setLoader(function(t,n){e([t],function(e){n(null,e)})});var i=function(){return this||typeof window!="undefined"&&window}();n.exports=function(t){r.init=s,r.$require=e,t.require=e,typeof define=="function"&&(t.define=define)}}),define("ace/range",["require","exports","module"],function(e,t,n){"use strict";var r=function(){function e(e,t,n,r){this.start={row:e,column:t},this.end={row:n,column:r}}return e.prototype.isEqual=function(e){return this.start.row===e.start.row&&this.end.row===e.end.row&&this.start.column===e.start.column&&this.end.column===e.end.column},e.prototype.toString=function(){return"Range: ["+this.start.row+"/"+this.start.column+"] -> ["+this.end.row+"/"+this.end.column+"]"},e.prototype.contains=function(e,t){return this.compare(e,t)==0},e.prototype.compareRange=function(e){var t,n=e.end,r=e.start;return t=this.compare(n.row,n.column),t==1?(t=this.compare(r.row,r.column),t==1?2:t==0?1:0):t==-1?-2:(t=this.compare(r.row,r.column),t==-1?-1:t==1?42:0)},e.prototype.comparePoint=function(e){return this.compare(e.row,e.column)},e.prototype.containsRange=function(e){return this.comparePoint(e.start)==0&&this.comparePoint(e.end)==0},e.prototype.intersects=function(e){var t=this.compareRange(e);return t==-1||t==0||t==1},e.prototype.isEnd=function(e,t){return this.end.row==e&&this.end.column==t},e.prototype.isStart=function(e,t){return this.start.row==e&&this.start.column==t},e.prototype.setStart=function(e,t){typeof e=="object"?(this.start.column=e.column,this.start.row=e.row):(this.start.row=e,this.start.column=t)},e.prototype.setEnd=function(e,t){typeof e=="object"?(this.end.column=e.column,this.end.row=e.row):(this.end.row=e,this.end.column=t)},e.prototype.inside=function(e,t){return this.compare(e,t)==0?this.isEnd(e,t)||this.isStart(e,t)?!1:!0:!1},e.prototype.insideStart=function(e,t){return this.compare(e,t)==0?this.isEnd(e,t)?!1:!0:!1},e.prototype.insideEnd=function(e,t){return this.compare(e,t)==0?this.isStart(e,t)?!1:!0:!1},e.prototype.compare=function(e,t){return!this.isMultiLine()&&e===this.start.row?t<this.start.column?-1:t>this.end.column?1:0:e<this.start.row?-1:e>this.end.row?1:this.start.row===e?t>=this.start.column?0:-1:this.end.row===e?t<=this.end.column?0:1:0},e.prototype.compareStart=function(e,t){return this.start.row==e&&this.start.column==t?-1:this.compare(e,t)},e.prototype.compareEnd=function(e,t){return this.end.row==e&&this.end.column==t?1:this.compare(e,t)},e.prototype.compareInside=function(e,t){return this.end.row==e&&this.end.column==t?1:this.start.row==e&&this.start.column==t?-1:this.compare(e,t)},e.prototype.clipRows=function(t,n){if(this.end.row>n)var r={row:n+1,column:0};else if(this.end.row<t)var r={row:t,column:0};if(this.start.row>n)var i={row:n+1,column:0};else if(this.start.row<t)var i={row:t,column:0};return e.fromPoints(i||this.start,r||this.end)},e.prototype.extend=function(t,n){var r=this.compare(t,n);if(r==0)return this;if(r==-1)var i={row:t,column:n};else var s={row:t,column:n};return e.fromPoints(i||this.start,s||this.end)},e.prototype.isEmpty=function(){return this.start.row===this.end.row&&this.start.column===this.end.column},e.prototype.isMultiLine=function(){return this.start.row!==this.end.row},e.prototype.clone=function(){return e.fromPoints(this.start,this.end)},e.prototype.collapseRows=function(){return this.end.column==0?new e(this.start.row,0,Math.max(this.start.row,this.end.row-1),0):new e(this.start.row,0,this.end.row,0)},e.prototype.toScreenRange=function(t){var n=t.documentToScreenPosition(this.start),r=t.documentToScreenPosition(this.end);return new e(n.row,n.column,r.row,r.column)},e.prototype.moveBy=function(e,t){this.start.row+=e,this.start.column+=t,this.end.row+=e,this.end.column+=t},e}();r.fromPoints=function(e,t){return new r(e.row,e.column,t.row,t.column)},r.comparePoints=function(e,t){return e.row-t.row||e.column-t.column},t.Range=r}),define("ace/lib/keys",["require","exports","module","ace/lib/oop"],function(e,t,n){"use strict";var r=e("./oop"),i={MODIFIER_KEYS:{16:"Shift",17:"Ctrl",18:"Alt",224:"Meta",91:"MetaLeft",92:"MetaRight",93:"ContextMenu"},KEY_MODS:{ctrl:1,alt:2,option:2,shift:4,"super":8,meta:8,command:8,cmd:8,control:1},FUNCTION_KEYS:{8:"Backspace",9:"Tab",13:"Return",19:"Pause",27:"Esc",32:"Space",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"Left",38:"Up",39:"Right",40:"Down",44:"Print",45:"Insert",46:"Delete","-13":"NumpadEnter",144:"Numlock",145:"Scrolllock"},PRINTABLE_KEYS:{32:" ",59:";",61:"=",107:"+",109:"-",110:".",186:";",187:"=",188:",",189:"-",190:".",191:"/",192:"`",219:"[",220:"\\",221:"]",222:"'",111:"/",106:"*"}},s={Command:224,Backspace:8,Tab:9,Return:13,Enter:13,Pause:19,Escape:27,PageUp:33,PageDown:34,End:35,Home:36,Insert:45,Delete:46,ArrowLeft:37,ArrowUp:38,ArrowRight:39,ArrowDown:40,Backquote:192,Minus:189,Equal:187,BracketLeft:219,Backslash:220,BracketRight:221,Semicolon:186,Quote:222,Comma:188,Period:190,Slash:191,Space:32,NumpadAdd:107,NumpadDecimal:110,NumpadSubtract:109,NumpadDivide:111,NumpadMultiply:106};for(var o=0;o<10;o++)s["Digit"+o]=48+o,s["Numpad"+o]=96+o,i.PRINTABLE_KEYS[48+o]=""+o,i.FUNCTION_KEYS[96+o]="Numpad"+o;for(var o=65;o<91;o++){var u=String.fromCharCode(o+32);s["Key"+u.toUpperCase()]=o,i.PRINTABLE_KEYS[o]=u}for(var o=1;o<13;o++)s["F"+o]=111+o,i.FUNCTION_KEYS[111+o]="F"+o;var a={Shift:16,Control:17,Alt:18,Meta:224};for(var f in a)s[f]=s[f+"Left"]=s[f+"Right"]=a[f];t.$codeToKeyCode=s,i.PRINTABLE_KEYS[173]="-";for(var l in i.FUNCTION_KEYS){var c=i.FUNCTION_KEYS[l].toLowerCase();i[c]=parseInt(l,10)}for(var l in i.PRINTABLE_KEYS){var c=i.PRINTABLE_KEYS[l].toLowerCase();i[c]=parseInt(l,10)}r.mixin(i,i.MODIFIER_KEYS),r.mixin(i,i.PRINTABLE_KEYS),r.mixin(i,i.FUNCTION_KEYS),i.enter=i["return"],i.escape=i.esc,i.del=i["delete"],function(){var e=["cmd","ctrl","alt","shift"];for(var t=Math.pow(2,e.length);t--;)i.KEY_MODS[t]=e.filter(function(e){return t&i.KEY_MODS[e]}).join("-")+"-"}(),i.KEY_MODS[0]="",i.KEY_MODS[-1]="input-",r.mixin(t,i),t.default=t,t.keyCodeToString=function(e){var t=i[e];return typeof t!="string"&&(t=String.fromCharCode(e)),t.toLowerCase()}}),define("ace/lib/event",["require","exports","module","ace/lib/keys","ace/lib/useragent"],function(e,t,n){"use strict";function a(){u=!1;try{document.createComment("").addEventListener("test",function(){},{get passive(){return u={passive:!1},!0}})}catch(e){}}function f(){return u==undefined&&a(),u}function l(e,t,n){this.elem=e,this.type=t,this.callback=n}function p(e){return 0|(e.ctrlKey?1:0)|(e.altKey?2:0)|(e.shiftKey?4:0)|(e.metaKey?8:0)}function d(e,t,n){var u=p(t);!n&&t.code&&(n=r.$codeToKeyCode[t.code]||n);if(!i.isMac&&s){t.getModifierState&&(t.getModifierState("OS")||t.getModifierState("Win"))&&(u|=8);if(s.altGr){if((3&u)==3)return;s.altGr=0}if(n===18||n===17){var a=t.location;if(n===17&&a===1)s[n]==1&&(o=t.timeStamp);else if(n===18&&u===3&&a===2){var f=t.timeStamp-o;f<50&&(s.altGr=!0)}}}n in r.MODIFIER_KEYS&&(n=-1);if(!u&&n===13&&t.location===3){e(t,u,-n);if(t.defaultPrevented)return}if(i.isChromeOS&&u&8){e(t,u,n);if(t.defaultPrevented)return;u&=-9}return!!u||n in r.FUNCTION_KEYS||n in r.PRINTABLE_KEYS?e(t,u,n):!1}function v(){s=Object.create(null)}var r=e("./keys"),i=e("./useragent"),s=null,o=0,u;l.prototype.destroy=function(){h(this.elem,this.type,this.callback),this.elem=this.type=this.callback=undefined};var c=t.addListener=function(e,t,n,r){e.addEventListener(t,n,f()),r&&r.$toDestroy.push(new l(e,t,n))},h=t.removeListener=function(e,t,n){e.removeEventListener(t,n,f())};t.stopEvent=function(e){return t.stopPropagation(e),t.preventDefault(e),!1},t.stopPropagation=function(e){e.stopPropagation&&e.stopPropagation()},t.preventDefault=function(e){e.preventDefault&&e.preventDefault()},t.getButton=function(e){return e.type=="dblclick"?0:e.type=="contextmenu"||i.isMac&&e.ctrlKey&&!e.altKey&&!e.shiftKey?2:e.button},t.capture=function(e,t,n){function i(e){t&&t(e),n&&n(e),h(r,"mousemove",t),h(r,"mouseup",i),h(r,"dragstart",i)}var r=e&&e.ownerDocument||document;return c(r,"mousemove",t),c(r,"mouseup",i),c(r,"dragstart",i),i},t.addMouseWheelListener=function(e,t,n){c(e,"wheel",function(e){var n=.15,r=e.deltaX||0,i=e.deltaY||0;switch(e.deltaMode){case e.DOM_DELTA_PIXEL:e.wheelX=r*n,e.wheelY=i*n;break;case e.DOM_DELTA_LINE:var s=15;e.wheelX=r*s,e.wheelY=i*s;break;case e.DOM_DELTA_PAGE:var o=150;e.wheelX=r*o,e.wheelY=i*o}t(e)},n)},t.addMultiMouseDownListener=function(e,n,r,s,o){function p(e){t.getButton(e)!==0?u=0:e.detail>1?(u++,u>4&&(u=1)):u=1;if(i.isIE){var o=Math.abs(e.clientX-a)>5||Math.abs(e.clientY-f)>5;if(!l||o)u=1;l&&clearTimeout(l),l=setTimeout(function(){l=null},n[u-1]||600),u==1&&(a=e.clientX,f=e.clientY)}e._clicks=u,r[s]("mousedown",e);if(u>4)u=0;else if(u>1)return r[s](h[u],e)}var u=0,a,f,l,h={2:"dblclick",3:"tripleclick",4:"quadclick"};Array.isArray(e)||(e=[e]),e.forEach(function(e){c(e,"mousedown",p,o)})},t.getModifierString=function(e){return r.KEY_MODS[p(e)]},t.addCommandKeyListener=function(e,n,r){var i=null;c(e,"keydown",function(e){s[e.keyCode]=(s[e.keyCode]||0)+1;var t=d(n,e,e.keyCode);return i=e.defaultPrevented,t},r),c(e,"keypress",function(e){i&&(e.ctrlKey||e.altKey||e.shiftKey||e.metaKey)&&(t.stopEvent(e),i=null)},r),c(e,"keyup",function(e){s[e.keyCode]=null},r),s||(v(),c(window,"focus",v))};if(typeof window=="object"&&window.postMessage&&!i.isOldIE){var m=1;t.nextTick=function(e,n){n=n||window;var r="zero-timeout-message-"+m++,i=function(s){s.data==r&&(t.stopPropagation(s),h(n,"message",i),e())};c(n,"message",i),n.postMessage(r,"*")}}t.$idleBlocked=!1,t.onIdle=function(e,n){return setTimeout(function r(){t.$idleBlocked?setTimeout(r,100):e()},n)},t.$idleBlockId=null,t.blockIdle=function(e){t.$idleBlockId&&clearTimeout(t.$idleBlockId),t.$idleBlocked=!0,t.$idleBlockId=setTimeout(function(){t.$idleBlocked=!1},e||100)},t.nextFrame=typeof window=="object"&&(window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||window.msRequestAnimationFrame||window.oRequestAnimationFrame),t.nextFrame?t.nextFrame=t.nextFrame.bind(window):t.nextFrame=function(e){setTimeout(e,17)}}),define("ace/clipboard",["require","exports","module"],function(e,t,n){"use strict";var r;n.exports={lineMode:!1,pasteCancelled:function(){return r&&r>Date.now()-50?!0:r=!1},cancel:function(){r=Date.now()}}}),define("ace/keyboard/textinput",["require","exports","module","ace/lib/event","ace/config","ace/lib/useragent","ace/lib/dom","ace/lib/lang","ace/clipboard","ace/lib/keys"],function(e,t,n){"use strict";var r=e("../lib/event"),i=e("../config").nls,s=e("../lib/useragent"),o=e("../lib/dom"),u=e("../lib/lang"),a=e("../clipboard"),f=s.isChrome<18,l=s.isIE,c=s.isChrome>63,h=400,p=e("../lib/keys"),d=p.KEY_MODS,v=s.isIOS,m=v?/\s/:/\n/,g=s.isMobile,y=function(){function e(e,t){var n=this;this.host=t,this.text=o.createElement("textarea"),this.text.className="ace_text-input",this.text.setAttribute("wrap","off"),this.text.setAttribute("autocomplete","off"),this.text.setAttribute("autocorrect","off"),this.text.setAttribute("autocapitalize","off"),this.text.setAttribute("spellcheck","false"),this.text.style.opacity="0",e.insertBefore(this.text,e.firstChild),this.copied=!1,this.pasted=!1,this.inComposition=!1,this.sendingText=!1,this.tempStyle="",g||(this.text.style.fontSize="1px"),this.commandMode=!1,this.ignoreFocusEvents=!1,this.lastValue="",this.lastSelectionStart=0,this.lastSelectionEnd=0,this.lastRestoreEnd=0,this.rowStart=Number.MAX_SAFE_INTEGER,this.rowEnd=Number.MIN_SAFE_INTEGER,this.numberOfExtraLines=0;try{this.$isFocused=document.activeElement===this.text}catch(i){}this.cancelComposition=this.cancelComposition.bind(this),this.setAriaOptions({role:"textbox"}),r.addListener(this.text,"blur",function(e){if(n.ignoreFocusEvents)return;t.onBlur(e),n.$isFocused=!1},t),r.addListener(this.text,"focus",function(e){if(n.ignoreFocusEvents)return;n.$isFocused=!0;if(s.isEdge)try{if(!document.hasFocus())return}catch(e){}t.onFocus(e),s.isEdge?setTimeout(n.resetSelection.bind(n)):n.resetSelection()},t),this.$focusScroll=!1,t.on("beforeEndOperation",function(){var e=t.curOp,r=e&&e.command&&e.command.name;if(r=="insertstring")return;var i=r&&(e.docChanged||e.selectionChanged);n.inComposition&&i&&(n.lastValue=n.text.value="",n.onCompositionEnd()),n.resetSelection()}),t.on("changeSelection",this.setAriaLabel.bind(this)),this.resetSelection=v?this.$resetSelectionIOS:this.$resetSelection,this.$isFocused&&t.onFocus(),this.inputHandler=null,this.afterContextMenu=!1,r.addCommandKeyListener(this.text,function(e,r,i){if(n.inComposition)return;return t.onCommandKey(e,r,i)},t),r.addListener(this.text,"select",this.onSelect.bind(this),t),r.addListener(this.text,"input",this.onInput.bind(this),t),r.addListener(this.text,"cut",this.onCut.bind(this),t),r.addListener(this.text,"copy",this.onCopy.bind(this),t),r.addListener(this.text,"paste",this.onPaste.bind(this),t),(!("oncut"in this.text)||!("oncopy"in this.text)||!("onpaste"in this.text))&&r.addListener(e,"keydown",function(e){if(s.isMac&&!e.metaKey||!e.ctrlKey)return;switch(e.keyCode){case 67:n.onCopy(e);break;case 86:n.onPaste(e);break;case 88:n.onCut(e)}},t),this.syncComposition=u.delayedCall(this.onCompositionUpdate.bind(this),50).schedule.bind(null,null),r.addListener(this.text,"compositionstart",this.onCompositionStart.bind(this),t),r.addListener(this.text,"compositionupdate",this.onCompositionUpdate.bind(this),t),r.addListener(this.text,"keyup",this.onKeyup.bind(this),t),r.addListener(this.text,"keydown",this.syncComposition.bind(this),t),r.addListener(this.text,"compositionend",this.onCompositionEnd.bind(this),t),this.closeTimeout,r.addListener(this.text,"mouseup",this.$onContextMenu.bind(this),t),r.addListener(this.text,"mousedown",function(e){e.preventDefault(),n.onContextMenuClose()},t),r.addListener(t.renderer.scroller,"contextmenu",this.$onContextMenu.bind(this),t),r.addListener(this.text,"contextmenu",this.$onContextMenu.bind(this),t),v&&this.addIosSelectionHandler(e,t,this.text)}return e.prototype.addIosSelectionHandler=function(e,t,n){var r=this,i=null,s=!1;n.addEventListener("keydown",function(e){i&&clearTimeout(i),s=!0},!0),n.addEventListener("keyup",function(e){i=setTimeout(function(){s=!1},100)},!0);var o=function(e){if(document.activeElement!==n)return;if(s||r.inComposition||t.$mouseHandler.isMousePressed)return;if(r.copied)return;var i=n.selectionStart,o=n.selectionEnd,u=null,a=0;if(i==0)u=p.up;else if(i==1)u=p.home;else if(o>r.lastSelectionEnd&&r.lastValue[o]=="\n")u=p.end;else if(i<r.lastSelectionStart&&r.lastValue[i-1]==" ")u=p.left,a=d.option;else if(i<r.lastSelectionStart||i==r.lastSelectionStart&&r.lastSelectionEnd!=r.lastSelectionStart&&i==o)u=p.left;else if(o>r.lastSelectionEnd&&r.lastValue.slice(0,o).split("\n").length>2)u=p.down;else if(o>r.lastSelectionEnd&&r.lastValue[o-1]==" ")u=p.right,a=d.option;else if(o>r.lastSelectionEnd||o==r.lastSelectionEnd&&r.lastSelectionEnd!=r.lastSelectionStart&&i==o)u=p.right;i!==o&&(a|=d.shift);if(u){var f=t.onCommandKey({},a,u);if(!f&&t.commands){u=p.keyCodeToString(u);var l=t.commands.findKeyCommand(a,u);l&&t.execCommand(l)}r.lastSelectionStart=i,r.lastSelectionEnd=o,r.resetSelection("")}};document.addEventListener("selectionchange",o),t.on("destroy",function(){document.removeEventListener("selectionchange",o)})},e.prototype.onContextMenuClose=function(){var e=this;clearTimeout(this.closeTimeout),this.closeTimeout=setTimeout(function(){e.tempStyle&&(e.text.style.cssText=e.tempStyle,e.tempStyle=""),e.host.renderer.$isMousePressed=!1,e.host.renderer.$keepTextAreaAtCursor&&e.host.renderer.$moveTextAreaToCursor()},0)},e.prototype.$onContextMenu=function(e){this.host.textInput.onContextMenu(e),this.onContextMenuClose()},e.prototype.onKeyup=function(e){e.keyCode==27&&this.text.value.length<this.text.selectionStart&&(this.inComposition||(this.lastValue=this.text.value),this.lastSelectionStart=this.lastSelectionEnd=-1,this.resetSelection()),this.syncComposition()},e.prototype.cancelComposition=function(){this.ignoreFocusEvents=!0,this.text.blur(),this.text.focus(),this.ignoreFocusEvents=!1},e.prototype.onCompositionStart=function(e){if(this.inComposition||!this.host.onCompositionStart||this.host.$readOnly)return;this.inComposition={};if(this.commandMode)return;e.data&&(this.inComposition.useTextareaForIME=!1),setTimeout(this.onCompositionUpdate.bind(this),0),this.host._signal("compositionStart"),this.host.on("mousedown",this.cancelComposition);var t=this.host.getSelectionRange();t.end.row=t.start.row,t.end.column=t.start.column,this.inComposition.markerRange=t,this.inComposition.selectionStart=this.lastSelectionStart,this.host.onCompositionStart(this.inComposition),this.inComposition.useTextareaForIME?(this.lastValue=this.text.value="",this.lastSelectionStart=0,this.lastSelectionEnd=0):(this.text.msGetInputContext&&(this.inComposition.context=this.text.msGetInputContext()),this.text.getInputContext&&(this.inComposition.context=this.text.getInputContext()))},e.prototype.onCompositionUpdate=function(){if(!this.inComposition||!this.host.onCompositionUpdate||this.host.$readOnly)return;if(this.commandMode)return this.cancelComposition();if(this.inComposition.useTextareaForIME)this.host.onCompositionUpdate(this.text.value);else{var e=this.text.value;this.sendText(e),this.inComposition.markerRange&&(this.inComposition.context&&(this.inComposition.markerRange.start.column=this.inComposition.selectionStart=this.inComposition.context.compositionStartOffset),this.inComposition.markerRange.end.column=this.inComposition.markerRange.start.column+this.lastSelectionEnd-this.inComposition.selectionStart+this.lastRestoreEnd)}},e.prototype.onCompositionEnd=function(e){if(!this.host.onCompositionEnd||this.host.$readOnly)return;this.inComposition=!1,this.host.onCompositionEnd(),this.host.off("mousedown",this.cancelComposition),e&&this.onInput()},e.prototype.onCut=function(e){this.doCopy(e,!0)},e.prototype.onCopy=function(e){this.doCopy(e,!1)},e.prototype.onPaste=function(e){var t=this.handleClipboardData(e);if(a.pasteCancelled())return;typeof t=="string"?(t&&this.host.onPaste(t,e),s.isIE&&setTimeout(this.resetSelection),r.preventDefault(e)):(this.text.value="",this.pasted=!0)},e.prototype.doCopy=function(e,t){var n=this,i=this.host.getCopyText();if(!i)return r.preventDefault(e);this.handleClipboardData(e,i)?(v&&(this.resetSelection(i),this.copied=i,setTimeout(function(){n.copied=!1},10)),t?this.host.onCut():this.host.onCopy(),r.preventDefault(e)):(this.copied=!0,this.text.value=i,this.text.select(),setTimeout(function(){n.copied=!1,n.resetSelection(),t?n.host.onCut():n.host.onCopy()}))},e.prototype.handleClipboardData=function(e,t,n){var r=e.clipboardData||window.clipboardData;if(!r||f)return;var i=l||n?"Text":"text/plain";try{return t?r.setData(i,t)!==!1:r.getData(i)}catch(e){if(!n)return this.handleClipboardData(e,t,!0)}},e.prototype.onInput=function(e){if(this.inComposition)return this.onCompositionUpdate();if(e&&e.inputType){if(e.inputType=="historyUndo")return this.host.execCommand("undo");if(e.inputType=="historyRedo")return this.host.execCommand("redo")}var t=this.text.value,n=this.sendText(t,!0);(t.length>h+100||m.test(n)||g&&this.lastSelectionStart<1&&this.lastSelectionStart==this.lastSelectionEnd)&&this.resetSelection()},e.prototype.sendText=function(e,t){this.afterContextMenu&&(this.afterContextMenu=!1);if(this.pasted)return this.resetSelection(),e&&this.host.onPaste(e),this.pasted=!1,"";var n=this.text.selectionStart,r=this.text.selectionEnd,i=this.lastSelectionStart,o=this.lastValue.length-this.lastSelectionEnd,u=e,a=e.length-n,f=e.length-r,l=0;while(i>0&&this.lastValue[l]==e[l])l++,i--;u=u.slice(l),l=1;while(o>0&&this.lastValue.length-l>this.lastSelectionStart-1&&this.lastValue[this.lastValue.length-l]==e[e.length-l])l++,o--;a-=l-1,f-=l-1;var c=u.length-l+1;c<0&&(i=-c,c=0),u=u.slice(0,c);if(!t&&!u&&!a&&!i&&!o&&!f)return"";this.sendingText=!0;var h=!1;return s.isAndroid&&u==". "&&(u="  ",h=!0),u&&!i&&!o&&!a&&!f||this.commandMode?this.host.onTextInput(u):this.host.onTextInput(u,{extendLeft:i,extendRight:o,restoreStart:a,restoreEnd:f}),this.sendingText=!1,this.lastValue=e,this.lastSelectionStart=n,this.lastSelectionEnd=r,this.lastRestoreEnd=f,h?"\n":u},e.prototype.onSelect=function(e){var t=this;if(this.inComposition)return;var n=function(e){return e.selectionStart===0&&e.selectionEnd>=t.lastValue.length&&e.value===t.lastValue&&t.lastValue&&e.selectionEnd!==t.lastSelectionEnd};this.copied?this.copied=!1:n(this.text)?(this.host.selectAll(),this.resetSelection()):g&&this.text.selectionStart!=this.lastSelectionStart&&this.resetSelection()},e.prototype.$resetSelectionIOS=function(e){if(!this.$isFocused||this.copied&&!e||this.sendingText)return;e||(e="");var t="\n ab"+e+"cde fg\n";t!=this.text.value&&(this.text.value=this.lastValue=t);var n=4,r=4+(e.length||(this.host.selection.isEmpty()?0:1));(this.lastSelectionStart!=n||this.lastSelectionEnd!=r)&&this.text.setSelectionRange(n,r),this.lastSelectionStart=n,this.lastSelectionEnd=r},e.prototype.$resetSelection=function(){var e=this;if(this.inComposition||this.sendingText)return;if(!this.$isFocused&&!this.afterContextMenu)return;this.inComposition=!0;var t=0,n=0,r="",i=function(t,n){var r=n;for(var i=1;i<=t-e.rowStart&&i<2*e.numberOfExtraLines+1;i++)r+=e.host.session.getLine(t-i).length+1;return r};if(this.host.session){var s=this.host.selection,o=s.getRange(),u=s.cursor.row;if(u===this.rowEnd+1)this.rowStart=this.rowEnd+1,this.rowEnd=this.rowStart+2*this.numberOfExtraLines;else if(u===this.rowStart-1)this.rowEnd=this.rowStart-1,this.rowStart=this.rowEnd-2*this.numberOfExtraLines;else if(u<this.rowStart-1||u>this.rowEnd+1)this.rowStart=u>this.numberOfExtraLines?u-this.numberOfExtraLines:0,this.rowEnd=u>this.numberOfExtraLines?u+this.numberOfExtraLines:2*this.numberOfExtraLines;var a=[];for(var f=this.rowStart;f<=this.rowEnd;f++)a.push(this.host.session.getLine(f));r=a.join("\n"),t=i(o.start.row,o.start.column),n=i(o.end.row,o.end.column);if(o.start.row<this.rowStart){var l=this.host.session.getLine(this.rowStart-1);t=o.start.row<this.rowStart-1?0:t,n+=l.length+1,r=l+"\n"+r}else if(o.end.row>this.rowEnd){var c=this.host.session.getLine(this.rowEnd+1);n=o.end.row>this.rowEnd+1?c.length:o.end.column,n+=r.length+1,r=r+"\n"+c}else g&&u>0&&(r="\n"+r,n+=1,t+=1);r.length>h&&(t<h&&n<h?r=r.slice(0,h):(r="\n",t==n?t=n=0:(t=0,n=1)));var p=r+"\n\n";p!=this.lastValue&&(this.text.value=this.lastValue=p,this.lastSelectionStart=this.lastSelectionEnd=p.length)}this.afterContextMenu&&(this.lastSelectionStart=this.text.selectionStart,this.lastSelectionEnd=this.text.selectionEnd);if(this.lastSelectionEnd!=n||this.lastSelectionStart!=t||this.text.selectionEnd!=this.lastSelectionEnd)try{this.text.setSelectionRange(t,n),this.lastSelectionStart=t,this.lastSelectionEnd=n}catch(d){}this.inComposition=!1},e.prototype.setHost=function(e){this.host=e},e.prototype.setNumberOfExtraLines=function(e){this.rowStart=Number.MAX_SAFE_INTEGER,this.rowEnd=Number.MIN_SAFE_INTEGER;if(e<0){this.numberOfExtraLines=0;return}this.numberOfExtraLines=e},e.prototype.setAriaLabel=function(){var e="";this.host.$textInputAriaLabel&&(e+="".concat(this.host.$textInputAriaLabel,", "));if(this.host.session){var t=this.host.session.selection.cursor.row;e+=i("text-input.aria-label","Cursor at row $0",[t+1])}this.text.setAttribute("aria-label",e)},e.prototype.setAriaOptions=function(e){e.activeDescendant?(this.text.setAttribute("aria-haspopup","true"),this.text.setAttribute("aria-autocomplete",e.inline?"both":"list"),this.text.setAttribute("aria-activedescendant",e.activeDescendant)):(this.text.setAttribute("aria-haspopup","false"),this.text.setAttribute("aria-autocomplete","both"),this.text.removeAttribute("aria-activedescendant")),e.role&&this.text.setAttribute("role",e.role),e.setLabel&&(this.text.setAttribute("aria-roledescription",i("text-input.aria-roledescription","editor")),this.setAriaLabel())},e.prototype.focus=function(){var e=this;this.setAriaOptions({setLabel:this.host.renderer.enableKeyboardAccessibility});if(this.tempStyle||c||this.$focusScroll=="browser")return this.text.focus({preventScroll:!0});var t=this.text.style.top;this.text.style.position="fixed",this.text.style.top="0px";try{var n=this.text.getBoundingClientRect().top!=0}catch(r){return}var i=[];if(n){var s=this.text.parentElement;while(s&&s.nodeType==1)i.push(s),s.setAttribute("ace_nocontext","true"),!s.parentElement&&s.getRootNode?s=s.getRootNode().host:s=s.parentElement}this.text.focus({preventScroll:!0}),n&&i.forEach(function(e){e.removeAttribute("ace_nocontext")}),setTimeout(function(){e.text.style.position="",e.text.style.top=="0px"&&(e.text.style.top=t)},0)},e.prototype.blur=function(){this.text.blur()},e.prototype.isFocused=function(){return this.$isFocused},e.prototype.setInputHandler=function(e){this.inputHandler=e},e.prototype.getInputHandler=function(){return this.inputHandler},e.prototype.getElement=function(){return this.text},e.prototype.setCommandMode=function(e){this.commandMode=e,this.text.readOnly=!1},e.prototype.setReadOnly=function(e){this.commandMode||(this.text.readOnly=e)},e.prototype.setCopyWithEmptySelection=function(e){},e.prototype.onContextMenu=function(e){this.afterContextMenu=!0,this.resetSelection(),this.host._emit("nativecontextmenu",{target:this.host,domEvent:e}),this.moveToMouse(e,!0)},e.prototype.moveToMouse=function(e,t){var n=this;this.tempStyle||(this.tempStyle=this.text.style.cssText),this.text.style.cssText=(t?"z-index:100000;":"")+(s.isIE?"opacity:0.1;":"")+"text-indent: -"+(this.lastSelectionStart+this.lastSelectionEnd)*this.host.renderer.characterWidth*.5+"px;";var i=this.host.container.getBoundingClientRect(),u=o.computedStyle(this.host.container),a=i.top+(parseInt(u.borderTopWidth)||0),f=i.left+(parseInt(u.borderLeftWidth)||0),l=i.bottom-a-this.text.clientHeight-2,c=function(e){o.translate(n.text,e.clientX-f-2,Math.min(e.clientY-a-2,l))};c(e);if(e.type!="mousedown")return;this.host.renderer.$isMousePressed=!0,clearTimeout(this.closeTimeout),s.isWin&&r.capture(this.host.container,c,this.onContextMenuClose.bind(this))},e.prototype.destroy=function(){this.text.parentElement&&this.text.parentElement.removeChild(this.text)},e}();t.TextInput=y,t.$setUserAgentForTests=function(e,t){g=e,v=t}}),define("ace/mouse/default_handlers",["require","exports","module","ace/lib/useragent"],function(e,t,n){"use strict";function u(e,t,n,r){return Math.sqrt(Math.pow(n-e,2)+Math.pow(r-t,2))}function a(e,t,n){if(e.start.row==e.end.row)var r=2*t.column-e.start.column-e.end.column;else if(e.start.row==e.end.row-1&&!e.start.column&&!e.end.column)var r=3*t.column-2*n.getLine(e.start.row).length;else var r=2*t.row-e.start.row-e.end.row;return r<0?{cursor:e.start,anchor:e.end}:{cursor:e.end,anchor:e.start}}var r=e("../lib/useragent"),i=0,s=550,o=function(){function e(e){e.$clickSelection=null;var t=e.editor;t.setDefaultHandler("mousedown",this.onMouseDown.bind(e)),t.setDefaultHandler("dblclick",this.onDoubleClick.bind(e)),t.setDefaultHandler("tripleclick",this.onTripleClick.bind(e)),t.setDefaultHandler("quadclick",this.onQuadClick.bind(e)),t.setDefaultHandler("mousewheel",this.onMouseWheel.bind(e));var n=["select","startSelect","selectEnd","selectAllEnd","selectByWordsEnd","selectByLinesEnd","dragWait","dragWaitEnd","focusWait"];n.forEach(function(t){e[t]=this[t]},this),e.selectByLines=this.extendSelectionBy.bind(e,"getLineRange"),e.selectByWords=this.extendSelectionBy.bind(e,"getWordRange")}return e.prototype.onMouseDown=function(e){var t=e.inSelection(),n=e.getDocumentPosition();this.mousedownEvent=e;var i=this.editor,s=e.getButton();if(s!==0){var o=i.getSelectionRange(),u=o.isEmpty();(u||s==1)&&i.selection.moveToPosition(n),s==2&&(i.textInput.onContextMenu(e.domEvent),r.isMozilla||e.preventDefault());return}this.mousedownEvent.time=Date.now();if(t&&!i.isFocused()){i.focus();if(this.$focusTimeout&&!this.$clickSelection&&!i.inMultiSelectMode){this.setState("focusWait"),this.captureMouse(e);return}}return this.captureMouse(e),this.startSelect(n,e.domEvent._clicks>1),e.preventDefault()},e.prototype.startSelect=function(e,t){e=e||this.editor.renderer.screenToTextCoordinates(this.x,this.y);var n=this.editor;if(!this.mousedownEvent)return;this.mousedownEvent.getShiftKey()?n.selection.selectToPosition(e):t||n.selection.moveToPosition(e),t||this.select(),n.setStyle("ace_selecting"),this.setState("select")},e.prototype.select=function(){var e,t=this.editor,n=t.renderer.screenToTextCoordinates(this.x,this.y);if(this.$clickSelection){var r=this.$clickSelection.comparePoint(n);if(r==-1)e=this.$clickSelection.end;else if(r==1)e=this.$clickSelection.start;else{var i=a(this.$clickSelection,n,t.session);n=i.cursor,e=i.anchor}t.selection.setSelectionAnchor(e.row,e.column)}t.selection.selectToPosition(n),t.renderer.scrollCursorIntoView()},e.prototype.extendSelectionBy=function(e){var t,n=this.editor,r=n.renderer.screenToTextCoordinates(this.x,this.y),i=n.selection[e](r.row,r.column);if(this.$clickSelection){var s=this.$clickSelection.comparePoint(i.start),o=this.$clickSelection.comparePoint(i.end);if(s==-1&&o<=0){t=this.$clickSelection.end;if(i.end.row!=r.row||i.end.column!=r.column)r=i.start}else if(o==1&&s>=0){t=this.$clickSelection.start;if(i.start.row!=r.row||i.start.column!=r.column)r=i.end}else if(s==-1&&o==1)r=i.end,t=i.start;else{var u=a(this.$clickSelection,r,n.session);r=u.cursor,t=u.anchor}n.selection.setSelectionAnchor(t.row,t.column)}n.selection.selectToPosition(r),n.renderer.scrollCursorIntoView()},e.prototype.selectByLinesEnd=function(){this.$clickSelection=null,this.editor.unsetStyle("ace_selecting")},e.prototype.focusWait=function(){var e=u(this.mousedownEvent.x,this.mousedownEvent.y,this.x,this.y),t=Date.now();(e>i||t-this.mousedownEvent.time>this.$focusTimeout)&&this.startSelect(this.mousedownEvent.getDocumentPosition())},e.prototype.onDoubleClick=function(e){var t=e.getDocumentPosition(),n=this.editor,r=n.session,i=r.getBracketRange(t);i?(i.isEmpty()&&(i.start.column--,i.end.column++),this.setState("select")):(i=n.selection.getWordRange(t.row,t.column),this.setState("selectByWords")),this.$clickSelection=i,this.select()},e.prototype.onTripleClick=function(e){var t=e.getDocumentPosition(),n=this.editor;this.setState("selectByLines");var r=n.getSelectionRange();r.isMultiLine()&&r.contains(t.row,t.column)?(this.$clickSelection=n.selection.getLineRange(r.start.row),this.$clickSelection.end=n.selection.getLineRange(r.end.row).end):this.$clickSelection=n.selection.getLineRange(t.row),this.select()},e.prototype.onQuadClick=function(e){var t=this.editor;t.selectAll(),this.$clickSelection=t.getSelectionRange(),this.setState("selectAll")},e.prototype.onMouseWheel=function(e){if(e.getAccelKey())return;e.getShiftKey()&&e.wheelY&&!e.wheelX&&(e.wheelX=e.wheelY,e.wheelY=0);var t=this.editor;this.$lastScroll||(this.$lastScroll={t:0,vx:0,vy:0,allowed:0});var n=this.$lastScroll,r=e.domEvent.timeStamp,i=r-n.t,o=i?e.wheelX/i:n.vx,u=i?e.wheelY/i:n.vy;i<s&&(o=(o+n.vx)/2,u=(u+n.vy)/2);var a=Math.abs(o/u),f=!1;a>=1&&t.renderer.isScrollableBy(e.wheelX*e.speed,0)&&(f=!0),a<=1&&t.renderer.isScrollableBy(0,e.wheelY*e.speed)&&(f=!0);if(f)n.allowed=r;else if(r-n.allowed<s){var l=Math.abs(o)<=1.5*Math.abs(n.vx)&&Math.abs(u)<=1.5*Math.abs(n.vy);l?(f=!0,n.allowed=r):n.allowed=0}n.t=r,n.vx=o,n.vy=u;if(f)return t.renderer.scrollBy(e.wheelX*e.speed,e.wheelY*e.speed),e.stop()},e}();o.prototype.selectEnd=o.prototype.selectByLinesEnd,o.prototype.selectAllEnd=o.prototype.selectByLinesEnd,o.prototype.selectByWordsEnd=o.prototype.selectByLinesEnd,t.DefaultHandlers=o}),define("ace/mouse/mouse_event",["require","exports","module","ace/lib/event","ace/lib/useragent"],function(e,t,n){"use strict";var r=e("../lib/event"),i=e("../lib/useragent"),s=function(){function e(e,t){this.speed,this.wheelX,this.wheelY,this.domEvent=e,this.editor=t,this.x=this.clientX=e.clientX,this.y=this.clientY=e.clientY,this.$pos=null,this.$inSelection=null,this.propagationStopped=!1,this.defaultPrevented=!1}return e.prototype.stopPropagation=function(){r.stopPropagation(this.domEvent),this.propagationStopped=!0},e.prototype.preventDefault=function(){r.preventDefault(this.domEvent),this.defaultPrevented=!0},e.prototype.stop=function(){this.stopPropagation(),this.preventDefault()},e.prototype.getDocumentPosition=function(){return this.$pos?this.$pos:(this.$pos=this.editor.renderer.screenToTextCoordinates(this.clientX,this.clientY),this.$pos)},e.prototype.getGutterRow=function(){var e=this.getDocumentPosition().row,t=this.editor.session.documentToScreenRow(e,0),n=this.editor.session.documentToScreenRow(this.editor.renderer.$gutterLayer.$lines.get(0).row,0);return t-n},e.prototype.inSelection=function(){if(this.$inSelection!==null)return this.$inSelection;var e=this.editor,t=e.getSelectionRange();if(t.isEmpty())this.$inSelection=!1;else{var n=this.getDocumentPosition();this.$inSelection=t.contains(n.row,n.column)}return this.$inSelection},e.prototype.getButton=function(){return r.getButton(this.domEvent)},e.prototype.getShiftKey=function(){return this.domEvent.shiftKey},e.prototype.getAccelKey=function(){return i.isMac?this.domEvent.metaKey:this.domEvent.ctrlKey},e}();t.MouseEvent=s}),define("ace/lib/scroll",["require","exports","module"],function(e,t,n){t.preventParentScroll=function(t){t.stopPropagation();var n=t.currentTarget,r=n.scrollHeight>n.clientHeight;r||t.preventDefault()}}),define("ace/tooltip",["require","exports","module","ace/lib/dom","ace/lib/event","ace/range","ace/lib/scroll"],function(e,t,n){"use strict";var r=this&&this.__extends||function(){var e=function(t,n){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},e(t,n)};return function(t,n){function r(){this.constructor=t}if(typeof n!="function"&&n!==null)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");e(t,n),t.prototype=n===null?Object.create(n):(r.prototype=n.prototype,new r)}}(),i=this&&this.__values||function(e){var t=typeof Symbol=="function"&&Symbol.iterator,n=t&&e[t],r=0;if(n)return n.call(e);if(e&&typeof e.length=="number")return{next:function(){return e&&r>=e.length&&(e=void 0),{value:e&&e[r++],done:!e}}};throw new TypeError(t?"Object is not iterable.":"Symbol.iterator is not defined.")},s=e("./lib/dom"),o=e("./lib/event"),u=e("./range").Range,a=e("./lib/scroll").preventParentScroll,f="ace_tooltip",l=function(){function e(e){this.isOpen=!1,this.$element=null,this.$parentNode=e}return e.prototype.$init=function(){return this.$element=s.createElement("div"),this.$element.className=f,this.$element.style.display="none",this.$parentNode.appendChild(this.$element),this.$element},e.prototype.getElement=function(){return this.$element||this.$init()},e.prototype.setText=function(e){this.getElement().textContent=e},e.prototype.setHtml=function(e){this.getElement().innerHTML=e},e.prototype.setPosition=function(e,t){this.getElement().style.left=e+"px",this.getElement().style.top=t+"px"},e.prototype.setClassName=function(e){s.addCssClass(this.getElement(),e)},e.prototype.setTheme=function(e){this.theme&&(this.theme.isDark&&s.removeCssClass(this.getElement(),"ace_dark"),this.theme.cssClass&&s.removeCssClass(this.getElement(),this.theme.cssClass)),e.isDark&&s.addCssClass(this.getElement(),"ace_dark"),e.cssClass&&s.addCssClass(this.getElement(),e.cssClass),this.theme={isDark:e.isDark,cssClass:e.cssClass}},e.prototype.show=function(e,t,n){e!=null&&this.setText(e),t!=null&&n!=null&&this.setPosition(t,n),this.isOpen||(this.getElement().style.display="block",this.isOpen=!0)},e.prototype.hide=function(e){this.isOpen&&(this.getElement().style.display="none",this.getElement().className=f,this.isOpen=!1)},e.prototype.getHeight=function(){return this.getElement().offsetHeight},e.prototype.getWidth=function(){return this.getElement().offsetWidth},e.prototype.destroy=function(){this.isOpen=!1,this.$element&&this.$element.parentNode&&this.$element.parentNode.removeChild(this.$element)},e}(),c=function(){function e(){this.popups=[]}return e.prototype.addPopup=function(e){this.popups.push(e),this.updatePopups()},e.prototype.removePopup=function(e){var t=this.popups.indexOf(e);t!==-1&&(this.popups.splice(t,1),this.updatePopups())},e.prototype.updatePopups=function(){var e,t,n,r;this.popups.sort(function(e,t){return t.priority-e.priority});var s=[];try{for(var o=i(this.popups),u=o.next();!u.done;u=o.next()){var a=u.value,f=!0;try{for(var l=(n=void 0,i(s)),c=l.next();!c.done;c=l.next()){var h=c.value;if(this.doPopupsOverlap(h,a)){f=!1;break}}}catch(p){n={error:p}}finally{try{c&&!c.done&&(r=l.return)&&r.call(l)}finally{if(n)throw n.error}}f?s.push(a):a.hide()}}catch(d){e={error:d}}finally{try{u&&!u.done&&(t=o.return)&&t.call(o)}finally{if(e)throw e.error}}},e.prototype.doPopupsOverlap=function(e,t){var n=e.getElement().getBoundingClientRect(),r=t.getElement().getBoundingClientRect();return n.left<r.right&&n.right>r.left&&n.top<r.bottom&&n.bottom>r.top},e}(),h=new c;t.popupManager=h,t.Tooltip=l;var p=function(e){function t(t){t===void 0&&(t=document.body);var n=e.call(this,t)||this;n.timeout=undefined,n.lastT=0,n.idleTime=350,n.lastEvent=undefined,n.onMouseOut=n.onMouseOut.bind(n),n.onMouseMove=n.onMouseMove.bind(n),n.waitForHover=n.waitForHover.bind(n),n.hide=n.hide.bind(n);var r=n.getElement();return r.style.whiteSpace="pre-wrap",r.style.pointerEvents="auto",r.addEventListener("mouseout",n.onMouseOut),r.tabIndex=-1,r.addEventListener("blur",function(){r.contains(document.activeElement)||this.hide()}.bind(n)),r.addEventListener("wheel",a),n}return r(t,e),t.prototype.addToEditor=function(e){e.on("mousemove",this.onMouseMove),e.on("mousedown",this.hide);var t=e.renderer.getMouseEventTarget();t&&typeof t.removeEventListener=="function"&&t.addEventListener("mouseout",this.onMouseOut,!0)},t.prototype.removeFromEditor=function(e){e.off("mousemove",this.onMouseMove),e.off("mousedown",this.hide);var t=e.renderer.getMouseEventTarget();t&&typeof t.removeEventListener=="function"&&t.removeEventListener("mouseout",this.onMouseOut,!0),this.timeout&&(clearTimeout(this.timeout),this.timeout=null)},t.prototype.onMouseMove=function(e,t){this.lastEvent=e,this.lastT=Date.now();var n=t.$mouseHandler.isMousePressed;if(this.isOpen){var r=this.lastEvent&&this.lastEvent.getDocumentPosition();(!this.range||!this.range.contains(r.row,r.column)||n||this.isOutsideOfText(this.lastEvent))&&this.hide()}if(this.timeout||n)return;this.lastEvent=e,this.timeout=setTimeout(this.waitForHover,this.idleTime)},t.prototype.waitForHover=function(){this.timeout&&clearTimeout(this.timeout);var e=Date.now()-this.lastT;if(this.idleTime-e>10){this.timeout=setTimeout(this.waitForHover,this.idleTime-e);return}this.timeout=null,this.lastEvent&&!this.isOutsideOfText(this.lastEvent)&&this.$gatherData(this.lastEvent,this.lastEvent.editor)},t.prototype.isOutsideOfText=function(e){var t=e.editor,n=e.getDocumentPosition(),r=t.session.getLine(n.row);if(n.column==r.length){var i=t.renderer.pixelToScreenCoordinates(e.clientX,e.clientY),s=t.session.documentToScreenPosition(n.row,n.column);if(s.column!=i.column||s.row!=i.row)return!0}return!1},t.prototype.setDataProvider=function(e){this.$gatherData=e},t.prototype.showForRange=function(e,t,n,r){if(r&&r!=this.lastEvent)return;if(this.isOpen&&document.activeElement==this.getElement())return;var i=e.renderer;this.isOpen||(h.addPopup(this),this.$registerCloseEvents(),this.setTheme(i.theme)),this.isOpen=!0,this.range=u.fromPoints(t.start,t.end);var o=i.textToScreenCoordinates(t.start.row,t.start.column),a=i.scroller.getBoundingClientRect();o.pageX<a.left&&(o.pageX=a.left);var f=this.getElement();f.innerHTML="",f.appendChild(n),f.style.maxHeight="",f.style.display="block",this.$setPosition(e,o,!0,t),s.$fixPositionBug(f)},t.prototype.$setPosition=function(e,t,n,r){var i=10;n&&this.addMarker(r,e.session);var s=e.renderer,o=this.getElement(),u=o.offsetHeight,a=o.offsetWidth,f=t.pageY,l=t.pageX,c=window.innerHeight-f-s.lineHeight,h=this.$shouldPlaceAbove(u,f,c-i);o.style.maxHeight=(h?f:c)-i+"px",o.style.top=h?"":f+s.lineHeight+"px",o.style.bottom=h?window.innerHeight-f+"px":"",o.style.left=Math.min(l,window.innerWidth-a-i)+"px"},t.prototype.$shouldPlaceAbove=function(e,t,n){return!(t-e<0&&t<n)},t.prototype.addMarker=function(e,t){this.marker&&this.$markerSession.removeMarker(this.marker),this.$markerSession=t,this.marker=t&&t.addMarker(e,"ace_highlight-marker","text")},t.prototype.hide=function(e){if(e&&this.$fromKeyboard&&e.type=="keydown"&&e.code=="Escape")return;if(!e&&document.activeElement==this.getElement())return;if(e&&e.target&&(e.type!="keydown"||e.ctrlKey||e.metaKey)&&this.$element.contains(e.target))return;this.lastEvent=null,this.timeout&&clearTimeout(this.timeout),this.timeout=null,this.addMarker(null),this.isOpen&&(this.$fromKeyboard=!1,this.$removeCloseEvents(),this.getElement().style.display="none",this.isOpen=!1,h.removePopup(this))},t.prototype.$registerCloseEvents=function(){window.addEventListener("keydown",this.hide,!0),window.addEventListener("wheel",this.hide,!0),window.addEventListener("mousedown",this.hide,!0)},t.prototype.$removeCloseEvents=function(){window.removeEventListener("keydown",this.hide,!0),window.removeEventListener("wheel",this.hide,!0),window.removeEventListener("mousedown",this.hide,!0)},t.prototype.onMouseOut=function(e){this.timeout&&(clearTimeout(this.timeout),this.timeout=null),this.lastEvent=null;if(!this.isOpen)return;if(!e.relatedTarget||this.getElement().contains(e.relatedTarget))return;if(e&&e.currentTarget.contains(e.relatedTarget))return;e.relatedTarget.classList.contains("ace_content")||this.hide()},t}(l);t.HoverTooltip=p}),define("ace/mouse/default_gutter_handler",["require","exports","module","ace/lib/dom","ace/mouse/mouse_event","ace/tooltip","ace/config","ace/range"],function(e,t,n){"use strict";function l(e){var t=e.editor,n=t.renderer.$gutterLayer;e.$tooltip=new c(t),e.$tooltip.addToEditor(t),e.$tooltip.setDataProvider(function(t,n){var r=t.getDocumentPosition().row;e.$tooltip.showTooltip(r)}),e.editor.setDefaultHandler("guttermousedown",function(r){if(!t.isFocused()||r.getButton()!=0)return;var i=n.getRegion(r);if(i=="foldWidgets")return;var s=r.getDocumentPosition().row,o=t.session.selection;if(r.getShiftKey())o.selectTo(s,0);else{if(r.domEvent.detail==2)return t.selectAll(),r.preventDefault();e.$clickSelection=t.selection.getLineRange(s)}return e.setState("selectByLines"),e.captureMouse(r),r.preventDefault()})}var r=this&&this.__extends||function(){var e=function(t,n){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},e(t,n)};return function(t,n){function r(){this.constructor=t}if(typeof n!="function"&&n!==null)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");e(t,n),t.prototype=n===null?Object.create(n):(r.prototype=n.prototype,new r)}}(),i=this&&this.__values||function(e){var t=typeof Symbol=="function"&&Symbol.iterator,n=t&&e[t],r=0;if(n)return n.call(e);if(e&&typeof e.length=="number")return{next:function(){return e&&r>=e.length&&(e=void 0),{value:e&&e[r++],done:!e}}};throw new TypeError(t?"Object is not iterable.":"Symbol.iterator is not defined.")},s=e("../lib/dom"),o=e("./mouse_event").MouseEvent,u=e("../tooltip").HoverTooltip,a=e("../config").nls,f=e("../range").Range;t.GutterHandler=l;var c=function(e){function t(n){var r=e.call(this,n.container)||this;r.id="gt"+ ++t.$uid,r.editor=n,r.visibleTooltipRow;var i=r.getElement();return i.setAttribute("role","tooltip"),i.setAttribute("id",r.id),i.style.pointerEvents="auto",r.idleTime=50,r.onDomMouseMove=r.onDomMouseMove.bind(r),r.onDomMouseOut=r.onDomMouseOut.bind(r),r.setClassName("ace_gutter-tooltip"),r}return r(t,e),t.prototype.onDomMouseMove=function(e){var t=new o(e,this.editor);this.onMouseMove(t,this.editor)},t.prototype.onDomMouseOut=function(e){var t=new o(e,this.editor);this.onMouseOut(t)},t.prototype.addToEditor=function(t){var n=t.renderer.$gutter;n.addEventListener("mousemove",this.onDomMouseMove),n.addEventListener("mouseout",this.onDomMouseOut),e.prototype.addToEditor.call(this,t)},t.prototype.removeFromEditor=function(t){var n=t.renderer.$gutter;n.removeEventListener("mousemove",this.onDomMouseMove),n.removeEventListener("mouseout",this.onDomMouseOut),e.prototype.removeFromEditor.call(this,t)},t.prototype.destroy=function(){this.editor&&this.removeFromEditor(this.editor),e.prototype.destroy.call(this)},Object.defineProperty(t,"annotationLabels",{get:function(){return{error:{singular:a("gutter-tooltip.aria-label.error.singular","error"),plural:a("gutter-tooltip.aria-label.error.plural","errors")},security:{singular:a("gutter-tooltip.aria-label.security.singular","security finding"),plural:a("gutter-tooltip.aria-label.security.plural","security findings")},warning:{singular:a("gutter-tooltip.aria-label.warning.singular","warning"),plural:a("gutter-tooltip.aria-label.warning.plural","warnings")},info:{singular:a("gutter-tooltip.aria-label.info.singular","information message"),plural:a("gutter-tooltip.aria-label.info.plural","information messages")},hint:{singular:a("gutter-tooltip.aria-label.hint.singular","suggestion"),plural:a("gutter-tooltip.aria-label.hint.plural","suggestions")}}},enumerable:!1,configurable:!0}),t.prototype.showTooltip=function(e){var n,r=this.editor.renderer.$gutterLayer,i=r.$annotations[e],o;i?o={displayText:Array.from(i.displayText),type:Array.from(i.type)}:o={displayText:[],type:[]};var u=r.session.getFoldLine(e);if(u&&r.$showFoldedAnnotations){var a={error:[],security:[],warning:[],info:[],hint:[]},l={error:1,security:2,warning:3,info:4,hint:5},c;for(var h=e+1;h<=u.end.row;h++){if(!r.$annotations[h])continue;for(var p=0;p<r.$annotations[h].text.length;p++){var d=r.$annotations[h].type[p];a[d].push(r.$annotations[h].text[p]);if(!c||l[d]<l[c])c=d}}if(["error","security","warning"].includes(c)){var v="".concat(t.annotationsToSummaryString(a)," in folded code.");o.displayText.push(v),o.type.push(c+"_fold")}}if(o.displayText.length===0)return this.hide();var m={error:[],security:[],warning:[],info:[],hint:[]},g=r.$useSvgGutterIcons?"ace_icon_svg":"ace_icon";for(var h=0;h<o.displayText.length;h++){var y=s.createElement("span"),b=s.createElement("span");(n=b.classList).add.apply(n,["ace_".concat(o.type[h]),g]),b.setAttribute("aria-label","".concat(t.annotationLabels[o.type[h].replace("_fold","")].singular)),b.setAttribute("role","img"),b.appendChild(s.createTextNode(" ")),y.appendChild(b),y.appendChild(s.createTextNode(o.displayText[h])),y.appendChild(s.createElement("br")),m[o.type[h].replace("_fold","")].push(y)}var w=s.createElement("span");m.error.forEach(function(e){return w.appendChild(e)}),m.security.forEach(function(e){return w.appendChild(e)}),m.warning.forEach(function(e){return w.appendChild(e)}),m.info.forEach(function(e){return w.appendChild(e)}),m.hint.forEach(function(e){return w.appendChild(e)}),w.setAttribute("aria-live","polite");var E=this.$findLinkedAnnotationNode(e);E&&E.setAttribute("aria-describedby",this.id);var S=f.fromPoints({row:e,column:0},{row:e,column:0});this.showForRange(this.editor,S,w),this.visibleTooltipRow=e,this.editor._signal("showGutterTooltip",this)},t.prototype.$setPosition=function(t,n,r,i){var s=this.$findCellByRow(i.start.row);if(!s)return;var o=s&&s.element,u=o&&o.querySelector(".ace_gutter_annotation");if(!u)return;var a=u.getBoundingClientRect();if(!a)return;var f={pageX:a.right,pageY:a.top};return e.prototype.$setPosition.call(this,t,f,!1,i)},t.prototype.$shouldPlaceAbove=function(e,t,n){return n<e},t.prototype.$findLinkedAnnotationNode=function(e){var t=this.$findCellByRow(e);if(t){var n=t.element;if(n.childNodes.length>2)return n.childNodes[2]}},t.prototype.$findCellByRow=function(e){return this.editor.renderer.$gutterLayer.$lines.cells.find(function(t){return t.row===e})},t.prototype.hide=function(t){if(!this.isOpen)return;this.$element.removeAttribute("aria-live");if(this.visibleTooltipRow!=undefined){var n=this.$findLinkedAnnotationNode(this.visibleTooltipRow);n&&n.removeAttribute("aria-describedby")}this.visibleTooltipRow=undefined,this.editor._signal("hideGutterTooltip",this),e.prototype.hide.call(this,t)},t.annotationsToSummaryString=function(e){var n,r,s=[],o=["error","security","warning","info","hint"];try{for(var u=i(o),a=u.next();!a.done;a=u.next()){var f=a.value;if(!e[f].length)continue;var l=e[f].length===1?t.annotationLabels[f].singular:t.annotationLabels[f].plural;s.push("".concat(e[f].length," ").concat(l))}}catch(c){n={error:c}}finally{try{a&&!a.done&&(r=u.return)&&r.call(u)}finally{if(n)throw n.error}}return s.join(", ")},t.prototype.isOutsideOfText=function(e){var t=e.editor,n=t.renderer.$gutter.getBoundingClientRect();return!(e.clientX>=n.left&&e.clientX<=n.right&&e.clientY>=n.top&&e.clientY<=n.bottom)},t}(u);c.$uid=0,t.GutterTooltip=c}),define("ace/mouse/dragdrop_handler",["require","exports","module","ace/lib/dom","ace/lib/event","ace/lib/useragent"],function(e,t,n){"use strict";function f(e){function T(e,n){var r=Date.now(),i=!n||e.row!=n.row,s=!n||e.column!=n.column;if(!S||i||s)t.moveCursorToPosition(e),S=r,x={x:p,y:d};else{var o=l(x.x,x.y,p,d);o>a?S=null:r-S>=u&&(t.renderer.scrollCursorIntoView(),S=null)}}function N(e,n){var r=Date.now(),i=t.renderer.layerConfig.lineHeight,s=t.renderer.layerConfig.characterWidth,u=t.renderer.scroller.getBoundingClientRect(),a={x:{left:p-u.left,right:u.right-p},y:{top:d-u.top,bottom:u.bottom-d}},f=Math.min(a.x.left,a.x.right),l=Math.min(a.y.top,a.y.bottom),c={row:e.row,column:e.column};f/s<=2&&(c.column+=a.x.left<a.x.right?-3:2),l/i<=1&&(c.row+=a.y.top<a.y.bottom?-1:1);var h=e.row!=c.row,v=e.column!=c.column,m=!n||e.row!=n.row;h||v&&!m?E?r-E>=o&&t.renderer.scrollCursorIntoView(c):E=r:E=null}function C(){var e=g;g=t.renderer.screenToTextCoordinates(p,d),T(g,e),N(g,e)}function k(){m=t.selection.toOrientedRange(),h=t.session.addMarker(m,"ace_selection",t.getSelectionStyle()),t.clearSelection(),t.isFocused()&&t.renderer.$cursorLayer.setBlinking(!1),clearInterval(v),C(),v=setInterval(C,20),y=0,i.addListener(document,"mousemove",O)}function L(){clearInterval(v),t.session.removeMarker(h),h=null,t.selection.fromOrientedRange(m),t.isFocused()&&!w&&t.$resetCursorStyle(),m=null,g=null,y=0,E=null,S=null,i.removeListener(document,"mousemove",O)}function O(){A==null&&(A=setTimeout(function(){A!=null&&h&&L()},20))}function M(e){var t=e.types;return!t||Array.prototype.some.call(t,function(e){return e=="text/plain"||e=="Text"})}function _(e){var t=["copy","copymove","all","uninitialized"],n=["move","copymove","linkmove","all","uninitialized"],r=s.isMac?e.altKey:e.ctrlKey,i="uninitialized";try{i=e.dataTransfer.effectAllowed.toLowerCase()}catch(e){}var o="none";return r&&t.indexOf(i)>=0?o="copy":n.indexOf(i)>=0?o="move":t.indexOf(i)>=0&&(o="copy"),o}var t=e.editor,n=r.createElement("div");n.style.cssText="top:-100px;position:absolute;z-index:2147483647;opacity:0.5",n.textContent="\u00a0";var f=["dragWait","dragWaitEnd","startDrag","dragReadyEnd","onMouseDrag"];f.forEach(function(t){e[t]=this[t]},this),t.on("mousedown",this.onMouseDown.bind(e));var c=t.container,h,p,d,v,m,g,y=0,b,w,E,S,x;this.onDragStart=function(e){if(this.cancelDrag||!c.draggable){var r=this;return setTimeout(function(){r.startSelect(),r.captureMouse(e)},0),e.preventDefault()}m=t.getSelectionRange();var i=e.dataTransfer;i.effectAllowed=t.getReadOnly()?"copy":"copyMove",t.container.appendChild(n),i.setDragImage&&i.setDragImage(n,0,0),setTimeout(function(){t.container.removeChild(n)}),i.clearData(),i.setData("Text",t.session.getTextRange()),w=!0,this.setState("drag")},this.onDragEnd=function(e){c.draggable=!1,w=!1,this.setState(null);if(!t.getReadOnly()){var n=e.dataTransfer.dropEffect;!b&&n=="move"&&t.session.remove(t.getSelectionRange()),t.$resetCursorStyle()}this.editor.unsetStyle("ace_dragging"),this.editor.renderer.setCursorStyle("")},this.onDragEnter=function(e){if(t.getReadOnly()||!M(e.dataTransfer))return;return p=e.clientX,d=e.clientY,h||k(),y++,e.dataTransfer.dropEffect=b=_(e),i.preventDefault(e)},this.onDragOver=function(e){if(t.getReadOnly()||!M(e.dataTransfer))return;return p=e.clientX,d=e.clientY,h||(k(),y++),A!==null&&(A=null),e.dataTransfer.dropEffect=b=_(e),i.preventDefault(e)},this.onDragLeave=function(e){y--;if(y<=0&&h)return L(),b=null,i.preventDefault(e)},this.onDrop=function(e){if(!g)return;var n=e.dataTransfer;if(w)switch(b){case"move":m.contains(g.row,g.column)?m={start:g,end:g}:m=t.moveText(m,g);break;case"copy":m=t.moveText(m,g,!0)}else{var r=n.getData("Text");m={start:g,end:t.session.insert(g,r)},t.focus(),b=null}return L(),i.preventDefault(e)},i.addListener(c,"dragstart",this.onDragStart.bind(e),t),i.addListener(c,"dragend",this.onDragEnd.bind(e),t),i.addListener(c,"dragenter",this.onDragEnter.bind(e),t),i.addListener(c,"dragover",this.onDragOver.bind(e),t),i.addListener(c,"dragleave",this.onDragLeave.bind(e),t),i.addListener(c,"drop",this.onDrop.bind(e),t);var A=null}function l(e,t,n,r){return Math.sqrt(Math.pow(n-e,2)+Math.pow(r-t,2))}var r=e("../lib/dom"),i=e("../lib/event"),s=e("../lib/useragent"),o=200,u=200,a=5;(function(){this.dragWait=function(){var e=Date.now()-this.mousedownEvent.time;e>this.editor.getDragDelay()&&this.startDrag()},this.dragWaitEnd=function(){var e=this.editor.container;e.draggable=!1,this.startSelect(this.mousedownEvent.getDocumentPosition()),this.selectEnd()},this.dragReadyEnd=function(e){this.editor.$resetCursorStyle(),this.editor.unsetStyle("ace_dragging"),this.editor.renderer.setCursorStyle(""),this.dragWaitEnd()},this.startDrag=function(){this.cancelDrag=!1;var e=this.editor,t=e.container;t.draggable=!0,e.renderer.$cursorLayer.setBlinking(!1),e.setStyle("ace_dragging");var n=s.isWin?"default":"move";e.renderer.setCursorStyle(n),this.setState("dragReady")},this.onMouseDrag=function(e){var t=this.editor.container;if(s.isIE&&this.state=="dragReady"){var n=l(this.mousedownEvent.x,this.mousedownEvent.y,this.x,this.y);n>3&&t.dragDrop()}if(this.state==="dragWait"){var n=l(this.mousedownEvent.x,this.mousedownEvent.y,this.x,this.y);n>0&&(t.draggable=!1,this.startSelect(this.mousedownEvent.getDocumentPosition()))}},this.onMouseDown=function(e){if(!this.$dragEnabled)return;this.mousedownEvent=e;var t=this.editor,n=e.inSelection(),r=e.getButton(),i=e.domEvent.detail||1;if(i===1&&r===0&&n){if(e.editor.inMultiSelectMode&&(e.getAccelKey()||e.getShiftKey()))return;this.mousedownEvent.time=Date.now();var o=e.domEvent.target||e.domEvent.srcElement;"unselectable"in o&&(o.unselectable="on");if(t.getDragDelay()){if(s.isWebKit){this.cancelDrag=!0;var u=t.container;u.draggable=!0}this.setState("dragWait")}else this.startDrag();this.captureMouse(e,this.onMouseDrag.bind(this)),e.defaultPrevented=!0}}}).call(f.prototype),t.DragdropHandler=f}),define("ace/mouse/touch_handler",["require","exports","module","ace/mouse/mouse_event","ace/lib/event","ace/lib/dom"],function(e,t,n){"use strict";var r=e("./mouse_event").MouseEvent,i=e("../lib/event"),s=e("../lib/dom");t.addTouchListeners=function(e,t){function b(){var e=window.navigator&&window.navigator.clipboard,r=!1,i=function(){var n=t.getCopyText(),i=t.session.getUndoManager().hasUndo();y.replaceChild(s.buildDom(r?["span",!n&&o("selectall")&&["span",{"class":"ace_mobile-button",action:"selectall"},"Select All"],n&&o("copy")&&["span",{"class":"ace_mobile-button",action:"copy"},"Copy"],n&&o("cut")&&["span",{"class":"ace_mobile-button",action:"cut"},"Cut"],e&&o("paste")&&["span",{"class":"ace_mobile-button",action:"paste"},"Paste"],i&&o("undo")&&["span",{"class":"ace_mobile-button",action:"undo"},"Undo"],o("find")&&["span",{"class":"ace_mobile-button",action:"find"},"Find"],o("openCommandPalette")&&["span",{"class":"ace_mobile-button",action:"openCommandPalette"},"Palette"]]:["span"]),y.firstChild)},o=function(e){return t.commands.canExecute(e,t)},u=function(n){var s=n.target.getAttribute("action");if(s=="more"||!r)return r=!r,i();if(s=="paste")e.readText().then(function(e){t.execCommand(s,e)});else if(s){if(s=="cut"||s=="copy")e?e.writeText(t.getCopyText()):document.execCommand("copy");t.execCommand(s)}y.firstChild.style.display="none",r=!1,s!="openCommandPalette"&&t.focus()};y=s.buildDom(["div",{"class":"ace_mobile-menu",onclick:u},["span"],["span",{"class":"ace_mobile-button",action:"more"},"..."]],t.container),y.addEventListener("touchstart",function(e){n="menu",e.stopPropagation(),e.preventDefault(),t.textInput.focus()}),y.addEventListener("touchend",function(e){e.stopPropagation(),e.preventDefault(),u(e)})}function w(){if(!t.getOption("enableMobileMenu")){y&&E();return}y||b();var e=t.selection.cursor,n=t.renderer.textToScreenCoordinates(e.row,e.column),r=t.renderer.textToScreenCoordinates(0,0).pageX,i=t.renderer.scrollLeft,s=t.container.getBoundingClientRect();y.style.top=n.pageY-s.top-3+"px",n.pageX-s.left<s.width-70?(y.style.left="",y.style.right="10px"):(y.style.right="",y.style.left=r+i-s.left+"px"),y.style.display="",y.firstChild.style.display="none",t.on("input",E)}function E(e){y&&(y.style.display="none"),t.off("input",E)}function S(){l=null,clearTimeout(l);var e=t.selection.getRange(),r=e.contains(p.row,p.column);if(e.isEmpty()||!r)t.selection.moveToPosition(p),t.selection.selectWord();n="wait",w()}function x(){l=null,clearTimeout(l),t.selection.moveToPosition(p);var e=d>=2?t.selection.getLineRange(p.row):t.session.getBracketRange(p);e&&!e.isEmpty()?t.selection.setRange(e):t.selection.selectWord(),n="wait"}function T(){h+=60,c=setInterval(function(){h--<=0&&(clearInterval(c),c=null),Math.abs(v)<.01&&(v=0),Math.abs(m)<.01&&(m=0),h<20&&(v=.9*v),h<20&&(m=.9*m);var e=t.session.getScrollTop();t.renderer.scrollBy(10*v,10*m),e==t.session.getScrollTop()&&(h=0)},10)}var n="scroll",o,u,a,f,l,c,h=0,p,d=0,v=0,m=0,g,y;i.addListener(e,"contextmenu",function(e){if(!g)return;var n=t.textInput.getElement();n.focus()},t),i.addListener(e,"touchstart",function(e){var i=e.touches;if(l||i.length>1){clearTimeout(l),l=null,a=-1,n="zoom";return}g=t.$mouseHandler.isMousePressed=!0;var s=t.renderer.layerConfig.lineHeight,c=t.renderer.layerConfig.lineHeight,y=e.timeStamp;f=y;var b=i[0],w=b.clientX,E=b.clientY;Math.abs(o-w)+Math.abs(u-E)>s&&(a=-1),o=e.clientX=w,u=e.clientY=E,v=m=0;var T=new r(e,t);p=T.getDocumentPosition();if(y-a<500&&i.length==1&&!h)d++,e.preventDefault(),e.button=0,x();else{d=0;var N=t.selection.cursor,C=t.selection.isEmpty()?N:t.selection.anchor,k=t.renderer.$cursorLayer.getPixelPosition(N,!0),L=t.renderer.$cursorLayer.getPixelPosition(C,!0),A=t.renderer.scroller.getBoundingClientRect(),O=t.renderer.layerConfig.offset,M=t.renderer.scrollLeft,_=function(e,t){return e/=c,t=t/s-.75,e*e+t*t};if(e.clientX<A.left){n="zoom";return}var D=_(e.clientX-A.left-k.left+M,e.clientY-A.top-k.top+O),P=_(e.clientX-A.left-L.left+M,e.clientY-A.top-L.top+O);D<3.5&&P<3.5&&(n=D>P?"cursor":"anchor"),P<3.5?n="anchor":D<3.5?n="cursor":n="scroll",l=setTimeout(S,450)}a=y},t),i.addListener(e,"touchend",function(e){g=t.$mouseHandler.isMousePressed=!1,c&&clearInterval(c),n=="zoom"?(n="",h=0):l?(t.selection.moveToPosition(p),h=0,w()):n=="scroll"?(T(),E()):w(),clearTimeout(l),l=null},t),i.addListener(e,"touchmove",function(e){l&&(clearTimeout(l),l=null);var i=e.touches;if(i.length>1||n=="zoom")return;var s=i[0],a=o-s.clientX,c=u-s.clientY;if(n=="wait"){if(!(a*a+c*c>4))return e.preventDefault();n="cursor"}o=s.clientX,u=s.clientY,e.clientX=s.clientX,e.clientY=s.clientY;var h=e.timeStamp,p=h-f;f=h;if(n=="scroll"){var d=new r(e,t);d.speed=1,d.wheelX=a,d.wheelY=c,10*Math.abs(a)<Math.abs(c)&&(a=0),10*Math.abs(c)<Math.abs(a)&&(c=0),p!=0&&(v=a/p,m=c/p),t._emit("mousewheel",d),d.propagationStopped||(v=m=0)}else{var g=new r(e,t),y=g.getDocumentPosition();n=="cursor"?t.selection.moveCursorToPosition(y):n=="anchor"&&t.selection.setSelectionAnchor(y.row,y.column),t.renderer.scrollCursorIntoView(y),e.preventDefault()}},t)}}),define("ace/mouse/mouse_handler",["require","exports","module","ace/lib/event","ace/lib/useragent","ace/mouse/default_handlers","ace/mouse/default_gutter_handler","ace/mouse/mouse_event","ace/mouse/dragdrop_handler","ace/mouse/touch_handler","ace/config"],function(e,t,n){"use strict";var r=e("../lib/event"),i=e("../lib/useragent"),s=e("./default_handlers").DefaultHandlers,o=e("./default_gutter_handler").GutterHandler,u=e("./mouse_event").MouseEvent,a=e("./dragdrop_handler").DragdropHandler,f=e("./touch_handler").addTouchListeners,l=e("../config"),c=function(){function e(e){this.$dragDelay,this.$dragEnabled,this.$mouseMoved,this.mouseEvent,this.$focusTimeout;var t=this;this.editor=e,new s(this),new o(this),new a(this);var n=function(t){var n=!document.hasFocus||!document.hasFocus()||!e.isFocused()&&document.activeElement==(e.textInput&&e.textInput.getElement());n&&window.focus(),e.focus(),setTimeout(function(){e.isFocused()||e.focus()})},u=e.renderer.getMouseEventTarget();r.addListener(u,"click",this.onMouseEvent.bind(this,"click"),e),r.addListener(u,"mousemove",this.onMouseMove.bind(this,"mousemove"),e),r.addMultiMouseDownListener([u,e.renderer.scrollBarV&&e.renderer.scrollBarV.inner,e.renderer.scrollBarH&&e.renderer.scrollBarH.inner,e.textInput&&e.textInput.getElement()].filter(Boolean),[400,300,250],this,"onMouseEvent",e),r.addMouseWheelListener(e.container,this.onMouseWheel.bind(this,"mousewheel"),e),f(e.container,e);var l=e.renderer.$gutter;r.addListener(l,"mousedown",this.onMouseEvent.bind(this,"guttermousedown"),e),r.addListener(l,"click",this.onMouseEvent.bind(this,"gutterclick"),e),r.addListener(l,"dblclick",this.onMouseEvent.bind(this,"gutterdblclick"),e),r.addListener(l,"mousemove",this.onMouseEvent.bind(this,"guttermousemove"),e),r.addListener(u,"mousedown",n,e),r.addListener(l,"mousedown",n,e),i.isIE&&e.renderer.scrollBarV&&(r.addListener(e.renderer.scrollBarV.element,"mousedown",n,e),r.addListener(e.renderer.scrollBarH.element,"mousedown",n,e)),e.on("mousemove",function(n){if(t.state||t.$dragDelay||!t.$dragEnabled)return;var r=e.renderer.screenToTextCoordinates(n.x,n.y),i=e.session.selection.getRange(),s=e.renderer;!i.isEmpty()&&i.insideStart(r.row,r.column)?s.setCursorStyle("default"):s.setCursorStyle("")},e)}return e.prototype.onMouseEvent=function(e,t){if(!this.editor.session)return;this.editor._emit(e,new u(t,this.editor))},e.prototype.onMouseMove=function(e,t){var n=this.editor._eventRegistry&&this.editor._eventRegistry.mousemove;if(!n||!n.length)return;this.editor._emit(e,new u(t,this.editor))},e.prototype.onMouseWheel=function(e,t){var n=new u(t,this.editor);n.speed=this.$scrollSpeed*2,n.wheelX=t.wheelX,n.wheelY=t.wheelY,this.editor._emit(e,n)},e.prototype.setState=function(e){this.state=e},e.prototype.captureMouse=function(e,t){this.x=e.x,this.y=e.y,this.isMousePressed=!0;var n=this.editor,s=this.editor.renderer;s.$isMousePressed=!0;var o=this,a=!0,f=function(e){if(!e)return;if(i.isWebKit&&!e.which&&o.releaseMouse)return o.releaseMouse();o.x=e.clientX,o.y=e.clientY,t&&t(e),o.mouseEvent=new u(e,o.editor),o.$mouseMoved=!0},l=function(e){n.off("beforeEndOperation",p),a=!1,n.session&&c(),o[o.state+"End"]&&o[o.state+"End"](e),o.state="",o.isMousePressed=s.$isMousePressed=!1,s.$keepTextAreaAtCursor&&s.$moveTextAreaToCursor(),o.$onCaptureMouseMove=o.releaseMouse=null,e&&o.onMouseEvent("mouseup",e),n.endOperation()},c=function(){o[o.state]&&o[o.state](),o.$mouseMoved=!1},h=function(){a&&(c(),r.nextFrame(h))};if(i.isOldIE&&e.domEvent.type=="dblclick")return setTimeout(function(){l(e)});var p=function(e){if(!o.releaseMouse)return;n.curOp.command.name&&n.curOp.selectionChanged&&(o[o.state+"End"]&&o[o.state+"End"](),o.state="",o.releaseMouse())};n.on("beforeEndOperation",p),n.startOperation({command:{name:"mouse"}}),o.$onCaptureMouseMove=f,o.releaseMouse=r.capture(this.editor.container,f,l),h()},e.prototype.cancelContextMenu=function(){var e=function(t){if(t&&t.domEvent&&t.domEvent.type!="contextmenu")return;this.editor.off("nativecontextmenu",e),t&&t.domEvent&&r.stopEvent(t.domEvent)}.bind(this);setTimeout(e,10),this.editor.on("nativecontextmenu",e)},e.prototype.destroy=function(){this.releaseMouse&&this.releaseMouse(),this.$tooltip&&this.$tooltip.destroy()},e}();c.prototype.releaseMouse=null,l.defineOptions(c.prototype,"mouseHandler",{scrollSpeed:{initialValue:2},dragDelay:{initialValue:i.isMac?150:0},dragEnabled:{initialValue:!0},focusTimeout:{initialValue:0}}),t.MouseHandler=c}),define("ace/mouse/fold_handler",["require","exports","module","ace/lib/dom"],function(e,t,n){"use strict";var r=e("../lib/dom"),i=function(){function e(e){e.on("click",function(t){var n=t.getDocumentPosition(),i=e.session,s=i.getFoldAt(n.row,n.column,1);s&&(t.getAccelKey()?i.removeFold(s):i.expandFold(s),t.stop());var o=t.domEvent&&t.domEvent.target;o&&r.hasCssClass(o,"ace_inline_button")&&r.hasCssClass(o,"ace_toggle_wrap")&&(i.setOption("wrap",!i.getUseWrapMode()),e.renderer.scrollCursorIntoView())}),e.on("gutterclick",function(t){var n=e.renderer.$gutterLayer.getRegion(t);if(n=="foldWidgets"){var r=t.getDocumentPosition().row,i=e.session;i.foldWidgets&&i.foldWidgets[r]&&e.session.onFoldWidgetClick(r,t),e.isFocused()||e.focus(),t.stop()}}),e.on("gutterdblclick",function(t){var n=e.renderer.$gutterLayer.getRegion(t);if(n=="foldWidgets"){var r=t.getDocumentPosition().row,i=e.session,s=i.getParentFoldRangeData(r,!0),o=s.range||s.firstRange;if(o){r=o.start.row;var u=i.getFoldAt(r,i.getLine(r).length,1);u?i.removeFold(u):(i.addFold("...",o),e.renderer.scrollCursorIntoView({row:o.start.row,column:0}))}t.stop()}})}return e}();t.FoldHandler=i}),define("ace/keyboard/keybinding",["require","exports","module","ace/lib/keys","ace/lib/event"],function(e,t,n){"use strict";var r=e("../lib/keys"),i=e("../lib/event"),s=function(){function e(e){this.$editor=e,this.$data={editor:e},this.$handlers=[],this.setDefaultHandler(e.commands)}return e.prototype.setDefaultHandler=function(e){this.removeKeyboardHandler(this.$defaultHandler),this.$defaultHandler=e,this.addKeyboardHandler(e,0)},e.prototype.setKeyboardHandler=function(e){var t=this.$handlers;if(t[t.length-1]==e)return;while(t[t.length-1]&&t[t.length-1]!=this.$defaultHandler)this.removeKeyboardHandler(t[t.length-1]);this.addKeyboardHandler(e,1)},e.prototype.addKeyboardHandler=function(e,t){if(!e)return;typeof e=="function"&&!e.handleKeyboard&&(e.handleKeyboard=e);var n=this.$handlers.indexOf(e);n!=-1&&this.$handlers.splice(n,1),t==undefined?this.$handlers.push(e):this.$handlers.splice(t,0,e),n==-1&&e.attach&&e.attach(this.$editor)},e.prototype.removeKeyboardHandler=function(e){var t=this.$handlers.indexOf(e);return t==-1?!1:(this.$handlers.splice(t,1),e.detach&&e.detach(this.$editor),!0)},e.prototype.getKeyboardHandler=function(){return this.$handlers[this.$handlers.length-1]},e.prototype.getStatusText=function(){var e=this.$data,t=e.editor;return this.$handlers.map(function(n){return n.getStatusText&&n.getStatusText(t,e)||""}).filter(Boolean).join(" ")},e.prototype.$callKeyboardHandlers=function(e,t,n,r){var s,o=!1,u=this.$editor.commands;for(var a=this.$handlers.length;a--;){s=this.$handlers[a].handleKeyboard(this.$data,e,t,n,r);if(!s||!s.command)continue;s.command=="null"?o=!0:o=u.exec(s.command,this.$editor,s.args,r),o&&r&&e!=-1&&s["passEvent"]!=1&&s.command["passEvent"]!=1&&i.stopEvent(r);if(o)break}return!o&&e==-1&&(s={command:"insertstring"},o=u.exec("insertstring",this.$editor,t)),o&&this.$editor._signal&&this.$editor._signal("keyboardActivity",s),o},e.prototype.onCommandKey=function(e,t,n){var i=r.keyCodeToString(n);return this.$callKeyboardHandlers(t,i,n,e)},e.prototype.onTextInput=function(e){return this.$callKeyboardHandlers(-1,e)},e}();t.KeyBinding=s}),define("ace/lib/bidiutil",["require","exports","module"],function(e,t,n){"use strict";function F(e,t,n,r){var i=s?d:p,c=null,h=null,v=null,m=0,g=null,y=null,b=-1,w=null,E=null,T=[];if(!r)for(w=0,r=[];w<n;w++)r[w]=R(e[w]);o=s,u=!1,a=!1,f=!1,l=!1;for(E=0;E<n;E++){c=m,T[E]=h=q(e,r,T,E),m=i[c][h],g=m&240,m&=15,t[E]=v=i[m][5];if(g>0)if(g==16){for(w=b;w<E;w++)t[w]=1;b=-1}else b=-1;y=i[m][6];if(y)b==-1&&(b=E);else if(b>-1){for(w=b;w<E;w++)t[w]=v;b=-1}r[E]==S&&(t[E]=0),o|=v}if(l)for(w=0;w<n;w++)if(r[w]==x){t[w]=s;for(var C=w-1;C>=0;C--){if(r[C]!=N)break;t[C]=s}}}function I(e,t,n){if(o<e)return;if(e==1&&s==m&&!f){n.reverse();return}var r=n.length,i=0,u,a,l,c;while(i<r){if(t[i]>=e){u=i+1;while(u<r&&t[u]>=e)u++;for(a=i,l=u-1;a<l;a++,l--)c=n[a],n[a]=n[l],n[l]=c;i=u}i++}}function q(e,t,n,r){var i=t[r],o,c,h,p;switch(i){case g:case y:u=!1;case E:case w:return i;case b:return u?w:b;case T:return u=!0,a=!0,y;case N:return E;case C:if(r<1||r+1>=t.length||(o=n[r-1])!=b&&o!=w||(c=t[r+1])!=b&&c!=w)return E;return u&&(c=w),c==o?c:E;case k:o=r>0?n[r-1]:S;if(o==b&&r+1<t.length&&t[r+1]==b)return b;return E;case L:if(r>0&&n[r-1]==b)return b;if(u)return E;p=r+1,h=t.length;while(p<h&&t[p]==L)p++;if(p<h&&t[p]==b)return b;return E;case A:h=t.length,p=r+1;while(p<h&&t[p]==A)p++;if(p<h){var d=e[r],v=d>=1425&&d<=2303||d==64286;o=t[p];if(v&&(o==y||o==T))return y}if(r<1||(o=t[r-1])==S)return E;return n[r-1];case S:return u=!1,f=!0,s;case x:return l=!0,E;case O:case M:case D:case P:case _:u=!1;case H:return E}}function R(e){var t=e.charCodeAt(0),n=t>>8;return n==0?t>191?g:B[t]:n==5?/[\u0591-\u05f4]/.test(e)?y:g:n==6?/[\u0610-\u061a\u064b-\u065f\u06d6-\u06e4\u06e7-\u06ed]/.test(e)?A:/[\u0660-\u0669\u066b-\u066c]/.test(e)?w:t==1642?L:/[\u06f0-\u06f9]/.test(e)?b:T:n==32&&t<=8287?j[t&255]:n==254?t>=65136?T:E:E}function U(e){return e>="\u064b"&&e<="\u0655"}var r=["\u0621","\u0641"],i=["\u063a","\u064a"],s=0,o=0,u=!1,a=!1,f=!1,l=!1,c=!1,h=!1,p=[[0,3,0,1,0,0,0],[0,3,0,1,2,2,0],[0,3,0,17,2,0,1],[0,3,5,5,4,1,0],[0,3,21,21,4,0,1],[0,3,5,5,4,2,0]],d=[[2,0,1,1,0,1,0],[2,0,1,1,0,2,0],[2,0,2,1,3,2,0],[2,0,2,33,3,1,1]],v=0,m=1,g=0,y=1,b=2,w=3,E=4,S=5,x=6,T=7,N=8,C=9,k=10,L=11,A=12,O=13,M=14,_=15,D=16,P=17,H=18,B=[H,H,H,H,H,H,H,H,H,x,S,x,N,S,H,H,H,H,H,H,H,H,H,H,H,H,H,H,S,S,S,x,N,E,E,L,L,L,E,E,E,E,E,k,C,k,C,C,b,b,b,b,b,b,b,b,b,b,C,E,E,E,E,E,E,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,E,E,E,E,E,E,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,g,E,E,E,E,H,H,H,H,H,H,S,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,H,C,E,L,L,L,L,E,E,E,E,g,E,E,H,E,E,L,L,b,b,E,g,E,E,E,b,g,E,E,E,E,E],j=[N,N,N,N,N,N,N,N,N,N,N,H,H,H,g,y,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,N,S,O,M,_,D,P,C,L,L,L,L,L,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,C,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,E,N];t.L=g,t.R=y,t.EN=b,t.ON_R=3,t.AN=4,t.R_H=5,t.B=6,t.RLE=7,t.DOT="\u00b7",t.doBidiReorder=function(e,n,r){if(e.length<2)return{};var i=e.split(""),o=new Array(i.length),u=new Array(i.length),a=[];s=r?m:v,F(i,a,i.length,n);for(var f=0;f<o.length;o[f]=f,f++);I(2,a,o),I(1,a,o);for(var f=0;f<o.length-1;f++)n[f]===w?a[f]=t.AN:a[f]===y&&(n[f]>T&&n[f]<O||n[f]===E||n[f]===H)?a[f]=t.ON_R:f>0&&i[f-1]==="\u0644"&&/\u0622|\u0623|\u0625|\u0627/.test(i[f])&&(a[f-1]=a[f]=t.R_H,f++);i[i.length-1]===t.DOT&&(a[i.length-1]=t.B),i[0]==="\u202b"&&(a[0]=t.RLE);for(var f=0;f<o.length;f++)u[f]=a[o[f]];return{logicalFromVisual:o,bidiLevels:u}},t.hasBidiCharacters=function(e,t){var n=!1;for(var r=0;r<e.length;r++)t[r]=R(e.charAt(r)),!n&&(t[r]==y||t[r]==T||t[r]==w)&&(n=!0);return n},t.getVisualFromLogicalIdx=function(e,t){for(var n=0;n<t.logicalFromVisual.length;n++)if(t.logicalFromVisual[n]==e)return n;return 0}}),define("ace/bidihandler",["require","exports","module","ace/lib/bidiutil","ace/lib/lang"],function(e,t,n){"use strict";var r=e("./lib/bidiutil"),i=e("./lib/lang"),s=/[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\u202B]/,o=function(){function e(e){this.session=e,this.bidiMap={},this.currentRow=null,this.bidiUtil=r,this.charWidths=[],this.EOL="\u00ac",this.showInvisibles=!0,this.isRtlDir=!1,this.$isRtl=!1,this.line="",this.wrapIndent=0,this.EOF="\u00b6",this.RLE="\u202b",this.contentWidth=0,this.fontMetrics=null,this.rtlLineOffset=0,this.wrapOffset=0,this.isMoveLeftOperation=!1,this.seenBidi=s.test(e.getValue())}return e.prototype.isBidiRow=function(e,t,n){return this.seenBidi?(e!==this.currentRow&&(this.currentRow=e,this.updateRowLine(t,n),this.updateBidiMap()),this.bidiMap.bidiLevels):!1},e.prototype.onChange=function(e){this.seenBidi?this.currentRow=null:e.action=="insert"&&s.test(e.lines.join("\n"))&&(this.seenBidi=!0,this.currentRow=null)},e.prototype.getDocumentRow=function(){var e=0,t=this.session.$screenRowCache;if(t.length){var n=this.session.$getRowCacheIndex(t,this.currentRow);n>=0&&(e=this.session.$docRowCache[n])}return e},e.prototype.getSplitIndex=function(){var e=0,t=this.session.$screenRowCache;if(t.length){var n,r=this.session.$getRowCacheIndex(t,this.currentRow);while(this.currentRow-e>0){n=this.session.$getRowCacheIndex(t,this.currentRow-e-1);if(n!==r)break;r=n,e++}}else e=this.currentRow;return e},e.prototype.updateRowLine=function(e,t){e===undefined&&(e=this.getDocumentRow());var n=e===this.session.getLength()-1,s=n?this.EOF:this.EOL;this.wrapIndent=0,this.line=this.session.getLine(e),this.isRtlDir=this.$isRtl||this.line.charAt(0)===this.RLE;if(this.session.$useWrapMode){var o=this.session.$wrapData[e];o&&(t===undefined&&(t=this.getSplitIndex()),t>0&&o.length?(this.wrapIndent=o.indent,this.wrapOffset=this.wrapIndent*this.charWidths[r.L],this.line=t<o.length?this.line.substring(o[t-1],o[t]):this.line.substring(o[o.length-1])):this.line=this.line.substring(0,o[t]),t==o.length&&(this.line+=this.showInvisibles?s:r.DOT))}else this.line+=this.showInvisibles?s:r.DOT;var u=this.session,a=0,f;this.line=this.line.replace(/\t|[\u1100-\u2029, \u202F-\uFFE6]/g,function(e,t){return e==="	"||u.isFullWidth(e.charCodeAt(0))?(f=e==="	"?u.getScreenTabSize(t+a):2,a+=f-1,i.stringRepeat(r.DOT,f)):e}),this.isRtlDir&&(this.fontMetrics.$main.textContent=this.line.charAt(this.line.length-1)==r.DOT?this.line.substr(0,this.line.length-1):this.line,this.rtlLineOffset=this.contentWidth-this.fontMetrics.$main.getBoundingClientRect().width)},e.prototype.updateBidiMap=function(){var e=[];r.hasBidiCharacters(this.line,e)||this.isRtlDir?this.bidiMap=r.doBidiReorder(this.line,e,this.isRtlDir):this.bidiMap={}},e.prototype.markAsDirty=function(){this.currentRow=null},e.prototype.updateCharacterWidths=function(e){if(this.characterWidth===e.$characterSize.width)return;this.fontMetrics=e;var t=this.characterWidth=e.$characterSize.width,n=e.$measureCharWidth("\u05d4");this.charWidths[r.L]=this.charWidths[r.EN]=this.charWidths[r.ON_R]=t,this.charWidths[r.R]=this.charWidths[r.AN]=n,this.charWidths[r.R_H]=n*.45,this.charWidths[r.B]=this.charWidths[r.RLE]=0,this.currentRow=null},e.prototype.setShowInvisibles=function(e){this.showInvisibles=e,this.currentRow=null},e.prototype.setEolChar=function(e){this.EOL=e},e.prototype.setContentWidth=function(e){this.contentWidth=e},e.prototype.isRtlLine=function(e){return this.$isRtl?!0:e!=undefined?this.session.getLine(e).charAt(0)==this.RLE:this.isRtlDir},e.prototype.setRtlDirection=function(e,t){var n=e.getCursorPosition();for(var r=e.selection.getSelectionAnchor().row;r<=n.row;r++)!t&&e.session.getLine(r).charAt(0)===e.session.$bidiHandler.RLE?e.session.doc.removeInLine(r,0,1):t&&e.session.getLine(r).charAt(0)!==e.session.$bidiHandler.RLE&&e.session.doc.insert({column:0,row:r},e.session.$bidiHandler.RLE)},e.prototype.getPosLeft=function(e){e-=this.wrapIndent;var t=this.line.charAt(0)===this.RLE?1:0,n=e>t?this.session.getOverwrite()?e:e-1:t,i=r.getVisualFromLogicalIdx(n,this.bidiMap),s=this.bidiMap.bidiLevels,o=0;!this.session.getOverwrite()&&e<=t&&s[i]%2!==0&&i++;for(var u=0;u<i;u++)o+=this.charWidths[s[u]];return!this.session.getOverwrite()&&e>t&&s[i]%2===0&&(o+=this.charWidths[s[i]]),this.wrapIndent&&(o+=this.isRtlDir?-1*this.wrapOffset:this.wrapOffset),this.isRtlDir&&(o+=this.rtlLineOffset),o},e.prototype.getSelections=function(e,t){var n=this.bidiMap,r=n.bidiLevels,i,s=[],o=0,u=Math.min(e,t)-this.wrapIndent,a=Math.max(e,t)-this.wrapIndent,f=!1,l=!1,c=0;this.wrapIndent&&(o+=this.isRtlDir?-1*this.wrapOffset:this.wrapOffset);for(var h,p=0;p<r.length;p++)h=n.logicalFromVisual[p],i=r[p],f=h>=u&&h<a,f&&!l?c=o:!f&&l&&s.push({left:c,width:o-c}),o+=this.charWidths[i],l=f;f&&p===r.length&&s.push({left:c,width:o-c});if(this.isRtlDir)for(var d=0;d<s.length;d++)s[d].left+=this.rtlLineOffset;return s},e.prototype.offsetToCol=function(e){this.isRtlDir&&(e-=this.rtlLineOffset);var t=0,e=Math.max(e,0),n=0,r=0,i=this.bidiMap.bidiLevels,s=this.charWidths[i[r]];this.wrapIndent&&(e-=this.isRtlDir?-1*this.wrapOffset:this.wrapOffset);while(e>n+s/2){n+=s;if(r===i.length-1){s=0;break}s=this.charWidths[i[++r]]}return r>0&&i[r-1]%2!==0&&i[r]%2===0?(e<n&&r--,t=this.bidiMap.logicalFromVisual[r]):r>0&&i[r-1]%2===0&&i[r]%2!==0?t=1+(e>n?this.bidiMap.logicalFromVisual[r]:this.bidiMap.logicalFromVisual[r-1]):this.isRtlDir&&r===i.length-1&&s===0&&i[r-1]%2===0||!this.isRtlDir&&r===0&&i[r]%2!==0?t=1+this.bidiMap.logicalFromVisual[r]:(r>0&&i[r-1]%2!==0&&s!==0&&r--,t=this.bidiMap.logicalFromVisual[r]),t===0&&this.isRtlDir&&t++,t+this.wrapIndent},e}();t.BidiHandler=o}),define("ace/selection",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/lib/event_emitter","ace/range"],function(e,t,n){"use strict";var r=e("./lib/oop"),i=e("./lib/lang"),s=e("./lib/event_emitter").EventEmitter,o=e("./range").Range,u=function(){function e(e){this.session=e,this.doc=e.getDocument(),this.clearSelection(),this.cursor=this.lead=this.doc.createAnchor(0,0),this.anchor=this.doc.createAnchor(0,0),this.$silent=!1;var t=this;this.cursor.on("change",function(e){t.$cursorChanged=!0,t.$silent||t._emit("changeCursor"),!t.$isEmpty&&!t.$silent&&t._emit("changeSelection"),!t.$keepDesiredColumnOnChange&&e.old.column!=e.value.column&&(t.$desiredColumn=null)}),this.anchor.on("change",function(){t.$anchorChanged=!0,!t.$isEmpty&&!t.$silent&&t._emit("changeSelection")})}return e.prototype.isEmpty=function(){return this.$isEmpty||this.anchor.row==this.lead.row&&this.anchor.column==this.lead.column},e.prototype.isMultiLine=function(){return!this.$isEmpty&&this.anchor.row!=this.cursor.row},e.prototype.getCursor=function(){return this.lead.getPosition()},e.prototype.setAnchor=function(e,t){this.$isEmpty=!1,this.anchor.setPosition(e,t)},e.prototype.getAnchor=function(){return this.$isEmpty?this.getSelectionLead():this.anchor.getPosition()},e.prototype.getSelectionLead=function(){return this.lead.getPosition()},e.prototype.isBackwards=function(){var e=this.anchor,t=this.lead;return e.row>t.row||e.row==t.row&&e.column>t.column},e.prototype.getRange=function(){var e=this.anchor,t=this.lead;return this.$isEmpty?o.fromPoints(t,t):this.isBackwards()?o.fromPoints(t,e):o.fromPoints(e,t)},e.prototype.clearSelection=function(){this.$isEmpty||(this.$isEmpty=!0,this._emit("changeSelection"))},e.prototype.selectAll=function(){this.$setSelection(0,0,Number.MAX_VALUE,Number.MAX_VALUE)},e.prototype.setRange=function(e,t){var n=t?e.end:e.start,r=t?e.start:e.end;this.$setSelection(n.row,n.column,r.row,r.column)},e.prototype.$setSelection=function(e,t,n,r){if(this.$silent)return;var i=this.$isEmpty,s=this.inMultiSelectMode;this.$silent=!0,this.$cursorChanged=this.$anchorChanged=!1,this.anchor.setPosition(e,t),this.cursor.setPosition(n,r),this.$isEmpty=!o.comparePoints(this.anchor,this.cursor),this.$silent=!1,this.$cursorChanged&&this._emit("changeCursor"),(this.$cursorChanged||this.$anchorChanged||i!=this.$isEmpty||s)&&this._emit("changeSelection")},e.prototype.$moveSelection=function(e){var t=this.lead;this.$isEmpty&&this.setSelectionAnchor(t.row,t.column),e.call(this)},e.prototype.selectTo=function(e,t){this.$moveSelection(function(){this.moveCursorTo(e,t)})},e.prototype.selectToPosition=function(e){this.$moveSelection(function(){this.moveCursorToPosition(e)})},e.prototype.moveTo=function(e,t){this.clearSelection(),this.moveCursorTo(e,t)},e.prototype.moveToPosition=function(e){this.clearSelection(),this.moveCursorToPosition(e)},e.prototype.selectUp=function(){this.$moveSelection(this.moveCursorUp)},e.prototype.selectDown=function(){this.$moveSelection(this.moveCursorDown)},e.prototype.selectRight=function(){this.$moveSelection(this.moveCursorRight)},e.prototype.selectLeft=function(){this.$moveSelection(this.moveCursorLeft)},e.prototype.selectLineStart=function(){this.$moveSelection(this.moveCursorLineStart)},e.prototype.selectLineEnd=function(){this.$moveSelection(this.moveCursorLineEnd)},e.prototype.selectFileEnd=function(){this.$moveSelection(this.moveCursorFileEnd)},e.prototype.selectFileStart=function(){this.$moveSelection(this.moveCursorFileStart)},e.prototype.selectWordRight=function(){this.$moveSelection(this.moveCursorWordRight)},e.prototype.selectWordLeft=function(){this.$moveSelection(this.moveCursorWordLeft)},e.prototype.getWordRange=function(e,t){if(typeof t=="undefined"){var n=e||this.lead;e=n.row,t=n.column}return this.session.getWordRange(e,t)},e.prototype.selectWord=function(){this.setSelectionRange(this.getWordRange())},e.prototype.selectAWord=function(){var e=this.getCursor(),t=this.session.getAWordRange(e.row,e.column);this.setSelectionRange(t)},e.prototype.getLineRange=function(e,t){var n=typeof e=="number"?e:this.lead.row,r,i=this.session.getFoldLine(n);return i?(n=i.start.row,r=i.end.row):r=n,t===!0?new o(n,0,r,this.session.getLine(r).length):new o(n,0,r+1,0)},e.prototype.selectLine=function(){this.setSelectionRange(this.getLineRange())},e.prototype.moveCursorUp=function(){this.moveCursorBy(-1,0)},e.prototype.moveCursorDown=function(){this.moveCursorBy(1,0)},e.prototype.wouldMoveIntoSoftTab=function(e,t,n){var r=e.column,i=e.column+t;return n<0&&(r=e.column-t,i=e.column),this.session.isTabStop(e)&&this.doc.getLine(e.row).slice(r,i).split(" ").length-1==t},e.prototype.moveCursorLeft=function(){var e=this.lead.getPosition(),t;if(t=this.session.getFoldAt(e.row,e.column,-1))this.moveCursorTo(t.start.row,t.start.column);else if(e.column===0)e.row>0&&this.moveCursorTo(e.row-1,this.doc.getLine(e.row-1).length);else{var n=this.session.getTabSize();this.wouldMoveIntoSoftTab(e,n,-1)&&!this.session.getNavigateWithinSoftTabs()?this.moveCursorBy(0,-n):this.moveCursorBy(0,-1)}},e.prototype.moveCursorRight=function(){var e=this.lead.getPosition(),t;if(t=this.session.getFoldAt(e.row,e.column,1))this.moveCursorTo(t.end.row,t.end.column);else if(this.lead.column==this.doc.getLine(this.lead.row).length)this.lead.row<this.doc.getLength()-1&&this.moveCursorTo(this.lead.row+1,0);else{var n=this.session.getTabSize(),e=this.lead;this.wouldMoveIntoSoftTab(e,n,1)&&!this.session.getNavigateWithinSoftTabs()?this.moveCursorBy(0,n):this.moveCursorBy(0,1)}},e.prototype.moveCursorLineStart=function(){var e=this.lead.row,t=this.lead.column,n=this.session.documentToScreenRow(e,t),r=this.session.screenToDocumentPosition(n,0),i=this.session.getDisplayLine(e,null,r.row,r.column),s=i.match(/^\s*/);s[0].length!=t&&!this.session.$useEmacsStyleLineStart&&(r.column+=s[0].length),this.moveCursorToPosition(r)},e.prototype.moveCursorLineEnd=function(){var e=this.lead,t=this.session.getDocumentLastRowColumnPosition(e.row,e.column);if(this.lead.column==t.column){var n=this.session.getLine(t.row);if(t.column==n.length){var r=n.search(/\s+$/);r>0&&(t.column=r)}}this.moveCursorTo(t.row,t.column)},e.prototype.moveCursorFileEnd=function(){var e=this.doc.getLength()-1,t=this.doc.getLine(e).length;this.moveCursorTo(e,t)},e.prototype.moveCursorFileStart=function(){this.moveCursorTo(0,0)},e.prototype.moveCursorLongWordRight=function(){var e=this.lead.row,t=this.lead.column,n=this.doc.getLine(e),r=n.substring(t);this.session.nonTokenRe.lastIndex=0,this.session.tokenRe.lastIndex=0;var i=this.session.getFoldAt(e,t,1);if(i){this.moveCursorTo(i.end.row,i.end.column);return}this.session.nonTokenRe.exec(r)&&(t+=this.session.nonTokenRe.lastIndex,this.session.nonTokenRe.lastIndex=0,r=n.substring(t));if(t>=n.length){this.moveCursorTo(e,n.length),this.moveCursorRight(),e<this.doc.getLength()-1&&this.moveCursorWordRight();return}this.session.tokenRe.exec(r)&&(t+=this.session.tokenRe.lastIndex,this.session.tokenRe.lastIndex=0),this.moveCursorTo(e,t)},e.prototype.moveCursorLongWordLeft=function(){var e=this.lead.row,t=this.lead.column,n;if(n=this.session.getFoldAt(e,t,-1)){this.moveCursorTo(n.start.row,n.start.column);return}var r=this.session.getFoldStringAt(e,t,-1);r==null&&(r=this.doc.getLine(e).substring(0,t));var s=i.stringReverse(r);this.session.nonTokenRe.lastIndex=0,this.session.tokenRe.lastIndex=0,this.session.nonTokenRe.exec(s)&&(t-=this.session.nonTokenRe.lastIndex,s=s.slice(this.session.nonTokenRe.lastIndex),this.session.nonTokenRe.lastIndex=0);if(t<=0){this.moveCursorTo(e,0),this.moveCursorLeft(),e>0&&this.moveCursorWordLeft();return}this.session.tokenRe.exec(s)&&(t-=this.session.tokenRe.lastIndex,this.session.tokenRe.lastIndex=0),this.moveCursorTo(e,t)},e.prototype.$shortWordEndIndex=function(e){var t=0,n,r=/\s/,i=this.session.tokenRe;i.lastIndex=0;if(this.session.tokenRe.exec(e))t=this.session.tokenRe.lastIndex;else{while((n=e[t])&&r.test(n))t++;if(t<1){i.lastIndex=0;while((n=e[t])&&!i.test(n)){i.lastIndex=0,t++;if(r.test(n)){if(t>2){t--;break}while((n=e[t])&&r.test(n))t++;if(t>2)break}}}}return i.lastIndex=0,t},e.prototype.moveCursorShortWordRight=function(){var e=this.lead.row,t=this.lead.column,n=this.doc.getLine(e),r=n.substring(t),i=this.session.getFoldAt(e,t,1);if(i)return this.moveCursorTo(i.end.row,i.end.column);if(t==n.length){var s=this.doc.getLength();do e++,r=this.doc.getLine(e);while(e<s&&/^\s*$/.test(r));/^\s+/.test(r)||(r=""),t=0}var o=this.$shortWordEndIndex(r);this.moveCursorTo(e,t+o)},e.prototype.moveCursorShortWordLeft=function(){var e=this.lead.row,t=this.lead.column,n;if(n=this.session.getFoldAt(e,t,-1))return this.moveCursorTo(n.start.row,n.start.column);var r=this.session.getLine(e).substring(0,t);if(t===0){do e--,r=this.doc.getLine(e);while(e>0&&/^\s*$/.test(r));t=r.length,/\s+$/.test(r)||(r="")}var s=i.stringReverse(r),o=this.$shortWordEndIndex(s);return this.moveCursorTo(e,t-o)},e.prototype.moveCursorWordRight=function(){this.session.$selectLongWords?this.moveCursorLongWordRight():this.moveCursorShortWordRight()},e.prototype.moveCursorWordLeft=function(){this.session.$selectLongWords?this.moveCursorLongWordLeft():this.moveCursorShortWordLeft()},e.prototype.moveCursorBy=function(e,t){var n=this.session.documentToScreenPosition(this.lead.row,this.lead.column),r;t===0&&(e!==0&&(this.session.$bidiHandler.isBidiRow(n.row,this.lead.row)?(r=this.session.$bidiHandler.getPosLeft(n.column),n.column=Math.round(r/this.session.$bidiHandler.charWidths[0])):r=n.column*this.session.$bidiHandler.charWidths[0]),this.$desiredColumn?n.column=this.$desiredColumn:this.$desiredColumn=n.column);if(e!=0&&this.session.lineWidgets&&this.session.lineWidgets[this.lead.row]){var i=this.session.lineWidgets[this.lead.row];e<0?e-=i.rowsAbove||0:e>0&&(e+=i.rowCount-(i.rowsAbove||0))}var s=this.session.screenToDocumentPosition(n.row+e,n.column,r);e!==0&&t===0&&s.row===this.lead.row&&s.column===this.lead.column,this.moveCursorTo(s.row,s.column+t,t===0)},e.prototype.moveCursorToPosition=function(e){this.moveCursorTo(e.row,e.column)},e.prototype.moveCursorTo=function(e,t,n){var r=this.session.getFoldAt(e,t,1);r&&(e=r.start.row,t=r.start.column),this.$keepDesiredColumnOnChange=!0;var i=this.session.getLine(e);/[\uDC00-\uDFFF]/.test(i.charAt(t))&&i.charAt(t-1)&&(this.lead.row==e&&this.lead.column==t+1?t-=1:t+=1),this.lead.setPosition(e,t),this.$keepDesiredColumnOnChange=!1,n||(this.$desiredColumn=null)},e.prototype.moveCursorToScreen=function(e,t,n){var r=this.session.screenToDocumentPosition(e,t);this.moveCursorTo(r.row,r.column,n)},e.prototype.detach=function(){this.lead.detach(),this.anchor.detach()},e.prototype.fromOrientedRange=function(e){this.setSelectionRange(e,e.cursor==e.start),this.$desiredColumn=e.desiredColumn||this.$desiredColumn},e.prototype.toOrientedRange=function(e){var t=this.getRange();return e?(e.start.column=t.start.column,e.start.row=t.start.row,e.end.column=t.end.column,e.end.row=t.end.row):e=t,e.cursor=this.isBackwards()?e.start:e.end,e.desiredColumn=this.$desiredColumn,e},e.prototype.getRangeOfMovements=function(e){var t=this.getCursor();try{e(this);var n=this.getCursor();return o.fromPoints(t,n)}catch(r){return o.fromPoints(t,t)}finally{this.moveCursorToPosition(t)}},e.prototype.toJSON=function(){if(this.rangeCount)var e=this.ranges.map(function(e){var t=e.clone();return t.isBackwards=e.cursor==e.start,t});else{var e=this.getRange();e.isBackwards=this.isBackwards()}return e},e.prototype.fromJSON=function(e){if(e.start==undefined){if(this.rangeList&&e.length>1){this.toSingleRange(e[0]);for(var t=e.length;t--;){var n=o.fromPoints(e[t].start,e[t].end);e[t].isBackwards&&(n.cursor=n.start),this.addRange(n,!0)}return}e=e[0]}this.rangeList&&this.toSingleRange(e),this.setSelectionRange(e,e.isBackwards)},e.prototype.isEqual=function(e){if((e.length||this.rangeCount)&&e.length!=this.rangeCount)return!1;if(!e.length||!this.ranges)return this.getRange().isEqual(e);for(var t=this.ranges.length;t--;)if(!this.ranges[t].isEqual(e[t]))return!1;return!0},e}();u.prototype.setSelectionAnchor=u.prototype.setAnchor,u.prototype.getSelectionAnchor=u.prototype.getAnchor,u.prototype.setSelectionRange=u.prototype.setRange,r.implement(u.prototype,s),t.Selection=u}),define("ace/tokenizer",["require","exports","module","ace/lib/report_error"],function(e,t,n){"use strict";var r=e("./lib/report_error").reportError,i=2e3,s=function(){function e(e){this.splitRegex,this.states=e,this.regExps={},this.matchMappings={};for(var t in this.states){var n=this.states[t],r=[],i=0,s=this.matchMappings[t]={defaultToken:"text"},o="g",u=[];for(var a=0;a<n.length;a++){var f=n[a];f.defaultToken&&(s.defaultToken=f.defaultToken),f.caseInsensitive&&o.indexOf("i")===-1&&(o+="i"),f.unicode&&o.indexOf("u")===-1&&(o+="u");if(f.regex==null)continue;f.regex instanceof RegExp&&(f.regex=f.regex.toString().slice(1,-1));var l=f.regex,c=(new RegExp("(?:("+l+")|(.))")).exec("a").length-2;Array.isArray(f.token)?f.token.length==1||c==1?f.token=f.token[0]:c-1!=f.token.length?(this.reportError("number of classes and regexp groups doesn't match",{rule:f,groupCount:c-1}),f.token=f.token[0]):(f.tokenArray=f.token,f.token=null,f.onMatch=this.$arrayTokens):typeof f.token=="function"&&!f.onMatch&&(c>1?f.onMatch=this.$applyToken:f.onMatch=f.token),c>1&&(/\\\d/.test(f.regex)?l=f.regex.replace(/\\([0-9]+)/g,function(e,t){return"\\"+(parseInt(t,10)+i+1)}):(c=1,l=this.removeCapturingGroups(f.regex)),!f.splitRegex&&typeof f.token!="string"&&u.push(f)),s[i]=a,i+=c,r.push(l),f.onMatch||(f.onMatch=null)}r.length||(s[0]=0,r.push("$")),u.forEach(function(e){e.splitRegex=this.createSplitterRegexp(e.regex,o)},this),this.regExps[t]=new RegExp("("+r.join(")|(")+")|($)",o)}}return e.prototype.$setMaxTokenCount=function(e){i=e|0},e.prototype.$applyToken=function(e){var t=this.splitRegex.exec(e).slice(1),n=this.token.apply(this,t);if(typeof n=="string")return[{type:n,value:e}];var r=[];for(var i=0,s=n.length;i<s;i++)t[i]&&(r[r.length]={type:n[i],value:t[i]});return r},e.prototype.$arrayTokens=function(e){if(!e)return[];var t=this.splitRegex.exec(e);if(!t)return"text";var n=[],r=this.tokenArray;for(var i=0,s=r.length;i<s;i++)t[i+1]&&(n[n.length]={type:r[i],value:t[i+1]});return n},e.prototype.removeCapturingGroups=function(e){var t=e.replace(/\\.|\[(?:\\.|[^\\\]])*|\(\?[:=!<]|(\()/g,function(e,t){return t?"(?:":e});return t},e.prototype.createSplitterRegexp=function(e,t){if(e.indexOf("(?=")!=-1){var n=0,r=!1,i={};e.replace(/(\\.)|(\((?:\?[=!])?)|(\))|([\[\]])/g,function(e,t,s,o,u,a){return r?r=u!="]":u?r=!0:o?(n==i.stack&&(i.end=a+1,i.stack=-1),n--):s&&(n++,s.length!=1&&(i.stack=n,i.start=a)),e}),i.end!=null&&/^\)*$/.test(e.substr(i.end))&&(e=e.substring(0,i.start)+e.substr(i.end))}return e.charAt(0)!="^"&&(e="^"+e),e.charAt(e.length-1)!="$"&&(e+="$"),new RegExp(e,(t||"").replace("g",""))},e.prototype.getLineTokens=function(e,t){if(t&&typeof t!="string"){var n=t.slice(0);t=n[0],t==="#tmp"&&(n.shift(),t=n.shift())}else var n=[];var r=t||"start",s=this.states[r];s||(r="start",s=this.states[r]);var o=this.matchMappings[r],u=this.regExps[r];u.lastIndex=0;var a,f=[],l=0,c=0,h={type:null,value:""};while(a=u.exec(e)){var p=o.defaultToken,d=null,v=a[0],m=u.lastIndex;if(m-v.length>l){var g=e.substring(l,m-v.length);h.type==p?h.value+=g:(h.type&&f.push(h),h={type:p,value:g})}for(var y=0;y<a.length-2;y++){if(a[y+1]===undefined)continue;d=s[o[y]],d.onMatch?p=d.onMatch(v,r,n,e):p=d.token,d.next&&(typeof d.next=="string"?r=d.next:r=d.next(r,n),s=this.states[r],s||(this.reportError("state doesn't exist",r),r="start",s=this.states[r]),o=this.matchMappings[r],l=m,u=this.regExps[r],u.lastIndex=m),d.consumeLineEnd&&(l=m);break}if(v)if(typeof p=="string")!!d&&d.merge===!1||h.type!==p?(h.type&&f.push(h),h={type:p,value:v}):h.value+=v;else if(p){h.type&&f.push(h),h={type:null,value:""};for(var y=0;y<p.length;y++)f.push(p[y])}if(l==e.length)break;l=m;if(c++>i){c>2*e.length&&this.reportError("infinite loop with in ace tokenizer",{startState:t,line:e});while(l<e.length)h.type&&f.push(h),h={value:e.substring(l,l+=500),type:"overflow"};r="start",n=[];break}}return h.type&&f.push(h),n.length>1&&n[0]!==r&&n.unshift("#tmp",r),{tokens:f,state:n.length?n:r}},e}();s.prototype.reportError=r,t.Tokenizer=s}),define("ace/mode/text_highlight_rules",["require","exports","module","ace/lib/deep_copy"],function(e,t,n){"use strict";var r=e("../lib/deep_copy").deepCopy,i;i=function(){this.$rules={start:[{token:"empty_line",regex:"^$"},{defaultToken:"text"}]}},function(){this.addRules=function(e,t){if(!t){for(var n in e)this.$rules[n]=e[n];return}for(var n in e){var r=e[n];for(var i=0;i<r.length;i++){var s=r[i];if(s.next||s.onMatch)typeof s.next=="string"&&s.next.indexOf(t)!==0&&(s.next=t+s.next),s.nextState&&s.nextState.indexOf(t)!==0&&(s.nextState=t+s.nextState)}this.$rules[t+n]=r}},this.getRules=function(){return this.$rules},this.embedRules=function(e,t,n,i,s){var o=typeof e=="function"?(new e).getRules():e;if(i)for(var u=0;u<i.length;u++)i[u]=t+i[u];else{i=[];for(var a in o)i.push(t+a)}this.addRules(o,t);if(n){var f=Array.prototype[s?"push":"unshift"];for(var u=0;u<i.length;u++)f.apply(this.$rules[i[u]],r(n))}this.$embeds||(this.$embeds=[]),this.$embeds.push(t)},this.getEmbeds=function(){return this.$embeds};var e=function(e,t){return(e!="start"||t.length)&&t.unshift(this.nextState,e),this.nextState},t=function(e,t){return t.shift(),t.shift()||"start"};this.normalizeRules=function(){function i(s){var o=r[s];o.processed=!0;for(var u=0;u<o.length;u++){var a=o[u],f=null;Array.isArray(a)&&(f=a,a={}),!a.regex&&a.start&&(a.regex=a.start,a.next||(a.next=[]),a.next.push({defaultToken:a.token},{token:a.token+".end",regex:a.end||a.start,next:"pop"}),a.token=a.token+".start",a.push=!0);var l=a.next||a.push;if(l&&Array.isArray(l)){var c=a.stateName;c||(c=a.token,typeof c!="string"&&(c=c[0]||""),r[c]&&(c+=n++)),r[c]=l,a.next=c,i(c)}else l=="pop"&&(a.next=t);a.push&&(a.nextState=a.next||a.push,a.next=e,delete a.push);if(a.rules)for(var h in a.rules)r[h]?r[h].push&&r[h].push.apply(r[h],a.rules[h]):r[h]=a.rules[h];var p=typeof a=="string"?a:a.include;p&&(p==="$self"&&(p="start"),Array.isArray(p)?f=p.map(function(e){return r[e]}):f=r[p]);if(f){var d=[u,1].concat(f);a.noEscape&&(d=d.filter(function(e){return!e.next})),o.splice.apply(o,d),u--}a.keywordMap&&(a.token=this.createKeywordMapper(a.keywordMap,a.defaultToken||"text",a.caseInsensitive),delete a.defaultToken)}}var n=0,r=this.$rules;Object.keys(r).forEach(i,this)},this.createKeywordMapper=function(e,t,n,r){var i=Object.create(null);return this.$keywordList=[],Object.keys(e).forEach(function(t){var s=e[t],o=s.split(r||"|");for(var u=o.length;u--;){var a=o[u];this.$keywordList.push(a),n&&(a=a.toLowerCase()),i[a]=t}},this),e=null,n?function(e){return i[e.toLowerCase()]||t}:function(e){return i[e]||t}},this.getKeywords=function(){return this.$keywords}}.call(i.prototype),t.TextHighlightRules=i}),define("ace/mode/behaviour",["require","exports","module"],function(e,t,n){"use strict";var r;r=function(){this.$behaviours={}},function(){this.add=function(e,t,n){switch(undefined){case this.$behaviours:this.$behaviours={};case this.$behaviours[e]:this.$behaviours[e]={}}this.$behaviours[e][t]=n},this.addBehaviours=function(e){for(var t in e)for(var n in e[t])this.add(t,n,e[t][n])},this.remove=function(e){this.$behaviours&&this.$behaviours[e]&&delete this.$behaviours[e]},this.inherit=function(e,t){if(typeof e=="function")var n=(new e).getBehaviours(t);else var n=e.getBehaviours(t);this.addBehaviours(n)},this.getBehaviours=function(e){if(!e)return this.$behaviours;var t={};for(var n=0;n<e.length;n++)this.$behaviours[e[n]]&&(t[e[n]]=this.$behaviours[e[n]]);return t}}.call(r.prototype),t.Behaviour=r}),define("ace/token_iterator",["require","exports","module","ace/range"],function(e,t,n){"use strict";var r=e("./range").Range,i=function(){function e(e,t,n){this.$session=e,this.$row=t,this.$rowTokens=e.getTokens(t);var r=e.getTokenAt(t,n);this.$tokenIndex=r?r.index:-1}return e.prototype.stepBackward=function(){this.$tokenIndex-=1;while(this.$tokenIndex<0){this.$row-=1;if(this.$row<0)return this.$row=0,null;this.$rowTokens=this.$session.getTokens(this.$row),this.$tokenIndex=this.$rowTokens.length-1}return this.$rowTokens[this.$tokenIndex]},e.prototype.stepForward=function(){this.$tokenIndex+=1;var e;while(this.$tokenIndex>=this.$rowTokens.length){this.$row+=1,e||(e=this.$session.getLength());if(this.$row>=e)return this.$row=e-1,null;this.$rowTokens=this.$session.getTokens(this.$row),this.$tokenIndex=0}return this.$rowTokens[this.$tokenIndex]},e.prototype.getCurrentToken=function(){return this.$rowTokens[this.$tokenIndex]},e.prototype.getCurrentTokenRow=function(){return this.$row},e.prototype.getCurrentTokenColumn=function(){var e=this.$rowTokens,t=this.$tokenIndex,n=e[t].start;if(n!==undefined)return n;n=0;while(t>0)t-=1,n+=e[t].value.length;return n},e.prototype.getCurrentTokenPosition=function(){return{row:this.$row,column:this.getCurrentTokenColumn()}},e.prototype.getCurrentTokenRange=function(){var e=this.$rowTokens[this.$tokenIndex],t=this.getCurrentTokenColumn();return new r(this.$row,t,this.$row,t+e.value.length)},e}();t.TokenIterator=i}),define("ace/mode/behaviour/cstyle",["require","exports","module","ace/lib/oop","ace/mode/behaviour","ace/token_iterator","ace/lib/lang"],function(e,t,n){"use strict";var r=e("../../lib/oop"),i=e("../behaviour").Behaviour,s=e("../../token_iterator").TokenIterator,o=e("../../lib/lang"),u=["text","paren.rparen","rparen","paren","punctuation.operator"],a=["text","paren.rparen","rparen","paren","punctuation.operator","comment"],f,l={},c={'"':'"',"'":"'"},h=function(e){var t=-1;e.multiSelect&&(t=e.selection.index,l.rangeCount!=e.multiSelect.rangeCount&&(l={rangeCount:e.multiSelect.rangeCount}));if(l[t])return f=l[t];f=l[t]={autoInsertedBrackets:0,autoInsertedRow:-1,autoInsertedLineEnd:"",maybeInsertedBrackets:0,maybeInsertedRow:-1,maybeInsertedLineStart:"",maybeInsertedLineEnd:""}},p=function(e,t,n,r){var i=e.end.row-e.start.row;return{text:n+t+r,selection:[0,e.start.column+1,i,e.end.column+(i?0:1)]}},d;d=function(e){e=e||{},this.add("braces","insertion",function(t,n,r,i,s){var u=r.getCursorPosition(),a=i.doc.getLine(u.row);if(s=="{"){h(r);var l=r.getSelectionRange(),c=i.doc.getTextRange(l),v=i.getTokenAt(u.row,u.column);if(c!==""&&c!=="{"&&r.getWrapBehavioursEnabled())return p(l,c,"{","}");if(v&&/(?:string)\.quasi|\.xml/.test(v.type)){var m=[/tag\-(?:open|name)/,/attribute\-name/];if(m.some(function(e){return e.test(v.type)})||/(string)\.quasi/.test(v.type)&&v.value[u.column-v.start-1]!=="$")return;return d.recordAutoInsert(r,i,"}"),{text:"{}",selection:[1,1]}}if(d.isSaneInsertion(r,i))return/[\]\}\)]/.test(a[u.column])||r.inMultiSelectMode||e.braces?(d.recordAutoInsert(r,i,"}"),{text:"{}",selection:[1,1]}):(d.recordMaybeInsert(r,i,"{"),{text:"{",selection:[1,1]})}else if(s=="}"){h(r);var g=a.substring(u.column,u.column+1);if(g=="}"){var y=i.$findOpeningBracket("}",{column:u.column+1,row:u.row});if(y!==null&&d.isAutoInsertedClosing(u,a,s))return d.popAutoInsertedClosing(),{text:"",selection:[1,1]}}}else{if(s=="\n"||s=="\r\n"){h(r);var b="";d.isMaybeInsertedClosing(u,a)&&(b=o.stringRepeat("}",f.maybeInsertedBrackets),d.clearMaybeInsertedClosing());var g=a.substring(u.column,u.column+1);if(g==="}"){var w=i.findMatchingBracket({row:u.row,column:u.column+1},"}");if(!w)return null;var E=this.$getIndent(i.getLine(w.row))}else{if(!b){d.clearMaybeInsertedClosing();return}var E=this.$getIndent(a)}var S=E+i.getTabString();return{text:"\n"+S+"\n"+E+b,selection:[1,S.length,1,S.length]}}d.clearMaybeInsertedClosing()}}),this.add("braces","deletion",function(e,t,n,r,i){var s=r.doc.getTextRange(i);if(!i.isMultiLine()&&s=="{"){h(n);var o=r.doc.getLine(i.start.row),u=o.substring(i.end.column,i.end.column+1);if(u=="}")return i.end.column++,i;f.maybeInsertedBrackets--}}),this.add("parens","insertion",function(e,t,n,r,i){if(i=="("){h(n);var s=n.getSelectionRange(),o=r.doc.getTextRange(s);if(o!==""&&n.getWrapBehavioursEnabled())return p(s,o,"(",")");if(d.isSaneInsertion(n,r))return d.recordAutoInsert(n,r,")"),{text:"()",selection:[1,1]}}else if(i==")"){h(n);var u=n.getCursorPosition(),a=r.doc.getLine(u.row),f=a.substring(u.column,u.column+1);if(f==")"){var l=r.$findOpeningBracket(")",{column:u.column+1,row:u.row});if(l!==null&&d.isAutoInsertedClosing(u,a,i))return d.popAutoInsertedClosing(),{text:"",selection:[1,1]}}}}),this.add("parens","deletion",function(e,t,n,r,i){var s=r.doc.getTextRange(i);if(!i.isMultiLine()&&s=="("){h(n);var o=r.doc.getLine(i.start.row),u=o.substring(i.start.column+1,i.start.column+2);if(u==")")return i.end.column++,i}}),this.add("brackets","insertion",function(e,t,n,r,i){if(i=="["){h(n);var s=n.getSelectionRange(),o=r.doc.getTextRange(s);if(o!==""&&n.getWrapBehavioursEnabled())return p(s,o,"[","]");if(d.isSaneInsertion(n,r))return d.recordAutoInsert(n,r,"]"),{text:"[]",selection:[1,1]}}else if(i=="]"){h(n);var u=n.getCursorPosition(),a=r.doc.getLine(u.row),f=a.substring(u.column,u.column+1);if(f=="]"){var l=r.$findOpeningBracket("]",{column:u.column+1,row:u.row});if(l!==null&&d.isAutoInsertedClosing(u,a,i))return d.popAutoInsertedClosing(),{text:"",selection:[1,1]}}}}),this.add("brackets","deletion",function(e,t,n,r,i){var s=r.doc.getTextRange(i);if(!i.isMultiLine()&&s=="["){h(n);var o=r.doc.getLine(i.start.row),u=o.substring(i.start.column+1,i.start.column+2);if(u=="]")return i.end.column++,i}}),this.add("string_dquotes","insertion",function(e,t,n,r,i){var s=r.$mode.$quotes||c;if(i.length==1&&s[i]){if(this.lineCommentStart&&this.lineCommentStart.indexOf(i)!=-1)return;h(n);var o=i,u=n.getSelectionRange(),a=r.doc.getTextRange(u);if(a!==""&&(a.length!=1||!s[a])&&n.getWrapBehavioursEnabled())return p(u,a,o,o);if(!a){var f=n.getCursorPosition(),l=r.doc.getLine(f.row),d=l.substring(f.column-1,f.column),v=l.substring(f.column,f.column+1),m=r.getTokenAt(f.row,f.column),g=r.getTokenAt(f.row,f.column+1);if(d=="\\"&&m&&/escape/.test(m.type))return null;var y=m&&/string|escape/.test(m.type),b=!g||/string|escape/.test(g.type),w;if(v==o)w=y!==b,w&&/string\.end/.test(g.type)&&(w=!1);else{if(y&&!b)return null;if(y&&b)return null;var E=r.$mode.tokenRe;E.lastIndex=0;var S=E.test(d);E.lastIndex=0;var x=E.test(v),T=r.$mode.$pairQuotesAfter,N=T&&T[o]&&T[o].test(d);if(!N&&S||x)return null;if(v&&!/[\s;,.})\]\\]/.test(v))return null;var C=l[f.column-2];if(!(d!=o||C!=o&&!E.test(C)))return null;w=!0}return{text:w?o+o:"",selection:[1,1]}}}}),this.add("string_dquotes","deletion",function(e,t,n,r,i){var s=r.$mode.$quotes||c,o=r.doc.getTextRange(i);if(!i.isMultiLine()&&s.hasOwnProperty(o)){h(n);var u=r.doc.getLine(i.start.row),a=u.substring(i.start.column+1,i.start.column+2);if(a==o)return i.end.column++,i}}),e.closeDocComment!==!1&&this.add("doc comment end","insertion",function(e,t,n,r,i){if(e==="doc-start"&&(i==="\n"||i==="\r\n")&&n.selection.isEmpty()){var s=n.getCursorPosition();if(s.column===0)return;var o=r.doc.getLine(s.row),u=r.doc.getLine(s.row+1),a=r.getTokens(s.row),f=0;for(var l=0;l<a.length;l++){f+=a[l].value.length;var c=a[l];if(f>=s.column){if(f===s.column){if(!/\.doc/.test(c.type))return;if(/\*\//.test(c.value)){var h=a[l+1];if(!h||!/\.doc/.test(h.type))return}}var p=s.column-(f-c.value.length),d=c.value.indexOf("*/"),v=c.value.indexOf("/**",d>-1?d+2:0);if(v!==-1&&p>v&&p<v+3)return;if(d!==-1&&v!==-1&&p>=d&&p<=v||!/\.doc/.test(c.type))return;break}}var m=this.$getIndent(o);if(/\s*\*/.test(u))return/^\s*\*/.test(o)?{text:i+m+"* ",selection:[1,2+m.length,1,2+m.length]}:{text:i+m+" * ",selection:[1,3+m.length,1,3+m.length]};if(/\/\*\*/.test(o.substring(0,s.column)))return{text:i+m+" * "+i+" "+m+"*/",selection:[1,4+m.length,1,4+m.length]}}})},d.isSaneInsertion=function(e,t){var n=e.getCursorPosition(),r=new s(t,n.row,n.column);if(!this.$matchTokenType(r.getCurrentToken()||"text",u)){if(/[)}\]]/.test(e.session.getLine(n.row)[n.column]))return!0;var i=new s(t,n.row,n.column+1);if(!this.$matchTokenType(i.getCurrentToken()||"text",u))return!1}return r.stepForward(),r.getCurrentTokenRow()!==n.row||this.$matchTokenType(r.getCurrentToken()||"text",a)},d.$matchTokenType=function(e,t){return t.indexOf(e.type||e)>-1},d.recordAutoInsert=function(e,t,n){var r=e.getCursorPosition(),i=t.doc.getLine(r.row);this.isAutoInsertedClosing(r,i,f.autoInsertedLineEnd[0])||(f.autoInsertedBrackets=0),f.autoInsertedRow=r.row,f.autoInsertedLineEnd=n+i.substr(r.column),f.autoInsertedBrackets++},d.recordMaybeInsert=function(e,t,n){var r=e.getCursorPosition(),i=t.doc.getLine(r.row);this.isMaybeInsertedClosing(r,i)||(f.maybeInsertedBrackets=0),f.maybeInsertedRow=r.row,f.maybeInsertedLineStart=i.substr(0,r.column)+n,f.maybeInsertedLineEnd=i.substr(r.column),f.maybeInsertedBrackets++},d.isAutoInsertedClosing=function(e,t,n){return f.autoInsertedBrackets>0&&e.row===f.autoInsertedRow&&n===f.autoInsertedLineEnd[0]&&t.substr(e.column)===f.autoInsertedLineEnd},d.isMaybeInsertedClosing=function(e,t){return f.maybeInsertedBrackets>0&&e.row===f.maybeInsertedRow&&t.substr(e.column)===f.maybeInsertedLineEnd&&t.substr(0,e.column)==f.maybeInsertedLineStart},d.popAutoInsertedClosing=function(){f.autoInsertedLineEnd=f.autoInsertedLineEnd.substr(1),f.autoInsertedBrackets--},d.clearMaybeInsertedClosing=function(){f&&(f.maybeInsertedBrackets=0,f.maybeInsertedRow=-1)},r.inherits(d,i),t.CstyleBehaviour=d}),define("ace/unicode",["require","exports","module"],function(e,t,n){"use strict";var r=[48,9,8,25,5,0,2,25,48,0,11,0,5,0,6,22,2,30,2,457,5,11,15,4,8,0,2,0,18,116,2,1,3,3,9,0,2,2,2,0,2,19,2,82,2,138,2,4,3,155,12,37,3,0,8,38,10,44,2,0,2,1,2,1,2,0,9,26,6,2,30,10,7,61,2,9,5,101,2,7,3,9,2,18,3,0,17,58,3,100,15,53,5,0,6,45,211,57,3,18,2,5,3,11,3,9,2,1,7,6,2,2,2,7,3,1,3,21,2,6,2,0,4,3,3,8,3,1,3,3,9,0,5,1,2,4,3,11,16,2,2,5,5,1,3,21,2,6,2,1,2,1,2,1,3,0,2,4,5,1,3,2,4,0,8,3,2,0,8,15,12,2,2,8,2,2,2,21,2,6,2,1,2,4,3,9,2,2,2,2,3,0,16,3,3,9,18,2,2,7,3,1,3,21,2,6,2,1,2,4,3,8,3,1,3,2,9,1,5,1,2,4,3,9,2,0,17,1,2,5,4,2,2,3,4,1,2,0,2,1,4,1,4,2,4,11,5,4,4,2,2,3,3,0,7,0,15,9,18,2,2,7,2,2,2,22,2,9,2,4,4,7,2,2,2,3,8,1,2,1,7,3,3,9,19,1,2,7,2,2,2,22,2,9,2,4,3,8,2,2,2,3,8,1,8,0,2,3,3,9,19,1,2,7,2,2,2,22,2,15,4,7,2,2,2,3,10,0,9,3,3,9,11,5,3,1,2,17,4,23,2,8,2,0,3,6,4,0,5,5,2,0,2,7,19,1,14,57,6,14,2,9,40,1,2,0,3,1,2,0,3,0,7,3,2,6,2,2,2,0,2,0,3,1,2,12,2,2,3,4,2,0,2,5,3,9,3,1,35,0,24,1,7,9,12,0,2,0,2,0,5,9,2,35,5,19,2,5,5,7,2,35,10,0,58,73,7,77,3,37,11,42,2,0,4,328,2,3,3,6,2,0,2,3,3,40,2,3,3,32,2,3,3,6,2,0,2,3,3,14,2,56,2,3,3,66,5,0,33,15,17,84,13,619,3,16,2,25,6,74,22,12,2,6,12,20,12,19,13,12,2,2,2,1,13,51,3,29,4,0,5,1,3,9,34,2,3,9,7,87,9,42,6,69,11,28,4,11,5,11,11,39,3,4,12,43,5,25,7,10,38,27,5,62,2,28,3,10,7,9,14,0,89,75,5,9,18,8,13,42,4,11,71,55,9,9,4,48,83,2,2,30,14,230,23,280,3,5,3,37,3,5,3,7,2,0,2,0,2,0,2,30,3,52,2,6,2,0,4,2,2,6,4,3,3,5,5,12,6,2,2,6,67,1,20,0,29,0,14,0,17,4,60,12,5,0,4,11,18,0,5,0,3,9,2,0,4,4,7,0,2,0,2,0,2,3,2,10,3,3,6,4,5,0,53,1,2684,46,2,46,2,132,7,6,15,37,11,53,10,0,17,22,10,6,2,6,2,6,2,6,2,6,2,6,2,6,2,6,2,31,48,0,470,1,36,5,2,4,6,1,5,85,3,1,3,2,2,89,2,3,6,40,4,93,18,23,57,15,513,6581,75,20939,53,1164,68,45,3,268,4,27,21,31,3,13,13,1,2,24,9,69,11,1,38,8,3,102,3,1,111,44,25,51,13,68,12,9,7,23,4,0,5,45,3,35,13,28,4,64,15,10,39,54,10,13,3,9,7,22,4,1,5,66,25,2,227,42,2,1,3,9,7,11171,13,22,5,48,8453,301,3,61,3,105,39,6,13,4,6,11,2,12,2,4,2,0,2,1,2,1,2,107,34,362,19,63,3,53,41,11,5,15,17,6,13,1,25,2,33,4,2,134,20,9,8,25,5,0,2,25,12,88,4,5,3,5,3,5,3,2],i=0,s=[];for(var o=0;o<r.length;o+=2)s.push(i+=r[o]),r[o+1]&&s.push(45,i+=r[o+1]);t.wordChars=String.fromCharCode.apply(null,s)}),define("ace/mode/text",["require","exports","module","ace/config","ace/tokenizer","ace/mode/text_highlight_rules","ace/mode/behaviour/cstyle","ace/unicode","ace/lib/lang","ace/token_iterator","ace/range"],function(e,t,n){"use strict";var r=e("../config"),i=e("../tokenizer").Tokenizer,s=e("./text_highlight_rules").TextHighlightRules,o=e("./behaviour/cstyle").CstyleBehaviour,u=e("../unicode"),a=e("../lib/lang"),f=e("../token_iterator").TokenIterator,l=e("../range").Range,c;c=function(){this.HighlightRules=s},function(){this.$defaultBehaviour=new o,this.tokenRe=new RegExp("^["+u.wordChars+"\\$_]+","g"),this.nonTokenRe=new RegExp("^(?:[^"+u.wordChars+"\\$_]|\\s])+","g"),this.getTokenizer=function(){return this.$tokenizer||(this.$highlightRules=this.$highlightRules||new this.HighlightRules(this.$highlightRuleConfig),this.$tokenizer=new i(this.$highlightRules.getRules())),this.$tokenizer},this.lineCommentStart="",this.blockComment="",this.toggleCommentLines=function(e,t,n,r){function w(e){for(var t=n;t<=r;t++)e(i.getLine(t),t)}var i=t.doc,s=!0,o=!0,u=Infinity,f=t.getTabSize(),l=!1;if(!this.lineCommentStart){if(!this.blockComment)return!1;var c=this.blockComment.start,h=this.blockComment.end,p=new RegExp("^(\\s*)(?:"+a.escapeRegExp(c)+")"),d=new RegExp("(?:"+a.escapeRegExp(h)+")\\s*$"),v=function(e,t){if(g(e,t))return;if(!s||/\S/.test(e))i.insertInLine({row:t,column:e.length},h),i.insertInLine({row:t,column:u},c)},m=function(e,t){var n;(n=e.match(d))&&i.removeInLine(t,e.length-n[0].length,e.length),(n=e.match(p))&&i.removeInLine(t,n[1].length,n[0].length)},g=function(e,n){if(p.test(e))return!0;var r=t.getTokens(n);for(var i=0;i<r.length;i++)if(r[i].type==="comment")return!0}}else{if(Array.isArray(this.lineCommentStart))var p=this.lineCommentStart.map(a.escapeRegExp).join("|"),c=this.lineCommentStart[0];else var p=a.escapeRegExp(this.lineCommentStart),c=this.lineCommentStart;p=new RegExp("^(\\s*)(?:"+p+") ?"),l=t.getUseSoftTabs();var m=function(e,t){var n=e.match(p);if(!n)return;var r=n[1].length,s=n[0].length;!b(e,r,s)&&n[0][s-1]==" "&&s--,i.removeInLine(t,r,s)},y=c+" ",v=function(e,t){if(!s||/\S/.test(e))b(e,u,u)?i.insertInLine({row:t,column:u},y):i.insertInLine({row:t,column:u},c)},g=function(e,t){return p.test(e)},b=function(e,t,n){var r=0;while(t--&&e.charAt(t)==" ")r++;if(r%f!=0)return!1;var r=0;while(e.charAt(n++)==" ")r++;return f>2?r%f!=f-1:r%f==0}}var E=Infinity;w(function(e,t){var n=e.search(/\S/);n!==-1?(n<u&&(u=n),o&&!g(e,t)&&(o=!1)):E>e.length&&(E=e.length)}),u==Infinity&&(u=E,s=!1,o=!1),l&&u%f!=0&&(u=Math.floor(u/f)*f),w(o?m:v)},this.toggleBlockComment=function(e,t,n,r){var i=this.blockComment;if(!i)return;!i.start&&i[0]&&(i=i[0]);var s=new f(t,r.row,r.column),o=s.getCurrentToken(),u=t.selection,a=t.selection.toOrientedRange(),c,h;if(o&&/comment/.test(o.type)){var p,d;while(o&&/comment/.test(o.type)){var v=o.value.indexOf(i.start);if(v!=-1){var m=s.getCurrentTokenRow(),g=s.getCurrentTokenColumn()+v;p=new l(m,g,m,g+i.start.length);break}o=s.stepBackward()}var s=new f(t,r.row,r.column),o=s.getCurrentToken();while(o&&/comment/.test(o.type)){var v=o.value.indexOf(i.end);if(v!=-1){var m=s.getCurrentTokenRow(),g=s.getCurrentTokenColumn()+v;d=new l(m,g,m,g+i.end.length);break}o=s.stepForward()}d&&t.remove(d),p&&(t.remove(p),c=p.start.row,h=-i.start.length)}else h=i.start.length,c=n.start.row,t.insert(n.end,i.end),t.insert(n.start,i.start);a.start.row==c&&(a.start.column+=h),a.end.row==c&&(a.end.column+=h),t.selection.fromOrientedRange(a)},this.getNextLineIndent=function(e,t,n){return this.$getIndent(t)},this.checkOutdent=function(e,t,n){return!1},this.autoOutdent=function(e,t,n){},this.$getIndent=function(e){return e.match(/^\s*/)[0]},this.createWorker=function(e){return null},this.createModeDelegates=function(e){this.$embeds=[],this.$modes={};for(var t in e)if(e[t]){var n=e[t],i=n.prototype.$id,s=r.$modes[i];s||(r.$modes[i]=s=new n),r.$modes[t]||(r.$modes[t]=s),this.$embeds.push(t),this.$modes[t]=s}var o=["toggleBlockComment","toggleCommentLines","getNextLineIndent","checkOutdent","autoOutdent","transformAction","getCompletions"],u=function(e){(function(t){var n=o[e],r=t[n];t[o[e]]=function(){return this.$delegator(n,arguments,r)}})(a)},a=this;for(var t=0;t<o.length;t++)u(t)},this.$delegator=function(e,t,n){var r=t[0]||"start";if(typeof r!="string"){if(Array.isArray(r[2])){var i=r[2][r[2].length-1],s=this.$modes[i];if(s)return s[e].apply(s,[r[1]].concat([].slice.call(t,1)))}r=r[0]||"start"}for(var o=0;o<this.$embeds.length;o++){if(!this.$modes[this.$embeds[o]])continue;var u=r.split(this.$embeds[o]);if(!u[0]&&u[1]){t[0]=u[1];var s=this.$modes[this.$embeds[o]];return s[e].apply(s,t)}}var a=n.apply(this,t);return n?a:undefined},this.transformAction=function(e,t,n,r,i){if(this.$behaviour){var s=this.$behaviour.getBehaviours();for(var o in s)if(s[o][t]){var u=s[o][t].apply(this,arguments);if(u)return u}}},this.getKeywords=function(e){if(!this.completionKeywords){var t=this.$tokenizer.rules,n=[];for(var r in t){var i=t[r];for(var s=0,o=i.length;s<o;s++)if(typeof i[s].token=="string")/keyword|support|storage/.test(i[s].token)&&n.push(i[s].regex);else if(typeof i[s].token=="object")for(var u=0,a=i[s].token.length;u<a;u++)if(/keyword|support|storage/.test(i[s].token[u])){var r=i[s].regex.match(/\(.+?\)/g)[u];n.push(r.substr(1,r.length-2))}}this.completionKeywords=n}return e?n.concat(this.$keywordList||[]):this.$keywordList},this.$createKeywordList=function(){return this.$highlightRules||this.getTokenizer(),this.$keywordList=this.$highlightRules.$keywordList||[]},this.getCompletions=function(e,t,n,r){var i=this.$keywordList||this.$createKeywordList();return i.map(function(e){return{name:e,value:e,score:0,meta:"keyword"}})},this.$id="ace/mode/text"}.call(c.prototype),t.Mode=c}),define("ace/line_widgets",["require","exports","module","ace/lib/dom"],function(e,t,n){"use strict";var r=e("./lib/dom"),i=function(){function e(e){this.session=e,this.session.widgetManager=this,this.session.getRowLength=this.getRowLength,this.session.$getWidgetScreenLength=this.$getWidgetScreenLength,this.updateOnChange=this.updateOnChange.bind(this),this.renderWidgets=this.renderWidgets.bind(this),this.measureWidgets=this.measureWidgets.bind(this),this.session._changedWidgets=[],this.$onChangeEditor=this.$onChangeEditor.bind(this),this.session.on("change",this.updateOnChange),this.session.on("changeFold",this.updateOnFold),this.session.on("changeEditor",this.$onChangeEditor)}return e.prototype.getRowLength=function(e){var t;return this.lineWidgets?t=this.lineWidgets[e]&&this.lineWidgets[e].rowCount||0:t=0,!this.$useWrapMode||!this.$wrapData[e]?1+t:this.$wrapData[e].length+1+t},e.prototype.$getWidgetScreenLength=function(){var e=0;return this.lineWidgets.forEach(function(t){t&&t.rowCount&&!t.hidden&&(e+=t.rowCount)}),e},e.prototype.$onChangeEditor=function(e){this.attach(e.editor)},e.prototype.attach=function(e){e&&e.widgetManager&&e.widgetManager!=this&&e.widgetManager.detach();if(this.editor==e)return;this.detach(),this.editor=e,e&&(e.widgetManager=this,e.renderer.on("beforeRender",this.measureWidgets),e.renderer.on("afterRender",this.renderWidgets))},e.prototype.detach=function(e){var t=this.editor;if(!t)return;this.editor=null,t.widgetManager=null,t.renderer.off("beforeRender",this.measureWidgets),t.renderer.off("afterRender",this.renderWidgets);var n=this.session.lineWidgets;n&&n.forEach(function(e){e&&e.el&&e.el.parentNode&&(e._inDocument=!1,e.el.parentNode.removeChild(e.el))})},e.prototype.updateOnFold=function(e,t){var n=t.lineWidgets;if(!n||!e.action)return;var r=e.data,i=r.start.row,s=r.end.row,o=e.action=="add";for(var u=i+1;u<s;u++)n[u]&&(n[u].hidden=o);n[s]&&(o?n[i]?n[s].hidden=o:n[i]=n[s]:(n[i]==n[s]&&(n[i]=undefined),n[s].hidden=o))},e.prototype.updateOnChange=function(e){var t=this.session.lineWidgets;if(!t)return;var n=e.start.row,r=e.end.row-n;if(r!==0)if(e.action=="remove"){var i=t.splice(n+1,r);!t[n]&&i[i.length-1]&&(t[n]=i.pop()),i.forEach(function(e){e&&this.removeLineWidget(e)},this),this.$updateRows()}else{var s=new Array(r);t[n]&&t[n].column!=null&&e.start.column>t[n].column&&n++,s.unshift(n,0),t.splice.apply(t,s),this.$updateRows()}},e.prototype.$updateRows=function(){var e=this.session.lineWidgets;if(!e)return;var t=!0;e.forEach(function(e,n){if(e){t=!1,e.row=n;while(e.$oldWidget)e.$oldWidget.row=n,e=e.$oldWidget}}),t&&(this.session.lineWidgets=null)},e.prototype.$registerLineWidget=function(e){this.session.lineWidgets||(this.session.lineWidgets=new Array(this.session.getLength()));var t=this.session.lineWidgets[e.row];return t&&(e.$oldWidget=t,t.el&&t.el.parentNode&&(t.el.parentNode.removeChild(t.el),t._inDocument=!1)),this.session.lineWidgets[e.row]=e,e},e.prototype.addLineWidget=function(e){this.$registerLineWidget(e),e.session=this.session;if(!this.editor)return e;var t=this.editor.renderer;e.html&&!e.el&&(e.el=r.createElement("div"),e.el.innerHTML=e.html),e.text&&!e.el&&(e.el=r.createElement("div"),e.el.textContent=e.text),e.el&&(r.addCssClass(e.el,"ace_lineWidgetContainer"),e.className&&r.addCssClass(e.el,e.className),e.el.style.position="absolute",e.el.style.zIndex="5",t.container.appendChild(e.el),e._inDocument=!0,e.coverGutter||(e.el.style.zIndex="3"),e.pixelHeight==null&&(e.pixelHeight=e.el.offsetHeight)),e.rowCount==null&&(e.rowCount=e.pixelHeight/t.layerConfig.lineHeight);var n=this.session.getFoldAt(e.row,0);e.$fold=n;if(n){var i=this.session.lineWidgets;e.row==n.end.row&&!i[n.start.row]?i[n.start.row]=e:e.hidden=!0}return this.session._emit("changeFold",{data:{start:{row:e.row}}}),this.$updateRows(),this.renderWidgets(null,t),this.onWidgetChanged(e),e},e.prototype.removeLineWidget=function(e){e._inDocument=!1,e.session=null,e.el&&e.el.parentNode&&e.el.parentNode.removeChild(e.el);if(e.editor&&e.editor.destroy)try{e.editor.destroy()}catch(t){}if(this.session.lineWidgets){var n=this.session.lineWidgets[e.row];if(n==e)this.session.lineWidgets[e.row]=e.$oldWidget,e.$oldWidget&&this.onWidgetChanged(e.$oldWidget);else while(n){if(n.$oldWidget==e){n.$oldWidget=e.$oldWidget;break}n=n.$oldWidget}}this.session._emit("changeFold",{data:{start:{row:e.row}}}),this.$updateRows()},e.prototype.getWidgetsAtRow=function(e){var t=this.session.lineWidgets,n=t&&t[e],r=[];while(n)r.push(n),n=n.$oldWidget;return r},e.prototype.onWidgetChanged=function(e){this.session._changedWidgets.push(e),this.editor&&this.editor.renderer.updateFull()},e.prototype.measureWidgets=function(e,t){var n=this.session._changedWidgets,r=t.layerConfig;if(!n||!n.length)return;var i=Infinity;for(var s=0;s<n.length;s++){var o=n[s];if(!o||!o.el)continue;if(o.session!=this.session)continue;if(!o._inDocument){if(this.session.lineWidgets[o.row]!=o)continue;o._inDocument=!0,t.container.appendChild(o.el)}o.h=o.el.offsetHeight,o.fixedWidth||(o.w=o.el.offsetWidth,o.screenWidth=Math.ceil(o.w/r.characterWidth));var u=o.h/r.lineHeight;o.coverLine&&(u-=this.session.getRowLineCount(o.row),u<0&&(u=0)),o.rowCount!=u&&(o.rowCount=u,o.row<i&&(i=o.row))}i!=Infinity&&(this.session._emit("changeFold",{data:{start:{row:i}}}),this.session.lineWidgetWidth=null),this.session._changedWidgets=[]},e.prototype.renderWidgets=function(e,t){var n=t.layerConfig,r=this.session.lineWidgets;if(!r)return;var i=Math.min(this.firstRow,n.firstRow),s=Math.max(this.lastRow,n.lastRow,r.length);while(i>0&&!r[i])i--;this.firstRow=n.firstRow,this.lastRow=n.lastRow,t.$cursorLayer.config=n;for(var o=i;o<=s;o++){var u=r[o];if(!u||!u.el)continue;if(u.hidden){u.el.style.top=-100-(u.pixelHeight||0)+"px";continue}u._inDocument||(u._inDocument=!0,t.container.appendChild(u.el));var a=t.$cursorLayer.getPixelPosition({row:o,column:0},!0).top;u.coverLine||(a+=n.lineHeight*this.session.getRowLineCount(u.row)),u.el.style.top=a-n.offset+"px";var f=u.coverGutter?0:t.gutterWidth;u.fixedWidth||(f-=t.scrollLeft),u.el.style.left=f+"px",u.fullWidth&&u.screenWidth&&(u.el.style.minWidth=n.width+2*n.padding+"px"),u.fixedWidth?u.el.style.right=t.scrollBar.getWidth()+"px":u.el.style.right=""}},e}();t.LineWidgets=i}),define("ace/apply_delta",["require","exports","module"],function(e,t,n){"use strict";function r(e,t){throw console.log("Invalid Delta:",e),"Invalid Delta: "+t}function i(e,t){return t.row>=0&&t.row<e.length&&t.column>=0&&t.column<=e[t.row].length}function s(e,t){t.action!="insert"&&t.action!="remove"&&r(t,"delta.action must be 'insert' or 'remove'"),t.lines instanceof Array||r(t,"delta.lines must be an Array"),(!t.start||!t.end)&&r(t,"delta.start/end must be an present");var n=t.start;i(e,t.start)||r(t,"delta.start must be contained in document");var s=t.end;t.action=="remove"&&!i(e,s)&&r(t,"delta.end must contained in document for 'remove' actions");var o=s.row-n.row,u=s.column-(o==0?n.column:0);(o!=t.lines.length-1||t.lines[o].length!=u)&&r(t,"delta.range must match delta lines")}t.applyDelta=function(e,t,n){var r=t.start.row,i=t.start.column,s=e[r]||"";switch(t.action){case"insert":var o=t.lines;if(o.length===1)e[r]=s.substring(0,i)+t.lines[0]+s.substring(i);else{var u=[r,1].concat(t.lines);e.splice.apply(e,u),e[r]=s.substring(0,i)+e[r],e[r+t.lines.length-1]+=s.substring(i)}break;case"remove":var a=t.end.column,f=t.end.row;r===f?e[r]=s.substring(0,i)+s.substring(a):e.splice(r,f-r+1,s.substring(0,i)+e[f].substring(a))}}}),define("ace/anchor",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"],function(e,t,n){"use strict";function o(e,t,n){var r=n?e.column<=t.column:e.column<t.column;return e.row<t.row||e.row==t.row&&r}function u(e,t,n){var r=e.action=="insert",i=(r?1:-1)*(e.end.row-e.start.row),s=(r?1:-1)*(e.end.column-e.start.column),u=e.start,a=r?u:e.end;return o(t,u,n)?{row:t.row,column:t.column}:o(a,t,!n)?{row:t.row+i,column:t.column+(t.row==a.row?s:0)}:{row:u.row,column:u.column}}var r=e("./lib/oop"),i=e("./lib/event_emitter").EventEmitter,s=function(){function e(e,t,n){this.$onChange=this.onChange.bind(this),this.attach(e),typeof t!="number"?this.setPosition(t.row,t.column):this.setPosition(t,n)}return e.prototype.getPosition=function(){return this.$clipPositionToDocument(this.row,this.column)},e.prototype.getDocument=function(){return this.document},e.prototype.onChange=function(e){if(e.start.row==e.end.row&&e.start.row!=this.row)return;if(e.start.row>this.row)return;var t=u(e,{row:this.row,column:this.column},this.$insertRight);this.setPosition(t.row,t.column,!0)},e.prototype.setPosition=function(e,t,n){var r;n?r={row:e,column:t}:r=this.$clipPositionToDocument(e,t);if(this.row==r.row&&this.column==r.column)return;var i={row:this.row,column:this.column};this.row=r.row,this.column=r.column,this._signal("change",{old:i,value:r})},e.prototype.detach=function(){this.document.off("change",this.$onChange)},e.prototype.attach=function(e){this.document=e||this.document,this.document.on("change",this.$onChange)},e.prototype.$clipPositionToDocument=function(e,t){var n={};return e>=this.document.getLength()?(n.row=Math.max(0,this.document.getLength()-1),n.column=this.document.getLine(n.row).length):e<0?(n.row=0,n.column=0):(n.row=e,n.column=Math.min(this.document.getLine(n.row).length,Math.max(0,t))),t<0&&(n.column=0),n},e}();s.prototype.$insertRight=!1,r.implement(s.prototype,i),t.Anchor=s}),define("ace/document",["require","exports","module","ace/lib/oop","ace/apply_delta","ace/lib/event_emitter","ace/range","ace/anchor"],function(e,t,n){"use strict";var r=e("./lib/oop"),i=e("./apply_delta").applyDelta,s=e("./lib/event_emitter").EventEmitter,o=e("./range").Range,u=e("./anchor").Anchor,a=function(){function e(e){this.$lines=[""],e.length===0?this.$lines=[""]:Array.isArray(e)?this.insertMergedLines({row:0,column:0},e):this.insert({row:0,column:0},e)}return e.prototype.setValue=function(e){var t=this.getLength()-1;this.remove(new o(0,0,t,this.getLine(t).length)),this.insert({row:0,column:0},e||"")},e.prototype.getValue=function(){return this.getAllLines().join(this.getNewLineCharacter())},e.prototype.createAnchor=function(e,t){return new u(this,e,t)},e.prototype.$detectNewLine=function(e){var t=e.match(/^.*?(\r\n|\r|\n)/m);this.$autoNewLine=t?t[1]:"\n",this._signal("changeNewLineMode")},e.prototype.getNewLineCharacter=function(){switch(this.$newLineMode){case"windows":return"\r\n";case"unix":return"\n";default:return this.$autoNewLine||"\n"}},e.prototype.setNewLineMode=function(e){if(this.$newLineMode===e)return;this.$newLineMode=e,this._signal("changeNewLineMode")},e.prototype.getNewLineMode=function(){return this.$newLineMode},e.prototype.isNewLine=function(e){return e=="\r\n"||e=="\r"||e=="\n"},e.prototype.getLine=function(e){return this.$lines[e]||""},e.prototype.getLines=function(e,t){return this.$lines.slice(e,t+1)},e.prototype.getAllLines=function(){return this.getLines(0,this.getLength())},e.prototype.getLength=function(){return this.$lines.length},e.prototype.getTextRange=function(e){return this.getLinesForRange(e).join(this.getNewLineCharacter())},e.prototype.getLinesForRange=function(e){var t;if(e.start.row===e.end.row)t=[this.getLine(e.start.row).substring(e.start.column,e.end.column)];else{t=this.getLines(e.start.row,e.end.row),t[0]=(t[0]||"").substring(e.start.column);var n=t.length-1;e.end.row-e.start.row==n&&(t[n]=t[n].substring(0,e.end.column))}return t},e.prototype.insertLines=function(e,t){return console.warn("Use of document.insertLines is deprecated. Use the insertFullLines method instead."),this.insertFullLines(e,t)},e.prototype.removeLines=function(e,t){return console.warn("Use of document.removeLines is deprecated. Use the removeFullLines method instead."),this.removeFullLines(e,t)},e.prototype.insertNewLine=function(e){return console.warn("Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead."),this.insertMergedLines(e,["",""])},e.prototype.insert=function(e,t){return this.getLength()<=1&&this.$detectNewLine(t),this.insertMergedLines(e,this.$split(t))},e.prototype.insertInLine=function(e,t){var n=this.clippedPos(e.row,e.column),r=this.pos(e.row,e.column+t.length);return this.applyDelta({start:n,end:r,action:"insert",lines:[t]},!0),this.clonePos(r)},e.prototype.clippedPos=function(e,t){var n=this.getLength();e===undefined?e=n:e<0?e=0:e>=n&&(e=n-1,t=undefined);var r=this.getLine(e);return t==undefined&&(t=r.length),t=Math.min(Math.max(t,0),r.length),{row:e,column:t}},e.prototype.clonePos=function(e){return{row:e.row,column:e.column}},e.prototype.pos=function(e,t){return{row:e,column:t}},e.prototype.$clipPosition=function(e){var t=this.getLength();return e.row>=t?(e.row=Math.max(0,t-1),e.column=this.getLine(t-1).length):(e.row=Math.max(0,e.row),e.column=Math.min(Math.max(e.column,0),this.getLine(e.row).length)),e},e.prototype.insertFullLines=function(e,t){e=Math.min(Math.max(e,0),this.getLength());var n=0;e<this.getLength()?(t=t.concat([""]),n=0):(t=[""].concat(t),e--,n=this.$lines[e].length),this.insertMergedLines({row:e,column:n},t)},e.prototype.insertMergedLines=function(e,t){var n=this.clippedPos(e.row,e.column),r={row:n.row+t.length-1,column:(t.length==1?n.column:0)+t[t.length-1].length};return this.applyDelta({start:n,end:r,action:"insert",lines:t}),this.clonePos(r)},e.prototype.remove=function(e){var t=this.clippedPos(e.start.row,e.start.column),n=this.clippedPos(e.end.row,e.end.column);return this.applyDelta({start:t,end:n,action:"remove",lines:this.getLinesForRange({start:t,end:n})}),this.clonePos(t)},e.prototype.removeInLine=function(e,t,n){var r=this.clippedPos(e,t),i=this.clippedPos(e,n);return this.applyDelta({start:r,end:i,action:"remove",lines:this.getLinesForRange({start:r,end:i})},!0),this.clonePos(r)},e.prototype.removeFullLines=function(e,t){e=Math.min(Math.max(0,e),this.getLength()-1),t=Math.min(Math.max(0,t),this.getLength()-1);var n=t==this.getLength()-1&&e>0,r=t<this.getLength()-1,i=n?e-1:e,s=n?this.getLine(i).length:0,u=r?t+1:t,a=r?0:this.getLine(u).length,f=new o(i,s,u,a),l=this.$lines.slice(e,t+1);return this.applyDelta({start:f.start,end:f.end,action:"remove",lines:this.getLinesForRange(f)}),l},e.prototype.removeNewLine=function(e){e<this.getLength()-1&&e>=0&&this.applyDelta({start:this.pos(e,this.getLine(e).length),end:this.pos(e+1,0),action:"remove",lines:["",""]})},e.prototype.replace=function(e,t){e instanceof o||(e=o.fromPoints(e.start,e.end));if(t.length===0&&e.isEmpty())return e.start;if(t==this.getTextRange(e))return e.end;this.remove(e);var n;return t?n=this.insert(e.start,t):n=e.start,n},e.prototype.applyDeltas=function(e){for(var t=0;t<e.length;t++)this.applyDelta(e[t])},e.prototype.revertDeltas=function(e){for(var t=e.length-1;t>=0;t--)this.revertDelta(e[t])},e.prototype.applyDelta=function(e,t){var n=e.action=="insert";if(n?e.lines.length<=1&&!e.lines[0]:!o.comparePoints(e.start,e.end))return;n&&e.lines.length>2e4?this.$splitAndapplyLargeDelta(e,2e4):(i(this.$lines,e,t),this._signal("change",e))},e.prototype.$safeApplyDelta=function(e){var t=this.$lines.length;(e.action=="remove"&&e.start.row<t&&e.end.row<t||e.action=="insert"&&e.start.row<=t)&&this.applyDelta(e)},e.prototype.$splitAndapplyLargeDelta=function(e,t){var n=e.lines,r=n.length-t+1,i=e.start.row,s=e.start.column;for(var o=0,u=0;o<r;o=u){u+=t-1;var a=n.slice(o,u);a.push(""),this.applyDelta({start:this.pos(i+o,s),end:this.pos(i+u,s=0),action:e.action,lines:a},!0)}e.lines=n.slice(o),e.start.row=i+o,e.start.column=s,this.applyDelta(e,!0)},e.prototype.revertDelta=function(e){this.$safeApplyDelta({start:this.clonePos(e.start),end:this.clonePos(e.end),action:e.action=="insert"?"remove":"insert",lines:e.lines.slice()})},e.prototype.indexToPosition=function(e,t){var n=this.$lines||this.getAllLines(),r=this.getNewLineCharacter().length;for(var i=t||0,s=n.length;i<s;i++){e-=n[i].length+r;if(e<0)return{row:i,column:e+n[i].length+r}}return{row:s-1,column:e+n[s-1].length+r}},e.prototype.positionToIndex=function(e,t){var n=this.$lines||this.getAllLines(),r=this.getNewLineCharacter().length,i=0,s=Math.min(e.row,n.length);for(var o=t||0;o<s;++o)i+=n[o].length+r;return i+e.column},e.prototype.$split=function(e){return e.split(/\r\n|\r|\n/)},e}();a.prototype.$autoNewLine="",a.prototype.$newLineMode="auto",r.implement(a.prototype,s),t.Document=a}),define("ace/background_tokenizer",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"],function(e,t,n){"use strict";var r=e("./lib/oop"),i=e("./lib/event_emitter").EventEmitter,s=function(){function e(e,t){this.running=!1,this.lines=[],this.states=[],this.currentLine=0,this.tokenizer=e;var n=this;this.$worker=function(){if(!n.running)return;var e=new Date,t=n.currentLine,r=-1,i=n.doc,s=t;while(n.lines[t])t++;var o=i.getLength(),u=0;n.running=!1;while(t<o){n.$tokenizeRow(t),r=t;do t++;while(n.lines[t]);u++;if(u%5===0&&new Date-e>20){n.running=setTimeout(n.$worker,20);break}}n.currentLine=t,r==-1&&(r=t),s<=r&&n.fireUpdateEvent(s,r)}}return e.prototype.setTokenizer=function(e){this.tokenizer=e,this.lines=[],this.states=[],this.start(0)},e.prototype.setDocument=function(e){this.doc=e,this.lines=[],this.states=[],this.stop()},e.prototype.fireUpdateEvent=function(e,t){var n={first:e,last:t};this._signal("update",{data:n})},e.prototype.start=function(e){this.currentLine=Math.min(e||0,this.currentLine,this.doc.getLength()),this.lines.splice(this.currentLine,this.lines.length),this.states.splice(this.currentLine,this.states.length),this.stop(),this.running=setTimeout(this.$worker,700)},e.prototype.scheduleStart=function(){this.running||(this.running=setTimeout(this.$worker,700))},e.prototype.$updateOnChange=function(e){var t=e.start.row,n=e.end.row-t;if(n===0)this.lines[t]=null;else if(e.action=="remove")this.lines.splice(t,n+1,null),this.states.splice(t,n+1,null);else{var r=Array(n+1);r.unshift(t,1),this.lines.splice.apply(this.lines,r),this.states.splice.apply(this.states,r)}this.currentLine=Math.min(t,this.currentLine,this.doc.getLength()),this.stop()},e.prototype.stop=function(){this.running&&clearTimeout(this.running),this.running=!1},e.prototype.getTokens=function(e){return this.lines[e]||this.$tokenizeRow(e)},e.prototype.getState=function(e){return this.currentLine==e&&this.$tokenizeRow(e),this.states[e]||"start"},e.prototype.$tokenizeRow=function(e){var t=this.doc.getLine(e),n=this.states[e-1],r=this.tokenizer.getLineTokens(t,n,e);return this.states[e]+""!=r.state+""?(this.states[e]=r.state,this.lines[e+1]=null,this.currentLine>e+1&&(this.currentLine=e+1)):this.currentLine==e&&(this.currentLine=e+1),this.lines[e]=r.tokens},e.prototype.cleanup=function(){this.running=!1,this.lines=[],this.states=[],this.currentLine=0,this.removeAllListeners()},e}();r.implement(s.prototype,i),t.BackgroundTokenizer=s}),define("ace/search_highlight",["require","exports","module","ace/lib/lang","ace/range"],function(e,t,n){"use strict";var r=e("./lib/lang"),i=e("./range").Range,s=function(){function e(e,t,n){n===void 0&&(n="text"),this.setRegexp(e),this.clazz=t,this.type=n,this.docLen=0}return e.prototype.setRegexp=function(e){if(this.regExp+""==e+"")return;this.regExp=e,this.cache=[]},e.prototype.update=function(e,t,n,s){if(!this.regExp)return;var o=s.firstRow,u=s.lastRow,a={},f=n.$editor&&n.$editor.$search,l=f&&f.$isMultilineSearch(n.$editor.getLastSearchOptions());for(var c=o;c<=u;c++){var h=this.cache[c];if(h==null||n.getValue().length!=this.docLen){if(l){h=[];var p=f.$multiLineForward(n,this.regExp,c,u);if(p){var d=p.endRow<=u?p.endRow-1:u;d>c&&(c=d),h.push(new i(p.startRow,p.startCol,p.endRow,p.endCol))}h.length>this.MAX_RANGES&&(h=h.slice(0,this.MAX_RANGES))}else h=r.getMatchOffsets(n.getLine(c),this.regExp),h.length>this.MAX_RANGES&&(h=h.slice(0,this.MAX_RANGES)),h=h.map(function(e){return new i(c,e.offset,c,e.offset+e.length)});this.cache[c]=h.length?h:""}if(h.length===0)continue;for(var v=h.length;v--;){var m=h[v].toScreenRange(n),g=m.toString();if(a[g])continue;a[g]=!0,t.drawSingleLineMarker(e,m,this.clazz,s)}}this.docLen=n.getValue().length},e}();s.prototype.MAX_RANGES=500,t.SearchHighlight=s}),define("ace/undomanager",["require","exports","module","ace/range"],function(e,t,n){"use strict";function i(e,t){for(var n=t;n--;){var r=e[n];if(r&&!r[0].ignore){while(n<t-1){var i=d(e[n],e[n+1]);e[n]=i[0],e[n+1]=i[1],n++}return!0}}}function a(e){var t=e.action=="insert",n=e.start,r=e.end,i=(r.row-n.row)*(t?1:-1),s=(r.column-n.column)*(t?1:-1);t&&(r=n);for(var o in this.marks){var a=this.marks[o],f=u(a,n);if(f<0)continue;if(f===0&&t){if(a.bias!=1){a.bias==-1;continue}f=1}var l=t?f:u(a,r);if(l>0){a.row+=i,a.column+=a.row==r.row?s:0;continue}!t&&l<=0&&(a.row=n.row,a.column=n.column,l===0&&(a.bias=1))}}function f(e){return{row:e.row,column:e.column}}function l(e){return{start:f(e.start),end:f(e.end),action:e.action,lines:e.lines.slice()}}function c(e){e=e||this;if(Array.isArray(e))return e.map(c).join("\n");var t="";e.action?(t=e.action=="insert"?"+":"-",t+="["+e.lines+"]"):e.value&&(Array.isArray(e.value)?t=e.value.map(h).join("\n"):t=h(e.value)),e.start&&(t+=h(e));if(e.id||e.rev)t+="	("+(e.id||e.rev)+")";return t}function h(e){return e.start.row+":"+e.start.column+"=>"+e.end.row+":"+e.end.column}function p(e,t){var n=e.action=="insert",r=t.action=="insert";if(n&&r)if(o(t.start,e.end)>=0)m(t,e,-1);else{if(!(o(t.start,e.start)<=0))return null;m(e,t,1)}else if(n&&!r)if(o(t.start,e.end)>=0)m(t,e,-1);else{if(!(o(t.end,e.start)<=0))return null;m(e,t,-1)}else if(!n&&r)if(o(t.start,e.start)>=0)m(t,e,1);else{if(!(o(t.start,e.start)<=0))return null;m(e,t,1)}else if(!n&&!r)if(o(t.start,e.start)>=0)m(t,e,1);else{if(!(o(t.end,e.start)<=0))return null;m(e,t,-1)}return[t,e]}function d(e,t){for(var n=e.length;n--;)for(var r=0;r<t.length;r++)if(!p(e[n],t[r])){while(n<e.length){while(r--)p(t[r],e[n]);r=t.length,n++}return[e,t]}return e.selectionBefore=t.selectionBefore=e.selectionAfter=t.selectionAfter=null,[t,e]}function v(e,t){var n=e.action=="insert",r=t.action=="insert";if(n&&r)o(e.start,t.start)<0?m(t,e,1):m(e,t,1);else if(n&&!r)o(e.start,t.end)>=0?m(e,t,-1):o(e.start,t.start)<=0?m(t,e,1):(m(e,s.fromPoints(t.start,e.start),-1),m(t,e,1));else if(!n&&r)o(t.start,e.end)>=0?m(t,e,-1):o(t.start,e.start)<=0?m(e,t,1):(m(t,s.fromPoints(e.start,t.start),-1),m(e,t,1));else if(!n&&!r)if(o(t.start,e.end)>=0)m(t,e,-1);else{if(!(o(t.end,e.start)<=0)){var i,u;return o(e.start,t.start)<0&&(i=e,e=y(e,t.start)),o(e.end,t.end)>0&&(u=y(e,t.end)),g(t.end,e.start,e.end,-1),u&&!i&&(e.lines=u.lines,e.start=u.start,e.end=u.end,u=e),[t,i,u].filter(Boolean)}m(e,t,-1)}return[t,e]}function m(e,t,n){g(e.start,t.start,t.end,n),g(e.end,t.start,t.end,n)}function g(e,t,n,r){e.row==(r==1?t:n).row&&(e.column+=r*(n.column-t.column)),e.row+=r*(n.row-t.row)}function y(e,t){var n=e.lines,r=e.end;e.end=f(t);var i=e.end.row-e.start.row,s=n.splice(i,n.length),o=i?t.column:t.column-e.start.column;n.push(s[0].substring(0,o)),s[0]=s[0].substr(o);var u={start:f(t),end:r,lines:s,action:e.action};return u}function b(e,t){t=l(t);for(var n=e.length;n--;){var r=e[n];for(var i=0;i<r.length;i++){var s=r[i],o=v(s,t);t=o[0],o.length!=2&&(o[2]?(r.splice(i+1,1,o[1],o[2]),i++):o[1]||(r.splice(i,1),i--))}r.length||e.splice(n,1)}return e}function w(e,t){for(var n=0;n<t.length;n++){var r=t[n];for(var i=0;i<r.length;i++)b(e,r[i])}}var r=function(){function e(){this.$keepRedoStack,this.$maxRev=0,this.$fromUndo=!1,this.$undoDepth=Infinity,this.reset()}return e.prototype.addSession=function(e){this.$session=e},e.prototype.add=function(e,t,n){if(this.$fromUndo)return;if(e==this.$lastDelta)return;this.$keepRedoStack||(this.$redoStack.length=0);if(t===!1||!this.lastDeltas){this.lastDeltas=[];var r=this.$undoStack.length;r>this.$undoDepth-1&&this.$undoStack.splice(0,r-this.$undoDepth+1),this.$undoStack.push(this.lastDeltas),e.id=this.$rev=++this.$maxRev}if(e.action=="remove"||e.action=="insert")this.$lastDelta=e;this.lastDeltas.push(e)},e.prototype.addSelection=function(e,t){this.selections.push({value:e,rev:t||this.$rev})},e.prototype.startNewGroup=function(){return this.lastDeltas=null,this.$rev},e.prototype.markIgnored=function(e,t){t==null&&(t=this.$rev+1);var n=this.$undoStack;for(var r=n.length;r--;){var i=n[r][0];if(i.id<=e)break;i.id<t&&(i.ignore=!0)}this.lastDeltas=null},e.prototype.getSelection=function(e,t){var n=this.selections;for(var r=n.length;r--;){var i=n[r];if(i.rev<e)return t&&(i=n[r+1]),i}},e.prototype.getRevision=function(){return this.$rev},e.prototype.getDeltas=function(e,t){t==null&&(t=this.$rev+1);var n=this.$undoStack,r=null,i=0;for(var s=n.length;s--;){var o=n[s][0];o.id<t&&!r&&(r=s+1);if(o.id<=e){i=s+1;break}}return n.slice(i,r)},e.prototype.getChangedRanges=function(e,t){t==null&&(t=this.$rev+1)},e.prototype.getChangedLines=function(e,t){t==null&&(t=this.$rev+1)},e.prototype.undo=function(e,t){this.lastDeltas=null;var n=this.$undoStack;if(!i(n,n.length))return;e||(e=this.$session),this.$redoStackBaseRev!==this.$rev&&this.$redoStack.length&&(this.$redoStack=[]),this.$fromUndo=!0;var r=n.pop(),s=null;return r&&(s=e.undoChanges(r,t),this.$redoStack.push(r),this.$syncRev()),this.$fromUndo=!1,s},e.prototype.redo=function(e,t){this.lastDeltas=null,e||(e=this.$session),this.$fromUndo=!0;if(this.$redoStackBaseRev!=this.$rev){var n=this.getDeltas(this.$redoStackBaseRev,this.$rev+1);w(this.$redoStack,n),this.$redoStackBaseRev=this.$rev,this.$redoStack.forEach(function(e){e[0].id=++this.$maxRev},this)}var r=this.$redoStack.pop(),i=null;return r&&(i=e.redoChanges(r,t),this.$undoStack.push(r),this.$syncRev()),this.$fromUndo=!1,i},e.prototype.$syncRev=function(){var e=this.$undoStack,t=e[e.length-1],n=t&&t[0].id||0;this.$redoStackBaseRev=n,this.$rev=n},e.prototype.reset=function(){this.lastDeltas=null,this.$lastDelta=null,this.$undoStack=[],this.$redoStack=[],this.$rev=0,this.mark=0,this.$redoStackBaseRev=this.$rev,this.selections=[]},e.prototype.canUndo=function(){return this.$undoStack.length>0},e.prototype.canRedo=function(){return this.$redoStack.length>0},e.prototype.bookmark=function(e){e==undefined&&(e=this.$rev),this.mark=e},e.prototype.isAtBookmark=function(){return this.$rev===this.mark},e.prototype.toJSON=function(){return{$redoStack:this.$redoStack,$undoStack:this.$undoStack}},e.prototype.fromJSON=function(e){this.reset(),this.$undoStack=e.$undoStack,this.$redoStack=e.$redoStack},e.prototype.$prettyPrint=function(e){return e?c(e):c(this.$undoStack)+"\n---\n"+c(this.$redoStack)},e}();r.prototype.hasUndo=r.prototype.canUndo,r.prototype.hasRedo=r.prototype.canRedo,r.prototype.isClean=r.prototype.isAtBookmark,r.prototype.markClean=r.prototype.bookmark;var s=e("./range").Range,o=s.comparePoints,u=s.comparePoints;t.UndoManager=r}),define("ace/edit_session/fold_line",["require","exports","module","ace/range"],function(e,t,n){"use strict";var r=e("../range").Range,i=function(){function e(e,t){this.foldData=e,Array.isArray(t)?this.folds=t:t=this.folds=[t];var n=t[t.length-1];this.range=new r(t[0].start.row,t[0].start.column,n.end.row,n.end.column),this.start=this.range.start,this.end=this.range.end,this.folds.forEach(function(e){e.setFoldLine(this)},this)}return e.prototype.shiftRow=function(e){this.start.row+=e,this.end.row+=e,this.folds.forEach(function(t){t.start.row+=e,t.end.row+=e})},e.prototype.addFold=function(e){if(e.sameRow){if(e.start.row<this.startRow||e.endRow>this.endRow)throw new Error("Can't add a fold to this FoldLine as it has no connection");this.folds.push(e),this.folds.sort(function(e,t){return-e.range.compareEnd(t.start.row,t.start.column)}),this.range.compareEnd(e.start.row,e.start.column)>0?(this.end.row=e.end.row,this.end.column=e.end.column):this.range.compareStart(e.end.row,e.end.column)<0&&(this.start.row=e.start.row,this.start.column=e.start.column)}else if(e.start.row==this.end.row)this.folds.push(e),this.end.row=e.end.row,this.end.column=e.end.column;else{if(e.end.row!=this.start.row)throw new Error("Trying to add fold to FoldRow that doesn't have a matching row");this.folds.unshift(e),this.start.row=e.start.row,this.start.column=e.start.column}e.foldLine=this},e.prototype.containsRow=function(e){return e>=this.start.row&&e<=this.end.row},e.prototype.walk=function(e,t,n){var r=0,i=this.folds,s,o,u,a=!0;t==null&&(t=this.end.row,n=this.end.column);for(var f=0;f<i.length;f++){s=i[f],o=s.range.compareStart(t,n);if(o==-1){e(null,t,n,r,a);return}u=e(null,s.start.row,s.start.column,r,a),u=!u&&e(s.placeholder,s.start.row,s.start.column,r);if(u||o===0)return;a=!s.sameRow,r=s.end.column}e(null,t,n,r,a)},e.prototype.getNextFoldTo=function(e,t){var n,r;for(var i=0;i<this.folds.length;i++){n=this.folds[i],r=n.range.compareEnd(e,t);if(r==-1)return{fold:n,kind:"after"};if(r===0)return{fold:n,kind:"inside"}}return null},e.prototype.addRemoveChars=function(e,t,n){var r=this.getNextFoldTo(e,t),i,s;if(r){i=r.fold;if(r.kind=="inside"&&i.start.column!=t&&i.start.row!=e)window.console&&window.console.log(e,t,i);else if(i.start.row==e){s=this.folds;var o=s.indexOf(i);o===0&&(this.start.column+=n);for(o;o<s.length;o++){i=s[o],i.start.column+=n;if(!i.sameRow)return;i.end.column+=n}this.end.column+=n}}},e.prototype.split=function(t,n){var r=this.getNextFoldTo(t,n);if(!r||r.kind=="inside")return null;var i=r.fold,s=this.folds,o=this.foldData,u=s.indexOf(i),a=s[u-1];this.end.row=a.end.row,this.end.column=a.end.column,s=s.splice(u,s.length-u);var f=new e(o,s);return o.splice(o.indexOf(this)+1,0,f),f},e.prototype.merge=function(e){var t=e.folds;for(var n=0;n<t.length;n++)this.addFold(t[n]);var r=this.foldData;r.splice(r.indexOf(e),1)},e.prototype.toString=function(){var e=[this.range.toString()+": ["];return this.folds.forEach(function(t){e.push("  "+t.toString())}),e.push("]"),e.join("\n")},e.prototype.idxToPosition=function(e){var t=0;for(var n=0;n<this.folds.length;n++){var r=this.folds[n];e-=r.start.column-t;if(e<0)return{row:r.start.row,column:r.start.column+e};e-=r.placeholder.length;if(e<0)return r.start;t=r.end.column}return{row:this.end.row,column:this.end.column+e}},e}();t.FoldLine=i}),define("ace/range_list",["require","exports","module","ace/range"],function(e,t,n){"use strict";var r=e("./range").Range,i=r.comparePoints,s=function(){function e(){this.ranges=[],this.$bias=1}return e.prototype.pointIndex=function(e,t,n){var r=this.ranges;for(var s=n||0;s<r.length;s++){var o=r[s],u=i(e,o.end);if(u>0)continue;var a=i(e,o.start);return u===0?t&&a!==0?-s-2:s:a>0||a===0&&!t?s:-s-1}return-s-1},e.prototype.add=function(e){var t=!e.isEmpty(),n=this.pointIndex(e.start,t);n<0&&(n=-n-1);var r=this.pointIndex(e.end,t,n);return r<0?r=-r-1:r++,this.ranges.splice(n,r-n,e)},e.prototype.addList=function(e){var t=[];for(var n=e.length;n--;)t.push.apply(t,this.add(e[n]));return t},e.prototype.substractPoint=function(e){var t=this.pointIndex(e);if(t>=0)return this.ranges.splice(t,1)},e.prototype.merge=function(){var e=[],t=this.ranges;t=t.sort(function(e,t){return i(e.start,t.start)});var n=t[0],r;for(var s=1;s<t.length;s++){r=n,n=t[s];var o=i(r.end,n.start);if(o<0)continue;if(o==0&&!r.isEmpty()&&!n.isEmpty())continue;i(r.end,n.end)<0&&(r.end.row=n.end.row,r.end.column=n.end.column),t.splice(s,1),e.push(n),n=r,s--}return this.ranges=t,e},e.prototype.contains=function(e,t){return this.pointIndex({row:e,column:t})>=0},e.prototype.containsPoint=function(e){return this.pointIndex(e)>=0},e.prototype.rangeAtPoint=function(e){var t=this.pointIndex(e);if(t>=0)return this.ranges[t]},e.prototype.clipRows=function(e,t){var n=this.ranges;if(n[0].start.row>t||n[n.length-1].start.row<e)return[];var r=this.pointIndex({row:e,column:0});r<0&&(r=-r-1);var i=this.pointIndex({row:t,column:0},r);i<0&&(i=-i-1);var s=[];for(var o=r;o<i;o++)s.push(n[o]);return s},e.prototype.removeAll=function(){return this.ranges.splice(0,this.ranges.length)},e.prototype.attach=function(e){this.session&&this.detach(),this.session=e,this.onChange=this.$onChange.bind(this),this.session.on("change",this.onChange)},e.prototype.detach=function(){if(!this.session)return;this.session.removeListener("change",this.onChange),this.session=null},e.prototype.$onChange=function(e){var t=e.start,n=e.end,r=t.row,i=n.row,s=this.ranges;for(var o=0,u=s.length;o<u;o++){var a=s[o];if(a.end.row>=r)break}if(e.action=="insert"){var f=i-r,l=-t.column+n.column;for(;o<u;o++){var a=s[o];if(a.start.row>r)break;a.start.row==r&&a.start.column>=t.column&&(a.start.column==t.column&&this.$bias<=0||(a.start.column+=l,a.start.row+=f));if(a.end.row==r&&a.end.column>=t.column){if(a.end.column==t.column&&this.$bias<0)continue;a.end.column==t.column&&l>0&&o<u-1&&a.end.column>a.start.column&&a.end.column==s[o+1].start.column&&(a.end.column-=l),a.end.column+=l,a.end.row+=f}}}else{var f=r-i,l=t.column-n.column;for(;o<u;o++){var a=s[o];if(a.start.row>i)break;if(a.end.row<i&&(r<a.end.row||r==a.end.row&&t.column<a.end.column))a.end.row=r,a.end.column=t.column;else if(a.end.row==i)if(a.end.column<=n.column){if(f||a.end.column>t.column)a.end.column=t.column,a.end.row=t.row}else a.end.column+=l,a.end.row+=f;else a.end.row>i&&(a.end.row+=f);if(a.start.row<i&&(r<a.start.row||r==a.start.row&&t.column<a.start.column))a.start.row=r,a.start.column=t.column;else if(a.start.row==i)if(a.start.column<=n.column){if(f||a.start.column>t.column)a.start.column=t.column,a.start.row=t.row}else a.start.column+=l,a.start.row+=f;else a.start.row>i&&(a.start.row+=f)}}if(f!=0&&o<u)for(;o<u;o++){var a=s[o];a.start.row+=f,a.end.row+=f}},e}();s.prototype.comparePoints=i,t.RangeList=s}),define("ace/edit_session/fold",["require","exports","module","ace/range_list"],function(e,t,n){"use strict";function o(e,t){e.row-=t.row,e.row==0&&(e.column-=t.column)}function u(e,t){o(e.start,t),o(e.end,t)}function a(e,t){e.row==0&&(e.column+=t.column),e.row+=t.row}function f(e,t){a(e.start,t),a(e.end,t)}var r=this&&this.__extends||function(){var e=function(t,n){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},e(t,n)};return function(t,n){function r(){this.constructor=t}if(typeof n!="function"&&n!==null)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");e(t,n),t.prototype=n===null?Object.create(n):(r.prototype=n.prototype,new r)}}(),i=e("../range_list").RangeList,s=function(e){function t(t,n){var r=e.call(this)||this;return r.foldLine=null,r.placeholder=n,r.range=t,r.start=t.start,r.end=t.end,r.sameRow=t.start.row==t.end.row,r.subFolds=r.ranges=[],r}return r(t,e),t.prototype.toString=function(){return'"'+this.placeholder+'" '+this.range.toString()},t.prototype.setFoldLine=function(e){this.foldLine=e,this.subFolds.forEach(function(t){t.setFoldLine(e)})},t.prototype.clone=function(){var e=this.range.clone(),n=new t(e,this.placeholder);return this.subFolds.forEach(function(e){n.subFolds.push(e.clone())}),n.collapseChildren=this.collapseChildren,n},t.prototype.addSubFold=function(e){if(this.range.isEqual(e))return;u(e,this.start);var t=e.start.row,n=e.start.column;for(var r=0,i=-1;r<this.subFolds.length;r++){i=this.subFolds[r].range.compare(t,n);if(i!=1)break}var s=this.subFolds[r],o=0;if(i==0){if(s.range.containsRange(e))return s.addSubFold(e);o=1}var t=e.range.end.row,n=e.range.end.column;for(var a=r,i=-1;a<this.subFolds.length;a++){i=this.subFolds[a].range.compare(t,n);if(i!=1)break}i==0&&a++;var f=this.subFolds.splice(r,a-r,e),l=i==0?f.length-1:f.length;for(var c=o;c<l;c++)e.addSubFold(f[c]);return e.setFoldLine(this.foldLine),e},t.prototype.restoreRange=function(e){return f(e,this.start)},t}(i);t.Fold=s}),define("ace/edit_session/folding",["require","exports","module","ace/range","ace/edit_session/fold_line","ace/edit_session/fold","ace/token_iterator","ace/mouse/mouse_event"],function(e,t,n){"use strict";function a(){this.getFoldAt=function(e,t,n){var r=this.getFoldLine(e);if(!r)return null;var i=r.folds;for(var s=0;s<i.length;s++){var o=i[s].range;if(o.contains(e,t)){if(n==1&&o.isEnd(e,t)&&!o.isEmpty())continue;if(n==-1&&o.isStart(e,t)&&!o.isEmpty())continue;return i[s]}}},this.getFoldsInRange=function(e){var t=e.start,n=e.end,r=this.$foldData,i=[];t.column+=1,n.column-=1;for(var s=0;s<r.length;s++){var o=r[s].range.compareRange(e);if(o==2)continue;if(o==-2)break;var u=r[s].folds;for(var a=0;a<u.length;a++){var f=u[a];o=f.range.compareRange(e);if(o==-2)break;if(o==2)continue;if(o==42)break;i.push(f)}}return t.column-=1,n.column+=1,i},this.getFoldsInRangeList=function(e){if(Array.isArray(e)){var t=[];e.forEach(function(e){t=t.concat(this.getFoldsInRange(e))},this)}else var t=this.getFoldsInRange(e);return t},this.getAllFolds=function(){var e=[],t=this.$foldData;for(var n=0;n<t.length;n++)for(var r=0;r<t[n].folds.length;r++)e.push(t[n].folds[r]);return e},this.getFoldStringAt=function(e,t,n,r){r=r||this.getFoldLine(e);if(!r)return null;var i={end:{column:0}},s,o;for(var u=0;u<r.folds.length;u++){o=r.folds[u];var a=o.range.compareEnd(e,t);if(a==-1){s=this.getLine(o.start.row).substring(i.end.column,o.start.column);break}if(a===0)return null;i=o}return s||(s=this.getLine(o.start.row).substring(i.end.column)),n==-1?s.substring(0,t-i.end.column):n==1?s.substring(t-i.end.column):s},this.getFoldLine=function(e,t){var n=this.$foldData,r=0;t&&(r=n.indexOf(t)),r==-1&&(r=0);for(r;r<n.length;r++){var i=n[r];if(i.start.row<=e&&i.end.row>=e)return i;if(i.end.row>e)return null}return null},this.getNextFoldLine=function(e,t){var n=this.$foldData,r=0;t&&(r=n.indexOf(t)),r==-1&&(r=0);for(r;r<n.length;r++){var i=n[r];if(i.end.row>=e)return i}return null},this.getFoldedRowCount=function(e,t){var n=this.$foldData,r=t-e+1;for(var i=0;i<n.length;i++){var s=n[i],o=s.end.row,u=s.start.row;if(o>=t){u<t&&(u>=e?r-=t-u:r=0);break}o>=e&&(u>=e?r-=o-u:r-=o-e+1)}return r},this.$addFoldLine=function(e){return this.$foldData.push(e),this.$foldData.sort(function(e,t){return e.start.row-t.start.row}),e},this.addFold=function(e,t){var n=this.$foldData,r=!1,o;e instanceof s?o=e:(o=new s(t,e),o.collapseChildren=t.collapseChildren),this.$clipRangeToDocument(o.range);var u=o.start.row,a=o.start.column,f=o.end.row,l=o.end.column,c=this.getFoldAt(u,a,1),h=this.getFoldAt(f,l,-1);if(c&&h==c)return c.addSubFold(o);c&&!c.range.isStart(u,a)&&this.removeFold(c),h&&!h.range.isEnd(f,l)&&this.removeFold(h);var p=this.getFoldsInRange(o.range);p.length>0&&(this.removeFolds(p),o.collapseChildren||p.forEach(function(e){o.addSubFold(e)}));for(var d=0;d<n.length;d++){var v=n[d];if(f==v.start.row){v.addFold(o),r=!0;break}if(u==v.end.row){v.addFold(o),r=!0;if(!o.sameRow){var m=n[d+1];if(m&&m.start.row==f){v.merge(m);break}}break}if(f<=v.start.row)break}return r||(v=this.$addFoldLine(new i(this.$foldData,o))),this.$useWrapMode?this.$updateWrapData(v.start.row,v.start.row):this.$updateRowLengthCache(v.start.row,v.start.row),this.$modified=!0,this._signal("changeFold",{data:o,action:"add"}),o},this.addFolds=function(e){e.forEach(function(e){this.addFold(e)},this)},this.removeFold=function(e){var t=e.foldLine,n=t.start.row,r=t.end.row,i=this.$foldData,s=t.folds;if(s.length==1)i.splice(i.indexOf(t),1);else if(t.range.isEnd(e.end.row,e.end.column))s.pop(),t.end.row=s[s.length-1].end.row,t.end.column=s[s.length-1].end.column;else if(t.range.isStart(e.start.row,e.start.column))s.shift(),t.start.row=s[0].start.row,t.start.column=s[0].start.column;else if(e.sameRow)s.splice(s.indexOf(e),1);else{var o=t.split(e.start.row,e.start.column);s=o.folds,s.shift(),o.start.row=s[0].start.row,o.start.column=s[0].start.column}this.$updating||(this.$useWrapMode?this.$updateWrapData(n,r):this.$updateRowLengthCache(n,r)),this.$modified=!0,this._signal("changeFold",{data:e,action:"remove"})},this.removeFolds=function(e){var t=[];for(var n=0;n<e.length;n++)t.push(e[n]);t.forEach(function(e){this.removeFold(e)},this),this.$modified=!0},this.expandFold=function(e){this.removeFold(e),e.subFolds.forEach(function(t){e.restoreRange(t),this.addFold(t)},this),e.collapseChildren>0&&this.foldAll(e.start.row+1,e.end.row,e.collapseChildren-1),e.subFolds=[]},this.expandFolds=function(e){e.forEach(function(e){this.expandFold(e)},this)},this.unfold=function(e,t){var n,i;if(e==null)n=new r(0,0,this.getLength(),0),t==null&&(t=!0);else if(typeof e=="number")n=new r(e,0,e,this.getLine(e).length);else if("row"in e)n=r.fromPoints(e,e);else{if(Array.isArray(e))return i=[],e.forEach(function(e){i=i.concat(this.unfold(e))},this),i;n=e}i=this.getFoldsInRangeList(n);var s=i;while(i.length==1&&r.comparePoints(i[0].start,n.start)<0&&r.comparePoints(i[0].end,n.end)>0)this.expandFolds(i),i=this.getFoldsInRangeList(n);t!=0?this.removeFolds(i):this.expandFolds(i);if(s.length)return s},this.isRowFolded=function(e,t){return!!this.getFoldLine(e,t)},this.getRowFoldEnd=function(e,t){var n=this.getFoldLine(e,t);return n?n.end.row:e},this.getRowFoldStart=function(e,t){var n=this.getFoldLine(e,t);return n?n.start.row:e},this.getFoldDisplayLine=function(e,t,n,r,i){r==null&&(r=e.start.row),i==null&&(i=0),t==null&&(t=e.end.row),n==null&&(n=this.getLine(t).length);var s=this.doc,o="";return e.walk(function(e,t,n,u){if(t<r)return;if(t==r){if(n<i)return;u=Math.max(i,u)}e!=null?o+=e:o+=s.getLine(t).substring(u,n)},t,n),o},this.getDisplayLine=function(e,t,n,r){var i=this.getFoldLine(e);if(!i){var s;return s=this.doc.getLine(e),s.substring(r||0,t||s.length)}return this.getFoldDisplayLine(i,e,t,n,r)},this.$cloneFoldData=function(){var e=[];return e=this.$foldData.map(function(t){var n=t.folds.map(function(e){return e.clone()});return new i(e,n)}),e},this.toggleFold=function(e){var t=this.selection,n=t.getRange(),r,i;if(n.isEmpty()){var s=n.start;r=this.getFoldAt(s.row,s.column);if(r){this.expandFold(r);return}if(e){var o=this.getFoldLine(s.row);o&&this.expandFolds(o.folds);return}(i=this.findMatchingBracket(s))?n.comparePoint(i)==1?n.end=i:(n.start=i,n.start.column++,n.end.column--):(i=this.findMatchingBracket({row:s.row,column:s.column+1}))?(n.comparePoint(i)==1?n.end=i:n.start=i,n.start.column++):n=this.getCommentFoldRange(s.row,s.column)||n}else{var u=this.getFoldsInRange(n);if(e&&u.length){this.expandFolds(u);return}u.length==1&&(r=u[0])}r||(r=this.getFoldAt(n.start.row,n.start.column));if(r&&r.range.toString()==n.toString()){this.expandFold(r);return}var a="...";if(!n.isMultiLine()){a=this.getTextRange(n);if(a.length<4)return;a=a.trim().substring(0,2)+".."}this.addFold(a,n)},this.getCommentFoldRange=function(e,t,n){var i=new o(this,e,t),s=i.getCurrentToken(),u=s&&s.type;if(s&&/^comment|string/.test(u)){u=u.match(/comment|string/)[0],u=="comment"&&(u+="|doc-start|\\.doc");var a=new RegExp(u),f=new r;if(n!=1){do s=i.stepBackward();while(s&&a.test(s.type));s=i.stepForward()}f.start.row=i.getCurrentTokenRow(),f.start.column=i.getCurrentTokenColumn()+s.value.length,i=new o(this,e,t);var l=this.getState(i.$row);if(n!=-1){var c=-1;do{s=i.stepForward();if(c==-1){var h=this.getState(i.$row);l.toString()!==h.toString()&&(c=i.$row)}else if(i.$row>c)break}while(s&&a.test(s.type));s=i.stepBackward()}else s=i.getCurrentToken();f.end.row=i.getCurrentTokenRow(),f.end.column=i.getCurrentTokenColumn();if(f.start.row==f.end.row&&f.start.column>f.end.column)return;return f}},this.foldAll=function(e,t,n,r){n==undefined&&(n=1e5);var i=this.foldWidgets;if(!i)return;t=t||this.getLength(),e=e||0;for(var s=e;s<t;s++){i[s]==null&&(i[s]=this.getFoldWidget(s));if(i[s]!="start")continue;if(r&&!r(s))continue;var o=this.getFoldWidgetRange(s);o&&o.isMultiLine()&&o.end.row<=t&&o.start.row>=e&&(s=o.end.row,o.collapseChildren=n,this.addFold("...",o))}},this.foldToLevel=function(e){this.foldAll();while(e-->0)this.unfold(null,!1)},this.foldAllComments=function(){var e=this;this.foldAll(null,null,null,function(t){var n=e.getTokens(t);for(var r=0;r<n.length;r++){var i=n[r];if(i.type=="text"&&/^\s+$/.test(i.value))continue;return/comment/.test(i.type)?!0:!1}})},this.$foldStyles={manual:1,markbegin:1,markbeginend:1},this.$foldStyle="markbegin",this.setFoldStyle=function(e){if(!this.$foldStyles[e])throw new Error("invalid fold style: "+e+"["+Object.keys(this.$foldStyles).join(", ")+"]");if(this.$foldStyle==e)return;this.$foldStyle=e,e=="manual"&&this.unfold();var t=this.$foldMode;this.$setFolding(null),this.$setFolding(t)},this.$setFolding=function(e){if(this.$foldMode==e)return;this.$foldMode=e,this.off("change",this.$updateFoldWidgets),this.off("tokenizerUpdate",this.$tokenizerUpdateFoldWidgets),this._signal("changeAnnotation");if(!e||this.$foldStyle=="manual"){this.foldWidgets=null;return}this.foldWidgets=[],this.getFoldWidget=e.getFoldWidget.bind(e,this,this.$foldStyle),this.getFoldWidgetRange=e.getFoldWidgetRange.bind(e,this,this.$foldStyle),this.$updateFoldWidgets=this.updateFoldWidgets.bind(this),this.$tokenizerUpdateFoldWidgets=this.tokenizerUpdateFoldWidgets.bind(this),this.on("change",this.$updateFoldWidgets),this.on("tokenizerUpdate",this.$tokenizerUpdateFoldWidgets)},this.getParentFoldRangeData=function(e,t){var n=this.foldWidgets;if(!n||t&&n[e])return{};var r=e-1,i;while(r>=0){var s=n[r];s==null&&(s=n[r]=this.getFoldWidget(r));if(s=="start"){var o=this.getFoldWidgetRange(r);i||(i=o);if(o&&o.end.row>=e)break}r--}return{range:r!==-1&&o,firstRange:i}},this.onFoldWidgetClick=function(e,t){t instanceof u&&(t=t.domEvent);var n={children:t.shiftKey,all:t.ctrlKey||t.metaKey,siblings:t.altKey},r=this.$toggleFoldWidget(e,n);if(!r){var i=t.target||t.srcElement;i&&/ace_fold-widget/.test(i.className)&&(i.className+=" ace_invalid")}},this.$toggleFoldWidget=function(e,t){if(!this.getFoldWidget)return;var n=this.getFoldWidget(e),r=this.getLine(e),i=n==="end"?-1:1,s=this.getFoldAt(e,i===-1?0:r.length,i);if(s)return t.children||t.all?this.removeFold(s):this.expandFold(s),s;var o=this.getFoldWidgetRange(e,!0);if(o&&!o.isMultiLine()){s=this.getFoldAt(o.start.row,o.start.column,1);if(s&&o.isEqual(s.range))return this.removeFold(s),s}if(t.siblings){var u=this.getParentFoldRangeData(e);if(u.range)var a=u.range.start.row+1,f=u.range.end.row;this.foldAll(a,f,t.all?1e4:0)}else t.children?(f=o?o.end.row:this.getLength(),this.foldAll(e+1,f,t.all?1e4:0)):o&&(t.all&&(o.collapseChildren=1e4),this.addFold("...",o));return o},this.toggleFoldWidget=function(e){var t=this.selection.getCursor().row;t=this.getRowFoldStart(t);var n=this.$toggleFoldWidget(t,{});if(n)return;var r=this.getParentFoldRangeData(t,!0);n=r.range||r.firstRange;if(n){t=n.start.row;var i=this.getFoldAt(t,this.getLine(t).length,1);i?this.removeFold(i):this.addFold("...",n)}},this.updateFoldWidgets=function(e){var t=e.start.row,n=e.end.row-t;if(n===0)this.foldWidgets[t]=null;else if(e.action=="remove")this.foldWidgets.splice(t,n+1,null);else{var r=Array(n+1);r.unshift(t,1),this.foldWidgets.splice.apply(this.foldWidgets,r)}},this.tokenizerUpdateFoldWidgets=function(e){var t=e.data;t.first!=t.last&&this.foldWidgets.length>t.first&&this.foldWidgets.splice(t.first,this.foldWidgets.length)}}var r=e("../range").Range,i=e("./fold_line").FoldLine,s=e("./fold").Fold,o=e("../token_iterator").TokenIterator,u=e("../mouse/mouse_event").MouseEvent;t.Folding=a}),define("ace/edit_session/bracket_match",["require","exports","module","ace/token_iterator","ace/range"],function(e,t,n){"use strict";function s(){this.findMatchingBracket=function(e,t){if(e.column==0)return null;var n=t||this.getLine(e.row).charAt(e.column-1);if(n=="")return null;var r=n.match(/([\(\[\{])|([\)\]\}])/);return r?r[1]?this.$findClosingBracket(r[1],e):this.$findOpeningBracket(r[2],e):null},this.getBracketRange=function(e){var t=this.getLine(e.row),n=!0,r,s=t.charAt(e.column-1),o=s&&s.match(/([\(\[\{])|([\)\]\}])/);o||(s=t.charAt(e.column),e={row:e.row,column:e.column+1},o=s&&s.match(/([\(\[\{])|([\)\]\}])/),n=!1);if(!o)return null;if(o[1]){var u=this.$findClosingBracket(o[1],e);if(!u)return null;r=i.fromPoints(e,u),n||(r.end.column++,r.start.column--),r.cursor=r.end}else{var u=this.$findOpeningBracket(o[2],e);if(!u)return null;r=i.fromPoints(u,e),n||(r.start.column++,r.end.column--),r.cursor=r.start}return r},this.getMatchingBracketRanges=function(e,t){var n=this.getLine(e.row),r=/([\(\[\{])|([\)\]\}])/,s=!t&&n.charAt(e.column-1),o=s&&s.match(r);o||(s=(t===undefined||t)&&n.charAt(e.column),e={row:e.row,column:e.column+1},o=s&&s.match(r));if(!o)return null;var u=new i(e.row,e.column-1,e.row,e.column),a=o[1]?this.$findClosingBracket(o[1],e):this.$findOpeningBracket(o[2],e);if(!a)return[u];var f=new i(a.row,a.column,a.row,a.column+1);return[u,f]},this.$brackets={")":"(","(":")","]":"[","[":"]","{":"}","}":"{","<":">",">":"<"},this.$findOpeningBracket=function(e,t,n){var i=this.$brackets[e],s=1,o=new r(this,t.row,t.column),u=o.getCurrentToken();u||(u=o.stepForward());if(!u)return;n||(n=new RegExp("(\\.?"+u.type.replace(".","\\.").replace("rparen",".paren").replace(/\b(?:end)\b/,"(?:start|begin|end)").replace(/-close\b/,"-(close|open)")+")+"));var a=t.column-o.getCurrentTokenColumn()-2,f=u.value;for(;;){while(a>=0){var l=f.charAt(a);if(l==i){s-=1;if(s==0)return{row:o.getCurrentTokenRow(),column:a+o.getCurrentTokenColumn()}}else l==e&&(s+=1);a-=1}do u=o.stepBackward();while(u&&!n.test(u.type));if(u==null)break;f=u.value,a=f.length-1}return null},this.$findClosingBracket=function(e,t,n){var i=this.$brackets[e],s=1,o=new r(this,t.row,t.column),u=o.getCurrentToken();u||(u=o.stepForward());if(!u)return;n||(n=new RegExp("(\\.?"+u.type.replace(".","\\.").replace("lparen",".paren").replace(/\b(?:start|begin)\b/,"(?:start|begin|end)").replace(/-open\b/,"-(close|open)")+")+"));var a=t.column-o.getCurrentTokenColumn();for(;;){var f=u.value,l=f.length;while(a<l){var c=f.charAt(a);if(c==i){s-=1;if(s==0)return{row:o.getCurrentTokenRow(),column:a+o.getCurrentTokenColumn()}}else c==e&&(s+=1);a+=1}do u=o.stepForward();while(u&&!n.test(u.type));if(u==null)break;a=0}return null},this.getMatchingTags=function(e){var t=new r(this,e.row,e.column),n=this.$findTagName(t);if(!n)return;var i=t.stepBackward();return i.value==="<"?this.$findClosingTag(t,n):this.$findOpeningTag(t,n)},this.$findTagName=function(e){var t=e.getCurrentToken(),n=!1,r=!1;if(t&&t.type.indexOf("tag-name")===-1)do r?t=e.stepBackward():t=e.stepForward(),t&&(t.value==="/>"?r=!0:t.type.indexOf("tag-name")!==-1&&(n=!0));while(t&&!n);return t},this.$findClosingTag=function(e,t){var n,r=t.value,s=t.value,o=0,u=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+1);t=e.stepForward();var a=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+t.value.length),f=!1;do{n=t;if(n.type.indexOf("tag-close")!==-1&&!f){var l=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+1);f=!0}t=e.stepForward();if(t){if(t.value===">"&&!f){var l=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+1);f=!0}if(t.type.indexOf("tag-name")!==-1){r=t.value;if(s===r)if(n.value==="<")o++;else if(n.value==="</"){o--;if(o<0){e.stepBackward();var c=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+2);t=e.stepForward();var h=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+t.value.length);t.type.indexOf("tag-close")===-1&&(t=e.stepForward());if(!t||t.value!==">")return;var p=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+1)}}}else if(s===r&&t.value==="/>"){o--;if(o<0)var c=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+2),h=c,p=h,l=new i(a.end.row,a.end.column,a.end.row,a.end.column+1)}}}while(t&&o>=0);if(u&&l&&c&&p&&a&&h)return{openTag:new i(u.start.row,u.start.column,l.end.row,l.end.column),closeTag:new i(c.start.row,c.start.column,p.end.row,p.end.column),openTagName:a,closeTagName:h}},this.$findOpeningTag=function(e,t){var n=e.getCurrentToken(),r=t.value,s=0,o=e.getCurrentTokenRow(),u=e.getCurrentTokenColumn(),a=u+2,f=new i(o,u,o,a);e.stepForward();var l=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+t.value.length);t.type.indexOf("tag-close")===-1&&(t=e.stepForward());if(!t||t.value!==">")return;var c=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+1);e.stepBackward(),e.stepBackward();do{t=n,o=e.getCurrentTokenRow(),u=e.getCurrentTokenColumn(),a=u+t.value.length,n=e.stepBackward();if(t)if(t.type.indexOf("tag-name")!==-1){if(r===t.value)if(n.value==="<"){s++;if(s>0){var h=new i(o,u,o,a),p=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+1);do t=e.stepForward();while(t&&t.value!==">");var d=new i(e.getCurrentTokenRow(),e.getCurrentTokenColumn(),e.getCurrentTokenRow(),e.getCurrentTokenColumn()+1)}}else n.value==="</"&&s--}else if(t.value==="/>"){var v=0,m=n;while(m){if(m.type.indexOf("tag-name")!==-1&&m.value===r){s--;break}if(m.value==="<")break;m=e.stepBackward(),v++}for(var g=0;g<v;g++)e.stepForward()}}while(n&&s<=0);if(p&&d&&f&&c&&h&&l)return{openTag:new i(p.start.row,p.start.column,d.end.row,d.end.column),closeTag:new i(f.start.row,f.start.column,c.end.row,c.end.column),openTagName:h,closeTagName:l}}}var r=e("../token_iterator").TokenIterator,i=e("../range").Range;t.BracketMatch=s}),define("ace/edit_session",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/bidihandler","ace/config","ace/lib/event_emitter","ace/selection","ace/mode/text","ace/range","ace/line_widgets","ace/document","ace/background_tokenizer","ace/search_highlight","ace/undomanager","ace/edit_session/folding","ace/edit_session/bracket_match"],function(e,t,n){"use strict";function N(e){return e<4352?!1:e>=4352&&e<=4447||e>=4515&&e<=4519||e>=4602&&e<=4607||e>=9001&&e<=9002||e>=11904&&e<=11929||e>=11931&&e<=12019||e>=12032&&e<=12245||e>=12272&&e<=12283||e>=12288&&e<=12350||e>=12353&&e<=12438||e>=12441&&e<=12543||e>=12549&&e<=12589||e>=12593&&e<=12686||e>=12688&&e<=12730||e>=12736&&e<=12771||e>=12784&&e<=12830||e>=12832&&e<=12871||e>=12880&&e<=13054||e>=13056&&e<=19903||e>=19968&&e<=42124||e>=42128&&e<=42182||e>=43360&&e<=43388||e>=44032&&e<=55203||e>=55216&&e<=55238||e>=55243&&e<=55291||e>=63744&&e<=64255||e>=65040&&e<=65049||e>=65072&&e<=65106||e>=65108&&e<=65126||e>=65128&&e<=65131||e>=65281&&e<=65376||e>=65504&&e<=65510}var r=e("./lib/oop"),i=e("./lib/lang"),s=e("./bidihandler").BidiHandler,o=e("./config"),u=e("./lib/event_emitter").EventEmitter,a=e("./selection").Selection,f=e("./mode/text").Mode,l=e("./range").Range,c=e("./line_widgets").LineWidgets,h=e("./document").Document,p=e("./background_tokenizer").BackgroundTokenizer,d=e("./search_highlight").SearchHighlight,v=e("./undomanager").UndoManager,m=function(){function e(t,n){this.doc,this.$breakpoints=[],this.$decorations=[],this.$frontMarkers={},this.$backMarkers={},this.$markerId=1,this.$undoSelect=!0,this.$editor=null,this.prevOp={},this.$foldData=[],this.id="session"+ ++e.$uid,this.$foldData.toString=function(){return this.join("\n")},this.$gutterCustomWidgets={},this.bgTokenizer=new p((new f).getTokenizer(),this);var r=this;this.bgTokenizer.on("update",function(e){r._signal("tokenizerUpdate",e)}),this.on("changeFold",this.onChangeFold.bind(this)),this.$onChange=this.onChange.bind(this);if(typeof t!="object"||!t.getLine)t=new h(t);this.setDocument(t),this.selection=new a(this),this.$onSelectionChange=this.onSelectionChange.bind(this),this.selection.on("changeSelection",this.$onSelectionChange),this.selection.on("changeCursor",this.$onSelectionChange),this.$bidiHandler=new s(this),o.resetOptions(this),this.setMode(n),o._signal("session",this),this.destroyed=!1,this.$initOperationListeners()}return e.prototype.$initOperationListeners=function(){var e=this;this.curOp=null,this.on("change",function(){e.curOp||(e.startOperation(),e.curOp.selectionBefore=e.$lastSel),e.curOp.docChanged=!0},!0),this.on("changeSelection",function(){e.curOp||(e.startOperation(),e.curOp.selectionBefore=e.$lastSel),e.curOp.selectionChanged=!0},!0),this.$operationResetTimer=i.delayedCall(this.endOperation.bind(this,!0))},e.prototype.startOperation=function(e){if(this.curOp){if(!e||this.curOp.command)return;this.prevOp=this.curOp}e||(e={}),this.$operationResetTimer.schedule(),this.curOp={command:e.command||{},args:e.args},this.curOp.selectionBefore=this.selection.toJSON(),this._signal("startOperation",e)},e.prototype.endOperation=function(e){if(this.curOp){if(e&&e.returnValue===!1){this.curOp=null,this._signal("endOperation",e);return}if(e==1&&this.curOp.command&&this.curOp.command.name=="mouse")return;var t=this.selection.toJSON();this.curOp.selectionAfter=t,this.$lastSel=this.selection.toJSON(),this.getUndoManager().addSelection(t),this._signal("beforeEndOperation"),this.prevOp=this.curOp,this.curOp=null,this._signal("endOperation",e)}},e.prototype.setDocument=function(e){this.doc&&this.doc.off("change",this.$onChange),this.doc=e,e.on("change",this.$onChange,!0),this.bgTokenizer.setDocument(this.getDocument()),this.resetCaches()},e.prototype.getDocument=function(){return this.doc},Object.defineProperty(e.prototype,"widgetManager",{get:function(){var e=new c(this);return this.widgetManager=e,this.$editor&&e.attach(this.$editor),e},set:function(e){Object.defineProperty(this,"widgetManager",{writable:!0,enumerable:!0,configurable:!0,value:e})},enumerable:!1,configurable:!0}),e.prototype.$resetRowCache=function(e){if(!e){this.$docRowCache=[],this.$screenRowCache=[];return}var t=this.$docRowCache.length,n=this.$getRowCacheIndex(this.$docRowCache,e)+1;t>n&&(this.$docRowCache.splice(n,t),this.$screenRowCache.splice(n,t))},e.prototype.$getRowCacheIndex=function(e,t){var n=0,r=e.length-1;while(n<=r){var i=n+r>>1,s=e[i];if(t>s)n=i+1;else{if(!(t<s))return i;r=i-1}}return n-1},e.prototype.resetCaches=function(){this.$modified=!0,this.$wrapData=[],this.$rowLengthCache=[],this.$resetRowCache(0),this.destroyed||this.bgTokenizer.start(0)},e.prototype.onChangeFold=function(e){var t=e.data;this.$resetRowCache(t.start.row)},e.prototype.onChange=function(e){this.$modified=!0,this.$bidiHandler.onChange(e),this.$resetRowCache(e.start.row);var t=this.$updateInternalDataOnChange(e);!this.$fromUndo&&this.$undoManager&&(t&&t.length&&(this.$undoManager.add({action:"removeFolds",folds:t},this.mergeUndoDeltas),this.mergeUndoDeltas=!0),this.$undoManager.add(e,this.mergeUndoDeltas),this.mergeUndoDeltas=!0,this.$informUndoManager.schedule()),this.bgTokenizer.$updateOnChange(e),this._signal("change",e)},e.prototype.onSelectionChange=function(){this._signal("changeSelection")},e.prototype.setValue=function(e){this.doc.setValue(e),this.selection.moveTo(0,0),this.$resetRowCache(0),this.setUndoManager(this.$undoManager),this.getUndoManager().reset()},e.fromJSON=function(t){typeof t=="string"&&(t=JSON.parse(t));var n=new v;n.$undoStack=t.history.$undoStack,n.$redoStack=t.history.$redoStack,n.mark=t.history.mark,n.$rev=t.history.rev;var r=new e(t.value);return t.folds.forEach(function(e){r.addFold("...",l.fromPoints(e.start,e.end))}),r.setAnnotations(t.annotations),r.setBreakpoints(t.breakpoints),r.setMode(t.mode),r.setScrollLeft(t.scrollLeft),r.setScrollTop(t.scrollTop),r.setUndoManager(n),r.selection.fromJSON(t.selection),r},e.prototype.toJSON=function(){return{annotations:this.$annotations,breakpoints:this.$breakpoints,folds:this.getAllFolds().map(function(e){return e.range}),history:this.getUndoManager(),mode:this.$mode.$id,scrollLeft:this.$scrollLeft,scrollTop:this.$scrollTop,selection:this.selection.toJSON(),value:this.doc.getValue()}},e.prototype.toString=function(){return this.doc.getValue()},e.prototype.getSelection=function(){return this.selection},e.prototype.getState=function(e){return this.bgTokenizer.getState(e)},e.prototype.getTokens=function(e){return this.bgTokenizer.getTokens(e)},e.prototype.getTokenAt=function(e,t){var n=this.bgTokenizer.getTokens(e),r,i=0;if(t==null){var s=n.length-1;i=this.getLine(e).length}else for(var s=0;s<n.length;s++){i+=n[s].value.length;if(i>=t)break}return r=n[s],r?(r.index=s,r.start=i-r.value.length,r):null},e.prototype.setUndoManager=function(e){this.$undoManager=e,this.$informUndoManager&&this.$informUndoManager.cancel();if(e){var t=this;e.addSession(this),this.$syncInformUndoManager=function(){t.$informUndoManager.cancel(),t.mergeUndoDeltas=!1},this.$informUndoManager=i.delayedCall(this.$syncInformUndoManager)}else this.$syncInformUndoManager=function(){}},e.prototype.markUndoGroup=function(){this.$syncInformUndoManager&&this.$syncInformUndoManager()},e.prototype.getUndoManager=function(){return this.$undoManager||this.$defaultUndoManager},e.prototype.getTabString=function(){return this.getUseSoftTabs()?i.stringRepeat(" ",this.getTabSize()):"	"},e.prototype.setUseSoftTabs=function(e){this.setOption("useSoftTabs",e)},e.prototype.getUseSoftTabs=function(){return this.$useSoftTabs&&!this.$mode.$indentWithTabs},e.prototype.setTabSize=function(e){this.setOption("tabSize",e)},e.prototype.getTabSize=function(){return this.$tabSize},e.prototype.isTabStop=function(e){return this.$useSoftTabs&&e.column%this.$tabSize===0},e.prototype.setNavigateWithinSoftTabs=function(e){this.setOption("navigateWithinSoftTabs",e)},e.prototype.getNavigateWithinSoftTabs=function(){return this.$navigateWithinSoftTabs},e.prototype.setOverwrite=function(e){this.setOption("overwrite",e)},e.prototype.getOverwrite=function(){return this.$overwrite},e.prototype.toggleOverwrite=function(){this.setOverwrite(!this.$overwrite)},e.prototype.addGutterDecoration=function(e,t){this.$decorations[e]||(this.$decorations[e]=""),this.$decorations[e]+=" "+t,this._signal("changeBreakpoint",{})},e.prototype.removeGutterCustomWidget=function(e){this.$editor&&this.$editor.renderer.$gutterLayer.$removeCustomWidget(e)},e.prototype.addGutterCustomWidget=function(e,t){this.$editor&&this.$editor.renderer.$gutterLayer.$addCustomWidget(e,t)},e.prototype.removeGutterDecoration=function(e,t){this.$decorations[e]=(this.$decorations[e]||"").replace(" "+t,""),this._signal("changeBreakpoint",{})},e.prototype.getBreakpoints=function(){return this.$breakpoints},e.prototype.setBreakpoints=function(e){this.$breakpoints=[];for(var t=0;t<e.length;t++)this.$breakpoints[e[t]]="ace_breakpoint";this._signal("changeBreakpoint",{})},e.prototype.clearBreakpoints=function(){this.$breakpoints=[],this._signal("changeBreakpoint",{})},e.prototype.setBreakpoint=function(e,t){t===undefined&&(t="ace_breakpoint"),t?this.$breakpoints[e]=t:delete this.$breakpoints[e],this._signal("changeBreakpoint",{})},e.prototype.clearBreakpoint=function(e){delete this.$breakpoints[e],this._signal("changeBreakpoint",{})},e.prototype.addMarker=function(e,t,n,r){var i=this.$markerId++,s={range:e,type:n||"line",renderer:typeof n=="function"?n:null,clazz:t,inFront:!!r,id:i};return r?(this.$frontMarkers[i]=s,this._signal("changeFrontMarker")):(this.$backMarkers[i]=s,this._signal("changeBackMarker")),i},e.prototype.addDynamicMarker=function(e,t){if(!e.update)return;var n=this.$markerId++;return e.id=n,e.inFront=!!t,t?(this.$frontMarkers[n]=e,this._signal("changeFrontMarker")):(this.$backMarkers[n]=e,this._signal("changeBackMarker")),e},e.prototype.removeMarker=function(e){var t=this.$frontMarkers[e]||this.$backMarkers[e];if(!t)return;var n=t.inFront?this.$frontMarkers:this.$backMarkers;delete n[e],this._signal(t.inFront?"changeFrontMarker":"changeBackMarker")},e.prototype.getMarkers=function(e){return e?this.$frontMarkers:this.$backMarkers},e.prototype.highlight=function(e){if(!this.$searchHighlight){var t=new d(null,"ace_selected-word","text");this.$searchHighlight=this.addDynamicMarker(t)}this.$searchHighlight.setRegexp(e)},e.prototype.highlightLines=function(e,t,n,r){typeof t!="number"&&(n=t,t=e),n||(n="ace_step");var i=new l(e,0,t,Infinity);return i.id=this.addMarker(i,n,"fullLine",r),i},e.prototype.setAnnotations=function(e){this.$annotations=e,this._signal("changeAnnotation",{})},e.prototype.getAnnotations=function(){return this.$annotations||[]},e.prototype.clearAnnotations=function(){this.setAnnotations([])},e.prototype.$detectNewLine=function(e){var t=e.match(/^.*?(\r?\n)/m);t?this.$autoNewLine=t[1]:this.$autoNewLine="\n"},e.prototype.getWordRange=function(e,t){var n=this.getLine(e),r=!1;t>0&&(r=!!n.charAt(t-1).match(this.tokenRe)),r||(r=!!n.charAt(t).match(this.tokenRe));if(r)var i=this.tokenRe;else if(/^\s+$/.test(n.slice(t-1,t+1)))var i=/\s/;else var i=this.nonTokenRe;var s=t;if(s>0){do s--;while(s>=0&&n.charAt(s).match(i));s++}var o=t;while(o<n.length&&n.charAt(o).match(i))o++;return new l(e,s,e,o)},e.prototype.getAWordRange=function(e,t){var n=this.getWordRange(e,t),r=this.getLine(n.end.row);while(r.charAt(n.end.column).match(/[ \t]/))n.end.column+=1;return n},e.prototype.setNewLineMode=function(e){this.doc.setNewLineMode(e)},e.prototype.getNewLineMode=function(){return this.doc.getNewLineMode()},e.prototype.setUseWorker=function(e){this.setOption("useWorker",e)},e.prototype.getUseWorker=function(){return this.$useWorker},e.prototype.onReloadTokenizer=function(e){var t=e.data;this.bgTokenizer.start(t.first),this._signal("tokenizerUpdate",e)},e.prototype.setMode=function(e,t){if(e&&typeof e=="object"){if(e.getTokenizer)return this.$onChangeMode(e);var n=e,r=n.path}else r=e||"ace/mode/text";this.$modes["ace/mode/text"]||(this.$modes["ace/mode/text"]=new f);if(this.$modes[r]&&!n){this.$onChangeMode(this.$modes[r]),t&&t();return}this.$modeId=r,o.loadModule(["mode",r],function(e){if(this.destroyed)return;if(this.$modeId!==r)return t&&t();this.$modes[r]&&!n?this.$onChangeMode(this.$modes[r]):e&&e.Mode&&(e=new e.Mode(n),n||(this.$modes[r]=e,e.$id=r),this.$onChangeMode(e)),t&&t()}.bind(this)),this.$mode||this.$onChangeMode(this.$modes["ace/mode/text"],!0)},e.prototype.$onChangeMode=function(e,t){t||(this.$modeId=e.$id);if(this.$mode===e)return;var n=this.$mode;this.$mode=e,this.$stopWorker(),this.$useWorker&&this.$startWorker();var r=e.getTokenizer();if(r.on!==undefined){var i=this.onReloadTokenizer.bind(this);r.on("update",i)}this.bgTokenizer.setTokenizer(r),this.bgTokenizer.setDocument(this.getDocument()),this.tokenRe=e.tokenRe,this.nonTokenRe=e.nonTokenRe,t||(e.attachToSession&&e.attachToSession(this),this.$options.wrapMethod.set.call(this,this.$wrapMethod),this.$setFolding(e.foldingRules),this.bgTokenizer.start(0),this._emit("changeMode",{oldMode:n,mode:e}))},e.prototype.$stopWorker=function(){this.$worker&&(this.$worker.terminate(),this.$worker=null)},e.prototype.$startWorker=function(){try{this.$worker=this.$mode.createWorker(this)}catch(e){o.warn("Could not load worker",e),this.$worker=null}},e.prototype.getMode=function(){return this.$mode},e.prototype.setScrollTop=function(e){if(this.$scrollTop===e||isNaN(e))return;this.$scrollTop=e,this._signal("changeScrollTop",e)},e.prototype.getScrollTop=function(){return this.$scrollTop},e.prototype.setScrollLeft=function(e){if(this.$scrollLeft===e||isNaN(e))return;this.$scrollLeft=e,this._signal("changeScrollLeft",e)},e.prototype.getScrollLeft=function(){return this.$scrollLeft},e.prototype.getScreenWidth=function(){return this.$computeWidth(),this.lineWidgets?Math.max(this.getLineWidgetMaxWidth(),this.screenWidth):this.screenWidth},e.prototype.getLineWidgetMaxWidth=function(){if(this.lineWidgetsWidth!=null)return this.lineWidgetsWidth;var e=0;return this.lineWidgets.forEach(function(t){t&&t.screenWidth>e&&(e=t.screenWidth)}),this.lineWidgetWidth=e},e.prototype.$computeWidth=function(e){if(this.$modified||e){this.$modified=!1;if(this.$useWrapMode)return this.screenWidth=this.$wrapLimit;var t=this.doc.getAllLines(),n=this.$rowLengthCache,r=0,i=0,s=this.$foldData[i],o=s?s.start.row:Infinity,u=t.length;for(var a=0;a<u;a++){if(a>o){a=s.end.row+1;if(a>=u)break;s=this.$foldData[i++],o=s?s.start.row:Infinity}n[a]==null&&(n[a]=this.$getStringScreenWidth(t[a])[0]),n[a]>r&&(r=n[a])}this.screenWidth=r}},e.prototype.getLine=function(e){return this.doc.getLine(e)},e.prototype.getLines=function(e,t){return this.doc.getLines(e,t)},e.prototype.getLength=function(){return this.doc.getLength()},e.prototype.getTextRange=function(e){return this.doc.getTextRange(e||this.selection.getRange())},e.prototype.insert=function(e,t){return this.doc.insert(e,t)},e.prototype.remove=function(e){return this.doc.remove(e)},e.prototype.removeFullLines=function(e,t){return this.doc.removeFullLines(e,t)},e.prototype.undoChanges=function(e,t){if(!e.length)return;this.$fromUndo=!0;for(var n=e.length-1;n!=-1;n--){var r=e[n];r.action=="insert"||r.action=="remove"?this.doc.revertDelta(r):r.folds&&this.addFolds(r.folds)}!t&&this.$undoSelect&&(e.selectionBefore?this.selection.fromJSON(e.selectionBefore):this.selection.setRange(this.$getUndoSelection(e,!0))),this.$fromUndo=!1},e.prototype.redoChanges=function(e,t){if(!e.length)return;this.$fromUndo=!0;for(var n=0;n<e.length;n++){var r=e[n];(r.action=="insert"||r.action=="remove")&&this.doc.$safeApplyDelta(r)}!t&&this.$undoSelect&&(e.selectionAfter?this.selection.fromJSON(e.selectionAfter):this.selection.setRange(this.$getUndoSelection(e,!1))),this.$fromUndo=!1},e.prototype.setUndoSelect=function(e){this.$undoSelect=e},e.prototype.$getUndoSelection=function(e,t){function n(e){return t?e.action!=="insert":e.action==="insert"}var r,i;for(var s=0;s<e.length;s++){var o=e[s];if(!o.start)continue;if(!r){n(o)?r=l.fromPoints(o.start,o.end):r=l.fromPoints(o.start,o.start);continue}n(o)?(i=o.start,r.compare(i.row,i.column)==-1&&r.setStart(i),i=o.end,r.compare(i.row,i.column)==1&&r.setEnd(i)):(i=o.start,r.compare(i.row,i.column)==-1&&(r=l.fromPoints(o.start,o.start)))}return r},e.prototype.replace=function(e,t){return this.doc.replace(e,t)},e.prototype.moveText=function(e,t,n){var r=this.getTextRange(e),i=this.getFoldsInRange(e),s=l.fromPoints(t,t);if(!n){this.remove(e);var o=e.start.row-e.end.row,u=o?-e.end.column:e.start.column-e.end.column;u&&(s.start.row==e.end.row&&s.start.column>e.end.column&&(s.start.column+=u),s.end.row==e.end.row&&s.end.column>e.end.column&&(s.end.column+=u)),o&&s.start.row>=e.end.row&&(s.start.row+=o,s.end.row+=o)}s.end=this.insert(s.start,r);if(i.length){var a=e.start,f=s.start,o=f.row-a.row,u=f.column-a.column;this.addFolds(i.map(function(e){return e=e.clone(),e.start.row==a.row&&(e.start.column+=u),e.end.row==a.row&&(e.end.column+=u),e.start.row+=o,e.end.row+=o,e}))}return s},e.prototype.indentRows=function(e,t,n){n=n.replace(/\t/g,this.getTabString());for(var r=e;r<=t;r++)this.doc.insertInLine({row:r,column:0},n)},e.prototype.outdentRows=function(e){var t=e.collapseRows(),n=new l(0,0,0,0),r=this.getTabSize();for(var i=t.start.row;i<=t.end.row;++i){var s=this.getLine(i);n.start.row=i,n.end.row=i;for(var o=0;o<r;++o)if(s.charAt(o)!=" ")break;o<r&&s.charAt(o)=="	"?(n.start.column=o,n.end.column=o+1):(n.start.column=0,n.end.column=o),this.remove(n)}},e.prototype.$moveLines=function(e,t,n){e=this.getRowFoldStart(e),t=this.getRowFoldEnd(t);if(n<0){var r=this.getRowFoldStart(e+n);if(r<0)return 0;var i=r-e}else if(n>0){var r=this.getRowFoldEnd(t+n);if(r>this.doc.getLength()-1)return 0;var i=r-t}else{e=this.$clipRowToDocument(e),t=this.$clipRowToDocument(t);var i=t-e+1}var s=new l(e,0,t,Number.MAX_VALUE),o=this.getFoldsInRange(s).map(function(e){return e=e.clone(),e.start.row+=i,e.end.row+=i,e}),u=n==0?this.doc.getLines(e,t):this.doc.removeFullLines(e,t);return this.doc.insertFullLines(e+i,u),o.length&&this.addFolds(o),i},e.prototype.moveLinesUp=function(e,t){return this.$moveLines(e,t,-1)},e.prototype.moveLinesDown=function(e,t){return this.$moveLines(e,t,1)},e.prototype.duplicateLines=function(e,t){return this.$moveLines(e,t,0)},e.prototype.$clipRowToDocument=function(e){return Math.max(0,Math.min(e,this.doc.getLength()-1))},e.prototype.$clipColumnToRow=function(e,t){return t<0?0:Math.min(this.doc.getLine(e).length,t)},e.prototype.$clipPositionToDocument=function(e,t){t=Math.max(0,t);if(e<0)e=0,t=0;else{var n=this.doc.getLength();e>=n?(e=n-1,t=this.doc.getLine(n-1).length):t=Math.min(this.doc.getLine(e).length,t)}return{row:e,column:t}},e.prototype.$clipRangeToDocument=function(e){e.start.row<0?(e.start.row=0,e.start.column=0):e.start.column=this.$clipColumnToRow(e.start.row,e.start.column);var t=this.doc.getLength()-1;return e.end.row>t?(e.end.row=t,e.end.column=this.doc.getLine(t).length):e.end.column=this.$clipColumnToRow(e.end.row,e.end.column),e},e.prototype.setUseWrapMode=function(e){if(e!=this.$useWrapMode){this.$useWrapMode=e,this.$modified=!0,this.$resetRowCache(0);if(e){var t=this.getLength();this.$wrapData=Array(t),this.$updateWrapData(0,t-1)}this._signal("changeWrapMode")}},e.prototype.getUseWrapMode=function(){return this.$useWrapMode},e.prototype.setWrapLimitRange=function(e,t){if(this.$wrapLimitRange.min!==e||this.$wrapLimitRange.max!==t)this.$wrapLimitRange={min:e,max:t},this.$modified=!0,this.$bidiHandler.markAsDirty(),this.$useWrapMode&&this._signal("changeWrapMode")},e.prototype.adjustWrapLimit=function(e,t){var n=this.$wrapLimitRange;n.max<0&&(n={min:t,max:t});var r=this.$constrainWrapLimit(e,n.min,n.max);return r!=this.$wrapLimit&&r>1?(this.$wrapLimit=r,this.$modified=!0,this.$useWrapMode&&(this.$updateWrapData(0,this.getLength()-1),this.$resetRowCache(0),this._signal("changeWrapLimit")),!0):!1},e.prototype.$constrainWrapLimit=function(e,t,n){return t&&(e=Math.max(t,e)),n&&(e=Math.min(n,e)),e},e.prototype.getWrapLimit=function(){return this.$wrapLimit},e.prototype.setWrapLimit=function(e){this.setWrapLimitRange(e,e)},e.prototype.getWrapLimitRange=function(){return{min:this.$wrapLimitRange.min,max:this.$wrapLimitRange.max}},e.prototype.$updateInternalDataOnChange=function(e){var t=this.$useWrapMode,n=e.action,r=e.start,i=e.end,s=r.row,o=i.row,u=o-s,a=null;this.$updating=!0;if(u!=0)if(n==="remove"){this[t?"$wrapData":"$rowLengthCache"].splice(s,u);var f=this.$foldData;a=this.getFoldsInRange(e),this.removeFolds(a);var l=this.getFoldLine(i.row),c=0;if(l){l.addRemoveChars(i.row,i.column,r.column-i.column),l.shiftRow(-u);var h=this.getFoldLine(s);h&&h!==l&&(h.merge(l),l=h),c=f.indexOf(l)+1}for(c;c<f.length;c++){var l=f[c];l.start.row>=i.row&&l.shiftRow(-u)}o=s}else{var p=Array(u);p.unshift(s,0);var d=t?this.$wrapData:this.$rowLengthCache;d.splice.apply(d,p);var f=this.$foldData,l=this.getFoldLine(s),c=0;if(l){var v=l.range.compareInside(r.row,r.column);v==0?(l=l.split(r.row,r.column),l&&(l.shiftRow(u),l.addRemoveChars(o,0,i.column-r.column))):v==-1&&(l.addRemoveChars(s,0,i.column-r.column),l.shiftRow(u)),c=f.indexOf(l)+1}for(c;c<f.length;c++){var l=f[c];l.start.row>=s&&l.shiftRow(u)}}else{u=Math.abs(e.start.column-e.end.column),n==="remove"&&(a=this.getFoldsInRange(e),this.removeFolds(a),u=-u);var l=this.getFoldLine(s);l&&l.addRemoveChars(s,r.column,u)}return t&&this.$wrapData.length!=this.doc.getLength()&&console.error("doc.getLength() and $wrapData.length have to be the same!"),this.$updating=!1,t?this.$updateWrapData(s,o):this.$updateRowLengthCache(s,o),a},e.prototype.$updateRowLengthCache=function(e,t){this.$rowLengthCache[e]=null,this.$rowLengthCache[t]=null},e.prototype.$updateWrapData=function(e,t){var n=this.doc.getAllLines(),r=this.getTabSize(),i=this.$wrapData,s=this.$wrapLimit,o,u,a=e;t=Math.min(t,n.length-1);while(a<=t)u=this.getFoldLine(a,u),u?(o=[],u.walk(function(e,t,r,i){var s;if(e!=null){s=this.$getDisplayTokens(e,o.length),s[0]=b;for(var u=1;u<s.length;u++)s[u]=w}else s=this.$getDisplayTokens(n[t].substring(i,r),o.length);o=o.concat(s)}.bind(this),u.end.row,n[u.end.row].length+1),i[u.start.row]=this.$computeWrapSplits(o,s,r),a=u.end.row+1):(o=this.$getDisplayTokens(n[a]),i[a]=this.$computeWrapSplits(o,s,r),a++)},e.prototype.$computeWrapSplits=function(e,t,n){function l(){var t=0;if(f===0)return t;if(a)for(var r=0;r<e.length;r++){var i=e[r];if(i==S)t+=1;else{if(i!=x){if(i==T)continue;break}t+=n}}return u&&a!==!1&&(t+=n),Math.min(t,f)}function c(t){var n=t-s;for(var i=s;i<t;i++){var u=e[i];if(u===12||u===2)n-=1}r.length||(h=l(),r.indent=h),o+=n,r.push(o),s=t}if(e.length==0)return[];var r=[],i=e.length,s=0,o=0,u=this.$wrapAsCode,a=this.$indentedSoftWrap,f=t<=Math.max(2*n,8)||a===!1?0:Math.floor(t/2),h=0;while(i-s>t-h){var p=s+t-h;if(e[p-1]>=S&&e[p]>=S){c(p);continue}if(e[p]==b||e[p]==w){for(p;p!=s-1;p--)if(e[p]==b)break;if(p>s){c(p);continue}p=s+t;for(p;p<e.length;p++)if(e[p]!=w)break;if(p==e.length)break;c(p);continue}var d=Math.max(p-(t-(t>>2)),s-1);while(p>d&&e[p]<b)p--;if(u){while(p>d&&e[p]<b)p--;while(p>d&&e[p]==E)p--}else while(p>d&&e[p]<S)p--;if(p>d){c(++p);continue}p=s+t,e[p]==y&&p--,c(p-h)}return r},e.prototype.$getDisplayTokens=function(e,t){var n=[],r;t=t||0;for(var i=0;i<e.length;i++){var s=e.charCodeAt(i);if(s==9){r=this.getScreenTabSize(n.length+t),n.push(x);for(var o=1;o<r;o++)n.push(T)}else s==32?n.push(S):s>39&&s<48||s>57&&s<64?n.push(E):s>=4352&&N(s)?n.push(g,y):n.push(g)}return n},e.prototype.$getStringScreenWidth=function(e,t,n){if(t==0)return[0,0];t==null&&(t=Infinity),n=n||0;var r,i;for(i=0;i<e.length;i++){r=e.charCodeAt(i),r==9?n+=this.getScreenTabSize(n):r>=4352&&N(r)?n+=2:n+=1;if(n>t)break}return[n,i]},e.prototype.getRowLength=function(e){var t=1;return this.lineWidgets&&(t+=this.lineWidgets[e]&&this.lineWidgets[e].rowCount||0),!this.$useWrapMode||!this.$wrapData[e]?t:this.$wrapData[e].length+t},e.prototype.getRowLineCount=function(e){return!this.$useWrapMode||!this.$wrapData[e]?1:this.$wrapData[e].length+1},e.prototype.getRowWrapIndent=function(e){if(this.$useWrapMode){var t=this.screenToDocumentPosition(e,Number.MAX_VALUE),n=this.$wrapData[t.row];return n.length&&n[0]<t.column?n.indent:0}return 0},e.prototype.getScreenLastRowColumn=function(e){var t=this.screenToDocumentPosition(e,Number.MAX_VALUE);return this.documentToScreenColumn(t.row,t.column)},e.prototype.getDocumentLastRowColumn=function(e,t){var n=this.documentToScreenRow(e,t);return this.getScreenLastRowColumn(n)},e.prototype.getDocumentLastRowColumnPosition=function(e,t){var n=this.documentToScreenRow(e,t);return this.screenToDocumentPosition(n,Number.MAX_VALUE/10)},e.prototype.getRowSplitData=function(e){return this.$useWrapMode?this.$wrapData[e]:undefined},e.prototype.getScreenTabSize=function(e){return this.$tabSize-(e%this.$tabSize|0)},e.prototype.screenToDocumentRow=function(e,t){return this.screenToDocumentPosition(e,t).row},e.prototype.screenToDocumentColumn=function(e,t){return this.screenToDocumentPosition(e,t).column},e.prototype.screenToDocumentPosition=function(e,t,n){if(e<0)return{row:0,column:0};var r,i=0,s=0,o,u=0,a=0,f=this.$screenRowCache,l=this.$getRowCacheIndex(f,e),c=f.length;if(c&&l>=0)var u=f[l],i=this.$docRowCache[l],h=e>f[c-1];else var h=!c;var p=this.getLength()-1,d=this.getNextFoldLine(i),v=d?d.start.row:Infinity;while(u<=e){a=this.getRowLength(i);if(u+a>e||i>=p)break;u+=a,i++,i>v&&(i=d.end.row+1,d=this.getNextFoldLine(i,d),v=d?d.start.row:Infinity),h&&(this.$docRowCache.push(i),this.$screenRowCache.push(u))}if(d&&d.start.row<=i)r=this.getFoldDisplayLine(d),i=d.start.row;else{if(u+a<=e||i>p)return{row:p,column:this.getLine(p).length};r=this.getLine(i),d=null}var m=0,g=Math.floor(e-u);if(this.$useWrapMode){var y=this.$wrapData[i];y&&(o=y[g],g>0&&y.length&&(m=y.indent,s=y[g-1]||y[y.length-1],r=r.substring(s)))}return n!==undefined&&this.$bidiHandler.isBidiRow(u+g,i,g)&&(t=this.$bidiHandler.offsetToCol(n)),s+=this.$getStringScreenWidth(r,t-m)[1],this.$useWrapMode&&s>=o&&(s=o-1),d?d.idxToPosition(s):{row:i,column:s}},e.prototype.documentToScreenPosition=function(e,t){if(typeof t=="undefined")var n=this.$clipPositionToDocument(e.row,e.column);else n=this.$clipPositionToDocument(e,t);e=n.row,t=n.column;var r=0,i=null,s=null;s=this.getFoldAt(e,t,1),s&&(e=s.start.row,t=s.start.column);var o,u=0,a=this.$docRowCache,f=this.$getRowCacheIndex(a,e),l=a.length;if(l&&f>=0)var u=a[f],r=this.$screenRowCache[f],c=e>a[l-1];else var c=!l;var h=this.getNextFoldLine(u),p=h?h.start.row:Infinity;while(u<e){if(u>=p){o=h.end.row+1;if(o>e)break;h=this.getNextFoldLine(o,h),p=h?h.start.row:Infinity}else o=u+1;r+=this.getRowLength(u),u=o,c&&(this.$docRowCache.push(u),this.$screenRowCache.push(r))}var d="";h&&u>=p?(d=this.getFoldDisplayLine(h,e,t),i=h.start.row):(d=this.getLine(e).substring(0,t),i=e);var v=0;if(this.$useWrapMode){var m=this.$wrapData[i];if(m){var g=0;while(d.length>=m[g])r++,g++;d=d.substring(m[g-1]||0,d.length),v=g>0?m.indent:0}}return this.lineWidgets&&this.lineWidgets[u]&&this.lineWidgets[u].rowsAbove&&(r+=this.lineWidgets[u].rowsAbove),{row:r,column:v+this.$getStringScreenWidth(d)[0]}},e.prototype.documentToScreenColumn=function(e,t){return this.documentToScreenPosition(e,t).column},e.prototype.documentToScreenRow=function(e,t){return this.documentToScreenPosition(e,t).row},e.prototype.getScreenLength=function(){var e=0,t=null;if(!this.$useWrapMode){e=this.getLength();var n=this.$foldData;for(var r=0;r<n.length;r++)t=n[r],e-=t.end.row-t.start.row}else{var i=this.$wrapData.length,s=0,r=0,t=this.$foldData[r++],o=t?t.start.row:Infinity;while(s<i){var u=this.$wrapData[s];e+=u?u.length+1:1,s++,s>o&&(s=t.end.row+1,t=this.$foldData[r++],o=t?t.start.row:Infinity)}}return this.lineWidgets&&(e+=this.$getWidgetScreenLength()),e},e.prototype.$setFontMetrics=function(e){if(!this.$enableVarChar)return;this.$getStringScreenWidth=function(t,n,r){if(n===0)return[0,0];n||(n=Infinity),r=r||0;var i,s;for(s=0;s<t.length;s++){i=t.charAt(s),i==="	"?r+=this.getScreenTabSize(r):r+=e.getCharacterWidth(i);if(r>n)break}return[r,s]}},e.prototype.getPrecedingCharacter=function(){var e=this.selection.getCursor();if(e.column===0)return e.row===0?"":this.doc.getNewLineCharacter();var t=this.getLine(e.row);return t[e.column-1]},e.prototype.destroy=function(){this.destroyed||(this.bgTokenizer.setDocument(null),this.bgTokenizer.cleanup(),this.destroyed=!0),this.endOperation(),this.$stopWorker(),this.removeAllListeners(),this.doc&&this.doc.off("change",this.$onChange),this.selection&&(this.selection.off("changeCursor",this.$onSelectionChange),this.selection.off("changeSelection",this.$onSelectionChange)),this.selection.detach()},e}();m.$uid=0,m.prototype.$modes=o.$modes,m.prototype.getValue=m.prototype.toString,m.prototype.$defaultUndoManager={undo:function(){},redo:function(){},hasUndo:function(){},hasRedo:function(){},reset:function(){},add:function(){},addSelection:function(){},startNewGroup:function(){},addSession:function(){}},m.prototype.$overwrite=!1,m.prototype.$mode=null,m.prototype.$modeId=null,m.prototype.$scrollTop=0,m.prototype.$scrollLeft=0,m.prototype.$wrapLimit=80,m.prototype.$useWrapMode=!1,m.prototype.$wrapLimitRange={min:null,max:null},m.prototype.lineWidgets=null,m.prototype.isFullWidth=N,r.implement(m.prototype,u);var g=1,y=2,b=3,w=4,E=9,S=10,x=11,T=12;e("./edit_session/folding").Folding.call(m.prototype),e("./edit_session/bracket_match").BracketMatch.call(m.prototype),o.defineOptions(m.prototype,"session",{wrap:{set:function(e){!e||e=="off"?e=!1:e=="free"?e=!0:e=="printMargin"?e=-1:typeof e=="string"&&(e=parseInt(e,10)||!1);if(this.$wrap==e)return;this.$wrap=e;if(!e)this.setUseWrapMode(!1);else{var t=typeof e=="number"?e:null;this.setWrapLimitRange(t,t),this.setUseWrapMode(!0)}},get:function(){return this.getUseWrapMode()?this.$wrap==-1?"printMargin":this.getWrapLimitRange().min?this.$wrap:"free":"off"},handlesSet:!0},wrapMethod:{set:function(e){e=e=="auto"?this.$mode.type!="text":e!="text",e!=this.$wrapAsCode&&(this.$wrapAsCode=e,this.$useWrapMode&&(this.$useWrapMode=!1,this.setUseWrapMode(!0)))},initialValue:"auto"},indentedSoftWrap:{set:function(){this.$useWrapMode&&(this.$useWrapMode=!1,this.setUseWrapMode(!0))},initialValue:!0},firstLineNumber:{set:function(){this._signal("changeBreakpoint")},initialValue:1},useWorker:{set:function(e){this.$useWorker=e,this.$stopWorker(),e&&this.$startWorker()},initialValue:!0},useSoftTabs:{initialValue:!0},tabSize:{set:function(e){e=parseInt(e),e>0&&this.$tabSize!==e&&(this.$modified=!0,this.$rowLengthCache=[],this.$tabSize=e,this._signal("changeTabSize"))},initialValue:4,handlesSet:!0},navigateWithinSoftTabs:{initialValue:!1},foldStyle:{set:function(e){this.setFoldStyle(e)},handlesSet:!0},overwrite:{set:function(e){this._signal("changeOverwrite")},initialValue:!1},newLineMode:{set:function(e){this.doc.setNewLineMode(e)},get:function(){return this.doc.getNewLineMode()},handlesSet:!0},mode:{set:function(e){this.setMode(e)},get:function(){return this.$modeId},handlesSet:!0}}),t.EditSession=m}),define("ace/search",["require","exports","module","ace/lib/lang","ace/lib/oop","ace/range"],function(e,t,n){"use strict";function u(e,t){function i(e,r){r===void 0&&(r=!0);var i=n&&t.$supportsUnicodeFlag?new RegExp("[\\p{L}\\p{N}_]","u"):new RegExp("\\w");if(i.test(e)||t.regExp)return n&&t.$supportsUnicodeFlag?r?"(?<=^|[^\\p{L}\\p{N}_])":"(?=[^\\p{L}\\p{N}_]|$)":"\\b";return""}var n=r.supportsLookbehind(),s=Array.from(e),o=s[0],u=s[s.length-1];return i(o)+e+i(u,!1)}function a(e,t,n){var r=null,i=0;while(i<=e.length){t.lastIndex=i;var s=t.exec(e);if(!s)break;var o=s.index+s[0].length;if(o>e.length-n)break;if(!r||o>r.index+r[0].length)r=s;i=s.index+1}return r}function f(e,t){var n=5e3,r={row:t,column:0},i=e.doc.positionToIndex(r),s=i+n,o=e.doc.indexToPosition(s),u=o.row;return u+1}var r=e("./lib/lang"),i=e("./lib/oop"),s=e("./range").Range,o=function(){function e(){this.$options={}}return e.prototype.set=function(e){return i.mixin(this.$options,e),this},e.prototype.getOptions=function(){return r.copyObject(this.$options)},e.prototype.setOptions=function(e){this.$options=e},e.prototype.find=function(e){var t=this.$options,n=this.$matchIterator(e,t);if(!n)return!1;var r=null;return n.forEach(function(e,n,i,o){return r=new s(e,n,i,o),n==o&&t.start&&t.start.start&&t.skipCurrent!=0&&r.isEqual(t.start)?(r=null,!1):!0}),r},e.prototype.findAll=function(e){var t=this.$options;if(!t.needle)return[];this.$assembleRegExp(t);var n=t.range,i=n?e.getLines(n.start.row,n.end.row):e.doc.getAllLines(),o=[],u=t.re;if(t.$isMultiLine){var a=u.length,f=i.length-a,l;e:for(var c=u.offset||0;c<=f;c++){for(var h=0;h<a;h++)if(i[c+h].search(u[h])==-1)continue e;var p=i[c],d=i[c+a-1],v=p.length-p.match(u[0])[0].length,m=d.match(u[a-1])[0].length;if(l&&l.end.row===c&&l.end.column>v)continue;o.push(l=new s(c,v,c+a-1,m)),a>2&&(c=c+a-2)}}else for(var g,y=0;y<i.length;y++)if(this.$isMultilineSearch(t)){var b=i.length-1;g=this.$multiLineForward(e,u,y,b);if(g){var w=g.endRow<=b?g.endRow-1:b;w>y&&(y=w),o.push(new s(g.startRow,g.startCol,g.endRow,g.endCol))}}else{g=r.getMatchOffsets(i[y],u);for(var h=0;h<g.length;h++){var E=g[h];o.push(new s(y,E.offset,y,E.offset+E.length))}}if(n){var S=n.start.column,x=n.end.column,y=0,h=o.length-1;while(y<h&&o[y].start.column<S&&o[y].start.row==0)y++;var T=n.end.row-n.start.row;while(y<h&&o[h].end.column>x&&o[h].end.row==T)h--;o=o.slice(y,h+1);for(y=0,h=o.length;y<h;y++)o[y].start.row+=n.start.row,o[y].end.row+=n.start.row}return o},e.prototype.parseReplaceString=function(e){var t={DollarSign:36,Ampersand:38,Digit0:48,Digit1:49,Digit9:57,Backslash:92,n:110,t:116},n="";for(var r=0,i=e.length;r<i;r++){var s=e.charCodeAt(r);if(s===t.Backslash){r++;if(r>=i){n+="\\";break}var o=e.charCodeAt(r);switch(o){case t.Backslash:n+="\\";break;case t.n:n+="\n";break;case t.t:n+="	"}continue}if(s===t.DollarSign){r++;if(r>=i){n+="$";break}var u=e.charCodeAt(r);if(u===t.DollarSign){n+="$$";continue}if(u===t.Digit0||u===t.Ampersand){n+="$&";continue}if(t.Digit1<=u&&u<=t.Digit9){n+="$"+e[r];continue}}n+=e[r]}return n||e},e.prototype.replace=function(e,t){var n=this.$options,r=this.$assembleRegExp(n);if(n.$isMultiLine)return t;if(!r)return;var i=this.$isMultilineSearch(n);i&&(e=e.replace(/\r\n|\r|\n/g,"\n"));var s=r.exec(e);if(!s||!i&&s[0].length!=e.length)return null;t=n.regExp?this.parseReplaceString(t):t.replace(/\$/g,"$$$$"),t=e.replace(r,t);if(n.preserveCase){t=t.split("");for(var o=Math.min(e.length,e.length);o--;){var u=e[o];u&&u.toLowerCase()!=u?t[o]=t[o].toUpperCase():t[o]=t[o].toLowerCase()}t=t.join("")}return t},e.prototype.$assembleRegExp=function(e,t){if(e.needle instanceof RegExp)return e.re=e.needle;var n=e.needle;if(!e.needle)return e.re=!1;e.regExp||(n=r.escapeRegExp(n));var i=e.caseSensitive?"gm":"gmi";try{new RegExp(n,"u"),e.$supportsUnicodeFlag=!0,i+="u"}catch(s){e.$supportsUnicodeFlag=!1}e.wholeWord&&(n=u(n,e)),e.$isMultiLine=!t&&/[\n\r]/.test(n);if(e.$isMultiLine)return e.re=this.$assembleMultilineRegExp(n,i);try{var o=new RegExp(n,i)}catch(s){o=!1}return e.re=o},e.prototype.$assembleMultilineRegExp=function(e,t){var n=e.replace(/\r\n|\r|\n/g,"$\n^").split("\n"),r=[];for(var i=0;i<n.length;i++)try{r.push(new RegExp(n[i],t))}catch(s){return!1}return r},e.prototype.$isMultilineSearch=function(e){return e.re&&/\\r\\n|\\r|\\n/.test(e.re.source)&&e.regExp&&!e.$isMultiLine},e.prototype.$multiLineForward=function(e,t,n,r){var i,s=f(e,n);for(var o=n;o<=r;){for(var u=0;u<s;u++){if(o>r)break;var a=e.getLine(o++);i=i==null?a:i+"\n"+a}var l=t.exec(i);t.lastIndex=0;if(l){var c=i.slice(0,l.index).split("\n"),h=l[0].split("\n"),p=n+c.length-1,d=c[c.length-1].length,v=p+h.length-1,m=h.length==1?d+h[0].length:h[h.length-1].length;return{startRow:p,startCol:d,endRow:v,endCol:m}}}return null},e.prototype.$multiLineBackward=function(e,t,n,r,i){var s,o=f(e,r),u=e.getLine(r).length-n;for(var l=r;l>=i;){for(var c=0;c<o&&l>=i;c++){var h=e.getLine(l--);s=s==null?h:h+"\n"+s}var p=a(s,t,u);if(p){var d=s.slice(0,p.index).split("\n"),v=p[0].split("\n"),m=l+d.length,g=d[d.length-1].length,y=m+v.length-1,b=v.length==1?g+v[0].length:v[v.length-1].length;return{startRow:m,startCol:g,endRow:y,endCol:b}}}return null},e.prototype.$matchIterator=function(e,t){var n=this.$assembleRegExp(t);if(!n)return!1;var i=this.$isMultilineSearch(t),s=this.$multiLineForward,o=this.$multiLineBackward,u=t.backwards==1,a=t.skipCurrent!=0,f=n.unicode,l=t.range,c=t.start;c||(c=l?l[u?"end":"start"]:e.selection.getRange()),c.start&&(c=c[a!=u?"end":"start"]);var h=l?l.start.row:0,p=l?l.end.row:e.getLength()-1;if(u)var d=function(e){var n=c.row;if(m(n,c.column,e))return;for(n--;n>=h;n--)if(m(n,Number.MAX_VALUE,e))return;if(t.wrap==0)return;for(n=p,h=c.row;n>=h;n--)if(m(n,Number.MAX_VALUE,e))return};else var d=function(e){var n=c.row;if(m(n,c.column,e))return;for(n+=1;n<=p;n++)if(m(n,0,e))return;if(t.wrap==0)return;for(n=h,p=c.row;n<=p;n++)if(m(n,0,e))return};if(t.$isMultiLine)var v=n.length,m=function(t,r,i){var s=u?t-v+1:t;if(s<0||s+v>e.getLength())return;var o=e.getLine(s),a=o.search(n[0]);if(!u&&a<r||a===-1)return;for(var f=1;f<v;f++){o=e.getLine(s+f);if(o.search(n[f])==-1)return}var l=o.match(n[v-1])[0].length;if(u&&l>r)return;if(i(s,a,s+v-1,l))return!0};else if(u)var m=function(t,s,u){if(i){var a=o(e,n,s,t,h);if(!a)return!1;if(u(a.startRow,a.startCol,a.endRow,a.endCol))return!0}else{var l=e.getLine(t),c=[],p,d=0;n.lastIndex=0;while(p=n.exec(l)){var v=p[0].length;d=p.index;if(!v){if(d>=l.length)break;n.lastIndex=d+=r.skipEmptyMatch(l,d,f)}if(p.index+v>s)break;c.push(p.index,v)}for(var m=c.length-1;m>=0;m-=2){var g=c[m-1],v=c[m];if(u(t,g,t,g+v))return!0}}};else var m=function(t,o,u){n.lastIndex=o;if(i){var a=s(e,n,t,p);if(a){var l=a.endRow<=p?a.endRow-1:p;l>t&&(t=l)}if(!a)return!1;if(u(a.startRow,a.startCol,a.endRow,a.endCol))return!0}else{var c=e.getLine(t),h,d;while(d=n.exec(c)){var v=d[0].length;h=d.index;if(u(t,h,t,h+v))return!0;if(!v){n.lastIndex=h+=r.skipEmptyMatch(c,h,f);if(h>=c.length)return!1}}}};return{forEach:d}},e}();t.Search=o}),define("ace/keyboard/hash_handler",["require","exports","module","ace/lib/keys","ace/lib/useragent"],function(e,t,n){"use strict";function a(e){return typeof e=="object"&&e.bindKey&&e.bindKey.position||(e.isDefault?-100:0)}var r=this&&this.__extends||function(){var e=function(t,n){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},e(t,n)};return function(t,n){function r(){this.constructor=t}if(typeof n!="function"&&n!==null)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");e(t,n),t.prototype=n===null?Object.create(n):(r.prototype=n.prototype,new r)}}(),i=e("../lib/keys"),s=e("../lib/useragent"),o=i.KEY_MODS,u=function(){function e(e,t){this.$init(e,t,!1)}return e.prototype.$init=function(e,t,n){this.platform=t||(s.isMac?"mac":"win"),this.commands={},this.commandKeyBinding={},this.addCommands(e),this.$singleCommand=n},e.prototype.addCommand=function(e){this.commands[e.name]&&this.removeCommand(e),this.commands[e.name]=e,e.bindKey&&this._buildKeyHash(e)},e.prototype.removeCommand=function(e,t){var n=e&&(typeof e=="string"?e:e.name);e=this.commands[n],t||delete this.commands[n];var r=this.commandKeyBinding;for(var i in r){var s=r[i];if(s==e)delete r[i];else if(Array.isArray(s)){var o=s.indexOf(e);o!=-1&&(s.splice(o,1),s.length==1&&(r[i]=s[0]))}}},e.prototype.bindKey=function(e,t,n){typeof e=="object"&&e&&(n==undefined&&(n=e.position),e=e[this.platform]);if(!e)return;if(typeof t=="function")return this.addCommand({exec:t,bindKey:e,name:t.name||e});e.split("|").forEach(function(e){var r="";if(e.indexOf(" ")!=-1){var i=e.split(/\s+/);e=i.pop(),i.forEach(function(e){var t=this.parseKeys(e),n=o[t.hashId]+t.key;r+=(r?" ":"")+n,this._addCommandToBinding(r,"chainKeys")},this),r+=" "}var s=this.parseKeys(e),u=o[s.hashId]+s.key;this._addCommandToBinding(r+u,t,n)},this)},e.prototype._addCommandToBinding=function(e,t,n){var r=this.commandKeyBinding,i;if(!t)delete r[e];else if(!r[e]||this.$singleCommand)r[e]=t;else{Array.isArray(r[e])?(i=r[e].indexOf(t))!=-1&&r[e].splice(i,1):r[e]=[r[e]],typeof n!="number"&&(n=a(t));var s=r[e];for(i=0;i<s.length;i++){var o=s[i],u=a(o);if(u>n)break}s.splice(i,0,t)}},e.prototype.addCommands=function(e){e&&Object.keys(e).forEach(function(t){var n=e[t];if(!n)return;if(typeof n=="string")return this.bindKey(n,t);typeof n=="function"&&(n={exec:n});if(typeof n!="object")return;n.name||(n.name=t),this.addCommand(n)},this)},e.prototype.removeCommands=function(e){Object.keys(e).forEach(function(t){this.removeCommand(e[t])},this)},e.prototype.bindKeys=function(e){Object.keys(e).forEach(function(t){this.bindKey(t,e[t])},this)},e.prototype._buildKeyHash=function(e){this.bindKey(e.bindKey,e)},e.prototype.parseKeys=function(e){var t=e.toLowerCase().split(/[\-\+]([\-\+])?/).filter(function(e){return e}),n=t.pop(),r=i[n];if(i.FUNCTION_KEYS[r])n=i.FUNCTION_KEYS[r].toLowerCase();else{if(!t.length)return{key:n,hashId:-1};if(t.length==1&&t[0]=="shift")return{key:n.toUpperCase(),hashId:-1}}var s=0;for(var o=t.length;o--;){var u=i.KEY_MODS[t[o]];if(u==null)return typeof console!="undefined"&&console.error("invalid modifier "+t[o]+" in "+e),!1;s|=u}return{key:n,hashId:s}},e.prototype.findKeyCommand=function(e,t){var n=o[e]+t;return this.commandKeyBinding[n]},e.prototype.handleKeyboard=function(e,t,n,r){if(r<0)return;var i=o[t]+n,s=this.commandKeyBinding[i];e.$keyChain&&(e.$keyChain+=" "+i,s=this.commandKeyBinding[e.$keyChain]||s);if(s)if(s=="chainKeys"||s[s.length-1]=="chainKeys")return e.$keyChain=e.$keyChain||i,{command:"null"};if(e.$keyChain)if(!!t&&t!=4||n.length!=1){if(t==-1||r>0)e.$keyChain=""}else e.$keyChain=e.$keyChain.slice(0,-i.length-1);return{command:s}},e.prototype.getStatusText=function(e,t){return t.$keyChain||""},e}(),f=function(e){function t(t,n){var r=e.call(this,t,n)||this;return r.$singleCommand=!0,r}return r(t,e),t}(u);f.call=function(e,t,n){u.prototype.$init.call(e,t,n,!0)},u.call=function(e,t,n){u.prototype.$init.call(e,t,n,!1)},t.HashHandler=f,t.MultiHashHandler=u}),define("ace/commands/command_manager",["require","exports","module","ace/lib/oop","ace/keyboard/hash_handler","ace/lib/event_emitter"],function(e,t,n){"use strict";var r=this&&this.__extends||function(){var e=function(t,n){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},e(t,n)};return function(t,n){function r(){this.constructor=t}if(typeof n!="function"&&n!==null)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");e(t,n),t.prototype=n===null?Object.create(n):(r.prototype=n.prototype,new r)}}(),i=e("../lib/oop"),s=e("../keyboard/hash_handler").MultiHashHandler,o=e("../lib/event_emitter").EventEmitter,u=function(e){function t(t,n){var r=e.call(this,n,t)||this;return r.byName=r.commands,r.setDefaultHandler("exec",function(e){return e.args?e.command.exec(e.editor,e.args,e.event,!1):e.command.exec(e.editor,{},e.event,!0)}),r}return r(t,e),t.prototype.exec=function(e,t,n){if(Array.isArray(e)){for(var r=e.length;r--;)if(this.exec(e[r],t,n))return!0;return!1}typeof e=="string"&&(e=this.commands[e]);var i={editor:t,command:e,args:n};return this.canExecute(e,t)?(i.returnValue=this._emit("exec",i),this._signal("afterExec",i),i.returnValue===!1?!1:!0):(this._signal("commandUnavailable",i),!1)},t.prototype.canExecute=function(e,t){return typeof e=="string"&&(e=this.commands[e]),e?t&&t.$readOnly&&!e.readOnly?!1:this.$checkCommandState!=0&&e.isAvailable&&!e.isAvailable(t)?!1:!0:!1},t.prototype.toggleRecording=function(e){if(this.$inReplay)return;return e&&e._emit("changeStatus"),this.recording?(this.macro.pop(),this.off("exec",this.$addCommandToMacro),this.macro.length||(this.macro=this.oldMacro),this.recording=!1):(this.$addCommandToMacro||(this.$addCommandToMacro=function(e){this.macro.push([e.command,e.args])}.bind(this)),this.oldMacro=this.macro,this.macro=[],this.on("exec",this.$addCommandToMacro),this.recording=!0)},t.prototype.replay=function(e){if(this.$inReplay||!this.macro)return;if(this.recording)return this.toggleRecording(e);try{this.$inReplay=!0,this.macro.forEach(function(t){typeof t=="string"?this.exec(t,e):this.exec(t[0],e,t[1])},this)}finally{this.$inReplay=!1}},t.prototype.trimMacro=function(e){return e.map(function(e){return typeof e[0]!="string"&&(e[0]=e[0].name),e[1]||(e=e[0]),e})},t}(s);i.implement(u.prototype,o),t.CommandManager=u}),define("ace/commands/default_commands",["require","exports","module","ace/lib/lang","ace/config","ace/range"],function(e,t,n){"use strict";function o(e,t){return{win:e,mac:t}}var r=e("../lib/lang"),i=e("../config"),s=e("../range").Range;t.commands=[{name:"showSettingsMenu",description:"Show settings menu",bindKey:o("Ctrl-,","Command-,"),exec:function(e){i.loadModule("ace/ext/settings_menu",function(t){t.init(e),e.showSettingsMenu()})},readOnly:!0},{name:"goToNextError",description:"Go to next error",bindKey:o("Alt-E","F4"),exec:function(e){i.loadModule("ace/ext/error_marker",function(t){t.showErrorMarker(e,1)})},scrollIntoView:"animate",readOnly:!0},{name:"goToPreviousError",description:"Go to previous error",bindKey:o("Alt-Shift-E","Shift-F4"),exec:function(e){i.loadModule("ace/ext/error_marker",function(t){t.showErrorMarker(e,-1)})},scrollIntoView:"animate",readOnly:!0},{name:"selectall",description:"Select all",bindKey:o("Ctrl-A","Command-A"),exec:function(e){e.selectAll()},readOnly:!0},{name:"centerselection",description:"Center selection",bindKey:o(null,"Ctrl-L"),exec:function(e){e.centerSelection()},readOnly:!0},{name:"gotoline",description:"Go to line...",bindKey:o("Ctrl-L","Command-L"),exec:function(e,t){typeof t=="number"&&!isNaN(t)&&e.gotoLine(t),e.prompt({$type:"gotoLine"})},readOnly:!0},{name:"fold",bindKey:o("Alt-L|Ctrl-F1","Command-Alt-L|Command-F1"),exec:function(e){e.session.toggleFold(!1)},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"unfold",bindKey:o("Alt-Shift-L|Ctrl-Shift-F1","Command-Alt-Shift-L|Command-Shift-F1"),exec:function(e){e.session.toggleFold(!0)},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"toggleFoldWidget",description:"Toggle fold widget",bindKey:o("F2","F2"),exec:function(e){e.session.toggleFoldWidget()},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"toggleParentFoldWidget",description:"Toggle parent fold widget",bindKey:o("Alt-F2","Alt-F2"),exec:function(e){e.session.toggleFoldWidget(!0)},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"foldall",description:"Fold all",bindKey:o(null,"Ctrl-Command-Option-0"),exec:function(e){e.session.foldAll()},scrollIntoView:"center",readOnly:!0},{name:"foldAllComments",description:"Fold all comments",bindKey:o(null,"Ctrl-Command-Option-0"),exec:function(e){e.session.foldAllComments()},scrollIntoView:"center",readOnly:!0},{name:"foldOther",description:"Fold other",bindKey:o("Alt-0","Command-Option-0"),exec:function(e){e.session.foldAll(),e.session.unfold(e.selection.getAllRanges())},scrollIntoView:"center",readOnly:!0},{name:"unfoldall",description:"Unfold all",bindKey:o("Alt-Shift-0","Command-Option-Shift-0"),exec:function(e){e.session.unfold()},scrollIntoView:"center",readOnly:!0},{name:"findnext",description:"Find next",bindKey:o("Ctrl-K","Command-G"),exec:function(e){e.findNext()},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"findprevious",description:"Find previous",bindKey:o("Ctrl-Shift-K","Command-Shift-G"),exec:function(e){e.findPrevious()},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"selectOrFindNext",description:"Select or find next",bindKey:o("Alt-K","Ctrl-G"),exec:function(e){e.selection.isEmpty()?e.selection.selectWord():e.findNext()},readOnly:!0},{name:"selectOrFindPrevious",description:"Select or find previous",bindKey:o("Alt-Shift-K","Ctrl-Shift-G"),exec:function(e){e.selection.isEmpty()?e.selection.selectWord():e.findPrevious()},readOnly:!0},{name:"find",description:"Find",bindKey:o("Ctrl-F","Command-F"),exec:function(e){i.loadModule("ace/ext/searchbox",function(t){t.Search(e)})},readOnly:!0},{name:"overwrite",description:"Overwrite",bindKey:"Insert",exec:function(e){e.toggleOverwrite()},readOnly:!0},{name:"selecttostart",description:"Select to start",bindKey:o("Ctrl-Shift-Home","Command-Shift-Home|Command-Shift-Up"),exec:function(e){e.getSelection().selectFileStart()},multiSelectAction:"forEach",readOnly:!0,scrollIntoView:"animate",aceCommandGroup:"fileJump"},{name:"gotostart",description:"Go to start",bindKey:o("Ctrl-Home","Command-Home|Command-Up"),exec:function(e){e.navigateFileStart()},multiSelectAction:"forEach",readOnly:!0,scrollIntoView:"animate",aceCommandGroup:"fileJump"},{name:"selectup",description:"Select up",bindKey:o("Shift-Up","Shift-Up|Ctrl-Shift-P"),exec:function(e){e.getSelection().selectUp()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"golineup",description:"Go line up",bindKey:o("Up","Up|Ctrl-P"),exec:function(e,t){e.navigateUp(t.times)},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selecttoend",description:"Select to end",bindKey:o("Ctrl-Shift-End","Command-Shift-End|Command-Shift-Down"),exec:function(e){e.getSelection().selectFileEnd()},multiSelectAction:"forEach",readOnly:!0,scrollIntoView:"animate",aceCommandGroup:"fileJump"},{name:"gotoend",description:"Go to end",bindKey:o("Ctrl-End","Command-End|Command-Down"),exec:function(e){e.navigateFileEnd()},multiSelectAction:"forEach",readOnly:!0,scrollIntoView:"animate",aceCommandGroup:"fileJump"},{name:"selectdown",description:"Select down",bindKey:o("Shift-Down","Shift-Down|Ctrl-Shift-N"),exec:function(e){e.getSelection().selectDown()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"golinedown",description:"Go line down",bindKey:o("Down","Down|Ctrl-N"),exec:function(e,t){e.navigateDown(t.times)},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectwordleft",description:"Select word left",bindKey:o("Ctrl-Shift-Left","Option-Shift-Left"),exec:function(e){e.getSelection().selectWordLeft()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotowordleft",description:"Go to word left",bindKey:o("Ctrl-Left","Option-Left"),exec:function(e){e.navigateWordLeft()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selecttolinestart",description:"Select to line start",bindKey:o("Alt-Shift-Left","Command-Shift-Left|Ctrl-Shift-A"),exec:function(e){e.getSelection().selectLineStart()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotolinestart",description:"Go to line start",bindKey:o("Alt-Left|Home","Command-Left|Home|Ctrl-A"),exec:function(e){e.navigateLineStart()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectleft",description:"Select left",bindKey:o("Shift-Left","Shift-Left|Ctrl-Shift-B"),exec:function(e){e.getSelection().selectLeft()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotoleft",description:"Go to left",bindKey:o("Left","Left|Ctrl-B"),exec:function(e,t){e.navigateLeft(t.times)},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectwordright",description:"Select word right",bindKey:o("Ctrl-Shift-Right","Option-Shift-Right"),exec:function(e){e.getSelection().selectWordRight()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotowordright",description:"Go to word right",bindKey:o("Ctrl-Right","Option-Right"),exec:function(e){e.navigateWordRight()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selecttolineend",description:"Select to line end",bindKey:o("Alt-Shift-Right","Command-Shift-Right|Shift-End|Ctrl-Shift-E"),exec:function(e){e.getSelection().selectLineEnd()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotolineend",description:"Go to line end",bindKey:o("Alt-Right|End","Command-Right|End|Ctrl-E"),exec:function(e){e.navigateLineEnd()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectright",description:"Select right",bindKey:o("Shift-Right","Shift-Right"),exec:function(e){e.getSelection().selectRight()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotoright",description:"Go to right",bindKey:o("Right","Right|Ctrl-F"),exec:function(e,t){e.navigateRight(t.times)},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectpagedown",description:"Select page down",bindKey:"Shift-PageDown",exec:function(e){e.selectPageDown()},readOnly:!0},{name:"pagedown",description:"Page down",bindKey:o(null,"Option-PageDown"),exec:function(e){e.scrollPageDown()},readOnly:!0},{name:"gotopagedown",description:"Go to page down",bindKey:o("PageDown","PageDown|Ctrl-V"),exec:function(e){e.gotoPageDown()},readOnly:!0},{name:"selectpageup",description:"Select page up",bindKey:"Shift-PageUp",exec:function(e){e.selectPageUp()},readOnly:!0},{name:"pageup",description:"Page up",bindKey:o(null,"Option-PageUp"),exec:function(e){e.scrollPageUp()},readOnly:!0},{name:"gotopageup",description:"Go to page up",bindKey:"PageUp",exec:function(e){e.gotoPageUp()},readOnly:!0},{name:"scrollup",description:"Scroll up",bindKey:o("Ctrl-Up",null),exec:function(e){e.renderer.scrollBy(0,-2*e.renderer.layerConfig.lineHeight)},readOnly:!0},{name:"scrolldown",description:"Scroll down",bindKey:o("Ctrl-Down",null),exec:function(e){e.renderer.scrollBy(0,2*e.renderer.layerConfig.lineHeight)},readOnly:!0},{name:"selectlinestart",description:"Select line start",bindKey:"Shift-Home",exec:function(e){e.getSelection().selectLineStart()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectlineend",description:"Select line end",bindKey:"Shift-End",exec:function(e){e.getSelection().selectLineEnd()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"togglerecording",description:"Toggle recording",bindKey:o("Ctrl-Alt-E","Command-Option-E"),exec:function(e){e.commands.toggleRecording(e)},readOnly:!0},{name:"replaymacro",description:"Replay macro",bindKey:o("Ctrl-Shift-E","Command-Shift-E"),exec:function(e){e.commands.replay(e)},readOnly:!0},{name:"jumptomatching",description:"Jump to matching",bindKey:o("Ctrl-\\|Ctrl-P","Command-\\"),exec:function(e){e.jumpToMatching()},multiSelectAction:"forEach",scrollIntoView:"animate",readOnly:!0},{name:"selecttomatching",description:"Select to matching",bindKey:o("Ctrl-Shift-\\|Ctrl-Shift-P","Command-Shift-\\"),exec:function(e){e.jumpToMatching(!0)},multiSelectAction:"forEach",scrollIntoView:"animate",readOnly:!0},{name:"expandToMatching",description:"Expand to matching",bindKey:o("Ctrl-Shift-M","Ctrl-Shift-M"),exec:function(e){e.jumpToMatching(!0,!0)},multiSelectAction:"forEach",scrollIntoView:"animate",readOnly:!0},{name:"passKeysToBrowser",description:"Pass keys to browser",bindKey:o(null,null),exec:function(){},passEvent:!0,readOnly:!0},{name:"copy",description:"Copy",exec:function(e){},readOnly:!0},{name:"cut",description:"Cut",exec:function(e){var t=e.$copyWithEmptySelection&&e.selection.isEmpty(),n=t?e.selection.getLineRange():e.selection.getRange();e._emit("cut",n),n.isEmpty()||e.session.remove(n),e.clearSelection()},scrollIntoView:"cursor",multiSelectAction:"forEach"},{name:"paste",description:"Paste",exec:function(e,t){e.$handlePaste(t)},scrollIntoView:"cursor"},{name:"removeline",description:"Remove line",bindKey:o("Ctrl-D","Command-D"),exec:function(e){e.removeLines()},scrollIntoView:"cursor",multiSelectAction:"forEachLine"},{name:"duplicateSelection",description:"Duplicate selection",bindKey:o("Ctrl-Shift-D","Command-Shift-D"),exec:function(e){e.duplicateSelection()},scrollIntoView:"cursor",multiSelectAction:"forEach"},{name:"sortlines",description:"Sort lines",bindKey:o("Ctrl-Alt-S","Command-Alt-S"),exec:function(e){e.sortLines()},scrollIntoView:"selection",multiSelectAction:"forEachLine"},{name:"togglecomment",description:"Toggle comment",bindKey:o("Ctrl-/","Command-/"),exec:function(e){e.toggleCommentLines()},multiSelectAction:"forEachLine",scrollIntoView:"selectionPart"},{name:"toggleBlockComment",description:"Toggle block comment",bindKey:o("Ctrl-Shift-/","Command-Shift-/"),exec:function(e){e.toggleBlockComment()},multiSelectAction:"forEach",scrollIntoView:"selectionPart"},{name:"modifyNumberUp",description:"Modify number up",bindKey:o("Ctrl-Shift-Up","Alt-Shift-Up"),exec:function(e){e.modifyNumber(1)},scrollIntoView:"cursor",multiSelectAction:"forEach"},{name:"modifyNumberDown",description:"Modify number down",bindKey:o("Ctrl-Shift-Down","Alt-Shift-Down"),exec:function(e){e.modifyNumber(-1)},scrollIntoView:"cursor",multiSelectAction:"forEach"},{name:"replace",description:"Replace",bindKey:o("Ctrl-H","Command-Option-F"),exec:function(e){i.loadModule("ace/ext/searchbox",function(t){t.Search(e,!0)})}},{name:"undo",description:"Undo",bindKey:o("Ctrl-Z","Command-Z"),exec:function(e){e.undo()}},{name:"redo",description:"Redo",bindKey:o("Ctrl-Shift-Z|Ctrl-Y","Command-Shift-Z|Command-Y"),exec:function(e){e.redo()}},{name:"copylinesup",description:"Copy lines up",bindKey:o("Alt-Shift-Up","Command-Option-Up"),exec:function(e){e.copyLinesUp()},scrollIntoView:"cursor"},{name:"movelinesup",description:"Move lines up",bindKey:o("Alt-Up","Option-Up"),exec:function(e){e.moveLinesUp()},scrollIntoView:"cursor"},{name:"copylinesdown",description:"Copy lines down",bindKey:o("Alt-Shift-Down","Command-Option-Down"),exec:function(e){e.copyLinesDown()},scrollIntoView:"cursor"},{name:"movelinesdown",description:"Move lines down",bindKey:o("Alt-Down","Option-Down"),exec:function(e){e.moveLinesDown()},scrollIntoView:"cursor"},{name:"del",description:"Delete",bindKey:o("Delete","Delete|Ctrl-D|Shift-Delete"),exec:function(e){e.remove("right")},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"backspace",description:"Backspace",bindKey:o("Shift-Backspace|Backspace","Ctrl-Backspace|Shift-Backspace|Backspace|Ctrl-H"),exec:function(e){e.remove("left")},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"cut_or_delete",description:"Cut or delete",bindKey:o("Shift-Delete",null),exec:function(e){if(!e.selection.isEmpty())return!1;e.remove("left")},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removetolinestart",description:"Remove to line start",bindKey:o("Alt-Backspace","Command-Backspace"),exec:function(e){e.removeToLineStart()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removetolineend",description:"Remove to line end",bindKey:o("Alt-Delete","Ctrl-K|Command-Delete"),exec:function(e){e.removeToLineEnd()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removetolinestarthard",description:"Remove to line start hard",bindKey:o("Ctrl-Shift-Backspace",null),exec:function(e){var t=e.selection.getRange();t.start.column=0,e.session.remove(t)},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removetolineendhard",description:"Remove to line end hard",bindKey:o("Ctrl-Shift-Delete",null),exec:function(e){var t=e.selection.getRange();t.end.column=Number.MAX_VALUE,e.session.remove(t)},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removewordleft",description:"Remove word left",bindKey:o("Ctrl-Backspace","Alt-Backspace|Ctrl-Alt-Backspace"),exec:function(e){e.removeWordLeft()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removewordright",description:"Remove word right",bindKey:o("Ctrl-Delete","Alt-Delete"),exec:function(e){e.removeWordRight()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"outdent",description:"Outdent",bindKey:o("Shift-Tab","Shift-Tab"),exec:function(e){e.blockOutdent()},multiSelectAction:"forEach",scrollIntoView:"selectionPart"},{name:"indent",description:"Indent",bindKey:o("Tab","Tab"),exec:function(e){e.indent()},multiSelectAction:"forEach",scrollIntoView:"selectionPart"},{name:"blockoutdent",description:"Block outdent",bindKey:o("Ctrl-[","Ctrl-["),exec:function(e){e.blockOutdent()},multiSelectAction:"forEachLine",scrollIntoView:"selectionPart"},{name:"blockindent",description:"Block indent",bindKey:o("Ctrl-]","Ctrl-]"),exec:function(e){e.blockIndent()},multiSelectAction:"forEachLine",scrollIntoView:"selectionPart"},{name:"insertstring",description:"Insert string",exec:function(e,t){e.insert(t)},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"inserttext",description:"Insert text",exec:function(e,t){e.insert(r.stringRepeat(t.text||"",t.times||1))},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"splitline",description:"Split line",bindKey:o(null,"Ctrl-O"),exec:function(e){e.splitLine()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"transposeletters",description:"Transpose letters",bindKey:o("Alt-Shift-X","Ctrl-T"),exec:function(e){e.transposeLetters()},multiSelectAction:function(e){e.transposeSelections(1)},scrollIntoView:"cursor"},{name:"touppercase",description:"To uppercase",bindKey:o("Ctrl-U","Ctrl-U"),exec:function(e){e.toUpperCase()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"tolowercase",description:"To lowercase",bindKey:o("Ctrl-Shift-U","Ctrl-Shift-U"),exec:function(e){e.toLowerCase()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"autoindent",description:"Auto Indent",bindKey:o(null,null),exec:function(e){e.autoIndent()},scrollIntoView:"animate"},{name:"expandtoline",description:"Expand to line",bindKey:o("Ctrl-Shift-L","Command-Shift-L"),exec:function(e){var t=e.selection.getRange();t.start.column=t.end.column=0,t.end.row++,e.selection.setRange(t,!1)},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"openlink",bindKey:o("Ctrl+F3","F3"),exec:function(e){e.openLink()}},{name:"joinlines",description:"Join lines",bindKey:o(null,null),exec:function(e){var t=e.selection.isBackwards(),n=t?e.selection.getSelectionLead():e.selection.getSelectionAnchor(),i=t?e.selection.getSelectionAnchor():e.selection.getSelectionLead(),o=e.session.doc.getLine(n.row).length,u=e.session.doc.getTextRange(e.selection.getRange()),a=u.replace(/\n\s*/," ").length,f=e.session.doc.getLine(n.row);for(var l=n.row+1;l<=i.row+1;l++){var c=r.stringTrimLeft(r.stringTrimRight(e.session.doc.getLine(l)));c.length!==0&&(c=" "+c),f+=c}i.row+1<e.session.doc.getLength()-1&&(f+=e.session.doc.getNewLineCharacter()),e.clearSelection(),e.session.doc.replace(new s(n.row,0,i.row+2,0),f),a>0?(e.selection.moveCursorTo(n.row,n.column),e.selection.selectTo(n.row,n.column+a)):(o=e.session.doc.getLine(n.row).length>o?o+1:o,e.selection.moveCursorTo(n.row,o))},multiSelectAction:"forEach",readOnly:!0},{name:"invertSelection",description:"Invert selection",bindKey:o(null,null),exec:function(e){var t=e.session.doc.getLength()-1,n=e.session.doc.getLine(t).length,r=e.selection.rangeList.ranges,i=[];r.length<1&&(r=[e.selection.getRange()]);for(var o=0;o<r.length;o++)o==r.length-1&&(r[o].end.row!==t||r[o].end.column!==n)&&i.push(new s(r[o].end.row,r[o].end.column,t,n)),o===0?(r[o].start.row!==0||r[o].start.column!==0)&&i.push(new s(0,0,r[o].start.row,r[o].start.column)):i.push(new s(r[o-1].end.row,r[o-1].end.column,r[o].start.row,r[o].start.column));e.exitMultiSelectMode(),e.clearSelection();for(var o=0;o<i.length;o++)e.selection.addRange(i[o],!1)},readOnly:!0,scrollIntoView:"none"},{name:"addLineAfter",description:"Add new line after the current line",exec:function(e){e.selection.clearSelection(),e.navigateLineEnd(),e.insert("\n")},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"addLineBefore",description:"Add new line before the current line",exec:function(e){e.selection.clearSelection();var t=e.getCursorPosition();e.selection.moveTo(t.row-1,Number.MAX_VALUE),e.insert("\n"),t.row===0&&e.navigateUp()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"openCommandPallete",exec:function(e){console.warn("This is an obsolete command. Please use `openCommandPalette` instead."),e.prompt({$type:"commands"})},readOnly:!0},{name:"openCommandPalette",description:"Open command palette",bindKey:o("F1","F1"),exec:function(e){e.prompt({$type:"commands"})},readOnly:!0},{name:"modeSelect",description:"Change language mode...",bindKey:o(null,null),exec:function(e){e.prompt({$type:"modes"})},readOnly:!0}];for(var u=1;u<9;u++)t.commands.push({name:"foldToLevel"+u,description:"Fold To Level "+u,level:u,exec:function(e){e.session.foldToLevel(this.level)},scrollIntoView:"center",readOnly:!0})}),define("ace/keyboard/gutter_handler",["require","exports","module","ace/lib/keys"],function(e,t,n){"use strict";var r=e("../lib/keys"),i=function(){function e(e){this.editor=e,this.gutterLayer=e.renderer.$gutterLayer,this.element=e.renderer.$gutter,this.lines=e.renderer.$gutterLayer.$lines,this.activeRowIndex=null,this.activeLane=null,this.annotationTooltip=this.editor.$mouseHandler.$tooltip}return e.prototype.addListener=function(){this.element.addEventListener("keydown",this.$onGutterKeyDown.bind(this)),this.element.addEventListener("focusout",this.$blurGutter.bind(this)),this.editor.on("mousewheel",this.$blurGutter.bind(this))},e.prototype.removeListener=function(){this.element.removeEventListener("keydown",this.$onGutterKeyDown.bind(this)),this.element.removeEventListener("focusout",this.$blurGutter.bind(this)),this.editor.off("mousewheel",this.$blurGutter.bind(this))},e.prototype.$onGutterKeyDown=function(e){if(this.annotationTooltip.isOpen){e.preventDefault(),e.keyCode===r.escape&&this.annotationTooltip.hide();return}if(e.target===this.element){if(e.keyCode!=r["enter"])return;e.preventDefault();var t=this.editor.getCursorPosition().row;this.editor.isRowVisible(t)||this.editor.scrollToLine(t,!0,!0),setTimeout(function(){var e=this.$rowToRowIndex(this.gutterLayer.$cursorCell.row),t=this.$findNearestFoldLaneWidget(e),n=this.$findNearestAnnotation(e);if(t===null&&n===null)return;var r=this.$findClosestNumber(t,n,e);if(r===t){this.activeLane="fold",this.activeRowIndex=t;if(this.$isCustomWidgetVisible(t)){this.$focusCustomWidget(this.activeRowIndex);return}this.$focusFoldWidget(this.activeRowIndex);return}this.activeRowIndex=n,this.activeLane="annotation",this.$focusAnnotation(this.activeRowIndex);return}.bind(this),10);return}this.$handleGutterKeyboardInteraction(e),setTimeout(function(){this.editor._signal("gutterkeydown",new s(e,this))}.bind(this),10)},e.prototype.$handleGutterKeyboardInteraction=function(e){if(e.keyCode===r.tab){e.preventDefault();return}if(e.keyCode===r.escape){e.preventDefault(),this.$blurGutter(),this.element.focus(),this.lane=null;return}if(e.keyCode===r.up){e.preventDefault();switch(this.activeLane){case"fold":this.$moveFoldWidgetUp();break;case"annotation":this.$moveAnnotationUp()}return}if(e.keyCode===r.down){e.preventDefault();switch(this.activeLane){case"fold":this.$moveFoldWidgetDown();break;case"annotation":this.$moveAnnotationDown()}return}if(e.keyCode===r.left){e.preventDefault(),this.$switchLane("annotation");return}if(e.keyCode===r.right){e.preventDefault(),this.$switchLane("fold");return}if(e.keyCode===r.enter||e.keyCode===r.space){e.preventDefault();switch(this.activeLane){case"fold":var t=this.$rowIndexToRow(this.activeRowIndex),n=this.editor.session.$gutterCustomWidgets[t];if(n)n.callbacks&&n.callbacks.onClick&&n.callbacks.onClick(e,t);else{if(this.gutterLayer.session.foldWidgets[t]==="start"){this.editor.session.onFoldWidgetClick(this.$rowIndexToRow(this.activeRowIndex),e),setTimeout(function(){this.$rowIndexToRow(this.activeRowIndex)!==t&&(this.$blurFoldWidget(this.activeRowIndex),this.activeRowIndex=this.$rowToRowIndex(t),this.$focusFoldWidget(this.activeRowIndex))}.bind(this),10);break}if(this.gutterLayer.session.foldWidgets[this.$rowIndexToRow(this.activeRowIndex)]==="end")break}return;case"annotation":this.annotationTooltip.showTooltip(this.$rowIndexToRow(this.activeRowIndex)),this.annotationTooltip.$fromKeyboard=!0}return}},e.prototype.$blurGutter=function(){if(this.activeRowIndex!==null)switch(this.activeLane){case"fold":this.$blurFoldWidget(this.activeRowIndex),this.$blurCustomWidget(this.activeRowIndex);break;case"annotation":this.$blurAnnotation(this.activeRowIndex)}this.annotationTooltip.isOpen&&this.annotationTooltip.hide();return},e.prototype.$isFoldWidgetVisible=function(e){var t=this.editor.isRowFullyVisible(this.$rowIndexToRow(e)),n=this.$getFoldWidget(e).style.display!=="none";return t&&n},e.prototype.$isCustomWidgetVisible=function(e){var t=this.editor.isRowFullyVisible(this.$rowIndexToRow(e)),n=!!this.$getCustomWidget(e);return t&&n},e.prototype.$isAnnotationVisible=function(e){var t=this.editor.isRowFullyVisible(this.$rowIndexToRow(e)),n=this.$getAnnotation(e).style.display!=="none";return t&&n},e.prototype.$getFoldWidget=function(e){var t=this.lines.get(e),n=t.element;return n.childNodes[1]},e.prototype.$getCustomWidget=function(e){var t=this.lines.get(e),n=t.element;return n.childNodes[3]},e.prototype.$getAnnotation=function(e){var t=this.lines.get(e),n=t.element;return n.childNodes[2]},e.prototype.$findNearestFoldLaneWidget=function(e){if(this.$isCustomWidgetVisible(e))return e;if(this.$isFoldWidgetVisible(e))return e;var t=0;while(e-t>0||e+t<this.lines.getLength()-1){t++;if(e-t>=0&&this.$isCustomWidgetVisible(e-t))return e-t;if(e+t<=this.lines.getLength()-1&&this.$isCustomWidgetVisible(e+t))return e+t;if(e-t>=0&&this.$isFoldWidgetVisible(e-t))return e-t;if(e+t<=this.lines.getLength()-1&&this.$isFoldWidgetVisible(e+t))return e+t}return null},e.prototype.$findNearestAnnotation=function(e){if(this.$isAnnotationVisible(e))return e;var t=0;while(e-t>0||e+t<this.lines.getLength()-1){t++;if(e-t>=0&&this.$isAnnotationVisible(e-t))return e-t;if(e+t<=this.lines.getLength()-1&&this.$isAnnotationVisible(e+t))return e+t}return null},e.prototype.$focusFoldWidget=function(e){if(e==null)return;var t=this.$getFoldWidget(e);t.classList.add(this.editor.renderer.keyboardFocusClassName),t.focus()},e.prototype.$focusCustomWidget=function(e){if(e==null)return;var t=this.$getCustomWidget(e);t&&(t.classList.add(this.editor.renderer.keyboardFocusClassName),t.focus())},e.prototype.$focusAnnotation=function(e){if(e==null)return;var t=this.$getAnnotation(e);t.classList.add(this.editor.renderer.keyboardFocusClassName),t.focus()},e.prototype.$blurFoldWidget=function(e){var t=this.$getFoldWidget(e);t.classList.remove(this.editor.renderer.keyboardFocusClassName),t.blur()},e.prototype.$blurCustomWidget=function(e){var t=this.$getCustomWidget(e);t&&(t.classList.remove(this.editor.renderer.keyboardFocusClassName),t.blur())},e.prototype.$blurAnnotation=function(e){var t=this.$getAnnotation(e);t.classList.remove(this.editor.renderer.keyboardFocusClassName),t.blur()},e.prototype.$moveFoldWidgetUp=function(){var e=this.activeRowIndex;while(e>0){e--;if(this.$isFoldWidgetVisible(e)||this.$isCustomWidgetVisible(e)){this.$blurFoldWidget(this.activeRowIndex),this.$blurCustomWidget(this.activeRowIndex),this.activeRowIndex=e,this.$isFoldWidgetVisible(e)?this.$focusFoldWidget(this.activeRowIndex):this.$focusCustomWidget(this.activeRowIndex);return}}return},e.prototype.$moveFoldWidgetDown=function(){var e=this.activeRowIndex;while(e<this.lines.getLength()-1){e++;if(this.$isFoldWidgetVisible(e)||this.$isCustomWidgetVisible(e)){this.$blurFoldWidget(this.activeRowIndex),this.$blurCustomWidget(this.activeRowIndex),this.activeRowIndex=e,this.$isFoldWidgetVisible(e)?this.$focusFoldWidget(this.activeRowIndex):this.$focusCustomWidget(this.activeRowIndex);return}}return},e.prototype.$moveAnnotationUp=function(){var e=this.activeRowIndex;while(e>0){e--;if(this.$isAnnotationVisible(e)){this.$blurAnnotation(this.activeRowIndex),this.activeRowIndex=e,this.$focusAnnotation(this.activeRowIndex);return}}return},e.prototype.$moveAnnotationDown=function(){var e=this.activeRowIndex;while(e<this.lines.getLength()-1){e++;if(this.$isAnnotationVisible(e)){this.$blurAnnotation(this.activeRowIndex),this.activeRowIndex=e,this.$focusAnnotation(this.activeRowIndex);return}}return},e.prototype.$findClosestNumber=function(e,t,n){return e===null?t:t===null?e:Math.abs(n-e)<=Math.abs(n-t)?e:t},e.prototype.$switchLane=function(e){switch(e){case"annotation":if(this.activeLane==="annotation")break;var t=this.$findNearestAnnotation(this.activeRowIndex);if(t==null)break;this.activeLane="annotation",this.$blurFoldWidget(this.activeRowIndex),this.$blurCustomWidget(this.activeRowIndex),this.activeRowIndex=t,this.$focusAnnotation(this.activeRowIndex);break;case"fold":if(this.activeLane==="fold")break;var n=this.$findNearestFoldLaneWidget(this.activeRowIndex);if(n===null)break;this.activeLane="fold",this.$blurAnnotation(this.activeRowIndex),this.activeRowIndex=n,this.$isCustomWidgetVisible(n)?this.$focusCustomWidget(this.activeRowIndex):this.$focusFoldWidget(this.activeRowIndex)}return},e.prototype.$rowIndexToRow=function(e){var t=this.lines.get(e);return t?t.row:null},e.prototype.$rowToRowIndex=function(e){for(var t=0;t<this.lines.getLength();t++){var n=this.lines.get(t);if(n.row==e)return t}return null},e}();t.GutterKeyboardHandler=i;var s=function(){function e(e,t){this.gutterKeyboardHandler=t,this.domEvent=e}return e.prototype.getKey=function(){return r.keyCodeToString(this.domEvent.keyCode)},e.prototype.getRow=function(){return this.gutterKeyboardHandler.$rowIndexToRow(this.gutterKeyboardHandler.activeRowIndex)},e.prototype.isInAnnotationLane=function(){return this.gutterKeyboardHandler.activeLane==="annotation"},e.prototype.isInFoldLane=function(){return this.gutterKeyboardHandler.activeLane==="fold"},e}();t.GutterKeyboardEvent=s}),define("ace/editor",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/lib/useragent","ace/keyboard/textinput","ace/mouse/mouse_handler","ace/mouse/fold_handler","ace/keyboard/keybinding","ace/edit_session","ace/search","ace/range","ace/lib/event_emitter","ace/commands/command_manager","ace/commands/default_commands","ace/config","ace/token_iterator","ace/keyboard/gutter_handler","ace/config","ace/clipboard","ace/lib/keys","ace/lib/event","ace/tooltip"],function(e,t,n){"use strict";var r=this&&this.__values||function(e){var t=typeof Symbol=="function"&&Symbol.iterator,n=t&&e[t],r=0;if(n)return n.call(e);if(e&&typeof e.length=="number")return{next:function(){return e&&r>=e.length&&(e=void 0),{value:e&&e[r++],done:!e}}};throw new TypeError(t?"Object is not iterable.":"Symbol.iterator is not defined.")},i=e("./lib/oop"),s=e("./lib/dom"),o=e("./lib/lang"),u=e("./lib/useragent"),a=e("./keyboard/textinput").TextInput,f=e("./mouse/mouse_handler").MouseHandler,l=e("./mouse/fold_handler").FoldHandler,c=e("./keyboard/keybinding").KeyBinding,h=e("./edit_session").EditSession,p=e("./search").Search,d=e("./range").Range,v=e("./lib/event_emitter").EventEmitter,m=e("./commands/command_manager").CommandManager,g=e("./commands/default_commands").commands,y=e("./config"),b=e("./token_iterator").TokenIterator,w=e("./keyboard/gutter_handler").GutterKeyboardHandler,E=e("./config").nls,S=e("./clipboard"),x=e("./lib/keys"),T=e("./lib/event"),N=e("./tooltip").HoverTooltip,C=function(){function e(t,n,r){this.id="editor"+ ++e.$uid,this.session,this.$toDestroy=[];var i=t.getContainerElement();this.container=i,this.renderer=t,this.commands=new m(u.isMac?"mac":"win",g),typeof document=="object"&&(this.textInput=new a(t.getTextAreaContainer(),this),this.renderer.textarea=this.textInput.getElement(),this.$mouseHandler=new f(this),new l(this)),this.keyBinding=new c(this),this.$search=(new p).set({wrap:!0}),this.$historyTracker=this.$historyTracker.bind(this),this.commands.on("exec",this.$historyTracker),this.$initOperationListeners(),this._$emitInputEvent=o.delayedCall(function(){this._signal("input",{}),this.session&&!this.session.destroyed&&this.session.bgTokenizer.scheduleStart()}.bind(this)),this.on("change",function(e,t){t._$emitInputEvent.schedule(31)}),this.setSession(n||r&&r.session||new h("")),y.resetOptions(this),r&&this.setOptions(r),y._signal("editor",this)}return e.prototype.$initOperationListeners=function(){this.commands.on("exec",this.startOperation.bind(this),!0),this.commands.on("afterExec",this.endOperation.bind(this),!0)},e.prototype.startOperation=function(e){this.session.startOperation(e)},e.prototype.endOperation=function(e){this.session.endOperation(e)},e.prototype.onStartOperation=function(e){this.curOp=this.session.curOp,this.curOp.scrollTop=this.renderer.scrollTop,this.prevOp=this.session.prevOp,e||(this.previousCommand=null)},e.prototype.onEndOperation=function(e){if(this.curOp&&this.session){if(e&&e.returnValue===!1){this.curOp=null;return}this._signal("beforeEndOperation");if(!this.curOp)return;var t=this.curOp.command,n=t&&t.scrollIntoView;if(n){switch(n){case"center-animate":n="animate";case"center":this.renderer.scrollCursorIntoView(null,.5);break;case"animate":case"cursor":this.renderer.scrollCursorIntoView();break;case"selectionPart":var r=this.selection.getRange(),i=this.renderer.layerConfig;(r.start.row>=i.lastRow||r.end.row<=i.firstRow)&&this.renderer.scrollSelectionIntoView(this.selection.anchor,this.selection.lead);break;default:}n=="animate"&&this.renderer.animateScrolling(this.curOp.scrollTop)}this.$lastSel=this.session.selection.toJSON(),this.prevOp=this.curOp,this.curOp=null}},e.prototype.$historyTracker=function(e){if(!this.$mergeUndoDeltas)return;var t=this.prevOp,n=this.$mergeableCommands,r=t.command&&e.command.name==t.command.name;if(e.command.name=="insertstring"){var i=e.args;this.mergeNextCommand===undefined&&(this.mergeNextCommand=!0),r=r&&this.mergeNextCommand&&(!/\s/.test(i)||/\s/.test(t.args)),this.mergeNextCommand=!0}else r=r&&n.indexOf(e.command.name)!==-1;this.$mergeUndoDeltas!="always"&&Date.now()-this.sequenceStartTime>2e3&&(r=!1),r?this.session.mergeUndoDeltas=!0:n.indexOf(e.command.name)!==-1&&(this.sequenceStartTime=Date.now())},e.prototype.setKeyboardHandler=function(e,t){if(e&&typeof e=="string"&&e!="ace"){this.$keybindingId=e;var n=this;y.loadModule(["keybinding",e],function(r){n.$keybindingId==e&&n.keyBinding.setKeyboardHandler(r&&r.handler),t&&t()})}else this.$keybindingId=null,this.keyBinding.setKeyboardHandler(e),t&&t()},e.prototype.getKeyboardHandler=function(){return this.keyBinding.getKeyboardHandler()},e.prototype.setSession=function(e){if(this.session==e)return;this.curOp&&this.endOperation(),this.curOp={};var t=this.session;if(t){this.session.off("change",this.$onDocumentChange),this.session.off("changeMode",this.$onChangeMode),this.session.off("tokenizerUpdate",this.$onTokenizerUpdate),this.session.off("changeTabSize",this.$onChangeTabSize),this.session.off("changeWrapLimit",this.$onChangeWrapLimit),this.session.off("changeWrapMode",this.$onChangeWrapMode),this.session.off("changeFold",this.$onChangeFold),this.session.off("changeFrontMarker",this.$onChangeFrontMarker),this.session.off("changeBackMarker",this.$onChangeBackMarker),this.session.off("changeBreakpoint",this.$onChangeBreakpoint),this.session.off("changeAnnotation",this.$onChangeAnnotation),this.session.off("changeOverwrite",this.$onCursorChange),this.session.off("changeScrollTop",this.$onScrollTopChange),this.session.off("changeScrollLeft",this.$onScrollLeftChange),this.session.off("startOperation",this.$onStartOperation),this.session.off("endOperation",this.$onEndOperation);var n=this.session.getSelection();n.off("changeCursor",this.$onCursorChange),n.off("changeSelection",this.$onSelectionChange)}this.session=e,e?(this.$onDocumentChange=this.onDocumentChange.bind(this),e.on("change",this.$onDocumentChange),this.renderer.setSession(e),this.$onChangeMode=this.onChangeMode.bind(this),e.on("changeMode",this.$onChangeMode),this.$onTokenizerUpdate=this.onTokenizerUpdate.bind(this),e.on("tokenizerUpdate",this.$onTokenizerUpdate),this.$onChangeTabSize=this.renderer.onChangeTabSize.bind(this.renderer),e.on("changeTabSize",this.$onChangeTabSize),this.$onChangeWrapLimit=this.onChangeWrapLimit.bind(this),e.on("changeWrapLimit",this.$onChangeWrapLimit),this.$onChangeWrapMode=this.onChangeWrapMode.bind(this),e.on("changeWrapMode",this.$onChangeWrapMode),this.$onChangeFold=this.onChangeFold.bind(this),e.on("changeFold",this.$onChangeFold),this.$onChangeFrontMarker=this.onChangeFrontMarker.bind(this),this.session.on("changeFrontMarker",this.$onChangeFrontMarker),this.$onChangeBackMarker=this.onChangeBackMarker.bind(this),this.session.on("changeBackMarker",this.$onChangeBackMarker),this.$onChangeBreakpoint=this.onChangeBreakpoint.bind(this),this.session.on("changeBreakpoint",this.$onChangeBreakpoint),this.$onChangeAnnotation=this.onChangeAnnotation.bind(this),this.session.on("changeAnnotation",this.$onChangeAnnotation),this.$onCursorChange=this.onCursorChange.bind(this),this.session.on("changeOverwrite",this.$onCursorChange),this.$onScrollTopChange=this.onScrollTopChange.bind(this),this.session.on("changeScrollTop",this.$onScrollTopChange),this.$onScrollLeftChange=this.onScrollLeftChange.bind(this),this.session.on("changeScrollLeft",this.$onScrollLeftChange),this.selection=e.getSelection(),this.selection.on("changeCursor",this.$onCursorChange),this.$onSelectionChange=this.onSelectionChange.bind(this),this.selection.on("changeSelection",this.$onSelectionChange),this.$onStartOperation=this.onStartOperation.bind(this),this.session.on("startOperation",this.$onStartOperation),this.$onEndOperation=this.onEndOperation.bind(this),this.session.on("endOperation",this.$onEndOperation),this.onChangeMode(),this.onCursorChange(),this.onScrollTopChange(),this.onScrollLeftChange(),this.onSelectionChange(),this.onChangeFrontMarker(),this.onChangeBackMarker(),this.onChangeBreakpoint(),this.onChangeAnnotation(),this.session.getUseWrapMode()&&this.renderer.adjustWrapLimit(),this.renderer.updateFull()):(this.selection=null,this.renderer.setSession(e)),this._signal("changeSession",{session:e,oldSession:t}),this.curOp=null,t&&t._signal("changeEditor",{oldEditor:this}),t&&(t.$editor=null),e&&e._signal("changeEditor",{editor:this}),e&&(e.$editor=this),e&&!e.destroyed&&e.bgTokenizer.scheduleStart()},e.prototype.getSession=function(){return this.session},e.prototype.setValue=function(e,t){return this.session.doc.setValue(e),t?t==1?this.navigateFileEnd():t==-1&&this.navigateFileStart():this.selectAll(),e},e.prototype.getValue=function(){return this.session.getValue()},e.prototype.getSelection=function(){return this.selection},e.prototype.resize=function(e){this.renderer.onResize(e)},e.prototype.setTheme=function(e,t){this.renderer.setTheme(e,t)},e.prototype.getTheme=function(){return this.renderer.getTheme()},e.prototype.setStyle=function(e,t){this.renderer.setStyle(e,t)},e.prototype.unsetStyle=function(e){this.renderer.unsetStyle(e)},e.prototype.getFontSize=function(){return this.getOption("fontSize")||s.computedStyle(this.container).fontSize},e.prototype.setFontSize=function(e){this.setOption("fontSize",e)},e.prototype.$highlightBrackets=function(){if(this.$highlightPending)return;var e=this;this.$highlightPending=!0,setTimeout(function(){e.$highlightPending=!1;var t=e.session;if(!t||t.destroyed)return;t.$bracketHighlight&&(t.$bracketHighlight.markerIds.forEach(function(e){t.removeMarker(e)}),t.$bracketHighlight=null);var n=e.getCursorPosition(),r=e.getKeyboardHandler(),i=r&&r.$getDirectionForHighlight&&r.$getDirectionForHighlight(e),s=t.getMatchingBracketRanges(n,i);if(!s){var o=new b(t,n.row,n.column),u=o.getCurrentToken();if(u&&/\b(?:tag-open|tag-name)/.test(u.type)){var a=t.getMatchingTags(n);a&&(s=[a.openTagName.isEmpty()?a.openTag:a.openTagName,a.closeTagName.isEmpty()?a.closeTag:a.closeTagName])}}!s&&t.$mode.getMatching&&(s=t.$mode.getMatching(e.session));if(!s){e.getHighlightIndentGuides()&&e.renderer.$textLayer.$highlightIndentGuide();return}var f="ace_bracket";Array.isArray(s)?s.length==1&&(f="ace_error_bracket"):s=[s],s.length==2&&(d.comparePoints(s[0].end,s[1].start)==0?s=[d.fromPoints(s[0].start,s[1].end)]:d.comparePoints(s[0].start,s[1].end)==0&&(s=[d.fromPoints(s[1].start,s[0].end)])),t.$bracketHighlight={ranges:s,markerIds:s.map(function(e){return t.addMarker(e,f,"text")})},e.getHighlightIndentGuides()&&e.renderer.$textLayer.$highlightIndentGuide()},50)},e.prototype.focus=function(){this.textInput.focus()},e.prototype.isFocused=function(){return this.textInput.isFocused()},e.prototype.blur=function(){this.textInput.blur()},e.prototype.onFocus=function(e){if(this.$isFocused)return;this.$isFocused=!0,this.renderer.showCursor(),this.renderer.visualizeFocus(),this._emit("focus",e)},e.prototype.onBlur=function(e){if(!this.$isFocused)return;this.$isFocused=!1,this.renderer.hideCursor(),this.renderer.visualizeBlur(),this._emit("blur",e)},e.prototype.$cursorChange=function(){this.renderer.updateCursor(),this.$highlightBrackets(),this.$updateHighlightActiveLine()},e.prototype.onDocumentChange=function(e){var t=this.session.$useWrapMode,n=e.start.row==e.end.row?e.end.row:Infinity;this.renderer.updateLines(e.start.row,n,t),this._signal("change",e),this.$cursorChange()},e.prototype.onTokenizerUpdate=function(e){var t=e.data;this.renderer.updateLines(t.first,t.last)},e.prototype.onScrollTopChange=function(){this.renderer.scrollToY(this.session.getScrollTop())},e.prototype.onScrollLeftChange=function(){this.renderer.scrollToX(this.session.getScrollLeft())},e.prototype.onCursorChange=function(){this.$cursorChange(),this._signal("changeSelection")},e.prototype.$updateHighlightActiveLine=function(){var e=this.getSession(),t;if(this.$highlightActiveLine){if(this.$selectionStyle!="line"||!this.selection.isMultiLine())t=this.getCursorPosition();this.renderer.theme&&this.renderer.theme.$selectionColorConflict&&!this.selection.isEmpty()&&(t=!1),this.renderer.$maxLines&&this.session.getLength()===1&&!(this.renderer.$minLines>1)&&(t=!1)}if(e.$highlightLineMarker&&!t)e.removeMarker(e.$highlightLineMarker.id),e.$highlightLineMarker=null;else if(!e.$highlightLineMarker&&t){var n=new d(t.row,t.column,t.row,Infinity);n.id=e.addMarker(n,"ace_active-line","screenLine"),e.$highlightLineMarker=n}else t&&(e.$highlightLineMarker.start.row=t.row,e.$highlightLineMarker.end.row=t.row,e.$highlightLineMarker.start.column=t.column,e._signal("changeBackMarker"))},e.prototype.onSelectionChange=function(e){var t=this.session;t.$selectionMarker&&t.removeMarker(t.$selectionMarker),t.$selectionMarker=null;if(!this.selection.isEmpty()){var n=this.selection.getRange(),r=this.getSelectionStyle();t.$selectionMarker=t.addMarker(n,"ace_selection",r)}else this.$updateHighlightActiveLine();var i=this.$highlightSelectedWord&&this.$getSelectionHighLightRegexp();this.session.highlight(i),this._signal("changeSelection")},e.prototype.$getSelectionHighLightRegexp=function(){var e=this.session,t=this.getSelectionRange();if(t.isEmpty()||t.isMultiLine())return;var n=t.start.column,r=t.end.column,i=e.getLine(t.start.row),s=i.substring(n,r);if(s.length>5e3||!/[\w\d]/.test(s))return;var o=this.$search.$assembleRegExp({wholeWord:!0,caseSensitive:!0,needle:s}),u=i.substring(n-1,r+1);if(!o.test(u))return;return o},e.prototype.onChangeFrontMarker=function(){this.renderer.updateFrontMarkers()},e.prototype.onChangeBackMarker=function(){this.renderer.updateBackMarkers()},e.prototype.onChangeBreakpoint=function(){this.renderer.updateBreakpoints()},e.prototype.onChangeAnnotation=function(){this.renderer.setAnnotations(this.session.getAnnotations())},e.prototype.onChangeMode=function(e){this.renderer.updateText(),this._emit("changeMode",e)},e.prototype.onChangeWrapLimit=function(){this.renderer.updateFull()},e.prototype.onChangeWrapMode=function(){this.renderer.onResize(!0)},e.prototype.onChangeFold=function(){this.$updateHighlightActiveLine(),this.renderer.updateFull()},e.prototype.getSelectedText=function(){return this.session.getTextRange(this.getSelectionRange())},e.prototype.getCopyText=function(){var e=this.getSelectedText(),t=this.session.doc.getNewLineCharacter(),n=!1;if(!e&&this.$copyWithEmptySelection){n=!0;var r=this.selection.getAllRanges();for(var i=0;i<r.length;i++){var s=r[i];if(i&&r[i-1].start.row==s.start.row)continue;e+=this.session.getLine(s.start.row)+t}}var o={text:e};return this._signal("copy",o),S.lineMode=n?o.text:!1,o.text},e.prototype.onCopy=function(){this.commands.exec("copy",this)},e.prototype.onCut=function(){this.commands.exec("cut",this)},e.prototype.onPaste=function(e,t){var n={text:e,event:t};this.commands.exec("paste",this,n)},e.prototype.$handlePaste=function(e){typeof e=="string"&&(e={text:e}),this._signal("paste",e);var t=e.text,n=t===S.lineMode,r=this.session;if(!this.inMultiSelectMode||this.inVirtualSelectionMode)n?r.insert({row:this.selection.lead.row,column:0},t):this.insert(t);else if(n)this.selection.rangeList.ranges.forEach(function(e){r.insert({row:e.start.row,column:0},t)});else{var i=t.split(/\r\n|\r|\n/),s=this.selection.rangeList.ranges,o=i.length==2&&(!i[0]||!i[1]);if(i.length!=s.length||o)return this.commands.exec("insertstring",this,t);for(var u=s.length;u--;){var a=s[u];a.isEmpty()||r.remove(a),r.insert(a.start,i[u])}}},e.prototype.execCommand=function(e,t){return this.commands.exec(e,this,t)},e.prototype.insert=function(e,t){var n=this.session,r=n.getMode(),i=this.getCursorPosition();if(this.getBehavioursEnabled()&&!t){var s=r.transformAction(n.getState(i.row),"insertion",this,n,e);s&&(e!==s.text&&(this.inVirtualSelectionMode||(this.session.mergeUndoDeltas=!1,this.mergeNextCommand=!1)),e=s.text)}e=="	"&&(e=this.session.getTabString());if(!this.selection.isEmpty()){var o=this.getSelectionRange();i=this.session.remove(o),this.clearSelection()}else if(this.session.getOverwrite()&&e.indexOf("\n")==-1){var o=d.fromPoints(i,i);o.end.column+=e.length,this.session.remove(o)}if(e=="\n"||e=="\r\n"){var u=n.getLine(i.row);if(i.column>u.search(/\S|$/)){var a=u.substr(i.column).search(/\S|$/);n.doc.removeInLine(i.row,i.column,i.column+a)}}this.clearSelection();var f=i.column,l=n.getState(i.row),u=n.getLine(i.row),c=r.checkOutdent(l,u,e);n.insert(i,e),s&&s.selection&&(s.selection.length==2?this.selection.setSelectionRange(new d(i.row,f+s.selection[0],i.row,f+s.selection[1])):this.selection.setSelectionRange(new d(i.row+s.selection[0],s.selection[1],i.row+s.selection[2],s.selection[3])));if(this.$enableAutoIndent){if(n.getDocument().isNewLine(e)){var h=r.getNextLineIndent(l,u.slice(0,i.column),n.getTabString());n.insert({row:i.row+1,column:0},h)}c&&r.autoOutdent(l,n,i.row)}},e.prototype.autoIndent=function(){var e=this.session,t=e.getMode(),n=this.selection.isEmpty()?[new d(0,0,e.doc.getLength()-1,0)]:this.selection.getAllRanges(),r="",i="",s="",o=e.getTabString();for(var u=0;u<n.length;u++){var a=n[u].start.row,f=n[u].end.row;for(var l=a;l<=f;l++){l>0&&(r=e.getState(l-1),i=e.getLine(l-1),s=t.getNextLineIndent(r,i,o));var c=e.getLine(l),h=t.$getIndent(c);if(s!==h){if(h.length>0){var p=new d(l,0,l,h.length);e.remove(p)}s.length>0&&e.insert({row:l,column:0},s)}t.autoOutdent(r,e,l)}}},e.prototype.onTextInput=function(e,t){if(!t)return this.keyBinding.onTextInput(e);this.startOperation({command:{name:"insertstring"}});var n=this.applyComposition.bind(this,e,t);this.selection.rangeCount?this.forEachSelection(n):n(),this.endOperation()},e.prototype.applyComposition=function(e,t){if(t.extendLeft||t.extendRight){var n=this.selection.getRange();n.start.column-=t.extendLeft,n.end.column+=t.extendRight,n.start.column<0&&(n.start.row--,n.start.column+=this.session.getLine(n.start.row).length+1),this.selection.setRange(n),!e&&!n.isEmpty()&&this.remove()}(e||!this.selection.isEmpty())&&this.insert(e,!0);if(t.restoreStart||t.restoreEnd){var n=this.selection.getRange();n.start.column-=t.restoreStart,n.end.column-=t.restoreEnd,this.selection.setRange(n)}},e.prototype.onCommandKey=function(e,t,n){return this.keyBinding.onCommandKey(e,t,n)},e.prototype.setOverwrite=function(e){this.session.setOverwrite(e)},e.prototype.getOverwrite=function(){return this.session.getOverwrite()},e.prototype.toggleOverwrite=function(){this.session.toggleOverwrite()},e.prototype.setScrollSpeed=function(e){this.setOption("scrollSpeed",e)},e.prototype.getScrollSpeed=function(){return this.getOption("scrollSpeed")},e.prototype.setDragDelay=function(e){this.setOption("dragDelay",e)},e.prototype.getDragDelay=function(){return this.getOption("dragDelay")},e.prototype.setSelectionStyle=function(e){this.setOption("selectionStyle",e)},e.prototype.getSelectionStyle=function(){return this.getOption("selectionStyle")},e.prototype.setHighlightActiveLine=function(e){this.setOption("highlightActiveLine",e)},e.prototype.getHighlightActiveLine=function(){return this.getOption("highlightActiveLine")},e.prototype.setHighlightGutterLine=function(e){this.setOption("highlightGutterLine",e)},e.prototype.getHighlightGutterLine=function(){return this.getOption("highlightGutterLine")},e.prototype.setHighlightSelectedWord=function(e){this.setOption("highlightSelectedWord",e)},e.prototype.getHighlightSelectedWord=function(){return this.$highlightSelectedWord},e.prototype.setAnimatedScroll=function(e){this.renderer.setAnimatedScroll(e)},e.prototype.getAnimatedScroll=function(){return this.renderer.getAnimatedScroll()},e.prototype.setShowInvisibles=function(e){this.renderer.setShowInvisibles(e)},e.prototype.getShowInvisibles=function(){return this.renderer.getShowInvisibles()},e.prototype.setDisplayIndentGuides=function(e){this.renderer.setDisplayIndentGuides(e)},e.prototype.getDisplayIndentGuides=function(){return this.renderer.getDisplayIndentGuides()},e.prototype.setHighlightIndentGuides=function(e){this.renderer.setHighlightIndentGuides(e)},e.prototype.getHighlightIndentGuides=function(){return this.renderer.getHighlightIndentGuides()},e.prototype.setShowPrintMargin=function(e){this.renderer.setShowPrintMargin(e)},e.prototype.getShowPrintMargin=function(){return this.renderer.getShowPrintMargin()},e.prototype.setPrintMarginColumn=function(e){this.renderer.setPrintMarginColumn(e)},e.prototype.getPrintMarginColumn=function(){return this.renderer.getPrintMarginColumn()},e.prototype.setReadOnly=function(e){this.setOption("readOnly",e)},e.prototype.getReadOnly=function(){return this.getOption("readOnly")},e.prototype.setBehavioursEnabled=function(e){this.setOption("behavioursEnabled",e)},e.prototype.getBehavioursEnabled=function(){return this.getOption("behavioursEnabled")},e.prototype.setWrapBehavioursEnabled=function(e){this.setOption("wrapBehavioursEnabled",e)},e.prototype.getWrapBehavioursEnabled=function(){return this.getOption("wrapBehavioursEnabled")},e.prototype.setShowFoldWidgets=function(e){this.setOption("showFoldWidgets",e)},e.prototype.getShowFoldWidgets=function(){return this.getOption("showFoldWidgets")},e.prototype.setFadeFoldWidgets=function(e){this.setOption("fadeFoldWidgets",e)},e.prototype.getFadeFoldWidgets=function(){return this.getOption("fadeFoldWidgets")},e.prototype.remove=function(e){this.selection.isEmpty()&&(e=="left"?this.selection.selectLeft():this.selection.selectRight());var t=this.getSelectionRange();if(this.getBehavioursEnabled()){var n=this.session,r=n.getState(t.start.row),i=n.getMode().transformAction(r,"deletion",this,n,t);if(t.end.column===0){var s=n.getTextRange(t);if(s[s.length-1]=="\n"){var o=n.getLine(t.end.row);/^\s+$/.test(o)&&(t.end.column=o.length)}}i&&(t=i)}this.session.remove(t),this.clearSelection()},e.prototype.removeWordRight=function(){this.selection.isEmpty()&&this.selection.selectWordRight(),this.session.remove(this.getSelectionRange()),this.clearSelection()},e.prototype.removeWordLeft=function(){this.selection.isEmpty()&&this.selection.selectWordLeft(),this.session.remove(this.getSelectionRange()),this.clearSelection()},e.prototype.removeToLineStart=function(){this.selection.isEmpty()&&this.selection.selectLineStart(),this.selection.isEmpty()&&this.selection.selectLeft(),this.session.remove(this.getSelectionRange()),this.clearSelection()},e.prototype.removeToLineEnd=function(){this.selection.isEmpty()&&this.selection.selectLineEnd();var e=this.getSelectionRange();e.start.column==e.end.column&&e.start.row==e.end.row&&(e.end.column=0,e.end.row++),this.session.remove(e),this.clearSelection()},e.prototype.splitLine=function(){this.selection.isEmpty()||(this.session.remove(this.getSelectionRange()),this.clearSelection());var e=this.getCursorPosition();this.insert("\n"),this.moveCursorToPosition(e)},e.prototype.setGhostText=function(e,t){this.renderer.setGhostText(e,t)},e.prototype.removeGhostText=function(){this.renderer.removeGhostText()},e.prototype.transposeLetters=function(){if(!this.selection.isEmpty())return;var e=this.getCursorPosition(),t=e.column;if(t===0)return;var n=this.session.getLine(e.row),r,i;t<n.length?(r=n.charAt(t)+n.charAt(t-1),i=new d(e.row,t-1,e.row,t+1)):(r=n.charAt(t-1)+n.charAt(t-2),i=new d(e.row,t-2,e.row,t)),this.session.replace(i,r),this.session.selection.moveToPosition(i.end)},e.prototype.toLowerCase=function(){var e=this.getSelectionRange();this.selection.isEmpty()&&this.selection.selectWord();var t=this.getSelectionRange(),n=this.session.getTextRange(t);this.session.replace(t,n.toLowerCase()),this.selection.setSelectionRange(e)},e.prototype.toUpperCase=function(){var e=this.getSelectionRange();this.selection.isEmpty()&&this.selection.selectWord();var t=this.getSelectionRange(),n=this.session.getTextRange(t);this.session.replace(t,n.toUpperCase()),this.selection.setSelectionRange(e)},e.prototype.indent=function(){var e=this.session,t=this.getSelectionRange();if(t.start.row<t.end.row){var n=this.$getSelectedRows();e.indentRows(n.first,n.last,"	");return}if(t.start.column<t.end.column){var r=e.getTextRange(t);if(!/^\s+$/.test(r)){var n=this.$getSelectedRows();e.indentRows(n.first,n.last,"	");return}}var i=e.getLine(t.start.row),s=t.start,u=e.getTabSize(),a=e.documentToScreenColumn(s.row,s.column);if(this.session.getUseSoftTabs())var f=u-a%u,l=o.stringRepeat(" ",f);else{var f=a%u;while(i[t.start.column-1]==" "&&f)t.start.column--,f--;this.selection.setSelectionRange(t),l="	"}return this.insert(l)},e.prototype.blockIndent=function(){var e=this.$getSelectedRows();this.session.indentRows(e.first,e.last,"	")},e.prototype.blockOutdent=function(){var e=this.session.getSelection();this.session.outdentRows(e.getRange())},e.prototype.sortLines=function(){var e=this.$getSelectedRows(),t=this.session,n=[];for(var r=e.first;r<=e.last;r++)n.push(t.getLine(r));n.sort(function(e,t){return e.toLowerCase()<t.toLowerCase()?-1:e.toLowerCase()>t.toLowerCase()?1:0});var i=new d(0,0,0,0);for(var r=e.first;r<=e.last;r++){var s=t.getLine(r);i.start.row=r,i.end.row=r,i.end.column=s.length,t.replace(i,n[r-e.first])}},e.prototype.toggleCommentLines=function(){var e=this.session.getState(this.getCursorPosition().row),t=this.$getSelectedRows();this.session.getMode().toggleCommentLines(e,this.session,t.first,t.last)},e.prototype.toggleBlockComment=function(){var e=this.getCursorPosition(),t=this.session.getState(e.row),n=this.getSelectionRange();this.session.getMode().toggleBlockComment(t,this.session,n,e)},e.prototype.getNumberAt=function(e,t){var n=/[\-]?[0-9]+(?:\.[0-9]+)?/g;n.lastIndex=0;var r=this.session.getLine(e);while(n.lastIndex<t){var i=n.exec(r);if(i.index<=t&&i.index+i[0].length>=t){var s={value:i[0],start:i.index,end:i.index+i[0].length};return s}}return null},e.prototype.modifyNumber=function(e){var t=this.selection.getCursor().row,n=this.selection.getCursor().column,r=new d(t,n-1,t,n),i=this.session.getTextRange(r);if(!isNaN(parseFloat(i))&&isFinite(i)){var s=this.getNumberAt(t,n);if(s){var o=s.value.indexOf(".")>=0?s.start+s.value.indexOf(".")+1:s.end,u=s.start+s.value.length-o,a=parseFloat(s.value);a*=Math.pow(10,u),o!==s.end&&n<o?e*=Math.pow(10,s.end-n-1):e*=Math.pow(10,s.end-n),a+=e,a/=Math.pow(10,u);var f=a.toFixed(u),l=new d(t,s.start,t,s.end);this.session.replace(l,f),this.moveCursorTo(t,Math.max(s.start+1,n+f.length-s.value.length))}}else this.toggleWord()},e.prototype.toggleWord=function(){var e=this.selection.getCursor().row,t=this.selection.getCursor().column;this.selection.selectWord();var n=this.getSelectedText(),r=this.selection.getWordRange().start.column,i=n.replace(/([a-z]+|[A-Z]+)(?=[A-Z_]|$)/g,"$1 ").split(/\s/),s=t-r-1;s<0&&(s=0);var u=0,a=0,f=this;n.match(/[A-Za-z0-9_]+/)&&i.forEach(function(t,i){a=u+t.length,s>=u&&s<=a&&(n=t,f.selection.clearSelection(),f.moveCursorTo(e,u+r),f.selection.selectTo(e,a+r)),u=a});var l=this.$toggleWordPairs,c;for(var h=0;h<l.length;h++){var p=l[h];for(var d=0;d<=1;d++){var v=+!d,m=n.match(new RegExp("^\\s?_?("+o.escapeRegExp(p[d])+")\\s?$","i"));if(m){var g=n.match(new RegExp("([_]|^|\\s)("+o.escapeRegExp(m[1])+")($|\\s)","g"));g&&(c=n.replace(new RegExp(o.escapeRegExp(p[d]),"i"),function(e){var t=p[v];return e.toUpperCase()==e?t=t.toUpperCase():e.charAt(0).toUpperCase()==e.charAt(0)&&(t=t.substr(0,0)+p[v].charAt(0).toUpperCase()+t.substr(1)),t}),this.insert(c),c="")}}}},e.prototype.findLinkAt=function(e,t){var n,i,s=this.session.getLine(e),o=s.split(/((?:https?|ftp):\/\/[\S]+)/),u=t;u<0&&(u=0);var a=0,f=0,l;try{for(var c=r(o),h=c.next();!h.done;h=c.next()){var p=h.value;f=a+p.length;if(u>=a&&u<=f&&p.match(/((?:https?|ftp):\/\/[\S]+)/)){l=p.replace(/[\s:.,'";}\]]+$/,"");break}a=f}}catch(d){n={error:d}}finally{try{h&&!h.done&&(i=c.return)&&i.call(c)}finally{if(n)throw n.error}}return l},e.prototype.openLink=function(){var e=this.selection.getCursor(),t=this.findLinkAt(e.row,e.column);return t&&window.open(t,"_blank"),t!=null},e.prototype.removeLines=function(){var e=this.$getSelectedRows();this.session.removeFullLines(e.first,e.last),this.clearSelection()},e.prototype.duplicateSelection=function(){var e=this.selection,t=this.session,n=e.getRange(),r=e.isBackwards();if(n.isEmpty()){var i=n.start.row;t.duplicateLines(i,i)}else{var s=r?n.start:n.end,o=t.insert(s,t.getTextRange(n));n.start=s,n.end=o,e.setSelectionRange(n,r)}},e.prototype.moveLinesDown=function(){this.$moveLines(1,!1)},e.prototype.moveLinesUp=function(){this.$moveLines(-1,!1)},e.prototype.moveText=function(e,t,n){return this.session.moveText(e,t,n)},e.prototype.copyLinesUp=function(){this.$moveLines(-1,!0)},e.prototype.copyLinesDown=function(){this.$moveLines(1,!0)},e.prototype.$moveLines=function(e,t){var n,r,i=this.selection;if(!i.inMultiSelectMode||this.inVirtualSelectionMode){var s=i.toOrientedRange();n=this.$getSelectedRows(s),r=this.session.$moveLines(n.first,n.last,t?0:e),t&&e==-1&&(r=0),s.moveBy(r,0),i.fromOrientedRange(s)}else{var o=i.rangeList.ranges;i.rangeList.detach(this.session),this.inVirtualSelectionMode=!0;var u=0,a=0,f=o.length;for(var l=0;l<f;l++){var c=l;o[l].moveBy(u,0),n=this.$getSelectedRows(o[l]);var h=n.first,p=n.last;while(++l<f){a&&o[l].moveBy(a,0);var d=this.$getSelectedRows(o[l]);if(t&&d.first!=p)break;if(!t&&d.first>p+1)break;p=d.last}l--,u=this.session.$moveLines(h,p,t?0:e),t&&e==-1&&(c=l+1);while(c<=l)o[c].moveBy(u,0),c++;t||(u=0),a+=u}i.fromOrientedRange(i.ranges[0]),i.rangeList.attach(this.session),this.inVirtualSelectionMode=!1}},e.prototype.$getSelectedRows=function(e){return e=(e||this.getSelectionRange()).collapseRows(),{first:this.session.getRowFoldStart(e.start.row),last:this.session.getRowFoldEnd(e.end.row)}},e.prototype.onCompositionStart=function(e){this.renderer.showComposition(e)},e.prototype.onCompositionUpdate=function(e){this.renderer.setCompositionText(e)},e.prototype.onCompositionEnd=function(){this.renderer.hideComposition()},e.prototype.getFirstVisibleRow=function(){return this.renderer.getFirstVisibleRow()},e.prototype.getLastVisibleRow=function(){return this.renderer.getLastVisibleRow()},e.prototype.isRowVisible=function(e){return e>=this.getFirstVisibleRow()&&e<=this.getLastVisibleRow()},e.prototype.isRowFullyVisible=function(e){return e>=this.renderer.getFirstFullyVisibleRow()&&e<=this.renderer.getLastFullyVisibleRow()},e.prototype.$getVisibleRowCount=function(){return this.renderer.getScrollBottomRow()-this.renderer.getScrollTopRow()+1},e.prototype.$moveByPage=function(e,t){var n=this.renderer,r=this.renderer.layerConfig,i=e*Math.floor(r.height/r.lineHeight);t===!0?this.selection.$moveSelection(function(){this.moveCursorBy(i,0)}):t===!1&&(this.selection.moveCursorBy(i,0),this.selection.clearSelection());var s=n.scrollTop;n.scrollBy(0,i*r.lineHeight),t!=null&&n.scrollCursorIntoView(null,.5),n.animateScrolling(s)},e.prototype.selectPageDown=function(){this.$moveByPage(1,!0)},e.prototype.selectPageUp=function(){this.$moveByPage(-1,!0)},e.prototype.gotoPageDown=function(){this.$moveByPage(1,!1)},e.prototype.gotoPageUp=function(){this.$moveByPage(-1,!1)},e.prototype.scrollPageDown=function(){this.$moveByPage(1)},e.prototype.scrollPageUp=function(){this.$moveByPage(-1)},e.prototype.scrollToRow=function(e){this.renderer.scrollToRow(e)},e.prototype.scrollToLine=function(e,t,n,r){this.renderer.scrollToLine(e,t,n,r)},e.prototype.centerSelection=function(){var e=this.getSelectionRange(),t={row:Math.floor(e.start.row+(e.end.row-e.start.row)/2),column:Math.floor(e.start.column+(e.end.column-e.start.column)/2)};this.renderer.alignCursor(t,.5)},e.prototype.getCursorPosition=function(){return this.selection.getCursor()},e.prototype.getCursorPositionScreen=function(){return this.session.documentToScreenPosition(this.getCursorPosition())},e.prototype.getSelectionRange=function(){return this.selection.getRange()},e.prototype.selectAll=function(){this.selection.selectAll()},e.prototype.clearSelection=function(){this.selection.clearSelection()},e.prototype.moveCursorTo=function(e,t){this.selection.moveCursorTo(e,t)},e.prototype.moveCursorToPosition=function(e){this.selection.moveCursorToPosition(e)},e.prototype.jumpToMatching=function(e,t){var n=this.getCursorPosition(),r=new b(this.session,n.row,n.column),i=r.getCurrentToken(),s=0;i&&i.type.indexOf("tag-name")!==-1&&(i=r.stepBackward());var o=i||r.stepForward();if(!o)return;var u,a=!1,f={},l=n.column-o.start,c,h={")":"(","(":"(","]":"[","[":"[","{":"{","}":"{"};do{if(o.value.match(/[{}()\[\]]/g))for(;l<o.value.length&&!a;l++){if(!h[o.value[l]])continue;c=h[o.value[l]]+"."+o.type.replace("rparen","lparen"),isNaN(f[c])&&(f[c]=0);switch(o.value[l]){case"(":case"[":case"{":f[c]++;break;case")":case"]":case"}":f[c]--,f[c]===-1&&(u="bracket",a=!0)}}else o.type.indexOf("tag-name")!==-1&&(isNaN(f[o.value])&&(f[o.value]=0),i.value==="<"&&s>1?f[o.value]++:i.value==="</"&&f[o.value]--,f[o.value]===-1&&(u="tag",a=!0));a||(i=o,s++,o=r.stepForward(),l=0)}while(o&&!a);if(!u)return;var p,v;if(u==="bracket"){p=this.session.getBracketRange(n);if(!p){p=new d(r.getCurrentTokenRow(),r.getCurrentTokenColumn()+l-1,r.getCurrentTokenRow(),r.getCurrentTokenColumn()+l-1),v=p.start;if(t||v.row===n.row&&Math.abs(v.column-n.column)<2)p=this.session.getBracketRange(v)}}else if(u==="tag"){if(!o||o.type.indexOf("tag-name")===-1)return;p=new d(r.getCurrentTokenRow(),r.getCurrentTokenColumn()-2,r.getCurrentTokenRow(),r.getCurrentTokenColumn()-2);if(p.compare(n.row,n.column)===0){var m=this.session.getMatchingTags(n);m&&(m.openTag.contains(n.row,n.column)?(p=m.closeTag,v=p.start):(p=m.openTag,m.closeTag.start.row===n.row&&m.closeTag.start.column===n.column?v=p.end:v=p.start))}v=v||p.start}v=p&&p.cursor||v,v&&(e?p&&t?this.selection.setRange(p):p&&p.isEqual(this.getSelectionRange())?this.clearSelection():this.selection.selectTo(v.row,v.column):this.selection.moveTo(v.row,v.column))},e.prototype.gotoLine=function(e,t,n){this.selection.clearSelection(),this.session.unfold({row:e-1,column:t||0}),this.exitMultiSelectMode&&this.exitMultiSelectMode(),this.moveCursorTo(e-1,t||0),this.isRowFullyVisible(e-1)||this.scrollToLine(e-1,!0,n)},e.prototype.navigateTo=function(e,t){this.selection.moveTo(e,t)},e.prototype.navigateUp=function(e){if(this.selection.isMultiLine()&&!this.selection.isBackwards()){var t=this.selection.anchor.getPosition();return this.moveCursorToPosition(t)}this.selection.clearSelection(),this.selection.moveCursorBy(-e||-1,0)},e.prototype.navigateDown=function(e){if(this.selection.isMultiLine()&&this.selection.isBackwards()){var t=this.selection.anchor.getPosition();return this.moveCursorToPosition(t)}this.selection.clearSelection(),this.selection.moveCursorBy(e||1,0)},e.prototype.navigateLeft=function(e){if(!this.selection.isEmpty()){var t=this.getSelectionRange().start;this.moveCursorToPosition(t)}else{e=e||1;while(e--)this.selection.moveCursorLeft()}this.clearSelection()},e.prototype.navigateRight=function(e){if(!this.selection.isEmpty()){var t=this.getSelectionRange().end;this.moveCursorToPosition(t)}else{e=e||1;while(e--)this.selection.moveCursorRight()}this.clearSelection()},e.prototype.navigateLineStart=function(){this.selection.moveCursorLineStart(),this.clearSelection()},e.prototype.navigateLineEnd=function(){this.selection.moveCursorLineEnd(),this.clearSelection()},e.prototype.navigateFileEnd=function(){this.selection.moveCursorFileEnd(),this.clearSelection()},e.prototype.navigateFileStart=function(){this.selection.moveCursorFileStart(),this.clearSelection()},e.prototype.navigateWordRight=function(){this.selection.moveCursorWordRight(),this.clearSelection()},e.prototype.navigateWordLeft=function(){this.selection.moveCursorWordLeft(),this.clearSelection()},e.prototype.replace=function(e,t){t&&this.$search.set(t);var n=this.$search.find(this.session),r=0;return n?(this.$tryReplace(n,e)&&(r=1),this.selection.setSelectionRange(n),this.renderer.scrollSelectionIntoView(n.start,n.end),r):r},e.prototype.replaceAll=function(e,t){t&&this.$search.set(t);var n=this.$search.findAll(this.session),r=0;if(!n.length)return r;var i=this.getSelectionRange();this.selection.moveTo(0,0);for(var s=n.length-1;s>=0;--s)this.$tryReplace(n[s],e)&&r++;return this.selection.setSelectionRange(i),r},e.prototype.$tryReplace=function(e,t){var n=this.session.getTextRange(e);return t=this.$search.replace(n,t),t!==null?(e.end=this.session.replace(e,t),e):null},e.prototype.getLastSearchOptions=function(){return this.$search.getOptions()},e.prototype.find=function(e,t,n){t||(t={}),typeof e=="string"||e instanceof RegExp?t.needle=e:typeof e=="object"&&i.mixin(t,e);var r=this.selection.getRange();t.needle==null&&(e=this.session.getTextRange(r)||this.$search.$options.needle,e||(r=this.session.getWordRange(r.start.row,r.start.column),e=this.session.getTextRange(r)),this.$search.set({needle:e})),this.$search.set(t),t.start||this.$search.set({start:r});var s=this.$search.find(this.session);if(t.preventScroll)return s;if(s)return this.revealRange(s,n),s;t.backwards?r.start=r.end:r.end=r.start,this.selection.setRange(r)},e.prototype.findNext=function(e,t){this.find({skipCurrent:!0,backwards:!1},e,t)},e.prototype.findPrevious=function(e,t){this.find(e,{skipCurrent:!0,backwards:!0},t)},e.prototype.revealRange=function(e,t){this.session.unfold(e),this.selection.setSelectionRange(e);var n=this.renderer.scrollTop;this.renderer.scrollSelectionIntoView(e.start,e.end,.5),t!==!1&&this.renderer.animateScrolling(n)},e.prototype.undo=function(){this.session.getUndoManager().undo(this.session),this.renderer.scrollCursorIntoView(null,.5)},e.prototype.redo=function(){this.session.getUndoManager().redo(this.session),this.renderer.scrollCursorIntoView(null,.5)},e.prototype.destroy=function(){this.destroyed=!0,this.$toDestroy&&(this.$toDestroy.forEach(function(e){e.destroy()}),this.$toDestroy=[]),this.$mouseHandler&&this.$mouseHandler.destroy(),this.renderer.destroy(),this._signal("destroy",this),this.session&&this.session.destroy(),this._$emitInputEvent&&this._$emitInputEvent.cancel(),this.removeAllListeners()},e.prototype.setAutoScrollEditorIntoView=function(e){if(!e)return;var t,n=this,r=!1;this.$scrollAnchor||(this.$scrollAnchor=document.createElement("div"));var i=this.$scrollAnchor;i.style.cssText="position:absolute",this.container.insertBefore(i,this.container.firstChild);var s=this.on("changeSelection",function(){r=!0}),o=this.renderer.on("beforeRender",function(){r&&(t=n.renderer.container.getBoundingClientRect())}),u=this.renderer.on("afterRender",function(){if(r&&t&&(n.isFocused()||n.searchBox&&n.searchBox.isFocused())){var e=n.renderer,s=e.$cursorLayer.$pixelPos,o=e.layerConfig,u=s.top-o.offset;s.top>=0&&u+t.top<0?r=!0:s.top<o.height&&s.top+t.top+o.lineHeight>window.innerHeight?r=!1:r=null,r!=null&&(i.style.top=u+"px",i.style.left=s.left+"px",i.style.height=o.lineHeight+"px",i.scrollIntoView(r)),r=t=null}});this.setAutoScrollEditorIntoView=function(e){if(e)return;delete this.setAutoScrollEditorIntoView,this.off("changeSelection",s),this.renderer.off("afterRender",u),this.renderer.off("beforeRender",o)}},e.prototype.$resetCursorStyle=function(){var e=this.$cursorStyle||"ace",t=this.renderer.$cursorLayer;if(!t)return;t.setSmoothBlinking(/smooth/.test(e)),t.isBlinking=!this.$readOnly&&e!="wide",s.setCssClass(t.element,"ace_slim-cursors",/slim/.test(e))},e.prototype.prompt=function(e,t,n){var r=this;y.loadModule("ace/ext/prompt",function(i){i.prompt(r,e,t,n)})},Object.defineProperty(e.prototype,"hoverTooltip",{get:function(){return this.$hoverTooltip||(this.$hoverTooltip=new N(this.container))},set:function(e){this.$hoverTooltip&&this.$hoverTooltip.destroy(),this.$hoverTooltip=e},enumerable:!1,configurable:!0}),e}();C.$uid=0,C.prototype.curOp=null,C.prototype.prevOp={},C.prototype.$mergeableCommands=["backspace","del","insertstring"],C.prototype.$toggleWordPairs=[["first","last"],["true","false"],["yes","no"],["width","height"],["top","bottom"],["right","left"],["on","off"],["x","y"],["get","set"],["max","min"],["horizontal","vertical"],["show","hide"],["add","remove"],["up","down"],["before","after"],["even","odd"],["in","out"],["inside","outside"],["next","previous"],["increase","decrease"],["attach","detach"],["&&","||"],["==","!="]],i.implement(C.prototype,v),y.defineOptions(C.prototype,"editor",{selectionStyle:{set:function(e){this.onSelectionChange(),this._signal("changeSelectionStyle",{data:e})},initialValue:"line"},highlightActiveLine:{set:function(){this.$updateHighlightActiveLine()},initialValue:!0},highlightSelectedWord:{set:function(e){this.$onSelectionChange()},initialValue:!0},readOnly:{set:function(e){var t=this;this.textInput.setReadOnly(e);if(this.destroyed)return;this.$resetCursorStyle(),this.$readOnlyCallback||(this.$readOnlyCallback=function(e){var n=!1;if(e&&e.type=="keydown"){e&&e.key&&!e.ctrlKey&&!e.metaKey&&(e.key==" "&&e.preventDefault(),n=e.key.length==1);if(!n)return}else e&&e.type!=="exec"&&(n=!0);if(n){var r=s.createElement("div");r.textContent=E("editor.tooltip.disable-editing","Editing is disabled"),t.hoverTooltip.isOpen||t.hoverTooltip.showForRange(t,t.getSelectionRange(),r)}else t.hoverTooltip&&t.hoverTooltip.isOpen&&t.hoverTooltip.hide()});var n=this.textInput.getElement();e?(T.addListener(n,"keydown",this.$readOnlyCallback,this),this.commands.on("exec",this.$readOnlyCallback),this.commands.on("commandUnavailable",this.$readOnlyCallback)):(T.removeListener(n,"keydown",this.$readOnlyCallback),this.commands.off("exec",this.$readOnlyCallback),this.commands.off("commandUnavailable",this.$readOnlyCallback))},initialValue:!1},copyWithEmptySelection:{set:function(e){this.textInput.setCopyWithEmptySelection(e)},initialValue:!1},cursorStyle:{set:function(e){this.$resetCursorStyle()},values:["ace","slim","smooth","wide"],initialValue:"ace"},mergeUndoDeltas:{values:[!1,!0,"always"],initialValue:!0},behavioursEnabled:{initialValue:!0},wrapBehavioursEnabled:{initialValue:!0},enableAutoIndent:{initialValue:!0},autoScrollEditorIntoView:{set:function(e){this.setAutoScrollEditorIntoView(e)}},keyboardHandler:{set:function(e){this.setKeyboardHandler(e)},get:function(){return this.$keybindingId},handlesSet:!0},value:{set:function(e){this.session.setValue(e)},get:function(){return this.getValue()},handlesSet:!0,hidden:!0},session:{set:function(e){this.setSession(e)},get:function(){return this.session},handlesSet:!0,hidden:!0},showLineNumbers:{set:function(e){this.renderer.$gutterLayer.setShowLineNumbers(e),this.renderer.$loop.schedule(this.renderer.CHANGE_GUTTER),e&&this.$relativeLineNumbers?k.attach(this):k.detach(this)},initialValue:!0},relativeLineNumbers:{set:function(e){this.$showLineNumbers&&e?k.attach(this):k.detach(this)}},placeholder:{set:function(e){this.$updatePlaceholder||(this.$updatePlaceholder=function(){var e=this.session&&(this.renderer.$composition||this.session.getLength()>1||this.session.getLine(0).length>0);if(e&&this.renderer.placeholderNode)this.renderer.off("afterRender",this.$updatePlaceholder),s.removeCssClass(this.container,"ace_hasPlaceholder"),this.renderer.placeholderNode.remove(),this.renderer.placeholderNode=null;else if(!e&&!this.renderer.placeholderNode){this.renderer.on("afterRender",this.$updatePlaceholder),s.addCssClass(this.container,"ace_hasPlaceholder");var t=s.createElement("div");t.className="ace_placeholder",t.textContent=this.$placeholder||"",this.renderer.placeholderNode=t,this.renderer.content.appendChild(this.renderer.placeholderNode)}else!e&&this.renderer.placeholderNode&&(this.renderer.placeholderNode.textContent=this.$placeholder||"")}.bind(this),this.on("input",this.$updatePlaceholder)),this.$updatePlaceholder()}},enableKeyboardAccessibility:{set:function(e){var t={name:"blurTextInput",description:"Set focus to the editor content div to allow tabbing through the page",bindKey:"Esc",exec:function(e){e.blur(),e.renderer.scroller.focus()},readOnly:!0},n=function(e){if(e.target==this.renderer.scroller&&e.keyCode===x.enter){e.preventDefault();var t=this.getCursorPosition().row;this.isRowVisible(t)||this.scrollToLine(t,!0,!0),this.focus()}},r;e?(this.renderer.enableKeyboardAccessibility=!0,this.renderer.keyboardFocusClassName="ace_keyboard-focus",this.textInput.getElement().setAttribute("tabindex",-1),this.textInput.setNumberOfExtraLines(u.isWin?3:0),this.renderer.scroller.setAttribute("tabindex",0),this.renderer.scroller.setAttribute("role","group"),this.renderer.scroller.setAttribute("aria-roledescription",E("editor.scroller.aria-roledescription","editor")),this.renderer.scroller.classList.add(this.renderer.keyboardFocusClassName),this.renderer.scroller.setAttribute("aria-label",E("editor.scroller.aria-label","Editor content, press Enter to start editing, press Escape to exit")),this.renderer.scroller.addEventListener("keyup",n.bind(this)),this.commands.addCommand(t),this.renderer.$gutter.setAttribute("tabindex",0),this.renderer.$gutter.setAttribute("aria-hidden",!1),this.renderer.$gutter.setAttribute("role","group"),this.renderer.$gutter.setAttribute("aria-roledescription",E("editor.gutter.aria-roledescription","editor gutter")),this.renderer.$gutter.setAttribute("aria-label",E("editor.gutter.aria-label","Editor gutter, press Enter to interact with controls using arrow keys, press Escape to exit")),this.renderer.$gutter.classList.add(this.renderer.keyboardFocusClassName),this.renderer.content.setAttribute("aria-hidden",!0),r||(r=new w(this)),r.addListener(),this.textInput.setAriaOptions({setLabel:!0})):(this.renderer.enableKeyboardAccessibility=!1,this.textInput.getElement().setAttribute("tabindex",0),this.textInput.setNumberOfExtraLines(0),this.renderer.scroller.setAttribute("tabindex",-1),this.renderer.scroller.removeAttribute("role"),this.renderer.scroller.removeAttribute("aria-roledescription"),this.renderer.scroller.classList.remove(this.renderer.keyboardFocusClassName),this.renderer.scroller.removeAttribute("aria-label"),this.renderer.scroller.removeEventListener("keyup",n.bind(this)),this.commands.removeCommand(t),this.renderer.content.removeAttribute("aria-hidden"),this.renderer.$gutter.setAttribute("tabindex",-1),this.renderer.$gutter.setAttribute("aria-hidden",!0),this.renderer.$gutter.removeAttribute("role"),this.renderer.$gutter.removeAttribute("aria-roledescription"),this.renderer.$gutter.removeAttribute("aria-label"),this.renderer.$gutter.classList.remove(this.renderer.keyboardFocusClassName),r&&r.removeListener())},initialValue:!1},textInputAriaLabel:{set:function(e){this.$textInputAriaLabel=e},initialValue:""},enableMobileMenu:{set:function(e){this.$enableMobileMenu=e},initialValue:!0},customScrollbar:"renderer",hScrollBarAlwaysVisible:"renderer",vScrollBarAlwaysVisible:"renderer",highlightGutterLine:"renderer",animatedScroll:"renderer",showInvisibles:"renderer",showPrintMargin:"renderer",printMarginColumn:"renderer",printMargin:"renderer",fadeFoldWidgets:"renderer",showFoldWidgets:"renderer",displayIndentGuides:"renderer",highlightIndentGuides:"renderer",showGutter:"renderer",fontSize:"renderer",fontFamily:"renderer",maxLines:"renderer",minLines:"renderer",scrollPastEnd:"renderer",fixedWidthGutter:"renderer",theme:"renderer",hasCssTransforms:"renderer",maxPixelHeight:"renderer",useTextareaForIME:"renderer",useResizeObserver:"renderer",useSvgGutterIcons:"renderer",showFoldedAnnotations:"renderer",scrollSpeed:"$mouseHandler",dragDelay:"$mouseHandler",dragEnabled:"$mouseHandler",focusTimeout:"$mouseHandler",firstLineNumber:"session",overwrite:"session",newLineMode:"session",useWorker:"session",useSoftTabs:"session",navigateWithinSoftTabs:"session",tabSize:"session",wrap:"session",indentedSoftWrap:"session",foldStyle:"session",mode:"session"});var k={getText:function(e,t){return(Math.abs(e.selection.lead.row-t)||t+1+(t<9?"\u00b7":""))+""},getWidth:function(e,t,n){return Math.max(t.toString().length,(n.lastRow+1).toString().length,2)*n.characterWidth},update:function(e,t){t.renderer.$loop.schedule(t.renderer.CHANGE_GUTTER)},attach:function(e){e.renderer.$gutterLayer.$renderer=this,e.on("changeSelection",this.update),this.update(null,e)},detach:function(e){e.renderer.$gutterLayer.$renderer==this&&(e.renderer.$gutterLayer.$renderer=null),e.off("changeSelection",this.update),this.update(null,e)}};t.Editor=C}),define("ace/layer/lines",["require","exports","module","ace/lib/dom"],function(e,t,n){"use strict";var r=e("../lib/dom"),i=function(){function e(e,t){this.element=e,this.canvasHeight=t||5e5,this.element.style.height=this.canvasHeight*2+"px",this.cells=[],this.cellCache=[],this.$offsetCoefficient=0}return e.prototype.moveContainer=function(e){r.translate(this.element,0,-(e.firstRowScreen*e.lineHeight%this.canvasHeight)-e.offset*this.$offsetCoefficient)},e.prototype.pageChanged=function(e,t){return Math.floor(e.firstRowScreen*e.lineHeight/this.canvasHeight)!==Math.floor(t.firstRowScreen*t.lineHeight/this.canvasHeight)},e.prototype.computeLineTop=function(e,t,n){var r=t.firstRowScreen*t.lineHeight,i=Math.floor(r/this.canvasHeight),s=n.documentToScreenRow(e,0)*t.lineHeight;return s-i*this.canvasHeight},e.prototype.computeLineHeight=function(e,t,n){return t.lineHeight*n.getRowLineCount(e)},e.prototype.getLength=function(){return this.cells.length},e.prototype.get=function(e){return this.cells[e]},e.prototype.shift=function(){this.$cacheCell(this.cells.shift())},e.prototype.pop=function(){this.$cacheCell(this.cells.pop())},e.prototype.push=function(e){if(Array.isArray(e)){this.cells.push.apply(this.cells,e);var t=r.createFragment(this.element);for(var n=0;n<e.length;n++)t.appendChild(e[n].element);this.element.appendChild(t)}else this.cells.push(e),this.element.appendChild(e.element)},e.prototype.unshift=function(e){if(Array.isArray(e)){this.cells.unshift.apply(this.cells,e);var t=r.createFragment(this.element);for(var n=0;n<e.length;n++)t.appendChild(e[n].element);this.element.firstChild?this.element.insertBefore(t,this.element.firstChild):this.element.appendChild(t)}else this.cells.unshift(e),this.element.insertAdjacentElement("afterbegin",e.element)},e.prototype.last=function(){return this.cells.length?this.cells[this.cells.length-1]:null},e.prototype.$cacheCell=function(e){if(!e)return;e.element.remove(),this.cellCache.push(e)},e.prototype.createCell=function(e,t,n,i){var s=this.cellCache.pop();if(!s){var o=r.createElement("div");i&&i(o),this.element.appendChild(o),s={element:o,text:"",row:e}}return s.row=e,s},e}();t.Lines=i}),define("ace/layer/gutter",["require","exports","module","ace/lib/dom","ace/lib/oop","ace/lib/lang","ace/lib/event_emitter","ace/layer/lines","ace/config"],function(e,t,n){"use strict";function l(e){var t=document.createTextNode("");e.appendChild(t);var n=r.createElement("span");e.appendChild(n);var i=r.createElement("span");e.appendChild(i);var s=r.createElement("span");return i.appendChild(s),e}var r=e("../lib/dom"),i=e("../lib/oop"),s=e("../lib/lang"),o=e("../lib/event_emitter").EventEmitter,u=e("./lines").Lines,a=e("../config").nls,f=function(){function e(e){this.$showCursorMarker=null,this.element=r.createElement("div"),this.element.className="ace_layer ace_gutter-layer",e.appendChild(this.element),this.setShowFoldWidgets(this.$showFoldWidgets),this.gutterWidth=0,this.$annotations=[],this.$updateAnnotations=this.$updateAnnotations.bind(this),this.$lines=new u(this.element),this.$lines.$offsetCoefficient=1}return e.prototype.setSession=function(e){this.session&&this.session.off("change",this.$updateAnnotations),this.session=e,e&&e.on("change",this.$updateAnnotations)},e.prototype.addGutterDecoration=function(e,t){window.console&&console.warn&&console.warn("deprecated use session.addGutterDecoration"),this.session.addGutterDecoration(e,t)},e.prototype.removeGutterDecoration=function(e,t){window.console&&console.warn&&console.warn("deprecated use session.removeGutterDecoration"),this.session.removeGutterDecoration(e,t)},e.prototype.setAnnotations=function(e){this.$annotations=[];for(var t=0;t<e.length;t++){var n=e[t],r=n.row,i=this.$annotations[r];i||(i=this.$annotations[r]={text:[],type:[],displayText:[]});var o=n.text,u=n.text,a=n.type;o=o?s.escapeHTML(o):n.html||"",u=u?u:n.html||"",i.text.indexOf(o)===-1&&(i.text.push(o),i.type.push(a),i.displayText.push(u));var f=n.className;f?i.className=f:a==="error"?i.className=" ace_error":a==="security"&&!/\bace_error\b/.test(i.className)?i.className=" ace_security":a==="warning"&&!/\bace_(error|security)\b/.test(i.className)?i.className=" ace_warning":a==="info"&&!i.className?i.className=" ace_info":a==="hint"&&!i.className&&(i.className=" ace_hint")}},e.prototype.$updateAnnotations=function(e){if(!this.$annotations.length)return;var t=e.start.row,n=e.end.row-t;if(n!==0)if(e.action=="remove")this.$annotations.splice(t,n+1,null);else{var r=new Array(n+1);r.unshift(t,1),this.$annotations.splice.apply(this.$annotations,r)}},e.prototype.update=function(e){this.config=e;var t=this.session,n=e.firstRow,r=Math.min(e.lastRow+e.gutterOffset,t.getLength()-1);this.oldLastRow=r,this.config=e,this.$lines.moveContainer(e),this.$updateCursorRow();var i=t.getNextFoldLine(n),s=i?i.start.row:Infinity,o=null,u=-1,a=n;for(;;){a>s&&(a=i.end.row+1,i=t.getNextFoldLine(a,i),s=i?i.start.row:Infinity);if(a>r){while(this.$lines.getLength()>u+1)this.$lines.pop();break}o=this.$lines.get(++u),o?o.row=a:(o=this.$lines.createCell(a,e,this.session,l),this.$lines.push(o)),this.$renderCell(o,e,i,a),a++}this._signal("afterRender"),this.$updateGutterWidth(e),this.$showCursorMarker&&this.$highlightGutterLine&&this.$updateCursorMarker()},e.prototype.$updateGutterWidth=function(e){var t=this.session,n=t.gutterRenderer||this.$renderer,r=t.$firstLineNumber,i=this.$lines.last()?this.$lines.last().text:"";if(this.$fixedWidth||t.$useWrapMode)i=t.getLength()+r-1;var s=n?n.getWidth(t,i,e):i.toString().length*e.characterWidth,o=this.$padding||this.$computePadding();s+=o.left+o.right,s!==this.gutterWidth&&!isNaN(s)&&(this.gutterWidth=s,this.element.parentNode.style.width=this.element.style.width=Math.ceil(this.gutterWidth)+"px",this._signal("changeGutterWidth",s))},e.prototype.$updateCursorRow=function(){if(!this.$highlightGutterLine)return;var e=this.session.selection.getCursor();if(this.$cursorRow===e.row)return;this.$cursorRow=e.row},e.prototype.updateLineHighlight=function(){this.$showCursorMarker&&this.$updateCursorMarker();if(!this.$highlightGutterLine)return;var e=this.session.selection.cursor.row;this.$cursorRow=e;if(this.$cursorCell&&this.$cursorCell.row==e)return;this.$cursorCell&&(this.$cursorCell.element.className=this.$cursorCell.element.className.replace("ace_gutter-active-line ",""));var t=this.$lines.cells;this.$cursorCell=null;for(var n=0;n<t.length;n++){var r=t[n];if(r.row>=this.$cursorRow){if(r.row>this.$cursorRow){var i=this.session.getFoldLine(this.$cursorRow);if(!(n>0&&i&&i.start.row==t[n-1].row))break;r=t[n-1]}r.element.className="ace_gutter-active-line "+r.element.className,this.$cursorCell=r;break}}},e.prototype.$updateCursorMarker=function(){if(!this.session)return;var e=this.session;this.$highlightElement||(this.$highlightElement=r.createElement("div"),this.$highlightElement.className="ace_gutter-cursor",this.$highlightElement.style.pointerEvents="none",this.element.appendChild(this.$highlightElement));var t=e.selection.cursor,n=this.config,i=this.$lines,s=n.firstRowScreen*n.lineHeight,o=Math.floor(s/i.canvasHeight),u=e.documentToScreenRow(t)*n.lineHeight,a=u-o*i.canvasHeight;r.setStyle(this.$highlightElement.style,"height",n.lineHeight+"px"),r.setStyle(this.$highlightElement.style,"top",a+"px")},e.prototype.scrollLines=function(e){var t=this.config;this.config=e,this.$updateCursorRow();if(this.$lines.pageChanged(t,e))return this.update(e);this.$lines.moveContainer(e);var n=Math.min(e.lastRow+e.gutterOffset,this.session.getLength()-1),r=this.oldLastRow;this.oldLastRow=n;if(!t||r<e.firstRow)return this.update(e);if(n<t.firstRow)return this.update(e);if(t.firstRow<e.firstRow)for(var i=this.session.getFoldedRowCount(t.firstRow,e.firstRow-1);i>0;i--)this.$lines.shift();if(r>n)for(var i=this.session.getFoldedRowCount(n+1,r);i>0;i--)this.$lines.pop();e.firstRow<t.firstRow&&this.$lines.unshift(this.$renderLines(e,e.firstRow,t.firstRow-1)),n>r&&this.$lines.push(this.$renderLines(e,r+1,n)),this.updateLineHighlight(),this._signal("afterRender"),this.$updateGutterWidth(e)},e.prototype.$renderLines=function(e,t,n){var r=[],i=t,s=this.session.getNextFoldLine(i),o=s?s.start.row:Infinity;for(;;){i>o&&(i=s.end.row+1,s=this.session.getNextFoldLine(i,s),o=s?s.start.row:Infinity);if(i>n)break;var u=this.$lines.createCell(i,e,this.session,l);this.$renderCell(u,e,s,i),r.push(u),i++}return r},e.prototype.$renderCell=function(e,t,n,i){var s=e.element,o=this.session,u=s.childNodes[0],f=s.childNodes[1],l=s.childNodes[2],c=s.childNodes[3],h=l.firstChild,p=o.$firstLineNumber,d=o.$breakpoints,v=o.$decorations,m=o.gutterRenderer||this.$renderer,g=this.$showFoldWidgets&&o.foldWidgets,y=n?n.start.row:Number.MAX_VALUE,b=t.lineHeight+"px",w=this.$useSvgGutterIcons?"ace_gutter-cell_svg-icons ":"ace_gutter-cell ",E=this.$useSvgGutterIcons?"ace_icon_svg":"ace_icon",S=(m?m.getText(o,i):i+p).toString();this.$highlightGutterLine&&(i==this.$cursorRow||n&&i<this.$cursorRow&&i>=y&&this.$cursorRow<=n.end.row)&&(w+="ace_gutter-active-line ",this.$cursorCell!=e&&(this.$cursorCell&&(this.$cursorCell.element.className=this.$cursorCell.element.className.replace("ace_gutter-active-line ","")),this.$cursorCell=e)),d[i]&&(w+=d[i]),v[i]&&(w+=v[i]),this.$annotations[i]&&i!==y&&(w+=this.$annotations[i].className);if(g){var x=g[i];x==null&&(x=g[i]=o.getFoldWidget(i))}if(x){var T="ace_fold-widget ace_"+x,N=x=="start"&&i==y&&i<n.end.row;if(N){T+=" ace_closed";var C="",k=!1;for(var L=i+1;L<=n.end.row;L++){if(!this.$annotations[L])continue;if(this.$annotations[L].className===" ace_error"){k=!0,C=" ace_error_fold";break}this.$annotations[L].className===" ace_security"?(k=!0,C=" ace_security_fold"):this.$annotations[L].className===" ace_warning"&&C!==" ace_security_fold"&&(k=!0,C=" ace_warning_fold")}w+=C}else T+=" ace_open";f.className!=T&&(f.className=T),r.setStyle(f.style,"height",b),r.setStyle(f.style,"display","inline-block"),f.setAttribute("role","button"),f.setAttribute("tabindex","-1");var A=o.getFoldWidgetRange(i);A?f.setAttribute("aria-label",a("gutter.code-folding.range.aria-label","Toggle code folding, rows $0 through $1",[A.start.row+1,A.end.row+1])):n?f.setAttribute("aria-label",a("gutter.code-folding.closed.aria-label","Toggle code folding, rows $0 through $1",[n.start.row+1,n.end.row+1])):f.setAttribute("aria-label",a("gutter.code-folding.open.aria-label","Toggle code folding, row $0",[i+1])),N?(f.setAttribute("aria-expanded","false"),f.setAttribute("title",a("gutter.code-folding.closed.title","Unfold code"))):(f.setAttribute("aria-expanded","true"),f.setAttribute("title",a("gutter.code-folding.open.title","Fold code")))}else f&&(r.setStyle(f.style,"display","none"),f.setAttribute("tabindex","0"),f.removeAttribute("role"),f.removeAttribute("aria-label"));var O=this.session.$gutterCustomWidgets[i];O?this.$addCustomWidget(i,O,e):c&&this.$removeCustomWidget(i,e);if(k&&this.$showFoldedAnnotations){l.className="ace_gutter_annotation",h.className=E,h.className+=C,r.setStyle(h.style,"height",b),r.setStyle(l.style,"display","block"),r.setStyle(l.style,"height",b);var M;switch(C){case" ace_error_fold":M=a("gutter.annotation.aria-label.error","Error, read annotations row $0",[S]);break;case" ace_security_fold":M=a("gutter.annotation.aria-label.security","Security finding, read annotations row $0",[S]);break;case" ace_warning_fold":M=a("gutter.annotation.aria-label.warning","Warning, read annotations row $0",[S])}l.setAttribute("aria-label",M),l.setAttribute("tabindex","-1"),l.setAttribute("role","button")}else if(this.$annotations[i]){l.className="ace_gutter_annotation",h.className=E,this.$useSvgGutterIcons?h.className+=this.$annotations[i].className:s.classList.add(this.$annotations[i].className.replace(" ","")),r.setStyle(h.style,"height",b),r.setStyle(l.style,"display","block"),r.setStyle(l.style,"height",b);var M;switch(this.$annotations[i].className){case" ace_error":M=a("gutter.annotation.aria-label.error","Error, read annotations row $0",[S]);break;case" ace_security":M=a("gutter.annotation.aria-label.security","Security finding, read annotations row $0",[S]);break;case" ace_warning":M=a("gutter.annotation.aria-label.warning","Warning, read annotations row $0",[S]);break;case" ace_info":M=a("gutter.annotation.aria-label.info","Info, read annotations row $0",[S]);break;case" ace_hint":M=a("gutter.annotation.aria-label.hint","Suggestion, read annotations row $0",[S])}l.setAttribute("aria-label",M),l.setAttribute("tabindex","-1"),l.setAttribute("role","button")}else r.setStyle(l.style,"display","none"),l.removeAttribute("aria-label"),l.removeAttribute("role"),l.setAttribute("tabindex","0");return S!==u.data&&(u.data=S),s.className!=w&&(s.className=w),r.setStyle(e.element.style,"height",this.$lines.computeLineHeight(i,t,o)+"px"),r.setStyle(e.element.style,"top",this.$lines.computeLineTop(i,t,o)+"px"),e.text=S,l.style.display==="none"&&f.style.display==="none"&&!O?e.element.setAttribute("aria-hidden",!0):e.element.setAttribute("aria-hidden",!1),e},e.prototype.setHighlightGutterLine=function(e){this.$highlightGutterLine=e,!e&&this.$highlightElement&&(this.$highlightElement.remove(),this.$highlightElement=null)},e.prototype.setShowLineNumbers=function(e){this.$renderer=!e&&{getWidth:function(){return 0},getText:function(){return""}}},e.prototype.getShowLineNumbers=function(){return this.$showLineNumbers},e.prototype.setShowFoldWidgets=function(e){e?r.addCssClass(this.element,"ace_folding-enabled"):r.removeCssClass(this.element,"ace_folding-enabled"),this.$showFoldWidgets=e,this.$padding=null},e.prototype.getShowFoldWidgets=function(){return this.$showFoldWidgets},e.prototype.$hideFoldWidget=function(e,t){var n=t||this.$getGutterCell(e);if(n&&n.element){var i=n.element.childNodes[1];i&&r.setStyle(i.style,"display","none")}},e.prototype.$showFoldWidget=function(e,t){var n=t||this.$getGutterCell(e);if(n&&n.element){var i=n.element.childNodes[1];i&&this.session.foldWidgets&&this.session.foldWidgets[n.row]&&r.setStyle(i.style,"display","inline-block")}},e.prototype.$getGutterCell=function(e){var t=this.$lines.cells,n=0,r=t.length-1;if(e<t[0].row||e>t[r].row)return;while(n<=r){var i=Math.floor((n+r)/2),s=t[i];if(s.row>e)r=i-1;else{if(!(s.row<e))return s;n=i+1}}return s},e.prototype.$addCustomWidget=function(e,t,n){var i=t.className,s=t.label,o=t.title,u=t.callbacks;this.session.$gutterCustomWidgets[e]={className:i,label:s,title:o,callbacks:u},this.$hideFoldWidget(e,n);var a=n||this.$getGutterCell(e);if(a&&a.element){var f=a.element.querySelector(".ace_custom-widget");f&&f.remove(),f=r.createElement("span"),f.className="ace_custom-widget ".concat(i),f.setAttribute("tabindex","-1"),f.setAttribute("role","button"),f.setAttribute("aria-label",s),f.setAttribute("title",o),r.setStyle(f.style,"display","inline-block"),r.setStyle(f.style,"height","inherit"),u&&u.onClick&&f.addEventListener("click",function(t){u.onClick(t,e),t.stopPropagation()}),a.element.appendChild(f)}},e.prototype.$removeCustomWidget=function(e,t){delete this.session.$gutterCustomWidgets[e],this.$showFoldWidget(e,t);var n=t||this.$getGutterCell(e);if(n&&n.element){var r=n.element.querySelector(".ace_custom-widget");r&&n.element.removeChild(r)}},e.prototype.$computePadding=function(){if(!this.element.firstChild)return{left:0,right:0};var e=r.computedStyle(this.element.firstChild);return this.$padding={},this.$padding.left=(parseInt(e.borderLeftWidth)||0)+(parseInt(e.paddingLeft)||0)+1,this.$padding.right=(parseInt(e.borderRightWidth)||0)+(parseInt(e.paddingRight)||0),this.$padding},e.prototype.getRegion=function(e){var t=this.$padding||this.$computePadding(),n=this.element.getBoundingClientRect();if(e.x<t.left+n.left)return"markers";if(this.$showFoldWidgets&&e.x>n.right-t.right)return"foldWidgets"},e}();f.prototype.$fixedWidth=!1,f.prototype.$highlightGutterLine=!0,f.prototype.$renderer=undefined,f.prototype.$showLineNumbers=!0,f.prototype.$showFoldWidgets=!0,i.implement(f.prototype,o),t.Gutter=f}),define("ace/layer/marker",["require","exports","module","ace/range","ace/lib/dom"],function(e,t,n){"use strict";function o(e,t,n,r){return(e?1:0)|(t?2:0)|(n?4:0)|(r?8:0)}var r=e("../range").Range,i=e("../lib/dom"),s=function(){function e(e){this.element=i.createElement("div"),this.element.className="ace_layer ace_marker-layer",e.appendChild(this.element)}return e.prototype.setPadding=function(e){this.$padding=e},e.prototype.setSession=function(e){this.session=e},e.prototype.setMarkers=function(e){this.markers=e},e.prototype.elt=function(e,t){var n=this.i!=-1&&this.element.childNodes[this.i];n?this.i++:(n=document.createElement("div"),this.element.appendChild(n),this.i=-1),n.style.cssText=t,n.className=e},e.prototype.update=function(e){if(!e)return;this.config=e,this.i=0;var t;for(var n in this.markers){var r=this.markers[n];if(!r.range){r.update(t,this,this.session,e);continue}var i=r.range.clipRows(e.firstRow,e.lastRow);if(i.isEmpty())continue;i=i.toScreenRange(this.session);if(r.renderer){var s=this.$getTop(i.start.row,e),o=this.$padding+i.start.column*e.characterWidth;r.renderer(t,i,o,s,e)}else r.type=="fullLine"?this.drawFullLineMarker(t,i,r.clazz,e):r.type=="screenLine"?this.drawScreenLineMarker(t,i,r.clazz,e):i.isMultiLine()?r.type=="text"?this.drawTextMarker(t,i,r.clazz,e):this.drawMultiLineMarker(t,i,r.clazz,e):this.drawSingleLineMarker(t,i,r.clazz+" ace_start"+" ace_br15",e)}if(this.i!=-1)while(this.i<this.element.childElementCount)this.element.removeChild(this.element.lastChild)},e.prototype.$getTop=function(e,t){return(e-t.firstRowScreen)*t.lineHeight},e.prototype.drawTextMarker=function(e,t,n,i,s){var u=this.session,a=t.start.row,f=t.end.row,l=a,c=0,h=0,p=u.getScreenLastRowColumn(l),d=new r(l,t.start.column,l,h);for(;l<=f;l++)d.start.row=d.end.row=l,d.start.column=l==a?t.start.column:u.getRowWrapIndent(l),d.end.column=p,c=h,h=p,p=l+1<f?u.getScreenLastRowColumn(l+1):l==f?0:t.end.column,this.drawSingleLineMarker(e,d,n+(l==a?" ace_start":"")+" ace_br"+o(l==a||l==a+1&&t.start.column,c<h,h>p,l==f),i,l==f?0:1,s)},e.prototype.drawMultiLineMarker=function(e,t,n,r,i){var s=this.$padding,o=r.lineHeight,u=this.$getTop(t.start.row,r),a=s+t.start.column*r.characterWidth;i=i||"";if(this.session.$bidiHandler.isBidiRow(t.start.row)){var f=t.clone();f.end.row=f.start.row,f.end.column=this.session.getLine(f.start.row).length,this.drawBidiSingleLineMarker(e,f,n+" ace_br1 ace_start",r,null,i)}else this.elt(n+" ace_br1 ace_start","height:"+o+"px;"+"right:"+s+"px;"+"top:"+u+"px;left:"+a+"px;"+(i||""));if(this.session.$bidiHandler.isBidiRow(t.end.row)){var f=t.clone();f.start.row=f.end.row,f.start.column=0,this.drawBidiSingleLineMarker(e,f,n+" ace_br12",r,null,i)}else{u=this.$getTop(t.end.row,r);var l=t.end.column*r.characterWidth;this.elt(n+" ace_br12","height:"+o+"px;"+"width:"+l+"px;"+"top:"+u+"px;"+"left:"+s+"px;"+(i||""))}o=(t.end.row-t.start.row-1)*r.lineHeight;if(o<=0)return;u=this.$getTop(t.start.row+1,r);var c=(t.start.column?1:0)|(t.end.column?0:8);this.elt(n+(c?" ace_br"+c:""),"height:"+o+"px;"+"right:"+s+"px;"+"top:"+u+"px;"+"left:"+s+"px;"+(i||""))},e.prototype.drawSingleLineMarker=function(e,t,n,r,i,s){if(this.session.$bidiHandler.isBidiRow(t.start.row))return this.drawBidiSingleLineMarker(e,t,n,r,i,s);var o=r.lineHeight,u=(t.end.column+(i||0)-t.start.column)*r.characterWidth,a=this.$getTop(t.start.row,r),f=this.$padding+t.start.column*r.characterWidth;this.elt(n,"height:"+o+"px;"+"width:"+u+"px;"+"top:"+a+"px;"+"left:"+f+"px;"+(s||""))},e.prototype.drawBidiSingleLineMarker=function(e,t,n,r,i,s){var o=r.lineHeight,u=this.$getTop(t.start.row,r),a=this.$padding,f=this.session.$bidiHandler.getSelections(t.start.column,t.end.column);f.forEach(function(e){this.elt(n,"height:"+o+"px;"+"width:"+(e.width+(i||0))+"px;"+"top:"+u+"px;"+"left:"+(a+e.left)+"px;"+(s||""))},this)},e.prototype.drawFullLineMarker=function(e,t,n,r,i){var s=this.$getTop(t.start.row,r),o=r.lineHeight;t.start.row!=t.end.row&&(o+=this.$getTop(t.end.row,r)-s),this.elt(n,"height:"+o+"px;"+"top:"+s+"px;"+"left:0;right:0;"+(i||""))},e.prototype.drawScreenLineMarker=function(e,t,n,r,i){var s=this.$getTop(t.start.row,r),o=r.lineHeight;this.elt(n,"height:"+o+"px;"+"top:"+s+"px;"+"left:0;right:0;"+(i||""))},e}();s.prototype.$padding=0,t.Marker=s}),define("ace/layer/text_util",["require","exports","module"],function(e,t,n){var r=new Set(["text","rparen","lparen"]);t.isTextToken=function(e){return r.has(e)}}),define("ace/layer/text",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/layer/lines","ace/lib/event_emitter","ace/config","ace/layer/text_util"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("../lib/dom"),s=e("../lib/lang"),o=e("./lines").Lines,u=e("../lib/event_emitter").EventEmitter,a=e("../config").nls,f=e("./text_util").isTextToken,l=function(){function e(e){this.dom=i,this.element=this.dom.createElement("div"),this.element.className="ace_layer ace_text-layer",e.appendChild(this.element),this.$updateEolChar=this.$updateEolChar.bind(this),this.$lines=new o(this.element)}return e.prototype.$updateEolChar=function(){var e=this.session.doc,t=e.getNewLineCharacter()=="\n"&&e.getNewLineMode()!="windows",n=t?this.EOL_CHAR_LF:this.EOL_CHAR_CRLF;if(this.EOL_CHAR!=n)return this.EOL_CHAR=n,!0},e.prototype.setPadding=function(e){this.$padding=e,this.element.style.margin="0 "+e+"px"},e.prototype.getLineHeight=function(){return this.$fontMetrics.$characterSize.height||0},e.prototype.getCharacterWidth=function(){return this.$fontMetrics.$characterSize.width||0},e.prototype.$setFontMetrics=function(e){this.$fontMetrics=e,this.$fontMetrics.on("changeCharacterSize",function(e){this._signal("changeCharacterSize",e)}.bind(this)),this.$pollSizeChanges()},e.prototype.checkForSizeChanges=function(){this.$fontMetrics.checkForSizeChanges()},e.prototype.$pollSizeChanges=function(){return this.$pollSizeChangesTimer=this.$fontMetrics.$pollSizeChanges()},e.prototype.setSession=function(e){this.session=e,e&&this.$computeTabString()},e.prototype.setShowInvisibles=function(e){return this.showInvisibles==e?!1:(this.showInvisibles=e,typeof e=="string"?(this.showSpaces=/tab/i.test(e),this.showTabs=/space/i.test(e),this.showEOL=/eol/i.test(e)):this.showSpaces=this.showTabs=this.showEOL=e,this.$computeTabString(),!0)},e.prototype.setDisplayIndentGuides=function(e){return this.displayIndentGuides==e?!1:(this.displayIndentGuides=e,this.$computeTabString(),!0)},e.prototype.setHighlightIndentGuides=function(e){return this.$highlightIndentGuides===e?!1:(this.$highlightIndentGuides=e,e)},e.prototype.$computeTabString=function(){var e=this.session.getTabSize();this.tabSize=e;var t=this.$tabStrings=[0];for(var n=1;n<e+1;n++)if(this.showTabs){var r=this.dom.createElement("span");r.className="ace_invisible ace_invisible_tab",r.textContent=s.stringRepeat(this.TAB_CHAR,n),t.push(r)}else t.push(this.dom.createTextNode(s.stringRepeat(" ",n),this.element));if(this.displayIndentGuides){this.$indentGuideRe=/\s\S| \t|\t |\s$/;var i="ace_indent-guide",o=this.showSpaces?" ace_invisible ace_invisible_space":"",u=this.showSpaces?s.stringRepeat(this.SPACE_CHAR,this.tabSize):s.stringRepeat(" ",this.tabSize),a=this.showTabs?" ace_invisible ace_invisible_tab":"",f=this.showTabs?s.stringRepeat(this.TAB_CHAR,this.tabSize):u,r=this.dom.createElement("span");r.className=i+o,r.textContent=u,this.$tabStrings[" "]=r;var r=this.dom.createElement("span");r.className=i+a,r.textContent=f,this.$tabStrings["	"]=r}},e.prototype.updateLines=function(e,t,n){if(this.config.lastRow!=e.lastRow||this.config.firstRow!=e.firstRow)return this.update(e);this.config=e;var r=Math.max(t,e.firstRow),i=Math.min(n,e.lastRow),s=this.element.childNodes,o=0;for(var u=e.firstRow;u<r;u++){var a=this.session.getFoldLine(u);if(a){if(a.containsRow(r)){r=a.start.row;break}u=a.end.row}o++}var f=!1,u=r,a=this.session.getNextFoldLine(u),l=a?a.start.row:Infinity;for(;;){u>l&&(u=a.end.row+1,a=this.session.getNextFoldLine(u,a),l=a?a.start.row:Infinity);if(u>i)break;var c=s[o++];if(c){this.dom.removeChildren(c),this.$renderLine(c,u,u==l?a:!1),f&&(c.style.top=this.$lines.computeLineTop(u,e,this.session)+"px");var h=e.lineHeight*this.session.getRowLength(u)+"px";c.style.height!=h&&(f=!0,c.style.height=h)}u++}if(f)while(o<this.$lines.cells.length){var p=this.$lines.cells[o++];p.element.style.top=this.$lines.computeLineTop(p.row,e,this.session)+"px"}},e.prototype.scrollLines=function(e){var t=this.config;this.config=e;if(this.$lines.pageChanged(t,e))return this.update(e);this.$lines.moveContainer(e);var n=e.lastRow,r=t?t.lastRow:-1;if(!t||r<e.firstRow)return this.update(e);if(n<t.firstRow)return this.update(e);if(!t||t.lastRow<e.firstRow)return this.update(e);if(e.lastRow<t.firstRow)return this.update(e);if(t.firstRow<e.firstRow)for(var i=this.session.getFoldedRowCount(t.firstRow,e.firstRow-1);i>0;i--)this.$lines.shift();if(t.lastRow>e.lastRow)for(var i=this.session.getFoldedRowCount(e.lastRow+1,t.lastRow);i>0;i--)this.$lines.pop();e.firstRow<t.firstRow&&this.$lines.unshift(this.$renderLinesFragment(e,e.firstRow,t.firstRow-1)),e.lastRow>t.lastRow&&this.$lines.push(this.$renderLinesFragment(e,t.lastRow+1,e.lastRow)),this.$highlightIndentGuide()},e.prototype.$renderLinesFragment=function(e,t,n){var r=[],s=t,o=this.session.getNextFoldLine(s),u=o?o.start.row:Infinity;for(;;){s>u&&(s=o.end.row+1,o=this.session.getNextFoldLine(s,o),u=o?o.start.row:Infinity);if(s>n)break;var a=this.$lines.createCell(s,e,this.session),f=a.element;this.dom.removeChildren(f),i.setStyle(f.style,"height",this.$lines.computeLineHeight(s,e,this.session)+"px"),i.setStyle(f.style,"top",this.$lines.computeLineTop(s,e,this.session)+"px"),this.$renderLine(f,s,s==u?o:!1),this.$useLineGroups()?f.className="ace_line_group":f.className="ace_line",r.push(a),s++}return r},e.prototype.update=function(e){this.$lines.moveContainer(e),this.config=e;var t=e.firstRow,n=e.lastRow,r=this.$lines;while(r.getLength())r.pop();r.push(this.$renderLinesFragment(e,t,n))},e.prototype.$renderToken=function(e,t,n,r){var i=this,o=/(\t)|( +)|([\x00-\x1f\x80-\xa0\xad\u1680\u180E\u2000-\u200f\u2028\u2029\u202F\u205F\uFEFF\uFFF9-\uFFFC\u2066\u2067\u2068\u202A\u202B\u202D\u202E\u202C\u2069\u2060\u2061\u2062\u2063\u2064\u206A\u206B\u206B\u206C\u206D\u206E\u206F]+)|(\u3000)|([\u1100-\u115F\u11A3-\u11A7\u11FA-\u11FF\u2329-\u232A\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3001-\u303E\u3041-\u3096\u3099-\u30FF\u3105-\u312D\u3131-\u318E\u3190-\u31BA\u31C0-\u31E3\u31F0-\u321E\u3220-\u3247\u3250-\u32FE\u3300-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFAFF\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFF01-\uFF60\uFFE0-\uFFE6]|[\uD800-\uDBFF][\uDC00-\uDFFF])/g,u=this.dom.createFragment(this.element),l,c=0;while(l=o.exec(r)){var h=l[1],p=l[2],d=l[3],v=l[4],m=l[5];if(!i.showSpaces&&p)continue;var g=c!=l.index?r.slice(c,l.index):"";c=l.index+l[0].length,g&&u.appendChild(this.dom.createTextNode(g,this.element));if(h){var y=i.session.getScreenTabSize(t+l.index),b=i.$tabStrings[y].cloneNode(!0);b.charCount=1,u.appendChild(b),t+=y-1}else if(p)if(i.showSpaces){var w=this.dom.createElement("span");w.className="ace_invisible ace_invisible_space",w.textContent=s.stringRepeat(i.SPACE_CHAR,p.length),u.appendChild(w)}else u.appendChild(this.dom.createTextNode(p,this.element));else if(d){var w=this.dom.createElement("span");w.className="ace_invisible ace_invisible_space ace_invalid",w.textContent=s.stringRepeat(i.SPACE_CHAR,d.length),u.appendChild(w)}else if(v){t+=1;var w=this.dom.createElement("span");w.style.width=i.config.characterWidth*2+"px",w.className=i.showSpaces?"ace_cjk ace_invisible ace_invisible_space":"ace_cjk",w.textContent=i.showSpaces?i.SPACE_CHAR:v,u.appendChild(w)}else if(m){t+=1;var w=this.dom.createElement("span");w.style.width=i.config.characterWidth*2+"px",w.className="ace_cjk",w.textContent=m,u.appendChild(w)}}u.appendChild(this.dom.createTextNode(c?r.slice(c):r,this.element));if(!f(n.type)){var E="ace_"+n.type.replace(/\./g," ace_"),w=this.dom.createElement("span");n.type=="fold"&&(w.style.width=n.value.length*this.config.characterWidth+"px",w.setAttribute("title",a("inline-fold.closed.title","Unfold code"))),w.className=E,w.appendChild(u),e.appendChild(w)}else e.appendChild(u);return t+r.length},e.prototype.renderIndentGuide=function(e,t,n){var r=t.search(this.$indentGuideRe);if(r<=0||r>=n)return t;if(t[0]==" "){r-=r%this.tabSize;var i=r/this.tabSize;for(var s=0;s<i;s++)e.appendChild(this.$tabStrings[" "].cloneNode(!0));return this.$highlightIndentGuide(),t.substr(r)}if(t[0]=="	"){for(var s=0;s<r;s++){var o=this.$tabStrings["	"].cloneNode(!0);o.charCount=1,e.appendChild(o)}return this.$highlightIndentGuide(),t.substr(r)}return this.$highlightIndentGuide(),t},e.prototype.$highlightIndentGuide=function(){if(!this.$highlightIndentGuides||!this.displayIndentGuides)return;this.$highlightIndentGuideMarker={indentLevel:undefined,start:undefined,end:undefined,dir:undefined};var e=this.session.doc.$lines;if(!e)return;var t=this.session.selection.getCursor(),n=/^\s*/.exec(this.session.doc.getLine(t.row))[0].length,r=Math.floor(n/this.tabSize);this.$highlightIndentGuideMarker={indentLevel:r,start:t.row};var i=this.session.$bracketHighlight;if(i){var s=this.session.$bracketHighlight.ranges;for(var o=0;o<s.length;o++)if(t.row!==s[o].start.row){this.$highlightIndentGuideMarker.end=s[o].start.row+1,t.row>s[o].start.row?this.$highlightIndentGuideMarker.dir=-1:this.$highlightIndentGuideMarker.dir=1;break}}if(!this.$highlightIndentGuideMarker.end&&e[t.row]!==""&&t.column===e[t.row].length){this.$highlightIndentGuideMarker.dir=1;for(var o=t.row+1;o<e.length;o++){var u=e[o],a=/^\s*/.exec(u)[0].length;if(u!==""){this.$highlightIndentGuideMarker.end=o;if(a<=n)break}}}this.$renderHighlightIndentGuide()},e.prototype.$clearActiveIndentGuide=function(){var e=this.element.querySelectorAll(".ace_indent-guide-active");for(var t=0;t<e.length;t++)e[t].classList.remove("ace_indent-guide-active")},e.prototype.$setIndentGuideActive=function(e,t){var n=this.session.doc.getLine(e.row);if(n!==""){var r=e.element;if(e.element.classList&&e.element.classList.contains("ace_line_group")){if(!(e.element.childNodes.length>0))return;r=e.element.childNodes[0]}var i=r.childNodes;if(i){var s=i[t-1];s&&s.classList&&s.classList.contains("ace_indent-guide")&&s.classList.add("ace_indent-guide-active")}}},e.prototype.$renderHighlightIndentGuide=function(){if(!this.$lines)return;var e=this.$lines.cells;this.$clearActiveIndentGuide();var t=this.$highlightIndentGuideMarker.indentLevel;if(t!==0)if(this.$highlightIndentGuideMarker.dir===1)for(var n=0;n<e.length;n++){var r=e[n];if(this.$highlightIndentGuideMarker.end&&r.row>=this.$highlightIndentGuideMarker.start+1){if(r.row>=this.$highlightIndentGuideMarker.end)break;this.$setIndentGuideActive(r,t)}}else for(var n=e.length-1;n>=0;n--){var r=e[n];if(this.$highlightIndentGuideMarker.end&&r.row<this.$highlightIndentGuideMarker.start){if(r.row<this.$highlightIndentGuideMarker.end)break;this.$setIndentGuideActive(r,t)}}},e.prototype.$createLineElement=function(e){var t=this.dom.createElement("div");return t.className="ace_line",t.style.height=this.config.lineHeight+"px",t},e.prototype.$renderWrappedLine=function(e,t,n){var r=0,i=0,o=n[0],u=0,a=this.$createLineElement();e.appendChild(a);for(var f=0;f<t.length;f++){var l=t[f],c=l.value;if(f==0&&this.displayIndentGuides){r=c.length,c=this.renderIndentGuide(a,c,o);if(!c)continue;r-=c.length}if(r+c.length<o)u=this.$renderToken(a,u,l,c),r+=c.length;else{while(r+c.length>=o){u=this.$renderToken(a,u,l,c.substring(0,o-r)),c=c.substring(o-r),r=o,a=this.$createLineElement(),e.appendChild(a);var h=this.dom.createTextNode(s.stringRepeat("\u00a0",n.indent),this.element);h.charCount=0,a.appendChild(h),i++,u=0,o=n[i]||Number.MAX_VALUE}c.length!=0&&(r+=c.length,u=this.$renderToken(a,u,l,c))}}n[n.length-1]>this.MAX_LINE_LENGTH&&this.$renderOverflowMessage(a,u,null,"",!0)},e.prototype.$renderSimpleLine=function(e,t){var n=0;for(var r=0;r<t.length;r++){var i=t[r],s=i.value;if(r==0&&this.displayIndentGuides){s=this.renderIndentGuide(e,s);if(!s)continue}if(n+s.length>this.MAX_LINE_LENGTH)return this.$renderOverflowMessage(e,n,i,s);n=this.$renderToken(e,n,i,s)}},e.prototype.$renderOverflowMessage=function(e,t,n,r,i){n&&this.$renderToken(e,t,n,r.slice(0,this.MAX_LINE_LENGTH-t));var s=this.dom.createElement("span");s.className="ace_inline_button ace_keyword ace_toggle_wrap",s.textContent=i?"<hide>":"<click to see more...>",e.appendChild(s)},e.prototype.$renderLine=function(e,t,n){!n&&n!=0&&(n=this.session.getFoldLine(t));if(n)var r=this.$getFoldLineTokens(t,n);else var r=this.session.getTokens(t);var i=e;if(r.length){var s=this.session.getRowSplitData(t);if(s&&s.length){this.$renderWrappedLine(e,r,s);var i=e.lastChild}else{var i=e;this.$useLineGroups()&&(i=this.$createLineElement(),e.appendChild(i)),this.$renderSimpleLine(i,r)}}else this.$useLineGroups()&&(i=this.$createLineElement(),e.appendChild(i));if(this.showEOL&&i){n&&(t=n.end.row);var o=this.dom.createElement("span");o.className="ace_invisible ace_invisible_eol",o.textContent=t==this.session.getLength()-1?this.EOF_CHAR:this.EOL_CHAR,i.appendChild(o)}},e.prototype.$getFoldLineTokens=function(e,t){function i(e,t,n){var i=0,s=0;while(s+e[i].value.length<t){s+=e[i].value.length,i++;if(i==e.length)return}if(s!=t){var o=e[i].value.substring(t-s);o.length>n-t&&(o=o.substring(0,n-t)),r.push({type:e[i].type,value:o}),s=t+o.length,i+=1}while(s<n&&i<e.length){var o=e[i].value;o.length+s>n?r.push({type:e[i].type,value:o.substring(0,n-s)}):r.push(e[i]),s+=o.length,i+=1}}var n=this.session,r=[],s=n.getTokens(e);return t.walk(function(e,t,o,u,a){e!=null?r.push({type:"fold",value:e}):(a&&(s=n.getTokens(t)),s.length&&i(s,u,o))},t.end.row,this.session.getLine(t.end.row).length),r},e.prototype.$useLineGroups=function(){return this.session.getUseWrapMode()},e}();l.prototype.EOF_CHAR="\u00b6",l.prototype.EOL_CHAR_LF="\u00ac",l.prototype.EOL_CHAR_CRLF="\u00a4",l.prototype.EOL_CHAR=l.prototype.EOL_CHAR_LF,l.prototype.TAB_CHAR="\u2014",l.prototype.SPACE_CHAR="\u00b7",l.prototype.$padding=0,l.prototype.MAX_LINE_LENGTH=1e4,l.prototype.showInvisibles=!1,l.prototype.showSpaces=!1,l.prototype.showTabs=!1,l.prototype.showEOL=!1,l.prototype.displayIndentGuides=!0,l.prototype.$highlightIndentGuides=!0,l.prototype.$tabStrings=[],l.prototype.destroy={},l.prototype.onChangeTabSize=l.prototype.$computeTabString,r.implement(l.prototype,u),t.Text=l}),define("ace/layer/cursor",["require","exports","module","ace/lib/dom"],function(e,t,n){"use strict";var r=e("../lib/dom"),i=function(){function e(e){this.element=r.createElement("div"),this.element.className="ace_layer ace_cursor-layer",e.appendChild(this.element),this.isVisible=!1,this.isBlinking=!0,this.blinkInterval=1e3,this.smoothBlinking=!1,this.cursors=[],this.cursor=this.addCursor(),r.addCssClass(this.element,"ace_hidden-cursors"),this.$updateCursors=this.$updateOpacity.bind(this)}return e.prototype.$updateOpacity=function(e){var t=this.cursors;for(var n=t.length;n--;)r.setStyle(t[n].style,"opacity",e?"":"0")},e.prototype.$startCssAnimation=function(){var e=this.cursors;for(var t=e.length;t--;)e[t].style.animationDuration=this.blinkInterval+"ms";this.$isAnimating=!0,setTimeout(function(){this.$isAnimating&&r.addCssClass(this.element,"ace_animate-blinking")}.bind(this))},e.prototype.$stopCssAnimation=function(){this.$isAnimating=!1,r.removeCssClass(this.element,"ace_animate-blinking")},e.prototype.setPadding=function(e){this.$padding=e},e.prototype.setSession=function(e){this.session=e},e.prototype.setBlinking=function(e){e!=this.isBlinking&&(this.isBlinking=e,this.restartTimer())},e.prototype.setBlinkInterval=function(e){e!=this.blinkInterval&&(this.blinkInterval=e,this.restartTimer())},e.prototype.setSmoothBlinking=function(e){e!=this.smoothBlinking&&(this.smoothBlinking=e,r.setCssClass(this.element,"ace_smooth-blinking",e),this.$updateCursors(!0),this.restartTimer())},e.prototype.addCursor=function(){var e=r.createElement("div");return e.className="ace_cursor",this.element.appendChild(e),this.cursors.push(e),e},e.prototype.removeCursor=function(){if(this.cursors.length>1){var e=this.cursors.pop();return e.parentNode.removeChild(e),e}},e.prototype.hideCursor=function(){this.isVisible=!1,r.addCssClass(this.element,"ace_hidden-cursors"),this.restartTimer()},e.prototype.showCursor=function(){this.isVisible=!0,r.removeCssClass(this.element,"ace_hidden-cursors"),this.restartTimer()},e.prototype.restartTimer=function(){var e=this.$updateCursors;clearInterval(this.intervalId),clearTimeout(this.timeoutId),this.$stopCssAnimation(),this.smoothBlinking&&(this.$isSmoothBlinking=!1,r.removeCssClass(this.element,"ace_smooth-blinking")),e(!0);if(!this.isBlinking||!this.blinkInterval||!this.isVisible){this.$stopCssAnimation();return}this.smoothBlinking&&(this.$isSmoothBlinking=!0,setTimeout(function(){this.$isSmoothBlinking&&r.addCssClass(this.element,"ace_smooth-blinking")}.bind(this)));if(r.HAS_CSS_ANIMATION)this.$startCssAnimation();else{var t=function(){this.timeoutId=setTimeout(function(){e(!1)},.6*this.blinkInterval)}.bind(this);this.intervalId=setInterval(function(){e(!0),t()},this.blinkInterval),t()}},e.prototype.getPixelPosition=function(e,t){if(!this.config||!this.session)return{left:0,top:0};e||(e=this.session.selection.getCursor());var n=this.session.documentToScreenPosition(e),r=this.$padding+(this.session.$bidiHandler.isBidiRow(n.row,e.row)?this.session.$bidiHandler.getPosLeft(n.column):n.column*this.config.characterWidth),i=(n.row-(t?this.config.firstRowScreen:0))*this.config.lineHeight;return{left:r,top:i}},e.prototype.isCursorInView=function(e,t){return e.top>=0&&e.top<t.maxHeight},e.prototype.update=function(e){this.config=e;var t=this.session.$selectionMarkers,n=0,i=0;if(t===undefined||t.length===0)t=[{cursor:null}];for(var n=0,s=t.length;n<s;n++){var o=this.getPixelPosition(t[n].cursor,!0);if((o.top>e.height+e.offset||o.top<0)&&n>1)continue;var u=this.cursors[i++]||this.addCursor(),a=u.style;this.drawCursor?this.drawCursor(u,o,e,t[n],this.session):this.isCursorInView(o,e)?(r.setStyle(a,"display","block"),r.translate(u,o.left,o.top),r.setStyle(a,"width",Math.round(e.characterWidth)+"px"),r.setStyle(a,"height",e.lineHeight+"px")):r.setStyle(a,"display","none")}while(this.cursors.length>i)this.removeCursor();var f=this.session.getOverwrite();this.$setOverwrite(f),this.$pixelPos=o,this.restartTimer()},e.prototype.$setOverwrite=function(e){e!=this.overwrite&&(this.overwrite=e,e?r.addCssClass(this.element,"ace_overwrite-cursors"):r.removeCssClass(this.element,"ace_overwrite-cursors"))},e.prototype.destroy=function(){clearInterval(this.intervalId),clearTimeout(this.timeoutId)},e}();i.prototype.$padding=0,i.prototype.drawCursor=null,t.Cursor=i}),define("ace/scrollbar",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/event","ace/lib/event_emitter"],function(e,t,n){"use strict";var r=this&&this.__extends||function(){var e=function(t,n){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},e(t,n)};return function(t,n){function r(){this.constructor=t}if(typeof n!="function"&&n!==null)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");e(t,n),t.prototype=n===null?Object.create(n):(r.prototype=n.prototype,new r)}}(),i=e("./lib/oop"),s=e("./lib/dom"),o=e("./lib/event"),u=e("./lib/event_emitter").EventEmitter,a=32768,f=function(){function e(e,t){this.element=s.createElement("div"),this.element.className="ace_scrollbar ace_scrollbar"+t,this.element.tabIndex=-1,this.inner=s.createElement("div"),this.inner.className="ace_scrollbar-inner",this.inner.textContent="\u00a0",this.element.appendChild(this.inner),e.appendChild(this.element),this.setVisible(!1),this.skipEvent=!1,o.addListener(this.element,"scroll",this.onScroll.bind(this)),o.addListener(this.element,"mousedown",o.preventDefault)}return e.prototype.setVisible=function(e){this.element.style.display=e?"":"none",this.isVisible=e,this.coeff=1},e}();i.implement(f.prototype,u);var l=function(e){function t(t,n){var r=e.call(this,t,"-v")||this;return r.scrollTop=0,r.scrollHeight=0,n.$scrollbarWidth=r.width=s.scrollbarWidth(t.ownerDocument),r.inner.style.width=r.element.style.width=(r.width||15)+5+"px",r.$minWidth=0,r}return r(t,e),t.prototype.onScroll=function(){if(!this.skipEvent){this.scrollTop=this.element.scrollTop;if(this.coeff!=1){var e=this.element.clientHeight/this.scrollHeight;this.scrollTop=this.scrollTop*(1-e)/(this.coeff-e)}this._emit("scroll",{data:this.scrollTop})}this.skipEvent=!1},t.prototype.getWidth=function(){return Math.max(this.isVisible?this.width:0,this.$minWidth||0)},t.prototype.setHeight=function(e){this.element.style.height=e+"px"},t.prototype.setScrollHeight=function(e){this.scrollHeight=e,e>a?(this.coeff=a/e,e=a):this.coeff!=1&&(this.coeff=1),this.inner.style.height=e+"px"},t.prototype.setScrollTop=function(e){this.scrollTop!=e&&(this.skipEvent=!0,this.scrollTop=e,this.element.scrollTop=e*this.coeff)},t}(f);l.prototype.setInnerHeight=l.prototype.setScrollHeight;var c=function(e){function t(t,n){var r=e.call(this,t,"-h")||this;return r.scrollLeft=0,r.height=n.$scrollbarWidth,r.inner.style.height=r.element.style.height=(r.height||15)+5+"px",r}return r(t,e),t.prototype.onScroll=function(){this.skipEvent||(this.scrollLeft=this.element.scrollLeft,this._emit("scroll",{data:this.scrollLeft})),this.skipEvent=!1},t.prototype.getHeight=function(){return this.isVisible?this.height:0},t.prototype.setWidth=function(e){this.element.style.width=e+"px"},t.prototype.setInnerWidth=function(e){this.inner.style.width=e+"px"},t.prototype.setScrollWidth=function(e){this.inner.style.width=e+"px"},t.prototype.setScrollLeft=function(e){this.scrollLeft!=e&&(this.skipEvent=!0,this.scrollLeft=this.element.scrollLeft=e)},t}(f);t.ScrollBar=l,t.ScrollBarV=l,t.ScrollBarH=c,t.VScrollBar=l,t.HScrollBar=c}),define("ace/scrollbar_custom",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/event","ace/lib/event_emitter"],function(e,t,n){"use strict";var r=this&&this.__extends||function(){var e=function(t,n){return e=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},e(t,n)};return function(t,n){function r(){this.constructor=t}if(typeof n!="function"&&n!==null)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");e(t,n),t.prototype=n===null?Object.create(n):(r.prototype=n.prototype,new r)}}(),i=e("./lib/oop"),s=e("./lib/dom"),o=e("./lib/event"),u=e("./lib/event_emitter").EventEmitter;s.importCssString(".ace_editor>.ace_sb-v div, .ace_editor>.ace_sb-h div{\n  position: absolute;\n  background: rgba(128, 128, 128, 0.6);\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  border: 1px solid #bbb;\n  border-radius: 2px;\n  z-index: 8;\n}\n.ace_editor>.ace_sb-v, .ace_editor>.ace_sb-h {\n  position: absolute;\n  z-index: 6;\n  background: none;\n  overflow: hidden!important;\n}\n.ace_editor>.ace_sb-v {\n  z-index: 6;\n  right: 0;\n  top: 0;\n  width: 12px;\n}\n.ace_editor>.ace_sb-v div {\n  z-index: 8;\n  right: 0;\n  width: 100%;\n}\n.ace_editor>.ace_sb-h {\n  bottom: 0;\n  left: 0;\n  height: 12px;\n}\n.ace_editor>.ace_sb-h div {\n  bottom: 0;\n  height: 100%;\n}\n.ace_editor>.ace_sb_grabbed {\n  z-index: 8;\n  background: #000;\n}","ace_scrollbar.css",!1);var a=function(){function e(e,t){this.element=s.createElement("div"),this.element.className="ace_sb"+t,this.inner=s.createElement("div"),this.inner.className="",this.element.appendChild(this.inner),this.VScrollWidth=12,this.HScrollHeight=12,e.appendChild(this.element),this.setVisible(!1),this.skipEvent=!1,o.addMultiMouseDownListener(this.element,[500,300,300],this,"onMouseDown")}return e.prototype.setVisible=function(e){this.element.style.display=e?"":"none",this.isVisible=e,this.coeff=1},e}();i.implement(a.prototype,u);var f=function(e){function t(t,n){var r=e.call(this,t,"-v")||this;return r.scrollTop=0,r.scrollHeight=0,r.parent=t,r.width=r.VScrollWidth,r.renderer=n,r.inner.style.width=r.element.style.width=(r.width||15)+"px",r.$minWidth=0,r}return r(t,e),t.prototype.onMouseDown=function(e,t){if(e!=="mousedown")return;if(o.getButton(t)!==0||t.detail===2)return;if(t.target===this.inner){var n=this,r=t.clientY,i=function(e){r=e.clientY},s=function(){clearInterval(l)},u=t.clientY,a=this.thumbTop,f=function(){if(r===undefined)return;var e=n.scrollTopFromThumbTop(a+r-u);if(e===n.scrollTop)return;n._emit("scroll",{data:e})};o.capture(this.inner,i,s);var l=setInterval(f,20);return o.preventDefault(t)}var c=t.clientY-this.element.getBoundingClientRect().top-this.thumbHeight/2;return this._emit("scroll",{data:this.scrollTopFromThumbTop(c)}),o.preventDefault(t)},t.prototype.getHeight=function(){return this.height},t.prototype.scrollTopFromThumbTop=function(e){var t=e*(this.pageHeight-this.viewHeight)/(this.slideHeight-this.thumbHeight);return t>>=0,t<0?t=0:t>this.pageHeight-this.viewHeight&&(t=this.pageHeight-this.viewHeight),t},t.prototype.getWidth=function(){return Math.max(this.isVisible?this.width:0,this.$minWidth||0)},t.prototype.setHeight=function(e){this.height=Math.max(0,e),this.slideHeight=this.height,this.viewHeight=this.height,this.setScrollHeight(this.pageHeight,!0)},t.prototype.setScrollHeight=function(e,t){if(this.pageHeight===e&&!t)return;this.pageHeight=e,this.thumbHeight=this.slideHeight*this.viewHeight/this.pageHeight,this.thumbHeight>this.slideHeight&&(this.thumbHeight=this.slideHeight),this.thumbHeight<15&&(this.thumbHeight=15),this.inner.style.height=this.thumbHeight+"px",this.scrollTop>this.pageHeight-this.viewHeight&&(this.scrollTop=this.pageHeight-this.viewHeight,this.scrollTop<0&&(this.scrollTop=0),this._emit("scroll",{data:this.scrollTop}))},t.prototype.setScrollTop=function(e){this.scrollTop=e,e<0&&(e=0),this.thumbTop=e*(this.slideHeight-this.thumbHeight)/(this.pageHeight-this.viewHeight),this.inner.style.top=this.thumbTop+"px"},t}(a);f.prototype.setInnerHeight=f.prototype.setScrollHeight;var l=function(e){function t(t,n){var r=e.call(this,t,"-h")||this;return r.scrollLeft=0,r.scrollWidth=0,r.height=r.HScrollHeight,r.inner.style.height=r.element.style.height=(r.height||12)+"px",r.renderer=n,r}return r(t,e),t.prototype.onMouseDown=function(e,t){if(e!=="mousedown")return;if(o.getButton(t)!==0||t.detail===2)return;if(t.target===this.inner){var n=this,r=t.clientX,i=function(e){r=e.clientX},s=function(){clearInterval(l)},u=t.clientX,a=this.thumbLeft,f=function(){if(r===undefined)return;var e=n.scrollLeftFromThumbLeft(a+r-u);if(e===n.scrollLeft)return;n._emit("scroll",{data:e})};o.capture(this.inner,i,s);var l=setInterval(f,20);return o.preventDefault(t)}var c=t.clientX-this.element.getBoundingClientRect().left-this.thumbWidth/2;return this._emit("scroll",{data:this.scrollLeftFromThumbLeft(c)}),o.preventDefault(t)},t.prototype.getHeight=function(){return this.isVisible?this.height:0},t.prototype.scrollLeftFromThumbLeft=function(e){var t=e*(this.pageWidth-this.viewWidth)/(this.slideWidth-this.thumbWidth);return t>>=0,t<0?t=0:t>this.pageWidth-this.viewWidth&&(t=this.pageWidth-this.viewWidth),t},t.prototype.setWidth=function(e){this.width=Math.max(0,e),this.element.style.width=this.width+"px",this.slideWidth=this.width,this.viewWidth=this.width,this.setScrollWidth(this.pageWidth,!0)},t.prototype.setScrollWidth=function(e,t){if(this.pageWidth===e&&!t)return;this.pageWidth=e,this.thumbWidth=this.slideWidth*this.viewWidth/this.pageWidth,this.thumbWidth>this.slideWidth&&(this.thumbWidth=this.slideWidth),this.thumbWidth<15&&(this.thumbWidth=15),this.inner.style.width=this.thumbWidth+"px",this.scrollLeft>this.pageWidth-this.viewWidth&&(this.scrollLeft=this.pageWidth-this.viewWidth,this.scrollLeft<0&&(this.scrollLeft=0),this._emit("scroll",{data:this.scrollLeft}))},t.prototype.setScrollLeft=function(e){this.scrollLeft=e,e<0&&(e=0),this.thumbLeft=e*(this.slideWidth-this.thumbWidth)/(this.pageWidth-this.viewWidth),this.inner.style.left=this.thumbLeft+"px"},t}(a);l.prototype.setInnerWidth=l.prototype.setScrollWidth,t.ScrollBar=f,t.ScrollBarV=f,t.ScrollBarH=l,t.VScrollBar=f,t.HScrollBar=l}),define("ace/renderloop",["require","exports","module","ace/lib/event"],function(e,t,n){"use strict";var r=e("./lib/event"),i=function(){function e(e,t){this.onRender=e,this.pending=!1,this.changes=0,this.$recursionLimit=2,this.window=t||window;var n=this;this._flush=function(e){n.pending=!1;var t=n.changes;t&&(r.blockIdle(100),n.changes=0,n.onRender(t));if(n.changes){if(n.$recursionLimit--<0)return;n.schedule()}else n.$recursionLimit=2}}return e.prototype.schedule=function(e){this.changes=this.changes|e,this.changes&&!this.pending&&(r.nextFrame(this._flush),this.pending=!0)},e.prototype.clear=function(e){var t=this.changes;return this.changes=0,t},e}();t.RenderLoop=i}),define("ace/layer/font_metrics",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/lib/event","ace/lib/useragent","ace/lib/event_emitter"],function(e,t,n){var r=e("../lib/oop"),i=e("../lib/dom"),s=e("../lib/lang"),o=e("../lib/event"),u=e("../lib/useragent"),a=e("../lib/event_emitter").EventEmitter,f=512,l=typeof ResizeObserver=="function",c=200,h=function(){function e(e){this.el=i.createElement("div"),this.$setMeasureNodeStyles(this.el.style,!0),this.$main=i.createElement("div"),this.$setMeasureNodeStyles(this.$main.style),this.$measureNode=i.createElement("div"),this.$setMeasureNodeStyles(this.$measureNode.style),this.el.appendChild(this.$main),this.el.appendChild(this.$measureNode),e.appendChild(this.el),this.$measureNode.textContent=s.stringRepeat("X",f),this.$characterSize={width:0,height:0},l?this.$addObserver():this.checkForSizeChanges()}return e.prototype.$setMeasureNodeStyles=function(e,t){e.width=e.height="auto",e.left=e.top="0px",e.visibility="hidden",e.position="absolute",e.whiteSpace="pre",u.isIE<8?e["font-family"]="inherit":e.font="inherit",e.overflow=t?"hidden":"visible"},e.prototype.checkForSizeChanges=function(e){e===undefined&&(e=this.$measureSizes());if(e&&(this.$characterSize.width!==e.width||this.$characterSize.height!==e.height)){this.$measureNode.style.fontWeight="bold";var t=this.$measureSizes();this.$measureNode.style.fontWeight="",this.$characterSize=e,this.charSizes=Object.create(null),this.allowBoldFonts=t&&t.width===e.width&&t.height===e.height,this._emit("changeCharacterSize",{data:e})}},e.prototype.$addObserver=function(){var e=this;this.$observer=new window.ResizeObserver(function(t){e.checkForSizeChanges()}),this.$observer.observe(this.$measureNode)},e.prototype.$pollSizeChanges=function(){if(this.$pollSizeChangesTimer||this.$observer)return this.$pollSizeChangesTimer;var e=this;return this.$pollSizeChangesTimer=o.onIdle(function t(){e.checkForSizeChanges(),o.onIdle(t,500)},500)},e.prototype.setPolling=function(e){e?this.$pollSizeChanges():this.$pollSizeChangesTimer&&(clearInterval(this.$pollSizeChangesTimer),this.$pollSizeChangesTimer=0)},e.prototype.$measureSizes=function(e){var t={height:(e||this.$measureNode).clientHeight,width:(e||this.$measureNode).clientWidth/f};return t.width===0||t.height===0?null:t},e.prototype.$measureCharWidth=function(e){this.$main.textContent=s.stringRepeat(e,f);var t=this.$main.getBoundingClientRect();return t.width/f},e.prototype.getCharacterWidth=function(e){var t=this.charSizes[e];return t===undefined&&(t=this.charSizes[e]=this.$measureCharWidth(e)/this.$characterSize.width),t},e.prototype.destroy=function(){clearInterval(this.$pollSizeChangesTimer),this.$observer&&this.$observer.disconnect(),this.el&&this.el.parentNode&&this.el.parentNode.removeChild(this.el)},e.prototype.$getZoom=function(e){return!e||!e.parentElement?1:(Number(window.getComputedStyle(e).zoom)||1)*this.$getZoom(e.parentElement)},e.prototype.$initTransformMeasureNodes=function(){var e=function(e,t){return["div",{style:"position: absolute;top:"+e+"px;left:"+t+"px;"}]};this.els=i.buildDom([e(0,0),e(c,0),e(0,c),e(c,c)],this.el)},e.prototype.transformCoordinates=function(e,t){function r(e,t,n){var r=e[1]*t[0]-e[0]*t[1];return[(-t[1]*n[0]+t[0]*n[1])/r,(+e[1]*n[0]-e[0]*n[1])/r]}function i(e,t){return[e[0]-t[0],e[1]-t[1]]}function s(e,t){return[e[0]+t[0],e[1]+t[1]]}function o(e,t){return[e*t[0],e*t[1]]}function u(e){var t=e.getBoundingClientRect();return[t.left,t.top]}if(e){var n=this.$getZoom(this.el);e=o(1/n,e)}this.els||this.$initTransformMeasureNodes();var a=u(this.els[0]),f=u(this.els[1]),l=u(this.els[2]),h=u(this.els[3]),p=r(i(h,f),i(h,l),i(s(f,l),s(h,a))),d=o(1+p[0],i(f,a)),v=o(1+p[1],i(l,a));if(t){var m=t,g=p[0]*m[0]/c+p[1]*m[1]/c+1,y=s(o(m[0],d),o(m[1],v));return s(o(1/g/c,y),a)}var b=i(e,a),w=r(i(d,o(p[0],b)),i(v,o(p[1],b)),b);return o(c,w)},e}();h.prototype.$characterSize={width:0,height:0},r.implement(h.prototype,a),t.FontMetrics=h}),define("ace/css/editor-css",["require","exports","module"],function(e,t,n){n.exports='\n.ace_br1 {border-top-left-radius    : 3px;}\n.ace_br2 {border-top-right-radius   : 3px;}\n.ace_br3 {border-top-left-radius    : 3px; border-top-right-radius:    3px;}\n.ace_br4 {border-bottom-right-radius: 3px;}\n.ace_br5 {border-top-left-radius    : 3px; border-bottom-right-radius: 3px;}\n.ace_br6 {border-top-right-radius   : 3px; border-bottom-right-radius: 3px;}\n.ace_br7 {border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px;}\n.ace_br8 {border-bottom-left-radius : 3px;}\n.ace_br9 {border-top-left-radius    : 3px; border-bottom-left-radius:  3px;}\n.ace_br10{border-top-right-radius   : 3px; border-bottom-left-radius:  3px;}\n.ace_br11{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-left-radius:  3px;}\n.ace_br12{border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\n.ace_br13{border-top-left-radius    : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\n.ace_br14{border-top-right-radius   : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}\n.ace_br15{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px; border-bottom-left-radius: 3px;}\n\n\n.ace_editor {\n    position: relative;\n    overflow: hidden;\n    padding: 0;\n    font: 12px/normal \'Monaco\', \'Menlo\', \'Ubuntu Mono\', \'Consolas\', \'Source Code Pro\', \'source-code-pro\', monospace;\n    direction: ltr;\n    text-align: left;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    forced-color-adjust: none;\n}\n\n.ace_scroller {\n    position: absolute;\n    overflow: hidden;\n    top: 0;\n    bottom: 0;\n    background-color: inherit;\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    cursor: text;\n}\n\n.ace_content {\n    position: absolute;\n    box-sizing: border-box;\n    min-width: 100%;\n    contain: style size layout;\n    font-variant-ligatures: no-common-ligatures;\n}\n.ace_invisible {\n    font-variant-ligatures: none;\n}\n\n.ace_keyboard-focus:focus {\n    box-shadow: inset 0 0 0 2px #5E9ED6;\n    outline: none;\n}\n\n.ace_dragging .ace_scroller:before{\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    content: \'\';\n    background: rgba(250, 250, 250, 0.01);\n    z-index: 1000;\n}\n.ace_dragging.ace_dark .ace_scroller:before{\n    background: rgba(0, 0, 0, 0.01);\n}\n\n.ace_gutter {\n    position: absolute;\n    overflow : hidden;\n    width: auto;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    cursor: default;\n    z-index: 4;\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    contain: style size layout;\n}\n\n.ace_gutter-active-line {\n    position: absolute;\n    left: 0;\n    right: 0;\n}\n\n.ace_scroller.ace_scroll-left:after {\n    content: "";\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    box-shadow: 17px 0 16px -16px rgba(0, 0, 0, 0.4) inset;\n    pointer-events: none;\n}\n\n.ace_gutter-cell, .ace_gutter-cell_svg-icons {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    padding-left: 19px;\n    padding-right: 6px;\n    background-repeat: no-repeat;\n}\n\n.ace_gutter-cell_svg-icons .ace_gutter_annotation {\n    margin-left: -14px;\n    float: left;\n}\n\n.ace_gutter-cell .ace_gutter_annotation {\n    margin-left: -19px;\n    float: left;\n}\n\n.ace_gutter-cell.ace_error, .ace_icon.ace_error, .ace_icon.ace_error_fold, .ace_gutter-cell.ace_security, .ace_icon.ace_security, .ace_icon.ace_security_fold {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAABOFBMVEX/////////QRswFAb/Ui4wFAYwFAYwFAaWGAfDRymzOSH/PxswFAb/SiUwFAYwFAbUPRvjQiDllog5HhHdRybsTi3/Tyv9Tir+Syj/UC3////XurebMBIwFAb/RSHbPx/gUzfdwL3kzMivKBAwFAbbvbnhPx66NhowFAYwFAaZJg8wFAaxKBDZurf/RB6mMxb/SCMwFAYwFAbxQB3+RB4wFAb/Qhy4Oh+4QifbNRcwFAYwFAYwFAb/QRzdNhgwFAYwFAbav7v/Uy7oaE68MBK5LxLewr/r2NXewLswFAaxJw4wFAbkPRy2PyYwFAaxKhLm1tMwFAazPiQwFAaUGAb/QBrfOx3bvrv/VC/maE4wFAbRPBq6MRO8Qynew8Dp2tjfwb0wFAbx6eju5+by6uns4uH9/f36+vr/GkHjAAAAYnRSTlMAGt+64rnWu/bo8eAA4InH3+DwoN7j4eLi4xP99Nfg4+b+/u9B/eDs1MD1mO7+4PHg2MXa347g7vDizMLN4eG+Pv7i5evs/v79yu7S3/DV7/498Yv24eH+4ufQ3Ozu/v7+y13sRqwAAADLSURBVHjaZc/XDsFgGIBhtDrshlitmk2IrbHFqL2pvXf/+78DPokj7+Fz9qpU/9UXJIlhmPaTaQ6QPaz0mm+5gwkgovcV6GZzd5JtCQwgsxoHOvJO15kleRLAnMgHFIESUEPmawB9ngmelTtipwwfASilxOLyiV5UVUyVAfbG0cCPHig+GBkzAENHS0AstVF6bacZIOzgLmxsHbt2OecNgJC83JERmePUYq8ARGkJx6XtFsdddBQgZE2nPR6CICZhawjA4Fb/chv+399kfR+MMMDGOQAAAABJRU5ErkJggg==");\n    background-repeat: no-repeat;\n    background-position: 2px center;\n}\n\n.ace_gutter-cell.ace_warning, .ace_icon.ace_warning, .ace_icon.ace_warning_fold {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAmVBMVEX///8AAAD///8AAAAAAABPSzb/5sAAAAB/blH/73z/ulkAAAAAAAD85pkAAAAAAAACAgP/vGz/rkDerGbGrV7/pkQICAf////e0IsAAAD/oED/qTvhrnUAAAD/yHD/njcAAADuv2r/nz//oTj/p064oGf/zHAAAAA9Nir/tFIAAAD/tlTiuWf/tkIAAACynXEAAAAAAAAtIRW7zBpBAAAAM3RSTlMAABR1m7RXO8Ln31Z36zT+neXe5OzooRDfn+TZ4p3h2hTf4t3k3ucyrN1K5+Xaks52Sfs9CXgrAAAAjklEQVR42o3PbQ+CIBQFYEwboPhSYgoYunIqqLn6/z8uYdH8Vmdnu9vz4WwXgN/xTPRD2+sgOcZjsge/whXZgUaYYvT8QnuJaUrjrHUQreGczuEafQCO/SJTufTbroWsPgsllVhq3wJEk2jUSzX3CUEDJC84707djRc5MTAQxoLgupWRwW6UB5fS++NV8AbOZgnsC7BpEAAAAABJRU5ErkJggg==");\n    background-repeat: no-repeat;\n    background-position: 2px center;\n}\n\n.ace_gutter-cell.ace_info, .ace_icon.ace_info, .ace_gutter-cell.ace_hint, .ace_icon.ace_hint {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAAAAAA6mKC9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAJ0Uk5TAAB2k804AAAAPklEQVQY02NgIB68QuO3tiLznjAwpKTgNyDbMegwisCHZUETUZV0ZqOquBpXj2rtnpSJT1AEnnRmL2OgGgAAIKkRQap2htgAAAAASUVORK5CYII=");\n    background-repeat: no-repeat;\n    background-position: 2px center;\n}\n\n.ace_dark .ace_gutter-cell.ace_info, .ace_dark .ace_icon.ace_info, .ace_dark .ace_gutter-cell.ace_hint, .ace_dark .ace_icon.ace_hint {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJFBMVEUAAAChoaGAgIAqKiq+vr6tra1ZWVmUlJSbm5s8PDxubm56enrdgzg3AAAAAXRSTlMAQObYZgAAAClJREFUeNpjYMAPdsMYHegyJZFQBlsUlMFVCWUYKkAZMxZAGdxlDMQBAG+TBP4B6RyJAAAAAElFTkSuQmCC");\n}\n\n.ace_icon_svg.ace_error {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CjxnIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJyZWQiIHNoYXBlLXJlbmRlcmluZz0iZ2VvbWV0cmljUHJlY2lzaW9uIj4KPGNpcmNsZSBmaWxsPSJub25lIiBjeD0iOCIgY3k9IjgiIHI9IjciIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPGxpbmUgeDE9IjExIiB5MT0iNSIgeDI9IjUiIHkyPSIxMSIvPgo8bGluZSB4MT0iMTEiIHkxPSIxMSIgeDI9IjUiIHkyPSI1Ii8+CjwvZz4KPC9zdmc+");\n    background-color: crimson;\n}\n.ace_icon_svg.ace_security {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8ZyBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZT0iZGFya29yYW5nZSIgZmlsbD0ibm9uZSIgc2hhcGUtcmVuZGVyaW5nPSJnZW9tZXRyaWNQcmVjaXNpb24iPgogICAgICAgIDxwYXRoIGNsYXNzPSJzdHJva2UtbGluZWpvaW4tcm91bmQiIGQ9Ik04IDE0LjgzMDdDOCAxNC44MzA3IDIgMTIuOTA0NyAyIDguMDg5OTJWMy4yNjU0OEM1LjMxIDMuMjY1NDggNy45ODk5OSAxLjM0OTE4IDcuOTg5OTkgMS4zNDkxOEM3Ljk4OTk5IDEuMzQ5MTggMTAuNjkgMy4yNjU0OCAxNCAzLjI2NTQ4VjguMDg5OTJDMTQgMTIuOTA0NyA4IDE0LjgzMDcgOCAxNC44MzA3WiIvPgogICAgICAgIDxwYXRoIGQ9Ik0yIDguMDg5OTJWMy4yNjU0OEM1LjMxIDMuMjY1NDggNy45ODk5OSAxLjM0OTE4IDcuOTg5OTkgMS4zNDkxOCIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMy45OSA4LjA4OTkyVjMuMjY1NDhDMTAuNjggMy4yNjU0OCA4IDEuMzQ5MTggOCAxLjM0OTE4Ii8+CiAgICAgICAgPHBhdGggY2xhc3M9InN0cm9rZS1saW5lam9pbi1yb3VuZCIgZD0iTTggNFY5Ii8+CiAgICAgICAgPHBhdGggY2xhc3M9InN0cm9rZS1saW5lam9pbi1yb3VuZCIgZD0iTTggMTBWMTIiLz4KICAgIDwvZz4KPC9zdmc+");\n    background-color: crimson;\n}\n.ace_icon_svg.ace_warning {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CjxnIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJkYXJrb3JhbmdlIiBzaGFwZS1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiI+Cjxwb2x5Z29uIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGZpbGw9Im5vbmUiIHBvaW50cz0iOCAxIDE1IDE1IDEgMTUgOCAxIi8+CjxyZWN0IHg9IjgiIHk9IjEyIiB3aWR0aD0iMC4wMSIgaGVpZ2h0PSIwLjAxIi8+CjxsaW5lIHgxPSI4IiB5MT0iNiIgeDI9IjgiIHkyPSIxMCIvPgo8L2c+Cjwvc3ZnPg==");\n    background-color: darkorange;\n}\n.ace_icon_svg.ace_info {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CjxnIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJibHVlIiBzaGFwZS1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiI+CjxjaXJjbGUgZmlsbD0ibm9uZSIgY3g9IjgiIGN5PSI4IiByPSI3IiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjxwb2x5bGluZSBwb2ludHM9IjggMTEgOCA4Ii8+Cjxwb2x5bGluZSBwb2ludHM9IjkgOCA2IDgiLz4KPGxpbmUgeDE9IjEwIiB5MT0iMTEiIHgyPSI2IiB5Mj0iMTEiLz4KPHJlY3QgeD0iOCIgeT0iNSIgd2lkdGg9IjAuMDEiIGhlaWdodD0iMC4wMSIvPgo8L2c+Cjwvc3ZnPg==");\n    background-color: royalblue;\n}\n.ace_icon_svg.ace_hint {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8ZyBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZT0ic2lsdmVyIiBmaWxsPSJub25lIiBzaGFwZS1yZW5kZXJpbmc9Imdlb21ldHJpY1ByZWNpc2lvbiI+CiAgICAgICAgPHBhdGggY2xhc3M9InN0cm9rZS1saW5lam9pbi1yb3VuZCIgZD0iTTYgMTRIMTAiLz4KICAgICAgICA8cGF0aCBkPSJNOCAxMUg5QzkgOS40NzAwMiAxMiA4LjU0MDAyIDEyIDUuNzYwMDJDMTIuMDIgNC40MDAwMiAxMS4zOSAzLjM2MDAyIDEwLjQzIDIuNjcwMDJDOSAxLjY0MDAyIDcuMDAwMDEgMS42NDAwMiA1LjU3MDAxIDIuNjcwMDJDNC42MTAwMSAzLjM2MDAyIDMuOTggNC40MDAwMiA0IDUuNzYwMDJDNCA4LjU0MDAyIDcuMDAwMDEgOS40NzAwMiA3LjAwMDAxIDExSDhaIi8+CiAgICA8L2c+Cjwvc3ZnPg==");\n    background-color: silver;\n}\n\n.ace_icon_svg.ace_error_fold {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiIgZmlsbD0ibm9uZSI+CiAgPHBhdGggZD0ibSAxOC45Mjk4NTEsNy44Mjk4MDc2IGMgMC4xNDYzNTMsNi4zMzc0NjA0IC02LjMyMzE0Nyw3Ljc3Nzg0NDQgLTcuNDc3OTEyLDcuNzc3ODQ0NCAtMi4xMDcyNzI2LC0wLjEyODc1IDUuMTE3Njc4LDAuMzU2MjQ5IDUuMDUxNjk4LC03Ljg3MDA2MTggLTAuNjA0NjcyLC04LjAwMzk3MzQ5IC03LjA3NzI3MDYsLTcuNTYzMTE4OSAtNC44NTczLC03LjQzMDM5NTU2IDEuNjA2LC0wLjExNTE0MjI1IDYuODk3NDg1LDEuMjYyNTQ1OTYgNy4yODM1MTQsNy41MjI2MTI5NiB6IiBmaWxsPSJjcmltc29uIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0ibSA4LjExNDc1NjIsMi4wNTI5ODI4IGMgMy4zNDkxNjk4LDAgNi4wNjQxMzI4LDIuNjc2ODYyNyA2LjA2NDEzMjgsNS45Nzg5NTMgMCwzLjMwMjExMjIgLTIuNzE0OTYzLDUuOTc4OTIwMiAtNi4wNjQxMzI4LDUuOTc4OTIwMiAtMy4zNDkxNDczLDAgLTYuMDY0MTc3MiwtMi42NzY4MDggLTYuMDY0MTc3MiwtNS45Nzg5MjAyIDAuMDA1MzksLTMuMjk5ODg2MSAyLjcxNzI2NTYsLTUuOTczNjQwOCA2LjA2NDE3NzIsLTUuOTc4OTUzIHogbSAwLC0xLjczNTgyNzE5IGMgLTQuMzIxNDgzNiwwIC03LjgyNDc0MDM4LDMuNDU0MDE4NDkgLTcuODI0NzQwMzgsNy43MTQ3ODAxOSAwLDQuMjYwNzI4MiAzLjUwMzI1Njc4LDcuNzE0NzQ1MiA3LjgyNDc0MDM4LDcuNzE0NzQ1MiA0LjMyMTQ0OTgsMCA3LjgyNDY5OTgsLTMuNDU0MDE3IDcuODI0Njk5OCwtNy43MTQ3NDUyIDAsLTIuMDQ2MDkxNCAtMC44MjQzOTIsLTQuMDA4MzY3MiAtMi4yOTE3NTYsLTUuNDU1MTc0NiBDIDEyLjE4MDIyNSwxLjEyOTk2NDggMTAuMTkwMDEzLDAuMzE3MTU1NjEgOC4xMTQ3NTYyLDAuMzE3MTU1NjEgWiBNIDYuOTM3NDU2Myw4LjI0MDU5ODUgNC42NzE4Njg1LDEwLjQ4NTg1MiA2LjAwODY4MTQsMTEuODc2NzI4IDguMzE3MDAzNSw5LjYwMDc5MTEgMTAuNjI1MzM3LDExLjg3NjcyOCAxMS45NjIxMzgsMTAuNDg1ODUyIDkuNjk2NTUwOCw4LjI0MDU5ODUgMTEuOTYyMTM4LDYuMDA2ODA2NiAxMC41NzMyNDYsNC42Mzc0MzM1IDguMzE3MDAzNSw2Ljg3MzQyOTcgNi4wNjA3NjA3LDQuNjM3NDMzNSA0LjY3MTg2ODUsNi4wMDY4MDY2IFoiIGZpbGw9ImNyaW1zb24iIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4=");\n    background-color: crimson;\n}\n.ace_icon_svg.ace_security_fold {\n    -webkit-mask-image: url("data:image/svg+xml;base64,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");\n    background-color: crimson;\n}\n.ace_icon_svg.ace_warning_fold {\n    -webkit-mask-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC43NzY5IDE0LjczMzdMOC42NTE5MiAyLjQ4MzY5QzguMzI5NDYgMS44Mzg3NyA3LjQwOTEzIDEuODM4NzcgNy4wODY2NyAyLjQ4MzY5TDAuOTYxNjY5IDE0LjczMzdDMC42NzA3NzUgMTUuMzE1NSAxLjA5MzgzIDE2IDEuNzQ0MjkgMTZIMTMuOTk0M0MxNC42NDQ4IDE2IDE1LjA2NzggMTUuMzE1NSAxNC43NzY5IDE0LjczMzdaTTMuMTYwMDcgMTQuMjVMNy44NjkyOSA0LjgzMTU2TDEyLjU3ODUgMTQuMjVIMy4xNjAwN1pNOC43NDQyOSAxMS42MjVWMTMuMzc1SDYuOTk0MjlWMTEuNjI1SDguNzQ0MjlaTTYuOTk0MjkgMTAuNzVWNy4yNUg4Ljc0NDI5VjEwLjc1SDYuOTk0MjlaIiBmaWxsPSIjRUM3MjExIi8+CjxwYXRoIGQ9Ik0xMS4xOTkxIDIuOTUyMzhDMTAuODgwOSAyLjMxNDY3IDEwLjM1MzcgMS44MDUyNiA5LjcwNTUgMS41MDlMMTEuMDQxIDEuMDY5NzhDMTEuNjg4MyAwLjk0OTgxNCAxMi4zMzcgMS4yNzI2MyAxMi42MzE3IDEuODYxNDFMMTcuNjEzNiAxMS44MTYxQzE4LjM1MjcgMTMuMjkyOSAxNy41OTM4IDE1LjA4MDQgMTYuMDE4IDE1LjU3NDVDMTYuNDA0NCAxNC40NTA3IDE2LjMyMzEgMTMuMjE4OCAxNS43OTI0IDEyLjE1NTVMMTEuMTk5MSAyLjk1MjM4WiIgZmlsbD0iI0VDNzIxMSIvPgo8L3N2Zz4=");\n    background-color: darkorange;\n}\n\n.ace_scrollbar {\n    contain: strict;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    z-index: 6;\n}\n\n.ace_scrollbar-inner {\n    position: absolute;\n    cursor: text;\n    left: 0;\n    top: 0;\n}\n\n.ace_scrollbar-v{\n    overflow-x: hidden;\n    overflow-y: scroll;\n    top: 0;\n}\n\n.ace_scrollbar-h {\n    overflow-x: scroll;\n    overflow-y: hidden;\n    left: 0;\n}\n\n.ace_print-margin {\n    position: absolute;\n    height: 100%;\n}\n\n.ace_text-input {\n    position: absolute;\n    z-index: 0;\n    width: 0.5em;\n    height: 1em;\n    opacity: 0;\n    background: transparent;\n    -moz-appearance: none;\n    appearance: none;\n    border: none;\n    resize: none;\n    outline: none;\n    overflow: hidden;\n    font: inherit;\n    padding: 0 1px;\n    margin: 0 -1px;\n    contain: strict;\n    -ms-user-select: text;\n    -moz-user-select: text;\n    -webkit-user-select: text;\n    user-select: text;\n    /*with `pre-line` chrome inserts &nbsp; instead of space*/\n    white-space: pre!important;\n}\n.ace_text-input.ace_composition {\n    background: transparent;\n    color: inherit;\n    z-index: 1000;\n    opacity: 1;\n}\n.ace_composition_placeholder { color: transparent }\n.ace_composition_marker { \n    border-bottom: 1px solid;\n    position: absolute;\n    border-radius: 0;\n    margin-top: 1px;\n}\n\n[ace_nocontext=true] {\n    transform: none!important;\n    filter: none!important;\n    clip-path: none!important;\n    mask : none!important;\n    contain: none!important;\n    perspective: none!important;\n    mix-blend-mode: initial!important;\n    z-index: auto;\n}\n\n.ace_layer {\n    z-index: 1;\n    position: absolute;\n    overflow: hidden;\n    /* workaround for chrome bug https://github.com/ajaxorg/ace/issues/2312*/\n    word-wrap: normal;\n    white-space: pre;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    /* setting pointer-events: auto; on node under the mouse, which changes\n        during scroll, will break mouse wheel scrolling in Safari */\n    pointer-events: none;\n}\n\n.ace_gutter-layer {\n    position: relative;\n    width: auto;\n    text-align: right;\n    pointer-events: auto;\n    height: 1000000px;\n    contain: style size layout;\n}\n\n.ace_text-layer {\n    font: inherit !important;\n    position: absolute;\n    height: 1000000px;\n    width: 1000000px;\n    contain: style size layout;\n}\n\n.ace_text-layer > .ace_line, .ace_text-layer > .ace_line_group {\n    contain: style size layout;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n}\n\n.ace_hidpi .ace_text-layer,\n.ace_hidpi .ace_gutter-layer,\n.ace_hidpi .ace_content,\n.ace_hidpi .ace_gutter {\n    contain: strict;\n}\n.ace_hidpi .ace_text-layer > .ace_line, \n.ace_hidpi .ace_text-layer > .ace_line_group {\n    contain: strict;\n}\n\n.ace_cjk {\n    display: inline-block;\n    text-align: center;\n}\n\n.ace_cursor-layer {\n    z-index: 4;\n}\n\n.ace_cursor {\n    z-index: 4;\n    position: absolute;\n    box-sizing: border-box;\n    border-left: 2px solid;\n    /* workaround for smooth cursor repaintng whole screen in chrome */\n    transform: translatez(0);\n}\n\n.ace_multiselect .ace_cursor {\n    border-left-width: 1px;\n}\n\n.ace_slim-cursors .ace_cursor {\n    border-left-width: 1px;\n}\n\n.ace_overwrite-cursors .ace_cursor {\n    border-left-width: 0;\n    border-bottom: 1px solid;\n}\n\n.ace_hidden-cursors .ace_cursor {\n    opacity: 0.2;\n}\n\n.ace_hasPlaceholder .ace_hidden-cursors .ace_cursor {\n    opacity: 0;\n}\n\n.ace_smooth-blinking .ace_cursor {\n    transition: opacity 0.18s;\n}\n\n.ace_animate-blinking .ace_cursor {\n    animation-duration: 1000ms;\n    animation-timing-function: step-end;\n    animation-name: blink-ace-animate;\n    animation-iteration-count: infinite;\n}\n\n.ace_animate-blinking.ace_smooth-blinking .ace_cursor {\n    animation-duration: 1000ms;\n    animation-timing-function: ease-in-out;\n    animation-name: blink-ace-animate-smooth;\n}\n    \n@keyframes blink-ace-animate {\n    from, to { opacity: 1; }\n    60% { opacity: 0; }\n}\n\n@keyframes blink-ace-animate-smooth {\n    from, to { opacity: 1; }\n    45% { opacity: 1; }\n    60% { opacity: 0; }\n    85% { opacity: 0; }\n}\n\n.ace_marker-layer .ace_step, .ace_marker-layer .ace_stack {\n    position: absolute;\n    z-index: 3;\n}\n\n.ace_marker-layer .ace_selection {\n    position: absolute;\n    z-index: 5;\n}\n\n.ace_marker-layer .ace_bracket {\n    position: absolute;\n    z-index: 6;\n}\n\n.ace_marker-layer .ace_error_bracket {\n    position: absolute;\n    border-bottom: 1px solid #DE5555;\n    border-radius: 0;\n}\n\n.ace_marker-layer .ace_active-line {\n    position: absolute;\n    z-index: 2;\n}\n\n.ace_marker-layer .ace_selected-word {\n    position: absolute;\n    z-index: 4;\n    box-sizing: border-box;\n}\n\n.ace_line .ace_fold {\n    box-sizing: border-box;\n\n    display: inline-block;\n    height: 11px;\n    margin-top: -2px;\n    vertical-align: middle;\n\n    background-image:\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII="),\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACJJREFUeNpi+P//fxgTAwPDBxDxD078RSX+YeEyDFMCIMAAI3INmXiwf2YAAAAASUVORK5CYII=");\n    background-repeat: no-repeat, repeat-x;\n    background-position: center center, top left;\n    color: transparent;\n\n    border: 1px solid black;\n    border-radius: 2px;\n\n    cursor: pointer;\n    pointer-events: auto;\n}\n\n.ace_dark .ace_fold {\n}\n\n.ace_fold:hover{\n    background-image:\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII="),\n        url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACBJREFUeNpi+P//fz4TAwPDZxDxD5X4i5fLMEwJgAADAEPVDbjNw87ZAAAAAElFTkSuQmCC");\n}\n\n.ace_tooltip {\n    background-color: #f5f5f5;\n    border: 1px solid gray;\n    border-radius: 1px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n    color: black;\n    padding: 3px 4px;\n    position: fixed;\n    z-index: 999999;\n    box-sizing: border-box;\n    cursor: default;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n    line-height: normal;\n    font-style: normal;\n    font-weight: normal;\n    letter-spacing: normal;\n    pointer-events: none;\n    overflow: auto;\n    max-width: min(33em, 66vw);\n    overscroll-behavior: contain;\n}\n.ace_tooltip pre {\n    white-space: pre-wrap;\n}\n\n.ace_tooltip.ace_dark {\n    background-color: #636363;\n    color: #fff;\n}\n\n.ace_tooltip:focus {\n    outline: 1px solid #5E9ED6;\n}\n\n.ace_icon {\n    display: inline-block;\n    width: 18px;\n    vertical-align: top;\n}\n\n.ace_icon_svg {\n    display: inline-block;\n    width: 12px;\n    vertical-align: top;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-size: 12px;\n    -webkit-mask-position: center;\n}\n\n.ace_folding-enabled > .ace_gutter-cell, .ace_folding-enabled > .ace_gutter-cell_svg-icons {\n    padding-right: 13px;\n}\n\n.ace_fold-widget, .ace_custom-widget {\n    box-sizing: border-box;\n\n    margin: 0 -12px 0 1px;\n    display: none;\n    width: 11px;\n    vertical-align: top;\n\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42mWKsQ0AMAzC8ixLlrzQjzmBiEjp0A6WwBCSPgKAXoLkqSot7nN3yMwR7pZ32NzpKkVoDBUxKAAAAABJRU5ErkJggg==");\n    background-repeat: no-repeat;\n    background-position: center;\n\n    border-radius: 3px;\n    \n    border: 1px solid transparent;\n    cursor: pointer;\n    pointer-events: auto;\n}\n\n.ace_custom-widget {\n    background: none;\n}\n\n.ace_folding-enabled .ace_fold-widget {\n    display: inline-block;   \n}\n\n.ace_fold-widget.ace_end {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42m3HwQkAMAhD0YzsRchFKI7sAikeWkrxwScEB0nh5e7KTPWimZki4tYfVbX+MNl4pyZXejUO1QAAAABJRU5ErkJggg==");\n}\n\n.ace_fold-widget.ace_closed {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAGCAYAAAAG5SQMAAAAOUlEQVR42jXKwQkAMAgDwKwqKD4EwQ26sSOkVWjgIIHAzPiCgaqiqnJHZnKICBERHN194O5b9vbLuAVRL+l0YWnZAAAAAElFTkSuQmCCXA==");\n}\n\n.ace_fold-widget:hover {\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background-color: rgba(255, 255, 255, 0.2);\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.7);\n}\n\n.ace_fold-widget:active {\n    border: 1px solid rgba(0, 0, 0, 0.4);\n    background-color: rgba(0, 0, 0, 0.05);\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.8);\n}\n/**\n * Dark version for fold widgets\n */\n.ace_dark .ace_fold-widget {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHklEQVQIW2P4//8/AzoGEQ7oGCaLLAhWiSwB146BAQCSTPYocqT0AAAAAElFTkSuQmCC");\n}\n.ace_dark .ace_fold-widget.ace_end {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAH0lEQVQIW2P4//8/AxQ7wNjIAjDMgC4AxjCVKBirIAAF0kz2rlhxpAAAAABJRU5ErkJggg==");\n}\n.ace_dark .ace_fold-widget.ace_closed {\n    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAFCAYAAACAcVaiAAAAHElEQVQIW2P4//+/AxAzgDADlOOAznHAKgPWAwARji8UIDTfQQAAAABJRU5ErkJggg==");\n}\n.ace_dark .ace_fold-widget:hover {\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\n    background-color: rgba(255, 255, 255, 0.1);\n}\n.ace_dark .ace_fold-widget:active {\n    box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);\n}\n\n.ace_inline_button {\n    border: 1px solid lightgray;\n    display: inline-block;\n    margin: -1px 8px;\n    padding: 0 5px;\n    pointer-events: auto;\n    cursor: pointer;\n}\n.ace_inline_button:hover {\n    border-color: gray;\n    background: rgba(200,200,200,0.2);\n    display: inline-block;\n    pointer-events: auto;\n}\n\n.ace_fold-widget.ace_invalid {\n    background-color: #FFB4B4;\n    border-color: #DE5555;\n}\n\n.ace_fade-fold-widgets .ace_fold-widget {\n    transition: opacity 0.4s ease 0.05s;\n    opacity: 0;\n}\n\n.ace_fade-fold-widgets:hover .ace_fold-widget {\n    transition: opacity 0.05s ease 0.05s;\n    opacity:1;\n}\n\n.ace_underline {\n    text-decoration: underline;\n}\n\n.ace_bold {\n    font-weight: bold;\n}\n\n.ace_nobold .ace_bold {\n    font-weight: normal;\n}\n\n.ace_italic {\n    font-style: italic;\n}\n\n\n.ace_error-marker {\n    background-color: rgba(255, 0, 0,0.2);\n    position: absolute;\n    z-index: 9;\n}\n\n.ace_highlight-marker {\n    background-color: rgba(255, 255, 0,0.2);\n    position: absolute;\n    z-index: 8;\n}\n\n.ace_mobile-menu {\n    position: absolute;\n    line-height: 1.5;\n    border-radius: 4px;\n    -ms-user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    background: white;\n    box-shadow: 1px 3px 2px grey;\n    border: 1px solid #dcdcdc;\n    color: black;\n}\n.ace_dark > .ace_mobile-menu {\n    background: #333;\n    color: #ccc;\n    box-shadow: 1px 3px 2px grey;\n    border: 1px solid #444;\n\n}\n.ace_mobile-button {\n    padding: 2px;\n    cursor: pointer;\n    overflow: hidden;\n}\n.ace_mobile-button:hover {\n    background-color: #eee;\n    opacity:1;\n}\n.ace_mobile-button:active {\n    background-color: #ddd;\n}\n\n.ace_placeholder {\n    position: relative;\n    font-family: arial;\n    transform: scale(0.9);\n    transform-origin: left;\n    white-space: pre;\n    opacity: 0.7;\n    margin: 0 10px;\n    z-index: 1;\n}\n\n.ace_ghost_text {\n    opacity: 0.5;\n    font-style: italic;\n}\n\n.ace_ghost_text_container > div {\n    white-space: pre;\n}\n\n.ghost_text_line_wrapped::after {\n    content: "\u21a9";\n    position: absolute;\n}\n\n.ace_lineWidgetContainer.ace_ghost_text {\n    margin: 0px 4px\n}\n\n.ace_screenreader-only {\n    position:absolute;\n    left:-10000px;\n    top:auto;\n    width:1px;\n    height:1px;\n    overflow:hidden;\n}\n\n.ace_hidden_token {\n    display: none;\n}'}),define("ace/layer/decorators",["require","exports","module","ace/lib/dom","ace/lib/oop","ace/lib/event_emitter"],function(e,t,n){"use strict";var r=e("../lib/dom"),i=e("../lib/oop"),s=e("../lib/event_emitter").EventEmitter,o=function(){function e(e,t){this.renderer=t,this.pixelRatio=1,this.maxHeight=t.layerConfig.maxHeight,this.lineHeight=t.layerConfig.lineHeight,this.minDecorationHeight=2*this.pixelRatio|0,this.halfMinDecorationHeight=this.minDecorationHeight/2|0,this.colors={},this.colors.dark={error:"rgba(255, 18, 18, 1)",warning:"rgba(18, 136, 18, 1)",info:"rgba(18, 18, 136, 1)"},this.colors.light={error:"rgb(255,51,51)",warning:"rgb(32,133,72)",info:"rgb(35,68,138)"},this.setScrollBarV(e)}return e.prototype.$createCanvas=function(){this.canvas=r.createElement("canvas"),this.canvas.style.top="0px",this.canvas.style.right="0px",this.canvas.style.zIndex="7",this.canvas.style.position="absolute"},e.prototype.setScrollBarV=function(e){this.$createCanvas(),this.scrollbarV=e,e.element.appendChild(this.canvas),this.setDimensions()},e.prototype.$updateDecorators=function(e){function r(e,t){return e.priority<t.priority?-1:e.priority>t.priority?1:0}if(typeof this.canvas.getContext!="function")return;var t=this.renderer.theme.isDark===!0?this.colors.dark:this.colors.light;this.setDimensions(e);var n=this.canvas.getContext("2d"),i=this.renderer.session.$annotations;n.clearRect(0,0,this.canvas.width,this.canvas.height);if(i){var s={info:1,warning:2,error:3};i.forEach(function(e){e.priority=s[e.type]||null}),i=i.sort(r);for(var o=0;o<i.length;o++){var u=i[o].row,a=this.getVerticalOffsetForRow(u),f=a+this.lineHeight,l=Math.round(this.heightRatio*a),c=Math.round(this.heightRatio*f),h=Math.round((l+c)/2),p=c-h;p<this.halfMinDecorationHeight&&(p=this.halfMinDecorationHeight),h-p<0&&(h=p),h+p>this.canvasHeight&&(h=this.canvasHeight-p);var d=h-p,v=h+p,m=v-d;n.fillStyle=t[i[o].type]||null,n.fillRect(0,d,Math.round(this.oneZoneWidth-1),m)}}var g=this.renderer.session.selection.getCursor();if(g){var y=Math.round(this.getVerticalOffsetForRow(g.row)*this.heightRatio);n.fillStyle="rgba(0, 0, 0, 0.5)",n.fillRect(0,y,this.canvasWidth,2)}},e.prototype.getVerticalOffsetForRow=function(e){e|=0;var t=this.renderer.session.documentToScreenRow(e,0)*this.lineHeight;return t},e.prototype.setDimensions=function(e){e=e||this.renderer.layerConfig,this.maxHeight=e.maxHeight,this.lineHeight=e.lineHeight,this.canvasHeight=e.height,this.canvasWidth=this.scrollbarV.width||this.canvasWidth,this.setZoneWidth(),this.canvas.width=this.canvasWidth,this.canvas.height=this.canvasHeight,this.maxHeight<this.canvasHeight?this.heightRatio=1:this.heightRatio=this.canvasHeight/this.maxHeight},e.prototype.setZoneWidth=function(){this.oneZoneWidth=this.canvasWidth},e.prototype.destroy=function(){this.canvas.parentNode.removeChild(this.canvas)},e}();i.implement(o.prototype,s),t.Decorator=o}),define("ace/virtual_renderer",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/config","ace/layer/gutter","ace/layer/marker","ace/layer/text","ace/layer/cursor","ace/scrollbar","ace/scrollbar","ace/scrollbar_custom","ace/scrollbar_custom","ace/renderloop","ace/layer/font_metrics","ace/lib/event_emitter","ace/css/editor-css","ace/layer/decorators","ace/lib/useragent","ace/layer/text_util"],function(e,t,n){"use strict";var r=e("./lib/oop"),i=e("./lib/dom"),s=e("./lib/lang"),o=e("./config"),u=e("./layer/gutter").Gutter,a=e("./layer/marker").Marker,f=e("./layer/text").Text,l=e("./layer/cursor").Cursor,c=e("./scrollbar").HScrollBar,h=e("./scrollbar").VScrollBar,p=e("./scrollbar_custom").HScrollBar,d=e("./scrollbar_custom").VScrollBar,v=e("./renderloop").RenderLoop,m=e("./layer/font_metrics").FontMetrics,g=e("./lib/event_emitter").EventEmitter,y=e("./css/editor-css"),b=e("./layer/decorators").Decorator,w=e("./lib/useragent"),E=e("./layer/text_util").isTextToken;i.importCssString(y,"ace_editor.css",!1);var S=function(){function e(e,t){var n=this;this.container=e||i.createElement("div"),i.addCssClass(this.container,"ace_editor"),i.HI_DPI&&i.addCssClass(this.container,"ace_hidpi"),this.setTheme(t),o.get("useStrictCSP")==null&&o.set("useStrictCSP",!1),this.$gutter=i.createElement("div"),this.$gutter.className="ace_gutter",this.container.appendChild(this.$gutter),this.$gutter.setAttribute("aria-hidden","true"),this.scroller=i.createElement("div"),this.scroller.className="ace_scroller",this.container.appendChild(this.scroller),this.content=i.createElement("div"),this.content.className="ace_content",this.scroller.appendChild(this.content),this.$gutterLayer=new u(this.$gutter),this.$gutterLayer.on("changeGutterWidth",this.onGutterResize.bind(this)),this.$markerBack=new a(this.content);var r=this.$textLayer=new f(this.content);this.canvas=r.element,this.$markerFront=new a(this.content),this.$cursorLayer=new l(this.content),this.$horizScroll=!1,this.$vScroll=!1,this.scrollBar=this.scrollBarV=new h(this.container,this),this.scrollBarH=new c(this.container,this),this.scrollBarV.on("scroll",function(e){n.$scrollAnimation||n.session.setScrollTop(e.data-n.scrollMargin.top)}),this.scrollBarH.on("scroll",function(e){n.$scrollAnimation||n.session.setScrollLeft(e.data-n.scrollMargin.left)}),this.scrollTop=0,this.scrollLeft=0,this.cursorPos={row:0,column:0},this.$fontMetrics=new m(this.container),this.$textLayer.$setFontMetrics(this.$fontMetrics),this.$textLayer.on("changeCharacterSize",function(e){n.updateCharacterSize(),n.onResize(!0,n.gutterWidth,n.$size.width,n.$size.height),n._signal("changeCharacterSize",e)}),this.$size={width:0,height:0,scrollerHeight:0,scrollerWidth:0,$dirty:!0},this.layerConfig={width:1,padding:0,firstRow:0,firstRowScreen:0,lastRow:0,lineHeight:0,characterWidth:0,minHeight:1,maxHeight:1,offset:0,height:1,gutterOffset:1},this.scrollMargin={left:0,right:0,top:0,bottom:0,v:0,h:0},this.margin={left:0,right:0,top:0,bottom:0,v:0,h:0},this.$keepTextAreaAtCursor=!w.isIOS,this.$loop=new v(this.$renderChanges.bind(this),this.container.ownerDocument.defaultView),this.$loop.schedule(this.CHANGE_FULL),this.updateCharacterSize(),this.setPadding(4),this.$addResizeObserver(),o.resetOptions(this),o._signal("renderer",this)}return e.prototype.updateCharacterSize=function(){this.$textLayer.allowBoldFonts!=this.$allowBoldFonts&&(this.$allowBoldFonts=this.$textLayer.allowBoldFonts,this.setStyle("ace_nobold",!this.$allowBoldFonts)),this.layerConfig.characterWidth=this.characterWidth=this.$textLayer.getCharacterWidth(),this.layerConfig.lineHeight=this.lineHeight=this.$textLayer.getLineHeight(),this.$updatePrintMargin(),i.setStyle(this.scroller.style,"line-height",this.lineHeight+"px")},e.prototype.setSession=function(e){this.session&&this.session.doc.off("changeNewLineMode",this.onChangeNewLineMode),this.session=e,e&&this.scrollMargin.top&&e.getScrollTop()<=0&&e.setScrollTop(-this.scrollMargin.top),this.$cursorLayer.setSession(e),this.$markerBack.setSession(e),this.$markerFront.setSession(e),this.$gutterLayer.setSession(e),this.$textLayer.setSession(e);if(!e)return;this.$loop.schedule(this.CHANGE_FULL),this.session.$setFontMetrics(this.$fontMetrics),this.scrollBarH.scrollLeft=this.scrollBarV.scrollTop=null,this.onChangeNewLineMode=this.onChangeNewLineMode.bind(this),this.onChangeNewLineMode(),this.session.doc.on("changeNewLineMode",this.onChangeNewLineMode)},e.prototype.updateLines=function(e,t,n){t===undefined&&(t=Infinity),this.$changedLines?(this.$changedLines.firstRow>e&&(this.$changedLines.firstRow=e),this.$changedLines.lastRow<t&&(this.$changedLines.lastRow=t)):this.$changedLines={firstRow:e,lastRow:t};if(this.$changedLines.lastRow<this.layerConfig.firstRow){if(!n)return;this.$changedLines.lastRow=this.layerConfig.lastRow}if(this.$changedLines.firstRow>this.layerConfig.lastRow)return;this.$loop.schedule(this.CHANGE_LINES)},e.prototype.onChangeNewLineMode=function(){this.$loop.schedule(this.CHANGE_TEXT),this.$textLayer.$updateEolChar(),this.session.$bidiHandler.setEolChar(this.$textLayer.EOL_CHAR)},e.prototype.onChangeTabSize=function(){this.$loop.schedule(this.CHANGE_TEXT|this.CHANGE_MARKER),this.$textLayer.onChangeTabSize()},e.prototype.updateText=function(){this.$loop.schedule(this.CHANGE_TEXT)},e.prototype.updateFull=function(e){e?this.$renderChanges(this.CHANGE_FULL,!0):this.$loop.schedule(this.CHANGE_FULL)},e.prototype.updateFontSize=function(){this.$textLayer.checkForSizeChanges()},e.prototype.$updateSizeAsync=function(){this.$loop.pending?this.$size.$dirty=!0:this.onResize()},e.prototype.onResize=function(e,t,n,r){if(this.resizing>2)return;this.resizing>0?this.resizing++:this.resizing=e?1:0;var i=this.container;r||(r=i.clientHeight||i.scrollHeight),!r&&this.$maxLines&&this.lineHeight>1&&(!i.style.height||i.style.height=="0px")&&(i.style.height="1px",r=i.clientHeight||i.scrollHeight),n||(n=i.clientWidth||i.scrollWidth);var s=this.$updateCachedSize(e,t,n,r);this.$resizeTimer&&this.$resizeTimer.cancel();if(!this.$size.scrollerHeight||!n&&!r)return this.resizing=0;e&&(this.$gutterLayer.$padding=null),e?this.$renderChanges(s|this.$changes,!0):this.$loop.schedule(s|this.$changes),this.resizing&&(this.resizing=0),this.scrollBarH.scrollLeft=this.scrollBarV.scrollTop=null,this.$customScrollbar&&this.$updateCustomScrollbar(!0)},e.prototype.$updateCachedSize=function(e,t,n,r){r-=this.$extraHeight||0;var s=0,o=this.$size,u={width:o.width,height:o.height,scrollerHeight:o.scrollerHeight,scrollerWidth:o.scrollerWidth};r&&(e||o.height!=r)&&(o.height=r,s|=this.CHANGE_SIZE,o.scrollerHeight=o.height,this.$horizScroll&&(o.scrollerHeight-=this.scrollBarH.getHeight()),this.scrollBarV.setHeight(o.scrollerHeight),this.scrollBarV.element.style.bottom=this.scrollBarH.getHeight()+"px",s|=this.CHANGE_SCROLL);if(n&&(e||o.width!=n)){s|=this.CHANGE_SIZE,o.width=n,t==null&&(t=this.$showGutter?this.$gutter.offsetWidth:0),this.gutterWidth=t,i.setStyle(this.scrollBarH.element.style,"left",t+"px"),i.setStyle(this.scroller.style,"left",t+this.margin.left+"px"),o.scrollerWidth=Math.max(0,n-t-this.scrollBarV.getWidth()-this.margin.h),i.setStyle(this.$gutter.style,"left",this.margin.left+"px");var a=this.scrollBarV.getWidth()+"px";i.setStyle(this.scrollBarH.element.style,"right",a),i.setStyle(this.scroller.style,"right",a),i.setStyle(this.scroller.style,"bottom",this.scrollBarH.getHeight()),this.scrollBarH.setWidth(o.scrollerWidth);if(this.session&&this.session.getUseWrapMode()&&this.adjustWrapLimit()||e)s|=this.CHANGE_FULL}return o.$dirty=!n||!r,s&&this._signal("resize",u),s},e.prototype.onGutterResize=function(e){var t=this.$showGutter?e:0;t!=this.gutterWidth&&(this.$changes|=this.$updateCachedSize(!0,t,this.$size.width,this.$size.height)),this.session.getUseWrapMode()&&this.adjustWrapLimit()?this.$loop.schedule(this.CHANGE_FULL):this.$size.$dirty?this.$loop.schedule(this.CHANGE_FULL):this.$computeLayerConfig()},e.prototype.adjustWrapLimit=function(){var e=this.$size.scrollerWidth-this.$padding*2,t=Math.floor(e/this.characterWidth);return this.session.adjustWrapLimit(t,this.$showPrintMargin&&this.$printMarginColumn)},e.prototype.setAnimatedScroll=function(e){this.setOption("animatedScroll",e)},e.prototype.getAnimatedScroll=function(){return this.$animatedScroll},e.prototype.setShowInvisibles=function(e){this.setOption("showInvisibles",e),this.session.$bidiHandler.setShowInvisibles(e)},e.prototype.getShowInvisibles=function(){return this.getOption("showInvisibles")},e.prototype.getDisplayIndentGuides=function(){return this.getOption("displayIndentGuides")},e.prototype.setDisplayIndentGuides=function(e){this.setOption("displayIndentGuides",e)},e.prototype.getHighlightIndentGuides=function(){return this.getOption("highlightIndentGuides")},e.prototype.setHighlightIndentGuides=function(e){this.setOption("highlightIndentGuides",e)},e.prototype.setShowPrintMargin=function(e){this.setOption("showPrintMargin",e)},e.prototype.getShowPrintMargin=function(){return this.getOption("showPrintMargin")},e.prototype.setPrintMarginColumn=function(e){this.setOption("printMarginColumn",e)},e.prototype.getPrintMarginColumn=function(){return this.getOption("printMarginColumn")},e.prototype.getShowGutter=function(){return this.getOption("showGutter")},e.prototype.setShowGutter=function(e){return this.setOption("showGutter",e)},e.prototype.getFadeFoldWidgets=function(){return this.getOption("fadeFoldWidgets")},e.prototype.setFadeFoldWidgets=function(e){this.setOption("fadeFoldWidgets",e)},e.prototype.setHighlightGutterLine=function(e){this.setOption("highlightGutterLine",e)},e.prototype.getHighlightGutterLine=function(){return this.getOption("highlightGutterLine")},e.prototype.$updatePrintMargin=function(){if(!this.$showPrintMargin&&!this.$printMarginEl)return;if(!this.$printMarginEl){var e=i.createElement("div");e.className="ace_layer ace_print-margin-layer",this.$printMarginEl=i.createElement("div"),this.$printMarginEl.className="ace_print-margin",e.appendChild(this.$printMarginEl),this.content.insertBefore(e,this.content.firstChild)}var t=this.$printMarginEl.style;t.left=Math.round(this.characterWidth*this.$printMarginColumn+this.$padding)+"px",t.visibility=this.$showPrintMargin?"visible":"hidden",this.session&&this.session.$wrap==-1&&this.adjustWrapLimit()},e.prototype.getContainerElement=function(){return this.container},e.prototype.getMouseEventTarget=function(){return this.scroller},e.prototype.getTextAreaContainer=function(){return this.container},e.prototype.$moveTextAreaToCursor=function(){if(this.$isMousePressed)return;var e=this.textarea.style,t=this.$composition;if(!this.$keepTextAreaAtCursor&&!t){i.translate(this.textarea,-100,0);return}var n=this.$cursorLayer.$pixelPos;if(!n)return;t&&t.markerRange&&(n=this.$cursorLayer.getPixelPosition(t.markerRange.start,!0));var r=this.layerConfig,s=n.top,o=n.left;s-=r.offset;var u=t&&t.useTextareaForIME||w.isMobile?this.lineHeight:1;if(s<0||s>r.height-u){i.translate(this.textarea,0,0);return}var a=1,f=this.$size.height-u;if(!t)s+=this.lineHeight;else if(t.useTextareaForIME){var l=this.textarea.value;a=this.characterWidth*this.session.$getStringScreenWidth(l)[0]}else s+=this.lineHeight+2;o-=this.scrollLeft,o>this.$size.scrollerWidth-a&&(o=this.$size.scrollerWidth-a),o+=this.gutterWidth+this.margin.left,i.setStyle(e,"height",u+"px"),i.setStyle(e,"width",a+"px"),i.translate(this.textarea,Math.min(o,this.$size.scrollerWidth-a),Math.min(s,f))},e.prototype.getFirstVisibleRow=function(){return this.layerConfig.firstRow},e.prototype.getFirstFullyVisibleRow=function(){return this.layerConfig.firstRow+(this.layerConfig.offset===0?0:1)},e.prototype.getLastFullyVisibleRow=function(){var e=this.layerConfig,t=e.lastRow,n=this.session.documentToScreenRow(t,0)*e.lineHeight;return n-this.session.getScrollTop()>e.height-e.lineHeight?t-1:t},e.prototype.getLastVisibleRow=function(){return this.layerConfig.lastRow},e.prototype.setPadding=function(e){this.$padding=e,this.$textLayer.setPadding(e),this.$cursorLayer.setPadding(e),this.$markerFront.setPadding(e),this.$markerBack.setPadding(e),this.$loop.schedule(this.CHANGE_FULL),this.$updatePrintMargin()},e.prototype.setScrollMargin=function(e,t,n,r){var i=this.scrollMargin;i.top=e|0,i.bottom=t|0,i.right=r|0,i.left=n|0,i.v=i.top+i.bottom,i.h=i.left+i.right,i.top&&this.scrollTop<=0&&this.session&&this.session.setScrollTop(-i.top),this.updateFull()},e.prototype.setMargin=function(e,t,n,r){var i=this.margin;i.top=e|0,i.bottom=t|0,i.right=r|0,i.left=n|0,i.v=i.top+i.bottom,i.h=i.left+i.right,this.$updateCachedSize(!0,this.gutterWidth,this.$size.width,this.$size.height),this.updateFull()},e.prototype.getHScrollBarAlwaysVisible=function(){return this.$hScrollBarAlwaysVisible},e.prototype.setHScrollBarAlwaysVisible=function(e){this.setOption("hScrollBarAlwaysVisible",e)},e.prototype.getVScrollBarAlwaysVisible=function(){return this.$vScrollBarAlwaysVisible},e.prototype.setVScrollBarAlwaysVisible=function(e){this.setOption("vScrollBarAlwaysVisible",e)},e.prototype.$updateScrollBarV=function(){var e=this.layerConfig.maxHeight,t=this.$size.scrollerHeight;!this.$maxLines&&this.$scrollPastEnd&&(e-=(t-this.lineHeight)*this.$scrollPastEnd,this.scrollTop>e-t&&(e=this.scrollTop+t,this.scrollBarV.scrollTop=null)),this.scrollBarV.setScrollHeight(e+this.scrollMargin.v),this.scrollBarV.setScrollTop(this.scrollTop+this.scrollMargin.top)},e.prototype.$updateScrollBarH=function(){this.scrollBarH.setScrollWidth(this.layerConfig.width+2*this.$padding+this.scrollMargin.h),this.scrollBarH.setScrollLeft(this.scrollLeft+this.scrollMargin.left)},e.prototype.freeze=function(){this.$frozen=!0},e.prototype.unfreeze=function(){this.$frozen=!1},e.prototype.$renderChanges=function(e,t){this.$changes&&(e|=this.$changes,this.$changes=0);if(!this.session||!this.container.offsetWidth||this.$frozen||!e&&!t){this.$changes|=e;return}if(this.$size.$dirty)return this.$changes|=e,this.onResize(!0);this.lineHeight||this.$textLayer.checkForSizeChanges(),this._signal("beforeRender",e),this.session&&this.session.$bidiHandler&&this.session.$bidiHandler.updateCharacterWidths(this.$fontMetrics);var n=this.layerConfig;if(e&this.CHANGE_FULL||e&this.CHANGE_SIZE||e&this.CHANGE_TEXT||e&this.CHANGE_LINES||e&this.CHANGE_SCROLL||e&this.CHANGE_H_SCROLL){e|=this.$computeLayerConfig()|this.$loop.clear();if(n.firstRow!=this.layerConfig.firstRow&&n.firstRowScreen==this.layerConfig.firstRowScreen){var r=this.scrollTop+(n.firstRow-Math.max(this.layerConfig.firstRow,0))*this.lineHeight;r>0&&(this.scrollTop=r,e|=this.CHANGE_SCROLL,e|=this.$computeLayerConfig()|this.$loop.clear())}n=this.layerConfig,this.$updateScrollBarV(),e&this.CHANGE_H_SCROLL&&this.$updateScrollBarH(),i.translate(this.content,-this.scrollLeft,-n.offset);var s=n.width+2*this.$padding+"px",o=n.minHeight+"px";i.setStyle(this.content.style,"width",s),i.setStyle(this.content.style,"height",o)}e&this.CHANGE_H_SCROLL&&(i.translate(this.content,-this.scrollLeft,-n.offset),this.scroller.className=this.scrollLeft<=0?"ace_scroller ":"ace_scroller ace_scroll-left ",this.enableKeyboardAccessibility&&(this.scroller.className+=this.keyboardFocusClassName));if(e&this.CHANGE_FULL){this.$changedLines=null,this.$textLayer.update(n),this.$showGutter&&this.$gutterLayer.update(n),this.$customScrollbar&&this.$scrollDecorator.$updateDecorators(n),this.$markerBack.update(n),this.$markerFront.update(n),this.$cursorLayer.update(n),this.$moveTextAreaToCursor(),this._signal("afterRender",e);return}if(e&this.CHANGE_SCROLL){this.$changedLines=null,e&this.CHANGE_TEXT||e&this.CHANGE_LINES?this.$textLayer.update(n):this.$textLayer.scrollLines(n),this.$showGutter&&(e&this.CHANGE_GUTTER||e&this.CHANGE_LINES?this.$gutterLayer.update(n):this.$gutterLayer.scrollLines(n)),this.$customScrollbar&&this.$scrollDecorator.$updateDecorators(n),this.$markerBack.update(n),this.$markerFront.update(n),this.$cursorLayer.update(n),this.$moveTextAreaToCursor(),this._signal("afterRender",e);return}e&this.CHANGE_TEXT?(this.$changedLines=null,this.$textLayer.update(n),this.$showGutter&&this.$gutterLayer.update(n),this.$customScrollbar&&this.$scrollDecorator.$updateDecorators(n)):e&this.CHANGE_LINES?((this.$updateLines()||e&this.CHANGE_GUTTER&&this.$showGutter)&&this.$gutterLayer.update(n),this.$customScrollbar&&this.$scrollDecorator.$updateDecorators(n)):e&this.CHANGE_TEXT||e&this.CHANGE_GUTTER?(this.$showGutter&&this.$gutterLayer.update(n),this.$customScrollbar&&this.$scrollDecorator.$updateDecorators(n)):e&this.CHANGE_CURSOR&&(this.$highlightGutterLine&&this.$gutterLayer.updateLineHighlight(n),this.$customScrollbar&&this.$scrollDecorator.$updateDecorators(n)),e&this.CHANGE_CURSOR&&(this.$cursorLayer.update(n),this.$moveTextAreaToCursor()),e&(this.CHANGE_MARKER|this.CHANGE_MARKER_FRONT)&&this.$markerFront.update(n),e&(this.CHANGE_MARKER|this.CHANGE_MARKER_BACK)&&this.$markerBack.update(n),this._signal("afterRender",e)},e.prototype.$autosize=function(){var e=this.session.getScreenLength()*this.lineHeight,t=this.$maxLines*this.lineHeight,n=Math.min(t,Math.max((this.$minLines||1)*this.lineHeight,e))+this.scrollMargin.v+(this.$extraHeight||0);this.$horizScroll&&(n+=this.scrollBarH.getHeight()),this.$maxPixelHeight&&n>this.$maxPixelHeight&&(n=this.$maxPixelHeight);var r=n<=2*this.lineHeight,i=!r&&e>t;if(n!=this.desiredHeight||this.$size.height!=this.desiredHeight||i!=this.$vScroll){i!=this.$vScroll&&(this.$vScroll=i,this.scrollBarV.setVisible(i));var s=this.container.clientWidth;this.container.style.height=n+"px",this.$updateCachedSize(!0,this.$gutterWidth,s,n),this.desiredHeight=n,this._signal("autosize")}},e.prototype.$computeLayerConfig=function(){var e=this.session,t=this.$size,n=t.height<=2*this.lineHeight,r=this.session.getScreenLength(),i=r*this.lineHeight,s=this.$getLongestLine(),o=!n&&(this.$hScrollBarAlwaysVisible||t.scrollerWidth-s-2*this.$padding<0),u=this.$horizScroll!==o;u&&(this.$horizScroll=o,this.scrollBarH.setVisible(o));var a=this.$vScroll;this.$maxLines&&this.lineHeight>1&&(this.$autosize(),n=t.height<=2*this.lineHeight);var f=t.scrollerHeight+this.lineHeight,l=!this.$maxLines&&this.$scrollPastEnd?(t.scrollerHeight-this.lineHeight)*this.$scrollPastEnd:0;i+=l;var c=this.scrollMargin;this.session.setScrollTop(Math.max(-c.top,Math.min(this.scrollTop,i-t.scrollerHeight+c.bottom))),this.session.setScrollLeft(Math.max(-c.left,Math.min(this.scrollLeft,s+2*this.$padding-t.scrollerWidth+c.right)));var h=!n&&(this.$vScrollBarAlwaysVisible||t.scrollerHeight-i+l<0||this.scrollTop>c.top),p=a!==h;p&&(this.$vScroll=h,this.scrollBarV.setVisible(h));var d=this.scrollTop%this.lineHeight,v=Math.ceil(f/this.lineHeight)-1,m=Math.max(0,Math.round((this.scrollTop-d)/this.lineHeight)),g=m+v,y,b,w=this.lineHeight;m=e.screenToDocumentRow(m,0);var E=e.getFoldLine(m);E&&(m=E.start.row),y=e.documentToScreenRow(m,0),b=e.getRowLength(m)*w,g=Math.min(e.screenToDocumentRow(g,0),e.getLength()-1),f=t.scrollerHeight+e.getRowLength(g)*w+b,d=this.scrollTop-y*w,d<0&&y>0&&(y=Math.max(0,y+Math.floor(d/w)),d=this.scrollTop-y*w);var S=0;if(this.layerConfig.width!=s||u)S=this.CHANGE_H_SCROLL;if(u||p)S|=this.$updateCachedSize(!0,this.gutterWidth,t.width,t.height),this._signal("scrollbarVisibilityChanged"),p&&(s=this.$getLongestLine());return this.layerConfig={width:s,padding:this.$padding,firstRow:m,firstRowScreen:y,lastRow:g,lineHeight:w,characterWidth:this.characterWidth,minHeight:f,maxHeight:i,offset:d,gutterOffset:w?Math.max(0,Math.ceil((d+t.height-t.scrollerHeight)/w)):0,height:this.$size.scrollerHeight},this.session.$bidiHandler&&this.session.$bidiHandler.setContentWidth(s-this.$padding),S},e.prototype.$updateLines=function(){if(!this.$changedLines)return;var e=this.$changedLines.firstRow,t=this.$changedLines.lastRow;this.$changedLines=null;var n=this.layerConfig;if(e>n.lastRow+1)return;if(t<n.firstRow)return;if(t===Infinity){this.$showGutter&&this.$gutterLayer.update(n),this.$textLayer.update(n);return}return this.$textLayer.updateLines(n,e,t),!0},e.prototype.$getLongestLine=function(){var e=this.session.getScreenWidth();return this.showInvisibles&&!this.session.$useWrapMode&&(e+=1),this.$textLayer&&e>this.$textLayer.MAX_LINE_LENGTH&&(e=this.$textLayer.MAX_LINE_LENGTH+30),Math.max(this.$size.scrollerWidth-2*this.$padding,Math.round(e*this.characterWidth))},e.prototype.updateFrontMarkers=function(){this.$markerFront.setMarkers(this.session.getMarkers(!0)),this.$loop.schedule(this.CHANGE_MARKER_FRONT)},e.prototype.updateBackMarkers=function(){this.$markerBack.setMarkers(this.session.getMarkers()),this.$loop.schedule(this.CHANGE_MARKER_BACK)},e.prototype.addGutterDecoration=function(e,t){this.$gutterLayer.addGutterDecoration(e,t)},e.prototype.removeGutterDecoration=function(e,t){this.$gutterLayer.removeGutterDecoration(e,t)},e.prototype.updateBreakpoints=function(e){this._rows=e,this.$loop.schedule(this.CHANGE_GUTTER)},e.prototype.setAnnotations=function(e){this.$gutterLayer.setAnnotations(e),this.$loop.schedule(this.CHANGE_GUTTER)},e.prototype.updateCursor=function(){this.$loop.schedule(this.CHANGE_CURSOR)},e.prototype.hideCursor=function(){this.$cursorLayer.hideCursor()},e.prototype.showCursor=function(){this.$cursorLayer.showCursor()},e.prototype.scrollSelectionIntoView=function(e,t,n){this.scrollCursorIntoView(e,n),this.scrollCursorIntoView(t,n)},e.prototype.scrollCursorIntoView=function(e,t,n){if(this.$size.scrollerHeight===0)return;var r=this.$cursorLayer.getPixelPosition(e),i=r.left,s=r.top,o=n&&n.top||0,u=n&&n.bottom||0;this.$scrollAnimation&&(this.$stopAnimation=!0);var a=this.$scrollAnimation?this.session.getScrollTop():this.scrollTop;a+o>s?(t&&a+o>s+this.lineHeight&&(s-=t*this.$size.scrollerHeight),s===0&&(s=-this.scrollMargin.top),this.session.setScrollTop(s)):a+this.$size.scrollerHeight-u<s+this.lineHeight&&(t&&a+this.$size.scrollerHeight-u<s-this.lineHeight&&(s+=t*this.$size.scrollerHeight),this.session.setScrollTop(s+this.lineHeight+u-this.$size.scrollerHeight));var f=this.scrollLeft,l=2*this.layerConfig.characterWidth;i-l<f?(i-=l,i<this.$padding+l&&(i=-this.scrollMargin.left),this.session.setScrollLeft(i)):(i+=l,f+this.$size.scrollerWidth<i+this.characterWidth?this.session.setScrollLeft(Math.round(i+this.characterWidth-this.$size.scrollerWidth)):f<=this.$padding&&i-f<this.characterWidth&&this.session.setScrollLeft(0))},e.prototype.getScrollTop=function(){return this.session.getScrollTop()},e.prototype.getScrollLeft=function(){return this.session.getScrollLeft()},e.prototype.getScrollTopRow=function(){return this.scrollTop/this.lineHeight},e.prototype.getScrollBottomRow=function(){return Math.max(0,Math.floor((this.scrollTop+this.$size.scrollerHeight)/this.lineHeight)-1)},e.prototype.scrollToRow=function(e){this.session.setScrollTop(e*this.lineHeight)},e.prototype.alignCursor=function(e,t){typeof e=="number"&&(e={row:e,column:0});var n=this.$cursorLayer.getPixelPosition(e),r=this.$size.scrollerHeight-this.lineHeight,i=n.top-r*(t||0);return this.session.setScrollTop(i),i},e.prototype.$calcSteps=function(e,t){var n=0,r=this.STEPS,i=[],s=function(e,t,n){return n*(Math.pow(e-1,3)+1)+t};for(n=0;n<r;++n)i.push(s(n/this.STEPS,e,t-e));return i},e.prototype.scrollToLine=function(e,t,n,r){var i=this.$cursorLayer.getPixelPosition({row:e,column:0}),s=i.top;t&&(s-=this.$size.scrollerHeight/2);var o=this.scrollTop;this.session.setScrollTop(s),n!==!1&&this.animateScrolling(o,r)},e.prototype.animateScrolling=function(e,t){function o(){r.$timer=clearInterval(r.$timer),r.$scrollAnimation=null,r.$stopAnimation=!1,t&&t()}var n=this.scrollTop;if(!this.$animatedScroll)return;var r=this;if(e==n)return;if(this.$scrollAnimation){var i=this.$scrollAnimation.steps;if(i.length){e=i[0];if(e==n)return}}var s=r.$calcSteps(e,n);this.$scrollAnimation={from:e,to:n,steps:s},clearInterval(this.$timer),r.session.setScrollTop(s.shift()),r.session.$scrollTop=n,this.$timer=setInterval(function(){if(r.$stopAnimation){o();return}if(!r.session)return clearInterval(r.$timer);s.length?(r.session.setScrollTop(s.shift()),r.session.$scrollTop=n):n!=null?(r.session.$scrollTop=-1,r.session.setScrollTop(n),n=null):o()},10)},e.prototype.scrollToY=function(e){this.scrollTop!==e&&(this.$loop.schedule(this.CHANGE_SCROLL),this.scrollTop=e)},e.prototype.scrollToX=function(e){this.scrollLeft!==e&&(this.scrollLeft=e),this.$loop.schedule(this.CHANGE_H_SCROLL)},e.prototype.scrollTo=function(e,t){this.session.setScrollTop(t),this.session.setScrollLeft(e)},e.prototype.scrollBy=function(e,t){t&&this.session.setScrollTop(this.session.getScrollTop()+t),e&&this.session.setScrollLeft(this.session.getScrollLeft()+e)},e.prototype.isScrollableBy=function(e,t){if(t<0&&this.session.getScrollTop()>=1-this.scrollMargin.top)return!0;if(t>0&&this.session.getScrollTop()+this.$size.scrollerHeight-this.layerConfig.maxHeight<-1+this.scrollMargin.bottom)return!0;if(e<0&&this.session.getScrollLeft()>=1-this.scrollMargin.left)return!0;if(e>0&&this.session.getScrollLeft()+this.$size.scrollerWidth-this.layerConfig.width<-1+this.scrollMargin.right)return!0},e.prototype.pixelToScreenCoordinates=function(e,t){var n;if(this.$hasCssTransforms){n={top:0,left:0};var r=this.$fontMetrics.transformCoordinates([e,t]);e=r[1]-this.gutterWidth-this.margin.left,t=r[0]}else n=this.scroller.getBoundingClientRect();var i=e+this.scrollLeft-n.left-this.$padding,s=i/this.characterWidth,o=Math.floor((t+this.scrollTop-n.top)/this.lineHeight),u=this.$blockCursor?Math.floor(s):Math.round(s);return{row:o,column:u,side:s-u>0?1:-1,offsetX:i}},e.prototype.screenToTextCoordinates=function(e,t){var n;if(this.$hasCssTransforms){n={top:0,left:0};var r=this.$fontMetrics.transformCoordinates([e,t]);e=r[1]-this.gutterWidth-this.margin.left,t=r[0]}else n=this.scroller.getBoundingClientRect();var i=e+this.scrollLeft-n.left-this.$padding,s=i/this.characterWidth,o=this.$blockCursor?Math.floor(s):Math.round(s),u=(t+this.scrollTop-n.top)/this.lineHeight;return this.session.screenToDocumentPosition(u,Math.max(o,0),i)},e.prototype.textToScreenCoordinates=function(e,t){var n=this.scroller.getBoundingClientRect(),r=this.session.documentToScreenPosition(e,t),i=this.$padding+(this.session.$bidiHandler.isBidiRow(r.row,e)?this.session.$bidiHandler.getPosLeft(r.column):Math.round(r.column*this.characterWidth)),s=r.row*this.lineHeight;return{pageX:n.left+i-this.scrollLeft,pageY:n.top+s-this.scrollTop}},e.prototype.visualizeFocus=function(){i.addCssClass(this.container,"ace_focus")},e.prototype.visualizeBlur=function(){i.removeCssClass(this.container,"ace_focus")},e.prototype.showComposition=function(e){this.$composition=e,e.cssText||(e.cssText=this.textarea.style.cssText),e.useTextareaForIME==undefined&&(e.useTextareaForIME=this.$useTextareaForIME),this.$useTextareaForIME?(i.addCssClass(this.textarea,"ace_composition"),this.textarea.style.cssText="",this.$moveTextAreaToCursor(),this.$cursorLayer.element.style.display="none"):e.markerId=this.session.addMarker(e.markerRange,"ace_composition_marker","text")},e.prototype.setCompositionText=function(e){var t=this.session.selection.cursor;this.addToken(e,"composition_placeholder",t.row,t.column),this.$moveTextAreaToCursor()},e.prototype.hideComposition=function(){if(!this.$composition)return;this.$composition.markerId&&this.session.removeMarker(this.$composition.markerId),i.removeCssClass(this.textarea,"ace_composition"),this.textarea.style.cssText=this.$composition.cssText;var e=this.session.selection.cursor;this.removeExtraToken(e.row,e.column),this.$composition=null,this.$cursorLayer.element.style.display=""},e.prototype.setGhostText=function(e,t){var n=this.session.selection.cursor,r=t||{row:n.row,column:n.column};this.removeGhostText();var s=this.$calculateWrappedTextChunks(e,r);this.addToken(s[0].text,"ghost_text",r.row,r.column),this.$ghostText={text:e,position:{row:r.row,column:r.column}};var o=i.createElement("div");if(s.length>1){var u=this.hideTokensAfterPosition(r.row,r.column),a;s.slice(1).forEach(function(e){var t=i.createElement("div"),n=i.createElement("span");n.className="ace_ghost_text",e.wrapped&&(t.className="ghost_text_line_wrapped"),e.text.length===0&&(e.text=" "),n.appendChild(i.createTextNode(e.text)),t.appendChild(n),o.appendChild(t),a=t}),u.forEach(function(e){var t=i.createElement("span");E(e.type)||(t.className="ace_"+e.type.replace(/\./g," ace_")),t.appendChild(i.createTextNode(e.value)),a.appendChild(t)}),this.$ghostTextWidget={el:o,row:r.row,column:r.column,className:"ace_ghost_text_container"},this.session.widgetManager.addLineWidget(this.$ghostTextWidget);var f=this.$cursorLayer.getPixelPosition(r,!0),l=this.container,c=l.getBoundingClientRect().height,h=s.length*this.lineHeight,p=h<c-f.top;if(p)return;h<c?this.scrollBy(0,(s.length-1)*this.lineHeight):this.scrollToRow(r.row)}},e.prototype.$calculateWrappedTextChunks=function(e,t){var n=this.$size.scrollerWidth-this.$padding*2,r=Math.floor(n/this.characterWidth)-2;r=r<=0?60:r;var i=e.split(/\r?\n/),s=[];for(var o=0;o<i.length;o++){var u=this.session.$getDisplayTokens(i[o],t.column),a=this.session.$computeWrapSplits(u,r,this.session.$tabSize);if(a.length>0){var f=0;a.push(i[o].length);for(var l=0;l<a.length;l++){var c=i[o].slice(f,a[l]);s.push({text:c,wrapped:!0}),f=a[l]}}else s.push({text:i[o],wrapped:!1})}return s},e.prototype.removeGhostText=function(){if(!this.$ghostText)return;var e=this.$ghostText.position;this.removeExtraToken(e.row,e.column),this.$ghostTextWidget&&(this.session.widgetManager.removeLineWidget(this.$ghostTextWidget),this.$ghostTextWidget=null),this.$ghostText=null},e.prototype.addToken=function(e,t,n,r){var i=this.session;i.bgTokenizer.lines[n]=null;var s={type:t,value:e},o=i.getTokens(n);if(r==null||!o.length)o.push(s);else{var u=0;for(var a=0;a<o.length;a++){var f=o[a];u+=f.value.length;if(r<=u){var l=f.value.length-(u-r),c=f.value.slice(0,l),h=f.value.slice(l);o.splice(a,1,{type:f.type,value:c},s,{type:f.type,value:h});break}}}this.updateLines(n,n)},e.prototype.hideTokensAfterPosition=function(e,t){var n=this.session.getTokens(e),r=0,i=!1,s=[];for(var o=0;o<n.length;o++){var u=n[o];r+=u.value.length;if(u.type==="ghost_text")continue;if(i){s.push({type:u.type,value:u.value}),u.type="hidden_token";continue}r===t&&(i=!0)}return this.updateLines(e,e),s},e.prototype.removeExtraToken=function(e,t){this.session.bgTokenizer.lines[e]=null,this.updateLines(e,e)},e.prototype.setTheme=function(e,t){function s(r){if(n.$themeId!=e)return t&&t();if(!r||!r.cssClass)throw new Error("couldn't load module "+e+" or it didn't call define");r.$id&&(n.$themeId=r.$id),i.importCssString(r.cssText,r.cssClass,n.container),n.theme&&i.removeCssClass(n.container,n.theme.cssClass);var s="padding"in r?r.padding:"padding"in(n.theme||{})?4:n.$padding;n.$padding&&s!=n.$padding&&n.setPadding(s);if(n.$gutterLayer){var o=r.$showGutterCursorMarker;o&&!n.$gutterLayer.$showCursorMarker?n.$gutterLayer.$showCursorMarker="theme":!o&&n.$gutterLayer.$showCursorMarker=="theme"&&(n.$gutterLayer.$showCursorMarker=null)}n.$theme=r.cssClass,n.theme=r,i.addCssClass(n.container,r.cssClass),i.setCssClass(n.container,"ace_dark",r.isDark),n.$size&&(n.$size.width=0,n.$updateSizeAsync()),n._dispatchEvent("themeLoaded",{theme:r}),t&&t(),w.isSafari&&n.scroller&&(n.scroller.style.background="red",n.scroller.style.background="")}var n=this;this.$themeId=e,n._dispatchEvent("themeChange",{theme:e});if(!e||typeof e=="string"){var r=e||this.$options.theme.initialValue;o.loadModule(["theme",r],s)}else s(e)},e.prototype.getTheme=function(){return this.$themeId},e.prototype.setStyle=function(e,t){i.setCssClass(this.container,e,t!==!1)},e.prototype.unsetStyle=function(e){i.removeCssClass(this.container,e)},e.prototype.setCursorStyle=function(e){i.setStyle(this.scroller.style,"cursor",e)},e.prototype.setMouseCursor=function(e){i.setStyle(this.scroller.style,"cursor",e)},e.prototype.attachToShadowRoot=function(){i.importCssString(y,"ace_editor.css",this.container)},e.prototype.destroy=function(){this.freeze(),this.$fontMetrics.destroy(),this.$cursorLayer.destroy(),this.removeAllListeners(),this.container.textContent="",this.setOption("useResizeObserver",!1)},e.prototype.$updateCustomScrollbar=function(e){var t=this;this.$horizScroll=this.$vScroll=null,this.scrollBarV.element.remove(),this.scrollBarH.element.remove(),e===!0?(this.scrollBarV=new d(this.container,this),this.scrollBarH=new p(this.container,this),this.scrollBarV.setHeight(this.$size.scrollerHeight),this.scrollBarH.setWidth(this.$size.scrollerWidth),this.scrollBarV.addEventListener("scroll",function(e){t.$scrollAnimation||t.session.setScrollTop(e.data-t.scrollMargin.top)}),this.scrollBarH.addEventListener("scroll",function(e){t.$scrollAnimation||t.session.setScrollLeft(e.data-t.scrollMargin.left)}),this.$scrollDecorator?(this.$scrollDecorator.setScrollBarV(this.scrollBarV),this.$scrollDecorator.$updateDecorators()):(this.$scrollDecorator=new b(this.scrollBarV,this),this.$scrollDecorator.$updateDecorators())):(this.scrollBarV=new h(this.container,this),this.scrollBarH=new c(this.container,this),this.scrollBarV.addEventListener("scroll",function(e){t.$scrollAnimation||t.session.setScrollTop(e.data-t.scrollMargin.top)}),this.scrollBarH.addEventListener("scroll",function(e){t.$scrollAnimation||t.session.setScrollLeft(e.data-t.scrollMargin.left)}))},e.prototype.$addResizeObserver=function(){if(!window.ResizeObserver||this.$resizeObserver)return;var e=this;this.$resizeTimer=s.delayedCall(function(){e.destroyed||e.onResize()},50),this.$resizeObserver=new window.ResizeObserver(function(t){var n=t[0].contentRect.width,r=t[0].contentRect.height;Math.abs(e.$size.width-n)>1||Math.abs(e.$size.height-r)>1?e.$resizeTimer.delay():e.$resizeTimer.cancel()}),this.$resizeObserver.observe(this.container)},e}();S.prototype.CHANGE_CURSOR=1,S.prototype.CHANGE_MARKER=2,S.prototype.CHANGE_GUTTER=4,S.prototype.CHANGE_SCROLL=8,S.prototype.CHANGE_LINES=16,S.prototype.CHANGE_TEXT=32,S.prototype.CHANGE_SIZE=64,S.prototype.CHANGE_MARKER_BACK=128,S.prototype.CHANGE_MARKER_FRONT=256,S.prototype.CHANGE_FULL=512,S.prototype.CHANGE_H_SCROLL=1024,S.prototype.$changes=0,S.prototype.$padding=null,S.prototype.$frozen=!1,S.prototype.STEPS=8,r.implement(S.prototype,g),o.defineOptions(S.prototype,"renderer",{useResizeObserver:{set:function(e){!e&&this.$resizeObserver?(this.$resizeObserver.disconnect(),this.$resizeTimer.cancel(),this.$resizeTimer=this.$resizeObserver=null):e&&!this.$resizeObserver&&this.$addResizeObserver()}},animatedScroll:{initialValue:!1},showInvisibles:{set:function(e){this.$textLayer.setShowInvisibles(e)&&this.$loop.schedule(this.CHANGE_TEXT)},initialValue:!1},showPrintMargin:{set:function(){this.$updatePrintMargin()},initialValue:!0},printMarginColumn:{set:function(){this.$updatePrintMargin()},initialValue:80},printMargin:{set:function(e){typeof e=="number"&&(this.$printMarginColumn=e),this.$showPrintMargin=!!e,this.$updatePrintMargin()},get:function(){return this.$showPrintMargin&&this.$printMarginColumn}},showGutter:{set:function(e){this.$gutter.style.display=e?"block":"none",this.$loop.schedule(this.CHANGE_FULL),this.onGutterResize()},initialValue:!0},useSvgGutterIcons:{set:function(e){this.$gutterLayer.$useSvgGutterIcons=e},initialValue:!1},showFoldedAnnotations:{set:function(e){this.$gutterLayer.$showFoldedAnnotations=e},initialValue:!1},fadeFoldWidgets:{set:function(e){i.setCssClass(this.$gutter,"ace_fade-fold-widgets",e)},initialValue:!1},showFoldWidgets:{set:function(e){this.$gutterLayer.setShowFoldWidgets(e),this.$loop.schedule(this.CHANGE_GUTTER)},initialValue:!0},displayIndentGuides:{set:function(e){this.$textLayer.setDisplayIndentGuides(e)&&this.$loop.schedule(this.CHANGE_TEXT)},initialValue:!0},highlightIndentGuides:{set:function(e){this.$textLayer.setHighlightIndentGuides(e)==1?this.$textLayer.$highlightIndentGuide():this.$textLayer.$clearActiveIndentGuide(this.$textLayer.$lines.cells)},initialValue:!0},highlightGutterLine:{set:function(e){this.$gutterLayer.setHighlightGutterLine(e),this.$loop.schedule(this.CHANGE_GUTTER)},initialValue:!0},hScrollBarAlwaysVisible:{set:function(e){(!this.$hScrollBarAlwaysVisible||!this.$horizScroll)&&this.$loop.schedule(this.CHANGE_SCROLL)},initialValue:!1},vScrollBarAlwaysVisible:{set:function(e){(!this.$vScrollBarAlwaysVisible||!this.$vScroll)&&this.$loop.schedule(this.CHANGE_SCROLL)},initialValue:!1},fontSize:{set:function(e){typeof e=="number"&&(e+="px"),this.container.style.fontSize=e,this.updateFontSize()},initialValue:12},fontFamily:{set:function(e){this.container.style.fontFamily=e,this.updateFontSize()}},maxLines:{set:function(e){this.updateFull()}},minLines:{set:function(e){this.$minLines<562949953421311||(this.$minLines=0),this.updateFull()}},maxPixelHeight:{set:function(e){this.updateFull()},initialValue:0},scrollPastEnd:{set:function(e){e=+e||0;if(this.$scrollPastEnd==e)return;this.$scrollPastEnd=e,this.$loop.schedule(this.CHANGE_SCROLL)},initialValue:0,handlesSet:!0},fixedWidthGutter:{set:function(e){this.$gutterLayer.$fixedWidth=!!e,this.$loop.schedule(this.CHANGE_GUTTER)}},customScrollbar:{set:function(e){this.$updateCustomScrollbar(e)},initialValue:!1},theme:{set:function(e){this.setTheme(e)},get:function(){return this.$themeId||this.theme},initialValue:"./theme/textmate",handlesSet:!0},hasCssTransforms:{},useTextareaForIME:{initialValue:!w.isMobile&&!w.isIE}}),t.VirtualRenderer=S}),define("ace/worker/worker_client",["require","exports","module","ace/lib/oop","ace/lib/net","ace/lib/event_emitter","ace/config"],function(e,t,n){"use strict";function u(e){var t="importScripts('"+i.qualifyURL(e)+"');";try{return new Blob([t],{type:"application/javascript"})}catch(n){var r=window.BlobBuilder||window.WebKitBlobBuilder||window.MozBlobBuilder,s=new r;return s.append(t),s.getBlob("application/javascript")}}function a(e){if(typeof Worker=="undefined")return{postMessage:function(){},terminate:function(){}};if(o.get("loadWorkerFromBlob")){var t=u(e),n=window.URL||window.webkitURL,r=n.createObjectURL(t);return new Worker(r)}return new Worker(e)}var r=e("../lib/oop"),i=e("../lib/net"),s=e("../lib/event_emitter").EventEmitter,o=e("../config"),f=function(e){e.postMessage||(e=this.$createWorkerFromOldConfig.apply(this,arguments)),this.$worker=e,this.$sendDeltaQueue=this.$sendDeltaQueue.bind(this),this.changeListener=this.changeListener.bind(this),this.onMessage=this.onMessage.bind(this),this.callbackId=1,this.callbacks={},this.$worker.onmessage=this.onMessage};(function(){r.implement(this,s),this.$createWorkerFromOldConfig=function(t,n,r,i,s){e.nameToUrl&&!e.toUrl&&(e.toUrl=e.nameToUrl);if(o.get("packaged")||!e.toUrl)i=i||o.moduleUrl(n,"worker");else{var u=this.$normalizePath;i=i||u(e.toUrl("ace/worker/worker.js",null,"_"));var f={};t.forEach(function(t){f[t]=u(e.toUrl(t,null,"_").replace(/(\.js)?(\?.*)?$/,""))})}return this.$worker=a(i),s&&this.send("importScripts",s),this.$worker.postMessage({init:!0,tlns:f,module:n,classname:r}),this.$worker},this.onMessage=function(e){var t=e.data;switch(t.type){case"event":this._signal(t.name,{data:t.data});break;case"call":var n=this.callbacks[t.id];n&&(n(t.data),delete this.callbacks[t.id]);break;case"error":this.reportError(t.data);break;case"log":window.console&&console.log&&console.log.apply(console,t.data)}},this.reportError=function(e){window.console&&console.error&&console.error(e)},this.$normalizePath=function(e){return i.qualifyURL(e)},this.terminate=function(){this._signal("terminate",{}),this.deltaQueue=null,this.$worker.terminate(),this.$worker.onerror=function(e){e.preventDefault()},this.$worker=null,this.$doc&&this.$doc.off("change",this.changeListener),this.$doc=null},this.send=function(e,t){this.$worker.postMessage({command:e,args:t})},this.call=function(e,t,n){if(n){var r=this.callbackId++;this.callbacks[r]=n,t.push(r)}this.send(e,t)},this.emit=function(e,t){try{t.data&&t.data.err&&(t.data.err={message:t.data.err.message,stack:t.data.err.stack,code:t.data.err.code}),this.$worker&&this.$worker.postMessage({event:e,data:{data:t.data}})}catch(n){console.error(n.stack)}},this.attachToDocument=function(e){this.$doc&&this.terminate(),this.$doc=e,this.call("setValue",[e.getValue()]),e.on("change",this.changeListener,!0)},this.changeListener=function(e){this.deltaQueue||(this.deltaQueue=[],setTimeout(this.$sendDeltaQueue,0)),e.action=="insert"?this.deltaQueue.push(e.start,e.lines):this.deltaQueue.push(e.start,e.end)},this.$sendDeltaQueue=function(){var e=this.deltaQueue;if(!e)return;this.deltaQueue=null,e.length>50&&e.length>this.$doc.getLength()>>1?this.call("setValue",[this.$doc.getValue()]):this.emit("change",{data:e})}}).call(f.prototype);var l=function(e,t,n){var r=null,i=!1,u=Object.create(s),a=[],l=new f({messageBuffer:a,terminate:function(){},postMessage:function(e){a.push(e);if(!r)return;i?setTimeout(c):c()}});l.setEmitSync=function(e){i=e};var c=function(){var e=a.shift();e.command?r[e.command].apply(r,e.args):e.event&&u._signal(e.event,e.data)};return u.postMessage=function(e){l.onMessage({data:e})},u.callback=function(e,t){this.postMessage({type:"call",id:t,data:e})},u.emit=function(e,t){this.postMessage({type:"event",name:e,data:t})},o.loadModule(["worker",t],function(e){r=new e[n](u);while(a.length)c()}),l};t.UIWorkerClient=l,t.WorkerClient=f,t.createWorker=a}),define("ace/placeholder",["require","exports","module","ace/range","ace/lib/event_emitter","ace/lib/oop"],function(e,t,n){"use strict";var r=e("./range").Range,i=e("./lib/event_emitter").EventEmitter,s=e("./lib/oop"),o=function(){function e(e,t,n,r,i,s){var o=this;this.length=t,this.session=e,this.doc=e.getDocument(),this.mainClass=i,this.othersClass=s,this.$onUpdate=this.onUpdate.bind(this),this.doc.on("change",this.$onUpdate,!0),this.$others=r,this.$onCursorChange=function(){setTimeout(function(){o.onCursorChange()})},this.$pos=n;var u=e.getUndoManager().$undoStack||e.getUndoManager().$undostack||{length:-1};this.$undoStackDepth=u.length,this.setup(),e.selection.on("changeCursor",this.$onCursorChange)}return e.prototype.setup=function(){var e=this,t=this.doc,n=this.session;this.selectionBefore=n.selection.toJSON(),n.selection.inMultiSelectMode&&n.selection.toSingleRange(),this.pos=t.createAnchor(this.$pos.row,this.$pos.column);var i=this.pos;i.$insertRight=!0,i.detach(),i.markerId=n.addMarker(new r(i.row,i.column,i.row,i.column+this.length),this.mainClass,null,!1),this.others=[],this.$others.forEach(function(n){var r=t.createAnchor(n.row,n.column);r.$insertRight=!0,r.detach(),e.others.push(r)}),n.setUndoSelect(!1)},e.prototype.showOtherMarkers=function(){if(this.othersActive)return;var e=this.session,t=this;this.othersActive=!0,this.others.forEach(function(n){n.markerId=e.addMarker(new r(n.row,n.column,n.row,n.column+t.length),t.othersClass,null,!1)})},e.prototype.hideOtherMarkers=function(){if(!this.othersActive)return;this.othersActive=!1;for(var e=0;e<this.others.length;e++)this.session.removeMarker(this.others[e].markerId)},e.prototype.onUpdate=function(e){if(this.$updating)return this.updateAnchors(e);var t=e;if(t.start.row!==t.end.row)return;if(t.start.row!==this.pos.row)return;this.$updating=!0;var n=e.action==="insert"?t.end.column-t.start.column:t.start.column-t.end.column,i=t.start.column>=this.pos.column&&t.start.column<=this.pos.column+this.length+1,s=t.start.column-this.pos.column;this.updateAnchors(e),i&&(this.length+=n);if(i&&!this.session.$fromUndo)if(e.action==="insert")for(var o=this.others.length-1;o>=0;o--){var u=this.others[o],a={row:u.row,column:u.column+s};this.doc.insertMergedLines(a,e.lines)}else if(e.action==="remove")for(var o=this.others.length-1;o>=0;o--){var u=this.others[o],a={row:u.row,column:u.column+s};this.doc.remove(new r(a.row,a.column,a.row,a.column-n))}this.$updating=!1,this.updateMarkers()},e.prototype.updateAnchors=function(e){this.pos.onChange(e);for(var t=this.others.length;t--;)this.others[t].onChange(e);this.updateMarkers()},e.prototype.updateMarkers=function(){if(this.$updating)return;var e=this,t=this.session,n=function(n,i){t.removeMarker(n.markerId),n.markerId=t.addMarker(new r(n.row,n.column,n.row,n.column+e.length),i,null,!1)};n(this.pos,this.mainClass);for(var i=this.others.length;i--;)n(this.others[i],this.othersClass)},e.prototype.onCursorChange=function(e){if(this.$updating||!this.session)return;var t=this.session.selection.getCursor();t.row===this.pos.row&&t.column>=this.pos.column&&t.column<=this.pos.column+this.length?(this.showOtherMarkers(),this._emit("cursorEnter",e)):(this.hideOtherMarkers(),this._emit("cursorLeave",e))},e.prototype.detach=function(){this.session.removeMarker(this.pos&&this.pos.markerId),this.hideOtherMarkers(),this.doc.off("change",this.$onUpdate),this.session.selection.off("changeCursor",this.$onCursorChange),this.session.setUndoSelect(!0),this.session=null},e.prototype.cancel=function(){if(this.$undoStackDepth===-1)return;var e=this.session.getUndoManager(),t=(e.$undoStack||e.$undostack).length-this.$undoStackDepth;for(var n=0;n<t;n++)e.undo(this.session,!0);this.selectionBefore&&this.session.selection.fromJSON(this.selectionBefore)},e}();s.implement(o.prototype,i),t.PlaceHolder=o}),define("ace/mouse/multi_select_handler",["require","exports","module","ace/lib/event","ace/lib/useragent"],function(e,t,n){function s(e,t){return e.row==t.row&&e.column==t.column}function o(e){var t=e.domEvent,n=t.altKey,o=t.shiftKey,u=t.ctrlKey,a=e.getAccelKey(),f=e.getButton();u&&i.isMac&&(f=t.button);if(e.editor.inMultiSelectMode&&f==2){e.editor.textInput.onContextMenu(e.domEvent);return}if(!u&&!n&&!a){f===0&&e.editor.inMultiSelectMode&&e.editor.exitMultiSelectMode();return}if(f!==0)return;var l=e.editor,c=l.selection,h=l.inMultiSelectMode,p=e.getDocumentPosition(),d=c.getCursor(),v=e.inSelection()||c.isEmpty()&&s(p,d),m=e.x,g=e.y,y=function(e){m=e.clientX,g=e.clientY},b=l.session,w=l.renderer.pixelToScreenCoordinates(m,g),E=w,S;if(l.$mouseHandler.$enableJumpToDef)u&&n||a&&n?S=o?"block":"add":n&&l.$blockSelectEnabled&&(S="block");else if(a&&!n){S="add";if(!h&&o)return}else n&&l.$blockSelectEnabled&&(S="block");S&&i.isMac&&t.ctrlKey&&l.$mouseHandler.cancelContextMenu();if(S=="add"){if(!h&&v)return;if(!h){var x=c.toOrientedRange();l.addSelectionMarker(x)}var T=c.rangeList.rangeAtPoint(p);l.inVirtualSelectionMode=!0,o&&(T=null,x=c.ranges[0]||x,l.removeSelectionMarker(x)),l.once("mouseup",function(){var e=c.toOrientedRange();T&&e.isEmpty()&&s(T.cursor,e.cursor)?c.substractPoint(e.cursor):(o?c.substractPoint(x.cursor):x&&(l.removeSelectionMarker(x),c.addRange(x)),c.addRange(e)),l.inVirtualSelectionMode=!1})}else if(S=="block"){e.stop(),l.inVirtualSelectionMode=!0;var N,C=[],k=function(){var e=l.renderer.pixelToScreenCoordinates(m,g),t=b.screenToDocumentPosition(e.row,e.column,e.offsetX);if(s(E,e)&&s(t,c.lead))return;E=e,l.selection.moveToPosition(t),l.renderer.scrollCursorIntoView(),l.removeSelectionMarkers(C),C=c.rectangularRangeBlock(E,w),l.$mouseHandler.$clickSelection&&C.length==1&&C[0].isEmpty()&&(C[0]=l.$mouseHandler.$clickSelection.clone()),C.forEach(l.addSelectionMarker,l),l.updateSelectionMarkers()};h&&!a?c.toSingleRange():!h&&a&&(N=c.toOrientedRange(),l.addSelectionMarker(N)),o?w=b.documentToScreenPosition(c.lead):c.moveToPosition(p),E={row:-1,column:-1};var L=function(e){k(),clearInterval(O),l.removeSelectionMarkers(C),C.length||(C=[c.toOrientedRange()]),N&&(l.removeSelectionMarker(N),c.toSingleRange(N));for(var t=0;t<C.length;t++)c.addRange(C[t]);l.inVirtualSelectionMode=!1,l.$mouseHandler.$clickSelection=null},A=k;r.capture(l.container,y,L);var O=setInterval(function(){A()},20);return e.preventDefault()}}var r=e("../lib/event"),i=e("../lib/useragent");t.onMouseDown=o}),define("ace/commands/multi_select_commands",["require","exports","module","ace/keyboard/hash_handler"],function(e,t,n){t.defaultCommands=[{name:"addCursorAbove",description:"Add cursor above",exec:function(e){e.selectMoreLines(-1)},bindKey:{win:"Ctrl-Alt-Up",mac:"Ctrl-Alt-Up"},scrollIntoView:"cursor",readOnly:!0},{name:"addCursorBelow",description:"Add cursor below",exec:function(e){e.selectMoreLines(1)},bindKey:{win:"Ctrl-Alt-Down",mac:"Ctrl-Alt-Down"},scrollIntoView:"cursor",readOnly:!0},{name:"addCursorAboveSkipCurrent",description:"Add cursor above (skip current)",exec:function(e){e.selectMoreLines(-1,!0)},bindKey:{win:"Ctrl-Alt-Shift-Up",mac:"Ctrl-Alt-Shift-Up"},scrollIntoView:"cursor",readOnly:!0},{name:"addCursorBelowSkipCurrent",description:"Add cursor below (skip current)",exec:function(e){e.selectMoreLines(1,!0)},bindKey:{win:"Ctrl-Alt-Shift-Down",mac:"Ctrl-Alt-Shift-Down"},scrollIntoView:"cursor",readOnly:!0},{name:"selectMoreBefore",description:"Select more before",exec:function(e){e.selectMore(-1)},bindKey:{win:"Ctrl-Alt-Left",mac:"Ctrl-Alt-Left"},scrollIntoView:"cursor",readOnly:!0},{name:"selectMoreAfter",description:"Select more after",exec:function(e){e.selectMore(1)},bindKey:{win:"Ctrl-Alt-Right",mac:"Ctrl-Alt-Right"},scrollIntoView:"cursor",readOnly:!0},{name:"selectNextBefore",description:"Select next before",exec:function(e){e.selectMore(-1,!0)},bindKey:{win:"Ctrl-Alt-Shift-Left",mac:"Ctrl-Alt-Shift-Left"},scrollIntoView:"cursor",readOnly:!0},{name:"selectNextAfter",description:"Select next after",exec:function(e){e.selectMore(1,!0)},bindKey:{win:"Ctrl-Alt-Shift-Right",mac:"Ctrl-Alt-Shift-Right"},scrollIntoView:"cursor",readOnly:!0},{name:"toggleSplitSelectionIntoLines",description:"Split selection into lines",exec:function(e){e.multiSelect.rangeCount>1?e.multiSelect.joinSelections():e.multiSelect.splitIntoLines()},bindKey:{win:"Ctrl-Alt-L",mac:"Ctrl-Alt-L"},readOnly:!0},{name:"splitSelectionIntoLines",description:"Split into lines",exec:function(e){e.multiSelect.splitIntoLines()},readOnly:!0},{name:"alignCursors",description:"Align cursors",exec:function(e){e.alignCursors()},bindKey:{win:"Ctrl-Alt-A",mac:"Ctrl-Alt-A"},scrollIntoView:"cursor"},{name:"findAll",description:"Find all",exec:function(e){e.findAll()},bindKey:{win:"Ctrl-Alt-K",mac:"Ctrl-Alt-G"},scrollIntoView:"cursor",readOnly:!0}],t.multiSelectCommands=[{name:"singleSelection",description:"Single selection",bindKey:"esc",exec:function(e){e.exitMultiSelectMode()},scrollIntoView:"cursor",readOnly:!0,isAvailable:function(e){return e&&e.inMultiSelectMode}}];var r=e("../keyboard/hash_handler").HashHandler;t.keyboardHandler=new r(t.multiSelectCommands)}),define("ace/multi_select",["require","exports","module","ace/range_list","ace/range","ace/selection","ace/mouse/multi_select_handler","ace/lib/event","ace/lib/lang","ace/commands/multi_select_commands","ace/search","ace/edit_session","ace/editor","ace/config"],function(e,t,n){function h(e,t,n){return c.$options.wrap=!0,c.$options.needle=t,c.$options.backwards=n==-1,c.find(e)}function v(e,t){return e.row==t.row&&e.column==t.column}function m(e){if(e.$multiselectOnSessionChange)return;e.$onAddRange=e.$onAddRange.bind(e),e.$onRemoveRange=e.$onRemoveRange.bind(e),e.$onMultiSelect=e.$onMultiSelect.bind(e),e.$onSingleSelect=e.$onSingleSelect.bind(e),e.$multiselectOnSessionChange=t.onSessionChange.bind(e),e.$checkMultiselectChange=e.$checkMultiselectChange.bind(e),e.$multiselectOnSessionChange(e),e.on("changeSession",e.$multiselectOnSessionChange),e.on("mousedown",o),e.commands.addCommands(f.defaultCommands),g(e)}function g(e){function r(t){n&&(e.renderer.setMouseCursor(""),n=!1)}if(!e.textInput)return;var t=e.textInput.getElement(),n=!1;u.addListener(t,"keydown",function(t){var i=t.keyCode==18&&!(t.ctrlKey||t.shiftKey||t.metaKey);e.$blockSelectEnabled&&i?n||(e.renderer.setMouseCursor("crosshair"),n=!0):n&&r()},e),u.addListener(t,"keyup",r,e),u.addListener(t,"blur",r,e)}var r=e("./range_list").RangeList,i=e("./range").Range,s=e("./selection").Selection,o=e("./mouse/multi_select_handler").onMouseDown,u=e("./lib/event"),a=e("./lib/lang"),f=e("./commands/multi_select_commands");t.commands=f.defaultCommands.concat(f.multiSelectCommands);var l=e("./search").Search,c=new l,p=e("./edit_session").EditSession;(function(){this.getSelectionMarkers=function(){return this.$selectionMarkers}}).call(p.prototype),function(){this.ranges=null,this.rangeList=null,this.addRange=function(e,t){if(!e)return;if(!this.inMultiSelectMode&&this.rangeCount===0){var n=this.toOrientedRange();this.rangeList.add(n),this.rangeList.add(e);if(this.rangeList.ranges.length!=2)return this.rangeList.removeAll(),t||this.fromOrientedRange(e);this.rangeList.removeAll(),this.rangeList.add(n),this.$onAddRange(n)}e.cursor||(e.cursor=e.end);var r=this.rangeList.add(e);return this.$onAddRange(e),r.length&&this.$onRemoveRange(r),this.rangeCount>1&&!this.inMultiSelectMode&&(this._signal("multiSelect"),this.inMultiSelectMode=!0,this.session.$undoSelect=!1,this.rangeList.attach(this.session)),t||this.fromOrientedRange(e)},this.toSingleRange=function(e){e=e||this.ranges[0];var t=this.rangeList.removeAll();t.length&&this.$onRemoveRange(t),e&&this.fromOrientedRange(e)},this.substractPoint=function(e){var t=this.rangeList.substractPoint(e);if(t)return this.$onRemoveRange(t),t[0]},this.mergeOverlappingRanges=function(){var e=this.rangeList.merge();e.length&&this.$onRemoveRange(e)},this.$onAddRange=function(e){this.rangeCount=this.rangeList.ranges.length,this.ranges.unshift(e),this._signal("addRange",{range:e})},this.$onRemoveRange=function(e){this.rangeCount=this.rangeList.ranges.length;if(this.rangeCount==1&&this.inMultiSelectMode){var t=this.rangeList.ranges.pop();e.push(t),this.rangeCount=0}for(var n=e.length;n--;){var r=this.ranges.indexOf(e[n]);this.ranges.splice(r,1)}this._signal("removeRange",{ranges:e}),this.rangeCount===0&&this.inMultiSelectMode&&(this.inMultiSelectMode=!1,this._signal("singleSelect"),this.session.$undoSelect=!0,this.rangeList.detach(this.session)),t=t||this.ranges[0],t&&!t.isEqual(this.getRange())&&this.fromOrientedRange(t)},this.$initRangeList=function(){if(this.rangeList)return;this.rangeList=new r,this.ranges=[],this.rangeCount=0},this.getAllRanges=function(){return this.rangeCount?this.rangeList.ranges.concat():[this.getRange()]},this.splitIntoLines=function(){var e=this.ranges.length?this.ranges:[this.getRange()],t=[];for(var n=0;n<e.length;n++){var r=e[n],s=r.start.row,o=r.end.row;if(s===o)t.push(r.clone());else{t.push(new i(s,r.start.column,s,this.session.getLine(s).length));while(++s<o)t.push(this.getLineRange(s,!0));t.push(new i(o,0,o,r.end.column))}n==0&&!this.isBackwards()&&(t=t.reverse())}this.toSingleRange();for(var n=t.length;n--;)this.addRange(t[n])},this.joinSelections=function(){var e=this.rangeList.ranges,t=e[e.length-1],n=i.fromPoints(e[0].start,t.end);this.toSingleRange(),this.setSelectionRange(n,t.cursor==t.start)},this.toggleBlockSelection=function(){if(this.rangeCount>1){var e=this.rangeList.ranges,t=e[e.length-1],n=i.fromPoints(e[0].start,t.end);this.toSingleRange(),this.setSelectionRange(n,t.cursor==t.start)}else{var r=this.session.documentToScreenPosition(this.cursor),s=this.session.documentToScreenPosition(this.anchor),o=this.rectangularRangeBlock(r,s);o.forEach(this.addRange,this)}},this.rectangularRangeBlock=function(e,t,n){var r=[],s=e.column<t.column;if(s)var o=e.column,u=t.column,a=e.offsetX,f=t.offsetX;else var o=t.column,u=e.column,a=t.offsetX,f=e.offsetX;var l=e.row<t.row;if(l)var c=e.row,h=t.row;else var c=t.row,h=e.row;o<0&&(o=0),c<0&&(c=0),c==h&&(n=!0);var p;for(var d=c;d<=h;d++){var m=i.fromPoints(this.session.screenToDocumentPosition(d,o,a),this.session.screenToDocumentPosition(d,u,f));if(m.isEmpty()){if(p&&v(m.end,p))break;p=m.end}m.cursor=s?m.start:m.end,r.push(m)}l&&r.reverse();if(!n){var g=r.length-1;while(r[g].isEmpty()&&g>0)g--;if(g>0){var y=0;while(r[y].isEmpty())y++}for(var b=g;b>=y;b--)r[b].isEmpty()&&r.splice(b,1)}return r}}.call(s.prototype);var d=e("./editor").Editor;(function(){this.updateSelectionMarkers=function(){this.renderer.updateCursor(),this.renderer.updateBackMarkers()},this.addSelectionMarker=function(e){e.cursor||(e.cursor=e.end);var t=this.getSelectionStyle();return e.marker=this.session.addMarker(e,"ace_selection",t),this.session.$selectionMarkers.push(e),this.session.selectionMarkerCount=this.session.$selectionMarkers.length,e},this.removeSelectionMarker=function(e){if(!e.marker)return;this.session.removeMarker(e.marker);var t=this.session.$selectionMarkers.indexOf(e);t!=-1&&this.session.$selectionMarkers.splice(t,1),this.session.selectionMarkerCount=this.session.$selectionMarkers.length},this.removeSelectionMarkers=function(e){var t=this.session.$selectionMarkers;for(var n=e.length;n--;){var r=e[n];if(!r.marker)continue;this.session.removeMarker(r.marker);var i=t.indexOf(r);i!=-1&&t.splice(i,1)}this.session.selectionMarkerCount=t.length},this.$onAddRange=function(e){this.addSelectionMarker(e.range),this.renderer.updateCursor(),this.renderer.updateBackMarkers()},this.$onRemoveRange=function(e){this.removeSelectionMarkers(e.ranges),this.renderer.updateCursor(),this.renderer.updateBackMarkers()},this.$onMultiSelect=function(e){if(this.inMultiSelectMode)return;this.inMultiSelectMode=!0,this.setStyle("ace_multiselect"),this.keyBinding.addKeyboardHandler(f.keyboardHandler),this.commands.setDefaultHandler("exec",this.$onMultiSelectExec),this.renderer.updateCursor(),this.renderer.updateBackMarkers()},this.$onSingleSelect=function(e){if(this.session.multiSelect.inVirtualMode)return;this.inMultiSelectMode=!1,this.unsetStyle("ace_multiselect"),this.keyBinding.removeKeyboardHandler(f.keyboardHandler),this.commands.removeDefaultHandler("exec",this.$onMultiSelectExec),this.renderer.updateCursor(),this.renderer.updateBackMarkers(),this._emit("changeSelection")},this.$onMultiSelectExec=function(e){var t=e.command,n=e.editor;if(!n.multiSelect)return;if(!t.multiSelectAction){var r=t.exec(n,e.args||{});n.multiSelect.addRange(n.multiSelect.toOrientedRange()),n.multiSelect.mergeOverlappingRanges()}else t.multiSelectAction=="forEach"?r=n.forEachSelection(t,e.args):t.multiSelectAction=="forEachLine"?r=n.forEachSelection(t,e.args,!0):t.multiSelectAction=="single"?(n.exitMultiSelectMode(),r=t.exec(n,e.args||{})):r=t.multiSelectAction(n,e.args||{});return r},this.forEachSelection=function(e,t,n){if(this.inVirtualSelectionMode)return;var r=n&&n.keepOrder,i=n==1||n&&n.$byLines,o=this.session,u=this.selection,a=u.rangeList,f=(r?u:a).ranges,l;if(!f.length)return e.exec?e.exec(this,t||{}):e(this,t||{});var c=u._eventRegistry;u._eventRegistry={};var h=new s(o);this.inVirtualSelectionMode=!0;for(var p=f.length;p--;){if(i)while(p>0&&f[p].start.row==f[p-1].end.row)p--;h.fromOrientedRange(f[p]),h.index=p,this.selection=o.selection=h;var d=e.exec?e.exec(this,t||{}):e(this,t||{});!l&&d!==undefined&&(l=d),h.toOrientedRange(f[p])}h.detach(),this.selection=o.selection=u,this.inVirtualSelectionMode=!1,u._eventRegistry=c,u.mergeOverlappingRanges(),u.ranges[0]&&u.fromOrientedRange(u.ranges[0]);var v=this.renderer.$scrollAnimation;return this.onCursorChange(),this.onSelectionChange(),v&&v.from==v.to&&this.renderer.animateScrolling(v.from),l},this.exitMultiSelectMode=function(){if(!this.inMultiSelectMode||this.inVirtualSelectionMode)return;this.multiSelect.toSingleRange()},this.getSelectedText=function(){var e="";if(this.inMultiSelectMode&&!this.inVirtualSelectionMode){var t=this.multiSelect.rangeList.ranges,n=[];for(var r=0;r<t.length;r++)n.push(this.session.getTextRange(t[r]));var i=this.session.getDocument().getNewLineCharacter();e=n.join(i),e.length==(n.length-1)*i.length&&(e="")}else this.selection.isEmpty()||(e=this.session.getTextRange(this.getSelectionRange()));return e},this.$checkMultiselectChange=function(e,t){if(this.inMultiSelectMode&&!this.inVirtualSelectionMode){var n=this.multiSelect.ranges[0];if(this.multiSelect.isEmpty()&&t==this.multiSelect.anchor)return;var r=t==this.multiSelect.anchor?n.cursor==n.start?n.end:n.start:n.cursor;r.row!=t.row||this.session.$clipPositionToDocument(r.row,r.column).column!=t.column?this.multiSelect.toSingleRange(this.multiSelect.toOrientedRange()):this.multiSelect.mergeOverlappingRanges()}},this.findAll=function(e,t,n){t=t||{},t.needle=e||t.needle;if(t.needle==undefined){var r=this.selection.isEmpty()?this.selection.getWordRange():this.selection.getRange();t.needle=this.session.getTextRange(r)}this.$search.set(t);var i=this.$search.findAll(this.session);if(!i.length)return 0;var s=this.multiSelect;n||s.toSingleRange(i[0]);for(var o=i.length;o--;)s.addRange(i[o],!0);return r&&s.rangeList.rangeAtPoint(r.start)&&s.addRange(r,!0),i.length},this.selectMoreLines=function(e,t){var n=this.selection.toOrientedRange(),r=n.cursor==n.end,s=this.session.documentToScreenPosition(n.cursor);this.selection.$desiredColumn&&(s.column=this.selection.$desiredColumn);var o=this.session.screenToDocumentPosition(s.row+e,s.column);if(!n.isEmpty())var u=this.session.documentToScreenPosition(r?n.end:n.start),a=this.session.screenToDocumentPosition(u.row+e,u.column);else var a=o;if(r){var f=i.fromPoints(o,a);f.cursor=f.start}else{var f=i.fromPoints(a,o);f.cursor=f.end}f.desiredColumn=s.column;if(!this.selection.inMultiSelectMode)this.selection.addRange(n);else if(t)var l=n.cursor;this.selection.addRange(f),l&&this.selection.substractPoint(l)},this.transposeSelections=function(e){var t=this.session,n=t.multiSelect,r=n.ranges;for(var i=r.length;i--;){var s=r[i];if(s.isEmpty()){var o=t.getWordRange(s.start.row,s.start.column);s.start.row=o.start.row,s.start.column=o.start.column,s.end.row=o.end.row,s.end.column=o.end.column}}n.mergeOverlappingRanges();var u=[];for(var i=r.length;i--;){var s=r[i];u.unshift(t.getTextRange(s))}e<0?u.unshift(u.pop()):u.push(u.shift());for(var i=r.length;i--;){var s=r[i],a=s.clone();t.replace(s,u[i]),s.start.row=a.start.row,s.start.column=a.start.column}n.fromOrientedRange(n.ranges[0])},this.selectMore=function(e,t,n){var r=this.session,i=r.multiSelect,s=i.toOrientedRange();if(s.isEmpty()){s=r.getWordRange(s.start.row,s.start.column),s.cursor=e==-1?s.start:s.end,this.multiSelect.addRange(s);if(n)return}var o=r.getTextRange(s),u=h(r,o,e);u&&(u.cursor=e==-1?u.start:u.end,this.session.unfold(u),this.multiSelect.addRange(u),this.renderer.scrollCursorIntoView(null,.5)),t&&this.multiSelect.substractPoint(s.cursor)},this.alignCursors=function(){var e=this.session,t=e.multiSelect,n=t.ranges,r=-1,s=n.filter(function(e){if(e.cursor.row==r)return!0;r=e.cursor.row});if(!n.length||s.length==n.length-1){var o=this.selection.getRange(),u=o.start.row,f=o.end.row,l=u==f;if(l){var c=this.session.getLength(),h;do h=this.session.getLine(f);while(/[=:]/.test(h)&&++f<c);do h=this.session.getLine(u);while(/[=:]/.test(h)&&--u>0);u<0&&(u=0),f>=c&&(f=c-1)}var p=this.session.removeFullLines(u,f);p=this.$reAlignText(p,l),this.session.insert({row:u,column:0},p.join("\n")+"\n"),l||(o.start.column=0,o.end.column=p[p.length-1].length),this.selection.setRange(o)}else{s.forEach(function(e){t.substractPoint(e.cursor)});var d=0,v=Infinity,m=n.map(function(t){var n=t.cursor,r=e.getLine(n.row),i=r.substr(n.column).search(/\S/g);return i==-1&&(i=0),n.column>d&&(d=n.column),i<v&&(v=i),i});n.forEach(function(t,n){var r=t.cursor,s=d-r.column,o=m[n]-v;s>o?e.insert(r,a.stringRepeat(" ",s-o)):e.remove(new i(r.row,r.column,r.row,r.column-s+o)),t.start.column=t.end.column=d,t.start.row=t.end.row=r.row,t.cursor=t.end}),t.fromOrientedRange(n[0]),this.renderer.updateCursor(),this.renderer.updateBackMarkers()}},this.$reAlignText=function(e,t){function u(e){return a.stringRepeat(" ",e)}function f(e){return e[2]?u(i)+e[2]+u(s-e[2].length+o)+e[4].replace(/^([=:])\s+/,"$1 "):e[0]}function l(e){return e[2]?u(i+s-e[2].length)+e[2]+u(o)+e[4].replace(/^([=:])\s+/,"$1 "):e[0]}function c(e){return e[2]?u(i)+e[2]+u(o)+e[4].replace(/^([=:])\s+/,"$1 "):e[0]}var n=!0,r=!0,i,s,o;return e.map(function(e){var t=e.match(/(\s*)(.*?)(\s*)([=:].*)/);return t?i==null?(i=t[1].length,s=t[2].length,o=t[3].length,t):(i+s+o!=t[1].length+t[2].length+t[3].length&&(r=!1),i!=t[1].length&&(n=!1),i>t[1].length&&(i=t[1].length),s<t[2].length&&(s=t[2].length),o>t[3].length&&(o=t[3].length),t):[e]}).map(t?f:n?r?l:f:c)}}).call(d.prototype),t.onSessionChange=function(e){var t=e.session;t&&!t.multiSelect&&(t.$selectionMarkers=[],t.selection.$initRangeList(),t.multiSelect=t.selection),this.multiSelect=t&&t.multiSelect;var n=e.oldSession;n&&(n.multiSelect.off("addRange",this.$onAddRange),n.multiSelect.off("removeRange",this.$onRemoveRange),n.multiSelect.off("multiSelect",this.$onMultiSelect),n.multiSelect.off("singleSelect",this.$onSingleSelect),n.multiSelect.lead.off("change",this.$checkMultiselectChange),n.multiSelect.anchor.off("change",this.$checkMultiselectChange)),t&&(t.multiSelect.on("addRange",this.$onAddRange),t.multiSelect.on("removeRange",this.$onRemoveRange),t.multiSelect.on("multiSelect",this.$onMultiSelect),t.multiSelect.on("singleSelect",this.$onSingleSelect),t.multiSelect.lead.on("change",this.$checkMultiselectChange),t.multiSelect.anchor.on("change",this.$checkMultiselectChange)),t&&this.inMultiSelectMode!=t.selection.inMultiSelectMode&&(t.selection.inMultiSelectMode?this.$onMultiSelect():this.$onSingleSelect())},t.MultiSelect=m,e("./config").defineOptions(d.prototype,"editor",{enableMultiselect:{set:function(e){m(this),e?this.on("mousedown",o):this.off("mousedown",o)},value:!0},enableBlockSelect:{set:function(e){this.$blockSelectEnabled=e},value:!0}})}),define("ace/mode/folding/fold_mode",["require","exports","module","ace/range"],function(e,t,n){"use strict";var r=e("../../range").Range,i=t.FoldMode=function(){};(function(){this.foldingStartMarker=null,this.foldingStopMarker=null,this.getFoldWidget=function(e,t,n){var r=e.getLine(n);return this.foldingStartMarker.test(r)?"start":t=="markbeginend"&&this.foldingStopMarker&&this.foldingStopMarker.test(r)?"end":""},this.getFoldWidgetRange=function(e,t,n){return null},this.indentationBlock=function(e,t,n){var i=/\S/,s=e.getLine(t),o=s.search(i);if(o==-1)return;var u=n||s.length,a=e.getLength(),f=t,l=t;while(++t<a){var c=e.getLine(t).search(i);if(c==-1)continue;if(c<=o){var h=e.getTokenAt(t,0);if(!h||h.type!=="string")break}l=t}if(l>f){var p=e.getLine(l).length;return new r(f,u,l,p)}},this.openingBracketBlock=function(e,t,n,i,s){var o={row:n,column:i+1},u=e.$findClosingBracket(t,o,s);if(!u)return;var a=e.foldWidgets[u.row];return a==null&&(a=e.getFoldWidget(u.row)),a=="start"&&u.row>o.row&&(u.row--,u.column=e.getLine(u.row).length),r.fromPoints(o,u)},this.closingBracketBlock=function(e,t,n,i,s){var o={row:n,column:i},u=e.$findOpeningBracket(t,o);if(!u)return;return u.column++,o.column--,r.fromPoints(u,o)}}).call(i.prototype)}),define("ace/ext/error_marker",["require","exports","module","ace/lib/dom","ace/range","ace/config"],function(e,t,n){"use strict";function o(e,t,n){var r=0,i=e.length-1;while(r<=i){var s=r+i>>1,o=n(t,e[s]);if(o>0)r=s+1;else{if(!(o<0))return s;i=s-1}}return-(r+1)}function u(e,t,n){var r=e.getAnnotations().sort(i.comparePoints);if(!r.length)return;var s=o(r,{row:t,column:-1},i.comparePoints);s<0&&(s=-s-1),s>=r.length?s=n>0?0:r.length-1:s===0&&n<0&&(s=r.length-1);var u=r[s];if(!u||!n)return;if(u.row===t){do u=r[s+=n];while(u&&u.row===t);if(!u)return r.slice()}var a=[];t=u.row;do a[n<0?"unshift":"push"](u),u=r[s+=n];while(u&&u.row==t);return a.length&&a}var r=e("../lib/dom"),i=e("../range").Range,s=e("../config").nls;t.showErrorMarker=function(e,t){var n=e.session,i=e.getCursorPosition(),o=i.row,a=n.widgetManager.getWidgetsAtRow(o).filter(function(e){return e.type=="errorMarker"})[0];a?a.destroy():o-=t;var f=u(n,o,t),l;if(f){var c=f[0];i.column=(c.pos&&typeof c.column!="number"?c.pos.sc:c.column)||0,i.row=c.row,l=e.renderer.$gutterLayer.$annotations[i.row]}else{if(a)return;l={displayText:[s("error-marker.good-state","Looks good!")],className:"ace_ok"}}e.session.unfold(i.row),e.selection.moveToPosition(i);var h={row:i.row,fixedWidth:!0,coverGutter:!0,el:r.createElement("div"),type:"errorMarker"},p=h.el.appendChild(r.createElement("div")),d=h.el.appendChild(r.createElement("div"));d.className="error_widget_arrow "+l.className;var v=e.renderer.$cursorLayer.getPixelPosition(i).left;d.style.left=v+e.renderer.gutterWidth-5+"px",h.el.className="error_widget_wrapper",p.className="error_widget "+l.className,l.displayText.forEach(function(e,t){p.appendChild(r.createTextNode(e)),t<l.displayText.length-1&&p.appendChild(r.createElement("br"))}),p.appendChild(r.createElement("div"));var m=function(e,t,n){if(t===0&&(n==="esc"||n==="return"))return h.destroy(),{command:"null"}};h.destroy=function(){if(e.$mouseHandler.isMousePressed)return;e.keyBinding.removeKeyboardHandler(m),n.widgetManager.removeLineWidget(h),e.off("changeSelection",h.destroy),e.off("changeSession",h.destroy),e.off("mouseup",h.destroy),e.off("change",h.destroy)},e.keyBinding.addKeyboardHandler(m),e.on("changeSelection",h.destroy),e.on("changeSession",h.destroy),e.on("mouseup",h.destroy),e.on("change",h.destroy),e.session.widgetManager.addLineWidget(h),h.el.onmousedown=e.focus.bind(e),e.renderer.scrollCursorIntoView(null,.5,{bottom:h.el.offsetHeight})},r.importCssString("\n    .error_widget_wrapper {\n        background: inherit;\n        color: inherit;\n        border:none\n    }\n    .error_widget {\n        border-top: solid 2px;\n        border-bottom: solid 2px;\n        margin: 5px 0;\n        padding: 10px 40px;\n        white-space: pre-wrap;\n    }\n    .error_widget.ace_error, .error_widget_arrow.ace_error{\n        border-color: #ff5a5a\n    }\n    .error_widget.ace_warning, .error_widget_arrow.ace_warning{\n        border-color: #F1D817\n    }\n    .error_widget.ace_info, .error_widget_arrow.ace_info{\n        border-color: #5a5a5a\n    }\n    .error_widget.ace_ok, .error_widget_arrow.ace_ok{\n        border-color: #5aaa5a\n    }\n    .error_widget_arrow {\n        position: absolute;\n        border: solid 5px;\n        border-top-color: transparent!important;\n        border-right-color: transparent!important;\n        border-left-color: transparent!important;\n        top: -5px;\n    }\n","error_marker.css",!1)}),define("ace/ace",["require","exports","module","ace/lib/dom","ace/range","ace/editor","ace/edit_session","ace/undomanager","ace/virtual_renderer","ace/worker/worker_client","ace/keyboard/hash_handler","ace/placeholder","ace/multi_select","ace/mode/folding/fold_mode","ace/theme/textmate","ace/ext/error_marker","ace/config","ace/loader_build"],function(e,t,n){"use strict";e("./loader_build")(t);var r=e("./lib/dom"),i=e("./range").Range,s=e("./editor").Editor,o=e("./edit_session").EditSession,u=e("./undomanager").UndoManager,a=e("./virtual_renderer").VirtualRenderer;e("./worker/worker_client"),e("./keyboard/hash_handler"),e("./placeholder"),e("./multi_select"),e("./mode/folding/fold_mode"),e("./theme/textmate"),e("./ext/error_marker"),t.config=e("./config"),t.edit=function(e,n){if(typeof e=="string"){var i=e;e=document.getElementById(i);if(!e)throw new Error("ace.edit can't find div #"+i)}if(e&&e.env&&e.env.editor instanceof s)return e.env.editor;var o="";if(e&&/input|textarea/i.test(e.tagName)){var u=e;o=u.value,e=r.createElement("pre"),u.parentNode.replaceChild(e,u)}else e&&(o=e.textContent,e.innerHTML="");var f=t.createEditSession(o),l=new s(new a(e),f,n),c={document:f,editor:l,onResize:l.resize.bind(l,null)};return u&&(c.textarea=u),l.on("destroy",function(){c.editor.container.env=null}),l.container.env=l.env=c,l},t.createEditSession=function(e,t){var n=new o(e,t);return n.setUndoManager(new u),n},t.Range=i,t.Editor=s,t.EditSession=o,t.UndoManager=u,t.VirtualRenderer=a;var f=t.config.version;t.version=f});            (function() {
                window.require(["ace/ace"], function(a) {
                    if (a) {
                        a.config.init(true);
                        a.define = window.define;
                    }
                    var global = (function () {
                        return this;
                    })();
                    if (!global && typeof window != "undefined") global = window; // can happen in strict mode
                    if (!global && typeof self != "undefined") global = self; // can happen in webworker
                    
                    if (!global.ace)
                        global.ace = a;
                    for (var key in a) if (a.hasOwnProperty(key))
                        global.ace[key] = a[key];
                    global.ace["default"] = global.ace;
                    if (typeof module == "object" && typeof exports == "object" && module) {
                        module.exports = global.ace;
                    }
                });
            })();
        